/*!
 * @mescius/activereports 5.0.4
 * Description: ActiveReportsJS
 * https://www.npmjs.com/package/@mescius/activereports
 * Copyright ©️ MESCIUS inc. All rights reserved.
 * Licensed under the Commercial license
 */
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __pow = Math.pow;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a10, b10) => {
  for (var prop in b10 || (b10 = {}))
    if (__hasOwnProp.call(b10, prop))
      __defNormalProp(a10, prop, b10[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b10)) {
      if (__propIsEnum.call(b10, prop))
        __defNormalProp(a10, prop, b10[prop]);
    }
  return a10;
};
var __spreadProps = (a10, b10) => __defProps(a10, __getOwnPropDescs(b10));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e14) {
        reject(e14);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e14) {
        reject(e14);
      }
    };
    var step = (x10) => x10.done ? resolve(x10.value) : Promise.resolve(x10.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var _o2, _p2;
import { withLocalizedErrorsAsync as e, readDataRecords as t, FontStore as n, CustomCode as r, getLicenseKey as o } from"../ar-js-pagereport.js";
import a, { PaletteColorUtility as i, FlexDV as s } from"../../gc-dv.cjs";
import l from"../../barcodejs.cjs";
function c(e14, t10) {
  return t10.forEach(function(t11) {
    t11 && "string" != typeof t11 && !Array.isArray(t11) && Object.keys(t11).forEach(function(n10) {
      if ("default" !== n10 && !(n10 in e14)) {
        var r10 = Object.getOwnPropertyDescriptor(t11, n10);
        Object.defineProperty(e14, n10, r10.get ? r10 : { enumerable: true, get: function() {
          return t11[n10];
        } });
      }
    });
  }), Object.freeze(e14);
}
var u = function(e14, t10) {
  return u = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t11) {
    e15.__proto__ = t11;
  } || function(e15, t11) {
    for (var n10 in t11) Object.prototype.hasOwnProperty.call(t11, n10) && (e15[n10] = t11[n10]);
  }, u(e14, t10);
};
function d(e14, t10) {
  if ("function" != typeof t10 && null !== t10) throw new TypeError("Class extends value " + String(t10) + " is not a constructor or null");
  function n10() {
    this.constructor = e14;
  }
  u(e14, t10), e14.prototype = null === t10 ? Object.create(t10) : (n10.prototype = t10.prototype, new n10());
}
var p = function() {
  return p = Object.assign || function(e14) {
    for (var t10, n10 = 1, r10 = arguments.length; n10 < r10; n10++) for (var o10 in t10 = arguments[n10]) Object.prototype.hasOwnProperty.call(t10, o10) && (e14[o10] = t10[o10]);
    return e14;
  }, p.apply(this, arguments);
};
function m(e14, t10) {
  var n10 = {};
  for (var r10 in e14) Object.prototype.hasOwnProperty.call(e14, r10) && t10.indexOf(r10) < 0 && (n10[r10] = e14[r10]);
  if (null != e14 && "function" == typeof Object.getOwnPropertySymbols) {
    var o10 = 0;
    for (r10 = Object.getOwnPropertySymbols(e14); o10 < r10.length; o10++) t10.indexOf(r10[o10]) < 0 && Object.prototype.propertyIsEnumerable.call(e14, r10[o10]) && (n10[r10[o10]] = e14[r10[o10]]);
  }
  return n10;
}
function h(e14, t10, n10, r10) {
  var o10, a10 = arguments.length, i10 = a10 < 3 ? t10 : null === r10 ? r10 = Object.getOwnPropertyDescriptor(t10, n10) : r10;
  if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) i10 = Reflect.decorate(e14, t10, n10, r10);
  else for (var s10 = e14.length - 1; s10 >= 0; s10--) (o10 = e14[s10]) && (i10 = (a10 < 3 ? o10(i10) : a10 > 3 ? o10(t10, n10, i10) : o10(t10, n10)) || i10);
  return a10 > 3 && i10 && Object.defineProperty(t10, n10, i10), i10;
}
function f(e14, t10) {
  return function(n10, r10) {
    t10(n10, r10, e14);
  };
}
function g(e14, t10) {
  if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e14, t10);
}
function y(e14, t10, n10, r10) {
  return new (n10 || (n10 = Promise))(function(o10, a10) {
    function i10(e15) {
      try {
        l10(r10.next(e15));
      } catch (e16) {
        a10(e16);
      }
    }
    function s10(e15) {
      try {
        l10(r10.throw(e15));
      } catch (e16) {
        a10(e16);
      }
    }
    function l10(e15) {
      e15.done ? o10(e15.value) : function(e16) {
        return e16 instanceof n10 ? e16 : new n10(function(t11) {
          t11(e16);
        });
      }(e15.value).then(i10, s10);
    }
    l10((r10 = r10.apply(e14, t10 || [])).next());
  });
}
function v(e14, t10) {
  var n10, r10, o10, a10, i10 = { label: 0, sent: function() {
    if (1 & o10[0]) throw o10[1];
    return o10[1];
  }, trys: [], ops: [] };
  return a10 = { next: s10(0), throw: s10(1), return: s10(2) }, "function" == typeof Symbol && (a10[Symbol.iterator] = function() {
    return this;
  }), a10;
  function s10(s11) {
    return function(l10) {
      return function(s12) {
        if (n10) throw new TypeError("Generator is already executing.");
        for (; a10 && (a10 = 0, s12[0] && (i10 = 0)), i10; ) try {
          if (n10 = 1, r10 && (o10 = 2 & s12[0] ? r10.return : s12[0] ? r10.throw || ((o10 = r10.return) && o10.call(r10), 0) : r10.next) && !(o10 = o10.call(r10, s12[1])).done) return o10;
          switch (r10 = 0, o10 && (s12 = [2 & s12[0], o10.value]), s12[0]) {
            case 0:
            case 1:
              o10 = s12;
              break;
            case 4:
              return i10.label++, { value: s12[1], done: false };
            case 5:
              i10.label++, r10 = s12[1], s12 = [0];
              continue;
            case 7:
              s12 = i10.ops.pop(), i10.trys.pop();
              continue;
            default:
              if (!(o10 = i10.trys, (o10 = o10.length > 0 && o10[o10.length - 1]) || 6 !== s12[0] && 2 !== s12[0])) {
                i10 = 0;
                continue;
              }
              if (3 === s12[0] && (!o10 || s12[1] > o10[0] && s12[1] < o10[3])) {
                i10.label = s12[1];
                break;
              }
              if (6 === s12[0] && i10.label < o10[1]) {
                i10.label = o10[1], o10 = s12;
                break;
              }
              if (o10 && i10.label < o10[2]) {
                i10.label = o10[2], i10.ops.push(s12);
                break;
              }
              o10[2] && i10.ops.pop(), i10.trys.pop();
              continue;
          }
          s12 = t10.call(e14, i10);
        } catch (e15) {
          s12 = [6, e15], r10 = 0;
        } finally {
          n10 = o10 = 0;
        }
        if (5 & s12[0]) throw s12[1];
        return { value: s12[0] ? s12[1] : void 0, done: true };
      }([s11, l10]);
    };
  }
}
var b = Object.create ? function(e14, t10, n10, r10) {
  void 0 === r10 && (r10 = n10);
  var o10 = Object.getOwnPropertyDescriptor(t10, n10);
  o10 && !("get" in o10 ? !t10.__esModule : o10.writable || o10.configurable) || (o10 = { enumerable: true, get: function() {
    return t10[n10];
  } }), Object.defineProperty(e14, r10, o10);
} : function(e14, t10, n10, r10) {
  void 0 === r10 && (r10 = n10), e14[r10] = t10[n10];
};
function S(e14, t10) {
  for (var n10 in e14) "default" === n10 || Object.prototype.hasOwnProperty.call(t10, n10) || b(t10, e14, n10);
}
function C(e14) {
  var t10 = "function" == typeof Symbol && Symbol.iterator, n10 = t10 && e14[t10], r10 = 0;
  if (n10) return n10.call(e14);
  if (e14 && "number" == typeof e14.length) return { next: function() {
    return e14 && r10 >= e14.length && (e14 = void 0), { value: e14 && e14[r10++], done: !e14 };
  } };
  throw new TypeError(t10 ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function x(e14, t10) {
  var n10 = "function" == typeof Symbol && e14[Symbol.iterator];
  if (!n10) return e14;
  var r10, o10, a10 = n10.call(e14), i10 = [];
  try {
    for (; (void 0 === t10 || t10-- > 0) && !(r10 = a10.next()).done; ) i10.push(r10.value);
  } catch (e15) {
    o10 = { error: e15 };
  } finally {
    try {
      r10 && !r10.done && (n10 = a10.return) && n10.call(a10);
    } finally {
      if (o10) throw o10.error;
    }
  }
  return i10;
}
function w() {
  for (var e14 = [], t10 = 0; t10 < arguments.length; t10++) e14 = e14.concat(x(arguments[t10]));
  return e14;
}
function T() {
  for (var e14 = 0, t10 = 0, n10 = arguments.length; t10 < n10; t10++) e14 += arguments[t10].length;
  var r10 = Array(e14), o10 = 0;
  for (t10 = 0; t10 < n10; t10++) for (var a10 = arguments[t10], i10 = 0, s10 = a10.length; i10 < s10; i10++, o10++) r10[o10] = a10[i10];
  return r10;
}
function E(e14, t10, n10) {
  if (n10 || 2 === arguments.length) for (var r10, o10 = 0, a10 = t10.length; o10 < a10; o10++) !r10 && o10 in t10 || (r10 || (r10 = Array.prototype.slice.call(t10, 0, o10)), r10[o10] = t10[o10]);
  return e14.concat(r10 || Array.prototype.slice.call(t10));
}
function F(e14) {
  return this instanceof F ? (this.v = e14, this) : new F(e14);
}
function M(e14, t10, n10) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var r10, o10 = n10.apply(e14, t10 || []), a10 = [];
  return r10 = {}, i10("next"), i10("throw"), i10("return"), r10[Symbol.asyncIterator] = function() {
    return this;
  }, r10;
  function i10(e15) {
    o10[e15] && (r10[e15] = function(t11) {
      return new Promise(function(n11, r11) {
        a10.push([e15, t11, n11, r11]) > 1 || s10(e15, t11);
      });
    });
  }
  function s10(e15, t11) {
    try {
      !function(e16) {
        e16.value instanceof F ? Promise.resolve(e16.value.v).then(l10, c10) : u10(a10[0][2], e16);
      }(o10[e15](t11));
    } catch (e16) {
      u10(a10[0][3], e16);
    }
  }
  function l10(e15) {
    s10("next", e15);
  }
  function c10(e15) {
    s10("throw", e15);
  }
  function u10(e15, t11) {
    e15(t11), a10.shift(), a10.length && s10(a10[0][0], a10[0][1]);
  }
}
function k(e14) {
  var t10, n10;
  return t10 = {}, r10("next"), r10("throw", function(e15) {
    throw e15;
  }), r10("return"), t10[Symbol.iterator] = function() {
    return this;
  }, t10;
  function r10(r11, o10) {
    t10[r11] = e14[r11] ? function(t11) {
      return (n10 = !n10) ? { value: F(e14[r11](t11)), done: false } : o10 ? o10(t11) : t11;
    } : o10;
  }
}
function P(e14) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var t10, n10 = e14[Symbol.asyncIterator];
  return n10 ? n10.call(e14) : (e14 = C(e14), t10 = {}, r10("next"), r10("throw"), r10("return"), t10[Symbol.asyncIterator] = function() {
    return this;
  }, t10);
  function r10(n11) {
    t10[n11] = e14[n11] && function(t11) {
      return new Promise(function(r11, o10) {
        (function(e15, t12, n12, r12) {
          Promise.resolve(r12).then(function(t13) {
            e15({ value: t13, done: n12 });
          }, t12);
        })(r11, o10, (t11 = e14[n11](t11)).done, t11.value);
      });
    };
  }
}
function N(e14, t10) {
  return Object.defineProperty ? Object.defineProperty(e14, "raw", { value: t10 }) : e14.raw = t10, e14;
}
var D = Object.create ? function(e14, t10) {
  Object.defineProperty(e14, "default", { enumerable: true, value: t10 });
} : function(e14, t10) {
  e14.default = t10;
};
function L(e14) {
  if (e14 && e14.__esModule) return e14;
  var t10 = {};
  if (null != e14) for (var n10 in e14) "default" !== n10 && Object.prototype.hasOwnProperty.call(e14, n10) && b(t10, e14, n10);
  return D(t10, e14), t10;
}
function H(e14) {
  return e14 && e14.__esModule ? e14 : { default: e14 };
}
function I(e14, t10, n10, r10) {
  if ("a" === n10 && !r10) throw new TypeError("Private accessor was defined without a getter");
  if ("function" == typeof t10 ? e14 !== t10 || !r10 : !t10.has(e14)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return "m" === n10 ? r10 : "a" === n10 ? r10.call(e14) : r10 ? r10.value : t10.get(e14);
}
function _(e14, t10, n10, r10, o10) {
  if ("m" === r10) throw new TypeError("Private method is not writable");
  if ("a" === r10 && !o10) throw new TypeError("Private accessor was defined without a setter");
  if ("function" == typeof t10 ? e14 !== t10 || !o10 : !t10.has(e14)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return "a" === r10 ? o10.call(e14, n10) : o10 ? o10.value = n10 : t10.set(e14, n10), n10;
}
function V(e14, t10) {
  if (null === t10 || "object" != typeof t10 && "function" != typeof t10) throw new TypeError("Cannot use 'in' operator on non-object");
  return "function" == typeof e14 ? t10 === e14 : e14.has(t10);
}
function R(e14, t10, n10) {
  if (null != t10) {
    if ("object" != typeof t10 && "function" != typeof t10) throw new TypeError("Object expected.");
    var r10;
    if (n10) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      r10 = t10[Symbol.asyncDispose];
    }
    if (void 0 === r10) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      r10 = t10[Symbol.dispose];
    }
    if ("function" != typeof r10) throw new TypeError("Object not disposable.");
    e14.stack.push({ value: t10, dispose: r10, async: n10 });
  } else n10 && e14.stack.push({ async: true });
  return t10;
}
var A = "function" == typeof SuppressedError ? SuppressedError : function(e14, t10, n10) {
  var r10 = new Error(n10);
  return r10.name = "SuppressedError", r10.error = e14, r10.suppressed = t10, r10;
};
function O(e14) {
  function t10(t11) {
    e14.error = e14.hasError ? new A(t11, e14.error, "An error was suppressed during disposal.") : t11, e14.hasError = true;
  }
  return function n10() {
    for (; e14.stack.length; ) {
      var r10 = e14.stack.pop();
      try {
        var o10 = r10.dispose && r10.dispose.call(r10.value);
        if (r10.async) return Promise.resolve(o10).then(n10, function(e15) {
          return t10(e15), n10();
        });
      } catch (e15) {
        t10(e15);
      }
    }
    if (e14.hasError) throw e14.error;
  }();
}
var B = { __extends: d, __assign: p, __rest: m, __decorate: h, __param: f, __metadata: g, __awaiter: y, __generator: v, __createBinding: b, __exportStar: S, __values: C, __read: x, __spread: w, __spreadArrays: T, __spreadArray: E, __await: F, __asyncGenerator: M, __asyncDelegator: k, __asyncValues: P, __makeTemplateObject: N, __importStar: L, __importDefault: H, __classPrivateFieldGet: I, __classPrivateFieldSet: _, __classPrivateFieldIn: V, __addDisposableResource: R, __disposeResources: O };
var z = Object.freeze({ __proto__: null, __extends: d, get __assign() {
  return p;
}, __rest: m, __decorate: h, __param: f, __esDecorate: function(e14, t10, n10, r10, o10, a10) {
  function i10(e15) {
    if (void 0 !== e15 && "function" != typeof e15) throw new TypeError("Function expected");
    return e15;
  }
  var s10 = r10.kind, l10 = "getter" === s10 ? "get" : "setter" === s10 ? "set" : "value";
  var c10 = !t10 && e14 ? r10.static ? e14 : e14.prototype : null;
  var u10 = t10 || (c10 ? Object.getOwnPropertyDescriptor(c10, r10.name) : {});
  var d10, p10 = false;
  for (var m10 = n10.length - 1; m10 >= 0; m10--) {
    var h10 = {};
    for (var f10 in r10) h10[f10] = "access" === f10 ? {} : r10[f10];
    for (var f10 in r10.access) h10.access[f10] = r10.access[f10];
    h10.addInitializer = function(e15) {
      if (p10) throw new TypeError("Cannot add initializers after decoration has completed");
      a10.push(i10(e15 || null));
    };
    var g10 = (0, n10[m10])("accessor" === s10 ? { get: u10.get, set: u10.set } : u10[l10], h10);
    if ("accessor" === s10) {
      if (void 0 === g10) continue;
      if (null === g10 || "object" != typeof g10) throw new TypeError("Object expected");
      (d10 = i10(g10.get)) && (u10.get = d10), (d10 = i10(g10.set)) && (u10.set = d10), (d10 = i10(g10.init)) && o10.unshift(d10);
    } else (d10 = i10(g10)) && ("field" === s10 ? o10.unshift(d10) : u10[l10] = d10);
  }
  c10 && Object.defineProperty(c10, r10.name, u10), p10 = true;
}, __runInitializers: function(e14, t10, n10) {
  var r10 = arguments.length > 2;
  for (var o10 = 0; o10 < t10.length; o10++) n10 = r10 ? t10[o10].call(e14, n10) : t10[o10].call(e14);
  return r10 ? n10 : void 0;
}, __propKey: function(e14) {
  return "symbol" == typeof e14 ? e14 : "".concat(e14);
}, __setFunctionName: function(e14, t10, n10) {
  return "symbol" == typeof t10 && (t10 = t10.description ? "[".concat(t10.description, "]") : ""), Object.defineProperty(e14, "name", { configurable: true, value: n10 ? "".concat(n10, " ", t10) : t10 });
}, __metadata: g, __awaiter: y, __generator: v, __createBinding: b, __exportStar: S, __values: C, __read: x, __spread: w, __spreadArrays: T, __spreadArray: E, __await: F, __asyncGenerator: M, __asyncDelegator: k, __asyncValues: P, __makeTemplateObject: N, __importStar: L, __importDefault: H, __classPrivateFieldGet: I, __classPrivateFieldSet: _, __classPrivateFieldIn: V, __addDisposableResource: R, __disposeResources: O, default: B });
var $ = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function W(e14) {
  return e14 && e14.__esModule && Object.prototype.hasOwnProperty.call(e14, "default") ? e14.default : e14;
}
function j(e14) {
  if (e14.__esModule) return e14;
  var t10 = e14.default;
  if ("function" == typeof t10) {
    var n10 = function e15() {
      return this instanceof e15 ? Reflect.construct(t10, arguments, this.constructor) : t10.apply(this, arguments);
    };
    n10.prototype = t10.prototype;
  } else n10 = {};
  return Object.defineProperty(n10, "__esModule", { value: true }), Object.keys(e14).forEach(function(t11) {
    var r10 = Object.getOwnPropertyDescriptor(e14, t11);
    Object.defineProperty(n10, t11, r10.get ? r10 : { enumerable: true, get: function() {
      return e14[t11];
    } });
  }), n10;
}
var Z = {};
var G = {};
var U = {};
var q = {};
!function(e14) {
  function t10(e15) {
    return null != e15 && "object" == typeof e15;
  }
  Object.defineProperty(e14, "__esModule", { value: true }), e14.isEqual = e14.isObjectLike = e14.isObject = e14.isArray = void 0, e14.isArray = Array.isArray, e14.isObject = function(e15) {
    var t11 = typeof e15;
    return null != e15 && ("object" == t11 || "function" == t11);
  }, e14.isObjectLike = t10, e14.isEqual = function n10(r10, o10) {
    return r10 === o10 || (null == r10 || null == o10 || !t10(r10) && !t10(o10) ? r10 != r10 && o10 != o10 : typeof r10 == typeof o10 && ("object" == typeof r10 && ((0, e14.isArray)(r10) ? r10.length === o10.length && r10.every(function(e15, t11) {
      return n10(e15, o10[t11]);
    }) : n10(Object.keys(r10).sort(), Object.keys(o10).sort()) && Object.keys(r10).every(function(e15) {
      return n10(r10[e15], o10[e15]);
    }))));
  };
}(q), function(e14) {
  var t10 = $ && $.__assign || function() {
    return t10 = Object.assign || function(e15) {
      for (var t11, n11 = 1, r11 = arguments.length; n11 < r11; n11++) for (var o11 in t11 = arguments[n11]) Object.prototype.hasOwnProperty.call(t11, o11) && (e15[o11] = t11[o11]);
      return e15;
    }, t10.apply(this, arguments);
  };
  var n10 = $ && $.__spreadArray || function(e15, t11, n11) {
    if (n11 || 2 === arguments.length) for (var r11, o11 = 0, a11 = t11.length; o11 < a11; o11++) !r11 && o11 in t11 || (r11 || (r11 = Array.prototype.slice.call(t11, 0, o11)), r11[o11] = t11[o11]);
    return e15.concat(r11 || Array.prototype.slice.call(t11));
  };
  Object.defineProperty(e14, "__esModule", { value: true }), e14.orElse = e14.getLastRecordedFailures = e14.recordFailures = e14.upcast = e14.makeDefaultOf = e14.omit = e14.pick = e14.Enum = e14.members = e14.lazy = e14.iif = e14.alt = e14.intersectWith = e14.mapInput = e14.map = e14.arrayDef = e14.array = e14.typeDefReq = e14.typeReq = e14.required = e14.typeDef = e14.type = e14.withDefaultOf = e14.literalInit = e14.initValue = e14.DefaultOf = e14.Default = e14.nullable = e14.justRead = e14.optional = e14.boolean = e14.number = e14.string = e14.literal = e14.Temp = e14.Const = e14.unknown = e14.resultOf = e14.failure = e14.success = e14.pipe = e14.recordFailure = void 0;
  var r10 = q;
  var o10 = [];
  function a10() {
    o10 = [];
  }
  function i10(e15) {
    o10.push(t10(t10({}, e15), { context: u10() }));
  }
  function s10(e15, t11, r11, o11) {
    var a11 = [];
    for (var i11 = 4; i11 < arguments.length; i11++) a11[i11 - 4] = arguments[i11];
    switch (arguments.length) {
      case 0:
        return;
      case 1:
        return e15;
      case 2:
        return t11(e15);
      case 3:
        return r11(t11(e15));
      case 4:
        return o11(r11(t11(e15)));
      default:
        return s10.apply(null, n10([o11(r11(t11(e15)))], a11, true));
    }
  }
  e14.recordFailure = i10, e14.pipe = s10;
  e14.success = function(e15, t11) {
    return void 0 === t11 && (t11 = []), { type: "success", value: e15, warnings: t11 };
  };
  e14.failure = function(e15) {
    return { type: "error", reason: e15 };
  };
  e14.resultOf = function(e15) {
    return "success" === e15.type ? e15.value : void 0;
  }, e14.unknown = { decode: function(t11) {
    return (0, e14.success)(t11);
  }, encode: function(e15) {
    return e15;
  } };
  e14.Const = function(t11) {
    return { decode: function() {
      return (0, e14.success)(t11);
    }, encode: function() {
    } };
  };
  var l10;
  function c10(e15, t11) {
    var n11 = l10;
    l10 = { part: e15, next: n11 };
    try {
      return t11();
    } finally {
      l10 = n11;
    }
  }
  function u10() {
    var e15 = [];
    for (var t11 = l10; null != t11 && t11.part; t11 = t11.next) e15.unshift(t11.part);
    return "".concat.apply("", e15);
  }
  e14.Temp = function(t11) {
    return { decode: function() {
      return (0, e14.success)(t11);
    }, encode: function() {
    } };
  };
  var d10 = function(e15) {
    var t11 = [];
    for (var n11 = 1; n11 < arguments.length; n11++) t11[n11 - 1] = arguments[n11];
    return -1 !== t11.findIndex(function(t12) {
      return t12 === e15;
    });
  };
  e14.literal = function() {
    var t11 = [];
    for (var r11 = 0; r11 < arguments.length; r11++) t11[r11] = arguments[r11];
    return { decode: function(r12) {
      return d10.apply(void 0, n10([r12], t11, false)) ? (0, e14.success)(r12) : (0, e14.failure)("expected ".concat(t11.map(function(e15) {
        return JSON.stringify(e15);
      }).join(" | "), ", got: '").concat(r12, "'"));
    }, encode: function(e15) {
      return "string" == typeof e15 || "number" == typeof e15 || null === e15 ? e15 : (i10({ type: "error", message: "expected a string value" }), null == e15 ? void 0 : e15.toString());
    } };
  }, e14.string = { decode: function(t11) {
    return "string" == typeof t11 ? (0, e14.success)(t11) : (0, e14.failure)("expected string");
  }, encode: function(e15) {
    return "string" == typeof e15 ? e15 : (i10({ type: "error", message: "expected a string value" }), null == e15 ? void 0 : e15.toString());
  } }, e14.number = { decode: function(t11) {
    return "number" != typeof t11 || Number.isNaN(t11) ? (0, e14.failure)("expected number") : (0, e14.success)(t11);
  }, encode: function(e15) {
    return "number" == typeof e15 ? e15 : (i10({ type: "error", message: "expected a numeric value" }), null == e15 || Number.isNaN(+e15) ? void 0 : +e15);
  } }, e14.boolean = { decode: function(t11) {
    return "boolean" == typeof t11 ? (0, e14.success)(t11) : (0, e14.failure)("expected boolean");
  }, encode: function(e15) {
    return "boolean" == typeof e15 ? e15 : (i10({ type: "error", message: "expected a bool value" }), null == e15 ? void 0 : !!e15);
  } };
  e14.optional = function(t11) {
    return { decode: function(n11) {
      return null == n11 ? (0, e14.success)(void 0) : t11.decode(n11);
    }, encode: function(e15) {
      return void 0 === e15 ? void 0 : t11.encode(e15);
    } };
  };
  e14.justRead = function(e15) {
    return { decode: e15.decode, encode: function() {
    } };
  };
  e14.nullable = function(t11) {
    return { decode: function(n11) {
      return null == n11 ? (0, e14.success)(null) : t11.decode(n11);
    }, encode: function(e15) {
      return null == e15 ? null : t11.encode(e15);
    } };
  };
  e14.Default = function(t11, n11) {
    return { decode: function(r11) {
      return void 0 === r11 ? (0, e14.success)(t11) : n11.decode(r11);
    }, encode: function(e15) {
      if (!Array.isArray(e15) || 0 !== e15.length || !Array.isArray(t11) || 0 !== t11.length) return (0, r10.isEqual)(e15, t11) ? void 0 : n11.encode(e15);
    } };
  };
  e14.DefaultOf = function(t11, n11) {
    var o11 = n11.decode(t11);
    if ("error" === o11.type) throw new Error("Failed to create a default result");
    var a11 = Object.freeze(o11.value);
    return { decode: function(t12) {
      return void 0 === t12 ? (0, e14.success)(a11) : n11.decode(t12);
    }, encode: function(e15) {
      var o12 = n11.encode(e15);
      return (0, r10.isEqual)(o12, t11) ? void 0 : o12;
    } };
  };
  e14.initValue = function(t11, n11) {
    return { decode: function(r11) {
      return void 0 === r11 ? (0, e14.success)(t11) : n11.decode(r11);
    }, encode: n11.encode };
  };
  e14.literalInit = function(t11) {
    return (0, e14.initValue)(t11, (0, e14.literal)(t11));
  };
  e14.withDefaultOf = function(t11) {
    return function(n11) {
      return (0, e14.DefaultOf)(t11, n11);
    };
  };
  e14.type = function(t11) {
    return { decode: function(n11) {
      if (null == n11) return (0, e14.failure)("non-null expected");
      var r11 = {};
      for (var o11 in t11) if ({}.hasOwnProperty.call(t11, o11)) {
        if (!t11[o11]) return (0, e14.failure)("".concat(o11, ": missing property"));
        var a11 = t11[o11].decode(n11[o11]);
        if ("error" === a11.type) return (0, e14.failure)("".concat(o11, ": ").concat(a11.reason));
        r11[o11] = a11.value;
      }
      return (0, e14.success)(r11);
    }, encode: function(e15) {
      if (null != e15) {
        var n11 = {};
        var r11 = function(r12) {
          if (!{}.hasOwnProperty.call(t11, r12)) return "continue";
          c10(".", function() {
            var o12 = c10(r12, function() {
              return t11[r12].encode(e15[r12]);
            });
            void 0 !== o12 && (n11[r12] = o12);
          });
        };
        for (var o11 in t11) r11(o11);
        return n11;
      }
      i10({ type: "error", message: "non-null value is expected" });
    } };
  };
  e14.typeDef = function(t11) {
    return (0, e14.DefaultOf)({}, (0, e14.type)(t11));
  };
  e14.required = function() {
    var e15 = [];
    for (var t11 = 0; t11 < arguments.length; t11++) e15[t11] = arguments[t11];
    return function(t12) {
      return { decode: function(n11) {
        var r11 = e15.find(function(e16) {
          return void 0 === n11[e16];
        });
        return null != r11 && i10({ type: "error", message: "Property ".concat(String(r11), " is marked as required, but not provided") }), t12.decode(n11);
      }, encode: function(e16) {
        return t12.encode(e16);
      } };
    };
  };
  e14.typeReq = function(t11, n11) {
    return s10((0, e14.type)(t11), e14.required.apply(void 0, n11));
  };
  e14.typeDefReq = function(t11, n11, r11) {
    return (0, e14.DefaultOf)(n11, (0, e14.typeReq)(t11, r11));
  };
  e14.array = function(t11) {
    return { decode: function(n11) {
      if (!(0, r10.isArray)(n11)) return (0, e14.failure)("array expected");
      var o11 = n11.map(t11.decode);
      var a11 = o11.find(function(e15) {
        return "error" === e15.type;
      });
      return a11 && "error" === a11.type ? (0, e14.failure)(a11.reason) : (0, e14.success)(o11.map(e14.resultOf));
    }, encode: function(e15) {
      if (null != e15) return (0, r10.isArray)(e15) ? e15.map(function(e16, n11) {
        return c10("[".concat(n11, "]"), function() {
          return t11.encode(e16);
        });
      }) : (i10({ type: "error", message: "array is expected" }), []);
    } };
  };
  e14.arrayDef = function(t11) {
    return (0, e14.Default)([], (0, e14.array)(t11));
  };
  e14.map = function(t11, n11) {
    return function(r11) {
      return { decode: function(n12) {
        var o11 = r11.decode(n12);
        return "error" === o11.type ? o11 : (0, e14.success)(t11(o11.value));
      }, encode: function(e15) {
        return r11.encode(n11(e15));
      } };
    };
  };
  e14.mapInput = function(e15, t11) {
    return function(n11) {
      return { decode: function(e16) {
        return n11.decode(t11(e16));
      }, encode: function(t12) {
        return e15(n11.encode(t12));
      } };
    };
  };
  e14.intersectWith = function(n11) {
    return function(r11) {
      return { decode: function(o11) {
        var a11 = r11.decode(o11);
        if ("error" === a11.type) return (0, e14.failure)(a11.reason);
        var i11 = n11.decode(o11);
        return "success" === i11.type ? (0, e14.success)(t10(t10({}, a11.value), i11.value)) : (0, e14.failure)(i11.reason);
      }, encode: function(e15) {
        return t10(t10({}, r11.encode(e15)), n11.encode(e15));
      } };
    };
  };
  e14.alt = function(t11, n11, r11) {
    return { decode: function(n12) {
      var o11 = t11(n12) || "";
      var a11 = r11[o11];
      return null == a11 ? (0, e14.failure)('Unknown or unsupported item type "'.concat(o11, '"')) : a11.decode(n12);
    }, encode: function(e15) {
      var t12 = r11[n11(e15)];
      if (null == t12) throw new Error("unknown item type '".concat(n11(e15), "'"));
      return t12.encode(e15);
    } };
  };
  e14.iif = function(e15, t11, n11, r11) {
    return { decode: function(t12) {
      return e15(t12) ? n11.decode(t12) : r11.decode(t12);
    }, encode: function(e16) {
      return t11(e16) ? n11.encode(e16) : r11.encode(e16);
    } };
  };
  e14.lazy = function() {
    var e15 = function() {
      throw new Error("Cannot get here");
    };
    var t11 = { decode: e15, encode: e15 };
    return [t11, function(e16) {
      t11.decode = e16.decode, t11.encode = e16.encode;
    }];
  };
  e14.members = function() {
    var t11 = [];
    for (var n11 = 0; n11 < arguments.length; n11++) t11[n11] = arguments[n11];
    var r11 = {};
    t11.forEach(function(e15) {
      r11[e15] = e15, r11[e15.toLowerCase()] = e15;
    });
    var o11 = "expected ".concat(t11.map(function(e15) {
      return JSON.stringify(e15);
    }).join(" | "));
    return { decode: function(t12) {
      var n12 = "string" == typeof t12 ? r11[t12] || r11[t12.toLowerCase()] : void 0;
      return void 0 !== n12 ? (0, e14.success)(n12) : (0, e14.failure)("".concat(o11, ", got: '").concat(t12, "'"));
    }, encode: function(e15) {
      return "string" == typeof e15 ? e15 : (i10({ type: "error", message: "expected a string value" }), null == e15 ? void 0 : e15.toString());
    } };
  };
  e14.Enum = function(t11, n11) {
    return { decode: function(r11) {
      if (void 0 === r11) return (0, e14.success)(t11);
      var o11 = n11.decode(r11);
      return "success" === o11.type ? o11 : (i10({ type: "error", message: o11.reason }), (0, e14.success)(t11));
    }, encode: function(e15) {
      return e15 === t11 ? void 0 : n11.encode(e15);
    } };
  }, e14.pick = function(e15) {
    var t11 = [];
    for (var n11 = 1; n11 < arguments.length; n11++) t11[n11 - 1] = arguments[n11];
    var r11 = {};
    for (var o11 = 0, a11 = t11; o11 < a11.length; o11++) {
      var i11 = a11[o11];
      r11[i11] = e15[i11];
    }
    return r11;
  }, e14.omit = function(e15) {
    var t11 = [];
    for (var n11 = 1; n11 < arguments.length; n11++) t11[n11 - 1] = arguments[n11];
    var r11 = {};
    var o11 = function(n12) {
      t11.find(function(e16) {
        return e16 === n12;
      }) || (r11[n12] = e15[n12]);
    };
    for (var a11 = 0, i11 = Object.keys(e15); a11 < i11.length; a11++) {
      o11(i11[a11]);
    }
    return r11;
  }, e14.makeDefaultOf = function(t11, n11) {
    return void 0 === n11 && (n11 = {}), Object.freeze((0, e14.resultOf)(t11.decode(n11)));
  };
  e14.upcast = function() {
    return function(e15) {
      return e15;
    };
  };
  e14.recordFailures = function(t11) {
    return { decode: function(n11) {
      a10();
      var r11 = t11.decode(n11);
      var i11 = o10;
      return "success" === r11.type ? (0, e14.success)(r11.value, i11) : r11;
    }, encode: function(e15) {
      return a10(), t11.encode(e15);
    } };
  };
  e14.getLastRecordedFailures = function() {
    return n10([], o10, true);
  };
  e14.orElse = function(e15, t11) {
    return function(n11) {
      return { decode: function(t12) {
        var r11 = n11.decode(t12);
        return "error" === r11.type ? (i10({ type: "warning", message: r11.reason }), e15.decode(t12)) : r11;
      }, encode: function(r11) {
        return t11(r11) ? e15.encode(r11) : n11.encode(r11);
      } };
    };
  };
}(U);
var Y = {};
var K = $ && $.__assign || function() {
  return K = Object.assign || function(e14) {
    for (var t10, n10 = 1, r10 = arguments.length; n10 < r10; n10++) for (var o10 in t10 = arguments[n10]) Object.prototype.hasOwnProperty.call(t10, o10) && (e14[o10] = t10[o10]);
    return e14;
  }, K.apply(this, arguments);
};
var X = $ && $.__rest || function(e14, t10) {
  var n10 = {};
  for (var r10 in e14) Object.prototype.hasOwnProperty.call(e14, r10) && t10.indexOf(r10) < 0 && (n10[r10] = e14[r10]);
  if (null != e14 && "function" == typeof Object.getOwnPropertySymbols) {
    var o10 = 0;
    for (r10 = Object.getOwnPropertySymbols(e14); o10 < r10.length; o10++) t10.indexOf(r10[o10]) < 0 && Object.prototype.propertyIsEnumerable.call(e14, r10[o10]) && (n10[r10[o10]] = e14[r10[o10]]);
  }
  return n10;
};
Object.defineProperty(Y, "__esModule", { value: true }), Y.identity = Y.mapOfLens = Y.iif = Y.combine5 = Y.combine4 = Y.combine3 = Y.combine = Y.replace = Y.array = Y.nullable = Y.prop = Y.make = void 0;
var J = U;
Y.make = function(e14, t10) {
  return { f: e14, frev: t10 };
}, Y.prop = function(e14, t10) {
  return { f: function(n10) {
    var r10;
    var o10 = e14, a10 = n10[o10], i10 = X(n10, ["symbol" == typeof o10 ? o10 : o10 + ""]);
    return K(K({}, i10), ((r10 = {})[e14] = t10.f(a10), r10));
  }, frev: function(n10) {
    var r10;
    var o10 = e14, a10 = n10[o10], i10 = X(n10, ["symbol" == typeof o10 ? o10 : o10 + ""]);
    return K(K({}, i10), ((r10 = {})[e14] = t10.frev(a10), r10));
  } };
}, Y.nullable = function(e14) {
  return { f: function(t10) {
    return null === t10 ? null : e14.f(t10);
  }, frev: function(t10) {
    return null === t10 ? null : e14.frev(t10);
  } };
}, Y.array = function(e14) {
  return { f: function(t10) {
    return t10.map(e14.f);
  }, frev: function(t10) {
    return t10.map(e14.frev);
  } };
}, Y.replace = function(e14, t10) {
  return { f: function() {
    return t10;
  }, frev: function() {
    return e14;
  } };
}, Y.combine = function(e14, t10) {
  return { f: function(n10) {
    return t10.f(e14.f(n10));
  }, frev: function(n10) {
    return e14.frev(t10.frev(n10));
  } };
}, Y.combine3 = function(e14, t10, n10) {
  return { f: function(r10) {
    return n10.f(t10.f(e14.f(r10)));
  }, frev: function(r10) {
    return e14.frev(t10.frev(n10.frev(r10)));
  } };
}, Y.combine4 = function(e14, t10, n10, r10) {
  return { f: function(o10) {
    return r10.f(n10.f(t10.f(e14.f(o10))));
  }, frev: function(o10) {
    return e14.frev(t10.frev(n10.frev(r10.frev(o10))));
  } };
}, Y.combine5 = function(e14, t10, n10, r10, o10) {
  return { f: function(a10) {
    return o10.f(r10.f(n10.f(t10.f(e14.f(a10)))));
  }, frev: function(a10) {
    return e14.frev(t10.frev(n10.frev(r10.frev(o10.frev(a10)))));
  } };
}, Y.iif = function(e14, t10, n10, r10) {
  return { f: function(t11) {
    return e14(t11) ? n10.f(t11) : r10.f(t11);
  }, frev: function(e15) {
    return t10(e15) ? n10.frev(e15) : r10.frev(e15);
  } };
}, Y.mapOfLens = function(e14) {
  return (0, J.map)(e14.f, e14.frev);
}, Y.identity = function() {
  return { f: function(e14) {
    return e14;
  }, frev: function(e14) {
    return e14;
  } };
}, function(e14) {
  var t10 = $ && $.__createBinding || (Object.create ? function(e15, t11, n11, r10) {
    void 0 === r10 && (r10 = n11);
    var o10 = Object.getOwnPropertyDescriptor(t11, n11);
    o10 && !("get" in o10 ? !t11.__esModule : o10.writable || o10.configurable) || (o10 = { enumerable: true, get: function() {
      return t11[n11];
    } }), Object.defineProperty(e15, r10, o10);
  } : function(e15, t11, n11, r10) {
    void 0 === r10 && (r10 = n11), e15[r10] = t11[n11];
  });
  var n10 = $ && $.__exportStar || function(e15, n11) {
    for (var r10 in e15) "default" === r10 || Object.prototype.hasOwnProperty.call(n11, r10) || t10(n11, e15, r10);
  };
  Object.defineProperty(e14, "__esModule", { value: true }), e14.Helpers = e14.Lenses = void 0, n10(U, e14), e14.Lenses = Y, e14.Helpers = q;
}(G);
var Q = {};
var ee = {};
var te = {};
Object.defineProperty(te, "__esModule", { value: true }), te.ExprColor = te.ExprLength = te.ExprVariant = te.ExprNum = te.ExprBool = te.ExprStr = te.c = te.e = void 0;
var ne = G;
te.e = function(e14) {
  return re(e14) ? "" : "=".concat(e14);
};
te.c = function(e14) {
  return e14;
};
var re = function(e14) {
  return "" === e14 || "=" === e14 || '=""' === e14;
};
var oe = function() {
  return { decode: function(e14) {
    return "string" == typeof e14 ? re(e14) ? (0, ne.success)("") : (0, ne.success)(e14) : null == e14 ? (0, ne.failure)("non-null expected") : (0, ne.success)("".concat(e14));
  }, encode: function(e14) {
    return "string" == typeof e14 ? e14 : ((0, ne.recordFailure)({ type: "error", message: "expected a enum/string value" }), null == e14 ? void 0 : e14.toString());
  } };
};
te.ExprStr = oe(), te.ExprBool = oe(), te.ExprNum = oe(), te.ExprVariant = oe(), te.ExprLength = oe(), te.ExprColor = oe();
var ae = {};
!function(e14) {
  var t10 = $ && $.__assign || function() {
    return t10 = Object.assign || function(e15) {
      for (var t11, n11 = 1, r11 = arguments.length; n11 < r11; n11++) for (var o10 in t11 = arguments[n11]) Object.prototype.hasOwnProperty.call(t11, o10) && (e15[o10] = t11[o10]);
      return e15;
    }, t10.apply(this, arguments);
  };
  var n10 = $ && $.__rest || function(e15, t11) {
    var n11 = {};
    for (var r11 in e15) Object.prototype.hasOwnProperty.call(e15, r11) && t11.indexOf(r11) < 0 && (n11[r11] = e15[r11]);
    if (null != e15 && "function" == typeof Object.getOwnPropertySymbols) {
      var o10 = 0;
      for (r11 = Object.getOwnPropertySymbols(e15); o10 < r11.length; o10++) t11.indexOf(r11[o10]) < 0 && Object.prototype.propertyIsEnumerable.call(e15, r11[o10]) && (n11[r11[o10]] = e15[r11[o10]]);
    }
    return n11;
  };
  Object.defineProperty(e14, "__esModule", { value: true }), e14.StoreUndefinedAsNull = e14.TreatNullAsUndefined = e14.TreatNullAs = e14.AcceptBlankString = e14.orElse = e14.changeType = e14.EnumExpr = e14.Enum = e14.members = void 0;
  var r10 = G;
  e14.members = function() {
    var e15 = [];
    for (var t11 = 0; t11 < arguments.length; t11++) e15[t11] = arguments[t11];
    var n11 = {};
    e15.forEach(function(e16) {
      n11[e16] = e16, n11[e16.toLowerCase()] = e16;
    });
    var o10 = "expected ".concat(e15.map(function(e16) {
      return JSON.stringify(e16);
    }).join(" | "));
    return { decode: function(e16) {
      var t12 = "string" == typeof e16 ? n11[e16] || n11[e16.toLowerCase()] : void 0;
      return void 0 !== t12 ? (0, r10.success)(t12) : (0, r10.failure)("".concat(o10, ", got: '").concat(e16, "'"));
    }, encode: function(e16) {
      return "string" == typeof e16 ? e16 : ((0, r10.recordFailure)({ type: "error", message: "expected a string value" }), null == e16 ? void 0 : e16.toString());
    } };
  };
  e14.Enum = function(e15, t11) {
    return { decode: function(n11) {
      if (void 0 === n11) return (0, r10.success)(e15);
      var o10 = t11.decode(n11);
      return "success" === o10.type ? o10 : ((0, r10.recordFailure)({ type: "error", message: o10.reason }), (0, r10.success)(e15));
    }, encode: function(n11) {
      return n11 === e15 ? void 0 : t11.encode(n11);
    } };
  };
  e14.EnumExpr = function(t11, n11) {
    var o10 = (0, e14.Enum)(t11, n11);
    return { decode: function(e15) {
      return void 0 === e15 ? (0, r10.success)(t11) : "string" == typeof e15 && e15.startsWith("=") ? (0, r10.success)(e15) : o10.decode(e15);
    }, encode: function(e15) {
      if (e15 !== t11) return "string" == typeof e15 && e15.startsWith("=") ? e15 : n11.encode(e15);
    } };
  };
  e14.changeType = function(e15, o10) {
    return function(a10) {
      return (0, r10.pipe)(a10, (0, r10.map)(function(e16) {
        var r11 = n10(e16, []);
        return t10(t10({}, r11), { Type: o10 });
      }, function(r11) {
        var o11 = n10(r11, []);
        return t10(t10({}, o11), { Type: e15 });
      }));
    };
  };
  e14.orElse = function(e15, t11) {
    return function(n11) {
      return { decode: function(t12) {
        var o10 = n11.decode(t12);
        return "error" === o10.type ? ((0, r10.recordFailure)({ type: "warning", message: o10.reason }), e15.decode(t12)) : o10;
      }, encode: function(r11) {
        return t11(r11) ? e15.encode(r11) : n11.encode(r11);
      } };
    };
  };
  e14.AcceptBlankString = function(e15) {
    return { decode: function(t11) {
      return "string" == typeof t11 && "" === t11 ? e15.decode(void 0) : e15.decode(t11);
    }, encode: e15.encode };
  };
  e14.TreatNullAs = function(e15) {
    return function(t11) {
      return { decode: function(n11) {
        return null === n11 ? t11.decode(e15) : t11.decode(n11);
      }, encode: t11.encode };
    };
  };
  e14.TreatNullAsUndefined = function(e15) {
    return { decode: function(t11) {
      return null === t11 ? e15.decode(void 0) : e15.decode(t11);
    }, encode: e15.encode };
  };
  e14.StoreUndefinedAsNull = function(e15) {
    return { decode: function(t11) {
      return e15.decode(null === t11 ? void 0 : t11);
    }, encode: function(t11) {
      var n11 = e15.encode(t11);
      return void 0 === n11 ? null : n11;
    } };
  };
}(ae), function(e14) {
  var t10 = $ && $.__assign || function() {
    return t10 = Object.assign || function(e15) {
      for (var t11, n11 = 1, r11 = arguments.length; n11 < r11; n11++) for (var o11 in t11 = arguments[n11]) Object.prototype.hasOwnProperty.call(t11, o11) && (e15[o11] = t11[o11]);
      return e15;
    }, t10.apply(this, arguments);
  };
  var n10 = $ && $.__rest || function(e15, t11) {
    var n11 = {};
    for (var r11 in e15) Object.prototype.hasOwnProperty.call(e15, r11) && t11.indexOf(r11) < 0 && (n11[r11] = e15[r11]);
    if (null != e15 && "function" == typeof Object.getOwnPropertySymbols) {
      var o11 = 0;
      for (r11 = Object.getOwnPropertySymbols(e15); o11 < r11.length; o11++) t11.indexOf(r11[o11]) < 0 && Object.prototype.propertyIsEnumerable.call(e15, r11[o11]) && (n11[r11[o11]] = e15[r11[o11]]);
    }
    return n11;
  };
  var r10 = $ && $.__spreadArray || function(e15, t11, n11) {
    if (n11 || 2 === arguments.length) for (var r11, o11 = 0, a11 = t11.length; o11 < a11; o11++) !r11 && o11 in t11 || (r11 || (r11 = Array.prototype.slice.call(t11, 0, o11)), r11[o11] = t11[o11]);
    return e15.concat(r11 || Array.prototype.slice.call(t11));
  };
  Object.defineProperty(e14, "__esModule", { value: true }), e14.CustomProperty = e14.QueryParameter = e14.Filters = e14.Filter = e14.FilterOperator = e14.TextProps = e14.PaddingProps = e14.FontProps = e14.BorderProps = e14.CommonStyle = e14.style = e14.Action = e14.ApplyParameterStep = e14.SubreportParameter = e14.Visibility = e14.SideStyle = e14.BorderStyle = e14.Enums = e14.Length = void 0;
  var o10 = te;
  var a10 = G;
  var i10 = ae;
  e14.Length = a10.string, e14.Enums = { FontStyle: (0, i10.members)("Default", "Normal", "Italic"), FontWeight: (0, i10.members)("Default", "Lighter", "Thin", "ExtraLight", "Light", "Normal", "Medium", "SemiBold", "Bold", "ExtraBold", "Heavy", "Bolder"), BackgroundGradientType: (0, i10.members)("None", "LeftRight", "TopBottom", "Center", "DiagonalLeft", "DiagonalRight", "HorizontalCenter", "VerticalCenter"), TextDecoration: (0, i10.members)("Default", "None", "Underline", "DoubleUnderline", "Overline", "LineThrough"), TextAlign: (0, i10.members)("General", "Left", "Center", "Right", "Justify"), VerticalAlign: (0, i10.members)("Default", "Top", "Middle", "Bottom"), VerticalImageAlign: (0, i10.members)("Top", "Middle", "Bottom"), HorizontalImageAlign: (0, i10.members)("Left", "Center", "Right"), WrapMode: (0, i10.members)("NoWrap", "CharWrap", "WordWrap"), Direction: (0, i10.members)("Default", "LTR", "RTL"), LayoutDirection: (0, i10.members)("LTR", "RTL"), WritingMode: (0, i10.members)("lr-tb", "tb-rl"), Calendar: (0, i10.members)("Default", "Gregorian", "GregorianArabic", "GregorianMiddleEastFrench", "GregorianTransliteratedEnglish", "GregorianTransliteratedFrench", "GregorianUSEnglish", "Hebrew", "Hijri", "Japanese", "Korean", "Taiwan", "ThaiBuddhist"), UnicodeBiDi: (0, i10.members)("Normal", "Embed", "BidiOverride"), UprightInVerticalText: (0, i10.members)("None", "Digits", "DigitsAndLatinLetters"), TextJustify: (0, i10.members)("Auto", "Distribute", "DistributeAllLines"), BorderStyle: (0, i10.members)("Default", "None", "Dotted", "Dashed", "Solid", "Double", "DashDot", "DashDotDot", "Groove", "Ridge", "Inset", "WindowInset", "Outset"), BorderSideStyle: (0, i10.members)("", "Default", "None", "Dotted", "Dashed", "Solid", "Double", "DashDot", "DashDotDot", "Groove", "Ridge", "Inset", "WindowInset", "Outset"), BreakLocation: (0, i10.members)("Start", "End", "StartAndEnd", "Between", "None"), NewPage: (0, i10.members)("Next", "Odd", "Even"), DataElementOutput: (0, i10.members)("Auto", "Output", "NoOutput", "ContentsOnly"), DataElementStyle: (0, i10.members)("Auto", "AttributeNormal", "ElementNormal"), ImageSource: (0, i10.members)("External", "Embedded", "Database"), ImageRepeat: (0, i10.members)("Repeat", "NoRepeat", "RepeatX", "RepeatY"), ShapeStyle: (0, i10.members)("Rectangle", "RoundRect", "Ellipse"), ApplyValueCmd: (0, i10.members)("Set", "Reset", "Toggle"), ReportPartPropertyType: (0, i10.members)("boolean", "integer", "float", "string", "color", "length", "fontFamily", "fontSize", "fontStyle", "fontWeight", "textDecoration", "lineWidth", "borderStyle", "lineStyle"), RectangleOverflow: (0, i10.members)("Scroll", "Clip", "Auto", "Grow"), BulletLabelFontStyles: (0, i10.members)("Regular", "Bold", "Italic", "Underline", "Strikeout"), ParagraphTextAlign: (0, i10.members)("Left", "Center", "Right", "Justify") }, e14.BorderStyle = (0, a10.typeDef)({ Color: (0, a10.DefaultOf)("Black", o10.ExprColor), Style: (0, i10.EnumExpr)("None", e14.Enums.BorderStyle), Width: (0, a10.DefaultOf)("1pt", o10.ExprLength) }), e14.SideStyle = (0, a10.typeDef)({ Color: (0, a10.DefaultOf)("", o10.ExprColor), Style: (0, i10.EnumExpr)("", e14.Enums.BorderSideStyle), Width: (0, a10.DefaultOf)("", o10.ExprLength) });
  var s10 = (0, a10.typeDef)({ Source: (0, i10.Enum)("External", e14.Enums.ImageSource), Value: (0, a10.Default)("", o10.ExprStr), MIMEType: (0, a10.DefaultOf)("", o10.ExprStr), BackgroundRepeat: (0, i10.EnumExpr)("Repeat", e14.Enums.ImageRepeat) });
  e14.Visibility = (0, a10.typeDef)({ Hidden: (0, a10.Default)("False", o10.ExprBool), ToggleItem: (0, a10.Default)("", a10.string) }), e14.SubreportParameter = (0, a10.pipe)((0, a10.type)({ Type: (0, a10.Const)("parameter"), ParameterName: a10.string, Value: (0, a10.Default)("", o10.ExprVariant), Omit: (0, a10.Default)("false", o10.ExprBool) }), (0, a10.required)("ParameterName")), e14.ApplyParameterStep = (0, a10.pipe)((0, a10.type)({ Name: (0, a10.Default)("", a10.string), Type: (0, i10.Enum)("Set", e14.Enums.ApplyValueCmd), Value: (0, a10.Default)("", o10.ExprVariant) }), (0, a10.required)("Name")), e14.Action = (0, a10.pipe)((0, a10.type)({ Hyperlink: (0, a10.DefaultOf)("", o10.ExprStr), Drillthrough: (0, a10.typeDef)({ ReportName: (0, a10.Default)("", o10.ExprStr), Parameters: (0, a10.arrayDef)(e14.SubreportParameter) }), BookmarkLink: (0, a10.DefaultOf)("", o10.ExprStr), ApplyParameters: (0, a10.typeDef)({ Parameters: (0, a10.arrayDef)(e14.ApplyParameterStep) }) }), (0, a10.withDefaultOf)({}), i10.TreatNullAsUndefined);
  var l10 = { Border: e14.BorderStyle, TopBorder: e14.SideStyle, RightBorder: e14.SideStyle, BottomBorder: e14.SideStyle, LeftBorder: e14.SideStyle, BackgroundColor: (0, a10.DefaultOf)("Transparent", o10.ExprColor), BackgroundGradientEndColor: (0, a10.DefaultOf)("Transparent", o10.ExprColor), BackgroundGradientType: (0, i10.EnumExpr)("None", e14.Enums.BackgroundGradientType), BackgroundImage: s10, FontStyle: (0, i10.EnumExpr)("Normal", e14.Enums.FontStyle), FontFamily: (0, a10.DefaultOf)("Arial", o10.ExprStr), FontSize: (0, a10.DefaultOf)("10pt", o10.ExprLength), FontWeight: (0, i10.EnumExpr)("Normal", e14.Enums.FontWeight), LineHeight: (0, a10.Default)("1pt", o10.ExprLength), LineSpacing: (0, a10.DefaultOf)("", o10.ExprLength), CharacterSpacing: (0, a10.DefaultOf)("", o10.ExprLength), Format: (0, a10.DefaultOf)("", o10.ExprStr), TextDecoration: (0, i10.EnumExpr)("None", e14.Enums.TextDecoration), TextAlign: (0, i10.EnumExpr)("General", e14.Enums.TextAlign), VerticalAlign: (0, i10.EnumExpr)("Top", e14.Enums.VerticalAlign), WrapMode: (0, i10.EnumExpr)("WordWrap", e14.Enums.WrapMode), Color: (0, a10.DefaultOf)("Black", o10.ExprColor), PaddingLeft: (0, a10.DefaultOf)("0pt", o10.ExprLength), PaddingRight: (0, a10.DefaultOf)("0pt", o10.ExprLength), PaddingTop: (0, a10.DefaultOf)("0pt", o10.ExprLength), PaddingBottom: (0, a10.DefaultOf)("0pt", o10.ExprLength), Direction: (0, i10.EnumExpr)("LTR", e14.Enums.Direction), WritingMode: (0, i10.EnumExpr)("lr-tb", e14.Enums.WritingMode), Language: (0, a10.DefaultOf)("", o10.ExprStr), Calendar: (0, i10.EnumExpr)("Gregorian", e14.Enums.Calendar), NumeralLanguage: (0, a10.DefaultOf)("", o10.ExprStr), NumeralVariant: (0, a10.Default)("1", o10.ExprNum), UnicodeBiDi: (0, i10.EnumExpr)("Normal", e14.Enums.UnicodeBiDi), UprightInVerticalText: (0, i10.EnumExpr)("None", e14.Enums.UprightInVerticalText), TextIndent: (0, a10.DefaultOf)("0.5in", e14.Length), LeadingChar: (0, a10.Default)("", o10.ExprStr), MaxLevel: (0, a10.DefaultOf)("0", o10.ExprNum), HeadingLevel: (0, a10.DefaultOf)("", o10.ExprNum), ShrinkToFit: (0, a10.Default)("False", o10.ExprBool), TextJustify: (0, i10.EnumExpr)("Auto", e14.Enums.TextJustify), Angle: (0, a10.Default)("0", a10.string), MinCondenseRate: (0, a10.Default)(100, o10.ExprNum) };
  e14.style = function() {
    var e15 = [];
    for (var t11 = 0; t11 < arguments.length; t11++) e15[t11] = arguments[t11];
    return a10.pick.apply(void 0, r10([l10], e15, false));
  }, e14.CommonStyle = (0, a10.type)(l10), e14.BorderProps = (0, e14.style)("Border", "TopBorder", "BottomBorder", "LeftBorder", "RightBorder"), e14.FontProps = (0, e14.style)("FontFamily", "FontSize", "FontStyle", "FontWeight"), e14.PaddingProps = (0, e14.style)("PaddingLeft", "PaddingRight", "PaddingTop", "PaddingBottom"), e14.TextProps = t10(t10(t10({}, e14.FontProps), e14.PaddingProps), (0, e14.style)("Color", "Format", "LineHeight", "TextAlign", "TextDecoration", "VerticalAlign", "Calendar", "Direction", "Language", "NumeralLanguage", "NumeralVariant", "UnicodeBiDi", "UprightInVerticalText", "WritingMode")), e14.FilterOperator = (0, i10.members)("Equal", "Like", "NotEqual", "GreaterThan", "GreaterThanOrEqual", "LessThan", "LessThanOrEqual", "TopN", "BottomN", "TopPercent", "BottomPercent", "In", "Between"), e14.Filter = (0, a10.pipe)((0, a10.type)({ FilterExpression: (0, a10.initValue)("", o10.ExprVariant), Operator: (0, a10.initValue)("Equal", e14.FilterOperator), FilterValues: (0, a10.arrayDef)(o10.ExprVariant) }), (0, a10.required)("FilterExpression", "Operator", "FilterValues")), e14.Filters = (0, a10.arrayDef)(e14.Filter);
  var c10 = { encode: function() {
    return {};
  }, decode: function(e15) {
    e15.Name, e15.Value;
    var t11 = n10(e15, ["Name", "Value"]);
    return 0 === Object.keys(t11).length ? (0, a10.success)({}) : (0, a10.success)({ $legacy: t11 });
  } };
  e14.QueryParameter = (0, a10.pipe)((0, a10.type)({ Name: a10.string, Value: (0, a10.DefaultOf)("", o10.ExprVariant) }), (0, a10.intersectWith)(c10), (0, a10.required)("Name", "Value")), e14.CustomProperty = (0, a10.pipe)((0, a10.type)({ Name: a10.string, Value: (0, a10.initValue)("", o10.ExprVariant) }), (0, a10.required)("Name", "Value"));
}(ee);
var ie = {};
!function(e14) {
  Object.defineProperty(e14, "__esModule", { value: true }), e14.DataSet = e14.Field = e14.DataSource = e14.ReportParameter = e14.Filters = void 0;
  var t10 = G;
  var n10 = te;
  var r10 = ee;
  var o10 = ae;
  var a10 = ee;
  Object.defineProperty(e14, "Filters", { enumerable: true, get: function() {
    return a10.Filters;
  } });
  var i10 = (0, t10.Default)(false, t10.boolean);
  var s10 = (0, t10.Default)("", t10.string);
  var l10 = (0, o10.members)("Auto", "True", "False");
  var c10 = (0, t10.typeDefReq)({ DataSetName: t10.string, ValueField: t10.string, LabelField: s10 }, { DataSetName: "", ValueField: "" }, ["DataSetName", "ValueField"]);
  var u10 = (0, t10.type)({ Value: (0, t10.optional)(n10.ExprVariant), Label: (0, t10.optional)(n10.ExprVariant) });
  var d10 = (0, t10.DefaultOf)({}, (0, t10.type)({ Condition: (0, t10.initValue)("None", (0, o10.members)("None", "Label", "Value")), Direction: (0, o10.Enum)("Ascending", (0, o10.members)("Ascending", "Descending")) }));
  var p10 = (0, t10.DefaultOf)({}, (0, t10.type)({ ParameterValues: (0, t10.arrayDef)(u10), DataSetReference: c10, OrderBy: d10 }));
  var m10 = (0, t10.DefaultOf)({}, (0, t10.type)({ Values: (0, t10.arrayDef)(n10.ExprVariant), DataSetReference: c10 }));
  e14.ReportParameter = (0, t10.pipe)((0, t10.type)({ Type: (0, t10.Const)("reportparameter"), AllowBlank: i10, DataType: (0, t10.initValue)("String", (0, o10.members)("Boolean", "Date", "DateTime", "Integer", "Float", "String")), DefaultValue: m10, Hidden: i10, Multiline: i10, MultiValue: i10, Name: t10.string, Nullable: i10, Prompt: (0, t10.Default)("", n10.ExprStr), SelectAllValue: (0, t10.DefaultOf)("", n10.ExprVariant), UsedInQuery: (0, o10.Enum)("Auto", l10), ValidValues: p10, DisplayFormat: (0, t10.Default)("", t10.string) }), (0, t10.required)("Name", "DataType")), e14.DataSource = (0, t10.pipe)((0, t10.type)({ Name: t10.string, Transaction: i10, DataSourceReference: s10, ConnectionProperties: (0, t10.typeDefReq)({ DataProvider: t10.string, ConnectString: (0, t10.Default)("", n10.ExprStr), IntegratedSecurity: i10, Prompt: s10 }, { DataProvider: "" }, ["DataProvider"]) })), e14.Field = (0, t10.pipe)((0, t10.type)({ Name: s10, DataField: s10, Value: (0, t10.DefaultOf)("", n10.ExprVariant) }), (0, t10.required)("Name")), e14.DataSet = (0, t10.pipe)((0, t10.type)({ Name: t10.string, Fields: (0, t10.arrayDef)(e14.Field), Query: (0, t10.typeDefReq)({ DataSourceName: t10.string, CommandType: (0, o10.Enum)("Text", (0, o10.members)("Text", "StoredProcedure", "TableDirect")), CommandText: (0, o10.TreatNullAsUndefined)((0, t10.DefaultOf)("", n10.ExprStr)), QueryParameters: (0, t10.arrayDef)(r10.QueryParameter), Timeout: (0, t10.Default)(0, t10.number) }, { DataSourceName: "" }, ["DataSourceName"]), Filters: r10.Filters, CaseSensitivity: (0, t10.initValue)("Auto", l10), Collation: s10, KanatypeSensitivity: (0, t10.initValue)("Auto", l10), AccentSensitivity: (0, t10.initValue)("Auto", l10), WidthSensitivity: (0, t10.initValue)("Auto", l10) }), (0, t10.required)("Name"));
}(ie);
var se = {};
var le = {};
!function(e14) {
  var t10 = $ && $.__assign || function() {
    return t10 = Object.assign || function(e15) {
      for (var t11, n11 = 1, r11 = arguments.length; n11 < r11; n11++) for (var o11 in t11 = arguments[n11]) Object.prototype.hasOwnProperty.call(t11, o11) && (e15[o11] = t11[o11]);
      return e15;
    }, t10.apply(this, arguments);
  };
  Object.defineProperty(e14, "__esModule", { value: true }), e14.Length_0in = e14.string_empty = e14.boolean_true = e14.boolean_false = e14.ReportItemProps = e14.ReportItemProperties = void 0;
  var n10 = G;
  var r10 = te;
  var o10 = ee;
  e14.ReportItemProperties = { Name: n10.string, ZIndex: (0, n10.Default)(0, n10.number), Visibility: o10.Visibility, ToolTip: (0, n10.DefaultOf)("", r10.ExprStr), Bookmark: (0, n10.DefaultOf)("", r10.ExprStr), DataElementName: (0, n10.Default)("", n10.string), DataElementOutput: (0, n10.Default)("Auto", o10.Enums.DataElementOutput), Label: (0, n10.DefaultOf)("", r10.ExprStr), LayerName: (0, n10.Default)("default", n10.string), CustomProperties: (0, n10.arrayDef)(o10.CustomProperty) };
  e14.ReportItemProps = function(r11) {
    return t10({ Type: (0, n10.literalInit)(r11) }, e14.ReportItemProperties);
  }, e14.boolean_false = (0, n10.Default)(false, n10.boolean), e14.boolean_true = (0, n10.Default)(true, n10.boolean), e14.string_empty = (0, n10.Default)("", n10.string), e14.Length_0in = (0, n10.DefaultOf)("0in", o10.Length);
}(le);
var ce = {};
var ue = $ && $.__assign || function() {
  return ue = Object.assign || function(e14) {
    for (var t10, n10 = 1, r10 = arguments.length; n10 < r10; n10++) for (var o10 in t10 = arguments[n10]) Object.prototype.hasOwnProperty.call(t10, o10) && (e14[o10] = t10[o10]);
    return e14;
  }, ue.apply(this, arguments);
};
Object.defineProperty(ce, "__esModule", { value: true }), ce.RichText = void 0;
var de = G;
var pe = te;
var me = ee;
var he = ae;
var fe = le;
var ge = { FontFamily: (0, de.optional)(pe.ExprStr), FontSize: (0, de.optional)(pe.ExprLength), FontStyle: (0, de.optional)(me.Enums.FontStyle), FontWeight: (0, de.optional)(me.Enums.FontWeight), Color: (0, de.optional)(pe.ExprColor), LineSpacing: (0, de.optional)(pe.ExprLength), BackgroundColor: (0, de.optional)(pe.ExprColor), TextDecoration: (0, de.optional)(me.Enums.TextDecoration) };
var ye = (0, de.pipe)((0, de.type)({ Type: (0, de.literalInit)("text"), Action: me.Action, Label: fe.string_empty, Value: (0, de.Default)("", pe.ExprStr), StyleName: fe.string_empty, Style: (0, de.typeDef)(ue(ue({}, ge), { Subscript: (0, de.optional)(pe.ExprBool), Superscript: (0, de.optional)(pe.ExprBool) })), ToolTip: (0, de.Default)("", pe.ExprStr) }), (0, de.required)("Type"));
var ve = (0, de.pipe)((0, de.type)({ Type: (0, de.literalInit)("image"), Action: me.Action, Label: fe.string_empty, Source: (0, he.Enum)("External", me.Enums.ImageSource), Value: (0, de.DefaultOf)("", pe.ExprStr), Width: (0, de.DefaultOf)("1in", pe.ExprLength), Height: (0, de.DefaultOf)("1in", pe.ExprLength), MIMEType: (0, de.pipe)((0, de.DefaultOf)("", pe.ExprStr), he.TreatNullAsUndefined), ToolTip: (0, de.Default)("", pe.ExprStr) }), (0, de.required)("Type"));
var be = (0, de.alt)(function(e14) {
  return e14.Type || "text";
}, function(e14) {
  return e14.Type;
}, { text: ye, image: ve });
var Se = (0, de.type)({ TextRuns: (0, de.arrayDef)(be), LeftIndent: (0, de.optional)(pe.ExprLength), RightIndent: (0, de.optional)(pe.ExprLength), HangingIndent: (0, de.optional)(pe.ExprLength), StyleName: fe.string_empty, Style: (0, de.typeDef)(ue(ue({}, ge), { TextAlign: (0, de.optional)(me.Enums.ParagraphTextAlign) })), ListStyle: (0, he.Enum)("None", (0, he.members)("None", "Numbered", "Bullet")), ListLevel: (0, de.Default)(0, de.number), ListItemIndex: (0, de.Default)(0, de.number), SpaceBefore: (0, de.optional)(pe.ExprLength), SpaceAfter: (0, de.optional)(pe.ExprLength), ListStyleType: (0, de.optional)((0, he.Enum)("None", (0, he.members)("None", "Disc", "Circle", "Square", "Decimal", "DecimalLeadingZero", "CircledNumber", "LowerRoman", "UpperRoman", "LowerLatin", "UpperLatin", "LowerGreek", "UpperGreek", "Katakana", "KatakanaBrackets", "KatakanaIrohaBrackets", "KatakanaIroha", "KatakanaLower", "KatakanaIrohaLower"))) });
var Ce = (0, de.pipe)((0, de.type)(ue(ue({}, (0, fe.ReportItemProps)("richtext")), { CanGrow: fe.boolean_false, DataElementStyle: (0, de.Default)("Auto", me.Enums.DataElementStyle), KeepTogether: fe.boolean_false, Style: (0, de.typeDef)(ue(ue(ue(ue({}, me.BorderProps), me.FontProps), me.PaddingProps), (0, me.style)("Color", "LineHeight", "BackgroundColor", "BackgroundImage"))) })), (0, de.required)("Name"));
ce.RichText = (0, de.alt)(function(e14) {
  return e14.MarkupType || "None";
}, function(e14) {
  return e14.MarkupType;
}, { None: (0, de.pipe)(Ce, (0, de.intersectWith)((0, de.type)({ MarkupType: (0, de.Const)("None"), Paragraphs: (0, de.arrayDef)(Se) }))), HTML: (0, de.pipe)(Ce, (0, de.intersectWith)((0, de.type)({ MarkupType: (0, de.literalInit)("HTML"), Value: pe.ExprVariant }))) }), function(e14) {
  var t10 = $ && $.__assign || function() {
    return t10 = Object.assign || function(e15) {
      for (var t11, n11 = 1, r11 = arguments.length; n11 < r11; n11++) for (var o11 in t11 = arguments[n11]) Object.prototype.hasOwnProperty.call(t11, o11) && (e15[o11] = t11[o11]);
      return e15;
    }, t10.apply(this, arguments);
  };
  var n10 = $ && $.__createBinding || (Object.create ? function(e15, t11, n11, r11) {
    void 0 === r11 && (r11 = n11);
    var o11 = Object.getOwnPropertyDescriptor(t11, n11);
    o11 && !("get" in o11 ? !t11.__esModule : o11.writable || o11.configurable) || (o11 = { enumerable: true, get: function() {
      return t11[n11];
    } }), Object.defineProperty(e15, r11, o11);
  } : function(e15, t11, n11, r11) {
    void 0 === r11 && (r11 = n11), e15[r11] = t11[n11];
  });
  var r10 = $ && $.__exportStar || function(e15, t11) {
    for (var r11 in e15) "default" === r11 || Object.prototype.hasOwnProperty.call(t11, r11) || n10(t11, e15, r11);
  };
  var o10 = $ && $.__rest || function(e15, t11) {
    var n11 = {};
    for (var r11 in e15) Object.prototype.hasOwnProperty.call(e15, r11) && t11.indexOf(r11) < 0 && (n11[r11] = e15[r11]);
    if (null != e15 && "function" == typeof Object.getOwnPropertySymbols) {
      var o11 = 0;
      for (r11 = Object.getOwnPropertySymbols(e15); o11 < r11.length; o11++) t11.indexOf(r11[o11]) < 0 && Object.prototype.propertyIsEnumerable.call(e15, r11[o11]) && (n11[r11[o11]] = e15[r11[o11]]);
    }
    return n11;
  };
  Object.defineProperty(e14, "__esModule", { value: true }), e14.UnknownReportItem = e14.ContentPlaceHolder = e14.PartItem = e14.InputField = e14.FormattedText = e14.Bullet = e14.Image = e14.Barcode = e14.TableOfContents = e14.Shape = e14.Subreport = e14.Sparkline = e14.DvChart = e14.DVPlotConfig = e14.DVTextsEncoding = e14.DVValueAggregateEncoding = e14.DVAggregateEncoding = e14.DVEncodingField = e14.BandedList = e14.Tablix = e14.recChildrenLens = e14.Table = e14.List = e14.DataRegionProps = e14.GroupDef = e14.Group = e14.SortExpressions = e14.SortExpression = e14.Rectangle = e14.Line = e14.CheckBox = e14.TextBox = e14.ReportItemProperties = void 0;
  var a10 = ae;
  var i10 = G;
  var s10 = te;
  var l10 = ee;
  var c10 = ae;
  var u10 = le;
  Object.defineProperty(e14, "ReportItemProperties", { enumerable: true, get: function() {
    return u10.ReportItemProperties;
  } }), r10(ce, e14), e14.TextBox = (0, i10.pipe)((0, i10.type)(t10(t10({}, (0, u10.ReportItemProps)("textbox")), { Action: l10.Action, CanGrow: u10.boolean_false, CanShrink: u10.boolean_false, DataElementStyle: (0, i10.Default)("Auto", l10.Enums.DataElementStyle), KeepTogether: u10.boolean_false, ToggleImage: (0, i10.typeDefReq)({ InitialState: s10.ExprBool }, { InitialState: "False" }, ["InitialState"]), UserSort: (0, i10.typeDefReq)({ SortExpression: s10.ExprStr, SortExpressionScope: u10.string_empty, SortTarget: u10.string_empty }, { SortExpression: "" }, ["SortExpression"]), Value: (0, i10.DefaultOf)("", s10.ExprVariant), Style: (0, i10.typeDef)(t10(t10(t10({}, l10.BorderProps), l10.TextProps), (0, l10.style)("BackgroundColor", "BackgroundImage", "TextJustify", "WrapMode", "ShrinkToFit", "LineSpacing", "LineHeight", "CharacterSpacing", "Angle", "HeadingLevel", "MinCondenseRate"))) })), (0, i10.required)("Name"));
  var d10 = (0, c10.Enum)("MiddleLeft", (0, c10.members)("TopLeft", "TopCenter", "TopRight", "MiddleLeft", "MiddleCenter", "MiddleRight", "BottomLeft", "BottomCenter", "BottomRight"));
  var p10 = (0, c10.Enum)("Never", (0, c10.members)("Never", "Always", "Restricted"));
  var m10 = (0, c10.Enum)("None", (0, c10.members)("None", "LeftRight", "TopBottom", "Center", "DiagonalLeft", "DiagonalRight", "HorizontalCenter", "VerticalCenter"));
  e14.CheckBox = (0, i10.pipe)((0, i10.type)(t10(t10({}, (0, u10.ReportItemProps)("checkbox")), { Action: l10.Action, CheckAlignment: d10, Text: (0, i10.DefaultOf)("", s10.ExprStr), Checked: (0, i10.Default)("False", s10.ExprBool), DataElementStyle: (0, i10.DefaultOf)("Auto", l10.Enums.DataElementStyle), Style: (0, i10.typeDef)(t10(t10(t10(t10({}, l10.BorderProps), l10.PaddingProps), l10.FontProps), (0, l10.style)("BackgroundColor", "BackgroundImage", "Color", "WrapMode", "TextDecoration"))) })), (0, i10.required)("Name"));
  var h10 = (0, i10.initValue)({ X: "0in", Y: "0in" }, (0, i10.type)({ X: (0, i10.initValue)("0in", l10.Length), Y: (0, i10.initValue)("0in", l10.Length) }));
  e14.Line = (0, i10.pipe)((0, i10.type)(t10(t10({}, (0, i10.omit)((0, u10.ReportItemProps)("line"), "DataElementName", "DataElementOutput", "ToolTip")), { StartPoint: h10, EndPoint: h10, LineWidth: (0, i10.DefaultOf)("1pt", s10.ExprLength), LineStyle: (0, c10.EnumExpr)("Solid", l10.Enums.BorderStyle), LineColor: (0, i10.DefaultOf)("Black", s10.ExprColor), AccessibleDescription: (0, i10.DefaultOf)("", s10.ExprStr) })), (0, i10.required)("Name"));
  e14.Rectangle = function(e15) {
    return (0, i10.pipe)((0, i10.type)(t10(t10({}, (0, u10.ReportItemProps)("rectangle")), { PageBreak: (0, i10.Default)("None", l10.Enums.BreakLocation), NewPage: (0, i10.Default)("Next", l10.Enums.NewPage), KeepTogether: u10.boolean_false, PageName: (0, i10.DefaultOf)("", s10.ExprStr), RoundingRadius: (0, i10.typeDef)({ Default: (0, i10.DefaultOf)("", s10.ExprLength), TopLeft: (0, i10.DefaultOf)("", s10.ExprLength), TopRight: (0, i10.DefaultOf)("", s10.ExprLength), BottomLeft: (0, i10.DefaultOf)("", s10.ExprLength), BottomRight: (0, i10.DefaultOf)("", s10.ExprLength) }), ConsumeWhiteSpace: u10.boolean_false, Overflow: (0, c10.Enum)("Auto", l10.Enums.RectangleOverflow), LinkToChild: u10.string_empty, Style: (0, i10.typeDef)(t10(t10({}, l10.BorderProps), (0, l10.style)("BackgroundColor", "BackgroundImage"))), ReportItems: (0, i10.arrayDef)(e15) })), (0, i10.required)("Name"));
  }, e14.SortExpression = (0, i10.type)({ Value: (0, i10.DefaultOf)("", s10.ExprVariant), Direction: (0, c10.Enum)("Ascending", (0, c10.members)("Ascending", "Descending")) }), e14.SortExpressions = (0, i10.arrayDef)(e14.SortExpression);
  var f10 = { Name: u10.string_empty, DocumentMapLabel: (0, i10.Default)("", s10.ExprStr), GroupExpressions: (0, i10.arrayDef)(s10.ExprVariant), PageBreak: (0, i10.Default)("None", l10.Enums.BreakLocation), PageBreakDisabled: (0, i10.Default)("False", s10.ExprBool), NewPage: (0, i10.Default)("Next", l10.Enums.NewPage), Filters: l10.Filters, ParentGroup: (0, i10.Default)("", s10.ExprVariant), DataElementName: u10.string_empty, DataElementOutput: (0, i10.Default)("Output", l10.Enums.DataElementOutput), DataCollectionName: u10.string_empty, NewSection: u10.boolean_false };
  e14.Group = (0, i10.type)(f10), e14.GroupDef = (0, i10.DefaultOf)({}, e14.Group), e14.DataRegionProps = { NoRowsMessage: (0, i10.DefaultOf)("", s10.ExprStr), DataSetName: u10.string_empty, DataSetParameters: (0, i10.arrayDef)(l10.QueryParameter), PageBreak: (0, i10.Default)("None", l10.Enums.BreakLocation), NewPage: (0, i10.Default)("Next", l10.Enums.NewPage), Filters: l10.Filters, PageName: (0, i10.DefaultOf)("", s10.ExprStr), NewSection: u10.boolean_false };
  e14.List = function(n11) {
    return (0, i10.pipe)((0, i10.type)(t10(t10(t10({}, (0, u10.ReportItemProps)("list")), e14.DataRegionProps), { Action: l10.Action, SortExpressions: e14.SortExpressions, KeepTogether: u10.boolean_false, ConsumeWhiteSpace: u10.boolean_false, DataInstanceName: u10.string_empty, DataInstanceElementOutput: (0, c10.Enum)("Output", (0, c10.members)("Output", "NoOutput")), Group: e14.GroupDef, RowsOrColumnsCount: (0, i10.Default)(1, i10.number), GrowDirection: (0, c10.Enum)("Column", (0, c10.members)("Column", "ColumnReverse", "Row", "RowReverse")), Style: (0, i10.typeDef)(t10(t10(t10({}, l10.BorderProps), l10.TextProps), (0, l10.style)("BackgroundColor", "BackgroundImage"))), ReportItems: (0, i10.arrayDef)(n11) })), (0, i10.required)("Name"));
  };
  e14.Table = function(n11) {
    var r11 = (0, i10.type)({ Type: (0, i10.Const)("tablecolumn"), Width: u10.Length_0in, FixedHeader: u10.boolean_false, Visibility: l10.Visibility, AutoWidth: (0, c10.Enum)("None", (0, c10.members)("None", "Proportional")) });
    var o11 = (0, i10.pipe)((0, i10.type)({ Item: n11, ColSpan: (0, i10.Default)(1, i10.number), RowSpan: (0, i10.Default)(1, i10.number), AutoMergeMode: p10 }), (0, i10.required)("Item"));
    var a11 = (0, i10.type)({ Action: l10.Action, Type: (0, i10.Const)("tablerow"), Height: u10.Length_0in, Visibility: l10.Visibility, TableCells: (0, i10.arrayDef)((0, i10.nullable)(o11)) });
    var s11 = (0, i10.type)({ Type: (0, i10.Const)("tableheader"), FixedHeader: u10.boolean_false, TableRows: (0, i10.arrayDef)(a11), RepeatOnNewPage: u10.boolean_false });
    var d11 = (0, i10.type)({ Type: (0, i10.Const)("tablefooter"), PrintAtBottom: u10.boolean_false, TableRows: (0, i10.arrayDef)(a11), RepeatOnNewPage: u10.boolean_false });
    var m11 = (0, i10.type)({ Type: (0, i10.Const)("tabledetails"), TableRows: (0, i10.arrayDef)(a11), Group: e14.GroupDef, SortExpressions: e14.SortExpressions, Visibility: l10.Visibility });
    var h11 = (0, i10.type)({ Type: (0, i10.Const)("tablegroup"), Group: e14.GroupDef, SortExpressions: e14.SortExpressions, Header: (0, i10.Default)(null, (0, i10.nullable)(s11)), Footer: (0, i10.Default)(null, (0, i10.nullable)(d11)), Visibility: l10.Visibility, KeepTogether: u10.boolean_false, PreventOrphanedFooter: u10.boolean_true });
    return (0, i10.pipe)((0, i10.type)(t10(t10(t10({}, (0, u10.ReportItemProps)("table")), e14.DataRegionProps), { KeepTogether: u10.boolean_false, FillPage: u10.boolean_false, DetailDataElementName: u10.string_empty, DetailDataCollectionName: u10.string_empty, DetailDataElementOutput: (0, i10.Default)("Auto", l10.Enums.DataElementOutput), FrozenRows: (0, i10.Default)(0, i10.number), FrozenColumns: (0, i10.Default)(0, i10.number), RepeatToFill: u10.boolean_false, RepeatBlankRows: (0, c10.Enum)("None", (0, c10.members)("None", "FillPage", "FillGroup")), PreventOrphanedFooter: u10.boolean_true, SortExpressions: e14.SortExpressions, Style: (0, i10.typeDef)(t10(t10(t10({}, l10.BorderProps), l10.TextProps), (0, l10.style)("BackgroundColor", "BackgroundImage"))), TableColumns: (0, i10.arrayDef)(r11), Header: (0, i10.Default)(null, (0, i10.nullable)(s11)), TableGroups: (0, i10.arrayDef)(h11), Details: (0, i10.Default)(null, (0, i10.nullable)(m11)), Footer: (0, i10.Default)(null, (0, i10.nullable)(d11)) })), (0, i10.required)("Name"));
  };
  var g10 = function(e15) {
    var t11 = (0, i10.lazy)(), n11 = t11[0], r11 = t11[1];
    var o11 = (0, i10.pipe)(e15, (0, i10.intersectWith)((0, i10.type)({ Children: (0, i10.arrayDef)(n11) })));
    return r11(o11), o11;
  };
  e14.recChildrenLens = function(e15) {
    var n11 = i10.Lenses.make(function(r11) {
      var a11 = r11.Children, i11 = o10(r11, ["Children"]);
      return t10(t10({}, e15.f(i11)), { Children: a11.map(n11.f) });
    }, function(r11) {
      var a11 = r11.Children, i11 = o10(r11, ["Children"]);
      return t10(t10({}, e15.frev(i11)), { Children: a11.map(n11.frev) });
    });
    return n11;
  };
  e14.Tablix = function(n11) {
    var r11 = (0, i10.type)({ Item: n11, LevelCount: (0, i10.Default)(0, i10.number) });
    var o11 = (0, i10.pipe)((0, i10.type)({ Header: (0, i10.Default)(null, (0, i10.nullable)(r11)), BodyIndex: (0, i10.Default)(-1, i10.number), BodyCount: (0, i10.Default)(1, i10.number), Visibility: l10.Visibility, DataElementName: u10.string_empty, DataElementOutput: (0, i10.Default)("Auto", l10.Enums.DataElementOutput), KeepTogether: u10.boolean_false, Group: (0, i10.nullable)((0, i10.type)(t10(t10({}, f10), { PrintFooterAtBottom: u10.boolean_false }))), KeepWithGroup: (0, c10.Enum)("None", (0, c10.members)("None", "Before", "After")), RepeatOnNewPage: u10.boolean_false, SortExpressions: e14.SortExpressions }), g10);
    var a11 = { RowSpan: (0, i10.Default)(1, i10.number), ColSpan: (0, i10.Default)(1, i10.number), Item: (0, i10.Default)(null, (0, i10.nullable)(n11)) };
    var s11 = (0, i10.type)(a11);
    var d11 = (0, i10.type)(t10(t10({}, a11), { AutoMergeMode: p10 }));
    var m11 = (0, i10.type)({ Height: u10.Length_0in, Cells: (0, i10.arrayDef)((0, i10.nullable)(d11)) });
    var h11 = (0, i10.typeDef)({ LevelSizes: (0, i10.arrayDef)(l10.Length), Members: (0, i10.arrayDef)(o11) });
    var y11 = (0, i10.array)((0, i10.nullable)(s11));
    return (0, i10.pipe)((0, i10.type)(t10(t10(t10({}, (0, u10.ReportItemProps)("tablix")), e14.DataRegionProps), { SortExpressions: e14.SortExpressions, KeepTogether: u10.boolean_false, FrozenRows: (0, i10.Default)(0, i10.number), FrozenColumns: (0, i10.Default)(0, i10.number), RepeatColumnHeaders: u10.boolean_false, RepeatRowHeaders: u10.boolean_false, GroupsBeforeRowHeaders: (0, i10.Default)(0, i10.number), LayoutDirection: (0, i10.Default)("LTR", l10.Enums.LayoutDirection), RowHierarchy: h11, ColumnHierarchy: h11, Corner: (0, i10.arrayDef)(y11), Body: (0, i10.typeDef)({ Columns: (0, i10.arrayDef)(l10.Length), Rows: (0, i10.arrayDef)(m11) }), Style: (0, i10.typeDef)(t10(t10(t10({}, l10.BorderProps), l10.TextProps), (0, l10.style)("BackgroundColor", "BackgroundImage"))) })), (0, i10.required)("Name"));
  };
  e14.BandedList = function(n11) {
    var r11 = { Name: (0, i10.nullable)(i10.string), Action: l10.Action, CanShrink: u10.boolean_false, CanGrow: u10.boolean_true, KeepTogether: u10.boolean_true, Height: u10.Length_0in, Visibility: l10.Visibility, PageBreak: (0, i10.Default)("None", l10.Enums.BreakLocation), NewPage: (0, i10.Default)("Next", l10.Enums.NewPage) };
    var o11 = (0, i10.type)(t10(t10({ Type: (0, i10.Const)("bandedlistdetails") }, r11), { ReportItems: (0, i10.arrayDef)(n11) }));
    var a11 = (0, i10.type)(t10(t10({ Type: (0, i10.Const)("bandedlistheader") }, r11), { RepeatOnNewPage: u10.boolean_false, ReportItems: (0, i10.arrayDef)(n11) }));
    var s11 = (0, i10.type)(t10(t10({ Type: (0, i10.Const)("bandedlistfooter") }, r11), { RepeatOnNewPage: u10.boolean_false, PrintAtBottom: u10.boolean_false, ReportItems: (0, i10.arrayDef)(n11) }));
    var c11 = (0, i10.type)({ Type: (0, i10.Const)("bandedlistgroup"), Group: e14.GroupDef, SortExpressions: e14.SortExpressions, Visibility: l10.Visibility, KeepTogether: u10.boolean_false, PreventOrphanedHeader: u10.boolean_false, PreventOrphanedFooter: u10.boolean_false, Header: (0, i10.Default)(null, (0, i10.nullable)(a11)), Footer: (0, i10.Default)(null, (0, i10.nullable)(s11)) });
    return (0, i10.pipe)((0, i10.type)(t10(t10(t10({}, (0, u10.ReportItemProps)("bandedlist")), (0, i10.omit)(e14.DataRegionProps, "NoRowsMessage")), { KeepTogether: u10.boolean_false, ConsumeWhiteSpace: u10.boolean_false, PreventOrphanedHeader: u10.boolean_false, PreventOrphanedFooter: u10.boolean_false, Header: (0, i10.Default)(null, (0, i10.nullable)(a11)), Details: (0, i10.Default)(null, (0, i10.nullable)(o11)), Footer: (0, i10.Default)(null, (0, i10.nullable)(s11)), Groups: (0, i10.arrayDef)(c11) })), (0, i10.required)("Name"));
  };
  var y10 = (0, c10.Enum)("None", (0, c10.members)("None", "Average", "Count", "CountDistinct", "CountOfAll", "List", "Max", "Min", "PopulationStandardDeviation", "PopulationVariance", "Range", "StandardDeviation", "Sum", "Variance"));
  var v10 = (0, c10.Enum)("Office", (0, c10.members)("Aspect", "Blue", "Blue2", "BlueGreen", "BlueWarm", "Cerulan", "Cocoa", "Coral", "Cyborg", "Dark", "Darkly", "Flatly", "Grayscale", "Green", "GreenYellow", "HighContrast", "Light", "Marquee", "Median", "Midnight", "Modern", "Office", "Office2010", "Orange", "OrangeRed", "Organic", "Paper", "Red", "RedOrange", "RedViolet", "Slate", "Slipstream", "Standard", "Superhero", "Violet", "Violet2", "Yellow", "YellowOrange", "Zen", "Custom"));
  var b10 = t10(t10({}, l10.FontProps), (0, l10.style)("Color", "TextDecoration"));
  var S10 = { Hidden: u10.boolean_false, Orientation: (0, c10.Enum)("Horizontal", (0, c10.members)("Horizontal", "Vertical")), Position: (0, c10.Enum)("Right", (0, c10.members)("Left", "Right", "Top", "Bottom")), Style: (0, i10.typeDef)(t10(t10({}, l10.PaddingProps), (0, l10.style)("BackgroundColor", "Border"))), TextStyle: (0, i10.typeDef)(b10), TitleStyle: (0, i10.typeDef)(b10) };
  var C10 = { Style: (0, i10.typeDef)(t10(t10({}, l10.PaddingProps), (0, l10.style)("BackgroundColor", "Border"))), TextStyle: (0, i10.typeDef)(b10), Title: (0, i10.DefaultOf)("", s10.ExprStr), Height: (0, c10.AcceptBlankString)((0, i10.optional)(i10.number)), HAlign: (0, c10.Enum)("Center", (0, c10.members)("Center", "Left", "Right")), VAlign: (0, c10.Enum)("Middle", (0, c10.members)("Middle", "Bottom", "Top")) };
  var x10 = (0, i10.typeDef)((0, l10.style)("Border"));
  var w10 = (0, i10.typeDef)({ Type: (0, i10.Const)("dvchartaxis"), AxisLine: u10.boolean_true, AxisType: (0, c10.Enum)("X", (0, c10.members)("X", "Y")), DateMode: (0, c10.Enum)("Default", (0, c10.members)("Default", "Millisecond", "Second", "Minute", "Hour", "Day", "Week", "Month", "Year")), Format: (0, i10.DefaultOf)("", s10.ExprStr), LabelAngle: (0, i10.Default)(0, i10.number), LabelField: (0, i10.DefaultOf)("", s10.ExprStr), Labels: u10.boolean_true, LabelStyle: (0, i10.typeDef)(t10(t10(t10({}, b10), l10.PaddingProps), (0, l10.style)("WritingMode"))), LineStyle: x10, LogBase: (0, i10.Default)(10, i10.number), MajorGrid: u10.boolean_false, MajorGridStyle: x10, MajorTicks: (0, c10.Enum)("None", (0, c10.members)("Inside", "Outside", "Cross", "None")), MajorTickSize: (0, i10.DefaultOf)("4pt", s10.ExprLength), MajorTickStyle: x10, MajorUnit: (0, i10.DefaultOf)("", s10.ExprNum), Max: (0, i10.DefaultOf)("", s10.ExprNum), Min: (0, i10.DefaultOf)("", s10.ExprNum), MinorGrid: u10.boolean_false, MinorGridStyle: x10, MinorTicks: (0, c10.Enum)("None", (0, c10.members)("Inside", "Outside", "Cross", "None")), MinorTickSize: (0, i10.DefaultOf)("2pt", s10.ExprLength), MinorTickStyle: x10, MinorUnit: (0, i10.DefaultOf)("", s10.ExprNum), Origin: (0, i10.DefaultOf)("", s10.ExprNum), OverlappingLabels: (0, c10.Enum)("Auto", (0, c10.members)("Auto", "Show")), Plots: (0, i10.arrayDef)(i10.string), Position: (0, c10.Enum)("Near", (0, c10.members)("Near", "Far", "None")), Reversed: u10.boolean_false, Scale: (0, c10.Enum)("Linear", (0, c10.members)("Linear", "Logarithmic", "Ordinal", "Percentage")), Style: x10, TextStyle: (0, i10.typeDef)(t10(t10({}, b10), l10.PaddingProps)), Title: (0, i10.DefaultOf)("", s10.ExprStr), TitleStyle: (0, i10.typeDef)(t10(t10({}, b10), l10.PaddingProps)), MaxHeight: (0, i10.Default)(1, i10.number), MaxWidth: (0, i10.Default)(1, i10.number), Width: (0, i10.Default)(null, (0, i10.nullable)(i10.number)), Height: (0, i10.Default)(null, (0, i10.nullable)(i10.number)) });
  var T10 = (0, i10.typeDef)(t10(t10({ Type: (0, i10.Const)("dvchartlegend") }, S10), { MaxHeight: (0, i10.Default)(1, i10.number), MaxWidth: (0, i10.Default)(1, i10.number), Title: (0, i10.DefaultOf)("", s10.ExprStr), LegendType: (0, c10.Enum)("Color", (0, c10.members)("Color", "Shape", "Size")), IconColor: (0, i10.DefaultOf)("", s10.ExprColor), RangeOptions: (0, i10.arrayDef)((0, i10.type)({ Title: u10.string_empty, To: i10.number })) }));
  var E10 = (0, i10.typeDef)({ FieldType: (0, i10.literalInit)("Simple"), Value: (0, i10.arrayDef)(s10.ExprVariant), Captions: (0, i10.pipe)(i10.string, (0, a10.TreatNullAs)(""), i10.arrayDef) });
  var F10 = (0, i10.typeDef)({ FieldType: (0, i10.literalInit)("Complex"), Subfields: (0, i10.arrayDef)((0, i10.type)({ Key: i10.string, Value: (0, i10.DefaultOf)("", s10.ExprVariant), Caption: u10.string_empty })) });
  e14.DVEncodingField = (0, i10.iif)(function(e15) {
    return "Complex" === (null == e15 ? void 0 : e15.FieldType);
  }, function(e15) {
    return "Complex" === e15.FieldType;
  }, F10, E10);
  var M10 = (0, i10.typeDef)({ Type: (0, i10.Const)("dvchartcategoryencoding"), Field: E10, Sort: (0, c10.Enum)("None", (0, c10.members)("None", "Ascending", "Descending")), SortingField: (0, i10.DefaultOf)("", s10.ExprVariant), SortingAggregate: y10 });
  var k10 = (0, i10.typeDef)({ Type: (0, i10.Const)("dvchartdetailsencoding"), Field: E10, Group: (0, c10.Enum)("None", (0, c10.members)("None", "Cluster", "Stack")), ExcludeNulls: u10.boolean_false, Sort: (0, c10.Enum)("None", (0, c10.members)("None", "Ascending", "Descending")), SortingField: (0, i10.DefaultOf)("", s10.ExprVariant), SortingAggregate: y10 });
  e14.DVAggregateEncoding = (0, i10.typeDef)({ Type: (0, i10.Const)("dvchartaggregateencoding"), Field: E10, Aggregate: y10, Action: l10.Action }), e14.DVValueAggregateEncoding = (0, i10.typeDef)({ Type: (0, i10.Const)("dvchartvalueaggregateencoding"), Field: e14.DVEncodingField, Aggregate: y10 }), e14.DVTextsEncoding = (0, i10.typeDef)({ Type: (0, i10.Const)("dvcharttextencoding"), Field: E10, Target: (0, c10.Enum)("Label", (0, c10.members)("Label", "ToolTip")), Aggregate: y10 });
  var P10 = (0, i10.type)({ Name: (0, i10.initValue)("", i10.string), Type: (0, i10.Const)("dvchartrule"), Condition: (0, i10.DefaultOf)("", s10.ExprStr), RuleProperties: (0, i10.arrayDef)((0, i10.type)({ TargetProperty: (0, c10.Enum)("BackgroundColor", (0, c10.members)("BackgroundColor", "LineColor", "LineStyle", "LineWidth", "SymbolBackgroundColor", "SymbolLineColor", "SymbolLineStyle", "SymbolLineWidth", "LabelTemplate", "TooltipTemplate")), Value: (0, i10.DefaultOf)("", s10.ExprVariant) })) });
  var N10 = (0, i10.type)({ Name: i10.string, Type: (0, i10.Const)("dvchartoverlay"), OverlayType: (0, c10.Enum)("ReferenceLine", (0, c10.members)("ReferenceLine", "ReferenceBand", "LinearTrendline", "ExponentialTrendline", "PowerTrendline", "LogarithmicTrendline", "PolynomialTrendline", "FourierTrendline", "MovingAverageTrendline", "CumulativeMovingAverageTrendline", "ExponentialMovingAverageTrendline", "WeightedMovingAverageTrendline", "MovingAnnualTotalTrendline")), Display: (0, c10.Enum)("Front", (0, c10.members)("Front", "Back")), Style: (0, i10.typeDef)((0, l10.style)("Border", "BackgroundColor")), Field: u10.string_empty, DetailLevel: (0, c10.Enum)("Total", (0, c10.members)("Group", "Total")), LegendLabel: u10.string_empty, Value: u10.string_empty, Axis: (0, c10.Enum)("Y", (0, c10.members)("X", "Y")), AggregateType: (0, c10.Enum)("Average", (0, c10.members)("Sum", "Count", "Average", "Max", "Min", "Median", "Percentile")), Start: (0, i10.Default)(0, i10.number), End: (0, i10.Default)(0, i10.number), Order: (0, i10.Default)(2, i10.number), Period: (0, i10.Default)(2, i10.number), ForwardForecastPeriod: (0, i10.Default)(0, i10.number), BackwardForecastPeriod: (0, i10.Default)(0, i10.number), Intercept: (0, i10.Default)(null, (0, i10.nullable)(i10.number)) });
  e14.DVPlotConfig = (0, i10.pipe)((0, i10.typeDef)({ Action: l10.Action, AxisMode: (0, c10.Enum)("Cartesian", (0, c10.members)("Cartesian", "Radial", "Polygonal")), Bar: (0, i10.typeDef)({ BottomWidth: (0, i10.optional)(i10.number), NeckHeight: (0, i10.optional)(i10.number), Overlap: (0, i10.optional)(i10.number), TopWidth: (0, i10.optional)(i10.number), Width: (0, i10.optional)(i10.number) }), BarLines: u10.boolean_false, BarLineStyle: (0, i10.typeDef)({ Color: (0, i10.DefaultOf)("Black", s10.ExprColor), Style: (0, c10.EnumExpr)("Solid", l10.Enums.BorderStyle), Width: (0, i10.DefaultOf)("1pt", s10.ExprLength) }), ClippingMode: (0, c10.Enum)("Clip", (0, c10.members)("Clip", "Fit", "None")), CustomLabels: (0, i10.pipe)((0, i10.type)({ Type: (0, i10.Const)("dvchartplotcustomlabel"), Style: (0, i10.typeDef)(t10(t10({}, (0, l10.style)("TextDecoration", "Color", "WritingMode")), l10.FontProps)), Text: (0, i10.Default)("", s10.ExprStr), OffsetX: (0, i10.Default)("0in", l10.Length), OffsetY: (0, i10.Default)("0.5in", l10.Length) }), (0, i10.withDefaultOf)({}), a10.StoreUndefinedAsNull, i10.arrayDef), InnerRadius: (0, i10.Default)(0, i10.number), LineAspect: (0, c10.Enum)("Default", (0, c10.members)("Default", "Spline", "StepCenter", "StepLeft", "StepRight")), LineStyle: (0, i10.typeDef)({ Color: (0, i10.DefaultOf)("", s10.ExprColor), Style: (0, c10.EnumExpr)("None", l10.Enums.BorderStyle), Width: (0, i10.DefaultOf)("1pt", s10.ExprLength) }), Offset: (0, i10.Default)(0, i10.number), Opacity: (0, i10.Default)(1, i10.number), Overlays: (0, i10.arrayDef)(N10), Pointers: (0, i10.pipe)((0, i10.type)({ Type: (0, i10.Const)("dvchartplotpointer"), Style: (0, i10.typeDef)({ BackgroundColor: (0, i10.DefaultOf)("Black", s10.ExprColor) }), NeedleWidth: (0, i10.Default)("0in", l10.Length), NeedlePinWidth: (0, i10.Default)("0in", l10.Length), End: (0, i10.Default)("", s10.ExprStr) }), (0, i10.withDefaultOf)({}), a10.StoreUndefinedAsNull, i10.arrayDef), Radial: u10.boolean_false, ShowNulls: (0, c10.Enum)("Gaps", (0, c10.members)("Connected", "Gaps", "Zeros")), StartAngle: (0, i10.Default)(0, i10.number), Style: (0, i10.typeDef)({ BackgroundColor: (0, i10.DefaultOf)("", s10.ExprColor) }), SwapAxes: u10.boolean_false, Sweep: (0, i10.Default)(360, i10.number), SymbolOpacity: (0, i10.Default)(1, i10.number), Symbols: u10.boolean_false, SymbolShape: (0, c10.Enum)("Auto", (0, c10.members)("Auto", "Dot", "Box", "Diamond", "Triangle", "X", "Dash", "Plus")), SymbolStyle: (0, i10.typeDef)(t10({ BackgroundColor: (0, i10.DefaultOf)("", s10.ExprColor) }, (0, l10.style)("Border"))), Text: (0, i10.typeDef)({ ConnectingLine: x10, LinePosition: (0, c10.Enum)("Auto", (0, c10.members)("Auto", "Center")), Offset: (0, i10.Default)(0, i10.number), OverlappingLabels: (0, c10.Enum)("Auto", (0, c10.members)("Auto", "Show", "Hide")), TextPosition: (0, c10.Enum)("Auto", (0, c10.members)("Auto", "Center", "Inside", "Outside")), Template: u10.string_empty, Style: (0, i10.typeDef)(t10(t10({}, b10), (0, l10.style)("BackgroundColor", "Border"))) }), Tooltip: (0, i10.typeDef)({ Template: (0, i10.DefaultOf)("", s10.ExprStr) }), Rules: (0, i10.arrayDef)(P10), UnpivotData: u10.boolean_false }), (0, i10.map)(function(e15) {
    return t10(t10({}, e15), { AxisMode: "Cartesian" === e15.AxisMode && e15.Radial ? "Radial" : e15.AxisMode });
  }, function(e15) {
    return t10(t10({}, e15), { Radial: "Radial" === e15.AxisMode });
  }));
  var D10 = (0, i10.typeDef)({ Type: (0, i10.Const)("dvchartplot"), PlotType: (0, c10.Enum)("Bar", (0, c10.members)("Bar", "Line", "Area", "Scatter", "HighLowOpenClose", "Candlestick")), PlotName: (0, i10.Default)("p1", i10.string), Encodings: (0, i10.typeDef)({ Values: (0, i10.arrayDef)((0, a10.StoreUndefinedAsNull)(e14.DVValueAggregateEncoding)), Category: M10, Details: (0, i10.arrayDef)((0, a10.StoreUndefinedAsNull)(k10)), Color: e14.DVAggregateEncoding, Shape: e14.DVAggregateEncoding, Size: e14.DVAggregateEncoding, Texts: (0, i10.arrayDef)((0, a10.StoreUndefinedAsNull)(e14.DVTextsEncoding)) }), Config: e14.DVPlotConfig, PlotChartType: (0, c10.Enum)("Custom", (0, c10.members)("Custom", "Column", "Bar", "Line", "Pie", "Area", "Pyramid", "Funnel", "Scatter", "Bubble", "Gantt", "Candlestick", "HighLowClose", "HighLowOpenClose", "PolarColumn", "PolarBar", "RadarArea", "RadarBubble", "RadarScatter", "RadarLine", "RangeArea", "RangeBar", "RangeColumn", "Gauge")), PlotChartSubtype: (0, c10.Enum)("Plain", (0, c10.members)("Plain", "Clustered", "Stacked")) });
  e14.DvChart = (0, i10.pipe)((0, i10.type)(t10(t10(t10({}, (0, u10.ReportItemProps)("dvchart")), e14.DataRegionProps), { Style: (0, i10.typeDef)(t10(t10(t10({}, l10.BorderProps), l10.TextProps), (0, l10.style)("BackgroundColor", "BackgroundImage", "BackgroundGradientType", "BackgroundGradientEndColor"))), Bar: (0, i10.typeDef)({ BottomWidth: (0, i10.Default)(0.55, i10.number), NeckHeight: (0, i10.Default)(1, i10.number), Overlap: (0, i10.Default)(0, i10.number), TopWidth: (0, i10.Default)(0.55, i10.number), Width: (0, i10.Default)(0.55, i10.number) }), Header: (0, i10.typeDef)(t10({ Type: (0, i10.Const)("dvchartheader") }, C10)), Footer: (0, i10.typeDef)(t10({ Type: (0, i10.Const)("dvchartfooter") }, C10)), Palette: v10, CustomPalette: (0, i10.arrayDef)(s10.ExprColor), Legend: (0, i10.typeDef)(t10(t10({ Type: (0, i10.Const)("dvchartgloballegend") }, S10), { Wrapping: u10.boolean_true })), PlotArea: (0, i10.typeDef)({ Type: (0, i10.Const)("dvchartplotarea"), Axes: (0, i10.arrayDef)((0, a10.StoreUndefinedAsNull)(w10)), Legends: (0, i10.arrayDef)((0, a10.StoreUndefinedAsNull)(T10)), Style: (0, i10.typeDef)(t10(t10({}, l10.PaddingProps), (0, l10.style)("BackgroundColor", "Border"))) }), Plots: (0, i10.arrayDef)((0, a10.StoreUndefinedAsNull)(D10)), AccessibleDescription: (0, i10.DefaultOf)("", s10.ExprStr) })), (0, i10.required)("Name")), e14.Sparkline = (0, i10.pipe)((0, i10.type)(t10(t10({}, (0, u10.ReportItemProps)("sparkline")), { DataSetName: u10.string_empty, DataSetParameters: (0, i10.arrayDef)(l10.QueryParameter), Filters: l10.Filters, SortExpressions: e14.SortExpressions, Group: e14.GroupDef, FillColor: (0, i10.Default)("Black", s10.ExprColor), GradientStyle: m10, GradientEndColor: (0, i10.Default)("White", s10.ExprColor), LineColor: (0, i10.Default)("Black", s10.ExprColor), LineWidth: (0, i10.Default)("1pt", s10.ExprLength), MarkerColor: (0, i10.Default)("Black", s10.ExprColor), MarkerVisibility: u10.boolean_true, MaximumColumnWidth: (0, i10.Default)("", s10.ExprLength), RangeFillColor: (0, i10.Default)("Gray", s10.ExprColor), RangeGradientStyle: m10, RangeGradientEndColor: (0, i10.Default)("White", s10.ExprColor), RangeLowerBound: (0, i10.Default)("", s10.ExprNum), RangeUpperBound: (0, i10.Default)("", s10.ExprNum), RangeVisibility: u10.boolean_false, SparklineType: (0, c10.Enum)("Line", (0, c10.members)("Line", "Columns", "Whiskers", "Area", "StackedBar")), SeriesValue: (0, i10.Default)("", s10.ExprNum), AccessibleDescription: (0, i10.DefaultOf)("", s10.ExprStr) })), (0, i10.required)("Name"));
  var L10 = (0, i10.type)({ ParameterName: u10.string_empty, Value: (0, i10.DefaultOf)("", s10.ExprVariant), Omit: (0, i10.DefaultOf)("false", s10.ExprBool) });
  e14.Subreport = (0, i10.pipe)((0, i10.type)(t10(t10({}, (0, u10.ReportItemProps)("subreport")), { ReportName: u10.string_empty, NoRowsMessage: (0, i10.DefaultOf)("", s10.ExprStr), KeepTogether: u10.boolean_false, MergeTransactions: u10.boolean_false, SubstituteThemeOnSubreport: u10.boolean_false, InheritStyleSheet: u10.boolean_true, Parameters: (0, i10.arrayDef)(L10), Style: (0, i10.typeDef)(t10(t10({}, l10.BorderProps), l10.TextProps)), PageName: (0, i10.DefaultOf)("", s10.ExprStr) })), (0, i10.required)("Name")), e14.Shape = (0, i10.pipe)((0, i10.type)(t10(t10({}, (0, u10.ReportItemProps)("shape")), { Style: (0, i10.typeDef)(t10(t10({}, l10.BorderProps), (0, l10.style)("BackgroundColor", "BackgroundImage"))), RoundingRadius: (0, i10.typeDef)({ Default: (0, i10.DefaultOf)("", s10.ExprLength), TopLeft: (0, i10.DefaultOf)("", s10.ExprLength), TopRight: (0, i10.DefaultOf)("", s10.ExprLength), BottomLeft: (0, i10.DefaultOf)("", s10.ExprLength), BottomRight: (0, i10.DefaultOf)("", s10.ExprLength) }), ShapeStyle: (0, c10.EnumExpr)("Rectangle", l10.Enums.ShapeStyle), AccessibleDescription: (0, i10.DefaultOf)("", s10.ExprStr) })), (0, i10.required)("Name"));
  var H10 = (0, i10.type)({ Type: (0, i10.Const)("tableofcontentslevel"), LevelName: (0, i10.Default)("", i10.string), DataElementName: u10.string_empty, DisplayFillCharacters: u10.boolean_true, DisplayPageNumber: u10.boolean_true, Style: (0, i10.typeDef)(t10(t10(t10({}, l10.FontProps), l10.PaddingProps), (0, l10.style)("BackgroundColor", "Color", "TextDecoration", "TextAlign", "LeadingChar", "TextIndent"))) });
  e14.TableOfContents = (0, i10.pipe)((0, i10.type)(t10(t10({}, (0, u10.ReportItemProps)("tableofcontents")), { Style: (0, i10.typeDef)(t10(t10({}, l10.BorderProps), (0, l10.style)("BackgroundColor", "MaxLevel"))), Levels: (0, i10.arrayDef)(H10), PageBreak: (0, i10.Default)("None", l10.Enums.BreakLocation), NewPage: (0, i10.Default)("Next", l10.Enums.NewPage) })), (0, i10.required)("Name"));
  var I10 = (0, c10.members)("None", "Ansi39", "Ansi39x", "Aztec", "BC412", "Codabar", "Code_11", "Code_128_A", "Code_128_B", "Code_128_C", "Code_128auto", "Code_2_of_5", "Code_93", "Code25intlv", "Code39", "Code39x", "Code49", "Code93x", "DataMatrix", "EAN_13", "EAN_8", "EAN128FNC1", "GS1DataMatrix", "GS1QRCode", "HIBCCode128", "HIBCCode39", "IATA_2_of_5", "IntelligentMail", "IntelligentMailPackage", "ISBN", "ISMN", "ISSN", "ITF14", "JapanesePostal", "Matrix_2_of_5", "MaxiCode", "MicroPDF417", "MicroQRCode", "MSI", "Pdf417", "Pharmacode", "Plessey", "PostNet", "PZN", "QRCode", "RM4SCC", "RSS14", "RSS14Stacked", "RSS14StackedOmnidirectional", "RSS14Truncated", "RSSExpanded", "RSSExpandedStacked", "RSSLimited", "SSCC_18", "Telepen", "UCCEAN128", "UPC_A", "UPC_E0", "UPC_E1");
  var _10 = (0, c10.members)("SquareAuto", "RectangularAuto", "Square10", "Square12", "Square14", "Square16", "Square18", "Square20", "Square22", "Square24", "Square26", "Square32", "Square36", "Square40", "Square44", "Square48", "Square52", "Square64", "Square72", "Square80", "Square88", "Square96", "Square104", "Square120", "Square132", "Square144", "Rectangular8x18", "Rectangular8x32", "Rectangular12x26", "Rectangular12x36", "Rectangular16x36", "Rectangular16x48");
  var V10 = (0, c10.members)("Auto", "Square9", "Square11", "Square13", "Square15", "Square17", "Square19", "Square21", "Square23", "Square25", "Square27", "Square29", "Square31", "Square33", "Square35", "Square37", "Square39", "Square41", "Square43", "Square45", "Square47", "Square49");
  var R10 = (0, c10.members)("ColumnPriorAuto", "RowPriorAuto", "Version1X11", "Version1X14", "Version1X17", "Version1X20", "Version1X24", "Version1X28", "Version2X8", "Version2X11", "Version2X14", "Version2X17", "Version2X20", "Version2X23", "Version2X26", "Version3X6", "Version3X8", "Version3X10", "Version3X12", "Version3X15", "Version3X20", "Version3X26", "Version3X32", "Version3X38", "Version3X44", "Version4X4", "Version4X6", "Version4X8", "Version4X10", "Version4X12", "Version4X15", "Version4X20", "Version4X26", "Version4X32", "Version4X38", "Version4X44");
  e14.Barcode = (0, i10.pipe)((0, i10.type)(t10(t10({}, (0, u10.ReportItemProps)("barcode")), { Value: (0, i10.DefaultOf)("", s10.ExprVariant), InvalidBarcodeText: (0, i10.DefaultOf)("", s10.ExprStr), Symbology: (0, c10.Enum)("Ansi39", I10), CheckSum: u10.boolean_true, BarHeight: u10.Length_0in, CaptionGrouping: u10.boolean_true, CaptionLocation: (0, c10.Enum)("None", (0, c10.members)("None", "Above", "Below")), AztecOptions: (0, i10.typeDef)({ ErrorCorrection: (0, i10.Default)(33, i10.number), Layers: (0, i10.Default)(0, i10.number), Encoding: (0, i10.Default)("65001", i10.string) }), Code49Options: (0, i10.typeDef)({ Grouping: u10.boolean_false, GroupNumber: (0, i10.Default)(0, i10.number) }), DataMatrixOptions: (0, i10.typeDef)({ EccMode: (0, c10.Enum)("ECC200", (0, c10.members)("ECC000", "ECC050", "ECC080", "ECC100", "ECC140", "ECC200")), Ecc200SymbolSize: (0, c10.Enum)("SquareAuto", _10), Ecc200EncodingMode: (0, c10.Enum)("Auto", (0, c10.members)("Auto", "ASCII", "C40", "Text", "X12", "EDIFACT", "Base256")), Ecc000_140SymbolSize: (0, c10.Enum)("Auto", V10), StructuredAppend: u10.boolean_false, StructureNumber: (0, i10.Default)(0, i10.number), FileIdentifier: (0, i10.Default)(0, i10.number), Encoding: (0, i10.Default)("65001", i10.string) }), Ean128Fnc1Options: (0, i10.typeDef)({ Resolution: (0, i10.Default)(96, i10.number), ModuleSize: (0, i10.Default)(0, i10.number), BarAdjust: (0, i10.Default)(0, i10.number) }), Gs1CompositeOptions: (0, i10.typeDef)({ CompositeType: (0, c10.Enum)("None", (0, c10.members)("None", "CCA")), Value: (0, i10.DefaultOf)("", s10.ExprStr) }), MaxiCodeOptions: (0, i10.typeDef)({ Mode: (0, c10.Enum)("Mode4", (0, c10.members)("Mode2", "Mode3", "Mode4", "Mode5", "Mode6")) }), MicroPdf417Options: (0, i10.typeDef)({ CompactionMode: (0, c10.Enum)("Auto", (0, c10.members)("Auto", "TextCompactionMode", "NumericCompactionMode", "ByteCompactionMode")), Version: (0, c10.Enum)("ColumnPriorAuto", R10), SegmentIndex: (0, i10.Default)(0, i10.number), SegmentCount: (0, i10.Default)(0, i10.number), FileID: (0, i10.Default)(0, i10.number) }), MicroQrCodeOptions: (0, i10.typeDef)({ Version: (0, c10.Enum)("Auto", (0, c10.members)("Auto", "M1", "M2", "M3", "M4")), ErrorLevel: (0, c10.Enum)("L", (0, c10.members)("L", "M", "Q")), Mask: (0, c10.Enum)("Auto", (0, c10.members)("Auto", "Mask00", "Mask01", "Mask10", "Mask11")), Encoding: (0, i10.Default)("65001", i10.string) }), NarrowBarWidth: (0, i10.Default)("", l10.Length), NWRation: (0, i10.Default)(0, i10.number), Pdf417Options: (0, i10.typeDef)({ Columns: (0, i10.Default)(-1, i10.number), Rows: (0, i10.Default)(-1, i10.number), ErrorCorrectionLevel: (0, c10.Enum)("Level0", (0, c10.members)("Level0", "Level1", "Level2", "Level3", "Level4", "Level5", "Level6", "Level7", "Level8")), Pdf417Type: (0, c10.Enum)("Normal", (0, c10.members)("Normal", "Simple")) }), QrCodeOptions: (0, i10.typeDef)({ Connection: u10.boolean_false, ConnectionNumber: (0, i10.Default)(0, i10.number), Version: (0, i10.Default)(-1, i10.number), ErrorLevel: (0, c10.Enum)("L", (0, c10.members)("M", "L", "H", "Q")), Mask: (0, c10.Enum)("Auto", (0, c10.members)("Auto", "Mask000", "Mask001", "Mask010", "Mask011", "Mask100", "Mask101", "Mask110", "Mask111")), Model: (0, c10.Enum)("Model2", (0, c10.members)("Model1", "Model2")), Encoding: (0, i10.Default)("65001", i10.string) }), QuietZone: (0, i10.typeDef)({ Left: u10.Length_0in, Right: u10.Length_0in, Top: u10.Length_0in, Bottom: u10.Length_0in }), Rotation: (0, i10.Default)("None", i10.string), RssExpandedStacked: (0, i10.typeDef)({ RowCount: (0, i10.Default)(2, i10.number) }), SupplementOptions: (0, i10.typeDef)({ Value: u10.string_empty, BarHeight: u10.Length_0in, CaptionLocation: (0, i10.Default)("Above", i10.string), Spacing: u10.Length_0in }), Style: (0, i10.typeDef)(t10(t10(t10(t10({}, l10.BorderProps), l10.FontProps), l10.PaddingProps), (0, l10.style)("BackgroundColor", "Color", "Format", "TextAlign", "TextDecoration"))), DataElementStyle: (0, i10.Default)("Auto", l10.Enums.DataElementStyle), AccessibleDescription: (0, i10.DefaultOf)("", s10.ExprStr) })), (0, i10.required)("Name")), e14.Image = (0, i10.pipe)((0, i10.type)(t10(t10({}, (0, i10.omit)((0, u10.ReportItemProps)("image"), "DataElementName", "DataElementOutput")), { Action: l10.Action, Source: (0, c10.Enum)("External", l10.Enums.ImageSource), Value: (0, i10.DefaultOf)("", s10.ExprStr), MIMEType: (0, c10.TreatNullAsUndefined)((0, i10.DefaultOf)("", s10.ExprStr)), Sizing: (0, c10.Enum)("AutoSize", (0, c10.members)("AutoSize", "Fit", "FitProportional", "Clip")), HorizontalAlignment: (0, c10.EnumExpr)("Left", l10.Enums.HorizontalImageAlign), VerticalAlignment: (0, c10.EnumExpr)("Top", l10.Enums.VerticalImageAlign), AccessibleDescription: (0, i10.DefaultOf)("", s10.ExprStr), Style: (0, i10.typeDef)(t10(t10({}, l10.BorderProps), l10.PaddingProps)) })), (0, i10.required)("Name")), e14.Bullet = (0, i10.pipe)((0, i10.type)(t10(t10({}, (0, u10.ReportItemProps)("bullet")), { LabelFormat: (0, i10.DefaultOf)("", s10.ExprStr), LabelFontFamily: (0, i10.DefaultOf)("Arial", s10.ExprStr), LabelFontSize: (0, i10.DefaultOf)("10pt", s10.ExprLength), LabelFontStyle: (0, c10.EnumExpr)("Regular", l10.Enums.BulletLabelFontStyles), LabelFontColor: (0, i10.DefaultOf)("Black", s10.ExprColor), Orientation: (0, c10.Enum)("Horizontal", (0, c10.members)("Horizontal", "Vertical")), ShowLabels: u10.boolean_true, TargetShape: (0, c10.Enum)("Line", (0, c10.members)("Line", "Square", "Dot")), TargetLineColor: (0, i10.DefaultOf)("Black", s10.ExprColor), TargetLineWidth: (0, i10.DefaultOf)("3pt", s10.ExprLength), TickMarks: (0, c10.Enum)("Outside", (0, c10.members)("None", "Inside", "Outside")), TicksLineColor: (0, i10.DefaultOf)("LightGray", s10.ExprColor), TicksLineWidth: (0, i10.DefaultOf)("1pt", s10.ExprLength), ValueColor: (0, i10.DefaultOf)("Black", s10.ExprColor), BestValue: (0, i10.Default)("", s10.ExprNum), Interval: (0, i10.Default)("", s10.ExprNum), Range1Boundary: (0, i10.Default)("", s10.ExprNum), Range2Boundary: (0, i10.Default)("", s10.ExprNum), TargetValue: (0, i10.Default)("", s10.ExprNum), Value: (0, i10.Default)("", s10.ExprNum), WorstValue: (0, i10.Default)("", s10.ExprNum), AccessibleDescription: (0, i10.DefaultOf)("", s10.ExprStr) })), (0, i10.required)("Name")), e14.FormattedText = (0, i10.pipe)((0, i10.type)(t10(t10({}, (0, u10.ReportItemProps)("formattedtext")), { EncodeMailMergeFields: u10.boolean_true, Html: (0, i10.DefaultOf)("", s10.ExprStr), MailMergeFields: (0, i10.arrayDef)((0, i10.type)({ Name: i10.string, Value: (0, i10.DefaultOf)("", s10.ExprStr) })), Style: (0, i10.typeDef)(t10(t10({}, l10.BorderProps), (0, l10.style)("BackgroundColor", "BackgroundImage"))), AccessibleDescription: (0, i10.DefaultOf)("", s10.ExprStr) })), (0, i10.required)("Name"));
  var A10 = (0, i10.pipe)((0, i10.type)(t10(t10({}, (0, u10.ReportItemProps)("inputfield")), { FieldName: u10.string_empty, Readonly: u10.boolean_false, Required: u10.boolean_false, TabIndex: (0, i10.Default)(null, (0, i10.nullable)(i10.number)) })), (0, i10.required)("Name"));
  e14.InputField = (0, i10.iif)(function(e15) {
    return !e15.InputType || "Text" === e15.InputType;
  }, function(e15) {
    return "Text" === e15.InputType;
  }, (0, i10.pipe)(A10, (0, i10.intersectWith)((0, i10.type)({ InputType: (0, i10.Const)("Text"), Password: u10.boolean_false, Multiline: u10.boolean_false, SpellCheck: u10.boolean_false, MaxLength: (0, i10.Default)(null, (0, i10.nullable)(i10.number)), Value: (0, i10.Default)("", s10.ExprStr), Style: (0, i10.typeDef)(t10(t10(t10({}, l10.BorderProps), l10.FontProps), (0, l10.style)("BackgroundColor", "Color", "TextAlign", "Format"))) }))), (0, i10.pipe)(A10, (0, i10.intersectWith)((0, i10.type)({ InputType: (0, i10.literalInit)("CheckBox"), Checked: (0, i10.Default)("False", s10.ExprBool), CheckStyle: (0, c10.Enum)("Check", (0, c10.members)("Check", "Circle", "Cross", "Diamond", "Square", "Star")), CheckSize: (0, i10.DefaultOf)("10pt", s10.ExprLength), Style: (0, i10.typeDef)(t10(t10({}, l10.BorderProps), (0, l10.style)("BackgroundColor", "Color", "TextAlign"))) }))));
  var O10 = (0, i10.pipe)((0, i10.type)({ Name: i10.string, Value: (0, i10.Default)("", s10.ExprVariant) }), (0, i10.required)("Name"));
  e14.PartItem = (0, i10.pipe)((0, i10.type)(t10(t10({}, (0, u10.ReportItemProps)("partitem")), { ReportPart: u10.string_empty, Library: u10.string_empty, Properties: (0, i10.arrayDef)(O10) })), (0, i10.required)("Name"));
  e14.ContentPlaceHolder = function(e15) {
    return (0, i10.pipe)((0, i10.type)(t10(t10({}, (0, i10.pick)((0, u10.ReportItemProps)("contentplaceholder"), "Type", "Name", "CustomProperties", "ZIndex", "LayerName")), { Text: u10.string_empty, ConsumeWhiteSpace: u10.boolean_false, ReportItems: (0, i10.arrayDef)(e15) })), (0, i10.required)("Name"));
  };
  var B10 = { encode: function(e15) {
    return e15.Item;
  }, decode: function(e15) {
    return (0, i10.success)({ Item: e15 });
  } };
  e14.UnknownReportItem = (0, i10.pipe)(B10, (0, i10.intersectWith)((0, i10.type)(t10({ Type: (0, i10.Const)("unknown") }, u10.ReportItemProperties))), (0, i10.required)("Name"));
}(se);
var xe = {};
var we = {};
Object.defineProperty(we, "__esModule", { value: true }), we.version = void 0, we.version = "7.6.0", function(e14) {
  var t10 = $ && $.__assign || function() {
    return t10 = Object.assign || function(e15) {
      for (var t11, n11 = 1, r11 = arguments.length; n11 < r11; n11++) for (var o11 in t11 = arguments[n11]) Object.prototype.hasOwnProperty.call(t11, o11) && (e15[o11] = t11[o11]);
      return e15;
    }, t10.apply(this, arguments);
  };
  Object.defineProperty(e14, "__esModule", { value: true }), e14.FixedPage = e14.ReportCommonProps = e14.ReportSectionProps = e14.Layer = e14.PageSection = e14.BodySection = e14.Page = void 0;
  var n10 = G;
  var r10 = te;
  var o10 = ae;
  var a10 = ee;
  var i10 = ie;
  var s10 = se;
  var l10 = le;
  var c10 = we;
  var u10 = [(0, n10.Default)(false, n10.boolean), (0, n10.Default)(true, n10.boolean), (0, n10.Default)("", n10.string)], d10 = u10[0], p10 = u10[1], m10 = u10[2];
  var h10 = (0, o10.Enum)("AttributeNormal", (0, o10.members)("Auto", "AttributeNormal", "ElementNormal"));
  var f10 = (0, o10.Enum)("Labels", (0, o10.members)("None", "Labels", "Headings", "All"));
  var g10 = (0, o10.members)("None", "Decimal", "DecimalLeadingZero", "LowerRoman", "UpperRoman", "LowerLatin", "UpperLatin", "CircledNumber", "KatakanaBrackets", "KatakanaIrohaBrackets", "Katakana", "KatakanaIroha", "KatakanaLower", "KatakanaIrohaLower", "LowerGreek", "UpperGreek", "LowerArmenian", "UpperArmenian", "Georgian");
  e14.Page = (0, n10.type)({ PageWidth: (0, n10.initValue)("8.5in", a10.Length), PageHeight: (0, n10.initValue)("11in", a10.Length), RightMargin: (0, n10.initValue)("0in", a10.Length), LeftMargin: (0, n10.initValue)("0in", a10.Length), TopMargin: (0, n10.initValue)("0in", a10.Length), BottomMargin: (0, n10.initValue)("0in", a10.Length), Columns: (0, n10.initValue)(1, n10.number), ColumnSpacing: (0, n10.initValue)("0.5in", a10.Length), PaperOrientation: (0, n10.initValue)("Portrait", (0, o10.members)("Portrait", "Landscape")) });
  var y10 = (0, n10.DefaultOf)({}, (0, n10.type)(t10(t10({}, a10.BorderProps), (0, a10.style)("BackgroundColor", "BackgroundImage"))));
  e14.BodySection = function(e15) {
    return (0, n10.type)({ Type: (0, n10.Const)("section"), Height: (0, n10.initValue)("0in", a10.Length), ReportItems: (0, n10.arrayDef)(e15), Style: y10 });
  };
  e14.PageSection = function(e15) {
    return (0, n10.type)({ Type: (0, n10.Const)("pagesection"), Height: (0, n10.DefaultOf)("0.25in", a10.Length), ReportItems: (0, n10.arrayDef)(e15), Style: y10, PrintOnFirstPage: p10, PrintOnLastPage: p10 });
  }, e14.Layer = (0, n10.pipe)((0, n10.type)({ Type: (0, n10.Const)("layer"), Name: n10.string, DesignerLock: d10, DesignerTransparency: (0, n10.Default)(0, n10.number), DesignerVisible: p10, DesignerDataFieldVisible: p10, TargetDevice: (0, n10.Default)("All", n10.string) }), (0, n10.required)("Name"), (0, n10.withDefaultOf)({ Name: "" }), o10.StoreUndefinedAsNull), e14.ReportSectionProps = { Name: n10.string, DisplayName: (0, n10.DefaultOf)("", n10.string), Page: (0, n10.DefaultOf)({}, e14.Page), Width: (0, n10.initValue)("6.5in", a10.Length), DataElementName: m10, DataElementOutput: (0, n10.Default)("Auto", a10.Enums.DataElementOutput), Visibility: a10.Visibility };
  var v10 = (0, n10.pipe)((0, n10.type)({ Name: n10.string, Type: (0, n10.Const)("reportpartproperty"), DisplayName: l10.string_empty, Description: l10.string_empty, Category: l10.string_empty, DefaultValue: (0, n10.DefaultOf)("", r10.ExprVariant), PropertyType: (0, n10.Default)("String", a10.Enums.ReportPartPropertyType) }), (0, n10.required)("Name"));
  var b10 = (0, n10.pipe)((0, n10.type)({ Name: n10.string, Type: (0, n10.Const)("reportpart"), DisplayName: l10.string_empty, Description: l10.string_empty, ReportItemName: l10.string_empty, SizeMode: (0, o10.Enum)("Fit", (0, o10.members)("Grow", "Fit")), Properties: (0, n10.arrayDef)(v10) }), (0, n10.required)("Name"));
  var S10 = (0, n10.pipe)((0, n10.type)({ Name: n10.string, Path: n10.string }), (0, n10.required)("Name", "Path"));
  e14.ReportCommonProps = { Name: m10, Description: m10, Author: m10, Page: (0, n10.DefaultOf)({}, e14.Page), Width: (0, n10.initValue)("6.5in", a10.Length), Language: (0, n10.DefaultOf)("", r10.ExprStr), ConsumeContainerWhitespace: d10, DataElementName: (0, n10.Default)("Report", n10.string), DataElementStyle: h10, DocumentMap: (0, n10.typeDef)({ Source: f10, NumberingStyle: (0, o10.Enum)("None", g10), Levels: (0, n10.arrayDef)((0, n10.pipe)((0, o10.Enum)("Decimal", g10), o10.StoreUndefinedAsNull)) }), ReportParameters: (0, n10.arrayDef)(i10.ReportParameter), DataSources: (0, n10.arrayDef)(i10.DataSource), DataSets: (0, n10.arrayDef)(i10.DataSet), EmbeddedImages: (0, n10.arrayDef)((0, n10.type)({ Name: n10.string, ImageData: n10.string, MIMEType: n10.string })), LayoutOrder: (0, o10.Enum)("ZOrder", (0, o10.members)("NOrder", "ZOrder")), StartPageNumber: (0, n10.Default)(1, n10.number), Layers: (0, n10.initValue)([(0, n10.makeDefaultOf)(e14.Layer, { Name: "default" })], (0, n10.array)(e14.Layer)), ThemeUri: m10, Code: m10, Classes: (0, n10.arrayDef)((0, n10.type)({ ClassName: m10, InstanceName: m10 })), CodeModules: (0, n10.arrayDef)(n10.string), CustomProperties: (0, n10.arrayDef)(a10.CustomProperty), LocalizationResources: (0, n10.arrayDef)((0, n10.type)({ Language: n10.string, Data: (0, n10.arrayDef)((0, n10.type)({ Name: n10.string, Value: n10.string })) })), ReportParts: (0, n10.arrayDef)(b10), Libraries: (0, n10.arrayDef)(S10), Version: /* @__PURE__ */ function(e15) {
    return { encode: function(t11) {
      return e15;
    }, decode: function(e16) {
      return (0, n10.success)(e16);
    } };
  }(c10.version) };
  e14.FixedPage = function(e15) {
    var t11 = (0, n10.type)({ Type: (0, n10.Const)("fixedpagesection"), ReportItems: (0, n10.arrayDef)(e15), Style: y10, ThrowIfPlaceHoldersEmpty: d10, Visibility: a10.Visibility, Width: (0, n10.optional)(a10.Length), Height: (0, n10.optional)(a10.Length), LeftMargin: (0, n10.optional)(a10.Length), RightMargin: (0, n10.optional)(a10.Length), TopMargin: (0, n10.optional)(a10.Length), BottomMargin: (0, n10.optional)(a10.Length), PaperOrientation: (0, n10.initValue)("Portrait", (0, o10.members)("Portrait", "Landscape")) });
    return (0, n10.type)({ Type: (0, n10.Const)("fixedpage"), Pages: (0, n10.Default)([(0, n10.makeDefaultOf)(t11)], (0, n10.array)(t11)), Group: s10.GroupDef, DataSetName: m10, Filters: a10.Filters, SortExpressions: s10.SortExpressions, DataElementName: m10, DataElementOutput: (0, n10.Default)("Auto", a10.Enums.DataElementOutput) });
  };
}(xe), function(e14) {
  var t10 = $ && $.__createBinding || (Object.create ? function(e15, t11, n11, r10) {
    void 0 === r10 && (r10 = n11);
    var o10 = Object.getOwnPropertyDescriptor(t11, n11);
    o10 && !("get" in o10 ? !t11.__esModule : o10.writable || o10.configurable) || (o10 = { enumerable: true, get: function() {
      return t11[n11];
    } }), Object.defineProperty(e15, r10, o10);
  } : function(e15, t11, n11, r10) {
    void 0 === r10 && (r10 = n11), e15[r10] = t11[n11];
  });
  var n10 = $ && $.__exportStar || function(e15, n11) {
    for (var r10 in e15) "default" === r10 || Object.prototype.hasOwnProperty.call(n11, r10) || t10(n11, e15, r10);
  };
  Object.defineProperty(e14, "__esModule", { value: true }), e14.Decoders = void 0, n10(ee, e14), n10(ie, e14), n10(se, e14), n10(xe, e14), n10(te, e14), e14.Decoders = ae;
}(Q);
var Te = {};
var Ee = {};
var Fe = {};
Object.defineProperty(Fe, "__esModule", { value: true }), Fe.compare = Fe.getCss = Fe.abs = Fe.subtract = Fe.convert = Fe.parse = void 0;
var Me = /^([-+]?[0-9]*\.?[0-9]+)\s*(cm|mm|in|pt|pc)$/i;
var ke = { in: 1440, pt: 20, pc: 240, cm: 566.9291338582677, mm: 56.69291338582677 };
var Pe = { in: 4, pt: 2, pc: 3, cm: 3, mm: 2 };
function Ne(e14, t10) {
  if (e14.unit === t10) return e14;
  if (!ke[t10]) throw new Error("Specified targetUnits (".concat(t10, ") is invalid."));
  return { value: ke[e14.unit] / ke[t10] * e14.value, unit: t10 };
}
Fe.parse = function(e14) {
  if (!e14) throw new Error("Unable to parse Length, non-empty value expected");
  var t10 = Me.exec(e14);
  var n10;
  if (!t10 || isNaN(n10 = parseFloat(t10[1]))) throw new Error('Unable to parse Length: "'.concat(e14, '", valid string format: <number><').concat(Object.keys(ke).join("|"), ">"));
  return { value: n10, unit: t10[2] };
}, Fe.convert = Ne, Fe.subtract = function(e14, t10) {
  var n10 = Ne(t10, e14.unit).value;
  return { value: e14.value - n10, unit: e14.unit };
}, Fe.abs = function(e14) {
  return { value: Math.abs(e14.value), unit: e14.unit };
}, Fe.getCss = function(e14) {
  var t10 = Pe[e14.unit];
  var n10 = (r10 = e14.value, o10 = t10, a10 = Math.pow(10, o10), Math.round(r10 * a10) / a10);
  var r10, o10, a10;
  return "".concat(n10).concat(e14.unit);
}, Fe.compare = function(e14, t10) {
  var n10 = e14.value * ke[e14.unit];
  var r10 = t10.value * ke[t10.unit];
  return n10 < r10 ? -1 : n10 > r10 ? 1 : 0;
}, function(e14) {
  var t10 = $ && $.__assign || function() {
    return t10 = Object.assign || function(e15) {
      for (var t11, n11 = 1, r11 = arguments.length; n11 < r11; n11++) for (var o11 in t11 = arguments[n11]) Object.prototype.hasOwnProperty.call(t11, o11) && (e15[o11] = t11[o11]);
      return e15;
    }, t10.apply(this, arguments);
  };
  Object.defineProperty(e14, "__esModule", { value: true }), e14.Report = e14.ReportItem = e14.getLineBoundaries = void 0;
  var n10 = G;
  var r10 = Q;
  var o10 = Q;
  var a10 = ae;
  var i10 = Fe;
  var s10 = (0, n10.type)({ Left: (0, n10.DefaultOf)("0in", r10.Length), Top: (0, n10.DefaultOf)("0in", r10.Length), Width: (0, n10.initValue)("0in", r10.Length), Height: (0, n10.initValue)("0in", r10.Length) });
  var l10 = (0, n10.Default)("", n10.string);
  var c10 = (0, n10.type)({ FixedWidth: (0, n10.Default)(null, (0, n10.nullable)(n10.string)), FixedHeight: (0, n10.Default)(null, (0, n10.nullable)(n10.string)), OverflowName: l10 });
  var u10 = (0, n10.type)({ OverflowName: l10 });
  var d10 = (0, n10.type)({ FixedHeight: (0, n10.DefaultOf)("0in", n10.string), OverflowName: (0, n10.Default)("", n10.string) });
  (0, n10.type)(o10.ReportItemProperties);
  var p10 = (0, n10.lazy)(), m10 = p10[0], h10 = p10[1];
  var f10 = (0, n10.pipe)((0, n10.type)({ Type: (0, n10.literalInit)("overflowplaceholder"), Name: n10.string, LayerName: (0, n10.Default)("default", n10.string) }), (0, n10.intersectWith)(s10), (0, n10.intersectWith)(u10), (0, n10.required)("Name"));
  function g10(e15) {
    var t11 = e15.StartPoint, r11 = e15.EndPoint;
    var o11 = { x: i10.parse(t11.X), y: i10.parse(t11.Y) };
    var a11 = { x: i10.parse(r11.X), y: i10.parse(r11.Y) };
    var s11 = function(e16, t12) {
      return i10.compare(e16, t12) <= 0 ? e16 : t12;
    };
    return { Top: i10.getCss(s11(o11.y, a11.y)), Left: i10.getCss(s11(o11.x, a11.x)), Height: (0, n10.pipe)(i10.subtract(o11.y, a11.y), i10.abs, i10.getCss), Width: (0, n10.pipe)(i10.subtract(o11.x, a11.x), i10.abs, i10.getCss) };
  }
  e14.getLineBoundaries = g10, e14.ReportItem = (0, n10.alt)(function(e15) {
    return e15.Type;
  }, function(e15) {
    return e15.Type;
  }, { textbox: (0, n10.pipe)(o10.TextBox, (0, n10.intersectWith)(s10)), checkbox: (0, n10.pipe)(o10.CheckBox, (0, n10.intersectWith)(s10)), list: (0, n10.pipe)(o10.List(m10), (0, n10.intersectWith)(s10), (0, n10.intersectWith)(c10)), table: (0, n10.pipe)(o10.Table(m10), (0, n10.intersectWith)(s10), (0, n10.intersectWith)(c10)), tablix: (0, n10.pipe)(o10.Tablix(m10), (0, n10.intersectWith)(s10), (0, n10.intersectWith)(c10)), line: (0, n10.pipe)(o10.Line, (0, n10.map)(function(e15) {
    return t10(t10({}, e15), g10(e15));
  }, function(e15) {
    return e15;
  })), rectangle: (0, n10.pipe)(o10.Rectangle(m10), (0, n10.intersectWith)(s10)), bandedlist: (0, n10.pipe)(o10.BandedList(m10), (0, n10.intersectWith)(s10), (0, n10.intersectWith)(c10)), subreport: (0, n10.pipe)(o10.Subreport, (0, n10.intersectWith)(s10), (0, n10.intersectWith)(u10)), shape: (0, n10.pipe)(o10.Shape, (0, n10.intersectWith)(s10)), tableofcontents: (0, n10.pipe)(o10.TableOfContents, (0, n10.intersectWith)(s10), (0, n10.intersectWith)(d10)), barcode: (0, n10.pipe)(o10.Barcode, (0, n10.intersectWith)(s10)), dvchart: (0, n10.pipe)(o10.DvChart, (0, n10.intersectWith)(s10)), image: (0, n10.pipe)(o10.Image, (0, n10.intersectWith)(s10)), bullet: (0, n10.pipe)(o10.Bullet, (0, n10.intersectWith)(s10)), formattedtext: (0, n10.pipe)(o10.FormattedText, (0, n10.intersectWith)(s10)), inputfield: (0, n10.pipe)(o10.InputField, (0, n10.intersectWith)(s10)), sparkline: (0, n10.pipe)(o10.Sparkline, (0, n10.intersectWith)(s10)), richtext: (0, n10.pipe)(o10.RichText, (0, n10.intersectWith)(s10)), overflowplaceholder: f10, partitem: (0, n10.pipe)(o10.PartItem, (0, n10.intersectWith)(s10), (0, n10.intersectWith)(c10)), contentplaceholder: (0, n10.pipe)(o10.ContentPlaceHolder(m10), (0, n10.intersectWith)(s10)) });
  var y10 = (0, n10.pipe)(o10.UnknownReportItem, (0, n10.intersectWith)(s10));
  var v10 = (0, n10.pipe)(e14.ReportItem, (0, a10.orElse)(y10, function(e15) {
    return "unknown" === e15.Type;
  }));
  h10(v10);
  var b10 = (0, n10.optional)(o10.PageSection(v10));
  var S10 = (0, n10.pipe)((0, n10.type)(t10(t10({ Type: (0, n10.literalInit)("Continuous") }, o10.ReportSectionProps), { PageHeader: (0, n10.optional)(o10.PageSection(v10)), Body: (0, n10.optional)(o10.BodySection(v10)), PageFooter: (0, n10.optional)(o10.PageSection(v10)) })), (0, n10.required)("Type", "Name"));
  var C10 = (0, n10.pipe)((0, n10.type)(t10(t10({ Type: (0, n10.literalInit)("FixedPage") }, o10.ReportSectionProps), { FixedPage: (0, n10.optional)(o10.FixedPage(v10)) })), (0, n10.required)("Type", "Name"));
  var x10 = (0, n10.alt)(function(e15) {
    return e15.Type;
  }, function(e15) {
    return e15.Type;
  }, { Continuous: S10, FixedPage: C10 });
  e14.Report = (0, n10.pipe)((0, n10.type)(t10(t10({}, o10.ReportCommonProps), { PageHeader: b10, Body: (0, n10.optional)(o10.BodySection(v10)), PageFooter: b10, FixedPage: (0, n10.optional)(o10.FixedPage(v10)), CollateBy: (0, a10.Enum)("Simple", (0, a10.members)("Simple", "ValueIndex", "Value")), Themes: (0, n10.arrayDef)(n10.string), ReportSections: (0, n10.optional)((0, n10.array)(x10)) })), n10.recordFailures);
}(Ee);
var De = {};
Object.defineProperty(De, "__esModule", { value: true });
var Le = {};
function He(e14) {
  return void 0 !== e14;
}
function Ie(e14) {
  return null !== e14;
}
function _e(e14) {
  return Ie(e14) && He(e14);
}
Object.defineProperty(Le, "__esModule", { value: true }), Object.defineProperty(Te, "__esModule", { value: true }), Te.Rom = Te.Rdl = Te.D = void 0, Te.D = Ee, Te.Rdl = De, Te.Rom = Le, function(e14) {
  Object.defineProperty(e14, "__esModule", { value: true }), e14.version = e14.Model = e14.Rom = e14.Rdl = e14.Lenses = e14.Dsl = e14.BasicModel = void 0;
  var t10 = G;
  e14.Dsl = t10, e14.BasicModel = Q, e14.Lenses = t10.Lenses;
  var n10 = Te;
  Object.defineProperty(e14, "Rdl", { enumerable: true, get: function() {
    return n10.Rdl;
  } }), Object.defineProperty(e14, "Rom", { enumerable: true, get: function() {
    return n10.Rom;
  } }), Object.defineProperty(e14, "Model", { enumerable: true, get: function() {
    return n10.D;
  } });
  var r10 = we;
  Object.defineProperty(e14, "version", { enumerable: true, get: function() {
    return r10.version;
  } });
}(Z);
const Ve = (e14) => Math.random().toString(36).substring(e14);
var Re = {};
var Ae = j(z);
var Oe = {};
Object.defineProperty(Oe, "__esModule", { value: true }), Oe.exponent = Oe.makePos = Oe.mergeTokens = Oe.tokenize = void 0;
var Be = /^[0-9]+(?:\.[0-9]+)?e$/i;
Oe.exponent = Be;
var ze = function(e14, t10, n10) {
  return { line: e14, column: t10, character: n10 };
};
Oe.makePos = ze, Oe.tokenize = function(e14) {
  var t10 = function(e15) {
    return e15 && Be.test(e15);
  };
  var n10 = [];
  var r10 = "";
  var o10 = false;
  var a10 = false;
  var i10 = 0;
  var s10 = -1;
  var l10 = 0;
  var c10 = 0;
  var u10 = 0;
  var d10 = function(e15) {
    r10 || (l10 = i10, c10 = s10, u10 = e15);
  };
  for (var p10 = 0; p10 < e14.length; p10++) {
    var m10 = e14[p10];
    if (s10 += 1, '"' !== m10) if (o10) d10(p10), (r10 += m10) && !o10 && (n10.push({ token: r10, position: ze(l10, c10, u10), expression: e14 }), r10 = ""), "\n" === m10 && i10++, "\n" !== m10 && "\r" !== m10 || (s10 = -1);
    else if ("#" !== m10 || 0 !== r10.length && "\\" === r10[r10.length - 1] || (a10 = !a10), a10 || "#" === m10) r10 += m10;
    else if (" " !== m10 && "	" !== m10 && "\n" !== m10 && "\r" !== m10) if ((v10 = m10) && "+-/*=<>&,()\\^".indexOf(v10) > -1) {
      if (("+" === m10 || "-" === m10) && t10(r10)) {
        r10 += m10;
        continue;
      }
      if ("" !== r10 && n10.push({ token: r10, position: ze(l10, c10, u10), expression: e14 }), r10 = "", "=" !== m10 && "<" !== m10 && ">" !== m10 || !(n10.length > 0) || "<" !== n10[n10.length - 1].token && ">" !== n10[n10.length - 1].token) if ("(" === m10 && n10.length > 0) {
        var h10 = n10[n10.length - 1];
        var f10 = Math.max(h10.token.lastIndexOf("."), h10.token.lastIndexOf("!"));
        if (f10 > 0) {
          var g10 = h10.token;
          n10[n10.length - 1].token = g10.substr(0, f10), n10.push({ token: g10.substr(f10), position: ze(l10, c10 + f10, u10 + f10), expression: e14 });
        }
        n10.push({ token: m10, position: ze(i10, s10, p10), expression: e14 });
      } else n10.push({ token: m10, position: ze(i10, s10, p10), expression: e14 });
      else n10[n10.length - 1].token += m10;
    } else d10(p10), r10 += m10;
    else "" !== r10 && n10.push({ token: r10, position: ze(l10, c10, u10), expression: e14 }), r10 = "", "\n" === m10 && i10++, "\n" !== m10 && "\r" !== m10 || (s10 = -1), l10 = i10, c10 = 0;
    else if (o10) {
      var y10 = e14[p10 + 1];
      y10 === m10 ? (p10 += 1, s10 += 1, r10 += m10 + y10) : (o10 = false, (r10 += m10) && (n10.push({ token: r10, position: ze(l10, c10, u10), expression: e14 }), r10 = ""), d10(p10));
    } else o10 = true, r10 && (n10.push({ token: r10, position: ze(l10, c10, u10), expression: e14 }), r10 = ""), d10(p10), r10 += m10;
  }
  var v10;
  return "" !== r10 && n10.push({ token: r10, position: ze(l10, c10, u10), expression: e14 }), n10;
}, Oe.mergeTokens = function(e14) {
  return e14.reduce(function(e15, t10) {
    return e15 + (t10 && ".!".includes(t10[0]) || !e15 ? "" : " ") + t10;
  }, "");
};
var $e = {};
var We = {};
var je = {};
var Ze;
function Ge() {
  if (Ze) return je;
  Ze = 1, Object.defineProperty(je, "__esModule", { value: true }), je.parseDateTimeFormat = je.formatDateTimeWithPattern = void 0;
  var e14 = Ae;
  var t10 = ["dddd", "ddd", "dd", "d", "fffffff", "ffffff", "fffff", "ffff", "fff", "ff", "f", "FFFFFFF", "FFFFFF", "FFFFF", "FFFF", "FFF", "FF", "F", "gg", "g", "hh", "h", "HH", "H", "K", "mm", "m", "MMMM", "MMM", "MM", "M", "ss", "s", "tt", "t", "yyyyy", "yyyy", "yyy", "yy", "y", "zzz", "zz", "z", "YYYYY", "YYYY", "YYY", "YY", "Y", "G"];
  je.formatDateTimeWithPattern = function(e15, n11, r11, a10) {
    function i10(e16, t11, n12) {
      if (void 0 === n12 && (n12 = false), "string" == typeof e16) return e16;
      var r12 = Math.abs(e16).toString();
      return (e16 < 0 ? "-" : n12 ? "+" : "") + (r12.length < t11 ? "0".repeat(t11 - r12.length) + r12 : r12);
    }
    var s10 = o10(n11, t10);
    var l10 = s10.indexOf("d") > -1 || s10.indexOf("dd") > -1;
    var c10 = e15;
    var u10 = a10 ? c10.getUTCFullYear() : c10.getFullYear();
    var d10 = a10 ? c10.getUTCMonth() : c10.getMonth();
    var p10 = a10 ? c10.getUTCDate() : c10.getDate();
    var m10 = a10 ? c10.getUTCDay() : c10.getDay();
    var h10 = a10 ? c10.getUTCHours() : c10.getHours();
    var f10 = a10 ? c10.getUTCMinutes() : c10.getMinutes();
    var g10 = a10 ? c10.getUTCSeconds() : c10.getSeconds();
    var y10 = a10 ? c10.getUTCMilliseconds() : c10.getMilliseconds();
    var v10 = c10.getTimezoneOffset();
    var b10 = Math.round(v10 / 60);
    var S10 = Math.abs(v10) % 60;
    var C10 = s10.map(function(e16, t11) {
      var n12 = s10[t11 - 1];
      switch (e16) {
        case "d":
          return i10(p10, 1);
        case "dd":
          return i10(p10, 2);
        case "ddd":
          return r11.daysShort[m10];
        case "dddd":
          return r11.days[m10];
        case "f":
          return i10(Math.round(y10 / 100), 1);
        case "ff":
          return i10(Math.round(y10 / 10), 2);
        case "fff":
          return i10(y10, 3);
        case "ffff":
          return i10(y10, 4);
        case "fffff":
          return i10(y10, 5);
        case "ffffff":
          return i10(y10, 6);
        case "fffffff":
          return i10(y10, 7);
        case "F":
          return i10(Math.round(y10 / 100) || "", 0);
        case "FF":
          return i10(Math.round(y10 / 10) || "", 0);
        case "FFF":
        case "FFFF":
        case "FFFFF":
        case "FFFFFF":
        case "FFFFFFF":
          return i10(Math.round(y10) || "", 0);
        case "h":
          return i10(h10 % 12 || 12, 1);
        case "hh":
          return i10(h10 % 12 || 12, 2);
        case "H":
          return i10(h10, 1);
        case "HH":
          return i10(h10, 2);
        case "K":
          return v10 ? i10(b10, 2, true) + ":" + i10(S10, 2) : "Z";
        case "m":
          return i10(f10, 1);
        case "mm":
          return i10(f10, 2);
        case "M":
          return i10(d10 + 1, 1);
        case "MM":
          return i10(d10 + 1, 2);
        case "MMM":
          return r11.monthsShort[d10];
        case "MMMM":
          return l10 && r11.monthsDeclined ? r11.monthsDeclined[d10] : r11.months[d10];
        case "s":
          return i10(g10, 1);
        case "ss":
          return i10(g10, 2);
        case "t":
          return h10 < 12 ? r11.amPmShort[0] : r11.amPmShort[1];
        case "tt":
          return h10 < 12 ? r11.amPm[0] : r11.amPm[1];
        case "Y":
        case "YY":
        case "YYY":
        case "YYYY":
        case "YYYYY":
        case "y":
        case "yy":
        case "yyy":
        case "yyyy":
        case "yyyyy":
          return r11.getCustomYear ? r11.getCustomYear(c10, e16, i10, n12) : i10(e16.length <= 2 ? u10 % 100 : u10, e16.length);
        case "z":
          return i10(-b10, 1, true);
        case "zz":
          return i10(-b10, 2, true);
        case "zzz":
          return i10(-b10, 2, true) + ":" + i10(S10, 2);
        case "g":
        case "gg":
          return r11.getCustomEra ? r11.getCustomEra(c10, false).substr(0, e16.length) : r11.era;
        case "G":
          return r11.getCustomEra ? r11.getCustomEra(c10, true) : "G";
        default:
          return e16.replace(/\\(.)/g, "$1").replace(/"/g, "");
      }
    });
    return C10.join("");
  };
  var n10 = /* @__PURE__ */ new Map();
  function r10(t11, r11) {
    n10.set(t11, r11), n10.size > 1e4 && (n10 = new Map(function(t12) {
      var n11, r12;
      var o11 = [];
      try {
        for (var a10 = e14.__values(t12), i10 = a10.next(); !i10.done; i10 = a10.next()) {
          var s10 = i10.value;
          o11.push([s10[0], s10[1]]);
        }
      } catch (e15) {
        n11 = { error: e15 };
      } finally {
        try {
          i10 && !i10.done && (r12 = a10.return) && r12.call(a10);
        } finally {
          if (n11) throw n11.error;
        }
      }
      return o11;
    }(n10).slice(n10.size - 1e3)));
  }
  function o10(t11, o11) {
    var a10 = n10.get(t11);
    if (a10) return a10;
    var i10 = (t11 && "%" === t11[0] ? t11.replace("%", "") : t11) || "";
    var s10 = function(e15) {
      var t12 = function(t13) {
        if (e15.endsWith(o11[t13])) {
          if (!(e15.length > o11[t13].length && "\\" === e15[e15.length - 1 - o11[t13].length])) return { value: o11[t13] };
          var n12 = o11.find(function(e16) {
            return e16 === o11[t13].substr(1, o11[t13].length - 1);
          });
          if (n12) return { value: n12 };
        }
      };
      for (var n11 = 0; n11 < o11.length; n11++) {
        var r11 = t12(n11);
        if ("object" == typeof r11) return r11.value;
      }
      return "";
    };
    var l10 = function(e15) {
      var t12 = [];
      var n11 = s10(e15);
      for (; n11; ) e15 = e15.substr(0, e15.length - n11.length), t12.push(n11), n11 = s10(e15);
      return e15 && t12.push(e15), t12.reverse(), t12;
    };
    var c10 = [];
    var u10 = "";
    var d10 = false;
    for (var p10 = 0; p10 < i10.length; p10++) if ('"' !== i10[p10]) if (d10) u10 += i10[p10];
    else {
      var m10 = s10(u10);
      var h10 = s10(u10 + i10[p10]);
      m10 && !h10 && (c10.push.apply(c10, e14.__spread(l10(u10))), u10 = ""), u10 += i10[p10];
    }
    else (d10 = !d10) || (u10 += '"'), s10(u10) ? c10.push.apply(c10, e14.__spread(l10(u10))) : (c10.push(u10), u10 = ""), d10 && (u10 = '"');
    return d10 && u10 && !u10.endsWith('"') && (u10 += '"'), s10(u10) ? c10.push.apply(c10, e14.__spread(l10(u10))) : u10 && c10.push(u10), r10(t11, c10), c10;
  }
  return je.parseDateTimeFormat = o10, je;
}
function Ue(e14) {
  return Ue = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e15) {
    return typeof e15;
  } : function(e15) {
    return e15 && "function" == typeof Symbol && e15.constructor === Symbol && e15 !== Symbol.prototype ? "symbol" : typeof e15;
  }, Ue(e14);
}
function qe(e14) {
  if (null === e14 || true === e14 || false === e14) return NaN;
  var t10 = Number(e14);
  return isNaN(t10) ? t10 : t10 < 0 ? Math.ceil(t10) : Math.floor(t10);
}
function Ye(e14, t10) {
  if (t10.length < e14) throw new TypeError(e14 + " argument" + (e14 > 1 ? "s" : "") + " required, but only " + t10.length + " present");
}
function Ke(e14) {
  Ye(1, arguments);
  var t10 = Object.prototype.toString.call(e14);
  return e14 instanceof Date || "object" === Ue(e14) && "[object Date]" === t10 ? new Date(e14.getTime()) : "number" == typeof e14 || "[object Number]" === t10 ? new Date(e14) : ("string" != typeof e14 && "[object String]" !== t10 || "undefined" == typeof console || (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Xe(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = qe(t10);
  return isNaN(r10) ? /* @__PURE__ */ new Date(NaN) : r10 ? (n10.setDate(n10.getDate() + r10), n10) : n10;
}
function Je(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = qe(t10);
  if (isNaN(r10)) return /* @__PURE__ */ new Date(NaN);
  if (!r10) return n10;
  var o10 = n10.getDate();
  var a10 = new Date(n10.getTime());
  return a10.setMonth(n10.getMonth() + r10 + 1, 0), o10 >= a10.getDate() ? a10 : (n10.setFullYear(a10.getFullYear(), a10.getMonth(), o10), n10);
}
function Qe(e14, t10) {
  if (Ye(2, arguments), !t10 || "object" !== Ue(t10)) return /* @__PURE__ */ new Date(NaN);
  var n10 = t10.years ? qe(t10.years) : 0;
  var r10 = t10.months ? qe(t10.months) : 0;
  var o10 = t10.weeks ? qe(t10.weeks) : 0;
  var a10 = t10.days ? qe(t10.days) : 0;
  var i10 = t10.hours ? qe(t10.hours) : 0;
  var s10 = t10.minutes ? qe(t10.minutes) : 0;
  var l10 = t10.seconds ? qe(t10.seconds) : 0;
  var c10 = Ke(e14);
  var u10 = r10 || n10 ? Je(c10, r10 + 12 * n10) : c10;
  var d10 = a10 || o10 ? Xe(u10, a10 + 7 * o10) : u10;
  var p10 = 1e3 * (l10 + 60 * (s10 + 60 * i10));
  return new Date(d10.getTime() + p10);
}
function et(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14).getDay();
  return 0 === t10 || 6 === t10;
}
function tt(e14) {
  return Ye(1, arguments), 0 === Ke(e14).getDay();
}
function nt(e14) {
  return Ye(1, arguments), 6 === Ke(e14).getDay();
}
function rt(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = et(n10);
  var o10 = qe(t10);
  if (isNaN(o10)) return /* @__PURE__ */ new Date(NaN);
  var a10 = n10.getHours();
  var i10 = o10 < 0 ? -1 : 1;
  var s10 = qe(o10 / 5);
  n10.setDate(n10.getDate() + 7 * s10);
  var l10 = Math.abs(o10 % 5);
  for (; l10 > 0; ) n10.setDate(n10.getDate() + i10), et(n10) || (l10 -= 1);
  return r10 && et(n10) && 0 !== o10 && (nt(n10) && n10.setDate(n10.getDate() + (i10 < 0 ? 2 : -1)), tt(n10) && n10.setDate(n10.getDate() + (i10 < 0 ? 1 : -2))), n10.setHours(a10), n10;
}
function ot(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14).getTime();
  var r10 = qe(t10);
  return new Date(n10 + r10);
}
var at = 36e5;
function it(e14, t10) {
  return Ye(2, arguments), ot(e14, qe(t10) * at);
}
var st = {};
function lt() {
  return st;
}
function ct(e14, t10) {
  var n10, r10, o10, a10, i10, s10, l10, c10;
  Ye(1, arguments);
  var u10 = lt();
  var d10 = qe(null !== (n10 = null !== (r10 = null !== (o10 = null !== (a10 = null == t10 ? void 0 : t10.weekStartsOn) && void 0 !== a10 ? a10 : null == t10 || null === (i10 = t10.locale) || void 0 === i10 || null === (s10 = i10.options) || void 0 === s10 ? void 0 : s10.weekStartsOn) && void 0 !== o10 ? o10 : u10.weekStartsOn) && void 0 !== r10 ? r10 : null === (l10 = u10.locale) || void 0 === l10 || null === (c10 = l10.options) || void 0 === c10 ? void 0 : c10.weekStartsOn) && void 0 !== n10 ? n10 : 0);
  if (!(d10 >= 0 && d10 <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p10 = Ke(e14);
  var m10 = p10.getDay();
  var h10 = (m10 < d10 ? 7 : 0) + m10 - d10;
  return p10.setDate(p10.getDate() - h10), p10.setHours(0, 0, 0, 0), p10;
}
function ut(e14) {
  return Ye(1, arguments), ct(e14, { weekStartsOn: 1 });
}
function dt(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  var n10 = t10.getFullYear();
  var r10 = /* @__PURE__ */ new Date(0);
  r10.setFullYear(n10 + 1, 0, 4), r10.setHours(0, 0, 0, 0);
  var o10 = ut(r10);
  var a10 = /* @__PURE__ */ new Date(0);
  a10.setFullYear(n10, 0, 4), a10.setHours(0, 0, 0, 0);
  var i10 = ut(a10);
  return t10.getTime() >= o10.getTime() ? n10 + 1 : t10.getTime() >= i10.getTime() ? n10 : n10 - 1;
}
function pt(e14) {
  Ye(1, arguments);
  var t10 = dt(e14);
  var n10 = /* @__PURE__ */ new Date(0);
  return n10.setFullYear(t10, 0, 4), n10.setHours(0, 0, 0, 0), ut(n10);
}
function mt(e14) {
  var t10 = new Date(Date.UTC(e14.getFullYear(), e14.getMonth(), e14.getDate(), e14.getHours(), e14.getMinutes(), e14.getSeconds(), e14.getMilliseconds()));
  return t10.setUTCFullYear(e14.getFullYear()), e14.getTime() - t10.getTime();
}
function ht(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  return t10.setHours(0, 0, 0, 0), t10;
}
var ft = 864e5;
function gt(e14, t10) {
  Ye(2, arguments);
  var n10 = ht(e14);
  var r10 = ht(t10);
  var o10 = n10.getTime() - mt(n10);
  var a10 = r10.getTime() - mt(r10);
  return Math.round((o10 - a10) / ft);
}
function yt(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = qe(t10);
  var o10 = gt(n10, pt(n10));
  var a10 = /* @__PURE__ */ new Date(0);
  return a10.setFullYear(r10, 0, 4), a10.setHours(0, 0, 0, 0), (n10 = pt(a10)).setDate(n10.getDate() + o10), n10;
}
function vt(e14, t10) {
  Ye(2, arguments);
  var n10 = qe(t10);
  return yt(e14, dt(e14) + n10);
}
var bt = 6e4;
function St(e14, t10) {
  return Ye(2, arguments), ot(e14, qe(t10) * bt);
}
function Ct(e14, t10) {
  return Ye(2, arguments), Je(e14, 3 * qe(t10));
}
function xt(e14, t10) {
  return Ye(2, arguments), ot(e14, 1e3 * qe(t10));
}
function wt(e14, t10) {
  return Ye(2, arguments), Xe(e14, 7 * qe(t10));
}
function Tt(e14, t10) {
  return Ye(2, arguments), Je(e14, 12 * qe(t10));
}
function Et(e14) {
  var t10;
  if (Ye(1, arguments), e14 && "function" == typeof e14.forEach) t10 = e14;
  else {
    if ("object" !== Ue(e14) || null === e14) return /* @__PURE__ */ new Date(NaN);
    t10 = Array.prototype.slice.call(e14);
  }
  var n10;
  return t10.forEach(function(e15) {
    var t11 = Ke(e15);
    (void 0 === n10 || n10 < t11 || isNaN(Number(t11))) && (n10 = t11);
  }), n10 || /* @__PURE__ */ new Date(NaN);
}
function Ft(e14) {
  var t10;
  if (Ye(1, arguments), e14 && "function" == typeof e14.forEach) t10 = e14;
  else {
    if ("object" !== Ue(e14) || null === e14) return /* @__PURE__ */ new Date(NaN);
    t10 = Array.prototype.slice.call(e14);
  }
  var n10;
  return t10.forEach(function(e15) {
    var t11 = Ke(e15);
    (void 0 === n10 || n10 > t11 || isNaN(t11.getDate())) && (n10 = t11);
  }), n10 || /* @__PURE__ */ new Date(NaN);
}
function Mt(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = Ke(t10);
  var o10 = n10.getTime() - r10.getTime();
  return o10 < 0 ? -1 : o10 > 0 ? 1 : o10;
}
var kt = 365.2425;
var Pt = 24 * Math.pow(10, 8) * 60 * 60 * 1e3;
var Nt = 6e4;
var Dt = 36e5;
var Lt = 1e3;
var Ht = -Pt;
var It = 3600;
var _t = 86400;
var Vt = 604800;
var Rt = 31556952;
var At = 2629746;
var Ot = 7889238;
function Bt(e14, t10) {
  Ye(2, arguments);
  var n10 = ht(e14);
  var r10 = ht(t10);
  return n10.getTime() === r10.getTime();
}
function zt(e14) {
  return Ye(1, arguments), e14 instanceof Date || "object" === Ue(e14) && "[object Date]" === Object.prototype.toString.call(e14);
}
function $t(e14) {
  if (Ye(1, arguments), !zt(e14) && "number" != typeof e14) return false;
  var t10 = Ke(e14);
  return !isNaN(Number(t10));
}
function Wt(e14, t10) {
  return Ye(2, arguments), dt(e14) - dt(t10);
}
function jt(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = Ke(t10);
  return 12 * (n10.getFullYear() - r10.getFullYear()) + (n10.getMonth() - r10.getMonth());
}
function Zt(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  return Math.floor(t10.getMonth() / 3) + 1;
}
function Gt(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = Ke(t10);
  return 4 * (n10.getFullYear() - r10.getFullYear()) + (Zt(n10) - Zt(r10));
}
var Ut = 6048e5;
function qt(e14, t10, n10) {
  Ye(2, arguments);
  var r10 = ct(e14, n10);
  var o10 = ct(t10, n10);
  var a10 = r10.getTime() - mt(r10);
  var i10 = o10.getTime() - mt(o10);
  return Math.round((a10 - i10) / Ut);
}
function Yt(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = Ke(t10);
  return n10.getFullYear() - r10.getFullYear();
}
function Kt(e14, t10) {
  var n10 = e14.getFullYear() - t10.getFullYear() || e14.getMonth() - t10.getMonth() || e14.getDate() - t10.getDate() || e14.getHours() - t10.getHours() || e14.getMinutes() - t10.getMinutes() || e14.getSeconds() - t10.getSeconds() || e14.getMilliseconds() - t10.getMilliseconds();
  return n10 < 0 ? -1 : n10 > 0 ? 1 : n10;
}
function Xt(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = Ke(t10);
  var o10 = Kt(n10, r10);
  var a10 = Math.abs(gt(n10, r10));
  n10.setDate(n10.getDate() - o10 * a10);
  var i10 = o10 * (a10 - Number(Kt(n10, r10) === -o10));
  return 0 === i10 ? 0 : i10;
}
function Jt(e14, t10) {
  return Ye(2, arguments), Ke(e14).getTime() - Ke(t10).getTime();
}
var Qt = { ceil: Math.ceil, round: Math.round, floor: Math.floor, trunc: function(e14) {
  return e14 < 0 ? Math.ceil(e14) : Math.floor(e14);
} };
var en = "trunc";
function tn(e14) {
  return e14 ? Qt[e14] : Qt[en];
}
function nn(e14, t10, n10) {
  Ye(2, arguments);
  var r10 = Jt(e14, t10) / Dt;
  return tn(null == n10 ? void 0 : n10.roundingMethod)(r10);
}
function rn(e14, t10) {
  return Ye(2, arguments), vt(e14, -qe(t10));
}
function on(e14, t10, n10) {
  Ye(2, arguments);
  var r10 = Jt(e14, t10) / Nt;
  return tn(null == n10 ? void 0 : n10.roundingMethod)(r10);
}
function an(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  return t10.setHours(23, 59, 59, 999), t10;
}
function sn(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  var n10 = t10.getMonth();
  return t10.setFullYear(t10.getFullYear(), n10 + 1, 0), t10.setHours(23, 59, 59, 999), t10;
}
function ln(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  return an(t10).getTime() === sn(t10).getTime();
}
function cn(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = Ke(t10);
  var o10 = Mt(n10, r10);
  var a10 = Math.abs(jt(n10, r10));
  var i10;
  if (a10 < 1) i10 = 0;
  else {
    1 === n10.getMonth() && n10.getDate() > 27 && n10.setDate(30), n10.setMonth(n10.getMonth() - o10 * a10);
    var s10 = Mt(n10, r10) === -o10;
    ln(Ke(e14)) && 1 === a10 && 1 === Mt(e14, r10) && (s10 = false), i10 = o10 * (a10 - Number(s10));
  }
  return 0 === i10 ? 0 : i10;
}
function un(e14, t10, n10) {
  Ye(2, arguments);
  var r10 = Jt(e14, t10) / 1e3;
  return tn(null == n10 ? void 0 : n10.roundingMethod)(r10);
}
function dn(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = Ke(t10);
  var o10 = Mt(n10, r10);
  var a10 = Math.abs(Yt(n10, r10));
  n10.setFullYear(1584), r10.setFullYear(1584);
  var i10 = Mt(n10, r10) === -o10;
  var s10 = o10 * (a10 - Number(i10));
  return 0 === s10 ? 0 : s10;
}
function pn(e14, t10) {
  var n10;
  Ye(1, arguments);
  var r10 = e14 || {};
  var o10 = Ke(r10.start);
  var a10 = Ke(r10.end).getTime();
  if (!(o10.getTime() <= a10)) throw new RangeError("Invalid interval");
  var i10 = [];
  var s10 = o10;
  s10.setHours(0, 0, 0, 0);
  var l10 = Number(null !== (n10 = null == t10 ? void 0 : t10.step) && void 0 !== n10 ? n10 : 1);
  if (l10 < 1 || isNaN(l10)) throw new RangeError("`options.step` must be a number greater than 1");
  for (; s10.getTime() <= a10; ) i10.push(Ke(s10)), s10.setDate(s10.getDate() + l10), s10.setHours(0, 0, 0, 0);
  return i10;
}
function mn(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  return t10.setSeconds(0, 0), t10;
}
function hn(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  var n10 = t10.getMonth();
  var r10 = n10 - n10 % 3;
  return t10.setMonth(r10, 1), t10.setHours(0, 0, 0, 0), t10;
}
function fn(e14) {
  Ye(1, arguments);
  var t10 = pn(e14);
  var n10 = [];
  var r10 = 0;
  for (; r10 < t10.length; ) {
    var o10 = t10[r10++];
    et(o10) && (n10.push(o10), tt(o10) && (r10 += 5));
  }
  return n10;
}
function gn(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  return t10.setDate(1), t10.setHours(0, 0, 0, 0), t10;
}
function yn(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  var n10 = t10.getFullYear();
  return t10.setFullYear(n10 + 1, 0, 0), t10.setHours(23, 59, 59, 999), t10;
}
function vn(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  var n10 = /* @__PURE__ */ new Date(0);
  return n10.setFullYear(t10.getFullYear(), 0, 1), n10.setHours(0, 0, 0, 0), n10;
}
function bn(e14, t10) {
  var n10, r10, o10, a10, i10, s10, l10, c10;
  Ye(1, arguments);
  var u10 = lt();
  var d10 = qe(null !== (n10 = null !== (r10 = null !== (o10 = null !== (a10 = null == t10 ? void 0 : t10.weekStartsOn) && void 0 !== a10 ? a10 : null == t10 || null === (i10 = t10.locale) || void 0 === i10 || null === (s10 = i10.options) || void 0 === s10 ? void 0 : s10.weekStartsOn) && void 0 !== o10 ? o10 : u10.weekStartsOn) && void 0 !== r10 ? r10 : null === (l10 = u10.locale) || void 0 === l10 || null === (c10 = l10.options) || void 0 === c10 ? void 0 : c10.weekStartsOn) && void 0 !== n10 ? n10 : 0);
  if (!(d10 >= 0 && d10 <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p10 = Ke(e14);
  var m10 = p10.getDay();
  var h10 = 6 + (m10 < d10 ? -7 : 0) - (m10 - d10);
  return p10.setDate(p10.getDate() + h10), p10.setHours(23, 59, 59, 999), p10;
}
function Sn(e14, t10) {
  return Ye(2, arguments), ot(e14, -qe(t10));
}
function Cn(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  var n10 = t10.getUTCDay();
  var r10 = (n10 < 1 ? 7 : 0) + n10 - 1;
  return t10.setUTCDate(t10.getUTCDate() - r10), t10.setUTCHours(0, 0, 0, 0), t10;
}
function xn(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  var n10 = t10.getUTCFullYear();
  var r10 = /* @__PURE__ */ new Date(0);
  r10.setUTCFullYear(n10 + 1, 0, 4), r10.setUTCHours(0, 0, 0, 0);
  var o10 = Cn(r10);
  var a10 = /* @__PURE__ */ new Date(0);
  a10.setUTCFullYear(n10, 0, 4), a10.setUTCHours(0, 0, 0, 0);
  var i10 = Cn(a10);
  return t10.getTime() >= o10.getTime() ? n10 + 1 : t10.getTime() >= i10.getTime() ? n10 : n10 - 1;
}
var wn = 6048e5;
function Tn(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  var n10 = Cn(t10).getTime() - function(e15) {
    Ye(1, arguments);
    var t11 = xn(e15);
    var n11 = /* @__PURE__ */ new Date(0);
    return n11.setUTCFullYear(t11, 0, 4), n11.setUTCHours(0, 0, 0, 0), Cn(n11);
  }(t10).getTime();
  return Math.round(n10 / wn) + 1;
}
function En(e14, t10) {
  var n10, r10, o10, a10, i10, s10, l10, c10;
  Ye(1, arguments);
  var u10 = lt();
  var d10 = qe(null !== (n10 = null !== (r10 = null !== (o10 = null !== (a10 = null == t10 ? void 0 : t10.weekStartsOn) && void 0 !== a10 ? a10 : null == t10 || null === (i10 = t10.locale) || void 0 === i10 || null === (s10 = i10.options) || void 0 === s10 ? void 0 : s10.weekStartsOn) && void 0 !== o10 ? o10 : u10.weekStartsOn) && void 0 !== r10 ? r10 : null === (l10 = u10.locale) || void 0 === l10 || null === (c10 = l10.options) || void 0 === c10 ? void 0 : c10.weekStartsOn) && void 0 !== n10 ? n10 : 0);
  if (!(d10 >= 0 && d10 <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p10 = Ke(e14);
  var m10 = p10.getUTCDay();
  var h10 = (m10 < d10 ? 7 : 0) + m10 - d10;
  return p10.setUTCDate(p10.getUTCDate() - h10), p10.setUTCHours(0, 0, 0, 0), p10;
}
function Fn(e14, t10) {
  var n10, r10, o10, a10, i10, s10, l10, c10;
  Ye(1, arguments);
  var u10 = Ke(e14);
  var d10 = u10.getUTCFullYear();
  var p10 = lt();
  var m10 = qe(null !== (n10 = null !== (r10 = null !== (o10 = null !== (a10 = null == t10 ? void 0 : t10.firstWeekContainsDate) && void 0 !== a10 ? a10 : null == t10 || null === (i10 = t10.locale) || void 0 === i10 || null === (s10 = i10.options) || void 0 === s10 ? void 0 : s10.firstWeekContainsDate) && void 0 !== o10 ? o10 : p10.firstWeekContainsDate) && void 0 !== r10 ? r10 : null === (l10 = p10.locale) || void 0 === l10 || null === (c10 = l10.options) || void 0 === c10 ? void 0 : c10.firstWeekContainsDate) && void 0 !== n10 ? n10 : 1);
  if (!(m10 >= 1 && m10 <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var h10 = /* @__PURE__ */ new Date(0);
  h10.setUTCFullYear(d10 + 1, 0, m10), h10.setUTCHours(0, 0, 0, 0);
  var f10 = En(h10, t10);
  var g10 = /* @__PURE__ */ new Date(0);
  g10.setUTCFullYear(d10, 0, m10), g10.setUTCHours(0, 0, 0, 0);
  var y10 = En(g10, t10);
  return u10.getTime() >= f10.getTime() ? d10 + 1 : u10.getTime() >= y10.getTime() ? d10 : d10 - 1;
}
var Mn = 6048e5;
function kn(e14, t10) {
  Ye(1, arguments);
  var n10 = Ke(e14);
  var r10 = En(n10, t10).getTime() - function(e15, t11) {
    var n11, r11, o10, a10, i10, s10, l10, c10;
    Ye(1, arguments);
    var u10 = lt();
    var d10 = qe(null !== (n11 = null !== (r11 = null !== (o10 = null !== (a10 = null == t11 ? void 0 : t11.firstWeekContainsDate) && void 0 !== a10 ? a10 : null == t11 || null === (i10 = t11.locale) || void 0 === i10 || null === (s10 = i10.options) || void 0 === s10 ? void 0 : s10.firstWeekContainsDate) && void 0 !== o10 ? o10 : u10.firstWeekContainsDate) && void 0 !== r11 ? r11 : null === (l10 = u10.locale) || void 0 === l10 || null === (c10 = l10.options) || void 0 === c10 ? void 0 : c10.firstWeekContainsDate) && void 0 !== n11 ? n11 : 1);
    var p10 = Fn(e15, t11);
    var m10 = /* @__PURE__ */ new Date(0);
    return m10.setUTCFullYear(p10, 0, d10), m10.setUTCHours(0, 0, 0, 0), En(m10, t11);
  }(n10, t10).getTime();
  return Math.round(r10 / Mn) + 1;
}
function Pn(e14, t10) {
  var n10 = e14 < 0 ? "-" : "";
  var r10 = Math.abs(e14).toString();
  for (; r10.length < t10; ) r10 = "0" + r10;
  return n10 + r10;
}
var Nn = { y: function(e14, t10) {
  var n10 = e14.getUTCFullYear();
  var r10 = n10 > 0 ? n10 : 1 - n10;
  return Pn("yy" === t10 ? r10 % 100 : r10, t10.length);
}, M: function(e14, t10) {
  var n10 = e14.getUTCMonth();
  return "M" === t10 ? String(n10 + 1) : Pn(n10 + 1, 2);
}, d: function(e14, t10) {
  return Pn(e14.getUTCDate(), t10.length);
}, a: function(e14, t10) {
  var n10 = e14.getUTCHours() / 12 >= 1 ? "pm" : "am";
  switch (t10) {
    case "a":
    case "aa":
      return n10.toUpperCase();
    case "aaa":
      return n10;
    case "aaaaa":
      return n10[0];
    default:
      return "am" === n10 ? "a.m." : "p.m.";
  }
}, h: function(e14, t10) {
  return Pn(e14.getUTCHours() % 12 || 12, t10.length);
}, H: function(e14, t10) {
  return Pn(e14.getUTCHours(), t10.length);
}, m: function(e14, t10) {
  return Pn(e14.getUTCMinutes(), t10.length);
}, s: function(e14, t10) {
  return Pn(e14.getUTCSeconds(), t10.length);
}, S: function(e14, t10) {
  var n10 = t10.length;
  var r10 = e14.getUTCMilliseconds();
  return Pn(Math.floor(r10 * Math.pow(10, n10 - 3)), t10.length);
} };
var Dn = Nn;
var Ln = "midnight", Hn = "noon", In = "morning", _n = "afternoon", Vn = "evening", Rn = "night";
var An = { G: function(e14, t10, n10) {
  var r10 = e14.getUTCFullYear() > 0 ? 1 : 0;
  switch (t10) {
    case "G":
    case "GG":
    case "GGG":
      return n10.era(r10, { width: "abbreviated" });
    case "GGGGG":
      return n10.era(r10, { width: "narrow" });
    default:
      return n10.era(r10, { width: "wide" });
  }
}, y: function(e14, t10, n10) {
  if ("yo" === t10) {
    var r10 = e14.getUTCFullYear();
    var o10 = r10 > 0 ? r10 : 1 - r10;
    return n10.ordinalNumber(o10, { unit: "year" });
  }
  return Dn.y(e14, t10);
}, Y: function(e14, t10, n10, r10) {
  var o10 = Fn(e14, r10);
  var a10 = o10 > 0 ? o10 : 1 - o10;
  return "YY" === t10 ? Pn(a10 % 100, 2) : "Yo" === t10 ? n10.ordinalNumber(a10, { unit: "year" }) : Pn(a10, t10.length);
}, R: function(e14, t10) {
  return Pn(xn(e14), t10.length);
}, u: function(e14, t10) {
  return Pn(e14.getUTCFullYear(), t10.length);
}, Q: function(e14, t10, n10) {
  var r10 = Math.ceil((e14.getUTCMonth() + 1) / 3);
  switch (t10) {
    case "Q":
      return String(r10);
    case "QQ":
      return Pn(r10, 2);
    case "Qo":
      return n10.ordinalNumber(r10, { unit: "quarter" });
    case "QQQ":
      return n10.quarter(r10, { width: "abbreviated", context: "formatting" });
    case "QQQQQ":
      return n10.quarter(r10, { width: "narrow", context: "formatting" });
    default:
      return n10.quarter(r10, { width: "wide", context: "formatting" });
  }
}, q: function(e14, t10, n10) {
  var r10 = Math.ceil((e14.getUTCMonth() + 1) / 3);
  switch (t10) {
    case "q":
      return String(r10);
    case "qq":
      return Pn(r10, 2);
    case "qo":
      return n10.ordinalNumber(r10, { unit: "quarter" });
    case "qqq":
      return n10.quarter(r10, { width: "abbreviated", context: "standalone" });
    case "qqqqq":
      return n10.quarter(r10, { width: "narrow", context: "standalone" });
    default:
      return n10.quarter(r10, { width: "wide", context: "standalone" });
  }
}, M: function(e14, t10, n10) {
  var r10 = e14.getUTCMonth();
  switch (t10) {
    case "M":
    case "MM":
      return Dn.M(e14, t10);
    case "Mo":
      return n10.ordinalNumber(r10 + 1, { unit: "month" });
    case "MMM":
      return n10.month(r10, { width: "abbreviated", context: "formatting" });
    case "MMMMM":
      return n10.month(r10, { width: "narrow", context: "formatting" });
    default:
      return n10.month(r10, { width: "wide", context: "formatting" });
  }
}, L: function(e14, t10, n10) {
  var r10 = e14.getUTCMonth();
  switch (t10) {
    case "L":
      return String(r10 + 1);
    case "LL":
      return Pn(r10 + 1, 2);
    case "Lo":
      return n10.ordinalNumber(r10 + 1, { unit: "month" });
    case "LLL":
      return n10.month(r10, { width: "abbreviated", context: "standalone" });
    case "LLLLL":
      return n10.month(r10, { width: "narrow", context: "standalone" });
    default:
      return n10.month(r10, { width: "wide", context: "standalone" });
  }
}, w: function(e14, t10, n10, r10) {
  var o10 = kn(e14, r10);
  return "wo" === t10 ? n10.ordinalNumber(o10, { unit: "week" }) : Pn(o10, t10.length);
}, I: function(e14, t10, n10) {
  var r10 = Tn(e14);
  return "Io" === t10 ? n10.ordinalNumber(r10, { unit: "week" }) : Pn(r10, t10.length);
}, d: function(e14, t10, n10) {
  return "do" === t10 ? n10.ordinalNumber(e14.getUTCDate(), { unit: "date" }) : Dn.d(e14, t10);
}, D: function(e14, t10, n10) {
  var r10 = function(e15) {
    Ye(1, arguments);
    var t11 = Ke(e15);
    var n11 = t11.getTime();
    t11.setUTCMonth(0, 1), t11.setUTCHours(0, 0, 0, 0);
    var r11 = n11 - t11.getTime();
    return Math.floor(r11 / 864e5) + 1;
  }(e14);
  return "Do" === t10 ? n10.ordinalNumber(r10, { unit: "dayOfYear" }) : Pn(r10, t10.length);
}, E: function(e14, t10, n10) {
  var r10 = e14.getUTCDay();
  switch (t10) {
    case "E":
    case "EE":
    case "EEE":
      return n10.day(r10, { width: "abbreviated", context: "formatting" });
    case "EEEEE":
      return n10.day(r10, { width: "narrow", context: "formatting" });
    case "EEEEEE":
      return n10.day(r10, { width: "short", context: "formatting" });
    default:
      return n10.day(r10, { width: "wide", context: "formatting" });
  }
}, e: function(e14, t10, n10, r10) {
  var o10 = e14.getUTCDay();
  var a10 = (o10 - r10.weekStartsOn + 8) % 7 || 7;
  switch (t10) {
    case "e":
      return String(a10);
    case "ee":
      return Pn(a10, 2);
    case "eo":
      return n10.ordinalNumber(a10, { unit: "day" });
    case "eee":
      return n10.day(o10, { width: "abbreviated", context: "formatting" });
    case "eeeee":
      return n10.day(o10, { width: "narrow", context: "formatting" });
    case "eeeeee":
      return n10.day(o10, { width: "short", context: "formatting" });
    default:
      return n10.day(o10, { width: "wide", context: "formatting" });
  }
}, c: function(e14, t10, n10, r10) {
  var o10 = e14.getUTCDay();
  var a10 = (o10 - r10.weekStartsOn + 8) % 7 || 7;
  switch (t10) {
    case "c":
      return String(a10);
    case "cc":
      return Pn(a10, t10.length);
    case "co":
      return n10.ordinalNumber(a10, { unit: "day" });
    case "ccc":
      return n10.day(o10, { width: "abbreviated", context: "standalone" });
    case "ccccc":
      return n10.day(o10, { width: "narrow", context: "standalone" });
    case "cccccc":
      return n10.day(o10, { width: "short", context: "standalone" });
    default:
      return n10.day(o10, { width: "wide", context: "standalone" });
  }
}, i: function(e14, t10, n10) {
  var r10 = e14.getUTCDay();
  var o10 = 0 === r10 ? 7 : r10;
  switch (t10) {
    case "i":
      return String(o10);
    case "ii":
      return Pn(o10, t10.length);
    case "io":
      return n10.ordinalNumber(o10, { unit: "day" });
    case "iii":
      return n10.day(r10, { width: "abbreviated", context: "formatting" });
    case "iiiii":
      return n10.day(r10, { width: "narrow", context: "formatting" });
    case "iiiiii":
      return n10.day(r10, { width: "short", context: "formatting" });
    default:
      return n10.day(r10, { width: "wide", context: "formatting" });
  }
}, a: function(e14, t10, n10) {
  var r10 = e14.getUTCHours() / 12 >= 1 ? "pm" : "am";
  switch (t10) {
    case "a":
    case "aa":
      return n10.dayPeriod(r10, { width: "abbreviated", context: "formatting" });
    case "aaa":
      return n10.dayPeriod(r10, { width: "abbreviated", context: "formatting" }).toLowerCase();
    case "aaaaa":
      return n10.dayPeriod(r10, { width: "narrow", context: "formatting" });
    default:
      return n10.dayPeriod(r10, { width: "wide", context: "formatting" });
  }
}, b: function(e14, t10, n10) {
  var r10 = e14.getUTCHours();
  var o10;
  switch (o10 = 12 === r10 ? Hn : 0 === r10 ? Ln : r10 / 12 >= 1 ? "pm" : "am", t10) {
    case "b":
    case "bb":
      return n10.dayPeriod(o10, { width: "abbreviated", context: "formatting" });
    case "bbb":
      return n10.dayPeriod(o10, { width: "abbreviated", context: "formatting" }).toLowerCase();
    case "bbbbb":
      return n10.dayPeriod(o10, { width: "narrow", context: "formatting" });
    default:
      return n10.dayPeriod(o10, { width: "wide", context: "formatting" });
  }
}, B: function(e14, t10, n10) {
  var r10 = e14.getUTCHours();
  var o10;
  switch (o10 = r10 >= 17 ? Vn : r10 >= 12 ? _n : r10 >= 4 ? In : Rn, t10) {
    case "B":
    case "BB":
    case "BBB":
      return n10.dayPeriod(o10, { width: "abbreviated", context: "formatting" });
    case "BBBBB":
      return n10.dayPeriod(o10, { width: "narrow", context: "formatting" });
    default:
      return n10.dayPeriod(o10, { width: "wide", context: "formatting" });
  }
}, h: function(e14, t10, n10) {
  if ("ho" === t10) {
    var r10 = e14.getUTCHours() % 12;
    return 0 === r10 && (r10 = 12), n10.ordinalNumber(r10, { unit: "hour" });
  }
  return Dn.h(e14, t10);
}, H: function(e14, t10, n10) {
  return "Ho" === t10 ? n10.ordinalNumber(e14.getUTCHours(), { unit: "hour" }) : Dn.H(e14, t10);
}, K: function(e14, t10, n10) {
  var r10 = e14.getUTCHours() % 12;
  return "Ko" === t10 ? n10.ordinalNumber(r10, { unit: "hour" }) : Pn(r10, t10.length);
}, k: function(e14, t10, n10) {
  var r10 = e14.getUTCHours();
  return 0 === r10 && (r10 = 24), "ko" === t10 ? n10.ordinalNumber(r10, { unit: "hour" }) : Pn(r10, t10.length);
}, m: function(e14, t10, n10) {
  return "mo" === t10 ? n10.ordinalNumber(e14.getUTCMinutes(), { unit: "minute" }) : Dn.m(e14, t10);
}, s: function(e14, t10, n10) {
  return "so" === t10 ? n10.ordinalNumber(e14.getUTCSeconds(), { unit: "second" }) : Dn.s(e14, t10);
}, S: function(e14, t10) {
  return Dn.S(e14, t10);
}, X: function(e14, t10, n10, r10) {
  var o10 = (r10._originalDate || e14).getTimezoneOffset();
  if (0 === o10) return "Z";
  switch (t10) {
    case "X":
      return Bn(o10);
    case "XXXX":
    case "XX":
      return zn(o10);
    default:
      return zn(o10, ":");
  }
}, x: function(e14, t10, n10, r10) {
  var o10 = (r10._originalDate || e14).getTimezoneOffset();
  switch (t10) {
    case "x":
      return Bn(o10);
    case "xxxx":
    case "xx":
      return zn(o10);
    default:
      return zn(o10, ":");
  }
}, O: function(e14, t10, n10, r10) {
  var o10 = (r10._originalDate || e14).getTimezoneOffset();
  switch (t10) {
    case "O":
    case "OO":
    case "OOO":
      return "GMT" + On(o10, ":");
    default:
      return "GMT" + zn(o10, ":");
  }
}, z: function(e14, t10, n10, r10) {
  var o10 = (r10._originalDate || e14).getTimezoneOffset();
  switch (t10) {
    case "z":
    case "zz":
    case "zzz":
      return "GMT" + On(o10, ":");
    default:
      return "GMT" + zn(o10, ":");
  }
}, t: function(e14, t10, n10, r10) {
  var o10 = r10._originalDate || e14;
  return Pn(Math.floor(o10.getTime() / 1e3), t10.length);
}, T: function(e14, t10, n10, r10) {
  return Pn((r10._originalDate || e14).getTime(), t10.length);
} };
function On(e14, t10) {
  var n10 = e14 > 0 ? "-" : "+";
  var r10 = Math.abs(e14);
  var o10 = Math.floor(r10 / 60);
  var a10 = r10 % 60;
  if (0 === a10) return n10 + String(o10);
  var i10 = t10 || "";
  return n10 + String(o10) + i10 + Pn(a10, 2);
}
function Bn(e14, t10) {
  return e14 % 60 == 0 ? (e14 > 0 ? "-" : "+") + Pn(Math.abs(e14) / 60, 2) : zn(e14, t10);
}
function zn(e14, t10) {
  var n10 = t10 || "";
  var r10 = e14 > 0 ? "-" : "+";
  var o10 = Math.abs(e14);
  return r10 + Pn(Math.floor(o10 / 60), 2) + n10 + Pn(o10 % 60, 2);
}
var $n = An;
var Wn = function(e14, t10) {
  switch (e14) {
    case "P":
      return t10.date({ width: "short" });
    case "PP":
      return t10.date({ width: "medium" });
    case "PPP":
      return t10.date({ width: "long" });
    default:
      return t10.date({ width: "full" });
  }
};
var jn = function(e14, t10) {
  switch (e14) {
    case "p":
      return t10.time({ width: "short" });
    case "pp":
      return t10.time({ width: "medium" });
    case "ppp":
      return t10.time({ width: "long" });
    default:
      return t10.time({ width: "full" });
  }
};
var Zn = { p: jn, P: function(e14, t10) {
  var n10 = e14.match(/(P+)(p+)?/) || [];
  var r10 = n10[1];
  var o10 = n10[2];
  if (!o10) return Wn(e14, t10);
  var a10;
  switch (r10) {
    case "P":
      a10 = t10.dateTime({ width: "short" });
      break;
    case "PP":
      a10 = t10.dateTime({ width: "medium" });
      break;
    case "PPP":
      a10 = t10.dateTime({ width: "long" });
      break;
    default:
      a10 = t10.dateTime({ width: "full" });
  }
  return a10.replace("{{date}}", Wn(r10, t10)).replace("{{time}}", jn(o10, t10));
} };
var Gn = Zn;
var Un = ["D", "DD"];
var qn = ["YY", "YYYY"];
function Yn(e14) {
  return -1 !== Un.indexOf(e14);
}
function Kn(e14) {
  return -1 !== qn.indexOf(e14);
}
function Xn(e14, t10, n10) {
  if ("YYYY" === e14) throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t10, "`) for formatting years to the input `").concat(n10, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if ("YY" === e14) throw new RangeError("Use `yy` instead of `YY` (in `".concat(t10, "`) for formatting years to the input `").concat(n10, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if ("D" === e14) throw new RangeError("Use `d` instead of `D` (in `".concat(t10, "`) for formatting days of the month to the input `").concat(n10, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if ("DD" === e14) throw new RangeError("Use `dd` instead of `DD` (in `".concat(t10, "`) for formatting days of the month to the input `").concat(n10, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var Jn = { lessThanXSeconds: { one: "less than a second", other: "less than {{count}} seconds" }, xSeconds: { one: "1 second", other: "{{count}} seconds" }, halfAMinute: "half a minute", lessThanXMinutes: { one: "less than a minute", other: "less than {{count}} minutes" }, xMinutes: { one: "1 minute", other: "{{count}} minutes" }, aboutXHours: { one: "about 1 hour", other: "about {{count}} hours" }, xHours: { one: "1 hour", other: "{{count}} hours" }, xDays: { one: "1 day", other: "{{count}} days" }, aboutXWeeks: { one: "about 1 week", other: "about {{count}} weeks" }, xWeeks: { one: "1 week", other: "{{count}} weeks" }, aboutXMonths: { one: "about 1 month", other: "about {{count}} months" }, xMonths: { one: "1 month", other: "{{count}} months" }, aboutXYears: { one: "about 1 year", other: "about {{count}} years" }, xYears: { one: "1 year", other: "{{count}} years" }, overXYears: { one: "over 1 year", other: "over {{count}} years" }, almostXYears: { one: "almost 1 year", other: "almost {{count}} years" } };
var Qn = function(e14, t10, n10) {
  var r10;
  var o10 = Jn[e14];
  return r10 = "string" == typeof o10 ? o10 : 1 === t10 ? o10.one : o10.other.replace("{{count}}", t10.toString()), null != n10 && n10.addSuffix ? n10.comparison && n10.comparison > 0 ? "in " + r10 : r10 + " ago" : r10;
};
function er(e14) {
  return function() {
    var t10 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    var n10 = t10.width ? String(t10.width) : e14.defaultWidth;
    return e14.formats[n10] || e14.formats[e14.defaultWidth];
  };
}
var tr = { date: er({ formats: { full: "EEEE, MMMM do, y", long: "MMMM do, y", medium: "MMM d, y", short: "MM/dd/yyyy" }, defaultWidth: "full" }), time: er({ formats: { full: "h:mm:ss a zzzz", long: "h:mm:ss a z", medium: "h:mm:ss a", short: "h:mm a" }, defaultWidth: "full" }), dateTime: er({ formats: { full: "{{date}} 'at' {{time}}", long: "{{date}} 'at' {{time}}", medium: "{{date}}, {{time}}", short: "{{date}}, {{time}}" }, defaultWidth: "full" }) };
var nr = { lastWeek: "'last' eeee 'at' p", yesterday: "'yesterday at' p", today: "'today at' p", tomorrow: "'tomorrow at' p", nextWeek: "eeee 'at' p", other: "P" };
var rr = function(e14, t10, n10, r10) {
  return nr[e14];
};
function or(e14) {
  return function(t10, n10) {
    var r10;
    if ("formatting" === (null != n10 && n10.context ? String(n10.context) : "standalone") && e14.formattingValues) {
      var o10 = e14.defaultFormattingWidth || e14.defaultWidth;
      var a10 = null != n10 && n10.width ? String(n10.width) : o10;
      r10 = e14.formattingValues[a10] || e14.formattingValues[o10];
    } else {
      var i10 = e14.defaultWidth;
      var s10 = null != n10 && n10.width ? String(n10.width) : e14.defaultWidth;
      r10 = e14.values[s10] || e14.values[i10];
    }
    return r10[e14.argumentCallback ? e14.argumentCallback(t10) : t10];
  };
}
var ar = { ordinalNumber: function(e14, t10) {
  var n10 = Number(e14);
  var r10 = n10 % 100;
  if (r10 > 20 || r10 < 10) switch (r10 % 10) {
    case 1:
      return n10 + "st";
    case 2:
      return n10 + "nd";
    case 3:
      return n10 + "rd";
  }
  return n10 + "th";
}, era: or({ values: { narrow: ["B", "A"], abbreviated: ["BC", "AD"], wide: ["Before Christ", "Anno Domini"] }, defaultWidth: "wide" }), quarter: or({ values: { narrow: ["1", "2", "3", "4"], abbreviated: ["Q1", "Q2", "Q3", "Q4"], wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"] }, defaultWidth: "wide", argumentCallback: function(e14) {
  return e14 - 1;
} }), month: or({ values: { narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"], abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"] }, defaultWidth: "wide" }), day: or({ values: { narrow: ["S", "M", "T", "W", "T", "F", "S"], short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"] }, defaultWidth: "wide" }), dayPeriod: or({ values: { narrow: { am: "a", pm: "p", midnight: "mi", noon: "n", morning: "morning", afternoon: "afternoon", evening: "evening", night: "night" }, abbreviated: { am: "AM", pm: "PM", midnight: "midnight", noon: "noon", morning: "morning", afternoon: "afternoon", evening: "evening", night: "night" }, wide: { am: "a.m.", pm: "p.m.", midnight: "midnight", noon: "noon", morning: "morning", afternoon: "afternoon", evening: "evening", night: "night" } }, defaultWidth: "wide", formattingValues: { narrow: { am: "a", pm: "p", midnight: "mi", noon: "n", morning: "in the morning", afternoon: "in the afternoon", evening: "in the evening", night: "at night" }, abbreviated: { am: "AM", pm: "PM", midnight: "midnight", noon: "noon", morning: "in the morning", afternoon: "in the afternoon", evening: "in the evening", night: "at night" }, wide: { am: "a.m.", pm: "p.m.", midnight: "midnight", noon: "noon", morning: "in the morning", afternoon: "in the afternoon", evening: "in the evening", night: "at night" } }, defaultFormattingWidth: "wide" }) };
var ir = ar;
function sr(e14) {
  return function(t10) {
    var n10 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    var r10 = n10.width;
    var o10 = r10 && e14.matchPatterns[r10] || e14.matchPatterns[e14.defaultMatchWidth];
    var a10 = t10.match(o10);
    if (!a10) return null;
    var i10 = a10[0];
    var s10 = r10 && e14.parsePatterns[r10] || e14.parsePatterns[e14.defaultParseWidth];
    var l10 = Array.isArray(s10) ? function(e15, t11) {
      for (var n11 = 0; n11 < e15.length; n11++) if (t11(e15[n11])) return n11;
      return;
    }(s10, function(e15) {
      return e15.test(i10);
    }) : function(e15, t11) {
      for (var n11 in e15) if (e15.hasOwnProperty(n11) && t11(e15[n11])) return n11;
      return;
    }(s10, function(e15) {
      return e15.test(i10);
    });
    var c10;
    return c10 = e14.valueCallback ? e14.valueCallback(l10) : l10, { value: c10 = n10.valueCallback ? n10.valueCallback(c10) : c10, rest: t10.slice(i10.length) };
  };
}
var lr = { ordinalNumber: (cr = { matchPattern: /^(\d+)(th|st|nd|rd)?/i, parsePattern: /\d+/i, valueCallback: function(e14) {
  return parseInt(e14, 10);
} }, function(e14) {
  var t10 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  var n10 = e14.match(cr.matchPattern);
  if (!n10) return null;
  var r10 = n10[0];
  var o10 = e14.match(cr.parsePattern);
  if (!o10) return null;
  var a10 = cr.valueCallback ? cr.valueCallback(o10[0]) : o10[0];
  return { value: a10 = t10.valueCallback ? t10.valueCallback(a10) : a10, rest: e14.slice(r10.length) };
}), era: sr({ matchPatterns: { narrow: /^(b|a)/i, abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i, wide: /^(before christ|before common era|anno domini|common era)/i }, defaultMatchWidth: "wide", parsePatterns: { any: [/^b/i, /^(a|c)/i] }, defaultParseWidth: "any" }), quarter: sr({ matchPatterns: { narrow: /^[1234]/i, abbreviated: /^q[1234]/i, wide: /^[1234](th|st|nd|rd)? quarter/i }, defaultMatchWidth: "wide", parsePatterns: { any: [/1/i, /2/i, /3/i, /4/i] }, defaultParseWidth: "any", valueCallback: function(e14) {
  return e14 + 1;
} }), month: sr({ matchPatterns: { narrow: /^[jfmasond]/i, abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i, wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i }, defaultMatchWidth: "wide", parsePatterns: { narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i], any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i] }, defaultParseWidth: "any" }), day: sr({ matchPatterns: { narrow: /^[smtwf]/i, short: /^(su|mo|tu|we|th|fr|sa)/i, abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i, wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i }, defaultMatchWidth: "wide", parsePatterns: { narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i], any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i] }, defaultParseWidth: "any" }), dayPeriod: sr({ matchPatterns: { narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i, any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i }, defaultMatchWidth: "any", parsePatterns: { any: { am: /^a/i, pm: /^p/i, midnight: /^mi/i, noon: /^no/i, morning: /morning/i, afternoon: /afternoon/i, evening: /evening/i, night: /night/i } }, defaultParseWidth: "any" }) };
var cr;
var ur = { code: "en-US", formatDistance: Qn, formatLong: tr, formatRelative: rr, localize: ir, match: lr, options: { weekStartsOn: 0, firstWeekContainsDate: 1 } };
var dr = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var pr = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var mr = /^'([^]*?)'?$/;
var hr = /''/g;
var fr = /[a-zA-Z]/;
function gr(e14, t10, n10) {
  var r10, o10, a10, i10, s10, l10, c10, u10, d10, p10, m10, h10, f10, g10, y10, v10, b10, S10;
  Ye(2, arguments);
  var C10 = String(t10);
  var x10 = lt();
  var w10 = null !== (r10 = null !== (o10 = null == n10 ? void 0 : n10.locale) && void 0 !== o10 ? o10 : x10.locale) && void 0 !== r10 ? r10 : ur;
  var T10 = qe(null !== (a10 = null !== (i10 = null !== (s10 = null !== (l10 = null == n10 ? void 0 : n10.firstWeekContainsDate) && void 0 !== l10 ? l10 : null == n10 || null === (c10 = n10.locale) || void 0 === c10 || null === (u10 = c10.options) || void 0 === u10 ? void 0 : u10.firstWeekContainsDate) && void 0 !== s10 ? s10 : x10.firstWeekContainsDate) && void 0 !== i10 ? i10 : null === (d10 = x10.locale) || void 0 === d10 || null === (p10 = d10.options) || void 0 === p10 ? void 0 : p10.firstWeekContainsDate) && void 0 !== a10 ? a10 : 1);
  if (!(T10 >= 1 && T10 <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var E10 = qe(null !== (m10 = null !== (h10 = null !== (f10 = null !== (g10 = null == n10 ? void 0 : n10.weekStartsOn) && void 0 !== g10 ? g10 : null == n10 || null === (y10 = n10.locale) || void 0 === y10 || null === (v10 = y10.options) || void 0 === v10 ? void 0 : v10.weekStartsOn) && void 0 !== f10 ? f10 : x10.weekStartsOn) && void 0 !== h10 ? h10 : null === (b10 = x10.locale) || void 0 === b10 || null === (S10 = b10.options) || void 0 === S10 ? void 0 : S10.weekStartsOn) && void 0 !== m10 ? m10 : 0);
  if (!(E10 >= 0 && E10 <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!w10.localize) throw new RangeError("locale must contain localize property");
  if (!w10.formatLong) throw new RangeError("locale must contain formatLong property");
  var F10 = Ke(e14);
  if (!$t(F10)) throw new RangeError("Invalid time value");
  var M10 = Sn(F10, mt(F10));
  var k10 = { firstWeekContainsDate: T10, weekStartsOn: E10, locale: w10, _originalDate: F10 };
  var P10 = C10.match(pr).map(function(e15) {
    var t11 = e15[0];
    return "p" === t11 || "P" === t11 ? (0, Gn[t11])(e15, w10.formatLong) : e15;
  }).join("").match(dr).map(function(r11) {
    if ("''" === r11) return "'";
    var o11 = r11[0];
    if ("'" === o11) return function(e15) {
      var t11 = e15.match(mr);
      if (!t11) return e15;
      return t11[1].replace(hr, "'");
    }(r11);
    var a11 = $n[o11];
    if (a11) return null != n10 && n10.useAdditionalWeekYearTokens || !Kn(r11) || Xn(r11, t10, String(e14)), null != n10 && n10.useAdditionalDayOfYearTokens || !Yn(r11) || Xn(r11, t10, String(e14)), a11(M10, r11, w10.localize, k10);
    if (o11.match(fr)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + o11 + "`");
    return r11;
  }).join("");
  return P10;
}
function yr(e14, t10) {
  if (null == e14) throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n10 in t10) Object.prototype.hasOwnProperty.call(t10, n10) && (e14[n10] = t10[n10]);
  return e14;
}
function vr(e14) {
  return yr({}, e14);
}
var br = 1440;
var Sr = 2520;
var Cr = 43200;
var xr = 86400;
function wr(e14, t10, n10) {
  var r10, o10;
  Ye(2, arguments);
  var a10 = lt();
  var i10 = null !== (r10 = null !== (o10 = null == n10 ? void 0 : n10.locale) && void 0 !== o10 ? o10 : a10.locale) && void 0 !== r10 ? r10 : ur;
  if (!i10.formatDistance) throw new RangeError("locale must contain formatDistance property");
  var s10 = Mt(e14, t10);
  if (isNaN(s10)) throw new RangeError("Invalid time value");
  var l10 = yr(vr(n10), { addSuffix: Boolean(null == n10 ? void 0 : n10.addSuffix), comparison: s10 });
  var c10;
  var u10;
  s10 > 0 ? (c10 = Ke(t10), u10 = Ke(e14)) : (c10 = Ke(e14), u10 = Ke(t10));
  var d10 = un(u10, c10);
  var p10 = (mt(u10) - mt(c10)) / 1e3;
  var m10 = Math.round((d10 - p10) / 60);
  var h10;
  if (m10 < 2) return null != n10 && n10.includeSeconds ? d10 < 5 ? i10.formatDistance("lessThanXSeconds", 5, l10) : d10 < 10 ? i10.formatDistance("lessThanXSeconds", 10, l10) : d10 < 20 ? i10.formatDistance("lessThanXSeconds", 20, l10) : d10 < 40 ? i10.formatDistance("halfAMinute", 0, l10) : d10 < 60 ? i10.formatDistance("lessThanXMinutes", 1, l10) : i10.formatDistance("xMinutes", 1, l10) : 0 === m10 ? i10.formatDistance("lessThanXMinutes", 1, l10) : i10.formatDistance("xMinutes", m10, l10);
  if (m10 < 45) return i10.formatDistance("xMinutes", m10, l10);
  if (m10 < 90) return i10.formatDistance("aboutXHours", 1, l10);
  if (m10 < br) {
    var f10 = Math.round(m10 / 60);
    return i10.formatDistance("aboutXHours", f10, l10);
  }
  if (m10 < Sr) return i10.formatDistance("xDays", 1, l10);
  if (m10 < Cr) {
    var g10 = Math.round(m10 / br);
    return i10.formatDistance("xDays", g10, l10);
  }
  if (m10 < xr) return h10 = Math.round(m10 / Cr), i10.formatDistance("aboutXMonths", h10, l10);
  if ((h10 = cn(u10, c10)) < 12) {
    var y10 = Math.round(m10 / Cr);
    return i10.formatDistance("xMonths", y10, l10);
  }
  var v10 = h10 % 12;
  var b10 = Math.floor(h10 / 12);
  return v10 < 3 ? i10.formatDistance("aboutXYears", b10, l10) : v10 < 9 ? i10.formatDistance("overXYears", b10, l10) : i10.formatDistance("almostXYears", b10 + 1, l10);
}
var Tr = 6e4;
var Er = 1440;
var Fr = 30 * Er;
var Mr = 365 * Er;
function kr(e14, t10, n10) {
  var r10, o10, a10;
  Ye(2, arguments);
  var i10 = lt();
  var s10 = null !== (r10 = null !== (o10 = null == n10 ? void 0 : n10.locale) && void 0 !== o10 ? o10 : i10.locale) && void 0 !== r10 ? r10 : ur;
  if (!s10.formatDistance) throw new RangeError("locale must contain localize.formatDistance property");
  var l10 = Mt(e14, t10);
  if (isNaN(l10)) throw new RangeError("Invalid time value");
  var c10 = yr(vr(n10), { addSuffix: Boolean(null == n10 ? void 0 : n10.addSuffix), comparison: l10 });
  var u10;
  var d10;
  l10 > 0 ? (u10 = Ke(t10), d10 = Ke(e14)) : (u10 = Ke(e14), d10 = Ke(t10));
  var p10 = String(null !== (a10 = null == n10 ? void 0 : n10.roundingMethod) && void 0 !== a10 ? a10 : "round");
  var m10;
  if ("floor" === p10) m10 = Math.floor;
  else if ("ceil" === p10) m10 = Math.ceil;
  else {
    if ("round" !== p10) throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
    m10 = Math.round;
  }
  var h10 = d10.getTime() - u10.getTime();
  var f10 = h10 / Tr;
  var g10 = (h10 - (mt(d10) - mt(u10))) / Tr;
  var y10 = null == n10 ? void 0 : n10.unit;
  var v10;
  if ("second" === (v10 = y10 ? String(y10) : f10 < 1 ? "second" : f10 < 60 ? "minute" : f10 < Er ? "hour" : g10 < Fr ? "day" : g10 < Mr ? "month" : "year")) {
    var b10 = m10(h10 / 1e3);
    return s10.formatDistance("xSeconds", b10, c10);
  }
  if ("minute" === v10) {
    var S10 = m10(f10);
    return s10.formatDistance("xMinutes", S10, c10);
  }
  if ("hour" === v10) {
    var C10 = m10(f10 / 60);
    return s10.formatDistance("xHours", C10, c10);
  }
  if ("day" === v10) {
    var x10 = m10(g10 / Er);
    return s10.formatDistance("xDays", x10, c10);
  }
  if ("month" === v10) {
    var w10 = m10(g10 / Fr);
    return 12 === w10 && "month" !== y10 ? s10.formatDistance("xYears", 1, c10) : s10.formatDistance("xMonths", w10, c10);
  }
  if ("year" === v10) {
    var T10 = m10(g10 / Mr);
    return s10.formatDistance("xYears", T10, c10);
  }
  throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
}
var Pr = ["years", "months", "weeks", "days", "hours", "minutes", "seconds"];
var Nr = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
var Dr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
function Lr(e14) {
  return Ye(1, arguments), Ke(e14).getDate();
}
function Hr(e14) {
  return Ye(1, arguments), Ke(e14).getDay();
}
function Ir(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  var n10 = t10.getFullYear();
  var r10 = t10.getMonth();
  var o10 = /* @__PURE__ */ new Date(0);
  return o10.setFullYear(n10, r10 + 1, 0), o10.setHours(0, 0, 0, 0), o10.getDate();
}
function _r(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14).getFullYear();
  return t10 % 400 == 0 || t10 % 4 == 0 && t10 % 100 != 0;
}
function Vr(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14).getDay();
  return 0 === t10 && (t10 = 7), t10;
}
var Rr = 6048e5;
function Ar(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  var n10 = ut(t10).getTime() - pt(t10).getTime();
  return Math.round(n10 / Rr) + 1;
}
function Or(e14) {
  return Ye(1, arguments), Ke(e14).getTime();
}
function Br(e14, t10) {
  var n10, r10, o10, a10, i10, s10, l10, c10;
  Ye(1, arguments);
  var u10 = Ke(e14);
  var d10 = u10.getFullYear();
  var p10 = lt();
  var m10 = qe(null !== (n10 = null !== (r10 = null !== (o10 = null !== (a10 = null == t10 ? void 0 : t10.firstWeekContainsDate) && void 0 !== a10 ? a10 : null == t10 || null === (i10 = t10.locale) || void 0 === i10 || null === (s10 = i10.options) || void 0 === s10 ? void 0 : s10.firstWeekContainsDate) && void 0 !== o10 ? o10 : p10.firstWeekContainsDate) && void 0 !== r10 ? r10 : null === (l10 = p10.locale) || void 0 === l10 || null === (c10 = l10.options) || void 0 === c10 ? void 0 : c10.firstWeekContainsDate) && void 0 !== n10 ? n10 : 1);
  if (!(m10 >= 1 && m10 <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var h10 = /* @__PURE__ */ new Date(0);
  h10.setFullYear(d10 + 1, 0, m10), h10.setHours(0, 0, 0, 0);
  var f10 = ct(h10, t10);
  var g10 = /* @__PURE__ */ new Date(0);
  g10.setFullYear(d10, 0, m10), g10.setHours(0, 0, 0, 0);
  var y10 = ct(g10, t10);
  return u10.getTime() >= f10.getTime() ? d10 + 1 : u10.getTime() >= y10.getTime() ? d10 : d10 - 1;
}
function zr(e14, t10) {
  var n10, r10, o10, a10, i10, s10, l10, c10;
  Ye(1, arguments);
  var u10 = lt();
  var d10 = qe(null !== (n10 = null !== (r10 = null !== (o10 = null !== (a10 = null == t10 ? void 0 : t10.firstWeekContainsDate) && void 0 !== a10 ? a10 : null == t10 || null === (i10 = t10.locale) || void 0 === i10 || null === (s10 = i10.options) || void 0 === s10 ? void 0 : s10.firstWeekContainsDate) && void 0 !== o10 ? o10 : u10.firstWeekContainsDate) && void 0 !== r10 ? r10 : null === (l10 = u10.locale) || void 0 === l10 || null === (c10 = l10.options) || void 0 === c10 ? void 0 : c10.firstWeekContainsDate) && void 0 !== n10 ? n10 : 1);
  var p10 = Br(e14, t10);
  var m10 = /* @__PURE__ */ new Date(0);
  return m10.setFullYear(p10, 0, d10), m10.setHours(0, 0, 0, 0), ct(m10, t10);
}
var $r = 6048e5;
function Wr(e14, t10) {
  Ye(1, arguments);
  var n10 = Ke(e14);
  var r10 = ct(n10, t10).getTime() - zr(n10, t10).getTime();
  return Math.round(r10 / $r) + 1;
}
function jr(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  var n10 = t10.getMonth();
  return t10.setFullYear(t10.getFullYear(), n10 + 1, 0), t10.setHours(0, 0, 0, 0), t10;
}
function Zr(e14, t10) {
  (null == t10 || t10 > e14.length) && (t10 = e14.length);
  for (var n10 = 0, r10 = new Array(t10); n10 < t10; n10++) r10[n10] = e14[n10];
  return r10;
}
function Gr(e14, t10) {
  if (e14) {
    if ("string" == typeof e14) return Zr(e14, t10);
    var n10 = Object.prototype.toString.call(e14).slice(8, -1);
    return "Object" === n10 && e14.constructor && (n10 = e14.constructor.name), "Map" === n10 || "Set" === n10 ? Array.from(e14) : "Arguments" === n10 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n10) ? Zr(e14, t10) : void 0;
  }
}
function Ur(e14, t10) {
  var n10 = "undefined" != typeof Symbol && e14[Symbol.iterator] || e14["@@iterator"];
  if (!n10) {
    if (Array.isArray(e14) || (n10 = Gr(e14)) || t10 && e14 && "number" == typeof e14.length) {
      n10 && (e14 = n10);
      var r10 = 0;
      var o10 = function() {
      };
      return { s: o10, n: function() {
        return r10 >= e14.length ? { done: true } : { done: false, value: e14[r10++] };
      }, e: function(e15) {
        throw e15;
      }, f: o10 };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var a10, i10 = true, s10 = false;
  return { s: function() {
    n10 = n10.call(e14);
  }, n: function() {
    var e15 = n10.next();
    return i10 = e15.done, e15;
  }, e: function(e15) {
    s10 = true, a10 = e15;
  }, f: function() {
    try {
      i10 || null == n10.return || n10.return();
    } finally {
      if (s10) throw a10;
    }
  } };
}
function qr(e14) {
  if (void 0 === e14) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e14;
}
function Yr(e14, t10) {
  return Yr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e15, t11) {
    return e15.__proto__ = t11, e15;
  }, Yr(e14, t10);
}
function Kr(e14, t10) {
  if ("function" != typeof t10 && null !== t10) throw new TypeError("Super expression must either be null or a function");
  e14.prototype = Object.create(t10 && t10.prototype, { constructor: { value: e14, writable: true, configurable: true } }), Object.defineProperty(e14, "prototype", { writable: false }), t10 && Yr(e14, t10);
}
function Xr(e14) {
  return Xr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e15) {
    return e15.__proto__ || Object.getPrototypeOf(e15);
  }, Xr(e14);
}
function Jr() {
  try {
    var e14 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (e15) {
  }
  return (Jr = function() {
    return !!e14;
  })();
}
function Qr(e14, t10) {
  if (t10 && ("object" === Ue(t10) || "function" == typeof t10)) return t10;
  if (void 0 !== t10) throw new TypeError("Derived constructors may only return object or undefined");
  return qr(e14);
}
function eo(e14) {
  var t10 = Jr();
  return function() {
    var n10, r10 = Xr(e14);
    if (t10) {
      var o10 = Xr(this).constructor;
      n10 = Reflect.construct(r10, arguments, o10);
    } else n10 = r10.apply(this, arguments);
    return Qr(this, n10);
  };
}
function to(e14, t10) {
  if (!(e14 instanceof t10)) throw new TypeError("Cannot call a class as a function");
}
function no(e14) {
  var t10 = function(e15, t11) {
    if ("object" != Ue(e15) || !e15) return e15;
    var n10 = e15[Symbol.toPrimitive];
    if (void 0 !== n10) {
      var r10 = n10.call(e15, t11 || "default");
      if ("object" != Ue(r10)) return r10;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t11 ? String : Number)(e15);
  }(e14, "string");
  return "symbol" == Ue(t10) ? t10 : String(t10);
}
function ro(e14, t10) {
  for (var n10 = 0; n10 < t10.length; n10++) {
    var r10 = t10[n10];
    r10.enumerable = r10.enumerable || false, r10.configurable = true, "value" in r10 && (r10.writable = true), Object.defineProperty(e14, no(r10.key), r10);
  }
}
function oo(e14, t10, n10) {
  return t10 && ro(e14.prototype, t10), n10 && ro(e14, n10), Object.defineProperty(e14, "prototype", { writable: false }), e14;
}
function ao(e14, t10, n10) {
  return (t10 = no(t10)) in e14 ? Object.defineProperty(e14, t10, { value: n10, enumerable: true, configurable: true, writable: true }) : e14[t10] = n10, e14;
}
var io = function() {
  function e14() {
    to(this, e14), ao(this, "priority", void 0), ao(this, "subPriority", 0);
  }
  return oo(e14, [{ key: "validate", value: function(e15, t10) {
    return true;
  } }]), e14;
}();
var so = function(e14) {
  Kr(n10, io);
  var t10 = eo(n10);
  function n10(e15, r10, o10, a10, i10) {
    var s10;
    return to(this, n10), (s10 = t10.call(this)).value = e15, s10.validateValue = r10, s10.setValue = o10, s10.priority = a10, i10 && (s10.subPriority = i10), s10;
  }
  return oo(n10, [{ key: "validate", value: function(e15, t11) {
    return this.validateValue(e15, this.value, t11);
  } }, { key: "set", value: function(e15, t11, n11) {
    return this.setValue(e15, t11, this.value, n11);
  } }]), n10;
}();
var lo = function(e14) {
  Kr(n10, io);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 10), ao(qr(e15), "subPriority", -1), e15;
  }
  return oo(n10, [{ key: "set", value: function(e15, t11) {
    if (t11.timestampIsSet) return e15;
    var n11 = /* @__PURE__ */ new Date(0);
    return n11.setFullYear(e15.getUTCFullYear(), e15.getUTCMonth(), e15.getUTCDate()), n11.setHours(e15.getUTCHours(), e15.getUTCMinutes(), e15.getUTCSeconds(), e15.getUTCMilliseconds()), n11;
  } }]), n10;
}();
var co = function() {
  function e14() {
    to(this, e14), ao(this, "incompatibleTokens", void 0), ao(this, "priority", void 0), ao(this, "subPriority", void 0);
  }
  return oo(e14, [{ key: "run", value: function(e15, t10, n10, r10) {
    var o10 = this.parse(e15, t10, n10, r10);
    return o10 ? { setter: new so(o10.value, this.validate, this.set, this.priority, this.subPriority), rest: o10.rest } : null;
  } }, { key: "validate", value: function(e15, t10, n10) {
    return true;
  } }]), e14;
}();
var uo = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 140), ao(qr(e15), "incompatibleTokens", ["R", "u", "t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11, n11) {
    switch (t11) {
      case "G":
      case "GG":
      case "GGG":
        return n11.era(e15, { width: "abbreviated" }) || n11.era(e15, { width: "narrow" });
      case "GGGGG":
        return n11.era(e15, { width: "narrow" });
      default:
        return n11.era(e15, { width: "wide" }) || n11.era(e15, { width: "abbreviated" }) || n11.era(e15, { width: "narrow" });
    }
  } }, { key: "set", value: function(e15, t11, n11) {
    return t11.era = n11, e15.setUTCFullYear(n11, 0, 1), e15.setUTCHours(0, 0, 0, 0), e15;
  } }]), n10;
}();
var po = /^(1[0-2]|0?\d)/, mo = /^(3[0-1]|[0-2]?\d)/, ho = /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/, fo = /^(5[0-3]|[0-4]?\d)/, go = /^(2[0-3]|[0-1]?\d)/, yo = /^(2[0-4]|[0-1]?\d)/, vo = /^(1[0-1]|0?\d)/, bo = /^(1[0-2]|0?\d)/, So = /^[0-5]?\d/, Co = /^[0-5]?\d/, xo = /^\d/, wo = /^\d{1,2}/, To = /^\d{1,3}/, Eo = /^\d{1,4}/, Fo = /^-?\d+/, Mo = /^-?\d/, ko = /^-?\d{1,2}/, Po = /^-?\d{1,3}/, No = /^-?\d{1,4}/;
var Do = /^([+-])(\d{2})(\d{2})?|Z/, Lo = /^([+-])(\d{2})(\d{2})|Z/, Ho = /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/, Io = /^([+-])(\d{2}):(\d{2})|Z/, _o = /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/;
function Vo(e14, t10) {
  return e14 ? { value: t10(e14.value), rest: e14.rest } : e14;
}
function Ro(e14, t10) {
  var n10 = t10.match(e14);
  return n10 ? { value: parseInt(n10[0], 10), rest: t10.slice(n10[0].length) } : null;
}
function Ao(e14, t10) {
  var n10 = t10.match(e14);
  if (!n10) return null;
  if ("Z" === n10[0]) return { value: 0, rest: t10.slice(1) };
  var r10 = "+" === n10[1] ? 1 : -1;
  var o10 = n10[2] ? parseInt(n10[2], 10) : 0;
  var a10 = n10[3] ? parseInt(n10[3], 10) : 0;
  var i10 = n10[5] ? parseInt(n10[5], 10) : 0;
  return { value: r10 * (o10 * Dt + a10 * Nt + i10 * Lt), rest: t10.slice(n10[0].length) };
}
function Oo(e14) {
  return Ro(Fo, e14);
}
function Bo(e14, t10) {
  switch (e14) {
    case 1:
      return Ro(xo, t10);
    case 2:
      return Ro(wo, t10);
    case 3:
      return Ro(To, t10);
    case 4:
      return Ro(Eo, t10);
    default:
      return Ro(new RegExp("^\\d{1," + e14 + "}"), t10);
  }
}
function zo(e14, t10) {
  switch (e14) {
    case 1:
      return Ro(Mo, t10);
    case 2:
      return Ro(ko, t10);
    case 3:
      return Ro(Po, t10);
    case 4:
      return Ro(No, t10);
    default:
      return Ro(new RegExp("^-?\\d{1," + e14 + "}"), t10);
  }
}
function $o(e14) {
  switch (e14) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    default:
      return 0;
  }
}
function Wo(e14, t10) {
  var n10 = t10 > 0;
  var r10 = n10 ? t10 : 1 - t10;
  var o10;
  if (r10 <= 50) o10 = e14 || 100;
  else {
    var a10 = r10 + 50;
    o10 = e14 + 100 * Math.floor(a10 / 100) - (e14 >= a10 % 100 ? 100 : 0);
  }
  return n10 ? o10 : 1 - o10;
}
function jo(e14) {
  return e14 % 400 == 0 || e14 % 4 == 0 && e14 % 100 != 0;
}
var Zo = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 130), ao(qr(e15), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11, n11) {
    var r10 = function(e16) {
      return { year: e16, isTwoDigitYear: "yy" === t11 };
    };
    switch (t11) {
      case "y":
        return Vo(Bo(4, e15), r10);
      case "yo":
        return Vo(n11.ordinalNumber(e15, { unit: "year" }), r10);
      default:
        return Vo(Bo(t11.length, e15), r10);
    }
  } }, { key: "validate", value: function(e15, t11) {
    return t11.isTwoDigitYear || t11.year > 0;
  } }, { key: "set", value: function(e15, t11, n11) {
    var r10 = e15.getUTCFullYear();
    if (n11.isTwoDigitYear) {
      var o10 = Wo(n11.year, r10);
      return e15.setUTCFullYear(o10, 0, 1), e15.setUTCHours(0, 0, 0, 0), e15;
    }
    var a10 = "era" in t11 && 1 !== t11.era ? 1 - n11.year : n11.year;
    return e15.setUTCFullYear(a10, 0, 1), e15.setUTCHours(0, 0, 0, 0), e15;
  } }]), n10;
}();
var Go = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 130), ao(qr(e15), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11, n11) {
    var r10 = function(e16) {
      return { year: e16, isTwoDigitYear: "YY" === t11 };
    };
    switch (t11) {
      case "Y":
        return Vo(Bo(4, e15), r10);
      case "Yo":
        return Vo(n11.ordinalNumber(e15, { unit: "year" }), r10);
      default:
        return Vo(Bo(t11.length, e15), r10);
    }
  } }, { key: "validate", value: function(e15, t11) {
    return t11.isTwoDigitYear || t11.year > 0;
  } }, { key: "set", value: function(e15, t11, n11, r10) {
    var o10 = Fn(e15, r10);
    if (n11.isTwoDigitYear) {
      var a10 = Wo(n11.year, o10);
      return e15.setUTCFullYear(a10, 0, r10.firstWeekContainsDate), e15.setUTCHours(0, 0, 0, 0), En(e15, r10);
    }
    var i10 = "era" in t11 && 1 !== t11.era ? 1 - n11.year : n11.year;
    return e15.setUTCFullYear(i10, 0, r10.firstWeekContainsDate), e15.setUTCHours(0, 0, 0, 0), En(e15, r10);
  } }]), n10;
}();
var Uo = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 130), ao(qr(e15), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11) {
    return zo("R" === t11 ? 4 : t11.length, e15);
  } }, { key: "set", value: function(e15, t11, n11) {
    var r10 = /* @__PURE__ */ new Date(0);
    return r10.setUTCFullYear(n11, 0, 4), r10.setUTCHours(0, 0, 0, 0), Cn(r10);
  } }]), n10;
}();
var qo = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 130), ao(qr(e15), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11) {
    return zo("u" === t11 ? 4 : t11.length, e15);
  } }, { key: "set", value: function(e15, t11, n11) {
    return e15.setUTCFullYear(n11, 0, 1), e15.setUTCHours(0, 0, 0, 0), e15;
  } }]), n10;
}();
var Yo = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 120), ao(qr(e15), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11, n11) {
    switch (t11) {
      case "Q":
      case "QQ":
        return Bo(t11.length, e15);
      case "Qo":
        return n11.ordinalNumber(e15, { unit: "quarter" });
      case "QQQ":
        return n11.quarter(e15, { width: "abbreviated", context: "formatting" }) || n11.quarter(e15, { width: "narrow", context: "formatting" });
      case "QQQQQ":
        return n11.quarter(e15, { width: "narrow", context: "formatting" });
      default:
        return n11.quarter(e15, { width: "wide", context: "formatting" }) || n11.quarter(e15, { width: "abbreviated", context: "formatting" }) || n11.quarter(e15, { width: "narrow", context: "formatting" });
    }
  } }, { key: "validate", value: function(e15, t11) {
    return t11 >= 1 && t11 <= 4;
  } }, { key: "set", value: function(e15, t11, n11) {
    return e15.setUTCMonth(3 * (n11 - 1), 1), e15.setUTCHours(0, 0, 0, 0), e15;
  } }]), n10;
}();
var Ko = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 120), ao(qr(e15), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11, n11) {
    switch (t11) {
      case "q":
      case "qq":
        return Bo(t11.length, e15);
      case "qo":
        return n11.ordinalNumber(e15, { unit: "quarter" });
      case "qqq":
        return n11.quarter(e15, { width: "abbreviated", context: "standalone" }) || n11.quarter(e15, { width: "narrow", context: "standalone" });
      case "qqqqq":
        return n11.quarter(e15, { width: "narrow", context: "standalone" });
      default:
        return n11.quarter(e15, { width: "wide", context: "standalone" }) || n11.quarter(e15, { width: "abbreviated", context: "standalone" }) || n11.quarter(e15, { width: "narrow", context: "standalone" });
    }
  } }, { key: "validate", value: function(e15, t11) {
    return t11 >= 1 && t11 <= 4;
  } }, { key: "set", value: function(e15, t11, n11) {
    return e15.setUTCMonth(3 * (n11 - 1), 1), e15.setUTCHours(0, 0, 0, 0), e15;
  } }]), n10;
}();
var Xo = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), ao(qr(e15), "priority", 110), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11, n11) {
    var r10 = function(e16) {
      return e16 - 1;
    };
    switch (t11) {
      case "M":
        return Vo(Ro(po, e15), r10);
      case "MM":
        return Vo(Bo(2, e15), r10);
      case "Mo":
        return Vo(n11.ordinalNumber(e15, { unit: "month" }), r10);
      case "MMM":
        return n11.month(e15, { width: "abbreviated", context: "formatting" }) || n11.month(e15, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return n11.month(e15, { width: "narrow", context: "formatting" });
      default:
        return n11.month(e15, { width: "wide", context: "formatting" }) || n11.month(e15, { width: "abbreviated", context: "formatting" }) || n11.month(e15, { width: "narrow", context: "formatting" });
    }
  } }, { key: "validate", value: function(e15, t11) {
    return t11 >= 0 && t11 <= 11;
  } }, { key: "set", value: function(e15, t11, n11) {
    return e15.setUTCMonth(n11, 1), e15.setUTCHours(0, 0, 0, 0), e15;
  } }]), n10;
}();
var Jo = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 110), ao(qr(e15), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11, n11) {
    var r10 = function(e16) {
      return e16 - 1;
    };
    switch (t11) {
      case "L":
        return Vo(Ro(po, e15), r10);
      case "LL":
        return Vo(Bo(2, e15), r10);
      case "Lo":
        return Vo(n11.ordinalNumber(e15, { unit: "month" }), r10);
      case "LLL":
        return n11.month(e15, { width: "abbreviated", context: "standalone" }) || n11.month(e15, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return n11.month(e15, { width: "narrow", context: "standalone" });
      default:
        return n11.month(e15, { width: "wide", context: "standalone" }) || n11.month(e15, { width: "abbreviated", context: "standalone" }) || n11.month(e15, { width: "narrow", context: "standalone" });
    }
  } }, { key: "validate", value: function(e15, t11) {
    return t11 >= 0 && t11 <= 11;
  } }, { key: "set", value: function(e15, t11, n11) {
    return e15.setUTCMonth(n11, 1), e15.setUTCHours(0, 0, 0, 0), e15;
  } }]), n10;
}();
var Qo = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 100), ao(qr(e15), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11, n11) {
    switch (t11) {
      case "w":
        return Ro(fo, e15);
      case "wo":
        return n11.ordinalNumber(e15, { unit: "week" });
      default:
        return Bo(t11.length, e15);
    }
  } }, { key: "validate", value: function(e15, t11) {
    return t11 >= 1 && t11 <= 53;
  } }, { key: "set", value: function(e15, t11, n11, r10) {
    return En(function(e16, t12, n12) {
      Ye(2, arguments);
      var r11 = Ke(e16);
      var o10 = qe(t12);
      var a10 = kn(r11, n12) - o10;
      return r11.setUTCDate(r11.getUTCDate() - 7 * a10), r11;
    }(e15, n11, r10), r10);
  } }]), n10;
}();
var ea = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 100), ao(qr(e15), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11, n11) {
    switch (t11) {
      case "I":
        return Ro(fo, e15);
      case "Io":
        return n11.ordinalNumber(e15, { unit: "week" });
      default:
        return Bo(t11.length, e15);
    }
  } }, { key: "validate", value: function(e15, t11) {
    return t11 >= 1 && t11 <= 53;
  } }, { key: "set", value: function(e15, t11, n11) {
    return Cn(function(e16, t12) {
      Ye(2, arguments);
      var n12 = Ke(e16);
      var r10 = qe(t12);
      var o10 = Tn(n12) - r10;
      return n12.setUTCDate(n12.getUTCDate() - 7 * o10), n12;
    }(e15, n11));
  } }]), n10;
}();
var ta = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var na = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var ra = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 90), ao(qr(e15), "subPriority", 1), ao(qr(e15), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11, n11) {
    switch (t11) {
      case "d":
        return Ro(mo, e15);
      case "do":
        return n11.ordinalNumber(e15, { unit: "date" });
      default:
        return Bo(t11.length, e15);
    }
  } }, { key: "validate", value: function(e15, t11) {
    var n11 = jo(e15.getUTCFullYear());
    var r10 = e15.getUTCMonth();
    return n11 ? t11 >= 1 && t11 <= na[r10] : t11 >= 1 && t11 <= ta[r10];
  } }, { key: "set", value: function(e15, t11, n11) {
    return e15.setUTCDate(n11), e15.setUTCHours(0, 0, 0, 0), e15;
  } }]), n10;
}();
var oa = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 90), ao(qr(e15), "subpriority", 1), ao(qr(e15), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11, n11) {
    switch (t11) {
      case "D":
      case "DD":
        return Ro(ho, e15);
      case "Do":
        return n11.ordinalNumber(e15, { unit: "date" });
      default:
        return Bo(t11.length, e15);
    }
  } }, { key: "validate", value: function(e15, t11) {
    return jo(e15.getUTCFullYear()) ? t11 >= 1 && t11 <= 366 : t11 >= 1 && t11 <= 365;
  } }, { key: "set", value: function(e15, t11, n11) {
    return e15.setUTCMonth(0, n11), e15.setUTCHours(0, 0, 0, 0), e15;
  } }]), n10;
}();
function aa(e14, t10, n10) {
  var r10, o10, a10, i10, s10, l10, c10, u10;
  Ye(2, arguments);
  var d10 = lt();
  var p10 = qe(null !== (r10 = null !== (o10 = null !== (a10 = null !== (i10 = null == n10 ? void 0 : n10.weekStartsOn) && void 0 !== i10 ? i10 : null == n10 || null === (s10 = n10.locale) || void 0 === s10 || null === (l10 = s10.options) || void 0 === l10 ? void 0 : l10.weekStartsOn) && void 0 !== a10 ? a10 : d10.weekStartsOn) && void 0 !== o10 ? o10 : null === (c10 = d10.locale) || void 0 === c10 || null === (u10 = c10.options) || void 0 === u10 ? void 0 : u10.weekStartsOn) && void 0 !== r10 ? r10 : 0);
  if (!(p10 >= 0 && p10 <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var m10 = Ke(e14);
  var h10 = qe(t10);
  var f10 = ((h10 % 7 + 7) % 7 < p10 ? 7 : 0) + h10 - m10.getUTCDay();
  return m10.setUTCDate(m10.getUTCDate() + f10), m10;
}
var ia = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 90), ao(qr(e15), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11, n11) {
    switch (t11) {
      case "E":
      case "EE":
      case "EEE":
        return n11.day(e15, { width: "abbreviated", context: "formatting" }) || n11.day(e15, { width: "short", context: "formatting" }) || n11.day(e15, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return n11.day(e15, { width: "narrow", context: "formatting" });
      case "EEEEEE":
        return n11.day(e15, { width: "short", context: "formatting" }) || n11.day(e15, { width: "narrow", context: "formatting" });
      default:
        return n11.day(e15, { width: "wide", context: "formatting" }) || n11.day(e15, { width: "abbreviated", context: "formatting" }) || n11.day(e15, { width: "short", context: "formatting" }) || n11.day(e15, { width: "narrow", context: "formatting" });
    }
  } }, { key: "validate", value: function(e15, t11) {
    return t11 >= 0 && t11 <= 6;
  } }, { key: "set", value: function(e15, t11, n11, r10) {
    return (e15 = aa(e15, n11, r10)).setUTCHours(0, 0, 0, 0), e15;
  } }]), n10;
}();
var sa = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 90), ao(qr(e15), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11, n11, r10) {
    var o10 = function(e16) {
      var t12 = 7 * Math.floor((e16 - 1) / 7);
      return (e16 + r10.weekStartsOn + 6) % 7 + t12;
    };
    switch (t11) {
      case "e":
      case "ee":
        return Vo(Bo(t11.length, e15), o10);
      case "eo":
        return Vo(n11.ordinalNumber(e15, { unit: "day" }), o10);
      case "eee":
        return n11.day(e15, { width: "abbreviated", context: "formatting" }) || n11.day(e15, { width: "short", context: "formatting" }) || n11.day(e15, { width: "narrow", context: "formatting" });
      case "eeeee":
        return n11.day(e15, { width: "narrow", context: "formatting" });
      case "eeeeee":
        return n11.day(e15, { width: "short", context: "formatting" }) || n11.day(e15, { width: "narrow", context: "formatting" });
      default:
        return n11.day(e15, { width: "wide", context: "formatting" }) || n11.day(e15, { width: "abbreviated", context: "formatting" }) || n11.day(e15, { width: "short", context: "formatting" }) || n11.day(e15, { width: "narrow", context: "formatting" });
    }
  } }, { key: "validate", value: function(e15, t11) {
    return t11 >= 0 && t11 <= 6;
  } }, { key: "set", value: function(e15, t11, n11, r10) {
    return (e15 = aa(e15, n11, r10)).setUTCHours(0, 0, 0, 0), e15;
  } }]), n10;
}();
var la = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 90), ao(qr(e15), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11, n11, r10) {
    var o10 = function(e16) {
      var t12 = 7 * Math.floor((e16 - 1) / 7);
      return (e16 + r10.weekStartsOn + 6) % 7 + t12;
    };
    switch (t11) {
      case "c":
      case "cc":
        return Vo(Bo(t11.length, e15), o10);
      case "co":
        return Vo(n11.ordinalNumber(e15, { unit: "day" }), o10);
      case "ccc":
        return n11.day(e15, { width: "abbreviated", context: "standalone" }) || n11.day(e15, { width: "short", context: "standalone" }) || n11.day(e15, { width: "narrow", context: "standalone" });
      case "ccccc":
        return n11.day(e15, { width: "narrow", context: "standalone" });
      case "cccccc":
        return n11.day(e15, { width: "short", context: "standalone" }) || n11.day(e15, { width: "narrow", context: "standalone" });
      default:
        return n11.day(e15, { width: "wide", context: "standalone" }) || n11.day(e15, { width: "abbreviated", context: "standalone" }) || n11.day(e15, { width: "short", context: "standalone" }) || n11.day(e15, { width: "narrow", context: "standalone" });
    }
  } }, { key: "validate", value: function(e15, t11) {
    return t11 >= 0 && t11 <= 6;
  } }, { key: "set", value: function(e15, t11, n11, r10) {
    return (e15 = aa(e15, n11, r10)).setUTCHours(0, 0, 0, 0), e15;
  } }]), n10;
}();
var ca = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 90), ao(qr(e15), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11, n11) {
    var r10 = function(e16) {
      return 0 === e16 ? 7 : e16;
    };
    switch (t11) {
      case "i":
      case "ii":
        return Bo(t11.length, e15);
      case "io":
        return n11.ordinalNumber(e15, { unit: "day" });
      case "iii":
        return Vo(n11.day(e15, { width: "abbreviated", context: "formatting" }) || n11.day(e15, { width: "short", context: "formatting" }) || n11.day(e15, { width: "narrow", context: "formatting" }), r10);
      case "iiiii":
        return Vo(n11.day(e15, { width: "narrow", context: "formatting" }), r10);
      case "iiiiii":
        return Vo(n11.day(e15, { width: "short", context: "formatting" }) || n11.day(e15, { width: "narrow", context: "formatting" }), r10);
      default:
        return Vo(n11.day(e15, { width: "wide", context: "formatting" }) || n11.day(e15, { width: "abbreviated", context: "formatting" }) || n11.day(e15, { width: "short", context: "formatting" }) || n11.day(e15, { width: "narrow", context: "formatting" }), r10);
    }
  } }, { key: "validate", value: function(e15, t11) {
    return t11 >= 1 && t11 <= 7;
  } }, { key: "set", value: function(e15, t11, n11) {
    return e15 = function(e16, t12) {
      Ye(2, arguments);
      var n12 = qe(t12);
      n12 % 7 == 0 && (n12 -= 7);
      var r10 = Ke(e16);
      var o10 = ((n12 % 7 + 7) % 7 < 1 ? 7 : 0) + n12 - r10.getUTCDay();
      return r10.setUTCDate(r10.getUTCDate() + o10), r10;
    }(e15, n11), e15.setUTCHours(0, 0, 0, 0), e15;
  } }]), n10;
}();
var ua = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 80), ao(qr(e15), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11, n11) {
    switch (t11) {
      case "a":
      case "aa":
      case "aaa":
        return n11.dayPeriod(e15, { width: "abbreviated", context: "formatting" }) || n11.dayPeriod(e15, { width: "narrow", context: "formatting" });
      case "aaaaa":
        return n11.dayPeriod(e15, { width: "narrow", context: "formatting" });
      default:
        return n11.dayPeriod(e15, { width: "wide", context: "formatting" }) || n11.dayPeriod(e15, { width: "abbreviated", context: "formatting" }) || n11.dayPeriod(e15, { width: "narrow", context: "formatting" });
    }
  } }, { key: "set", value: function(e15, t11, n11) {
    return e15.setUTCHours($o(n11), 0, 0, 0), e15;
  } }]), n10;
}();
var da = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 80), ao(qr(e15), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11, n11) {
    switch (t11) {
      case "b":
      case "bb":
      case "bbb":
        return n11.dayPeriod(e15, { width: "abbreviated", context: "formatting" }) || n11.dayPeriod(e15, { width: "narrow", context: "formatting" });
      case "bbbbb":
        return n11.dayPeriod(e15, { width: "narrow", context: "formatting" });
      default:
        return n11.dayPeriod(e15, { width: "wide", context: "formatting" }) || n11.dayPeriod(e15, { width: "abbreviated", context: "formatting" }) || n11.dayPeriod(e15, { width: "narrow", context: "formatting" });
    }
  } }, { key: "set", value: function(e15, t11, n11) {
    return e15.setUTCHours($o(n11), 0, 0, 0), e15;
  } }]), n10;
}();
var pa = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 80), ao(qr(e15), "incompatibleTokens", ["a", "b", "t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11, n11) {
    switch (t11) {
      case "B":
      case "BB":
      case "BBB":
        return n11.dayPeriod(e15, { width: "abbreviated", context: "formatting" }) || n11.dayPeriod(e15, { width: "narrow", context: "formatting" });
      case "BBBBB":
        return n11.dayPeriod(e15, { width: "narrow", context: "formatting" });
      default:
        return n11.dayPeriod(e15, { width: "wide", context: "formatting" }) || n11.dayPeriod(e15, { width: "abbreviated", context: "formatting" }) || n11.dayPeriod(e15, { width: "narrow", context: "formatting" });
    }
  } }, { key: "set", value: function(e15, t11, n11) {
    return e15.setUTCHours($o(n11), 0, 0, 0), e15;
  } }]), n10;
}();
var ma = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 70), ao(qr(e15), "incompatibleTokens", ["H", "K", "k", "t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11, n11) {
    switch (t11) {
      case "h":
        return Ro(bo, e15);
      case "ho":
        return n11.ordinalNumber(e15, { unit: "hour" });
      default:
        return Bo(t11.length, e15);
    }
  } }, { key: "validate", value: function(e15, t11) {
    return t11 >= 1 && t11 <= 12;
  } }, { key: "set", value: function(e15, t11, n11) {
    var r10 = e15.getUTCHours() >= 12;
    return r10 && n11 < 12 ? e15.setUTCHours(n11 + 12, 0, 0, 0) : r10 || 12 !== n11 ? e15.setUTCHours(n11, 0, 0, 0) : e15.setUTCHours(0, 0, 0, 0), e15;
  } }]), n10;
}();
var ha = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 70), ao(qr(e15), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11, n11) {
    switch (t11) {
      case "H":
        return Ro(go, e15);
      case "Ho":
        return n11.ordinalNumber(e15, { unit: "hour" });
      default:
        return Bo(t11.length, e15);
    }
  } }, { key: "validate", value: function(e15, t11) {
    return t11 >= 0 && t11 <= 23;
  } }, { key: "set", value: function(e15, t11, n11) {
    return e15.setUTCHours(n11, 0, 0, 0), e15;
  } }]), n10;
}();
var fa = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 70), ao(qr(e15), "incompatibleTokens", ["h", "H", "k", "t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11, n11) {
    switch (t11) {
      case "K":
        return Ro(vo, e15);
      case "Ko":
        return n11.ordinalNumber(e15, { unit: "hour" });
      default:
        return Bo(t11.length, e15);
    }
  } }, { key: "validate", value: function(e15, t11) {
    return t11 >= 0 && t11 <= 11;
  } }, { key: "set", value: function(e15, t11, n11) {
    return e15.getUTCHours() >= 12 && n11 < 12 ? e15.setUTCHours(n11 + 12, 0, 0, 0) : e15.setUTCHours(n11, 0, 0, 0), e15;
  } }]), n10;
}();
var ga = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 70), ao(qr(e15), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11, n11) {
    switch (t11) {
      case "k":
        return Ro(yo, e15);
      case "ko":
        return n11.ordinalNumber(e15, { unit: "hour" });
      default:
        return Bo(t11.length, e15);
    }
  } }, { key: "validate", value: function(e15, t11) {
    return t11 >= 1 && t11 <= 24;
  } }, { key: "set", value: function(e15, t11, n11) {
    var r10 = n11 <= 24 ? n11 % 24 : n11;
    return e15.setUTCHours(r10, 0, 0, 0), e15;
  } }]), n10;
}();
var ya = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 60), ao(qr(e15), "incompatibleTokens", ["t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11, n11) {
    switch (t11) {
      case "m":
        return Ro(So, e15);
      case "mo":
        return n11.ordinalNumber(e15, { unit: "minute" });
      default:
        return Bo(t11.length, e15);
    }
  } }, { key: "validate", value: function(e15, t11) {
    return t11 >= 0 && t11 <= 59;
  } }, { key: "set", value: function(e15, t11, n11) {
    return e15.setUTCMinutes(n11, 0, 0), e15;
  } }]), n10;
}();
var va = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 50), ao(qr(e15), "incompatibleTokens", ["t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11, n11) {
    switch (t11) {
      case "s":
        return Ro(Co, e15);
      case "so":
        return n11.ordinalNumber(e15, { unit: "second" });
      default:
        return Bo(t11.length, e15);
    }
  } }, { key: "validate", value: function(e15, t11) {
    return t11 >= 0 && t11 <= 59;
  } }, { key: "set", value: function(e15, t11, n11) {
    return e15.setUTCSeconds(n11, 0), e15;
  } }]), n10;
}();
var ba = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 30), ao(qr(e15), "incompatibleTokens", ["t", "T"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11) {
    return Vo(Bo(t11.length, e15), function(e16) {
      return Math.floor(e16 * Math.pow(10, 3 - t11.length));
    });
  } }, { key: "set", value: function(e15, t11, n11) {
    return e15.setUTCMilliseconds(n11), e15;
  } }]), n10;
}();
var Sa = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 10), ao(qr(e15), "incompatibleTokens", ["t", "T", "x"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11) {
    switch (t11) {
      case "X":
        return Ao(Do, e15);
      case "XX":
        return Ao(Lo, e15);
      case "XXXX":
        return Ao(Ho, e15);
      case "XXXXX":
        return Ao(_o, e15);
      default:
        return Ao(Io, e15);
    }
  } }, { key: "set", value: function(e15, t11, n11) {
    return t11.timestampIsSet ? e15 : new Date(e15.getTime() - n11);
  } }]), n10;
}();
var Ca = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 10), ao(qr(e15), "incompatibleTokens", ["t", "T", "X"]), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15, t11) {
    switch (t11) {
      case "x":
        return Ao(Do, e15);
      case "xx":
        return Ao(Lo, e15);
      case "xxxx":
        return Ao(Ho, e15);
      case "xxxxx":
        return Ao(_o, e15);
      default:
        return Ao(Io, e15);
    }
  } }, { key: "set", value: function(e15, t11, n11) {
    return t11.timestampIsSet ? e15 : new Date(e15.getTime() - n11);
  } }]), n10;
}();
var xa = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 40), ao(qr(e15), "incompatibleTokens", "*"), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15) {
    return Oo(e15);
  } }, { key: "set", value: function(e15, t11, n11) {
    return [new Date(1e3 * n11), { timestampIsSet: true }];
  } }]), n10;
}();
var wa = function(e14) {
  Kr(n10, co);
  var t10 = eo(n10);
  function n10() {
    var e15;
    to(this, n10);
    for (var r10 = arguments.length, o10 = new Array(r10), a10 = 0; a10 < r10; a10++) o10[a10] = arguments[a10];
    return ao(qr(e15 = t10.call.apply(t10, [this].concat(o10))), "priority", 20), ao(qr(e15), "incompatibleTokens", "*"), e15;
  }
  return oo(n10, [{ key: "parse", value: function(e15) {
    return Oo(e15);
  } }, { key: "set", value: function(e15, t11, n11) {
    return [new Date(n11), { timestampIsSet: true }];
  } }]), n10;
}();
var Ta = { G: new uo(), y: new Zo(), Y: new Go(), R: new Uo(), u: new qo(), Q: new Yo(), q: new Ko(), M: new Xo(), L: new Jo(), w: new Qo(), I: new ea(), d: new ra(), D: new oa(), E: new ia(), e: new sa(), c: new la(), i: new ca(), a: new ua(), b: new da(), B: new pa(), h: new ma(), H: new ha(), K: new fa(), k: new ga(), m: new ya(), s: new va(), S: new ba(), X: new Sa(), x: new Ca(), t: new xa(), T: new wa() };
var Ea = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var Fa = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var Ma = /^'([^]*?)'?$/;
var ka = /''/g;
var Pa = /\S/;
var Na = /[a-zA-Z]/;
function Da(e14, t10, n10, r10) {
  var o10, a10, i10, s10, l10, c10, u10, d10, p10, m10, h10, f10, g10, y10, v10, b10, S10, C10;
  Ye(3, arguments);
  var x10 = String(e14);
  var w10 = String(t10);
  var T10 = lt();
  var E10 = null !== (o10 = null !== (a10 = null == r10 ? void 0 : r10.locale) && void 0 !== a10 ? a10 : T10.locale) && void 0 !== o10 ? o10 : ur;
  if (!E10.match) throw new RangeError("locale must contain match property");
  var F10 = qe(null !== (i10 = null !== (s10 = null !== (l10 = null !== (c10 = null == r10 ? void 0 : r10.firstWeekContainsDate) && void 0 !== c10 ? c10 : null == r10 || null === (u10 = r10.locale) || void 0 === u10 || null === (d10 = u10.options) || void 0 === d10 ? void 0 : d10.firstWeekContainsDate) && void 0 !== l10 ? l10 : T10.firstWeekContainsDate) && void 0 !== s10 ? s10 : null === (p10 = T10.locale) || void 0 === p10 || null === (m10 = p10.options) || void 0 === m10 ? void 0 : m10.firstWeekContainsDate) && void 0 !== i10 ? i10 : 1);
  if (!(F10 >= 1 && F10 <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var M10 = qe(null !== (h10 = null !== (f10 = null !== (g10 = null !== (y10 = null == r10 ? void 0 : r10.weekStartsOn) && void 0 !== y10 ? y10 : null == r10 || null === (v10 = r10.locale) || void 0 === v10 || null === (b10 = v10.options) || void 0 === b10 ? void 0 : b10.weekStartsOn) && void 0 !== g10 ? g10 : T10.weekStartsOn) && void 0 !== f10 ? f10 : null === (S10 = T10.locale) || void 0 === S10 || null === (C10 = S10.options) || void 0 === C10 ? void 0 : C10.weekStartsOn) && void 0 !== h10 ? h10 : 0);
  if (!(M10 >= 0 && M10 <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if ("" === w10) return "" === x10 ? Ke(n10) : /* @__PURE__ */ new Date(NaN);
  var k10 = { firstWeekContainsDate: F10, weekStartsOn: M10, locale: E10 };
  var P10 = [new lo()];
  var N10 = w10.match(Fa).map(function(e15) {
    var t11 = e15[0];
    return t11 in Gn ? (0, Gn[t11])(e15, E10.formatLong) : e15;
  }).join("").match(Ea);
  var D10 = [];
  var L10, H10 = Ur(N10);
  try {
    var I10 = function() {
      var t11 = L10.value;
      null != r10 && r10.useAdditionalWeekYearTokens || !Kn(t11) || Xn(t11, w10, e14), null != r10 && r10.useAdditionalDayOfYearTokens || !Yn(t11) || Xn(t11, w10, e14);
      var n11 = t11[0];
      var o11 = Ta[n11];
      if (o11) {
        var a11 = o11.incompatibleTokens;
        if (Array.isArray(a11)) {
          var i11 = D10.find(function(e15) {
            return a11.includes(e15.token) || e15.token === n11;
          });
          if (i11) throw new RangeError("The format string mustn't contain `".concat(i11.fullToken, "` and `").concat(t11, "` at the same time"));
        } else if ("*" === o11.incompatibleTokens && D10.length > 0) throw new RangeError("The format string mustn't contain `".concat(t11, "` and any other token at the same time"));
        D10.push({ token: n11, fullToken: t11 });
        var s11 = o11.run(x10, t11, E10.match, k10);
        if (!s11) return { v: /* @__PURE__ */ new Date(NaN) };
        P10.push(s11.setter), x10 = s11.rest;
      } else {
        if (n11.match(Na)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + n11 + "`");
        if ("''" === t11 ? t11 = "'" : "'" === n11 && (t11 = t11.match(Ma)[1].replace(ka, "'")), 0 !== x10.indexOf(t11)) return { v: /* @__PURE__ */ new Date(NaN) };
        x10 = x10.slice(t11.length);
      }
    };
    for (H10.s(); !(L10 = H10.n()).done; ) {
      var _10 = I10();
      if ("object" === Ue(_10)) return _10.v;
    }
  } catch (e15) {
    H10.e(e15);
  } finally {
    H10.f();
  }
  if (x10.length > 0 && Pa.test(x10)) return /* @__PURE__ */ new Date(NaN);
  var V10 = P10.map(function(e15) {
    return e15.priority;
  }).sort(function(e15, t11) {
    return t11 - e15;
  }).filter(function(e15, t11, n11) {
    return n11.indexOf(e15) === t11;
  }).map(function(e15) {
    return P10.filter(function(t11) {
      return t11.priority === e15;
    }).sort(function(e16, t11) {
      return t11.subPriority - e16.subPriority;
    });
  }).map(function(e15) {
    return e15[0];
  });
  var R10 = Ke(n10);
  if (isNaN(R10.getTime())) return /* @__PURE__ */ new Date(NaN);
  var A10 = Sn(R10, mt(R10));
  var O10 = {};
  var B10, z10 = Ur(V10);
  try {
    for (z10.s(); !(B10 = z10.n()).done; ) {
      var $10 = B10.value;
      if (!$10.validate(A10, k10)) return /* @__PURE__ */ new Date(NaN);
      var W10 = $10.set(A10, O10, k10);
      Array.isArray(W10) ? (A10 = W10[0], yr(O10, W10[1])) : A10 = W10;
    }
  } catch (e15) {
    z10.e(e15);
  } finally {
    z10.f();
  }
  return A10;
}
function La(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  return t10.setMinutes(0, 0, 0), t10;
}
function Ha(e14, t10) {
  Ye(2, arguments);
  var n10 = La(e14);
  var r10 = La(t10);
  return n10.getTime() === r10.getTime();
}
function Ia(e14, t10, n10) {
  Ye(2, arguments);
  var r10 = ct(e14, n10);
  var o10 = ct(t10, n10);
  return r10.getTime() === o10.getTime();
}
function _a(e14, t10) {
  return Ye(2, arguments), Ia(e14, t10, { weekStartsOn: 1 });
}
function Va(e14, t10) {
  Ye(2, arguments);
  var n10 = mn(e14);
  var r10 = mn(t10);
  return n10.getTime() === r10.getTime();
}
function Ra(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = Ke(t10);
  return n10.getFullYear() === r10.getFullYear() && n10.getMonth() === r10.getMonth();
}
function Aa(e14, t10) {
  Ye(2, arguments);
  var n10 = hn(e14);
  var r10 = hn(t10);
  return n10.getTime() === r10.getTime();
}
function Oa(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  return t10.setMilliseconds(0), t10;
}
function Ba(e14, t10) {
  Ye(2, arguments);
  var n10 = Oa(e14);
  var r10 = Oa(t10);
  return n10.getTime() === r10.getTime();
}
function za(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = Ke(t10);
  return n10.getFullYear() === r10.getFullYear();
}
function $a(e14, t10) {
  return Ye(2, arguments), Xe(e14, -qe(t10));
}
function Wa(e14, t10) {
  var n10, r10, o10, a10, i10, s10, l10, c10;
  Ye(1, arguments);
  var u10 = lt();
  var d10 = qe(null !== (n10 = null !== (r10 = null !== (o10 = null !== (a10 = null == t10 ? void 0 : t10.weekStartsOn) && void 0 !== a10 ? a10 : null == t10 || null === (i10 = t10.locale) || void 0 === i10 || null === (s10 = i10.options) || void 0 === s10 ? void 0 : s10.weekStartsOn) && void 0 !== o10 ? o10 : u10.weekStartsOn) && void 0 !== r10 ? r10 : null === (l10 = u10.locale) || void 0 === l10 || null === (c10 = l10.options) || void 0 === c10 ? void 0 : c10.weekStartsOn) && void 0 !== n10 ? n10 : 0);
  if (!(d10 >= 0 && d10 <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6");
  var p10 = Ke(e14);
  var m10 = p10.getDay();
  var h10 = 6 + (m10 < d10 ? -7 : 0) - (m10 - d10);
  return p10.setHours(0, 0, 0, 0), p10.setDate(p10.getDate() + h10), p10;
}
var ja = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
var Za = /^'([^]*?)'?$/;
var Ga = /''/g;
var Ua = /[a-zA-Z]/;
var qa = 365.2425;
function Ya(e14, t10) {
  Ye(2, arguments);
  var n10 = t10 - Hr(e14);
  return n10 <= 0 && (n10 += 7), Xe(e14, n10);
}
function Ka(e14, t10) {
  var n10;
  Ye(1, arguments);
  var r10 = qe(null !== (n10 = null == t10 ? void 0 : t10.additionalDigits) && void 0 !== n10 ? n10 : 2);
  if (2 !== r10 && 1 !== r10 && 0 !== r10) throw new RangeError("additionalDigits must be 0, 1 or 2");
  if ("string" != typeof e14 && "[object String]" !== Object.prototype.toString.call(e14)) return /* @__PURE__ */ new Date(NaN);
  var o10 = function(e15) {
    var t11 = {};
    var n11 = e15.split(Xa.dateTimeDelimiter);
    var r11;
    if (n11.length > 2) return t11;
    /:/.test(n11[0]) ? r11 = n11[0] : (t11.date = n11[0], r11 = n11[1], Xa.timeZoneDelimiter.test(t11.date) && (t11.date = e15.split(Xa.timeZoneDelimiter)[0], r11 = e15.substr(t11.date.length, e15.length)));
    if (r11) {
      var o11 = Xa.timezone.exec(r11);
      o11 ? (t11.time = r11.replace(o11[1], ""), t11.timezone = o11[1]) : t11.time = r11;
    }
    return t11;
  }(e14);
  var a10;
  if (o10.date) {
    var i10 = function(e15, t11) {
      var n11 = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + t11) + "})|(\\d{2}|[+-]\\d{" + (2 + t11) + "})$)");
      var r11 = e15.match(n11);
      if (!r11) return { year: NaN, restDateString: "" };
      var o11 = r11[1] ? parseInt(r11[1]) : null;
      var a11 = r11[2] ? parseInt(r11[2]) : null;
      return { year: null === a11 ? o11 : 100 * a11, restDateString: e15.slice((r11[1] || r11[2]).length) };
    }(o10.date, r10);
    a10 = function(e15, t11) {
      if (null === t11) return /* @__PURE__ */ new Date(NaN);
      var n11 = e15.match(Ja);
      if (!n11) return /* @__PURE__ */ new Date(NaN);
      var r11 = !!n11[4];
      var o11 = ti(n11[1]);
      var a11 = ti(n11[2]) - 1;
      var i11 = ti(n11[3]);
      var s11 = ti(n11[4]);
      var l11 = ti(n11[5]) - 1;
      if (r11) return function(e16, t12, n12) {
        return t12 >= 1 && t12 <= 53 && n12 >= 0 && n12 <= 6;
      }(0, s11, l11) ? function(e16, t12, n12) {
        var r12 = /* @__PURE__ */ new Date(0);
        r12.setUTCFullYear(e16, 0, 4);
        var o12 = r12.getUTCDay() || 7;
        var a12 = 7 * (t12 - 1) + n12 + 1 - o12;
        return r12.setUTCDate(r12.getUTCDate() + a12), r12;
      }(t11, s11, l11) : /* @__PURE__ */ new Date(NaN);
      var c11 = /* @__PURE__ */ new Date(0);
      return function(e16, t12, n12) {
        return t12 >= 0 && t12 <= 11 && n12 >= 1 && n12 <= (ri[t12] || (oi(e16) ? 29 : 28));
      }(t11, a11, i11) && function(e16, t12) {
        return t12 >= 1 && t12 <= (oi(e16) ? 366 : 365);
      }(t11, o11) ? (c11.setUTCFullYear(t11, a11, Math.max(o11, i11)), c11) : /* @__PURE__ */ new Date(NaN);
    }(i10.restDateString, i10.year);
  }
  if (!a10 || isNaN(a10.getTime())) return /* @__PURE__ */ new Date(NaN);
  var s10 = a10.getTime();
  var l10 = 0;
  var c10;
  if (o10.time && (l10 = function(e15) {
    var t11 = e15.match(Qa);
    if (!t11) return NaN;
    var n11 = ni(t11[1]);
    var r11 = ni(t11[2]);
    var o11 = ni(t11[3]);
    if (!function(e16, t12, n12) {
      if (24 === e16) return 0 === t12 && 0 === n12;
      return n12 >= 0 && n12 < 60 && t12 >= 0 && t12 < 60 && e16 >= 0 && e16 < 25;
    }(n11, r11, o11)) return NaN;
    return n11 * Dt + r11 * Nt + 1e3 * o11;
  }(o10.time), isNaN(l10))) return /* @__PURE__ */ new Date(NaN);
  if (!o10.timezone) {
    var u10 = new Date(s10 + l10);
    var d10 = /* @__PURE__ */ new Date(0);
    return d10.setFullYear(u10.getUTCFullYear(), u10.getUTCMonth(), u10.getUTCDate()), d10.setHours(u10.getUTCHours(), u10.getUTCMinutes(), u10.getUTCSeconds(), u10.getUTCMilliseconds()), d10;
  }
  return c10 = function(e15) {
    if ("Z" === e15) return 0;
    var t11 = e15.match(ei);
    if (!t11) return 0;
    var n11 = "+" === t11[1] ? -1 : 1;
    var r11 = parseInt(t11[2]);
    var o11 = t11[3] && parseInt(t11[3]) || 0;
    if (!function(e16, t12) {
      return t12 >= 0 && t12 <= 59;
    }(0, o11)) return NaN;
    return n11 * (r11 * Dt + o11 * Nt);
  }(o10.timezone), isNaN(c10) ? /* @__PURE__ */ new Date(NaN) : new Date(s10 + l10 + c10);
}
var Xa = { dateTimeDelimiter: /[T ]/, timeZoneDelimiter: /[Z ]/i, timezone: /([Z+-].*)$/ };
var Ja = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var Qa = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var ei = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function ti(e14) {
  return e14 ? parseInt(e14) : 1;
}
function ni(e14) {
  return e14 && parseFloat(e14.replace(",", ".")) || 0;
}
var ri = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function oi(e14) {
  return e14 % 400 == 0 || e14 % 4 == 0 && e14 % 100 != 0;
}
function ai(e14, t10) {
  Ye(2, arguments);
  var n10 = Hr(e14) - t10;
  return n10 <= 0 && (n10 += 7), $a(e14, n10);
}
function ii(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = qe(t10);
  var o10 = n10.getFullYear();
  var a10 = n10.getDate();
  var i10 = /* @__PURE__ */ new Date(0);
  i10.setFullYear(o10, r10, 15), i10.setHours(0, 0, 0, 0);
  var s10 = Ir(i10);
  return n10.setMonth(r10, Math.min(a10, s10)), n10;
}
function si(e14, t10) {
  return Ye(2, arguments), Je(e14, -qe(t10));
}
var li = Object.freeze({ __proto__: null, add: Qe, addBusinessDays: rt, addDays: Xe, addHours: it, addISOWeekYears: vt, addMilliseconds: ot, addMinutes: St, addMonths: Je, addQuarters: Ct, addSeconds: xt, addWeeks: wt, addYears: Tt, areIntervalsOverlapping: function(e14, t10, n10) {
  Ye(2, arguments);
  var r10 = Ke(null == e14 ? void 0 : e14.start).getTime();
  var o10 = Ke(null == e14 ? void 0 : e14.end).getTime();
  var a10 = Ke(null == t10 ? void 0 : t10.start).getTime();
  var i10 = Ke(null == t10 ? void 0 : t10.end).getTime();
  if (!(r10 <= o10 && a10 <= i10)) throw new RangeError("Invalid interval");
  return null != n10 && n10.inclusive ? r10 <= i10 && a10 <= o10 : r10 < i10 && a10 < o10;
}, clamp: function(e14, t10) {
  var n10 = t10.start, r10 = t10.end;
  return Ye(2, arguments), Ft([Et([e14, n10]), r10]);
}, closestIndexTo: function(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  if (isNaN(Number(n10))) return NaN;
  var r10 = n10.getTime();
  var o10;
  var a10;
  return (null == t10 ? [] : "function" == typeof t10.forEach ? t10 : Array.prototype.slice.call(t10)).forEach(function(e15, t11) {
    var n11 = Ke(e15);
    if (isNaN(Number(n11))) return o10 = NaN, void (a10 = NaN);
    var i10 = Math.abs(r10 - n11.getTime());
    (null == o10 || i10 < Number(a10)) && (o10 = t11, a10 = i10);
  }), o10;
}, closestTo: function(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  if (isNaN(Number(n10))) return /* @__PURE__ */ new Date(NaN);
  var r10 = n10.getTime();
  var o10;
  var a10;
  return (null == t10 ? [] : "function" == typeof t10.forEach ? t10 : Array.prototype.slice.call(t10)).forEach(function(e15) {
    var t11 = Ke(e15);
    if (isNaN(Number(t11))) return o10 = /* @__PURE__ */ new Date(NaN), void (a10 = NaN);
    var n11 = Math.abs(r10 - t11.getTime());
    (null == o10 || n11 < Number(a10)) && (o10 = t11, a10 = n11);
  }), o10;
}, compareAsc: Mt, compareDesc: function(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = Ke(t10);
  var o10 = n10.getTime() - r10.getTime();
  return o10 > 0 ? -1 : o10 < 0 ? 1 : o10;
}, daysToWeeks: function(e14) {
  Ye(1, arguments);
  var t10 = e14 / 7;
  return Math.floor(t10);
}, differenceInBusinessDays: function(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = Ke(t10);
  if (!$t(n10) || !$t(r10)) return NaN;
  var o10 = gt(n10, r10);
  var a10 = o10 < 0 ? -1 : 1;
  var i10 = qe(o10 / 7);
  var s10 = 5 * i10;
  for (r10 = Xe(r10, 7 * i10); !Bt(n10, r10); ) s10 += et(r10) ? 0 : a10, r10 = Xe(r10, a10);
  return 0 === s10 ? 0 : s10;
}, differenceInCalendarDays: gt, differenceInCalendarISOWeekYears: Wt, differenceInCalendarISOWeeks: function(e14, t10) {
  Ye(2, arguments);
  var n10 = ut(e14);
  var r10 = ut(t10);
  var o10 = n10.getTime() - mt(n10);
  var a10 = r10.getTime() - mt(r10);
  return Math.round((o10 - a10) / 6048e5);
}, differenceInCalendarMonths: jt, differenceInCalendarQuarters: Gt, differenceInCalendarWeeks: qt, differenceInCalendarYears: Yt, differenceInDays: Xt, differenceInHours: nn, differenceInISOWeekYears: function(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = Ke(t10);
  var o10 = Mt(n10, r10);
  var a10 = Math.abs(Wt(n10, r10));
  n10 = rn(n10, o10 * a10);
  var i10 = o10 * (a10 - Number(Mt(n10, r10) === -o10));
  return 0 === i10 ? 0 : i10;
}, differenceInMilliseconds: Jt, differenceInMinutes: on, differenceInMonths: cn, differenceInQuarters: function(e14, t10, n10) {
  Ye(2, arguments);
  var r10 = cn(e14, t10) / 3;
  return tn(null == n10 ? void 0 : n10.roundingMethod)(r10);
}, differenceInSeconds: un, differenceInWeeks: function(e14, t10, n10) {
  Ye(2, arguments);
  var r10 = Xt(e14, t10) / 7;
  return tn(null == n10 ? void 0 : n10.roundingMethod)(r10);
}, differenceInYears: dn, eachDayOfInterval: pn, eachHourOfInterval: function(e14, t10) {
  var n10;
  Ye(1, arguments);
  var r10 = e14 || {};
  var o10 = Ke(r10.start);
  var a10 = Ke(r10.end);
  var i10 = o10.getTime();
  var s10 = a10.getTime();
  if (!(i10 <= s10)) throw new RangeError("Invalid interval");
  var l10 = [];
  var c10 = o10;
  c10.setMinutes(0, 0, 0);
  var u10 = Number(null !== (n10 = null == t10 ? void 0 : t10.step) && void 0 !== n10 ? n10 : 1);
  if (u10 < 1 || isNaN(u10)) throw new RangeError("`options.step` must be a number greater than 1");
  for (; c10.getTime() <= s10; ) l10.push(Ke(c10)), c10 = it(c10, u10);
  return l10;
}, eachMinuteOfInterval: function(e14, t10) {
  var n10;
  Ye(1, arguments);
  var r10 = mn(Ke(e14.start));
  var o10 = Ke(e14.end);
  var a10 = r10.getTime();
  var i10 = o10.getTime();
  if (a10 >= i10) throw new RangeError("Invalid interval");
  var s10 = [];
  var l10 = r10;
  var c10 = Number(null !== (n10 = null == t10 ? void 0 : t10.step) && void 0 !== n10 ? n10 : 1);
  if (c10 < 1 || isNaN(c10)) throw new RangeError("`options.step` must be a number equal to or greater than 1");
  for (; l10.getTime() <= i10; ) s10.push(Ke(l10)), l10 = St(l10, c10);
  return s10;
}, eachMonthOfInterval: function(e14) {
  Ye(1, arguments);
  var t10 = e14 || {};
  var n10 = Ke(t10.start);
  var r10 = Ke(t10.end).getTime();
  var o10 = [];
  if (!(n10.getTime() <= r10)) throw new RangeError("Invalid interval");
  var a10 = n10;
  for (a10.setHours(0, 0, 0, 0), a10.setDate(1); a10.getTime() <= r10; ) o10.push(Ke(a10)), a10.setMonth(a10.getMonth() + 1);
  return o10;
}, eachQuarterOfInterval: function(e14) {
  Ye(1, arguments);
  var t10 = e14 || {};
  var n10 = Ke(t10.start);
  var r10 = Ke(t10.end);
  var o10 = r10.getTime();
  if (!(n10.getTime() <= o10)) throw new RangeError("Invalid interval");
  var a10 = hn(n10);
  o10 = hn(r10).getTime();
  var i10 = [];
  var s10 = a10;
  for (; s10.getTime() <= o10; ) i10.push(Ke(s10)), s10 = Ct(s10, 1);
  return i10;
}, eachWeekOfInterval: function(e14, t10) {
  Ye(1, arguments);
  var n10 = e14 || {};
  var r10 = Ke(n10.start);
  var o10 = Ke(n10.end);
  var a10 = o10.getTime();
  if (!(r10.getTime() <= a10)) throw new RangeError("Invalid interval");
  var i10 = ct(r10, t10);
  var s10 = ct(o10, t10);
  i10.setHours(15), s10.setHours(15), a10 = s10.getTime();
  var l10 = [];
  var c10 = i10;
  for (; c10.getTime() <= a10; ) c10.setHours(0), l10.push(Ke(c10)), (c10 = wt(c10, 1)).setHours(15);
  return l10;
}, eachWeekendOfInterval: fn, eachWeekendOfMonth: function(e14) {
  Ye(1, arguments);
  var t10 = gn(e14);
  if (isNaN(t10.getTime())) throw new RangeError("The passed date is invalid");
  return fn({ start: t10, end: sn(e14) });
}, eachWeekendOfYear: function(e14) {
  return Ye(1, arguments), fn({ start: vn(e14), end: yn(e14) });
}, eachYearOfInterval: function(e14) {
  Ye(1, arguments);
  var t10 = e14 || {};
  var n10 = Ke(t10.start);
  var r10 = Ke(t10.end).getTime();
  if (!(n10.getTime() <= r10)) throw new RangeError("Invalid interval");
  var o10 = [];
  var a10 = n10;
  for (a10.setHours(0, 0, 0, 0), a10.setMonth(0, 1); a10.getTime() <= r10; ) o10.push(Ke(a10)), a10.setFullYear(a10.getFullYear() + 1);
  return o10;
}, endOfDay: an, endOfDecade: function(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  var n10 = t10.getFullYear();
  var r10 = 9 + 10 * Math.floor(n10 / 10);
  return t10.setFullYear(r10, 11, 31), t10.setHours(23, 59, 59, 999), t10;
}, endOfHour: function(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  return t10.setMinutes(59, 59, 999), t10;
}, endOfISOWeek: function(e14) {
  return Ye(1, arguments), bn(e14, { weekStartsOn: 1 });
}, endOfISOWeekYear: function(e14) {
  Ye(1, arguments);
  var t10 = dt(e14);
  var n10 = /* @__PURE__ */ new Date(0);
  n10.setFullYear(t10 + 1, 0, 4), n10.setHours(0, 0, 0, 0);
  var r10 = ut(n10);
  return r10.setMilliseconds(r10.getMilliseconds() - 1), r10;
}, endOfMinute: function(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  return t10.setSeconds(59, 999), t10;
}, endOfMonth: sn, endOfQuarter: function(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  var n10 = t10.getMonth();
  var r10 = n10 - n10 % 3 + 3;
  return t10.setMonth(r10, 0), t10.setHours(23, 59, 59, 999), t10;
}, endOfSecond: function(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  return t10.setMilliseconds(999), t10;
}, endOfToday: function() {
  return an(Date.now());
}, endOfTomorrow: function() {
  var e14 = /* @__PURE__ */ new Date();
  var t10 = e14.getFullYear();
  var n10 = e14.getMonth();
  var r10 = e14.getDate();
  var o10 = /* @__PURE__ */ new Date(0);
  return o10.setFullYear(t10, n10, r10 + 1), o10.setHours(23, 59, 59, 999), o10;
}, endOfWeek: bn, endOfYear: yn, endOfYesterday: function() {
  var e14 = /* @__PURE__ */ new Date();
  var t10 = e14.getFullYear();
  var n10 = e14.getMonth();
  var r10 = e14.getDate();
  var o10 = /* @__PURE__ */ new Date(0);
  return o10.setFullYear(t10, n10, r10 - 1), o10.setHours(23, 59, 59, 999), o10;
}, format: gr, formatDistance: wr, formatDistanceStrict: kr, formatDistanceToNow: function(e14, t10) {
  return Ye(1, arguments), wr(e14, Date.now(), t10);
}, formatDistanceToNowStrict: function(e14, t10) {
  return Ye(1, arguments), kr(e14, Date.now(), t10);
}, formatDuration: function(e14, t10) {
  var n10, r10, o10, a10, i10;
  if (arguments.length < 1) throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
  var s10 = lt();
  var l10 = null !== (n10 = null !== (r10 = null == t10 ? void 0 : t10.locale) && void 0 !== r10 ? r10 : s10.locale) && void 0 !== n10 ? n10 : ur;
  var c10 = null !== (o10 = null == t10 ? void 0 : t10.format) && void 0 !== o10 ? o10 : Pr;
  var u10 = null !== (a10 = null == t10 ? void 0 : t10.zero) && void 0 !== a10 && a10;
  var d10 = null !== (i10 = null == t10 ? void 0 : t10.delimiter) && void 0 !== i10 ? i10 : " ";
  if (!l10.formatDistance) return "";
  var p10 = c10.reduce(function(t11, n11) {
    var r11 = "x".concat(n11.replace(/(^.)/, function(e15) {
      return e15.toUpperCase();
    }));
    var o11 = e14[n11];
    return "number" == typeof o11 && (u10 || e14[n11]) ? t11.concat(l10.formatDistance(r11, o11)) : t11;
  }, []).join(d10);
  return p10;
}, formatISO: function(e14, t10) {
  var n10, r10;
  Ye(1, arguments);
  var o10 = Ke(e14);
  if (isNaN(o10.getTime())) throw new RangeError("Invalid time value");
  var a10 = String(null !== (n10 = null == t10 ? void 0 : t10.format) && void 0 !== n10 ? n10 : "extended");
  var i10 = String(null !== (r10 = null == t10 ? void 0 : t10.representation) && void 0 !== r10 ? r10 : "complete");
  if ("extended" !== a10 && "basic" !== a10) throw new RangeError("format must be 'extended' or 'basic'");
  if ("date" !== i10 && "time" !== i10 && "complete" !== i10) throw new RangeError("representation must be 'date', 'time', or 'complete'");
  var s10 = "";
  var l10 = "";
  var c10 = "extended" === a10 ? "-" : "";
  var u10 = "extended" === a10 ? ":" : "";
  if ("time" !== i10) {
    var d10 = Pn(o10.getDate(), 2);
    var p10 = Pn(o10.getMonth() + 1, 2);
    var m10 = Pn(o10.getFullYear(), 4);
    s10 = "".concat(m10).concat(c10).concat(p10).concat(c10).concat(d10);
  }
  if ("date" !== i10) {
    var h10 = o10.getTimezoneOffset();
    if (0 !== h10) {
      var f10 = Math.abs(h10);
      var g10 = Pn(Math.floor(f10 / 60), 2);
      var y10 = Pn(f10 % 60, 2);
      l10 = "".concat(h10 < 0 ? "+" : "-").concat(g10, ":").concat(y10);
    } else l10 = "Z";
    var v10 = "" === s10 ? "" : "T";
    var b10 = [Pn(o10.getHours(), 2), Pn(o10.getMinutes(), 2), Pn(o10.getSeconds(), 2)].join(u10);
    s10 = "".concat(s10).concat(v10).concat(b10).concat(l10);
  }
  return s10;
}, formatISO9075: function(e14, t10) {
  var n10, r10;
  if (arguments.length < 1) throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
  var o10 = Ke(e14);
  if (!$t(o10)) throw new RangeError("Invalid time value");
  var a10 = String(null !== (n10 = null == t10 ? void 0 : t10.format) && void 0 !== n10 ? n10 : "extended");
  var i10 = String(null !== (r10 = null == t10 ? void 0 : t10.representation) && void 0 !== r10 ? r10 : "complete");
  if ("extended" !== a10 && "basic" !== a10) throw new RangeError("format must be 'extended' or 'basic'");
  if ("date" !== i10 && "time" !== i10 && "complete" !== i10) throw new RangeError("representation must be 'date', 'time', or 'complete'");
  var s10 = "";
  var l10 = "extended" === a10 ? "-" : "";
  var c10 = "extended" === a10 ? ":" : "";
  if ("time" !== i10) {
    var u10 = Pn(o10.getDate(), 2);
    var d10 = Pn(o10.getMonth() + 1, 2);
    var p10 = Pn(o10.getFullYear(), 4);
    s10 = "".concat(p10).concat(l10).concat(d10).concat(l10).concat(u10);
  }
  if ("date" !== i10) {
    var m10 = Pn(o10.getHours(), 2);
    var h10 = Pn(o10.getMinutes(), 2);
    var f10 = Pn(o10.getSeconds(), 2);
    var g10 = "" === s10 ? "" : " ";
    s10 = "".concat(s10).concat(g10).concat(m10).concat(c10).concat(h10).concat(c10).concat(f10);
  }
  return s10;
}, formatISODuration: function(e14) {
  if (Ye(1, arguments), "object" !== Ue(e14)) throw new Error("Duration must be an object");
  var t10 = e14.years, n10 = void 0 === t10 ? 0 : t10, r10 = e14.months, o10 = void 0 === r10 ? 0 : r10, a10 = e14.days, i10 = void 0 === a10 ? 0 : a10, s10 = e14.hours, l10 = void 0 === s10 ? 0 : s10, c10 = e14.minutes, u10 = void 0 === c10 ? 0 : c10, d10 = e14.seconds, p10 = void 0 === d10 ? 0 : d10;
  return "P".concat(n10, "Y").concat(o10, "M").concat(i10, "DT").concat(l10, "H").concat(u10, "M").concat(p10, "S");
}, formatRFC3339: function(e14, t10) {
  var n10;
  if (arguments.length < 1) throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
  var r10 = Ke(e14);
  if (!$t(r10)) throw new RangeError("Invalid time value");
  var o10 = Number(null !== (n10 = null == t10 ? void 0 : t10.fractionDigits) && void 0 !== n10 ? n10 : 0);
  if (!(o10 >= 0 && o10 <= 3)) throw new RangeError("fractionDigits must be between 0 and 3 inclusively");
  var a10 = Pn(r10.getDate(), 2);
  var i10 = Pn(r10.getMonth() + 1, 2);
  var s10 = r10.getFullYear();
  var l10 = Pn(r10.getHours(), 2);
  var c10 = Pn(r10.getMinutes(), 2);
  var u10 = Pn(r10.getSeconds(), 2);
  var d10 = "";
  if (o10 > 0) {
    var p10 = r10.getMilliseconds();
    d10 = "." + Pn(Math.floor(p10 * Math.pow(10, o10 - 3)), o10);
  }
  var m10 = "";
  var h10 = r10.getTimezoneOffset();
  if (0 !== h10) {
    var f10 = Math.abs(h10);
    var g10 = Pn(qe(f10 / 60), 2);
    var y10 = Pn(f10 % 60, 2);
    m10 = "".concat(h10 < 0 ? "+" : "-").concat(g10, ":").concat(y10);
  } else m10 = "Z";
  return "".concat(s10, "-").concat(i10, "-").concat(a10, "T").concat(l10, ":").concat(c10, ":").concat(u10).concat(d10).concat(m10);
}, formatRFC7231: function(e14) {
  if (arguments.length < 1) throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
  var t10 = Ke(e14);
  if (!$t(t10)) throw new RangeError("Invalid time value");
  var n10 = Nr[t10.getUTCDay()];
  var r10 = Pn(t10.getUTCDate(), 2);
  var o10 = Dr[t10.getUTCMonth()];
  var a10 = t10.getUTCFullYear();
  var i10 = Pn(t10.getUTCHours(), 2);
  var s10 = Pn(t10.getUTCMinutes(), 2);
  var l10 = Pn(t10.getUTCSeconds(), 2);
  return "".concat(n10, ", ").concat(r10, " ").concat(o10, " ").concat(a10, " ").concat(i10, ":").concat(s10, ":").concat(l10, " GMT");
}, formatRelative: function(e14, t10, n10) {
  var r10, o10, a10, i10, s10, l10, c10, u10, d10, p10;
  Ye(2, arguments);
  var m10 = Ke(e14);
  var h10 = Ke(t10);
  var f10 = lt();
  var g10 = null !== (r10 = null !== (o10 = null == n10 ? void 0 : n10.locale) && void 0 !== o10 ? o10 : f10.locale) && void 0 !== r10 ? r10 : ur;
  var y10 = qe(null !== (a10 = null !== (i10 = null !== (s10 = null !== (l10 = null == n10 ? void 0 : n10.weekStartsOn) && void 0 !== l10 ? l10 : null == n10 || null === (c10 = n10.locale) || void 0 === c10 || null === (u10 = c10.options) || void 0 === u10 ? void 0 : u10.weekStartsOn) && void 0 !== s10 ? s10 : f10.weekStartsOn) && void 0 !== i10 ? i10 : null === (d10 = f10.locale) || void 0 === d10 || null === (p10 = d10.options) || void 0 === p10 ? void 0 : p10.weekStartsOn) && void 0 !== a10 ? a10 : 0);
  if (!g10.localize) throw new RangeError("locale must contain localize property");
  if (!g10.formatLong) throw new RangeError("locale must contain formatLong property");
  if (!g10.formatRelative) throw new RangeError("locale must contain formatRelative property");
  var v10 = gt(m10, h10);
  if (isNaN(v10)) throw new RangeError("Invalid time value");
  var b10;
  b10 = v10 < -6 ? "other" : v10 < -1 ? "lastWeek" : v10 < 0 ? "yesterday" : v10 < 1 ? "today" : v10 < 2 ? "tomorrow" : v10 < 7 ? "nextWeek" : "other";
  var S10 = Sn(m10, mt(m10));
  var C10 = Sn(h10, mt(h10));
  return gr(m10, g10.formatRelative(b10, S10, C10, { locale: g10, weekStartsOn: y10 }), { locale: g10, weekStartsOn: y10 });
}, fromUnixTime: function(e14) {
  return Ye(1, arguments), Ke(1e3 * qe(e14));
}, getDate: Lr, getDay: Hr, getDayOfYear: function(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  return gt(t10, vn(t10)) + 1;
}, getDaysInMonth: Ir, getDaysInYear: function(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  return "Invalid Date" === String(new Date(t10)) ? NaN : _r(t10) ? 366 : 365;
}, getDecade: function(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14).getFullYear();
  return 10 * Math.floor(t10 / 10);
}, getDefaultOptions: function() {
  return yr({}, lt());
}, getHours: function(e14) {
  return Ye(1, arguments), Ke(e14).getHours();
}, getISODay: Vr, getISOWeek: Ar, getISOWeekYear: dt, getISOWeeksInYear: function(e14) {
  Ye(1, arguments);
  var t10 = pt(e14);
  var n10 = pt(wt(t10, 60)).valueOf() - t10.valueOf();
  return Math.round(n10 / 6048e5);
}, getMilliseconds: function(e14) {
  return Ye(1, arguments), Ke(e14).getMilliseconds();
}, getMinutes: function(e14) {
  return Ye(1, arguments), Ke(e14).getMinutes();
}, getMonth: function(e14) {
  return Ye(1, arguments), Ke(e14).getMonth();
}, getOverlappingDaysInIntervals: function(e14, t10) {
  Ye(2, arguments);
  var n10 = e14 || {};
  var r10 = t10 || {};
  var o10 = Ke(n10.start).getTime();
  var a10 = Ke(n10.end).getTime();
  var i10 = Ke(r10.start).getTime();
  var s10 = Ke(r10.end).getTime();
  if (!(o10 <= a10 && i10 <= s10)) throw new RangeError("Invalid interval");
  if (!(o10 < s10 && i10 < a10)) return 0;
  var l10 = (s10 > a10 ? a10 : s10) - (i10 < o10 ? o10 : i10);
  return Math.ceil(l10 / 864e5);
}, getQuarter: Zt, getSeconds: function(e14) {
  return Ye(1, arguments), Ke(e14).getSeconds();
}, getTime: Or, getUnixTime: function(e14) {
  return Ye(1, arguments), Math.floor(Or(e14) / 1e3);
}, getWeek: Wr, getWeekOfMonth: function(e14, t10) {
  var n10, r10, o10, a10, i10, s10, l10, c10;
  Ye(1, arguments);
  var u10 = lt();
  var d10 = qe(null !== (n10 = null !== (r10 = null !== (o10 = null !== (a10 = null == t10 ? void 0 : t10.weekStartsOn) && void 0 !== a10 ? a10 : null == t10 || null === (i10 = t10.locale) || void 0 === i10 || null === (s10 = i10.options) || void 0 === s10 ? void 0 : s10.weekStartsOn) && void 0 !== o10 ? o10 : u10.weekStartsOn) && void 0 !== r10 ? r10 : null === (l10 = u10.locale) || void 0 === l10 || null === (c10 = l10.options) || void 0 === c10 ? void 0 : c10.weekStartsOn) && void 0 !== n10 ? n10 : 0);
  if (!(d10 >= 0 && d10 <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p10 = Lr(e14);
  if (isNaN(p10)) return NaN;
  var m10 = d10 - Hr(gn(e14));
  m10 <= 0 && (m10 += 7);
  var h10 = p10 - m10;
  return Math.ceil(h10 / 7) + 1;
}, getWeekYear: Br, getWeeksInMonth: function(e14, t10) {
  return Ye(1, arguments), qt(jr(e14), gn(e14), t10) + 1;
}, getYear: function(e14) {
  return Ye(1, arguments), Ke(e14).getFullYear();
}, hoursToMilliseconds: function(e14) {
  return Ye(1, arguments), Math.floor(e14 * Dt);
}, hoursToMinutes: function(e14) {
  return Ye(1, arguments), Math.floor(60 * e14);
}, hoursToSeconds: function(e14) {
  return Ye(1, arguments), Math.floor(e14 * It);
}, intervalToDuration: function(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14.start);
  var n10 = Ke(e14.end);
  if (isNaN(t10.getTime())) throw new RangeError("Start Date is invalid");
  if (isNaN(n10.getTime())) throw new RangeError("End Date is invalid");
  var r10 = {};
  r10.years = Math.abs(dn(n10, t10));
  var o10 = Mt(n10, t10);
  var a10 = Qe(t10, { years: o10 * r10.years });
  r10.months = Math.abs(cn(n10, a10));
  var i10 = Qe(a10, { months: o10 * r10.months });
  r10.days = Math.abs(Xt(n10, i10));
  var s10 = Qe(i10, { days: o10 * r10.days });
  r10.hours = Math.abs(nn(n10, s10));
  var l10 = Qe(s10, { hours: o10 * r10.hours });
  r10.minutes = Math.abs(on(n10, l10));
  var c10 = Qe(l10, { minutes: o10 * r10.minutes });
  return r10.seconds = Math.abs(un(n10, c10)), r10;
}, intlFormat: function(e14, t10, n10) {
  var r10;
  var o10;
  var a10;
  return Ye(1, arguments), void 0 === (a10 = t10) || "locale" in a10 ? n10 = t10 : o10 = t10, new Intl.DateTimeFormat(null === (r10 = n10) || void 0 === r10 ? void 0 : r10.locale, o10).format(e14);
}, intlFormatDistance: function(e14, t10, n10) {
  Ye(2, arguments);
  var r10 = 0;
  var o10;
  var a10 = Ke(e14);
  var i10 = Ke(t10);
  if (null != n10 && n10.unit) "second" === (o10 = null == n10 ? void 0 : n10.unit) ? r10 = un(a10, i10) : "minute" === o10 ? r10 = on(a10, i10) : "hour" === o10 ? r10 = nn(a10, i10) : "day" === o10 ? r10 = gt(a10, i10) : "week" === o10 ? r10 = qt(a10, i10) : "month" === o10 ? r10 = jt(a10, i10) : "quarter" === o10 ? r10 = Gt(a10, i10) : "year" === o10 && (r10 = Yt(a10, i10));
  else {
    var s10 = un(a10, i10);
    Math.abs(s10) < 60 ? (r10 = un(a10, i10), o10 = "second") : Math.abs(s10) < It ? (r10 = on(a10, i10), o10 = "minute") : Math.abs(s10) < _t && Math.abs(gt(a10, i10)) < 1 ? (r10 = nn(a10, i10), o10 = "hour") : Math.abs(s10) < Vt && (r10 = gt(a10, i10)) && Math.abs(r10) < 7 ? o10 = "day" : Math.abs(s10) < At ? (r10 = qt(a10, i10), o10 = "week") : Math.abs(s10) < Ot ? (r10 = jt(a10, i10), o10 = "month") : Math.abs(s10) < Rt && Gt(a10, i10) < 4 ? (r10 = Gt(a10, i10), o10 = "quarter") : (r10 = Yt(a10, i10), o10 = "year");
  }
  return new Intl.RelativeTimeFormat(null == n10 ? void 0 : n10.locale, { localeMatcher: null == n10 ? void 0 : n10.localeMatcher, numeric: (null == n10 ? void 0 : n10.numeric) || "auto", style: null == n10 ? void 0 : n10.style }).format(r10, o10);
}, isAfter: function(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = Ke(t10);
  return n10.getTime() > r10.getTime();
}, isBefore: function(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = Ke(t10);
  return n10.getTime() < r10.getTime();
}, isDate: zt, isEqual: function(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = Ke(t10);
  return n10.getTime() === r10.getTime();
}, isExists: function(e14, t10, n10) {
  if (arguments.length < 3) throw new TypeError("3 argument required, but only " + arguments.length + " present");
  var r10 = new Date(e14, t10, n10);
  return r10.getFullYear() === e14 && r10.getMonth() === t10 && r10.getDate() === n10;
}, isFirstDayOfMonth: function(e14) {
  return Ye(1, arguments), 1 === Ke(e14).getDate();
}, isFriday: function(e14) {
  return Ye(1, arguments), 5 === Ke(e14).getDay();
}, isFuture: function(e14) {
  return Ye(1, arguments), Ke(e14).getTime() > Date.now();
}, isLastDayOfMonth: ln, isLeapYear: _r, isMatch: function(e14, t10, n10) {
  return Ye(2, arguments), $t(Da(e14, t10, /* @__PURE__ */ new Date(), n10));
}, isMonday: function(e14) {
  return Ye(1, arguments), 1 === Ke(e14).getDay();
}, isPast: function(e14) {
  return Ye(1, arguments), Ke(e14).getTime() < Date.now();
}, isSameDay: Bt, isSameHour: Ha, isSameISOWeek: _a, isSameISOWeekYear: function(e14, t10) {
  Ye(2, arguments);
  var n10 = pt(e14);
  var r10 = pt(t10);
  return n10.getTime() === r10.getTime();
}, isSameMinute: Va, isSameMonth: Ra, isSameQuarter: Aa, isSameSecond: Ba, isSameWeek: Ia, isSameYear: za, isSaturday: nt, isSunday: tt, isThisHour: function(e14) {
  return Ye(1, arguments), Ha(Date.now(), e14);
}, isThisISOWeek: function(e14) {
  return Ye(1, arguments), _a(e14, Date.now());
}, isThisMinute: function(e14) {
  return Ye(1, arguments), Va(Date.now(), e14);
}, isThisMonth: function(e14) {
  return Ye(1, arguments), Ra(Date.now(), e14);
}, isThisQuarter: function(e14) {
  return Ye(1, arguments), Aa(Date.now(), e14);
}, isThisSecond: function(e14) {
  return Ye(1, arguments), Ba(Date.now(), e14);
}, isThisWeek: function(e14, t10) {
  return Ye(1, arguments), Ia(e14, Date.now(), t10);
}, isThisYear: function(e14) {
  return Ye(1, arguments), za(e14, Date.now());
}, isThursday: function(e14) {
  return Ye(1, arguments), 4 === Ke(e14).getDay();
}, isToday: function(e14) {
  return Ye(1, arguments), Bt(e14, Date.now());
}, isTomorrow: function(e14) {
  return Ye(1, arguments), Bt(e14, Xe(Date.now(), 1));
}, isTuesday: function(e14) {
  return Ye(1, arguments), 2 === Ke(e14).getDay();
}, isValid: $t, isWednesday: function(e14) {
  return Ye(1, arguments), 3 === Ke(e14).getDay();
}, isWeekend: et, isWithinInterval: function(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14).getTime();
  var r10 = Ke(t10.start).getTime();
  var o10 = Ke(t10.end).getTime();
  if (!(r10 <= o10)) throw new RangeError("Invalid interval");
  return n10 >= r10 && n10 <= o10;
}, isYesterday: function(e14) {
  return Ye(1, arguments), Bt(e14, $a(Date.now(), 1));
}, lastDayOfDecade: function(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  var n10 = t10.getFullYear();
  var r10 = 9 + 10 * Math.floor(n10 / 10);
  return t10.setFullYear(r10 + 1, 0, 0), t10.setHours(0, 0, 0, 0), t10;
}, lastDayOfISOWeek: function(e14) {
  return Ye(1, arguments), Wa(e14, { weekStartsOn: 1 });
}, lastDayOfISOWeekYear: function(e14) {
  Ye(1, arguments);
  var t10 = dt(e14);
  var n10 = /* @__PURE__ */ new Date(0);
  n10.setFullYear(t10 + 1, 0, 4), n10.setHours(0, 0, 0, 0);
  var r10 = ut(n10);
  return r10.setDate(r10.getDate() - 1), r10;
}, lastDayOfMonth: jr, lastDayOfQuarter: function(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  var n10 = t10.getMonth();
  var r10 = n10 - n10 % 3 + 3;
  return t10.setMonth(r10, 0), t10.setHours(0, 0, 0, 0), t10;
}, lastDayOfWeek: Wa, lastDayOfYear: function(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  var n10 = t10.getFullYear();
  return t10.setFullYear(n10 + 1, 0, 0), t10.setHours(0, 0, 0, 0), t10;
}, lightFormat: function(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  if (!$t(n10)) throw new RangeError("Invalid time value");
  var r10 = Sn(n10, mt(n10));
  var o10 = t10.match(ja);
  if (!o10) return "";
  var a10 = o10.map(function(e15) {
    if ("''" === e15) return "'";
    var t11 = e15[0];
    if ("'" === t11) return function(e16) {
      var t12 = e16.match(Za);
      if (!t12) return e16;
      return t12[1].replace(Ga, "'");
    }(e15);
    var n11 = Dn[t11];
    if (n11) return n11(r10, e15);
    if (t11.match(Ua)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + t11 + "`");
    return e15;
  }).join("");
  return a10;
}, max: Et, milliseconds: function(e14) {
  var t10 = e14.years, n10 = e14.months, r10 = e14.weeks, o10 = e14.days, a10 = e14.hours, i10 = e14.minutes, s10 = e14.seconds;
  Ye(1, arguments);
  var l10 = 0;
  t10 && (l10 += t10 * qa), n10 && (l10 += 30.436875 * n10), r10 && (l10 += 7 * r10), o10 && (l10 += o10);
  var c10 = 24 * l10 * 60 * 60;
  return a10 && (c10 += 60 * a10 * 60), i10 && (c10 += 60 * i10), s10 && (c10 += s10), Math.round(1e3 * c10);
}, millisecondsToHours: function(e14) {
  Ye(1, arguments);
  var t10 = e14 / Dt;
  return Math.floor(t10);
}, millisecondsToMinutes: function(e14) {
  Ye(1, arguments);
  var t10 = e14 / Nt;
  return Math.floor(t10);
}, millisecondsToSeconds: function(e14) {
  Ye(1, arguments);
  var t10 = e14 / Lt;
  return Math.floor(t10);
}, min: Ft, minutesToHours: function(e14) {
  Ye(1, arguments);
  var t10 = e14 / 60;
  return Math.floor(t10);
}, minutesToMilliseconds: function(e14) {
  return Ye(1, arguments), Math.floor(e14 * Nt);
}, minutesToSeconds: function(e14) {
  return Ye(1, arguments), Math.floor(60 * e14);
}, monthsToQuarters: function(e14) {
  Ye(1, arguments);
  var t10 = e14 / 3;
  return Math.floor(t10);
}, monthsToYears: function(e14) {
  Ye(1, arguments);
  var t10 = e14 / 12;
  return Math.floor(t10);
}, nextDay: Ya, nextFriday: function(e14) {
  return Ye(1, arguments), Ya(e14, 5);
}, nextMonday: function(e14) {
  return Ye(1, arguments), Ya(e14, 1);
}, nextSaturday: function(e14) {
  return Ye(1, arguments), Ya(e14, 6);
}, nextSunday: function(e14) {
  return Ye(1, arguments), Ya(e14, 0);
}, nextThursday: function(e14) {
  return Ye(1, arguments), Ya(e14, 4);
}, nextTuesday: function(e14) {
  return Ye(1, arguments), Ya(e14, 2);
}, nextWednesday: function(e14) {
  return Ye(1, arguments), Ya(e14, 3);
}, parse: Da, parseISO: Ka, parseJSON: function(e14) {
  if (Ye(1, arguments), "string" == typeof e14) {
    var t10 = e14.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
    return t10 ? new Date(Date.UTC(+t10[1], +t10[2] - 1, +t10[3], +t10[4] - (+t10[9] || 0) * ("-" == t10[8] ? -1 : 1), +t10[5] - (+t10[10] || 0) * ("-" == t10[8] ? -1 : 1), +t10[6], +((t10[7] || "0") + "00").substring(0, 3))) : /* @__PURE__ */ new Date(NaN);
  }
  return Ke(e14);
}, previousDay: ai, previousFriday: function(e14) {
  return Ye(1, arguments), ai(e14, 5);
}, previousMonday: function(e14) {
  return Ye(1, arguments), ai(e14, 1);
}, previousSaturday: function(e14) {
  return Ye(1, arguments), ai(e14, 6);
}, previousSunday: function(e14) {
  return Ye(1, arguments), ai(e14, 0);
}, previousThursday: function(e14) {
  return Ye(1, arguments), ai(e14, 4);
}, previousTuesday: function(e14) {
  return Ye(1, arguments), ai(e14, 2);
}, previousWednesday: function(e14) {
  return Ye(1, arguments), ai(e14, 3);
}, quartersToMonths: function(e14) {
  return Ye(1, arguments), Math.floor(3 * e14);
}, quartersToYears: function(e14) {
  Ye(1, arguments);
  var t10 = e14 / 4;
  return Math.floor(t10);
}, roundToNearestMinutes: function(e14, t10) {
  var n10;
  if (arguments.length < 1) throw new TypeError("1 argument required, but only none provided present");
  var r10 = qe(null !== (n10 = null == t10 ? void 0 : t10.nearestTo) && void 0 !== n10 ? n10 : 1);
  if (r10 < 1 || r10 > 30) throw new RangeError("`options.nearestTo` must be between 1 and 30");
  var o10 = Ke(e14);
  var a10 = o10.getSeconds();
  var i10 = o10.getMinutes() + a10 / 60;
  var s10 = tn(null == t10 ? void 0 : t10.roundingMethod)(i10 / r10) * r10;
  var l10 = i10 % r10;
  var c10 = Math.round(l10 / r10) * r10;
  return new Date(o10.getFullYear(), o10.getMonth(), o10.getDate(), o10.getHours(), s10 + c10);
}, secondsToHours: function(e14) {
  Ye(1, arguments);
  var t10 = e14 / It;
  return Math.floor(t10);
}, secondsToMilliseconds: function(e14) {
  return Ye(1, arguments), e14 * Lt;
}, secondsToMinutes: function(e14) {
  Ye(1, arguments);
  var t10 = e14 / 60;
  return Math.floor(t10);
}, set: function(e14, t10) {
  if (Ye(2, arguments), "object" !== Ue(t10) || null === t10) throw new RangeError("values parameter must be an object");
  var n10 = Ke(e14);
  return isNaN(n10.getTime()) ? /* @__PURE__ */ new Date(NaN) : (null != t10.year && n10.setFullYear(t10.year), null != t10.month && (n10 = ii(n10, t10.month)), null != t10.date && n10.setDate(qe(t10.date)), null != t10.hours && n10.setHours(qe(t10.hours)), null != t10.minutes && n10.setMinutes(qe(t10.minutes)), null != t10.seconds && n10.setSeconds(qe(t10.seconds)), null != t10.milliseconds && n10.setMilliseconds(qe(t10.milliseconds)), n10);
}, setDate: function(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = qe(t10);
  return n10.setDate(r10), n10;
}, setDay: function(e14, t10, n10) {
  var r10, o10, a10, i10, s10, l10, c10, u10;
  Ye(2, arguments);
  var d10 = lt();
  var p10 = qe(null !== (r10 = null !== (o10 = null !== (a10 = null !== (i10 = null == n10 ? void 0 : n10.weekStartsOn) && void 0 !== i10 ? i10 : null == n10 || null === (s10 = n10.locale) || void 0 === s10 || null === (l10 = s10.options) || void 0 === l10 ? void 0 : l10.weekStartsOn) && void 0 !== a10 ? a10 : d10.weekStartsOn) && void 0 !== o10 ? o10 : null === (c10 = d10.locale) || void 0 === c10 || null === (u10 = c10.options) || void 0 === u10 ? void 0 : u10.weekStartsOn) && void 0 !== r10 ? r10 : 0);
  if (!(p10 >= 0 && p10 <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var m10 = Ke(e14);
  var h10 = qe(t10);
  var f10 = m10.getDay();
  var g10 = 7 - p10;
  return Xe(m10, h10 < 0 || h10 > 6 ? h10 - (f10 + g10) % 7 : ((h10 % 7 + 7) % 7 + g10) % 7 - (f10 + g10) % 7);
}, setDayOfYear: function(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = qe(t10);
  return n10.setMonth(0), n10.setDate(r10), n10;
}, setDefaultOptions: function(e14) {
  Ye(1, arguments);
  var t10 = {};
  var n10 = lt();
  for (var r10 in n10) Object.prototype.hasOwnProperty.call(n10, r10) && (t10[r10] = n10[r10]);
  for (var o10 in e14) Object.prototype.hasOwnProperty.call(e14, o10) && (void 0 === e14[o10] ? delete t10[o10] : t10[o10] = e14[o10]);
  !function(e15) {
    st = e15;
  }(t10);
}, setHours: function(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = qe(t10);
  return n10.setHours(r10), n10;
}, setISODay: function(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  return Xe(n10, qe(t10) - Vr(n10));
}, setISOWeek: function(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = qe(t10);
  var o10 = Ar(n10) - r10;
  return n10.setDate(n10.getDate() - 7 * o10), n10;
}, setISOWeekYear: yt, setMilliseconds: function(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = qe(t10);
  return n10.setMilliseconds(r10), n10;
}, setMinutes: function(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = qe(t10);
  return n10.setMinutes(r10), n10;
}, setMonth: ii, setQuarter: function(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = qe(t10) - (Math.floor(n10.getMonth() / 3) + 1);
  return ii(n10, n10.getMonth() + 3 * r10);
}, setSeconds: function(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = qe(t10);
  return n10.setSeconds(r10), n10;
}, setWeek: function(e14, t10, n10) {
  Ye(2, arguments);
  var r10 = Ke(e14);
  var o10 = qe(t10);
  var a10 = Wr(r10, n10) - o10;
  return r10.setDate(r10.getDate() - 7 * a10), r10;
}, setWeekYear: function(e14, t10, n10) {
  var r10, o10, a10, i10, s10, l10, c10, u10;
  Ye(2, arguments);
  var d10 = lt();
  var p10 = qe(null !== (r10 = null !== (o10 = null !== (a10 = null !== (i10 = null == n10 ? void 0 : n10.firstWeekContainsDate) && void 0 !== i10 ? i10 : null == n10 || null === (s10 = n10.locale) || void 0 === s10 || null === (l10 = s10.options) || void 0 === l10 ? void 0 : l10.firstWeekContainsDate) && void 0 !== a10 ? a10 : d10.firstWeekContainsDate) && void 0 !== o10 ? o10 : null === (c10 = d10.locale) || void 0 === c10 || null === (u10 = c10.options) || void 0 === u10 ? void 0 : u10.firstWeekContainsDate) && void 0 !== r10 ? r10 : 1);
  var m10 = Ke(e14);
  var h10 = qe(t10);
  var f10 = gt(m10, zr(m10, n10));
  var g10 = /* @__PURE__ */ new Date(0);
  return g10.setFullYear(h10, 0, p10), g10.setHours(0, 0, 0, 0), (m10 = zr(g10, n10)).setDate(m10.getDate() + f10), m10;
}, setYear: function(e14, t10) {
  Ye(2, arguments);
  var n10 = Ke(e14);
  var r10 = qe(t10);
  return isNaN(n10.getTime()) ? /* @__PURE__ */ new Date(NaN) : (n10.setFullYear(r10), n10);
}, startOfDay: ht, startOfDecade: function(e14) {
  Ye(1, arguments);
  var t10 = Ke(e14);
  var n10 = t10.getFullYear();
  var r10 = 10 * Math.floor(n10 / 10);
  return t10.setFullYear(r10, 0, 1), t10.setHours(0, 0, 0, 0), t10;
}, startOfHour: La, startOfISOWeek: ut, startOfISOWeekYear: pt, startOfMinute: mn, startOfMonth: gn, startOfQuarter: hn, startOfSecond: Oa, startOfToday: function() {
  return ht(Date.now());
}, startOfTomorrow: function() {
  var e14 = /* @__PURE__ */ new Date();
  var t10 = e14.getFullYear();
  var n10 = e14.getMonth();
  var r10 = e14.getDate();
  var o10 = /* @__PURE__ */ new Date(0);
  return o10.setFullYear(t10, n10, r10 + 1), o10.setHours(0, 0, 0, 0), o10;
}, startOfWeek: ct, startOfWeekYear: zr, startOfYear: vn, startOfYesterday: function() {
  var e14 = /* @__PURE__ */ new Date();
  var t10 = e14.getFullYear();
  var n10 = e14.getMonth();
  var r10 = e14.getDate();
  var o10 = /* @__PURE__ */ new Date(0);
  return o10.setFullYear(t10, n10, r10 - 1), o10.setHours(0, 0, 0, 0), o10;
}, sub: function(e14, t10) {
  if (Ye(2, arguments), !t10 || "object" !== Ue(t10)) return /* @__PURE__ */ new Date(NaN);
  var n10 = t10.years ? qe(t10.years) : 0;
  var r10 = t10.months ? qe(t10.months) : 0;
  var o10 = t10.weeks ? qe(t10.weeks) : 0;
  var a10 = t10.days ? qe(t10.days) : 0;
  var i10 = t10.hours ? qe(t10.hours) : 0;
  var s10 = t10.minutes ? qe(t10.minutes) : 0;
  var l10 = t10.seconds ? qe(t10.seconds) : 0;
  var c10 = $a(si(e14, r10 + 12 * n10), a10 + 7 * o10);
  var u10 = 1e3 * (l10 + 60 * (s10 + 60 * i10));
  return new Date(c10.getTime() - u10);
}, subBusinessDays: function(e14, t10) {
  return Ye(2, arguments), rt(e14, -qe(t10));
}, subDays: $a, subHours: function(e14, t10) {
  return Ye(2, arguments), it(e14, -qe(t10));
}, subISOWeekYears: rn, subMilliseconds: Sn, subMinutes: function(e14, t10) {
  return Ye(2, arguments), St(e14, -qe(t10));
}, subMonths: si, subQuarters: function(e14, t10) {
  return Ye(2, arguments), Ct(e14, -qe(t10));
}, subSeconds: function(e14, t10) {
  return Ye(2, arguments), xt(e14, -qe(t10));
}, subWeeks: function(e14, t10) {
  return Ye(2, arguments), wt(e14, -qe(t10));
}, subYears: function(e14, t10) {
  return Ye(2, arguments), Tt(e14, -qe(t10));
}, toDate: Ke, weeksToDays: function(e14) {
  return Ye(1, arguments), Math.floor(7 * e14);
}, yearsToMonths: function(e14) {
  return Ye(1, arguments), Math.floor(12 * e14);
}, yearsToQuarters: function(e14) {
  return Ye(1, arguments), Math.floor(4 * e14);
}, daysInWeek: 7, daysInYear: kt, maxTime: Pt, millisecondsInMinute: Nt, millisecondsInHour: Dt, millisecondsInSecond: Lt, minTime: Ht, minutesInHour: 60, monthsInQuarter: 3, monthsInYear: 12, quartersInYear: 4, secondsInHour: It, secondsInMinute: 60, secondsInDay: _t, secondsInWeek: Vt, secondsInYear: Rt, secondsInMonth: At, secondsInQuarter: Ot });
var ci = j(li);
var ui;
function di() {
  if (ui) return We;
  ui = 1, Object.defineProperty(We, "__esModule", { value: true }), We.dateTimeFactory = void 0;
  var e14 = Ae;
  var t10 = Ge();
  var n10 = ci;
  var r10 = function() {
    function e15(e16) {
      this.dt = e16;
    }
    return e15.prototype.format = function(e16) {
      return e16 ? n10.format(this.dt, i10(e16)) : n10.formatISO(this.dt);
    }, e15.prototype.toDate = function() {
      return this.dt;
    }, e15.prototype.clone = function() {
      return new e15(new Date(this.dt));
    }, e15.prototype.valueOf = function() {
      return this.dt.valueOf();
    }, e15.prototype.toISOString = function() {
      return n10.isValid(this.dt) ? this.dt.toISOString() : "";
    }, e15.prototype.isAfter = function(e16) {
      return n10.isAfter(this.dt, e16.dt);
    }, e15.prototype.year = function() {
      return n10.getYear(this.dt);
    }, e15.prototype.month = function() {
      return n10.getMonth(this.dt);
    }, e15.prototype.day = function() {
      return n10.getDay(this.dt);
    }, e15.prototype.quarter = function() {
      return n10.getQuarter(this.dt);
    }, e15.prototype.date = function() {
      return n10.getDate(this.dt);
    }, e15.prototype.hour = function() {
      return n10.getHours(this.dt);
    }, e15.prototype.minute = function() {
      return n10.getMinutes(this.dt);
    }, e15.prototype.second = function() {
      return n10.getSeconds(this.dt);
    }, e15.prototype.startOfDay = function() {
      return new e15(n10.startOfDay(this.dt));
    }, e15.prototype.add = function(t11, r11) {
      switch (r11) {
        case "milliseconds":
          return new e15(n10.addMilliseconds(this.dt, t11));
        case "seconds":
          return new e15(n10.add(this.dt, { seconds: t11 }));
        case "minutes":
          return new e15(n10.add(this.dt, { minutes: t11 }));
        case "hours":
          return new e15(n10.add(this.dt, { hours: t11 }));
        case "days":
          return new e15(n10.add(this.dt, { days: t11 }));
        case "weeks":
          return new e15(n10.add(this.dt, { weeks: t11 }));
        case "months":
          return new e15(n10.add(this.dt, { months: t11 }));
        case "quarters":
          return new e15(n10.addQuarters(this.dt, t11));
        case "years":
          return new e15(n10.add(this.dt, { years: t11 }));
        default:
          throw new Error("add " + r11 + " is not implemented");
      }
    }, e15.prototype.getTime = function() {
      var t11 = new Date(this.dt);
      return t11.setFullYear(1, 0, 1), new e15(t11);
    }, e15.prototype.dateDiff = function(e16, t11, r11) {
      var o11 = t11.dt;
      switch (e16) {
        case "yyyy":
          return n10.differenceInYears(this.dt, o11);
        case "q":
          return n10.differenceInQuarters(this.dt, o11);
        case "m":
          return n10.differenceInMonths(this.dt, o11);
        case "y":
        case "d":
        case "w":
          return n10.differenceInDays(this.dt, o11);
        case "ww":
          return n10.isAfter(o11, this.dt) ? -1 : n10.differenceInCalendarWeeks(this.dt, o11, { weekStartsOn: this.getStartOfWeek(r11) });
        case "h":
          return n10.differenceInHours(this.dt, o11);
        case "n":
          return n10.differenceInMinutes(this.dt, o11);
        case "s":
          return n10.differenceInSeconds(this.dt, o11);
        default:
          throw new Error('"' + e16 + '" is not valid interval value for DateDiff() function');
      }
    }, e15.prototype.datePart = function(e16, t11, r11) {
      switch (e16) {
        case "yyyy":
          return n10.getYear(this.dt);
        case "q":
          return n10.getQuarter(this.dt);
        case "m":
          return n10.getMonth(this.dt) + 1;
        case "y":
          return n10.getDayOfYear(this.dt);
        case "d":
          return n10.getDate(this.dt);
        case "w":
          return n10.differenceInDays(this.dt, n10.startOfWeek(this.dt, { weekStartsOn: this.getStartOfWeek(t11) })) + 1;
        case "ww":
          var o11 = this.getStartOfWeek(t11);
          var a11 = 1;
          return 2 === r11 ? a11 = 4 : 3 === r11 && (a11 = 7), n10.getWeekYear(this.dt, { weekStartsOn: o11, firstWeekContainsDate: a11 }) > n10.getYear(this.dt) ? this.getWeeksInYear(o11) + 1 : n10.getWeek(this.dt, { weekStartsOn: o11, firstWeekContainsDate: a11 });
        case "h":
          return n10.getHours(this.dt);
        case "n":
          return n10.getMinutes(this.dt);
        case "s":
          return n10.getSeconds(this.dt);
        default:
          throw new Error('"' + e16 + '" is not valid interval value for DatePart() function');
      }
    }, e15.prototype.getWeeksInYear = function(e16) {
      return n10.differenceInCalendarWeeks(n10.endOfYear(this.dt), n10.startOfYear(this.dt), { weekStartsOn: e16 });
    }, e15.prototype.getStartOfWeek = function(e16) {
      var t11 = e16 ? e16 - 1 : 0;
      if ([0, 1, 2, 3, 4, 5, 6].includes(t11)) return t11;
      throw new Error("firstDayOfWeek must be integer [1..7]");
    }, e15;
  }();
  function o10(e15) {
    return "object" == typeof e15 && e15.ISO_8601;
  }
  We.dateTimeFactory = { create: function() {
    return new r10(/* @__PURE__ */ new Date());
  }, createFromString: function(t11, a11, s10) {
    var l10 = function(t12, r11) {
      var a12, s11;
      try {
        if (!r11 || Array.isArray(r11) && 0 === r11.length) return n10.parseISO(t12);
        try {
          for (var l11 = e14.__values(r11), c10 = l11.next(); !c10.done; c10 = l11.next()) {
            var u10 = c10.value;
            var d10 = o10(u10) ? n10.parseISO(t12) : n10.parse(t12, i10(u10), /* @__PURE__ */ new Date());
            if (n10.isValid(d10)) return d10;
          }
        } catch (e15) {
          a12 = { error: e15 };
        } finally {
          try {
            c10 && !c10.done && (s11 = l11.return) && s11.call(l11);
          } finally {
            if (a12) throw a12.error;
          }
        }
      } catch (e15) {
        return console.warn(e15), null;
      }
      return null;
    }(t11, a11);
    return null != l10 ? new r10(l10) : null;
  }, createFromArray: function(e15) {
    if (!function(e16) {
      return (!e16[1] || !(e16[1] < 1 || e16[1] > 12)) && ((!e16[2] || !(e16[2] < 1 || e16[2] > 31)) && ((!e16[3] || !(e16[3] < 0 || e16[3] > 24)) && ((!e16[4] || !(e16[4] < 0 || e16[4] > 59)) && (!e16[5] || !(e16[5] < 0 || e16[5] > 59)))));
    }(e15)) return null;
    var t11 = new Date(e15[0], e15[1], e15[2], e15[3], e15[4], e15[5]);
    return t11.setFullYear(e15[0]), new r10(t11);
  }, createFromJsDate: function(e15) {
    return n10.isValid(e15) ? new r10(e15) : null;
  }, isDateTime: function(e15) {
    return e15 && e15.dt && e15.dt instanceof Date;
  } };
  var a10 = { dd: "dd", d: "d", DD: "dd", D: "d", fffffff: "SSSSSSS", ffffff: "SSSSSS", fffff: "SSSSS", ffff: "SSSS", fff: "SSS", ff: "SS", f: "S", hh: "hh", h: "h", HH: "HH", H: "H", mm: "mm", m: "m", ss: "ss", s: "s", tt: "aa", t: "a", a: "a", A: "aa", MM: "MM", M: "M", yyyy: "yyyy", yy: "yy", YYYY: "yyyy", YY: "yy", zzz: "XXX", zz: "X", z: "X", Z: "XXX", X: "t", x: "T" };
  function i10(e15) {
    var n11 = t10.parseDateTimeFormat(e15, Object.keys(a10)).map(function(e16) {
      var t11;
      return null !== (t11 = a10[e16]) && void 0 !== t11 ? t11 : "'" + e16 + "'";
    });
    return n11.join("");
  }
  return We;
}
var pi = {};
var mi = {};
var hi = {};
var fi = {};
var gi;
function yi() {
  if (gi) return fi;
  gi = 1, Object.defineProperty(fi, "__esModule", { value: true }), fi.formatDateTime = fi.isDateTimeFormat = void 0;
  var e14 = Ge();
  var t10 = { d: "Short date", D: "Long date", f: "Full date/short time", F: "Full date/long time", g: "General date/short time", G: "General date/long time", M: "Month/day", m: "Month/day", O: "Round-trip date/time", o: "Round-trip date/time", R: "RFC1123", r: "RFC1123", s: "Sortable date/time", t: "Short time", T: "Long time", u: "Universal sortable date/time", U: "Universal full date/time", Y: "Year/month", y: "Year/month" };
  var n10 = { "Round-trip date/time": 'yyyy"-"MM"-"dd"T"HH":"mm":"ss.fffffffK', RFC1123: 'ddd, dd MMM yyyy HH":"mm":"ss "GMT"', "Sortable date/time": 'yyyy"-"MM"-"dd"T"HH":"mm":"ss', "Universal sortable date/time": 'yyyy"-"MM"-"dd HH":"mm":"ss"Z"' };
  var r10 = { "Full date/short time": ["Long date", "Short time"], "Full date/long time": ["Long date", "Long time"], "General date/short time": ["Short date", "Short time"], "General date/long time": ["Short date", "Long time"], "Universal full date/time": ["Long date", "Long time"] };
  var o10 = Object.keys(t10);
  return fi.isDateTimeFormat = function(e15) {
    return o10.includes(e15);
  }, fi.formatDateTime = function(o11, a10, i10) {
    var s10 = 1 === (a10 = a10 || "G").length ? t10[a10] : void 0;
    var l10;
    if (s10) {
      if (!function(e15) {
        return Object.keys(n10).includes(e15);
      }(s10)) return function(e15) {
        return Object.keys(r10).includes(e15);
      }(s10) ? r10[s10].map(function(e15) {
        return i10.Format(o11, e15);
      }).join(" ") : i10.Format(o11, s10);
      l10 = n10[s10];
    } else l10 = a10;
    return e14.formatDateTimeWithPattern(o11, l10, i10.FormatInfo, "U" === a10);
  }, fi;
}
var vi = {};
var bi = {};
var Si = { exports: {} };
var Ci;
function xi() {
  return Ci || (Ci = 1, e14 = Si, Si.exports, e14.exports = function(e15) {
    function t10(r10) {
      if (n10[r10]) return n10[r10].exports;
      var o10 = n10[r10] = { exports: {}, id: r10, loaded: false };
      return e15[r10].call(o10.exports, o10, o10.exports, t10), o10.loaded = true, o10.exports;
    }
    var n10 = {};
    return t10.m = e15, t10.c = n10, t10.p = "", t10(0);
  }([function(e15, t10, n10) {
    function r10(e16) {
      return e16 && e16.__esModule ? e16 : { default: e16 };
    }
    var o10 = r10(n10(1)), a10 = r10(n10(20)), i10 = r10(n10(21)), s10 = n10(22), l10 = r10(n10(64)), c10 = "en-US";
    e15.exports = function() {
      function e16() {
        var t11 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n11 = t11.debug, r11 = void 0 !== n11 && n11, i11 = t11.UTCOffset, s11 = void 0 === i11 ? null : i11, u10 = t11.locale, d10 = void 0 === u10 ? c10 : u10, p10 = t11.transformCode, m10 = void 0 === p10 ? function(e17) {
          return e17;
        } : p10, h10 = t11.locales, f10 = void 0 === h10 ? [] : h10;
        (0, a10.default)(this, e16), this.memoized = {}, this.debug = r11, this.UTCOffset = s11, this.transformCode = m10, this.zeroDate = this.createDate("1899-12-31T00:00:00.000"), this.locales = (0, o10.default)({}, c10, l10.default), this.defineLocales(f10), this.setLocale(d10);
      }
      return (0, i10.default)(e16, [{ key: "clearMemoizedFunctions", value: function() {
        this.memoized = {};
      } }, { key: "defineLocales", value: function(e17) {
        var t11 = this;
        e17.forEach(function(e18) {
          return t11.locales[e18.name] = e18;
        });
      } }, { key: "setLocale", value: function(e17) {
        this.locale = this.locales[e17] || this.locales[c10], this.clearMemoizedFunctions();
      } }, { key: "setUTCOffset", value: function(e17) {
        this.UTCOffset = e17;
      } }, { key: "createDate", value: function() {
        var e17 = new (Function.prototype.bind.apply(Date, [null].concat(Array.prototype.slice.call(arguments))))();
        if (null !== this.UTCOffset) {
          var t11 = e17.getTimezoneOffset(), n11 = 60 * (this.UTCOffset + t11) * 1e3;
          e17.setTime(e17.getTime() + n11);
        }
        return e17;
      } }, { key: "log", value: function(e17) {
        this.debug && console.log(e17);
      } }, { key: "roundDecimals", value: function(e17, t11) {
        var n11 = Math.pow(10, t11);
        return Math.round(e17 * n11) / n11;
      } }, { key: "gcd", value: function(e17, t11) {
        for (var n11 = void 0; t11; ) n11 = e17 % t11, e17 = t11, t11 = n11;
        return Math.abs(e17);
      } }, { key: "applyNumberPattern", value: function(e17, t11, n11) {
        e17 = e17.toString();
        var r11 = "";
        if ("right" === n11) for (var o11 = 0, a11 = -1, i11 = t11.length; ++a11 < i11; ) switch (t11[a11]) {
          case "0":
            r11 += e17[o11] || "0", o11++;
            break;
          case "#":
            r11 += e17[o11] || "", o11++;
            break;
          case "?":
            r11 += e17[o11] || " ", o11++;
            break;
          case "[":
            for (; a11 < t11.length && "]" !== t11[a11]; ) r11 += t11[a11], a11++;
            a11--;
            break;
          default:
            r11 += t11[a11];
        }
        else {
          var s11 = false, l11 = void 0;
          if (t11 = t11.replace(/(0|#|\?)(,+?)(0|#|\?)/g, function(e18, t12, n12, r12) {
            return s11 = true, t12 + r12;
          }), s11) for (var c11 = e17.length - 3; "-" === e17[0] ? c11 > 1 : c11 > 0; ) e17 = e17.substr(0, c11) + this.locale.thousandSeparator + e17.substr(c11), c11 -= 3;
          var u10 = e17.length - 1, d10 = t11.length;
          for (e17 = "0" === e17 ? "" : e17; d10--; ) switch (t11[d10]) {
            case "0":
              r11 = (e17[u10] || "0") + r11, l11 = d10, u10--;
              break;
            case "#":
              r11 = (e17[u10] || "") + r11, l11 = d10, u10--;
              break;
            case "?":
              r11 = (e17[u10] || " ") + r11, l11 = d10, u10--;
              break;
            case "]":
              for (; d10 > 0 && "[" !== t11[d10]; ) r11 = t11[d10] + r11, d10--;
              d10++;
              break;
            default:
              r11 = t11[d10] + r11;
          }
          u10 >= 0 && null !== l11 && (r11 = r11.substr(0, l11) + e17.substr(0, u10 + 1) + r11.substr(l11));
        }
        return r11;
      } }, { key: "restoreOrigins", value: function(e17, t11) {
        return e17.toString().replace(/\[(?:(\$*?)|(.*?))\]/g, function(e18, n11) {
          return n11 && t11[n11.length - 1] || e18;
        });
      } }, { key: "formatAsNumberDecimal", value: function(e17, t11, n11, r11) {
        var o11 = (e17 = this.roundDecimals(e17, t11).toString().split("."))[0], a11 = e17[1] || 0;
        return this.applyNumberPattern(o11, n11) + this.locale.decimalSeparator + this.applyNumberPattern(a11, r11, "right");
      } }, { key: "formatAsNumberFractial", value: function(e17, t11, n11) {
        var r11 = e17.toString().split(".");
        r11 = r11[1] ? Math.pow(10, r11[1].length) : 1, e17 = Math.floor(e17 * r11);
        var o11 = this.gcd(e17, r11);
        return this.applyNumberPattern(e17 / o11, t11) + "/" + this.applyNumberPattern(r11 / o11, n11);
      } }, { key: "formatAsNumberFractialMixed", value: function(e17, t11, n11, r11) {
        var o11 = 0, a11 = 1, i11 = 1, s11 = e17.toString().split(".");
        return s11[1] && (a11 = Math.pow(10, s11[1].length), o11 = parseInt(s11[1]), i11 = this.gcd(o11, a11)), this.applyNumberPattern(parseInt(e17), t11) + this.applyNumberPattern(o11 / i11, n11) + "/" + this.applyNumberPattern(a11 / i11, r11);
      } }, { key: "formatAsNumberExponential", value: function(e17, t11, n11, r11, o11, a11) {
        var i11 = e17 < 0 ? -1 : 1, s11 = 0;
        if (0 !== e17) {
          e17 = Math.abs(e17);
          for (var l11 = Math.pow(10, t11); e17 < l11 || this.roundDecimals(e17, n11) < l11; ) e17 *= 10, s11++;
          for (; e17 >= l11 || this.roundDecimals(e17, n11) >= l11; ) e17 /= 10, s11--;
        }
        e17 = this.roundDecimals(e17 * i11, n11).toString().split(".");
        var c11 = "";
        return c11 += this.applyNumberPattern(parseInt(e17[0]), r11), o11 && (c11 += this.locale.decimalSeparator + this.applyNumberPattern(parseInt(e17[1] || 0), o11, "right")), c11 + "E" + (s11 > 0 ? "-" : "+") + this.applyNumberPattern(Math.abs(s11), a11);
      } }, { key: "formatAsDateTimeElapsed", value: function(e17, t11, n11, r11, o11) {
        var a11 = this;
        e17 = Math.abs(e17.getTime() - this.zeroDate.getTime());
        var i11 = parseInt(e17 / 1e3), s11 = parseInt(i11 / 60), l11 = parseInt(s11 / 60), c11 = parseInt(l11 / 24);
        return l11 = t11 ? l11 % 24 : l11, s11 = n11 ? s11 % 60 : s11, i11 = r11 ? i11 % 60 : i11, o11.replace(/(dd)|(d)|(hh)|(h)|(mm)|(m)|(ss)|(s)/gi, function(e18, t12, n12, r12, o12, u10, d10, p10, m10) {
          return t12 ? a11.applyNumberPattern(c11, "00") : n12 ? c11 : r12 ? a11.applyNumberPattern(l11, "00") : o12 ? l11 : u10 ? a11.applyNumberPattern(s11, "00") : d10 ? s11 : p10 ? a11.applyNumberPattern(i11, "00") : m10 ? i11 : "";
        });
      } }, { key: "formatAsDateTimeNormal", value: function(e17, t11) {
        var n11 = this, r11 = this.locale, o11 = r11.days, a11 = r11.daysShort, i11 = r11.months, s11 = r11.monthsShort, l11 = false, c11 = e17.getFullYear(), u10 = e17.getMonth(), d10 = e17.getDate(), p10 = e17.getDay(), m10 = e17.getHours(), h10 = e17.getMinutes(), f10 = e17.getSeconds(), g10 = t11.replace(/((?:am\/pm)|(?:a\/p))|(?:(h[^ydsap]*?)mm)|(?:mm([^ydh]*?s))|(?:(h[^ydsap]*?)m)|(?:m([^ydh]*?s))/gi, function(e18, t12, r12, o12, a12, i12) {
          return t12 ? (l11 = true, "[]") : r12 ? r12 + n11.applyNumberPattern(h10, "00") : o12 ? n11.applyNumberPattern(h10, "00") + o12 : a12 ? a12 + h10 : i12 ? h10 + i12 : "";
        });
        return g10.replace(/(ss)|(s)|(hh)|(h)|(dddd)|(ddd)|(dd)|(d)|(mmmmm)|(mmmm)|(mmm)|(mm)|(m)|(yyyy)|(yy)|(\[\])/gi, function(e18, t12, r12, h11, g11, y10, v10, b10, S10, C10, x10, w10, T10, E10, F10, M10, k10) {
          return t12 ? n11.applyNumberPattern(f10, "00") : r12 ? f10 : h11 ? n11.applyNumberPattern(l11 ? m10 % 12 : m10, "00") : g11 ? l11 ? m10 % 12 : m10 : y10 ? o11[p10] : v10 ? a11[p10] : b10 ? n11.applyNumberPattern(d10, "00") : S10 ? d10 : C10 ? s11[u10][0] : x10 ? i11[u10] : w10 ? s11[u10] : T10 ? n11.applyNumberPattern(u10 + 1, "00") : E10 ? u10 + 1 : F10 ? c11 : M10 ? c11.toString().substr(2) : k10 ? m10 < 12 ? "AM" : "PM" : "";
        });
      } }, { key: "createTextCode", value: function(e17) {
        var t11 = new s10.Code();
        return t11.append("\n      result.value = {0}.replace(/@/, n);\n    ", e17), t11.toString();
      } }, { key: "createGeneralCode", value: function() {
        var e17 = new s10.Code(), t11 = this.createNumberCode("#.00"), n11 = this.createDateTimeCode("[d]");
        return e17.append('\n      if (type === "Number") {\n        ' + t11 + '\n      }\n      if (type === "DateTime") {\n        ' + n11 + "\n      }\n    "), e17.toString();
      } }, { key: "createNumberExponentialCode", value: function(e17) {
        var t11 = e17[1], n11 = e17[2], r11 = e17[3], o11 = new s10.Code(), a11 = void 0, i11 = void 0, l11 = function(e18) {
          return e18.match(/0|\?|#/g).length;
        };
        return t11 ? a11 = l11(t11) : (t11 = "#", a11 = 1), n11 ? i11 = l11(n11) : (n11 = "", i11 = 0), o11.append("\n      result.value = this.formatAsNumberExponential(n, {0}, {1}, {2}, {3}, {4});\n    ", a11, i11, t11, n11, r11), o11.toString();
      } }, { key: "createNumberFractialCode", value: function(e17) {
        for (var t11 = new s10.Code(), n11 = e17[1] || "#", r11 = e17[2] || "#", o11 = n11.length - 1; "0" === n11[o11] && "?" !== n11[o11] && "#" !== n11[o11] && " " !== n11[o11] && o11 > 0; ) o11--;
        var a11 = n11.substr(0, o11), i11 = n11.substr(o11);
        return a11 ? t11.append("\n        result.value = this.formatAsNumberFractialMixed(n, {0}, {1}, {2});\n      ", a11, i11, r11) : t11.append("\n        result.value = this.formatAsNumberFractial(n, {0}, {1});\n      ", i11, r11), t11.toString();
      } }, { key: "createNumberDecimalCode", value: function(e17) {
        var t11 = new s10.Code(), n11 = e17[1] || "0", r11 = e17[2] || "", o11 = void 0, a11 = 1, i11 = function(e18) {
          return e18.match(/0|\?|#/g).length;
        };
        return o11 = r11 ? i11(r11) : 0, n11 = n11.replace(/(0|#|\?)(,+)([^0?#]*)$/, function(e18, t12, n12, r12) {
          return a11 *= Math.pow(1e3, n12.length), t12 + r12;
        }), 1 !== a11 && t11.append("\n        n /= {0};\n      ", a11), t11.append("\n      result.value = this.formatAsNumberDecimal(n, {0}, {1}, {2});\n    ", o11, n11, r11), t11.toString();
      } }, { key: "createNumberIntegerCode", value: function(e17) {
        var t11 = new s10.Code();
        return t11.append("\n      n = Math.round(n);\n      result.value = this.applyNumberPattern(n, {0});\n    ", e17), t11.toString();
      } }, { key: "createNumberCode", value: function(e17, t11) {
        var n11 = new s10.Code();
        t11 && n11.append("\n        n = Math.abs(n);\n      ");
        var r11 = e17.match(/(.*?)(?:\.(.*?))?e(?:\+|\-)(.*)/i);
        if (r11) n11.append(this.createNumberExponentialCode(r11));
        else {
          var o11 = 1;
          e17 = e17.replace(/(0|#|\?)([\s,]+)([^0?#]*?)($|\.)/, function(e18, t12, n12, r12, a12) {
            return o11 *= Math.pow(1e3, n12.length), t12 + r12 + a12;
          });
          var a11 = e17.match(/%/g);
          a11 && (o11 /= Math.pow(100, a11.length)), 1 !== o11 && n11.append("\n          n /= {0};\n        ", o11);
          var i11 = void 0, l11 = void 0;
          switch (true) {
            case !!(i11 = e17.match(/(.*?)\/(.*)/)):
              n11.append(this.createNumberFractialCode(i11));
              break;
            case !!(l11 = e17.match(/(.*?)\.(.*)/)):
              n11.append(this.createNumberDecimalCode(l11));
              break;
            default:
              n11.append(this.createNumberIntegerCode(e17));
          }
        }
        var c11 = new s10.Code();
        return c11.append("\n      n = parseFloat(n);\n    "), c11.append("\n      if (!isNaN(n)) {\n        if (n >= 1e21 || n <= -1e21) {\n          result.value = n.toString().toUpperCase();\n        }\n        else {\n          " + n11 + "\n        }\n      }\n    "), c11.toString();
      } }, { key: "createDateTimeElapsedCode", value: function(e17) {
        var t11 = new s10.Code(), n11 = /d/i.test(e17), r11 = /h/i.test(e17), o11 = /m/i.test(e17);
        return t11.append("\n      result.value = this.formatAsDateTimeElapsed(n, {0}, {1}, {2}, {3});\n    ", n11, r11, o11, e17), t11.toString();
      } }, { key: "createDateTimeNormalCode", value: function(e17) {
        var t11 = new s10.Code();
        return t11.append("\n      result.value = this.formatAsDateTimeNormal(n, {0});\n    ", e17), t11.toString();
      } }, { key: "createDateTimeCode", value: function(e17) {
        var t11 = new s10.Code(), n11 = false;
        e17 = e17.replace(/\[(h+?|m+?|s+?|y+?|d+?)]/gi, function(e18, t12) {
          return n11 = true, t12;
        });
        var r11 = n11 ? this.createDateTimeElapsedCode(e17) : this.createDateTimeNormalCode(e17);
        return t11.append("\n      n = this.createDate(n);\n      if (!isNaN(n.getTime())) {\n        " + r11 + "\n      }\n    "), t11.toString();
      } }, { key: "createSectionCode", value: function(e17, t11, n11) {
        var r11 = new s10.Code(), o11 = void 0, a11 = false, i11 = e17.match(/\[((?:>|>=|<|<=|=|<>)[0-9\.]+?)]/);
        switch (true) {
          case !!i11:
            o11 = 'type == "Number" && parseFloat(n)' + i11[1].replace(/<>/, "!=").replace("/=/", "==");
            break;
          case (0 === t11 && n11 > 2):
            o11 = 'type == "Number" && parseFloat(n) > 0';
            break;
          case (0 === t11 && 2 === n11):
            o11 = 'type == "Number" && parseFloat(n) >= 0';
            break;
          case 1 === t11:
            o11 = 'type == "Number" && parseFloat(n) < 0', a11 = true;
        }
        e17 = e17.replace(/\[(Red|Green|White|Blue|Magenta|Yellow|Cyan|Black)]/gi, function(e18, t12) {
          return r11.append("\n        result.color = {0};\n      ", t12), "";
        }), e17 = e17.replace(/(\[((?!((\$*?)|(d*?)|(h*?)|(m*?)|(s*?))]).*?)])/, "");
        var l11 = new s10.Code();
        switch (l11.append("\n      result.value = {0};\n      result.pattern = {0};\n    ", e17), true) {
          case /General/i.test(e17):
            l11.append(this.createGeneralCode(e17));
            break;
          case /@/.test(e17):
            l11.append(this.createTextCode(e17));
            break;
          case /#|\?|0/.test(e17):
            o11 || (o11 = 'type === "Number"'), l11.append(this.createNumberCode(e17, a11));
            break;
          case /h|m|s|y|d/i.test(e17):
            o11 || (o11 = 'type === "DateTime"'), l11.append(this.createDateTimeCode(e17));
        }
        return l11.append("\n      return makeResult.call(this);\n    "), o11 ? r11.append("\n        // Section\n        if (" + o11 + ") {\n          " + l11 + "\n        }\n        // End section\n      ") : r11.append("\n        // Section\n        " + l11 + "\n        // End section\n      "), r11.toString();
      } }, { key: "createPatternCode", value: function(e17) {
        var t11 = this, n11 = [], r11 = "", o11 = e17.replace(/"([^"]+)"|\\(.?)|(_.?)|(\*.?)|(")/g, function(e18, t12, o12, a12) {
          return t12 ? (n11.push(t12.replace(/("|'|\\)/g, "\\$1")), "[" + (r11 += "$") + "]") : o12 ? (n11.push(o12.replace(/("|'|\\)/g, "\\$1")), "[" + (r11 += "$") + "]") : a12 ? (n11.push(" "), "[" + (r11 += "$") + "]") : "";
        }), a11 = o11.split(/;/), i11 = new s10.Code();
        return i11.append('\n      var result = {\n        value: "",\n        align: type === "Number" || type === "DateTime" ? "right" : "",\n        color: "",\n        pattern: ""\n      };\n\n      function makeResult() {\n        var origins = {0};\n        result.value = this.restoreOrigins(result.value, origins);\n        result.pattern = this.restoreOrigins(result.pattern, origins);\n        return result;\n      };\n    ', n11), (a11 = a11.slice(0, 4)).forEach(function(e18, n12) {
          return i11.append(t11.createSectionCode(e18, n12, a11.length));
        }), i11.append("\n      result.value = {0};\n      result.pattern = {0};\n      return makeResult.call(this);\n    ", o11), i11.toString();
      } }, { key: "format", value: function(e17, t11, n11) {
        if (this.log("Input:"), this.log("n = " + e17 + ", type = " + t11 + ", pattern = " + n11), e17 = e17.toString(), n11 = n11.toString(), this.locale.formats[n11] && (n11 = this.locale.formats[n11]), !this.memoized[n11]) {
          var r11 = this.createPatternCode(n11);
          r11 = this.transformCode(r11), this.memoized[n11] = Function("n", "type", r11), this.log("Code:"), this.log(r11);
        }
        var o11 = this.memoized[n11].call(this, e17, t11);
        return this.log("Result:"), this.log(o11), o11;
      } }]), e16;
    }();
  }, function(e15, t10, n10) {
    function r10(e16) {
      return e16 && e16.__esModule ? e16 : { default: e16 };
    }
    t10.__esModule = true;
    var o10 = r10(n10(2));
    t10.default = function(e16, t11, n11) {
      return t11 in e16 ? (0, o10.default)(e16, t11, { value: n11, enumerable: true, configurable: true, writable: true }) : e16[t11] = n11, e16;
    };
  }, function(e15, t10, n10) {
    e15.exports = { default: n10(3), __esModule: true };
  }, function(e15, t10, n10) {
    n10(4);
    var r10 = n10(7).Object;
    e15.exports = function(e16, t11, n11) {
      return r10.defineProperty(e16, t11, n11);
    };
  }, function(e15, t10, n10) {
    var r10 = n10(5);
    r10(r10.S + r10.F * !n10(15), "Object", { defineProperty: n10(11).f });
  }, function(e15, t10, n10) {
    var r10 = n10(6), o10 = n10(7), a10 = n10(8), i10 = n10(10), s10 = "prototype", l10 = function(e16, t11, n11) {
      var c10, u10, d10, p10 = e16 & l10.F, m10 = e16 & l10.G, h10 = e16 & l10.S, f10 = e16 & l10.P, g10 = e16 & l10.B, y10 = e16 & l10.W, v10 = m10 ? o10 : o10[t11] || (o10[t11] = {}), b10 = v10[s10], S10 = m10 ? r10 : h10 ? r10[t11] : (r10[t11] || {})[s10];
      for (c10 in m10 && (n11 = t11), n11) (u10 = !p10 && S10 && void 0 !== S10[c10]) && c10 in v10 || (d10 = u10 ? S10[c10] : n11[c10], v10[c10] = m10 && "function" != typeof S10[c10] ? n11[c10] : g10 && u10 ? a10(d10, r10) : y10 && S10[c10] == d10 ? function(e17) {
        var t12 = function(t13, n12, r11) {
          if (this instanceof e17) {
            switch (arguments.length) {
              case 0:
                return new e17();
              case 1:
                return new e17(t13);
              case 2:
                return new e17(t13, n12);
            }
            return new e17(t13, n12, r11);
          }
          return e17.apply(this, arguments);
        };
        return t12[s10] = e17[s10], t12;
      }(d10) : f10 && "function" == typeof d10 ? a10(Function.call, d10) : d10, f10 && ((v10.virtual || (v10.virtual = {}))[c10] = d10, e16 & l10.R && b10 && !b10[c10] && i10(b10, c10, d10)));
    };
    l10.F = 1, l10.G = 2, l10.S = 4, l10.P = 8, l10.B = 16, l10.W = 32, l10.U = 64, l10.R = 128, e15.exports = l10;
  }, function(e15, t10) {
    var n10 = e15.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = n10);
  }, function(e15, t10) {
    var n10 = e15.exports = { version: "2.5.3" };
    "number" == typeof __e && (__e = n10);
  }, function(e15, t10, n10) {
    var r10 = n10(9);
    e15.exports = function(e16, t11, n11) {
      if (r10(e16), void 0 === t11) return e16;
      switch (n11) {
        case 1:
          return function(n12) {
            return e16.call(t11, n12);
          };
        case 2:
          return function(n12, r11) {
            return e16.call(t11, n12, r11);
          };
        case 3:
          return function(n12, r11, o10) {
            return e16.call(t11, n12, r11, o10);
          };
      }
      return function() {
        return e16.apply(t11, arguments);
      };
    };
  }, function(e15, t10) {
    e15.exports = function(e16) {
      if ("function" != typeof e16) throw TypeError(e16 + " is not a function!");
      return e16;
    };
  }, function(e15, t10, n10) {
    var r10 = n10(11), o10 = n10(19);
    e15.exports = n10(15) ? function(e16, t11, n11) {
      return r10.f(e16, t11, o10(1, n11));
    } : function(e16, t11, n11) {
      return e16[t11] = n11, e16;
    };
  }, function(e15, t10, n10) {
    var r10 = n10(12), o10 = n10(14), a10 = n10(18), i10 = Object.defineProperty;
    t10.f = n10(15) ? Object.defineProperty : function(e16, t11, n11) {
      if (r10(e16), t11 = a10(t11, true), r10(n11), o10) try {
        return i10(e16, t11, n11);
      } catch (e17) {
      }
      if ("get" in n11 || "set" in n11) throw TypeError("Accessors not supported!");
      return "value" in n11 && (e16[t11] = n11.value), e16;
    };
  }, function(e15, t10, n10) {
    var r10 = n10(13);
    e15.exports = function(e16) {
      if (!r10(e16)) throw TypeError(e16 + " is not an object!");
      return e16;
    };
  }, function(e15, t10) {
    e15.exports = function(e16) {
      return "object" == typeof e16 ? null !== e16 : "function" == typeof e16;
    };
  }, function(e15, t10, n10) {
    e15.exports = !n10(15) && !n10(16)(function() {
      return 7 != Object.defineProperty(n10(17)("div"), "a", { get: function() {
        return 7;
      } }).a;
    });
  }, function(e15, t10, n10) {
    e15.exports = !n10(16)(function() {
      return 7 != Object.defineProperty({}, "a", { get: function() {
        return 7;
      } }).a;
    });
  }, function(e15, t10) {
    e15.exports = function(e16) {
      try {
        return !!e16();
      } catch (e17) {
        return true;
      }
    };
  }, function(e15, t10, n10) {
    var r10 = n10(13), o10 = n10(6).document, a10 = r10(o10) && r10(o10.createElement);
    e15.exports = function(e16) {
      return a10 ? o10.createElement(e16) : {};
    };
  }, function(e15, t10, n10) {
    var r10 = n10(13);
    e15.exports = function(e16, t11) {
      if (!r10(e16)) return e16;
      var n11, o10;
      if (t11 && "function" == typeof (n11 = e16.toString) && !r10(o10 = n11.call(e16))) return o10;
      if ("function" == typeof (n11 = e16.valueOf) && !r10(o10 = n11.call(e16))) return o10;
      if (!t11 && "function" == typeof (n11 = e16.toString) && !r10(o10 = n11.call(e16))) return o10;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function(e15, t10) {
    e15.exports = function(e16, t11) {
      return { enumerable: !(1 & e16), configurable: !(2 & e16), writable: !(4 & e16), value: t11 };
    };
  }, function(e15, t10) {
    t10.__esModule = true, t10.default = function(e16, t11) {
      if (!(e16 instanceof t11)) throw new TypeError("Cannot call a class as a function");
    };
  }, function(e15, t10, n10) {
    function r10(e16) {
      return e16 && e16.__esModule ? e16 : { default: e16 };
    }
    t10.__esModule = true;
    var o10 = r10(n10(2));
    t10.default = /* @__PURE__ */ function() {
      function e16(e17, t11) {
        for (var n11 = 0; n11 < t11.length; n11++) {
          var r11 = t11[n11];
          r11.enumerable = r11.enumerable || false, r11.configurable = true, "value" in r11 && (r11.writable = true), (0, o10.default)(e17, r11.key, r11);
        }
      }
      return function(t11, n11, r11) {
        return n11 && e16(t11.prototype, n11), r11 && e16(t11, r11), t11;
      };
    }();
  }, function(e15, t10, n10) {
    function r10(e16) {
      return e16 && e16.__esModule ? e16 : { default: e16 };
    }
    function o10(e16) {
      for (var t11 = arguments.length, n11 = Array(t11 > 1 ? t11 - 1 : 0), r11 = 1; r11 < t11; r11++) n11[r11 - 1] = arguments[r11];
      return e16.replace(/{(\d+)}/g, function(e17, t12) {
        return void 0 !== n11[t12] ? n11[t12] : e17;
      });
    }
    Object.defineProperty(t10, "__esModule", { value: true }), t10.Code = void 0;
    var a10 = r10(n10(23)), i10 = r10(n10(62)), s10 = r10(n10(20)), l10 = r10(n10(21));
    t10.formatString = o10, t10.Code = function() {
      function e16() {
        (0, s10.default)(this, e16), this.code = "";
      }
      return (0, l10.default)(e16, [{ key: "makeString", value: function(e17) {
        for (var t11 = arguments.length, n11 = Array(t11 > 1 ? t11 - 1 : 0), r11 = 1; r11 < t11; r11++) n11[r11 - 1] = arguments[r11];
        return n11 = n11.map(i10.default), o10.apply(void 0, [e17].concat((0, a10.default)(n11)));
      } }, { key: "append", value: function() {
        this.code += this.makeString.apply(this, arguments);
      } }, { key: "toString", value: function() {
        return this.code;
      } }]), e16;
    }();
  }, function(e15, t10, n10) {
    function r10(e16) {
      return e16 && e16.__esModule ? e16 : { default: e16 };
    }
    t10.__esModule = true;
    var o10 = r10(n10(24));
    t10.default = function(e16) {
      if (Array.isArray(e16)) {
        for (var t11 = 0, n11 = Array(e16.length); t11 < e16.length; t11++) n11[t11] = e16[t11];
        return n11;
      }
      return (0, o10.default)(e16);
    };
  }, function(e15, t10, n10) {
    e15.exports = { default: n10(25), __esModule: true };
  }, function(e15, t10, n10) {
    n10(26), n10(55), e15.exports = n10(7).Array.from;
  }, function(e15, t10, n10) {
    var r10 = n10(27)(true);
    n10(30)(String, "String", function(e16) {
      this._t = String(e16), this._i = 0;
    }, function() {
      var e16, t11 = this._t, n11 = this._i;
      return n11 >= t11.length ? { value: void 0, done: true } : (e16 = r10(t11, n11), this._i += e16.length, { value: e16, done: false });
    });
  }, function(e15, t10, n10) {
    var r10 = n10(28), o10 = n10(29);
    e15.exports = function(e16) {
      return function(t11, n11) {
        var a10, i10, s10 = String(o10(t11)), l10 = r10(n11), c10 = s10.length;
        return l10 < 0 || l10 >= c10 ? e16 ? "" : void 0 : (a10 = s10.charCodeAt(l10)) < 55296 || a10 > 56319 || l10 + 1 === c10 || (i10 = s10.charCodeAt(l10 + 1)) < 56320 || i10 > 57343 ? e16 ? s10.charAt(l10) : a10 : e16 ? s10.slice(l10, l10 + 2) : i10 - 56320 + (a10 - 55296 << 10) + 65536;
      };
    };
  }, function(e15, t10) {
    var n10 = Math.ceil, r10 = Math.floor;
    e15.exports = function(e16) {
      return isNaN(e16 = +e16) ? 0 : (e16 > 0 ? r10 : n10)(e16);
    };
  }, function(e15, t10) {
    e15.exports = function(e16) {
      if (null == e16) throw TypeError("Can't call method on  " + e16);
      return e16;
    };
  }, function(e15, t10, n10) {
    var r10 = n10(31), o10 = n10(5), a10 = n10(32), i10 = n10(10), s10 = n10(33), l10 = n10(34), c10 = n10(35), u10 = n10(51), d10 = n10(53), p10 = n10(52)("iterator"), m10 = !([].keys && "next" in [].keys()), h10 = "@@iterator", f10 = "keys", g10 = "values", y10 = function() {
      return this;
    };
    e15.exports = function(e16, t11, n11, v10, b10, S10, C10) {
      c10(n11, t11, v10);
      var x10, w10, T10, E10 = function(e17) {
        if (!m10 && e17 in P10) return P10[e17];
        switch (e17) {
          case f10:
          case g10:
            return function() {
              return new n11(this, e17);
            };
        }
        return function() {
          return new n11(this, e17);
        };
      }, F10 = t11 + " Iterator", M10 = b10 == g10, k10 = false, P10 = e16.prototype, N10 = P10[p10] || P10[h10] || b10 && P10[b10], D10 = !m10 && N10 || E10(b10), L10 = b10 ? M10 ? E10("entries") : D10 : void 0, H10 = "Array" == t11 && P10.entries || N10;
      if (H10 && (T10 = d10(H10.call(new e16()))) !== Object.prototype && T10.next && (u10(T10, F10, true), r10 || s10(T10, p10) || i10(T10, p10, y10)), M10 && N10 && N10.name !== g10 && (k10 = true, D10 = function() {
        return N10.call(this);
      }), r10 && !C10 || !m10 && !k10 && P10[p10] || i10(P10, p10, D10), l10[t11] = D10, l10[F10] = y10, b10) if (x10 = { values: M10 ? D10 : E10(g10), keys: S10 ? D10 : E10(f10), entries: L10 }, C10) for (w10 in x10) w10 in P10 || a10(P10, w10, x10[w10]);
      else o10(o10.P + o10.F * (m10 || k10), t11, x10);
      return x10;
    };
  }, function(e15, t10) {
    e15.exports = true;
  }, function(e15, t10, n10) {
    e15.exports = n10(10);
  }, function(e15, t10) {
    var n10 = {}.hasOwnProperty;
    e15.exports = function(e16, t11) {
      return n10.call(e16, t11);
    };
  }, function(e15, t10) {
    e15.exports = {};
  }, function(e15, t10, n10) {
    var r10 = n10(36), o10 = n10(19), a10 = n10(51), i10 = {};
    n10(10)(i10, n10(52)("iterator"), function() {
      return this;
    }), e15.exports = function(e16, t11, n11) {
      e16.prototype = r10(i10, { next: o10(1, n11) }), a10(e16, t11 + " Iterator");
    };
  }, function(e15, t10, n10) {
    var r10 = n10(12), o10 = n10(37), a10 = n10(49), i10 = n10(46)("IE_PROTO"), s10 = function() {
    }, l10 = "prototype", c10 = function() {
      var e16, t11 = n10(17)("iframe"), r11 = a10.length, o11 = "<", i11 = ">";
      for (t11.style.display = "none", n10(50).appendChild(t11), t11.src = "javascript:", (e16 = t11.contentWindow.document).open(), e16.write(o11 + "script" + i11 + "document.F=Object" + o11 + "/script" + i11), e16.close(), c10 = e16.F; r11--; ) delete c10[l10][a10[r11]];
      return c10();
    };
    e15.exports = Object.create || function(e16, t11) {
      var n11;
      return null !== e16 ? (s10[l10] = r10(e16), n11 = new s10(), s10[l10] = null, n11[i10] = e16) : n11 = c10(), void 0 === t11 ? n11 : o10(n11, t11);
    };
  }, function(e15, t10, n10) {
    var r10 = n10(11), o10 = n10(12), a10 = n10(38);
    e15.exports = n10(15) ? Object.defineProperties : function(e16, t11) {
      o10(e16);
      for (var n11, i10 = a10(t11), s10 = i10.length, l10 = 0; s10 > l10; ) r10.f(e16, n11 = i10[l10++], t11[n11]);
      return e16;
    };
  }, function(e15, t10, n10) {
    var r10 = n10(39), o10 = n10(49);
    e15.exports = Object.keys || function(e16) {
      return r10(e16, o10);
    };
  }, function(e15, t10, n10) {
    var r10 = n10(33), o10 = n10(40), a10 = n10(43)(false), i10 = n10(46)("IE_PROTO");
    e15.exports = function(e16, t11) {
      var n11, s10 = o10(e16), l10 = 0, c10 = [];
      for (n11 in s10) n11 != i10 && r10(s10, n11) && c10.push(n11);
      for (; t11.length > l10; ) r10(s10, n11 = t11[l10++]) && (~a10(c10, n11) || c10.push(n11));
      return c10;
    };
  }, function(e15, t10, n10) {
    var r10 = n10(41), o10 = n10(29);
    e15.exports = function(e16) {
      return r10(o10(e16));
    };
  }, function(e15, t10, n10) {
    var r10 = n10(42);
    e15.exports = Object("z").propertyIsEnumerable(0) ? Object : function(e16) {
      return "String" == r10(e16) ? e16.split("") : Object(e16);
    };
  }, function(e15, t10) {
    var n10 = {}.toString;
    e15.exports = function(e16) {
      return n10.call(e16).slice(8, -1);
    };
  }, function(e15, t10, n10) {
    var r10 = n10(40), o10 = n10(44), a10 = n10(45);
    e15.exports = function(e16) {
      return function(t11, n11, i10) {
        var s10, l10 = r10(t11), c10 = o10(l10.length), u10 = a10(i10, c10);
        if (e16 && n11 != n11) {
          for (; c10 > u10; ) if ((s10 = l10[u10++]) != s10) return true;
        } else for (; c10 > u10; u10++) if ((e16 || u10 in l10) && l10[u10] === n11) return e16 || u10 || 0;
        return !e16 && -1;
      };
    };
  }, function(e15, t10, n10) {
    var r10 = n10(28), o10 = Math.min;
    e15.exports = function(e16) {
      return e16 > 0 ? o10(r10(e16), 9007199254740991) : 0;
    };
  }, function(e15, t10, n10) {
    var r10 = n10(28), o10 = Math.max, a10 = Math.min;
    e15.exports = function(e16, t11) {
      return (e16 = r10(e16)) < 0 ? o10(e16 + t11, 0) : a10(e16, t11);
    };
  }, function(e15, t10, n10) {
    var r10 = n10(47)("keys"), o10 = n10(48);
    e15.exports = function(e16) {
      return r10[e16] || (r10[e16] = o10(e16));
    };
  }, function(e15, t10, n10) {
    var r10 = n10(6), o10 = "__core-js_shared__", a10 = r10[o10] || (r10[o10] = {});
    e15.exports = function(e16) {
      return a10[e16] || (a10[e16] = {});
    };
  }, function(e15, t10) {
    var n10 = 0, r10 = Math.random();
    e15.exports = function(e16) {
      return "Symbol(".concat(void 0 === e16 ? "" : e16, ")_", (++n10 + r10).toString(36));
    };
  }, function(e15, t10) {
    e15.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, function(e15, t10, n10) {
    var r10 = n10(6).document;
    e15.exports = r10 && r10.documentElement;
  }, function(e15, t10, n10) {
    var r10 = n10(11).f, o10 = n10(33), a10 = n10(52)("toStringTag");
    e15.exports = function(e16, t11, n11) {
      e16 && !o10(e16 = n11 ? e16 : e16.prototype, a10) && r10(e16, a10, { configurable: true, value: t11 });
    };
  }, function(e15, t10, n10) {
    var r10 = n10(47)("wks"), o10 = n10(48), a10 = n10(6).Symbol, i10 = "function" == typeof a10;
    (e15.exports = function(e16) {
      return r10[e16] || (r10[e16] = i10 && a10[e16] || (i10 ? a10 : o10)("Symbol." + e16));
    }).store = r10;
  }, function(e15, t10, n10) {
    var r10 = n10(33), o10 = n10(54), a10 = n10(46)("IE_PROTO"), i10 = Object.prototype;
    e15.exports = Object.getPrototypeOf || function(e16) {
      return e16 = o10(e16), r10(e16, a10) ? e16[a10] : "function" == typeof e16.constructor && e16 instanceof e16.constructor ? e16.constructor.prototype : e16 instanceof Object ? i10 : null;
    };
  }, function(e15, t10, n10) {
    var r10 = n10(29);
    e15.exports = function(e16) {
      return Object(r10(e16));
    };
  }, function(e15, t10, n10) {
    var r10 = n10(8), o10 = n10(5), a10 = n10(54), i10 = n10(56), s10 = n10(57), l10 = n10(44), c10 = n10(58), u10 = n10(59);
    o10(o10.S + o10.F * !n10(61)(function(e16) {
      Array.from(e16);
    }), "Array", { from: function(e16) {
      var t11, n11, o11, d10, p10 = a10(e16), m10 = "function" == typeof this ? this : Array, h10 = arguments.length, f10 = h10 > 1 ? arguments[1] : void 0, g10 = void 0 !== f10, y10 = 0, v10 = u10(p10);
      if (g10 && (f10 = r10(f10, h10 > 2 ? arguments[2] : void 0, 2)), null == v10 || m10 == Array && s10(v10)) for (n11 = new m10(t11 = l10(p10.length)); t11 > y10; y10++) c10(n11, y10, g10 ? f10(p10[y10], y10) : p10[y10]);
      else for (d10 = v10.call(p10), n11 = new m10(); !(o11 = d10.next()).done; y10++) c10(n11, y10, g10 ? i10(d10, f10, [o11.value, y10], true) : o11.value);
      return n11.length = y10, n11;
    } });
  }, function(e15, t10, n10) {
    var r10 = n10(12);
    e15.exports = function(e16, t11, n11, o10) {
      try {
        return o10 ? t11(r10(n11)[0], n11[1]) : t11(n11);
      } catch (t12) {
        var a10 = e16.return;
        throw void 0 !== a10 && r10(a10.call(e16)), t12;
      }
    };
  }, function(e15, t10, n10) {
    var r10 = n10(34), o10 = n10(52)("iterator"), a10 = Array.prototype;
    e15.exports = function(e16) {
      return void 0 !== e16 && (r10.Array === e16 || a10[o10] === e16);
    };
  }, function(e15, t10, n10) {
    var r10 = n10(11), o10 = n10(19);
    e15.exports = function(e16, t11, n11) {
      t11 in e16 ? r10.f(e16, t11, o10(0, n11)) : e16[t11] = n11;
    };
  }, function(e15, t10, n10) {
    var r10 = n10(60), o10 = n10(52)("iterator"), a10 = n10(34);
    e15.exports = n10(7).getIteratorMethod = function(e16) {
      if (null != e16) return e16[o10] || e16["@@iterator"] || a10[r10(e16)];
    };
  }, function(e15, t10, n10) {
    var r10 = n10(42), o10 = n10(52)("toStringTag"), a10 = "Arguments" == r10(/* @__PURE__ */ function() {
      return arguments;
    }()), i10 = function(e16, t11) {
      try {
        return e16[t11];
      } catch (e17) {
      }
    };
    e15.exports = function(e16) {
      var t11, n11, s10;
      return void 0 === e16 ? "Undefined" : null === e16 ? "Null" : "string" == typeof (n11 = i10(t11 = Object(e16), o10)) ? n11 : a10 ? r10(t11) : "Object" == (s10 = r10(t11)) && "function" == typeof t11.callee ? "Arguments" : s10;
    };
  }, function(e15, t10, n10) {
    var r10 = n10(52)("iterator"), o10 = false;
    try {
      var a10 = [7][r10]();
      a10.return = function() {
        o10 = true;
      }, Array.from(a10, function() {
        throw 2;
      });
    } catch (e16) {
    }
    e15.exports = function(e16, t11) {
      if (!t11 && !o10) return false;
      var n11 = false;
      try {
        var a11 = [7], i10 = a11[r10]();
        i10.next = function() {
          return { done: n11 = true };
        }, a11[r10] = function() {
          return i10;
        }, e16(a11);
      } catch (e17) {
      }
      return n11;
    };
  }, function(e15, t10, n10) {
    e15.exports = { default: n10(63), __esModule: true };
  }, function(e15, t10, n10) {
    var r10 = n10(7), o10 = r10.JSON || (r10.JSON = { stringify: JSON.stringify });
    e15.exports = function(e16) {
      return o10.stringify.apply(o10, arguments);
    };
  }, function(e15, t10) {
    e15.exports = { name: "en-US", months: ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"], monthsShort: ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"], days: ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"], daysShort: ["su", "mo", "tu", "we", "th", "fr", "sa"], thousandSeparator: " ", decimalSeparator: ".", formats: { "General Number": "#.#", Currency: "$ #,##0.00;[Red]$ -#,##0.00", Fixed: "0.00", Standard: "#,##0.00", Percent: "0.00%", Scientific: "0.00E+00", "Yes/No": '"Yes";"Yes";"No"', "True/False": '"True";"True";"False"', "On/Off": '"On";"On";"Off"', "Short Date": "mm.dd.yyyy", "Long Date": "dd mmmm yyyy", "General Date": "mm.dd.yyyy h:mm", "Medium Date": "dd.mmm.yy", "Long Time": "hh:mm:ss AM/PM", "Short Time": "h:mm", "Medium Time": "hh:mm AM/PM" } };
  }])), Si.exports;
  var e14;
}
var wi;
function Ti() {
  if (wi) return bi;
  wi = 1, Object.defineProperty(bi, "__esModule", { value: true }), bi.specifyPrecision = bi.formatNumberWithPattern = void 0;
  var e14 = Ae.__importDefault(xi());
  var t10 = {};
  return bi.formatNumberWithPattern = function(n10, r10, o10) {
    var a10;
    var i10 = o10.decimalSeparator + "<|>" + o10.thousandSeparator;
    var s10 = null !== (a10 = t10[i10]) && void 0 !== a10 ? a10 : t10[i10] = new e14.default({ locale: i10, locales: [(l10 = i10, c10 = o10, { name: l10, thousandSeparator: c10.thousandSeparator, decimalSeparator: c10.decimalSeparator, formats: {} })] });
    var l10, c10;
    r10 = r10.replace(/ /g, "\\ ").replace(/\.([^0\#])/g, "$1").replace(/['"]/g, "");
    var u10 = s10.format(n10, "Number", r10).value;
    return null != u10 ? u10 : "";
  }, bi.specifyPrecision = function(e15, t11, n10) {
    return void 0 === n10 && (n10 = true), e15.replace(/\.[0#]*/g, (t11 ? "." : "") + (n10 ? "0" : "#").repeat(t11));
  }, bi;
}
var Ei;
function Fi() {
  if (Ei) return vi;
  Ei = 1, Object.defineProperty(vi, "__esModule", { value: true }), vi.formatNumber = void 0;
  var e14 = Ti();
  var t10 = { p: "Percent", c: "Currency" };
  var n10 = /^[cdefgnprx][0-9]*$/i;
  return vi.formatNumber = function(r10, o10, a10) {
    if (isNaN(r10)) return r10.toString();
    var i10 = o10 || "g";
    if (n10.test(i10)) {
      var s10 = i10[0].toLowerCase();
      var l10 = i10.substr(1) ? parseInt(i10.substr(1), 10) || 0 : void 0;
      switch (s10) {
        case "x":
          var c10 = Math.round(r10).toString(16).toLowerCase();
          return l10 && c10.length < l10 && (c10 = "0".repeat(l10 - c10.length) + c10), "X" === i10[0] && (c10 = c10.toUpperCase()), c10;
        case "r":
          return r10.toString();
        case "g":
          i10 = function(e15, t11) {
            if (!e15) return "0";
            var n11 = t11 || 15;
            var r11 = parseFloat(e15.toExponential().toLowerCase().split("e")[1]);
            if (r11 > -5 && r11 < n11) {
              var o11 = n11 - r11 - 1;
              return "0" + (!Number.isInteger(e15) && o11 > 0 && !/\.0+$/.test(e15.toFixed(o11)) ? "." + "#".repeat(o11) : "");
            }
            return "0" + (n11 > 1 ? ".0" : "") + (n11 > 2 ? "#".repeat(n11 - 2) : "") + "E+######00";
          }(r10, null != l10 ? l10 : 0);
          break;
        case "d":
          i10 = "0".repeat(Math.max(null != l10 ? l10 : 0, 1));
          break;
        case "f":
          i10 = "0.00";
          break;
        case "n":
          i10 = "#,##0.##";
          break;
        case "e":
          i10 = "0.000000E+000";
          break;
        default:
          return a10.Format(r10, t10[s10], l10);
      }
      ["f", "n", "e"].includes(s10) && null != l10 && (i10 = e14.specifyPrecision(i10, l10));
    }
    return e14.formatNumberWithPattern(r10, i10, a10.FormatInfo);
  }, vi;
}
Si.exports;
var Mi = {};
var ki = {};
var Pi;
var Ni = {};
var Di = {};
var Li = {};
var Hi;
var Ii = {};
var _i;
var Vi = {};
var Ri;
var Ai = {};
var Oi;
var Bi = {};
var zi;
var $i = {};
var Wi;
var ji = {};
var Zi;
var Gi = {};
var Ui;
var qi = {};
var Yi;
var Ki = {};
var Xi;
var Ji = {};
var Qi;
var es = {};
var ts;
var ns = {};
var rs;
var os = {};
var as;
var is = {};
var ss;
var ls = {};
var cs;
var us = {};
var ds;
var ps;
function ms() {
  if (ps) return Di;
  ps = 1, Object.defineProperty(Di, "__esModule", { value: true }), Di.locales = Di.getLocaleSafeName = Di.addLocale = void 0;
  var e14 = Ae;
  var t10 = e14.__importDefault((Hi || (Hi = 1, Object.defineProperty(Li, "__esModule", { value: true }), Li.default = { name: "be-by", months: ["\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C", "\u043B\u044E\u0442\u044B", "\u0441\u0430\u043A\u0430\u0432\u0456\u043A", "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A", "\u043C\u0430\u0439", "\u0447\u044D\u0440\u0432\u0435\u043D\u044C", "\u043B\u0456\u043F\u0435\u043D\u044C", "\u0436\u043D\u0456\u0432\u0435\u043D\u044C", "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C", "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A", "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434", "\u0441\u043D\u0435\u0436\u0430\u043D\u044C", ""], monthsDeclined: ["\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F", "\u043B\u044E\u0442\u0430\u0433\u0430", "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430", "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430", "\u043C\u0430\u044F", "\u0447\u044D\u0440\u0432\u0435\u043D\u044F", "\u043B\u0456\u043F\u0435\u043D\u044F", "\u0436\u043D\u0456\u045E\u043D\u044F", "\u0432\u0435\u0440\u0430\u0441\u043D\u044F", "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430", "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430", "\u0441\u043D\u0435\u0436\u043D\u044F", ""], monthsShort: ["\u0441\u0442\u0443\u0434\u0437", "\u043B\u044E\u0442", "\u0441\u0430\u043A", "\u043A\u0440\u0430\u0441", "\u043C\u0430\u0439", "\u0447\u044D\u0440\u0432", "\u043B\u0456\u043F", "\u0436\u043D", "\u0432\u0435\u0440", "\u043A\u0430\u0441\u0442\u0440", "\u043B\u0456\u0441\u0442", "\u0441\u043D\u0435\u0436", ""], days: ["\u043D\u044F\u0434\u0437\u0435\u043B\u044F", "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A", "\u0430\u045E\u0442\u043E\u0440\u0430\u043A", "\u0441\u0435\u0440\u0430\u0434\u0430", "\u0447\u0430\u0446\u0432\u0435\u0440", "\u043F\u044F\u0442\u043D\u0456\u0446\u0430", "\u0441\u0443\u0431\u043E\u0442\u0430"], daysShort: ["\u043D\u0434", "\u043F\u043D", "\u0430\u045E\u0442", "\u0441\u0440", "\u0447\u0446", "\u043F\u0442", "\u0441\u0431"], quarters: ["1", "2", "3", "4"], amPm: ["", ""], amPmShort: ["", ""], era: "\u043D.\u044D.", thousandSeparator: "\xA0", decimalSeparator: ",", formats: { Percent: "###,###,##0.00 %;-###,###,##0.00 %", Currency: "###,###,##0.00 Br;-###,###,##0.00 Br", "Short date": "dd.MM.yy", "Long date": "d MMMM yyyy", "Month/day": "d MMMM", "Short time": "HH:mm", "Long time": "HH:mm:ss", "Year/month": "MMMM yyyy \u0433." } }), Li));
  var n10 = e14.__importDefault((_i || (_i = 1, Object.defineProperty(Ii, "__esModule", { value: true }), Ii.default = { name: "de-de", months: ["Januar", "Februar", "M\xE4rz", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember", ""], monthsDeclined: ["Januar", "Februar", "M\xE4rz", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember", ""], monthsShort: ["Jan", "Feb", "Mrz", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez", ""], days: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"], daysShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"], quarters: ["1", "2", "3", "4"], amPm: ["", ""], amPmShort: ["", ""], era: "n. Chr.", thousandSeparator: ".", decimalSeparator: ",", formats: { Percent: "###,###,##0.00%;-###,###,##0.00%", Currency: "###,###,##0.00 \u20AC;-###,###,##0.00 \u20AC", "Short date": "dd.MM.yyyy", "Long date": "dddd, d. MMMM yyyy", "Month/day": "dd MMMM", "Short time": "HH:mm", "Long time": "HH:mm:ss", "Year/month": "MMMM yyyy" } }), Ii));
  var r10 = e14.__importDefault((Ri || (Ri = 1, Object.defineProperty(Vi, "__esModule", { value: true }), Vi.default = { name: "en-ca", months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December", ""], monthsDeclined: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December", ""], monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", ""], days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], quarters: ["Q1", "Q2", "Q3", "Q4"], amPm: ["AM", "PM"], amPmShort: ["A", "P"], era: "A.D.", thousandSeparator: ",", decimalSeparator: ".", formats: { Percent: "###,###,##0.00 %;-###,###,##0.00 %", Currency: "$###,###,##0.00;-$###,###,##0.00", "Short date": "dd/MM/yyyy", "Long date": "MMMM-dd-yy", "Month/day": "MMMM dd", "Short time": "h:mm tt", "Long time": "h:mm:ss tt", "Year/month": "MMMM, yyyy" } }), Vi));
  var o10 = e14.__importDefault((Oi || (Oi = 1, Object.defineProperty(Ai, "__esModule", { value: true }), Ai.default = { name: "en-gb", months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December", ""], monthsDeclined: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December", ""], monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", ""], days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], quarters: ["Q1", "Q2", "Q3", "Q4"], amPm: ["AM", "PM"], amPmShort: ["A", "P"], era: "A.D.", thousandSeparator: ",", decimalSeparator: ".", formats: { Percent: "###,###,##0.00 %;-###,###,##0.00 %", Currency: "\xA3###,###,##0.00;-\xA3###,###,##0.00", "Short date": "dd/MM/yyyy", "Long date": "dd MMMM yyyy", "Month/day": "dd MMMM", "Short time": "HH:mm", "Long time": "HH:mm:ss", "Year/month": "MMMM yyyy" } }), Ai));
  var a10 = e14.__importDefault((zi || (zi = 1, Object.defineProperty(Bi, "__esModule", { value: true }), Bi.default = { name: "en-us", months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December", ""], monthsDeclined: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December", ""], monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", ""], days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], quarters: ["Q1", "Q2", "Q3", "Q4"], amPm: ["AM", "PM"], amPmShort: ["A", "P"], era: "A.D.", thousandSeparator: ",", decimalSeparator: ".", formats: { Percent: "###,###,##0.00 %;-###,###,##0.00 %", Currency: "$###,###,##0.00;($###,###,##0.00)", "Short date": "M/d/yyyy", "Long date": "dddd, MMMM dd, yyyy", "Month/day": "MMMM dd", "Short time": "h:mm tt", "Long time": "h:mm:ss tt", "Year/month": "MMMM, yyyy" } }), Bi));
  var i10 = e14.__importDefault((Wi || (Wi = 1, Object.defineProperty($i, "__esModule", { value: true }), $i.default = { name: "es-es", months: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre", ""], monthsDeclined: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre", ""], monthsShort: ["ene.", "feb.", "mar.", "abr.", "may.", "jun.", "jul.", "ago.", "sep.", "oct.", "nov.", "dic.", ""], days: ["domingo", "lunes", "martes", "mi\xE9rcoles", "jueves", "viernes", "s\xE1bado"], daysShort: ["do.", "lu.", "ma.", "mi.", "ju.", "vi.", "s\xE1."], quarters: ["1", "2", "3", "4"], amPm: ["", ""], amPmShort: ["", ""], era: "d. C.", thousandSeparator: ".", decimalSeparator: ",", formats: { Percent: "###,###,##0.00 %;-###,###,##0.00 %", Currency: "###,###,##0.00 \u20AC;-###,###,##0.00 \u20AC", "Short date": "dd/MM/yyyy", "Long date": 'dddd, d" de "MMMM" de "yyyy', "Month/day": 'd "de" MMMM', "Short time": "H:mm", "Long time": "H:mm:ss", "Year/month": 'MMMM" de "yyyy' } }), $i));
  var s10 = e14.__importDefault((Zi || (Zi = 1, Object.defineProperty(ji, "__esModule", { value: true }), ji.default = { name: "ja-jp", months: ["1\u6708", "2\u6708", "3\u6708", "4\u6708", "5\u6708", "6\u6708", "7\u6708", "8\u6708", "9\u6708", "10\u6708", "11\u6708", "12\u6708", ""], monthsDeclined: ["1\u6708", "2\u6708", "3\u6708", "4\u6708", "5\u6708", "6\u6708", "7\u6708", "8\u6708", "9\u6708", "10\u6708", "11\u6708", "12\u6708", ""], monthsShort: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", ""], days: ["\u65E5\u66DC\u65E5", "\u6708\u66DC\u65E5", "\u706B\u66DC\u65E5", "\u6C34\u66DC\u65E5", "\u6728\u66DC\u65E5", "\u91D1\u66DC\u65E5", "\u571F\u66DC\u65E5"], daysShort: ["\u65E5", "\u6708", "\u706B", "\u6C34", "\u6728", "\u91D1", "\u571F"], quarters: ["Q1", "Q2", "Q3", "Q4"], amPm: ["\u5348\u524D", "\u5348\u5F8C"], amPmShort: ["\u5348", "\u5348"], era: "\u897F\u66A6", thousandSeparator: ",", decimalSeparator: ".", formats: { Percent: "###,###,##0.00%;-###,###,##0.00%", Currency: "\xA5###,###,##0.;-\xA5###,###,##0.", "Short date": "yyyy/MM/dd", "Long date": 'yyyy"\u5E74"M"\u6708"d"\u65E5"', "Month/day": 'M"\u6708"d"\u65E5"', "Short time": "H:mm", "Long time": "H:mm:ss", "Year/month": 'yyyy"\u5E74"M"\u6708"' } }), ji));
  var l10 = e14.__importDefault((Ui || (Ui = 1, Object.defineProperty(Gi, "__esModule", { value: true }), Gi.default = { name: "ko-kr", months: ["1\uC6D4", "2\uC6D4", "3\uC6D4", "4\uC6D4", "5\uC6D4", "6\uC6D4", "7\uC6D4", "8\uC6D4", "9\uC6D4", "10\uC6D4", "11\uC6D4", "12\uC6D4", ""], monthsDeclined: ["1\uC6D4", "2\uC6D4", "3\uC6D4", "4\uC6D4", "5\uC6D4", "6\uC6D4", "7\uC6D4", "8\uC6D4", "9\uC6D4", "10\uC6D4", "11\uC6D4", "12\uC6D4", ""], monthsShort: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", ""], days: ["\uC77C\uC694\uC77C", "\uC6D4\uC694\uC77C", "\uD654\uC694\uC77C", "\uC218\uC694\uC77C", "\uBAA9\uC694\uC77C", "\uAE08\uC694\uC77C", "\uD1A0\uC694\uC77C"], daysShort: ["\uC77C", "\uC6D4", "\uD654", "\uC218", "\uBAA9", "\uAE08", "\uD1A0"], quarters: ["1", "2", "3", "4"], amPm: ["\uC624\uC804", "\uC624\uD6C4"], amPmShort: ["\uC624", "\uC624"], era: "\uC11C\uAE30", thousandSeparator: ",", decimalSeparator: ".", formats: { Percent: "###,###,##0.00%;-###,###,##0.00%", Currency: "\u20A9###,###,##0.;-\u20A9###,###,##0.", "Short date": "yyyy-MM-dd", "Long date": 'yyyy"\uB144" M"\uC6D4" d"\uC77C" dddd', "Month/day": "M\uC6D4 d\uC77C", "Short time": "tt h:mm", "Long time": "tt h:mm:ss", "Year/month": 'yyyy"\uB144" M"\uC6D4"' } }), Gi));
  var c10 = e14.__importDefault((Yi || (Yi = 1, Object.defineProperty(qi, "__esModule", { value: true }), qi.default = { name: "nl-be", months: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december", ""], monthsDeclined: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december", ""], monthsShort: ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec", ""], days: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"], daysShort: ["zo", "ma", "di", "wo", "do", "vr", "za"], quarters: ["1", "2", "3", "4"], amPm: ["", ""], amPmShort: ["", ""], era: "A.D.", thousandSeparator: ".", decimalSeparator: ",", formats: { Percent: "###,###,##0.00%;-###,###,##0.00%", Currency: "\u20AC ###,###,##0.00;\u20AC -###,###,##0.00", "Short date": "d/MM/yyyy", "Long date": "dddd d MMMM yyyy", "Month/day": "d MMMM", "Short time": "H:mm", "Long time": "H:mm:ss", "Year/month": "MMMM yyyy" } }), qi));
  var u10 = e14.__importDefault((Xi || (Xi = 1, Object.defineProperty(Ki, "__esModule", { value: true }), Ki.default = { name: "nl-nl", months: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december", ""], monthsDeclined: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december", ""], monthsShort: ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec", ""], days: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"], daysShort: ["zo", "ma", "di", "wo", "do", "vr", "za"], quarters: ["1", "2", "3", "4"], amPm: ["", ""], amPmShort: ["", ""], era: "n.Chr.", thousandSeparator: ".", decimalSeparator: ",", formats: { Percent: "###,###,##0.00%;-###,###,##0.00%", Currency: "\u20AC ###,###,##0.00;\u20AC -###,###,##0.00", "Short date": "d-M-yyyy", "Long date": "dddd d MMMM yyyy", "Month/day": "d MMMM", "Short time": "HH:mm", "Long time": "HH:mm:ss", "Year/month": "MMMM yyyy" } }), Ki));
  var d10 = e14.__importDefault((Qi || (Qi = 1, Object.defineProperty(Ji, "__esModule", { value: true }), Ji.default = { name: "pt-br", months: ["janeiro", "fevereiro", "mar\xE7o", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro", ""], monthsDeclined: ["janeiro", "fevereiro", "mar\xE7o", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro", ""], monthsShort: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez", ""], days: ["domingo", "segunda-feira", "ter\xE7a-feira", "quarta-feira", "quinta-feira", "sexta-feira", "s\xE1bado"], daysShort: ["dom", "seg", "ter", "qua", "qui", "sex", "s\xE1b"], quarters: ["Q1", "Q2", "Q3", "Q4"], amPm: ["", ""], amPmShort: ["", ""], era: "d.C.", thousandSeparator: ".", decimalSeparator: ",", formats: { Percent: "###,###,##0.00%;-###,###,##0.00%", Currency: "R$ ###,###,##0.00;-R$ ###,###,##0.00", "Short date": "dd/MM/yyyy", "Long date": 'dddd, d" de "MMMM" de "yyyy', "Month/day": 'd "de" MMMM', "Short time": "HH:mm", "Long time": "HH:mm:ss", "Year/month": 'MMMM" de "yyyy' } }), Ji));
  var p10 = e14.__importDefault((ts || (ts = 1, Object.defineProperty(es, "__esModule", { value: true }), es.default = { name: "ru-ru", months: ["\u042F\u043D\u0432\u0430\u0440\u044C", "\u0424\u0435\u0432\u0440\u0430\u043B\u044C", "\u041C\u0430\u0440\u0442", "\u0410\u043F\u0440\u0435\u043B\u044C", "\u041C\u0430\u0439", "\u0418\u044E\u043D\u044C", "\u0418\u044E\u043B\u044C", "\u0410\u0432\u0433\u0443\u0441\u0442", "\u0421\u0435\u043D\u0442\u044F\u0431\u0440\u044C", "\u041E\u043A\u0442\u044F\u0431\u0440\u044C", "\u041D\u043E\u044F\u0431\u0440\u044C", "\u0414\u0435\u043A\u0430\u0431\u0440\u044C", ""], monthsDeclined: ["\u044F\u043D\u0432\u0430\u0440\u044F", "\u0444\u0435\u0432\u0440\u0430\u043B\u044F", "\u043C\u0430\u0440\u0442\u0430", "\u0430\u043F\u0440\u0435\u043B\u044F", "\u043C\u0430\u044F", "\u0438\u044E\u043D\u044F", "\u0438\u044E\u043B\u044F", "\u0430\u0432\u0433\u0443\u0441\u0442\u0430", "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F", "\u043E\u043A\u0442\u044F\u0431\u0440\u044F", "\u043D\u043E\u044F\u0431\u0440\u044F", "\u0434\u0435\u043A\u0430\u0431\u0440\u044F", ""], monthsShort: ["\u044F\u043D\u0432", "\u0444\u0435\u0432", "\u043C\u0430\u0440", "\u0430\u043F\u0440", "\u043C\u0430\u0439", "\u0438\u044E\u043D", "\u0438\u044E\u043B", "\u0430\u0432\u0433", "\u0441\u0435\u043D", "\u043E\u043A\u0442", "\u043D\u043E\u044F", "\u0434\u0435\u043A", ""], days: ["\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435", "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A", "\u0432\u0442\u043E\u0440\u043D\u0438\u043A", "\u0441\u0440\u0435\u0434\u0430", "\u0447\u0435\u0442\u0432\u0435\u0440\u0433", "\u043F\u044F\u0442\u043D\u0438\u0446\u0430", "\u0441\u0443\u0431\u0431\u043E\u0442\u0430"], daysShort: ["\u0412\u0441", "\u041F\u043D", "\u0412\u0442", "\u0421\u0440", "\u0427\u0442", "\u041F\u0442", "\u0421\u0431"], quarters: ["1", "2", "3", "4"], amPm: ["", ""], amPmShort: ["", ""], era: "A.D.", thousandSeparator: "\xA0", decimalSeparator: ",", formats: { Percent: "###,###,##0.00%;-###,###,##0.00%", Currency: "###,###,##0.00 \u20BD;-###,###,##0.00 \u20BD", "Short date": "dd.MM.yyyy", "Long date": 'd MMMM yyyy "\u0433."', "Month/day": "MMMM dd", "Short time": "H:mm", "Long time": "H:mm:ss", "Year/month": "MMMM yyyy" } }), es));
  var m10 = e14.__importDefault((rs || (rs = 1, Object.defineProperty(ns, "__esModule", { value: true }), ns.default = { name: "zh-cn", months: ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708", ""], monthsDeclined: ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708", ""], monthsShort: ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708", ""], days: ["\u661F\u671F\u65E5", "\u661F\u671F\u4E00", "\u661F\u671F\u4E8C", "\u661F\u671F\u4E09", "\u661F\u671F\u56DB", "\u661F\u671F\u4E94", "\u661F\u671F\u516D"], daysShort: ["\u5468\u65E5", "\u5468\u4E00", "\u5468\u4E8C", "\u5468\u4E09", "\u5468\u56DB", "\u5468\u4E94", "\u5468\u516D"], quarters: ["\u4E00\u5B63\u5EA6", "\u4E8C\u5B63\u5EA6", "\u4E09\u5B63\u5EA6", "\u56DB\u5B63\u5EA6"], amPm: ["\u4E0A\u5348", "\u4E0B\u5348"], amPmShort: ["\u4E0A", "\u4E0B"], era: "\u516C\u5143", thousandSeparator: ",", decimalSeparator: ".", formats: { Percent: "###,###,##0.00%;-###,###,##0.00%", Currency: "\xA5###,###,##0.00;\xA5-###,###,##0.00", "Short date": "yyyy/M/d", "Long date": 'yyyy"\u5E74"M"\u6708"d"\u65E5"', "Month/day": 'M"\u6708"d"\u65E5"', "Short time": "H:mm", "Long time": "H:mm:ss", "Year/month": 'yyyy"\u5E74"M"\u6708"' } }), ns));
  var h10 = e14.__importDefault((as || (as = 1, Object.defineProperty(os, "__esModule", { value: true }), os.default = { name: "zh-hk", months: ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708", ""], monthsDeclined: ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708", ""], monthsShort: ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708", ""], days: ["\u661F\u671F\u65E5", "\u661F\u671F\u4E00", "\u661F\u671F\u4E8C", "\u661F\u671F\u4E09", "\u661F\u671F\u56DB", "\u661F\u671F\u4E94", "\u661F\u671F\u516D"], daysShort: ["\u9031\u65E5", "\u9031\u4E00", "\u9031\u4E8C", "\u9031\u4E09", "\u9031\u56DB", "\u9031\u4E94", "\u9031\u516D"], quarters: ["1", "2", "3", "4"], amPm: ["\u4E0A\u5348", "\u4E0B\u5348"], amPmShort: ["\u4E0A", "\u4E0B"], era: "\u516C\u5143", thousandSeparator: ",", decimalSeparator: ".", formats: { Percent: "###,###,##0.00%;-###,###,##0.00%", Currency: "HK$###,###,##0.00;(HK$###,###,##0.00)", "Short date": "d/M/yyyy", "Long date": 'yyyy"\u5E74"M"\u6708"d"\u65E5"', "Month/day": "M\u6708d\u65E5", "Short time": "H:mm", "Long time": "H:mm:ss", "Year/month": 'yyyy"\u5E74"M"\u6708"' } }), os));
  var f10 = e14.__importDefault((ss || (ss = 1, Object.defineProperty(is, "__esModule", { value: true }), is.default = { name: "zh-mo", months: ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708", ""], monthsDeclined: ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708", ""], monthsShort: ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708", ""], days: ["\u661F\u671F\u65E5", "\u661F\u671F\u4E00", "\u661F\u671F\u4E8C", "\u661F\u671F\u4E09", "\u661F\u671F\u56DB", "\u661F\u671F\u4E94", "\u661F\u671F\u516D"], daysShort: ["\u9031\u65E5", "\u9031\u4E00", "\u9031\u4E8C", "\u9031\u4E09", "\u9031\u56DB", "\u9031\u4E94", "\u9031\u516D"], quarters: ["1", "2", "3", "4"], amPm: ["\u4E0A\u5348", "\u4E0B\u5348"], amPmShort: ["\u4E0A", "\u4E0B"], era: "\u516C\u5143", thousandSeparator: ",", decimalSeparator: ".", formats: { Percent: "###,###,##0.00%;-###,###,##0.00%", Currency: "MOP###,###,##0.00;-MOP###,###,##0.00", "Short date": "d/M/yyyy", "Long date": 'yyyy"\u5E74"M"\u6708"d"\u65E5"', "Month/day": "M\u6708d\u65E5", "Short time": "H:mm", "Long time": "H:mm:ss", "Year/month": 'yyyy"\u5E74"M"\u6708"' } }), is));
  var g10 = e14.__importDefault((cs || (cs = 1, Object.defineProperty(ls, "__esModule", { value: true }), ls.default = { name: "zh-sg", months: ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708", ""], monthsDeclined: ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708", ""], monthsShort: ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708", ""], days: ["\u661F\u671F\u65E5", "\u661F\u671F\u4E00", "\u661F\u671F\u4E8C", "\u661F\u671F\u4E09", "\u661F\u671F\u56DB", "\u661F\u671F\u4E94", "\u661F\u671F\u516D"], daysShort: ["\u5468\u65E5", "\u5468\u4E00", "\u5468\u4E8C", "\u5468\u4E09", "\u5468\u56DB", "\u5468\u4E94", "\u5468\u516D"], quarters: ["1", "2", "3", "4"], amPm: ["\u4E0A\u5348", "\u4E0B\u5348"], amPmShort: ["\u4E0A", "\u4E0B"], era: "\u516C\u5143", thousandSeparator: ",", decimalSeparator: ".", formats: { Percent: "###,###,##0.00%;-###,###,##0.00%", Currency: "$###,###,##0.00;-$###,###,##0.00", "Short date": "d/M/yyyy", "Long date": 'yyyy"\u5E74"M"\u6708"d"\u65E5"', "Month/day": "M\u6708d\u65E5", "Short time": "tt h:mm", "Long time": "tt h:mm:ss", "Year/month": 'yyyy"\u5E74"M"\u6708"' } }), ls));
  var y10 = e14.__importDefault((ds || (ds = 1, Object.defineProperty(us, "__esModule", { value: true }), us.default = { name: "zh-tw", months: ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708", ""], monthsDeclined: ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708", ""], monthsShort: ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708", ""], days: ["\u661F\u671F\u65E5", "\u661F\u671F\u4E00", "\u661F\u671F\u4E8C", "\u661F\u671F\u4E09", "\u661F\u671F\u56DB", "\u661F\u671F\u4E94", "\u661F\u671F\u516D"], daysShort: ["\u9031\u65E5", "\u9031\u4E00", "\u9031\u4E8C", "\u9031\u4E09", "\u9031\u56DB", "\u9031\u4E94", "\u9031\u516D"], quarters: ["1", "2", "3", "4"], amPm: ["\u4E0A\u5348", "\u4E0B\u5348"], amPmShort: ["\u4E0A", "\u4E0B"], era: "\u897F\u5143", thousandSeparator: ",", decimalSeparator: ".", formats: { Percent: "###,###,##0.00%;-###,###,##0.00%", Currency: "NT$###,###,##0.00;-NT$###,###,##0.00", "Short date": "yyyy/M/d", "Long date": 'yyyy"\u5E74"M"\u6708"d"\u65E5"', "Month/day": "M\u6708d\u65E5", "Short time": "tt hh:mm", "Long time": "tt hh:mm:ss", "Year/month": 'yyyy"\u5E74"M"\u6708"' } }), us));
  var v10 = {};
  function b10(t11) {
    var n11 = [];
    for (var r11 = 1; r11 < arguments.length; r11++) n11[r11 - 1] = arguments[r11];
    v10[t11.name] = t11, n11.forEach(function(n12) {
      if (n12) {
        var r12 = e14.__assign({}, t11);
        r12.name = n12.toLowerCase(), v10[r12.name] = r12;
      }
    });
  }
  Di.locales = v10, Di.addLocale = b10, b10(t10.default, "be"), b10(n10.default, "de"), b10(r10.default), b10(o10.default), b10(a10.default, "en"), b10(i10.default, "es"), b10(s10.default, "ja"), b10(l10.default, "ko"), b10(c10.default, "nl"), b10(u10.default), b10(d10.default), b10(p10.default, "ru"), b10(m10.default, "zh", "cn"), b10(h10.default), b10(f10.default), b10(g10.default), b10(y10.default);
  var S10 = "en-us";
  var C10 = "undefined" != typeof navigator ? (navigator.language || navigator.userLanguage || S10).toLowerCase() : S10;
  return Di.getLocaleSafeName = function(e15) {
    return e15 && v10[e15.toLowerCase()] ? e15.toLowerCase() : v10[C10] ? C10 : S10;
  }, Di;
}
var hs = {};
var fs = {};
var gs;
function ys() {
  return gs || (gs = 1, function(e14) {
    function t10(e15, t11, n11, r11, o11, a11) {
      return e15 > r11 || !(e15 < r11) && (t11 > o11 || !(t11 < o11) && n11 >= a11);
    }
    function n10(e15) {
      switch (e15) {
        case "\u4EE4\u548C":
          return "Reiwa";
        case "\u5E73\u6210":
          return "Heisei";
        case "\u662D\u548C":
          return "Shouwa";
        case "\u5927\u6B63":
          return "Taishou";
        case "\u660E\u6CBB":
          return "Meiji";
        default:
          throw new Error("unknown gengou: " + e15);
      }
    }
    var r10 = ["\uFF10", "\uFF11", "\uFF12", "\uFF13", "\uFF14", "\uFF15", "\uFF16", "\uFF17", "\uFF18", "\uFF19"];
    var o10 = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    function a10(e15) {
      var t11 = o10.indexOf(e15);
      return t11 >= 0 ? r10[t11] : e15;
    }
    function i10(e15, n11, r11) {
      return t10(e15, n11, r11, 2019, 5, 1) ? { gengou: "\u4EE4\u548C", nen: e15 - 2018 } : t10(e15, n11, r11, 1989, 1, 8) ? { gengou: "\u5E73\u6210", nen: e15 - 1988 } : t10(e15, n11, r11, 1926, 12, 25) ? { gengou: "\u662D\u548C", nen: e15 - 1925 } : t10(e15, n11, r11, 1912, 7, 30) ? { gengou: "\u5927\u6B63", nen: e15 - 1911 } : t10(e15, n11, r11, 1873, 1, 1) ? { gengou: "\u660E\u6CBB", nen: e15 - 1867 } : { gengou: "\u897F\u66A6", nen: e15 };
    }
    e14.toGengou = i10, e14.fromGengou = function(e15, t11) {
      if ((t11 = Math.floor(+t11)) < 0) throw new Error("invalid nen: " + t11);
      switch (e15) {
        case "\u4EE4\u548C":
          return 2018 + t11;
        case "\u5E73\u6210":
          return 1988 + t11;
        case "\u662D\u548C":
          return 1925 + t11;
        case "\u5927\u6B63":
          return 1911 + t11;
        case "\u660E\u6CBB":
          return 1867 + t11;
        case "\u897F\u66A6":
          return t11;
        default:
          throw new Error("invalid gengou: " + e15);
      }
    };
    var s10 = ["\u65E5", "\u6708", "\u706B", "\u6C34", "\u6728", "\u91D1", "\u571F"];
    function l10(e15) {
      this.year = e15.getFullYear(), this.month = e15.getMonth() + 1, this.day = e15.getDate(), this.hour = e15.getHours(), this.minute = e15.getMinutes(), this.second = e15.getSeconds(), this.msec = e15.getMilliseconds(), this.dayOfWeek = e15.getDay();
      var t11 = i10(this.year, this.month, this.day);
      this.gengou = t11.gengou, this.nen = t11.nen, this.youbi = s10[this.dayOfWeek];
    }
    function c10(e15, t11, n11, r11, o11, a11, i11) {
      return void 0 === r11 && (r11 = 0), void 0 === o11 && (o11 = 0), void 0 === a11 && (a11 = 0), void 0 === i11 && (i11 = 0), new l10(new Date(e15, t11 - 1, n11, r11, o11, a11, i11));
    }
    e14.toYoubi = function(e15) {
      return s10[e15];
    };
    var u10 = "{G}{N}\u5E74{M}\u6708{D}\u65E5\uFF08{W}\uFF09";
    var d10 = "{Y}-{M:2}-{D:2}";
    var p10 = "{Y}-{M:2}-{D:2} {h:2}:{m:2}:{s:2}";
    function m10(e15, t11) {
      var n11 = false;
      var r11 = 1;
      t11.forEach(function(e16) {
        switch (e16) {
          case "1":
            r11 = 1;
            break;
          case "2":
            r11 = 2;
            break;
          case "z":
            n11 = true;
        }
      });
      var o11 = e15.toString();
      return n11 && (o11 = o11.split("").map(a10).join("")), r11 > 1 && e15 < 10 && (o11 = (n11 ? "\uFF10" : "0") + o11), o11;
    }
    function h10(e15, t11) {
      var r11 = [];
      var o11;
      return (o11 = [], e15.split(/(\{[^}]+)\}/).forEach(function(e16) {
        if ("" !== e16) if ("{" === e16[0]) {
          var t12 = { opts: [] };
          var n11 = (e16 = e16.substring(1)).indexOf(":");
          if (e16.indexOf(":") >= 0) {
            t12.part = e16.substring(0, n11);
            var r12 = e16.substring(n11 + 1).trim();
            "" !== r12 && (r12.indexOf(",") >= 0 ? t12.opts = r12.split(/\s*,\s*/) : t12.opts = [r12]);
          } else t12.part = e16;
          o11.push(t12);
        } else o11.push(e16);
      }), o11).forEach(function(e16) {
        if ("string" == typeof e16) r11.push(e16);
        else switch (e16.part) {
          case "G":
            r11.push(function(e17, t12) {
              var r12 = "2";
              switch (t12.forEach(function(e18) {
                ["2", "1", "a", "alpha"].indexOf(e18) >= 0 && (r12 = e18);
              }), r12) {
                case "2":
                default:
                  return e17.gengou;
                case "1":
                  return e17.gengou[0];
                case "a":
                  return n10(e17.gengou)[0];
                case "alpha":
                  return n10(e17.gengou);
              }
            }(t11, e16.opts));
            break;
          case "N":
            r11.push(function(e17, t12) {
              return 1 === e17.nen && t12.indexOf("g") >= 0 ? "\u5143" : m10(e17.nen, t12);
            }(t11, e16.opts));
            break;
          case "M":
            r11.push(m10(t11.month, e16.opts));
            break;
          case "D":
            r11.push(m10(t11.day, e16.opts));
            break;
          case "W":
            r11.push(function(e17, t12) {
              var n11;
              switch (t12.forEach(function(e18) {
                ["1", "2", "3", "alpha"].indexOf(e18) >= 0 && (n11 = e18);
              }), n11) {
                case "1":
                default:
                  return e17.youbi;
                case "2":
                  return e17.youbi + "\u66DC";
                case "3":
                  return e17.youbi + "\u66DC\u65E5";
                case "alpha":
                  return dayOfWeek[e17.dayOfWeek];
              }
            }(t11, e16.opts));
            break;
          case "h":
            r11.push((a11 = t11.hour, i11 = e16.opts, s11 = false, i11.indexOf("12") >= 0 && (s11 = true, i11 = function(e17, t12) {
              var n11 = [];
              for (var r12 = 0; r12 < e17.length; r12++) {
                var o13 = e17[r12];
                o13 !== t12 && n11.push(o13);
              }
              return n11;
            }(i11, "12")), s11 && (a11 %= 12), m10(a11, i11)));
            break;
          case "m":
            r11.push(m10(t11.minute, e16.opts));
            break;
          case "s":
            r11.push(m10(t11.second, e16.opts));
            break;
          case "a":
            r11.push(function(e17, t12) {
              var n11 = "kanji";
              t12.forEach(function(e18) {
                switch (e18) {
                  case "am/pm":
                    n11 = "am/pm";
                    break;
                  case "AM/PM":
                    n11 = "AM/PM";
                }
              });
              var r12 = e17.hour < 12;
              switch (n11) {
                case "kanji":
                  return r12 ? "\u5348\u524D" : "\u5348\u5F8C";
                case "am/pm":
                  return r12 ? "am" : "pm";
                case "AM/PM":
                  return r12 ? "AM" : "PM";
                default:
                  throw new Error("unknown style for AM/PM");
              }
            }(t11, e16.opts));
            break;
          case "Y":
            r11.push((o12 = t11.year, e16.opts, o12.toString()));
        }
        var o12;
        var a11, i11, s11;
      }), r11.join("");
    }
    e14.f1 = u10, e14.f2 = "{G}{N}\u5E74{M}\u6708{D}\u65E5", e14.f3 = "{G:a}{N}.{M}.{D}", e14.f4 = "{G}{N:2}\u5E74{M:2}\u6708{D:2}\u65E5\uFF08{W}\uFF09", e14.f5 = "{G}{N:2}\u5E74{M:2}\u6708{D:2}\u65E5", e14.f6 = "{G:a}{N:2}.{M:2}.{D:2}", e14.f7 = "{G}{N}\u5E74{M}\u6708{D}\u65E5\uFF08{W}\uFF09 {a}{h:12}\u6642{m}\u5206{s}\u79D2", e14.f8 = "{G}{N:2}\u5E74{M:2}\u6708{D:2}\u65E5\uFF08{W}\uFF09 {a}{h:12,2}\u6642{m:2}\u5206{s:2}\u79D2", e14.f9 = "{G}{N}\u5E74{M}\u6708{D}\u65E5\uFF08{W}\uFF09 {a}{h:12}\u6642{m}\u5206", e14.f10 = "{G}{N:2}\u5E74{M:2}\u6708{D:2}\u65E5\uFF08{W}\uFF09 {a}{h:12,2}\u6642{m:2}\u5206", e14.f11 = "{G}{N:z}\u5E74{M:z}\u6708{D:z}\u65E5", e14.f12 = "{G}{N:z,2}\u5E74{M:z,2}\u6708{D:z,2}\u65E5", e14.f13 = d10, e14.f14 = p10, e14.fSqlDate = d10, e14.fSqlDateTime = p10, e14.format = function() {
      var e15 = arguments.length;
      var t11, n11, r11;
      if (0 === e15) return h10(u10, new l10(/* @__PURE__ */ new Date()));
      if (1 === e15) return h10(u10, o11(arguments[0]));
      for (null == (t11 = arguments[0]) && (t11 = u10), n11 = [], r11 = 1; r11 < arguments.length; r11++) n11.push(arguments[r11]);
      return 1 === n11.length ? h10(t11, o11(n11[0])) : h10(t11, c10.apply(null, n11));
      function o11(e16) {
        if (e16 instanceof Date) return new l10(e16);
        if ("string" == typeof e16) return function(e17) {
          var t12;
          if (t12 = e17.match(/^(\d{4})-(\d{2})-(\d{2})$/)) return c10(+t12[1], +t12[2], +t12[3]);
          if (t12 = e17.match(/^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/)) return c10(+t12[1], +t12[2], +t12[3], +t12[4], +t12[5], +t12[6]);
          throw new Error("cannot convert to KanjiDate");
        }(e16);
        throw new Error("cannot convert to KanjiDate");
      }
    };
  }(fs)), fs;
}
var vs;
function bs() {
  if (vs) return hs;
  vs = 1, Object.defineProperty(hs, "__esModule", { value: true }), hs.jpDate = void 0;
  var e14 = Ae.__importDefault(ys());
  var t10 = new Date(Date.UTC(1868, 8, 7));
  var n10 = new Date(Date.UTC(1873, 0, 1));
  return hs.jpDate = { getEra: function(r10, o10) {
    if (r10 < t10) throw new Error(r10 + " is incorrect gengou date. The Gengou calendar begins on September 8, 1868.");
    return r10 < n10 && (r10 = n10), o10 ? e14.default.format("{G:a}", r10.getFullYear(), r10.getMonth() + 1, r10.getDate()) : e14.default.toGengou(r10.getFullYear(), r10.getMonth() + 1, r10.getDate()).gengou;
  }, getYear: function(r10, o10, a10, i10) {
    var s10 = r10.getFullYear();
    if (i10 && (i10.startsWith("g") || i10.startsWith("G"))) {
      if (r10 < t10) throw new Error(r10 + " is incorrect gengou date. The Gengou calendar begins on September 8, 1868.");
      if (1 === (s10 = r10 < n10 ? s10 - t10.getFullYear() + 1 : e14.default.toGengou(r10.getFullYear(), r10.getMonth() + 1, r10.getDate()).nen) && o10.startsWith("Y") && i10.startsWith("g")) return "\u5143";
    }
    return a10(o10.length <= 2 ? s10 % 100 : s10, o10.length);
  } }, hs;
}
var Ss;
var Cs = {};
var xs = {};
var ws;
var Ts;
function Es() {
  if (Ts) return Cs;
  Ts = 1, Object.defineProperty(Cs, "__esModule", { value: true }), Cs.intlLocaleProvider = void 0;
  var e14 = Ae;
  var t10 = di();
  var n10 = (ws || (ws = 1, Object.defineProperty(xs, "__esModule", { value: true }), xs.currencyCodes = void 0, xs.currencyCodes = { "ar-AE": "AED", "ps-AF": "AFN", "sq-AL": "ALL", "hy-AM": "AMD", "nl-CW": "ANG", "ln-AO": "AOA", "es-AR": "ARS", "en-AU": "AUD", "nl-AW": "AWG", "az-Cyrl-AZ": "AZN", "bs-Cyrl-BA": "BAM", "en-BB": "BBD", "bn-BD": "BDT", "bg-BG": "BGN", "ar-BH": "BHD", "rn-BI": "BIF", "en-BM": "BMD", "ms-BN": "BND", "es-BO": "BOB", "pt-BR": "BRL", "en-BS": "BSD", "dz-BT": "BTN", "en-BW": "BWP", "ru-BY": "BYR", "en-BZ": "BZD", "fr-CA": "CAD", "lu-CD": "CDF", "rm-CH": "CHF", "es-CL": "CLP", "ii-CN": "CNY", "es-CO": "COP", "es-CR": "CRC", "es-CU": "CUP", "pt-CV": "CVE", "en-CZ": "CZK", "ar-DJ": "DJF", "da-DK": "DKK", "es-DO": "DOP", "kab-DZ": "DZD", "ar-EG": "EGP", "ar-ER": "ERN", "om-ET": "ETB", "en-DE": "EUR", "en-FJ": "FJD", "en-FK": "FKP", "en-GB": "GBP", "ka-GE": "GEL", "ak-GH": "GHS", "en-GG": "GGP", "en-GI": "GIP", "en-GM": "GMD", "fr-GN": "GNF", "es-GT": "GTQ", "en-GY": "GYD", "zh-HK": "HKD", "es-HN": "HNL", "hr-HR": "HRK", "fr-HT": "HTG", "en-HU": "HUF", "id-ID": "IDR", "ar-IL": "ILS", "kok-IN": "INR", "ar-IQ": "IQD", "fa-IR": "IRR", "en-IS": "ISK", "en-JM": "JMD", "ar-JO": "JOD", "ja-JP": "JPY", "saq-KE": "KES", "ru-KG": "KGS", "km-KH": "KHR", "ar-KM": "KMF", "ko-KP": "KPW", "ko-KR": "KRW", "ar-KW": "KWD", "en-KY": "KYD", "kk-KZ": "KZT", "lo-LA": "LAK", "ar-LB": "LBP", "ta-LK": "LKR", "vai-Latn-LR": "LRD", "en-LT": "LTL", "en-LV": "LVL", "ar-LY": "LYD", "ar-MA": "MAD", "ru-MD": "MDL", "mg-MG": "MGA", "sq-MK": "MKD", "my-MM": "MMK", "mn-Cyrl-MN": "MNT", "zh-Hant-MO": "MOP", "ar-MR": "MRO", "en-MU": "MUR", "en-MW": "MWK", "es-MX": "MXN", "ms-Latn-MY": "MYR", "mgh-MZ": "MZN", "naq-NA": "NAD", "ha-Latn-NG": "NGN", "es-NI": "NIO", "nn-NO": "NOK", "ne-NP": "NPR", "en-NZ": "NZD", "ar-OM": "OMR", "es-PA": "PAB", "es-PE": "PEN", "en-PG": "PGK", "es-PH": "PHP", "pa-Arab-PK": "PKR", "en-PL": "PLN", "es-PY": "PYG", "ar-QA": "QAR", "en-RO": "RON", "sr-Latn-RS": "RSD", "ru-RU": "RUB", "rw-RW": "RWF", "ar-SA": "SAR", "en-SB": "SBD", "en-SC": "SCR", "ar-SD": "SDG", "sv-SE": "SEK", "ms-Latn-SG": "SGD", "en-SH": "SHP", "en-SL": "SLL", "ar-SO": "SOS", "nl-SR": "SRD", "pt-ST": "STD", "ar-SY": "SYP", "en-SZ": "SZL", "th-TH": "THB", "tg-Cyrl-TJ": "TJS", "tk-TM": "TMT", "ar-TN": "TND", "to-TO": "TOP", "tr-TR": "TRY", "en-TT": "TTD", "zh-Hant-TW": "TWD", "sw-TZ": "TZS", "ru-UA": "UAH", "teo-UG": "UGX", "en-US": "USD", "es-UY": "UYU", "uz-Cyrl-UZ": "UZS", "es-VE": "VEF", "vi-VN": "VND", "en-VU": "VUV", "en-WS": "WST", "ar-YE": "YER", "en-LS": "ZAR", "af-ZA": "ZMW", "am-ET": "ETB", "ar-DZ": "DZD", "bn-IN": "INR", "bo-CN": "CNY", "br-FR": "EUR", "ca-ES": "EUR", "co-FR": "EUR", "cs-CZ": "CZK", "cy-GB": "GBP", "de-AT": "EUR", "de-CH": "CHF", "de-DE": "EUR", "de-LI": "CHF", "de-LU": "EUR", "el-GR": "EUR", "en-CA": "CAD", "en-IE": "EUR", "en-IN": "INR", "en-MY": "MYR", "en-PH": "PHP", "en-SG": "SGD", "en-ZA": "ZAR", "en-ZW": "USD", "es-EC": "USD", "es-ES": "EUR", "es-PR": "USD", "es-SV": "USD", "es-US": "USD", "es-EE": "USD", "fi-FI": "EUR", "fil-PH": "PHP", "fo-FO": "DKK", "fr-BE": "EUR", "fr-CH": "EUR", "fr-FR": "EUR", "fr-LU": "EUR", "fr-MC": "EUR", "fy-NL": "EUR", "ga-IE": "EUR", "gl-ES": "EUR", "gu-IN": "INR", "he-IL": "ILS", "hi-IN": "INR", "hr-BA": "BAM", "hu-HU": "HUF", "ig-NG": "NGN", "is-IS": "ISK", "it-CH": "EUR", "it-IT": "EUR", "kl-GL": "DKK", "kn-IN": "INR", "ky-KG": "KGS", "lb-LU": "EUR", "lt-LT": "EUR", "lv-LV": "EUR", "mi-NZ": "NZD", "mk-MK": "MKD", "ml-IN": "INR", "mr-IN": "INR", "ms-MY": "MYR", "mt-MT": "EUR", "nb-NO": "NOK", "nl-BE": "EUR", "nl-NL": "EUR", "oc-FR": "EUR", "or-IN": "INR", "pa-IN": "INR", "pl-PL": "PLN", "pt-PT": "EUR", "rp-RO": "USD", "sa-IN": "INR", "se-FI": "EUR", "se-NO": "NOK", "se-SE": "SEK", "si-LK": "LKR", "sk-SK": "EUR", "sl-SL": "EUR", "sv-FI": "EUR", "sw-KE": "KES", "syr-SY": "SYP", "ta-IN": "INR", "te-IN": "INR", "tn-ZA": "ZAR", "ug-CN": "CNY", "uk-UA": "UAH", "ur-PK": "PKR", "wo-SN": "XOF", "xh-ZA": "ZAR", "yo-NG": "NGN", "zh-CN": "CNY", "zh-MO": "CNY", "zh-SG": "SGD", "zh-TW": "TWD", "zu-ZA": "ZAR" }), xs);
  var r10 = bs();
  function o10(n11) {
    var o11, i11;
    var s11 = { weekDay: Intl.DateTimeFormat(n11, { weekday: "long" }), weekDayShort: Intl.DateTimeFormat(n11, { weekday: "short" }), monthDay: Intl.DateTimeFormat(n11, { month: "long" }), monthDayShort: Intl.DateTimeFormat(n11, { month: "short" }), dateLong: Intl.DateTimeFormat(n11, { dateStyle: "long" }), timeShort: Intl.DateTimeFormat(n11, { timeStyle: "short" }), hours12: Intl.DateTimeFormat(n11, { hour12: true, hour: "numeric" }), yearEra: Intl.DateTimeFormat("ja-JP" === n11 ? "ja-JP-u-ca-japanese" : n11, { year: "numeric", era: "short" }) };
    var l10 = n11.startsWith("ja-JP") ? { getCustomEra: function(e15) {
      var t11, n12;
      return null !== (n12 = null === (t11 = s11.yearEra.formatToParts(e15).find(function(e16) {
        return "era" === e16.type;
      })) || void 0 === t11 ? void 0 : t11.value) && void 0 !== n12 ? n12 : "";
    }, getCustomYear: function(e15, t11, n12, o12) {
      return r10.jpDate.getYear(e15, t11, n12, o12);
    } } : {};
    var c10 = t10.dateTimeFactory.createFromJsDate(/* @__PURE__ */ new Date("2022-01-02T00:00:00Z"));
    var u10 = e14.__spread(Array(7).keys()).map(function(e15) {
      return c10.add(e15, "days").toDate();
    });
    var d10 = e14.__spread(Array(12).keys()).map(function(e15) {
      return c10.add(e15, "months").toDate();
    });
    var p10 = [c10.startOfDay().add(1, "hours").toDate(), c10.startOfDay().add(13, "hours").toDate()];
    return e14.__assign({ months: d10.map(function(e15) {
      return s11.monthDay.format(e15);
    }), monthsDeclined: d10.map(function(e15) {
      var t11, n12;
      return null !== (n12 = null === (t11 = s11.dateLong.formatToParts(e15).find(function(e16) {
        return "month" === e16.type;
      })) || void 0 === t11 ? void 0 : t11.value) && void 0 !== n12 ? n12 : "";
    }), monthsShort: d10.map(function(e15) {
      return s11.monthDayShort.format(e15);
    }), days: u10.map(function(e15) {
      return s11.weekDay.format(e15);
    }), daysShort: u10.map(function(e15) {
      return s11.weekDayShort.format(e15);
    }), quarters: a10(n11), amPm: p10.map(function(e15) {
      var t11, n12;
      return null !== (n12 = null === (t11 = s11.hours12.formatToParts(e15).find(function(e16) {
        return "dayPeriod" === e16.type;
      })) || void 0 === t11 ? void 0 : t11.value) && void 0 !== n12 ? n12 : "";
    }), amPmShort: p10.map(function(e15) {
      var t11, n12;
      return null !== (n12 = null === (t11 = s11.hours12.formatToParts(e15).find(function(e16) {
        return "dayPeriod" === e16.type;
      })) || void 0 === t11 ? void 0 : t11.value.charAt(0)) && void 0 !== n12 ? n12 : "";
    }), era: null !== (i11 = null === (o11 = s11.yearEra.formatToParts(/* @__PURE__ */ new Date()).find(function(e15) {
      return "era" === e15.type;
    })) || void 0 === o11 ? void 0 : o11.value) && void 0 !== i11 ? i11 : "" }, l10);
  }
  function a10(e15) {
    switch (e15) {
      case "en-US":
      case "ja-JP":
      case "en-GB":
      case "pt-BR":
      case "en-CA":
        return ["Q1", "Q2", "Q3", "Q4"];
      case "zh-CN":
        return ["\u4E00\u5B63\u5EA6", "\u4E8C\u5B63\u5EA6", "\u4E09\u5B63\u5EA6", "\u56DB\u5B63\u5EA6"];
      default:
        return ["1", "2", "3", "4"];
    }
  }
  function i10(e15) {
    var t11, n11;
    var r11 = Intl.NumberFormat(e15).formatToParts(1000.1);
    var o11 = null === (t11 = r11.find(function(e16) {
      return "decimal" === e16.type;
    })) || void 0 === t11 ? void 0 : t11.value;
    var a11 = null === (n11 = r11.find(function(e16) {
      return "group" === e16.type;
    })) || void 0 === n11 ? void 0 : n11.value;
    return { decimalSeparator: null != o11 ? o11 : "." !== a11 ? "." : ",", thousandSeparator: null != a11 ? a11 : "" };
  }
  var s10 = {};
  return Cs.intlLocaleProvider = { getLocale: function(t11) {
    var r11, a11;
    var l10 = s10[t11.toLowerCase()];
    if (l10) return l10;
    try {
      if (0 === Intl.DateTimeFormat.supportedLocalesOf([t11], { localeMatcher: "lookup" }).length || 0 === Intl.NumberFormat.supportedLocalesOf([t11], { localeMatcher: "lookup" }).length) return null;
    } catch (e15) {
      return null;
    }
    var c10 = { dateLong: Intl.DateTimeFormat(t11, { dateStyle: "full" }), dateShort: Intl.DateTimeFormat(t11, { dateStyle: "short" }), timeLong: Intl.DateTimeFormat(t11, { timeStyle: "medium" }), timeShort: Intl.DateTimeFormat(t11, { timeStyle: "short" }), monthDay: Intl.DateTimeFormat(t11, { month: "long", day: "numeric" }), yearMonth: Intl.DateTimeFormat(t11, { year: "numeric", month: "long" }) };
    var u10 = null !== (a11 = null === (r11 = Object.entries(n10.currencyCodes).find(function(e15) {
      return t11.toLowerCase().startsWith(e15[0].toLowerCase());
    })) || void 0 === r11 ? void 0 : r11[1]) && void 0 !== a11 ? a11 : "USD";
    var d10 = { DateTime: { FormatInfo: o10(t11), Format: function(e15, t12) {
      switch (t12) {
        case "Short date":
          return c10.dateShort.format(e15);
        case "Long date":
          return c10.dateLong.format(e15);
        case "Short time":
          return c10.timeShort.format(e15);
        case "Long time":
          return c10.timeLong.format(e15);
        case "Month/day":
          return c10.monthDay.format(e15);
        case "Year/month":
          return c10.yearMonth.format(e15);
        default:
          throw new Error("Invalid DateTime format alias.");
      }
    } }, Number: { FormatInfo: i10(t11), Format: function(n11, r12, o11) {
      var a12 = { minimumFractionDigits: null != o11 ? o11 : 2, maximumFractionDigits: null != o11 ? o11 : 2 };
      switch (r12) {
        case "Currency":
          return Intl.NumberFormat(t11, e14.__assign(e14.__assign({}, a12), { style: "currency", currency: u10 })).format(n11);
        case "Percent":
          return Intl.NumberFormat(t11, e14.__assign(e14.__assign({}, a12), { style: "percent" })).format(n11);
        default:
          throw new Error("Invalid Number format alias.");
      }
    } } };
    return s10[t11.toLowerCase()] = d10, d10;
  } }, Cs;
}
var Fs;
function Ms() {
  if (Fs) return Mi;
  Fs = 1, Object.defineProperty(Mi, "__esModule", { value: true }), Mi.localeProvider = void 0;
  var e14 = function() {
    if (Pi) return ki;
    Pi = 1, Object.defineProperty(ki, "__esModule", { value: true }), ki.createComposedLocaleProvider = void 0;
    var e15 = Ae;
    return ki.createComposedLocaleProvider = function(t11) {
      return { getLocale: function(n11) {
        var r10, o10;
        try {
          for (var a10 = e15.__values(t11), i10 = a10.next(); !i10.done; i10 = a10.next()) {
            var s10 = i10.value.getLocale(n11);
            if (s10) return s10;
          }
        } catch (e16) {
          r10 = { error: e16 };
        } finally {
          try {
            i10 && !i10.done && (o10 = a10.return) && o10.call(a10);
          } finally {
            if (r10) throw r10.error;
          }
        }
        return null;
      } };
    }, ki;
  }();
  var t10 = function() {
    if (Ss) return Ni;
    Ss = 1, Object.defineProperty(Ni, "__esModule", { value: true }), Ni.predefinedLocaleProvider = void 0;
    var e15 = Ae;
    var t11 = Ge();
    var n11 = ms();
    var r10 = Ti();
    var o10 = bs();
    return Ni.predefinedLocaleProvider = { getLocale: function(a10) {
      var i10 = n11.locales[a10.toLowerCase()];
      if (!i10) return null;
      var s10 = { "Short date": i10.formats["Short date"], "Long date": i10.formats["Long date"], "Month/day": i10.formats["Month/day"], "Short time": i10.formats["Short time"], "Long time": i10.formats["Long time"], "Year/month": i10.formats["Year/month"] };
      var l10 = { Percent: i10.formats.Percent, Currency: i10.formats.Currency };
      var c10 = a10.startsWith("ja-JP") ? { getCustomEra: function(e16, t12) {
        return o10.jpDate.getEra(e16, t12);
      }, getCustomYear: function(e16, t12, n12, r11) {
        return o10.jpDate.getYear(e16, t12, n12, r11);
      } } : {};
      return { DateTime: { FormatInfo: e15.__assign(e15.__assign({}, i10), c10), Format: function(e16, n12) {
        var r11 = s10[n12];
        if (!r11) throw new Error("Invalid DateTime format alias.");
        return t11.formatDateTimeWithPattern(e16, r11, i10, false);
      } }, Number: { FormatInfo: i10, Format: function(e16, t12, n12) {
        var o11 = l10[t12];
        if (!o11) throw new Error("Invalid Number format alias.");
        var a11 = null != n12 ? r10.specifyPrecision(o11, n12) : o11;
        return r10.formatNumberWithPattern(e16, a11, i10);
      } } };
    } }, Ni;
  }();
  var n10 = Es();
  return Mi.localeProvider = e14.createComposedLocaleProvider([t10.predefinedLocaleProvider, n10.intlLocaleProvider]), Mi;
}
var ks;
function Ps() {
  if (ks) return hi;
  ks = 1, Object.defineProperty(hi, "__esModule", { value: true }), hi.shouldTreatAsDate = void 0;
  var e14 = Ae;
  var t10 = yi();
  var n10 = Fi();
  var r10 = As();
  var o10 = Ms();
  var a10 = di();
  var i10 = "en-US";
  var s10 = "undefined" != typeof navigator && (navigator.language || navigator.userLanguage) || i10;
  var l10 = s10 === i10 ? [i10] : [s10, i10];
  var c10 = /^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$/;
  var u10 = function(e15) {
    return e15 && e15.length > 11 && "-" === e15[4] && "-" === e15[7] && "T" === e15[10] && c10.test(e15);
  };
  function d10(e15, n11) {
    return t10.isDateTimeFormat(n11) && u10(e15);
  }
  return hi.shouldTreatAsDate = d10, hi.default = function i11(s11, c11, u11) {
    var p10, m10;
    if (Array.isArray(s11)) return s11.map(function(e15) {
      return i11(e15, c11, u11);
    }).join(", ");
    if (null == s11) return "";
    var h10 = "r" === (null == u11 ? void 0 : u11.toLowerCase()) ? ["en-US"] : c11 ? e14.__spread([c11], l10.filter(function(e15) {
      return e15 !== c11;
    })) : l10;
    var f10 = null;
    try {
      for (var g10 = e14.__values(h10), y10 = g10.next(); !y10.done; y10 = g10.next()) {
        var v10 = y10.value;
        if (f10 = o10.localeProvider.getLocale(v10)) break;
      }
    } catch (e15) {
      p10 = { error: e15 };
    } finally {
      try {
        y10 && !y10.done && (m10 = g10.return) && m10.call(g10);
      } finally {
        if (p10) throw p10.error;
      }
    }
    if (null == f10) throw new Error("Unable to format value: none of locales '" + h10 + "' can be resolved.");
    if (r10.isVariant(s11)) switch (s11.Type) {
      case "Date":
      case "TimeSpan":
        return t10.formatDateTime(s11.Value.toDate(), u11, f10.DateTime);
      case "Decimal":
      case "Double":
      case "Float":
      case "Int32":
      case "Int64":
        return n10.formatNumber(s11.Value, u11, f10.Number);
      default:
        return r10.Convert.toString(s11);
    }
    return u11 && "string" == typeof s11 && d10(s11, u11) && (s11 = a10.dateTimeFactory.createFromString(s11)), a10.dateTimeFactory.isDateTime(s11) ? t10.formatDateTime(s11.toDate(), u11, f10.DateTime) : "string" == typeof s11 ? s11 || "" : "number" == typeof s11 ? n10.formatNumber(s11, u11, f10.Number) : "boolean" == typeof s11 ? s11 ? "True" : "False" : "" + s11;
  }, hi;
}
var Ns;
function Ds() {
  if (Ns) return mi;
  Ns = 1, Object.defineProperty(mi, "__esModule", { value: true }), mi.getStringValue = mi.getBooleanValue = mi.getNumberValue = mi.parseDate = mi.vbRound = mi.timeFormats = mi.dateTimeFormats = void 0;
  var e14 = Ae;
  var t10 = di();
  var n10 = e14.__importDefault(Ps());
  var r10 = { ISO_8601: true };
  return mi.dateTimeFormats = [r10, "MM/dd/YYYY", "MM/dd/YYYY HH:mm", "MM/dd/YYYY HH:mm:ss", "YYYY-MM-ddTHH:mm:ss.fffffff", "YYYY-MM-dd HH:mm:sszzz", "YYYY-MM-ddTHH:mm:ss", "HH:mm", "HH:mm:ss"], mi.timeFormats = ["H:m", "H:m:s", "htt", "h tt", "h:mtt", "h:m tt", "h:m:stt", "h:m:s tt"], mi.vbRound = function(e15) {
    var t11 = Math.trunc(e15);
    return t11 + (Math.abs(e15 - t11) > 0.5 ? 1 : 0) * Math.sign(e15);
  }, mi.parseDate = function(e15) {
    if (e15) {
      var n11 = t10.dateTimeFactory.createFromString(e15, [r10], true);
      if (null != n11) return n11;
    }
    throw new Error("Invalid date format: " + e15);
  }, mi.getNumberValue = function(e15, t11) {
    switch (void 0 === t11 && (t11 = false), e15.Type) {
      case "Bool":
        return e15.Value ? -1 : 0;
      case "Int32":
      case "Int64":
      case "UInt64":
      case "Float":
      case "Double":
      case "Decimal":
        return e15.Value;
      case "String":
        return function(e16, t12) {
          if (void 0 === t12 && (t12 = false), !(t12 ? /^\-?[0-9]+$/ : /^\-?[0-9]+(\.[0-9]*)?$/).test(e16)) throw new Error("Invalid number format: " + e16);
          var n11 = parseFloat(e16);
          if (isNaN(n11)) throw new Error("Invalid number format: " + e16);
          if (!isFinite(n11)) throw new Error("Number overflow: " + e16);
          return n11;
        }(e15.Value, t11);
      case "Object":
      case "Date":
      case "TimeSpan":
        throw new Error("Invalid conversion: " + e15.Type + " to number");
      default:
        return 0;
    }
  }, mi.getBooleanValue = function(e15) {
    switch (e15.Type) {
      case "Bool":
        return e15.Value;
      case "Int32":
      case "Int64":
      case "UInt64":
      case "Float":
      case "Double":
      case "Decimal":
        return 0 !== e15.Value;
      case "Null":
      default:
        return false;
      case "String":
        return function(e16) {
          var t11 = e16.trim();
          if ("False" === t11) return false;
          if ("True" === t11) return true;
          var n11 = parseFloat(t11);
          if (!isNaN(n11) && isFinite(n11)) return 0 !== n11;
          throw new Error("Invalid boolean format: " + e16);
        }(e15.Value);
      case "Object":
        return null !== e15.Value;
      case "TimeSpan":
      case "Date":
        return 0 !== e15.Value.valueOf();
    }
  }, mi.getStringValue = function(e15) {
    switch (e15.Type) {
      case "Null":
      default:
        return "";
      case "Int32":
      case "Int64":
      case "Enum":
      case "UInt64":
      case "Double":
      case "Float":
      case "Decimal":
      case "TimeSpan":
      case "Date":
        return n10.default(e15, null, null);
      case "String":
        return e15.Value;
      case "Bool":
        return e15.Value ? "True" : "False";
    }
  }, mi;
}
var Ls = {};
var Hs;
var Is = {};
var _s;
function Vs() {
  if (_s) return Is;
  _s = 1, Object.defineProperty(Is, "__esModule", { value: true }), Is.GreaterOrEqual = Is.LessOrEqual = Is.GreaterThan = Is.LessThan = Is.NotEquals = Is.Equals = Is.Compare = void 0;
  var e14 = As();
  var t10 = Ds();
  function n10(e15, t11) {
    return !e15 && t11 ? -1 : e15 && !t11 ? 1 : 0;
  }
  function r10(e15, t11) {
    var n11 = e15.localeCompare(t11);
    return n11 < 0 ? -1 : n11 > 0 ? 1 : 0;
  }
  function o10(e15, o11) {
    switch (e15.Type) {
      case "Null":
        switch (o11.Type) {
          case "Null":
            return 0;
          case "Bool":
          case "Int32":
          case "Int64":
          case "UInt64":
          case "Float":
          case "Double":
          case "Decimal":
            return -t10.getNumberValue(o11);
          case "TimeSpan":
          case "Date":
            return -o11.Value.valueOf();
          case "String":
            return r10("", o11.Value);
          default:
            return -1;
        }
      case "Bool":
        switch (o11.Type) {
          case "Null":
          case "Bool":
          case "Int32":
          case "Int64":
          case "UInt64":
          case "Float":
          case "Double":
          case "Decimal":
            return t10.getNumberValue(e15) - t10.getNumberValue(o11);
          case "String":
            return n10(e15.Value, t10.getBooleanValue(o11));
          default:
            throw new Error("Invalid comparison: " + e15.Type + " and " + o11.Type);
        }
      case "Int32":
      case "Int64":
      case "UInt64":
      case "Float":
      case "Double":
      case "Decimal":
        switch (o11.Type) {
          case "Null":
          case "Bool":
          case "Int32":
          case "Int64":
          case "UInt64":
          case "Float":
          case "Double":
          case "Decimal":
          case "String":
            return t10.getNumberValue(e15) - t10.getNumberValue(o11);
          default:
            throw new Error("Invalid comparison: " + e15.Type + " and " + o11.Type);
        }
      case "Object":
        switch (o11.Type) {
          case "Null":
          case "Object":
            return 1;
          default:
            throw new Error("Invalid comparison: " + e15.Type + " and " + o11.Type);
        }
      case "String":
        switch (o11.Type) {
          case "Null":
            return e15.Value.localeCompare("");
          case "Bool":
            return n10(t10.getBooleanValue(e15), o11.Value);
          case "Int32":
          case "Int64":
          case "UInt64":
          case "Float":
          case "Double":
          case "Decimal":
            return t10.getNumberValue(e15) - t10.getNumberValue(o11);
          case "String":
            return r10(e15.Value, o11.Value);
          default:
            throw new Error("Invalid comparison: " + e15.Type + " and " + o11.Type);
        }
      case "Date":
        if ("Date" === o11.Type) return e15.Value.valueOf() - o11.Value.valueOf();
        throw new Error("Invalid comparison: " + e15.Type + " and " + o11.Type);
      default:
        throw new Error("Invalid comparison: " + e15.Type + " and " + o11.Type);
    }
  }
  return Is.Compare = o10, Is.Equals = function(t11, n11) {
    return e14.Create(0 === o10(t11, n11));
  }, Is.NotEquals = function(t11, n11) {
    return e14.Create(0 !== o10(t11, n11));
  }, Is.LessThan = function(t11, n11) {
    return e14.Create(o10(t11, n11) < 0);
  }, Is.GreaterThan = function(t11, n11) {
    return e14.Create(o10(t11, n11) > 0);
  }, Is.LessOrEqual = function(t11, n11) {
    return e14.Create(o10(t11, n11) <= 0);
  }, Is.GreaterOrEqual = function(t11, n11) {
    return e14.Create(o10(t11, n11) >= 0);
  }, Is;
}
var Rs;
function As() {
  return Rs || (Rs = 1, function(e14) {
    Object.defineProperty(e14, "__esModule", { value: true }), e14.Convert = e14.Create = e14.isTimeVariant = e14.isStringVariant = e14.isObjectVariant = e14.isBoolVariant = e14.isNumericVariant = e14.isVariant = e14.IsNullOrEmptyString = e14.IsNull = e14.False = e14.True = e14.Zero = e14.DBNull = e14.Null = e14.Comparison = e14.Operators = void 0;
    var t10 = Ae;
    var n10 = di();
    var r10 = t10.__importStar(Ds());
    var o10 = t10.__importStar(function() {
      if (Hs) return Ls;
      Hs = 1, Object.defineProperty(Ls, "__esModule", { value: true }), Ls.And = Ls.Or = Ls.Xor = Ls.Pow = Ls.Mod = Ls.IntegralDivide = Ls.Divide = Ls.Mult = Ls.Minus = Ls.Plus = Ls.UnaryPlus = Ls.UnaryMinus = Ls.BitwiseShiftRight = Ls.BitwiseShiftLeft = Ls.Not = void 0;
      var e15 = As();
      var t11 = Ds();
      return Ls.Not = function(n11) {
        switch (n11.Type) {
          case "Null":
            return e15.Create(-1);
          case "Bool":
            return e15.Create(0 == t11.getNumberValue(n11));
          case "Int32":
          case "Int64":
          case "UInt64":
            return e15.Create(~n11.Value);
          case "Float":
          case "Double":
          case "Decimal":
            return e15.Create(~t11.vbRound(n11.Value));
          case "String":
            return e15.Create(~t11.getNumberValue(n11));
          default:
            throw new Error("Invalid operation: ! " + n11.Type);
        }
      }, Ls.BitwiseShiftLeft = function(n11, r11) {
        switch (n11.Type) {
          case "Null":
          case "Bool":
          case "Int32":
          case "Int64":
          case "UInt64":
          case "Float":
          case "Double":
          case "Decimal":
          case "String":
            return e15.Create(t11.getNumberValue(n11) << t11.getNumberValue(r11));
          default:
            throw new Error("Invalid operation: << " + n11.Type);
        }
      }, Ls.BitwiseShiftRight = function(n11, r11) {
        switch (n11.Type) {
          case "Null":
          case "Bool":
          case "Int32":
          case "Int64":
          case "UInt64":
          case "Float":
          case "Double":
          case "Decimal":
          case "String":
            return e15.Create(t11.getNumberValue(n11) >> t11.getNumberValue(r11));
          default:
            throw new Error("Invalid operation: >> " + n11.Type);
        }
      }, Ls.UnaryMinus = function(n11) {
        switch (n11.Type) {
          case "Null":
            return e15.Zero;
          case "Bool":
          case "Int32":
          case "Int64":
          case "UInt64":
          case "Float":
          case "Double":
          case "Decimal":
          case "String":
          case "TimeSpan":
          case "Date":
            return e15.Create(-t11.getNumberValue(n11));
          default:
            throw new Error("Invalid operation: - " + n11.Type);
        }
      }, Ls.UnaryPlus = function(n11) {
        switch (n11.Type) {
          case "Null":
            return e15.Zero;
          case "Bool":
          case "Int32":
          case "Int64":
          case "UInt64":
          case "Float":
          case "Double":
          case "Decimal":
          case "String":
          case "TimeSpan":
          case "Date":
            return e15.Create(t11.getNumberValue(n11));
          default:
            throw new Error("Invalid operation: + " + n11.Type);
        }
      }, Ls.Plus = function(n11, r11) {
        switch (n11.Type) {
          case "Null":
            switch (r11.Type) {
              case "Null":
                return e15.Zero;
              case "Bool":
              case "String":
              case "Enum":
                return e15.Create(t11.getNumberValue(r11));
              case "Int32":
              case "Int64":
              case "UInt64":
              case "Double":
              case "Float":
              case "Decimal":
              case "TimeSpan":
                return r11;
              default:
                throw new Error("Invalid operation: " + n11.Type + " + " + r11.Type);
            }
          case "Bool":
          case "Int32":
          case "Int64":
          case "Enum":
          case "UInt64":
          case "Double":
          case "Float":
          case "Decimal":
            switch (r11.Type) {
              case "Null":
                return e15.Create(t11.getNumberValue(n11));
              case "Bool":
              case "Int32":
              case "Int64":
              case "Enum":
              case "UInt64":
              case "Double":
              case "Float":
              case "Decimal":
              case "String":
                return e15.Create(t11.getNumberValue(n11) + t11.getNumberValue(r11));
              default:
                throw new Error("Invalid operation: " + n11.Type + " + " + r11.Type);
            }
          case "TimeSpan":
            if ("Null" === r11.Type) return n11;
            throw new Error("Invalid operation: " + n11.Type + " + " + r11.Type);
          case "Date":
            switch (r11.Type) {
              case "Date":
              case "String":
                return e15.Create(t11.getStringValue(n11) + t11.getStringValue(r11));
              default:
                throw new Error("Invalid operation: " + n11.Type + " + " + r11.Type);
            }
          case "String":
            switch (r11.Type) {
              case "Null":
              case "Bool":
              case "Int32":
              case "Int64":
              case "Enum":
              case "UInt64":
              case "Double":
              case "Float":
              case "Decimal":
                return e15.Create(t11.getNumberValue(n11) + t11.getNumberValue(r11));
              case "Date":
                return e15.Create(n11.Value + t11.getStringValue(r11));
              default:
                return e15.Create(t11.getStringValue(n11) + t11.getStringValue(r11));
            }
          default:
            throw new Error("Invalid operation: " + n11.Type + " + " + r11.Type);
        }
      }, Ls.Minus = function(n11, r11) {
        switch (n11.Type) {
          case "Null":
            switch (r11.Type) {
              case "Null":
                return e15.Zero;
              case "Bool":
              case "String":
              case "Enum":
              case "Int32":
              case "Int64":
              case "UInt64":
              case "Double":
              case "Float":
              case "Decimal":
              case "TimeSpan":
                return e15.Create(-t11.getNumberValue(r11));
              default:
                throw new Error("Invalid operation: " + n11.Type + " - " + r11.Type);
            }
          case "Bool":
          case "Int32":
          case "Int64":
          case "Enum":
          case "UInt64":
          case "Double":
          case "Float":
          case "Decimal":
            switch (r11.Type) {
              case "Null":
                return e15.Create(t11.getNumberValue(n11));
              case "Bool":
              case "Int32":
              case "Int64":
              case "Enum":
              case "UInt64":
              case "Double":
              case "Float":
              case "Decimal":
              case "String":
                return e15.Create(t11.getNumberValue(n11) - t11.getNumberValue(r11));
              default:
                throw new Error("Invalid operation: " + n11.Type + " - " + r11.Type);
            }
          case "TimeSpan":
            if ("Null" === r11.Type) return n11;
            throw new Error("Invalid operation: " + n11.Type + " - " + r11.Type);
          case "Date":
            throw r11.Type, new Error("Invalid operation: " + n11.Type + " - " + r11.Type);
          case "String":
            switch (r11.Type) {
              case "Null":
              case "Bool":
              case "Int32":
              case "Int64":
              case "Enum":
              case "UInt64":
              case "Double":
              case "Float":
              case "Decimal":
              case "String":
                return e15.Create(t11.getNumberValue(n11) - t11.getNumberValue(r11));
              default:
                throw new Error("Invalid operation: " + n11.Type + " - " + r11.Type);
            }
          default:
            throw new Error("Invalid operation: " + n11.Type + " - " + r11.Type);
        }
      }, Ls.Mult = function(n11, r11) {
        switch (n11.Type) {
          case "Null":
            switch (r11.Type) {
              case "Null":
              case "Bool":
              case "Int32":
              case "Int64":
              case "Enum":
              case "UInt64":
              case "Double":
              case "Float":
              case "Decimal":
                return e15.Zero;
              case "String":
                return e15.Create(0 * t11.getNumberValue(r11));
              default:
                throw new Error("Invalid operation: " + n11.Type + " * " + r11.Type);
            }
          case "Bool":
          case "Int32":
          case "Int64":
          case "Enum":
          case "UInt64":
          case "Double":
          case "Float":
          case "Decimal":
          case "String":
            switch (r11.Type) {
              case "Null":
              case "Bool":
              case "Int32":
              case "Int64":
              case "Enum":
              case "UInt64":
              case "Double":
              case "Float":
              case "Decimal":
              case "String":
                return e15.Create(t11.getNumberValue(n11) * t11.getNumberValue(r11));
              default:
                throw new Error("Invalid operation: " + n11.Type + " * " + r11.Type);
            }
          default:
            throw new Error("Invalid operation: " + n11.Type + " * " + r11.Type);
        }
      }, Ls.Divide = function(n11, r11) {
        if (0 === t11.getNumberValue(r11)) throw new Error("Invalid operation: division by zero");
        switch (n11.Type) {
          case "Null":
            switch (r11.Type) {
              case "Null":
                return e15.Create(Number.NaN);
              case "Bool":
              case "Int32":
              case "Int64":
              case "Enum":
              case "UInt64":
              case "Double":
              case "Float":
              case "Decimal":
              case "String":
                return e15.Create(0 / t11.getNumberValue(r11));
              default:
                throw new Error("Invalid operation: " + n11.Type + " / " + r11.Type);
            }
          case "Bool":
          case "Int32":
          case "Int64":
          case "Enum":
          case "UInt64":
          case "Double":
          case "Float":
          case "Decimal":
          case "String":
            switch (r11.Type) {
              case "Null":
              case "Bool":
              case "Int32":
              case "Int64":
              case "Enum":
              case "UInt64":
              case "Double":
              case "Float":
              case "Decimal":
              case "String":
                return e15.Create(t11.getNumberValue(n11) / t11.getNumberValue(r11));
              default:
                throw new Error("Invalid operation: " + n11.Type + " / " + r11.Type);
            }
          default:
            throw new Error("Invalid operation: " + n11.Type + " / " + r11.Type);
        }
      }, Ls.IntegralDivide = function(n11, r11) {
        if (0 === t11.getNumberValue(r11)) throw new Error("Invalid operation: division by zero");
        switch (n11.Type) {
          case "Null":
            switch (r11.Type) {
              case "Null":
                return e15.Create(Number.NaN);
              case "Bool":
              case "Int32":
              case "Int64":
              case "Enum":
              case "UInt64":
              case "Double":
              case "Float":
              case "Decimal":
              case "String":
                return e15.Create(0 / t11.getNumberValue(r11));
              default:
                throw new Error("Invalid operation: " + n11.Type + "  " + r11.Type);
            }
          case "Bool":
          case "Int32":
          case "Int64":
          case "Enum":
          case "UInt64":
          case "Double":
          case "Float":
          case "Decimal":
          case "String":
            switch (r11.Type) {
              case "Null":
              case "Bool":
              case "Int32":
              case "Int64":
              case "Enum":
              case "UInt64":
              case "Double":
              case "Float":
              case "Decimal":
              case "String":
                return e15.Create(Math.trunc(t11.vbRound(t11.getNumberValue(n11)) / t11.vbRound(t11.getNumberValue(r11))));
              default:
                throw new Error("Invalid operation: " + n11.Type + " / " + r11.Type);
            }
          default:
            throw new Error("Invalid operation: " + n11.Type + "  " + r11.Type);
        }
      }, Ls.Mod = function(n11, r11) {
        if (0 === t11.getNumberValue(r11)) throw new Error("Invalid operation: division by zero");
        switch (n11.Type) {
          case "Null":
            switch (r11.Type) {
              case "Bool":
                if (r11.Value) return e15.Zero;
                throw new Error("Invalid operation: " + n11.Type + " % " + r11.Type);
              case "Int32":
              case "Int64":
              case "Enum":
              case "UInt64":
              case "Double":
              case "Float":
              case "Decimal":
                return e15.Zero;
              case "String":
                return e15.Create(0 * t11.getNumberValue(r11));
              default:
                throw new Error("Invalid operation: " + n11.Type + " % " + r11.Type);
            }
          case "Bool":
          case "Int32":
          case "Int64":
          case "Enum":
          case "UInt64":
          case "Double":
          case "Float":
          case "Decimal":
          case "String":
            switch (r11.Type) {
              case "Null":
              case "Bool":
              case "Int32":
              case "Int64":
              case "Enum":
              case "UInt64":
              case "Double":
              case "Float":
              case "Decimal":
              case "String":
                return e15.Create(t11.getNumberValue(n11) % t11.getNumberValue(r11));
              default:
                throw new Error("Invalid operation: " + n11.Type + " % " + r11.Type);
            }
          default:
            throw new Error("Invalid operation: " + n11.Type + " % " + r11.Type);
        }
      }, Ls.Pow = function(n11, r11) {
        switch (n11.Type) {
          case "Null":
            switch (r11.Type) {
              case "Null":
              case "Bool":
              case "Int32":
              case "Int64":
              case "Enum":
              case "UInt64":
              case "Double":
              case "Float":
              case "Decimal":
                return e15.Zero;
              case "String":
                return e15.Create(0 * t11.getNumberValue(r11));
              default:
                throw new Error("Invalid operation: " + n11.Type + " ^ " + r11.Type);
            }
          case "Bool":
          case "Int32":
          case "Int64":
          case "Enum":
          case "UInt64":
          case "Double":
          case "Float":
          case "Decimal":
          case "String":
            switch (r11.Type) {
              case "Null":
              case "Bool":
              case "Int32":
              case "Int64":
              case "Enum":
              case "UInt64":
              case "Double":
              case "Float":
              case "Decimal":
              case "String":
                return e15.Create(Math.pow(t11.getNumberValue(n11), t11.getNumberValue(r11)));
              default:
                throw new Error("Invalid operation: " + n11.Type + " ^ " + r11.Type);
            }
          default:
            throw new Error("Invalid operation: " + n11.Type + " ^ " + r11.Type);
        }
      }, Ls.Xor = function(n11, r11) {
        return "Bool" === n11.Type && "Bool" === r11.Type ? n11.Value !== r11.Value ? e15.True : e15.False : e15.Create(t11.getNumberValue(n11) ^ t11.getNumberValue(r11));
      }, Ls.Or = function(n11, r11) {
        return "Bool" === n11.Type && "Bool" === r11.Type ? n11.Value || r11.Value ? e15.True : e15.False : e15.Create(t11.getNumberValue(n11) | t11.getNumberValue(r11));
      }, Ls.And = function(n11, r11) {
        return "Bool" === n11.Type && "Bool" === r11.Type ? n11.Value && r11.Value ? e15.True : e15.False : e15.Create(t11.getNumberValue(n11) & t11.getNumberValue(r11));
      }, Ls;
    }());
    e14.Operators = t10.__assign({}, o10);
    var a10 = t10.__importStar(Vs());
    function i10(e15) {
      return void 0 !== e15.Type && void 0 !== e15.Value && (s10(e15) || "Null" === e15.Type && null === e15.Value || "Bool" === e15.Type && "boolean" == typeof e15.Value || ("TimeSpan" === e15.Type || "Date" === e15.Type) && n10.dateTimeFactory.isDateTime(e15.Value) || ("String" === e15.Type || "Enum" === e15.Type) && "string" == typeof e15.Value || "Object" === e15.Type && "object" == typeof e15.Value);
    }
    function s10(e15) {
      return void 0 !== e15.Type && void 0 !== e15.Value && ("Int32" === e15.Type || "Int64" === e15.Type || "UInt64" === e15.Type || "Float" === e15.Type || "Double" === e15.Type || "Decimal" === e15.Type) && "number" == typeof e15.Value;
    }
    function l10(e15) {
      return void 0 !== e15.Type && void 0 !== e15.Value && "String" === e15.Type && "string" == typeof e15.Value;
    }
    function c10(t11, r11, o11) {
      if (void 0 === r11 && (r11 = null), void 0 === o11 && (o11 = false), r11) {
        if ("Bool" !== r11 && "Date" !== r11 && "Decimal" !== r11 && "Double" !== r11 && "Enum" !== r11 && "Float" !== r11 && "Int32" !== r11 && "Int64" !== r11 && "Null" !== r11 && "Object" !== r11 && "String" !== r11 && "TimeSpan" !== r11 && "UInt64" !== r11) throw new Error("Unknown variant Type: " + r11);
        var a11 = { Type: r11, Value: t11 };
        if (i10(a11)) return a11;
        if (!o11) throw new Error("Type mismatch: " + t11 + " is not instance of " + r11);
        var s11 = c10(t11);
        switch (r11) {
          case "Bool":
            return c10(e14.Convert.toBoolean(s11), r11);
          case "Null":
            return e14.Null;
          case "Int32":
          case "Int64":
          case "UInt64":
            return c10(e14.Convert.toInteger(s11), r11);
          case "Float":
          case "Double":
          case "Decimal":
            return c10(e14.Convert.toDouble(s11), r11);
          case "String":
            return c10(e14.Convert.toString(s11), r11);
          case "Date":
            return c10(e14.Convert.toDate(s11), r11);
          case "TimeSpan":
            return c10(e14.Convert.toTimeSpan(s11), r11);
          default:
            throw new Error("Type mismatch: cannot convert " + t11 + " to type " + r11);
        }
      }
      if (null == t11) return e14.Null;
      if (i10(t11)) return t11;
      if ("boolean" == typeof t11) return { Type: "Bool", Value: t11 };
      if ("object" == typeof t11) {
        if (n10.dateTimeFactory.isDateTime(t11)) return { Type: "Date", Value: t11 };
        if (t11 instanceof Date) {
          var l11 = n10.dateTimeFactory.createFromJsDate(t11);
          return null != l11 ? { Type: "Date", Value: l11 } : e14.Null;
        }
        return { Type: "Object", Value: t11 };
      }
      if ("string" == typeof t11) return { Type: "String", Value: t11 };
      if ("number" == typeof t11) return Number.isInteger(t11) ? { Type: "Int64", Value: t11 } : { Type: "Double", Value: t11 };
      throw new Error("Invalid argument: unable to create variant from '" + typeof t11 + "'.");
    }
    e14.Comparison = t10.__assign({}, a10), e14.Null = { Type: "Null", Value: null }, e14.DBNull = { Type: "Object", Value: {} }, e14.Zero = { Type: "Int32", Value: 0 }, e14.True = { Type: "Bool", Value: true }, e14.False = { Type: "Bool", Value: false }, e14.IsNull = function(e15) {
      return "Null" === e15.Type;
    }, e14.IsNullOrEmptyString = function(t11) {
      return e14.IsNull(t11) || "String" === t11.Type && "" === t11.Value;
    }, e14.isVariant = i10, e14.isNumericVariant = s10, e14.isBoolVariant = function(e15) {
      return void 0 !== e15.Type && void 0 !== e15.Value && "Bool" === e15.Type && "boolean" == typeof e15.Value;
    }, e14.isObjectVariant = function(e15) {
      return void 0 !== e15.Type && void 0 !== e15.Value && "Object" === e15.Type && "object" == typeof e15.Value;
    }, e14.isStringVariant = l10, e14.isTimeVariant = function(e15) {
      return void 0 !== e15.Type && void 0 !== e15.Value && ("TimeSpan" === e15.Type || "Date" === e15.Type) && n10.dateTimeFactory.isDateTime(e15.Value);
    }, e14.Create = c10;
    var u10 = function(t11) {
      switch (t11.Type) {
        case "Date":
        case "TimeSpan":
        default:
          return t11.Value;
        case "Object":
          if (t11 === e14.DBNull) return null;
          if (t11.Value instanceof Array) return t11.Value.map(function(e15) {
            return u10(c10(e15));
          });
          throw new Error("Cannot convert Object to safe value");
      }
    };
    e14.Convert = { toBoolean: function(e15) {
      if ("String" === e15.Type) {
        var t11 = e15.Value.trim().toLowerCase();
        if ("false" === t11) return false;
        if ("true" === t11) return true;
        var n11 = parseFloat(t11);
        if (!isNaN(n11) && isFinite(n11)) return 0 !== n11;
      }
      return r10.getBooleanValue(e15);
    }, toString: function(e15) {
      return r10.getStringValue(e15);
    }, toChar: function(e15) {
      return l10(e15) ? e15.Value[0] || "" : String.fromCharCode(r10.getNumberValue(e15));
    }, toInteger: function(e15) {
      return r10.vbRound(r10.getNumberValue(e15, true));
    }, toDouble: function(e15) {
      return r10.getNumberValue(e15);
    }, toDate: function(e15) {
      switch (e15.Type) {
        case "Date":
          return e15.Value;
        case "String":
          return r10.parseDate(e15.Value);
        case "Object":
          if (e15.Value instanceof Date) {
            var t11 = n10.dateTimeFactory.createFromJsDate(e15.Value);
            if (null != t11) return t11;
          }
        default:
          throw new Error("Invalid conversion: " + e15.Type + " to date");
      }
    }, toTimeSpan: function(e15) {
      switch (e15.Type) {
        case "TimeSpan":
          return e15.Value;
        case "String":
          throw new Error("Not implemented");
        default:
          throw new Error("Invalid conversion: " + e15.Type + " to timespan");
      }
    }, toSafeValue: u10 };
  }(pi)), pi;
}
var Os = {};
var Bs = {};
var zs;
var $s;
function Ws() {
  return $s || ($s = 1, function(e14) {
    Object.defineProperty(e14, "__esModule", { value: true }), e14.ExpressionNode = void 0;
    var t10 = function() {
      if (zs) return Bs;
      zs = 1, Object.defineProperty(Bs, "__esModule", { value: true }), Bs.ExpressionNode = void 0;
      var e15 = Ae.__importStar(As());
      var t11 = function t12(n10, r10, o10) {
        this.evaluate = n10, this.Children = r10, this.Token = o10, this.Eval = function(e16) {
          return this.evaluate(e16, this.Children);
        }, this.EvalConst = function() {
          return this.evaluate({ Data: {} }, this.Children);
        }, this.Contains = function(e16, t13) {
          return !((!t13 || this.Token.type !== t13) && t13 || !(null === e16 || "string" == typeof e16 && this.Token.value === e16 || "object" == typeof e16 && "value" !== this.Token.type && this.Token.value.match(e16))) || this.Children.some(function(n11) {
            return n11.Contains(e16, t13);
          });
        }, this.ToString = function() {
          switch (this.Token.type) {
            case "variable":
            case "constant":
              return this.Token.value;
            case "function":
              var t13 = this.Token.value;
              return t13 && "." === t13[0] ? "" + this.Children[0].ToString() + this.Token.value + "(" + this.Children.slice(1).map(function(e16) {
                return e16.ToString();
              }).join(",") + ")" : this.Token.value + "(" + this.Children.map(function(e16) {
                return e16.ToString();
              }).join(",") + ")";
            case "operator":
              return 1 === this.Token.arity ? "(" + this.Token.value + "(" + this.Children[0].ToString() + "))" : "((" + this.Children[0].ToString() + ")" + this.Token.value + "(" + this.Children[1].ToString() + "))";
            case "value":
              switch (this.Token.value.Type) {
                case "String":
                  return '"' + this.Token.value.Value.replace(/"/g, '""') + '"';
                case "Date":
                  return "#" + e15.Convert.toString(this.Token.value) + "#";
                case "Object":
                  throw new Error("[expression] cannot serialize object to string: " + this.Token.value.Value);
                default:
                  return "" + this.Token.value.Value;
              }
            default:
              return "";
          }
        }, this.ReplaceChildren = function(e16) {
          return new t12(this.evaluate, e16, this.Token);
        }, this.Simplify = function() {
          if ("function" === this.Token.type || "operator" === this.Token.type) {
            if (!this.Contains(null, "variable")) {
              var e16 = this.EvalConst();
              return new t12(function() {
                return e16;
              }, [], { value: e16, type: "value" });
            }
            return new t12(this.evaluate, this.Children.map(function(e17) {
              return e17.Simplify();
            }), this.Token);
          }
          return this;
        };
      };
      return Bs.ExpressionNode = t11, Bs;
    }();
    Object.defineProperty(e14, "ExpressionNode", { enumerable: true, get: function() {
      return t10.ExpressionNode;
    } });
  }(Os)), Os;
}
var js = {};
var Zs = {};
var Gs;
function Us() {
  if (Gs) return Zs;
  Gs = 1, Object.defineProperty(Zs, "__esModule", { value: true }), Zs.getValueByKey = Zs.toNumber = Zs.dateToString = Zs.isDate = Zs.isBool = Zs.tryParseFloat = Zs.tryParseBool = Zs.boolOpArg = Zs.isNotEmpty = Zs.isStringOrNumber = Zs.isNumber = Zs.mapKeysDeep = Zs.mapKeys = Zs.mapValues = void 0;
  var e14 = di();
  var t10 = As();
  function n10(e15) {
    return "number" == typeof e15 && !Number.isNaN(e15) && Number.isFinite(e15);
  }
  Zs.mapValues = function(e15, t11) {
    var n11 = {};
    return Object.keys(e15 || {}).forEach(function(r11) {
      n11[r11] = t11(e15[r11]);
    }), n11;
  }, Zs.mapKeys = function(e15, t11) {
    var n11 = {};
    return Object.keys(e15 || {}).forEach(function(r11) {
      n11[t11(r11)] = e15[r11];
    }), n11;
  }, Zs.mapKeysDeep = function e15(n11, r11) {
    if (null == n11 || "object" != typeof n11) return n11;
    if (t10.isVariant(n11)) return n11 === t10.DBNull ? n11 : { Type: n11.Type, Value: Array.isArray(n11.Value) ? n11.Value.map(function(t11) {
      return e15(t11, r11);
    }) : e15(n11.Value, r11) };
    var o11 = {};
    return Object.keys(n11 || {}).forEach(function(t11) {
      o11[r11(t11)] = Array.isArray(n11[t11]) ? n11[t11].map(function(t12) {
        return e15(t12, r11);
      }) : e15(n11[t11], r11);
    }), o11;
  }, Zs.isNumber = n10, Zs.isStringOrNumber = function(e15) {
    return "string" == typeof e15 || n10(e15);
  }, Zs.isNotEmpty = function(e15) {
    return null !== e15 && "" !== e15;
  };
  Zs.boolOpArg = function(e15) {
    if ("string" == typeof e15 || o10(e15)) throw new Error("[expression evaluator] invalid operation: cannot convert " + e15 + " to boolean");
    return !!e15;
  };
  Zs.toNumber = function(e15, t11) {
    if ("number" == typeof e15) return e15;
    if ("boolean" == typeof e15) return -e15;
    if (t11) return o10(e15) ? a10(e15) : e15;
    if ("string" == typeof e15) return r10(e15);
    throw new Error("[expression evaluator] invalid operation: cannot convert " + e15 + " to number");
  };
  Zs.tryParseBool = function(e15) {
    if ("true" === e15.toLowerCase()) return true;
    if ("false" === e15.toLowerCase()) return false;
    throw new Error("[expression evaluator] invalid operation: cannot convert " + e15 + " to boolean");
  };
  var r10 = function(e15) {
    var t11 = parseFloat(e15);
    if (!isNaN(t11) && isFinite(t11)) return t11;
    throw new Error("[expression evaluator] invalid operation: cannot convert " + e15 + " to number");
  };
  Zs.tryParseFloat = r10;
  Zs.isBool = function(e15) {
    return "boolean" == typeof e15;
  };
  var o10 = function(t11) {
    return t11 && e14.dateTimeFactory.isDateTime(t11);
  };
  Zs.isDate = o10;
  var a10 = function(e15) {
    return o10(e15) ? (e15.creationData().input || e15.toISOString()).toString() : e15;
  };
  Zs.dateToString = a10;
  return Zs.getValueByKey = function(e15, t11) {
    return e15[t11];
  }, Zs;
}
var qs = {};
var Ys;
function Ks() {
  if (Ys) return qs;
  Ys = 1, Object.defineProperty(qs, "__esModule", { value: true });
  var e14 = As();
  function t10(e15) {
    if (e15 < 0) throw new Error("Can not convert " + e15 + " to unsigned");
    return e15;
  }
  var n10 = { ToBoolean: function(t11) {
    return e14.Create(e14.Convert.toBoolean(t11[1]), "Bool");
  }, ToByte: function(n11) {
    return e14.Create(t10(r10(n11[1], e14.Convert.toInteger)), "Int32");
  }, ToInt16: function(t11) {
    return e14.Create(r10(t11[1], e14.Convert.toInteger), "Int32");
  }, ToInt32: function(t11) {
    return e14.Create(r10(t11[1], e14.Convert.toInteger), "Int32");
  }, ToInt64: function(t11) {
    return e14.Create(r10(t11[1], e14.Convert.toInteger), "Int64");
  }, ToUInt16: function(n11) {
    return e14.Create(t10(r10(n11[1], e14.Convert.toInteger)), "UInt64");
  }, ToUInt32: function(n11) {
    return e14.Create(t10(r10(n11[1], e14.Convert.toInteger)), "UInt64");
  }, ToUInt64: function(n11) {
    return e14.Create(t10(r10(n11[1], e14.Convert.toInteger)), "UInt64");
  }, ToDecimal: function(t11) {
    return e14.Create(r10(t11[1], e14.Convert.toDouble), "Decimal");
  }, ToDouble: function(t11) {
    return e14.Create(r10(t11[1], e14.Convert.toDouble), "Double");
  }, ToSingle: function(t11) {
    return e14.Create(r10(t11[1], e14.Convert.toDouble), "Float");
  }, ToString: function(t11) {
    return e14.Create(e14.Convert.toString(t11[1]), "String");
  }, ToDateTime: function(t11) {
    return e14.Create(e14.Convert.toDate(t11[1]), "Date");
  }, ToChar: function(t11) {
    return e14.Create(e14.Convert.toChar(t11[1]), "String");
  }, IsDBNull: function(t11) {
    return function(t12) {
      return t12 === e14.DBNull ? e14.True : e14.False;
    }(t11[1]);
  } };
  function r10(e15, t11) {
    return "Bool" === e15.Type ? e15.Value ? 1 : 0 : t11(e15);
  }
  return qs.default = n10, qs;
}
var Xs = {};
var Js;
function Qs() {
  if (Js) return Xs;
  Js = 1, Object.defineProperty(Xs, "__esModule", { value: true });
  var e14 = Ae;
  var t10 = As();
  function n10(e15) {
    if (t10.isNumericVariant(e15)) return t10.Convert.toDouble(e15);
    throw new Error("Type mismatch: " + e15.Value + " is not a number");
  }
  var r10 = { Abs: function(e15) {
    return t10.Create(Math.abs(n10(e15[1])));
  }, Ceiling: function(e15) {
    return t10.Create(Math.ceil(n10(e15[1])));
  }, Floor: function(e15) {
    return t10.Create(Math.floor(n10(e15[1])));
  }, Truncate: function(e15) {
    return t10.Create(Math.trunc(n10(e15[1])));
  }, Round: function(e15) {
    return t10.Create(2 === e15.length ? Math.round(n10(e15[1])) : Math.round(n10(e15[1]) * Math.pow(10, n10(e15[2]))) / Math.pow(10, n10(e15[2])));
  }, Sign: function(e15) {
    return t10.Create(Math.sign(n10(e15[1])));
  }, Sin: function(e15) {
    return t10.Create(Math.sin(n10(e15[1])));
  }, Cos: function(e15) {
    return t10.Create(Math.cos(n10(e15[1])));
  }, Tan: function(e15) {
    return t10.Create(Math.tan(n10(e15[1])));
  }, Sinh: function(e15) {
    return t10.Create(Math.sinh(n10(e15[1])));
  }, Cosh: function(e15) {
    return t10.Create(Math.cosh(n10(e15[1])));
  }, Tanh: function(e15) {
    return t10.Create(Math.tanh(n10(e15[1])));
  }, Asin: function(e15) {
    return t10.Create(Math.asin(n10(e15[1])));
  }, Acos: function(e15) {
    return t10.Create(Math.acos(n10(e15[1])));
  }, Atan: function(e15) {
    return t10.Create(Math.atan(n10(e15[1])));
  }, Pow: function(e15) {
    return t10.Create(Math.pow(n10(e15[1]), n10(e15[2])));
  }, Min: function(r11) {
    return t10.Create(Math.min.apply(Math, e14.__spread(r11.slice(1).map(n10))));
  }, Max: function(r11) {
    return t10.Create(Math.max.apply(Math, e14.__spread(r11.slice(1).map(n10))));
  }, Sqrt: function(e15) {
    return t10.Create(Math.sqrt(n10(e15[1])));
  }, Log: function(e15) {
    return t10.Create(2 === e15.length ? Math.log(n10(e15[1])) : Math.log(n10(e15[1])) / Math.log(n10(e15[2])));
  }, Log10: function(e15) {
    return t10.Create(Math.log10(n10(e15[1])));
  }, Exp: function(e15) {
    return t10.Create(Math.exp(n10(e15[1])));
  }, Atan2: function(e15) {
    return t10.Create(Math.atan2(n10(e15[1]), n10(e15[2])));
  }, IEEERemainder: function(e15) {
    return t10.Create((r11 = n10(e15[1]), o10 = n10(e15[2]), r11 - o10 * Math.round(r11 / o10)));
    var r11, o10;
  }, BigMul: function(e15) {
    return t10.Create(n10(e15[1]) * n10(e15[2]), "Int64", true);
  }, Fix: function(e15) {
    return t10.Create(Math.trunc(n10(e15[1])), e15[1].Type);
  } };
  return Xs.default = r10, Xs;
}
var el = {};
var tl;
function nl() {
  if (tl) return el;
  tl = 1, Object.defineProperty(el, "__esModule", { value: true });
  var e14 = As();
  var t10 = { IsNumeric: function(t11) {
    return function(t12) {
      if (e14.IsNull(t12)) return e14.False;
      try {
        return e14.Convert.toDouble(t12), e14.True;
      } catch (t13) {
        return e14.False;
      }
    }(t11[1]);
  }, IsDate: function(t11) {
    return function(t12) {
      try {
        return e14.Convert.toDate(t12), e14.True;
      } catch (t13) {
        return e14.False;
      }
    }(t11[1]);
  }, IsNothing: function(t11) {
    return function(t12) {
      return e14.IsNull(t12) ? e14.True : e14.False;
    }(t11[1]);
  }, IsError: function(t11) {
    return t11[1], e14.False;
  }, IsArray: function(t11) {
    return function(t12) {
      return t12 && "Object" === t12.Type && Array.isArray(t12.Value) ? e14.True : e14.False;
    }(t11[1]);
  } };
  return el.default = t10, el;
}
var rl = {};
var ol;
function al() {
  if (ol) return rl;
  ol = 1, Object.defineProperty(rl, "__esModule", { value: true }), rl.variables = rl.classFunctions = rl.functions = void 0;
  var e14 = Ae;
  var t10 = As();
  var n10 = di();
  var r10 = e14.__importStar(Us());
  var o10 = Ds();
  var a10 = { ISO_8601: true };
  var i10 = Ms().localeProvider.getLocale("en-US").DateTime.FormatInfo;
  function s10(e15) {
    if (t10.isVariant(e15)) return t10.Convert.toDate(e15).clone();
    throw new Error("Type mismatch: " + e15 + " is not a valid value");
  }
  function l10(e15) {
    if (t10.isVariant(e15)) return t10.Convert.toDouble(e15);
    throw new Error("Type mismatch: " + e15 + " is not a valid number");
  }
  function c10(e15) {
    if (t10.isVariant(e15)) return t10.Convert.toString(e15);
    throw new Error("Type mismatch: " + e15 + " is not a valid value");
  }
  var u10 = { Year: function(e15) {
    return t10.Create(s10(e15[1]).year());
  }, Month: function(e15) {
    return t10.Create(s10(e15[1]).month() + 1);
  }, Day: function(e15) {
    return t10.Create(s10(e15[1]).date());
  }, Weekday: function(e15) {
    return function(e16, n11) {
      var r11 = n11 ? l10(n11) : 1;
      if (r11 < 1 || r11 > 7) throw new Error("FirstDayOfWeek is less than 1 or greater than 7");
      var o11 = s10(e16).day() - r11 + 2;
      return t10.Create(o11 > 0 ? o11 : o11 + 7);
    }(e15[1], e15[2]);
  }, Hour: function(e15) {
    return t10.Create(s10(e15[1]).hour());
  }, Minute: function(e15) {
    return t10.Create(s10(e15[1]).minute());
  }, Second: function(e15) {
    return t10.Create(s10(e15[1]).second());
  }, DateValue: function(e15) {
    return t10.Create(s10(e15[1]).startOfDay());
  }, TimeValue: function(n11) {
    return function(n12) {
      var r11 = p10(n12, e14.__spread(o10.dateTimeFormats, o10.timeFormats));
      return t10.Create(r11.Value.getTime());
    }(n11[1]);
  }, AddDays: function(e15) {
    return t10.Create(s10(e15[1]).add(l10(e15[2]), "days"));
  }, AddHours: function(e15) {
    return t10.Create(s10(e15[1]).add(l10(e15[2]), "hours"));
  }, AddMilliseconds: function(e15) {
    return t10.Create(s10(e15[1]).add(l10(e15[2]), "milliseconds"));
  }, AddMinutes: function(e15) {
    return t10.Create(s10(e15[1]).add(l10(e15[2]), "minutes"));
  }, AddMonths: function(e15) {
    return t10.Create(s10(e15[1]).add(l10(e15[2]), "months"));
  }, AddSeconds: function(e15) {
    return t10.Create(s10(e15[1]).add(l10(e15[2]), "seconds"));
  }, AddYears: function(e15) {
    return t10.Create(s10(e15[1]).add(l10(e15[2]), "years"));
  } };
  var d10 = { Now: function() {
    return t10.Create(n10.dateTimeFactory.create());
  }, TimeOfDay: function() {
    return t10.Create(n10.dateTimeFactory.create());
  }, Today: function() {
    return t10.Create(n10.dateTimeFactory.create().startOfDay());
  }, TimeString: function() {
    return t10.Create(n10.dateTimeFactory.create().format("HH:mm:ss"));
  }, DateString: function() {
    return t10.Create(n10.dateTimeFactory.create().format("YYYY-MM-dd"));
  }, Timer: function() {
    return t10.Create(n10.dateTimeFactory.create().dateDiff("s", n10.dateTimeFactory.create().startOfDay()));
  } };
  function p10(e15, r11) {
    if ("Date" === e15.Type) return e15;
    var o11 = n10.dateTimeFactory.createFromString(c10(e15), r11, true);
    if (null == o11) throw new Error('Cannot parse date "' + e15.Value + '"');
    return t10.Create(o11);
  }
  function m10(e15) {
    var t11 = s10(e15).month();
    return Math.floor(t11 / 3) + 1;
  }
  rl.functions = e14.__assign(e14.__assign(e14.__assign({}, d10), u10), { TimeSerial: function(e15) {
    return t10.Create(n10.dateTimeFactory.createFromArray([1, 0, 1, l10(e15[1]), l10(e15[2]), l10(e15[3])]), "Date", true);
  }, DateSerial: function(e15) {
    return t10.Create(n10.dateTimeFactory.createFromArray([l10(e15[1]), l10(e15[2]) - 1, l10(e15[3]), 0, 0, 0]), "Date", true);
  }, MonthName: function(e15) {
    return function(e16, n11) {
      var r11 = l10(e16);
      if (r11 < 1 || r11 > 12) throw new Error("Month is less than 1 or greater than 12");
      var o11 = !!n11 && t10.Convert.toBoolean(n11);
      return t10.Create((o11 ? i10.monthsShort : i10.months)[r11 - 1]);
    }(e15[1], e15[2]);
  }, WeekdayName: function(e15) {
    return function(e16, n11, r11) {
      var o11 = l10(e16);
      var a11 = r11 ? l10(r11) : 1;
      if (o11 < 1 || o11 > 7) throw new Error("Weekday is less than 1 or greater than 7");
      if (a11 < 1 || a11 > 7) throw new Error("FirstDayOfWeek is less than 1 or greater than 7");
      var s11 = o11 + a11 - 1;
      var c11 = s11 > 7 ? s11 - 7 : s11;
      var u11 = !!n11 && t10.Convert.toBoolean(n11);
      return t10.Create((u11 ? i10.daysShort : i10.days)[c11 - 1]);
    }(e15[1], e15[2], e15[3]);
  }, Parse: function(e15) {
    return function(e16, t11) {
      return p10(e16, t11 ? [c10(t11)] : o10.dateTimeFormats);
    }(e15[1], e15[2]);
  }, DatePart: function(e15) {
    return t10.Create(function(e16, t11, n11, r11) {
      var o11 = c10(e16);
      var a11 = n11 ? l10(n11) : void 0;
      var i11 = r11 ? l10(r11) : void 0;
      return s10(t11).datePart(o11, a11, i11);
    }(e15[1], e15[2], e15[3], e15[4]));
  }, DateAdd: function(e15) {
    return t10.Create(function(e16, t11, n11) {
      var r11 = c10(e16);
      var o11 = l10(t11);
      var a11 = s10(n11);
      switch (r11) {
        case "yyyy":
          return a11.add(o11, "years");
        case "q":
          return a11.add(o11, "quarters");
        case "m":
          return a11.add(o11, "months");
        case "y":
        case "d":
        case "w":
          return a11.add(o11, "days");
        case "ww":
          return a11.add(o11, "weeks");
        case "h":
          return a11.add(o11, "hours");
        case "n":
          return a11.add(o11, "minutes");
        case "s":
          return a11.add(o11, "seconds");
        default:
          throw new Error('"' + e16.Value + '" is not valid interval value for DateAdd() function');
      }
    }(e15[1], e15[2], e15[3]));
  }, DateDiff: function(e15) {
    return t10.Create(function(e16, t11, n11, r11) {
      var o11 = c10(e16);
      var a11 = r11 ? l10(r11) : void 0;
      var i11 = s10(t11);
      return s10(n11).dateDiff(o11, i11, a11);
    }(e15[1], e15[2], e15[3], e15[4]));
  }, Quarter: function(e15) {
    return t10.Create(m10(e15[1]));
  }, QuarterName: function(e15) {
    return t10.Create((n11 = e15[1], i10.quarters[m10(n11) - 1]));
    var n11;
  } }), rl.classFunctions = r10.mapKeys(r10.mapValues(u10, function(e15) {
    return function(t11) {
      return e15(function(e16, t12) {
        if ("Date" !== e16[1].Type) throw new Error("[expression evaluator] function " + t12 + "() not found in " + e16[1].Type);
        return e16;
      }(t11, e15.name));
    };
  }), function(e15) {
    return "." + e15;
  });
  var h10 = t10.Create(n10.dateTimeFactory.createFromString("9999-12-31T23:59:59.9999999Z", [a10]));
  var f10 = t10.Create(n10.dateTimeFactory.createFromString("0001-01-01T00:00:00.0000000Z", [a10]));
  return rl.variables = e14.__assign(e14.__assign(e14.__assign({}, d10), r10.mapKeys(d10, function(e15) {
    return "DateTime." + e15;
  })), { "DateTime.MaxValue": function() {
    return h10;
  }, "DateTime.MinValue": function() {
    return f10;
  } }), rl;
}
var il = {};
var sl;
function ll() {
  if (sl) return il;
  sl = 1, Object.defineProperty(il, "__esModule", { value: true }), il.classFunctions = il.functions = void 0;
  var e14 = Ae;
  var t10 = As();
  var n10 = e14.__importStar(Us());
  function r10(e15) {
    if (t10.isVariant(e15)) return t10.Convert.toString(e15);
    throw new Error("Type mismatch: " + e15 + " is not a valid value");
  }
  function o10(e15) {
    if (t10.isNumericVariant(e15)) return t10.Convert.toDouble(e15);
    throw new Error("Type mismatch: " + e15.Value + " is not a number");
  }
  var a10 = /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g;
  var i10 = { Trim: function(e15) {
    return t10.Create(r10(e15[1]).trim());
  }, TrimStart: function(e15) {
    return t10.Create(r10(e15[1]).replace(/^[\s\uFEFF\xA0]+/g, ""));
  }, TrimEnd: function(e15) {
    return t10.Create(r10(e15[1]).replace(/[\s\uFEFF\xA0]+$/g, ""));
  }, Substring: function(e15) {
    return t10.Create(r10(e15[1]).substr(o10(e15[2]), e15[3] ? o10(e15[3]) : void 0));
  }, ToLower: function(e15) {
    return t10.Create(r10(e15[1]).toLowerCase());
  }, ToUpper: function(e15) {
    return t10.Create(r10(e15[1]).toUpperCase());
  }, StartsWith: function(e15) {
    return t10.Create(r10(e15[1]).startsWith(r10(e15[2])));
  }, EndsWith: function(e15) {
    return t10.Create(r10(e15[1]).endsWith(r10(e15[2])));
  }, IndexOf: function(e15) {
    return t10.Create(r10(e15[1]).indexOf(r10(e15[2]), e15[3] ? o10(e15[3]) : void 0));
  }, LastIndexOf: function(e15) {
    return t10.Create(r10(e15[1]).lastIndexOf(r10(e15[2]), e15[3] ? o10(e15[3]) : void 0));
  }, Replace: function(e15) {
    return t10.Create(r10(e15[1]).replace(new RegExp(r10(e15[2]).replace(a10, "\\$&"), "g"), r10(e15[3])));
  } };
  return il.functions = { Trim: i10.Trim, TrimStart: i10.TrimStart, TrimEnd: i10.TrimEnd, Substring: i10.Substring, ToLower: i10.ToLower, ToUpper: i10.ToUpper, StartsWith: i10.StartsWith, EndsWith: i10.EndsWith, LastIndexOf: i10.LastIndexOf, Replace: i10.Replace }, il.classFunctions = n10.mapKeys(n10.mapValues(i10, function(e15) {
    return function(t11) {
      return e15(function(e16, t12) {
        if ("String" !== e16[1].Type) throw new Error("[expression evaluator] function " + t12 + "() not found in " + e16[1].Type);
        return e16;
      }(t11, e15.name));
    };
  }), function(e15) {
    return "." + e15;
  }), il;
}
var cl = {};
var ul;
var dl = {};
var pl;
var ml = {};
var hl;
var fl = {};
var gl = {};
var yl;
function vl() {
  if (yl) return gl;
  yl = 1, Object.defineProperty(gl, "__esModule", { value: true });
  var e14 = Ae;
  var t10 = As();
  var n10 = Us();
  var r10 = function() {
    function r11(e15, t11, n11) {
      this.Index = e15, this.FieldNameIndex = t11, this.data = n11;
    }
    return Object.defineProperty(r11.prototype, "Count", { get: function() {
      return this.data.length;
    }, enumerable: false, configurable: true }), r11.prototype.MakeCopy = function(e15) {
      return new r11(e15, this.FieldNameIndex, this.data);
    }, r11.prototype.GetByIndex = function(e15) {
      var t11 = this.data[e15];
      if (!t11) throw new Error("Index out of range: " + e15);
      return t11;
    }, r11.prototype.GetByName = function(e15) {
      var r12 = n10.getValueByKey(this.FieldNameIndex, e15);
      return void 0 === r12 ? t10.Null : this.data[r12] || t10.Null;
    }, r11.prototype[Symbol.iterator] = function() {
      var t11, n11, r12, o10;
      var a10 = this;
      return e14.__generator(this, function(i10) {
        switch (i10.label) {
          case 0:
            t11 = Object.keys(this.FieldNameIndex), n11 = function(n12) {
              var o11;
              return e14.__generator(this, function(e15) {
                switch (e15.label) {
                  case 0:
                    return o11 = t11.find(function(e16) {
                      return a10.FieldNameIndex[e16] === n12;
                    }) || "", [4, { Key: o11, Value: r12.data[n12] }];
                  case 1:
                    return e15.sent(), [2];
                }
              });
            }, r12 = this, o10 = 0, i10.label = 1;
          case 1:
            return o10 < this.data.length ? [5, n11(o10)] : [3, 4];
          case 2:
            i10.sent(), i10.label = 3;
          case 3:
            return o10++, [3, 1];
          case 4:
            return [2];
        }
      });
    }, r11.Empty = new r11(0, {}, []), r11;
  }();
  return gl.default = r10, gl;
}
var bl;
function Sl() {
  if (bl) return fl;
  bl = 1, Object.defineProperty(fl, "__esModule", { value: true }), fl.getValueFromContainer = void 0;
  var e14 = Ae;
  var t10 = e14.__importDefault(vl());
  var n10 = e14.__importStar(As());
  var r10 = Us();
  return fl.getValueFromContainer = function e15(o10, a10) {
    if (0 === o10.length) return n10.Create(a10);
    var i10 = o10.shift();
    if (!a10) return n10.Null;
    if ("value" === i10 && 0 === o10.length && n10.isObjectVariant(a10) && Array.isArray(a10.Value)) return a10;
    if (n10.isVariant(a10)) {
      var s10 = function(e16, t11) {
        var r11 = e16.toLowerCase();
        switch (t11.Type) {
          case "String":
            if ("length" === r11) return n10.Create(n10.Convert.toString(t11).length);
            break;
          case "Object":
            if ("length" === r11 && Array.isArray(t11.Value)) return n10.Create(t11.Value.length);
        }
        return;
      }(i10, a10);
      if (s10) return s10;
    }
    var l10 = n10.isObjectVariant(a10) ? a10.Value : a10;
    if (l10 instanceof t10.default) return (c10 = l10.GetByName(i10)) ? e15(o10, n10.Create({ Value: c10, Name: i10 })) : n10.Null;
    var c10 = "value" === i10 && "Value" in l10 ? l10.Value : "name" === i10 && "Name" in l10 ? l10.Name : "type" === i10 && "Type" in l10 ? l10.Type : r10.getValueByKey(l10, i10);
    return e15(o10, n10.Create(c10));
  }, fl;
}
var Cl;
function xl() {
  if (Cl) return js;
  Cl = 1, Object.defineProperty(js, "__esModule", { value: true }), js.predefinedVariables = js.predefinedConstants = js.predefinedFunctions = js.operators = void 0;
  var e14 = Ae;
  var t10 = As();
  var n10 = e14.__importStar(Us());
  var r10 = e14.__importDefault(Ps());
  var o10 = e14.__importDefault(Ks());
  var a10 = e14.__importDefault(Qs());
  var i10 = e14.__importDefault(nl());
  var s10 = e14.__importStar(al());
  var l10 = e14.__importStar(ll());
  var c10 = e14.__importStar(function() {
    if (ul) return cl;
    ul = 1, Object.defineProperty(cl, "__esModule", { value: true }), cl.IndexOf = void 0;
    var e15 = As();
    return cl.IndexOf = function(t11) {
      var n11, r11;
      var o11 = t11[0].Value;
      var a11 = t11[1];
      var i11 = null !== (r11 = null === (n11 = t11[2]) || void 0 === n11 ? void 0 : n11.Value) && void 0 !== r11 ? r11 : 0;
      if ("number" != typeof i11) throw new Error("[expression evaluator] start argument of IndexOf function must be number");
      for (var s11 = i11; s11 < o11.length; s11++) if (e15.Comparison.Equals(e15.Create(o11[s11]), a11).Value) return e15.Create(s11);
      return e15.Create(-1);
    }, cl;
  }());
  var u10 = e14.__importDefault((pl || (pl = 1, Object.defineProperty(dl, "__esModule", { value: true }), dl.default = function(e15) {
    var t11 = "^";
    var n11 = false;
    var r11 = false;
    for (var o11 = 0; o11 < e15.length; o11++) {
      var a11 = e15[o11];
      "]" !== a11 ? (r11 = false, "[" !== a11 ? t11 += "?" !== a11 || n11 ? "*" !== a11 || n11 ? "#" !== a11 || n11 ? (".{}()?/\\*+^$".indexOf(a11) > -1 ? "\\" : "") + a11 : "\\d" : ".*" : "." : n11 ? t11 += "\\" + a11 : (t11 += a11, n11 = true, r11 = true, "!" === e15[o11 + 1] && (t11 += "^", r11 = false, o11++))) : n11 ? (t11 += a11, n11 = false, r11 && (t11 = t11.substr(0, t11.length - 2))) : (t11 += "\\" + a11, r11 = false);
    }
    return t11 += "$", new RegExp(t11);
  }), dl));
  var d10 = e14.__importDefault(function() {
    if (hl) return ml;
    hl = 1, Object.defineProperty(ml, "__esModule", { value: true });
    var e15 = As();
    ml.default = function(n11) {
      if (4 !== n11.length) throw new Error("[syntax error] Partition function: must have 4 arguments");
      if (n11.some(e15.IsNull)) return e15.Null;
      var r11 = e15.Convert.toDouble(n11[0]), o11 = e15.Convert.toInteger(n11[1]), a11 = e15.Convert.toInteger(n11[2]), i11 = e15.Convert.toInteger(n11[3]);
      if (o11 < 0) throw new Error("[expression evaluator] Partition function: Start cannot be less than 0");
      if (a11 <= o11) throw new Error("[expression evaluator] Partition function: Stop cannot be less than or equal to Start");
      if (i11 < 1) throw new Error("[expression evaluator] Partition function: Interval cannot be less than 1");
      var s11 = a11.toString().length;
      if (r11 < o11) return e15.Create(":" + t11(o11 - 1, s11));
      if (r11 > a11) return e15.Create(t11(a11 + 1, s11) + ":");
      var l11 = Math.trunc((r11 - o11) / i11) * i11 + o11;
      return e15.Create(t11(l11, s11) + ":" + t11(l11 + i11 - 1, s11));
    };
    var t11 = function(e16, t12) {
      var n11 = e16.toString();
      for (; n11.length < t12; ) n11 = " " + n11;
      return n11;
    };
    return ml;
  }());
  var p10 = Sl();
  var m10 = function(e15, t11, n11) {
    if (t11.length !== e15) throw new Error("[syntax error] " + (1 === e15 ? "u" : "bi") + "nary operator used as unary");
    return n11;
  };
  var h10 = function(e15) {
    if ("String" === e15.Type) throw new Error("Invalid operation: " + e15.Value + " is not boolean");
    return t10.Convert.toBoolean(e15);
  };
  var f10 = n10.mapValues({ "^": { priority: 3.6, calc: function(e15) {
    return m10(2, e15, t10.Operators.Pow(e15[0], e15[1]));
  } }, "*": { priority: 3.5, calc: function(e15) {
    return m10(2, e15, t10.Operators.Mult(e15[0], e15[1]));
  } }, "/": { priority: 3.5, calc: function(e15) {
    return m10(2, e15, t10.Operators.Divide(e15[0], e15[1]));
  } }, "\\": { priority: 3.4, calc: function(e15) {
    return m10(2, e15, t10.Operators.IntegralDivide(e15[0], e15[1]));
  } }, mod: { priority: 3.3, calc: function(e15) {
    return m10(2, e15, t10.Operators.Mod(e15[0], e15[1]));
  } }, "+": { priority: 3.2, calc: function(e15) {
    return 1 === e15.length ? t10.Operators.UnaryPlus(e15[0]) : t10.Operators.Plus(e15[0], e15[1]);
  } }, "-": { priority: 3.2, calc: function(e15) {
    return 1 === e15.length ? t10.Operators.UnaryMinus(e15[0]) : t10.Operators.Minus(e15[0], e15[1]);
  } }, "&": { priority: 3.1, calc: function(e15) {
    return m10(2, e15, t10.Create("" + t10.Convert.toString(e15[0]) + t10.Convert.toString(e15[1])));
  } }, "<<": { priority: 3, calc: function(e15) {
    return m10(2, e15, t10.Operators.BitwiseShiftLeft(e15[0], e15[1]));
  } }, ">>": { priority: 3, calc: function(e15) {
    return m10(2, e15, t10.Operators.BitwiseShiftRight(e15[0], e15[1]));
  } }, "<": { priority: 2, calc: function(e15) {
    return m10(2, e15, t10.Comparison.LessThan(e15[0], e15[1]));
  } }, ">": { priority: 2, calc: function(e15) {
    return m10(2, e15, t10.Comparison.GreaterThan(e15[0], e15[1]));
  } }, "<=": { priority: 2, calc: function(e15) {
    return m10(2, e15, t10.Comparison.LessOrEqual(e15[0], e15[1]));
  } }, ">=": { priority: 2, calc: function(e15) {
    return m10(2, e15, t10.Comparison.GreaterOrEqual(e15[0], e15[1]));
  } }, "=": { priority: 2, calc: function(e15) {
    return m10(2, e15, t10.Comparison.Equals(e15[0], e15[1]));
  } }, "<>": { priority: 2, calc: function(e15) {
    return m10(2, e15, t10.Comparison.NotEquals(e15[0], e15[1]));
  } }, is: { priority: 2, calc: function(e15) {
    return m10(2, e15, t10.Comparison.Equals(e15[0], e15[1]));
  } }, like: { priority: 2, calc: function(e15) {
    if (2 !== e15.length) throw new Error("[syntax error] binary operator LIKE is used as unary");
    if (e15.some(function(e16) {
      return "String" !== e16.Type;
    })) throw new Error("[expression evaluator] invalid operation: LIKE arguments must be string");
    return u10.default(t10.Convert.toString(e15[1])).test(t10.Convert.toString(e15[0])) ? t10.True : t10.False;
  } }, not: { priority: 1.3, calc: function(e15) {
    return m10(1, e15, t10.Operators.Not(e15[0]));
  } }, and: { priority: 1.2, calc: function(e15) {
    return m10(2, e15, t10.Operators.And(e15[0], e15[1]));
  } }, andalso: { priority: 1.2, calc: function(e15) {
    return m10(2, e15, h10(e15[0]) && h10(e15[1]) ? t10.True : t10.False);
  } }, or: { priority: 1.1, calc: function(e15) {
    return m10(2, e15, t10.Operators.Or(e15[0], e15[1]));
  } }, orelse: { priority: 1.1, calc: function(e15) {
    return m10(2, e15, h10(e15[0]) || h10(e15[1]) ? t10.True : t10.False);
  } }, xor: { priority: 1, calc: function(e15) {
    return m10(2, e15, t10.Operators.Xor(e15[0], e15[1]));
  } } }, function(e15) {
    return { priority: e15.priority, calc: function(t11, n11) {
      return e15.calc(n11.map(function(e16) {
        return e16.Eval(t11);
      }));
    } };
  });
  js.operators = f10;
  var g10 = function(e15) {
    return function(t11, n11) {
      return e15(n11.map(function(e16) {
        return e16.Eval(t11);
      }));
    };
  };
  var y10 = function(e15, n11) {
    if (null !== n11[0] && void 0 !== n11[0]) {
      var o11 = n11.map(function(t11) {
        return t11.Eval(e15);
      });
      var a11 = o11[0];
      var i11 = null !== o11[1] && void 0 !== o11[1] ? t10.Convert.toString(o11[1]) : null;
      return t10.Create(r10.default(a11, null, i11));
    }
    return "";
  };
  var v10 = function(e15) {
    return t10.Create(t10.Convert.toString(e15[0]).indexOf(t10.Convert.toString(e15[1])) >= 0);
  };
  var b10 = n10.mapKeys(e14.__assign(e14.__assign({}, n10.mapValues(e14.__assign(e14.__assign(e14.__assign(e14.__assign(e14.__assign(e14.__assign(e14.__assign({ InStr: function(e15) {
    return t10.Create(t10.Convert.toString(e15[0]).indexOf(t10.Convert.toString(e15[1])) + 1);
  }, Contains: v10, ".Contains": v10, ".GetLength": function(e15) {
    if ("Object" !== e15[0].Type && !Array.isArray(e15[0].Value)) throw new Error("[expression evaluator] " + e15[0].Value + " is not array");
    if (e15[1] && 0 !== t10.Convert.toInteger(e15[1])) throw new Error("[expression evaluator] multi-dimensional arrays not supported");
    return t10.Create(e15[0].Value.length);
  }, Len: function(e15) {
    return t10.IsNull(e15[0]) ? t10.Null : t10.Create(t10.Convert.toString(e15[0]).length);
  }, Partition: d10.default, Chr: function(e15) {
    var n11 = t10.Convert.toInteger(e15[0]);
    if (n11 >= 0 && n11 <= 255) return t10.Create(String.fromCharCode(n11));
    throw new Error("[expression evaluator] Char code must be from 0 to 255 but was " + n11);
  }, Join: function(e15) {
    if ("Object" !== e15[0].Type) return t10.Create(t10.Convert.toString(e15[0]));
    var n11 = e15[0].Value;
    if (!Array.isArray(n11)) throw new Error("First argument of Join() function must be array");
    var r11 = e15.length > 1 ? t10.Convert.toString(e15[1]) : " ";
    return t10.Create(n11.map(function(e16) {
      return t10.Convert.toString(t10.Create(e16));
    }).join(r11));
  }, Split: function(e15) {
    var n11 = t10.Convert.toString(e15[0]);
    var r11 = e15.length > 1 ? t10.Convert.toString(e15[1]) : " ";
    var o11 = e15.length > 2 ? t10.Convert.toInteger(e15[2]) : -1;
    if (0 === n11.length) return t10.Create([]);
    if (0 === r11.length) return t10.Create([n11]);
    var a11 = -1 === o11 ? n11.split(r11) : n11.split(r11, o11);
    return t10.Create(a11);
  }, CStr: function(e15) {
    var n11 = e15[0];
    if (t10.isTimeVariant(n11)) {
      if (1 === n11.Value.year() && 0 === n11.Value.month() && 1 === n11.Value.date()) return t10.Create(r10.default(n11, null, "T"));
      if (0 === n11.Value.hour() && 0 === n11.Value.minute() && 0 === n11.Value.second()) return t10.Create(r10.default(n11, null, "d"));
    }
    return t10.Create(t10.Convert.toString(n11));
  }, IndexOf: function(n11) {
    var r11 = n11[0];
    switch (r11.Type) {
      case "String":
        return l10.classFunctions[".IndexOf"](e14.__spread([t10.Null], n11));
      case "Object":
        if (Array.isArray(r11.Value)) return c10.IndexOf(n11);
      default:
        throw new Error("[expression evaluator] IndexOf function must be called on String or Array");
    }
  } }, n10.mapValues(o10.default, function(t11) {
    return function(n11) {
      return t11(e14.__spread([S10.Convert], n11));
    };
  })), n10.mapValues(a10.default, function(t11) {
    return function(n11) {
      return t11(e14.__spread([S10.Math], n11));
    };
  })), n10.mapValues(i10.default, function(t11) {
    return function(n11) {
      return t11(e14.__spread([S10.Information], n11));
    };
  })), n10.mapValues(s10.functions, function(t11) {
    return function(n11) {
      return t11(e14.__spread([S10.DateTime], n11));
    };
  })), n10.mapValues(s10.classFunctions, function(t11) {
    return function(n11) {
      return t11(e14.__spread([S10.DateTime], n11));
    };
  })), n10.mapValues(l10.functions, function(t11) {
    return function(n11) {
      return t11(e14.__spread([S10.String], n11));
    };
  })), n10.mapValues(l10.classFunctions, function(t11) {
    return function(n11) {
      return t11(e14.__spread([S10.String], n11));
    };
  })), g10)), { Format: y10, ToString: y10, ".ToString": y10, ".Item": function(e15, n11) {
    if (2 !== n11.length) throw new Error("[syntax error] Item function must have 1 argument");
    var r11 = n11[0].Eval(e15);
    var o11 = ("" + n11[1].Eval(e15).Value).toLowerCase();
    if (!o11) throw new Error("[expression evaluator] Item function argument must be not empty");
    if (!t10.isObjectVariant(r11) && !t10.isStringVariant(r11)) throw new Error("[expression evaluator] Item function must be called on container");
    return p10.getValueFromContainer([o11], r11);
  }, Fields: function(e15, t11) {
    if (!e15.Data.fields) throw new Error("[expression evaluator] Fields collection is not provided");
    var n11 = ("" + t11[0].Eval(e15).Value).toLowerCase();
    if (!n11) throw new Error("[expression evaluator] Field name must be not empty");
    return p10.getValueFromContainer([n11], e15.Data.fields);
  }, IIf: function(e15, n11) {
    return t10.Convert.toBoolean(n11[0].Eval(e15)) ? n11[1].Eval(e15) : n11[2].Eval(e15);
  }, Choose: function(e15, n11) {
    return n11[t10.Convert.toInteger(n11[0].Eval(e15))].Eval(e15);
  }, Switch: function(e15, n11) {
    for (var r11 = 0; r11 < n11.length; r11 += 2) if (true === t10.Convert.toBoolean(n11[r11].Eval(e15))) return n11[r11 + 1].Eval(e15);
    return t10.Null;
  } }), function(e15) {
    return e15.toLowerCase();
  });
  js.predefinedFunctions = b10;
  var S10 = n10.mapKeys({ Math: n10.mapKeys(n10.mapValues(a10.default, g10), function(e15) {
    return e15.toLowerCase();
  }), Convert: n10.mapKeys(n10.mapValues(o10.default, g10), function(e15) {
    return e15.toLowerCase();
  }), Information: n10.mapKeys(n10.mapValues(i10.default, g10), function(e15) {
    return e15.toLowerCase();
  }), DateTime: n10.mapKeys(n10.mapValues(s10.functions, g10), function(e15) {
    return e15.toLowerCase();
  }), String: n10.mapKeys(n10.mapValues(l10.classFunctions, g10), function(e15) {
    return e15.toLowerCase().replace(/^\./, "");
  }) }, function(e15) {
    return e15.toLowerCase();
  });
  var C10 = n10.mapKeys(e14.__assign(e14.__assign({}, n10.mapValues(S10, function(e15) {
    return t10.Create(e15);
  })), { E: t10.Create(Math.E), PI: t10.Create(Math.PI), "Math.E": t10.Create(Math.E), "Math.PI": t10.Create(Math.PI), Nothing: t10.Null, Null: t10.Null, "DBNull.Value": t10.DBNull, "System.DBNull.Value": t10.DBNull, "Double.MinValue": t10.Create(-Infinity), "Double.MaxValue": t10.Create(17976931348623157e292), "Decimal.MinValue": t10.Create(-7922816251426434e13), "Decimal.MaxValue": t10.Create(7922816251426434e13), "Int32.MinValue": t10.Create(-2147483648), "Int32.MaxValue": t10.Create(2147483647), vbCrLf: t10.Create("\r\n") }), function(e15) {
    return e15.toLowerCase();
  });
  js.predefinedConstants = C10;
  var x10 = n10.mapKeys(e14.__assign({}, s10.variables), function(e15) {
    return e15.toLowerCase();
  });
  return js.predefinedVariables = x10, js;
}
var wl = {};
var Tl;
function El() {
  if (Tl) return wl;
  Tl = 1, Object.defineProperty(wl, "__esModule", { value: true }), wl.makeCustomCode = wl.CustomCodeInternal = void 0;
  var e14 = Ae;
  var t10 = Bl();
  var n10 = As();
  var r10 = {};
  return wl.CustomCodeInternal = { getFunctions: function() {
    return r10;
  }, registerFunctions: function(t11) {
    r10 = e14.__assign(e14.__assign({}, r10), t11);
  } }, wl.makeCustomCode = function() {
    var o10 = {};
    return Object.entries(r10).forEach(function(r11) {
      var a10 = e14.__read(r11, 2), i10 = a10[0], s10 = a10[1];
      o10[i10.toLowerCase()] = function(r12, o11) {
        var a11 = o11.slice(1).map(function(e15) {
          return e15.Eval(r12).Value;
        }).map(function(e15) {
          return Array.isArray(e15) ? e15.map(function(e16) {
            return n10.isVariant(e16) ? e16.Value : e16;
          }) : e15;
        });
        var l10 = null;
        try {
          l10 = s10.apply(void 0, e14.__spread(a11));
        } catch (e15) {
          throw new Error("[custom code expression]: Code." + i10 + "()\nexception: " + (e15 instanceof Error ? e15.message : "" + e15));
        }
        switch (typeof l10) {
          case "boolean":
          case "number":
          case "string":
          case "undefined":
            return t10.Tools.Variant.Create(l10);
          case "object":
            if (Array.isArray(l10)) return t10.Tools.Variant.Create(l10.map(function(e15) {
              return t10.Tools.Variant.Create(e15);
            }));
            if (l10 instanceof Promise) throw new Error("[custom code expression]: Code." + i10 + "()\nasync functions are not supported");
            return t10.Tools.Variant.Create(l10);
          default:
            throw new Error("[custom code expression]: Code." + i10 + "()\nunsupported return value type: " + typeof l10);
        }
      };
    }), { code: t10.Tools.Variant.Create(o10) };
  }, wl;
}
var Fl;
function Ml() {
  if (Fl) return $e;
  Fl = 1, Object.defineProperty($e, "__esModule", { value: true }), $e.makeExpressionNode = $e.compile = $e.parse = $e.containsNode = $e.replaceNode = $e.createTreeBuilder = $e.makeToken = void 0;
  var e14 = Ae;
  var t10 = di();
  var n10 = e14.__importStar(As());
  var r10 = Ws();
  var o10 = Oe;
  var a10 = xl();
  var i10 = Us();
  var s10 = Ds();
  var l10 = Sl();
  var c10 = El();
  function u10(e15, r11, o11, i11, l11, c11) {
    void 0 === c11 && (c11 = true);
    var u11 = e15.token.toLowerCase();
    var d11 = function(r12) {
      var o12 = e15.token;
      ("variable" === r12 || r12.includes("function")) && (o12 = o12.replace(/\!/g, "."));
      var a11 = parseFloat(o12);
      if (isNaN(a11)) {
        if ("true" === u11 || "false" === u11) o12 = "true" === u11;
        else if (e15 && '"' === e15.token[0]) o12 = e15.token.replace(/^"|"$/g, ""), c11 && (o12 = o12.replace(/""/g, '"'));
        else if (e15 && "#" === e15.token[0]) {
          var i12 = t10.dateTimeFactory.createFromString(e15.token.replace(/^#|#$/g, ""), s10.dateTimeFormats, true);
          o12 = null != i12 ? i12 : e15.token;
        }
      } else o12 = a11;
      switch (r12) {
        case "value":
          return { value: n10.Create(o12), type: r12, raw: e15 };
        case "operator":
        case "function":
          return { value: o12.toLowerCase(), type: r12, arity: 0, raw: e15 };
        default:
          return { value: o12.toLowerCase(), type: r12, raw: e15 };
      }
    };
    return function(e16) {
      return null == e16 || ("string" != typeof e16 || (!(isNaN(parseFloat(e16)) || !isFinite(parseFloat(e16))) || ("true" === e16.toLowerCase() || "false" === e16.toLowerCase() || e16.length > 0 && ('"' === e16[0] || "#" === e16[0]))));
    }(e15.token) ? d11("value") : u11 in i11 ? d11("constant") : !(u11.replace(/\!/g, ".") in o11) || u11.replace(/\!/g, ".") in l11 || r11 && "(" === r11.token || r11 && "." === r11.token[0] ? u11 in a10.operators ? d11("operator") : "," === e15.token ? d11("separator") : "(" === e15.token ? d11("left_bracket") : ")" === e15.token ? d11("right_bracket") : r11 && "(" === r11.token ? d11("function") : d11("variable") : d11("value");
  }
  function d10(t11, r11, o11, i11, s11) {
    void 0 === s11 && (s11 = true);
    var l11 = function(e15) {
      return e15[e15.length - 1];
    };
    var c11 = [];
    var d11 = [];
    var p11 = [];
    var m11;
    var h10 = function(t12) {
      var r12 = [];
      var o12 = [];
      for (var a11 = 0; a11 < t12.length; a11++) "variable" === (i12 = t12[a11]).type && ".!".includes(i12.value[0]) ? (r12.push({ type: "function", value: ".item", arity: 1, raw: i12.raw }), r12.push({ type: "left_bracket", value: "(" }), r12.push({ type: "value", value: n10.Create(i12.value.replace(/^[\.!]/, "")), raw: i12.raw }), r12.push({ type: "right_bracket", value: ")" })) : r12.push(i12);
      for (a11 = 0; a11 < r12.length - 1; a11++) {
        var i12;
        if ("function" === (i12 = r12[a11]).type && ".!".includes(i12.value[0])) {
          var s12 = [];
          var l12 = false;
          var c12 = 0;
          for (; !l12; ) {
            var u11 = o12.pop();
            if (u11) {
              "left_bracket" === u11.type ? c12++ : "right_bracket" === u11.type && c12--;
              var d12 = o12[o12.length - 1];
              0 !== c12 || d12 && "function" === d12.type || (l12 = true), s12.push(u11);
            } else l12 = true;
          }
          s12.reverse(), o12.push(r12[a11]), o12.push(r12[a11 + 1]), s12.length && (o12.push.apply(o12, e14.__spread(s12)), "right_bracket" !== r12[a11 + 2].type && o12.push({ type: "separator", value: "," })), a11++;
        } else o12.push(i12);
      }
      return r12.length > 0 && o12.push(r12[r12.length - 1]), o12;
    }(t11.map(function(e15, t12, n11) {
      return u10(e15, n11[t12 + 1], r11, o11, i11, s11);
    }));
    return h10.reduce(function(e15, t12, n11) {
      if (0 === n11 && "=" === t12.value) return e15;
      var r12 = t12;
      switch (r12.type) {
        case "variable":
        case "constant":
        case "value":
          e15.push(r12), d11.length > 0 && (d11.pop(), d11.push(true));
          break;
        case "function":
          r12.arity = 1, c11.push(r12), p11.push(0), d11.length > 0 && (d11.pop(), d11.push(true)), d11.push(false);
          break;
        case "separator":
          for (; c11.length > 0 && "left_bracket" !== l11(c11).type; ) {
            void 0 !== (o12 = c11.pop()) && e15.push(o12);
          }
          if (d11.pop()) void 0 !== (s12 = p11.pop()) && (s12++, p11.push(s12));
          d11.push(false);
          break;
        case "operator":
          if (m11 && "operator" !== m11.type && "left_bracket" !== m11.type && "separator" !== m11.type) for (r12.arity = 2; c11.length > 0 && "operator" === l11(c11).type && a10.operators[r12.value.toString().toLowerCase()].priority <= a10.operators[l11(c11).value.toString().toLowerCase()].priority; ) {
            void 0 !== (o12 = c11.pop()) && e15.push(o12);
          }
          else r12.arity = 1;
          c11.push(r12);
          break;
        case "left_bracket":
          if (m11 && "variable" === m11.type) throw new Error("[expression compiler] Syntax error at token: " + m11.value.toString());
          c11.push(r12);
          break;
        case "right_bracket":
          for (; c11.length > 0 && "left_bracket" !== l11(c11).type; ) {
            var o12;
            void 0 !== (o12 = c11.pop()) && e15.push(o12);
          }
          if (c11.pop(), c11.length > 0 && "function" === l11(c11).type) {
            var i12 = c11.pop();
            var s12 = p11.pop();
            d11.pop() && void 0 !== s12 && s12++, void 0 !== i12 && void 0 !== s12 && (i12.arity = s12, e15.push(i12));
          }
      }
      return m11 = r12, e15;
    }, []).concat(c11.reverse());
  }
  $e.makeToken = u10, $e.parse = d10;
  var p10 = function(e15, t11, n11) {
    return new r10.ExpressionNode(e15, t11, n11);
  };
  function m10(e15, t11, n11, r11) {
    var o11 = [];
    var s11 = function(s12) {
      var c12 = e15[s12];
      switch (c12.type) {
        case "value":
          o11.push(p10(function() {
            return c12.value;
          }, [], c12));
          break;
        case "variable":
          o11.push(p10(function(e16) {
            var t12 = function(e17, t13, n12) {
              var r12 = e17.split(".");
              if (n12) {
                var o12 = i10.getValueByKey(n12, e17);
                if (o12) return o12(t13, e17);
                var a11 = i10.getValueByKey(n12, r12[0]);
                if (a11) return a11(t13, e17);
              }
              return l10.getValueFromContainer(e17.split("."), t13.Data);
            }(c12.value, e16, r11);
            if (void 0 === t12) throw new Error("[expression evaluator] Variable value not provided: " + c12.value);
            return t12;
          }, [], c12));
          break;
        case "constant":
          o11.push(p10(function() {
            return n11[c12.value.toLowerCase()];
          }, [], c12));
          break;
        case "function":
          var u11 = [];
          for (var d11 = 0; d11 < c12.arity; d11++) u11.push(o11.pop());
          u11.reverse();
          var m11 = c12.value;
          m11.startsWith(".") ? o11.push(p10(function(e16, n12) {
            var r12 = n12[0] && n12[0].Eval(e16);
            var o12 = "Object" === r12.Type && i10.getValueByKey(r12.Value, m11.replace(/^\./, ""));
            if (!o12 || "function" != typeof o12) {
              if (!t11[m11]) throw new Error("[expression evaluator] Function " + m11 + " not found in " + (n12[0] && n12[0].Token.value));
              o12 = t11[m11];
            }
            return o12(e16, n12);
          }, u11, c12)) : o11.push(p10(function(e16, n12) {
            if (!t11[m11]) throw new Error("[expression compiler] Function not found: " + m11);
            return t11[m11](e16, n12);
          }, u11, c12));
          break;
        case "operator":
          var h10 = [];
          for (d11 = 0; d11 < c12.arity; d11++) h10.push(o11.pop());
          h10.reverse();
          var f10 = c12.value;
          if (!a10.operators[f10]) throw new Error("[expression compiler] Operator not found: " + c12.value);
          o11.push(p10(function(e16, t12) {
            return a10.operators[f10].calc(e16, t12);
          }, h10, c12));
          break;
        default:
          throw new Error("[expression compiler] Unexpected token type: " + c12.type);
      }
    };
    for (var c11 = 0; c11 < e15.length; c11++) s11(c11);
    if (1 === o11.length) return o11[0];
    throw new Error("[expression compiler] Compilation error");
  }
  return $e.makeExpressionNode = p10, $e.compile = m10, $e.createTreeBuilder = function(t11, r11, s11) {
    var l11 = i10.mapKeysDeep(e14.__assign(e14.__assign({}, a10.predefinedFunctions), t11), function(e15) {
      return e15.toLowerCase();
    });
    var u11 = i10.mapKeysDeep(e14.__assign(e14.__assign({}, a10.predefinedConstants), s11), function(e15) {
      return e15.toLowerCase();
    });
    var h10 = i10.mapKeysDeep(e14.__assign(e14.__assign({}, a10.predefinedVariables), r11), function(e15) {
      return e15.toLowerCase();
    });
    return function(t12) {
      if (t12 && "string" == typeof t12 && t12.trim().startsWith("=")) {
        var r12 = e14.__assign(e14.__assign({}, u11), c10.makeCustomCode());
        return m10(d10(o10.tokenize(t12), l11, r12, h10), l11, r12, h10);
      }
      return p10(function() {
        return n10.Create(t12);
      }, [], { type: "value", value: n10.Create(t12) });
    };
  }, $e.replaceNode = function e15(t11, n11, r11) {
    return n11(t11) ? r11(t11) : t11.ReplaceChildren(t11.Children.map(function(t12) {
      return e15(t12, n11, r11);
    }));
  }, $e.containsNode = function e15(t11, n11) {
    return !!n11(t11) || t11.Children.map(function(t12) {
      return e15(t12, n11);
    }).filter(function(e16) {
      return true === e16;
    }).length > 0;
  }, $e;
}
var kl = {};
function Pl(e14) {
  throw new Error('Could not dynamically require "' + e14 + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Nl = { exports: {} };
var Dl;
function Ll() {
  return Dl || (Dl = 1, e14 = Nl, Nl.exports, e14.exports = function e15(t10, n10, r10) {
    function o10(i11, s10) {
      if (!n10[i11]) {
        if (!t10[i11]) {
          if (!s10 && Pl) return Pl(i11);
          if (a10) return a10(i11, true);
          var l10 = new Error("Cannot find module '" + i11 + "'");
          throw l10.code = "MODULE_NOT_FOUND", l10;
        }
        var c10 = n10[i11] = { exports: {} };
        t10[i11][0].call(c10.exports, function(e16) {
          var n11 = t10[i11][1][e16];
          return o10(n11 || e16);
        }, c10, c10.exports, e15, t10, n10, r10);
      }
      return n10[i11].exports;
    }
    var a10 = Pl;
    for (var i10 = 0; i10 < r10.length; i10++) o10(r10[i10]);
    return o10;
  }({ 1: [function(e15, t10, n10) {
    /*!
    		 * XRegExp.build 3.2.0
    		 * <xregexp.com>
    		 * Steven Levithan (c) 2012-2017 MIT License
    		 * Inspired by Lea Verou's RegExp.create <lea.verou.me>
    		 */
    t10.exports = function(e16) {
      var t11 = "xregexp";
      var n11 = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g;
      var r10 = e16.union([/\({{([\w$]+)}}\)|{{([\w$]+)}}/, n11], "g", { conjunction: "or" });
      function o10(e17) {
        var t12 = /^(?:\(\?:\))*\^/;
        var n12 = /\$(?:\(\?:\))*$/;
        return t12.test(e17) && n12.test(e17) && n12.test(e17.replace(/\\[\s\S]/g, "")) ? e17.replace(t12, "").replace(n12, "") : e17;
      }
      function a10(n12, r11) {
        var o11 = r11 ? "x" : "";
        return e16.isRegExp(n12) ? n12[t11] && n12[t11].captureNames ? n12 : e16(n12.source, o11) : e16(n12, o11);
      }
      e16.build = function(i10, s10, l10) {
        var c10 = (l10 = l10 || "").indexOf("x") > -1;
        var u10 = /^\(\?([\w$]+)\)/.exec(i10);
        u10 && (l10 = e16._clipDuplicates(l10 + u10[1]));
        var d10 = {};
        for (var p10 in s10) if (s10.hasOwnProperty(p10)) {
          var m10 = a10(s10[p10], c10);
          d10[p10] = { pattern: o10(m10.source), names: m10[t11].captureNames || [] };
        }
        var h10 = a10(i10, c10);
        var f10 = 0;
        var g10;
        var y10 = 0;
        var v10 = [0];
        var b10 = h10[t11].captureNames || [];
        var S10 = h10.source.replace(r10, function(e17, t12, r11, o11, a11) {
          var i11 = t12 || r11;
          var s11;
          var l11;
          var c11;
          if (i11) {
            if (!d10.hasOwnProperty(i11)) throw new ReferenceError("Undefined property " + e17);
            return t12 ? (s11 = b10[y10], v10[++y10] = ++f10, l11 = "(?<" + (s11 || i11) + ">") : l11 = "(?:", g10 = f10, l11 + d10[i11].pattern.replace(n11, function(e18, t13, n12) {
              if (t13) {
                if (s11 = d10[i11].names[f10 - g10], ++f10, s11) return "(?<" + s11 + ">";
              } else if (n12) return c11 = +n12 - 1, d10[i11].names[c11] ? "\\k<" + d10[i11].names[c11] + ">" : "\\" + (+n12 + g10);
              return e18;
            }) + ")";
          }
          if (o11) {
            if (s11 = b10[y10], v10[++y10] = ++f10, s11) return "(?<" + s11 + ">";
          } else if (a11) return b10[c11 = +a11 - 1] ? "\\k<" + b10[c11] + ">" : "\\" + v10[+a11];
          return e17;
        });
        return e16(S10, l10);
      };
    };
  }, {}], 2: [function(e15, t10, n10) {
    /*!
    		 * XRegExp.matchRecursive 3.2.0
    		 * <xregexp.com>
    		 * Steven Levithan (c) 2009-2017 MIT License
    		 */
    t10.exports = function(e16) {
      function t11(e17, t12, n11, r10) {
        return { name: e17, value: t12, start: n11, end: r10 };
      }
      e16.matchRecursive = function(n11, r10, o10, a10, i10) {
        i10 = i10 || {};
        var s10 = (a10 = a10 || "").indexOf("g") > -1;
        var l10 = a10.indexOf("y") > -1;
        var c10 = a10.replace(/y/g, "");
        var u10 = i10.escapeChar;
        var d10 = i10.valueNames;
        var p10 = [];
        var m10 = 0;
        var h10 = 0;
        var f10 = 0;
        var g10 = 0;
        var y10;
        var v10;
        var b10;
        var S10;
        var C10;
        if (r10 = e16(r10, c10), o10 = e16(o10, c10), u10) {
          if (u10.length > 1) throw new Error("Cannot use more than one escape character");
          u10 = e16.escape(u10), C10 = new RegExp("(?:" + u10 + "[\\S\\s]|(?:(?!" + e16.union([r10, o10], "", { conjunction: "or" }).source + ")[^" + u10 + "])+)+", a10.replace(/[^imu]+/g, ""));
        }
        for (; ; ) {
          if (u10 && (f10 += (e16.exec(n11, C10, f10, "sticky") || [""])[0].length), b10 = e16.exec(n11, r10, f10), S10 = e16.exec(n11, o10, f10), b10 && S10 && (b10.index <= S10.index ? S10 = null : b10 = null), b10 || S10) f10 = (h10 = (b10 || S10).index) + (b10 || S10)[0].length;
          else if (!m10) break;
          if (l10 && !m10 && h10 > g10) break;
          if (b10) m10 || (y10 = h10, v10 = f10), ++m10;
          else {
            if (!S10 || !m10) throw new Error("Unbalanced delimiter found in string");
            if (!--m10 && (d10 ? (d10[0] && y10 > g10 && p10.push(t11(d10[0], n11.slice(g10, y10), g10, y10)), d10[1] && p10.push(t11(d10[1], n11.slice(y10, v10), y10, v10)), d10[2] && p10.push(t11(d10[2], n11.slice(v10, h10), v10, h10)), d10[3] && p10.push(t11(d10[3], n11.slice(h10, f10), h10, f10))) : p10.push(n11.slice(v10, h10)), g10 = f10, !s10)) break;
          }
          h10 === f10 && ++f10;
        }
        return s10 && !l10 && d10 && d10[0] && n11.length > g10 && p10.push(t11(d10[0], n11.slice(g10), g10, n11.length)), p10;
      };
    };
  }, {}], 3: [function(e15, t10, n10) {
    /*!
    		 * XRegExp Unicode Base 3.2.0
    		 * <xregexp.com>
    		 * Steven Levithan (c) 2008-2017 MIT License
    		 */
    t10.exports = function(e16) {
      var t11 = {};
      var n11 = e16._dec;
      var r10 = e16._hex;
      var o10 = e16._pad4;
      function a10(e17) {
        return e17.replace(/[- _]+/g, "").toLowerCase();
      }
      function i10(e17) {
        var t12 = /^\\[xu](.+)/.exec(e17);
        return t12 ? n11(t12[1]) : e17.charCodeAt("\\" === e17.charAt(0) ? 1 : 0);
      }
      function s10(t12) {
        var n12 = "";
        var a11 = -1;
        return e16.forEach(t12, /(\\x..|\\u....|\\?[\s\S])(?:-(\\x..|\\u....|\\?[\s\S]))?/, function(e17) {
          var t13 = i10(e17[1]);
          t13 > a11 + 1 && (n12 += "\\u" + o10(r10(a11 + 1)), t13 > a11 + 2 && (n12 += "-\\u" + o10(r10(t13 - 1)))), a11 = i10(e17[2] || e17[1]);
        }), a11 < 65535 && (n12 += "\\u" + o10(r10(a11 + 1)), a11 < 65534 && (n12 += "-\\uFFFF")), n12;
      }
      function l10(e17) {
        var n12 = "b!";
        return t11[e17][n12] || (t11[e17][n12] = s10(t11[e17].bmp));
      }
      function c10(e17, n12) {
        var r11 = t11[e17];
        var o11 = "";
        return r11.bmp && !r11.isBmpLast && (o11 = "[" + r11.bmp + "]" + (r11.astral ? "|" : "")), r11.astral && (o11 += r11.astral), r11.isBmpLast && r11.bmp && (o11 += (r11.astral ? "|" : "") + "[" + r11.bmp + "]"), n12 ? "(?:(?!" + o11 + ")(?:[\uD800-\uDBFF][\uDC00-\uDFFF]|[\0-\uFFFF]))" : "(?:" + o11 + ")";
      }
      function u10(e17, n12) {
        var r11 = n12 ? "a!" : "a=";
        return t11[e17][r11] || (t11[e17][r11] = c10(e17, n12));
      }
      e16.addToken(/\\([pP])(?:{(\^?)([^}]*)}|([A-Za-z]))/, function(e17, n12, r11) {
        var o11 = "Invalid double negation ";
        var i11 = "Unknown Unicode token ";
        var s11 = "Unicode token missing data ";
        var c11 = "Astral mode required for Unicode token ";
        var d10 = "Astral mode does not support Unicode tokens within character classes";
        var p10 = "P" === e17[1] || !!e17[2];
        var m10 = r11.indexOf("A") > -1;
        var h10 = a10(e17[4] || e17[3]);
        var f10 = t11[h10];
        if ("P" === e17[1] && e17[2]) throw new SyntaxError(o11 + e17[0]);
        if (!t11.hasOwnProperty(h10)) throw new SyntaxError(i11 + e17[0]);
        if (f10.inverseOf) {
          if (h10 = a10(f10.inverseOf), !t11.hasOwnProperty(h10)) throw new ReferenceError(s11 + e17[0] + " -> " + f10.inverseOf);
          f10 = t11[h10], p10 = !p10;
        }
        if (!f10.bmp && !m10) throw new SyntaxError(c11 + e17[0]);
        if (m10) {
          if ("class" === n12) throw new SyntaxError(d10);
          return u10(h10, p10);
        }
        return "class" === n12 ? p10 ? l10(h10) : f10.bmp : (p10 ? "[^" : "[") + f10.bmp + "]";
      }, { scope: "all", optionalFlags: "A", leadChar: "\\" }), e16.addUnicodeData = function(n12) {
        var r11 = "Unicode token requires name";
        var o11 = "Unicode token has no character data ";
        var i11;
        for (var s11 = 0; s11 < n12.length; ++s11) {
          if (!(i11 = n12[s11]).name) throw new Error(r11);
          if (!(i11.inverseOf || i11.bmp || i11.astral)) throw new Error(o11 + i11.name);
          t11[a10(i11.name)] = i11, i11.alias && (t11[a10(i11.alias)] = i11);
        }
        e16.cache.flush("patterns");
      }, e16._getUnicodeProperty = function(e17) {
        var n12 = a10(e17);
        return t11[n12];
      };
    };
  }, {}], 4: [function(e15, t10, n10) {
    /*!
    		 * XRegExp Unicode Blocks 3.2.0
    		 * <xregexp.com>
    		 * Steven Levithan (c) 2010-2017 MIT License
    		 * Unicode data by Mathias Bynens <mathiasbynens.be>
    		 */
    t10.exports = function(e16) {
      if (!e16.addUnicodeData) throw new ReferenceError("Unicode Base must be loaded before Unicode Blocks");
      e16.addUnicodeData([{ name: "InAdlam", astral: "\uD83A[\uDD00-\uDD5F]" }, { name: "InAegean_Numbers", astral: "\uD800[\uDD00-\uDD3F]" }, { name: "InAhom", astral: "\uD805[\uDF00-\uDF3F]" }, { name: "InAlchemical_Symbols", astral: "\uD83D[\uDF00-\uDF7F]" }, { name: "InAlphabetic_Presentation_Forms", bmp: "\uFB00-\uFB4F" }, { name: "InAnatolian_Hieroglyphs", astral: "\uD811[\uDC00-\uDE7F]" }, { name: "InAncient_Greek_Musical_Notation", astral: "\uD834[\uDE00-\uDE4F]" }, { name: "InAncient_Greek_Numbers", astral: "\uD800[\uDD40-\uDD8F]" }, { name: "InAncient_Symbols", astral: "\uD800[\uDD90-\uDDCF]" }, { name: "InArabic", bmp: "\u0600-\u06FF" }, { name: "InArabic_Extended_A", bmp: "\u08A0-\u08FF" }, { name: "InArabic_Mathematical_Alphabetic_Symbols", astral: "\uD83B[\uDE00-\uDEFF]" }, { name: "InArabic_Presentation_Forms_A", bmp: "\uFB50-\uFDFF" }, { name: "InArabic_Presentation_Forms_B", bmp: "\uFE70-\uFEFF" }, { name: "InArabic_Supplement", bmp: "\u0750-\u077F" }, { name: "InArmenian", bmp: "\u0530-\u058F" }, { name: "InArrows", bmp: "\u2190-\u21FF" }, { name: "InAvestan", astral: "\uD802[\uDF00-\uDF3F]" }, { name: "InBalinese", bmp: "\u1B00-\u1B7F" }, { name: "InBamum", bmp: "\uA6A0-\uA6FF" }, { name: "InBamum_Supplement", astral: "\uD81A[\uDC00-\uDE3F]" }, { name: "InBasic_Latin", bmp: "\0-\x7F" }, { name: "InBassa_Vah", astral: "\uD81A[\uDED0-\uDEFF]" }, { name: "InBatak", bmp: "\u1BC0-\u1BFF" }, { name: "InBengali", bmp: "\u0980-\u09FF" }, { name: "InBhaiksuki", astral: "\uD807[\uDC00-\uDC6F]" }, { name: "InBlock_Elements", bmp: "\u2580-\u259F" }, { name: "InBopomofo", bmp: "\u3100-\u312F" }, { name: "InBopomofo_Extended", bmp: "\u31A0-\u31BF" }, { name: "InBox_Drawing", bmp: "\u2500-\u257F" }, { name: "InBrahmi", astral: "\uD804[\uDC00-\uDC7F]" }, { name: "InBraille_Patterns", bmp: "\u2800-\u28FF" }, { name: "InBuginese", bmp: "\u1A00-\u1A1F" }, { name: "InBuhid", bmp: "\u1740-\u175F" }, { name: "InByzantine_Musical_Symbols", astral: "\uD834[\uDC00-\uDCFF]" }, { name: "InCJK_Compatibility", bmp: "\u3300-\u33FF" }, { name: "InCJK_Compatibility_Forms", bmp: "\uFE30-\uFE4F" }, { name: "InCJK_Compatibility_Ideographs", bmp: "\uF900-\uFAFF" }, { name: "InCJK_Compatibility_Ideographs_Supplement", astral: "\uD87E[\uDC00-\uDE1F]" }, { name: "InCJK_Radicals_Supplement", bmp: "\u2E80-\u2EFF" }, { name: "InCJK_Strokes", bmp: "\u31C0-\u31EF" }, { name: "InCJK_Symbols_and_Punctuation", bmp: "\u3000-\u303F" }, { name: "InCJK_Unified_Ideographs", bmp: "\u4E00-\u9FFF" }, { name: "InCJK_Unified_Ideographs_Extension_A", bmp: "\u3400-\u4DBF" }, { name: "InCJK_Unified_Ideographs_Extension_B", astral: "[\uD840-\uD868][\uDC00-\uDFFF]|\uD869[\uDC00-\uDEDF]" }, { name: "InCJK_Unified_Ideographs_Extension_C", astral: "\uD869[\uDF00-\uDFFF]|[\uD86A-\uD86C][\uDC00-\uDFFF]|\uD86D[\uDC00-\uDF3F]" }, { name: "InCJK_Unified_Ideographs_Extension_D", astral: "\uD86D[\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1F]" }, { name: "InCJK_Unified_Ideographs_Extension_E", astral: "\uD86E[\uDC20-\uDFFF]|[\uD86F-\uD872][\uDC00-\uDFFF]|\uD873[\uDC00-\uDEAF]" }, { name: "InCarian", astral: "\uD800[\uDEA0-\uDEDF]" }, { name: "InCaucasian_Albanian", astral: "\uD801[\uDD30-\uDD6F]" }, { name: "InChakma", astral: "\uD804[\uDD00-\uDD4F]" }, { name: "InCham", bmp: "\uAA00-\uAA5F" }, { name: "InCherokee", bmp: "\u13A0-\u13FF" }, { name: "InCherokee_Supplement", bmp: "\uAB70-\uABBF" }, { name: "InCombining_Diacritical_Marks", bmp: "\u0300-\u036F" }, { name: "InCombining_Diacritical_Marks_Extended", bmp: "\u1AB0-\u1AFF" }, { name: "InCombining_Diacritical_Marks_Supplement", bmp: "\u1DC0-\u1DFF" }, { name: "InCombining_Diacritical_Marks_for_Symbols", bmp: "\u20D0-\u20FF" }, { name: "InCombining_Half_Marks", bmp: "\uFE20-\uFE2F" }, { name: "InCommon_Indic_Number_Forms", bmp: "\uA830-\uA83F" }, { name: "InControl_Pictures", bmp: "\u2400-\u243F" }, { name: "InCoptic", bmp: "\u2C80-\u2CFF" }, { name: "InCoptic_Epact_Numbers", astral: "\uD800[\uDEE0-\uDEFF]" }, { name: "InCounting_Rod_Numerals", astral: "\uD834[\uDF60-\uDF7F]" }, { name: "InCuneiform", astral: "\uD808[\uDC00-\uDFFF]" }, { name: "InCuneiform_Numbers_and_Punctuation", astral: "\uD809[\uDC00-\uDC7F]" }, { name: "InCurrency_Symbols", bmp: "\u20A0-\u20CF" }, { name: "InCypriot_Syllabary", astral: "\uD802[\uDC00-\uDC3F]" }, { name: "InCyrillic", bmp: "\u0400-\u04FF" }, { name: "InCyrillic_Extended_A", bmp: "\u2DE0-\u2DFF" }, { name: "InCyrillic_Extended_B", bmp: "\uA640-\uA69F" }, { name: "InCyrillic_Extended_C", bmp: "\u1C80-\u1C8F" }, { name: "InCyrillic_Supplement", bmp: "\u0500-\u052F" }, { name: "InDeseret", astral: "\uD801[\uDC00-\uDC4F]" }, { name: "InDevanagari", bmp: "\u0900-\u097F" }, { name: "InDevanagari_Extended", bmp: "\uA8E0-\uA8FF" }, { name: "InDingbats", bmp: "\u2700-\u27BF" }, { name: "InDomino_Tiles", astral: "\uD83C[\uDC30-\uDC9F]" }, { name: "InDuployan", astral: "\uD82F[\uDC00-\uDC9F]" }, { name: "InEarly_Dynastic_Cuneiform", astral: "\uD809[\uDC80-\uDD4F]" }, { name: "InEgyptian_Hieroglyphs", astral: "\uD80C[\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F]" }, { name: "InElbasan", astral: "\uD801[\uDD00-\uDD2F]" }, { name: "InEmoticons", astral: "\uD83D[\uDE00-\uDE4F]" }, { name: "InEnclosed_Alphanumeric_Supplement", astral: "\uD83C[\uDD00-\uDDFF]" }, { name: "InEnclosed_Alphanumerics", bmp: "\u2460-\u24FF" }, { name: "InEnclosed_CJK_Letters_and_Months", bmp: "\u3200-\u32FF" }, { name: "InEnclosed_Ideographic_Supplement", astral: "\uD83C[\uDE00-\uDEFF]" }, { name: "InEthiopic", bmp: "\u1200-\u137F" }, { name: "InEthiopic_Extended", bmp: "\u2D80-\u2DDF" }, { name: "InEthiopic_Extended_A", bmp: "\uAB00-\uAB2F" }, { name: "InEthiopic_Supplement", bmp: "\u1380-\u139F" }, { name: "InGeneral_Punctuation", bmp: "\u2000-\u206F" }, { name: "InGeometric_Shapes", bmp: "\u25A0-\u25FF" }, { name: "InGeometric_Shapes_Extended", astral: "\uD83D[\uDF80-\uDFFF]" }, { name: "InGeorgian", bmp: "\u10A0-\u10FF" }, { name: "InGeorgian_Supplement", bmp: "\u2D00-\u2D2F" }, { name: "InGlagolitic", bmp: "\u2C00-\u2C5F" }, { name: "InGlagolitic_Supplement", astral: "\uD838[\uDC00-\uDC2F]" }, { name: "InGothic", astral: "\uD800[\uDF30-\uDF4F]" }, { name: "InGrantha", astral: "\uD804[\uDF00-\uDF7F]" }, { name: "InGreek_Extended", bmp: "\u1F00-\u1FFF" }, { name: "InGreek_and_Coptic", bmp: "\u0370-\u03FF" }, { name: "InGujarati", bmp: "\u0A80-\u0AFF" }, { name: "InGurmukhi", bmp: "\u0A00-\u0A7F" }, { name: "InHalfwidth_and_Fullwidth_Forms", bmp: "\uFF00-\uFFEF" }, { name: "InHangul_Compatibility_Jamo", bmp: "\u3130-\u318F" }, { name: "InHangul_Jamo", bmp: "\u1100-\u11FF" }, { name: "InHangul_Jamo_Extended_A", bmp: "\uA960-\uA97F" }, { name: "InHangul_Jamo_Extended_B", bmp: "\uD7B0-\uD7FF" }, { name: "InHangul_Syllables", bmp: "\uAC00-\uD7AF" }, { name: "InHanunoo", bmp: "\u1720-\u173F" }, { name: "InHatran", astral: "\uD802[\uDCE0-\uDCFF]" }, { name: "InHebrew", bmp: "\u0590-\u05FF" }, { name: "InHigh_Private_Use_Surrogates", bmp: "\uDB80-\uDBFF" }, { name: "InHigh_Surrogates", bmp: "\uD800-\uDB7F" }, { name: "InHiragana", bmp: "\u3040-\u309F" }, { name: "InIPA_Extensions", bmp: "\u0250-\u02AF" }, { name: "InIdeographic_Description_Characters", bmp: "\u2FF0-\u2FFF" }, { name: "InIdeographic_Symbols_and_Punctuation", astral: "\uD81B[\uDFE0-\uDFFF]" }, { name: "InImperial_Aramaic", astral: "\uD802[\uDC40-\uDC5F]" }, { name: "InInscriptional_Pahlavi", astral: "\uD802[\uDF60-\uDF7F]" }, { name: "InInscriptional_Parthian", astral: "\uD802[\uDF40-\uDF5F]" }, { name: "InJavanese", bmp: "\uA980-\uA9DF" }, { name: "InKaithi", astral: "\uD804[\uDC80-\uDCCF]" }, { name: "InKana_Supplement", astral: "\uD82C[\uDC00-\uDCFF]" }, { name: "InKanbun", bmp: "\u3190-\u319F" }, { name: "InKangxi_Radicals", bmp: "\u2F00-\u2FDF" }, { name: "InKannada", bmp: "\u0C80-\u0CFF" }, { name: "InKatakana", bmp: "\u30A0-\u30FF" }, { name: "InKatakana_Phonetic_Extensions", bmp: "\u31F0-\u31FF" }, { name: "InKayah_Li", bmp: "\uA900-\uA92F" }, { name: "InKharoshthi", astral: "\uD802[\uDE00-\uDE5F]" }, { name: "InKhmer", bmp: "\u1780-\u17FF" }, { name: "InKhmer_Symbols", bmp: "\u19E0-\u19FF" }, { name: "InKhojki", astral: "\uD804[\uDE00-\uDE4F]" }, { name: "InKhudawadi", astral: "\uD804[\uDEB0-\uDEFF]" }, { name: "InLao", bmp: "\u0E80-\u0EFF" }, { name: "InLatin_Extended_Additional", bmp: "\u1E00-\u1EFF" }, { name: "InLatin_Extended_A", bmp: "\u0100-\u017F" }, { name: "InLatin_Extended_B", bmp: "\u0180-\u024F" }, { name: "InLatin_Extended_C", bmp: "\u2C60-\u2C7F" }, { name: "InLatin_Extended_D", bmp: "\uA720-\uA7FF" }, { name: "InLatin_Extended_E", bmp: "\uAB30-\uAB6F" }, { name: "InLatin_1_Supplement", bmp: "\x80-\xFF" }, { name: "InLepcha", bmp: "\u1C00-\u1C4F" }, { name: "InLetterlike_Symbols", bmp: "\u2100-\u214F" }, { name: "InLimbu", bmp: "\u1900-\u194F" }, { name: "InLinear_A", astral: "\uD801[\uDE00-\uDF7F]" }, { name: "InLinear_B_Ideograms", astral: "\uD800[\uDC80-\uDCFF]" }, { name: "InLinear_B_Syllabary", astral: "\uD800[\uDC00-\uDC7F]" }, { name: "InLisu", bmp: "\uA4D0-\uA4FF" }, { name: "InLow_Surrogates", bmp: "\uDC00-\uDFFF" }, { name: "InLycian", astral: "\uD800[\uDE80-\uDE9F]" }, { name: "InLydian", astral: "\uD802[\uDD20-\uDD3F]" }, { name: "InMahajani", astral: "\uD804[\uDD50-\uDD7F]" }, { name: "InMahjong_Tiles", astral: "\uD83C[\uDC00-\uDC2F]" }, { name: "InMalayalam", bmp: "\u0D00-\u0D7F" }, { name: "InMandaic", bmp: "\u0840-\u085F" }, { name: "InManichaean", astral: "\uD802[\uDEC0-\uDEFF]" }, { name: "InMarchen", astral: "\uD807[\uDC70-\uDCBF]" }, { name: "InMathematical_Alphanumeric_Symbols", astral: "\uD835[\uDC00-\uDFFF]" }, { name: "InMathematical_Operators", bmp: "\u2200-\u22FF" }, { name: "InMeetei_Mayek", bmp: "\uABC0-\uABFF" }, { name: "InMeetei_Mayek_Extensions", bmp: "\uAAE0-\uAAFF" }, { name: "InMende_Kikakui", astral: "\uD83A[\uDC00-\uDCDF]" }, { name: "InMeroitic_Cursive", astral: "\uD802[\uDDA0-\uDDFF]" }, { name: "InMeroitic_Hieroglyphs", astral: "\uD802[\uDD80-\uDD9F]" }, { name: "InMiao", astral: "\uD81B[\uDF00-\uDF9F]" }, { name: "InMiscellaneous_Mathematical_Symbols_A", bmp: "\u27C0-\u27EF" }, { name: "InMiscellaneous_Mathematical_Symbols_B", bmp: "\u2980-\u29FF" }, { name: "InMiscellaneous_Symbols", bmp: "\u2600-\u26FF" }, { name: "InMiscellaneous_Symbols_and_Arrows", bmp: "\u2B00-\u2BFF" }, { name: "InMiscellaneous_Symbols_and_Pictographs", astral: "\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF]" }, { name: "InMiscellaneous_Technical", bmp: "\u2300-\u23FF" }, { name: "InModi", astral: "\uD805[\uDE00-\uDE5F]" }, { name: "InModifier_Tone_Letters", bmp: "\uA700-\uA71F" }, { name: "InMongolian", bmp: "\u1800-\u18AF" }, { name: "InMongolian_Supplement", astral: "\uD805[\uDE60-\uDE7F]" }, { name: "InMro", astral: "\uD81A[\uDE40-\uDE6F]" }, { name: "InMultani", astral: "\uD804[\uDE80-\uDEAF]" }, { name: "InMusical_Symbols", astral: "\uD834[\uDD00-\uDDFF]" }, { name: "InMyanmar", bmp: "\u1000-\u109F" }, { name: "InMyanmar_Extended_A", bmp: "\uAA60-\uAA7F" }, { name: "InMyanmar_Extended_B", bmp: "\uA9E0-\uA9FF" }, { name: "InNKo", bmp: "\u07C0-\u07FF" }, { name: "InNabataean", astral: "\uD802[\uDC80-\uDCAF]" }, { name: "InNew_Tai_Lue", bmp: "\u1980-\u19DF" }, { name: "InNewa", astral: "\uD805[\uDC00-\uDC7F]" }, { name: "InNumber_Forms", bmp: "\u2150-\u218F" }, { name: "InOgham", bmp: "\u1680-\u169F" }, { name: "InOl_Chiki", bmp: "\u1C50-\u1C7F" }, { name: "InOld_Hungarian", astral: "\uD803[\uDC80-\uDCFF]" }, { name: "InOld_Italic", astral: "\uD800[\uDF00-\uDF2F]" }, { name: "InOld_North_Arabian", astral: "\uD802[\uDE80-\uDE9F]" }, { name: "InOld_Permic", astral: "\uD800[\uDF50-\uDF7F]" }, { name: "InOld_Persian", astral: "\uD800[\uDFA0-\uDFDF]" }, { name: "InOld_South_Arabian", astral: "\uD802[\uDE60-\uDE7F]" }, { name: "InOld_Turkic", astral: "\uD803[\uDC00-\uDC4F]" }, { name: "InOptical_Character_Recognition", bmp: "\u2440-\u245F" }, { name: "InOriya", bmp: "\u0B00-\u0B7F" }, { name: "InOrnamental_Dingbats", astral: "\uD83D[\uDE50-\uDE7F]" }, { name: "InOsage", astral: "\uD801[\uDCB0-\uDCFF]" }, { name: "InOsmanya", astral: "\uD801[\uDC80-\uDCAF]" }, { name: "InPahawh_Hmong", astral: "\uD81A[\uDF00-\uDF8F]" }, { name: "InPalmyrene", astral: "\uD802[\uDC60-\uDC7F]" }, { name: "InPau_Cin_Hau", astral: "\uD806[\uDEC0-\uDEFF]" }, { name: "InPhags_pa", bmp: "\uA840-\uA87F" }, { name: "InPhaistos_Disc", astral: "\uD800[\uDDD0-\uDDFF]" }, { name: "InPhoenician", astral: "\uD802[\uDD00-\uDD1F]" }, { name: "InPhonetic_Extensions", bmp: "\u1D00-\u1D7F" }, { name: "InPhonetic_Extensions_Supplement", bmp: "\u1D80-\u1DBF" }, { name: "InPlaying_Cards", astral: "\uD83C[\uDCA0-\uDCFF]" }, { name: "InPrivate_Use_Area", bmp: "\uE000-\uF8FF" }, { name: "InPsalter_Pahlavi", astral: "\uD802[\uDF80-\uDFAF]" }, { name: "InRejang", bmp: "\uA930-\uA95F" }, { name: "InRumi_Numeral_Symbols", astral: "\uD803[\uDE60-\uDE7F]" }, { name: "InRunic", bmp: "\u16A0-\u16FF" }, { name: "InSamaritan", bmp: "\u0800-\u083F" }, { name: "InSaurashtra", bmp: "\uA880-\uA8DF" }, { name: "InSharada", astral: "\uD804[\uDD80-\uDDDF]" }, { name: "InShavian", astral: "\uD801[\uDC50-\uDC7F]" }, { name: "InShorthand_Format_Controls", astral: "\uD82F[\uDCA0-\uDCAF]" }, { name: "InSiddham", astral: "\uD805[\uDD80-\uDDFF]" }, { name: "InSinhala", bmp: "\u0D80-\u0DFF" }, { name: "InSinhala_Archaic_Numbers", astral: "\uD804[\uDDE0-\uDDFF]" }, { name: "InSmall_Form_Variants", bmp: "\uFE50-\uFE6F" }, { name: "InSora_Sompeng", astral: "\uD804[\uDCD0-\uDCFF]" }, { name: "InSpacing_Modifier_Letters", bmp: "\u02B0-\u02FF" }, { name: "InSpecials", bmp: "\uFFF0-\uFFFF" }, { name: "InSundanese", bmp: "\u1B80-\u1BBF" }, { name: "InSundanese_Supplement", bmp: "\u1CC0-\u1CCF" }, { name: "InSuperscripts_and_Subscripts", bmp: "\u2070-\u209F" }, { name: "InSupplemental_Arrows_A", bmp: "\u27F0-\u27FF" }, { name: "InSupplemental_Arrows_B", bmp: "\u2900-\u297F" }, { name: "InSupplemental_Arrows_C", astral: "\uD83E[\uDC00-\uDCFF]" }, { name: "InSupplemental_Mathematical_Operators", bmp: "\u2A00-\u2AFF" }, { name: "InSupplemental_Punctuation", bmp: "\u2E00-\u2E7F" }, { name: "InSupplemental_Symbols_and_Pictographs", astral: "\uD83E[\uDD00-\uDDFF]" }, { name: "InSupplementary_Private_Use_Area_A", astral: "[\uDB80-\uDBBF][\uDC00-\uDFFF]" }, { name: "InSupplementary_Private_Use_Area_B", astral: "[\uDBC0-\uDBFF][\uDC00-\uDFFF]" }, { name: "InSutton_SignWriting", astral: "\uD836[\uDC00-\uDEAF]" }, { name: "InSyloti_Nagri", bmp: "\uA800-\uA82F" }, { name: "InSyriac", bmp: "\u0700-\u074F" }, { name: "InTagalog", bmp: "\u1700-\u171F" }, { name: "InTagbanwa", bmp: "\u1760-\u177F" }, { name: "InTags", astral: "\uDB40[\uDC00-\uDC7F]" }, { name: "InTai_Le", bmp: "\u1950-\u197F" }, { name: "InTai_Tham", bmp: "\u1A20-\u1AAF" }, { name: "InTai_Viet", bmp: "\uAA80-\uAADF" }, { name: "InTai_Xuan_Jing_Symbols", astral: "\uD834[\uDF00-\uDF5F]" }, { name: "InTakri", astral: "\uD805[\uDE80-\uDECF]" }, { name: "InTamil", bmp: "\u0B80-\u0BFF" }, { name: "InTangut", astral: "[\uD81C-\uD821][\uDC00-\uDFFF]" }, { name: "InTangut_Components", astral: "\uD822[\uDC00-\uDEFF]" }, { name: "InTelugu", bmp: "\u0C00-\u0C7F" }, { name: "InThaana", bmp: "\u0780-\u07BF" }, { name: "InThai", bmp: "\u0E00-\u0E7F" }, { name: "InTibetan", bmp: "\u0F00-\u0FFF" }, { name: "InTifinagh", bmp: "\u2D30-\u2D7F" }, { name: "InTirhuta", astral: "\uD805[\uDC80-\uDCDF]" }, { name: "InTransport_and_Map_Symbols", astral: "\uD83D[\uDE80-\uDEFF]" }, { name: "InUgaritic", astral: "\uD800[\uDF80-\uDF9F]" }, { name: "InUnified_Canadian_Aboriginal_Syllabics", bmp: "\u1400-\u167F" }, { name: "InUnified_Canadian_Aboriginal_Syllabics_Extended", bmp: "\u18B0-\u18FF" }, { name: "InVai", bmp: "\uA500-\uA63F" }, { name: "InVariation_Selectors", bmp: "\uFE00-\uFE0F" }, { name: "InVariation_Selectors_Supplement", astral: "\uDB40[\uDD00-\uDDEF]" }, { name: "InVedic_Extensions", bmp: "\u1CD0-\u1CFF" }, { name: "InVertical_Forms", bmp: "\uFE10-\uFE1F" }, { name: "InWarang_Citi", astral: "\uD806[\uDCA0-\uDCFF]" }, { name: "InYi_Radicals", bmp: "\uA490-\uA4CF" }, { name: "InYi_Syllables", bmp: "\uA000-\uA48F" }, { name: "InYijing_Hexagram_Symbols", bmp: "\u4DC0-\u4DFF" }]);
    };
  }, {}], 5: [function(e15, t10, n10) {
    /*!
    		 * XRegExp Unicode Categories 3.2.0
    		 * <xregexp.com>
    		 * Steven Levithan (c) 2010-2017 MIT License
    		 * Unicode data by Mathias Bynens <mathiasbynens.be>
    		 */
    t10.exports = function(e16) {
      if (!e16.addUnicodeData) throw new ReferenceError("Unicode Base must be loaded before Unicode Categories");
      e16.addUnicodeData([{ name: "C", alias: "Other", isBmpLast: true, bmp: "\0-\x7F-\x9F\xAD\u0378\u0379\u0380-\u0383\u038B\u038D\u03A2\u0530\u0557\u0558\u0560\u0588\u058B\u058C\u0590\u05C8-\u05CF\u05EB-\u05EF\u05F5-\u0605\u061C\u061D\u06DD\u070E\u070F\u074B\u074C\u07B2-\u07BF\u07FB-\u07FF\u082E\u082F\u083F\u085C\u085D\u085F-\u089F\u08B5\u08BE-\u08D3\u08E2\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09FC-\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF2-\u0AF8\u0AFA-\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B55\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BFB-\u0BFF\u0C04\u0C0D\u0C11\u0C29\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5B-\u0C5F\u0C64\u0C65\u0C70-\u0C77\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0D00\u0D04\u0D0D\u0D11\u0D3B\u0D3C\u0D45\u0D49\u0D50-\u0D53\u0D64\u0D65\u0D80\u0D81\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DE5\u0DF0\u0DF1\u0DF5-\u0E00\u0E3B-\u0E3E\u0E5C-\u0E80\u0E83\u0E85\u0E86\u0E89\u0E8B\u0E8C\u0E8E-\u0E93\u0E98\u0EA0\u0EA4\u0EA6\u0EA8\u0EA9\u0EAC\u0EBA\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F48\u0F6D-\u0F70\u0F98\u0FBD\u0FCD\u0FDB-\u0FFF\u10C6\u10C8-\u10CC\u10CE\u10CF\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u137D-\u137F\u139A-\u139F\u13F6\u13F7\u13FE\u13FF\u169D-\u169F\u16F9-\u16FF\u170D\u1715-\u171F\u1737-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17DE\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180E\u180F\u181A-\u181F\u1878-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191F\u192C-\u192F\u193C-\u193F\u1941-\u1943\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19DD\u1A1C\u1A1D\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AAE\u1AAF\u1ABF-\u1AFF\u1B4C-\u1B4F\u1B7D-\u1B7F\u1BF4-\u1BFB\u1C38-\u1C3A\u1C4A-\u1C4C\u1C89-\u1CBF\u1CC8-\u1CCF\u1CF7\u1CFA-\u1CFF\u1DF6-\u1DFA\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FC5\u1FD4\u1FD5\u1FDC\u1FF0\u1FF1\u1FF5\u1FFF\u200B-\u200F\u202A-\u202E\u2060-\u206F\u2072\u2073\u208F\u209D-\u209F\u20BF-\u20CF\u20F1-\u20FF\u218C-\u218F\u23FF\u2427-\u243F\u244B-\u245F\u2B74\u2B75\u2B96\u2B97\u2BBA-\u2BBC\u2BC9\u2BD2-\u2BEB\u2BF0-\u2BFF\u2C2F\u2C5F\u2CF4-\u2CF8\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D71-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E45-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3040\u3097\u3098\u3100-\u3104\u312E-\u3130\u318F\u31BB-\u31BF\u31E4-\u31EF\u321F\u32FF\u4DB6-\u4DBF\u9FD6-\u9FFF\uA48D-\uA48F\uA4C7-\uA4CF\uA62C-\uA63F\uA6F8-\uA6FF\uA7AF\uA7B8-\uA7F6\uA82C-\uA82F\uA83A-\uA83F\uA878-\uA87F\uA8C6-\uA8CD\uA8DA-\uA8DF\uA8FE\uA8FF\uA954-\uA95E\uA97D-\uA97F\uA9CE\uA9DA-\uA9DD\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A\uAA5B\uAAC3-\uAADA\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB66-\uAB6F\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBC2-\uFBD2\uFD40-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFE\uFDFF\uFE1A-\uFE1F\uFE53\uFE67\uFE6C-\uFE6F\uFE75\uFEFD-\uFF00\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFDF\uFFE7\uFFEF-\uFFFB\uFFFE\uFFFF", astral: "\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDCFF\uDD03-\uDD06\uDD34-\uDD36\uDD8F\uDD9C-\uDD9F\uDDA1-\uDDCF\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEFC-\uDEFF\uDF24-\uDF2F\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDFC4-\uDFC7\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6E\uDD70-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1E\uDD3A-\uDD3E\uDD40-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE34-\uDE37\uDE3B-\uDE3E\uDE48-\uDE4F\uDE59-\uDE5F\uDEA0-\uDEBF\uDEE7-\uDEEA\uDEF7-\uDEFF\uDF36-\uDF38\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDF98\uDF9D-\uDFA8\uDFB0-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD00-\uDE5F\uDE7F-\uDFFF]|\uD804[\uDC4E-\uDC51\uDC70-\uDC7E\uDCBD\uDCC2-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD44-\uDD4F\uDD77-\uDD7F\uDDCE\uDDCF\uDDE0\uDDF5-\uDDFF\uDE12\uDE3F-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEAA-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF3B\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC5A\uDC5C\uDC5E-\uDC7F\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDDE-\uDDFF\uDE45-\uDE4F\uDE5A-\uDE5F\uDE6D-\uDE7F\uDEB8-\uDEBF\uDECA-\uDEFF\uDF1A-\uDF1C\uDF2C-\uDF2F\uDF40-\uDFFF]|\uD806[\uDC00-\uDC9F\uDCF3-\uDCFE\uDD00-\uDEBF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC37\uDC46-\uDC4F\uDC6D-\uDC6F\uDC90\uDC91\uDCA8\uDCB7-\uDFFF]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F\uDC75-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80B\uD80E-\uD810\uD812-\uD819\uD823-\uD82B\uD82D\uD82E\uD830-\uD833\uD837\uD839\uD83F\uD874-\uD87D\uD87F-\uDB3F\uDB41-\uDBFF][\uDC00-\uDFFF]|\uD80D[\uDC2F-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6D\uDE70-\uDECF\uDEEE\uDEEF\uDEF6-\uDEFF\uDF46-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDEFF\uDF45-\uDF4F\uDF7F-\uDF8E\uDFA0-\uDFDF\uDFE1-\uDFFF]|\uD821[\uDFED-\uDFFF]|\uD822[\uDEF3-\uDFFF]|\uD82C[\uDC02-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A\uDC9B\uDCA0-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDD73-\uDD7A\uDDE9-\uDDFF\uDE46-\uDEFF\uDF57-\uDF5F\uDF72-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]|\uD836[\uDE8C-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD7-\uDCFF\uDD4B-\uDD4F\uDD5A-\uDD5D\uDD60-\uDFFF]|\uD83B[\uDC00-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDEEF\uDEF2-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD6F\uDDAD-\uDDE5\uDE03-\uDE0F\uDE3C-\uDE3F\uDE49-\uDE4F\uDE52-\uDEFF]|\uD83D[\uDED3-\uDEDF\uDEED-\uDEEF\uDEF7-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDD0F\uDD1F\uDD28-\uDD2F\uDD31\uDD32\uDD3F\uDD4C-\uDD4F\uDD5F-\uDD7F\uDD92-\uDDBF\uDDC1-\uDFFF]|\uD869[\uDED7-\uDEFF]|\uD86D[\uDF35-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uDB40[\uDC00-\uDCFF\uDDF0-\uDFFF]" }, { name: "Cc", alias: "Control", bmp: "\0-\x7F-\x9F" }, { name: "Cf", alias: "Format", bmp: "\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB", astral: "\u{110BD}|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]" }, { name: "Cn", alias: "Unassigned", bmp: "\u0378\u0379\u0380-\u0383\u038B\u038D\u03A2\u0530\u0557\u0558\u0560\u0588\u058B\u058C\u0590\u05C8-\u05CF\u05EB-\u05EF\u05F5-\u05FF\u061D\u070E\u074B\u074C\u07B2-\u07BF\u07FB-\u07FF\u082E\u082F\u083F\u085C\u085D\u085F-\u089F\u08B5\u08BE-\u08D3\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09FC-\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF2-\u0AF8\u0AFA-\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B55\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BFB-\u0BFF\u0C04\u0C0D\u0C11\u0C29\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5B-\u0C5F\u0C64\u0C65\u0C70-\u0C77\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0D00\u0D04\u0D0D\u0D11\u0D3B\u0D3C\u0D45\u0D49\u0D50-\u0D53\u0D64\u0D65\u0D80\u0D81\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DE5\u0DF0\u0DF1\u0DF5-\u0E00\u0E3B-\u0E3E\u0E5C-\u0E80\u0E83\u0E85\u0E86\u0E89\u0E8B\u0E8C\u0E8E-\u0E93\u0E98\u0EA0\u0EA4\u0EA6\u0EA8\u0EA9\u0EAC\u0EBA\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F48\u0F6D-\u0F70\u0F98\u0FBD\u0FCD\u0FDB-\u0FFF\u10C6\u10C8-\u10CC\u10CE\u10CF\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u137D-\u137F\u139A-\u139F\u13F6\u13F7\u13FE\u13FF\u169D-\u169F\u16F9-\u16FF\u170D\u1715-\u171F\u1737-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17DE\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180F\u181A-\u181F\u1878-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191F\u192C-\u192F\u193C-\u193F\u1941-\u1943\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19DD\u1A1C\u1A1D\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AAE\u1AAF\u1ABF-\u1AFF\u1B4C-\u1B4F\u1B7D-\u1B7F\u1BF4-\u1BFB\u1C38-\u1C3A\u1C4A-\u1C4C\u1C89-\u1CBF\u1CC8-\u1CCF\u1CF7\u1CFA-\u1CFF\u1DF6-\u1DFA\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FC5\u1FD4\u1FD5\u1FDC\u1FF0\u1FF1\u1FF5\u1FFF\u2065\u2072\u2073\u208F\u209D-\u209F\u20BF-\u20CF\u20F1-\u20FF\u218C-\u218F\u23FF\u2427-\u243F\u244B-\u245F\u2B74\u2B75\u2B96\u2B97\u2BBA-\u2BBC\u2BC9\u2BD2-\u2BEB\u2BF0-\u2BFF\u2C2F\u2C5F\u2CF4-\u2CF8\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D71-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E45-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3040\u3097\u3098\u3100-\u3104\u312E-\u3130\u318F\u31BB-\u31BF\u31E4-\u31EF\u321F\u32FF\u4DB6-\u4DBF\u9FD6-\u9FFF\uA48D-\uA48F\uA4C7-\uA4CF\uA62C-\uA63F\uA6F8-\uA6FF\uA7AF\uA7B8-\uA7F6\uA82C-\uA82F\uA83A-\uA83F\uA878-\uA87F\uA8C6-\uA8CD\uA8DA-\uA8DF\uA8FE\uA8FF\uA954-\uA95E\uA97D-\uA97F\uA9CE\uA9DA-\uA9DD\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A\uAA5B\uAAC3-\uAADA\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB66-\uAB6F\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uD7FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBC2-\uFBD2\uFD40-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFE\uFDFF\uFE1A-\uFE1F\uFE53\uFE67\uFE6C-\uFE6F\uFE75\uFEFD\uFEFE\uFF00\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFDF\uFFE7\uFFEF-\uFFF8\uFFFE\uFFFF", astral: "\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDCFF\uDD03-\uDD06\uDD34-\uDD36\uDD8F\uDD9C-\uDD9F\uDDA1-\uDDCF\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEFC-\uDEFF\uDF24-\uDF2F\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDFC4-\uDFC7\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6E\uDD70-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1E\uDD3A-\uDD3E\uDD40-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE34-\uDE37\uDE3B-\uDE3E\uDE48-\uDE4F\uDE59-\uDE5F\uDEA0-\uDEBF\uDEE7-\uDEEA\uDEF7-\uDEFF\uDF36-\uDF38\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDF98\uDF9D-\uDFA8\uDFB0-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD00-\uDE5F\uDE7F-\uDFFF]|\uD804[\uDC4E-\uDC51\uDC70-\uDC7E\uDCC2-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD44-\uDD4F\uDD77-\uDD7F\uDDCE\uDDCF\uDDE0\uDDF5-\uDDFF\uDE12\uDE3F-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEAA-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF3B\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC5A\uDC5C\uDC5E-\uDC7F\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDDE-\uDDFF\uDE45-\uDE4F\uDE5A-\uDE5F\uDE6D-\uDE7F\uDEB8-\uDEBF\uDECA-\uDEFF\uDF1A-\uDF1C\uDF2C-\uDF2F\uDF40-\uDFFF]|\uD806[\uDC00-\uDC9F\uDCF3-\uDCFE\uDD00-\uDEBF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC37\uDC46-\uDC4F\uDC6D-\uDC6F\uDC90\uDC91\uDCA8\uDCB7-\uDFFF]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F\uDC75-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80B\uD80E-\uD810\uD812-\uD819\uD823-\uD82B\uD82D\uD82E\uD830-\uD833\uD837\uD839\uD83F\uD874-\uD87D\uD87F-\uDB3F\uDB41-\uDB7F][\uDC00-\uDFFF]|\uD80D[\uDC2F-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6D\uDE70-\uDECF\uDEEE\uDEEF\uDEF6-\uDEFF\uDF46-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDEFF\uDF45-\uDF4F\uDF7F-\uDF8E\uDFA0-\uDFDF\uDFE1-\uDFFF]|\uD821[\uDFED-\uDFFF]|\uD822[\uDEF3-\uDFFF]|\uD82C[\uDC02-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A\uDC9B\uDCA4-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDDE9-\uDDFF\uDE46-\uDEFF\uDF57-\uDF5F\uDF72-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]|\uD836[\uDE8C-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD7-\uDCFF\uDD4B-\uDD4F\uDD5A-\uDD5D\uDD60-\uDFFF]|\uD83B[\uDC00-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDEEF\uDEF2-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD6F\uDDAD-\uDDE5\uDE03-\uDE0F\uDE3C-\uDE3F\uDE49-\uDE4F\uDE52-\uDEFF]|\uD83D[\uDED3-\uDEDF\uDEED-\uDEEF\uDEF7-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDD0F\uDD1F\uDD28-\uDD2F\uDD31\uDD32\uDD3F\uDD4C-\uDD4F\uDD5F-\uDD7F\uDD92-\uDDBF\uDDC1-\uDFFF]|\uD869[\uDED7-\uDEFF]|\uD86D[\uDF35-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uDB40[\uDC00\uDC02-\uDC1F\uDC80-\uDCFF\uDDF0-\uDFFF]|[\uDBBF\uDBFF][\uDFFE\uDFFF]" }, { name: "Co", alias: "Private_Use", bmp: "\uE000-\uF8FF", astral: "[\uDB80-\uDBBE\uDBC0-\uDBFE][\uDC00-\uDFFF]|[\uDBBF\uDBFF][\uDC00-\uDFFD]" }, { name: "Cs", alias: "Surrogate", bmp: "\uD800-\uDFFF" }, { name: "L", alias: "Letter", bmp: "A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC", astral: "\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]" }, { name: "Ll", alias: "Lowercase_Letter", bmp: "a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1C80-\u1C88\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A", astral: "\uD801[\uDC28-\uDC4F\uDCD8-\uDCFB]|\uD803[\uDCC0-\uDCF2]|\uD806[\uDCC0-\uDCDF]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD83A[\uDD22-\uDD43]" }, { name: "Lm", alias: "Modifier_Letter", bmp: "\u02B0-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0374\u037A\u0559\u0640\u06E5\u06E6\u07F4\u07F5\u07FA\u081A\u0824\u0828\u0971\u0E46\u0EC6\u10FC\u17D7\u1843\u1AA7\u1C78-\u1C7D\u1D2C-\u1D6A\u1D78\u1D9B-\u1DBF\u2071\u207F\u2090-\u209C\u2C7C\u2C7D\u2D6F\u2E2F\u3005\u3031-\u3035\u303B\u309D\u309E\u30FC-\u30FE\uA015\uA4F8-\uA4FD\uA60C\uA67F\uA69C\uA69D\uA717-\uA71F\uA770\uA788\uA7F8\uA7F9\uA9CF\uA9E6\uAA70\uAADD\uAAF3\uAAF4\uAB5C-\uAB5F\uFF70\uFF9E\uFF9F", astral: "\uD81A[\uDF40-\uDF43]|\uD81B[\uDF93-\uDF9F\uDFE0]" }, { name: "Lo", alias: "Other_Letter", bmp: "\xAA\xBA\u01BB\u01C0-\u01C3\u0294\u05D0-\u05EA\u05F0-\u05F2\u0620-\u063F\u0641-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u0800-\u0815\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0972-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E45\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10D0-\u10FA\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17DC\u1820-\u1842\u1844-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C77\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u2135-\u2138\u2D30-\u2D67\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3006\u303C\u3041-\u3096\u309F\u30A1-\u30FA\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA014\uA016-\uA48C\uA4D0-\uA4F7\uA500-\uA60B\uA610-\uA61F\uA62A\uA62B\uA66E\uA6A0-\uA6E5\uA78F\uA7F7\uA7FB-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9E0-\uA9E4\uA9E7-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA6F\uAA71-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB\uAADC\uAAE0-\uAAEA\uAAF2\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF66-\uFF6F\uFF71-\uFF9D\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC", astral: "\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC50-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD83A[\uDC00-\uDCC4]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]" }, { name: "Lt", alias: "Titlecase_Letter", bmp: "\u01C5\u01C8\u01CB\u01F2\u1F88-\u1F8F\u1F98-\u1F9F\u1FA8-\u1FAF\u1FBC\u1FCC\u1FFC" }, { name: "Lu", alias: "Uppercase_Letter", bmp: "A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AE\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A", astral: "\uD801[\uDC00-\uDC27\uDCB0-\uDCD3]|\uD803[\uDC80-\uDCB2]|\uD806[\uDCA0-\uDCBF]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]|\uD83A[\uDD00-\uDD21]" }, { name: "M", alias: "Mark", bmp: "\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D4-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C03\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D01-\u0D03\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ABE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFB-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F", astral: "\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD804[\uDC00-\uDC02\uDC38-\uDC46\uDC7F-\uDC82\uDCB0-\uDCBA\uDD00-\uDD02\uDD27-\uDD34\uDD73\uDD80-\uDD82\uDDB3-\uDDC0\uDDCA-\uDDCC\uDE2C-\uDE37\uDE3E\uDEDF-\uDEEA\uDF00-\uDF03\uDF3C\uDF3E-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC35-\uDC46\uDCB0-\uDCC3\uDDAF-\uDDB5\uDDB8-\uDDC0\uDDDC\uDDDD\uDE30-\uDE40\uDEAB-\uDEB7\uDF1D-\uDF2B]|\uD807[\uDC2F-\uDC36\uDC38-\uDC3F\uDC92-\uDCA7\uDCA9-\uDCB6]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF51-\uDF7E\uDF8F-\uDF92]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF]" }, { name: "Mc", alias: "Spacing_Mark", bmp: "\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BE-\u09C0\u09C7\u09C8\u09CB\u09CC\u09D7\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B3E\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0B57\u0BBE\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD7\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0-\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0CD5\u0CD6\u0D02\u0D03\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D57\u0D82\u0D83\u0DCF-\u0DD1\u0DD8-\u0DDF\u0DF2\u0DF3\u0F3E\u0F3F\u0F7F\u102B\u102C\u1031\u1038\u103B\u103C\u1056\u1057\u1062-\u1064\u1067-\u106D\u1083\u1084\u1087-\u108C\u108F\u109A-\u109C\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A61\u1A63\u1A64\u1A6D-\u1A72\u1B04\u1B35\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF2\u1CF3\u302E\u302F\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BD-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAA7B\uAA7D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC", astral: "\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3E\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB0-\uDCB2\uDCB9\uDCBB-\uDCBE\uDCC1\uDDAF-\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF20\uDF21\uDF26]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4]|\uD81B[\uDF51-\uDF7E]|\uD834[\uDD65\uDD66\uDD6D-\uDD72]" }, { name: "Me", alias: "Enclosing_Mark", bmp: "\u0488\u0489\u1ABE\u20DD-\u20E0\u20E2-\u20E4\uA670-\uA672" }, { name: "Mn", alias: "Nonspacing_Mark", bmp: "\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D4-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D01\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F", astral: "\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDCA-\uDDCC\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3C\uDF40\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDCB3-\uDCB8\uDCBA\uDCBF\uDCC0\uDCC2\uDCC3\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF8F-\uDF92]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF]" }, { name: "N", alias: "Number", bmp: "0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19", astral: "\uD800[\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23\uDF41\uDF4A\uDFD1-\uDFD5]|\uD801[\uDCA0-\uDCA9]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE47\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDCFA-\uDCFF\uDE60-\uDE7E]|\uD804[\uDC52-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDDE1-\uDDF4\uDEF0-\uDEF9]|\uD805[\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF3B]|\uD806[\uDCE0-\uDCF2]|\uD807[\uDC50-\uDC6C]|\uD809[\uDC00-\uDC6E]|\uD81A[\uDE60-\uDE69\uDF50-\uDF59\uDF5B-\uDF61]|\uD834[\uDF60-\uDF71]|\uD835[\uDFCE-\uDFFF]|\uD83A[\uDCC7-\uDCCF\uDD50-\uDD59]|\uD83C[\uDD00-\uDD0C]" }, { name: "Nd", alias: "Decimal_Number", bmp: "0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19", astral: "\uD801[\uDCA0-\uDCA9]|\uD804[\uDC66-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDEF0-\uDEF9]|\uD805[\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF39]|\uD806[\uDCE0-\uDCE9]|\uD807[\uDC50-\uDC59]|\uD81A[\uDE60-\uDE69\uDF50-\uDF59]|\uD835[\uDFCE-\uDFFF]|\uD83A[\uDD50-\uDD59]" }, { name: "Nl", alias: "Letter_Number", bmp: "\u16EE-\u16F0\u2160-\u2182\u2185-\u2188\u3007\u3021-\u3029\u3038-\u303A\uA6E6-\uA6EF", astral: "\uD800[\uDD40-\uDD74\uDF41\uDF4A\uDFD1-\uDFD5]|\uD809[\uDC00-\uDC6E]" }, { name: "No", alias: "Other_Number", bmp: "\xB2\xB3\xB9\xBC-\xBE\u09F4-\u09F9\u0B72-\u0B77\u0BF0-\u0BF2\u0C78-\u0C7E\u0D58-\u0D5E\u0D70-\u0D78\u0F2A-\u0F33\u1369-\u137C\u17F0-\u17F9\u19DA\u2070\u2074-\u2079\u2080-\u2089\u2150-\u215F\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA830-\uA835", astral: "\uD800[\uDD07-\uDD33\uDD75-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE47\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDCFA-\uDCFF\uDE60-\uDE7E]|\uD804[\uDC52-\uDC65\uDDE1-\uDDF4]|\uD805[\uDF3A\uDF3B]|\uD806[\uDCEA-\uDCF2]|\uD807[\uDC5A-\uDC6C]|\uD81A[\uDF5B-\uDF61]|\uD834[\uDF60-\uDF71]|\uD83A[\uDCC7-\uDCCF]|\uD83C[\uDD00-\uDD0C]" }, { name: "P", alias: "Punctuation", bmp: "!-#%-\\x2A,-/:;\\x3F@\\x5B-\\x5D_\\x7B}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E44\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65", astral: "\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\u{1056F}|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\u{1BC9F}|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]" }, { name: "Pc", alias: "Connector_Punctuation", bmp: "_\u203F\u2040\u2054\uFE33\uFE34\uFE4D-\uFE4F\uFF3F" }, { name: "Pd", alias: "Dash_Punctuation", bmp: "\\x2D\u058A\u05BE\u1400\u1806\u2010-\u2015\u2E17\u2E1A\u2E3A\u2E3B\u2E40\u301C\u3030\u30A0\uFE31\uFE32\uFE58\uFE63\uFF0D" }, { name: "Pe", alias: "Close_Punctuation", bmp: "\\x29\\x5D}\u0F3B\u0F3D\u169C\u2046\u207E\u208E\u2309\u230B\u232A\u2769\u276B\u276D\u276F\u2771\u2773\u2775\u27C6\u27E7\u27E9\u27EB\u27ED\u27EF\u2984\u2986\u2988\u298A\u298C\u298E\u2990\u2992\u2994\u2996\u2998\u29D9\u29DB\u29FD\u2E23\u2E25\u2E27\u2E29\u3009\u300B\u300D\u300F\u3011\u3015\u3017\u3019\u301B\u301E\u301F\uFD3E\uFE18\uFE36\uFE38\uFE3A\uFE3C\uFE3E\uFE40\uFE42\uFE44\uFE48\uFE5A\uFE5C\uFE5E\uFF09\uFF3D\uFF5D\uFF60\uFF63" }, { name: "Pf", alias: "Final_Punctuation", bmp: "\xBB\u2019\u201D\u203A\u2E03\u2E05\u2E0A\u2E0D\u2E1D\u2E21" }, { name: "Pi", alias: "Initial_Punctuation", bmp: "\xAB\u2018\u201B\u201C\u201F\u2039\u2E02\u2E04\u2E09\u2E0C\u2E1C\u2E20" }, { name: "Po", alias: "Other_Punctuation", bmp: "!-#%-'\\x2A,\\x2E/:;\\x3F@\\x5C\xA1\xA7\xB6\xB7\xBF\u037E\u0387\u055A-\u055F\u0589\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u166D\u166E\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u1805\u1807-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2016\u2017\u2020-\u2027\u2030-\u2038\u203B-\u203E\u2041-\u2043\u2047-\u2051\u2053\u2055-\u205E\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00\u2E01\u2E06-\u2E08\u2E0B\u2E0E-\u2E16\u2E18\u2E19\u2E1B\u2E1E\u2E1F\u2E2A-\u2E2E\u2E30-\u2E39\u2E3C-\u2E3F\u2E41\u2E43\u2E44\u3001-\u3003\u303D\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFE10-\uFE16\uFE19\uFE30\uFE45\uFE46\uFE49-\uFE4C\uFE50-\uFE52\uFE54-\uFE57\uFE5F-\uFE61\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF07\uFF0A\uFF0C\uFF0E\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3C\uFF61\uFF64\uFF65", astral: "\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\u{1056F}|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\u{1BC9F}|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]" }, { name: "Ps", alias: "Open_Punctuation", bmp: "\\x28\\x5B\\x7B\u0F3A\u0F3C\u169B\u201A\u201E\u2045\u207D\u208D\u2308\u230A\u2329\u2768\u276A\u276C\u276E\u2770\u2772\u2774\u27C5\u27E6\u27E8\u27EA\u27EC\u27EE\u2983\u2985\u2987\u2989\u298B\u298D\u298F\u2991\u2993\u2995\u2997\u29D8\u29DA\u29FC\u2E22\u2E24\u2E26\u2E28\u2E42\u3008\u300A\u300C\u300E\u3010\u3014\u3016\u3018\u301A\u301D\uFD3F\uFE17\uFE35\uFE37\uFE39\uFE3B\uFE3D\uFE3F\uFE41\uFE43\uFE47\uFE59\uFE5B\uFE5D\uFF08\uFF3B\uFF5B\uFF5F\uFF62" }, { name: "S", alias: "Symbol", bmp: "\\x24\\x2B<->\\x5E`\\x7C~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20BE\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u23FE\u2400-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B98-\u2BB9\u2BBD-\u2BC8\u2BCA-\u2BD1\u2BEC-\u2BEF\u2CE5-\u2CEA\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u32FE\u3300-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uFB29\uFBB2-\uFBC1\uFDFC\uFDFD\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD", astral: "\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9B\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\u{1173F}|\uD81A[\uDF3C-\uDF3F\uDF45]|\u{1BC9C}|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD83B[\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD10-\uDD2E\uDD30-\uDD6B\uDD70-\uDDAC\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED2\uDEE0-\uDEEC\uDEF0-\uDEF6\uDF00-\uDF73\uDF80-\uDFD4]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDD10-\uDD1E\uDD20-\uDD27\uDD30\uDD33-\uDD3E\uDD40-\uDD4B\uDD50-\uDD5E\uDD80-\uDD91\uDDC0]" }, { name: "Sc", alias: "Currency_Symbol", bmp: "\\x24\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20BE\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6" }, { name: "Sk", alias: "Modifier_Symbol", bmp: "\\x5E`\xA8\xAF\xB4\xB8\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u309B\u309C\uA700-\uA716\uA720\uA721\uA789\uA78A\uAB5B\uFBB2-\uFBC1\uFF3E\uFF40\uFFE3", astral: "\uD83C[\uDFFB-\uDFFF]" }, { name: "Sm", alias: "Math_Symbol", bmp: "\\x2B<->\\x7C~\xAC\xB1\xD7\xF7\u03F6\u0606-\u0608\u2044\u2052\u207A-\u207C\u208A-\u208C\u2118\u2140-\u2144\u214B\u2190-\u2194\u219A\u219B\u21A0\u21A3\u21A6\u21AE\u21CE\u21CF\u21D2\u21D4\u21F4-\u22FF\u2320\u2321\u237C\u239B-\u23B3\u23DC-\u23E1\u25B7\u25C1\u25F8-\u25FF\u266F\u27C0-\u27C4\u27C7-\u27E5\u27F0-\u27FF\u2900-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2AFF\u2B30-\u2B44\u2B47-\u2B4C\uFB29\uFE62\uFE64-\uFE66\uFF0B\uFF1C-\uFF1E\uFF5C\uFF5E\uFFE2\uFFE9-\uFFEC", astral: "\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD83B[\uDEF0\uDEF1]" }, { name: "So", alias: "Other_Symbol", bmp: "\xA6\xA9\xAE\xB0\u0482\u058D\u058E\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u09FA\u0B70\u0BF3-\u0BF8\u0BFA\u0C7F\u0D4F\u0D79\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116\u2117\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u214A\u214C\u214D\u214F\u218A\u218B\u2195-\u2199\u219C-\u219F\u21A1\u21A2\u21A4\u21A5\u21A7-\u21AD\u21AF-\u21CD\u21D0\u21D1\u21D3\u21D5-\u21F3\u2300-\u2307\u230C-\u231F\u2322-\u2328\u232B-\u237B\u237D-\u239A\u23B4-\u23DB\u23E2-\u23FE\u2400-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u25B6\u25B8-\u25C0\u25C2-\u25F7\u2600-\u266E\u2670-\u2767\u2794-\u27BF\u2800-\u28FF\u2B00-\u2B2F\u2B45\u2B46\u2B4D-\u2B73\u2B76-\u2B95\u2B98-\u2BB9\u2BBD-\u2BC8\u2BCA-\u2BD1\u2BEC-\u2BEF\u2CE5-\u2CEA\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u32FE\u3300-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA828-\uA82B\uA836\uA837\uA839\uAA77-\uAA79\uFDFD\uFFE4\uFFE8\uFFED\uFFEE\uFFFC\uFFFD", astral: "\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9B\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\u{1173F}|\uD81A[\uDF3C-\uDF3F\uDF45]|\u{1BC9C}|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD10-\uDD2E\uDD30-\uDD6B\uDD70-\uDDAC\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDF00-\uDFFA]|\uD83D[\uDC00-\uDED2\uDEE0-\uDEEC\uDEF0-\uDEF6\uDF00-\uDF73\uDF80-\uDFD4]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDD10-\uDD1E\uDD20-\uDD27\uDD30\uDD33-\uDD3E\uDD40-\uDD4B\uDD50-\uDD5E\uDD80-\uDD91\uDDC0]" }, { name: "Z", alias: "Separator", bmp: " \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000" }, { name: "Zl", alias: "Line_Separator", bmp: "\u2028" }, { name: "Zp", alias: "Paragraph_Separator", bmp: "\u2029" }, { name: "Zs", alias: "Space_Separator", bmp: " \xA0\u1680\u2000-\u200A\u202F\u205F\u3000" }]);
    };
  }, {}], 6: [function(e15, t10, n10) {
    /*!
    		 * XRegExp Unicode Properties 3.2.0
    		 * <xregexp.com>
    		 * Steven Levithan (c) 2012-2017 MIT License
    		 * Unicode data by Mathias Bynens <mathiasbynens.be>
    		 */
    t10.exports = function(e16) {
      if (!e16.addUnicodeData) throw new ReferenceError("Unicode Base must be loaded before Unicode Properties");
      var t11 = [{ name: "ASCII", bmp: "\0-\x7F" }, { name: "Alphabetic", bmp: "A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0345\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05B0-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0657\u0659-\u065F\u066E-\u06D3\u06D5-\u06DC\u06E1-\u06E8\u06ED-\u06EF\u06FA-\u06FC\u06FF\u0710-\u073F\u074D-\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0817\u081A-\u082C\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08DF\u08E3-\u08E9\u08F0-\u093B\u093D-\u094C\u094E-\u0950\u0955-\u0963\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD-\u09C4\u09C7\u09C8\u09CB\u09CC\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09F0\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3E-\u0A42\u0A47\u0A48\u0A4B\u0A4C\u0A51\u0A59-\u0A5C\u0A5E\u0A70-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD-\u0AC5\u0AC7-\u0AC9\u0ACB\u0ACC\u0AD0\u0AE0-\u0AE3\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D-\u0B44\u0B47\u0B48\u0B4B\u0B4C\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4C\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCC\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E46\u0E4D\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0ECD\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F71-\u0F81\u0F88-\u0F97\u0F99-\u0FBC\u1000-\u1036\u1038\u103B-\u103F\u1050-\u1062\u1065-\u1068\u106E-\u1086\u108E\u109C\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1713\u1720-\u1733\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17B3\u17B6-\u17C8\u17D7\u17DC\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u1938\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A1B\u1A20-\u1A5E\u1A61-\u1A74\u1AA7\u1B00-\u1B33\u1B35-\u1B43\u1B45-\u1B4B\u1B80-\u1BA9\u1BAC-\u1BAF\u1BBA-\u1BE5\u1BE7-\u1BF1\u1C00-\u1C35\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1D00-\u1DBF\u1DE7-\u1DF4\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u24B6-\u24E9\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA674-\uA67B\uA67F-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA827\uA840-\uA873\uA880-\uA8C3\uA8C5\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA92A\uA930-\uA952\uA960-\uA97C\uA980-\uA9B2\uA9B4-\uA9BF\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA60-\uAA76\uAA7A\uAA7E-\uAABE\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF5\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC", astral: "\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC45\uDC82-\uDCB8\uDCD0-\uDCE8\uDD00-\uDD32\uDD50-\uDD72\uDD76\uDD80-\uDDBF\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE34\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEE8\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D-\uDF44\uDF47\uDF48\uDF4B\uDF4C\uDF50\uDF57\uDF5D-\uDF63]|\uD805[\uDC00-\uDC41\uDC43-\uDC45\uDC47-\uDC4A\uDC80-\uDCC1\uDCC4\uDCC5\uDCC7\uDD80-\uDDB5\uDDB8-\uDDBE\uDDD8-\uDDDD\uDE00-\uDE3E\uDE40\uDE44\uDE80-\uDEB5\uDF00-\uDF19\uDF1D-\uDF2A]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC3E\uDC40\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF36\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9E]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD47]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD30-\uDD49\uDD50-\uDD69\uDD70-\uDD89]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]" }, { name: "Any", isBmpLast: true, bmp: "\0-\uFFFF", astral: "[\uD800-\uDBFF][\uDC00-\uDFFF]" }, { name: "Default_Ignorable_Code_Point", bmp: "\xAD\u034F\u061C\u115F\u1160\u17B4\u17B5\u180B-\u180E\u200B-\u200F\u202A-\u202E\u2060-\u206F\u3164\uFE00-\uFE0F\uFEFF\uFFA0\uFFF0-\uFFF8", astral: "\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|[\uDB40-\uDB43][\uDC00-\uDFFF]" }, { name: "Lowercase", bmp: "a-z\xAA\xB5\xBA\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02B8\u02C0\u02C1\u02E0-\u02E4\u0345\u0371\u0373\u0377\u037A-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1C80-\u1C88\u1D00-\u1DBF\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u2071\u207F\u2090-\u209C\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2170-\u217F\u2184\u24D0-\u24E9\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7D\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B-\uA69D\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7F8-\uA7FA\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A", astral: "\uD801[\uDC28-\uDC4F\uDCD8-\uDCFB]|\uD803[\uDCC0-\uDCF2]|\uD806[\uDCC0-\uDCDF]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD83A[\uDD22-\uDD43]" }, { name: "Noncharacter_Code_Point", bmp: "\uFDD0-\uFDEF\uFFFE\uFFFF", astral: "[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]" }, { name: "Uppercase", bmp: "A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2160-\u216F\u2183\u24B6-\u24CF\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AE\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A", astral: "\uD801[\uDC00-\uDC27\uDCB0-\uDCD3]|\uD803[\uDC80-\uDCB2]|\uD806[\uDCA0-\uDCBF]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]|\uD83A[\uDD00-\uDD21]|\uD83C[\uDD30-\uDD49\uDD50-\uDD69\uDD70-\uDD89]" }, { name: "White_Space", bmp: "	-\r \x85\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000" }];
      t11.push({ name: "Assigned", inverseOf: "Cn" }), e16.addUnicodeData(t11);
    };
  }, {}], 7: [function(e15, t10, n10) {
    /*!
    		 * XRegExp Unicode Scripts 3.2.0
    		 * <xregexp.com>
    		 * Steven Levithan (c) 2010-2017 MIT License
    		 * Unicode data by Mathias Bynens <mathiasbynens.be>
    		 */
    t10.exports = function(e16) {
      if (!e16.addUnicodeData) throw new ReferenceError("Unicode Base must be loaded before Unicode Scripts");
      e16.addUnicodeData([{ name: "Adlam", astral: "\uD83A[\uDD00-\uDD4A\uDD50-\uDD59\uDD5E\uDD5F]" }, { name: "Ahom", astral: "\uD805[\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF3F]" }, { name: "Anatolian_Hieroglyphs", astral: "\uD811[\uDC00-\uDE46]" }, { name: "Arabic", bmp: "\u0600-\u0604\u0606-\u060B\u060D-\u061A\u061E\u0620-\u063F\u0641-\u064A\u0656-\u066F\u0671-\u06DC\u06DE-\u06FF\u0750-\u077F\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u08FF\uFB50-\uFBC1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFD\uFE70-\uFE74\uFE76-\uFEFC", astral: "\uD803[\uDE60-\uDE7E]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB\uDEF0\uDEF1]" }, { name: "Armenian", bmp: "\u0531-\u0556\u0559-\u055F\u0561-\u0587\u058A\u058D-\u058F\uFB13-\uFB17" }, { name: "Avestan", astral: "\uD802[\uDF00-\uDF35\uDF39-\uDF3F]" }, { name: "Balinese", bmp: "\u1B00-\u1B4B\u1B50-\u1B7C" }, { name: "Bamum", bmp: "\uA6A0-\uA6F7", astral: "\uD81A[\uDC00-\uDE38]" }, { name: "Bassa_Vah", astral: "\uD81A[\uDED0-\uDEED\uDEF0-\uDEF5]" }, { name: "Batak", bmp: "\u1BC0-\u1BF3\u1BFC-\u1BFF" }, { name: "Bengali", bmp: "\u0980-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09FB" }, { name: "Bhaiksuki", astral: "\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC45\uDC50-\uDC6C]" }, { name: "Bopomofo", bmp: "\u02EA\u02EB\u3105-\u312D\u31A0-\u31BA" }, { name: "Brahmi", astral: "\uD804[\uDC00-\uDC4D\uDC52-\uDC6F\uDC7F]" }, { name: "Braille", bmp: "\u2800-\u28FF" }, { name: "Buginese", bmp: "\u1A00-\u1A1B\u1A1E\u1A1F" }, { name: "Buhid", bmp: "\u1740-\u1753" }, { name: "Canadian_Aboriginal", bmp: "\u1400-\u167F\u18B0-\u18F5" }, { name: "Carian", astral: "\uD800[\uDEA0-\uDED0]" }, { name: "Caucasian_Albanian", astral: "\uD801[\uDD30-\uDD63\uDD6F]" }, { name: "Chakma", astral: "\uD804[\uDD00-\uDD34\uDD36-\uDD43]" }, { name: "Cham", bmp: "\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F" }, { name: "Cherokee", bmp: "\u13A0-\u13F5\u13F8-\u13FD\uAB70-\uABBF" }, { name: "Common", bmp: "\0-@\\x5B-`\\x7B-\xA9\xAB-\xB9\xBB-\xBF\xD7\xF7\u02B9-\u02DF\u02E5-\u02E9\u02EC-\u02FF\u0374\u037E\u0385\u0387\u0589\u0605\u060C\u061B\u061C\u061F\u0640\u06DD\u08E2\u0964\u0965\u0E3F\u0FD5-\u0FD8\u10FB\u16EB-\u16ED\u1735\u1736\u1802\u1803\u1805\u1CD3\u1CE1\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u2000-\u200B\u200E-\u2064\u2066-\u2070\u2074-\u207E\u2080-\u208E\u20A0-\u20BE\u2100-\u2125\u2127-\u2129\u212C-\u2131\u2133-\u214D\u214F-\u215F\u2189-\u218B\u2190-\u23FE\u2400-\u2426\u2440-\u244A\u2460-\u27FF\u2900-\u2B73\u2B76-\u2B95\u2B98-\u2BB9\u2BBD-\u2BC8\u2BCA-\u2BD1\u2BEC-\u2BEF\u2E00-\u2E44\u2FF0-\u2FFB\u3000-\u3004\u3006\u3008-\u3020\u3030-\u3037\u303C-\u303F\u309B\u309C\u30A0\u30FB\u30FC\u3190-\u319F\u31C0-\u31E3\u3220-\u325F\u327F-\u32CF\u3358-\u33FF\u4DC0-\u4DFF\uA700-\uA721\uA788-\uA78A\uA830-\uA839\uA92E\uA9CF\uAB5B\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFEFF\uFF01-\uFF20\uFF3B-\uFF40\uFF5B-\uFF65\uFF70\uFF9E\uFF9F\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFF9-\uFFFD", astral: "\uD800[\uDD00-\uDD02\uDD07-\uDD33\uDD37-\uDD3F\uDD90-\uDD9B\uDDD0-\uDDFC\uDEE1-\uDEFB]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD66\uDD6A-\uDD7A\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDF00-\uDF56\uDF60-\uDF71]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDFCB\uDFCE-\uDFFF]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD00-\uDD0C\uDD10-\uDD2E\uDD30-\uDD6B\uDD70-\uDDAC\uDDE6-\uDDFF\uDE01\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED2\uDEE0-\uDEEC\uDEF0-\uDEF6\uDF00-\uDF73\uDF80-\uDFD4]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDD10-\uDD1E\uDD20-\uDD27\uDD30\uDD33-\uDD3E\uDD40-\uDD4B\uDD50-\uDD5E\uDD80-\uDD91\uDDC0]|\uDB40[\uDC01\uDC20-\uDC7F]" }, { name: "Coptic", bmp: "\u03E2-\u03EF\u2C80-\u2CF3\u2CF9-\u2CFF" }, { name: "Cuneiform", astral: "\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC70-\uDC74\uDC80-\uDD43]" }, { name: "Cypriot", astral: "\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F]" }, { name: "Cyrillic", bmp: "\u0400-\u0484\u0487-\u052F\u1C80-\u1C88\u1D2B\u1D78\u2DE0-\u2DFF\uA640-\uA69F\uFE2E\uFE2F" }, { name: "Deseret", astral: "\uD801[\uDC00-\uDC4F]" }, { name: "Devanagari", bmp: "\u0900-\u0950\u0953-\u0963\u0966-\u097F\uA8E0-\uA8FD" }, { name: "Duployan", astral: "\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9C-\uDC9F]" }, { name: "Egyptian_Hieroglyphs", astral: "\uD80C[\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]" }, { name: "Elbasan", astral: "\uD801[\uDD00-\uDD27]" }, { name: "Ethiopic", bmp: "\u1200-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u137C\u1380-\u1399\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E" }, { name: "Georgian", bmp: "\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u10FF\u2D00-\u2D25\u2D27\u2D2D" }, { name: "Glagolitic", bmp: "\u2C00-\u2C2E\u2C30-\u2C5E", astral: "\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]" }, { name: "Gothic", astral: "\uD800[\uDF30-\uDF4A]" }, { name: "Grantha", astral: "\uD804[\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]" }, { name: "Greek", bmp: "\u0370-\u0373\u0375-\u0377\u037A-\u037D\u037F\u0384\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03E1\u03F0-\u03FF\u1D26-\u1D2A\u1D5D-\u1D61\u1D66-\u1D6A\u1DBF\u1F00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FC4\u1FC6-\u1FD3\u1FD6-\u1FDB\u1FDD-\u1FEF\u1FF2-\u1FF4\u1FF6-\u1FFE\u2126\uAB65", astral: "\uD800[\uDD40-\uDD8E\uDDA0]|\uD834[\uDE00-\uDE45]" }, { name: "Gujarati", bmp: "\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AF1\u0AF9" }, { name: "Gurmukhi", bmp: "\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75" }, { name: "Han", bmp: "\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FD5\uF900-\uFA6D\uFA70-\uFAD9", astral: "[\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]" }, { name: "Hangul", bmp: "\u1100-\u11FF\u302E\u302F\u3131-\u318E\u3200-\u321E\u3260-\u327E\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC" }, { name: "Hanunoo", bmp: "\u1720-\u1734" }, { name: "Hatran", astral: "\uD802[\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDCFF]" }, { name: "Hebrew", bmp: "\u0591-\u05C7\u05D0-\u05EA\u05F0-\u05F4\uFB1D-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFB4F" }, { name: "Hiragana", bmp: "\u3041-\u3096\u309D-\u309F", astral: "\u{1B001}|\u{1F200}" }, { name: "Imperial_Aramaic", astral: "\uD802[\uDC40-\uDC55\uDC57-\uDC5F]" }, { name: "Inherited", bmp: "\u0300-\u036F\u0485\u0486\u064B-\u0655\u0670\u0951\u0952\u1AB0-\u1ABE\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFB-\u1DFF\u200C\u200D\u20D0-\u20F0\u302A-\u302D\u3099\u309A\uFE00-\uFE0F\uFE20-\uFE2D", astral: "\uD800[\uDDFD\uDEE0]|\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD]|\uDB40[\uDD00-\uDDEF]" }, { name: "Inscriptional_Pahlavi", astral: "\uD802[\uDF60-\uDF72\uDF78-\uDF7F]" }, { name: "Inscriptional_Parthian", astral: "\uD802[\uDF40-\uDF55\uDF58-\uDF5F]" }, { name: "Javanese", bmp: "\uA980-\uA9CD\uA9D0-\uA9D9\uA9DE\uA9DF" }, { name: "Kaithi", astral: "\uD804[\uDC80-\uDCC1]" }, { name: "Kannada", bmp: "\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2" }, { name: "Katakana", bmp: "\u30A1-\u30FA\u30FD-\u30FF\u31F0-\u31FF\u32D0-\u32FE\u3300-\u3357\uFF66-\uFF6F\uFF71-\uFF9D", astral: "\u{1B000}" }, { name: "Kayah_Li", bmp: "\uA900-\uA92D\uA92F" }, { name: "Kharoshthi", astral: "\uD802[\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F-\uDE47\uDE50-\uDE58]" }, { name: "Khmer", bmp: "\u1780-\u17DD\u17E0-\u17E9\u17F0-\u17F9\u19E0-\u19FF" }, { name: "Khojki", astral: "\uD804[\uDE00-\uDE11\uDE13-\uDE3E]" }, { name: "Khudawadi", astral: "\uD804[\uDEB0-\uDEEA\uDEF0-\uDEF9]" }, { name: "Lao", bmp: "\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF" }, { name: "Latin", bmp: "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A" }, { name: "Lepcha", bmp: "\u1C00-\u1C37\u1C3B-\u1C49\u1C4D-\u1C4F" }, { name: "Limbu", bmp: "\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1940\u1944-\u194F" }, { name: "Linear_A", astral: "\uD801[\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]" }, { name: "Linear_B", astral: "\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA]" }, { name: "Lisu", bmp: "\uA4D0-\uA4FF" }, { name: "Lycian", astral: "\uD800[\uDE80-\uDE9C]" }, { name: "Lydian", astral: "\uD802[\uDD20-\uDD39\uDD3F]" }, { name: "Mahajani", astral: "\uD804[\uDD50-\uDD76]" }, { name: "Malayalam", bmp: "\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4F\u0D54-\u0D63\u0D66-\u0D7F" }, { name: "Mandaic", bmp: "\u0840-\u085B\u085E" }, { name: "Manichaean", astral: "\uD802[\uDEC0-\uDEE6\uDEEB-\uDEF6]" }, { name: "Marchen", astral: "\uD807[\uDC70-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]" }, { name: "Meetei_Mayek", bmp: "\uAAE0-\uAAF6\uABC0-\uABED\uABF0-\uABF9" }, { name: "Mende_Kikakui", astral: "\uD83A[\uDC00-\uDCC4\uDCC7-\uDCD6]" }, { name: "Meroitic_Cursive", astral: "\uD802[\uDDA0-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDDFF]" }, { name: "Meroitic_Hieroglyphs", astral: "\uD802[\uDD80-\uDD9F]" }, { name: "Miao", astral: "\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F]" }, { name: "Modi", astral: "\uD805[\uDE00-\uDE44\uDE50-\uDE59]" }, { name: "Mongolian", bmp: "\u1800\u1801\u1804\u1806-\u180E\u1810-\u1819\u1820-\u1877\u1880-\u18AA", astral: "\uD805[\uDE60-\uDE6C]" }, { name: "Mro", astral: "\uD81A[\uDE40-\uDE5E\uDE60-\uDE69\uDE6E\uDE6F]" }, { name: "Multani", astral: "\uD804[\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA9]" }, { name: "Myanmar", bmp: "\u1000-\u109F\uA9E0-\uA9FE\uAA60-\uAA7F" }, { name: "Nabataean", astral: "\uD802[\uDC80-\uDC9E\uDCA7-\uDCAF]" }, { name: "New_Tai_Lue", bmp: "\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u19DE\u19DF" }, { name: "Newa", astral: "\uD805[\uDC00-\uDC59\uDC5B\uDC5D]" }, { name: "Nko", bmp: "\u07C0-\u07FA" }, { name: "Ogham", bmp: "\u1680-\u169C" }, { name: "Ol_Chiki", bmp: "\u1C50-\u1C7F" }, { name: "Old_Hungarian", astral: "\uD803[\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDCFF]" }, { name: "Old_Italic", astral: "\uD800[\uDF00-\uDF23]" }, { name: "Old_North_Arabian", astral: "\uD802[\uDE80-\uDE9F]" }, { name: "Old_Permic", astral: "\uD800[\uDF50-\uDF7A]" }, { name: "Old_Persian", astral: "\uD800[\uDFA0-\uDFC3\uDFC8-\uDFD5]" }, { name: "Old_South_Arabian", astral: "\uD802[\uDE60-\uDE7F]" }, { name: "Old_Turkic", astral: "\uD803[\uDC00-\uDC48]" }, { name: "Oriya", bmp: "\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B77" }, { name: "Osage", astral: "\uD801[\uDCB0-\uDCD3\uDCD8-\uDCFB]" }, { name: "Osmanya", astral: "\uD801[\uDC80-\uDC9D\uDCA0-\uDCA9]" }, { name: "Pahawh_Hmong", astral: "\uD81A[\uDF00-\uDF45\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]" }, { name: "Palmyrene", astral: "\uD802[\uDC60-\uDC7F]" }, { name: "Pau_Cin_Hau", astral: "\uD806[\uDEC0-\uDEF8]" }, { name: "Phags_Pa", bmp: "\uA840-\uA877" }, { name: "Phoenician", astral: "\uD802[\uDD00-\uDD1B\uDD1F]" }, { name: "Psalter_Pahlavi", astral: "\uD802[\uDF80-\uDF91\uDF99-\uDF9C\uDFA9-\uDFAF]" }, { name: "Rejang", bmp: "\uA930-\uA953\uA95F" }, { name: "Runic", bmp: "\u16A0-\u16EA\u16EE-\u16F8" }, { name: "Samaritan", bmp: "\u0800-\u082D\u0830-\u083E" }, { name: "Saurashtra", bmp: "\uA880-\uA8C5\uA8CE-\uA8D9" }, { name: "Sharada", astral: "\uD804[\uDD80-\uDDCD\uDDD0-\uDDDF]" }, { name: "Shavian", astral: "\uD801[\uDC50-\uDC7F]" }, { name: "Siddham", astral: "\uD805[\uDD80-\uDDB5\uDDB8-\uDDDD]" }, { name: "SignWriting", astral: "\uD836[\uDC00-\uDE8B\uDE9B-\uDE9F\uDEA1-\uDEAF]" }, { name: "Sinhala", bmp: "\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2-\u0DF4", astral: "\uD804[\uDDE1-\uDDF4]" }, { name: "Sora_Sompeng", astral: "\uD804[\uDCD0-\uDCE8\uDCF0-\uDCF9]" }, { name: "Sundanese", bmp: "\u1B80-\u1BBF\u1CC0-\u1CC7" }, { name: "Syloti_Nagri", bmp: "\uA800-\uA82B" }, { name: "Syriac", bmp: "\u0700-\u070D\u070F-\u074A\u074D-\u074F" }, { name: "Tagalog", bmp: "\u1700-\u170C\u170E-\u1714" }, { name: "Tagbanwa", bmp: "\u1760-\u176C\u176E-\u1770\u1772\u1773" }, { name: "Tai_Le", bmp: "\u1950-\u196D\u1970-\u1974" }, { name: "Tai_Tham", bmp: "\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA0-\u1AAD" }, { name: "Tai_Viet", bmp: "\uAA80-\uAAC2\uAADB-\uAADF" }, { name: "Takri", astral: "\uD805[\uDE80-\uDEB7\uDEC0-\uDEC9]" }, { name: "Tamil", bmp: "\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BFA" }, { name: "Tangut", astral: "\u{16FE0}|[\uD81C-\uD820][\uDC00-\uDFFF]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]" }, { name: "Telugu", bmp: "\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C78-\u0C7F" }, { name: "Thaana", bmp: "\u0780-\u07B1" }, { name: "Thai", bmp: "\u0E01-\u0E3A\u0E40-\u0E5B" }, { name: "Tibetan", bmp: "\u0F00-\u0F47\u0F49-\u0F6C\u0F71-\u0F97\u0F99-\u0FBC\u0FBE-\u0FCC\u0FCE-\u0FD4\u0FD9\u0FDA" }, { name: "Tifinagh", bmp: "\u2D30-\u2D67\u2D6F\u2D70\u2D7F" }, { name: "Tirhuta", astral: "\uD805[\uDC80-\uDCC7\uDCD0-\uDCD9]" }, { name: "Ugaritic", astral: "\uD800[\uDF80-\uDF9D\uDF9F]" }, { name: "Vai", bmp: "\uA500-\uA62B" }, { name: "Warang_Citi", astral: "\uD806[\uDCA0-\uDCF2\uDCFF]" }, { name: "Yi", bmp: "\uA000-\uA48C\uA490-\uA4C6" }]);
    };
  }, {}], 8: [function(e15, t10, n10) {
    var r10 = e15("./xregexp");
    e15("./addons/build")(r10), e15("./addons/matchrecursive")(r10), e15("./addons/unicode-base")(r10), e15("./addons/unicode-blocks")(r10), e15("./addons/unicode-categories")(r10), e15("./addons/unicode-properties")(r10), e15("./addons/unicode-scripts")(r10), t10.exports = r10;
  }, { "./addons/build": 1, "./addons/matchrecursive": 2, "./addons/unicode-base": 3, "./addons/unicode-blocks": 4, "./addons/unicode-categories": 5, "./addons/unicode-properties": 6, "./addons/unicode-scripts": 7, "./xregexp": 9 }], 9: [function(e15, t10, n10) {
    var r10 = "xregexp";
    var o10 = { astral: false, natives: false };
    var a10 = { exec: RegExp.prototype.exec, test: RegExp.prototype.test, match: String.prototype.match, replace: String.prototype.replace, split: String.prototype.split };
    var i10 = {};
    var s10 = {};
    var l10 = {};
    var c10 = [];
    var u10 = "default";
    var d10 = "class";
    var p10 = { default: /\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9]\d*|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|\(\?(?:[:=!]|<[=!])|[?*+]\?|{\d+(?:,\d*)?}\??|[\s\S]/, class: /\\(?:[0-3][0-7]{0,2}|[4-7][0-7]?|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|[\s\S]/ };
    var m10 = /\$(?:{([\w$]+)}|(\d\d?|[\s\S]))/g;
    var h10 = void 0 === a10.exec.call(/()??/, "")[1];
    var f10 = void 0 !== /x/.flags;
    var g10 = {}.toString;
    function y10(e16) {
      var t11 = true;
      try {
        new RegExp("", e16);
      } catch (e17) {
        t11 = false;
      }
      return t11;
    }
    var v10 = y10("u");
    var b10 = y10("y");
    var S10 = { g: true, i: true, m: true, u: v10, y: b10 };
    function C10(e16, t11, n11, o11, a11) {
      var i11;
      if (e16[r10] = { captureNames: t11 }, a11) return e16;
      if (e16.__proto__) e16.__proto__ = B10.prototype;
      else for (i11 in B10.prototype) e16[i11] = B10.prototype[i11];
      return e16[r10].source = n11, e16[r10].flags = o11 ? o11.split("").sort().join("") : o11, e16;
    }
    function x10(e16) {
      return a10.replace.call(e16, /([\s\S])(?=[\s\S]*\1)/g, "");
    }
    function w10(e16, t11) {
      if (!B10.isRegExp(e16)) throw new TypeError("Type RegExp expected");
      var n11 = e16[r10] || {};
      var o11 = F10(e16);
      var i11 = "";
      var s11 = "";
      var l11 = null;
      var c11 = null;
      return (t11 = t11 || {}).removeG && (s11 += "g"), t11.removeY && (s11 += "y"), s11 && (o11 = a10.replace.call(o11, new RegExp("[" + s11 + "]+", "g"), "")), t11.addG && (i11 += "g"), t11.addY && (i11 += "y"), i11 && (o11 = x10(o11 + i11)), t11.isInternalOnly || (void 0 !== n11.source && (l11 = n11.source), null != n11.flags && (c11 = i11 ? x10(n11.flags + i11) : n11.flags)), e16 = C10(new RegExp(t11.source || e16.source, o11), M10(e16) ? n11.captureNames.slice(0) : null, l11, c11, t11.isInternalOnly);
    }
    function T10(e16) {
      return parseInt(e16, 16);
    }
    function E10(e16, t11, n11) {
      return "(" === e16.input.charAt(e16.index - 1) || ")" === e16.input.charAt(e16.index + e16[0].length) || N10(e16.input, e16.index + e16[0].length, n11, "[?*+]|{\\d+(?:,\\d*)?}") ? "" : "(?:)";
    }
    function F10(e16) {
      return f10 ? e16.flags : a10.exec.call(/\/([a-z]*)$/i, RegExp.prototype.toString.call(e16))[1];
    }
    function M10(e16) {
      return !(!e16[r10] || !e16[r10].captureNames);
    }
    function k10(e16) {
      return parseInt(e16, 10).toString(16);
    }
    function P10(e16, t11) {
      var n11 = e16.length;
      var r11;
      for (r11 = 0; r11 < n11; ++r11) if (e16[r11] === t11) return r11;
      return -1;
    }
    function N10(e16, t11, n11, r11) {
      var o11 = "\\(\\?#[^)]*\\)";
      var i11 = "#[^#\\n]*";
      var s11 = n11.indexOf("x") > -1 ? ["\\s", i11, o11] : [o11];
      return a10.test.call(new RegExp("^(?:" + s11.join("|") + ")*(?:" + r11 + ")"), e16.slice(t11));
    }
    function D10(e16, t11) {
      return g10.call(e16) === "[object " + t11 + "]";
    }
    function L10(e16) {
      for (; e16.length < 4; ) e16 = "0" + e16;
      return e16;
    }
    function H10(e16, t11) {
      var n11;
      if (x10(t11) !== t11) throw new SyntaxError("Invalid duplicate regex flag " + t11);
      for (e16 = a10.replace.call(e16, /^\(\?([\w$]+)\)/, function(e17, n12) {
        if (a10.test.call(/[gy]/, n12)) throw new SyntaxError("Cannot use flag g or y in mode modifier " + e17);
        return t11 = x10(t11 + n12), "";
      }), n11 = 0; n11 < t11.length; ++n11) if (!S10[t11.charAt(n11)]) throw new SyntaxError("Unknown regex flag " + t11.charAt(n11));
      return { pattern: e16, flags: t11 };
    }
    function I10(e16) {
      var t11 = {};
      return D10(e16, "String") ? (B10.forEach(e16, /[^\s,]+/, function(e17) {
        t11[e17] = true;
      }), t11) : e16;
    }
    function _10(e16) {
      if (!/^[\w$]$/.test(e16)) throw new Error("Flag must be a single character A-Za-z0-9_$");
      S10[e16] = true;
    }
    function V10(e16, t11, n11, r11, o11) {
      var a11 = c10.length;
      var i11 = e16.charAt(n11);
      var s11 = null;
      var l11;
      var u11;
      for (; a11--; ) if (!((u11 = c10[a11]).leadChar && u11.leadChar !== i11 || u11.scope !== r11 && "all" !== u11.scope || u11.flag && -1 === t11.indexOf(u11.flag)) && (l11 = B10.exec(e16, u11.regex, n11, "sticky"))) {
        s11 = { matchLength: l11[0].length, output: u11.handler.call(o11, l11, r11, t11), reparse: u11.reparse };
        break;
      }
      return s11;
    }
    function R10(e16) {
      o10.astral = e16;
    }
    function A10(e16) {
      RegExp.prototype.exec = (e16 ? i10 : a10).exec, RegExp.prototype.test = (e16 ? i10 : a10).test, String.prototype.match = (e16 ? i10 : a10).match, String.prototype.replace = (e16 ? i10 : a10).replace, String.prototype.split = (e16 ? i10 : a10).split, o10.natives = e16;
    }
    function O10(e16) {
      if (null == e16) throw new TypeError("Cannot convert null or undefined to object");
      return e16;
    }
    function B10(e16, t11) {
      if (B10.isRegExp(e16)) {
        if (void 0 !== t11) throw new TypeError("Cannot supply flags when copying a RegExp");
        return w10(e16);
      }
      if (e16 = void 0 === e16 ? "" : String(e16), t11 = void 0 === t11 ? "" : String(t11), B10.isInstalled("astral") && -1 === t11.indexOf("A") && (t11 += "A"), l10[e16] || (l10[e16] = {}), !l10[e16][t11]) {
        var n11 = { hasNamedCapture: false, captureNames: [] };
        var r11 = u10;
        var o11 = "";
        var i11 = 0;
        var s11;
        var c11 = H10(e16, t11);
        var m11 = c11.pattern;
        var h11 = c11.flags;
        for (; i11 < m11.length; ) {
          do {
            (s11 = V10(m11, h11, i11, r11, n11)) && s11.reparse && (m11 = m11.slice(0, i11) + s11.output + m11.slice(i11 + s11.matchLength));
          } while (s11 && s11.reparse);
          if (s11) o11 += s11.output, i11 += s11.matchLength || 1;
          else {
            var f11 = B10.exec(m11, p10[r11], i11, "sticky")[0];
            o11 += f11, i11 += f11.length, "[" === f11 && r11 === u10 ? r11 = d10 : "]" === f11 && r11 === d10 && (r11 = u10);
          }
        }
        l10[e16][t11] = { pattern: a10.replace.call(o11, /(?:\(\?:\))+/g, "(?:)"), flags: a10.replace.call(h11, /[^gimuy]+/g, ""), captures: n11.hasNamedCapture ? n11.captureNames : null };
      }
      var g11 = l10[e16][t11];
      return C10(new RegExp(g11.pattern, g11.flags), g11.captures, e16, t11);
    }
    B10.prototype = new RegExp(), B10.version = "3.2.0", B10._clipDuplicates = x10, B10._hasNativeFlag = y10, B10._dec = T10, B10._hex = k10, B10._pad4 = L10, B10.addToken = function(e16, t11, n11) {
      var r11 = (n11 = n11 || {}).optionalFlags;
      var o11;
      if (n11.flag && _10(n11.flag), r11) for (r11 = a10.split.call(r11, ""), o11 = 0; o11 < r11.length; ++o11) _10(r11[o11]);
      c10.push({ regex: w10(e16, { addG: true, addY: b10, isInternalOnly: true }), handler: t11, scope: n11.scope || u10, flag: n11.flag, reparse: n11.reparse, leadChar: n11.leadChar }), B10.cache.flush("patterns");
    }, B10.cache = function(e16, t11) {
      return s10[e16] || (s10[e16] = {}), s10[e16][t11] || (s10[e16][t11] = B10(e16, t11));
    }, B10.cache.flush = function(e16) {
      "patterns" === e16 ? l10 = {} : s10 = {};
    }, B10.escape = function(e16) {
      return a10.replace.call(O10(e16), /[-\[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    }, B10.exec = function(e16, t11, n11, o11) {
      var a11 = "g";
      var s11 = false;
      var l11 = false;
      var c11;
      var u11;
      return (s11 = b10 && !!(o11 || t11.sticky && false !== o11)) ? a11 += "y" : o11 && (l11 = true, a11 += "FakeY"), t11[r10] = t11[r10] || {}, n11 = n11 || 0, (u11 = t11[r10][a11] || (t11[r10][a11] = w10(t11, { addG: true, addY: s11, source: l11 ? t11.source + "|()" : void 0, removeY: false === o11, isInternalOnly: true }))).lastIndex = n11, c11 = i10.exec.call(u11, e16), l11 && c11 && "" === c11.pop() && (c11 = null), t11.global && (t11.lastIndex = c11 ? u11.lastIndex : 0), c11;
    }, B10.forEach = function(e16, t11, n11) {
      var r11 = 0;
      var o11 = -1;
      var a11;
      for (; a11 = B10.exec(e16, t11, r11); ) n11(a11, ++o11, e16, t11), r11 = a11.index + (a11[0].length || 1);
    }, B10.globalize = function(e16) {
      return w10(e16, { addG: true });
    }, B10.install = function(e16) {
      e16 = I10(e16), !o10.astral && e16.astral && R10(true), !o10.natives && e16.natives && A10(true);
    }, B10.isInstalled = function(e16) {
      return !!o10[e16];
    }, B10.isRegExp = function(e16) {
      return "[object RegExp]" === g10.call(e16);
    }, B10.match = function(e16, t11, n11) {
      var o11 = t11.global && "one" !== n11 || "all" === n11;
      var i11 = (o11 ? "g" : "") + (t11.sticky ? "y" : "") || "noGY";
      var s11;
      var l11;
      return t11[r10] = t11[r10] || {}, l11 = t11[r10][i11] || (t11[r10][i11] = w10(t11, { addG: !!o11, removeG: "one" === n11, isInternalOnly: true })), s11 = a10.match.call(O10(e16), l11), t11.global && (t11.lastIndex = "one" === n11 && s11 ? s11.index + s11[0].length : 0), o11 ? s11 || [] : s11 && s11[0];
    }, B10.matchChain = function(e16, t11) {
      return function e17(n11, r11) {
        var o11 = t11[r11].regex ? t11[r11] : { regex: t11[r11] };
        var a11 = [];
        function i11(e18) {
          if (o11.backref) {
            if (!(e18.hasOwnProperty(o11.backref) || +o11.backref < e18.length)) throw new ReferenceError("Backreference to undefined group: " + o11.backref);
            a11.push(e18[o11.backref] || "");
          } else a11.push(e18[0]);
        }
        for (var s11 = 0; s11 < n11.length; ++s11) B10.forEach(n11[s11], o11.regex, i11);
        return r11 !== t11.length - 1 && a11.length ? e17(a11, r11 + 1) : a11;
      }([e16], 0);
    }, B10.replace = function(e16, t11, n11, o11) {
      var a11 = B10.isRegExp(t11);
      var s11 = t11.global && "one" !== o11 || "all" === o11;
      var l11 = (s11 ? "g" : "") + (t11.sticky ? "y" : "") || "noGY";
      var c11 = t11;
      var u11;
      return a11 ? (t11[r10] = t11[r10] || {}, c11 = t11[r10][l11] || (t11[r10][l11] = w10(t11, { addG: !!s11, removeG: "one" === o11, isInternalOnly: true }))) : s11 && (c11 = new RegExp(B10.escape(String(t11)), "g")), u11 = i10.replace.call(O10(e16), c11, n11), a11 && t11.global && (t11.lastIndex = 0), u11;
    }, B10.replaceEach = function(e16, t11) {
      var n11;
      var r11;
      for (n11 = 0; n11 < t11.length; ++n11) r11 = t11[n11], e16 = B10.replace(e16, r11[0], r11[1], r11[2]);
      return e16;
    }, B10.split = function(e16, t11, n11) {
      return i10.split.call(O10(e16), t11, n11);
    }, B10.test = function(e16, t11, n11, r11) {
      return !!B10.exec(e16, t11, n11, r11);
    }, B10.uninstall = function(e16) {
      e16 = I10(e16), o10.astral && e16.astral && R10(false), o10.natives && e16.natives && A10(false);
    }, B10.union = function(e16, t11, n11) {
      var o11 = (n11 = n11 || {}).conjunction || "or";
      var i11 = 0;
      var s11;
      var l11;
      function c11(e17, t12, n12) {
        var r11 = l11[i11 - s11];
        if (t12) {
          if (++i11, r11) return "(?<" + r11 + ">";
        } else if (n12) return "\\" + (+n12 + s11);
        return e17;
      }
      if (!D10(e16, "Array") || !e16.length) throw new TypeError("Must provide a nonempty array of patterns to merge");
      var u11 = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g;
      var d11 = [];
      var p11;
      for (var m11 = 0; m11 < e16.length; ++m11) p11 = e16[m11], B10.isRegExp(p11) ? (s11 = i11, l11 = p11[r10] && p11[r10].captureNames || [], d11.push(a10.replace.call(B10(p11.source).source, u11, c11))) : d11.push(B10.escape(p11));
      var h11 = "none" === o11 ? "" : "|";
      return B10(d11.join(h11), t11);
    }, i10.exec = function(e16) {
      var t11 = this.lastIndex;
      var n11 = a10.exec.apply(this, arguments);
      var o11;
      var i11;
      var s11;
      if (n11) {
        if (!h10 && n11.length > 1 && P10(n11, "") > -1 && (i11 = w10(this, { removeG: true, isInternalOnly: true }), a10.replace.call(String(e16).slice(n11.index), i11, function() {
          var e17 = arguments.length;
          var t12;
          for (t12 = 1; t12 < e17 - 2; ++t12) void 0 === arguments[t12] && (n11[t12] = void 0);
        })), this[r10] && this[r10].captureNames) for (s11 = 1; s11 < n11.length; ++s11) (o11 = this[r10].captureNames[s11 - 1]) && (n11[o11] = n11[s11]);
        this.global && !n11[0].length && this.lastIndex > n11.index && (this.lastIndex = n11.index);
      }
      return this.global || (this.lastIndex = t11), n11;
    }, i10.test = function(e16) {
      return !!i10.exec.call(this, e16);
    }, i10.match = function(e16) {
      var t11;
      if (B10.isRegExp(e16)) {
        if (e16.global) return t11 = a10.match.apply(this, arguments), e16.lastIndex = 0, t11;
      } else e16 = new RegExp(e16);
      return i10.exec.call(e16, O10(this));
    }, i10.replace = function(e16, t11) {
      var n11 = B10.isRegExp(e16);
      var o11;
      var i11;
      var s11;
      return n11 ? (e16[r10] && (i11 = e16[r10].captureNames), o11 = e16.lastIndex) : e16 += "", s11 = D10(t11, "Function") ? a10.replace.call(String(this), e16, function() {
        var r11 = arguments;
        var o12;
        if (i11) for (r11[0] = new String(r11[0]), o12 = 0; o12 < i11.length; ++o12) i11[o12] && (r11[0][i11[o12]] = r11[o12 + 1]);
        return n11 && e16.global && (e16.lastIndex = r11[r11.length - 2] + r11[0].length), t11.apply(void 0, r11);
      }) : a10.replace.call(null == this ? this : String(this), e16, function() {
        var e17 = arguments;
        return a10.replace.call(String(t11), m10, function(t12, n12, r11) {
          var o12;
          if (n12) {
            if ((o12 = +n12) <= e17.length - 3) return e17[o12] || "";
            if ((o12 = i11 ? P10(i11, n12) : -1) < 0) throw new SyntaxError("Backreference to undefined group " + t12);
            return e17[o12 + 1] || "";
          }
          if ("$" === r11) return "$";
          if ("&" === r11 || 0 == +r11) return e17[0];
          if ("`" === r11) return e17[e17.length - 1].slice(0, e17[e17.length - 2]);
          if ("'" === r11) return e17[e17.length - 1].slice(e17[e17.length - 2] + e17[0].length);
          if (r11 = +r11, !isNaN(r11)) {
            if (r11 > e17.length - 3) throw new SyntaxError("Backreference to undefined group " + t12);
            return e17[r11] || "";
          }
          throw new SyntaxError("Invalid token " + t12);
        });
      }), n11 && (e16.global ? e16.lastIndex = 0 : e16.lastIndex = o11), s11;
    }, i10.split = function(e16, t11) {
      if (!B10.isRegExp(e16)) return a10.split.apply(this, arguments);
      var n11 = String(this);
      var r11 = [];
      var o11 = e16.lastIndex;
      var i11 = 0;
      var s11;
      return t11 = (void 0 === t11 ? -1 : t11) >>> 0, B10.forEach(n11, e16, function(e17) {
        e17.index + e17[0].length > i11 && (r11.push(n11.slice(i11, e17.index)), e17.length > 1 && e17.index < n11.length && Array.prototype.push.apply(r11, e17.slice(1)), s11 = e17[0].length, i11 = e17.index + s11);
      }), i11 === n11.length ? a10.test.call(e16, "") && !s11 || r11.push("") : r11.push(n11.slice(i11)), e16.lastIndex = o11, r11.length > t11 ? r11.slice(0, t11) : r11;
    }, B10.addToken(/\\([ABCE-RTUVXYZaeg-mopqyz]|c(?![A-Za-z])|u(?![\dA-Fa-f]{4}|{[\dA-Fa-f]+})|x(?![\dA-Fa-f]{2}))/, function(e16, t11) {
      if ("B" === e16[1] && t11 === u10) return e16[0];
      throw new SyntaxError("Invalid escape " + e16[0]);
    }, { scope: "all", leadChar: "\\" }), B10.addToken(/\\u{([\dA-Fa-f]+)}/, function(e16, t11, n11) {
      var r11 = T10(e16[1]);
      if (r11 > 1114111) throw new SyntaxError("Invalid Unicode code point " + e16[0]);
      if (r11 <= 65535) return "\\u" + L10(k10(r11));
      if (v10 && n11.indexOf("u") > -1) return e16[0];
      throw new SyntaxError("Cannot use Unicode code point above \\u{FFFF} without flag u");
    }, { scope: "all", leadChar: "\\" }), B10.addToken(/\[(\^?)\]/, function(e16) {
      return e16[1] ? "[\\s\\S]" : "\\b\\B";
    }, { leadChar: "[" }), B10.addToken(/\(\?#[^)]*\)/, E10, { leadChar: "(" }), B10.addToken(/\s+|#[^\n]*\n?/, E10, { flag: "x" }), B10.addToken(/\./, function() {
      return "[\\s\\S]";
    }, { flag: "s", leadChar: "." }), B10.addToken(/\\k<([\w$]+)>/, function(e16) {
      var t11 = isNaN(e16[1]) ? P10(this.captureNames, e16[1]) + 1 : +e16[1];
      var n11 = e16.index + e16[0].length;
      if (!t11 || t11 > this.captureNames.length) throw new SyntaxError("Backreference to undefined group " + e16[0]);
      return "\\" + t11 + (n11 === e16.input.length || isNaN(e16.input.charAt(n11)) ? "" : "(?:)");
    }, { leadChar: "\\" }), B10.addToken(/\\(\d+)/, function(e16, t11) {
      if (!(t11 === u10 && /^[1-9]/.test(e16[1]) && +e16[1] <= this.captureNames.length) && "0" !== e16[1]) throw new SyntaxError("Cannot use octal escape or backreference to undefined group " + e16[0]);
      return e16[0];
    }, { scope: "all", leadChar: "\\" }), B10.addToken(/\(\?P?<([\w$]+)>/, function(e16) {
      if (!isNaN(e16[1])) throw new SyntaxError("Cannot use integer as capture name " + e16[0]);
      if ("length" === e16[1] || "__proto__" === e16[1]) throw new SyntaxError("Cannot use reserved word as capture name " + e16[0]);
      if (P10(this.captureNames, e16[1]) > -1) throw new SyntaxError("Cannot use same name for multiple groups " + e16[0]);
      return this.captureNames.push(e16[1]), this.hasNamedCapture = true, "(";
    }, { leadChar: "(" }), B10.addToken(/\((?!\?)/, function(e16, t11, n11) {
      return n11.indexOf("n") > -1 ? "(?:" : (this.captureNames.push(null), "(");
    }, { optionalFlags: "n", leadChar: "(" }), t10.exports = B10;
  }, {}] }, {}, [8])(8)), Nl.exports;
  var e14;
}
var Hl;
function Il() {
  if (Hl) return kl;
  Hl = 1, Object.defineProperty(kl, "__esModule", { value: true }), kl.tokenizeIS = kl.createTreeBuilderIS = void 0;
  var e14 = Ae;
  var t10 = e14.__importDefault(Ll());
  var n10 = xl();
  var r10 = Oe;
  var o10 = Ml();
  var a10 = e14.__importStar(As());
  var i10 = Us();
  var s10 = "+-/*=<>&,()\\{}[]^";
  var l10 = "^((?:\\pL[\\pL_\\d]*)|(?:_[\\pL_\\d]+))$";
  function c10(o11, a11) {
    var i11;
    var c11 = [];
    var d10 = a11.globals;
    var p10 = function(e15) {
      return e15 && '"' === e15[0] && y10;
    };
    var m10 = "";
    var h10 = true;
    var f10 = false;
    var g10 = false;
    var y10 = false;
    var v10 = 0;
    var b10 = -1;
    var S10 = 0;
    var C10 = 0;
    var x10 = 0;
    var w10 = function(e15) {
      m10 || (S10 = v10, C10 = b10, x10 = e15);
    };
    var T10 = function(e15) {
      var t11 = o11[e15];
      if (b10 += 1, "{" === t11) {
        if (g10) return b10 += 1, w10(e15), m10 += t11, E10 = e15, "continue";
        if ("{" === o11[e15 + 1] && !p10(m10)) return b10 += 1, w10(e15 += 1), m10 += t11, E10 = e15, "continue";
        h10 && (0 === m10.length ? (h10 = false, y10 = true) : p10(m10) || (w10(e15), c11.push({ token: '"' + m10 + '"', position: r10.makePos(S10, C10, x10), expression: o11 }), m10 = "", h10 = false, y10 = true));
      }
      if ("}" === t11 && !h10) return g10 ? (b10 += 1, w10(e15), m10 += t11, E10 = e15, "continue") : (0 !== m10.length && (w10(e15), c11.push({ token: m10, position: r10.makePos(S10, C10, x10), expression: o11 }), m10 = ""), c11.push({ token: t11, position: r10.makePos(v10, b10, e15), expression: o11 }), h10 = true, y10 = false, E10 = e15, "continue");
      if ("[" === t11 && !h10 && !g10) return c11.push({ token: t11, position: r10.makePos(v10, b10, e15), expression: o11 }), g10 = true, E10 = e15, "continue";
      if ("]" === t11 && !h10 && g10) return 0 !== m10.length && (w10(e15), c11.push({ token: m10, position: r10.makePos(S10, C10, x10), expression: o11 }), m10 = ""), c11.push({ token: t11, position: r10.makePos(v10, b10, e15), expression: o11 }), g10 = false, E10 = e15, "continue";
      if ('"' === t11 && (0 === m10.length || "\\" !== m10[m10.length - 1])) {
        if (g10 || h10 && !y10) return m10 += t11, E10 = e15, "continue";
        if (!h10 && y10) h10 = true;
        else {
          if ('"' === o11[e15 + 1]) return b10 += 1, w10(e15 += 1), m10 += t11, E10 = e15, "continue";
          y10 && (h10 = false);
        }
      }
      if (h10 || '"' === t11) return w10(e15), (m10 += t11) && !h10 && (c11.push({ token: m10, position: r10.makePos(S10, C10, x10), expression: o11 }), m10 = ""), "\n" === t11 && v10++, "\n" !== t11 && "\r" !== t11 || (b10 = -1), E10 = e15, "continue";
      if (!g10 && " " === t11 || "	" === t11 || "\n" === t11 || "\r" === t11) return "" !== m10 && c11.push({ token: m10, position: r10.makePos(S10, C10, x10), expression: o11 }), m10 = "", "\n" === t11 && v10++, "\n" !== t11 && "\r" !== t11 || (b10 = -1), S10 = v10, C10 = 0, E10 = e15, "continue";
      if ("#" !== t11 || !o11[e15 + 1].match(/\d/) || 0 !== m10.length && "\\" === m10[m10.length - 1] || (f10 = !f10), f10 || "#" === t11) return m10 += t11, E10 = e15, "continue";
      if ((T11 = t11) && s10.indexOf(T11) > -1 && !g10) {
        if (("+" === t11 || "-" === t11) && function(e16) {
          return e16 && r10.exponent.test(e16);
        }(m10)) return m10 += t11, E10 = e15, "continue";
        if ("&" === t11 && 0 === m10.length && d10 && 0 !== d10.length) {
          var n11 = null === (i11 = o11.slice(e15 + 1).match(/^\w+/i)) || void 0 === i11 ? void 0 : i11[0];
          if (n11 && d10.find(function(e16) {
            return e16.localeCompare(n11);
          })) return m10 += t11, E10 = e15, "continue";
        }
        if ("" !== m10 && c11.push({ token: m10, position: r10.makePos(S10, C10, x10), expression: o11 }), m10 = "", "=" !== t11 && "<" !== t11 && ">" !== t11 || !(c11.length > 0) || "<" !== c11[c11.length - 1].token && ">" !== c11[c11.length - 1].token) if ("(" === t11 && c11.length > 0) {
          var a12 = c11[c11.length - 1];
          var l11 = Math.max(a12.token.lastIndexOf("."), a12.token.lastIndexOf("!"));
          if (l11 > 0) {
            var u11 = a12.token;
            c11[c11.length - 1].token = u11.substr(0, l11), c11.push({ token: u11.substr(l11), position: r10.makePos(S10, C10 + l11, x10 + l11), expression: o11 });
          }
          c11.push({ token: t11, position: r10.makePos(v10, b10, e15), expression: o11 });
        } else c11.push({ token: t11, position: r10.makePos(v10, b10, e15), expression: o11 });
        else c11[c11.length - 1].token += t11;
        return E10 = e15, "continue";
      }
      var T11;
      w10(e15), m10 += t11, E10 = e15;
    };
    var E10;
    for (var F10 = 0; F10 < o11.length; F10++) T10(F10), F10 = E10;
    return "" !== m10 && c11.push({ token: h10 ? '"' + m10 + '"' : m10, position: r10.makePos(S10, C10, x10), expression: o11 }), function(r11, o12) {
      var a12 = function(e15, t11, r12) {
        var a13 = e15.toLowerCase();
        var i13 = o12.constants, l11 = o12.variables, c13 = o12.globalCollectionNames, d11 = o12.globalNamespaces;
        return "[" === t11 && "]" === r12 || !a13.includes(".") && "(" !== r12 && (!(s10.indexOf(a13) >= 0) && ("true" !== a13 && "false" !== a13 && (!(a13.search(/^\d+$/) >= 0) && (!a13.startsWith('"') && (!(a13.search(/^#.+#$/) >= 0) && (!c13.some(u10(a13, r12)) && !d11.some(u10(a13, r12)) && (!(a13 in n10.operators) && !i13.includes(a13) && !l11.includes(a13))))))));
      };
      var i12 = function(e15) {
        return ["}", "{"].includes(e15);
      };
      var c12 = false;
      return r11.reduce(function(n11, o13, s11) {
        var u11, d11, p11;
        if (c12) return c12 = false, n11;
        if (i12(o13.token)) return 0 === s11 || s11 === r11.length - 1 || i12(r11[s11 + 1].token) || n11.push(e14.__assign(e14.__assign({}, o13), { token: "&" })), n11;
        if (o13.token.startsWith("&") && !o13.token.includes(".") && o13.token.length > 1) return n11.push(e14.__assign(e14.__assign({}, o13), { token: "Globals!" + o13.token.slice(1) })), n11;
        if (o13.token.startsWith("@") && !o13.token.includes(".") && o13.token.length > 1) return n11.push(e14.__assign(e14.__assign({}, o13), { token: "Parameters!" + o13.token.slice(1) + ".Value" })), n11;
        if (o13.token.startsWith("#") && /\D/.test(o13.token[1]) && !o13.token.includes(".") && o13.token.length > 1) return n11.push(e14.__assign(e14.__assign({}, o13), { token: "ReportItems!" + o13.token.slice(1) + ".Value" })), n11;
        if (o13.token.startsWith("$") && o13.token.length > 1) return n11.push(e14.__assign(e14.__assign({}, o13), { token: o13.token.slice(1) })), n11;
        var m11 = null === (u11 = r11[s11 - 1]) || void 0 === u11 ? void 0 : u11.token;
        var h11 = null === (d11 = r11[s11 + 1]) || void 0 === d11 ? void 0 : d11.token;
        return a12(o13.token, m11, h11) ? ("[" === m11 && "[" === (null === (p11 = n11[n11.length - 1]) || void 0 === p11 ? void 0 : p11.token) && "]" === h11 && (n11.pop(), c12 = true), t10.default.test(o13.token, t10.default(l10)) ? (n11.push(e14.__assign(e14.__assign({}, o13), { token: "Fields!" + o13.token + ".Value" })), n11) : (n11.push(e14.__assign(e14.__assign({}, o13), { token: "Fields" })), n11.push(e14.__assign(e14.__assign({}, o13), { token: ".Item" })), n11.push(e14.__assign(e14.__assign({}, o13), { token: "(" })), n11.push(e14.__assign(e14.__assign({}, o13), { token: '"' + o13.token + '"' })), n11.push(e14.__assign(e14.__assign({}, o13), { token: ")" })), n11.push(e14.__assign(e14.__assign({}, o13), { token: ".Value" })), n11)) : (n11.push(o13), n11);
      }, []);
    }(c11, a11);
  }
  kl.tokenizeIS = c10;
  var u10 = function(e15, t11) {
    return function(n11) {
      return !(!e15.startsWith(n11 + "!") && !e15.startsWith(n11 + ".")) || !(e15 !== n11 || !t11 || !t11.startsWith("!") && !t11.startsWith("."));
    };
  };
  return kl.createTreeBuilderIS = function(t11, r11, s11, l11) {
    var u11 = i10.mapKeys(e14.__assign(e14.__assign({}, n10.predefinedFunctions), r11), function(e15) {
      return e15.toLowerCase();
    });
    var d10 = i10.mapKeys(e14.__assign(e14.__assign({}, n10.predefinedConstants), l11), function(e15) {
      return e15.toLowerCase();
    });
    var p10 = i10.mapKeys(e14.__assign(e14.__assign({}, n10.predefinedVariables), s11), function(e15) {
      return e15.toLowerCase();
    });
    return function(n11) {
      if (n11 && "string" == typeof n11) {
        var r12 = e14.__assign(e14.__assign({}, t11), { constants: e14.__spread(t11.constants, Object.keys(d10)) });
        return o10.compile(o10.parse(c10(n11, r12), u11, d10, p10, false), u11, d10, p10);
      }
      return o10.makeExpressionNode(function() {
        return a10.Create(n11);
      }, [], { type: "value", value: a10.Create(n11) });
    };
  }, kl;
}
Nl.exports;
var _l = {};
var Vl;
var Rl = {};
var Al;
var Ol;
function Bl() {
  return Ol || (Ol = 1, function(e14) {
    Object.defineProperty(e14, "__esModule", { value: true }), e14.Format = e14.addLocale = e14.shouldTreatAsDate = e14.dateTimeFactory = e14.Tools = e14.createTreeBuilder = e14.createCompiler = void 0;
    var t10 = Ae;
    var n10 = Oe;
    var r10 = Ml();
    Object.defineProperty(e14, "createTreeBuilder", { enumerable: true, get: function() {
      return r10.createTreeBuilder;
    } });
    var o10 = Il();
    Object.defineProperty(e14, "createTreeBuilderIS", { enumerable: true, get: function() {
      return o10.createTreeBuilderIS;
    } }), t10.__exportStar(Ws(), e14);
    var a10 = t10.__importStar(As());
    var i10 = t10.__importStar(Us());
    var s10 = di();
    Object.defineProperty(e14, "dateTimeFactory", { enumerable: true, get: function() {
      return s10.dateTimeFactory;
    } });
    var l10 = ms();
    Object.defineProperty(e14, "addLocale", { enumerable: true, get: function() {
      return l10.addLocale;
    } });
    var c10 = t10.__importDefault(Ps());
    var u10 = vl();
    Object.defineProperty(e14, "Record", { enumerable: true, get: function() {
      return u10.default;
    } });
    var d10 = function() {
      if (Vl) return _l;
      Vl = 1, Object.defineProperty(_l, "__esModule", { value: true });
      var e15 = Ae;
      var t11 = e15.__importDefault(vl());
      var n11 = function() {
        function n12(e16, t12) {
          void 0 === e16 && (e16 = []), void 0 === t12 && (t12 = null), this.Records = e16, this.getAggregateDataProvider = t12;
        }
        return Object.defineProperty(n12.prototype, "AggregateDataProvider", { get: function() {
          return this._aggregateDataProvider || (this._aggregateDataProvider = null !== this.getAggregateDataProvider ? this.getAggregateDataProvider() : null);
        }, enumerable: false, configurable: true }), n12.prototype.FirstOrDefault = function() {
          var n13, r11;
          try {
            for (var o11 = e15.__values(this.Records), a11 = o11.next(); !a11.done; a11 = o11.next()) return a11.value;
          } catch (e16) {
            n13 = { error: e16 };
          } finally {
            try {
              a11 && !a11.done && (r11 = o11.return) && r11.call(o11);
            } finally {
              if (n13) throw n13.error;
            }
          }
          return t11.default.Empty;
        }, n12.prototype.Any = function() {
          var t12, n13;
          try {
            for (var r11 = e15.__values(this.Records), o11 = r11.next(); !o11.done; o11 = r11.next()) return !!o11.value;
          } catch (e16) {
            t12 = { error: e16 };
          } finally {
            try {
              o11 && !o11.done && (n13 = r11.return) && n13.call(r11);
            } finally {
              if (t12) throw t12.error;
            }
          }
          return false;
        }, n12.prototype[Symbol.iterator] = function() {
          var t12, n13, r11;
          var o11, a11;
          return e15.__generator(this, function(i11) {
            switch (i11.label) {
              case 0:
                i11.trys.push([0, 5, 6, 7]), t12 = e15.__values(this.Records), n13 = t12.next(), i11.label = 1;
              case 1:
                return n13.done ? [3, 4] : [4, n13.value];
              case 2:
                i11.sent(), i11.label = 3;
              case 3:
                return n13 = t12.next(), [3, 1];
              case 4:
                return [3, 7];
              case 5:
                return r11 = i11.sent(), o11 = { error: r11 }, [3, 7];
              case 6:
                try {
                  n13 && !n13.done && (a11 = t12.return) && a11.call(t12);
                } finally {
                  if (o11) throw o11.error;
                }
                return [7];
              case 7:
                return [2];
            }
          });
        }, n12.Empty = new n12([]), n12;
      }();
      return _l.default = n11, _l;
    }();
    Object.defineProperty(e14, "RecordSet", { enumerable: true, get: function() {
      return d10.default;
    } });
    var p10 = function() {
      if (Al) return Rl;
      Al = 1, Object.defineProperty(Rl, "__esModule", { value: true }), Rl.validateExpressionInternal = Rl.validateExpression = void 0;
      var e15 = Ae;
      var t11 = Oe;
      var n11 = Ml();
      var r11 = xl();
      var o11 = Us();
      var a11 = function(e16, t12) {
        return void 0 === t12 && (t12 = 0), s11(e16, t12, "warning");
      };
      function i11(t12, n12) {
        return e15.__assign(e15.__assign({}, s11(t12, n12.code, "warning")), { customArgs: n12.customArgs });
      }
      function s11(e16, t12, n12) {
        return void 0 === t12 && (t12 = 0), void 0 === n12 && (n12 = "error"), { message: e16.raw ? 'Unexpected symbol "' + e16.raw.token + '" in "' + e16.raw.expression + '" at ' + e16.raw.position.character : "Unknown error", details: e16.raw, level: n12, code: t12 };
      }
      function l11(e16, t12, n12) {
        return "constant" === t12.type && !!n12[t12.value.toLowerCase()] && "Object" === n12[t12.value.toLowerCase()].Type && !!o11.getValueByKey(n12[t12.value.toLowerCase()].Value, e16.value.replace(/^[\.!]/, ""));
      }
      function c11(e16, t12, n12, r12, o12) {
        void 0 === t12 && (t12 = {}), void 0 === n12 && (n12 = {}), void 0 === r12 && (r12 = {}), void 0 === o12 && (o12 = {});
        var c12 = function(e17) {
          return function(e18, t13) {
            return !!t13[e18];
          }(e17, r12) || (o12.variableValidator ? o12.variableValidator(e17) : { code: 0, level: "warning" });
        };
        var u11 = o12.severity || "error";
        var d11 = [];
        var p11 = 0;
        for (var m11 = 0; m11 < e16.length; m11++) {
          var h11 = e16[m11];
          var f11 = e16[m11 + 1];
          var g11 = e16[m11 - 1];
          if (0 !== m11 || "operator" !== h11.type || "=" !== h11.value) {
            if ("left_bracket" === h11.type && (p11++, g11 && "right_bracket" === g11.type)) return d11.push(s11(h11)), d11;
            if ("right_bracket" === h11.type && --p11 < 0) return d11.push(s11(h11)), d11;
            if ("separator" === h11.type) {
              if (!f11 || 0 === p11) return d11.push(s11(h11)), d11;
              if ("separator" === f11.type || "right_bracket" === f11.type) return d11.push(s11(f11)), d11;
            }
            if ("function" === h11.type) {
              if (!f11) return d11.push(s11(h11)), d11;
              if ("left_bracket" !== f11.type && "separator" !== f11.type) return d11.push(s11(f11)), d11;
              if ("." === h11.value[0] || t12[h11.value.toLowerCase()] || "error" !== u11 && d11.push(a11(h11)), "." === h11.value[0]) {
                if (!g11) return d11.push(s11(h11)), d11;
                if ("left_bracket" === g11.type || "operator" === g11.type || "separator" === g11.type) return d11.push(s11(g11)), d11;
                t12[h11.value.toLowerCase()] || l11(h11, g11, n12) || "error" !== u11 && d11.push(a11(h11));
              }
            }
            if ("operator" === h11.type) {
              if (!f11) return d11.push(s11(h11)), d11;
              if ("right_bracket" === f11.type || "separator" === f11.type) return d11.push(s11(f11)), d11;
              if ("operator" === f11.type && "+" !== f11.value && "-" !== f11.value && "not" !== f11.value.toLowerCase()) return d11.push(s11(f11)), d11;
            }
            if ("variable" === h11.type && "error" !== u11) {
              var y10 = c12(h11.value);
              true !== y10 && d11.push(i11(h11, y10));
            }
            if (f11 && ("value" === h11.type || "constant" === h11.type || "variable" === h11.type) && "operator" !== f11.type && "separator" !== f11.type && "right_bracket" !== f11.type) {
              if ("function" === f11.type && "." === f11.value[0]) continue;
              return d11.push(s11(f11)), d11;
            }
          }
        }
        return 0 !== p11 ? (d11.push(s11(e16[e16.length - 1])), d11) : d11;
      }
      return Rl.validateExpression = function(a12, i12) {
        void 0 === i12 && (i12 = {});
        var s12 = i12.customFunctions || [];
        var l12 = o11.mapKeys(e15.__assign(e15.__assign({}, r11.predefinedFunctions), s12.reduce(function(e16, t12) {
          return e16[t12] = t12, e16;
        }, {})), function(e16) {
          return e16.toLowerCase();
        });
        var u11 = o11.mapKeys(r11.predefinedConstants, function(e16) {
          return e16.toLowerCase();
        });
        var d11 = o11.mapKeys(r11.predefinedVariables, function(e16) {
          return e16.toLowerCase();
        });
        var p11 = t11.tokenize(a12).map(function(e16, t12, r12) {
          return n11.makeToken(e16, r12[t12 + 1], l12, u11, d11);
        });
        return c11(p11, l12, u11, d11, i12);
      }, Rl.validateExpressionInternal = c11, Rl;
    }();
    Object.defineProperty(e14, "validateExpression", { enumerable: true, get: function() {
      return p10.validateExpression;
    } });
    var m10 = Ps();
    Object.defineProperty(e14, "shouldTreatAsDate", { enumerable: true, get: function() {
      return m10.shouldTreatAsDate;
    } });
    var h10 = El();
    Object.defineProperty(e14, "CustomCodeInternal", { enumerable: true, get: function() {
      return h10.CustomCodeInternal;
    } });
    var f10 = { tokenize: n10.tokenize, mergeTokens: n10.mergeTokens, Variant: a10, replaceNode: r10.replaceNode, containsNode: r10.containsNode, getValueByKey: i10.getValueByKey };
    e14.Tools = f10;
    var g10 = { Data: {} };
    e14.Format = function(e15, t11, n11) {
      try {
        return c10.default(e15, t11, n11);
      } catch (e16) {
        return console.warn(e16.message), "ERROR!";
      }
    }, e14.createCompiler = function(e15, t11, n11) {
      var o11 = r10.createTreeBuilder(e15, t11, n11);
      return function(e16) {
        var t12 = o11(e16);
        return (n12 = t12).Contains(null, "variable") || n12.Contains(null, "function") ? function(e17) {
          return t12.Eval(e17);
        } : t12.Eval(g10);
        var n12;
      };
    };
  }(Re)), Re;
}
var zl = Bl();
const $l = ["-", "+", "not"];
const Wl = ["<", ">", "<=", ">=", "=", "<>", "is", "like"];
const jl = ["and", "andalso", "or", "orelse", "xor", "^", "*", "/", "\\", "mod", "+", "-", "&", "<<", ">>"];
const Zl = ["length", "value", "imagedata"];
const Gl = ["aggregateif", "cumulativetotal", "runningvalue", "crossAggregate"];
const Ul = { aggregateif: 3, avg: 1, count: 1, countdistinct: 1, countrows: 0, distinctsum: 2, first: 1, last: 1, median: 1, max: 1, min: 1, mode: 1, runningvalue: 2, stdev: 1, stdevp: 1, sum: 1, var: 1, varp: 1, level: 0, previous: 1, rownumber: 0, groupindex: 0 };
const ql = { isScopeNode: false };
const Yl = { constants: ["math", "convert", "information", "datetime", "string", "e", "pi", "nothing", "null", "vbcrlf"], variables: ["now", "timeofday", "today", "timestring", "datestring", "timer"], globals: ["ExecutionTime", "PageNumber", "TotalPages", "PageNM", "PageNumberInSection", "TotalPagesInSection", "PageNMSection", "PageNumberCumulative", "TotalPagesCumulative", "PageNMCumulative", "ReportName", "UserId", "UserLanguage"], globalCollectionNames: ["parameters", "globals", "reportitems", "fields", "chart"], globalNamespaces: ["usercontext", "user", "system", "microsoft", "theme", "code"] };
const Kl = zl.createTreeBuilder();
const Xl = zl.createTreeBuilderIS(Yl);
function Jl(e14, t10) {
  return t10.includes(e14);
}
const Ql = /^(Fields|Parameters|ReportItems|Globals|Theme\.Images)[.!]([^.!]+)(?:[.!](.*))?/i;
const ec = (e14, t10) => 0 === (e14 == null ? void 0 : e14.localeCompare(t10, void 0, { sensitivity: "base" }));
const tc = (e14, t10) => ({ type: "scope", name: e14, quote: t10 });
const nc = (e14) => ({ type: "const", value: e14 });
const rc = (e14) => ({ type: "variable", name: e14 });
const oc = (e14) => (t10, n10, r10) => {
  const { Token: o10, Children: a10 } = t10;
  if ("function" !== o10.type || o10.value !== e14 || 2 !== o10.arity) return null;
  const i10 = n10(a10[0]);
  if (null === i10) return null;
  const s10 = r10(a10[1]);
  return null === s10 ? null : [i10, s10];
};
const ac = oc(".item");
const ic = (e14) => {
  const t10 = e14.Token;
  return "variable" === t10.type ? t10.value : "value" === t10.type && "String" === t10.value.Type ? t10.value.Value : null;
};
const sc = (e14) => "value" === e14.Token.type && "String" === e14.Token.value.Type ? e14.Token.value.Value : null;
const lc = (e14) => {
  var _a2;
  return "value" === e14.Token.type && "String" === e14.Token.value.Type ? ((_a2 = e14.Token.raw) == null ? void 0 : _a2.token.replace(/^[.!]/, "")) || e14.Token.value.Value : null;
};
function cc(e14) {
  const t10 = function(e15) {
    const t11 = ac(e15, (e16) => uc(e16, dc, sc), sc);
    const n11 = null === t11 ? uc(e15, dc, sc) : null;
    if (null === t11 && null === n11) return null;
    const [[, r11], o11] = t11 != null ? t11 : [n11, null];
    return { type: "collectionitem", collection: "themeimages", itemName: r11, propertyName: o11 || "" };
  }(e14);
  if (null != t10) return t10;
  const n10 = ac(e14, (e15) => ac(e15, ic, sc), lc);
  const r10 = null == n10 ? ac(e14, ic, sc) : null;
  if (null == n10 && null == r10) return null;
  const [[o10, a10], i10] = n10 != null ? n10 : [r10, null];
  const s10 = o10.toLowerCase();
  const l10 = i10 == null ? void 0 : i10.toLowerCase();
  if ("fields" === s10 && "value" === l10) return { type: "field", fieldName: a10 };
  if ("parameters" === s10 && "value" === l10) return { type: "parameter", name: a10 };
  if ("reportitems" === s10 && "value" === l10) return { type: "reportitem", name: a10 };
  if ("globals" === s10 && null == l10) return { type: "global", name: a10 };
  switch (s10) {
    case "fields":
    case "parameters":
    case "reportitems":
    case "user":
    case "usercontext":
    case "globals":
      return { type: "collectionitem", collection: s10, itemName: a10, propertyName: i10 || "" };
    case "theme.images":
      return { type: "collectionitem", collection: "themeimages", itemName: a10, propertyName: i10 || "" };
  }
  return null;
}
const uc = oc(".images");
const dc = (e14) => {
  const { type: t10, value: n10 } = e14.Token;
  return "variable" === t10 && "theme" === n10 ? n10 : null;
};
function pc(e14, t10 = ql) {
  var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2, _o3, _p3, _q2;
  const n10 = e14.Token;
  switch (n10.type) {
    case "constant":
      return { type: "variable", name: (_b2 = (_a2 = n10.raw) == null ? void 0 : _a2.token) != null ? _b2 : n10.value };
    case "value": {
      const { value: e15 } = n10;
      if (t10.isScopeNode) return tc(((_c2 = e15.Value) == null ? void 0 : _c2.toString()) || "", true);
      switch (e15.Type) {
        case "String":
          return "now" === ((_d2 = n10.raw) == null ? void 0 : _d2.token.toLocaleLowerCase()) ? rc(e15.Value) : nc(e15.Value);
        case "Bool":
        case "Int32":
        case "Int64":
        case "UInt64":
        case "Decimal":
        case "Double":
        case "Float":
          return nc(e15.Value);
        default:
          return nc(((_e2 = e15.Value) == null ? void 0 : _e2.toString()) || "");
      }
    }
    case "variable":
      return function(e15, t11 = ql) {
        var _a3, _b3, _c3;
        if ("variable" === e15.type) {
          const n11 = ((_a3 = e15.raw) == null ? void 0 : _a3.token) || e15.value;
          const r10 = Ql.exec(n11);
          if (null != r10) {
            if (ec(r10[1], "fields") && ec(r10[3], "value") && t11.isScopeNode) return tc(r10[2], false);
            if (ec(r10[1], "fields") && ec(r10[3], "value")) return { type: "field", fieldName: r10[2] };
            if (ec(r10[1], "parameters") && ec(r10[3], "value")) return { type: "parameter", name: r10[2] };
            if (ec(r10[1], "reportitems")) {
              if (ec(r10[3], "value") || void 0 === r10[3]) return { type: "reportitem", name: r10[2] };
              throw new Error(`Unexpected property name "${r10[3]}" in the report items`);
            }
            if (ec(r10[1], "globals")) {
              if (void 0 === r10[3]) return { type: "global", name: r10[2] };
              throw new Error(`Unexpected property name "${r10[3]}" in the global variable.`);
            }
            if (ec(r10[1], "theme.images")) return { type: "collectionitem", collection: "themeimages", itemName: r10[2], propertyName: r10[3] };
            const e16 = r10[1].toLowerCase();
            if ("fields" === e16 || "parameters" === e16 || "globals" === e16 || "reportitems" === e16) return { type: "collectionitem", collection: e16, itemName: r10[2], propertyName: r10[3] };
          }
          return t11.isScopeNode ? tc(((_b3 = e15.raw) == null ? void 0 : _b3.token) || e15.value, false) : { type: "variable", name: ((_c3 = e15.raw) == null ? void 0 : _c3.token) || e15.value };
        }
        throw new Error("Invalid call, expected variable token");
      }(n10, t10);
    case "operator":
      return function(e15) {
        var _a3;
        const t11 = [];
        const n11 = e15.Token;
        const r10 = ((_a3 = n11.raw) == null ? void 0 : _a3.token) || n11.value;
        if ("operator" === n11.type) if (1 === n11.arity) {
          if (Jl(n11.value, $l)) return { type: "unary", op: r10, operand: pc(e15.Children[0]) };
        } else {
          if (2 === n11.arity && Jl(n11.value, Wl)) return { type: "binary", op: r10, leftOperand: pc(e15.Children[0]), rightOperand: pc(e15.Children[1]) };
          if (n11.arity > 1 && Jl(n11.value, jl)) return function e16(n12, r11) {
            const { Token: o10, Children: [a10, ...i10] } = r11;
            "operator" === o10.type && o10.arity > 1 && o10.value === n12 ? (e16(n12, a10), t11.push(...i10.map((e17) => pc(e17)))) : t11.push(pc(r11));
          }(n11.value, e15), { type: "infix", op: r10, operands: t11 };
        }
        throw new Error("Invalid call, expected binary expression");
      }(e14);
    case "function": {
      const t11 = cc(e14);
      if (null != t11) return t11;
      const r10 = (_g2 = (_f2 = n10.raw) == null ? void 0 : _f2.token) != null ? _g2 : n10.value;
      if ("function" === n10.type && ".item" === n10.value && 2 === e14.Children.length && "value" === e14.Children[1].Token.type && Zl.includes(`${e14.Children[1].Token.value.Value}`)) {
        return { type: "prop", thisArg: pc(e14.Children[0]), propName: r10.substr(1) };
      }
      if (r10.startsWith(".")) {
        if (0 === e14.Children.length) throw new Error(`Method ${r10} without arguments starts with "."`);
        const [t12, ...n11] = e14.Children.map((e15) => pc(e15));
        return { type: "method", thisArg: t12, methodName: r10.substr(1), args: n11 };
      }
      const o10 = (_h2 = Ul[r10.toLowerCase()]) != null ? _h2 : -1;
      if (Gl.includes(r10.toLowerCase()) && "variable" === ((_i2 = e14.Children[1]) == null ? void 0 : _i2.Token.type)) {
        const t12 = e14.Children[1].Token;
        let r11 = (_k2 = (_j2 = t12.raw) == null ? void 0 : _j2.token) != null ? _k2 : t12.value;
        const a10 = Ql.exec(r11);
        null != a10 && ec(a10[1], "fields") && ec(a10[3], "value") && (r11 = a10[2]);
        const i10 = [pc(e14.Children[0]), nc(r11), ...e14.Children.slice(2).map((e15, t13) => pc(e15, { isScopeNode: o10 === t13 + 2 }))];
        return { type: "fn", funcName: (_m2 = (_l2 = n10.raw) == null ? void 0 : _l2.token) != null ? _m2 : n10.value, args: i10 };
      }
      if (o10 > -1 && e14.Children[o10]) {
        const t12 = e14.Children.map((e15, t13) => pc(e15, { isScopeNode: o10 === t13 }));
        return { type: "fn", funcName: (_o3 = (_n2 = n10.raw) == null ? void 0 : _n2.token) != null ? _o3 : n10.value, args: t12 };
      }
      return { type: "fn", funcName: (_q2 = (_p3 = n10.raw) == null ? void 0 : _p3.token) != null ? _q2 : n10.value, args: e14.Children.map((e15) => pc(e15)) };
    }
  }
  throw new Error(`Unknown token ${JSON.stringify(n10)}`);
}
function mc(e14) {
  return "const" === e14.type && "string" == typeof e14.value ? { type: "literal", text: e14.value } : { type: "ex", expression: e14 };
}
function hc(e14) {
  try {
    return pc(Kl(e14));
  } catch (t10) {
    return { type: "invalid", text: e14, errors: [{ code: -4, message: t10.message, level: "error" }] };
  }
}
function fc(e14, t10, n10 = "string") {
  const r10 = "rdl" === e14 ? Kl : Xl;
  if (!(t10 == null ? void 0 : t10.startsWith("=")) && "rdl" === e14) return function(e15) {
    if (null === e15) return { type: "const", value: null };
    switch (n10) {
      case "boolean":
        return { type: "const", value: "true" === e15 };
      case "number":
        return { type: "const", value: +e15 };
      case "string":
        return { type: "const", value: e15 };
    }
    return { type: "const", value: e15 };
  }(t10);
  try {
    const e15 = pc(r10(t10));
    switch (e15.type) {
      case "field":
      case "const":
        return e15;
      case "infix":
        if ("&" === e15.op) return { type: "expression", text: "", pieces: e15.operands.map(mc) };
    }
    return { type: "expression", text: "", pieces: [{ type: "ex", expression: e15 }] };
  } catch (e15) {
    return { type: "invalid", text: t10, errors: [{ code: -4, message: e15.message, level: "error" }] };
  }
}
const gc = (e14, t10) => "const" !== fc(e14, t10).type;
/*!
 * XRegExp 3.1.1
 * <xregexp.com>
 * Steven Levithan (c) 2007-2016 MIT License
 */
var yc = "xregexp";
var vc = { astral: false, natives: false };
var bc = { exec: RegExp.prototype.exec, test: RegExp.prototype.test, match: String.prototype.match, replace: String.prototype.replace, split: String.prototype.split };
var Sc = {};
var Cc = {};
var xc = {};
var wc = [];
var Tc = "default";
var Ec = "class";
var Fc = { default: /\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9]\d*|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|\(\?(?:[:=!]|<[=!])|[?*+]\?|{\d+(?:,\d*)?}\??|[\s\S]/, class: /\\(?:[0-3][0-7]{0,2}|[4-7][0-7]?|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|[\s\S]/ };
var Mc = /\$(?:{([\w$]+)}|(\d\d?|[\s\S]))/g;
var kc = void 0 === bc.exec.call(/()??/, "")[1];
var Pc = void 0 !== /x/.flags;
var Nc = {}.toString;
function Dc(e14) {
  var t10 = true;
  try {
    new RegExp("", e14);
  } catch (e15) {
    t10 = false;
  }
  return t10 && "y" === e14 ? new RegExp("aa|.", "y").test("b") : t10;
}
var Lc = Dc("u");
var Hc = Dc("y");
var Ic = { g: true, i: true, m: true, u: Lc, y: Hc };
function _c(e14, t10, n10, r10, o10) {
  var a10;
  if (e14[yc] = { captureNames: t10 }, o10) return e14;
  if (e14.__proto__) e14.__proto__ = Kc.prototype;
  else for (a10 in Kc.prototype) e14[a10] = Kc.prototype[a10];
  return e14[yc].source = n10, e14[yc].flags = r10 ? r10.split("").sort().join("") : r10, e14;
}
function Vc(e14) {
  return bc.replace.call(e14, /([\s\S])(?=[\s\S]*\1)/g, "");
}
function Rc(e14, t10) {
  if (!Kc.isRegExp(e14)) throw new TypeError("Type RegExp expected");
  var n10 = e14[yc] || {}, r10 = function(e15) {
    return Pc ? e15.flags : bc.exec.call(/\/([a-z]*)$/i, RegExp.prototype.toString.call(e15))[1];
  }(e14), o10 = "", a10 = "", i10 = null, s10 = null;
  return (t10 = t10 || {}).removeG && (a10 += "g"), t10.removeY && (a10 += "y"), a10 && (r10 = bc.replace.call(r10, new RegExp("[" + a10 + "]+", "g"), "")), t10.addG && (o10 += "g"), t10.addY && (o10 += "y"), o10 && (r10 = Vc(r10 + o10)), t10.isInternalOnly || (void 0 !== n10.source && (i10 = n10.source), null != n10.flags && (s10 = o10 ? Vc(n10.flags + o10) : n10.flags)), e14 = _c(new RegExp(e14.source, r10), function(e15) {
    return !(!e15[yc] || !e15[yc].captureNames);
  }(e14) ? n10.captureNames.slice(0) : null, i10, s10, t10.isInternalOnly);
}
function Ac(e14) {
  return parseInt(e14, 16);
}
function Oc(e14) {
  return parseInt(e14, 10).toString(16);
}
function Bc(e14, t10) {
  var n10, r10 = e14.length;
  for (n10 = 0; n10 < r10; ++n10) if (e14[n10] === t10) return n10;
  return -1;
}
function zc(e14, t10) {
  return Nc.call(e14) === "[object " + t10 + "]";
}
function $c(e14, t10, n10) {
  return bc.test.call(n10.indexOf("x") > -1 ? /^(?:\s|#[^#\n]*|\(\?#[^)]*\))*(?:[?*+]|{\d+(?:,\d*)?})/ : /^(?:\(\?#[^)]*\))*(?:[?*+]|{\d+(?:,\d*)?})/, e14.slice(t10));
}
function Wc(e14) {
  for (; e14.length < 4; ) e14 = "0" + e14;
  return e14;
}
function jc(e14) {
  var t10 = {};
  return zc(e14, "String") ? (Kc.forEach(e14, /[^\s,]+/, function(e15) {
    t10[e15] = true;
  }), t10) : e14;
}
function Zc(e14) {
  if (!/^[\w$]$/.test(e14)) throw new Error("Flag must be a single character A-Za-z0-9_$");
  Ic[e14] = true;
}
function Gc(e14, t10, n10, r10, o10) {
  var a10, i10, s10 = wc.length, l10 = e14.charAt(n10), c10 = null;
  for (; s10--; ) if (!((i10 = wc[s10]).leadChar && i10.leadChar !== l10 || i10.scope !== r10 && "all" !== i10.scope || i10.flag && -1 === t10.indexOf(i10.flag)) && (a10 = Kc.exec(e14, i10.regex, n10, "sticky"))) {
    c10 = { matchLength: a10[0].length, output: i10.handler.call(o10, a10, r10, t10), reparse: i10.reparse };
    break;
  }
  return c10;
}
function Uc(e14) {
  vc.astral = e14;
}
function qc(e14) {
  RegExp.prototype.exec = (e14 ? Sc : bc).exec, RegExp.prototype.test = (e14 ? Sc : bc).test, String.prototype.match = (e14 ? Sc : bc).match, String.prototype.replace = (e14 ? Sc : bc).replace, String.prototype.split = (e14 ? Sc : bc).split, vc.natives = e14;
}
function Yc(e14) {
  if (null == e14) throw new TypeError("Cannot convert null or undefined to object");
  return e14;
}
function Kc(e14, t10) {
  if (Kc.isRegExp(e14)) {
    if (void 0 !== t10) throw new TypeError("Cannot supply flags when copying a RegExp");
    return Rc(e14);
  }
  if (e14 = void 0 === e14 ? "" : String(e14), t10 = void 0 === t10 ? "" : String(t10), Kc.isInstalled("astral") && -1 === t10.indexOf("A") && (t10 += "A"), xc[e14] || (xc[e14] = {}), !xc[e14][t10]) {
    var n10 = { hasNamedCapture: false, captureNames: [] };
    var r10 = Tc;
    var o10 = "";
    var a10 = 0;
    var i10;
    var s10 = function(e15, t11) {
      var n11;
      if (Vc(t11) !== t11) throw new SyntaxError("Invalid duplicate regex flag " + t11);
      for (e15 = bc.replace.call(e15, /^\(\?([\w$]+)\)/, function(e16, n12) {
        if (bc.test.call(/[gy]/, n12)) throw new SyntaxError("Cannot use flag g or y in mode modifier " + e16);
        return t11 = Vc(t11 + n12), "";
      }), n11 = 0; n11 < t11.length; ++n11) if (!Ic[t11.charAt(n11)]) throw new SyntaxError("Unknown regex flag " + t11.charAt(n11));
      return { pattern: e15, flags: t11 };
    }(e14, t10);
    var l10 = s10.pattern;
    var c10 = s10.flags;
    for (; a10 < l10.length; ) {
      do {
        (i10 = Gc(l10, c10, a10, r10, n10)) && i10.reparse && (l10 = l10.slice(0, a10) + i10.output + l10.slice(a10 + i10.matchLength));
      } while (i10 && i10.reparse);
      if (i10) o10 += i10.output, a10 += i10.matchLength || 1;
      else {
        var u10 = Kc.exec(l10, Fc[r10], a10, "sticky")[0];
        o10 += u10, a10 += u10.length, "[" === u10 && r10 === Tc ? r10 = Ec : "]" === u10 && r10 === Ec && (r10 = Tc);
      }
    }
    xc[e14][t10] = { pattern: bc.replace.call(o10, /(?:\(\?:\))+/g, "(?:)"), flags: bc.replace.call(c10, /[^gimuy]+/g, ""), captures: n10.hasNamedCapture ? n10.captureNames : null };
  }
  var d10 = xc[e14][t10];
  return _c(new RegExp(d10.pattern, d10.flags), d10.captures, e14, t10);
}
Kc.prototype = new RegExp(), Kc.version = "3.1.1", Kc._hasNativeFlag = Dc, Kc._dec = Ac, Kc._hex = Oc, Kc._pad4 = Wc, Kc.addToken = function(e14, t10, n10) {
  var r10, o10 = (n10 = n10 || {}).optionalFlags;
  if (n10.flag && Zc(n10.flag), o10) for (o10 = bc.split.call(o10, ""), r10 = 0; r10 < o10.length; ++r10) Zc(o10[r10]);
  wc.push({ regex: Rc(e14, { addG: true, addY: Hc, isInternalOnly: true }), handler: t10, scope: n10.scope || Tc, flag: n10.flag, reparse: n10.reparse, leadChar: n10.leadChar }), Kc.cache.flush("patterns");
}, Kc.cache = function(e14, t10) {
  return Cc[e14] || (Cc[e14] = {}), Cc[e14][t10] || (Cc[e14][t10] = Kc(e14, t10));
}, Kc.cache.flush = function(e14) {
  "patterns" === e14 ? xc = {} : Cc = {};
}, Kc.escape = function(e14) {
  return bc.replace.call(Yc(e14), /[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}, Kc.exec = function(e14, t10, n10, r10) {
  var o10, a10, i10, s10 = "g";
  return (o10 = Hc && !!(r10 || t10.sticky && false !== r10)) && (s10 += "y"), t10[yc] = t10[yc] || {}, (i10 = t10[yc][s10] || (t10[yc][s10] = Rc(t10, { addG: true, addY: o10, removeY: false === r10, isInternalOnly: true }))).lastIndex = n10 = n10 || 0, a10 = Sc.exec.call(i10, e14), r10 && a10 && a10.index !== n10 && (a10 = null), t10.global && (t10.lastIndex = a10 ? i10.lastIndex : 0), a10;
}, Kc.forEach = function(e14, t10, n10) {
  var r10, o10 = 0, a10 = -1;
  for (; r10 = Kc.exec(e14, t10, o10); ) n10(r10, ++a10, e14, t10), o10 = r10.index + (r10[0].length || 1);
}, Kc.globalize = function(e14) {
  return Rc(e14, { addG: true });
}, Kc.install = function(e14) {
  e14 = jc(e14), !vc.astral && e14.astral && Uc(true), !vc.natives && e14.natives && qc(true);
}, Kc.isInstalled = function(e14) {
  return !!vc[e14];
}, Kc.isRegExp = function(e14) {
  return "[object RegExp]" === Nc.call(e14);
}, Kc.match = function(e14, t10, n10) {
  var r10, o10, a10 = t10.global && "one" !== n10 || "all" === n10, i10 = (a10 ? "g" : "") + (t10.sticky ? "y" : "") || "noGY";
  return t10[yc] = t10[yc] || {}, o10 = t10[yc][i10] || (t10[yc][i10] = Rc(t10, { addG: !!a10, removeG: "one" === n10, isInternalOnly: true })), r10 = bc.match.call(Yc(e14), o10), t10.global && (t10.lastIndex = "one" === n10 && r10 ? r10.index + r10[0].length : 0), a10 ? r10 || [] : r10 && r10[0];
}, Kc.matchChain = function(e14, t10) {
  return function e15(n10, r10) {
    var o10 = t10[r10].regex ? t10[r10] : { regex: t10[r10] };
    var a10 = [];
    function i10(e16) {
      if (o10.backref) {
        if (!(e16.hasOwnProperty(o10.backref) || +o10.backref < e16.length)) throw new ReferenceError("Backreference to undefined group: " + o10.backref);
        a10.push(e16[o10.backref] || "");
      } else a10.push(e16[0]);
    }
    for (var s10 = 0; s10 < n10.length; ++s10) Kc.forEach(n10[s10], o10.regex, i10);
    return r10 !== t10.length - 1 && a10.length ? e15(a10, r10 + 1) : a10;
  }([e14], 0);
}, Kc.replace = function(e14, t10, n10, r10) {
  var o10, a10 = Kc.isRegExp(t10), i10 = t10.global && "one" !== r10 || "all" === r10, s10 = (i10 ? "g" : "") + (t10.sticky ? "y" : "") || "noGY", l10 = t10;
  return a10 ? (t10[yc] = t10[yc] || {}, l10 = t10[yc][s10] || (t10[yc][s10] = Rc(t10, { addG: !!i10, removeG: "one" === r10, isInternalOnly: true }))) : i10 && (l10 = new RegExp(Kc.escape(String(t10)), "g")), o10 = Sc.replace.call(Yc(e14), l10, n10), a10 && t10.global && (t10.lastIndex = 0), o10;
}, Kc.replaceEach = function(e14, t10) {
  var n10, r10;
  for (n10 = 0; n10 < t10.length; ++n10) r10 = t10[n10], e14 = Kc.replace(e14, r10[0], r10[1], r10[2]);
  return e14;
}, Kc.split = function(e14, t10, n10) {
  return Sc.split.call(Yc(e14), t10, n10);
}, Kc.test = function(e14, t10, n10, r10) {
  return !!Kc.exec(e14, t10, n10, r10);
}, Kc.uninstall = function(e14) {
  e14 = jc(e14), vc.astral && e14.astral && Uc(false), vc.natives && e14.natives && qc(false);
}, Kc.union = function(e14, t10) {
  var n10 = 0;
  var r10;
  var o10;
  function a10(e15, t11, a11) {
    var i11 = o10[n10 - r10];
    if (t11) {
      if (++n10, i11) return "(?<" + i11 + ">";
    } else if (a11) return "\\" + (+a11 + r10);
    return e15;
  }
  if (!zc(e14, "Array") || !e14.length) throw new TypeError("Must provide a nonempty array of patterns to merge");
  var i10 = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*]/g;
  var s10 = [];
  var l10;
  for (var c10 = 0; c10 < e14.length; ++c10) l10 = e14[c10], Kc.isRegExp(l10) ? (r10 = n10, o10 = l10[yc] && l10[yc].captureNames || [], s10.push(bc.replace.call(Kc(l10.source).source, i10, a10))) : s10.push(Kc.escape(l10));
  return Kc(s10.join("|"), t10);
}, Sc.exec = function(e14) {
  var t10, n10, r10, o10 = this.lastIndex, a10 = bc.exec.apply(this, arguments);
  if (a10) {
    if (!kc && a10.length > 1 && Bc(a10, "") > -1 && (n10 = Rc(this, { removeG: true, isInternalOnly: true }), bc.replace.call(String(e14).slice(a10.index), n10, function() {
      var e15, t11 = arguments.length;
      for (e15 = 1; e15 < t11 - 2; ++e15) void 0 === arguments[e15] && (a10[e15] = void 0);
    })), this[yc] && this[yc].captureNames) for (r10 = 1; r10 < a10.length; ++r10) (t10 = this[yc].captureNames[r10 - 1]) && (a10[t10] = a10[r10]);
    this.global && !a10[0].length && this.lastIndex > a10.index && (this.lastIndex = a10.index);
  }
  return this.global || (this.lastIndex = o10), a10;
}, Sc.test = function(e14) {
  return !!Sc.exec.call(this, e14);
}, Sc.match = function(e14) {
  var t10;
  if (Kc.isRegExp(e14)) {
    if (e14.global) return t10 = bc.match.apply(this, arguments), e14.lastIndex = 0, t10;
  } else e14 = new RegExp(e14);
  return Sc.exec.call(e14, Yc(this));
}, Sc.replace = function(e14, t10) {
  var n10, r10, o10, a10 = Kc.isRegExp(e14);
  return a10 ? (e14[yc] && (r10 = e14[yc].captureNames), n10 = e14.lastIndex) : e14 += "", o10 = zc(t10, "Function") ? bc.replace.call(String(this), e14, function() {
    var n11, o11 = arguments;
    if (r10) for (o11[0] = new String(o11[0]), n11 = 0; n11 < r10.length; ++n11) r10[n11] && (o11[0][r10[n11]] = o11[n11 + 1]);
    return a10 && e14.global && (e14.lastIndex = o11[o11.length - 2] + o11[0].length), t10.apply(void 0, o11);
  }) : bc.replace.call(null == this ? this : String(this), e14, function() {
    var e15 = arguments;
    return bc.replace.call(String(t10), Mc, function(t11, n11, o11) {
      var a11;
      if (n11) {
        if ((a11 = +n11) <= e15.length - 3) return e15[a11] || "";
        if ((a11 = r10 ? Bc(r10, n11) : -1) < 0) throw new SyntaxError("Backreference to undefined group " + t11);
        return e15[a11 + 1] || "";
      }
      if ("$" === o11) return "$";
      if ("&" === o11 || 0 == +o11) return e15[0];
      if ("`" === o11) return e15[e15.length - 1].slice(0, e15[e15.length - 2]);
      if ("'" === o11) return e15[e15.length - 1].slice(e15[e15.length - 2] + e15[0].length);
      if (o11 = +o11, !isNaN(o11)) {
        if (o11 > e15.length - 3) throw new SyntaxError("Backreference to undefined group " + t11);
        return e15[o11] || "";
      }
      throw new SyntaxError("Invalid token " + t11);
    });
  }), a10 && (e14.global ? e14.lastIndex = 0 : e14.lastIndex = n10), o10;
}, Sc.split = function(e14, t10) {
  if (!Kc.isRegExp(e14)) return bc.split.apply(this, arguments);
  var n10, r10 = String(this), o10 = [], a10 = e14.lastIndex, i10 = 0;
  return t10 = (void 0 === t10 ? -1 : t10) >>> 0, Kc.forEach(r10, e14, function(e15) {
    e15.index + e15[0].length > i10 && (o10.push(r10.slice(i10, e15.index)), e15.length > 1 && e15.index < r10.length && Array.prototype.push.apply(o10, e15.slice(1)), n10 = e15[0].length, i10 = e15.index + n10);
  }), i10 === r10.length ? bc.test.call(e14, "") && !n10 || o10.push("") : o10.push(r10.slice(i10)), e14.lastIndex = a10, o10.length > t10 ? o10.slice(0, t10) : o10;
}, Kc.addToken(/\\([ABCE-RTUVXYZaeg-mopqyz]|c(?![A-Za-z])|u(?![\dA-Fa-f]{4}|{[\dA-Fa-f]+})|x(?![\dA-Fa-f]{2}))/, function(e14, t10) {
  if ("B" === e14[1] && t10 === Tc) return e14[0];
  throw new SyntaxError("Invalid escape " + e14[0]);
}, { scope: "all", leadChar: "\\" }), Kc.addToken(/\\u{([\dA-Fa-f]+)}/, function(e14, t10, n10) {
  var r10 = Ac(e14[1]);
  if (r10 > 1114111) throw new SyntaxError("Invalid Unicode code point " + e14[0]);
  if (r10 <= 65535) return "\\u" + Wc(Oc(r10));
  if (Lc && n10.indexOf("u") > -1) return e14[0];
  throw new SyntaxError("Cannot use Unicode code point above \\u{FFFF} without flag u");
}, { scope: "all", leadChar: "\\" }), Kc.addToken(/\[(\^?)]/, function(e14) {
  return e14[1] ? "[\\s\\S]" : "\\b\\B";
}, { leadChar: "[" }), Kc.addToken(/\(\?#[^)]*\)/, function(e14, t10, n10) {
  return $c(e14.input, e14.index + e14[0].length, n10) ? "" : "(?:)";
}, { leadChar: "(" }), Kc.addToken(/\s+|#[^\n]*\n?/, function(e14, t10, n10) {
  return $c(e14.input, e14.index + e14[0].length, n10) ? "" : "(?:)";
}, { flag: "x" }), Kc.addToken(/\./, function() {
  return "[\\s\\S]";
}, { flag: "s", leadChar: "." }), Kc.addToken(/\\k<([\w$]+)>/, function(e14) {
  var t10 = isNaN(e14[1]) ? Bc(this.captureNames, e14[1]) + 1 : +e14[1], n10 = e14.index + e14[0].length;
  if (!t10 || t10 > this.captureNames.length) throw new SyntaxError("Backreference to undefined group " + e14[0]);
  return "\\" + t10 + (n10 === e14.input.length || isNaN(e14.input.charAt(n10)) ? "" : "(?:)");
}, { leadChar: "\\" }), Kc.addToken(/\\(\d+)/, function(e14, t10) {
  if (!(t10 === Tc && /^[1-9]/.test(e14[1]) && +e14[1] <= this.captureNames.length) && "0" !== e14[1]) throw new SyntaxError("Cannot use octal escape or backreference to undefined group " + e14[0]);
  return e14[0];
}, { scope: "all", leadChar: "\\" }), Kc.addToken(/\(\?P?<([\w$]+)>/, function(e14) {
  if (!isNaN(e14[1])) throw new SyntaxError("Cannot use integer as capture name " + e14[0]);
  if ("length" === e14[1] || "__proto__" === e14[1]) throw new SyntaxError("Cannot use reserved word as capture name " + e14[0]);
  if (Bc(this.captureNames, e14[1]) > -1) throw new SyntaxError("Cannot use same name for multiple groups " + e14[0]);
  return this.captureNames.push(e14[1]), this.hasNamedCapture = true, "(";
}, { leadChar: "(" }), Kc.addToken(/\((?!\?)/, function(e14, t10, n10) {
  return n10.indexOf("n") > -1 ? "(?:" : (this.captureNames.push(null), "(");
}, { optionalFlags: "n", leadChar: "(" });
var Xc = Kc;
!function(e14) {
  var t10 = "xregexp";
  var n10 = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*]/g;
  var r10 = e14.union([/\({{([\w$]+)}}\)|{{([\w$]+)}}/, n10], "g");
  function o10(e15) {
    var t11 = /^(?:\(\?:\))*\^/, n11 = /\$(?:\(\?:\))*$/;
    return t11.test(e15) && n11.test(e15) && n11.test(e15.replace(/\\[\s\S]/g, "")) ? e15.replace(t11, "").replace(n11, "") : e15;
  }
  function a10(n11) {
    return e14.isRegExp(n11) ? n11[t10] && n11[t10].captureNames ? n11 : e14(n11.source) : e14(n11);
  }
  e14.build = function(i10, s10, l10) {
    var c10, u10, d10, p10, m10 = /^\(\?([\w$]+)\)/.exec(i10), h10 = {}, f10 = 0, g10 = 0, y10 = [0];
    for (p10 in m10 && (l10 = l10 || "", m10[1].replace(/./g, function(e15) {
      l10 += l10.indexOf(e15) > -1 ? "" : e15;
    })), s10) s10.hasOwnProperty(p10) && (d10 = a10(s10[p10]), h10[p10] = { pattern: o10(d10.source), names: d10[t10].captureNames || [] });
    return i10 = a10(i10), u10 = i10[t10].captureNames || [], i10 = i10.source.replace(r10, function(e15, t11, r11, o11, a11) {
      var i11, s11, l11, d11 = t11 || r11;
      if (d11) {
        if (!h10.hasOwnProperty(d11)) throw new ReferenceError("Undefined property " + e15);
        return t11 ? (i11 = u10[g10], y10[++g10] = ++f10, s11 = "(?<" + (i11 || d11) + ">") : s11 = "(?:", c10 = f10, s11 + h10[d11].pattern.replace(n10, function(e16, t12, n11) {
          if (t12) {
            if (i11 = h10[d11].names[f10 - c10], ++f10, i11) return "(?<" + i11 + ">";
          } else if (n11) return l11 = +n11 - 1, h10[d11].names[l11] ? "\\k<" + h10[d11].names[l11] + ">" : "\\" + (+n11 + c10);
          return e16;
        }) + ")";
      }
      if (o11) {
        if (i11 = u10[g10], y10[++g10] = ++f10, i11) return "(?<" + i11 + ">";
      } else if (a11) return u10[l11 = +a11 - 1] ? "\\k<" + u10[l11] + ">" : "\\" + y10[+a11];
      return e15;
    }), e14(i10, l10);
  };
}(Xc), function(e14) {
  function t10(e15, t11, n10, r10) {
    return { name: e15, value: t11, start: n10, end: r10 };
  }
  e14.matchRecursive = function(n10, r10, o10, a10, i10) {
    i10 = i10 || {};
    var s10, l10, c10, u10, d10, p10 = (a10 = a10 || "").indexOf("g") > -1, m10 = a10.indexOf("y") > -1, h10 = a10.replace(/y/g, ""), f10 = i10.escapeChar, g10 = i10.valueNames, y10 = [], v10 = 0, b10 = 0, S10 = 0, C10 = 0;
    if (r10 = e14(r10, h10), o10 = e14(o10, h10), f10) {
      if (f10.length > 1) throw new Error("Cannot use more than one escape character");
      f10 = e14.escape(f10), d10 = new RegExp("(?:" + f10 + "[\\S\\s]|(?:(?!" + e14.union([r10, o10]).source + ")[^" + f10 + "])+)+", a10.replace(/[^imu]+/g, ""));
    }
    for (; ; ) {
      if (f10 && (S10 += (e14.exec(n10, d10, S10, "sticky") || [""])[0].length), c10 = e14.exec(n10, r10, S10), u10 = e14.exec(n10, o10, S10), c10 && u10 && (c10.index <= u10.index ? u10 = null : c10 = null), c10 || u10) S10 = (b10 = (c10 || u10).index) + (c10 || u10)[0].length;
      else if (!v10) break;
      if (m10 && !v10 && b10 > C10) break;
      if (c10) v10 || (s10 = b10, l10 = S10), ++v10;
      else {
        if (!u10 || !v10) throw new Error("Unbalanced delimiter found in string");
        if (!--v10 && (g10 ? (g10[0] && s10 > C10 && y10.push(t10(g10[0], n10.slice(C10, s10), C10, s10)), g10[1] && y10.push(t10(g10[1], n10.slice(s10, l10), s10, l10)), g10[2] && y10.push(t10(g10[2], n10.slice(l10, b10), l10, b10)), g10[3] && y10.push(t10(g10[3], n10.slice(b10, S10), b10, S10))) : y10.push(n10.slice(l10, b10)), C10 = S10, !p10)) break;
      }
      b10 === S10 && ++S10;
    }
    return p10 && !m10 && g10 && g10[0] && n10.length > C10 && y10.push(t10(g10[0], n10.slice(C10), C10, n10.length)), y10;
  };
}(Xc), function(e14) {
  var t10 = {};
  var n10 = e14._dec;
  var r10 = e14._hex;
  var o10 = e14._pad4;
  function a10(e15) {
    return e15.replace(/[- _]+/g, "").toLowerCase();
  }
  function i10(e15) {
    var t11 = /^\\[xu](.+)/.exec(e15);
    return t11 ? n10(t11[1]) : e15.charCodeAt("\\" === e15.charAt(0) ? 1 : 0);
  }
  function s10(n11) {
    return t10[n11]["b!"] || (t10[n11]["b!"] = (a11 = t10[n11].bmp, s11 = "", l11 = -1, e14.forEach(a11, /(\\x..|\\u....|\\?[\s\S])(?:-(\\x..|\\u....|\\?[\s\S]))?/, function(e15) {
      var t11 = i10(e15[1]);
      t11 > l11 + 1 && (s11 += "\\u" + o10(r10(l11 + 1)), t11 > l11 + 2 && (s11 += "-\\u" + o10(r10(t11 - 1)))), l11 = i10(e15[2] || e15[1]);
    }), l11 < 65535 && (s11 += "\\u" + o10(r10(l11 + 1)), l11 < 65534 && (s11 += "-\\uFFFF")), s11));
    var a11, s11, l11;
  }
  function l10(e15, n11) {
    var r11 = n11 ? "a!" : "a=";
    return t10[e15][r11] || (t10[e15][r11] = function(e16, n12) {
      var r12 = t10[e16], o11 = "";
      return r12.bmp && !r12.isBmpLast && (o11 = "[" + r12.bmp + "]" + (r12.astral ? "|" : "")), r12.astral && (o11 += r12.astral), r12.isBmpLast && r12.bmp && (o11 += (r12.astral ? "|" : "") + "[" + r12.bmp + "]"), n12 ? "(?:(?!" + o11 + ")(?:[\uD800-\uDBFF][\uDC00-\uDFFF]|[\0-\uFFFF]))" : "(?:" + o11 + ")";
    }(e15, n11));
  }
  e14.addToken(/\\([pP])(?:{(\^?)([^}]*)}|([A-Za-z]))/, function(e15, n11, r11) {
    var o11 = "P" === e15[1] || !!e15[2], i11 = r11.indexOf("A") > -1, c10 = a10(e15[4] || e15[3]), u10 = t10[c10];
    if ("P" === e15[1] && e15[2]) throw new SyntaxError("Invalid double negation " + e15[0]);
    if (!t10.hasOwnProperty(c10)) throw new SyntaxError("Unknown Unicode token " + e15[0]);
    if (u10.inverseOf) {
      if (c10 = a10(u10.inverseOf), !t10.hasOwnProperty(c10)) throw new ReferenceError("Unicode token missing data " + e15[0] + " -> " + u10.inverseOf);
      u10 = t10[c10], o11 = !o11;
    }
    if (!u10.bmp && !i11) throw new SyntaxError("Astral mode required for Unicode token " + e15[0]);
    if (i11) {
      if ("class" === n11) throw new SyntaxError("Astral mode does not support Unicode tokens within character classes");
      return l10(c10, o11);
    }
    return "class" === n11 ? o11 ? s10(c10) : u10.bmp : (o11 ? "[^" : "[") + u10.bmp + "]";
  }, { scope: "all", optionalFlags: "A", leadChar: "\\" }), e14.addUnicodeData = function(n11) {
    var r11, o11;
    for (o11 = 0; o11 < n11.length; ++o11) {
      if (!(r11 = n11[o11]).name) throw new Error("Unicode token requires name");
      if (!(r11.inverseOf || r11.bmp || r11.astral)) throw new Error("Unicode token has no character data " + r11.name);
      t10[a10(r11.name)] = r11, r11.alias && (t10[a10(r11.alias)] = r11);
    }
    e14.cache.flush("patterns");
  };
}(Xc), function(e14) {
  if (!e14.addUnicodeData) throw new ReferenceError("Unicode Base must be loaded before Unicode Blocks");
  e14.addUnicodeData([{ name: "InAegean_Numbers", astral: "\uD800[\uDD00-\uDD3F]" }, { name: "InAhom", astral: "\uD805[\uDF00-\uDF3F]" }, { name: "InAlchemical_Symbols", astral: "\uD83D[\uDF00-\uDF7F]" }, { name: "InAlphabetic_Presentation_Forms", bmp: "\uFB00-\uFB4F" }, { name: "InAnatolian_Hieroglyphs", astral: "\uD811[\uDC00-\uDE7F]" }, { name: "InAncient_Greek_Musical_Notation", astral: "\uD834[\uDE00-\uDE4F]" }, { name: "InAncient_Greek_Numbers", astral: "\uD800[\uDD40-\uDD8F]" }, { name: "InAncient_Symbols", astral: "\uD800[\uDD90-\uDDCF]" }, { name: "InArabic", bmp: "\u0600-\u06FF" }, { name: "InArabic_Extended_A", bmp: "\u08A0-\u08FF" }, { name: "InArabic_Mathematical_Alphabetic_Symbols", astral: "\uD83B[\uDE00-\uDEFF]" }, { name: "InArabic_Presentation_Forms_A", bmp: "\uFB50-\uFDFF" }, { name: "InArabic_Presentation_Forms_B", bmp: "\uFE70-\uFEFF" }, { name: "InArabic_Supplement", bmp: "\u0750-\u077F" }, { name: "InArmenian", bmp: "\u0530-\u058F" }, { name: "InArrows", bmp: "\u2190-\u21FF" }, { name: "InAvestan", astral: "\uD802[\uDF00-\uDF3F]" }, { name: "InBalinese", bmp: "\u1B00-\u1B7F" }, { name: "InBamum", bmp: "\uA6A0-\uA6FF" }, { name: "InBamum_Supplement", astral: "\uD81A[\uDC00-\uDE3F]" }, { name: "InBasic_Latin", bmp: "\0-\x7F" }, { name: "InBassa_Vah", astral: "\uD81A[\uDED0-\uDEFF]" }, { name: "InBatak", bmp: "\u1BC0-\u1BFF" }, { name: "InBengali", bmp: "\u0980-\u09FF" }, { name: "InBlock_Elements", bmp: "\u2580-\u259F" }, { name: "InBopomofo", bmp: "\u3100-\u312F" }, { name: "InBopomofo_Extended", bmp: "\u31A0-\u31BF" }, { name: "InBox_Drawing", bmp: "\u2500-\u257F" }, { name: "InBrahmi", astral: "\uD804[\uDC00-\uDC7F]" }, { name: "InBraille_Patterns", bmp: "\u2800-\u28FF" }, { name: "InBuginese", bmp: "\u1A00-\u1A1F" }, { name: "InBuhid", bmp: "\u1740-\u175F" }, { name: "InByzantine_Musical_Symbols", astral: "\uD834[\uDC00-\uDCFF]" }, { name: "InCJK_Compatibility", bmp: "\u3300-\u33FF" }, { name: "InCJK_Compatibility_Forms", bmp: "\uFE30-\uFE4F" }, { name: "InCJK_Compatibility_Ideographs", bmp: "\uF900-\uFAFF" }, { name: "InCJK_Compatibility_Ideographs_Supplement", astral: "\uD87E[\uDC00-\uDE1F]" }, { name: "InCJK_Radicals_Supplement", bmp: "\u2E80-\u2EFF" }, { name: "InCJK_Strokes", bmp: "\u31C0-\u31EF" }, { name: "InCJK_Symbols_and_Punctuation", bmp: "\u3000-\u303F" }, { name: "InCJK_Unified_Ideographs", bmp: "\u4E00-\u9FFF" }, { name: "InCJK_Unified_Ideographs_Extension_A", bmp: "\u3400-\u4DBF" }, { name: "InCJK_Unified_Ideographs_Extension_B", astral: "[\uD840-\uD868][\uDC00-\uDFFF]|\uD869[\uDC00-\uDEDF]" }, { name: "InCJK_Unified_Ideographs_Extension_C", astral: "\uD86D[\uDC00-\uDF3F]|[\uD86A-\uD86C][\uDC00-\uDFFF]|\uD869[\uDF00-\uDFFF]" }, { name: "InCJK_Unified_Ideographs_Extension_D", astral: "\uD86D[\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1F]" }, { name: "InCJK_Unified_Ideographs_Extension_E", astral: "[\uD86F-\uD872][\uDC00-\uDFFF]|\uD873[\uDC00-\uDEAF]|\uD86E[\uDC20-\uDFFF]" }, { name: "InCarian", astral: "\uD800[\uDEA0-\uDEDF]" }, { name: "InCaucasian_Albanian", astral: "\uD801[\uDD30-\uDD6F]" }, { name: "InChakma", astral: "\uD804[\uDD00-\uDD4F]" }, { name: "InCham", bmp: "\uAA00-\uAA5F" }, { name: "InCherokee", bmp: "\u13A0-\u13FF" }, { name: "InCherokee_Supplement", bmp: "\uAB70-\uABBF" }, { name: "InCombining_Diacritical_Marks", bmp: "\u0300-\u036F" }, { name: "InCombining_Diacritical_Marks_Extended", bmp: "\u1AB0-\u1AFF" }, { name: "InCombining_Diacritical_Marks_Supplement", bmp: "\u1DC0-\u1DFF" }, { name: "InCombining_Diacritical_Marks_for_Symbols", bmp: "\u20D0-\u20FF" }, { name: "InCombining_Half_Marks", bmp: "\uFE20-\uFE2F" }, { name: "InCommon_Indic_Number_Forms", bmp: "\uA830-\uA83F" }, { name: "InControl_Pictures", bmp: "\u2400-\u243F" }, { name: "InCoptic", bmp: "\u2C80-\u2CFF" }, { name: "InCoptic_Epact_Numbers", astral: "\uD800[\uDEE0-\uDEFF]" }, { name: "InCounting_Rod_Numerals", astral: "\uD834[\uDF60-\uDF7F]" }, { name: "InCuneiform", astral: "\uD808[\uDC00-\uDFFF]" }, { name: "InCuneiform_Numbers_and_Punctuation", astral: "\uD809[\uDC00-\uDC7F]" }, { name: "InCurrency_Symbols", bmp: "\u20A0-\u20CF" }, { name: "InCypriot_Syllabary", astral: "\uD802[\uDC00-\uDC3F]" }, { name: "InCyrillic", bmp: "\u0400-\u04FF" }, { name: "InCyrillic_Extended_A", bmp: "\u2DE0-\u2DFF" }, { name: "InCyrillic_Extended_B", bmp: "\uA640-\uA69F" }, { name: "InCyrillic_Supplement", bmp: "\u0500-\u052F" }, { name: "InDeseret", astral: "\uD801[\uDC00-\uDC4F]" }, { name: "InDevanagari", bmp: "\u0900-\u097F" }, { name: "InDevanagari_Extended", bmp: "\uA8E0-\uA8FF" }, { name: "InDingbats", bmp: "\u2700-\u27BF" }, { name: "InDomino_Tiles", astral: "\uD83C[\uDC30-\uDC9F]" }, { name: "InDuployan", astral: "\uD82F[\uDC00-\uDC9F]" }, { name: "InEarly_Dynastic_Cuneiform", astral: "\uD809[\uDC80-\uDD4F]" }, { name: "InEgyptian_Hieroglyphs", astral: "\uD80C[\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F]" }, { name: "InElbasan", astral: "\uD801[\uDD00-\uDD2F]" }, { name: "InEmoticons", astral: "\uD83D[\uDE00-\uDE4F]" }, { name: "InEnclosed_Alphanumeric_Supplement", astral: "\uD83C[\uDD00-\uDDFF]" }, { name: "InEnclosed_Alphanumerics", bmp: "\u2460-\u24FF" }, { name: "InEnclosed_CJK_Letters_and_Months", bmp: "\u3200-\u32FF" }, { name: "InEnclosed_Ideographic_Supplement", astral: "\uD83C[\uDE00-\uDEFF]" }, { name: "InEthiopic", bmp: "\u1200-\u137F" }, { name: "InEthiopic_Extended", bmp: "\u2D80-\u2DDF" }, { name: "InEthiopic_Extended_A", bmp: "\uAB00-\uAB2F" }, { name: "InEthiopic_Supplement", bmp: "\u1380-\u139F" }, { name: "InGeneral_Punctuation", bmp: "\u2000-\u206F" }, { name: "InGeometric_Shapes", bmp: "\u25A0-\u25FF" }, { name: "InGeometric_Shapes_Extended", astral: "\uD83D[\uDF80-\uDFFF]" }, { name: "InGeorgian", bmp: "\u10A0-\u10FF" }, { name: "InGeorgian_Supplement", bmp: "\u2D00-\u2D2F" }, { name: "InGlagolitic", bmp: "\u2C00-\u2C5F" }, { name: "InGothic", astral: "\uD800[\uDF30-\uDF4F]" }, { name: "InGrantha", astral: "\uD804[\uDF00-\uDF7F]" }, { name: "InGreek_Extended", bmp: "\u1F00-\u1FFF" }, { name: "InGreek_and_Coptic", bmp: "\u0370-\u03FF" }, { name: "InGujarati", bmp: "\u0A80-\u0AFF" }, { name: "InGurmukhi", bmp: "\u0A00-\u0A7F" }, { name: "InHalfwidth_and_Fullwidth_Forms", bmp: "\uFF00-\uFFEF" }, { name: "InHangul_Compatibility_Jamo", bmp: "\u3130-\u318F" }, { name: "InHangul_Jamo", bmp: "\u1100-\u11FF" }, { name: "InHangul_Jamo_Extended_A", bmp: "\uA960-\uA97F" }, { name: "InHangul_Jamo_Extended_B", bmp: "\uD7B0-\uD7FF" }, { name: "InHangul_Syllables", bmp: "\uAC00-\uD7AF" }, { name: "InHanunoo", bmp: "\u1720-\u173F" }, { name: "InHatran", astral: "\uD802[\uDCE0-\uDCFF]" }, { name: "InHebrew", bmp: "\u0590-\u05FF" }, { name: "InHigh_Private_Use_Surrogates", bmp: "\uDB80-\uDBFF" }, { name: "InHigh_Surrogates", bmp: "\uD800-\uDB7F" }, { name: "InHiragana", bmp: "\u3040-\u309F" }, { name: "InIPA_Extensions", bmp: "\u0250-\u02AF" }, { name: "InIdeographic_Description_Characters", bmp: "\u2FF0-\u2FFF" }, { name: "InImperial_Aramaic", astral: "\uD802[\uDC40-\uDC5F]" }, { name: "InInscriptional_Pahlavi", astral: "\uD802[\uDF60-\uDF7F]" }, { name: "InInscriptional_Parthian", astral: "\uD802[\uDF40-\uDF5F]" }, { name: "InJavanese", bmp: "\uA980-\uA9DF" }, { name: "InKaithi", astral: "\uD804[\uDC80-\uDCCF]" }, { name: "InKana_Supplement", astral: "\uD82C[\uDC00-\uDCFF]" }, { name: "InKanbun", bmp: "\u3190-\u319F" }, { name: "InKangxi_Radicals", bmp: "\u2F00-\u2FDF" }, { name: "InKannada", bmp: "\u0C80-\u0CFF" }, { name: "InKatakana", bmp: "\u30A0-\u30FF" }, { name: "InKatakana_Phonetic_Extensions", bmp: "\u31F0-\u31FF" }, { name: "InKayah_Li", bmp: "\uA900-\uA92F" }, { name: "InKharoshthi", astral: "\uD802[\uDE00-\uDE5F]" }, { name: "InKhmer", bmp: "\u1780-\u17FF" }, { name: "InKhmer_Symbols", bmp: "\u19E0-\u19FF" }, { name: "InKhojki", astral: "\uD804[\uDE00-\uDE4F]" }, { name: "InKhudawadi", astral: "\uD804[\uDEB0-\uDEFF]" }, { name: "InLao", bmp: "\u0E80-\u0EFF" }, { name: "InLatin_Extended_Additional", bmp: "\u1E00-\u1EFF" }, { name: "InLatin_Extended_A", bmp: "\u0100-\u017F" }, { name: "InLatin_Extended_B", bmp: "\u0180-\u024F" }, { name: "InLatin_Extended_C", bmp: "\u2C60-\u2C7F" }, { name: "InLatin_Extended_D", bmp: "\uA720-\uA7FF" }, { name: "InLatin_Extended_E", bmp: "\uAB30-\uAB6F" }, { name: "InLatin_1_Supplement", bmp: "\x80-\xFF" }, { name: "InLepcha", bmp: "\u1C00-\u1C4F" }, { name: "InLetterlike_Symbols", bmp: "\u2100-\u214F" }, { name: "InLimbu", bmp: "\u1900-\u194F" }, { name: "InLinear_A", astral: "\uD801[\uDE00-\uDF7F]" }, { name: "InLinear_B_Ideograms", astral: "\uD800[\uDC80-\uDCFF]" }, { name: "InLinear_B_Syllabary", astral: "\uD800[\uDC00-\uDC7F]" }, { name: "InLisu", bmp: "\uA4D0-\uA4FF" }, { name: "InLow_Surrogates", bmp: "\uDC00-\uDFFF" }, { name: "InLycian", astral: "\uD800[\uDE80-\uDE9F]" }, { name: "InLydian", astral: "\uD802[\uDD20-\uDD3F]" }, { name: "InMahajani", astral: "\uD804[\uDD50-\uDD7F]" }, { name: "InMahjong_Tiles", astral: "\uD83C[\uDC00-\uDC2F]" }, { name: "InMalayalam", bmp: "\u0D00-\u0D7F" }, { name: "InMandaic", bmp: "\u0840-\u085F" }, { name: "InManichaean", astral: "\uD802[\uDEC0-\uDEFF]" }, { name: "InMathematical_Alphanumeric_Symbols", astral: "\uD835[\uDC00-\uDFFF]" }, { name: "InMathematical_Operators", bmp: "\u2200-\u22FF" }, { name: "InMeetei_Mayek", bmp: "\uABC0-\uABFF" }, { name: "InMeetei_Mayek_Extensions", bmp: "\uAAE0-\uAAFF" }, { name: "InMende_Kikakui", astral: "\uD83A[\uDC00-\uDCDF]" }, { name: "InMeroitic_Cursive", astral: "\uD802[\uDDA0-\uDDFF]" }, { name: "InMeroitic_Hieroglyphs", astral: "\uD802[\uDD80-\uDD9F]" }, { name: "InMiao", astral: "\uD81B[\uDF00-\uDF9F]" }, { name: "InMiscellaneous_Mathematical_Symbols_A", bmp: "\u27C0-\u27EF" }, { name: "InMiscellaneous_Mathematical_Symbols_B", bmp: "\u2980-\u29FF" }, { name: "InMiscellaneous_Symbols", bmp: "\u2600-\u26FF" }, { name: "InMiscellaneous_Symbols_and_Arrows", bmp: "\u2B00-\u2BFF" }, { name: "InMiscellaneous_Symbols_and_Pictographs", astral: "\uD83D[\uDC00-\uDDFF]|\uD83C[\uDF00-\uDFFF]" }, { name: "InMiscellaneous_Technical", bmp: "\u2300-\u23FF" }, { name: "InModi", astral: "\uD805[\uDE00-\uDE5F]" }, { name: "InModifier_Tone_Letters", bmp: "\uA700-\uA71F" }, { name: "InMongolian", bmp: "\u1800-\u18AF" }, { name: "InMro", astral: "\uD81A[\uDE40-\uDE6F]" }, { name: "InMultani", astral: "\uD804[\uDE80-\uDEAF]" }, { name: "InMusical_Symbols", astral: "\uD834[\uDD00-\uDDFF]" }, { name: "InMyanmar", bmp: "\u1000-\u109F" }, { name: "InMyanmar_Extended_A", bmp: "\uAA60-\uAA7F" }, { name: "InMyanmar_Extended_B", bmp: "\uA9E0-\uA9FF" }, { name: "InNKo", bmp: "\u07C0-\u07FF" }, { name: "InNabataean", astral: "\uD802[\uDC80-\uDCAF]" }, { name: "InNew_Tai_Lue", bmp: "\u1980-\u19DF" }, { name: "InNumber_Forms", bmp: "\u2150-\u218F" }, { name: "InOgham", bmp: "\u1680-\u169F" }, { name: "InOl_Chiki", bmp: "\u1C50-\u1C7F" }, { name: "InOld_Hungarian", astral: "\uD803[\uDC80-\uDCFF]" }, { name: "InOld_Italic", astral: "\uD800[\uDF00-\uDF2F]" }, { name: "InOld_North_Arabian", astral: "\uD802[\uDE80-\uDE9F]" }, { name: "InOld_Permic", astral: "\uD800[\uDF50-\uDF7F]" }, { name: "InOld_Persian", astral: "\uD800[\uDFA0-\uDFDF]" }, { name: "InOld_South_Arabian", astral: "\uD802[\uDE60-\uDE7F]" }, { name: "InOld_Turkic", astral: "\uD803[\uDC00-\uDC4F]" }, { name: "InOptical_Character_Recognition", bmp: "\u2440-\u245F" }, { name: "InOriya", bmp: "\u0B00-\u0B7F" }, { name: "InOrnamental_Dingbats", astral: "\uD83D[\uDE50-\uDE7F]" }, { name: "InOsmanya", astral: "\uD801[\uDC80-\uDCAF]" }, { name: "InPahawh_Hmong", astral: "\uD81A[\uDF00-\uDF8F]" }, { name: "InPalmyrene", astral: "\uD802[\uDC60-\uDC7F]" }, { name: "InPau_Cin_Hau", astral: "\uD806[\uDEC0-\uDEFF]" }, { name: "InPhags_pa", bmp: "\uA840-\uA87F" }, { name: "InPhaistos_Disc", astral: "\uD800[\uDDD0-\uDDFF]" }, { name: "InPhoenician", astral: "\uD802[\uDD00-\uDD1F]" }, { name: "InPhonetic_Extensions", bmp: "\u1D00-\u1D7F" }, { name: "InPhonetic_Extensions_Supplement", bmp: "\u1D80-\u1DBF" }, { name: "InPlaying_Cards", astral: "\uD83C[\uDCA0-\uDCFF]" }, { name: "InPrivate_Use_Area", bmp: "\uE000-\uF8FF" }, { name: "InPsalter_Pahlavi", astral: "\uD802[\uDF80-\uDFAF]" }, { name: "InRejang", bmp: "\uA930-\uA95F" }, { name: "InRumi_Numeral_Symbols", astral: "\uD803[\uDE60-\uDE7F]" }, { name: "InRunic", bmp: "\u16A0-\u16FF" }, { name: "InSamaritan", bmp: "\u0800-\u083F" }, { name: "InSaurashtra", bmp: "\uA880-\uA8DF" }, { name: "InSharada", astral: "\uD804[\uDD80-\uDDDF]" }, { name: "InShavian", astral: "\uD801[\uDC50-\uDC7F]" }, { name: "InShorthand_Format_Controls", astral: "\uD82F[\uDCA0-\uDCAF]" }, { name: "InSiddham", astral: "\uD805[\uDD80-\uDDFF]" }, { name: "InSinhala", bmp: "\u0D80-\u0DFF" }, { name: "InSinhala_Archaic_Numbers", astral: "\uD804[\uDDE0-\uDDFF]" }, { name: "InSmall_Form_Variants", bmp: "\uFE50-\uFE6F" }, { name: "InSora_Sompeng", astral: "\uD804[\uDCD0-\uDCFF]" }, { name: "InSpacing_Modifier_Letters", bmp: "\u02B0-\u02FF" }, { name: "InSpecials", bmp: "\uFFF0-\uFFFF" }, { name: "InSundanese", bmp: "\u1B80-\u1BBF" }, { name: "InSundanese_Supplement", bmp: "\u1CC0-\u1CCF" }, { name: "InSuperscripts_and_Subscripts", bmp: "\u2070-\u209F" }, { name: "InSupplemental_Arrows_A", bmp: "\u27F0-\u27FF" }, { name: "InSupplemental_Arrows_B", bmp: "\u2900-\u297F" }, { name: "InSupplemental_Arrows_C", astral: "\uD83E[\uDC00-\uDCFF]" }, { name: "InSupplemental_Mathematical_Operators", bmp: "\u2A00-\u2AFF" }, { name: "InSupplemental_Punctuation", bmp: "\u2E00-\u2E7F" }, { name: "InSupplemental_Symbols_and_Pictographs", astral: "\uD83E[\uDD00-\uDDFF]" }, { name: "InSupplementary_Private_Use_Area_A", astral: "[\uDB80-\uDBBF][\uDC00-\uDFFF]" }, { name: "InSupplementary_Private_Use_Area_B", astral: "[\uDBC0-\uDBFF][\uDC00-\uDFFF]" }, { name: "InSutton_SignWriting", astral: "\uD836[\uDC00-\uDEAF]" }, { name: "InSyloti_Nagri", bmp: "\uA800-\uA82F" }, { name: "InSyriac", bmp: "\u0700-\u074F" }, { name: "InTagalog", bmp: "\u1700-\u171F" }, { name: "InTagbanwa", bmp: "\u1760-\u177F" }, { name: "InTags", astral: "\uDB40[\uDC00-\uDC7F]" }, { name: "InTai_Le", bmp: "\u1950-\u197F" }, { name: "InTai_Tham", bmp: "\u1A20-\u1AAF" }, { name: "InTai_Viet", bmp: "\uAA80-\uAADF" }, { name: "InTai_Xuan_Jing_Symbols", astral: "\uD834[\uDF00-\uDF5F]" }, { name: "InTakri", astral: "\uD805[\uDE80-\uDECF]" }, { name: "InTamil", bmp: "\u0B80-\u0BFF" }, { name: "InTelugu", bmp: "\u0C00-\u0C7F" }, { name: "InThaana", bmp: "\u0780-\u07BF" }, { name: "InThai", bmp: "\u0E00-\u0E7F" }, { name: "InTibetan", bmp: "\u0F00-\u0FFF" }, { name: "InTifinagh", bmp: "\u2D30-\u2D7F" }, { name: "InTirhuta", astral: "\uD805[\uDC80-\uDCDF]" }, { name: "InTransport_and_Map_Symbols", astral: "\uD83D[\uDE80-\uDEFF]" }, { name: "InUgaritic", astral: "\uD800[\uDF80-\uDF9F]" }, { name: "InUnified_Canadian_Aboriginal_Syllabics", bmp: "\u1400-\u167F" }, { name: "InUnified_Canadian_Aboriginal_Syllabics_Extended", bmp: "\u18B0-\u18FF" }, { name: "InVai", bmp: "\uA500-\uA63F" }, { name: "InVariation_Selectors", bmp: "\uFE00-\uFE0F" }, { name: "InVariation_Selectors_Supplement", astral: "\uDB40[\uDD00-\uDDEF]" }, { name: "InVedic_Extensions", bmp: "\u1CD0-\u1CFF" }, { name: "InVertical_Forms", bmp: "\uFE10-\uFE1F" }, { name: "InWarang_Citi", astral: "\uD806[\uDCA0-\uDCFF]" }, { name: "InYi_Radicals", bmp: "\uA490-\uA4CF" }, { name: "InYi_Syllables", bmp: "\uA000-\uA48F" }, { name: "InYijing_Hexagram_Symbols", bmp: "\u4DC0-\u4DFF" }]);
}(Xc), function(e14) {
  if (!e14.addUnicodeData) throw new ReferenceError("Unicode Base must be loaded before Unicode Categories");
  e14.addUnicodeData([{ name: "C", alias: "Other", isBmpLast: true, bmp: "\0-\x7F-\x9F\xAD\u0378\u0379\u0380-\u0383\u038B\u038D\u03A2\u0530\u0557\u0558\u0560\u0588\u058B\u058C\u0590\u05C8-\u05CF\u05EB-\u05EF\u05F5-\u0605\u061C\u061D\u06DD\u070E\u070F\u074B\u074C\u07B2-\u07BF\u07FB-\u07FF\u082E\u082F\u083F\u085C\u085D\u085F-\u089F\u08B5-\u08E2\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09FC-\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF2-\u0AF8\u0AFA-\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B55\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BFB-\u0BFF\u0C04\u0C0D\u0C11\u0C29\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5B-\u0C5F\u0C64\u0C65\u0C70-\u0C77\u0C80\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0D00\u0D04\u0D0D\u0D11\u0D3B\u0D3C\u0D45\u0D49\u0D4F-\u0D56\u0D58-\u0D5E\u0D64\u0D65\u0D76-\u0D78\u0D80\u0D81\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DE5\u0DF0\u0DF1\u0DF5-\u0E00\u0E3B-\u0E3E\u0E5C-\u0E80\u0E83\u0E85\u0E86\u0E89\u0E8B\u0E8C\u0E8E-\u0E93\u0E98\u0EA0\u0EA4\u0EA6\u0EA8\u0EA9\u0EAC\u0EBA\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F48\u0F6D-\u0F70\u0F98\u0FBD\u0FCD\u0FDB-\u0FFF\u10C6\u10C8-\u10CC\u10CE\u10CF\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u137D-\u137F\u139A-\u139F\u13F6\u13F7\u13FE\u13FF\u169D-\u169F\u16F9-\u16FF\u170D\u1715-\u171F\u1737-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17DE\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180E\u180F\u181A-\u181F\u1878-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191F\u192C-\u192F\u193C-\u193F\u1941-\u1943\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19DD\u1A1C\u1A1D\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AAE\u1AAF\u1ABF-\u1AFF\u1B4C-\u1B4F\u1B7D-\u1B7F\u1BF4-\u1BFB\u1C38-\u1C3A\u1C4A-\u1C4C\u1C80-\u1CBF\u1CC8-\u1CCF\u1CF7\u1CFA-\u1CFF\u1DF6-\u1DFB\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FC5\u1FD4\u1FD5\u1FDC\u1FF0\u1FF1\u1FF5\u1FFF\u200B-\u200F\u202A-\u202E\u2060-\u206F\u2072\u2073\u208F\u209D-\u209F\u20BF-\u20CF\u20F1-\u20FF\u218C-\u218F\u23FB-\u23FF\u2427-\u243F\u244B-\u245F\u2B74\u2B75\u2B96\u2B97\u2BBA-\u2BBC\u2BC9\u2BD2-\u2BEB\u2BF0-\u2BFF\u2C2F\u2C5F\u2CF4-\u2CF8\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D71-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E43-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3040\u3097\u3098\u3100-\u3104\u312E-\u3130\u318F\u31BB-\u31BF\u31E4-\u31EF\u321F\u32FF\u4DB6-\u4DBF\u9FD6-\u9FFF\uA48D-\uA48F\uA4C7-\uA4CF\uA62C-\uA63F\uA6F8-\uA6FF\uA7AE\uA7AF\uA7B8-\uA7F6\uA82C-\uA82F\uA83A-\uA83F\uA878-\uA87F\uA8C5-\uA8CD\uA8DA-\uA8DF\uA8FE\uA8FF\uA954-\uA95E\uA97D-\uA97F\uA9CE\uA9DA-\uA9DD\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A\uAA5B\uAAC3-\uAADA\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB66-\uAB6F\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBC2-\uFBD2\uFD40-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFE\uFDFF\uFE1A-\uFE1F\uFE53\uFE67\uFE6C-\uFE6F\uFE75\uFEFD-\uFF00\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFDF\uFFE7\uFFEF-\uFFFB\uFFFE\uFFFF", astral: "\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDD73-\uDD7A\uDDE9-\uDDFF\uDE46-\uDEFF\uDF57-\uDF5F\uDF72-\uDFFF]|\uD836[\uDE8C-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD6F\uDD9B-\uDDE5\uDE03-\uDE0F\uDE3B-\uDE3F\uDE49-\uDE4F\uDE52-\uDEFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6D\uDE70-\uDECF\uDEEE\uDEEF\uDEF6-\uDEFF\uDF46-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD809[\uDC6F\uDC75-\uDC7F\uDD44-\uDFFF]|\uD81B[\uDC00-\uDEFF\uDF45-\uDF4F\uDF7F-\uDF8E\uDFA0-\uDFFF]|\uD86E[\uDC1E\uDC1F]|\uD83D[\uDD7A\uDDA4\uDED1-\uDEDF\uDEED-\uDEEF\uDEF4-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6E\uDD70-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDFFF]|\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDCFF\uDD03-\uDD06\uDD34-\uDD36\uDD8D-\uDD8F\uDD9C-\uDD9F\uDDA1-\uDDCF\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEFC-\uDEFF\uDF24-\uDF2F\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDFC4-\uDFC7\uDFD6-\uDFFF]|\uD869[\uDED7-\uDEFF]|\uD83B[\uDC00-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDEEF\uDEF2-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uDB40[\uDC00-\uDCFF\uDDF0-\uDFFF]|\uD804[\uDC4E-\uDC51\uDC70-\uDC7E\uDCBD\uDCC2-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD44-\uDD4F\uDD77-\uDD7F\uDDCE\uDDCF\uDDE0\uDDF5-\uDDFF\uDE12\uDE3E-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEAA-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF3B\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD7-\uDFFF]|\uD80D[\uDC2F-\uDFFF]|\uD86D[\uDF35-\uDF3F]|[\uD807\uD80A\uD80B\uD80E-\uD810\uD812-\uD819\uD81C-\uD82B\uD82D\uD82E\uD830-\uD833\uD837-\uD839\uD83F\uD874-\uD87D\uD87F-\uDB3F\uDB41-\uDBFF][\uDC00-\uDFFF]|\uD806[\uDC00-\uDC9F\uDCF3-\uDCFE\uDD00-\uDEBF\uDEF9-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD00-\uDE5F\uDE7F-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]|\uD805[\uDC00-\uDC7F\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDDE-\uDDFF\uDE45-\uDE4F\uDE5A-\uDE7F\uDEB8-\uDEBF\uDECA-\uDEFF\uDF1A-\uDF1C\uDF2C-\uDF2F\uDF40-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1E\uDD3A-\uDD3E\uDD40-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE34-\uDE37\uDE3B-\uDE3E\uDE48-\uDE4F\uDE59-\uDE5F\uDEA0-\uDEBF\uDEE7-\uDEEA\uDEF7-\uDEFF\uDF36-\uDF38\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDF98\uDF9D-\uDFA8\uDFB0-\uDFFF]|\uD808[\uDF9A-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A\uDC9B\uDCA0-\uDFFF]|\uD82C[\uDC02-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDD0F\uDD19-\uDD7F\uDD85-\uDDBF\uDDC1-\uDFFF]|\uD873[\uDEA2-\uDFFF]" }, { name: "Cc", alias: "Control", bmp: "\0-\x7F-\x9F" }, { name: "Cf", alias: "Format", bmp: "\xAD\u0600-\u0605\u061C\u06DD\u070F\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB", astral: "\uDB40[\uDC01\uDC20-\uDC7F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\u{110BD}" }, { name: "Cn", alias: "Unassigned", bmp: "\u0378\u0379\u0380-\u0383\u038B\u038D\u03A2\u0530\u0557\u0558\u0560\u0588\u058B\u058C\u0590\u05C8-\u05CF\u05EB-\u05EF\u05F5-\u05FF\u061D\u070E\u074B\u074C\u07B2-\u07BF\u07FB-\u07FF\u082E\u082F\u083F\u085C\u085D\u085F-\u089F\u08B5-\u08E2\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09FC-\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF2-\u0AF8\u0AFA-\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B55\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BFB-\u0BFF\u0C04\u0C0D\u0C11\u0C29\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5B-\u0C5F\u0C64\u0C65\u0C70-\u0C77\u0C80\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0D00\u0D04\u0D0D\u0D11\u0D3B\u0D3C\u0D45\u0D49\u0D4F-\u0D56\u0D58-\u0D5E\u0D64\u0D65\u0D76-\u0D78\u0D80\u0D81\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DE5\u0DF0\u0DF1\u0DF5-\u0E00\u0E3B-\u0E3E\u0E5C-\u0E80\u0E83\u0E85\u0E86\u0E89\u0E8B\u0E8C\u0E8E-\u0E93\u0E98\u0EA0\u0EA4\u0EA6\u0EA8\u0EA9\u0EAC\u0EBA\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F48\u0F6D-\u0F70\u0F98\u0FBD\u0FCD\u0FDB-\u0FFF\u10C6\u10C8-\u10CC\u10CE\u10CF\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u137D-\u137F\u139A-\u139F\u13F6\u13F7\u13FE\u13FF\u169D-\u169F\u16F9-\u16FF\u170D\u1715-\u171F\u1737-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17DE\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180F\u181A-\u181F\u1878-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191F\u192C-\u192F\u193C-\u193F\u1941-\u1943\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19DD\u1A1C\u1A1D\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AAE\u1AAF\u1ABF-\u1AFF\u1B4C-\u1B4F\u1B7D-\u1B7F\u1BF4-\u1BFB\u1C38-\u1C3A\u1C4A-\u1C4C\u1C80-\u1CBF\u1CC8-\u1CCF\u1CF7\u1CFA-\u1CFF\u1DF6-\u1DFB\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FC5\u1FD4\u1FD5\u1FDC\u1FF0\u1FF1\u1FF5\u1FFF\u2065\u2072\u2073\u208F\u209D-\u209F\u20BF-\u20CF\u20F1-\u20FF\u218C-\u218F\u23FB-\u23FF\u2427-\u243F\u244B-\u245F\u2B74\u2B75\u2B96\u2B97\u2BBA-\u2BBC\u2BC9\u2BD2-\u2BEB\u2BF0-\u2BFF\u2C2F\u2C5F\u2CF4-\u2CF8\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D71-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E43-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3040\u3097\u3098\u3100-\u3104\u312E-\u3130\u318F\u31BB-\u31BF\u31E4-\u31EF\u321F\u32FF\u4DB6-\u4DBF\u9FD6-\u9FFF\uA48D-\uA48F\uA4C7-\uA4CF\uA62C-\uA63F\uA6F8-\uA6FF\uA7AE\uA7AF\uA7B8-\uA7F6\uA82C-\uA82F\uA83A-\uA83F\uA878-\uA87F\uA8C5-\uA8CD\uA8DA-\uA8DF\uA8FE\uA8FF\uA954-\uA95E\uA97D-\uA97F\uA9CE\uA9DA-\uA9DD\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A\uAA5B\uAAC3-\uAADA\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB66-\uAB6F\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uD7FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBC2-\uFBD2\uFD40-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFE\uFDFF\uFE1A-\uFE1F\uFE53\uFE67\uFE6C-\uFE6F\uFE75\uFEFD\uFEFE\uFF00\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFDF\uFFE7\uFFEF-\uFFF8\uFFFE\uFFFF", astral: "\uDB40[\uDC00\uDC02-\uDC1F\uDC80-\uDCFF\uDDF0-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDDE9-\uDDFF\uDE46-\uDEFF\uDF57-\uDF5F\uDF72-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD6F\uDD9B-\uDDE5\uDE03-\uDE0F\uDE3B-\uDE3F\uDE49-\uDE4F\uDE52-\uDEFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6D\uDE70-\uDECF\uDEEE\uDEEF\uDEF6-\uDEFF\uDF46-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD809[\uDC6F\uDC75-\uDC7F\uDD44-\uDFFF]|\uD81B[\uDC00-\uDEFF\uDF45-\uDF4F\uDF7F-\uDF8E\uDFA0-\uDFFF]|\uD86E[\uDC1E\uDC1F]|\uD83D[\uDD7A\uDDA4\uDED1-\uDEDF\uDEED-\uDEEF\uDEF4-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6E\uDD70-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDFFF]|\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDCFF\uDD03-\uDD06\uDD34-\uDD36\uDD8D-\uDD8F\uDD9C-\uDD9F\uDDA1-\uDDCF\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEFC-\uDEFF\uDF24-\uDF2F\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDFC4-\uDFC7\uDFD6-\uDFFF]|\uD869[\uDED7-\uDEFF]|\uD83B[\uDC00-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDEEF\uDEF2-\uDFFF]|[\uDBBF\uDBFF][\uDFFE\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A\uDC9B\uDCA4-\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD7-\uDFFF]|\uD80D[\uDC2F-\uDFFF]|\uD86D[\uDF35-\uDF3F]|[\uD807\uD80A\uD80B\uD80E-\uD810\uD812-\uD819\uD81C-\uD82B\uD82D\uD82E\uD830-\uD833\uD837-\uD839\uD83F\uD874-\uD87D\uD87F-\uDB3F\uDB41-\uDB7F][\uDC00-\uDFFF]|\uD806[\uDC00-\uDC9F\uDCF3-\uDCFE\uDD00-\uDEBF\uDEF9-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD00-\uDE5F\uDE7F-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]|\uD836[\uDE8C-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD805[\uDC00-\uDC7F\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDDE-\uDDFF\uDE45-\uDE4F\uDE5A-\uDE7F\uDEB8-\uDEBF\uDECA-\uDEFF\uDF1A-\uDF1C\uDF2C-\uDF2F\uDF40-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1E\uDD3A-\uDD3E\uDD40-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE34-\uDE37\uDE3B-\uDE3E\uDE48-\uDE4F\uDE59-\uDE5F\uDEA0-\uDEBF\uDEE7-\uDEEA\uDEF7-\uDEFF\uDF36-\uDF38\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDF98\uDF9D-\uDFA8\uDFB0-\uDFFF]|\uD808[\uDF9A-\uDFFF]|\uD804[\uDC4E-\uDC51\uDC70-\uDC7E\uDCC2-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD44-\uDD4F\uDD77-\uDD7F\uDDCE\uDDCF\uDDE0\uDDF5-\uDDFF\uDE12\uDE3E-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEAA-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF3B\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD82C[\uDC02-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDD0F\uDD19-\uDD7F\uDD85-\uDDBF\uDDC1-\uDFFF]|\uD873[\uDEA2-\uDFFF]" }, { name: "Co", alias: "Private_Use", bmp: "\uE000-\uF8FF", astral: "[\uDB80-\uDBBE\uDBC0-\uDBFE][\uDC00-\uDFFF]|[\uDBBF\uDBFF][\uDC00-\uDFFD]" }, { name: "Cs", alias: "Surrogate", bmp: "\uD800-\uDFFF" }, { name: "L", alias: "Letter", bmp: "A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC", astral: "\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD83A[\uDC00-\uDCC4]|\uD801[\uDC00-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD80D[\uDC00-\uDC2E]|\uD87E[\uDC00-\uDE1D]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F]|[\uD80C\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD805[\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD809[\uDC80-\uDD43]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD808[\uDC00-\uDF99]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD811[\uDC00-\uDE46]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD82C[\uDC00\uDC01]|\uD873[\uDC00-\uDEA1]" }, { name: "Ll", alias: "Lowercase_Letter", bmp: "a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A", astral: "\uD803[\uDCC0-\uDCF2]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD801[\uDC28-\uDC4F]|\uD806[\uDCC0-\uDCDF]" }, { name: "Lm", alias: "Modifier_Letter", bmp: "\u02B0-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0374\u037A\u0559\u0640\u06E5\u06E6\u07F4\u07F5\u07FA\u081A\u0824\u0828\u0971\u0E46\u0EC6\u10FC\u17D7\u1843\u1AA7\u1C78-\u1C7D\u1D2C-\u1D6A\u1D78\u1D9B-\u1DBF\u2071\u207F\u2090-\u209C\u2C7C\u2C7D\u2D6F\u2E2F\u3005\u3031-\u3035\u303B\u309D\u309E\u30FC-\u30FE\uA015\uA4F8-\uA4FD\uA60C\uA67F\uA69C\uA69D\uA717-\uA71F\uA770\uA788\uA7F8\uA7F9\uA9CF\uA9E6\uAA70\uAADD\uAAF3\uAAF4\uAB5C-\uAB5F\uFF70\uFF9E\uFF9F", astral: "\uD81A[\uDF40-\uDF43]|\uD81B[\uDF93-\uDF9F]" }, { name: "Lo", alias: "Other_Letter", bmp: "\xAA\xBA\u01BB\u01C0-\u01C3\u0294\u05D0-\u05EA\u05F0-\u05F2\u0620-\u063F\u0641-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u0800-\u0815\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0972-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E45\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10D0-\u10FA\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17DC\u1820-\u1842\u1844-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C77\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u2135-\u2138\u2D30-\u2D67\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3006\u303C\u3041-\u3096\u309F\u30A1-\u30FA\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA014\uA016-\uA48C\uA4D0-\uA4F7\uA500-\uA60B\uA610-\uA61F\uA62A\uA62B\uA66E\uA6A0-\uA6E5\uA78F\uA7F7\uA7FB-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9E0-\uA9E4\uA9E7-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA6F\uAA71-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB\uAADC\uAAE0-\uAAEA\uAAF2\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF66-\uFF6F\uFF71-\uFF9D\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC", astral: "\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD83A[\uDC00-\uDCC4]|\uD803[\uDC00-\uDC48]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD80D[\uDC00-\uDC2E]|\uD87E[\uDC00-\uDE1D]|\uD81B[\uDF00-\uDF44\uDF50]|[\uD80C\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD805[\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCFF\uDEC0-\uDEF8]|\uD809[\uDC80-\uDD43]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD808[\uDC00-\uDF99]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF63-\uDF77\uDF7D-\uDF8F]|\uD801[\uDC50-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD811[\uDC00-\uDE46]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD82C[\uDC00\uDC01]|\uD873[\uDC00-\uDEA1]" }, { name: "Lt", alias: "Titlecase_Letter", bmp: "\u01C5\u01C8\u01CB\u01F2\u1F88-\u1F8F\u1F98-\u1F9F\u1FA8-\u1FAF\u1FBC\u1FCC\u1FFC" }, { name: "Lu", alias: "Uppercase_Letter", bmp: "A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A", astral: "\uD806[\uDCA0-\uDCBF]|\uD803[\uDC80-\uDCB2]|\uD801[\uDC00-\uDC27]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]" }, { name: "M", alias: "Mark", bmp: "\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C03\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D01-\u0D03\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ABE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFC-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F", astral: "\uD805[\uDCB0-\uDCC3\uDDAF-\uDDB5\uDDB8-\uDDC0\uDDDC\uDDDD\uDE30-\uDE40\uDEAB-\uDEB7\uDF1D-\uDF2B]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD804[\uDC00-\uDC02\uDC38-\uDC46\uDC7F-\uDC82\uDCB0-\uDCBA\uDD00-\uDD02\uDD27-\uDD34\uDD73\uDD80-\uDD82\uDDB3-\uDDC0\uDDCA-\uDDCC\uDE2C-\uDE37\uDEDF-\uDEEA\uDF00-\uDF03\uDF3C\uDF3E-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD81B[\uDF51-\uDF7E\uDF8F-\uDF92]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD82F[\uDC9D\uDC9E]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD83A[\uDCD0-\uDCD6]|\uDB40[\uDD00-\uDDEF]" }, { name: "Mc", alias: "Spacing_Mark", bmp: "\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BE-\u09C0\u09C7\u09C8\u09CB\u09CC\u09D7\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B3E\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0B57\u0BBE\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD7\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0-\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0CD5\u0CD6\u0D02\u0D03\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D57\u0D82\u0D83\u0DCF-\u0DD1\u0DD8-\u0DDF\u0DF2\u0DF3\u0F3E\u0F3F\u0F7F\u102B\u102C\u1031\u1038\u103B\u103C\u1056\u1057\u1062-\u1064\u1067-\u106D\u1083\u1084\u1087-\u108C\u108F\u109A-\u109C\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A61\u1A63\u1A64\u1A6D-\u1A72\u1B04\u1B35\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF2\u1CF3\u302E\u302F\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BD-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAA7B\uAA7D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC", astral: "\uD834[\uDD65\uDD66\uDD6D-\uDD72]|\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3E\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63]|\uD805[\uDCB0-\uDCB2\uDCB9\uDCBB-\uDCBE\uDCC1\uDDAF-\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF20\uDF21\uDF26]|\uD81B[\uDF51-\uDF7E]" }, { name: "Me", alias: "Enclosing_Mark", bmp: "\u0488\u0489\u1ABE\u20DD-\u20E0\u20E2-\u20E4\uA670-\uA672" }, { name: "Mn", alias: "Nonspacing_Mark", bmp: "\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D01\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFC-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F", astral: "\uD805[\uDCB3-\uDCB8\uDCBA\uDCBF\uDCC0\uDCC2\uDCC3\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF8F-\uDF92]|\uD82F[\uDC9D\uDC9E]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDCA-\uDDCC\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3C\uDF40\uDF66-\uDF6C\uDF70-\uDF74]|\uD83A[\uDCD0-\uDCD6]|\uDB40[\uDD00-\uDDEF]" }, { name: "N", alias: "Number", bmp: "0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19", astral: "\uD800[\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23\uDF41\uDF4A\uDFD1-\uDFD5]|\uD801[\uDCA0-\uDCA9]|\uD803[\uDCFA-\uDCFF\uDE60-\uDE7E]|\uD835[\uDFCE-\uDFFF]|\uD83A[\uDCC7-\uDCCF]|\uD81A[\uDE60-\uDE69\uDF50-\uDF59\uDF5B-\uDF61]|\uD806[\uDCE0-\uDCF2]|\uD804[\uDC52-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDDE1-\uDDF4\uDEF0-\uDEF9]|\uD834[\uDF60-\uDF71]|\uD83C[\uDD00-\uDD0C]|\uD809[\uDC00-\uDC6E]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE47\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD805[\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF3B]" }, { name: "Nd", alias: "Decimal_Number", bmp: "0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19", astral: "\uD801[\uDCA0-\uDCA9]|\uD835[\uDFCE-\uDFFF]|\uD805[\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF39]|\uD806[\uDCE0-\uDCE9]|\uD804[\uDC66-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDEF0-\uDEF9]|\uD81A[\uDE60-\uDE69\uDF50-\uDF59]" }, { name: "Nl", alias: "Letter_Number", bmp: "\u16EE-\u16F0\u2160-\u2182\u2185-\u2188\u3007\u3021-\u3029\u3038-\u303A\uA6E6-\uA6EF", astral: "\uD809[\uDC00-\uDC6E]|\uD800[\uDD40-\uDD74\uDF41\uDF4A\uDFD1-\uDFD5]" }, { name: "No", alias: "Other_Number", bmp: "\xB2\xB3\xB9\xBC-\xBE\u09F4-\u09F9\u0B72-\u0B77\u0BF0-\u0BF2\u0C78-\u0C7E\u0D70-\u0D75\u0F2A-\u0F33\u1369-\u137C\u17F0-\u17F9\u19DA\u2070\u2074-\u2079\u2080-\u2089\u2150-\u215F\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA830-\uA835", astral: "\uD804[\uDC52-\uDC65\uDDE1-\uDDF4]|\uD803[\uDCFA-\uDCFF\uDE60-\uDE7E]|\uD83C[\uDD00-\uDD0C]|\uD806[\uDCEA-\uDCF2]|\uD83A[\uDCC7-\uDCCF]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE47\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD805[\uDF3A\uDF3B]|\uD81A[\uDF5B-\uDF61]|\uD834[\uDF60-\uDF71]|\uD800[\uDD07-\uDD33\uDD75-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23]" }, { name: "P", alias: "Punctuation", bmp: "!-#%-\\x2A,-/:;\\x3F@\\x5B-\\x5D_\\x7B}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E42\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65", astral: "\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD809[\uDC70-\uDC74]|\uD805[\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDF3C-\uDF3E]|\uD836[\uDE87-\uDE8B]|\u{1056F}|\u{1BC9F}|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]" }, { name: "Pc", alias: "Connector_Punctuation", bmp: "_\u203F\u2040\u2054\uFE33\uFE34\uFE4D-\uFE4F\uFF3F" }, { name: "Pd", alias: "Dash_Punctuation", bmp: "\\x2D\u058A\u05BE\u1400\u1806\u2010-\u2015\u2E17\u2E1A\u2E3A\u2E3B\u2E40\u301C\u3030\u30A0\uFE31\uFE32\uFE58\uFE63\uFF0D" }, { name: "Pe", alias: "Close_Punctuation", bmp: "\\x29\\x5D}\u0F3B\u0F3D\u169C\u2046\u207E\u208E\u2309\u230B\u232A\u2769\u276B\u276D\u276F\u2771\u2773\u2775\u27C6\u27E7\u27E9\u27EB\u27ED\u27EF\u2984\u2986\u2988\u298A\u298C\u298E\u2990\u2992\u2994\u2996\u2998\u29D9\u29DB\u29FD\u2E23\u2E25\u2E27\u2E29\u3009\u300B\u300D\u300F\u3011\u3015\u3017\u3019\u301B\u301E\u301F\uFD3E\uFE18\uFE36\uFE38\uFE3A\uFE3C\uFE3E\uFE40\uFE42\uFE44\uFE48\uFE5A\uFE5C\uFE5E\uFF09\uFF3D\uFF5D\uFF60\uFF63" }, { name: "Pf", alias: "Final_Punctuation", bmp: "\xBB\u2019\u201D\u203A\u2E03\u2E05\u2E0A\u2E0D\u2E1D\u2E21" }, { name: "Pi", alias: "Initial_Punctuation", bmp: "\xAB\u2018\u201B\u201C\u201F\u2039\u2E02\u2E04\u2E09\u2E0C\u2E1C\u2E20" }, { name: "Po", alias: "Other_Punctuation", bmp: "!-#%-'\\x2A,\\x2E/:;\\x3F@\\x5C\xA1\xA7\xB6\xB7\xBF\u037E\u0387\u055A-\u055F\u0589\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u166D\u166E\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u1805\u1807-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2016\u2017\u2020-\u2027\u2030-\u2038\u203B-\u203E\u2041-\u2043\u2047-\u2051\u2053\u2055-\u205E\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00\u2E01\u2E06-\u2E08\u2E0B\u2E0E-\u2E16\u2E18\u2E19\u2E1B\u2E1E\u2E1F\u2E2A-\u2E2E\u2E30-\u2E39\u2E3C-\u2E3F\u2E41\u3001-\u3003\u303D\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFE10-\uFE16\uFE19\uFE30\uFE45\uFE46\uFE49-\uFE4C\uFE50-\uFE52\uFE54-\uFE57\uFE5F-\uFE61\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF07\uFF0A\uFF0C\uFF0E\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3C\uFF61\uFF64\uFF65", astral: "\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD809[\uDC70-\uDC74]|\uD805[\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDF3C-\uDF3E]|\uD836[\uDE87-\uDE8B]|\u{1056F}|\u{1BC9F}|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]" }, { name: "Ps", alias: "Open_Punctuation", bmp: "\\x28\\x5B\\x7B\u0F3A\u0F3C\u169B\u201A\u201E\u2045\u207D\u208D\u2308\u230A\u2329\u2768\u276A\u276C\u276E\u2770\u2772\u2774\u27C5\u27E6\u27E8\u27EA\u27EC\u27EE\u2983\u2985\u2987\u2989\u298B\u298D\u298F\u2991\u2993\u2995\u2997\u29D8\u29DA\u29FC\u2E22\u2E24\u2E26\u2E28\u2E42\u3008\u300A\u300C\u300E\u3010\u3014\u3016\u3018\u301A\u301D\uFD3F\uFE17\uFE35\uFE37\uFE39\uFE3B\uFE3D\uFE3F\uFE41\uFE43\uFE47\uFE59\uFE5B\uFE5D\uFF08\uFF3B\uFF5B\uFF5F\uFF62" }, { name: "S", alias: "Symbol", bmp: "\\x24\\x2B<->\\x5E`\\x7C~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20BE\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u23FA\u2400-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B98-\u2BB9\u2BBD-\u2BC8\u2BCA-\u2BD1\u2BEC-\u2BEF\u2CE5-\u2CEA\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u32FE\u3300-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uFB29\uFBB2-\uFBC1\uFDFC\uFDFD\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD", astral: "\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDD10-\uDD18\uDD80-\uDD84\uDDC0]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD10-\uDD2E\uDD30-\uDD6B\uDD70-\uDD9A\uDDE6-\uDE02\uDE10-\uDE3A\uDE40-\uDE48\uDE50\uDE51\uDF00-\uDFFF]|\uD83D[\uDC00-\uDD79\uDD7B-\uDDA3\uDDA5-\uDED0\uDEE0-\uDEEC\uDEF0-\uDEF3\uDF00-\uDF73\uDF80-\uDFD4]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C\uDD90-\uDD9B\uDDA0\uDDD0-\uDDFC]|\u{1BC9C}|\u{1173F}|\uD802[\uDC77\uDC78\uDEC8]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD83B[\uDEF0\uDEF1]" }, { name: "Sc", alias: "Currency_Symbol", bmp: "\\x24\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20BE\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6" }, { name: "Sk", alias: "Modifier_Symbol", bmp: "\\x5E`\xA8\xAF\xB4\xB8\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u309B\u309C\uA700-\uA716\uA720\uA721\uA789\uA78A\uAB5B\uFBB2-\uFBC1\uFF3E\uFF40\uFFE3", astral: "\uD83C[\uDFFB-\uDFFF]" }, { name: "Sm", alias: "Math_Symbol", bmp: "\\x2B<->\\x7C~\xAC\xB1\xD7\xF7\u03F6\u0606-\u0608\u2044\u2052\u207A-\u207C\u208A-\u208C\u2118\u2140-\u2144\u214B\u2190-\u2194\u219A\u219B\u21A0\u21A3\u21A6\u21AE\u21CE\u21CF\u21D2\u21D4\u21F4-\u22FF\u2320\u2321\u237C\u239B-\u23B3\u23DC-\u23E1\u25B7\u25C1\u25F8-\u25FF\u266F\u27C0-\u27C4\u27C7-\u27E5\u27F0-\u27FF\u2900-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2AFF\u2B30-\u2B44\u2B47-\u2B4C\uFB29\uFE62\uFE64-\uFE66\uFF0B\uFF1C-\uFF1E\uFF5C\uFF5E\uFFE2\uFFE9-\uFFEC", astral: "\uD83B[\uDEF0\uDEF1]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]" }, { name: "So", alias: "Other_Symbol", bmp: "\xA6\xA9\xAE\xB0\u0482\u058D\u058E\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u09FA\u0B70\u0BF3-\u0BF8\u0BFA\u0C7F\u0D79\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116\u2117\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u214A\u214C\u214D\u214F\u218A\u218B\u2195-\u2199\u219C-\u219F\u21A1\u21A2\u21A4\u21A5\u21A7-\u21AD\u21AF-\u21CD\u21D0\u21D1\u21D3\u21D5-\u21F3\u2300-\u2307\u230C-\u231F\u2322-\u2328\u232B-\u237B\u237D-\u239A\u23B4-\u23DB\u23E2-\u23FA\u2400-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u25B6\u25B8-\u25C0\u25C2-\u25F7\u2600-\u266E\u2670-\u2767\u2794-\u27BF\u2800-\u28FF\u2B00-\u2B2F\u2B45\u2B46\u2B4D-\u2B73\u2B76-\u2B95\u2B98-\u2BB9\u2BBD-\u2BC8\u2BCA-\u2BD1\u2BEC-\u2BEF\u2CE5-\u2CEA\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u32FE\u3300-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA828-\uA82B\uA836\uA837\uA839\uAA77-\uAA79\uFDFD\uFFE4\uFFE8\uFFED\uFFEE\uFFFC\uFFFD", astral: "\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDD10-\uDD18\uDD80-\uDD84\uDDC0]|\uD83D[\uDC00-\uDD79\uDD7B-\uDDA3\uDDA5-\uDED0\uDEE0-\uDEEC\uDEF0-\uDEF3\uDF00-\uDF73\uDF80-\uDFD4]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD10-\uDD2E\uDD30-\uDD6B\uDD70-\uDD9A\uDDE6-\uDE02\uDE10-\uDE3A\uDE40-\uDE48\uDE50\uDE51\uDF00-\uDFFA]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C\uDD90-\uDD9B\uDDA0\uDDD0-\uDDFC]|\u{1BC9C}|\u{1173F}|\uD802[\uDC77\uDC78\uDEC8]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]" }, { name: "Z", alias: "Separator", bmp: " \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000" }, { name: "Zl", alias: "Line_Separator", bmp: "\u2028" }, { name: "Zp", alias: "Paragraph_Separator", bmp: "\u2029" }, { name: "Zs", alias: "Space_Separator", bmp: " \xA0\u1680\u2000-\u200A\u202F\u205F\u3000" }]);
}(Xc), function(e14) {
  if (!e14.addUnicodeData) throw new ReferenceError("Unicode Base must be loaded before Unicode Properties");
  var t10 = [{ name: "ASCII", bmp: "\0-\x7F" }, { name: "Alphabetic", bmp: "A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0345\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05B0-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0657\u0659-\u065F\u066E-\u06D3\u06D5-\u06DC\u06E1-\u06E8\u06ED-\u06EF\u06FA-\u06FC\u06FF\u0710-\u073F\u074D-\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0817\u081A-\u082C\u0840-\u0858\u08A0-\u08B4\u08E3-\u08E9\u08F0-\u093B\u093D-\u094C\u094E-\u0950\u0955-\u0963\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD-\u09C4\u09C7\u09C8\u09CB\u09CC\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09F0\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3E-\u0A42\u0A47\u0A48\u0A4B\u0A4C\u0A51\u0A59-\u0A5C\u0A5E\u0A70-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD-\u0AC5\u0AC7-\u0AC9\u0ACB\u0ACC\u0AD0\u0AE0-\u0AE3\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D-\u0B44\u0B47\u0B48\u0B4B\u0B4C\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4C\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C81-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCC\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D57\u0D5F-\u0D63\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E46\u0E4D\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0ECD\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F71-\u0F81\u0F88-\u0F97\u0F99-\u0FBC\u1000-\u1036\u1038\u103B-\u103F\u1050-\u1062\u1065-\u1068\u106E-\u1086\u108E\u109C\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1713\u1720-\u1733\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17B3\u17B6-\u17C8\u17D7\u17DC\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u1938\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A1B\u1A20-\u1A5E\u1A61-\u1A74\u1AA7\u1B00-\u1B33\u1B35-\u1B43\u1B45-\u1B4B\u1B80-\u1BA9\u1BAC-\u1BAF\u1BBA-\u1BE5\u1BE7-\u1BF1\u1C00-\u1C35\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1D00-\u1DBF\u1DE7-\u1DF4\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u24B6-\u24E9\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA674-\uA67B\uA67F-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA827\uA840-\uA873\uA880-\uA8C3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA92A\uA930-\uA952\uA960-\uA97C\uA980-\uA9B2\uA9B4-\uA9BF\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA60-\uAA76\uAA7A\uAA7E-\uAABE\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF5\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC", astral: "\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD804[\uDC00-\uDC45\uDC82-\uDCB8\uDCD0-\uDCE8\uDD00-\uDD32\uDD50-\uDD72\uDD76\uDD80-\uDDBF\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE34\uDE37\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEE8\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D-\uDF44\uDF47\uDF48\uDF4B\uDF4C\uDF50\uDF57\uDF5D-\uDF63]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD83A[\uDC00-\uDCC4]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF36\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD801[\uDC00-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD83C[\uDD30-\uDD49\uDD50-\uDD69\uDD70-\uDD89]|\uD80D[\uDC00-\uDC2E]|\uD87E[\uDC00-\uDE1D]|[\uD80C\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9E]|\uD808[\uDC00-\uDF99]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD805[\uDC80-\uDCC1\uDCC4\uDCC5\uDCC7\uDD80-\uDDB5\uDDB8-\uDDBE\uDDD8-\uDDDD\uDE00-\uDE3E\uDE40\uDE44\uDE80-\uDEB5\uDF00-\uDF19\uDF1D-\uDF2A]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD811[\uDC00-\uDE46]|\uD82C[\uDC00\uDC01]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF93-\uDF9F]|\uD873[\uDC00-\uDEA1]" }, { name: "Any", isBmpLast: true, bmp: "\0-\uFFFF", astral: "[\uD800-\uDBFF][\uDC00-\uDFFF]" }, { name: "Default_Ignorable_Code_Point", bmp: "\xAD\u034F\u061C\u115F\u1160\u17B4\u17B5\u180B-\u180E\u200B-\u200F\u202A-\u202E\u2060-\u206F\u3164\uFE00-\uFE0F\uFEFF\uFFA0\uFFF0-\uFFF8", astral: "[\uDB40-\uDB43][\uDC00-\uDFFF]|\uD834[\uDD73-\uDD7A]|\uD82F[\uDCA0-\uDCA3]" }, { name: "Lowercase", bmp: "a-z\xAA\xB5\xBA\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02B8\u02C0\u02C1\u02E0-\u02E4\u0345\u0371\u0373\u0377\u037A-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1DBF\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u2071\u207F\u2090-\u209C\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2170-\u217F\u2184\u24D0-\u24E9\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7D\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B-\uA69D\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7F8-\uA7FA\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A", astral: "\uD803[\uDCC0-\uDCF2]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD801[\uDC28-\uDC4F]|\uD806[\uDCC0-\uDCDF]" }, { name: "Noncharacter_Code_Point", bmp: "\uFDD0-\uFDEF\uFFFE\uFFFF", astral: "[\uDB3F\uDB7F\uDBBF\uDBFF\uD83F\uD87F\uD8BF\uDAFF\uD97F\uD9BF\uD9FF\uDA3F\uD8FF\uDABF\uDA7F\uD93F][\uDFFE\uDFFF]" }, { name: "Uppercase", bmp: "A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2160-\u216F\u2183\u24B6-\u24CF\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A", astral: "\uD806[\uDCA0-\uDCBF]|\uD803[\uDC80-\uDCB2]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]|\uD801[\uDC00-\uDC27]|\uD83C[\uDD30-\uDD49\uDD50-\uDD69\uDD70-\uDD89]" }, { name: "White_Space", bmp: "	-\r \x85\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000" }];
  t10.push({ name: "Assigned", inverseOf: "Cn" }), e14.addUnicodeData(t10);
}(Xc), function(e14) {
  if (!e14.addUnicodeData) throw new ReferenceError("Unicode Base must be loaded before Unicode Scripts");
  e14.addUnicodeData([{ name: "Ahom", astral: "\uD805[\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF3F]" }, { name: "Anatolian_Hieroglyphs", astral: "\uD811[\uDC00-\uDE46]" }, { name: "Arabic", bmp: "\u0600-\u0604\u0606-\u060B\u060D-\u061A\u061E\u0620-\u063F\u0641-\u064A\u0656-\u066F\u0671-\u06DC\u06DE-\u06FF\u0750-\u077F\u08A0-\u08B4\u08E3-\u08FF\uFB50-\uFBC1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFD\uFE70-\uFE74\uFE76-\uFEFC", astral: "\uD803[\uDE60-\uDE7E]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB\uDEF0\uDEF1]" }, { name: "Armenian", bmp: "\u0531-\u0556\u0559-\u055F\u0561-\u0587\u058A\u058D-\u058F\uFB13-\uFB17" }, { name: "Avestan", astral: "\uD802[\uDF00-\uDF35\uDF39-\uDF3F]" }, { name: "Balinese", bmp: "\u1B00-\u1B4B\u1B50-\u1B7C" }, { name: "Bamum", bmp: "\uA6A0-\uA6F7", astral: "\uD81A[\uDC00-\uDE38]" }, { name: "Bassa_Vah", astral: "\uD81A[\uDED0-\uDEED\uDEF0-\uDEF5]" }, { name: "Batak", bmp: "\u1BC0-\u1BF3\u1BFC-\u1BFF" }, { name: "Bengali", bmp: "\u0980-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09FB" }, { name: "Bopomofo", bmp: "\u02EA\u02EB\u3105-\u312D\u31A0-\u31BA" }, { name: "Brahmi", astral: "\uD804[\uDC00-\uDC4D\uDC52-\uDC6F\uDC7F]" }, { name: "Braille", bmp: "\u2800-\u28FF" }, { name: "Buginese", bmp: "\u1A00-\u1A1B\u1A1E\u1A1F" }, { name: "Buhid", bmp: "\u1740-\u1753" }, { name: "Canadian_Aboriginal", bmp: "\u1400-\u167F\u18B0-\u18F5" }, { name: "Carian", astral: "\uD800[\uDEA0-\uDED0]" }, { name: "Caucasian_Albanian", astral: "\uD801[\uDD30-\uDD63\uDD6F]" }, { name: "Chakma", astral: "\uD804[\uDD00-\uDD34\uDD36-\uDD43]" }, { name: "Cham", bmp: "\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F" }, { name: "Cherokee", bmp: "\u13A0-\u13F5\u13F8-\u13FD\uAB70-\uABBF" }, { name: "Common", bmp: "\0-@\\x5B-`\\x7B-\xA9\xAB-\xB9\xBB-\xBF\xD7\xF7\u02B9-\u02DF\u02E5-\u02E9\u02EC-\u02FF\u0374\u037E\u0385\u0387\u0589\u0605\u060C\u061B\u061C\u061F\u0640\u06DD\u0964\u0965\u0E3F\u0FD5-\u0FD8\u10FB\u16EB-\u16ED\u1735\u1736\u1802\u1803\u1805\u1CD3\u1CE1\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u2000-\u200B\u200E-\u2064\u2066-\u2070\u2074-\u207E\u2080-\u208E\u20A0-\u20BE\u2100-\u2125\u2127-\u2129\u212C-\u2131\u2133-\u214D\u214F-\u215F\u2189-\u218B\u2190-\u23FA\u2400-\u2426\u2440-\u244A\u2460-\u27FF\u2900-\u2B73\u2B76-\u2B95\u2B98-\u2BB9\u2BBD-\u2BC8\u2BCA-\u2BD1\u2BEC-\u2BEF\u2E00-\u2E42\u2FF0-\u2FFB\u3000-\u3004\u3006\u3008-\u3020\u3030-\u3037\u303C-\u303F\u309B\u309C\u30A0\u30FB\u30FC\u3190-\u319F\u31C0-\u31E3\u3220-\u325F\u327F-\u32CF\u3358-\u33FF\u4DC0-\u4DFF\uA700-\uA721\uA788-\uA78A\uA830-\uA839\uA92E\uA9CF\uAB5B\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFEFF\uFF01-\uFF20\uFF3B-\uFF40\uFF5B-\uFF65\uFF70\uFF9E\uFF9F\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFF9-\uFFFD", astral: "\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDD10-\uDD18\uDD80-\uDD84\uDDC0]|\uD82F[\uDCA0-\uDCA3]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDFCB\uDFCE-\uDFFF]|\uDB40[\uDC01\uDC20-\uDC7F]|\uD83D[\uDC00-\uDD79\uDD7B-\uDDA3\uDDA5-\uDED0\uDEE0-\uDEEC\uDEF0-\uDEF3\uDF00-\uDF73\uDF80-\uDFD4]|\uD800[\uDD00-\uDD02\uDD07-\uDD33\uDD37-\uDD3F\uDD90-\uDD9B\uDDD0-\uDDFC\uDEE1-\uDEFB]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD66\uDD6A-\uDD7A\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDF00-\uDF56\uDF60-\uDF71]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD00-\uDD0C\uDD10-\uDD2E\uDD30-\uDD6B\uDD70-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE10-\uDE3A\uDE40-\uDE48\uDE50\uDE51\uDF00-\uDFFF]" }, { name: "Coptic", bmp: "\u03E2-\u03EF\u2C80-\u2CF3\u2CF9-\u2CFF" }, { name: "Cuneiform", astral: "\uD809[\uDC00-\uDC6E\uDC70-\uDC74\uDC80-\uDD43]|\uD808[\uDC00-\uDF99]" }, { name: "Cypriot", astral: "\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F]" }, { name: "Cyrillic", bmp: "\u0400-\u0484\u0487-\u052F\u1D2B\u1D78\u2DE0-\u2DFF\uA640-\uA69F\uFE2E\uFE2F" }, { name: "Deseret", astral: "\uD801[\uDC00-\uDC4F]" }, { name: "Devanagari", bmp: "\u0900-\u0950\u0953-\u0963\u0966-\u097F\uA8E0-\uA8FD" }, { name: "Duployan", astral: "\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9C-\uDC9F]" }, { name: "Egyptian_Hieroglyphs", astral: "\uD80C[\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]" }, { name: "Elbasan", astral: "\uD801[\uDD00-\uDD27]" }, { name: "Ethiopic", bmp: "\u1200-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u137C\u1380-\u1399\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E" }, { name: "Georgian", bmp: "\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u10FF\u2D00-\u2D25\u2D27\u2D2D" }, { name: "Glagolitic", bmp: "\u2C00-\u2C2E\u2C30-\u2C5E" }, { name: "Gothic", astral: "\uD800[\uDF30-\uDF4A]" }, { name: "Grantha", astral: "\uD804[\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]" }, { name: "Greek", bmp: "\u0370-\u0373\u0375-\u0377\u037A-\u037D\u037F\u0384\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03E1\u03F0-\u03FF\u1D26-\u1D2A\u1D5D-\u1D61\u1D66-\u1D6A\u1DBF\u1F00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FC4\u1FC6-\u1FD3\u1FD6-\u1FDB\u1FDD-\u1FEF\u1FF2-\u1FF4\u1FF6-\u1FFE\u2126\uAB65", astral: "\uD800[\uDD40-\uDD8C\uDDA0]|\uD834[\uDE00-\uDE45]" }, { name: "Gujarati", bmp: "\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AF1\u0AF9" }, { name: "Gurmukhi", bmp: "\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75" }, { name: "Han", bmp: "\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FD5\uF900-\uFA6D\uFA70-\uFAD9", astral: "\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|[\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD87E[\uDC00-\uDE1D]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD873[\uDC00-\uDEA1]" }, { name: "Hangul", bmp: "\u1100-\u11FF\u302E\u302F\u3131-\u318E\u3200-\u321E\u3260-\u327E\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC" }, { name: "Hanunoo", bmp: "\u1720-\u1734" }, { name: "Hatran", astral: "\uD802[\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDCFF]" }, { name: "Hebrew", bmp: "\u0591-\u05C7\u05D0-\u05EA\u05F0-\u05F4\uFB1D-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFB4F" }, { name: "Hiragana", bmp: "\u3041-\u3096\u309D-\u309F", astral: "\u{1B001}|\u{1F200}" }, { name: "Imperial_Aramaic", astral: "\uD802[\uDC40-\uDC55\uDC57-\uDC5F]" }, { name: "Inherited", bmp: "\u0300-\u036F\u0485\u0486\u064B-\u0655\u0670\u0951\u0952\u1AB0-\u1ABE\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFC-\u1DFF\u200C\u200D\u20D0-\u20F0\u302A-\u302D\u3099\u309A\uFE00-\uFE0F\uFE20-\uFE2D", astral: "\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD]|\uD800[\uDDFD\uDEE0]|\uDB40[\uDD00-\uDDEF]" }, { name: "Inscriptional_Pahlavi", astral: "\uD802[\uDF60-\uDF72\uDF78-\uDF7F]" }, { name: "Inscriptional_Parthian", astral: "\uD802[\uDF40-\uDF55\uDF58-\uDF5F]" }, { name: "Javanese", bmp: "\uA980-\uA9CD\uA9D0-\uA9D9\uA9DE\uA9DF" }, { name: "Kaithi", astral: "\uD804[\uDC80-\uDCC1]" }, { name: "Kannada", bmp: "\u0C81-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2" }, { name: "Katakana", bmp: "\u30A1-\u30FA\u30FD-\u30FF\u31F0-\u31FF\u32D0-\u32FE\u3300-\u3357\uFF66-\uFF6F\uFF71-\uFF9D", astral: "\u{1B000}" }, { name: "Kayah_Li", bmp: "\uA900-\uA92D\uA92F" }, { name: "Kharoshthi", astral: "\uD802[\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F-\uDE47\uDE50-\uDE58]" }, { name: "Khmer", bmp: "\u1780-\u17DD\u17E0-\u17E9\u17F0-\u17F9\u19E0-\u19FF" }, { name: "Khojki", astral: "\uD804[\uDE00-\uDE11\uDE13-\uDE3D]" }, { name: "Khudawadi", astral: "\uD804[\uDEB0-\uDEEA\uDEF0-\uDEF9]" }, { name: "Lao", bmp: "\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF" }, { name: "Latin", bmp: "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A" }, { name: "Lepcha", bmp: "\u1C00-\u1C37\u1C3B-\u1C49\u1C4D-\u1C4F" }, { name: "Limbu", bmp: "\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1940\u1944-\u194F" }, { name: "Linear_A", astral: "\uD801[\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]" }, { name: "Linear_B", astral: "\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA]" }, { name: "Lisu", bmp: "\uA4D0-\uA4FF" }, { name: "Lycian", astral: "\uD800[\uDE80-\uDE9C]" }, { name: "Lydian", astral: "\uD802[\uDD20-\uDD39\uDD3F]" }, { name: "Mahajani", astral: "\uD804[\uDD50-\uDD76]" }, { name: "Malayalam", bmp: "\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D57\u0D5F-\u0D63\u0D66-\u0D75\u0D79-\u0D7F" }, { name: "Mandaic", bmp: "\u0840-\u085B\u085E" }, { name: "Manichaean", astral: "\uD802[\uDEC0-\uDEE6\uDEEB-\uDEF6]" }, { name: "Meetei_Mayek", bmp: "\uAAE0-\uAAF6\uABC0-\uABED\uABF0-\uABF9" }, { name: "Mende_Kikakui", astral: "\uD83A[\uDC00-\uDCC4\uDCC7-\uDCD6]" }, { name: "Meroitic_Cursive", astral: "\uD802[\uDDA0-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDDFF]" }, { name: "Meroitic_Hieroglyphs", astral: "\uD802[\uDD80-\uDD9F]" }, { name: "Miao", astral: "\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F]" }, { name: "Modi", astral: "\uD805[\uDE00-\uDE44\uDE50-\uDE59]" }, { name: "Mongolian", bmp: "\u1800\u1801\u1804\u1806-\u180E\u1810-\u1819\u1820-\u1877\u1880-\u18AA" }, { name: "Mro", astral: "\uD81A[\uDE40-\uDE5E\uDE60-\uDE69\uDE6E\uDE6F]" }, { name: "Multani", astral: "\uD804[\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA9]" }, { name: "Myanmar", bmp: "\u1000-\u109F\uA9E0-\uA9FE\uAA60-\uAA7F" }, { name: "Nabataean", astral: "\uD802[\uDC80-\uDC9E\uDCA7-\uDCAF]" }, { name: "New_Tai_Lue", bmp: "\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u19DE\u19DF" }, { name: "Nko", bmp: "\u07C0-\u07FA" }, { name: "Ogham", bmp: "\u1680-\u169C" }, { name: "Ol_Chiki", bmp: "\u1C50-\u1C7F" }, { name: "Old_Hungarian", astral: "\uD803[\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDCFF]" }, { name: "Old_Italic", astral: "\uD800[\uDF00-\uDF23]" }, { name: "Old_North_Arabian", astral: "\uD802[\uDE80-\uDE9F]" }, { name: "Old_Permic", astral: "\uD800[\uDF50-\uDF7A]" }, { name: "Old_Persian", astral: "\uD800[\uDFA0-\uDFC3\uDFC8-\uDFD5]" }, { name: "Old_South_Arabian", astral: "\uD802[\uDE60-\uDE7F]" }, { name: "Old_Turkic", astral: "\uD803[\uDC00-\uDC48]" }, { name: "Oriya", bmp: "\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B77" }, { name: "Osmanya", astral: "\uD801[\uDC80-\uDC9D\uDCA0-\uDCA9]" }, { name: "Pahawh_Hmong", astral: "\uD81A[\uDF00-\uDF45\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]" }, { name: "Palmyrene", astral: "\uD802[\uDC60-\uDC7F]" }, { name: "Pau_Cin_Hau", astral: "\uD806[\uDEC0-\uDEF8]" }, { name: "Phags_Pa", bmp: "\uA840-\uA877" }, { name: "Phoenician", astral: "\uD802[\uDD00-\uDD1B\uDD1F]" }, { name: "Psalter_Pahlavi", astral: "\uD802[\uDF80-\uDF91\uDF99-\uDF9C\uDFA9-\uDFAF]" }, { name: "Rejang", bmp: "\uA930-\uA953\uA95F" }, { name: "Runic", bmp: "\u16A0-\u16EA\u16EE-\u16F8" }, { name: "Samaritan", bmp: "\u0800-\u082D\u0830-\u083E" }, { name: "Saurashtra", bmp: "\uA880-\uA8C4\uA8CE-\uA8D9" }, { name: "Sharada", astral: "\uD804[\uDD80-\uDDCD\uDDD0-\uDDDF]" }, { name: "Shavian", astral: "\uD801[\uDC50-\uDC7F]" }, { name: "Siddham", astral: "\uD805[\uDD80-\uDDB5\uDDB8-\uDDDD]" }, { name: "SignWriting", astral: "\uD836[\uDC00-\uDE8B\uDE9B-\uDE9F\uDEA1-\uDEAF]" }, { name: "Sinhala", bmp: "\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2-\u0DF4", astral: "\uD804[\uDDE1-\uDDF4]" }, { name: "Sora_Sompeng", astral: "\uD804[\uDCD0-\uDCE8\uDCF0-\uDCF9]" }, { name: "Sundanese", bmp: "\u1B80-\u1BBF\u1CC0-\u1CC7" }, { name: "Syloti_Nagri", bmp: "\uA800-\uA82B" }, { name: "Syriac", bmp: "\u0700-\u070D\u070F-\u074A\u074D-\u074F" }, { name: "Tagalog", bmp: "\u1700-\u170C\u170E-\u1714" }, { name: "Tagbanwa", bmp: "\u1760-\u176C\u176E-\u1770\u1772\u1773" }, { name: "Tai_Le", bmp: "\u1950-\u196D\u1970-\u1974" }, { name: "Tai_Tham", bmp: "\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA0-\u1AAD" }, { name: "Tai_Viet", bmp: "\uAA80-\uAAC2\uAADB-\uAADF" }, { name: "Takri", astral: "\uD805[\uDE80-\uDEB7\uDEC0-\uDEC9]" }, { name: "Tamil", bmp: "\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BFA" }, { name: "Telugu", bmp: "\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C78-\u0C7F" }, { name: "Thaana", bmp: "\u0780-\u07B1" }, { name: "Thai", bmp: "\u0E01-\u0E3A\u0E40-\u0E5B" }, { name: "Tibetan", bmp: "\u0F00-\u0F47\u0F49-\u0F6C\u0F71-\u0F97\u0F99-\u0FBC\u0FBE-\u0FCC\u0FCE-\u0FD4\u0FD9\u0FDA" }, { name: "Tifinagh", bmp: "\u2D30-\u2D67\u2D6F\u2D70\u2D7F" }, { name: "Tirhuta", astral: "\uD805[\uDC80-\uDCC7\uDCD0-\uDCD9]" }, { name: "Ugaritic", astral: "\uD800[\uDF80-\uDF9D\uDF9F]" }, { name: "Vai", bmp: "\uA500-\uA62B" }, { name: "Warang_Citi", astral: "\uD806[\uDCA0-\uDCF2\uDCFF]" }, { name: "Yi", bmp: "\uA000-\uA48C\uA490-\uA4C6" }]);
}(Xc);
var Jc = W(Xc);
const Qc = (e14) => e14 && Jc("^\\pL[\\pL_\\d]*$").test(e14) || false;
const eu = { fields: "Fields", globals: "Globals", parameters: "Parameters", reportitems: "ReportItems", themeimages: "Theme.Images", user: "User", usercontext: "UserContext", partproperties: "PartProperties" };
const tu = { "^": 3.6, "*": 3.5, "/": 3.5, "\\": 3.4, mod: 3.3, "+": 3.2, "-": 3.2, "&": 3.1, "<<": 3, ">>": 3, "<": 2, ">": 2, "<=": 2, ">=": 2, "=": 2, "<>": 2, is: 2, like: 2, and: 1.2, andalso: 1.2, or: 1.1, orelse: 1.1, xor: 1 };
const nu = { not: 1.3, "-": 3.55, "+": 3.55 };
function ru(e14) {
  return `"${e14.replace(/"/g, '""')}"`;
}
function ou(e14, t10) {
  const n10 = nu[t10.op];
  return `${t10.op}${0 === t10.op.localeCompare("not", "en", { sensitivity: "base" }) ? " " : ""}${((t11) => "infix" === t11.type || "binary" === t11.type ? au(n10, e14, t11) : e14(t11))(t10.operand)}`;
}
function au(e14, t10, n10, r10 = true) {
  const o10 = tu[n10.op];
  const a10 = ("infix" === n10.type ? n10.operands : [n10.leftOperand, n10.rightOperand]).map((e15, n11) => "infix" === e15.type || "binary" === e15.type ? au(o10, t10, e15, 0 === n11) : t10(e15)).join(` ${n10.op} `);
  return o10 < e14 || !r10 && o10 === e14 ? `(${a10})` : a10;
}
function iu(e14) {
  var _a2;
  function t10(e15) {
    return "binary" === e15.thisArg.type || "infix" === e15.thisArg.type ? `(${iu(e15.thisArg)})` : iu(e15.thisArg);
  }
  switch (e14.type) {
    case "const":
      return "string" == typeof e14.value ? ru(e14.value) : ((_a2 = e14.value) == null ? void 0 : _a2.toString()) || "null";
    case "field":
      if (!function(e15) {
        const t11 = e15.toLowerCase();
        return Yl.constants.includes(t11) || Yl.variables.includes(t11);
      }(e14.fieldName)) {
        if (Qc(e14.fieldName)) return e14.fieldName;
        if (!function(e15, t11) {
          return null != t11 && e15.findIndex((e16) => t11.includes(e16)) >= 0;
        }(["]", "#", "@", "&"], e14.fieldName)) return `[${e14.fieldName}]`;
      }
      return `Fields.Item(${ru(e14.fieldName)}).Value`;
    case "global":
      return Qc(e14.name) ? `&${e14.name}` : `Globals.Item(${ru(e14.name)})`;
    case "parameter":
      return Qc(e14.name) ? `@${e14.name}` : `Parameters.Item(${ru(e14.name)}).Value`;
    case "reportitem":
      return Qc(e14.name) ? `#${e14.name}` : `ReportItems.Item(${ru(e14.name)}).Value`;
    case "unary":
      return ou(iu, e14);
    case "binary":
    case "infix":
      return au(0, iu, e14);
    case "fn":
      return `${e14.funcName}(${e14.args.map(iu).join(", ")})`;
    case "method":
      return `${t10(e14)}.${e14.methodName}(${e14.args.map(iu).join(", ")})`;
    case "prop":
      return `${t10(e14)}.${e14.propName}`;
    case "variable":
      return `${e14.name}`;
    case "collectionitem":
      return cu(e14.collection, e14.itemName, e14.propertyName);
    case "scope":
      return e14.quote ? `"${e14.name}"` : `${e14.name}`;
  }
  throw new Error("Invalid node type");
}
const su = { imagedata: "ImageData", name: "Name" };
const lu = (e14, t10) => {
  var _a2;
  const n10 = eu.themeimages;
  const r10 = t10 ? `.${(_a2 = su[t10]) != null ? _a2 : t10}` : "";
  return Qc(e14) ? `${n10}!${e14}${r10}` : `${n10}(${ru(e14)})${r10}`;
};
function cu(e14, t10, n10 = null) {
  var _a2;
  if ("themeimages" === e14) return lu(t10, n10);
  const r10 = (_a2 = eu[e14]) != null ? _a2 : e14;
  const o10 = n10 ? `.${n10}` : "";
  return Qc(t10) ? `${r10}!${t10}${o10}` : `${r10}.Item(${ru(t10)})${o10}`;
}
function uu(e14) {
  return `${e14.replace(/{/g, "{{")}`;
}
function du(e14) {
  var _a2;
  function t10(e15) {
    return "binary" === e15.thisArg.type || "infix" === e15.thisArg.type ? `(${du(e15.thisArg)})` : du(e15.thisArg);
  }
  switch (e14.type) {
    case "const":
      return "string" == typeof e14.value ? ru(e14.value) : ((_a2 = e14.value) == null ? void 0 : _a2.toString()) || "null";
    case "field":
      return cu("fields", e14.fieldName, "Value");
    case "global":
      return cu("globals", e14.name);
    case "parameter":
      return cu("parameters", e14.name, "Value");
    case "reportitem":
      return cu("reportitems", e14.name, "Value");
    case "unary":
      return ou(du, e14);
    case "binary":
    case "infix":
      return au(0, du, e14);
    case "fn":
      return `${e14.funcName}(${e14.args.map(du).join(", ")})`;
    case "method":
      return `${t10(e14)}.${e14.methodName}(${e14.args.map(du).join(", ")})`;
    case "prop":
      return `${t10(e14)}.${e14.propName}`;
    case "variable":
      return `${e14.name}`;
    case "collectionitem":
      return cu(e14.collection, e14.itemName, e14.propertyName);
    case "scope":
      return e14.quote ? `"${e14.name}"` : `${e14.name}`;
  }
  throw new Error("Invalid node type");
}
function pu(e14) {
  switch (e14.type) {
    case "const":
      return "string" != typeof e14.value || e14.value.startsWith("=") ? `=${du(e14)}` : e14.value;
    case "field":
      return `=${du(e14)}`;
    case "expression": {
      const t10 = e14.pieces.map((e15) => {
        switch (e15.type) {
          case "ex":
            return du(e15.expression);
          case "literal":
            return ru(e15.text);
          default:
            return "";
        }
      });
      return `=${t10.join(" & ")}`;
    }
    case "invalid":
      return e14.text;
  }
  throw new Error("Invalid expression type");
}
function mu(e14, t10) {
  return "i11n" === e14 ? function(e15) {
    switch (e15.type) {
      case "const":
        return "string" == typeof e15.value ? uu(e15.value) : `{${iu(e15)}}`;
      case "field":
        return `{${iu(e15)}}`;
      case "expression": {
        const t11 = e15.pieces.map((e16) => {
          switch (e16.type) {
            case "ex":
              return `{${iu(e16.expression)}}`;
            case "literal":
              return uu(e16.text);
            default:
              return "";
          }
        });
        return "".concat(...t11);
      }
      case "invalid":
        return e15.text;
    }
    throw new Error("Invalid expression type");
  }(t10) : pu(t10);
}
const hu = (e14) => mu("i11n", fc("rdl", e14));
const fu = (e14) => mu("rdl", fc("i11n", e14));
function gu(e14) {
  return `=${du(e14)}`;
}
const yu = { "=": "Equal", ">": "GreaterThan", "<": "LessThan", ">=": "GreaterThanOrEqual", "<=": "LessThanOrEqual", "<>": "NotEqual", like: "Like", is: "EqualTo" };
const vu = {};
Object.entries(yu).forEach(([e14, t10]) => {
  vu[t10] = e14;
});
const bu = (e14) => e14.hasOwnProperty("items");
const Su = (e14) => "invalid" === e14.type;
const Cu = (e14) => "invalid" !== e14.type;
const xu = (e14, t10, n10) => ({ Type: "filter", FilterExpression: e14, Operator: t10, FilterValues: n10 });
const wu = (e14, t10, n10) => ({ type: "binary", op: e14, leftOperand: t10, rightOperand: n10 });
const Tu = (e14, t10) => ({ type: "infix", op: e14, operands: t10 });
const Eu = (e14) => ({ type: "parameter", name: e14 });
const Fu = (e14) => ({ type: "field", fieldName: e14 });
const Mu = (e14) => ({ type: "const", value: e14 });
function ku(e14) {
  var _a2, _b2;
  return Su(e14) ? e14.text : "const" === e14.type ? (_b2 = (_a2 = e14.value) == null ? void 0 : _a2.toString()) != null ? _b2 : "" : gu(e14);
}
function Pu(e14) {
  if (!e14 || !e14.items) return e14;
  const t10 = e14.operator || "and";
  const n10 = [];
  return e14.items.forEach((e15) => {
    if (bu(e15)) {
      const r10 = Pu(e15);
      if (r10.operator === t10) return void n10.push(...r10.items);
    }
    n10.push(e15);
  }), Ru(t10, n10);
}
function Nu(e14) {
  if (!e14 || !e14.items || !e14.items.length) return [];
  const t10 = Pu(e14);
  return t10.operator && "and" !== t10.operator ? "or" === t10.operator ? [Lu(t10)].filter(Ie) : [] : t10.items.map((e15) => Du(e15)).filter(Ie);
}
function Du(e14) {
  return bu(e14) ? Lu(e14) : function(e15) {
    const { field: t10, operator: n10, value: r10 } = e15;
    if (!t10 || !r10 || !n10) return null;
    const o10 = Vu(t10);
    const a10 = ku(o10);
    if ("between" === r10.type) {
      const e16 = ku(_u(r10.from));
      const t11 = ku(_u(r10.to));
      return xu(a10, "Between", [e16, t11]);
    }
    if ("list" === r10.type) return xu(a10, n10, r10.value);
    const i10 = _u(r10);
    const s10 = ku(i10);
    return xu(a10, n10, [s10]);
  }(e14);
}
function Lu(e14) {
  if (1 === e14.items.length) return Du(e14.items[0]);
  const t10 = Iu(e14);
  return null === t10 ? null : xu(gu(t10), "Equal", ["True"]);
}
function Hu(e14) {
  return bu(e14) ? Iu(e14) : function(e15) {
    const { field: t10, operator: n10, value: r10 } = e15;
    if (!t10 || !r10 || !n10) return null;
    if ("Equal" === n10 && "simple" === r10.type && "True" === r10.value && "expression" === t10.type) {
      const e16 = hc(t10.value);
      if (Cu(e16)) return e16;
    }
    if ("list" === r10.type) return null;
    if (n10 in vu && "between" !== r10.type) {
      const e16 = vu[n10];
      const o10 = Vu(t10);
      const a10 = _u(r10);
      if (Cu(o10) && Cu(a10)) return wu(e16, o10, a10);
    }
    return null;
  }(e14);
}
function Iu(e14) {
  const t10 = e14.items.map((e15) => Hu(e15)).filter(Ie);
  return t10.length > 1 ? Tu(e14.operator, t10) : 1 === t10.length ? t10[0] : null;
}
function _u(e14) {
  return "parameter" === e14.type ? Eu(e14.value) : "simple" === e14.type ? Mu(e14.value) : "field" === e14.type ? Fu(e14.value) : hc(e14.value);
}
function Vu(e14) {
  return "generic" === e14.type ? Fu(e14.value) : "parameter" === e14.type ? Eu(e14.value) : hc(e14.value);
}
const Ru = (e14, t10) => ({ operator: e14, items: t10 });
const Au = (e14, t10) => ({ Type: "filter", operator: e14, items: t10 });
const Ou = (e14, t10, n10) => ({ field: e14, operator: t10, value: n10 });
const Bu = (e14) => ({ type: "generic", value: e14 });
const zu = (e14) => ({ type: "parameter", value: e14 });
const $u = (e14) => ({ type: "expression", value: e14 });
const Wu = (e14) => ({ type: "simple", value: e14 });
const ju = (e14) => ({ type: "parameter", value: e14 });
const Zu = (e14) => ({ type: "expression", value: e14 });
const Gu = (e14, t10) => ({ type: "between", from: e14, to: t10 });
const Uu = (e14) => ({ type: "list", value: e14 });
const qu = (e14) => {
  var _a2;
  return (_a2 = e14 == null ? void 0 : e14.toString()) != null ? _a2 : "";
};
function Yu(e14) {
  if (!e14 || !e14.length) return Au("and", []);
  if (1 === e14.length) {
    const t10 = Ku(e14[0]);
    return bu(t10) ? Au(t10.operator, t10.items) : Au("and", [t10]);
  }
  return Au("and", e14.map((e15) => Ku(e15)));
}
function Ku(e14) {
  var _a2, _b2;
  const t10 = qu(e14.FilterExpression);
  const n10 = e14.Operator;
  const r10 = (_b2 = (_a2 = e14.FilterValues) == null ? void 0 : _a2.map(qu)) != null ? _b2 : [""];
  const o10 = r10[0];
  const a10 = hc(t10);
  if ("infix" === a10.type && "or" === a10.op && "Equal" === n10 && "True" === o10) {
    const e15 = a10.operands.map((e16) => Xu(e16));
    return Ju(a10.op, e15);
  }
  const i10 = ed(a10);
  const s10 = r10.map(hc);
  if ("Between" === n10) {
    const e15 = Qu(s10[0]);
    const t11 = Qu(s10[1]);
    return Ou(i10, "Between", Gu(e15, t11));
  }
  if ("In" === n10 && (r10.length > 1 || !o10.startsWith("="))) return Ou(i10, n10, Uu(r10));
  const l10 = Qu(s10[0]);
  return Ou(i10, n10, l10);
}
function Xu(e14) {
  if ("infix" === e14.type && ("and" === e14.op || "or" === e14.op)) {
    const t10 = e14.operands.map((e15) => Xu(e15));
    return Ju(e14.op, t10);
  }
  if ("binary" === e14.type && e14.op in yu) {
    const t10 = yu[e14.op];
    const n10 = ed(e14.leftOperand);
    const r10 = Qu(e14.rightOperand);
    return Ou(n10, t10, r10);
  }
  return Ou(ed(e14), "Equal", Wu("True"));
}
function Ju(e14, t10) {
  const n10 = Ru(e14, []);
  return t10.forEach((t11) => {
    bu(t11) && t11.operator === e14 ? n10.items.push(...t11.items) : n10.items.push(t11);
  }), n10;
}
function Qu(e14) {
  var _a2;
  return "parameter" === e14.type ? ju(e14.name) : "const" === e14.type ? Wu(((_a2 = e14.value) == null ? void 0 : _a2.toString()) || "") : "invalid" === e14.type ? Wu(e14.text) : Zu(gu(e14));
}
function ed(e14) {
  return "field" === e14.type ? Bu(e14.fieldName) : "parameter" === e14.type ? zu(e14.name) : "invalid" === e14.type ? $u(e14.text) : $u(gu(e14));
}
function td(e14, t10, n10) {
  if (0 === e14.length && void 0 === n10) return;
  const r10 = void 0 === n10 ? [] : [{ Name: t10, Value: n10 }];
  const o10 = e14.findIndex((e15) => e15.Name === t10);
  o10 >= 0 ? e14.splice(o10, 1, ...r10) : e14.push(...r10);
}
const nd = (e14) => (t10) => ({ decode: (n10) => {
  var _a2;
  const r10 = t10.decode(n10);
  if ("error" === r10.type) return r10;
  const o10 = r10.value.CustomProperties;
  const a10 = {};
  for (const t11 in e14) {
    if (!{}.hasOwnProperty.call(e14, t11)) continue;
    if (!e14[t11]) return Z.Dsl.failure(`${t11}: missing property`);
    const n11 = (_a2 = o10.find(({ Name: n12 }) => n12 === e14[t11].Prop)) == null ? void 0 : _a2.Value;
    let r11 = e14[t11].Decoder.decode(n11);
    if ("error" === r11.type && (r11 = e14[t11].Decoder.decode(null)), "error" === r11.type) return Z.Dsl.failure(`${t11}: failed to decode by ${r11.reason}`);
    const i10 = Z.Dsl.resultOf(r11);
    void 0 !== i10 && (a10[t11] = i10);
  }
  return Z.Dsl.success(__spreadValues(__spreadValues({}, r10.value), a10));
}, encode: (_a2) => {
  var _b2 = _a2, { CustomProperties: n10 } = _b2, r10 = __objRest(_b2, ["CustomProperties"]);
  const o10 = r10;
  for (const t11 in e14) {
    if (!{}.hasOwnProperty.call(e14, t11)) continue;
    if (!e14[t11]) return Z.Dsl.failure(`${t11}: missing property`);
    td(n10, e14[t11].Prop, e14[t11].Decoder.encode(r10[t11])), delete o10[t11];
  }
  return t10.encode(__spreadProps(__spreadValues({}, o10), { CustomProperties: n10 }));
} });
const rd = (e14) => Z.Dsl.map((t10) => __spreadValues(__spreadValues({}, t10), e14), (e15) => e15);
const od = (e14, t10) => ({ decode: (n10) => {
  const r10 = t10.decode(n10);
  return "success" === r10.type ? r10 : (Z.Dsl.recordFailure({ type: "error", message: r10.reason }), Z.Dsl.success(e14));
}, encode: (e15) => t10.encode(e15) });
const { ReportParameter: ad } = Z.BasicModel;
const id = Z.Lenses.make(Yu, Nu);
Z.Dsl.pipe(Z.BasicModel.Filters, Z.Lenses.mapOfLens(id));
const sd = Z.Dsl.pipe(Z.BasicModel.DataSource, Z.Dsl.intersectWith(Z.Dsl.type({ $id: Z.Dsl.optional(Z.Dsl.string) })), ((e14) => Z.Dsl.map((t10) => __spreadValues(__spreadValues({}, t10), e14(t10)), (e15) => e15))((e14) => ({ $dataProvider: e14.ConnectionProperties.DataProvider })), Z.Dsl.required("Name"));
const ld = Z.Dsl.pipe(Z.BasicModel.DataSet, Z.Dsl.intersectWith(Z.Dsl.type({ $fieldsInfo: Z.Dsl.optional(Z.Dsl.string) })), rd({ $queryFilter: null }), rd({ $parentReference: null }), rd({ $childrenReferences: [] }), Z.Lenses.mapOfLens(Z.Lenses.prop("Filters", id)), Z.Dsl.map((_a2) => {
  var _b2 = _a2, { $fieldsInfo: e14 } = _b2, t10 = __objRest(_b2, ["$fieldsInfo"]);
  const n10 = e14 ? JSON.parse(e14) : {};
  const r10 = t10.Fields.filter((e15) => e15.Name && e15.Name.length > 0).map((e15) => {
    var _a3, _b3;
    const t11 = n10[e15.Name];
    const r11 = __spreadProps(__spreadValues({}, e15), { DataType: (_a3 = t11 == null ? void 0 : t11.dataType) != null ? _a3 : "", Aggregate: (_b3 = t11 == null ? void 0 : t11.aggregate) != null ? _b3 : "" });
    return "string" == typeof (t11 == null ? void 0 : t11.format) && (r11.Format = t11.format), r11;
  });
  return __spreadProps(__spreadValues({}, t10), { Fields: r10.filter((e15) => e15.DataField), $calculatedFields: r10.filter((e15) => !e15.DataField), Collation: t10.Collation || "Default" });
}, (_c2) => {
  var _d2 = _c2, { $calculatedFields: e14 } = _d2, t10 = __objRest(_d2, ["$calculatedFields"]);
  const n10 = t10.Fields.concat(...e14 || []);
  const r10 = {};
  n10.forEach(({ Name: e15, Aggregate: t11, DataType: n11, Format: o11 }) => {
    (t11 || n11) && (r10[e15] = { aggregate: t11 || void 0, dataType: n11 || void 0, format: o11 });
  });
  const o10 = Object.getOwnPropertyNames(r10).length > 0 ? JSON.stringify(r10) : void 0;
  return __spreadProps(__spreadValues({}, t10), { Fields: n10.map((_a2) => {
    var _b2 = _a2, { DataType: e15, Aggregate: t11, Format: n11, Value: r11 } = _b2, o11 = __objRest(_b2, ["DataType", "Aggregate", "Format", "Value"]);
    return __spreadProps(__spreadValues({}, o11), { Value: r11 != null ? r11 : "" });
  }), $fieldsInfo: o10, Collation: "Default" === t10.Collation ? "" : t10.Collation });
}));
var cd = { exports: {} };
var ud = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var dd = Object.getOwnPropertySymbols;
var pd = Object.prototype.hasOwnProperty;
var md = Object.prototype.propertyIsEnumerable;
var hd = function() {
  try {
    if (!Object.assign) return false;
    var e14 = new String("abc");
    if (e14[5] = "de", "5" === Object.getOwnPropertyNames(e14)[0]) return false;
    var t10 = {};
    for (var n10 = 0; n10 < 10; n10++) t10["_" + String.fromCharCode(n10)] = n10;
    var r10 = Object.getOwnPropertyNames(t10).map(function(e15) {
      return t10[e15];
    });
    if ("0123456789" !== r10.join("")) return false;
    var o10 = {};
    return "abcdefghijklmnopqrst".split("").forEach(function(e15) {
      o10[e15] = e15;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, o10)).join("");
  } catch (e15) {
    return false;
  }
}() ? Object.assign : function(e14, t10) {
  var n10;
  var r10 = function(e15) {
    if (null == e15) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(e15);
  }(e14);
  var o10;
  for (var a10 = 1; a10 < arguments.length; a10++) {
    for (var i10 in n10 = Object(arguments[a10])) pd.call(n10, i10) && (r10[i10] = n10[i10]);
    if (dd) {
      o10 = dd(n10);
      for (var s10 = 0; s10 < o10.length; s10++) md.call(n10, o10[s10]) && (r10[o10[s10]] = n10[o10[s10]]);
    }
  }
  return r10;
};
/** @license React v16.13.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fd = hd, gd = "function" == typeof Symbol && Symbol.for, yd = gd ? Symbol.for("react.element") : 60103, vd = gd ? Symbol.for("react.portal") : 60106, bd = gd ? Symbol.for("react.fragment") : 60107, Sd = gd ? Symbol.for("react.strict_mode") : 60108, Cd = gd ? Symbol.for("react.profiler") : 60114, xd = gd ? Symbol.for("react.provider") : 60109, wd = gd ? Symbol.for("react.context") : 60110, Td = gd ? Symbol.for("react.forward_ref") : 60112, Ed = gd ? Symbol.for("react.suspense") : 60113, Fd = gd ? Symbol.for("react.memo") : 60115, Md = gd ? Symbol.for("react.lazy") : 60116, kd = "function" == typeof Symbol && Symbol.iterator;
function Pd(e14) {
  for (var t10 = "https://reactjs.org/docs/error-decoder.html?invariant=" + e14, n10 = 1; n10 < arguments.length; n10++) t10 += "&args[]=" + encodeURIComponent(arguments[n10]);
  return "Minified React error #" + e14 + "; visit " + t10 + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var Nd = { isMounted: function() {
  return false;
}, enqueueForceUpdate: function() {
}, enqueueReplaceState: function() {
}, enqueueSetState: function() {
} }, Dd = {};
function Ld(e14, t10, n10) {
  this.props = e14, this.context = t10, this.refs = Dd, this.updater = n10 || Nd;
}
function Hd() {
}
function Id(e14, t10, n10) {
  this.props = e14, this.context = t10, this.refs = Dd, this.updater = n10 || Nd;
}
Ld.prototype.isReactComponent = {}, Ld.prototype.setState = function(e14, t10) {
  if ("object" != typeof e14 && "function" != typeof e14 && null != e14) throw Error(Pd(85));
  this.updater.enqueueSetState(this, e14, t10, "setState");
}, Ld.prototype.forceUpdate = function(e14) {
  this.updater.enqueueForceUpdate(this, e14, "forceUpdate");
}, Hd.prototype = Ld.prototype;
var _d = Id.prototype = new Hd();
_d.constructor = Id, fd(_d, Ld.prototype), _d.isPureReactComponent = true;
var Vd = { current: null }, Rd = Object.prototype.hasOwnProperty, Ad = { key: true, ref: true, __self: true, __source: true };
function Od(e14, t10, n10) {
  var r10, o10 = {}, a10 = null, i10 = null;
  if (null != t10) for (r10 in void 0 !== t10.ref && (i10 = t10.ref), void 0 !== t10.key && (a10 = "" + t10.key), t10) Rd.call(t10, r10) && !Ad.hasOwnProperty(r10) && (o10[r10] = t10[r10]);
  var s10 = arguments.length - 2;
  if (1 === s10) o10.children = n10;
  else if (1 < s10) {
    for (var l10 = Array(s10), c10 = 0; c10 < s10; c10++) l10[c10] = arguments[c10 + 2];
    o10.children = l10;
  }
  if (e14 && e14.defaultProps) for (r10 in s10 = e14.defaultProps) void 0 === o10[r10] && (o10[r10] = s10[r10]);
  return { $$typeof: yd, type: e14, key: a10, ref: i10, props: o10, _owner: Vd.current };
}
function Bd(e14) {
  return "object" == typeof e14 && null !== e14 && e14.$$typeof === yd;
}
var zd = /\/+/g, $d = [];
function Wd(e14, t10, n10, r10) {
  if ($d.length) {
    var o10 = $d.pop();
    return o10.result = e14, o10.keyPrefix = t10, o10.func = n10, o10.context = r10, o10.count = 0, o10;
  }
  return { result: e14, keyPrefix: t10, func: n10, context: r10, count: 0 };
}
function jd(e14) {
  e14.result = null, e14.keyPrefix = null, e14.func = null, e14.context = null, e14.count = 0, 10 > $d.length && $d.push(e14);
}
function Zd(e14, t10, n10, r10) {
  var o10 = typeof e14;
  "undefined" !== o10 && "boolean" !== o10 || (e14 = null);
  var a10 = false;
  if (null === e14) a10 = true;
  else switch (o10) {
    case "string":
    case "number":
      a10 = true;
      break;
    case "object":
      switch (e14.$$typeof) {
        case yd:
        case vd:
          a10 = true;
      }
  }
  if (a10) return n10(r10, e14, "" === t10 ? "." + Ud(e14, 0) : t10), 1;
  if (a10 = 0, t10 = "" === t10 ? "." : t10 + ":", Array.isArray(e14)) for (var i10 = 0; i10 < e14.length; i10++) {
    var s10 = t10 + Ud(o10 = e14[i10], i10);
    a10 += Zd(o10, s10, n10, r10);
  }
  else if (null === e14 || "object" != typeof e14 ? s10 = null : s10 = "function" == typeof (s10 = kd && e14[kd] || e14["@@iterator"]) ? s10 : null, "function" == typeof s10) for (e14 = s10.call(e14), i10 = 0; !(o10 = e14.next()).done; ) a10 += Zd(o10 = o10.value, s10 = t10 + Ud(o10, i10++), n10, r10);
  else if ("object" === o10) throw n10 = "" + e14, Error(Pd(31, "[object Object]" === n10 ? "object with keys {" + Object.keys(e14).join(", ") + "}" : n10, ""));
  return a10;
}
function Gd(e14, t10, n10) {
  return null == e14 ? 0 : Zd(e14, "", t10, n10);
}
function Ud(e14, t10) {
  return "object" == typeof e14 && null !== e14 && null != e14.key ? function(e15) {
    var t11 = { "=": "=0", ":": "=2" };
    return "$" + ("" + e15).replace(/[=:]/g, function(e16) {
      return t11[e16];
    });
  }(e14.key) : t10.toString(36);
}
function qd(e14, t10) {
  e14.func.call(e14.context, t10, e14.count++);
}
function Yd(e14, t10, n10) {
  var r10 = e14.result, o10 = e14.keyPrefix;
  e14 = e14.func.call(e14.context, t10, e14.count++), Array.isArray(e14) ? Kd(e14, r10, n10, function(e15) {
    return e15;
  }) : null != e14 && (Bd(e14) && (e14 = function(e15, t11) {
    return { $$typeof: yd, type: e15.type, key: t11, ref: e15.ref, props: e15.props, _owner: e15._owner };
  }(e14, o10 + (!e14.key || t10 && t10.key === e14.key ? "" : ("" + e14.key).replace(zd, "$&/") + "/") + n10)), r10.push(e14));
}
function Kd(e14, t10, n10, r10, o10) {
  var a10 = "";
  null != n10 && (a10 = ("" + n10).replace(zd, "$&/") + "/"), Gd(e14, Yd, t10 = Wd(t10, a10, r10, o10)), jd(t10);
}
var Xd = { current: null };
function Jd() {
  var e14 = Xd.current;
  if (null === e14) throw Error(Pd(321));
  return e14;
}
var Qd = { ReactCurrentDispatcher: Xd, ReactCurrentBatchConfig: { suspense: null }, ReactCurrentOwner: Vd, IsSomeRendererActing: { current: false }, assign: fd };
ud.Children = { map: function(e14, t10, n10) {
  if (null == e14) return e14;
  var r10 = [];
  return Kd(e14, r10, null, t10, n10), r10;
}, forEach: function(e14, t10, n10) {
  if (null == e14) return e14;
  Gd(e14, qd, t10 = Wd(null, null, t10, n10)), jd(t10);
}, count: function(e14) {
  return Gd(e14, function() {
    return null;
  }, null);
}, toArray: function(e14) {
  var t10 = [];
  return Kd(e14, t10, null, function(e15) {
    return e15;
  }), t10;
}, only: function(e14) {
  if (!Bd(e14)) throw Error(Pd(143));
  return e14;
} }, ud.Component = Ld, ud.Fragment = bd, ud.Profiler = Cd, ud.PureComponent = Id, ud.StrictMode = Sd, ud.Suspense = Ed, ud.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Qd, ud.cloneElement = function(e14, t10, n10) {
  if (null == e14) throw Error(Pd(267, e14));
  var r10 = fd({}, e14.props), o10 = e14.key, a10 = e14.ref, i10 = e14._owner;
  if (null != t10) {
    if (void 0 !== t10.ref && (a10 = t10.ref, i10 = Vd.current), void 0 !== t10.key && (o10 = "" + t10.key), e14.type && e14.type.defaultProps) var s10 = e14.type.defaultProps;
    for (l10 in t10) Rd.call(t10, l10) && !Ad.hasOwnProperty(l10) && (r10[l10] = void 0 === t10[l10] && void 0 !== s10 ? s10[l10] : t10[l10]);
  }
  var l10 = arguments.length - 2;
  if (1 === l10) r10.children = n10;
  else if (1 < l10) {
    s10 = Array(l10);
    for (var c10 = 0; c10 < l10; c10++) s10[c10] = arguments[c10 + 2];
    r10.children = s10;
  }
  return { $$typeof: yd, type: e14.type, key: o10, ref: a10, props: r10, _owner: i10 };
}, ud.createContext = function(e14, t10) {
  return void 0 === t10 && (t10 = null), (e14 = { $$typeof: wd, _calculateChangedBits: t10, _currentValue: e14, _currentValue2: e14, _threadCount: 0, Provider: null, Consumer: null }).Provider = { $$typeof: xd, _context: e14 }, e14.Consumer = e14;
}, ud.createElement = Od, ud.createFactory = function(e14) {
  var t10 = Od.bind(null, e14);
  return t10.type = e14, t10;
}, ud.createRef = function() {
  return { current: null };
}, ud.forwardRef = function(e14) {
  return { $$typeof: Td, render: e14 };
}, ud.isValidElement = Bd, ud.lazy = function(e14) {
  return { $$typeof: Md, _ctor: e14, _status: -1, _result: null };
}, ud.memo = function(e14, t10) {
  return { $$typeof: Fd, type: e14, compare: void 0 === t10 ? null : t10 };
}, ud.useCallback = function(e14, t10) {
  return Jd().useCallback(e14, t10);
}, ud.useContext = function(e14, t10) {
  return Jd().useContext(e14, t10);
}, ud.useDebugValue = function() {
}, ud.useEffect = function(e14, t10) {
  return Jd().useEffect(e14, t10);
}, ud.useImperativeHandle = function(e14, t10, n10) {
  return Jd().useImperativeHandle(e14, t10, n10);
}, ud.useLayoutEffect = function(e14, t10) {
  return Jd().useLayoutEffect(e14, t10);
}, ud.useMemo = function(e14, t10) {
  return Jd().useMemo(e14, t10);
}, ud.useReducer = function(e14, t10, n10) {
  return Jd().useReducer(e14, t10, n10);
}, ud.useRef = function(e14) {
  return Jd().useRef(e14);
}, ud.useState = function(e14) {
  return Jd().useState(e14);
}, ud.version = "16.13.1", cd.exports = ud;
var ep = cd.exports;
var tp = W(ep);
function np(e14, t10) {
  if (null == e14) return {};
  var n10 = {};
  var r10 = Object.keys(e14);
  var o10, a10;
  for (a10 = 0; a10 < r10.length; a10++) o10 = r10[a10], t10.indexOf(o10) >= 0 || (n10[o10] = e14[o10]);
  return n10;
}
var rp = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var op = { "&amp;": "&", "&#38;": "&", "&lt;": "<", "&#60;": "<", "&gt;": ">", "&#62;": ">", "&apos;": "'", "&#39;": "'", "&quot;": '"', "&#34;": '"', "&nbsp;": " ", "&#160;": " ", "&copy;": "\xA9", "&#169;": "\xA9", "&reg;": "\xAE", "&#174;": "\xAE", "&hellip;": "\u2026", "&#8230;": "\u2026", "&#x2F;": "/", "&#47;": "/" };
var ap = function(e14) {
  return op[e14];
};
var ip = { bindI18n: "languageChanged", bindI18nStore: "", transEmptyNodeValue: "", transSupportBasicHtmlNodes: true, transWrapTextNodes: "", transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"], useSuspense: true, unescape: function(e14) {
  return e14.replace(rp, ap);
} };
var sp;
var lp = ep.createContext();
var cp = function() {
  function e14() {
    to(this, e14), this.usedNamespaces = {};
  }
  return oo(e14, [{ key: "addUsedNamespaces", value: function(e15) {
    var t10 = this;
    e15.forEach(function(e16) {
      t10.usedNamespaces[e16] || (t10.usedNamespaces[e16] = true);
    });
  } }, { key: "getUsedNamespaces", value: function() {
    return Object.keys(this.usedNamespaces);
  } }]), e14;
}();
function up() {
  if (console && console.warn) {
    var e14;
    for (var t10 = arguments.length, n10 = new Array(t10), r10 = 0; r10 < t10; r10++) n10[r10] = arguments[r10];
    "string" == typeof n10[0] && (n10[0] = "react-i18next:: ".concat(n10[0])), (e14 = console).warn.apply(e14, n10);
  }
}
var dp = {};
function pp() {
  for (var e14 = arguments.length, t10 = new Array(e14), n10 = 0; n10 < e14; n10++) t10[n10] = arguments[n10];
  "string" == typeof t10[0] && dp[t10[0]] || ("string" == typeof t10[0] && (dp[t10[0]] = /* @__PURE__ */ new Date()), up.apply(void 0, t10));
}
function mp(e14, t10, n10) {
  e14.loadNamespaces(t10, function() {
    if (e14.isInitialized) n10();
    else {
      e14.on("initialized", function t11() {
        setTimeout(function() {
          e14.off("initialized", t11);
        }, 0), n10();
      });
    }
  });
}
function hp(e14, t10) {
  return function(e15) {
    if (Array.isArray(e15)) return e15;
  }(e14) || function(e15, t11) {
    var n10 = null == e15 ? null : "undefined" != typeof Symbol && e15[Symbol.iterator] || e15["@@iterator"];
    if (null != n10) {
      var r10, o10, a10, i10, s10 = [], l10 = true, c10 = false;
      try {
        if (a10 = (n10 = n10.call(e15)).next, 0 === t11) {
          if (Object(n10) !== n10) return;
          l10 = false;
        } else for (; !(l10 = (r10 = a10.call(n10)).done) && (s10.push(r10.value), s10.length !== t11); l10 = true) ;
      } catch (e16) {
        c10 = true, o10 = e16;
      } finally {
        try {
          if (!l10 && null != n10.return && (i10 = n10.return(), Object(i10) !== i10)) return;
        } finally {
          if (c10) throw o10;
        }
      }
      return s10;
    }
  }(e14, t10) || Gr(e14, t10) || function() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function fp(e14, t10) {
  var n10 = Object.keys(e14);
  if (Object.getOwnPropertySymbols) {
    var r10 = Object.getOwnPropertySymbols(e14);
    t10 && (r10 = r10.filter(function(t11) {
      return Object.getOwnPropertyDescriptor(e14, t11).enumerable;
    })), n10.push.apply(n10, r10);
  }
  return n10;
}
function gp(e14) {
  for (var t10 = 1; t10 < arguments.length; t10++) {
    var n10 = null != arguments[t10] ? arguments[t10] : {};
    t10 % 2 ? fp(Object(n10), true).forEach(function(t11) {
      ao(e14, t11, n10[t11]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e14, Object.getOwnPropertyDescriptors(n10)) : fp(Object(n10)).forEach(function(t11) {
      Object.defineProperty(e14, t11, Object.getOwnPropertyDescriptor(n10, t11));
    });
  }
  return e14;
}
var yp = function(e14, t10) {
  var n10 = ep.useRef();
  return ep.useEffect(function() {
    n10.current = t10 ? n10.current : e14;
  }, [e14, t10]), n10.current;
};
function vp(e14) {
  var t10 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  var n10 = t10.i18n;
  var r10 = ep.useContext(lp) || {}, o10 = r10.i18n, a10 = r10.defaultNS;
  var i10 = n10 || o10 || sp;
  if (i10 && !i10.reportNamespaces && (i10.reportNamespaces = new cp()), !i10) {
    pp("You will need to pass in an i18next instance by using initReactI18next");
    var s10 = function(e15) {
      return Array.isArray(e15) ? e15[e15.length - 1] : e15;
    };
    var l10 = [s10, {}, false];
    return l10.t = s10, l10.i18n = {}, l10.ready = false, l10;
  }
  i10.options.react && void 0 !== i10.options.react.wait && pp("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  var c10 = gp(gp(gp({}, ip), i10.options.react), t10);
  var u10 = c10.useSuspense, d10 = c10.keyPrefix;
  var p10 = e14 || a10 || i10.options && i10.options.defaultNS;
  p10 = "string" == typeof p10 ? [p10] : p10 || ["translation"], i10.reportNamespaces.addUsedNamespaces && i10.reportNamespaces.addUsedNamespaces(p10);
  var m10 = (i10.isInitialized || i10.initializedStoreOnce) && p10.every(function(e15) {
    return function(e16, t11) {
      var n11 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      return t11.languages && t11.languages.length ? void 0 !== t11.options.ignoreJSONStructure ? t11.hasLoadedNamespace(e16, { precheck: function(t12, r11) {
        if (n11.bindI18n && n11.bindI18n.indexOf("languageChanging") > -1 && t12.services.backendConnector.backend && t12.isLanguageChangingTo && !r11(t12.isLanguageChangingTo, e16)) return false;
      } }) : function(e17, t12) {
        var n12 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        var r11 = t12.languages[0];
        var o11 = !!t12.options && t12.options.fallbackLng;
        var a11 = t12.languages[t12.languages.length - 1];
        if ("cimode" === r11.toLowerCase()) return true;
        var i11 = function(e18, n13) {
          var r12 = t12.services.backendConnector.state["".concat(e18, "|").concat(n13)];
          return -1 === r12 || 2 === r12;
        };
        return !(n12.bindI18n && n12.bindI18n.indexOf("languageChanging") > -1 && t12.services.backendConnector.backend && t12.isLanguageChangingTo && !i11(t12.isLanguageChangingTo, e17) || !t12.hasResourceBundle(r11, e17) && t12.services.backendConnector.backend && (!t12.options.resources || t12.options.partialBundledLanguages) && (!i11(r11, e17) || o11 && !i11(a11, e17)));
      }(e16, t11, n11) : (pp("i18n.languages were undefined or empty", t11.languages), true);
    }(e15, i10, c10);
  });
  function h10() {
    return i10.getFixedT(null, "fallback" === c10.nsMode ? p10 : p10[0], d10);
  }
  var f10 = hp(ep.useState(h10), 2), g10 = f10[0], y10 = f10[1];
  var v10 = p10.join();
  var b10 = yp(v10);
  var S10 = ep.useRef(true);
  ep.useEffect(function() {
    var e15 = c10.bindI18n, t11 = c10.bindI18nStore;
    function n11() {
      S10.current && y10(h10);
    }
    return S10.current = true, m10 || u10 || mp(i10, p10, function() {
      S10.current && y10(h10);
    }), m10 && b10 && b10 !== v10 && S10.current && y10(h10), e15 && i10 && i10.on(e15, n11), t11 && i10 && i10.store.on(t11, n11), function() {
      S10.current = false, e15 && i10 && e15.split(" ").forEach(function(e16) {
        return i10.off(e16, n11);
      }), t11 && i10 && t11.split(" ").forEach(function(e16) {
        return i10.store.off(e16, n11);
      });
    };
  }, [i10, v10]);
  var C10 = ep.useRef(true);
  ep.useEffect(function() {
    S10.current && !C10.current && y10(h10), C10.current = false;
  }, [i10, d10]);
  var x10 = [g10, i10, m10];
  if (x10.t = g10, x10.i18n = i10, x10.ready = m10, m10) return x10;
  if (!m10 && !u10) return x10;
  throw new Promise(function(e15) {
    mp(i10, p10, function() {
      e15();
    });
  });
}
var bp = ["forwardedRef"];
function Sp(e14, t10) {
  var n10 = Object.keys(e14);
  if (Object.getOwnPropertySymbols) {
    var r10 = Object.getOwnPropertySymbols(e14);
    t10 && (r10 = r10.filter(function(t11) {
      return Object.getOwnPropertyDescriptor(e14, t11).enumerable;
    })), n10.push.apply(n10, r10);
  }
  return n10;
}
function Cp(e14) {
  for (var t10 = 1; t10 < arguments.length; t10++) {
    var n10 = null != arguments[t10] ? arguments[t10] : {};
    t10 % 2 ? Sp(Object(n10), true).forEach(function(t11) {
      ao(e14, t11, n10[t11]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e14, Object.getOwnPropertyDescriptors(n10)) : Sp(Object(n10)).forEach(function(t11) {
      Object.defineProperty(e14, t11, Object.getOwnPropertyDescriptor(n10, t11));
    });
  }
  return e14;
}
function xp(e14) {
  var t10 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  return function(n10) {
    function r10(r11) {
      var o10 = r11.forwardedRef, a10 = function(e15, t11) {
        if (null == e15) return {};
        var n11 = np(e15, t11);
        var r12, o11;
        if (Object.getOwnPropertySymbols) {
          var a11 = Object.getOwnPropertySymbols(e15);
          for (o11 = 0; o11 < a11.length; o11++) r12 = a11[o11], t11.indexOf(r12) >= 0 || Object.prototype.propertyIsEnumerable.call(e15, r12) && (n11[r12] = e15[r12]);
        }
        return n11;
      }(r11, bp);
      var i10 = hp(vp(e14, Cp(Cp({}, a10), {}, { keyPrefix: t10.keyPrefix })), 3), s10 = i10[0], l10 = i10[1], c10 = i10[2];
      var u10 = Cp(Cp({}, a10), {}, { t: s10, i18n: l10, tReady: c10 });
      return t10.withRef && o10 ? u10.ref = o10 : !t10.withRef && o10 && (u10.forwardedRef = o10), ep.createElement(n10, u10);
    }
    r10.displayName = "withI18nextTranslation(".concat(function(e15) {
      return e15.displayName || e15.name || ("string" == typeof e15 && e15.length > 0 ? e15 : "Unknown");
    }(n10), ")"), r10.WrappedComponent = n10;
    return t10.withRef ? ep.forwardRef(function(e15, t11) {
      return ep.createElement(r10, Object.assign({}, e15, { forwardedRef: t11 }));
    }) : r10;
  };
}
function wp(e14) {
  var t10 = e14.i18n, n10 = e14.defaultNS, r10 = e14.children;
  var o10 = ep.useMemo(function() {
    return { i18n: t10, defaultNS: n10 };
  }, [t10, n10]);
  return ep.createElement(lp.Provider, { value: o10 }, r10);
}
const Tp = (e14) => {
  const { clientHeight: t10 } = e14;
  const { paddingTop: n10, paddingBottom: r10 } = getComputedStyle(e14);
  return t10 - parseFloat(n10) - parseFloat(r10);
};
const Ep = (e14) => {
  const { clientWidth: t10 } = e14;
  const { paddingLeft: n10, paddingRight: r10 } = getComputedStyle(e14);
  return t10 - parseFloat(n10) - parseFloat(r10);
};
let Fp = 0;
const Mp = () => {
  if (0 !== Fp) return Fp;
  if ("undefined" != typeof document) {
    const e14 = document.createElement("div");
    Np(e14, { width: 100, height: 100, position: "absolute", top: -9999, overflow: "scroll", MsOverflowStyle: "scrollbar" }), document.body.appendChild(e14), Fp = e14.offsetWidth - e14.clientWidth, document.body.removeChild(e14);
  } else Fp = 0;
  return Fp || 0;
};
const kp = (...e14) => {
  const t10 = [];
  for (let n10 = 0; n10 < e14.length; n10++) {
    const r10 = e14[n10];
    const o10 = typeof r10;
    r10 && ("string" === o10 || "number" === o10 ? t10.push(`${r10}`) : Array.isArray(r10) && r10.length ? t10.push(kp(r10)) : "object" === o10 && Object.keys(r10).forEach((e15) => r10[e15] && t10.push(e15)));
  }
  return t10.join(" ");
};
const Pp = ["animationiterationcount", "boxflex", "boxflexgroup", "boxordinalgroup", "columncount", "fillopacity", "flex", "flexgrow", "flexpositive", "flexshrink", "flexnegative", "flexorder", "gridrow", "gridcolumn", "fontweight", "lineclamp", "lineheight", "opacity", "order", "orphans", "stopopacity", "strokedashoffset", "strokeopacity", "strokewidth", "tabsize", "widows", "zindex", "zoom"];
const Np = (e14, t10) => {
  e14 && e14.style && Object.keys(t10).forEach((n10) => {
    "string" == typeof t10[n10] ? e14.style[n10] = t10[n10] : Pp.includes(n10.toLowerCase()) ? e14.style[n10] = `${t10[n10]}` : e14.style[n10] = `${t10[n10]}px`;
  });
};
const Dp = (e14) => [e14, (t10) => `${e14}--${t10}`, (t10) => Dp(`${e14}__${t10}`)];
const Lp = 38, Hp = 40, Ip = 9, _p = 27, Vp = 13;
const Rp = 30, Ap = 40, Op = 50;
const Bp = "gcui";
const [zp, $p] = Dp("gc-portal-root");
const [Wp] = Dp("gc-dd-adjustment");
const [jp] = Dp("gc-col");
const [Zp] = Dp("gc-accent-color");
const [Gp] = Dp("gc-rounded");
const [Up] = Dp("gc-size-sm");
const [qp] = Dp("gc-size-lg");
const Yp = (e14) => "string" == typeof e14;
const Kp = (e14) => void 0 === e14;
const Xp = (e14) => "object" == typeof e14 && !!e14;
const Jp = () => {
};
const Qp = () => false;
const em = (e14) => Xp(e14) ? JSON.stringify(e14) : `${e14}`;
const tm = (e14, t10, n10) => {
  const r10 = [...e14];
  return [r10[t10], r10[n10]] = [r10[n10], r10[t10]], r10;
};
const nm = (e14, t10) => {
  const n10 = document.createElement("div");
  return n10.id = e14, n10.className = kp(zp, $p(t10)), n10;
};
const rm = (e14) => `${jp}-${e14}`;
const om = { set(e14, t10) {
  e14._componentType_ = t10;
}, get: (e14) => "function" == typeof e14 ? e14._componentType_ : void 0, is(e14, t10) {
  const n10 = this.get(e14);
  const r10 = this.get(t10);
  return !Kp(n10) && !Kp(r10) && n10 === r10;
} };
const am = (e14, t10) => t10 ? `${t10} ${e14}` : e14;
const im = (e14, { labelId: t10, labelText: n10, labelFor: r10 }) => {
  if (r10) return e14;
  const o10 = __spreadValues({}, e14);
  return t10 ? o10.ariaLabelledBy = t10 : o10.ariaLabel = n10, o10;
};
var sm;
const lm = /^rgb\(\s?(\d{1,3})\s?,\s?(\d{1,3})\s?,\s?(\d{1,3})\s?\)$/;
const cm = /^rgba\(\s?(\d{1,3})\s?,\s?(\d{1,3})\s?,\s?(\d{1,3})\s?,\s?(\d.?\d*?)\s?\)$/;
const um = /^#([A-Fa-f0-9]{3,4}){1,2}$/;
class dm {
  constructor(e14, t10, n10, r10) {
    this.R = 0, this.G = 0, this.B = 0, this.A = 255, this.R = e14 >= 0 && e14 < 256 ? e14 : 0, this.G = t10 >= 0 && t10 < 256 ? t10 : 0, this.B = n10 >= 0 && n10 < 256 ? n10 : 0, this.A = void 0 !== r10 && r10 >= 0 && r10 < 256 ? r10 : 255;
  }
  lighten(e14) {
    return dm.shade(this, e14);
  }
  darken(e14) {
    return dm.shade(this, -e14);
  }
  transparentize(e14) {
    return e14 >= 0 && e14 <= 1 ? new dm(this.R, this.G, this.B, Math.round(this.A * (1 - e14))) : this;
  }
  get rgb() {
    return `rgb(${this.R}, ${this.G}, ${this.B})`;
  }
  get rgba() {
    return `rgba(${this.R}, ${this.G}, ${this.B}, ${Math.round(this.A / 255 * 100) / 100})`;
  }
  get hex() {
    return `#${(16777216 + 65536 * this.R + 256 * this.G + this.B).toString(16).slice(1)}`;
  }
  get hex8() {
    return `${this.hex}${(256 + this.A).toString(16).slice(1)}`;
  }
}
sm = dm, dm.webColorsMap = { Transparent: "#00000000", Black: "#000000", DarkSlateGray: "#2f4f4f", SlateGray: "#708090", LightSlateGray: "#778899", DimGray: "#696969", Gray: "#808080", DarkGray: "#a9a9a9", LightGray: "#d3d3d3", DarkSlateGrey: "#2f4f4f", SlateGrey: "#708090", LightSlateGrey: "#778899", DimGrey: "#696969", Grey: "#808080", DarkGrey: "#a9a9a9", LightGrey: "#d3d3d3", Silver: "#c0c0c0", Gainsboro: "#dcdcdc", WhiteSmoke: "#f5f5f5", White: "#ffffff", Snow: "#fffafa", HoneyDew: "#f0fff0", MintCream: "#f5fffa", Azure: "#f0ffff", AliceBlue: "#f0f8ff", GhostWhite: "#f8f8ff", SeaShell: "#fff5ee", Beige: "#f5f5dc", OldLace: "#fdf5e6", FloralWhite: "#fffaf0", Ivory: "#fffff0", AntiqueWhite: "#faebd7", Linen: "#faf0e6", LavenderBlush: "#fff0f5", MistyRose: "#ffe4e1", Pink: "#ffc0cb", LightPink: "#ffb6c1", HotPink: "#ff69b4", DeepPink: "#ff1493", PaleVioletRed: "#db7093", MediumVioletRed: "#c71585", LightSalmon: "#ffa07a", Salmon: "#fa8072", DarkSalmon: "#e9967a", LightCoral: "#f08080", IndianRed: "#cd5c5c", Crimson: "#dc143c", FireBrick: "#b22222", DarkRed: "#8b0000", Red: "#ff0000", OrangeRed: "#ff4500", Tomato: "#ff6347", Coral: "#ff7f50", DarkOrange: "#ff8c00", Orange: "#ffa500", Yellow: "#ffff00", LightYellow: "#ffffe0", LemonChiffon: "#fffacd", LightGoldenrodYellow: "#fafad2", PapayaWhip: "#ffefd5", Moccasin: "#ffe4b5", PeachPuff: "#ffdab9", PaleGoldenrod: "#eee8aa", Khaki: "#f0e68c", DarkKhaki: "#bdb76b", Gold: "#ffd700", Cornsilk: "#fff8dc", BlanchedAlmond: "#ffebcd", Bisque: "#ffe4c4", NavajoWhite: "#ffdead", Wheat: "#f5deb3", BurlyWood: "#deb887", Tan: "#d2b48c", RosyBrown: "#bc8f8f", SandyBrown: "#f4a460", Goldenrod: "#daa520", DarkGoldenrod: "#b8860b", Peru: "#cd853f", Chocolate: "#d2691e", SaddleBrown: "#8b4513", Sienna: "#a0522d", Brown: "#a52a2a", Maroon: "#800000", DarkOliveGreen: "#556b2f", Olive: "#808000", OliveDrab: "#6b8e23", YellowGreen: "#9acd32", LimeGreen: "#32cd32", Lime: "#00ff00", LawnGreen: "#7cfc00", Chartreuse: "#7fff00", GreenYellow: "#adff2f", SpringGreen: "#00ff7f", MediumSpringGreen: "#00fa9a", LightGreen: "#90ee90", PaleGreen: "#98fb98", DarkSeaGreen: "#8fbc8f", MediumAquamarine: "#66cdaa", MediumSeaGreen: "#3cb371", SeaGreen: "#2e8b57", ForestGreen: "#228b22", Green: "#008000", DarkGreen: "#006400", Aqua: "#00ffff", Cyan: "#00ffff", LightCyan: "#e0ffff", PaleTurquoise: "#afeeee", Aquamarine: "#7fffd4", Turquoise: "#40e0d0", MediumTurquoise: "#48d1cc", DarkTurquoise: "#00ced1", LightSeaGreen: "#20b2aa", CadetBlue: "#5f9ea0", DarkCyan: "#008b8b", Teal: "#008080", LightSteelBlue: "#b0c4de", PowderBlue: "#b0e0e6", LightBlue: "#add8e6", SkyBlue: "#87ceeb", LightSkyBlue: "#87cefa", DeepSkyBlue: "#00bfff", DodgerBlue: "#1e90ff", CornflowerBlue: "#6495ed", SteelBlue: "#4682b4", RoyalBlue: "#4169e1", Blue: "#0000ff", MediumBlue: "#0000cd", DarkBlue: "#00008b", Navy: "#000080", MidnightBlue: "#191970", Lavender: "#e6e6fa", Thistle: "#d8bfd8", Plum: "#dda0dd", Violet: "#ee82ee", Orchid: "#da70d6", Fuchsia: "#ff00ff", Magenta: "#ff00ff", MediumOrchid: "#ba55d3", MediumPurple: "#9370db", BlueViolet: "#8a2be2", DarkViolet: "#9400d3", DarkOrchid: "#9932cc", DarkMagenta: "#8b008b", Purple: "#800080", Indigo: "#4b0082", DarkSlateBlue: "#483d8b", RebeccaPurple: "#663399", SlateBlue: "#6a5acd", MediumSlateBlue: "#7b68ee" }, dm.colorAliases = ["Cyan", "Magenta", "DarkSlateGrey", "SlateGrey", "LightSlateGrey", "DimGrey", "Grey", "DarkGrey", "LightGrey"], dm.webToHexMap = {}, dm.hexToWebMap = {}, dm.initMaps = () => {
  if (!(Object.keys(sm.webToHexMap).length > 0)) {
    for (const e14 in sm.webColorsMap) sm.webToHexMap[e14.toLowerCase()] = sm.webColorsMap[e14];
    for (const e14 of sm.webColors(true)) sm.hexToWebMap[sm.webColorsMap[e14]] = e14;
  }
}, dm.webColors = (e14 = false) => e14 ? Object.keys(sm.webColorsMap).filter((e15) => !sm.colorAliases.includes(e15)) : Object.keys(sm.webColorsMap), dm.webColorsEnum = (e14 = false) => sm.webColors(e14).map((e15) => ({ name: e15, value: sm.webColorsMap[e15] })), dm.fromWeb = (e14) => {
  sm.initMaps();
  const t10 = sm.webToHexMap[e14.toLowerCase()];
  return t10 ? sm.fromHEX(t10) : new dm(0, 0, 0, 255);
}, dm.fromRGB = (e14, t10, n10, r10) => (sm.initMaps(), new dm(e14, t10, n10, r10)), dm.fromRGBA = (e14, t10, n10, r10) => (sm.initMaps(), new dm(e14, t10, n10, void 0 !== r10 ? 255 * r10 : r10)), dm.fromHEX = (e14) => {
  if (sm.initMaps(), !e14 || !um.test(e14)) return new dm(0, 0, 0, 255);
  let t10 = e14.substring(1).split("");
  3 !== t10.length && 4 !== t10.length || (t10 = t10.reduce((e15, t11) => [...e15, t11, t11], []));
  let n10 = parseInt(`0x${t10.join("")}`);
  const r10 = [];
  return 8 === t10.length && r10.push(n10 >> 24 & 255), r10.push(n10 >> 16 & 255), r10.push(n10 >> 8 & 255), r10.push(255 & n10), new dm(r10[0], r10[1], r10[2], void 0 !== r10[3] ? r10[3] : 255);
}, dm.fromString = (e14) => {
  if (!e14) return new dm(0, 0, 0, 255);
  if (sm.initMaps(), um.test(e14)) return sm.fromHEX(e14);
  const t10 = lm.exec(e14);
  if (t10) {
    const [, e15, n11, r10] = t10;
    return new dm(parseInt(e15), parseInt(n11), parseInt(r10));
  }
  const n10 = cm.exec(e14);
  if (n10) {
    const [, e15, t11, r10, o10] = n10;
    return new dm(parseInt(e15), parseInt(t11), parseInt(r10), 255 * parseFloat(o10));
  }
  return sm.fromWeb(e14);
}, dm.fromHSL = (e14) => {
  sm.initMaps();
  const { H: t10, S: n10, L: r10 } = e14;
  let o10, a10, i10;
  if (0 == n10) o10 = a10 = i10 = r10;
  else {
    const e15 = (e16, t11, n11) => (n11 < 0 && (n11 += 1), n11 > 1 && (n11 -= 1), n11 < 1 / 6 ? e16 + 6 * (t11 - e16) * n11 : n11 < 0.5 ? t11 : n11 < 2 / 3 ? e16 + (t11 - e16) * (2 / 3 - n11) * 6 : e16);
    var s10 = r10 < 0.5 ? r10 * (1 + n10) : r10 + n10 - r10 * n10;
    var l10 = 2 * r10 - s10;
    o10 = e15(l10, s10, t10 + 1 / 3), a10 = e15(l10, s10, t10), i10 = e15(l10, s10, t10 - 1 / 3);
  }
  return new dm(Math.round(255 * o10), Math.round(255 * a10), Math.round(255 * i10));
}, dm.toWeb = (e14) => {
  if (e14) {
    if (sm.initMaps(), 0 === e14.A) return "Transparent";
    {
      const t10 = e14.hex.toLowerCase();
      return sm.hexToWebMap[t10];
    }
  }
}, dm.toHSL = (e14) => {
  sm.initMaps();
  const t10 = e14.R / 255;
  const n10 = e14.G / 255;
  const r10 = e14.B / 255;
  const o10 = Math.max(t10, n10, r10), a10 = Math.min(t10, n10, r10);
  let i10, s10 = 0, l10 = (o10 + a10) / 2;
  if (o10 == a10) s10 = i10 = 0;
  else {
    const e15 = o10 - a10;
    switch (i10 = l10 > 0.5 ? e15 / (2 - o10 - a10) : e15 / (o10 + a10), o10) {
      case t10:
        s10 = (n10 - r10) / e15 + (n10 < r10 ? 6 : 0);
        break;
      case n10:
        s10 = (r10 - t10) / e15 + 2;
        break;
      case r10:
        s10 = (t10 - n10) / e15 + 4;
    }
    s10 /= 6;
  }
  return { H: s10, S: i10, L: l10 };
}, dm.shade = (e14, t10) => {
  if (!e14) return new dm(0, 0, 0, 255);
  if (t10 < -1 || t10 > 1) return e14;
  const n10 = t10 < 0 ? 0 : 255;
  const r10 = (e15) => Math.round((n10 - e15) * Math.abs(t10)) + e15;
  const { R: o10, G: a10, B: i10, A: s10 } = e14;
  return new dm(r10(o10), r10(a10), r10(i10), s10);
}, dm.shades = (e14) => e14 ? [e14, sm.shade(e14, -0.5), sm.shade(e14, -0.25), sm.shade(e14, 0.25), sm.shade(e14, 0.5), sm.shade(e14, 0.72)] : [], dm.isLight = ({ R: e14, G: t10, B: n10 }) => (2126 * e14 + 7152 * t10 + 722 * n10) / 1e4 >= 128, dm.isDark = (e14) => !sm.isLight(e14);
const pm = {};
const mm = (e14) => `${e14}ui`;
const hm = { of: (e14) => pm[mm(e14)], getInstances: () => pm, get menu() {
  return fm.getDefaultInstance().menu;
}, get dropdowns() {
  return fm.getDefaultInstance().dropdowns;
}, get modals() {
  return fm.getDefaultInstance().modals;
}, get sidebar() {
  return fm.getDefaultInstance().sidebar;
}, get contextMenu() {
  return fm.getDefaultInstance().contextMenu;
}, get focusTimer() {
  return fm.getDefaultInstance().focusTimer;
}, get notifications() {
  return fm.getDefaultInstance().notifications;
} };
class fm {
  constructor(e14) {
    this._namespace = Bp, this.destroy = () => {
      window[this._namespace] = void 0, delete hm.getInstances()[this._namespace];
    }, e14 && (this._namespace = mm(e14)), pm[this._namespace] = this, this._stubs = new gm(this._namespace);
  }
  get current() {
    return fm.getNamespaceObject(this._namespace);
  }
  get global() {
    return fm.getNamespaceObject(Bp);
  }
  get namespace() {
    return this._namespace;
  }
  get menu() {
    return this.current.menu || this._stubs.menu;
  }
  get dropdowns() {
    return this.current.dropdowns || this._stubs.dropdowns;
  }
  get modals() {
    return this.current.modals || this._stubs.modals;
  }
  get sidebar() {
    return this.current.sidebar || this._stubs.sidebar;
  }
  get contextMenu() {
    return this.current.contextMenu || this._stubs.contextMenu;
  }
  get focusTimer() {
    return this.current.focusTimer || this._stubs.focusTimer;
  }
  get notifications() {
    return this.current.notifications || this._stubs.notifications;
  }
}
fm.getDefaultInstance = () => pm[Bp] || new fm(), fm.getNamespaceObject = (e14) => {
  const t10 = window;
  return t10[e14] || (t10[e14] = {}), t10[e14];
};
class gm {
  constructor(e14) {
    this.namespace = e14, this.onStubCall = (e15, t10) => () => {
      const n10 = `${e15} API is not available in "${this.namespace}" namespace.
Make sure that you have a mounted ${t10} component and you're using correct namespace.
`;
      return console.warn(new Error(n10)), null;
    };
  }
  get menu() {
    const e14 = this.onStubCall("Menu", "Menu");
    return { expand: e14, collapse: e14, toggle: e14, panels: { open: e14, close: e14, pin: e14, unpin: e14 }, onTransition: e14, isStub: true };
  }
  get dropdowns() {
    const e14 = this.onStubCall("Dropdowns", "Dropdown/ComboBox");
    return { open: e14, cleanup: e14, get menuRootSelector() {
      return e14();
    }, get current() {
      return e14();
    }, isStub: true };
  }
  get modals() {
    const e14 = this.onStubCall("Modals", "ModalApiProvider");
    return { dialog: e14, message: e14, close: e14, isStub: true };
  }
  get sidebar() {
    const e14 = this.onStubCall("Sidebar", "Sidebar");
    return { open: e14, close: e14, onTransition: e14, isStub: true };
  }
  get contextMenu() {
    const e14 = this.onStubCall("Context Menu", "ContextMenuProvider");
    return { open: e14, close: e14, isStub: true };
  }
  get focusTimer() {
    const e14 = this.onStubCall("Focus Timer", "FocusTimer");
    return { advance: e14, reset: e14, isStub: true };
  }
  get notifications() {
    const e14 = this.onStubCall("Notifications", "NotificationManager");
    return { send: e14, dismiss: e14, dismissAll: e14, updateTask: e14, subscribe: e14, unsubscribe: e14, getState: e14, isStub: true };
  }
}
const ym = () => ({ type: "core-ui-theme", name: "default", accent: dm.fromHEX("#205F78"), accentText: dm.fromHEX("#205F78"), accentSecondary: dm.fromHEX("#FAAB1C"), accentWarning: dm.fromHEX("#EC8520"), accentError: dm.fromHEX("#BF2A2A"), colorContrast: dm.fromHEX("#ffffff"), colorContrastText: dm.fromHEX("#ffffff"), backgroundBody: dm.fromHEX("#E6E6E6"), backgroundPanels: dm.fromHEX("#F1F1F1"), shadow: `0 0 10px 1px ${dm.fromHEX("#000000").transparentize(0.8).rgba}`, shadowBorder: `0 0 10px 1px ${dm.fromHEX("#000000").transparentize(0.9).rgba}`, overlay: dm.fromHEX("#000000").transparentize(0.85), textColor: dm.fromHEX("#333333"), borderRadius: 4, elemBackground: dm.fromHEX("#000000").transparentize(0.95), elemBackgroundHover: dm.fromHEX("#000000").transparentize(0.9), btnGroupHeader: dm.fromHEX("#dddddd"), btnGroupHeaderHover: dm.fromHEX("#c6c6c6"), dropdownBackground: dm.fromHEX("#ffffff"), dropdownBorder: dm.fromHEX("#ededed"), bindingModified: dm.fromHEX("#4dca7d"), bindingBound: dm.fromHEX("#e4d50a") });
const vm = ({ accent: e14, accentText: t10, accentSecondary: n10, accentWarning: r10, accentWarningText: o10, accentError: a10, accentErrorText: i10, colorContrast: s10, colorContrastText: l10, textColor: c10, textFamily: u10, shadow: d10, shadowBorder: p10, overlay: m10, borderRadius: h10, backgroundBody: f10, backgroundBodyOverlay: g10, backgroundPanels: y10, backgroundPanelsSection: v10, backgroundPanelsOverlay: b10, backgroundPanelsBorder: S10, elemBackground: C10, elemBackgroundHover: x10, btnGroupHeader: w10, btnGroupHeaderHover: T10, dropdownBackground: E10, dropdownBackgroundHover: F10, dropdownBorder: M10, bindingModified: k10, bindingBound: P10, custom: N10 }) => {
  var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2;
  const D10 = o10 != null ? o10 : r10;
  const L10 = i10 != null ? i10 : a10;
  return __spreadValues({ "--cui-accent": e14.rgba, "--cui-accent-hover": e14.darken(0.1).rgba, "--cui-accent-semi-10": e14.transparentize(0.9).rgba, "--cui-accent-semi-20": e14.transparentize(0.8).rgba, "--cui-accent-semi-40": e14.transparentize(0.62).rgba, "--cui-accent-semi-60": e14.transparentize(0.38).rgba, "--cui-accent-text": t10.rgba, "--cui-accent-text-hover": t10.darken(0.1).rgba, "--cui-accent-text-semi-10": t10.transparentize(0.9).rgba, "--cui-accent-text-semi-20": t10.transparentize(0.8).rgba, "--cui-accent-text-semi-40": t10.transparentize(0.62).rgba, "--cui-accent-text-semi-60": t10.transparentize(0.38).rgba, "--cui-accent-icon": t10.rgba, "--cui-accent-icon-hover": t10.darken(0.1).rgba, "--cui-accent-secondary": n10.rgba, "--cui-accent-warning": r10.rgba, "--cui-accent-warning-hover": r10.darken(0.1).rgba, "--cui-accent-warning-semi-10": r10.transparentize(0.9).rgba, "--cui-accent-warning-semi-40": r10.transparentize(0.62).rgba, "--cui-accent-warning-semi-60": r10.transparentize(0.38).rgba, "--cui-accent-warning-text": D10.rgba, "--cui-accent-warning-text-hover": D10.darken(0.2).rgba, "--cui-accent-warning-text-semi-10": D10.transparentize(0.9).rgba, "--cui-accent-warning-text-semi-40": D10.transparentize(0.62).rgba, "--cui-accent-warning-text-semi-60": D10.transparentize(0.38).rgba, "--cui-accent-error": a10.rgba, "--cui-accent-error-hover": a10.darken(0.2).rgba, "--cui-accent-error-semi-10": a10.transparentize(0.9).rgba, "--cui-accent-error-semi-40": a10.transparentize(0.62).rgba, "--cui-accent-error-semi-60": a10.transparentize(0.38).rgba, "--cui-accent-error-text": L10.rgba, "--cui-accent-error-text-hover": L10.darken(0.2).rgba, "--cui-accent-error-text-semi-10": L10.transparentize(0.9).rgba, "--cui-accent-error-text-semi-40": L10.transparentize(0.62).rgba, "--cui-accent-error-text-semi-60": L10.transparentize(0.38).rgba, "--cui-contrast": s10.rgba, "--cui-contrast-semi-10": s10.transparentize(0.9).rgba, "--cui-contrast-semi-40": s10.transparentize(0.62).rgba, "--cui-contrast-semi-60": s10.transparentize(0.38).rgba, "--cui-contrast-text": l10.rgba, "--cui-contrast-text-semi-40": l10.transparentize(0.62).rgba, "--cui-bg-body": f10.rgba, "--cui-bg-body-overlay": (_a2 = g10 == null ? void 0 : g10.rgba) != null ? _a2 : f10.transparentize(0.62).rgba, "--cui-bg-panels": y10.rgba, "--cui-bg-panels-section": (_b2 = v10 == null ? void 0 : v10.rgba) != null ? _b2 : "rgba(0, 0, 0, 0.05)", "--cui-bg-panels-border": (_c2 = S10 == null ? void 0 : S10.rgba) != null ? _c2 : y10.darken(0.1).rgba, "--cui-bg-panels-overlay": (_d2 = b10 == null ? void 0 : b10.rgba) != null ? _d2 : y10.transparentize(0.62).rgba, "--cui-shadow": d10, "--cui-shadow-border": p10, "--cui-overlay": m10.rgba, "--cui-outline-offset": "-2px", "--cui-outline": `2px solid ${t10.rgba}`, "--cui-outline-contrast": `2px solid ${l10.rgba}`, "--cui-outline-warning": `2px solid ${D10.rgba}`, "--cui-outline-error": `2px solid ${L10.rgba}`, "--cui-text": c10.rgba, "--cui-text-semi-10": c10.transparentize(0.9).rgba, "--cui-text-semi-20": c10.transparentize(0.8).rgba, "--cui-text-semi-40": c10.transparentize(0.62).rgba, "--cui-text-semi-60": c10.transparentize(0.38).rgba, "--cui-text-family": u10 != null ? u10 : '"Open Sans", "Segoe UI", Tahoma, Geneva, Verdana, sans-serif', "--cui-text-size": "12px", "--cui-text-size-lg": "14px", "--cui-text-size-xl": "18px", "--cui-text-size-sm": "10px", "--cui-border-radius": `${h10}px`, "--cui-btn-bg": C10.rgba, "--cui-btn-bg-hover": x10.rgba, "--cui-btn-transparent-warning": r10.transparentize(0.9).rgba, "--cui-btn-transparent-warning-hover": r10.transparentize(0.8).rgba, "--cui-btn-transparent-error": a10.transparentize(0.9).rgba, "--cui-btn-transparent-error-hover": a10.transparentize(0.85).rgba, "--cui-btn-group-header-bg": w10.rgba, "--cui-btn-group-header-bg-hover": T10.rgba, "--cui-item-bg": C10.rgba, "--cui-item-bg-hover": x10.rgba, "--cui-input-bg": C10.rgba, "--cui-input-bg-hover": x10.rgba, "--cui-input-bg-focus": x10.rgba, "--cui-input-text": c10.rgba, "--cui-input-text-disabled": c10.transparentize(0.62).rgba, "--cui-input-text-placeholder": c10.transparentize(0.62).rgba, "--cui-dd-background": E10.rgba, "--cui-dd-background-hover": (_e2 = F10 == null ? void 0 : F10.rgba) != null ? _e2 : E10.darken(0.05).rgba, "--cui-dd-divider": (_f2 = M10 == null ? void 0 : M10.rgba) != null ? _f2 : E10.darken(0.1).rgba, "--cui-binding-default": c10.transparentize(0.38).rgba, "--cui-binding-default-shadow": c10.transparentize(0.62).rgba, "--cui-binding-modified": (_g2 = k10 == null ? void 0 : k10.rgba) != null ? _g2 : "#4dca7d", "--cui-binding-modified-shadow": (k10 != null ? k10 : dm.fromHEX("#4dca7d")).darken(0.1).transparentize(0.38).rgba, "--cui-binding-bind": (_h2 = P10 == null ? void 0 : P10.rgba) != null ? _h2 : "#e4d50a", "--cui-binding-bind-shadow": (P10 != null ? P10 : dm.fromHEX("#e4d50a")).darken(0.1).transparentize(0.38).rgba, "--cui-binding-error": L10.rgba, "--cui-binding-error-shadow": L10.transparentize(0.38).rgba, "--cui-menu-splitter": s10.transparentize(0.85).rgba, "--cui-prop-editors-drag-shadow": `1px 2px 5px 0 ${x10.rgba}`, "--cui-prop-editors-bg": C10.rgba, "--cui-wizard-bg": e14.transparentize(0.38).rgba, "--cui-wizard-dark-bg-main": dm.fromRGB(0, 0, 0).transparentize(0.62).rgba, "--cui-wizard-dark-bg-secondary": dm.fromRGB(0, 0, 0).transparentize(0.2).rgba, "--cui-wizard-dark-hover": dm.fromRGB(0, 0, 0).transparentize(0.62).rgba, "--cui-wizard-light-bg-main": dm.fromRGB(255, 255, 255).transparentize(0.62).rgba, "--cui-wizard-light-bg-secondary": dm.fromRGB(255, 255, 255).transparentize(0.2).rgba, "--cui-wizard-light-hover": dm.fromRGB(255, 255, 255).transparentize(0.62).rgba, "--cui-progressbar-bg": y10.rgba, "--cui-progressbar-bg-semi": x10.rgba, "--cui-progress-fill-color": c10.rgba, "--cui-progress-value-color": l10.rgba, "--cui-scrollbar-color": C10.rgba, "--cui-scrollbar-color-contrast": s10.transparentize(0.8).rgba, "--cui-treeview-outline-color": (_i2 = S10 == null ? void 0 : S10.rgba) != null ? _i2 : y10.darken(0.1).rgba, "--cui-calendar-range-fill-color": t10.transparentize(0.9).rgba, "--cui-notification-btn-accent-bg": "var(--cui-accent)", "--cui-notification-btn-warning-bg": "var(--cui-accent-warning)", "--cui-notification-btn-error-bg": "var(--cui-accent-error)", "--cui-notification-btn-bg": "rgba(0, 0, 0, .25)", "--cui-notification-btn-bg-hover": "rgba(0, 0, 0, .35)" }, N10);
};
const bm = { default: ym(), defaultDark: { type: "core-ui-theme", name: "defaultDark", accent: dm.fromHEX("#205F78"), accentText: dm.fromHEX("#4DB8E3"), accentSecondary: dm.fromHEX("#FAAB1C"), accentWarning: dm.fromHEX("#e59500"), accentWarningText: dm.fromHEX("#FFBE44"), accentError: dm.fromHEX("#E14B4B"), accentErrorText: dm.fromHEX("#E87474"), colorContrast: dm.fromHEX("#ffffff"), colorContrastText: dm.fromHEX("#ffffff"), backgroundBody: dm.fromHEX("#222222"), backgroundPanels: dm.fromHEX("#363636"), backgroundPanelsSection: dm.fromHEX("#ffffff").transparentize(0.95), backgroundPanelsBorder: dm.fromHEX("#363636").lighten(0.1), shadow: `0 0 10px 1px ${dm.fromHEX("#000000").transparentize(0.6).rgba}`, shadowBorder: `0 0 10px 1px ${dm.fromHEX("#000000").transparentize(0.6).rgba}`, overlay: dm.fromHEX("#000000").transparentize(0.6), textColor: dm.fromHEX("#f1f1f1"), borderRadius: 4, elemBackground: dm.fromHEX("#ffffff").transparentize(0.925), elemBackgroundHover: dm.fromHEX("#ffffff").transparentize(0.8), btnGroupHeader: dm.fromHEX("#555555"), btnGroupHeaderHover: dm.fromHEX("#6F6F6F").lighten(0.15), dropdownBackground: dm.fromHEX("#363636"), dropdownBackgroundHover: dm.fromHEX("#363636").lighten(0.15), dropdownBorder: dm.fromHEX("#5A5A5A") }, darkOled: { type: "core-ui-theme", name: "darkOled", accent: dm.fromHEX("#11455A"), accentText: dm.fromHEX("#1583AE"), accentSecondary: dm.fromHEX("#C4821F"), accentWarning: dm.fromHEX("#A06C0E"), accentWarningText: dm.fromHEX("#FFBE44"), accentError: dm.fromHEX("#801919"), accentErrorText: dm.fromHEX("#E87474"), colorContrast: dm.fromHEX("#DCDCDC"), colorContrastText: dm.fromHEX("#DCDCDC"), backgroundBody: dm.fromHEX("#000"), backgroundPanels: dm.fromHEX("#000"), backgroundPanelsSection: dm.fromHEX("#ffffff").transparentize(0.9), backgroundPanelsBorder: dm.fromHEX("#000").lighten(0.15), shadow: `0 0 5px 1px ${dm.fromHEX("#000000").transparentize(0.6).rgba}`, shadowBorder: `0 0 5px 1px ${dm.fromHEX("#000000").transparentize(0.6).rgba}`, overlay: dm.fromHEX("#000").transparentize(0.5), textColor: dm.fromHEX("#CECECE"), borderRadius: 4, elemBackground: dm.fromHEX("#ffffff").transparentize(0.9), elemBackgroundHover: dm.fromHEX("#ffffff").transparentize(0.85), btnGroupHeader: dm.fromHEX("#272727"), btnGroupHeaderHover: dm.fromHEX("#272727").lighten(0.1), dropdownBackground: dm.fromHEX("#111"), dropdownBackgroundHover: dm.fromHEX("#111").lighten(0.1), dropdownBorder: dm.fromHEX("#111").lighten(0.1) }, highContrast: { type: "core-ui-theme", name: "highContrast", accent: dm.fromHEX("#724BA5"), accentText: dm.fromHEX("#724BA5"), accentSecondary: dm.fromHEX("#FCA200"), accentWarning: dm.fromHEX("#EC8520"), accentError: dm.fromHEX("#BF2A2A"), colorContrast: dm.fromHEX("#ffffff"), colorContrastText: dm.fromHEX("#ffffff"), backgroundBody: dm.fromHEX("#fff"), backgroundPanels: dm.fromHEX("#F7F7F7"), backgroundPanelsSection: dm.fromHEX("#000").transparentize(0.9), backgroundPanelsBorder: dm.fromHEX("#F7F7F7").darken(0.2), shadow: `0 0 0 2px ${dm.fromHEX("#000").transparentize(0.6).rgba}`, shadowBorder: `0 0 0 2px ${dm.fromHEX("#000").transparentize(0.6).rgba}`, overlay: dm.fromHEX("#000").transparentize(0.8), textColor: dm.fromHEX("#000"), borderRadius: 0, elemBackground: dm.fromHEX("#000").transparentize(0.9), elemBackgroundHover: dm.fromHEX("#000").transparentize(0.8), btnGroupHeader: dm.fromHEX("#BEBEBE"), btnGroupHeaderHover: dm.fromHEX("#BEBEBE").darken(0.2), dropdownBackground: dm.fromHEX("#fff"), dropdownBackgroundHover: dm.fromHEX("#fff").darken(0.1), dropdownBorder: dm.fromHEX("#fff").darken(0.4) }, highContrastDark: { type: "core-ui-theme", name: "highContrastDark", accent: dm.fromHEX("#2D414A"), accentText: dm.fromHEX("#8EE3F0"), accentSecondary: dm.fromHEX("#FCA200"), accentWarning: dm.fromHEX("#A06C0E"), accentWarningText: dm.fromHEX("#FFBE44"), accentError: dm.fromHEX("#801919"), accentErrorText: dm.fromHEX("#E87474"), colorContrast: dm.fromHEX("#ffffff"), colorContrastText: dm.fromHEX("#ffffff"), backgroundBody: dm.fromHEX("#000"), backgroundPanels: dm.fromHEX("#000"), backgroundPanelsSection: dm.fromHEX("#ffffff").transparentize(0.7), backgroundPanelsBorder: dm.fromHEX("#000").lighten(0.5), shadow: `0 0 0 2px ${dm.fromHEX("#ffffff").transparentize(0.3).rgba}`, shadowBorder: `0 0 0 2px ${dm.fromHEX("#ffffff").transparentize(0.3).rgba}`, overlay: dm.fromHEX("#000").transparentize(0.5), textColor: dm.fromHEX("#fff"), borderRadius: 0, elemBackground: dm.fromHEX("#ffffff").transparentize(0.7), elemBackgroundHover: dm.fromHEX("#ffffff").transparentize(0.5), btnGroupHeader: dm.fromHEX("#737373"), btnGroupHeaderHover: dm.fromHEX("#737373").lighten(0.3), dropdownBackground: dm.fromHEX("#111"), dropdownBackgroundHover: dm.fromHEX("#111").lighten(0.2), dropdownBorder: dm.fromHEX("#111").lighten(0.4) } };
const Sm = ep.createContext({ root: { addEventListener: window.addEventListener.bind(window), removeEventListener: window.removeEventListener.bind(window), getElement: () => document.body }, theme: { current: ym(), update: (e14) => {
}, reset: () => {
} }, API: fm.getDefaultInstance() });
const [Cm] = Dp("gc-link");
const xm = [{ pattern: /\[br\]/g, template: "<br>" }, { pattern: /\[b\]([\s\S]+?)\[\/b\]/g, template: "<b>$1</b>" }, { pattern: /\[i\]([\s\S]+?)\[\/i\]/g, template: "<i>$1</i>" }, { pattern: /\[u\]([\s\S]+?)\[\/u\]/g, template: "<u>$1</u>" }, { pattern: /\[email\](.+?)\[\/email\]/g, template: `<a href="mailto:$1" class="${Cm}">$1</a>` }, { pattern: /\[email=(.+?)\](.+?)\[\/email\]/g, template: `<a href="mailto:$1" class="${Cm}">$2</a>` }, { pattern: /\[url\](.+?)\[\/url\]/g, template: `<a href="$1" class="${Cm}" target="_blank">$1</a>` }, { pattern: /\[url=(.+?)\](.+?)\[\/url\]/g, template: `<a href="$1" class="${Cm}" target="_blank">$2</a>` }];
const wm = (e14 = "") => xm.reduce((e15, t10) => e15.replace(t10.pattern, t10.template), e14);
const [Tm, Em] = Dp("gc-icon");
const Fm = ({ icon: e14, customCSS: t10 }) => {
  if ("font" === e14.type) {
    const { iconCssClass: n11, fontSize: r11 } = e14;
    const o11 = kp(n11, t10);
    const a11 = r11 && { fontSize: r11 } || void 0;
    return ep.createElement("i", { className: o11, style: a11 });
  }
  if ("css" === e14.type) {
    const { cssClass: n11 } = e14;
    return ep.createElement("i", { className: kp(n11, t10) });
  }
  const { content: n10, rotate: r10, cssClass: o10, size: a10 } = e14;
  const i10 = kp(Tm, o10, t10, { [Em(a10)]: a10 && "default" !== a10, [Em(`r${r10}`)]: r10 });
  return ep.createElement("i", { className: i10 }, n10);
};
const [, Mm] = Dp("gc-icon-color");
const km = { text: Mm("text"), accent: Mm("accent") };
const Pm = (e14, t10) => __spreadValues({ type: "svg", content: e14 }, t10);
const Nm = ep.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, ep.createElement("path", { className: km.text, d: "M20 11v2H8l5.5 5.5-1.42 1.42L4.16 12l7.92-7.92L13.5 5.5 8 11h12z" }));
const Dm = ep.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, ep.createElement("path", { className: km.text, d: "M15.41 16.58L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.42z" }));
const Lm = ep.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, ep.createElement("path", { className: km.text, d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z" }));
const Hm = ep.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, ep.createElement("path", { className: km.text, d: "M11 9h2V7h-2m1 13c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10 10 10 0 0 0 10-10A10 10 0 0 0 12 2m-1 15h2v-6h-2v6z" }));
const Im = ep.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, ep.createElement("path", { className: km.text, d: "M19 13H5v-2h14v2z" }));
const _m = ep.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, ep.createElement("path", { className: km.text, d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" }));
const [Vm, Rm] = Dp("gc-badge");
const Am = (e14) => {
  const { inset: t10 = false, inverted: n10 = false, level: r10 = "info", position: o10 = "bottom-right", rounded: a10 = false, size: i10 = "default", customCSS: s10, component: l10, content: c10, dataAid: u10, id: d10, title: p10 } = e14;
  const m10 = kp(Vm, s10, { [Rm(`${o10}`)]: o10, [Rm(`level-${r10}`)]: "info" !== r10, [Rm("size-sm")]: "small" === i10, [Rm("size-lg")]: "large" === i10, [Rm("custom")]: l10, [Rm("rounded")]: a10, [Rm("inset")]: t10, [Rm("inverted")]: n10, [Rm("dot")]: void 0 === c10 && !l10 });
  return ep.createElement("div", { className: m10, title: p10, id: d10, "data-aid": u10 }, l10 || c10);
};
const [Om, Bm, zm] = Dp("gc-btn");
const [$m, Wm] = zm("text");
const [jm] = zm("icon");
const [Zm] = zm("icon-badge");
const [Gm] = Dp("gc-loader-button");
const Um = Bm("disabled");
const qm = (e14) => {
  const { accent: t10 = "none", background: n10 = "default", block: r10 = false, disabled: o10 = false, layout: a10 = "horizontal", level: i10 = "info", loading: s10 = false, rounded: l10 = false, textAlign: c10 = "left", type: u10 = "button", size: d10 = "default", id: p10, onClick: m10, width: h10, icon: f10, text: g10, title: y10, children: v10, customCSS: b10, name: S10, tabIndex: C10, onMouseDown: x10, dataAid: w10, badge: T10, onDoubleClick: E10, ariaRole: F10, ariaLabel: M10, ariaLabelledBy: k10, ariaHasPopup: P10, ariaExpanded: N10, ariaSelected: D10, ariaControls: L10, ariaActivedescendant: H10 } = e14;
  const I10 = ep.Children.toArray(v10).length > 0;
  const _10 = kp(Om, b10, { [Bm("block")]: r10, [Bm(`text-align-${c10}`)]: "left" !== c10, [Bm("with-icon")]: (f10 || s10) && !I10, [Bm("with-badge")]: T10 && "inline" === T10.position && !I10, [Bm("accent")]: "full" === t10, [Bm("transparent")]: "transparent" === n10, [Bm("custom")]: I10, [Bm(`level-${i10}`)]: "info" !== i10, [Bm("vertical")]: "vertical" === a10, [Gp]: l10, [Up]: "small" === d10, [qp]: "large" === d10 });
  const V10 = h10 && { width: h10 } || void 0;
  const R10 = kp(jm, { [Zp]: "icon" === t10 || "text+icon" === t10 });
  const A10 = kp($m, { [Wm("empty")]: !g10, [Zp]: "text" === t10 || "text+icon" === t10 });
  const O10 = { id: p10, tabIndex: C10, disabled: o10, type: u10, className: _10, style: V10, name: S10, title: y10, role: F10, "aria-label": M10, "aria-labelledby": k10, "aria-haspopup": P10, "aria-expanded": N10, "aria-selected": D10, "aria-activedescendant": H10, "aria-controls": L10, "aria-owns": L10, onClick: m10, onMouseDown: x10, onDoubleClick: E10 };
  let B10;
  T10 && (B10 = __spreadProps(__spreadValues({}, T10), { level: T10.level || i10, rounded: T10.rounded || l10, inset: T10.inset || T10.nearIcon, customCSS: kp({ [Zm]: T10.nearIcon }, T10.customCSS) }), "full" !== t10 || B10.level !== i10 && (i10 || "info" !== B10.level) || (B10.inverted = true));
  const z10 = s10 && { type: "font", iconCssClass: Gm } || f10;
  return ep.createElement("button", __spreadProps(__spreadValues({ type: "button" }, O10), { "data-aid": w10 }), !I10 && z10 && ep.createElement(Fm, { icon: z10, customCSS: R10 }), !I10 && ep.createElement("span", { className: A10 }, g10), v10, T10 && ep.createElement(Am, __spreadValues({}, B10)));
};
const Ym = { text: "gc-ci-a-text", accent: "gc-ci-a-accent" }, Km = { accent: "gc-ci-c-accent", secondary: "gc-ci-c-accent-sec", error: "gc-ci-c-accent-err" };
const Xm = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M8 2.5c0-.276-.224-.5-.5-.5s-.5.224-.5.5V7H2.5c-.276 0-.5.224-.5.5s.224.5.5.5H7v4.5c0 .276.224.5.5.5s.5-.224.5-.5V8h4.5c.276 0 .5-.224.5-.5s-.224-.5-.5-.5H8V2.5Z" }));
const Jm = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M3 8c0-.276.224-.5.5-.5h9c.276 0 .5.224.5.5s-.224.5-.5.5h-9c-.276 0-.5-.224-.5-.5Z" }));
const Qm = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M3 2.5c0-.276.224-.5.5-.5s.5.224.5.5v3.843l3.171-3.171c1.562-1.563 4.095-1.563 5.657 0 1.562 1.562 1.562 4.094 0 5.656l-5.025 5.026c-.195.195-.512.195-.707 0-.196-.196-.196-.512 0-.708l5.025-5.025c1.171-1.171 1.171-3.071 0-4.242-1.172-1.172-3.071-1.172-4.243 0L4.757 7H8.5c.276 0 .5.224.5.5s-.224.5-.5.5H3.6c-.331 0-.6-.269-.6-.6V2.5Z" }));
const eh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M12.999 2.5c0-.276-.223-.5-.5-.5-.276 0-.5.224-.5.5v3.843L8.828 3.172c-1.562-1.563-4.094-1.563-5.656 0-1.563 1.562-1.563 4.094 0 5.656l5.025 5.026c.195.195.512.195.707 0 .195-.196.195-.512 0-.708L3.879 8.121c-1.172-1.171-1.172-3.071 0-4.242 1.171-1.172 3.071-1.172 4.242 0L11.243 7H7.499c-.276 0-.5.224-.5.5s.224.5.5.5h4.9c.332 0 .6-.269.6-.6V2.5Z" }));
const th = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M2 4c0-1.105.895-2 2-2h6.379c.53 0 1.039.211 1.414.586l1.621 1.621c.375.375.586.884.586 1.414V12c0 1.105-.895 2-2 2H4c-1.105 0-2-.895-2-2V4Zm3-1H4c-.552 0-1 .448-1 1v8c0 .552.448 1 1 1V9.5C4 8.672 4.672 8 5.5 8h5c.828 0 1.5.672 1.5 1.5V13c.552 0 1-.448 1-1V5.621c0-.265-.105-.519-.293-.707l-1.621-1.621c-.188-.188-.442-.293-.707-.293H10v1.5C10 5.328 9.328 6 8.5 6h-2C5.672 6 5 5.328 5 4.5V3Zm0 10h6V9.5c0-.276-.224-.5-.5-.5h-5c-.276 0-.5.224-.5.5V13ZM9 3H6v1.5c0 .276.224.5.5.5h2c.276 0 .5-.224.5-.5V3Z" }));
const nh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M14 10c0 1.061-.421 2.078-1.172 2.828C12.078 13.579 11.061 14 10 14H6c-.352.002-.697-.091-1-.27-.302-.177-.553-.428-.73-.73H10c.795-.002 1.557-.319 2.119-.881.562-.562.879-1.324.881-2.119V5.3l.41.41c.192.182.342.404.44.65.099.241.15.499.15.76V10Zm-3.707-7.414 1.121 1.121c.374.376.584.884.586 1.414V10c0 .53-.211 1.039-.586 1.414S10.53 12 10 12H4c-.53 0-1.039-.211-1.414-.586S2 10.53 2 10V4c0-.53.211-1.039.586-1.414S3.47 2 4 2h4.879c.53.001 1.038.212 1.414.586ZM5 3H4c-.265 0-.52.105-.707.293C3.105 3.48 3 3.735 3 4v6c0 .265.105.52.293.707.187.188.442.293.707.293V8c0-.265.105-.52.293-.707C4.48 7.105 4.735 7 5 7h4c.265 0 .52.105.707.293.188.187.293.442.293.707v3c.265 0 .52-.105.707-.293.188-.187.293-.442.293-.707V5.121c0-.265-.105-.52-.293-.707L9.586 3.293C9.426 3.141 9.22 3.022 9 3v1c0 .265-.105.52-.293.707C8.52 4.895 8.265 5 8 5H6c-.265 0-.52-.105-.707-.293C5.105 4.52 5 4.265 5 4V3Zm0 8h4V8H5v3Zm3-8H6v1h2V3Z" }));
const rh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M13.043 6v-.004c0-1.104-.896-2-2-2H6.214l-1.109-.887C5.016 3.039 4.906 3 4.793 3H3.04c-1.105 0-2 .895-2 2v6c0 1.105.895 2 2 2h9.25c.667 0 1.253-.44 1.44-1.079l1.169-4C15.18 6.961 14.46 6 13.459 6h-.416ZM3.04 4h1.577l1.11.887c.089.071.199.109.312.109h5.004c.552 0 1 .448 1 1V6H4.29c-.667 0-1.254.44-1.44 1.08l-.81 2.777V5c0-.552.448-1 1-1Zm.77 3.36c.062-.213.257-.36.48-.36h9.169c.334 0 .574.32.48.64l-1.169 4c-.062.213-.258.36-.48.36H3.123c-.333 0-.573-.32-.48-.64l1.167-4Z" }));
const oh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M4.146 6.646c.196-.195.512-.195.708 0L8 9.793l3.146-3.147c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-3.5 3.5c-.196.195-.512.195-.708 0l-3.5-3.5c-.195-.196-.195-.512 0-.708Z" }));
const ah = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M6.235 2.195C5.235 1.632 4 2.355 4 3.502v9c0 1.148 1.235 1.87 2.235 1.308l8-4.5c1.02-.574 1.02-2.041 0-2.615l-8-4.5Z" }));
const ih = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M2 8c0-3.314 2.686-6 6-6s6 2.686 6 6-2.686 6-6 6-6-2.686-6-6Zm6-5C5.239 3 3 5.239 3 8s2.239 5 5 5 5-2.239 5-5-2.239-5-5-5Zm0 4c.276 0 .5.224.5.5v3c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-3c0-.276.224-.5.5-.5Zm0-.751c-.414 0-.749-.335-.749-.749s.335-.749.749-.749.749.335.749.749-.335.749-.749.749Z" }));
const sh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M2.5 2h4c.276 0 .5.224.5.5s-.224.5-.5.5H3.707l3.147 3.146c.195.196.195.512 0 .708-.196.195-.512.195-.708 0L3 3.707V6.5c0 .276-.224.5-.5.5S2 6.776 2 6.5v-4c0-.276.224-.5.5-.5Zm0 12c-.276 0-.5-.224-.5-.5v-4c0-.276.224-.5.5-.5s.5.224.5.5v2.793l3.146-3.147c.196-.195.512-.195.708 0 .195.196.195.512 0 .708L3.707 13H6.5c.276 0 .5.224.5.5s-.224.5-.5.5h-4ZM14 2.5v4c0 .276-.224.5-.5.5s-.5-.224-.5-.5V3.707L9.854 6.854c-.196.195-.512.195-.708 0-.195-.196-.195-.512 0-.708L12.293 3H9.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h4c.276 0 .5.224.5.5ZM13.5 14h-4c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h2.793L9.146 9.854c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0L13 12.293V9.5c0-.276.224-.5.5-.5s.5.224.5.5v4c0 .276-.224.5-.5.5Z" }));
const lh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M6.5 7h-4c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h2.793L2.146 2.854c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0L6 5.293V2.5c0-.276.224-.5.5-.5s.5.224.5.5v4c0 .276-.224.5-.5.5Zm0 2c.276 0 .5.224.5.5v4c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-2.793l-3.146 3.147c-.196.195-.512.195-.708 0-.195-.196-.195-.512 0-.708L5.293 10H2.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h4ZM9 6.5v-4c0-.276.224-.5.5-.5s.5.224.5.5v2.793l3.146-3.147c.196-.195.512-.195.708 0 .195.196.195.512 0 .708L10.707 6H13.5c.276 0 .5.224.5.5s-.224.5-.5.5h-4c-.276 0-.5-.224-.5-.5ZM9.5 9h4c.276 0 .5.224.5.5s-.224.5-.5.5h-2.793l3.147 3.146c.195.196.195.512 0 .708-.196.195-.512.195-.708 0L10 10.707V13.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-4c0-.276.224-.5.5-.5" }));
const ch = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("g", { className: Ym.text }, tp.createElement("path", { fillOpacity: ".62", d: "M8 6c-1.105 0-2 .895-2 2s.895 2 2 2c1.104 0 2-.895 2-2s-.896-2-2-2ZM7 8c0-.552.448-1 1-1s1 .448 1 1-.448 1-1 1-1-.448-1-1Z" }), tp.createElement("path", { d: "M10.618 4.398c-.385.07-.754-.184-.824-.567l-.26-1.416c-.026-.141-.134-.252-.275-.282-.411-.087-.832-.131-1.259-.131-.427 0-.849.044-1.26.131-.14.03-.249.142-.275.282l-.259 1.416c-.007.037-.017.075-.03.111-.131.367-.537.558-.905.427l-1.36-.484c-.135-.048-.286-.011-.382.095-.569.627-1 1.367-1.262 2.173-.044.136-.001.285.108.378l1.102.931c.029.025.057.052.081.081.254.297.217.743-.081.995l-1.102.931c-.109.093-.152.242-.108.378.262.806.693 1.546 1.262 2.173.096.106.247.143.382.095l1.36-.484c.036-.013.073-.023.111-.029.385-.07.754.184.824.567l.259 1.416c.026.14.135.252.275.282.411.087.833.131 1.26.131.427 0 .848-.044 1.259-.131.141-.03.249-.141.275-.282l.26-1.416c.007-.037.017-.075.03-.111.131-.367.537-.558.905-.427l1.36.484c.135.048.286.011.382-.095.569-.627 1-1.367 1.262-2.173.044-.136.001-.285-.108-.378l-1.102-.931c-.029-.025-.057-.052-.081-.081-.254-.297-.217-.743.081-.995l1.102-.931c.109-.093.152-.242.108-.378-.262-.806-.693-1.546-1.262-2.173-.096-.106-.247-.143-.382-.095l-1.36.484c-.036.013-.073.023-.111.029Zm-6.619.579.936.334c.885.315 1.864-.143 2.183-1.032.031-.087.055-.177.072-.268l.177-.97c.209-.026.42-.039.633-.039.213 0 .424.013.632.039l.178.97c.171.93 1.063 1.539 1.987 1.371.091-.016.18-.04.268-.071l.936-.334c.255.334.467.698.631 1.084l-.755.637c-.72.61-.81 1.689-.196 2.408.06.07.126.136.196.196l.755.637c-.164.386-.376.75-.631 1.084l-.936-.334c-.885-.315-1.864.143-2.183 1.032-.031.087-.055.177-.072.268l-.178.97c-.208.026-.419.039-.632.039-.213 0-.424-.013-.633-.039l-.177-.97c-.17-.93-1.063-1.539-1.987-1.371-.091.016-.181.04-.268.071l-.936.334c-.255-.334-.467-.698-.631-1.084l.755-.637c.72-.61.81-1.689.196-2.408-.06-.07-.126-.136-.196-.196l-.755-.637c.164-.386.376-.75.631-1.084Z" })));
const uh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M7 3h2c0-.552-.448-1-1-1s-1 .448-1 1ZM6 3c0-1.105.895-2 2-2s2 .895 2 2h4c.276 0 .5.224.5.5s-.224.5-.5.5h-.564l-1.205 8.838C12.062 14.076 11.004 15 9.754 15H6.246c-1.25 0-2.308-.924-2.477-2.162L2.564 4H2c-.276 0-.5-.224-.5-.5S1.724 3 2 3h4Zm1 3.5c0-.276-.224-.5-.5-.5s-.5.224-.5.5v5c0 .276.224.5.5.5s.5-.224.5-.5v-5ZM9.5 6c.276 0 .5.224.5.5v5c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-5c0-.276.224-.5.5-.5Zm-4.74 6.703c.101.743.736 1.297 1.486 1.297h3.508c.75 0 1.385-.554 1.487-1.297L12.427 4H3.573l1.187 8.703Z" }));
const dh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M13.44 2.561c-.748-.748-1.96-.748-2.707-.001L3.338 9.955c-.181.181-.318.401-.399.644l-.914 2.743c-.06.18-.013.378.121.512s.332.18.512.12L5.4 13.06c.243-.081.464-.217.645-.398l7.395-7.394c.747-.748.747-1.96 0-2.707Zm-2 .707c.357-.357.936-.357 1.293 0 .357.357.357.936 0 1.293l-.734.733-1.293-1.293.734-.733Zm-1.441 1.44 1.293 1.293-5.954 5.954c-.071.071-.158.125-.254.156l-1.794.598.598-1.793c.032-.096.086-.183.157-.254l5.954-5.954Z" }));
const ph = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M10.068 2.443c-.712-.714-1.912-.537-2.386.354l-2.02 3.79-2.811.937c-.164.055-.289.191-.329.359-.039.169.011.346.133.469l2.147 2.146-2.647 2.647-.146.853.854-.146 2.646-2.647 2.146 2.147c.123.122.3.173.469.133.169-.04.305-.164.359-.329l.937-2.811 3.779-2.023c.886-.474 1.064-1.669.354-2.381l-3.485-3.498Zm-1.504.824c.158-.297.558-.356.796-.118l3.485 3.498c.237.237.177.636-.118.794L8.773 9.557c-.113.061-.198.162-.238.283l-.744 2.232-3.856-3.855 2.232-.744c.122-.041.223-.127.283-.24l2.114-3.966Z" }));
const mh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "m9.56 10.267 4.586 4.587c.196.195.512.195.708 0 .195-.196.195-.512 0-.708l-13-13c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708l4.586 4.585-.079.15-2.811.937c-.165.054-.289.19-.329.359-.039.169.011.346.133.469L4.793 10.5l-2.647 2.647L2 14l.854-.146L5.5 11.207l2.146 2.147c.123.122.3.172.469.133.169-.04.305-.164.359-.329l.937-2.811.149-.08Zm-.739-.739-.057.031c-.113.061-.198.162-.238.283l-.745 2.232-3.855-3.855 2.232-.745c.122-.04.223-.126.283-.239l.03-.056 2.35 2.349Zm3.897-2.085-2.054 1.099.738.739 1.788-.957c.886-.474 1.064-1.669.354-2.381l-3.485-3.498c-.712-.714-1.912-.537-2.386.353l-.957 1.796.739.739 1.1-2.064c.158-.297.558-.356.796-.118l3.485 3.498c.236.237.177.635-.118.794Z" }));
const hh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "m2.986 8.6-.009.028c-.071.267-.344.426-.611.355-.431-.114-.355-.611-.355-.611l.018-.062s.026-.084.047-.145c.042-.122.106-.292.197-.495.183-.405.475-.945.92-1.487C4.09 5.089 5.599 4 7.994 4s3.904 1.089 4.802 2.183c.444.542.737 1.082.919 1.487.091.203.156.373.198.495.021.061.036.11.047.145.005.018.009.032.012.042l.005.02c.071.267-.088.541-.355.611-.266.071-.54-.087-.611-.354l-.009-.029c-.007-.024-.018-.061-.035-.109-.033-.097-.086-.239-.164-.411-.155-.345-.405-.805-.781-1.263C11.28 5.911 10.038 5 7.994 5c-2.044 0-3.285.911-4.028 1.817-.376.458-.625.918-.781 1.263-.077.172-.131.314-.164.411-.016.048-.028.085-.035.109ZM7.994 7c-1.38 0-2.5 1.119-2.5 2.5s1.12 2.5 2.5 2.5c1.381 0 2.5-1.119 2.5-2.5S9.375 7 7.994 7Zm-1.5 2.5c0-.828.672-1.5 1.5-1.5.829 0 1.5.672 1.5 1.5s-.671 1.5-1.5 1.5c-.828 0-1.5-.672-1.5-1.5Z" }));
const fh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "m10.12 10.827 4.026 4.027c.196.195.512.195.708 0 .195-.196.195-.512 0-.708l-13-13c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708l3.23 3.229c-.475.335-.863.717-1.177 1.1-.445.542-.737 1.082-.92 1.487-.091.203-.155.373-.197.495-.021.061-.047.145-.047.145l-.018.062s-.076.497.355.611c.267.071.541-.088.611-.355l.009-.028c.007-.024.019-.061.035-.109.033-.097.087-.239.164-.411.156-.345.405-.805.781-1.263.292-.356.66-.712 1.124-1.014l1.578 1.578C5.969 7.823 5.5 8.607 5.5 9.5 5.5 10.881 6.62 12 8 12c.894 0 1.677-.469 2.12-1.173Zm-.739-.739C9.152 10.624 8.62 11 8 11c-.828 0-1.5-.672-1.5-1.5 0-.62.376-1.152.912-1.38l1.969 1.968ZM6.32 4.199l.854.854C7.434 5.019 7.709 5 8 5c2.044 0 3.286.912 4.028 1.817.376.458.626.918.781 1.263.078.172.131.314.164.411.017.048.028.085.035.109l.009.029c.071.267.345.425.611.354.267-.07.426-.344.355-.611l-.005-.02c-.003-.01-.007-.024-.012-.042-.011-.035-.026-.084-.047-.145-.042-.122-.107-.292-.198-.495-.182-.405-.475-.945-.919-1.487C11.904 5.089 10.395 4 8 4c-.617 0-1.176.072-1.68.199Z" }));
const gh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M7.836 1.505 8 1.5c1.325 0 2.41 1.032 2.495 2.336L10.5 4v1h1c.828 0 1.5.672 1.5 1.5v6c0 .828-.672 1.5-1.5 1.5h-7c-.828 0-1.5-.672-1.5-1.5v-6C3 5.672 3.672 5 4.5 5h1V4c0-1.325 1.032-2.41 2.336-2.495ZM11.5 6h-7c-.276 0-.5.224-.5.5v6c0 .276.224.5.5.5h7c.276 0 .5-.224.5-.5v-6c0-.276-.224-.5-.5-.5ZM8 8.5c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1Zm.144-5.993L8 2.5c-.78 0-1.42.595-1.493 1.356L6.5 4v1h3V4c0-.78-.595-1.42-1.356-1.493Z" }));
const yh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M8 11.5c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1Zm0-9c-.828 0-1.5.672-1.5 1.5v2h5c.828 0 1.5.672 1.5 1.5v6c0 .828-.672 1.5-1.5 1.5h-7c-.828 0-1.5-.672-1.5-1.5v-6C3 6.672 3.672 6 4.5 6h1V4c0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5c0-.828-.672-1.5-1.5-1.5ZM4.5 7c-.276 0-.5.224-.5.5v6c0 .276.224.5.5.5h7c.276 0 .5-.224.5-.5v-6c0-.276-.224-.5-.5-.5h-7Z" }));
const vh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M5 8c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1Zm4 0c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1Zm3 1c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1Z" }));
const bh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M8.5 2.5c0-.276-.224-.5-.5-.5s-.5.224-.5.5v9.697L3.872 8.166c-.185-.206-.501-.222-.706-.038-.206.185-.222.501-.038.706l4.5 5.001c.095.105.23.165.372.165s.277-.06.372-.165l4.5-5.001c.184-.205.168-.521-.038-.706-.205-.184-.521-.168-.706.038L8.5 12.197V2.5Z" }));
const Sh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M11 6c0 .552.448 1 1 1s1-.448 1-1-.448-1-1-1-1 .448-1 1ZM7 6c0 .552.448 1 1 1s1-.448 1-1-.448-1-1-1-1 .448-1 1ZM4 7c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1Zm7 3c0 .552.448 1 1 1s1-.448 1-1-.448-1-1-1-1 .448-1 1Zm-3 1c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1Zm-5-1c0 .552.448 1 1 1s1-.448 1-1-.448-1-1-1-1 .448-1 1Z" }));
const Ch = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M8 3C5.239 3 3 5.239 3 8c0 1.201.423 2.302 1.129 3.164l7.035-7.035C10.302 3.423 9.201 3 8 3Zm3.871 1.836-7.035 7.035C5.698 12.577 6.799 13 8 13c2.761 0 5-2.239 5-5 0-1.201-.423-2.302-1.129-3.164ZM2 8c0-3.314 2.686-6 6-6s6 2.686 6 6-2.686 6-6 6-6-2.686-6-6Z" }));
const xh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "m2.589 2.716.057-.07c.174-.173.443-.192.638-.057l.07.057L8 7.293l4.646-4.647c.196-.195.512-.195.708 0 .195.196.195.512 0 .708L8.707 8l4.647 4.646c.173.174.192.443.057.638l-.057.07c-.174.173-.443.192-.638.057l-.07-.057L8 8.707l-4.646 4.647c-.196.195-.512.195-.708 0-.195-.196-.195-.512 0-.708L7.293 8 2.646 3.354c-.173-.174-.192-.443-.057-.638l.057-.07-.057.07Z" }));
const wh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M4 2c-1.105 0-2 .895-2 2v6c0 1.105.895 2 2 2h6c1.105 0 2-.895 2-2V4c0-1.105-.895-2-2-2H4ZM3 4c0-.552.448-1 1-1h6c.552 0 1 .448 1 1v6c0 .552-.448 1-1 1H4c-.552 0-1-.448-1-1V4Zm1.268 9c.345.598.992 1 1.732 1h4c2.209 0 4-1.791 4-4V6c0-.74-.402-1.387-1-1.732V10c0 1.657-1.343 3-3 3H4.268Z" }));
const Th = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M2 4c0-1.105.895-2 2-2h6c1.105 0 2 .895 2 2v6c0 1.105-.895 2-2 2H4c-1.105 0-2-.895-2-2V4Zm2-1c-.552 0-1 .448-1 1v6c0 .552.448 1 1 1h6c.552 0 1-.448 1-1V4c0-.552-.448-1-1-1H4Zm2.275 4.525 2.871-2.878c.195-.196.512-.196.707-.001.174.173.194.443.059.638l-.058.069L6.63 8.586c-.174.174-.443.193-.639.058l-.069-.058-1.75-1.75c-.195-.195-.195-.511 0-.707.174-.173.443-.192.638-.057l.069.057 1.396 1.396ZM6 14c-.74 0-1.387-.402-1.732-1H10c1.657 0 3-1.343 3-3V4.268c.598.345 1 .992 1 1.732v4c0 2.209-1.791 4-4 4H6Z" }));
const Eh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M9.309 10.016c-.77.616-1.746.984-2.809.984C4.015 11 2 8.985 2 6.5S4.015 2 6.5 2 11 4.015 11 6.5c0 1.063-.368 2.039-.984 2.809l3.838 3.837c.195.196.195.512 0 .708-.196.195-.512.195-.708 0l-3.837-3.838ZM10 6.5C10 4.567 8.433 3 6.5 3S3 4.567 3 6.5 4.567 10 6.5 10 10 8.433 10 6.5Z" }));
const Fh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M13.864 3.657c.189.201.18.517-.021.707l-7.93 7.474c-.237.223-.61.217-.839-.016l-2.68-2.72c-.194-.197-.192-.513.005-.707.197-.194.513-.192.707.005l2.406 2.442 7.645-7.206c.201-.189.517-.18.707.021Z" }));
const Mh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "m10.293 11 3.853 3.854c.196.195.512.195.708 0 .195-.196.195-.512 0-.708l-13-13c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708L4.293 5H2.5c-.276 0-.5.224-.5.5s.224.5.5.5h2.793l4 4H2.5c-.276 0-.5.224-.5.5s.224.5.5.5h7.793Zm1.828-1 1 1h.379c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-1.379Zm-5-5 1 1H13.5c.276 0 .5-.224.5-.5s-.224-.5-.5-.5H7.121Z" }));
const kh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M2.498 6.55c-.182 0-.353-.049-.5-.134-.298-.173-.498-.495-.498-.865 0-.369.2-.691.498-.864.147-.085.318-.134.5-.134s.353.049.5.134c.298.173.499.495.499.864s-.201.692-.499.865c-.147.085-.318.134-.5.134Zm-.325-2.971c.106-.017.215-.026.325-.026.26 0 .508.05.736.14C3.5 3.276 3.967 3 4.498 3h7c.829 0 1.5.672 1.5 1.5v7c0 .828-.671 1.5-1.5 1.5h-7c-.828 0-1.5-.672-1.5-1.5V7.487c-.16.041-.327.063-.5.063-.172 0-.34-.022-.5-.063V11.5c0 1.381 1.12 2.5 2.5 2.5h7c1.381 0 2.5-1.119 2.5-2.5v-7c0-1.381-1.119-2.5-2.5-2.5h-7c-1.055 0-1.958.654-2.325 1.579ZM5.998 6c-.276 0-.5.224-.5.5s.224.5.5.5h4c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-4Zm0 3c-.276 0-.5.224-.5.5s.224.5.5.5h2.614c.276 0 .5-.224.5-.5s-.224-.5-.5-.5H5.998Z" }));
const Ph = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M2 3.5c0-.27614.22386-.5.5-.5h11c.2761 0 .5.22386.5.5s-.2239.5-.5.5h-11c-.27614 0-.5-.22386-.5-.5Zm0 4c0-.27614.22386-.5.5-.5h11c.2761 0 .5.22386.5.5s-.2239.5-.5.5h-11c-.27614 0-.5-.22386-.5-.5Zm0 4c0-.2761.22386-.5.5-.5h11c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-11c-.27614 0-.5-.2239-.5-.5Z" }));
const Nh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M8.74707 10.2487c0 .4142-.33579.75-.75.75s-.75-.3358-.75-.75c0-.41418.33579-.74997.75-.74997s.75.33579.75.74997Zm-1.25-2.24997c0 .27615.22386.5.5.5s.5-.22385.5-.5v-2.5c0-.27614-.22386-.5-.5-.5s-.5.22386-.5.5v2.5Zm-.59142-5.36259c.47714-.85349 1.70532-.85337 2.18229.00022L13.8385 11.138c.4655.8333-.1368 1.8598-1.0912 1.8598H3.244c-.95458 0-1.55688-1.0268-1.09108-1.86l4.75273-8.50166Zm1.30933.48801c-.0954-.17072-.34103-.17075-.43646-.00005l-4.75274 8.5017c-.09316.1666.0273.372.21822.372h9.5033c.1908 0 .3113-.2053.2182-.372L8.21498 3.12415Z" }));
const Dh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M8 2c3.3137 0 6 2.68629 6 6 0 3.3137-2.6863 6-6 6-3.31371 0-6-2.6863-6-6 0-3.31371 2.68629-6 6-6Zm0 1C5.23858 3 3 5.23858 3 8c0 2.7614 2.23858 5 5 5 2.7614 0 5-2.2386 5-5 0-2.76142-2.2386-5-5-5Zm0 7c.41421 0 .75.3358.75.75s-.33579.75-.75.75-.75-.3358-.75-.75S7.58579 10 8 10Zm0-5.5c.24546 0 .44961.17688.49194.41012L8.5 5v3.5c0 .27614-.22386.5-.5.5-.24546 0-.44961-.17688-.49194-.41012L7.5 8.5V5c0-.27614.22386-.5.5-.5Z" }));
const Lh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M5.24848 8.99696c.41338 0 .74848-.3351.74848-.74848 0-.41337-.3351-.74848-.74848-.74848-.41337 0-.74848.33511-.74848.74848 0 .41338.33511.74848.74848.74848Zm.74848 1.75154c0 .4134-.3351.7485-.74848.7485-.41337 0-.74848-.3351-.74848-.7485 0-.4134.33511-.7485.74848-.7485.41338 0 .74848.3351.74848.7485Zm2.00347-1.75154c.41338 0 .74849-.3351.74849-.74848 0-.41337-.33511-.74848-.74849-.74848-.41337 0-.74848.33511-.74848.74848 0 .41338.33511.74848.74848.74848Zm.74849 1.75154c0 .4134-.33511.7485-.74849.7485-.41337 0-.74848-.3351-.74848-.7485 0-.4134.33511-.7485.74848-.7485.41338 0 .74849.3351.74849.7485Zm1.99958-1.75154c.4134 0 .7485-.3351.7485-.74848 0-.41337-.3351-.74848-.7485-.74848-.4134 0-.7485.33511-.7485.74848 0 .41338.3351.74848.7485.74848ZM14 4.5C14 3.11929 12.8807 2 11.5 2h-7C3.11929 2 2 3.11929 2 4.5v7C2 12.8807 3.11929 14 4.5 14h7c1.3807 0 2.5-1.1193 2.5-2.5v-7ZM3 6h10v5.5c0 .8284-.6716 1.5-1.5 1.5h-7c-.82843 0-1.5-.6716-1.5-1.5V6Zm1.5-3h7c.8284 0 1.5.67157 1.5 1.5V5H3v-.5C3 3.67157 3.67157 3 4.5 3Z" }));
const Hh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("g", { className: Ym.text }, tp.createElement("path", { fillOpacity: ".38", d: "M10.564 3C11.908 3 13 4.092 13 5.436V6.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5V5.436C12 4.644 11.356 4 10.564 4H9.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h1.064Zm0 9c.792 0 1.436-.644 1.436-1.436V9.5c0-.276.224-.5.5-.5s.5.224.5.5v1.064C13 11.908 11.908 13 10.564 13H9.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h1.064ZM4 10.564C4 11.356 4.644 12 5.436 12H6.5c.276 0 .5.224.5.5s-.224.5-.5.5H5.436C4.092 13 3 11.908 3 10.564V9.5c0-.276.224-.5.5-.5s.5.224.5.5v1.064Z" }), tp.createElement("path", { d: "M3 6.5V5.436C3 4.092 4.092 3 5.436 3H6.5c.276 0 .5.224.5.5s-.224.5-.5.5H5.436C4.644 4 4 4.644 4 5.436V6.5c0 .276-.224.5-.5.5S3 6.776 3 6.5Z" })));
const Ih = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M8 2c3.3137 0 6 2.68629 6 6 0 3.3137-2.6863 6-6 6-3.31371 0-6-2.6863-6-6 0-3.31371 2.68629-6 6-6Zm0 1C5.23858 3 3 5.23858 3 8c0 2.7614 2.23858 5 5 5 2.7614 0 5-2.2386 5-5 0-2.76142-2.2386-5-5-5Zm0 7.5c.41421 0 .75.3358.75.75S8.41421 12 8 12s-.75-.3358-.75-.75.33579-.75.75-.75Zm0-6c1.10457 0 2 .89543 2 2 0 .73053-.21178 1.13969-.75395 1.70791l-.26409.26954C8.60451 8.87102 8.5 9.0831 8.5 9.5c0 .27614-.22386.5-.5.5s-.5-.22386-.5-.5c0-.73053.21178-1.13969.75395-1.70791l.26409-.26954C8.89549 7.12898 9 6.9169 9 6.5c0-.55228-.44772-1-1-1s-1 .44772-1 1c0 .27614-.22386.5-.5.5S6 6.77614 6 6.5c0-1.10457.89543-2 2-2Z" }));
const _h = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M11.5 5.50207c0 .55343-.4486 1.00207-1.0021 1.00207-.55341 0-1.00205-.44864-1.00205-1.00207 0-.55343.44864-1.00207 1.00205-1.00207.5535 0 1.0021.44864 1.0021 1.00207ZM2 4.5C2 3.11929 3.11929 2 4.5 2h7C12.8807 2 14 3.11929 14 4.5v7c0 1.3807-1.1193 2.5-2.5 2.5h-7C3.11929 14 2 12.8807 2 11.5v-7ZM4.5 3C3.67157 3 3 3.67157 3 4.5v7c0 .2316.05248.4509.1462.6467l3.65176-3.65171c.66389-.66389 1.74027-.66389 2.40416 0l3.65168 3.65171c.0937-.1958.1462-.4151.1462-.6467v-7c0-.82843-.6716-1.5-1.5-1.5h-7Zm7.6467 9.8538L8.49501 9.2021c-.27337-.27337-.71658-.27337-.98995 0l-3.65173 3.6517c.19581.0937.41511.1462.64667.1462h7c.2316 0 .4509-.0525.6467-.1462" }));
const Vh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "m8.85355 10.8536-3 3c-.19526.1952-.51184.1952-.7071 0l-3-3c-.19527-.1953-.19527-.5119 0-.7072.19526-.19522.51184-.19522.7071 0L5 12.2929V2.5c0-.27614.22386-.5.5-.5s.5.22386.5.5v9.7929l2.14645-2.1465c.19526-.19522.51184-.19522.7071 0 .19527.1953.19527.5119 0 .7072ZM8.5 3c-.27614 0-.5.22386-.5.5s.22386.5.5.5h5c.2761 0 .5-.22386.5-.5s-.2239-.5-.5-.5h-5Zm0 2c-.27614 0-.5.22386-.5.5s.22386.5.5.5h3c.2761 0 .5-.22386.5-.5s-.2239-.5-.5-.5h-3Zm0 2c-.27614 0-.5.22386-.5.5s.22386.5.5.5h1c.27614 0 .5-.22386.5-.5S9.77614 7 9.5 7h-1Z" }));
const Rh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16px", viewBox: "0 0 16 16" }, tp.createElement("path", { className: Ym.text, d: "M3.5 13h9c.2761 0 .5.2239.5.5 0 .2455-.1769.4496-.4101.4919L12.5 14h-9c-.27614 0-.5-.2239-.5-.5 0-.2455.17688-.4496.41012-.4919L3.5 13h9-9ZM7.91012 1.00806 8 1c.24546 0 .44961.17688.49194.41012L8.5 1.5v8.792l2.682-2.68109c.1735-.17356.443-.19285.6378-.05785l.0693.05785c.1736.17357.1928.44299.0578.63786l-.0578.06925-3.53555 3.53558c-.17356.1735-.44299.1928-.63786.0578l-.06924-.0578-3.53554-3.53558c-.19526-.19526-.19526-.51185 0-.70711.17357-.17356.44299-.19285.63786-.05785l.06925.05785L7.5 10.292V1.5c0-.24546.17688-.44961.41012-.49194L8 1l-.08988.00806Z" }));
const Ah = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" }, tp.createElement("path", { className: Ym.text, d: "M14 4.5A2.5 2.5 0 0 0 11.5 2h-7A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7ZM3 6h10v5.5a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5V6Zm1.5-3h7A1.5 1.5 0 0 1 13 4.5V5H3v-.5A1.5 1.5 0 0 1 4.5 3Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M5.248 8.997a.748.748 0 1 1 0-1.497.748.748 0 0 1 0 1.497Zm5.5 2.5a.748.748 0 1 1 0-1.497.748.748 0 0 1 0 1.497Z" }), tp.createElement("path", { className: Ym.text, d: "M11.497 8.252a.748.748 0 0 1-.749.748H7.997a.748.748 0 1 1 0-1.497h2.751c.414 0 .749.335.749.748Zm-2.748 2.497a.749.749 0 0 1-.749.749H5.248a.748.748 0 0 1 0-1.497H8c.414 0 .749.335.749.748Z" }));
const Oh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" }, tp.createElement("path", { className: Ym.text, d: "M2 11.5v-7A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5V6H3v5.5A1.5 1.5 0 0 0 4.5 13h4c-.003.034-.241 1-.241 1H4.5A2.5 2.5 0 0 1 2 11.5ZM13 5v-.5A1.5 1.5 0 0 0 11.5 3h-7A1.5 1.5 0 0 0 3 4.5V5h10Z" }), tp.createElement("path", { className: Ym.text, d: "M9.496 12.639a.5.5 0 0 0-.485-.622h-1.11a.5.5 0 0 1-.461-.692l2.083-4a.502.502 0 0 1 .462-.308h3.473a.5.5 0 0 1 .474.658l-.561 1.684a.5.5 0 0 0 .474.658h.403a.75.75 0 0 1 .512 1.299l-4.872 3.547c-.364.34-.947-.003-.827-.487l.435-1.737Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M5.251 9a.749.749 0 1 0 0-1.497.749.749 0 0 0 0 1.497ZM6 10.752a.748.748 0 1 1 0-.001Zm2.003-1.751a.749.749 0 1 0 0-1.497.749.749 0 0 0 0 1.497Z" }));
const Bh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20px", viewBox: "0 0 20 20" }, tp.createElement("path", { className: Ym.text, d: "M5.854 2.646c.195.196.195.512 0 .708L4.207 5H11c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6c0-.276.224-.5.5-.5s.5.224.5.5c0 2.761 2.239 5 5 5s5-2.239 5-5-2.239-5-5-5H4.207l1.647 1.646c.195.196.195.512 0 .708-.196.195-.512.195-.708 0l-2.5-2.5c-.195-.196-.195-.512 0-.708l2.5-2.5c.196-.195.512-.195.708 0Z" }));
const zh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20px", viewBox: "0 0 20 20" }, tp.createElement("path", { className: Ym.text, d: "M10.122 3.106c.611-1.221 2.238-1.485 3.203-.52l4.057 4.057c.965.965.701 2.593-.52 3.203l-3.458 1.729c-.329.165-.586.444-.722.785l-1.436 3.59c-.267.666-1.128.843-1.636.335L7 13.675l-3.293 3.293H3v-.707l3.293-3.293-2.61-2.61c-.508-.508-.331-1.369.335-1.636l3.59-1.436c.341-.136.621-.393.785-.722l1.729-3.458Zm2.496.187c-.483-.482-1.296-.35-1.601.26l-1.73 3.459c-.274.547-.739.975-1.307 1.203L4.39 9.651l5.927 5.927 1.436-3.59c.228-.568.656-1.033 1.204-1.307l3.458-1.729c.611-.306.742-1.119.26-1.602l-4.057-4.057Z" }));
const $h = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20px", viewBox: "0 0 20 20" }, tp.createElement("path", { className: Ym.text, d: "M2.854 2.146c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708l4.75 4.749-2.878 1.151c-.666.267-.843 1.128-.335 1.636L6.293 13 3 16.293V17h.707L7 13.707l2.61 2.61c.508.508 1.369.331 1.636-.335l1.151-2.878 4.749 4.75c.196.195.512.195.708 0 .195-.196.195-.512 0-.708l-15-15Zm8.774 10.189-1.311 3.275L4.39 9.683l3.275-1.311 3.963 3.963Zm1.328-1.622c-.027.013-.053.027-.08.042l.744.744 3.242-1.621c1.221-.611 1.485-2.238.52-3.203l-4.057-4.057c-.965-.965-2.592-.701-3.203.52L8.501 6.38l.744.744c.015-.027.029-.053.042-.081l1.729-3.458c.306-.61 1.119-.742 1.602-.26l4.057 4.057c.482.483.35 1.296-.26 1.602l-3.459 1.729Z" }));
const Wh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20px", viewBox: "0 0 20 20" }, tp.createElement("path", { className: Ym.text, d: "M6.25 10c0 .69-.56 1.25-1.25 1.25S3.75 10.69 3.75 10 4.31 8.75 5 8.75s1.25.56 1.25 1.25Zm5 0c0 .69-.56 1.25-1.25 1.25S8.75 10.69 8.75 10 9.31 8.75 10 8.75s1.25.56 1.25 1.25ZM15 11.25c.69 0 1.25-.56 1.25-1.25S15.69 8.75 15 8.75s-1.25.56-1.25 1.25.56 1.25 1.25 1.25Z" }));
const jh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20px", viewBox: "0 0 20 20" }, tp.createElement("path", { className: Ym.text, d: "M2 4.5c0-.27614.22386-.5.5-.5h15c.2761 0 .5.22386.5.5s-.2239.5-.5.5h-15c-.27614 0-.5-.22386-.5-.5Zm0 5c0-.27614.22386-.5.5-.5h15c.2761 0 .5.22386.5.5s-.2239.5-.5.5h-15c-.27614 0-.5-.22386-.5-.5Zm.5 4.5c-.27614 0-.5.2239-.5.5s.22386.5.5.5h15c.2761 0 .5-.2239.5-.5s-.2239-.5-.5-.5h-15Z" }));
const Zh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20px", viewBox: "0 0 20 20" }, tp.createElement("path", { className: Ym.text, d: "m4.08859 4.21569.05786-.06924c.17356-.17357.44299-.19285.63786-.05786l.06924.05786L10 9.293l5.1464-5.14655c.1736-.17357.443-.19285.6379-.05786l.0693.05786c.1735.17356.1928.44299.0578.63786l-.0578.06924L10.707 10l5.1466 5.1464c.1735.1736.1928.443.0578.6379l-.0578.0693c-.1736.1735-.443.1928-.6379.0578l-.0693-.0578L10 10.707l-5.14645 5.1466c-.17356.1735-.44299.1928-.63786.0578l-.06924-.0578c-.17357-.1736-.19285-.443-.05786-.6379l.05786-.0693L9.293 10 4.14645 4.85355c-.17357-.17356-.19285-.44299-.05786-.63786l.05786-.06924-.05786.06924Z" }));
const Gh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20px", viewBox: "0 0 20 20" }, tp.createElement("path", { className: Ym.text, d: "M17.1794 2.92494c-1.1523-1.21184-3.0767-1.23612-4.2591-.05373L3.54545 12.2456c-.32782.3278-.55537.7423-.65592 1.1949l-.87762 3.9499c-.03708.1669.01368.3412.13458.462.1209.1209.29517.1716.46206.1345l3.92639-.8731c.46743-.104.89554-.339 1.23413-.6776l9.35803-9.35812c1.141-1.14104 1.1642-2.98372.0523-4.15314Zm-3.552.6534c.7849-.78491 2.0624-.76879 2.8273.03566.7381.7763.7227 1.99952-.0347 2.75698l-.6713.67125-2.7926-2.79263.6713-.67126Zm-1.3785 1.37835 2.7927 2.79265-7.97964 7.97976c-.20415.2041-.46227.3458-.7441.4085l-3.15931.7026.70717-3.1828c.0593-.2669.19349-.5114.38682-.7047l7.99636-7.99601Z" }));
const Uh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24px", viewBox: "0 0 24 24" }, tp.createElement("path", { className: Ym.text, d: "M17.75 3c1.733 0 3.149 1.356 3.245 3.066L21 6.25v11.5c0 1.733-1.356 3.149-3.066 3.245L17.75 21H6.25c-1.733 0-3.149-1.357-3.245-3.066L3 17.75V9.372c.234.083.487.128.75.128s.516-.045.75-.128v8.378c0 .918.707 1.671 1.606 1.744l.144.006h11.5c.918 0 1.671-.707 1.744-1.607l.006-.143V6.25c0-.918-.707-1.671-1.606-1.744L17.75 4.5H6.25c-.6 0-1.13.302-1.445.763C4.491 5.095 4.132 5 3.75 5c-.181 0-.357.021-.526.062.453-1.153 1.546-1.984 2.842-2.057L6.25 3h11.5Zm-4.504 10.003c.414 0 .75.336.75.75 0 .38-.282.694-.648.743l-.102.007H8.748c-.414 0-.75-.336-.75-.75 0-.38.282-.693.648-.743l.102-.007h4.498Zm2.006-3.507c.415 0 .75.336.75.75 0 .38-.282.694-.648.743l-.102.007H8.748c-.414 0-.75-.336-.75-.75 0-.379.282-.693.648-.743l.102-.007h6.504ZM3.75 6C4.44 6 5 6.56 5 7.25c0 .691-.56 1.25-1.25 1.25S2.5 7.941 2.5 7.25C2.5 6.56 3.06 6 3.75 6" }));
const qh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24px", viewBox: "0 0 24 24" }, tp.createElement("path", { className: kp(Ym.accent, "ci-sidebar-toggle__arrow"), d: "M9.193 9.249c.277-.308.751-.333 1.059-.056l2.5 2.25c.158.142.248.344.248.557 0 .213-.09.415-.248.557l-2.5 2.25c-.308.277-.782.252-1.059-.056-.278-.308-.253-.782.055-1.059l1.048-.942H6.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h3.546l-1.048-.942c-.308-.277-.333-.751-.055-1.059Z" }), tp.createElement("path", { className: Ym.text, d: "M14.5 4h4.75C20.769 4 22 5.231 22 6.749v10.502C22 18.769 20.769 20 19.25 20H14.5V4Zm4.75 14.5c.69 0 1.25-.559 1.25-1.249V6.749c0-.69-.56-1.249-1.25-1.249h-3.254v13h3.254Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".9", d: "M14.5 20H4.75C3.231 20 2 18.769 2 17.251V6.749C2 5.231 3.231 4 4.75 4h9.75v16Zm-.004-1.5v-13H4.75c-.69 0-1.25.559-1.25 1.249v10.502c0 .69.56 1.249 1.25 1.249h9.746Z" }));
const Yh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24px", viewBox: "0 0 24 24" }, tp.createElement("path", { className: Ym.text, d: "M2.75086 18.0007H21.2509c.4142 0 .75.3358.75.75 0 .3797-.2822.6935-.6483.7431l-.1017.0069H2.75086c-.41421 0-.75-.3358-.75-.75 0-.3797.28215-.6935.64823-.7432l.10177-.0068H21.2509 2.75086Zm0-6.497H21.2509c.4142 0 .75.3358.75.75 0 .3797-.2822.6935-.6483.7431l-.1017.0069H2.75086c-.41421 0-.75-.3358-.75-.75 0-.3797.28215-.6935.64823-.7432l.10177-.0068H21.2509 2.75086ZM2.75 5.00391h18.5c.4142 0 .75.33578.75.75 0 .37969-.2822.69349-.6482.74315l-.1018.00685H2.75c-.41421 0-.75-.33579-.75-.75 0-.3797.28215-.69349.64823-.74316L2.75 5.00391h18.5-18.5Z" }));
const Kh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24px", viewBox: "0 0 24 24" }, tp.createElement("path", { className: Ym.text, d: "M12 2c5.5228 0 10 4.47715 10 10 0 5.5228-4.4772 10-10 10-5.52285 0-10-4.4772-10-10C2 6.47715 6.47715 2 12 2Zm6.5173 4.54309L6.54309 18.5173C8.01955 19.7549 9.92276 20.5 12 20.5c4.6944 0 8.5-3.8056 8.5-8.5 0-2.07724-.7451-3.98045-1.9827-5.45691ZM12 3.5c-4.69442 0-8.5 3.80558-8.5 8.5 0 2.0772.74513 3.9804 1.98268 5.4569L17.4569 5.48268C15.9804 4.24513 14.0772 3.5 12 3.5Z" }));
const Xh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24px", viewBox: "0 0 24 24" }, tp.createElement("path", { className: Ym.text, d: "M12.0016 2c5.5237 0 10.0015 4.47785 10.0015 10.0016 0 5.5237-4.4778 10.0015-10.0015 10.0015C6.47785 22.0031 2 17.5253 2 12.0016 2 6.47785 6.47785 2 12.0016 2Zm0 1.5C7.30627 3.5 3.5 7.30627 3.5 12.0016c0 4.6952 3.80627 8.5015 8.5016 8.5015 4.6952 0 8.5015-3.8063 8.5015-8.5015 0-4.69533-3.8063-8.5016-8.5015-8.5016Zm-.0037 7.0006c.3797-.0003.6937.2817.7436.6477l.0069.1018.0036 5.5016c.0003.4142-.3353.7502-.7495.7505-.3797.0002-.6937-.2817-.7436-.6478l-.0069-.1017-.0036-5.5016c-.0003-.4142.3353-.7502.7495-.7505Zm.0041-3.49778c.5515 0 .9987.44711.9987.99866s-.4472.99866-.9987.99866c-.5515 0-.9987-.44711-.9987-.99866s.4472-.99866.9987-.99866Z" }));
const Jh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24px", viewBox: "0 0 24 24" }, tp.createElement("path", { className: Ym.text, d: "M12.9973 17.0019c0-.5515-.4471-.9986-.9986-.9986-.5516 0-.9987.4471-.9987.9986 0 .5516.4471.9987.9987.9987.5515 0 .9986-.4471.9986-.9987Zm-.2592-7.85325c-.0499-.36604-.3639-.64794-.7436-.64763-.4143.00033-.7498.33638-.7494.7506l.0036 4.50158.0069.1018c.0499.366.364.6479.7437.6476.4142-.0003.7497-.3364.7494-.7506l-.0036-4.50158-.007-.10177Zm1.2292-5.48782c-.8562-1.54779-3.0814-1.54777-3.9376.00005L2.28438 17.6624c-.82955 1.4996.25507 3.3391 1.96885 3.3391H19.7443c1.7138 0 2.7984-1.8396 1.9688-3.3392L13.9673 3.66083Zm-2.6251.72613c.2854-.51594 1.0272-.51595 1.3126-.00001l7.7457 14.00145c.2766.4999-.085 1.1131-.6562 1.1131H4.25323c-.57127 0-.9328-.6132-.65629-1.1131L11.3422 4.38696Z" }));
const Qh = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24px", viewBox: "0 0 24 24" }, tp.createElement("path", { className: Ym.text, d: "M12 2c5.523 0 10 4.478 10 10s-4.477 10-10 10S2 17.522 2 12 6.477 2 12 2Zm0 1.667c-4.595 0-8.333 3.738-8.333 8.333 0 4.595 3.738 8.333 8.333 8.333 4.595 0 8.333-3.738 8.333-8.333 0-4.595-3.738-8.333-8.333-8.333Zm-.0013 10.8352c.5515 0 .9986.4472.9986.9987 0 .5515-.4471.9987-.9986.9987-.5516 0-.9987-.4472-.9987-.9987 0-.5515.4471-.9987.9987-.9987ZM11.9945 7c.3797-.0003.6937.2816.7436.64764l.007.10176.0036 4.5016c.0003.4142-.3352.7503-.7494.7506-.3797.0003-.6938-.2816-.7437-.6476l-.0069-.1018-.0036-4.5016c-.0004-.41421.3351-.75027.7494-.7506Z" }));
const ef = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24px", viewBox: "0 0 24 24" }, tp.createElement("path", { className: Ym.text, d: "M12.011 2.25c.734.008 1.465.093 2.181.253.313.07.547.331.582.649l.17 1.527c.077.701.669 1.232 1.375 1.233.19 0 .377-.04.553-.117l1.4-.615c.292-.128.632-.059.849.174 1.013 1.081 1.766 2.377 2.205 3.792.095.305-.014.636-.271.826l-1.242.915c-.354.26-.563.673-.563 1.113 0 .439.209.852.564 1.113l1.243.915c.257.19.366.521.271.826-.438 1.415-1.192 2.711-2.203 3.792-.218.232-.558.302-.849.175l-1.406-.616c-.403-.177-.865-.151-1.245.069-.38.22-.633.607-.682 1.044l-.169 1.526c-.035.315-.263.574-.572.648-1.448.344-2.957.344-4.405 0-.309-.074-.537-.333-.572-.648l-.169-1.524c-.05-.436-.303-.822-.683-1.041-.38-.219-.841-.245-1.242-.07l-1.407.617c-.291.127-.631.057-.849-.175-1.012-1.082-1.765-2.38-2.203-3.796-.095-.305.014-.636.271-.826l1.244-.916c.354-.26.563-.673.563-1.112 0-.44-.209-.853-.564-1.114l-1.242-.914c-.258-.19-.367-.521-.272-.826.439-1.415 1.192-2.711 2.205-3.792.217-.233.557-.302.849-.174l1.4.615c.403.177.866.15 1.248-.073.381-.221.634-.609.683-1.045l.17-1.526c.035-.319.269-.579.582-.649.718-.16 1.449-.244 2.202-.253Zm0 1.5c-.454.005-.907.044-1.355.117l-.109.977c-.102.91-.628 1.717-1.418 2.175-.795.464-1.763.52-2.606.15l-.898-.394c-.572.694-1.027 1.476-1.348 2.317l.798.587c.739.543 1.175 1.405 1.175 2.322 0 .916-.436 1.778-1.174 2.321l-.799.588c.32.842.775 1.626 1.347 2.322l.906-.397c.838-.366 1.8-.312 2.592.144.792.457 1.321 1.263 1.424 2.174l.109.984c.89.151 1.799.151 2.689 0l.108-.984c.101-.911.629-1.719 1.422-2.178.794-.458 1.758-.512 2.597-.144l.905.396c.571-.695 1.027-1.477 1.347-2.318l-.798-.588c-.739-.543-1.175-1.405-1.175-2.321 0-.917.436-1.779 1.174-2.322l.797-.587c-.321-.84-.776-1.623-1.348-2.317l-.896.393c-.366.162-.761.245-1.16.245-1.47-.002-2.703-1.108-2.863-2.568l-.109-.977c-.446-.073-.894-.112-1.334-.117Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M11.998 8.25c2.071 0 3.75 1.679 3.75 3.75 0 2.071-1.679 3.75-3.75 3.75-2.071 0-3.75-1.679-3.75-3.75 0-2.071 1.679-3.75 3.75-3.75Zm0 1.5c-1.243 0-2.25 1.007-2.25 2.25s1.007 2.25 2.25 2.25 2.25-1.007 2.25-2.25-1.007-2.25-2.25-2.25Z" }));
const tf = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24px", viewBox: "0 0 24 24" }, tp.createElement("path", { className: Ym.text, d: "M17.75 3C19.5449 3 21 4.45507 21 6.25v11.5c0 1.7949-1.4551 3.25-3.25 3.25H6.25C4.45507 21 3 19.5449 3 17.75V6.25C3 4.45507 4.45507 3 6.25 3h11.5Zm.5805 16.4014-5.8058-5.6866c-.2651-.2595-.6746-.2832-.9659-.0708l-.0836.0708-5.80675 5.6863c.18195.064.37768.0989.58155.0989h11.5c.2035 0 .3989-.0347.5805-.0986l-5.8058-5.6866 5.8058 5.6866ZM17.75 4.5H6.25c-.9665 0-1.75.7835-1.75 1.75v11.5c0 .2084.03643.4083.10326.5937l5.82254-5.7007c.8331-.8157 2.1417-.8545 3.02-.1164l.1284.1165 5.8222 5.7016c.067-.1857.1036-.3859.1036-.5947V6.25c0-.9665-.7835-1.75-1.75-1.75Zm-2.4979 2c1.2438 0 2.2521 1.00831 2.2521 2.25212 0 1.2438-1.0083 2.25208-2.2521 2.25208S13 9.99592 13 8.75212C13 7.50831 14.0083 6.5 15.2521 6.5Zm0 1.5c-.4154 0-.7521.33673-.7521.75212 0 .41538.3367.75211.7521.75211s.7521-.33673.7521-.75211c0-.41539-.3367-.75212-.7521-.75212Z" }));
const nf = (e14, t10) => __spreadProps(__spreadValues({ type: "svg", content: e14 }, t10), { cssClass: kp("gc-icon--core", t10 == null ? void 0 : t10.cssClass) });
const rf = (e14, t10) => ep.useMemo(() => nf(e14, t10), []);
var of = { exports: {} };
var af = {};
var sf = { exports: {} };
var lf = {};
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
!function(e14) {
  var t10, n10, r10, o10, a10;
  if ("undefined" == typeof window || "function" != typeof MessageChannel) {
    var i10 = null, s10 = null, l10 = function() {
      if (null !== i10) try {
        var t11 = e14.unstable_now();
        i10(true, t11), i10 = null;
      } catch (e15) {
        throw setTimeout(l10, 0), e15;
      }
    }, c10 = Date.now();
    e14.unstable_now = function() {
      return Date.now() - c10;
    }, t10 = function(e15) {
      null !== i10 ? setTimeout(t10, 0, e15) : (i10 = e15, setTimeout(l10, 0));
    }, n10 = function(e15, t11) {
      s10 = setTimeout(e15, t11);
    }, r10 = function() {
      clearTimeout(s10);
    }, o10 = function() {
      return false;
    }, a10 = e14.unstable_forceFrameRate = function() {
    };
  } else {
    var u10 = window.performance, d10 = window.Date, p10 = window.setTimeout, m10 = window.clearTimeout;
    if ("undefined" != typeof console) {
      var h10 = window.cancelAnimationFrame;
      "function" != typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), "function" != typeof h10 && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" == typeof u10 && "function" == typeof u10.now) e14.unstable_now = function() {
      return u10.now();
    };
    else {
      var f10 = d10.now();
      e14.unstable_now = function() {
        return d10.now() - f10;
      };
    }
    var g10 = false, y10 = null, v10 = -1, b10 = 5, S10 = 0;
    o10 = function() {
      return e14.unstable_now() >= S10;
    }, a10 = function() {
    }, e14.unstable_forceFrameRate = function(e15) {
      0 > e15 || 125 < e15 ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : b10 = 0 < e15 ? Math.floor(1e3 / e15) : 5;
    };
    var C10 = new MessageChannel(), x10 = C10.port2;
    C10.port1.onmessage = function() {
      if (null !== y10) {
        var t11 = e14.unstable_now();
        S10 = t11 + b10;
        try {
          y10(true, t11) ? x10.postMessage(null) : (g10 = false, y10 = null);
        } catch (e15) {
          throw x10.postMessage(null), e15;
        }
      } else g10 = false;
    }, t10 = function(e15) {
      y10 = e15, g10 || (g10 = true, x10.postMessage(null));
    }, n10 = function(t11, n11) {
      v10 = p10(function() {
        t11(e14.unstable_now());
      }, n11);
    }, r10 = function() {
      m10(v10), v10 = -1;
    };
  }
  function w10(e15, t11) {
    var n11 = e15.length;
    e15.push(t11);
    e: for (; ; ) {
      var r11 = n11 - 1 >>> 1, o11 = e15[r11];
      if (!(void 0 !== o11 && 0 < F10(o11, t11))) break e;
      e15[r11] = t11, e15[n11] = o11, n11 = r11;
    }
  }
  function T10(e15) {
    return void 0 === (e15 = e15[0]) ? null : e15;
  }
  function E10(e15) {
    var t11 = e15[0];
    if (void 0 !== t11) {
      var n11 = e15.pop();
      if (n11 !== t11) {
        e15[0] = n11;
        e: for (var r11 = 0, o11 = e15.length; r11 < o11; ) {
          var a11 = 2 * (r11 + 1) - 1, i11 = e15[a11], s11 = a11 + 1, l11 = e15[s11];
          if (void 0 !== i11 && 0 > F10(i11, n11)) void 0 !== l11 && 0 > F10(l11, i11) ? (e15[r11] = l11, e15[s11] = n11, r11 = s11) : (e15[r11] = i11, e15[a11] = n11, r11 = a11);
          else {
            if (!(void 0 !== l11 && 0 > F10(l11, n11))) break e;
            e15[r11] = l11, e15[s11] = n11, r11 = s11;
          }
        }
      }
      return t11;
    }
    return null;
  }
  function F10(e15, t11) {
    var n11 = e15.sortIndex - t11.sortIndex;
    return 0 !== n11 ? n11 : e15.id - t11.id;
  }
  var M10 = [], k10 = [], P10 = 1, N10 = null, D10 = 3, L10 = false, H10 = false, I10 = false;
  function _10(e15) {
    for (var t11 = T10(k10); null !== t11; ) {
      if (null === t11.callback) E10(k10);
      else {
        if (!(t11.startTime <= e15)) break;
        E10(k10), t11.sortIndex = t11.expirationTime, w10(M10, t11);
      }
      t11 = T10(k10);
    }
  }
  function V10(e15) {
    if (I10 = false, _10(e15), !H10) if (null !== T10(M10)) H10 = true, t10(R10);
    else {
      var r11 = T10(k10);
      null !== r11 && n10(V10, r11.startTime - e15);
    }
  }
  function R10(t11, a11) {
    H10 = false, I10 && (I10 = false, r10()), L10 = true;
    var i11 = D10;
    try {
      for (_10(a11), N10 = T10(M10); null !== N10 && (!(N10.expirationTime > a11) || t11 && !o10()); ) {
        var s11 = N10.callback;
        if (null !== s11) {
          N10.callback = null, D10 = N10.priorityLevel;
          var l11 = s11(N10.expirationTime <= a11);
          a11 = e14.unstable_now(), "function" == typeof l11 ? N10.callback = l11 : N10 === T10(M10) && E10(M10), _10(a11);
        } else E10(M10);
        N10 = T10(M10);
      }
      if (null !== N10) var c11 = true;
      else {
        var u11 = T10(k10);
        null !== u11 && n10(V10, u11.startTime - a11), c11 = false;
      }
      return c11;
    } finally {
      N10 = null, D10 = i11, L10 = false;
    }
  }
  function A10(e15) {
    switch (e15) {
      case 1:
        return -1;
      case 2:
        return 250;
      case 5:
        return 1073741823;
      case 4:
        return 1e4;
      default:
        return 5e3;
    }
  }
  var O10 = a10;
  e14.unstable_IdlePriority = 5, e14.unstable_ImmediatePriority = 1, e14.unstable_LowPriority = 4, e14.unstable_NormalPriority = 3, e14.unstable_Profiling = null, e14.unstable_UserBlockingPriority = 2, e14.unstable_cancelCallback = function(e15) {
    e15.callback = null;
  }, e14.unstable_continueExecution = function() {
    H10 || L10 || (H10 = true, t10(R10));
  }, e14.unstable_getCurrentPriorityLevel = function() {
    return D10;
  }, e14.unstable_getFirstCallbackNode = function() {
    return T10(M10);
  }, e14.unstable_next = function(e15) {
    switch (D10) {
      case 1:
      case 2:
      case 3:
        var t11 = 3;
        break;
      default:
        t11 = D10;
    }
    var n11 = D10;
    D10 = t11;
    try {
      return e15();
    } finally {
      D10 = n11;
    }
  }, e14.unstable_pauseExecution = function() {
  }, e14.unstable_requestPaint = O10, e14.unstable_runWithPriority = function(e15, t11) {
    switch (e15) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        e15 = 3;
    }
    var n11 = D10;
    D10 = e15;
    try {
      return t11();
    } finally {
      D10 = n11;
    }
  }, e14.unstable_scheduleCallback = function(o11, a11, i11) {
    var s11 = e14.unstable_now();
    if ("object" == typeof i11 && null !== i11) {
      var l11 = i11.delay;
      l11 = "number" == typeof l11 && 0 < l11 ? s11 + l11 : s11, i11 = "number" == typeof i11.timeout ? i11.timeout : A10(o11);
    } else i11 = A10(o11), l11 = s11;
    return o11 = { id: P10++, callback: a11, priorityLevel: o11, startTime: l11, expirationTime: i11 = l11 + i11, sortIndex: -1 }, l11 > s11 ? (o11.sortIndex = l11, w10(k10, o11), null === T10(M10) && o11 === T10(k10) && (I10 ? r10() : I10 = true, n10(V10, l11 - s11))) : (o11.sortIndex = i11, w10(M10, o11), H10 || L10 || (H10 = true, t10(R10))), o11;
  }, e14.unstable_shouldYield = function() {
    var t11 = e14.unstable_now();
    _10(t11);
    var n11 = T10(M10);
    return n11 !== N10 && null !== N10 && null !== n11 && null !== n11.callback && n11.startTime <= t11 && n11.expirationTime < N10.expirationTime || o10();
  }, e14.unstable_wrapCallback = function(e15) {
    var t11 = D10;
    return function() {
      var n11 = D10;
      D10 = t11;
      try {
        return e15.apply(this, arguments);
      } finally {
        D10 = n11;
      }
    };
  };
}(lf), sf.exports = lf;
var cf = sf.exports;
/** @license React v16.13.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var uf = ep, df = hd, pf = cf;
function mf(e14) {
  for (var t10 = "https://reactjs.org/docs/error-decoder.html?invariant=" + e14, n10 = 1; n10 < arguments.length; n10++) t10 += "&args[]=" + encodeURIComponent(arguments[n10]);
  return "Minified React error #" + e14 + "; visit " + t10 + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!uf) throw Error(mf(227));
function hf(e14, t10, n10, r10, o10, a10, i10, s10, l10) {
  var c10 = Array.prototype.slice.call(arguments, 3);
  try {
    t10.apply(n10, c10);
  } catch (e15) {
    this.onError(e15);
  }
}
var ff = false, gf = null, yf = false, vf = null, bf = { onError: function(e14) {
  ff = true, gf = e14;
} };
function Sf(e14, t10, n10, r10, o10, a10, i10, s10, l10) {
  ff = false, gf = null, hf.apply(bf, arguments);
}
var Cf = null, xf = null, wf = null;
function Tf(e14, t10, n10) {
  var r10 = e14.type || "unknown-event";
  e14.currentTarget = wf(n10), function(e15, t11, n11, r11, o10, a10, i10, s10, l10) {
    if (Sf.apply(this, arguments), ff) {
      if (!ff) throw Error(mf(198));
      var c10 = gf;
      ff = false, gf = null, yf || (yf = true, vf = c10);
    }
  }(r10, t10, void 0, e14), e14.currentTarget = null;
}
var Ef = null, Ff = {};
function Mf() {
  if (Ef) for (var e14 in Ff) {
    var t10 = Ff[e14], n10 = Ef.indexOf(e14);
    if (!(-1 < n10)) throw Error(mf(96, e14));
    if (!Pf[n10]) {
      if (!t10.extractEvents) throw Error(mf(97, e14));
      for (var r10 in Pf[n10] = t10, n10 = t10.eventTypes) {
        var o10 = void 0;
        var a10 = n10[r10], i10 = t10, s10 = r10;
        if (Nf.hasOwnProperty(s10)) throw Error(mf(99, s10));
        Nf[s10] = a10;
        var l10 = a10.phasedRegistrationNames;
        if (l10) {
          for (o10 in l10) l10.hasOwnProperty(o10) && kf(l10[o10], i10, s10);
          o10 = true;
        } else a10.registrationName ? (kf(a10.registrationName, i10, s10), o10 = true) : o10 = false;
        if (!o10) throw Error(mf(98, r10, e14));
      }
    }
  }
}
function kf(e14, t10, n10) {
  if (Df[e14]) throw Error(mf(100, e14));
  Df[e14] = t10, Lf[e14] = t10.eventTypes[n10].dependencies;
}
var Pf = [], Nf = {}, Df = {}, Lf = {};
function Hf(e14) {
  var t10, n10 = false;
  for (t10 in e14) if (e14.hasOwnProperty(t10)) {
    var r10 = e14[t10];
    if (!Ff.hasOwnProperty(t10) || Ff[t10] !== r10) {
      if (Ff[t10]) throw Error(mf(102, t10));
      Ff[t10] = r10, n10 = true;
    }
  }
  n10 && Mf();
}
var If = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement), _f = null, Vf = null, Rf = null;
function Af(e14) {
  if (e14 = xf(e14)) {
    if ("function" != typeof _f) throw Error(mf(280));
    var t10 = e14.stateNode;
    t10 && (t10 = Cf(t10), _f(e14.stateNode, e14.type, t10));
  }
}
function Of(e14) {
  Vf ? Rf ? Rf.push(e14) : Rf = [e14] : Vf = e14;
}
function Bf() {
  if (Vf) {
    var e14 = Vf, t10 = Rf;
    if (Rf = Vf = null, Af(e14), t10) for (e14 = 0; e14 < t10.length; e14++) Af(t10[e14]);
  }
}
function zf(e14, t10) {
  return e14(t10);
}
function $f(e14, t10, n10, r10, o10) {
  return e14(t10, n10, r10, o10);
}
function Wf() {
}
var jf = zf, Zf = false, Gf = false;
function Uf() {
  null === Vf && null === Rf || (Wf(), Bf());
}
function qf(e14, t10, n10) {
  if (Gf) return e14(t10, n10);
  Gf = true;
  try {
    return jf(e14, t10, n10);
  } finally {
    Gf = false, Uf();
  }
}
var Yf = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Kf = Object.prototype.hasOwnProperty, Xf = {}, Jf = {};
function Qf(e14, t10, n10, r10, o10, a10) {
  this.acceptsBooleans = 2 === t10 || 3 === t10 || 4 === t10, this.attributeName = r10, this.attributeNamespace = o10, this.mustUseProperty = n10, this.propertyName = e14, this.type = t10, this.sanitizeURL = a10;
}
var eg = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e14) {
  eg[e14] = new Qf(e14, 0, false, e14, null, false);
}), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e14) {
  var t10 = e14[0];
  eg[t10] = new Qf(t10, 1, false, e14[1], null, false);
}), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e14) {
  eg[e14] = new Qf(e14, 2, false, e14.toLowerCase(), null, false);
}), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e14) {
  eg[e14] = new Qf(e14, 2, false, e14, null, false);
}), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e14) {
  eg[e14] = new Qf(e14, 3, false, e14.toLowerCase(), null, false);
}), ["checked", "multiple", "muted", "selected"].forEach(function(e14) {
  eg[e14] = new Qf(e14, 3, true, e14, null, false);
}), ["capture", "download"].forEach(function(e14) {
  eg[e14] = new Qf(e14, 4, false, e14, null, false);
}), ["cols", "rows", "size", "span"].forEach(function(e14) {
  eg[e14] = new Qf(e14, 6, false, e14, null, false);
}), ["rowSpan", "start"].forEach(function(e14) {
  eg[e14] = new Qf(e14, 5, false, e14.toLowerCase(), null, false);
});
var tg = /[\-:]([a-z])/g;
function ng(e14) {
  return e14[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e14) {
  var t10 = e14.replace(tg, ng);
  eg[t10] = new Qf(t10, 1, false, e14, null, false);
}), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e14) {
  var t10 = e14.replace(tg, ng);
  eg[t10] = new Qf(t10, 1, false, e14, "http://www.w3.org/1999/xlink", false);
}), ["xml:base", "xml:lang", "xml:space"].forEach(function(e14) {
  var t10 = e14.replace(tg, ng);
  eg[t10] = new Qf(t10, 1, false, e14, "http://www.w3.org/XML/1998/namespace", false);
}), ["tabIndex", "crossOrigin"].forEach(function(e14) {
  eg[e14] = new Qf(e14, 1, false, e14.toLowerCase(), null, false);
}), eg.xlinkHref = new Qf("xlinkHref", 1, false, "xlink:href", "http://www.w3.org/1999/xlink", true), ["src", "href", "action", "formAction"].forEach(function(e14) {
  eg[e14] = new Qf(e14, 1, false, e14.toLowerCase(), null, true);
});
var rg = uf.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
function og(e14, t10, n10, r10) {
  var o10 = eg.hasOwnProperty(t10) ? eg[t10] : null;
  (null !== o10 ? 0 === o10.type : !r10 && (2 < t10.length && ("o" === t10[0] || "O" === t10[0]) && ("n" === t10[1] || "N" === t10[1]))) || (function(e15, t11, n11, r11) {
    if (null == t11 || function(e16, t12, n12, r12) {
      if (null !== n12 && 0 === n12.type) return false;
      switch (typeof t12) {
        case "function":
        case "symbol":
          return true;
        case "boolean":
          return !r12 && (null !== n12 ? !n12.acceptsBooleans : "data-" !== (e16 = e16.toLowerCase().slice(0, 5)) && "aria-" !== e16);
        default:
          return false;
      }
    }(e15, t11, n11, r11)) return true;
    if (r11) return false;
    if (null !== n11) switch (n11.type) {
      case 3:
        return !t11;
      case 4:
        return false === t11;
      case 5:
        return isNaN(t11);
      case 6:
        return isNaN(t11) || 1 > t11;
    }
    return false;
  }(t10, n10, o10, r10) && (n10 = null), r10 || null === o10 ? function(e15) {
    return !!Kf.call(Jf, e15) || !Kf.call(Xf, e15) && (Yf.test(e15) ? Jf[e15] = true : (Xf[e15] = true, false));
  }(t10) && (null === n10 ? e14.removeAttribute(t10) : e14.setAttribute(t10, "" + n10)) : o10.mustUseProperty ? e14[o10.propertyName] = null === n10 ? 3 !== o10.type && "" : n10 : (t10 = o10.attributeName, r10 = o10.attributeNamespace, null === n10 ? e14.removeAttribute(t10) : (n10 = 3 === (o10 = o10.type) || 4 === o10 && true === n10 ? "" : "" + n10, r10 ? e14.setAttributeNS(r10, t10, n10) : e14.setAttribute(t10, n10))));
}
rg.hasOwnProperty("ReactCurrentDispatcher") || (rg.ReactCurrentDispatcher = { current: null }), rg.hasOwnProperty("ReactCurrentBatchConfig") || (rg.ReactCurrentBatchConfig = { suspense: null });
var ag = /^(.*)[\\\/]/, ig = "function" == typeof Symbol && Symbol.for, sg = ig ? Symbol.for("react.element") : 60103, lg = ig ? Symbol.for("react.portal") : 60106, cg = ig ? Symbol.for("react.fragment") : 60107, ug = ig ? Symbol.for("react.strict_mode") : 60108, dg = ig ? Symbol.for("react.profiler") : 60114, pg = ig ? Symbol.for("react.provider") : 60109, mg = ig ? Symbol.for("react.context") : 60110, hg = ig ? Symbol.for("react.concurrent_mode") : 60111, fg = ig ? Symbol.for("react.forward_ref") : 60112, gg = ig ? Symbol.for("react.suspense") : 60113, yg = ig ? Symbol.for("react.suspense_list") : 60120, vg = ig ? Symbol.for("react.memo") : 60115, bg = ig ? Symbol.for("react.lazy") : 60116, Sg = ig ? Symbol.for("react.block") : 60121, Cg = "function" == typeof Symbol && Symbol.iterator;
function xg(e14) {
  return null === e14 || "object" != typeof e14 ? null : "function" == typeof (e14 = Cg && e14[Cg] || e14["@@iterator"]) ? e14 : null;
}
function wg(e14) {
  if (null == e14) return null;
  if ("function" == typeof e14) return e14.displayName || e14.name || null;
  if ("string" == typeof e14) return e14;
  switch (e14) {
    case cg:
      return "Fragment";
    case lg:
      return "Portal";
    case dg:
      return "Profiler";
    case ug:
      return "StrictMode";
    case gg:
      return "Suspense";
    case yg:
      return "SuspenseList";
  }
  if ("object" == typeof e14) switch (e14.$$typeof) {
    case mg:
      return "Context.Consumer";
    case pg:
      return "Context.Provider";
    case fg:
      var t10 = e14.render;
      return t10 = t10.displayName || t10.name || "", e14.displayName || ("" !== t10 ? "ForwardRef(" + t10 + ")" : "ForwardRef");
    case vg:
      return wg(e14.type);
    case Sg:
      return wg(e14.render);
    case bg:
      if (e14 = 1 === e14._status ? e14._result : null) return wg(e14);
  }
  return null;
}
function Tg(e14) {
  var t10 = "";
  do {
    e: switch (e14.tag) {
      case 3:
      case 4:
      case 6:
      case 7:
      case 10:
      case 9:
        var n10 = "";
        break e;
      default:
        var r10 = e14._debugOwner, o10 = e14._debugSource, a10 = wg(e14.type);
        n10 = null, r10 && (n10 = wg(r10.type)), r10 = a10, a10 = "", o10 ? a10 = " (at " + o10.fileName.replace(ag, "") + ":" + o10.lineNumber + ")" : n10 && (a10 = " (created by " + n10 + ")"), n10 = "\n    in " + (r10 || "Unknown") + a10;
    }
    t10 += n10, e14 = e14.return;
  } while (e14);
  return t10;
}
function Eg(e14) {
  switch (typeof e14) {
    case "boolean":
    case "number":
    case "object":
    case "string":
    case "undefined":
      return e14;
    default:
      return "";
  }
}
function Fg(e14) {
  var t10 = e14.type;
  return (e14 = e14.nodeName) && "input" === e14.toLowerCase() && ("checkbox" === t10 || "radio" === t10);
}
function Mg(e14) {
  e14._valueTracker || (e14._valueTracker = function(e15) {
    var t10 = Fg(e15) ? "checked" : "value", n10 = Object.getOwnPropertyDescriptor(e15.constructor.prototype, t10), r10 = "" + e15[t10];
    if (!e15.hasOwnProperty(t10) && void 0 !== n10 && "function" == typeof n10.get && "function" == typeof n10.set) {
      var o10 = n10.get, a10 = n10.set;
      return Object.defineProperty(e15, t10, { configurable: true, get: function() {
        return o10.call(this);
      }, set: function(e16) {
        r10 = "" + e16, a10.call(this, e16);
      } }), Object.defineProperty(e15, t10, { enumerable: n10.enumerable }), { getValue: function() {
        return r10;
      }, setValue: function(e16) {
        r10 = "" + e16;
      }, stopTracking: function() {
        e15._valueTracker = null, delete e15[t10];
      } };
    }
  }(e14));
}
function kg(e14) {
  if (!e14) return false;
  var t10 = e14._valueTracker;
  if (!t10) return true;
  var n10 = t10.getValue();
  var r10 = "";
  return e14 && (r10 = Fg(e14) ? e14.checked ? "true" : "false" : e14.value), (e14 = r10) !== n10 && (t10.setValue(e14), true);
}
function Pg(e14, t10) {
  var n10 = t10.checked;
  return df({}, t10, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: null != n10 ? n10 : e14._wrapperState.initialChecked });
}
function Ng(e14, t10) {
  var n10 = null == t10.defaultValue ? "" : t10.defaultValue, r10 = null != t10.checked ? t10.checked : t10.defaultChecked;
  n10 = Eg(null != t10.value ? t10.value : n10), e14._wrapperState = { initialChecked: r10, initialValue: n10, controlled: "checkbox" === t10.type || "radio" === t10.type ? null != t10.checked : null != t10.value };
}
function Dg(e14, t10) {
  null != (t10 = t10.checked) && og(e14, "checked", t10, false);
}
function Lg(e14, t10) {
  Dg(e14, t10);
  var n10 = Eg(t10.value), r10 = t10.type;
  if (null != n10) "number" === r10 ? (0 === n10 && "" === e14.value || e14.value != n10) && (e14.value = "" + n10) : e14.value !== "" + n10 && (e14.value = "" + n10);
  else if ("submit" === r10 || "reset" === r10) return void e14.removeAttribute("value");
  t10.hasOwnProperty("value") ? Ig(e14, t10.type, n10) : t10.hasOwnProperty("defaultValue") && Ig(e14, t10.type, Eg(t10.defaultValue)), null == t10.checked && null != t10.defaultChecked && (e14.defaultChecked = !!t10.defaultChecked);
}
function Hg(e14, t10, n10) {
  if (t10.hasOwnProperty("value") || t10.hasOwnProperty("defaultValue")) {
    var r10 = t10.type;
    if (!("submit" !== r10 && "reset" !== r10 || void 0 !== t10.value && null !== t10.value)) return;
    t10 = "" + e14._wrapperState.initialValue, n10 || t10 === e14.value || (e14.value = t10), e14.defaultValue = t10;
  }
  "" !== (n10 = e14.name) && (e14.name = ""), e14.defaultChecked = !!e14._wrapperState.initialChecked, "" !== n10 && (e14.name = n10);
}
function Ig(e14, t10, n10) {
  "number" === t10 && e14.ownerDocument.activeElement === e14 || (null == n10 ? e14.defaultValue = "" + e14._wrapperState.initialValue : e14.defaultValue !== "" + n10 && (e14.defaultValue = "" + n10));
}
function _g(e14, t10) {
  return e14 = df({ children: void 0 }, t10), (t10 = function(e15) {
    var t11 = "";
    return uf.Children.forEach(e15, function(e16) {
      null != e16 && (t11 += e16);
    }), t11;
  }(t10.children)) && (e14.children = t10), e14;
}
function Vg(e14, t10, n10, r10) {
  if (e14 = e14.options, t10) {
    t10 = {};
    for (var o10 = 0; o10 < n10.length; o10++) t10["$" + n10[o10]] = true;
    for (n10 = 0; n10 < e14.length; n10++) o10 = t10.hasOwnProperty("$" + e14[n10].value), e14[n10].selected !== o10 && (e14[n10].selected = o10), o10 && r10 && (e14[n10].defaultSelected = true);
  } else {
    for (n10 = "" + Eg(n10), t10 = null, o10 = 0; o10 < e14.length; o10++) {
      if (e14[o10].value === n10) return e14[o10].selected = true, void (r10 && (e14[o10].defaultSelected = true));
      null !== t10 || e14[o10].disabled || (t10 = e14[o10]);
    }
    null !== t10 && (t10.selected = true);
  }
}
function Rg(e14, t10) {
  if (null != t10.dangerouslySetInnerHTML) throw Error(mf(91));
  return df({}, t10, { value: void 0, defaultValue: void 0, children: "" + e14._wrapperState.initialValue });
}
function Ag(e14, t10) {
  var n10 = t10.value;
  if (null == n10) {
    if (n10 = t10.children, t10 = t10.defaultValue, null != n10) {
      if (null != t10) throw Error(mf(92));
      if (Array.isArray(n10)) {
        if (!(1 >= n10.length)) throw Error(mf(93));
        n10 = n10[0];
      }
      t10 = n10;
    }
    null == t10 && (t10 = ""), n10 = t10;
  }
  e14._wrapperState = { initialValue: Eg(n10) };
}
function Og(e14, t10) {
  var n10 = Eg(t10.value), r10 = Eg(t10.defaultValue);
  null != n10 && ((n10 = "" + n10) !== e14.value && (e14.value = n10), null == t10.defaultValue && e14.defaultValue !== n10 && (e14.defaultValue = n10)), null != r10 && (e14.defaultValue = "" + r10);
}
function Bg(e14) {
  var t10 = e14.textContent;
  t10 === e14._wrapperState.initialValue && "" !== t10 && null !== t10 && (e14.value = t10);
}
var zg = "http://www.w3.org/1999/xhtml", $g = "http://www.w3.org/2000/svg";
function Wg(e14) {
  switch (e14) {
    case "svg":
      return "http://www.w3.org/2000/svg";
    case "math":
      return "http://www.w3.org/1998/Math/MathML";
    default:
      return "http://www.w3.org/1999/xhtml";
  }
}
function jg(e14, t10) {
  return null == e14 || "http://www.w3.org/1999/xhtml" === e14 ? Wg(t10) : "http://www.w3.org/2000/svg" === e14 && "foreignObject" === t10 ? "http://www.w3.org/1999/xhtml" : e14;
}
var Zg, Gg = (Ug = function(e14, t10) {
  if (e14.namespaceURI !== $g || "innerHTML" in e14) e14.innerHTML = t10;
  else {
    for ((Zg = Zg || document.createElement("div")).innerHTML = "<svg>" + t10.valueOf().toString() + "</svg>", t10 = Zg.firstChild; e14.firstChild; ) e14.removeChild(e14.firstChild);
    for (; t10.firstChild; ) e14.appendChild(t10.firstChild);
  }
}, "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction ? function(e14, t10, n10, r10) {
  MSApp.execUnsafeLocalFunction(function() {
    return Ug(e14, t10);
  });
} : Ug);
var Ug;
function qg(e14, t10) {
  if (t10) {
    var n10 = e14.firstChild;
    if (n10 && n10 === e14.lastChild && 3 === n10.nodeType) return void (n10.nodeValue = t10);
  }
  e14.textContent = t10;
}
function Yg(e14, t10) {
  var n10 = {};
  return n10[e14.toLowerCase()] = t10.toLowerCase(), n10["Webkit" + e14] = "webkit" + t10, n10["Moz" + e14] = "moz" + t10, n10;
}
var Kg = { animationend: Yg("Animation", "AnimationEnd"), animationiteration: Yg("Animation", "AnimationIteration"), animationstart: Yg("Animation", "AnimationStart"), transitionend: Yg("Transition", "TransitionEnd") }, Xg = {}, Jg = {};
function Qg(e14) {
  if (Xg[e14]) return Xg[e14];
  if (!Kg[e14]) return e14;
  var t10, n10 = Kg[e14];
  for (t10 in n10) if (n10.hasOwnProperty(t10) && t10 in Jg) return Xg[e14] = n10[t10];
  return e14;
}
If && (Jg = document.createElement("div").style, "AnimationEvent" in window || (delete Kg.animationend.animation, delete Kg.animationiteration.animation, delete Kg.animationstart.animation), "TransitionEvent" in window || delete Kg.transitionend.transition);
var ey = Qg("animationend"), ty = Qg("animationiteration"), ny = Qg("animationstart"), ry = Qg("transitionend"), oy = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), ay = new ("function" == typeof WeakMap ? WeakMap : Map)();
function iy(e14) {
  var t10 = ay.get(e14);
  return void 0 === t10 && (t10 = /* @__PURE__ */ new Map(), ay.set(e14, t10)), t10;
}
function sy(e14) {
  var t10 = e14, n10 = e14;
  if (e14.alternate) for (; t10.return; ) t10 = t10.return;
  else {
    e14 = t10;
    do {
      0 != (1026 & (t10 = e14).effectTag) && (n10 = t10.return), e14 = t10.return;
    } while (e14);
  }
  return 3 === t10.tag ? n10 : null;
}
function ly(e14) {
  if (13 === e14.tag) {
    var t10 = e14.memoizedState;
    if (null === t10 && (null !== (e14 = e14.alternate) && (t10 = e14.memoizedState)), null !== t10) return t10.dehydrated;
  }
  return null;
}
function cy(e14) {
  if (sy(e14) !== e14) throw Error(mf(188));
}
function uy(e14) {
  if (e14 = function(e15) {
    var t11 = e15.alternate;
    if (!t11) {
      if (null === (t11 = sy(e15))) throw Error(mf(188));
      return t11 !== e15 ? null : e15;
    }
    for (var n10 = e15, r10 = t11; ; ) {
      var o10 = n10.return;
      if (null === o10) break;
      var a10 = o10.alternate;
      if (null === a10) {
        if (null !== (r10 = o10.return)) {
          n10 = r10;
          continue;
        }
        break;
      }
      if (o10.child === a10.child) {
        for (a10 = o10.child; a10; ) {
          if (a10 === n10) return cy(o10), e15;
          if (a10 === r10) return cy(o10), t11;
          a10 = a10.sibling;
        }
        throw Error(mf(188));
      }
      if (n10.return !== r10.return) n10 = o10, r10 = a10;
      else {
        for (var i10 = false, s10 = o10.child; s10; ) {
          if (s10 === n10) {
            i10 = true, n10 = o10, r10 = a10;
            break;
          }
          if (s10 === r10) {
            i10 = true, r10 = o10, n10 = a10;
            break;
          }
          s10 = s10.sibling;
        }
        if (!i10) {
          for (s10 = a10.child; s10; ) {
            if (s10 === n10) {
              i10 = true, n10 = a10, r10 = o10;
              break;
            }
            if (s10 === r10) {
              i10 = true, r10 = a10, n10 = o10;
              break;
            }
            s10 = s10.sibling;
          }
          if (!i10) throw Error(mf(189));
        }
      }
      if (n10.alternate !== r10) throw Error(mf(190));
    }
    if (3 !== n10.tag) throw Error(mf(188));
    return n10.stateNode.current === n10 ? e15 : t11;
  }(e14), !e14) return null;
  for (var t10 = e14; ; ) {
    if (5 === t10.tag || 6 === t10.tag) return t10;
    if (t10.child) t10.child.return = t10, t10 = t10.child;
    else {
      if (t10 === e14) break;
      for (; !t10.sibling; ) {
        if (!t10.return || t10.return === e14) return null;
        t10 = t10.return;
      }
      t10.sibling.return = t10.return, t10 = t10.sibling;
    }
  }
  return null;
}
function dy(e14, t10) {
  if (null == t10) throw Error(mf(30));
  return null == e14 ? t10 : Array.isArray(e14) ? Array.isArray(t10) ? (e14.push.apply(e14, t10), e14) : (e14.push(t10), e14) : Array.isArray(t10) ? [e14].concat(t10) : [e14, t10];
}
function py(e14, t10, n10) {
  Array.isArray(e14) ? e14.forEach(t10, n10) : e14 && t10.call(n10, e14);
}
var my = null;
function hy(e14) {
  if (e14) {
    var t10 = e14._dispatchListeners, n10 = e14._dispatchInstances;
    if (Array.isArray(t10)) for (var r10 = 0; r10 < t10.length && !e14.isPropagationStopped(); r10++) Tf(e14, t10[r10], n10[r10]);
    else t10 && Tf(e14, t10, n10);
    e14._dispatchListeners = null, e14._dispatchInstances = null, e14.isPersistent() || e14.constructor.release(e14);
  }
}
function fy(e14) {
  if (null !== e14 && (my = dy(my, e14)), e14 = my, my = null, e14) {
    if (py(e14, hy), my) throw Error(mf(95));
    if (yf) throw e14 = vf, yf = false, vf = null, e14;
  }
}
function gy(e14) {
  return (e14 = e14.target || e14.srcElement || window).correspondingUseElement && (e14 = e14.correspondingUseElement), 3 === e14.nodeType ? e14.parentNode : e14;
}
function yy(e14) {
  if (!If) return false;
  var t10 = (e14 = "on" + e14) in document;
  return t10 || ((t10 = document.createElement("div")).setAttribute(e14, "return;"), t10 = "function" == typeof t10[e14]), t10;
}
var vy = [];
function by(e14) {
  e14.topLevelType = null, e14.nativeEvent = null, e14.targetInst = null, e14.ancestors.length = 0, 10 > vy.length && vy.push(e14);
}
function Sy(e14, t10, n10, r10) {
  if (vy.length) {
    var o10 = vy.pop();
    return o10.topLevelType = e14, o10.eventSystemFlags = r10, o10.nativeEvent = t10, o10.targetInst = n10, o10;
  }
  return { topLevelType: e14, eventSystemFlags: r10, nativeEvent: t10, targetInst: n10, ancestors: [] };
}
function Cy(e14) {
  var t10 = e14.targetInst, n10 = t10;
  do {
    if (!n10) {
      e14.ancestors.push(n10);
      break;
    }
    var r10 = n10;
    if (3 === r10.tag) r10 = r10.stateNode.containerInfo;
    else {
      for (; r10.return; ) r10 = r10.return;
      r10 = 3 !== r10.tag ? null : r10.stateNode.containerInfo;
    }
    if (!r10) break;
    5 !== (t10 = n10.tag) && 6 !== t10 || e14.ancestors.push(n10), n10 = Ov(r10);
  } while (n10);
  for (n10 = 0; n10 < e14.ancestors.length; n10++) {
    t10 = e14.ancestors[n10];
    var o10 = gy(e14.nativeEvent);
    r10 = e14.topLevelType;
    var a10 = e14.nativeEvent, i10 = e14.eventSystemFlags;
    0 === n10 && (i10 |= 64);
    for (var s10 = null, l10 = 0; l10 < Pf.length; l10++) {
      var c10 = Pf[l10];
      c10 && (c10 = c10.extractEvents(r10, t10, a10, o10, i10)) && (s10 = dy(s10, c10));
    }
    fy(s10);
  }
}
function xy(e14, t10, n10) {
  if (!n10.has(e14)) {
    switch (e14) {
      case "scroll":
        nv(t10, "scroll", true);
        break;
      case "focus":
      case "blur":
        nv(t10, "focus", true), nv(t10, "blur", true), n10.set("blur", null), n10.set("focus", null);
        break;
      case "cancel":
      case "close":
        yy(e14) && nv(t10, e14, true);
        break;
      case "invalid":
      case "submit":
      case "reset":
        break;
      default:
        -1 === oy.indexOf(e14) && tv(e14, t10);
    }
    n10.set(e14, null);
  }
}
var wy, Ty, Ey, Fy = false, My = [], ky = null, Py = null, Ny = null, Dy = /* @__PURE__ */ new Map(), Ly = /* @__PURE__ */ new Map(), Hy = [], Iy = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), _y = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Vy(e14, t10, n10, r10, o10) {
  return { blockedOn: e14, topLevelType: t10, eventSystemFlags: 32 | n10, nativeEvent: o10, container: r10 };
}
function Ry(e14, t10) {
  switch (e14) {
    case "focus":
    case "blur":
      ky = null;
      break;
    case "dragenter":
    case "dragleave":
      Py = null;
      break;
    case "mouseover":
    case "mouseout":
      Ny = null;
      break;
    case "pointerover":
    case "pointerout":
      Dy.delete(t10.pointerId);
      break;
    case "gotpointercapture":
    case "lostpointercapture":
      Ly.delete(t10.pointerId);
  }
}
function Ay(e14, t10, n10, r10, o10, a10) {
  return null === e14 || e14.nativeEvent !== a10 ? (e14 = Vy(t10, n10, r10, o10, a10), null !== t10 && (null !== (t10 = Bv(t10)) && Ty(t10)), e14) : (e14.eventSystemFlags |= r10, e14);
}
function Oy(e14) {
  var t10 = Ov(e14.target);
  if (null !== t10) {
    var n10 = sy(t10);
    if (null !== n10) {
      if (13 === (t10 = n10.tag)) {
        if (null !== (t10 = ly(n10))) return e14.blockedOn = t10, void pf.unstable_runWithPriority(e14.priority, function() {
          Ey(n10);
        });
      } else if (3 === t10 && n10.stateNode.hydrate) return void (e14.blockedOn = 3 === n10.tag ? n10.stateNode.containerInfo : null);
    }
  }
  e14.blockedOn = null;
}
function By(e14) {
  if (null !== e14.blockedOn) return false;
  var t10 = iv(e14.topLevelType, e14.eventSystemFlags, e14.container, e14.nativeEvent);
  if (null !== t10) {
    var n10 = Bv(t10);
    return null !== n10 && Ty(n10), e14.blockedOn = t10, false;
  }
  return true;
}
function zy(e14, t10, n10) {
  By(e14) && n10.delete(t10);
}
function $y() {
  for (Fy = false; 0 < My.length; ) {
    var e14 = My[0];
    if (null !== e14.blockedOn) {
      null !== (e14 = Bv(e14.blockedOn)) && wy(e14);
      break;
    }
    var t10 = iv(e14.topLevelType, e14.eventSystemFlags, e14.container, e14.nativeEvent);
    null !== t10 ? e14.blockedOn = t10 : My.shift();
  }
  null !== ky && By(ky) && (ky = null), null !== Py && By(Py) && (Py = null), null !== Ny && By(Ny) && (Ny = null), Dy.forEach(zy), Ly.forEach(zy);
}
function Wy(e14, t10) {
  e14.blockedOn === t10 && (e14.blockedOn = null, Fy || (Fy = true, pf.unstable_scheduleCallback(pf.unstable_NormalPriority, $y)));
}
function jy(e14) {
  function t10(t11) {
    return Wy(t11, e14);
  }
  if (0 < My.length) {
    Wy(My[0], e14);
    for (var n10 = 1; n10 < My.length; n10++) {
      var r10 = My[n10];
      r10.blockedOn === e14 && (r10.blockedOn = null);
    }
  }
  for (null !== ky && Wy(ky, e14), null !== Py && Wy(Py, e14), null !== Ny && Wy(Ny, e14), Dy.forEach(t10), Ly.forEach(t10), n10 = 0; n10 < Hy.length; n10++) (r10 = Hy[n10]).blockedOn === e14 && (r10.blockedOn = null);
  for (; 0 < Hy.length && null === (n10 = Hy[0]).blockedOn; ) Oy(n10), null === n10.blockedOn && Hy.shift();
}
var Zy = {}, Gy = /* @__PURE__ */ new Map(), Uy = /* @__PURE__ */ new Map(), qy = ["abort", "abort", ey, "animationEnd", ty, "animationIteration", ny, "animationStart", "canplay", "canPlay", "canplaythrough", "canPlayThrough", "durationchange", "durationChange", "emptied", "emptied", "encrypted", "encrypted", "ended", "ended", "error", "error", "gotpointercapture", "gotPointerCapture", "load", "load", "loadeddata", "loadedData", "loadedmetadata", "loadedMetadata", "loadstart", "loadStart", "lostpointercapture", "lostPointerCapture", "playing", "playing", "progress", "progress", "seeking", "seeking", "stalled", "stalled", "suspend", "suspend", "timeupdate", "timeUpdate", ry, "transitionEnd", "waiting", "waiting"];
function Yy(e14, t10) {
  for (var n10 = 0; n10 < e14.length; n10 += 2) {
    var r10 = e14[n10], o10 = e14[n10 + 1], a10 = "on" + (o10[0].toUpperCase() + o10.slice(1));
    a10 = { phasedRegistrationNames: { bubbled: a10, captured: a10 + "Capture" }, dependencies: [r10], eventPriority: t10 }, Uy.set(r10, t10), Gy.set(r10, a10), Zy[o10] = a10;
  }
}
Yy("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0), Yy("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1), Yy(qy, 2);
for (var Ky = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), Xy = 0; Xy < Ky.length; Xy++) Uy.set(Ky[Xy], 0);
var Jy = pf.unstable_UserBlockingPriority, Qy = pf.unstable_runWithPriority, ev = true;
function tv(e14, t10) {
  nv(t10, e14, false);
}
function nv(e14, t10, n10) {
  var r10 = Uy.get(t10);
  switch (void 0 === r10 ? 2 : r10) {
    case 0:
      r10 = rv.bind(null, t10, 1, e14);
      break;
    case 1:
      r10 = ov.bind(null, t10, 1, e14);
      break;
    default:
      r10 = av.bind(null, t10, 1, e14);
  }
  n10 ? e14.addEventListener(t10, r10, true) : e14.addEventListener(t10, r10, false);
}
function rv(e14, t10, n10, r10) {
  Zf || Wf();
  var o10 = av, a10 = Zf;
  Zf = true;
  try {
    $f(o10, e14, t10, n10, r10);
  } finally {
    (Zf = a10) || Uf();
  }
}
function ov(e14, t10, n10, r10) {
  Qy(Jy, av.bind(null, e14, t10, n10, r10));
}
function av(e14, t10, n10, r10) {
  if (ev) if (0 < My.length && -1 < Iy.indexOf(e14)) e14 = Vy(null, e14, t10, n10, r10), My.push(e14);
  else {
    var o10 = iv(e14, t10, n10, r10);
    if (null === o10) Ry(e14, r10);
    else if (-1 < Iy.indexOf(e14)) e14 = Vy(o10, e14, t10, n10, r10), My.push(e14);
    else if (!function(e15, t11, n11, r11, o11) {
      switch (t11) {
        case "focus":
          return ky = Ay(ky, e15, t11, n11, r11, o11), true;
        case "dragenter":
          return Py = Ay(Py, e15, t11, n11, r11, o11), true;
        case "mouseover":
          return Ny = Ay(Ny, e15, t11, n11, r11, o11), true;
        case "pointerover":
          var a10 = o11.pointerId;
          return Dy.set(a10, Ay(Dy.get(a10) || null, e15, t11, n11, r11, o11)), true;
        case "gotpointercapture":
          return a10 = o11.pointerId, Ly.set(a10, Ay(Ly.get(a10) || null, e15, t11, n11, r11, o11)), true;
      }
      return false;
    }(o10, e14, t10, n10, r10)) {
      Ry(e14, r10), e14 = Sy(e14, r10, null, t10);
      try {
        qf(Cy, e14);
      } finally {
        by(e14);
      }
    }
  }
}
function iv(e14, t10, n10, r10) {
  if (null !== (n10 = Ov(n10 = gy(r10)))) {
    var o10 = sy(n10);
    if (null === o10) n10 = null;
    else {
      var a10 = o10.tag;
      if (13 === a10) {
        if (null !== (n10 = ly(o10))) return n10;
        n10 = null;
      } else if (3 === a10) {
        if (o10.stateNode.hydrate) return 3 === o10.tag ? o10.stateNode.containerInfo : null;
        n10 = null;
      } else o10 !== n10 && (n10 = null);
    }
  }
  e14 = Sy(e14, r10, n10, t10);
  try {
    qf(Cy, e14);
  } finally {
    by(e14);
  }
  return null;
}
var sv = { animationIterationCount: true, borderImageOutset: true, borderImageSlice: true, borderImageWidth: true, boxFlex: true, boxFlexGroup: true, boxOrdinalGroup: true, columnCount: true, columns: true, flex: true, flexGrow: true, flexPositive: true, flexShrink: true, flexNegative: true, flexOrder: true, gridArea: true, gridRow: true, gridRowEnd: true, gridRowSpan: true, gridRowStart: true, gridColumn: true, gridColumnEnd: true, gridColumnSpan: true, gridColumnStart: true, fontWeight: true, lineClamp: true, lineHeight: true, opacity: true, order: true, orphans: true, tabSize: true, widows: true, zIndex: true, zoom: true, fillOpacity: true, floodOpacity: true, stopOpacity: true, strokeDasharray: true, strokeDashoffset: true, strokeMiterlimit: true, strokeOpacity: true, strokeWidth: true }, lv = ["Webkit", "ms", "Moz", "O"];
function cv(e14, t10, n10) {
  return null == t10 || "boolean" == typeof t10 || "" === t10 ? "" : n10 || "number" != typeof t10 || 0 === t10 || sv.hasOwnProperty(e14) && sv[e14] ? ("" + t10).trim() : t10 + "px";
}
function uv(e14, t10) {
  for (var n10 in e14 = e14.style, t10) if (t10.hasOwnProperty(n10)) {
    var r10 = 0 === n10.indexOf("--"), o10 = cv(n10, t10[n10], r10);
    "float" === n10 && (n10 = "cssFloat"), r10 ? e14.setProperty(n10, o10) : e14[n10] = o10;
  }
}
Object.keys(sv).forEach(function(e14) {
  lv.forEach(function(t10) {
    t10 = t10 + e14.charAt(0).toUpperCase() + e14.substring(1), sv[t10] = sv[e14];
  });
});
var dv = df({ menuitem: true }, { area: true, base: true, br: true, col: true, embed: true, hr: true, img: true, input: true, keygen: true, link: true, meta: true, param: true, source: true, track: true, wbr: true });
function pv(e14, t10) {
  if (t10) {
    if (dv[e14] && (null != t10.children || null != t10.dangerouslySetInnerHTML)) throw Error(mf(137, e14, ""));
    if (null != t10.dangerouslySetInnerHTML) {
      if (null != t10.children) throw Error(mf(60));
      if ("object" != typeof t10.dangerouslySetInnerHTML || !("__html" in t10.dangerouslySetInnerHTML)) throw Error(mf(61));
    }
    if (null != t10.style && "object" != typeof t10.style) throw Error(mf(62, ""));
  }
}
function mv(e14, t10) {
  if (-1 === e14.indexOf("-")) return "string" == typeof t10.is;
  switch (e14) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return false;
    default:
      return true;
  }
}
var hv = zg;
function fv(e14, t10) {
  var n10 = iy(e14 = 9 === e14.nodeType || 11 === e14.nodeType ? e14 : e14.ownerDocument);
  t10 = Lf[t10];
  for (var r10 = 0; r10 < t10.length; r10++) xy(t10[r10], e14, n10);
}
function gv() {
}
function yv(e14) {
  if (void 0 === (e14 = e14 || ("undefined" != typeof document ? document : void 0))) return null;
  try {
    return e14.activeElement || e14.body;
  } catch (t10) {
    return e14.body;
  }
}
function vv(e14) {
  for (; e14 && e14.firstChild; ) e14 = e14.firstChild;
  return e14;
}
function bv(e14, t10) {
  var n10 = vv(e14);
  e14 = 0;
  for (var r10; n10; ) {
    if (3 === n10.nodeType) {
      if (r10 = e14 + n10.textContent.length, e14 <= t10 && r10 >= t10) return { node: n10, offset: t10 - e14 };
      e14 = r10;
    }
    e: {
      for (; n10; ) {
        if (n10.nextSibling) {
          n10 = n10.nextSibling;
          break e;
        }
        n10 = n10.parentNode;
      }
      n10 = void 0;
    }
    n10 = vv(n10);
  }
}
function Sv(e14, t10) {
  return !(!e14 || !t10) && (e14 === t10 || (!e14 || 3 !== e14.nodeType) && (t10 && 3 === t10.nodeType ? Sv(e14, t10.parentNode) : "contains" in e14 ? e14.contains(t10) : !!e14.compareDocumentPosition && !!(16 & e14.compareDocumentPosition(t10))));
}
function Cv() {
  for (var e14 = window, t10 = yv(); t10 instanceof e14.HTMLIFrameElement; ) {
    try {
      var n10 = "string" == typeof t10.contentWindow.location.href;
    } catch (e15) {
      n10 = false;
    }
    if (!n10) break;
    t10 = yv((e14 = t10.contentWindow).document);
  }
  return t10;
}
function xv(e14) {
  var t10 = e14 && e14.nodeName && e14.nodeName.toLowerCase();
  return t10 && ("input" === t10 && ("text" === e14.type || "search" === e14.type || "tel" === e14.type || "url" === e14.type || "password" === e14.type) || "textarea" === t10 || "true" === e14.contentEditable);
}
var wv = "$", Tv = "/$", Ev = "$?", Fv = "$!", Mv = null, kv = null;
function Pv(e14, t10) {
  switch (e14) {
    case "button":
    case "input":
    case "select":
    case "textarea":
      return !!t10.autoFocus;
  }
  return false;
}
function Nv(e14, t10) {
  return "textarea" === e14 || "option" === e14 || "noscript" === e14 || "string" == typeof t10.children || "number" == typeof t10.children || "object" == typeof t10.dangerouslySetInnerHTML && null !== t10.dangerouslySetInnerHTML && null != t10.dangerouslySetInnerHTML.__html;
}
var Dv = "function" == typeof setTimeout ? setTimeout : void 0, Lv = "function" == typeof clearTimeout ? clearTimeout : void 0;
function Hv(e14) {
  for (; null != e14; e14 = e14.nextSibling) {
    var t10 = e14.nodeType;
    if (1 === t10 || 3 === t10) break;
  }
  return e14;
}
function Iv(e14) {
  e14 = e14.previousSibling;
  for (var t10 = 0; e14; ) {
    if (8 === e14.nodeType) {
      var n10 = e14.data;
      if (n10 === wv || n10 === Fv || n10 === Ev) {
        if (0 === t10) return e14;
        t10--;
      } else n10 === Tv && t10++;
    }
    e14 = e14.previousSibling;
  }
  return null;
}
var _v = Math.random().toString(36).slice(2), Vv = "__reactInternalInstance$" + _v, Rv = "__reactEventHandlers$" + _v, Av = "__reactContainere$" + _v;
function Ov(e14) {
  var t10 = e14[Vv];
  if (t10) return t10;
  for (var n10 = e14.parentNode; n10; ) {
    if (t10 = n10[Av] || n10[Vv]) {
      if (n10 = t10.alternate, null !== t10.child || null !== n10 && null !== n10.child) for (e14 = Iv(e14); null !== e14; ) {
        if (n10 = e14[Vv]) return n10;
        e14 = Iv(e14);
      }
      return t10;
    }
    n10 = (e14 = n10).parentNode;
  }
  return null;
}
function Bv(e14) {
  return !(e14 = e14[Vv] || e14[Av]) || 5 !== e14.tag && 6 !== e14.tag && 13 !== e14.tag && 3 !== e14.tag ? null : e14;
}
function zv(e14) {
  if (5 === e14.tag || 6 === e14.tag) return e14.stateNode;
  throw Error(mf(33));
}
function $v(e14) {
  return e14[Rv] || null;
}
function Wv(e14) {
  do {
    e14 = e14.return;
  } while (e14 && 5 !== e14.tag);
  return e14 || null;
}
function jv(e14, t10) {
  var n10 = e14.stateNode;
  if (!n10) return null;
  var r10 = Cf(n10);
  if (!r10) return null;
  n10 = r10[t10];
  e: switch (t10) {
    case "onClick":
    case "onClickCapture":
    case "onDoubleClick":
    case "onDoubleClickCapture":
    case "onMouseDown":
    case "onMouseDownCapture":
    case "onMouseMove":
    case "onMouseMoveCapture":
    case "onMouseUp":
    case "onMouseUpCapture":
    case "onMouseEnter":
      (r10 = !r10.disabled) || (r10 = !("button" === (e14 = e14.type) || "input" === e14 || "select" === e14 || "textarea" === e14)), e14 = !r10;
      break e;
    default:
      e14 = false;
  }
  if (e14) return null;
  if (n10 && "function" != typeof n10) throw Error(mf(231, t10, typeof n10));
  return n10;
}
function Zv(e14, t10, n10) {
  (t10 = jv(e14, n10.dispatchConfig.phasedRegistrationNames[t10])) && (n10._dispatchListeners = dy(n10._dispatchListeners, t10), n10._dispatchInstances = dy(n10._dispatchInstances, e14));
}
function Gv(e14) {
  if (e14 && e14.dispatchConfig.phasedRegistrationNames) {
    for (var t10 = e14._targetInst, n10 = []; t10; ) n10.push(t10), t10 = Wv(t10);
    for (t10 = n10.length; 0 < t10--; ) Zv(n10[t10], "captured", e14);
    for (t10 = 0; t10 < n10.length; t10++) Zv(n10[t10], "bubbled", e14);
  }
}
function Uv(e14, t10, n10) {
  e14 && n10 && n10.dispatchConfig.registrationName && (t10 = jv(e14, n10.dispatchConfig.registrationName)) && (n10._dispatchListeners = dy(n10._dispatchListeners, t10), n10._dispatchInstances = dy(n10._dispatchInstances, e14));
}
function qv(e14) {
  e14 && e14.dispatchConfig.registrationName && Uv(e14._targetInst, null, e14);
}
function Yv(e14) {
  py(e14, Gv);
}
var Kv = null, Xv = null, Jv = null;
function Qv() {
  if (Jv) return Jv;
  var e14, t10, n10 = Xv, r10 = n10.length, o10 = "value" in Kv ? Kv.value : Kv.textContent, a10 = o10.length;
  for (e14 = 0; e14 < r10 && n10[e14] === o10[e14]; e14++) ;
  var i10 = r10 - e14;
  for (t10 = 1; t10 <= i10 && n10[r10 - t10] === o10[a10 - t10]; t10++) ;
  return Jv = o10.slice(e14, 1 < t10 ? 1 - t10 : void 0);
}
function eb() {
  return true;
}
function tb() {
  return false;
}
function nb(e14, t10, n10, r10) {
  for (var o10 in this.dispatchConfig = e14, this._targetInst = t10, this.nativeEvent = n10, e14 = this.constructor.Interface) e14.hasOwnProperty(o10) && ((t10 = e14[o10]) ? this[o10] = t10(n10) : "target" === o10 ? this.target = r10 : this[o10] = n10[o10]);
  return this.isDefaultPrevented = (null != n10.defaultPrevented ? n10.defaultPrevented : false === n10.returnValue) ? eb : tb, this.isPropagationStopped = tb, this;
}
function rb(e14, t10, n10, r10) {
  if (this.eventPool.length) {
    var o10 = this.eventPool.pop();
    return this.call(o10, e14, t10, n10, r10), o10;
  }
  return new this(e14, t10, n10, r10);
}
function ob(e14) {
  if (!(e14 instanceof this)) throw Error(mf(279));
  e14.destructor(), 10 > this.eventPool.length && this.eventPool.push(e14);
}
function ab(e14) {
  e14.eventPool = [], e14.getPooled = rb, e14.release = ob;
}
df(nb.prototype, { preventDefault: function() {
  this.defaultPrevented = true;
  var e14 = this.nativeEvent;
  e14 && (e14.preventDefault ? e14.preventDefault() : "unknown" != typeof e14.returnValue && (e14.returnValue = false), this.isDefaultPrevented = eb);
}, stopPropagation: function() {
  var e14 = this.nativeEvent;
  e14 && (e14.stopPropagation ? e14.stopPropagation() : "unknown" != typeof e14.cancelBubble && (e14.cancelBubble = true), this.isPropagationStopped = eb);
}, persist: function() {
  this.isPersistent = eb;
}, isPersistent: tb, destructor: function() {
  var e14, t10 = this.constructor.Interface;
  for (e14 in t10) this[e14] = null;
  this.nativeEvent = this._targetInst = this.dispatchConfig = null, this.isPropagationStopped = this.isDefaultPrevented = tb, this._dispatchInstances = this._dispatchListeners = null;
} }), nb.Interface = { type: null, target: null, currentTarget: function() {
  return null;
}, eventPhase: null, bubbles: null, cancelable: null, timeStamp: function(e14) {
  return e14.timeStamp || Date.now();
}, defaultPrevented: null, isTrusted: null }, nb.extend = function(e14) {
  function t10() {
  }
  function n10() {
    return r10.apply(this, arguments);
  }
  var r10 = this;
  t10.prototype = r10.prototype;
  var o10 = new t10();
  return df(o10, n10.prototype), n10.prototype = o10, n10.prototype.constructor = n10, n10.Interface = df({}, r10.Interface, e14), n10.extend = r10.extend, ab(n10), n10;
}, ab(nb);
var ib = nb.extend({ data: null }), sb = nb.extend({ data: null }), lb = [9, 13, 27, 32], cb = If && "CompositionEvent" in window, ub = null;
If && "documentMode" in document && (ub = document.documentMode);
var db = If && "TextEvent" in window && !ub, pb = If && (!cb || ub && 8 < ub && 11 >= ub), mb = String.fromCharCode(32), hb = { beforeInput: { phasedRegistrationNames: { bubbled: "onBeforeInput", captured: "onBeforeInputCapture" }, dependencies: ["compositionend", "keypress", "textInput", "paste"] }, compositionEnd: { phasedRegistrationNames: { bubbled: "onCompositionEnd", captured: "onCompositionEndCapture" }, dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ") }, compositionStart: { phasedRegistrationNames: { bubbled: "onCompositionStart", captured: "onCompositionStartCapture" }, dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ") }, compositionUpdate: { phasedRegistrationNames: { bubbled: "onCompositionUpdate", captured: "onCompositionUpdateCapture" }, dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ") } }, fb = false;
function gb(e14, t10) {
  switch (e14) {
    case "keyup":
      return -1 !== lb.indexOf(t10.keyCode);
    case "keydown":
      return 229 !== t10.keyCode;
    case "keypress":
    case "mousedown":
    case "blur":
      return true;
    default:
      return false;
  }
}
function yb(e14) {
  return "object" == typeof (e14 = e14.detail) && "data" in e14 ? e14.data : null;
}
var vb = false;
var bb = { eventTypes: hb, extractEvents: function(e14, t10, n10, r10) {
  var o10;
  if (cb) e: {
    switch (e14) {
      case "compositionstart":
        var a10 = hb.compositionStart;
        break e;
      case "compositionend":
        a10 = hb.compositionEnd;
        break e;
      case "compositionupdate":
        a10 = hb.compositionUpdate;
        break e;
    }
    a10 = void 0;
  }
  else vb ? gb(e14, n10) && (a10 = hb.compositionEnd) : "keydown" === e14 && 229 === n10.keyCode && (a10 = hb.compositionStart);
  return a10 ? (pb && "ko" !== n10.locale && (vb || a10 !== hb.compositionStart ? a10 === hb.compositionEnd && vb && (o10 = Qv()) : (Xv = "value" in (Kv = r10) ? Kv.value : Kv.textContent, vb = true)), a10 = ib.getPooled(a10, t10, n10, r10), o10 ? a10.data = o10 : null !== (o10 = yb(n10)) && (a10.data = o10), Yv(a10), o10 = a10) : o10 = null, (e14 = db ? function(e15, t11) {
    switch (e15) {
      case "compositionend":
        return yb(t11);
      case "keypress":
        return 32 !== t11.which ? null : (fb = true, mb);
      case "textInput":
        return (e15 = t11.data) === mb && fb ? null : e15;
      default:
        return null;
    }
  }(e14, n10) : function(e15, t11) {
    if (vb) return "compositionend" === e15 || !cb && gb(e15, t11) ? (e15 = Qv(), Jv = Xv = Kv = null, vb = false, e15) : null;
    switch (e15) {
      case "paste":
      default:
        return null;
      case "keypress":
        if (!(t11.ctrlKey || t11.altKey || t11.metaKey) || t11.ctrlKey && t11.altKey) {
          if (t11.char && 1 < t11.char.length) return t11.char;
          if (t11.which) return String.fromCharCode(t11.which);
        }
        return null;
      case "compositionend":
        return pb && "ko" !== t11.locale ? null : t11.data;
    }
  }(e14, n10)) ? ((t10 = sb.getPooled(hb.beforeInput, t10, n10, r10)).data = e14, Yv(t10)) : t10 = null, null === o10 ? t10 : null === t10 ? o10 : [o10, t10];
} }, Sb = { color: true, date: true, datetime: true, "datetime-local": true, email: true, month: true, number: true, password: true, range: true, search: true, tel: true, text: true, time: true, url: true, week: true };
function Cb(e14) {
  var t10 = e14 && e14.nodeName && e14.nodeName.toLowerCase();
  return "input" === t10 ? !!Sb[e14.type] : "textarea" === t10;
}
var xb = { change: { phasedRegistrationNames: { bubbled: "onChange", captured: "onChangeCapture" }, dependencies: "blur change click focus input keydown keyup selectionchange".split(" ") } };
function wb(e14, t10, n10) {
  return (e14 = nb.getPooled(xb.change, e14, t10, n10)).type = "change", Of(n10), Yv(e14), e14;
}
var Tb = null, Eb = null;
function Fb(e14) {
  fy(e14);
}
function Mb(e14) {
  if (kg(zv(e14))) return e14;
}
function kb(e14, t10) {
  if ("change" === e14) return t10;
}
var Pb = false;
function Nb() {
  Tb && (Tb.detachEvent("onpropertychange", Db), Eb = Tb = null);
}
function Db(e14) {
  if ("value" === e14.propertyName && Mb(Eb)) if (e14 = wb(Eb, e14, gy(e14)), Zf) fy(e14);
  else {
    Zf = true;
    try {
      zf(Fb, e14);
    } finally {
      Zf = false, Uf();
    }
  }
}
function Lb(e14, t10, n10) {
  "focus" === e14 ? (Nb(), Eb = n10, (Tb = t10).attachEvent("onpropertychange", Db)) : "blur" === e14 && Nb();
}
function Hb(e14) {
  if ("selectionchange" === e14 || "keyup" === e14 || "keydown" === e14) return Mb(Eb);
}
function Ib(e14, t10) {
  if ("click" === e14) return Mb(t10);
}
function _b(e14, t10) {
  if ("input" === e14 || "change" === e14) return Mb(t10);
}
If && (Pb = yy("input") && (!document.documentMode || 9 < document.documentMode));
var Vb = { eventTypes: xb, _isInputEventSupported: Pb, extractEvents: function(e14, t10, n10, r10) {
  var o10 = t10 ? zv(t10) : window, a10 = o10.nodeName && o10.nodeName.toLowerCase();
  if ("select" === a10 || "input" === a10 && "file" === o10.type) var i10 = kb;
  else if (Cb(o10)) if (Pb) i10 = _b;
  else {
    i10 = Hb;
    var s10 = Lb;
  }
  else (a10 = o10.nodeName) && "input" === a10.toLowerCase() && ("checkbox" === o10.type || "radio" === o10.type) && (i10 = Ib);
  if (i10 && (i10 = i10(e14, t10))) return wb(i10, n10, r10);
  s10 && s10(e14, o10, t10), "blur" === e14 && (e14 = o10._wrapperState) && e14.controlled && "number" === o10.type && Ig(o10, "number", o10.value);
} }, Rb = nb.extend({ view: null, detail: null }), Ab = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
function Ob(e14) {
  var t10 = this.nativeEvent;
  return t10.getModifierState ? t10.getModifierState(e14) : !!(e14 = Ab[e14]) && !!t10[e14];
}
function Bb() {
  return Ob;
}
var zb = 0, $b = 0, Wb = false, jb = false, Zb = Rb.extend({ screenX: null, screenY: null, clientX: null, clientY: null, pageX: null, pageY: null, ctrlKey: null, shiftKey: null, altKey: null, metaKey: null, getModifierState: Bb, button: null, buttons: null, relatedTarget: function(e14) {
  return e14.relatedTarget || (e14.fromElement === e14.srcElement ? e14.toElement : e14.fromElement);
}, movementX: function(e14) {
  if ("movementX" in e14) return e14.movementX;
  var t10 = zb;
  return zb = e14.screenX, Wb ? "mousemove" === e14.type ? e14.screenX - t10 : 0 : (Wb = true, 0);
}, movementY: function(e14) {
  if ("movementY" in e14) return e14.movementY;
  var t10 = $b;
  return $b = e14.screenY, jb ? "mousemove" === e14.type ? e14.screenY - t10 : 0 : (jb = true, 0);
} }), Gb = Zb.extend({ pointerId: null, width: null, height: null, pressure: null, tangentialPressure: null, tiltX: null, tiltY: null, twist: null, pointerType: null, isPrimary: null }), Ub = { mouseEnter: { registrationName: "onMouseEnter", dependencies: ["mouseout", "mouseover"] }, mouseLeave: { registrationName: "onMouseLeave", dependencies: ["mouseout", "mouseover"] }, pointerEnter: { registrationName: "onPointerEnter", dependencies: ["pointerout", "pointerover"] }, pointerLeave: { registrationName: "onPointerLeave", dependencies: ["pointerout", "pointerover"] } }, qb = { eventTypes: Ub, extractEvents: function(e14, t10, n10, r10, o10) {
  var a10 = "mouseover" === e14 || "pointerover" === e14, i10 = "mouseout" === e14 || "pointerout" === e14;
  if (a10 && 0 == (32 & o10) && (n10.relatedTarget || n10.fromElement) || !i10 && !a10) return null;
  (a10 = r10.window === r10 ? r10 : (a10 = r10.ownerDocument) ? a10.defaultView || a10.parentWindow : window, i10) ? (i10 = t10, null !== (t10 = (t10 = n10.relatedTarget || n10.toElement) ? Ov(t10) : null) && (t10 !== sy(t10) || 5 !== t10.tag && 6 !== t10.tag) && (t10 = null)) : i10 = null;
  if (i10 === t10) return null;
  if ("mouseout" === e14 || "mouseover" === e14) {
    var s10 = Zb;
    var l10 = Ub.mouseLeave;
    var c10 = Ub.mouseEnter;
    var u10 = "mouse";
  } else "pointerout" !== e14 && "pointerover" !== e14 || (s10 = Gb, l10 = Ub.pointerLeave, c10 = Ub.pointerEnter, u10 = "pointer");
  if (e14 = null == i10 ? a10 : zv(i10), a10 = null == t10 ? a10 : zv(t10), (l10 = s10.getPooled(l10, i10, n10, r10)).type = u10 + "leave", l10.target = e14, l10.relatedTarget = a10, (n10 = s10.getPooled(c10, t10, n10, r10)).type = u10 + "enter", n10.target = a10, n10.relatedTarget = e14, u10 = t10, (r10 = i10) && u10) e: {
    for (c10 = u10, i10 = 0, e14 = s10 = r10; e14; e14 = Wv(e14)) i10++;
    for (e14 = 0, t10 = c10; t10; t10 = Wv(t10)) e14++;
    for (; 0 < i10 - e14; ) s10 = Wv(s10), i10--;
    for (; 0 < e14 - i10; ) c10 = Wv(c10), e14--;
    for (; i10--; ) {
      if (s10 === c10 || s10 === c10.alternate) break e;
      s10 = Wv(s10), c10 = Wv(c10);
    }
    s10 = null;
  }
  else s10 = null;
  for (c10 = s10, s10 = []; r10 && r10 !== c10 && (null === (i10 = r10.alternate) || i10 !== c10); ) s10.push(r10), r10 = Wv(r10);
  for (r10 = []; u10 && u10 !== c10 && (null === (i10 = u10.alternate) || i10 !== c10); ) r10.push(u10), u10 = Wv(u10);
  for (u10 = 0; u10 < s10.length; u10++) Uv(s10[u10], "bubbled", l10);
  for (u10 = r10.length; 0 < u10--; ) Uv(r10[u10], "captured", n10);
  return 0 == (64 & o10) ? [l10] : [l10, n10];
} };
var Yb = "function" == typeof Object.is ? Object.is : function(e14, t10) {
  return e14 === t10 && (0 !== e14 || 1 / e14 == 1 / t10) || e14 != e14 && t10 != t10;
}, Kb = Object.prototype.hasOwnProperty;
function Xb(e14, t10) {
  if (Yb(e14, t10)) return true;
  if ("object" != typeof e14 || null === e14 || "object" != typeof t10 || null === t10) return false;
  var n10 = Object.keys(e14), r10 = Object.keys(t10);
  if (n10.length !== r10.length) return false;
  for (r10 = 0; r10 < n10.length; r10++) if (!Kb.call(t10, n10[r10]) || !Yb(e14[n10[r10]], t10[n10[r10]])) return false;
  return true;
}
var Jb = If && "documentMode" in document && 11 >= document.documentMode, Qb = { select: { phasedRegistrationNames: { bubbled: "onSelect", captured: "onSelectCapture" }, dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ") } }, eS = null, tS = null, nS = null, rS = false;
function oS(e14, t10) {
  var n10 = t10.window === t10 ? t10.document : 9 === t10.nodeType ? t10 : t10.ownerDocument;
  return rS || null == eS || eS !== yv(n10) ? null : ("selectionStart" in (n10 = eS) && xv(n10) ? n10 = { start: n10.selectionStart, end: n10.selectionEnd } : n10 = { anchorNode: (n10 = (n10.ownerDocument && n10.ownerDocument.defaultView || window).getSelection()).anchorNode, anchorOffset: n10.anchorOffset, focusNode: n10.focusNode, focusOffset: n10.focusOffset }, nS && Xb(nS, n10) ? null : (nS = n10, (e14 = nb.getPooled(Qb.select, tS, e14, t10)).type = "select", e14.target = eS, Yv(e14), e14));
}
var aS = { eventTypes: Qb, extractEvents: function(e14, t10, n10, r10, o10, a10) {
  if (!(a10 = !(o10 = a10 || (r10.window === r10 ? r10.document : 9 === r10.nodeType ? r10 : r10.ownerDocument)))) {
    e: {
      o10 = iy(o10), a10 = Lf.onSelect;
      for (var i10 = 0; i10 < a10.length; i10++) if (!o10.has(a10[i10])) {
        o10 = false;
        break e;
      }
      o10 = true;
    }
    a10 = !o10;
  }
  if (a10) return null;
  switch (o10 = t10 ? zv(t10) : window, e14) {
    case "focus":
      (Cb(o10) || "true" === o10.contentEditable) && (eS = o10, tS = t10, nS = null);
      break;
    case "blur":
      nS = tS = eS = null;
      break;
    case "mousedown":
      rS = true;
      break;
    case "contextmenu":
    case "mouseup":
    case "dragend":
      return rS = false, oS(n10, r10);
    case "selectionchange":
      if (Jb) break;
    case "keydown":
    case "keyup":
      return oS(n10, r10);
  }
  return null;
} }, iS = nb.extend({ animationName: null, elapsedTime: null, pseudoElement: null }), sS = nb.extend({ clipboardData: function(e14) {
  return "clipboardData" in e14 ? e14.clipboardData : window.clipboardData;
} }), lS = Rb.extend({ relatedTarget: null });
function cS(e14) {
  var t10 = e14.keyCode;
  return "charCode" in e14 ? 0 === (e14 = e14.charCode) && 13 === t10 && (e14 = 13) : e14 = t10, 10 === e14 && (e14 = 13), 32 <= e14 || 13 === e14 ? e14 : 0;
}
var uS = { Esc: "Escape", Spacebar: " ", Left: "ArrowLeft", Up: "ArrowUp", Right: "ArrowRight", Down: "ArrowDown", Del: "Delete", Win: "OS", Menu: "ContextMenu", Apps: "ContextMenu", Scroll: "ScrollLock", MozPrintableKey: "Unidentified" }, dS = { 8: "Backspace", 9: "Tab", 12: "Clear", 13: "Enter", 16: "Shift", 17: "Control", 18: "Alt", 19: "Pause", 20: "CapsLock", 27: "Escape", 32: " ", 33: "PageUp", 34: "PageDown", 35: "End", 36: "Home", 37: "ArrowLeft", 38: "ArrowUp", 39: "ArrowRight", 40: "ArrowDown", 45: "Insert", 46: "Delete", 112: "F1", 113: "F2", 114: "F3", 115: "F4", 116: "F5", 117: "F6", 118: "F7", 119: "F8", 120: "F9", 121: "F10", 122: "F11", 123: "F12", 144: "NumLock", 145: "ScrollLock", 224: "Meta" }, pS = Rb.extend({ key: function(e14) {
  if (e14.key) {
    var t10 = uS[e14.key] || e14.key;
    if ("Unidentified" !== t10) return t10;
  }
  return "keypress" === e14.type ? 13 === (e14 = cS(e14)) ? "Enter" : String.fromCharCode(e14) : "keydown" === e14.type || "keyup" === e14.type ? dS[e14.keyCode] || "Unidentified" : "";
}, location: null, ctrlKey: null, shiftKey: null, altKey: null, metaKey: null, repeat: null, locale: null, getModifierState: Bb, charCode: function(e14) {
  return "keypress" === e14.type ? cS(e14) : 0;
}, keyCode: function(e14) {
  return "keydown" === e14.type || "keyup" === e14.type ? e14.keyCode : 0;
}, which: function(e14) {
  return "keypress" === e14.type ? cS(e14) : "keydown" === e14.type || "keyup" === e14.type ? e14.keyCode : 0;
} }), mS = Zb.extend({ dataTransfer: null }), hS = Rb.extend({ touches: null, targetTouches: null, changedTouches: null, altKey: null, metaKey: null, ctrlKey: null, shiftKey: null, getModifierState: Bb }), fS = nb.extend({ propertyName: null, elapsedTime: null, pseudoElement: null }), gS = Zb.extend({ deltaX: function(e14) {
  return "deltaX" in e14 ? e14.deltaX : "wheelDeltaX" in e14 ? -e14.wheelDeltaX : 0;
}, deltaY: function(e14) {
  return "deltaY" in e14 ? e14.deltaY : "wheelDeltaY" in e14 ? -e14.wheelDeltaY : "wheelDelta" in e14 ? -e14.wheelDelta : 0;
}, deltaZ: null, deltaMode: null }), yS = { eventTypes: Zy, extractEvents: function(e14, t10, n10, r10) {
  var o10 = Gy.get(e14);
  if (!o10) return null;
  switch (e14) {
    case "keypress":
      if (0 === cS(n10)) return null;
    case "keydown":
    case "keyup":
      e14 = pS;
      break;
    case "blur":
    case "focus":
      e14 = lS;
      break;
    case "click":
      if (2 === n10.button) return null;
    case "auxclick":
    case "dblclick":
    case "mousedown":
    case "mousemove":
    case "mouseup":
    case "mouseout":
    case "mouseover":
    case "contextmenu":
      e14 = Zb;
      break;
    case "drag":
    case "dragend":
    case "dragenter":
    case "dragexit":
    case "dragleave":
    case "dragover":
    case "dragstart":
    case "drop":
      e14 = mS;
      break;
    case "touchcancel":
    case "touchend":
    case "touchmove":
    case "touchstart":
      e14 = hS;
      break;
    case ey:
    case ty:
    case ny:
      e14 = iS;
      break;
    case ry:
      e14 = fS;
      break;
    case "scroll":
      e14 = Rb;
      break;
    case "wheel":
      e14 = gS;
      break;
    case "copy":
    case "cut":
    case "paste":
      e14 = sS;
      break;
    case "gotpointercapture":
    case "lostpointercapture":
    case "pointercancel":
    case "pointerdown":
    case "pointermove":
    case "pointerout":
    case "pointerover":
    case "pointerup":
      e14 = Gb;
      break;
    default:
      e14 = nb;
  }
  return Yv(t10 = e14.getPooled(o10, t10, n10, r10)), t10;
} };
if (Ef) throw Error(mf(101));
Ef = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" ")), Mf(), Cf = $v, xf = Bv, wf = zv, Hf({ SimpleEventPlugin: yS, EnterLeaveEventPlugin: qb, ChangeEventPlugin: Vb, SelectEventPlugin: aS, BeforeInputEventPlugin: bb });
var vS = [], bS = -1;
function SS(e14) {
  0 > bS || (e14.current = vS[bS], vS[bS] = null, bS--);
}
function CS(e14, t10) {
  bS++, vS[bS] = e14.current, e14.current = t10;
}
var xS = {}, wS = { current: xS }, TS = { current: false }, ES = xS;
function FS(e14, t10) {
  var n10 = e14.type.contextTypes;
  if (!n10) return xS;
  var r10 = e14.stateNode;
  if (r10 && r10.__reactInternalMemoizedUnmaskedChildContext === t10) return r10.__reactInternalMemoizedMaskedChildContext;
  var o10, a10 = {};
  for (o10 in n10) a10[o10] = t10[o10];
  return r10 && ((e14 = e14.stateNode).__reactInternalMemoizedUnmaskedChildContext = t10, e14.__reactInternalMemoizedMaskedChildContext = a10), a10;
}
function MS(e14) {
  return null != (e14 = e14.childContextTypes);
}
function kS() {
  SS(TS), SS(wS);
}
function PS(e14, t10, n10) {
  if (wS.current !== xS) throw Error(mf(168));
  CS(wS, t10), CS(TS, n10);
}
function NS(e14, t10, n10) {
  var r10 = e14.stateNode;
  if (e14 = t10.childContextTypes, "function" != typeof r10.getChildContext) return n10;
  for (var o10 in r10 = r10.getChildContext()) if (!(o10 in e14)) throw Error(mf(108, wg(t10) || "Unknown", o10));
  return df({}, n10, {}, r10);
}
function DS(e14) {
  return e14 = (e14 = e14.stateNode) && e14.__reactInternalMemoizedMergedChildContext || xS, ES = wS.current, CS(wS, e14), CS(TS, TS.current), true;
}
function LS(e14, t10, n10) {
  var r10 = e14.stateNode;
  if (!r10) throw Error(mf(169));
  n10 ? (e14 = NS(e14, t10, ES), r10.__reactInternalMemoizedMergedChildContext = e14, SS(TS), SS(wS), CS(wS, e14)) : SS(TS), CS(TS, n10);
}
var HS = pf.unstable_runWithPriority, IS = pf.unstable_scheduleCallback, _S = pf.unstable_cancelCallback, VS = pf.unstable_requestPaint, RS = pf.unstable_now, AS = pf.unstable_getCurrentPriorityLevel, OS = pf.unstable_ImmediatePriority, BS = pf.unstable_UserBlockingPriority, zS = pf.unstable_NormalPriority, $S = pf.unstable_LowPriority, WS = pf.unstable_IdlePriority, jS = {}, ZS = pf.unstable_shouldYield, GS = void 0 !== VS ? VS : function() {
}, US = null, qS = null, YS = false, KS = RS(), XS = 1e4 > KS ? RS : function() {
  return RS() - KS;
};
function JS() {
  switch (AS()) {
    case OS:
      return 99;
    case BS:
      return 98;
    case zS:
      return 97;
    case $S:
      return 96;
    case WS:
      return 95;
    default:
      throw Error(mf(332));
  }
}
function QS(e14) {
  switch (e14) {
    case 99:
      return OS;
    case 98:
      return BS;
    case 97:
      return zS;
    case 96:
      return $S;
    case 95:
      return WS;
    default:
      throw Error(mf(332));
  }
}
function eC(e14, t10) {
  return e14 = QS(e14), HS(e14, t10);
}
function tC(e14, t10, n10) {
  return e14 = QS(e14), IS(e14, t10, n10);
}
function nC(e14) {
  return null === US ? (US = [e14], qS = IS(OS, oC)) : US.push(e14), jS;
}
function rC() {
  if (null !== qS) {
    var e14 = qS;
    qS = null, _S(e14);
  }
  oC();
}
function oC() {
  if (!YS && null !== US) {
    YS = true;
    var e14 = 0;
    try {
      var t10 = US;
      eC(99, function() {
        for (; e14 < t10.length; e14++) {
          var n10 = t10[e14];
          do {
            n10 = n10(true);
          } while (null !== n10);
        }
      }), US = null;
    } catch (t11) {
      throw null !== US && (US = US.slice(e14 + 1)), IS(OS, rC), t11;
    } finally {
      YS = false;
    }
  }
}
function aC(e14, t10, n10) {
  return 1073741821 - (1 + ((1073741821 - e14 + t10 / 10) / (n10 /= 10) | 0)) * n10;
}
function iC(e14, t10) {
  if (e14 && e14.defaultProps) for (var n10 in t10 = df({}, t10), e14 = e14.defaultProps) void 0 === t10[n10] && (t10[n10] = e14[n10]);
  return t10;
}
var sC = { current: null }, lC = null, cC = null, uC = null;
function dC() {
  uC = cC = lC = null;
}
function pC(e14) {
  var t10 = sC.current;
  SS(sC), e14.type._context._currentValue = t10;
}
function mC(e14, t10) {
  for (; null !== e14; ) {
    var n10 = e14.alternate;
    if (e14.childExpirationTime < t10) e14.childExpirationTime = t10, null !== n10 && n10.childExpirationTime < t10 && (n10.childExpirationTime = t10);
    else {
      if (!(null !== n10 && n10.childExpirationTime < t10)) break;
      n10.childExpirationTime = t10;
    }
    e14 = e14.return;
  }
}
function hC(e14, t10) {
  lC = e14, uC = cC = null, null !== (e14 = e14.dependencies) && null !== e14.firstContext && (e14.expirationTime >= t10 && (zx = true), e14.firstContext = null);
}
function fC(e14, t10) {
  if (uC !== e14 && false !== t10 && 0 !== t10) if ("number" == typeof t10 && 1073741823 !== t10 || (uC = e14, t10 = 1073741823), t10 = { context: e14, observedBits: t10, next: null }, null === cC) {
    if (null === lC) throw Error(mf(308));
    cC = t10, lC.dependencies = { expirationTime: 0, firstContext: t10, responders: null };
  } else cC = cC.next = t10;
  return e14._currentValue;
}
var gC = false;
function yC(e14) {
  e14.updateQueue = { baseState: e14.memoizedState, baseQueue: null, shared: { pending: null }, effects: null };
}
function vC(e14, t10) {
  e14 = e14.updateQueue, t10.updateQueue === e14 && (t10.updateQueue = { baseState: e14.baseState, baseQueue: e14.baseQueue, shared: e14.shared, effects: e14.effects });
}
function bC(e14, t10) {
  return (e14 = { expirationTime: e14, suspenseConfig: t10, tag: 0, payload: null, callback: null, next: null }).next = e14;
}
function SC(e14, t10) {
  if (null !== (e14 = e14.updateQueue)) {
    var n10 = (e14 = e14.shared).pending;
    null === n10 ? t10.next = t10 : (t10.next = n10.next, n10.next = t10), e14.pending = t10;
  }
}
function CC(e14, t10) {
  var n10 = e14.alternate;
  null !== n10 && vC(n10, e14), null === (n10 = (e14 = e14.updateQueue).baseQueue) ? (e14.baseQueue = t10.next = t10, t10.next = t10) : (t10.next = n10.next, n10.next = t10);
}
function xC(e14, t10, n10, r10) {
  var o10 = e14.updateQueue;
  gC = false;
  var a10 = o10.baseQueue, i10 = o10.shared.pending;
  if (null !== i10) {
    if (null !== a10) {
      var s10 = a10.next;
      a10.next = i10.next, i10.next = s10;
    }
    a10 = i10, o10.shared.pending = null, null !== (s10 = e14.alternate) && (null !== (s10 = s10.updateQueue) && (s10.baseQueue = i10));
  }
  if (null !== a10) {
    s10 = a10.next;
    var l10 = o10.baseState, c10 = 0, u10 = null, d10 = null, p10 = null;
    if (null !== s10) {
      var m10 = s10;
      for (; ; ) {
        if ((i10 = m10.expirationTime) < r10) {
          var h10 = { expirationTime: m10.expirationTime, suspenseConfig: m10.suspenseConfig, tag: m10.tag, payload: m10.payload, callback: m10.callback, next: null };
          null === p10 ? (d10 = p10 = h10, u10 = l10) : p10 = p10.next = h10, i10 > c10 && (c10 = i10);
        } else {
          null !== p10 && (p10 = p10.next = { expirationTime: 1073741823, suspenseConfig: m10.suspenseConfig, tag: m10.tag, payload: m10.payload, callback: m10.callback, next: null }), FT(i10, m10.suspenseConfig);
          e: {
            var f10 = e14, g10 = m10;
            switch (i10 = t10, h10 = n10, g10.tag) {
              case 1:
                if ("function" == typeof (f10 = g10.payload)) {
                  l10 = f10.call(h10, l10, i10);
                  break e;
                }
                l10 = f10;
                break e;
              case 3:
                f10.effectTag = -4097 & f10.effectTag | 64;
              case 0:
                if (null == (i10 = "function" == typeof (f10 = g10.payload) ? f10.call(h10, l10, i10) : f10)) break e;
                l10 = df({}, l10, i10);
                break e;
              case 2:
                gC = true;
            }
          }
          null !== m10.callback && (e14.effectTag |= 32, null === (i10 = o10.effects) ? o10.effects = [m10] : i10.push(m10));
        }
        if (null === (m10 = m10.next) || m10 === s10) {
          if (null === (i10 = o10.shared.pending)) break;
          m10 = a10.next = i10.next, i10.next = s10, o10.baseQueue = a10 = i10, o10.shared.pending = null;
        }
      }
    }
    null === p10 ? u10 = l10 : p10.next = d10, o10.baseState = u10, o10.baseQueue = p10, MT(c10), e14.expirationTime = c10, e14.memoizedState = l10;
  }
}
function wC(e14, t10, n10) {
  if (e14 = t10.effects, t10.effects = null, null !== e14) for (t10 = 0; t10 < e14.length; t10++) {
    var r10 = e14[t10], o10 = r10.callback;
    if (null !== o10) {
      if (r10.callback = null, r10 = o10, o10 = n10, "function" != typeof r10) throw Error(mf(191, r10));
      r10.call(o10);
    }
  }
}
var TC = rg.ReactCurrentBatchConfig, EC = new uf.Component().refs;
function FC(e14, t10, n10, r10) {
  n10 = null == (n10 = n10(r10, t10 = e14.memoizedState)) ? t10 : df({}, t10, n10), e14.memoizedState = n10, 0 === e14.expirationTime && (e14.updateQueue.baseState = n10);
}
var MC = { isMounted: function(e14) {
  return !!(e14 = e14._reactInternalFiber) && sy(e14) === e14;
}, enqueueSetState: function(e14, t10, n10) {
  e14 = e14._reactInternalFiber;
  var r10 = mT(), o10 = TC.suspense;
  (o10 = bC(r10 = hT(r10, e14, o10), o10)).payload = t10, null != n10 && (o10.callback = n10), SC(e14, o10), fT(e14, r10);
}, enqueueReplaceState: function(e14, t10, n10) {
  e14 = e14._reactInternalFiber;
  var r10 = mT(), o10 = TC.suspense;
  (o10 = bC(r10 = hT(r10, e14, o10), o10)).tag = 1, o10.payload = t10, null != n10 && (o10.callback = n10), SC(e14, o10), fT(e14, r10);
}, enqueueForceUpdate: function(e14, t10) {
  e14 = e14._reactInternalFiber;
  var n10 = mT(), r10 = TC.suspense;
  (r10 = bC(n10 = hT(n10, e14, r10), r10)).tag = 2, null != t10 && (r10.callback = t10), SC(e14, r10), fT(e14, n10);
} };
function kC(e14, t10, n10, r10, o10, a10, i10) {
  return "function" == typeof (e14 = e14.stateNode).shouldComponentUpdate ? e14.shouldComponentUpdate(r10, a10, i10) : !t10.prototype || !t10.prototype.isPureReactComponent || (!Xb(n10, r10) || !Xb(o10, a10));
}
function PC(e14, t10, n10) {
  var r10 = false, o10 = xS;
  var a10 = t10.contextType;
  return "object" == typeof a10 && null !== a10 ? a10 = fC(a10) : (o10 = MS(t10) ? ES : wS.current, a10 = (r10 = null != (r10 = t10.contextTypes)) ? FS(e14, o10) : xS), t10 = new t10(n10, a10), e14.memoizedState = null !== t10.state && void 0 !== t10.state ? t10.state : null, t10.updater = MC, e14.stateNode = t10, t10._reactInternalFiber = e14, r10 && ((e14 = e14.stateNode).__reactInternalMemoizedUnmaskedChildContext = o10, e14.__reactInternalMemoizedMaskedChildContext = a10), t10;
}
function NC(e14, t10, n10, r10) {
  e14 = t10.state, "function" == typeof t10.componentWillReceiveProps && t10.componentWillReceiveProps(n10, r10), "function" == typeof t10.UNSAFE_componentWillReceiveProps && t10.UNSAFE_componentWillReceiveProps(n10, r10), t10.state !== e14 && MC.enqueueReplaceState(t10, t10.state, null);
}
function DC(e14, t10, n10, r10) {
  var o10 = e14.stateNode;
  o10.props = n10, o10.state = e14.memoizedState, o10.refs = EC, yC(e14);
  var a10 = t10.contextType;
  "object" == typeof a10 && null !== a10 ? o10.context = fC(a10) : (a10 = MS(t10) ? ES : wS.current, o10.context = FS(e14, a10)), xC(e14, n10, o10, r10), o10.state = e14.memoizedState, "function" == typeof (a10 = t10.getDerivedStateFromProps) && (FC(e14, t10, a10, n10), o10.state = e14.memoizedState), "function" == typeof t10.getDerivedStateFromProps || "function" == typeof o10.getSnapshotBeforeUpdate || "function" != typeof o10.UNSAFE_componentWillMount && "function" != typeof o10.componentWillMount || (t10 = o10.state, "function" == typeof o10.componentWillMount && o10.componentWillMount(), "function" == typeof o10.UNSAFE_componentWillMount && o10.UNSAFE_componentWillMount(), t10 !== o10.state && MC.enqueueReplaceState(o10, o10.state, null), xC(e14, n10, o10, r10), o10.state = e14.memoizedState), "function" == typeof o10.componentDidMount && (e14.effectTag |= 4);
}
var LC = Array.isArray;
function HC(e14, t10, n10) {
  if (null !== (e14 = n10.ref) && "function" != typeof e14 && "object" != typeof e14) {
    if (n10._owner) {
      if (n10 = n10._owner) {
        if (1 !== n10.tag) throw Error(mf(309));
        var r10 = n10.stateNode;
      }
      if (!r10) throw Error(mf(147, e14));
      var o10 = "" + e14;
      return null !== t10 && null !== t10.ref && "function" == typeof t10.ref && t10.ref._stringRef === o10 ? t10.ref : (t10 = function(e15) {
        var t11 = r10.refs;
        t11 === EC && (t11 = r10.refs = {}), null === e15 ? delete t11[o10] : t11[o10] = e15;
      }, t10._stringRef = o10, t10);
    }
    if ("string" != typeof e14) throw Error(mf(284));
    if (!n10._owner) throw Error(mf(290, e14));
  }
  return e14;
}
function IC(e14, t10) {
  if ("textarea" !== e14.type) throw Error(mf(31, "[object Object]" === Object.prototype.toString.call(t10) ? "object with keys {" + Object.keys(t10).join(", ") + "}" : t10, ""));
}
function _C(e14) {
  function t10(t11, n11) {
    if (e14) {
      var r11 = t11.lastEffect;
      null !== r11 ? (r11.nextEffect = n11, t11.lastEffect = n11) : t11.firstEffect = t11.lastEffect = n11, n11.nextEffect = null, n11.effectTag = 8;
    }
  }
  function n10(n11, r11) {
    if (!e14) return null;
    for (; null !== r11; ) t10(n11, r11), r11 = r11.sibling;
    return null;
  }
  function r10(e15, t11) {
    for (e15 = /* @__PURE__ */ new Map(); null !== t11; ) null !== t11.key ? e15.set(t11.key, t11) : e15.set(t11.index, t11), t11 = t11.sibling;
    return e15;
  }
  function o10(e15, t11) {
    return (e15 = qT(e15, t11)).index = 0, e15.sibling = null, e15;
  }
  function a10(t11, n11, r11) {
    return t11.index = r11, e14 ? null !== (r11 = t11.alternate) ? (r11 = r11.index) < n11 ? (t11.effectTag = 2, n11) : r11 : (t11.effectTag = 2, n11) : n11;
  }
  function i10(t11) {
    return e14 && null === t11.alternate && (t11.effectTag = 2), t11;
  }
  function s10(e15, t11, n11, r11) {
    return null === t11 || 6 !== t11.tag ? ((t11 = XT(n11, e15.mode, r11)).return = e15, t11) : ((t11 = o10(t11, n11)).return = e15, t11);
  }
  function l10(e15, t11, n11, r11) {
    return null !== t11 && t11.elementType === n11.type ? ((r11 = o10(t11, n11.props)).ref = HC(e15, t11, n11), r11.return = e15, r11) : ((r11 = YT(n11.type, n11.key, n11.props, null, e15.mode, r11)).ref = HC(e15, t11, n11), r11.return = e15, r11);
  }
  function c10(e15, t11, n11, r11) {
    return null === t11 || 4 !== t11.tag || t11.stateNode.containerInfo !== n11.containerInfo || t11.stateNode.implementation !== n11.implementation ? ((t11 = JT(n11, e15.mode, r11)).return = e15, t11) : ((t11 = o10(t11, n11.children || [])).return = e15, t11);
  }
  function u10(e15, t11, n11, r11, a11) {
    return null === t11 || 7 !== t11.tag ? ((t11 = KT(n11, e15.mode, r11, a11)).return = e15, t11) : ((t11 = o10(t11, n11)).return = e15, t11);
  }
  function d10(e15, t11, n11) {
    if ("string" == typeof t11 || "number" == typeof t11) return (t11 = XT("" + t11, e15.mode, n11)).return = e15, t11;
    if ("object" == typeof t11 && null !== t11) {
      switch (t11.$$typeof) {
        case sg:
          return (n11 = YT(t11.type, t11.key, t11.props, null, e15.mode, n11)).ref = HC(e15, null, t11), n11.return = e15, n11;
        case lg:
          return (t11 = JT(t11, e15.mode, n11)).return = e15, t11;
      }
      if (LC(t11) || xg(t11)) return (t11 = KT(t11, e15.mode, n11, null)).return = e15, t11;
      IC(e15, t11);
    }
    return null;
  }
  function p10(e15, t11, n11, r11) {
    var o11 = null !== t11 ? t11.key : null;
    if ("string" == typeof n11 || "number" == typeof n11) return null !== o11 ? null : s10(e15, t11, "" + n11, r11);
    if ("object" == typeof n11 && null !== n11) {
      switch (n11.$$typeof) {
        case sg:
          return n11.key === o11 ? n11.type === cg ? u10(e15, t11, n11.props.children, r11, o11) : l10(e15, t11, n11, r11) : null;
        case lg:
          return n11.key === o11 ? c10(e15, t11, n11, r11) : null;
      }
      if (LC(n11) || xg(n11)) return null !== o11 ? null : u10(e15, t11, n11, r11, null);
      IC(e15, n11);
    }
    return null;
  }
  function m10(e15, t11, n11, r11, o11) {
    if ("string" == typeof r11 || "number" == typeof r11) return s10(t11, e15 = e15.get(n11) || null, "" + r11, o11);
    if ("object" == typeof r11 && null !== r11) {
      switch (r11.$$typeof) {
        case sg:
          return e15 = e15.get(null === r11.key ? n11 : r11.key) || null, r11.type === cg ? u10(t11, e15, r11.props.children, o11, r11.key) : l10(t11, e15, r11, o11);
        case lg:
          return c10(t11, e15 = e15.get(null === r11.key ? n11 : r11.key) || null, r11, o11);
      }
      if (LC(r11) || xg(r11)) return u10(t11, e15 = e15.get(n11) || null, r11, o11, null);
      IC(t11, r11);
    }
    return null;
  }
  function h10(o11, i11, s11, l11) {
    for (var c11 = null, u11 = null, h11 = i11, f11 = i11 = 0, g10 = null; null !== h11 && f11 < s11.length; f11++) {
      h11.index > f11 ? (g10 = h11, h11 = null) : g10 = h11.sibling;
      var y10 = p10(o11, h11, s11[f11], l11);
      if (null === y10) {
        null === h11 && (h11 = g10);
        break;
      }
      e14 && h11 && null === y10.alternate && t10(o11, h11), i11 = a10(y10, i11, f11), null === u11 ? c11 = y10 : u11.sibling = y10, u11 = y10, h11 = g10;
    }
    if (f11 === s11.length) return n10(o11, h11), c11;
    if (null === h11) {
      for (; f11 < s11.length; f11++) null !== (h11 = d10(o11, s11[f11], l11)) && (i11 = a10(h11, i11, f11), null === u11 ? c11 = h11 : u11.sibling = h11, u11 = h11);
      return c11;
    }
    for (h11 = r10(o11, h11); f11 < s11.length; f11++) null !== (g10 = m10(h11, o11, f11, s11[f11], l11)) && (e14 && null !== g10.alternate && h11.delete(null === g10.key ? f11 : g10.key), i11 = a10(g10, i11, f11), null === u11 ? c11 = g10 : u11.sibling = g10, u11 = g10);
    return e14 && h11.forEach(function(e15) {
      return t10(o11, e15);
    }), c11;
  }
  function f10(o11, i11, s11, l11) {
    var c11 = xg(s11);
    if ("function" != typeof c11) throw Error(mf(150));
    if (null == (s11 = c11.call(s11))) throw Error(mf(151));
    for (var u11 = c11 = null, h11 = i11, f11 = i11 = 0, g10 = null, y10 = s11.next(); null !== h11 && !y10.done; f11++, y10 = s11.next()) {
      h11.index > f11 ? (g10 = h11, h11 = null) : g10 = h11.sibling;
      var v10 = p10(o11, h11, y10.value, l11);
      if (null === v10) {
        null === h11 && (h11 = g10);
        break;
      }
      e14 && h11 && null === v10.alternate && t10(o11, h11), i11 = a10(v10, i11, f11), null === u11 ? c11 = v10 : u11.sibling = v10, u11 = v10, h11 = g10;
    }
    if (y10.done) return n10(o11, h11), c11;
    if (null === h11) {
      for (; !y10.done; f11++, y10 = s11.next()) null !== (y10 = d10(o11, y10.value, l11)) && (i11 = a10(y10, i11, f11), null === u11 ? c11 = y10 : u11.sibling = y10, u11 = y10);
      return c11;
    }
    for (h11 = r10(o11, h11); !y10.done; f11++, y10 = s11.next()) null !== (y10 = m10(h11, o11, f11, y10.value, l11)) && (e14 && null !== y10.alternate && h11.delete(null === y10.key ? f11 : y10.key), i11 = a10(y10, i11, f11), null === u11 ? c11 = y10 : u11.sibling = y10, u11 = y10);
    return e14 && h11.forEach(function(e15) {
      return t10(o11, e15);
    }), c11;
  }
  return function(e15, r11, a11, s11) {
    var l11 = "object" == typeof a11 && null !== a11 && a11.type === cg && null === a11.key;
    l11 && (a11 = a11.props.children);
    var c11 = "object" == typeof a11 && null !== a11;
    if (c11) switch (a11.$$typeof) {
      case sg:
        e: {
          for (c11 = a11.key, l11 = r11; null !== l11; ) {
            if (l11.key === c11) {
              if (7 === l11.tag) {
                if (a11.type === cg) {
                  n10(e15, l11.sibling), (r11 = o10(l11, a11.props.children)).return = e15, e15 = r11;
                  break e;
                }
              } else if (l11.elementType === a11.type) {
                n10(e15, l11.sibling), (r11 = o10(l11, a11.props)).ref = HC(e15, l11, a11), r11.return = e15, e15 = r11;
                break e;
              }
              n10(e15, l11);
              break;
            }
            t10(e15, l11), l11 = l11.sibling;
          }
          a11.type === cg ? ((r11 = KT(a11.props.children, e15.mode, s11, a11.key)).return = e15, e15 = r11) : ((s11 = YT(a11.type, a11.key, a11.props, null, e15.mode, s11)).ref = HC(e15, r11, a11), s11.return = e15, e15 = s11);
        }
        return i10(e15);
      case lg:
        e: {
          for (l11 = a11.key; null !== r11; ) {
            if (r11.key === l11) {
              if (4 === r11.tag && r11.stateNode.containerInfo === a11.containerInfo && r11.stateNode.implementation === a11.implementation) {
                n10(e15, r11.sibling), (r11 = o10(r11, a11.children || [])).return = e15, e15 = r11;
                break e;
              }
              n10(e15, r11);
              break;
            }
            t10(e15, r11), r11 = r11.sibling;
          }
          (r11 = JT(a11, e15.mode, s11)).return = e15, e15 = r11;
        }
        return i10(e15);
    }
    if ("string" == typeof a11 || "number" == typeof a11) return a11 = "" + a11, null !== r11 && 6 === r11.tag ? (n10(e15, r11.sibling), (r11 = o10(r11, a11)).return = e15, e15 = r11) : (n10(e15, r11), (r11 = XT(a11, e15.mode, s11)).return = e15, e15 = r11), i10(e15);
    if (LC(a11)) return h10(e15, r11, a11, s11);
    if (xg(a11)) return f10(e15, r11, a11, s11);
    if (c11 && IC(e15, a11), void 0 === a11 && !l11) switch (e15.tag) {
      case 1:
      case 0:
        throw e15 = e15.type, Error(mf(152, e15.displayName || e15.name || "Component"));
    }
    return n10(e15, r11);
  };
}
var VC = _C(true), RC = _C(false), AC = {}, OC = { current: AC }, BC = { current: AC }, zC = { current: AC };
function $C(e14) {
  if (e14 === AC) throw Error(mf(174));
  return e14;
}
function WC(e14, t10) {
  switch (CS(zC, t10), CS(BC, e14), CS(OC, AC), e14 = t10.nodeType) {
    case 9:
    case 11:
      t10 = (t10 = t10.documentElement) ? t10.namespaceURI : jg(null, "");
      break;
    default:
      t10 = jg(t10 = (e14 = 8 === e14 ? t10.parentNode : t10).namespaceURI || null, e14 = e14.tagName);
  }
  SS(OC), CS(OC, t10);
}
function jC() {
  SS(OC), SS(BC), SS(zC);
}
function ZC(e14) {
  $C(zC.current);
  var t10 = $C(OC.current);
  var n10 = jg(t10, e14.type);
  t10 !== n10 && (CS(BC, e14), CS(OC, n10));
}
function GC(e14) {
  BC.current === e14 && (SS(OC), SS(BC));
}
var UC = { current: 0 };
function qC(e14) {
  for (var t10 = e14; null !== t10; ) {
    if (13 === t10.tag) {
      var n10 = t10.memoizedState;
      if (null !== n10 && (null === (n10 = n10.dehydrated) || n10.data === Ev || n10.data === Fv)) return t10;
    } else if (19 === t10.tag && void 0 !== t10.memoizedProps.revealOrder) {
      if (0 != (64 & t10.effectTag)) return t10;
    } else if (null !== t10.child) {
      t10.child.return = t10, t10 = t10.child;
      continue;
    }
    if (t10 === e14) break;
    for (; null === t10.sibling; ) {
      if (null === t10.return || t10.return === e14) return null;
      t10 = t10.return;
    }
    t10.sibling.return = t10.return, t10 = t10.sibling;
  }
  return null;
}
function YC(e14, t10) {
  return { responder: e14, props: t10 };
}
var KC = rg.ReactCurrentDispatcher, XC = rg.ReactCurrentBatchConfig, JC = 0, QC = null, ex = null, tx = null, nx = false;
function rx() {
  throw Error(mf(321));
}
function ox(e14, t10) {
  if (null === t10) return false;
  for (var n10 = 0; n10 < t10.length && n10 < e14.length; n10++) if (!Yb(e14[n10], t10[n10])) return false;
  return true;
}
function ax(e14, t10, n10, r10, o10, a10) {
  if (JC = a10, QC = t10, t10.memoizedState = null, t10.updateQueue = null, t10.expirationTime = 0, KC.current = null === e14 || null === e14.memoizedState ? kx : Px, e14 = n10(r10, o10), t10.expirationTime === JC) {
    a10 = 0;
    do {
      if (t10.expirationTime = 0, !(25 > a10)) throw Error(mf(301));
      a10 += 1, tx = ex = null, t10.updateQueue = null, KC.current = Nx, e14 = n10(r10, o10);
    } while (t10.expirationTime === JC);
  }
  if (KC.current = Mx, t10 = null !== ex && null !== ex.next, JC = 0, tx = ex = QC = null, nx = false, t10) throw Error(mf(300));
  return e14;
}
function ix() {
  var e14 = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
  return null === tx ? QC.memoizedState = tx = e14 : tx = tx.next = e14, tx;
}
function sx() {
  if (null === ex) {
    var e14 = QC.alternate;
    e14 = null !== e14 ? e14.memoizedState : null;
  } else e14 = ex.next;
  var t10 = null === tx ? QC.memoizedState : tx.next;
  if (null !== t10) tx = t10, ex = e14;
  else {
    if (null === e14) throw Error(mf(310));
    e14 = { memoizedState: (ex = e14).memoizedState, baseState: ex.baseState, baseQueue: ex.baseQueue, queue: ex.queue, next: null }, null === tx ? QC.memoizedState = tx = e14 : tx = tx.next = e14;
  }
  return tx;
}
function lx(e14, t10) {
  return "function" == typeof t10 ? t10(e14) : t10;
}
function cx(e14) {
  var t10 = sx(), n10 = t10.queue;
  if (null === n10) throw Error(mf(311));
  n10.lastRenderedReducer = e14;
  var r10 = ex, o10 = r10.baseQueue, a10 = n10.pending;
  if (null !== a10) {
    if (null !== o10) {
      var i10 = o10.next;
      o10.next = a10.next, a10.next = i10;
    }
    r10.baseQueue = o10 = a10, n10.pending = null;
  }
  if (null !== o10) {
    o10 = o10.next, r10 = r10.baseState;
    var s10 = i10 = a10 = null, l10 = o10;
    do {
      var c10 = l10.expirationTime;
      if (c10 < JC) {
        var u10 = { expirationTime: l10.expirationTime, suspenseConfig: l10.suspenseConfig, action: l10.action, eagerReducer: l10.eagerReducer, eagerState: l10.eagerState, next: null };
        null === s10 ? (i10 = s10 = u10, a10 = r10) : s10 = s10.next = u10, c10 > QC.expirationTime && (QC.expirationTime = c10, MT(c10));
      } else null !== s10 && (s10 = s10.next = { expirationTime: 1073741823, suspenseConfig: l10.suspenseConfig, action: l10.action, eagerReducer: l10.eagerReducer, eagerState: l10.eagerState, next: null }), FT(c10, l10.suspenseConfig), r10 = l10.eagerReducer === e14 ? l10.eagerState : e14(r10, l10.action);
      l10 = l10.next;
    } while (null !== l10 && l10 !== o10);
    null === s10 ? a10 = r10 : s10.next = i10, Yb(r10, t10.memoizedState) || (zx = true), t10.memoizedState = r10, t10.baseState = a10, t10.baseQueue = s10, n10.lastRenderedState = r10;
  }
  return [t10.memoizedState, n10.dispatch];
}
function ux(e14) {
  var t10 = sx(), n10 = t10.queue;
  if (null === n10) throw Error(mf(311));
  n10.lastRenderedReducer = e14;
  var r10 = n10.dispatch, o10 = n10.pending, a10 = t10.memoizedState;
  if (null !== o10) {
    n10.pending = null;
    var i10 = o10 = o10.next;
    do {
      a10 = e14(a10, i10.action), i10 = i10.next;
    } while (i10 !== o10);
    Yb(a10, t10.memoizedState) || (zx = true), t10.memoizedState = a10, null === t10.baseQueue && (t10.baseState = a10), n10.lastRenderedState = a10;
  }
  return [a10, r10];
}
function dx(e14) {
  var t10 = ix();
  return "function" == typeof e14 && (e14 = e14()), t10.memoizedState = t10.baseState = e14, e14 = (e14 = t10.queue = { pending: null, dispatch: null, lastRenderedReducer: lx, lastRenderedState: e14 }).dispatch = Fx.bind(null, QC, e14), [t10.memoizedState, e14];
}
function px(e14, t10, n10, r10) {
  return e14 = { tag: e14, create: t10, destroy: n10, deps: r10, next: null }, null === (t10 = QC.updateQueue) ? (t10 = { lastEffect: null }, QC.updateQueue = t10, t10.lastEffect = e14.next = e14) : null === (n10 = t10.lastEffect) ? t10.lastEffect = e14.next = e14 : (r10 = n10.next, n10.next = e14, e14.next = r10, t10.lastEffect = e14), e14;
}
function mx() {
  return sx().memoizedState;
}
function hx(e14, t10, n10, r10) {
  var o10 = ix();
  QC.effectTag |= e14, o10.memoizedState = px(1 | t10, n10, void 0, void 0 === r10 ? null : r10);
}
function fx(e14, t10, n10, r10) {
  var o10 = sx();
  r10 = void 0 === r10 ? null : r10;
  var a10 = void 0;
  if (null !== ex) {
    var i10 = ex.memoizedState;
    if (a10 = i10.destroy, null !== r10 && ox(r10, i10.deps)) return void px(t10, n10, a10, r10);
  }
  QC.effectTag |= e14, o10.memoizedState = px(1 | t10, n10, a10, r10);
}
function gx(e14, t10) {
  return hx(516, 4, e14, t10);
}
function yx(e14, t10) {
  return fx(516, 4, e14, t10);
}
function vx(e14, t10) {
  return fx(4, 2, e14, t10);
}
function bx(e14, t10) {
  return "function" == typeof t10 ? (e14 = e14(), t10(e14), function() {
    t10(null);
  }) : null != t10 ? (e14 = e14(), t10.current = e14, function() {
    t10.current = null;
  }) : void 0;
}
function Sx(e14, t10, n10) {
  return n10 = null != n10 ? n10.concat([e14]) : null, fx(4, 2, bx.bind(null, t10, e14), n10);
}
function Cx() {
}
function xx(e14, t10) {
  return ix().memoizedState = [e14, void 0 === t10 ? null : t10], e14;
}
function wx(e14, t10) {
  var n10 = sx();
  t10 = void 0 === t10 ? null : t10;
  var r10 = n10.memoizedState;
  return null !== r10 && null !== t10 && ox(t10, r10[1]) ? r10[0] : (n10.memoizedState = [e14, t10], e14);
}
function Tx(e14, t10) {
  var n10 = sx();
  t10 = void 0 === t10 ? null : t10;
  var r10 = n10.memoizedState;
  return null !== r10 && null !== t10 && ox(t10, r10[1]) ? r10[0] : (e14 = e14(), n10.memoizedState = [e14, t10], e14);
}
function Ex(e14, t10, n10) {
  var r10 = JS();
  eC(98 > r10 ? 98 : r10, function() {
    e14(true);
  }), eC(97 < r10 ? 97 : r10, function() {
    var r11 = XC.suspense;
    XC.suspense = void 0 === t10 ? null : t10;
    try {
      e14(false), n10();
    } finally {
      XC.suspense = r11;
    }
  });
}
function Fx(e14, t10, n10) {
  var r10 = mT(), o10 = TC.suspense;
  o10 = { expirationTime: r10 = hT(r10, e14, o10), suspenseConfig: o10, action: n10, eagerReducer: null, eagerState: null, next: null };
  var a10 = t10.pending;
  if (null === a10 ? o10.next = o10 : (o10.next = a10.next, a10.next = o10), t10.pending = o10, a10 = e14.alternate, e14 === QC || null !== a10 && a10 === QC) nx = true, o10.expirationTime = JC, QC.expirationTime = JC;
  else {
    if (0 === e14.expirationTime && (null === a10 || 0 === a10.expirationTime) && null !== (a10 = t10.lastRenderedReducer)) try {
      var i10 = t10.lastRenderedState, s10 = a10(i10, n10);
      if (o10.eagerReducer = a10, o10.eagerState = s10, Yb(s10, i10)) return;
    } catch (e15) {
    }
    fT(e14, r10);
  }
}
var Mx = { readContext: fC, useCallback: rx, useContext: rx, useEffect: rx, useImperativeHandle: rx, useLayoutEffect: rx, useMemo: rx, useReducer: rx, useRef: rx, useState: rx, useDebugValue: rx, useResponder: rx, useDeferredValue: rx, useTransition: rx }, kx = { readContext: fC, useCallback: xx, useContext: fC, useEffect: gx, useImperativeHandle: function(e14, t10, n10) {
  return n10 = null != n10 ? n10.concat([e14]) : null, hx(4, 2, bx.bind(null, t10, e14), n10);
}, useLayoutEffect: function(e14, t10) {
  return hx(4, 2, e14, t10);
}, useMemo: function(e14, t10) {
  var n10 = ix();
  return t10 = void 0 === t10 ? null : t10, e14 = e14(), n10.memoizedState = [e14, t10], e14;
}, useReducer: function(e14, t10, n10) {
  var r10 = ix();
  return t10 = void 0 !== n10 ? n10(t10) : t10, r10.memoizedState = r10.baseState = t10, e14 = (e14 = r10.queue = { pending: null, dispatch: null, lastRenderedReducer: e14, lastRenderedState: t10 }).dispatch = Fx.bind(null, QC, e14), [r10.memoizedState, e14];
}, useRef: function(e14) {
  return e14 = { current: e14 }, ix().memoizedState = e14;
}, useState: dx, useDebugValue: Cx, useResponder: YC, useDeferredValue: function(e14, t10) {
  var n10 = dx(e14), r10 = n10[0], o10 = n10[1];
  return gx(function() {
    var n11 = XC.suspense;
    XC.suspense = void 0 === t10 ? null : t10;
    try {
      o10(e14);
    } finally {
      XC.suspense = n11;
    }
  }, [e14, t10]), r10;
}, useTransition: function(e14) {
  var t10 = dx(false), n10 = t10[0];
  return t10 = t10[1], [xx(Ex.bind(null, t10, e14), [t10, e14]), n10];
} }, Px = { readContext: fC, useCallback: wx, useContext: fC, useEffect: yx, useImperativeHandle: Sx, useLayoutEffect: vx, useMemo: Tx, useReducer: cx, useRef: mx, useState: function() {
  return cx(lx);
}, useDebugValue: Cx, useResponder: YC, useDeferredValue: function(e14, t10) {
  var n10 = cx(lx), r10 = n10[0], o10 = n10[1];
  return yx(function() {
    var n11 = XC.suspense;
    XC.suspense = void 0 === t10 ? null : t10;
    try {
      o10(e14);
    } finally {
      XC.suspense = n11;
    }
  }, [e14, t10]), r10;
}, useTransition: function(e14) {
  var t10 = cx(lx), n10 = t10[0];
  return t10 = t10[1], [wx(Ex.bind(null, t10, e14), [t10, e14]), n10];
} }, Nx = { readContext: fC, useCallback: wx, useContext: fC, useEffect: yx, useImperativeHandle: Sx, useLayoutEffect: vx, useMemo: Tx, useReducer: ux, useRef: mx, useState: function() {
  return ux(lx);
}, useDebugValue: Cx, useResponder: YC, useDeferredValue: function(e14, t10) {
  var n10 = ux(lx), r10 = n10[0], o10 = n10[1];
  return yx(function() {
    var n11 = XC.suspense;
    XC.suspense = void 0 === t10 ? null : t10;
    try {
      o10(e14);
    } finally {
      XC.suspense = n11;
    }
  }, [e14, t10]), r10;
}, useTransition: function(e14) {
  var t10 = ux(lx), n10 = t10[0];
  return t10 = t10[1], [wx(Ex.bind(null, t10, e14), [t10, e14]), n10];
} }, Dx = null, Lx = null, Hx = false;
function Ix(e14, t10) {
  var n10 = GT(5, null, null, 0);
  n10.elementType = "DELETED", n10.type = "DELETED", n10.stateNode = t10, n10.return = e14, n10.effectTag = 8, null !== e14.lastEffect ? (e14.lastEffect.nextEffect = n10, e14.lastEffect = n10) : e14.firstEffect = e14.lastEffect = n10;
}
function _x(e14, t10) {
  switch (e14.tag) {
    case 5:
      var n10 = e14.type;
      return null !== (t10 = 1 !== t10.nodeType || n10.toLowerCase() !== t10.nodeName.toLowerCase() ? null : t10) && (e14.stateNode = t10, true);
    case 6:
      return null !== (t10 = "" === e14.pendingProps || 3 !== t10.nodeType ? null : t10) && (e14.stateNode = t10, true);
    default:
      return false;
  }
}
function Vx(e14) {
  if (Hx) {
    var t10 = Lx;
    if (t10) {
      var n10 = t10;
      if (!_x(e14, t10)) {
        if (!(t10 = Hv(n10.nextSibling)) || !_x(e14, t10)) return e14.effectTag = -1025 & e14.effectTag | 2, Hx = false, void (Dx = e14);
        Ix(Dx, n10);
      }
      Dx = e14, Lx = Hv(t10.firstChild);
    } else e14.effectTag = -1025 & e14.effectTag | 2, Hx = false, Dx = e14;
  }
}
function Rx(e14) {
  for (e14 = e14.return; null !== e14 && 5 !== e14.tag && 3 !== e14.tag && 13 !== e14.tag; ) e14 = e14.return;
  Dx = e14;
}
function Ax(e14) {
  if (e14 !== Dx) return false;
  if (!Hx) return Rx(e14), Hx = true, false;
  var t10 = e14.type;
  if (5 !== e14.tag || "head" !== t10 && "body" !== t10 && !Nv(t10, e14.memoizedProps)) for (t10 = Lx; t10; ) Ix(e14, t10), t10 = Hv(t10.nextSibling);
  if (Rx(e14), 13 === e14.tag) {
    if (!(e14 = null !== (e14 = e14.memoizedState) ? e14.dehydrated : null)) throw Error(mf(317));
    e: {
      for (e14 = e14.nextSibling, t10 = 0; e14; ) {
        if (8 === e14.nodeType) {
          var n10 = e14.data;
          if (n10 === Tv) {
            if (0 === t10) {
              Lx = Hv(e14.nextSibling);
              break e;
            }
            t10--;
          } else n10 !== wv && n10 !== Fv && n10 !== Ev || t10++;
        }
        e14 = e14.nextSibling;
      }
      Lx = null;
    }
  } else Lx = Dx ? Hv(e14.stateNode.nextSibling) : null;
  return true;
}
function Ox() {
  Lx = Dx = null, Hx = false;
}
var Bx = rg.ReactCurrentOwner, zx = false;
function $x(e14, t10, n10, r10) {
  t10.child = null === e14 ? RC(t10, null, n10, r10) : VC(t10, e14.child, n10, r10);
}
function Wx(e14, t10, n10, r10, o10) {
  n10 = n10.render;
  var a10 = t10.ref;
  return hC(t10, o10), r10 = ax(e14, t10, n10, r10, a10, o10), null === e14 || zx ? (t10.effectTag |= 1, $x(e14, t10, r10, o10), t10.child) : (t10.updateQueue = e14.updateQueue, t10.effectTag &= -517, e14.expirationTime <= o10 && (e14.expirationTime = 0), nw(e14, t10, o10));
}
function jx(e14, t10, n10, r10, o10, a10) {
  if (null === e14) {
    var i10 = n10.type;
    return "function" != typeof i10 || UT(i10) || void 0 !== i10.defaultProps || null !== n10.compare || void 0 !== n10.defaultProps ? ((e14 = YT(n10.type, null, r10, null, t10.mode, a10)).ref = t10.ref, e14.return = t10, t10.child = e14) : (t10.tag = 15, t10.type = i10, Zx(e14, t10, i10, r10, o10, a10));
  }
  return i10 = e14.child, o10 < a10 && (o10 = i10.memoizedProps, (n10 = null !== (n10 = n10.compare) ? n10 : Xb)(o10, r10) && e14.ref === t10.ref) ? nw(e14, t10, a10) : (t10.effectTag |= 1, (e14 = qT(i10, r10)).ref = t10.ref, e14.return = t10, t10.child = e14);
}
function Zx(e14, t10, n10, r10, o10, a10) {
  return null !== e14 && Xb(e14.memoizedProps, r10) && e14.ref === t10.ref && (zx = false, o10 < a10) ? (t10.expirationTime = e14.expirationTime, nw(e14, t10, a10)) : Ux(e14, t10, n10, r10, a10);
}
function Gx(e14, t10) {
  var n10 = t10.ref;
  (null === e14 && null !== n10 || null !== e14 && e14.ref !== n10) && (t10.effectTag |= 128);
}
function Ux(e14, t10, n10, r10, o10) {
  var a10 = MS(n10) ? ES : wS.current;
  return a10 = FS(t10, a10), hC(t10, o10), n10 = ax(e14, t10, n10, r10, a10, o10), null === e14 || zx ? (t10.effectTag |= 1, $x(e14, t10, n10, o10), t10.child) : (t10.updateQueue = e14.updateQueue, t10.effectTag &= -517, e14.expirationTime <= o10 && (e14.expirationTime = 0), nw(e14, t10, o10));
}
function qx(e14, t10, n10, r10, o10) {
  if (MS(n10)) {
    var a10 = true;
    DS(t10);
  } else a10 = false;
  if (hC(t10, o10), null === t10.stateNode) null !== e14 && (e14.alternate = null, t10.alternate = null, t10.effectTag |= 2), PC(t10, n10, r10), DC(t10, n10, r10, o10), r10 = true;
  else if (null === e14) {
    var i10 = t10.stateNode, s10 = t10.memoizedProps;
    i10.props = s10;
    var l10 = i10.context, c10 = n10.contextType;
    "object" == typeof c10 && null !== c10 ? c10 = fC(c10) : c10 = FS(t10, c10 = MS(n10) ? ES : wS.current);
    var u10 = n10.getDerivedStateFromProps, d10 = "function" == typeof u10 || "function" == typeof i10.getSnapshotBeforeUpdate;
    d10 || "function" != typeof i10.UNSAFE_componentWillReceiveProps && "function" != typeof i10.componentWillReceiveProps || (s10 !== r10 || l10 !== c10) && NC(t10, i10, r10, c10), gC = false;
    var p10 = t10.memoizedState;
    i10.state = p10, xC(t10, r10, i10, o10), l10 = t10.memoizedState, s10 !== r10 || p10 !== l10 || TS.current || gC ? ("function" == typeof u10 && (FC(t10, n10, u10, r10), l10 = t10.memoizedState), (s10 = gC || kC(t10, n10, s10, r10, p10, l10, c10)) ? (d10 || "function" != typeof i10.UNSAFE_componentWillMount && "function" != typeof i10.componentWillMount || ("function" == typeof i10.componentWillMount && i10.componentWillMount(), "function" == typeof i10.UNSAFE_componentWillMount && i10.UNSAFE_componentWillMount()), "function" == typeof i10.componentDidMount && (t10.effectTag |= 4)) : ("function" == typeof i10.componentDidMount && (t10.effectTag |= 4), t10.memoizedProps = r10, t10.memoizedState = l10), i10.props = r10, i10.state = l10, i10.context = c10, r10 = s10) : ("function" == typeof i10.componentDidMount && (t10.effectTag |= 4), r10 = false);
  } else i10 = t10.stateNode, vC(e14, t10), s10 = t10.memoizedProps, i10.props = t10.type === t10.elementType ? s10 : iC(t10.type, s10), l10 = i10.context, "object" == typeof (c10 = n10.contextType) && null !== c10 ? c10 = fC(c10) : c10 = FS(t10, c10 = MS(n10) ? ES : wS.current), (d10 = "function" == typeof (u10 = n10.getDerivedStateFromProps) || "function" == typeof i10.getSnapshotBeforeUpdate) || "function" != typeof i10.UNSAFE_componentWillReceiveProps && "function" != typeof i10.componentWillReceiveProps || (s10 !== r10 || l10 !== c10) && NC(t10, i10, r10, c10), gC = false, l10 = t10.memoizedState, i10.state = l10, xC(t10, r10, i10, o10), p10 = t10.memoizedState, s10 !== r10 || l10 !== p10 || TS.current || gC ? ("function" == typeof u10 && (FC(t10, n10, u10, r10), p10 = t10.memoizedState), (u10 = gC || kC(t10, n10, s10, r10, l10, p10, c10)) ? (d10 || "function" != typeof i10.UNSAFE_componentWillUpdate && "function" != typeof i10.componentWillUpdate || ("function" == typeof i10.componentWillUpdate && i10.componentWillUpdate(r10, p10, c10), "function" == typeof i10.UNSAFE_componentWillUpdate && i10.UNSAFE_componentWillUpdate(r10, p10, c10)), "function" == typeof i10.componentDidUpdate && (t10.effectTag |= 4), "function" == typeof i10.getSnapshotBeforeUpdate && (t10.effectTag |= 256)) : ("function" != typeof i10.componentDidUpdate || s10 === e14.memoizedProps && l10 === e14.memoizedState || (t10.effectTag |= 4), "function" != typeof i10.getSnapshotBeforeUpdate || s10 === e14.memoizedProps && l10 === e14.memoizedState || (t10.effectTag |= 256), t10.memoizedProps = r10, t10.memoizedState = p10), i10.props = r10, i10.state = p10, i10.context = c10, r10 = u10) : ("function" != typeof i10.componentDidUpdate || s10 === e14.memoizedProps && l10 === e14.memoizedState || (t10.effectTag |= 4), "function" != typeof i10.getSnapshotBeforeUpdate || s10 === e14.memoizedProps && l10 === e14.memoizedState || (t10.effectTag |= 256), r10 = false);
  return Yx(e14, t10, n10, r10, a10, o10);
}
function Yx(e14, t10, n10, r10, o10, a10) {
  Gx(e14, t10);
  var i10 = 0 != (64 & t10.effectTag);
  if (!r10 && !i10) return o10 && LS(t10, n10, false), nw(e14, t10, a10);
  r10 = t10.stateNode, Bx.current = t10;
  var s10 = i10 && "function" != typeof n10.getDerivedStateFromError ? null : r10.render();
  return t10.effectTag |= 1, null !== e14 && i10 ? (t10.child = VC(t10, e14.child, null, a10), t10.child = VC(t10, null, s10, a10)) : $x(e14, t10, s10, a10), t10.memoizedState = r10.state, o10 && LS(t10, n10, true), t10.child;
}
function Kx(e14) {
  var t10 = e14.stateNode;
  t10.pendingContext ? PS(0, t10.pendingContext, t10.pendingContext !== t10.context) : t10.context && PS(0, t10.context, false), WC(e14, t10.containerInfo);
}
var Xx = { dehydrated: null, retryTime: 0 };
function Jx(e14, t10, n10) {
  var r10, o10 = t10.mode, a10 = t10.pendingProps, i10 = UC.current, s10 = false;
  if ((r10 = 0 != (64 & t10.effectTag)) || (r10 = 0 != (2 & i10) && (null === e14 || null !== e14.memoizedState)), r10 ? (s10 = true, t10.effectTag &= -65) : null !== e14 && null === e14.memoizedState || void 0 === a10.fallback || true === a10.unstable_avoidThisFallback || (i10 |= 1), CS(UC, 1 & i10), null === e14) {
    if (void 0 !== a10.fallback && Vx(t10), s10) {
      if (s10 = a10.fallback, (a10 = KT(null, o10, 0, null)).return = t10, 0 == (2 & t10.mode)) for (e14 = null !== t10.memoizedState ? t10.child.child : t10.child, a10.child = e14; null !== e14; ) e14.return = a10, e14 = e14.sibling;
      return (n10 = KT(s10, o10, n10, null)).return = t10, a10.sibling = n10, t10.memoizedState = Xx, t10.child = a10, n10;
    }
    return o10 = a10.children, t10.memoizedState = null, t10.child = RC(t10, null, o10, n10);
  }
  if (null !== e14.memoizedState) {
    if (o10 = (e14 = e14.child).sibling, s10) {
      if (a10 = a10.fallback, (n10 = qT(e14, e14.pendingProps)).return = t10, 0 == (2 & t10.mode) && (s10 = null !== t10.memoizedState ? t10.child.child : t10.child) !== e14.child) for (n10.child = s10; null !== s10; ) s10.return = n10, s10 = s10.sibling;
      return (o10 = qT(o10, a10)).return = t10, n10.sibling = o10, n10.childExpirationTime = 0, t10.memoizedState = Xx, t10.child = n10, o10;
    }
    return n10 = VC(t10, e14.child, a10.children, n10), t10.memoizedState = null, t10.child = n10;
  }
  if (e14 = e14.child, s10) {
    if (s10 = a10.fallback, (a10 = KT(null, o10, 0, null)).return = t10, a10.child = e14, null !== e14 && (e14.return = a10), 0 == (2 & t10.mode)) for (e14 = null !== t10.memoizedState ? t10.child.child : t10.child, a10.child = e14; null !== e14; ) e14.return = a10, e14 = e14.sibling;
    return (n10 = KT(s10, o10, n10, null)).return = t10, a10.sibling = n10, n10.effectTag |= 2, a10.childExpirationTime = 0, t10.memoizedState = Xx, t10.child = a10, n10;
  }
  return t10.memoizedState = null, t10.child = VC(t10, e14, a10.children, n10);
}
function Qx(e14, t10) {
  e14.expirationTime < t10 && (e14.expirationTime = t10);
  var n10 = e14.alternate;
  null !== n10 && n10.expirationTime < t10 && (n10.expirationTime = t10), mC(e14.return, t10);
}
function ew(e14, t10, n10, r10, o10, a10) {
  var i10 = e14.memoizedState;
  null === i10 ? e14.memoizedState = { isBackwards: t10, rendering: null, renderingStartTime: 0, last: r10, tail: n10, tailExpiration: 0, tailMode: o10, lastEffect: a10 } : (i10.isBackwards = t10, i10.rendering = null, i10.renderingStartTime = 0, i10.last = r10, i10.tail = n10, i10.tailExpiration = 0, i10.tailMode = o10, i10.lastEffect = a10);
}
function tw(e14, t10, n10) {
  var r10 = t10.pendingProps, o10 = r10.revealOrder, a10 = r10.tail;
  if ($x(e14, t10, r10.children, n10), 0 != (2 & (r10 = UC.current))) r10 = 1 & r10 | 2, t10.effectTag |= 64;
  else {
    if (null !== e14 && 0 != (64 & e14.effectTag)) e: for (e14 = t10.child; null !== e14; ) {
      if (13 === e14.tag) null !== e14.memoizedState && Qx(e14, n10);
      else if (19 === e14.tag) Qx(e14, n10);
      else if (null !== e14.child) {
        e14.child.return = e14, e14 = e14.child;
        continue;
      }
      if (e14 === t10) break e;
      for (; null === e14.sibling; ) {
        if (null === e14.return || e14.return === t10) break e;
        e14 = e14.return;
      }
      e14.sibling.return = e14.return, e14 = e14.sibling;
    }
    r10 &= 1;
  }
  if (CS(UC, r10), 0 == (2 & t10.mode)) t10.memoizedState = null;
  else switch (o10) {
    case "forwards":
      for (n10 = t10.child, o10 = null; null !== n10; ) null !== (e14 = n10.alternate) && null === qC(e14) && (o10 = n10), n10 = n10.sibling;
      null === (n10 = o10) ? (o10 = t10.child, t10.child = null) : (o10 = n10.sibling, n10.sibling = null), ew(t10, false, o10, n10, a10, t10.lastEffect);
      break;
    case "backwards":
      for (n10 = null, o10 = t10.child, t10.child = null; null !== o10; ) {
        if (null !== (e14 = o10.alternate) && null === qC(e14)) {
          t10.child = o10;
          break;
        }
        e14 = o10.sibling, o10.sibling = n10, n10 = o10, o10 = e14;
      }
      ew(t10, true, n10, null, a10, t10.lastEffect);
      break;
    case "together":
      ew(t10, false, null, null, void 0, t10.lastEffect);
      break;
    default:
      t10.memoizedState = null;
  }
  return t10.child;
}
function nw(e14, t10, n10) {
  null !== e14 && (t10.dependencies = e14.dependencies);
  var r10 = t10.expirationTime;
  if (0 !== r10 && MT(r10), t10.childExpirationTime < n10) return null;
  if (null !== e14 && t10.child !== e14.child) throw Error(mf(153));
  if (null !== t10.child) {
    for (n10 = qT(e14 = t10.child, e14.pendingProps), t10.child = n10, n10.return = t10; null !== e14.sibling; ) e14 = e14.sibling, (n10 = n10.sibling = qT(e14, e14.pendingProps)).return = t10;
    n10.sibling = null;
  }
  return t10.child;
}
var rw, ow, aw, iw;
function sw(e14, t10) {
  switch (e14.tailMode) {
    case "hidden":
      t10 = e14.tail;
      for (var n10 = null; null !== t10; ) null !== t10.alternate && (n10 = t10), t10 = t10.sibling;
      null === n10 ? e14.tail = null : n10.sibling = null;
      break;
    case "collapsed":
      n10 = e14.tail;
      for (var r10 = null; null !== n10; ) null !== n10.alternate && (r10 = n10), n10 = n10.sibling;
      null === r10 ? t10 || null === e14.tail ? e14.tail = null : e14.tail.sibling = null : r10.sibling = null;
  }
}
function lw(e14, t10, n10) {
  var r10 = t10.pendingProps;
  switch (t10.tag) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return null;
    case 1:
    case 17:
      return MS(t10.type) && kS(), null;
    case 3:
      return jC(), SS(TS), SS(wS), (n10 = t10.stateNode).pendingContext && (n10.context = n10.pendingContext, n10.pendingContext = null), null !== e14 && null !== e14.child || !Ax(t10) || (t10.effectTag |= 4), ow(t10), null;
    case 5:
      GC(t10), n10 = $C(zC.current);
      var o10 = t10.type;
      if (null !== e14 && null != t10.stateNode) aw(e14, t10, o10, r10, n10), e14.ref !== t10.ref && (t10.effectTag |= 128);
      else {
        if (!r10) {
          if (null === t10.stateNode) throw Error(mf(166));
          return null;
        }
        if (e14 = $C(OC.current), Ax(t10)) {
          r10 = t10.stateNode, o10 = t10.type;
          var a10 = t10.memoizedProps;
          switch (r10[Vv] = t10, r10[Rv] = a10, o10) {
            case "iframe":
            case "object":
            case "embed":
              tv("load", r10);
              break;
            case "video":
            case "audio":
              for (e14 = 0; e14 < oy.length; e14++) tv(oy[e14], r10);
              break;
            case "source":
              tv("error", r10);
              break;
            case "img":
            case "image":
            case "link":
              tv("error", r10), tv("load", r10);
              break;
            case "form":
              tv("reset", r10), tv("submit", r10);
              break;
            case "details":
              tv("toggle", r10);
              break;
            case "input":
              Ng(r10, a10), tv("invalid", r10), fv(n10, "onChange");
              break;
            case "select":
              r10._wrapperState = { wasMultiple: !!a10.multiple }, tv("invalid", r10), fv(n10, "onChange");
              break;
            case "textarea":
              Ag(r10, a10), tv("invalid", r10), fv(n10, "onChange");
          }
          for (var i10 in pv(o10, a10), e14 = null, a10) if (a10.hasOwnProperty(i10)) {
            var s10 = a10[i10];
            "children" === i10 ? "string" == typeof s10 ? r10.textContent !== s10 && (e14 = ["children", s10]) : "number" == typeof s10 && r10.textContent !== "" + s10 && (e14 = ["children", "" + s10]) : Df.hasOwnProperty(i10) && null != s10 && fv(n10, i10);
          }
          switch (o10) {
            case "input":
              Mg(r10), Hg(r10, a10, true);
              break;
            case "textarea":
              Mg(r10), Bg(r10);
              break;
            case "select":
            case "option":
              break;
            default:
              "function" == typeof a10.onClick && (r10.onclick = gv);
          }
          n10 = e14, t10.updateQueue = n10, null !== n10 && (t10.effectTag |= 4);
        } else {
          switch (i10 = 9 === n10.nodeType ? n10 : n10.ownerDocument, e14 === hv && (e14 = Wg(o10)), e14 === hv ? "script" === o10 ? ((e14 = i10.createElement("div")).innerHTML = "<script><\/script>", e14 = e14.removeChild(e14.firstChild)) : "string" == typeof r10.is ? e14 = i10.createElement(o10, { is: r10.is }) : (e14 = i10.createElement(o10), "select" === o10 && (i10 = e14, r10.multiple ? i10.multiple = true : r10.size && (i10.size = r10.size))) : e14 = i10.createElementNS(e14, o10), e14[Vv] = t10, e14[Rv] = r10, rw(e14, t10, false, false), t10.stateNode = e14, i10 = mv(o10, r10), o10) {
            case "iframe":
            case "object":
            case "embed":
              tv("load", e14), s10 = r10;
              break;
            case "video":
            case "audio":
              for (s10 = 0; s10 < oy.length; s10++) tv(oy[s10], e14);
              s10 = r10;
              break;
            case "source":
              tv("error", e14), s10 = r10;
              break;
            case "img":
            case "image":
            case "link":
              tv("error", e14), tv("load", e14), s10 = r10;
              break;
            case "form":
              tv("reset", e14), tv("submit", e14), s10 = r10;
              break;
            case "details":
              tv("toggle", e14), s10 = r10;
              break;
            case "input":
              Ng(e14, r10), s10 = Pg(e14, r10), tv("invalid", e14), fv(n10, "onChange");
              break;
            case "option":
              s10 = _g(e14, r10);
              break;
            case "select":
              e14._wrapperState = { wasMultiple: !!r10.multiple }, s10 = df({}, r10, { value: void 0 }), tv("invalid", e14), fv(n10, "onChange");
              break;
            case "textarea":
              Ag(e14, r10), s10 = Rg(e14, r10), tv("invalid", e14), fv(n10, "onChange");
              break;
            default:
              s10 = r10;
          }
          pv(o10, s10);
          var l10 = s10;
          for (a10 in l10) if (l10.hasOwnProperty(a10)) {
            var c10 = l10[a10];
            "style" === a10 ? uv(e14, c10) : "dangerouslySetInnerHTML" === a10 ? null != (c10 = c10 ? c10.__html : void 0) && Gg(e14, c10) : "children" === a10 ? "string" == typeof c10 ? ("textarea" !== o10 || "" !== c10) && qg(e14, c10) : "number" == typeof c10 && qg(e14, "" + c10) : "suppressContentEditableWarning" !== a10 && "suppressHydrationWarning" !== a10 && "autoFocus" !== a10 && (Df.hasOwnProperty(a10) ? null != c10 && fv(n10, a10) : null != c10 && og(e14, a10, c10, i10));
          }
          switch (o10) {
            case "input":
              Mg(e14), Hg(e14, r10, false);
              break;
            case "textarea":
              Mg(e14), Bg(e14);
              break;
            case "option":
              null != r10.value && e14.setAttribute("value", "" + Eg(r10.value));
              break;
            case "select":
              e14.multiple = !!r10.multiple, null != (n10 = r10.value) ? Vg(e14, !!r10.multiple, n10, false) : null != r10.defaultValue && Vg(e14, !!r10.multiple, r10.defaultValue, true);
              break;
            default:
              "function" == typeof s10.onClick && (e14.onclick = gv);
          }
          Pv(o10, r10) && (t10.effectTag |= 4);
        }
        null !== t10.ref && (t10.effectTag |= 128);
      }
      return null;
    case 6:
      if (e14 && null != t10.stateNode) iw(e14, t10, e14.memoizedProps, r10);
      else {
        if ("string" != typeof r10 && null === t10.stateNode) throw Error(mf(166));
        n10 = $C(zC.current), $C(OC.current), Ax(t10) ? (n10 = t10.stateNode, r10 = t10.memoizedProps, n10[Vv] = t10, n10.nodeValue !== r10 && (t10.effectTag |= 4)) : ((n10 = (9 === n10.nodeType ? n10 : n10.ownerDocument).createTextNode(r10))[Vv] = t10, t10.stateNode = n10);
      }
      return null;
    case 13:
      return SS(UC), r10 = t10.memoizedState, 0 != (64 & t10.effectTag) ? (t10.expirationTime = n10, t10) : (n10 = null !== r10, r10 = false, null === e14 ? void 0 !== t10.memoizedProps.fallback && Ax(t10) : (r10 = null !== (o10 = e14.memoizedState), n10 || null === o10 || null !== (o10 = e14.child.sibling) && (null !== (a10 = t10.firstEffect) ? (t10.firstEffect = o10, o10.nextEffect = a10) : (t10.firstEffect = t10.lastEffect = o10, o10.nextEffect = null), o10.effectTag = 8)), n10 && !r10 && 0 != (2 & t10.mode) && (null === e14 && true !== t10.memoizedProps.unstable_avoidThisFallback || 0 != (1 & UC.current) ? Uw === Rw && (Uw = Bw) : (Uw !== Rw && Uw !== Bw || (Uw = zw), 0 !== Jw && null !== jw && (tE(jw, Gw), nE(jw, Jw)))), (n10 || r10) && (t10.effectTag |= 4), null);
    case 4:
      return jC(), ow(t10), null;
    case 10:
      return pC(t10), null;
    case 19:
      if (SS(UC), null === (r10 = t10.memoizedState)) return null;
      if (o10 = 0 != (64 & t10.effectTag), null === (a10 = r10.rendering)) {
        if (o10) sw(r10, false);
        else if (Uw !== Rw || null !== e14 && 0 != (64 & e14.effectTag)) for (a10 = t10.child; null !== a10; ) {
          if (null !== (e14 = qC(a10))) {
            for (t10.effectTag |= 64, sw(r10, false), null !== (o10 = e14.updateQueue) && (t10.updateQueue = o10, t10.effectTag |= 4), null === r10.lastEffect && (t10.firstEffect = null), t10.lastEffect = r10.lastEffect, r10 = t10.child; null !== r10; ) a10 = n10, (o10 = r10).effectTag &= 2, o10.nextEffect = null, o10.firstEffect = null, o10.lastEffect = null, null === (e14 = o10.alternate) ? (o10.childExpirationTime = 0, o10.expirationTime = a10, o10.child = null, o10.memoizedProps = null, o10.memoizedState = null, o10.updateQueue = null, o10.dependencies = null) : (o10.childExpirationTime = e14.childExpirationTime, o10.expirationTime = e14.expirationTime, o10.child = e14.child, o10.memoizedProps = e14.memoizedProps, o10.memoizedState = e14.memoizedState, o10.updateQueue = e14.updateQueue, a10 = e14.dependencies, o10.dependencies = null === a10 ? null : { expirationTime: a10.expirationTime, firstContext: a10.firstContext, responders: a10.responders }), r10 = r10.sibling;
            return CS(UC, 1 & UC.current | 2), t10.child;
          }
          a10 = a10.sibling;
        }
      } else {
        if (!o10) if (null !== (e14 = qC(a10))) {
          if (t10.effectTag |= 64, o10 = true, null !== (n10 = e14.updateQueue) && (t10.updateQueue = n10, t10.effectTag |= 4), sw(r10, true), null === r10.tail && "hidden" === r10.tailMode && !a10.alternate) return null !== (t10 = t10.lastEffect = r10.lastEffect) && (t10.nextEffect = null), null;
        } else 2 * XS() - r10.renderingStartTime > r10.tailExpiration && 1 < n10 && (t10.effectTag |= 64, o10 = true, sw(r10, false), t10.expirationTime = t10.childExpirationTime = n10 - 1);
        r10.isBackwards ? (a10.sibling = t10.child, t10.child = a10) : (null !== (n10 = r10.last) ? n10.sibling = a10 : t10.child = a10, r10.last = a10);
      }
      return null !== r10.tail ? (0 === r10.tailExpiration && (r10.tailExpiration = XS() + 500), n10 = r10.tail, r10.rendering = n10, r10.tail = n10.sibling, r10.lastEffect = t10.lastEffect, r10.renderingStartTime = XS(), n10.sibling = null, t10 = UC.current, CS(UC, o10 ? 1 & t10 | 2 : 1 & t10), n10) : null;
  }
  throw Error(mf(156, t10.tag));
}
function cw(e14) {
  switch (e14.tag) {
    case 1:
      MS(e14.type) && kS();
      var t10 = e14.effectTag;
      return 4096 & t10 ? (e14.effectTag = -4097 & t10 | 64, e14) : null;
    case 3:
      if (jC(), SS(TS), SS(wS), 0 != (64 & (t10 = e14.effectTag))) throw Error(mf(285));
      return e14.effectTag = -4097 & t10 | 64, e14;
    case 5:
      return GC(e14), null;
    case 13:
      return SS(UC), 4096 & (t10 = e14.effectTag) ? (e14.effectTag = -4097 & t10 | 64, e14) : null;
    case 19:
      return SS(UC), null;
    case 4:
      return jC(), null;
    case 10:
      return pC(e14), null;
    default:
      return null;
  }
}
function uw(e14, t10) {
  return { value: e14, source: t10, stack: Tg(t10) };
}
rw = function(e14, t10) {
  for (var n10 = t10.child; null !== n10; ) {
    if (5 === n10.tag || 6 === n10.tag) e14.appendChild(n10.stateNode);
    else if (4 !== n10.tag && null !== n10.child) {
      n10.child.return = n10, n10 = n10.child;
      continue;
    }
    if (n10 === t10) break;
    for (; null === n10.sibling; ) {
      if (null === n10.return || n10.return === t10) return;
      n10 = n10.return;
    }
    n10.sibling.return = n10.return, n10 = n10.sibling;
  }
}, ow = function() {
}, aw = function(e14, t10, n10, r10, o10) {
  var a10 = e14.memoizedProps;
  if (a10 !== r10) {
    var i10 = t10.stateNode;
    switch ($C(OC.current), e14 = null, n10) {
      case "input":
        a10 = Pg(i10, a10), r10 = Pg(i10, r10), e14 = [];
        break;
      case "option":
        a10 = _g(i10, a10), r10 = _g(i10, r10), e14 = [];
        break;
      case "select":
        a10 = df({}, a10, { value: void 0 }), r10 = df({}, r10, { value: void 0 }), e14 = [];
        break;
      case "textarea":
        a10 = Rg(i10, a10), r10 = Rg(i10, r10), e14 = [];
        break;
      default:
        "function" != typeof a10.onClick && "function" == typeof r10.onClick && (i10.onclick = gv);
    }
    var s10, l10;
    for (s10 in pv(n10, r10), n10 = null, a10) if (!r10.hasOwnProperty(s10) && a10.hasOwnProperty(s10) && null != a10[s10]) if ("style" === s10) for (l10 in i10 = a10[s10]) i10.hasOwnProperty(l10) && (n10 || (n10 = {}), n10[l10] = "");
    else "dangerouslySetInnerHTML" !== s10 && "children" !== s10 && "suppressContentEditableWarning" !== s10 && "suppressHydrationWarning" !== s10 && "autoFocus" !== s10 && (Df.hasOwnProperty(s10) ? e14 || (e14 = []) : (e14 = e14 || []).push(s10, null));
    for (s10 in r10) {
      var c10 = r10[s10];
      if (i10 = null != a10 ? a10[s10] : void 0, r10.hasOwnProperty(s10) && c10 !== i10 && (null != c10 || null != i10)) if ("style" === s10) if (i10) {
        for (l10 in i10) !i10.hasOwnProperty(l10) || c10 && c10.hasOwnProperty(l10) || (n10 || (n10 = {}), n10[l10] = "");
        for (l10 in c10) c10.hasOwnProperty(l10) && i10[l10] !== c10[l10] && (n10 || (n10 = {}), n10[l10] = c10[l10]);
      } else n10 || (e14 || (e14 = []), e14.push(s10, n10)), n10 = c10;
      else "dangerouslySetInnerHTML" === s10 ? (c10 = c10 ? c10.__html : void 0, i10 = i10 ? i10.__html : void 0, null != c10 && i10 !== c10 && (e14 = e14 || []).push(s10, c10)) : "children" === s10 ? i10 === c10 || "string" != typeof c10 && "number" != typeof c10 || (e14 = e14 || []).push(s10, "" + c10) : "suppressContentEditableWarning" !== s10 && "suppressHydrationWarning" !== s10 && (Df.hasOwnProperty(s10) ? (null != c10 && fv(o10, s10), e14 || i10 === c10 || (e14 = [])) : (e14 = e14 || []).push(s10, c10));
    }
    n10 && (e14 = e14 || []).push("style", n10), o10 = e14, (t10.updateQueue = o10) && (t10.effectTag |= 4);
  }
}, iw = function(e14, t10, n10, r10) {
  n10 !== r10 && (t10.effectTag |= 4);
};
var dw = "function" == typeof WeakSet ? WeakSet : Set;
function pw(e14, t10) {
  var n10 = t10.source, r10 = t10.stack;
  null === r10 && null !== n10 && (r10 = Tg(n10)), null !== n10 && wg(n10.type), t10 = t10.value, null !== e14 && 1 === e14.tag && wg(e14.type);
  try {
    console.error(t10);
  } catch (e15) {
    setTimeout(function() {
      throw e15;
    });
  }
}
function mw(e14) {
  var t10 = e14.ref;
  if (null !== t10) if ("function" == typeof t10) try {
    t10(null);
  } catch (t11) {
    OT(e14, t11);
  }
  else t10.current = null;
}
function hw(e14, t10) {
  switch (t10.tag) {
    case 0:
    case 11:
    case 15:
    case 22:
    case 3:
    case 5:
    case 6:
    case 4:
    case 17:
      return;
    case 1:
      if (256 & t10.effectTag && null !== e14) {
        var n10 = e14.memoizedProps, r10 = e14.memoizedState;
        t10 = (e14 = t10.stateNode).getSnapshotBeforeUpdate(t10.elementType === t10.type ? n10 : iC(t10.type, n10), r10), e14.__reactInternalSnapshotBeforeUpdate = t10;
      }
      return;
  }
  throw Error(mf(163));
}
function fw(e14, t10) {
  if (null !== (t10 = null !== (t10 = t10.updateQueue) ? t10.lastEffect : null)) {
    var n10 = t10 = t10.next;
    do {
      if ((n10.tag & e14) === e14) {
        var r10 = n10.destroy;
        n10.destroy = void 0, void 0 !== r10 && r10();
      }
      n10 = n10.next;
    } while (n10 !== t10);
  }
}
function gw(e14, t10) {
  if (null !== (t10 = null !== (t10 = t10.updateQueue) ? t10.lastEffect : null)) {
    var n10 = t10 = t10.next;
    do {
      if ((n10.tag & e14) === e14) {
        var r10 = n10.create;
        n10.destroy = r10();
      }
      n10 = n10.next;
    } while (n10 !== t10);
  }
}
function yw(e14, t10, n10) {
  switch (n10.tag) {
    case 0:
    case 11:
    case 15:
    case 22:
      return void gw(3, n10);
    case 1:
      if (e14 = n10.stateNode, 4 & n10.effectTag) if (null === t10) e14.componentDidMount();
      else {
        var r10 = n10.elementType === n10.type ? t10.memoizedProps : iC(n10.type, t10.memoizedProps);
        e14.componentDidUpdate(r10, t10.memoizedState, e14.__reactInternalSnapshotBeforeUpdate);
      }
      return void (null !== (t10 = n10.updateQueue) && wC(n10, t10, e14));
    case 3:
      if (null !== (t10 = n10.updateQueue)) {
        if (e14 = null, null !== n10.child) switch (n10.child.tag) {
          case 5:
          case 1:
            e14 = n10.child.stateNode;
        }
        wC(n10, t10, e14);
      }
      return;
    case 5:
      return e14 = n10.stateNode, void (null === t10 && 4 & n10.effectTag && Pv(n10.type, n10.memoizedProps) && e14.focus());
    case 6:
    case 4:
    case 12:
    case 19:
    case 17:
    case 20:
    case 21:
      return;
    case 13:
      return void (null === n10.memoizedState && (n10 = n10.alternate, null !== n10 && (n10 = n10.memoizedState, null !== n10 && (n10 = n10.dehydrated, null !== n10 && jy(n10)))));
  }
  throw Error(mf(163));
}
function vw(e14, t10, n10) {
  switch ("function" == typeof jT && jT(t10), t10.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
    case 22:
      if (null !== (e14 = t10.updateQueue) && null !== (e14 = e14.lastEffect)) {
        var r10 = e14.next;
        eC(97 < n10 ? 97 : n10, function() {
          var e15 = r10;
          do {
            var n11 = e15.destroy;
            if (void 0 !== n11) {
              var o10 = t10;
              try {
                n11();
              } catch (e16) {
                OT(o10, e16);
              }
            }
            e15 = e15.next;
          } while (e15 !== r10);
        });
      }
      break;
    case 1:
      mw(t10), "function" == typeof (n10 = t10.stateNode).componentWillUnmount && function(e15, t11) {
        try {
          t11.props = e15.memoizedProps, t11.state = e15.memoizedState, t11.componentWillUnmount();
        } catch (t12) {
          OT(e15, t12);
        }
      }(t10, n10);
      break;
    case 5:
      mw(t10);
      break;
    case 4:
      Tw(e14, t10, n10);
  }
}
function bw(e14) {
  var t10 = e14.alternate;
  e14.return = null, e14.child = null, e14.memoizedState = null, e14.updateQueue = null, e14.dependencies = null, e14.alternate = null, e14.firstEffect = null, e14.lastEffect = null, e14.pendingProps = null, e14.memoizedProps = null, e14.stateNode = null, null !== t10 && bw(t10);
}
function Sw(e14) {
  return 5 === e14.tag || 3 === e14.tag || 4 === e14.tag;
}
function Cw(e14) {
  e: {
    for (var t10 = e14.return; null !== t10; ) {
      if (Sw(t10)) {
        var n10 = t10;
        break e;
      }
      t10 = t10.return;
    }
    throw Error(mf(160));
  }
  switch (t10 = n10.stateNode, n10.tag) {
    case 5:
      var r10 = false;
      break;
    case 3:
    case 4:
      t10 = t10.containerInfo, r10 = true;
      break;
    default:
      throw Error(mf(161));
  }
  16 & n10.effectTag && (qg(t10, ""), n10.effectTag &= -17);
  e: t: for (n10 = e14; ; ) {
    for (; null === n10.sibling; ) {
      if (null === n10.return || Sw(n10.return)) {
        n10 = null;
        break e;
      }
      n10 = n10.return;
    }
    for (n10.sibling.return = n10.return, n10 = n10.sibling; 5 !== n10.tag && 6 !== n10.tag && 18 !== n10.tag; ) {
      if (2 & n10.effectTag) continue t;
      if (null === n10.child || 4 === n10.tag) continue t;
      n10.child.return = n10, n10 = n10.child;
    }
    if (!(2 & n10.effectTag)) {
      n10 = n10.stateNode;
      break e;
    }
  }
  r10 ? xw(e14, n10, t10) : ww(e14, n10, t10);
}
function xw(e14, t10, n10) {
  var r10 = e14.tag, o10 = 5 === r10 || 6 === r10;
  if (o10) e14 = o10 ? e14.stateNode : e14.stateNode.instance, t10 ? 8 === n10.nodeType ? n10.parentNode.insertBefore(e14, t10) : n10.insertBefore(e14, t10) : (8 === n10.nodeType ? (t10 = n10.parentNode).insertBefore(e14, n10) : (t10 = n10).appendChild(e14), null != (n10 = n10._reactRootContainer) || null !== t10.onclick || (t10.onclick = gv));
  else if (4 !== r10 && null !== (e14 = e14.child)) for (xw(e14, t10, n10), e14 = e14.sibling; null !== e14; ) xw(e14, t10, n10), e14 = e14.sibling;
}
function ww(e14, t10, n10) {
  var r10 = e14.tag, o10 = 5 === r10 || 6 === r10;
  if (o10) e14 = o10 ? e14.stateNode : e14.stateNode.instance, t10 ? n10.insertBefore(e14, t10) : n10.appendChild(e14);
  else if (4 !== r10 && null !== (e14 = e14.child)) for (ww(e14, t10, n10), e14 = e14.sibling; null !== e14; ) ww(e14, t10, n10), e14 = e14.sibling;
}
function Tw(e14, t10, n10) {
  for (var r10, o10, a10 = t10, i10 = false; ; ) {
    if (!i10) {
      i10 = a10.return;
      e: for (; ; ) {
        if (null === i10) throw Error(mf(160));
        switch (r10 = i10.stateNode, i10.tag) {
          case 5:
            o10 = false;
            break e;
          case 3:
          case 4:
            r10 = r10.containerInfo, o10 = true;
            break e;
        }
        i10 = i10.return;
      }
      i10 = true;
    }
    if (5 === a10.tag || 6 === a10.tag) {
      e: for (var s10 = e14, l10 = a10, c10 = n10, u10 = l10; ; ) if (vw(s10, u10, c10), null !== u10.child && 4 !== u10.tag) u10.child.return = u10, u10 = u10.child;
      else {
        if (u10 === l10) break e;
        for (; null === u10.sibling; ) {
          if (null === u10.return || u10.return === l10) break e;
          u10 = u10.return;
        }
        u10.sibling.return = u10.return, u10 = u10.sibling;
      }
      o10 ? (s10 = r10, l10 = a10.stateNode, 8 === s10.nodeType ? s10.parentNode.removeChild(l10) : s10.removeChild(l10)) : r10.removeChild(a10.stateNode);
    } else if (4 === a10.tag) {
      if (null !== a10.child) {
        r10 = a10.stateNode.containerInfo, o10 = true, a10.child.return = a10, a10 = a10.child;
        continue;
      }
    } else if (vw(e14, a10, n10), null !== a10.child) {
      a10.child.return = a10, a10 = a10.child;
      continue;
    }
    if (a10 === t10) break;
    for (; null === a10.sibling; ) {
      if (null === a10.return || a10.return === t10) return;
      4 === (a10 = a10.return).tag && (i10 = false);
    }
    a10.sibling.return = a10.return, a10 = a10.sibling;
  }
}
function Ew(e14, t10) {
  switch (t10.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
    case 22:
      return void fw(3, t10);
    case 1:
    case 12:
    case 17:
      return;
    case 5:
      var n10 = t10.stateNode;
      if (null != n10) {
        var r10 = t10.memoizedProps, o10 = null !== e14 ? e14.memoizedProps : r10;
        e14 = t10.type;
        var a10 = t10.updateQueue;
        if (t10.updateQueue = null, null !== a10) {
          for (n10[Rv] = r10, "input" === e14 && "radio" === r10.type && null != r10.name && Dg(n10, r10), mv(e14, o10), t10 = mv(e14, r10), o10 = 0; o10 < a10.length; o10 += 2) {
            var i10 = a10[o10], s10 = a10[o10 + 1];
            "style" === i10 ? uv(n10, s10) : "dangerouslySetInnerHTML" === i10 ? Gg(n10, s10) : "children" === i10 ? qg(n10, s10) : og(n10, i10, s10, t10);
          }
          switch (e14) {
            case "input":
              Lg(n10, r10);
              break;
            case "textarea":
              Og(n10, r10);
              break;
            case "select":
              t10 = n10._wrapperState.wasMultiple, n10._wrapperState.wasMultiple = !!r10.multiple, null != (e14 = r10.value) ? Vg(n10, !!r10.multiple, e14, false) : t10 !== !!r10.multiple && (null != r10.defaultValue ? Vg(n10, !!r10.multiple, r10.defaultValue, true) : Vg(n10, !!r10.multiple, r10.multiple ? [] : "", false));
          }
        }
      }
      return;
    case 6:
      if (null === t10.stateNode) throw Error(mf(162));
      return void (t10.stateNode.nodeValue = t10.memoizedProps);
    case 3:
      return void ((t10 = t10.stateNode).hydrate && (t10.hydrate = false, jy(t10.containerInfo)));
    case 13:
      if (n10 = t10, null === t10.memoizedState ? r10 = false : (r10 = true, n10 = t10.child, eT = XS()), null !== n10) e: for (e14 = n10; ; ) {
        if (5 === e14.tag) a10 = e14.stateNode, r10 ? "function" == typeof (a10 = a10.style).setProperty ? a10.setProperty("display", "none", "important") : a10.display = "none" : (a10 = e14.stateNode, o10 = null != (o10 = e14.memoizedProps.style) && o10.hasOwnProperty("display") ? o10.display : null, a10.style.display = cv("display", o10));
        else if (6 === e14.tag) e14.stateNode.nodeValue = r10 ? "" : e14.memoizedProps;
        else {
          if (13 === e14.tag && null !== e14.memoizedState && null === e14.memoizedState.dehydrated) {
            (a10 = e14.child.sibling).return = e14, e14 = a10;
            continue;
          }
          if (null !== e14.child) {
            e14.child.return = e14, e14 = e14.child;
            continue;
          }
        }
        if (e14 === n10) break;
        for (; null === e14.sibling; ) {
          if (null === e14.return || e14.return === n10) break e;
          e14 = e14.return;
        }
        e14.sibling.return = e14.return, e14 = e14.sibling;
      }
      return void Fw(t10);
    case 19:
      return void Fw(t10);
  }
  throw Error(mf(163));
}
function Fw(e14) {
  var t10 = e14.updateQueue;
  if (null !== t10) {
    e14.updateQueue = null;
    var n10 = e14.stateNode;
    null === n10 && (n10 = e14.stateNode = new dw()), t10.forEach(function(t11) {
      var r10 = zT.bind(null, e14, t11);
      n10.has(t11) || (n10.add(t11), t11.then(r10, r10));
    });
  }
}
var Mw = "function" == typeof WeakMap ? WeakMap : Map;
function kw(e14, t10, n10) {
  (n10 = bC(n10, null)).tag = 3, n10.payload = { element: null };
  var r10 = t10.value;
  return n10.callback = function() {
    rT || (rT = true, oT = r10), pw(e14, t10);
  }, n10;
}
function Pw(e14, t10, n10) {
  (n10 = bC(n10, null)).tag = 3;
  var r10 = e14.type.getDerivedStateFromError;
  if ("function" == typeof r10) {
    var o10 = t10.value;
    n10.payload = function() {
      return pw(e14, t10), r10(o10);
    };
  }
  var a10 = e14.stateNode;
  return null !== a10 && "function" == typeof a10.componentDidCatch && (n10.callback = function() {
    "function" != typeof r10 && (null === aT ? aT = /* @__PURE__ */ new Set([this]) : aT.add(this), pw(e14, t10));
    var n11 = t10.stack;
    this.componentDidCatch(t10.value, { componentStack: null !== n11 ? n11 : "" });
  }), n10;
}
var Nw = Math.ceil, Dw = rg.ReactCurrentDispatcher, Lw = rg.ReactCurrentOwner, Hw = 0, Iw = 8, _w = 16, Vw = 32, Rw = 0, Aw = 1, Ow = 2, Bw = 3, zw = 4, $w = 5, Ww = Hw, jw = null, Zw = null, Gw = 0, Uw = Rw, qw = null, Yw = 1073741823, Kw = 1073741823, Xw = null, Jw = 0, Qw = false, eT = 0, tT = 500, nT = null, rT = false, oT = null, aT = null, iT = false, sT = null, lT = 90, cT = null, uT = 0, dT = null, pT = 0;
function mT() {
  return (Ww & (_w | Vw)) !== Hw ? 1073741821 - (XS() / 10 | 0) : 0 !== pT ? pT : pT = 1073741821 - (XS() / 10 | 0);
}
function hT(e14, t10, n10) {
  if (0 == (2 & (t10 = t10.mode))) return 1073741823;
  var r10 = JS();
  if (0 == (4 & t10)) return 99 === r10 ? 1073741823 : 1073741822;
  if ((Ww & _w) !== Hw) return Gw;
  if (null !== n10) e14 = aC(e14, 0 | n10.timeoutMs || 5e3, 250);
  else switch (r10) {
    case 99:
      e14 = 1073741823;
      break;
    case 98:
      e14 = aC(e14, 150, 100);
      break;
    case 97:
    case 96:
      e14 = aC(e14, 5e3, 250);
      break;
    case 95:
      e14 = 2;
      break;
    default:
      throw Error(mf(326));
  }
  return null !== jw && e14 === Gw && --e14, e14;
}
function fT(e14, t10) {
  if (50 < uT) throw uT = 0, dT = null, Error(mf(185));
  if (null !== (e14 = gT(e14, t10))) {
    var n10 = JS();
    1073741823 === t10 ? (Ww & Iw) !== Hw && (Ww & (_w | Vw)) === Hw ? ST(e14) : (vT(e14), Ww === Hw && rC()) : vT(e14), (4 & Ww) === Hw || 98 !== n10 && 99 !== n10 || (null === cT ? cT = /* @__PURE__ */ new Map([[e14, t10]]) : (void 0 === (n10 = cT.get(e14)) || n10 > t10) && cT.set(e14, t10));
  }
}
function gT(e14, t10) {
  e14.expirationTime < t10 && (e14.expirationTime = t10);
  var n10 = e14.alternate;
  null !== n10 && n10.expirationTime < t10 && (n10.expirationTime = t10);
  var r10 = e14.return, o10 = null;
  if (null === r10 && 3 === e14.tag) o10 = e14.stateNode;
  else for (; null !== r10; ) {
    if (n10 = r10.alternate, r10.childExpirationTime < t10 && (r10.childExpirationTime = t10), null !== n10 && n10.childExpirationTime < t10 && (n10.childExpirationTime = t10), null === r10.return && 3 === r10.tag) {
      o10 = r10.stateNode;
      break;
    }
    r10 = r10.return;
  }
  return null !== o10 && (jw === o10 && (MT(t10), Uw === zw && tE(o10, Gw)), nE(o10, t10)), o10;
}
function yT(e14) {
  var t10 = e14.lastExpiredTime;
  if (0 !== t10) return t10;
  if (!eE(e14, t10 = e14.firstPendingTime)) return t10;
  var n10 = e14.lastPingedTime;
  return 2 >= (e14 = n10 > (e14 = e14.nextKnownPendingLevel) ? n10 : e14) && t10 !== e14 ? 0 : e14;
}
function vT(e14) {
  if (0 !== e14.lastExpiredTime) e14.callbackExpirationTime = 1073741823, e14.callbackPriority = 99, e14.callbackNode = nC(ST.bind(null, e14));
  else {
    var t10 = yT(e14), n10 = e14.callbackNode;
    if (0 === t10) null !== n10 && (e14.callbackNode = null, e14.callbackExpirationTime = 0, e14.callbackPriority = 90);
    else {
      var r10 = mT();
      if (1073741823 === t10 ? r10 = 99 : 1 === t10 || 2 === t10 ? r10 = 95 : r10 = 0 >= (r10 = 10 * (1073741821 - t10) - 10 * (1073741821 - r10)) ? 99 : 250 >= r10 ? 98 : 5250 >= r10 ? 97 : 95, null !== n10) {
        var o10 = e14.callbackPriority;
        if (e14.callbackExpirationTime === t10 && o10 >= r10) return;
        n10 !== jS && _S(n10);
      }
      e14.callbackExpirationTime = t10, e14.callbackPriority = r10, t10 = 1073741823 === t10 ? nC(ST.bind(null, e14)) : tC(r10, bT.bind(null, e14), { timeout: 10 * (1073741821 - t10) - XS() }), e14.callbackNode = t10;
    }
  }
}
function bT(e14, t10) {
  if (pT = 0, t10) return rE(e14, t10 = mT()), vT(e14), null;
  var n10 = yT(e14);
  if (0 !== n10) {
    if (t10 = e14.callbackNode, (Ww & (_w | Vw)) !== Hw) throw Error(mf(327));
    if (VT(), e14 === jw && n10 === Gw || wT(e14, n10), null !== Zw) {
      var r10 = Ww;
      Ww |= _w;
      var o10 = ET();
      for (; ; ) try {
        PT();
        break;
      } catch (t11) {
        TT(e14, t11);
      }
      if (dC(), Ww = r10, Dw.current = o10, Uw === Aw) throw t10 = qw, wT(e14, n10), tE(e14, n10), vT(e14), t10;
      if (null === Zw) switch (o10 = e14.finishedWork = e14.current.alternate, e14.finishedExpirationTime = n10, r10 = Uw, jw = null, r10) {
        case Rw:
        case Aw:
          throw Error(mf(345));
        case Ow:
          rE(e14, 2 < n10 ? 2 : n10);
          break;
        case Bw:
          if (tE(e14, n10), n10 === (r10 = e14.lastSuspendedTime) && (e14.nextKnownPendingLevel = LT(o10)), 1073741823 === Yw && 10 < (o10 = eT + tT - XS())) {
            if (Qw) {
              var a10 = e14.lastPingedTime;
              if (0 === a10 || a10 >= n10) {
                e14.lastPingedTime = n10, wT(e14, n10);
                break;
              }
            }
            if (0 !== (a10 = yT(e14)) && a10 !== n10) break;
            if (0 !== r10 && r10 !== n10) {
              e14.lastPingedTime = r10;
              break;
            }
            e14.timeoutHandle = Dv(HT.bind(null, e14), o10);
            break;
          }
          HT(e14);
          break;
        case zw:
          if (tE(e14, n10), n10 === (r10 = e14.lastSuspendedTime) && (e14.nextKnownPendingLevel = LT(o10)), Qw && (0 === (o10 = e14.lastPingedTime) || o10 >= n10)) {
            e14.lastPingedTime = n10, wT(e14, n10);
            break;
          }
          if (0 !== (o10 = yT(e14)) && o10 !== n10) break;
          if (0 !== r10 && r10 !== n10) {
            e14.lastPingedTime = r10;
            break;
          }
          if (1073741823 !== Kw ? r10 = 10 * (1073741821 - Kw) - XS() : 1073741823 === Yw ? r10 = 0 : (r10 = 10 * (1073741821 - Yw) - 5e3, 0 > (r10 = (o10 = XS()) - r10) && (r10 = 0), (n10 = 10 * (1073741821 - n10) - o10) < (r10 = (120 > r10 ? 120 : 480 > r10 ? 480 : 1080 > r10 ? 1080 : 1920 > r10 ? 1920 : 3e3 > r10 ? 3e3 : 4320 > r10 ? 4320 : 1960 * Nw(r10 / 1960)) - r10) && (r10 = n10)), 10 < r10) {
            e14.timeoutHandle = Dv(HT.bind(null, e14), r10);
            break;
          }
          HT(e14);
          break;
        case $w:
          if (1073741823 !== Yw && null !== Xw) {
            a10 = Yw;
            var i10 = Xw;
            if (0 >= (r10 = 0 | i10.busyMinDurationMs) ? r10 = 0 : (o10 = 0 | i10.busyDelayMs, r10 = (a10 = XS() - (10 * (1073741821 - a10) - (0 | i10.timeoutMs || 5e3))) <= o10 ? 0 : o10 + r10 - a10), 10 < r10) {
              tE(e14, n10), e14.timeoutHandle = Dv(HT.bind(null, e14), r10);
              break;
            }
          }
          HT(e14);
          break;
        default:
          throw Error(mf(329));
      }
      if (vT(e14), e14.callbackNode === t10) return bT.bind(null, e14);
    }
  }
  return null;
}
function ST(e14) {
  var t10 = e14.lastExpiredTime;
  if (t10 = 0 !== t10 ? t10 : 1073741823, (Ww & (_w | Vw)) !== Hw) throw Error(mf(327));
  if (VT(), e14 === jw && t10 === Gw || wT(e14, t10), null !== Zw) {
    var n10 = Ww;
    Ww |= _w;
    var r10 = ET();
    for (; ; ) try {
      kT();
      break;
    } catch (t11) {
      TT(e14, t11);
    }
    if (dC(), Ww = n10, Dw.current = r10, Uw === Aw) throw n10 = qw, wT(e14, t10), tE(e14, t10), vT(e14), n10;
    if (null !== Zw) throw Error(mf(261));
    e14.finishedWork = e14.current.alternate, e14.finishedExpirationTime = t10, jw = null, HT(e14), vT(e14);
  }
  return null;
}
function CT(e14, t10) {
  var n10 = Ww;
  Ww |= 1;
  try {
    return e14(t10);
  } finally {
    (Ww = n10) === Hw && rC();
  }
}
function xT(e14, t10) {
  var n10 = Ww;
  Ww &= -2, Ww |= Iw;
  try {
    return e14(t10);
  } finally {
    (Ww = n10) === Hw && rC();
  }
}
function wT(e14, t10) {
  e14.finishedWork = null, e14.finishedExpirationTime = 0;
  var n10 = e14.timeoutHandle;
  if (-1 !== n10 && (e14.timeoutHandle = -1, Lv(n10)), null !== Zw) for (n10 = Zw.return; null !== n10; ) {
    var r10 = n10;
    switch (r10.tag) {
      case 1:
        null != (r10 = r10.type.childContextTypes) && kS();
        break;
      case 3:
        jC(), SS(TS), SS(wS);
        break;
      case 5:
        GC(r10);
        break;
      case 4:
        jC();
        break;
      case 13:
      case 19:
        SS(UC);
        break;
      case 10:
        pC(r10);
    }
    n10 = n10.return;
  }
  jw = e14, Zw = qT(e14.current, null), Gw = t10, Uw = Rw, qw = null, Kw = Yw = 1073741823, Xw = null, Jw = 0, Qw = false;
}
function TT(e14, t10) {
  for (; ; ) {
    try {
      if (dC(), KC.current = Mx, nx) for (var n10 = QC.memoizedState; null !== n10; ) {
        var r10 = n10.queue;
        null !== r10 && (r10.pending = null), n10 = n10.next;
      }
      if (JC = 0, tx = ex = QC = null, nx = false, null === Zw || null === Zw.return) return Uw = Aw, qw = t10, Zw = null;
      e: {
        var o10 = e14, a10 = Zw.return, i10 = Zw, s10 = t10;
        if (t10 = Gw, i10.effectTag |= 2048, i10.firstEffect = i10.lastEffect = null, null !== s10 && "object" == typeof s10 && "function" == typeof s10.then) {
          var l10 = s10;
          if (0 == (2 & i10.mode)) {
            var c10 = i10.alternate;
            c10 ? (i10.updateQueue = c10.updateQueue, i10.memoizedState = c10.memoizedState, i10.expirationTime = c10.expirationTime) : (i10.updateQueue = null, i10.memoizedState = null);
          }
          var u10 = 0 != (1 & UC.current), d10 = a10;
          do {
            var p10;
            if (p10 = 13 === d10.tag) {
              var m10 = d10.memoizedState;
              if (null !== m10) p10 = null !== m10.dehydrated;
              else {
                var h10 = d10.memoizedProps;
                p10 = void 0 !== h10.fallback && (true !== h10.unstable_avoidThisFallback || !u10);
              }
            }
            if (p10) {
              var f10 = d10.updateQueue;
              if (null === f10) {
                var g10 = /* @__PURE__ */ new Set();
                g10.add(l10), d10.updateQueue = g10;
              } else f10.add(l10);
              if (0 == (2 & d10.mode)) {
                if (d10.effectTag |= 64, i10.effectTag &= -2981, 1 === i10.tag) if (null === i10.alternate) i10.tag = 17;
                else {
                  var y10 = bC(1073741823, null);
                  y10.tag = 2, SC(i10, y10);
                }
                i10.expirationTime = 1073741823;
                break e;
              }
              s10 = void 0, i10 = t10;
              var v10 = o10.pingCache;
              if (null === v10 ? (v10 = o10.pingCache = new Mw(), s10 = /* @__PURE__ */ new Set(), v10.set(l10, s10)) : void 0 === (s10 = v10.get(l10)) && (s10 = /* @__PURE__ */ new Set(), v10.set(l10, s10)), !s10.has(i10)) {
                s10.add(i10);
                var b10 = BT.bind(null, o10, l10, i10);
                l10.then(b10, b10);
              }
              d10.effectTag |= 4096, d10.expirationTime = t10;
              break e;
            }
            d10 = d10.return;
          } while (null !== d10);
          s10 = Error((wg(i10.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + Tg(i10));
        }
        Uw !== $w && (Uw = Ow), s10 = uw(s10, i10), d10 = a10;
        do {
          switch (d10.tag) {
            case 3:
              l10 = s10, d10.effectTag |= 4096, d10.expirationTime = t10, CC(d10, kw(d10, l10, t10));
              break e;
            case 1:
              l10 = s10;
              var S10 = d10.type, C10 = d10.stateNode;
              if (0 == (64 & d10.effectTag) && ("function" == typeof S10.getDerivedStateFromError || null !== C10 && "function" == typeof C10.componentDidCatch && (null === aT || !aT.has(C10)))) {
                d10.effectTag |= 4096, d10.expirationTime = t10, CC(d10, Pw(d10, l10, t10));
                break e;
              }
          }
          d10 = d10.return;
        } while (null !== d10);
      }
      Zw = DT(Zw);
    } catch (e15) {
      t10 = e15;
      continue;
    }
    break;
  }
}
function ET() {
  var e14 = Dw.current;
  return Dw.current = Mx, null === e14 ? Mx : e14;
}
function FT(e14, t10) {
  e14 < Yw && 2 < e14 && (Yw = e14), null !== t10 && e14 < Kw && 2 < e14 && (Kw = e14, Xw = t10);
}
function MT(e14) {
  e14 > Jw && (Jw = e14);
}
function kT() {
  for (; null !== Zw; ) Zw = NT(Zw);
}
function PT() {
  for (; null !== Zw && !ZS(); ) Zw = NT(Zw);
}
function NT(e14) {
  var t10 = $T(e14.alternate, e14, Gw);
  return e14.memoizedProps = e14.pendingProps, null === t10 && (t10 = DT(e14)), Lw.current = null, t10;
}
function DT(e14) {
  Zw = e14;
  do {
    var t10 = Zw.alternate;
    if (e14 = Zw.return, 0 == (2048 & Zw.effectTag)) {
      if (t10 = lw(t10, Zw, Gw), 1 === Gw || 1 !== Zw.childExpirationTime) {
        for (var n10 = 0, r10 = Zw.child; null !== r10; ) {
          var o10 = r10.expirationTime, a10 = r10.childExpirationTime;
          o10 > n10 && (n10 = o10), a10 > n10 && (n10 = a10), r10 = r10.sibling;
        }
        Zw.childExpirationTime = n10;
      }
      if (null !== t10) return t10;
      null !== e14 && 0 == (2048 & e14.effectTag) && (null === e14.firstEffect && (e14.firstEffect = Zw.firstEffect), null !== Zw.lastEffect && (null !== e14.lastEffect && (e14.lastEffect.nextEffect = Zw.firstEffect), e14.lastEffect = Zw.lastEffect), 1 < Zw.effectTag && (null !== e14.lastEffect ? e14.lastEffect.nextEffect = Zw : e14.firstEffect = Zw, e14.lastEffect = Zw));
    } else {
      if (null !== (t10 = cw(Zw))) return t10.effectTag &= 2047, t10;
      null !== e14 && (e14.firstEffect = e14.lastEffect = null, e14.effectTag |= 2048);
    }
    if (null !== (t10 = Zw.sibling)) return t10;
    Zw = e14;
  } while (null !== Zw);
  return Uw === Rw && (Uw = $w), null;
}
function LT(e14) {
  var t10 = e14.expirationTime;
  return t10 > (e14 = e14.childExpirationTime) ? t10 : e14;
}
function HT(e14) {
  var t10 = JS();
  return eC(99, IT.bind(null, e14, t10)), null;
}
function IT(e14, t10) {
  do {
    VT();
  } while (null !== sT);
  if ((Ww & (_w | Vw)) !== Hw) throw Error(mf(327));
  var n10 = e14.finishedWork, r10 = e14.finishedExpirationTime;
  if (null === n10) return null;
  if (e14.finishedWork = null, e14.finishedExpirationTime = 0, n10 === e14.current) throw Error(mf(177));
  e14.callbackNode = null, e14.callbackExpirationTime = 0, e14.callbackPriority = 90, e14.nextKnownPendingLevel = 0;
  var o10 = LT(n10);
  if (e14.firstPendingTime = o10, r10 <= e14.lastSuspendedTime ? e14.firstSuspendedTime = e14.lastSuspendedTime = e14.nextKnownPendingLevel = 0 : r10 <= e14.firstSuspendedTime && (e14.firstSuspendedTime = r10 - 1), r10 <= e14.lastPingedTime && (e14.lastPingedTime = 0), r10 <= e14.lastExpiredTime && (e14.lastExpiredTime = 0), e14 === jw && (Zw = jw = null, Gw = 0), 1 < n10.effectTag ? null !== n10.lastEffect ? (n10.lastEffect.nextEffect = n10, o10 = n10.firstEffect) : o10 = n10 : o10 = n10.firstEffect, null !== o10) {
    var a10 = Ww;
    Ww |= Vw, Lw.current = null, Mv = ev;
    var i10 = Cv();
    if (xv(i10)) {
      if ("selectionStart" in i10) var s10 = { start: i10.selectionStart, end: i10.selectionEnd };
      else e: {
        var l10 = (s10 = (s10 = i10.ownerDocument) && s10.defaultView || window).getSelection && s10.getSelection();
        if (l10 && 0 !== l10.rangeCount) {
          s10 = l10.anchorNode;
          var c10 = l10.anchorOffset, u10 = l10.focusNode;
          l10 = l10.focusOffset;
          try {
            s10.nodeType, u10.nodeType;
          } catch (e15) {
            s10 = null;
            break e;
          }
          var d10 = 0, p10 = -1, m10 = -1, h10 = 0, f10 = 0, g10 = i10, y10 = null;
          t: for (; ; ) {
            for (var v10; g10 !== s10 || 0 !== c10 && 3 !== g10.nodeType || (p10 = d10 + c10), g10 !== u10 || 0 !== l10 && 3 !== g10.nodeType || (m10 = d10 + l10), 3 === g10.nodeType && (d10 += g10.nodeValue.length), null !== (v10 = g10.firstChild); ) y10 = g10, g10 = v10;
            for (; ; ) {
              if (g10 === i10) break t;
              if (y10 === s10 && ++h10 === c10 && (p10 = d10), y10 === u10 && ++f10 === l10 && (m10 = d10), null !== (v10 = g10.nextSibling)) break;
              y10 = (g10 = y10).parentNode;
            }
            g10 = v10;
          }
          s10 = -1 === p10 || -1 === m10 ? null : { start: p10, end: m10 };
        } else s10 = null;
      }
      s10 = s10 || { start: 0, end: 0 };
    } else s10 = null;
    kv = { activeElementDetached: null, focusedElem: i10, selectionRange: s10 }, ev = false, nT = o10;
    do {
      try {
        _T();
      } catch (e15) {
        if (null === nT) throw Error(mf(330));
        OT(nT, e15), nT = nT.nextEffect;
      }
    } while (null !== nT);
    nT = o10;
    do {
      try {
        for (i10 = e14, s10 = t10; null !== nT; ) {
          var b10 = nT.effectTag;
          if (16 & b10 && qg(nT.stateNode, ""), 128 & b10) {
            var S10 = nT.alternate;
            if (null !== S10) {
              var C10 = S10.ref;
              null !== C10 && ("function" == typeof C10 ? C10(null) : C10.current = null);
            }
          }
          switch (1038 & b10) {
            case 2:
              Cw(nT), nT.effectTag &= -3;
              break;
            case 6:
              Cw(nT), nT.effectTag &= -3, Ew(nT.alternate, nT);
              break;
            case 1024:
              nT.effectTag &= -1025;
              break;
            case 1028:
              nT.effectTag &= -1025, Ew(nT.alternate, nT);
              break;
            case 4:
              Ew(nT.alternate, nT);
              break;
            case 8:
              Tw(i10, c10 = nT, s10), bw(c10);
          }
          nT = nT.nextEffect;
        }
      } catch (e15) {
        if (null === nT) throw Error(mf(330));
        OT(nT, e15), nT = nT.nextEffect;
      }
    } while (null !== nT);
    if (C10 = kv, S10 = Cv(), b10 = C10.focusedElem, s10 = C10.selectionRange, S10 !== b10 && b10 && b10.ownerDocument && Sv(b10.ownerDocument.documentElement, b10)) {
      null !== s10 && xv(b10) && (S10 = s10.start, void 0 === (C10 = s10.end) && (C10 = S10), "selectionStart" in b10 ? (b10.selectionStart = S10, b10.selectionEnd = Math.min(C10, b10.value.length)) : (C10 = (S10 = b10.ownerDocument || document) && S10.defaultView || window).getSelection && (C10 = C10.getSelection(), c10 = b10.textContent.length, i10 = Math.min(s10.start, c10), s10 = void 0 === s10.end ? i10 : Math.min(s10.end, c10), !C10.extend && i10 > s10 && (c10 = s10, s10 = i10, i10 = c10), c10 = bv(b10, i10), u10 = bv(b10, s10), c10 && u10 && (1 !== C10.rangeCount || C10.anchorNode !== c10.node || C10.anchorOffset !== c10.offset || C10.focusNode !== u10.node || C10.focusOffset !== u10.offset) && ((S10 = S10.createRange()).setStart(c10.node, c10.offset), C10.removeAllRanges(), i10 > s10 ? (C10.addRange(S10), C10.extend(u10.node, u10.offset)) : (S10.setEnd(u10.node, u10.offset), C10.addRange(S10))))), S10 = [];
      for (C10 = b10; C10 = C10.parentNode; ) 1 === C10.nodeType && S10.push({ element: C10, left: C10.scrollLeft, top: C10.scrollTop });
      for ("function" == typeof b10.focus && b10.focus(), b10 = 0; b10 < S10.length; b10++) (C10 = S10[b10]).element.scrollLeft = C10.left, C10.element.scrollTop = C10.top;
    }
    ev = !!Mv, kv = Mv = null, e14.current = n10, nT = o10;
    do {
      try {
        for (b10 = e14; null !== nT; ) {
          var x10 = nT.effectTag;
          if (36 & x10 && yw(b10, nT.alternate, nT), 128 & x10) {
            S10 = void 0;
            var w10 = nT.ref;
            if (null !== w10) {
              var T10 = nT.stateNode;
              nT.tag, S10 = T10, "function" == typeof w10 ? w10(S10) : w10.current = S10;
            }
          }
          nT = nT.nextEffect;
        }
      } catch (e15) {
        if (null === nT) throw Error(mf(330));
        OT(nT, e15), nT = nT.nextEffect;
      }
    } while (null !== nT);
    nT = null, GS(), Ww = a10;
  } else e14.current = n10;
  if (iT) iT = false, sT = e14, lT = t10;
  else for (nT = o10; null !== nT; ) t10 = nT.nextEffect, nT.nextEffect = null, nT = t10;
  if (0 === (t10 = e14.firstPendingTime) && (aT = null), 1073741823 === t10 ? e14 === dT ? uT++ : (uT = 0, dT = e14) : uT = 0, "function" == typeof WT && WT(n10.stateNode, r10), vT(e14), rT) throw rT = false, e14 = oT, oT = null, e14;
  return (Ww & Iw) !== Hw || rC(), null;
}
function _T() {
  for (; null !== nT; ) {
    var e14 = nT.effectTag;
    0 != (256 & e14) && hw(nT.alternate, nT), 0 == (512 & e14) || iT || (iT = true, tC(97, function() {
      return VT(), null;
    })), nT = nT.nextEffect;
  }
}
function VT() {
  if (90 !== lT) {
    var e14 = 97 < lT ? 97 : lT;
    return lT = 90, eC(e14, RT);
  }
}
function RT() {
  if (null === sT) return false;
  var e14 = sT;
  if (sT = null, (Ww & (_w | Vw)) !== Hw) throw Error(mf(331));
  var t10 = Ww;
  for (Ww |= Vw, e14 = e14.current.firstEffect; null !== e14; ) {
    try {
      var n10 = e14;
      if (0 != (512 & n10.effectTag)) switch (n10.tag) {
        case 0:
        case 11:
        case 15:
        case 22:
          fw(5, n10), gw(5, n10);
      }
    } catch (t11) {
      if (null === e14) throw Error(mf(330));
      OT(e14, t11);
    }
    n10 = e14.nextEffect, e14.nextEffect = null, e14 = n10;
  }
  return Ww = t10, rC(), true;
}
function AT(e14, t10, n10) {
  SC(e14, t10 = kw(e14, t10 = uw(n10, t10), 1073741823)), null !== (e14 = gT(e14, 1073741823)) && vT(e14);
}
function OT(e14, t10) {
  if (3 === e14.tag) AT(e14, e14, t10);
  else for (var n10 = e14.return; null !== n10; ) {
    if (3 === n10.tag) {
      AT(n10, e14, t10);
      break;
    }
    if (1 === n10.tag) {
      var r10 = n10.stateNode;
      if ("function" == typeof n10.type.getDerivedStateFromError || "function" == typeof r10.componentDidCatch && (null === aT || !aT.has(r10))) {
        SC(n10, e14 = Pw(n10, e14 = uw(t10, e14), 1073741823)), null !== (n10 = gT(n10, 1073741823)) && vT(n10);
        break;
      }
    }
    n10 = n10.return;
  }
}
function BT(e14, t10, n10) {
  var r10 = e14.pingCache;
  null !== r10 && r10.delete(t10), jw === e14 && Gw === n10 ? Uw === zw || Uw === Bw && 1073741823 === Yw && XS() - eT < tT ? wT(e14, Gw) : Qw = true : eE(e14, n10) && (0 !== (t10 = e14.lastPingedTime) && t10 < n10 || (e14.lastPingedTime = n10, vT(e14)));
}
function zT(e14, t10) {
  var n10 = e14.stateNode;
  null !== n10 && n10.delete(t10), 0 === (t10 = 0) && (t10 = hT(t10 = mT(), e14, null)), null !== (e14 = gT(e14, t10)) && vT(e14);
}
var $T;
$T = function(e14, t10, n10) {
  var r10 = t10.expirationTime;
  if (null !== e14) {
    var o10 = t10.pendingProps;
    if (e14.memoizedProps !== o10 || TS.current) zx = true;
    else {
      if (r10 < n10) {
        switch (zx = false, t10.tag) {
          case 3:
            Kx(t10), Ox();
            break;
          case 5:
            if (ZC(t10), 4 & t10.mode && 1 !== n10 && o10.hidden) return t10.expirationTime = t10.childExpirationTime = 1, null;
            break;
          case 1:
            MS(t10.type) && DS(t10);
            break;
          case 4:
            WC(t10, t10.stateNode.containerInfo);
            break;
          case 10:
            r10 = t10.memoizedProps.value, o10 = t10.type._context, CS(sC, o10._currentValue), o10._currentValue = r10;
            break;
          case 13:
            if (null !== t10.memoizedState) return 0 !== (r10 = t10.child.childExpirationTime) && r10 >= n10 ? Jx(e14, t10, n10) : (CS(UC, 1 & UC.current), null !== (t10 = nw(e14, t10, n10)) ? t10.sibling : null);
            CS(UC, 1 & UC.current);
            break;
          case 19:
            if (r10 = t10.childExpirationTime >= n10, 0 != (64 & e14.effectTag)) {
              if (r10) return tw(e14, t10, n10);
              t10.effectTag |= 64;
            }
            if (null !== (o10 = t10.memoizedState) && (o10.rendering = null, o10.tail = null), CS(UC, UC.current), !r10) return null;
        }
        return nw(e14, t10, n10);
      }
      zx = false;
    }
  } else zx = false;
  switch (t10.expirationTime = 0, t10.tag) {
    case 2:
      if (r10 = t10.type, null !== e14 && (e14.alternate = null, t10.alternate = null, t10.effectTag |= 2), e14 = t10.pendingProps, o10 = FS(t10, wS.current), hC(t10, n10), o10 = ax(null, t10, r10, e14, o10, n10), t10.effectTag |= 1, "object" == typeof o10 && null !== o10 && "function" == typeof o10.render && void 0 === o10.$$typeof) {
        if (t10.tag = 1, t10.memoizedState = null, t10.updateQueue = null, MS(r10)) {
          var a10 = true;
          DS(t10);
        } else a10 = false;
        t10.memoizedState = null !== o10.state && void 0 !== o10.state ? o10.state : null, yC(t10);
        var i10 = r10.getDerivedStateFromProps;
        "function" == typeof i10 && FC(t10, r10, i10, e14), o10.updater = MC, t10.stateNode = o10, o10._reactInternalFiber = t10, DC(t10, r10, e14, n10), t10 = Yx(null, t10, r10, true, a10, n10);
      } else t10.tag = 0, $x(null, t10, o10, n10), t10 = t10.child;
      return t10;
    case 16:
      e: {
        if (o10 = t10.elementType, null !== e14 && (e14.alternate = null, t10.alternate = null, t10.effectTag |= 2), e14 = t10.pendingProps, function(e15) {
          if (-1 === e15._status) {
            e15._status = 0;
            var t11 = e15._ctor;
            t11 = t11(), e15._result = t11, t11.then(function(t12) {
              0 === e15._status && (t12 = t12.default, e15._status = 1, e15._result = t12);
            }, function(t12) {
              0 === e15._status && (e15._status = 2, e15._result = t12);
            });
          }
        }(o10), 1 !== o10._status) throw o10._result;
        switch (o10 = o10._result, t10.type = o10, a10 = t10.tag = function(e15) {
          if ("function" == typeof e15) return UT(e15) ? 1 : 0;
          if (null != e15) {
            if ((e15 = e15.$$typeof) === fg) return 11;
            if (e15 === vg) return 14;
          }
          return 2;
        }(o10), e14 = iC(o10, e14), a10) {
          case 0:
            t10 = Ux(null, t10, o10, e14, n10);
            break e;
          case 1:
            t10 = qx(null, t10, o10, e14, n10);
            break e;
          case 11:
            t10 = Wx(null, t10, o10, e14, n10);
            break e;
          case 14:
            t10 = jx(null, t10, o10, iC(o10.type, e14), r10, n10);
            break e;
        }
        throw Error(mf(306, o10, ""));
      }
      return t10;
    case 0:
      return r10 = t10.type, o10 = t10.pendingProps, Ux(e14, t10, r10, o10 = t10.elementType === r10 ? o10 : iC(r10, o10), n10);
    case 1:
      return r10 = t10.type, o10 = t10.pendingProps, qx(e14, t10, r10, o10 = t10.elementType === r10 ? o10 : iC(r10, o10), n10);
    case 3:
      if (Kx(t10), r10 = t10.updateQueue, null === e14 || null === r10) throw Error(mf(282));
      if (r10 = t10.pendingProps, o10 = null !== (o10 = t10.memoizedState) ? o10.element : null, vC(e14, t10), xC(t10, r10, null, n10), (r10 = t10.memoizedState.element) === o10) Ox(), t10 = nw(e14, t10, n10);
      else {
        if ((o10 = t10.stateNode.hydrate) && (Lx = Hv(t10.stateNode.containerInfo.firstChild), Dx = t10, o10 = Hx = true), o10) for (n10 = RC(t10, null, r10, n10), t10.child = n10; n10; ) n10.effectTag = -3 & n10.effectTag | 1024, n10 = n10.sibling;
        else $x(e14, t10, r10, n10), Ox();
        t10 = t10.child;
      }
      return t10;
    case 5:
      return ZC(t10), null === e14 && Vx(t10), r10 = t10.type, o10 = t10.pendingProps, a10 = null !== e14 ? e14.memoizedProps : null, i10 = o10.children, Nv(r10, o10) ? i10 = null : null !== a10 && Nv(r10, a10) && (t10.effectTag |= 16), Gx(e14, t10), 4 & t10.mode && 1 !== n10 && o10.hidden ? (t10.expirationTime = t10.childExpirationTime = 1, t10 = null) : ($x(e14, t10, i10, n10), t10 = t10.child), t10;
    case 6:
      return null === e14 && Vx(t10), null;
    case 13:
      return Jx(e14, t10, n10);
    case 4:
      return WC(t10, t10.stateNode.containerInfo), r10 = t10.pendingProps, null === e14 ? t10.child = VC(t10, null, r10, n10) : $x(e14, t10, r10, n10), t10.child;
    case 11:
      return r10 = t10.type, o10 = t10.pendingProps, Wx(e14, t10, r10, o10 = t10.elementType === r10 ? o10 : iC(r10, o10), n10);
    case 7:
      return $x(e14, t10, t10.pendingProps, n10), t10.child;
    case 8:
    case 12:
      return $x(e14, t10, t10.pendingProps.children, n10), t10.child;
    case 10:
      e: {
        r10 = t10.type._context, o10 = t10.pendingProps, i10 = t10.memoizedProps, a10 = o10.value;
        var s10 = t10.type._context;
        if (CS(sC, s10._currentValue), s10._currentValue = a10, null !== i10) if (s10 = i10.value, 0 === (a10 = Yb(s10, a10) ? 0 : 0 | ("function" == typeof r10._calculateChangedBits ? r10._calculateChangedBits(s10, a10) : 1073741823))) {
          if (i10.children === o10.children && !TS.current) {
            t10 = nw(e14, t10, n10);
            break e;
          }
        } else for (null !== (s10 = t10.child) && (s10.return = t10); null !== s10; ) {
          var l10 = s10.dependencies;
          if (null !== l10) {
            i10 = s10.child;
            for (var c10 = l10.firstContext; null !== c10; ) {
              if (c10.context === r10 && 0 != (c10.observedBits & a10)) {
                1 === s10.tag && ((c10 = bC(n10, null)).tag = 2, SC(s10, c10)), s10.expirationTime < n10 && (s10.expirationTime = n10), null !== (c10 = s10.alternate) && c10.expirationTime < n10 && (c10.expirationTime = n10), mC(s10.return, n10), l10.expirationTime < n10 && (l10.expirationTime = n10);
                break;
              }
              c10 = c10.next;
            }
          } else i10 = 10 === s10.tag && s10.type === t10.type ? null : s10.child;
          if (null !== i10) i10.return = s10;
          else for (i10 = s10; null !== i10; ) {
            if (i10 === t10) {
              i10 = null;
              break;
            }
            if (null !== (s10 = i10.sibling)) {
              s10.return = i10.return, i10 = s10;
              break;
            }
            i10 = i10.return;
          }
          s10 = i10;
        }
        $x(e14, t10, o10.children, n10), t10 = t10.child;
      }
      return t10;
    case 9:
      return o10 = t10.type, r10 = (a10 = t10.pendingProps).children, hC(t10, n10), r10 = r10(o10 = fC(o10, a10.unstable_observedBits)), t10.effectTag |= 1, $x(e14, t10, r10, n10), t10.child;
    case 14:
      return a10 = iC(o10 = t10.type, t10.pendingProps), jx(e14, t10, o10, a10 = iC(o10.type, a10), r10, n10);
    case 15:
      return Zx(e14, t10, t10.type, t10.pendingProps, r10, n10);
    case 17:
      return r10 = t10.type, o10 = t10.pendingProps, o10 = t10.elementType === r10 ? o10 : iC(r10, o10), null !== e14 && (e14.alternate = null, t10.alternate = null, t10.effectTag |= 2), t10.tag = 1, MS(r10) ? (e14 = true, DS(t10)) : e14 = false, hC(t10, n10), PC(t10, r10, o10), DC(t10, r10, o10, n10), Yx(null, t10, r10, true, e14, n10);
    case 19:
      return tw(e14, t10, n10);
  }
  throw Error(mf(156, t10.tag));
};
var WT = null, jT = null;
function ZT(e14, t10, n10, r10) {
  this.tag = e14, this.key = n10, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t10, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r10, this.effectTag = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childExpirationTime = this.expirationTime = 0, this.alternate = null;
}
function GT(e14, t10, n10, r10) {
  return new ZT(e14, t10, n10, r10);
}
function UT(e14) {
  return !(!(e14 = e14.prototype) || !e14.isReactComponent);
}
function qT(e14, t10) {
  var n10 = e14.alternate;
  return null === n10 ? ((n10 = GT(e14.tag, t10, e14.key, e14.mode)).elementType = e14.elementType, n10.type = e14.type, n10.stateNode = e14.stateNode, n10.alternate = e14, e14.alternate = n10) : (n10.pendingProps = t10, n10.effectTag = 0, n10.nextEffect = null, n10.firstEffect = null, n10.lastEffect = null), n10.childExpirationTime = e14.childExpirationTime, n10.expirationTime = e14.expirationTime, n10.child = e14.child, n10.memoizedProps = e14.memoizedProps, n10.memoizedState = e14.memoizedState, n10.updateQueue = e14.updateQueue, t10 = e14.dependencies, n10.dependencies = null === t10 ? null : { expirationTime: t10.expirationTime, firstContext: t10.firstContext, responders: t10.responders }, n10.sibling = e14.sibling, n10.index = e14.index, n10.ref = e14.ref, n10;
}
function YT(e14, t10, n10, r10, o10, a10) {
  var i10 = 2;
  if (r10 = e14, "function" == typeof e14) UT(e14) && (i10 = 1);
  else if ("string" == typeof e14) i10 = 5;
  else e: switch (e14) {
    case cg:
      return KT(n10.children, o10, a10, t10);
    case hg:
      i10 = 8, o10 |= 7;
      break;
    case ug:
      i10 = 8, o10 |= 1;
      break;
    case dg:
      return (e14 = GT(12, n10, t10, 8 | o10)).elementType = dg, e14.type = dg, e14.expirationTime = a10, e14;
    case gg:
      return (e14 = GT(13, n10, t10, o10)).type = gg, e14.elementType = gg, e14.expirationTime = a10, e14;
    case yg:
      return (e14 = GT(19, n10, t10, o10)).elementType = yg, e14.expirationTime = a10, e14;
    default:
      if ("object" == typeof e14 && null !== e14) switch (e14.$$typeof) {
        case pg:
          i10 = 10;
          break e;
        case mg:
          i10 = 9;
          break e;
        case fg:
          i10 = 11;
          break e;
        case vg:
          i10 = 14;
          break e;
        case bg:
          i10 = 16, r10 = null;
          break e;
        case Sg:
          i10 = 22;
          break e;
      }
      throw Error(mf(130, null == e14 ? e14 : typeof e14, ""));
  }
  return (t10 = GT(i10, n10, t10, o10)).elementType = e14, t10.type = r10, t10.expirationTime = a10, t10;
}
function KT(e14, t10, n10, r10) {
  return (e14 = GT(7, e14, r10, t10)).expirationTime = n10, e14;
}
function XT(e14, t10, n10) {
  return (e14 = GT(6, e14, null, t10)).expirationTime = n10, e14;
}
function JT(e14, t10, n10) {
  return (t10 = GT(4, null !== e14.children ? e14.children : [], e14.key, t10)).expirationTime = n10, t10.stateNode = { containerInfo: e14.containerInfo, pendingChildren: null, implementation: e14.implementation }, t10;
}
function QT(e14, t10, n10) {
  this.tag = t10, this.current = null, this.containerInfo = e14, this.pingCache = this.pendingChildren = null, this.finishedExpirationTime = 0, this.finishedWork = null, this.timeoutHandle = -1, this.pendingContext = this.context = null, this.hydrate = n10, this.callbackNode = null, this.callbackPriority = 90, this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function eE(e14, t10) {
  var n10 = e14.firstSuspendedTime;
  return e14 = e14.lastSuspendedTime, 0 !== n10 && n10 >= t10 && e14 <= t10;
}
function tE(e14, t10) {
  var n10 = e14.firstSuspendedTime, r10 = e14.lastSuspendedTime;
  n10 < t10 && (e14.firstSuspendedTime = t10), (r10 > t10 || 0 === n10) && (e14.lastSuspendedTime = t10), t10 <= e14.lastPingedTime && (e14.lastPingedTime = 0), t10 <= e14.lastExpiredTime && (e14.lastExpiredTime = 0);
}
function nE(e14, t10) {
  t10 > e14.firstPendingTime && (e14.firstPendingTime = t10);
  var n10 = e14.firstSuspendedTime;
  0 !== n10 && (t10 >= n10 ? e14.firstSuspendedTime = e14.lastSuspendedTime = e14.nextKnownPendingLevel = 0 : t10 >= e14.lastSuspendedTime && (e14.lastSuspendedTime = t10 + 1), t10 > e14.nextKnownPendingLevel && (e14.nextKnownPendingLevel = t10));
}
function rE(e14, t10) {
  var n10 = e14.lastExpiredTime;
  (0 === n10 || n10 > t10) && (e14.lastExpiredTime = t10);
}
function oE(e14, t10, n10, r10) {
  var o10 = t10.current, a10 = mT(), i10 = TC.suspense;
  a10 = hT(a10, o10, i10);
  e: if (n10) {
    t: {
      if (sy(n10 = n10._reactInternalFiber) !== n10 || 1 !== n10.tag) throw Error(mf(170));
      var s10 = n10;
      do {
        switch (s10.tag) {
          case 3:
            s10 = s10.stateNode.context;
            break t;
          case 1:
            if (MS(s10.type)) {
              s10 = s10.stateNode.__reactInternalMemoizedMergedChildContext;
              break t;
            }
        }
        s10 = s10.return;
      } while (null !== s10);
      throw Error(mf(171));
    }
    if (1 === n10.tag) {
      var l10 = n10.type;
      if (MS(l10)) {
        n10 = NS(n10, l10, s10);
        break e;
      }
    }
    n10 = s10;
  } else n10 = xS;
  return null === t10.context ? t10.context = n10 : t10.pendingContext = n10, (t10 = bC(a10, i10)).payload = { element: e14 }, null !== (r10 = void 0 === r10 ? null : r10) && (t10.callback = r10), SC(o10, t10), fT(o10, a10), a10;
}
function aE(e14) {
  return (e14 = e14.current).child ? (e14.child.tag, e14.child.stateNode) : null;
}
function iE(e14, t10) {
  null !== (e14 = e14.memoizedState) && null !== e14.dehydrated && e14.retryTime < t10 && (e14.retryTime = t10);
}
function sE(e14, t10) {
  iE(e14, t10), (e14 = e14.alternate) && iE(e14, t10);
}
function lE(e14, t10, n10) {
  var r10 = new QT(e14, t10, n10 = null != n10 && true === n10.hydrate), o10 = GT(3, null, null, 2 === t10 ? 7 : 1 === t10 ? 3 : 0);
  r10.current = o10, o10.stateNode = r10, yC(o10), e14[Av] = r10.current, n10 && 0 !== t10 && function(e15, t11) {
    var n11 = iy(t11);
    Iy.forEach(function(e16) {
      xy(e16, t11, n11);
    }), _y.forEach(function(e16) {
      xy(e16, t11, n11);
    });
  }(0, 9 === e14.nodeType ? e14 : e14.ownerDocument), this._internalRoot = r10;
}
function cE(e14) {
  return !(!e14 || 1 !== e14.nodeType && 9 !== e14.nodeType && 11 !== e14.nodeType && (8 !== e14.nodeType || " react-mount-point-unstable " !== e14.nodeValue));
}
function uE(e14, t10, n10, r10, o10) {
  var a10 = n10._reactRootContainer;
  if (a10) {
    var i10 = a10._internalRoot;
    if ("function" == typeof o10) {
      var s10 = o10;
      o10 = function() {
        var e15 = aE(i10);
        s10.call(e15);
      };
    }
    oE(t10, i10, e14, o10);
  } else {
    if (a10 = n10._reactRootContainer = function(e15, t11) {
      if (t11 || (t11 = !(!(t11 = e15 ? 9 === e15.nodeType ? e15.documentElement : e15.firstChild : null) || 1 !== t11.nodeType || !t11.hasAttribute("data-reactroot"))), !t11) for (var n11; n11 = e15.lastChild; ) e15.removeChild(n11);
      return new lE(e15, 0, t11 ? { hydrate: true } : void 0);
    }(n10, r10), i10 = a10._internalRoot, "function" == typeof o10) {
      var l10 = o10;
      o10 = function() {
        var e15 = aE(i10);
        l10.call(e15);
      };
    }
    xT(function() {
      oE(t10, i10, e14, o10);
    });
  }
  return aE(i10);
}
function dE(e14, t10) {
  var n10 = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
  if (!cE(t10)) throw Error(mf(200));
  return function(e15, t11, n11) {
    var r10 = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return { $$typeof: lg, key: null == r10 ? null : "" + r10, children: e15, containerInfo: t11, implementation: n11 };
  }(e14, t10, null, n10);
}
lE.prototype.render = function(e14) {
  oE(e14, this._internalRoot, null, null);
}, lE.prototype.unmount = function() {
  var e14 = this._internalRoot, t10 = e14.containerInfo;
  oE(null, e14, null, function() {
    t10[Av] = null;
  });
}, wy = function(e14) {
  if (13 === e14.tag) {
    var t10 = aC(mT(), 150, 100);
    fT(e14, t10), sE(e14, t10);
  }
}, Ty = function(e14) {
  13 === e14.tag && (fT(e14, 3), sE(e14, 3));
}, Ey = function(e14) {
  if (13 === e14.tag) {
    var t10 = mT();
    fT(e14, t10 = hT(t10, e14, null)), sE(e14, t10);
  }
}, _f = function(e14, t10, n10) {
  switch (t10) {
    case "input":
      if (Lg(e14, n10), t10 = n10.name, "radio" === n10.type && null != t10) {
        for (n10 = e14; n10.parentNode; ) n10 = n10.parentNode;
        for (n10 = n10.querySelectorAll("input[name=" + JSON.stringify("" + t10) + '][type="radio"]'), t10 = 0; t10 < n10.length; t10++) {
          var r10 = n10[t10];
          if (r10 !== e14 && r10.form === e14.form) {
            var o10 = $v(r10);
            if (!o10) throw Error(mf(90));
            kg(r10), Lg(r10, o10);
          }
        }
      }
      break;
    case "textarea":
      Og(e14, n10);
      break;
    case "select":
      null != (t10 = n10.value) && Vg(e14, !!n10.multiple, t10, false);
  }
}, zf = CT, $f = function(e14, t10, n10, r10, o10) {
  var a10 = Ww;
  Ww |= 4;
  try {
    return eC(98, e14.bind(null, t10, n10, r10, o10));
  } finally {
    (Ww = a10) === Hw && rC();
  }
}, Wf = function() {
  (Ww & (1 | _w | Vw)) === Hw && (function() {
    if (null !== cT) {
      var e14 = cT;
      cT = null, e14.forEach(function(e15, t10) {
        rE(t10, e15), vT(t10);
      }), rC();
    }
  }(), VT());
}, jf = function(e14, t10) {
  var n10 = Ww;
  Ww |= 2;
  try {
    return e14(t10);
  } finally {
    (Ww = n10) === Hw && rC();
  }
};
var pE = { Events: [Bv, zv, $v, Hf, Nf, Yv, function(e14) {
  py(e14, qv);
}, Of, Bf, av, fy, VT, { current: false }] };
!function(e14) {
  var t10 = e14.findFiberByHostInstance;
  (function(e15) {
    if ("undefined" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return false;
    var t11 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (t11.isDisabled || !t11.supportsFiber) return true;
    try {
      var n10 = t11.inject(e15);
      WT = function(e16) {
        try {
          t11.onCommitFiberRoot(n10, e16, void 0, 64 == (64 & e16.current.effectTag));
        } catch (e17) {
        }
      }, jT = function(e16) {
        try {
          t11.onCommitFiberUnmount(n10, e16);
        } catch (e17) {
        }
      };
    } catch (e16) {
    }
  })(df({}, e14, { overrideHookState: null, overrideProps: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: rg.ReactCurrentDispatcher, findHostInstanceByFiber: function(e15) {
    return null === (e15 = uy(e15)) ? null : e15.stateNode;
  }, findFiberByHostInstance: function(e15) {
    return t10 ? t10(e15) : null;
  }, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null }));
}({ findFiberByHostInstance: Ov, bundleType: 0, version: "16.13.1", rendererPackageName: "react-dom" }), af.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = pE, af.createPortal = dE, af.findDOMNode = function(e14) {
  if (null == e14) return null;
  if (1 === e14.nodeType) return e14;
  var t10 = e14._reactInternalFiber;
  if (void 0 === t10) {
    if ("function" == typeof e14.render) throw Error(mf(188));
    throw Error(mf(268, Object.keys(e14)));
  }
  return e14 = null === (e14 = uy(t10)) ? null : e14.stateNode;
}, af.flushSync = function(e14, t10) {
  if ((Ww & (_w | Vw)) !== Hw) throw Error(mf(187));
  var n10 = Ww;
  Ww |= 1;
  try {
    return eC(99, e14.bind(null, t10));
  } finally {
    Ww = n10, rC();
  }
}, af.hydrate = function(e14, t10, n10) {
  if (!cE(t10)) throw Error(mf(200));
  return uE(null, e14, t10, true, n10);
}, af.render = function(e14, t10, n10) {
  if (!cE(t10)) throw Error(mf(200));
  return uE(null, e14, t10, false, n10);
}, af.unmountComponentAtNode = function(e14) {
  if (!cE(e14)) throw Error(mf(40));
  return !!e14._reactRootContainer && (xT(function() {
    uE(null, null, e14, false, function() {
      e14._reactRootContainer = null, e14[Av] = null;
    });
  }), true);
}, af.unstable_batchedUpdates = CT, af.unstable_createPortal = function(e14, t10) {
  return dE(e14, t10, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
}, af.unstable_renderSubtreeIntoContainer = function(e14, t10, n10, r10) {
  if (!cE(n10)) throw Error(mf(200));
  if (null == e14 || void 0 === e14._reactInternalFiber) throw Error(mf(38));
  return uE(e14, t10, n10, false, r10);
}, af.version = "16.13.1", function e2() {
  if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE) try {
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e2);
  } catch (e14) {
    console.error(e14);
  }
}(), of.exports = af;
var mE = of.exports;
var hE = W(mE);
const [fE, gE, yE] = Dp("gc-check");
const [vE, bE] = yE("input");
const [SE] = yE("mark");
const CE = (e14) => {
  const { block: t10 = false, defaultIndeterminate: n10 = false, disabled: r10 = false, indeterminate: o10 = false, invalid: a10 = false, size: i10 = "default", textAlign: s10 = "right", checked: l10, customCSS: c10, dataAid: u10, defaultChecked: d10, id: p10, name: m10, tabIndex: h10, text: f10, title: g10, value: y10, ariaLabel: v10, ariaLabelledBy: b10, ariaRole: S10 } = e14;
  const [C10, x10] = ep.useState(n10);
  const w10 = kp(fE, c10, { [gE("block")]: t10, [gE("invalid")]: a10, [gE("disabled")]: r10, [gE("align-left")]: "left" === s10, [Up]: "small" === i10, [qp]: "large" === i10 });
  const T10 = kp(vE, { [bE("indeterminate")]: o10 || C10 });
  const E10 = { type: "checkbox", checked: l10, id: p10, name: m10, value: y10, disabled: r10, tabIndex: h10, defaultChecked: d10, onChange: () => {
    const { onChange: t11 } = e14;
    C10 && x10(false), t11 == null ? void 0 : t11(y10);
  }, role: S10, "aria-label": v10, "aria-labelledby": b10 };
  return tp.createElement("label", { className: w10, title: g10 || f10, "data-aid": u10 }, tp.createElement("input", __spreadProps(__spreadValues({}, E10), { className: T10, "data-aid": u10 && `${u10}_input` })), tp.createElement("span", { className: SE }), f10);
};
const [xE, wE] = Dp("gc-loader");
const TE = (e14) => {
  const { background: t10 = "default", block: n10 = false, customCSS: r10, height: o10, level: a10, width: i10 } = e14;
  const s10 = kp(xE, r10, { [wE("block")]: n10, [wE("transparent")]: "transparent" === t10, [wE(a10)]: a10 });
  return ep.createElement("div", { className: s10, style: { width: i10, height: o10 } }, ep.createElement("div", null), ep.createElement("div", null), ep.createElement("div", null));
};
const [EE, FE, ME] = Dp("gc-heading");
const [kE] = ME("container");
const [PE] = ME("text");
const [NE] = ME("divider");
const [DE] = ME("actions");
const LE = (e14) => {
  const { align: t10 = "left", headingLevel: n10 = "span", loading: r10 = false, size: o10 = "small", strikeThrough: a10 = true, textSize: i10 = "default", uppercase: s10 = true, weight: l10 = "normal", actions: c10, customCSS: u10, level: d10, text: p10, title: m10, onClick: h10 } = e14;
  const f10 = n10;
  const g10 = kp(EE, u10, { [FE("size-md")]: "default" === o10, [FE("size-lg")]: "large" === o10, [FE(`level-${d10}`)]: d10, [FE("case-default")]: false === s10, [FE("no-strike")]: false === a10, [FE(`align-${t10}`)]: "left" !== t10, [FE(`weight-${l10}`)]: "normal" !== l10, [FE(`text-size-${i10}`)]: "default" !== i10 });
  const y10 = "center" === t10;
  const v10 = c10 && "center" !== t10;
  return ep.createElement("div", { className: g10 }, ep.createElement(f10, { className: kE, title: m10, onClick: h10 }, y10 && ep.createElement("span", { className: NE }), ep.createElement("span", { className: PE }, p10), r10 && ep.createElement(TE, { background: "transparent", level: d10 }), ep.createElement("span", { className: NE }), v10 && ep.createElement(sM, __spreadProps(__spreadValues({}, c10), { size: o10, defaultLevel: d10, customCSS: DE }))));
};
const [HE, IE] = Dp("gc-positioner");
class _E extends ep.Component {
  constructor() {
    super(...arguments), this._disposables = [], this._item = null, this.state = { hasCalculatedStyle: false }, this.getNode = () => this._item, this.setupScrollSpy = () => {
      const { props: { parent: e14 }, context: { root: t10 } } = this;
      const n10 = t10.getElement().parentElement;
      let r10 = "element" === e14.type ? e14.element : n10;
      const o10 = (e15) => {
        e15.addEventListener("scroll", this.onScrollAndResize), this._disposables.push(() => e15.removeEventListener("scroll", this.onScrollAndResize));
      };
      let a10 = false;
      for (; r10 && !a10; ) ((i10 = r10).scrollHeight !== i10.clientHeight || i10.scrollWidth !== i10.clientWidth) && o10(r10), r10 === n10 && (a10 = true), r10 = r10.parentElement;
      var i10;
      o10(window);
    }, this.onScrollAndResize = () => this.updatePosition(), this.setViewportRelativePosition = () => {
      const { props: { align: e14 }, context: { root: t10 }, state: { hasCalculatedStyle: n10 } } = this;
      const r10 = t10.getElement();
      const o10 = r10 === document.body;
      if (o10 && n10) return;
      let a10 = {};
      const [i10, s10] = e14.split("-");
      const l10 = r10.getBoundingClientRect();
      const c10 = r10.parentElement.getBoundingClientRect();
      const u10 = l10.top - c10.top;
      switch (o10 && (a10.position = "fixed"), i10) {
        case "top":
          a10.top = o10 ? 0 : Math.abs(u10);
          break;
        case "bottom":
          a10.bottom = o10 ? 0 : u10;
      }
      switch (s10) {
        case "left":
          a10.left = 0;
          break;
        case "right":
          a10.right = 0;
          break;
        case "center": {
          const e15 = this._item ? this._item.clientWidth : 0;
          a10.left = l10.width / 2 - e15 / 2;
          break;
        }
      }
      this.applyStyle(a10);
    }, this.updatePosition = (e14) => {
      const { props: { align: t10, parent: n10, offset: r10, edgeSnapOffset: o10, flippable: a10, onSide: i10 }, context: { root: s10 } } = this;
      const [l10, c10] = i10 ? [false, r10] : [r10, false];
      if ("viewport" === n10.type) return this.setViewportRelativePosition();
      const u10 = {};
      const [d10, p10] = t10.split("-");
      let m10;
      const h10 = s10.getElement();
      let f10;
      m10 = h10 === document.body ? document.documentElement.getBoundingClientRect() : h10.getBoundingClientRect(), f10 = "element" === n10.type ? n10.element.getBoundingClientRect() : { top: n10.position.y, left: n10.position.x, right: n10.position.x, bottom: n10.position.y, width: 0, height: 0 };
      const g10 = { right: m10.width - (f10.right - m10.left), left: f10.left - m10.left, top: f10.top - m10.top };
      const y10 = m10.top < 0 ? Math.abs(m10.top) : 0;
      const v10 = Math.min(m10.height, document.documentElement.clientHeight - m10.top);
      const b10 = Math.min(m10.right, document.documentElement.clientWidth - m10.left);
      const S10 = this._item ? this._item.clientHeight : 0;
      const C10 = this._item ? this._item.clientWidth : 0;
      const x10 = (e15) => {
        if ("top" === e15) return i10 ? g10.top - S10 + f10.height : false === l10 ? g10.top + f10.height : g10.top - l10 - S10;
        const t11 = S10 + g10.top + f10.height;
        const n11 = g10.top - S10 - +l10;
        let r11 = g10.top + f10.height + l10;
        return r11 = t11 > m10.height && a10 ? n11 : r11, false === l10 ? g10.top : r11;
      };
      let w10 = x10(d10);
      if (e14 && a10) if ("top" === d10) {
        const e15 = x10("bottom");
        w10 < 0 && e15 + S10 <= v10 && (w10 = e15);
      } else {
        const e15 = x10("top");
        w10 + S10 > v10 && e15 > y10 && (w10 = e15);
      }
      const T10 = Math.max(v10 - S10, 0);
      u10.top = w10 < y10 ? y10 + S10 <= v10 ? y10 : T10 : w10 + S10 > v10 ? T10 : w10;
      const E10 = (e15) => {
        switch (e15) {
          case "left":
            return i10 ? { left: g10.left + f10.width + (c10 || 0) } : g10.left < o10 ? { left: o10 } : g10.left + C10 > m10.width - o10 ? { left: m10.width - C10 - o10 } : { left: g10.left };
          case "center": {
            const e16 = C10 / 2;
            const t11 = g10.left + f10.width / 2;
            return t11 - e16 < o10 ? { left: e16 + o10 } : t11 + e16 > m10.width - o10 ? { left: m10.width - e16 - o10 } : { left: t11 };
          }
          case "right":
            return i10 ? { right: g10.right + f10.width + (c10 || 0) } : g10.right < o10 ? { right: o10 } : g10.right + C10 > m10.width - o10 ? { right: m10.width - C10 - o10 } : { right: g10.right };
        }
      };
      let { left: F10, right: M10 } = E10(p10);
      if (e14 && a10) if ("center" === p10) u10.left = F10;
      else if ("left" === p10) {
        const e15 = E10("right").right;
        e15 && F10 && F10 + C10 > b10 && b10 - e15 - C10 > 0 ? u10.right = e15 : u10.left = F10;
      } else {
        const e15 = E10("left").left;
        M10 && e15 && b10 - M10 - C10 < 0 && e15 + C10 < b10 ? u10.left = e15 : u10.right = M10;
      }
      else u10.left = F10, u10.right = M10;
      this.applyStyle(u10);
    }, this.applyStyle = (_a2) => {
      var _b2 = _a2, { position: e14 } = _b2, t10 = __objRest(_b2, ["position"]);
      if (!this._item) return;
      const n10 = e14 ? `position:${e14};` : "";
      const r10 = ["top", "left", "right", "bottom"].map((e15) => void 0 !== t10[e15] ? `${e15}:${t10[e15]}px;` : `${e15}:auto;`).join("");
      this._item.setAttribute("style", n10 + r10), this.state.hasCalculatedStyle || this.setState({ hasCalculatedStyle: true }, this.props.onReady);
    };
  }
  componentDidMount() {
    this.updatePosition(true), window.addEventListener("resize", this.onScrollAndResize), this._disposables.push(() => window.removeEventListener("resize", this.onScrollAndResize)), this.setupScrollSpy();
  }
  componentWillUnmount() {
    this._disposables.forEach((e14) => e14());
  }
  render() {
    const { props: { children: e14, fillContainer: t10 }, state: { hasCalculatedStyle: n10 } } = this;
    const r10 = kp(HE, { [IE("calculating")]: !n10, [IE("fill-container")]: t10 });
    return ep.createElement("div", { className: r10, ref: (e15) => this._item = e15 }, e14);
  }
}
_E.contextType = Sm, _E.defaultProps = { edgeSnapOffset: 0, offset: 0 };
var VE = { exports: {} };
var RE = { exports: {} };
(function() {
  var e14, t10, n10, r10, o10, a10;
  "undefined" != typeof performance && null !== performance && performance.now ? RE.exports = function() {
    return performance.now();
  } : "undefined" != typeof process && null !== process && process.hrtime ? (RE.exports = function() {
    return (e14() - o10) / 1e6;
  }, t10 = process.hrtime, r10 = (e14 = function() {
    var e15;
    return 1e9 * (e15 = t10())[0] + e15[1];
  })(), a10 = 1e9 * process.uptime(), o10 = r10 - a10) : Date.now ? (RE.exports = function() {
    return Date.now() - n10;
  }, n10 = Date.now()) : (RE.exports = function() {
    return (/* @__PURE__ */ new Date()).getTime() - n10;
  }, n10 = (/* @__PURE__ */ new Date()).getTime());
}).call($);
var AE = RE.exports, OE = "undefined" == typeof window ? $ : window, BE = ["moz", "webkit"], zE = "AnimationFrame", $E = OE["request" + zE], WE = OE["cancel" + zE] || OE["cancelRequest" + zE];
for (var jE = 0; !$E && jE < BE.length; jE++) $E = OE[BE[jE] + "Request" + zE], WE = OE[BE[jE] + "Cancel" + zE] || OE[BE[jE] + "CancelRequest" + zE];
if (!$E || !WE) {
  var ZE = 0, GE = 0, UE = [];
  $E = function(e14) {
    if (0 === UE.length) {
      var t10 = AE(), n10 = Math.max(0, 16.666666666666668 - (t10 - ZE));
      ZE = n10 + t10, setTimeout(function() {
        var e15 = UE.slice(0);
        UE.length = 0;
        for (var t11 = 0; t11 < e15.length; t11++) if (!e15[t11].cancelled) try {
          e15[t11].callback(ZE);
        } catch (e16) {
          setTimeout(function() {
            throw e16;
          }, 0);
        }
      }, Math.round(n10));
    }
    return UE.push({ handle: ++GE, callback: e14, cancelled: false }), GE;
  }, WE = function(e14) {
    for (var t10 = 0; t10 < UE.length; t10++) UE[t10].handle === e14 && (UE[t10].cancelled = true);
  };
}
VE.exports = function(e14) {
  return $E.call(OE, e14);
};
var qE = VE.exports.cancel = function() {
  WE.apply(OE, arguments);
};
VE.exports.polyfill = function(e14) {
  e14 || (e14 = OE), e14.requestAnimationFrame = $E, e14.cancelAnimationFrame = WE;
};
var YE = W(VE.exports);
const KE = "rgba(0, 0, 0, .2)";
const XE = { position: "relative", overflow: "hidden", width: "100%", height: "100%" };
const JE = { height: "auto" };
const QE = { position: "absolute", top: 0, left: 0, right: 0, bottom: 0, WebkitOverflowScrolling: "touch" };
const eF = { position: "relative", top: void 0, left: void 0, right: void 0, bottom: void 0 };
const tF = { overflow: "hidden", marginRight: 0, marginBottom: 0 };
const nF = { position: "absolute" };
const rF = { position: "absolute" };
const oF = { position: "relative", display: "block", height: "100%" };
const aF = { position: "relative", display: "block", width: "100%" };
const iF = { userSelect: "none" };
const sF = { userSelect: "" };
class lF extends ep.Component {
  constructor(e14) {
    super(e14), this.state = { didMountUniversal: false }, this.getScrollLeft = this.getScrollLeft.bind(this), this.getScrollTop = this.getScrollTop.bind(this), this.getScrollWidth = this.getScrollWidth.bind(this), this.getScrollHeight = this.getScrollHeight.bind(this), this.getClientWidth = this.getClientWidth.bind(this), this.getClientHeight = this.getClientHeight.bind(this), this.getValues = this.getValues.bind(this), this.getThumbHorizontalWidth = this.getThumbHorizontalWidth.bind(this), this.getThumbVerticalHeight = this.getThumbVerticalHeight.bind(this), this.getScrollLeftForOffset = this.getScrollLeftForOffset.bind(this), this.getScrollTopForOffset = this.getScrollTopForOffset.bind(this), this.scrollLeft = this.scrollLeft.bind(this), this.scrollTop = this.scrollTop.bind(this), this.scrollToLeft = this.scrollToLeft.bind(this), this.scrollToTop = this.scrollToTop.bind(this), this.scrollToRight = this.scrollToRight.bind(this), this.scrollToBottom = this.scrollToBottom.bind(this), this.handleTrackMouseEnter = this.handleTrackMouseEnter.bind(this), this.handleTrackMouseLeave = this.handleTrackMouseLeave.bind(this), this.handleHorizontalTrackMouseDown = this.handleHorizontalTrackMouseDown.bind(this), this.handleVerticalTrackMouseDown = this.handleVerticalTrackMouseDown.bind(this), this.handleHorizontalThumbMouseDown = this.handleHorizontalThumbMouseDown.bind(this), this.handleVerticalThumbMouseDown = this.handleVerticalThumbMouseDown.bind(this), this.handleContainerResize = this.handleContainerResize.bind(this), this.handleScroll = this.handleScroll.bind(this), this.handleDrag = this.handleDrag.bind(this), this.handleDragEnd = this.handleDragEnd.bind(this);
  }
  componentDidMount() {
    this.addListeners(), this.update(), this.componentDidMountUniversal();
  }
  componentDidMountUniversal() {
    const { universal: e14 } = this.props;
    e14 && this.setState({ didMountUniversal: true });
  }
  componentDidUpdate() {
    this.update();
  }
  componentWillUnmount() {
    this.removeListeners(), qE(this.requestFrame), clearTimeout(this.hideTracksTimeout), clearInterval(this.detectScrollingInterval);
  }
  getScrollLeft() {
    return this.view ? this.view.scrollLeft : 0;
  }
  getScrollTop() {
    return this.view ? this.view.scrollTop : 0;
  }
  getScrollWidth() {
    return this.view ? this.view.scrollWidth : 0;
  }
  getScrollHeight() {
    return this.view ? this.view.scrollHeight : 0;
  }
  getClientWidth() {
    return this.view ? this.view.clientWidth : 0;
  }
  getClientHeight() {
    return this.view ? this.view.clientHeight : 0;
  }
  getValues() {
    const { scrollLeft: e14 = 0, scrollTop: t10 = 0, scrollWidth: n10 = 0, scrollHeight: r10 = 0, clientWidth: o10 = 0, clientHeight: a10 = 0 } = this.view || {};
    return { left: e14 / (n10 - o10) || 0, top: t10 / (r10 - a10) || 0, scrollLeft: e14, scrollTop: t10, scrollWidth: n10, scrollHeight: r10, clientWidth: o10, clientHeight: a10 };
  }
  getThumbHorizontalWidth() {
    const { thumbSize: e14, thumbMinSize: t10 } = this.props;
    const { scrollWidth: n10, clientWidth: r10 } = this.view;
    const o10 = Ep(this.trackHorizontal);
    const a10 = Math.ceil(r10 / n10 * o10);
    return o10 === a10 ? 0 : e14 || Math.max(a10, t10);
  }
  getThumbVerticalHeight() {
    const { thumbSize: e14, thumbMinSize: t10 } = this.props;
    const { scrollHeight: n10, clientHeight: r10 } = this.view;
    const o10 = Tp(this.trackVertical);
    const a10 = Math.ceil(r10 / n10 * o10);
    return o10 === a10 ? 0 : e14 || Math.max(a10, t10);
  }
  getScrollLeftForOffset(e14) {
    const { scrollWidth: t10, clientWidth: n10 } = this.view;
    return e14 / (Ep(this.trackHorizontal) - this.getThumbHorizontalWidth()) * (t10 - n10);
  }
  getScrollTopForOffset(e14) {
    const { scrollHeight: t10, clientHeight: n10 } = this.view;
    return e14 / (Tp(this.trackVertical) - this.getThumbVerticalHeight()) * (t10 - n10);
  }
  scrollLeft(e14 = 0) {
    this.view && (this.view.scrollLeft = e14);
  }
  scrollTop(e14 = 0) {
    this.view && (this.view.scrollTop = e14);
  }
  scrollToLeft() {
    this.view && (this.view.scrollLeft = 0);
  }
  scrollToTop() {
    this.view && (this.view.scrollTop = 0);
  }
  scrollToRight() {
    this.view && (this.view.scrollLeft = this.view.scrollWidth);
  }
  scrollToBottom() {
    this.view && (this.view.scrollTop = this.view.scrollHeight);
  }
  addListeners() {
    if ("undefined" == typeof document || !this.view) return;
    const { view: e14, trackHorizontal: t10, trackVertical: n10, thumbHorizontal: r10, thumbVertical: o10 } = this;
    e14.addEventListener("scroll", this.handleScroll), Mp() && (t10.addEventListener("mouseenter", this.handleTrackMouseEnter), t10.addEventListener("mouseleave", this.handleTrackMouseLeave), t10.addEventListener("mousedown", this.handleHorizontalTrackMouseDown), n10.addEventListener("mouseenter", this.handleTrackMouseEnter), n10.addEventListener("mouseleave", this.handleTrackMouseLeave), n10.addEventListener("mousedown", this.handleVerticalTrackMouseDown), r10.addEventListener("mousedown", this.handleHorizontalThumbMouseDown), o10.addEventListener("mousedown", this.handleVerticalThumbMouseDown), this.containerResizeObserver = new ResizeObserver(this.handleContainerResize), this.containerResizeObserver.observe(this.container));
  }
  removeListeners() {
    if ("undefined" == typeof document || !this.view) return;
    const { view: e14, trackHorizontal: t10, trackVertical: n10, thumbHorizontal: r10, thumbVertical: o10 } = this;
    e14.removeEventListener("scroll", this.handleScroll), Mp() && (t10.removeEventListener("mouseenter", this.handleTrackMouseEnter), t10.removeEventListener("mouseleave", this.handleTrackMouseLeave), t10.removeEventListener("mousedown", this.handleHorizontalTrackMouseDown), n10.removeEventListener("mouseenter", this.handleTrackMouseEnter), n10.removeEventListener("mouseleave", this.handleTrackMouseLeave), n10.removeEventListener("mousedown", this.handleVerticalTrackMouseDown), r10.removeEventListener("mousedown", this.handleHorizontalThumbMouseDown), o10.removeEventListener("mousedown", this.handleVerticalThumbMouseDown), this.containerResizeObserver.disconnect(), this.teardownDragging());
  }
  handleScroll(e14) {
    const { onScroll: t10, onScrollFrame: n10 } = this.props;
    t10 && t10(e14), this.update((e15) => {
      const { scrollLeft: t11, scrollTop: r10 } = e15;
      this.viewScrollLeft = t11, this.viewScrollTop = r10, n10 && n10(e15);
    }), this.detectScrolling();
  }
  handleScrollStart() {
    const { onScrollStart: e14 } = this.props;
    e14 && e14(), this.handleScrollStartAutoHide();
  }
  handleScrollStartAutoHide() {
    const { autoHide: e14 } = this.props;
    e14 && this.showTracks();
  }
  handleScrollStop() {
    const { onScrollStop: e14 } = this.props;
    e14 && e14(), this.handleScrollStopAutoHide();
  }
  handleScrollStopAutoHide() {
    const { autoHide: e14 } = this.props;
    e14 && this.hideTracks();
  }
  handleContainerResize() {
    this.update();
  }
  handleHorizontalTrackMouseDown(e14) {
    e14.preventDefault();
    const { target: t10, clientX: n10 } = e14;
    const { left: r10 } = t10.getBoundingClientRect();
    const o10 = this.getThumbHorizontalWidth();
    const a10 = Math.abs(r10 - n10) - o10 / 2;
    this.view.scrollLeft = this.getScrollLeftForOffset(a10);
  }
  handleVerticalTrackMouseDown(e14) {
    e14.preventDefault();
    const { target: t10, clientY: n10 } = e14;
    const { top: r10 } = t10.getBoundingClientRect();
    const o10 = this.getThumbVerticalHeight();
    const a10 = Math.abs(r10 - n10) - o10 / 2;
    this.view.scrollTop = this.getScrollTopForOffset(a10);
  }
  handleHorizontalThumbMouseDown(e14) {
    e14.preventDefault(), this.handleDragStart(e14);
    const { target: t10, clientX: n10 } = e14;
    const { offsetWidth: r10 } = t10;
    const { left: o10 } = t10.getBoundingClientRect();
    this.prevPageX = r10 - (n10 - o10);
  }
  handleVerticalThumbMouseDown(e14) {
    e14.preventDefault(), this.handleDragStart(e14);
    const { target: t10, clientY: n10 } = e14;
    const { offsetHeight: r10 } = t10;
    const { top: o10 } = t10.getBoundingClientRect();
    this.prevPageY = r10 - (n10 - o10);
  }
  setupDragging() {
    Np(document.body, iF), document.addEventListener("mousemove", this.handleDrag), document.addEventListener("mouseup", this.handleDragEnd), document.onselectstart = Qp;
  }
  teardownDragging() {
    Np(document.body, sF), document.removeEventListener("mousemove", this.handleDrag), document.removeEventListener("mouseup", this.handleDragEnd), document.onselectstart = void 0;
  }
  handleDragStart(e14) {
    this.dragging = true, this.draggedThumb = e14.target, this.draggedThumb.classList.add("is-dragged"), e14.stopImmediatePropagation(), this.setupDragging();
  }
  handleDrag(e14) {
    if (this.prevPageX) {
      const { clientX: t10 } = e14;
      const { left: n10 } = this.trackHorizontal.getBoundingClientRect();
      const r10 = -n10 + t10 - (this.getThumbHorizontalWidth() - this.prevPageX);
      this.view.scrollLeft = this.getScrollLeftForOffset(r10);
    }
    if (this.prevPageY) {
      const { clientY: t10 } = e14;
      const { top: n10 } = this.trackVertical.getBoundingClientRect();
      const r10 = -n10 + t10 - (this.getThumbVerticalHeight() - this.prevPageY);
      this.view.scrollTop = this.getScrollTopForOffset(r10);
    }
    return false;
  }
  handleDragEnd() {
    this.dragging = false, this.draggedThumb.classList.remove("is-dragged"), this.prevPageX = this.prevPageY = 0, this.teardownDragging(), this.handleDragEndAutoHide();
  }
  handleDragEndAutoHide() {
    const { autoHide: e14 } = this.props;
    e14 && this.hideTracks();
  }
  handleTrackMouseEnter() {
    this.trackMouseOver = true, this.handleTrackMouseEnterAutoHide();
  }
  handleTrackMouseEnterAutoHide() {
    const { autoHide: e14 } = this.props;
    e14 && this.showTracks();
  }
  handleTrackMouseLeave() {
    this.trackMouseOver = false, this.handleTrackMouseLeaveAutoHide();
  }
  handleTrackMouseLeaveAutoHide() {
    const { autoHide: e14 } = this.props;
    e14 && this.hideTracks();
  }
  showTracks() {
    clearTimeout(this.hideTracksTimeout), Np(this.trackHorizontal, { opacity: 1 }), Np(this.trackVertical, { opacity: 1 });
  }
  hideTracks() {
    if (this.dragging) return;
    if (this.scrolling) return;
    if (this.trackMouseOver) return;
    const { autoHideTimeout: e14 } = this.props;
    clearTimeout(this.hideTracksTimeout), this.hideTracksTimeout = setTimeout(() => {
      Np(this.trackHorizontal, { opacity: 0 }), Np(this.trackVertical, { opacity: 0 });
    }, e14);
  }
  detectScrolling() {
    this.scrolling || (this.scrolling = true, this.handleScrollStart(), this.detectScrollingInterval = setInterval(() => {
      this.lastViewScrollLeft === this.viewScrollLeft && this.lastViewScrollTop === this.viewScrollTop && (clearInterval(this.detectScrollingInterval), this.scrolling = false, this.handleScrollStop()), this.lastViewScrollLeft = this.viewScrollLeft, this.lastViewScrollTop = this.viewScrollTop;
    }, 100));
  }
  raf(e14) {
    this.requestFrame && YE.cancel(this.requestFrame), this.requestFrame = YE(() => {
      this.requestFrame = void 0, e14();
    });
  }
  update(e14) {
    this.raf(() => this._update(e14));
  }
  _update(e14) {
    const { onUpdate: t10, hideTracksWhenNotNeeded: n10 } = this.props;
    const r10 = this.getValues();
    if (Mp()) {
      const { scrollLeft: e15, clientWidth: t11, scrollWidth: o10 } = r10;
      const a10 = Ep(this.trackHorizontal);
      const i10 = this.getThumbHorizontalWidth();
      const s10 = { width: i10, transform: `translateX(${e15 / (o10 - t11) * (a10 - i10)}px)` };
      const { scrollTop: l10, clientHeight: c10, scrollHeight: u10 } = r10;
      const d10 = Tp(this.trackVertical);
      const p10 = this.getThumbVerticalHeight();
      const m10 = { height: p10, transform: `translateY(${l10 / (u10 - c10) * (d10 - p10)}px)` };
      if (n10) {
        const e16 = { visibility: o10 > t11 ? "visible" : "hidden" };
        const n11 = { visibility: u10 > c10 ? "visible" : "hidden" };
        Np(this.trackHorizontal, e16), Np(this.trackVertical, n11);
      }
      Np(this.thumbHorizontal, s10), Np(this.thumbVertical, m10);
    }
    t10 && t10(r10), "function" == typeof e14 && e14(r10);
  }
  render() {
    const e14 = Mp();
    const _a2 = this.props, { onScroll: t10, onScrollFrame: n10, onScrollStart: r10, onScrollStop: o10, onUpdate: a10, renderView: i10, renderTrackHorizontal: s10, renderTrackVertical: l10, renderThumbHorizontal: c10, renderThumbVertical: u10, tagName: d10, hideTracksWhenNotNeeded: p10, autoHide: m10, autoHideTimeout: h10, autoHideDuration: f10, thumbSize: g10, thumbMinSize: y10, universal: v10, autoHeight: b10, autoHeightMin: S10, autoHeightMax: C10, style: x10, containerClassName: w10, children: T10 } = _a2, E10 = __objRest(_a2, ["onScroll", "onScrollFrame", "onScrollStart", "onScrollStop", "onUpdate", "renderView", "renderTrackHorizontal", "renderTrackVertical", "renderThumbHorizontal", "renderThumbVertical", "tagName", "hideTracksWhenNotNeeded", "autoHide", "autoHideTimeout", "autoHideDuration", "thumbSize", "thumbMinSize", "universal", "autoHeight", "autoHeightMin", "autoHeightMax", "style", "containerClassName", "children"]);
    const { didMountUniversal: F10 } = this.state;
    const M10 = __spreadValues(__spreadValues(__spreadValues({}, XE), b10 && __spreadProps(__spreadValues({}, JE), { minHeight: S10, maxHeight: C10 })), x10);
    const k10 = __spreadValues(__spreadValues(__spreadValues(__spreadProps(__spreadValues({}, QE), { marginRight: e14 ? -e14 : 0, marginBottom: e14 ? -e14 : 0 }), b10 && __spreadProps(__spreadValues({}, eF), { minHeight: Yp(S10) ? `calc(${S10} + ${e14}px)` : S10 + e14, maxHeight: Yp(C10) ? `calc(${C10} + ${e14}px)` : C10 + e14 })), b10 && v10 && !F10 && { minHeight: S10, maxHeight: C10 }), v10 && !F10 && tF);
    const P10 = { transition: `opacity ${f10}ms`, opacity: 0 };
    const N10 = __spreadValues(__spreadValues(__spreadValues({}, nF), m10 && P10), (!e14 || v10 && !F10) && { display: "none" });
    const D10 = __spreadValues(__spreadValues(__spreadValues({}, rF), m10 && P10), (!e14 || v10 && !F10) && { display: "none" });
    return i10 && s10 && c10 && l10 && u10 ? ep.createElement(d10, __spreadProps(__spreadValues({}, E10), { className: w10, style: M10, ref: (e15) => {
      this.container = e15;
    } }), [ep.cloneElement(i10({ style: k10 }), { key: "view", ref: (e15) => {
      this.view = e15;
    } }, T10), ep.cloneElement(s10({ style: N10 }), { key: "trackHorizontal", ref: (e15) => {
      this.trackHorizontal = e15;
    } }, ep.cloneElement(c10({ style: oF }), { ref: (e15) => {
      this.thumbHorizontal = e15;
    } })), ep.cloneElement(l10({ style: D10 }), { key: "trackVertical", ref: (e15) => {
      this.trackVertical = e15;
    } }, ep.cloneElement(u10({ style: aF }), { ref: (e15) => {
      this.thumbVertical = e15;
    } }))]) : null;
  }
}
lF.defaultProps = { renderView: function(e14) {
  return ep.createElement("div", __spreadValues({}, e14));
}, renderTrackHorizontal: function(_e2) {
  var _f2 = _e2, { style: e14 } = _f2, t10 = __objRest(_f2, ["style"]);
  const n10 = __spreadProps(__spreadValues({}, e14), { right: 2, bottom: 2, left: 2, borderRadius: 3 });
  return ep.createElement("div", __spreadValues({ style: n10 }, t10));
}, renderTrackVertical: function(_g2) {
  var _h2 = _g2, { style: e14 } = _h2, t10 = __objRest(_h2, ["style"]);
  const n10 = __spreadProps(__spreadValues({}, e14), { right: 2, bottom: 2, top: 2, borderRadius: 3 });
  return ep.createElement("div", __spreadValues({ style: n10 }, t10));
}, renderThumbHorizontal: function(_i2) {
  var _j2 = _i2, { style: e14 } = _j2, t10 = __objRest(_j2, ["style"]);
  const n10 = __spreadProps(__spreadValues({}, e14), { cursor: "pointer", borderRadius: "inherit", backgroundColor: KE });
  return ep.createElement("div", __spreadValues({ style: n10 }, t10));
}, renderThumbVertical: function(_k2) {
  var _l2 = _k2, { style: e14 } = _l2, t10 = __objRest(_l2, ["style"]);
  const n10 = __spreadProps(__spreadValues({}, e14), { cursor: "pointer", borderRadius: "inherit", backgroundColor: KE });
  return ep.createElement("div", __spreadValues({ style: n10 }, t10));
}, tagName: "div", hideTracksWhenNotNeeded: false, autoHide: false, autoHideTimeout: 1e3, autoHideDuration: 200, thumbMinSize: 30, universal: false, autoHeight: false, autoHeightMin: 0, autoHeightMax: 200 };
const [cF, uF, dF] = Dp("gc-scrollbars");
const [pF, mF] = dF("view");
const [hF, fF] = dF("track");
const [gF, yF] = dF("thumb");
const vF = () => ep.createElement("div", null);
class bF extends ep.Component {
  constructor() {
    super(...arguments), this._baseRef = null, this.getBaseRef = () => this._baseRef;
  }
  render() {
    const _a2 = this.props, { direction: e14, customCSS: t10, color: n10, autoHide: r10, style: o10, size: a10, growOnHover: i10, viewCustomCSS: s10 } = _a2, l10 = __objRest(_a2, ["direction", "customCSS", "color", "autoHide", "style", "size", "growOnHover", "viewCustomCSS"]);
    const c10 = kp(cF, t10, { [uF("contrast")]: "contrast" === n10, [uF("no-hide")]: !r10, [uF("size-sm")]: "small" === a10, [uF("no-grow")]: !i10 });
    const u10 = kp(pF, s10, { [mF(e14)]: "both" !== e14 });
    const d10 = (e15, t11) => (_a3) => {
      var _b2 = _a3, { style: n11 } = _b2, r11 = __objRest(_b2, ["style"]);
      const o11 = `${hF} ${fF(e15)}`;
      return ep.createElement("div", __spreadProps(__spreadValues({}, r11), { className: o11, style: __spreadValues(__spreadValues({}, n11), t11) }));
    };
    const p10 = (e15, t11) => (_a3) => {
      var _b2 = _a3, { style: n11 } = _b2, r11 = __objRest(_b2, ["style"]);
      const o11 = `${gF} ${yF(e15)}`;
      return ep.createElement("div", __spreadProps(__spreadValues({}, r11), { className: o11, style: __spreadValues(__spreadValues({}, n11), t11) }));
    };
    const m10 = __spreadProps(__spreadValues({}, l10), { style: o10.container, containerClassName: c10, renderView: (_b2) => {
      var _c2 = _b2, { style: e15 } = _c2, t11 = __objRest(_c2, ["style"]);
      return ep.createElement("div", __spreadProps(__spreadValues({}, t11), { className: u10, style: __spreadValues(__spreadValues({}, e15), o10.view) }));
    }, renderTrackVertical: "horizontal" === e14 ? vF : d10("vertical", o10.trackVertical), renderThumbVertical: "horizontal" === e14 ? vF : p10("vertical", o10.thumbVertical), renderTrackHorizontal: "vertical" === e14 ? vF : d10("horizontal", o10.trackHorizontal), renderThumbHorizontal: "vertical" === e14 ? vF : p10("horizontal", o10.thumbHorizontal) });
    return ep.createElement(lF, __spreadValues({ ref: (e15) => this._baseRef = e15 }, m10));
  }
}
bF.defaultProps = { direction: "both", style: {}, growOnHover: true, autoHide: true, color: "default", size: "default" };
const SF = (e14) => e14.stopPropagation();
const CF = { onTouchStart: SF, onTouchEnd: SF, onMouseDown: SF, onClick: SF };
const xF = (e14) => e14 && "type" in e14 && "group" === e14.type || false;
const [wF, TF, EF] = Dp("gc-dd-menu");
const [FF] = EF("scroll");
const [MF] = EF("header");
const [kF] = EF("divider");
const [PF] = EF("group");
const [NF] = EF("group-icon");
const [DF, LF] = EF("group-dd");
const [HF, IF] = EF("item");
const [_F] = EF("item-preview");
class VF extends ep.Component {
  constructor(e14) {
    super(e14), this.contentRef = null, this.observer = null, this.observer = new MutationObserver(() => this.props.forseUpdateScrollContainer());
  }
  componentDidMount() {
    var _a2, _b2, _c2;
    ((_a2 = this.contentRef) == null ? void 0 : _a2.firstChild) && ((_c2 = this.observer) == null ? void 0 : _c2.observe((_b2 = this.contentRef) == null ? void 0 : _b2.firstChild, { childList: true, subtree: true }));
  }
  componentWillUnmount() {
    var _a2;
    (_a2 = this.observer) == null ? void 0 : _a2.disconnect();
  }
  render() {
    const { content: e14 } = this.props;
    return ep.createElement("div", { ref: (e15) => this.contentRef = e15 }, e14);
  }
}
class RF extends ep.Component {
  constructor(e14, t10) {
    super(e14), this._menu = null, this._positioner = null, this._scrollContainer = null, this._itemsCollection = {}, this._intersectionObserver = null, this._lowestIntersectedItemIndex = 0, this.state = { focusedItemId: null, expandGroupDropDownItemId: null, inTransitionDropDownId: null, itemsRenderCountLimit: 100, isFocused: true }, this.debounce = (e15, t11) => {
      this._debounceTimer && clearTimeout(this._debounceTimer), this._debounceTimer = setTimeout(e15, t11);
    }, this.onKeyDown = (e15) => {
      var _a2, _b2, _c2, _d2, _e2;
      const { props: { items: t11 }, state: { focusedItemId: n10 }, _itemsCollection: r10 } = this;
      if ("ArrowDown" === e15.key && (SF(e15), this.focusNextItem()), "ArrowUp" === e15.key && (SF(e15), this.focusPrevItem()), "Enter" === e15.key) {
        SF(e15), e15.preventDefault();
        const o10 = t11 == null ? void 0 : t11[Number(n10)];
        xF(o10) ? this.onToggleGroupItem(Number(n10), true) : n10 && ((_a2 = r10[n10].node) == null ? void 0 : _a2.click());
      }
      if ("ArrowRight" === e15.key) {
        SF(e15);
        const r11 = t11 == null ? void 0 : t11[Number(n10)];
        xF(r11) && this.onToggleGroupItem(Number(n10), true);
      }
      "ArrowLeft" === e15.key && (SF(e15), (_c2 = (_b2 = this.props).leaveGroup) == null ? void 0 : _c2.call(_b2)), "Escape" === e15.key && (SF(e15), (_e2 = (_d2 = this.props).backButtonCallbacks) == null ? void 0 : _e2.call(_d2));
    }, this.onIntersection = (e15) => {
      var _a2, _b2, _c2;
      for (const t12 of e15) if (t12.isIntersecting) {
        const e16 = Number((_a2 = t12.target.dataset.ddIndex) != null ? _a2 : 0);
        e16 > this._lowestIntersectedItemIndex && (this._lowestIntersectedItemIndex = e16);
      }
      this.unobserveMenuItems();
      const t11 = Math.min(this._lowestIntersectedItemIndex + 100, (_c2 = (_b2 = this.props.items) == null ? void 0 : _b2.length) != null ? _c2 : 0);
      t11 !== this.state.itemsRenderCountLimit && this.setState({ itemsRenderCountLimit: t11 });
    }, this.prepareMenuItemsDomElementsList = () => {
      var _a2, _b2;
      return Array.from((_b2 = (_a2 = this._menu) == null ? void 0 : _a2.querySelectorAll(`.${pF} > *`)) != null ? _b2 : []).map((e15, t11) => (e15.hasAttribute("data-dd-index") || e15.setAttribute("data-dd-index", `${t11}`), e15));
    }, this.observeMenuItems = () => {
      var _a2;
      const e15 = this.prepareMenuItemsDomElementsList().slice(this._lowestIntersectedItemIndex);
      for (const t11 of e15) (_a2 = this._intersectionObserver) == null ? void 0 : _a2.observe(t11);
    }, this.unobserveMenuItems = () => {
      var _a2;
      const e15 = this.prepareMenuItemsDomElementsList().slice(0, this._lowestIntersectedItemIndex + 1);
      for (const t11 of e15) (_a2 = this._intersectionObserver) == null ? void 0 : _a2.unobserve(t11);
    }, this.onToggleGroupItem = (e15, t11) => {
      t11 && this.state.expandGroupDropDownItemId !== e15 ? (this._menu && window.removeEventListener("keydown", this.onKeyDown, true), this._debounceTimer && clearTimeout(this._debounceTimer), this.setState(__spreadProps(__spreadValues({}, this.state), { expandGroupDropDownItemId: e15, inTransitionDropDownId: null }))) : t11 || this.state.expandGroupDropDownItemId !== e15 || (this._menu && window.addEventListener("keydown", this.onKeyDown, true), this.debounce(() => this.setState(__spreadProps(__spreadValues({}, this.state), { expandGroupDropDownItemId: null, inTransitionDropDownId: e15 })), 700));
    }, this.setEndTransition = (e15) => {
      this.state.inTransitionDropDownId === e15 && null === this.state.expandGroupDropDownItemId && this.setState(__spreadProps(__spreadValues({}, this.state), { inTransitionDropDownId: null }));
    }, this.getRoot = ({ root: e15, API: t11 }) => {
      const n10 = e15.getElement();
      const r10 = `${t11.namespace}-dropdown-root`;
      const o10 = document.getElementById(r10);
      if (o10) return o10;
      const a10 = t11.current.dropdowns.menuRootSelector;
      const i10 = nm(r10, "dropdown");
      return (a10 && a10() || n10).appendChild(i10);
    }, this.storeItems = (e15, t11, n10) => {
      this._itemsCollection[n10] = { node: e15, item: t11 };
    }, this.resetFocusedItem = () => {
      null !== this.state.focusedItemId && this.setState({ focusedItemId: null });
    }, this.getFocusedItemId = () => this.state.focusedItemId, this.updatePosition = () => {
      this._positioner && this._positioner.updatePosition();
    }, this.focusNextItem = () => {
      const e15 = Object.keys(this._itemsCollection);
      if (!e15.length) return;
      const { focusedItemId: t11 } = this.state;
      let n10 = null;
      const r10 = () => {
        const o10 = e15[e15.length - 1];
        if (null === n10 && null === t11) n10 = e15[0];
        else {
          if (t11 === o10 || n10 === o10) return n10 = t11;
          n10 = e15[e15.indexOf(n10 || t11) + 1];
        }
        const a10 = this._itemsCollection[n10].node;
        a10 && !a10.hasAttribute("disabled") || r10();
      };
      r10(), n10 !== t11 && this.setState({ focusedItemId: n10 }, () => {
        this._itemsCollection[this.state.focusedItemId].node.scrollIntoView({ block: "nearest" });
      });
    }, this.focusPrevItem = () => {
      const { focusedItemId: e15 } = this.state;
      const t11 = Object.keys(this._itemsCollection);
      if (!e15 || !t11.length) return;
      let n10 = null;
      const r10 = () => {
        if (e15 === t11[0] || n10 === t11[0]) return n10 = e15;
        n10 = t11[t11.indexOf(n10 || e15) - 1];
        const o10 = this._itemsCollection[n10].node;
        o10 && !o10.hasAttribute("disabled") || r10();
      };
      r10(), n10 !== e15 && this.setState({ focusedItemId: n10 }, () => {
        this._itemsCollection[this.state.focusedItemId].node.scrollIntoView({ block: "nearest" });
      });
    }, this.selectFocusedItem = () => {
      const { state: { focusedItemId: e15 }, props: { onItemClick: t11 }, _itemsCollection: n10 } = this;
      e15 && t11 && n10[e15] && t11(n10[e15].item);
    }, this.getMenuNode = () => this._menu, this.getPositionerNode = () => {
      var _a2;
      return (_a2 = this._positioner) == null ? void 0 : _a2.getNode();
    }, this.onItemClick = (e15) => () => {
      const { onItemClick: t11 } = this.props;
      t11 && t11(e15);
    }, this.generatePreview = (e15) => {
      const { generateItemPreview: t11, multiselect: n10, size: r10 } = this.props;
      if (n10) {
        const t12 = { value: "", size: r10, checked: e15.selected || false, tabIndex: -1 };
        return ep.createElement(CE, __spreadValues({}, t12));
      }
      return t11 && t11(e15.value, e15.selected);
    }, this.getMenuRect = () => {
      const { props: { width: e15, maxHeight: t11, parent: n10 }, context: { root: r10 } } = this;
      const o10 = r10.getElement();
      let a10 = 200;
      "default" !== e15 && ("100%" === e15 ? a10 = "element" === n10.type ? n10.element.clientWidth : o10.clientWidth : "auto" === e15 ? a10 = void 0 : isNaN(e15) || (a10 = e15));
      let i10 = `${Math.min(window.innerHeight, o10.clientHeight)}px`;
      return "none" !== t11 && ("default" === t11 ? i10 = 255 : Number.isNaN(Number(t11)) || (i10 = `${t11}px`)), { width: a10, maxHeight: i10 };
    }, this.getMenuAlign = () => `${this.props.dropup ? "top" : "bottom"}-${this.props.align}`, this.forseUpdateScrollContainer = () => {
      var _a2;
      (_a2 = this._scrollContainer) == null ? void 0 : _a2.forceUpdate();
    }, this.renderContent = () => {
      const { props: { items: e15, content: t11, size: n10, customButtonRenderer: r10, onItemClick: o10 }, state: { focusedItemId: a10, itemsRenderCountLimit: i10 } } = this;
      if (e15 && e15.length > 0) {
        const t12 = Math.min(i10, e15.length);
        return e15.slice(0, t12).map((e16, t13) => {
          var _a2, _b2, _c2;
          if (!e16) return null;
          switch (e16.type) {
            case "custom":
              return e16.customContent;
            case "header": {
              const n11 = { headingLevel: "span", text: e16.header, align: "center", textSize: "default", uppercase: false, customCSS: MF };
              return ep.createElement(LE, __spreadProps(__spreadValues({}, n11), { key: `dd-item-${t13}` }));
            }
            case "splitter":
              return ep.createElement("div", { key: `dd-item-${t13}`, className: kF });
            case "button": {
              const o11 = this.generatePreview(e16);
              const i11 = kp(HF, { [IF("selected")]: e16.selected, [IF("focused")]: a10 === `${t13}`, [IF("disabled")]: e16.disabled, [IF("with-preview")]: o11, [Up]: "small" === n10, [qp]: "large" === n10 });
              const s10 = { key: e16.key || (e16.value ? `${em(e16.value)}-${t13}` : `dd-item-${t13}`), className: i11, title: e16.title || e16.text, disabled: e16.disabled, onClick: this.onItemClick(e16), tabIndex: -1, role: "option", "aria-selected": !!e16.selected || void 0, "data-selected": !!e16.selected || void 0, id: ((_a2 = e16.key) == null ? void 0 : _a2.toString()) || (e16.value ? `${em(e16.value)}-${t13}` : `dd-item-${t13}`) };
              return r10 ? ep.createElement("button", __spreadProps(__spreadValues({}, s10), { ref: (n11) => this.storeItems(n11, e16, t13) }), r10(e16)) : ep.createElement("button", __spreadProps(__spreadValues({}, s10), { ref: (n11) => this.storeItems(n11, e16, t13) }), o11 && ep.createElement("div", { className: _F }, o11), e16.icon && ep.createElement(Fm, { icon: e16.icon }), e16.text && ep.createElement("span", null, e16.text));
            }
            case "group": {
              if (!e16.items) return null;
              const i11 = !e16.disabled && e16.items.findIndex((e17) => e17 && ("custom" === e17.type || ("button" === e17.type || "group" === e17.type) && !e17.disabled)) >= 0;
              const s10 = nf(oh, { rotate: "270" });
              const l10 = kp(HF, PF, { [IF("selected")]: e16.selected, [IF("focused")]: a10 === `${t13}`, [IF("disabled")]: !i11, [Up]: "small" === n10, [qp]: "large" === n10 });
              const c10 = { key: e16.key, className: l10, title: e16.title || e16.text, disabled: !i11, tabIndex: -1, role: "option", "aria-selected": !!e16.selected || void 0, "data-selected": !!e16.selected || void 0, onClick: (t14) => {
                var _a3;
                SF(t14), (_a3 = e16.onClick) == null ? void 0 : _a3.call(e16, e16.value);
              }, onMouseDown: SF, onMouseEnter: () => this.onToggleGroupItem(t13, true), onMouseLeave: () => this.onToggleGroupItem(t13, false), id: ((_b2 = e16.key) == null ? void 0 : _b2.toString()) || (e16.value ? `${em(e16.value)}-${t13}` : `dd-item-${t13}`) };
              const u10 = this._itemsCollection[t13] && this.state.expandGroupDropDownItemId === t13;
              const d10 = null !== this.state.expandGroupDropDownItemId && this.state.expandGroupDropDownItemId !== t13;
              const p10 = { items: e16.items, align: "left", dropOnSide: true, size: n10, offset: 0, dataAid: `${e16.text}_menu`, customCSS: kp(DF, e16.menuCustomCSS, { [LF("hidden")]: !u10 || d10, [LF("transition")]: this.state.inTransitionDropDownId === t13 }), parent: { type: "element", element: ((_c2 = this._itemsCollection[t13]) == null ? void 0 : _c2.node) || null }, onTransitionEnd: () => {
                this.state.isFocused && this._debounceTimer && clearTimeout(this._debounceTimer), u10 || this.setEndTransition(t13);
              }, customButtonRenderer: r10, onItemClick: o10, leaveGroup: () => this.onToggleGroupItem(t13, false) };
              return ep.createElement("div", __spreadProps(__spreadValues({}, c10), { ref: (n11) => this.storeItems(n11, e16, t13) }), e16.icon && ep.createElement(Fm, { icon: e16.icon }), e16.text && ep.createElement("span", null, e16.text), ep.createElement(Fm, { icon: s10, customCSS: NF }), i11 && u10 && ep.createElement(RF, __spreadValues({}, p10)));
            }
          }
        });
      }
      return ep.createElement(VF, { content: t11, forseUpdateScrollContainer: this.forseUpdateScrollContainer });
    }, this._root = this.getRoot(t10);
  }
  componentDidMount() {
    const { scrollToSelection: e14, items: t10 } = this.props;
    if (this._menu && window.addEventListener("keydown", this.onKeyDown, true), e14 && t10 && this._scrollContainer) {
      const e15 = this._scrollContainer.view.querySelector("[data-selected]");
      e15 && e15.offsetTop && setTimeout(() => {
        if (!this._scrollContainer) return;
        const t11 = this._scrollContainer.getClientHeight();
        const n10 = e15.clientHeight;
        this._scrollContainer.scrollTop(e15.offsetTop - t11 / 2 + n10 / 2);
      }, 10);
    }
    t10 && (t10 == null ? void 0 : t10.length) > 100 && (this._intersectionObserver = new IntersectionObserver(this.onIntersection, { root: this._menu, threshold: 0.05 }), this.observeMenuItems());
  }
  componentWillUnmount() {
    var _a2;
    window.removeEventListener("keydown", this.onKeyDown, true), (_a2 = this._intersectionObserver) == null ? void 0 : _a2.disconnect(), this._debounceTimer && clearTimeout(this._debounceTimer);
  }
  componentDidUpdate(e14) {
    e14.items && this.props.items && e14.items.length !== this.props.items.length && this.resetFocusedItem(), this.observeMenuItems();
  }
  render() {
    const { props: { content: e14, align: t10, dropup: n10, dropOnSide: r10, offset: o10, parent: a10, customScroll: i10, customCSS: s10, dataAid: l10, multiselect: c10, edgeSnapOffset: u10, ariaRole: d10, ariaLabel: p10, ariaLabelledBy: m10, onTransitionEnd: h10, id: f10 } } = this;
    const g10 = kp(wF, s10, { [TF("multiselect")]: c10, [TF(`align-${t10}`)]: "right" !== t10, [TF("dropup")]: n10, [TF("drop-on-side")]: r10, [TF("custom")]: e14 });
    const { width: y10, maxHeight: v10 } = this.getMenuRect();
    const b10 = { autoHeight: true, autoHeightMax: v10, customCSS: FF, direction: "vertical", style: { view: { maxHeight: v10 } } };
    const S10 = { edgeSnapOffset: u10, parent: a10, align: this.getMenuAlign(), offset: true === o10 ? 4 : o10, flippable: true, onSide: r10 };
    const C10 = __spreadValues({ className: g10, style: { width: y10 }, role: d10, "aria-label": p10, "aria-labelledby": m10, onTransitionEnd: h10, id: f10, onMouseEnter: () => {
      this.setState((e15) => __spreadProps(__spreadValues({}, e15), { isFocused: true }));
    }, onMouseLeave: () => {
      this.setState((e15) => __spreadProps(__spreadValues({}, e15), { isFocused: false }));
    } }, CF);
    return mE.createPortal(ep.createElement(_E, __spreadProps(__spreadValues({}, S10), { ref: (e15) => this._positioner = e15 }), ep.createElement("div", __spreadProps(__spreadValues({}, C10), { ref: (e15) => this._menu = e15, "data-aid": l10, "aria-multiselectable": c10 }), i10 ? this.renderContent() : ep.createElement(bF, __spreadValues({ ref: (e15) => this._scrollContainer = e15 && e15.getBaseRef() }, b10), this.renderContent()))), this._root);
  }
}
RF.contextType = Sm, RF.defaultProps = { edgeSnapOffset: 0, offset: true, align: "right", dropup: false, dropOnSide: false, maxHeight: "none", multiselect: false, scrollToSelection: false, size: "default", width: "default", customScroll: false, ariaRole: "listbox" };
class AF {
  constructor(e14) {
    this._activeDropdown = null, this.onPointerEvent = (e15) => {
      const { _activeDropdown: t10 } = this;
      if (!t10) return;
      const n10 = t10.getNode();
      if (!n10 || n10 === e15.target || n10.contains(e15.target)) return;
      const r10 = t10.getSafeZone();
      if (r10 && (r10 === e15.target || r10.contains(e15.target))) return;
      const o10 = t10.getMenuNode();
      o10 && o10.contains(e15.target) || (t10.close(), this._activeDropdown = null);
    }, this.open = (e15) => {
      const { _activeDropdown: t10 } = this;
      t10 && t10.close(), this._activeDropdown = e15;
    }, this.cleanup = () => {
      this._activeDropdown = null;
    }, e14.addEventListener("mousedown", this.onPointerEvent), e14.addEventListener("touchstart", this.onPointerEvent);
  }
  set menuRootSelector(e14) {
    this._menuRootSelector = e14;
  }
  get menuRootSelector() {
    return this._menuRootSelector;
  }
  get current() {
    return this._activeDropdown;
  }
}
const [OF, BF, zF] = Dp("gc-dd");
const [$F, WF] = zF("chevron");
const [jF] = zF("toggle-content");
const [ZF] = zF("preview");
const GF = { chevron: { small: nf(oh), default: nf(oh), large: nf(oh) } };
class UF extends ep.Component {
  constructor() {
    super(...arguments), this._dropdown = null, this._menu = null, this.state = { open: false }, this.getNode = () => this._dropdown, this.getSafeZone = () => {
      var _a2, _b2;
      return ((_b2 = (_a2 = this.props).safeZone) == null ? void 0 : _b2.call(_a2)) || null;
    }, this.getMenuNode = () => {
      var _a2;
      return (_a2 = this._menu) == null ? void 0 : _a2.getMenuNode();
    }, this.getPositionerNode = () => {
      var _a2;
      return (_a2 = this._menu) == null ? void 0 : _a2.getPositionerNode();
    }, this.updateMenuPosition = () => {
      var _a2;
      return (_a2 = this._menu) == null ? void 0 : _a2.updatePosition();
    }, this.open = () => {
      const { props: { disabled: e14, onToggle: t10 }, context: { API: n10 } } = this;
      e14 || (n10.current.dropdowns.open(this), this.setState({ open: true }), t10 == null ? void 0 : t10(true));
    }, this.close = () => {
      const { onToggle: e14 } = this.props;
      e14 == null ? void 0 : e14(false), this.setState({ open: false });
    }, this.onToggleClick = (e14) => {
      e14.preventDefault(), e14.stopPropagation(), this.state.open ? this.close() : this.open();
    }, this.onItemClick = (e14) => {
      const { onSelect: t10, noCloseOnSelect: n10, multiselect: r10 } = this.props;
      e14.onClick ? e14.onClick(e14.value) : t10 && t10(e14.value), n10 || r10 || this.close();
    }, this.onNavSelect = () => {
      var _a2;
      return (_a2 = this._menu) == null ? void 0 : _a2.selectFocusedItem();
    }, this.getFocusedItemId = () => this._menu ? this._menu.getFocusedItemId() : null;
  }
  componentDidMount() {
    const { API: e14, root: t10 } = this.context;
    e14.current.dropdowns || (e14.current.dropdowns = new AF(t10));
  }
  componentDidUpdate() {
    var _a2;
    this.state.open && ((_a2 = this._menu) == null ? void 0 : _a2.updatePosition());
  }
  componentWillUnmount() {
    var _a2;
    const { API: e14 } = this.context;
    ((_a2 = e14.current.dropdowns) == null ? void 0 : _a2.current) === this && e14.current.dropdowns.cleanup();
  }
  render() {
    var _a2;
    const { items: e14, content: t10, hiddenChevron: n10, offset: r10, menuAlign: o10, menuWidth: a10, dropup: i10, dropOnSide: s10, dataAid: l10, id: c10, block: u10, accent: d10, background: p10, rounded: m10, size: h10, width: f10, icon: g10, menuMaxHeight: y10, edgeSnapOffset: v10, text: b10, loading: S10, textAlign: C10, title: x10, disabled: w10, toggleContent: T10, generatePreview: E10, scrollToSelection: F10, generateItemPreview: M10, menuCustomCSS: k10, invalid: P10, customCSS: N10, level: D10, multiselect: L10, itemSize: H10, placeholderText: I10, customScroll: _10, chevronIcon: V10, customButtonRenderer: R10, ariaRole: A10, ariaLabel: O10, ariaLabelledBy: B10, menuAriaRole: z10, menuAriaLabel: $10, menuAriaLabelledBy: W10 } = this.props;
    const { open: j10 } = this.state;
    const Z10 = E10 == null ? void 0 : E10();
    const G10 = kp(OF, N10, { [BF("block")]: u10, [BF("chevron")]: !n10, [BF("menu-open")]: j10, [BF("disabled")]: w10, [BF("invalid")]: P10, [BF("with-preview")]: Z10, [BF("placeholder-text")]: I10, [Gp]: m10, [Up]: "small" === h10, [qp]: "large" === h10 });
    const U10 = f10 && { width: f10 } || void 0;
    const q10 = e14 == null ? void 0 : e14.findIndex((e15) => e15 && ("button" === e15.type || "group" === e15.type) && e15.selected);
    const Y10 = void 0 !== q10 && e14 && e14[q10];
    const K10 = { id: c10 ? `${c10}_toggle` : void 0, dataAid: l10 ? `${l10}_toggle` : void 0, block: true, accent: d10, background: p10, rounded: m10, size: h10, icon: g10, text: b10, textAlign: C10, title: x10, disabled: w10, level: D10, ariaRole: A10, ariaLabel: O10, ariaLabelledBy: B10, loading: S10, ariaHasPopup: "listbox", ariaExpanded: j10, onClick: this.onToggleClick, onDoubleClick: (e15) => e15.stopPropagation(), ariaControls: c10 ? `${c10}_menu` : void 0, ariaActivedescendant: Y10 ? ((_a2 = Y10.key) == null ? void 0 : _a2.toString()) || (Y10.value ? `${em(Y10.value)}-${q10}` : `dd-item-${q10}`) : void 0 };
    const X10 = kp($F, { [WF("accent-full")]: "full" === d10, [WF("custom")]: V10, [Zp]: "text+icon" === d10, [Up]: "small" === h10, [qp]: "large" === h10 });
    const J10 = { parent: { type: "element", element: this._dropdown }, dataAid: l10 ? `${l10}_menu` : void 0, content: t10, items: e14, align: o10, width: a10, dropup: i10, dropOnSide: s10, offset: r10, edgeSnapOffset: v10, maxHeight: y10, ariaRole: z10, ariaLabel: $10, ariaLabelledBy: W10, onItemClick: this.onItemClick, scrollToSelection: F10, generateItemPreview: M10, multiselect: L10, customCSS: k10, customScroll: _10, customButtonRenderer: R10, size: H10 || h10, id: c10 ? `${c10}_menu` : void 0, backButtonCallbacks: this.close };
    return ep.createElement("div", { id: c10, "data-aid": l10, className: G10, style: U10, ref: (e15) => this._dropdown = e15 }, ep.createElement(qm, __spreadValues({}, K10), T10 && ep.createElement("div", { className: jF }, T10)), Z10 && ep.createElement("div", { className: ZF }, Z10), !n10 && ep.createElement(Fm, { icon: V10 || GF.chevron[h10], customCSS: X10 }), j10 && ep.createElement(RF, __spreadValues({ ref: (e15) => this._menu = e15 }, J10)));
  }
}
UF.contextType = Sm, UF.defaultProps = { accent: "none", background: "default", block: false, disabled: false, dropup: false, dropOnSide: false, edgeSnapOffset: 0, hiddenChevron: false, invalid: false, level: "info", menuAlign: "right", menuMaxHeight: "none", menuWidth: "default", multiselect: false, noCloseOnSelect: false, offset: true, rounded: false, scrollToSelection: false, size: "default", textAlign: "left" };
const [qF, YF] = Dp("gc-input");
class KF extends ep.Component {
  constructor() {
    super(...arguments), this._input = null, this.onFocus = (e14) => {
      const { selectOnFocus: t10, onFocus: n10 } = this.props;
      t10 && e14.target.select(), n10 && n10(e14);
    }, this.select = () => {
      this._input && this._input.select();
    }, this.focus = () => {
      this._input && this._input.focus();
    }, this.getNode = () => this._input;
  }
  render() {
    const { id: e14, name: t10, block: n10, rounded: r10, size: o10, width: a10, textAlign: i10, invalid: s10, type: l10, placeholder: c10, defaultValue: u10, value: d10, title: p10, disabled: m10, autoFocus: h10, spellCheck: f10, dataAid: g10, customCSS: y10, ariaLabel: v10, ariaLabelledBy: b10, onClick: S10, onChange: C10, onBlur: x10, onKeyDown: w10, onKeyUp: T10, onKeyPress: E10 } = this.props;
    const F10 = { id: e14, name: t10, type: l10, className: kp(qF, y10, { [YF("block")]: n10, [YF(`text-align-${i10}`)]: "left" !== i10, [YF("invalid")]: s10, [Gp]: r10, [Up]: "small" === o10, [qp]: "large" === o10 }), style: a10 && { width: a10 } || void 0, placeholder: u10 || d10 ? void 0 : c10, defaultValue: u10, value: d10, title: p10, disabled: m10, autoFocus: h10, spellCheck: f10, onClick: S10, onChange: C10, onBlur: x10, onKeyDown: w10, onKeyUp: T10, onKeyPress: E10, onFocus: this.onFocus, "aria-label": v10, "aria-labelledby": b10 };
    return ep.createElement("input", __spreadProps(__spreadValues({}, F10), { "data-aid": g10, ref: (e15) => this._input = e15 }));
  }
}
KF.defaultProps = { autoFocus: false, block: false, disabled: false, invalid: false, rounded: false, selectOnFocus: false, size: "default", spellCheck: false, textAlign: "left", type: "text" };
const [XF, JF, QF] = Dp("gc-combo");
const [eM] = QF("preview");
class tM extends ep.Component {
  constructor() {
    super(...arguments), this._input = null, this._dropdown = null, this._dropdownIsOpen = false, this.state = { searchQuery: null, menuWidth: void 0, focused: false }, this.onChange = (e14) => {
      const { onChange: t10, filterOnInput: n10 } = this.props;
      n10 && this.setState({ searchQuery: e14.target.value }), t10 && t10(e14);
    }, this.onSelect = (e14) => {
      const { onSelect: t10 } = this.props;
      const { searchQuery: n10 } = this.state;
      null !== n10 && this.setState({ searchQuery: null }), t10 && t10(e14);
    }, this.onClick = () => {
      const { openOnFocus: e14 } = this.props;
      e14 && !this._dropdownIsOpen && this._dropdown && this._dropdown.open();
    }, this.onFocus = () => {
      this.setState({ focused: true }, () => {
        this._input && this._input.select(), this.onClick();
      });
    }, this.onBlur = (e14) => {
      this.setState({ focused: false }), this.props.onBlur && this.props.onBlur(e14);
    }, this.setMenuWidth = () => {
      const { menuWidth: e14 } = this.props;
      if ("100%" !== e14) return;
      const t10 = this._input && this._input.getNode();
      if (!t10) return;
      const n10 = t10.offsetWidth;
      n10 !== this.state.menuWidth && this.setState({ menuWidth: n10 });
    }, this.onToggle = (e14) => {
      const { state: { searchQuery: t10 }, props: { onToggle: n10 } } = this;
      this._dropdownIsOpen = e14, n10 && n10(e14), e14 ? this._input && (this._input.focus(), this.setMenuWidth()) : null !== t10 && this.setState({ searchQuery: null });
    }, this.getSafeZone = () => this._input && this._input.getNode(), this.focusInput = () => this._input && this._input.focus(), this.onKeyDown = (e14) => {
      const { onKeyDown: t10 } = this.props;
      const { _dropdown: n10 } = this;
      if (!n10) return;
      e14.stopPropagation();
      null !== n10.getFocusedItemId() || t10 && t10(e14);
    }, this.defaultFilter = (e14, t10) => t10.filter((t11) => t11 && t11.text && -1 !== t11.text.toLowerCase().indexOf(e14.toLowerCase())), this.filterItems = () => {
      const { props: { items: e14, customFilter: t10 }, state: { searchQuery: n10 } } = this;
      const r10 = t10 || this.defaultFilter;
      return n10 && e14 ? r10(n10, e14) : e14;
    };
  }
  render() {
    const { props: { id: e14, size: t10, width: n10, rounded: r10, disabled: o10, block: a10, multiselect: i10, customScroll: s10, dropup: l10, noCloseOnSelect: c10, items: u10, menuMaxHeight: d10, itemSize: p10, scrollToSelection: m10, inputType: h10, value: f10, name: g10, invalid: y10, dataAid: v10, filterOnInput: b10, edgeSnapOffset: S10, generatePreview: C10, placeholder: x10, content: w10, menuWidth: T10, generateItemPreview: E10, menuCustomCSS: F10, displayValue: M10, customCSS: k10, chevronIcon: P10, titleToggle: N10, toggleContent: D10, customButtonRenderer: L10 }, state: { searchQuery: H10, menuWidth: I10, focused: _10 } } = this;
    const V10 = n10 && { width: n10 } || void 0;
    const R10 = { name: g10, size: t10, invalid: y10, rounded: r10, disabled: o10, placeholder: i10 && f10 || x10, dataAid: v10 ? `${v10}_input` : void 0, value: null !== H10 ? H10 : i10 ? "" : !_10 && M10 || f10, title: M10 || f10 || x10, type: h10, selectOnFocus: true, onClick: this.onClick, onFocus: this.onFocus, onBlur: this.onBlur, onChange: this.onChange, onKeyDown: this.onKeyDown, onKeyUp: (e15) => e15.stopPropagation(), onKeyPress: (e15) => e15.stopPropagation() };
    const A10 = { size: t10, rounded: r10, dropup: l10, menuMaxHeight: d10, content: w10, disabled: o10, noCloseOnSelect: c10, multiselect: i10, itemSize: p10, dataAid: v10 ? `${v10}_dropdown` : void 0, items: b10 ? this.filterItems() : u10, title: N10, toggleContent: D10, hiddenChevron: void 0 !== D10 || void 0, onToggle: this.onToggle, safeZone: this.getSafeZone, onSelect: this.onSelect, generateItemPreview: E10, menuCustomCSS: F10, edgeSnapOffset: S10, customButtonRenderer: L10, menuWidth: "100%" !== T10 ? T10 : I10, scrollToSelection: m10, customScroll: s10, chevronIcon: P10 };
    const O10 = C10 && C10(f10);
    const B10 = kp(XF, k10, { [JF("block")]: a10, [JF("disabled")]: o10, [JF("rounded")]: r10, [JF("with-preview")]: O10, [JF("focused-input")]: _10, [JF("value-placeholder")]: i10 && f10, [Up]: "small" === t10, [qp]: "large" === t10 });
    return ep.createElement("div", { className: B10, id: e14, "data-aid": v10, style: V10 }, ep.createElement(KF, __spreadProps(__spreadValues({}, R10), { ref: (e15) => this._input = e15 })), ep.createElement(UF, __spreadProps(__spreadValues({}, A10), { ref: (e15) => this._dropdown = e15 })), O10 && ep.createElement("div", { className: eM }, O10));
  }
}
tM.defaultProps = { menuWidth: "100%", block: false, disabled: false, dropup: false, edgeSnapOffset: 0, filterOnInput: false, inputType: "text", invalid: false, menuMaxHeight: "none", multiselect: false, noCloseOnSelect: false, openOnFocus: true, rounded: false, scrollToSelection: false, size: "default" };
const [nM, rM, oM] = Dp("gc-btn-group");
const [aM, iM] = oM("splitter");
const sM = (e14) => {
  const { align: t10 = "left", defaultAccent: n10 = "none", defaultBackground: r10 = "default", defaultLevel: o10 = "info", disabled: a10 = false, rounded: i10 = false, size: s10 = "default", withHeader: l10 = false, withSplitters: c10 = false, id: u10, block: d10, customCSS: p10, dataAid: m10, items: h10 } = e14;
  const f10 = h10.filter((e15) => e15);
  if (!f10.length) return null;
  const g10 = l10 && f10.length > 1;
  let y10;
  var v10;
  g10 && (y10 = "full" === ((v10 = f10[0]).accent || n10) ? v10.level || o10 : "default");
  const b10 = kp(nM, p10, { [rM(`header-${y10}`)]: g10, [rM(`align-${t10}`)]: "left" !== t10, [rM("block")]: d10, [rM("disabled")]: a10, [Gp]: i10, [Up]: "small" === s10, [qp]: "large" === s10 });
  return ep.createElement("div", { id: u10, "data-aid": m10, className: b10 }, ((e15) => {
    let u11;
    return c10 && (u11 = kp(aM, { [iM("accent-full")]: "full" === n10, [iM(`accent-${o10}`)]: "none" !== n10 && "full" !== n10, [iM("background-transparent")]: "transparent" === r10 })), e15.reduce((e16, d11, p11) => {
      c10 && (l10 ? p11 > 1 : p11 > 0) && e16.push(ep.createElement("div", { key: `splitter-${p11}`, className: u11 }));
      const m11 = d11.key || p11;
      if ("button" === d11.type) {
        const l11 = __spreadValues({ rounded: i10, size: s10, disabled: a10, block: true, accent: n10, background: r10, level: o10, textAlign: "justify" === t10 ? "center" : "left" }, d11);
        e16.push(ep.createElement(qm, __spreadValues({ key: m11 }, l11), d11.customContent));
      }
      if ("dropdown" === d11.type) {
        const l11 = __spreadValues({ rounded: i10, size: s10, disabled: a10, block: true, accent: n10, background: r10, level: o10, textAlign: "justify" === t10 ? "center" : "left" }, d11);
        e16.push(ep.createElement(UF, __spreadValues({ key: m11 }, l11)));
      }
      if ("combobox" === d11.type) {
        const t11 = __spreadProps(__spreadValues({}, d11), { block: true, rounded: i10, size: s10, disabled: a10 });
        e16.push(ep.createElement(tM, __spreadValues({ key: m11 }, t11)));
      }
      if ("input" === d11.type) {
        const t11 = __spreadProps(__spreadValues({}, d11), { block: true, rounded: i10, size: s10, disabled: a10, type: d11.inputType });
        e16.push(ep.createElement(KF, __spreadValues({ key: m11 }, t11)));
      }
      return e16;
    }, []);
  })(f10));
};
const [lM, cM, uM] = Dp("gc-radio");
const [dM] = uM("input");
const [pM] = uM("mark");
const mM = (e14) => {
  const { block: t10 = false, disabled: n10 = false, invalid: r10 = false, size: o10 = "default", textAlign: a10 = "right", checked: i10, customCSS: s10, dataAid: l10, defaultChecked: c10, id: u10, name: d10, text: p10, title: m10, value: h10, ariaLabel: f10, ariaLabelledBy: g10, ariaRole: y10 } = e14;
  const v10 = kp(lM, s10, { [cM("block")]: t10, [cM("invalid")]: r10, [cM("disabled")]: n10, [cM("align-left")]: "left" === a10, [Up]: "small" === o10, [qp]: "large" === o10 });
  const b10 = { type: "radio", checked: i10, id: u10, name: d10, value: h10, disabled: n10, defaultChecked: c10, onChange: () => {
    const { onChange: t11 } = e14;
    t11 == null ? void 0 : t11(h10);
  }, role: y10, "aria-label": f10, "aria-labelledby": g10 };
  return ep.createElement("label", { className: v10, title: m10 || p10, "data-aid": l10 }, ep.createElement("input", __spreadProps(__spreadValues({}, b10), { className: dM, "data-aid": l10 && `${l10}_input` })), ep.createElement("span", { className: pM }), p10);
};
const [hM, fM, gM] = Dp("gc-toggle");
const [yM, vM] = gM("input");
const [bM] = gM("mark");
const SM = (e14) => {
  const { block: t10 = false, disabled: n10 = false, indeterminate: r10 = false, invalid: o10 = false, size: a10 = "default", textAlign: i10 = "right", checked: s10, customCSS: l10, dataAid: c10, defaultChecked: u10, id: d10, name: p10, onToggle: m10, text: h10, title: f10, value: g10 } = e14;
  const y10 = kp(hM, l10, { [fM("block")]: t10, [fM("disabled")]: n10, [fM("align-left")]: "left" === i10, [fM("invalid")]: o10, [Up]: "small" === a10, [qp]: "large" === a10 });
  const v10 = kp(yM, { [vM("indeterminate")]: r10 });
  const b10 = { type: "checkbox", checked: s10, defaultChecked: u10, id: d10, name: p10, value: g10, disabled: n10, onChange: m10 };
  return ep.createElement("label", { className: y10, title: f10, "data-aid": c10 }, ep.createElement("input", __spreadProps(__spreadValues({}, b10), { className: v10, "data-aid": c10 && `${c10}_input` })), ep.createElement("div", { className: bM }), h10);
};
const [CM, xM, wM] = Dp("gc-toolbar");
const [TM, EM] = wM("content");
const [FM] = wM("content-container");
const [MM, kM] = wM("item-container");
const [PM] = wM("splitter");
const NM = (e14) => {
  const { block: t10 = false, toggleAccent: n10 = "none", toggleBackground: r10 = "default", rounded: o10 = false, size: a10 = "default", padding: i10 = false, dropup: s10 = false, overflowVisible: l10 = false, customCSS: c10, id: u10, children: d10, dataAid: p10, ariaLabel: m10, toggleTitle: h10, onToggle: f10 } = e14;
  const [g10, y10] = ep.useState(false);
  const [v10, b10] = ep.useState(false);
  const { root: S10 } = ep.useContext(Sm);
  const C10 = ep.useRef(null);
  const x10 = ep.useRef(null);
  const w10 = rf(vh, { rotate: "90" });
  const T10 = rf(Wh, { rotate: "90" });
  const E10 = ep.useRef(new ResizeObserver((e15) => {
    if (e15[0] && e15[1]) {
      const { height: t11 } = e15[0].contentRect;
      const { height: n11 } = e15[1].contentRect;
      b10(n11 > t11), y10(false);
    }
  }));
  ep.useLayoutEffect(() => {
    C10.current && x10.current && b10(x10.current.clientHeight > C10.current.clientHeight);
  }, [d10]), ep.useLayoutEffect(() => (C10.current && x10.current && (E10.current.observe(C10.current), E10.current.observe(x10.current)), () => E10.current.disconnect()), []), ep.useEffect(() => () => {
    S10.removeEventListener("mousedown", F10), S10.removeEventListener("touchstart", F10);
  }, [g10]);
  const F10 = (e15) => {
    var _a2;
    e15.target === C10.current || ((_a2 = C10.current) == null ? void 0 : _a2.contains(e15.target)) || (y10(false), f10 && f10("collapsed"));
  };
  const M10 = ep.useCallback(() => {
    y10(!g10), f10 && f10(g10 ? "collapsed" : "expanded"), g10 || (S10.addEventListener("mousedown", F10), S10.addEventListener("touchstart", F10));
  }, [g10, F10]);
  const k10 = ep.useCallback((e15, t11, n11) => {
    const r11 = kp(MM, { [kM("padding")]: n11 });
    return tp.Children.map(e15, (e16, n12) => {
      const o11 = { key: `container_${n12}`, id: `${t11}_Item_${n12}`, className: r11 };
      return e16 && tp.createElement("div", __spreadValues({}, o11), e16);
    });
  }, [d10, u10, i10]);
  const P10 = ep.useMemo(() => k10(d10, u10, i10), [d10, u10, i10, k10]);
  const N10 = kp(CM, c10, { [xM("block")]: t10, [xM("no-wrap")]: l10, [xM("with-toggle")]: v10, [xM("rounded")]: o10, [xM("expanded")]: g10, [xM("dropup")]: s10, [Up]: "small" === a10, [qp]: "large" === a10 });
  const D10 = kp(TM, { [EM("padding")]: i10 });
  const L10 = { dataAid: p10 ? `${p10}_toggle` : void 0, size: a10, rounded: o10, accent: n10, background: r10, icon: "small" === a10 ? w10 : T10, title: h10, onClick: M10 };
  return tp.createElement("div", { className: N10, ref: C10, "data-aid": p10, role: "navigation", "aria-label": m10 || "toolbar" }, tp.createElement("div", { className: FM }, tp.createElement("div", { className: D10, ref: x10 }, P10)), v10 && tp.createElement(qm, __spreadValues({}, L10)));
};
const DM = () => tp.createElement("div", { className: PM });
const [LM, HM] = Dp("gc-tabs");
class IM extends ep.Component {
  constructor() {
    super(...arguments), this.onTabClick = (e14) => () => {
      const { onTabSelect: t10 } = this.props;
      t10 && t10(e14);
    };
  }
  render() {
    const { id: e14, block: t10, tabs: n10, customCSS: r10, dataAid: o10, design: a10, rounded: i10, align: s10, size: l10, splitter: c10, selectedTabId: u10 } = this.props;
    const d10 = kp(LM, r10, { [HM("block")]: t10, [HM("simplified")]: "simplified" === a10, [HM("transparent")]: "transparent" === a10 });
    const p10 = "simplified" === a10 ? "text+icon" : "full";
    const m10 = "transparent" !== a10 ? "none" : "full";
    const h10 = { id: e14 ? `${e14}_group` : void 0, block: t10, rounded: i10, align: s10, size: l10, defaultAccent: m10, defaultBackground: "default" === a10 ? "default" : "transparent", withSplitters: c10, items: n10.map((e15) => ({ type: "button", dataAid: o10 ? `${o10}_tab_${e15.id}` : void 0, icon: e15.icon, text: e15.text, title: e15.title, badge: e15.badge, disabled: e15.disabled, accent: e15.id === u10 ? p10 : m10, onClick: this.onTabClick(e15.id), customCSS: e15.id === u10 ? "selected" : void 0 })) };
    return ep.createElement("div", { id: e14, "data-aid": o10, className: d10 }, ep.createElement(sM, __spreadValues({}, h10)));
  }
}
IM.defaultProps = { align: "left", block: false, design: "default", rounded: false, size: "default", splitter: false };
const [_M, VM, RM] = Dp("gc-appbar");
const [AM, OM] = RM("badge");
const [BM] = RM("logo-container");
const [zM] = RM("main-section");
const [$M] = RM("title-section");
const [WM] = RM("title");
const [jM] = RM("subtitle");
const [ZM] = RM("control-section");
const GM = (e14) => {
  const { legacyMode: t10 = false, rounded: n10 = false, size: r10 = "default", badge: o10, controlItems: a10, customCSS: i10, dataAid: s10, id: l10, mainItems: c10, menuItems: u10, selectedMenuItemId: d10, subtitle: p10, title: m10 } = e14;
  const h10 = (e15, o11) => {
    if (!e15) return;
    const a11 = `appbar-item-${o11}`;
    if ("splitter" === e15.type) return ep.createElement(DM, { key: a11 });
    if ("button" === e15.type) {
      const o12 = { block: true, accent: t10 ? "full" : "text+icon", background: t10 ? "default" : "transparent", size: t10 ? "large" : r10, rounded: n10 };
      return ep.createElement(qm, __spreadValues(__spreadValues({ key: a11 }, e15), o12));
    }
    if ("dropdown" === e15.type) {
      const o12 = { block: true, accent: t10 ? "full" : "text+icon", background: t10 ? "default" : "transparent", size: t10 ? "large" : r10, rounded: n10 };
      return ep.createElement(UF, __spreadValues(__spreadValues({ key: a11 }, e15), o12));
    }
    if ("group" === e15.type) {
      const o12 = { block: true, defaultAccent: t10 ? "full" : "text+icon", defaultBackground: t10 ? "default" : "transparent", size: t10 ? "large" : r10, rounded: n10 };
      return ep.createElement(sM, __spreadValues(__spreadValues({ key: a11 }, e15), o12));
    }
  };
  const f10 = (e15) => ({ id: e15.id, text: e15.text, title: e15.title, disabled: e15.disabled });
  const g10 = (t11) => {
    const { onMenuItemSelect: n11 } = e14;
    n11 && n11(t11);
  };
  const y10 = kp(_M, i10, { [Up]: !t10 && "small" === r10, [qp]: t10 || "large" === r10, [VM("legacy")]: t10 });
  const v10 = c10 && c10.map(h10);
  const b10 = a10 && a10.map(h10);
  let S10;
  if (u10) {
    const e15 = { dataAid: s10 ? `${s10}_tabs` : void 0, design: t10 ? "transparent" : "simplified", align: "left", tabs: u10.map(f10), size: t10 ? "large" : r10, rounded: n10, block: true, selectedTabId: d10, onTabSelect: g10 };
    S10 = ep.createElement(IM, __spreadValues({}, e15));
  }
  const C10 = { block: true, toggleBackground: "transparent", toggleAccent: "icon", padding: true, rounded: n10, size: t10 ? "large" : r10, overflowVisible: true };
  let x10;
  return o10 && (x10 = kp(AM, { [OM("accent")]: "accent" === o10.type, [OM("error")]: "error" === o10.type, [OM("warning")]: "warning" === o10.type, [OM("clickable")]: o10.onClick })), ep.createElement("div", { id: `appbar_${l10}`, "data-aid": s10, className: y10 }, ep.createElement("div", { id: `appbar_${l10}_logo_container`, className: BM }), ep.createElement("div", { className: zM }, ep.createElement(NM, __spreadValues({ id: `appbar_${l10}_main`, dataAid: s10 && `${s10}_main-section` }, C10), v10, v10 && S10 && ep.createElement(DM, null), S10)), ep.createElement("div", { className: $M }, m10 && ep.createElement("span", { className: WM }, m10), p10 && ep.createElement("span", { className: jM }, `* ${p10} *`), o10 && ep.createElement("span", { className: x10, title: o10.title || o10.text, onClick: o10.onClick }, o10.text)), ep.createElement("div", { className: ZM }, ep.createElement(NM, __spreadValues({ id: `appbar_${l10}_control`, dataAid: s10 && `${s10}_control-section` }, C10), b10)));
};
const [UM, qM, YM] = Dp("gc-menu-panel");
const [KM] = YM("placeholder");
class XM extends ep.Component {
  constructor() {
    super(...arguments), this.displayName = "MenuPanel";
  }
  render() {
    const { children: e14, customCSS: t10, customScroll: n10, dataAid: r10, toggle: { text: o10 } } = this.props;
    const a10 = kp(UM, t10, { [qM("fill-container")]: n10 });
    return ep.createElement("div", { className: a10, "data-aid": r10, role: "region", "aria-label": o10 }, e14);
  }
}
XM.defaultProps = { chevronIcon: nf(oh, { rotate: "270" }), customScroll: false, disabled: false, hideChevron: false }, om.set(XM, "MenuPanel");
const JM = ({ text: e14 }) => ep.createElement("div", { className: KM }, e14);
const [QM, ek, tk] = Dp("gc-modal");
const [nk, rk] = Dp("gc-modal-overlay");
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */
const ok = /input|select|textarea|button|object/;
const ak = (e14) => {
  const t10 = e14.offsetWidth <= 0 && e14.offsetHeight <= 0;
  if (t10 && !e14.innerHTML) return true;
  const n10 = window.getComputedStyle(e14);
  return t10 ? "visible" !== n10.getPropertyValue("overflow") : "none" == n10.getPropertyValue("display");
};
function ik(e14, t10) {
  const n10 = e14.nodeName.toLowerCase();
  return (ok.test(n10) && !e14.disabled || "a" === n10 && e14.href || t10) && function(e15) {
    let t11 = e15;
    for (; t11 && t11 !== document.body; ) {
      if (ak(t11)) return false;
      t11 = t11.parentNode;
    }
    return true;
  }(e14);
}
function sk(e14) {
  let t10 = e14.getAttribute("tabindex");
  null === t10 && (t10 = void 0);
  const n10 = isNaN(t10);
  return (n10 || t10 >= 0) && ik(e14, !n10);
}
function lk(e14) {
  return [].slice.call(e14.querySelectorAll("*"), 0).filter(sk);
}
const ck = [];
let uk = null;
let dk = false;
function pk() {
  dk = true;
}
function mk() {
  if (dk) {
    if (dk = false, !uk) return;
    setTimeout(() => {
      if (uk.contains(document.activeElement)) return;
      (lk(uk)[0] || uk).focus();
    }, 0);
  }
}
const [, hk] = tk("body");
const fk = hk("open");
const gk = ep.forwardRef((e14, t10) => {
  const { open: n10, onClose: r10, dataAid: o10, children: a10, style: i10 = { overlay: {}, content: {} }, shouldCloseOnOverlayClick: s10 = true, shouldCloseOnEsc: l10 = true, closeTimeoutMS: c10 = 0, customCSS: u10 = "", overlayCustomCSS: d10 = "", withDefaultStyles: p10 = false } = e14;
  const { API: m10, root: h10 } = ep.useContext(Sm);
  const [f10, g10] = ep.useState();
  const [y10, v10] = ep.useState(false);
  const [b10, S10] = ep.useState(false);
  const [C10, x10] = ep.useState(false);
  const [w10, T10] = ep.useState(null);
  const E10 = ep.useRef(null);
  const F10 = ep.useRef(null);
  const M10 = ep.useRef(null);
  const k10 = ep.useRef();
  ep.useEffect(() => {
    g10(N10());
  }, []), ep.useEffect(() => (n10 && !y10 ? L10() : !n10 && y10 && H10(), () => {
    D10(), clearTimeout(k10.current);
  }), [n10]), ep.useEffect(() => {
    y10 ? (I10(), S10(true)) : M10.current && D10();
  }, [y10]), ep.useEffect(() => {
    C10 && w10 && (k10.current = window.setTimeout(V10, w10 - Date.now()));
  }, [C10, w10]);
  const P10 = ep.useCallback((e15) => {
    F10.current = e15, "function" == typeof t10 ? t10(e15) : t10 && (t10.current = e15);
  }, []);
  const N10 = () => {
    const e15 = `${m10.namespace}-modal-root`;
    const t11 = document.getElementById(e15);
    if (t11) return t11;
    const n11 = nm(e15, "modal");
    return h10.getElement().appendChild(n11);
  };
  const D10 = () => {
    const e15 = h10.getElement();
    setTimeout(() => fk && e15.classList.remove(fk), 0), function() {
      let e16 = null;
      try {
        return void (0 !== ck.length && (e16 = ck.pop(), e16.focus()));
      } catch (t11) {
        console.warn(["You tried to return focus to", e16, "but it is not in the DOM anymore"].join(" "));
      }
    }(), uk = null, "function" == typeof window.addEventListener ? (window.removeEventListener("blur", pk), document.removeEventListener("focus", mk)) : (window.detachEvent("onBlur", pk), document.detachEvent("onFocus", mk));
  };
  const L10 = () => {
    (() => {
      const e15 = h10.getElement();
      fk && e15.classList.add(fk);
    })(), b10 && C10 ? (clearTimeout(k10.current), x10(false)) : (ck.push(document.activeElement), v10(true));
  };
  const H10 = () => {
    c10 > 0 ? _10() : V10();
  };
  const I10 = () => F10.current && !R10() && F10.current.focus();
  const _10 = () => {
    const e15 = Date.now() + c10;
    x10(true), T10(e15), x10(true);
  };
  const V10 = () => {
    x10(false), v10(false), S10(false), T10(null);
  };
  const R10 = () => {
    var _a2;
    return document.activeElement === F10.current || ((_a2 = F10.current) == null ? void 0 : _a2.contains(document.activeElement));
  };
  const A10 = (e15, t11, n11) => kp(e15, n11, { [t11("before-close")]: C10, [t11("default")]: p10 });
  if (!y10 && !C10) return null;
  const O10 = { style: __spreadValues({}, i10.overlay), onClick: () => {
    null === M10.current && (M10.current = true), M10.current && s10 && (r10 ? r10() : I10()), M10.current = null;
  }, onMouseDown: (e15) => {
    s10 || e15.target != E10.current || e15.preventDefault();
  }, className: A10(nk, rk, d10) };
  const B10 = { style: __spreadValues({}, i10.content), className: A10(QM, ek, u10), tabIndex: -1, role: "dialog", onKeyDown: (e15) => {
    e15.stopPropagation(), "Tab" === e15.key && F10.current && function(e16, t11) {
      const n11 = lk(e16);
      if (!n11.length) return void t11.preventDefault();
      const { shiftKey: r11 } = t11;
      const o11 = n11[0];
      const a11 = n11[n11.length - 1];
      let i11;
      if (e16 === document.activeElement) {
        if (!r11) return;
        i11 = a11;
      }
      if (a11 !== document.activeElement || r11 || (i11 = o11), o11 === document.activeElement && r11 && (i11 = a11), i11) return t11.preventDefault(), void i11.focus();
      const s11 = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
      if (null == s11 || "Chrome" === s11[1] || null != /\biPod\b|\biPad\b/g.exec(navigator.userAgent)) return;
      let l11 = document.activeElement ? n11.indexOf(document.activeElement) : -1;
      if (l11 > -1 && (l11 += r11 ? -1 : 1), void 0 === n11[l11]) return t11.preventDefault(), i11 = r11 ? a11 : o11, void i11.focus();
      t11.preventDefault(), n11[l11].focus();
    }(F10.current, e15), l10 && "Escape" === e15.key && r10();
  }, onMouseDown: () => {
    M10.current = false;
  }, onMouseUp: () => {
    M10.current = false;
  }, onClick: () => {
    M10.current = false;
  } };
  return f10 ? hE.createPortal(tp.createElement("div", __spreadProps(__spreadValues({}, O10), { ref: E10, "data-aid": o10 && `${o10}_overlay` }), tp.createElement("div", __spreadProps(__spreadValues({}, B10), { ref: P10, "data-aid": o10 }), a10)), f10) : null;
});
gk.displayName = "Modal";
const yk = (e14) => ep.createElement(gk, __spreadValues({}, e14), e14.children);
const vk = (e14 = true, t10, n10) => {
  const r10 = ep.useRef(null);
  const o10 = ep.useRef(null);
  const a10 = ep.useRef({ currentX: 0, currentY: 0 });
  const i10 = ep.useRef();
  const { root: s10 } = ep.useContext(Sm);
  const l10 = (e15) => {
    i10.current = { grabX: e15.pageX, grabY: e15.pageY }, window.addEventListener("pointermove", c10), window.addEventListener("pointerup", d10), document.body.classList.add("gc-disable-selection");
  };
  const c10 = (e15) => {
    if (o10.current && i10.current) {
      const { currentX: t11, currentY: n11 } = a10.current;
      const { grabX: r11, grabY: s11 } = i10.current;
      const l11 = t11 + (e15.pageX - r11);
      const c11 = n11 + (e15.pageY - s11);
      const { constrainedX: d11, constrainedY: p11 } = u10({ x: l11, y: c11 }, o10.current);
      o10.current.style.left = `${d11}px`, o10.current.style.top = `${p11}px`;
    }
  };
  const u10 = ({ x: e15, y: t11 }, n11) => {
    const r11 = s10.getElement();
    const o11 = r11.clientWidth - n11.offsetWidth;
    const a11 = r11.clientHeight - n11.offsetHeight;
    let i11 = e15;
    let l11 = t11;
    return e15 < 0 && (i11 = 0), e15 > o11 && (i11 = o11), t11 < 0 && (l11 = 0), t11 > a11 && (l11 = a11), { constrainedX: i11, constrainedY: l11 };
  };
  const d10 = () => {
    var _a2, _b2;
    a10.current = { currentX: parseInt(((_a2 = o10.current) == null ? void 0 : _a2.style.left) || "0"), currentY: parseInt(((_b2 = o10.current) == null ? void 0 : _b2.style.top) || "0") }, window.removeEventListener("pointermove", c10), window.removeEventListener("pointerup", d10), document.body.classList.remove("gc-disable-selection"), n10 && n10(p10());
  };
  const p10 = () => ({ top: a10.current.currentY, left: a10.current.currentX });
  const m10 = () => {
    const e15 = s10.getElement();
    if (o10.current) {
      const t11 = o10.current.offsetWidth;
      const n11 = o10.current.offsetHeight;
      const r11 = { top: a10.current.currentY, left: a10.current.currentX };
      e15.clientWidth <= t11 + r11.left && (r11.left = e15.clientWidth - t11), e15.clientHeight <= n11 + r11.top && (r11.top = e15.clientHeight - n11);
      const { constrainedX: i11, constrainedY: s11 } = u10({ x: r11.left, y: r11.top }, o10.current);
      ((e16, t12) => {
        const { left: n12, top: r12 } = t12;
        e16.style.left = `${n12}px`, e16.style.top = `${r12}px`, a10.current = { currentX: n12, currentY: r12 };
      })(o10.current, { left: i11, top: s11 });
    }
  };
  const h10 = (e15) => {
    e15.style.left = "", e15.style.top = "";
    const { offsetTop: t11, offsetLeft: n11 } = e15;
    a10.current = { currentX: n11, currentY: t11 };
  };
  const f10 = (e15, t11) => {
    var _a2, _b2;
    const n11 = (_a2 = t11 == null ? void 0 : t11.top) != null ? _a2 : e15.offsetTop;
    const r11 = (_b2 = t11 == null ? void 0 : t11.left) != null ? _b2 : e15.offsetLeft;
    e15.style.left = `${r11}px`, e15.style.top = `${n11}px`, a10.current = { currentX: r11, currentY: n11 };
  };
  ep.useEffect(() => {
    o10.current && (e14 ? f10(o10.current) : h10(o10.current));
  }, [e14]);
  const g10 = ep.useCallback((t11) => {
    var n11;
    r10.current && !t11 && ((n11 = r10.current).removeEventListener("pointerdown", l10), n11.style.cursor = "", window.removeEventListener("resize", m10)), t11 && e14 && ((e15) => {
      e15.addEventListener("pointerdown", l10), e15.style.cursor = "move", window.addEventListener("resize", m10);
    })(t11), r10.current = t11;
  }, [e14]);
  const y10 = ep.useCallback((n11) => {
    o10.current && h10(o10.current), n11 && e14 && f10(n11, t10), o10.current = n11;
  }, [e14]);
  return { moveHandleRef: g10, modalRef: y10 };
};
const bk = (e14 = true, t10 = 0, n10 = 0, r10, o10) => {
  const a10 = ep.useRef(null);
  const i10 = ep.useRef(null);
  const s10 = ep.useRef({ currentWidth: 0, currentHeight: 0 });
  const l10 = ep.useRef();
  const { root: c10 } = ep.useContext(Sm);
  const u10 = ep.useRef(t10);
  const d10 = ep.useRef(n10);
  const p10 = ep.useRef();
  const m10 = ep.useRef();
  ep.useEffect(() => {
    u10.current = t10, d10.current = n10;
  }, [t10, n10]);
  const h10 = (e15) => {
    l10.current = { grabX: e15.pageX, grabY: e15.pageY }, window.addEventListener("pointermove", f10), window.addEventListener("pointerup", y10), document.body.classList.add("gc-disable-selection"), document.body.style.cursor = "nwse-resize";
  };
  const f10 = (e15) => {
    if (i10.current && l10.current && s10.current) {
      const { currentWidth: t11, currentHeight: n11 } = s10.current;
      const { grabX: r11, grabY: o11 } = l10.current;
      const a11 = t11 + (e15.pageX - r11);
      const c11 = n11 + (e15.pageY - o11);
      const { constrainedWidth: u11, constrainedHeight: d11 } = g10({ width: a11, height: c11 }, i10.current);
      i10.current.style.width = `${u11}px`, i10.current.style.height = `${d11}px`;
    }
  };
  const g10 = ({ width: e15, height: t11 }, n11) => {
    const r11 = c10.getElement();
    const o11 = r11.clientWidth - n11.offsetLeft;
    const a11 = r11.clientHeight - n11.offsetTop;
    const i11 = u10.current;
    const s11 = d10.current;
    let l11 = e15;
    let p11 = t11;
    return e15 < i11 && (l11 = i11), e15 > o11 && (l11 = o11), t11 < s11 && (p11 = s11), t11 > a11 && (p11 = a11), { constrainedWidth: l11, constrainedHeight: p11 };
  };
  const y10 = () => {
    var _a2, _b2;
    s10.current = { currentWidth: parseInt(((_a2 = i10.current) == null ? void 0 : _a2.style.width) || "0"), currentHeight: parseInt(((_b2 = i10.current) == null ? void 0 : _b2.style.height) || "0") }, window.removeEventListener("pointermove", f10), window.removeEventListener("pointerup", y10), document.body.classList.remove("gc-disable-selection"), document.body.style.cursor = "", o10 && o10(v10());
  };
  const v10 = () => {
    var _a2, _b2;
    return { width: (_a2 = s10.current) == null ? void 0 : _a2.currentWidth, height: (_b2 = s10.current) == null ? void 0 : _b2.currentHeight };
  };
  const b10 = (e15) => {
    e15.style.width = p10.current ? `${p10.current}px` : "", e15.style.height = m10.current ? `${m10.current}px` : "";
    const { offsetWidth: t11, offsetHeight: n11 } = e15;
    s10.current = { currentWidth: t11, currentHeight: n11 };
  };
  const S10 = (e15, r11) => {
    var _a2, _b2;
    const o11 = (_a2 = r11 == null ? void 0 : r11.width) != null ? _a2 : e15.offsetWidth;
    const a11 = (_b2 = r11 == null ? void 0 : r11.height) != null ? _b2 : e15.offsetHeight;
    e15.style.width = `${o11}px`, e15.style.height = `${a11}px`, p10.current = o11, m10.current = a11, u10.current = t10 || o11, d10.current = n10 || a11, s10.current = { currentWidth: o11, currentHeight: a11 };
  };
  ep.useEffect(() => {
    i10.current && (e14 ? S10(i10.current) : b10(i10.current));
  }, [e14]);
  const C10 = ep.useCallback((t11) => {
    a10.current && !t11 && ((e15) => {
      e15.removeEventListener("pointerdown", h10), e15.style.cursor = "";
    })(a10.current), t11 && e14 && ((e15) => {
      e15.addEventListener("pointerdown", h10), e15.style.cursor = "nwse-resize";
    })(t11), a10.current = t11;
  }, [e14]);
  const x10 = ep.useCallback((t11) => {
    i10.current && b10(i10.current), t11 && e14 && S10(t11, r10), i10.current = t11;
  }, []);
  return { resizeHandleRef: C10, modalRef: x10 };
};
const [Sk, Ck] = tk("header");
const [xk] = tk("content");
const [wk, Tk] = tk("footer");
const [Ek] = tk("right-control");
const [Fk] = tk("close-btn");
const [Mk] = tk("icon");
const [kk] = tk("title-box");
const [Pk] = tk("title");
const [Nk] = tk("subtitle");
const [Dk] = tk("resize-handle");
const [Lk] = tk("resize-handle-wrapper");
const Hk = (e14) => {
  const { closeTimeoutMS: t10 = 0, hideCloseButton: n10 = false, level: r10 = "info", rounded: o10 = false, shouldCloseOnEsc: a10 = true, shouldCloseOnOverlayClick: i10 = true, titleAlign: s10 = "left", style: l10 = { content: {}, overlay: {} }, canResize: c10 = false, customScroll: u10 = false, open: d10, icon: p10, title: m10, customCSS: h10, onClose: f10, subtitle: g10, onOpen: y10, dataAid: v10, overlayCustomCSS: b10, controls: S10, contentMaxHeight: C10, minWidth: x10, minHeight: w10, position: T10, onUpdatePosition: E10, size: F10, onUpdateSize: M10, children: k10 } = e14;
  const { root: P10 } = ep.useContext(Sm);
  const N10 = rf(Zh);
  const { moveHandleRef: D10, resizeHandleRef: L10, modalRef: H10 } = ((e15) => {
    const { canResize: t11 = false, minWidth: n11 = 0, minHeight: r11 = 0, position: o11, size: a11, onUpdatePosition: i11, onUpdateSize: s11 } = e15;
    const { moveHandleRef: l11, modalRef: c11 } = vk(true, o11, i11);
    const { resizeHandleRef: u11, modalRef: d11 } = bk(t11, n11, r11, a11, s11);
    return { moveHandleRef: l11, resizeHandleRef: u11, modalRef: (e16) => {
      c11(e16), d11(e16);
    } };
  })({ canResize: c10, minWidth: x10, minHeight: w10, position: T10, size: F10, onUpdatePosition: E10, onUpdateSize: M10 });
  const I10 = kp(h10, { [ek(`level-${r10}`)]: "info" !== r10, [ek("with-icon")]: p10, [Gp]: o10 });
  const _10 = kp(Sk, { [Ck("centered-title")]: "center" === s10 });
  const V10 = kp(wk, { [Tk(`align-${S10.align}`)]: S10.align && "right" !== S10.align });
  const R10 = { style: l10, open: d10, onClose: f10, onOpen: y10, closeTimeoutMS: t10, dataAid: v10, shouldCloseOnOverlayClick: i10, shouldCloseOnEsc: a10, customCSS: I10, overlayCustomCSS: b10, withDefaultStyles: true };
  const A10 = { dataAid: v10 ? `${v10}_close-button` : void 0, rounded: o10, onClick: f10, customCSS: Fk, background: "transparent", icon: N10, tabIndex: -1 };
  const O10 = { autoHeight: true, autoHeightMax: C10 || 0.62 * Math.min(window.innerHeight, P10.getElement().offsetHeight), direction: "vertical" };
  return tp.createElement(gk, __spreadProps(__spreadValues({}, R10), { ref: H10 }), tp.createElement("div", { className: _10, ref: D10 }, p10 && tp.createElement(Fm, { icon: p10, customCSS: Mk }), tp.createElement("div", { className: kk }, tp.createElement("h4", { className: Pk, title: m10 }, m10), g10 && tp.createElement("span", { className: Nk, title: g10 }, g10)), !n10 && tp.createElement(qm, __spreadValues({}, A10))), tp.createElement("div", { className: xk }, u10 ? k10 : tp.createElement(bF, __spreadValues({}, O10), k10)), tp.createElement("div", { className: V10 }, (() => {
    const e15 = { size: "small", rounded: o10, level: r10 };
    if ("spread" === S10.align) {
      const t11 = (e16, t12) => 0 === t12 ? kp(e16.customCSS, Ek) : e16.customCSS;
      const n11 = S10.left.map((t12, n12) => tp.createElement(qm, __spreadProps(__spreadValues(__spreadValues({}, e15), t12), { key: `left_${n12}`, dataAid: v10 && `${v10}_control_${n12}` })));
      const r11 = S10.right.map((n12, r12) => tp.createElement(qm, __spreadProps(__spreadValues(__spreadValues({}, e15), n12), { key: `right_${r12}`, customCSS: t11(n12, r12), dataAid: v10 && `${v10}_control_${S10.left.length + r12}` })));
      return n11.concat(r11);
    }
    return S10.buttons.map((t11, n11) => tp.createElement(qm, __spreadProps(__spreadValues(__spreadValues({}, e15), t11), { key: n11, dataAid: v10 && `${v10}_control_${n11}` })));
  })(), c10 && tp.createElement("div", { ref: L10, className: Lk }, tp.createElement("div", { className: Dk }))));
};
Hk.displayName = "Dialog";
const [Ik] = Dp("gc-message-box");
const [_k] = tk("message");
const Vk = (e14) => {
  const { closeTimeoutMS: t10 = 0, hideCloseButton: n10 = false, level: r10 = "info", rounded: o10 = false, shouldCloseOnEsc: a10 = true, shouldCloseOnOverlayClick: i10 = true, titleAlign: s10 = "left", controls: l10 = [], buttonsAlign: c10, customControlLabels: u10, customCSS: d10, message: p10 } = e14;
  const m10 = (t11) => () => {
    e14.onClose(t11);
  };
  const h10 = __spreadProps(__spreadValues({}, e14), { level: r10, rounded: o10, hideCloseButton: n10, titleAlign: s10, closeTimeoutMS: t10, shouldCloseOnOverlayClick: i10, shouldCloseOnEsc: a10, customCSS: kp(Ik, d10), onClose: e14.onClose, controls: (() => {
    const e15 = l10.length > 2 ? "right" : "center";
    const t11 = c10 || e15;
    return l10.reduce((e16, t12) => {
      let n11 = { onClick: m10(t12) };
      const r11 = u10 && u10[t12];
      return "ok" === t12 && (n11.text = r11 || "OK", n11.accent = "full"), "yes" === t12 && (n11.text = r11 || "Yes", n11.accent = "full"), "no" === t12 && (n11.text = r11 || "No", n11.accent = "full"), "cancel" === t12 && (n11.text = r11 || "Cancel"), e16.buttons.push(n11), e16;
    }, { align: t11, buttons: [] });
  })() });
  return tp.createElement(Hk, __spreadValues({}, h10), tp.createElement("div", { className: _k }, p10));
};
const [Rk, Ak, Ok] = Dp("gc-notification");
const [Bk] = Ok("button");
const [zk] = Ok("button-mini");
const [$k] = Ok("tag");
const [Wk] = Ok("content");
const [jk] = Ok("actions");
const [Zk] = Ok("caption");
const [Gk] = Ok("loader");
const [Uk] = Ok("status");
const [qk] = Ok("timeout-bar");
class Yk extends ep.Component {
  render() {
    const { notifications: e14, onShowAll: t10, onDismissAll: n10, showAllLabel: r10, dismissAllLabel: o10, rounded: a10, size: i10, dataAid: s10 } = this.props;
    const l10 = kp(Rk, Ak("batch"), { [Ak("rounded")]: a10, [Ak("size-small")]: "small" === i10 });
    const c10 = { type: "button", onClick: t10, customContent: r10, customCSS: Bk };
    const u10 = { type: "button", onClick: n10, customContent: o10, customCSS: Bk };
    return "small" === i10 ? ep.createElement("div", { className: l10, "data-aid": s10 && `${s10}_batch` }, ep.createElement("div", { className: $k }, "+" + (e14.length - 3)), ep.createElement("div", { className: Wk }, ep.createElement("div", { className: jk }, ep.createElement(sM, { size: "small", rounded: a10, items: [c10, u10] })))) : ep.createElement("div", { className: l10, "data-aid": s10 && `${s10}_batch` }, ep.createElement("div", { className: $k }, "+" + (e14.length - 3)), ep.createElement("div", { className: Wk }, ep.createElement("div", { className: jk }, ep.createElement(qm, __spreadValues({}, c10), r10), ep.createElement(qm, __spreadValues({}, u10), o10))));
  }
}
const [Kk, , Xk] = Dp("gc-notification-details-item");
const [Jk] = Xk("main");
const [Qk] = Xk("caption");
const [eP] = Xk("content");
const tP = ({ active: e14, notification: t10, collapseTitle: n10, expandTitle: r10, dismissLabel: o10 }) => {
  const { API: a10 } = ep.useContext(Sm);
  const [i10, s10] = ep.useState(e14);
  const l10 = rf(xh);
  const c10 = rf(oh, { rotate: "180" });
  const u10 = rf(oh);
  const d10 = { type: "button", background: "transparent", accent: "icon", level: t10.level };
  const p10 = __spreadProps(__spreadValues({}, d10), { icon: i10 ? c10 : u10, onClick: () => s10(!i10), title: i10 ? n10 : r10 });
  const m10 = __spreadProps(__spreadValues({}, d10), { icon: l10, onClick: /* @__PURE__ */ ((e15) => () => a10.current.notifications.dismiss(e15))(t10.id), title: o10 });
  return tp.createElement("div", { className: Kk }, tp.createElement("div", { className: Jk }, tp.createElement("div", { className: Qk, title: t10.caption }, tp.createElement("span", null, t10.caption)), tp.createElement(sM, { size: "small", items: [t10.content && p10, m10] })), i10 && tp.createElement("div", { className: eP, dangerouslySetInnerHTML: { __html: wm(t10.content || "") } }));
};
const [nP, , rP] = Dp("gc-notification-details");
const [oP] = rP("content");
const [aP, iP] = rP("category");
const [sP] = rP("action");
class lP extends ep.Component {
  constructor() {
    super(...arguments), this.onDismissAll = () => this.context.API.current.notifications.dismissAll(), this.getLocalizedText = (e14, t10 = 0) => "function" == typeof this.props[e14] ? this.props[e14](t10) : this.props[e14];
  }
  render() {
    const { notifications: e14, activeId: t10, customCSS: n10, dataAid: r10 } = this.props;
    const o10 = { size: "small", accent: "full", text: this.getLocalizedText("dismissAllLabel"), onClick: this.onDismissAll, width: "100%", textAlign: "center" };
    const a10 = { error: [], warning: [], info: [] };
    return e14.map((e15) => a10[e15.level].push(e15)), ep.createElement("div", { className: kp(nP, n10), "data-aid": r10 && `${r10}_notification-details`, role: "alertdialog", "aria-live": "assertive", "aria-label": this.getLocalizedText("ariaLabel") }, ep.createElement("div", { className: oP }, ep.createElement(bF, { direction: "vertical" }, Object.keys(a10).map((e15) => a10[e15].length > 0 && ep.createElement("div", { key: e15, className: kp(aP, iP(e15)), role: "log", "aria-live": "polite" }, ep.createElement(LE, { text: `${a10[e15].length} ${this.getLocalizedText(`${e15}CategoryLabel`, a10[e15].length)}` }), a10[e15].map((e16) => {
      const n11 = { notification: e16, active: e16.id === t10 && Boolean(e16.content), expandTitle: this.getLocalizedText("expandTitle"), collapseTitle: this.getLocalizedText("collapseTitle"), dismissLabel: this.getLocalizedText("dismissLabel") };
      return ep.createElement(tP, __spreadValues({ key: e16.id }, n11));
    }))))), ep.createElement("div", { className: sP }, ep.createElement(qm, __spreadValues({}, o10))));
  }
}
lP.contextType = Sm, lP.defaultProps = { dismissLabel: "Dismiss", dismissAllLabel: "Dismiss All", expandTitle: "Expand", collapseTitle: "Collapse", errorCategoryLabel: "Error", warningCategoryLabel: "Warning", infoCategoryLabel: "Notification", ariaLabel: "Notifications details" };
const [cP, uP, dP] = Dp("gc-progress");
const [pP] = dP("fill");
const [mP] = dP("value");
class hP extends ep.Component {
  constructor() {
    super(...arguments), this._fillRef = ep.createRef(), this.getFillElement = () => this._fillRef.current;
  }
  render() {
    const { id: e14, progress: t10, indeterminate: n10, pause: r10, size: o10, showProgress: a10, color: i10, transparent: s10, width: l10, inline: c10, customCSS: u10, dataAid: d10, style: p10 } = this.props;
    const m10 = kp(cP, u10, { [uP("inline")]: c10, [uP("accent")]: "accent" === i10, [uP("semi-transparent")]: "semi" === s10, [uP("transparent")]: "full" === s10, [uP("indeterminate")]: n10, [uP(`pause-${r10}`)]: r10, [Up]: "small" === o10, [qp]: "large" === o10 });
    let h10;
    if ("default" !== i10 && "accent" !== i10 && (h10 = i10), n10) return ep.createElement("div", { id: e14, "data-aid": d10, className: m10, style: __spreadValues({ width: l10 }, p10.bar) }, ep.createElement("div", { className: pP, ref: this._fillRef, style: __spreadValues({ backgroundColor: h10 }, p10.fill) }));
    const f10 = 100 * (t10 && !isNaN(t10) && t10 >= 0 && t10 <= 1 && t10 || 0);
    const g10 = `${Math.round(f10)}%`;
    const y10 = __spreadValues({ width: `${f10}%`, backgroundColor: h10 }, p10.fill);
    return ep.createElement("div", { id: e14, "data-aid": d10, className: m10, style: __spreadValues({ width: l10 }, p10.bar) }, ep.createElement("div", { className: pP, ref: this._fillRef, style: y10 }, a10 && "small" !== o10 && ep.createElement("span", { className: mP }, g10)));
  }
}
hP.defaultProps = { color: "default", indeterminate: false, inline: false, showProgress: true, size: "default", style: {} };
const fP = ({ notification: e14, onDetailsClick: t10, onDismiss: n10, dismissLabel: r10, showDetailsLabel: o10, rounded: a10, size: i10, dataAid: s10, renderTimeout: l10 }) => {
  const c10 = rf(Qh);
  const u10 = rf(Dh);
  const d10 = rf(Jh);
  const p10 = rf(Nh);
  const m10 = rf(Xh);
  const h10 = rf(ih);
  const f10 = rf(vh);
  const g10 = rf(xh);
  const y10 = ep.useMemo(() => ({ error: { icon: "small" === i10 ? u10 : c10, modifier: "error" }, warning: { icon: "small" === i10 ? p10 : d10, modifier: "warning" }, info: { icon: "small" === i10 ? h10 : m10, modifier: "info" } }), [i10]);
  const v10 = () => {
    var _a2, _b2;
    l10 == null ? void 0 : l10.callback(), (_b2 = (_a2 = b10.current) == null ? void 0 : _a2.getFillElement()) == null ? void 0 : _b2.removeEventListener("animationend", v10);
  };
  const b10 = ep.useRef(null);
  if (ep.useEffect(() => {
    var _a2, _b2;
    return (_b2 = (_a2 = b10.current) == null ? void 0 : _a2.getFillElement()) == null ? void 0 : _b2.addEventListener("animationend", v10), v10;
  }, []), e14.hidden) return null;
  const { icon: S10, modifier: C10 } = y10[e14.level];
  const x10 = kp(Rk, Ak(C10), { [Ak("rounded")]: a10, [Ak("size-small")]: "small" === i10 });
  const w10 = { type: "button", onClick: t10, customCSS: Bk };
  const T10 = { type: "button", onClick: n10, customCSS: Bk };
  let E10;
  return l10 && (E10 = { size: "small", progress: 1, style: { fill: { animationDuration: `${l10.time}ms` } }, customCSS: qk }), "small" === i10 ? tp.createElement("div", { className: x10, "data-aid": s10 && `${s10}_notification`, role: "alert", "aria-live": "assertive", "aria-label": C10 }, tp.createElement("div", { className: $k }, tp.createElement(Fm, { icon: e14.icon || S10 })), tp.createElement("div", { className: Wk }, tp.createElement("div", { className: Zk }, e14.caption), tp.createElement("div", { className: jk }, tp.createElement(sM, { defaultBackground: "transparent", size: "small", rounded: a10, items: [e14.content && __spreadProps(__spreadValues({}, w10), { icon: f10, title: o10, customCSS: zk, dataAid: s10 && `${s10}_notification_show_details` }), __spreadProps(__spreadValues({}, T10), { icon: g10, title: r10, customCSS: zk, dataAid: s10 && `${s10}_notification_dismiss` })] }))), l10 && tp.createElement(hP, __spreadProps(__spreadValues({}, E10), { ref: b10 }))) : tp.createElement("div", { className: x10, "data-aid": s10 && `${s10}_notification`, role: "alert", "aria-live": "assertive", "aria-label": C10 }, tp.createElement("div", { className: $k }, tp.createElement(Fm, { icon: e14.icon || S10 })), tp.createElement("div", { className: Wk }, tp.createElement("div", { className: Zk }, e14.caption), tp.createElement("div", { className: jk }, e14.content && tp.createElement(qm, __spreadProps(__spreadValues({}, w10), { rounded: a10, dataAid: s10 && `${s10}_notification_show_details` }), o10), tp.createElement(qm, __spreadProps(__spreadValues({}, T10), { rounded: a10, dataAid: s10 && `${s10}_notification_dismiss` }), r10))), l10 && tp.createElement(hP, __spreadProps(__spreadValues({}, E10), { ref: b10 })));
};
const gP = ({ task: e14, cancelTaskTitle: t10, rounded: n10, size: r10, dataAid: o10 }) => {
  const a10 = rf(Ch);
  const i10 = rf(Kh);
  const s10 = { rounded: n10, customCSS: Bk, size: "large", icon: i10, title: t10, onClick: e14.cancel, dataAid: o10 && `${o10}_task_cancel` };
  const l10 = ((e15) => Number.isFinite(e15) && e15 > 1 ? e15 / 100 : e15)(e14.progress);
  const c10 = { size: "small", indeterminate: !l10 || l10 === 1 / 0, progress: l10 };
  const u10 = kp(Rk, Ak("task"), { [Ak("rounded")]: n10, [Ak("size-small")]: "small" === r10 });
  if ("small" === r10) {
    const n11 = __spreadProps(__spreadValues({}, s10), { size: "small", icon: a10, customCSS: zk, name: t10 });
    return tp.createElement("div", { className: u10, "data-aid": o10 && `${o10}_task`, role: "status", "aria-live": "polite", "aria-label": `${l10}` }, tp.createElement("div", { className: $k }, tp.createElement("div", { className: Gk }, tp.createElement("div", null)), e14.cancel && tp.createElement(qm, __spreadValues({}, n11))), tp.createElement("div", { className: Wk }, tp.createElement("div", { className: Zk }, e14.caption), !c10.indeterminate && tp.createElement(hP, __spreadValues({}, c10))));
  }
  return tp.createElement("div", { className: u10, "data-aid": o10 && `${o10}_task`, role: "status", "aria-live": "polite", "aria-label": `${l10}` }, tp.createElement("div", { className: $k }, tp.createElement("div", { className: Gk }, tp.createElement("div", null)), e14.cancel && tp.createElement(qm, __spreadValues({}, s10))), tp.createElement("div", { className: Wk }, tp.createElement("div", { className: Zk }, e14.caption), tp.createElement(hP, __spreadValues({}, c10)), tp.createElement("div", { className: Uk }, e14.statusText)));
};
const [yP, vP] = Dp("gc-notifications-container");
const [bP] = Dp("gc-notifications-modal");
const SP = { expanded: false, activeId: void 0 };
class CP extends ep.Component {
  constructor() {
    super(...arguments), this._root = null, this.state = SP, this.getRoot = () => {
      const { root: e14, API: t10 } = this.context;
      const n10 = e14.getElement();
      const r10 = `${t10.namespace}-notifications-root`;
      const o10 = document.getElementById(r10);
      if (o10) return o10;
      const a10 = nm(r10, "notifications");
      return n10.appendChild(a10);
    }, this.getRenderTimeout = (e14) => {
      const { autoDismissTimeout: t10, autoHideTimeout: n10 } = this.props;
      let r10;
      let o10;
      if ((e14.autoDismissTimeout || t10) && (r10 = { callback: this.onDismiss(e14.id, true), time: e14.autoDismissTimeout || t10 }), n10 && (o10 = { callback: () => this.hideNotification(e14.id), time: n10 }), r10 && o10) {
        const [e15, t11] = [r10, o10].sort((e16, t12) => e16.time - t12.time);
        const n11 = e15.callback;
        return e15.callback = () => {
          n11(), setTimeout(t11.callback, t11.time - e15.time);
        }, e15;
      }
      return r10 || o10;
    }, this.hideNotification = (e14) => {
      this.props.onNotificationHide(e14);
    }, this.hideNotificationsAll = () => {
      this.props.onNotificationHide();
    }, this.setActiveIndex = (e14) => {
      this.setState({ activeId: e14 });
    }, this.toggleExpand = (e14) => {
      const { expanded: t10 } = this.state;
      e14 && t10 || false === e14 && !t10 || this.setState({ expanded: !t10 });
    }, this.onDismiss = (e14, t10 = false) => () => {
      t10 && this.state.expanded || this.props.onDismiss(e14);
    }, this.onDetailsOpen = (e14) => () => {
      this.props.autoHideTimeout && this.hideNotificationsAll(), this.setActiveIndex(e14), this.toggleExpand(true);
    };
  }
  static getDerivedStateFromProps(e14, t10) {
    return e14.notifications.length ? null : SP;
  }
  componentDidMount() {
    this._root = this.getRoot();
  }
  render() {
    const _a2 = this, { _root: e14, props: _b2 } = _a2, _c2 = _b2, { notifications: t10, tasks: n10, rounded: r10, position: o10, showLastThree: a10, customCSS: i10, detailsCustomCSS: s10, size: l10, dataAid: c10, dismissLabel: u10, dismissAllLabel: d10, showAllLabel: p10, showDetailsLabel: m10, cancelTaskTitle: h10, onDismissAll: f10, ariaLabel: g10 } = _c2, y10 = __objRest(_c2, ["notifications", "tasks", "rounded", "position", "showLastThree", "customCSS", "detailsCustomCSS", "size", "dataAid", "dismissLabel", "dismissAllLabel", "showAllLabel", "showDetailsLabel", "cancelTaskTitle", "onDismissAll", "ariaLabel"]), { state: { expanded: v10, activeId: b10 } } = _a2;
    if (!e14) return null;
    if (v10 && t10.length) {
      const e15 = __spreadProps(__spreadValues({}, y10), { customCSS: s10, dismissLabel: u10, dismissAllLabel: d10, notifications: t10, activeId: b10, dataAid: c10, ariaLabel: g10 });
      return ep.createElement(yk, { open: v10, onClose: () => this.toggleExpand(false), customCSS: bP }, ep.createElement(lP, __spreadValues({}, e15)));
    }
    let S10 = t10.filter((e15) => !e15.hidden);
    if (!S10.length && !n10.length) return null;
    const C10 = !a10 && S10.length > 3;
    S10 = a10 ? S10.slice(-3) : C10 ? S10.slice(0, 3) : S10;
    const x10 = kp(yP, i10, { [vP(`position-${o10}`)]: o10 });
    const w10 = { notifications: t10, rounded: r10, size: l10, dataAid: c10, showAllLabel: p10, dismissAllLabel: d10, onShowAll: this.onDetailsOpen(), onDismissAll: f10 };
    const T10 = { parent: { type: "viewport" }, align: o10 };
    return mE.createPortal(ep.createElement(_E, __spreadValues({}, T10), ep.createElement("div", { className: x10 }, n10.map((e15) => {
      const t11 = { task: e15, rounded: r10, size: l10, dataAid: c10, cancelTaskTitle: h10 };
      return ep.createElement(gP, __spreadValues({ key: e15.id }, t11));
    }), S10.map((e15) => {
      const t11 = { notification: e15, rounded: r10, size: l10, dataAid: c10, onDetailsClick: this.onDetailsOpen(e15.id), onDismiss: this.onDismiss(e15.id), dismissLabel: u10, showDetailsLabel: m10, renderTimeout: this.getRenderTimeout(e15) };
      return ep.createElement(fP, __spreadValues({ key: e15.id }, t11));
    }), C10 && ep.createElement(Yk, __spreadValues({}, w10)))), e14);
  }
}
CP.contextType = Sm;
class xP {
  constructor(e14) {
    this._state = { notifications: /* @__PURE__ */ new Map(), tasks: /* @__PURE__ */ new Map() }, this._updateCallback = e14;
  }
  dispatch(e14) {
    const t10 = ((e15, t11) => {
      switch (t11.type) {
        case "ADD_NOTIFICATION":
          e15.notifications.set(t11.payload.id, t11.payload);
          break;
        case "ADD_TASK":
          e15.tasks.set(t11.payload.id, t11.payload);
          break;
        case "REMOVE_NOTIFICATION":
          return e15.notifications.delete(t11.payload);
        case "REMOVE_TASK":
          return e15.tasks.delete(t11.payload);
        case "UPDATE_TASK": {
          const { id: n10, progress: r10, statusText: o10 } = t11.payload;
          const a10 = e15.tasks.get(n10);
          if (!a10) return false;
          a10.progress = r10, a10.statusText = o10 || a10.statusText;
          break;
        }
        case "CLEAR_NOTIFICATIONS":
          e15.notifications.clear();
          break;
        case "HIDE_NOTIFICATION": {
          const n10 = e15.notifications.get(t11.payload);
          if (!n10) return false;
          n10.hidden = true;
          break;
        }
        case "HIDE_NOTIFICATIONS_ALL":
          e15.notifications.forEach((e16) => {
            e16.hidden = true;
          });
      }
      return true;
    })(this._state, e14);
    t10 && this.scheduleUpdate();
  }
  scheduleUpdate() {
    clearTimeout(this._updateTimer), this._updateTimer = window.setTimeout(() => {
      this._updateCallback(this._state);
    }, 0);
  }
}
function wP(e14, t10 = void 0) {
  return { type: e14, payload: t10 };
}
class TP extends ep.Component {
  constructor(e14) {
    super(e14), this._subscribedCallbacks = [], this._notificationIdBase = Math.random().toString(36), this._notificationCounter = 0, this.state = { notifications: [], tasks: [] }, this.onSend = ({ type: e15, payload: t10 }) => {
      var _a2;
      if (t10.id = (_a2 = t10.id) != null ? _a2 : this.generateNotificationId(), "notification" === e15) {
        const e16 = t10;
        "info" !== e16.level && "warning" !== e16.level && (e16.level = "error"), this._store.dispatch(wP("ADD_NOTIFICATION", e16));
      } else {
        const e16 = t10;
        e16.cancel = this.onTaskCancel(e16), this._store.dispatch(wP("ADD_TASK", e16));
      }
    }, this.onDismiss = (e15) => {
      this._store.dispatch(wP("REMOVE_NOTIFICATION", e15));
    }, this.onDismissAll = () => {
      this._store.dispatch(wP("CLEAR_NOTIFICATIONS"));
    }, this.onTaskUpdate = (e15) => {
      this._store.dispatch(wP("UPDATE_TASK", e15));
    }, this.subscribe = (e15) => {
      this._subscribedCallbacks.push(e15);
    }, this.unsubscribe = (e15) => {
      this._subscribedCallbacks = this._subscribedCallbacks.filter((t10) => t10 !== e15);
    }, this.getState = () => this.state, this.generateNotificationId = () => `${this._notificationIdBase}${this._notificationCounter++}`, this.onUpdate = (e15) => {
      const { onDismiss: t10 } = this.props;
      if (t10) {
        const n11 = this.state.notifications.filter((t11) => !e15.notifications.has(t11.id));
        n11.forEach((e16) => t10(e16.id));
      }
      const n10 = { notifications: [], tasks: [] };
      e15.notifications.forEach((e16) => n10.notifications.push(e16)), e15.tasks.forEach((e16) => n10.tasks.push(e16)), this.setState(n10, () => {
        this._subscribedCallbacks.forEach((e16) => e16 && e16(this.state));
      });
    }, this.onTaskCancel = ({ id: e15, cancel: t10 }) => () => {
      false !== (t10 == null ? void 0 : t10()) && this._store.dispatch(wP("REMOVE_TASK", e15));
    }, this.onNotificationHide = (e15) => {
      void 0 === e15 ? this._store.dispatch(wP("HIDE_NOTIFICATIONS_ALL")) : this._store.dispatch(wP("HIDE_NOTIFICATION", e15));
    }, this._store = new xP(this.onUpdate);
  }
  componentDidMount() {
    const { API: e14 } = this.context;
    e14.current.notifications ? console.warn("Repeated <NotificationManager/> mounting") : e14.current.notifications = { send: this.onSend, dismiss: this.onDismiss, dismissAll: this.onDismissAll, updateTask: this.onTaskUpdate, subscribe: this.subscribe, unsubscribe: this.unsubscribe, getState: this.getState };
  }
  componentWillUnmount() {
    const { API: e14 } = this.context;
    e14.current.notifications && e14.current.notifications.send === this.onSend && delete e14.current.notifications;
  }
  render() {
    const _a2 = this, { _subscribedCallbacks: e14, props: _b2 } = _a2, _c2 = _b2, { autoHideTimeout: t10 } = _c2, n10 = __objRest(_c2, ["autoHideTimeout"]), { state: { notifications: r10, tasks: o10 } } = _a2;
    let a10 = t10;
    e14.length > 0 && void 0 === t10 && (a10 = 2e3);
    const i10 = __spreadProps(__spreadValues({}, n10), { notifications: r10, tasks: o10, autoHideTimeout: a10, showLastThree: e14.length > 0, onDismiss: this.onDismiss, onDismissAll: this.onDismissAll, onNotificationHide: this.onNotificationHide });
    return ep.createElement(CP, __spreadValues({}, i10));
  }
}
function EP(e14) {
  var t10;
  return t10 = class extends ep.Component {
    constructor() {
      super(...arguments), this.state = { notifications: [], tasks: [], amount: { info: 0, warning: 0, error: 0, notifications: 0, tasks: 0, total: 0 }, level: "info" }, this.update = ({ notifications: e15, tasks: t11 }) => {
        const n10 = { info: 0, warning: 0, error: 0, notifications: 0, tasks: 0, total: 0 };
        let r10;
        e15.forEach((e16) => ++n10[e16.level]), n10.notifications = e15.length, n10.tasks = t11.length, n10.total = t11.length + e15.length, r10 = n10.error ? "error" : n10.warning ? "warning" : "info", this.setState({ notifications: e15, tasks: t11, amount: n10, level: r10 });
      };
    }
    componentDidMount() {
      setTimeout(() => {
        const { API: e15 } = this.context;
        e15.current.notifications && (e15.current.notifications.subscribe(this.update), this.update(e15.current.notifications.getState()));
      }, 0);
    }
    componentWillUnmount() {
      const { API: e15 } = this.context;
      e15.current.notifications && e15.current.notifications.unsubscribe(this.update);
    }
    render() {
      return ep.createElement(e14, __spreadProps(__spreadValues({}, this.props), { notificationsData: __spreadValues({}, this.state) }));
    }
  }, t10.contextType = Sm, t10;
}
TP.contextType = Sm, TP.defaultProps = { position: "bottom-center", rounded: false, size: "default", dismissLabel: "Dismiss", dismissAllLabel: "Dismiss All", showAllLabel: "Show All", showDetailsLabel: "Show Details", cancelTaskTitle: "Cancel this task", expandTitle: "Expand", collapseTitle: "Collapse", errorCategoryLabel: "Error", warningCategoryLabel: "Warning", infoCategoryLabel: "Notification", ariaLabel: "Notifications details" };
const [FP, MP, kP] = Dp("gc-resizable");
const [PP, NP] = kP("handler");
class DP extends ep.Component {
  constructor() {
    super(...arguments), this._container = ep.createRef(), this._handler = ep.createRef(), this._initialPointerPosition = { x: 0, y: 0 }, this._maxSize = 0, this._minSize = 0, this.onWindowResize = () => {
      var _a2;
      if (this._aspectRatio) {
        const { onResizeStart: e14, onResize: t10, onResizeEnd: n10 } = this.props;
        const r10 = this.rootSize * this._aspectRatio;
        this.updateContainerSize(r10), this._committedSize = r10, this._windowResizeTimer || (e14 == null ? void 0 : e14(r10)), t10 == null ? void 0 : t10(r10), (_a2 = this._container.current) == null ? void 0 : _a2.classList.add("gc-disable-transition"), clearTimeout(this._windowResizeTimer), this._windowResizeTimer = window.setTimeout(() => {
          var _a3;
          (_a3 = this._container.current) == null ? void 0 : _a3.classList.remove("gc-disable-transition"), n10 == null ? void 0 : n10(r10), this._windowResizeTimer = void 0;
        }, 100);
      }
    }, this.updateContainerSize = (e14) => {
      this._container.current && (this._container.current.style[this.isHorizontal ? "width" : "height"] = `${e14}px`);
    }, this.commitSize = (e14) => {
      this._committedSize = e14[this.isHorizontal ? "offsetWidth" : "offsetHeight"];
    }, this.getBounds = () => {
      const { minSize: e14, maxSize: t10 } = this.props;
      this._maxSize = t10 <= 1 ? this.rootSize * t10 : t10, this._minSize = e14 <= 1 ? this.rootSize * e14 : e14;
    }, this.getDelta = (e14) => {
      switch (this.props.handlerSide) {
        case "right":
          return e14.pageX - this._initialPointerPosition.x;
        case "left":
          return this._initialPointerPosition.x - e14.pageX;
        case "top":
          return this._initialPointerPosition.y - e14.pageY;
        case "bottom":
          return e14.pageY - this._initialPointerPosition.y;
      }
    }, this.onMouseDown = (e14) => {
      var _a2, _b2;
      this._container.current && (this._committedSize || this.commitSize(this._container.current), this.props.size && (this._committedSize = this.props.size), this.getBounds(), this._initialPointerPosition = { x: e14.pageX, y: e14.pageY }, e14.preventDefault(), window.addEventListener("mousemove", this.onMouseMove), window.addEventListener("mouseup", this.onMouseUp), document.body.classList.add("gc-disable-selection"), this._container.current.classList.add("gc-disable-transition"), (_b2 = (_a2 = this.props).onResizeStart) == null ? void 0 : _b2.call(_a2, this._committedSize));
    }, this.onMouseMove = (e14) => {
      var _a2, _b2;
      if (!this._container.current) return this.onMouseUp();
      let t10 = this._committedSize + this.getDelta(e14);
      this._minSize > t10 && (t10 = this._minSize), this._maxSize < t10 && (t10 = this._maxSize), this.updateContainerSize(t10), (_b2 = (_a2 = this.props).onResize) == null ? void 0 : _b2.call(_a2, t10);
    }, this.onMouseUp = () => {
      const { onResizeEnd: e14, keepAspectRatio: t10 } = this.props;
      this._container.current && (this.commitSize(this._container.current), e14 == null ? void 0 : e14(this._committedSize), this._container.current.classList.remove("gc-disable-transition")), t10 && (this._aspectRatio = this._committedSize / this.rootSize), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("mouseup", this.onMouseUp), document.body.classList.remove("gc-disable-selection");
    };
  }
  componentDidMount() {
    this.props.keepAspectRatio && window.addEventListener("resize", this.onWindowResize);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.onWindowResize);
  }
  get element() {
    return this._container.current;
  }
  get isHorizontal() {
    const { handlerSide: e14 } = this.props;
    return "left" === e14 || "right" === e14;
  }
  get rootSize() {
    return this.context.root.getElement()[this.isHorizontal ? "offsetWidth" : "offsetHeight"];
  }
  render() {
    var _a2;
    const { children: e14, customCSS: t10, dataAid: n10, handlerSide: r10, disabled: o10, size: a10, defaultSize: i10 } = this.props;
    const s10 = kp(FP, t10, { [MP("disabled")]: o10, [MP("horizontal")]: !o10 && this.isHorizontal, [MP("vertical")]: !o10 && !this.isHorizontal });
    const l10 = { [this.isHorizontal ? "width" : "height"]: (_a2 = a10 != null ? a10 : this._committedSize) != null ? _a2 : i10 };
    const c10 = kp(PP, NP(`side-${r10}`));
    return ep.createElement("div", { className: s10, ref: this._container, style: l10, "data-aid": n10 }, e14, ep.createElement("div", { className: c10, ref: this._handler, onMouseDown: this.onMouseDown }));
  }
}
DP.contextType = Sm, DP.defaultProps = { minSize: 0, maxSize: 1, disabled: false, keepAspectRatio: false };
const LP = "__gc-notifications__";
class HP extends ep.Component {
  render() {
    const _a2 = this.props, { notifications: e14, placeholder: t10, customCSS: n10, dataAid: r10, alwaysVisible: o10, chevronIcon: a10, customScroll: i10, disabled: s10, hideChevron: l10, id: c10, toggle: u10, children: d10 } = _a2, p10 = __objRest(_a2, ["notifications", "placeholder", "customCSS", "dataAid", "alwaysVisible", "chevronIcon", "customScroll", "disabled", "hideChevron", "id", "toggle", "children"]);
    const m10 = __spreadProps(__spreadValues({}, p10), { notifications: e14 });
    const h10 = { dataAid: r10, chevronIcon: a10, customScroll: i10, disabled: s10, hideChevron: l10, id: c10, toggle: u10, customCSS: kp(qM("notifications"), n10) };
    return ep.createElement(XM, __spreadValues({}, h10), e14.length > 0 ? ep.createElement(lP, __spreadValues({}, m10)) : ep.createElement(JM, { text: t10 }));
  }
}
HP.defaultProps = { id: LP, toggle: { icon: nf(Uh), text: "Notifications" }, customScroll: true, placeholder: "There are no notifications", disabled: false, alwaysVisible: false, chevronIcon: nf(oh, { rotate: "270" }), hideChevron: false };
const [IP, _P, VP] = Dp("gc-menu");
const [RP, AP] = VP("panel-container");
const [OP] = VP("panel-header");
const [BP] = VP("panel-content");
const [zP, $P] = VP("panel-toggle");
const [WP, jP] = VP("panel-toggle-chevron");
const [ZP, GP] = VP("logo");
const [UP, qP] = VP("logo-placeholder");
const [YP] = VP("btn-container");
const [KP] = VP("scrollable-buttons");
const [XP] = VP("splitter");
const [JP, QP] = Dp("gc-btn-pin");
const eN = { toggle: { small: nf(Ph), default: nf(jh), large: nf(Yh) }, pin: { small: nf(ph), default: nf(zh) }, pinOff: { small: nf(mh), default: nf($h) } };
const tN = () => ep.createElement("div", { className: XP });
om.set(tN, "MenuSplitter");
class nN extends ep.Component {
  constructor(e14) {
    super(e14), this._menuDiv = null, this._buttonContainer = null, this._panelContainer = null, this._transitionSubscribers = { start: [], end: [] }, this.getPanelsAndSplitters = (e15) => {
      let t11 = ep.Children.toArray(e15).filter((e16) => ep.isValidElement(e16) && (om.is(e16.type, XM) || om.is(e16.type, tN)));
      const { notificationPanel: n10, notificationsData: r10 } = this.props;
      if (r10 && n10) {
        const { notifications: e16, amount: o10 } = r10;
        const a10 = o10.notifications > 0 || n10.alwaysVisible;
        const i10 = __spreadProps(__spreadValues({}, n10), { notifications: e16 });
        o10.notifications > 0 && !n10.alwaysVisible && t11.push(ep.createElement(tN, null)), a10 && t11.push(ep.createElement(HP, __spreadValues({}, i10)));
      }
      return t11;
    }, this.onToggle = () => {
      var _a2, _b2, _c2;
      const { _transitionSubscribers: e15, props: { onToggle: t11 }, state: { status: n10 } } = this;
      t11 && t11(n10), e15.start.forEach((e16) => e16(n10)), (_a2 = this._buttonContainer) == null ? void 0 : _a2.addEventListener("transitionend", this.onTransitionEnd), (_c2 = (_b2 = this._panelContainer) == null ? void 0 : _b2.element) == null ? void 0 : _c2.addEventListener("transitionend", this.onTransitionEnd);
    }, this.onTransitionEnd = (e15) => {
      var _a2;
      const { API: t11 } = this.context;
      const n10 = this._buttonContainer;
      const r10 = this._panelContainer.element;
      if (e15.target !== n10 && e15.target !== r10) return;
      const o10 = (_a2 = t11.current.dropdowns) == null ? void 0 : _a2.current;
      const a10 = o10 == null ? void 0 : o10.getPositionerNode();
      a10 == null ? void 0 : a10.classList.add(Wp), o10 == null ? void 0 : o10.updateMenuPosition(), n10.removeEventListener("transitionend", this.onTransitionEnd), r10.removeEventListener("transitionend", this.onTransitionEnd), this._transitionSubscribers.end.forEach((e16) => e16(this.state.status));
    }, this.onPointerEventStart = (e15) => {
      const { _menuDiv: t11, props: { noCloseOnWindowClick: n10 }, context: { root: r10 } } = this;
      const o10 = r10.getElement();
      n10 || !t11 || o10.classList.contains(fk) || t11 === e15.target || t11.contains(e15.target) || (r10.addEventListener("mouseup", this.onPointerEventEnd), r10.addEventListener("touchend", this.onPointerEventEnd), r10.addEventListener("click", this.onPointerEventEnd));
    }, this.onPointerEventEnd = (e15) => {
      const { _menuDiv: t11, state: { status: n10, pinned: r10 }, context: { root: o10 } } = this;
      if ("expanded" === n10) {
        const { onToggleClick: e16 } = this.props;
        e16 && e16(), this.collapseMenu();
      } else "panel" !== n10 || r10 || t11 === e15.target || (t11 == null ? void 0 : t11.contains(e15.target)) || this.closePanel();
      o10.removeEventListener("mouseup", this.onPointerEventEnd), o10.removeEventListener("touchend", this.onPointerEventEnd), o10.removeEventListener("click", this.onPointerEventEnd);
    }, this.expandMenu = () => {
      this.setState({ status: "expanded" });
    }, this.collapseMenu = () => {
      const { pinned: e15 } = this.state;
      e15 ? this.setState({ status: "panel" }) : this.setState({ status: "collapsed" });
    }, this.toggleMenu = () => {
      const { status: e15 } = this.state;
      "expanded" !== e15 ? this.expandMenu() : this.collapseMenu();
    }, this.openPanel = (e15) => {
      const { activePanelId: t11 } = this.state;
      e15 !== t11 && (this.setState({ activePanelId: e15, status: "panel" }), this.onPanelChange(e15));
    }, this.closePanel = (e15) => {
      const { activePanelId: t11, status: n10 } = this.state;
      "panel" !== n10 || void 0 !== e15 && t11 !== e15 || (this.setState({ activePanelId: null, status: "collapsed", pinned: false }), this.onPanelChange(null));
    }, this.pinPanel = (e15) => {
      const { activePanelId: t11, status: n10 } = this.state;
      void 0 === e15 && "panel" === n10 && t11 ? this.setState({ pinned: true }) : void 0 !== e15 && (this.setState({ activePanelId: e15, status: "panel", pinned: true }), this.onPanelChange(e15));
    }, this.unpinPanel = () => {
      this.setState({ pinned: false });
    }, this.onPanelChange = (e15) => {
      const { onPanelChange: t11 } = this.props;
      t11 && t11(e15);
    }, this.subscribeToTransition = ({ start: e15, end: t11 }) => (e15 && this._transitionSubscribers.start.push(e15), t11 && this._transitionSubscribers.end.push(t11), () => {
      e15 && (this._transitionSubscribers.start = this._transitionSubscribers.start.filter((t12) => t12 !== e15)), t11 && (this._transitionSubscribers.end = this._transitionSubscribers.end.filter((e16) => e16 !== t11));
    }), this.onPanelToggleClick = (e15) => () => {
      const { activePanelId: t11, pinned: n10, status: r10 } = this.state;
      "panel" !== r10 || t11 !== e15 || n10 ? (this.setState({ activePanelId: e15, status: "panel" }), this.onPanelChange(e15)) : (this.setState({ activePanelId: null, status: "collapsed" }), this.onPanelChange(null));
    }, this.mapTogglesAndSplitters = (e15, t11) => {
      if (om.is(e15.type, tN)) return ep.createElement(tN, { key: `panel-splitter-${t11}` });
      const { props: { size: n10, legacyMode: r10, notificationsData: o10 }, state: { status: a10, activePanelId: i10 } } = this;
      const { id: s10, toggle: l10, disabled: c10, dataAid: u10, notifications: d10, chevronIcon: p10, hideChevron: m10 } = e15.props;
      let h10 = l10.badge && __spreadValues({ nearIcon: true }, l10.badge);
      if (d10) {
        const { amount: e16, level: t12 } = o10;
        h10 = e16.notifications > 0 ? { nearIcon: true, rounded: true, content: e16.notifications, level: t12 } : void 0;
      }
      const f10 = { dataAid: u10 ? `${u10}_toggle` : void 0, block: true, accent: r10 ? "icon" : "full", background: r10 ? "transparent" : "default", rounded: false, size: n10, badge: h10, width: "100%", onClick: this.onPanelToggleClick(s10), icon: l10.icon, text: l10.text, title: l10.title, disabled: c10 };
      const g10 = { icon: p10, customCSS: kp(WP, { [jP("accent")]: r10 }) };
      const y10 = kp(zP, { [$P(`size-${n10}`)]: "default" !== n10, [$P("active")]: "panel" === a10 && s10 === i10, [$P("no-chevron")]: m10, [$P("disabled")]: c10 });
      return ep.createElement("div", { key: `menu-panel-${s10}`, className: y10 }, ep.createElement(qm, __spreadValues({}, f10)), !m10 && ep.createElement(Fm, __spreadValues({}, g10)));
    }, this.mapItems = (e15, t11) => {
      if (!e15) return;
      const { size: n10, legacyMode: r10 } = this.props;
      const o10 = `menu-item-${t11}`;
      if ("splitter" === e15.type) return ep.createElement(tN, { key: o10 });
      if ("button" === e15.type) {
        const t12 = { block: true, accent: r10 ? "icon" : "full", background: r10 ? "transparent" : "default", rounded: false, size: n10, width: "100%", badge: e15.badge && __spreadProps(__spreadValues({}, e15.badge), { nearIcon: true }) };
        return ep.createElement(qm, __spreadValues(__spreadValues({ key: o10 }, e15), t12), e15.customContent);
      }
      return "custom" === e15.type ? ep.cloneElement(e15.content, { key: o10 }) : void 0;
    }, this.onToggleClick = () => {
      const { onToggleClick: e15 } = this.props;
      e15 && e15(), this.toggleMenu();
    }, this.onPinClick = () => {
      const { onPinClick: e15 } = this.props;
      e15 && e15(), this.setState({ pinned: !this.state.pinned });
    }, this.getNode = () => this._menuDiv, this.onResize = (e15) => {
      var _a2;
      ((_a2 = this._panelContainer) == null ? void 0 : _a2.element) && (this._panelContainer.element.style.marginLeft = `-${e15}px`);
    }, this.onResizeEnd = () => {
      this._transitionSubscribers.end.forEach((e15) => e15(this.state.status));
    };
    const t10 = { activePanelId: null, status: "collapsed", pinned: false, logoContainerElement: null };
    e14.defaultPanelId ? (t10.activePanelId = e14.defaultPanelId, t10.status = "panel") : "expanded" === e14.defaultStatus && (t10.status = "expanded"), this.state = t10;
  }
  static getDerivedStateFromProps(e14, t10) {
    let n10 = null;
    function r10(e15) {
      n10 || (n10 = __spreadValues({}, t10)), n10 = __spreadValues(__spreadValues({}, n10), e15);
    }
    return t10.activePanelId !== LP || e14.notificationPanel.alwaysVisible || e14.notificationsData.amount.notifications || (t10.pinned && e14.defaultPanelId ? r10({ activePanelId: e14.defaultPanelId }) : r10({ activePanelId: null, status: "collapsed" })), void 0 !== e14.activePanelId && e14.activePanelId !== t10.activePanelId && r10({ activePanelId: e14.activePanelId, status: null !== e14.activePanelId ? "panel" : t10.status }), void 0 !== e14.status && e14.status !== t10.status && r10({ status: e14.status }), void 0 !== e14.pinned && e14.pinned !== t10.pinned && r10({ pinned: e14.pinned }), n10;
  }
  componentDidMount() {
    const { API: e14, root: t10 } = this.context;
    e14.current.menu = { expand: this.expandMenu, collapse: this.collapseMenu, toggle: this.toggleMenu, panels: { open: this.openPanel, close: this.closePanel, pin: this.pinPanel, unpin: this.unpinPanel }, onTransition: this.subscribeToTransition };
    const { logo: n10 } = this.props;
    if (n10) {
      const e15 = document.getElementById(`appbar_${n10.appBarId}_logo_container`);
      null !== e15 && this.setState({ logoContainerElement: e15 });
    }
    t10.addEventListener("mousedown", this.onPointerEventStart), t10.addEventListener("touchstart", this.onPointerEventStart);
  }
  componentWillUnmount() {
    const { root: e14 } = this.context;
    e14.removeEventListener("mousedown", this.onPointerEventStart), e14.removeEventListener("touchstart", this.onPointerEventStart), e14.removeEventListener("mouseup", this.onPointerEventEnd), e14.removeEventListener("touchend", this.onPointerEventEnd), e14.removeEventListener("click", this.onPointerEventEnd);
  }
  componentDidUpdate(e14, t10) {
    const { state: { status: n10 } } = this;
    t10.status !== n10 && this.onToggle();
  }
  render() {
    const { props: { items: e14, size: t10, mode: n10, children: r10, autoHideScrollbar: o10, logo: a10, customCSS: i10, dataAid: s10, legacyMode: l10, toggleText: c10, toggleTitle: u10, toggleContent: d10, pinBtnIcon: p10, panelWidth: m10, hidePinBtn: h10, resizablePanel: f10, minResizeWidth: g10, maxResizeWidth: y10, ariaLabel: v10, pinBtnTitle: b10 }, state: { activePanelId: S10, status: C10, pinned: x10, logoContainerElement: w10 } } = this;
    const T10 = kp(IP, i10, { [_P("expanded")]: "expanded" === C10, [_P("panel")]: "panel" === C10, [_P("drawer")]: "drawer" === n10, [_P("size-small")]: "small" === t10, [_P("size-large")]: "large" === t10, [_P("legacy")]: l10 });
    const E10 = { dataAid: s10 ? `${s10}_toggle` : void 0, block: true, accent: l10 ? "icon" : "full", background: l10 ? "transparent" : "default", size: t10, icon: eN.toggle[t10], text: c10, title: u10 || c10, onClick: this.onToggleClick };
    const F10 = e14 ? e14.map(this.mapItems) : [];
    const M10 = { direction: "vertical", style: { container: { position: "unset" } }, color: "contrast", size: "small", growOnHover: "expanded" === C10, autoHide: o10 };
    let k10 = [];
    let P10;
    const N10 = this.getPanelsAndSplitters(r10);
    N10.length > 0 && (P10 = N10.find((e15) => e15.props.id === S10), k10 = N10.map(this.mapTogglesAndSplitters));
    const D10 = kp(RP, { [AP("visible")]: "panel" === C10 });
    const L10 = x10 ? eN.pinOff : eN.pin;
    const H10 = { dataAid: s10 ? `${s10}_pin` : void 0, block: true, icon: p10 || "large" === t10 ? L10.default : L10.small, accent: "text+icon", background: "transparent", size: "large" === t10 ? "default" : "small", customCSS: kp(JP, { [QP("pinned")]: x10 }), onClick: this.onPinClick, title: b10 };
    const I10 = { handlerSide: "right", disabled: !f10 || "panel" !== C10, minSize: g10, maxSize: y10, onResize: this.onResize, onResizeEnd: this.onResizeEnd, customCSS: D10, defaultSize: m10, keepAspectRatio: true };
    return ep.createElement("div", { className: T10, ref: (e15) => this._menuDiv = e15, "data-aid": s10, role: "navigation", "aria-label": v10 || "menu" }, (() => {
      if (!a10 || !w10) return null;
      const e15 = kp(ZP, { [GP("expanded")]: "expanded" === C10, [GP("drawer")]: "drawer" === n10, [GP("menu-size-small")]: "small" === t10, [GP("menu-size-large")]: "large" === t10, [GP("size-small")]: !l10 && "small" === a10.size, [GP("size-large")]: l10 || "large" === a10.size });
      return mE.createPortal(ep.createElement(ep.Fragment, null, "drawer" === n10 && ep.createElement("div", { className: kp(UP, qP(`size-${t10}`)) }), ep.createElement("div", { className: e15 }, a10.content)), w10);
    })(), ep.createElement("div", { className: YP, ref: (e15) => this._buttonContainer = e15 }, ep.createElement(qm, __spreadValues({}, E10), d10), ep.createElement(tN, null), k10.length > 0 && k10, k10.length > 0 && ep.createElement(tN, null), F10.length > 0 && ep.createElement("div", { className: KP }, ep.createElement(bF, __spreadValues({}, M10), F10))), ep.createElement(DP, __spreadProps(__spreadValues({}, I10), { ref: (e15) => this._panelContainer = e15 }), P10 && ep.createElement(ep.Fragment, null, ep.createElement("h2", { className: OP }, P10.props.toggle.text, !h10 && ep.createElement(qm, __spreadValues({}, H10))), ep.createElement("div", { className: BP }, P10.props.customScroll ? P10 : ep.createElement(bF, null, P10)))));
  }
}
nN.contextType = Sm, nN.defaultProps = { autoHideScrollbar: true, defaultStatus: "collapsed", hidePinBtn: false, legacyMode: false, mode: "panel", noCloseOnWindowClick: false, size: "large", resizablePanel: true, minResizeWidth: 160, maxResizeWidth: 0.8 };
const rN = EP(nN);
const oN = (e14) => e14.notificationPanel ? ep.createElement(rN, __spreadValues({}, e14)) : ep.createElement(nN, __spreadValues({}, e14));
const aN = (e14, t10) => `${e14}-${t10}-root`;
const iN = ({ id: e14, customCSS: t10, ariaLabel: n10 }) => {
  const { API: r10 } = ep.useContext(Sm);
  return tp.createElement("div", { id: aN(r10.namespace, e14), className: t10, role: "navigation", "aria-label": n10 || "sidebar" });
};
const [sN, lN, cN] = Dp("gc-sidebar-panel");
const [uN] = cN("placeholder");
class dN extends ep.Component {
  render() {
    const { children: e14, customScroll: t10, customCSS: n10, dataAid: r10, toggle: { text: o10 } } = this.props;
    const a10 = kp(sN, n10, { [lN("fill-container")]: t10 });
    return ep.createElement("div", { className: a10, "data-aid": r10, role: "region", "aria-label": o10 }, e14);
  }
}
om.set(dN, "SidebarPanel");
const pN = ({ text: e14 }) => ep.createElement("div", { className: uN }, e14);
const mN = "__gc-sidebar-notifications__";
class hN extends tp.Component {
  render() {
    const _a2 = this.props, { id: e14, dataAid: t10, customCSS: n10, children: r10, toggle: o10, alwaysVisible: a10, customScroll: i10, placeholder: s10, notifications: l10 } = _a2, c10 = __objRest(_a2, ["id", "dataAid", "customCSS", "children", "toggle", "alwaysVisible", "customScroll", "placeholder", "notifications"]);
    const u10 = __spreadValues({ notifications: l10 }, c10);
    const d10 = { id: e14, toggle: o10, customScroll: i10, dataAid: t10, customCSS: kp(lN("notifications"), n10) };
    return tp.createElement(dN, __spreadValues({}, d10), l10.length > 0 ? tp.createElement(lP, __spreadValues({}, u10)) : tp.createElement(pN, { text: s10 }));
  }
}
hN.defaultProps = { id: mN, toggle: { icon: nf(Uh), text: "Notifications" }, customScroll: true, placeholder: "There are no notifications", alwaysVisible: false };
const [fN, gN, yN] = Dp("gc-sidebar");
const [vN, bN] = yN("menu");
const [SN] = yN("container");
const [CN] = yN("toggle-area");
const [xN] = yN("toggle-area-button");
const [wN] = yN("toggle-area-bar");
const TN = nf(qh);
const EN = { small: Rp, default: Rp, large: Ap };
const FN = { small: Rp, default: Ap, large: Op };
class MN extends ep.Component {
  constructor() {
    super(...arguments), this._panelIds = [], this._container = null, this._menu = null, this._panelContainer = null, this._transitionSubscribers = { start: [], end: [] }, this._prevPanelsAmount = 0, this._panelsAmount = 0, this.getPanels = (e14) => {
      const { notificationPanel: t10, notificationsData: n10 } = this.props;
      const r10 = ep.Children.toArray(e14).filter((e15) => ep.isValidElement(e15) && om.is(e15.type, dN));
      if (n10 && t10) {
        const { notifications: e15, amount: o10 } = n10;
        const a10 = o10.notifications > 0 || t10.alwaysVisible;
        const i10 = __spreadProps(__spreadValues({}, t10), { notifications: e15 });
        a10 && r10.push(ep.createElement(hN, __spreadValues({}, i10)));
      }
      return this._panelsAmount = r10.length, r10;
    }, this.state = { activePanelId: this.props.defaultPanelId || null, status: this.props.defaultPanelId ? "expanded" : "collapsed", inTransition: false, controlsRoot: null }, this.onToggle = () => {
      var _a2;
      const { _container: e14, _transitionSubscribers: t10, props: { onToggle: n10 }, state: { status: r10 } } = this;
      n10 && n10(r10), t10.start.forEach((e15) => e15(r10)), (_a2 = e14 == null ? void 0 : e14.element) == null ? void 0 : _a2.addEventListener("transitionend", this.onTransitionEnd);
    }, this.onTransitionEnd = (e14) => {
      const t10 = this._container.element;
      e14.target === t10 && (t10.removeEventListener("transitionend", this.onTransitionEnd), this._transitionSubscribers.end.forEach((e15) => e15(this.state.status)));
    }, this.open = (e14) => {
      const { activePanelId: t10 } = this.state;
      if (e14 && this._panelIds.includes(e14)) this.setState({ activePanelId: e14, status: "expanded" });
      else {
        const e15 = t10 || this._panelIds[0];
        this.setState({ activePanelId: e15, status: "expanded" });
      }
    }, this.close = () => {
      const { status: e14 } = this.state;
      "expanded" === e14 && this.setState({ status: "collapsed" });
    }, this.subscribeToTransition = ({ start: e14, end: t10 }) => (e14 && this._transitionSubscribers.start.push(e14), t10 && this._transitionSubscribers.end.push(t10), () => {
      e14 && (this._transitionSubscribers.start = this._transitionSubscribers.start.filter((t11) => t11 !== e14)), t10 && (this._transitionSubscribers.end = this._transitionSubscribers.end.filter((e15) => e15 !== t10));
    }), this.onTabSelect = (e14) => {
      const { activePanelId: t10, status: n10 } = this.state;
      "collapsed" !== n10 && e14 === t10 || this.setState({ activePanelId: e14, status: "expanded" });
    }, this.toggleSidebar = () => {
      const { status: e14, activePanelId: t10 } = this.state;
      const n10 = t10 || this._panelIds[0];
      const r10 = "collapsed" === e14 ? "expanded" : "collapsed";
      this.setState({ status: r10, activePanelId: n10 });
    }, this.setControlsRoot = (e14) => {
      if (!e14) return this.setState({ controlsRoot: null });
      const t10 = document.getElementById(aN(this.context.API.namespace, e14));
      t10 !== this.state.controlsRoot && this.setState({ controlsRoot: t10 });
    }, this.setMenuMinWidth = () => {
      if (!this._menu) return;
      const { toggleSize: e14, hidePanelToggles: t10 } = this.props;
      const n10 = window.getComputedStyle(this._menu);
      const r10 = parseFloat(n10.getPropertyValue("padding-left"));
      const o10 = parseFloat(n10.getPropertyValue("padding-right"));
      const a10 = EN[e14];
      const i10 = t10 ? 0 : FN[e14] * this._panelsAmount;
      this._prevPanelsAmount = this._panelsAmount, this._collapsedMenuWidth = a10 + i10 + r10 + o10, this.forceUpdate();
    }, this.onResizeStart = () => {
      var _a2;
      (_a2 = this._menu) == null ? void 0 : _a2.classList.add("gc-disable-transition");
    }, this.onResize = (e14) => {
      const { status: t10 } = this.state;
      this._resizedWidth = e14, this._panelContainer && (this._panelContainer.style.width = `${e14}px`), "expanded" === t10 && this._menu && (this._menu.style.width = `${e14}px`);
    }, this.onResizeEnd = () => {
      var _a2;
      const { onResizeEnd: e14 } = this.props;
      e14 && this._resizedWidth && e14(this._resizedWidth), this._transitionSubscribers.end.forEach((e15) => e15(this.state.status)), (_a2 = this._menu) == null ? void 0 : _a2.classList.remove("gc-disable-transition");
    };
  }
  static getDerivedStateFromProps(e14, t10) {
    var _a2;
    let n10 = null;
    return t10.activePanelId !== mN || e14.notificationPanel.alwaysVisible || e14.notificationsData.amount.notifications || function(e15) {
      n10 || (n10 = __spreadValues({}, t10)), n10 = __spreadValues(__spreadValues({}, n10), e15);
    }({ activePanelId: (_a2 = e14.defaultPanelId) != null ? _a2 : null }), n10;
  }
  componentDidMount() {
    const { props: { controlsContainerId: e14 }, context: { API: t10 } } = this;
    t10.current.sidebar = { open: this.open, close: this.close, onTransition: this.subscribeToTransition }, e14 && this.setControlsRoot(e14), this.setMenuMinWidth(), this.subscribeToTransition({ start: () => this.setState({ inTransition: true }), end: () => this.setState({ inTransition: false }) });
  }
  componentDidUpdate(e14, t10) {
    const { props: { toggleSize: n10, onPanelChange: r10, hidePanelToggles: o10, controlsContainerId: a10 }, state: { status: i10, activePanelId: s10 } } = this;
    t10.status !== i10 && this.onToggle(), "expanded" !== i10 || this._panelIds.find((e15) => e15 === s10) || this.close(), r10 && t10.activePanelId !== s10 && r10(s10), e14.controlsContainerId !== a10 && this.setControlsRoot(a10), this._collapsedMenuWidth && this._prevPanelsAmount === this._panelsAmount && e14.toggleSize === n10 && e14.hidePanelToggles === o10 || this.setMenuMinWidth();
  }
  render() {
    var _a2;
    const { props: { children: e14, customCSS: t10, toggleSize: n10, withSideToggle: r10, dataAid: o10, hidePanelToggles: a10, collapseTitle: i10, expandTitle: s10, notificationsData: l10, defaultWidth: c10, resizable: u10, minResizeWidth: d10, maxResizeWidth: p10 }, state: { activePanelId: m10, status: h10, controlsRoot: f10 } } = this;
    const g10 = this.getPanels(e14);
    if (!g10.length) return null;
    const y10 = g10.find((e15) => e15.props.id === m10);
    const v10 = g10.map((e15, t11) => {
      const { toggle: n11, id: r11 } = e15.props;
      0 === t11 && (this._panelIds = []), this._panelIds.push(r11);
      const o11 = "expanded" === h10 && r11 === m10 && n11.text || void 0;
      let a11 = n11.badge && __spreadValues({ nearIcon: true }, n11.badge);
      if (r11 === mN) {
        const { amount: e16, level: t12 } = l10;
        a11 = e16.notifications > 0 ? { nearIcon: true, rounded: true, content: e16.notifications, level: t12 } : void 0;
      }
      return __spreadProps(__spreadValues({}, n11), { id: r11, text: o11, badge: a11 });
    });
    const b10 = { dataAid: o10 ? `${o10}_panel-toggles` : void 0, tabs: v10, design: "simplified", selectedTabId: "expanded" === h10 && m10 || void 0, onTabSelect: this.onTabSelect, size: n10 };
    const S10 = "collapsed" === h10 ? s10 : i10;
    const C10 = { dataAid: o10 ? `${o10}_toggle` : void 0, icon: TN, background: "transparent", onClick: this.toggleSidebar, size: "large" === n10 ? "default" : "small", title: S10 };
    const x10 = kp(fN, t10, { [gN("collapsed")]: "collapsed" === h10, [gN("size-sm")]: "small" === n10, [gN("size-md")]: "default" === n10 });
    const w10 = a10 && "collapsed" === h10;
    const T10 = kp(vN, { [bN("collapsed")]: "collapsed" === h10, [bN("hidden-toggles")]: w10, [bN("size-md")]: "default" === n10 });
    const E10 = { handlerSide: "left", disabled: !u10 || "collapsed" === h10, minSize: d10, maxSize: p10, onResizeStart: this.onResizeStart, onResize: this.onResize, onResizeEnd: this.onResizeEnd, customCSS: x10, dataAid: o10, keepAspectRatio: true, defaultSize: c10 };
    const F10 = (_a2 = this._resizedWidth) != null ? _a2 : c10;
    const M10 = { width: "expanded" === h10 ? F10 : this._collapsedMenuWidth };
    const k10 = ep.createElement("div", { className: T10, ref: (e15) => this._menu = e15, style: M10 }, !w10 && ep.createElement(IM, __spreadValues({}, b10)), ep.createElement(qm, __spreadValues({}, C10)));
    const P10 = "expanded" === h10 || this.state.inTransition;
    return ep.createElement(DP, __spreadProps(__spreadValues({}, E10), { ref: (e15) => this._container = e15 }), f10 ? mE.createPortal(k10, f10) : k10, ep.createElement("div", { className: SN, ref: (e15) => this._panelContainer = e15, style: { width: F10 } }, r10 && ep.createElement("div", { className: CN }, ep.createElement("button", { className: xN, onClick: this.toggleSidebar, "data-aid": o10 && `${o10}_side-toggle`, title: S10 }), ep.createElement("div", { className: wN })), P10 && y10 && (y10.props.customScroll ? y10 : ep.createElement(bF, { direction: "vertical" }, y10))));
  }
}
MN.contextType = Sm, MN.defaultProps = { collapseTitle: "Collapse", expandTitle: "Expand", toggleSize: "large", withSideToggle: false, resizable: true, hidePanelToggles: false, minResizeWidth: 230, maxResizeWidth: 0.8, defaultWidth: 330 };
const kN = EP(MN);
const PN = (e14) => e14.notificationPanel ? ep.createElement(kN, __spreadValues({}, e14)) : ep.createElement(MN, __spreadValues({}, e14));
const [NN, DN, LN] = Dp("gc-label");
const [HN] = LN("label");
const [IN] = LN("icon");
const [_N] = LN("tooltip");
const [VN] = LN("content");
const RN = tp.createContext({});
const AN = (e14) => {
  const { block: t10 = false, disabled: n10 = false, position: r10 = "top", textAlignment: o10 = "left", size: a10 = "default", width: i10 = "default", dataAid: s10, children: l10, customCSS: c10, highlightRange: u10, htmlFor: d10, icon: p10, id: m10, label: h10, tooltip: f10 } = e14;
  const g10 = rf(ih);
  const y10 = kp(NN, c10, { [DN("block")]: t10, [DN(`position-${r10}`)]: "top" !== r10, [DN(`alignment-${o10}`)]: "left" !== o10 || "right" === r10, [DN("with-tooltip")]: f10, [DN("with-icon")]: p10, [DN(`size-${a10}`)]: "default" !== a10, [DN("disabled")]: n10, [DN("width-half")]: "50%" === i10, [DN("width-auto")]: "auto" === i10 });
  const v10 = { before: h10, highlight: void 0, after: void 0 };
  u10 && h10 && (v10.before = h10.slice(0, u10[0]), v10.highlight = h10.slice(u10[0], u10[1]), v10.after = h10.slice(u10[1]));
  const b10 = ep.useMemo(() => ({ labelId: m10, labelText: h10, labelFor: d10 }), [m10, h10, d10]);
  return tp.createElement("div", { className: y10, "data-aid": s10 }, tp.createElement("label", { id: m10, htmlFor: d10, className: HN }, p10 ? tp.createElement("div", { className: IN }, tp.createElement(Fm, { icon: p10 })) : tp.createElement("span", null, v10.before, v10.highlight && tp.createElement("b", null, v10.highlight), v10.after), f10 && tp.createElement("div", { className: _N, title: f10.text, onClick: f10.onClick }, tp.createElement(Fm, { icon: f10.icon || g10 }))), tp.createElement("div", { className: VN }, tp.createElement(RN.Provider, { value: b10 }, l10)));
};
const [ON, BN] = Dp("gc-textarea");
class zN extends ep.Component {
  constructor() {
    super(...arguments), this._area = null, this.onFocus = (e14) => {
      const { selectOnFocus: t10, onFocus: n10 } = this.props;
      t10 && e14.target.select(), n10 && n10(e14);
    }, this.focus = () => {
      this._area && this._area.focus();
    };
  }
  render() {
    const { id: e14, name: t10, block: n10, rounded: r10, size: o10, width: a10, textAlign: i10, invalid: s10, placeholder: l10, defaultValue: c10, value: u10, title: d10, disabled: p10, dataAid: m10, autoFocus: h10, spellCheck: f10, cols: g10, rows: y10, resize: v10, customCSS: b10, onChange: S10, onBlur: C10, onKeyDown: x10, onKeyUp: w10, onKeyPress: T10, height: E10 } = this.props;
    const F10 = kp(ON, b10, { [BN("block")]: n10, [BN(`text-align-${i10}`)]: "left" !== i10, [BN("invalid")]: s10, [BN(`resize-${v10}`)]: "none" !== v10, [BN("size-sm")]: "small" === o10, [BN("size-lg")]: "large" === o10, [Gp]: r10 });
    let M10 = {};
    g10 || (M10.width = a10), y10 || (M10.height = E10);
    const k10 = { id: e14, name: t10, className: F10, style: M10, placeholder: l10, defaultValue: c10, title: d10, value: u10, rows: y10, cols: g10, disabled: p10, autoFocus: h10, spellCheck: f10, onChange: S10, onFocus: this.onFocus, onBlur: C10, onKeyDown: x10, onKeyUp: w10, onKeyPress: T10 };
    return ep.createElement("textarea", __spreadProps(__spreadValues({}, k10), { ref: (e15) => this._area = e15, "data-aid": m10 }));
  }
}
zN.defaultProps = { autoFocus: false, block: false, disabled: false, invalid: false, rounded: false, selectOnFocus: false, spellCheck: false, textAlign: "left", resize: "none", size: "default" };
const $N = (e14, t10, n10, r10, o10 = "both", a10) => ({ category: e14, label: t10, type: n10, valuePath: r10, mode: o10, meta: a10 });
function WN(e14, t10) {
  if (!e14) throw new Error(`Property descriptor cannot be '${e14}'`);
  return t10 ? e14.valuePath ? __spreadProps(__spreadValues({}, e14), { valuePath: `${t10}.${e14.valuePath}` }) : __spreadProps(__spreadValues({}, e14), { valuePath: t10 }) : e14;
}
const jN = (e14) => (t10) => {
  const n10 = e14 && e14.split(".") || [];
  let r10 = t10;
  for (let e15 = 0; r10 && e15 < n10.length; e15++) r10 = r10[n10[e15]];
  return r10;
};
const ZN = (e14 = "") => (t10) => e14.split(".").reduceRight((e15, t11) => ({ [t11]: e15 }), { $set: t10 });
const GN = (e14) => e14 instanceof Date;
const UN = (e14) => null != e14 && "object" == typeof e14;
const qN = (e14, ...t10) => Object.prototype.hasOwnProperty.call(e14, ...t10);
const YN = (e14) => UN(e14) && ((e15) => 0 === Object.keys(e15).length)(e14);
const KN = (e14, t10) => {
  if (e14 === t10) return {};
  if (!UN(e14) || !UN(t10)) return t10;
  const n10 = Object.keys(e14).reduce((e15, n11) => (qN(t10, n11) || (e15[n11] = void 0), e15), /* @__PURE__ */ Object.create(null));
  return GN(e14) || GN(t10) ? e14.valueOf() == t10.valueOf() ? {} : t10 : Object.keys(t10).reduce((n11, r10) => {
    if (!qN(e14, r10)) return n11[r10] = t10[r10], n11;
    const o10 = KN(e14[r10], t10[r10]);
    return !YN(o10) || GN(o10) || !YN(e14[r10]) && YN(t10[r10]) ? (n11[r10] = o10, n11) : n11;
  }, n10);
};
const XN = { $multipleValues: [], toString: () => "<Multiple Values>" };
function JN(e14, t10, n10) {
  return n10.indexOf(e14) === t10;
}
function QN(e14) {
  return 0 === e14.length ? {} : 1 === e14.length ? e14[0] : e14.every(Array.isArray) ? null : e14.every(Xp) ? function(e15) {
    let t10 = [];
    e15.forEach((e16) => {
      t10.push(...Object.getOwnPropertyNames(e16));
    }), t10 = t10.filter(JN);
    const n10 = {};
    for (const r10 of t10) {
      const t11 = e15.map((e16) => e16[r10]);
      n10[r10] = QN(t11);
    }
    return n10;
  }(e14) : function(e15) {
    let t10 = true;
    for (let n10 = 1; n10 < e15.length; n10++) t10 = t10 && e15[n10 - 1] === e15[n10];
    return t10;
  }(e14) ? e14[0] : XN;
}
const eD = (e14, t10) => !e14 && !t10 || !(!e14 && t10 || e14 && !t10) && 0 === Object.keys(KN(e14, t10)).length;
function tD(e14) {
  if (0 === e14.length) return [];
  if (1 === e14.length && e14[0]) return Array.isArray(e14[0]) ? e14[0] : [];
  const t10 = e14[0];
  const n10 = e14.slice(1);
  const r10 = t10.map((e15) => {
    const t11 = n10.map((t12) => t12.find((t13) => {
      return r12 = e15, !(!(n11 = t13) || !r12) && n11.valuePath === r12.valuePath && n11.category === r12.category && n11.label === r12.label && n11.type === r12.type && eD(n11.meta, r12.meta);
      var n11, r12;
    }));
    if (t11.indexOf(void 0) >= 0) return null;
    const r11 = t11.map(({ mode: e16 }) => e16 || "both");
    const o10 = e15.mode || "both";
    return r11.every((e16) => e16 === o10) ? e15 : $N(e15.category, e15.label, e15.type, e15.valuePath, "both");
  }).filter((e15) => e15);
  return r10;
}
const [nD, , rD] = Dp("gc-property-grid");
const [oD] = rD("scroll");
const [aD, , iD] = Dp("gc-property-category");
const [sD] = iD("flex-container");
const [lD, cD] = iD("content");
const uD = cD("collapsed");
const [dD] = iD("title");
const [pD] = Dp("gc-unknown-editor");
const mD = ({ dataAid: e14, text: t10, type: n10 }) => ep.createElement("div", { className: pD, "data-aid": e14 }, `${t10} ${n10}`);
class hD extends ep.Component {
  constructor() {
    super(...arguments), this.onToggleClick = () => {
      const { categoryKey: e14, onToggle: t10 } = this.props;
      t10 == null ? void 0 : t10(`category|${e14}`);
    }, this.renderPropertyEditor = (e14) => {
      var _a2;
      const { propertyEditors: t10, setProperty: n10, environment: r10, objectName: o10, searchQuery: a10, labelWidth: i10, labelPosition: s10, dataAid: l10, textUnknownProperty: c10, t: u10, onEditorToggle: d10, disabled: p10 } = this.props;
      const { descriptor: m10 } = e14;
      const h10 = `${o10}-${m10.type}-${m10.valuePath}-${m10.label}`;
      const f10 = t10[m10.type];
      const g10 = __spreadProps(__spreadValues({}, e14), { onToggle: d10, setProperty: n10, environment: r10, searchQuery: a10, labelWidth: i10, labelPosition: s10, t: u10, dataAid: l10 ? `${l10}_editor_${m10.type}_${m10.valuePath}` : void 0, disabled: p10 || ((_a2 = m10.meta) == null ? void 0 : _a2.disabled) });
      return f10 ? f10(g10, h10) : ep.createElement(mD, { key: h10, text: c10, type: m10.type, dataAid: l10 && `${l10}_unknown-editor` });
    };
  }
  shouldComponentUpdate({ shouldUpdate: e14 }) {
    return e14;
  }
  render() {
    const { name: e14, properties: t10, dataAid: n10, t: r10, onToggle: o10, searchQuery: a10, categoryKey: i10 } = this.props;
    const { onToggleClick: s10 } = this;
    return ep.createElement("fieldset", { className: aD, "data-aid": n10 && `${n10}_category` }, ep.createElement(yD.Consumer, null, ({ expandedStates: n11 }) => {
      var _a2, _b2;
      const r11 = t10.map(this.renderPropertyEditor);
      const l10 = !!a10 && ((_a2 = r11.length) != null ? _a2 : 0) > 0 || ((_b2 = n11 == null ? void 0 : n11.categories[fD(i10)]) != null ? _b2 : true);
      const c10 = o10 ? { defaultAccent: "icon", defaultBackground: "transparent", rounded: true, items: [{ type: "button", icon: nf(oh, { rotate: l10 ? "180" : void 0 }), onClick: s10, dataAid: `${e14}|expanded:${!!l10}` }] } : void 0;
      const u10 = o10 ? s10 : void 0;
      return ep.createElement("div", { className: sD }, ep.createElement("div", { className: kp(lD, { [uD]: !l10 }) }, r11), e14 && ep.createElement(LE, { headingLevel: "legend", actions: c10, text: e14, onClick: u10, customCSS: dD, level: "info" }));
    }));
  }
}
const fD = (e14) => `category|${e14}`;
const gD = ({ category: e14, type: t10, valuePath: n10, mode: r10 }) => `editor|${e14}|${t10}|${n10}|${r10}`;
const yD = ep.createContext({});
const [vD, , bD] = Dp("gc-property-list");
const [SD] = bD("placeholder");
const CD = ({ text: e14 }) => ep.createElement("div", { className: SD }, e14);
const xD = (e14 = { categories: {}, editors: {} }) => {
  const [t10, n10] = ep.useState(e14);
  const r10 = ({ categories: e15, editors: t11 }) => ({ categories: __spreadValues({}, e15), editors: __spreadValues({}, t11) });
  return { expandedStates: t10, updateStates: n10, onCategoryToggle: (e15) => {
    const o10 = r10(t10);
    o10.categories[e15] = false === o10.categories[e15], n10(o10);
  }, onEditorToggle: (e15) => {
    n10((t11) => {
      const n11 = r10(t11);
      return n11.editors[e15] = true !== n11.editors[e15], n11;
    });
  } };
};
class wD extends ep.PureComponent {
  constructor() {
    super(...arguments), this.setProperty = (e14, t10) => {
      (this.props.setProperty || Jp)(e14, t10);
    }, this.getCategoryState = (e14 = "") => {
      var _a2;
      const { expandedStates: t10 } = this.props;
      return (_a2 = t10 == null ? void 0 : t10.categories[e14]) != null ? _a2 : void 0;
    }, this.getEditorState = (e14 = "") => {
      var _a2;
      const { expandedStates: t10 } = this.props;
      return (_a2 = t10 == null ? void 0 : t10.editors[e14]) != null ? _a2 : void 0;
    }, this.getVisibleProperties = () => {
      const { descriptors: e14, objectValue: t10, defaultValue: n10, customFilter: r10, displayMode: o10, sort: a10, searchQuery: i10, t: s10 } = this.props;
      let l10 = wD.generateProperties(e14, t10, n10, r10);
      return l10 = i10 ? l10.filter((e15) => "advanced" === e15.descriptor.mode || "both" === e15.descriptor.mode) : l10.filter((e15) => e15.descriptor.mode === o10 || "both" === e15.descriptor.mode), a10 && l10.sort((e15, t11) => {
        var _a2, _b2;
        const n11 = (_a2 = s10 == null ? void 0 : s10(e15.descriptor.label)) != null ? _a2 : e15.descriptor.label;
        const r11 = (_b2 = s10 == null ? void 0 : s10(t11.descriptor.label)) != null ? _b2 : t11.descriptor.label;
        return n11 > r11 ? 1 : n11 < r11 ? -1 : 0;
      }), l10;
    }, this.getObjectName = (e14) => e14 && (Array.isArray(e14) ? e14.map((e15) => e15.name).join("-") : e14.name), this.getPropsDiff = () => {
      const { objectValue: e14, environment: t10, searchQuery: n10 } = this.props;
      let r10;
      if (this._prevEnvironment && t10) {
        const e15 = KN(this._prevEnvironment, t10);
        r10 = Object.keys(e15).length ? e15 : void 0;
      }
      let o10;
      this._prevEnvironment = t10;
      let a10 = false;
      if (!r10 && this._prevObjectValue) {
        let t11 = {};
        this.getObjectName(e14) !== this.getObjectName(this._prevObjectValue) ? a10 = true : t11 = Array.isArray(e14) ? e14.reduce((e15, t12, n11) => __spreadValues(__spreadValues({}, e15), KN(this._prevObjectValue[n11], t12)), {}) : KN(this._prevObjectValue, e14), o10 = Object.keys(t11).length ? t11 : void 0;
      }
      this._prevObjectValue = e14;
      const i10 = n10 !== this._prevSearchQuery;
      return this._prevSearchQuery = n10, { environmentDiff: r10, objectValueDiff: o10, searchQueryDiff: i10, forceUpdate: a10 };
    }, this.generateCategories = (e14, t10) => {
      const { environmentDiff: n10, objectValueDiff: r10, searchQueryDiff: o10, forceUpdate: a10 } = this.getPropsDiff();
      const i10 = {};
      e14.forEach((e15) => {
        const { category: s11, valuePath: l10 } = e15.descriptor;
        const c10 = t10 ? t10(s11) : s11;
        if (i10[c10] || (i10[c10] = { shouldUpdate: false, properties: [], key: s11 }), i10[c10].properties.push(e15), void 0 !== n10 || o10 || a10) return e15.shouldUpdate = true, void (i10[c10].shouldUpdate = true);
        if (void 0 === r10) return e15.shouldUpdate = false, void (i10[c10].shouldUpdate = false);
        if ("" === l10) return e15.shouldUpdate = true, void (i10[c10].shouldUpdate = true);
        const u10 = l10.split(".");
        let d10 = true;
        let p10;
        for (let e16 = 0; e16 < u10.length; e16++) {
          const t11 = 0 === e16 ? r10 : p10;
          if (!Xp(t11) || !(u10[e16] in t11)) {
            d10 = false;
            break;
          }
          p10 = t11[u10[e16]];
        }
        e15.shouldUpdate = d10, d10 && (i10[c10].shouldUpdate = true);
      });
      const s10 = this._prevCategories;
      return s10 && Object.keys(i10).forEach((e15) => {
        const { properties: t11, shouldUpdate: n11 } = i10[e15];
        const r11 = s10[e15];
        if (!r11) return;
        const { updCategoryProperties: o11, descriptorsDiffs: a11 } = ((e16, t12) => {
          const n12 = [];
          const r12 = t12.map((t13, r13) => {
            if (t13.shouldUpdate) return t13;
            const o12 = KN(e16[r13], t13.descriptor);
            return Object.keys(o12).length && (t13.shouldUpdate = true, n12.push(o12)), t13;
          });
          return { updCategoryProperties: r12, descriptorsDiffs: n12 };
        })(r11, t11);
        i10[e15].properties = o11, n11 || (r11.length === t11.length ? i10[e15].shouldUpdate = a11.some((e16) => Object.keys(e16).length > 0) : i10[e15].shouldUpdate = true);
      }), this._prevCategories = Object.entries(i10).reduce((e15, [t11, n11]) => __spreadProps(__spreadValues({}, e15), { [t11]: n11.properties.map((e16) => e16.descriptor) }), {}), i10;
    };
  }
  static translateProps(e14, t10, n10, r10) {
    return e14.map((e15) => {
      if (r10 && false === r10(e15, t10)) return null;
      const o10 = (a10 = e15.valuePath, { getValue: (e16) => {
        const t11 = a10 && a10.split(".") || [];
        let n11 = e16;
        for (let e17 = 0; n11 && e17 < t11.length; e17++) n11 = n11[t11[e17]];
        return n11;
      }, setValue: (e16, t11) => {
        const n11 = a10.split(".");
        let r11 = e16;
        for (let e17 = 0; e17 < n11.length - 1; e17++) {
          const t12 = n11[e17];
          t12 in r11 || (r11[t12] = {}), r11 = r11[t12];
        }
        r11[n11[n11.length - 1]] = t11;
      } });
      var a10;
      return { descriptor: e15, value: o10.getValue(t10), defaultValue: n10 && o10.getValue(n10) };
    }).filter((e15) => e15);
  }
  render() {
    const { propertyEditors: e14, environment: t10, labelWidth: n10, dataAid: r10, customCSS: o10, descriptors: a10, objectValue: i10, labelPosition: s10, searchQuery: l10, emptyListPlaceholder: c10, noCommonProperties: u10, textUnknownProperty: d10, t: p10, onCategoryToggle: m10, onEditorToggle: h10, expandedStates: f10, disabled: g10 } = this.props;
    if (!a10.length) return ep.createElement(CD, { text: c10 });
    const y10 = this.getObjectName(i10);
    if (!y10) return console.warn('Failed to render PropertyList. Make sure PropertyList receives "objectValue" prop which contains a "name" property'), null;
    const v10 = this.getVisibleProperties();
    if (!v10.length) return ep.createElement(CD, { text: u10 });
    const b10 = this.generateCategories(v10, p10);
    return ep.createElement("div", { className: kp(vD, o10), "data-aid": r10 && `${r10}_${y10}` }, ep.createElement(yD.Provider, { value: { expandedStates: f10 } }, Object.keys(b10).map((o11) => {
      const { properties: a11, shouldUpdate: i11, key: c11 } = b10[o11];
      const u11 = { name: o11, categoryKey: c11, setProperty: this.setProperty, disabled: g10, propertyEditors: e14, environment: t10, labelWidth: n10, labelPosition: s10, dataAid: r10, objectName: y10, textUnknownProperty: d10, searchQuery: l10, properties: a11, shouldUpdate: i11, t: p10, onToggle: m10, onEditorToggle: h10 };
      return ep.createElement(hD, __spreadValues({ key: o11 }, u11));
    })));
  }
}
wD.defaultProps = { emptyListPlaceholder: "Select an item to see properties", noCommonProperties: "There are no common properties", textUnknownProperty: "Unknown Property:", displayMode: "advanced", labelPosition: "left", labelWidth: "default" }, wD.generateProperties = (e14, t10, n10, r10) => {
  let o10 = [];
  return e14 && (Array.isArray(t10) && (t10 = QN(t10), Array.isArray(n10) && (n10 = QN(n10)), Array.isArray(e14) && Array.isArray(e14[0]) && (e14 = tD(e14))), o10 = wD.translateProps(e14, t10, n10, r10)), o10;
};
const [TD, ED] = rD("header");
const [FD, MD] = rD("button");
const [kD] = rD("button-back");
const [PD] = rD("container");
const ND = { search: nf(Eh), options: nf(vh, { rotate: "90" }), back: nf(bh, { rotate: "90" }), close: nf(xh) };
class DD extends ep.Component {
  constructor() {
    super(...arguments), this.state = { searchEnabled: false, searchQuery: "" }, this.onSearchInput = (e14) => {
      this.setState({ searchQuery: e14.target.value });
    }, this.onKeyDown = (e14) => {
      e14.stopPropagation(), e14.which === _p && this.closeSearch();
    }, this.onClick = () => {
      const { searchEnabled: e14 } = this.state;
      e14 ? this.closeSearch() : this.setState({ searchEnabled: true });
    }, this.closeSearch = () => this.setState({ searchEnabled: false, searchQuery: "" });
  }
  render() {
    const _a2 = this, { props: _b2 } = _a2, _c2 = _b2, { displayMode: e14, options: t10, descriptors: n10, selectionName: r10, optionsWidth: o10, tabs: a10, selectedTabId: i10, onTabSelect: s10, onBackClick: l10, customCSS: c10, dataAid: u10, emptyListPlaceholder: d10, closeSearchBtnTitle: p10, gridSearchPlaceholder: m10, listCustomCSS: h10, disabled: f10 } = _c2, g10 = __objRest(_c2, ["displayMode", "options", "descriptors", "selectionName", "optionsWidth", "tabs", "selectedTabId", "onTabSelect", "onBackClick", "customCSS", "dataAid", "emptyListPlaceholder", "closeSearchBtnTitle", "gridSearchPlaceholder", "listCustomCSS", "disabled"]), { state: { searchEnabled: y10, searchQuery: v10 } } = _a2;
    if (!n10.length) return ep.createElement(CD, { text: d10 });
    const b10 = __spreadProps(__spreadValues({}, g10), { searchQuery: v10, descriptors: n10, displayMode: e14, dataAid: u10, emptyListPlaceholder: d10, disabled: f10, customCSS: h10 });
    const S10 = kp(TD, { [ED("with-tabs")]: a10, [ED("search-view")]: y10 });
    const C10 = { direction: "vertical", viewCustomCSS: oD };
    return ep.createElement("div", { className: kp(nD, c10), "data-aid": u10 }, y10 ? (() => {
      let e15;
      if (a10 && i10) {
        const t12 = a10.find((e16) => e16.id === i10);
        t12 && (e15 = `${t12.text}:`);
      }
      void 0 === e15 && (e15 = `${r10}:`);
      const t11 = { dataAid: u10 ? `${u10}_search-toggle` : void 0, icon: ND.close, text: e15, title: p10, accent: "full", size: "small", customCSS: kp(FD, MD("search-mode")), onClick: this.onClick };
      const n11 = { dataAid: u10 ? `${u10}_search-input` : void 0, size: "small", onChange: this.onSearchInput, onKeyDown: this.onKeyDown, value: v10, autoFocus: true, placeholder: m10, onKeyUp: (e16) => e16.stopPropagation(), onKeyPress: (e16) => e16.stopPropagation() };
      return ep.createElement("div", { className: S10 }, ep.createElement(qm, __spreadValues({}, t11)), ep.createElement(KF, __spreadValues({}, n11)));
    })() : (() => {
      const e15 = { dataAid: u10 ? `${u10}_search-toggle` : void 0, icon: ND.search, customCSS: FD, text: a10 ? void 0 : r10, accent: "full", size: "small", disabled: f10, onClick: this.onClick };
      const n11 = { dataAid: u10 ? `${u10}_options` : void 0, hiddenChevron: true, icon: ND.options, accent: "full", items: t10, size: "small", menuWidth: o10, disabled: f10 };
      const c11 = { dataAid: u10 ? `${u10}_tabs` : void 0, selectedTabId: i10, onTabSelect: s10, tabs: a10, block: true, align: "justify", size: "small", design: "transparent" };
      const d11 = { dataAid: u10 ? `${u10}_back` : void 0, icon: ND.back, customCSS: kD, accent: "full", size: "small", onClick: l10 };
      return ep.createElement("div", { className: S10 }, l10 && ep.createElement(qm, __spreadValues({}, d11)), a10 && ep.createElement(IM, __spreadValues({}, c11)), t10 && ep.createElement(UF, __spreadValues({}, n11)), ep.createElement(qm, __spreadValues({}, e15)));
    })(), ep.createElement("div", { className: PD }, ep.createElement(bF, __spreadValues({}, C10), ep.createElement(wD, __spreadProps(__spreadValues({}, b10), { key: `${i10}-${e14}` })))));
  }
}
DD.defaultProps = { emptyListPlaceholder: "Select an item to see properties", gridSearchPlaceholder: "enter property name here...", closeSearchBtnTitle: "Close", noCommonProperties: "There are no common properties", textUnknownProperty: "Unknown Property:", displayMode: "advanced", labelPosition: "left", labelWidth: "default", optionsWidth: "default" };
const LD = (e14, t10) => {
  if (!((e15) => void 0 !== (e15 == null ? void 0 : e15.tooltip))(e14)) return;
  const { tooltip: n10, tooltip: { text: r10 } } = e14;
  return t10 ? __spreadProps(__spreadValues({}, n10), { text: t10(r10) }) : n10;
};
const HD = (e14) => class extends ep.Component {
  render() {
    const _a2 = this.props, { highlightRange: t10, icon: n10, tooltip: r10, labelWidth: o10, dataAid: a10 } = _a2, i10 = __objRest(_a2, ["highlightRange", "icon", "tooltip", "labelWidth", "dataAid"]);
    const { t: s10, descriptor: { label: l10, meta: c10 } } = i10;
    const u10 = { icon: n10, dataAid: a10, highlightRange: t10, width: o10, tooltip: r10 != null ? r10 : LD(c10, s10), block: true, size: "small", position: i10.labelPosition || "left", disabled: i10.disabled };
    return n10 || (u10.label = s10 ? s10(l10) : l10), ep.createElement(AN, __spreadValues({}, u10), ep.createElement(e14, __spreadValues({}, i10)));
  }
};
function ID(e14) {
  var t10;
  return t10 = class extends ep.Component {
    shouldComponentUpdate({ shouldUpdate: e15 }) {
      return !!Kp(e15) || e15;
    }
    render() {
      const { searchQuery: t11, descriptor: n10, descriptor: { label: r10 }, t: o10 } = this.props;
      let a10;
      let i10 = true;
      if (t11) {
        const e15 = (o10 ? o10(r10) : r10).toLowerCase().indexOf(t11.toLowerCase());
        -1 !== e15 ? a10 = [e15, e15 + t11.length] : i10 = false;
      }
      return i10 && ep.createElement(e14, __spreadProps(__spreadValues({}, this.props), { highlightRange: a10 }));
    }
  }, t10.defaultProps = { shouldUpdate: true }, t10;
}
const _D = (e14) => ID(HD(e14));
var VD = Number.isNaN || function(e14) {
  return "number" == typeof e14 && e14 != e14;
};
function RD(e14, t10) {
  if (e14.length !== t10.length) return false;
  for (var n10 = 0; n10 < e14.length; n10++) if (r10 = e14[n10], o10 = t10[n10], !(r10 === o10 || VD(r10) && VD(o10))) return false;
  var r10, o10;
  return true;
}
function AD(e14, t10) {
  var n10;
  void 0 === t10 && (t10 = RD);
  var r10 = [];
  var o10;
  var a10 = false;
  return function() {
    var i10 = [];
    for (var s10 = 0; s10 < arguments.length; s10++) i10[s10] = arguments[s10];
    return a10 && n10 === this && t10(i10, r10) || (o10 = e14.apply(this, i10), a10 = true, n10 = this, r10 = i10), o10;
  };
}
const [OD, BD, zD] = Dp("gc-binding-wrapper");
const [$D] = zD("toggle");
const [WD] = zD("content");
class jD extends ep.Component {
  constructor() {
    super(...arguments), this.getItems = AD((e14, t10) => e14.map((e15) => e15 && __spreadProps(__spreadValues({}, e15), { selected: void 0 !== e15.value && t10 === e15.value })));
  }
  render() {
    var _a2;
    const { value: e14, status: t10, menuId: n10, environment: r10, children: o10, menuWidth: a10, menuMaxHeight: i10, content: s10, itemSize: l10, titleToggle: c10, onSelect: u10, descriptor: d10 } = this.props;
    if (!n10 || !r10) return null;
    if (!r10.bindingMenus || !r10.bindingMenus[n10]) return null;
    let p10 = kp(OD, { [BD("modified")]: "modified" === t10, [BD("bind")]: "bind" === t10 }, t10.cssClass);
    const m10 = { size: "small", itemSize: l10, content: s10, block: true, background: "transparent", hiddenChevron: true, scrollToSelection: true, toggleContent: ep.createElement("div", { className: $D }), items: this.getItems(r10.bindingMenus[n10], e14), onSelect: u10, menuMaxHeight: i10, menuWidth: a10, title: c10, disabled: (_a2 = d10 == null ? void 0 : d10.meta) == null ? void 0 : _a2.disabled };
    return ep.createElement("div", { className: p10 }, ep.createElement("div", { className: WD }, o10), ep.createElement(UF, __spreadValues({}, m10)));
  }
}
jD.defaultProps = { status: "default", menuMaxHeight: "none", menuWidth: "default", titleToggle: "Data binding" };
const ZD = XN.toString();
const GD = ({ value: e14, validate: t10 }) => ({ initialValue: e14, value: e14, invalid: t10 && !t10(e14) || false, focused: false });
class UD extends ep.Component {
  constructor() {
    super(...arguments), this._input = null, this.state = GD(this.props), this.onChange = (e14) => {
      const { validate: t10 } = this.props;
      const { value: n10 } = e14.target;
      if (!t10) return this.setState({ value: n10 });
      this.setState({ value: n10, invalid: !t10(n10) });
    }, this.onKeyDown = (e14) => {
      e14.stopPropagation();
    }, this.onKeyUp = (e14) => {
      e14.stopPropagation();
      const { validate: t10, onChange: n10 } = this.props;
      const { value: r10 } = e14.target;
      e14.which === Vp && (t10 ? t10(r10) && (n10 || Jp)(r10) : (n10 || Jp)(r10)), e14.which === _p && this.setState(GD(this.props));
    }, this.onKeyPress = (e14) => {
      e14.stopPropagation();
    }, this.onBlur = (e14) => {
      const { value: t10, validate: n10, onChange: r10, displayValue: o10, onBlur: a10 } = this.props;
      const { value: i10 } = e14.target;
      a10 == null ? void 0 : a10(e14), i10 !== t10 && (n10 ? n10(i10) ? (r10 || Jp)(i10) : this.setState(GD(this.props)) : (r10 || Jp)(i10)), o10 && this.setState({ focused: false });
    }, this.onFocus = (e14) => {
      const { selectOnFocus: t10, displayValue: n10, onFocus: r10 } = this.props;
      r10 && r10(e14), n10 && this.setState({ focused: true }, () => {
        t10 && this._input && this._input.select();
      });
    };
  }
  componentDidUpdate(e14, t10) {
    const { value: n10, validate: r10 } = this.props;
    (e14.value !== this.props.value || e14 !== this.props && n10 !== this.state.value) && this.setState({ initialValue: n10, value: n10, invalid: !!r10 && !r10(n10) });
  }
  render() {
    const { props: { type: e14, placeholder: t10, readonly: n10, disabled: r10, autoFocus: o10, selectOnFocus: a10, textAlign: i10, displayValue: s10, width: l10, id: c10, name: u10, placeholderEmpty: d10, placeholderMultipleValues: p10, ariaLabel: m10, ariaLabelledBy: h10 }, state: { value: f10, invalid: g10, focused: y10 } } = this;
    const v10 = f10 === ZD || Xp(f10) && f10.toString() === ZD;
    const b10 = { id: c10, name: u10, type: e14, block: true, size: "small", width: l10, value: v10 ? "" : !y10 && s10 || f10, title: v10 ? "" : s10 || f10, placeholder: t10 || (v10 ? p10 : d10), invalid: g10, disabled: n10 || r10, autoFocus: o10, selectOnFocus: a10, textAlign: i10, ariaLabel: m10, ariaLabelledBy: h10, onChange: this.onChange, onFocus: this.onFocus, onBlur: this.onBlur, onKeyDown: this.onKeyDown, onKeyUp: this.onKeyUp, onKeyPress: this.onKeyPress };
    return ep.createElement(KF, __spreadProps(__spreadValues({}, b10), { ref: (e15) => this._input = e15 }));
  }
}
UD.defaultProps = { placeholderEmpty: "<Empty>", placeholderMultipleValues: ZD, type: "text", value: "", width: "100%" };
const [qD, , YD] = Dp("gc-text-editor");
const [KD] = YD("preview");
class XD extends ep.Component {
  constructor() {
    super(...arguments), this.onChange = (e14) => {
      const { setProperty: t10, descriptor: n10 } = this.props;
      t10 && n10 && t10(n10, e14);
    };
  }
  render() {
    const { value: e14, generatePreview: t10 } = this.props;
    const n10 = t10 && t10(e14);
    const r10 = __spreadProps(__spreadValues({}, this.props), { onChange: this.onChange });
    return ep.createElement(RN.Consumer, null, (e15) => ep.createElement("div", { className: qD }, n10 && ep.createElement("div", { className: KD }, n10), ep.createElement(UD, __spreadValues({}, im(r10, e15)))));
  }
}
const [JD] = Dp("gc-bool-editor");
class QD extends ep.Component {
  constructor() {
    super(...arguments), this.onToggle = () => {
      const { descriptor: e14, value: t10, setProperty: n10 } = this.props;
      n10(e14, !t10);
    };
  }
  render() {
    const { value: e14, disabled: t10, labelPosition: n10, textTrue: r10, textFalse: o10, textUndefined: a10 } = this.props;
    let i10 = null == e14;
    let s10;
    let l10 = a10;
    if (!i10) {
      const t11 = e14.toString().toLowerCase();
      "true" === t11 ? (s10 = true, l10 = r10) : "false" === t11 ? (s10 = false, l10 = o10) : i10 = true;
    }
    const c10 = { block: true, onToggle: this.onToggle, customCSS: JD, text: l10, checked: s10, size: "small", textAlign: "top" === n10 ? "right" : "left", disabled: t10, indeterminate: i10 };
    return ep.createElement(SM, __spreadValues({}, c10));
  }
}
QD.defaultProps = { textTrue: "True", textFalse: "False", textUndefined: "Undefined", labelPosition: "left", disabled: false };
const eL = { id: null, node: null, yPos: 0 };
const [tL, nL, rL] = Dp("gc-collection-editor");
const [oL, aL] = rL("item");
const [iL] = rL("items");
const [sL] = rL("clone");
const [lL, cL] = rL("header");
const [uL] = rL("content");
const [dL] = rL("empty");
const [pL] = rL("main");
const [mL] = rL("counter");
const [hL] = rL("item-actions");
const [fL] = rL("arrows");
const [gL] = rL("arrow-up");
const [yL] = rL("arrow-down");
class vL extends ep.Component {
  constructor() {
    super(...arguments), this._itemInnerOffset = 0, this._itemsContainer = { node: null, offset: 0 }, this._scrollContainer = null, this.state = { expanded: false, isDragging: false, draggedItem: eL, temporaryItems: { value: null, nodes: null } }, this.toggleEditorState = () => {
      const { state: { expanded: e14 }, props: { descriptor: t10, onToggle: n10 } } = this;
      n10 ? n10(gD(t10)) : this.setState({ expanded: !e14 });
    }, this.startDragging = (e14) => (t10) => {
      const { node: n10 } = this._itemsContainer;
      n10 && (this._itemsContainer.offset = n10.getBoundingClientRect().top), "notFound" !== this._scrollContainer && n10 && (this._scrollContainer = document.querySelector(`.${oD}`) || "notFound");
      const r10 = t10.currentTarget.getBoundingClientRect();
      this._itemInnerOffset = t10.clientY - r10.top, this.setState({ isDragging: true }), this.initDragData(e14, t10.clientY), window.addEventListener("mousemove", this.onMouseMove), window.addEventListener("mouseup", this.finishDragging), this._scrollContainer && "notFound" !== this._scrollContainer && this._scrollContainer.addEventListener("scroll", this.onContainerScroll);
    }, this.initDragData = (e14, t10) => {
      const { draggedItem: n10 } = this.state;
      const { value: r10 } = this.props;
      this.setState({ draggedItem: { id: e14, node: this.createItem(r10[e14], e14), yPos: t10 ? this.getDragPosition(t10) : n10.yPos }, temporaryItems: { nodes: r10.map((t11, n11) => this.createItem(t11, n11, e14)), value: r10 } });
    }, this.changeOrder = (e14) => () => {
      const { draggedItem: { id: t10 }, temporaryItems: n10 } = this.state;
      if (null === t10 || e14 === t10) return;
      const r10 = tm(n10.nodes || [], t10, e14);
      const o10 = tm(n10.value || [], t10, e14);
      this.setState((t11) => ({ temporaryItems: { nodes: r10, value: o10 }, draggedItem: __spreadProps(__spreadValues({}, t11.draggedItem), { id: e14 }) }));
    }, this.finishDragging = () => {
      const { _scrollContainer: e14, props: { reordering: t10, setProperty: n10, descriptor: r10 }, state: { temporaryItems: o10 } } = this;
      const { onReorder: a10 } = t10;
      o10.value && (a10 ? a10(o10.value) : n10(r10, o10.value)), this.setState({ isDragging: false, draggedItem: eL, temporaryItems: { value: null, nodes: null } }), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("mouseup", this.finishDragging), e14 && "notFound" !== e14 && e14.removeEventListener("scroll", this.onContainerScroll);
    }, this.onMouseMove = (e14) => {
      const t10 = this.getDragPosition(e14.clientY);
      this.setState((e15) => ({ draggedItem: __spreadProps(__spreadValues({}, e15.draggedItem), { yPos: t10 }) }));
    }, this.onContainerScroll = () => {
      const { node: e14 } = this._itemsContainer;
      e14 && (this._itemsContainer.offset = e14.getBoundingClientRect().top);
    }, this.getDragPosition = (e14) => e14 - this._itemInnerOffset - this._itemsContainer.offset, this.onUp = (e14) => () => {
      const { reordering: t10, setProperty: n10, descriptor: r10, value: o10 } = this.props;
      const { onUp: a10 } = t10;
      a10 ? a10(e14) : n10(r10, tm(o10, e14, e14 - 1));
    }, this.onDown = (e14) => () => {
      const { reordering: t10, setProperty: n10, descriptor: r10, value: o10 } = this.props;
      const { onDown: a10 } = t10;
      a10 ? a10(e14) : n10(r10, tm(o10, e14, e14 + 1));
    }, this.onItemAdd = () => {
      var _a2;
      const { onAdd: e14 } = this.props;
      const { expandedStates: t10 } = this.context;
      const n10 = (_a2 = t10 == null ? void 0 : t10.editors[gD(this.props.descriptor)]) != null ? _a2 : this.state.expanded;
      e14 == null ? void 0 : e14(), !n10 && this.toggleEditorState();
    }, this.onItemDelete = (e14) => () => (this.props.onDelete || Jp)(e14), this.createItem = (e14, t10, n10) => {
      const { props: { onDelete: r10, disableItemButtons: o10, reordering: a10, createEditor: i10, iconUp: s10, iconDown: l10, iconDrag: c10, iconDelete: u10, deleteBtnTitle: d10, descriptor: { valuePath: p10 }, disabled: m10 }, state: { draggedItem: h10 } } = this;
      const f10 = r10 || a10;
      const g10 = m10 || !!(o10 == null ? void 0 : o10(t10));
      const y10 = void 0 !== n10 ? this.changeOrder(t10) : void 0;
      const v10 = kp(oL, { [aL("dragged")]: (h10.id || n10) === t10 });
      const b10 = a10 && a10.canSwap;
      const S10 = a10 && "arrows" === a10.type;
      const C10 = a10 && "drag" === a10.type;
      return ep.createElement("div", { key: `${p10 || e14}-${t10}`, onMouseOver: y10, className: v10 }, f10 && ep.createElement("div", { className: hL }, S10 && ep.createElement("div", { className: fL }, t10 > 0 && (!b10 || b10(t10, t10 - 1)) && ep.createElement(qm, { onClick: this.onUp(t10), disabled: g10, customCSS: gL, size: "small", icon: s10, background: "transparent", dataAid: "MoveUp" }), t10 < this.props.value.length - 1 && (!b10 || b10(t10, t10 + 1)) && ep.createElement(qm, { onClick: this.onDown(t10), disabled: g10, customCSS: yL, size: "small", icon: l10, background: "transparent", dataAid: "MoveDown" })), ep.createElement(sM, { size: "small", items: [C10 && { type: "button", onMouseDown: this.startDragging(t10), icon: c10, tabIndex: -1, dataAid: "Move", disabled: g10 }, r10 && { type: "button", onClick: this.onItemDelete(t10), title: d10, icon: u10, dataAid: "Delete", disabled: g10 }] })), i10(e14, t10));
    };
  }
  componentDidUpdate(e14) {
    const { state: { isDragging: t10, draggedItem: n10 }, props: { value: r10 } } = this;
    t10 && e14.value !== r10 && this.initDragData(n10.id);
  }
  render() {
    const { props: { value: e14, header: t10, highlightRange: n10, descriptor: r10, onAdd: o10, customCSS: a10, onDelete: i10, reordering: s10, disabled: l10, background: c10, tooltip: u10, labelPosition: d10, labelWidth: p10, iconClose: m10, iconOpen: h10, iconAdd: f10, dataAid: g10, addBtnText: y10, addBtnTitle: v10, closeBtnTitle: b10, showBtnTitle: S10, textEmpty: C10, textItems: x10, t: w10 = (e15) => e15 }, state: { isDragging: T10, draggedItem: E10, temporaryItems: F10 } } = this;
    if (!e14) return null;
    const M10 = () => {
      if (!e14.length) return ep.createElement("div", { className: uL }, ep.createElement("div", { className: dL }, C10));
      let n11;
      n11 = F10.nodes ? F10.nodes.map((e15, t11) => ep.cloneElement(e15, { onMouseOver: this.changeOrder(t11) })) : e14.map((e15, t11) => this.createItem(e15, t11));
      let r11 = 0;
      i10 && r11++, s10 && r11++;
      const o11 = kp(lL, { [cL(`offset-${r11}`)]: r11 > 0 });
      return ep.createElement("div", { className: uL }, t10 && ep.createElement("div", { className: o11 }, t10), ep.createElement("div", { className: iL, ref: (e15) => this._itemsContainer.node = e15 }, n11, T10 && ep.createElement("div", { className: sL, style: { transform: `translate3d(0, ${E10.yPos}px, 0)` } }, E10.node)));
    };
    const k10 = { highlightRange: n10, disabled: l10, dataAid: g10, tooltip: u10, label: w10(r10.label), position: d10 || "left", block: true, size: "small", width: p10 };
    const P10 = "function" == typeof x10 ? x10(e14.length) : `${e14.length} ${x10}`;
    return ep.createElement(ep.Fragment, null, ep.createElement(yD.Consumer, null, ({ expandedStates: e15 }) => {
      var _a2;
      const t11 = (_a2 = e15 == null ? void 0 : e15.editors[gD(this.props.descriptor)]) != null ? _a2 : this.state.expanded;
      const n11 = { type: "button", disabled: l10, onClick: this.toggleEditorState, title: t11 ? b10 : S10, icon: t11 ? m10 : h10, background: t11 ? "transparent" : "default" };
      const r11 = { type: "button", disabled: l10, icon: f10, onClick: this.onItemAdd, text: t11 ? y10 : void 0, title: v10, background: t11 ? "transparent" : "default" };
      const i11 = kp(tL, a10, { [nL("expanded")]: t11, [nL("dragging")]: T10, [nL("disabled")]: l10, [nL("transparent")]: "transparent" === c10 });
      return ep.createElement("div", { className: i11 }, ep.createElement(AN, __spreadValues({}, k10), ep.createElement("div", { className: pL }, !t11 && ep.createElement("div", { className: mL, title: P10 }, `[${P10}]`), ep.createElement(sM, { size: "small", items: [o10 && r11, n11] }))), t11 && M10());
    }));
  }
}
vL.contextType = yD, vL.defaultProps = { background: "default", disabled: false, labelPosition: "left", labelWidth: "default", closeBtnTitle: "Close", showBtnTitle: "Show Items", addBtnText: "Add", addBtnTitle: "Add Item", deleteBtnTitle: "Delete", textEmpty: "Collection is empty", textItems: "items", iconUp: nf(oh, { rotate: "180" }), iconDown: nf(oh), iconDrag: nf(Sh, { rotate: "90" }), iconAdd: nf(Xm), iconDelete: nf(uh), iconOpen: nf(Ph), iconClose: nf(xh) };
const bL = ID(vL);
const [SL, CL, xL] = Dp("gc-expand-editor");
const [wL] = xL("main");
const [TL] = xL("toggle");
const [EL] = xL("content");
class FL extends ep.Component {
  constructor() {
    super(...arguments), this.state = { expanded: false }, this.onEditorToggle = () => {
      const { state: { expanded: e14 }, props: { descriptor: t10, onToggle: n10 } } = this;
      n10 ? n10(gD(t10)) : this.setState({ expanded: !e14 });
    };
  }
  render() {
    const { props: { mainEditor: e14, customCSS: t10, children: n10, background: r10, iconExpand: o10, iconCollapse: a10, titleExpand: i10, titleCollapse: s10, descriptor: l10, disabled: c10 } } = this;
    return ep.createElement(ep.Fragment, null, ep.createElement(yD.Consumer, null, ({ expandedStates: u10 }) => {
      var _a2;
      const d10 = (_a2 = u10 == null ? void 0 : u10.editors[gD(l10)]) != null ? _a2 : this.state.expanded;
      const p10 = kp(SL, t10, { [CL("expanded")]: d10, [CL("transparent")]: "transparent" === r10 });
      const m10 = { size: "small", icon: d10 ? a10 : o10, title: d10 ? s10 : i10, ariaExpanded: d10, customCSS: TL, onClick: this.onEditorToggle, disabled: c10 };
      return ep.createElement("div", { className: p10 }, ep.createElement("div", { className: wL }, e14, ep.createElement(qm, __spreadValues({}, m10))), d10 && ep.createElement("div", { className: EL }, n10));
    }));
  }
}
FL.contextType = yD, FL.defaultProps = { iconExpand: nf(sh), iconCollapse: nf(lh), titleExpand: "Expand", titleCollapse: "Collapse", background: "default" };
const ML = ID(FL);
const [kL, PL, NL] = Dp("gc-side-editor");
const [DL, LL] = NL("side");
const HL = (e14) => {
  const { sides: t10, sideIcons: n10, stretched: r10 } = e14;
  const o10 = ep.useMemo(() => ({ left: nf(bh, { rotate: "90" }), top: nf(bh, { rotate: "180" }), right: nf(bh, { rotate: "270" }), bottom: nf(bh) }), []);
  const a10 = __spreadProps(__spreadValues({}, e14), { customCSS: kp(kL, { [PL("stretched")]: r10 }) });
  return tp.createElement(ML, __spreadValues({}, a10), ((e15, t11, n11) => Object.keys(e15).map((r11) => {
    var _a2, _b2, _c2;
    const o11 = `${DL} ${LL(r11)}`;
    const a11 = (_c2 = (_b2 = (_a2 = e15[r11]) == null ? void 0 : _a2.props) == null ? void 0 : _b2.descriptor) == null ? void 0 : _c2.valuePath;
    return "default" === r11 ? tp.createElement("div", { key: r11, className: o11, "data-value-path": a11 }, e15[r11]) : tp.createElement("div", { key: r11, className: o11, "data-value-path": a11 }, tp.cloneElement(e15[r11], { icon: (n11 == null ? void 0 : n11[r11]) || t11[r11] }));
  }))(t10, o10, n10));
};
const [IL] = Dp("gc-number-editor");
class _L extends ep.Component {
  constructor() {
    super(...arguments), this.validateNumber = (e14) => {
      const { minValue: t10, maxValue: n10, validate: r10 } = this.props;
      if (r10) return r10(e14);
      if (e14 && -1 !== e14.search(_L.numberRegex)) {
        const r11 = parseInt(e14, 10);
        return !(r11 < t10) && !(r11 > n10);
      }
      return false;
    }, this.onChange = (e14) => {
      const { setProperty: t10, descriptor: n10 } = this.props;
      t10 && n10 && t10(n10, parseInt(e14, 10));
    }, this.onNumberChange = (e14) => () => {
      const { setProperty: t10, descriptor: n10, value: r10, minValue: o10, maxValue: a10 } = this.props;
      if (!t10 || !n10) return;
      let i10 = r10 + e14;
      i10 < o10 ? i10 = o10 : i10 > a10 && (i10 = a10), t10(n10, i10);
    };
  }
  render() {
    const { value: e14, disabled: t10, step: n10, displayValue: r10, placeholder: o10, minValue: a10, maxValue: i10, iconDecrease: s10, iconIncrease: l10, id: c10, name: u10, placeholderEmpty: d10, placeholderMultipleValues: p10, titleIncrease: m10, titleDecrease: h10 } = this.props;
    const f10 = { id: c10, name: u10, placeholderEmpty: d10, placeholderMultipleValues: p10, value: `${e14}`, validate: this.validateNumber, onChange: this.onChange, selectOnFocus: true, textAlign: "center", disabled: t10, displayValue: r10, placeholder: o10, width: "0px" };
    const g10 = { block: true, size: "small" };
    return ep.createElement(RN.Consumer, null, (r11) => {
      const o11 = r11.labelId || r11.labelFor ? void 0 : r11.labelText;
      const c11 = __spreadProps(__spreadValues({}, g10), { disabled: t10 || e14 === a10, icon: s10, title: h10, ariaLabel: am(h10, o11), dataAid: "decrease", onClick: this.onNumberChange(-n10) });
      const u11 = __spreadProps(__spreadValues({}, g10), { disabled: t10 || e14 === i10, icon: l10, title: m10, ariaLabel: am(m10, o11), dataAid: "increase", onClick: this.onNumberChange(n10) });
      return ep.createElement("div", { className: IL }, ep.createElement(qm, __spreadValues({}, c11)), ep.createElement(UD, __spreadValues({ key: e14 }, im(f10, r11))), ep.createElement(qm, __spreadValues({}, u11)));
    });
  }
}
_L.numberRegex = /^-?(\d+)$/, _L.defaultProps = { iconDecrease: nf(Jm), iconIncrease: nf(Xm), titleDecrease: "Decrease", titleIncrease: "Increase", step: 1, maxValue: 1 / 0, minValue: -1 / 0 };
const [VL, RL] = Dp("gc-enum-editor");
class AL extends ep.Component {
  constructor() {
    super(...arguments), this.getItems = AD((e14, t10) => e14.values.map((n10) => {
      const r10 = e14.friendlyNames.find((e15) => e15.value === n10);
      return { type: "button", value: n10, selected: n10 === t10, text: r10 && r10.name || n10 };
    })), this.onSelect = (e14) => {
      const { setProperty: t10, descriptor: n10 } = this.props;
      t10 && n10 && t10(n10, e14);
    };
  }
  render() {
    const { value: e14, disabled: t10, friendlyEnum: n10, textEmpty: r10, titleToggle: o10, dropup: a10, chevronIcon: i10, noCloseOnSelect: s10, placeholderText: l10, menuMaxHeight: c10, menuCustomCSS: u10, customCSS: d10, generatePreview: p10, generateItemPreview: m10, customButtonRenderer: h10 } = this.props;
    const f10 = n10.friendlyNames.find((t11) => t11.value === e14);
    const g10 = (f10 == null ? void 0 : f10.name) || e14;
    const y10 = kp(VL, { [RL("empty")]: !g10 }, d10);
    return ep.createElement(RN.Consumer, null, ({ labelFor: d11, labelId: f11, labelText: v10 }) => {
      const b10 = { block: true, size: "small", width: "100%", menuWidth: "100%", menuMaxHeight: c10, menuCustomCSS: u10, text: g10 || r10, title: o10, items: this.getItems(n10, e14), onSelect: this.onSelect, scrollToSelection: true, noCloseOnSelect: s10, placeholderText: l10, disabled: t10, dropup: a10, chevronIcon: i10, customCSS: y10, generatePreview: p10, generateItemPreview: m10, customButtonRenderer: h10 };
      return f11 ? b10.ariaLabelledBy = f11 : b10.ariaLabel = am(g10 || r10, v10), ep.createElement(UF, __spreadValues({}, b10));
    });
  }
}
const OL = (e14) => ({ backgroundColor: e14.rgba });
const BL = (e14) => e14.title || e14.hex;
const [zL, , $L] = Dp("gc-color-palette");
const [WL] = $L("colors");
const [jL] = $L("heading");
const [ZL, , GL] = Dp("gc-color");
const [UL] = GL("main");
const [qL] = GL("shades");
const YL = ({ palette: e14, onSelect: t10 }) => {
  const n10 = { text: e14.name, align: "center", textSize: "small", customCSS: jL };
  return tp.createElement("div", { className: zL }, tp.createElement(LE, __spreadValues({}, n10)), tp.createElement("div", { className: WL }, e14.colors.map((e15) => tp.createElement("div", { key: e15[0].hex8, className: ZL }, tp.createElement("div", { className: UL, title: BL(e15[0]), style: OL(e15[0]), onClick: () => t10(e15[0]) }), tp.createElement("div", { className: qL }, e15.slice(1).map((e16) => tp.createElement("div", { key: e16.hex8, title: BL(e16), style: OL(e16), onClick: () => t10(e16) })))))));
};
const [KL, XL, JL] = Dp("gc-slider");
const [QL] = JL("background");
const [eH] = JL("area");
const [tH] = JL("fill");
const [nH, rH] = JL("toggle");
const oH = (e14, { mode: t10, range: n10, min: r10, max: o10 }) => {
  const a10 = { X: [r10, o10], Y: [r10, o10] };
  if (void 0 === e14) return a10;
  switch (t10) {
    case "X": {
      const t11 = n10 ? e14 : [e14, 0];
      return __spreadProps(__spreadValues({}, a10), { X: t11 });
    }
    case "Y": {
      const t11 = n10 ? e14 : [e14, 0];
      return __spreadProps(__spreadValues({}, a10), { Y: t11 });
    }
    case "XY":
      return { X: [e14.X, 0], Y: [e14.Y, 0] };
  }
};
class aH extends ep.Component {
  constructor() {
    var _a2;
    super(...arguments), this._togglesMap = /* @__PURE__ */ new Map(), this.activeToggleIndex = 0, this.startPage = { X: 0, Y: 0 }, this.startLocal = { X: 0, Y: 0 }, this.state = oH((_a2 = this.props.value) != null ? _a2 : this.props.defaultValue, this.props), this.getControlArea = (e14) => {
      this._controlArea = e14;
    }, this.getToggleRef = (e14, t10) => {
      this._togglesMap.set(t10, e14);
    }, this.trimPixelValue = (e14, t10, n10, r10, o10, a10, i10) => {
      if (e14 < t10) return t10;
      if (e14 > n10) return n10;
      const s10 = (a10 - o10) / r10;
      const l10 = i10 / s10;
      return Math.round(e14 / l10) / s10 * i10;
    }, this.countDigitsAfterRadix = AD((e14) => {
      const t10 = `${e14}`.split(".");
      return 2 === t10.length ? t10[1].length : 0;
    }), this.roundToStep = (e14, t10, n10, r10) => {
      const o10 = parseFloat(e14.toFixed(this.countDigitsAfterRadix(t10)));
      return o10 < n10 ? n10 : o10 > r10 ? r10 : o10;
    }, this.getTrimmedValue = (e14, t10, n10, r10 = n10) => {
      const { min: o10, max: a10, step: i10 } = this.props;
      const s10 = o10 + this.trimPixelValue(e14, t10, n10, i10, o10, a10, r10) / r10 * (a10 - o10);
      return this.roundToStep(s10, i10, o10, a10);
    }, this.calcNextPoint = (e14, t10) => {
      const { getTrimmedValue: n10, activeToggleIndex: r10, startPage: o10, startLocal: a10, _controlArea: { clientWidth: i10, clientHeight: s10 }, props: { range: l10, min: c10, max: u10 } } = this;
      const d10 = (e15) => (e15 - c10) / (u10 - c10);
      return l10 ? 0 === r10 ? { X: n10(a10.X + e14 - o10.X, 0, i10 * d10(this.state.X[1]), i10), Y: n10(a10.Y + t10 - o10.Y, 0, s10 * d10(this.state.Y[1]), s10) } : { X: n10(a10.X + e14 - o10.X, i10 * d10(this.state.X[0]), i10), Y: n10(a10.Y + t10 - o10.Y, s10 * d10(this.state.Y[0]), s10) } : { X: n10(a10.X + e14 - o10.X, 0, i10), Y: n10(a10.Y + t10 - o10.Y, 0, s10) };
    }, this.onPointerDown = (e14) => {
      const { onPointerMove: t10, onPointerUp: n10, getTrimmedValue: r10, getActiveToggle: o10, _controlArea: a10 } = this;
      const { clientWidth: i10, clientHeight: s10 } = a10;
      const { left: l10, top: c10 } = a10.getBoundingClientRect();
      const u10 = e14.pageX - l10;
      const d10 = e14.pageY - window.pageYOffset - c10;
      const p10 = r10(u10, 0, i10);
      const m10 = r10(d10, 0, s10);
      this.activeToggleIndex = o10(e14, p10, m10), this.startPage = { X: e14.pageX, Y: e14.pageY }, this.startLocal = { X: u10, Y: d10 }, this.setTogglePosition({ X: p10, Y: m10 }, this.props.onGrab), window.addEventListener("pointermove", t10), window.addEventListener("pointerup", n10), document.body.classList.add("gc-disable-selection");
    }, this.onPointerMove = (e14) => {
      const t10 = this.calcNextPoint(e14.pageX, e14.pageY);
      this.setTogglePosition(t10);
    }, this.onPointerUp = (e14) => {
      this.onChange(this.props.onRelease), window.removeEventListener("pointermove", this.onPointerMove), window.removeEventListener("pointerup", this.onPointerUp), document.body.classList.remove("gc-disable-selection");
    }, this.setTogglePosition = (e14, t10 = this.props.onChange) => {
      const n10 = this.state.X.map((t11, n11) => n11 === this.activeToggleIndex ? e14.X : t11);
      const r10 = this.state.Y.map((t11, n11) => n11 === this.activeToggleIndex ? e14.Y : t11);
      this.setState({ X: n10, Y: r10 }, this.onChange(t10));
    }, this.onChange = (e14) => {
      if (!e14) return;
      const { props: { mode: t10, range: n10 }, state: { X: r10, Y: o10 } } = this;
      switch (t10) {
        case "X":
          return e14(n10 ? r10 : r10[0]);
        case "Y":
          return e14(n10 ? o10 : o10[0]);
        case "XY":
          return e14({ X: r10[0], Y: o10[0] });
      }
    }, this.getActiveToggle = (e14, t10, n10) => {
      const { state: { X: r10, Y: o10 }, props: { range: a10, mode: i10 } } = this;
      if (!a10 || "XY" === i10) return 0;
      if (e14.target && e14.target.dataset.index) return Number(e14.target.dataset.index);
      const s10 = (e15, t11) => {
        if (e15[0] === e15[1]) return t11 > e15[0] ? 1 : 0;
        const n11 = e15.map((e16, n12) => ({ index: n12, distance: Math.abs(e16 - t11) }));
        return n11.sort((e16, t12) => e16.distance - t12.distance)[0].index;
      };
      switch (i10) {
        case "X":
          return s10(r10, t10);
        case "Y":
          return s10(o10, n10);
      }
    }, this.getToggleStyle = (e14) => {
      const { state: { X: t10, Y: n10 }, props: { mode: r10, toggleBackgroundColor: o10, min: a10, max: i10 } } = this;
      let s10 = 50;
      let l10 = 50;
      const c10 = (e15) => 100 * (e15 - a10) / (i10 - a10);
      switch (r10) {
        case "X":
          s10 = c10(t10[e14]);
          break;
        case "Y":
          l10 = c10(n10[e14]);
          break;
        case "XY":
          s10 = c10(t10[0]), l10 = c10(n10[0]);
      }
      return { left: `${s10}%`, top: `${l10}%`, backgroundColor: o10 };
    }, this.getToggleLabel = (e14) => {
      const { props: { mode: t10 }, state: { X: n10, Y: r10 } } = this;
      switch (t10) {
        case "X":
          return `${n10[e14]}`;
        case "Y":
          return `${r10[e14]}`;
        case "XY":
          return `${n10[0]}, ${r10[0]}`;
      }
    };
  }
  componentDidMount() {
    const { onPointerDown: e14, _controlArea: t10, _togglesMap: n10 } = this;
    t10.addEventListener("pointerdown", e14), n10.forEach((t11) => t11 && t11.addEventListener("pointerdown", e14));
  }
  componentWillUnmount() {
    const { onPointerDown: e14, _controlArea: t10, _togglesMap: n10 } = this;
    t10.removeEventListener("pointerdown", e14), n10.forEach((t11) => t11 && t11.removeEventListener("pointerdown", e14));
  }
  componentDidUpdate(e14) {
    const { value: t10 } = this.props;
    e14.value !== t10 && this.setState(oH(t10, this.props));
  }
  render() {
    const { mode: e14, range: t10, width: n10, areaCustomCSS: r10, areaStyle: o10, customCSS: a10, disabled: i10, id: s10, dataAid: l10, rangeFillColor: c10, withTooltip: u10, tooltipPosition: d10, invalid: p10 } = this.props;
    const m10 = kp(KL, a10, XL(`mode-${e14}`), { [XL("disabled")]: i10, [XL("invalid")]: p10 });
    const h10 = {};
    "X" !== e14 && "XY" !== e14 || (h10.width = n10), "Y" !== e14 && "XY" !== e14 || (h10.height = n10);
    const f10 = this.getToggleStyle(0);
    let g10;
    let y10;
    if (t10) switch (g10 = this.getToggleStyle(1), e14) {
      case "X":
        y10 = { left: f10.left, right: `calc(100% - ${g10.left})`, top: 0, bottom: 0, height: "100%", backgroundColor: c10 };
        break;
      case "Y":
        y10 = { left: 0, right: 0, top: f10.top, bottom: `calc(100% - ${g10.top})`, width: "100%", backgroundColor: c10 };
    }
    const v10 = kp(nH, { [rH(`tooltip-${d10 || ("Y" === e14 ? "right" : "top")}`)]: u10 });
    return ep.createElement("div", { className: m10, style: h10, id: s10, "data-aid": l10 }, ep.createElement("div", { className: kp(QL, r10), style: o10 }, t10 && ep.createElement("div", { className: tH, style: y10 })), ep.createElement("div", { className: eH, ref: this.getControlArea }), ep.createElement("span", { className: v10, "data-value": this.getToggleLabel(0), "data-index": "0", style: this.getToggleStyle(0), ref: (e15) => this.getToggleRef(e15, 0) }), t10 && ep.createElement("span", { className: v10, "data-value": this.getToggleLabel(1), "data-index": "1", style: g10, ref: (e15) => this.getToggleRef(e15, 1) }));
  }
}
aH.defaultProps = { mode: "X", min: 0, max: 1, step: 1e-3, withTooltip: false, disabled: false, invalid: false };
const iH = (e14) => ep.createElement(aH, __spreadValues({}, e14));
const sH = (e14) => ep.createElement(aH, __spreadProps(__spreadValues({}, e14), { range: true }));
const lH = (e14, t10) => ({ color: e14, hsl: t10 || dm.toHSL(e14), HEX_Text: e14.hex, R_Text: `${e14.R}`, G_Text: `${e14.G}`, B_Text: `${e14.B}` });
const [cH, , uH] = Dp("gc-color-picker");
const [dH] = uH("preview");
const [pH] = uH("settings");
const [mH] = uH("slider");
const [hH] = uH("inputs");
const [fH] = uH("hex");
const [gH] = uH("rgb");
class yH extends ep.Component {
  constructor() {
    super(...arguments), this.state = lH(this.props.color), this.onColorChange = (e14) => {
      const { onChange: t10 } = this.props;
      t10 && t10(e14);
    }, this.onHueChange = (e14) => {
      const t10 = __spreadProps(__spreadValues({}, this.state.hsl), { H: e14 });
      const n10 = dm.fromHSL(t10);
      n10.A = this.state.color.A, this.setState(lH(n10, t10)), this.onColorChange(n10);
    }, this.onSaturationChange = (e14) => {
      const t10 = __spreadProps(__spreadValues({}, this.state.hsl), { S: e14 });
      const n10 = dm.fromHSL(t10);
      n10.A = this.state.color.A, this.setState(lH(n10, t10)), this.onColorChange(n10);
    }, this.onLightnessChange = (e14) => {
      const t10 = __spreadProps(__spreadValues({}, this.state.hsl), { L: e14 });
      const n10 = dm.fromHSL(t10);
      n10.A = this.state.color.A, this.setState(lH(n10, t10)), this.onColorChange(n10);
    }, this.onEditorChange = (e14) => (t10) => {
      const { value: n10 } = t10.target;
      this.setState({ [`${e14}_Text`]: n10 });
    }, this.onEditorKeyDown = (e14) => {
      e14.stopPropagation();
    }, this.updateRGBValue = (e14, t10) => {
      let n10 = parseInt(t10 || "0", 10);
      n10 < 0 ? n10 = 0 : n10 > 255 && (n10 = 255);
      const { R: r10, G: o10, B: a10, A: i10 } = this.state.color;
      const s10 = { R: r10, G: o10, B: a10 };
      s10[e14] = n10;
      const l10 = new dm(s10.R, s10.G, s10.B, i10);
      this.setState(lH(l10)), this.onColorChange(l10);
    }, this.onEditorKeyUp = (e14) => (t10) => {
      t10.stopPropagation();
      const { value: n10 } = t10.target;
      t10.which === Vp ? this.updateRGBValue(e14, n10) : t10.which === _p && this.setState({ [`${e14}_Text`]: `${this.state.color[e14]}` });
    }, this.onEditorBlur = (e14) => (t10) => {
      const { value: n10 } = t10.target;
      this.updateRGBValue(e14, n10);
    }, this.updateHexValue = (e14) => {
      let t10 = `${e14}`;
      "#" !== t10[0] && (t10 = `#${t10}`);
      const n10 = dm.fromHEX(t10);
      this.setState(lH(n10)), this.onColorChange(n10);
    }, this.onHexKeyUp = (e14) => {
      const { value: t10 } = e14.target;
      e14.which === Vp && this.updateHexValue(t10), e14.which === _p && this.setState({ HEX_Text: this.state.color.hex });
    }, this.onHexBlur = (e14) => {
      this.updateHexValue(e14.target.value);
    };
  }
  componentDidUpdate(e14) {
    e14.color.A !== this.state.color.A && this.setState({ color: e14.color });
  }
  render() {
    const { color: e14, onPreviewClick: t10, textHue: n10, textSaturation: r10, textLightness: o10, textHex: a10, textR: i10, textG: s10, textB: l10 } = this.props;
    const { hsl: { H: c10, S: u10, L: d10 }, HEX_Text: p10 } = this.state;
    const m10 = e14.rgb;
    const h10 = dm.fromHSL({ H: c10, S: 1, L: 0.5 }).rgb;
    const f10 = `linear-gradient(to right, ${dm.fromHSL({ H: c10, S: 0, L: d10 }).rgb} 0%, ${dm.fromHSL({ H: c10, S: 1, L: d10 }).rgb} 100%)`;
    const g10 = `linear-gradient(to right, ${dm.fromHSL({ H: c10, S: u10, L: 0 }).rgb} 0%, ${dm.fromHSL({ H: c10, S: u10, L: 0.5 }).rgb} 50%, ${dm.fromHSL({ H: c10, S: u10, L: 1 }).rgb} 100%)`;
    const y10 = { top: "50%", height: "10px", transform: "translateY(-50%)" };
    const v10 = __spreadValues({ background: "linear-gradient(to right, #ff0000 0%, #ffff00 17%, #00ff00 33%, #00ffff 50%, #0000ff 67%, #ff00ff 83%, #ff0000 100%)" }, y10);
    const b10 = __spreadValues({ background: f10 }, y10);
    const S10 = __spreadValues({ background: g10 }, y10);
    const C10 = { block: true, size: "small" };
    const x10 = (e15) => ({ value: this.state[`${e15}_Text`], size: "small", textAlign: "center", selectOnFocus: true, onKeyDown: this.onEditorKeyDown, onBlur: this.onEditorBlur(e15), onKeyUp: this.onEditorKeyUp(e15), onChange: this.onEditorChange(e15), onKeyPress: (e16) => e16.stopPropagation() });
    return ep.createElement("div", { className: cH }, ep.createElement("div", { className: dH, style: { backgroundColor: e14.rgba }, onClick: t10 }), ep.createElement("div", { className: pH }, ep.createElement("span", null, n10), ep.createElement(iH, { areaStyle: v10, areaCustomCSS: mH, toggleBackgroundColor: h10, defaultValue: c10, value: c10, onChange: this.onHueChange }), ep.createElement("span", null, r10), ep.createElement(iH, { areaStyle: b10, areaCustomCSS: mH, toggleBackgroundColor: m10, defaultValue: u10, value: u10, onChange: this.onSaturationChange }), ep.createElement("span", null, o10), ep.createElement(iH, { areaStyle: S10, areaCustomCSS: mH, toggleBackgroundColor: m10, defaultValue: d10, value: d10, onChange: this.onLightnessChange })), ep.createElement("div", { className: hH }, ep.createElement("div", { className: fH }, ep.createElement(AN, __spreadProps(__spreadValues({}, C10), { label: a10 }), ep.createElement(KF, __spreadProps(__spreadValues({}, x10("HEX")), { value: p10, onBlur: this.onHexBlur, onKeyUp: this.onHexKeyUp })))), ep.createElement("div", { className: gH }, ep.createElement(AN, __spreadProps(__spreadValues({}, C10), { label: i10 }), ep.createElement(KF, __spreadValues({}, x10("R")))), ep.createElement(AN, __spreadProps(__spreadValues({}, C10), { label: s10 }), ep.createElement(KF, __spreadValues({}, x10("G")))), ep.createElement(AN, __spreadProps(__spreadValues({}, C10), { label: l10 }), ep.createElement(KF, __spreadValues({}, x10("B")))))));
  }
}
yH.defaultProps = { textHue: "Hue", textLightness: "Lightness", textSaturation: "Saturation", textHex: "Hex", textR: "R", textG: "G", textB: "B" };
const [vH, , bH] = Dp("gc-color-dropdown");
const [SH] = bH("web-color");
const [CH] = bH("web-colors");
class xH extends ep.Component {
  constructor() {
    var e14;
    super(...arguments), this._fallback = dm.fromHEX("#000"), this.state = { color: (e14 = this.props).value, opacity: e14.opacity ? e14.value.A : 255, mode: e14.palettes && e14.palettes.length > 0 ? "palettes" : "picker" }, this.onChange = (e15) => {
      const { onSelect: t10 } = this.props;
      if (!t10) return;
      if (e15.customValue) return t10(e15);
      const n10 = 0 === e15.A ? 0 : this.state.opacity;
      t10(dm.fromRGB(e15.R, e15.G, e15.B, n10));
    }, this.onColorSelect = (e15) => {
      this.setState({ color: e15 }), this.onChange(e15);
    }, this.onOpacityChange = (e15) => {
      const { state: { color: { R: t10, G: n10, B: r10 } } } = this;
      const o10 = Math.round(255 * e15);
      const a10 = dm.fromRGB(t10, n10, r10, o10);
      this.setState({ color: a10, opacity: o10 });
    }, this.onPickerChange = (e15) => {
      const { props: { opacity: t10 } } = this;
      const { R: n10, G: r10, B: o10 } = e15;
      this.setState({ color: t10 ? e15 : dm.fromRGB(n10, r10, o10, 255) });
    }, this.onPickerClick = () => {
      this.onChange(this.state.color);
    }, this.onWebSelect = (e15) => () => {
      let t10;
      t10 = "#00000000" === e15 ? new dm(0, 0, 0, 0) : dm.fromHEX(e15), this.setState({ color: t10 }), this.onChange(t10);
    }, this.onModeSelect = (e15) => () => {
      this.setState({ mode: e15 });
    };
  }
  render() {
    const { props: { opacity: e14, palettes: t10, textPalettes: n10, textColorPicker: r10, textWebColors: o10, textOpacity: a10, textHue: i10, textSaturation: s10, textLightness: l10, textHex: c10, textR: u10, textG: d10, textB: p10, textWebColorNames: m10 }, state: { color: h10, mode: f10 }, _fallback: g10 } = this;
    const y10 = h10 || g10;
    const { A: v10, hex: b10, hex8: S10 } = y10;
    const C10 = { color: y10, textHue: i10, textSaturation: s10, textLightness: l10, textHex: c10, textR: u10, textG: d10, textB: p10, onChange: this.onPickerChange, onPreviewClick: this.onPickerClick };
    const x10 = { top: "50%", height: "10px", transform: "translateY(-50%)", background: `linear-gradient(to right, transparent 0%, ${y10.rgb} 100%)` };
    const w10 = { autoHeight: true, autoHeightMax: "200px", style: { view: { maxHeight: "200px" } }, customCSS: FF };
    return ep.createElement("div", { className: vH }, ep.createElement(sM, { size: "small", block: true, align: "justify", items: [t10 && t10.length > 0 && { type: "button", width: "100%", accent: "palettes" === f10 ? "full" : "none", text: n10, onClick: this.onModeSelect("palettes") }, { type: "button", width: "100%", accent: "picker" === f10 ? "full" : "none", text: r10, onClick: this.onModeSelect("picker") }, { type: "button", width: "100%", accent: "web" === f10 ? "full" : "none", text: o10, onClick: this.onModeSelect("web") }] }), "palettes" === f10 && t10.map((e15, t11) => ep.createElement(YL, { key: t11, palette: e15, onSelect: this.onColorSelect })), "picker" === f10 && ep.createElement(yH, __spreadValues({}, C10)), "web" === f10 && ep.createElement("div", { className: CH }, ep.createElement(bF, __spreadValues({}, w10), dm.webColorsEnum(true).map(({ name: e15, value: t11 }) => {
      const n11 = "#00000000" === S10 ? t11 === S10 : t11 === b10;
      const r11 = { className: kp(HF, Up, IF("with-preview"), { [IF("selected")]: n11 }), onClick: this.onWebSelect(t11) };
      return ep.createElement("button", __spreadValues({ key: e15 }, r11), ep.createElement("div", { className: _F }, ep.createElement("div", { className: SH, style: { backgroundColor: t11 } })), ep.createElement("span", null, m10[e15] || e15));
    }))), e14 && ep.createElement(ep.Fragment, null, ep.createElement(LE, { text: `${a10}${v10 < 255 ? `: ${Math.round(v10 / 255 * 100)}%` : ""}`, align: "center", textSize: "small", customCSS: MF }), ep.createElement(iH, { toggleBackgroundColor: y10.rgba, areaCustomCSS: mH, areaStyle: x10, defaultValue: v10 / 255, value: v10 / 255, onChange: this.onOpacityChange })));
  }
}
xH.defaultProps = __spreadProps(__spreadValues({}, yH.defaultProps), { opacity: false, textColorPicker: "Picker", textOpacity: "Opacity", textPalettes: "Palettes", textWebColors: "Web Colors", textWebColorNames: {} });
class wH extends ep.Component {
  constructor() {
    super(...arguments), this._menu = null, this._menuProps = {}, this._lastFocusedElement = null, this.state = { showMenu: false, mousePosition: { x: 0, y: 0 } }, this.open = (e14, t10, n10, r10) => {
      const { API: o10 } = this.context;
      this._lastFocusedElement = document.activeElement, o10.current.dropdowns.open(this), this._menuProps = __spreadValues({ items: t10 }, r10 || {}), this._onItemClick = n10, this.setState({ showMenu: true, mousePosition: e14 });
    }, this.close = () => {
      var _a2;
      this.setState({ showMenu: false }), (_a2 = this._lastFocusedElement) == null ? void 0 : _a2.focus();
    }, this.onItemClick = (e14) => {
      e14.onClick ? e14.onClick(e14.value, this.state.mousePosition) : this._onItemClick && this._onItemClick(e14), this.close();
    }, this.getNode = () => this._menu && this._menu.getMenuNode(), this.getSafeZone = Jp, this.getMenuNode = Jp, this.onNavigation = Jp, this.getPositionerNode = Jp, this.updateMenuPosition = Jp;
  }
  componentDidMount() {
    const { API: e14, root: t10 } = this.context;
    e14.current.dropdowns || (e14.current.dropdowns = new AF(t10)), e14.current.contextMenu && console.warn("Repeated <ContextMenuProvider/> mounting"), e14.current.contextMenu = { open: this.open, close: this.close };
  }
  render() {
    const { props: { dataAid: e14, size: t10 }, state: { showMenu: n10, mousePosition: r10 } } = this;
    const o10 = { type: "mouse", position: r10 };
    const a10 = __spreadProps(__spreadValues({}, this._menuProps), { parent: o10, onItemClick: this.onItemClick, dataAid: e14, size: t10, align: "left", backButtonCallbacks: this.close });
    return n10 && ep.createElement(RF, __spreadProps(__spreadValues({}, a10), { ref: (e15) => this._menu = e15 }));
  }
}
wH.contextType = Sm;
const [TH, EH, FH] = Dp("gc-wizard");
const [MH, kH] = FH("step");
const [PH] = FH("step-text");
const NH = (e14) => {
  const { onStepChange: t10 = () => true, style: n10 = "default", customCSS: r10, currentIndex: o10, dataAid: a10, defaultStepIcon: i10, id: s10, steps: l10 } = e14;
  if (l10.length < 2) return process.env.DEBUG && console.warn("<Wizard />: There must be at least two steps for the Wizard to render properly"), null;
  const c10 = kp(TH, r10, { [EH(n10)]: "default" !== n10 });
  return ep.createElement("div", { className: c10, id: s10, "data-aid": a10 }, l10.map((e15, n11) => {
    const r11 = l10.length === n11 + 1;
    const s11 = n11 < o10;
    const c11 = !r11 && s11;
    const u10 = kp(MH, { [kH("complete")]: o10 > 0 && s11, [kH("current")]: n11 === o10 });
    const d10 = { title: e15.title || e15.text, icon: s11 ? e15.icon || i10 : void 0, text: s11 ? void 0 : `${n11 + 1}`, onClick: c11 ? () => ((e16, n12) => {
      false !== t10(n12) && e16.moveToStep && e16.moveToStep();
    })(e15, n11) : void 0, disabled: !c11, rounded: true, size: "small", accent: "full", dataAid: a10 ? `${a10}_step` : void 0 };
    return ep.createElement("div", { key: `step-${n11}`, className: u10 }, ep.createElement(qm, __spreadValues({}, d10)), e15.text && ep.createElement("span", { className: PH }, e15.text));
  }));
};
const [DH, , LH] = Dp("gc-notifications-counter");
const [HH] = LH("toggle");
const [IH] = LH("menu");
const _H = (_m2) => {
  var _n2 = _m2, { notificationsData: { notifications: e14, amount: t10, level: n10 }, dataAid: r10, title: o10 } = _n2, a10 = __objRest(_n2, ["notificationsData", "dataAid", "title"]);
  const i10 = rf(kh);
  if (!t10.notifications) return null;
  const s10 = __spreadProps(__spreadValues({}, a10), { notifications: e14, dataAid: r10 });
  const l10 = { content: ep.createElement(lP, __spreadValues({}, s10)), dataAid: r10 ? `${r10}_notification-toggle` : void 0, size: "small", accent: "text+icon", background: "transparent", dropup: true, offset: 0, level: n10, icon: i10, title: o10, text: `${t10.notifications}`, menuAlign: "left", hiddenChevron: true, menuWidth: "auto", customCSS: HH, menuCustomCSS: IH };
  return ep.createElement("div", { className: kp(DH, Up) }, ep.createElement(UF, __spreadValues({}, l10)), ep.createElement(DM, null));
};
const [VH, , RH] = Dp("gc-status-bar");
const [AH] = RH("accessory");
const [OH] = RH("items");
class BH extends ep.Component {
  render() {
    const { children: e14, accessory: t10, customCSS: n10, dataAid: r10 } = this.props;
    return ep.createElement("div", { className: kp(VH, n10), "data-aid": r10 }, t10 && ep.createElement("div", { className: AH }, t10), ep.createElement("div", { className: OH }, ep.createElement(NM, { id: "statusbar-tools", block: true, dropup: true, toggleBackground: "transparent", size: "small" }, e14)));
  }
}
class zH extends ep.Component {
  render() {
    const _a2 = this.props, { children: e14, notificationsData: t10, notificationCounterTitle: n10, dataAid: r10, customCSS: o10 } = _a2, a10 = __objRest(_a2, ["children", "notificationsData", "notificationCounterTitle", "dataAid", "customCSS"]);
    const i10 = __spreadProps(__spreadValues({}, a10), { notificationsData: t10, dataAid: r10, title: n10 });
    return ep.createElement(BH, { dataAid: r10, customCSS: o10, accessory: ep.createElement(_H, __spreadValues({}, i10)) }, e14);
  }
}
const $H = EP(zH);
const WH = (e14) => ep.createElement($H, __spreadValues({}, e14));
const [jH, , ZH] = Dp("gc-treeitem");
const [GH] = ZH("text");
const [UH] = ZH("icon");
class qH extends ep.Component {
  render() {
    const e14 = kp(jH, this.props.customCSS);
    if ("custom" === this.props.type) return ep.createElement("div", { className: e14 }, this.props.customNode);
    const { text: t10, icon: n10, selected: r10, disabled: o10, onClick: a10, onIconClick: i10 } = this.props;
    const s10 = { customCSS: GH, block: true, size: "small", accent: r10 ? "full" : "none", background: r10 ? "default" : "transparent", disabled: o10, onClick: a10, text: t10 };
    const l10 = { customCSS: UH, disabled: o10, icon: n10, size: "small", accent: r10 ? "full" : "icon", background: "transparent", onClick: i10 };
    return ep.createElement("div", { className: e14 }, ep.createElement(qm, __spreadValues({}, s10)), n10 && ep.createElement(qm, __spreadValues({}, l10)));
  }
}
const [YH] = Dp("gc-treeview");
const [KH, , XH] = Dp("gc-treenode");
const [JH, QH] = XH("subtree");
class eI extends ep.Component {
  constructor() {
    super(...arguments), this.renderNode = (e14, t10) => {
      const { outline: n10, disabled: r10, defaultToggleIcon: o10, defaultExpandedToggleIcon: a10, renderNode: i10, onNodeClick: s10, onNodeIconClick: l10 } = this.props;
      const { nodes: c10, text: u10, icon: d10, customCSS: p10, expanded: m10, selected: h10 } = e14;
      const f10 = c10 || [];
      const g10 = f10.length > 0 && true === m10;
      let y10;
      y10 = g10 ? d10 || a10 : f10.length > 0 ? d10 || o10 : d10;
      const v10 = (n11) => {
        s10 && s10(e14, t10);
      };
      const b10 = (n11) => {
        l10 ? l10(e14, t10) : s10 && s10(e14, t10);
      };
      let S10;
      S10 = i10 ? { type: "custom", customNode: i10(e14, t10, r10), customCSS: p10 } : { type: "default", text: u10, icon: y10, customCSS: p10, selected: h10, disabled: r10, onClick: v10, onIconClick: b10 };
      const C10 = kp(JH, { [QH("outline")]: n10 });
      return ep.createElement("div", { className: KH, key: `node_${t10.join("-")}` }, ep.createElement(qH, __spreadValues({}, S10)), g10 && ep.createElement("div", { className: C10 }, f10.map((e15, n11) => this.renderNode(e15, [...t10, n11]))));
    };
  }
  render() {
    const { nodes: e14, customCSS: t10 } = this.props;
    return ep.createElement("div", { className: kp(YH, t10) }, e14.map((e15, t11) => this.renderNode(e15, [t11])));
  }
}
eI.defaultProps = { defaultExpandedToggleIcon: nf(Jm), defaultToggleIcon: nf(Xm), disabled: false, outline: false };
const [tI, nI] = Dp("gc-checklist");
class rI extends ep.Component {
  constructor() {
    super(...arguments), this._mediaMap = null, this._disposables = [], this.state = { columns: this.props.layout.columnsDefault || 3 }, this.generateColumnStyles = (e14, t10) => {
      if (!e14 && !t10) return;
      let n10 = [];
      e14 && n10.push(e14), t10 && n10.push(...t10.map((e15) => e15.amount)), n10.forEach((e15) => {
        if (e15 < 6 || document.getElementById(`${tI}-col-${e15}`)) return;
        const t11 = document.createElement("style");
        t11.id = `${tI}-col-${e15}`, t11.innerHTML = `
				.${tI}.${nI("horizontal")}.${rm(e15)} > .${lM},
				.${tI}.${nI("horizontal")}.${rm(e15)} > .${fE} {
					max-width: calc(100% / ${e15});
				}
			`, document.body.appendChild(t11);
      });
    }, this.generateMediaMap = (e14) => {
      if (this._mediaMap = {}, !e14) return;
      const t10 = e14.sort((e15, t11) => e15.breakpoint - t11.breakpoint);
      const n10 = (e15) => `(max-width: ${e15}px)`;
      let r10;
      for (let e15 = 0; e15 < t10.length; e15++) {
        const o10 = n10(t10[e15].breakpoint);
        const a10 = t10[e15 + 1] && n10(t10[e15 + 1].breakpoint);
        const i10 = r10 || window.matchMedia(o10);
        a10 && (r10 = window.matchMedia(a10)), i10.addListener(this.onMediaMatch), this._disposables.push(() => i10.removeListener(this.onMediaMatch)), this._mediaMap[i10.media] = { query: i10, columns: t10[e15].amount, next: a10 && r10.media };
      }
    }, this.onMediaMatch = (e14) => {
      const { _mediaMap: t10, props: { layout: n10 } } = this;
      if (!t10) return;
      const r10 = t10[e14.media];
      let o10;
      o10 = e14.matches ? r10.columns : r10.next ? t10[r10.next].columns : n10.columnsDefault || 3, this.setState({ columns: o10 });
    }, this.mapItems = (e14, t10) => {
      if (!e14) return null;
      const { type: n10, size: r10, invalid: o10, disabled: a10, textAlign: i10, onChange: s10 } = this.props;
      if ("checkboxes" === n10) {
        const n11 = __spreadProps(__spreadValues({ onChange: s10 }, e14), { disabled: a10 || e14.disabled, invalid: o10, size: r10, textAlign: i10 });
        return ep.createElement(CE, __spreadProps(__spreadValues({}, n11), { key: t10 }));
      }
      if ("radios" === n10) {
        const n11 = __spreadProps(__spreadValues({ onChange: s10 }, e14), { disabled: a10 || e14.disabled, invalid: o10, size: r10, textAlign: i10 });
        return ep.createElement(mM, __spreadProps(__spreadValues({}, n11), { key: t10 }));
      }
      return null;
    };
  }
  componentDidMount() {
    const { _mediaMap: e14, props: { layout: t10 }, state: { columns: n10 } } = this;
    if ("vertical" !== t10.direction) if (t10.columns) {
      const { columns: e15 } = t10;
      this.generateColumnStyles(e15);
    } else {
      if (t10.columnsMedia) {
        const { columnsDefault: e15, columnsMedia: n11 } = t10;
        n11 && this.generateMediaMap(n11), this.generateColumnStyles(e15, n11);
      }
      if (e14) {
        let r10 = t10.columnsDefault || n10;
        for (const t11 of Object.keys(e14)) if (e14[t11].query.matches) {
          r10 = e14[t11].columns;
          break;
        }
        r10 !== n10 && this.setState({ columns: r10 });
      }
    }
  }
  componentWillUnmount() {
    this._disposables.forEach((e14) => e14());
  }
  componentDidUpdate() {
    const { layout: e14 } = this.props;
    if ("horizontal" === e14.direction) {
      const { columns: t10, columnsDefault: n10, columnsMedia: r10 } = e14;
      if (t10) return void this.generateColumnStyles(t10);
      r10 && !this._mediaMap && (this.generateMediaMap(r10), this.generateColumnStyles(n10, r10));
    } else this._mediaMap && (this._mediaMap = null);
  }
  render() {
    const { props: { items: e14, dataAid: t10, customCSS: n10, layout: r10, align: o10, itemOffset: a10 }, state: { columns: i10 } } = this;
    let s10;
    "horizontal" === r10.direction && (s10 = r10.columns);
    const l10 = kp(tI, n10, { [nI("horizontal")]: "horizontal" === r10.direction, [nI(`align-${o10}`)]: "vertical" === r10.direction && "left" !== o10, [nI("with-offset")]: a10, [rm(s10 || i10)]: "horizontal" === r10.direction });
    return ep.createElement("div", { className: l10, "data-aid": t10 }, e14.map(this.mapItems));
  }
}
rI.defaultProps = { layout: { direction: "vertical" }, align: "left", disabled: false, invalid: false, itemOffset: false, size: "default", textAlign: "right" };
var oI = { exports: {} };
var aI;
(aI = oI).exports = function() {
  var e14;
  function t10() {
    return e14.apply(null, arguments);
  }
  function n10(t11) {
    e14 = t11;
  }
  function r10(e15) {
    return e15 instanceof Array || "[object Array]" === Object.prototype.toString.call(e15);
  }
  function o10(e15) {
    return null != e15 && "[object Object]" === Object.prototype.toString.call(e15);
  }
  function a10(e15, t11) {
    return Object.prototype.hasOwnProperty.call(e15, t11);
  }
  function i10(e15) {
    if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(e15).length;
    var t11;
    for (t11 in e15) if (a10(e15, t11)) return false;
    return true;
  }
  function s10(e15) {
    return void 0 === e15;
  }
  function l10(e15) {
    return "number" == typeof e15 || "[object Number]" === Object.prototype.toString.call(e15);
  }
  function c10(e15) {
    return e15 instanceof Date || "[object Date]" === Object.prototype.toString.call(e15);
  }
  function u10(e15, t11) {
    var n11, r11 = [], o11 = e15.length;
    for (n11 = 0; n11 < o11; ++n11) r11.push(t11(e15[n11], n11));
    return r11;
  }
  function d10(e15, t11) {
    for (var n11 in t11) a10(t11, n11) && (e15[n11] = t11[n11]);
    return a10(t11, "toString") && (e15.toString = t11.toString), a10(t11, "valueOf") && (e15.valueOf = t11.valueOf), e15;
  }
  function p10(e15, t11, n11, r11) {
    return Un2(e15, t11, n11, r11, true).utc();
  }
  function m10() {
    return { empty: false, unusedTokens: [], unusedInput: [], overflow: -2, charsLeftOver: 0, nullInput: false, invalidEra: null, invalidMonth: null, invalidFormat: false, userInvalidated: false, iso: false, parsedDateParts: [], era: null, meridiem: null, rfc2822: false, weekdayMismatch: false };
  }
  function h10(e15) {
    return null == e15._pf && (e15._pf = m10()), e15._pf;
  }
  var f10;
  function g10(e15) {
    if (null == e15._isValid) {
      var t11 = h10(e15), n11 = f10.call(t11.parsedDateParts, function(e16) {
        return null != e16;
      }), r11 = !isNaN(e15._d.getTime()) && t11.overflow < 0 && !t11.empty && !t11.invalidEra && !t11.invalidMonth && !t11.invalidWeekday && !t11.weekdayMismatch && !t11.nullInput && !t11.invalidFormat && !t11.userInvalidated && (!t11.meridiem || t11.meridiem && n11);
      if (e15._strict && (r11 = r11 && 0 === t11.charsLeftOver && 0 === t11.unusedTokens.length && void 0 === t11.bigHour), null != Object.isFrozen && Object.isFrozen(e15)) return r11;
      e15._isValid = r11;
    }
    return e15._isValid;
  }
  function y10(e15) {
    var t11 = p10(NaN);
    return null != e15 ? d10(h10(t11), e15) : h10(t11).userInvalidated = true, t11;
  }
  f10 = Array.prototype.some ? Array.prototype.some : function(e15) {
    var t11, n11 = Object(this), r11 = n11.length >>> 0;
    for (t11 = 0; t11 < r11; t11++) if (t11 in n11 && e15.call(this, n11[t11], t11, n11)) return true;
    return false;
  };
  var v10 = t10.momentProperties = [], b10 = false;
  function S10(e15, t11) {
    var n11, r11, o11, a11 = v10.length;
    if (s10(t11._isAMomentObject) || (e15._isAMomentObject = t11._isAMomentObject), s10(t11._i) || (e15._i = t11._i), s10(t11._f) || (e15._f = t11._f), s10(t11._l) || (e15._l = t11._l), s10(t11._strict) || (e15._strict = t11._strict), s10(t11._tzm) || (e15._tzm = t11._tzm), s10(t11._isUTC) || (e15._isUTC = t11._isUTC), s10(t11._offset) || (e15._offset = t11._offset), s10(t11._pf) || (e15._pf = h10(t11)), s10(t11._locale) || (e15._locale = t11._locale), a11 > 0) for (n11 = 0; n11 < a11; n11++) s10(o11 = t11[r11 = v10[n11]]) || (e15[r11] = o11);
    return e15;
  }
  function C10(e15) {
    S10(this, e15), this._d = new Date(null != e15._d ? e15._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), false === b10 && (b10 = true, t10.updateOffset(this), b10 = false);
  }
  function x10(e15) {
    return e15 instanceof C10 || null != e15 && null != e15._isAMomentObject;
  }
  function w10(e15) {
    false === t10.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + e15);
  }
  function T10(e15, n11) {
    var r11 = true;
    return d10(function() {
      if (null != t10.deprecationHandler && t10.deprecationHandler(null, e15), r11) {
        var o11, i11, s11, l11 = [], c11 = arguments.length;
        for (i11 = 0; i11 < c11; i11++) {
          if (o11 = "", "object" == typeof arguments[i11]) {
            for (s11 in o11 += "\n[" + i11 + "] ", arguments[0]) a10(arguments[0], s11) && (o11 += s11 + ": " + arguments[0][s11] + ", ");
            o11 = o11.slice(0, -2);
          } else o11 = arguments[i11];
          l11.push(o11);
        }
        w10(e15 + "\nArguments: " + Array.prototype.slice.call(l11).join("") + "\n" + new Error().stack), r11 = false;
      }
      return n11.apply(this, arguments);
    }, n11);
  }
  var E10 = {};
  function F10(e15, n11) {
    null != t10.deprecationHandler && t10.deprecationHandler(e15, n11), E10[e15] || (w10(n11), E10[e15] = true);
  }
  function M10(e15) {
    return "undefined" != typeof Function && e15 instanceof Function || "[object Function]" === Object.prototype.toString.call(e15);
  }
  function k10(e15) {
    var t11, n11;
    for (n11 in e15) a10(e15, n11) && (M10(t11 = e15[n11]) ? this[n11] = t11 : this["_" + n11] = t11);
    this._config = e15, this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
  }
  function P10(e15, t11) {
    var n11, r11 = d10({}, e15);
    for (n11 in t11) a10(t11, n11) && (o10(e15[n11]) && o10(t11[n11]) ? (r11[n11] = {}, d10(r11[n11], e15[n11]), d10(r11[n11], t11[n11])) : null != t11[n11] ? r11[n11] = t11[n11] : delete r11[n11]);
    for (n11 in e15) a10(e15, n11) && !a10(t11, n11) && o10(e15[n11]) && (r11[n11] = d10({}, r11[n11]));
    return r11;
  }
  function N10(e15) {
    null != e15 && this.set(e15);
  }
  var D10;
  t10.suppressDeprecationWarnings = false, t10.deprecationHandler = null, D10 = Object.keys ? Object.keys : function(e15) {
    var t11, n11 = [];
    for (t11 in e15) a10(e15, t11) && n11.push(t11);
    return n11;
  };
  var L10 = { sameDay: "[Today at] LT", nextDay: "[Tomorrow at] LT", nextWeek: "dddd [at] LT", lastDay: "[Yesterday at] LT", lastWeek: "[Last] dddd [at] LT", sameElse: "L" };
  function H10(e15, t11, n11) {
    var r11 = this._calendar[e15] || this._calendar.sameElse;
    return M10(r11) ? r11.call(t11, n11) : r11;
  }
  function I10(e15, t11, n11) {
    var r11 = "" + Math.abs(e15), o11 = t11 - r11.length;
    return (e15 >= 0 ? n11 ? "+" : "" : "-") + Math.pow(10, Math.max(0, o11)).toString().substr(1) + r11;
  }
  var _10 = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, V10 = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, R10 = {}, A10 = {};
  function O10(e15, t11, n11, r11) {
    var o11 = r11;
    "string" == typeof r11 && (o11 = function() {
      return this[r11]();
    }), e15 && (A10[e15] = o11), t11 && (A10[t11[0]] = function() {
      return I10(o11.apply(this, arguments), t11[1], t11[2]);
    }), n11 && (A10[n11] = function() {
      return this.localeData().ordinal(o11.apply(this, arguments), e15);
    });
  }
  function B10(e15) {
    return e15.match(/\[[\s\S]/) ? e15.replace(/^\[|\]$/g, "") : e15.replace(/\\/g, "");
  }
  function z10(e15) {
    var t11, n11, r11 = e15.match(_10);
    for (t11 = 0, n11 = r11.length; t11 < n11; t11++) A10[r11[t11]] ? r11[t11] = A10[r11[t11]] : r11[t11] = B10(r11[t11]);
    return function(t12) {
      var o11, a11 = "";
      for (o11 = 0; o11 < n11; o11++) a11 += M10(r11[o11]) ? r11[o11].call(t12, e15) : r11[o11];
      return a11;
    };
  }
  function $10(e15, t11) {
    return e15.isValid() ? (t11 = W10(t11, e15.localeData()), R10[t11] = R10[t11] || z10(t11), R10[t11](e15)) : e15.localeData().invalidDate();
  }
  function W10(e15, t11) {
    var n11 = 5;
    function r11(e16) {
      return t11.longDateFormat(e16) || e16;
    }
    for (V10.lastIndex = 0; n11 >= 0 && V10.test(e15); ) e15 = e15.replace(V10, r11), V10.lastIndex = 0, n11 -= 1;
    return e15;
  }
  var j10 = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
  function Z10(e15) {
    var t11 = this._longDateFormat[e15], n11 = this._longDateFormat[e15.toUpperCase()];
    return t11 || !n11 ? t11 : (this._longDateFormat[e15] = n11.match(_10).map(function(e16) {
      return "MMMM" === e16 || "MM" === e16 || "DD" === e16 || "dddd" === e16 ? e16.slice(1) : e16;
    }).join(""), this._longDateFormat[e15]);
  }
  var G10 = "Invalid date";
  function U10() {
    return this._invalidDate;
  }
  var q10 = "%d", Y10 = /\d{1,2}/;
  function K10(e15) {
    return this._ordinal.replace("%d", e15);
  }
  var X10 = { future: "in %s", past: "%s ago", s: "a few seconds", ss: "%d seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", w: "a week", ww: "%d weeks", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
  function J10(e15, t11, n11, r11) {
    var o11 = this._relativeTime[n11];
    return M10(o11) ? o11(e15, t11, n11, r11) : o11.replace(/%d/i, e15);
  }
  function Q10(e15, t11) {
    var n11 = this._relativeTime[e15 > 0 ? "future" : "past"];
    return M10(n11) ? n11(t11) : n11.replace(/%s/i, t11);
  }
  var ee2 = {};
  function te2(e15, t11) {
    var n11 = e15.toLowerCase();
    ee2[n11] = ee2[n11 + "s"] = ee2[t11] = e15;
  }
  function ne2(e15) {
    return "string" == typeof e15 ? ee2[e15] || ee2[e15.toLowerCase()] : void 0;
  }
  function re2(e15) {
    var t11, n11, r11 = {};
    for (n11 in e15) a10(e15, n11) && (t11 = ne2(n11)) && (r11[t11] = e15[n11]);
    return r11;
  }
  var oe2 = {};
  function ae2(e15, t11) {
    oe2[e15] = t11;
  }
  function ie2(e15) {
    var t11, n11 = [];
    for (t11 in e15) a10(e15, t11) && n11.push({ unit: t11, priority: oe2[t11] });
    return n11.sort(function(e16, t12) {
      return e16.priority - t12.priority;
    }), n11;
  }
  function se2(e15) {
    return e15 % 4 == 0 && e15 % 100 != 0 || e15 % 400 == 0;
  }
  function le2(e15) {
    return e15 < 0 ? Math.ceil(e15) || 0 : Math.floor(e15);
  }
  function ce2(e15) {
    var t11 = +e15, n11 = 0;
    return 0 !== t11 && isFinite(t11) && (n11 = le2(t11)), n11;
  }
  function ue2(e15, n11) {
    return function(r11) {
      return null != r11 ? (pe2(this, e15, r11), t10.updateOffset(this, n11), this) : de2(this, e15);
    };
  }
  function de2(e15, t11) {
    return e15.isValid() ? e15._d["get" + (e15._isUTC ? "UTC" : "") + t11]() : NaN;
  }
  function pe2(e15, t11, n11) {
    e15.isValid() && !isNaN(n11) && ("FullYear" === t11 && se2(e15.year()) && 1 === e15.month() && 29 === e15.date() ? (n11 = ce2(n11), e15._d["set" + (e15._isUTC ? "UTC" : "") + t11](n11, e15.month(), Je2(n11, e15.month()))) : e15._d["set" + (e15._isUTC ? "UTC" : "") + t11](n11));
  }
  function me2(e15) {
    return M10(this[e15 = ne2(e15)]) ? this[e15]() : this;
  }
  function he2(e15, t11) {
    if ("object" == typeof e15) {
      var n11, r11 = ie2(e15 = re2(e15)), o11 = r11.length;
      for (n11 = 0; n11 < o11; n11++) this[r11[n11].unit](e15[r11[n11].unit]);
    } else if (M10(this[e15 = ne2(e15)])) return this[e15](t11);
    return this;
  }
  var fe2, ge2 = /\d/, ye2 = /\d\d/, ve2 = /\d{3}/, be2 = /\d{4}/, Se2 = /[+-]?\d{6}/, Ce2 = /\d\d?/, xe2 = /\d\d\d\d?/, we2 = /\d\d\d\d\d\d?/, Te2 = /\d{1,3}/, Ee2 = /\d{1,4}/, Fe2 = /[+-]?\d{1,6}/, Me2 = /\d+/, ke2 = /[+-]?\d+/, Pe2 = /Z|[+-]\d\d:?\d\d/gi, Ne2 = /Z|[+-]\d\d(?::?\d\d)?/gi, De2 = /[+-]?\d+(\.\d{1,3})?/, Le2 = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
  function He2(e15, t11, n11) {
    fe2[e15] = M10(t11) ? t11 : function(e16, r11) {
      return e16 && n11 ? n11 : t11;
    };
  }
  function Ie2(e15, t11) {
    return a10(fe2, e15) ? fe2[e15](t11._strict, t11._locale) : new RegExp(_e2(e15));
  }
  function _e2(e15) {
    return Ve2(e15.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(e16, t11, n11, r11, o11) {
      return t11 || n11 || r11 || o11;
    }));
  }
  function Ve2(e15) {
    return e15.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
  }
  fe2 = {};
  var Re2 = {};
  function Ae2(e15, t11) {
    var n11, r11, o11 = t11;
    for ("string" == typeof e15 && (e15 = [e15]), l10(t11) && (o11 = function(e16, n12) {
      n12[t11] = ce2(e16);
    }), r11 = e15.length, n11 = 0; n11 < r11; n11++) Re2[e15[n11]] = o11;
  }
  function Oe2(e15, t11) {
    Ae2(e15, function(e16, n11, r11, o11) {
      r11._w = r11._w || {}, t11(e16, r11._w, r11, o11);
    });
  }
  function Be2(e15, t11, n11) {
    null != t11 && a10(Re2, e15) && Re2[e15](t11, n11._a, n11, e15);
  }
  var ze2 = 0, $e2 = 1, We2 = 2, je2 = 3, Ze2 = 4, Ge2 = 5, Ue2 = 6, qe2 = 7, Ye2 = 8;
  function Ke2(e15, t11) {
    return (e15 % t11 + t11) % t11;
  }
  var Xe2;
  function Je2(e15, t11) {
    if (isNaN(e15) || isNaN(t11)) return NaN;
    var n11 = Ke2(t11, 12);
    return e15 += (t11 - n11) / 12, 1 === n11 ? se2(e15) ? 29 : 28 : 31 - n11 % 7 % 2;
  }
  Xe2 = Array.prototype.indexOf ? Array.prototype.indexOf : function(e15) {
    var t11;
    for (t11 = 0; t11 < this.length; ++t11) if (this[t11] === e15) return t11;
    return -1;
  }, O10("M", ["MM", 2], "Mo", function() {
    return this.month() + 1;
  }), O10("MMM", 0, 0, function(e15) {
    return this.localeData().monthsShort(this, e15);
  }), O10("MMMM", 0, 0, function(e15) {
    return this.localeData().months(this, e15);
  }), te2("month", "M"), ae2("month", 8), He2("M", Ce2), He2("MM", Ce2, ye2), He2("MMM", function(e15, t11) {
    return t11.monthsShortRegex(e15);
  }), He2("MMMM", function(e15, t11) {
    return t11.monthsRegex(e15);
  }), Ae2(["M", "MM"], function(e15, t11) {
    t11[$e2] = ce2(e15) - 1;
  }), Ae2(["MMM", "MMMM"], function(e15, t11, n11, r11) {
    var o11 = n11._locale.monthsParse(e15, r11, n11._strict);
    null != o11 ? t11[$e2] = o11 : h10(n11).invalidMonth = e15;
  });
  var Qe2 = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), et2 = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), tt2 = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, nt2 = Le2, rt2 = Le2;
  function ot2(e15, t11) {
    return e15 ? r10(this._months) ? this._months[e15.month()] : this._months[(this._months.isFormat || tt2).test(t11) ? "format" : "standalone"][e15.month()] : r10(this._months) ? this._months : this._months.standalone;
  }
  function at2(e15, t11) {
    return e15 ? r10(this._monthsShort) ? this._monthsShort[e15.month()] : this._monthsShort[tt2.test(t11) ? "format" : "standalone"][e15.month()] : r10(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
  }
  function it2(e15, t11, n11) {
    var r11, o11, a11, i11 = e15.toLocaleLowerCase();
    if (!this._monthsParse) for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], r11 = 0; r11 < 12; ++r11) a11 = p10([2e3, r11]), this._shortMonthsParse[r11] = this.monthsShort(a11, "").toLocaleLowerCase(), this._longMonthsParse[r11] = this.months(a11, "").toLocaleLowerCase();
    return n11 ? "MMM" === t11 ? -1 !== (o11 = Xe2.call(this._shortMonthsParse, i11)) ? o11 : null : -1 !== (o11 = Xe2.call(this._longMonthsParse, i11)) ? o11 : null : "MMM" === t11 ? -1 !== (o11 = Xe2.call(this._shortMonthsParse, i11)) || -1 !== (o11 = Xe2.call(this._longMonthsParse, i11)) ? o11 : null : -1 !== (o11 = Xe2.call(this._longMonthsParse, i11)) || -1 !== (o11 = Xe2.call(this._shortMonthsParse, i11)) ? o11 : null;
  }
  function st2(e15, t11, n11) {
    var r11, o11, a11;
    if (this._monthsParseExact) return it2.call(this, e15, t11, n11);
    for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), r11 = 0; r11 < 12; r11++) {
      if (o11 = p10([2e3, r11]), n11 && !this._longMonthsParse[r11] && (this._longMonthsParse[r11] = new RegExp("^" + this.months(o11, "").replace(".", "") + "$", "i"), this._shortMonthsParse[r11] = new RegExp("^" + this.monthsShort(o11, "").replace(".", "") + "$", "i")), n11 || this._monthsParse[r11] || (a11 = "^" + this.months(o11, "") + "|^" + this.monthsShort(o11, ""), this._monthsParse[r11] = new RegExp(a11.replace(".", ""), "i")), n11 && "MMMM" === t11 && this._longMonthsParse[r11].test(e15)) return r11;
      if (n11 && "MMM" === t11 && this._shortMonthsParse[r11].test(e15)) return r11;
      if (!n11 && this._monthsParse[r11].test(e15)) return r11;
    }
  }
  function lt2(e15, t11) {
    var n11;
    if (!e15.isValid()) return e15;
    if ("string" == typeof t11) {
      if (/^\d+$/.test(t11)) t11 = ce2(t11);
      else if (!l10(t11 = e15.localeData().monthsParse(t11))) return e15;
    }
    return n11 = Math.min(e15.date(), Je2(e15.year(), t11)), e15._d["set" + (e15._isUTC ? "UTC" : "") + "Month"](t11, n11), e15;
  }
  function ct2(e15) {
    return null != e15 ? (lt2(this, e15), t10.updateOffset(this, true), this) : de2(this, "Month");
  }
  function ut2() {
    return Je2(this.year(), this.month());
  }
  function dt2(e15) {
    return this._monthsParseExact ? (a10(this, "_monthsRegex") || mt2.call(this), e15 ? this._monthsShortStrictRegex : this._monthsShortRegex) : (a10(this, "_monthsShortRegex") || (this._monthsShortRegex = nt2), this._monthsShortStrictRegex && e15 ? this._monthsShortStrictRegex : this._monthsShortRegex);
  }
  function pt2(e15) {
    return this._monthsParseExact ? (a10(this, "_monthsRegex") || mt2.call(this), e15 ? this._monthsStrictRegex : this._monthsRegex) : (a10(this, "_monthsRegex") || (this._monthsRegex = rt2), this._monthsStrictRegex && e15 ? this._monthsStrictRegex : this._monthsRegex);
  }
  function mt2() {
    function e15(e16, t12) {
      return t12.length - e16.length;
    }
    var t11, n11, r11 = [], o11 = [], a11 = [];
    for (t11 = 0; t11 < 12; t11++) n11 = p10([2e3, t11]), r11.push(this.monthsShort(n11, "")), o11.push(this.months(n11, "")), a11.push(this.months(n11, "")), a11.push(this.monthsShort(n11, ""));
    for (r11.sort(e15), o11.sort(e15), a11.sort(e15), t11 = 0; t11 < 12; t11++) r11[t11] = Ve2(r11[t11]), o11[t11] = Ve2(o11[t11]);
    for (t11 = 0; t11 < 24; t11++) a11[t11] = Ve2(a11[t11]);
    this._monthsRegex = new RegExp("^(" + a11.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp("^(" + o11.join("|") + ")", "i"), this._monthsShortStrictRegex = new RegExp("^(" + r11.join("|") + ")", "i");
  }
  function ht2(e15) {
    return se2(e15) ? 366 : 365;
  }
  O10("Y", 0, 0, function() {
    var e15 = this.year();
    return e15 <= 9999 ? I10(e15, 4) : "+" + e15;
  }), O10(0, ["YY", 2], 0, function() {
    return this.year() % 100;
  }), O10(0, ["YYYY", 4], 0, "year"), O10(0, ["YYYYY", 5], 0, "year"), O10(0, ["YYYYYY", 6, true], 0, "year"), te2("year", "y"), ae2("year", 1), He2("Y", ke2), He2("YY", Ce2, ye2), He2("YYYY", Ee2, be2), He2("YYYYY", Fe2, Se2), He2("YYYYYY", Fe2, Se2), Ae2(["YYYYY", "YYYYYY"], ze2), Ae2("YYYY", function(e15, n11) {
    n11[ze2] = 2 === e15.length ? t10.parseTwoDigitYear(e15) : ce2(e15);
  }), Ae2("YY", function(e15, n11) {
    n11[ze2] = t10.parseTwoDigitYear(e15);
  }), Ae2("Y", function(e15, t11) {
    t11[ze2] = parseInt(e15, 10);
  }), t10.parseTwoDigitYear = function(e15) {
    return ce2(e15) + (ce2(e15) > 68 ? 1900 : 2e3);
  };
  var ft2 = ue2("FullYear", true);
  function gt2() {
    return se2(this.year());
  }
  function yt2(e15, t11, n11, r11, o11, a11, i11) {
    var s11;
    return e15 < 100 && e15 >= 0 ? (s11 = new Date(e15 + 400, t11, n11, r11, o11, a11, i11), isFinite(s11.getFullYear()) && s11.setFullYear(e15)) : s11 = new Date(e15, t11, n11, r11, o11, a11, i11), s11;
  }
  function vt2(e15) {
    var t11, n11;
    return e15 < 100 && e15 >= 0 ? ((n11 = Array.prototype.slice.call(arguments))[0] = e15 + 400, t11 = new Date(Date.UTC.apply(null, n11)), isFinite(t11.getUTCFullYear()) && t11.setUTCFullYear(e15)) : t11 = new Date(Date.UTC.apply(null, arguments)), t11;
  }
  function bt2(e15, t11, n11) {
    var r11 = 7 + t11 - n11;
    return -(7 + vt2(e15, 0, r11).getUTCDay() - t11) % 7 + r11 - 1;
  }
  function St2(e15, t11, n11, r11, o11) {
    var a11, i11, s11 = 1 + 7 * (t11 - 1) + (7 + n11 - r11) % 7 + bt2(e15, r11, o11);
    return s11 <= 0 ? i11 = ht2(a11 = e15 - 1) + s11 : s11 > ht2(e15) ? (a11 = e15 + 1, i11 = s11 - ht2(e15)) : (a11 = e15, i11 = s11), { year: a11, dayOfYear: i11 };
  }
  function Ct2(e15, t11, n11) {
    var r11, o11, a11 = bt2(e15.year(), t11, n11), i11 = Math.floor((e15.dayOfYear() - a11 - 1) / 7) + 1;
    return i11 < 1 ? r11 = i11 + xt2(o11 = e15.year() - 1, t11, n11) : i11 > xt2(e15.year(), t11, n11) ? (r11 = i11 - xt2(e15.year(), t11, n11), o11 = e15.year() + 1) : (o11 = e15.year(), r11 = i11), { week: r11, year: o11 };
  }
  function xt2(e15, t11, n11) {
    var r11 = bt2(e15, t11, n11), o11 = bt2(e15 + 1, t11, n11);
    return (ht2(e15) - r11 + o11) / 7;
  }
  function wt2(e15) {
    return Ct2(e15, this._week.dow, this._week.doy).week;
  }
  O10("w", ["ww", 2], "wo", "week"), O10("W", ["WW", 2], "Wo", "isoWeek"), te2("week", "w"), te2("isoWeek", "W"), ae2("week", 5), ae2("isoWeek", 5), He2("w", Ce2), He2("ww", Ce2, ye2), He2("W", Ce2), He2("WW", Ce2, ye2), Oe2(["w", "ww", "W", "WW"], function(e15, t11, n11, r11) {
    t11[r11.substr(0, 1)] = ce2(e15);
  });
  var Tt2 = { dow: 0, doy: 6 };
  function Et2() {
    return this._week.dow;
  }
  function Ft2() {
    return this._week.doy;
  }
  function Mt2(e15) {
    var t11 = this.localeData().week(this);
    return null == e15 ? t11 : this.add(7 * (e15 - t11), "d");
  }
  function kt2(e15) {
    var t11 = Ct2(this, 1, 4).week;
    return null == e15 ? t11 : this.add(7 * (e15 - t11), "d");
  }
  function Pt2(e15, t11) {
    return "string" != typeof e15 ? e15 : isNaN(e15) ? "number" == typeof (e15 = t11.weekdaysParse(e15)) ? e15 : null : parseInt(e15, 10);
  }
  function Nt2(e15, t11) {
    return "string" == typeof e15 ? t11.weekdaysParse(e15) % 7 || 7 : isNaN(e15) ? null : e15;
  }
  function Dt2(e15, t11) {
    return e15.slice(t11, 7).concat(e15.slice(0, t11));
  }
  O10("d", 0, "do", "day"), O10("dd", 0, 0, function(e15) {
    return this.localeData().weekdaysMin(this, e15);
  }), O10("ddd", 0, 0, function(e15) {
    return this.localeData().weekdaysShort(this, e15);
  }), O10("dddd", 0, 0, function(e15) {
    return this.localeData().weekdays(this, e15);
  }), O10("e", 0, 0, "weekday"), O10("E", 0, 0, "isoWeekday"), te2("day", "d"), te2("weekday", "e"), te2("isoWeekday", "E"), ae2("day", 11), ae2("weekday", 11), ae2("isoWeekday", 11), He2("d", Ce2), He2("e", Ce2), He2("E", Ce2), He2("dd", function(e15, t11) {
    return t11.weekdaysMinRegex(e15);
  }), He2("ddd", function(e15, t11) {
    return t11.weekdaysShortRegex(e15);
  }), He2("dddd", function(e15, t11) {
    return t11.weekdaysRegex(e15);
  }), Oe2(["dd", "ddd", "dddd"], function(e15, t11, n11, r11) {
    var o11 = n11._locale.weekdaysParse(e15, r11, n11._strict);
    null != o11 ? t11.d = o11 : h10(n11).invalidWeekday = e15;
  }), Oe2(["d", "e", "E"], function(e15, t11, n11, r11) {
    t11[r11] = ce2(e15);
  });
  var Lt2 = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), Ht2 = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), It2 = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), _t2 = Le2, Vt2 = Le2, Rt2 = Le2;
  function At2(e15, t11) {
    var n11 = r10(this._weekdays) ? this._weekdays : this._weekdays[e15 && true !== e15 && this._weekdays.isFormat.test(t11) ? "format" : "standalone"];
    return true === e15 ? Dt2(n11, this._week.dow) : e15 ? n11[e15.day()] : n11;
  }
  function Ot2(e15) {
    return true === e15 ? Dt2(this._weekdaysShort, this._week.dow) : e15 ? this._weekdaysShort[e15.day()] : this._weekdaysShort;
  }
  function Bt2(e15) {
    return true === e15 ? Dt2(this._weekdaysMin, this._week.dow) : e15 ? this._weekdaysMin[e15.day()] : this._weekdaysMin;
  }
  function zt2(e15, t11, n11) {
    var r11, o11, a11, i11 = e15.toLocaleLowerCase();
    if (!this._weekdaysParse) for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], r11 = 0; r11 < 7; ++r11) a11 = p10([2e3, 1]).day(r11), this._minWeekdaysParse[r11] = this.weekdaysMin(a11, "").toLocaleLowerCase(), this._shortWeekdaysParse[r11] = this.weekdaysShort(a11, "").toLocaleLowerCase(), this._weekdaysParse[r11] = this.weekdays(a11, "").toLocaleLowerCase();
    return n11 ? "dddd" === t11 ? -1 !== (o11 = Xe2.call(this._weekdaysParse, i11)) ? o11 : null : "ddd" === t11 ? -1 !== (o11 = Xe2.call(this._shortWeekdaysParse, i11)) ? o11 : null : -1 !== (o11 = Xe2.call(this._minWeekdaysParse, i11)) ? o11 : null : "dddd" === t11 ? -1 !== (o11 = Xe2.call(this._weekdaysParse, i11)) || -1 !== (o11 = Xe2.call(this._shortWeekdaysParse, i11)) || -1 !== (o11 = Xe2.call(this._minWeekdaysParse, i11)) ? o11 : null : "ddd" === t11 ? -1 !== (o11 = Xe2.call(this._shortWeekdaysParse, i11)) || -1 !== (o11 = Xe2.call(this._weekdaysParse, i11)) || -1 !== (o11 = Xe2.call(this._minWeekdaysParse, i11)) ? o11 : null : -1 !== (o11 = Xe2.call(this._minWeekdaysParse, i11)) || -1 !== (o11 = Xe2.call(this._weekdaysParse, i11)) || -1 !== (o11 = Xe2.call(this._shortWeekdaysParse, i11)) ? o11 : null;
  }
  function $t2(e15, t11, n11) {
    var r11, o11, a11;
    if (this._weekdaysParseExact) return zt2.call(this, e15, t11, n11);
    for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), r11 = 0; r11 < 7; r11++) {
      if (o11 = p10([2e3, 1]).day(r11), n11 && !this._fullWeekdaysParse[r11] && (this._fullWeekdaysParse[r11] = new RegExp("^" + this.weekdays(o11, "").replace(".", "\\.?") + "$", "i"), this._shortWeekdaysParse[r11] = new RegExp("^" + this.weekdaysShort(o11, "").replace(".", "\\.?") + "$", "i"), this._minWeekdaysParse[r11] = new RegExp("^" + this.weekdaysMin(o11, "").replace(".", "\\.?") + "$", "i")), this._weekdaysParse[r11] || (a11 = "^" + this.weekdays(o11, "") + "|^" + this.weekdaysShort(o11, "") + "|^" + this.weekdaysMin(o11, ""), this._weekdaysParse[r11] = new RegExp(a11.replace(".", ""), "i")), n11 && "dddd" === t11 && this._fullWeekdaysParse[r11].test(e15)) return r11;
      if (n11 && "ddd" === t11 && this._shortWeekdaysParse[r11].test(e15)) return r11;
      if (n11 && "dd" === t11 && this._minWeekdaysParse[r11].test(e15)) return r11;
      if (!n11 && this._weekdaysParse[r11].test(e15)) return r11;
    }
  }
  function Wt2(e15) {
    if (!this.isValid()) return null != e15 ? this : NaN;
    var t11 = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    return null != e15 ? (e15 = Pt2(e15, this.localeData()), this.add(e15 - t11, "d")) : t11;
  }
  function jt2(e15) {
    if (!this.isValid()) return null != e15 ? this : NaN;
    var t11 = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return null == e15 ? t11 : this.add(e15 - t11, "d");
  }
  function Zt2(e15) {
    if (!this.isValid()) return null != e15 ? this : NaN;
    if (null != e15) {
      var t11 = Nt2(e15, this.localeData());
      return this.day(this.day() % 7 ? t11 : t11 - 7);
    }
    return this.day() || 7;
  }
  function Gt2(e15) {
    return this._weekdaysParseExact ? (a10(this, "_weekdaysRegex") || Yt2.call(this), e15 ? this._weekdaysStrictRegex : this._weekdaysRegex) : (a10(this, "_weekdaysRegex") || (this._weekdaysRegex = _t2), this._weekdaysStrictRegex && e15 ? this._weekdaysStrictRegex : this._weekdaysRegex);
  }
  function Ut2(e15) {
    return this._weekdaysParseExact ? (a10(this, "_weekdaysRegex") || Yt2.call(this), e15 ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (a10(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Vt2), this._weekdaysShortStrictRegex && e15 ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
  }
  function qt2(e15) {
    return this._weekdaysParseExact ? (a10(this, "_weekdaysRegex") || Yt2.call(this), e15 ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (a10(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Rt2), this._weekdaysMinStrictRegex && e15 ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
  }
  function Yt2() {
    function e15(e16, t12) {
      return t12.length - e16.length;
    }
    var t11, n11, r11, o11, a11, i11 = [], s11 = [], l11 = [], c11 = [];
    for (t11 = 0; t11 < 7; t11++) n11 = p10([2e3, 1]).day(t11), r11 = Ve2(this.weekdaysMin(n11, "")), o11 = Ve2(this.weekdaysShort(n11, "")), a11 = Ve2(this.weekdays(n11, "")), i11.push(r11), s11.push(o11), l11.push(a11), c11.push(r11), c11.push(o11), c11.push(a11);
    i11.sort(e15), s11.sort(e15), l11.sort(e15), c11.sort(e15), this._weekdaysRegex = new RegExp("^(" + c11.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp("^(" + l11.join("|") + ")", "i"), this._weekdaysShortStrictRegex = new RegExp("^(" + s11.join("|") + ")", "i"), this._weekdaysMinStrictRegex = new RegExp("^(" + i11.join("|") + ")", "i");
  }
  function Kt2() {
    return this.hours() % 12 || 12;
  }
  function Xt2() {
    return this.hours() || 24;
  }
  function Jt2(e15, t11) {
    O10(e15, 0, 0, function() {
      return this.localeData().meridiem(this.hours(), this.minutes(), t11);
    });
  }
  function Qt2(e15, t11) {
    return t11._meridiemParse;
  }
  function en2(e15) {
    return "p" === (e15 + "").toLowerCase().charAt(0);
  }
  O10("H", ["HH", 2], 0, "hour"), O10("h", ["hh", 2], 0, Kt2), O10("k", ["kk", 2], 0, Xt2), O10("hmm", 0, 0, function() {
    return "" + Kt2.apply(this) + I10(this.minutes(), 2);
  }), O10("hmmss", 0, 0, function() {
    return "" + Kt2.apply(this) + I10(this.minutes(), 2) + I10(this.seconds(), 2);
  }), O10("Hmm", 0, 0, function() {
    return "" + this.hours() + I10(this.minutes(), 2);
  }), O10("Hmmss", 0, 0, function() {
    return "" + this.hours() + I10(this.minutes(), 2) + I10(this.seconds(), 2);
  }), Jt2("a", true), Jt2("A", false), te2("hour", "h"), ae2("hour", 13), He2("a", Qt2), He2("A", Qt2), He2("H", Ce2), He2("h", Ce2), He2("k", Ce2), He2("HH", Ce2, ye2), He2("hh", Ce2, ye2), He2("kk", Ce2, ye2), He2("hmm", xe2), He2("hmmss", we2), He2("Hmm", xe2), He2("Hmmss", we2), Ae2(["H", "HH"], je2), Ae2(["k", "kk"], function(e15, t11, n11) {
    var r11 = ce2(e15);
    t11[je2] = 24 === r11 ? 0 : r11;
  }), Ae2(["a", "A"], function(e15, t11, n11) {
    n11._isPm = n11._locale.isPM(e15), n11._meridiem = e15;
  }), Ae2(["h", "hh"], function(e15, t11, n11) {
    t11[je2] = ce2(e15), h10(n11).bigHour = true;
  }), Ae2("hmm", function(e15, t11, n11) {
    var r11 = e15.length - 2;
    t11[je2] = ce2(e15.substr(0, r11)), t11[Ze2] = ce2(e15.substr(r11)), h10(n11).bigHour = true;
  }), Ae2("hmmss", function(e15, t11, n11) {
    var r11 = e15.length - 4, o11 = e15.length - 2;
    t11[je2] = ce2(e15.substr(0, r11)), t11[Ze2] = ce2(e15.substr(r11, 2)), t11[Ge2] = ce2(e15.substr(o11)), h10(n11).bigHour = true;
  }), Ae2("Hmm", function(e15, t11, n11) {
    var r11 = e15.length - 2;
    t11[je2] = ce2(e15.substr(0, r11)), t11[Ze2] = ce2(e15.substr(r11));
  }), Ae2("Hmmss", function(e15, t11, n11) {
    var r11 = e15.length - 4, o11 = e15.length - 2;
    t11[je2] = ce2(e15.substr(0, r11)), t11[Ze2] = ce2(e15.substr(r11, 2)), t11[Ge2] = ce2(e15.substr(o11));
  });
  var tn2 = /[ap]\.?m?\.?/i, nn2 = ue2("Hours", true);
  function rn2(e15, t11, n11) {
    return e15 > 11 ? n11 ? "pm" : "PM" : n11 ? "am" : "AM";
  }
  var on2 = { calendar: L10, longDateFormat: j10, invalidDate: G10, ordinal: q10, dayOfMonthOrdinalParse: Y10, relativeTime: X10, months: Qe2, monthsShort: et2, week: Tt2, weekdays: Lt2, weekdaysMin: It2, weekdaysShort: Ht2, meridiemParse: tn2 };
  var an2, sn2 = {}, ln2 = {};
  function cn2(e15, t11) {
    var n11, r11 = Math.min(e15.length, t11.length);
    for (n11 = 0; n11 < r11; n11 += 1) if (e15[n11] !== t11[n11]) return n11;
    return r11;
  }
  function un2(e15) {
    return e15 ? e15.toLowerCase().replace("_", "-") : e15;
  }
  function dn2(e15) {
    var t11, n11, r11, o11, a11 = 0;
    for (; a11 < e15.length; ) {
      for (t11 = (o11 = un2(e15[a11]).split("-")).length, n11 = (n11 = un2(e15[a11 + 1])) ? n11.split("-") : null; t11 > 0; ) {
        if (r11 = mn2(o11.slice(0, t11).join("-"))) return r11;
        if (n11 && n11.length >= t11 && cn2(o11, n11) >= t11 - 1) break;
        t11--;
      }
      a11++;
    }
    return an2;
  }
  function pn2(e15) {
    return null != e15.match("^[^/\\\\]*$");
  }
  function mn2(e15) {
    var t11 = null;
    if (void 0 === sn2[e15] && aI && aI.exports && pn2(e15)) try {
      t11 = an2._abbr, Pl("./locale/" + e15), hn2(t11);
    } catch (t12) {
      sn2[e15] = null;
    }
    return sn2[e15];
  }
  function hn2(e15, t11) {
    var n11;
    return e15 && ((n11 = s10(t11) ? yn2(e15) : fn2(e15, t11)) ? an2 = n11 : "undefined" != typeof console && console.warn && console.warn("Locale " + e15 + " not found. Did you forget to load it?")), an2._abbr;
  }
  function fn2(e15, t11) {
    if (null !== t11) {
      var n11, r11 = on2;
      if (t11.abbr = e15, null != sn2[e15]) F10("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."), r11 = sn2[e15]._config;
      else if (null != t11.parentLocale) if (null != sn2[t11.parentLocale]) r11 = sn2[t11.parentLocale]._config;
      else {
        if (null == (n11 = mn2(t11.parentLocale))) return ln2[t11.parentLocale] || (ln2[t11.parentLocale] = []), ln2[t11.parentLocale].push({ name: e15, config: t11 }), null;
        r11 = n11._config;
      }
      return sn2[e15] = new N10(P10(r11, t11)), ln2[e15] && ln2[e15].forEach(function(e16) {
        fn2(e16.name, e16.config);
      }), hn2(e15), sn2[e15];
    }
    return delete sn2[e15], null;
  }
  function gn2(e15, t11) {
    if (null != t11) {
      var n11, r11, o11 = on2;
      null != sn2[e15] && null != sn2[e15].parentLocale ? sn2[e15].set(P10(sn2[e15]._config, t11)) : (null != (r11 = mn2(e15)) && (o11 = r11._config), t11 = P10(o11, t11), null == r11 && (t11.abbr = e15), (n11 = new N10(t11)).parentLocale = sn2[e15], sn2[e15] = n11), hn2(e15);
    } else null != sn2[e15] && (null != sn2[e15].parentLocale ? (sn2[e15] = sn2[e15].parentLocale, e15 === hn2() && hn2(e15)) : null != sn2[e15] && delete sn2[e15]);
    return sn2[e15];
  }
  function yn2(e15) {
    var t11;
    if (e15 && e15._locale && e15._locale._abbr && (e15 = e15._locale._abbr), !e15) return an2;
    if (!r10(e15)) {
      if (t11 = mn2(e15)) return t11;
      e15 = [e15];
    }
    return dn2(e15);
  }
  function vn2() {
    return D10(sn2);
  }
  function bn2(e15) {
    var t11, n11 = e15._a;
    return n11 && -2 === h10(e15).overflow && (t11 = n11[$e2] < 0 || n11[$e2] > 11 ? $e2 : n11[We2] < 1 || n11[We2] > Je2(n11[ze2], n11[$e2]) ? We2 : n11[je2] < 0 || n11[je2] > 24 || 24 === n11[je2] && (0 !== n11[Ze2] || 0 !== n11[Ge2] || 0 !== n11[Ue2]) ? je2 : n11[Ze2] < 0 || n11[Ze2] > 59 ? Ze2 : n11[Ge2] < 0 || n11[Ge2] > 59 ? Ge2 : n11[Ue2] < 0 || n11[Ue2] > 999 ? Ue2 : -1, h10(e15)._overflowDayOfYear && (t11 < ze2 || t11 > We2) && (t11 = We2), h10(e15)._overflowWeeks && -1 === t11 && (t11 = qe2), h10(e15)._overflowWeekday && -1 === t11 && (t11 = Ye2), h10(e15).overflow = t11), e15;
  }
  var Sn2 = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Cn2 = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, xn2 = /Z|[+-]\d\d(?::?\d\d)?/, wn2 = [["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/], ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/], ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/], ["GGGG-[W]WW", /\d{4}-W\d\d/, false], ["YYYY-DDD", /\d{4}-\d{3}/], ["YYYY-MM", /\d{4}-\d\d/, false], ["YYYYYYMMDD", /[+-]\d{10}/], ["YYYYMMDD", /\d{8}/], ["GGGG[W]WWE", /\d{4}W\d{3}/], ["GGGG[W]WW", /\d{4}W\d{2}/, false], ["YYYYDDD", /\d{7}/], ["YYYYMM", /\d{6}/, false], ["YYYY", /\d{4}/, false]], Tn2 = [["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/], ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/], ["HH:mm:ss", /\d\d:\d\d:\d\d/], ["HH:mm", /\d\d:\d\d/], ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/], ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/], ["HHmmss", /\d\d\d\d\d\d/], ["HHmm", /\d\d\d\d/], ["HH", /\d\d/]], En2 = /^\/?Date\((-?\d+)/i, Fn2 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, Mn2 = { UT: 0, GMT: 0, EDT: -240, EST: -300, CDT: -300, CST: -360, MDT: -360, MST: -420, PDT: -420, PST: -480 };
  function kn2(e15) {
    var t11, n11, r11, o11, a11, i11, s11 = e15._i, l11 = Sn2.exec(s11) || Cn2.exec(s11), c11 = wn2.length, u11 = Tn2.length;
    if (l11) {
      for (h10(e15).iso = true, t11 = 0, n11 = c11; t11 < n11; t11++) if (wn2[t11][1].exec(l11[1])) {
        o11 = wn2[t11][0], r11 = false !== wn2[t11][2];
        break;
      }
      if (null == o11) return void (e15._isValid = false);
      if (l11[3]) {
        for (t11 = 0, n11 = u11; t11 < n11; t11++) if (Tn2[t11][1].exec(l11[3])) {
          a11 = (l11[2] || " ") + Tn2[t11][0];
          break;
        }
        if (null == a11) return void (e15._isValid = false);
      }
      if (!r11 && null != a11) return void (e15._isValid = false);
      if (l11[4]) {
        if (!xn2.exec(l11[4])) return void (e15._isValid = false);
        i11 = "Z";
      }
      e15._f = o11 + (a11 || "") + (i11 || ""), Bn2(e15);
    } else e15._isValid = false;
  }
  function Pn2(e15, t11, n11, r11, o11, a11) {
    var i11 = [Nn2(e15), et2.indexOf(t11), parseInt(n11, 10), parseInt(r11, 10), parseInt(o11, 10)];
    return a11 && i11.push(parseInt(a11, 10)), i11;
  }
  function Nn2(e15) {
    var t11 = parseInt(e15, 10);
    return t11 <= 49 ? 2e3 + t11 : t11 <= 999 ? 1900 + t11 : t11;
  }
  function Dn2(e15) {
    return e15.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
  }
  function Ln2(e15, t11, n11) {
    return !e15 || Ht2.indexOf(e15) === new Date(t11[0], t11[1], t11[2]).getDay() || (h10(n11).weekdayMismatch = true, n11._isValid = false, false);
  }
  function Hn2(e15, t11, n11) {
    if (e15) return Mn2[e15];
    if (t11) return 0;
    var r11 = parseInt(n11, 10), o11 = r11 % 100;
    return (r11 - o11) / 100 * 60 + o11;
  }
  function In2(e15) {
    var t11, n11 = Fn2.exec(Dn2(e15._i));
    if (n11) {
      if (t11 = Pn2(n11[4], n11[3], n11[2], n11[5], n11[6], n11[7]), !Ln2(n11[1], t11, e15)) return;
      e15._a = t11, e15._tzm = Hn2(n11[8], n11[9], n11[10]), e15._d = vt2.apply(null, e15._a), e15._d.setUTCMinutes(e15._d.getUTCMinutes() - e15._tzm), h10(e15).rfc2822 = true;
    } else e15._isValid = false;
  }
  function _n2(e15) {
    var n11 = En2.exec(e15._i);
    null === n11 ? (kn2(e15), false === e15._isValid && (delete e15._isValid, In2(e15), false === e15._isValid && (delete e15._isValid, e15._strict ? e15._isValid = false : t10.createFromInputFallback(e15)))) : e15._d = /* @__PURE__ */ new Date(+n11[1]);
  }
  function Vn2(e15, t11, n11) {
    return null != e15 ? e15 : null != t11 ? t11 : n11;
  }
  function Rn2(e15) {
    var n11 = new Date(t10.now());
    return e15._useUTC ? [n11.getUTCFullYear(), n11.getUTCMonth(), n11.getUTCDate()] : [n11.getFullYear(), n11.getMonth(), n11.getDate()];
  }
  function An2(e15) {
    var t11, n11, r11, o11, a11, i11 = [];
    if (!e15._d) {
      for (r11 = Rn2(e15), e15._w && null == e15._a[We2] && null == e15._a[$e2] && On2(e15), null != e15._dayOfYear && (a11 = Vn2(e15._a[ze2], r11[ze2]), (e15._dayOfYear > ht2(a11) || 0 === e15._dayOfYear) && (h10(e15)._overflowDayOfYear = true), n11 = vt2(a11, 0, e15._dayOfYear), e15._a[$e2] = n11.getUTCMonth(), e15._a[We2] = n11.getUTCDate()), t11 = 0; t11 < 3 && null == e15._a[t11]; ++t11) e15._a[t11] = i11[t11] = r11[t11];
      for (; t11 < 7; t11++) e15._a[t11] = i11[t11] = null == e15._a[t11] ? 2 === t11 ? 1 : 0 : e15._a[t11];
      24 === e15._a[je2] && 0 === e15._a[Ze2] && 0 === e15._a[Ge2] && 0 === e15._a[Ue2] && (e15._nextDay = true, e15._a[je2] = 0), e15._d = (e15._useUTC ? vt2 : yt2).apply(null, i11), o11 = e15._useUTC ? e15._d.getUTCDay() : e15._d.getDay(), null != e15._tzm && e15._d.setUTCMinutes(e15._d.getUTCMinutes() - e15._tzm), e15._nextDay && (e15._a[je2] = 24), e15._w && void 0 !== e15._w.d && e15._w.d !== o11 && (h10(e15).weekdayMismatch = true);
    }
  }
  function On2(e15) {
    var t11, n11, r11, o11, a11, i11, s11, l11, c11;
    null != (t11 = e15._w).GG || null != t11.W || null != t11.E ? (a11 = 1, i11 = 4, n11 = Vn2(t11.GG, e15._a[ze2], Ct2(qn2(), 1, 4).year), r11 = Vn2(t11.W, 1), ((o11 = Vn2(t11.E, 1)) < 1 || o11 > 7) && (l11 = true)) : (a11 = e15._locale._week.dow, i11 = e15._locale._week.doy, c11 = Ct2(qn2(), a11, i11), n11 = Vn2(t11.gg, e15._a[ze2], c11.year), r11 = Vn2(t11.w, c11.week), null != t11.d ? ((o11 = t11.d) < 0 || o11 > 6) && (l11 = true) : null != t11.e ? (o11 = t11.e + a11, (t11.e < 0 || t11.e > 6) && (l11 = true)) : o11 = a11), r11 < 1 || r11 > xt2(n11, a11, i11) ? h10(e15)._overflowWeeks = true : null != l11 ? h10(e15)._overflowWeekday = true : (s11 = St2(n11, r11, o11, a11, i11), e15._a[ze2] = s11.year, e15._dayOfYear = s11.dayOfYear);
  }
  function Bn2(e15) {
    if (e15._f !== t10.ISO_8601) if (e15._f !== t10.RFC_2822) {
      e15._a = [], h10(e15).empty = true;
      var n11, r11, o11, a11, i11, s11, l11, c11 = "" + e15._i, u11 = c11.length, d11 = 0;
      for (l11 = (o11 = W10(e15._f, e15._locale).match(_10) || []).length, n11 = 0; n11 < l11; n11++) a11 = o11[n11], (r11 = (c11.match(Ie2(a11, e15)) || [])[0]) && ((i11 = c11.substr(0, c11.indexOf(r11))).length > 0 && h10(e15).unusedInput.push(i11), c11 = c11.slice(c11.indexOf(r11) + r11.length), d11 += r11.length), A10[a11] ? (r11 ? h10(e15).empty = false : h10(e15).unusedTokens.push(a11), Be2(a11, r11, e15)) : e15._strict && !r11 && h10(e15).unusedTokens.push(a11);
      h10(e15).charsLeftOver = u11 - d11, c11.length > 0 && h10(e15).unusedInput.push(c11), e15._a[je2] <= 12 && true === h10(e15).bigHour && e15._a[je2] > 0 && (h10(e15).bigHour = void 0), h10(e15).parsedDateParts = e15._a.slice(0), h10(e15).meridiem = e15._meridiem, e15._a[je2] = zn2(e15._locale, e15._a[je2], e15._meridiem), null !== (s11 = h10(e15).era) && (e15._a[ze2] = e15._locale.erasConvertYear(s11, e15._a[ze2])), An2(e15), bn2(e15);
    } else In2(e15);
    else kn2(e15);
  }
  function zn2(e15, t11, n11) {
    var r11;
    return null == n11 ? t11 : null != e15.meridiemHour ? e15.meridiemHour(t11, n11) : null != e15.isPM ? ((r11 = e15.isPM(n11)) && t11 < 12 && (t11 += 12), r11 || 12 !== t11 || (t11 = 0), t11) : t11;
  }
  function $n2(e15) {
    var t11, n11, r11, o11, a11, i11, s11 = false, l11 = e15._f.length;
    if (0 === l11) return h10(e15).invalidFormat = true, void (e15._d = /* @__PURE__ */ new Date(NaN));
    for (o11 = 0; o11 < l11; o11++) a11 = 0, i11 = false, t11 = S10({}, e15), null != e15._useUTC && (t11._useUTC = e15._useUTC), t11._f = e15._f[o11], Bn2(t11), g10(t11) && (i11 = true), a11 += h10(t11).charsLeftOver, a11 += 10 * h10(t11).unusedTokens.length, h10(t11).score = a11, s11 ? a11 < r11 && (r11 = a11, n11 = t11) : (null == r11 || a11 < r11 || i11) && (r11 = a11, n11 = t11, i11 && (s11 = true));
    d10(e15, n11 || t11);
  }
  function Wn2(e15) {
    if (!e15._d) {
      var t11 = re2(e15._i), n11 = void 0 === t11.day ? t11.date : t11.day;
      e15._a = u10([t11.year, t11.month, n11, t11.hour, t11.minute, t11.second, t11.millisecond], function(e16) {
        return e16 && parseInt(e16, 10);
      }), An2(e15);
    }
  }
  function jn2(e15) {
    var t11 = new C10(bn2(Zn2(e15)));
    return t11._nextDay && (t11.add(1, "d"), t11._nextDay = void 0), t11;
  }
  function Zn2(e15) {
    var t11 = e15._i, n11 = e15._f;
    return e15._locale = e15._locale || yn2(e15._l), null === t11 || void 0 === n11 && "" === t11 ? y10({ nullInput: true }) : ("string" == typeof t11 && (e15._i = t11 = e15._locale.preparse(t11)), x10(t11) ? new C10(bn2(t11)) : (c10(t11) ? e15._d = t11 : r10(n11) ? $n2(e15) : n11 ? Bn2(e15) : Gn2(e15), g10(e15) || (e15._d = null), e15));
  }
  function Gn2(e15) {
    var n11 = e15._i;
    s10(n11) ? e15._d = new Date(t10.now()) : c10(n11) ? e15._d = new Date(n11.valueOf()) : "string" == typeof n11 ? _n2(e15) : r10(n11) ? (e15._a = u10(n11.slice(0), function(e16) {
      return parseInt(e16, 10);
    }), An2(e15)) : o10(n11) ? Wn2(e15) : l10(n11) ? e15._d = new Date(n11) : t10.createFromInputFallback(e15);
  }
  function Un2(e15, t11, n11, a11, s11) {
    var l11 = {};
    return true !== t11 && false !== t11 || (a11 = t11, t11 = void 0), true !== n11 && false !== n11 || (a11 = n11, n11 = void 0), (o10(e15) && i10(e15) || r10(e15) && 0 === e15.length) && (e15 = void 0), l11._isAMomentObject = true, l11._useUTC = l11._isUTC = s11, l11._l = n11, l11._i = e15, l11._f = t11, l11._strict = a11, jn2(l11);
  }
  function qn2(e15, t11, n11, r11) {
    return Un2(e15, t11, n11, r11, false);
  }
  t10.createFromInputFallback = T10("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(e15) {
    e15._d = /* @__PURE__ */ new Date(e15._i + (e15._useUTC ? " UTC" : ""));
  }), t10.ISO_8601 = function() {
  }, t10.RFC_2822 = function() {
  };
  var Yn2 = T10("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
    var e15 = qn2.apply(null, arguments);
    return this.isValid() && e15.isValid() ? e15 < this ? this : e15 : y10();
  }), Kn2 = T10("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
    var e15 = qn2.apply(null, arguments);
    return this.isValid() && e15.isValid() ? e15 > this ? this : e15 : y10();
  });
  function Xn2(e15, t11) {
    var n11, o11;
    if (1 === t11.length && r10(t11[0]) && (t11 = t11[0]), !t11.length) return qn2();
    for (n11 = t11[0], o11 = 1; o11 < t11.length; ++o11) t11[o11].isValid() && !t11[o11][e15](n11) || (n11 = t11[o11]);
    return n11;
  }
  function Jn2() {
    return Xn2("isBefore", [].slice.call(arguments, 0));
  }
  function Qn2() {
    return Xn2("isAfter", [].slice.call(arguments, 0));
  }
  var er2 = function() {
    return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
  };
  var tr2 = ["year", "quarter", "month", "week", "day", "hour", "minute", "second", "millisecond"];
  function nr2(e15) {
    var t11, n11, r11 = false, o11 = tr2.length;
    for (t11 in e15) if (a10(e15, t11) && (-1 === Xe2.call(tr2, t11) || null != e15[t11] && isNaN(e15[t11]))) return false;
    for (n11 = 0; n11 < o11; ++n11) if (e15[tr2[n11]]) {
      if (r11) return false;
      parseFloat(e15[tr2[n11]]) !== ce2(e15[tr2[n11]]) && (r11 = true);
    }
    return true;
  }
  function rr2() {
    return this._isValid;
  }
  function or2() {
    return Mr2(NaN);
  }
  function ar2(e15) {
    var t11 = re2(e15), n11 = t11.year || 0, r11 = t11.quarter || 0, o11 = t11.month || 0, a11 = t11.week || t11.isoWeek || 0, i11 = t11.day || 0, s11 = t11.hour || 0, l11 = t11.minute || 0, c11 = t11.second || 0, u11 = t11.millisecond || 0;
    this._isValid = nr2(t11), this._milliseconds = +u11 + 1e3 * c11 + 6e4 * l11 + 1e3 * s11 * 60 * 60, this._days = +i11 + 7 * a11, this._months = +o11 + 3 * r11 + 12 * n11, this._data = {}, this._locale = yn2(), this._bubble();
  }
  function ir2(e15) {
    return e15 instanceof ar2;
  }
  function sr2(e15) {
    return e15 < 0 ? -1 * Math.round(-1 * e15) : Math.round(e15);
  }
  function lr2(e15, t11, n11) {
    var r11, o11 = Math.min(e15.length, t11.length), a11 = Math.abs(e15.length - t11.length), i11 = 0;
    for (r11 = 0; r11 < o11; r11++) (n11 && e15[r11] !== t11[r11] || !n11 && ce2(e15[r11]) !== ce2(t11[r11])) && i11++;
    return i11 + a11;
  }
  function cr2(e15, t11) {
    O10(e15, 0, 0, function() {
      var e16 = this.utcOffset(), n11 = "+";
      return e16 < 0 && (e16 = -e16, n11 = "-"), n11 + I10(~~(e16 / 60), 2) + t11 + I10(~~e16 % 60, 2);
    });
  }
  cr2("Z", ":"), cr2("ZZ", ""), He2("Z", Ne2), He2("ZZ", Ne2), Ae2(["Z", "ZZ"], function(e15, t11, n11) {
    n11._useUTC = true, n11._tzm = dr2(Ne2, e15);
  });
  var ur2 = /([\+\-]|\d\d)/gi;
  function dr2(e15, t11) {
    var n11, r11, o11 = (t11 || "").match(e15);
    return null === o11 ? null : 0 === (r11 = 60 * (n11 = ((o11[o11.length - 1] || []) + "").match(ur2) || ["-", 0, 0])[1] + ce2(n11[2])) ? 0 : "+" === n11[0] ? r11 : -r11;
  }
  function pr2(e15, n11) {
    var r11, o11;
    return n11._isUTC ? (r11 = n11.clone(), o11 = (x10(e15) || c10(e15) ? e15.valueOf() : qn2(e15).valueOf()) - r11.valueOf(), r11._d.setTime(r11._d.valueOf() + o11), t10.updateOffset(r11, false), r11) : qn2(e15).local();
  }
  function mr2(e15) {
    return -Math.round(e15._d.getTimezoneOffset());
  }
  function hr2(e15, n11, r11) {
    var o11, a11 = this._offset || 0;
    if (!this.isValid()) return null != e15 ? this : NaN;
    if (null != e15) {
      if ("string" == typeof e15) {
        if (null === (e15 = dr2(Ne2, e15))) return this;
      } else Math.abs(e15) < 16 && !r11 && (e15 *= 60);
      return !this._isUTC && n11 && (o11 = mr2(this)), this._offset = e15, this._isUTC = true, null != o11 && this.add(o11, "m"), a11 !== e15 && (!n11 || this._changeInProgress ? Lr2(this, Mr2(e15 - a11, "m"), 1, false) : this._changeInProgress || (this._changeInProgress = true, t10.updateOffset(this, true), this._changeInProgress = null)), this;
    }
    return this._isUTC ? a11 : mr2(this);
  }
  function fr2(e15, t11) {
    return null != e15 ? ("string" != typeof e15 && (e15 = -e15), this.utcOffset(e15, t11), this) : -this.utcOffset();
  }
  function gr2(e15) {
    return this.utcOffset(0, e15);
  }
  function yr2(e15) {
    return this._isUTC && (this.utcOffset(0, e15), this._isUTC = false, e15 && this.subtract(mr2(this), "m")), this;
  }
  function vr2() {
    if (null != this._tzm) this.utcOffset(this._tzm, false, true);
    else if ("string" == typeof this._i) {
      var e15 = dr2(Pe2, this._i);
      null != e15 ? this.utcOffset(e15) : this.utcOffset(0, true);
    }
    return this;
  }
  function br2(e15) {
    return !!this.isValid() && (e15 = e15 ? qn2(e15).utcOffset() : 0, (this.utcOffset() - e15) % 60 == 0);
  }
  function Sr2() {
    return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
  }
  function Cr2() {
    if (!s10(this._isDSTShifted)) return this._isDSTShifted;
    var e15, t11 = {};
    return S10(t11, this), (t11 = Zn2(t11))._a ? (e15 = t11._isUTC ? p10(t11._a) : qn2(t11._a), this._isDSTShifted = this.isValid() && lr2(t11._a, e15.toArray()) > 0) : this._isDSTShifted = false, this._isDSTShifted;
  }
  function xr2() {
    return !!this.isValid() && !this._isUTC;
  }
  function wr2() {
    return !!this.isValid() && this._isUTC;
  }
  function Tr2() {
    return !!this.isValid() && this._isUTC && 0 === this._offset;
  }
  t10.updateOffset = function() {
  };
  var Er2 = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, Fr2 = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
  function Mr2(e15, t11) {
    var n11, r11, o11, i11 = e15, s11 = null;
    return ir2(e15) ? i11 = { ms: e15._milliseconds, d: e15._days, M: e15._months } : l10(e15) || !isNaN(+e15) ? (i11 = {}, t11 ? i11[t11] = +e15 : i11.milliseconds = +e15) : (s11 = Er2.exec(e15)) ? (n11 = "-" === s11[1] ? -1 : 1, i11 = { y: 0, d: ce2(s11[We2]) * n11, h: ce2(s11[je2]) * n11, m: ce2(s11[Ze2]) * n11, s: ce2(s11[Ge2]) * n11, ms: ce2(sr2(1e3 * s11[Ue2])) * n11 }) : (s11 = Fr2.exec(e15)) ? (n11 = "-" === s11[1] ? -1 : 1, i11 = { y: kr2(s11[2], n11), M: kr2(s11[3], n11), w: kr2(s11[4], n11), d: kr2(s11[5], n11), h: kr2(s11[6], n11), m: kr2(s11[7], n11), s: kr2(s11[8], n11) }) : null == i11 ? i11 = {} : "object" == typeof i11 && ("from" in i11 || "to" in i11) && (o11 = Nr2(qn2(i11.from), qn2(i11.to)), (i11 = {}).ms = o11.milliseconds, i11.M = o11.months), r11 = new ar2(i11), ir2(e15) && a10(e15, "_locale") && (r11._locale = e15._locale), ir2(e15) && a10(e15, "_isValid") && (r11._isValid = e15._isValid), r11;
  }
  function kr2(e15, t11) {
    var n11 = e15 && parseFloat(e15.replace(",", "."));
    return (isNaN(n11) ? 0 : n11) * t11;
  }
  function Pr2(e15, t11) {
    var n11 = {};
    return n11.months = t11.month() - e15.month() + 12 * (t11.year() - e15.year()), e15.clone().add(n11.months, "M").isAfter(t11) && --n11.months, n11.milliseconds = +t11 - +e15.clone().add(n11.months, "M"), n11;
  }
  function Nr2(e15, t11) {
    var n11;
    return e15.isValid() && t11.isValid() ? (t11 = pr2(t11, e15), e15.isBefore(t11) ? n11 = Pr2(e15, t11) : ((n11 = Pr2(t11, e15)).milliseconds = -n11.milliseconds, n11.months = -n11.months), n11) : { milliseconds: 0, months: 0 };
  }
  function Dr2(e15, t11) {
    return function(n11, r11) {
      var o11;
      return null === r11 || isNaN(+r11) || (F10(t11, "moment()." + t11 + "(period, number) is deprecated. Please use moment()." + t11 + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."), o11 = n11, n11 = r11, r11 = o11), Lr2(this, Mr2(n11, r11), e15), this;
    };
  }
  function Lr2(e15, n11, r11, o11) {
    var a11 = n11._milliseconds, i11 = sr2(n11._days), s11 = sr2(n11._months);
    e15.isValid() && (o11 = null == o11 || o11, s11 && lt2(e15, de2(e15, "Month") + s11 * r11), i11 && pe2(e15, "Date", de2(e15, "Date") + i11 * r11), a11 && e15._d.setTime(e15._d.valueOf() + a11 * r11), o11 && t10.updateOffset(e15, i11 || s11));
  }
  Mr2.fn = ar2.prototype, Mr2.invalid = or2;
  var Hr2 = Dr2(1, "add"), Ir2 = Dr2(-1, "subtract");
  function _r2(e15) {
    return "string" == typeof e15 || e15 instanceof String;
  }
  function Vr2(e15) {
    return x10(e15) || c10(e15) || _r2(e15) || l10(e15) || Ar2(e15) || Rr2(e15) || null == e15;
  }
  function Rr2(e15) {
    var t11, n11, r11 = o10(e15) && !i10(e15), s11 = false, l11 = ["years", "year", "y", "months", "month", "M", "days", "day", "d", "dates", "date", "D", "hours", "hour", "h", "minutes", "minute", "m", "seconds", "second", "s", "milliseconds", "millisecond", "ms"], c11 = l11.length;
    for (t11 = 0; t11 < c11; t11 += 1) n11 = l11[t11], s11 = s11 || a10(e15, n11);
    return r11 && s11;
  }
  function Ar2(e15) {
    var t11 = r10(e15), n11 = false;
    return t11 && (n11 = 0 === e15.filter(function(t12) {
      return !l10(t12) && _r2(e15);
    }).length), t11 && n11;
  }
  function Or2(e15) {
    var t11, n11, r11 = o10(e15) && !i10(e15), s11 = false, l11 = ["sameDay", "nextDay", "lastDay", "nextWeek", "lastWeek", "sameElse"];
    for (t11 = 0; t11 < l11.length; t11 += 1) n11 = l11[t11], s11 = s11 || a10(e15, n11);
    return r11 && s11;
  }
  function Br2(e15, t11) {
    var n11 = e15.diff(t11, "days", true);
    return n11 < -6 ? "sameElse" : n11 < -1 ? "lastWeek" : n11 < 0 ? "lastDay" : n11 < 1 ? "sameDay" : n11 < 2 ? "nextDay" : n11 < 7 ? "nextWeek" : "sameElse";
  }
  function zr2(e15, n11) {
    1 === arguments.length && (arguments[0] ? Vr2(arguments[0]) ? (e15 = arguments[0], n11 = void 0) : Or2(arguments[0]) && (n11 = arguments[0], e15 = void 0) : (e15 = void 0, n11 = void 0));
    var r11 = e15 || qn2(), o11 = pr2(r11, this).startOf("day"), a11 = t10.calendarFormat(this, o11) || "sameElse", i11 = n11 && (M10(n11[a11]) ? n11[a11].call(this, r11) : n11[a11]);
    return this.format(i11 || this.localeData().calendar(a11, this, qn2(r11)));
  }
  function $r2() {
    return new C10(this);
  }
  function Wr2(e15, t11) {
    var n11 = x10(e15) ? e15 : qn2(e15);
    return !(!this.isValid() || !n11.isValid()) && ("millisecond" === (t11 = ne2(t11) || "millisecond") ? this.valueOf() > n11.valueOf() : n11.valueOf() < this.clone().startOf(t11).valueOf());
  }
  function jr2(e15, t11) {
    var n11 = x10(e15) ? e15 : qn2(e15);
    return !(!this.isValid() || !n11.isValid()) && ("millisecond" === (t11 = ne2(t11) || "millisecond") ? this.valueOf() < n11.valueOf() : this.clone().endOf(t11).valueOf() < n11.valueOf());
  }
  function Zr2(e15, t11, n11, r11) {
    var o11 = x10(e15) ? e15 : qn2(e15), a11 = x10(t11) ? t11 : qn2(t11);
    return !!(this.isValid() && o11.isValid() && a11.isValid()) && ("(" === (r11 = r11 || "()")[0] ? this.isAfter(o11, n11) : !this.isBefore(o11, n11)) && (")" === r11[1] ? this.isBefore(a11, n11) : !this.isAfter(a11, n11));
  }
  function Gr2(e15, t11) {
    var n11, r11 = x10(e15) ? e15 : qn2(e15);
    return !(!this.isValid() || !r11.isValid()) && ("millisecond" === (t11 = ne2(t11) || "millisecond") ? this.valueOf() === r11.valueOf() : (n11 = r11.valueOf(), this.clone().startOf(t11).valueOf() <= n11 && n11 <= this.clone().endOf(t11).valueOf()));
  }
  function Ur2(e15, t11) {
    return this.isSame(e15, t11) || this.isAfter(e15, t11);
  }
  function qr2(e15, t11) {
    return this.isSame(e15, t11) || this.isBefore(e15, t11);
  }
  function Yr2(e15, t11, n11) {
    var r11, o11, a11;
    if (!this.isValid()) return NaN;
    if (!(r11 = pr2(e15, this)).isValid()) return NaN;
    switch (o11 = 6e4 * (r11.utcOffset() - this.utcOffset()), t11 = ne2(t11)) {
      case "year":
        a11 = Kr2(this, r11) / 12;
        break;
      case "month":
        a11 = Kr2(this, r11);
        break;
      case "quarter":
        a11 = Kr2(this, r11) / 3;
        break;
      case "second":
        a11 = (this - r11) / 1e3;
        break;
      case "minute":
        a11 = (this - r11) / 6e4;
        break;
      case "hour":
        a11 = (this - r11) / 36e5;
        break;
      case "day":
        a11 = (this - r11 - o11) / 864e5;
        break;
      case "week":
        a11 = (this - r11 - o11) / 6048e5;
        break;
      default:
        a11 = this - r11;
    }
    return n11 ? a11 : le2(a11);
  }
  function Kr2(e15, t11) {
    if (e15.date() < t11.date()) return -Kr2(t11, e15);
    var n11 = 12 * (t11.year() - e15.year()) + (t11.month() - e15.month()), r11 = e15.clone().add(n11, "months");
    return -(n11 + (t11 - r11 < 0 ? (t11 - r11) / (r11 - e15.clone().add(n11 - 1, "months")) : (t11 - r11) / (e15.clone().add(n11 + 1, "months") - r11))) || 0;
  }
  function Xr2() {
    return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
  }
  function Jr2(e15) {
    if (!this.isValid()) return null;
    var t11 = true !== e15, n11 = t11 ? this.clone().utc() : this;
    return n11.year() < 0 || n11.year() > 9999 ? $10(n11, t11 ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ") : M10(Date.prototype.toISOString) ? t11 ? this.toDate().toISOString() : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3).toISOString().replace("Z", $10(n11, "Z")) : $10(n11, t11 ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
  }
  function Qr2() {
    if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
    var e15, t11, n11, r11, o11 = "moment", a11 = "";
    return this.isLocal() || (o11 = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone", a11 = "Z"), e15 = "[" + o11 + '("]', t11 = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", n11 = "-MM-DD[T]HH:mm:ss.SSS", r11 = a11 + '[")]', this.format(e15 + t11 + n11 + r11);
  }
  function eo2(e15) {
    e15 || (e15 = this.isUtc() ? t10.defaultFormatUtc : t10.defaultFormat);
    var n11 = $10(this, e15);
    return this.localeData().postformat(n11);
  }
  function to2(e15, t11) {
    return this.isValid() && (x10(e15) && e15.isValid() || qn2(e15).isValid()) ? Mr2({ to: this, from: e15 }).locale(this.locale()).humanize(!t11) : this.localeData().invalidDate();
  }
  function no2(e15) {
    return this.from(qn2(), e15);
  }
  function ro2(e15, t11) {
    return this.isValid() && (x10(e15) && e15.isValid() || qn2(e15).isValid()) ? Mr2({ from: this, to: e15 }).locale(this.locale()).humanize(!t11) : this.localeData().invalidDate();
  }
  function oo2(e15) {
    return this.to(qn2(), e15);
  }
  function ao2(e15) {
    var t11;
    return void 0 === e15 ? this._locale._abbr : (null != (t11 = yn2(e15)) && (this._locale = t11), this);
  }
  t10.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", t10.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
  var io2 = T10("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(e15) {
    return void 0 === e15 ? this.localeData() : this.locale(e15);
  });
  function so2() {
    return this._locale;
  }
  var lo2 = 1e3, co2 = 60 * lo2, uo2 = 60 * co2, po2 = 3506328 * uo2;
  function mo2(e15, t11) {
    return (e15 % t11 + t11) % t11;
  }
  function ho2(e15, t11, n11) {
    return e15 < 100 && e15 >= 0 ? new Date(e15 + 400, t11, n11) - po2 : new Date(e15, t11, n11).valueOf();
  }
  function fo2(e15, t11, n11) {
    return e15 < 100 && e15 >= 0 ? Date.UTC(e15 + 400, t11, n11) - po2 : Date.UTC(e15, t11, n11);
  }
  function go2(e15) {
    var n11, r11;
    if (void 0 === (e15 = ne2(e15)) || "millisecond" === e15 || !this.isValid()) return this;
    switch (r11 = this._isUTC ? fo2 : ho2, e15) {
      case "year":
        n11 = r11(this.year(), 0, 1);
        break;
      case "quarter":
        n11 = r11(this.year(), this.month() - this.month() % 3, 1);
        break;
      case "month":
        n11 = r11(this.year(), this.month(), 1);
        break;
      case "week":
        n11 = r11(this.year(), this.month(), this.date() - this.weekday());
        break;
      case "isoWeek":
        n11 = r11(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
        break;
      case "day":
      case "date":
        n11 = r11(this.year(), this.month(), this.date());
        break;
      case "hour":
        n11 = this._d.valueOf(), n11 -= mo2(n11 + (this._isUTC ? 0 : this.utcOffset() * co2), uo2);
        break;
      case "minute":
        n11 = this._d.valueOf(), n11 -= mo2(n11, co2);
        break;
      case "second":
        n11 = this._d.valueOf(), n11 -= mo2(n11, lo2);
    }
    return this._d.setTime(n11), t10.updateOffset(this, true), this;
  }
  function yo2(e15) {
    var n11, r11;
    if (void 0 === (e15 = ne2(e15)) || "millisecond" === e15 || !this.isValid()) return this;
    switch (r11 = this._isUTC ? fo2 : ho2, e15) {
      case "year":
        n11 = r11(this.year() + 1, 0, 1) - 1;
        break;
      case "quarter":
        n11 = r11(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
        break;
      case "month":
        n11 = r11(this.year(), this.month() + 1, 1) - 1;
        break;
      case "week":
        n11 = r11(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
        break;
      case "isoWeek":
        n11 = r11(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
        break;
      case "day":
      case "date":
        n11 = r11(this.year(), this.month(), this.date() + 1) - 1;
        break;
      case "hour":
        n11 = this._d.valueOf(), n11 += uo2 - mo2(n11 + (this._isUTC ? 0 : this.utcOffset() * co2), uo2) - 1;
        break;
      case "minute":
        n11 = this._d.valueOf(), n11 += co2 - mo2(n11, co2) - 1;
        break;
      case "second":
        n11 = this._d.valueOf(), n11 += lo2 - mo2(n11, lo2) - 1;
    }
    return this._d.setTime(n11), t10.updateOffset(this, true), this;
  }
  function vo2() {
    return this._d.valueOf() - 6e4 * (this._offset || 0);
  }
  function bo2() {
    return Math.floor(this.valueOf() / 1e3);
  }
  function So2() {
    return new Date(this.valueOf());
  }
  function Co2() {
    var e15 = this;
    return [e15.year(), e15.month(), e15.date(), e15.hour(), e15.minute(), e15.second(), e15.millisecond()];
  }
  function xo2() {
    var e15 = this;
    return { years: e15.year(), months: e15.month(), date: e15.date(), hours: e15.hours(), minutes: e15.minutes(), seconds: e15.seconds(), milliseconds: e15.milliseconds() };
  }
  function wo2() {
    return this.isValid() ? this.toISOString() : null;
  }
  function To2() {
    return g10(this);
  }
  function Eo2() {
    return d10({}, h10(this));
  }
  function Fo2() {
    return h10(this).overflow;
  }
  function Mo2() {
    return { input: this._i, format: this._f, locale: this._locale, isUTC: this._isUTC, strict: this._strict };
  }
  function ko2(e15, n11) {
    var r11, o11, a11, i11 = this._eras || yn2("en")._eras;
    for (r11 = 0, o11 = i11.length; r11 < o11; ++r11) switch ("string" == typeof i11[r11].since && (a11 = t10(i11[r11].since).startOf("day"), i11[r11].since = a11.valueOf()), typeof i11[r11].until) {
      case "undefined":
        i11[r11].until = 1 / 0;
        break;
      case "string":
        a11 = t10(i11[r11].until).startOf("day").valueOf(), i11[r11].until = a11.valueOf();
    }
    return i11;
  }
  function Po2(e15, t11, n11) {
    var r11, o11, a11, i11, s11, l11 = this.eras();
    for (e15 = e15.toUpperCase(), r11 = 0, o11 = l11.length; r11 < o11; ++r11) if (a11 = l11[r11].name.toUpperCase(), i11 = l11[r11].abbr.toUpperCase(), s11 = l11[r11].narrow.toUpperCase(), n11) switch (t11) {
      case "N":
      case "NN":
      case "NNN":
        if (i11 === e15) return l11[r11];
        break;
      case "NNNN":
        if (a11 === e15) return l11[r11];
        break;
      case "NNNNN":
        if (s11 === e15) return l11[r11];
    }
    else if ([a11, i11, s11].indexOf(e15) >= 0) return l11[r11];
  }
  function No2(e15, n11) {
    var r11 = e15.since <= e15.until ? 1 : -1;
    return void 0 === n11 ? t10(e15.since).year() : t10(e15.since).year() + (n11 - e15.offset) * r11;
  }
  function Do2() {
    var e15, t11, n11, r11 = this.localeData().eras();
    for (e15 = 0, t11 = r11.length; e15 < t11; ++e15) {
      if (n11 = this.clone().startOf("day").valueOf(), r11[e15].since <= n11 && n11 <= r11[e15].until) return r11[e15].name;
      if (r11[e15].until <= n11 && n11 <= r11[e15].since) return r11[e15].name;
    }
    return "";
  }
  function Lo2() {
    var e15, t11, n11, r11 = this.localeData().eras();
    for (e15 = 0, t11 = r11.length; e15 < t11; ++e15) {
      if (n11 = this.clone().startOf("day").valueOf(), r11[e15].since <= n11 && n11 <= r11[e15].until) return r11[e15].narrow;
      if (r11[e15].until <= n11 && n11 <= r11[e15].since) return r11[e15].narrow;
    }
    return "";
  }
  function Ho2() {
    var e15, t11, n11, r11 = this.localeData().eras();
    for (e15 = 0, t11 = r11.length; e15 < t11; ++e15) {
      if (n11 = this.clone().startOf("day").valueOf(), r11[e15].since <= n11 && n11 <= r11[e15].until) return r11[e15].abbr;
      if (r11[e15].until <= n11 && n11 <= r11[e15].since) return r11[e15].abbr;
    }
    return "";
  }
  function Io2() {
    var e15, n11, r11, o11, a11 = this.localeData().eras();
    for (e15 = 0, n11 = a11.length; e15 < n11; ++e15) if (r11 = a11[e15].since <= a11[e15].until ? 1 : -1, o11 = this.clone().startOf("day").valueOf(), a11[e15].since <= o11 && o11 <= a11[e15].until || a11[e15].until <= o11 && o11 <= a11[e15].since) return (this.year() - t10(a11[e15].since).year()) * r11 + a11[e15].offset;
    return this.year();
  }
  function _o3(e15) {
    return a10(this, "_erasNameRegex") || $o2.call(this), e15 ? this._erasNameRegex : this._erasRegex;
  }
  function Vo2(e15) {
    return a10(this, "_erasAbbrRegex") || $o2.call(this), e15 ? this._erasAbbrRegex : this._erasRegex;
  }
  function Ro2(e15) {
    return a10(this, "_erasNarrowRegex") || $o2.call(this), e15 ? this._erasNarrowRegex : this._erasRegex;
  }
  function Ao2(e15, t11) {
    return t11.erasAbbrRegex(e15);
  }
  function Oo2(e15, t11) {
    return t11.erasNameRegex(e15);
  }
  function Bo2(e15, t11) {
    return t11.erasNarrowRegex(e15);
  }
  function zo2(e15, t11) {
    return t11._eraYearOrdinalRegex || Me2;
  }
  function $o2() {
    var e15, t11, n11 = [], r11 = [], o11 = [], a11 = [], i11 = this.eras();
    for (e15 = 0, t11 = i11.length; e15 < t11; ++e15) r11.push(Ve2(i11[e15].name)), n11.push(Ve2(i11[e15].abbr)), o11.push(Ve2(i11[e15].narrow)), a11.push(Ve2(i11[e15].name)), a11.push(Ve2(i11[e15].abbr)), a11.push(Ve2(i11[e15].narrow));
    this._erasRegex = new RegExp("^(" + a11.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + r11.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + n11.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp("^(" + o11.join("|") + ")", "i");
  }
  function Wo2(e15, t11) {
    O10(0, [e15, e15.length], 0, t11);
  }
  function jo2(e15) {
    return Ko2.call(this, e15, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
  }
  function Zo2(e15) {
    return Ko2.call(this, e15, this.isoWeek(), this.isoWeekday(), 1, 4);
  }
  function Go2() {
    return xt2(this.year(), 1, 4);
  }
  function Uo2() {
    return xt2(this.isoWeekYear(), 1, 4);
  }
  function qo2() {
    var e15 = this.localeData()._week;
    return xt2(this.year(), e15.dow, e15.doy);
  }
  function Yo2() {
    var e15 = this.localeData()._week;
    return xt2(this.weekYear(), e15.dow, e15.doy);
  }
  function Ko2(e15, t11, n11, r11, o11) {
    var a11;
    return null == e15 ? Ct2(this, r11, o11).year : (t11 > (a11 = xt2(e15, r11, o11)) && (t11 = a11), Xo2.call(this, e15, t11, n11, r11, o11));
  }
  function Xo2(e15, t11, n11, r11, o11) {
    var a11 = St2(e15, t11, n11, r11, o11), i11 = vt2(a11.year, 0, a11.dayOfYear);
    return this.year(i11.getUTCFullYear()), this.month(i11.getUTCMonth()), this.date(i11.getUTCDate()), this;
  }
  function Jo2(e15) {
    return null == e15 ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (e15 - 1) + this.month() % 3);
  }
  O10("N", 0, 0, "eraAbbr"), O10("NN", 0, 0, "eraAbbr"), O10("NNN", 0, 0, "eraAbbr"), O10("NNNN", 0, 0, "eraName"), O10("NNNNN", 0, 0, "eraNarrow"), O10("y", ["y", 1], "yo", "eraYear"), O10("y", ["yy", 2], 0, "eraYear"), O10("y", ["yyy", 3], 0, "eraYear"), O10("y", ["yyyy", 4], 0, "eraYear"), He2("N", Ao2), He2("NN", Ao2), He2("NNN", Ao2), He2("NNNN", Oo2), He2("NNNNN", Bo2), Ae2(["N", "NN", "NNN", "NNNN", "NNNNN"], function(e15, t11, n11, r11) {
    var o11 = n11._locale.erasParse(e15, r11, n11._strict);
    o11 ? h10(n11).era = o11 : h10(n11).invalidEra = e15;
  }), He2("y", Me2), He2("yy", Me2), He2("yyy", Me2), He2("yyyy", Me2), He2("yo", zo2), Ae2(["y", "yy", "yyy", "yyyy"], ze2), Ae2(["yo"], function(e15, t11, n11, r11) {
    var o11;
    n11._locale._eraYearOrdinalRegex && (o11 = e15.match(n11._locale._eraYearOrdinalRegex)), n11._locale.eraYearOrdinalParse ? t11[ze2] = n11._locale.eraYearOrdinalParse(e15, o11) : t11[ze2] = parseInt(e15, 10);
  }), O10(0, ["gg", 2], 0, function() {
    return this.weekYear() % 100;
  }), O10(0, ["GG", 2], 0, function() {
    return this.isoWeekYear() % 100;
  }), Wo2("gggg", "weekYear"), Wo2("ggggg", "weekYear"), Wo2("GGGG", "isoWeekYear"), Wo2("GGGGG", "isoWeekYear"), te2("weekYear", "gg"), te2("isoWeekYear", "GG"), ae2("weekYear", 1), ae2("isoWeekYear", 1), He2("G", ke2), He2("g", ke2), He2("GG", Ce2, ye2), He2("gg", Ce2, ye2), He2("GGGG", Ee2, be2), He2("gggg", Ee2, be2), He2("GGGGG", Fe2, Se2), He2("ggggg", Fe2, Se2), Oe2(["gggg", "ggggg", "GGGG", "GGGGG"], function(e15, t11, n11, r11) {
    t11[r11.substr(0, 2)] = ce2(e15);
  }), Oe2(["gg", "GG"], function(e15, n11, r11, o11) {
    n11[o11] = t10.parseTwoDigitYear(e15);
  }), O10("Q", 0, "Qo", "quarter"), te2("quarter", "Q"), ae2("quarter", 7), He2("Q", ge2), Ae2("Q", function(e15, t11) {
    t11[$e2] = 3 * (ce2(e15) - 1);
  }), O10("D", ["DD", 2], "Do", "date"), te2("date", "D"), ae2("date", 9), He2("D", Ce2), He2("DD", Ce2, ye2), He2("Do", function(e15, t11) {
    return e15 ? t11._dayOfMonthOrdinalParse || t11._ordinalParse : t11._dayOfMonthOrdinalParseLenient;
  }), Ae2(["D", "DD"], We2), Ae2("Do", function(e15, t11) {
    t11[We2] = ce2(e15.match(Ce2)[0]);
  });
  var Qo2 = ue2("Date", true);
  function ea2(e15) {
    var t11 = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
    return null == e15 ? t11 : this.add(e15 - t11, "d");
  }
  O10("DDD", ["DDDD", 3], "DDDo", "dayOfYear"), te2("dayOfYear", "DDD"), ae2("dayOfYear", 4), He2("DDD", Te2), He2("DDDD", ve2), Ae2(["DDD", "DDDD"], function(e15, t11, n11) {
    n11._dayOfYear = ce2(e15);
  }), O10("m", ["mm", 2], 0, "minute"), te2("minute", "m"), ae2("minute", 14), He2("m", Ce2), He2("mm", Ce2, ye2), Ae2(["m", "mm"], Ze2);
  var ta2 = ue2("Minutes", false);
  O10("s", ["ss", 2], 0, "second"), te2("second", "s"), ae2("second", 15), He2("s", Ce2), He2("ss", Ce2, ye2), Ae2(["s", "ss"], Ge2);
  var na2 = ue2("Seconds", false);
  var ra2, oa2;
  for (O10("S", 0, 0, function() {
    return ~~(this.millisecond() / 100);
  }), O10(0, ["SS", 2], 0, function() {
    return ~~(this.millisecond() / 10);
  }), O10(0, ["SSS", 3], 0, "millisecond"), O10(0, ["SSSS", 4], 0, function() {
    return 10 * this.millisecond();
  }), O10(0, ["SSSSS", 5], 0, function() {
    return 100 * this.millisecond();
  }), O10(0, ["SSSSSS", 6], 0, function() {
    return 1e3 * this.millisecond();
  }), O10(0, ["SSSSSSS", 7], 0, function() {
    return 1e4 * this.millisecond();
  }), O10(0, ["SSSSSSSS", 8], 0, function() {
    return 1e5 * this.millisecond();
  }), O10(0, ["SSSSSSSSS", 9], 0, function() {
    return 1e6 * this.millisecond();
  }), te2("millisecond", "ms"), ae2("millisecond", 16), He2("S", Te2, ge2), He2("SS", Te2, ye2), He2("SSS", Te2, ve2), ra2 = "SSSS"; ra2.length <= 9; ra2 += "S") He2(ra2, Me2);
  function aa2(e15, t11) {
    t11[Ue2] = ce2(1e3 * ("0." + e15));
  }
  for (ra2 = "S"; ra2.length <= 9; ra2 += "S") Ae2(ra2, aa2);
  function ia2() {
    return this._isUTC ? "UTC" : "";
  }
  function sa2() {
    return this._isUTC ? "Coordinated Universal Time" : "";
  }
  oa2 = ue2("Milliseconds", false), O10("z", 0, 0, "zoneAbbr"), O10("zz", 0, 0, "zoneName");
  var la2 = C10.prototype;
  function ca2(e15) {
    return qn2(1e3 * e15);
  }
  function ua2() {
    return qn2.apply(null, arguments).parseZone();
  }
  function da2(e15) {
    return e15;
  }
  la2.add = Hr2, la2.calendar = zr2, la2.clone = $r2, la2.diff = Yr2, la2.endOf = yo2, la2.format = eo2, la2.from = to2, la2.fromNow = no2, la2.to = ro2, la2.toNow = oo2, la2.get = me2, la2.invalidAt = Fo2, la2.isAfter = Wr2, la2.isBefore = jr2, la2.isBetween = Zr2, la2.isSame = Gr2, la2.isSameOrAfter = Ur2, la2.isSameOrBefore = qr2, la2.isValid = To2, la2.lang = io2, la2.locale = ao2, la2.localeData = so2, la2.max = Kn2, la2.min = Yn2, la2.parsingFlags = Eo2, la2.set = he2, la2.startOf = go2, la2.subtract = Ir2, la2.toArray = Co2, la2.toObject = xo2, la2.toDate = So2, la2.toISOString = Jr2, la2.inspect = Qr2, "undefined" != typeof Symbol && null != Symbol.for && (la2[Symbol.for("nodejs.util.inspect.custom")] = function() {
    return "Moment<" + this.format() + ">";
  }), la2.toJSON = wo2, la2.toString = Xr2, la2.unix = bo2, la2.valueOf = vo2, la2.creationData = Mo2, la2.eraName = Do2, la2.eraNarrow = Lo2, la2.eraAbbr = Ho2, la2.eraYear = Io2, la2.year = ft2, la2.isLeapYear = gt2, la2.weekYear = jo2, la2.isoWeekYear = Zo2, la2.quarter = la2.quarters = Jo2, la2.month = ct2, la2.daysInMonth = ut2, la2.week = la2.weeks = Mt2, la2.isoWeek = la2.isoWeeks = kt2, la2.weeksInYear = qo2, la2.weeksInWeekYear = Yo2, la2.isoWeeksInYear = Go2, la2.isoWeeksInISOWeekYear = Uo2, la2.date = Qo2, la2.day = la2.days = Wt2, la2.weekday = jt2, la2.isoWeekday = Zt2, la2.dayOfYear = ea2, la2.hour = la2.hours = nn2, la2.minute = la2.minutes = ta2, la2.second = la2.seconds = na2, la2.millisecond = la2.milliseconds = oa2, la2.utcOffset = hr2, la2.utc = gr2, la2.local = yr2, la2.parseZone = vr2, la2.hasAlignedHourOffset = br2, la2.isDST = Sr2, la2.isLocal = xr2, la2.isUtcOffset = wr2, la2.isUtc = Tr2, la2.isUTC = Tr2, la2.zoneAbbr = ia2, la2.zoneName = sa2, la2.dates = T10("dates accessor is deprecated. Use date instead.", Qo2), la2.months = T10("months accessor is deprecated. Use month instead", ct2), la2.years = T10("years accessor is deprecated. Use year instead", ft2), la2.zone = T10("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", fr2), la2.isDSTShifted = T10("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", Cr2);
  var pa2 = N10.prototype;
  function ma2(e15, t11, n11, r11) {
    var o11 = yn2(), a11 = p10().set(r11, t11);
    return o11[n11](a11, e15);
  }
  function ha2(e15, t11, n11) {
    if (l10(e15) && (t11 = e15, e15 = void 0), e15 = e15 || "", null != t11) return ma2(e15, t11, n11, "month");
    var r11, o11 = [];
    for (r11 = 0; r11 < 12; r11++) o11[r11] = ma2(e15, r11, n11, "month");
    return o11;
  }
  function fa2(e15, t11, n11, r11) {
    "boolean" == typeof e15 ? (l10(t11) && (n11 = t11, t11 = void 0), t11 = t11 || "") : (n11 = t11 = e15, e15 = false, l10(t11) && (n11 = t11, t11 = void 0), t11 = t11 || "");
    var o11, a11 = yn2(), i11 = e15 ? a11._week.dow : 0, s11 = [];
    if (null != n11) return ma2(t11, (n11 + i11) % 7, r11, "day");
    for (o11 = 0; o11 < 7; o11++) s11[o11] = ma2(t11, (o11 + i11) % 7, r11, "day");
    return s11;
  }
  function ga2(e15, t11) {
    return ha2(e15, t11, "months");
  }
  function ya2(e15, t11) {
    return ha2(e15, t11, "monthsShort");
  }
  function va2(e15, t11, n11) {
    return fa2(e15, t11, n11, "weekdays");
  }
  function ba2(e15, t11, n11) {
    return fa2(e15, t11, n11, "weekdaysShort");
  }
  function Sa2(e15, t11, n11) {
    return fa2(e15, t11, n11, "weekdaysMin");
  }
  pa2.calendar = H10, pa2.longDateFormat = Z10, pa2.invalidDate = U10, pa2.ordinal = K10, pa2.preparse = da2, pa2.postformat = da2, pa2.relativeTime = J10, pa2.pastFuture = Q10, pa2.set = k10, pa2.eras = ko2, pa2.erasParse = Po2, pa2.erasConvertYear = No2, pa2.erasAbbrRegex = Vo2, pa2.erasNameRegex = _o3, pa2.erasNarrowRegex = Ro2, pa2.months = ot2, pa2.monthsShort = at2, pa2.monthsParse = st2, pa2.monthsRegex = pt2, pa2.monthsShortRegex = dt2, pa2.week = wt2, pa2.firstDayOfYear = Ft2, pa2.firstDayOfWeek = Et2, pa2.weekdays = At2, pa2.weekdaysMin = Bt2, pa2.weekdaysShort = Ot2, pa2.weekdaysParse = $t2, pa2.weekdaysRegex = Gt2, pa2.weekdaysShortRegex = Ut2, pa2.weekdaysMinRegex = qt2, pa2.isPM = en2, pa2.meridiem = rn2, hn2("en", { eras: [{ since: "0001-01-01", until: 1 / 0, offset: 1, name: "Anno Domini", narrow: "AD", abbr: "AD" }, { since: "0000-12-31", until: -1 / 0, offset: 1, name: "Before Christ", narrow: "BC", abbr: "BC" }], dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/, ordinal: function(e15) {
    var t11 = e15 % 10;
    return e15 + (1 === ce2(e15 % 100 / 10) ? "th" : 1 === t11 ? "st" : 2 === t11 ? "nd" : 3 === t11 ? "rd" : "th");
  } }), t10.lang = T10("moment.lang is deprecated. Use moment.locale instead.", hn2), t10.langData = T10("moment.langData is deprecated. Use moment.localeData instead.", yn2);
  var Ca2 = Math.abs;
  function xa2() {
    var e15 = this._data;
    return this._milliseconds = Ca2(this._milliseconds), this._days = Ca2(this._days), this._months = Ca2(this._months), e15.milliseconds = Ca2(e15.milliseconds), e15.seconds = Ca2(e15.seconds), e15.minutes = Ca2(e15.minutes), e15.hours = Ca2(e15.hours), e15.months = Ca2(e15.months), e15.years = Ca2(e15.years), this;
  }
  function wa2(e15, t11, n11, r11) {
    var o11 = Mr2(t11, n11);
    return e15._milliseconds += r11 * o11._milliseconds, e15._days += r11 * o11._days, e15._months += r11 * o11._months, e15._bubble();
  }
  function Ta2(e15, t11) {
    return wa2(this, e15, t11, 1);
  }
  function Ea2(e15, t11) {
    return wa2(this, e15, t11, -1);
  }
  function Fa2(e15) {
    return e15 < 0 ? Math.floor(e15) : Math.ceil(e15);
  }
  function Ma2() {
    var e15, t11, n11, r11, o11, a11 = this._milliseconds, i11 = this._days, s11 = this._months, l11 = this._data;
    return a11 >= 0 && i11 >= 0 && s11 >= 0 || a11 <= 0 && i11 <= 0 && s11 <= 0 || (a11 += 864e5 * Fa2(Pa2(s11) + i11), i11 = 0, s11 = 0), l11.milliseconds = a11 % 1e3, e15 = le2(a11 / 1e3), l11.seconds = e15 % 60, t11 = le2(e15 / 60), l11.minutes = t11 % 60, n11 = le2(t11 / 60), l11.hours = n11 % 24, i11 += le2(n11 / 24), s11 += o11 = le2(ka2(i11)), i11 -= Fa2(Pa2(o11)), r11 = le2(s11 / 12), s11 %= 12, l11.days = i11, l11.months = s11, l11.years = r11, this;
  }
  function ka2(e15) {
    return 4800 * e15 / 146097;
  }
  function Pa2(e15) {
    return 146097 * e15 / 4800;
  }
  function Na2(e15) {
    if (!this.isValid()) return NaN;
    var t11, n11, r11 = this._milliseconds;
    if ("month" === (e15 = ne2(e15)) || "quarter" === e15 || "year" === e15) switch (t11 = this._days + r11 / 864e5, n11 = this._months + ka2(t11), e15) {
      case "month":
        return n11;
      case "quarter":
        return n11 / 3;
      case "year":
        return n11 / 12;
    }
    else switch (t11 = this._days + Math.round(Pa2(this._months)), e15) {
      case "week":
        return t11 / 7 + r11 / 6048e5;
      case "day":
        return t11 + r11 / 864e5;
      case "hour":
        return 24 * t11 + r11 / 36e5;
      case "minute":
        return 1440 * t11 + r11 / 6e4;
      case "second":
        return 86400 * t11 + r11 / 1e3;
      case "millisecond":
        return Math.floor(864e5 * t11) + r11;
      default:
        throw new Error("Unknown unit " + e15);
    }
  }
  function Da2() {
    return this.isValid() ? this._milliseconds + 864e5 * this._days + this._months % 12 * 2592e6 + 31536e6 * ce2(this._months / 12) : NaN;
  }
  function La2(e15) {
    return function() {
      return this.as(e15);
    };
  }
  var Ha2 = La2("ms"), Ia2 = La2("s"), _a2 = La2("m"), Va2 = La2("h"), Ra2 = La2("d"), Aa2 = La2("w"), Oa2 = La2("M"), Ba2 = La2("Q"), za2 = La2("y");
  function $a2() {
    return Mr2(this);
  }
  function Wa2(e15) {
    return e15 = ne2(e15), this.isValid() ? this[e15 + "s"]() : NaN;
  }
  function ja2(e15) {
    return function() {
      return this.isValid() ? this._data[e15] : NaN;
    };
  }
  var Za2 = ja2("milliseconds"), Ga2 = ja2("seconds"), Ua2 = ja2("minutes"), qa2 = ja2("hours"), Ya2 = ja2("days"), Ka2 = ja2("months"), Xa2 = ja2("years");
  function Ja2() {
    return le2(this.days() / 7);
  }
  var Qa2 = Math.round, ei2 = { ss: 44, s: 45, m: 45, h: 22, d: 26, w: null, M: 11 };
  function ti2(e15, t11, n11, r11, o11) {
    return o11.relativeTime(t11 || 1, !!n11, e15, r11);
  }
  function ni2(e15, t11, n11, r11) {
    var o11 = Mr2(e15).abs(), a11 = Qa2(o11.as("s")), i11 = Qa2(o11.as("m")), s11 = Qa2(o11.as("h")), l11 = Qa2(o11.as("d")), c11 = Qa2(o11.as("M")), u11 = Qa2(o11.as("w")), d11 = Qa2(o11.as("y")), p11 = a11 <= n11.ss && ["s", a11] || a11 < n11.s && ["ss", a11] || i11 <= 1 && ["m"] || i11 < n11.m && ["mm", i11] || s11 <= 1 && ["h"] || s11 < n11.h && ["hh", s11] || l11 <= 1 && ["d"] || l11 < n11.d && ["dd", l11];
    return null != n11.w && (p11 = p11 || u11 <= 1 && ["w"] || u11 < n11.w && ["ww", u11]), (p11 = p11 || c11 <= 1 && ["M"] || c11 < n11.M && ["MM", c11] || d11 <= 1 && ["y"] || ["yy", d11])[2] = t11, p11[3] = +e15 > 0, p11[4] = r11, ti2.apply(null, p11);
  }
  function ri2(e15) {
    return void 0 === e15 ? Qa2 : "function" == typeof e15 && (Qa2 = e15, true);
  }
  function oi2(e15, t11) {
    return void 0 !== ei2[e15] && (void 0 === t11 ? ei2[e15] : (ei2[e15] = t11, "s" === e15 && (ei2.ss = t11 - 1), true));
  }
  function ai2(e15, t11) {
    if (!this.isValid()) return this.localeData().invalidDate();
    var n11, r11, o11 = false, a11 = ei2;
    return "object" == typeof e15 && (t11 = e15, e15 = false), "boolean" == typeof e15 && (o11 = e15), "object" == typeof t11 && (a11 = Object.assign({}, ei2, t11), null != t11.s && null == t11.ss && (a11.ss = t11.s - 1)), r11 = ni2(this, !o11, a11, n11 = this.localeData()), o11 && (r11 = n11.pastFuture(+this, r11)), n11.postformat(r11);
  }
  var ii2 = Math.abs;
  function si2(e15) {
    return (e15 > 0) - (e15 < 0) || +e15;
  }
  function li2() {
    if (!this.isValid()) return this.localeData().invalidDate();
    var e15, t11, n11, r11, o11, a11, i11, s11, l11 = ii2(this._milliseconds) / 1e3, c11 = ii2(this._days), u11 = ii2(this._months), d11 = this.asSeconds();
    return d11 ? (e15 = le2(l11 / 60), t11 = le2(e15 / 60), l11 %= 60, e15 %= 60, n11 = le2(u11 / 12), u11 %= 12, r11 = l11 ? l11.toFixed(3).replace(/\.?0+$/, "") : "", o11 = d11 < 0 ? "-" : "", a11 = si2(this._months) !== si2(d11) ? "-" : "", i11 = si2(this._days) !== si2(d11) ? "-" : "", s11 = si2(this._milliseconds) !== si2(d11) ? "-" : "", o11 + "P" + (n11 ? a11 + n11 + "Y" : "") + (u11 ? a11 + u11 + "M" : "") + (c11 ? i11 + c11 + "D" : "") + (t11 || e15 || l11 ? "T" : "") + (t11 ? s11 + t11 + "H" : "") + (e15 ? s11 + e15 + "M" : "") + (l11 ? s11 + r11 + "S" : "")) : "P0D";
  }
  var ci2 = ar2.prototype;
  return ci2.isValid = rr2, ci2.abs = xa2, ci2.add = Ta2, ci2.subtract = Ea2, ci2.as = Na2, ci2.asMilliseconds = Ha2, ci2.asSeconds = Ia2, ci2.asMinutes = _a2, ci2.asHours = Va2, ci2.asDays = Ra2, ci2.asWeeks = Aa2, ci2.asMonths = Oa2, ci2.asQuarters = Ba2, ci2.asYears = za2, ci2.valueOf = Da2, ci2._bubble = Ma2, ci2.clone = $a2, ci2.get = Wa2, ci2.milliseconds = Za2, ci2.seconds = Ga2, ci2.minutes = Ua2, ci2.hours = qa2, ci2.days = Ya2, ci2.weeks = Ja2, ci2.months = Ka2, ci2.years = Xa2, ci2.humanize = ai2, ci2.toISOString = li2, ci2.toString = li2, ci2.toJSON = li2, ci2.locale = ao2, ci2.localeData = so2, ci2.toIsoString = T10("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", li2), ci2.lang = io2, O10("X", 0, 0, "unix"), O10("x", 0, 0, "valueOf"), He2("x", ke2), He2("X", De2), Ae2("X", function(e15, t11, n11) {
    n11._d = new Date(1e3 * parseFloat(e15));
  }), Ae2("x", function(e15, t11, n11) {
    n11._d = new Date(ce2(e15));
  }), //! moment.js
  t10.version = "2.29.4", n10(qn2), t10.fn = la2, t10.min = Jn2, t10.max = Qn2, t10.now = er2, t10.utc = p10, t10.unix = ca2, t10.months = ga2, t10.isDate = c10, t10.locale = hn2, t10.invalid = y10, t10.duration = Mr2, t10.isMoment = x10, t10.weekdays = va2, t10.parseZone = ua2, t10.localeData = yn2, t10.isDuration = ir2, t10.monthsShort = ya2, t10.weekdaysMin = Sa2, t10.defineLocale = fn2, t10.updateLocale = gn2, t10.locales = vn2, t10.weekdaysShort = ba2, t10.normalizeUnits = ne2, t10.relativeTimeRounding = ri2, t10.relativeTimeThreshold = oi2, t10.calendarFormat = Br2, t10.prototype = la2, t10.HTML5_FMT = { DATETIME_LOCAL: "YYYY-MM-DDTHH:mm", DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss", DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS", DATE: "YYYY-MM-DD", TIME: "HH:mm", TIME_SECONDS: "HH:mm:ss", TIME_MS: "HH:mm:ss.SSS", WEEK: "GGGG-[W]WW", MONTH: "YYYY-MM" }, t10;
}();
var iI = oI.exports;
var sI = W(iI);
const lI = { type: "iso" };
const cI = sI().year();
const uI = Array.from(Array(12).keys());
const dI = (e14, t10) => e14 - e14 % t10;
const pI = (e14, t10, n10) => {
  if (!e14) return null;
  let r10;
  "string" == typeof e14 && (r10 = "string" == typeof t10 ? t10 : "iso" === t10.type ? iI.ISO_8601 : t10.format);
  const o10 = n10(e14, r10);
  return o10.isValid() ? o10 : null;
};
const mI = (e14, t10) => {
  const n10 = [].concat(e14);
  const r10 = n10.some((e15) => null !== e15);
  const o10 = n10.length > 1 && !n10.includes(null);
  return { getSelectionStatus: (e15) => {
    if (!r10) return { isSelected: false };
    const a10 = n10.some((n11) => n11 && e15.isSame(n11, t10));
    let i10;
    if (o10) {
      const [r11, o11] = n10;
      const a11 = e15.isSame(r11, t10);
      const s10 = e15.isSame(o11, t10);
      a11 || s10 ? i10 = a11 && s10 ? "range-both" : a11 ? "range-start" : "range-end" : e15.isBetween(r11, o11) && (i10 = "in-range");
    }
    return { isSelected: a10, rangeStatus: i10 };
  } };
};
const hI = /(Y+)/;
const fI = /(M+)/;
const gI = (e14) => {
  const t10 = hI.exec(e14);
  const n10 = fI.exec(e14);
  return t10 && n10 && t10.index < n10.index ? "Y-M" : "M-Y";
};
const [yI, vI, bI] = Dp("gc-datetime-date");
const [SI, CI] = bI("button");
const xI = (e14) => {
  const { isNeighbor: t10, isToday: n10, disabled: r10, onClick: o10, text: a10, enlarged: i10, selectionStatus: { isSelected: s10, rangeStatus: l10 }, dataAid: c10 } = e14;
  const u10 = kp(yI, l10 && vI(l10), i10 && vI("large"));
  const d10 = { dataAid: c10 && `${c10}_date${s10 ? "_selected" : ""}`, customCSS: kp(SI, { [CI("neighbor")]: t10, [CI("selected")]: s10, [CI("today")]: n10 }), text: a10, onClick: o10, disabled: r10, rounded: true, size: "small", textAlign: "center", background: s10 ? "default" : "transparent", accent: s10 ? "full" : "none", title: "" };
  return tp.createElement("div", { className: u10 }, tp.createElement(qm, __spreadValues({}, d10)));
};
const [wI, TI, EI] = Dp("gc-datetime-header");
const [FI] = EI("title");
const [MI] = EI("buttons");
const kI = { left: nf(oh, { rotate: "90" }), right: nf(oh, { rotate: "270" }) };
const PI = (e14) => {
  const { title: t10, dataAid: n10, prevBtnText: r10, isContrast: o10, onNext: a10, onPrev: i10, onTitleClick: s10, parseFormatString: l10, toggleViewSelection: c10, viewDate: u10, monthYearFlag: d10 } = e14;
  const p10 = { rounded: true, background: "transparent", textAlign: "center" };
  const m10 = __spreadProps(__spreadValues({}, p10), { accent: o10 ? "full" : "icon", icon: kI.left, onClick: i10, dataAid: n10 && `${n10}_prev`, text: r10 });
  const h10 = __spreadProps(__spreadValues({}, p10), { accent: o10 ? "full" : "icon", icon: kI.right, onClick: a10, dataAid: n10 && `${n10}_next` });
  const f10 = kp(wI, o10 && TI("contrast"));
  return tp.createElement("div", { className: f10 }, i10 && tp.createElement(qm, __spreadValues({}, m10)), (() => {
    if (!t10) return null;
    if (d10 && l10 && c10) {
      const e15 = l10.map((e16) => {
        const t11 = e16[0].toLowerCase();
        return __spreadProps(__spreadValues({}, p10), { type: "button", accent: o10 ? "full" : "icon", text: u10 == null ? void 0 : u10.format(e16), onClick: c10(t11), dataAid: n10 && `${n10}_title_${t11}`, customCSS: FI });
      });
      return tp.createElement(sM, { customCSS: MI, dataAid: n10 && `${n10}_title`, items: e15 });
    }
    if (s10) {
      const e15 = __spreadProps(__spreadValues({}, p10), { accent: o10 ? "full" : "icon", text: t10, onClick: s10, dataAid: n10 && `${n10}_title`, customCSS: FI });
      return tp.createElement(qm, __spreadValues({}, e15));
    }
    return tp.createElement("div", { className: FI, "data-aid": n10 && `${n10}_title` }, t10);
  })(), a10 && tp.createElement(qm, __spreadValues({}, h10)));
};
const [NI, DI, LI] = Dp("gc-datetime");
const [HI] = LI("header");
const [II] = LI("body");
const [_I] = LI("footer");
const VI = (e14) => {
  const { dataAid: t10, viewMode: n10, footerItemsAmount: r10, body: o10, footerItems: a10, hideHeader: i10 } = e14;
  const s10 = kp(NI, DI(n10), r10 && DI(`extended-${r10}`));
  return tp.createElement("div", { className: s10, "data-aid": t10 && `${t10}_${n10}_view` }, tp.createElement("div", { className: HI }, !i10 && tp.createElement(PI, __spreadValues({}, e14))), tp.createElement("div", { className: II }, o10), a10 && a10.map((e15, t11) => tp.createElement("div", { className: _I, key: t11 + r10 }, e15)));
};
const [RI, , AI] = Dp("gc-datetime-days");
const [OI] = AI("header");
const [BI] = AI("weekday");
const [zI] = AI("content");
const [$I] = Dp("gc-datetime-footer-time");
const [WI] = Dp("gc-datetime-footer-control");
const jI = (e14) => e14.match(/(m+|y+)/gi);
const ZI = (e14) => {
  const { viewDate: t10, dataAid: n10, viewMode: r10, hideHeader: o10, availableYears: [a10, i10], advanceViewDate: s10, daysViewHeaderFormat: l10, toggleQuickSelection: c10, isValidDate: u10, onDateClick: d10, selectedDate: p10, toggleViewSelection: m10, viewSection: h10 } = e14;
  const f10 = sI();
  const g10 = tp.createElement("div", { className: RI }, tp.createElement("div", { className: OI }, (() => {
    const e15 = t10.localeData();
    const n11 = e15.weekdaysMin();
    const r11 = e15.firstDayOfWeek();
    const o11 = [];
    let a11 = 0;
    return n11.forEach((e16) => o11[(7 + a11++ - r11) % 7] = e16), o11.map((e16, t11) => tp.createElement("span", { key: t11, className: BI }, e16));
  })()), tp.createElement("div", { className: zI }, (() => {
    const e15 = t10.clone().subtract(1, "months");
    e15.date(e15.daysInMonth()).startOf("week");
    const r11 = e15.clone().add(42, "d");
    const o11 = [];
    for (; e15.isBefore(r11); ) o11.push(e15.clone()), e15.add(1, "d");
    const { getSelectionStatus: s11 } = mI(p10, "day");
    return o11.map((e16) => {
      const r12 = e16.date();
      const o12 = e16.year();
      const l11 = e16.isBefore(t10, "month");
      const c11 = e16.isAfter(t10, "month");
      const p11 = l11 ? -1 : c11 ? 1 : 0;
      const m11 = { isNeighbor: l11 || c11, disabled: o12 < a10 || o12 > i10 || !u10(e16.clone(), "days"), onClick: d10({ type: "day", value: r12, monthOffset: p11 }), selectionStatus: s11(e16), isToday: e16.isSame(f10, "day"), text: `${r12}`, dataAid: n10 };
      return tp.createElement(xI, __spreadProps(__spreadValues({}, m11), { key: e16.format("M_D") }));
    });
  })()));
  let y10;
  let v10;
  "date-time" === e14.type && (v10 = e14.footerItemsAmount, y10 = [], e14.timeFormat && y10.push(((e15) => {
    const { timeFormat: r11, selectedDate: o11, setView: a11 } = e15;
    const i11 = { accent: "text+icon", block: true, width: "100%", rounded: true, background: "transparent", textAlign: "center", customCSS: $I, text: (o11 || t10).format(r11), onClick: a11("time"), dataAid: n10 && `${n10}_time` };
    return tp.createElement(qm, __spreadValues({}, i11));
  })(e14)), e14.withShortcuts && y10.push(((e15) => {
    const { selectShortcut: t11, textShortcutClear: r11, textShortcutToday: o11 } = e15;
    const a11 = { textAlign: "center", size: "small", accent: "icon", customCSS: WI };
    return tp.createElement(tp.Fragment, null, tp.createElement(qm, __spreadProps(__spreadValues({}, a11), { accent: "full", text: o11, onClick: t11("today"), dataAid: n10 && `${n10}_today` })), tp.createElement(qm, __spreadProps(__spreadValues({}, a11), { text: r11, onClick: t11("clear"), dataAid: n10 && `${n10}_clear` })));
  })(e14)));
  const b10 = { viewMode: r10, dataAid: n10, body: g10, footerItemsAmount: v10, footerItems: y10, hideHeader: o10, title: t10.format(l10), onPrev: s10("subtract", 1, "month"), onNext: s10("add", 1, "month"), onTitleClick: c10, toggleViewSelection: m10, viewSection: h10, viewDate: t10, parseFormatString: jI(l10) };
  return tp.createElement(VI, __spreadProps(__spreadValues({}, b10), { monthYearFlag: true }));
};
const GI = (e14) => {
  const { viewDate: t10, dataAid: n10, viewMode: r10, selectedDate: o10, toggleQuickSelection: a10, advanceViewDate: i10, isValidDate: s10, onDateClick: l10, hideHeader: c10, availableYears: [u10, d10] } = e14;
  const { getSelectionStatus: p10 } = mI(o10, "month");
  const m10 = { body: uI.map((e15) => {
    const r11 = t10.clone().set("month", e15);
    const o11 = r11.year();
    const a11 = { disabled: o11 < u10 || o11 > d10 || !s10(r11.clone(), "months"), onClick: l10({ type: "month", value: e15 }), selectionStatus: p10(r11), text: r11.format("MMM"), enlarged: true, dataAid: n10 };
    return tp.createElement(xI, __spreadProps(__spreadValues({}, a11), { key: e15 }));
  }), viewMode: r10, dataAid: n10, hideHeader: c10, title: `${t10.year()}`, onPrev: i10("subtract", 1, "year"), onNext: i10("add", 1, "year"), onTitleClick: a10 };
  return tp.createElement(VI, __spreadValues({}, m10));
};
const UI = (e14) => {
  const { viewDate: t10, dataAid: n10, viewMode: r10, selectedDate: o10, availableYears: [a10, i10], advanceViewDate: s10, isValidDate: l10, onDateClick: c10, hideHeader: u10 } = e14;
  const d10 = dI(t10.year(), 10);
  const p10 = d10 + 9;
  const m10 = { body: (() => {
    const { getSelectionStatus: e15 } = mI(o10, "year");
    return uI.map((r11) => {
      const o11 = d10 + r11;
      const s11 = t10.clone().set("year", o11);
      const u11 = { disabled: o11 < a10 || o11 > i10 || !l10(s11.clone(), "years"), onClick: c10({ type: "year", value: o11 }), selectionStatus: e15(s11), text: `${o11}`, enlarged: true, isNeighbor: o11 > p10, dataAid: n10 };
      return tp.createElement(xI, __spreadProps(__spreadValues({}, u11), { key: r11 }));
    });
  })(), viewMode: r10, dataAid: n10, hideHeader: u10, title: `${d10} - ${p10}`, onPrev: s10("subtract", 10, "year"), onNext: s10("add", 10, "year") };
  return tp.createElement(VI, __spreadValues({}, m10));
};
const [qI, , YI] = Dp("gc-clock");
const [KI] = YI("value");
const XI = { up: nf(oh, { rotate: "180" }), down: nf(oh) };
const JI = (e14, t10, n10) => n10 <= t10 && n10 >= e14;
const QI = (e14) => {
  const { dataAid: t10, unit: n10, value: r10, displayValue: o10, constraints: a10, setTime: i10 } = e14;
  const [s10, l10] = ep.useState(o10);
  ep.useEffect(() => {
    l10(o10);
  }, [o10, r10]);
  const c10 = { customCSS: KI, dataAid: t10 && `${t10}_time_value`, onChange: ({ currentTarget: { value: e15 } }) => l10(e15), value: s10, onBlur: () => {
    const e15 = parseInt(s10);
    if (r10 === e15) return void l10(o10);
    const t11 = ((e16, t12, n11) => "hours" === e16 ? JI(t12.hours.min, t12.hours.max, n11) : "minutes" === e16 ? JI(t12.minutes.min, t12.minutes.max, n11) : "seconds" === e16 && JI(t12.seconds.min, t12.seconds.max, n11))(n10, a10, e15);
    t11 ? i10(n10, e15) : l10(o10);
  }, size: "large", textAlign: "center" };
  const u10 = { accent: "icon", block: true, background: "transparent", size: "large" };
  return tp.createElement("div", { className: qI }, tp.createElement(qm, __spreadProps(__spreadValues({}, u10), { icon: XI.up, onClick: () => {
    let e15 = r10 + a10[n10].step;
    e15 > a10[n10].max && (e15 = a10[n10].min + (e15 - (a10[n10].max + 1))), i10(n10, e15);
  }, dataAid: t10 && `${t10}_time_inc` })), tp.createElement(KF, __spreadValues({}, c10)), tp.createElement(qm, __spreadProps(__spreadValues({}, u10), { icon: XI.down, onClick: () => {
    let e15 = r10 - a10[n10].step;
    e15 < a10[n10].min && (e15 = a10[n10].max + 1 - (a10[n10].min - e15)), i10(n10, e15);
  }, dataAid: t10 && `${t10}_time_dec` })));
};
const [e_, , t_] = Dp("gc-datetime-timer");
const [n_] = t_("delimiter");
const [r_] = t_("daypart");
const [o_, a_] = t_("daypart-title");
const [i_] = t_("seconds");
const s_ = (e14) => {
  var _a2;
  const { setView: t10, selectedDate: n10, viewDate: r10, timeConstraints: o10, timeFormat: a10, dataAid: i10, viewMode: s10, textBack: l10, footerItemsAmount: c10, hideHeader: u10, setTime: d10 } = e14;
  const p10 = n10 || r10;
  const m10 = p10.hour();
  const h10 = -1 !== a10.toLowerCase().indexOf(" a") && (m10 >= 12 ? "PM" : "AM");
  const f10 = a10.toLowerCase().includes("ss");
  const g10 = { string: { hours: p10.format(h10 ? "h" : "H"), minutes: p10.format("mm"), seconds: p10.format("ss") }, number: { hours: m10, minutes: p10.minute(), seconds: p10.second() } };
  const y10 = (() => {
    const e15 = { hours: { min: 0, max: 23, step: 1 }, minutes: { min: 0, max: 59, step: 1 }, seconds: { min: 0, max: 59, step: 1 } };
    return o10.hours && (e15.hours = o10.hours), o10.minutes && (e15.minutes = o10.minutes), o10.seconds && (e15.seconds = o10.seconds), e15;
  })();
  const v10 = () => {
    let e15 = g10.number.hours + 12;
    e15 > y10.hours.max && (e15 = y10.hours.min + (e15 - (y10.hours.max + 1))), d10("hours", e15);
  };
  const b10 = (e15) => {
    const t11 = { dataAid: i10, value: g10.number[e15], displayValue: g10.string[e15], constraints: y10, unit: e15, setTime: d10 };
    return tp.createElement(QI, __spreadValues({}, t11));
  };
  const S10 = kp(e_, { [i_]: (_a2 = f10 && h10) != null ? _a2 : i_ });
  const C10 = tp.createElement("div", { className: S10 }, b10("hours"), tp.createElement("span", { className: n_ }, ":"), b10("minutes"), f10 ? tp.createElement(tp.Fragment, null, tp.createElement("span", { className: n_ }, ":"), b10("seconds")) : null, (() => {
    if (!h10) return null;
    const e15 = { background: "transparent", size: "large", customCSS: r_, onClick: v10, dataAid: i10 && `${i10}_day_part` };
    const t11 = (e16) => kp(o_, { [a_("selected")]: e16 === h10 });
    return tp.createElement(qm, __spreadValues({}, e15), tp.createElement("div", { className: t11("AM") }, "AM"), tp.createElement("div", { className: t11("PM") }, "PM"));
  })());
  const x10 = { viewMode: s10, footerItemsAmount: c10, dataAid: i10, body: C10, prevBtnText: l10, hideHeader: u10, onPrev: t10("days") };
  return tp.createElement(VI, __spreadValues({}, x10));
};
const [l_, c_, u_] = Dp("gc-datetime-barrel");
const [d_] = u_("column");
const [p_, m_] = u_("item");
const [h_] = u_("scroll");
const [f_] = u_("years-container");
const [g_] = u_("year-wrapper");
const y_ = Rp;
const v_ = Array.from(Array(15).keys());
const b_ = (e14) => {
  const { viewMode: t10, dataAid: n10, toggleQuickSelection: r10, viewDate: o10, setViewDate: a10, availableYears: [i10, s10], textBack: l10, monthYearOrder: c10, isValidDate: u10, footerItemsAmount: d10, hideHeader: p10, locale: m10, viewSection: h10 } = e14;
  const [f10, g10] = ep.useState(0);
  const { maxRenderIndex: y10, yearsContainerHeight: v10 } = ep.useMemo(() => ({ maxRenderIndex: s10 - i10, yearsContainerHeight: (s10 - i10 + 1) * y_ }), [i10, s10]);
  const b10 = ep.useRef(null);
  const S10 = o10.year();
  ep.useLayoutEffect(() => {
    var _a2;
    const e15 = (_a2 = b10.current) == null ? void 0 : _a2.getBaseRef();
    if (e15) {
      const t11 = e15.getClientHeight();
      const n11 = (S10 - i10) * y_;
      const r11 = (t11 - y_) / 2;
      e15.scrollTop(n11 - r11);
    }
  }, []);
  const C10 = (e15) => {
    const t11 = Math.round(e15.target.scrollTop);
    const n11 = Math.floor(t11 / y_);
    f10 !== n11 && n11 < y10 && g10(n11);
  };
  const x10 = { style: { container: { height: "100%" } }, direction: "vertical", autoHeight: true, autoHeightMax: "none", viewCustomCSS: h_, size: "small" };
  const w10 = kp(l_, { [c_("swapped")]: "days" === t10 && "Y-M" === c10 });
  const T10 = () => tp.createElement(bF, __spreadValues({}, x10), (() => {
    const e15 = o10.month();
    const r11 = "ja" === m10 ? "MMM" : "MMMM";
    return uI.map((i11) => {
      const s11 = o10.clone().set("month", i11);
      const l11 = i11 === e15;
      const c11 = u10(s11.clone(), t10);
      const d11 = { text: s11.format(r11), block: true, size: "small", textAlign: "center", background: "transparent", accent: l11 ? "text" : "none", customCSS: kp(p_, l11 && m_("selected")), onClick: c11 ? a10("month", i11) : void 0, disabled: !c11, dataAid: n10 && `${n10}_barrel_month` };
      return tp.createElement(qm, __spreadValues({ key: i11 }, d11));
    });
  })());
  const E10 = () => tp.createElement(bF, __spreadProps(__spreadValues({}, x10), { ref: b10, onScroll: C10 }), tp.createElement("div", { className: f_, style: { height: v10 } }, (() => {
    const e15 = i10 + f10;
    return v_.map((r11) => {
      const o11 = e15 + r11;
      if (o11 > s10) return null;
      const i11 = o11 === S10;
      const l11 = u10(o11, t10);
      const c11 = { text: `${o11}`, block: true, size: "small", textAlign: "center", background: "transparent", accent: i11 ? "text" : "none", customCSS: kp(p_, i11 && m_("selected")), onClick: l11 ? a10("year", o11) : void 0, disabled: !l11, dataAid: n10 && `${n10}_barrel_year` };
      return tp.createElement("div", { key: o11, className: g_, style: { top: (f10 + r11) * y_ } }, tp.createElement(qm, __spreadValues({}, c11)));
    });
  })()));
  const F10 = tp.createElement("div", { className: w10 }, tp.createElement("div", { className: d_, onClick: r10 }, h10 && "m" === h10 ? T10() : E10()));
  const M10 = { viewMode: t10, footerItemsAmount: d10, dataAid: n10, body: F10, prevBtnText: l10, hideHeader: p10, onPrev: r10, viewDate: o10 };
  return tp.createElement(VI, __spreadValues({}, M10));
};
const S_ = (e14) => {
  const { quickSelection: t10, viewMode: n10 } = e14;
  if (t10) return ep.createElement(b_, __spreadValues({}, e14));
  switch (n10) {
    case "days":
      return ep.createElement(ZI, __spreadValues({}, e14));
    case "months":
      return ep.createElement(GI, __spreadValues({}, e14));
    case "years":
      return ep.createElement(UI, __spreadValues({}, e14));
    case "time":
      return ep.createElement(s_, __spreadValues({}, e14));
    default:
      return null;
  }
};
function C_(e14, t10 = void 0) {
  return { type: e14, payload: t10 };
}
const x_ = ({ props: e14, localMoment: t10, inputFormat: n10 }) => {
  const { value: r10, defaultValue: o10, viewDate: a10, valueFormat: i10 } = e14;
  const s10 = i10 || n10;
  const l10 = pI(r10 || o10, s10, t10);
  const c10 = l10 ? l10.clone().startOf("month") : (pI(a10, s10, t10) || t10()).startOf("month");
  const u10 = "string" == typeof r10 ? r10 : "";
  return { inputValue: l10 ? l10.format(n10) : u10, selectedDate: l10, viewDate: c10, currentView: "days", quickSelection: false, viewSection: null };
};
const w_ = (e14, t10) => {
  switch (t10.type) {
    case "SELECT_DATE": {
      const { params: n10, inputFormat: r10 } = t10.payload;
      const o10 = (e14.selectedDate || e14.viewDate).clone().year(e14.viewDate.year()).month(e14.viewDate.month() + n10.monthOffset).date(n10.value);
      return __spreadProps(__spreadValues({}, e14), { selectedDate: o10, viewDate: o10.clone().startOf("month"), inputValue: o10.format(r10) });
    }
    case "SELECT_SHORTCUT": {
      const { type: n10, localMoment: r10, inputFormat: o10 } = t10.payload;
      let a10;
      switch (n10) {
        case "today":
          a10 = r10();
          break;
        case "clear":
          a10 = null;
      }
      return __spreadProps(__spreadValues({}, e14), { selectedDate: a10, viewDate: (a10 || r10()).clone().startOf("month"), inputValue: a10 ? a10.format(o10) : "" });
    }
    case "SET_VALUE": {
      const { value: n10, inputFormat: r10, valueFormat: o10, localMoment: a10 } = t10.payload;
      const i10 = pI(n10, o10 || r10, a10);
      const s10 = i10 ? i10.clone().startOf("month") : e14.viewDate;
      const l10 = "string" == typeof n10 ? n10 : "";
      const c10 = i10 ? i10.format(r10) : l10;
      return __spreadProps(__spreadValues({}, e14), { inputValue: c10, selectedDate: i10, viewDate: s10 });
    }
    case "SET_TIME": {
      const { unit: n10, value: r10, inputFormat: o10 } = t10.payload;
      const a10 = (e14.selectedDate || e14.viewDate).clone()[n10](r10);
      return __spreadProps(__spreadValues({}, e14), { selectedDate: a10, inputValue: a10.format(o10) });
    }
    case "SET_VIEW": {
      const { viewMode: n10 } = t10.payload;
      return __spreadProps(__spreadValues({}, e14), { currentView: n10 });
    }
    case "SET_VIEW_DATE": {
      const { type: n10, value: r10 } = t10.payload;
      return __spreadProps(__spreadValues({}, e14), { viewDate: e14.viewDate.clone()[n10](r10) });
    }
    case "ADVANCE_VIEW_DATE": {
      const { operation: n10, amount: r10, unit: o10 } = t10.payload;
      return __spreadProps(__spreadValues({}, e14), { viewDate: e14.viewDate.clone()[n10](r10, o10) });
    }
    case "CHANGE_INPUT_VALUE": {
      const { value: n10, localMoment: r10, inputFormat: o10 } = t10.payload;
      const a10 = r10(n10, o10);
      return __spreadProps(__spreadValues({}, e14), { inputValue: n10, selectedDate: a10.isValid() ? a10 : null, viewDate: a10.isValid() ? a10.clone().startOf("month") : e14.viewDate });
    }
    case "CHANGE_FORMAT": {
      const { localMoment: n10, inputFormat: r10 } = t10.payload;
      const { selectedDate: o10, inputValue: a10 } = e14;
      if (!a10) return e14;
      if (o10) return __spreadProps(__spreadValues({}, e14), { inputValue: o10.format(r10) });
      const i10 = n10(a10, r10);
      return i10.isValid() ? __spreadProps(__spreadValues({}, e14), { selectedDate: i10, viewDate: i10.clone().startOf("month") }) : e14;
    }
    case "CHANGE_LOCALE": {
      const { locale: n10, inputFormat: r10 } = t10.payload;
      let { selectedDate: o10 } = e14;
      let { inputValue: a10 } = e14;
      return o10 && (o10 = o10.clone().locale(n10), a10 = o10.format(r10)), __spreadProps(__spreadValues({}, e14), { selectedDate: o10, inputValue: a10, viewDate: e14.viewDate.clone().locale(n10) });
    }
    case "CHANGE_UTC": {
      const { utc: n10, inputFormat: r10 } = t10.payload;
      const o10 = n10 ? "utc" : "local";
      let { selectedDate: a10 } = e14;
      let { inputValue: i10 } = e14;
      let { viewDate: s10 } = e14;
      return a10 && (a10 = a10.clone()[o10](), i10 = a10.format(r10), s10 = a10.clone().startOf("month")), __spreadProps(__spreadValues({}, e14), { selectedDate: a10, inputValue: i10, viewDate: s10 });
    }
    case "TOGGLE_VIEW_SELECTION": {
      const { view: n10 } = t10.payload;
      return __spreadProps(__spreadValues({}, e14), { quickSelection: !e14.quickSelection, viewSection: n10 });
    }
    case "TOGGLE_QUICK_SELECTION":
      return __spreadProps(__spreadValues({}, e14), { quickSelection: !e14.quickSelection, viewSection: null });
    default:
      return e14;
  }
};
const T_ = { block: false, disabled: false, dropup: false, invalid: false, noCloseOnSelect: false, rounded: false, size: "default", icon: nf(Lh), pickerMode: "date", defaultValue: "", timeConstraints: {}, utc: false, locale: "en", daysViewHeaderFormat: "MMMM YYYY", availableYears: [cI - 200, cI + 200], strictParsing: true, isValidDate: () => true, withShortcuts: false, textShortcutToday: "Today", textShortcutClear: "Clear", textBack: "Back to Calendar" };
const E_ = (e14) => {
  const { API: t10 } = ep.useContext(Sm);
  const { id: n10, dataAid: r10, size: o10, block: a10, width: i10, rounded: s10, disabled: l10, invalid: c10, pickerMode: u10, utc: d10, dropup: p10, placeholder: m10, name: h10, customCSS: f10, menuCustomCSS: g10, noCloseOnSelect: y10, locale: v10, value: b10, timeConstraints: S10, withShortcuts: C10, daysViewHeaderFormat: x10, onChange: w10, textBack: T10, strictParsing: E10, valueFormat: F10, textShortcutClear: M10, textShortcutToday: k10, availableYears: P10, isValidDate: N10, icon: D10, titleToggle: L10, dateTimeFormat: H10 } = e14;
  const I10 = ep.useCallback((e15, t11) => (d10 ? sI.utc(e15, t11, E10) : sI(e15, t11, E10)).locale(v10), [v10, d10, E10]);
  const { dateFormat: _10, timeFormat: V10, inputFormat: R10, monthYearOrder: A10 } = ep.useMemo(() => {
    const t11 = I10().localeData();
    if (H10) return { dateFormat: "", timeFormat: H10.match(/[Hh]/) ? t11.longDateFormat("LTS") : "", inputFormat: H10, monthYearOrder: e14.monthYearOrder || gI(H10) };
    const n11 = e14.dateFormat || t11.longDateFormat("L");
    const r11 = { dateFormat: n11, timeFormat: "", inputFormat: "", monthYearOrder: e14.monthYearOrder || gI(n11) };
    return "date-time" === u10 && (r11.timeFormat = e14.timeFormat || t11.longDateFormat("LTS")), r11.inputFormat = `${r11.dateFormat} ${r11.timeFormat}`.trim(), r11;
  }, [e14.dateFormat, e14.timeFormat, I10, u10, e14.monthYearOrder, e14.dateTimeFormat]);
  const [O10, B10] = ep.useReducer(w_, { props: e14, inputFormat: R10, localMoment: I10 }, x_);
  const { currentView: z10, inputValue: $10, selectedDate: W10, viewDate: j10, quickSelection: Z10, viewSection: G10 } = O10;
  const U10 = void 0 !== b10;
  const q10 = (e15) => {
    if (U10) {
      const t11 = w_(O10, e15);
      w10 == null ? void 0 : w10(t11.selectedDate || t11.inputValue);
    } else B10(e15);
  };
  const Y10 = ep.useRef(false);
  const K10 = ep.useRef(false);
  const X10 = ep.useRef(null);
  const J10 = W10 || $10;
  ep.useEffect(() => {
    Y10.current && (!U10 && (w10 == null ? void 0 : w10(J10)), K10.current && (X10.current = J10));
  }, [W10, $10]), ep.useEffect(() => {
    Y10.current && B10(C_("SET_VALUE", { value: b10, localMoment: I10, inputFormat: R10, valueFormat: F10 }));
  }, [b10]), ep.useEffect(() => {
    Y10.current && B10(C_("CHANGE_FORMAT", { localMoment: I10, inputFormat: R10 }));
  }, [R10]), ep.useEffect(() => {
    Y10.current && B10(C_("CHANGE_LOCALE", { locale: v10, inputFormat: R10 }));
  }, [v10]), ep.useEffect(() => {
    Y10.current && B10(C_("CHANGE_UTC", { utc: d10, inputFormat: R10 }));
  }, [d10]), ep.useEffect(() => (Y10.current = true, () => {
    var _a2;
    null !== X10.current && U10 && ((_a2 = e14.onChange) == null ? void 0 : _a2.call(e14, X10.current));
  }), []);
  const Q10 = () => {
    y10 || t10.current.dropdowns.open(null);
  };
  let ee2 = 0;
  V10 && ee2++, C10 && ee2++;
  const te2 = { type: "date-time", textBack: T10, monthYearOrder: A10, dateFormat: _10, timeFormat: V10, textShortcutClear: M10, textShortcutToday: k10, value: b10, isValidDate: N10, timeConstraints: S10, daysViewHeaderFormat: x10, viewDate: j10, selectedDate: W10, withShortcuts: C10, dataAid: r10, setView: (e15) => () => {
    B10(C_("SET_VIEW", { viewMode: e15 }));
  }, setTime: (e15, t11) => {
    q10(C_("SET_TIME", { unit: e15, value: t11, inputFormat: R10 }));
  }, onDateClick: (e15) => () => {
    q10(C_("SELECT_DATE", { params: e15, inputFormat: R10 })), Q10();
  }, availableYears: P10, viewMode: z10, advanceViewDate: (e15, t11, n11) => () => {
    B10(C_("ADVANCE_VIEW_DATE", { operation: e15, amount: t11, unit: n11 }));
  }, selectShortcut: (e15, t11 = true) => () => {
    q10(C_("SELECT_SHORTCUT", { type: e15, localMoment: I10, inputFormat: R10 })), t11 && Q10();
  }, footerItemsAmount: ee2, quickSelection: Z10, toggleQuickSelection: () => {
    B10(C_("TOGGLE_QUICK_SELECTION"));
  }, setViewDate: (e15, t11) => () => {
    B10(C_("SET_VIEW_DATE", { type: e15, value: t11 }));
  }, locale: v10, toggleViewSelection: (e15) => () => {
    B10(C_("TOGGLE_VIEW_SELECTION", { view: e15 }));
  }, viewSection: G10 };
  const ne2 = { value: $10, content: tp.createElement(S_, __spreadValues({}, te2)), openOnFocus: true, customScroll: true, menuWidth: "auto", placeholder: m10 || (E10 ? R10 : void 0), chevronIcon: D10, titleToggle: L10, onToggle: (e15) => {
    e15 || "days" === z10 || B10(C_("SET_VIEW", { viewMode: "days" }));
  }, onChange: (t11) => {
    var _a2;
    K10.current = true, B10(C_("CHANGE_INPUT_VALUE", { value: t11.target.value, localMoment: I10, inputFormat: R10 })), (_a2 = e14.onInputChange) == null ? void 0 : _a2.call(e14, t11);
  }, onBlur: () => {
    K10.current = false, null !== X10.current && (X10.current = null, U10 && (w10 == null ? void 0 : w10(J10)));
  }, id: n10, dataAid: r10, invalid: c10, size: o10, block: a10, width: i10, rounded: s10, disabled: l10, dropup: p10, name: h10, customCSS: f10, menuCustomCSS: g10 };
  return tp.createElement(tM, __spreadValues({}, ne2));
};
function F_(e14, t10 = void 0) {
  return { type: e14, payload: t10 };
}
E_.defaultProps = T_;
const M_ = (e14, t10) => {
  const n10 = t10.clone();
  switch (e14) {
    case "day":
    case "days":
      n10.startOf("month");
      break;
    case "month":
    case "months":
      n10.startOf("year");
      break;
    case "year":
    case "years":
      n10.year(dI(n10.year(), 10)).startOf("year");
  }
  return n10;
};
const k_ = (e14, t10, n10, r10, o10) => {
  const a10 = M_(e14, t10 || n10 || o10());
  let i10 = M_(e14, n10 || t10 || o10());
  return !r10 && a10.isSame(i10) && (i10 = ((e15, t11) => {
    switch (e15) {
      case "days":
        return M_(e15, t11.clone().add(1, "months"));
      case "months":
        return M_(e15, t11.clone().add(1, "years"));
      case "years":
        return M_(e15, t11.clone().add(10, "years"));
      default:
        return t11;
    }
  })(e14, a10)), [a10, i10];
};
const P_ = (e14, t10, n10) => {
  switch (n10) {
    case "days":
      return e14.isSame(t10, "M");
    case "months":
      return e14.isSame(t10, "y");
    case "years":
      return e14.isBetween(t10, t10.clone().add(9, "y"), "y", "[]");
    default:
      return false;
  }
};
const N_ = (e14, t10, { localMoment: n10, simplified: r10 }, { viewDates: o10, currentView: a10 }) => {
  if (e14 && t10) {
    return !(P_(e14, o10[0], a10) && P_(t10, o10[0], a10) || P_(e14, o10[1], a10) && P_(t10, o10[1], a10)) ? k_(a10, e14, t10, r10, n10) : o10;
  }
  const i10 = e14 || t10;
  if (!i10) return o10;
  const s10 = o10.reduce((e15, t11, n11) => P_(i10, t11, a10) ? { foundMatch: true, shouldUpdate: false } : e15.foundMatch ? e15 : ((e16, t12, n12) => {
    switch (n12) {
      case "days":
        return e16.isBetween(t12.clone().subtract(1, "M"), t12.clone().add(1, "M"), "month", "[]");
      case "months":
      default:
        return false;
      case "years":
        return e16.isBetween(t12.clone().add(10, "y"), t12.clone().add(11, "y"), "y", "[]");
    }
  })(i10, t11, a10) ? { foundMatch: true, shouldUpdate: true, calendarIndex: n11 } : e15, { foundMatch: false, shouldUpdate: false });
  return s10.foundMatch ? s10.shouldUpdate ? o10.map((e15, t11) => t11 === s10.calendarIndex ? M_(a10, i10) : e15) : o10 : k_(a10, e14, t10, r10, n10);
};
const D_ = ({ props: e14, localMoment: t10, dateFormat: n10 }) => {
  const { value: r10, defaultValue: o10, defaultViewDates: a10, viewMode: i10, valueFormat: s10 } = e14;
  const l10 = s10 || n10;
  const c10 = r10 || o10;
  const u10 = pI(c10 == null ? void 0 : c10[0], l10, t10);
  const d10 = pI(c10 == null ? void 0 : c10[1], l10, t10);
  const p10 = u10 || pI(a10 == null ? void 0 : a10[0], l10, t10);
  const m10 = d10 || pI(a10 == null ? void 0 : a10[1], l10, t10);
  return { selectedRange: [u10, d10], currentView: i10, viewDates: k_(i10, p10, m10, e14.simplified, t10), quickSelection: false, viewSection: null };
};
const L_ = (e14, t10) => {
  switch (t10.type) {
    case "UPDATE_SELECTED_DATE": {
      const { params: n10, calendarIndex: r10, simplified: o10 } = t10.payload;
      const a10 = e14.viewDates[r10].clone();
      switch (n10.type) {
        case "day":
          a10.month(a10.month() + n10.monthOffset).date(n10.value);
          break;
        case "month":
          a10.month(n10.value);
          break;
        case "year":
          a10.year(n10.value);
      }
      let i10;
      const s10 = e14.selectedRange.filter((e15) => e15);
      let l10 = e14.viewDates;
      const c10 = M_(n10.type, a10);
      const u10 = e14.viewDates[1 - r10].clone();
      if (1 === s10.length) {
        const e15 = s10[0];
        const t11 = M_(n10.type, e15);
        i10 = a10.isAfter(e15) ? [e15.startOf(n10.type), a10.endOf(n10.type)] : [a10.startOf(n10.type), e15.endOf(n10.type)], o10 || c10.isSame(u10) || c10.isSame(t11) || (l10 = t11.isAfter(c10) ? [c10, t11] : [t11, c10]);
      } else i10 = [a10.startOf(n10.type), null], c10.isSame(u10) && u10[0 === r10 ? "add" : "subtract"](1, "months"), l10 = e14.viewDates.map((e15, t11) => t11 === r10 ? c10 : u10);
      return __spreadProps(__spreadValues({}, e14), { selectedRange: i10, viewDates: l10 });
    }
    case "SET_VALUE": {
      const { value: [n10, r10], format: o10, localMoment: a10 } = t10.payload;
      const i10 = pI(n10, o10, a10);
      const s10 = pI(r10, o10, a10);
      return __spreadProps(__spreadValues({}, e14), { selectedRange: [i10, s10], viewDates: N_(i10, s10, t10.payload, e14) });
    }
    case "SET_VIEW_DATE": {
      const { type: n10, value: r10, calendarIndex: o10 } = t10.payload;
      const a10 = e14.viewDates[o10].clone()[n10](r10);
      const i10 = e14.viewDates[1 - o10].clone();
      return __spreadProps(__spreadValues({}, e14), { viewDates: e14.viewDates.map((e15, t11) => t11 === o10 ? a10 : i10) });
    }
    case "ADVANCE_VIEW_DATE": {
      const { amount: n10, operation: r10, calendarIndex: o10, unit: a10 } = t10.payload;
      const i10 = e14.viewDates[o10].clone()[r10](n10, a10);
      const s10 = e14.viewDates[1 - o10].clone();
      return i10.isSame(s10) && s10[r10](n10, a10), __spreadProps(__spreadValues({}, e14), { viewDates: e14.viewDates.map((e15, t11) => t11 === o10 ? i10 : s10) });
    }
    case "SET_VIEW": {
      const { viewMode: n10, localMoment: r10, simplified: o10 } = t10.payload;
      const [a10, i10] = e14.selectedRange;
      return __spreadProps(__spreadValues({}, e14), { currentView: n10, viewDates: k_(n10, a10, i10, o10, r10), quickSelection: false });
    }
    case "SELECT_SHORTCUT": {
      const { value: [n10, r10], localMoment: o10, format: a10, simplified: i10 } = t10.payload;
      const s10 = pI(n10, a10, o10);
      const l10 = pI(r10, a10, o10);
      return s10 && l10 ? __spreadProps(__spreadValues({}, e14), { selectedRange: [s10, l10], viewDates: k_(e14.currentView, s10, l10, i10, o10), quickSelection: false }) : e14;
    }
    case "TOGGLE_QUICK_SELECTION":
      return __spreadProps(__spreadValues({}, e14), { quickSelection: !e14.quickSelection, viewSection: null });
    case "TOGGLE_VIEW_SELECTION": {
      const { view: n10 } = t10.payload;
      return __spreadProps(__spreadValues({}, e14), { viewSection: n10, quickSelection: !e14.quickSelection });
    }
    case "CHANGE_LOCALE": {
      const { locale: n10 } = t10.payload;
      return __spreadProps(__spreadValues({}, e14), { selectedRange: e14.selectedRange.map((e15) => e15 && e15.clone().locale(n10)), viewDates: [e14.viewDates[0].clone().locale(n10), e14.viewDates[1].clone().locale(n10)] });
    }
    default:
      return e14;
  }
};
const H_ = { "last-week": (e14, t10) => ({ label: e14, viewMode: "days", getValue: () => [t10().subtract(7, "d").startOf("w"), t10().subtract(7, "d").endOf("w")] }), "last-month": (e14, t10) => ({ label: e14, viewMode: "months", getValue: () => [t10().subtract(1, "M").startOf("M"), t10().subtract(1, "M").endOf("M")] }), "last-year": (e14, t10) => ({ label: e14, viewMode: "years", getValue: () => [t10().subtract(1, "y").startOf("y"), t10().subtract(1, "y").endOf("y")] }), "last-week-to-date": (e14, t10) => ({ label: e14, viewMode: "days", getValue: () => [t10().subtract(7, "d"), t10()] }), "last-month-to-date": (e14, t10) => ({ label: e14, viewMode: "months", getValue: () => [t10().subtract(1, "M"), t10()] }), "last-year-to-date": (e14, t10) => ({ label: e14, viewMode: "years", getValue: () => [t10().subtract(1, "y"), t10()] }), "week-to-date": (e14, t10) => ({ label: e14, viewMode: "days", getValue: () => [t10().startOf("week"), t10()] }), "month-to-date": (e14, t10) => ({ label: e14, viewMode: "months", getValue: () => [t10().startOf("month"), t10()] }), "year-to-date": (e14, t10) => ({ label: e14, viewMode: "years", getValue: () => [t10().startOf("year"), t10()] }) };
const [I_, __, V_] = Dp("gc-date-range-aside");
const [R_] = V_("item");
const A_ = ({ shortcut: e14, dataAid: t10, onShortcutClick: n10 }) => {
  const r10 = { text: e14.label, size: "small", block: true, accent: "full", customCSS: R_, dataAid: t10 && `${t10}_shortcut`, onClick: n10(e14.getValue) };
  return tp.createElement(qm, __spreadValues({}, r10));
};
const [O_] = V_("header");
const [B_] = V_("body");
const [z_] = V_("title");
const [$_] = V_("list");
const [W_] = V_("scroll");
const j_ = { days: { prev: "time", next: "months" }, months: { prev: "days", next: "years" }, years: { prev: "months", next: "time" }, time: { prev: "years", next: "days" } };
const Z_ = (e14, t10, n10) => {
  if (!n10.length) return e14;
  let r10 = e14;
  do {
    r10 = j_[r10][t10];
  } while (r10 !== e14 && !n10.includes(r10));
  return r10;
};
const G_ = (e14) => {
  const { localMoment: t10, shortcuts: n10, currentView: r10, onShortcutClick: o10, onViewChange: a10, textShortcutsList: i10, textModeDaily: s10, textModeMonthly: l10, textModeYearly: c10, textModeTime: u10, dateModesOnly: d10, simplified: p10, dataAid: m10 } = e14;
  const h10 = ep.useMemo(() => n10.map((e15) => "custom" === e15.type ? e15.shortcut : H_[e15.type](e15.label, t10)), [t10, n10]);
  const f10 = ep.useMemo(() => {
    const e15 = [];
    return h10.forEach((t11) => {
      e15.includes(t11.viewMode) || e15.push(t11.viewMode);
    }), d10 ? e15.filter((e16) => "time" !== e16) : e15;
  }, [h10, d10]);
  const g10 = ep.useMemo(() => h10.filter((e15) => e15.viewMode === r10), [r10, h10]);
  const y10 = ep.useMemo(() => ({ days: s10, months: l10, years: c10, time: u10 }), [s10, l10, u10, c10]);
  const v10 = { style: { container: { height: "100%" } }, direction: "vertical", autoHeight: true, autoHeightMax: "none", size: "small", viewCustomCSS: W_, color: "contrast" };
  const b10 = { isContrast: true, dataAid: m10, onNext: f10.length > 1 ? a10(Z_(r10, "next", f10)) : void 0, onPrev: f10.length > 1 ? a10(Z_(r10, "prev", f10)) : void 0, title: y10[r10] };
  ep.useEffect(() => {
    var _a2;
    f10.includes(r10) || ((_a2 = a10(Z_(r10, "next", f10))) == null ? void 0 : _a2());
  }, [r10, f10, a10]);
  const S10 = kp(I_, p10 && __("simple"));
  return p10 && !g10.length ? null : tp.createElement("div", { className: S10 }, tp.createElement("div", { className: O_ }, tp.createElement(PI, __spreadValues({}, b10))), g10.length > 0 && tp.createElement("div", { className: B_ }, tp.createElement("div", { className: z_, "data-aid": m10 && `${m10}_shortcuts-title` }, i10), tp.createElement("div", { className: $_ }, tp.createElement(bF, __spreadValues({}, v10), g10.map((e15, t11) => tp.createElement(A_, { key: `${e15.label}_${t11}`, shortcut: e15, onShortcutClick: o10, dataAid: m10 }))))));
};
const U_ = { menuAlign: "left", daysViewHeaderFormat: "MMMM YYYY", strictParsing: true, block: false, viewMode: "days", disabled: false, dropup: false, invalid: false, isValidDate: () => true, rounded: false, size: "default", locale: "en", availableYears: [cI - 200, cI + 200], simplified: false, icon: nf(Lh), textModeYearly: "Annually", textModeDaily: "Daily", textModeMonthly: "Monthly", textShortcutsList: "Common Ranges", placeholderDateStart: "Start", placeholderDateEnd: "End", textBack: "Back to Calendar" };
const [q_, , Y_] = Dp("gc-date-range");
const [K_] = Y_("main");
const [X_] = Y_("aside");
const J_ = (e14) => {
  const { shortcuts: t10, id: n10, dataAid: r10, invalid: o10, menuAlign: a10, placeholderDateStart: i10, placeholderDateEnd: s10, size: l10, block: c10, width: u10, rounded: d10, disabled: p10, daysViewHeaderFormat: m10, viewMode: h10, dropup: f10, customCSS: g10, menuCustomCSS: y10, value: v10, availableYears: b10, icon: S10, textBack: C10, isValidDate: x10, simplified: w10, textShortcutsList: T10, textModeDaily: E10, textModeMonthly: F10, textModeYearly: M10, onViewModeChange: k10, onChange: P10, locale: N10, valueFormat: D10, strictParsing: L10, titleToggle: H10 } = e14;
  const I10 = ep.useCallback((e15, t11) => sI(e15, t11, L10).locale(N10), [N10, L10]);
  const { dateFormat: _10, monthYearOrder: V10 } = ep.useMemo(() => {
    const t11 = e14.dateFormat || I10().localeData().longDateFormat("L");
    return { dateFormat: t11, monthYearOrder: e14.monthYearOrder || gI(t11) };
  }, [e14.dateFormat, e14.monthYearOrder, I10]);
  const [R10, A10] = ep.useReducer(L_, { props: e14, localMoment: I10, dateFormat: _10 }, D_);
  const { currentView: O10, selectedRange: B10, viewDates: z10, quickSelection: $10, viewSection: W10 } = R10;
  const j10 = void 0 !== v10;
  const Z10 = (e15) => {
    if (j10) {
      const t11 = L_(R10, e15);
      P10 == null ? void 0 : P10(t11.selectedRange, O10);
    } else A10(e15);
  };
  const G10 = ep.useRef(false);
  let U10 = w10;
  const q10 = (() => {
    const [e15, t11] = ep.useState({ width: void 0, height: void 0 });
    return ep.useEffect(() => {
      const e16 = () => {
        t11({ width: window.innerWidth, height: window.innerHeight });
      };
      return window.addEventListener("resize", e16), e16(), () => window.removeEventListener("resize", e16);
    }, []), e15;
  })();
  q10.width && q10.width <= 812 && (U10 = true), ep.useEffect(() => {
    G10.current && !j10 && (P10 == null ? void 0 : P10(B10, O10));
  }, [B10]), ep.useEffect(() => {
    G10.current && (k10 == null ? void 0 : k10(O10));
  }, [O10]), ep.useEffect(() => {
    G10.current && v10 && A10(F_("SET_VALUE", { value: v10, localMoment: I10, format: D10 || _10, simplified: U10 }));
  }, [v10]), ep.useEffect(() => {
    G10.current && A10(F_("SET_VIEW", { viewMode: h10, localMoment: I10, simplified: U10 }));
  }, [h10]), ep.useEffect(() => {
    G10.current && A10(F_("CHANGE_LOCALE", { locale: N10 }));
  }, [N10]), ep.useEffect(() => {
    G10.current = true;
  }, []);
  const Y10 = (e15) => (t11, n11) => () => {
    A10(F_("SET_VIEW_DATE", { type: t11, value: n11, calendarIndex: e15 }));
  };
  const K10 = (e15) => (t11, n11, r11) => () => {
    A10(F_("ADVANCE_VIEW_DATE", { operation: t11, amount: n11, unit: r11, calendarIndex: e15 }));
  };
  const X10 = (e15) => () => {
    A10(F_("SET_VIEW", { viewMode: e15, localMoment: I10, simplified: U10 }));
  };
  const J10 = { type: "date-range", dataAid: r10, textBack: C10, viewMode: O10, daysViewHeaderFormat: m10, selectedDate: B10, isValidDate: x10, availableYears: b10, setView: X10, monthYearOrder: V10, toggleQuickSelection: () => {
    A10(F_("TOGGLE_QUICK_SELECTION"));
  }, quickSelection: $10, viewSection: W10, toggleViewSelection: (e15) => () => {
    A10(F_("TOGGLE_VIEW_SELECTION", { view: e15 }));
  } };
  const Q10 = (e15) => {
    return { viewDate: z10[e15], onDateClick: (t11 = e15, (e16) => () => {
      Z10(F_("UPDATE_SELECTED_DATE", { params: e16, calendarIndex: t11, simplified: U10 }));
    }), advanceViewDate: K10(e15), setViewDate: Y10(e15), hideHeader: !U10 && $10 && 1 === e15 };
    var t11;
  };
  const ee2 = { onShortcutClick: (e15) => () => {
    Z10(F_("SELECT_SHORTCUT", { value: e15(I10().toDate(), { firstDayOfWeek: I10().localeData().firstDayOfWeek() }), localMoment: I10, format: D10 || _10, simplified: U10 }));
  }, currentView: O10, onViewChange: X10, textModeDaily: E10, localMoment: I10, textModeMonthly: F10, textModeYearly: M10, textModeTime: "", dateModesOnly: true, simplified: U10, textShortcutsList: T10, dataAid: r10 };
  const te2 = { dataAid: r10 && `${r10}_dropdown`, id: n10, invalid: o10, dropup: f10, customCSS: g10, size: l10, block: c10, width: u10, rounded: d10, disabled: p10, menuAlign: a10, content: tp.createElement("div", { className: q_, "data-aid": r10 }, tp.createElement("div", { className: K_ }, !U10 && tp.createElement(S_, __spreadValues(__spreadValues({}, J10), Q10(0))), tp.createElement(S_, __spreadValues(__spreadValues({}, J10), Q10(1)))), t10 && t10.length > 0 && tp.createElement("div", { className: X_ }, tp.createElement(G_, __spreadProps(__spreadValues({}, ee2), { shortcuts: t10 })))), onToggle: (t11) => {
    var _a2;
    (_a2 = e14.onToggle) == null ? void 0 : _a2.call(e14, t11, B10);
  }, menuWidth: "auto", menuCustomCSS: y10, text: `${B10[0] ? B10[0].format(_10) : i10} - ${B10[1] ? B10[1].format(_10) : s10}`, customScroll: true, chevronIcon: S10, title: H10 };
  return tp.createElement(UF, __spreadValues({}, te2));
};
J_.defaultProps = U_;
const [Q_, eV, tV] = Dp("gc-alert");
const [nV] = tV("main");
const [rV] = tV("icon");
const [oV] = tV("title");
const [aV] = tV("actions");
const [iV] = tV("details");
const sV = (e14) => {
  const { level: t10 = "info", size: n10 = "default", textExpand: r10 = "Show Details", textCollapse: o10 = "Hide Details", textClose: a10 = "Close", defaultExpanded: i10 = false, icon: s10, title: l10, details: c10, customCSS: u10, onClose: d10, id: p10, dataAid: m10 } = e14;
  const [h10, f10] = ep.useState(i10 && c10);
  const g10 = rf(oh);
  const y10 = rf(oh, { rotate: "180" });
  const v10 = rf(xh);
  const b10 = kp(Q_, u10, { [eV(`level-${t10}`)]: "info" !== t10, [eV(`size-${n10}`)]: "default" !== n10 });
  const S10 = { type: "button", accent: "none", text: h10 ? o10 : r10, title: h10 ? o10 : r10, textAlign: "center", level: t10, onClick: () => f10(!h10) };
  const C10 = { type: "button", text: a10, title: a10, accent: "full", level: t10, onClick: d10 };
  const x10 = { size: "small", customCSS: aV, items: [c10 && S10, d10 && C10] };
  const w10 = c10 || d10;
  return w10 && "small" === n10 && (S10.text = void 0, S10.icon = h10 ? y10 : g10, S10.accent = "icon", S10.background = "transparent", C10.text = void 0, C10.accent = "icon", C10.icon = v10, C10.background = "transparent"), tp.createElement("div", { className: b10, id: p10, "data-aid": m10 }, tp.createElement("div", { className: nV }, s10 && tp.createElement(Fm, { icon: s10, customCSS: rV }), tp.createElement("h4", { className: oV }, l10), w10 && tp.createElement(sM, __spreadValues({}, x10))), h10 && c10 && tp.createElement("div", { className: iV }, c10));
};
var lV = { exports: {} };
var cV = "object" == typeof Reflect ? Reflect : null;
var uV = cV && "function" == typeof cV.apply ? cV.apply : function(e14, t10, n10) {
  return Function.prototype.apply.call(e14, t10, n10);
};
var dV;
dV = cV && "function" == typeof cV.ownKeys ? cV.ownKeys : Object.getOwnPropertySymbols ? function(e14) {
  return Object.getOwnPropertyNames(e14).concat(Object.getOwnPropertySymbols(e14));
} : function(e14) {
  return Object.getOwnPropertyNames(e14);
};
var pV = Number.isNaN || function(e14) {
  return e14 != e14;
};
function mV() {
  mV.init.call(this);
}
lV.exports = mV, lV.exports.once = function(e14, t10) {
  return new Promise(function(n10, r10) {
    function o10(n11) {
      e14.removeListener(t10, a10), r10(n11);
    }
    function a10() {
      "function" == typeof e14.removeListener && e14.removeListener("error", o10), n10([].slice.call(arguments));
    }
    wV(e14, t10, a10, { once: true }), "error" !== t10 && function(e15, t11, n11) {
      "function" == typeof e15.on && wV(e15, "error", t11, n11);
    }(e14, o10, { once: true });
  });
}, mV.EventEmitter = mV, mV.prototype._events = void 0, mV.prototype._eventsCount = 0, mV.prototype._maxListeners = void 0;
var hV = 10;
function fV(e14) {
  if ("function" != typeof e14) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e14);
}
function gV(e14) {
  return void 0 === e14._maxListeners ? mV.defaultMaxListeners : e14._maxListeners;
}
function yV(e14, t10, n10, r10) {
  var o10;
  var a10;
  var i10;
  if (fV(n10), void 0 === (a10 = e14._events) ? (a10 = e14._events = /* @__PURE__ */ Object.create(null), e14._eventsCount = 0) : (void 0 !== a10.newListener && (e14.emit("newListener", t10, n10.listener ? n10.listener : n10), a10 = e14._events), i10 = a10[t10]), void 0 === i10) i10 = a10[t10] = n10, ++e14._eventsCount;
  else if ("function" == typeof i10 ? i10 = a10[t10] = r10 ? [n10, i10] : [i10, n10] : r10 ? i10.unshift(n10) : i10.push(n10), (o10 = gV(e14)) > 0 && i10.length > o10 && !i10.warned) {
    i10.warned = true;
    var s10 = new Error("Possible EventEmitter memory leak detected. " + i10.length + " " + String(t10) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    s10.name = "MaxListenersExceededWarning", s10.emitter = e14, s10.type = t10, s10.count = i10.length, function(e15) {
      console && console.warn && console.warn(e15);
    }(s10);
  }
  return e14;
}
function vV() {
  if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = true, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function bV(e14, t10, n10) {
  var r10 = { fired: false, wrapFn: void 0, target: e14, type: t10, listener: n10 };
  var o10 = vV.bind(r10);
  return o10.listener = n10, r10.wrapFn = o10, o10;
}
function SV(e14, t10, n10) {
  var r10 = e14._events;
  if (void 0 === r10) return [];
  var o10 = r10[t10];
  return void 0 === o10 ? [] : "function" == typeof o10 ? n10 ? [o10.listener || o10] : [o10] : n10 ? function(e15) {
    var t11 = new Array(e15.length);
    for (var n11 = 0; n11 < t11.length; ++n11) t11[n11] = e15[n11].listener || e15[n11];
    return t11;
  }(o10) : xV(o10, o10.length);
}
function CV(e14) {
  var t10 = this._events;
  if (void 0 !== t10) {
    var n10 = t10[e14];
    if ("function" == typeof n10) return 1;
    if (void 0 !== n10) return n10.length;
  }
  return 0;
}
function xV(e14, t10) {
  var n10 = new Array(t10);
  for (var r10 = 0; r10 < t10; ++r10) n10[r10] = e14[r10];
  return n10;
}
function wV(e14, t10, n10, r10) {
  if ("function" == typeof e14.on) r10.once ? e14.once(t10, n10) : e14.on(t10, n10);
  else {
    if ("function" != typeof e14.addEventListener) throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e14);
    e14.addEventListener(t10, function o10(a10) {
      r10.once && e14.removeEventListener(t10, o10), n10(a10);
    });
  }
}
Object.defineProperty(mV, "defaultMaxListeners", { enumerable: true, get: function() {
  return hV;
}, set: function(e14) {
  if ("number" != typeof e14 || e14 < 0 || pV(e14)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e14 + ".");
  hV = e14;
} }), mV.init = function() {
  void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
}, mV.prototype.setMaxListeners = function(e14) {
  if ("number" != typeof e14 || e14 < 0 || pV(e14)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e14 + ".");
  return this._maxListeners = e14, this;
}, mV.prototype.getMaxListeners = function() {
  return gV(this);
}, mV.prototype.emit = function(e14) {
  var t10 = [];
  for (var n10 = 1; n10 < arguments.length; n10++) t10.push(arguments[n10]);
  var r10 = "error" === e14;
  var o10 = this._events;
  if (void 0 !== o10) r10 = r10 && void 0 === o10.error;
  else if (!r10) return false;
  if (r10) {
    var a10;
    if (t10.length > 0 && (a10 = t10[0]), a10 instanceof Error) throw a10;
    var i10 = new Error("Unhandled error." + (a10 ? " (" + a10.message + ")" : ""));
    throw i10.context = a10, i10;
  }
  var s10 = o10[e14];
  if (void 0 === s10) return false;
  if ("function" == typeof s10) uV(s10, this, t10);
  else {
    var l10 = s10.length;
    var c10 = xV(s10, l10);
    for (n10 = 0; n10 < l10; ++n10) uV(c10[n10], this, t10);
  }
  return true;
}, mV.prototype.addListener = function(e14, t10) {
  return yV(this, e14, t10, false);
}, mV.prototype.on = mV.prototype.addListener, mV.prototype.prependListener = function(e14, t10) {
  return yV(this, e14, t10, true);
}, mV.prototype.once = function(e14, t10) {
  return fV(t10), this.on(e14, bV(this, e14, t10)), this;
}, mV.prototype.prependOnceListener = function(e14, t10) {
  return fV(t10), this.prependListener(e14, bV(this, e14, t10)), this;
}, mV.prototype.removeListener = function(e14, t10) {
  var n10, r10, o10, a10, i10;
  if (fV(t10), void 0 === (r10 = this._events)) return this;
  if (void 0 === (n10 = r10[e14])) return this;
  if (n10 === t10 || n10.listener === t10) 0 == --this._eventsCount ? this._events = /* @__PURE__ */ Object.create(null) : (delete r10[e14], r10.removeListener && this.emit("removeListener", e14, n10.listener || t10));
  else if ("function" != typeof n10) {
    for (o10 = -1, a10 = n10.length - 1; a10 >= 0; a10--) if (n10[a10] === t10 || n10[a10].listener === t10) {
      i10 = n10[a10].listener, o10 = a10;
      break;
    }
    if (o10 < 0) return this;
    0 === o10 ? n10.shift() : function(e15, t11) {
      for (; t11 + 1 < e15.length; t11++) e15[t11] = e15[t11 + 1];
      e15.pop();
    }(n10, o10), 1 === n10.length && (r10[e14] = n10[0]), void 0 !== r10.removeListener && this.emit("removeListener", e14, i10 || t10);
  }
  return this;
}, mV.prototype.off = mV.prototype.removeListener, mV.prototype.removeAllListeners = function(e14) {
  var t10, n10, r10;
  if (void 0 === (n10 = this._events)) return this;
  if (void 0 === n10.removeListener) return 0 === arguments.length ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : void 0 !== n10[e14] && (0 == --this._eventsCount ? this._events = /* @__PURE__ */ Object.create(null) : delete n10[e14]), this;
  if (0 === arguments.length) {
    var o10 = Object.keys(n10);
    var a10;
    for (r10 = 0; r10 < o10.length; ++r10) "removeListener" !== (a10 = o10[r10]) && this.removeAllListeners(a10);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if ("function" == typeof (t10 = n10[e14])) this.removeListener(e14, t10);
  else if (void 0 !== t10) for (r10 = t10.length - 1; r10 >= 0; r10--) this.removeListener(e14, t10[r10]);
  return this;
}, mV.prototype.listeners = function(e14) {
  return SV(this, e14, true);
}, mV.prototype.rawListeners = function(e14) {
  return SV(this, e14, false);
}, mV.listenerCount = function(e14, t10) {
  return "function" == typeof e14.listenerCount ? e14.listenerCount(t10) : CV.call(e14, t10);
}, mV.prototype.listenerCount = CV, mV.prototype.eventNames = function() {
  return this._eventsCount > 0 ? dV(this._events) : [];
};
var TV = lV.exports;
class EV extends ep.Component {
  constructor() {
    super(...arguments), this.onKeyUp = (e14) => e14.which === Ip && this.advance(), this.advance = () => {
      const { className: e14, waitingTime: t10 } = this.props;
      clearTimeout(this._timerId), this._container.classList.remove(e14), this._timerId = window.setTimeout(() => {
        this._container.classList.add(e14);
      }, t10);
    }, this.reset = () => {
      this._container.classList.add(this.props.className);
    };
  }
  componentDidMount() {
    const { props: { className: e14, getContainer: t10 }, context: { API: n10 } } = this;
    n10.current.focusTimer ? console.warn("Repeated <FocusTimer/> mounting") : (n10.current.focusTimer = { advance: this.advance, reset: this.reset }, this._container = t10(), window.addEventListener("keyup", this.onKeyUp), this._container.classList.add(e14));
  }
  componentWillUnmount() {
    const { props: { className: e14 }, context: { API: t10 } } = this;
    t10.current.focusTimer && t10.current.focusTimer.advance === this.advance && (window.removeEventListener("keyup", this.onKeyUp), this._container.classList.remove(e14), clearTimeout(this._timerId));
  }
  render() {
    return null;
  }
}
EV.contextType = Sm, EV.defaultProps = { waitingTime: 3e3, className: "gc-no-focus-effect", getContainer: () => document.body };
const [FV, MV] = Dp("gc-grid");
class kV extends ep.Component {
  render() {
    const { template: e14, customCSS: t10, children: n10 } = this.props;
    const r10 = kp(FV, MV(e14), t10);
    return ep.createElement("div", { className: r10 }, n10);
  }
}
const [PV, NV] = Dp("gc-grid-item");
class DV extends ep.Component {
  render() {
    const { area: e14, customCSS: t10, children: n10 } = this.props;
    const r10 = kp(PV, t10, NV(e14));
    return ep.createElement("div", { className: r10 }, n10);
  }
}
const [LV] = Dp("gc-app");
class HV extends tp.Component {
  constructor(e14) {
    super(e14), this._root = null, this._rootId = `${this.props.rootId}-app`, this._API = new fm(this.props.rootId), this._eventEmitter = new TV.EventEmitter(), this.getRootElement = () => (this._root || (this._root = document.getElementById(this._rootId)), this._root || document.body), this.addEventListener = (e15, t10) => {
      this._eventEmitter.on(e15, t10);
    }, this.removeEventListener = (e15, t10) => {
      this._eventEmitter.off(e15, t10);
    }, this.onPointerEvent = (e15) => {
      this._eventEmitter.emit(e15.type, e15);
    }, this.onUpdateTheme = (e15) => {
      const t10 = "core-ui-simple-theme" === e15.type ? (({ name: e16, basedOn: t11, accent: n10, accentText: r10, borderRadius: o10, textFamily: a10 }) => {
        const i10 = __spreadProps(__spreadValues({}, bm[t11]), { name: e16, accent: n10, accentText: n10 });
        return r10 && (i10.accentText = r10), a10 && (i10.textFamily = a10), o10 && (i10.borderRadius = o10), i10;
      })(e15) : e15;
      this.setState({ theme: t10, cssTheme: vm(t10) });
    }, this.onResetTheme = () => {
      this.setState({ theme: ym(), cssTheme: vm(ym()) });
    }, this.state = HV.getDerivedStateFromProps(e14);
  }
  static getDerivedStateFromProps(e14) {
    const { theme: t10, useInlineThemeCSS: n10 } = e14;
    const r10 = t10 != null ? t10 : ym();
    return { theme: r10, cssTheme: n10 ? vm(r10) : void 0 };
  }
  componentWillUnmount() {
    this._API.destroy();
  }
  render() {
    const { children: e14, focusWaitingTime: t10, withFocusTimer: n10, gridTemplate: r10, role: o10, customCSS: a10 } = this.props;
    const { theme: i10, cssTheme: s10 } = this.state;
    const l10 = { root: { addEventListener: this.addEventListener, removeEventListener: this.removeEventListener, getElement: this.getRootElement }, theme: { current: i10, reset: this.onResetTheme, update: this.onUpdateTheme }, API: this._API };
    const c10 = { onMouseDown: this.onPointerEvent, onMouseUp: this.onPointerEvent, onClick: this.onPointerEvent, onTouchStart: this.onPointerEvent, onTouchEnd: this.onPointerEvent };
    const u10 = { waitingTime: t10, getContainer: this.getRootElement };
    const d10 = kp(LV, a10);
    return tp.createElement(Sm.Provider, { value: l10 }, n10 && tp.createElement(EV, __spreadValues({}, u10)), tp.createElement("div", __spreadProps(__spreadValues({}, c10), { className: d10, id: this._rootId, role: o10, style: s10 }), r10 ? tp.createElement(kV, { template: r10 }, e14) : e14));
  }
}
function IV(e14, t10) {
  const n10 = e14;
  return n10.type = t10, n10.match = (e15) => e15.type === t10, n10.toString = () => `[Action type=${t10}]`, n10;
}
function _V(e14, t10, n10) {
  let r10;
  return r10 = n10 && t10 ? (r11, o10) => ({ type: e14, payload: t10(r11), meta: n10(o10) }) : t10 ? (n11, r11) => __spreadValues({ type: e14, payload: t10(n11) }, He(r11) && { meta: r11 }) : n10 ? (t11, r11) => ({ type: e14, meta: n10(r11) }) : (t11, n11) => {
    const r11 = { type: e14 };
    return He(t11) && (r11.payload = t11), He(n11) && (r11.meta = n11), r11;
  }, IV(r10, e14);
}
HV.defaultProps = { withFocusTimer: true, focusWaitingTime: 3e3, useInlineThemeCSS: true };
const VV = { open: _V("@core/dialogs/open", ({ name: e14, containerId: t10 = "default" }) => ({ name: e14, containerId: t10 })), close: _V("@core/dialogs/close", ({ containerId: e14 = "default" }) => ({ containerId: e14 })) };
var RV = { exports: {} };
!function(e14, t10) {
  function n10(e15) {
    return "object" != typeof e15 || "toString" in e15 ? e15 : Object.prototype.toString.call(e15).slice(8, -1);
  }
  Object.defineProperty(t10, "__esModule", { value: true });
  var r10 = "object" == typeof process && true;
  function o10(e15, t11) {
    if (!e15) {
      if (r10) throw new Error("Invariant failed");
      throw new Error(t11());
    }
  }
  t10.invariant = o10;
  var a10 = Object.prototype.hasOwnProperty;
  var i10 = Array.prototype.splice;
  var s10 = Object.prototype.toString;
  function l10(e15) {
    return s10.call(e15).slice(8, -1);
  }
  var c10 = Object.assign || function(e15, t11) {
    return u10(t11).forEach(function(n11) {
      a10.call(t11, n11) && (e15[n11] = t11[n11]);
    }), e15;
  };
  var u10 = "function" == typeof Object.getOwnPropertySymbols ? function(e15) {
    return Object.keys(e15).concat(Object.getOwnPropertySymbols(e15));
  } : function(e15) {
    return Object.keys(e15);
  };
  function d10(e15) {
    return Array.isArray(e15) ? c10(e15.constructor(e15.length), e15) : "Map" === l10(e15) ? new Map(e15) : "Set" === l10(e15) ? new Set(e15) : e15 && "object" == typeof e15 ? c10(Object.create(Object.getPrototypeOf(e15)), e15) : e15;
  }
  var p10 = function() {
    function e15() {
      this.commands = c10({}, m10), this.update = this.update.bind(this), this.update.extend = this.extend = this.extend.bind(this), this.update.isEquals = function(e16, t11) {
        return e16 === t11;
      }, this.update.newContext = function() {
        return new e15().update;
      };
    }
    return Object.defineProperty(e15.prototype, "isEquals", { get: function() {
      return this.update.isEquals;
    }, set: function(e16) {
      this.update.isEquals = e16;
    }, enumerable: true, configurable: true }), e15.prototype.extend = function(e16, t11) {
      this.commands[e16] = t11;
    }, e15.prototype.update = function(e16, t11) {
      var n11 = this;
      var r11 = "function" == typeof t11 ? { $apply: t11 } : t11;
      Array.isArray(e16) && Array.isArray(r11) || o10(!Array.isArray(r11), function() {
        return "update(): You provided an invalid spec to update(). The spec may not contain an array except as the value of $set, $push, $unshift, $splice or any custom command allowing an array value.";
      }), o10("object" == typeof r11 && null !== r11, function() {
        return "update(): You provided an invalid spec to update(). The spec and every included key path must be plain objects containing one of the following commands: " + Object.keys(n11.commands).join(", ") + ".";
      });
      var i11 = e16;
      return u10(r11).forEach(function(t12) {
        if (a10.call(n11.commands, t12)) {
          var o11 = e16 === i11;
          i11 = n11.commands[t12](r11[t12], i11, r11, e16), o11 && n11.isEquals(i11, e16) && (i11 = e16);
        } else {
          var s11 = "Map" === l10(e16) ? n11.update(e16.get(t12), r11[t12]) : n11.update(e16[t12], r11[t12]);
          var c11 = "Map" === l10(i11) ? i11.get(t12) : i11[t12];
          n11.isEquals(s11, c11) && (void 0 !== s11 || a10.call(e16, t12)) || (i11 === e16 && (i11 = d10(e16)), "Map" === l10(i11) ? i11.set(t12, s11) : i11[t12] = s11);
        }
      }), i11;
    }, e15;
  }();
  t10.Context = p10;
  var m10 = { $push: function(e15, t11, n11) {
    return f10(t11, n11, "$push"), e15.length ? t11.concat(e15) : t11;
  }, $unshift: function(e15, t11, n11) {
    return f10(t11, n11, "$unshift"), e15.length ? e15.concat(t11) : t11;
  }, $splice: function(e15, t11, r11, a11) {
    return function(e16, t12) {
      o10(Array.isArray(e16), function() {
        return "Expected $splice target to be an array; got " + n10(e16);
      }), y10(t12.$splice);
    }(t11, r11), e15.forEach(function(e16) {
      y10(e16), t11 === a11 && e16.length && (t11 = d10(a11)), i10.apply(t11, e16);
    }), t11;
  }, $set: function(e15, t11, n11) {
    return function(e16) {
      o10(1 === Object.keys(e16).length, function() {
        return "Cannot have more than one key in an object with $set";
      });
    }(n11), e15;
  }, $toggle: function(e15, t11) {
    g10(e15, "$toggle");
    var n11 = e15.length ? d10(t11) : t11;
    return e15.forEach(function(e16) {
      n11[e16] = !t11[e16];
    }), n11;
  }, $unset: function(e15, t11, n11, r11) {
    return g10(e15, "$unset"), e15.forEach(function(e16) {
      Object.hasOwnProperty.call(t11, e16) && (t11 === r11 && (t11 = d10(r11)), delete t11[e16]);
    }), t11;
  }, $add: function(e15, t11, n11, r11) {
    return v10(t11, "$add"), g10(e15, "$add"), "Map" === l10(t11) ? e15.forEach(function(e16) {
      var n12 = e16[0], o11 = e16[1];
      t11 === r11 && t11.get(n12) !== o11 && (t11 = d10(r11)), t11.set(n12, o11);
    }) : e15.forEach(function(e16) {
      t11 !== r11 || t11.has(e16) || (t11 = d10(r11)), t11.add(e16);
    }), t11;
  }, $remove: function(e15, t11, n11, r11) {
    return v10(t11, "$remove"), g10(e15, "$remove"), e15.forEach(function(e16) {
      t11 === r11 && t11.has(e16) && (t11 = d10(r11)), t11.delete(e16);
    }), t11;
  }, $merge: function(e15, t11, r11, a11) {
    var i11, s11;
    return i11 = t11, o10((s11 = e15) && "object" == typeof s11, function() {
      return "update(): $merge expects a spec of type 'object'; got " + n10(s11);
    }), o10(i11 && "object" == typeof i11, function() {
      return "update(): $merge expects a target of type 'object'; got " + n10(i11);
    }), u10(e15).forEach(function(n11) {
      e15[n11] !== t11[n11] && (t11 === a11 && (t11 = d10(a11)), t11[n11] = e15[n11]);
    }), t11;
  }, $apply: function(e15, t11) {
    var r11;
    return o10("function" == typeof (r11 = e15), function() {
      return "update(): expected spec of $apply to be a function; got " + n10(r11) + ".";
    }), e15(t11);
  } };
  var h10 = new p10();
  function f10(e15, t11, r11) {
    o10(Array.isArray(e15), function() {
      return "update(): expected target of " + n10(r11) + " to be an array; got " + n10(e15) + ".";
    }), g10(t11[r11], r11);
  }
  function g10(e15, t11) {
    o10(Array.isArray(e15), function() {
      return "update(): expected spec of " + n10(t11) + " to be an array; got " + n10(e15) + ". Did you forget to wrap your parameter in an array?";
    });
  }
  function y10(e15) {
    o10(Array.isArray(e15), function() {
      return "update(): expected spec of $splice to be an array of arrays; got " + n10(e15) + ". Did you forget to wrap your parameters in an array?";
    });
  }
  function v10(e15, t11) {
    var r11 = l10(e15);
    o10("Map" === r11 || "Set" === r11, function() {
      return "update(): " + n10(t11) + " expects a target of type Set or Map; got " + n10(r11);
    });
  }
  t10.isEquals = h10.update.isEquals, t10.extend = h10.extend, t10.default = h10.update, t10.default.default = e14.exports = c10(t10.default, t10);
}(RV, RV.exports);
var AV = W(RV.exports);
var OV = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
!function(e14, t10) {
  (function() {
    var n10;
    var r10 = "Expected a function";
    var o10 = "__lodash_hash_undefined__";
    var a10 = "__lodash_placeholder__";
    var i10 = 16, s10 = 32, l10 = 64, c10 = 128, u10 = 256;
    var d10 = 1 / 0, p10 = 9007199254740991, m10 = NaN;
    var h10 = 4294967295;
    var f10 = [["ary", c10], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", i10], ["flip", 512], ["partial", s10], ["partialRight", l10], ["rearg", u10]];
    var g10 = "[object Arguments]", y10 = "[object Array]", v10 = "[object Boolean]", b10 = "[object Date]", S10 = "[object Error]", C10 = "[object Function]", x10 = "[object GeneratorFunction]", w10 = "[object Map]", T10 = "[object Number]", E10 = "[object Object]", F10 = "[object Promise]", M10 = "[object RegExp]", k10 = "[object Set]", P10 = "[object String]", N10 = "[object Symbol]", D10 = "[object WeakMap]";
    var L10 = "[object ArrayBuffer]", H10 = "[object DataView]", I10 = "[object Float32Array]", _10 = "[object Float64Array]", V10 = "[object Int8Array]", R10 = "[object Int16Array]", A10 = "[object Int32Array]", O10 = "[object Uint8Array]", B10 = "[object Uint8ClampedArray]", z10 = "[object Uint16Array]", W10 = "[object Uint32Array]";
    var j10 = /\b__p \+= '';/g, Z10 = /\b(__p \+=) '' \+/g, G10 = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    var U10 = /&(?:amp|lt|gt|quot|#39);/g, q10 = /[&<>"']/g, Y10 = RegExp(U10.source), K10 = RegExp(q10.source);
    var X10 = /<%-([\s\S]+?)%>/g, J10 = /<%([\s\S]+?)%>/g, Q10 = /<%=([\s\S]+?)%>/g;
    var ee2 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, te2 = /^\w*$/, ne2 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var re2 = /[\\^$.*+?()[\]{}|]/g, oe2 = RegExp(re2.source);
    var ae2 = /^\s+/;
    var ie2 = /\s/;
    var se2 = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, le2 = /\{\n\/\* \[wrapped with (.+)\] \*/, ce2 = /,? & /;
    var ue2 = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    var de2 = /[()=,{}\[\]\/\s]/;
    var pe2 = /\\(\\)?/g;
    var me2 = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    var he2 = /\w*$/;
    var fe2 = /^[-+]0x[0-9a-f]+$/i;
    var ge2 = /^0b[01]+$/i;
    var ye2 = /^\[object .+?Constructor\]$/;
    var ve2 = /^0o[0-7]+$/i;
    var be2 = /^(?:0|[1-9]\d*)$/;
    var Se2 = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    var Ce2 = /($^)/;
    var xe2 = /['\n\r\u2028\u2029\\]/g;
    var we2 = "\\ud800-\\udfff", Te2 = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff", Ee2 = "\\u2700-\\u27bf", Fe2 = "a-z\\xdf-\\xf6\\xf8-\\xff", Me2 = "A-Z\\xc0-\\xd6\\xd8-\\xde", ke2 = "\\ufe0e\\ufe0f", Pe2 = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000";
    var Ne2 = "['\u2019]", De2 = "[" + we2 + "]", Le2 = "[" + Pe2 + "]", He2 = "[" + Te2 + "]", Ie2 = "\\d+", _e2 = "[" + Ee2 + "]", Ve2 = "[" + Fe2 + "]", Re2 = "[^" + we2 + Pe2 + Ie2 + Ee2 + Fe2 + Me2 + "]", Ae2 = "\\ud83c[\\udffb-\\udfff]", Oe2 = "[^" + we2 + "]", Be2 = "(?:\\ud83c[\\udde6-\\uddff]){2}", ze2 = "[\\ud800-\\udbff][\\udc00-\\udfff]", $e2 = "[" + Me2 + "]", We2 = "\\u200d";
    var je2 = "(?:" + Ve2 + "|" + Re2 + ")", Ze2 = "(?:" + $e2 + "|" + Re2 + ")", Ge2 = "(?:['\u2019](?:d|ll|m|re|s|t|ve))?", Ue2 = "(?:['\u2019](?:D|LL|M|RE|S|T|VE))?", qe2 = "(?:" + He2 + "|" + Ae2 + ")?", Ye2 = "[" + ke2 + "]?", Ke2 = Ye2 + qe2 + ("(?:" + We2 + "(?:" + [Oe2, Be2, ze2].join("|") + ")" + Ye2 + qe2 + ")*"), Xe2 = "(?:" + [_e2, Be2, ze2].join("|") + ")" + Ke2, Je2 = "(?:" + [Oe2 + He2 + "?", He2, Be2, ze2, De2].join("|") + ")";
    var Qe2 = RegExp(Ne2, "g");
    var et2 = RegExp(He2, "g");
    var tt2 = RegExp(Ae2 + "(?=" + Ae2 + ")|" + Je2 + Ke2, "g");
    var nt2 = RegExp([$e2 + "?" + Ve2 + "+" + Ge2 + "(?=" + [Le2, $e2, "$"].join("|") + ")", Ze2 + "+" + Ue2 + "(?=" + [Le2, $e2 + je2, "$"].join("|") + ")", $e2 + "?" + je2 + "+" + Ge2, $e2 + "+" + Ue2, "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Ie2, Xe2].join("|"), "g");
    var rt2 = RegExp("[" + We2 + we2 + Te2 + ke2 + "]");
    var ot2 = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    var at2 = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"];
    var it2 = -1;
    var st2 = {};
    st2[I10] = st2[_10] = st2[V10] = st2[R10] = st2[A10] = st2[O10] = st2[B10] = st2[z10] = st2[W10] = true, st2[g10] = st2[y10] = st2[L10] = st2[v10] = st2[H10] = st2[b10] = st2[S10] = st2[C10] = st2[w10] = st2[T10] = st2[E10] = st2[M10] = st2[k10] = st2[P10] = st2[D10] = false;
    var lt2 = {};
    lt2[g10] = lt2[y10] = lt2[L10] = lt2[H10] = lt2[v10] = lt2[b10] = lt2[I10] = lt2[_10] = lt2[V10] = lt2[R10] = lt2[A10] = lt2[w10] = lt2[T10] = lt2[E10] = lt2[M10] = lt2[k10] = lt2[P10] = lt2[N10] = lt2[O10] = lt2[B10] = lt2[z10] = lt2[W10] = true, lt2[S10] = lt2[C10] = lt2[D10] = false;
    var ct2 = { "\\": "\\", "'": "'", "\n": "n", "\r": "r", "\u2028": "u2028", "\u2029": "u2029" };
    var ut2 = parseFloat, dt2 = parseInt;
    var pt2 = "object" == typeof $ && $ && $.Object === Object && $;
    var mt2 = "object" == typeof self && self && self.Object === Object && self;
    var ht2 = pt2 || mt2 || Function("return this")();
    var ft2 = t10 && !t10.nodeType && t10;
    var gt2 = ft2 && e14 && !e14.nodeType && e14;
    var yt2 = gt2 && gt2.exports === ft2;
    var vt2 = yt2 && pt2.process;
    var bt2 = function() {
      try {
        var e15 = gt2 && gt2.require && gt2.require("util").types;
        return e15 || vt2 && vt2.binding && vt2.binding("util");
      } catch (e16) {
      }
    }();
    var St2 = bt2 && bt2.isArrayBuffer, Ct2 = bt2 && bt2.isDate, xt2 = bt2 && bt2.isMap, wt2 = bt2 && bt2.isRegExp, Tt2 = bt2 && bt2.isSet, Et2 = bt2 && bt2.isTypedArray;
    function Ft2(e15, t11, n11) {
      switch (n11.length) {
        case 0:
          return e15.call(t11);
        case 1:
          return e15.call(t11, n11[0]);
        case 2:
          return e15.call(t11, n11[0], n11[1]);
        case 3:
          return e15.call(t11, n11[0], n11[1], n11[2]);
      }
      return e15.apply(t11, n11);
    }
    function Mt2(e15, t11, n11, r11) {
      var o11 = -1, a11 = null == e15 ? 0 : e15.length;
      for (; ++o11 < a11; ) {
        var i11 = e15[o11];
        t11(r11, i11, n11(i11), e15);
      }
      return r11;
    }
    function kt2(e15, t11) {
      var n11 = -1, r11 = null == e15 ? 0 : e15.length;
      for (; ++n11 < r11 && false !== t11(e15[n11], n11, e15); ) ;
      return e15;
    }
    function Pt2(e15, t11) {
      var n11 = null == e15 ? 0 : e15.length;
      for (; n11-- && false !== t11(e15[n11], n11, e15); ) ;
      return e15;
    }
    function Nt2(e15, t11) {
      var n11 = -1, r11 = null == e15 ? 0 : e15.length;
      for (; ++n11 < r11; ) if (!t11(e15[n11], n11, e15)) return false;
      return true;
    }
    function Dt2(e15, t11) {
      var n11 = -1, r11 = null == e15 ? 0 : e15.length, o11 = 0, a11 = [];
      for (; ++n11 < r11; ) {
        var i11 = e15[n11];
        t11(i11, n11, e15) && (a11[o11++] = i11);
      }
      return a11;
    }
    function Lt2(e15, t11) {
      return !!(null == e15 ? 0 : e15.length) && $t2(e15, t11, 0) > -1;
    }
    function Ht2(e15, t11, n11) {
      var r11 = -1, o11 = null == e15 ? 0 : e15.length;
      for (; ++r11 < o11; ) if (n11(t11, e15[r11])) return true;
      return false;
    }
    function It2(e15, t11) {
      var n11 = -1, r11 = null == e15 ? 0 : e15.length, o11 = Array(r11);
      for (; ++n11 < r11; ) o11[n11] = t11(e15[n11], n11, e15);
      return o11;
    }
    function _t2(e15, t11) {
      var n11 = -1, r11 = t11.length, o11 = e15.length;
      for (; ++n11 < r11; ) e15[o11 + n11] = t11[n11];
      return e15;
    }
    function Vt2(e15, t11, n11, r11) {
      var o11 = -1, a11 = null == e15 ? 0 : e15.length;
      for (r11 && a11 && (n11 = e15[++o11]); ++o11 < a11; ) n11 = t11(n11, e15[o11], o11, e15);
      return n11;
    }
    function Rt2(e15, t11, n11, r11) {
      var o11 = null == e15 ? 0 : e15.length;
      for (r11 && o11 && (n11 = e15[--o11]); o11--; ) n11 = t11(n11, e15[o11], o11, e15);
      return n11;
    }
    function At2(e15, t11) {
      var n11 = -1, r11 = null == e15 ? 0 : e15.length;
      for (; ++n11 < r11; ) if (t11(e15[n11], n11, e15)) return true;
      return false;
    }
    var Ot2 = Gt2("length");
    function Bt2(e15, t11, n11) {
      var r11;
      return n11(e15, function(e16, n12, o11) {
        if (t11(e16, n12, o11)) return r11 = n12, false;
      }), r11;
    }
    function zt2(e15, t11, n11, r11) {
      var o11 = e15.length, a11 = n11 + (r11 ? 1 : -1);
      for (; r11 ? a11-- : ++a11 < o11; ) if (t11(e15[a11], a11, e15)) return a11;
      return -1;
    }
    function $t2(e15, t11, n11) {
      return t11 == t11 ? function(e16, t12, n12) {
        var r11 = n12 - 1, o11 = e16.length;
        for (; ++r11 < o11; ) if (e16[r11] === t12) return r11;
        return -1;
      }(e15, t11, n11) : zt2(e15, jt2, n11);
    }
    function Wt2(e15, t11, n11, r11) {
      var o11 = n11 - 1, a11 = e15.length;
      for (; ++o11 < a11; ) if (r11(e15[o11], t11)) return o11;
      return -1;
    }
    function jt2(e15) {
      return e15 != e15;
    }
    function Zt2(e15, t11) {
      var n11 = null == e15 ? 0 : e15.length;
      return n11 ? Yt2(e15, t11) / n11 : m10;
    }
    function Gt2(e15) {
      return function(t11) {
        return null == t11 ? n10 : t11[e15];
      };
    }
    function Ut2(e15) {
      return function(t11) {
        return null == e15 ? n10 : e15[t11];
      };
    }
    function qt2(e15, t11, n11, r11, o11) {
      return o11(e15, function(e16, o12, a11) {
        n11 = r11 ? (r11 = false, e16) : t11(n11, e16, o12, a11);
      }), n11;
    }
    function Yt2(e15, t11) {
      var r11, o11 = -1, a11 = e15.length;
      for (; ++o11 < a11; ) {
        var i11 = t11(e15[o11]);
        i11 !== n10 && (r11 = r11 === n10 ? i11 : r11 + i11);
      }
      return r11;
    }
    function Kt2(e15, t11) {
      var n11 = -1, r11 = Array(e15);
      for (; ++n11 < e15; ) r11[n11] = t11(n11);
      return r11;
    }
    function Xt2(e15) {
      return e15 ? e15.slice(0, fn2(e15) + 1).replace(ae2, "") : e15;
    }
    function Jt2(e15) {
      return function(t11) {
        return e15(t11);
      };
    }
    function Qt2(e15, t11) {
      return It2(t11, function(t12) {
        return e15[t12];
      });
    }
    function en2(e15, t11) {
      return e15.has(t11);
    }
    function tn2(e15, t11) {
      var n11 = -1, r11 = e15.length;
      for (; ++n11 < r11 && $t2(t11, e15[n11], 0) > -1; ) ;
      return n11;
    }
    function nn2(e15, t11) {
      var n11 = e15.length;
      for (; n11-- && $t2(t11, e15[n11], 0) > -1; ) ;
      return n11;
    }
    var rn2 = Ut2({ "\xC0": "A", "\xC1": "A", "\xC2": "A", "\xC3": "A", "\xC4": "A", "\xC5": "A", "\xE0": "a", "\xE1": "a", "\xE2": "a", "\xE3": "a", "\xE4": "a", "\xE5": "a", "\xC7": "C", "\xE7": "c", "\xD0": "D", "\xF0": "d", "\xC8": "E", "\xC9": "E", "\xCA": "E", "\xCB": "E", "\xE8": "e", "\xE9": "e", "\xEA": "e", "\xEB": "e", "\xCC": "I", "\xCD": "I", "\xCE": "I", "\xCF": "I", "\xEC": "i", "\xED": "i", "\xEE": "i", "\xEF": "i", "\xD1": "N", "\xF1": "n", "\xD2": "O", "\xD3": "O", "\xD4": "O", "\xD5": "O", "\xD6": "O", "\xD8": "O", "\xF2": "o", "\xF3": "o", "\xF4": "o", "\xF5": "o", "\xF6": "o", "\xF8": "o", "\xD9": "U", "\xDA": "U", "\xDB": "U", "\xDC": "U", "\xF9": "u", "\xFA": "u", "\xFB": "u", "\xFC": "u", "\xDD": "Y", "\xFD": "y", "\xFF": "y", "\xC6": "Ae", "\xE6": "ae", "\xDE": "Th", "\xFE": "th", "\xDF": "ss", "\u0100": "A", "\u0102": "A", "\u0104": "A", "\u0101": "a", "\u0103": "a", "\u0105": "a", "\u0106": "C", "\u0108": "C", "\u010A": "C", "\u010C": "C", "\u0107": "c", "\u0109": "c", "\u010B": "c", "\u010D": "c", "\u010E": "D", "\u0110": "D", "\u010F": "d", "\u0111": "d", "\u0112": "E", "\u0114": "E", "\u0116": "E", "\u0118": "E", "\u011A": "E", "\u0113": "e", "\u0115": "e", "\u0117": "e", "\u0119": "e", "\u011B": "e", "\u011C": "G", "\u011E": "G", "\u0120": "G", "\u0122": "G", "\u011D": "g", "\u011F": "g", "\u0121": "g", "\u0123": "g", "\u0124": "H", "\u0126": "H", "\u0125": "h", "\u0127": "h", "\u0128": "I", "\u012A": "I", "\u012C": "I", "\u012E": "I", "\u0130": "I", "\u0129": "i", "\u012B": "i", "\u012D": "i", "\u012F": "i", "\u0131": "i", "\u0134": "J", "\u0135": "j", "\u0136": "K", "\u0137": "k", "\u0138": "k", "\u0139": "L", "\u013B": "L", "\u013D": "L", "\u013F": "L", "\u0141": "L", "\u013A": "l", "\u013C": "l", "\u013E": "l", "\u0140": "l", "\u0142": "l", "\u0143": "N", "\u0145": "N", "\u0147": "N", "\u014A": "N", "\u0144": "n", "\u0146": "n", "\u0148": "n", "\u014B": "n", "\u014C": "O", "\u014E": "O", "\u0150": "O", "\u014D": "o", "\u014F": "o", "\u0151": "o", "\u0154": "R", "\u0156": "R", "\u0158": "R", "\u0155": "r", "\u0157": "r", "\u0159": "r", "\u015A": "S", "\u015C": "S", "\u015E": "S", "\u0160": "S", "\u015B": "s", "\u015D": "s", "\u015F": "s", "\u0161": "s", "\u0162": "T", "\u0164": "T", "\u0166": "T", "\u0163": "t", "\u0165": "t", "\u0167": "t", "\u0168": "U", "\u016A": "U", "\u016C": "U", "\u016E": "U", "\u0170": "U", "\u0172": "U", "\u0169": "u", "\u016B": "u", "\u016D": "u", "\u016F": "u", "\u0171": "u", "\u0173": "u", "\u0174": "W", "\u0175": "w", "\u0176": "Y", "\u0177": "y", "\u0178": "Y", "\u0179": "Z", "\u017B": "Z", "\u017D": "Z", "\u017A": "z", "\u017C": "z", "\u017E": "z", "\u0132": "IJ", "\u0133": "ij", "\u0152": "Oe", "\u0153": "oe", "\u0149": "'n", "\u017F": "s" });
    var on2 = Ut2({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" });
    function an2(e15) {
      return "\\" + ct2[e15];
    }
    function sn2(e15) {
      return rt2.test(e15);
    }
    function ln2(e15) {
      var t11 = -1, n11 = Array(e15.size);
      return e15.forEach(function(e16, r11) {
        n11[++t11] = [r11, e16];
      }), n11;
    }
    function cn2(e15, t11) {
      return function(n11) {
        return e15(t11(n11));
      };
    }
    function un2(e15, t11) {
      var n11 = -1, r11 = e15.length, o11 = 0, i11 = [];
      for (; ++n11 < r11; ) {
        var s11 = e15[n11];
        s11 !== t11 && s11 !== a10 || (e15[n11] = a10, i11[o11++] = n11);
      }
      return i11;
    }
    function dn2(e15) {
      var t11 = -1, n11 = Array(e15.size);
      return e15.forEach(function(e16) {
        n11[++t11] = e16;
      }), n11;
    }
    function pn2(e15) {
      var t11 = -1, n11 = Array(e15.size);
      return e15.forEach(function(e16) {
        n11[++t11] = [e16, e16];
      }), n11;
    }
    function mn2(e15) {
      return sn2(e15) ? function(e16) {
        var t11 = tt2.lastIndex = 0;
        for (; tt2.test(e16); ) ++t11;
        return t11;
      }(e15) : Ot2(e15);
    }
    function hn2(e15) {
      return sn2(e15) ? function(e16) {
        return e16.match(tt2) || [];
      }(e15) : function(e16) {
        return e16.split("");
      }(e15);
    }
    function fn2(e15) {
      var t11 = e15.length;
      for (; t11-- && ie2.test(e15.charAt(t11)); ) ;
      return t11;
    }
    var gn2 = Ut2({ "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'" });
    var yn2 = function e15(t11) {
      var $10 = (t11 = null == t11 ? ht2 : yn2.defaults(ht2.Object(), t11, yn2.pick(ht2, at2))).Array, ie3 = t11.Date, we3 = t11.Error, Te3 = t11.Function, Ee3 = t11.Math, Fe3 = t11.Object, Me3 = t11.RegExp, ke3 = t11.String, Pe3 = t11.TypeError;
      var Ne3 = $10.prototype, De3 = Te3.prototype, Le3 = Fe3.prototype;
      var He3 = t11["__core-js_shared__"];
      var Ie3 = De3.toString;
      var _e3 = Le3.hasOwnProperty;
      var Ve3 = 0;
      var Re3 = (Ae3 = /[^.]+$/.exec(He3 && He3.keys && He3.keys.IE_PROTO || "")) ? "Symbol(src)_1." + Ae3 : "";
      var Ae3;
      var Oe3 = Le3.toString;
      var Be3 = Ie3.call(Fe3);
      var ze3 = ht2._;
      var $e3 = Me3("^" + Ie3.call(_e3).replace(re2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
      var We3 = yt2 ? t11.Buffer : n10, je3 = t11.Symbol, Ze3 = t11.Uint8Array, Ge3 = We3 ? We3.allocUnsafe : n10, Ue3 = cn2(Fe3.getPrototypeOf, Fe3), qe3 = Fe3.create, Ye3 = Le3.propertyIsEnumerable, Ke3 = Ne3.splice, Xe3 = je3 ? je3.isConcatSpreadable : n10, Je3 = je3 ? je3.iterator : n10, tt3 = je3 ? je3.toStringTag : n10;
      var rt3 = function() {
        try {
          var e16 = ma2(Fe3, "defineProperty");
          return e16({}, "", {}), e16;
        } catch (e17) {
        }
      }();
      var ct3 = t11.clearTimeout !== ht2.clearTimeout && t11.clearTimeout, pt3 = ie3 && ie3.now !== ht2.Date.now && ie3.now, mt3 = t11.setTimeout !== ht2.setTimeout && t11.setTimeout;
      var ft3 = Ee3.ceil, gt3 = Ee3.floor, vt3 = Fe3.getOwnPropertySymbols, bt3 = We3 ? We3.isBuffer : n10, Ot3 = t11.isFinite, Ut3 = Ne3.join, vn2 = cn2(Fe3.keys, Fe3), bn2 = Ee3.max, Sn2 = Ee3.min, Cn2 = ie3.now, xn2 = t11.parseInt, wn2 = Ee3.random, Tn2 = Ne3.reverse;
      var En2 = ma2(t11, "DataView"), Fn2 = ma2(t11, "Map"), Mn2 = ma2(t11, "Promise"), kn2 = ma2(t11, "Set"), Pn2 = ma2(t11, "WeakMap"), Nn2 = ma2(Fe3, "create");
      var Dn2 = Pn2 && new Pn2();
      var Ln2 = {};
      var Hn2 = Oa2(En2), In2 = Oa2(Fn2), _n2 = Oa2(Mn2), Vn2 = Oa2(kn2), Rn2 = Oa2(Pn2);
      var An2 = je3 ? je3.prototype : n10, On2 = An2 ? An2.valueOf : n10, Bn2 = An2 ? An2.toString : n10;
      function zn2(e16) {
        if (ns2(e16) && !Zi2(e16) && !(e16 instanceof Zn2)) {
          if (e16 instanceof jn2) return e16;
          if (_e3.call(e16, "__wrapped__")) return Ba2(e16);
        }
        return new jn2(e16);
      }
      var $n2 = /* @__PURE__ */ function() {
        function e16() {
        }
        return function(t12) {
          if (!ts2(t12)) return {};
          if (qe3) return qe3(t12);
          e16.prototype = t12;
          var r11 = new e16();
          return e16.prototype = n10, r11;
        };
      }();
      function Wn2() {
      }
      function jn2(e16, t12) {
        this.__wrapped__ = e16, this.__actions__ = [], this.__chain__ = !!t12, this.__index__ = 0, this.__values__ = n10;
      }
      function Zn2(e16) {
        this.__wrapped__ = e16, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = false, this.__iteratees__ = [], this.__takeCount__ = h10, this.__views__ = [];
      }
      function Gn2(e16) {
        var t12 = -1, n11 = null == e16 ? 0 : e16.length;
        for (this.clear(); ++t12 < n11; ) {
          var r11 = e16[t12];
          this.set(r11[0], r11[1]);
        }
      }
      function Un2(e16) {
        var t12 = -1, n11 = null == e16 ? 0 : e16.length;
        for (this.clear(); ++t12 < n11; ) {
          var r11 = e16[t12];
          this.set(r11[0], r11[1]);
        }
      }
      function qn2(e16) {
        var t12 = -1, n11 = null == e16 ? 0 : e16.length;
        for (this.clear(); ++t12 < n11; ) {
          var r11 = e16[t12];
          this.set(r11[0], r11[1]);
        }
      }
      function Yn2(e16) {
        var t12 = -1, n11 = null == e16 ? 0 : e16.length;
        for (this.__data__ = new qn2(); ++t12 < n11; ) this.add(e16[t12]);
      }
      function Kn2(e16) {
        var t12 = this.__data__ = new Un2(e16);
        this.size = t12.size;
      }
      function Xn2(e16, t12) {
        var n11 = Zi2(e16), r11 = !n11 && ji2(e16), o11 = !n11 && !r11 && Yi2(e16), a11 = !n11 && !r11 && !o11 && us2(e16), i11 = n11 || r11 || o11 || a11, s11 = i11 ? Kt2(e16.length, ke3) : [], l11 = s11.length;
        for (var c11 in e16) !t12 && !_e3.call(e16, c11) || i11 && ("length" == c11 || o11 && ("offset" == c11 || "parent" == c11) || a11 && ("buffer" == c11 || "byteLength" == c11 || "byteOffset" == c11) || Sa2(c11, l11)) || s11.push(c11);
        return s11;
      }
      function Jn2(e16) {
        var t12 = e16.length;
        return t12 ? e16[Yr2(0, t12 - 1)] : n10;
      }
      function Qn2(e16, t12) {
        return Va2(Do2(e16), lr2(t12, 0, e16.length));
      }
      function er2(e16) {
        return Va2(Do2(e16));
      }
      function tr2(e16, t12, r11) {
        (r11 !== n10 && !zi2(e16[t12], r11) || r11 === n10 && !(t12 in e16)) && ir2(e16, t12, r11);
      }
      function nr2(e16, t12, r11) {
        var o11 = e16[t12];
        _e3.call(e16, t12) && zi2(o11, r11) && (r11 !== n10 || t12 in e16) || ir2(e16, t12, r11);
      }
      function rr2(e16, t12) {
        var n11 = e16.length;
        for (; n11--; ) if (zi2(e16[n11][0], t12)) return n11;
        return -1;
      }
      function or2(e16, t12, n11, r11) {
        return mr2(e16, function(e17, o11, a11) {
          t12(r11, e17, n11(e17), a11);
        }), r11;
      }
      function ar2(e16, t12) {
        return e16 && Lo2(t12, Ls2(t12), e16);
      }
      function ir2(e16, t12, n11) {
        "__proto__" == t12 && rt3 ? rt3(e16, t12, { configurable: true, enumerable: true, value: n11, writable: true }) : e16[t12] = n11;
      }
      function sr2(e16, t12) {
        var r11 = -1, o11 = t12.length, a11 = $10(o11), i11 = null == e16;
        for (; ++r11 < o11; ) a11[r11] = i11 ? n10 : Ms2(e16, t12[r11]);
        return a11;
      }
      function lr2(e16, t12, r11) {
        return e16 == e16 && (r11 !== n10 && (e16 = e16 <= r11 ? e16 : r11), t12 !== n10 && (e16 = e16 >= t12 ? e16 : t12)), e16;
      }
      function cr2(e16, t12, r11, o11, a11, i11) {
        var s11, l11 = 1 & t12, c11 = 2 & t12, u11 = 4 & t12;
        if (r11 && (s11 = a11 ? r11(e16, o11, a11, i11) : r11(e16)), s11 !== n10) return s11;
        if (!ts2(e16)) return e16;
        var d11 = Zi2(e16);
        if (d11) {
          if (s11 = function(e17) {
            var t13 = e17.length, n11 = new e17.constructor(t13);
            t13 && "string" == typeof e17[0] && _e3.call(e17, "index") && (n11.index = e17.index, n11.input = e17.input);
            return n11;
          }(e16), !l11) return Do2(e16, s11);
        } else {
          var p11 = ga2(e16), m11 = p11 == C10 || p11 == x10;
          if (Yi2(e16)) return Eo2(e16, l11);
          if (p11 == E10 || p11 == g10 || m11 && !a11) {
            if (s11 = c11 || m11 ? {} : va2(e16), !l11) return c11 ? function(e17, t13) {
              return Lo2(e17, fa2(e17), t13);
            }(e16, function(e17, t13) {
              return e17 && Lo2(t13, Hs2(t13), e17);
            }(s11, e16)) : function(e17, t13) {
              return Lo2(e17, ha2(e17), t13);
            }(e16, ar2(s11, e16));
          } else {
            if (!lt2[p11]) return a11 ? e16 : {};
            s11 = function(e17, t13, n11) {
              var r12 = e17.constructor;
              switch (t13) {
                case L10:
                  return Fo2(e17);
                case v10:
                case b10:
                  return new r12(+e17);
                case H10:
                  return function(e18, t14) {
                    var n12 = t14 ? Fo2(e18.buffer) : e18.buffer;
                    return new e18.constructor(n12, e18.byteOffset, e18.byteLength);
                  }(e17, n11);
                case I10:
                case _10:
                case V10:
                case R10:
                case A10:
                case O10:
                case B10:
                case z10:
                case W10:
                  return Mo2(e17, n11);
                case w10:
                  return new r12();
                case T10:
                case P10:
                  return new r12(e17);
                case M10:
                  return function(e18) {
                    var t14 = new e18.constructor(e18.source, he2.exec(e18));
                    return t14.lastIndex = e18.lastIndex, t14;
                  }(e17);
                case k10:
                  return new r12();
                case N10:
                  return function(e18) {
                    return On2 ? Fe3(On2.call(e18)) : {};
                  }(e17);
              }
            }(e16, p11, l11);
          }
        }
        i11 || (i11 = new Kn2());
        var h11 = i11.get(e16);
        if (h11) return h11;
        i11.set(e16, s11), ss2(e16) ? e16.forEach(function(n11) {
          s11.add(cr2(n11, t12, r11, n11, e16, i11));
        }) : rs2(e16) && e16.forEach(function(n11, o12) {
          s11.set(o12, cr2(n11, t12, r11, o12, e16, i11));
        });
        var f11 = d11 ? n10 : (u11 ? c11 ? ia2 : aa2 : c11 ? Hs2 : Ls2)(e16);
        return kt2(f11 || e16, function(n11, o12) {
          f11 && (n11 = e16[o12 = n11]), nr2(s11, o12, cr2(n11, t12, r11, o12, e16, i11));
        }), s11;
      }
      function ur2(e16, t12, r11) {
        var o11 = r11.length;
        if (null == e16) return !o11;
        for (e16 = Fe3(e16); o11--; ) {
          var a11 = r11[o11], i11 = t12[a11], s11 = e16[a11];
          if (s11 === n10 && !(a11 in e16) || !i11(s11)) return false;
        }
        return true;
      }
      function dr2(e16, t12, o11) {
        if ("function" != typeof e16) throw new Pe3(r10);
        return La2(function() {
          e16.apply(n10, o11);
        }, t12);
      }
      function pr2(e16, t12, n11, r11) {
        var o11 = -1, a11 = Lt2, i11 = true, s11 = e16.length, l11 = [], c11 = t12.length;
        if (!s11) return l11;
        n11 && (t12 = It2(t12, Jt2(n11))), r11 ? (a11 = Ht2, i11 = false) : t12.length >= 200 && (a11 = en2, i11 = false, t12 = new Yn2(t12));
        e: for (; ++o11 < s11; ) {
          var u11 = e16[o11], d11 = null == n11 ? u11 : n11(u11);
          if (u11 = r11 || 0 !== u11 ? u11 : 0, i11 && d11 == d11) {
            var p11 = c11;
            for (; p11--; ) if (t12[p11] === d11) continue e;
            l11.push(u11);
          } else a11(t12, d11, r11) || l11.push(u11);
        }
        return l11;
      }
      zn2.templateSettings = { escape: X10, evaluate: J10, interpolate: Q10, variable: "", imports: { _: zn2 } }, zn2.prototype = Wn2.prototype, zn2.prototype.constructor = zn2, jn2.prototype = $n2(Wn2.prototype), jn2.prototype.constructor = jn2, Zn2.prototype = $n2(Wn2.prototype), Zn2.prototype.constructor = Zn2, Gn2.prototype.clear = function() {
        this.__data__ = Nn2 ? Nn2(null) : {}, this.size = 0;
      }, Gn2.prototype.delete = function(e16) {
        var t12 = this.has(e16) && delete this.__data__[e16];
        return this.size -= t12 ? 1 : 0, t12;
      }, Gn2.prototype.get = function(e16) {
        var t12 = this.__data__;
        if (Nn2) {
          var r11 = t12[e16];
          return r11 === o10 ? n10 : r11;
        }
        return _e3.call(t12, e16) ? t12[e16] : n10;
      }, Gn2.prototype.has = function(e16) {
        var t12 = this.__data__;
        return Nn2 ? t12[e16] !== n10 : _e3.call(t12, e16);
      }, Gn2.prototype.set = function(e16, t12) {
        var r11 = this.__data__;
        return this.size += this.has(e16) ? 0 : 1, r11[e16] = Nn2 && t12 === n10 ? o10 : t12, this;
      }, Un2.prototype.clear = function() {
        this.__data__ = [], this.size = 0;
      }, Un2.prototype.delete = function(e16) {
        var t12 = this.__data__, n11 = rr2(t12, e16);
        return !(n11 < 0) && (n11 == t12.length - 1 ? t12.pop() : Ke3.call(t12, n11, 1), --this.size, true);
      }, Un2.prototype.get = function(e16) {
        var t12 = this.__data__, r11 = rr2(t12, e16);
        return r11 < 0 ? n10 : t12[r11][1];
      }, Un2.prototype.has = function(e16) {
        return rr2(this.__data__, e16) > -1;
      }, Un2.prototype.set = function(e16, t12) {
        var n11 = this.__data__, r11 = rr2(n11, e16);
        return r11 < 0 ? (++this.size, n11.push([e16, t12])) : n11[r11][1] = t12, this;
      }, qn2.prototype.clear = function() {
        this.size = 0, this.__data__ = { hash: new Gn2(), map: new (Fn2 || Un2)(), string: new Gn2() };
      }, qn2.prototype.delete = function(e16) {
        var t12 = da2(this, e16).delete(e16);
        return this.size -= t12 ? 1 : 0, t12;
      }, qn2.prototype.get = function(e16) {
        return da2(this, e16).get(e16);
      }, qn2.prototype.has = function(e16) {
        return da2(this, e16).has(e16);
      }, qn2.prototype.set = function(e16, t12) {
        var n11 = da2(this, e16), r11 = n11.size;
        return n11.set(e16, t12), this.size += n11.size == r11 ? 0 : 1, this;
      }, Yn2.prototype.add = Yn2.prototype.push = function(e16) {
        return this.__data__.set(e16, o10), this;
      }, Yn2.prototype.has = function(e16) {
        return this.__data__.has(e16);
      }, Kn2.prototype.clear = function() {
        this.__data__ = new Un2(), this.size = 0;
      }, Kn2.prototype.delete = function(e16) {
        var t12 = this.__data__, n11 = t12.delete(e16);
        return this.size = t12.size, n11;
      }, Kn2.prototype.get = function(e16) {
        return this.__data__.get(e16);
      }, Kn2.prototype.has = function(e16) {
        return this.__data__.has(e16);
      }, Kn2.prototype.set = function(e16, t12) {
        var n11 = this.__data__;
        if (n11 instanceof Un2) {
          var r11 = n11.__data__;
          if (!Fn2 || r11.length < 199) return r11.push([e16, t12]), this.size = ++n11.size, this;
          n11 = this.__data__ = new qn2(r11);
        }
        return n11.set(e16, t12), this.size = n11.size, this;
      };
      var mr2 = _o3(Cr2);
      var hr2 = _o3(xr2, true);
      function fr2(e16, t12) {
        var n11 = true;
        return mr2(e16, function(e17, r11, o11) {
          return n11 = !!t12(e17, r11, o11);
        }), n11;
      }
      function gr2(e16, t12, r11) {
        var o11 = -1, a11 = e16.length;
        for (; ++o11 < a11; ) {
          var i11 = e16[o11], s11 = t12(i11);
          if (null != s11 && (l11 === n10 ? s11 == s11 && !cs2(s11) : r11(s11, l11))) var l11 = s11, c11 = i11;
        }
        return c11;
      }
      function yr2(e16, t12) {
        var n11 = [];
        return mr2(e16, function(e17, r11, o11) {
          t12(e17, r11, o11) && n11.push(e17);
        }), n11;
      }
      function vr2(e16, t12, n11, r11, o11) {
        var a11 = -1, i11 = e16.length;
        for (n11 || (n11 = ba2), o11 || (o11 = []); ++a11 < i11; ) {
          var s11 = e16[a11];
          t12 > 0 && n11(s11) ? t12 > 1 ? vr2(s11, t12 - 1, n11, r11, o11) : _t2(o11, s11) : r11 || (o11[o11.length] = s11);
        }
        return o11;
      }
      var br2 = Vo2();
      var Sr2 = Vo2(true);
      function Cr2(e16, t12) {
        return e16 && br2(e16, t12, Ls2);
      }
      function xr2(e16, t12) {
        return e16 && Sr2(e16, t12, Ls2);
      }
      function wr2(e16, t12) {
        return Dt2(t12, function(t13) {
          return Ji2(e16[t13]);
        });
      }
      function Tr2(e16, t12) {
        var r11 = 0, o11 = (t12 = Co2(t12, e16)).length;
        for (; null != e16 && r11 < o11; ) e16 = e16[Aa2(t12[r11++])];
        return r11 && r11 == o11 ? e16 : n10;
      }
      function Er2(e16, t12, n11) {
        var r11 = t12(e16);
        return Zi2(e16) ? r11 : _t2(r11, n11(e16));
      }
      function Fr2(e16) {
        return null == e16 ? e16 === n10 ? "[object Undefined]" : "[object Null]" : tt3 && tt3 in Fe3(e16) ? function(e17) {
          var t12 = _e3.call(e17, tt3), r11 = e17[tt3];
          try {
            e17[tt3] = n10;
            var o11 = true;
          } catch (e18) {
          }
          var a11 = Oe3.call(e17);
          o11 && (t12 ? e17[tt3] = r11 : delete e17[tt3]);
          return a11;
        }(e16) : function(e17) {
          return Oe3.call(e17);
        }(e16);
      }
      function Mr2(e16, t12) {
        return e16 > t12;
      }
      function kr2(e16, t12) {
        return null != e16 && _e3.call(e16, t12);
      }
      function Pr2(e16, t12) {
        return null != e16 && t12 in Fe3(e16);
      }
      function Nr2(e16, t12, r11) {
        var o11 = r11 ? Ht2 : Lt2, a11 = e16[0].length, i11 = e16.length, s11 = i11, l11 = $10(i11), c11 = 1 / 0, u11 = [];
        for (; s11--; ) {
          var d11 = e16[s11];
          s11 && t12 && (d11 = It2(d11, Jt2(t12))), c11 = Sn2(d11.length, c11), l11[s11] = !r11 && (t12 || a11 >= 120 && d11.length >= 120) ? new Yn2(s11 && d11) : n10;
        }
        d11 = e16[0];
        var p11 = -1, m11 = l11[0];
        e: for (; ++p11 < a11 && u11.length < c11; ) {
          var h11 = d11[p11], f11 = t12 ? t12(h11) : h11;
          if (h11 = r11 || 0 !== h11 ? h11 : 0, !(m11 ? en2(m11, f11) : o11(u11, f11, r11))) {
            for (s11 = i11; --s11; ) {
              var g11 = l11[s11];
              if (!(g11 ? en2(g11, f11) : o11(e16[s11], f11, r11))) continue e;
            }
            m11 && m11.push(f11), u11.push(h11);
          }
        }
        return u11;
      }
      function Dr2(e16, t12, r11) {
        var o11 = null == (e16 = Pa2(e16, t12 = Co2(t12, e16))) ? e16 : e16[Aa2(Xa2(t12))];
        return null == o11 ? n10 : Ft2(o11, e16, r11);
      }
      function Lr2(e16) {
        return ns2(e16) && Fr2(e16) == g10;
      }
      function Hr2(e16, t12, r11, o11, a11) {
        return e16 === t12 || (null == e16 || null == t12 || !ns2(e16) && !ns2(t12) ? e16 != e16 && t12 != t12 : function(e17, t13, r12, o12, a12, i11) {
          var s11 = Zi2(e17), l11 = Zi2(t13), c11 = s11 ? y10 : ga2(e17), u11 = l11 ? y10 : ga2(t13);
          var d11 = (c11 = c11 == g10 ? E10 : c11) == E10, p11 = (u11 = u11 == g10 ? E10 : u11) == E10, m11 = c11 == u11;
          if (m11 && Yi2(e17)) {
            if (!Yi2(t13)) return false;
            s11 = true, d11 = false;
          }
          if (m11 && !d11) return i11 || (i11 = new Kn2()), s11 || us2(e17) ? ra2(e17, t13, r12, o12, a12, i11) : function(e18, t14, n11, r13, o13, a13, i12) {
            switch (n11) {
              case H10:
                if (e18.byteLength != t14.byteLength || e18.byteOffset != t14.byteOffset) return false;
                e18 = e18.buffer, t14 = t14.buffer;
              case L10:
                return !(e18.byteLength != t14.byteLength || !a13(new Ze3(e18), new Ze3(t14)));
              case v10:
              case b10:
              case T10:
                return zi2(+e18, +t14);
              case S10:
                return e18.name == t14.name && e18.message == t14.message;
              case M10:
              case P10:
                return e18 == t14 + "";
              case w10:
                var s12 = ln2;
              case k10:
                var l12 = 1 & r13;
                if (s12 || (s12 = dn2), e18.size != t14.size && !l12) return false;
                var c12 = i12.get(e18);
                if (c12) return c12 == t14;
                r13 |= 2, i12.set(e18, t14);
                var u12 = ra2(s12(e18), s12(t14), r13, o13, a13, i12);
                return i12.delete(e18), u12;
              case N10:
                if (On2) return On2.call(e18) == On2.call(t14);
            }
            return false;
          }(e17, t13, c11, r12, o12, a12, i11);
          if (!(1 & r12)) {
            var h11 = d11 && _e3.call(e17, "__wrapped__"), f11 = p11 && _e3.call(t13, "__wrapped__");
            if (h11 || f11) {
              var C11 = h11 ? e17.value() : e17, x11 = f11 ? t13.value() : t13;
              return i11 || (i11 = new Kn2()), a12(C11, x11, r12, o12, i11);
            }
          }
          if (!m11) return false;
          return i11 || (i11 = new Kn2()), function(e18, t14, r13, o13, a13, i12) {
            var s12 = 1 & r13, l12 = aa2(e18), c12 = l12.length, u12 = aa2(t14), d12 = u12.length;
            if (c12 != d12 && !s12) return false;
            var p12 = c12;
            for (; p12--; ) {
              var m12 = l12[p12];
              if (!(s12 ? m12 in t14 : _e3.call(t14, m12))) return false;
            }
            var h12 = i12.get(e18);
            var f12 = i12.get(t14);
            if (h12 && f12) return h12 == t14 && f12 == e18;
            var g11 = true;
            i12.set(e18, t14), i12.set(t14, e18);
            var y11 = s12;
            for (; ++p12 < c12; ) {
              var v11 = e18[m12 = l12[p12]], b11 = t14[m12];
              if (o13) var S11 = s12 ? o13(b11, v11, m12, t14, e18, i12) : o13(v11, b11, m12, e18, t14, i12);
              if (!(S11 === n10 ? v11 === b11 || a13(v11, b11, r13, o13, i12) : S11)) {
                g11 = false;
                break;
              }
              y11 || (y11 = "constructor" == m12);
            }
            if (g11 && !y11) {
              var C12 = e18.constructor, x12 = t14.constructor;
              C12 == x12 || !("constructor" in e18) || !("constructor" in t14) || "function" == typeof C12 && C12 instanceof C12 && "function" == typeof x12 && x12 instanceof x12 || (g11 = false);
            }
            return i12.delete(e18), i12.delete(t14), g11;
          }(e17, t13, r12, o12, a12, i11);
        }(e16, t12, r11, o11, Hr2, a11));
      }
      function Ir2(e16, t12, r11, o11) {
        var a11 = r11.length, i11 = a11, s11 = !o11;
        if (null == e16) return !i11;
        for (e16 = Fe3(e16); a11--; ) {
          var l11 = r11[a11];
          if (s11 && l11[2] ? l11[1] !== e16[l11[0]] : !(l11[0] in e16)) return false;
        }
        for (; ++a11 < i11; ) {
          var c11 = (l11 = r11[a11])[0], u11 = e16[c11], d11 = l11[1];
          if (s11 && l11[2]) {
            if (u11 === n10 && !(c11 in e16)) return false;
          } else {
            var p11 = new Kn2();
            if (o11) var m11 = o11(u11, d11, c11, e16, t12, p11);
            if (!(m11 === n10 ? Hr2(d11, u11, 3, o11, p11) : m11)) return false;
          }
        }
        return true;
      }
      function _r2(e16) {
        return !(!ts2(e16) || function(e17) {
          return !!Re3 && Re3 in e17;
        }(e16)) && (Ji2(e16) ? $e3 : ye2).test(Oa2(e16));
      }
      function Vr2(e16) {
        return "function" == typeof e16 ? e16 : null == e16 ? ol2 : "object" == typeof e16 ? Zi2(e16) ? $r2(e16[0], e16[1]) : zr2(e16) : ml2(e16);
      }
      function Rr2(e16) {
        if (!Ea2(e16)) return vn2(e16);
        var t12 = [];
        for (var n11 in Fe3(e16)) _e3.call(e16, n11) && "constructor" != n11 && t12.push(n11);
        return t12;
      }
      function Ar2(e16) {
        if (!ts2(e16)) return function(e17) {
          var t13 = [];
          if (null != e17) for (var n12 in Fe3(e17)) t13.push(n12);
          return t13;
        }(e16);
        var t12 = Ea2(e16), n11 = [];
        for (var r11 in e16) ("constructor" != r11 || !t12 && _e3.call(e16, r11)) && n11.push(r11);
        return n11;
      }
      function Or2(e16, t12) {
        return e16 < t12;
      }
      function Br2(e16, t12) {
        var n11 = -1, r11 = Ui2(e16) ? $10(e16.length) : [];
        return mr2(e16, function(e17, o11, a11) {
          r11[++n11] = t12(e17, o11, a11);
        }), r11;
      }
      function zr2(e16) {
        var t12 = pa2(e16);
        return 1 == t12.length && t12[0][2] ? Ma2(t12[0][0], t12[0][1]) : function(n11) {
          return n11 === e16 || Ir2(n11, e16, t12);
        };
      }
      function $r2(e16, t12) {
        return xa2(e16) && Fa2(t12) ? Ma2(Aa2(e16), t12) : function(r11) {
          var o11 = Ms2(r11, e16);
          return o11 === n10 && o11 === t12 ? ks2(r11, e16) : Hr2(t12, o11, 3);
        };
      }
      function Wr2(e16, t12, r11, o11, a11) {
        e16 !== t12 && br2(t12, function(i11, s11) {
          if (a11 || (a11 = new Kn2()), ts2(i11)) !function(e17, t13, r12, o12, a12, i12, s12) {
            var l12 = Na2(e17, r12), c11 = Na2(t13, r12), u11 = s12.get(c11);
            if (u11) return void tr2(e17, r12, u11);
            var d11 = i12 ? i12(l12, c11, r12 + "", e17, t13, s12) : n10;
            var p11 = d11 === n10;
            if (p11) {
              var m11 = Zi2(c11), h11 = !m11 && Yi2(c11), f11 = !m11 && !h11 && us2(c11);
              d11 = c11, m11 || h11 || f11 ? Zi2(l12) ? d11 = l12 : qi2(l12) ? d11 = Do2(l12) : h11 ? (p11 = false, d11 = Eo2(c11, true)) : f11 ? (p11 = false, d11 = Mo2(c11, true)) : d11 = [] : as2(c11) || ji2(c11) ? (d11 = l12, ji2(l12) ? d11 = vs2(l12) : ts2(l12) && !Ji2(l12) || (d11 = va2(c11))) : p11 = false;
            }
            p11 && (s12.set(c11, d11), a12(d11, c11, o12, i12, s12), s12.delete(c11));
            tr2(e17, r12, d11);
          }(e16, t12, s11, r11, Wr2, o11, a11);
          else {
            var l11 = o11 ? o11(Na2(e16, s11), i11, s11 + "", e16, t12, a11) : n10;
            l11 === n10 && (l11 = i11), tr2(e16, s11, l11);
          }
        }, Hs2);
      }
      function jr2(e16, t12) {
        var r11 = e16.length;
        if (r11) return Sa2(t12 += t12 < 0 ? r11 : 0, r11) ? e16[t12] : n10;
      }
      function Zr2(e16, t12, n11) {
        t12 = t12.length ? It2(t12, function(e17) {
          return Zi2(e17) ? function(t13) {
            return Tr2(t13, 1 === e17.length ? e17[0] : e17);
          } : e17;
        }) : [ol2];
        var r11 = -1;
        t12 = It2(t12, Jt2(ua2()));
        var o11 = Br2(e16, function(e17, n12, o12) {
          var a11 = It2(t12, function(t13) {
            return t13(e17);
          });
          return { criteria: a11, index: ++r11, value: e17 };
        });
        return function(e17, t13) {
          var n12 = e17.length;
          for (e17.sort(t13); n12--; ) e17[n12] = e17[n12].value;
          return e17;
        }(o11, function(e17, t13) {
          return function(e18, t14, n12) {
            var r12 = -1, o12 = e18.criteria, a11 = t14.criteria, i11 = o12.length, s11 = n12.length;
            for (; ++r12 < i11; ) {
              var l11 = ko2(o12[r12], a11[r12]);
              if (l11) return r12 >= s11 ? l11 : l11 * ("desc" == n12[r12] ? -1 : 1);
            }
            return e18.index - t14.index;
          }(e17, t13, n11);
        });
      }
      function Gr2(e16, t12, n11) {
        var r11 = -1, o11 = t12.length, a11 = {};
        for (; ++r11 < o11; ) {
          var i11 = t12[r11], s11 = Tr2(e16, i11);
          n11(s11, i11) && eo2(a11, Co2(i11, e16), s11);
        }
        return a11;
      }
      function Ur2(e16, t12, n11, r11) {
        var o11 = r11 ? Wt2 : $t2, a11 = -1, i11 = t12.length, s11 = e16;
        for (e16 === t12 && (t12 = Do2(t12)), n11 && (s11 = It2(e16, Jt2(n11))); ++a11 < i11; ) {
          var l11 = 0, c11 = t12[a11], u11 = n11 ? n11(c11) : c11;
          for (; (l11 = o11(s11, u11, l11, r11)) > -1; ) s11 !== e16 && Ke3.call(s11, l11, 1), Ke3.call(e16, l11, 1);
        }
        return e16;
      }
      function qr2(e16, t12) {
        var n11 = e16 ? t12.length : 0, r11 = n11 - 1;
        for (; n11--; ) {
          var o11 = t12[n11];
          if (n11 == r11 || o11 !== a11) {
            var a11 = o11;
            Sa2(o11) ? Ke3.call(e16, o11, 1) : mo2(e16, o11);
          }
        }
        return e16;
      }
      function Yr2(e16, t12) {
        return e16 + gt3(wn2() * (t12 - e16 + 1));
      }
      function Kr2(e16, t12) {
        var n11 = "";
        if (!e16 || t12 < 1 || t12 > p10) return n11;
        do {
          t12 % 2 && (n11 += e16), (t12 = gt3(t12 / 2)) && (e16 += e16);
        } while (t12);
        return n11;
      }
      function Xr2(e16, t12) {
        return Ha2(ka2(e16, t12, ol2), e16 + "");
      }
      function Jr2(e16) {
        return Jn2(zs2(e16));
      }
      function Qr2(e16, t12) {
        var n11 = zs2(e16);
        return Va2(n11, lr2(t12, 0, n11.length));
      }
      function eo2(e16, t12, r11, o11) {
        if (!ts2(e16)) return e16;
        var a11 = -1, i11 = (t12 = Co2(t12, e16)).length, s11 = i11 - 1, l11 = e16;
        for (; null != l11 && ++a11 < i11; ) {
          var c11 = Aa2(t12[a11]), u11 = r11;
          if ("__proto__" === c11 || "constructor" === c11 || "prototype" === c11) return e16;
          if (a11 != s11) {
            var d11 = l11[c11];
            (u11 = o11 ? o11(d11, c11, l11) : n10) === n10 && (u11 = ts2(d11) ? d11 : Sa2(t12[a11 + 1]) ? [] : {});
          }
          nr2(l11, c11, u11), l11 = l11[c11];
        }
        return e16;
      }
      var to2 = Dn2 ? function(e16, t12) {
        return Dn2.set(e16, t12), e16;
      } : ol2;
      var no2 = rt3 ? function(e16, t12) {
        return rt3(e16, "toString", { configurable: true, enumerable: false, value: tl2(t12), writable: true });
      } : ol2;
      function ro2(e16) {
        return Va2(zs2(e16));
      }
      function oo2(e16, t12, n11) {
        var r11 = -1, o11 = e16.length;
        t12 < 0 && (t12 = -t12 > o11 ? 0 : o11 + t12), (n11 = n11 > o11 ? o11 : n11) < 0 && (n11 += o11), o11 = t12 > n11 ? 0 : n11 - t12 >>> 0, t12 >>>= 0;
        var a11 = $10(o11);
        for (; ++r11 < o11; ) a11[r11] = e16[r11 + t12];
        return a11;
      }
      function ao2(e16, t12) {
        var n11;
        return mr2(e16, function(e17, r11, o11) {
          return !(n11 = t12(e17, r11, o11));
        }), !!n11;
      }
      function io2(e16, t12, n11) {
        var r11 = 0, o11 = null == e16 ? r11 : e16.length;
        if ("number" == typeof t12 && t12 == t12 && o11 <= 2147483647) {
          for (; r11 < o11; ) {
            var a11 = r11 + o11 >>> 1, i11 = e16[a11];
            null !== i11 && !cs2(i11) && (n11 ? i11 <= t12 : i11 < t12) ? r11 = a11 + 1 : o11 = a11;
          }
          return o11;
        }
        return so2(e16, t12, ol2, n11);
      }
      function so2(e16, t12, r11, o11) {
        var a11 = 0, i11 = null == e16 ? 0 : e16.length;
        if (0 === i11) return 0;
        var s11 = (t12 = r11(t12)) != t12, l11 = null === t12, c11 = cs2(t12), u11 = t12 === n10;
        for (; a11 < i11; ) {
          var d11 = gt3((a11 + i11) / 2), p11 = r11(e16[d11]), m11 = p11 !== n10, h11 = null === p11, f11 = p11 == p11, g11 = cs2(p11);
          if (s11) var y11 = o11 || f11;
          else y11 = u11 ? f11 && (o11 || m11) : l11 ? f11 && m11 && (o11 || !h11) : c11 ? f11 && m11 && !h11 && (o11 || !g11) : !h11 && !g11 && (o11 ? p11 <= t12 : p11 < t12);
          y11 ? a11 = d11 + 1 : i11 = d11;
        }
        return Sn2(i11, 4294967294);
      }
      function lo2(e16, t12) {
        var n11 = -1, r11 = e16.length, o11 = 0, a11 = [];
        for (; ++n11 < r11; ) {
          var i11 = e16[n11], s11 = t12 ? t12(i11) : i11;
          if (!n11 || !zi2(s11, l11)) {
            var l11 = s11;
            a11[o11++] = 0 === i11 ? 0 : i11;
          }
        }
        return a11;
      }
      function co2(e16) {
        return "number" == typeof e16 ? e16 : cs2(e16) ? m10 : +e16;
      }
      function uo2(e16) {
        if ("string" == typeof e16) return e16;
        if (Zi2(e16)) return It2(e16, uo2) + "";
        if (cs2(e16)) return Bn2 ? Bn2.call(e16) : "";
        var t12 = e16 + "";
        return "0" == t12 && 1 / e16 == -1 / 0 ? "-0" : t12;
      }
      function po2(e16, t12, n11) {
        var r11 = -1, o11 = Lt2, a11 = e16.length, i11 = true, s11 = [], l11 = s11;
        if (n11) i11 = false, o11 = Ht2;
        else if (a11 >= 200) {
          var c11 = t12 ? null : Xo2(e16);
          if (c11) return dn2(c11);
          i11 = false, o11 = en2, l11 = new Yn2();
        } else l11 = t12 ? [] : s11;
        e: for (; ++r11 < a11; ) {
          var u11 = e16[r11], d11 = t12 ? t12(u11) : u11;
          if (u11 = n11 || 0 !== u11 ? u11 : 0, i11 && d11 == d11) {
            var p11 = l11.length;
            for (; p11--; ) if (l11[p11] === d11) continue e;
            t12 && l11.push(d11), s11.push(u11);
          } else o11(l11, d11, n11) || (l11 !== s11 && l11.push(d11), s11.push(u11));
        }
        return s11;
      }
      function mo2(e16, t12) {
        return null == (e16 = Pa2(e16, t12 = Co2(t12, e16))) || delete e16[Aa2(Xa2(t12))];
      }
      function ho2(e16, t12, n11, r11) {
        return eo2(e16, t12, n11(Tr2(e16, t12)), r11);
      }
      function fo2(e16, t12, n11, r11) {
        var o11 = e16.length, a11 = r11 ? o11 : -1;
        for (; (r11 ? a11-- : ++a11 < o11) && t12(e16[a11], a11, e16); ) ;
        return n11 ? oo2(e16, r11 ? 0 : a11, r11 ? a11 + 1 : o11) : oo2(e16, r11 ? a11 + 1 : 0, r11 ? o11 : a11);
      }
      function go2(e16, t12) {
        var n11 = e16;
        return n11 instanceof Zn2 && (n11 = n11.value()), Vt2(t12, function(e17, t13) {
          return t13.func.apply(t13.thisArg, _t2([e17], t13.args));
        }, n11);
      }
      function yo2(e16, t12, n11) {
        var r11 = e16.length;
        if (r11 < 2) return r11 ? po2(e16[0]) : [];
        var o11 = -1, a11 = $10(r11);
        for (; ++o11 < r11; ) {
          var i11 = e16[o11], s11 = -1;
          for (; ++s11 < r11; ) s11 != o11 && (a11[o11] = pr2(a11[o11] || i11, e16[s11], t12, n11));
        }
        return po2(vr2(a11, 1), t12, n11);
      }
      function vo2(e16, t12, r11) {
        var o11 = -1, a11 = e16.length, i11 = t12.length, s11 = {};
        for (; ++o11 < a11; ) {
          var l11 = o11 < i11 ? t12[o11] : n10;
          r11(s11, e16[o11], l11);
        }
        return s11;
      }
      function bo2(e16) {
        return qi2(e16) ? e16 : [];
      }
      function So2(e16) {
        return "function" == typeof e16 ? e16 : ol2;
      }
      function Co2(e16, t12) {
        return Zi2(e16) ? e16 : xa2(e16, t12) ? [e16] : Ra2(bs2(e16));
      }
      var xo2 = Xr2;
      function wo2(e16, t12, r11) {
        var o11 = e16.length;
        return r11 = r11 === n10 ? o11 : r11, !t12 && r11 >= o11 ? e16 : oo2(e16, t12, r11);
      }
      var To2 = ct3 || function(e16) {
        return ht2.clearTimeout(e16);
      };
      function Eo2(e16, t12) {
        if (t12) return e16.slice();
        var n11 = e16.length, r11 = Ge3 ? Ge3(n11) : new e16.constructor(n11);
        return e16.copy(r11), r11;
      }
      function Fo2(e16) {
        var t12 = new e16.constructor(e16.byteLength);
        return new Ze3(t12).set(new Ze3(e16)), t12;
      }
      function Mo2(e16, t12) {
        var n11 = t12 ? Fo2(e16.buffer) : e16.buffer;
        return new e16.constructor(n11, e16.byteOffset, e16.length);
      }
      function ko2(e16, t12) {
        if (e16 !== t12) {
          var r11 = e16 !== n10, o11 = null === e16, a11 = e16 == e16, i11 = cs2(e16);
          var s11 = t12 !== n10, l11 = null === t12, c11 = t12 == t12, u11 = cs2(t12);
          if (!l11 && !u11 && !i11 && e16 > t12 || i11 && s11 && c11 && !l11 && !u11 || o11 && s11 && c11 || !r11 && c11 || !a11) return 1;
          if (!o11 && !i11 && !u11 && e16 < t12 || u11 && r11 && a11 && !o11 && !i11 || l11 && r11 && a11 || !s11 && a11 || !c11) return -1;
        }
        return 0;
      }
      function Po2(e16, t12, n11, r11) {
        var o11 = -1, a11 = e16.length, i11 = n11.length, s11 = -1, l11 = t12.length, c11 = bn2(a11 - i11, 0), u11 = $10(l11 + c11), d11 = !r11;
        for (; ++s11 < l11; ) u11[s11] = t12[s11];
        for (; ++o11 < i11; ) (d11 || o11 < a11) && (u11[n11[o11]] = e16[o11]);
        for (; c11--; ) u11[s11++] = e16[o11++];
        return u11;
      }
      function No2(e16, t12, n11, r11) {
        var o11 = -1, a11 = e16.length, i11 = -1, s11 = n11.length, l11 = -1, c11 = t12.length, u11 = bn2(a11 - s11, 0), d11 = $10(u11 + c11), p11 = !r11;
        for (; ++o11 < u11; ) d11[o11] = e16[o11];
        var m11 = o11;
        for (; ++l11 < c11; ) d11[m11 + l11] = t12[l11];
        for (; ++i11 < s11; ) (p11 || o11 < a11) && (d11[m11 + n11[i11]] = e16[o11++]);
        return d11;
      }
      function Do2(e16, t12) {
        var n11 = -1, r11 = e16.length;
        for (t12 || (t12 = $10(r11)); ++n11 < r11; ) t12[n11] = e16[n11];
        return t12;
      }
      function Lo2(e16, t12, r11, o11) {
        var a11 = !r11;
        r11 || (r11 = {});
        var i11 = -1, s11 = t12.length;
        for (; ++i11 < s11; ) {
          var l11 = t12[i11];
          var c11 = o11 ? o11(r11[l11], e16[l11], l11, r11, e16) : n10;
          c11 === n10 && (c11 = e16[l11]), a11 ? ir2(r11, l11, c11) : nr2(r11, l11, c11);
        }
        return r11;
      }
      function Ho2(e16, t12) {
        return function(n11, r11) {
          var o11 = Zi2(n11) ? Mt2 : or2, a11 = t12 ? t12() : {};
          return o11(n11, e16, ua2(r11, 2), a11);
        };
      }
      function Io2(e16) {
        return Xr2(function(t12, r11) {
          var o11 = -1, a11 = r11.length, i11 = a11 > 1 ? r11[a11 - 1] : n10, s11 = a11 > 2 ? r11[2] : n10;
          for (i11 = e16.length > 3 && "function" == typeof i11 ? (a11--, i11) : n10, s11 && Ca2(r11[0], r11[1], s11) && (i11 = a11 < 3 ? n10 : i11, a11 = 1), t12 = Fe3(t12); ++o11 < a11; ) {
            var l11 = r11[o11];
            l11 && e16(t12, l11, o11, i11);
          }
          return t12;
        });
      }
      function _o3(e16, t12) {
        return function(n11, r11) {
          if (null == n11) return n11;
          if (!Ui2(n11)) return e16(n11, r11);
          var o11 = n11.length, a11 = t12 ? o11 : -1, i11 = Fe3(n11);
          for (; (t12 ? a11-- : ++a11 < o11) && false !== r11(i11[a11], a11, i11); ) ;
          return n11;
        };
      }
      function Vo2(e16) {
        return function(t12, n11, r11) {
          var o11 = -1, a11 = Fe3(t12), i11 = r11(t12), s11 = i11.length;
          for (; s11--; ) {
            var l11 = i11[e16 ? s11 : ++o11];
            if (false === n11(a11[l11], l11, a11)) break;
          }
          return t12;
        };
      }
      function Ro2(e16) {
        return function(t12) {
          var r11 = sn2(t12 = bs2(t12)) ? hn2(t12) : n10;
          var o11 = r11 ? r11[0] : t12.charAt(0);
          var a11 = r11 ? wo2(r11, 1).join("") : t12.slice(1);
          return o11[e16]() + a11;
        };
      }
      function Ao2(e16) {
        return function(t12) {
          return Vt2(Js2(js2(t12).replace(Qe2, "")), e16, "");
        };
      }
      function Oo2(e16) {
        return function() {
          var t12 = arguments;
          switch (t12.length) {
            case 0:
              return new e16();
            case 1:
              return new e16(t12[0]);
            case 2:
              return new e16(t12[0], t12[1]);
            case 3:
              return new e16(t12[0], t12[1], t12[2]);
            case 4:
              return new e16(t12[0], t12[1], t12[2], t12[3]);
            case 5:
              return new e16(t12[0], t12[1], t12[2], t12[3], t12[4]);
            case 6:
              return new e16(t12[0], t12[1], t12[2], t12[3], t12[4], t12[5]);
            case 7:
              return new e16(t12[0], t12[1], t12[2], t12[3], t12[4], t12[5], t12[6]);
          }
          var n11 = $n2(e16.prototype), r11 = e16.apply(n11, t12);
          return ts2(r11) ? r11 : n11;
        };
      }
      function Bo2(e16) {
        return function(t12, r11, o11) {
          var a11 = Fe3(t12);
          if (!Ui2(t12)) {
            var i11 = ua2(r11, 3);
            t12 = Ls2(t12), r11 = function(e17) {
              return i11(a11[e17], e17, a11);
            };
          }
          var s11 = e16(t12, r11, o11);
          return s11 > -1 ? a11[i11 ? t12[s11] : s11] : n10;
        };
      }
      function zo2(e16) {
        return oa2(function(t12) {
          var o11 = t12.length, a11 = o11, i11 = jn2.prototype.thru;
          for (e16 && t12.reverse(); a11--; ) {
            var s11 = t12[a11];
            if ("function" != typeof s11) throw new Pe3(r10);
            if (i11 && !l11 && "wrapper" == la2(s11)) var l11 = new jn2([], true);
          }
          for (a11 = l11 ? a11 : o11; ++a11 < o11; ) {
            var c11 = la2(s11 = t12[a11]), u11 = "wrapper" == c11 ? sa2(s11) : n10;
            l11 = u11 && wa2(u11[0]) && 424 == u11[1] && !u11[4].length && 1 == u11[9] ? l11[la2(u11[0])].apply(l11, u11[3]) : 1 == s11.length && wa2(s11) ? l11[c11]() : l11.thru(s11);
          }
          return function() {
            var e17 = arguments, n11 = e17[0];
            if (l11 && 1 == e17.length && Zi2(n11)) return l11.plant(n11).value();
            var r11 = 0, a12 = o11 ? t12[r11].apply(this, e17) : n11;
            for (; ++r11 < o11; ) a12 = t12[r11].call(this, a12);
            return a12;
          };
        });
      }
      function $o2(e16, t12, r11, o11, a11, i11, s11, l11, u11, d11) {
        var p11 = t12 & c10, m11 = 1 & t12, h11 = 2 & t12, f11 = 24 & t12, g11 = 512 & t12, y11 = h11 ? n10 : Oo2(e16);
        return function c11() {
          var v11 = arguments.length, b11 = $10(v11), S11 = v11;
          for (; S11--; ) b11[S11] = arguments[S11];
          if (f11) var C11 = ca2(c11), x11 = function(e17, t13) {
            var n11 = e17.length, r12 = 0;
            for (; n11--; ) e17[n11] === t13 && ++r12;
            return r12;
          }(b11, C11);
          if (o11 && (b11 = Po2(b11, o11, a11, f11)), i11 && (b11 = No2(b11, i11, s11, f11)), v11 -= x11, f11 && v11 < d11) {
            var w11 = un2(b11, C11);
            return Yo2(e16, t12, $o2, c11.placeholder, r11, b11, w11, l11, u11, d11 - v11);
          }
          var T11 = m11 ? r11 : this, E11 = h11 ? T11[e16] : e16;
          return v11 = b11.length, l11 ? b11 = function(e17, t13) {
            var r12 = e17.length, o12 = Sn2(t13.length, r12), a12 = Do2(e17);
            for (; o12--; ) {
              var i12 = t13[o12];
              e17[o12] = Sa2(i12, r12) ? a12[i12] : n10;
            }
            return e17;
          }(b11, l11) : g11 && v11 > 1 && b11.reverse(), p11 && u11 < v11 && (b11.length = u11), this && this !== ht2 && this instanceof c11 && (E11 = y11 || Oo2(E11)), E11.apply(T11, b11);
        };
      }
      function Wo2(e16, t12) {
        return function(n11, r11) {
          return function(e17, t13, n12, r12) {
            return Cr2(e17, function(e18, o11, a11) {
              t13(r12, n12(e18), o11, a11);
            }), r12;
          }(n11, e16, t12(r11), {});
        };
      }
      function jo2(e16, t12) {
        return function(r11, o11) {
          var a11;
          if (r11 === n10 && o11 === n10) return t12;
          if (r11 !== n10 && (a11 = r11), o11 !== n10) {
            if (a11 === n10) return o11;
            "string" == typeof r11 || "string" == typeof o11 ? (r11 = uo2(r11), o11 = uo2(o11)) : (r11 = co2(r11), o11 = co2(o11)), a11 = e16(r11, o11);
          }
          return a11;
        };
      }
      function Zo2(e16) {
        return oa2(function(t12) {
          return t12 = It2(t12, Jt2(ua2())), Xr2(function(n11) {
            var r11 = this;
            return e16(t12, function(e17) {
              return Ft2(e17, r11, n11);
            });
          });
        });
      }
      function Go2(e16, t12) {
        var r11 = (t12 = t12 === n10 ? " " : uo2(t12)).length;
        if (r11 < 2) return r11 ? Kr2(t12, e16) : t12;
        var o11 = Kr2(t12, ft3(e16 / mn2(t12)));
        return sn2(t12) ? wo2(hn2(o11), 0, e16).join("") : o11.slice(0, e16);
      }
      function Uo2(e16) {
        return function(t12, r11, o11) {
          return o11 && "number" != typeof o11 && Ca2(t12, r11, o11) && (r11 = o11 = n10), t12 = hs2(t12), r11 === n10 ? (r11 = t12, t12 = 0) : r11 = hs2(r11), function(e17, t13, n11, r12) {
            var o12 = -1, a11 = bn2(ft3((t13 - e17) / (n11 || 1)), 0), i11 = $10(a11);
            for (; a11--; ) i11[r12 ? a11 : ++o12] = e17, e17 += n11;
            return i11;
          }(t12, r11, o11 = o11 === n10 ? t12 < r11 ? 1 : -1 : hs2(o11), e16);
        };
      }
      function qo2(e16) {
        return function(t12, n11) {
          return "string" == typeof t12 && "string" == typeof n11 || (t12 = ys2(t12), n11 = ys2(n11)), e16(t12, n11);
        };
      }
      function Yo2(e16, t12, r11, o11, a11, i11, c11, u11, d11, p11) {
        var m11 = 8 & t12;
        t12 |= m11 ? s10 : l10, 4 & (t12 &= ~(m11 ? l10 : s10)) || (t12 &= -4);
        var h11 = [e16, t12, a11, m11 ? i11 : n10, m11 ? c11 : n10, m11 ? n10 : i11, m11 ? n10 : c11, u11, d11, p11];
        var f11 = r11.apply(n10, h11);
        return wa2(e16) && Da2(f11, h11), f11.placeholder = o11, Ia2(f11, e16, t12);
      }
      function Ko2(e16) {
        var t12 = Ee3[e16];
        return function(e17, n11) {
          if (e17 = ys2(e17), (n11 = null == n11 ? 0 : Sn2(fs2(n11), 292)) && Ot3(e17)) {
            var r11 = (bs2(e17) + "e").split("e");
            return +((r11 = (bs2(t12(r11[0] + "e" + (+r11[1] + n11))) + "e").split("e"))[0] + "e" + (+r11[1] - n11));
          }
          return t12(e17);
        };
      }
      var Xo2 = kn2 && 1 / dn2(new kn2([, -0]))[1] == d10 ? function(e16) {
        return new kn2(e16);
      } : cl2;
      function Jo2(e16) {
        return function(t12) {
          var n11 = ga2(t12);
          return n11 == w10 ? ln2(t12) : n11 == k10 ? pn2(t12) : function(e17, t13) {
            return It2(t13, function(t14) {
              return [t14, e17[t14]];
            });
          }(t12, e16(t12));
        };
      }
      function Qo2(e16, t12, o11, d11, p11, m11, h11, f11) {
        var g11 = 2 & t12;
        if (!g11 && "function" != typeof e16) throw new Pe3(r10);
        var y11 = d11 ? d11.length : 0;
        if (y11 || (t12 &= -97, d11 = p11 = n10), h11 = h11 === n10 ? h11 : bn2(fs2(h11), 0), f11 = f11 === n10 ? f11 : fs2(f11), y11 -= p11 ? p11.length : 0, t12 & l10) {
          var v11 = d11, b11 = p11;
          d11 = p11 = n10;
        }
        var S11 = g11 ? n10 : sa2(e16);
        var C11 = [e16, t12, o11, d11, p11, v11, b11, m11, h11, f11];
        if (S11 && function(e17, t13) {
          var n11 = e17[1], r11 = t13[1], o12 = n11 | r11, i11 = o12 < 131;
          var s11 = r11 == c10 && 8 == n11 || r11 == c10 && n11 == u10 && e17[7].length <= t13[8] || 384 == r11 && t13[7].length <= t13[8] && 8 == n11;
          if (!i11 && !s11) return e17;
          1 & r11 && (e17[2] = t13[2], o12 |= 1 & n11 ? 0 : 4);
          var l11 = t13[3];
          if (l11) {
            var d12 = e17[3];
            e17[3] = d12 ? Po2(d12, l11, t13[4]) : l11, e17[4] = d12 ? un2(e17[3], a10) : t13[4];
          }
          l11 = t13[5], l11 && (d12 = e17[5], e17[5] = d12 ? No2(d12, l11, t13[6]) : l11, e17[6] = d12 ? un2(e17[5], a10) : t13[6]);
          l11 = t13[7], l11 && (e17[7] = l11);
          r11 & c10 && (e17[8] = null == e17[8] ? t13[8] : Sn2(e17[8], t13[8]));
          null == e17[9] && (e17[9] = t13[9]);
          e17[0] = t13[0], e17[1] = o12;
        }(C11, S11), e16 = C11[0], t12 = C11[1], o11 = C11[2], d11 = C11[3], p11 = C11[4], !(f11 = C11[9] = C11[9] === n10 ? g11 ? 0 : e16.length : bn2(C11[9] - y11, 0)) && 24 & t12 && (t12 &= -25), t12 && 1 != t12) x11 = 8 == t12 || t12 == i10 ? function(e17, t13, r11) {
          var o12 = Oo2(e17);
          return function a11() {
            var i11 = arguments.length, s11 = $10(i11), l11 = i11, c11 = ca2(a11);
            for (; l11--; ) s11[l11] = arguments[l11];
            var u11 = i11 < 3 && s11[0] !== c11 && s11[i11 - 1] !== c11 ? [] : un2(s11, c11);
            return (i11 -= u11.length) < r11 ? Yo2(e17, t13, $o2, a11.placeholder, n10, s11, u11, n10, n10, r11 - i11) : Ft2(this && this !== ht2 && this instanceof a11 ? o12 : e17, this, s11);
          };
        }(e16, t12, f11) : t12 != s10 && 33 != t12 || p11.length ? $o2.apply(n10, C11) : function(e17, t13, n11, r11) {
          var o12 = 1 & t13, a11 = Oo2(e17);
          return function t14() {
            var i11 = -1, s11 = arguments.length, l11 = -1, c11 = r11.length, u11 = $10(c11 + s11), d12 = this && this !== ht2 && this instanceof t14 ? a11 : e17;
            for (; ++l11 < c11; ) u11[l11] = r11[l11];
            for (; s11--; ) u11[l11++] = arguments[++i11];
            return Ft2(d12, o12 ? n11 : this, u11);
          };
        }(e16, t12, o11, d11);
        else var x11 = function(e17, t13, n11) {
          var r11 = 1 & t13, o12 = Oo2(e17);
          return function t14() {
            return (this && this !== ht2 && this instanceof t14 ? o12 : e17).apply(r11 ? n11 : this, arguments);
          };
        }(e16, t12, o11);
        return Ia2((S11 ? to2 : Da2)(x11, C11), e16, t12);
      }
      function ea2(e16, t12, r11, o11) {
        return e16 === n10 || zi2(e16, Le3[r11]) && !_e3.call(o11, r11) ? t12 : e16;
      }
      function ta2(e16, t12, r11, o11, a11, i11) {
        return ts2(e16) && ts2(t12) && (i11.set(t12, e16), Wr2(e16, t12, n10, ta2, i11), i11.delete(t12)), e16;
      }
      function na2(e16) {
        return as2(e16) ? n10 : e16;
      }
      function ra2(e16, t12, r11, o11, a11, i11) {
        var s11 = 1 & r11, l11 = e16.length, c11 = t12.length;
        if (l11 != c11 && !(s11 && c11 > l11)) return false;
        var u11 = i11.get(e16);
        var d11 = i11.get(t12);
        if (u11 && d11) return u11 == t12 && d11 == e16;
        var p11 = -1, m11 = true, h11 = 2 & r11 ? new Yn2() : n10;
        for (i11.set(e16, t12), i11.set(t12, e16); ++p11 < l11; ) {
          var f11 = e16[p11], g11 = t12[p11];
          if (o11) var y11 = s11 ? o11(g11, f11, p11, t12, e16, i11) : o11(f11, g11, p11, e16, t12, i11);
          if (y11 !== n10) {
            if (y11) continue;
            m11 = false;
            break;
          }
          if (h11) {
            if (!At2(t12, function(e17, t13) {
              if (!en2(h11, t13) && (f11 === e17 || a11(f11, e17, r11, o11, i11))) return h11.push(t13);
            })) {
              m11 = false;
              break;
            }
          } else if (f11 !== g11 && !a11(f11, g11, r11, o11, i11)) {
            m11 = false;
            break;
          }
        }
        return i11.delete(e16), i11.delete(t12), m11;
      }
      function oa2(e16) {
        return Ha2(ka2(e16, n10, Ga2), e16 + "");
      }
      function aa2(e16) {
        return Er2(e16, Ls2, ha2);
      }
      function ia2(e16) {
        return Er2(e16, Hs2, fa2);
      }
      var sa2 = Dn2 ? function(e16) {
        return Dn2.get(e16);
      } : cl2;
      function la2(e16) {
        var t12 = e16.name + "", n11 = Ln2[t12], r11 = _e3.call(Ln2, t12) ? n11.length : 0;
        for (; r11--; ) {
          var o11 = n11[r11], a11 = o11.func;
          if (null == a11 || a11 == e16) return o11.name;
        }
        return t12;
      }
      function ca2(e16) {
        return (_e3.call(zn2, "placeholder") ? zn2 : e16).placeholder;
      }
      function ua2() {
        var e16 = zn2.iteratee || al2;
        return e16 = e16 === al2 ? Vr2 : e16, arguments.length ? e16(arguments[0], arguments[1]) : e16;
      }
      function da2(e16, t12) {
        var n11 = e16.__data__;
        return function(e17) {
          var t13 = typeof e17;
          return "string" == t13 || "number" == t13 || "symbol" == t13 || "boolean" == t13 ? "__proto__" !== e17 : null === e17;
        }(t12) ? n11["string" == typeof t12 ? "string" : "hash"] : n11.map;
      }
      function pa2(e16) {
        var t12 = Ls2(e16), n11 = t12.length;
        for (; n11--; ) {
          var r11 = t12[n11], o11 = e16[r11];
          t12[n11] = [r11, o11, Fa2(o11)];
        }
        return t12;
      }
      function ma2(e16, t12) {
        var r11 = function(e17, t13) {
          return null == e17 ? n10 : e17[t13];
        }(e16, t12);
        return _r2(r11) ? r11 : n10;
      }
      var ha2 = vt3 ? function(e16) {
        return null == e16 ? [] : (e16 = Fe3(e16), Dt2(vt3(e16), function(t12) {
          return Ye3.call(e16, t12);
        }));
      } : gl2;
      var fa2 = vt3 ? function(e16) {
        var t12 = [];
        for (; e16; ) _t2(t12, ha2(e16)), e16 = Ue3(e16);
        return t12;
      } : gl2;
      var ga2 = Fr2;
      function ya2(e16, t12, n11) {
        var r11 = -1, o11 = (t12 = Co2(t12, e16)).length, a11 = false;
        for (; ++r11 < o11; ) {
          var i11 = Aa2(t12[r11]);
          if (!(a11 = null != e16 && n11(e16, i11))) break;
          e16 = e16[i11];
        }
        return a11 || ++r11 != o11 ? a11 : !!(o11 = null == e16 ? 0 : e16.length) && es2(o11) && Sa2(i11, o11) && (Zi2(e16) || ji2(e16));
      }
      function va2(e16) {
        return "function" != typeof e16.constructor || Ea2(e16) ? {} : $n2(Ue3(e16));
      }
      function ba2(e16) {
        return Zi2(e16) || ji2(e16) || !!(Xe3 && e16 && e16[Xe3]);
      }
      function Sa2(e16, t12) {
        var n11 = typeof e16;
        return !!(t12 = null == t12 ? p10 : t12) && ("number" == n11 || "symbol" != n11 && be2.test(e16)) && e16 > -1 && e16 % 1 == 0 && e16 < t12;
      }
      function Ca2(e16, t12, n11) {
        if (!ts2(n11)) return false;
        var r11 = typeof t12;
        return !!("number" == r11 ? Ui2(n11) && Sa2(t12, n11.length) : "string" == r11 && t12 in n11) && zi2(n11[t12], e16);
      }
      function xa2(e16, t12) {
        if (Zi2(e16)) return false;
        var n11 = typeof e16;
        return !("number" != n11 && "symbol" != n11 && "boolean" != n11 && null != e16 && !cs2(e16)) || (te2.test(e16) || !ee2.test(e16) || null != t12 && e16 in Fe3(t12));
      }
      function wa2(e16) {
        var t12 = la2(e16), n11 = zn2[t12];
        if ("function" != typeof n11 || !(t12 in Zn2.prototype)) return false;
        if (e16 === n11) return true;
        var r11 = sa2(n11);
        return !!r11 && e16 === r11[0];
      }
      (En2 && ga2(new En2(new ArrayBuffer(1))) != H10 || Fn2 && ga2(new Fn2()) != w10 || Mn2 && ga2(Mn2.resolve()) != F10 || kn2 && ga2(new kn2()) != k10 || Pn2 && ga2(new Pn2()) != D10) && (ga2 = function(e16) {
        var t12 = Fr2(e16), r11 = t12 == E10 ? e16.constructor : n10, o11 = r11 ? Oa2(r11) : "";
        if (o11) switch (o11) {
          case Hn2:
            return H10;
          case In2:
            return w10;
          case _n2:
            return F10;
          case Vn2:
            return k10;
          case Rn2:
            return D10;
        }
        return t12;
      });
      var Ta2 = He3 ? Ji2 : yl2;
      function Ea2(e16) {
        var t12 = e16 && e16.constructor;
        return e16 === ("function" == typeof t12 && t12.prototype || Le3);
      }
      function Fa2(e16) {
        return e16 == e16 && !ts2(e16);
      }
      function Ma2(e16, t12) {
        return function(r11) {
          return null != r11 && (r11[e16] === t12 && (t12 !== n10 || e16 in Fe3(r11)));
        };
      }
      function ka2(e16, t12, r11) {
        return t12 = bn2(t12 === n10 ? e16.length - 1 : t12, 0), function() {
          var n11 = arguments, o11 = -1, a11 = bn2(n11.length - t12, 0), i11 = $10(a11);
          for (; ++o11 < a11; ) i11[o11] = n11[t12 + o11];
          o11 = -1;
          var s11 = $10(t12 + 1);
          for (; ++o11 < t12; ) s11[o11] = n11[o11];
          return s11[t12] = r11(i11), Ft2(e16, this, s11);
        };
      }
      function Pa2(e16, t12) {
        return t12.length < 2 ? e16 : Tr2(e16, oo2(t12, 0, -1));
      }
      function Na2(e16, t12) {
        if (("constructor" !== t12 || "function" != typeof e16[t12]) && "__proto__" != t12) return e16[t12];
      }
      var Da2 = _a2(to2);
      var La2 = mt3 || function(e16, t12) {
        return ht2.setTimeout(e16, t12);
      };
      var Ha2 = _a2(no2);
      function Ia2(e16, t12, n11) {
        var r11 = t12 + "";
        return Ha2(e16, function(e17, t13) {
          var n12 = t13.length;
          if (!n12) return e17;
          var r12 = n12 - 1;
          return t13[r12] = (n12 > 1 ? "& " : "") + t13[r12], t13 = t13.join(n12 > 2 ? ", " : " "), e17.replace(se2, "{\n/* [wrapped with " + t13 + "] */\n");
        }(r11, function(e17, t13) {
          return kt2(f10, function(n12) {
            var r12 = "_." + n12[0];
            t13 & n12[1] && !Lt2(e17, r12) && e17.push(r12);
          }), e17.sort();
        }(function(e17) {
          var t13 = e17.match(le2);
          return t13 ? t13[1].split(ce2) : [];
        }(r11), n11)));
      }
      function _a2(e16) {
        var t12 = 0, r11 = 0;
        return function() {
          var o11 = Cn2(), a11 = 16 - (o11 - r11);
          if (r11 = o11, a11 > 0) {
            if (++t12 >= 800) return arguments[0];
          } else t12 = 0;
          return e16.apply(n10, arguments);
        };
      }
      function Va2(e16, t12) {
        var r11 = -1, o11 = e16.length, a11 = o11 - 1;
        for (t12 = t12 === n10 ? o11 : t12; ++r11 < t12; ) {
          var i11 = Yr2(r11, a11), s11 = e16[i11];
          e16[i11] = e16[r11], e16[r11] = s11;
        }
        return e16.length = t12, e16;
      }
      var Ra2 = function(e16) {
        var t12 = _i2(e16, function(e17) {
          return 500 === n11.size && n11.clear(), e17;
        });
        var n11 = t12.cache;
        return t12;
      }(function(e16) {
        var t12 = [];
        return 46 === e16.charCodeAt(0) && t12.push(""), e16.replace(ne2, function(e17, n11, r11, o11) {
          t12.push(r11 ? o11.replace(pe2, "$1") : n11 || e17);
        }), t12;
      });
      function Aa2(e16) {
        if ("string" == typeof e16 || cs2(e16)) return e16;
        var t12 = e16 + "";
        return "0" == t12 && 1 / e16 == -1 / 0 ? "-0" : t12;
      }
      function Oa2(e16) {
        if (null != e16) {
          try {
            return Ie3.call(e16);
          } catch (e17) {
          }
          try {
            return e16 + "";
          } catch (e17) {
          }
        }
        return "";
      }
      function Ba2(e16) {
        if (e16 instanceof Zn2) return e16.clone();
        var t12 = new jn2(e16.__wrapped__, e16.__chain__);
        return t12.__actions__ = Do2(e16.__actions__), t12.__index__ = e16.__index__, t12.__values__ = e16.__values__, t12;
      }
      var za2 = Xr2(function(e16, t12) {
        return qi2(e16) ? pr2(e16, vr2(t12, 1, qi2, true)) : [];
      });
      var $a2 = Xr2(function(e16, t12) {
        var r11 = Xa2(t12);
        return qi2(r11) && (r11 = n10), qi2(e16) ? pr2(e16, vr2(t12, 1, qi2, true), ua2(r11, 2)) : [];
      });
      var Wa2 = Xr2(function(e16, t12) {
        var r11 = Xa2(t12);
        return qi2(r11) && (r11 = n10), qi2(e16) ? pr2(e16, vr2(t12, 1, qi2, true), n10, r11) : [];
      });
      function ja2(e16, t12, n11) {
        var r11 = null == e16 ? 0 : e16.length;
        if (!r11) return -1;
        var o11 = null == n11 ? 0 : fs2(n11);
        return o11 < 0 && (o11 = bn2(r11 + o11, 0)), zt2(e16, ua2(t12, 3), o11);
      }
      function Za2(e16, t12, r11) {
        var o11 = null == e16 ? 0 : e16.length;
        if (!o11) return -1;
        var a11 = o11 - 1;
        return r11 !== n10 && (a11 = fs2(r11), a11 = r11 < 0 ? bn2(o11 + a11, 0) : Sn2(a11, o11 - 1)), zt2(e16, ua2(t12, 3), a11, true);
      }
      function Ga2(e16) {
        return (null == e16 ? 0 : e16.length) ? vr2(e16, 1) : [];
      }
      function Ua2(e16) {
        return e16 && e16.length ? e16[0] : n10;
      }
      var qa2 = Xr2(function(e16) {
        var t12 = It2(e16, bo2);
        return t12.length && t12[0] === e16[0] ? Nr2(t12) : [];
      });
      var Ya2 = Xr2(function(e16) {
        var t12 = Xa2(e16), r11 = It2(e16, bo2);
        return t12 === Xa2(r11) ? t12 = n10 : r11.pop(), r11.length && r11[0] === e16[0] ? Nr2(r11, ua2(t12, 2)) : [];
      });
      var Ka2 = Xr2(function(e16) {
        var t12 = Xa2(e16), r11 = It2(e16, bo2);
        return (t12 = "function" == typeof t12 ? t12 : n10) && r11.pop(), r11.length && r11[0] === e16[0] ? Nr2(r11, n10, t12) : [];
      });
      function Xa2(e16) {
        var t12 = null == e16 ? 0 : e16.length;
        return t12 ? e16[t12 - 1] : n10;
      }
      var Ja2 = Xr2(Qa2);
      function Qa2(e16, t12) {
        return e16 && e16.length && t12 && t12.length ? Ur2(e16, t12) : e16;
      }
      var ei2 = oa2(function(e16, t12) {
        var n11 = null == e16 ? 0 : e16.length, r11 = sr2(e16, t12);
        return qr2(e16, It2(t12, function(e17) {
          return Sa2(e17, n11) ? +e17 : e17;
        }).sort(ko2)), r11;
      });
      function ti2(e16) {
        return null == e16 ? e16 : Tn2.call(e16);
      }
      var ni2 = Xr2(function(e16) {
        return po2(vr2(e16, 1, qi2, true));
      });
      var ri2 = Xr2(function(e16) {
        var t12 = Xa2(e16);
        return qi2(t12) && (t12 = n10), po2(vr2(e16, 1, qi2, true), ua2(t12, 2));
      });
      var oi2 = Xr2(function(e16) {
        var t12 = Xa2(e16);
        return t12 = "function" == typeof t12 ? t12 : n10, po2(vr2(e16, 1, qi2, true), n10, t12);
      });
      function ai2(e16) {
        if (!e16 || !e16.length) return [];
        var t12 = 0;
        return e16 = Dt2(e16, function(e17) {
          if (qi2(e17)) return t12 = bn2(e17.length, t12), true;
        }), Kt2(t12, function(t13) {
          return It2(e16, Gt2(t13));
        });
      }
      function ii2(e16, t12) {
        if (!e16 || !e16.length) return [];
        var r11 = ai2(e16);
        return null == t12 ? r11 : It2(r11, function(e17) {
          return Ft2(t12, n10, e17);
        });
      }
      var si2 = Xr2(function(e16, t12) {
        return qi2(e16) ? pr2(e16, t12) : [];
      });
      var li2 = Xr2(function(e16) {
        return yo2(Dt2(e16, qi2));
      });
      var ci2 = Xr2(function(e16) {
        var t12 = Xa2(e16);
        return qi2(t12) && (t12 = n10), yo2(Dt2(e16, qi2), ua2(t12, 2));
      });
      var ui2 = Xr2(function(e16) {
        var t12 = Xa2(e16);
        return t12 = "function" == typeof t12 ? t12 : n10, yo2(Dt2(e16, qi2), n10, t12);
      });
      var di2 = Xr2(ai2);
      var pi2 = Xr2(function(e16) {
        var t12 = e16.length, r11 = t12 > 1 ? e16[t12 - 1] : n10;
        return r11 = "function" == typeof r11 ? (e16.pop(), r11) : n10, ii2(e16, r11);
      });
      function mi2(e16) {
        var t12 = zn2(e16);
        return t12.__chain__ = true, t12;
      }
      function hi2(e16, t12) {
        return t12(e16);
      }
      var fi2 = oa2(function(e16) {
        var t12 = e16.length, r11 = t12 ? e16[0] : 0, o11 = this.__wrapped__, a11 = function(t13) {
          return sr2(t13, e16);
        };
        return !(t12 > 1 || this.__actions__.length) && o11 instanceof Zn2 && Sa2(r11) ? ((o11 = o11.slice(r11, +r11 + (t12 ? 1 : 0))).__actions__.push({ func: hi2, args: [a11], thisArg: n10 }), new jn2(o11, this.__chain__).thru(function(e17) {
          return t12 && !e17.length && e17.push(n10), e17;
        })) : this.thru(a11);
      });
      var gi2 = Ho2(function(e16, t12, n11) {
        _e3.call(e16, n11) ? ++e16[n11] : ir2(e16, n11, 1);
      });
      var yi2 = Bo2(ja2);
      var vi2 = Bo2(Za2);
      function bi2(e16, t12) {
        return (Zi2(e16) ? kt2 : mr2)(e16, ua2(t12, 3));
      }
      function Si2(e16, t12) {
        return (Zi2(e16) ? Pt2 : hr2)(e16, ua2(t12, 3));
      }
      var Ci2 = Ho2(function(e16, t12, n11) {
        _e3.call(e16, n11) ? e16[n11].push(t12) : ir2(e16, n11, [t12]);
      });
      var xi2 = Xr2(function(e16, t12, n11) {
        var r11 = -1, o11 = "function" == typeof t12, a11 = Ui2(e16) ? $10(e16.length) : [];
        return mr2(e16, function(e17) {
          a11[++r11] = o11 ? Ft2(t12, e17, n11) : Dr2(e17, t12, n11);
        }), a11;
      });
      var wi2 = Ho2(function(e16, t12, n11) {
        ir2(e16, n11, t12);
      });
      function Ti2(e16, t12) {
        return (Zi2(e16) ? It2 : Br2)(e16, ua2(t12, 3));
      }
      var Ei2 = Ho2(function(e16, t12, n11) {
        e16[n11 ? 0 : 1].push(t12);
      }, function() {
        return [[], []];
      });
      var Fi2 = Xr2(function(e16, t12) {
        if (null == e16) return [];
        var n11 = t12.length;
        return n11 > 1 && Ca2(e16, t12[0], t12[1]) ? t12 = [] : n11 > 2 && Ca2(t12[0], t12[1], t12[2]) && (t12 = [t12[0]]), Zr2(e16, vr2(t12, 1), []);
      });
      var Mi2 = pt3 || function() {
        return ht2.Date.now();
      };
      function ki2(e16, t12, r11) {
        return t12 = r11 ? n10 : t12, t12 = e16 && null == t12 ? e16.length : t12, Qo2(e16, c10, n10, n10, n10, n10, t12);
      }
      function Pi2(e16, t12) {
        var o11;
        if ("function" != typeof t12) throw new Pe3(r10);
        return e16 = fs2(e16), function() {
          return --e16 > 0 && (o11 = t12.apply(this, arguments)), e16 <= 1 && (t12 = n10), o11;
        };
      }
      var Ni2 = Xr2(function(e16, t12, n11) {
        var r11 = 1;
        if (n11.length) {
          var o11 = un2(n11, ca2(Ni2));
          r11 |= s10;
        }
        return Qo2(e16, r11, t12, n11, o11);
      });
      var Di2 = Xr2(function(e16, t12, n11) {
        var r11 = 3;
        if (n11.length) {
          var o11 = un2(n11, ca2(Di2));
          r11 |= s10;
        }
        return Qo2(t12, r11, e16, n11, o11);
      });
      function Li2(e16, t12, o11) {
        var a11, i11, s11, l11, c11, u11, d11 = 0, p11 = false, m11 = false, h11 = true;
        if ("function" != typeof e16) throw new Pe3(r10);
        function f11(t13) {
          var r11 = a11, o12 = i11;
          return a11 = i11 = n10, d11 = t13, l11 = e16.apply(o12, r11);
        }
        function g11(e17) {
          var r11 = e17 - u11;
          return u11 === n10 || r11 >= t12 || r11 < 0 || m11 && e17 - d11 >= s11;
        }
        function y11() {
          var e17 = Mi2();
          if (g11(e17)) return v11(e17);
          c11 = La2(y11, function(e18) {
            var n11 = t12 - (e18 - u11);
            return m11 ? Sn2(n11, s11 - (e18 - d11)) : n11;
          }(e17));
        }
        function v11(e17) {
          return c11 = n10, h11 && a11 ? f11(e17) : (a11 = i11 = n10, l11);
        }
        function b11() {
          var e17 = Mi2(), r11 = g11(e17);
          if (a11 = arguments, i11 = this, u11 = e17, r11) {
            if (c11 === n10) return function(e18) {
              return d11 = e18, c11 = La2(y11, t12), p11 ? f11(e18) : l11;
            }(u11);
            if (m11) return To2(c11), c11 = La2(y11, t12), f11(u11);
          }
          return c11 === n10 && (c11 = La2(y11, t12)), l11;
        }
        return t12 = ys2(t12) || 0, ts2(o11) && (p11 = !!o11.leading, s11 = (m11 = "maxWait" in o11) ? bn2(ys2(o11.maxWait) || 0, t12) : s11, h11 = "trailing" in o11 ? !!o11.trailing : h11), b11.cancel = function() {
          c11 !== n10 && To2(c11), d11 = 0, a11 = u11 = i11 = c11 = n10;
        }, b11.flush = function() {
          return c11 === n10 ? l11 : v11(Mi2());
        }, b11;
      }
      var Hi2 = Xr2(function(e16, t12) {
        return dr2(e16, 1, t12);
      });
      var Ii2 = Xr2(function(e16, t12, n11) {
        return dr2(e16, ys2(t12) || 0, n11);
      });
      function _i2(e16, t12) {
        if ("function" != typeof e16 || null != t12 && "function" != typeof t12) throw new Pe3(r10);
        var n11 = function() {
          var r11 = arguments, o11 = t12 ? t12.apply(this, r11) : r11[0], a11 = n11.cache;
          if (a11.has(o11)) return a11.get(o11);
          var i11 = e16.apply(this, r11);
          return n11.cache = a11.set(o11, i11) || a11, i11;
        };
        return n11.cache = new (_i2.Cache || qn2)(), n11;
      }
      function Vi2(e16) {
        if ("function" != typeof e16) throw new Pe3(r10);
        return function() {
          var t12 = arguments;
          switch (t12.length) {
            case 0:
              return !e16.call(this);
            case 1:
              return !e16.call(this, t12[0]);
            case 2:
              return !e16.call(this, t12[0], t12[1]);
            case 3:
              return !e16.call(this, t12[0], t12[1], t12[2]);
          }
          return !e16.apply(this, t12);
        };
      }
      _i2.Cache = qn2;
      var Ri2 = xo2(function(e16, t12) {
        var n11 = (t12 = 1 == t12.length && Zi2(t12[0]) ? It2(t12[0], Jt2(ua2())) : It2(vr2(t12, 1), Jt2(ua2()))).length;
        return Xr2(function(r11) {
          var o11 = -1, a11 = Sn2(r11.length, n11);
          for (; ++o11 < a11; ) r11[o11] = t12[o11].call(this, r11[o11]);
          return Ft2(e16, this, r11);
        });
      });
      var Ai2 = Xr2(function(e16, t12) {
        var r11 = un2(t12, ca2(Ai2));
        return Qo2(e16, s10, n10, t12, r11);
      });
      var Oi2 = Xr2(function(e16, t12) {
        var r11 = un2(t12, ca2(Oi2));
        return Qo2(e16, l10, n10, t12, r11);
      });
      var Bi2 = oa2(function(e16, t12) {
        return Qo2(e16, u10, n10, n10, n10, t12);
      });
      function zi2(e16, t12) {
        return e16 === t12 || e16 != e16 && t12 != t12;
      }
      var $i2 = qo2(Mr2);
      var Wi2 = qo2(function(e16, t12) {
        return e16 >= t12;
      });
      var ji2 = Lr2(/* @__PURE__ */ function() {
        return arguments;
      }()) ? Lr2 : function(e16) {
        return ns2(e16) && _e3.call(e16, "callee") && !Ye3.call(e16, "callee");
      };
      var Zi2 = $10.isArray;
      var Gi2 = St2 ? Jt2(St2) : function(e16) {
        return ns2(e16) && Fr2(e16) == L10;
      };
      function Ui2(e16) {
        return null != e16 && es2(e16.length) && !Ji2(e16);
      }
      function qi2(e16) {
        return ns2(e16) && Ui2(e16);
      }
      var Yi2 = bt3 || yl2;
      var Ki2 = Ct2 ? Jt2(Ct2) : function(e16) {
        return ns2(e16) && Fr2(e16) == b10;
      };
      function Xi2(e16) {
        if (!ns2(e16)) return false;
        var t12 = Fr2(e16);
        return t12 == S10 || "[object DOMException]" == t12 || "string" == typeof e16.message && "string" == typeof e16.name && !as2(e16);
      }
      function Ji2(e16) {
        if (!ts2(e16)) return false;
        var t12 = Fr2(e16);
        return t12 == C10 || t12 == x10 || "[object AsyncFunction]" == t12 || "[object Proxy]" == t12;
      }
      function Qi2(e16) {
        return "number" == typeof e16 && e16 == fs2(e16);
      }
      function es2(e16) {
        return "number" == typeof e16 && e16 > -1 && e16 % 1 == 0 && e16 <= p10;
      }
      function ts2(e16) {
        var t12 = typeof e16;
        return null != e16 && ("object" == t12 || "function" == t12);
      }
      function ns2(e16) {
        return null != e16 && "object" == typeof e16;
      }
      var rs2 = xt2 ? Jt2(xt2) : function(e16) {
        return ns2(e16) && ga2(e16) == w10;
      };
      function os2(e16) {
        return "number" == typeof e16 || ns2(e16) && Fr2(e16) == T10;
      }
      function as2(e16) {
        if (!ns2(e16) || Fr2(e16) != E10) return false;
        var t12 = Ue3(e16);
        if (null === t12) return true;
        var n11 = _e3.call(t12, "constructor") && t12.constructor;
        return "function" == typeof n11 && n11 instanceof n11 && Ie3.call(n11) == Be3;
      }
      var is2 = wt2 ? Jt2(wt2) : function(e16) {
        return ns2(e16) && Fr2(e16) == M10;
      };
      var ss2 = Tt2 ? Jt2(Tt2) : function(e16) {
        return ns2(e16) && ga2(e16) == k10;
      };
      function ls2(e16) {
        return "string" == typeof e16 || !Zi2(e16) && ns2(e16) && Fr2(e16) == P10;
      }
      function cs2(e16) {
        return "symbol" == typeof e16 || ns2(e16) && Fr2(e16) == N10;
      }
      var us2 = Et2 ? Jt2(Et2) : function(e16) {
        return ns2(e16) && es2(e16.length) && !!st2[Fr2(e16)];
      };
      var ds2 = qo2(Or2);
      var ps2 = qo2(function(e16, t12) {
        return e16 <= t12;
      });
      function ms2(e16) {
        if (!e16) return [];
        if (Ui2(e16)) return ls2(e16) ? hn2(e16) : Do2(e16);
        if (Je3 && e16[Je3]) return function(e17) {
          var t13, n11 = [];
          for (; !(t13 = e17.next()).done; ) n11.push(t13.value);
          return n11;
        }(e16[Je3]());
        var t12 = ga2(e16);
        return (t12 == w10 ? ln2 : t12 == k10 ? dn2 : zs2)(e16);
      }
      function hs2(e16) {
        return e16 ? (e16 = ys2(e16)) === d10 || e16 === -1 / 0 ? 17976931348623157e292 * (e16 < 0 ? -1 : 1) : e16 == e16 ? e16 : 0 : 0 === e16 ? e16 : 0;
      }
      function fs2(e16) {
        var t12 = hs2(e16), n11 = t12 % 1;
        return t12 == t12 ? n11 ? t12 - n11 : t12 : 0;
      }
      function gs2(e16) {
        return e16 ? lr2(fs2(e16), 0, h10) : 0;
      }
      function ys2(e16) {
        if ("number" == typeof e16) return e16;
        if (cs2(e16)) return m10;
        if (ts2(e16)) {
          var t12 = "function" == typeof e16.valueOf ? e16.valueOf() : e16;
          e16 = ts2(t12) ? t12 + "" : t12;
        }
        if ("string" != typeof e16) return 0 === e16 ? e16 : +e16;
        e16 = Xt2(e16);
        var n11 = ge2.test(e16);
        return n11 || ve2.test(e16) ? dt2(e16.slice(2), n11 ? 2 : 8) : fe2.test(e16) ? m10 : +e16;
      }
      function vs2(e16) {
        return Lo2(e16, Hs2(e16));
      }
      function bs2(e16) {
        return null == e16 ? "" : uo2(e16);
      }
      var Ss2 = Io2(function(e16, t12) {
        if (Ea2(t12) || Ui2(t12)) Lo2(t12, Ls2(t12), e16);
        else for (var n11 in t12) _e3.call(t12, n11) && nr2(e16, n11, t12[n11]);
      });
      var Cs2 = Io2(function(e16, t12) {
        Lo2(t12, Hs2(t12), e16);
      });
      var xs2 = Io2(function(e16, t12, n11, r11) {
        Lo2(t12, Hs2(t12), e16, r11);
      });
      var ws2 = Io2(function(e16, t12, n11, r11) {
        Lo2(t12, Ls2(t12), e16, r11);
      });
      var Ts2 = oa2(sr2);
      var Es2 = Xr2(function(e16, t12) {
        e16 = Fe3(e16);
        var r11 = -1;
        var o11 = t12.length;
        var a11 = o11 > 2 ? t12[2] : n10;
        for (a11 && Ca2(t12[0], t12[1], a11) && (o11 = 1); ++r11 < o11; ) {
          var i11 = t12[r11];
          var s11 = Hs2(i11);
          var l11 = -1;
          var c11 = s11.length;
          for (; ++l11 < c11; ) {
            var u11 = s11[l11];
            var d11 = e16[u11];
            (d11 === n10 || zi2(d11, Le3[u11]) && !_e3.call(e16, u11)) && (e16[u11] = i11[u11]);
          }
        }
        return e16;
      });
      var Fs2 = Xr2(function(e16) {
        return e16.push(n10, ta2), Ft2(_s2, n10, e16);
      });
      function Ms2(e16, t12, r11) {
        var o11 = null == e16 ? n10 : Tr2(e16, t12);
        return o11 === n10 ? r11 : o11;
      }
      function ks2(e16, t12) {
        return null != e16 && ya2(e16, t12, Pr2);
      }
      var Ps2 = Wo2(function(e16, t12, n11) {
        null != t12 && "function" != typeof t12.toString && (t12 = Oe3.call(t12)), e16[t12] = n11;
      }, tl2(ol2));
      var Ns2 = Wo2(function(e16, t12, n11) {
        null != t12 && "function" != typeof t12.toString && (t12 = Oe3.call(t12)), _e3.call(e16, t12) ? e16[t12].push(n11) : e16[t12] = [n11];
      }, ua2);
      var Ds2 = Xr2(Dr2);
      function Ls2(e16) {
        return Ui2(e16) ? Xn2(e16) : Rr2(e16);
      }
      function Hs2(e16) {
        return Ui2(e16) ? Xn2(e16, true) : Ar2(e16);
      }
      var Is2 = Io2(function(e16, t12, n11) {
        Wr2(e16, t12, n11);
      });
      var _s2 = Io2(function(e16, t12, n11, r11) {
        Wr2(e16, t12, n11, r11);
      });
      var Vs2 = oa2(function(e16, t12) {
        var n11 = {};
        if (null == e16) return n11;
        var r11 = false;
        t12 = It2(t12, function(t13) {
          return t13 = Co2(t13, e16), r11 || (r11 = t13.length > 1), t13;
        }), Lo2(e16, ia2(e16), n11), r11 && (n11 = cr2(n11, 7, na2));
        var o11 = t12.length;
        for (; o11--; ) mo2(n11, t12[o11]);
        return n11;
      });
      var Rs2 = oa2(function(e16, t12) {
        return null == e16 ? {} : function(e17, t13) {
          return Gr2(e17, t13, function(t14, n11) {
            return ks2(e17, n11);
          });
        }(e16, t12);
      });
      function As2(e16, t12) {
        if (null == e16) return {};
        var n11 = It2(ia2(e16), function(e17) {
          return [e17];
        });
        return t12 = ua2(t12), Gr2(e16, n11, function(e17, n12) {
          return t12(e17, n12[0]);
        });
      }
      var Os2 = Jo2(Ls2);
      var Bs2 = Jo2(Hs2);
      function zs2(e16) {
        return null == e16 ? [] : Qt2(e16, Ls2(e16));
      }
      var $s2 = Ao2(function(e16, t12, n11) {
        return t12 = t12.toLowerCase(), e16 + (n11 ? Ws2(t12) : t12);
      });
      function Ws2(e16) {
        return Xs2(bs2(e16).toLowerCase());
      }
      function js2(e16) {
        return (e16 = bs2(e16)) && e16.replace(Se2, rn2).replace(et2, "");
      }
      var Zs2 = Ao2(function(e16, t12, n11) {
        return e16 + (n11 ? "-" : "") + t12.toLowerCase();
      });
      var Gs2 = Ao2(function(e16, t12, n11) {
        return e16 + (n11 ? " " : "") + t12.toLowerCase();
      });
      var Us2 = Ro2("toLowerCase");
      var qs2 = Ao2(function(e16, t12, n11) {
        return e16 + (n11 ? "_" : "") + t12.toLowerCase();
      });
      var Ys2 = Ao2(function(e16, t12, n11) {
        return e16 + (n11 ? " " : "") + Xs2(t12);
      });
      var Ks2 = Ao2(function(e16, t12, n11) {
        return e16 + (n11 ? " " : "") + t12.toUpperCase();
      });
      var Xs2 = Ro2("toUpperCase");
      function Js2(e16, t12, r11) {
        return e16 = bs2(e16), (t12 = r11 ? n10 : t12) === n10 ? function(e17) {
          return ot2.test(e17);
        }(e16) ? function(e17) {
          return e17.match(nt2) || [];
        }(e16) : function(e17) {
          return e17.match(ue2) || [];
        }(e16) : e16.match(t12) || [];
      }
      var Qs2 = Xr2(function(e16, t12) {
        try {
          return Ft2(e16, n10, t12);
        } catch (e17) {
          return Xi2(e17) ? e17 : new we3(e17);
        }
      });
      var el2 = oa2(function(e16, t12) {
        return kt2(t12, function(t13) {
          t13 = Aa2(t13), ir2(e16, t13, Ni2(e16[t13], e16));
        }), e16;
      });
      function tl2(e16) {
        return function() {
          return e16;
        };
      }
      var nl2 = zo2();
      var rl2 = zo2(true);
      function ol2(e16) {
        return e16;
      }
      function al2(e16) {
        return Vr2("function" == typeof e16 ? e16 : cr2(e16, 1));
      }
      var il2 = Xr2(function(e16, t12) {
        return function(n11) {
          return Dr2(n11, e16, t12);
        };
      });
      var sl2 = Xr2(function(e16, t12) {
        return function(n11) {
          return Dr2(e16, n11, t12);
        };
      });
      function ll2(e16, t12, n11) {
        var r11 = Ls2(t12), o11 = wr2(t12, r11);
        null != n11 || ts2(t12) && (o11.length || !r11.length) || (n11 = t12, t12 = e16, e16 = this, o11 = wr2(t12, Ls2(t12)));
        var a11 = !(ts2(n11) && "chain" in n11 && !n11.chain), i11 = Ji2(e16);
        return kt2(o11, function(n12) {
          var r12 = t12[n12];
          e16[n12] = r12, i11 && (e16.prototype[n12] = function() {
            var t13 = this.__chain__;
            if (a11 || t13) {
              var n13 = e16(this.__wrapped__);
              return (n13.__actions__ = Do2(this.__actions__)).push({ func: r12, args: arguments, thisArg: e16 }), n13.__chain__ = t13, n13;
            }
            return r12.apply(e16, _t2([this.value()], arguments));
          });
        }), e16;
      }
      function cl2() {
      }
      var ul2 = Zo2(It2);
      var dl2 = Zo2(Nt2);
      var pl2 = Zo2(At2);
      function ml2(e16) {
        return xa2(e16) ? Gt2(Aa2(e16)) : /* @__PURE__ */ function(e17) {
          return function(t12) {
            return Tr2(t12, e17);
          };
        }(e16);
      }
      var hl2 = Uo2();
      var fl2 = Uo2(true);
      function gl2() {
        return [];
      }
      function yl2() {
        return false;
      }
      var vl2 = jo2(function(e16, t12) {
        return e16 + t12;
      }, 0);
      var bl2 = Ko2("ceil");
      var Sl2 = jo2(function(e16, t12) {
        return e16 / t12;
      }, 1);
      var Cl2 = Ko2("floor");
      var xl2 = jo2(function(e16, t12) {
        return e16 * t12;
      }, 1);
      var wl2 = Ko2("round");
      var Tl2 = jo2(function(e16, t12) {
        return e16 - t12;
      }, 0);
      return zn2.after = function(e16, t12) {
        if ("function" != typeof t12) throw new Pe3(r10);
        return e16 = fs2(e16), function() {
          if (--e16 < 1) return t12.apply(this, arguments);
        };
      }, zn2.ary = ki2, zn2.assign = Ss2, zn2.assignIn = Cs2, zn2.assignInWith = xs2, zn2.assignWith = ws2, zn2.at = Ts2, zn2.before = Pi2, zn2.bind = Ni2, zn2.bindAll = el2, zn2.bindKey = Di2, zn2.castArray = function() {
        if (!arguments.length) return [];
        var e16 = arguments[0];
        return Zi2(e16) ? e16 : [e16];
      }, zn2.chain = mi2, zn2.chunk = function(e16, t12, r11) {
        t12 = (r11 ? Ca2(e16, t12, r11) : t12 === n10) ? 1 : bn2(fs2(t12), 0);
        var o11 = null == e16 ? 0 : e16.length;
        if (!o11 || t12 < 1) return [];
        var a11 = 0, i11 = 0, s11 = $10(ft3(o11 / t12));
        for (; a11 < o11; ) s11[i11++] = oo2(e16, a11, a11 += t12);
        return s11;
      }, zn2.compact = function(e16) {
        var t12 = -1, n11 = null == e16 ? 0 : e16.length, r11 = 0, o11 = [];
        for (; ++t12 < n11; ) {
          var a11 = e16[t12];
          a11 && (o11[r11++] = a11);
        }
        return o11;
      }, zn2.concat = function() {
        var e16 = arguments.length;
        if (!e16) return [];
        var t12 = $10(e16 - 1), n11 = arguments[0], r11 = e16;
        for (; r11--; ) t12[r11 - 1] = arguments[r11];
        return _t2(Zi2(n11) ? Do2(n11) : [n11], vr2(t12, 1));
      }, zn2.cond = function(e16) {
        var t12 = null == e16 ? 0 : e16.length, n11 = ua2();
        return e16 = t12 ? It2(e16, function(e17) {
          if ("function" != typeof e17[1]) throw new Pe3(r10);
          return [n11(e17[0]), e17[1]];
        }) : [], Xr2(function(n12) {
          var r11 = -1;
          for (; ++r11 < t12; ) {
            var o11 = e16[r11];
            if (Ft2(o11[0], this, n12)) return Ft2(o11[1], this, n12);
          }
        });
      }, zn2.conforms = function(e16) {
        return function(e17) {
          var t12 = Ls2(e17);
          return function(n11) {
            return ur2(n11, e17, t12);
          };
        }(cr2(e16, 1));
      }, zn2.constant = tl2, zn2.countBy = gi2, zn2.create = function(e16, t12) {
        var n11 = $n2(e16);
        return null == t12 ? n11 : ar2(n11, t12);
      }, zn2.curry = function e16(t12, r11, o11) {
        var a11 = Qo2(t12, 8, n10, n10, n10, n10, n10, r11 = o11 ? n10 : r11);
        return a11.placeholder = e16.placeholder, a11;
      }, zn2.curryRight = function e16(t12, r11, o11) {
        var a11 = Qo2(t12, i10, n10, n10, n10, n10, n10, r11 = o11 ? n10 : r11);
        return a11.placeholder = e16.placeholder, a11;
      }, zn2.debounce = Li2, zn2.defaults = Es2, zn2.defaultsDeep = Fs2, zn2.defer = Hi2, zn2.delay = Ii2, zn2.difference = za2, zn2.differenceBy = $a2, zn2.differenceWith = Wa2, zn2.drop = function(e16, t12, r11) {
        var o11 = null == e16 ? 0 : e16.length;
        return o11 ? oo2(e16, (t12 = r11 || t12 === n10 ? 1 : fs2(t12)) < 0 ? 0 : t12, o11) : [];
      }, zn2.dropRight = function(e16, t12, r11) {
        var o11 = null == e16 ? 0 : e16.length;
        return o11 ? oo2(e16, 0, (t12 = o11 - (t12 = r11 || t12 === n10 ? 1 : fs2(t12))) < 0 ? 0 : t12) : [];
      }, zn2.dropRightWhile = function(e16, t12) {
        return e16 && e16.length ? fo2(e16, ua2(t12, 3), true, true) : [];
      }, zn2.dropWhile = function(e16, t12) {
        return e16 && e16.length ? fo2(e16, ua2(t12, 3), true) : [];
      }, zn2.fill = function(e16, t12, r11, o11) {
        var a11 = null == e16 ? 0 : e16.length;
        return a11 ? (r11 && "number" != typeof r11 && Ca2(e16, t12, r11) && (r11 = 0, o11 = a11), function(e17, t13, r12, o12) {
          var a12 = e17.length;
          for ((r12 = fs2(r12)) < 0 && (r12 = -r12 > a12 ? 0 : a12 + r12), (o12 = o12 === n10 || o12 > a12 ? a12 : fs2(o12)) < 0 && (o12 += a12), o12 = r12 > o12 ? 0 : gs2(o12); r12 < o12; ) e17[r12++] = t13;
          return e17;
        }(e16, t12, r11, o11)) : [];
      }, zn2.filter = function(e16, t12) {
        return (Zi2(e16) ? Dt2 : yr2)(e16, ua2(t12, 3));
      }, zn2.flatMap = function(e16, t12) {
        return vr2(Ti2(e16, t12), 1);
      }, zn2.flatMapDeep = function(e16, t12) {
        return vr2(Ti2(e16, t12), d10);
      }, zn2.flatMapDepth = function(e16, t12, r11) {
        return r11 = r11 === n10 ? 1 : fs2(r11), vr2(Ti2(e16, t12), r11);
      }, zn2.flatten = Ga2, zn2.flattenDeep = function(e16) {
        return (null == e16 ? 0 : e16.length) ? vr2(e16, d10) : [];
      }, zn2.flattenDepth = function(e16, t12) {
        return (null == e16 ? 0 : e16.length) ? vr2(e16, t12 = t12 === n10 ? 1 : fs2(t12)) : [];
      }, zn2.flip = function(e16) {
        return Qo2(e16, 512);
      }, zn2.flow = nl2, zn2.flowRight = rl2, zn2.fromPairs = function(e16) {
        var t12 = -1, n11 = null == e16 ? 0 : e16.length, r11 = {};
        for (; ++t12 < n11; ) {
          var o11 = e16[t12];
          r11[o11[0]] = o11[1];
        }
        return r11;
      }, zn2.functions = function(e16) {
        return null == e16 ? [] : wr2(e16, Ls2(e16));
      }, zn2.functionsIn = function(e16) {
        return null == e16 ? [] : wr2(e16, Hs2(e16));
      }, zn2.groupBy = Ci2, zn2.initial = function(e16) {
        return (null == e16 ? 0 : e16.length) ? oo2(e16, 0, -1) : [];
      }, zn2.intersection = qa2, zn2.intersectionBy = Ya2, zn2.intersectionWith = Ka2, zn2.invert = Ps2, zn2.invertBy = Ns2, zn2.invokeMap = xi2, zn2.iteratee = al2, zn2.keyBy = wi2, zn2.keys = Ls2, zn2.keysIn = Hs2, zn2.map = Ti2, zn2.mapKeys = function(e16, t12) {
        var n11 = {};
        return t12 = ua2(t12, 3), Cr2(e16, function(e17, r11, o11) {
          ir2(n11, t12(e17, r11, o11), e17);
        }), n11;
      }, zn2.mapValues = function(e16, t12) {
        var n11 = {};
        return t12 = ua2(t12, 3), Cr2(e16, function(e17, r11, o11) {
          ir2(n11, r11, t12(e17, r11, o11));
        }), n11;
      }, zn2.matches = function(e16) {
        return zr2(cr2(e16, 1));
      }, zn2.matchesProperty = function(e16, t12) {
        return $r2(e16, cr2(t12, 1));
      }, zn2.memoize = _i2, zn2.merge = Is2, zn2.mergeWith = _s2, zn2.method = il2, zn2.methodOf = sl2, zn2.mixin = ll2, zn2.negate = Vi2, zn2.nthArg = function(e16) {
        return e16 = fs2(e16), Xr2(function(t12) {
          return jr2(t12, e16);
        });
      }, zn2.omit = Vs2, zn2.omitBy = function(e16, t12) {
        return As2(e16, Vi2(ua2(t12)));
      }, zn2.once = function(e16) {
        return Pi2(2, e16);
      }, zn2.orderBy = function(e16, t12, r11, o11) {
        return null == e16 ? [] : (Zi2(t12) || (t12 = null == t12 ? [] : [t12]), Zi2(r11 = o11 ? n10 : r11) || (r11 = null == r11 ? [] : [r11]), Zr2(e16, t12, r11));
      }, zn2.over = ul2, zn2.overArgs = Ri2, zn2.overEvery = dl2, zn2.overSome = pl2, zn2.partial = Ai2, zn2.partialRight = Oi2, zn2.partition = Ei2, zn2.pick = Rs2, zn2.pickBy = As2, zn2.property = ml2, zn2.propertyOf = function(e16) {
        return function(t12) {
          return null == e16 ? n10 : Tr2(e16, t12);
        };
      }, zn2.pull = Ja2, zn2.pullAll = Qa2, zn2.pullAllBy = function(e16, t12, n11) {
        return e16 && e16.length && t12 && t12.length ? Ur2(e16, t12, ua2(n11, 2)) : e16;
      }, zn2.pullAllWith = function(e16, t12, r11) {
        return e16 && e16.length && t12 && t12.length ? Ur2(e16, t12, n10, r11) : e16;
      }, zn2.pullAt = ei2, zn2.range = hl2, zn2.rangeRight = fl2, zn2.rearg = Bi2, zn2.reject = function(e16, t12) {
        return (Zi2(e16) ? Dt2 : yr2)(e16, Vi2(ua2(t12, 3)));
      }, zn2.remove = function(e16, t12) {
        var n11 = [];
        if (!e16 || !e16.length) return n11;
        var r11 = -1, o11 = [], a11 = e16.length;
        for (t12 = ua2(t12, 3); ++r11 < a11; ) {
          var i11 = e16[r11];
          t12(i11, r11, e16) && (n11.push(i11), o11.push(r11));
        }
        return qr2(e16, o11), n11;
      }, zn2.rest = function(e16, t12) {
        if ("function" != typeof e16) throw new Pe3(r10);
        return Xr2(e16, t12 = t12 === n10 ? t12 : fs2(t12));
      }, zn2.reverse = ti2, zn2.sampleSize = function(e16, t12, r11) {
        return t12 = (r11 ? Ca2(e16, t12, r11) : t12 === n10) ? 1 : fs2(t12), (Zi2(e16) ? Qn2 : Qr2)(e16, t12);
      }, zn2.set = function(e16, t12, n11) {
        return null == e16 ? e16 : eo2(e16, t12, n11);
      }, zn2.setWith = function(e16, t12, r11, o11) {
        return o11 = "function" == typeof o11 ? o11 : n10, null == e16 ? e16 : eo2(e16, t12, r11, o11);
      }, zn2.shuffle = function(e16) {
        return (Zi2(e16) ? er2 : ro2)(e16);
      }, zn2.slice = function(e16, t12, r11) {
        var o11 = null == e16 ? 0 : e16.length;
        return o11 ? (r11 && "number" != typeof r11 && Ca2(e16, t12, r11) ? (t12 = 0, r11 = o11) : (t12 = null == t12 ? 0 : fs2(t12), r11 = r11 === n10 ? o11 : fs2(r11)), oo2(e16, t12, r11)) : [];
      }, zn2.sortBy = Fi2, zn2.sortedUniq = function(e16) {
        return e16 && e16.length ? lo2(e16) : [];
      }, zn2.sortedUniqBy = function(e16, t12) {
        return e16 && e16.length ? lo2(e16, ua2(t12, 2)) : [];
      }, zn2.split = function(e16, t12, r11) {
        return r11 && "number" != typeof r11 && Ca2(e16, t12, r11) && (t12 = r11 = n10), (r11 = r11 === n10 ? h10 : r11 >>> 0) ? (e16 = bs2(e16)) && ("string" == typeof t12 || null != t12 && !is2(t12)) && !(t12 = uo2(t12)) && sn2(e16) ? wo2(hn2(e16), 0, r11) : e16.split(t12, r11) : [];
      }, zn2.spread = function(e16, t12) {
        if ("function" != typeof e16) throw new Pe3(r10);
        return t12 = null == t12 ? 0 : bn2(fs2(t12), 0), Xr2(function(n11) {
          var r11 = n11[t12], o11 = wo2(n11, 0, t12);
          return r11 && _t2(o11, r11), Ft2(e16, this, o11);
        });
      }, zn2.tail = function(e16) {
        var t12 = null == e16 ? 0 : e16.length;
        return t12 ? oo2(e16, 1, t12) : [];
      }, zn2.take = function(e16, t12, r11) {
        return e16 && e16.length ? oo2(e16, 0, (t12 = r11 || t12 === n10 ? 1 : fs2(t12)) < 0 ? 0 : t12) : [];
      }, zn2.takeRight = function(e16, t12, r11) {
        var o11 = null == e16 ? 0 : e16.length;
        return o11 ? oo2(e16, (t12 = o11 - (t12 = r11 || t12 === n10 ? 1 : fs2(t12))) < 0 ? 0 : t12, o11) : [];
      }, zn2.takeRightWhile = function(e16, t12) {
        return e16 && e16.length ? fo2(e16, ua2(t12, 3), false, true) : [];
      }, zn2.takeWhile = function(e16, t12) {
        return e16 && e16.length ? fo2(e16, ua2(t12, 3)) : [];
      }, zn2.tap = function(e16, t12) {
        return t12(e16), e16;
      }, zn2.throttle = function(e16, t12, n11) {
        var o11 = true, a11 = true;
        if ("function" != typeof e16) throw new Pe3(r10);
        return ts2(n11) && (o11 = "leading" in n11 ? !!n11.leading : o11, a11 = "trailing" in n11 ? !!n11.trailing : a11), Li2(e16, t12, { leading: o11, maxWait: t12, trailing: a11 });
      }, zn2.thru = hi2, zn2.toArray = ms2, zn2.toPairs = Os2, zn2.toPairsIn = Bs2, zn2.toPath = function(e16) {
        return Zi2(e16) ? It2(e16, Aa2) : cs2(e16) ? [e16] : Do2(Ra2(bs2(e16)));
      }, zn2.toPlainObject = vs2, zn2.transform = function(e16, t12, n11) {
        var r11 = Zi2(e16), o11 = r11 || Yi2(e16) || us2(e16);
        if (t12 = ua2(t12, 4), null == n11) {
          var a11 = e16 && e16.constructor;
          n11 = o11 ? r11 ? new a11() : [] : ts2(e16) && Ji2(a11) ? $n2(Ue3(e16)) : {};
        }
        return (o11 ? kt2 : Cr2)(e16, function(e17, r12, o12) {
          return t12(n11, e17, r12, o12);
        }), n11;
      }, zn2.unary = function(e16) {
        return ki2(e16, 1);
      }, zn2.union = ni2, zn2.unionBy = ri2, zn2.unionWith = oi2, zn2.uniq = function(e16) {
        return e16 && e16.length ? po2(e16) : [];
      }, zn2.uniqBy = function(e16, t12) {
        return e16 && e16.length ? po2(e16, ua2(t12, 2)) : [];
      }, zn2.uniqWith = function(e16, t12) {
        return t12 = "function" == typeof t12 ? t12 : n10, e16 && e16.length ? po2(e16, n10, t12) : [];
      }, zn2.unset = function(e16, t12) {
        return null == e16 || mo2(e16, t12);
      }, zn2.unzip = ai2, zn2.unzipWith = ii2, zn2.update = function(e16, t12, n11) {
        return null == e16 ? e16 : ho2(e16, t12, So2(n11));
      }, zn2.updateWith = function(e16, t12, r11, o11) {
        return o11 = "function" == typeof o11 ? o11 : n10, null == e16 ? e16 : ho2(e16, t12, So2(r11), o11);
      }, zn2.values = zs2, zn2.valuesIn = function(e16) {
        return null == e16 ? [] : Qt2(e16, Hs2(e16));
      }, zn2.without = si2, zn2.words = Js2, zn2.wrap = function(e16, t12) {
        return Ai2(So2(t12), e16);
      }, zn2.xor = li2, zn2.xorBy = ci2, zn2.xorWith = ui2, zn2.zip = di2, zn2.zipObject = function(e16, t12) {
        return vo2(e16 || [], t12 || [], nr2);
      }, zn2.zipObjectDeep = function(e16, t12) {
        return vo2(e16 || [], t12 || [], eo2);
      }, zn2.zipWith = pi2, zn2.entries = Os2, zn2.entriesIn = Bs2, zn2.extend = Cs2, zn2.extendWith = xs2, ll2(zn2, zn2), zn2.add = vl2, zn2.attempt = Qs2, zn2.camelCase = $s2, zn2.capitalize = Ws2, zn2.ceil = bl2, zn2.clamp = function(e16, t12, r11) {
        return r11 === n10 && (r11 = t12, t12 = n10), r11 !== n10 && (r11 = (r11 = ys2(r11)) == r11 ? r11 : 0), t12 !== n10 && (t12 = (t12 = ys2(t12)) == t12 ? t12 : 0), lr2(ys2(e16), t12, r11);
      }, zn2.clone = function(e16) {
        return cr2(e16, 4);
      }, zn2.cloneDeep = function(e16) {
        return cr2(e16, 5);
      }, zn2.cloneDeepWith = function(e16, t12) {
        return cr2(e16, 5, t12 = "function" == typeof t12 ? t12 : n10);
      }, zn2.cloneWith = function(e16, t12) {
        return cr2(e16, 4, t12 = "function" == typeof t12 ? t12 : n10);
      }, zn2.conformsTo = function(e16, t12) {
        return null == t12 || ur2(e16, t12, Ls2(t12));
      }, zn2.deburr = js2, zn2.defaultTo = function(e16, t12) {
        return null == e16 || e16 != e16 ? t12 : e16;
      }, zn2.divide = Sl2, zn2.endsWith = function(e16, t12, r11) {
        e16 = bs2(e16), t12 = uo2(t12);
        var o11 = e16.length;
        var a11 = r11 = r11 === n10 ? o11 : lr2(fs2(r11), 0, o11);
        return (r11 -= t12.length) >= 0 && e16.slice(r11, a11) == t12;
      }, zn2.eq = zi2, zn2.escape = function(e16) {
        return (e16 = bs2(e16)) && K10.test(e16) ? e16.replace(q10, on2) : e16;
      }, zn2.escapeRegExp = function(e16) {
        return (e16 = bs2(e16)) && oe2.test(e16) ? e16.replace(re2, "\\$&") : e16;
      }, zn2.every = function(e16, t12, r11) {
        var o11 = Zi2(e16) ? Nt2 : fr2;
        return r11 && Ca2(e16, t12, r11) && (t12 = n10), o11(e16, ua2(t12, 3));
      }, zn2.find = yi2, zn2.findIndex = ja2, zn2.findKey = function(e16, t12) {
        return Bt2(e16, ua2(t12, 3), Cr2);
      }, zn2.findLast = vi2, zn2.findLastIndex = Za2, zn2.findLastKey = function(e16, t12) {
        return Bt2(e16, ua2(t12, 3), xr2);
      }, zn2.floor = Cl2, zn2.forEach = bi2, zn2.forEachRight = Si2, zn2.forIn = function(e16, t12) {
        return null == e16 ? e16 : br2(e16, ua2(t12, 3), Hs2);
      }, zn2.forInRight = function(e16, t12) {
        return null == e16 ? e16 : Sr2(e16, ua2(t12, 3), Hs2);
      }, zn2.forOwn = function(e16, t12) {
        return e16 && Cr2(e16, ua2(t12, 3));
      }, zn2.forOwnRight = function(e16, t12) {
        return e16 && xr2(e16, ua2(t12, 3));
      }, zn2.get = Ms2, zn2.gt = $i2, zn2.gte = Wi2, zn2.has = function(e16, t12) {
        return null != e16 && ya2(e16, t12, kr2);
      }, zn2.hasIn = ks2, zn2.head = Ua2, zn2.identity = ol2, zn2.includes = function(e16, t12, n11, r11) {
        e16 = Ui2(e16) ? e16 : zs2(e16), n11 = n11 && !r11 ? fs2(n11) : 0;
        var o11 = e16.length;
        return n11 < 0 && (n11 = bn2(o11 + n11, 0)), ls2(e16) ? n11 <= o11 && e16.indexOf(t12, n11) > -1 : !!o11 && $t2(e16, t12, n11) > -1;
      }, zn2.indexOf = function(e16, t12, n11) {
        var r11 = null == e16 ? 0 : e16.length;
        if (!r11) return -1;
        var o11 = null == n11 ? 0 : fs2(n11);
        return o11 < 0 && (o11 = bn2(r11 + o11, 0)), $t2(e16, t12, o11);
      }, zn2.inRange = function(e16, t12, r11) {
        return t12 = hs2(t12), r11 === n10 ? (r11 = t12, t12 = 0) : r11 = hs2(r11), function(e17, t13, n11) {
          return e17 >= Sn2(t13, n11) && e17 < bn2(t13, n11);
        }(e16 = ys2(e16), t12, r11);
      }, zn2.invoke = Ds2, zn2.isArguments = ji2, zn2.isArray = Zi2, zn2.isArrayBuffer = Gi2, zn2.isArrayLike = Ui2, zn2.isArrayLikeObject = qi2, zn2.isBoolean = function(e16) {
        return true === e16 || false === e16 || ns2(e16) && Fr2(e16) == v10;
      }, zn2.isBuffer = Yi2, zn2.isDate = Ki2, zn2.isElement = function(e16) {
        return ns2(e16) && 1 === e16.nodeType && !as2(e16);
      }, zn2.isEmpty = function(e16) {
        if (null == e16) return true;
        if (Ui2(e16) && (Zi2(e16) || "string" == typeof e16 || "function" == typeof e16.splice || Yi2(e16) || us2(e16) || ji2(e16))) return !e16.length;
        var t12 = ga2(e16);
        if (t12 == w10 || t12 == k10) return !e16.size;
        if (Ea2(e16)) return !Rr2(e16).length;
        for (var n11 in e16) if (_e3.call(e16, n11)) return false;
        return true;
      }, zn2.isEqual = function(e16, t12) {
        return Hr2(e16, t12);
      }, zn2.isEqualWith = function(e16, t12, r11) {
        var o11 = (r11 = "function" == typeof r11 ? r11 : n10) ? r11(e16, t12) : n10;
        return o11 === n10 ? Hr2(e16, t12, n10, r11) : !!o11;
      }, zn2.isError = Xi2, zn2.isFinite = function(e16) {
        return "number" == typeof e16 && Ot3(e16);
      }, zn2.isFunction = Ji2, zn2.isInteger = Qi2, zn2.isLength = es2, zn2.isMap = rs2, zn2.isMatch = function(e16, t12) {
        return e16 === t12 || Ir2(e16, t12, pa2(t12));
      }, zn2.isMatchWith = function(e16, t12, r11) {
        return r11 = "function" == typeof r11 ? r11 : n10, Ir2(e16, t12, pa2(t12), r11);
      }, zn2.isNaN = function(e16) {
        return os2(e16) && e16 != +e16;
      }, zn2.isNative = function(e16) {
        if (Ta2(e16)) throw new we3("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
        return _r2(e16);
      }, zn2.isNil = function(e16) {
        return null == e16;
      }, zn2.isNull = function(e16) {
        return null === e16;
      }, zn2.isNumber = os2, zn2.isObject = ts2, zn2.isObjectLike = ns2, zn2.isPlainObject = as2, zn2.isRegExp = is2, zn2.isSafeInteger = function(e16) {
        return Qi2(e16) && e16 >= -9007199254740991 && e16 <= p10;
      }, zn2.isSet = ss2, zn2.isString = ls2, zn2.isSymbol = cs2, zn2.isTypedArray = us2, zn2.isUndefined = function(e16) {
        return e16 === n10;
      }, zn2.isWeakMap = function(e16) {
        return ns2(e16) && ga2(e16) == D10;
      }, zn2.isWeakSet = function(e16) {
        return ns2(e16) && "[object WeakSet]" == Fr2(e16);
      }, zn2.join = function(e16, t12) {
        return null == e16 ? "" : Ut3.call(e16, t12);
      }, zn2.kebabCase = Zs2, zn2.last = Xa2, zn2.lastIndexOf = function(e16, t12, r11) {
        var o11 = null == e16 ? 0 : e16.length;
        if (!o11) return -1;
        var a11 = o11;
        return r11 !== n10 && (a11 = (a11 = fs2(r11)) < 0 ? bn2(o11 + a11, 0) : Sn2(a11, o11 - 1)), t12 == t12 ? function(e17, t13, n11) {
          var r12 = n11 + 1;
          for (; r12--; ) if (e17[r12] === t13) return r12;
          return r12;
        }(e16, t12, a11) : zt2(e16, jt2, a11, true);
      }, zn2.lowerCase = Gs2, zn2.lowerFirst = Us2, zn2.lt = ds2, zn2.lte = ps2, zn2.max = function(e16) {
        return e16 && e16.length ? gr2(e16, ol2, Mr2) : n10;
      }, zn2.maxBy = function(e16, t12) {
        return e16 && e16.length ? gr2(e16, ua2(t12, 2), Mr2) : n10;
      }, zn2.mean = function(e16) {
        return Zt2(e16, ol2);
      }, zn2.meanBy = function(e16, t12) {
        return Zt2(e16, ua2(t12, 2));
      }, zn2.min = function(e16) {
        return e16 && e16.length ? gr2(e16, ol2, Or2) : n10;
      }, zn2.minBy = function(e16, t12) {
        return e16 && e16.length ? gr2(e16, ua2(t12, 2), Or2) : n10;
      }, zn2.stubArray = gl2, zn2.stubFalse = yl2, zn2.stubObject = function() {
        return {};
      }, zn2.stubString = function() {
        return "";
      }, zn2.stubTrue = function() {
        return true;
      }, zn2.multiply = xl2, zn2.nth = function(e16, t12) {
        return e16 && e16.length ? jr2(e16, fs2(t12)) : n10;
      }, zn2.noConflict = function() {
        return ht2._ === this && (ht2._ = ze3), this;
      }, zn2.noop = cl2, zn2.now = Mi2, zn2.pad = function(e16, t12, n11) {
        e16 = bs2(e16);
        var r11 = (t12 = fs2(t12)) ? mn2(e16) : 0;
        if (!t12 || r11 >= t12) return e16;
        var o11 = (t12 - r11) / 2;
        return Go2(gt3(o11), n11) + e16 + Go2(ft3(o11), n11);
      }, zn2.padEnd = function(e16, t12, n11) {
        e16 = bs2(e16);
        var r11 = (t12 = fs2(t12)) ? mn2(e16) : 0;
        return t12 && r11 < t12 ? e16 + Go2(t12 - r11, n11) : e16;
      }, zn2.padStart = function(e16, t12, n11) {
        e16 = bs2(e16);
        var r11 = (t12 = fs2(t12)) ? mn2(e16) : 0;
        return t12 && r11 < t12 ? Go2(t12 - r11, n11) + e16 : e16;
      }, zn2.parseInt = function(e16, t12, n11) {
        return n11 || null == t12 ? t12 = 0 : t12 && (t12 = +t12), xn2(bs2(e16).replace(ae2, ""), t12 || 0);
      }, zn2.random = function(e16, t12, r11) {
        if (r11 && "boolean" != typeof r11 && Ca2(e16, t12, r11) && (t12 = r11 = n10), r11 === n10 && ("boolean" == typeof t12 ? (r11 = t12, t12 = n10) : "boolean" == typeof e16 && (r11 = e16, e16 = n10)), e16 === n10 && t12 === n10 ? (e16 = 0, t12 = 1) : (e16 = hs2(e16), t12 === n10 ? (t12 = e16, e16 = 0) : t12 = hs2(t12)), e16 > t12) {
          var o11 = e16;
          e16 = t12, t12 = o11;
        }
        if (r11 || e16 % 1 || t12 % 1) {
          var a11 = wn2();
          return Sn2(e16 + a11 * (t12 - e16 + ut2("1e-" + ((a11 + "").length - 1))), t12);
        }
        return Yr2(e16, t12);
      }, zn2.reduce = function(e16, t12, n11) {
        var r11 = Zi2(e16) ? Vt2 : qt2, o11 = arguments.length < 3;
        return r11(e16, ua2(t12, 4), n11, o11, mr2);
      }, zn2.reduceRight = function(e16, t12, n11) {
        var r11 = Zi2(e16) ? Rt2 : qt2, o11 = arguments.length < 3;
        return r11(e16, ua2(t12, 4), n11, o11, hr2);
      }, zn2.repeat = function(e16, t12, r11) {
        return t12 = (r11 ? Ca2(e16, t12, r11) : t12 === n10) ? 1 : fs2(t12), Kr2(bs2(e16), t12);
      }, zn2.replace = function() {
        var e16 = arguments, t12 = bs2(e16[0]);
        return e16.length < 3 ? t12 : t12.replace(e16[1], e16[2]);
      }, zn2.result = function(e16, t12, r11) {
        var o11 = -1, a11 = (t12 = Co2(t12, e16)).length;
        for (a11 || (a11 = 1, e16 = n10); ++o11 < a11; ) {
          var i11 = null == e16 ? n10 : e16[Aa2(t12[o11])];
          i11 === n10 && (o11 = a11, i11 = r11), e16 = Ji2(i11) ? i11.call(e16) : i11;
        }
        return e16;
      }, zn2.round = wl2, zn2.runInContext = e15, zn2.sample = function(e16) {
        return (Zi2(e16) ? Jn2 : Jr2)(e16);
      }, zn2.size = function(e16) {
        if (null == e16) return 0;
        if (Ui2(e16)) return ls2(e16) ? mn2(e16) : e16.length;
        var t12 = ga2(e16);
        return t12 == w10 || t12 == k10 ? e16.size : Rr2(e16).length;
      }, zn2.snakeCase = qs2, zn2.some = function(e16, t12, r11) {
        var o11 = Zi2(e16) ? At2 : ao2;
        return r11 && Ca2(e16, t12, r11) && (t12 = n10), o11(e16, ua2(t12, 3));
      }, zn2.sortedIndex = function(e16, t12) {
        return io2(e16, t12);
      }, zn2.sortedIndexBy = function(e16, t12, n11) {
        return so2(e16, t12, ua2(n11, 2));
      }, zn2.sortedIndexOf = function(e16, t12) {
        var n11 = null == e16 ? 0 : e16.length;
        if (n11) {
          var r11 = io2(e16, t12);
          if (r11 < n11 && zi2(e16[r11], t12)) return r11;
        }
        return -1;
      }, zn2.sortedLastIndex = function(e16, t12) {
        return io2(e16, t12, true);
      }, zn2.sortedLastIndexBy = function(e16, t12, n11) {
        return so2(e16, t12, ua2(n11, 2), true);
      }, zn2.sortedLastIndexOf = function(e16, t12) {
        if (null == e16 ? 0 : e16.length) {
          var n11 = io2(e16, t12, true) - 1;
          if (zi2(e16[n11], t12)) return n11;
        }
        return -1;
      }, zn2.startCase = Ys2, zn2.startsWith = function(e16, t12, n11) {
        return e16 = bs2(e16), n11 = null == n11 ? 0 : lr2(fs2(n11), 0, e16.length), t12 = uo2(t12), e16.slice(n11, n11 + t12.length) == t12;
      }, zn2.subtract = Tl2, zn2.sum = function(e16) {
        return e16 && e16.length ? Yt2(e16, ol2) : 0;
      }, zn2.sumBy = function(e16, t12) {
        return e16 && e16.length ? Yt2(e16, ua2(t12, 2)) : 0;
      }, zn2.template = function(e16, t12, r11) {
        var o11 = zn2.templateSettings;
        r11 && Ca2(e16, t12, r11) && (t12 = n10), e16 = bs2(e16), t12 = xs2({}, t12, o11, ea2);
        var a11 = xs2({}, t12.imports, o11.imports, ea2), i11 = Ls2(a11), s11 = Qt2(a11, i11);
        var l11, c11, u11 = 0, d11 = t12.interpolate || Ce2, p11 = "__p += '";
        var m11 = Me3((t12.escape || Ce2).source + "|" + d11.source + "|" + (d11 === Q10 ? me2 : Ce2).source + "|" + (t12.evaluate || Ce2).source + "|$", "g");
        var h11 = "//# sourceURL=" + (_e3.call(t12, "sourceURL") ? (t12.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++it2 + "]") + "\n";
        e16.replace(m11, function(t13, n11, r12, o12, a12, i12) {
          return r12 || (r12 = o12), p11 += e16.slice(u11, i12).replace(xe2, an2), n11 && (l11 = true, p11 += "' +\n__e(" + n11 + ") +\n'"), a12 && (c11 = true, p11 += "';\n" + a12 + ";\n__p += '"), r12 && (p11 += "' +\n((__t = (" + r12 + ")) == null ? '' : __t) +\n'"), u11 = i12 + t13.length, t13;
        }), p11 += "';\n";
        var f11 = _e3.call(t12, "variable") && t12.variable;
        if (f11) {
          if (de2.test(f11)) throw new we3("Invalid `variable` option passed into `_.template`");
        } else p11 = "with (obj) {\n" + p11 + "\n}\n";
        p11 = (c11 ? p11.replace(j10, "") : p11).replace(Z10, "$1").replace(G10, "$1;"), p11 = "function(" + (f11 || "obj") + ") {\n" + (f11 ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (l11 ? ", __e = _.escape" : "") + (c11 ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + p11 + "return __p\n}";
        var g11 = Qs2(function() {
          return Te3(i11, h11 + "return " + p11).apply(n10, s11);
        });
        if (g11.source = p11, Xi2(g11)) throw g11;
        return g11;
      }, zn2.times = function(e16, t12) {
        if ((e16 = fs2(e16)) < 1 || e16 > p10) return [];
        var n11 = h10, r11 = Sn2(e16, h10);
        t12 = ua2(t12), e16 -= h10;
        var o11 = Kt2(r11, t12);
        for (; ++n11 < e16; ) t12(n11);
        return o11;
      }, zn2.toFinite = hs2, zn2.toInteger = fs2, zn2.toLength = gs2, zn2.toLower = function(e16) {
        return bs2(e16).toLowerCase();
      }, zn2.toNumber = ys2, zn2.toSafeInteger = function(e16) {
        return e16 ? lr2(fs2(e16), -9007199254740991, p10) : 0 === e16 ? e16 : 0;
      }, zn2.toString = bs2, zn2.toUpper = function(e16) {
        return bs2(e16).toUpperCase();
      }, zn2.trim = function(e16, t12, r11) {
        if ((e16 = bs2(e16)) && (r11 || t12 === n10)) return Xt2(e16);
        if (!e16 || !(t12 = uo2(t12))) return e16;
        var o11 = hn2(e16), a11 = hn2(t12);
        return wo2(o11, tn2(o11, a11), nn2(o11, a11) + 1).join("");
      }, zn2.trimEnd = function(e16, t12, r11) {
        if ((e16 = bs2(e16)) && (r11 || t12 === n10)) return e16.slice(0, fn2(e16) + 1);
        if (!e16 || !(t12 = uo2(t12))) return e16;
        var o11 = hn2(e16);
        return wo2(o11, 0, nn2(o11, hn2(t12)) + 1).join("");
      }, zn2.trimStart = function(e16, t12, r11) {
        if ((e16 = bs2(e16)) && (r11 || t12 === n10)) return e16.replace(ae2, "");
        if (!e16 || !(t12 = uo2(t12))) return e16;
        var o11 = hn2(e16);
        return wo2(o11, tn2(o11, hn2(t12))).join("");
      }, zn2.truncate = function(e16, t12) {
        var r11 = 30, o11 = "...";
        if (ts2(t12)) {
          var a11 = "separator" in t12 ? t12.separator : a11;
          r11 = "length" in t12 ? fs2(t12.length) : r11, o11 = "omission" in t12 ? uo2(t12.omission) : o11;
        }
        var i11 = (e16 = bs2(e16)).length;
        if (sn2(e16)) {
          var s11 = hn2(e16);
          i11 = s11.length;
        }
        if (r11 >= i11) return e16;
        var l11 = r11 - mn2(o11);
        if (l11 < 1) return o11;
        var c11 = s11 ? wo2(s11, 0, l11).join("") : e16.slice(0, l11);
        if (a11 === n10) return c11 + o11;
        if (s11 && (l11 += c11.length - l11), is2(a11)) {
          if (e16.slice(l11).search(a11)) {
            var u11, d11 = c11;
            for (a11.global || (a11 = Me3(a11.source, bs2(he2.exec(a11)) + "g")), a11.lastIndex = 0; u11 = a11.exec(d11); ) var p11 = u11.index;
            c11 = c11.slice(0, p11 === n10 ? l11 : p11);
          }
        } else if (e16.indexOf(uo2(a11), l11) != l11) {
          var m11 = c11.lastIndexOf(a11);
          m11 > -1 && (c11 = c11.slice(0, m11));
        }
        return c11 + o11;
      }, zn2.unescape = function(e16) {
        return (e16 = bs2(e16)) && Y10.test(e16) ? e16.replace(U10, gn2) : e16;
      }, zn2.uniqueId = function(e16) {
        var t12 = ++Ve3;
        return bs2(e16) + t12;
      }, zn2.upperCase = Ks2, zn2.upperFirst = Xs2, zn2.each = bi2, zn2.eachRight = Si2, zn2.first = Ua2, ll2(zn2, function() {
        var e16 = {};
        return Cr2(zn2, function(t12, n11) {
          _e3.call(zn2.prototype, n11) || (e16[n11] = t12);
        }), e16;
      }(), { chain: false }), zn2.VERSION = "4.17.21", kt2(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e16) {
        zn2[e16].placeholder = zn2;
      }), kt2(["drop", "take"], function(e16, t12) {
        Zn2.prototype[e16] = function(r11) {
          r11 = r11 === n10 ? 1 : bn2(fs2(r11), 0);
          var o11 = this.__filtered__ && !t12 ? new Zn2(this) : this.clone();
          return o11.__filtered__ ? o11.__takeCount__ = Sn2(r11, o11.__takeCount__) : o11.__views__.push({ size: Sn2(r11, h10), type: e16 + (o11.__dir__ < 0 ? "Right" : "") }), o11;
        }, Zn2.prototype[e16 + "Right"] = function(t13) {
          return this.reverse()[e16](t13).reverse();
        };
      }), kt2(["filter", "map", "takeWhile"], function(e16, t12) {
        var n11 = t12 + 1, r11 = 1 == n11 || 3 == n11;
        Zn2.prototype[e16] = function(e17) {
          var t13 = this.clone();
          return t13.__iteratees__.push({ iteratee: ua2(e17, 3), type: n11 }), t13.__filtered__ = t13.__filtered__ || r11, t13;
        };
      }), kt2(["head", "last"], function(e16, t12) {
        var n11 = "take" + (t12 ? "Right" : "");
        Zn2.prototype[e16] = function() {
          return this[n11](1).value()[0];
        };
      }), kt2(["initial", "tail"], function(e16, t12) {
        var n11 = "drop" + (t12 ? "" : "Right");
        Zn2.prototype[e16] = function() {
          return this.__filtered__ ? new Zn2(this) : this[n11](1);
        };
      }), Zn2.prototype.compact = function() {
        return this.filter(ol2);
      }, Zn2.prototype.find = function(e16) {
        return this.filter(e16).head();
      }, Zn2.prototype.findLast = function(e16) {
        return this.reverse().find(e16);
      }, Zn2.prototype.invokeMap = Xr2(function(e16, t12) {
        return "function" == typeof e16 ? new Zn2(this) : this.map(function(n11) {
          return Dr2(n11, e16, t12);
        });
      }), Zn2.prototype.reject = function(e16) {
        return this.filter(Vi2(ua2(e16)));
      }, Zn2.prototype.slice = function(e16, t12) {
        e16 = fs2(e16);
        var r11 = this;
        return r11.__filtered__ && (e16 > 0 || t12 < 0) ? new Zn2(r11) : (e16 < 0 ? r11 = r11.takeRight(-e16) : e16 && (r11 = r11.drop(e16)), t12 !== n10 && (r11 = (t12 = fs2(t12)) < 0 ? r11.dropRight(-t12) : r11.take(t12 - e16)), r11);
      }, Zn2.prototype.takeRightWhile = function(e16) {
        return this.reverse().takeWhile(e16).reverse();
      }, Zn2.prototype.toArray = function() {
        return this.take(h10);
      }, Cr2(Zn2.prototype, function(e16, t12) {
        var r11 = /^(?:filter|find|map|reject)|While$/.test(t12), o11 = /^(?:head|last)$/.test(t12), a11 = zn2[o11 ? "take" + ("last" == t12 ? "Right" : "") : t12], i11 = o11 || /^find/.test(t12);
        a11 && (zn2.prototype[t12] = function() {
          var t13 = this.__wrapped__, s11 = o11 ? [1] : arguments, l11 = t13 instanceof Zn2, c11 = s11[0], u11 = l11 || Zi2(t13);
          var d11 = function(e17) {
            var t14 = a11.apply(zn2, _t2([e17], s11));
            return o11 && p11 ? t14[0] : t14;
          };
          u11 && r11 && "function" == typeof c11 && 1 != c11.length && (l11 = u11 = false);
          var p11 = this.__chain__, m11 = !!this.__actions__.length, h11 = i11 && !p11, f11 = l11 && !m11;
          if (!i11 && u11) {
            t13 = f11 ? t13 : new Zn2(this);
            var g11 = e16.apply(t13, s11);
            return g11.__actions__.push({ func: hi2, args: [d11], thisArg: n10 }), new jn2(g11, p11);
          }
          return h11 && f11 ? e16.apply(this, s11) : (g11 = this.thru(d11), h11 ? o11 ? g11.value()[0] : g11.value() : g11);
        });
      }), kt2(["pop", "push", "shift", "sort", "splice", "unshift"], function(e16) {
        var t12 = Ne3[e16], n11 = /^(?:push|sort|unshift)$/.test(e16) ? "tap" : "thru", r11 = /^(?:pop|shift)$/.test(e16);
        zn2.prototype[e16] = function() {
          var e17 = arguments;
          if (r11 && !this.__chain__) {
            var o11 = this.value();
            return t12.apply(Zi2(o11) ? o11 : [], e17);
          }
          return this[n11](function(n12) {
            return t12.apply(Zi2(n12) ? n12 : [], e17);
          });
        };
      }), Cr2(Zn2.prototype, function(e16, t12) {
        var n11 = zn2[t12];
        if (n11) {
          var r11 = n11.name + "";
          _e3.call(Ln2, r11) || (Ln2[r11] = []), Ln2[r11].push({ name: t12, func: n11 });
        }
      }), Ln2[$o2(n10, 2).name] = [{ name: "wrapper", func: n10 }], Zn2.prototype.clone = function() {
        var e16 = new Zn2(this.__wrapped__);
        return e16.__actions__ = Do2(this.__actions__), e16.__dir__ = this.__dir__, e16.__filtered__ = this.__filtered__, e16.__iteratees__ = Do2(this.__iteratees__), e16.__takeCount__ = this.__takeCount__, e16.__views__ = Do2(this.__views__), e16;
      }, Zn2.prototype.reverse = function() {
        if (this.__filtered__) {
          var e16 = new Zn2(this);
          e16.__dir__ = -1, e16.__filtered__ = true;
        } else (e16 = this.clone()).__dir__ *= -1;
        return e16;
      }, Zn2.prototype.value = function() {
        var e16 = this.__wrapped__.value(), t12 = this.__dir__, n11 = Zi2(e16), r11 = t12 < 0, o11 = n11 ? e16.length : 0, a11 = function(e17, t13, n12) {
          var r12 = -1, o12 = n12.length;
          for (; ++r12 < o12; ) {
            var a12 = n12[r12], i12 = a12.size;
            switch (a12.type) {
              case "drop":
                e17 += i12;
                break;
              case "dropRight":
                t13 -= i12;
                break;
              case "take":
                t13 = Sn2(t13, e17 + i12);
                break;
              case "takeRight":
                e17 = bn2(e17, t13 - i12);
            }
          }
          return { start: e17, end: t13 };
        }(0, o11, this.__views__), i11 = a11.start, s11 = a11.end, l11 = s11 - i11, c11 = r11 ? s11 : i11 - 1, u11 = this.__iteratees__, d11 = u11.length, p11 = 0, m11 = Sn2(l11, this.__takeCount__);
        if (!n11 || !r11 && o11 == l11 && m11 == l11) return go2(e16, this.__actions__);
        var h11 = [];
        e: for (; l11-- && p11 < m11; ) {
          var f11 = -1, g11 = e16[c11 += t12];
          for (; ++f11 < d11; ) {
            var y11 = u11[f11], v11 = y11.iteratee, b11 = y11.type, S11 = v11(g11);
            if (2 == b11) g11 = S11;
            else if (!S11) {
              if (1 == b11) continue e;
              break e;
            }
          }
          h11[p11++] = g11;
        }
        return h11;
      }, zn2.prototype.at = fi2, zn2.prototype.chain = function() {
        return mi2(this);
      }, zn2.prototype.commit = function() {
        return new jn2(this.value(), this.__chain__);
      }, zn2.prototype.next = function() {
        this.__values__ === n10 && (this.__values__ = ms2(this.value()));
        var e16 = this.__index__ >= this.__values__.length;
        return { done: e16, value: e16 ? n10 : this.__values__[this.__index__++] };
      }, zn2.prototype.plant = function(e16) {
        var t12, r11 = this;
        for (; r11 instanceof Wn2; ) {
          var o11 = Ba2(r11);
          o11.__index__ = 0, o11.__values__ = n10, t12 ? a11.__wrapped__ = o11 : t12 = o11;
          var a11 = o11;
          r11 = r11.__wrapped__;
        }
        return a11.__wrapped__ = e16, t12;
      }, zn2.prototype.reverse = function() {
        var e16 = this.__wrapped__;
        if (e16 instanceof Zn2) {
          var t12 = e16;
          return this.__actions__.length && (t12 = new Zn2(this)), (t12 = t12.reverse()).__actions__.push({ func: hi2, args: [ti2], thisArg: n10 }), new jn2(t12, this.__chain__);
        }
        return this.thru(ti2);
      }, zn2.prototype.toJSON = zn2.prototype.valueOf = zn2.prototype.value = function() {
        return go2(this.__wrapped__, this.__actions__);
      }, zn2.prototype.first = zn2.prototype.head, Je3 && (zn2.prototype[Je3] = function() {
        return this;
      }), zn2;
    }();
    gt2 ? ((gt2.exports = yn2)._ = yn2, ft2._ = yn2) : ht2._ = yn2;
  }).call($);
}(OV, OV.exports);
var BV = OV.exports;
var zV = W(BV);
let $V = (e14, t10, n10) => e14(t10, n10);
function WV(e14, t10, n10) {
  for (const [e15, n11] of Object.entries(t10)) if ("function" != typeof n11) throw new Error(`handleActions(): handler for action ${e15} is not a function`);
  if (void 0 !== n10 && "function" != typeof n10) throw new Error("handleActions(): fallbackReducer is not a function or undefined");
  return (e15, r10) => {
    const o10 = t10[r10.type] || n10;
    return "function" != typeof o10 ? e15 : $V(o10, e15, r10);
  };
}
function jV(...e14) {
  return (t10, n10) => e14.reduce((e15, t11) => $V(t11, e15, n10), t10);
}
function ZV(...e14) {
  return (t10, n10) => {
    let r10 = t10;
    let o10 = t10;
    let a10 = 0;
    let i10;
    for (; a10 < e14.length && (i10 = e14[a10], o10 = $V(i10, r10, n10), o10 !== r10); ) r10 = o10, a10++;
    return r10;
  };
}
function GV(e14, t10, n10) {
  return (r10, o10) => {
    const a10 = e14(r10, o10);
    return a10 ? $V(t10, r10, o10) : !a10 && n10 ? $V(n10, r10, o10) : r10;
  };
}
const UV = {};
const qV = WV(0, { [VV.open.type]: jV((e14, { payload: { containerId: t10 } }) => t10 in e14 ? e14 : AV(e14, { [t10]: { $set: [] } }), (e14, { payload: { containerId: t10, name: n10 } }) => e14[t10].includes(n10) ? (console.error(`'${n10}' dialog is already opened`), e14) : AV(e14, { [t10]: { $unshift: [n10] } })), [VV.close.type]: GV((e14, { payload: { containerId: t10 } }) => t10 in e14, (e14, { payload: { containerId: t10 } }) => {
  const n10 = e14[t10];
  const [r10, ...o10] = n10;
  return r10 ? AV(e14, { [t10]: { $set: o10 } }) : (console.error("There're no open dialogs."), e14);
}) }, (e14) => e14 || UV);
var YV = { exports: {} };
function KV() {
}
function XV() {
}
XV.resetWarningCache = KV;
YV.exports = function() {
  function e14(e15, t11, n11, r10, o10, a10) {
    if ("SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED" !== a10) {
      var i10 = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      throw i10.name = "Invariant Violation", i10;
    }
  }
  function t10() {
    return e14;
  }
  e14.isRequired = e14;
  var n10 = { array: e14, bigint: e14, bool: e14, func: e14, number: e14, object: e14, string: e14, symbol: e14, any: e14, arrayOf: t10, element: e14, elementType: e14, instanceOf: t10, node: e14, objectOf: t10, oneOf: t10, oneOfType: t10, shape: t10, exact: t10, checkPropTypes: XV, resetWarningCache: KV };
  return n10.PropTypes = n10, n10;
}();
var JV = W(YV.exports);
var QV = tp.createContext(null);
var eR = function(e14) {
  e14();
};
var tR = function() {
  return eR;
};
var nR = { notify: function() {
} };
var rR = function() {
  function e14(e15, t11) {
    this.store = e15, this.parentSub = t11, this.unsubscribe = null, this.listeners = nR, this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
  }
  var t10 = e14.prototype;
  return t10.addNestedSub = function(e15) {
    return this.trySubscribe(), this.listeners.subscribe(e15);
  }, t10.notifyNestedSubs = function() {
    this.listeners.notify();
  }, t10.handleChangeWrapper = function() {
    this.onStateChange && this.onStateChange();
  }, t10.isSubscribed = function() {
    return Boolean(this.unsubscribe);
  }, t10.trySubscribe = function() {
    this.unsubscribe || (this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper), this.listeners = function() {
      var e15 = tR();
      var t11 = null;
      var n10 = null;
      return { clear: function() {
        t11 = null, n10 = null;
      }, notify: function() {
        e15(function() {
          var e16 = t11;
          for (; e16; ) e16.callback(), e16 = e16.next;
        });
      }, get: function() {
        var e16 = [];
        var n11 = t11;
        for (; n11; ) e16.push(n11), n11 = n11.next;
        return e16;
      }, subscribe: function(e16) {
        var r10 = true;
        var o10 = n10 = { callback: e16, next: null, prev: n10 };
        return o10.prev ? o10.prev.next = o10 : t11 = o10, function() {
          r10 && null !== t11 && (r10 = false, o10.next ? o10.next.prev = o10.prev : n10 = o10.prev, o10.prev ? o10.prev.next = o10.next : t11 = o10.next);
        };
      } };
    }());
  }, t10.tryUnsubscribe = function() {
    this.unsubscribe && (this.unsubscribe(), this.unsubscribe = null, this.listeners.clear(), this.listeners = nR);
  }, e14;
}();
function oR(e14) {
  var t10 = e14.store, n10 = e14.context, r10 = e14.children;
  var o10 = ep.useMemo(function() {
    var e15 = new rR(t10);
    return e15.onStateChange = e15.notifyNestedSubs, { store: t10, subscription: e15 };
  }, [t10]);
  var a10 = ep.useMemo(function() {
    return t10.getState();
  }, [t10]);
  ep.useEffect(function() {
    var e15 = o10.subscription;
    return e15.trySubscribe(), a10 !== t10.getState() && e15.notifyNestedSubs(), function() {
      e15.tryUnsubscribe(), e15.onStateChange = null;
    };
  }, [o10, a10]);
  var i10 = n10 || QV;
  return tp.createElement(i10.Provider, { value: o10 }, r10);
}
function aR() {
  return aR = Object.assign ? Object.assign.bind() : function(e14) {
    for (var t10 = 1; t10 < arguments.length; t10++) {
      var n10 = arguments[t10];
      for (var r10 in n10) Object.prototype.hasOwnProperty.call(n10, r10) && (e14[r10] = n10[r10]);
    }
    return e14;
  }, aR.apply(this, arguments);
}
var iR = { exports: {} };
var sR = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lR = "function" == typeof Symbol && Symbol.for, cR = lR ? Symbol.for("react.element") : 60103, uR = lR ? Symbol.for("react.portal") : 60106, dR = lR ? Symbol.for("react.fragment") : 60107, pR = lR ? Symbol.for("react.strict_mode") : 60108, mR = lR ? Symbol.for("react.profiler") : 60114, hR = lR ? Symbol.for("react.provider") : 60109, fR = lR ? Symbol.for("react.context") : 60110, gR = lR ? Symbol.for("react.async_mode") : 60111, yR = lR ? Symbol.for("react.concurrent_mode") : 60111, vR = lR ? Symbol.for("react.forward_ref") : 60112, bR = lR ? Symbol.for("react.suspense") : 60113, SR = lR ? Symbol.for("react.suspense_list") : 60120, CR = lR ? Symbol.for("react.memo") : 60115, xR = lR ? Symbol.for("react.lazy") : 60116, wR = lR ? Symbol.for("react.block") : 60121, TR = lR ? Symbol.for("react.fundamental") : 60117, ER = lR ? Symbol.for("react.responder") : 60118, FR = lR ? Symbol.for("react.scope") : 60119;
function MR(e14) {
  if ("object" == typeof e14 && null !== e14) {
    var t10 = e14.$$typeof;
    switch (t10) {
      case cR:
        switch (e14 = e14.type) {
          case gR:
          case yR:
          case dR:
          case mR:
          case pR:
          case bR:
            return e14;
          default:
            switch (e14 = e14 && e14.$$typeof) {
              case fR:
              case vR:
              case xR:
              case CR:
              case hR:
                return e14;
              default:
                return t10;
            }
        }
      case uR:
        return t10;
    }
  }
}
function kR(e14) {
  return MR(e14) === yR;
}
sR.AsyncMode = gR, sR.ConcurrentMode = yR, sR.ContextConsumer = fR, sR.ContextProvider = hR, sR.Element = cR, sR.ForwardRef = vR, sR.Fragment = dR, sR.Lazy = xR, sR.Memo = CR, sR.Portal = uR, sR.Profiler = mR, sR.StrictMode = pR, sR.Suspense = bR, sR.isAsyncMode = function(e14) {
  return kR(e14) || MR(e14) === gR;
}, sR.isConcurrentMode = kR, sR.isContextConsumer = function(e14) {
  return MR(e14) === fR;
}, sR.isContextProvider = function(e14) {
  return MR(e14) === hR;
}, sR.isElement = function(e14) {
  return "object" == typeof e14 && null !== e14 && e14.$$typeof === cR;
}, sR.isForwardRef = function(e14) {
  return MR(e14) === vR;
}, sR.isFragment = function(e14) {
  return MR(e14) === dR;
}, sR.isLazy = function(e14) {
  return MR(e14) === xR;
}, sR.isMemo = function(e14) {
  return MR(e14) === CR;
}, sR.isPortal = function(e14) {
  return MR(e14) === uR;
}, sR.isProfiler = function(e14) {
  return MR(e14) === mR;
}, sR.isStrictMode = function(e14) {
  return MR(e14) === pR;
}, sR.isSuspense = function(e14) {
  return MR(e14) === bR;
}, sR.isValidElementType = function(e14) {
  return "string" == typeof e14 || "function" == typeof e14 || e14 === dR || e14 === yR || e14 === mR || e14 === pR || e14 === bR || e14 === SR || "object" == typeof e14 && null !== e14 && (e14.$$typeof === xR || e14.$$typeof === CR || e14.$$typeof === hR || e14.$$typeof === fR || e14.$$typeof === vR || e14.$$typeof === TR || e14.$$typeof === ER || e14.$$typeof === FR || e14.$$typeof === wR);
}, sR.typeOf = MR, iR.exports = sR;
var PR = iR.exports;
var NR = PR;
var DR = { childContextTypes: true, contextType: true, contextTypes: true, defaultProps: true, displayName: true, getDefaultProps: true, getDerivedStateFromError: true, getDerivedStateFromProps: true, mixins: true, propTypes: true, type: true };
var LR = { name: true, length: true, prototype: true, caller: true, callee: true, arguments: true, arity: true };
var HR = { $$typeof: true, compare: true, defaultProps: true, displayName: true, propTypes: true, type: true };
var IR = {};
function _R(e14) {
  return NR.isMemo(e14) ? HR : IR[e14.$$typeof] || DR;
}
IR[NR.ForwardRef] = { $$typeof: true, render: true, defaultProps: true, displayName: true, propTypes: true }, IR[NR.Memo] = HR;
var VR = Object.defineProperty;
var RR = Object.getOwnPropertyNames;
var AR = Object.getOwnPropertySymbols;
var OR = Object.getOwnPropertyDescriptor;
var BR = Object.getPrototypeOf;
var zR = Object.prototype;
var $R = function e3(t10, n10, r10) {
  if ("string" != typeof n10) {
    if (zR) {
      var o10 = BR(n10);
      o10 && o10 !== zR && e3(t10, o10, r10);
    }
    var a10 = RR(n10);
    AR && (a10 = a10.concat(AR(n10)));
    var i10 = _R(t10);
    var s10 = _R(n10);
    for (var l10 = 0; l10 < a10.length; ++l10) {
      var c10 = a10[l10];
      if (!(LR[c10] || r10 && r10[c10] || s10 && s10[c10] || i10 && i10[c10])) {
        var u10 = OR(n10, c10);
        try {
          VR(t10, c10, u10);
        } catch (e14) {
        }
      }
    }
  }
  return t10;
};
var WR = W($R);
var jR = "undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement ? ep.useLayoutEffect : ep.useEffect;
var ZR = [];
var GR = [null, null];
function UR(e14, t10) {
  var n10 = e14[1];
  return [t10.payload, n10 + 1];
}
function qR(e14, t10, n10) {
  jR(function() {
    return e14.apply(void 0, t10);
  }, n10);
}
function YR(e14, t10, n10, r10, o10, a10, i10) {
  e14.current = r10, t10.current = o10, n10.current = false, a10.current && (a10.current = null, i10());
}
function KR(e14, t10, n10, r10, o10, a10, i10, s10, l10, c10) {
  if (e14) {
    var u10 = false;
    var d10 = null;
    var p10 = function() {
      if (!u10) {
        var e15 = t10.getState();
        var n11, p11;
        try {
          n11 = r10(e15, o10.current);
        } catch (e16) {
          p11 = e16, d10 = e16;
        }
        p11 || (d10 = null), n11 === a10.current ? i10.current || l10() : (a10.current = n11, s10.current = n11, i10.current = true, c10({ type: "STORE_UPDATED", payload: { error: p11 } }));
      }
    };
    n10.onStateChange = p10, n10.trySubscribe(), p10();
    return function() {
      if (u10 = true, n10.tryUnsubscribe(), n10.onStateChange = null, d10) throw d10;
    };
  }
}
var XR = function() {
  return [null, 0];
};
function JR(e14, t10) {
  void 0 === t10 && (t10 = {});
  var n10 = t10, r10 = n10.getDisplayName, o10 = void 0 === r10 ? function(e15) {
    return "ConnectAdvanced(" + e15 + ")";
  } : r10, a10 = n10.methodName, i10 = void 0 === a10 ? "connectAdvanced" : a10, s10 = n10.renderCountProp, l10 = void 0 === s10 ? void 0 : s10, c10 = n10.shouldHandleStateChanges, u10 = void 0 === c10 || c10, d10 = n10.storeKey, p10 = void 0 === d10 ? "store" : d10;
  n10.withRef;
  var m10 = n10.forwardRef, h10 = void 0 !== m10 && m10, f10 = n10.context, g10 = void 0 === f10 ? QV : f10, y10 = np(n10, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);
  var v10 = g10;
  return function(t11) {
    var n11 = t11.displayName || t11.name || "Component";
    var r11 = o10(n11);
    var a11 = aR({}, y10, { getDisplayName: o10, methodName: i10, renderCountProp: l10, shouldHandleStateChanges: u10, storeKey: p10, displayName: r11, wrappedComponentName: n11, WrappedComponent: t11 });
    var s11 = y10.pure;
    var c11 = s11 ? ep.useMemo : function(e15) {
      return e15();
    };
    function d11(n12) {
      var r12 = ep.useMemo(function() {
        var e15 = n12.forwardedRef, t12 = np(n12, ["forwardedRef"]);
        return [n12.context, e15, t12];
      }, [n12]), o11 = r12[0], i11 = r12[1], s12 = r12[2];
      var l11 = ep.useMemo(function() {
        return o11 && o11.Consumer && PR.isContextConsumer(tp.createElement(o11.Consumer, null)) ? o11 : v10;
      }, [o11, v10]);
      var d12 = ep.useContext(l11);
      var p11 = Boolean(n12.store) && Boolean(n12.store.getState) && Boolean(n12.store.dispatch);
      Boolean(d12) && Boolean(d12.store);
      var m12 = p11 ? n12.store : d12.store;
      var h11 = ep.useMemo(function() {
        return function(t12) {
          return e14(t12.dispatch, a11);
        }(m12);
      }, [m12]);
      var f12 = ep.useMemo(function() {
        if (!u10) return GR;
        var e15 = new rR(m12, p11 ? null : d12.subscription);
        var t12 = e15.notifyNestedSubs.bind(e15);
        return [e15, t12];
      }, [m12, p11, d12]), g11 = f12[0], y11 = f12[1];
      var b10 = ep.useMemo(function() {
        return p11 ? d12 : aR({}, d12, { subscription: g11 });
      }, [p11, d12, g11]);
      var S10 = ep.useReducer(UR, ZR, XR), C10 = S10[0][0], x10 = S10[1];
      if (C10 && C10.error) throw C10.error;
      var w10 = ep.useRef();
      var T10 = ep.useRef(s12);
      var E10 = ep.useRef();
      var F10 = ep.useRef(false);
      var M10 = c11(function() {
        return E10.current && s12 === T10.current ? E10.current : h11(m12.getState(), s12);
      }, [m12, C10, s12]);
      qR(YR, [T10, w10, F10, s12, M10, E10, y11]), qR(KR, [u10, m12, g11, h11, T10, w10, F10, E10, y11, x10], [m12, g11, h11]);
      var k10 = ep.useMemo(function() {
        return tp.createElement(t11, aR({}, M10, { ref: i11 }));
      }, [i11, t11, M10]);
      return ep.useMemo(function() {
        return u10 ? tp.createElement(l11.Provider, { value: b10 }, k10) : k10;
      }, [l11, k10, b10]);
    }
    var m11 = s11 ? tp.memo(d11) : d11;
    if (m11.WrappedComponent = t11, m11.displayName = r11, h10) {
      var f11 = tp.forwardRef(function(e15, t12) {
        return tp.createElement(m11, aR({}, e15, { forwardedRef: t12 }));
      });
      return f11.displayName = r11, f11.WrappedComponent = t11, WR(f11, t11);
    }
    return WR(m11, t11);
  };
}
function QR(e14, t10) {
  return e14 === t10 ? 0 !== e14 || 0 !== t10 || 1 / e14 == 1 / t10 : e14 != e14 && t10 != t10;
}
function eA(e14, t10) {
  if (QR(e14, t10)) return true;
  if ("object" != typeof e14 || null === e14 || "object" != typeof t10 || null === t10) return false;
  var n10 = Object.keys(e14);
  var r10 = Object.keys(t10);
  if (n10.length !== r10.length) return false;
  for (var o10 = 0; o10 < n10.length; o10++) if (!Object.prototype.hasOwnProperty.call(t10, n10[o10]) || !QR(e14[n10[o10]], t10[n10[o10]])) return false;
  return true;
}
function tA(e14, t10) {
  var n10 = Object.keys(e14);
  if (Object.getOwnPropertySymbols) {
    var r10 = Object.getOwnPropertySymbols(e14);
    t10 && (r10 = r10.filter(function(t11) {
      return Object.getOwnPropertyDescriptor(e14, t11).enumerable;
    })), n10.push.apply(n10, r10);
  }
  return n10;
}
function nA(e14) {
  for (var t10 = 1; t10 < arguments.length; t10++) {
    var n10 = null != arguments[t10] ? arguments[t10] : {};
    t10 % 2 ? tA(Object(n10), true).forEach(function(t11) {
      ao(e14, t11, n10[t11]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e14, Object.getOwnPropertyDescriptors(n10)) : tA(Object(n10)).forEach(function(t11) {
      Object.defineProperty(e14, t11, Object.getOwnPropertyDescriptor(n10, t11));
    });
  }
  return e14;
}
function rA(e14) {
  return "Minified Redux error #" + e14 + "; visit https://redux.js.org/Errors?code=" + e14 + " for the full message or use the non-minified dev environment for full errors. ";
}
var oA = "function" == typeof Symbol && Symbol.observable || "@@observable";
var aA = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
};
var iA = { INIT: "@@redux/INIT" + aA(), REPLACE: "@@redux/REPLACE" + aA(), PROBE_UNKNOWN_ACTION: function() {
  return "@@redux/PROBE_UNKNOWN_ACTION" + aA();
} };
function sA(e14, t10, n10) {
  var r10;
  if ("function" == typeof t10 && "function" == typeof n10 || "function" == typeof n10 && "function" == typeof arguments[3]) throw new Error(rA(0));
  if ("function" == typeof t10 && void 0 === n10 && (n10 = t10, t10 = void 0), void 0 !== n10) {
    if ("function" != typeof n10) throw new Error(rA(1));
    return n10(sA)(e14, t10);
  }
  if ("function" != typeof e14) throw new Error(rA(2));
  var o10 = e14;
  var a10 = t10;
  var i10 = [];
  var s10 = i10;
  var l10 = false;
  function c10() {
    s10 === i10 && (s10 = i10.slice());
  }
  function u10() {
    if (l10) throw new Error(rA(3));
    return a10;
  }
  function d10(e15) {
    if ("function" != typeof e15) throw new Error(rA(4));
    if (l10) throw new Error(rA(5));
    var t11 = true;
    return c10(), s10.push(e15), function() {
      if (t11) {
        if (l10) throw new Error(rA(6));
        t11 = false, c10();
        var n11 = s10.indexOf(e15);
        s10.splice(n11, 1), i10 = null;
      }
    };
  }
  function p10(e15) {
    if (!function(e16) {
      if ("object" != typeof e16 || null === e16) return false;
      var t12 = e16;
      for (; null !== Object.getPrototypeOf(t12); ) t12 = Object.getPrototypeOf(t12);
      return Object.getPrototypeOf(e16) === t12;
    }(e15)) throw new Error(rA(7));
    if (void 0 === e15.type) throw new Error(rA(8));
    if (l10) throw new Error(rA(9));
    try {
      l10 = true, a10 = o10(a10, e15);
    } finally {
      l10 = false;
    }
    var t11 = i10 = s10;
    for (var n11 = 0; n11 < t11.length; n11++) {
      (0, t11[n11])();
    }
    return e15;
  }
  return p10({ type: iA.INIT }), (r10 = { dispatch: p10, subscribe: d10, getState: u10, replaceReducer: function(e15) {
    if ("function" != typeof e15) throw new Error(rA(10));
    o10 = e15, p10({ type: iA.REPLACE });
  } })[oA] = function() {
    var e15;
    var t11 = d10;
    return (e15 = { subscribe: function(e16) {
      if ("object" != typeof e16 || null === e16) throw new Error(rA(11));
      function n11() {
        e16.next && e16.next(u10());
      }
      return n11(), { unsubscribe: t11(n11) };
    } })[oA] = function() {
      return this;
    }, e15;
  }, r10;
}
function lA(e14) {
  var t10 = Object.keys(e14);
  var n10 = {};
  for (var r10 = 0; r10 < t10.length; r10++) {
    var o10 = t10[r10];
    "function" == typeof e14[o10] && (n10[o10] = e14[o10]);
  }
  var a10 = Object.keys(n10);
  var i10;
  try {
    !function(e15) {
      Object.keys(e15).forEach(function(t11) {
        var n11 = e15[t11];
        if (void 0 === n11(void 0, { type: iA.INIT })) throw new Error(rA(12));
        if (void 0 === n11(void 0, { type: iA.PROBE_UNKNOWN_ACTION() })) throw new Error(rA(13));
      });
    }(n10);
  } catch (e15) {
    i10 = e15;
  }
  return function(e15, t11) {
    if (void 0 === e15 && (e15 = {}), i10) throw i10;
    var r11 = false;
    var o11 = {};
    for (var s10 = 0; s10 < a10.length; s10++) {
      var l10 = a10[s10];
      var c10 = n10[l10];
      var u10 = e15[l10];
      var d10 = c10(u10, t11);
      if (void 0 === d10) throw t11 && t11.type, new Error(rA(14));
      o11[l10] = d10, r11 = r11 || d10 !== u10;
    }
    return (r11 = r11 || a10.length !== Object.keys(e15).length) ? o11 : e15;
  };
}
function cA(e14, t10) {
  return function() {
    return t10(e14.apply(this, arguments));
  };
}
function uA() {
  for (var e14 = arguments.length, t10 = new Array(e14), n10 = 0; n10 < e14; n10++) t10[n10] = arguments[n10];
  return 0 === t10.length ? function(e15) {
    return e15;
  } : 1 === t10.length ? t10[0] : t10.reduce(function(e15, t11) {
    return function() {
      return e15(t11.apply(void 0, arguments));
    };
  });
}
function dA(e14) {
  return function(t10, n10) {
    var r10 = e14(t10, n10);
    function o10() {
      return r10;
    }
    return o10.dependsOnOwnProps = false, o10;
  };
}
function pA(e14) {
  return null !== e14.dependsOnOwnProps && void 0 !== e14.dependsOnOwnProps ? Boolean(e14.dependsOnOwnProps) : 1 !== e14.length;
}
function mA(e14, t10) {
  return function(t11, n10) {
    n10.displayName;
    var r10 = function(e15, t12) {
      return r10.dependsOnOwnProps ? r10.mapToProps(e15, t12) : r10.mapToProps(e15);
    };
    return r10.dependsOnOwnProps = true, r10.mapToProps = function(t12, n11) {
      r10.mapToProps = e14, r10.dependsOnOwnProps = pA(e14);
      var o10 = r10(t12, n11);
      return "function" == typeof o10 && (r10.mapToProps = o10, r10.dependsOnOwnProps = pA(o10), o10 = r10(t12, n11)), o10;
    }, r10;
  };
}
var hA = [function(e14) {
  return "function" == typeof e14 ? mA(e14) : void 0;
}, function(e14) {
  return e14 ? void 0 : dA(function(e15) {
    return { dispatch: e15 };
  });
}, function(e14) {
  return e14 && "object" == typeof e14 ? dA(function(t10) {
    return function(e15, t11) {
      if ("function" == typeof e15) return cA(e15, t11);
      if ("object" != typeof e15 || null === e15) throw new Error(rA(16));
      var n10 = {};
      for (var r10 in e15) {
        var o10 = e15[r10];
        "function" == typeof o10 && (n10[r10] = cA(o10, t11));
      }
      return n10;
    }(e14, t10);
  }) : void 0;
}];
var fA = [function(e14) {
  return "function" == typeof e14 ? mA(e14) : void 0;
}, function(e14) {
  return e14 ? void 0 : dA(function() {
    return {};
  });
}];
function gA(e14, t10, n10) {
  return aR({}, n10, {}, e14, {}, t10);
}
var yA = [function(e14) {
  return "function" == typeof e14 ? /* @__PURE__ */ function(e15) {
    return function(t10, n10) {
      n10.displayName;
      var r10 = n10.pure, o10 = n10.areMergedPropsEqual;
      var a10 = false;
      var i10;
      return function(t11, n11, s10) {
        var l10 = e15(t11, n11, s10);
        return a10 ? r10 && o10(l10, i10) || (i10 = l10) : (a10 = true, i10 = l10), i10;
      };
    };
  }(e14) : void 0;
}, function(e14) {
  return e14 ? void 0 : function() {
    return gA;
  };
}];
function vA(e14, t10, n10, r10) {
  return function(o10, a10) {
    return n10(e14(o10, a10), t10(r10, a10), a10);
  };
}
function bA(e14, t10, n10, r10, o10) {
  var a10 = o10.areStatesEqual, i10 = o10.areOwnPropsEqual, s10 = o10.areStatePropsEqual;
  var l10 = false;
  var c10;
  var u10;
  var d10;
  var p10;
  var m10;
  function h10(o11, l11) {
    var h11 = !i10(l11, u10);
    var f10 = !a10(o11, c10);
    return c10 = o11, u10 = l11, h11 && f10 ? (d10 = e14(c10, u10), t10.dependsOnOwnProps && (p10 = t10(r10, u10)), m10 = n10(d10, p10, u10)) : h11 ? (e14.dependsOnOwnProps && (d10 = e14(c10, u10)), t10.dependsOnOwnProps && (p10 = t10(r10, u10)), m10 = n10(d10, p10, u10)) : f10 ? (g10 = e14(c10, u10), y10 = !s10(g10, d10), d10 = g10, y10 && (m10 = n10(d10, p10, u10)), m10) : m10;
    var g10, y10;
  }
  return function(o11, a11) {
    return l10 ? h10(o11, a11) : (d10 = e14(c10 = o11, u10 = a11), p10 = t10(r10, u10), m10 = n10(d10, p10, u10), l10 = true, m10);
  };
}
function SA(e14, t10) {
  var n10 = t10.initMapStateToProps, r10 = t10.initMapDispatchToProps, o10 = t10.initMergeProps, a10 = np(t10, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);
  var i10 = n10(e14, a10);
  var s10 = r10(e14, a10);
  var l10 = o10(e14, a10);
  return (a10.pure ? bA : vA)(i10, s10, l10, e14, a10);
}
function CA(e14, t10, n10) {
  for (var r10 = t10.length - 1; r10 >= 0; r10--) {
    var o10 = t10[r10](e14);
    if (o10) return o10;
  }
  return function(t11, r11) {
    throw new Error("Invalid value of type " + typeof e14 + " for " + n10 + " argument when connecting component " + r11.wrappedComponentName + ".");
  };
}
function xA(e14, t10) {
  return e14 === t10;
}
function wA(e14) {
  var t10 = void 0 === e14 ? {} : e14, n10 = t10.connectHOC, r10 = void 0 === n10 ? JR : n10, o10 = t10.mapStateToPropsFactories, a10 = void 0 === o10 ? fA : o10, i10 = t10.mapDispatchToPropsFactories, s10 = void 0 === i10 ? hA : i10, l10 = t10.mergePropsFactories, c10 = void 0 === l10 ? yA : l10, u10 = t10.selectorFactory, d10 = void 0 === u10 ? SA : u10;
  return function(e15, t11, n11, o11) {
    void 0 === o11 && (o11 = {});
    var i11 = o11, l11 = i11.pure, u11 = void 0 === l11 || l11, p10 = i11.areStatesEqual, m10 = void 0 === p10 ? xA : p10, h10 = i11.areOwnPropsEqual, f10 = void 0 === h10 ? eA : h10, g10 = i11.areStatePropsEqual, y10 = void 0 === g10 ? eA : g10, v10 = i11.areMergedPropsEqual, b10 = void 0 === v10 ? eA : v10, S10 = np(i11, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);
    var C10 = CA(e15, a10, "mapStateToProps");
    var x10 = CA(t11, s10, "mapDispatchToProps");
    var w10 = CA(n11, c10, "mergeProps");
    return r10(d10, aR({ methodName: "connect", getDisplayName: function(e16) {
      return "Connect(" + e16 + ")";
    }, shouldHandleStateChanges: Boolean(e15), initMapStateToProps: C10, initMapDispatchToProps: x10, initMergeProps: w10, pure: u11, areStatesEqual: m10, areOwnPropsEqual: f10, areStatePropsEqual: y10, areMergedPropsEqual: b10 }, S10));
  };
}
var TA = wA();
function EA() {
  return ep.useContext(QV);
}
function FA(e14) {
  void 0 === e14 && (e14 = QV);
  var t10 = e14 === QV ? EA : function() {
    return ep.useContext(e14);
  };
  return function() {
    return t10().store;
  };
}
var MA = FA();
function kA(e14) {
  void 0 === e14 && (e14 = QV);
  var t10 = e14 === QV ? MA : FA(e14);
  return function() {
    return t10().dispatch;
  };
}
var PA = kA();
var NA = function(e14, t10) {
  return e14 === t10;
};
function DA(e14) {
  void 0 === e14 && (e14 = QV);
  var t10 = e14 === QV ? EA : function() {
    return ep.useContext(e14);
  };
  return function(e15, n10) {
    void 0 === n10 && (n10 = NA);
    var r10 = t10();
    return function(e16, t11, n11, r11) {
      var o10 = ep.useReducer(function(e17) {
        return e17 + 1;
      }, 0)[1];
      var a10 = ep.useMemo(function() {
        return new rR(n11, r11);
      }, [n11, r11]);
      var i10 = ep.useRef();
      var s10 = ep.useRef();
      var l10 = ep.useRef();
      var c10;
      try {
        c10 = e16 !== s10.current || i10.current ? e16(n11.getState()) : l10.current;
      } catch (e17) {
        throw i10.current && (e17.message += "\nThe error may be correlated with this previous error:\n" + i10.current.stack + "\n\n"), e17;
      }
      return jR(function() {
        s10.current = e16, l10.current = c10, i10.current = void 0;
      }), jR(function() {
        function e17() {
          try {
            var e18 = s10.current(n11.getState());
            if (t11(e18, l10.current)) return;
            l10.current = e18;
          } catch (e19) {
            i10.current = e19;
          }
          o10({});
        }
        return a10.onStateChange = e17, a10.trySubscribe(), e17(), function() {
          return a10.tryUnsubscribe();
        };
      }, [n11, a10]), c10;
    }(e15, n10, r10.store, r10.subscription);
  };
}
var LA = DA();
var HA;
HA = mE.unstable_batchedUpdates, eR = HA;
const IA = {};
function _A(e14) {
  if (e14 in IA) throw new Error(`DialogsAPI[id=${e14}] already exists, use DialogsAPI.of(id)`);
  const t10 = {};
  const n10 = { open: function(n11, r10) {
    return t10[n11] = r10, VV.open({ name: n11, containerId: e14 });
  }, getProps: function(e15) {
    return t10[e15] || {};
  } };
  return IA[e14] = n10, n10;
}
_A.of = (e14 = "default") => IA[e14] || _A(e14), _A.destroy = (e14 = "default") => {
  e14 in IA && delete IA[e14];
};
const VA = ep.createContext({ containerId: "default" });
const RA = () => {
  const e14 = PA();
  const { containerId: t10 } = ep.useContext(VA);
  return { openDialog: (n10, r10) => {
    e14(_A.of(t10).open(n10, r10));
  }, closeDialog: () => {
    e14(VV.close({ containerId: t10 }));
  }, dispatch: e14 };
};
var AA = "NOT_FOUND";
var OA = function(e14, t10) {
  return e14 === t10;
};
function BA(e14, t10) {
  var n10 = "object" == typeof t10 ? t10 : { equalityCheck: t10 };
  var r10 = n10.equalityCheck, o10 = void 0 === r10 ? OA : r10, a10 = n10.maxSize, i10 = void 0 === a10 ? 1 : a10, s10 = n10.resultEqualityCheck;
  var l10 = /* @__PURE__ */ function(e15) {
    return function(t11, n11) {
      if (null === t11 || null === n11 || t11.length !== n11.length) return false;
      var r11 = t11.length;
      for (var o11 = 0; o11 < r11; o11++) if (!e15(t11[o11], n11[o11])) return false;
      return true;
    };
  }(o10);
  var c10 = 1 === i10 ? (u10 = l10, { get: function(e15) {
    return d10 && u10(d10.key, e15) ? d10.value : AA;
  }, put: function(e15, t11) {
    d10 = { key: e15, value: t11 };
  }, getEntries: function() {
    return d10 ? [d10] : [];
  }, clear: function() {
    d10 = void 0;
  } }) : /* @__PURE__ */ function(e15, t11) {
    var n11 = [];
    function r11(e16) {
      var r12 = n11.findIndex(function(n12) {
        return t11(e16, n12.key);
      });
      if (r12 > -1) {
        var o11 = n11[r12];
        return r12 > 0 && (n11.splice(r12, 1), n11.unshift(o11)), o11.value;
      }
      return AA;
    }
    return { get: r11, put: function(t12, o11) {
      r11(t12) === AA && (n11.unshift({ key: t12, value: o11 }), n11.length > e15 && n11.pop());
    }, getEntries: function() {
      return n11;
    }, clear: function() {
      n11 = [];
    } };
  }(i10, l10);
  var u10, d10;
  function p10() {
    var t11 = c10.get(arguments);
    if (t11 === AA) {
      if (t11 = e14.apply(null, arguments), s10) {
        var n11 = c10.getEntries().find(function(e15) {
          return s10(e15.value, t11);
        });
        n11 && (t11 = n11.value);
      }
      c10.put(arguments, t11);
    }
    return t11;
  }
  return p10.clearCache = function() {
    return c10.clear();
  }, p10;
}
function zA(e14) {
  for (var t10 = arguments.length, n10 = new Array(t10 > 1 ? t10 - 1 : 0), r10 = 1; r10 < t10; r10++) n10[r10 - 1] = arguments[r10];
  return function() {
    for (var t11 = arguments.length, r11 = new Array(t11), o10 = 0; o10 < t11; o10++) r11[o10] = arguments[o10];
    var a10 = 0;
    var i10;
    var s10 = { memoizeOptions: void 0 };
    var l10 = r11.pop();
    if ("object" == typeof l10 && (s10 = l10, l10 = r11.pop()), "function" != typeof l10) throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof l10 + "]");
    var c10 = s10.memoizeOptions, u10 = void 0 === c10 ? n10 : c10;
    var d10 = Array.isArray(u10) ? u10 : [u10];
    var p10 = function(e15) {
      var t12 = Array.isArray(e15[0]) ? e15[0] : e15;
      if (!t12.every(function(e16) {
        return "function" == typeof e16;
      })) {
        var n11 = t12.map(function(e16) {
          return "function" == typeof e16 ? "function " + (e16.name || "unnamed") + "()" : typeof e16;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + n11 + "]");
      }
      return t12;
    }(r11);
    var m10 = e14.apply(void 0, [function() {
      return a10++, l10.apply(null, arguments);
    }].concat(d10));
    var h10 = e14(function() {
      var e15 = [];
      var t12 = p10.length;
      for (var n11 = 0; n11 < t12; n11++) e15.push(p10[n11].apply(null, arguments));
      return i10 = m10.apply(null, e15);
    });
    return Object.assign(h10, { resultFunc: l10, memoizedResultFunc: m10, dependencies: p10, lastResult: function() {
      return i10;
    }, recomputations: function() {
      return a10;
    }, resetRecomputations: function() {
      return a10 = 0;
    } }), h10;
  };
}
var $A = zA(BA);
const WA = () => $A([(e14) => e14.dialogs, (e14, t10) => t10], (e14, t10) => e14[t10] || []);
const jA = ({ dialogs: e14, id: t10 = "default" }) => {
  const n10 = ep.useMemo(WA, []);
  const r10 = LA((e15) => n10(e15, t10));
  const { closeDialog: o10 } = RA();
  const a10 = _A.of(t10);
  const i10 = ep.useMemo(() => ({ containerId: t10 }), [t10]);
  return tp.createElement(VA.Provider, { value: i10 }, r10.map((t11) => {
    const n11 = e14[t11] || /* @__PURE__ */ ((e15, t12) => (n12) => tp.createElement(Vk, { open: true, title: "Error", message: `Dialog "${e15}" not found`, controls: ["ok"], onClose: t12, key: n12 }))(t11, o10);
    return n11(t11, a10.getProps(t11));
  }).reverse());
};
const [, , ZA] = Dp("gc-modal");
const [GA] = ZA("message");
const UA = ({ title: e14, text: t10, level: n10, choices: r10, onCancel: o10 }) => {
  const { dispatch: a10, closeDialog: i10 } = RA();
  const { t: s10 } = vp("dialogs");
  const l10 = () => {
    o10 && a10(o10), i10();
  };
  const c10 = { align: "right", buttons: (r10 || []).map(({ label: e15, primary: t11, action: n11 }) => ({ accent: t11 ? "full" : "none", text: e15, onClick: () => {
    i10(), n11 && a10(n11);
  } })) };
  if (o10) {
    const e15 = { accent: "none", text: s10("common.textCancel", "Cancel"), onClick: l10 };
    c10.buttons = [...c10.buttons, e15];
  }
  const u10 = { open: true, title: e14, controls: c10, level: n10, customCSS: "gc-message-box", shouldCloseOnOverlayClick: false, shouldCloseOnEsc: void 0 !== o10, hideCloseButton: void 0 === o10, onClose: l10 };
  return tp.createElement(Hk, __spreadValues({}, u10), (() => {
    if (!t10) return null;
    if ("string" == typeof t10) return tp.createElement("div", { className: GA }, t10);
    const e15 = t10[0];
    const n11 = t10[t10.length - 1];
    return tp.createElement("div", { className: GA }, tp.createElement("div", null, e15), tp.createElement("ul", { className: "wd-master-report-errors-list" }, t10.map((e16, n12) => 0 !== n12 && n12 !== t10.length - 1 && tp.createElement("li", { key: `modal-warning-${n12}-${e16}` }, tp.createElement(sV, { size: "small", icon: nf(ih, { size: "small" }), title: e16, level: "info" })))), tp.createElement("div", null, n11));
  })());
};
UA.displayName = "ConfirmDialog";
const qA = (e14, t10, n10) => ({ label: e14, action: t10, primary: n10 });
const YA = () => tp.createElement(wH, { dataAid: "context-menu", size: "small" });
const [KA, XA] = Dp("wd-sidebar-item-container");
const [JA, QA, eO] = Dp("wd-sidebar-item");
const [tO] = eO("text");
const [nO] = eO("title");
const [rO] = eO("subtitle");
const [oO] = eO("controls");
const [aO, , iO] = Dp("wd-sidebar-block");
iO("placeholder"), iO("heading"), iO("content");
const sO = ep.forwardRef(({ type: e14, icon: t10, title: n10, subtitle: r10, actions: o10 = {}, onClick: a10 }, i10) => tp.createElement("div", { className: kp(KA, XA(e14)) }, tp.createElement("div", { className: JA, ref: i10, onClick: a10 }, tp.createElement(Fm, { icon: t10 }), tp.createElement("div", { className: tO }, tp.createElement("span", { className: nO, title: n10 }, n10), r10 && tp.createElement("span", { className: rO }, r10)), tp.createElement("div", { className: oO }, Object.entries(o10).map(([e15, t11]) => {
  if ("button" === t11.type) {
    const n12 = __spreadProps(__spreadValues({}, t11), { block: true, size: "small", rounded: true, background: "transparent" });
    return tp.createElement(qm, __spreadValues({ key: e15 }, n12));
  }
  const n11 = __spreadProps(__spreadValues({}, t11), { block: true, size: "small", rounded: true, background: "transparent" });
  return tp.createElement(UF, __spreadValues({ key: e15 }, n11));
})))));
sO.displayName = "SidebarItem";
var lO = {};
var cO = {};
Object.defineProperty(cO, "__esModule", { value: true });
var uO = cO.ActionTypes = { UNDO: "@@redux-undo/UNDO", REDO: "@@redux-undo/REDO", JUMP_TO_FUTURE: "@@redux-undo/JUMP_TO_FUTURE", JUMP_TO_PAST: "@@redux-undo/JUMP_TO_PAST", JUMP: "@@redux-undo/JUMP", CLEAR_HISTORY: "@@redux-undo/CLEAR_HISTORY" };
cO.ActionCreators = { undo: function() {
  return { type: uO.UNDO };
}, redo: function() {
  return { type: uO.REDO };
}, jumpToFuture: function(e14) {
  return { type: uO.JUMP_TO_FUTURE, index: e14 };
}, jumpToPast: function(e14) {
  return { type: uO.JUMP_TO_PAST, index: e14 };
}, jump: function(e14) {
  return { type: uO.JUMP, index: e14 };
}, clearHistory: function() {
  return { type: uO.CLEAR_HISTORY };
} };
var dO = {};
function pO(e14) {
  var t10 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
  return Array.isArray(e14) ? e14 : "string" == typeof e14 ? [e14] : t10;
}
Object.defineProperty(dO, "__esModule", { value: true }), dO.parseActions = pO, dO.isHistory = function(e14) {
  return void 0 !== e14.present && void 0 !== e14.future && void 0 !== e14.past && Array.isArray(e14.future) && Array.isArray(e14.past);
}, dO.distinctState = function() {
  return console.warn("distinctState is deprecated in beta4 and newer. The distinctState behavior is now default, which means only actions resulting in a new state are recorded. See https://github.com/omnidan/redux-undo#filtering-actions for more details."), function() {
    return true;
  };
}, dO.includeAction = function(e14) {
  var t10 = pO(e14);
  return function(e15) {
    return t10.indexOf(e15.type) >= 0;
  };
}, dO.excludeAction = function(e14) {
  var t10 = pO(e14);
  return function(e15) {
    return t10.indexOf(e15.type) < 0;
  };
}, dO.combineFilters = function() {
  for (var e14 = arguments.length, t10 = Array(e14), n10 = 0; n10 < e14; n10++) t10[n10] = arguments[n10];
  return t10.reduce(function(e15, t11) {
    return function(n11, r10, o10) {
      return e15(n11, r10, o10) && t11(n11, r10, o10);
    };
  }, function() {
    return true;
  });
}, dO.groupByActionTypes = function(e14) {
  var t10 = pO(e14);
  return function(e15) {
    return t10.indexOf(e15.type) >= 0 ? e15.type : null;
  };
};
var mO = { exports: {} };
var hO = {};
function fO(e14) {
  if (Array.isArray(e14)) {
    for (var t10 = 0, n10 = Array(e14.length); t10 < e14.length; t10++) n10[t10] = e14[t10];
    return n10;
  }
  return Array.from(e14);
}
Object.defineProperty(hO, "__esModule", { value: true });
var gO = void 0;
var yO = void 0;
var vO = "#9E9E9E", bO = "#03A9F4", SO = "#4CAF50";
function CO(e14, t10, n10) {
  return ["%c" + e14, "color: " + t10 + "; font-weight: bold", n10];
}
hO.set = function(e14) {
  gO = e14;
}, hO.start = function(e14, t10) {
  yO = { header: [], prev: [], action: [], next: [], msgs: [] }, gO && (console.group ? (yO.header = ["%credux-undo", "font-style: italic", "action", e14.type], yO.action = CO("action", bO, e14), yO.prev = CO("prev history", vO, t10)) : (yO.header = ["redux-undo action", e14.type], yO.action = ["action", e14], yO.prev = ["prev history", t10]));
}, hO.end = function(e14) {
  gO && (console.group ? yO.next = CO("next history", SO, e14) : yO.next = ["next history", e14], function() {
    var e15 = yO, t10 = e15.header, n10 = e15.prev, r10 = e15.next, o10 = e15.action, a10 = e15.msgs;
    var i10, s10, l10, c10, u10;
    var d10, p10, m10, h10, f10;
    console.group ? ((i10 = console).groupCollapsed.apply(i10, fO(t10)), (s10 = console).log.apply(s10, fO(n10)), (l10 = console).log.apply(l10, fO(o10)), (c10 = console).log.apply(c10, fO(r10)), (u10 = console).log.apply(u10, fO(a10)), console.groupEnd()) : ((d10 = console).log.apply(d10, fO(t10)), (p10 = console).log.apply(p10, fO(n10)), (m10 = console).log.apply(m10, fO(o10)), (h10 = console).log.apply(h10, fO(r10)), (f10 = console).log.apply(f10, fO(a10)));
  }());
}, hO.log = function() {
  if (gO) {
    for (var e14 = arguments.length, t10 = Array(e14), n10 = 0; n10 < e14; n10++) t10[n10] = arguments[n10];
    yO.msgs = yO.msgs.concat([].concat(t10, ["\n"]));
  }
}, function(e14, t10) {
  Object.defineProperty(t10, "__esModule", { value: true });
  var n10 = Object.assign || function(e15) {
    for (var t11 = 1; t11 < arguments.length; t11++) {
      var n11 = arguments[t11];
      for (var r11 in n11) Object.prototype.hasOwnProperty.call(n11, r11) && (e15[r11] = n11[r11]);
    }
    return e15;
  };
  t10.default = function(e15) {
    var t11 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    r10.set(t11.debug);
    var m10 = { initTypes: (0, a10.parseActions)(t11.initTypes, ["@@redux-undo/INIT"]), limit: t11.limit, filter: t11.filter || function() {
      return true;
    }, groupBy: t11.groupBy || function() {
      return null;
    }, undoType: t11.undoType || o10.ActionTypes.UNDO, redoType: t11.redoType || o10.ActionTypes.REDO, jumpToPastType: t11.jumpToPastType || o10.ActionTypes.JUMP_TO_PAST, jumpToFutureType: t11.jumpToFutureType || o10.ActionTypes.JUMP_TO_FUTURE, jumpType: t11.jumpType || o10.ActionTypes.JUMP, clearHistoryType: Array.isArray(t11.clearHistoryType) ? t11.clearHistoryType : [t11.clearHistoryType || o10.ActionTypes.CLEAR_HISTORY], neverSkipReducer: t11.neverSkipReducer || false, ignoreInitialState: t11.ignoreInitialState || false, syncFilter: t11.syncFilter || false };
    var h10 = m10.history;
    return function() {
      for (var t12 = arguments.length, f10 = Array(t12 > 2 ? t12 - 2 : 0), g10 = 2; g10 < t12; g10++) f10[g10 - 2] = arguments[g10];
      var y10 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : h10;
      var v10 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      r10.start(v10, y10);
      var b10 = y10;
      if (!h10) if (r10.log("history is uninitialized"), void 0 === y10) {
        var S10 = { type: o10.ActionTypes.CLEAR_HISTORY };
        b10 = l10(e15.apply(void 0, [y10, S10].concat(f10)), m10.ignoreInitialState), r10.log("do not set initialState on probe actions");
      } else (0, a10.isHistory)(y10) ? (b10 = h10 = m10.ignoreInitialState ? y10 : s10(y10.past, y10.present, y10.future), r10.log("initialHistory initialized: initialState is a history", h10)) : (b10 = h10 = l10(y10, m10.ignoreInitialState), r10.log("initialHistory initialized: initialState is not a history", h10));
      var C10 = function(t13) {
        return m10.neverSkipReducer ? n10({}, t13, { present: e15.apply(void 0, [t13.present, v10].concat(f10)) }) : t13;
      };
      var x10 = void 0;
      switch (v10.type) {
        case void 0:
          return b10;
        case m10.undoType:
          return x10 = p10(b10, -1), r10.log("perform undo"), r10.end(x10), C10(x10);
        case m10.redoType:
          return x10 = p10(b10, 1), r10.log("perform redo"), r10.end(x10), C10(x10);
        case m10.jumpToPastType:
          return x10 = d10(b10, v10.index), r10.log("perform jumpToPast to " + v10.index), r10.end(x10), C10(x10);
        case m10.jumpToFutureType:
          return x10 = u10(b10, v10.index), r10.log("perform jumpToFuture to " + v10.index), r10.end(x10), C10(x10);
        case m10.jumpType:
          return x10 = p10(b10, v10.index), r10.log("perform jump to " + v10.index), r10.end(x10), C10(x10);
        case (M10 = v10.type, m10.clearHistoryType.indexOf(M10) > -1 ? M10 : !M10):
          return x10 = l10(b10.present), r10.log("perform clearHistory"), r10.end(x10), C10(x10);
        default:
          if (x10 = e15.apply(void 0, [b10.present, v10].concat(f10)), m10.initTypes.some(function(e16) {
            return e16 === v10.type;
          })) return r10.log("reset history due to init action"), r10.end(h10), h10;
          if (b10.present === x10) return b10;
          var w10 = "function" == typeof m10.filter && !m10.filter(v10, x10, b10);
          var T10 = m10.groupBy(v10, x10, b10);
          if (w10) {
            var E10 = s10(b10.past, x10, b10.future, b10.group);
            return m10.syncFilter || (E10._latestUnfiltered = b10._latestUnfiltered), r10.log("filter ignored action, not storing it in past"), r10.end(E10), E10;
          }
          if (null != T10 && T10 === b10.group) {
            var F10 = s10(b10.past, x10, b10.future, b10.group);
            return r10.log("groupBy grouped the action with the previous action"), r10.end(F10), F10;
          }
          return b10 = function(e16, t13, n11, o11) {
            r10.log("inserting", t13), r10.log("new free: ", n11 - c10(e16));
            var a11 = e16.past, l11 = e16._latestUnfiltered;
            var u11 = n11 && c10(e16) >= n11;
            var d11 = a11.slice(u11 ? 1 : 0);
            return s10(null != l11 ? [].concat(i10(d11), [l11]) : d11, t13, [], o11);
          }(b10, x10, m10.limit, T10), r10.log("inserted new state into history"), r10.end(b10), b10;
      }
      var M10;
    };
  };
  var r10 = function(e15) {
    if (e15 && e15.__esModule) return e15;
    var t11 = {};
    if (null != e15) for (var n11 in e15) Object.prototype.hasOwnProperty.call(e15, n11) && (t11[n11] = e15[n11]);
    return t11.default = e15, t11;
  }(hO);
  var o10 = cO;
  var a10 = dO;
  function i10(e15) {
    if (Array.isArray(e15)) {
      for (var t11 = 0, n11 = Array(e15.length); t11 < e15.length; t11++) n11[t11] = e15[t11];
      return n11;
    }
    return Array.from(e15);
  }
  function s10(e15, t11, n11) {
    return { past: e15, present: t11, future: n11, group: arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null, _latestUnfiltered: t11, index: e15.length, limit: e15.length + n11.length + 1 };
  }
  function l10(e15, t11) {
    var n11 = s10([], e15, []);
    return t11 && (n11._latestUnfiltered = null), n11;
  }
  function c10(e15) {
    return e15.past.length + 1;
  }
  function u10(e15, t11) {
    if (t11 < 0 || t11 >= e15.future.length) return e15;
    var n11 = e15.past, r11 = e15.future, o11 = e15._latestUnfiltered;
    return s10([].concat(i10(n11), [o11], i10(r11.slice(0, t11))), r11[t11], r11.slice(t11 + 1));
  }
  function d10(e15, t11) {
    if (t11 < 0 || t11 >= e15.past.length) return e15;
    var n11 = e15.past, r11 = e15.future, o11 = e15._latestUnfiltered;
    var a11 = n11.slice(0, t11);
    var l11 = [].concat(i10(n11.slice(t11 + 1)), [o11], i10(r11));
    return s10(a11, n11[t11], l11);
  }
  function p10(e15, t11) {
    return t11 > 0 ? u10(e15, t11 - 1) : t11 < 0 ? d10(e15, e15.past.length + t11) : e15;
  }
  e14.exports = t10.default;
}(mO, mO.exports);
var xO = mO.exports;
!function(e14) {
  Object.defineProperty(e14, "__esModule", { value: true });
  var t10 = cO;
  Object.defineProperty(e14, "ActionTypes", { enumerable: true, get: function() {
    return t10.ActionTypes;
  } }), Object.defineProperty(e14, "ActionCreators", { enumerable: true, get: function() {
    return t10.ActionCreators;
  } });
  var n10 = dO;
  Object.defineProperty(e14, "parseActions", { enumerable: true, get: function() {
    return n10.parseActions;
  } }), Object.defineProperty(e14, "isHistory", { enumerable: true, get: function() {
    return n10.isHistory;
  } }), Object.defineProperty(e14, "distinctState", { enumerable: true, get: function() {
    return n10.distinctState;
  } }), Object.defineProperty(e14, "includeAction", { enumerable: true, get: function() {
    return n10.includeAction;
  } }), Object.defineProperty(e14, "excludeAction", { enumerable: true, get: function() {
    return n10.excludeAction;
  } }), Object.defineProperty(e14, "combineFilters", { enumerable: true, get: function() {
    return n10.combineFilters;
  } }), Object.defineProperty(e14, "groupByActionTypes", { enumerable: true, get: function() {
    return n10.groupByActionTypes;
  } });
  var r10 = xO;
  Object.defineProperty(e14, "default", { enumerable: true, get: function() {
    return (e15 = r10, e15 && e15.__esModule ? e15 : { default: e15 }).default;
    var e15;
  } });
}(lO);
var wO = W(lO);
const TO = { units: "in", sidebar: { propertiesMode: "advanced", propertiesSort: "categorized", width: 330, expandedCategoriesStates: JSON.stringify({}), expandedEditorsStates: JSON.stringify({}) }, surface: { gridSize: "0.25in", showGrid: true, snapToGrid: false, snapToLines: false, zoomFactor: 1 }, rulers: { show: false, snapStep: { in: 0.25, cm: 0.5 } } };
const EO = { instanceId: "ar-web-designer", language: "en", fonts: ["Arial", "Arial Black", "Comic Sans MS", "Courier New", "Geneva", "Georgia", "Helvetica", "Impact", "Lucida Console", "Meiryo", "Meiryo UI", "MingLiU", "MingLiU-ExtB", "MS Gothic", "MS Mincho", "MS PGothic", "MS PMincho", "MS Song", "MS UI Gothic", "NSimSun", "Osaka", "PMingLiU", "PMingLiU-ExtB", "SimSun", "SimSun-ExtB", "Song", "Tahoma", "Times New Roman", "Trebuchet MS", "Verdana", "Yu Gothic"], imageMimeTypes: ["image/bmp", "image/jpeg", "image/gif", "image/png", "image/svg+xml", "image/x-emf", "image/x-wmf"], lockLayout: false, disableSystemClipboard: false, themes: { default: "default", list: ["system", "default", "defaultDark", "darkOled", "highContrast", "highContrastDark"], picker: { enabled: true } }, data: { dataSets: { canModify: true, visible: true }, dataSources: { canModify: true, visible: true, shared: { enabled: false } }, dataTab: { visible: true }, parameters: { canModify: true, visible: true }, slicers: { visible: true }, commonValues: { visible: true } }, userPreferences: TO, dateFormats: ["yyyy/MM/dd HH:mm:ss", "yyyy/MM/dd", "HH:mm:ss", "tt hh:mm:ss", "yyyy/MM/dd dddd", "tt hh:mm", "yyyyMMddHHmmss", "MM/dd/yyyy h:mm:ss tt", "M/d/yyyy H:mm:ss", "M/d/yyyy", "M/d/yy H:mm", "M/d/yy", "H:mm:ss", "h:mm:ss tt", "M/d/yyyy dddd", "M/d/yy dddd", "h:mm tt", "dd/MM/yyyy HH:mm:ss", "d/MM/yyyy H:mm:ss", "dd/MM/yyyy", "d/MM/yy H:mm", "d/MM/yy", "H' h 'mm:ss", "H' h 'mm"] };
const FO = ep.createContext(EO);
const MO = () => ep.useContext(FO);
const kO = {};
let PO = "";
const NO = (e14) => e14.startsWith("PercentageDetail") || e14.startsWith("PercentageCategory") ? e14.replace("_", ":") : e14;
const DO = (e14) => e14.startsWith("PercentageDetail") || e14.startsWith("PercentageCategory") ? e14.replace(":", "_") : e14;
const LO = (e14) => Object.keys(e14).filter((t10) => null !== e14[t10]);
function HO(e14, t10) {
  kO[e14] = t10;
}
function IO(e14) {
  if (!(e14 in kO)) throw new Error(`useEnums('${e14}'): This enums not registered`);
  PO = e14;
}
function _O(e14) {
  if (!PO) throw new Error("EnumAPI not initialized");
  return e14 in kO[PO];
}
function VO(e14) {
  if (!PO) throw new Error("EnumAPI not initialized");
  const t10 = kO[PO][e14] || [];
  return "dvchart_template" === e14 ? t10.map(NO) : t10;
}
function RO(e14, t10, n10) {
  const r10 = "dvchart_template" === e14 ? DO(t10) : t10;
  return n10(`${PO}:${e14}.${r10}`);
}
const AO = {};
function OO(e14, t10) {
  const n10 = `${PO}:${e14}`;
  return n10 in AO || (AO[n10] = function(e15, t11) {
    const n11 = t11(`${PO}:${e15}`, { returnObjects: true, defaultValue: null });
    if (null === n11) return [];
    const r10 = LO(n11);
    return "dvchart_template" === e15 ? r10.map((e16) => ({ label: n11[e16], value: NO(e16) })) : r10.map((e16) => ({ label: n11[e16], value: e16 }));
  }(e14, t10)), AO[n10];
}
function BO(e14, t10) {
  const n10 = t10(`${PO}:${e14}`, { returnObjects: true, defaultValue: null });
  const r10 = { values: [], friendlyNames: [] };
  if (null === n10) return r10;
  const o10 = LO(n10);
  return "dvchart_template" === e14 ? (r10.values = o10.map(NO), r10.friendlyNames = o10.map((e15) => ({ name: n10[e15], value: NO(e15) }))) : (r10.values = o10, r10.friendlyNames = o10.map((e15) => ({ name: n10[e15], value: e15 }))), r10;
}
const zO = (e14) => {
  var _a2, _b2, _c2, _d2;
  return { default: (_a2 = e14 == null ? void 0 : e14.default) != null ? _a2 : "default", list: (_b2 = e14 == null ? void 0 : e14.list) != null ? _b2 : ["default", "defaultDark", "darkOled", "highContrast", "highContrastDark"], picker: { enabled: (_d2 = (_c2 = e14 == null ? void 0 : e14.picker) == null ? void 0 : _c2.enabled) != null ? _d2 : true } };
};
const $O = (e14) => {
  var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2, _o3, _p3, _q2, _r2, _s2, _t2, _u2, _v2, _w2, _x2, _y2;
  return { rulers: { show: (_b2 = (_a2 = e14 == null ? void 0 : e14.rulers) == null ? void 0 : _a2.show) != null ? _b2 : TO.rulers.show, snapStep: (_d2 = (_c2 = e14 == null ? void 0 : e14.rulers) == null ? void 0 : _c2.snapStep) != null ? _d2 : TO.rulers.snapStep }, sidebar: { expandedCategoriesStates: (_f2 = (_e2 = e14 == null ? void 0 : e14.sidebar) == null ? void 0 : _e2.expandedCategoriesStates) != null ? _f2 : TO.sidebar.expandedCategoriesStates, expandedEditorsStates: (_h2 = (_g2 = e14 == null ? void 0 : e14.sidebar) == null ? void 0 : _g2.expandedEditorsStates) != null ? _h2 : TO.sidebar.expandedEditorsStates, propertiesMode: (_j2 = (_i2 = e14 == null ? void 0 : e14.sidebar) == null ? void 0 : _i2.propertiesMode) != null ? _j2 : TO.sidebar.propertiesMode, propertiesSort: (_l2 = (_k2 = e14 == null ? void 0 : e14.sidebar) == null ? void 0 : _k2.propertiesSort) != null ? _l2 : TO.sidebar.propertiesSort, width: (_n2 = (_m2 = e14 == null ? void 0 : e14.sidebar) == null ? void 0 : _m2.width) != null ? _n2 : TO.sidebar.width }, surface: { gridSize: (_p3 = (_o3 = e14 == null ? void 0 : e14.surface) == null ? void 0 : _o3.gridSize) != null ? _p3 : TO.surface.gridSize, showGrid: (_r2 = (_q2 = e14 == null ? void 0 : e14.surface) == null ? void 0 : _q2.showGrid) != null ? _r2 : TO.surface.showGrid, snapToGrid: (_t2 = (_s2 = e14 == null ? void 0 : e14.surface) == null ? void 0 : _s2.snapToGrid) != null ? _t2 : TO.surface.snapToGrid, snapToLines: (_v2 = (_u2 = e14 == null ? void 0 : e14.surface) == null ? void 0 : _u2.snapToLines) != null ? _v2 : TO.surface.snapToLines, zoomFactor: (_x2 = (_w2 = e14 == null ? void 0 : e14.surface) == null ? void 0 : _w2.zoomFactor) != null ? _x2 : TO.surface.zoomFactor }, units: (_y2 = e14 == null ? void 0 : e14.units) != null ? _y2 : TO.units, theme: e14 == null ? void 0 : e14.theme };
};
const WO = (e14, t10) => `@core/events/settings/${e14}${t10 ? `/${t10}` : ""}`;
const jO = new EventTarget();
const ZO = {};
const GO = {};
const UO = { fonts: true, userPreferences: { units: true, theme: true, sidebar: { propertiesMode: true, propertiesSort: true, width: true, expandedCategoriesStates: true, expandedEditorsStates: true }, surface: { gridSize: true, showGrid: true, snapToGrid: true, snapToLines: true, zoomFactor: true }, rulers: { show: true, snapStep: { cm: true, in: true } } } };
const qO = (e14, t10) => {
  const n10 = ((_a2 = {}) => {
    var _b2 = _a2, { instanceId: e15, language: t11, fonts: n11, imageMimeTypes: r10, lockLayout: o10, disableSystemClipboard: a10, themes: i10, data: s10, userPreferences: l10, dateFormats: c10 } = _b2, u10 = __objRest(_b2, ["instanceId", "language", "fonts", "imageMimeTypes", "lockLayout", "disableSystemClipboard", "themes", "data", "userPreferences", "dateFormats"]);
    return __spreadValues({ instanceId: e15 || EO.instanceId, language: t11 || EO.language, fonts: n11 || EO.fonts, imageMimeTypes: r10 || EO.imageMimeTypes, lockLayout: o10 || EO.lockLayout, disableSystemClipboard: a10 || EO.disableSystemClipboard, themes: zO(i10), data: { dataSets: __spreadValues(__spreadValues({}, EO.data.dataSets), s10 == null ? void 0 : s10.dataSets), dataSources: __spreadValues(__spreadValues({}, EO.data.dataSources), s10 == null ? void 0 : s10.dataSources), dataTab: __spreadValues(__spreadValues({}, EO.data.dataTab), s10 == null ? void 0 : s10.dataTab), parameters: __spreadValues(__spreadValues({}, EO.data.parameters), s10 == null ? void 0 : s10.parameters), slicers: { visible: false }, commonValues: __spreadValues(__spreadValues({}, EO.data.commonValues), s10 == null ? void 0 : s10.commonValues) }, userPreferences: $O(l10), dateFormats: c10 || EO.dateFormats }, u10);
  })(e14);
  if (!t10) return n10;
  for (const e15 in t10) t10.hasOwnProperty(e15) && (n10[e15] = t10[e15](n10[e15]));
  return n10;
};
const YO = (e14, t10, n10) => {
  const r10 = __spreadValues({}, t10);
  for (const o10 of Object.keys(t10)) {
    const a10 = n10[o10];
    null !== a10 && "object" == typeof a10 && (r10[o10] = YO(e14, t10[o10], a10));
  }
  return new Proxy(r10, /* @__PURE__ */ ((e15, t11) => ({ get: (e16, t12) => e16[t12], set(n11, r11, o10) {
    "userPreferences" === r11 && (o10 = $O(o10));
    const a10 = null !== t11[r11] && "object" == typeof t11[r11];
    if (("boolean" != typeof t11[r11] || true !== t11[r11]) && !a10) throw new Error(`"${r11}" is an immutable setting`);
    return n11[r11] = a10 ? YO(e15, o10, t11[r11]) : o10, jO.dispatchEvent(new CustomEvent(WO(e15), { detail: { instanceId: e15 } })), jO.dispatchEvent(new CustomEvent(WO(e15, r11), { detail: { instanceId: e15 } })), true;
  } }))(e14, n10));
};
const KO = (e14, t10, n10, r10 = {}) => {
  if (e14 in ZO) throw new Error(`Settings[id=${e14}] already exists. Use DesignerCore.settings.of(id)`);
  ZO[e14] = qO(t10, n10);
  const o10 = YO(e14, ZO[e14], BV.merge(UO, r10));
  return GO[e14] = o10, ZO[e14];
};
KO.of = (e14) => (((e15) => {
  if (!(e15 in ZO)) throw new Error(`Settings[id=${e15}] was not found`);
})(e14), GO[e14]), KO.subscribe = (e14, t10) => (jO.addEventListener(WO(e14), t10), () => jO.removeEventListener(WO(e14), t10)), KO.subscribeTo = (e14, t10, n10) => (jO.addEventListener(WO(e14, t10), n10), () => jO.removeEventListener(WO(e14, t10), n10)), KO.destroy = (e14) => {
  e14 in ZO && delete ZO[e14], e14 in GO && delete GO[e14];
};
const XO = _V("@core/workspaces/set", (e14) => ({ workspaceId: e14 }));
const JO = _V("@core/appBar/setItemId", (e14) => ({ itemId: e14 }));
const QO = _V("@core/menu/setPanel", ({ panelId: e14, workspaceId: t10 }) => ({ panelId: e14, workspaceId: t10 }));
const eB = _V("@core/menu/setPin", ({ pinned: e14, workspaceId: t10 }) => ({ pinned: e14, workspaceId: t10 }));
const tB = _V("@core/menu/setStatus", ({ status: e14, workspaceId: t10 }) => ({ status: e14, workspaceId: t10 }));
const nB = _V("@core/documents/updateDocumentInfo", (e14) => ({ name: e14 }), () => ({ skipUndo: true }));
const rB = _V("@core/documents/removeDirty", void 0, () => ({ skipUndo: true }));
const oB = _V("@core/documents/setDirty");
const aB = _V("@core/documents/restoreUnsaved", (e14) => e14);
const iB = IV((e14, t10, n10, r10) => ({ type: "@core/setProperty", payload: { descriptor: e14, value: t10 }, meta: { path: n10, naming: r10 } }), "@core/setProperty");
const sB = IV((e14) => ({ type: "@core/selection/set", meta: { path: e14, skipDirty: true, skipUndo: true } }), "@core/selection/set");
const lB = IV((e14) => ({ type: "@core/selection/expand", meta: { path: e14, skipDirty: true, skipUndo: true } }), "@core/selection/expand");
const cB = IV((e14) => ({ type: "@core/selection/unset", meta: { path: e14, skipDirty: true, skipUndo: true } }), "@core/selection/unset");
const uB = IV((e14, t10) => ({ type: "@core/selection/multiSet", payload: { primaryPath: e14, secondaryPaths: t10 }, meta: { skipDirty: true, skipUndo: true } }), "@core/selection/multiSet");
const dB = _V("@core/clipboard/copy");
const pB = _V("@core/clipboard/cut");
const mB = _V("@core/clipboard/paste", (e14, t10 = false) => ({ mousePosition: e14, contextAction: t10 }));
const hB = _V("@core/themes/reset");
const fB = _V("@core/themes/set", (e14) => ({ themeName: e14 }));
const gB = _V("@core/themes/updateCurrent", (e14) => ({ partialTheme: e14 }));
const yB = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 2.5, 3, 3.5, 4];
const vB = (e14, t10, n10) => {
  const r10 = n10 || yB;
  const [o10, a10] = [r10[0], r10[r10.length - 1]];
  const i10 = parseFloat((e14 + (t10 ? 0.1 : -0.1)).toFixed(2));
  if (e14 < o10 || e14 > a10) throw new Error();
  return i10 < o10 || i10 > a10 ? e14 : i10;
};
const bB = (_p2 = (_o2 = navigator == null ? void 0 : navigator.platform) == null ? void 0 : _o2.toUpperCase().includes("MAC")) != null ? _p2 : false;
const SB = (e14) => bB ? e14.metaKey : e14.ctrlKey;
const CB = (e14) => {
  let t10 = "";
  return SB(e14) && (t10 += "Ctrl+"), e14.shiftKey && (t10 += "Shift+"), e14.altKey && (t10 += "Alt+"), t10;
};
const xB = { "Ctrl+KeyZ": () => lO.ActionCreators.undo(), "Ctrl+KeyY": () => lO.ActionCreators.redo() };
const wB = { "Ctrl+KeyC": () => dB(), "Ctrl+KeyV": () => mB(), "Ctrl+KeyX": () => pB() };
const TB = ({ settings: e14 }) => () => {
  const t10 = KO.of(e14.instanceId).userPreferences.surface.zoomFactor;
  KO.of(e14.instanceId).userPreferences.surface.zoomFactor = vB(t10, true);
};
const EB = ({ settings: e14 }) => () => {
  const t10 = KO.of(e14.instanceId).userPreferences.surface.zoomFactor;
  KO.of(e14.instanceId).userPreferences.surface.zoomFactor = vB(t10, false);
};
const FB = ({ settings: e14 }) => () => {
  KO.of(e14.instanceId).userPreferences.surface.zoomFactor = 1;
};
const MB = { "Ctrl+Digit0": FB, "Ctrl+Numpad0": FB, "Ctrl+Equal": TB, "Ctrl+NumpadAdd": TB, "Ctrl+Minus": EB, "Ctrl+NumpadSubtract": EB, "Ctrl+WheelUp": TB, "Ctrl+WheelDown": EB };
const kB = (e14) => (_a2) => {
  var _b2 = _a2, { dispatch: t10 } = _b2, n10 = __objRest(_b2, ["dispatch"]);
  const r10 = e14(n10);
  ((e15) => !!(e15 == null ? void 0 : e15.type))(r10) ? t10(r10) : r10 && r10();
};
const PB = (e14, t10) => {
  const n10 = ((e15, t11) => xB[e15] ? xB[e15] : !t11.lockLayout && wB[e15] ? wB[e15] : MB[e15] ? MB[e15] : null)(e14, t10);
  return n10 ? kB(n10) : null;
};
const NB = (e14) => (t10) => {
  try {
    return JSON.parse(t10);
  } catch (t11) {
    return console.error(`utils/init.ts:: Incorrect ${"in" === e14 ? "imperialTemplates" : "metricTemplates"} in designerOptions.customInitTemplates: `, t11.message), {};
  }
};
var DB = { exports: {} };
var LB = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);
if (LB) {
  var HB = new Uint8Array(16);
  DB.exports = function() {
    return LB(HB), HB;
  };
} else {
  var IB = new Array(16);
  DB.exports = function() {
    for (var e14, t10 = 0; t10 < 16; t10++) 0 == (3 & t10) && (e14 = 4294967296 * Math.random()), IB[t10] = e14 >>> ((3 & t10) << 3) & 255;
    return IB;
  };
}
var _B = DB.exports;
var VB = [];
for (var RB = 0; RB < 256; ++RB) VB[RB] = (RB + 256).toString(16).substr(1);
var AB = function(e14, t10) {
  var n10 = t10 || 0;
  var r10 = VB;
  return [r10[e14[n10++]], r10[e14[n10++]], r10[e14[n10++]], r10[e14[n10++]], "-", r10[e14[n10++]], r10[e14[n10++]], "-", r10[e14[n10++]], r10[e14[n10++]], "-", r10[e14[n10++]], r10[e14[n10++]], "-", r10[e14[n10++]], r10[e14[n10++]], r10[e14[n10++]], r10[e14[n10++]], r10[e14[n10++]], r10[e14[n10++]]].join("");
};
var OB = _B;
var BB = AB;
var zB;
var $B;
var WB = 0;
var jB = 0;
var ZB = function(e14, t10, n10) {
  var r10 = t10 && n10 || 0;
  var o10 = t10 || [];
  var a10 = (e14 = e14 || {}).node || zB;
  var i10 = void 0 !== e14.clockseq ? e14.clockseq : $B;
  if (null == a10 || null == i10) {
    var s10 = OB();
    null == a10 && (a10 = zB = [1 | s10[0], s10[1], s10[2], s10[3], s10[4], s10[5]]), null == i10 && (i10 = $B = 16383 & (s10[6] << 8 | s10[7]));
  }
  var l10 = void 0 !== e14.msecs ? e14.msecs : (/* @__PURE__ */ new Date()).getTime();
  var c10 = void 0 !== e14.nsecs ? e14.nsecs : jB + 1;
  var u10 = l10 - WB + (c10 - jB) / 1e4;
  if (u10 < 0 && void 0 === e14.clockseq && (i10 = i10 + 1 & 16383), (u10 < 0 || l10 > WB) && void 0 === e14.nsecs && (c10 = 0), c10 >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  WB = l10, jB = c10, $B = i10;
  var d10 = (1e4 * (268435455 & (l10 += 122192928e5)) + c10) % 4294967296;
  o10[r10++] = d10 >>> 24 & 255, o10[r10++] = d10 >>> 16 & 255, o10[r10++] = d10 >>> 8 & 255, o10[r10++] = 255 & d10;
  var p10 = l10 / 4294967296 * 1e4 & 268435455;
  o10[r10++] = p10 >>> 8 & 255, o10[r10++] = 255 & p10, o10[r10++] = p10 >>> 24 & 15 | 16, o10[r10++] = p10 >>> 16 & 255, o10[r10++] = i10 >>> 8 | 128, o10[r10++] = 255 & i10;
  for (var m10 = 0; m10 < 6; ++m10) o10[r10 + m10] = a10[m10];
  return t10 || BB(o10);
};
var GB = W(ZB);
const UB = "{";
const qB = "#";
const YB = "}";
function KB(e14) {
  const t10 = e14 && e14.length > 0 ? e14 : "Item";
  const n10 = GB();
  return `${UB}${t10}${qB}${n10}${YB}`;
}
const XB = (e14, t10) => !t10.some((t11) => t11.toLowerCase() === e14.toLowerCase());
const JB = (e14, t10) => {
  let n10 = 1;
  for (; ; ) {
    const r10 = `${e14}${n10}`;
    if (XB(r10, t10)) return r10;
    n10++;
  }
};
function QB(e14, t10) {
  const n10 = {};
  let r10;
  const o10 = () => `DocumentItems[id=${e14}, documentType=${t10}]`;
  function a10(e15) {
    const t11 = i10(e15);
    return t11 ? t11.baseType || t11.type : void 0;
  }
  function i10(e15) {
    const t11 = n10[e15.toLowerCase()];
    return t11 || r10;
  }
  function s10(t11, n11) {
    if (!t11.initTemplates) return;
    const { units: r11 } = KO.of(e14).userPreferences;
    const o11 = t11.initTemplates[r11];
    if (!Array.isArray(o11)) return;
    const a11 = n11 ? o11.find((e15) => e15.id === n11) : o11[0];
    return a11 == null ? void 0 : a11.content;
  }
  return { register: function(t11) {
    if (!r10) throw new Error(`${o10()}: Register default item first`);
    const { type: a11 } = t11;
    const i11 = a11.toLowerCase();
    if (i11 in n10) throw new Error(`${o10()}: Item type ${a11} already registered`);
    n10[i11] = __spreadProps(__spreadValues({}, t11), { reducer: t11.getReducer ? t11.getReducer(e14) : void 0 });
  }, registerDefaults: function(t11) {
    if (r10) throw new Error(`${o10()}: default item already registered`);
    r10 = __spreadProps(__spreadValues({}, t11), { reducer: t11.getReducer(e14) });
  }, registerTemplates: function(e15, t11, r11, o11, i11) {
    const s11 = function(e16, t12, n11, r12, o12) {
      const a11 = { in: {}, cm: {} };
      function i12(e17, n12) {
        const r13 = {};
        e17.forEach((e18) => {
          var _a2;
          const n13 = e18.Type.toLowerCase();
          r13[n13] || (r13[n13] = []), r13[n13].push({ id: e18.Name, name: t12(e18), content: (_a2 = o12 == null ? void 0 : o12(e18)) != null ? _a2 : e18 });
        });
        for (const [e18, t13] of Object.entries(r13)) {
          a11[n12][e18] || (a11[n12][e18] = []);
          const r14 = a11[n12][e18];
          if (r14.length <= 1) a11[n12][e18] = t13;
          else for (const e19 of t13) {
            const t14 = r14.findIndex((t15) => t15.id === e19.id);
            t14 >= 0 ? r14[t14] = e19 : r14.push(e19);
          }
        }
      }
      function s12(t13) {
        const { imperialTemplates: n12, metricTemplates: r13 } = t13;
        const o13 = n12.map((t14) => e16(t14, void 0));
        const a12 = r13.map((t14) => e16(t14, void 0));
        o13.forEach((e17) => i12(e17, "in")), a12.forEach((e17) => i12(e17, "cm"));
      }
      if (s12(n11), !r12) return a11;
      const { imperialTemplates: l10 = [], metricTemplates: c10 = [] } = r12;
      return s12({ imperialTemplates: l10.map(NB("in")) || [], metricTemplates: c10.map(NB("cm")) || [] }), a11;
    }(e15, t11, r11, o11, i11);
    Object.keys(n10).forEach((e16) => {
      const t12 = a10(e16).toLowerCase();
      n10[e16].initTemplates = { in: s11.in[t12], cm: s11.cm[t12] };
    });
  }, create: function(t11, n11, r11, a11 = {}) {
    const l10 = i10(t11);
    if (!l10) throw new Error(`${o10()}.create('${t11}'): Unknown type`);
    if (!l10.init) throw new Error(`${o10()}.create('${t11}'): item.init() is undefined`);
    return l10.init(n11 || KB(t11), e14, a11, s10(l10, r11));
  }, getBaseType: a10, getDescriptor: i10, getDescriptorByBaseType: function(e15) {
    for (const t11 of Object.values(n10)) {
      if ((t11.baseType || t11.type) === e15) return t11;
    }
  }, getDefaultReducer: function() {
    if (!r10) throw new Error(`${o10()}: Register default item first`);
    return r10.reducer;
  }, getDefaults: () => r10, getFeature: function(e15, t11) {
    var _a2, _b2;
    const n11 = i10(e15);
    const o11 = (_a2 = n11 == null ? void 0 : n11.features) == null ? void 0 : _a2[t11];
    return void 0 === o11 ? (_b2 = r10.features) == null ? void 0 : _b2[t11] : o11;
  }, getGlyph: function(e15) {
    const t11 = i10(e15);
    return (t11 == null ? void 0 : t11.glyph) || r10.glyph;
  }, getContextActions: function(t11, n11) {
    const r11 = i10(t11.Type);
    return (r11 == null ? void 0 : r11.getContextActions) ? r11.getContextActions(t11, e14, n11) : [];
  }, getIcon: function(e15) {
    const t11 = i10(e15);
    return (t11 == null ? void 0 : t11.icon) || r10.icon;
  }, getLabelKey: function(e15) {
    const t11 = i10(e15);
    return (t11 == null ? void 0 : t11.labelKey) || r10.labelKey;
  }, getNameTemplateKey: function(e15) {
    const t11 = i10(e15);
    return (t11 == null ? void 0 : t11.nameTemplateKey) || r10.nameTemplateKey;
  }, getReducer: function(e15) {
    const t11 = i10(e15);
    return (t11 == null ? void 0 : t11.reducer) || r10.reducer;
  }, getRegisteredTypes: () => Object.keys(n10), toString: o10, getTemplate: function(e15, t11) {
    const n11 = i10(e15);
    return n11 ? s10(n11, t11) : void 0;
  }, getTemplates: function(t11) {
    const { units: n11 } = KO.of(e14).userPreferences;
    const r11 = i10(t11);
    if (r11 == null ? void 0 : r11.initTemplates) return r11.initTemplates[n11];
  } };
}
const ez = {};
let tz = null;
const nz = (e14) => {
  const t10 = () => `DocumentItems[id=${e14}]`;
  if (e14 in ez) throw new Error(`${t10()} already exists. Use DocumentItemsAPI.of(id)`);
  const n10 = {};
  let r10;
  const o10 = { registerDocumentType: function(t11) {
    return t11 in n10 || (n10[t11] = QB(e14, t11)), n10[t11];
  }, useDocumentType: function(e15) {
    if (!(e15 in n10)) throw new Error(`${t10()} Document type ${e15} not registered`);
    return r10 = n10[e15], r10;
  }, toString: t10, of: function(e15) {
    if (!(e15 in n10)) throw new Error(`${t10()} Document type ${e15} not registered`);
    return n10[e15];
  }, destroy: function() {
    delete ez[e14];
  }, hasDocumentType: function(e15) {
    return e15 in n10;
  }, register: (e15) => r10.register(e15), registerDefaults: (e15) => r10.registerDefaults(e15), registerTemplates: (e15, t11, n11, o11, a10) => r10.registerTemplates(e15, t11, n11, o11, a10), create: (e15, t11, n11, o11) => r10.create(e15, t11, n11, o11), getBaseType: (e15) => r10.getBaseType(e15), getDescriptor: (e15) => r10.getDescriptor(e15), getDescriptorByBaseType: (e15) => r10.getDescriptorByBaseType(e15), getDefaults: () => r10.getDefaults(), getDefaultReducer: () => r10.getDefaultReducer(), getFeature: (e15, t11) => r10.getFeature(e15, t11), getGlyph: (e15) => r10.getGlyph(e15), getContextActions: (e15, t11) => r10.getContextActions(e15, t11), getIcon: (e15) => r10.getIcon(e15), getLabelKey: (e15) => r10.getLabelKey(e15), getNameTemplateKey: (e15) => r10.getNameTemplateKey(e15), getReducer: (e15) => r10.getReducer(e15), getRegisteredTypes: () => r10.getRegisteredTypes(), getTemplate: (e15, t11) => r10.getTemplate(e15, t11), getTemplates: (e15) => r10.getTemplates(e15) };
  return tz = o10, ez[e14] = o10, o10;
};
nz.of = (e14) => ez[e14], nz.destroy = (e14) => {
  var _a2;
  return (_a2 = nz.of(e14)) == null ? void 0 : _a2.destroy();
};
const rz = _V("@core/transaction", (e14) => ({ actions: e14 }));
const oz = {};
const az = (e14, t10) => {
  const n10 = {};
  let r10 = [];
  function o10(n11) {
    const r11 = nz.of(e14).getNameTemplateKey(n11);
    return t10(r11, { defaultValue: void 0 });
  }
  const a10 = { getNameFactory: function() {
    const e15 = [...r10];
    return { getNextNameByTemplate(t11) {
      const n11 = JB(t11, e15);
      return e15.push(n11), n11;
    }, getNextDocumentItemName(t11) {
      const n11 = JB(o10(t11), e15);
      return e15.push(n11), n11;
    } };
  }, getNextNameByTemplate: function(e15) {
    return JB(e15, r10);
  }, getNextDocumentItemName: function(e15) {
    return JB(o10(e15), r10);
  }, findDuplicates: function() {
    const e15 = r10.slice().sort();
    const t11 = [];
    for (let n11 = 0; n11 < e15.length - 1; n11++) e15[n11 + 1] === e15[n11] && t11.push(e15[n11]);
    return t11;
  }, update: function(e15, t11) {
    r10 = e15 && t11 ? n10[e15](t11) : [];
  }, addNames: function(e15) {
    r10.push(...Array.isArray(e15) ? e15 : [e15]);
  }, isNameAvailable: function(e15) {
    return XB(e15, r10);
  }, registerDocumentType: function(e15, t11) {
    n10[e15] = t11;
  }, getDocumentItemTemplate: o10 };
  return oz[e14] = a10, a10;
};
az.of = (e14) => oz[e14], az.destroy = (e14) => delete oz[e14];
const iz = [lO.ActionTypes.UNDO, lO.ActionTypes.REDO, lO.ActionTypes.CLEAR_HISTORY, lO.ActionTypes.JUMP];
function sz(e14, t10, n10) {
  var _a2;
  const r10 = (_a2 = e14.meta) == null ? void 0 : _a2.naming;
  (r10 == null ? void 0 : r10.update) || iz.includes(e14.type) ? az.of(t10).update(n10.present.type.platform, n10.present.content) : (r10 == null ? void 0 : r10.add) && az.of(t10).addNames(r10.add);
}
az.reducerDecorator = (e14) => (t10) => (n10, r10) => {
  const o10 = t10(n10, r10);
  return n10 !== o10 && r10 ? (rz.match(r10) ? r10.payload.actions.forEach((t11) => sz(t11, e14, o10)) : sz(r10, e14, o10), o10) : n10;
};
const lz = (e14) => {
  var _b2, _c2, _d2;
  const _a2 = e14, { rulersBackground: t10, rulersSpanBackgroundPrimary: n10, rulersSpanBackgroundSecondary: r10, isDark: o10 } = _a2, a10 = __objRest(_a2, ["rulersBackground", "rulersSpanBackgroundPrimary", "rulersSpanBackgroundSecondary", "isDark"]);
  return __spreadProps(__spreadValues({}, a10), { custom: { "--wd-rulers-bg": (_b2 = t10 == null ? void 0 : t10.rgba) != null ? _b2 : "rgba(255, 255, 255, 1)", "--wd-rulers-span-primary": (_c2 = n10 == null ? void 0 : n10.rgba) != null ? _c2 : "rgba(32, 95, 120, 0.3)", "--wd-rulers-span-secondary": (_d2 = r10 == null ? void 0 : r10.rgba) != null ? _d2 : "rgba(32, 95, 120, 0.15)", isDark: o10 ? "true" : "", "--wd-bg-panels-light": a10.backgroundPanels.lighten(o10 ? 0.1 : 0.5).rgba } });
};
const cz = __spreadProps(__spreadValues({}, bm.defaultDark), { rulersBackground: dm.fromHEX("#414141"), rulersSpanBackgroundPrimary: dm.fromHEX("#1A4B5E"), rulersSpanBackgroundSecondary: dm.fromHEX("#0B3546"), isDark: true });
const uz = { system: window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? __spreadProps(__spreadValues({}, cz), { name: "system" }) : __spreadProps(__spreadValues({}, bm.default), { name: "system" }), default: __spreadValues({}, bm.default), defaultDark: cz, darkOled: __spreadProps(__spreadValues({}, bm.darkOled), { rulersBackground: dm.fromHEX("#222222"), rulersSpanBackgroundPrimary: dm.fromHEX("#1A4B5E"), rulersSpanBackgroundSecondary: dm.fromHEX("#0B3546"), isDark: true }), highContrast: __spreadProps(__spreadValues({}, bm.highContrast), { rulersBackground: dm.fromHEX("#fff"), rulersSpanBackgroundPrimary: dm.fromHEX("#CABBDD"), rulersSpanBackgroundSecondary: dm.fromHEX("#E3DCED"), isDark: false }), highContrastDark: __spreadProps(__spreadValues({}, bm.highContrastDark), { rulersBackground: dm.fromHEX("#444444"), rulersSpanBackgroundPrimary: dm.fromHEX("#5A7377"), rulersSpanBackgroundSecondary: dm.fromHEX("#536366"), isDark: true }) };
function dz(e14) {
  return "group" === e14.type;
}
const pz = "editor";
const mz = { type: {} };
const hz = { id: "", workspaceId: pz, appBarItemId: "Home", sidebarTabId: "Properties", hasUnsavedChanges: false, documentName: "", contextActions: [], theme: uz.default, document: { past: [], present: __spreadValues({}, mz), future: [], _latestUnfiltered: __spreadValues({}, mz), index: 0, limit: 100, group: void 0 }, menu: { editor: { status: "collapsed", pinned: false }, workspaces: {} } };
const fz = (e14, t10) => e14.workspaces[t10] ? e14 : AV(e14, { workspaces: { [t10]: { $set: { pinned: false, status: "collapsed" } } } });
const gz = (e14) => (t10, n10) => {
  const r10 = e14(t10.menu, n10);
  return r10 !== t10.menu ? __spreadProps(__spreadValues({}, t10), { menu: r10 }) : t10;
};
const yz = gz((e14, t10) => {
  const { panelId: n10, workspaceId: r10 } = t10.payload;
  if (r10 === pz) return AV(e14, { editor: { panelId: { $set: n10 } } });
  const o10 = fz(e14, r10);
  return AV(o10, { workspaces: { [r10]: { panelId: { $set: n10 } } } });
});
const vz = gz((e14, t10) => {
  const { pinned: n10, workspaceId: r10 } = t10.payload;
  if (r10 === pz) return AV(e14, { editor: { pinned: { $set: n10 } } });
  const o10 = fz(e14, r10);
  return AV(o10, { workspaces: { [r10]: { pinned: { $set: n10 } } } });
});
const bz = gz((e14, t10) => {
  const { status: n10, workspaceId: r10 } = t10.payload;
  if (r10 === pz) return AV(e14, { editor: { status: { $set: n10 } } });
  const o10 = fz(e14, r10);
  return AV(o10, { workspaces: { [r10]: { status: { $set: n10 } } } });
});
const Sz = { [XO.type]: (e14, { payload: { workspaceId: t10 } }) => __spreadProps(__spreadValues({}, e14), { workspaceId: t10 }), [JO.type]: (e14, { payload: { itemId: t10 } }) => __spreadProps(__spreadValues({}, e14), { appBarItemId: t10 }), [tB.type]: bz, [QO.type]: yz, [eB.type]: vz, [hB.type]: (e14) => AV(e14, { theme: { $set: uz.default } }), [fB.type]: (e14, { payload: { themeName: t10 } }) => {
  if (t10 === e14.theme.name) return e14;
  const n10 = ((e15, t11) => {
    const n11 = t11.find((t12) => "string" == typeof t12 ? t12 === e15 : t12.name === e15);
    return n11 ? "string" == typeof n11 ? uz[n11] : n11 : uz.default;
  })(t10, KO.of(e14.id).themes.list);
  return AV(e14, { theme: { $set: n10 } });
}, [gB.type]: (e14, { payload: { partialTheme: t10 } }) => {
  const n10 = __spreadValues(__spreadValues({}, e14.theme), t10);
  return AV(e14, { theme: { $set: n10 } });
} };
const Cz = (e14, { payload: { type: t10 } }) => __spreadProps(__spreadValues({}, e14), { type: t10 });
const xz = (e14, t10) => {
  const { payload: { descriptor: { valuePath: n10 }, value: r10 } } = t10;
  const o10 = n10.split(".");
  const a10 = {};
  let i10 = a10;
  for (const e15 of o10) i10[e15] = {}, i10 = i10[e15];
  return i10.$set = r10, AV(e14, a10);
};
const wz = $A((e14) => e14, (_q2) => {
  var { core: _r2 } = _q2, _s2 = _r2, { document: e14 } = _s2, t10 = __objRest(_s2, ["document"]);
  return t10;
});
const Tz = $A((e14) => e14, ({ core: { document: e14 } }) => e14.present);
const Ez = $A((e14) => e14, ({ core: { document: { present: { content: e14 } } } }) => e14);
$A((e14) => e14, ({ core: { menu: e14 } }) => e14);
const Fz = $A((e14) => e14, ({ core: { workspaceId: e14 } }) => [e14]);
const Mz = () => LA(wz);
const kz = () => LA(Tz);
const Pz = () => LA(Ez);
const Nz = () => LA(Fz);
const [Dz] = Dp("wd-property-grid");
const [Lz] = Dp("wd-property-list");
const [Hz, Iz] = Dp("wd-drop-area");
const _z = (e14, t10) => kp(Hz, { [Iz("hover")]: e14, [Iz("can-drop")]: t10 });
var Vz = { exports: {} };
/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */
!function(e14) {
  !function(t10, n10, r10) {
    e14.exports ? e14.exports = r10() : t10.bowser = r10();
  }($, 0, function() {
    var e15 = true;
    function t10(t11) {
      function n11(e16) {
        var n12 = t11.match(e16);
        return n12 && n12.length > 1 && n12[1] || "";
      }
      function r11(e16) {
        var n12 = t11.match(e16);
        return n12 && n12.length > 1 && n12[2] || "";
      }
      var o11 = n11(/(ipod|iphone|ipad)/i).toLowerCase(), i11 = !/like android/i.test(t11) && /android/i.test(t11), s10 = /nexus\s*[0-6]\s*/i.test(t11), l10 = !s10 && /nexus\s*[0-9]+/i.test(t11), c10 = /CrOS/.test(t11), u10 = /silk/i.test(t11), d10 = /sailfish/i.test(t11), p10 = /tizen/i.test(t11), m10 = /(web|hpw)(o|0)s/i.test(t11), h10 = /windows phone/i.test(t11);
      /SamsungBrowser/i.test(t11);
      var f10, g10 = !h10 && /windows/i.test(t11), y10 = !o11 && !u10 && /macintosh/i.test(t11), v10 = !i11 && !d10 && !p10 && !m10 && /linux/i.test(t11), b10 = r11(/edg([ea]|ios)\/(\d+(\.\d+)?)/i), S10 = n11(/version\/(\d+(\.\d+)?)/i), C10 = /tablet/i.test(t11) && !/tablet pc/i.test(t11), x10 = !C10 && /[^-]mobi/i.test(t11), w10 = /xbox/i.test(t11);
      /opera/i.test(t11) ? f10 = { name: "Opera", opera: e15, version: S10 || n11(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i) } : /opr\/|opios/i.test(t11) ? f10 = { name: "Opera", opera: e15, version: n11(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || S10 } : /SamsungBrowser/i.test(t11) ? f10 = { name: "Samsung Internet for Android", samsungBrowser: e15, version: S10 || n11(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i) } : /Whale/i.test(t11) ? f10 = { name: "NAVER Whale browser", whale: e15, version: n11(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i) } : /MZBrowser/i.test(t11) ? f10 = { name: "MZ Browser", mzbrowser: e15, version: n11(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i) } : /coast/i.test(t11) ? f10 = { name: "Opera Coast", coast: e15, version: S10 || n11(/(?:coast)[\s\/](\d+(\.\d+)?)/i) } : /focus/i.test(t11) ? f10 = { name: "Focus", focus: e15, version: n11(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i) } : /yabrowser/i.test(t11) ? f10 = { name: "Yandex Browser", yandexbrowser: e15, version: S10 || n11(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i) } : /ucbrowser/i.test(t11) ? f10 = { name: "UC Browser", ucbrowser: e15, version: n11(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i) } : /mxios/i.test(t11) ? f10 = { name: "Maxthon", maxthon: e15, version: n11(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i) } : /epiphany/i.test(t11) ? f10 = { name: "Epiphany", epiphany: e15, version: n11(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i) } : /puffin/i.test(t11) ? f10 = { name: "Puffin", puffin: e15, version: n11(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i) } : /sleipnir/i.test(t11) ? f10 = { name: "Sleipnir", sleipnir: e15, version: n11(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i) } : /k-meleon/i.test(t11) ? f10 = { name: "K-Meleon", kMeleon: e15, version: n11(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i) } : h10 ? (f10 = { name: "Windows Phone", osname: "Windows Phone", windowsphone: e15 }, b10 ? (f10.msedge = e15, f10.version = b10) : (f10.msie = e15, f10.version = n11(/iemobile\/(\d+(\.\d+)?)/i))) : /msie|trident/i.test(t11) ? f10 = { name: "Internet Explorer", msie: e15, version: n11(/(?:msie |rv:)(\d+(\.\d+)?)/i) } : c10 ? f10 = { name: "Chrome", osname: "Chrome OS", chromeos: e15, chromeBook: e15, chrome: e15, version: n11(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i) } : /edg([ea]|ios)/i.test(t11) ? f10 = { name: "Microsoft Edge", msedge: e15, version: b10 } : /vivaldi/i.test(t11) ? f10 = { name: "Vivaldi", vivaldi: e15, version: n11(/vivaldi\/(\d+(\.\d+)?)/i) || S10 } : d10 ? f10 = { name: "Sailfish", osname: "Sailfish OS", sailfish: e15, version: n11(/sailfish\s?browser\/(\d+(\.\d+)?)/i) } : /seamonkey\//i.test(t11) ? f10 = { name: "SeaMonkey", seamonkey: e15, version: n11(/seamonkey\/(\d+(\.\d+)?)/i) } : /firefox|iceweasel|fxios/i.test(t11) ? (f10 = { name: "Firefox", firefox: e15, version: n11(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i) }, /\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(t11) && (f10.firefoxos = e15, f10.osname = "Firefox OS")) : u10 ? f10 = { name: "Amazon Silk", silk: e15, version: n11(/silk\/(\d+(\.\d+)?)/i) } : /phantom/i.test(t11) ? f10 = { name: "PhantomJS", phantom: e15, version: n11(/phantomjs\/(\d+(\.\d+)?)/i) } : /slimerjs/i.test(t11) ? f10 = { name: "SlimerJS", slimer: e15, version: n11(/slimerjs\/(\d+(\.\d+)?)/i) } : /blackberry|\bbb\d+/i.test(t11) || /rim\stablet/i.test(t11) ? f10 = { name: "BlackBerry", osname: "BlackBerry OS", blackberry: e15, version: S10 || n11(/blackberry[\d]+\/(\d+(\.\d+)?)/i) } : m10 ? (f10 = { name: "WebOS", osname: "WebOS", webos: e15, version: S10 || n11(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i) }, /touchpad\//i.test(t11) && (f10.touchpad = e15)) : /bada/i.test(t11) ? f10 = { name: "Bada", osname: "Bada", bada: e15, version: n11(/dolfin\/(\d+(\.\d+)?)/i) } : p10 ? f10 = { name: "Tizen", osname: "Tizen", tizen: e15, version: n11(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || S10 } : /qupzilla/i.test(t11) ? f10 = { name: "QupZilla", qupzilla: e15, version: n11(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || S10 } : /chromium/i.test(t11) ? f10 = { name: "Chromium", chromium: e15, version: n11(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || S10 } : /chrome|crios|crmo/i.test(t11) ? f10 = { name: "Chrome", chrome: e15, version: n11(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i) } : i11 ? f10 = { name: "Android", version: S10 } : /safari|applewebkit/i.test(t11) ? (f10 = { name: "Safari", safari: e15 }, S10 && (f10.version = S10)) : o11 ? (f10 = { name: "iphone" == o11 ? "iPhone" : "ipad" == o11 ? "iPad" : "iPod" }, S10 && (f10.version = S10)) : f10 = /googlebot/i.test(t11) ? { name: "Googlebot", googlebot: e15, version: n11(/googlebot\/(\d+(\.\d+))/i) || S10 } : { name: n11(/^(.*)\/(.*) /), version: r11(/^(.*)\/(.*) /) }, !f10.msedge && /(apple)?webkit/i.test(t11) ? (/(apple)?webkit\/537\.36/i.test(t11) ? (f10.name = f10.name || "Blink", f10.blink = e15) : (f10.name = f10.name || "Webkit", f10.webkit = e15), !f10.version && S10 && (f10.version = S10)) : !f10.opera && /gecko\//i.test(t11) && (f10.name = f10.name || "Gecko", f10.gecko = e15, f10.version = f10.version || n11(/gecko\/(\d+(\.\d+)?)/i)), f10.windowsphone || !i11 && !f10.silk ? !f10.windowsphone && o11 ? (f10[o11] = e15, f10.ios = e15, f10.osname = "iOS") : y10 ? (f10.mac = e15, f10.osname = "macOS") : w10 ? (f10.xbox = e15, f10.osname = "Xbox") : g10 ? (f10.windows = e15, f10.osname = "Windows") : v10 && (f10.linux = e15, f10.osname = "Linux") : (f10.android = e15, f10.osname = "Android");
      var T10 = "";
      f10.windows ? T10 = function(e16) {
        switch (e16) {
          case "NT":
            return "NT";
          case "XP":
          case "NT 5.1":
            return "XP";
          case "NT 5.0":
            return "2000";
          case "NT 5.2":
            return "2003";
          case "NT 6.0":
            return "Vista";
          case "NT 6.1":
            return "7";
          case "NT 6.2":
            return "8";
          case "NT 6.3":
            return "8.1";
          case "NT 10.0":
            return "10";
          default:
            return;
        }
      }(n11(/Windows ((NT|XP)( \d\d?.\d)?)/i)) : f10.windowsphone ? T10 = n11(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i) : f10.mac ? T10 = (T10 = n11(/Mac OS X (\d+([_\.\s]\d+)*)/i)).replace(/[_\s]/g, ".") : o11 ? T10 = (T10 = n11(/os (\d+([_\s]\d+)*) like mac os x/i)).replace(/[_\s]/g, ".") : i11 ? T10 = n11(/android[ \/-](\d+(\.\d+)*)/i) : f10.webos ? T10 = n11(/(?:web|hpw)os\/(\d+(\.\d+)*)/i) : f10.blackberry ? T10 = n11(/rim\stablet\sos\s(\d+(\.\d+)*)/i) : f10.bada ? T10 = n11(/bada\/(\d+(\.\d+)*)/i) : f10.tizen && (T10 = n11(/tizen[\/\s](\d+(\.\d+)*)/i)), T10 && (f10.osversion = T10);
      var E10 = !f10.windows && T10.split(".")[0];
      return C10 || l10 || "ipad" == o11 || i11 && (3 == E10 || E10 >= 4 && !x10) || f10.silk ? f10.tablet = e15 : (x10 || "iphone" == o11 || "ipod" == o11 || i11 || s10 || f10.blackberry || f10.webos || f10.bada) && (f10.mobile = e15), f10.msedge || f10.msie && f10.version >= 10 || f10.yandexbrowser && f10.version >= 15 || f10.vivaldi && f10.version >= 1 || f10.chrome && f10.version >= 20 || f10.samsungBrowser && f10.version >= 4 || f10.whale && 1 === a10([f10.version, "1.0"]) || f10.mzbrowser && 1 === a10([f10.version, "6.0"]) || f10.focus && 1 === a10([f10.version, "1.0"]) || f10.firefox && f10.version >= 20 || f10.safari && f10.version >= 6 || f10.opera && f10.version >= 10 || f10.ios && f10.osversion && f10.osversion.split(".")[0] >= 6 || f10.blackberry && f10.version >= 10.1 || f10.chromium && f10.version >= 20 ? f10.a = e15 : f10.msie && f10.version < 10 || f10.chrome && f10.version < 20 || f10.firefox && f10.version < 20 || f10.safari && f10.version < 6 || f10.opera && f10.version < 10 || f10.ios && f10.osversion && f10.osversion.split(".")[0] < 6 || f10.chromium && f10.version < 20 ? f10.c = e15 : f10.x = e15, f10;
    }
    var n10 = t10("undefined" != typeof navigator && navigator.userAgent || "");
    function r10(e16) {
      return e16.split(".").length;
    }
    function o10(e16, t11) {
      var n11, r11 = [];
      if (Array.prototype.map) return Array.prototype.map.call(e16, t11);
      for (n11 = 0; n11 < e16.length; n11++) r11.push(t11(e16[n11]));
      return r11;
    }
    function a10(e16) {
      var t11 = Math.max(r10(e16[0]), r10(e16[1]));
      var n11 = o10(e16, function(e17) {
        var n12 = t11 - r10(e17);
        return o10((e17 += new Array(n12 + 1).join(".0")).split("."), function(e18) {
          return new Array(20 - e18.length).join("0") + e18;
        }).reverse();
      });
      for (; --t11 >= 0; ) {
        if (n11[0][t11] > n11[1][t11]) return 1;
        if (n11[0][t11] !== n11[1][t11]) return -1;
        if (0 === t11) return 0;
      }
    }
    function i10(e16, r11, o11) {
      var i11 = n10;
      "string" == typeof r11 && (o11 = r11, r11 = void 0), void 0 === r11 && (r11 = false), o11 && (i11 = t10(o11));
      var s10 = "" + i11.version;
      for (var l10 in e16) if (e16.hasOwnProperty(l10) && i11[l10]) {
        if ("string" != typeof e16[l10]) throw new Error("Browser version in the minVersion map should be a string: " + l10 + ": " + String(e16));
        return a10([s10, e16[l10]]) < 0;
      }
      return r11;
    }
    return n10.test = function(e16) {
      for (var t11 = 0; t11 < e16.length; ++t11) {
        var r11 = e16[t11];
        if ("string" == typeof r11 && r11 in n10) return true;
      }
      return false;
    }, n10.isUnsupportedBrowser = i10, n10.compareVersions = a10, n10.check = function(e16, t11, n11) {
      return !i10(e16, t11, n11);
    }, n10._detect = t10, n10.detect = t10, n10;
  });
}(Vz);
var Rz = W(Vz.exports);
const Az = Rz.webkit ? "webkit" : Rz.blink ? "blink" : Rz.gecko ? "gecko" : Rz.safari ? "safari" : null;
const Oz = { webkit: true, blink: true, gecko: false, safari: false };
const Bz = { webkit: true, blink: true, gecko: true, safari: true };
const zz = (e14) => Az && e14[Az] || false;
const $z = { get zoom() {
  return zz(Oz);
}, get rectangularSelection() {
  return zz(Bz);
} };
const Wz = "@core/panels/OPEN_PANEL";
const jz = "@core/panels/GOTO_PANEL";
const Zz = "@core/panels/CLOSE_PANEL";
const Gz = "@core/panels/RESET_PANELS";
const Uz = "@core/panels/INIT_PANEL";
const qz = "@core/panels/UPDATE_PANEL";
var Yz = { exports: {} };
!function(e14) {
  function t10(e15) {
    return null == e15;
  }
  function n10(e15) {
    throw new Error("Argument " + e15 + " is empty.");
  }
  function r10(e15) {
    return "function" == typeof e15 && "getType" in e15;
  }
  function o10(e15) {
    throw new Error("Argument " + e15 + ' is invalid, it should be an action-creator instance from "typesafe-actions"');
  }
  function a10(e15, t11) {
    if (null == e15) throw new Error("Argument contains array with empty element at index " + t11);
    if (null == e15.getType) throw new Error("Argument contains array with invalid element at index " + t11 + ', it should be an action-creator instance from "typesafe-actions"');
  }
  function i10(e15) {
    return "string" == typeof e15 || "symbol" == typeof e15;
  }
  function s10(e15) {
    return !i10(e15);
  }
  function l10(e15) {
    throw new Error("Argument " + e15 + " is invalid, it should be an action type of type: string | symbol");
  }
  function c10(e15, t11) {
    if (null == e15) throw new Error("Argument contains array with empty element at index " + t11);
    if ("string" != typeof e15 && "symbol" != typeof e15) throw new Error("Argument contains array with invalid element at index " + t11 + ", it should be of type: string | symbol");
  }
  function u10(e15, r11, a11, i11) {
    return t10(e15) && n10(1), s10(e15) && o10(1), { type: e15, payload: r11, meta: a11, error: i11 };
  }
  function d10(e15, r11) {
    return t10(e15) && n10(1), s10(e15) && l10(1), Object.assign(function() {
      var t11 = null != r11 ? r11.apply(void 0, arguments) : void 0;
      return Object.assign({ type: e15 }, t11);
    }, { getType: function() {
      return e15;
    }, toString: function() {
      return e15;
    } });
  }
  function p10(e15, r11, o11) {
    return t10(e15) && n10(1), s10(e15) && l10(1), function() {
      return d10(e15, function() {
        var e16 = arguments.length <= 0 ? void 0 : arguments[0], t11 = arguments.length <= 1 ? void 0 : arguments[1];
        return null == r11 && null == o11 || (e16 = null != r11 ? r11.apply(void 0, arguments) : void 0, t11 = null != o11 ? o11.apply(void 0, arguments) : void 0), Object.assign({}, void 0 !== e16 && { payload: e16 }, {}, void 0 !== t11 && { meta: t11 });
      });
    };
  }
  function m10(e15) {
    return t10(e15) && n10(1), r10(e15) || o10(1), e15.getType();
  }
  function h10(e15, r11) {
    t10(e15) && n10(1), s10(e15) && l10(1);
    var o11 = null != r11 ? r11(e15) : function() {
      return { type: e15 };
    };
    return Object.assign(o11, { getType: function() {
      return e15;
    }, toString: function() {
      return e15;
    } });
  }
  var f10 = { createAction: function(e15, t11) {
    var n11 = null == t11 ? function() {
      return u10(e15);
    } : t11(u10.bind(null, e15));
    return Object.assign(n11, { getType: function() {
      return e15;
    }, toString: function() {
      return e15;
    } });
  }, createCustomAction: h10, createStandardAction: function(e15) {
    return t10(e15) && n10(1), s10(e15) && l10(1), Object.assign(function() {
      return h10(e15, function(e16) {
        return function(t11, n11) {
          return { type: e16, payload: t11, meta: n11 };
        };
      });
    }, { map: function(t11) {
      return h10(e15, function(e16) {
        return function(n11, r11) {
          return Object.assign(t11(n11, r11), { type: e16 });
        };
      });
    } });
  } };
  e14.action = u10, e14.createAction = p10, e14.createAsyncAction = function(e15, t11, n11, r11) {
    return function() {
      var o11 = [e15, t11, n11, r11].map(function(e16, t12) {
        return Array.isArray(e16) ? p10(e16[0], e16[1], e16[2])() : "string" == typeof e16 || "symbol" == typeof e16 ? p10(e16)() : void (t12 < 3 && function(e17) {
          throw new Error("Argument " + e17 + ' is invalid, it should be an action type of "string | symbol" or a tuple of "[string | symbol, Function, Function?]"');
        }(t12));
      });
      return { request: o11[0], success: o11[1], failure: o11[2], cancel: o11[3] };
    };
  }, e14.createCustomAction = d10, e14.createReducer = function e15(t11, n11) {
    void 0 === n11 && (n11 = {});
    var o11 = Object.assign({}, n11), a11 = function(n12, a12) {
      var s11 = Array.isArray(n12) ? n12 : [n12], l11 = {};
      return s11.map(function(e16, t12) {
        return r10(e16) ? m10(e16) : i10(e16) ? e16 : function(e17) {
          throw new Error("Argument " + e17 + ' is invalid, it should be an action-creator instance from "typesafe-actions" or action type of type: string | symbol');
        }(t12 + 1);
      }).forEach(function(e16) {
        return l11[e16] = a12;
      }), e15(t11, Object.assign({}, o11, {}, l11));
    };
    return Object.assign(function(e16, n12) {
      if (void 0 === e16 && (e16 = t11), o11.hasOwnProperty(n12.type)) {
        var r11 = o11[n12.type];
        if ("function" != typeof r11) throw Error('Reducer under "' + n12.type + '" key is not a valid reducer');
        return r11(e16, n12);
      }
      return e16;
    }, { handlers: Object.assign({}, o11), handleAction: a11, handleType: a11 });
  }, e14.deprecated = f10, e14.getType = m10, e14.isActionOf = function(e15, r11) {
    t10(e15) && n10(1);
    var o11 = Array.isArray(e15) ? e15 : [e15];
    o11.forEach(a10);
    var i11 = function(e16) {
      return o11.some(function(t11) {
        return e16.type === t11.getType();
      });
    };
    return void 0 === r11 ? i11 : i11(r11);
  }, e14.isOfType = function(e15, r11) {
    t10(e15) && n10(1);
    var o11 = Array.isArray(e15) ? e15 : [e15];
    o11.forEach(c10);
    var a11 = function(e16) {
      return o11.includes(e16.type);
    };
    return void 0 === r11 ? a11 : a11(r11);
  };
}(Yz.exports);
var Kz = Yz.exports;
const Xz = (e14, t10, n10, r10) => Kz.action(Wz, { panelId: e14, panelName: t10, context: n10, params: r10 }), Jz = (e14) => Kz.action(jz, { panelId: e14 }), Qz = () => Kz.action(Zz), e$ = (e14) => Kz.action(Uz, e14), t$ = (e14, t10) => Kz.action(qz, { panelId: e14, action: t10 }), n$ = () => Kz.action(Gz);
const r$ = $A((e14) => e14, (e14) => e14.panels);
const o$ = () => LA(r$);
const a$ = (e14) => {
  const { panelStatesMap: t10 } = o$();
  const n10 = PA();
  const r10 = ep.useCallback((t11) => {
    n10(t$(e14, t11));
  }, [n10, e14]);
  const o10 = ep.useCallback((e15, t11) => {
    n10(Xz(e15, t11));
  }, [n10]);
  const a10 = ep.useCallback(() => {
    n10(Qz());
  }, [n10]);
  return { state: t10[e14], dispatch: n10, dispatchPanelAction: r10, openPanel: o10, closePanel: a10 };
};
const i$ = (e14, t10, n10) => {
  const [r10] = ep.useState({ objectPath: t10, objectValue: n10 });
  const o10 = a$(e14);
  const { closePanel: a10 } = o10;
  return ep.useEffect(() => {
    var e15, o11, i10, s10;
    e15 = r10.objectPath, o11 = r10.objectValue, s10 = n10, (["Body", "Pages.0"].includes((i10 = t10).join()) || i10.join() !== e15.join() || s10.length !== o11.length || s10.find((e16, t11) => e16.$selected !== o11[t11].$selected)) && a10();
  }, [t10, n10]), o10;
};
const [s$] = Dp("wd-panels-container");
const [l$, , c$] = Dp("wd-panels-header");
const [u$] = c$("back");
const [d$] = c$("nav");
const [p$] = Dp("wd-panels-content");
const m$ = ({ context: e14, panels: t10 }) => {
  const { t: n10 } = vp();
  const r10 = PA();
  const o10 = ep.useCallback(() => r10(Qz()), [r10]);
  const a10 = ep.useCallback((e15) => () => r10(Jz(e15)), [r10]);
  const [i10, ...s10] = t10;
  s10.reverse();
  const l10 = { block: true, accent: "full", size: "small" };
  const c10 = rf(bh, { rotate: "90" });
  const u10 = rf(oh, { rotate: "270" });
  const d10 = __spreadProps(__spreadValues({}, l10), { icon: c10, onClick: o10, customCSS: u$ });
  return tp.createElement("div", { className: l$ }, tp.createElement(qm, __spreadValues({}, d10)), tp.createElement("div", { className: d$ }, e14 && tp.createElement(qm, __spreadProps(__spreadValues({}, l10), { text: e14, onClick: a10(null) })), e14 && tp.createElement(Fm, { icon: u10 }), s10.map((e15) => [tp.createElement(qm, __spreadProps(__spreadValues({ key: e15.key }, l10), { text: e15.name, onClick: a10(e15.key) })), tp.createElement(Fm, { key: `${e15.key}_chevron`, icon: u10 })]), tp.createElement("span", null, n10(i10.name))));
};
const h$ = ({ panels: e14 }) => {
  const { $callstack: t10, context: n10 } = o$();
  if (0 === t10.length) return null;
  const { key: r10 } = t10[0];
  return tp.createElement("div", { className: s$ }, tp.createElement(m$, { panels: t10, context: n10 }), tp.createElement("div", { className: p$ }, e14[r10](r10)));
};
h$.displayName = "CorePanelsContainer";
const f$ = { getServerDataSourceInfo: () => ({ id: null, version: null }), getDataProviderLabel: ({ dataProvider: e14 }) => e14, isSemanticDataSource: () => false, getSemanticDataSourceInfo: () => ({ id: "", name: "", version: "" }), makeSemanticDataSource: () => null };
const g$ = (e14) => () => {
  throw Error(`Not implemented: ${e14}()`);
};
const y$ = (e14) => f$.getServerDataSourceInfo({ dataSource: e14 });
const v$ = (e14) => f$.getDataProviderLabel({ dataProvider: e14 });
const b$ = (e14) => f$.isSemanticDataSource({ dataSource: e14 });
let S$ = 0;
const C$ = () => {
  if (S$) return S$;
  {
    const e14 = document.documentElement.appendChild(document.createElement("DIV"));
    e14.style.width = "1in", e14.style.padding = "0", S$ = e14.offsetWidth, e14.parentNode && e14.parentNode.removeChild(e14);
  }
  return S$;
};
const x$ = /^(-?\d+(?:|\.\d+))(cm|mm|in|pt|pc)$/i;
const w$ = /^(\d+(?:|\.\d+))$/i;
const T$ = { in: 1440, pt: 20, pc: 240, cm: 566.9291338582677, mm: 56.69291338582677 };
const E$ = { in: 4, pt: 2, pc: 3, cm: 3, mm: 2, tw: 1 };
function F$(e14, t10, n10) {
  const r10 = k$(n10, t10.units).value;
  const o10 = e14(t10.value, r10);
  return new L$(o10, t10.units);
}
const M$ = (e14) => {
  const t10 = ((e15) => {
    if (!e15) throw new Error(`Unable to parse Length: ${e15}`);
    const t11 = Number(e15.value);
    const { units: n10 } = e15;
    if (Number.isNaN(t11) || !T$[n10]) throw new Error(`Unable to parse Length: ${e15}`);
    return { value: t11, units: n10 };
  })("string" == typeof e14 ? ((e15) => {
    if (!e15) return null;
    const t11 = x$.exec(e15);
    if (!t11) throw new Error(`Unable to parse Length: "${e15}", valid string format: <number><${Object.keys(T$).join("|")}>`);
    return { value: t11[1], units: t11[2] };
  })(e14) : e14);
  if (!t10) throw new Error(`Specified source (${JSON.stringify(e14)}) is invalid.`);
  return t10;
};
const k$ = (e14, t10) => {
  if (!T$[t10]) throw new Error(`Specified targetUnits (${t10}) is invalid.`);
  if (e14.units === t10) return new L$(e14.value, e14.units);
  const n10 = T$[e14.units] / T$[t10] * e14.value;
  return new L$(n10, t10);
};
const P$ = (e14) => Math.floor(N$(e14));
const N$ = (e14) => e14.value * T$[e14.units];
const D$ = (e14, t10, n10) => {
  if (!e14 || !t10) throw new Error(`One or both of specified lengths (${e14}: value ${e14 && e14.value}, units ${e14 && e14.units}),(${t10}: value ${t10 && t10.value}, units ${t10 && t10.units}) are invalid.`);
  return n10(P$(e14), P$(t10));
};
class L$ {
  constructor(e14, t10) {
    this.value = e14, this.units = t10;
  }
  get css() {
    const e14 = E$[this.units];
    const t10 = this.round(e14);
    return `${t10.value}${t10.units}`;
  }
  static toPixels(e14) {
    return ((e15) => {
      const t10 = M$(e15);
      return k$(t10, "in").value * C$();
    })(e14);
  }
  static fromPixels(e14, t10 = "in") {
    return ((e15, t11) => {
      if (!T$[t11]) throw new Error(`Specified targetUnits (${t11}) is invalid.`);
      const n10 = parseFloat(e15);
      if (Number.isNaN(n10)) throw new Error(`Specified length (${e15}) is invalid.`);
      const r10 = new L$(n10 / C$(), "in");
      return k$(r10, t11);
    })(e14, t10);
  }
  static fromTwips(e14, t10 = "in") {
    return ((e15, t11) => {
      if (!T$[t11]) throw new Error(`Specified targetUnits (${t11}) is invalid.`);
      return new L$(e15 / T$[t11], t11);
    })(e14, t10);
  }
  get toTwips() {
    return P$(this);
  }
  get toPreciseTwips() {
    return N$(this);
  }
  add(e14) {
    return F$((e15, t10) => e15 + t10, this, e14);
  }
  subtract(e14) {
    return F$((e15, t10) => e15 - t10, this, e14);
  }
  divideByNum(e14) {
    const t10 = parseFloat(e14);
    if (Number.isNaN(t10) || 0 === t10) throw new Error(`Specified divisor (${e14}) is invalid.`);
    return new L$(this.value / e14, this.units);
  }
  negative() {
    return new L$(-this.value, this.units);
  }
  abs() {
    return this.value >= 0 ? this : new L$(-this.value, this.units);
  }
  divide(e14) {
    if (0 === e14.value) throw new Error(`Specified length's value (${e14}: value ${e14.value}, units ${e14.units}) is invalid.`);
    const t10 = k$(e14, this.units);
    return this.value / t10.value;
  }
  multiply(e14) {
    const t10 = parseFloat(e14);
    if (Number.isNaN(t10)) throw new Error(`Specified multiplier (${e14}) is invalid.`);
    return new L$(this.value * t10, this.units);
  }
  equal(e14) {
    return D$(this, e14, (e15, t10) => e15 === t10);
  }
  absEqual(e14) {
    return D$(this, e14, (e15, t10) => Math.abs(e15) === Math.abs(t10));
  }
  greaterThan(e14) {
    return D$(this, e14, (e15, t10) => e15 > t10);
  }
  greaterThanOrEqual(e14) {
    return D$(this, e14, (e15, t10) => e15 >= t10);
  }
  lowerThan(e14) {
    return D$(this, e14, (e15, t10) => e15 < t10);
  }
  absLowerThan(e14) {
    return D$(this, e14, (e15, t10) => Math.abs(e15) < Math.abs(t10));
  }
  absLowerThanOrEqual(e14) {
    return D$(this, e14, (e15, t10) => Math.abs(e15) <= Math.abs(t10));
  }
  lowerThanOrEqual(e14) {
    return D$(this, e14, (e15, t10) => e15 <= t10);
  }
  round(e14) {
    const t10 = __pow(10, e14);
    const n10 = Math.round(this.value * t10) / t10;
    return new L$(n10, this.units);
  }
  normalize() {
    return this.round(E$[this.units]);
  }
  closeTo(e14, t10) {
    return this.subtract(e14).absLowerThan(t10);
  }
  static max(e14) {
    let t10;
    if (!e14 || !e14.length) throw new Error("Length.max(): wrong argument");
    return e14.forEach((e15) => {
      const n10 = L$.parse(e15);
      t10 ? n10.greaterThan(t10) && (t10 = n10) : t10 = n10;
    }), t10;
  }
  static min(e14) {
    let t10;
    if (!e14 || !e14.length) throw new Error("Length.min(): wrong argument");
    return e14.forEach((e15) => {
      const n10 = L$.parse(e15);
      t10 ? n10.lowerThan(t10) && (t10 = n10) : t10 = n10;
    }), t10;
  }
  static sum(e14, t10 = 0, n10 = null) {
    const r10 = null === n10 ? e14.length - 1 : Math.min(t10 + n10 - 1, e14.length - 1);
    if (t10 > r10) return L$.zero;
    let o10 = e14[t10];
    for (let n11 = t10 + 1; n11 <= r10; n11++) o10 = o10.add(e14[n11]);
    return o10;
  }
  static parse(e14 = "") {
    const t10 = M$(e14);
    return new L$(t10.value, t10.units);
  }
  static parseSafe(e14) {
    return this.parse(e14 || L$.zero);
  }
  static isValidString(e14, t10 = false) {
    if (!e14) return false;
    if (!t10 && "-" === e14[0]) return false;
    const n10 = x$.exec(e14);
    return Boolean(n10);
  }
  static get zero() {
    return I$;
  }
  static isZero(e14) {
    const t10 = M$(e14);
    return L$.zero.equal(t10);
  }
  static isZeroLike(e14) {
    return !e14 || L$.isZero(e14);
  }
}
const H$ = L$.parse("0in");
let I$ = H$;
const _$ = (e14) => {
  switch (e14) {
    case "cm":
    case "in":
      I$ = L$.parse(`0${e14}`);
      break;
    default:
      I$ = H$;
  }
};
const V$ = (e14, t10) => e14.units === t10 ? e14.value : L$.fromTwips(e14.toPreciseTwips, t10).value;
const R$ = $A((e14) => e14, (e14) => e14.semanticModel);
const A$ = () => LA(R$);
const O$ = _V("@rdlx/report/semantic/addDataSourceAndDataSets", (e14) => e14);
const B$ = _V("@rdlx/report/semantic/removeDataSet", (e14) => e14);
const z$ = _V("@rdlx/report/semantic/rebalanceDataSetEntity", (e14) => e14);
O$.type, B$.type, z$.type;
const $$ = ["barcode", "bullet", "checkbox", "formattedtext", "image", "inputfield", "line", "richtext", "shape", "textbox", "sparkline", "bandedlist", "dvchart", "list", "rectangle", "subreport", "table", "tablix", "tableofcontents", "partitem", "contentplaceholder", "fixedpagebandedlist", "fixedpagedvchart", "fixedpagelist", "fixedpagerectangle", "fixedpagesubreport", "fixedpagetable", "fixedpagetablix", "fixedpagetableofcontents", "overflowplaceholder", "fixedpagepartitem"];
const W$ = ["section", "pagesection"];
const j$ = [...[...W$, "bandedlistheader", "bandedlistfooter", "bandedlistdetails"], ...$$];
const Z$ = ["fixedpagesubreport", "overflowplaceholder"];
const G$ = [...Z$, "fixedpagetableofcontents"];
const U$ = [...G$, "fixedpagebandedlist", "fixedpagelist", "fixedpagetable", "fixedpagetablix"];
const q$ = ["bandedlist", "fixedpagebandedlist", "dvchart", "fixedpagedvchart", "list", "fixedpagelist", "table", "fixedpagetable", "tablix", "fixedpagetablix", "sparkline"];
function Y$(e14) {
  return U$.includes(e14.Type);
}
function K$(e14) {
  return Z$.includes(e14.Type);
}
function X$(e14) {
  return G$.includes(e14.Type);
}
function J$(e14) {
  return W$.includes(e14.Type);
}
function Q$(e14) {
  return j$.includes(e14.Type);
}
function eW(e14) {
  return "dynamictablixmember" === e14.Type;
}
function tW(e14) {
  return "statictablixmember" === e14.Type;
}
function nW(e14) {
  return e14.hasOwnProperty("Name");
}
const rW = { rectangle: "rectangle", fplRectangle: "fixedpagerectangle", list: "list", fplList: "fixedpagelist", tablix: "tablix", fplTablix: "fixedpagetablix", table: "table", fplTable: "fixedpagetable", dvchart: "dvchart", fplDvchart: "fixedpagedvchart", tableOfContents: "tableofcontents", fplTableOfContents: "fixedpagetableofcontents", textbox: "textbox", checkbox: "checkbox", line: "line", shape: "shape", image: "image", bullet: "bullet", barcode: "barcode", formattedText: "formattedtext", sparkline: "sparkline", subreport: "subreport", fplSubReport: "fixedpagesubreport", overflowPlaceHolder: "overflowplaceholder", bandedList: "bandedlist", fplBandedList: "fixedpagebandedlist", inputField: "inputfield", richtext: "richtext", dvchartFooter: "dvchartfooter", dvchartHeader: "dvchartheader", dvchartGlobalLegend: "dvchartgloballegend", dvchartLegend: "dvchartlegend", dvchartPlot: "dvchartplot", dvchartPlotArea: "dvchartplotarea", dvchartAxis: "dvchartaxis", dvchartValueAggregateEncoding: "dvchartvalueaggregateencoding", dvchartAggregateEncoding: "dvchartaggregateencoding", dvchartDetailsEncoding: "dvchartdetailsencoding", dvchartCategoryEncoding: "dvchartcategoryencoding", dvchartEncodingFieldValue: "dvchartencodingfieldvalue", tableRow: "tablerow", tableColumn: "tablecolumn", tableHeader: "tableheader", tableFooter: "tablefooter", tableDetails: "tabledetails", tableGroup: "tablegroup", bandedListHeader: "bandedlistheader", bandedListFooter: "bandedlistfooter", bandedListDetails: "bandedlistdetails", bandedListGroup: "bandedlistgroup", staticTablixMember: "statictablixmember", dynamicTablixMember: "dynamictablixmember", tablixRow: "tablixrow", tablixColumn: "tablixcolumn", gridRow: "gridrow", gridColumn: "gridcolumn", tableOfContentsLevel: "tableofcontentslevel", fplReport: "fixedpagereport", mslReport: "multisectionreport", dashboard: "dashboard", section: "section", pagesection: "pagesection", fplSection: "fixedpagesection", mslCplSection: "Continuous", mslFplSection: "FixedPage", dashboardSection: "dashboardsection", legacyChart: "legacy_chart", legacyMatrix: "legacy_matrix", calendar: "calendar", map: "map", parameter: "parameter", reportParameter: "reportparameter", defaultReportItem: "defaultreportitem", layer: "layer", filter: "filter" };
const oW = $$;
const aW = ["fixedpagereport", "multisectionreport", "dashboard"];
const iW = ["section", "pagesection", "fixedpagesection", "Continuous", "FixedPage", "dashboardsection"];
const sW = [...aW, ...iW];
const lW = ["rectangle", "fixedpagerectangle"];
const cW = ["list", "fixedpagelist"];
const uW = ["contentplaceholder"];
const dW = ["tablix", "fixedpagetablix"];
const pW = ["table", "fixedpagetable"];
const mW = ["bandedlist", "fixedpagebandedlist"];
const hW = ["bandedlistheader", "bandedlistfooter", "bandedlistdetails"];
const fW = ["dvchart", "fixedpagedvchart"];
const gW = [rW.tableOfContents, rW.fplTableOfContents];
const yW = [rW.subreport, rW.fplSubReport];
const vW = [rW.fplReport, rW.sparkline, rW.dynamicTablixMember, rW.tableDetails, rW.tableGroup, rW.bandedListGroup, ...cW];
const bW = [rW.staticTablixMember, rW.dynamicTablixMember, rW.tableDetails, rW.tableGroup, rW.tableRow, rW.tableColumn, rW.bandedListGroup, ...oW, ...hW, "fixedpagesection", "Continuous", "FixedPage", "dashboardsection"];
const SW = ["textbox"];
const CW = oW;
const xW = [rW.dvchart, rW.dvchartPlotArea, rW.dvchartLegend, rW.dvchartGlobalLegend, rW.dvchartFooter, rW.dvchartHeader, rW.dvchartPlot, rW.dvchartAxis, rW.tableOfContentsLevel, ...iW, ...oW];
const wW = ["fixedpagereport", "sparkline", ...cW, ...dW, ...pW, ...fW, ...mW];
const TW = ["tablixrow", "tablixcolumn"];
const EW = ["tablerow", "tablecolumn"];
const FW = [rW.gridRow, rW.gridColumn];
const MW = [rW.staticTablixMember, rW.dynamicTablixMember];
const kW = [rW.fplBandedList, rW.fplList, rW.fplSubReport, rW.fplTable, rW.fplTableOfContents, rW.fplTablix, rW.overflowPlaceHolder];
const PW = [...iW, ...lW, hW[1]];
rW.bullet, rW.checkbox, rW.formattedText, rW.richtext, rW.inputField, rW.shape, rW.sparkline, rW.textbox;
const NW = [...dW, ...pW];
const DW = [...lW, ...iW, ...cW, ...hW, ...uW];
const LW = [...NW, ...DW];
const HW = (e14, t10) => e14.includes(t10);
const IW = (e14) => HW(NW, e14);
const _W = (e14) => HW(DW, e14);
const VW = (e14) => HW(LW, e14);
const RW = (e14) => HW(aW, e14);
const AW = (e14) => HW(sW, e14);
const OW = (e14) => HW(lW, e14);
const BW = (e14) => HW(cW, e14);
const zW = (e14) => HW(dW, e14);
const $W = (e14) => HW(pW, e14);
const WW = (e14) => HW(gW, e14);
const jW = (e14) => HW(yW, e14);
const ZW = (e14) => HW(fW, e14);
const GW = (e14) => HW(oW, e14);
const UW = (e14) => HW(wW, e14);
const qW = (e14) => HW(vW, e14);
const YW = (e14) => HW(bW, e14);
const KW = (e14) => HW(CW, e14);
const XW = (e14) => HW(xW, e14);
const JW = (e14) => HW(MW, e14);
const QW = (e14) => HW(TW, e14) || HW(EW, e14) || HW(FW, e14);
const ej = (e14) => HW(kW, e14);
const tj = (e14) => HW(mW, e14);
const nj = (e14) => HW(hW, e14);
function rj(e14) {
  return "leaf" === (e14 == null ? void 0 : e14.$selected);
}
function oj(e14) {
  return "partial" === (e14 == null ? void 0 : e14.$selected);
}
function aj(e14) {
  return !!(e14 == null ? void 0 : e14.$selected);
}
function ij(e14) {
  return !(!(e14 == null ? void 0 : e14.$selected) || !(e14 == null ? void 0 : e14.$primary));
}
function sj(e14) {
  return !!e14 && !!e14.$primary && "leaf" === e14.$selected;
}
function lj(e14) {
  return Array.isArray(e14) ? function(e15) {
    const t10 = [];
    let n10 = false;
    for (const r10 of e15) {
      const e16 = lj(r10);
      t10.push(e16), e16 !== r10 && (n10 = true);
    }
    return n10 ? t10 : e15;
  }(e14) : function(e15) {
    if ("object" != typeof e15 || null === e15) return e15;
    const t10 = {};
    let n10 = false;
    for (const [r10, o10] of Object.entries(e15)) {
      if ("$primary" === r10 || "$selected" === r10) {
        n10 = true;
        continue;
      }
      const e16 = lj(o10);
      t10[r10] = e16, e16 !== o10 && (n10 = true);
    }
    return n10 ? t10 : e15;
  }(e14);
}
const cj = "leaf";
const uj = "partial";
function dj(e14, t10, n10) {
  if (!e14 || !zV.isObject(e14)) throw new Error("Cannot set selection attributes in non object");
  return AV(e14, { $selected: { $set: t10 ? cj : uj }, $primary: { $set: !!n10 } });
}
function pj(e14) {
  if (!e14 || !zV.isObject(e14)) throw new Error("Cannot set leaf selection tag");
  return AV(e14, { $selected: { $set: cj } });
}
function mj(e14) {
  if (!e14 || !zV.isObject(e14)) throw new Error("Cannot set leaf partial tag");
  return AV(e14, { $selected: { $set: uj } });
}
function hj(e14, t10) {
  return AV(e14, { $selected: { $set: t10.$selected }, $primary: { $set: t10.$primary } });
}
function fj(e14, t10) {
  let n10 = e14;
  if (aj(n10) || zV.isArray(n10)) {
    const e15 = t10(n10);
    if (e15 && (n10 = AV(n10, e15)), rj(n10)) return n10;
    for (const e16 in n10) {
      if (!n10.hasOwnProperty(e16)) continue;
      const r10 = n10[e16];
      if (aj(r10) || zV.isArray(r10)) {
        const o10 = fj(r10, t10);
        if (o10 !== r10) {
          const t11 = {};
          t11[e16] = { $set: o10 }, n10 = AV(n10, t11);
        }
      }
    }
  }
  return n10;
}
function gj(e14, t10) {
  if (aj(e14) || zV.isArray(e14)) {
    if (t10(e14)) return e14;
    for (const n10 in e14) {
      if (!e14.hasOwnProperty(n10)) continue;
      const r10 = gj(e14[n10], t10);
      if (r10) return r10;
    }
  }
  return null;
}
function yj(e14) {
  const t10 = [];
  return fj(e14, (e15) => {
    rj(e15) && t10.push(e15);
  }), t10;
}
function vj(e14) {
  if (rj(e14)) return [{ item: e14, path: "" }];
  const t10 = [];
  return Sj(e14, (e15, n10) => {
    rj(e15) && t10.push({ item: e15, path: n10 });
  }), t10;
}
function bj(e14) {
  if (sj(e14)) return e14;
  if (!ij(e14) && !zV.isArray(e14)) return null;
  const t10 = Object.getOwnPropertyNames(e14 || {}).map((t11) => e14[t11]).map((e15) => bj(e15)).filter((e15) => null !== e15);
  if (1 === t10.length) return t10[0];
  if (0 === t10.length) return null;
  throw new Error("Invalid selection structure.");
}
function Sj(e14, t10, n10 = "") {
  if (aj(e14) || zV.isArray(e14)) for (const r10 in e14) {
    if (!e14.hasOwnProperty(r10)) continue;
    const o10 = e14[r10];
    if (aj(o10) || zV.isArray(o10)) {
      const e15 = `${n10}${n10 ? "." : ""}${r10}`;
      t10(Sj(o10, t10, e15), e15);
    }
  }
  return e14;
}
function Cj(e14) {
  return function(e15, t10) {
    return fj(e15, (e16) => t10(e16) ? { $selected: { $set: null }, $primary: { $set: false } } : null);
  }(e14, (e15) => aj(e15) && !ij(e15));
}
var xj = [{ id: "e514f774-56d3-42c7-8854-c35e41eacd11", name: "Default", content: { BackgroundColor: "Transparent", Border: { Color: "Black", Width: "1pt", Style: "None" } } }, { id: "cbde8d83-9b56-4395-be78-d34e684e4663", name: "Accent 1", content: { BackgroundColor: "=Theme.Colors!Accent1", Border: { Color: "=Theme.Colors(4,4)", Width: "1pt", Style: "Solid" } } }, { id: "29004d00-265a-46cc-ac98-c80e13adbae7", name: "Accent 2", content: { BackgroundColor: "=Theme.Colors!Accent2", Border: { Color: "=Theme.Colors(4,5)", Width: "1pt", Style: "Solid" } } }, { id: "e2e73e25-593c-4ca4-b170-ec07e1acc51c", name: "Accent 3", content: { BackgroundColor: "=Theme.Colors!Accent3", Border: { Color: "=Theme.Colors(4,6)", Width: "1pt", Style: "Solid" } } }, { id: "27e526f1-8bf4-461a-9105-216c892ab43e", name: "Accent 4", content: { BackgroundColor: "=Theme.Colors!Accent4", Border: { Color: "=Theme.Colors(4,7)", Width: "1pt", Style: "Solid" } } }, { id: "785018a7-9042-42cc-9320-e85ec7d2fdb5", name: "Accent 5", content: { BackgroundColor: "=Theme.Colors!Accent5", Border: { Color: "=Theme.Colors(4,8)", Width: "1pt", Style: "Solid" } } }, { id: "a2e1a465-b08c-4b4c-b478-eae9e5b1a512", name: "Accent 6", content: { BackgroundColor: "=Theme.Colors!Accent6", Border: { Color: "=Theme.Colors(4,9)", Width: "1pt", Style: "Solid" } } }, { id: "cf50cd91-7778-4c90-bcbf-ca028f2b9104", name: "Light 1", content: { BackgroundColor: "=Theme.Colors!Light1", Border: { Color: "Black", Width: "1pt", Style: "None" } } }, { id: "efc0bf09-920f-4976-b4d3-8152eb5dbe14", name: "Light 1 Dark 1", content: { BackgroundColor: "=Theme.Colors!Light1", Border: { Color: "=Theme.Colors!Dark1", Width: "1pt", Style: "Solid" } } }, { id: "d82500d3-ac2a-4eab-8679-193c98283de1", name: "Light 2", content: { BackgroundColor: "=Theme.Colors!Light2", Border: { Color: "Black", Width: "1pt", Style: "None" } } }, { id: "60a1f834-4fd2-4939-9b8a-db9be4a8e71d", name: "Light 2 Dark 2", content: { BackgroundColor: "=Theme.Colors!Light2", Border: { Color: "=Theme.Colors!Dark2", Width: "1pt", Style: "Solid" } } }];
const wj = { Bullet: "Bullet", CheckBox: "CheckBox", FormattedText: "FormattedText", InputField: "InputField", List: "List", Container: "Container", Rectangle: "Container", RichText: "RichText", Shape: "Shape", Sparkline: "Sparkline", Table: "Table", TableOfContents: "TableOfContents", Tablix: "Tablix", TextBox: "TextBox", ChartPalette: "ChartPalette" };
const Tj = { Bullet: [{ id: "0b65e860-6c8c-4d79-9c06-69f939517ae5", name: "Dark 1 Accent 1", content: { ValueColor: "=Theme.Colors!Accent1", TargetLineColor: "=Theme.Colors(5,4)", LabelFontColor: "=Theme.Colors!Dark1", LabelFontFamily: "=Theme.Fonts!MinorFont.Family", LabelFontSize: "=Theme.Fonts!MinorFont.Size", LabelFontStyle: "=Theme.Fonts!MinorFont.Style", TicksLineColor: "=Theme.Colors(1,0)" } }, { id: "a2e6395b-4951-4c09-a99e-cd798d79691e", name: "Dark 1 Accent 2", content: { ValueColor: "=Theme.Colors!Accent2", TargetLineColor: "=Theme.Colors(5,5)", LabelFontColor: "=Theme.Colors!Dark1", LabelFontFamily: "=Theme.Fonts!MinorFont.Family", LabelFontSize: "=Theme.Fonts!MinorFont.Size", LabelFontStyle: "=Theme.Fonts!MinorFont.Style", TicksLineColor: "=Theme.Colors(1,0)" } }, { id: "585e5f24-a6e1-4990-9b91-2c23a4d611b3", name: "Dark 1 Accent 3", content: { ValueColor: "=Theme.Colors!Accent3", TargetLineColor: "=Theme.Colors(5,6)", LabelFontColor: "=Theme.Colors!Dark1", LabelFontFamily: "=Theme.Fonts!MinorFont.Family", LabelFontSize: "=Theme.Fonts!MinorFont.Size", LabelFontStyle: "=Theme.Fonts!MinorFont.Style", TicksLineColor: "=Theme.Colors(1,0)" } }, { id: "aef4a90f-7180-4024-84be-aa3a71ba4716", name: "Dark 1 Accent 4", content: { ValueColor: "=Theme.Colors!Accent4", TargetLineColor: "=Theme.Colors(5,7)", LabelFontColor: "=Theme.Colors!Dark1", LabelFontFamily: "=Theme.Fonts!MinorFont.Family", LabelFontSize: "=Theme.Fonts!MinorFont.Size", LabelFontStyle: "=Theme.Fonts!MinorFont.Style", TicksLineColor: "=Theme.Colors(1,0)" } }, { id: "deb76e0c-7794-4f5e-b56b-fa61d5b0285c", name: "Dark 1 Accent 5", content: { ValueColor: "=Theme.Colors!Accent5", TargetLineColor: "=Theme.Colors(5,8)", LabelFontColor: "=Theme.Colors!Dark1", LabelFontFamily: "=Theme.Fonts!MinorFont.Family", LabelFontSize: "=Theme.Fonts!MinorFont.Size", LabelFontStyle: "=Theme.Fonts!MinorFont.Style", TicksLineColor: "=Theme.Colors(1,0)" } }, { id: "fac9f5d1-65a1-4cd2-bbb2-934b3b173cd2", name: "Dark 1 Accent 6", content: { ValueColor: "=Theme.Colors!Accent6", TargetLineColor: "=Theme.Colors(5,9)", LabelFontColor: "=Theme.Colors!Dark1", LabelFontFamily: "=Theme.Fonts!MinorFont.Family", LabelFontSize: "=Theme.Fonts!MinorFont.Size", LabelFontStyle: "=Theme.Fonts!MinorFont.Style", TicksLineColor: "=Theme.Colors(1,0)" } }, { id: "ed6d70d2-fde9-4d61-a8b5-a91431825836", name: "Dark 2 Accent 1", content: { ValueColor: "=Theme.Colors!Accent1", TargetLineColor: "=Theme.Colors(5,4)", LabelFontColor: "=Theme.Colors!Dark2", LabelFontFamily: "=Theme.Fonts!MinorFont.Family", LabelFontSize: "=Theme.Fonts!MinorFont.Size", LabelFontStyle: "=Theme.Fonts!MinorFont.Style", TicksLineColor: "=Theme.Colors(1,2)" } }, { id: "e8179ad3-a9a0-440d-8750-1d058024e739", name: "Dark 2 Accent 2", content: { ValueColor: "=Theme.Colors!Accent2", TargetLineColor: "=Theme.Colors(5,5)", LabelFontColor: "=Theme.Colors!Dark2", LabelFontFamily: "=Theme.Fonts!MinorFont.Family", LabelFontSize: "=Theme.Fonts!MinorFont.Size", LabelFontStyle: "=Theme.Fonts!MinorFont.Style", TicksLineColor: "=Theme.Colors(1,2)" } }, { id: "847dc417-262b-4211-8d4b-5897584d4d84", name: "Dark 2 Accent 3", content: { ValueColor: "=Theme.Colors!Accent3", TargetLineColor: "=Theme.Colors(5,6)", LabelFontColor: "=Theme.Colors!Dark2", LabelFontFamily: "=Theme.Fonts!MinorFont.Family", LabelFontSize: "=Theme.Fonts!MinorFont.Size", LabelFontStyle: "=Theme.Fonts!MinorFont.Style", TicksLineColor: "=Theme.Colors(1,2)" } }, { id: "1b477fa5-ba60-4a3b-b878-c0d127a78d70", name: "Dark 2 Accent 4", content: { ValueColor: "=Theme.Colors!Accent4", TargetLineColor: "=Theme.Colors(5,7)", LabelFontColor: "=Theme.Colors!Dark2", LabelFontFamily: "=Theme.Fonts!MinorFont.Family", LabelFontSize: "=Theme.Fonts!MinorFont.Size", LabelFontStyle: "=Theme.Fonts!MinorFont.Style", TicksLineColor: "=Theme.Colors(1,2)" } }, { id: "f5e54e25-c0b0-46fa-88ee-79dc497be4d3", name: "Dark 2 Accent 5", content: { ValueColor: "=Theme.Colors!Accent5", TargetLineColor: "=Theme.Colors(5,8)", LabelFontColor: "=Theme.Colors!Dark2", LabelFontFamily: "=Theme.Fonts!MinorFont.Family", LabelFontSize: "=Theme.Fonts!MinorFont.Size", LabelFontStyle: "=Theme.Fonts!MinorFont.Style", TicksLineColor: "=Theme.Colors(1,2)" } }, { id: "5736df25-3a79-4a96-a6d1-db7fdc4e6776", name: "Dark 2 Accent 6", content: { ValueColor: "=Theme.Colors!Accent6", TargetLineColor: "=Theme.Colors(5,9)", LabelFontColor: "=Theme.Colors!Dark2", LabelFontFamily: "=Theme.Fonts!MinorFont.Family", LabelFontSize: "=Theme.Fonts!MinorFont.Size", LabelFontStyle: "=Theme.Fonts!MinorFont.Style", TicksLineColor: "=Theme.Colors(1,2)" } }], CheckBox: [{ id: "76d94bac-8df2-4ed2-93b9-28e3b2aebadc", name: "Dark 1 Major", content: { BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "cc5f5e08-c848-44e5-8712-c24aa6c11848", name: "Dark 1 Minor", content: { BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }, { id: "b075c22b-50bb-4843-875d-5e17acb45514", name: "Light 1 Accent 1 Major", content: { BackgroundColor: "=Theme.Colors!Accent1", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "5c6f965a-2829-45fe-a62d-921845be1a0d", name: "Light 1 Accent 1 Minor", content: { BackgroundColor: "=Theme.Colors!Accent1", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }, { id: "88911976-7dfb-44ab-9175-54d32a03b7c2", name: "Light 1 Accent 2 Major", content: { BackgroundColor: "=Theme.Colors!Accent2", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "c7b991b1-f7ee-49d3-a792-11a91b9d149e", name: "Light 1 Accent 2 Minor", content: { BackgroundColor: "=Theme.Colors!Accent2", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }, { id: "46e207d4-447e-4d12-bb4c-9cc96c99525b", name: "Light 1 Accent 3 Major", content: { BackgroundColor: "=Theme.Colors!Accent3", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "943f1068-9f41-4e1c-801c-cd6284ffdc74", name: "Light 1 Accent 3 Minor", content: { BackgroundColor: "=Theme.Colors!Accent3", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }, { id: "a7f000aa-ab6e-4c40-ac17-a4d376c66bd9", name: "Light 1 Accent 4 Major", content: { BackgroundColor: "=Theme.Colors!Accent4", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "886f19f4-a583-46b4-a78d-d8933400d2f6", name: "Light 1 Accent 4 Minor", content: { BackgroundColor: "=Theme.Colors!Accent4", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }, { id: "f996fdc4-e17f-4079-a269-df9ec56b4899", name: "Light 1 Accent 5 Major", content: { BackgroundColor: "=Theme.Colors!Accent5", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "f7d7f6b2-27b5-44d9-a2b0-067964af2bd6", name: "Light 1 Accent 5 Minor", content: { BackgroundColor: "=Theme.Colors!Accent5", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }, { id: "c551a6f6-449b-47b1-b6f3-30937a67395c", name: "Light 1 Accent 6 Major", content: { BackgroundColor: "=Theme.Colors!Accent6", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "0aa0e143-5e07-4c03-a476-c9ec1dd01fb3", name: "Light 1 Accent 6 Minor", content: { BackgroundColor: "=Theme.Colors!Accent6", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }], FormattedText: [{ id: "b3356016-1bdf-4ff7-a8f1-71b92fec107b", name: "Default", content: { BackgroundColor: "Transparent", Border: { Color: "Black", Width: "1pt", Style: "None" } } }, { id: "f5bf5fcd-3b28-494e-9660-84e4b125d23b", name: "Accent 1", content: { BackgroundColor: "=Theme.Colors!Accent1", Border: { Color: "=Theme.Colors(4,4)", Width: "1pt", Style: "Solid" } } }, { id: "7d35c10d-5fc1-4de5-a642-a9855d1ded9b", name: "Accent 2", content: { BackgroundColor: "=Theme.Colors!Accent2", Border: { Color: "=Theme.Colors(4,5)", Width: "1pt", Style: "Solid" } } }, { id: "a8641953-917f-4dcc-87ea-63cd0688c0a1", name: "Accent 3", content: { BackgroundColor: "=Theme.Colors!Accent3", Border: { Color: "=Theme.Colors(4,6)", Width: "1pt", Style: "Solid" } } }, { id: "9b3aa619-647f-4b92-8574-b3451e9e892d", name: "Accent 4", content: { BackgroundColor: "=Theme.Colors!Accent4", Border: { Color: "=Theme.Colors(4,7)", Width: "1pt", Style: "Solid" } } }, { id: "d22751d5-6ca5-4a60-94df-220413249ecd", name: "Accent 5", content: { BackgroundColor: "=Theme.Colors!Accent5", Border: { Color: "=Theme.Colors(4,8)", Width: "1pt", Style: "Solid" } } }, { id: "ab36b328-54c3-46e6-aa24-ffc558766b04", name: "Accent 6", content: { BackgroundColor: "=Theme.Colors!Accent6", Border: { Color: "=Theme.Colors(4,9)", Width: "1pt", Style: "Solid" } } }, { id: "90a0a4f5-66c3-4d7c-bafa-5f02d329ae89", name: "Light 1", content: { BackgroundColor: "=Theme.Colors!Light1", Border: { Color: "Black", Width: "1pt", Style: "None" } } }, { id: "e75b2618-e215-4e22-8c6c-7834ead38f45", name: "Light 1 Dark 1", content: { BackgroundColor: "=Theme.Colors!Light1", Border: { Color: "=Theme.Colors!Dark1", Width: "1pt", Style: "Solid" } } }, { id: "b4ff3a94-b6be-405a-afa6-1ec076ef2240", name: "Light 2", content: { BackgroundColor: "=Theme.Colors!Light2", Border: { Color: "Black", Width: "1pt", Style: "None" } } }, { id: "7517ddea-45f2-4dfa-9861-b829f18bdc55", name: "Light 2 Dark 2", content: { BackgroundColor: "=Theme.Colors!Light2", Border: { Color: "=Theme.Colors!Dark2", Width: "1pt", Style: "Solid" } } }], InputField: [{ id: "7713ace7-1c6b-4ec4-949d-db30361bd740", name: "Dark 1 Major", content: { BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "c39485ba-95ac-4de4-a313-eab418d255a0", name: "Dark 1 Minor", content: { BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }, { id: "e90a0b42-7b6b-4f4e-bdca-f191973b1f74", name: "Light 1 Accent 1 Major", content: { BackgroundColor: "=Theme.Colors!Accent1", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "389df4ec-93da-40bf-a475-0e52b74e7e54", name: "Light 1 Accent 1 Minor", content: { BackgroundColor: "=Theme.Colors!Accent1", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }, { id: "1b1591d8-fd0d-43fd-8f0a-b9b343e570d2", name: "Light 1 Accent 2 Major", content: { BackgroundColor: "=Theme.Colors!Accent2", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "746fba42-c352-46a2-a798-499f50ec2d50", name: "Light 1 Accent 2 Minor", content: { BackgroundColor: "=Theme.Colors!Accent2", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }, { id: "cf289f35-be44-4af3-83ae-5a4846ead33b", name: "Light 1 Accent 3 Major", content: { BackgroundColor: "=Theme.Colors!Accent3", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "e3b6edab-f857-46a3-ae7d-4ba23b54c753", name: "Light 1 Accent 3 Minor", content: { BackgroundColor: "=Theme.Colors!Accent3", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }, { id: "1d3c3753-6245-4124-938b-60d542fdf3a4", name: "Light 1 Accent 4 Major", content: { BackgroundColor: "=Theme.Colors!Accent4", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "0a5f1677-1f12-4425-bb0c-1c7b5082315f", name: "Light 1 Accent 4 Minor", content: { BackgroundColor: "=Theme.Colors!Accent4", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }, { id: "f813fc29-0864-4d8e-a273-7a8b7840fb91", name: "Light 1 Accent 5 Major", content: { BackgroundColor: "=Theme.Colors!Accent5", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "a063b40f-e6fc-4808-a4f8-8d3bad591e97", name: "Light 1 Accent 5 Minor", content: { BackgroundColor: "=Theme.Colors!Accent5", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }, { id: "27ab65e3-471c-42d2-8f75-ce8b6b21d242", name: "Light 1 Accent 6 Major", content: { BackgroundColor: "=Theme.Colors!Accent6", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "43442368-50d8-4df0-a78a-7c3d17e0a977", name: "Light 1 Accent 6 Minor", content: { BackgroundColor: "=Theme.Colors!Accent6", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }], List: [{ id: "2b3ab600-cc7f-4ffe-abcb-7adba37adff5", name: "Default List", content: { BackgroundColor: "Transparent", Border: { Color: "Black", Width: "1pt", Style: "None" }, Color: "Black", FontFamily: "Arial", FontSize: "10pt", FontStyle: "Normal", FontWeight: "Normal" } }, { id: "54d11a34-7c05-4bb6-a187-8feb56cfda20", name: "Accent 1 List", content: { BackgroundColor: "=Theme.Colors!Accent1", Border: { Color: "=Theme.Colors(4,4)", Width: "1pt", Style: "Solid" }, Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "ef393653-d647-41f3-b659-d9f32a26c21a", name: "Accent 2 List", content: { BackgroundColor: "=Theme.Colors!Accent2", Border: { Color: "=Theme.Colors(4,5)", Width: "1pt", Style: "Solid" }, Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "f576948e-863a-4f4e-9e9e-efc24c8930af", name: "Accent 3 List", content: { BackgroundColor: "=Theme.Colors!Accent3", Border: { Color: "=Theme.Colors(4,6)", Width: "1pt", Style: "Solid" }, Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "c01c6dd8-152e-4148-936b-4b948fbe5557", name: "Accent 4 List", content: { BackgroundColor: "=Theme.Colors!Accent4", Border: { Color: "=Theme.Colors(4,7)", Width: "1pt", Style: "Solid" }, Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "9556890b-07b9-412e-8ba2-b5b5a3d253aa", name: "Accent 5 List", content: { BackgroundColor: "=Theme.Colors!Accent5", Border: { Color: "=Theme.Colors(4,8)", Width: "1pt", Style: "Solid" }, Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "81c78100-f998-40e0-94fc-ab04852aa137", name: "Accent 6 List", content: { BackgroundColor: "=Theme.Colors!Accent6", Border: { Color: "=Theme.Colors(4,9)", Width: "1pt", Style: "Solid" }, Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "9d1662fc-8d39-4b3d-bf68-c0ea745ffa8e", name: "Light 1 List", content: { BackgroundColor: "=Theme.Colors!Light1", Border: { Color: "Black", Width: "1pt", Style: "None" }, Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "b9744ad7-9475-45d2-9f76-9f83b3bdf4db", name: "Light 1 Dark 1 List", content: { BackgroundColor: "=Theme.Colors!Light1", Border: { Color: "=Theme.Colors!Dark1", Width: "1pt", Style: "Solid" }, Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "69f250a1-af01-4ea8-8279-fefd6fe60917", name: "Light 2 List", content: { BackgroundColor: "=Theme.Colors!Light2", Border: { Color: "Black", Width: "1pt", Style: "None" }, Color: "=Theme.Colors!Dark2", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "2fccc554-d604-4b76-b936-65ba955e0b0e", name: "Light 2 Dark 2 List", content: { BackgroundColor: "=Theme.Colors!Light2", Border: { Color: "=Theme.Colors!Dark2", Width: "1pt", Style: "Solid" }, Color: "=Theme.Colors!Dark2", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }], Container: xj, Rectangle: xj, RichText: [{ id: "cb24c14e-22ea-43bb-a2af-6f405e2425ac", name: "Dark 1 Major", content: { BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "c6b79395-4a88-472d-934f-16e9b2f42462", name: "Dark 1 Minor", content: { BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }, { id: "46feeefd-33b7-4497-a043-9b625f757d56", name: "Light 1 Accent 1 Major", content: { BackgroundColor: "=Theme.Colors!Accent1", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "96202b0c-ca52-429d-9a6f-17349c15ee2c", name: "Light 1 Accent 1 Minor", content: { BackgroundColor: "=Theme.Colors!Accent1", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }, { id: "e8a8ab8b-3620-487c-b132-2b74a19004a1", name: "Light 1 Accent 2 Major", content: { BackgroundColor: "=Theme.Colors!Accent2", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "73e341c4-05ae-4c43-81e8-63d182cc1955", name: "Light 1 Accent 2 Minor", content: { BackgroundColor: "=Theme.Colors!Accent2", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }, { id: "e11becac-5cf9-49b9-aa07-19c11d0b4ad1", name: "Light 1 Accent 3 Major", content: { BackgroundColor: "=Theme.Colors!Accent3", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "41d60125-893e-4328-a793-f3525f7965b1", name: "Light 1 Accent 3 Minor", content: { BackgroundColor: "=Theme.Colors!Accent3", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }, { id: "a47bff74-43c6-4195-8aea-91782f837816", name: "Light 1 Accent 4 Major", content: { BackgroundColor: "=Theme.Colors!Accent4", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "90da9c5f-aca2-4f4f-9ade-dc9fcdd3acbb", name: "Light 1 Accent 4 Minor", content: { BackgroundColor: "=Theme.Colors!Accent4", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }, { id: "71b84ba6-f42f-4f31-ac97-8c746a3e8e0f", name: "Light 1 Accent 5 Major", content: { BackgroundColor: "=Theme.Colors!Accent5", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "350b5d22-9fd9-4a4a-87be-138e5acd1ddc", name: "Light 1 Accent 5 Minor", content: { BackgroundColor: "=Theme.Colors!Accent5", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }, { id: "45229a7e-e9bb-4b58-b90f-be37482e8389", name: "Light 1 Accent 6 Major", content: { BackgroundColor: "=Theme.Colors!Accent6", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "125e6b6f-f6d1-4772-9a32-7cbc5a5fa252", name: "Light 1 Accent 6 Minor", content: { BackgroundColor: "=Theme.Colors!Accent6", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }], Shape: [{ id: "616876e7-1a2c-4ec7-81df-c3ac878750b6", name: "Default", content: { BackgroundColor: "Transparent", Border: { Color: "Black", Width: "1pt", Style: "None" } } }, { id: "96c47ae0-3677-4968-83f0-0335dd778108", name: "Accent 1", content: { BackgroundColor: "=Theme.Colors!Accent1", Border: { Color: "=Theme.Colors(4,4)", Width: "1pt", Style: "Solid" } } }, { id: "9fbeb36f-b8c1-4d89-9dee-2246ed1722b7", name: "Accent 2", content: { BackgroundColor: "=Theme.Colors!Accent2", Border: { Color: "=Theme.Colors(4,5)", Width: "1pt", Style: "Solid" } } }, { id: "529752da-e9d5-491f-bda4-a403b49ff6eb", name: "Accent 3", content: { BackgroundColor: "=Theme.Colors!Accent3", Border: { Color: "=Theme.Colors(4,6)", Width: "1pt", Style: "Solid" } } }, { id: "45343e7b-ef05-4ed4-b4f8-1727a7b88716", name: "Accent 4", content: { BackgroundColor: "=Theme.Colors!Accent4", Border: { Color: "=Theme.Colors(4,7)", Width: "1pt", Style: "Solid" } } }, { id: "85d60738-825b-4f8f-a532-25f9cc6912c4", name: "Accent 5", content: { BackgroundColor: "=Theme.Colors!Accent5", Border: { Color: "=Theme.Colors(4,8)", Width: "1pt", Style: "Solid" } } }, { id: "308e8355-a83e-46f7-8c3e-1d459fcc9b3d", name: "Accent 6", content: { BackgroundColor: "=Theme.Colors!Accent6", Border: { Color: "=Theme.Colors(4,9)", Width: "1pt", Style: "Solid" } } }, { id: "ff8951ee-0351-487c-baff-3607d2e64189", name: "Light 1", content: { BackgroundColor: "=Theme.Colors!Light1", Border: { Color: "Black", Width: "1pt", Style: "None" } } }, { id: "c8537e73-0d9a-4a3c-b445-f14cf2bc92df", name: "Light 1 Dark 1", content: { BackgroundColor: "=Theme.Colors!Light1", Border: { Color: "=Theme.Colors!Dark1", Width: "1pt", Style: "Solid" } } }, { id: "941b6430-92b6-47f0-b9ab-1918d2aa4757", name: "Light 2", content: { BackgroundColor: "=Theme.Colors!Light2", Border: { Color: "Black", Width: "1pt", Style: "None" } } }, { id: "a05e713d-0aae-4e6b-9c4c-9c6518ba8c8a", name: "Light 2 Dark 2", content: { BackgroundColor: "=Theme.Colors!Light2", Border: { Color: "=Theme.Colors!Dark2", Width: "1pt", Style: "Solid" } } }], Sparkline: [{ id: "85e9e364-0655-475d-9c98-cd69c452b711", name: "Light 1 Accent 1", content: { LineColor: "=Theme.Colors!Accent1", MarkerColor: "=Theme.Colors(5,4)", FillColor: "=Theme.Colors!Accent1", GradientEndColor: "=Theme.Colors(5,4)", RangeFillColor: "=Theme.Colors!Light1", RangeGradientEndColor: "=Theme.Colors(4,1)" } }, { id: "962ae41c-ec9b-4c5a-86e5-f2cfede41c14", name: "Light 1 Accent 2", content: { LineColor: "=Theme.Colors!Accent2", MarkerColor: "=Theme.Colors(5,5)", FillColor: "=Theme.Colors!Accent2", GradientEndColor: "=Theme.Colors(5,5)", RangeFillColor: "=Theme.Colors!Light1", RangeGradientEndColor: "=Theme.Colors(4,1)" } }, { id: "198a0c17-a799-4be9-b50a-5d0044623560", name: "Light 1 Accent 3", content: { LineColor: "=Theme.Colors!Accent3", MarkerColor: "=Theme.Colors(5,6)", FillColor: "=Theme.Colors!Accent3", GradientEndColor: "=Theme.Colors(5,6)", RangeFillColor: "=Theme.Colors!Light1", RangeGradientEndColor: "=Theme.Colors(4,1)" } }, { id: "445e431e-ed90-4ac1-8e25-fb1593b623fb", name: "Light 1 Accent 4", content: { LineColor: "=Theme.Colors!Accent4", MarkerColor: "=Theme.Colors(5,7)", FillColor: "=Theme.Colors!Accent4", GradientEndColor: "=Theme.Colors(5,7)", RangeFillColor: "=Theme.Colors!Light1", RangeGradientEndColor: "=Theme.Colors(4,1)" } }, { id: "10518e5d-0bd0-459f-995d-1d648f543a2e", name: "Light 1 Accent 5", content: { LineColor: "=Theme.Colors!Accent5", MarkerColor: "=Theme.Colors(5,8)", FillColor: "=Theme.Colors!Accent5", GradientEndColor: "=Theme.Colors(5,8)", RangeFillColor: "=Theme.Colors!Light1", RangeGradientEndColor: "=Theme.Colors(4,1)" } }, { id: "3719a51c-95c7-4629-9af9-a7a6329c8dc9", name: "Light 1 Accent 6", content: { LineColor: "=Theme.Colors!Accent6", MarkerColor: "=Theme.Colors(5,9)", FillColor: "=Theme.Colors!Accent6", GradientEndColor: "=Theme.Colors(5,9)", RangeFillColor: "=Theme.Colors!Light1", RangeGradientEndColor: "=Theme.Colors(4,1)" } }, { id: "5221f8c8-f992-4c3f-92d8-58b200cbd498", name: "Light 2 Accent 1", content: { LineColor: "=Theme.Colors!Accent1", MarkerColor: "=Theme.Colors(5,4)", FillColor: "=Theme.Colors!Accent1", GradientEndColor: "=Theme.Colors(5,4)", RangeFillColor: "=Theme.Colors!Light2", RangeGradientEndColor: "=Theme.Colors(4,3)" } }, { id: "04a17568-8f1b-4bc7-9b21-123861406f0d", name: "Light 2 Accent 2", content: { LineColor: "=Theme.Colors!Accent2", MarkerColor: "=Theme.Colors(5,5)", FillColor: "=Theme.Colors!Accent2", GradientEndColor: "=Theme.Colors(5,5)", RangeFillColor: "=Theme.Colors!Light2", RangeGradientEndColor: "=Theme.Colors(4,3)" } }, { id: "8a811a9c-b1ab-4e2d-9d7f-9161d104af86", name: "Light 2 Accent 3", content: { LineColor: "=Theme.Colors!Accent3", MarkerColor: "=Theme.Colors(5,6)", FillColor: "=Theme.Colors!Accent3", GradientEndColor: "=Theme.Colors(5,6)", RangeFillColor: "=Theme.Colors!Light2", RangeGradientEndColor: "=Theme.Colors(4,3)" } }, { id: "74a90ebb-5ff8-4802-bbec-750c6895fe89", name: "Light 2 Accent 4", content: { LineColor: "=Theme.Colors!Accent4", MarkerColor: "=Theme.Colors(5,7)", FillColor: "=Theme.Colors!Accent4", GradientEndColor: "=Theme.Colors(5,7)", RangeFillColor: "=Theme.Colors!Light2", RangeGradientEndColor: "=Theme.Colors(4,3)" } }, { id: "56e3d1d0-2a38-4f42-8643-82e4f9bfb20e", name: "Light 2 Accent 5", content: { LineColor: "=Theme.Colors!Accent5", MarkerColor: "=Theme.Colors(5,8)", FillColor: "=Theme.Colors!Accent5", GradientEndColor: "=Theme.Colors(5,8)", RangeFillColor: "=Theme.Colors!Light2", RangeGradientEndColor: "=Theme.Colors(4,3)" } }, { id: "beee708f-ba7e-48e0-b0e9-46dde1f71cee", name: "Light 2 Accent 6", content: { LineColor: "=Theme.Colors!Accent6", MarkerColor: "=Theme.Colors(5,9)", FillColor: "=Theme.Colors!Accent6", GradientEndColor: "=Theme.Colors(5,9)", RangeFillColor: "=Theme.Colors!Light2", RangeGradientEndColor: "=Theme.Colors(4,3)" } }], Table: [{ id: "c728fbbc-6ae5-47bd-8e20-d710772a5858", name: "Light Style 1 Accent 1", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", TopBorder: { Color: "=Theme.Colors!Accent1", Width: "2pt", Style: "Solid" }, BottomBorder: { Color: "=Theme.Colors!Accent1", Width: "2pt", Style: "Solid" } }] }, Details: { AlternatingExpression: "=IIF(RowNumber(Nothing) Mod 2, {0}, {1})", Rows: [{ BackgroundColor: "=Theme.Colors(1,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }, { BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,4)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,4)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Style: "None" } } }, { id: "bac1137f-9811-45da-bc69-0f581b240356", name: "Light Style 1 Accent 2", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", TopBorder: { Color: "=Theme.Colors!Accent2", Width: "2pt", Style: "Solid" }, BottomBorder: { Color: "=Theme.Colors!Accent2", Width: "2pt", Style: "Solid" } }] }, Details: { AlternatingExpression: "=IIF(RowNumber(Nothing) Mod 2, {0}, {1})", Rows: [{ BackgroundColor: "=Theme.Colors(1,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }, { BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,5)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,5)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Style: "None" } } }, { id: "da7443b8-9a7c-43eb-9eef-6bd8a8b436d3", name: "Light Style 1 Accent 3", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", TopBorder: { Color: "=Theme.Colors!Accent3", Width: "2pt", Style: "Solid" }, BottomBorder: { Color: "=Theme.Colors!Accent3", Width: "2pt", Style: "Solid" } }] }, Details: { AlternatingExpression: "=IIF(RowNumber(Nothing) Mod 2, {0}, {1})", Rows: [{ BackgroundColor: "=Theme.Colors(1,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }, { BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,6)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,6)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Style: "None" } } }, { id: "901e7da0-b9fb-4d81-925f-54df0ebb0fe7", name: "Light Style 1 Accent 4", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", TopBorder: { Color: "=Theme.Colors!Accent4", Width: "2pt", Style: "Solid" }, BottomBorder: { Color: "=Theme.Colors!Accent4", Width: "2pt", Style: "Solid" } }] }, Details: { AlternatingExpression: "=IIF(RowNumber(Nothing) Mod 2, {0}, {1})", Rows: [{ BackgroundColor: "=Theme.Colors(1,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }, { BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,7)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,7)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Style: "None" } } }, { id: "d3cbe7f4-f0f6-4720-9a94-a86a27b3ea2a", name: "Light Style 1 Accent 5", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", TopBorder: { Color: "=Theme.Colors!Accent5", Width: "2pt", Style: "Solid" }, BottomBorder: { Color: "=Theme.Colors!Accent5", Width: "2pt", Style: "Solid" } }] }, Details: { AlternatingExpression: "=IIF(RowNumber(Nothing) Mod 2, {0}, {1})", Rows: [{ BackgroundColor: "=Theme.Colors(1,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }, { BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,8)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,8)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Style: "None" } } }, { id: "27909225-1d23-430a-a7a9-ff8e7b91e8bc", name: "Light Style 1", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", TopBorder: { Color: "=Theme.Colors!Accent1", Width: "2pt", Style: "Solid" }, BottomBorder: { Color: "=Theme.Colors!Accent1", Width: "2pt", Style: "Solid" } }] }, Details: { AlternatingExpression: "=IIF(RowNumber(Nothing) Mod 2, {0}, {1})", Rows: [{ BackgroundColor: "=Theme.Colors!Light2", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }, { BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Dark1", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Dark1", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light2", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light2", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Style: "None" } } }, { id: "4a7d1b8b-411a-4407-8122-74b944a5f4f6", name: "Light Style 2 Accent 1", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,4)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", LeftBorder: { Color: "=Theme.Colors!Accent1", Width: "1pt", Style: "Solid" }, RightBorder: { Color: "=Theme.Colors!Accent1", Width: "1pt", Style: "Solid" }, TopBorder: { Color: "=Theme.Colors!Accent1", Width: "1pt", Style: "Solid" }, BottomBorder: { Color: "=Theme.Colors!Accent1", Width: "1pt", Style: "Solid" } }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,4)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,4)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,4)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "=Theme.Colors(0,4)", Width: "1pt", Style: "Solid" } } }, { id: "7d27222b-41b5-46b9-877d-3cbce0321665", name: "Light Style 2 Accent 2", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,5)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", LeftBorder: { Color: "=Theme.Colors!Accent2", Width: "1pt", Style: "Solid" }, RightBorder: { Color: "=Theme.Colors!Accent2", Width: "1pt", Style: "Solid" }, TopBorder: { Color: "=Theme.Colors!Accent2", Width: "1pt", Style: "Solid" }, BottomBorder: { Color: "=Theme.Colors!Accent2", Width: "1pt", Style: "Solid" } }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,5)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,5)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,5)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "=Theme.Colors(0,5)", Width: "1pt", Style: "Solid" } } }, { id: "54855836-1ba3-42c7-938c-d65e62e2d010", name: "Light Style 2 Accent 3", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,6)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", LeftBorder: { Color: "=Theme.Colors!Accent3", Width: "1pt", Style: "Solid" }, RightBorder: { Color: "=Theme.Colors!Accent3", Width: "1pt", Style: "Solid" }, TopBorder: { Color: "=Theme.Colors!Accent3", Width: "1pt", Style: "Solid" }, BottomBorder: { Color: "=Theme.Colors!Accent3", Width: "1pt", Style: "Solid" } }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,6)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,6)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,6)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "=Theme.Colors(0,6)", Width: "1pt", Style: "Solid" } } }, { id: "1940320c-6e14-4d3a-80d2-eaaa0a62276b", name: "Light Style 2 Accent 4", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,7)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", LeftBorder: { Color: "=Theme.Colors!Accent4", Width: "1pt", Style: "Solid" }, RightBorder: { Color: "=Theme.Colors!Accent4", Width: "1pt", Style: "Solid" }, TopBorder: { Color: "=Theme.Colors!Accent4", Width: "1pt", Style: "Solid" }, BottomBorder: { Color: "=Theme.Colors!Accent4", Width: "1pt", Style: "Solid" } }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,7)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,7)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,7)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "=Theme.Colors(0,7)", Width: "1pt", Style: "Solid" } } }, { id: "3d6612bb-f5fd-46f9-8309-fe4a36033bf0", name: "Light Style 2 Accent 5", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,8)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", LeftBorder: { Color: "=Theme.Colors!Accent5", Width: "1pt", Style: "Solid" }, RightBorder: { Color: "=Theme.Colors!Accent5", Width: "1pt", Style: "Solid" }, TopBorder: { Color: "=Theme.Colors!Accent5", Width: "1pt", Style: "Solid" }, BottomBorder: { Color: "=Theme.Colors!Accent5", Width: "1pt", Style: "Solid" } }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,8)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,8)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,8)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "=Theme.Colors(0,8)", Width: "1pt", Style: "Solid" } } }, { id: "4f09022b-a3f4-4c36-9463-026d6bf673dc", name: "Light Style 2", content: { Header: { Rows: [{ BackgroundColor: "Black", Color: "White", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Details: { Rows: [{ BackgroundColor: "White", Color: "Black", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "Black", Color: "White", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "#AEAEAE", Color: "Black", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "#AEAEAE", Color: "Black", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "#D2D2D2", Color: "Black", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "#D2D2D2", Color: "Black", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "White", Color: "Black", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "White", Color: "Black", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "#000000", Width: "1pt", Style: "Solid" } } }, { id: "1ec442ab-94d4-4d07-a7b9-c1d035851d5c", name: "Medium Style 1 Accent 1", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,4)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", BottomBorder: { Color: "#FFFFFF", Width: "2pt", Style: "Solid" } }] }, Details: { AlternatingExpression: "=IIF(RowNumber(Nothing) Mod 2, {0}, {1})", Rows: [{ BackgroundColor: "=Theme.Colors(1,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }, { BackgroundColor: "=Theme.Colors(2,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,4)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", TopBorder: { Color: "#FFFFFF", Width: "2pt", Style: "Solid" } }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,4)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,4)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "#FFFFFF", Width: "1pt", Style: "Solid" } } }, { id: "1e174c8b-20a4-47be-9731-215cbd059aac", name: "Medium Style 1 Accent 2", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,5)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", BottomBorder: { Color: "#FFFFFF", Width: "2pt", Style: "Solid" } }] }, Details: { AlternatingExpression: "=IIF(RowNumber(Nothing) Mod 2, {0}, {1})", Rows: [{ BackgroundColor: "=Theme.Colors(1,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }, { BackgroundColor: "=Theme.Colors(2,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,5)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", TopBorder: { Color: "#FFFFFF", Width: "2pt", Style: "Solid" } }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,5)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,5)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "#FFFFFF", Width: "1pt", Style: "Solid" } } }, { id: "98d8e68b-070b-4bef-b328-1a8e618107d8", name: "Medium Style 1 Accent 3", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,6)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", BottomBorder: { Color: "#FFFFFF", Width: "2pt", Style: "Solid" } }] }, Details: { AlternatingExpression: "=IIF(RowNumber(Nothing) Mod 2, {0}, {1})", Rows: [{ BackgroundColor: "=Theme.Colors(1,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }, { BackgroundColor: "=Theme.Colors(2,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,6)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", TopBorder: { Color: "#FFFFFF", Width: "2pt", Style: "Solid" } }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,6)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,6)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "#FFFFFF", Width: "1pt", Style: "Solid" } } }, { id: "95410631-1721-4045-b1e9-5382c890288c", name: "Medium Style 1 Accent 4", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,7)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", BottomBorder: { Color: "#FFFFFF", Width: "2pt", Style: "Solid" } }] }, Details: { AlternatingExpression: "=IIF(RowNumber(Nothing) Mod 2, {0}, {1})", Rows: [{ BackgroundColor: "=Theme.Colors(1,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }, { BackgroundColor: "=Theme.Colors(2,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,7)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", TopBorder: { Color: "#FFFFFF", Width: "2pt", Style: "Solid" } }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,7)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,7)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "#FFFFFF", Width: "1pt", Style: "Solid" } } }, { id: "14754a8e-67cc-48ac-aa14-a2ba120c8d1d", name: "Medium Style 1 Accent 5", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,8)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", BottomBorder: { Color: "#FFFFFF", Width: "2pt", Style: "Solid" } }] }, Details: { AlternatingExpression: "=IIF(RowNumber(Nothing) Mod 2, {0}, {1})", Rows: [{ BackgroundColor: "=Theme.Colors(1,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }, { BackgroundColor: "=Theme.Colors(2,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,8)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", TopBorder: { Color: "#FFFFFF", Width: "2pt", Style: "Solid" } }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,8)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,8)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "#FFFFFF", Width: "1pt", Style: "Solid" } } }, { id: "f032ec21-09cd-41e4-8080-db2e0fc2a7c7", name: "Medium Style 1", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Dark1", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", BottomBorder: { Color: "#FFFFFF", Width: "2pt", Style: "Solid" } }] }, Details: { AlternatingExpression: "=IIF(RowNumber(Nothing) Mod 2, {0}, {1})", Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }, { BackgroundColor: "=Theme.Colors!Light2", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Dark1", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", TopBorder: { Color: "#FFFFFF", Width: "2pt", Style: "Solid" } }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Dark2", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Dark2", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light2", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light2", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(4,1)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(4,1)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "#FFFFFF", Width: "1pt", Style: "Solid" } } }, { id: "287a64bd-9e6b-4fc2-a6ee-269c8417a38c", name: "No Style No Grid", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "#FFFFFF", Width: "1pt", Style: "Solid" } } }, { id: "d21e4133-6301-4b7e-958b-10b377065120", name: "No Style Table Grid", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", LeftBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, RightBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, TopBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, BottomBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" } }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", LeftBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, RightBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, TopBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, BottomBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" } }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", LeftBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, RightBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, TopBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, BottomBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" } }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", LeftBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, RightBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, TopBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, BottomBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" } }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", LeftBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, RightBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, TopBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, BottomBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" } }] } }] }, Border: { Color: "#000000", Width: "1pt", Style: "Solid" } } }, { id: "78f0e2ee-bef9-418e-bd1b-dd01874c51fa", name: "SmoothTable", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Accent1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", BottomBorder: { Color: "=Theme.Colors!Dark1", Width: "0.5pt", Style: "Dashed" } }] }, Details: { AlternatingExpression: "=IIF(RowNumber(Nothing) Mod 2, {0}, {1})", Rows: [{ BackgroundColor: "=Theme.Colors!Accent6", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }, { BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Accent1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "#FFFFFF", Width: "1pt", Style: "None" } } }], TableOfContents: [{ id: "95bf5640-605c-402b-af76-6ee48d6d84e4", name: "Dark 1", content: { BackgroundColor: "=Theme.Colors!Light1", Border: { Color: "Black", Width: "1pt", Style: "None" }, Levels: [{ FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", Color: "=Theme.Colors!Dark1", PaddingLeft: "0pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", Color: "=Theme.Colors!Dark1", PaddingLeft: "5pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", Color: "=Theme.Colors(3,0)", PaddingLeft: "10pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", Color: "=Theme.Colors(3,0)", PaddingLeft: "15pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", Color: "=Theme.Colors(3,0)", PaddingLeft: "20pt" }] } }, { id: "807aaf1f-e4bd-48f5-9a81-8879a33121af", name: "Dark 2", content: { BackgroundColor: "=Theme.Colors!Light2", Border: { Color: "Black", Width: "1pt", Style: "None" }, Levels: [{ FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", Color: "=Theme.Colors!Dark2", PaddingLeft: "0pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", Color: "=Theme.Colors!Dark2", PaddingLeft: "5pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", Color: "=Theme.Colors(3,2)", PaddingLeft: "10pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", Color: "=Theme.Colors(3,2)", PaddingLeft: "15pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", Color: "=Theme.Colors(3,2)", PaddingLeft: "20pt" }] } }, { id: "c759a5d7-e402-4941-8449-7a7c6ddee9df", name: "Light 1 Accent 1", content: { BackgroundColor: "=Theme.Colors!Accent1", Border: { Color: "=Theme.Colors(4,4)", Width: "1pt", Style: "Solid" }, Levels: [{ FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", Color: "=Theme.Colors!Light1", PaddingLeft: "0pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", Color: "=Theme.Colors!Light1", PaddingLeft: "5pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", Color: "=Theme.Colors(3,1)", PaddingLeft: "10pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", Color: "=Theme.Colors(3,1)", PaddingLeft: "15pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", Color: "=Theme.Colors(3,1)", PaddingLeft: "20pt" }] } }, { id: "4e590ae2-e6a8-4289-8403-25260c70ceaf", name: "Light 1 Accent 2", content: { BackgroundColor: "=Theme.Colors!Accent2", Border: { Color: "=Theme.Colors(4,5)", Width: "1pt", Style: "Solid" }, Levels: [{ FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", Color: "=Theme.Colors!Light1", PaddingLeft: "0pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", Color: "=Theme.Colors!Light1", PaddingLeft: "5pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", Color: "=Theme.Colors(3,1)", PaddingLeft: "10pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", Color: "=Theme.Colors(3,1)", PaddingLeft: "15pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", Color: "=Theme.Colors(3,1)", PaddingLeft: "20pt" }] } }, { id: "5c0c5571-e788-47ac-a0cb-33042998b155", name: "Light 1 Accent 3", content: { BackgroundColor: "=Theme.Colors!Accent3", Border: { Color: "=Theme.Colors(4,6)", Width: "1pt", Style: "Solid" }, Levels: [{ FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", Color: "=Theme.Colors!Light1", PaddingLeft: "0pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", Color: "=Theme.Colors!Light1", PaddingLeft: "5pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", Color: "=Theme.Colors(3,1)", PaddingLeft: "10pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", Color: "=Theme.Colors(3,1)", PaddingLeft: "15pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", Color: "=Theme.Colors(3,1)", PaddingLeft: "20pt" }] } }, { id: "2590cdeb-776b-4bb1-b46a-9359a845d82a", name: "Light 1 Accent 4", content: { BackgroundColor: "=Theme.Colors!Accent4", Border: { Color: "=Theme.Colors(4,7)", Width: "1pt", Style: "Solid" }, Levels: [{ FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", Color: "=Theme.Colors!Light1", PaddingLeft: "0pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", Color: "=Theme.Colors!Light1", PaddingLeft: "5pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", Color: "=Theme.Colors(3,1)", PaddingLeft: "10pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", Color: "=Theme.Colors(3,1)", PaddingLeft: "15pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", Color: "=Theme.Colors(3,1)", PaddingLeft: "20pt" }] } }, { id: "8bc9d639-6f96-4ee6-8513-c961f406cc3e", name: "Light 1 Accent 5", content: { BackgroundColor: "=Theme.Colors!Accent5", Border: { Color: "=Theme.Colors(4,8)", Width: "1pt", Style: "Solid" }, Levels: [{ FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", Color: "=Theme.Colors!Light1", PaddingLeft: "0pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", Color: "=Theme.Colors!Light1", PaddingLeft: "5pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", Color: "=Theme.Colors(3,1)", PaddingLeft: "10pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", Color: "=Theme.Colors(3,1)", PaddingLeft: "15pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", Color: "=Theme.Colors(3,1)", PaddingLeft: "20pt" }] } }, { id: "3cf640aa-5d8f-41d6-8dda-4f6fe1722bdf", name: "Light 1 Accent 6", content: { BackgroundColor: "=Theme.Colors!Accent6", Border: { Color: "=Theme.Colors(4,9)", Width: "1pt", Style: "Solid" }, Levels: [{ FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", Color: "=Theme.Colors!Light1", PaddingLeft: "0pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", Color: "=Theme.Colors!Light1", PaddingLeft: "5pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", Color: "=Theme.Colors(3,1)", PaddingLeft: "10pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", Color: "=Theme.Colors(3,1)", PaddingLeft: "15pt" }, { FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", Color: "=Theme.Colors(3,1)", PaddingLeft: "20pt" }] } }], Tablix: [{ id: "4dcde9a5-0e6e-409e-881d-d04933abec1f", name: "Light Style 1 Accent 1 Tablix", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", TopBorder: { Color: "=Theme.Colors!Accent1", Width: "2pt", Style: "Solid" }, BottomBorder: { Color: "=Theme.Colors!Accent1", Width: "2pt", Style: "Solid" } }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,4)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,4)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Style: "None" } } }, { id: "744df740-3596-4f34-9e17-9aeca4c4794f", name: "Light Style 1 Accent 2 Tablix", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", TopBorder: { Color: "=Theme.Colors!Accent2", Width: "2pt", Style: "Solid" }, BottomBorder: { Color: "=Theme.Colors!Accent2", Width: "2pt", Style: "Solid" } }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,5)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,5)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Style: "None" } } }, { id: "38c445cf-2501-4c03-8e83-c744a7a35b07", name: "Light Style 1 Accent 3 Tablix", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", TopBorder: { Color: "=Theme.Colors!Accent3", Width: "2pt", Style: "Solid" }, BottomBorder: { Color: "=Theme.Colors!Accent3", Width: "2pt", Style: "Solid" } }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,6)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,6)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Style: "None" } } }, { id: "81c53fe3-30be-4152-8197-515eec23a322", name: "Light Style 1 Accent 4 Tablix", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", TopBorder: { Color: "=Theme.Colors!Accent4", Width: "2pt", Style: "Solid" }, BottomBorder: { Color: "=Theme.Colors!Accent4", Width: "2pt", Style: "Solid" } }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,7)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,7)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Style: "None" } } }, { id: "082f64b4-a247-4b83-9831-79f7f5da34b5", name: "Light Style 1 Accent 5 Tablix", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", TopBorder: { Color: "=Theme.Colors!Accent5", Width: "2pt", Style: "Solid" }, BottomBorder: { Color: "=Theme.Colors!Accent5", Width: "2pt", Style: "Solid" } }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,8)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,8)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Style: "None" } } }, { id: "310a002e-363d-4aae-bf48-94c18afe3e9e", name: "Light Style 1 Tablix", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", TopBorder: { Color: "=Theme.Colors!Accent1", Width: "2pt", Style: "Solid" }, BottomBorder: { Color: "=Theme.Colors!Accent1", Width: "2pt", Style: "Solid" } }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Dark1", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Dark1", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light2", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light2", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Style: "None" } } }, { id: "b6487d43-a517-46bd-a29d-983ea86d40c6", name: "Light Style 2 Accent 1 Tablix", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,4)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", LeftBorder: { Color: "=Theme.Colors!Accent1", Width: "1pt", Style: "Solid" }, RightBorder: { Color: "=Theme.Colors!Accent1", Width: "1pt", Style: "Solid" }, TopBorder: { Color: "=Theme.Colors!Accent1", Width: "1pt", Style: "Solid" }, BottomBorder: { Color: "=Theme.Colors!Accent1", Width: "1pt", Style: "Solid" } }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,4)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,4)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,4)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "=Theme.Colors(0,4)", Width: "1pt", Style: "Solid" } } }, { id: "2af452ed-9e11-4cbf-ae09-706ea809b077", name: "Light Style 2 Accent 2 Tablix", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,5)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", LeftBorder: { Color: "=Theme.Colors!Accent2", Width: "1pt", Style: "Solid" }, RightBorder: { Color: "=Theme.Colors!Accent2", Width: "1pt", Style: "Solid" }, TopBorder: { Color: "=Theme.Colors!Accent2", Width: "1pt", Style: "Solid" }, BottomBorder: { Color: "=Theme.Colors!Accent2", Width: "1pt", Style: "Solid" } }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,5)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,5)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,5)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "=Theme.Colors(0,5)", Width: "1pt", Style: "Solid" } } }, { id: "07b58dbb-2bc6-4279-aaca-4ada62ede325", name: "Light Style 2 Accent 3 Tablix", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,6)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", LeftBorder: { Color: "=Theme.Colors!Accent3", Width: "1pt", Style: "Solid" }, RightBorder: { Color: "=Theme.Colors!Accent3", Width: "1pt", Style: "Solid" }, TopBorder: { Color: "=Theme.Colors!Accent3", Width: "1pt", Style: "Solid" }, BottomBorder: { Color: "=Theme.Colors!Accent3", Width: "1pt", Style: "Solid" } }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,6)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,6)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,6)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "=Theme.Colors(0,6)", Width: "1pt", Style: "Solid" } } }, { id: "73b1826c-dc9e-4d7d-9eac-3bae6ad290c7", name: "Light Style 2 Accent 4 Tablix", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,7)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", LeftBorder: { Color: "=Theme.Colors!Accent4", Width: "1pt", Style: "Solid" }, RightBorder: { Color: "=Theme.Colors!Accent4", Width: "1pt", Style: "Solid" }, TopBorder: { Color: "=Theme.Colors!Accent4", Width: "1pt", Style: "Solid" }, BottomBorder: { Color: "=Theme.Colors!Accent4", Width: "1pt", Style: "Solid" } }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,7)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,7)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,7)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "=Theme.Colors(0,7)", Width: "1pt", Style: "Solid" } } }, { id: "515f4369-24b7-45e7-b3a8-6ce554d0e4ce", name: "Light Style 2 Accent 5 Tablix", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,8)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", LeftBorder: { Color: "=Theme.Colors!Accent5", Width: "1pt", Style: "Solid" }, RightBorder: { Color: "=Theme.Colors!Accent5", Width: "1pt", Style: "Solid" }, TopBorder: { Color: "=Theme.Colors!Accent5", Width: "1pt", Style: "Solid" }, BottomBorder: { Color: "=Theme.Colors!Accent5", Width: "1pt", Style: "Solid" } }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,8)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,8)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,8)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "=Theme.Colors(0,8)", Width: "1pt", Style: "Solid" } } }, { id: "174c7fc9-f8b9-446d-baa0-40f335f14664", name: "Light Style 2 Tablix", content: { Header: { Rows: [{ BackgroundColor: "Black", Color: "White", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Details: { Rows: [{ BackgroundColor: "White", Color: "Black", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "Black", Color: "White", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "#AEAEAE", Color: "Black", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "#AEAEAE", Color: "Black", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "#D2D2D2", Color: "Black", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "#D2D2D2", Color: "Black", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "White", Color: "Black", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "White", Color: "Black", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "#000000", Width: "1pt", Style: "Solid" } } }, { id: "bb97b29f-8ed7-478c-bc68-02c48823c829", name: "Medium Style 1 Accent 1 Tablix", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,4)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", BottomBorder: { Color: "#FFFFFF", Width: "2pt", Style: "Solid" } }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors(1,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,4)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", TopBorder: { Color: "#FFFFFF", Width: "2pt", Style: "Solid" } }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,4)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,4)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,4)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "#FFFFFF", Width: "1pt", Style: "Solid" } } }, { id: "427f3e82-2e8d-4d57-a802-0822eee4ee09", name: "Medium Style 1 Accent 2 Tablix", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,5)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", BottomBorder: { Color: "#FFFFFF", Width: "2pt", Style: "Solid" } }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors(1,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,5)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", TopBorder: { Color: "#FFFFFF", Width: "2pt", Style: "Solid" } }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,5)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,5)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,5)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "#FFFFFF", Width: "1pt", Style: "Solid" } } }, { id: "16949623-dbcb-42a1-8c6b-b098348ec814", name: "Medium Style 1 Accent 3 Tablix", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,6)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", BottomBorder: { Color: "#FFFFFF", Width: "2pt", Style: "Solid" } }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors(1,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,6)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", TopBorder: { Color: "#FFFFFF", Width: "2pt", Style: "Solid" } }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,6)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,6)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,6)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "#FFFFFF", Width: "1pt", Style: "Solid" } } }, { id: "98255249-c6aa-4ff3-a1da-e12776b90680", name: "Medium Style 1 Accent 4 Tablix", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,7)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", BottomBorder: { Color: "#FFFFFF", Width: "2pt", Style: "Solid" } }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors(1,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,7)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", TopBorder: { Color: "#FFFFFF", Width: "2pt", Style: "Solid" } }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,7)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,7)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,7)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "#FFFFFF", Width: "1pt", Style: "Solid" } } }, { id: "f51b931a-29d9-4b3c-977b-e8eee0ee081e", name: "Medium Style 1 Accent 5 Tablix", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,8)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", BottomBorder: { Color: "#FFFFFF", Width: "2pt", Style: "Solid" } }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors(1,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,8)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", TopBorder: { Color: "#FFFFFF", Width: "2pt", Style: "Solid" } }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors(0,8)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(0,8)", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(3,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(3,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(2,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(2,8)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "#FFFFFF", Width: "1pt", Style: "Solid" } } }, { id: "f7b6215e-d5ab-42f1-a424-4207b120d10f", name: "Medium Style 1 Tablix", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Dark1", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", BottomBorder: { Color: "#FFFFFF", Width: "2pt", Style: "Solid" } }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Dark1", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", TopBorder: { Color: "#FFFFFF", Width: "2pt", Style: "Solid" } }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Dark2", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Dark2", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light2", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light2", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }, { Header: { Rows: [{ BackgroundColor: "=Theme.Colors(4,1)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors(4,1)", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "#FFFFFF", Width: "1pt", Style: "Solid" } } }, { id: "58a14c1b-968f-41a7-bead-48e615f15899", name: "No Style No Grid Tablix", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "#FFFFFF", Width: "1pt", Style: "Solid" } } }, { id: "5320b76f-906f-4516-b4f5-bc086ffae804", name: "No Style Tablix Grid", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", LeftBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, RightBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, TopBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, BottomBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" } }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight", LeftBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, RightBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, TopBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, BottomBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" } }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", LeftBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, RightBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, TopBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, BottomBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" } }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", LeftBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, RightBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, TopBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, BottomBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" } }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", LeftBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, RightBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, TopBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" }, BottomBorder: { Color: "#000000", Width: "0.5pt", Style: "Solid" } }] } }] }, Border: { Color: "#000000", Width: "1pt", Style: "Solid" } } }, { id: "1b7cb623-d6d1-42fa-8c9a-b57f25cbfa75", name: "SmoothTablix", content: { Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Accent1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight", BottomBorder: { Color: "=Theme.Colors!Dark1", Width: "0.5pt", Style: "Dashed" } }] }, Details: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, TableGroups: { Styles: [{ Header: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Accent1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] }, Footer: { Rows: [{ BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" }] } }] }, Border: { Color: "#FFFFFF", Width: "1pt", Style: "None" } } }], TextBox: [{ id: "0b65e860-6c8c-4d79-9c06-69f939517ae6", name: "Dark 1 Major", content: { BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "a2e6395b-4951-4c09-a99e-cd798d79692e", name: "Dark 1 Minor", content: { BackgroundColor: "=Theme.Colors!Light1", Color: "=Theme.Colors!Dark1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }, { id: "585e5f24-a6e1-4990-9b91-2c23a4d611b4", name: "Light 1 Accent 1 Major", content: { BackgroundColor: "=Theme.Colors!Accent1", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "847dc417-262b-4211-8d4b-5897584d4d85", name: "Light 1 Accent 1 Minor", content: { BackgroundColor: "=Theme.Colors!Accent1", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }, { id: "aef4a90f-7180-4024-84be-aa3a71ba4717", name: "Light 1 Accent 2 Major", content: { BackgroundColor: "=Theme.Colors!Accent2", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "1b477fa5-ba60-4a3b-b878-c0d127a78d71", name: "Light 1 Accent 2 Minor", content: { BackgroundColor: "=Theme.Colors!Accent2", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }, { id: "deb76e0c-7794-4f5e-b56b-fa61d5b0286c", name: "Light 1 Accent 3 Major", content: { BackgroundColor: "=Theme.Colors!Accent3", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "f5e54e25-c0b0-46fa-88ee-79dc497be4d4", name: "Light 1 Accent 3 Minor", content: { BackgroundColor: "=Theme.Colors!Accent3", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }, { id: "fac9f5d1-65a1-4cd2-bbb2-934b3b173cd3", name: "Light 1 Accent 4 Major", content: { BackgroundColor: "=Theme.Colors!Accent4", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "5736df25-3a79-4a96-a6d1-db7fdc4e6777", name: "Light 1 Accent 4 Minor", content: { BackgroundColor: "=Theme.Colors!Accent4", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }, { id: "ed6d70d2-fde9-4d61-a8b5-a91431825837", name: "Light 1 Accent 5 Major", content: { BackgroundColor: "=Theme.Colors!Accent5", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "77f50a8a-7e30-4d69-b7f4-2056db7ad1ed", name: "Light 1 Accent 5 Minor", content: { BackgroundColor: "=Theme.Colors!Accent5", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }, { id: "e8179ad3-a9a0-440d-8750-1d058024e730", name: "Light 1 Accent 6 Major", content: { BackgroundColor: "=Theme.Colors!Accent6", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MajorFont.Family", FontSize: "=Theme.Fonts!MajorFont.Size", FontStyle: "=Theme.Fonts!MajorFont.Style", FontWeight: "=Theme.Fonts!MajorFont.Weight" } }, { id: "cf51809a-b899-48d7-9794-10e93d271b6d", name: "Light 1 Accent 6 Minor", content: { BackgroundColor: "=Theme.Colors!Accent6", Color: "=Theme.Colors!Light1", FontFamily: "=Theme.Fonts!MinorFont.Family", FontSize: "=Theme.Fonts!MinorFont.Size", FontStyle: "=Theme.Fonts!MinorFont.Style", FontWeight: "=Theme.Fonts!MinorFont.Weight" } }], ChartPalette: [{ id: "c7407cc5-5489-4b68-97fc-4318a3856f8f", name: "Accent Colors", content: ["=Theme.Colors!Accent1", "=Theme.Colors!Accent2", "=Theme.Colors!Accent3", "=Theme.Colors!Accent4", "=Theme.Colors!Accent5", "=Theme.Colors!Accent6", "=Theme.Colors(5,4)", "=Theme.Colors(5,5)", "=Theme.Colors(5,6)", "=Theme.Colors(5,7)", "=Theme.Colors(5,8)", "=Theme.Colors(5,9)"] }, { id: "e10811b6-f0d5-4da7-8a95-ae3408ef3370", name: "Smooth Colors", content: ["=Theme.Colors!Accent1", "=Theme.Colors!Accent3", "=Theme.Colors!Accent4", "=Theme.Colors!Accent5", "=Theme.Colors(2,6)", "=Theme.Colors(1,6)", "=Theme.Colors(3,4)", "=Theme.Colors(3,5)", "=Theme.Colors(3,6)"] }, { id: "4a500a12-d43d-4a4f-a49e-9dfb821ce5cc", name: "Accent Color 1", content: ["=Theme.Colors(5,4)", "=Theme.Colors(4,4)", "=Theme.Colors!Accent1", "=Theme.Colors(3,4)", "=Theme.Colors(2,4)", "=Theme.Colors(1,4)"] }, { id: "8a7d3dd7-65a2-4206-aafd-fb989b452dfb", name: "Accent Color 2", content: ["=Theme.Colors(5,5)", "=Theme.Colors(4,5)", "=Theme.Colors!Accent2", "=Theme.Colors(3,5)", "=Theme.Colors(2,5)", "=Theme.Colors(1,5)"] }, { id: "a29451d1-b8cc-4392-b839-dbc0325128df", name: "Accent Color 3", content: ["=Theme.Colors(5,6)", "=Theme.Colors(4,6)", "=Theme.Colors!Accent3", "=Theme.Colors(3,6)", "=Theme.Colors(2,6)", "=Theme.Colors(1,6)"] }, { id: "d9bbea9e-c4c6-43e9-8b8d-e701ee1ccb27", name: "Accent Color 4", content: ["=Theme.Colors(5,7)", "=Theme.Colors(4,7)", "=Theme.Colors!Accent4", "=Theme.Colors(3,7)", "=Theme.Colors(2,7)", "=Theme.Colors(1,7)"] }, { id: "a0094c2e-cb98-4852-9268-169c0085f353", name: "Accent Color 5", content: ["=Theme.Colors(5,8)", "=Theme.Colors(4,8)", "=Theme.Colors!Accent5", "=Theme.Colors(3,8)", "=Theme.Colors(2,8)", "=Theme.Colors(1,8)"] }, { id: "9470e8fa-c885-4b41-adf5-f8acc91cbf30", name: "Accent Color 6", content: ["=Theme.Colors(5,9)", "=Theme.Colors(4,9)", "=Theme.Colors!Accent6", "=Theme.Colors(3,9)", "=Theme.Colors(2,9)", "=Theme.Colors(1,9)"] }] };
const Ej = ({ id: e14, name: t10, content: n10 }, r10, o10) => ({ id: e14, name: t10, content: o10 === wj.ChartPalette ? { palette: n10, $targetType: o10 } : __spreadProps(__spreadValues({}, n10), { $targetType: o10 }), targetTypes: [o10], isDefault: r10 });
const Fj = (e14, t10) => (t10 || []).map((t11, n10) => Ej(t11, 0 === n10, e14));
const Mj = Object.entries(Tj).reduce((e14, [t10, n10]) => [...e14, ...Fj(t10, n10)], []);
const kj = (e14, t10) => {
  const n10 = e14 == null ? void 0 : e14.toLowerCase();
  const r10 = Object.values(wj).find((e15) => e15.toLowerCase() === n10);
  if (!r10) return [];
  return (t10 || []).filter((e15) => (e15 && e15.targetTypes || []).includes(r10));
};
const Pj = (e14) => kj(wj.ChartPalette, e14 || Mj);
const Nj = (e14, t10) => {
  var _a2;
  const n10 = t10.find((t11) => t11.id === e14);
  return n10 ? (_a2 = n10.content) == null ? void 0 : _a2.palette : null;
};
const Dj = { chart: { innerRadius: 0.5, startAngle: 0 } };
function Lj(e14) {
  return e14 && oW.some((t10) => t10 === e14.Type);
}
function Hj(e14) {
  return Ij(e14) && e14.hasOwnProperty("Name");
}
function Ij(e14) {
  return e14 && zV.isObject(e14) && e14.hasOwnProperty("Type");
}
const _j = (e14, t10) => {
  if (ZW(t10)) return ((e15) => {
    const t11 = Pj(e15);
    if (0 === t11.length) return null;
    const n11 = t11.find((e16) => e16.isDefault) || t11[0];
    const { id: r10, name: o10, content: a10 } = n11;
    const i10 = (a10 == null ? void 0 : a10.palette) || null;
    return r10 && o10 && i10 && Array.isArray(i10) ? { id: r10, name: o10, content: i10 } : null;
  })(e14);
  let n10;
  if ($W(t10)) n10 = wj.Table;
  else if (zW(t10)) n10 = wj.Tablix;
  else if (t10 === rW.textbox) n10 = wj.TextBox;
  else if (t10 === rW.bullet) n10 = wj.Bullet;
  else if (t10 === rW.sparkline) n10 = wj.Sparkline;
  else if (OW(t10)) n10 = wj.Rectangle;
  else if (BW(t10)) n10 = wj.List;
  else if (t10 === rW.formattedText) n10 = wj.FormattedText;
  else if (t10 === rW.richtext) n10 = wj.RichText;
  else if (t10 === rW.shape) n10 = wj.Shape;
  else if (t10 === rW.checkbox) n10 = wj.CheckBox;
  else if (t10 === rW.inputField) n10 = wj.InputField;
  else {
    if (!WW(t10)) return null;
    n10 = wj.TableOfContents;
  }
  return e14.find((e15) => e15.isDefault && e15.content.$targetType === n10);
};
function Vj(e14, t10, n10) {
  let r10 = e14;
  if (oj(r10) || zV.isArray(r10)) for (const e15 in r10) {
    if (!r10.hasOwnProperty(e15)) continue;
    const o10 = r10[e15];
    if (aj(o10) || zV.isArray(o10)) {
      const a10 = Ij(o10) ? t10(o10, n10) : Vj(o10, t10, n10);
      a10 !== o10 && (r10 = AV(r10, { [e15]: { $set: a10 } }));
    }
  }
  return r10;
}
function Rj(e14, t10) {
  if (!e14 || !t10) return null;
  const n10 = t10.split(".");
  let r10 = e14;
  for (const e15 of n10) if (r10 = r10[e15], null == r10) return null;
  return r10;
}
const Aj = (e14, t10) => t10 ? Array.isArray(e14) ? e14.map((e15, n10) => Aj(e15, t10[n10] || t10[0])) : "object" == typeof e14 ? Object.assign({}, zV.mapValues(e14, (e15, n10) => Aj(e15, t10[n10])), t10 ? { $softfallback: t10 } : {}) : e14 : e14;
const Oj = (e14, t10, n10) => t10 && void 0 !== t10[n10] && null !== t10[n10] && e14 && t10[n10] !== e14[n10] && (!e14[n10] || !t10.$softfallback || t10.$softfallback[n10] === e14[n10]);
const Bj = (e14) => e14 && "true" === e14.toString().toLowerCase() || false;
const zj = (e14, t10) => {
  if (!e14 || !t10) return false;
  let n10 = e14;
  return t10.split(".").some((e15) => (n10 = n10[e15] || {}, UW(n10.Type)));
};
function $j(e14 = "", t10 = "") {
  return e14 ? t10 ? `${e14}.${t10}` : e14 || "" : t10 || "";
}
function Wj(e14, t10) {
  return `${e14}.ReportItems.${t10}`;
}
function jj(e14, t10) {
  return `${e14}.Levels.${t10}`;
}
function Zj(e14, t10) {
  return `${e14}.Members.${t10}`;
}
function Gj(e14, t10) {
  return `${e14}.Children.${t10}`;
}
function Uj(e14) {
  return `${e14}.Header.Item`;
}
function qj(e14, t10) {
  return `Corner.${e14}.${t10}.Item`;
}
function Yj(e14, t10) {
  return `Body.Rows.${e14}.Cells.${t10}.Item`;
}
function Kj(e14) {
  return `Pages.${e14}`;
}
const Xj = "TABLIX/ADD_GROUP";
const Jj = "TABLIX/ADD_COL";
const Qj = "TABLIX/ADD_COL_QUICK";
const eZ = "TABLIX/DEL_COL";
const tZ = "TABLIX/ADD_ROW";
const nZ = "TABLIX/ADD_ROW_QUICK";
const rZ = "TABLIX/DEL_ROW";
const oZ = "TABLIX/DEL_COLGROUP";
const aZ = "TABLIX/DEL_ROWGROUP";
const iZ = "TABLIX/ADD_TOTAL";
const sZ = "TABLIX/SPLIT_CELLS";
const lZ = "TABLIX/MERGE_CELLS";
const cZ = "TABLIX/TOGGLE_MEMBER_TYPE";
const uZ = { ROW: "RowHierarchy", COLUMN: "ColumnHierarchy" };
const dZ = { ROW: "Row", COLUMN: "Column" };
const pZ = { PARENT: "parent", CHILD: "child", BEFORE: "before", AFTER: "after" };
const mZ = { InsideBefore: "InsideBefore", InsideAfter: "InsideAfter", OutsideBefore: "OutsideBefore", OutsideAfter: "OutsideAfter", Before: "Before", After: "After", More: "More" };
const hZ = { Body: "Body", Corner: "Corner", RowHierarchy: "RowHierarchy", ColumnHierarchy: "ColumnHierarchy" };
function fZ(e14, t10) {
  return { type: Xj, payload: { hierarchyName: e14, position: t10 } };
}
function gZ(e14, t10 = 1) {
  return { type: tZ, payload: { operation: e14, count: t10 } };
}
function yZ() {
  return { type: rZ };
}
function vZ(e14, t10 = 1) {
  return { type: Jj, payload: { operation: e14, count: t10 } };
}
function bZ() {
  return { type: eZ };
}
function SZ() {
  return { type: oZ };
}
function CZ() {
  return { type: aZ };
}
function xZ(e14) {
  return { type: iZ, payload: { position: e14 } };
}
function wZ() {
  return { type: lZ };
}
function TZ() {
  return { type: sZ };
}
function EZ() {
  return { type: cZ, payload: {} };
}
var FZ = {};
var MZ = {};
var kZ = {};
!function(e14) {
  function t10(e15) {
    return null != e15 && "object" == typeof e15;
  }
  Object.defineProperty(e14, "__esModule", { value: true }), e14.isEqual = e14.isObjectLike = e14.isObject = e14.isArray = void 0, e14.isArray = Array.isArray, e14.isObject = function(e15) {
    var t11 = typeof e15;
    return null != e15 && ("object" == t11 || "function" == t11);
  }, e14.isObjectLike = t10, e14.isEqual = function n10(r10, o10) {
    return r10 === o10 || (null == r10 || null == o10 || !t10(r10) && !t10(o10) ? r10 != r10 && o10 != o10 : typeof r10 == typeof o10 && ("object" == typeof r10 && ((0, e14.isArray)(r10) ? r10.length === o10.length && r10.every(function(e15, t11) {
      return n10(e15, o10[t11]);
    }) : n10(Object.keys(r10).sort(), Object.keys(o10).sort()) && Object.keys(r10).every(function(e15) {
      return n10(r10[e15], o10[e15]);
    }))));
  };
}(kZ), function(e14) {
  var t10 = $ && $.__assign || function() {
    return t10 = Object.assign || function(e15) {
      for (var t11, n11 = 1, r11 = arguments.length; n11 < r11; n11++) for (var o11 in t11 = arguments[n11]) Object.prototype.hasOwnProperty.call(t11, o11) && (e15[o11] = t11[o11]);
      return e15;
    }, t10.apply(this, arguments);
  };
  var n10 = $ && $.__spreadArray || function(e15, t11, n11) {
    if (n11 || 2 === arguments.length) for (var r11, o11 = 0, a11 = t11.length; o11 < a11; o11++) !r11 && o11 in t11 || (r11 || (r11 = Array.prototype.slice.call(t11, 0, o11)), r11[o11] = t11[o11]);
    return e15.concat(r11 || Array.prototype.slice.call(t11));
  };
  Object.defineProperty(e14, "__esModule", { value: true }), e14.orElse = e14.getLastRecordedFailures = e14.recordFailures = e14.upcast = e14.makeDefaultOf = e14.omit = e14.pick = e14.Enum = e14.members = e14.lazy = e14.iif = e14.alt = e14.intersectWith = e14.mapInput = e14.map = e14.arrayDef = e14.array = e14.typeDefReq = e14.typeReq = e14.required = e14.typeDef = e14.type = e14.withDefaultOf = e14.literalInit = e14.initValue = e14.DefaultOf = e14.Default = e14.nullable = e14.justRead = e14.optional = e14.boolean = e14.number = e14.string = e14.literal = e14.Temp = e14.Const = e14.unknown = e14.resultOf = e14.failure = e14.success = e14.pipe = e14.recordFailure = void 0;
  var r10 = kZ;
  var o10 = [];
  function a10() {
    o10 = [];
  }
  function i10(e15) {
    o10.push(t10(t10({}, e15), { context: u10() }));
  }
  function s10(e15, t11, r11, o11) {
    var a11 = [];
    for (var i11 = 4; i11 < arguments.length; i11++) a11[i11 - 4] = arguments[i11];
    switch (arguments.length) {
      case 0:
        return;
      case 1:
        return e15;
      case 2:
        return t11(e15);
      case 3:
        return r11(t11(e15));
      case 4:
        return o11(r11(t11(e15)));
      default:
        return s10.apply(null, n10([o11(r11(t11(e15)))], a11, true));
    }
  }
  e14.recordFailure = i10, e14.pipe = s10;
  e14.success = function(e15, t11) {
    return void 0 === t11 && (t11 = []), { type: "success", value: e15, warnings: t11 };
  };
  e14.failure = function(e15) {
    return { type: "error", reason: e15 };
  };
  e14.resultOf = function(e15) {
    return "success" === e15.type ? e15.value : void 0;
  }, e14.unknown = { decode: function(t11) {
    return (0, e14.success)(t11);
  }, encode: function(e15) {
    return e15;
  } };
  e14.Const = function(t11) {
    return { decode: function() {
      return (0, e14.success)(t11);
    }, encode: function() {
    } };
  };
  var l10;
  function c10(e15, t11) {
    var n11 = l10;
    l10 = { part: e15, next: n11 };
    try {
      return t11();
    } finally {
      l10 = n11;
    }
  }
  function u10() {
    var e15 = [];
    for (var t11 = l10; null != t11 && t11.part; t11 = t11.next) e15.unshift(t11.part);
    return "".concat.apply("", e15);
  }
  e14.Temp = function(t11) {
    return { decode: function() {
      return (0, e14.success)(t11);
    }, encode: function() {
    } };
  };
  var d10 = function(e15) {
    var t11 = [];
    for (var n11 = 1; n11 < arguments.length; n11++) t11[n11 - 1] = arguments[n11];
    return -1 !== t11.findIndex(function(t12) {
      return t12 === e15;
    });
  };
  e14.literal = function() {
    var t11 = [];
    for (var r11 = 0; r11 < arguments.length; r11++) t11[r11] = arguments[r11];
    return { decode: function(r12) {
      return d10.apply(void 0, n10([r12], t11, false)) ? (0, e14.success)(r12) : (0, e14.failure)("expected ".concat(t11.map(function(e15) {
        return JSON.stringify(e15);
      }).join(" | "), ", got: '").concat(r12, "'"));
    }, encode: function(e15) {
      return "string" == typeof e15 || "number" == typeof e15 || null === e15 ? e15 : (i10({ type: "error", message: "expected a string value" }), null == e15 ? void 0 : e15.toString());
    } };
  }, e14.string = { decode: function(t11) {
    return "string" == typeof t11 ? (0, e14.success)(t11) : (0, e14.failure)("expected string");
  }, encode: function(e15) {
    return "string" == typeof e15 ? e15 : (i10({ type: "error", message: "expected a string value" }), null == e15 ? void 0 : e15.toString());
  } }, e14.number = { decode: function(t11) {
    return "number" != typeof t11 || Number.isNaN(t11) ? (0, e14.failure)("expected number") : (0, e14.success)(t11);
  }, encode: function(e15) {
    return "number" == typeof e15 ? e15 : (i10({ type: "error", message: "expected a numeric value" }), null == e15 || Number.isNaN(+e15) ? void 0 : +e15);
  } }, e14.boolean = { decode: function(t11) {
    return "boolean" == typeof t11 ? (0, e14.success)(t11) : (0, e14.failure)("expected boolean");
  }, encode: function(e15) {
    return "boolean" == typeof e15 ? e15 : (i10({ type: "error", message: "expected a bool value" }), null == e15 ? void 0 : !!e15);
  } };
  e14.optional = function(t11) {
    return { decode: function(n11) {
      return null == n11 ? (0, e14.success)(void 0) : t11.decode(n11);
    }, encode: function(e15) {
      return void 0 === e15 ? void 0 : t11.encode(e15);
    } };
  };
  e14.justRead = function(e15) {
    return { decode: e15.decode, encode: function() {
    } };
  };
  e14.nullable = function(t11) {
    return { decode: function(n11) {
      return null == n11 ? (0, e14.success)(null) : t11.decode(n11);
    }, encode: function(e15) {
      return null == e15 ? null : t11.encode(e15);
    } };
  };
  e14.Default = function(t11, n11) {
    return { decode: function(r11) {
      return void 0 === r11 ? (0, e14.success)(t11) : n11.decode(r11);
    }, encode: function(e15) {
      if (!Array.isArray(e15) || 0 !== e15.length || !Array.isArray(t11) || 0 !== t11.length) return (0, r10.isEqual)(e15, t11) ? void 0 : n11.encode(e15);
    } };
  };
  e14.DefaultOf = function(t11, n11) {
    var o11 = n11.decode(t11);
    if ("error" === o11.type) throw new Error("Failed to create a default result");
    var a11 = Object.freeze(o11.value);
    return { decode: function(t12) {
      return void 0 === t12 ? (0, e14.success)(a11) : n11.decode(t12);
    }, encode: function(e15) {
      var o12 = n11.encode(e15);
      return (0, r10.isEqual)(o12, t11) ? void 0 : o12;
    } };
  };
  e14.initValue = function(t11, n11) {
    return { decode: function(r11) {
      return void 0 === r11 ? (0, e14.success)(t11) : n11.decode(r11);
    }, encode: n11.encode };
  };
  e14.literalInit = function(t11) {
    return (0, e14.initValue)(t11, (0, e14.literal)(t11));
  };
  e14.withDefaultOf = function(t11) {
    return function(n11) {
      return (0, e14.DefaultOf)(t11, n11);
    };
  };
  e14.type = function(t11) {
    return { decode: function(n11) {
      if (null == n11) return (0, e14.failure)("non-null expected");
      var r11 = {};
      for (var o11 in t11) if ({}.hasOwnProperty.call(t11, o11)) {
        if (!t11[o11]) return (0, e14.failure)("".concat(o11, ": missing property"));
        var a11 = t11[o11].decode(n11[o11]);
        if ("error" === a11.type) return (0, e14.failure)("".concat(o11, ": ").concat(a11.reason));
        r11[o11] = a11.value;
      }
      return (0, e14.success)(r11);
    }, encode: function(e15) {
      if (null != e15) {
        var n11 = {};
        var r11 = function(r12) {
          if (!{}.hasOwnProperty.call(t11, r12)) return "continue";
          c10(".", function() {
            var o12 = c10(r12, function() {
              return t11[r12].encode(e15[r12]);
            });
            void 0 !== o12 && (n11[r12] = o12);
          });
        };
        for (var o11 in t11) r11(o11);
        return n11;
      }
      i10({ type: "error", message: "non-null value is expected" });
    } };
  };
  e14.typeDef = function(t11) {
    return (0, e14.DefaultOf)({}, (0, e14.type)(t11));
  };
  e14.required = function() {
    var e15 = [];
    for (var t11 = 0; t11 < arguments.length; t11++) e15[t11] = arguments[t11];
    return function(t12) {
      return { decode: function(n11) {
        var r11 = e15.find(function(e16) {
          return void 0 === n11[e16];
        });
        return null != r11 && i10({ type: "error", message: "Property ".concat(String(r11), " is marked as required, but not provided") }), t12.decode(n11);
      }, encode: function(e16) {
        return t12.encode(e16);
      } };
    };
  };
  e14.typeReq = function(t11, n11) {
    return s10((0, e14.type)(t11), e14.required.apply(void 0, n11));
  };
  e14.typeDefReq = function(t11, n11, r11) {
    return (0, e14.DefaultOf)(n11, (0, e14.typeReq)(t11, r11));
  };
  e14.array = function(t11) {
    return { decode: function(n11) {
      if (!(0, r10.isArray)(n11)) return (0, e14.failure)("array expected");
      var o11 = n11.map(t11.decode);
      var a11 = o11.find(function(e15) {
        return "error" === e15.type;
      });
      return a11 && "error" === a11.type ? (0, e14.failure)(a11.reason) : (0, e14.success)(o11.map(e14.resultOf));
    }, encode: function(e15) {
      if (null != e15) return (0, r10.isArray)(e15) ? e15.map(function(e16, n11) {
        return c10("[".concat(n11, "]"), function() {
          return t11.encode(e16);
        });
      }) : (i10({ type: "error", message: "array is expected" }), []);
    } };
  };
  e14.arrayDef = function(t11) {
    return (0, e14.Default)([], (0, e14.array)(t11));
  };
  e14.map = function(t11, n11) {
    return function(r11) {
      return { decode: function(n12) {
        var o11 = r11.decode(n12);
        return "error" === o11.type ? o11 : (0, e14.success)(t11(o11.value));
      }, encode: function(e15) {
        return r11.encode(n11(e15));
      } };
    };
  };
  e14.mapInput = function(e15, t11) {
    return function(n11) {
      return { decode: function(e16) {
        return n11.decode(t11(e16));
      }, encode: function(t12) {
        return e15(n11.encode(t12));
      } };
    };
  };
  e14.intersectWith = function(n11) {
    return function(r11) {
      return { decode: function(o11) {
        var a11 = r11.decode(o11);
        if ("error" === a11.type) return (0, e14.failure)(a11.reason);
        var i11 = n11.decode(o11);
        return "success" === i11.type ? (0, e14.success)(t10(t10({}, a11.value), i11.value)) : (0, e14.failure)(i11.reason);
      }, encode: function(e15) {
        return t10(t10({}, r11.encode(e15)), n11.encode(e15));
      } };
    };
  };
  e14.alt = function(t11, n11, r11) {
    return { decode: function(n12) {
      var o11 = t11(n12) || "";
      var a11 = r11[o11];
      return null == a11 ? (0, e14.failure)('Unknown or unsupported item type "'.concat(o11, '"')) : a11.decode(n12);
    }, encode: function(e15) {
      var t12 = r11[n11(e15)];
      if (null == t12) throw new Error("unknown item type '".concat(n11(e15), "'"));
      return t12.encode(e15);
    } };
  };
  e14.iif = function(e15, t11, n11, r11) {
    return { decode: function(t12) {
      return e15(t12) ? n11.decode(t12) : r11.decode(t12);
    }, encode: function(e16) {
      return t11(e16) ? n11.encode(e16) : r11.encode(e16);
    } };
  };
  e14.lazy = function() {
    var e15 = function() {
      throw new Error("Cannot get here");
    };
    var t11 = { decode: e15, encode: e15 };
    return [t11, function(e16) {
      t11.decode = e16.decode, t11.encode = e16.encode;
    }];
  };
  e14.members = function() {
    var t11 = [];
    for (var n11 = 0; n11 < arguments.length; n11++) t11[n11] = arguments[n11];
    var r11 = {};
    t11.forEach(function(e15) {
      r11[e15] = e15, r11[e15.toLowerCase()] = e15;
    });
    var o11 = "expected ".concat(t11.map(function(e15) {
      return JSON.stringify(e15);
    }).join(" | "));
    return { decode: function(t12) {
      var n12 = "string" == typeof t12 ? r11[t12] || r11[t12.toLowerCase()] : void 0;
      return void 0 !== n12 ? (0, e14.success)(n12) : (0, e14.failure)("".concat(o11, ", got: '").concat(t12, "'"));
    }, encode: function(e15) {
      return "string" == typeof e15 ? e15 : (i10({ type: "error", message: "expected a string value" }), null == e15 ? void 0 : e15.toString());
    } };
  };
  e14.Enum = function(t11, n11) {
    return { decode: function(r11) {
      if (void 0 === r11) return (0, e14.success)(t11);
      var o11 = n11.decode(r11);
      return "success" === o11.type ? o11 : (i10({ type: "error", message: o11.reason }), (0, e14.success)(t11));
    }, encode: function(e15) {
      return e15 === t11 ? void 0 : n11.encode(e15);
    } };
  }, e14.pick = function(e15) {
    var t11 = [];
    for (var n11 = 1; n11 < arguments.length; n11++) t11[n11 - 1] = arguments[n11];
    var r11 = {};
    for (var o11 = 0, a11 = t11; o11 < a11.length; o11++) {
      var i11 = a11[o11];
      r11[i11] = e15[i11];
    }
    return r11;
  }, e14.omit = function(e15) {
    var t11 = [];
    for (var n11 = 1; n11 < arguments.length; n11++) t11[n11 - 1] = arguments[n11];
    var r11 = {};
    var o11 = function(n12) {
      t11.find(function(e16) {
        return e16 === n12;
      }) || (r11[n12] = e15[n12]);
    };
    for (var a11 = 0, i11 = Object.keys(e15); a11 < i11.length; a11++) {
      o11(i11[a11]);
    }
    return r11;
  }, e14.makeDefaultOf = function(t11, n11) {
    return void 0 === n11 && (n11 = {}), Object.freeze((0, e14.resultOf)(t11.decode(n11)));
  };
  e14.upcast = function() {
    return function(e15) {
      return e15;
    };
  };
  e14.recordFailures = function(t11) {
    return { decode: function(n11) {
      a10();
      var r11 = t11.decode(n11);
      var i11 = o10;
      return "success" === r11.type ? (0, e14.success)(r11.value, i11) : r11;
    }, encode: function(e15) {
      return a10(), t11.encode(e15);
    } };
  };
  e14.getLastRecordedFailures = function() {
    return n10([], o10, true);
  };
  e14.orElse = function(e15, t11) {
    return function(n11) {
      return { decode: function(t12) {
        var r11 = n11.decode(t12);
        return "error" === r11.type ? (i10({ type: "warning", message: r11.reason }), e15.decode(t12)) : r11;
      }, encode: function(r11) {
        return t11(r11) ? e15.encode(r11) : n11.encode(r11);
      } };
    };
  };
}(MZ);
var PZ = {};
var NZ = $ && $.__assign || function() {
  return NZ = Object.assign || function(e14) {
    for (var t10, n10 = 1, r10 = arguments.length; n10 < r10; n10++) for (var o10 in t10 = arguments[n10]) Object.prototype.hasOwnProperty.call(t10, o10) && (e14[o10] = t10[o10]);
    return e14;
  }, NZ.apply(this, arguments);
};
var DZ = $ && $.__rest || function(e14, t10) {
  var n10 = {};
  for (var r10 in e14) Object.prototype.hasOwnProperty.call(e14, r10) && t10.indexOf(r10) < 0 && (n10[r10] = e14[r10]);
  if (null != e14 && "function" == typeof Object.getOwnPropertySymbols) {
    var o10 = 0;
    for (r10 = Object.getOwnPropertySymbols(e14); o10 < r10.length; o10++) t10.indexOf(r10[o10]) < 0 && Object.prototype.propertyIsEnumerable.call(e14, r10[o10]) && (n10[r10[o10]] = e14[r10[o10]]);
  }
  return n10;
};
Object.defineProperty(PZ, "__esModule", { value: true }), PZ.identity = PZ.mapOfLens = PZ.iif = PZ.combine5 = PZ.combine4 = PZ.combine3 = PZ.combine = PZ.replace = PZ.array = PZ.nullable = PZ.prop = PZ.make = void 0;
var LZ = MZ;
PZ.make = function(e14, t10) {
  return { f: e14, frev: t10 };
}, PZ.prop = function(e14, t10) {
  return { f: function(n10) {
    var r10;
    var o10 = e14, a10 = n10[o10], i10 = DZ(n10, ["symbol" == typeof o10 ? o10 : o10 + ""]);
    return NZ(NZ({}, i10), ((r10 = {})[e14] = t10.f(a10), r10));
  }, frev: function(n10) {
    var r10;
    var o10 = e14, a10 = n10[o10], i10 = DZ(n10, ["symbol" == typeof o10 ? o10 : o10 + ""]);
    return NZ(NZ({}, i10), ((r10 = {})[e14] = t10.frev(a10), r10));
  } };
}, PZ.nullable = function(e14) {
  return { f: function(t10) {
    return null === t10 ? null : e14.f(t10);
  }, frev: function(t10) {
    return null === t10 ? null : e14.frev(t10);
  } };
}, PZ.array = function(e14) {
  return { f: function(t10) {
    return t10.map(e14.f);
  }, frev: function(t10) {
    return t10.map(e14.frev);
  } };
}, PZ.replace = function(e14, t10) {
  return { f: function() {
    return t10;
  }, frev: function() {
    return e14;
  } };
}, PZ.combine = function(e14, t10) {
  return { f: function(n10) {
    return t10.f(e14.f(n10));
  }, frev: function(n10) {
    return e14.frev(t10.frev(n10));
  } };
}, PZ.combine3 = function(e14, t10, n10) {
  return { f: function(r10) {
    return n10.f(t10.f(e14.f(r10)));
  }, frev: function(r10) {
    return e14.frev(t10.frev(n10.frev(r10)));
  } };
}, PZ.combine4 = function(e14, t10, n10, r10) {
  return { f: function(o10) {
    return r10.f(n10.f(t10.f(e14.f(o10))));
  }, frev: function(o10) {
    return e14.frev(t10.frev(n10.frev(r10.frev(o10))));
  } };
}, PZ.combine5 = function(e14, t10, n10, r10, o10) {
  return { f: function(a10) {
    return o10.f(r10.f(n10.f(t10.f(e14.f(a10)))));
  }, frev: function(a10) {
    return e14.frev(t10.frev(n10.frev(r10.frev(o10.frev(a10)))));
  } };
}, PZ.iif = function(e14, t10, n10, r10) {
  return { f: function(t11) {
    return e14(t11) ? n10.f(t11) : r10.f(t11);
  }, frev: function(e15) {
    return t10(e15) ? n10.frev(e15) : r10.frev(e15);
  } };
}, PZ.mapOfLens = function(e14) {
  return (0, LZ.map)(e14.f, e14.frev);
}, PZ.identity = function() {
  return { f: function(e14) {
    return e14;
  }, frev: function(e14) {
    return e14;
  } };
}, function(e14) {
  var t10 = $ && $.__createBinding || (Object.create ? function(e15, t11, n11, r10) {
    void 0 === r10 && (r10 = n11);
    var o10 = Object.getOwnPropertyDescriptor(t11, n11);
    o10 && !("get" in o10 ? !t11.__esModule : o10.writable || o10.configurable) || (o10 = { enumerable: true, get: function() {
      return t11[n11];
    } }), Object.defineProperty(e15, r10, o10);
  } : function(e15, t11, n11, r10) {
    void 0 === r10 && (r10 = n11), e15[r10] = t11[n11];
  });
  var n10 = $ && $.__exportStar || function(e15, n11) {
    for (var r10 in e15) "default" === r10 || Object.prototype.hasOwnProperty.call(n11, r10) || t10(n11, e15, r10);
  };
  Object.defineProperty(e14, "__esModule", { value: true }), e14.Helpers = e14.Lenses = void 0, n10(MZ, e14), e14.Lenses = PZ, e14.Helpers = kZ;
}(FZ);
var HZ = c({ __proto__: null, default: W(FZ) }, [FZ]);
function IZ(e14) {
  for (var t10 = 1; t10 < arguments.length; t10++) {
    var n10 = null != arguments[t10] ? Object(arguments[t10]) : {};
    var r10 = Object.keys(n10);
    "function" == typeof Object.getOwnPropertySymbols && r10.push.apply(r10, Object.getOwnPropertySymbols(n10).filter(function(e15) {
      return Object.getOwnPropertyDescriptor(n10, e15).enumerable;
    })), r10.forEach(function(t11) {
      ao(e14, t11, n10[t11]);
    });
  }
  return e14;
}
var _Z = { type: "logger", log: function(e14) {
  this.output("log", e14);
}, warn: function(e14) {
  this.output("warn", e14);
}, error: function(e14) {
  this.output("error", e14);
}, output: function(e14, t10) {
  console && console[e14] && console[e14].apply(console, t10);
} };
var VZ = function() {
  function e14(t10) {
    var n10 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    to(this, e14), this.init(t10, n10);
  }
  return oo(e14, [{ key: "init", value: function(e15) {
    var t10 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    this.prefix = t10.prefix || "i18next:", this.logger = e15 || _Z, this.options = t10, this.debug = t10.debug;
  } }, { key: "setDebug", value: function(e15) {
    this.debug = e15;
  } }, { key: "log", value: function() {
    for (var e15 = arguments.length, t10 = new Array(e15), n10 = 0; n10 < e15; n10++) t10[n10] = arguments[n10];
    return this.forward(t10, "log", "", true);
  } }, { key: "warn", value: function() {
    for (var e15 = arguments.length, t10 = new Array(e15), n10 = 0; n10 < e15; n10++) t10[n10] = arguments[n10];
    return this.forward(t10, "warn", "", true);
  } }, { key: "error", value: function() {
    for (var e15 = arguments.length, t10 = new Array(e15), n10 = 0; n10 < e15; n10++) t10[n10] = arguments[n10];
    return this.forward(t10, "error", "");
  } }, { key: "deprecate", value: function() {
    for (var e15 = arguments.length, t10 = new Array(e15), n10 = 0; n10 < e15; n10++) t10[n10] = arguments[n10];
    return this.forward(t10, "warn", "WARNING DEPRECATED: ", true);
  } }, { key: "forward", value: function(e15, t10, n10, r10) {
    return r10 && !this.debug ? null : ("string" == typeof e15[0] && (e15[0] = "".concat(n10).concat(this.prefix, " ").concat(e15[0])), this.logger[t10](e15));
  } }, { key: "create", value: function(t10) {
    return new e14(this.logger, IZ({}, { prefix: "".concat(this.prefix, ":").concat(t10, ":") }, this.options));
  } }]), e14;
}();
var RZ = new VZ();
var AZ = function() {
  function e14() {
    to(this, e14), this.observers = {};
  }
  return oo(e14, [{ key: "on", value: function(e15, t10) {
    var n10 = this;
    return e15.split(" ").forEach(function(e16) {
      n10.observers[e16] = n10.observers[e16] || [], n10.observers[e16].push(t10);
    }), this;
  } }, { key: "off", value: function(e15, t10) {
    this.observers[e15] && (t10 ? this.observers[e15] = this.observers[e15].filter(function(e16) {
      return e16 !== t10;
    }) : delete this.observers[e15]);
  } }, { key: "emit", value: function(e15) {
    for (var t10 = arguments.length, n10 = new Array(t10 > 1 ? t10 - 1 : 0), r10 = 1; r10 < t10; r10++) n10[r10 - 1] = arguments[r10];
    this.observers[e15] && [].concat(this.observers[e15]).forEach(function(e16) {
      e16.apply(void 0, n10);
    });
    this.observers["*"] && [].concat(this.observers["*"]).forEach(function(t11) {
      t11.apply(t11, [e15].concat(n10));
    });
  } }]), e14;
}();
function OZ() {
  var e14;
  var t10;
  var n10 = new Promise(function(n11, r10) {
    e14 = n11, t10 = r10;
  });
  return n10.resolve = e14, n10.reject = t10, n10;
}
function BZ(e14) {
  return null == e14 ? "" : "" + e14;
}
function zZ(e14, t10, n10) {
  function r10(e15) {
    return e15 && e15.indexOf("###") > -1 ? e15.replace(/###/g, ".") : e15;
  }
  function o10() {
    return !e14 || "string" == typeof e14;
  }
  var a10 = "string" != typeof t10 ? [].concat(t10) : t10.split(".");
  for (; a10.length > 1; ) {
    if (o10()) return {};
    var i10 = r10(a10.shift());
    !e14[i10] && n10 && (e14[i10] = new n10()), e14 = Object.prototype.hasOwnProperty.call(e14, i10) ? e14[i10] : {};
  }
  return o10() ? {} : { obj: e14, k: r10(a10.shift()) };
}
function $Z(e14, t10, n10) {
  var r10 = zZ(e14, t10, Object);
  r10.obj[r10.k] = n10;
}
function WZ(e14, t10) {
  var n10 = zZ(e14, t10), r10 = n10.obj, o10 = n10.k;
  if (r10) return r10[o10];
}
function jZ(e14, t10, n10) {
  var r10 = WZ(e14, n10);
  return void 0 !== r10 ? r10 : WZ(t10, n10);
}
function ZZ(e14, t10, n10) {
  for (var r10 in t10) "__proto__" !== r10 && "constructor" !== r10 && (r10 in e14 ? "string" == typeof e14[r10] || e14[r10] instanceof String || "string" == typeof t10[r10] || t10[r10] instanceof String ? n10 && (e14[r10] = t10[r10]) : ZZ(e14[r10], t10[r10], n10) : e14[r10] = t10[r10]);
  return e14;
}
function GZ(e14) {
  return e14.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var UZ = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "/": "&#x2F;" };
function qZ(e14) {
  return "string" == typeof e14 ? e14.replace(/[&<>"'\/]/g, function(e15) {
    return UZ[e15];
  }) : e14;
}
var YZ = "undefined" != typeof window && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1;
function KZ(e14, t10) {
  var n10 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ".";
  if (e14) {
    if (e14[t10]) return e14[t10];
    var r10 = t10.split(n10);
    var o10 = e14;
    for (var a10 = 0; a10 < r10.length; ++a10) {
      if ("string" == typeof o10[r10[a10]] && a10 + 1 < r10.length) return;
      if (void 0 === o10[r10[a10]]) {
        var i10 = 2;
        var s10 = r10.slice(a10, a10 + i10).join(n10);
        var l10 = o10[s10];
        for (; void 0 === l10 && r10.length > a10 + i10; ) i10++, l10 = o10[s10 = r10.slice(a10, a10 + i10).join(n10)];
        if (void 0 === l10) return;
        if ("string" == typeof l10) return l10;
        if (s10 && "string" == typeof l10[s10]) return l10[s10];
        var c10 = r10.slice(a10 + i10).join(n10);
        return c10 ? KZ(l10, c10, n10) : void 0;
      }
      o10 = o10[r10[a10]];
    }
    return o10;
  }
}
var XZ = function(e14) {
  function t10(e15) {
    var n10;
    var r10 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : { ns: ["translation"], defaultNS: "translation" };
    return to(this, t10), n10 = Qr(this, Xr(t10).call(this)), YZ && AZ.call(qr(n10)), n10.data = e15 || {}, n10.options = r10, void 0 === n10.options.keySeparator && (n10.options.keySeparator = "."), void 0 === n10.options.ignoreJSONStructure && (n10.options.ignoreJSONStructure = true), n10;
  }
  return Kr(t10, AZ), oo(t10, [{ key: "addNamespaces", value: function(e15) {
    this.options.ns.indexOf(e15) < 0 && this.options.ns.push(e15);
  } }, { key: "removeNamespaces", value: function(e15) {
    var t11 = this.options.ns.indexOf(e15);
    t11 > -1 && this.options.ns.splice(t11, 1);
  } }, { key: "getResource", value: function(e15, t11, n10) {
    var r10 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
    var o10 = void 0 !== r10.keySeparator ? r10.keySeparator : this.options.keySeparator;
    var a10 = void 0 !== r10.ignoreJSONStructure ? r10.ignoreJSONStructure : this.options.ignoreJSONStructure;
    var i10 = [e15, t11];
    n10 && "string" != typeof n10 && (i10 = i10.concat(n10)), n10 && "string" == typeof n10 && (i10 = i10.concat(o10 ? n10.split(o10) : n10)), e15.indexOf(".") > -1 && (i10 = e15.split("."));
    var s10 = WZ(this.data, i10);
    return s10 || !a10 || "string" != typeof n10 ? s10 : KZ(this.data && this.data[e15] && this.data[e15][t11], n10, o10);
  } }, { key: "addResource", value: function(e15, t11, n10, r10) {
    var o10 = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : { silent: false };
    var a10 = this.options.keySeparator;
    void 0 === a10 && (a10 = ".");
    var i10 = [e15, t11];
    n10 && (i10 = i10.concat(a10 ? n10.split(a10) : n10)), e15.indexOf(".") > -1 && (r10 = t11, t11 = (i10 = e15.split("."))[1]), this.addNamespaces(t11), $Z(this.data, i10, r10), o10.silent || this.emit("added", e15, t11, n10, r10);
  } }, { key: "addResources", value: function(e15, t11, n10) {
    var r10 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : { silent: false };
    for (var o10 in n10) "string" != typeof n10[o10] && "[object Array]" !== Object.prototype.toString.apply(n10[o10]) || this.addResource(e15, t11, o10, n10[o10], { silent: true });
    r10.silent || this.emit("added", e15, t11, n10);
  } }, { key: "addResourceBundle", value: function(e15, t11, n10, r10, o10) {
    var a10 = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : { silent: false };
    var i10 = [e15, t11];
    e15.indexOf(".") > -1 && (r10 = n10, n10 = t11, t11 = (i10 = e15.split("."))[1]), this.addNamespaces(t11);
    var s10 = WZ(this.data, i10) || {};
    r10 ? ZZ(s10, n10, o10) : s10 = IZ({}, s10, n10), $Z(this.data, i10, s10), a10.silent || this.emit("added", e15, t11, n10);
  } }, { key: "removeResourceBundle", value: function(e15, t11) {
    this.hasResourceBundle(e15, t11) && delete this.data[e15][t11], this.removeNamespaces(t11), this.emit("removed", e15, t11);
  } }, { key: "hasResourceBundle", value: function(e15, t11) {
    return void 0 !== this.getResource(e15, t11);
  } }, { key: "getResourceBundle", value: function(e15, t11) {
    return t11 || (t11 = this.options.defaultNS), "v1" === this.options.compatibilityAPI ? IZ({}, {}, this.getResource(e15, t11)) : this.getResource(e15, t11);
  } }, { key: "getDataByLanguage", value: function(e15) {
    return this.data[e15];
  } }, { key: "toJSON", value: function() {
    return this.data;
  } }]), t10;
}();
var JZ = { processors: {}, addPostProcessor: function(e14) {
  this.processors[e14.name] = e14;
}, handle: function(e14, t10, n10, r10, o10) {
  var a10 = this;
  return e14.forEach(function(e15) {
    a10.processors[e15] && (t10 = a10.processors[e15].process(t10, n10, r10, o10));
  }), t10;
} };
var QZ = {};
var eG = function(e14) {
  function t10(e15) {
    var n10;
    var r10 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    return to(this, t10), n10 = Qr(this, Xr(t10).call(this)), YZ && AZ.call(qr(n10)), function(e16, t11, n11) {
      e16.forEach(function(e17) {
        t11[e17] && (n11[e17] = t11[e17]);
      });
    }(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e15, qr(n10)), n10.options = r10, void 0 === n10.options.keySeparator && (n10.options.keySeparator = "."), n10.logger = RZ.create("translator"), n10;
  }
  return Kr(t10, AZ), oo(t10, [{ key: "changeLanguage", value: function(e15) {
    e15 && (this.language = e15);
  } }, { key: "exists", value: function(e15) {
    var t11 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : { interpolation: {} };
    if (null == e15) return false;
    var n10 = this.resolve(e15, t11);
    return n10 && void 0 !== n10.res;
  } }, { key: "extractFromKey", value: function(e15, t11) {
    var n10 = void 0 !== t11.nsSeparator ? t11.nsSeparator : this.options.nsSeparator;
    void 0 === n10 && (n10 = ":");
    var r10 = void 0 !== t11.keySeparator ? t11.keySeparator : this.options.keySeparator;
    var o10 = t11.ns || this.options.defaultNS;
    if (n10 && e15.indexOf(n10) > -1) {
      var a10 = e15.match(this.interpolator.nestingRegexp);
      if (a10 && a10.length > 0) return { key: e15, namespaces: o10 };
      var i10 = e15.split(n10);
      (n10 !== r10 || n10 === r10 && this.options.ns.indexOf(i10[0]) > -1) && (o10 = i10.shift()), e15 = i10.join(r10);
    }
    return "string" == typeof o10 && (o10 = [o10]), { key: e15, namespaces: o10 };
  } }, { key: "translate", value: function(e15, n10, r10) {
    var o10 = this;
    if ("object" !== Ue(n10) && this.options.overloadTranslationOptionHandler && (n10 = this.options.overloadTranslationOptionHandler(arguments)), n10 || (n10 = {}), null == e15) return "";
    Array.isArray(e15) || (e15 = [String(e15)]);
    var a10 = void 0 !== n10.keySeparator ? n10.keySeparator : this.options.keySeparator;
    var i10 = this.extractFromKey(e15[e15.length - 1], n10), s10 = i10.key, l10 = i10.namespaces;
    var c10 = l10[l10.length - 1];
    var u10 = n10.lng || this.language;
    var d10 = n10.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (u10 && "cimode" === u10.toLowerCase()) {
      if (d10) {
        var p10 = n10.nsSeparator || this.options.nsSeparator;
        return c10 + p10 + s10;
      }
      return s10;
    }
    var m10 = this.resolve(e15, n10);
    var h10 = m10 && m10.res;
    var f10 = m10 && m10.usedKey || s10;
    var g10 = m10 && m10.exactUsedKey || s10;
    var y10 = Object.prototype.toString.apply(h10);
    var v10 = void 0 !== n10.joinArrays ? n10.joinArrays : this.options.joinArrays;
    var b10 = !this.i18nFormat || this.i18nFormat.handleAsObject;
    if (b10 && h10 && ("string" != typeof h10 && "boolean" != typeof h10 && "number" != typeof h10) && ["[object Number]", "[object Function]", "[object RegExp]"].indexOf(y10) < 0 && ("string" != typeof v10 || "[object Array]" !== y10)) {
      if (!n10.returnObjects && !this.options.returnObjects) return this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!"), this.options.returnedObjectHandler ? this.options.returnedObjectHandler(f10, h10, IZ({}, n10, { ns: l10 })) : "key '".concat(s10, " (").concat(this.language, ")' returned an object instead of string.");
      if (a10) {
        var S10 = "[object Array]" === y10;
        var C10 = S10 ? [] : {};
        var x10 = S10 ? g10 : f10;
        for (var w10 in h10) if (Object.prototype.hasOwnProperty.call(h10, w10)) {
          var T10 = "".concat(x10).concat(a10).concat(w10);
          C10[w10] = this.translate(T10, IZ({}, n10, { joinArrays: false, ns: l10 })), C10[w10] === T10 && (C10[w10] = h10[w10]);
        }
        h10 = C10;
      }
    } else if (b10 && "string" == typeof v10 && "[object Array]" === y10) (h10 = h10.join(v10)) && (h10 = this.extendTranslation(h10, e15, n10, r10));
    else {
      var E10 = false;
      var F10 = false;
      var M10 = void 0 !== n10.count && "string" != typeof n10.count;
      var k10 = t10.hasDefaultValue(n10);
      var P10 = M10 ? this.pluralResolver.getSuffix(u10, n10.count) : "";
      var N10 = n10["defaultValue".concat(P10)] || n10.defaultValue;
      !this.isValidLookup(h10) && k10 && (E10 = true, h10 = N10), this.isValidLookup(h10) || (F10 = true, h10 = s10);
      var D10 = k10 && N10 !== h10 && this.options.updateMissing;
      if (F10 || E10 || D10) {
        if (this.logger.log(D10 ? "updateKey" : "missingKey", u10, c10, s10, D10 ? N10 : h10), a10) {
          var L10 = this.resolve(s10, IZ({}, n10, { keySeparator: false }));
          L10 && L10.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        var H10 = [];
        var I10 = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n10.lng || this.language);
        if ("fallback" === this.options.saveMissingTo && I10 && I10[0]) for (var _10 = 0; _10 < I10.length; _10++) H10.push(I10[_10]);
        else "all" === this.options.saveMissingTo ? H10 = this.languageUtils.toResolveHierarchy(n10.lng || this.language) : H10.push(n10.lng || this.language);
        var V10 = function(e16, t11, r11) {
          o10.options.missingKeyHandler ? o10.options.missingKeyHandler(e16, c10, t11, D10 ? r11 : h10, D10, n10) : o10.backendConnector && o10.backendConnector.saveMissing && o10.backendConnector.saveMissing(e16, c10, t11, D10 ? r11 : h10, D10, n10), o10.emit("missingKey", e16, c10, t11, h10);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && M10 ? H10.forEach(function(e16) {
          o10.pluralResolver.getSuffixes(e16).forEach(function(t11) {
            V10([e16], s10 + t11, n10["defaultValue".concat(t11)] || N10);
          });
        }) : V10(H10, s10, N10));
      }
      h10 = this.extendTranslation(h10, e15, n10, m10, r10), F10 && h10 === s10 && this.options.appendNamespaceToMissingKey && (h10 = "".concat(c10, ":").concat(s10)), (F10 || E10) && this.options.parseMissingKeyHandler && (h10 = this.options.parseMissingKeyHandler(h10));
    }
    return h10;
  } }, { key: "extendTranslation", value: function(e15, t11, n10, r10, o10) {
    var a10 = this;
    if (this.i18nFormat && this.i18nFormat.parse) e15 = this.i18nFormat.parse(e15, n10, r10.usedLng, r10.usedNS, r10.usedKey, { resolved: r10 });
    else if (!n10.skipInterpolation) {
      n10.interpolation && this.interpolator.init(IZ({}, n10, { interpolation: IZ({}, this.options.interpolation, n10.interpolation) }));
      var i10 = n10.interpolation && n10.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
      var s10;
      if (i10) {
        var l10 = e15.match(this.interpolator.nestingRegexp);
        s10 = l10 && l10.length;
      }
      var c10 = n10.replace && "string" != typeof n10.replace ? n10.replace : n10;
      if (this.options.interpolation.defaultVariables && (c10 = IZ({}, this.options.interpolation.defaultVariables, c10)), e15 = this.interpolator.interpolate(e15, c10, n10.lng || this.language, n10), i10) {
        var u10 = e15.match(this.interpolator.nestingRegexp);
        s10 < (u10 && u10.length) && (n10.nest = false);
      }
      false !== n10.nest && (e15 = this.interpolator.nest(e15, function() {
        for (var e16 = arguments.length, r11 = new Array(e16), i11 = 0; i11 < e16; i11++) r11[i11] = arguments[i11];
        return o10 && o10[0] === r11[0] && !n10.context ? (a10.logger.warn("It seems you are nesting recursively key: ".concat(r11[0], " in key: ").concat(t11[0])), null) : a10.translate.apply(a10, r11.concat([t11]));
      }, n10)), n10.interpolation && this.interpolator.reset();
    }
    var d10 = n10.postProcess || this.options.postProcess;
    var p10 = "string" == typeof d10 ? [d10] : d10;
    return null != e15 && p10 && p10.length && false !== n10.applyPostProcessor && (e15 = JZ.handle(p10, e15, t11, this.options && this.options.postProcessPassResolved ? IZ({ i18nResolved: r10 }, n10) : n10, this)), e15;
  } }, { key: "resolve", value: function(e15) {
    var t11 = this;
    var n10 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    var r10;
    var o10;
    var a10;
    var i10;
    var s10;
    return "string" == typeof e15 && (e15 = [e15]), e15.forEach(function(e16) {
      if (!t11.isValidLookup(r10)) {
        var l10 = t11.extractFromKey(e16, n10);
        var c10 = l10.key;
        o10 = c10;
        var u10 = l10.namespaces;
        t11.options.fallbackNS && (u10 = u10.concat(t11.options.fallbackNS));
        var d10 = void 0 !== n10.count && "string" != typeof n10.count;
        var p10 = void 0 !== n10.context && ("string" == typeof n10.context || "number" == typeof n10.context) && "" !== n10.context;
        var m10 = n10.lngs ? n10.lngs : t11.languageUtils.toResolveHierarchy(n10.lng || t11.language, n10.fallbackLng);
        u10.forEach(function(e17) {
          t11.isValidLookup(r10) || (s10 = e17, !QZ["".concat(m10[0], "-").concat(e17)] && t11.utils && t11.utils.hasLoadedNamespace && !t11.utils.hasLoadedNamespace(s10) && (QZ["".concat(m10[0], "-").concat(e17)] = true, t11.logger.warn('key "'.concat(o10, '" for languages "').concat(m10.join(", "), `" won't get resolved as namespace "`).concat(s10, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), m10.forEach(function(o11) {
            if (!t11.isValidLookup(r10)) {
              i10 = o11;
              var s11 = c10;
              var l11 = [s11];
              var u11;
              if (t11.i18nFormat && t11.i18nFormat.addLookupKeys) t11.i18nFormat.addLookupKeys(l11, c10, o11, e17, n10);
              else d10 && (u11 = t11.pluralResolver.getSuffix(o11, n10.count)), d10 && p10 && l11.push(s11 + u11), p10 && l11.push(s11 += "".concat(t11.options.contextSeparator).concat(n10.context)), d10 && l11.push(s11 += u11);
              var m11;
              for (; m11 = l11.pop(); ) t11.isValidLookup(r10) || (a10 = m11, r10 = t11.getResource(o11, e17, m11, n10));
            }
          }));
        });
      }
    }), { res: r10, usedKey: o10, exactUsedKey: a10, usedLng: i10, usedNS: s10 };
  } }, { key: "isValidLookup", value: function(e15) {
    return !(void 0 === e15 || !this.options.returnNull && null === e15 || !this.options.returnEmptyString && "" === e15);
  } }, { key: "getResource", value: function(e15, t11, n10) {
    var r10 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e15, t11, n10, r10) : this.resourceStore.getResource(e15, t11, n10, r10);
  } }], [{ key: "hasDefaultValue", value: function(e15) {
    var t11 = "defaultValue";
    for (var n10 in e15) if (Object.prototype.hasOwnProperty.call(e15, n10) && t11 === n10.substring(0, 12) && void 0 !== e15[n10]) return true;
    return false;
  } }]), t10;
}();
function tG(e14) {
  return e14.charAt(0).toUpperCase() + e14.slice(1);
}
var nG = function() {
  function e14(t10) {
    to(this, e14), this.options = t10, this.whitelist = this.options.supportedLngs || false, this.supportedLngs = this.options.supportedLngs || false, this.logger = RZ.create("languageUtils");
  }
  return oo(e14, [{ key: "getScriptPartFromCode", value: function(e15) {
    if (!e15 || e15.indexOf("-") < 0) return null;
    var t10 = e15.split("-");
    return 2 === t10.length ? null : (t10.pop(), "x" === t10[t10.length - 1].toLowerCase() ? null : this.formatLanguageCode(t10.join("-")));
  } }, { key: "getLanguagePartFromCode", value: function(e15) {
    if (!e15 || e15.indexOf("-") < 0) return e15;
    var t10 = e15.split("-");
    return this.formatLanguageCode(t10[0]);
  } }, { key: "formatLanguageCode", value: function(e15) {
    if ("string" == typeof e15 && e15.indexOf("-") > -1) {
      var t10 = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      var n10 = e15.split("-");
      return this.options.lowerCaseLng ? n10 = n10.map(function(e16) {
        return e16.toLowerCase();
      }) : 2 === n10.length ? (n10[0] = n10[0].toLowerCase(), n10[1] = n10[1].toUpperCase(), t10.indexOf(n10[1].toLowerCase()) > -1 && (n10[1] = tG(n10[1].toLowerCase()))) : 3 === n10.length && (n10[0] = n10[0].toLowerCase(), 2 === n10[1].length && (n10[1] = n10[1].toUpperCase()), "sgn" !== n10[0] && 2 === n10[2].length && (n10[2] = n10[2].toUpperCase()), t10.indexOf(n10[1].toLowerCase()) > -1 && (n10[1] = tG(n10[1].toLowerCase())), t10.indexOf(n10[2].toLowerCase()) > -1 && (n10[2] = tG(n10[2].toLowerCase()))), n10.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e15.toLowerCase() : e15;
  } }, { key: "isWhitelisted", value: function(e15) {
    return this.logger.deprecate("languageUtils.isWhitelisted", `function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it's usage asap.`), this.isSupportedCode(e15);
  } }, { key: "isSupportedCode", value: function(e15) {
    return ("languageOnly" === this.options.load || this.options.nonExplicitSupportedLngs) && (e15 = this.getLanguagePartFromCode(e15)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e15) > -1;
  } }, { key: "getBestMatchFromCodes", value: function(e15) {
    var t10 = this;
    return e15 ? (e15.forEach(function(e16) {
      if (!n10) {
        var r10 = t10.formatLanguageCode(e16);
        t10.options.supportedLngs && !t10.isSupportedCode(r10) || (n10 = r10);
      }
    }), !n10 && this.options.supportedLngs && e15.forEach(function(e16) {
      if (!n10) {
        var r10 = t10.getLanguagePartFromCode(e16);
        if (t10.isSupportedCode(r10)) return n10 = r10;
        n10 = t10.options.supportedLngs.find(function(e17) {
          if (0 === e17.indexOf(r10)) return e17;
        });
      }
    }), n10 || (n10 = this.getFallbackCodes(this.options.fallbackLng)[0]), n10) : null;
    var n10;
  } }, { key: "getFallbackCodes", value: function(e15, t10) {
    if (!e15) return [];
    if ("function" == typeof e15 && (e15 = e15(t10)), "string" == typeof e15 && (e15 = [e15]), "[object Array]" === Object.prototype.toString.apply(e15)) return e15;
    if (!t10) return e15.default || [];
    var n10 = e15[t10];
    return n10 || (n10 = e15[this.getScriptPartFromCode(t10)]), n10 || (n10 = e15[this.formatLanguageCode(t10)]), n10 || (n10 = e15[this.getLanguagePartFromCode(t10)]), n10 || (n10 = e15.default), n10 || [];
  } }, { key: "toResolveHierarchy", value: function(e15, t10) {
    var n10 = this;
    var r10 = this.getFallbackCodes(t10 || this.options.fallbackLng || [], e15);
    var o10 = [];
    var a10 = function(e16) {
      e16 && (n10.isSupportedCode(e16) ? o10.push(e16) : n10.logger.warn("rejecting language code not found in supportedLngs: ".concat(e16)));
    };
    return "string" == typeof e15 && e15.indexOf("-") > -1 ? ("languageOnly" !== this.options.load && a10(this.formatLanguageCode(e15)), "languageOnly" !== this.options.load && "currentOnly" !== this.options.load && a10(this.getScriptPartFromCode(e15)), "currentOnly" !== this.options.load && a10(this.getLanguagePartFromCode(e15))) : "string" == typeof e15 && a10(this.formatLanguageCode(e15)), r10.forEach(function(e16) {
      o10.indexOf(e16) < 0 && a10(n10.formatLanguageCode(e16));
    }), o10;
  } }]), e14;
}();
var rG = [{ lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"], nr: [1, 2], fc: 1 }, { lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"], nr: [1, 2], fc: 2 }, { lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"], nr: [1], fc: 3 }, { lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"], nr: [1, 2, 5], fc: 4 }, { lngs: ["ar"], nr: [0, 1, 2, 3, 11, 100], fc: 5 }, { lngs: ["cs", "sk"], nr: [1, 2, 5], fc: 6 }, { lngs: ["csb", "pl"], nr: [1, 2, 5], fc: 7 }, { lngs: ["cy"], nr: [1, 2, 3, 8], fc: 8 }, { lngs: ["fr"], nr: [1, 2], fc: 9 }, { lngs: ["ga"], nr: [1, 2, 3, 7, 11], fc: 10 }, { lngs: ["gd"], nr: [1, 2, 3, 20], fc: 11 }, { lngs: ["is"], nr: [1, 2], fc: 12 }, { lngs: ["jv"], nr: [0, 1], fc: 13 }, { lngs: ["kw"], nr: [1, 2, 3, 4], fc: 14 }, { lngs: ["lt"], nr: [1, 2, 10], fc: 15 }, { lngs: ["lv"], nr: [1, 2, 0], fc: 16 }, { lngs: ["mk"], nr: [1, 2], fc: 17 }, { lngs: ["mnk"], nr: [0, 1, 2], fc: 18 }, { lngs: ["mt"], nr: [1, 2, 11, 20], fc: 19 }, { lngs: ["or"], nr: [2, 1], fc: 2 }, { lngs: ["ro"], nr: [1, 2, 20], fc: 20 }, { lngs: ["sl"], nr: [5, 1, 2, 3], fc: 21 }, { lngs: ["he", "iw"], nr: [1, 2, 20, 21], fc: 22 }];
var oG = { 1: function(e14) {
  return Number(e14 > 1);
}, 2: function(e14) {
  return Number(1 != e14);
}, 3: function(e14) {
  return 0;
}, 4: function(e14) {
  return Number(e14 % 10 == 1 && e14 % 100 != 11 ? 0 : e14 % 10 >= 2 && e14 % 10 <= 4 && (e14 % 100 < 10 || e14 % 100 >= 20) ? 1 : 2);
}, 5: function(e14) {
  return Number(0 == e14 ? 0 : 1 == e14 ? 1 : 2 == e14 ? 2 : e14 % 100 >= 3 && e14 % 100 <= 10 ? 3 : e14 % 100 >= 11 ? 4 : 5);
}, 6: function(e14) {
  return Number(1 == e14 ? 0 : e14 >= 2 && e14 <= 4 ? 1 : 2);
}, 7: function(e14) {
  return Number(1 == e14 ? 0 : e14 % 10 >= 2 && e14 % 10 <= 4 && (e14 % 100 < 10 || e14 % 100 >= 20) ? 1 : 2);
}, 8: function(e14) {
  return Number(1 == e14 ? 0 : 2 == e14 ? 1 : 8 != e14 && 11 != e14 ? 2 : 3);
}, 9: function(e14) {
  return Number(e14 >= 2);
}, 10: function(e14) {
  return Number(1 == e14 ? 0 : 2 == e14 ? 1 : e14 < 7 ? 2 : e14 < 11 ? 3 : 4);
}, 11: function(e14) {
  return Number(1 == e14 || 11 == e14 ? 0 : 2 == e14 || 12 == e14 ? 1 : e14 > 2 && e14 < 20 ? 2 : 3);
}, 12: function(e14) {
  return Number(e14 % 10 != 1 || e14 % 100 == 11);
}, 13: function(e14) {
  return Number(0 !== e14);
}, 14: function(e14) {
  return Number(1 == e14 ? 0 : 2 == e14 ? 1 : 3 == e14 ? 2 : 3);
}, 15: function(e14) {
  return Number(e14 % 10 == 1 && e14 % 100 != 11 ? 0 : e14 % 10 >= 2 && (e14 % 100 < 10 || e14 % 100 >= 20) ? 1 : 2);
}, 16: function(e14) {
  return Number(e14 % 10 == 1 && e14 % 100 != 11 ? 0 : 0 !== e14 ? 1 : 2);
}, 17: function(e14) {
  return Number(1 == e14 || e14 % 10 == 1 && e14 % 100 != 11 ? 0 : 1);
}, 18: function(e14) {
  return Number(0 == e14 ? 0 : 1 == e14 ? 1 : 2);
}, 19: function(e14) {
  return Number(1 == e14 ? 0 : 0 == e14 || e14 % 100 > 1 && e14 % 100 < 11 ? 1 : e14 % 100 > 10 && e14 % 100 < 20 ? 2 : 3);
}, 20: function(e14) {
  return Number(1 == e14 ? 0 : 0 == e14 || e14 % 100 > 0 && e14 % 100 < 20 ? 1 : 2);
}, 21: function(e14) {
  return Number(e14 % 100 == 1 ? 1 : e14 % 100 == 2 ? 2 : e14 % 100 == 3 || e14 % 100 == 4 ? 3 : 0);
}, 22: function(e14) {
  return Number(1 == e14 ? 0 : 2 == e14 ? 1 : (e14 < 0 || e14 > 10) && e14 % 10 == 0 ? 2 : 3);
} };
var aG = function() {
  function e14(t10) {
    var n10 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    var r10;
    to(this, e14), this.languageUtils = t10, this.options = n10, this.logger = RZ.create("pluralResolver"), this.rules = (r10 = {}, rG.forEach(function(e15) {
      e15.lngs.forEach(function(t11) {
        r10[t11] = { numbers: e15.nr, plurals: oG[e15.fc] };
      });
    }), r10);
  }
  return oo(e14, [{ key: "addRule", value: function(e15, t10) {
    this.rules[e15] = t10;
  } }, { key: "getRule", value: function(e15) {
    return this.rules[e15] || this.rules[this.languageUtils.getLanguagePartFromCode(e15)];
  } }, { key: "needsPlural", value: function(e15) {
    var t10 = this.getRule(e15);
    return t10 && t10.numbers.length > 1;
  } }, { key: "getPluralFormsOfKey", value: function(e15, t10) {
    return this.getSuffixes(e15).map(function(e16) {
      return t10 + e16;
    });
  } }, { key: "getSuffixes", value: function(e15) {
    var t10 = this;
    var n10 = this.getRule(e15);
    return n10 ? n10.numbers.map(function(n11) {
      return t10.getSuffix(e15, n11);
    }) : [];
  } }, { key: "getSuffix", value: function(e15, t10) {
    var n10 = this;
    var r10 = this.getRule(e15);
    if (r10) {
      var o10 = r10.noAbs ? r10.plurals(t10) : r10.plurals(Math.abs(t10));
      var a10 = r10.numbers[o10];
      this.options.simplifyPluralSuffix && 2 === r10.numbers.length && 1 === r10.numbers[0] && (2 === a10 ? a10 = "plural" : 1 === a10 && (a10 = ""));
      var i10 = function() {
        return n10.options.prepend && a10.toString() ? n10.options.prepend + a10.toString() : a10.toString();
      };
      return "v1" === this.options.compatibilityJSON ? 1 === a10 ? "" : "number" == typeof a10 ? "_plural_".concat(a10.toString()) : i10() : "v2" === this.options.compatibilityJSON || this.options.simplifyPluralSuffix && 2 === r10.numbers.length && 1 === r10.numbers[0] ? i10() : this.options.prepend && o10.toString() ? this.options.prepend + o10.toString() : o10.toString();
    }
    return this.logger.warn("no plural rule found for: ".concat(e15)), "";
  } }]), e14;
}();
var iG = function() {
  function e14() {
    var t10 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    to(this, e14), this.logger = RZ.create("interpolator"), this.options = t10, this.format = t10.interpolation && t10.interpolation.format || function(e15) {
      return e15;
    }, this.init(t10);
  }
  return oo(e14, [{ key: "init", value: function() {
    var e15 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    e15.interpolation || (e15.interpolation = { escapeValue: true });
    var t10 = e15.interpolation;
    this.escape = void 0 !== t10.escape ? t10.escape : qZ, this.escapeValue = void 0 === t10.escapeValue || t10.escapeValue, this.useRawValueToEscape = void 0 !== t10.useRawValueToEscape && t10.useRawValueToEscape, this.prefix = t10.prefix ? GZ(t10.prefix) : t10.prefixEscaped || "{{", this.suffix = t10.suffix ? GZ(t10.suffix) : t10.suffixEscaped || "}}", this.formatSeparator = t10.formatSeparator ? t10.formatSeparator : t10.formatSeparator || ",", this.unescapePrefix = t10.unescapeSuffix ? "" : t10.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : t10.unescapeSuffix || "", this.nestingPrefix = t10.nestingPrefix ? GZ(t10.nestingPrefix) : t10.nestingPrefixEscaped || GZ("$t("), this.nestingSuffix = t10.nestingSuffix ? GZ(t10.nestingSuffix) : t10.nestingSuffixEscaped || GZ(")"), this.nestingOptionsSeparator = t10.nestingOptionsSeparator ? t10.nestingOptionsSeparator : t10.nestingOptionsSeparator || ",", this.maxReplaces = t10.maxReplaces ? t10.maxReplaces : 1e3, this.alwaysFormat = void 0 !== t10.alwaysFormat && t10.alwaysFormat, this.resetRegExp();
  } }, { key: "reset", value: function() {
    this.options && this.init(this.options);
  } }, { key: "resetRegExp", value: function() {
    var e15 = "".concat(this.prefix, "(.+?)").concat(this.suffix);
    this.regexp = new RegExp(e15, "g");
    var t10 = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
    this.regexpUnescape = new RegExp(t10, "g");
    var n10 = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
    this.nestingRegexp = new RegExp(n10, "g");
  } }, { key: "interpolate", value: function(e15, t10, n10, r10) {
    var o10 = this;
    var a10;
    var i10;
    var s10;
    var l10 = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
    function c10(e16) {
      return e16.replace(/\$/g, "$$$$");
    }
    var u10 = function(e16) {
      if (e16.indexOf(o10.formatSeparator) < 0) {
        var a11 = jZ(t10, l10, e16);
        return o10.alwaysFormat ? o10.format(a11, void 0, n10, IZ({}, r10, t10, { interpolationkey: e16 })) : a11;
      }
      var i11 = e16.split(o10.formatSeparator);
      var s11 = i11.shift().trim();
      var c11 = i11.join(o10.formatSeparator).trim();
      return o10.format(jZ(t10, l10, s11), c11, n10, IZ({}, r10, t10, { interpolationkey: s11 }));
    };
    this.resetRegExp();
    var d10 = r10 && r10.missingInterpolationHandler || this.options.missingInterpolationHandler;
    var p10 = r10 && r10.interpolation && r10.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
    return [{ regex: this.regexpUnescape, safeValue: function(e16) {
      return c10(e16);
    } }, { regex: this.regexp, safeValue: function(e16) {
      return o10.escapeValue ? c10(o10.escape(e16)) : c10(e16);
    } }].forEach(function(t11) {
      for (s10 = 0; a10 = t11.regex.exec(e15); ) {
        if (void 0 === (i10 = u10(a10[1].trim()))) if ("function" == typeof d10) {
          var n11 = d10(e15, a10, r10);
          i10 = "string" == typeof n11 ? n11 : "";
        } else {
          if (p10) {
            i10 = a10[0];
            continue;
          }
          o10.logger.warn("missed to pass in variable ".concat(a10[1], " for interpolating ").concat(e15)), i10 = "";
        }
        else "string" == typeof i10 || o10.useRawValueToEscape || (i10 = BZ(i10));
        var l11 = t11.safeValue(i10);
        if (e15 = e15.replace(a10[0], l11), p10 ? (t11.regex.lastIndex += l11.length, t11.regex.lastIndex -= a10[0].length) : t11.regex.lastIndex = 0, ++s10 >= o10.maxReplaces) break;
      }
    }), e15;
  } }, { key: "nest", value: function(e15, t10) {
    var n10 = this;
    var r10 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    var o10;
    var a10;
    var i10 = IZ({}, r10);
    function s10(e16, t11) {
      var n11 = this.nestingOptionsSeparator;
      if (e16.indexOf(n11) < 0) return e16;
      var r11 = e16.split(new RegExp("".concat(n11, "[ ]*{")));
      var o11 = "{".concat(r11[1]);
      e16 = r11[0], o11 = (o11 = this.interpolate(o11, i10)).replace(/'/g, '"');
      try {
        i10 = JSON.parse(o11), t11 && (i10 = IZ({}, t11, i10));
      } catch (t12) {
        return this.logger.warn("failed parsing options string in nesting for key ".concat(e16), t12), "".concat(e16).concat(n11).concat(o11);
      }
      return delete i10.defaultValue, e16;
    }
    for (i10.applyPostProcessor = false, delete i10.defaultValue; o10 = this.nestingRegexp.exec(e15); ) {
      var l10 = [];
      var c10 = false;
      if (-1 !== o10[0].indexOf(this.formatSeparator) && !/{.*}/.test(o10[1])) {
        var u10 = o10[1].split(this.formatSeparator).map(function(e16) {
          return e16.trim();
        });
        o10[1] = u10.shift(), l10 = u10, c10 = true;
      }
      if ((a10 = t10(s10.call(this, o10[1].trim(), i10), i10)) && o10[0] === e15 && "string" != typeof a10) return a10;
      "string" != typeof a10 && (a10 = BZ(a10)), a10 || (this.logger.warn("missed to resolve ".concat(o10[1], " for nesting ").concat(e15)), a10 = ""), c10 && (a10 = l10.reduce(function(e16, t11) {
        return n10.format(e16, t11, r10.lng, IZ({}, r10, { interpolationkey: o10[1].trim() }));
      }, a10.trim())), e15 = e15.replace(o10[0], a10), this.regexp.lastIndex = 0;
    }
    return e15;
  } }]), e14;
}();
var sG = function(e14) {
  function t10(e15, n10, r10) {
    var o10;
    var a10 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
    return to(this, t10), o10 = Qr(this, Xr(t10).call(this)), YZ && AZ.call(qr(o10)), o10.backend = e15, o10.store = n10, o10.services = r10, o10.languageUtils = r10.languageUtils, o10.options = a10, o10.logger = RZ.create("backendConnector"), o10.state = {}, o10.queue = [], o10.backend && o10.backend.init && o10.backend.init(r10, a10.backend, a10), o10;
  }
  return Kr(t10, AZ), oo(t10, [{ key: "queueLoad", value: function(e15, t11, n10, r10) {
    var o10 = this;
    var a10 = [];
    var i10 = [];
    var s10 = [];
    var l10 = [];
    return e15.forEach(function(e16) {
      var r11 = true;
      t11.forEach(function(t12) {
        var s11 = "".concat(e16, "|").concat(t12);
        !n10.reload && o10.store.hasResourceBundle(e16, t12) ? o10.state[s11] = 2 : o10.state[s11] < 0 || (1 === o10.state[s11] ? i10.indexOf(s11) < 0 && i10.push(s11) : (o10.state[s11] = 1, r11 = false, i10.indexOf(s11) < 0 && i10.push(s11), a10.indexOf(s11) < 0 && a10.push(s11), l10.indexOf(t12) < 0 && l10.push(t12)));
      }), r11 || s10.push(e16);
    }), (a10.length || i10.length) && this.queue.push({ pending: i10, loaded: {}, errors: [], callback: r10 }), { toLoad: a10, pending: i10, toLoadLanguages: s10, toLoadNamespaces: l10 };
  } }, { key: "loaded", value: function(e15, t11, n10) {
    var r10 = e15.split("|");
    var o10 = r10[0];
    var a10 = r10[1];
    t11 && this.emit("failedLoading", o10, a10, t11), n10 && this.store.addResourceBundle(o10, a10, n10), this.state[e15] = t11 ? -1 : 2;
    var i10 = {};
    this.queue.forEach(function(n11) {
      !function(e16, t12, n12, r11) {
        var o11 = zZ(e16, t12, Object), a11 = o11.obj, i11 = o11.k;
        a11[i11] = a11[i11] || [], r11 && (a11[i11] = a11[i11].concat(n12)), r11 || a11[i11].push(n12);
      }(n11.loaded, [o10], a10), function(e16, t12) {
        var n12 = e16.indexOf(t12);
        for (; -1 !== n12; ) e16.splice(n12, 1), n12 = e16.indexOf(t12);
      }(n11.pending, e15), t11 && n11.errors.push(t11), 0 !== n11.pending.length || n11.done || (Object.keys(n11.loaded).forEach(function(e16) {
        i10[e16] || (i10[e16] = []), n11.loaded[e16].length && n11.loaded[e16].forEach(function(t12) {
          i10[e16].indexOf(t12) < 0 && i10[e16].push(t12);
        });
      }), n11.done = true, n11.errors.length ? n11.callback(n11.errors) : n11.callback());
    }), this.emit("loaded", i10), this.queue = this.queue.filter(function(e16) {
      return !e16.done;
    });
  } }, { key: "read", value: function(e15, t11, n10) {
    var r10 = this;
    var o10 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
    var a10 = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 350;
    var i10 = arguments.length > 5 ? arguments[5] : void 0;
    return e15.length ? this.backend[n10](e15, t11, function(s10, l10) {
      s10 && l10 && o10 < 5 ? setTimeout(function() {
        r10.read.call(r10, e15, t11, n10, o10 + 1, 2 * a10, i10);
      }, a10) : i10(s10, l10);
    }) : i10(null, {});
  } }, { key: "prepareLoading", value: function(e15, t11) {
    var n10 = this;
    var r10 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    var o10 = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend) return this.logger.warn("No backend was added via i18next.use. Will not load resources."), o10 && o10();
    "string" == typeof e15 && (e15 = this.languageUtils.toResolveHierarchy(e15)), "string" == typeof t11 && (t11 = [t11]);
    var a10 = this.queueLoad(e15, t11, r10, o10);
    if (!a10.toLoad.length) return a10.pending.length || o10(), null;
    a10.toLoad.forEach(function(e16) {
      n10.loadOne(e16);
    });
  } }, { key: "load", value: function(e15, t11, n10) {
    this.prepareLoading(e15, t11, {}, n10);
  } }, { key: "reload", value: function(e15, t11, n10) {
    this.prepareLoading(e15, t11, { reload: true }, n10);
  } }, { key: "loadOne", value: function(e15) {
    var t11 = this;
    var n10 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
    var r10 = e15.split("|");
    var o10 = r10[0];
    var a10 = r10[1];
    this.read(o10, a10, "read", void 0, void 0, function(r11, i10) {
      r11 && t11.logger.warn("".concat(n10, "loading namespace ").concat(a10, " for language ").concat(o10, " failed"), r11), !r11 && i10 && t11.logger.log("".concat(n10, "loaded namespace ").concat(a10, " for language ").concat(o10), i10), t11.loaded(e15, r11, i10);
    });
  } }, { key: "saveMissing", value: function(e15, t11, n10, r10, o10) {
    var a10 = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {};
    this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(t11) ? this.logger.warn('did not save key "'.concat(n10, '" as the namespace "').concat(t11, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!") : null != n10 && "" !== n10 && (this.backend && this.backend.create && this.backend.create(e15, t11, n10, r10, null, IZ({}, a10, { isUpdate: o10 })), e15 && e15[0] && this.store.addResource(e15[0], t11, n10, r10));
  } }]), t10;
}();
function lG(e14) {
  return "string" == typeof e14.ns && (e14.ns = [e14.ns]), "string" == typeof e14.fallbackLng && (e14.fallbackLng = [e14.fallbackLng]), "string" == typeof e14.fallbackNS && (e14.fallbackNS = [e14.fallbackNS]), e14.whitelist && (e14.whitelist && e14.whitelist.indexOf("cimode") < 0 && (e14.whitelist = e14.whitelist.concat(["cimode"])), e14.supportedLngs = e14.whitelist), e14.nonExplicitWhitelist && (e14.nonExplicitSupportedLngs = e14.nonExplicitWhitelist), e14.supportedLngs && e14.supportedLngs.indexOf("cimode") < 0 && (e14.supportedLngs = e14.supportedLngs.concat(["cimode"])), e14;
}
function cG() {
}
var uG = function(e14) {
  function t10() {
    var e15;
    var n10 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    var r10 = arguments.length > 1 ? arguments[1] : void 0;
    if (to(this, t10), e15 = Qr(this, Xr(t10).call(this)), YZ && AZ.call(qr(e15)), e15.options = lG(n10), e15.services = {}, e15.logger = RZ, e15.modules = { external: [] }, r10 && !e15.isInitialized && !n10.isClone) {
      if (!e15.options.initImmediate) return e15.init(n10, r10), Qr(e15, qr(e15));
      setTimeout(function() {
        e15.init(n10, r10);
      }, 0);
    }
    return e15;
  }
  return Kr(t10, AZ), oo(t10, [{ key: "init", value: function() {
    var e15 = this;
    var t11 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    var n10 = arguments.length > 1 ? arguments[1] : void 0;
    function r10(e16) {
      return e16 ? "function" == typeof e16 ? new e16() : e16 : null;
    }
    if ("function" == typeof t11 && (n10 = t11, t11 = {}), t11.whitelist && !t11.supportedLngs && this.logger.deprecate("whitelist", 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.'), t11.nonExplicitWhitelist && !t11.nonExplicitSupportedLngs && this.logger.deprecate("whitelist", 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.'), this.options = IZ({}, { debug: false, initImmediate: true, ns: ["translation"], defaultNS: ["translation"], fallbackLng: ["dev"], fallbackNS: false, whitelist: false, nonExplicitWhitelist: false, supportedLngs: false, nonExplicitSupportedLngs: false, load: "all", preload: false, simplifyPluralSuffix: true, keySeparator: ".", nsSeparator: ":", pluralSeparator: "_", contextSeparator: "_", partialBundledLanguages: false, saveMissing: false, updateMissing: false, saveMissingTo: "fallback", saveMissingPlurals: true, missingKeyHandler: false, missingInterpolationHandler: false, postProcess: false, postProcessPassResolved: false, returnNull: true, returnEmptyString: true, returnObjects: false, joinArrays: false, returnedObjectHandler: false, parseMissingKeyHandler: false, appendNamespaceToMissingKey: false, appendNamespaceToCIMode: false, overloadTranslationOptionHandler: function(e16) {
      var t12 = {};
      if ("object" === Ue(e16[1]) && (t12 = e16[1]), "string" == typeof e16[1] && (t12.defaultValue = e16[1]), "string" == typeof e16[2] && (t12.tDescription = e16[2]), "object" === Ue(e16[2]) || "object" === Ue(e16[3])) {
        var n11 = e16[3] || e16[2];
        Object.keys(n11).forEach(function(e17) {
          t12[e17] = n11[e17];
        });
      }
      return t12;
    }, interpolation: { escapeValue: true, format: function(e16, t12, n11, r11) {
      return e16;
    }, prefix: "{{", suffix: "}}", formatSeparator: ",", unescapePrefix: "-", nestingPrefix: "$t(", nestingSuffix: ")", nestingOptionsSeparator: ",", maxReplaces: 1e3, skipOnVariables: false } }, this.options, lG(t11)), this.format = this.options.interpolation.format, n10 || (n10 = cG), !this.options.isClone) {
      this.modules.logger ? RZ.init(r10(this.modules.logger), this.options) : RZ.init(null, this.options);
      var o10 = new nG(this.options);
      this.store = new XZ(this.options.resources, this.options);
      var a10 = this.services;
      a10.logger = RZ, a10.resourceStore = this.store, a10.languageUtils = o10, a10.pluralResolver = new aG(o10, { prepend: this.options.pluralSeparator, compatibilityJSON: this.options.compatibilityJSON, simplifyPluralSuffix: this.options.simplifyPluralSuffix }), a10.interpolator = new iG(this.options), a10.utils = { hasLoadedNamespace: this.hasLoadedNamespace.bind(this) }, a10.backendConnector = new sG(r10(this.modules.backend), a10.resourceStore, a10, this.options), a10.backendConnector.on("*", function(t12) {
        for (var n11 = arguments.length, r11 = new Array(n11 > 1 ? n11 - 1 : 0), o11 = 1; o11 < n11; o11++) r11[o11 - 1] = arguments[o11];
        e15.emit.apply(e15, [t12].concat(r11));
      }), this.modules.languageDetector && (a10.languageDetector = r10(this.modules.languageDetector), a10.languageDetector.init(a10, this.options.detection, this.options)), this.modules.i18nFormat && (a10.i18nFormat = r10(this.modules.i18nFormat), a10.i18nFormat.init && a10.i18nFormat.init(this)), this.translator = new eG(this.services, this.options), this.translator.on("*", function(t12) {
        for (var n11 = arguments.length, r11 = new Array(n11 > 1 ? n11 - 1 : 0), o11 = 1; o11 < n11; o11++) r11[o11 - 1] = arguments[o11];
        e15.emit.apply(e15, [t12].concat(r11));
      }), this.modules.external.forEach(function(t12) {
        t12.init && t12.init(e15);
      });
    }
    if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      var i10 = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      i10.length > 0 && "dev" !== i10[0] && (this.options.lng = i10[0]);
    }
    this.services.languageDetector || this.options.lng || this.logger.warn("init: no languageDetector is used and no lng is defined");
    ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach(function(t12) {
      e15[t12] = function() {
        var n11;
        return (n11 = e15.store)[t12].apply(n11, arguments);
      };
    });
    ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach(function(t12) {
      e15[t12] = function() {
        var n11;
        return (n11 = e15.store)[t12].apply(n11, arguments), e15;
      };
    });
    var s10 = OZ();
    var l10 = function() {
      var t12 = function(t13, r11) {
        e15.isInitialized && !e15.initializedStoreOnce && e15.logger.warn("init: i18next is already initialized. You should call init just once!"), e15.isInitialized = true, e15.options.isClone || e15.logger.log("initialized", e15.options), e15.emit("initialized", e15.options), s10.resolve(r11), n10(t13, r11);
      };
      if (e15.languages && "v1" !== e15.options.compatibilityAPI && !e15.isInitialized) return t12(null, e15.t.bind(e15));
      e15.changeLanguage(e15.options.lng, t12);
    };
    return this.options.resources || !this.options.initImmediate ? l10() : setTimeout(l10, 0), s10;
  } }, { key: "loadResources", value: function(e15) {
    var t11 = this;
    var n10 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : cG;
    var r10 = "string" == typeof e15 ? e15 : this.language;
    if ("function" == typeof e15 && (n10 = e15), !this.options.resources || this.options.partialBundledLanguages) {
      if (r10 && "cimode" === r10.toLowerCase()) return n10();
      var o10 = [];
      var a10 = function(e16) {
        e16 && t11.services.languageUtils.toResolveHierarchy(e16).forEach(function(e17) {
          o10.indexOf(e17) < 0 && o10.push(e17);
        });
      };
      if (r10) a10(r10);
      else this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach(function(e16) {
        return a10(e16);
      });
      this.options.preload && this.options.preload.forEach(function(e16) {
        return a10(e16);
      }), this.services.backendConnector.load(o10, this.options.ns, n10);
    } else n10(null);
  } }, { key: "reloadResources", value: function(e15, t11, n10) {
    var r10 = OZ();
    return e15 || (e15 = this.languages), t11 || (t11 = this.options.ns), n10 || (n10 = cG), this.services.backendConnector.reload(e15, t11, function(e16) {
      r10.resolve(), n10(e16);
    }), r10;
  } }, { key: "use", value: function(e15) {
    if (!e15) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e15.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return "backend" === e15.type && (this.modules.backend = e15), ("logger" === e15.type || e15.log && e15.warn && e15.error) && (this.modules.logger = e15), "languageDetector" === e15.type && (this.modules.languageDetector = e15), "i18nFormat" === e15.type && (this.modules.i18nFormat = e15), "postProcessor" === e15.type && JZ.addPostProcessor(e15), "3rdParty" === e15.type && this.modules.external.push(e15), this;
  } }, { key: "changeLanguage", value: function(e15, t11) {
    var n10 = this;
    this.isLanguageChangingTo = e15;
    var r10 = OZ();
    this.emit("languageChanging", e15);
    var o10 = function(o11) {
      e15 || o11 || !n10.services.languageDetector || (o11 = []);
      var a10 = "string" == typeof o11 ? o11 : n10.services.languageUtils.getBestMatchFromCodes(o11);
      a10 && (n10.language || (n10.language = a10, n10.languages = n10.services.languageUtils.toResolveHierarchy(a10)), n10.translator.language || n10.translator.changeLanguage(a10), n10.services.languageDetector && n10.services.languageDetector.cacheUserLanguage(a10)), n10.loadResources(a10, function(e16) {
        !function(e17, o12) {
          o12 ? (n10.language = o12, n10.languages = n10.services.languageUtils.toResolveHierarchy(o12), n10.translator.changeLanguage(o12), n10.isLanguageChangingTo = void 0, n10.emit("languageChanged", o12), n10.logger.log("languageChanged", o12)) : n10.isLanguageChangingTo = void 0, r10.resolve(function() {
            return n10.t.apply(n10, arguments);
          }), t11 && t11(e17, function() {
            return n10.t.apply(n10, arguments);
          });
        }(e16, a10);
      });
    };
    return e15 || !this.services.languageDetector || this.services.languageDetector.async ? !e15 && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect(o10) : o10(e15) : o10(this.services.languageDetector.detect()), r10;
  } }, { key: "getFixedT", value: function(e15, t11) {
    var n10 = this;
    var r10 = function e16(t12, r11) {
      var o10;
      if ("object" !== Ue(r11)) {
        for (var a10 = arguments.length, i10 = new Array(a10 > 2 ? a10 - 2 : 0), s10 = 2; s10 < a10; s10++) i10[s10 - 2] = arguments[s10];
        o10 = n10.options.overloadTranslationOptionHandler([t12, r11].concat(i10));
      } else o10 = IZ({}, r11);
      return o10.lng = o10.lng || e16.lng, o10.lngs = o10.lngs || e16.lngs, o10.ns = o10.ns || e16.ns, n10.t(t12, o10);
    };
    return "string" == typeof e15 ? r10.lng = e15 : r10.lngs = e15, r10.ns = t11, r10;
  } }, { key: "t", value: function() {
    var e15;
    return this.translator && (e15 = this.translator).translate.apply(e15, arguments);
  } }, { key: "exists", value: function() {
    var e15;
    return this.translator && (e15 = this.translator).exists.apply(e15, arguments);
  } }, { key: "setDefaultNamespace", value: function(e15) {
    this.options.defaultNS = e15;
  } }, { key: "hasLoadedNamespace", value: function(e15) {
    var t11 = this;
    var n10 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    if (!this.isInitialized) return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), false;
    if (!this.languages || !this.languages.length) return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), false;
    var r10 = this.languages[0];
    var o10 = !!this.options && this.options.fallbackLng;
    var a10 = this.languages[this.languages.length - 1];
    if ("cimode" === r10.toLowerCase()) return true;
    var i10 = function(e16, n11) {
      var r11 = t11.services.backendConnector.state["".concat(e16, "|").concat(n11)];
      return -1 === r11 || 2 === r11;
    };
    if (n10.precheck) {
      var s10 = n10.precheck(this, i10);
      if (void 0 !== s10) return s10;
    }
    return !!this.hasResourceBundle(r10, e15) || (!this.services.backendConnector.backend || !(!i10(r10, e15) || o10 && !i10(a10, e15)));
  } }, { key: "loadNamespaces", value: function(e15, t11) {
    var n10 = this;
    var r10 = OZ();
    return this.options.ns ? ("string" == typeof e15 && (e15 = [e15]), e15.forEach(function(e16) {
      n10.options.ns.indexOf(e16) < 0 && n10.options.ns.push(e16);
    }), this.loadResources(function(e16) {
      r10.resolve(), t11 && t11(e16);
    }), r10) : (t11 && t11(), Promise.resolve());
  } }, { key: "loadLanguages", value: function(e15, t11) {
    var n10 = OZ();
    "string" == typeof e15 && (e15 = [e15]);
    var r10 = this.options.preload || [];
    var o10 = e15.filter(function(e16) {
      return r10.indexOf(e16) < 0;
    });
    return o10.length ? (this.options.preload = r10.concat(o10), this.loadResources(function(e16) {
      n10.resolve(), t11 && t11(e16);
    }), n10) : (t11 && t11(), Promise.resolve());
  } }, { key: "dir", value: function(e15) {
    if (e15 || (e15 = this.languages && this.languages.length > 0 ? this.languages[0] : this.language), !e15) return "rtl";
    return ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam"].indexOf(this.services.languageUtils.getLanguagePartFromCode(e15)) >= 0 ? "rtl" : "ltr";
  } }, { key: "createInstance", value: function() {
    return new t10(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, arguments.length > 1 ? arguments[1] : void 0);
  } }, { key: "cloneInstance", value: function() {
    var e15 = this;
    var n10 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    var r10 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : cG;
    var o10 = IZ({}, this.options, n10, { isClone: true });
    var a10 = new t10(o10);
    return ["store", "services", "language"].forEach(function(t11) {
      a10[t11] = e15[t11];
    }), a10.services = IZ({}, this.services), a10.services.utils = { hasLoadedNamespace: a10.hasLoadedNamespace.bind(a10) }, a10.translator = new eG(a10.services, a10.options), a10.translator.on("*", function(e16) {
      for (var t11 = arguments.length, n11 = new Array(t11 > 1 ? t11 - 1 : 0), r11 = 1; r11 < t11; r11++) n11[r11 - 1] = arguments[r11];
      a10.emit.apply(a10, [e16].concat(n11));
    }), a10.init(o10, r10), a10.translator.options = a10.options, a10.translator.backendConnector.services.utils = { hasLoadedNamespace: a10.hasLoadedNamespace.bind(a10) }, a10;
  } }, { key: "toJSON", value: function() {
    return { options: this.options, store: this.store, language: this.language, languages: this.languages };
  } }]), t10;
}();
var dG = new uG();
var pG = { en: { adorners: { table: { newGroupLabel: "<New Group>", detailsGroupLabel: "<Details Group>", groupsLabel: "Groups" }, bandedList: { detailsLabel: "<Details>", groupsLabel: "Groups" }, bullet: { value: "Value", targetValue: "Target value" }, common: { dropFieldsAndValues: "Drop fields and values here" }, chart: { dataFields: "Data Fields", categoryFields: "Category Fields", encodingFields: "Encodings", valueEncoding: { fieldStub: "Value {{index}}" }, detailEncoding: { fieldStub: "Details {{index}}", title: "Details" }, categoryEncoding: { fieldStub: "Category {{index}}" }, colorEncoding: { fieldStub: "Color {{index}}", title: "Color" }, shapeEncoding: { fieldStub: "Shape {{index}}", title: "Shape" }, sizeEncoding: { fieldStub: "Size {{index}}", title: "Size" }, multiValueField: "{{firstFieldValue}}, ...", textEncoding: { title: "Text" }, gaugePointer: { fieldStub: "Pointer {{index}}" }, gaugeLabel: { fieldStub: "Label {{index}}" }, gaugeRanges: "Gauge Ranges", labels: "Labels" }, formattedText: { previewError: "XHTML parsing error occurred. Please verify Html property value and Merge Fields values." }, shapeRoundingTip: { multiCornerMode: 'Press "Alt" key to switch to "Single Corner" mode', singleCornerMode: 'Press "Alt" key to switch to "Multi-Corner" mode' }, sparkline: { seriesValue: "Series Value", groupingExpressions: "Grouping Expressions" }, tableOfContents: { addItem: "Add item" } }, captions: { barcodeUnsupportedSymbology: "[{{symbology}}] '{{itemName}}' preview is limited in design-time.", dvchartAxis: { category: "Category", value: "Value" }, dvchartChartTitle: "Chart Title", dvchartDetails: "Details [{{index}}]", dvchartColor: "Color [{{index}}]", dvchartShape: "Shape [{{index}}]", basicSupportReportItemInfo: "{{itemLabel}} '{{itemName}}' has limited support in design-time.", overflowPlaceholder: "{{overflowedItemName}} Overflow Placeholder" }, chartWizard: { buttons: { btnNext: "Next", btnBack: "Back", btnFinish: "Finish", btnCancel: "Cancel" }, titleSelectType: "Select Data and Chart type", titleSettings: "Settings", titlePreview: "Preview", titleChartWizard: "Chart Wizard", textTypeStep: "Data and Type", textPreviewStep: "Preview", templates: { types: { column: "Column", bar: "Bar", line: "Line", area: "Area", pie: "Pie", doughnut: "Doughnut", polarColumn: "Spiral", polarBar: "Polar", radarArea: "Radar Area", radarBubble: "Radar Bubble", radarScatter: "Radar Scatter", radarLine: "Radar Line", pyramid: "Pyramid", funnel: "Funnel", bubble: "Bubble", scatter: "Scatter", gantt: "Gantt", candlestick: "Candlestick", highLowClose: "High Low Close", highLowOpenClose: "High Low Open Close", rangeArea: "Range Area", rangeColumn: "Range Column", rangeBar: "Range Bar", gauge: "Gauge" } }, labelSelectPalette: "Select chart palette", textCustom: "Custom", textAdvancedCustomization: "Advanced Customization", customization: { labels: { area: "Area", header: "Header", axisX: "X axis", axisY: "Y axis", legend: "Legend", plot: "Plot Settings", footer: "Footer" } }, textEmpty: "Empty", labelSelectDataSet: "Select Data Set", settings: { categories: { values: "Data values", category: "Data categories", subcategory: "Data subcategories" }, labels: { fields: "Fields", gaugeRanges: "Gauge Ranges", field: "Field", sortDirection: "Sort Direction", group: "Break-down method", fieldX: "X Field", fieldY: "Y Field", fieldSize: "Size Field", fieldStart: "Start Field", fieldEnd: "End Field", fieldHigh: "High Field", fieldLow: "Low Field", fieldOpen: "Open Field", fieldClose: "Close Field", lower: "Lower", upper: "Upper", pointer: "Gauge Pointer", gaugeLabel: "Gauge Label", aggregate: "Aggregate" } } }, common: { units: { cm: { textShortName: "cm", textFullName: "Centimeters" }, in: { textShortName: "in", textFullName: "Inches" } }, textExpand: "Expand", textCollapse: "Collapse", textDelete: "Delete", btnOk: "OK", btnCancel: "Cancel", btnSave: "Save", textOpen: "Open..." }, components: { dataPanel: { commonValues: { currentDateTime: "Current Date and Time", pageNM: "Page N of M", pageNMCumulative: "Page N of M (Cumulative)", pageNMSection: "Page N of M (Section)", pageNofMLabel: '"Page " & {{pageNumber}} & " of " & {{totalPages}}', pageNumber: "Page Number", pageNumberCumulative: "Page Number (Cumulative)", pageNumberSection: "Page Number (Section)", reportFolder: "Report Folder", reportName: "Report Name", totalPages: "Total Pages", totalPagesCumulative: "Total Pages (Cumulative)", totalPagesSection: "Total Pages (Section)", userContext: "User Context", userId: "User ID", userLanguage: "User Language" }, titleMore: "More...", textFieldsCount: "{{count}} field", textFieldsCount_plural: "{{count}} fields", textBasedOnDataSource: "based on {{dataSourceName}}", titleEditDataSet: "Edit Data Set...", titleSelectFields: "Select Fields...", dataSets: { placeholderEnterFieldName: "enter field name here...", textNoMatchingFieldsFound: "No matching fields found", semantic: { loading: "Loading...", editDataSet: "Edit Data Set...", searchPlaceholder: "enter attribute or relation name here...", noMatchingAttributesRelationsFound: "No matching attributes or relations found" } }, textSharedReference: "Shared Reference", titleEditDataSource: "Edit Data Source...", titleAddDataSet: "Add Data Set...", fieldVariations: { DateTime: [{ format: "=Year({fieldExpression})", label: "Year" }, { format: '=Year({fieldExpression}) & " Q" & DatePart("q", {fieldExpression})', label: "Year-Quarter" }, { format: '=Year({fieldExpression}) & " " & MonthName(Month({fieldExpression}))', label: "Year-Month" }, { format: '=Year({fieldExpression}) & " " & MonthName(Month({fieldExpression})) & " " & Day({fieldExpression})', label: "Year-Month-Day" }, { format: '=Year({fieldExpression}) & " W" & DatePart("ww", {fieldExpression})', label: "Year-Week" }, { format: '=DatePart("q", {fieldExpression})', label: "Quarter" }, { format: "=Month({fieldExpression})", label: "Month" }, { format: "=MonthName(Month({fieldExpression}))", label: "MonthName" }, { format: '=DatePart("ww", {fieldExpression})', label: "Week" }, { format: "=Day({fieldExpression})", label: "Day" }, { format: "=WeekdayName(Weekday({fieldExpression}))", label: "DayOfWeek" }], Date: [{ format: "=Year({fieldExpression})", label: "Year" }, { format: '=Year({fieldExpression}) & " Q" & DatePart("q", {fieldExpression})', label: "Year-Quarter" }, { format: '=Year({fieldExpression}) & " " & MonthName(Month({fieldExpression}))', label: "Year-Month" }, { format: '=Year({fieldExpression}) & " " & MonthName(Month({fieldExpression})) & " " & Day({fieldExpression})', label: "Year-Month-Day" }, { format: '=Year({fieldExpression}) & " W" & DatePart("ww", {fieldExpression})', label: "Year-Week" }, { format: '=DatePart("q", {fieldExpression})', label: "Quarter" }, { format: "=Month({fieldExpression})", label: "Month" }, { format: "=MonthName(Month({fieldExpression}))", label: "MonthName" }, { format: '=DatePart("ww", {fieldExpression})', label: "Week" }, { format: "=Day({fieldExpression})", label: "Day" }, { format: "=WeekdayName(Weekday({fieldExpression}))", label: "DayOfWeek" }] }, titleMoveParameterDown: "Move Down", titleMoveParameterUp: "Move Up", semantic: { textAttributesCount: "{{count}} attribute", textAttributesCount_plural: "{{count}} attributes", textRelationsCount: "{{count}} relation", textRelationsCount_plural: "{{count}} relations", textNoAttributes: "no attributes", textNoRelations: "no relations" }, textModelVersion: "Version: {{version}}", headingEditParameter: "Edit Parameter" }, chartPaletteDropdown: { headingStandardPalettes: "Standard Palettes", headingExtraPalettes: "Theme Palettes" }, appBar: { titleUndo: "Undo", titleRedo: "Redo", titleNew: "New", titleOpen: "Open", titleSave: "Save", btnSaveAs: "Save As", btnPreview: "Preview", btnFile: "File", btnHome: "Home", btnInsert: "Insert", textUnsavedChanges: "Unsaved Changes", btnParameters: "Parameters" }, menu: { btnBack: "Back", titleBack: "Back", btnClose: "Close", titlePin: "Pin", btnLayerList: "Layers", btnLibrariesList: "Libraries", btnGroupEditor: "Group Editor", btnReportExplorer: "Explorer" }, statusBar: { btnShowAdvancedProperties: "Show Advanced Properties", btnShowBasicProperties: "Show Basic Properties", btnPropertiesMode: "Properties Mode", common: { textEnabled: "Enabled", textDisabled: "Disabled" }, snapSettings: { labelGridSize: "Grid Size", labelSnapToGrid: "Snap To Grid", labelSnapToGuides: "Snap To Guides", titleSnapEnabled: "Snap Enabled", titleSnapDisabled: "Snap Disabled" }, titleHideGrid: "Hide Grid", titleShowGrid: "Show Grid", titleHideRulers: "Hide Rulers", titleShowRulers: "Show Rulers", themePicker: { titleTheme: "Theme", themes: { system: "System Theme", default: "Default", defaultDark: "Default Dark", darkOled: "OLED Dark", highContrast: "High Contrast", highContrastDark: "High Contrast Dark", activeReports: "ActiveReports", activeReportsDark: "ActiveReports Dark" } }, titleZoomOut: "Zoom Out", titleZoomIn: "Zoom In" }, notifications: { btnDismissAll: "Dismiss All", btnDismiss: "Dismiss", titleNotifications: "Notifications", headingError: "{{count}} Error", headingError_plural: "{{count}} Errors", headingWarning: "{{count}} Warning", headingWarning_plural: "{{count}} Warnings", headingNotification: "{{count}} Notification", headingNotification_plural: "{{count}} Notifications" }, toolbar: { titleExpand: "Expand", home: { textExpressionCompact: "<\u{1D453}>", textExpression: "<Expression>", titleFontFamily: "Font Family", titleFontSize: "Font Size", titleFontWeight: "Font Weight", titleFontStyle: "Font Style", titleTextDecoration: "Text Decoration Underline", titleTextColor: "Text Color", titleBackgroundColor: "Background Color", titleAlignLeft: "Text Align Left", titleAlignCenter: "Text Align Center", titleAlignRight: "Text Align Right", titleAlignJustify: "Text Align Justify", titleVerticalAlignTop: "Text Vertical Align Top", titleVerticalAlignMiddle: "Text Vertical Align Middle", titleVerticalAlignBottom: "Text Vertical Align Bottom", titleCut: "Cut", titleCopy: "Copy", titlePaste: "Paste" } }, title: { textUntitled: "Untitled" }, layerList: { titleHideLayer: "Hide Layer", titleShowLayer: "Show Layer", titleUnlockLayer: "Unlock Layer", titleLockLayer: "Lock Layer", titleEditLayer: "Edit Layer", titleDefaultLayerCannotBeDeleted: "Default layer can't be deleted", titleDeleteLayer: "Delete layer", btnAddLayer: "Add Layer" }, fieldPicker: { placeholderEnterFieldName: "enter field name here..." }, propertyGrid: { textReportItems: "<Report Items>", textMultipleTypes: "<Multiple Types>", options: { showAdvancedProperty: "Show Advanced Properties", hideAdvancedProperty: "Hide Advanced Properties", categories: "Categories", collapse: "Collapse All", expand: "Expand All" }, placeholderSearchBox: "enter property name here..." }, libraries: { textNoLibraries: "No available libraries", textError: "Error", textEmpty: "Empty", textNoReportParts: "Library contains no report parts" }, tabs: { textPage: "Page", btnAddPage: "Add Page", btnAddSection: "Add Section", actions: { textMoveLeft: "Move Left", textMoveRight: "Move Right", textInsert: "Insert", textDuplicate: "Duplicate", textShow: "Show", textHide: "Hide", textMDelete: "Delete" } }, themeEditor: { labelNone: "<None>" }, dataFieldPickerDropdown: { semantic: { noMatchingAttributesRelationsFound: "No matching items found", searchPlaceholder: "enter item name here..." } } }, "components-RPX": { appBar: { btnScript: "Script" }, dataTab: { titleDeleteDataSource: "Delete Data Source", titleEditDataSource: "Edit Data Source...", titleMoveParameterDown: "Move Down", titleMoveParameterUp: "Move Up" }, menu: { btnReportExplorer: "Explorer" }, propertyGrid: { textMultipleTypes: "<Multiple Types>", textSort: "Sort", textCategorized: "Categorized", textAlphabetical: "Alphabetical", placeholderSearchBox: "enter property name here..." }, stylesTab: { titleDeleteStyle: "Delete Style", titleAddStyle: 'Add Style Based on "{{parentName}}"', textBasedOn: 'Based on "{{parentName}}"', textRootStyle: "No Parent Style" }, toolbar: { home: { fontFamily: "Font Family", fontSize: "Font Size", fontWeight: "Font Weight Bold", fontStyle: "Font Style Italic", textDecoration: "Text Decoration Underline", foreColor: "Fore Color", backColor: "Back Color", titleAlignLeft: "Text Align Left", titleAlignCenter: "Text Align Center", titleAlignRight: "Text Align Right", titleAlignJustify: "Text Align Justify", verticalAlignTop: "Vertical Align Top", verticalAlignMiddle: "Vertical Align Middle", verticalAlignBottom: "Vertical Align Bottom" }, script: { events: { report: { textReportStart: "ReportStart", textReportEnd: "ReportEnd", textPageStart: "PageStart", textPageEnd: "PageEnd", textDataInitialize: "DataInitialize", textFetchData: "FetchData", textNoData: "NoData" }, section: { textFormat: "Format", textBeforePrint: "BeforePrint", textAfterPrint: "AfterPrint" } }, titleObject: "Object", textObject: "Object", titleEvent: "Event", textEvent: "Event" } }, scriptEditor: { placeholder: "Enter {{ScriptLanguage}} code" } }, contextActions: { dvchart: { presetGroups: { area: "Area", bar: "Bar", column: "Column", line: "Line", misc: "Miscellaneous", pie: "Pie", polarBar: "Polar", polarColumn: "Spiral", radar: "Radar", range: "Range" }, presets: { area: "Area", areaPercentStacked: "Area Percent Stacked", areaStacked: "Area Stacked", bar: "Bar", barPercentStacked: "Bar Percent Stacked", barStacked: "Bar Stacked", bubble: "Bubble", candlestick: "Candlestick", column: "Column", columnPercentStacked: "Column Percent Stacked", columnStacked: "Column Stacked", doughnut: "Doughnut", funnel: "Funnel", gantt: "Gantt", gauge: "Gauge", highLowClose: "High Low Close", highLowOpenClose: "High Low Open Close", line: "Line", lineSmooth: "Line Smooth", pie: "Pie", polarBar: "Polar", polarBarPercentStacked: "Polar Percent Stacked", polarBarStacked: "Polar Stacked", polarColumn: "Spiral", polarColumnPercentStacked: "Spiral Percent Stacked", polarColumnStacked: "Spiral Stacked", pyramid: "Pyramid", radarArea: "Radar Area", radarBubble: "Radar Bubble", radarLine: "Radar Line", radarScatter: "Radar Scatter", scatter: "Scatter", rangeArea: "Range Area", rangeBar: "Range Bar", rangeColumn: "Range Column", title: "Set Plot Template" }, palette: "Set Chart Palette" }, bandedList: { removeHeader: "Remove Header", addHeader: "Add Header", removeFooter: "Remove Footer", addFooter: "Add Footer", removeGroupHeader: "Remove Group Header", addGroupHeader: "Add Group Header", removeGroupFooter: "Remove Group Footer", addGroupFooter: "Add Group Footer", title: "Banded List", groupTitle: "Group", insertGroup: "Insert Group", deleteGroup: "Delete Group" }, container: { delete: "Delete", expression: "Expression" }, chart: "Chart", report: { reportParts: { title: "Report Parts", titleCreateReportPart: "Create Report Part" }, layout: { alignToGrid: "Align to Grid", sizeToGrid: "Size to Grid", separator: { sortControls: "Sort Controls", corelateControlSizing: "Correlate Control Sizes", horizontalSpacing: "Horizontal Spacing", verticalSpacing: "Vertical Spacing" }, bringToFront: "Bring to Front", sendToBack: "Send to Back", makeSameWidth: "Make Same Width", makeSameHeight: "Make Same Height", makeSameSize: "Make Same Size", horizontalAlignment: "Horizontal alignment", alignToLefts: "Align to Lefts", alignToCenters: "Align to Centers", alignToRights: "Align to Rights", verticalAlignment: "Vertical alignment", alignToTops: "Align to Tops", alignToMiddles: "Align to Middles", alignToBottoms: "Align to Bottoms", horizontal: { makeSpacingEqual: "Make Horizontal Spacing Equal", increaseSpacing: "Increase Horizontal Spacing", decreaseSpacing: "Decrease Horizontal Spacing", removeSpacing: "Remove Horizontal Spacing" }, vertical: { makeSpacingEqual: "Make Vertical Spacing Equal", increaseSpacing: "Increase Vertical Spacing", decreaseSpacing: "Decrease Vertical Spacing", removeSpacing: "Remove Vertical Spacing" }, title: "Layout" }, insertSection: "Insert Section", movePageBackward: "Move Page Left", movePageForward: "Move Page Right", deletePage: "Delete Page", insertPage: "Insert Page", duplicatePage: "Duplicate Page", hidePage: "Hide Page", showPage: "Show Page", pages: "Pages", moveSectionLeft: "Move Section Left", moveSectionRight: "Move Section Right", duplicateSection: "Duplicate Section", showSection: "Show Section", hideSection: "Hide Section", removeSection: "Delete Section", addContinuousSection: "Add Continuous Section", addFixedPageSection: "Add Fixed Page Section", convertToMasterReport: "Convert to Master Report", changeMasterReport: "Change Master Report", setMasterReport: "Set Master Report", switchTheme: "Switch Theme", title: "Report" }, dashboard: { moveSectionLeft: "Move Section Left", moveSectionRight: "Move Section Right", duplicateSection: "Duplicate Section", showSection: "Show Section", hideSection: "Hide Section", removeSection: "Delete Section", switchTheme: "Switch Theme", title: "Dashboard" }, reportSection: { removeHeader: "Remove Header", addHeader: "Add Header", removeFooter: "Remove Footer", addFooter: "Add Footer", title: "Section" }, table: { removeGroupHeader: "Remove Group Header", addGroupHeader: "Add Group Header", removeGroupFooter: "Remove Group Footer", addGroupFooter: "Add Group Footer", deleteGroup: "Delete Group", groupTitle: "Group", insertGroup: "Insert Group", expression: "Cell Expression", cellsTitle: "Cells", mergeCells: "Merge Cells", splitCells: "Split Cells", rowTitle: "Row", insertRowTitle: "Insert Row", insertRow: { above: "Above", below: "Below" }, more: "More...", deleteRow: "Delete Row", insertColumn: { left: "Left", right: "Right" }, columnTitle: "Column", insertColumnTitle: "Insert Column", deleteColumn: "Delete Column", removeHeader: "Remove Header", addHeader: "Add Header", removeDetails: "Remove Details", addDetails: "Add Details", removeFooter: "Remove Footer", addFooter: "Add Footer", title: "Table" }, tablix: { mergeCells: "Merge Cells", splitCells: "Split Cells", cellsTitle: "Cells", insertColumnTitle: "Insert Column", delete: "Delete", columnTitle: "Column", insertRowTitle: "Insert Row", rowTitle: "Row", insertRow: { above: "Above", below: "Below", insideGroupAbove: "Inside Group - Above", insideGroupBelow: "Inside Group - Below", outsideGroupAbove: "Outside Group - Above", outsideGroupBelow: "Outside Group - Below" }, insertColumn: { left: "Left", right: "Right", insideGroupLeft: "Inside Group - Left", insideGroupRight: "Inside Group - Right", outsideGroupLeft: "Outside Group - Left", outsideGroupRight: "Outside Group - Right" }, more: "More...", addGroup: { parent: "Parent", child: "Child", adjacentBefore: "Adjacent Before", adjacentAfter: "Adjacent After" }, enableGroup: "Enable Group", addGroupTitle: "Add Group", columnGroup: "Column Group", disableGroup: "Disable Group", rowGroup: "Row Group", addTotal: { contextMenuAfter: "Add Total After", contextMenuBefore: "Add Total Before" }, totalTitle: "Total", expression: "Cell Expression", deleteRow: "Delete Row", deleteColumn: "Delete Column" } }, "contextActions-RPX": { labels: { cut: "Cut", copy: "Copy", paste: "Paste", delete: "Delete", layout: { alignToGrid: "Align to Grid", sizeToGrid: "Size to Grid", separator: { sortControls: "Sort Controls", corelateControlSizing: "Correlate Control Sizes", horizontalAlignment: "Horizontal Alignment", verticalAlignment: "Vertical Alignment", horizontalSpacing: "Horizontal Spacing", verticalSpacing: "Vertical Spacing" }, bringToFront: "Bring to Front", sendToBack: "Send to Back", makeSameWidth: "Make Same Width", makeSameHeight: "Make Same Height", makeSameSize: "Make Same Size", alignToLefts: "Align to Lefts", alignToCenters: "Align to Centers", alignToRights: "Align to Rights", alignToTops: "Align to Tops", alignToMiddles: "Align to Middles", alignToBottoms: "Align to Bottoms", horizontal: { makeSpacingEqual: "Make Horizontal Spacing Equal", increaseSpacing: "Increase Horizontal Spacing", decreaseSpacing: "Decrease Horizontal Spacing", removeSpacing: "Remove Horizontal Spacing" }, vertical: { makeSpacingEqual: "Make Vertical Spacing Equal", increaseSpacing: "Increase Vertical Spacing", decreaseSpacing: "Decrease Vertical Spacing", removeSpacing: "Remove Vertical Spacing" }, title: "Layout" }, report: "Report", addReportHeaderFooter: "Add Report Header/Footer", deleteReportHeaderFooter: "Delete Report Header/Footer", addPageHeaderFooter: "Add Page Header/Footer", deletePageHeaderFooter: "Delete Page Header/Footer", addGroupHeaderFooter: "Add Group Header/Footer", reportHeader: "ReportHeader", reportFooter: "ReportFooter", pageHeader: "PageHeader", pageFooter: "PageFooter" } }, defaults: { chart: { innerRadius: 0.5, startAngle: 0 } }, dialogs: { common: { textCancel: "Cancel" }, headingInsertRows: "Insert Rows", headingInsertColumns: "Insert Columns", btnInsert: "Insert", btnCancel: "Cancel", labelCount: "Count", labelPosition: "Position", expressionEditor: { subtitle: "Expression Editor", infoPanel: { labelSyntax: "Syntax:", labelDescription: "Description:", labelExample: "Example:", labelName: "Name:", labelConstant: "Constant:" }, headingFunctions: "Functions", headingInfo: "Info", search: { textStartTyping: "start typing to see results", textNoResults: 'no results for "{{query}}"', placeholderSearch: "search..." }, headingValues: "Values", placeholderExpression: "expression", headingExpression: "Expression" }, dataVisualizer: { title: "Data Visualizer" } }, "documentItems-RPX": { Barcode: "Barcode", CheckBox: "CheckBox", CrossSectionBox: "CrossSectionBox", CrossSectionLine: "CrossSectionLine", Unknown: "Unknown", InputFieldCheckBox: "InputFieldCheckBox", InputFieldText: "InputFieldText", Label: "Label", Line: "Line", PageBreak: "PageBreak", Picture: "Picture", Report: "Report", ReportInfo: "ReportInfo", RichTextBox: "RichTextBox", Detail: "Detail", PageHeader: "Page Header", PageFooter: "Page Footer", GroupHeader: "Group Header", GroupFooter: "Group Footer", ReportHeader: "Report Header", ReportFooter: "Report Footer", Shape: "Shape", SubReport: "SubReport", TextBox: "TextBox", captions: { basicSupportReportItemInfo: "{{itemLabel}} '{{itemName}}' has limited support in design-time." } }, documentsAPI: { textOpenDocumentWarnings: "Document opened with warnings", romLabels: { chart: "Chart", dvchart: "DV.Chart", matrix: "Matrix", table: "Table", tablix: "Tablix" }, transform: { textError: "\u2013 [{{ErrorType}}] {{Message}}", helpLink: "Please find more information on report items transformation at {{link}}.", textReportItem: '\u2714 {{SourceType}} "{{Name}}" has been transformed to {{ResultType}}.', textBadReportItem: `\u2718 {{SourceType}} "{{Name}}" couldn't have been transformed to {{ResultType}} due to internal issues:`, textReport: 'The report "{{reportName}}" has been transformed.' }, textReportConversion: "There have been issues while opening this report", textRenamedItemPrefix: "Content_{{originalName}}" }, enums: { action: { None: "None", ApplyParameters: "Apply Parameters", Drillthrough: "Jump to Report", BookmarkLink: "Jump to Bookmark", Hyperlink: "Jump to URL" }, action_apply_value_cmd: { Set: "Set", Reset: "Reset", Toggle: "Toggle" }, auto_merge_mode: { Never: "Never", Always: "Always", Restricted: "Restricted" }, auto_width: { None: "None", Proportional: "Proportional" }, axis_location: { Left: "Left", Right: "Right" }, axis_mode: { Cartesian: "Cartesian", Radial: "Radial", Polygonal: "Polygonal" }, barcode_caption_location: { None: "None", Above: "Above", Below: "Below" }, barcode_ecc000_140_symbol_size: { Auto: "Auto", Square9: "Square9", Square11: "Square11", Square13: "Square13", Square15: "Square15", Square17: "Square17", Square19: "Square19", Square21: "Square21", Square23: "Square23", Square25: "Square25", Square27: "Square27", Square29: "Square29", Square31: "Square31", Square33: "Square33", Square35: "Square35", Square37: "Square37", Square39: "Square39", Square41: "Square41", Square43: "Square43", Square45: "Square45", Square47: "Square47", Square49: "Square49" }, barcode_ecc200_encoding_mode: { Auto: "Auto", ASCII: "ASCII", C40: "C40", Text: "Text", X12: "X12", EDIFACT: "EDIFACT", Base256: "Base256" }, barcode_ecc200_symbol_size: { SquareAuto: "SquareAuto", RectangularAuto: "RectangularAuto", Square10: "Square10", Square12: "Square12", Square14: "Square14", Square16: "Square16", Square18: "Square18", Square20: "Square20", Square22: "Square22", Square24: "Square24", Square26: "Square26", Square32: "Square32", Square36: "Square36", Square40: "Square40", Square44: "Square44", Square48: "Square48", Square52: "Square52", Square64: "Square64", Square72: "Square72", Square80: "Square80", Square88: "Square88", Square96: "Square96", Square104: "Square104", Square120: "Square120", Square132: "Square132", Square144: "Square144", Rectangular8x18: "Rectangular8x18", Rectangular8x32: "Rectangular8x32", Rectangular12x26: "Rectangular12x26", Rectangular12x36: "Rectangular12x36", Rectangular16x36: "Rectangular16x36", Rectangular16x48: "Rectangular16x48" }, barcode_ecc_mode: { ECC000: "ECC000", ECC050: "ECC050", ECC080: "ECC080", ECC100: "ECC100", ECC140: "ECC140", ECC200: "ECC200" }, barcode_encoding: { 37: "IBM EBCDIC (US-Canada) 37", 437: "OEM United States 437", 500: "IBM EBCDIC (International) 500", 708: "Arabic (ASMO 708) 708", 720: "Arabic (DOS) 720", 737: "Greek (DOS) 737", 775: "Baltic (DOS) 775", 850: "Western European (DOS) 850", 852: "Central European (DOS) 852", 855: "OEM Cyrillic 855", 857: "Turkish (DOS) 857", 858: "OEM Multilingual Latin I 858", 860: "Portuguese (DOS) 860", 861: "Icelandic (DOS) 861", 862: "Hebrew (DOS) 862", 863: "French Canadian (DOS) 863", 864: "Arabic (864) 864", 865: "Nordic (DOS) 865", 866: "Cyrillic (DOS) 866", 869: "Greek Modern (DOS) 869", 870: "IBM EBCDIC (Multilingual Latin-2) 870", 874: "Thai (Windows) 874", 875: "IBM EBCDIC (Greek Modern) 875", 932: "Japanese (Shift-JIS) 932", 936: "Chinese Simplified (GB2312) 936", 949: "Korean 949", 950: "Chinese Traditional (Big5) 950", 1026: "IBM EBCDIC (Turkish Latin-5) 1026", 1047: "IBM Latin-1 1047", 1140: "IBM EBCDIC (US-Canada-Euro) 1140", 1141: "IBM EBCDIC (Germany-Euro) 1141", 1142: "IBM EBCDIC (Denmark-Norway-Euro) 1142", 1143: "IBM EBCDIC (Finland-Sweden-Euro) 1143", 1144: "IBM EBCDIC (Italy-Euro) 1144", 1145: "IBM EBCDIC (Spain-Euro) 1145", 1146: "IBM EBCDIC (UK-Euro) 1146", 1147: "IBM EBCDIC (France-Euro) 1147", 1148: "IBM EBCDIC (International-Euro) 1148", 1149: "IBM EBCDIC (Icelandic-Euro) 1149", 1200: "Unicode 1200", 1201: "Unicode (Big-Endian) 1201", 1250: "Central European (Windows) 1250", 1251: "Cyrillic (Windows) 1251", 1252: "Western European (Windows) 1252", 1253: "Greek (Windows) 1253", 1254: "Turkish (Windows) 1254", 1255: "Hebrew (Windows) 1255", 1256: "Arabic (Windows) 1256", 1257: "Baltic (Windows) 1257", 1258: "Vietnamese (Windows) 1258", 1361: "Korean (Johab) 1361", 1e4: "Western European (Mac) 10000", 10001: "Japanese (Mac) 10001", 10002: "Chinese Traditional (Mac) 10002", 10003: "Korean (Mac) 10003", 10004: "Arabic (Mac) 10004", 10005: "Hebrew (Mac) 10005", 10006: "Greek (Mac) 10006", 10007: "Cyrillic (Mac) 10007", 10008: "Chinese Simplified (Mac) 10008", 10010: "Romanian (Mac) 10010", 10017: "Ukrainian (Mac) 10017", 10021: "Thai (Mac) 10021", 10029: "Central European (Mac) 10029", 10079: "Icelandic (Mac) 10079", 10081: "Turkish (Mac) 10081", 10082: "Croatian (Mac) 10082", 12e3: "Unicode (UTF-32) 12000", 12001: "Unicode (UTF-32 Big-Endian) 12001", 2e4: "Chinese Traditional (CNS) 20000", 20001: "TCA Taiwan 20001", 20002: "Chinese Traditional (Eten) 20002", 20003: "IBM5550 Taiwan 20003", 20004: "TeleText Taiwan 20004", 20005: "Wang Taiwan 20005", 20105: "Western European (IA5) 20105", 20106: "German (IA5) 20106", 20107: "Swedish (IA5) 20107", 20108: "Norwegian (IA5) 20108", 20127: "US-ASCII 20127", 20261: "T.61 20261", 20269: "ISO-6937 20269", 20273: "IBM EBCDIC (Germany) 20273", 20277: "IBM EBCDIC (Denmark-Norway) 20277", 20278: "IBM EBCDIC (Finland-Sweden) 20278", 20280: "IBM EBCDIC (Italy) 20280", 20284: "IBM EBCDIC (Spain) 20284", 20285: "IBM EBCDIC (UK) 20285", 20290: "IBM EBCDIC (Japanese katakana) 20290", 20297: "IBM EBCDIC (France) 20297", 20420: "IBM EBCDIC (Arabic) 20420", 20423: "IBM EBCDIC (Greek) 20423", 20424: "IBM EBCDIC (Hebrew) 20424", 20833: "IBM EBCDIC (Korean Extended) 20833", 20838: "IBM EBCDIC (Thai) 20838", 20866: "Cyrillic (KOI8-R) 20866", 20871: "IBM EBCDIC (Icelandic) 20871", 20880: "IBM EBCDIC (Cyrillic Russian) 20880", 20905: "IBM EBCDIC (Turkish) 20905", 20924: "IBM Latin-1 20924", 20932: "Japanese (JIS 0208-1990 and 0212-1990) 20932", 20936: "Chinese Simplified (GB2312-80) 20936", 20949: "Korean Wansung 20949", 21025: "IBM EBCDIC (Cyrillic Serbian-Bulgarian) 21025", 21866: "Cyrillic (KOI8-U) 21866", 28591: "Western European (ISO) 28591", 28592: "Central European (ISO) 28592", 28593: "Latin 3 (ISO) 28593", 28594: "Baltic (ISO) 28594", 28595: "Cyrillic (ISO) 28595", 28596: "Arabic (ISO) 28596", 28597: "Greek (ISO) 28597", 28598: "Hebrew (ISO-Visual) 28598", 28599: "Turkish (ISO) 28599", 28603: "Estonian (ISO) 28603", 28605: "Latin 9 (ISO) 28605", 29001: "Europa 29001", 38598: "Hebrew (ISO-Logical) 38598", 50220: "Japanese (JIS) 50220", 50221: "Japanese (JIS-Allow 1 byte Kana) 50221", 50222: "Japanese (JIS-Allow 1 byte Kana SO/SI) 50222", 50225: "Korean (ISO) 50225", 50227: "Chinese Simplified (ISO-2022) 50227", 51932: "Japanese (EUC) 51932", 51936: "Chinese Simplified (EUC) 51936", 51949: "Korean (EUC) 51949", 52936: "Chinese Simplified (HZ) 52936", 54936: "Chinese Simplified (GB18030) 54936", 57002: "ISCII Devanagari 57002", 57003: "ISCII Bengali 57003", 57004: "ISCII Tamil 57004", 57005: "ISCII Telugu 57005", 57006: "ISCII Assamese 57006", 57007: "ISCII Oriya 57007", 57008: "ISCII Kannada 57008", 57009: "ISCII Malayalam 57009", 57010: "ISCII Gujarati 57010", 57011: "ISCII Punjabi 57011", 65e3: "Unicode (UTF-7) 65000", 65001: "Unicode (UTF-8) 65001" }, barcode_gs1_composite_type: { None: "None", CCA: "CCA" }, barcode_maxicode_mode: { Mode2: "Mode2", Mode3: "Mode3", Mode4: "Mode4", Mode5: "Mode5", Mode6: "Mode6" }, barcode_micro_pdf417_compaction_mode: { Auto: "Auto", TextCompactionMode: "TextCompactionMode", NumericCompactionMode: "NumericCompactionMode", ByteCompactionMode: "ByteCompactionMode" }, barcode_micro_pdf417_version: { ColumnPriorAuto: "ColumnPriorAuto", RowPriorAuto: "RowPriorAuto", Version1X11: "Version1X11", Version1X14: "Version1X14", Version1X17: "Version1X17", Version1X20: "Version1X20", Version1X24: "Version1X24", Version1X28: "Version1X28", Version2X8: "Version2X8", Version2X11: "Version2X11", Version2X14: "Version2X14", Version2X17: "Version2X17", Version2X20: "Version2X20", Version2X23: "Version2X23", Version2X26: "Version2X26", Version3X6: "Version3X6", Version3X8: "Version3X8", Version3X10: "Version3X10", Version3X12: "Version3X12", Version3X15: "Version3X15", Version3X20: "Version3X20", Version3X26: "Version3X26", Version3X32: "Version3X32", Version3X38: "Version3X38", Version3X44: "Version3X44", Version4X4: "Version4X4", Version4X6: "Version4X6", Version4X8: "Version4X8", Version4X10: "Version4X10", Version4X12: "Version4X12", Version4X15: "Version4X15", Version4X20: "Version4X20", Version4X26: "Version4X26", Version4X32: "Version4X32", Version4X38: "Version4X38", Version4X44: "Version4X44" }, barcode_micro_qrcode_error_level: { L: "L", M: "M", Q: "Q" }, barcode_micro_qrcode_mask: { Auto: "Auto", Mask00: "Mask00", Mask01: "Mask01", Mask10: "Mask10", Mask11: "Mask11" }, barcode_micro_qrcode_version: { Auto: "Auto", M1: "M1", M2: "M2", M3: "M3", M4: "M4" }, barcode_pdf417_error_correction_level: { Level0: "Level0", Level1: "Level1", Level2: "Level2", Level3: "Level3", Level4: "Level4", Level5: "Level5", Level6: "Level6", Level7: "Level7", Level8: "Level8" }, barcode_pdf417_type: { Normal: "Normal", Simple: "Simple" }, barcode_qrcode_error_level: { M: "M", L: "L", H: "H", Q: "Q" }, barcode_qrcode_mask: { Auto: "Auto", Mask000: "Mask000", Mask001: "Mask001", Mask010: "Mask010", Mask011: "Mask011", Mask100: "Mask100", Mask101: "Mask101", Mask110: "Mask110", Mask111: "Mask111" }, barcode_qrcode_model: { Model1: "Model1", Model2: "Model2" }, barcode_rotation: { None: "None", Rotate90Degrees: "Rotate90Degrees", Rotate180Degrees: "Rotate180Degrees", Rotate270Degrees: "Rotate270Degrees" }, barcode_symbology: { None: "None", Ansi39: "ANSI 3 of 9", Ansi39x: "ANSI Extended 3 of 9", Aztec: "Aztec", BC412: "BC412", Codabar: "Codabar", Code_11: "Code 11", Code_128_A: "Code 128 A", Code_128_B: "Code 128 B", Code_128_C: "Code 128 C", Code_128auto: "Code 128 Auto", Code_2_of_5: "Code 2 of 5", Code_93: "Code 93", Code25intlv: "Interleaved 2 of 5", Code39: "Code 39", Code39x: "Extended Code 39", Code49: "Code 49", Code93x: "Extended Code 93", DataMatrix: "Data Matrix", EAN_13: "EAN-13", EAN_8: "EAN-8", EAN128FNC1: "EAN-128FNC1", GS1DataMatrix: "GS1 Data Matrix", GS1QRCode: "GS1 QR Code", HIBCCode128: "HIBC Code 128", HIBCCode39: "HIBC Code 39", IATA_2_of_5: "IATA 2 of 5", IntelligentMail: "Intelligent Mail", IntelligentMailPackage: "Intelligent Mail Package", ISBN: "ISBN (International Standard Book Number)", ISMN: "ISMN (Internationally Standard Music Number)", ISSN: "ISSN (International Standard Serial Number)", ITF14: "ITF-14", JapanesePostal: "Japanese Postal", Matrix_2_of_5: "Matrix 2 of 5", MaxiCode: "MaxiCode", MicroPDF417: "Micro PDF417", MicroQRCode: "Micro QR Code", MSI: "MSI Code", Pdf417: "PDF417", Pharmacode: "Pharmacode", Plessey: "Plessey", PostNet: "PostNet", PZN: "PZN (Pharmaceutical Central Number)", QRCode: "QR Code", RM4SCC: "RM4SCC (Royal Mail)", RSS14: "RSS-14", RSS14Stacked: "RSS-14 Stacked", RSS14StackedOmnidirectional: "RSS-14 Stacked Omnidirectional", RSS14Truncated: "RSS-14 Truncated", RSSExpanded: "RSS Expanded", RSSExpandedStacked: "RSS Expanded Stacked", RSSLimited: "RSS Limited", SSCC_18: "SSCC-18", Telepen: "Telepen", UCCEAN128: "UCC/EAN\u2013128", UPC_A: "UPC-A", UPC_E0: "UPC-E0", UPC_E1: "UPC-E1" }, border_style: { None: "None", Dotted: "Dotted", Dashed: "Dashed", Solid: "Solid", Double: "Double", Groove: "Groove", Ridge: "Ridge", Inset: "Inset", WindowInset: "WindowInset", Outset: "Outset", DashDot: "DashDot", DashDotDot: "DashDotDot" }, bullet_tick_marks: { None: "None", Inside: "Inside", Outside: "Outside" }, calendar: { Gregorian: "Gregorian", GregorianArabic: "Gregorian Arabic", GregorianMiddleEastFrench: "Gregorian Middle East French", GregorianTransliteratedEnglish: "Gregorian Transliterated English", GregorianTransliteratedFrench: "Gregorian Transliterated French", GregorianUSEnglish: "Gregorian US English", Hebrew: "Hebrew", Hijri: "Hijri", Japanese: "Japanese", Korean: "Korean", Taiwan: "Taiwan", ThaiBuddhist: "Thai Buddhist" }, check_alignment: { TopLeft: "TopLeft", TopCenter: "TopCenter", TopRight: "TopRight", MiddleLeft: "MiddleLeft", MiddleCenter: "MiddleCenter", MiddleRight: "MiddleRight", BottomLeft: "BottomLeft", BottomCenter: "BottomCenter", BottomRight: "BottomRight" }, check_style: { Check: "Check", Circle: "Circle", Cross: "Cross", Diamond: "Diamond", Square: "Square", Star: "Star" }, collate_by: { Simple: "Simple", ValueIndex: "ValueIndex", Value: "Value" }, collation: { Default: "Default", Albanian: "Albanian", Arabic: "Arabic", Chinese_PRC: "Chinese PRC", Chinese_PRC_Stroke: "Chinese PRC Stroke", Chinese_Taiwan_Bopomofo: "Chinese Taiwan Bopomofo", Chinese_Taiwan_Stroke: "Chinese Taiwan Stroke", Croatian: "Croatian", Cyrillic_General: "Cyrillic General", Czech: "Czech", Danish_Norwegian: "Danish Norwegian", Estonian: "Estonian", Finnish_Swedish: "Finnish Swedish", French: "French", Georgian_Modern_Sort: "Georgian Modern Sort", German_PhoneBook: "German Phone Book", Greek: "Greek", Hebrew: "Hebrew", Hindi: "Hindi", Hungarian: "Hungarian", Hungarian_Technical: "Hungarian Technical", Icelandic: "Icelandic", Japanese: "Japanese", Japanese_Unicode: "Japanese Unicode", Korean_Wansung: "Korean Wansung", Korean_Wansung_Unicode: "Korean Wansung Unicode", Latin1_General: "Latin-1 General", Latvian: "Latvian", Lithuanian: "Lithuanian", Lithuanian_Classic: "Lithuanian Classic", FYRO_Macedonian: "Macedonian FYRO", Polish: "Polish", Romanian: "Romanian", Slovak: "Slovak", Slovenian: "Slovenian", Spanish_Mexican_Trad: "Spanish Mexican Traditional", Spanish_Modern: "Spanish Modern", Thai: "Thai", Turkish: "Turkish", Ukrainian: "Ukrainian", Vietnamese: "Vietnamese" }, data_element_output: { Auto: "Auto", Output: "Output", NoOutput: "NoOutput", ContentsOnly: "ContentsOnly" }, data_element_output_aon: { Auto: "Auto", Output: "Output", NoOutput: "NoOutput" }, data_element_output_on: { Output: "Output", NoOutput: "NoOutput" }, data_element_style: { Auto: "Auto", AttributeNormal: "AttributeNormal", ElementNormal: "ElementNormal" }, data_label_position: { Auto: "Auto", TopLeft: "TopLeft", Top: "Top", TopRight: "TopRight", Left: "Left", Center: "Center", Right: "Right", BottomLeft: "BottomLeft", Bottom: "Bottom", BottomRight: "BottomRight" }, data_visualizer_color_type: { colorScale: "Color Scale" }, data_visualizer_gradient_type: { Horizontal: "Horizontal", Vertical: "Vertical", DiagonalUp: "DiagonalUp", DiagonalDown: "DiagonalDown", FromCenter: "FromCenter", FromCorner: "FromCorner" }, data_visualizer_hatch_style: { BackwardDiagonal: "BackwardDiagonal", Cross: "Cross", DarkDownwardDiagonal: "DarkDownwardDiagonal", DarkHorizontal: "DarkHorizontal", DarkUpwardDiagonal: "DarkUpwardDiagonal", DarkVertical: "DarkVertical", DashedDownwardDiagonal: "DashedDownwardDiagonal", DashedHorizontal: "DashedHorizontal", DashedUpwardDiagonal: "DashedUpwardDiagonal", DashedVertical: "DashedVertical", DiagonalBrick: "DiagonalBrick", DiagonalCross: "DiagonalCross", Divot: "Divot", DottedDiamond: "DottedDiamond", DottedGrid: "DottedGrid", ForwardDiagonal: "ForwardDiagonal", Horizontal: "Horizontal", HorizontalBrick: "HorizontalBrick", LargeCheckerBoard: "LargeCheckerBoard", LargeConfetti: "LargeConfetti", LargeGrid: "LargeGrid", LightDownwardDiagonal: "LightDownwardDiagonal", LightHorizontal: "LightHorizontal", LightUpwardDiagonal: "LightUpwardDiagonal", LightVertical: "LightVertical", NarrowHorizontal: "NarrowHorizontal", NarrowVertical: "NarrowVertical", OutlinedDiamond: "OutlinedDiamond", Percent05: "Percent05", Percent10: "Percent10", Percent20: "Percent20", Percent25: "Percent25", Percent30: "Percent30", Percent40: "Percent40", Percent50: "Percent50", Percent60: "Percent60", Percent70: "Percent70", Percent75: "Percent75", Percent80: "Percent80", Percent90: "Percent90", Plaid: "Plaid", Shingle: "Shingle", SmallCheckerBoard: "SmallCheckerBoard", SmallConfetti: "SmallConfetti", SmallGrid: "SmallGrid", SolidDiamond: "SolidDiamond", Sphere: "Sphere", Trellis: "Trellis", Vertical: "Vertical", Wave: "Wave", Weave: "Weave", WideDownwardDiagonal: "WideDownwardDiagonal", WideUpwardDiagonal: "WideUpwardDiagonal", ZigZag: "ZigZag" }, data_visualizer_icon_set_type: { Checkbox: "Checkbox", "3TrafficLights": "3TrafficLights", Arrows: "Arrows", Blank: "Blank", Flags: "Flags", GrayArrows: "GrayArrows", Quarters: "Quarters", Ratings: "Ratings", RedToBlack: "RedToBlack", Signs: "Signs", Symbols1: "Symbols1", Symbols2: "Symbols2", TrafficLights: "TrafficLights" }, data_visualizer_icon_set_value: { true: "True", false: "False" }, data_visualizer_image_type: { iconSet: "Icon Set", rangeBar: "Range Bar", dataBar: "Data Bar", gradient: "Gradient", hatch: "Hatch" }, dataset_option: { true: "True", false: "False", Auto: "Auto" }, dataset_query_command_type: { Text: "Text", StoredProcedure: "StoredProcedure" }, direction: { LTR: "Ltr", RTL: "Rtl" }, display_type: { Galley: "Galley", Page: "Page" }, documentmap_numbering_style: { None: "None", Decimal: "1, 2, 3, 4, 5", DecimalLeadingZero: "01, 02, 03, 04, 05", LowerRoman: "i, ii, iii, iv, v", UpperRoman: "I, II, III, IV, V", LowerLatin: "a, b, c, d, e", UpperLatin: "A, B, C, D, E", CircledNumber: "\u2460, \u2461, \u2462, \u2463, \u2464", KatakanaBrackets: "(\u30A2), (\u30A4), (\u30A6), (\u30A8), (\u30AA)", KatakanaIrohaBrackets: "\u30A4), \u30ED), \u30CF), \u30CB), \u30DB)", Katakana: "\u30A2, \u30A4, \u30A6, \u30A8, \u30AA", KatakanaIroha: "\u30A4, \u30ED, \u30CF, \u30CB, \u30DB", KatakanaLower: "\uFF71, \uFF72, \uFF73, \uFF74, \uFF75", KatakanaIrohaLower: "\uFF68, \uFF9B, \uFF8A, \uFF86, \uFF8E", LowerGreek: "\u03B1, \u03B2, \u03B3, \u03B4, \u03B5", UpperGreek: "\u0391, \u0392, \u0393, \u0394, \u0395", LowerArmenian: "\u0561, \u0562, \u0563, \u0564, \u0565", UpperArmenian: "\u0531, \u0532, \u0533, \u0534, \u0535", Georgian: "\u10D0, \u10D1, \u10D2, \u10D3, \u10D4" }, documentmap_source: { Labels: "Labels", Headings: "Headings", All: "All", None: "None" }, dvchart_aggregate_type: { None: "None", Average: "Average", Count: "Count", CountDistinct: "CountDistinct", CountOfAll: "CountOfAll", List: "List", Max: "Max", Min: "Min", PopulationStandardDeviation: "PopulationStandardDeviation", PopulationVariance: "PopulationVariance", Range: "Range", StandardDeviation: "StandardDeviation", Sum: "Sum", Variance: "Variance" }, dvchart_axis_position: { None: "None", Near: "Near", Far: "Far" }, dvchart_axis_type: { X: "X", Y: "Y" }, dvchart_axis_date_mode: { Default: "Default", Millisecond: "Millisecond", Second: "Second", Minute: "Minute", Hour: "Hour", Day: "Day", Week: "Week", Month: "Month", Year: "Year" }, dvchart_clipping_mode: { None: "None", Clip: "Clip", Fit: "Fit" }, dvchart_encoding_field_type: { Simple: "Simple", Complex: "Complex" }, dvchart_encoding_sort: { None: "None", Ascending: "Ascending", Descending: "Descending" }, dvchart_group_type: { None: "None", Cluster: "Cluster", Stack: "Stack" }, dvchart_group_type_wizard: { Cluster: "Cluster", Stacked: "Stack", PercentStacked: "Percentage Stack" }, dvchart_halign: { Left: "Left", Center: "Center", Right: "Right" }, dvchart_legend_position: { Bottom: "Bottom", Left: "Left", Right: "Right", Top: "Top" }, dvchart_line_aspect: { Default: "Default", Spline: "Spline", StepCenter: "StepCenter", StepLeft: "StepLeft", StepRight: "StepRight" }, dvchart_line_position: { Auto: "Auto", Center: "Center" }, dvchart_orientation: { Horizontal: "Horizontal", Vertical: "Vertical" }, dvchart_axis_overlapping_labels: { Auto: "Auto", Show: "Show" }, dvchart_overlapping_labels: { Auto: "Auto", Show: "Show", Hide: "Hide" }, dvchart_palette: { Custom: "Custom", Aspect: "Aspect", Blue: "Blue", Blue2: "Blue2", BlueGreen: "BlueGreen", BlueWarm: "BlueWarm", Cerulan: "Cerulan", Cocoa: "Cocoa", Coral: "Coral", Cyborg: "Cyborg", Dark: "Dark", Darkly: "Darkly", Flatly: "Flatly", Grayscale: "Grayscale", Green: "Green", GreenYellow: "GreenYellow", HighContrast: "HighContrast", Light: "Light", Marquee: "Marquee", Median: "Median", Midnight: "Midnight", Modern: "Modern", Office: "Office", Office2010: "Office2010", Orange: "Orange", OrangeRed: "OrangeRed", Organic: "Organic", Paper: "Paper", Red: "Red", RedOrange: "RedOrange", RedViolet: "RedViolet", Slate: "Slate", Slipstream: "Slipstream", Standard: "Standard", Superhero: "Superhero", Violet: "Violet", Violet2: "Violet2", Yellow: "Yellow", YellowOrange: "YellowOrange", Zen: "Zen" }, dvchart_plot_overlay_type: { ReferenceLine: "ReferenceLine", ReferenceBand: "ReferenceBand", LinearTrendline: "LinearTrendline", ExponentialTrendline: "ExponentialTrendline", PowerTrendline: "PowerTrendline", LogarithmicTrendline: "LogarithmicTrendline", PolynomialTrendline: "PolynomialTrendline", FourierTrendline: "FourierTrendline", MovingAverageTrendline: "MovingAverageTrendline", CumulativeMovingAverageTrendline: "CumulativeMovingAverageTrendline", ExponentialMovingAverageTrendline: "ExponentialMovingAverageTrendline", WeightedMovingAverageTrendline: "WeightedMovingAverageTrendline", MovingAnnualTotalTrendline: "MovingAnnualTotalTrendline" }, dvchart_plot_overlay_display: { Front: "Front", Back: "Back" }, dvchart_plot_overlay_detail_level: { Group: "Group", Total: "Total" }, dvchart_plot_overlay_axis: { X: "X", Y: "Y" }, dvchart_plot_overlay_aggregate_type: { Sum: "Sum", Count: "Count", Average: "Average", Max: "Max", Min: "Min", Median: "Median", Percentile: "Percentile" }, dvchart_plot_rule_properties: { BackgroundColor: "BackgroundColor", LabelTemplate: "LabelTemplate", LineColor: "LineColor", LineStyle: "LineStyle", LineWidth: "LineWidth", SymbolBackgroundColor: "SymbolBackgroundColor", SymbolLineColor: "SymbolLineColor", SymbolLineStyle: "SymbolLineStyle", SymbolLineWidth: "SymbolLineWidth", TooltipTemplate: "TooltipTemplate" }, dvchart_plot_type: { Bar: "Bar", Line: "Line", Area: "Area", Scatter: "Scatter", HighLowOpenClose: "HighLowOpenClose", Candlestick: "Candlestick" }, dvchart_scale: { Linear: "Linear", Logarithmic: "Logarithmic", Ordinal: "Ordinal", Percentage: "Percentage" }, dvchart_show_nulls: { Connected: "Connected", Gaps: "Gaps", Zeros: "Zeros" }, dvchart_symbol_shape: { Auto: "Auto", Dot: "Dot", Box: "Box", Diamond: "Diamond", Triangle: "Triangle", X: "X", Dash: "Dash", Plus: "Plus" }, dvchart_target: { Label: "Label", ToolTip: "ToolTip" }, dvchart_template: { valueField: { name: "Value Field Name", value: "Value Field Value" }, PercentageDetail_p0: "Percentage In Details", PercentageCategory_p0: "Percentage In Category", categoryField: { name: "Category Field Name", value: "Category Field Value" }, detailFields: { name: "Details Field Name", value: "Details Field Value" }, colorField: { name: "Color Field Name", value: "Color Field Value" }, shapeField: { name: "Shape Field Name", value: "Shape Field Value" }, sizeField: { name: "Size Field Name", value: "Size Field Value" } }, dvchart_text_position: { Auto: "Auto", Center: "Center", Inside: "Inside", Outside: "Outside" }, dvchart_tick_mark: { None: "None", Cross: "Cross", Inside: "Inside", Outside: "Outside" }, dvchart_valign: { Top: "Top", Middle: "Middle", Bottom: "Bottom" }, end_cap: { None: "None", Arrow: "Arrow" }, font_size: { "8pt": "8pt", "9pt": "9pt", "10pt": "10pt", "11pt": "11pt", "12pt": "12pt", "14pt": "14pt", "16pt": "16pt", "18pt": "18pt", "20pt": "20pt", "22pt": "22pt", "24pt": "24pt", "26pt": "26pt", "28pt": "28pt", "36pt": "36pt", "48pt": "48pt", "72pt": "72pt" }, font_style: { Normal: "Normal", Italic: "Italic" }, font_weight: { Lighter: "Lighter", Thin: "Thin", ExtraLight: "ExtraLight", Light: "Light", Normal: "Normal", Medium: "Medium", SemiBold: "SemiBold", Bold: "Bold", ExtraBold: "ExtraBold", Heavy: "Heavy", Bolder: "Bolder" }, gradient_type: { None: "None", LeftRight: "LeftRight", TopBottom: "TopBottom", Center: "Center", DiagonalLeft: "DiagonalLeft", DiagonalRight: "DiagonalRight", HorizontalCenter: "HorizontalCenter", VerticalCenter: "VerticalCenter" }, grid_mode: { Dots: "Dots", Lines: "Lines" }, horizontal_align: { Left: "Left", Center: "Center", Right: "Right" }, image_repeat: { Repeat: "Repeat", NoRepeat: "NoRepeat", RepeatX: "RepeatX", RepeatY: "RepeatY" }, image_sizing: { AutoSize: "AutoSize", Fit: "Fit", FitProportional: "FitProportional", Clip: "Clip" }, image_source: { External: "External", Embedded: "Embedded", Database: "Database" }, input_type: { Text: "Text", CheckBox: "CheckBox" }, keep_with_group: { None: "None", Before: "Before", After: "After" }, label_font_style: { Regular: "Regular", Bold: "Bold", Italic: "Italic", Underline: "Underline", Strikeout: "Strikeout" }, labels_text_orientation: { Auto: "Auto", Angled: "Angled", Horizontal: "Horizontal", Rotated90: "Rotated90", Rotated270: "Rotated270", Stacked: "Stacked" }, language: { Default: "Default", "af-ZA": "Afrikaans - South Africa", "sq-AL": "Albanian - Albania", "gsw-FR": "Alsatian - France", "am-ET": "Amharic - Ethiopia", "ar-DZ": "Arabic - Algeria", "ar-BH": "Arabic - Bahrain", "ar-EG": "Arabic - Egypt", "ar-IQ": "Arabic - Iraq", "ar-JO": "Arabic - Jordan", "ar-KW": "Arabic - Kuwait", "ar-LB": "Arabic - Lebanon", "ar-LY": "Arabic - Libya", "ar-MA": "Arabic - Morocco", "ar-OM": "Arabic - Oman", "ar-QA": "Arabic - Qatar", "ar-SA": "Arabic - Saudi Arabia", "ar-SY": "Arabic - Syria", "ar-TN": "Arabic - Tunisia", "ar-AE": "Arabic - United Arab Emirates", "ar-YE": "Arabic - Yemen", "hy-AM": "Armenian - Armenia", "as-IN": "Assamese - India", "az-AZ-Cyrl": "Azeri (Cyrillic) - Azerbaijan", "az-AZ-Latn": "Azeri (Latin) - Azerbaijan", "ba-RU": "Bashkir - Russia", "eu-ES": "Basque - Basque", "be-BY": "Belarusian - Belarus", "bn-BD": "Bengali - Bangladesh", "bn-IN": "Bengali - India", "bs-Cyrl-BA": "Bosnian (Cyrillic) - Bosnia and Herzegovina", "bs-Latn-BA": "Bosnian (Latin) - Bosnia and Herzegovina", "br-FR": "Breton - France", "bg-BG": "Bulgarian - Bulgaria", "ca-ES": "Catalan - Catalan", "zh-HK": "Chinese - Hong Kong SAR", "zh-MO": "Chinese - Macau SAR", "zh-CN": "Chinese - People's Republic of China", "zh-SG": "Chinese - Singapore", "zh-TW": "Chinese - Taiwan", "co-FR": "Corsican - France", "hr-HR": "Croatian - Croatia", "hr-BA": "Croatian (Latin) - Bosnia and Herzegovina", "cs-CZ": "Czech - Czech Republic", "da-DK": "Danish - Denmark", "prs-AF": "Dari - Afghanistan", "div-MV": "Dhivehi - Maldives", "nl-BE": "Dutch - Belgium", "nl-NL": "Dutch - The Netherlands", "en-AU": "English - Australia", "en-BZ": "English - Belize", "en-CA": "English - Canada", "en-CB": "English - Caribbean", "en-IN": "English - India", "en-IE": "English - Ireland", "en-JM": "English - Jamaica", "en-MY": "English - Malaysia", "en-NZ": "English - New Zealand", "en-PH": "English - Philippines", "en-SG": "English - Singapore", "en-ZA": "English - South Africa", "en-TT": "English - Trinidad and Tobago", "en-GB": "English - United Kingdom", "en-US": "English - United States", "en-ZW": "English - Zimbabwe", "et-EE": "Estonian - Estonia", "fo-FO": "Faroese - Faroe Islands", "fil-PH": "Filipino - Philippines", "fa-IR": "Persian - Iran", "fi-FI": "Finnish - Finland", "fr-BE": "French - Belgium", "fr-CA": "French - Canada", "fr-FR": "French - France", "fr-LU": "French - Luxembourg", "fr-MC": "French - Monaco", "fr-CH": "French - Switzerland", "fy-NL": "Frisian - Netherlands", "gl-ES": "Galician - Galician", "ka-GE": "Georgian - Georgia", "de-AT": "German - Austria", "de-DE": "German - Germany", "de-LI": "German - Liechtenstein", "de-LU": "German - Luxembourg", "de-CH": "German - Switzerland", "el-GR": "Greek - Greece", "kl-GL": "Greenlandic - Greenland", "gu-IN": "Gujarati - India", "ha-Latn-NG": "Hausa (Latin) - Nigeria", "he-IL": "Hebrew - Israel", "hi-IN": "Hindi - India", "hu-HU": "Hungarian - Hungary", "is-IS": "Icelandic - Iceland", "ig-NG": "Igbo - Nigeria", "id-ID": "Indonesian - Indonesia", "iu-Latn-CA": "Inuktitut (Latin) - Canada", "iu-Cans-CA": "Inuktitut (Syllabics) - Canada", "ga-IE": "Irish - Ireland", "xh-ZA": "isiXhosa - South Africa", "zu-ZA": "isiZulu - South Africa", "it-IT": "Italian - Italy", "it-CH": "Italian - Switzerland", "ja-JP": "Japanese - Japan", "kn-IN": "Kannada - India", "kk-KZ": "Kazakh - Kazakhstan", "km-KH": "Khmer - Cambodia", "qut-GT": "K'iche - Guatemala", "rw-RW": "Kinyarwanda - Rwanda", "sw-KE": "Swahili - Kenya", "kok-IN": "Konkani - India", "ko-KR": "Korean - Korea", "ky-KG": "Kyrgyz - Kyrgyzstan", "lo-LA": "Lao - Lao P.D.R.", "lv-LV": "Latvian - Latvia", "lt-LT": "Lithuanian - Lithuania", "wee-DE": "Lower Sorbian - Germany", "lb-LU": "Luxembourgish - Luxembourg", "mk-MK": "Macedonian - Macedonia", "ms-BN": "Malay - Brunei", "ms-MY": "Malay - Malaysia", "ml-IN": "Malayalam - India", "mt-MT": "Maltese - Malta", "mi-NZ": "Maori - New Zealand", "arn-CL": "Mapudungun - Chile", "mr-IN": "Marathi - India", "moh-CA": "Mohawk - Mohawk", "mn-Mong-MN": "Mongolian - Mongolia", "mn-MN": "Mongolian (Cyrillic) - Mongolia", "mn-Mong-CN": "Mongolian (Traditional Mongolian) - PRC", "ne-NP": "Nepali - Nepal", "nb-NO": "Norwegian (Bokm\xE5l) - Norway", "nn-NO": "Norwegian (Nynorsk) - Norway", "oc-FR": "Occitan - France", "or-IN": "Oriya - India", "ps-AF": "Pashto - Afghanistan", "pl-PL": "Polish - Poland", "pt-BR": "Portuguese - Brazil", "pt-PT": "Portuguese - Portugal", "pa-IN": "Punjabi - India", "quz-BO": "Quechua - Bolivia", "quz-EC": "Quechua - Ecuador", "quz-PE": "Quechua - Peru", "ro-RO": "Romanian - Romania", "rm-CH": "Romansh - Switzerland", "ru-RU": "Russian - Russia", "smn-FI": "Sami, Inari - Finland", "smj-NO": "Sami, Lule - Norway", "smj-SE": "Sami, Lule - Sweden", "se-FI": "Sami, Northern - Finland", "se-NO": "Sami, Northern - Norway", "se-SE": "Sami, Northern - Sweden", "sms-FI": "Sami, Skolt - Finland", "sma-NO": "Sami, Southern - Norway", "sma-SE": "Sami, Southern - Sweden", "sa-IN": "Sanskrit - India", "gd-GB": "Scottish Gaelic - United Kingdom", "sr-SP-Cyrl": "Serbian (Cyrillic) - Serbia", "sr-SP-Latn": "Serbian (Latin) - Serbia", "nso-ZA": "Sesotho sa Leboa - South Africa", "tn-ZA": "Setswana - South Africa", "si-LK": "Sinhala - Sri Lanka", "sk-SK": "Slovak - Slovakia", "sl-SI": "Slovenian - Slovenia", "es-AR": "Spanish - Argentina", "es-BO": "Spanish - Bolivia", "es-CL": "Spanish - Chile", "es-CO": "Spanish - Colombia", "es-CR": "Spanish - Costa Rica", "es-DO": "Spanish - Dominican Republic", "es-EC": "Spanish - Ecuador", "es-SV": "Spanish - El Salvador", "es-GT": "Spanish - Guatemala", "es-HN": "Spanish - Honduras", "es-MX": "Spanish - Mexico", "es-NI": "Spanish - Nicaragua", "es-PA": "Spanish - Panama", "es-PY": "Spanish - Paraguay", "es-PE": "Spanish - Peru", "es-PR": "Spanish - Puerto Rico", "es-ES": "Spanish - Spain", "es-US": "Spanish - United States", "es-UY": "Spanish - Uruguay", "es-VE": "Spanish - Venezuela", "sv-FI": "Swedish - Finland", "sv-SE": "Swedish - Sweden", "syr-SY": "Syriac - Syria", "tg-Cyrl-TJ": "Tajik (Cyrillic) - Tajikistan", "tzm-Latn-DZ": "Tamazight (Latin) - Algeria", "ta-IN": "Tamil - India", "tt-RU": "Tatar - Russia", "te-IN": "Telugu - India", "th-TH": "Thai - Thailand", "bo-CN": "Tibetan - PRC", "tr-TR": "Turkish - Turkey", "tk-TM": "Turkmen - Turkmenistan", "uk-UA": "Ukrainian - Ukraine", "wen-DE": "Upper Sorbian - Germany", "ur-PK": "Urdu - Pakistan", "ug-CN": "Uyghur - PRC", "uz-UZ-Cyrl": "Uzbek (Cyrillic) - Uzbekistan", "uz-UZ-Latn": "Uzbek (Latin) - Uzbekistan", "vi-VN": "Vietnamese - Vietnam", "cy-GB": "Welsh - United Kingdom", "wo-SN": "Wolof - Senegal", "sah-RU": "Yakut - Russia", "ii-CN": "Yi - PRC", "yo-NG": "Yoruba - Nigeria" }, layout_direction: { LTR: "Ltr", RTL: "Rtl" }, layout_order: { ZOrder: "Z-order", NOrder: "N-order" }, legend_layout: { Column: "Column", Row: "Row", Table: "Table" }, legend_position: { TopLeft: "TopLeft", TopCenter: "TopCenter", TopRight: "TopRight", LeftTop: "LeftTop", LeftCenter: "LeftCenter", LeftBottom: "LeftBottom", RightTop: "RightTop", RightCenter: "RightCenter", RightBottom: "RightBottom", BottomRight: "BottomRight", BottomCenter: "BottomCenter", BottomLeft: "BottomLeft" }, line_control_style: { None: "None", Solid: "Solid", Dashed: "Dashed", Dotted: "Dotted", DashDot: "DashDot", DashDotDot: "DashDotDot", Double: "Double" }, marker_type: { None: "None", Auto: "Auto", Circle: "Circle", Cross: "Cross", Diamond: "Diamond", Square: "Square", Triangle: "Triangle" }, mime_type: { "image/bmp": "image/bmp", "image/jpeg": "image/jpeg", "image/gif": "image/gif", "image/png": "image/png", "image/x-emf": "image/x-emf", "image/x-wmf": "image/x-wmf" }, numeral_variant: { 1: "1", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7" }, operator: { Equal: "Equal", Like: "Like", NotEqual: "NotEqual", GreaterThan: "GreaterThan", GreaterThanOrEqual: "GreaterThanOrEqual", LessThan: "LessThan", LessThanOrEqual: "LessThanOrEqual", TopN: "TopN", BottomN: "BottomN", TopPercent: "TopPercent", BottomPercent: "BottomPercent", In: "In", Between: "Between" }, order_by_condition: { None: "None", Label: "Label", Value: "Value" }, orientation: { Horizontal: "Horizontal", Vertical: "Vertical" }, page_break: { None: "None", Start: "Start", End: "End", StartAndEnd: "StartAndEnd" }, page_break_with_between: { None: "None", Start: "Start", End: "End", StartAndEnd: "StartAndEnd", Between: "Between" }, page_orientation: { Portrait: "Portrait", Landscape: "Landscape" }, plot_type: { Auto: "Auto", Line: "Line", Point: "Point" }, projection_mode: { Perspective: "Perspective", Orthographic: "Orthographic" }, repeat_blank_rows: { None: "None", FillPage: "FillPage", FillGroup: "FillGroup" }, reportparameter_datatype: { Boolean: "Boolean", Date: "Date", DateTime: "DateTime", Integer: "Integer", Float: "Float", String: "String" }, reportparts_property_type: { boolean: "Boolean", integer: "Integer", float: "Float", string: "String", length: "Length", color: "Color", fontFamily: "FontFamily", fontSize: "FontSize", fontStyle: "FontStyle", fontWeight: "FontWeight", textDecoration: "TextDecoration", lineWidth: "LineWidth", borderStyle: "BorderStyle", lineStyle: "LineStyle" }, reportparts_sizemode: { Resizable: "Resizable", Fixed: "Fixed" }, rich_text_markup: { HTML: "HTML" }, shading: { None: "None", Simple: "Simple", Real: "Real" }, shape_styles: { Rectangle: "Rectangle", RoundRect: "RoundRect", Ellipse: "Ellipse" }, size_type: { Default: "Default", FitToPage: "Fit To Page", FitToWidth: "Fit To Width" }, sparkline_type: { Line: "Line", Columns: "Columns", Whiskers: "Whiskers", Area: "Area", StackedBar: "StackedBar" }, new_page: { Next: "Next", Odd: "Odd", Even: "Even" }, target_shape: { Line: "Line", Dot: "Dot", Square: "Square" }, text_align: { General: "General", Left: "Left", Center: "Center", Right: "Right", Justify: "Justify" }, text_align_glcr: { General: "General", Left: "Left", Center: "Center", Right: "Right" }, text_decoration: { None: "None", Underline: "Underline", DoubleUnderline: "DoubleUnderline", Overline: "Overline", LineThrough: "LineThrough" }, text_justify: { Auto: "Auto", Distribute: "Distribute", DistributeAllLines: "DistributeAllLines" }, text_orientation: { Auto: "Auto", Horizontal: "Horizontal", Rotated90: "Rotated90", Rotated270: "Rotated270", Stacked: "Stacked" }, tick_mark: { None: "None", Inside: "Inside", Outside: "Outside", Cross: "Cross" }, title_position: { Center: "Center", Near: "Near", Far: "Far" }, unicode_bidi: { Normal: "Normal", Embed: "Embed", BidiOverride: "BidiOverride" }, upright_in_vertical_text: { None: "None", Digits: "Digits", DigitsAndLatinLetters: "DigitsAndLatinLetters" }, vertical_align: { Top: "Top", Middle: "Middle", Bottom: "Bottom" }, wrap_mode: { NoWrap: "NoWrap", CharWrap: "CharWrap", WordWrap: "WordWrap" }, writing_mode: { "lr-tb": "lr-tb", "tb-rl": "tb-rl" }, grow_direction: { Column: "Column", ColumnReverse: "ColumnReverse", Row: "Row", RowReverse: "RowReverse" }, overflow: { Auto: "Auto", Clip: "Clip", Scroll: "Scroll", Grow: "Grow" }, pve_datetime_range_unit: { Year: "Year", Quarter: "Quarter", Month: "Month", Week: "Week", Day: "Day", Hour: "Hour", Minute: "Minute", Second: "Second" }, pve_datetime_range_type: { Current: "Current", Last: "Last", Next: "Next", ToDate: "ToDate", LastToDate: "LastToDate" }, pve_datetime_range_type_time: { Current: "Current", Last: "Last", Next: "Next" }, pve_datetime_range_type_second: { Last: "Last", Next: "Next" } }, "enums-RPX": { mime_type: { "image/bmp": "image/bmp", "image/jpeg": "image/jpeg", "image/gif": "image/gif", "image/png": "image/png", "image/x-emf": "image/x-emf", "image/x-wmf": "image/x-wmf" }, barcode_style: { None: "None", Ansi39: "Ansi39", Ansi39x: "Ansi39x", Code_2_of_5: "Code_2_of_5", Code25intlv: "Code25intlv", Code25mat: "Code25mat", Matrix_2_of_5: "Matrix_2_of_5", Code39: "Code39", Code39x: "Code39x", Code_128_A: "Code_128_A", Code_128_B: "Code_128_B", Code_128_C: "Code_128_C", Code_128auto: "Code_128auto", Code_93: "Code_93", Code93x: "Code93x", MSI: "MSI", PostNet: "PostNet", Codabar: "Codabar", EAN_8: "EAN_8", EAN_13: "EAN_13", UPC_A: "UPC_A", UPC_E0: "UPC_E0", UPC_E1: "UPC_E1", RM4SCC: "RM4SCC", UCCEAN128: "UCCEAN128", QRCode: "QRCode", Code49: "Code49", JapanesePostal: "JapanesePostal", Pdf417: "Pdf417", EAN128FNC1: "EAN128FNC1", RSS14: "RSS14", RSS14Truncated: "RSS14Truncated", RSS14Stacked: "RSS14Stacked", RSS14StackedOmnidirectional: "RSS14StackedOmnidirectional", RSSExpanded: "RSSExpanded", RSSExpandedStacked: "RSSExpandedStacked", RSSLimited: "RSSLimited", DataMatrix: "DataMatrix", MicroPDF417: "MicroPDF417", MicroQRCode: "MicroQRCode", MaxiCode: "MaxiCode", GS1QRCode: "GS1QRCode", GS1DataMatrix: "GS1DataMatrix", Aztec: "Aztec", IntelligentMail: "IntelligentMail", ITF14: "ITF14", Code_11: "Code_11", SSCC_18: "SSCC_18", Telepen: "Telepen", Pharmacode: "Pharmacode", PZN: "PZN", HIBCCode128: "HIBCCode128", HIBCCode39: "HIBCCode39", ISBN: "ISBN", ISSN: "ISSN", ISMN: "ISMN", IATA_2_of_5: "IATA_2_of_5", BC412: "BC412", Plessey: "Plessey", IntelligentMailPackage: "IntelligentMailPackage" }, barcode_caption_position: { None: "None", Above: "Above", Below: "Below" }, barcode_rotation: { None: "None", Rotate90Degrees: "Rotate90Degrees", Rotate180Degrees: "Rotate180Degrees", Rotate270Degrees: "Rotate270Degrees" }, border_style_inputfield: { None: "None", Solid: "Solid", Dashed: "Dashed", Inset: "Inset" }, check_style: { Check: "Check", Circle: "Circle", Cross: "Cross", Diamond: "Diamond", Square: "Square", Star: "Star" }, column_direction: { DownAcross: "DownAcross", AcrossDown: "AcrossDown" }, group_keep_together: { None: "None", FirstDetail: "FirstDetail", All: "All" }, repeat_style: { None: "None", OnPage: "OnPage", OnColumn: "OnColumn", All: "All", OnPageIncludeNoDetail: "OnPageIncludeNoDetail" }, new_page: { None: "None", Before: "Before", After: "After", BeforeAfter: "BeforeAfter" }, new_column: { None: "None", Before: "Before", After: "After", BeforeAfter: "BeforeAfter" }, script_language: { "C#": "C#", VBNET: "VB.NET" }, compatibility_mode: { GDI: "GDI", CrossPlatform: "CrossPlatform" }, field_type: { None: "None", String: "String", Date: "Date", Int32: "Int32", Integer: "Integer", Float: "Float", Double: "Double", Boolean: "Boolean" }, calculated_field_type: { None: "None", String: "String", Date: "Date", Int32: "Int32", Float: "Float", Double: "Double", Boolean: "Boolean" }, parameter_type: { String: "String", Date: "Date", Boolean: "Boolean" }, collate: { Default: "Default", Collate: "Collate", DontCollate: "DontCollate" }, duplex: { Default: "Default", Simplex: "Simplex", Vertical: "Vertical", Horizontal: "Horizontal" }, page_orientation: { Default: "Default", Portrait: "Portrait", Landscape: "Landscape" }, paper_source_kind: { Upper: "Upper", Lower: "Lower", Middle: "Middle", Manual: "Manual", Envelope: "Envelope", ManualFeed: "ManualFeed", AutomaticFeed: "AutomaticFeed", TractorFeed: "TractorFeed", SmallFormat: "SmallFormat", LargeFormat: "LargeFormat", LargeCapacity: "LargeCapacity", Cassette: "Cassette", FormSource: "FormSource", Custom: "Custom" }, paper_kind: { Custom: "Custom", Letter: "Letter", LetterSmall: "LetterSmall", Tabloid: "Tabloid", Ledger: "Ledger", Legal: "Legal", Statement: "Statement", Executive: "Executive", A3: "A3", A4: "A4", A4Small: "A4Small", A5: "A5", B4: "B4", B5: "B5", Folio: "Folio", Quarto: "Quarto", Standard10x14: "Standard10x14", Standard11x17: "Standard11x17", Note: "Note", Number9Envelope: "Number9Envelope", Number10Envelope: "Number10Envelope", Number11Envelope: "Number11Envelope", Number12Envelope: "Number12Envelope", Number14Envelope: "Number14Envelope", CSheet: "CSheet", DSheet: "DSheet", ESheet: "ESheet", DLEnvelope: "DLEnvelope", C5Envelope: "C5Envelope", C3Envelope: "C3Envelope", C4Envelope: "C4Envelope", C6Envelope: "C6Envelope", C65Envelope: "C65Envelope", B4Envelope: "B4Envelope", B5Envelope: "B5Envelope", B6Envelope: "B6Envelope", ItalyEnvelope: "ItalyEnvelope", MonarchEnvelope: "MonarchEnvelope", PersonalEnvelope: "PersonalEnvelope", USStandardFanfold: "USStandardFanfold", GermanStandardFanfold: "GermanStandardFanfold", GermanLegalFanfold: "GermanLegalFanfold", IsoB4: "IsoB4", JapanesePostcard: "JapanesePostcard", Standard9x11: "Standard9x11", Standard10x11: "Standard10x11", Standard15x11: "Standard15x11", InviteEnvelope: "InviteEnvelope", LetterExtra: "LetterExtra", LegalExtra: "LegalExtra", TabloidExtra: "TabloidExtra", A4Extra: "A4Extra", LetterTransverse: "LetterTransverse", A4Transverse: "A4Transverse", LetterExtraTransverse: "LetterExtraTransverse", APlus: "APlus", BPlus: "BPlus", LetterPlus: "LetterPlus", A4Plus: "A4Plus", A5Transverse: "A5Transverse", B5Transverse: "B5Transverse", A3Extra: "A3Extra", A5Extra: "A5Extra", B5Extra: "B5Extra", A2: "A2", A3Transverse: "A3Transverse", A3ExtraTransverse: "A3ExtraTransverse", JapaneseDoublePostcard: "JapaneseDoublePostcard", A6: "A6", JapaneseEnvelopeKakuNumber2: "JapaneseEnvelopeKakuNumber2", JapaneseEnvelopeKakuNumber3: "JapaneseEnvelopeKakuNumber3", JapaneseEnvelopeChouNumber3: "JapaneseEnvelopeChouNumber3", JapaneseEnvelopeChouNumber4: "JapaneseEnvelopeChouNumber4", LetterRotated: "LetterRotated", A3Rotated: "A3Rotated", A4Rotated: "A4Rotated", A5Rotated: "A5Rotated", B4JisRotated: "B4JisRotated", B5JisRotated: "B5JisRotated", JapanesePostcardRotated: "JapanesePostcardRotated", JapaneseDoublePostcardRotated: "JapaneseDoublePostcardRotated", A6Rotated: "A6Rotated", JapaneseEnvelopeKakuNumber2Rotated: "JapaneseEnvelopeKakuNumber2Rotated", JapaneseEnvelopeKakuNumber3Rotated: "JapaneseEnvelopeKakuNumber3Rotated", JapaneseEnvelopeChouNumber3Rotated: "JapaneseEnvelopeChouNumber3Rotated", JapaneseEnvelopeChouNumber4Rotated: "JapaneseEnvelopeChouNumber4Rotated", B6Jis: "B6Jis", B6JisRotated: "B6JisRotated", Standard12x11: "Standard12x11", JapaneseEnvelopeYouNumber4: "JapaneseEnvelopeYouNumber4", JapaneseEnvelopeYouNumber4Rotated: "JapaneseEnvelopeYouNumber4Rotated", Prc16K: "Prc16K", Prc32K: "Prc32K", Prc32KBig: "Prc32KBig", PrcEnvelopeNumber1: "PrcEnvelopeNumber1", PrcEnvelopeNumber2: "PrcEnvelopeNumber2", PrcEnvelopeNumber3: "PrcEnvelopeNumber3", PrcEnvelopeNumber4: "PrcEnvelopeNumber4", PrcEnvelopeNumber5: "PrcEnvelopeNumber5", PrcEnvelopeNumber6: "PrcEnvelopeNumber6", PrcEnvelopeNumber7: "PrcEnvelopeNumber7", PrcEnvelopeNumber8: "PrcEnvelopeNumber8", PrcEnvelopeNumber9: "PrcEnvelopeNumber9", PrcEnvelopeNumber10: "PrcEnvelopeNumber10", Prc16KRotated: "Prc16KRotated", Prc32KRotated: "Prc32KRotated", Prc32KBigRotated: "Prc32KBigRotated", PrcEnvelopeNumber1Rotated: "PrcEnvelopeNumber1Rotated", PrcEnvelopeNumber2Rotated: "PrcEnvelopeNumber2Rotated", PrcEnvelopeNumber3Rotated: "PrcEnvelopeNumber3Rotated", PrcEnvelopeNumber4Rotated: "PrcEnvelopeNumber4Rotated", PrcEnvelopeNumber5Rotated: "PrcEnvelopeNumber5Rotated", PrcEnvelopeNumber6Rotated: "PrcEnvelopeNumber6Rotated", PrcEnvelopeNumber7Rotated: "PrcEnvelopeNumber7Rotated", PrcEnvelopeNumber8Rotated: "PrcEnvelopeNumber8Rotated", PrcEnvelopeNumber9Rotated: "PrcEnvelopeNumber9Rotated", PrcEnvelopeNumber10Rotated: "PrcEnvelopeNumber10Rotated" }, string_alignment: { Near: "Near", Center: "Center", Far: "Far" }, string_alignment_inputfield: { Left: "Left", Center: "Center", Right: "Right" }, content_alignment: { TopLeft: "TopLeft", TopCenter: "TopCenter", TopRight: "TopRight", MiddleLeft: "MiddleLeft", MiddleCenter: "MiddleCenter", MiddleRight: "MiddleRight", BottomLeft: "BottomLeft", BottomCenter: "BottomCenter", BottomRight: "BottomRight" }, line_style: { Transparent: "Transparent", Solid: "Solid", Dash: "Dash", Dot: "Dot", DashDot: "DashDot", DashDotDot: "DashDotDot", Double: "Double" }, size_mode: { Clip: "Clip", Stretch: "Stretch", Zoom: "Zoom" }, picture_alignment: { TopLeft: "TopLeft", TopRight: "TopRight", Center: "Center", BottomLeft: "BottomLeft", BottomRight: "BottomRight" }, shape_style: { Rectangle: "Rectangle", Ellipse: "Ellipse", RoundRect: "RoundRect" }, background_style: { Solid: "Solid", Gradient: "Gradient", Pattern: "Pattern" }, gradient_style: { Horizontal: "Horizontal", Vertical: "Vertical", DiagonalUp: "DiagonalUp", DiagonalDown: "DiagonalDown", FromCenter: "FromCenter", FromCorner: "FromCorner" }, hatch_style: { Horizontal: "Horizontal", Vertical: "Vertical", ForwardDiagonal: "ForwardDiagonal", BackwardDiagonal: "BackwardDiagonal", LargeGrid: "LargeGrid", DiagonalCross: "DiagonalCross", Percent05: "Percent05", Percent10: "Percent10", Percent20: "Percent20", Percent25: "Percent25", Percent30: "Percent30", Percent40: "Percent40", Percent50: "Percent50", Percent60: "Percent60", Percent70: "Percent70", Percent75: "Percent75", Percent80: "Percent80", Percent90: "Percent90", LightDownwardDiagonal: "LightDownwardDiagonal", LightUpwardDiagonal: "LightUpwardDiagonal", DarkDownwardDiagonal: "DarkDownwardDiagonal", DarkUpwardDiagonal: "DarkUpwardDiagonal", WideDownwardDiagonal: "WideDownwardDiagonal", WideUpwardDiagonal: "WideUpwardDiagonal", LightVertical: "LightVertical", LightHorizontal: "LightHorizontal", NarrowVertical: "NarrowVertical", NarrowHorizontal: "NarrowHorizontal", DarkVertical: "DarkVertical", DarkHorizontal: "DarkHorizontal", DashedDownwardDiagonal: "DashedDownwardDiagonal", DashedUpwardDiagonal: "DashedUpwardDiagonal", DashedHorizontal: "DashedHorizontal", DashedVertical: "DashedVertical", SmallConfetti: "SmallConfetti", LargeConfetti: "LargeConfetti", ZigZag: "ZigZag", Wave: "Wave", DiagonalBrick: "DiagonalBrick", HorizontalBrick: "HorizontalBrick", Weave: "Weave", Plaid: "Plaid", Divot: "Divot", DottedGrid: "DottedGrid", DottedDiamond: "DottedDiamond", Shingle: "Shingle", Trellis: "Trellis", Sphere: "Sphere", SmallGrid: "SmallGrid", SmallCheckerBoard: "SmallCheckerBoard", LargeCheckerBoard: "LargeCheckerBoard", OutlinedDiamond: "OutlinedDiamond", SolidDiamond: "SolidDiamond" }, summary_type: { None: "None", GrandTotal: "GrandTotal", PageTotal: "PageTotal", SubTotal: "SubTotal", PageCount: "PageCount" }, summary_func: { Sum: "Sum", Avg: "Avg", Count: "Count", Min: "Min", Max: "Max", Var: "Var", VarP: "VarP", StdDev: "StdDev", StdDevP: "StdDevP", DSum: "DSum", DAvg: "DAvg", DCount: "DCount", DVar: "DVar", DVarP: "DVarP", DStdDev: "DStdDev", DStdDevP: "DStdDevP" }, summary_running: { None: "None", Group: "Group", All: "All" }, richrext_rendering_type: { RTF: "RTF", Metafile: "Metafile", PNG: "PNG", TransparentPNG: "TransparentPNG" }, text_align: { Left: "Left", Right: "Right", Center: "Center", Justify: "Justify" }, text_justify: { Auto: "Auto", Distribute: "Distribute", Distribute_all_lines: "DistributeAllLines" }, vertical_align: { Top: "Top", Middle: "Middle", Bottom: "Bottom" }, format_string: { Page_PageNumber_of_PageCount_on_RunDateTime: "Page {PageNumber} of {PageCount} on {RunDateTime}", Page_PageNumber_of_PageCount: "Page {PageNumber} of {PageCount}", RunDateTime: "{RunDateTime:}", RunDateTime_M_d: "{RunDateTime:M/d}", RunDateTime_M_d_yy: "{RunDateTime:M/d/yy}", "RunDateTime_M_d_yyyy}": "{RunDateTime:M/d/yyyy}", RunDateTime_MM_dd_yy: "{RunDateTime:MM/dd/yy}", RunDateTime_MM_dd_yyyy: "{RunDateTime:MM/dd/yyyy}", RunDateTime_d_MMM: "{RunDateTime:d-MMM}", RunDateTime_d_MMM_yy: "{RunDateTime:d-MMM-yy}", RunDateTime_d_MMM_yyyy: "{RunDateTime:d-MMM-yyyy}", RunDateTime_dd_MMM_yy: "{RunDateTime:dd-MMM-yy}", RunDateTime_dd_MMM_yyyy: "{RunDateTime:dd-MMM-yyyy}", RunDateTime_MMM_yy: "{RunDateTime:MMM-yy}", RunDateTime_MMM_yyyy: "{RunDateTime:MMM-yyyy}", RunDateTime_MMMM_yy: "{RunDateTime:MMMM-yy}", RunDateTime_MMMM_yyyy: "{RunDateTime:MMMM-yyyy}", RunDateTime_MMMM_d_yyyy: "{RunDateTime:MMMM d, yyyy}", RunDateTime_M_d_yy_h_mm_tt: "{RunDateTime:M/d/yy h:mm tt}", RunDateTime_M_d_yyyy_h_mm_tt: "{RunDateTime:M/d/yyyy h:mm tt}", RunDateTime_M_d_yy_h_mm: "{RunDateTime:M/d/yy h:mm}", RunDateTime_M_d_yyyy_h_mm: "{RunDateTime:M/d/yyyy h:mm}", RunDateTime_M_d_yyyy: "{RunDateTime:M/d/yyyy}" }, font_weight: { Normal: "Normal", Bold: "Bold" }, font_style: { Normal: "Normal", Italic: "Italic" }, font_size: { "8pt": "8pt", "9pt": "9pt", "10pt": "10pt", "11pt": "11pt", "12pt": "12pt", "14pt": "14pt", "16pt": "16pt", "18pt": "18pt", "20pt": "20pt", "22pt": "22pt", "24pt": "24pt", "26pt": "26pt", "28pt": "28pt", "36pt": "36pt", "48pt": "48pt", "72pt": "72pt" }, white_space: { Normal: "Normal", Pre: "Pre", NoWrap: "NoWrap" }, word_wrap: { NoWrap: "NoWrap", WordWrap: "WordWrap", CharWrap: "CharWrap" }, kinsoku: { Auto: "Auto", None: "None", True: "True" }, paper_size: { Letter: "Letter", Tabloid: "Tabloid", Legal: "Legal", Executive: "Executive", A3: "A3", A4: "A4", A5: "A5", A6: "A6", JISB4: "B4 (JIS)", JISB5: "B5 (JIS)", JISB6: "B6 (JIS)", ISOB5: "B5 (ISO)", Custom: "Custom" }, paper_source: { AutomaticFeed: "Automatic Feed", Manual: "Manual", Cassette: "Cassette" }, calendar: { Gregorian: "Gregorian", GregorianArabic: "Gregorian Arabic", GregorianMiddleEastFrench: "Gregorian Middle East French", GregorianTransliteratedEnglish: "Gregorian Transliterated English", GregorianTransliteratedFrench: "Gregorian Transliterated French", GregorianUSEnglish: "Gregorian US English", Hebrew: "Hebrew", Hijri: "Hijri", Japanese: "Japanese", Korea: "Korea", Taiwan: "Taiwan", ThaiBuddhist: "Thai Buddhist" }, culture: { "af-ZA": "Afrikaans (South Africa)", "sq-AL": "Albanian (Albania)", "ar-DZ": "Arabic (Algeria)", "ar-BH": "Arabic (Bahrain)", "ar-EG": "Arabic (Egypt)", "ar-IQ": "Arabic (Iraq)", "ar-JO": "Arabic (Jordan)", "ar-KW": "Arabic (Kuwait)", "ar-LB": "Arabic (Lebanon)", "ar-LY": "Arabic (Libya)", "ar-MA": "Arabic (Morocco)", "ar-OM": "Arabic (Oman)", "ar-QA": "Arabic (Qatar)", "ar-SA": "Arabic (Saudi Arabia)", "ar-SY": "Arabic (Syria)", "ar-TN": "Arabic (Tunisia)", "ar-AE": "Arabic (U.A.E.)", "ar-YE": "Arabic (Yemen)", "hy-AM": "Armenian (Armenia)", "az-Cyrl-AZ": "Azeri (Cyrillic, Azerbaijan)", "az-Latn-AZ": "Azeri (Latin, Azerbaijan)", "eu-ES": "Basque (Basque)", "be-BY": "Belarusian (Belarus)", "bg-BG": "Bulgarian (Bulgaria)", "ca-ES": "Catalan (Catalan)", "zh-HK": "Chinese (Hong Kong S.A.R.)", "zh-MO": "Chinese (Macao S.A.R.)", "zh-CN": "Chinese (People's Republic of China)", "zh-SG": "Chinese (Singapore)", "zh-TW": "Chinese (Taiwan)", "hr-BA": "Croatian (Bosnia and Herzegovina)", "hr-HR": "Croatian (Croatia)", "cs-CZ": "Czech (Czech Republic)", "da-DK": "Danish (Denmark)", "dv-MV": "Divehi (Maldives)", "nl-BE": "Dutch (Belgium)", "nl-NL": "Dutch (Netherlands)", "en-AU": "English (Australia)", "en-BZ": "English (Belize)", "en-CA": "English (Canada)", "en-029": "English (Caribbean)", "en-IE": "English (Ireland)", "en-JM": "English (Jamaica)", "en-NZ": "English (New Zealand)", "en-PH": "English (Republic of the Philippines)", "en-ZA": "English (South Africa)", "en-TT": "English (Trinidad and Tobago)", "en-GB": "English (United Kingdom)", "en-US": "English (United States)", "en-ZW": "English (Zimbabwe)", "et-EE": "Estonian (Estonia)", "fo-FO": "Faroese (Faroe Islands)", "fi-FI": "Finnish (Finland)", "fr-BE": "French (Belgium)", "fr-CA": "French (Canada)", "fr-FR": "French (France)", "fr-LU": "French (Luxembourg)", "fr-MC": "French (Principality of Monaco)", "fr-CH": "French (Switzerland)", "gl-ES": "Galician (Galician)", "ka-GE": "Georgian (Georgia)", "de-AT": "German (Austria)", "de-DE": "German (Germany)", "de-LI": "German (Liechtenstein)", "de-LU": "German (Luxembourg)", "de-CH": "German (Switzerland)", "el-GR": "Greek (Greece)", "gu-IN": "Gujarati (India)", "he-IL": "Hebrew (Israel)", "hi-IN": "Hindi (India)", "hu-HU": "Hungarian (Hungary)", "is-IS": "Icelandic (Iceland)", "id-ID": "Indonesian (Indonesia)", "it-IT": "Italian (Italy)", "it-CH": "Italian (Switzerland)", "ja-JP": "Japanese (Japan)", "kn-IN": "Kannada (India)", "kk-KZ": "Kazakh (Kazakhstan)", "sw-KE": "Kiswahili (Kenya)", "kok-IN": "Konkani (India)", "ko-KR": "Korean (Korea)", "ky-KG": "Kyrgyz (Kyrgyzstan)", "lv-LV": "Latvian (Latvia)", "lt-LT": "Lithuanian (Lithuania)", "mk-MK": "Macedonian (Former Yugoslav Republic of Macedonia)", "ms-BN": "Malay (Brunei Darussalam)", "ms-MY": "Malay (Malaysia)", "mr-IN": "Marathi (India)", "mn-MN": "Mongolian (Cyrillic, Mongolia)", "nb-NO": "Norwegian, Bokm\xC3\xA5l (Norway)", "nn-NO": "Norwegian, Nynorsk (Norway)", "fa-IR": "Persian (Iran)", "pl-PL": "Polish (Poland)", "pt-BR": "Portuguese (Brazil)", "pt-PT": "Portuguese (Portugal)", "pa-IN": "Punjabi (India)", "ro-RO": "Romanian (Romania)", "ru-RU": "Russian (Russia)", "sa-IN": "Sanskrit (India)", "sk-SK": "Slovak (Slovakia)", "sl-SI": "Slovenian (Slovenia)", "es-AR": "Spanish (Argentina)", "es-BO": "Spanish (Bolivia)", "es-CL": "Spanish (Chile)", "es-CO": "Spanish (Colombia)", "es-CR": "Spanish (Costa Rica)", "es-DO": "Spanish (Dominican Republic)", "es-EC": "Spanish (Ecuador)", "es-SV": "Spanish (El Salvador)", "es-GT": "Spanish (Guatemala)", "es-HN": "Spanish (Honduras)", "es-MX": "Spanish (Mexico)", "es-NI": "Spanish (Nicaragua)", "es-PA": "Spanish (Panama)", "es-PY": "Spanish (Paraguay)", "es-PE": "Spanish (Peru)", "es-PR": "Spanish (Puerto Rico)", "es-ES": "Spanish (Spain)", "es-UY": "Spanish (Uruguay)", "es-VE": "Spanish (Venezuela)", "sv-FI": "Swedish (Finland)", "sv-SE": "Swedish (Sweden)", "syr-SY": "Syriac (Syria)", "ta-IN": "Tamil (India)", "tt-RU": "Tatar (Russia)", "te-IN": "Telugu (India)", "th-TH": "Thai (Thailand)", "tr-TR": "Turkish (Turkey)", "uk-UA": "Ukrainian (Ukraine)", "ur-PK": "Urdu (Islamic Republic of Pakistan)", "uz-Cyrl-UZ": "Uzbek (Cyrillic, Uzbekistan)", "uz-Latn-UZ": "Uzbek (Latin, Uzbekistan)", "vi-VN": "Vietnamese (Vietnam)" }, ddo_char_set: { Baltic: "Baltic", Greek: "Greek", Cyrillic: "Cyrillic", Vietnamese: "Vietnamese", Turkish: "Turkish", Arab: "Arab", Hebrew: "Hebrew", CentralEuropean: "Central European", Western: "Western" }, border_style: { None: "None", Solid: "Solid", Dash: "Dash", Dot: "Dot", DashDot: "DashDot", ThickSolid: "ThickSolid", Double: "Double", ThickDashDotDot: "ThickDashDotDot", ThickDash: "ThickDash", ThickDashDot: "ThickDashDot", ThickDot: "ThickDot", ExtraThickSolid: "ExtraThickSolid", ThickDouble: "ThickDouble" } }, error: { errorLabel: "Error", themes: { textCannotLoad: "Report theme cannot be loaded", textNotFound: 'The theme "{{theme}}" used in this report is not found.', textUseDefault: 'The default theme "{{theme}}" will be used instead.', textNoThemes: "Please note there are no other themes available so now the report has no theme specified.", textTotFoundOrInvalid: "The theme {{theme}} used in this report either is not found or has invalid content." }, expressionNode: { argumentIsNotValid: "Argument '{{argument}}' of function '{{functionName}}' is not valid. {{details}}", argumentValueNotFitFunctionValueDataType: "Argument '{{argument}}' of function '{{functionName}}' should have one of the following types - {{expectedTypes}} - but has type {{actualType}}.", argumentsShouldHaveSameDataType: "Arguments {{arguments}} of function '{{functionName}}' should have the same data type.", typeMismatch: "Value '{{value}}' cannot be converted to {{expectedType}}." }, upgradeReportSemanticModel: { entityIsAbsent: "\u25CF The entity '{{entityName}}' of the data set '{{dataSetName}}' is absent in the latest semantic model.", fieldAtQueryFilterIsAbsent: "\u25CF The field '{{fieldName}}' of the data set '{{dataSetName}}' query filter is absent in the latest semantic model.", fieldInControlGroupIsAbsent: "\u25CF The field '{{fieldName}}' in {{controlName}} group {{groupName}} '{{propertyLabel}}' property is absent in the latest semantic model.", fieldInControlIsAbsent: "\u25CF The field '{{fieldName}}' in {{controlName}} '{{propertyLabel}}' property is absent in the latest semantic model.", fieldInReportIsAbsent: "\u25CF The field '{{fieldName}}' in Report '{{propertyLabel}}' property is absent in the latest semantic model." } }, expressionFields: { chart: { Current: { Category: { description: "Represents the target element Category Field value.", example: '=Chart!CurrentCategory=1; =Chart!CurrentCategory>10; =Chart!CurrentCategory="Value1"; ', label: "Category", syntax: "Chart!CurrentCategory <Comparison operator> <Value>" }, Data: { description: "Represents the target element Data Field value.", example: '=Chart!CurrentData=1; =Chart!CurrentData>10; =Chart!CurrentData="Value1"; ', label: "Data", syntax: "Chart!CurrentData <Comparison operator> <Value>" }, Detail: { description: "Represents the target element Detail Field Encoding value.", example: '=Chart!CurrentDetail=1; =Chart!CurrentDetail>10; =Chart!CurrentDetail="Value1"; ', label: "Detail", syntax: "Chart!CurrentDetail <Comparison operator> <Value>" }, DataHigh: { description: "Represents the target element 'High' value in financial charts.", example: '=Chart!CurrentDataHigh=1; =Chart!CurrentDataHigh>10; =Chart!CurrentDataHigh="Value1"; ', label: "DataHigh", syntax: "Chart!CurrentDataHigh <Comparison operator> <Value>" }, DataLow: { description: "Represents the target element 'Low' value in financial charts.", example: '=Chart!CurrentDataLow=1; =Chart!CurrentDataLow>10; =Chart!CurrentDataLow="Value1"; ', label: "DataLow", syntax: "Chart!CurrentDataLow <Comparison operator> <Value>" }, DataOpen: { description: "Represents the target element 'Open' value in financial charts.", example: '=Chart!CurrentDataOpen=1; =Chart!CurrentDataOpen>10; =Chart!CurrentDataOpen="Value1"; ', label: "DataOpen", syntax: "Chart!CurrentDataOpen <Comparison operator> <Value>" }, DataClose: { description: "Represents the target element 'Close' value in financial charts.", example: '=Chart!CurrentDataClose=1; =Chart!CurrentDataClose>10; =Chart!CurrentDataClose="Value1"; ', label: "DataClose", syntax: "Chart!CurrentDataClose <Comparison operator> <Value>" }, DataUpper: { description: "Represents the target element 'Upper' value in the gantt and range charts.", example: '=Chart!CurrentDataUpper=1; =Chart!CurrentDataUpper>10; =Chart!CurrentDataUpper="Value1"; ', label: "DataUpper", syntax: "Chart!CurrentDataUpper <Comparison operator> <Value>" }, DataLower: { description: "Represents the target element 'Lower' value in the gantt and range charts.", example: '=Chart!CurrentDataLower=1; =Chart!CurrentDataLower>10; =Chart!CurrentDataLower="Value1"; ', label: "DataLower", syntax: "Chart!CurrentDataLower <Comparison operator> <Value>" }, label: "Current Item" }, Next: { Category: { description: "Represents the Category Field value next to the target element.", example: '=Chart!NextCategory=1; =Chart!NextCategory>10; =Chart!NextCategory="Value1"; ', label: "Category", syntax: "Chart!NextCategory <Comparison operator> <Value>" }, Data: { description: "Represents the Data Field next to the target element.", example: '=Chart!NextData=1; =Chart!NextData>10; =Chart!NextData="Value1"; ', label: "Data", syntax: "Chart!NextData <Comparison operator> <Value>" }, Detail: { description: "Represents the Detail Field Encoding value next to the target element.", example: '=Chart!NextDetail=1; =Chart!NextDetail>10; =Chart!NextDetail="Value1"; ', label: "Detail", syntax: "Chart!NextDetail <Comparison operator> <Value>" }, DataHigh: { description: "Represents the 'High' value next to the target element in financial charts.", example: '=Chart!NextDataHigh=1; =Chart!NextDataHigh>10; =Chart!NextDataHigh="Value1"; ', label: "DataHigh", syntax: "Chart!NextDataHigh <Comparison operator> <Value>" }, DataLow: { description: "Represents the 'Low' value next to the target element in financial charts.", example: '=Chart!NextDataLow=1; =Chart!NextDataLow>10; =Chart!NextDataLow="Value1"; ', label: "DataLow", syntax: "Chart!NextDataLow <Comparison operator> <Value>" }, DataOpen: { description: "Represents the 'Open' value next to the target element in financial charts.", example: '=Chart!NextDataOpen=1; =Chart!NextDataOpen>10; =Chart!NextDataOpen="Value1"; ', label: "DataOpen", syntax: "Chart!NextDataOpen <Comparison operator> <Value>" }, DataClose: { description: "Represents the 'Close' value next to the target element in financial charts.", example: '=Chart!NextDataClose=1; =Chart!NextDataClose>10; =Chart!NextDataClose="Value1"; ', label: "DataClose", syntax: "Chart!NextDataClose <Comparison operator> <Value>" }, DataUpper: { description: "Represents the 'Upper' value next to the target element in the gantt and range charts.", example: '=Chart!NextDataUpper=1; =Chart!NextDataUpper>10; =Chart!NextDataUpper="Value1"; ', label: "DataUpper", syntax: "Chart!NextDataUpper <Comparison operator> <Value>" }, DataLower: { description: "Represents the 'Lower' value next to the target element in the gantt and range charts.", example: '=Chart!NextDataLower=1; =Chart!NextDataLower>10; =Chart!NextDataLower="Value1"; ', label: "DataLower", syntax: "Chart!NextDataLower <Comparison operator> <Value>" }, label: "Next Item" }, Previous: { Category: { description: "Represents the Category Field value previous to the target element.", example: '=Chart!PreviousCategory=1; =Chart!PreviousCategory>10; =Chart!PreviousCategory="Value1"; ', label: "Category", syntax: "Chart!PreviousCategory <Comparison operator> <Value>" }, Data: { description: "Represents the Data Field value previous to the target element.", example: '=Chart!PreviousData=1; =Chart!PreviousData>10; =Chart!PreviousData="Value1"; ', label: "Data", syntax: "Chart!PreviousData <Comparison operator> <Value>" }, Detail: { description: "Represents the Detail Field Encoding value previous to the target element.", example: '=Chart!PreviousDetail=1; =Chart!PreviousDetail>10; =Chart!PreviousDetail="Value1"; ', label: "Detail", syntax: "Chart!PreviousDetail <Comparison operator> <Value>" }, DataHigh: { description: "Represents the 'High' value previous to the target element in financial charts.", example: '=Chart!PreviousDataHigh=1; =Chart!PreviousDataHigh>10; =Chart!PreviousDataHigh="Value1"; ', label: "DataHigh", syntax: "Chart!PreviousDataHigh <Comparison operator> <Value>" }, DataLow: { description: "Represents the 'Low' value previous to the target element in financial charts.", example: '=Chart!PreviousDataLow=1; =Chart!PreviousDataLow>10; =Chart!PreviousDataLow="Value1"; ', label: "DataLow", syntax: "Chart!PreviousDataLow <Comparison operator> <Value>" }, DataOpen: { description: "Represents the 'Open' value previous to the target element in financial charts.", example: '=Chart!PreviousDataOpen=1; =Chart!PreviousDataOpen>10; =Chart!PreviousDataOpen="Value1"; ', label: "DataOpen", syntax: "Chart!PreviousDataOpen <Comparison operator> <Value>" }, DataClose: { description: "Represents the 'Close' value previous to the target element in financial charts.", example: '=Chart!PreviousDataClose=1; =Chart!PreviousDataClose>10; =Chart!PreviousDataClose="Value1"; ', label: "DataClose", syntax: "Chart!PreviousDataClose <Comparison operator> <Value>" }, DataUpper: { description: "Represents the 'Upper' value previous to the target element in the gantt and range charts.", example: '=Chart!PreviousDataUpper=1; =Chart!PreviousDataUpper>10; =Chart!PreviousDataUpper="Value1"; ', label: "DataUpper", syntax: "Chart!PreviousDataUpper <Comparison operator> <Value>" }, DataLower: { description: "Represents the 'Lower' value previous to the target element in the gantt and range charts.", example: '=Chart!PreviousDataLower=1; =Chart!PreviousDataLower>10; =Chart!PreviousDataLower="Value1"; ', label: "DataLower", syntax: "Chart!PreviousDataLower <Comparison operator> <Value>" }, label: "Previous Item" }, Functions: { CurrentValue: { description: "Represents the current value of a data point on specified plot.", example: '=CurrentValue("plot1"); =CurrentValue("plot1","high"); ', label: "CurrentValue", syntax: 'CurrentValue("plot name" , "optional value identifier (high, low, open, close, upper, lower)")' }, NextValue: { description: "Represents the data point value next to current value on specified plot.", example: '=NextValue("plot1"); =NextValue("plot1","high"); ', label: "NextValue", syntax: 'NextValue("plot name" , "optional value identifier (high, low, open, close, upper, lower)")' }, PreviousValue: { description: "Represents the data point value previous to current value on specified plot.", example: '=PreviousValue("plot1"); =PreviousValue("plot1","high"); ', label: "PreviousValue", syntax: 'PreviousValue("plot name" , "optional value identifier (high, low, open, close, upper, lower)")' }, label: "Functions" }, label: "Chart" }, commonValues: { info: { currentDateTime: { description: "Displays the current date and time. It can be used in the Page Header and Page Footer." }, pageNM: { description: "Displays the current page number (N) and the total number of pages (M) in the format 'N of M'. It can be used in the Page Header and Page Footer." }, pageNMCumulative: { description: "Displays both the current page and the total number of cumulative pages in the report. Page N of M (Cumulative) is applied to page numbering when you use collation in the report." }, pageNMSection: { description: "Displays the current page number (N) and the total number of pages (M) in the format 'N of M,' of the section to which the function belongs. The section can be a report or a data region." }, pageNumber: { description: "Displays the current page number. It can be used in the Page Header and Page Footer." }, pageNumberCumulative: { description: "Displays the current cumulative page number. Page Number (Cumulative) is applied to page numbering when you use collation in the report." }, pageNumberSection: { description: "Displays the current page number of the section to which the function belongs. The section can be a report or a data region." }, reportName: { description: "Displays the name of the report." }, totalPages: { description: "Displays the total number of pages. It can be used in the Page Header and Page Footer." }, totalPagesCumulative: { description: "Displays the total number of cumulative pages in the report. Total Pages (Cumulative) is applied to page numbering when you use collation in the report." }, totalPagesSection: { description: "Displays the total number of pages of the section to which the function belongs. The section can be a report or a data region." }, userContext: { description: 'Use only with function, e.g. UserContext.GetValue("name"), UserContext.NumberToWords(123).' }, userId: { description: "Displays the User ID of the user previewing the report." }, userLanguage: { description: "Displays the Language of the user previewing the report as per system settings." }, textboxValue: { description: "This variable will be replaced with the current textbox(es) value(s) when saved.", example: "=Sum($$)", example_i11n: "{Sum($$$)}", label: "Current Textbox Value" } }, titles: { label: "Common Values" } }, constants: { dvchart_template: { PercentageCategory_p0: { description: "Displays the percentage of the Value field within the Category." }, PercentageDetail_p0: { description: "Displays the percentage of the Value field within the Details." }, categoryField: { name: { description: "Displays the Category field name." }, value: { description: "Displays the Category field value." } }, colorField: { name: { description: "Displays the Color field name." }, value: { description: "Displays the Color field value." } }, detailFields: { name: { description: "Displays the Details field name." }, value: { description: "Displays the Details field value." } }, shapeField: { name: { description: "Displays the Shape field name." }, value: { description: "Displays the Shape field value." } }, sizeField: { name: { description: "Displays the Size field name." }, value: { description: "Displays the Size field value." } }, valueField: { name: { description: "Displays the Value field name." }, value: { description: "Displays the Value field value." } } }, titles: { label: "Constants" } }, documentMap: { info: { path: { description: "Returns the path of the TOC level.", example: '=DocumentMap.Path & "This is Heading 1"', label: "Path" } }, titles: { label: "Document Map" } }, functions: { info: { aggregate: { aggregateIf: { description: "Calculates the aggregate of the values from the specified expression if the Boolean expression meets the given condition.", example: '=AggregateIf(Fields!Discontinued.Value = True, "Sum", Fields!InStock.Value)', label: "AggregateIf", syntax: "AggregateIf(<Condition>, <AggregateFunction>, <AggregateArguments>)" }, aggregateIfWithScope: { description: "Calculates the aggregate of the values from the specified expression if the Boolean expression meets the given condition, within the specified scope.", example: '=AggregateIf(Fields!Discontinued.Value = True, "Sum", Fields!InStock.Value, "Category")', label: "AggregateIf (with scope)", syntax: "AggregateIf(<Condition>, <AggregateFunction>, <AggregateArguments>, <Scope>)" }, avg: { description: "Calculates the average of all non-null numeric values from the specified expression.", example: "=Avg(Fields!LifeExpentancy.Value)", label: "Avg", syntax: "Avg(<Values>)" }, avgWithScope: { description: "Calculates the average of all non-null numeric values from the specified expression within the specified scope.", example: '=Avg(Fields!LifeExpentancy.Value, "GroupByCountry")', label: "Avg (with scope)", syntax: "Avg(<Values>, <Scope>)" }, count: { description: "Calculates the number of non-null values from the specified expression.", example: "=Count(Fields!EmployeeID.Value)", label: "Count", syntax: "Count(<Values>)" }, countDistinct: { description: "Calculates the number of non-repeated values from the specified expression.", example: "=CountDistinct(Fields!OrderID.Value)", label: "CountDistinct", syntax: "CountDistinct(<Values>)" }, countDistinctWithScope: { description: "Calculates the number of non-repeated values from the specified expression within the specified scope.", example: '=CountDistinct(Fields!OrderID.Value, "GroupByCategory")', label: "CountDistinct (with scope)", syntax: "CountDistinct(<Values>, <Scope>)" }, countRows: { description: "Calculates the number of rows.", example: "=CountRows()", label: "CountRows", syntax: "CountRows()" }, countRowsWithScope: { description: "Calculates the number of rows within the specified scope.", example: '=CountRows("Title")', label: "CountRows (with scope)", syntax: "CountRows(<Scope>)" }, countWithScope: { description: "Calculates the number of non-null values from the specified expression within the specified scope.", example: '=Count(Fields!EmployeeID.Value, "Title")', label: "Count (with scope)", syntax: "Count(<Values>, <Scope>)" }, crossAggregate: { description: "Calculates the specified function with specified expression as an argument in the cross of specified row and column.", example: '=CrossAggregate(Fields!Amount.Value, "Sum", "YearGroup", "CategoryGroup")', label: "CrossAggregate", syntax: "CrossAggregate(<Expression>, <FunctionName>, <ColumnGroupName>, <RowGroupName>)" }, cumulativeTotal: { description: "Calculates the sum of page-level aggregates returned by the expression for current and previous pages.", example: '=CumulativeTotal(Fields!OrderID.Value, "Count")', label: "CumulativeTotal", syntax: "CumulativeTotal(<Expression>, <Aggregate>)" }, distinctSum: { description: "Calculates the sum of values from the specified expression when the value of the other expression is not repeated.", example: "=DistinctSum(Fields!OrderID.Value, Fields!OrderFreight.Value)", label: "DistinctSum", syntax: "DistinctSum(<Values>, <Value>)" }, distinctSumWithScope: { description: "Calculates the sum of values of the specified expression when the value of the other expression is not repeated, within the specified scope.", example: '=DistinctSum(Fields!OrderID.Value, Fields!OrderFreight.Value, "Order")', label: "DistinctSum (with scope)", syntax: "DistinctSum(<Values>, <Value>, <Scope>)" }, first: { description: "Returns the first value from the specified expression.", example: "=First(Fields!ProductNumber.Value)", label: "First", syntax: "First(<Values>)" }, firstWithScope: { description: "Returns the first value from the specified expression within the specified scope.", example: '=First(Fields!ProductNumber.Value, "Category")', label: "First (with scope)", syntax: "First(<Values>, <Scope>)" }, last: { description: "Returns the last value from the specified expression.", example: "=Last(Fields!ProductNumber.Value)", label: "Last", syntax: "Last(<Values>)" }, lastWithScope: { description: "Returns the last value from the specified expression within the specified scope.", example: '=Last(Fields!ProductNumber.Value, "Category")', label: "Last (with scope)", syntax: "Last(<Values>, <Scope>)" }, max: { description: "Returns the maximum non-null value from the specified expression.", example: "=Max(Fields!OrderTotal.Value)", label: "Max", syntax: "Max(<Values>)" }, maxWithScope: { description: "Returns the maximum non-null value from the specified expression within the specified scope.", example: '=Max(Fields!OrderTotal.Value, "Year")', label: "Max (with scope)", syntax: "Max(<Values>, <Scope>)" }, median: { description: "Returns the value that is the mid-point of the values in the specified expression. Median is the center value in a sequence of values.", example: "=Median(Fields!OrderTotal.Value)", label: "Median", syntax: "Median(<Values>)" }, medianWithScope: { description: "Returns the value that is the mid-point of the ordered values in the specified expression, within the specified scope. Median is the center value in a sequence of values.", example: '=Median(Fields!OrderTotal.Value, "Year")', label: "Median (with scope)", syntax: "Median(<Values>, <Scope>)" }, min: { description: "Returns the minimum non-null value from the specified expression.", example: "=Min(Fields!OrderTotal.Value)", label: "Min", syntax: "Min(<Values>)" }, minWithScope: { description: "Returns the minimum non-null value from the specified expression within the specified scope.", example: '=Min(Fields!OrderTotal.Value, "Year")', label: "Min (with scope)", syntax: "Min(<Values>, <Scope>)" }, mode: { description: "Returns the most frequently occurring value from the specified expression.", example: "=Mode(Fields!OrderTotal.Value)", label: "Mode", syntax: "Mode(<Values>)" }, modeWithScope: { description: "Returns the most frequently occurring value from the specified expression, within the specified scope.", example: '=Mode(Fields!OrderTotal.Value, "Year")', label: "Mode (with scope)", syntax: "Mode(<Values>, <Scope>)" }, runningValue: { description: "Calculates a running aggregate of all non-null numeric values from the specified expression, using another aggregate function as a parameter.", example: '=RunningValue(Fields!Price.Value, "Sum")', label: "RunningValue", syntax: "RunningValue(<Values>, <AggregateFunction>)" }, runningValueWithScope: { description: "Calculates a running aggregate of all non-null numeric values from the specified expression, using another aggregate function as a parameter, within the specified scope.", example: '=RunningValue(Fields!Price.Value, "Sum", "Nwind")', label: "RunningValue (with scope)", syntax: "RunningValue(<Values>, <AggregateFunction>, <Scope>)" }, stDev: { description: "Calculates the standard deviation of all non-null values of the specified expression.", example: "=StDev(Fields!LineTotal.Value)", label: "StDev", syntax: "StDev(<Values>)" }, stDevP: { description: "Calculates the population standard deviation of all non-null values of the specified expression.", example: "=StDevP(Fields!LineTotal.Value)", label: "StDevP", syntax: "StDevP(<Values>)" }, stDevPWithScope: { description: "Calculates the population standard deviation of all non-null values of the specified expression within the specified scope.", example: '=StDevP(Fields!LineTotal.Value, "Order")', label: "StDevP (with scope)", syntax: "StDevP(<Values>, <Scope>)" }, stDevWithScope: { description: "Calculates the standard deviation of all non-null values of the specified expression, within the specified scope.", example: '=StDev(Fields!LineTotal.Value, "Nwind")', label: "StDev (with scope)", syntax: "StDev(<Values>, <Scope>)" }, sum: { description: "Calculates the sum of the values of the specified expression.", example: "=Sum(Fields!Price.Value)", label: "Sum", syntax: "Sum(<Values>)" }, sumWithScope: { description: "Calculates the sum of the values of the specified expression within the specified scope.", example: '=Sum(Fields!Price.Value, "Category")', label: "Sum (with scope)", syntax: "Sum(<Values>, <Scope>)" }, var: { description: "Calculates the variance (standard deviation squared) of all non-null values of the specified expression.", example: "=Var(Fields!LineTotal.Value)", label: "Var", syntax: "Var(<Values>)" }, varP: { description: "Calculates the population variance (population standard variation squared) of all non-null values of the specified expression.", example: "=VarP(Fields!LineTotal.Value)", label: "VarP", syntax: "VarP(<Values>)" }, varPWithScope: { description: "Calculates the population variance (population standard variation squared) of all non-null values of the specified expression, within the specified scope.", example: '=VarP(Fields!LineTotal.Value, "Order")', label: "VarP (with scope)", syntax: "VarP(<Values>, <Scope>)" }, varWithScope: { description: "Calculates the variance (standard deviation squared) of all non-null values of the specified expression.", example: '=Var(Fields!LineTotal.Value, "Order")', label: "Var (with scope)", syntax: "Var(<Values>, <Scope>)" } }, conversion: { format: { description: "Formats the value to the specified format.", example: '=Format(Fields!OrderDate.Value, "dd MMM yyyy")', label: "Format", syntax: "Format(<Value>, <String>)" }, toBoolean: { description: "Converts the specified value to Boolean.", example: "=ToBoolean(Fields!HouseOwnerFlag.Value)", label: "ToBoolean", syntax: "ToBoolean(<Value>)" }, toByte: { description: "Converts the specified value to Byte.", example: "=ToByte(Fields!ProductNumber.Value)", label: "ToByte", syntax: "ToByte(<Value>)" }, toChar: { description: "Converts the specified value to Char.", example: "=ToChar(Fields!OrderStatus.Value); =ToChar(\u201CHello\u201D)", label: "ToChar", syntax: "ToChar(<Value>)" }, toDateTime: { description: "Converts the specified value to a Date and Time value.", example: '=ToDateTime(Fields!SaleDate.Value); =ToDateTime("1 January, 2017")', label: "ToDateTime", syntax: "ToDateTime(<Value>)" }, toDecimal: { description: "Converts the specified value to Decimal.", example: "=ToDecimal(Fields!Sales.Value)", label: "ToDecimal", syntax: "ToDecimal(<Value>)" }, toDouble: { description: "Converts the specified value to Double.", example: "=ToDouble(Fields!AnnualSales.Value); =ToDouble(535.85 * .2691 * 67483)", label: "ToDouble", syntax: "ToDouble(<Value>)" }, toInt16: { description: "Converts the specified value to a 16-bit signed Integer.", example: "=ToInt16(Fields!AnnualSales.Value); =ToInt16(535.85)", label: "ToInt16", syntax: "ToInt16(<Value>)" }, toInt32: { description: "Converts the specified value to a 32-bit signed Integer.", example: "=ToInt32(Fields!AnnualSales.Value)", label: "ToInt32", syntax: "ToInt32(<Value>)" }, toInt64: { description: "Converts the specified value to a 64-bit signed Integer.", example: "=ToInt64(Fields!AnnualSales.Value)", label: "ToInt64", syntax: "ToInt64(<Value>)" }, toSingle: { description: "Converts the specified value to a single-precision floating-point number.", example: "=ToSingle(Fields!AnnualSales.Value); =ToSingle(15.857692134)", label: "ToSingle", syntax: "ToSingle(<Value>)" }, toStringDot: { description: "Converts the value to String in the specified format.", example: '=Fields!OrderDate.Value.ToString("dd MMM yyyy")', label: ".ToString", syntax: "<Value>.ToString(<String>)" }, toStringKey: { description: "Converts the specified value to String.", example: "=ToString(Fields!YearlyIncome.Value); =ToString(13.50)", label: "ToString", syntax: "ToString(<Value>)" }, toUInt16: { description: "Converts the specified value to a 16-bit unsigned Integer.", example: "=ToUInt16(Fields!AnnualSales.Value)", label: "ToUInt16", syntax: "ToUInt16(<Value>)" }, toUInt32: { description: "Converts the specified value to a 32-bit unsigned Integer.", example: "=ToUInt32(Fields!AnnualSales.Value)", label: "ToUInt32", syntax: "ToUInt32(<Value>)" }, toUInt64: { description: "Converts the specified value to a 64-bit unsigned Integer.", example: "=ToUInt64(Fields!AnnualSales.Value)", label: "ToUInt64", syntax: "ToUInt64(<Value>)" } }, customFunctions: { getValue: { description: 'Displays the user context value for specified property, e.g. "name","email".', example: '=UserContext.getValue("name")', label: "GetUserValue", syntax: "UserContext.getValue(<String>)" }, numberToWords: { description: 'Converts the specified value to words. Single argument function uses the current language from the portal. A function with two arguments uses the language passed by the second argument(Supported cultures: "zh-cn", "en-us", "ja-jp"). ', example: '=UserContext.NumberToWords(123.5); =UserContext.NumberToWords(981, "zh-CN")', label: "NumberToWords", syntax: "UserContext.NumberToWords(<Number>, <String>)" } }, dateTime: { addDays: { description: "Returns a date and time value that is a result of adding the date interval in days. The specified date interval can be negative.", example: "=Fields!OrderDate.Value.AddDays(5)", label: "AddDays", syntax: "<DateTime>.AddDays(<Number>)" }, addHours: { description: "Returns a date and time value that is a result of adding the time interval in hours. The specified time interval can be negative.", example: "=Fields!OrderDate.Value.AddHours(12)", label: "AddHours", syntax: "<DateTime>.AddHours(<Number>)" }, addMilliseconds: { description: "Returns a date and time value that is a result of adding the time interval in milliseconds. The specified time interval can be negative.", example: "=Fields!OrderDate.Value.AddMilliseconds(500)", label: "AddMilliseconds", syntax: "<DateTime>.AddMilliseconds(<Number>)" }, addMinutes: { description: "Returns a date and time value that is a result of adding the time interval in minutes. The specified time interval can be negative.", example: "=Fields!OrderDate.Value.AddMinutes(30)", label: "AddMinutes", syntax: "<DateTime>.AddMinutes(<Number>)" }, addMonths: { description: "Returns a date and time value that is a result of adding the date interval in months. The specified date interval can be negative.", example: "=Fields!OrderDate.Value.AddMonths(2)", label: "AddMonths", syntax: "<DateTime>.AddMonths(<Number>)" }, addSeconds: { description: "Returns a date and time value that is a result of adding the time interval in seconds. The specified time interval can be negative.", example: "=Fields!OrderDate.Value.AddSeconds(30)", label: "AddSeconds", syntax: "<DateTime>.AddSeconds(<Number>)" }, addYears: { description: "Returns a date and time value that is a result of adding the date interval in years. The specified date interval can be negative.", example: "=Fields!OrderDate.Value.AddYears(3)", label: "AddYears", syntax: "<DateTime>.AddYears(<Number>)" }, dateAdd: { description: "Returns a date and time value that is the result of adding the interval to the date and time field of the specified unit.", example: '=DateAdd("d", 5, Fields!SaleDate.Value); =DateAdd(DateInterval.Day, 5, Fields!SaleDate.Value)', label: "DateAdd", syntax: "DateAdd(<DateInterval>, <Number>, <DateTime>)" }, dateDiff: { description: "Returns the difference between the start date and time and end date and time of the specified unit.", example: '=DateDiff("yyyy", Fields!SaleDate.Value, "1/1/2015"); =DateDiff(DateInterval.Year, Fields!SaleDate.Value, "1/1/2015")', label: "DateDiff", syntax: "DateDiff(<DateInterval>, <DateTime1>, <DateTime2>[, <DayOfWeek>[, <WeekOfYear>]])" }, datePart: { description: "Returns the Integer value that represents the specified part of the given date.", example: '=DatePart("m", Fields!SaleDate.Value)', label: "DatePart", syntax: "DatePart(<DateInterval>, <DateTime>[, <FirstDayOfWeek>[, <FirstWeekOfYear>]])" }, dateSerial: { description: "Returns a Date value that represents a specified year, month, and day, with the time information set to midnight (00:00:00).", example: '=DateSerial(DatePart("yyyy", Fields!SaleDate.Value) - 10, DatePart("m", Fields!SaleDate.Value) + 5, DatePart("d", Fields!SaleDate.Value) - 1)', label: "DateSerial", syntax: "DateSerial(<Year Number>, <Month Number>, <Day Number>)" }, dateString: { description: "Returns the String value that represents the current date in your system.", example: '=DateString(); =DatePart("m", DateString())', label: "DateString", syntax: "DateString()" }, dateValue: { description: "Returns a Date value that contains the information on date represented by a string, with the time set to midnight (00:00:00).", example: '=DateValue("December 12, 2015")', label: "DateValue", syntax: "DateValue(<StringDate>)" }, day: { description: "Returns an Integer value from 1 through 31 that represents the day of the month.", example: "=Day(Fields!SaleDate.Value)", label: "Day", syntax: "Day(<DateTime>)" }, hour: { description: "Returns an Integer value from 0 through 23 that represents the hour of the day.", example: "=Hour(Fields!SaleDate.Value)", label: "Hour", syntax: "Hour(<DateTime>)" }, minute: { description: "Returns an Integer value from 0 through 59 that represents the minute of the hour.", example: "=Minute(Fields!SaleDate.Value)", label: "Minute", syntax: "Minute(<DateTime>)" }, month: { description: "Returns an Integer value from 1 through 12 that represents the month of the year.", example: "=Month(Fields!SaleDate.Value)", label: "Month", syntax: "Month(<DateTime>)" }, monthName: { description: "Returns the name of the month specified in the date as a String.", example: "=MonthName(Fields!MonthNumber.Value)", label: "MonthName", syntax: "MonthName(<Month Number>[, <Abbreviate>])" }, now: { description: "Returns the current date and time in your system.", example: "=Now()", label: "Now", syntax: "Now()" }, parse: { description: "Converts the specified string value to a date and time value.", example: '=DateTime.Parse("01/01/1970")', label: "DateTime.Parse", syntax: "DateTime.Parse(<String>[, <String>])" }, quarter: { description: "Returns an Integer value from 1 through 4 that represents the quarter of the year.", example: "=Quarter(Fields!SaleDate.Value)", label: "Quarter", syntax: "Quarter(<DateTime>)" }, quarterName: { description: "Returns a String value that represents the quarter of the year.", example: "=QuarterName(Fields!SaleDate.Value)", label: "QuarterName", syntax: "QuarterName(<DateTime>)" }, second: { description: "Returns an Integer value from 0 through 59 that represents the second of the minute.", example: "=Second(Fields!SaleDate.Value)", label: "Second", syntax: "Second(<DateTime>)" }, timeOfDay: { description: "Returns a Date value containing the current time of day in your system.", example: "=TimeOfDay()", label: "TimeOfDay", syntax: "TimeOfDay()" }, timeSerial: { description: "Returns a Date value that represents a specified hour, minute, and second, with the date information set relative to January 1 of the year 0001.", example: '=TimeSerial(DatePart("h", Fields!SaleDate.Value), DatePart("n", Fields!SaleDate.Value), DatePart("s", Fields!SaleDate.Value))', label: "TimeSerial", syntax: "TimeSerial(<Hour Number>, <Minute Number>, <Second Number>)" }, timeString: { description: "Returns the String value that represents the current time of day in your system.", example: "=TimeString()", label: "TimeString", syntax: "TimeString()" }, timeValue: { description: "Returns a Date value that contains the information on time represented by a string, with the date set to January 1 of the year 0001.", example: '=TimeValue("15:25:45"); =TimeValue(Fields!SaleDate.Value)', label: "TimeValue", syntax: "TimeValue(<StringTime>)" }, timer: { description: "Returns a Double value that represents the number of seconds elapsed since midnight.", example: "=Timer()", label: "Timer", syntax: "Timer()" }, today: { description: "Returns a Date value that contains the current date in your system.", example: "=Today()", label: "Today", syntax: "Today()" }, weekday: { description: "Returns an Integer value that contains a number representing the day of the week.", example: "=Weekday(Fields!SaleDate.Value, 0)", label: "Weekday", syntax: "Weekday(<DateTime>[, <DayOfWeek>])" }, weekdayName: { description: "Returns a String value that contains the name of the specified weekday.", example: '=WeekdayName(3, True, 0); =WeekDayName(DatePart("w", Fields!SaleDate.Value), True, 0)', label: "WeekdayName", syntax: "WeekdayName(<WeekDay>[, <Abbreviate>[, <FirstDayOfWeek>]])" }, year: { description: "Returns an Integer value from 1 through 9999 representing the year.", example: "=Year(Fields!SaleDate.Value)", label: "Year", syntax: "Year(<DateTime>)" } }, inspection: { dbNull: { description: "Allows checking whether a value is a DBNull value.", example: '=IIF(Fields!Organization.Value is DBNull.Value, "<NULL>", Fields!Organization.Value)', label: "DBNull.Value", syntax: "DBNull.Value" }, isArray: { description: "Returns True if the expression can be evaluated as an array.", example: "=IsArray(Parameters!Initials.Value)", label: "IsArray", syntax: "IsArray(<Expression>)" }, isDBNull: { description: "Returns True if the expression evaluates to a null.", example: "=IsDBNull(Fields!MonthlySales.Value)", label: "IsDBNull", syntax: "IsDBNull(<Expression>)" }, isDate: { description: "Returns True if the expression represents a valid Date value.", example: '=IsDate(Fields!BirthDate.Value); =IsDate("31/12/2010")', label: "IsDate", syntax: "IsDate(<Expression>)" }, isError: { description: "Returns True if the expression evaluates to an error.", example: "=IsError(Fields!AnnualSales.Value = 80000)", label: "IsError", syntax: "IsError(<Expression>)" }, isNothing: { description: "Returns True if the expression evaluates to nothing.", example: "=IsNothing(Fields!MiddleInitial.Value)", label: "IsNothing", syntax: "IsNothing(<Expression>)" }, isNumeric: { description: "Returns True if the expression can be evaluated as a number.", example: "=IsNumeric(Fields!AnnualSales.Value)", label: "IsNumeric", syntax: "IsNumeric(<Expression>)" } }, math: { abs: { description: "Returns the absolute or positive value of a single-precision floating-point number.", example: "=Abs(-5.5); =Abs(Fields!YearlyIncome.Value - 80000)", label: "Abs", syntax: "Abs(<Number>)" }, acos: { description: "Returns the angle whose cosine is the specified number.", example: "=Acos(.5); =Acos(Fields!Angle.Value)", label: "Acos", syntax: "Acos(<Number>)" }, asin: { description: "Returns the angle whose sine is the specified number.", example: "=Asin(.5); =Asin(Fields!Angle.Value)", label: "Asin", syntax: "Asin(<Number>)" }, atan: { description: "Returns the angle whose tangent is the specified number.", example: "=Atan(.5); =Atan(Fields!Angle.Value)", label: "Atan", syntax: "Atan(<Number>)" }, atan2: { description: "Returns the angle whose tangent is the quotient of two specified numbers.", example: "=Atan2(3,7); =Atan2(Fields!CoordinateY.Value, Fields!CoordinateX.Value)", label: "Atan2", syntax: "Atan2(<Number1>, <Number2>)" }, bigMul: { description: "Returns the multiplication of two 32-bit numbers.", example: "=BigMul(4294967295,-2147483647); =BigMul(Fields!Int32Value.Value, Fields!Int32Value.Value)", label: "BigMul", syntax: "BigMul(<Number1>, <Number2>)" }, ceiling: { description: "Returns the smallest integer greater than or equal to the specified double-precision floating-point number.", example: "=Ceiling(98.4331); =Ceiling(Fields!AnnualSales.Value / 6)", label: "Ceiling", syntax: "Ceiling(<Number>)" }, cos: { description: "Returns the smallest integer greater than or equal to the specified double-precision floating-point number.", example: "=Cos(60)", label: "Cos", syntax: "Cos(<Number>)" }, cosh: { description: "Returns the hyperbolic cosine of the specified angle.", example: "=Cosh(60)", label: "Cosh", syntax: "Cosh(<Number>)" }, e: { description: "Returns the value of E, which is 2.71828182845905.", example: "=E * 2", label: "E", syntax: "E" }, exp: { description: "Returns e raised to the specified power, where e is Euler's number. It is the inverse of the Log function.", example: "=Exp(3); =Exp(Fields!IntegerCounter.Value)", label: "Exp", syntax: "Exp(<Number>)" }, fix: { description: "Returns the integer portion of a number.", example: "=Fix(-7.15); =Fix(Fields!AnnualSales.Value / -5)", label: "Fix", syntax: "Fix(<Number>)" }, floor: { description: "Returns the largest integer less than or equal to the specified double-precision floating-point number.", example: "=Floor(4.67); =Floor(Fields!AnnualSales.Value / 12)", label: "Floor", syntax: "Floor(<Number>)" }, ieeeRemainder: { description: "Returns the remainder after division of one number by another according to IEEE standards.", example: "=IEEERemainder(9, 8)", label: "IEEERemainder", syntax: "IEEERemainder(<Number1>, <Number2>)" }, log: { description: "Returns the logarithm of the specified number.", example: "=Log(20.5); =Log(Fields!NumberValue.Value)", label: "Log", syntax: "Log(<Number>)" }, log10: { description: "Returns the logarithm of the specified number to the base 10.", example: "=Log10(20.5); =Log10(Fields!NumberValue.Value)", label: "Log10", syntax: "Log10(<Number>)" }, max: { description: "Returns the maximum non-null value from the specified expression.", example: "=Max(Fields!OrderTotal.Value)", label: "Max", syntax: "Max(<Values>)" }, min: { description: "Returns the minimum non-null value from the specified expression.", example: "=Min(Fields!OrderTotal.Value)", label: "Min", syntax: "Min(<Values>)" }, pi: { description: "Returns the value of PI, which is 3.14159265358979.", example: "=2 * PI * Fields!Radius.Value", label: "PI", syntax: "PI" }, pow: { description: "Returns one number raised to the power of another number.", example: "=Pow(Fields!Quantity.Value, 2)", label: "Pow", syntax: "Pow(<Number1>, <Number2>)" }, round: { description: "Returns the round-off of a decimal number to the nearest integer or to the nearest decimal number up to the specified digits.", example: "=Round(12.456); =Round(Fields!AnnualSales.Value / 12.3)", label: "Round", syntax: "Round(<Number>)" }, sign: { description: "Returns a value indicating the sign of an 8-bit signed integer.", example: "=Sign(Fields!AnnualSales.Value - 60000)", label: "Sign", syntax: "Sign(<Number>)" }, sin: { description: "Returns the sine of the specified number.", example: "=Sin(60)", label: "Sin", syntax: "Sin(<Number>)" }, sinh: { description: "Returns the hyperbolic sine of the specified angle.", example: "=Sinh(60)", label: "Sinh", syntax: "Sinh(<Number>)" }, sqrt: { description: "Returns the square root of the specified number.", example: "=Sqrt(121)", label: "Sqrt", syntax: "Sqrt(<Number>)" }, tan: { description: "Returns the tangent of the specified number.", example: "=Tan(60)", label: "Tan", syntax: "Tan(<Number>)" }, tanh: { description: "Returns the hyperbolic tangent of the specified angle.", example: "=Tanh(60)", label: "Tanh", syntax: "Tanh(<Number>)" }, truncate: { description: "Removes the digits after decimal point without rounding-off, and returns the integer value.", example: "=Truncate(Fields!UnitPrice.Value)", label: "Truncate", syntax: "Truncate(<Number>)" } }, miscellaneous: { getFields: { description: "Returns an IDictionary<string,Field> object that contains the current contents of the Fields collection. Only valid when used within a data region. This function makes it easier to write code that deals with complex conditionals. To write the equivalent function without GetFields() would require passing each of the queried field values into the method which could be prohibitive when dealing with many fields.", example: "=GetFields(); =Code.DisplayAccountID(GetFields())", label: "GetFields", syntax: "GetFields()" }, getLength: { description: "Returns the number of elements in the specified array.", example: "=Parameters!MultiValueParameter.Value.GetLength(0)", label: "GetLength", syntax: "<Collection>.GetLength(<Number>)" }, indexOf: { description: "Returns the first index at which a given element can be found in the array or -1 if it is not present.", example: "=IndexOf(Parameters!pContinent.Value, Fields!ContinentName.Value) >= 0", example_i11n: "{IndexOf(@pContinent, ContinentName) >= 0}", label: "IndexOf", syntax: "IndexOf(<Source>, <SearchElement>)" }, inScope: { description: "Evaluates to true or false depending on whether the current value is in the specified scope.", example: '=InScope("Order")', label: "InScope", syntax: "InScope(<Scope>)" }, item: { description: "Returns an item by its name from Fields/Parameters/ReportItems.", example: '=Fields.Item("Company Name").Name; =Parameters.Item("Parameter1").Name; =ReportItems.Item("TextBox1").Value', example_i11n: '{Fields.Item("Company Name").Name}; {Parameters.Item("Parameter1").Name}; {ReportItems.Item("TextBox1").Value}', label: "Item", syntax: "<Object | Record>.Item(<String>)" }, join: { description: "Returns a string that is a result of joining the elements of an array, using the specified delimiter between elements.", example: '=Join(Parameters!MultiValueParameter.Value, ", ")', label: "Join", syntax: "Join(<Values>, <String>)" }, level: { description: "Returns a zero-based integer representing the current level of depth in a recursive hierarchy in the current scope. The first level in the hierarchy is 0.", example: "=Level()", label: "Level", syntax: "Level()" }, levelWithScope: { description: "Returns a zero-based integer representing the current level of depth in a recursive hierarchy in the specified scope. The first level in the hierarchy is 0.", example: '=Level("Order")', label: "Level (with scope)", syntax: "Level(<Scope>)" }, lookup: { description: "Returns the first matching value for the specified name from the dataset with name and value pairs.", example: '=Lookup(Fields!ProductID.Value, Fields!ProductID.Value, Fields!Quantity.Value, "DataSet2")', label: "Lookup", syntax: "Lookup(<Source>, <Destination>, <Result>, <DataSet>)" }, lookupSet: { description: "Returns the set of matching values for the specified name from the dataset that contains name/value pairs.", example: '=LookupSet(Fields!ProductID.Value, Fields!ProductID.Value, Fields!Quantity.Value, "DataSet2")', label: "LookupSet", syntax: "LookupSet(<Source>, <Destination>, <Result>, <DataSet>)" }, previous: { description: "Calculates the value of the expression for the previous row of data.", example: "=Previous(Fields!OrderID.Value)", label: "Previous", syntax: "Previous(<Expression>)" }, previousWithScope: { description: "Calculates the value of the expression for the previous row of data within the specified scope.", example: '=Previous(Fields!OrderID.Value, "Order")', label: "Previous (with scope)", syntax: "Previous(<Expression>, <Scope>)" }, rowNumber: { description: "Returns the running count of all the rows.", example: "=RowNumber()", label: "RowNumber", syntax: "RowNumber()" }, rowNumberWithScope: { description: "Returns the running count of all the rows in the specified scope.", example: '=RowNumber("OrderID")', label: "RowNumber (with scope)", syntax: "RowNumber(<Scope>)" }, groupIndex: { description: "Returns the index of the element in the current group.", example: "=GroupIndex()", label: "GroupIndex", syntax: "GroupIndex()" }, groupIndexWithScope: { description: "Returns the index of the element in the specified group.", example: "=GroupIndex(Group1)", label: "GroupIndex (with scope)", syntax: "GroupIndex(<Group>)" } }, programFlow: { choose: { description: "Returns a value from a list of arguments.", example: '=Choose(3, "10", "15", "20", "25")', label: "Choose", syntax: "Choose(<Index>, <Value1>[, <Value2>,...[, <ValueN>]])" }, iif: { description: "Returns the first value if the expression evaluates to True, and the second value if the expression evaluates to False.", example: '=IIF(Fields!AnnualSales.Value >= 80000, "Above Average", "Below Average")', label: "IIF", syntax: "IIF(<Condition>, <TruePart>, <FalsePart>)" }, partition: { description: "Returns a string (in the form x : y) that represents the calculated range based on the specified interval containing the specified number. ", example: "=Partition(1999, 1980, 2000, 10)", label: "Partition", syntax: "Partition(<Value>, <Start>, <End>, <Interval>)" }, switch: { description: "Returns the value of the first expression that evaluates to True among a list of expressions.", example: '=Switch(Fields!FirstName.Value = "Abraham", "Adria", Fields!FirstName.Value = "Charelotte", "Cherrie")', label: "Switch", syntax: "Switch(<Condition1>, <Value1>[, <Condition2>, <Value2>,...[, <ConditionN>, <ValueN>]])" } }, text: { contains: { description: "Returns True if the string contains the specified substring.", example: '=Fields!ShipAddress.Value.Contains("street")', label: "Contains", syntax: "<String>.Contains(<String>)" }, endsWith: { description: "Returns True if the string ends with the specified substring.", example: '=Fields!Description.Value.EndsWith("documents")', label: "EndsWith", syntax: "<String>.EndsWith(<String>)" }, inStr: { description: "Returns the start position of the first occurrence of the specified substring within the string.", example: '=InStr(Fields!Description.Value, "documents")', label: "InStr", syntax: "InStr(<String>, <String>)" }, lastIndexOf: { description: "Returns the index of the last occurrence of the specified substring within the string.", example: '=Fields!Description.Value.LastIndexOf("documents")', label: "LastIndexOf", syntax: "<String>.LastIndexOf(<String>[, <Number>])" }, replace: { description: "Replaces all the occurrences of the first specified substring with the second specified substring within the string.", example: '=Fields!Description.Value.Replace("documents", "invoices")', label: "Replace", syntax: "<String>.Replace(<String>, <String>)" }, startsWith: { description: "Returns True if the string starts with the specified substring.", example: '=Fields!Description.Value.StartsWith("Invoice")', label: "StartsWith", syntax: "<String>.StartsWith(<String>)" }, substring: { description: "Returns the substring at the specified position (zero-based) of the specified length.", example: "=Fields!Description.Value.Substring(1, 10)", label: "Substring", syntax: "<String>.Substring(<Number>, <Number>)" }, toLower: { description: "Returns the specified string in lower case.", example: "=Fields!ShipCountry.Value.ToLower()", label: "ToLower", syntax: "<String>.ToLower()" }, toUpper: { description: "Returns the specified string in upper case.", example: "=Fields!ShipCountry.Value.ToUpper()", label: "ToUpper", syntax: "<String>.ToUpper()" }, trim: { description: "Returns the string after removing all the white-space characters from both the start and the end of the specified string.", example: "=Parameters!Info.Value.Trim()", label: "Trim", syntax: "<String>.Trim()" }, trimEnd: { description: "Returns the string after removing all the white-space characters from the end of the specified string.", example: "=Parameters!Info.Value.TrimEnd()", label: "TrimEnd", syntax: "<String>.TrimEnd()" }, trimStart: { description: "Returns the string after removing all the white-space characters from the start of the specified string.", example: "=Parameters!Info.Value.TrimStart()", label: "TrimStart", syntax: "<String>.TrimStart()" } } }, titles: { aggregate: "Aggregate", conversion: "Conversion", dateTime: "Date & Time", inspection: "Inspection", label: "Common Functions", math: "Math", miscellaneous: "Miscellaneous", programFlow: "Program Flow", text: "Text" } }, operations: { info: { arithmetic: { add: { description: "Evaluates the sum of two numbers or concatenates two strings.", example: "=Fields!Quantity.Value + 2", label: "+", syntax: "<Value1> + <Value2>" }, divide: { description: "Divides two numbers (numerator by denominator) and returns the quotient as a floating-point number.", example: "=Fields!AnnualSales.Value / 2", label: "/", syntax: "<Number1> / <Number2>" }, integerDivide: { description: "Divides two numbers and returns an integer result.", example: "=Fields!AnnualSales.Value \\ 2", label: "\\", syntax: "<Number1> \\ <Number2>" }, mod: { description: "Divides two numbers and returns the remainder.", example: "=Fields!AnnualSales.Value Mod 12", label: "Mod", syntax: "<Number1> Mod <Number2>" }, multiply: { description: "Evaluates the multiplication of two numbers.", example: "=Fields!Quantity.Value * 5", label: "*", syntax: "<Number1> * <Number2>" }, power: { description: "Raises a number to the power of another number.", example: "=Fields!Quantity.Value ^ 2", label: "^", syntax: "<Number1> ^ <Number2>" }, subtract: { description: "Evaluates the difference between two numbers or negates the value of a numeric expression.", example: "=Fields!Quantity.Value - 2", label: "-", syntax: "<Number1> - <Number2>" } }, bitShift: { leftShift: { description: "Performs an arithmetic left shift on a bit pattern.", example: "=Fields!RegionID.Value << 2", label: "<<", syntax: "<Number1> << <Number2>" }, rightShift: { description: "Performs an arithmetic right shift on a bit pattern.", example: "=Fields!RegionID.Value >> 2", label: ">>", syntax: "<Number1> >> <Number2>" } }, comparison: { equal: { description: "Returns True if the left operand is equal to the right operand.", example: "=Fields!AnnualSales.Value = 80000", label: "=", syntax: "<Value1> = <Value2>" }, greaterThan: { description: "Returns True if the left operand is greater than the right operand.", example: "=Fields!AnnualSales.Value > 80000", label: ">", syntax: "<Value1> > <Value2>" }, greaterThanOrEqual: { description: "Returns True if the left operand is greater than or equal to the right operand.", example: "=Fields!AnnualSales.Value >= 80000", label: ">=", syntax: "<Value1> >= <Value2>" }, is: { description: "Compares two object references and returns True if the left operand is identical to the right operand.", example: "=Fields!FirstName.Value Is Fields!LastName.Value", label: "Is", syntax: "<Value1> Is <Value2>" }, like: { description: "Compares two strings and returns True if the left operand is the same as the right operand.", example: '=Fields!FirstName.Value Like "A*"', label: "Like", syntax: "<String1> Like <String2>" }, lowerThan: { description: "Returns True if the left operand is less than the right operand.", example: "=Fields!AnnualSales.Value < 80000", label: "<", syntax: "<Value1> < <Value2>" }, lowerThanOrEqual: { description: "Returns True if the left operand is less than or equal to the right operand.", example: "=Fields!AnnualSales.Value <= 80000", label: "<=", syntax: "<Value1> <= <Value2>" }, notEqual: { description: "Returns True if the left operand is not equal to the right operand.", example: "=Fields!AnnualSales.Value <> 80000", label: "<>", syntax: "<Value1> <> <Value2>" } }, concatenation: { add: { description: "Evaluates the sum of two numbers or concatenates two strings.", example: '=Fields!FirstName.Value + " " + Fields!LastName.Value', label: "+", syntax: "<String1> + <String2>" }, concat: { description: "Returns the string value of the concatenation of two expressions that individually evaluate to strings.", example: '=Fields!FirstName.Value & " " & Fields!LastName.Value', example_i11n: '{FirstName & " " & LastName}', label: "&", syntax: "<String1> & <String2>" } }, logicalBitwise: { and: { description: "Returns the logical conjunction of two Boolean expressions, or the bitwise conjunction of two numeric expressions.", example: "=(Fields!AnnualSales.Value > 80000) And (Fields!Quantity.Value > 5)", label: "And", syntax: "<Value1> And <Value2>" }, andAlso: { description: "Returns the logical conjunction of two Boolean expressions by skipping evaluation of the other expression if the evaluation of the first expression provides the result.", example: "=(Fields!AnnualSales.Value > 80000) AndAlso (Fields!Quantity.Value > 1)", label: "AndAlso", syntax: "<Boolean1> AndAlso <Boolean2>" }, not: { description: "Returns the logical negation of a Boolean expression, or the bitwise negation of a numeric expression.", example: "=Not (Fields!AnnualSales.Value > 80000)", label: "Not", syntax: "Not <Value>" }, or: { description: "Returns the logical disjunction of two Boolean expressions, or the bitwise disjunction of two numeric values.", example: "=(Fields!AnnualSales.Value > 80000) Or (Fields!Quantity.Value > 5)", label: "Or", syntax: "<Value1> Or <Value2>" }, orElse: { description: "Returns the logical disjunction of two Boolean expressions by skipping evaluation of one expression if the evaluation of the other expression provides the result.", example: "=(Fields!AnnualSales.Value > 80000) OrElse (Fields!Quantity.Value > 1)", label: "OrElse", syntax: "<Boolean1> OrElse <Boolean2>" }, xor: { description: "Returns a logical exclusion operation of two Boolean expressions, or a bitwise exclusion of two numeric expressions.", example: "=(Fields!AnnualSales.Value > 80000) Xor (Fields!Quantity.Value) > 5", label: "Xor", syntax: "<Value1> Xor <Value2>" } } }, titles: { arithmetic: "Arithmetic", bitShift: "Bit Shift", comparison: "Comparison", concatenation: "Concatenation", label: "Operations", logicalBitwise: "Logical/Bitwise" } }, parameters: { titles: { label: "Parameters" } }, slicers: { titles: { label: "Slicers" } }, reportItems: { titles: { label: "Report Items" } }, dataSets: { titles: { label: "Data Sets" } }, theme: { titles: { color: "Colors", constant: "Constants", font: "Fonts", image: "Images", label: "Theme", majorFont: "Major Font", minorFont: "Minor Font" } }, textEncodingFields: { titles: { label: "Text Encoding Fields" } }, reportPartProperties: { titles: { label: "Report Part Properties" }, info: { example: "=PartProperties!<PropertyName>.Value", example_i11n: "{PartProperties.<PropertyName>.Value}, {PartProperties!<PropertyName>.Value}" } } }, filters: { add: "Add...", edit: "Edit...", addCriterion: "Add Criterion", expressionText: "Expression...", addGroup: "Add Group", operators: { beginsWith: "Begins With", between: "Between", bottomN: "Bottom N", bottomPercent: "Bottom Percent", contains: "Contains", doesNotBeginWith: "Does Not Begin With", doesNotContain: "Does Not Contain", equalTo: "Equal To", greaterThan: "Greater Than", greaterThanOrEqualTo: "Greater Than Or Equal To", in: "In", lessThan: "Less Than", lessThanOrEqualTo: "Less Than Or Equal To", like: "Like", notEqualTo: "Not Equal To", notIn: "Not In", topN: "Top N", topPercent: "Top Percent" }, delete: "Delete", reset: "Reset", allOf: "All Of", anyOf: "Any Of", addItem: "Add Item", newParameter: "New Parameter", listItemsCount: "{{count}} item", listItemsCount_plural: "{{count}} items" }, "glyphs-RPX": { barcode: { unsupportedSymbology: '[{{symbology}}] "{{itemName}}" preview is limited in design-time.', textError: "Error" } }, groupEditor: { textSelectTablix: "Select a tablix to edit its groups", headingRowGroups: "Row Groups", headingColumnGroups: "Column Groups", labelAdvancedMode: "Advanced Mode", btnEditExpression: "Edit Expression", btnEnableGroup: "Enable Group", btnDisableGroup: "Disable Group", headingAddGroup: "Add Group", addGroup: { btnParent: "Parent", btnChild: "Child", btnAdjacentBefore: "Adjacent Before", btnAdjacentAfter: "Adjacent After" }, headingAddTotal: "Add Total", addTotal: { btnBefore: "Before", btnAfter: "After" }, btnDelete: "Delete", textHiddenStatic: "(Static)" }, labels: { dvchartXAxis: "X Axis", dvchartYAxis: "Y Axis", dvchartPlotRuleNoCondition: "Empty Condition", header: "Header", body: "Body", footer: "Footer", pageHeader: "Page Header", pageFooter: "Page Footer", total: "Total" }, marginsSizes: { values: [{ _name: "None", cm: { bottom: "0cm", left: "0cm", right: "0cm", top: "0cm" }, in: { bottom: "0in", left: "0in", right: "0in", top: "0in" } }, { _name: "Narrow", cm: { bottom: "1.25cm", left: "1.25cm", right: "1.25cm", top: "1.25cm" }, in: { bottom: "0.5in", left: "0.5in", right: "0.5in", top: "0.5in" } }, { _name: "Normal", cm: { bottom: "2.5cm", left: "2.5cm", right: "2.5cm", top: "2.5cm" }, in: { bottom: "1in", left: "1in", right: "1in", top: "1in" } }, { _name: "Wide", cm: { bottom: "2.5cm", left: "5cm", right: "5cm", top: "2.5cm" }, in: { bottom: "1in", left: "2in", right: "2in", top: "1in" } }] }, "nameTemplate-RPX": { Style: "Style", Barcode: "Barcode", CheckBox: "CheckBox", CrossSectionBox: "CrossSectionBox", CrossSectionLine: "CrossSectionLine", Unknown: "Unknown", InputFieldCheckBox: "InputFieldCheckBox", InputFieldText: "InputFieldText", Label: "Label", Line: "Line", PageBreak: "PageBreak", Picture: "Picture", ReportInfo: "ReportInfo", RichTextBox: "RichTextBox", Detail: "Detail", PageHeader: "PageHeader", PageFooter: "PageFooter", GroupHeader: "GroupHeader", GroupFooter: "GroupFooter", ReportHeader: "ReportHeader", ReportFooter: "ReportFooter", Shape: "Shape", SubReport: "SubReport", TextBox: "TextBox" }, nameTemplates: { label: "Label", pointer: "Pointer", bandedListGroup: "Group", bandedList: "BandedList", barcode: "Barcode", bullet: "Bullet", dvchart: "Chart", dvchartPlot: "Plot", checkbox: "CheckBox", contentplaceholder: "ContentPlaceholder", Unknown: "Item", formattedText: "FormattedText", image: "Image", inputField: "InputField", layer: "Layer", line: "Line", list: "List", reportPart: "ReportPart", reportPartProperty: "Property", overflowPlaceholder: "OverflowPlaceholder", partItem: "PartItem", container: "Container", richtext: "RichText", shape: "Shape", sparkline: "Sparkline", subreport: "Subreport", table: "Table", tableGroup: "TableGroup", tablix: "Tablix", textbox: "TextBox", tableOfContents: "TableOfContents", tocLevel: "Level", fixedPage: "FixedPage", group: "Group", detailsGroup: "DetailsGroup", calculatedField: "CalculatedField", field: "Field", parameter: "Parameter", mailMergeField: "Field", parameterCollection: "Parameter", categoryGroup: "CategoryGroup", columnGroup: "ColumnGroup", dataset: "DataSet", dvchartEncodingField: "Field", dvchartoverlay: "Overlay", dvchartrule: "Rule", dvcharttextencoding: "Text", reportParameter: "Parameter", reportSlicer: "ReportSlicer", rowGroup: "RowGroup", seriesGroup: "SeriesGroup", seriesValue: "Value", tableDetailsGroup: "DetailsGroup", chart: "Chart", Continuous: "ContinuousSection", dashboardSection: "Section" }, notifications: { masterReports: { reportItemsWereMovedOrResized: { details: "{{num}}. {{items}} in the {{contentPlaceholder}}\n", caption: "Report items were moved or resized", text: "The items in the content placeholders moved or resized to fit into the updated content placeholders of master report:\n{{outsideItems}}" }, dataSetsWereRenamed: { caption: "Data sets were renamed", text: "Data sets which conflict with those in the master report were renamed: {{dataSetNames}}." }, dataSourcesWereRenamed: { caption: "Data sources were renamed", text: "Data sources which conflict with those in the master report were renamed: {{dataSourceNames}}." }, parametersWereRenamed: { caption: "Report parameters were renamed", text: "Parameters which conflict with those in the master report were renamed: {{parameterNames}}." }, reportItemsWereRenamed: { caption: "Report items were renamed", text: "Report items which conflict with those in the master report were renamed: {{reportItemNames}}." }, embeddedImagesWereRenamed: { caption: "Embedded Images were renamed", text: "Embedded Images which conflict with those in the master report were renamed: {{embeddedImagesNames}}." }, layersWereRenamed: { caption: "Layers were renamed", text: "Layers which conflict with those in the master report were renamed: {{layersNames}}." } }, addReportItem: { caption: "Report item of type '{{reportItemType}}' can't be added to {{containerType}}" }, contentPlaceholderSize: { caption: "Action cannot be performed", text: "Content exceeds Content placeholder size." }, deleteRowColumn: { caption: "Cannot delete {{rowColumn}}", text: "{{rowColumn}} cannot be deleted because {{itemType}} '{{itemName}}' would have invalid size as a result." }, fixedPageSize: { caption: "Action cannot be performed", text: "Report item could not exceed page size" }, fplPasteFailed: { caption: "Paste operation failed", text: "There is not enough space to paste report items" }, innerException: { caption: "Inner exception occurred" }, invalidPageSizes: { caption: "This action will result in invalid page sizes" }, lockLayout: { caption: "Report layout is locked", text: "Resizing, moving, deleting, adding report items and changing layout properties is restricted." }, removeDefaultLayer: { caption: "Default layer can't be removed" }, transaction: { caption: "Transaction failed: {{innerException}}" }, listRowsOrColumnsCount: { caption: "Action cannot be performed", text: "Content exceeds list column/row size" }, libraries: { loadingFailed: { caption: 'Library "{{path}}" loading failed' }, importFailed: { caption: 'Library "{{path}}" importing failed' }, unknownLibrary: { caption: "Report depends on unknown library", text: 'The library "{{libName}}" used in this report is not found' }, nonMslLibrary: { text: "Unable to parse non-MSL report as library" }, dataSourceNotFound: { text: 'Required data source "{{dataSourceName}}" not found' }, dataSetNotFound: { text: 'Required data set "{{dataSetName}}" not found' }, noDataSetsFound: { text: "No data sets found in library" }, invalidLibraryName: { text: 'Invalid library name "{{libName}}". Use alphanumeric characters and underscore only' }, duplicateLibrary: { text: 'Library with {{libProp}} "{{libValue}}" already exists. Library {{libProp}} must be unique' } }, contentPlaceholderSizeWithDetails: { text: "Content exceeds Content placeholder size. Please try manually reducing the size or position of {{items}} in the {{contentPlaceholder}}." }, convertTableForClient: { text: "\u2718 Table '{{name}}' has invalid structure and has been converted to Tablix" }, removeLastValidValue: { caption: "Last valid value for bound parameter can't be removed" }, pasteFailedDecode: { caption: "Decode error while pasting: {{reason}}" }, pasteWarningDecode: { caption: "Decode warning while pasting", text: "{{warning}}" }, pasteFailed: { caption: "Not valid item to paste: {{elementName}}", text: "You can paste Overflow Placeholder in fixed page report only" } }, pageSizes: { values: [{ _name: "Letter", cm: { height: "27.9cm", width: "21.6cm" }, in: { height: "11in", width: "8.5in" } }, { _name: "Tabloid", cm: { height: "43.2cm", width: "27.9cm" }, in: { height: "17in", width: "11in" } }, { _name: "Legal", cm: { height: "35.6cm", width: "21.6cm" }, in: { height: "14in", width: "8.5in" } }, { _name: "Executive", cm: { height: "26.7cm", width: "18.4cm" }, in: { height: "10.5in", width: "7.25in" } }, { _name: "A3", cm: { height: "42cm", width: "29.7cm" }, in: { height: "16.54in", width: "11.69in" } }, { _name: "A4", cm: { height: "29.7cm", width: "21cm" }, in: { height: "11.69in", width: "8.27in" } }, { _name: "A5", cm: { height: "21cm", width: "14.8cm" }, in: { height: "8.27in", width: "5.83in" } }, { _name: "A6", cm: { height: "14.8cm", width: "10.5cm" }, in: { height: "5.83in", width: "4.13in" } }, { _name: "B4 (JIS)", cm: { height: "36.4cm", width: "25.7cm" }, in: { height: "14.33in", width: "10.12in" } }, { _name: "B5 (JIS)", cm: { height: "25.7cm", width: "18.2cm" }, in: { height: "10.12in", width: "7.17in" } }, { _name: "B6 (JIS)", cm: { height: "18.2cm", width: "12.8cm" }, in: { height: "7.17in", width: "5.04in" } }, { _name: "B5 (ISO)", cm: { height: "25cm", width: "17.6cm" }, in: { height: "9.84in", width: "6.93in" } }] }, parametersViewEditor: { bindingAdorner: { textUnspecified: "Unspecified", headingBinding: "Binding" }, parametersPanel: { titleEditParameter: "Edit Parameter...", headingEditable: "Visible", headingHidden: "Hidden", headingEditParameter: "Edit Parameter", headingEditRange: "Edit Range" }, properties: { categories: { preview: "Preview", common: "Common", appearance: "Appearance", advanced: "Advanced", binding: "Binding", locationAndSize: "Location & Size", details: "Details", label: "Label" }, labels: { amount: "Amount", label: "Label", anchorDate: "Anchor Date", offset: "Offset", endpoint: "Endpoint", endpointStates: { textTrue: "Include", textFalse: "Exclude" }, binding: "Binding", left: "Left", top: "Top", width: "Width", height: "Height", ranges: "Ranges", showDefaultRanges: { label: "Default Ranges", textTrue: "Visible", textFalse: "Hidden" }, value: "Value", trueText: '"True" text', falseText: '"False" text', text: "Text", layout: "Layout", type: "Type", display: "Display", action: "Action", background: "Background", from: "From", to: "To", maxRange: "Max Range", viewMode: "View Mode", daysHeaderFormat: "Days Header Format", placeholder: "Placeholder", placeholderFrom: '"From" Placeholder', placeholderTo: '"To" Placeholder', alignment: "Alignment", color: "Color", strikeThrough: "Strikethrough", columns: "Columns", min: "Min", max: "Max", step: "Step", roundInputToStep: "Round Input To Step", upDownEditor: "Up-Down Editor", slider: "Slider", multiline: "Multiline", list: "List", dropdown: "Dropdown", recursive: "Recursive", groupBy: "Group By", pathString: "Path String", mode: "Mode", fields: "Fields", unit: "Unit", range: "Range" } }, sideBar: { collapse: "Collapse", expand: "Expand" }, propertiesText: "Properties", parametersText: "Parameters", canvas: "Canvas", boundParameter: { text: "Bound Parameter", parameter: "{{name}} Parameter", defaultValue: "Default Value", multiValue: "Multi Value", multiline: "Multiline", allowBlank: "Allow Blank", nullable: "Nullable" }, propertyGrid: { btnCloseSearch: "Close", textEmptyList: "Select an item to see properties", placeholderSearch: "enter property name here...", textNoCommonProperties: "There are no common properties", textUnknownProperty: "Unknown Property:" }, surface: { btnAutoGenerate: "Auto-Generate", messageBlock: { textDescriptionOne: "Not all report parameters have been bound.", textDescriptionButtonBefore: "You can", textDescriptionButtonAfter: "editors for them." }, btnGenerate: "Generate", emptySurfaceBlock: { textDescriptionOne: "This report doesn't have a custom parameters view.", textDescriptionButtonBefore: "You can", textDescriptionButtonAfter: "it from available parameters, or have a fresh start with the controls from the toolbox.", textDescriptionTwo: "You can create it using controls from the toolbox." }, scrollBar: { textMessagesOne: "Parameters will look this way when shown in the viewer`s sidebar.", textMessagesTwo: "You can change the order by dragging components." } }, toolbar: { btnDuplicate: "Duplicate", btnDelete: "Delete", btnLayoutStack: "Stack", btnLayoutFreeForm: "Free Form", btnHighlightRequired: "Highlight Required", btnGenerateView: "Generate View", btnResetView: "Reset View", btnRemoveView: "Remove View" }, booleanProperties: { trueText: "True", falseText: "False", undefinedText: "Undefined", toggle: "Toggle", checkbox: "Checkbox", radio: "Radio" }, parameters: { labelBoolean: "Boolean Parameter", labelDateRange: "DateRange Parameter", labelDateTime: "DateTime Parameter", labelDateTimeRange: "DateTimeRange Parameter", labelDropdown: "Dropdown Parameter", labelList: "List Parameter", labelMultivalue: "Multivalue Parameter", labelNumber: "Number Parameter", labelNumberRange: "NumberRange Parameter", labelSingleLineParameter: "Single-Line Parameter", labelHierarchical: "Hierarchical Parameter" }, editors: { nameBoolean: "Boolean Editor", nameButton: "Button", nameDateRange: "Date Range Editor", nameDateTime: "DateTime Editor", nameDateTimeRange: "DateTime Range Editor", nameDropdown: "Dropdown Editor", textHeading: "Heading Text", nameHeading: "Heading", nameList: "List Editor", nameMultivalue: "Multivalue Editor", textNull: "Null", nameNumber: "Number Editor", textCheckRangeType: "Both parameters should have the same data type", nameNumberRange: "Number Range Editor", namePlainText: "Plain Text", nameText: "Text Editor", nameTreeView: "Tree View" }, bindingProperties: { boolean: "Boolean", date: "Date", dateDateTime: "Date, DateTime", any: "Any", integerFloat: "Integer, Float" }, buttonProperties: { preview: "Preview", reset: "Reset", clear: "Clear" }, dateRangeParameterLabels: { tabLabelDaily: "Daily", tabLabelMonthly: "Monthly", tabLabelAnnually: "Annually", textBack: "Back to Calendar", textShortcutsList: "Common Ranges", placeholderDateStart: "Start", placeholderDateEnd: "End", shortcuts: { labelLastWeek: "Last week", labelLastMonth: "Last month", labelLastYear: "Last year", labelWeekToDate: "Week to date", labelMonthToDate: "Month to date", labelYearToDate: "Year to date" }, monthYearOrder: "M-Y" }, dateTimeParameterLabels: { monthYearOrder: "M-Y", textClear: "Clear", textToday: "Today", textBack: "Back to Calendar" }, dateTimeRange: { rangeTypes: { Current_Year: "Current Year", Current_Quarter: "Current Quarter", Current_Month: "Current Month", Current_Week: "Current Week", Current_Day: "Current Day", Current_Hour: "Current Hour", Current_Minute: "Current Minute", ToDate_Year: "Year-To-Date", ToDate_Quarter: "Quarter-To-Date", ToDate_Month: "Month-To-Date", ToDate_Week: "Week-To-Date", ToDate_Day: "Day-To-Date", LastSimple_Year: "Last Year", LastSimple_Quarter: "Last Quarter", LastSimple_Month: "Last Month", LastSimple_Week: "Last Week", LastSimple_Day: "Last Day", LastSimple_Hour: "Last Hour", LastSimple_Minute: "Last Minute", LastSimple_Second: "Last Second", NextSimple_Year: "Next Year", NextSimple_Quarter: "Next Quarter", NextSimple_Month: "Next Month", NextSimple_Week: "Next Week", NextSimple_Day: "Next Day", NextSimple_Hour: "Next Hour", NextSimple_Minute: "Next Minute", NextSimple_Second: "Next Second", LastToDateSimple_Year: "Last Year To Date", LastToDateSimple_Quarter: "Last Quarter To Date", LastToDateSimple_Month: "Last Month To Date", LastToDateSimple_Week: "Last Week To Date", LastToDateSimple_Day: "Last Day To Date", Last_Year: "Last {{count}} Years", Last_Year_plural: "Last {{count}} Years", Last_Quarter: "Last {{count}} Quarters", Last_Quarter_plural: "Last {{count}} Quarters", Last_Month: "Last {{count}} Months", Last_Month_plural: "Last {{count}} Months", Last_Week: "Last {{count}} Weeks", Last_Week_plural: "Last {{count}} Weeks", Last_Day: "Last {{count}} Days", Last_Day_plural: "Last {{count}} Days", Last_Hour: "Last {{count}} Hours", Last_Hour_plural: "Last {{count}} Hours", Last_Minute: "Last {{count}} Minutes", Last_Minute_plural: "Last {{count}} Minutes", Last_Second: "Last {{count}} Seconds", Last_Second_plural: "Last {{count}} Seconds", Next_Year: "Next {{count}} Years", Next_Year_plural: "Next {{count}} Years", Next_Quarter: "Next {{count}} Quarters", Next_Quarter_plural: "Next {{count}} Quarters", Next_Month: "Next {{count}} Months", Next_Month_plural: "Next {{count}} Months", Next_Week: "Next {{count}} Weeks", Next_Week_plural: "Next {{count}} Weeks", Next_Day: "Next {{count}} Days", Next_Day_plural: "Next {{count}} Days", Next_Hour: "Next {{count}} Hours", Next_Hour_plural: "Next {{count}} Hours", Next_Minute: "Next {{count}} Minutes", Next_Minute_plural: "Next {{count}} Minutes", Next_Second: "Next {{count}} Seconds", Next_Second_plural: "Next {{count}} Seconds", LastToDate_Year: "Last {{count}} Years To Date", LastToDate_Year_plural: "Last {{count}} Years To Date", LastToDate_Quarter: "Last {{count}} Quarters To Date", LastToDate_Quarter_plural: "Last {{count}} Quarters To Date", LastToDate_Month: "Last {{count}} Months To Date", LastToDate_Month_plural: "Last {{count}} Months To Date", LastToDate_Week: "Last {{count}} Weeks To Date", LastToDate_Week_plural: "Last {{count}} Weeks To Date", LastToDate_Day: "Last {{count}} Days To Date", LastToDate_Day_plural: "Last {{count}} Days To Date" } }, alignmentEnum: { left: "Left", center: "Center", right: "Right", justify: "Justify", none: "None", top: "Top", bottom: "Bottom", horizontal: "Horizontal", vertical: "Vertical" }, dateViewProperties: { default: "Default", days: "Days", months: "Months", years: "Years", accent: "Accent", error: "Error", warning: "Warning", none: "None" }, fieldsProperties: { addBtnText: "Add", addBtnTitle: "Add Item", closeBtnTitle: "Close", showItem: "Show Items", collectionIsEmpty: "Collection is empty", items: "items" }, labels: { removeDefaultValue: "Remove Default Value" }, placeholderEmpty: "<Empty>", placeholderMultipleValues: "<Multiple Values>", dataType: { boolean: "Boolean", string: "String", integer: "Integer", float: "Float", date: "Date", dateTime: "DateTime" }, msgString: { notSupControl: "is not supported by this control", controlNotSupportSingle: "This control doesn't support single value parameters", controlRequires: "This control requires a list of available values", controlNotSupportParameters: "This control doesn't support parameters with available values defined" } }, "properties-RPX": { labels: { paperSize: "Paper Size", paperWidth: "Paper Width", paperHeight: "Paper Height", orientation: "Orientation", radius: { default: "Default" }, alignment: "Alignment", backColor: "Background Color", barHeight: "Bar Height", barWidth: "Bar Width", captionGrouping: "Caption Grouping", captionPosition: "Caption Position", fontFamily: "Font Family", fontSize: "Font Size", fontWeight: "Font Weight", fontStyle: "Font Style", fontUnderline: "Text Underline", fontLinethrough: "Text Strikethrough", foreColor: "Fore Color", nwratio: "NW Ratio", rotation: "Rotation", barCodeStyle: "Style", quietZoneLeft: "Quiet Zone Left", quietZoneRight: "Quiet Zone Right", quietZoneTop: "Quiet Zone Top", quietZoneBottom: "Quiet Zone Bottom", supplementText: "Supplement Text", supplementBarHeight: "Supplement Bar Height", supplementCaptionPosition: "Supplement Caption Position", supplementDataField: "Supplement Data Field", supplementSpacing: "Supplement Spacing", autoSize: "Auto Size", checkSumEnabled: "Checksum Enabled", text: "Text", checkAlignment: "Check Alignment", checked: "Checked", padding: "Padding", border: { style: "Border Style", color: "Border Color", width: "Border Width" }, control: { name: "Name", visible: "Visible", dataField: "Data Field", tag: "Tag", left: "Left", top: "Top", width: "Width", height: "Height", right: "Right", bottom: "Bottom" }, styles: "Styles", style: { className: "Class Name", backColor: "Background Color", foreColor: "Color", fontFamily: "Font Family", fontSize: "Font Size", fontWeight: "Font Weight", fontStyle: "Font Style", shrinkToFit: "Shrink To Fit", fontUnderline: "Text Underline", fontLinethrough: "Text Strikethrough", textAlign: "Text Alignment", textJustify: "Text Justify", verticalAlign: "Vertical Alignment", wrapMode: "Wrap Mode", verticalText: "Vertical Text", ddoCharSet: "Script", kinsoku: "Kinsoku", styleName: "Name" }, crossSectionBoxRadius: "Radius", lineColor: "Line Color", lineStyle: "Line Style", lineWeight: "Line Weight", checkSize: "Check Size", fieldName: "Field Name", readonly: "Readonly", required: "Required", tabIndex: "Tab Index", checkStyle: "Check Style", outputFormat: "Output Format", maxLength: "Max Length", multiLine: "Multiline", spellCheck: "Spellcheck", password: "Password", hyperLink: "Hyperlink", rightToLeft: "Right to Left", angle: "Angle", minCondenseRate: "Min Condense Rate", characterSpacing: "Character Spacing", lineSpacing: "Line Spacing", x1: "X1", x2: "X2", y1: "Y1", y2: "Y2", anchorBottom: "Anchor Bottom", enabled: "Enabled", image: "Image", title: "Title", description: "Description", pictureAlignment: "Picture Alignment", sizeMode: "Size Mode", calcFieldName: "Name", calcFieldFormula: "Formula", calcFieldType: "Type", calcFieldDefaultValue: "Default Value", parameterName: "Name", parameterPrompt: "Prompt", parameterPromptUser: "Prompt User", parameterParameterType: "Parameter Type", parameterDefaultValue: "Default Value", parameterFormat: "Format", printWidth: "Print Width", maxPages: "Max Pages", paramUI: "Show Parameters UI", margin: "Margin", gutterMargin: "Gutter", mirrorMargins: "Mirror Margins", collate: "Collate", duplex: "Duplex", watermarkImage: "Image", watermarkAlignment: "Alignment", watermarkSizeMode: "Size Mode", watermarkPrintOnPages: "Print On Pages", scriptLanguage: "Script Language", culture: "Culture", userData: "User Data", script: "Script", version: "Version", expressionErrorMessage: "Expression Error Message", calendar: "Calendar", summaryRunning: "Summary Running", summaryGroup: "Summary Group", formatString: "Format String", canGrow: "Can Grow", canShrink: "Can Shrink", autoReplaceFields: "Auto Replace Fields", htmlValue: "HTML Value", MultiLine: "Multiline", name: "Name", height: "Height", columnCount: "Column Count", columnDirection: "Column Direction", columnSpacing: "Column Spacing", colKeepTogether: "Column Group Keep Together", columnLayout: "Column Layout", groupKeepTogether: "Group Keep Together", keepTogether: "Keep Together", newColumn: "New Column", newPage: "New Page", printAtBottom: "Print At Bottom", repeatStyle: "Repeat Style", repeatToFill: "Repeat To Fill", underlayNext: "Underlay Next", visible: "Visible", dataField: "Data Field", tag: "Tag", shape: "Shape", backgroundStyle: "Background Style", gradientStyle: "Gradient Style", backgroundPattern: "Background Pattern", backColor2: "Background Color 2", roundingRadius: "Rounding Radius", reportName: "Report Name", countNullValues: "Count Null Values", summaryType: "Summary Type", summaryFunc: "Summary Func", distinctField: "Distinct Field" }, categories: { appearance: "Appearance", behavior: "Behavior", common: "Common", data: "Data", design: "Design", layout: "Layout", summary: "Summary", format: "Format", misc: "Misc", page: "Page", watermark: "Watermark", printing: "Printing", text: "Text", border: "Border", pdf: "PDF" } }, propertyDescriptors: { labels: { border: { width: "Width", style: "Style", color: "Color", bottom: "Bottom", default: "Default", left: "Left", right: "Right", top: "Top" }, roundingRadius: { bottomLeft: "Bottom Left", bottomRight: "Bottom Right", default: "Default", label: "Rounding Radius", topLeft: "Top Left", topRight: "Top Right" }, dvchart: { plotTemplateDropdown: "Select...", bar: { bottomWidth: "Bottom Width", neckHeight: "Neck Height", overlap: "Overlap", topWidth: "Top Width", width: "Width" }, customPaletteColors: "Custom Palette Colors", legendHidden: "Hidden", legendOrientation: "Orientation", legendPosition: "Position", legendWrapping: "Wrapping", palette: "Palette", plotTemplate: "Plot Template", plots: "Plots" }, dvPlotOverlays: { name: "Name", type: "Type", display: "Display", lineColor: "Line Color", lineStyle: "Line Style", lineWidth: "Line Width", backgroundColor: "Background Color", field: "Field", detailLevel: "Detail Level", legendLabel: "Legend Label", value: "Value", axis: "Axis", aggregateType: "Aggregate Type", start: "Start", end: "End", order: "Order", period: "Period", forwardForecastPeriod: "Forward Forecast Period", backwardForecastPeriod: "Backward Forecast Period", intercept: "Intercept" }, dvchartPlotRules: { name: "Name", targetProperty: "Target Property", valueRuleProperties: "Value", condition: "Condition", ruleProperties: "Rule Properties" }, dvChartPlotPointers: { needleWidth: "Needle Width", needlePinWidth: "Needle Pin Width", end: "End" }, dvChartPlotCustomLabels: { text: "Text", offsetX: "Offset X", offsetY: "Offset Y" }, parameter: { omit: "Omit", parametername: "Parameter Name", parameters: "Parameters", value: "Value" }, multipleValues: "<Multiple Values>", overflowPlaceHolder: { overflowName: "Overflow Name" }, padding: { bottom: "Bottom", left: "Left", right: "Right", top: "Top" }, pageSection: { printOnFirstPage: "Print On First Page", printOnLastPage: "Print On Last Page" }, partItem: { reportPart: "Report Part", library: "Library" }, report: { author: "Author", collapseWhiteSpace: "Collapse White Space", collateBy: "Collate By", columnSpacing: "Column Spacing", columns: "Columns", consumeContainerWhitespace: "Consume White Space", description: "Description", displayType: "Display Type", embeddedImages: "Embedded Images", language: "Language", layers: "Layers", layoutOrder: "Layout Order", level: "Level", levels: "Levels", marginsSizes: "Sizes", marginsStyle: "Style", nameMasterReport: "Master Report", numberingStyle: "Numbering Style", pageHeight: "Page Height", pageOrientation: "Page Orientation", pageSize: "Page Size", pageWidth: "Page Width", reportParts: "Report Parts", reportPart: { description: "Description", displayName: "Display Name", partProperties: "Properties", properties: { defaultValue: "Default Value", description: "Description", displayName: "Display Name", category: "Category", type: "Type" }, reportItemName: "Report Item Name", sizeMode: "Size Mode" }, sizeType: "Size Type", source: "Source", startPageNumber: "Start Page Number", theme: "Theme", themes: "Themes" }, reportItem: { actionType: "Type", bookmark: "Bookmark", keepTogether: "Keep Together", label: "Label", layerName: "Layer Name", name: "Name", pageName: "Page Name", style: "Style", toolTip: "Tooltip", visibility: "Visibility", zIndex: "Z-Index", accessibleDescription: "Accessible Description" }, reportParameter: { allowBlankValue: "Allow Blank Value", allowNullValue: "Allow Null Value", dataSetName: "Data Set Name", dataType: "Data Type", hidden: "Hidden", label: "Label", labelField: "Label Field", multiline: "Multiline", multivalue: "Multivalue", name: "Name", orderBy: "Order By", parameterFormat: "Format", parameterValues: "Parameter Values", prompt: "Prompt", selectAllValue: "Select All Value", selectAllValue_help: { text: 'If specified, determines the value to be passed to parameter value in case "Select All" flag is set for multivalue parameter.' }, value: "Value", valueField: "Value Field", values: "Values" }, reportSlicer: { allowBlankValue: "Allow Blank Value", allowNullValue: "Allow Null Value", dataSetName: "Data Set Name", multivalue: "Multivalue", name: "Name" }, richtext: { canGrow: "Can Grow", markup: "Markup Type", value: "Value" }, sparkline: { fillColor: "Fill Color", gradientEndColor: "Gradient End Color", gradientStyle: "Gradient Type", lineColor: "Line Color", lineWidth: "Line Width", markerColor: "Marker Color", markerVisibility: "Marker Visibility", maximumColumnWidth: "Maximum Width", rangeFillColor: "Fill Color", rangeGradientEndColor: "Gradient End Color", rangeGradientStyle: "Gradient Type", rangeLowerBound: "Lower Bound", rangeUpperBound: "Upper Bound", rangeVisibility: "Visibility", seriesValue: "Series Value", sparklineType: "Sparkline Type" }, style: { angle: "Angle", backgroundAndBorders: "Background & Borders", backgroundColor: "Color", backgroundGradientEndColor: "Gradient End Color", backgroundGradientType: "Gradient Type", backgroundImage: "Image", border: "Border", calendar: "Calendar", characterSpacing: "Character Spacing", color: "Color", corner: "Corner", direction: "Direction", font: "Font", format: "Format", headingLevel: "Heading Level", language: "Language", lineHeight: "Line Height", lineSpacing: "Line Spacing", maxLevel: "Max Level", minCondenseRate: "Min Condense Rate", minCondenseRate_help: { text: "Specifies the minimal rate of text horizontal shrinking in percentages. Should be between 10 and 100." }, numeralLanguage: "Numeral Language", numeralVariant: "Numeral Variant", padding: "Padding", shapeStyle: "Shape Style", shrinkToFit: "Shrink To Fit", textAlign: "Text Align", textDecoration: "Text Decoration", textIndent: "Text Indent", textJustify: "Text Justify", unicodeBiDi: "Unicode BiDi", uprightInVerticalText: "Upright In Vertical Text", verticalAlign: "Vertical Align", wrapMode: "Wrap Mode", writingMode: "Writing Mode" }, subreport: { inheritStyleSheet: "Inherit Style Sheet", mergeTransactions: "Merge Transactions", reportName: "Report Name", reportParameters: "Report Parameters", substituteThemeOnSubreport: "Substitute Theme On Subreport" }, table: { autoWidth: "Auto Width", detailsDataCollectionName: "Details Data Collection Name", detailsDataElementName: "Details Data Element Name", detailsDataElementOutput: "Details Data Element Output", keepTogether: "Keep Together", preventOrphanedFooter: "Prevent Orphaned Footer", printAtBottom: "Print At Bottom", repeatBlankRows: "Repeat Blank Rows", repeatOnNewPage: "Repeat On New Page" }, tablix: { frozenColumns: "Frozen Columns", frozenRows: "Frozen Rows", groupsBeforeRowHeaders: "Groups Before Row Headers", layoutDirection: "Layout Direction", repeatColumnHeaders: "Repeat Column Headers", repeatRowHeaders: "Repeat Row Headers" }, tablixBodyCell: { autoMergeMode: "Auto Merge Mode", autoMergeMode_help: { text: "Indicates whether two or more continuous cells in a column having the same content should be merged. It would work only for TextBox cell." } }, tablixMember: { groupEnabled: "Enabled", keepWithGroup: "Keep With Group", repeatOnNewPage: "Repeat On New Page" }, textbox: { canGrow: "Can Grow", canShrink: "Can Shrink", initialToggleState: "Initial Toggle State", value: "Value" }, tocLevel: { displayFillCharacters: "Display Fill Character", displayPageNumber: "Display Page Number", fillCharacter: "Fill Character", label: "Label" }, userSort: { sortExpression: "Sort Expression", sortExpressionScope: "Sort Expression Scope", sortTarget: "Sort Target" }, visibility: { hidden: "Hidden", toggleItem: "Toggle Item" }, empty: "<Empty>", filter: { filterExpression: "Filter Expression", filterValues: "Filter Values", operator: "Operator", value: "Value" }, font: { fontFamily: "Font Family", fontSize: "Font Size", fontStyle: "Font Style", fontWeight: "Font Weight" }, formattedText: { encodeMailMergeFields: "Encode Merge Fields", html: "Html", mailMergeFields: "Merge Fields" }, fplReport: { fixedElementName: "Fixed Page Element Name", fixedElementOutput: "Fixed Page Element Output" }, group: { dataCollectionName: "Data Collection Name", dataElementName: "Data Element Name", dataElementOutput: "Data Element Output", documentMapLabel: "Label", filters: "Filters", groupExpressions: "Group Expressions", name: "Name", newSection: "New Section", pageBreak: "Page Break", pageBreakDisabled: "Page Break Disabled", newPage: "New Page", parent: "Parent", printFooterAtBottom: "Print Footer At Bottom" }, inputField: { checkSize: "Check Size", checkStyle: "Check Style", checked: "Checked", fieldName: "Field Name", inputType: "Type", maxLength: "Max Length", multiline: "Multiline", password: "Password", readonly: "Readonly", required: "Required", spellCheck: "Spellcheck", tabIndex: "Tab Index", value: "Value" }, layer: { designerDataFieldVisible: "Field Selector Availability", designerLock: "Designer Lock", designerTransparency: "Designer Transparency", designerVisible: "Designer Visible", name: "Name", targetDevice: { all: "All", export: "Export", paper: "Paper", screen: "Screen" } }, line: { endPoint: "End Point", lineColor: "Line Color", lineStyle: "Line Style", lineWidth: "Line Width", startPoint: "Start Point" }, list: { consumeWhiteSpace: "Consume White Space", dataInstanceElementOutput: "Data Instance Element Output", dataInstanceName: "Data Instance Name", gridMode: "Grid Mode", rowsOrColumnsCount: "Rows Or Columns Count", growDirection: "Grow Direction" }, margins: { bottom: "Bottom", left: "Left", right: "Right", top: "Top" }, dataVisualizer: { colorScale: { maximum: "Maximum", maximumColor: "Maximum Color", middle: "Middle", middleColor: "Middle Color", minimum: "Minimum", minimumColor: "Minimum Color", useMiddleColor: "Use Middle Color", value: "Value" }, dataBar: { alternateColor: "Alternate Color", color: "Color", maximum: "Maximum", minimum: "Minimum", useAlternateColor: "Use Alternate Color", useAlternateColor_help: { text: "If enabled, 'Alternate Color' will be used when 'Value' is less than 'Zero Value'" }, value: "Value", zeroValue: "Zero Value" }, gradient: { color1: "Color 1", color2: "Color 2", gradientType: "Gradient Type" }, hatch: { color1: "Color 1", color2: "Color 2", hatchStyle: "Hatch Style" }, iconSet: { icon1Value: "Icon 1 Value", icon2Value: "Icon 2 Value", icon3Value: "Icon 3 Value", icon4Value: "Icon 4 Value", icon5Value: "Icon 5 Value", iconSet: "Icon Set" }, rangeBar: { color: "Color", displayProgressIndicator: "Display Progress Indicator", length: "Length", maximum: "Maximum", minimum: "Minimum", progressIndicatorColor: "Progress Indicator Color", progressIndicatorLength: "Progress Indicator Length", startingValue: "Starting Value" }, visualizerType: "Visualizer Type" }, dimensions: { bottom: "Bottom", endPointX: "End Point X", endPointY: "End Point Y", fixedHeight: "Fixed Height", fixedSize: "Fixed Size", fixedWidth: "Fixed Width", height: "Height", left: "Left", location: "Location", right: "Right", size: "Size", startPointX: "Start Point X", startPointY: "Start Point Y", top: "Top", width: "Width" }, dvchartAxis: { axisType: "Axis Type", dateMode: "Date Mode", gridLinesStyle: "Grid Line Style", height: "Height", labelAngle: "Label Angle", labelField: "Label Field", lineStyle: "Line Style", logBase: "Log Base", majorInterval: "Major Interval", max: "Max", maxHeight: "Max Height", maxWidth: "Max Width", min: "Min", minorInterval: "Minor Interval", origin: "Origin", overlappingLabels: "Overlapping Labels", plots: "Plots", position: "Position", reversed: "Reversed", scale: "Scale Type", showGridLines: "Show Grid Lines", showMajorGridLines: "Major Grid Lines", showMinorGridLines: "Minor Grid Lines", tickMarks: "Tick Marks", tickSize: "Tick Size", tickStyle: "Tick Style", title: "Title", visible: "Visible", width: "Width" }, dvchartEncoding: { aggregateType: "Aggregate", excludeNulls: "Exclude Nulls", fieldType: "Field Type", fieldValue: "Value", group: "Group", sort: "Sort Direction", sortingAggregate: "Sorting Aggregate", sortingField: "Sort Expression", target: "Target", templateKey: "Template Key", value: "Values" }, dvchartHeaderFooter: { caption: "Caption", height: "Height" }, dvchartLegend: { hidden: "Hidden", iconColor: "Icon Color", maxHeight: "Max Height", maxWidth: "Max Width", orientation: "Orientation", position: "Position", ranges: "Ranges", title: "Title" }, dvchartPlot: { action: "Action Type", axisMode: "Axis Mode", bar: "Bar Lines", category: "Category", categorySort: "Category Sort Direction", categorySortingAggregate: "Category Sorting Aggregate", categorySortingField: "Category Sort Expression", clippingMode: "Clipping Mode", color: "Color", colorAggregate: "Color Aggregate", customLabels: "Gauge Labels", details: "Details", innerRadius: "Inner Radius", lineAspect: "Line Aspect", lineColor: "Line Color", lineStyle: "Line Style", lineWidth: "Line Width", offset: "Offset", opacity: "Opacity", overlays: "Overlays", plotStyle: "Plot Style", pointers: "Gauge Pointers", radial: "Radial", rules: "Rules", shape: "Shape", shapeAggregate: "Shape Aggregate", showNulls: "Show Nulls", showValuesNamesInLegend: "Show Values Names In Legend", size: "Size", sizeAggregate: "Size Aggregate", startAngle: "Start Angle", swapAxes: "Swap Axes", sweep: "Sweep", symbolBackgroundColor: "Background Color", symbolOpacity: "Symbol Opacity", symbolShape: "Symbol Shape", symbolStyle: "Symbol Style", symbols: "Show Symbols", text: "Text", textBackgroundColorStyle: "Background Color", textConnectingLine: "Connecting Line", textLinePosition: "Position", textOffset: "Offset", textOverlappingLabels: "Overlapping Labels", textPosition: "Position", texts: "Text Encodings", textTemplate: "Template", tooltip: "Tooltip", tooltipTemplate: "Tooltip Template", type: "Plot Type", unpivotData: "Unpivot Data", values: "Values", gaugeRanges: "Gauge Ranges" }, dvchartPlotArea: { axes: "Axes" }, dvchartValueEncoding: { field: { close: "Close", high: "High", key: "Key", low: "Low", lower: "Lower", open: "Open", upper: "Upper", value: "Value", caption: "Caption" } }, checkBox: { checkAlignment: "Check Alignment", checked: "Checked", text: "Text" }, container: { consumeWhiteSpace: "Consume White Space", gridMode: "Grid Mode", linkToChild: "Link To Child", pageBreak: "Page Break", newPage: "New Page", overflow: "Overflow", canGrow: "Can Grow" }, contentPlaceHolder: { consumeWhiteSpace: "Consume White Space", text: "Text" }, data: { dataElementName: "Element Name", dataElementOutput: "Element Output", dataElementStyle: "Element Style" }, dataRegion: { dataSetName: "Data Set Name", dataSetParameters: "Data Set Parameters", dataSetParameters_help: { text: "Setting a parameter in the DataSetParameters property allows adding relationships for displaying data in nested data regions that are bound to different datasets." }, filters: "Filters", newSection: "New Section", noRowsMessage: "Message", overflowName: "Overflow Name", pageBreak: "Page Break", newPage: "New Page", repeatToFill: "Repeat To Fill", sortExpressions: "Sort Expressions", throwIfPlaceHoldersEmpty: "Throw If Placeholders Empty" }, dataSet: { accentSensitivity: "Accent Sensitivity", boundFields: "Bound Fields", calculatedFields: "Calculated Fields", caseSensitivity: "Case Sensitivity", collation: "Collation", commandType: "Command Type", fields: "Fields", filters: "Filters", kanatypeSensitivity: "Kanatype Sensitivity", name: "Name", parameters: "Parameters", query: "Query", widthSensitivity: "Width Sensitivity" }, dataSetParameter: { name: "Name", value: "Value" }, bullet: { bestValue: "Best Value", interval: "Interval", labelFontColor: "Font Color", labelFontFamily: "Font Family", labelFontSize: "Font Size", labelFontStyle: "Font Style", labelFormat: "Label Format", orientation: "Orientation", range1Boundary: "Range1 Boundary", range2Boundary: "Range2 Boundary", showLabels: "Show Labels", targetLineColor: "Color", targetLineWidth: "Line Width", targetShape: "Shape", targetValue: "Target Value", tickMarks: "Marks", ticksLineColor: "Color", ticksLineWidth: "Line Width", value: "Value", valueColor: "Value Color", worstValue: "Worst Value" }, barcode: { barHeight: "Bar Height", captionGrouping: "Caption Grouping", captionLocation: "Caption Location", checksum: "Checksum", aztecOptions: { errorCorrection: "Error Correction", layers: "Layers", encoding: "Encoding" }, code49Options: { groupNumber: "Group Number", grouping: "Grouping" }, dataMatrixOptions: { ecc000_140SymbolSize: "Ecc000_140 Symbol Size", ecc200EncodingMode: "Ecc200 Encoding Mode", ecc200SymbolSize: "Ecc200 Symbol Size", encodingMode: "Encoding Mode", symbolSize: "Symbol Size", eccMode: "Ecc Mode", encoding: "Encoding", fileIdentifier: "File Identifier", structureNumber: "Structure Number", structuredAppend: "Structured Append" }, ean128Fnc1Options: { barAdjust: "Bar Adjust", moduleSize: "Module Size", resolution: "Dpi" }, gs1CompositeOptions: { type: "Composite Type", value: "Composite Value" }, gs1QrCodeOptions: { encoding: "Encoding", errorLevel: "Error Level", mask: "Mask", version: "Version" }, invalidBarcodeText: "Invalid Barcode Text", maxiCodeOptions: { mode: "Mode" }, microPdf417Options: { compactionMode: "Compaction Mode", fileId: "File ID", segmentCount: "Segment Count", segmentIndex: "Segment Index", version: "Version" }, microQrCodeOptions: { encoding: "Encoding", errorLevel: "Error Level", mask: "Mask", version: "Version" }, narrowBarWidth: "Narrow Bar Width", nwRatio: "NW Ratio", nwRatio_help: { text: "Also known as the N dimension, this is a value defining the multiple of the ratio between the narrow and wide bars in symbologies that contain bars in only two widths." }, pdf417Options: { columns: "Columns", errorCorrectionLevel: "Error Correction Level", rows: "Rows", type: "PDF417 Type" }, qrCodeOptions: { connection: "Connection", connectionNumber: "Connection Number", encoding: "Encoding", errorLevel: "Error Level", mask: "Mask", model: "Model", version: "Version" }, quietZone: "Quiet Zone", rotation: "Rotation", rssExpandedStacked: { rowCount: "Row Count" }, supplementOptions: { barHeight: "Supplement Bar Height", captionLocation: "Supplement Caption Location", spacing: "Supplement Spacing", value: "Supplement Value" }, symbology: "Type", value: "Value" }, bandedList: { canGrow: "Can Grow", canShrink: "Can Shrink", consumeWhiteSpace: "Consume White Space", preventOrphanedFooter: "Prevent Orphaned Footer", preventOrphanedHeader: "Prevent Orphaned Header", printAtBottom: "Print At Bottom", repeatOnNewPage: "Repeat On New Page" }, action: { applyParameters: "Apply Parameters", jumpToBookmark: "Jump to Bookmark", jumpToReport: "Jump to Report", jumpToUrl: "Jump to URL", parameters: "Parameters", slice: "Slicers" }, image: { backgroundRepeat: "Repeat", horizontalAlignment: "Horizontal Alignment", imageLabel: "Image", mimeType: "MIME Type", sizing: "Image Sizing", source: "Source", value: "Value", verticalAlignment: "Vertical Alignment" }, fplPage: { orientation: "Orientation", size: "Size" }, dashboardSection: { displayName: "Display Name" } }, categories: { action: "Action", appearance: "Appearance", availableValues: "Available Values", background: "Background", backgroundAndBorders: "Background & Borders", bar: "Bar Settings", border: "Border", borderColor: "Border Color", borderRoundingRadius: "Border Rounding Radius", borderStyle: "Border Style", borderWidth: "Border Width", borders: "Borders", column: "Column", common: "Common", configurations: "Configurations", content: "Content", data: "Data", dataLabel: "Data Label", dataLabelText: "Data Label Text", defaultValue: "Default Value", dimensions: "Dimensions", documentMap: "Document Map", dvchartLabelBorder: "Label Border", dvchartLabelLine: "Label Line", dvchartLabelText: "Label Text", dvchartLegend: "Legend", dvchartLegendBackground: "Legend Background", dvchartLegendBorder: "Legend Border", dvchartLegendText: "Legend Text", dvchartLegendTitle: "Legend Title", dvchartPlotConfig: "Config", dvchartPlotEncodings: "Encodings - Common", dvchartPlotColorEncodings: "Encoding - Color", dvchartPlotShapeEncodings: "Encoding - Shape", dvchartPlotSizeEncodings: "Encoding - Size", dvchartPlotStyle: "Style", dvchartPlotSymbols: "Symbols", fields: "Fields", fillStyle: "Fill Style", font: "Font", general: "General", grid: "Grid Lines", group: "Group", input: "Input", international: "International", labelStyle: "Label Style", labels: "Labels", layout: "Layout", line: "Line", majorGrid: "Major Grid", majorTicks: "Major Ticks", margins: "Margins", marker: "Marker", minorGrid: "Minor Grid", minorTicks: "Minor Ticks", misc: "Misc", noData: "No Data", options: "Options", pageSize: "Page Size", preview: "Preview", range: "Range", referenceLine: "Reference Line", scale: "Scale", seriesLineStyle: "Series Line Style", settings: "Settings", staticMembers: "Static Members", symbology: "Symbology", tableFooter: "Footer", tableHeader: "Header", targetDevice: "Target Device", targetStyle: "Target Style", text: "Text", threeDProperties: "3D properties", tickStyle: "Tick Style", title: "Title", userSort: "User Sort", valueStyle: "Value Style", visibility: "Visibility" } }, propertyEditors: { boolean: { textTrue: "True", textFalse: "False", textUndefined: "Undefined" }, colorDropdown: { headingStandard: "Standard Colors", btnPalettes: "Palettes", btnColorPicker: "Other Colors", btnWebColors: "Web Colors", labelHue: "Hue", labelSaturation: "Saturation", labelLightness: "Lightness", labelHex: "Hex", themeColors: { titleBase: "{{colorKey}}", titleDarker25: "{{colorKey}} - 25% darker", titleDarker50: "{{colorKey}} - 50% darker", titleLighter25: "{{colorKey}} - 25% lighter", titleLighter50: "{{colorKey}} - 50% lighter", titleLighter75: "{{colorKey}} - 75% lighter" }, headingTheme: "Theme Colors" }, common: { textMultipleValues: "<Multiple Values>", textEmpty: "<Empty>", titleCollapse: "Collapse", titleExpand: "Expand", textExpression: "<Expression>", textNone: "<None>" }, toggleState: { textExpanded: "Expanded", textCollapsed: "Collapsed" }, collection: { textItemsCount: "{{count}} item", textItemsCount_plural: "{{count}} items", btnAdd: "Add", titleAdd: "Add Item", titleDelete: "Delete", titleShowItems: "Show Items", titleClose: "Close", textEmpty: "Collection is empty" }, picker: { warnings: { groupingByAggregate: "grouping by aggregate attributes is discouraged", groupingIsDiscouraged: "grouping by this attribute is discouraged", masterReportAttributes: "only attributes used in the master report are available for content reports" }, btnReset: "Reset", btnExpression: "Expression...", btnDataVisualizer: "Data Visualizer...", btnPickData: "Pick Data...", headingParameters: "Parameters", titleDataBinding: "Data Binding" }, dataSetQuery: { placeholder: "enter query here..." }, dvchartEncodingCollection: { color: { valuesName: "Show Values Names In Legend" }, value: { prefix: "Value", propertiesTitle: "Value Properties" }, details: { prefix: "Details", propertiesTitle: "Details Properties" }, text: { prefix: "Text", propertiesTitle: "Text Properties" }, aggregate: { prefix: "Aggregate", propertiesTitle: "Aggregate Properties" }, fieldPlaceholder: "<Key>", valuePlaceholder: "<Value>" }, chartComplexEncodingFieldCollectionEditor: { prefix: "Field" }, chartSimpleEncodingFieldCollectionEditor: { keyHeader: "Key", valueHeader: "Value", captionHeader: "Caption" }, dvchartPlotTemplate: { textSelect: "Select..." }, dvchartRuleProperties: { headingTargetProperty: "Target Property", headingValueProperty: "Value" }, dvchartTemplate: { custom: "<Custom>" }, format: { $locale: "en-US", $localeCurrency: "USD", digitsLabel: "Digits", customFormatMask: "(###) ###-####", default: "<Default>", currency: "Currency", decimal: "Decimal", scientific: "Scientific", fixedPoint: "Fixed-point", general: "General", number: "Number", percent: "Percent", hexadecimal: "Hexadecimal", shortDate: "Short date", longDate: "Long date", fullDateShortTime: "Full date/short time", generalDateShortTime: "General date/short time", generalDateLongTime: "General date/long time", shortTime: "Short time", longTime: "Long time", monthDay: "Month day", yearMonth: "Year month", custom: "(Custom)" }, image: { textNoDataFieldsFound: "No data fields found", btnShared: "Shared", btnEmbedded: "Embedded", btnDatabase: "Database", titleRemove: "Remove '{{name}}'...", textLoad: "Load...", textNoImagesFound: "No images found" }, dataSetFieldCollection: { fieldHeader: "Field Name", valueHeader: "Value", fieldPlaceholder: "<Name>", valuePlaceholder: "<Value>", dataFieldHeader: "Data Field", dataFieldPlaceholder: "<Data Field>" }, dataSetParameterCollection: { nameHeader: "Parameter Name", valueHeader: "Value", namePlaceholder: "<Name>", valuePlaceholder: "<Value>" }, subreport: { parameter: "Parameter", parameterNamePlaceholder: "<Name>", parameterValuePlaceholder: "<Value>", parameterNameHeader: "Name", parameterValueHeader: "Value" }, mailMergeFieldsCollection: { nameHeader: "Field Name", valueHeader: "Value", namePlaceholder: "<Name>", valuePlaceholder: "<Value>" }, dvcartLegendRangeOptionsCollection: { titleHeader: "Title", toHeader: "To", titlePlaceholder: "<Title>" }, layerCollection: { propertiesTitle: "Layer properties: {{layerName}}" }, marginsSizes: { custom: "(Custom)" }, pageSize: { custom: "(Custom)" }, palette: { customPaletteLabel: "<Custom>", extraPalettesHeader: "Theme Palettes", standardPalettesHeader: "Standard Palettes" }, reportParameter: { placeholderEmpty: "<Empty>", placeholderValue: "Value", placeholderLabel: "Label", labelSource: "Source", labelFromQuery: "From Query", labelNonQueried: "Non-Queried" }, parameterValuesOrder: { ascending: "Ascending", descending: "Descending" }, parameterCollection: { titleProperties: "Parameter properties" }, reports: { textLoadingError: "Error {{status}}: {{statusText}}", textLoading: "Loading..." }, reportPartPropertiesCollection: { propertiesTitle: "Property: {{reportPartName}}" }, reportPartsCollection: { propertiesTitle: "Report Part: {{reportPartName}}" }, simple: { backgroundColor: { label: "Color", title: "Background Color" }, borders: { borderColor: { label: "Color", title: "Border Color" }, borderStyle: { label: "Style", title: "Border Style" }, borderWidth: { label: "Width", title: "Border Width" }, sides: { all: "All", left: "Left", top: "Top", right: "Right", bottom: "Bottom", reset: "Reset" }, borders: "Borders" }, common: { textExpressionCompact: "<\u{1D453}>" }, font: { fontFamily: { label: "Font", title: "Font Family" }, fontSize: { label: "Size", title: "Font Size" }, fontStyle: { label: "Style", title: "Font Style" }, fontWeight: { label: "Weight", title: "Font Weight" }, textColor: { label: "Color", title: "Text Color" }, textDecoration: { label: "Decoration", title: "Text Decoration" } } }, validationErrors: { expression: { unknownFunction: "Warning: unknown function name '{{token}}' {{positionInfo}}", disabledReportItems: "Warning: It is forbidden to use the 'ReportItems' token type in this expression (in '{{token}}' {{positionInfo}})", disabledFields: "Warning: It is forbidden to use the 'Fields' token type in this expression (in '{{token}}' {{positionInfo}})", parseError: "Syntax error: It is not possible to convert this interpolation syntax expression to rdl syntax", unknownThemeImage: "Warning: unknown theme image name in '{{token}}' {{positionInfo}}", unknownReportItem: "Warning: unknown report item name in '{{token}}' {{positionInfo}}", unknownParameter: "Warning: unknown parameter name in '{{token}}' {{positionInfo}}", unknownField: "Warning: unknown field name in '{{token}}' {{positionInfo}}", syntaxError: "Syntax error: unexpected token '{{token}}' {{positionInfo}}", warning: "Warning: unknown token '{{token}}' {{positionInfo}}", unknown: "Unknown error '{{positionInfo}}'", errorPosition: "at line {{line}}, column {{column}}" } } }, "propertyEditors-RPX": { image: { textChange: "Change...", textPick: "Pick..." }, statusWrapper: { titleModified: "Modified", titleError: "Invalid", titleInherited: "Inherited from Parent Style", titleDefault: "", btnReset: "Reset" }, style: { textEdit: "Edit", drillCaptionStyle: "Style" } }, reportItems: { dvchartHeader: "Header", dvchartPlotArea: "Plot Area", dvchartGlobalLegend: "Global Legend", dvchartFooter: "Footer", dvchartPlot: "Plot", dvchartXAxis: "X Axis", dvchartYAxis: "Y Axis", dvchartColorLegend: "Legend - Color", dvchartShapeLegend: "Legend - Shape", dvchartSizeLegend: "Legend - Size", Page: "Page", Report: "Report", dashboard: "Dashboard", body: "Body", dashboardPageHeader: "Header", pageHeader: "Page Header", dashboardPageFooter: "Footer", pageFooter: "Page Footer", bandedListDetails: "Details", bandedListFooter: "Footer", bandedListGroup: "Group", bandedListHeader: "Header", bandedList: "Banded List", barcode: "Barcode", bullet: "Bullet", dvchartAxis: "Axis", dvchartValueAggregateEncoding: "Value Aggregate Encoding", dvchartAggregateEncoding: "Aggregate Encoding", dvchartDetailsEncoding: "Details Encoding", dvchartTextEncoding: "Text Encoding", dvchartCategoryEncoding: "Category Encoding", dvchartEncodingValue: "Encoding Value", dvchart: "Chart", dvchartLegend: "Legend", dvchartPlotCustomLabel: "Gauge Label", dvchartPlotPointer: "Gauge Pointer", checkbox: "CheckBox", contentplaceholder: "Content Placeholder", contentPlaceholderText: "Set the Text property to tell Content Report authors what to add here", dashboardSection: "Section", unknown: "Unknown Item", report: "Report", page: "Page", formattedText: "Formatted Text", image: "Image", inputField: "Input Field", layer: "Layer", line: "Line", listRow: "Row", listColumn: "Column", listRowsStacked: "Rows 2-{{rowCount}}", listColumnsStacked: "Columns 2-{{columnCount}}", list: "List", continuousSection: "Continuous Section", fixedPageSection: "Fixed Page Section", reportPart: "Report Part", reportPartProperty: "Property", overflowPlaceholder: "Overflow Placeholder", pageSection: "Page Header/Footer", partItem: "PartItem", container: "Container", richtext: "Rich Text", shape: "Shape", sparkline: "Sparkline", subreport: "Subreport", tableColumn: "Column", tableDetails: "Details", tableFooter: "Footer", tableHeader: "Header", table: "Table", tableRow: "Row", tableGroup: "Group", tablix: "Tablix", tablixMember: "Tablix Member", tablixRow: "Row", tablixColumn: "Column", textbox: "TextBox", tableOfContents: "Table Of Contents", tableOfContentsLevel: "Level" }, romLabels: { chart: "Chart", dvchart: "DV.Chart", matrix: "Matrix", table: "Table", tablix: "Tablix" }, tablixWizard: { textNoValues: "There are no values specified.", textAddValue: "Please add at least a single value to create a Tablix.", aggregates: { avg: "Avg", count: "Count", max: "Max", min: "Min", none: "None", sum: "Sum" }, titleAggregate: "Aggregate", displayAsOptions: { default: "Default", percentColumnGroupTotal: "% Column Group Total", percentGrandTotal: "% Grand Total", percentParentColumnGroupTotal: "% Parent Column Group Total", percentParentRowGroupTotal: "% Parent Row Group Total", percentRowGroupTotal: "% Row Group Total" }, titleDisplayAs: "Display As", placeholderNoField: "no field", titleDelete: "Delete", textNoDataSets: "Report has no data sets.", textAddDataSet: "Please add a data set to your report at first.", formats: { currency: "Currency", decimal: "Decimal", default: "Default", general: "General", number: "Number", percent: "Percent" }, titleFormat: "Format", sortings: { Ascending: "Ascending", Descending: "Descending", None: "None" }, titleSorting: "Sorting: {{sorting}}", filters: { titleEditGroupFilters: "Edit Group Filters...", textFilters: "Filters", titleEditTablixFilters: "Edit Tablix Filters...", headingTablixFilters: "Tablix Filters", headingGroupFilters: "Group Filters \u2013 {{groupLabel}}" }, textSwap: "Swap", titleSwapRowColumnGroups: "Swap Row/Column Groups", textAsRows: "As Rows", textShowValuesAsRows: "Show Values as Rows", textLayoutOptions: "Layout Options", textRowGroups: "Row Groups", textColumns: "Column Groups", textValues: "Values", btnTotals: "Totals", btnStyling: "Styling", btnOrganization: "Organization", labelExpandCollapse: "Expand/Collapse Groups", labelCollapsedGroups: "Collapsed Groups", labelUserSortEnabled: "Enable User Sort", labelSteppedRowGroups: "Stepped Row Groups", labelFrozenRows: "Frozen Rows", labelFrozenColumns: "Frozen Columns", labelNone: "None", labelTotalsForRows: "Totals for Row Groups", labelSubTotalsForRows: "Subtotals for Row Groups", labelTotalsForColumns: "Totals for Column Groups", labelSubTotalsForColumns: "Subtotals for Column Groups", labelShowTotalsBeforeGroup: "Show Totals before Groups", warning: { btnRevert: "Revert", btnQuit: "Quit", headingWarning: "Warning", textChangedStructure: "Tablix Wizard cannot edit the Tablix as its structure has been changed.", textConfirmReverting: "Please confirm reverting to the previous Tablix state editable by Wizard.", textOtherwiseCannotEdit: "Otherwise, it will not be possible to continue editing within Tablix Wizard." }, headingTablixWizard: "Tablix Wizard", headingLayoutDesign: "Layout Design", headingDataSets: "Data Sets", makeTablix: { textValues: "Values", textTotal: "Total" }, textOpenWizard: "Open Tablix Wizard...", textCannotEditInWizard: "Tablix has complex structure and cannot be edited in Wizard. Please use Group Editor instead." }, validationErrors: { unknown: { unknown: "Unknown type '{{type}}'" }, enum: { incorrect: "Enum value of type '{{enumType}}' should be one of the following: {{enumValues}}" }, length: { negative: "Value should be greater than zero", tooLarge: "Value should be lower than {{max}}", tooSmall: "Value should be greater than {{min}}", unit: "Valid units are 'cm', 'mm', 'in', 'pt', and 'pc'" }, mime_type: { incorrect: "Image MIME Type is expected to match {{wildcard}}" }, number: { nan: "Value is not a number", tooLarge: "Value should be lower than {{max}}", tooSmall: "Value should be greater than {{min}}", empty: "Value is empty", outOfInterval: "Value is out of interval", outOfRange: "Value is too big or too small" }, pattern: "Invalid expression. Literal expressions for this property must be of type '{{type}}'. {{info}}", errorPosition: "at line {{line}}, column {{column}}", expression: { unknownFunction: "Warning: unknown function name '{{token}}' {{positionInfo}}", disabledReportItems: "Warning: It is forbidden to use the 'ReportItems' token type in this expression (in '{{token}}' {{positionInfo}})", disabledFields: "Warning: It is forbidden to use the 'Fields' token type in this expression (in '{{token}}' {{positionInfo}})", parseError: "Syntax error: It is not possible to convert this interpolation syntax expression to rdl syntax", unknownThemeImage: "Warning: unknown theme image name in '{{token}}' {{positionInfo}}", unknownReportItem: "Warning: unknown report item name in '{{token}}' {{positionInfo}}", unknownParameter: "Warning: unknown parameter name in '{{token}}' {{positionInfo}}", unknownField: "Warning: unknown field name in '{{token}}' {{positionInfo}}", syntaxError: "Syntax error: unexpected token '{{token}}' {{positionInfo}}", warning: "Warning: unknown token '{{token}}' {{positionInfo}}", unknown: "Unknown error '{{positionInfo}}'", errorPosition: "at line {{line}}, column {{column}}" } }, warning: { embeddedImage: { badImageFile: "Selected image file '{{name}}' is invalid.", badFileType: "Selected file '{{name}}' ({{type}}) is not supported.", badFile: "Selected file '{{name}}' is not an image.", badImageSize: "Selected image file '{{name}}' exceeds limit of {{limit}} MB." }, pageSize: { caption: "The specified page size cannot be set", info: "- '{{name}}' cannot be less than {{value}}.", labels: { height: "Page Height", width: "Page Width" } }, margins: { caption: "The specified margins cannot be set", labels: { top: "Top Margin", right: "Right Margin", bottom: "Bottom Margin", left: "Left Margin" }, info: "- '{{name}}' cannot be greater than {{value}}." } } } };
let mG;
const hG = () => {
  if (!mG) throw new Error("i18n instance was requested before initialization!");
  return { t: mG.getFixedT(null, []) };
};
const fG = (e14, t10, n10) => t10(`notifications:${e14}.caption`, n10);
const gG = (e14, t10, n10) => t10(`notifications:${e14}.text`, n10);
const yG = { bandedList: "BandedList", bandedListGroup: "Group", barcode: "Barcode", bullet: "Bullet", calculatedField: "CalculatedField", categoryGroup: "CategoryGroup", chart: "Chart", checkbox: "CheckBox", columnGroup: "ColumnGroup", container: "Container", Continuous: "ContinuousSection", dataset: "DataSet", detailsGroup: "DetailsGroup", dvchart: "Chart", dvchartEncodingField: "Field", dvchartPlot: "Plot", field: "Field", fixedPage: "FixedPage", formattedText: "FormattedText", group: "Group", image: "Image", inputField: "InputField", layer: "Layer", line: "Line", list: "List", mailMergeField: "Field", overflowPlaceholder: "OverflowPlaceholder", parameter: "Parameter", parameterCollection: "Parameter", reportParameter: "Parameter", reportSlicer: "Slicer", richtext: "RichText", rowGroup: "RowGroup", seriesGroup: "SeriesGroup", seriesValue: "Value", shape: "Shape", sparkline: "Sparkline", subreport: "Subreport", table: "Table", tableDetailsGroup: "DetailsGroup", tableGroup: "TableGroup", tableOfContents: "TableOfContents", tablix: "Tablix", textbox: "TextBox", tocLevel: "Level", contentplaceholder: "ContentPlaceHolder" };
const vG = { formattedtext: "formattedtext", richtext: "richtext", bullet: "bullet", barcode: "barcode", fixedpagedvchart: "fixedpagedvchart", dvchart: "dvchart", dvchartplot: "dvchartPlot", dvchartoverlay: "dvchartoverlay", dvchartrule: "dvchartrule", dvcharttextencoding: "dvcharttextencoding", checkbox: "checkbox", image: "image", layer: "layer", line: "line", list: "list", fixedpagelist: "fixedpagelist", shape: "shape", sparkline: "sparkline", table: "table", fixedpagetable: "fixedpagetable", toclevel: "tocLevel", fixedpagetableofcontents: "fixedpagetableofcontents", tableofcontents: "tableofcontents", tablegroup: "tableGroup", tabledetailsGroup: "tableDetailsGroup", tablix: "tablix", fixedpagetablix: "fixedpagetablix", rowgroup: "rowGroup", columngroup: "columnGroup", textbox: "textbox", subreport: "subreport", fixedpagesubreport: "fixedpagesubreport", bandedlist: "bandedlist", fixedpagebandedlist: "fixedpagebandedlist", bandedlistheader: "bandedlistheader", bandedlistdetails: "bandedlistdetails", bandedlistfooter: "bandedlistfooter", inputfield: "inputfield", partitem: "partitem", contentplaceholder: "contentplaceholder", fixedpagepartitem: "fixedpagepartitem" };
const bG = "{";
const SG = "#";
const CG = "}";
const xG = /^\{[^\{\}]+\#[^\{\}]+\}$/g;
const wG = (e14) => {
  if (void 0 !== mG) {
    const { t: t10 } = hG();
    return t10(`nameTemplates:${e14}`);
  }
  return yG[e14] || "Item";
};
function TG(e14) {
  switch (e14) {
    case "dataset":
      return wG("dataset");
    case "group":
      return wG("group");
    case "detailsGroup":
      return wG("detailsGroup");
    case "formattedtext":
      return wG("formattedText");
    case "richtext":
      return wG("richtext");
    case "bullet":
      return wG("bullet");
    case "barcode":
      return wG("barcode");
    case "fixedpagedvchart":
    case "dvchart":
      return wG("chart");
    case "dvchartPlot":
      return wG("dvchartPlot");
    case "dvchartoverlay":
      return wG("dvchartoverlay");
    case "dvchartrule":
      return wG("dvchartrule");
    case "dvcharttextencoding":
      return wG("dvcharttextencoding");
    case "checkbox":
      return wG("checkbox");
    case "image":
      return wG("image");
    case "layer":
      return wG("layer");
    case "line":
      return wG("line");
    case "list":
    case "fixedpagelist":
      return wG("list");
    case "overflowplaceholder":
      return wG("overflowPlaceholder");
    case "fixedpagerectangle":
    case "rectangle":
      return wG("container");
    case "shape":
      return wG("shape");
    case "sparkline":
      return wG("sparkline");
    case "table":
    case "fixedpagetable":
      return wG("table");
    case "tocLevel":
      return wG("tocLevel");
    case "fixedpagetableofcontents":
    case "tableofcontents":
      return wG("tableOfContents");
    case "tableGroup":
      return wG("tableGroup");
    case "tableDetailsGroup":
      return wG("tableDetailsGroup");
    case "tablix":
    case "fixedpagetablix":
      return wG("tablix");
    case "rowGroup":
      return wG("rowGroup");
    case "columnGroup":
      return wG("columnGroup");
    case "textbox":
      return wG("textbox");
    case "subreport":
    case "fixedpagesubreport":
      return wG("subreport");
    case "bandedlist":
    case "fixedpagebandedlist":
      return wG("bandedList");
    case "bandedlistheader":
      return "$BandedListHeader";
    case "bandedlistdetails":
      return "$BandedListDetails";
    case "bandedlistfooter":
      return "$BandedListFooter";
    case "inputfield":
      return wG("inputField");
    case "contentplaceholder":
      return wG("contentplaceholder");
    case "parameter":
      return wG("parameter");
    case "parameterCollection":
      return wG("parameterCollection");
    case "reportParameter":
      return wG("reportParameter");
    case "reportSlicer":
      return wG("reportSlicer");
    case "reportPart":
      return wG("reportPart");
    case "reportPartProperty":
      return wG("reportPartProperty");
    case "Continuous":
      return wG("Continuous");
    case "Body":
      return wG("Body");
    case "dashboardsection":
      return wG("dashboardSection");
  }
  return wG("Unknown");
}
const EG = (e14) => {
  const t10 = wG("group");
  return e14 ? MG(e14, t10) : t10;
};
function FG(e14) {
  const t10 = e14 && e14.length > 0 ? e14 : "Item";
  const n10 = GB();
  return `${bG}${t10}${SG}${n10}${CG}`;
}
function MG(e14, t10) {
  if (!e14 || 0 === e14.length) throw new Error("Invalid argument: namePrefix");
  return FG(`${e14}_${t10 || ""}`);
}
const kG = (e14, t10, n10 = false) => {
  const r10 = (e15) => !!t10.find((t11) => t11 === e15);
  const o10 = (e15, t11) => `${e15}${t11}`;
  let a10 = n10 ? 0 : 1;
  let i10 = o10(e14, a10);
  for (; r10(i10); ) a10++, i10 = o10(e14, a10);
  return i10;
};
const PG = (e14, t10) => e14 && !(t10 || []).includes(e14) || false;
const NG = (e14) => e14 && Jc("^\\pL[\\pL_\\d]*$").test(e14) || false;
const DG = (e14, t10, n10) => {
  const r10 = e14 && Array.from(e14).reduce((e15, t11) => e15 ? ((e16) => e16 && Jc("^(\\pL|\\d|_)$").test(e16) || false)(t11) ? `${e15}${t11}` : e15 : ((e16) => e16 && Jc("^\\pL$").test(e16) || false)(t11) ? t11 : "", "") || "";
  const o10 = NG(r10) ? r10 : n10 || "Item";
  return (t10 || []).includes(o10) ? kG(o10, t10) : o10;
};
function LG(e14, t10, n10) {
  let r10 = e14;
  for (const e15 in r10) {
    if (!r10.hasOwnProperty(e15)) continue;
    const o10 = r10[e15];
    if (zV.isObject(o10)) {
      const a10 = LG(o10, t10, n10);
      if (a10 !== o10) {
        r10 = AV(r10, { [e15]: { $set: a10 } });
      }
    } else if (t10.includes(e15)) {
      const t11 = n10(r10, e15, o10);
      t11 && (r10 = AV(r10, t11));
    }
  }
  return r10;
}
const HG = (e14) => {
  const t10 = e14 == null ? void 0 : e14.Type;
  switch (t10) {
    case "multisectionreport":
      return e14 && zV.keys(e14).filter((e15) => "ReportParts" !== e15);
    case "Continuous":
      return ["Body", "PageHeader", "PageFooter"];
    case "section":
    case "contentplaceholder":
    case "pagesection":
    case "fixedpagesection":
    case "bandedlistfooter":
    case "bandedlistheader":
    case "bandedlistdetails":
      return ["ReportItems"];
    case "rectangle":
    case "fixedpagerectangle":
      return ["ReportItems", "Grid"];
    case "list":
    case "fixedpagelist":
      return ["ReportItems", "Group"];
    case "table":
    case "fixedpagetable":
      return ["Header", "Details", "Footer", "TableGroups"];
    case "tableheader":
    case "tablefooter":
      return ["TableRows"];
    case "tabledetails":
      return ["TableRows", "Group"];
    case "tablegroup":
    case "bandedlistgroup":
      return ["Header", "Footer", "Group"];
    case "tablix":
    case "fixedpagetablix":
      return ["Corner", "ColumnHierarchy", "RowHierarchy", "Body"];
    case "statictablixmember":
      return ["Header", "Children"];
    case "dynamictablixmember":
      return ["Header", "Children", "Group"];
    case "sparkline":
      return ["Group"];
    case "bandedlist":
    case "fixedpagebandedlist":
      return ["Header", "Footer", "Details", "Groups"];
    case "barcode":
    case "bullet":
    case "checkbox":
    case "dvchart":
    case "fixedpagedvchart":
    case "formattedtext":
    case "image":
    case "line":
    case "richtext":
    case "shape":
    case "subreport":
    case "fixedpagesubreport":
    case "tableofcontents":
    case "fixedpagetableofcontents":
    case "textbox":
    case "partitem":
    case "fixedpagepartitem":
    case "reportpart":
      return [];
  }
  return e14 && zV.keys(e14) || [];
};
function IG(e14, t10) {
  (e14 == null ? void 0 : e14.Name) && t10(e14);
  HG(e14).forEach((n10) => {
    if (!n10 || n10.startsWith("$")) return;
    const r10 = e14[n10];
    zV.isObject(r10) && IG(r10, t10);
  });
}
const _G = (e14) => AW(e14) || GW(e14) || ((e15) => nj(e15) || "bandedlistgroup" === e15)(e14) || /* @__PURE__ */ ((e15) => "reportpart" === e15)(e14);
const VG = (e14) => (e14 == null ? void 0 : e14.Name) && !!(e14 == null ? void 0 : e14.GroupExpressions) || false;
function RG(e14, t10) {
  const n10 = t10.indexOf(SG);
  if (n10 < 0) throw new Error(`Invalid temporary name structure: ${t10}`);
  const r10 = t10.substring(bG.length, n10);
  const o10 = vG[r10.toLowerCase()];
  const a10 = o10 ? TG(o10) : r10;
  return kG(a10, e14);
}
function AG(e14) {
  const t10 = e14.match(xG);
  return 1 === (t10 == null ? void 0 : t10.length) && t10[0] === e14;
}
function OG(e14) {
  const t10 = [];
  const n10 = [];
  const r10 = [];
  const o10 = [];
  const a10 = /* @__PURE__ */ new Map();
  IG(e14, (e15) => {
    const a11 = e15 && _G(e15.Type) || false;
    const i11 = VG(e15);
    if (!a11 && !i11) return;
    const s11 = e15.Name;
    if (s11.startsWith(bG)) {
      if (r10.includes(s11) || o10.includes(s11)) throw new Error(`Temporary name is not unique: ${s11}`);
      (i11 ? o10 : r10).push(s11);
    } else if (!["multisectionreport", "fixedpagereport", "dashboard"].includes(e15.Type)) {
      const e16 = i11 ? n10 : t10;
      if (e16.includes(s11)) throw new Error(`Duplicate name: ${s11}`);
      e16.push(s11);
    }
  }), IG(e14.$masterReportContent, (e15) => {
    if (["multisectionreport", "section", "Continuous", "contentplaceholder", "pagesection"].includes(e15.Type)) return;
    const a11 = e15 && _G(e15.Type) || false;
    const i11 = VG(e15);
    if (!a11 && !i11) return;
    const s11 = e15.Name;
    if (s11.startsWith(bG)) {
      if (r10.includes(s11) || o10.includes(s11)) throw new Error(`Temporary name is not unique: ${s11}`);
      (i11 ? o10 : r10).push(s11);
    } else {
      const e16 = i11 ? n10 : t10;
      if (e16.includes(s11)) throw new Error(`Duplicate name: ${s11}`);
      e16.push(s11);
    }
  });
  const i10 = (e15, t11) => e15.map((e16) => ({ temporary: e16, prepared: e16, isGroupName: t11 }));
  const s10 = i10(r10, false).concat(i10(o10, true));
  for (; s10.length > 0; ) {
    const e15 = zV.remove(s10, (e16) => AG(e16.prepared));
    if (0 === e15.length) throw new Error("Invalid temporary names hierarchy");
    e15.forEach((e16) => {
      const r11 = e16.isGroupName ? n10 : t10;
      const o11 = RG(r11, e16.prepared);
      a10.set(e16.temporary, o11), r11.push(o11), s10.forEach((t11) => {
        t11.prepared.includes(e16.prepared) && Object.assign(t11, { prepared: t11.prepared.replace(e16.prepared, o11) });
      });
    });
  }
  return LG(e14, ["Name", "OverflowName", "ReportItemName"], (e15, t11, n11) => a10.has(n11) ? { [t11]: { $set: a10.get(n11) } } : null);
}
function BG(e14) {
  const t10 = [];
  return LG(e14, ["Type"], (e15) => {
    const n10 = ((e16) => e16 && qW(e16.Type) ? "Group" : null)(e15);
    if (!n10) return null;
    const r10 = ((e16, t11) => {
      if (!e16 || !t11) return null;
      const n11 = Rj(e16, t11);
      return (n11 == null ? void 0 : n11.Name) || "";
    })(e15, n10);
    if (!r10) return null;
    if (!t10.includes(r10)) return t10.push(r10), null;
    const o10 = kG(r10, t10);
    return t10.push(o10), n10.split(".").reduceRight((e16, t11) => ({ [t11]: e16 }), { Name: { $set: o10 } });
  });
}
function zG(e14, t10, n10) {
  const r10 = (t10 || []).map((e15) => e15.fieldName).filter(Boolean);
  function o10(e15) {
    return "object" == typeof e15 ? Array.isArray(e15) ? e15.map(o10) : function(e16) {
      if (!e16) return e16;
      const a10 = {};
      return Object.entries(e16).forEach(([n11, i10]) => {
        if ("Name" === n11 && "string" == typeof i10) {
          const n12 = !t10 || t10.find((e17) => e17.name === i10);
          const r11 = VG(e16);
          if (n12 && (e16.Type || r11)) {
            const t11 = FG(r11 ? EG() : TG(e16.Type));
            return void (a10.Name = t11);
          }
        }
        if ("FieldName" === n11 && "string" == typeof i10 && "" !== i10 && (!t10 || i10 && r10.includes(i10))) {
          const e17 = kG(i10, r10);
          return r10.push(e17), void (a10[n11] = e17);
        }
        a10[n11] = o10(i10);
      }), "function" == typeof n10 ? n10(a10) : a10;
    }(e15) : e15;
  }
  return o10(e14);
}
const $G = "@rdlx/report/item/reloc";
const WG = "@rdlx/report/addItem";
const jG = "@rdlx/report/addItems";
const ZG = "RDLX/REMOVE_ITEM";
const GG = "RDLX/REPLACE_REPORT_ITEM";
const UG = "@rdlx/container/paste";
const qG = { M: "m", C: "c", S: "s", N: "n", W: "w", E: "e", NW: "nw", NC: "nc", NE: "ne", MW: "mw", MC: "mc", ME: "me", SW: "sw", SC: "sc", SE: "se" };
const YG = _V("@rdlx/report/item/reloc", ({ grip: e14, delta: t10, snaps: n10 = {}, isItemInFixedArea: r10 }) => ({ grip: e14, delta: t10, snaps: n10, isItemInFixedArea: r10 }), (e14) => e14);
const KG = _V("@rdlx/report/addItems", ({ items: e14 }) => ({ items: e14 }), (e14) => e14);
const XG = _V("@rdlx/report/addItem", ({ Type: e14, Name: t10, Style: n10, TemplateId: r10, Extra: o10 }) => ({ Type: e14, Name: t10, Style: n10, TemplateId: r10, Extra: o10 }), (e14) => e14);
const JG = _V(ZG, (e14) => e14);
function QG(e14) {
  return { type: GG, payload: { item: e14 } };
}
const eU = _V("@rdlx/container/paste", ({ items: e14, pasteId: t10, contextAction: n10 }) => ({ items: e14, pasteId: t10, contextAction: n10 != null ? n10 : false }), (e14) => e14);
const tU = _V("@rdlx/container/addFilledTable", (e14) => e14, (e14) => e14);
const nU = _V("@rdlx/layout/bringToFront", (e14) => e14);
const rU = _V("@rdlx/layout/sendToBack", (e14) => e14);
const oU = _V("@rdlx/layout/horizontalSpacing", (e14) => e14);
const aU = _V("@rdlx/layout/verticalSpacing", (e14) => e14);
const iU = _V("@rdlx/layout/align", (e14) => e14);
const sU = _V("@rdlx/layout/alignToGrid", (e14) => e14);
function lU(e14, t10, n10) {
  const r10 = L$.parse(t10);
  const o10 = L$.parse(n10);
  return AV(e14, { StartPoint: { X: { $apply: (e15) => L$.parse(e15).add(r10).css }, Y: { $apply: (e15) => L$.parse(e15).add(o10).css } }, EndPoint: { X: { $apply: (e15) => L$.parse(e15).add(r10).css }, Y: { $apply: (e15) => L$.parse(e15).add(o10).css } } });
}
function cU(e14) {
  const t10 = (e15, t11) => e15.lowerThanOrEqual(t11) ? e15 : t11;
  return { Top: t10(L$.parse(e14.StartPoint.Y), L$.parse(e14.EndPoint.Y)), Left: t10(L$.parse(e14.StartPoint.X), L$.parse(e14.EndPoint.X)) };
}
const uU = (e14) => {
  const t10 = dU(e14);
  return AV(e14, { $place: { Top: { $set: t10.Top }, Left: { $set: t10.Left }, Height: { $set: t10.Height }, Width: { $set: t10.Width } } });
};
const dU = (e14) => {
  const { startPoint: t10, endPoint: n10 } = function(e15) {
    return { startPoint: { x: L$.parse(e15.StartPoint.X), y: L$.parse(e15.StartPoint.Y) }, endPoint: { x: L$.parse(e15.EndPoint.X), y: L$.parse(e15.EndPoint.Y) } };
  }(e14);
  const r10 = (e15, t11) => e15.lowerThanOrEqual(t11) ? e15 : t11;
  return { Top: r10(t10.y, n10.y).css, Left: r10(t10.x, n10.x).css, Height: t10.y.subtract(n10.y).abs().css, Width: t10.x.subtract(n10.x).abs().css };
};
const { alt: pU, boolean: mU, Default: hU, DefaultOf: fU, initValue: gU, intersectWith: yU, justRead: vU, lazy: bU, literalInit: SU, map: CU, optional: xU, orElse: wU, pipe: TU, required: EU, string: FU, Temp: MU, type: kU, withDefaultOf: PU } = HZ;
const { changeType: NU } = Z.BasicModel.Decoders;
const DU = (e14) => ({ decode: e14.decode, encode: e14.encode });
const LU = TU(kU({ Left: fU("0in", Z.BasicModel.Length), Top: fU("0in", Z.BasicModel.Length), Width: gU("0in", Z.BasicModel.Length), Height: gU("0in", Z.BasicModel.Length) }), CU(({ Left: e14, Top: t10, Width: n10, Height: r10 }) => ({ $place: { Left: e14, Top: t10, Width: n10, Height: r10 } }), ({ $place: { Left: e14, Top: t10, Width: n10, Height: r10 } }) => ({ Left: e14, Top: t10, Width: n10, Height: r10 })));
const HU = {};
const IU = (e14) => ({ decode: e14.decode, encode: (_a2) => {
  var _b2 = _a2, { $selected: t10, $primary: n10 } = _b2, r10 = __objRest(_b2, ["$selected", "$primary"]);
  return e14.encode(r10);
} });
const _U = Z.Lenses.make(Yu, Nu);
const VU = () => Z.Lenses.make((e14) => {
  var _a2, _b2, _c2, _d2;
  const t10 = (_b2 = (_a2 = e14.CustomProperties.find((e15) => "ReportStyleId" === e15.Name)) == null ? void 0 : _a2.Value) == null ? void 0 : _b2.toString();
  const n10 = (_d2 = (_c2 = e14.CustomProperties.find((e15) => "ReportStyleName" === e15.Name)) == null ? void 0 : _c2.Value) == null ? void 0 : _d2.toString();
  return __spreadProps(__spreadValues({}, e14), { ReportStyle: { StyleId: t10 || "", StyleName: t10 && n10 || "" } });
}, (_a2) => {
  var _b2 = _a2, { ReportStyle: e14 } = _b2, t10 = __objRest(_b2, ["ReportStyle"]);
  var _a3;
  const n10 = (e14 == null ? void 0 : e14.StyleId) || void 0;
  const r10 = n10 ? e14 == null ? void 0 : e14.StyleName : void 0;
  const o10 = ((_a3 = t10.CustomProperties) == null ? void 0 : _a3.slice()) || [];
  return td(o10, "ReportStyleId", n10), td(o10, "ReportStyleName", r10), __spreadProps(__spreadValues({}, t10), { CustomProperties: o10 });
});
const RU = () => Z.Lenses.make((e14) => e14.BookmarkLink ? { BookmarkLink: e14.BookmarkLink, ActionType: "BookmarkLink" } : e14.Drillthrough.ReportName ? { Drillthrough: e14.Drillthrough, ActionType: "Drillthrough" } : e14.Hyperlink ? { Hyperlink: e14.Hyperlink, ActionType: "Hyperlink" } : e14.ApplyParameters.Parameters.length > 0 ? { ApplyParameters: e14.ApplyParameters, ActionType: "ApplyParameters" } : { ActionType: "None" }, (e14) => {
  const _a2 = e14, { ActionType: t10 } = _a2, n10 = __objRest(_a2, ["ActionType"]);
  return __spreadValues({ BookmarkLink: "", Drillthrough: { Parameters: [], ReportName: "" }, Hyperlink: "", Slice: { Slicers: [] }, ApplyParameters: { Parameters: [] } }, n10);
});
const AU = () => Z.Lenses.make((e14) => __spreadProps(__spreadValues({}, e14), { Language: e14.Language || "Default", NumeralLanguage: e14.NumeralLanguage || "Default" }), (e14) => __spreadProps(__spreadValues({}, e14), { Language: "Default" === e14.Language ? "" : e14.Language, NumeralLanguage: "Default" === e14.NumeralLanguage ? "" : e14.NumeralLanguage }));
const OU = TU(Z.BasicModel.TextBox, yU(LU), Z.Lenses.mapOfLens(VU()), Z.Lenses.mapOfLens(Z.Lenses.prop("Action", RU())), Z.Lenses.mapOfLens(Z.Lenses.prop("Style", AU())));
const BU = TU(Z.BasicModel.CheckBox, Z.Lenses.mapOfLens(VU()), yU(LU), Z.Lenses.mapOfLens(Z.Lenses.prop("Action", RU())));
kU(Z.BasicModel.ReportItemProperties);
const [zU, $U] = bU();
const [WU, jU] = bU();
TU(Z.BasicModel.Group, Z.Lenses.mapOfLens(Z.Lenses.prop("Filters", _U)), PU({}));
const ZU = (e14) => TU(Z.BasicModel.List(e14), Z.Lenses.mapOfLens(Z.Lenses.prop("Filters", _U)), Z.Lenses.mapOfLens(Z.Lenses.prop("Group", Z.Lenses.prop("Filters", _U))), Z.Lenses.mapOfLens(VU()), Z.Lenses.mapOfLens(Z.Lenses.prop("Style", AU())), Z.Lenses.mapOfLens(Z.Lenses.prop("Action", RU())), yU(LU), DU);
const GU = { $width: "", $height: "" };
const UU = TU(zU, rd(GU));
const qU = TU(WU, rd(GU));
const YU = (e14) => TU(Z.BasicModel.Table(e14), Z.Lenses.mapOfLens(Z.Lenses.combine3(Z.Lenses.prop("Header", Z.Lenses.nullable(Z.Lenses.combine(Z.Lenses.prop("TableRows", Z.Lenses.array(Z.Lenses.combine3({ f: (e15) => e15, frev: (_a2) => {
  var _b2 = _a2, { $selected: e15, $primary: t10 } = _b2, n10 = __objRest(_b2, ["$selected", "$primary"]);
  return n10;
} }, Z.Lenses.prop("Action", RU()), Z.Lenses.prop("TableCells", Z.Lenses.array(Z.Lenses.nullable({ f: (e15) => e15, frev: (_c2) => {
  var _d2 = _c2, { $selected: e15, $primary: t10 } = _d2, n10 = __objRest(_d2, ["$selected", "$primary"]);
  return n10;
} })))))), { f: (e15) => e15, frev: (_e2) => {
  var _f2 = _e2, { $selected: e15, $primary: t10 } = _f2, n10 = __objRest(_f2, ["$selected", "$primary"]);
  return n10;
} }))), Z.Lenses.prop("Footer", Z.Lenses.nullable(Z.Lenses.combine(Z.Lenses.prop("TableRows", Z.Lenses.array(Z.Lenses.combine3({ f: (e15) => e15, frev: (_g2) => {
  var _h2 = _g2, { $selected: e15, $primary: t10 } = _h2, n10 = __objRest(_h2, ["$selected", "$primary"]);
  return n10;
} }, Z.Lenses.prop("Action", RU()), Z.Lenses.prop("TableCells", Z.Lenses.array(Z.Lenses.nullable({ f: (e15) => e15, frev: (_i2) => {
  var _j2 = _i2, { $selected: e15, $primary: t10 } = _j2, n10 = __objRest(_j2, ["$selected", "$primary"]);
  return n10;
} })))))), { f: (e15) => e15, frev: (_k2) => {
  var _l2 = _k2, { $selected: e15, $primary: t10 } = _l2, n10 = __objRest(_l2, ["$selected", "$primary"]);
  return n10;
} }))), Z.Lenses.prop("TableColumns", Z.Lenses.array({ f: (e15) => e15, frev: (_m2) => {
  var _n2 = _m2, { $selected: e15, $primary: t10 } = _n2, n10 = __objRest(_n2, ["$selected", "$primary"]);
  return n10;
} })))), Z.Lenses.mapOfLens(Z.Lenses.prop("Filters", _U)), Z.Lenses.mapOfLens(Z.Lenses.prop("Details", Z.Lenses.combine3(Z.Lenses.nullable(Z.Lenses.prop("Group", Z.Lenses.prop("Filters", _U))), Z.Lenses.nullable(Z.Lenses.prop("TableRows", Z.Lenses.array(Z.Lenses.combine3({ f: (e15) => e15, frev: (_o3) => {
  var _p3 = _o3, { $selected: e15, $primary: t10 } = _p3, n10 = __objRest(_p3, ["$selected", "$primary"]);
  return n10;
} }, Z.Lenses.prop("Action", RU()), Z.Lenses.prop("TableCells", Z.Lenses.array(Z.Lenses.nullable({ f: (e15) => e15, frev: (_q2) => {
  var _r2 = _q2, { $selected: e15, $primary: t10 } = _r2, n10 = __objRest(_r2, ["$selected", "$primary"]);
  return n10;
} }))))))), Z.Lenses.nullable({ f: (e15) => e15, frev: (_s2) => {
  var _t2 = _s2, { $selected: e15, $primary: t10 } = _t2, n10 = __objRest(_t2, ["$selected", "$primary"]);
  return n10;
} })))), Z.Lenses.mapOfLens(Z.Lenses.prop("TableGroups", Z.Lenses.array(Z.Lenses.combine4({ f: (e15) => e15, frev: (_u2) => {
  var _v2 = _u2, { $selected: e15, $primary: t10 } = _v2, n10 = __objRest(_v2, ["$selected", "$primary"]);
  return n10;
} }, Z.Lenses.prop("Group", Z.Lenses.prop("Filters", _U)), Z.Lenses.prop("Header", Z.Lenses.nullable(Z.Lenses.combine(Z.Lenses.prop("TableRows", Z.Lenses.array(Z.Lenses.combine({ f: (e15) => e15, frev: (_w2) => {
  var _x2 = _w2, { $selected: e15, $primary: t10 } = _x2, n10 = __objRest(_x2, ["$selected", "$primary"]);
  return n10;
} }, Z.Lenses.prop("Action", RU())))), { f: (e15) => e15, frev: (_y2) => {
  var _z2 = _y2, { $selected: e15, $primary: t10 } = _z2, n10 = __objRest(_z2, ["$selected", "$primary"]);
  return n10;
} }))), Z.Lenses.prop("Footer", Z.Lenses.nullable(Z.Lenses.combine(Z.Lenses.prop("TableRows", Z.Lenses.array(Z.Lenses.combine({ f: (e15) => e15, frev: (_A2) => {
  var _B2 = _A2, { $selected: e15, $primary: t10 } = _B2, n10 = __objRest(_B2, ["$selected", "$primary"]);
  return n10;
} }, Z.Lenses.prop("Action", RU())))), { f: (e15) => e15, frev: (_C2) => {
  var _D2 = _C2, { $selected: e15, $primary: t10 } = _D2, n10 = __objRest(_D2, ["$selected", "$primary"]);
  return n10;
} }))))))), Z.Lenses.mapOfLens(VU()), Z.Lenses.mapOfLens(Z.Lenses.prop("Style", AU())), yU(LU), rd(GU));
Z.BasicModel.Tablix(UU);
const KU = Z.BasicModel.recChildrenLens(Z.Lenses.make((_t2) => {
  var _u2 = _t2, { Group: e14, KeepWithGroup: t10, RepeatOnNewPage: n10, SortExpressions: r10 } = _u2, o10 = __objRest(_u2, ["Group", "KeepWithGroup", "RepeatOnNewPage", "SortExpressions"]);
  return null === e14 ? __spreadProps(__spreadValues({ Type: "statictablixmember" }, o10), { Group: null, KeepWithGroup: t10, RepeatOnNewPage: n10 }) : __spreadProps(__spreadValues({ Type: "dynamictablixmember" }, o10), { Group: __spreadProps(__spreadValues({}, e14), { Filters: _U.f(e14.Filters) }), SortExpressions: r10 });
}, (e14) => {
  if ("statictablixmember" === e14.Type) {
    const _a2 = e14, { Type: t11 } = _a2, n11 = __objRest(_a2, ["Type"]);
    return __spreadProps(__spreadValues({}, n11), { SortExpressions: [], Group: null });
  }
  const _b2 = e14, { Type: t10, Group: n10 } = _b2, r10 = __objRest(_b2, ["Type", "Group"]);
  return __spreadProps(__spreadValues({}, r10), { KeepWithGroup: "None", RepeatOnNewPage: false, Group: __spreadProps(__spreadValues({}, n10), { Filters: _U.frev(n10.Filters) }) });
}));
const XU = (e14) => TU(Z.BasicModel.Tablix(e14), Z.Lenses.mapOfLens(Z.Lenses.prop("Filters", _U)), Z.Lenses.mapOfLens(Z.Lenses.prop("RowHierarchy", Z.Lenses.combine(Z.Lenses.prop("Members", Z.Lenses.array(Z.Lenses.combine(KU, { f: (e15) => e15, frev: (_a2) => {
  var _b2 = _a2, { $selected: e15, $primary: t10 } = _b2, n10 = __objRest(_b2, ["$selected", "$primary"]);
  return n10;
} }))), { f: (e15) => e15, frev: (_c2) => {
  var _d2 = _c2, { $selected: e15, $primary: t10 } = _d2, n10 = __objRest(_d2, ["$selected", "$primary"]);
  return n10;
} }))), Z.Lenses.mapOfLens(Z.Lenses.prop("ColumnHierarchy", Z.Lenses.combine(Z.Lenses.prop("Members", Z.Lenses.array(Z.Lenses.combine(KU, { f: (e15) => e15, frev: (_e2) => {
  var _f2 = _e2, { $selected: e15, $primary: t10 } = _f2, n10 = __objRest(_f2, ["$selected", "$primary"]);
  return n10;
} }))), { f: (e15) => e15, frev: (_g2) => {
  var _h2 = _g2, { $selected: e15, $primary: t10 } = _h2, n10 = __objRest(_h2, ["$selected", "$primary"]);
  return n10;
} }))), Z.Lenses.mapOfLens(VU()), Z.Lenses.mapOfLens(Z.Lenses.prop("Corner", Z.Lenses.array(Z.Lenses.array(Z.Lenses.nullable({ f: (e15) => e15, frev: (_i2) => {
  var _j2 = _i2, { $selected: e15, $primary: t10 } = _j2, n10 = __objRest(_j2, ["$selected", "$primary"]);
  return n10;
} }))))), Z.Lenses.mapOfLens(Z.Lenses.prop("Body", { f: (e15) => e15, frev: (_k2) => {
  var _l2 = _k2, { $selected: e15, $primary: t10 } = _l2, n10 = __objRest(_l2, ["$selected", "$primary"]);
  return n10;
} })), Z.Lenses.mapOfLens(Z.Lenses.prop("Style", AU())), rd(__spreadValues({ $columns: { collection: [] }, $rows: { collection: [] } }, GU)), yU(LU));
const JU = Z.Lenses.combine(Z.Lenses.make((e14) => __spreadProps(__spreadValues({}, e14), { Value: e14.Value.map((e15) => ({ Type: "dvchartencodingfieldvalue", Value: e15 })) }), (e14) => __spreadProps(__spreadValues({}, e14), { Value: e14.Value.map(({ Value: e15 }) => e15), Captions: e14.Value.map(() => "") })), Z.Lenses.prop("Value", Z.Lenses.array({ f: (e14) => e14, frev: (_v2) => {
  var _w2 = _v2, { $selected: e14, $primary: t10 } = _w2, n10 = __objRest(_w2, ["$selected", "$primary"]);
  return n10;
} })));
const QU = Z.Lenses.make((e14) => ({ FieldType: "Simple", Value: e14.Value }), (e14) => __spreadProps(__spreadValues({}, e14), { Captions: e14.Value.map(() => "") }));
const eq = Z.Lenses.make((e14) => __spreadProps(__spreadValues({}, e14), { TemplateKey: e14.Captions[0], Value: e14.Value[0] }), (e14) => ({ FieldType: "Simple", Value: [e14.Value], Captions: [e14.TemplateKey] }));
const tq = Z.Lenses.make((e14) => "Simple" === e14.FieldType ? __spreadProps(__spreadValues({}, e14), { Subfields: [], Value: e14.Value.map((t10, n10) => ({ Value: t10, Caption: e14.Captions[n10] || "" })) }) : __spreadProps(__spreadValues({}, e14), { Values: [] }), (e14) => "Simple" === e14.FieldType ? { FieldType: e14.FieldType, Value: e14.Value.map((e15) => e15.Value), Captions: e14.Value.map((e15) => e15.Caption || "") } : { FieldType: e14.FieldType, Subfields: e14.Subfields });
const nq = Z.Lenses.make((e14) => e14.Radial ? __spreadProps(__spreadValues({}, e14), { AxisMode: "Radial" }) : e14, (e14) => __spreadProps(__spreadValues({}, e14), { Radial: "Radial" === e14.AxisMode }));
const rq = TU(Z.BasicModel.DvChart, Z.Lenses.mapOfLens(Z.Lenses.combine4(Z.Lenses.prop("Header", { f: (e14) => e14, frev: (_x2) => {
  var _y2 = _x2, { $selected: e14, $primary: t10 } = _y2, n10 = __objRest(_y2, ["$selected", "$primary"]);
  return n10;
} }), Z.Lenses.prop("Footer", { f: (e14) => e14, frev: (_z2) => {
  var _A2 = _z2, { $selected: e14, $primary: t10 } = _A2, n10 = __objRest(_A2, ["$selected", "$primary"]);
  return n10;
} }), Z.Lenses.prop("PlotArea", Z.Lenses.combine3({ f: (e14) => e14, frev: (_B2) => {
  var _C2 = _B2, { $selected: e14, $primary: t10 } = _C2, n10 = __objRest(_C2, ["$selected", "$primary"]);
  return n10;
} }, Z.Lenses.prop("Legends", Z.Lenses.array({ f: (e14) => e14, frev: (_D2) => {
  var _E2 = _D2, { $selected: e14, $primary: t10 } = _E2, n10 = __objRest(_E2, ["$selected", "$primary"]);
  return n10;
} })), Z.Lenses.prop("Axes", Z.Lenses.array({ f: (e14) => e14, frev: (_F2) => {
  var _G2 = _F2, { $selected: e14, $primary: t10 } = _G2, n10 = __objRest(_G2, ["$selected", "$primary"]);
  return n10;
} })))), Z.Lenses.prop("Legend", { f: (e14) => e14, frev: (_H2) => {
  var _I2 = _H2, { $selected: e14, $primary: t10 } = _I2, n10 = __objRest(_I2, ["$selected", "$primary"]);
  return n10;
} }))), Z.Lenses.mapOfLens(Z.Lenses.prop("Filters", _U)), Z.Lenses.mapOfLens(Z.Lenses.prop("Plots", Z.Lenses.array(Z.Lenses.combine3(Z.Lenses.prop("Config", Z.Lenses.combine4(nq, Z.Lenses.prop("Action", RU()), Z.Lenses.prop("Pointers", Z.Lenses.array({ f: (e14) => e14, frev: (_J2) => {
  var _K2 = _J2, { $selected: e14, $primary: t10 } = _K2, n10 = __objRest(_K2, ["$selected", "$primary"]);
  return n10;
} })), Z.Lenses.prop("CustomLabels", Z.Lenses.array({ f: (e14) => e14, frev: (_L2) => {
  var _M2 = _L2, { $selected: e14, $primary: t10 } = _M2, n10 = __objRest(_M2, ["$selected", "$primary"]);
  return n10;
} })))), Z.Lenses.prop("Encodings", Z.Lenses.combine(Z.Lenses.combine3(Z.Lenses.prop("Color", Z.Lenses.combine3(Z.Lenses.prop("Field", JU), Z.Lenses.prop("Action", RU()), { f: (e14) => e14, frev: (_N2) => {
  var _O2 = _N2, { $selected: e14, $primary: t10 } = _O2, n10 = __objRest(_O2, ["$selected", "$primary"]);
  return n10;
} })), Z.Lenses.prop("Shape", Z.Lenses.combine3(Z.Lenses.prop("Field", JU), Z.Lenses.prop("Action", RU()), { f: (e14) => e14, frev: (_P2) => {
  var _Q2 = _P2, { $selected: e14, $primary: t10 } = _Q2, n10 = __objRest(_Q2, ["$selected", "$primary"]);
  return n10;
} })), Z.Lenses.prop("Size", Z.Lenses.combine3(Z.Lenses.prop("Field", JU), Z.Lenses.prop("Action", RU()), { f: (e14) => e14, frev: (_R2) => {
  var _S2 = _R2, { $selected: e14, $primary: t10 } = _S2, n10 = __objRest(_S2, ["$selected", "$primary"]);
  return n10;
} }))), Z.Lenses.combine4(Z.Lenses.prop("Category", Z.Lenses.combine(Z.Lenses.prop("Field", JU), { f: (e14) => e14, frev: (_T2) => {
  var _U2 = _T2, { $selected: e14, $primary: t10 } = _U2, n10 = __objRest(_U2, ["$selected", "$primary"]);
  return n10;
} })), Z.Lenses.prop("Values", Z.Lenses.array(Z.Lenses.combine(Z.Lenses.prop("Field", tq), { f: (e14) => e14, frev: (_V2) => {
  var _W2 = _V2, { $selected: e14, $primary: t10 } = _W2, n10 = __objRest(_W2, ["$selected", "$primary"]);
  return n10;
} }))), Z.Lenses.prop("Details", Z.Lenses.array(Z.Lenses.combine(Z.Lenses.prop("Field", QU), { f: (e14) => e14, frev: (_X2) => {
  var _Y2 = _X2, { $selected: e14, $primary: t10 } = _Y2, n10 = __objRest(_Y2, ["$selected", "$primary"]);
  return n10;
} }))), Z.Lenses.prop("Texts", Z.Lenses.array(Z.Lenses.combine(Z.Lenses.prop("Field", eq), { f: (e14) => e14, frev: (_Z2) => {
  var __2 = _Z2, { $selected: e14, $primary: t10 } = __2, n10 = __objRest(__2, ["$selected", "$primary"]);
  return n10;
} })))))), { f: (e14) => e14, frev: (_$2) => {
  var _aa = _$2, { $selected: e14, $primary: t10 } = _aa, n10 = __objRest(_aa, ["$selected", "$primary"]);
  return n10;
} })))), Z.Lenses.mapOfLens(VU()), Z.Lenses.mapOfLens(Z.Lenses.prop("Style", AU())), nd({ $customPaletteId: { Prop: "CustomPaletteId", Decoder: hU("", FU) }, $customPaletteName: { Prop: "CustomPaletteName", Decoder: hU("", FU) } }), CU((_ba) => {
  var _ca = _ba, { $customPaletteId: e14, $customPaletteName: t10 } = _ca, n10 = __objRest(_ca, ["$customPaletteId", "$customPaletteName"]);
  return __spreadProps(__spreadValues({}, n10), { CustomPaletteInfo: { PaletteId: e14, PaletteName: e14 && t10 } });
}, (_da) => {
  var _ea = _da, { CustomPaletteInfo: e14 } = _ea, t10 = __objRest(_ea, ["CustomPaletteInfo"]);
  return __spreadProps(__spreadValues({}, t10), { $customPaletteId: e14.PaletteId, $customPaletteName: e14.PaletteId && e14.PaletteName });
}), yU(LU));
const oq = TU(Z.BasicModel.Line, CU((e14) => __spreadProps(__spreadValues({}, e14), { $place: dU(e14) }), (e14) => e14));
const aq = TU(Z.BasicModel.Rectangle(zU), Z.Lenses.mapOfLens(VU()), yU(LU), DU);
const iq = () => Z.Lenses.nullable(Z.Lenses.combine(Z.Lenses.make((e14) => __spreadProps(__spreadValues(__spreadValues({}, e14), HU), { $place: { Height: e14.Height, Width: "" }, $width: "", LayerName: "default" }), (_a2) => {
  var _b2 = _a2, { $place: { Height: e14 }, $width: t10, $primary: n10, $selected: r10, LayerName: o10 } = _b2, a10 = __objRest(_b2, ["$place", "$width", "$primary", "$selected", "LayerName"]);
  return __spreadProps(__spreadValues({}, a10), { Height: e14 });
}), Z.Lenses.prop("Action", RU())));
const sq = (e14) => TU(Z.BasicModel.BandedList(e14), Z.Lenses.mapOfLens(Z.Lenses.combine3(Z.Lenses.combine3(Z.Lenses.prop("Filters", _U), Z.Lenses.prop("Header", iq()), Z.Lenses.prop("Footer", iq())), Z.Lenses.prop("Details", iq()), Z.Lenses.prop("Groups", Z.Lenses.array(Z.Lenses.combine4(Z.Lenses.prop("Header", iq()), Z.Lenses.prop("Footer", iq()), Z.Lenses.prop("Group", Z.Lenses.prop("Filters", _U)), { f: (e15) => e15, frev: (_a2) => {
  var _b2 = _a2, { $selected: e15, $primary: t10 } = _b2, n10 = __objRest(_b2, ["$selected", "$primary"]);
  return n10;
} }))))), yU(LU), CU((e15) => {
  const t10 = L$.parse(e15.$place.Width).css;
  const n10 = (e16, t11) => __spreadProps(__spreadValues({}, t11), { $width: e16, $place: { Height: t11.Height, Width: e16 } });
  return __spreadProps(__spreadValues({}, e15), { Header: e15.Header && n10(t10, e15.Header), Details: e15.Details && n10(t10, e15.Details), Footer: e15.Footer && n10(t10, e15.Footer), Groups: e15.Groups.map((e16) => __spreadProps(__spreadValues({}, e16), { Header: e16.Header && n10(t10, e16.Header), Footer: e16.Footer && n10(t10, e16.Footer) })), $width: t10 });
}, (e15) => e15));
const lq = TU(Z.BasicModel.Subreport, yU(LU), Z.Lenses.mapOfLens(Z.Lenses.prop("Style", AU())));
const cq = TU(Z.BasicModel.Shape, Z.Lenses.mapOfLens(VU()), yU(LU));
const uq = TU(Z.BasicModel.TableOfContents, yU(kU({ $style: MU({}) })), Z.Lenses.mapOfLens(Z.Lenses.combine(VU(), Z.Lenses.prop("Levels", Z.Lenses.array({ f: (e14) => e14, frev: (_fa) => {
  var _ga = _fa, { $selected: e14, $primary: t10 } = _ga, n10 = __objRest(_ga, ["$selected", "$primary"]);
  return n10;
} })))), yU(LU));
const dq = TU(Z.BasicModel.Barcode, yU(LU));
const pq = TU(Z.BasicModel.Image, yU(LU), Z.Lenses.mapOfLens(Z.Lenses.prop("Action", RU())));
const mq = TU(Z.BasicModel.Bullet, Z.Lenses.mapOfLens(VU()), yU(LU));
const hq = TU(Z.BasicModel.FormattedText, Z.Lenses.mapOfLens(VU()), yU(LU));
const fq = kU({ $hiddenCheckboxProps: MU({ Checked: "False", CheckStyle: "Check", CheckSize: "10pt" }), $hiddenTextProps: MU({ Password: false, Multiline: false, SpellCheck: false, MaxLength: null, Value: "" }) });
const gq = TU(Z.BasicModel.InputField, Z.Lenses.mapOfLens(VU()), yU(fq), yU(LU));
const yq = TU(Z.BasicModel.Sparkline, Z.Lenses.mapOfLens(Z.Lenses.prop("Filters", _U)), Z.Lenses.mapOfLens(Z.Lenses.prop("Group", Z.Lenses.prop("Filters", _U))), Z.Lenses.mapOfLens(VU()), yU(LU));
const vq = TU(Z.BasicModel.RichText, yU(LU), Z.Lenses.mapOfLens(VU()));
const bq = TU(Z.BasicModel.PartItem, yU(LU));
const Sq = TU(Z.BasicModel.ContentPlaceHolder(zU), yU(LU), DU, rd({ $inChildReport: false }));
const Cq = TU(Z.BasicModel.UnknownReportItem, yU(LU));
const xq = pU((e14) => e14.Type, (e14) => e14.Type, { textbox: OU, checkbox: BU, list: ZU(zU), table: YU(UU), tablix: XU(UU), line: oq, rectangle: aq, bandedlist: sq(zU), subreport: lq, shape: cq, tableofcontents: uq, barcode: dq, dvchart: rq, image: pq, bullet: mq, formattedtext: hq, inputfield: gq, sparkline: yq, richtext: vq, partitem: bq, contentplaceholder: Sq });
const wq = TU(xq, wU(Cq, (e14) => "unknown" === e14.Type), IU, nd({ $templateId: { Prop: "TemplateId", Decoder: xU(FU) } }));
function Tq(e14, t10) {
  return !e14 || "0in" === e14 || L$.parse(e14).equal(L$.zero) ? t10 || L$.zero.css : e14;
}
$U(wq);
const Eq = TU(kU({ FixedWidth: fU("0in", Z.BasicModel.Length), FixedHeight: fU("0in", Z.BasicModel.Length), OverflowName: hU("", FU), Height: vU(xU(Z.BasicModel.Length)), Width: vU(xU(Z.BasicModel.Length)) }), CU(({ FixedWidth: e14, FixedHeight: t10, OverflowName: n10, Height: r10, Width: o10 }) => ({ $fixedPlace: { Width: Tq(e14, o10), Height: Tq(t10, r10), OverflowName: n10 } }), (e14) => {
  const { $fixedPlace: { Width: t10, Height: n10, OverflowName: r10 } } = e14;
  const { $place: { Width: o10, Height: a10 } = {} } = e14;
  return { FixedWidth: t10 === o10 ? "0in" : t10, FixedHeight: n10 === a10 ? "0in" : n10, OverflowName: r10 };
}));
const Fq = TU(kU({ OverflowName: hU("", FU) }), CU(({ OverflowName: e14 }) => ({ $fixedPlace: { OverflowName: e14 } }), ({ $fixedPlace: { OverflowName: e14 } }) => ({ OverflowName: e14 })));
const Mq = TU(kU({ FixedHeight: fU("0in", FU), OverflowName: hU("", FU), Height: vU(xU(Z.BasicModel.Length)) }), CU(({ FixedHeight: e14, Height: t10, OverflowName: n10 }) => ({ $fixedPlace: { OverflowName: n10, Height: Tq(e14, t10) } }), (e14) => {
  const { $fixedPlace: { Height: t10 } } = e14;
  const { $place: { Height: n10 } = {} } = e14;
  return { FixedHeight: t10 === n10 ? "0in" : t10, OverflowName: e14.$fixedPlace.OverflowName };
}));
const kq = TU(kU({ Type: SU("overflowplaceholder"), Name: FU, LayerName: hU("default", FU), CustomProperties: FZ.arrayDef(Z.BasicModel.CustomProperty) }), yU(LU), yU(Fq), EU("Name"));
const Pq = { fixedpagelist: "list", fixedpagetable: "table", fixedpagetablix: "tablix", fixedpagebandedlist: "bandedlist", fixedpagerectangle: "rectangle", fixedpagesubreport: "subreport", fixedpagetableofcontents: "tableofcontents", fixedpagedvchart: "dvchart", fixedpagepartitem: "partitem" };
const Nq = TU(ZU(WU), Z.Lenses.mapOfLens(Z.Lenses.prop("Type", Z.Lenses.replace("list", "fixedpagelist"))), yU(Eq), DU);
const Dq = TU(YU(qU), yU(Eq), NU("table", "fixedpagetable"));
const Lq = TU(XU(qU), yU(Eq), yU(kU({ RepeatToFill: hU(false, mU) })), Z.Lenses.mapOfLens(Z.Lenses.prop("Type", Z.Lenses.replace("tablix", "fixedpagetablix"))));
const Hq = TU(sq(WU), yU(Eq), Z.Lenses.mapOfLens(Z.Lenses.prop("Type", Z.Lenses.replace("bandedlist", "fixedpagebandedlist"))));
const Iq = TU(lq, yU(Fq), Z.Lenses.mapOfLens(Z.Lenses.prop("Type", Z.Lenses.replace("subreport", "fixedpagesubreport"))));
const _q = TU(uq, yU(Mq), Z.Lenses.mapOfLens(Z.Lenses.prop("Type", Z.Lenses.replace("tableofcontents", "fixedpagetableofcontents"))));
const Vq = TU(rq, Z.Lenses.mapOfLens(Z.Lenses.prop("Type", Z.Lenses.replace("dvchart", "fixedpagedvchart"))));
const Rq = { ConsumeWhiteSpace: false, PageBreak: "None", KeepTogether: false };
const Aq = pU((e14) => e14.Type, (e14) => Pq[e14.Type] || e14.Type, { textbox: OU, checkbox: BU, line: oq, list: Nq, table: Dq, tablix: Lq, bandedlist: Hq, rectangle: TU(Z.BasicModel.Rectangle(WU), Z.Lenses.mapOfLens(VU()), yU(LU), DU, CU((_ha) => {
  var _ia = _ha, { ConsumeWhiteSpace: e14, KeepTogether: t10, PageBreak: n10 } = _ia, r10 = __objRest(_ia, ["ConsumeWhiteSpace", "KeepTogether", "PageBreak"]);
  return r10;
}, (e14) => __spreadValues(__spreadValues({}, e14), Rq)), Z.Lenses.mapOfLens(Z.Lenses.prop("Type", Z.Lenses.replace("rectangle", "fixedpagerectangle")))), subreport: Iq, shape: cq, tableofcontents: _q, barcode: dq, dvchart: Vq, image: pq, bullet: mq, formattedtext: hq, inputfield: gq, overflowplaceholder: kq, sparkline: yq, richtext: vq, partitem: TU(bq, yU(Eq), NU("partitem", "fixedpagepartitem")) });
const Oq = TU(Aq, wU(Cq, (e14) => "unknown" === e14.Type), IU, nd({ $templateId: { Prop: "TemplateId", Decoder: xU(FU) } }));
jU(Oq), XU(UU);
const Bq = FZ.resultOf(wq.decode({ Type: "tablix", Name: "tablix1" }));
const zq = (e14) => {
  const t10 = tz && tz.getTemplate("tablix", e14);
  const [n10, r10] = [t10.Body.Rows[0].Height, t10.Body.Columns[0]];
  return { cellHeight: n10, cellWidth: r10 };
};
const $q = (e14) => {
  var _a2;
  const t10 = tz;
  if (!t10) return {};
  const n10 = t10.getTemplate("tablix", e14);
  const r10 = ((_a2 = n10.Body.Rows[0].Cells[0]) == null ? void 0 : _a2.Item) || t10.getTemplate("textbox");
  return r10 == null ? void 0 : r10.Style;
};
const Wq = (e14) => {
  const t10 = tz && tz.create("textbox", KB(TG("textbox")));
  const n10 = __spreadValues(__spreadValues({}, t10.Style), $q(e14));
  return __spreadProps(__spreadValues({}, t10), { Style: n10 });
};
const jq = (e14) => ({ RowSpan: 1, ColSpan: 1, Item: Wq(e14), AutoMergeMode: "Never" });
const Zq = (e14, t10, n10, r10, o10 = "both", a10, i10) => ({ type: n10, label: t10 ? `propertyDescriptors:labels.${t10}` : "", category: e14 ? `propertyDescriptors:categories.${e14}` : "", valuePath: r10, mode: o10, icon: i10, meta: a10 });
const Gq = { float: { numberType: "Float", step: 0.1 }, floatEmpty: { numberType: "Float", step: 0.1, emptyValue: "EmptyString" }, floatPositive: { numberType: "Float", minValue: 0, excludeMin: true, step: 0.1 }, floatPositiveEmpty: { numberType: "Float", minValue: 0, excludeMin: true, step: 0.1, emptyValue: "EmptyString" }, floatPositiveZero: { numberType: "Float", minValue: 0, step: 0.1 }, integer: { numberType: "Integer", step: 1 }, integerPositive: { numberType: "Integer", minValue: 0, step: 1 }, integerPositiveEmpty: { numberType: "Integer", minValue: 0, step: 1, emptyValue: "EmptyString" } };
const Uq = { positive: { min: 0, max: 100, scale: 100, emptyValue: "Undefined" } };
const qq = { borderWidth: { minValue: L$.parse("0.25pt"), maxValue: L$.parse("20pt"), unit: "pt" }, borderWidthWithEmptyValue: { minValue: L$.parse("0.25pt"), maxValue: L$.parse("20pt"), unit: "pt", allowEmptyString: true }, lineWidth: { minValue: L$.parse("0.25pt"), maxValue: L$.parse("20pt"), unit: "pt" }, length340: { maxValue: L$.parse("340in") }, padding: { minValue: L$.parse("0pt"), maxValue: L$.parse("1000pt") }, fontSize: { minValue: L$.parse("1pt"), maxValue: L$.parse("200pt") } };
const Yq = "action", Kq = "appearance", Xq = "background", Jq = "backgroundAndBorders", Qq = "border", eY = "borders", tY = "common", nY = "content", rY = "data", oY = "dimensions", aY = "documentMap", iY = "general", sY = "group", lY = "international", cY = "layout", uY = "margins", dY = "misc", pY = "noData", mY = "pageSize", hY = "preview", fY = "symbology", gY = "text", yY = "visibility";
const vY = { Angle: Zq(gY, "style.angle", "number_expr", "Style.Angle", "advanced", Gq.float), BackgroundAndBorders: Zq(Jq, "style.backgroundAndBorders", "background_borders", "Style", "simple"), BackgroundColor: Zq(Xq, "style.backgroundColor", "color_expr", "Style.BackgroundColor", "advanced"), BackgroundGradientEndColor: Zq(Xq, "style.backgroundGradientEndColor", "color_expr", "Style.BackgroundGradientEndColor", "advanced"), BackgroundGradientType: Zq(Xq, "style.backgroundGradientType", "enum_expr", "Style.BackgroundGradientType", "advanced", { enumKey: "gradient_type" }), BackgroundImage: Zq(Xq, "style.backgroundImage", "background_image", "Style.BackgroundImage", "advanced"), Border: Zq(Qq, "", "simple_border", "Style"), Borders: Zq(Qq, "style.border", "border", "Style", "advanced"), Calendar: Zq(lY, "style.calendar", "enum_expr", "Style.Calendar", "advanced", { enumKey: "calendar" }), CharacterSpacing: Zq(gY, "style.characterSpacing", "length_expr", "Style.CharacterSpacing", "advanced", { unit: "pt", allowEmptyString: true }), Color: Zq(gY, "style.color", "color_expr", "Style.Color", "advanced"), Corners: Zq(Qq, "roundingRadius.label", "corner", "RoundingRadius"), Direction: Zq(lY, "style.direction", "enum_expr", "Style.Direction", "advanced", { enumKey: "direction" }), Font: Zq(gY, "style.font", "font", "Style", "advanced"), FontSimple: Zq(gY, "style.font", "font_simple", "Style", "simple"), Format: Zq(gY, "style.format", "format", "Style.Format", "advanced"), HeadingLevel: Zq(dY, "style.headingLevel", "number_expr", "Style.HeadingLevel", "advanced", Gq.integerPositiveEmpty), Language: Zq(lY, "style.language", "language", "Style.Language", "advanced"), LineHeight: Zq(gY, "style.lineHeight", "length_expr", "Style.LineHeight", "advanced"), LineSpacing: Zq(gY, "style.lineSpacing", "length_expr", "Style.LineSpacing", "advanced", { unit: "pt", allowEmptyString: true }), MaxLevel: Zq(rY, "style.maxLevel", "number_expr", "Style.MaxLevel", void 0, Gq.integerPositive), NumeralLanguage: Zq(lY, "style.numeralLanguage", "enum_expr", "Style.NumeralLanguage", "advanced", { enumKey: "language" }), NumeralVariant: Zq(lY, "style.numeralVariant", "enum_expr", "Style.NumeralVariant", "advanced", { enumKey: "numeral_variant" }), Padding: Zq(cY, "style.padding", "padding", "Style"), ShapeStyle: Zq(Qq, "style.shapeStyle", "enum_expr", "ShapeStyle", void 0, { enumKey: "shape_styles" }), ShrinkToFit: Zq(gY, "style.shrinkToFit", "boolean_expr", "Style.ShrinkToFit", "advanced"), TextAlign: Zq(gY, "style.textAlign", "enum_expr", "Style.TextAlign", "advanced", { enumKey: "text_align" }), TextDecoration: Zq(gY, "style.textDecoration", "text_decoration", "Style.TextDecoration", "advanced", { enumKey: "text_decoration" }), TextIndent: Zq(gY, "style.textIndent", "length", "Style.TextIndent"), TextJustify: Zq(gY, "style.textJustify", "enum_expr", "Style.TextJustify", "advanced", { enumKey: "text_justify" }), UnicodeBiDi: Zq(lY, "style.unicodeBiDi", "enum_expr", "Style.UnicodeBiDi", "advanced", { enumKey: "unicode_bidi" }), UprightInVerticalText: Zq(lY, "style.uprightInVerticalText", "enum_expr", "Style.UprightInVerticalText", "advanced", { enumKey: "upright_in_vertical_text" }), VerticalAlign: Zq(gY, "style.verticalAlign", "enum_expr", "Style.VerticalAlign", "advanced", { enumKey: "vertical_align" }), WrapMode: Zq(gY, "style.wrapMode", "enum_expr", "Style.WrapMode", "advanced", { enumKey: "wrap_mode" }), WritingMode: Zq(lY, "style.writingMode", "enum_expr", "Style.WritingMode", "advanced", { enumKey: "writing_mode" }) };
const bY = { LayerName: Zq(cY, "reportItem.layerName", "layer_name", "LayerName", "advanced"), Location: Zq(oY, "dimensions.location", "location", ""), Name: Zq(tY, "reportItem.name", "name_item", "Name"), Size: Zq(oY, "dimensions.size", "size", "") };
const SY = { Levels: Zq(aY, "report.levels", "level_collection", "DocumentMap.Levels"), NumberingStyle: Zq(aY, "report.numberingStyle", "enum_expr", "DocumentMap.NumberingStyle", void 0, { enumKey: "documentmap_numbering_style" }), Source: Zq(aY, "report.source", "enum_expr", "DocumentMap.Source", void 0, { enumKey: "documentmap_source" }) };
const CY = { Height: Zq(oY, "dimensions.height", "length_locsize", "Height"), Width: Zq(oY, "dimensions.width", "length_locsize", "Width") };
const xY = { EndPointX: Zq(cY, "dimensions.endPointX", "length_locsize", "EndPoint.X"), EndPointY: Zq(cY, "dimensions.endPointY", "length_locsize", "EndPoint.Y"), FixedHeight: Zq(oY, "dimensions.fixedHeight", "length_locsize", "$fixedPlace.Height"), FixedWidth: Zq(oY, "dimensions.fixedWidth", "length_locsize", "$fixedPlace.Width"), Height: Zq(oY, "dimensions.height", "length_locsize", "$place.Height"), Left: Zq(oY, "dimensions.left", "length_locsize", "$place.Left"), Top: Zq(oY, "dimensions.top", "length_locsize", "$place.Top"), StartPointX: Zq(cY, "dimensions.startPointX", "length_locsize", "StartPoint.X"), StartPointY: Zq(cY, "dimensions.startPointY", "length_locsize", "StartPoint.Y"), Width: Zq(oY, "dimensions.width", "length_locsize", "$place.Width") };
const wY = Zq(rY, "data.dataElementName", "string", "DataElementName", "advanced");
const TY = Zq(rY, "data.dataElementStyle", "enum", "DataElementStyle", "advanced", { enumKey: "data_element_style" });
const EY = __spreadProps(__spreadValues({}, bY), { Action: Zq(Yq, "reportItem.actionType", "action", "Action", "advanced"), Bookmark: Zq(dY, "reportItem.bookmark", "string_expr", "Bookmark", "advanced"), DataElementName: wY, DataElementOutput: Zq(rY, "data.dataElementOutput", "enum", "DataElementOutput", "advanced", { enumKey: "data_element_output" }), DataElementOutput_AON: Zq(rY, "data.dataElementOutput", "enum", "DataElementOutput", "advanced", { enumKey: "data_element_output_aon" }), KeepTogether: Zq(cY, "reportItem.keepTogether", "boolean", "KeepTogether", "advanced"), Label: Zq(dY, "reportItem.label", "string_expr", "Label", "advanced"), PageName: Zq(dY, "reportItem.pageName", "string_expr", "PageName"), ToolTip: Zq(dY, "reportItem.toolTip", "string_expr", "ToolTip", "advanced"), Visibility: Zq(yY, "reportItem.visibility", "visibility", "Visibility", "advanced"), ZIndex: Zq(cY, "reportItem.zIndex", "number", "ZIndex", "advanced", Gq.integerPositive), AccessibleDescription: Zq(dY, "reportItem.accessibleDescription", "string_expr", "AccessibleDescription", "advanced") });
const FY = { DataSetName: Zq(rY, "dataRegion.dataSetName", "dataset_name", "DataSetName"), DataSetParameters: Zq(rY, "dataRegion.dataSetParameters", "dataset_parameter_collection", "DataSetParameters"), Filters: Zq(rY, "dataRegion.filters", "filter_collection", "Filters"), FixedHeight: Zq(oY, "dimensions.fixedHeight", "length_locsize", "$fixedPlace.Height"), FixedWidth: Zq(oY, "dimensions.fixedWidth", "length_locsize", "$fixedPlace.Width"), NewSection: Zq(cY, "dataRegion.newSection", "boolean", "NewSection", "advanced"), NoRowsMessage: Zq(rY, "dataRegion.noRowsMessage", "string_expr", "NoRowsMessage"), OverflowName: Zq(rY, "dataRegion.overflowName", "overflow_name", "$fixedPlace.OverflowName", "advanced"), PageBreak: Zq(cY, "dataRegion.pageBreak", "enum", "PageBreak", void 0, { enumKey: "page_break" }), NewPage: Zq(cY, "dataRegion.newPage", "enum", "NewPage", void 0, { enumKey: "new_page" }), SortExpressions: Zq(rY, "dataRegion.sortExpressions", "sort_expression_expr_collection", "SortExpressions"), ThrowIfPlaceHoldersEmpty: Zq(rY, "dataRegion.throwIfPlaceHoldersEmpty", "boolean", "ThrowIfPlaceHoldersEmpty", "advanced"), RepeatToFill: Zq(cY, "dataRegion.repeatToFill", "boolean", "RepeatToFill") };
const MY = { DataCollectionName: Zq(sY, "group.dataCollectionName", "string", "Group.DataCollectionName", "advanced"), DataElementName: Zq(sY, "group.dataElementName", "string", "Group.DataElementName", "advanced"), DataElementOutput: Zq(sY, "group.dataElementOutput", "enum", "Group.DataElementOutput", "advanced", { enumKey: "data_element_output" }), DataElementOutput_ON: Zq(sY, "group.dataElementOutput", "enum", "Group.DataElementOutput", "advanced", { enumKey: "data_element_output_on" }), DocumentMapLabel: Zq(sY, "group.documentMapLabel", "string_expr", "Group.DocumentMapLabel", "advanced"), Filters: Zq(sY, "group.filters", "filter_collection", "Group.Filters"), GroupExpressions: Zq(sY, "group.groupExpressions", "group_expr_collection", "Group.GroupExpressions"), GroupExpressionsExt: Zq(sY, "group.groupExpressions", "group_expr_ext_collection", "Group"), Name: Zq(sY, "group.name", "name_group", "Group.Name"), NewSection: Zq(sY, "group.newSection", "boolean", "Group.NewSection", "advanced"), PageBreak: Zq(sY, "group.pageBreak", "enum", "Group.PageBreak", void 0, { enumKey: "page_break" }), PageBreakDisabled: Zq(sY, "group.pageBreakDisabled", "boolean_expr", "Group.PageBreakDisabled", "advanced"), PageBreakWithBetween: Zq(sY, "group.pageBreak", "enum", "Group.PageBreak", void 0, { enumKey: "page_break_with_between" }), NewPage: Zq(sY, "group.newPage", "enum", "Group.NewPage", void 0, { enumKey: "new_page" }), Parent: Zq(sY, "group.parent", "string_expr", "Group.ParentGroup", "advanced"), PrintFooterAtBottom: Zq(cY, "group.printFooterAtBottom", "boolean", "Group.PrintFooterAtBottom") };
const kY = { CanGrow: Zq(cY, "bandedList.canGrow", "boolean", "CanGrow"), CanShrink: Zq(cY, "bandedList.canShrink", "boolean", "CanShrink"), RepeatOnNewPage: Zq(cY, "bandedList.repeatOnNewPage", "boolean", "RepeatOnNewPage"), PrintAtBottom: Zq(cY, "bandedList.printAtBottom", "boolean", "PrintAtBottom"), PreventOrphanedFooter: Zq(cY, "bandedList.preventOrphanedFooter", "boolean", "PreventOrphanedFooter"), PreventOrphanedHeader: Zq(cY, "bandedList.preventOrphanedHeader", "boolean", "PreventOrphanedHeader"), PageBreakWithBetween: Zq(cY, "dataRegion.pageBreak", "enum", "PageBreak", void 0, { enumKey: "page_break_with_between" }) };
const PY = Zq(cY, "report.theme", "theme_uri_legacy", "Themes.0");
const NY = Zq(cY, "report.theme", "theme_uri", "Themes.0", "simple");
const DY = Zq(cY, "report.themes", "themes_collection", "Themes", "advanced");
const LY = Zq(cY, "report.collateBy", "enum", "CollateBy", "advanced", { enumKey: "collate_by" });
const HY = Zq(hY, "report.displayType", "enum", "$displayType", void 0, { enumKey: "display_type" });
const IY = Zq(hY, "report.sizeType", "enum", "$sizeType", void 0, { enumKey: "size_type" });
const _Y = Zq(hY, "report.layoutOrder", "enum", "LayoutOrder", void 0, { enumKey: "layout_order" });
const VY = Zq(hY, "report.collapseWhiteSpace", "boolean", "$collapseWhiteSpace");
const RY = { numberType: "Float", valueMode: "number", step: 0.1 };
const AY = { min: -100, max: 100, scale: 100, step: 1 };
const OY = { maxValue: L$.parse("160in") };
const BY = (e14, t10, n10, r10, o10, a10) => ({ type: n10, label: t10 ? `propertyDescriptors:labels.${t10}` : "", category: e14 ? `propertyDescriptors:categories.${e14}` : "", valuePath: r10, mode: o10, meta: a10 });
const zY = { success: () => ({ isValid: true }), constantError: (e14, t10 = "", n10) => ({ isValid: false, messages: [{ level: "error", valueType: e14, key: t10, args: n10, pattern: "validationErrors:pattern" }] }) };
const $Y = /^(?:true|false)$/i;
const WY = /^#([0-9A-F]{3}|[0-9A-F]{6})$/i;
const jY = /^-?\d*\.?\d+e[+-]?\d+$/;
const ZY = /^(-|\+)?([0-9]+)$/;
const GY = /^(-|\+)?([0-9]+)%?$/;
const UY = /^(\d+(?:|\.\d+))$/i;
const qY = { in: L$.parse("0.1in"), pt: L$.parse("0.1in"), pc: L$.parse("0.1in"), cm: L$.parse("0.25cm"), mm: L$.parse("0.25cm") };
const YY = (e14 = "", t10, n10) => {
  const r10 = e14.trim().toLowerCase();
  return n10.some((e15) => (e15 || "").toLowerCase() === r10) ? zY.success() : zY.constantError("enum", "incorrect", { enumType: t10, enumValues: n10.join(", ") });
};
const KY = { boolean: (e14) => $Y.test(e14) ? zY.success() : zY.constantError("boolean"), color: (e14, t10, n10) => {
  const r10 = e14.trim().toLowerCase();
  if (!r10 && (n10 == null ? void 0 : n10.allowEmpty)) return zY.success();
  const o10 = dm.webColors().some((e15) => e15.toLowerCase() === r10) || WY.test(r10);
  return o10 ? zY.success() : zY.constantError("color");
}, length: (e14, t10, n10 = {}) => {
  if (!(t10 == null ? void 0 : t10.units)) throw new Error('"coreValidateConstant" requires "settings.units" argument for length properties validation');
  const { maxValue: r10, minValue: o10, minValueMap: a10, maxValueMap: i10, allowEmptyString: s10, allowAutoValue: l10 } = n10;
  let c10 = e14.trim().toLowerCase();
  if (s10 && "" === c10 || l10 && "auto" === c10) return zY.success();
  if (c10.startsWith("-")) return zY.constantError("length", "negative");
  if (c10.startsWith(".") && (c10 = `0${c10}`), UY.test(c10) && (c10 = `${c10}${n10.unit || t10.units}`), !L$.isValidString(c10, true)) return zY.constantError("length", "unit");
  const u10 = L$.parse(c10.toLowerCase());
  return o10 && u10.lowerThan(o10) ? zY.constantError("length", "tooSmall", { min: o10 }) : a10 && u10.lowerThan(a10[u10.units]) ? zY.constantError("length", "tooSmall", { min: a10[u10.units] }) : r10 && u10.greaterThan(r10) ? zY.constantError("length", "tooLarge", { max: r10 }) : i10 && u10.greaterThan(i10[u10.units]) ? zY.constantError("length", "tooLarge", { max: i10[u10.units] }) : zY.success();
}, number: (e14, t10, n10) => {
  const { numberType: r10, emptyValue: o10 } = n10;
  const a10 = e14.trim();
  if ("" === a10) return o10 ? zY.success() : zY.constantError("number", "empty");
  let i10 = NaN;
  if ("Integer" === r10 ? ZY.test(a10) && (i10 = parseInt(a10, 10)) : "Float" === r10 && (i10 = Number(a10)), Number.isNaN(i10)) return zY.constantError("number", "nan");
  const [s10, l10] = "Integer" === r10 ? [-2147483648, 2147483647] : [-1 / 0, 1 / 0];
  const { minValue: c10 = s10, maxValue: u10 = l10, intervals: d10 = [], excludeMin: p10 = false, excludeMax: m10 = false } = n10;
  if (p10 ? i10 <= c10 : i10 < c10) return zY.constantError("number", "tooSmall", { min: c10 });
  if (m10 ? i10 >= u10 : i10 > u10) return zY.constantError("number", "tooLarge", { max: u10 });
  if (jY.test(i10.toString())) return zY.constantError("number", "outOfRange");
  if (d10.length) {
    const e15 = d10.some((e16) => (p10 ? i10 > e16.min : i10 >= e16.min) && (m10 ? i10 < e16.max : i10 <= e16.max));
    if (!e15) return zY.constantError("number", "outOfInterval");
  }
  return zY.success();
}, percent: (e14, t10, n10 = {}) => {
  const { emptyValue: r10, max: o10 = AY.max, min: a10 = AY.min } = n10;
  const i10 = e14.trim();
  if ("" === i10) return r10 ? zY.success() : zY.constantError("number", "empty");
  if (!GY.test(i10)) return zY.constantError("number", "nan");
  const s10 = parseInt(i10, 10);
  return s10 > o10 ? zY.constantError("number", "tooLarge", { max: o10 }) : s10 < a10 ? zY.constantError("number", "tooSmall", { min: a10 }) : zY.success();
}, enum: (e14, t10, n10) => {
  const { enumKey: r10 } = n10;
  _O(r10) || console.warn(`coreValidator.enum(): enumKey "${r10}" is not registered as enum.`);
  const o10 = VO(r10);
  return YY(e14, r10, o10);
}, line_style: (e14, t10, n10) => {
  const { enumKey: r10 } = n10;
  _O(r10) || console.warn(`coreValidator.enum(): enumKey "${r10}" is not registered as enum.`);
  const o10 = VO(r10);
  return YY(e14, r10, o10);
}, string: zY.success, date_format: zY.success };
const XY = (e14) => (console.warn(`coreValidateConstant(): unknown type ${e14}`), { isValid: false, messages: [{ level: "error", valueType: "unknown", key: "unknown", args: { type: e14 } }] });
function JY(e14, t10, n10, r10, o10 = XY) {
  const a10 = KY[t10];
  return a10 ? a10(e14, n10, r10) : o10(t10);
}
const QY = {};
const eK = { of: (e14) => (e14 in QY || (QY[e14] = function(e15) {
  const t10 = nz.of(e15) ? nz.of(e15).of("rdlx") : tz == null ? void 0 : tz.of("rdlx");
  if (!t10) throw new Error("Error in RdlxDocumentItemsApi");
  return { getTextDecorations(e16) {
    const n10 = e16.map((e17) => t10.getFeature(e17, "textDecorations")).filter(He);
    return BV.intersection(...n10);
  }, getBorderStyles(e16) {
    const n10 = e16.map((e17) => t10.getFeature(e17, "borderStyles")).filter(He);
    return BV.intersection(...n10);
  }, isDataRegion: (e16) => !!t10.getFeature(e16, "isDataRegion") };
}(e14)), QY[e14]) };
const tK = /<body.*?>([\s\S]*)<\/body>/;
const nK = { boolean_expr: KY.boolean, color_expr: KY.color, dvchart_template: KY.string, enum_expr: KY.enum, font_size_expr: KY.length, length_expr: KY.length, length_locsize: KY.length, number_expr: KY.number, percent_expr: KY.percent, string_expr: KY.string, html_expr: (e14) => "" === e14 || tK.test(e14) ? zY.success() : zY.constantError("html"), mime_type: (e14, t10, n10) => "" === e14.trim() ? zY.success() : YY(e14, "mime_type", (n10 == null ? void 0 : n10.imageMimeTypes) || []), language: (e14, t10, n10) => {
  var _a2, _b2;
  if ("" === e14.trim()) return zY.success();
  const r10 = (_b2 = (_a2 = n10 == null ? void 0 : n10.reportLanguages) == null ? void 0 : _a2.map((e15) => e15.value)) != null ? _b2 : VO("language");
  return YY(e14, "language", r10);
} };
const rK = (e14 = "", t10, n10, r10 = []) => {
  const { enumKey: o10, allowEmpty: a10 } = t10;
  if ("" === e14 && a10) return zY.success();
  const i10 = r10.length ? eK.of(n10).getBorderStyles(r10) : VO(o10);
  return i10.map((e15) => e15.toLowerCase()).includes(e14.trim().toLowerCase()) ? zY.success() : zY.constantError("enum", "incorrect", { enumType: o10, enumValues: i10.join(", ") });
};
const oK = (e14 = "", t10, n10, r10 = []) => {
  const { enumKey: o10, allowEmpty: a10 } = t10;
  if ("" === e14 && a10) return zY.success();
  const i10 = r10.length ? eK.of(n10).getTextDecorations(r10) : VO(o10);
  const s10 = i10.map((e15) => e15.toLowerCase());
  return s10.includes(e14.trim().toLowerCase()) ? zY.success() : zY.constantError("enum", "incorrect", { enumType: o10, enumValues: i10.join(", ") });
};
function aK(e14 = "", t10, n10) {
  const { descriptor: r10, descriptor: { type: o10, meta: a10 } } = n10;
  if ("border_style" === r10.type) return rK(e14, r10.meta, n10.instanceId, n10.itemTypes);
  if ("text_decoration" === r10.type) return oK(e14, r10.meta, n10.instanceId, n10.itemTypes);
  const i10 = nK[o10];
  if (i10) return i10(e14, t10, a10);
  if (_O(o10)) {
    const t11 = VO(o10);
    return YY(e14, o10, t11);
  }
  return JY(e14, o10, t10, a10, zY.success);
}
const iK = XN.toString();
const sK = (e14) => e14 === iK || e14 && "object" == typeof e14 && e14.toString() === iK;
function lK(e14, t10) {
  switch (t10) {
    case "EmptyString":
      return "" === e14;
    case "Null":
      return null === e14;
    case "Undefined":
      return void 0 === e14;
  }
  return false;
}
const cK = /^#([0-9A-F]{3}|[0-9A-F]{6})$/i;
const uK = (e14, t10, n10 = "") => {
  const r10 = (e14 || "").trim().toLowerCase();
  const o10 = t10 && t10.find((e15) => (e15 || "").toLowerCase() === r10);
  return o10 || n10;
};
const dK = { string: (e14, t10, n10 = "", r10) => {
  var _a2;
  if (e14) return e14;
  switch ((_a2 = r10 == null ? void 0 : r10.emptyValue) != null ? _a2 : "EmptyString") {
    case "EmptyString":
      return "";
    case "Null":
      return null;
    case "Undefined":
      return;
    default:
      return n10;
  }
}, boolean: (e14) => false === e14 ? "False" : true === e14 || e14 && "false" !== e14.trim().toLowerCase() ? "True" : "False", color: (e14, t10, n10 = "") => {
  if (!e14) return n10;
  const r10 = e14.trim().toLowerCase();
  const o10 = dm.webColors().find((e15) => e15.toLowerCase() === r10);
  return void 0 !== o10 ? o10 : cK.test(r10) ? r10 : n10;
}, percent: (e14, t10, n10 = 0, r10) => {
  const o10 = (r10 == null ? void 0 : r10.scale) || 100;
  let a10 = NaN;
  return /^(-|\+)?([0-9]+)%?$/.test(e14.trim()) && (a10 = parseInt(e14, 10)), Number.isNaN(a10) ? n10 : a10 / o10;
}, number: (e14, t10, n10 = 0, r10) => {
  const { valueMode: o10 = "number", numberType: a10 = "Integer", emptyValue: i10 } = r10 || {};
  if ("EmptyString" === i10 && "" === e14) return "";
  let s10 = NaN;
  return "Integer" === a10 ? /^(-|\+)?([0-9]+)$/.test(e14) && (s10 = parseInt(e14, 10)) : "Float" === a10 && (s10 = Number(e14)), Number.isNaN(s10) ? n10 : "string" === o10 ? s10.toString() : s10;
}, length: (e14, t10, n10 = "", r10) => {
  if (!(t10 == null ? void 0 : t10.units)) throw new Error('"coreFromDisplayValue" requires "settings.units" argument for length properties validation');
  if (!e14) return n10;
  let o10 = e14.trim().toLowerCase();
  return (r10 == null ? void 0 : r10.allowAutoValue) && "auto" === o10 ? "Auto" : (o10.startsWith(".") && (o10 = `0${o10}`), w$.test(o10) && (o10 = `${o10}${(r10 == null ? void 0 : r10.unit) || t10.units}`), L$.isValidString(o10) ? L$.parse(o10).normalize().css : n10);
}, enum: (e14, t10, n10 = "", r10) => {
  const { enumKey: o10 } = r10;
  const a10 = VO(o10);
  return uK(e14, a10, n10);
}, line_style: (e14, t10, n10 = "", r10) => {
  const o10 = VO(r10.enumKey);
  return uK(e14, o10, n10);
} };
function pK(e14, t10, n10, r10, o10) {
  const a10 = dK[t10];
  return a10 ? a10(e14, n10, o10, r10) : e14;
}
const mK = { string: (e14, t10 = "", n10) => {
  var _a2, _b2;
  return lK(e14, (_a2 = n10 == null ? void 0 : n10.emptyValue) != null ? _a2 : "EmptyString") ? "" : "string" != typeof e14 ? (_b2 = e14 == null ? void 0 : e14.toString()) != null ? _b2 : t10 : e14;
}, color: (e14, t10 = "", n10) => {
  var _a2;
  if (!e14) return (n10 == null ? void 0 : n10.allowEmpty) ? "" : t10;
  if ("string" != typeof e14) return (_a2 = e14 == null ? void 0 : e14.toString()) != null ? _a2 : t10;
  const r10 = e14.trim();
  if (r10 in dm.webColors) return r10;
  if (/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(r10)) {
    const e15 = dm.toWeb(dm.fromHEX(r10));
    if (e15) return e15;
  }
  return r10;
}, percent: (e14, t10 = "", n10) => {
  if (lK(e14, n10 == null ? void 0 : n10.emptyValue)) return t10;
  const r10 = (n10 == null ? void 0 : n10.scale) || 100;
  const o10 = parseFloat(e14);
  return Number.isNaN(o10) ? t10 : `${Math.round(o10 * r10)}%`;
}, number: (e14, t10 = "", n10) => {
  var _a2;
  return lK(e14, n10 == null ? void 0 : n10.emptyValue) ? "" : (_a2 = e14 == null ? void 0 : e14.toString()) != null ? _a2 : t10;
} };
function hK(e14, t10, n10, r10, o10 = "") {
  if (sK(e14)) return o10;
  const a10 = mK[t10];
  return a10 ? a10(e14, o10, r10) : String(e14 != null ? e14 : "");
}
const fK = (e14, t10, n10) => {
  switch (e14.type) {
    case "unary":
      return __spreadProps(__spreadValues({}, e14), { operand: fK(e14.operand, t10, n10) });
    case "binary":
      return __spreadProps(__spreadValues({}, e14), { leftOperand: fK(e14.leftOperand, t10, n10), rightOperand: fK(e14.rightOperand, t10, n10) });
    case "infix":
      return __spreadProps(__spreadValues({}, e14), { operands: e14.operands.map((e15) => fK(e15, t10, n10)) });
    case "fn":
      return __spreadProps(__spreadValues({}, e14), { args: e14.args.map((e15) => fK(e15, t10, n10)) });
    case "method":
      return __spreadProps(__spreadValues({}, e14), { thisArg: fK(e14.thisArg, t10, n10), args: e14.args.map((e15) => fK(e15, t10, n10)) });
    case "prop":
      return __spreadProps(__spreadValues({}, e14), { thisArg: fK(e14.thisArg, t10, n10) });
    case "variable":
      if (e14.name === t10) return n10;
  }
  return e14;
};
const gK = (e14, t10, n10) => "expression" === e14.type ? __spreadProps(__spreadValues({}, e14), { pieces: e14.pieces.map((e15) => "ex" === e15.type ? { type: "ex", expression: fK(e15.expression, t10, n10) } : e15) }) : e14;
const yK = (e14) => {
  if (!e14) return [];
  return [...e14.Fields || [], ...e14.$calculatedFields || []].map((e15, t10) => __spreadProps(__spreadValues({}, e15), { fieldIndex: t10 }));
};
const vK = (e14) => {
  var _a2, _b2;
  const t10 = /^\$dataset:([\p{L}\d_]+)\/(.*)$/gu.exec((_b2 = (_a2 = e14 == null ? void 0 : e14.Query) == null ? void 0 : _a2.DataSourceName) != null ? _b2 : "");
  return 3 === (t10 == null ? void 0 : t10.length) ? { dataSetName: t10[1], fieldName: t10[2] } : null;
};
const bK = (e14, t10) => `$dataset:${e14}/${t10}`;
const SK = (e14) => {
  let t10 = e14.map((e15) => AV(e15, { $parentReference: { $set: null }, $childrenReferences: { $set: [] } }));
  return t10.forEach((n10, r10) => {
    const o10 = vK(n10);
    if (!o10) return;
    const a10 = e14.findIndex(({ Name: e15 }) => e15 === o10.dataSetName);
    if (a10 < 0) throw new Error(`There is no parent data set '${o10.dataSetName}' for data set '${n10.Name}'`);
    t10 = AV(t10, { [a10]: { $childrenReferences: { $push: [n10.Name] } }, [r10]: { $parentReference: { $set: o10.dataSetName } } });
  }), t10;
};
const CK = FZ.pipe(Z.BasicModel.ReportCommonProps.ReportParts, FZ.map((e14) => e14.map((e15) => {
  var _a2;
  return __spreadProps(__spreadValues({}, e15), { SizeMode: (t10 = e15.SizeMode, (_a2 = (/* @__PURE__ */ new Map()).set("Resizable", "Fit").set("Fixed", "Grow").get(t10)) != null ? _a2 : "Fit") });
  var t10;
}), (e14) => e14.map((e15) => {
  var _a2;
  return __spreadProps(__spreadValues({}, e15), { SizeMode: (t10 = e15.SizeMode, (_a2 = (/* @__PURE__ */ new Map()).set("Fit", "Resizable").set("Grow", "Fixed").get(t10)) != null ? _a2 : "Resizable") });
  var t10;
})));
const { type: xK, Default: wK, pipe: TK, nullable: EK, iif: FK, map: MK, mapInput: kK, upcast: PK, string: NK, required: DK, justRead: LK, Const: HK, arrayDef: IK, literal: _K, initValue: VK, members: RK, Lenses: AK } = HZ;
const { CommonStyle: OK } = Z.BasicModel;
const BK = TK(Z.BasicModel.BodySection(PK()(wq)), MK((_ja) => {
  var _ka = _ja, { Height: e14 } = _ka, t10 = __objRest(_ka, ["Height"]);
  return __spreadProps(__spreadValues({}, t10), { $place: { Height: e14 }, $width: "", $height: "" });
}, (_la) => {
  var _ma = _la, { $place: { Height: e14 }, $width: t10, $height: n10 } = _ma, r10 = __objRest(_ma, ["$place", "$width", "$height"]);
  return __spreadProps(__spreadValues({}, r10), { Height: e14 });
}), rd({ Name: "Body" }), IU);
const zK = TK(Z.BasicModel.BodySection(PK()(wq)), MK((_na) => {
  var _oa = _na, { Height: e14 } = _oa, t10 = __objRest(_oa, ["Height"]);
  return __spreadProps(__spreadValues({}, t10), { $place: { Height: e14 }, $width: "", $height: "", $selected: "leaf", $primary: true });
}, (_pa) => {
  var _qa = _pa, { $place: { Height: e14 }, $width: t10, $height: n10, $selected: r10, $primary: o10 } = _qa, a10 = __objRest(_qa, ["$place", "$width", "$height", "$selected", "$primary"]);
  return __spreadProps(__spreadValues({}, a10), { Height: e14 });
}), rd({ Name: "Body" }), IU);
const $K = TK(Z.BasicModel.PageSection(PK()(wq)), MK((_ra) => {
  var _sa = _ra, { Height: e14 } = _sa, t10 = __objRest(_sa, ["Height"]);
  return __spreadProps(__spreadValues({}, t10), { $place: { Height: e14 }, $width: "", $height: "" });
}, (_ta) => {
  var _ua = _ta, { $place: { Height: e14 }, $width: t10, $height: n10 } = _ua, r10 = __objRest(_ua, ["$place", "$width", "$height"]);
  return __spreadProps(__spreadValues({}, r10), { Height: e14 });
}), rd({ Name: "pagesection1" }), IU);
const WK = TK($K, MK((e14) => __spreadProps(__spreadValues({}, e14), { $dashboard: true }), (_va) => {
  var _wa = _va, { $dashboard: e14 } = _wa, t10 = __objRest(_wa, ["$dashboard"]);
  return t10;
}));
const jK = TK(xK({ ErrorType: NK, Message: NK }), DK("ErrorType", "Message"));
const ZK = TK(xK({ Name: NK, SourceType: NK, ResultType: NK, Errors: IK(jK) }), DK("Name", "SourceType", "ResultType"));
const GK = LK(IK(ZK));
let UK = 0;
const qK = TK(Z.BasicModel.FixedPage(PK()(Oq)), AK.mapOfLens(AK.prop("Pages", AK.array(AK.make((e14) => __spreadProps(__spreadValues({}, e14), { Name: "Page" + ++UK }), (e14) => e14)))), AK.mapOfLens(AK.prop("Pages", AK.array({ f: (e14) => e14, frev: (_xa) => {
  var _ya = _xa, { $selected: e14, $primary: t10 } = _ya, n10 = __objRest(_ya, ["$selected", "$primary"]);
  return n10;
} }))), AK.mapOfLens(AK.prop("Pages", AK.array({ f: (e14) => e14, frev: (_za) => {
  var _Aa = _za, { $active: e14 } = _Aa, t10 = __objRest(_Aa, ["$active"]);
  return t10;
} }))), AK.mapOfLens(AK.prop("Group", AK.prop("Filters", _U))), AK.mapOfLens(AK.prop("Filters", _U)));
const _Ba = Z.BasicModel.ReportCommonProps, { DataSets: YK, DataSources: KK, Page: XK } = _Ba, JK = __objRest(_Ba, ["DataSets", "DataSources", "Page"]);
const QK = TK(XK, MK((e14) => __spreadProps(__spreadValues({}, e14), { $autoPageHeight: false }), (_Ca) => {
  var _Da = _Ca, { $autoPageHeight: e14 } = _Da, t10 = __objRest(_Da, ["$autoPageHeight"]);
  return t10;
}));
const eX = TK(IK(ld), MK((e14) => SK(e14), (e14) => e14));
const tX = __spreadProps(__spreadValues({}, JK), { Page: QK, DataSources: IK(sd), DataSets: eX, ReportParts: CK, TransformationInfo: GK, Themes: IK(NK) });
const nX = () => AK.make((e14) => {
  const t10 = e14.ThemeUri ? AV(e14.Themes, { $splice: [[0, 1, e14.ThemeUri]] }) : [];
  return __spreadProps(__spreadValues({}, e14), { Themes: t10 });
}, (e14) => {
  let { ThemeUri: t10, Themes: n10 } = e14;
  const r10 = (n10 || []).filter((e15) => e15);
  return t10 = r10.length > 0 ? r10[0] : "", r10.length <= 1 && (n10 = []), __spreadProps(__spreadValues({}, e14), { ThemeUri: t10, Themes: n10 });
});
const rX = xK(__spreadProps(__spreadValues({ Type: FZ.literalInit("Continuous") }, Z.BasicModel.ReportSectionProps), { PageHeader: wK(null, EK($K)), Body: BK, PageFooter: wK(null, EK($K)), Page: QK }));
const oX = xK(__spreadProps(__spreadValues({ Type: FZ.literalInit("FixedPage") }, Z.BasicModel.ReportSectionProps), { FixedPage: qK, CollateBy: Z.BasicModel.Decoders.Enum("Simple", Z.BasicModel.Decoders.members("Simple", "ValueIndex", "Value")) }));
const aX = FZ.alt((e14) => e14.Type, (e14) => e14.Type, { Continuous: rX, FixedPage: oX });
const iX = "_Data_Set_Fields";
const sX = () => ({ decode: (e14) => "False" === e14 ? FZ.success(false) : FZ.success(true), encode: (e14) => true === e14 ? "True" : "False" });
const lX = TK(FK((e14) => "ReportSections" in e14, (e14) => "multisectionreport" === e14.Type, TK(xK(__spreadProps(__spreadValues({ Type: HK("multisectionreport") }, tX), { ReportSections: TK(FZ.array(aX), MK((e14) => e14.map((e15, t10) => 0 === t10 ? __spreadProps(__spreadValues({}, e15), { $active: true }) : e15), (e14) => e14)) })), MK((e14) => __spreadProps(__spreadValues({}, e14), { $activeSectionIndex: 0, $selected: "leaf", $primary: true }), (e14) => {
  const _a2 = e14, { $primary: t10, $selected: n10 } = _a2, r10 = __objRest(_a2, ["$primary", "$selected"]);
  return __spreadValues({}, r10);
}), AK.mapOfLens(AK.prop("Layers", AK.array({ f: (e14) => e14, frev: (_Ea) => {
  var _Fa = _Ea, { $selected: e14, $primary: t10 } = _Fa, n10 = __objRest(_Fa, ["$selected", "$primary"]);
  return n10;
} }))), AK.mapOfLens(AK.prop("ReportSections", AK.array({ f: (e14) => e14, frev: (_Ga) => {
  var _Ha = _Ga, { $selected: e14, $primary: t10 } = _Ha, n10 = __objRest(_Ha, ["$selected", "$primary"]);
  return n10;
} }))), AK.mapOfLens(AK.prop("ReportSections", AK.array({ f: (e14) => e14, frev: (_Ia) => {
  var _Ja = _Ia, { $active: e14 } = _Ja, t10 = __objRest(_Ja, ["$active"]);
  return t10;
} })))), TK(xK(__spreadProps(__spreadValues({ Type: HK("fixedpagereport") }, tX), { FixedPage: qK, CollateBy: Z.BasicModel.Decoders.Enum("Simple", Z.BasicModel.Decoders.members("Simple", "ValueIndex", "Value")) })), MK((e14) => {
  const _a2 = e14, { FixedPage: { DataSetName: t10, DataElementName: n10, DataElementOutput: r10, Pages: o10, Group: a10, SortExpressions: i10, Filters: s10 } } = _a2, l10 = __objRest(_a2, ["FixedPage"]);
  const c10 = o10.map((e15, t11) => __spreadProps(__spreadValues({}, e15), { Name: `Page${t11 + 1}` }));
  return c10[0] = __spreadProps(__spreadValues({}, c10[0]), { $selected: "leaf", $primary: true, $active: true }), __spreadProps(__spreadValues({}, l10), { DataSetName: t10, FixedPageDataElementName: n10, FixedPageDataElementOutput: r10, Pages: c10, Group: a10, SortExpressions: i10, Filters: s10, $activePageIndex: 0, $selected: "partial", $primary: true });
}, (e14) => {
  const _a2 = e14, { DataSetName: t10, FixedPageDataElementName: n10, FixedPageDataElementOutput: r10, Pages: o10, Group: a10, SortExpressions: i10, Filters: s10, $selected: l10, $primary: c10 } = _a2, u10 = __objRest(_a2, ["DataSetName", "FixedPageDataElementName", "FixedPageDataElementOutput", "Pages", "Group", "SortExpressions", "Filters", "$selected", "$primary"]);
  return __spreadProps(__spreadValues({}, u10), { FixedPage: { Type: "fixedpage", DataSetName: t10, DataElementName: n10, DataElementOutput: r10, Pages: o10, Group: a10, SortExpressions: i10, Filters: s10 } });
}), AK.mapOfLens(AK.prop("Layers", AK.array({ f: (e14) => e14, frev: (_Ka) => {
  var _La = _Ka, { $selected: e14, $primary: t10 } = _La, n10 = __objRest(_La, ["$selected", "$primary"]);
  return n10;
} }))))), rd({ $paramsView: null, $conversionInfo: null, $index: {}, $masterReportContent: null, $masterReport: null, $currentLayerName: "default" }), AK.mapOfLens(nX()), nd({ $displayType: { Prop: "DisplayType", Decoder: od("Page", VK("Page", RK("Page", "Galley"))) }, $sizeType: { Prop: "SizeType", Decoder: od("Default", VK("Default", RK("Default", "FitToPage", "FitToWidth"))) }, $masterReport: { Prop: "MasterReport", Decoder: wK(null, EK(NK)) }, $isMasterReport: { Prop: "IsMaster", Decoder: { decode: (e14) => "True" === e14 ? FZ.success(true) : FZ.success(false), encode: (e14) => true === e14 ? "True" : void 0 } }, $collapseWhiteSpace: { Prop: "CollapseWhiteSpace", Decoder: sX() } }), MK((e14) => {
  const t10 = ["_web_designer_model_id", "_web_designer_model_version", "Theme", "DataSourceLinks", "DataSetLinks"];
  return __spreadProps(__spreadValues({}, e14), { CustomProperties: e14.CustomProperties.filter((e15) => e15 && !t10.includes(e15.Name)) });
}, (e14) => e14), kK((_Ma) => {
  var _Na = _Ma, { DataSets: e14 } = _Na, t10 = __objRest(_Na, ["DataSets"]);
  var _a2;
  if (null == e14) return t10;
  let n10 = (_a2 = t10.CustomProperties) == null ? void 0 : _a2.slice();
  const r10 = e14.map((_b2) => {
    var _c2 = _b2, { $fieldsInfo: e15 } = _c2, t11 = __objRest(_c2, ["$fieldsInfo"]);
    const r11 = `${t11.Name}${iX}`;
    return n10 || (n10 = []), td(n10, r11, e15), t11;
  });
  return __spreadProps(__spreadValues({}, t10), { DataSets: r10, CustomProperties: n10 });
}, (_Oa) => {
  var _Pa = _Oa, { DataSets: e14 } = _Pa, t10 = __objRest(_Pa, ["DataSets"]);
  var _a2;
  const n10 = ((_a2 = t10.CustomProperties) == null ? void 0 : _a2.slice()) || [];
  const r10 = e14 == null ? void 0 : e14.map((e15) => {
    var _a3;
    const t11 = `${e15.Name}${iX}`;
    const r11 = ((_a3 = n10 == null ? void 0 : n10.find((e16) => e16.Name === t11)) == null ? void 0 : _a3.Value) || "";
    return td(n10, t11, void 0), __spreadProps(__spreadValues({}, e15), { $fieldsInfo: r11 });
  });
  return __spreadProps(__spreadValues({}, t10), { DataSets: r10, CustomProperties: n10 });
}), MK((e14) => __spreadProps(__spreadValues({}, e14), { Language: e14.Language || "Default" }), (e14) => __spreadProps(__spreadValues({}, e14), { Language: "Default" === e14.Language ? "" : e14.Language })), IU);
const cX = TK(BK, MK((e14) => __spreadProps(__spreadValues({}, e14), { $dashboard: true }), (_Qa) => {
  var _Ra = _Qa, { $dashboard: e14 } = _Ra, t10 = __objRest(_Ra, ["$dashboard"]);
  return t10;
}));
const uX = TK(xK(__spreadProps(__spreadValues({ Type: FZ.literalInit("Continuous") }, Z.BasicModel.ReportSectionProps), { PageHeader: wK(null, EK(WK)), PageFooter: wK(null, EK(WK)), Page: QK, Body: cX })), MK((e14) => __spreadProps(__spreadValues({}, e14), { Type: "dashboardsection" }), (e14) => __spreadProps(__spreadValues({}, e14), { Type: "Continuous" })));
const dX = TK(TK(xK(__spreadProps(__spreadValues({}, tX), { ReportSections: TK(FZ.array(uX), MK((e14) => e14.map((e15, t10) => 0 === t10 ? __spreadProps(__spreadValues({}, e15), { $active: true }) : e15), (e14) => e14)) })), MK((e14) => __spreadProps(__spreadValues({}, e14), { Type: "dashboard", $activeSectionIndex: 0, $selected: "leaf", $primary: true }), (_Sa) => {
  var _Ta = _Sa, { $primary: e14, $selected: t10 } = _Ta, n10 = __objRest(_Ta, ["$primary", "$selected"]);
  return __spreadProps(__spreadValues({}, n10), { Type: "report" });
}), AK.mapOfLens(AK.prop("Layers", AK.array({ f: (e14) => e14, frev: (_Ua) => {
  var _Va = _Ua, { $selected: e14, $primary: t10 } = _Va, n10 = __objRest(_Va, ["$selected", "$primary"]);
  return n10;
} }))), AK.mapOfLens(AK.prop("ReportSections", AK.array({ f: (e14) => e14, frev: (_Wa) => {
  var _Xa = _Wa, { $selected: e14, $primary: t10 } = _Xa, n10 = __objRest(_Xa, ["$selected", "$primary"]);
  return n10;
} }))), AK.mapOfLens(AK.prop("ReportSections", AK.array({ f: (e14) => e14, frev: (_Ya) => {
  var _Za = _Ya, { $active: e14 } = _Za, t10 = __objRest(_Za, ["$active"]);
  return t10;
} })))), rd({ $paramsView: null, $conversionInfo: null, $index: {}, $masterReportContent: null, $masterReport: null, $currentLayerName: "default" }), AK.mapOfLens(nX()), nd({ $displayType: { Prop: "DisplayType", Decoder: VK("Page", _K("Page", "Galley")) }, $sizeType: { Prop: "SizeType", Decoder: od("Default", VK("Default", RK("Default", "FitToPage", "FitToWidth"))) }, $viewerType: { Prop: "ViewerType", Decoder: VK("Dashboard", _K("Dashboard")) }, $collapseWhiteSpace: { Prop: "CollapseWhiteSpace", Decoder: sX() } }), MK((e14) => {
  const t10 = ["_web_designer_model_id", "_web_designer_model_version", "Theme", "DataSourceLinks", "DataSetLinks"];
  return __spreadProps(__spreadValues({}, e14), { CustomProperties: e14.CustomProperties.filter((e15) => e15 && !t10.includes(e15.Name)) });
}, (e14) => e14), kK((__a) => {
  var _$a = __a, { DataSets: e14 } = _$a, t10 = __objRest(_$a, ["DataSets"]);
  var _a2;
  if (null == e14) return t10;
  let n10 = (_a2 = t10.CustomProperties) == null ? void 0 : _a2.slice();
  const r10 = e14.map((_b2) => {
    var _c2 = _b2, { $fieldsInfo: e15 } = _c2, t11 = __objRest(_c2, ["$fieldsInfo"]);
    const r11 = `${t11.Name}${iX}`;
    return n10 || (n10 = []), td(n10, r11, e15), t11;
  });
  return __spreadProps(__spreadValues({}, t10), { DataSets: r10, CustomProperties: n10 });
}, (_ab) => {
  var _bb = _ab, { DataSets: e14 } = _bb, t10 = __objRest(_bb, ["DataSets"]);
  var _a2;
  const n10 = ((_a2 = t10.CustomProperties) == null ? void 0 : _a2.slice()) || [];
  const r10 = e14 == null ? void 0 : e14.map((e15) => {
    var _a3;
    const t11 = `${e15.Name}${iX}`;
    const r11 = ((_a3 = n10 == null ? void 0 : n10.find((e16) => e16.Name === t11)) == null ? void 0 : _a3.Value) || "";
    return td(n10, t11, void 0), __spreadProps(__spreadValues({}, e15), { $fieldsInfo: r11 });
  });
  return __spreadProps(__spreadValues({}, t10), { DataSets: r10, CustomProperties: n10 });
}), MK((e14) => __spreadProps(__spreadValues({}, e14), { Language: e14.Language || "Default" }), (e14) => __spreadProps(__spreadValues({}, e14), { Language: "Default" === e14.Language ? "" : e14.Language })), IU);
const pX = FZ.resultOf(ld.decode({ Name: "" }));
FZ.resultOf(sd.decode({ Name: "" }));
const mX = { createLink: ({ id: e14, version: t10, type: n10 }) => e14, parseLink: (e14) => ({ id: e14, version: null, type: null }) };
const hX = __spreadValues({}, mX);
const fX = "report", gX = "image", yX = "theme";
const vX = (e14, t10, n10) => hX.createLink({ id: e14, version: t10, type: n10 });
const bX = (e14) => vX(e14, null, gX);
const SX = (e14) => vX(e14, null, yX) || "";
const CX = (e14) => vX(e14, null, fX);
const xX = (e14) => hX.parseLink(e14);
const wX = { reportItems: void 0, reportItemsFeatures: { barcode: { symbologies: void 0, hideUnsupportedBarcodeJSProperties: false }, chart: { canUseWizard: true }, table: { autoFillHeader: true, autoFillFooter: false, canMergeCellsVertically: true, hideFrozenRowsColumns: void 0 }, tablix: { crossAggregates: true, autoFillCorner: true, canUseWizard: true, hideFrozenRowsColumns: void 0 } }, lockLayout: false, filterProperties: void 0, dataTab: { visible: true, dataSources: { visible: true, canModify: false }, dataSets: { visible: true, canModify: false }, parameters: { visible: true, canModify: true }, commonValues: { visible: true } }, openDataSourceEditor: void 0, dataSetPicker: { mode: "Panel", open: void 0, close: void 0 }, reportProvider: { label: void 0, open: void 0 }, imageProvider: { label: void 0, open: void 0 }, themeProvider: { label: void 0, open: void 0 } };
let TX = wX;
const EX = (e14) => {
  const { serverApi: t10, reportItems: n10, reportItemsFeatures: r10, lockLayout: o10, dataTab: a10, reportProvider: i10, imageProvider: s10, themeProvider: l10, filterProperties: c10, customInitTemplates: u10, customExpressionFunctions: d10, customExpressionCommonValues: p10, expressionSyntax: m10, rulers: h10 } = e14;
  var f10;
  f10 = ((e15) => {
    const t11 = e15 || {};
    return { createLink: t11.createResourceLink, parseLink: t11.parseResourceLink };
  })(t10), f10 && "function" == typeof f10.createLink && "function" == typeof f10.parseLink ? (hX.createLink = f10.createLink, hX.parseLink = f10.parseLink) : Object.assign(hX, mX), ((e15) => {
    if (e15) for (const t11 in e15) f$.hasOwnProperty(t11) && ("function" == typeof e15[t11] ? f$[t11] = e15[t11] : f$[t11] = g$(t11));
  })(t10), TX = zV.merge({}, wX, { reportItems: n10, reportItemsFeatures: r10, lockLayout: o10, dataTab: a10, reportProvider: i10, imageProvider: s10, themeProvider: l10, filterProperties: "function" == typeof c10 ? c10 : void 0, customExpressionFunctions: d10, customExpressionCommonValues: p10, expressionSyntax: m10, customInitTemplates: u10, rulers: h10 });
};
const FX = () => !!TX.lockLayout;
const MX = () => !!TX.dataTab.dataSources.canModify;
const kX = () => TX.reportProvider && zV.isFunction(TX.reportProvider.open) ? TX.reportProvider : null;
const PX = () => TX.imageProvider && zV.isFunction(TX.imageProvider.open) ? TX.imageProvider : null;
const NX = () => TX.themeProvider && zV.isFunction(TX.themeProvider.open) ? TX.themeProvider : null;
const DX = () => TX.customExpressionFunctions || [];
const LX = () => TX.customExpressionCommonValues || [];
const HX = () => "i11n" === TX.expressionSyntax;
function IX(e14, t10) {
  return hG().t(`components:dataPanel.commonValues.${e14}`, t10);
}
function _X(e14, t10, n10 = null, r10 = "") {
  return { name: e14, preview: r10, expr: t10, $localizeExpr: n10 };
}
function VX(e14, t10) {
  return { pageNumber: e14, totalPages: t10 };
}
const RX = { CurrentDateAndTime: _X("currentDateTime", "Globals!ExecutionTime"), PageNumber: _X("pageNumber", "Globals!PageNumber"), TotalPages: _X("totalPages", "Globals!TotalPages"), PageNM: _X("pageNM", "pageNofMLabel", { params: VX("Globals!PageNumber", "Globals!TotalPages") }), PageNumberSection: _X("pageNumberSection", "Globals!PageNumberInSection"), TotalPagesSection: _X("totalPagesSection", "Globals!TotalPagesInSection"), PageNMSection: _X("pageNMSection", "pageNofMLabel", { params: VX("Globals!PageNumberInSection", "Globals!TotalPagesInSection") }), PageNumberCumulative: _X("pageNumberCumulative", "Globals!CumulativePageNumber"), TotalPagesCumulative: _X("totalPagesCumulative", "Globals!CumulativeTotalPages"), PageNMCumulative: _X("pageNMCumulative", "pageNofMLabel", { params: VX("Globals!CumulativePageNumber", "Globals!CumulativeTotalPages") }), ReportName: _X("reportName", "Globals!ReportName"), UserId: _X("userId", "User!UserID"), UserLanguage: _X("userLanguage", "User!Language") };
function AX({ expr: e14, $localizeExpr: t10, name: n10, preview: r10 }) {
  let o10 = e14;
  if (!!t10) {
    o10 = IX(e14, t10.params || null);
  }
  return { Name: IX(n10), Preview: r10, Expr: o10, Key: n10 };
}
const OX = ["CurrentDateAndTime", "PageNumber", "TotalPages", "PageNM", "ReportName", "UserId", "UserLanguage"];
const BX = ["CurrentDateAndTime", "PageNumber", "TotalPages", "PageNM", "PageNumberCumulative", "TotalPagesCumulative", "PageNMCumulative", "ReportName", "UserId", "UserLanguage"];
const zX = ["CurrentDateAndTime", "PageNumber", "TotalPages", "PageNM", "PageNumberSection", "TotalPagesSection", "PageNMSection", "ReportName", "UserId", "UserLanguage"];
const $X = ["CurrentDateAndTime", "PageNumberSection", "TotalPagesSection", "PageNMSection", "ReportName", "UserId", "UserLanguage"];
const WX = (e14) => {
  switch (e14) {
    case "fixedpagereport":
      return BX;
    case "multisectionreport":
      return zX;
    case "dashboard":
      return $X;
    default:
      return OX;
  }
};
const jX = (e14) => ((e15, t10) => e15.map(t10).filter((e16) => null != e16))(e14 || [], (e15) => RX[e15]).map(AX);
function ZX(e14) {
  return function(e15, t10) {
    const n10 = t10.map(({ key: e16, value: t11 }) => AX(_X(e16, t11)));
    return [...e15, ...n10];
  }(jX(WX(e14)), LX());
}
const GX = /^(Globals|User)!(.*)$/;
function UX(e14) {
  const t10 = jX(WX(e14)).map((e15) => e15.Expr).map((e15) => {
    const t11 = GX.exec(e15);
    return t11 && 3 === t11.length ? `${t11[1]}.${t11[2]}`.toLowerCase() : null;
  }).filter(Boolean);
  return [...t10, ...LX().map((e15) => e15.value.toLowerCase())];
}
const qX = { key: "path", value: "DocumentMap.Path" };
const YX = (e14) => !e14 || e14.$isFallback ? [] : [...Object.keys(e14.Fonts.MinorFont).map((e15) => `theme.fonts.minorfont.${e15}`.toLowerCase()), ...Object.keys(e14.Fonts.MajorFont).map((e15) => `theme.fonts.majorfont.${e15}`.toLowerCase()), ...Object.keys(e14.Colors).map((e15) => `theme.colors.${e15}`.toLowerCase())];
const KX = (e14, t10) => [...UX(e14), ...YX(t10), qX.value.toLowerCase()];
const XX = [{ key: "dateAdd", value: "DateAdd()" }, { key: "dateDiff", value: "DateDiff()" }, { key: "datePart", value: "DatePart()" }, { key: "dateSerial", value: "DateSerial()" }, { key: "dateString", value: "DateString()" }, { key: "dateValue", value: "DateValue()" }, { key: "day", value: "Day()" }, { key: "hour", value: "Hour()" }, { key: "minute", value: "Minute()" }, { key: "month", value: "Month()" }, { key: "monthName", value: "MonthName()" }, { key: "now", value: "Now()" }, { key: "second", value: "Second()" }, { key: "timeOfDay", value: "TimeOfDay()" }, { key: "timer", value: "Timer()" }, { key: "timeSerial", value: "TimeSerial()" }, { key: "timeString", value: "TimeString()" }, { key: "timeValue", value: "TimeValue()" }, { key: "today", value: "Today()" }, { key: "weekday", value: "Weekday()" }, { key: "weekdayName", value: "WeekdayName()" }, { key: "quarter", value: "Quarter()" }, { key: "quarterName", value: "QuarterName()" }, { key: "year", value: "Year()" }, { key: "addYears", value: ".AddYears()" }, { key: "addMonths", value: ".AddMonths()" }, { key: "addDays", value: ".AddDays()" }, { key: "addHours", value: ".AddHours()" }, { key: "addMinutes", value: ".AddMinutes()" }, { key: "addSeconds", value: ".AddSeconds()" }, { key: "addMilliseconds", value: ".AddMilliseconds()" }, { key: "parse", value: "DateTime.Parse()" }];
const JX = [{ key: "abs", value: "Abs()" }, { key: "acos", value: "Acos()" }, { key: "asin", value: "Asin()" }, { key: "atan", value: "Atan()" }, { key: "atan2", value: "Atan2()" }, { key: "bigMul", value: "BigMul()" }, { key: "ceiling", value: "Ceiling()" }, { key: "cos", value: "Cos()" }, { key: "cosh", value: "Cosh()" }, { key: "e", value: "E" }, { key: "exp", value: "Exp()" }, { key: "fix", value: "Fix()" }, { key: "floor", value: "Floor()" }, { key: "ieeeRemainder", value: "IEEERemainder()" }, { key: "log", value: "Log()" }, { key: "log10", value: "Log10()" }, { key: "max", value: "Max()" }, { key: "min", value: "Min()" }, { key: "pi", value: "PI" }, { key: "pow", value: "Pow()" }, { key: "round", value: "Round()" }, { key: "sign", value: "Sign()" }, { key: "sin", value: "Sin()" }, { key: "sinh", value: "Sinh()" }, { key: "sqrt", value: "Sqrt()" }, { key: "tan", value: "Tan()" }, { key: "tanh", value: "Tanh()" }, { key: "truncate", value: "Truncate()" }];
const QX = [{ key: "contains", value: ".Contains()" }, { key: "endsWith", value: ".EndsWith()" }, { key: "inStr", value: "InStr()" }, { key: "lastIndexOf", value: ".LastIndexOf()" }, { key: "replace", value: ".Replace()" }, { key: "startsWith", value: ".StartsWith()" }, { key: "substring", value: ".Substring()" }, { key: "toLower", value: ".ToLower()" }, { key: "toUpper", value: ".ToUpper()" }, { key: "trim", value: ".Trim()" }, { key: "trimEnd", value: ".TrimEnd()" }, { key: "trimStart", value: ".TrimStart()" }];
const eJ = [{ key: "isArray", value: "IsArray()" }, { key: "isDate", value: "IsDate()" }, { key: "isDBNull", value: "IsDBNull()" }, { key: "isError", value: "IsError()" }, { key: "isNothing", value: "IsNothing()" }, { key: "isNumeric", value: "IsNumeric()" }, { key: "dbNull", value: "DBNull.Value" }];
const tJ = [{ key: "choose", value: "Choose()" }, { key: "iif", value: "IIF()" }, { key: "partition", value: "Partition()" }, { key: "switch", value: "Switch()" }];
const nJ = [{ key: "aggregateIf", value: "AggregateIf()" }, { key: "aggregateIfWithScope", value: "AggregateIf()" }, { key: "avg", value: "Avg()" }, { key: "avgWithScope", value: "Avg()" }, { key: "count", value: "Count()" }, { key: "countWithScope", value: "Count()" }, { key: "countDistinct", value: "CountDistinct()" }, { key: "countDistinctWithScope", value: "CountDistinct()" }, { key: "countRows", value: "CountRows()" }, { key: "countRowsWithScope", value: "CountRows()" }, { key: "crossAggregate", value: "CrossAggregate()" }, { key: "cumulativeTotal", value: "CumulativeTotal()" }, { key: "distinctSum", value: "DistinctSum()" }, { key: "distinctSumWithScope", value: "DistinctSum()" }, { key: "first", value: "First()" }, { key: "firstWithScope", value: "First()" }, { key: "last", value: "Last()" }, { key: "lastWithScope", value: "Last()" }, { key: "max", value: "Max()" }, { key: "maxWithScope", value: "Max()" }, { key: "median", value: "Median()" }, { key: "medianWithScope", value: "Median()" }, { key: "min", value: "Min()" }, { key: "minWithScope", value: "Min()" }, { key: "mode", value: "Mode()" }, { key: "modeWithScope", value: "Mode()" }, { key: "runningValue", value: "RunningValue()" }, { key: "runningValueWithScope", value: "RunningValue()" }, { key: "stDev", value: "StDev()" }, { key: "stDevWithScope", value: "StDev()" }, { key: "stDevP", value: "StDevP()" }, { key: "stDevPWithScope", value: "StDevP()" }, { key: "sum", value: "Sum()" }, { key: "sumWithScope", value: "Sum()" }, { key: "var", value: "Var()" }, { key: "varWithScope", value: "Var()" }, { key: "varP", value: "VarP()" }, { key: "varPWithScope", value: "VarP()" }];
const rJ = [{ key: "toBoolean", value: "ToBoolean()" }, { key: "toByte", value: "ToByte()" }, { key: "toChar", value: "ToChar()" }, { key: "toDateTime", value: "ToDateTime()" }, { key: "toDecimal", value: "ToDecimal()" }, { key: "toDouble", value: "ToDouble()" }, { key: "toInt16", value: "ToInt16()" }, { key: "toInt32", value: "ToInt32()" }, { key: "toInt64", value: "ToInt64()" }, { key: "toSingle", value: "ToSingle()" }, { key: "toStringKey", value: "ToString()" }, { key: "toStringDot", value: ".ToString()" }, { key: "toUInt16", value: "ToUInt16()" }, { key: "toUInt32", value: "ToUInt32()" }, { key: "toUInt64", value: "ToUInt64()" }, { key: "format", value: "Format()" }];
const oJ = [{ key: "getFields", value: "GetFields()" }, { key: "inScope", value: "InScope()" }, { key: "level", value: "Level()" }, { key: "levelWithScope", value: "Level()" }, { key: "lookup", value: "Lookup()" }, { key: "lookupSet", value: "LookupSet()" }, { key: "previous", value: "Previous()" }, { key: "previousWithScope", value: "Previous()" }, { key: "rowNumber", value: "RowNumber()" }, { key: "rowNumberWithScope", value: "RowNumber()" }, { key: "groupIndex", value: "GroupIndex()" }, { key: "groupIndexWithScope", value: "GroupIndex()" }, { key: "getLength", value: ".GetLength()" }, { key: "item", value: ".Item()" }, { key: "join", value: "Join()" }, { key: "indexOf", value: "IndexOf()" }];
const aJ = { DateTimeFunctions: XX, MathFunctions: JX, TextFunctions: QX, InspectionFunctions: eJ, ProgramFlowFunctions: tJ, AggregateFunctions: nJ, ConversionFunctions: rJ, MiscellaneousFunctions: oJ };
const iJ = { ICON_SET: "IconSet", RANGE_BAR: "RangeBar", RANGE_BAR_PROGRESS: "RangeBarProgress", DATA_BAR: "DataBar", GRADIENT: "Gradient", HATCH: "Hatch", COLOR_SCALE_2: "ColorScale2", COLOR_SCALE_3: "ColorScale3" };
const sJ = Object.values(iJ);
const lJ = [".colors", ".images"];
const cJ = [...XX, ...JX, ...QX, ...eJ, ...tJ, ...nJ, ...rJ, ...oJ].map((e14) => e14.value);
const uJ = (e14 = "", t10, n10) => {
  let r10 = null;
  if (e14 ? r10 = t10.find((t11) => t11.$path === e14) : n10 && (r10 = t10.find((e15) => e15.name === n10)), !r10) return [];
  const o10 = t10.filter((e15) => UW(e15.type) && !((e16, t11) => e16.level < t11.level && e16.leftKey <= t11.leftKey && e16.rightKey >= t11.rightKey)(e15, r10));
  const a10 = [];
  return t10.forEach((e15) => {
    if ("textbox" !== e15.type) return;
    o10.some((t11) => t11.level < e15.level && t11.leftKey <= e15.leftKey && t11.rightKey >= e15.rightKey) || a10.push(e15.name);
  }), a10;
};
function dJ(e14, t10, n10, r10, o10) {
  var _a2;
  const { ReportParameters: a10 = [], DataSets: i10 = [], DataSources: s10 = [], NamedItems: l10 = [] } = t10;
  const c10 = uJ(r10, l10, o10);
  const u10 = s10.some((e15) => b$(e15));
  return { parameters: a10.map((e15) => e15.Name.toLowerCase()), constants: KX(e14, n10), fields: !!u10 || i10.flatMap((e15) => yK(e15).map((e16) => e16.Name.toLowerCase())), reportItems: c10.map((e15) => e15.toLowerCase()), themeImages: ((_a2 = n10 == null ? void 0 : n10.Images) != null ? _a2 : []).reduce((e15, t11) => (t11 == null ? void 0 : t11.Name) ? [...e15, t11.Name.toLowerCase()] : e15, []), functions: [...cJ, ...sJ, ...lJ, ...DX().map((e15) => e15.value)].map((e15) => {
    const t11 = e15.split(".");
    return t11[t11.length - 1];
  }).map((e15) => e15.replace(/\(\)/g, "").toLowerCase()).filter((e15, t11, n11) => n11.indexOf(e15) === t11), semanticMode: u10 };
}
const pJ = -8, mJ = -7, hJ = -6, fJ = -5, gJ = -4, yJ = -3, vJ = -2, bJ = -1, SJ = 0;
const CJ = /^(Fields|Parameters|ReportItems)[.!]([^.!]+)(?:[.!](.*))?/i;
const xJ = (e14, t10) => {
  if (0 === e14.length) return zY.success();
  return { isValid: !e14.some((e15) => "error" === e15.level), messages: e14.map((e15) => function(e16, t11) {
    const { code: n10, details: r10, level: o10, customArgs: a10 } = e16;
    const i10 = "i11n" === t11;
    const s10 = (r10 == null ? void 0 : r10.token) || (a10 == null ? void 0 : a10.token) || "";
    const l10 = () => {
      const e17 = CJ.exec(s10);
      return i10 && e17 ? e17[2] : s10;
    };
    const c10 = r10 && !i10 ? { line: r10.position.line + 1, column: r10.position.column + 1 } : void 0;
    const u10 = (t12, n11) => ({ level: e16.level, valueType: "expression", key: t12, args: n11, positionInfo: c10 });
    switch (n10) {
      case pJ:
        return u10("unknownFunction", { token: s10 });
      case mJ:
        return u10("disabledReportItems", { token: l10() });
      case hJ:
        return u10("disabledFields", { token: l10() });
      case gJ:
        return u10("parseError", { token: s10 });
      case fJ:
        return u10("unknownThemeImage", { token: l10() });
      case yJ:
        return u10("unknownReportItem", { token: l10() });
      case vJ:
        return u10("unknownParameter", { token: l10() });
      case bJ:
        return u10("unknownField", { token: l10() });
      case SJ:
        return u10("error" === o10 ? "syntaxError" : "warning", { token: s10 });
      default:
        return u10("unknown", { token: s10 });
    }
  }(e15, t10)) };
};
const wJ = (e14, t10, n10 = "", r10) => ({ code: t10, level: e14, message: n10, customArgs: r10 });
const TJ = (e14, t10) => {
  if (!t10) return null;
  if (t10.semanticMode) return null;
  const { fields: n10 } = t10;
  if (false === n10) return wJ("warning", hJ, "", { token: e14 });
  return (Array.isArray(n10) ? n10.includes(e14.toLowerCase()) : !!n10) ? null : wJ("warning", bJ, "", { token: e14 });
};
const EJ = (e14, t10) => {
  const { parameters: n10, reportItems: r10, functions: o10 } = t10 || { parameters: [], reportItems: [] };
  const a10 = [];
  switch (e14.type) {
    case "field": {
      const n11 = TJ(e14.fieldName, t10);
      n11 && a10.push(n11);
      break;
    }
    case "parameter":
      Array.isArray(n10) && !n10.includes(e14.name.toLowerCase()) && a10.push(wJ("warning", vJ, "", { token: e14.name }));
      break;
    case "reportitem":
      Array.isArray(r10) && !r10.includes(e14.name.toLowerCase()) ? a10.push(wJ("warning", yJ, "", { token: e14.name })) : false === r10 && a10.push(wJ("warning", mJ, "", { token: e14.name }));
      break;
    case "unary":
      a10.push(...EJ(e14.operand, t10));
      break;
    case "binary":
      a10.push(...EJ(e14.leftOperand, t10)), a10.push(...EJ(e14.rightOperand, t10));
      break;
    case "infix":
      e14.operands.forEach((e15) => {
        a10.push(...EJ(e15, t10));
      });
      break;
    case "fn":
      (o10 == null ? void 0 : o10.every((t11) => e14.funcName.toLowerCase() !== t11)) && a10.push(wJ("warning", pJ, "", { token: e14.funcName })), e14.args.forEach((e15) => {
        a10.push(...EJ(e15, t10));
      });
      break;
    case "method":
      (o10 == null ? void 0 : o10.every((t11) => e14.methodName.toLowerCase() !== t11)) && a10.push(wJ("warning", pJ, "", { token: e14.methodName }));
  }
  return a10;
};
function FJ(e14, t10) {
  var _a2, _b2;
  const { defaultValue: n10, itemTypes: r10 = [], validationContext: o10, expressionSyntax: a10, units: i10, descriptor: s10 } = t10;
  const { extraValidator: l10 } = o10;
  let c10 = zY.success();
  if ("invalid" === e14.type) c10 = xJ(e14.errors, a10);
  else if ("const" === e14.type) c10 = aK((_b2 = (_a2 = e14.value) == null ? void 0 : _a2.toString()) != null ? _b2 : "", { units: i10 }, { descriptor: s10, defaultValue: n10, itemTypes: r10 });
  else if ("field" === e14.type) {
    const t11 = TJ(e14.fieldName, o10);
    c10 = t11 ? xJ([t11], a10) : zY.success();
  } else if ("expression" === e14.type) {
    const t11 = [];
    e14.pieces.forEach((e15) => {
      "ex" === e15.type && t11.push(...EJ(e15.expression, o10));
    }), c10 = xJ(t11, a10);
  }
  return "function" == typeof l10 && (c10 = l10(e14, c10)), c10;
}
const MJ = (e14, { expressionSyntax: t10 }, n10) => {
  const r10 = fc(t10, e14);
  if ("expression" === r10.type || "field" === r10.type) return mu("rdl", r10);
  const o10 = "const" === r10.type ? String(r10.value) : e14 != null ? e14 : "";
  return o10.startsWith("=") ? `="${o10}"` : n10(o10);
};
const kJ = (e14) => (t10, n10, r10, o10) => MJ(t10, n10, (t11) => pK(t11, e14, n10, r10, o10));
const PJ = { number_expr: kJ("number"), length_expr: kJ("length"), boolean_expr: kJ("boolean"), string_expr: kJ("string"), html_expr: kJ("string"), color_expr: kJ("color"), percent_expr: kJ("percent"), enum_expr: kJ("enum"), font_size_expr: kJ("length"), format: kJ("string"), dvchart_plot_rule_condition: kJ("string"), border_style: kJ("line_style"), font_family: (e14, t10) => MJ(e14, t10, (e15) => e15 || "Arial"), theme_uri: kJ("string"), theme_uri_legacy: kJ("string"), dataset_query: kJ("string"), text_decoration: kJ("enum") };
function NJ(e14, t10, n10, r10, o10) {
  return t10 in PJ ? PJ[t10](e14, n10, r10, o10) : _O(t10) ? MJ(e14, n10, (e15) => {
    const n11 = ((e16, t11) => {
      let n12;
      if (t11) switch (e16) {
        case "mime_type":
          n12 = t11 == null ? void 0 : t11.imageMimeTypes;
          break;
        case "language": {
          const e17 = t11 == null ? void 0 : t11.reportLanguages;
          n12 = e17 == null ? void 0 : e17.map((e18) => e18.value);
          break;
        }
      }
      return n12 || VO(e16);
    })(t10, r10);
    return uK(e15, n11);
  }) : pK(e14, t10, n10, r10, o10);
}
const DJ = (e14) => (t10, { expressionSyntax: n10 }, r10, o10) => {
  let a10 = t10;
  if ("string" == typeof t10) {
    if (t10.startsWith("=")) {
      return mu(n10, fc("rdl", t10));
    }
    "i11n" === n10 && (a10 = uu(a10));
  }
  return hK(a10, e14, void 0, r10, o10);
};
const LJ = { number_expr: DJ("number"), length_expr: DJ("length"), boolean_expr: DJ("boolean"), string_expr: DJ("string"), html_expr: DJ("string"), color_expr: DJ("color"), percent_expr: DJ("percent"), enum_expr: DJ("enum"), mime_type: DJ("enum"), font_size_expr: DJ("length"), language: DJ("enum"), format: DJ("string"), dvchart_plot_rule_condition: DJ("string"), border_style: DJ("line_style"), font_family: DJ("string"), background_image: DJ("string"), theme_uri: DJ("string"), theme_uri_legacy: DJ("string"), dataset_query: DJ("string"), text_decoration: DJ("enum"), image_data_advanced: DJ("string") };
function HJ(e14, t10, n10, r10, o10 = "") {
  return sK(e14) ? o10 : t10 in LJ ? LJ[t10](e14, n10, r10, o10) : hK(e14, t10, n10, r10, o10);
}
const IJ = (e14) => `tablixMember.${e14}`;
const _J = [EY.DataElementName, EY.DataElementOutput, Zq(cY, "reportItem.keepTogether", "boolean", "KeepTogether", "both"), EY.Visibility];
const VJ = [Zq(sY, IJ("groupEnabled"), "tablix_member_type", ""), Zq(cY, IJ("keepWithGroup"), "enum", "KeepWithGroup", void 0, { enumKey: "keep_with_group" }), Zq(cY, IJ("repeatOnNewPage"), "boolean", "RepeatOnNewPage")].concat(_J);
const RJ = [Zq(sY, IJ("groupEnabled"), "tablix_member_type", ""), MY.Name, MY.GroupExpressions, MY.PageBreakWithBetween, Zq(sY, "group.newPage", "tablix_member_new_page", "Group.NewPage", void 0, { enumKey: "new_page" }), MY.PageBreakDisabled, MY.Parent, MY.DocumentMapLabel, MY.DataElementName, MY.DataElementOutput, MY.NewSection, MY.Filters, MY.PrintFooterAtBottom, FY.SortExpressions].concat(_J);
const AJ = FZ.resultOf(wq.decode({ Type: "tablix", Name: "tablix1", ColumnHierarchy: { Members: [{}, { Group: {} }] } }));
const OJ = AJ.ColumnHierarchy.Members[0];
const BJ = AJ.ColumnHierarchy.Members[1];
function zJ(e14 = null, t10 = null, n10 = [], r10 = 1, o10) {
  return e14 ? __spreadProps(__spreadValues({}, BJ), { Group: __spreadValues(__spreadValues({}, BJ.Group), e14), Header: t10 ? __spreadValues(__spreadValues({}, BJ.Header), t10) : null, Children: n10, BodyCount: r10, BodyIndex: o10 }) : __spreadProps(__spreadValues({}, OJ), { Header: t10 ? __spreadValues(__spreadValues({}, OJ.Header), t10) : null, Children: n10, BodyCount: r10, BodyIndex: o10 });
}
const $J = { type: "statictablixmember", labelKey: "reportItems:tablixMember", defaultModel: OJ, getProperties: () => VJ };
const WJ = { type: "dynamictablixmember", labelKey: "reportItems:tablixMember", defaultModel: BJ, getProperties: (e14, t10, n10) => (n10 == null ? void 0 : n10.isDashboard) ? RJ.filter((e15) => "Group.PageBreak" !== e15.valuePath) : RJ };
function jJ(e14) {
  return !e14 || 0 === Object.getOwnPropertyNames(e14).length;
}
function ZJ(e14) {
  return e14 && e14.Header && (e14.Header.LevelCount || 1) || 0;
}
function GJ(e14) {
  return e14 && e14.BodyCount || 1;
}
function UJ(e14) {
  return e14 && zV.isArray(e14.Children) && e14.Children.length || 0;
}
function qJ(e14) {
  return e14 && !e14.Group;
}
function YJ(e14) {
  return e14 && !e14.Header;
}
function KJ(e14) {
  for (let t10 = e14.length - 1; t10 >= 0; t10--) if (e14[t10].Group) return e14.slice(0, t10 + 1);
  return null;
}
function XJ(e14, t10) {
  const n10 = (e15, r10) => {
    const o10 = ZJ(e15);
    const a10 = r10 === t10 || o10 > 1 && r10 + o10 > t10;
    const i10 = e15.Children && e15.Children.length > 0;
    if (a10 && (o10 > 0 || !i10)) return [e15];
    if (i10) {
      const t11 = n10(e15.Children[0], r10 + o10);
      if (t11) return t11.unshift(e15), t11;
    }
    return null;
  };
  return n10(e14[0], 0);
}
function JJ(e14, t10) {
  let n10;
  for (n10 = 0; n10 < e14.length; n10++) {
    const r10 = e14[n10];
    if (r10.Group && r10.Group.Name === t10) return [r10];
    if (r10.Header && r10.Header.Item && r10.Header.Item.Name === t10) return [r10];
    if (r10.BodyIndex === t10) return [r10];
    if (Array.isArray(r10.Children)) {
      const e15 = JJ(r10.Children, t10);
      if (e15.length > 0) return e15.unshift(r10), e15;
    }
  }
  return [];
}
const QJ = (e14, t10) => {
  const n10 = ((e15, t11, n11 = (e16) => true) => {
    const r11 = (e16) => {
      const o10 = e16.reduce((e17, o11) => (t11(o11) && e17.push(o11), n11(o11) && e17.push(...r11(o11.Children)), e17), []);
      return o10;
    };
    return r11(e15);
  })(e14[t10].Members, (e15) => e15 && (rj(e15) || e15.Header && rj(e15.Header.Item)) || false, (e15) => e15 && aj(e15) || false);
  if (1 !== n10.length) return false;
  const r10 = n10[0];
  return !!ij(r10) && r10;
};
const eQ = (e14, t10, n10) => {
  const r10 = ((e15) => !(!e15 || "dynamictablixmember" !== e15.Type) && !(!e15.Header && e15.Children.length > 0))((n10 || QJ)(e14, t10));
  return !!r10;
};
const tQ = (e14, t10, n10) => {
  const r10 = ((n11) => {
    if (!n11 || "statictablixmember" !== n11.Type) return false;
    if (t10 === uZ.ROW) return true;
    const { start: r11, end: o10 } = yQ(n11);
    const a10 = e14.Body.Rows.some((e15) => {
      if (!e15.Cells[r11]) return true;
      for (let t11 = r11; t11 <= o10; t11++) if (e15.Cells[t11]) return t11 + e15.Cells[t11].ColSpan > o10 + 1;
      return false;
    });
    return !a10;
  })((n10 || QJ)(e14, t10));
  return !!r10;
};
function nQ(e14, t10) {
  const n10 = new Array(t10);
  const r10 = (e15) => {
    e15.forEach((e16) => {
      ((e17) => {
        const n11 = (e17.Children || []).length > 0;
        const r11 = e17.BodyIndex;
        return !n11 && "number" == typeof r11 && r11 >= 0 && r11 < t10;
      })(e16) ? n10[e16.BodyIndex] = e16 : r10(e16.Children || []);
    });
  };
  if (r10(e14), n10.some((e15) => !e15)) throw new Error("Invalid hierarchy members leaves");
  return n10;
}
function rQ(e14, t10, n10, r10) {
  const o10 = r10 && r10.searchInBody || false;
  const a10 = r10 && r10.searchInCorner || false;
  if (!t10 || !e14[t10]) throw new Error("Invalid hierarchy name");
  if (!zV.isFunction(n10)) throw new Error("Invalid predicate for locate members");
  let i10 = [];
  const s10 = cQ(e14[t10].Members, n10);
  return s10 && i10.push(s10), o10 && (i10 = i10.concat(function(e15, t11, n11) {
    const r11 = e15[t11];
    for (let o11 = 0; o11 < e15.Body.Rows.length; o11++) for (let a11 = 0; a11 < e15.Body.Rows[o11].Cells.length; a11++) {
      const i11 = e15.Body.Rows[o11].Cells[a11];
      if (n11(i11) && i11 && i11.Item && rj(i11.Item)) {
        const [e16, n12] = t11 === uZ.COLUMN ? [a11, a11 + i11.ColSpan - 1] : [o11, o11 + i11.RowSpan - 1];
        const s11 = [];
        for (let t12 = e16; t12 <= n12; t12++) {
          const e17 = JJ(r11.Members, t12);
          s11.push(e17);
        }
        return s11;
      }
    }
    return [];
  }(e14, t10, n10))), a10 && (i10 = i10.concat(function(e15, t11, n11) {
    var _a2;
    if (!((_a2 = e15 == null ? void 0 : e15.Corner) == null ? void 0 : _a2.length)) return [];
    const r11 = e15[t11];
    for (let o11 = 0; o11 < e15.Corner.length; o11++) {
      const a11 = e15.Corner[o11];
      for (let e16 = 0; e16 < a11.length; e16++) {
        const i11 = a11[e16];
        if (n11(i11) && i11 && i11.Item && rj(i11.Item)) {
          const [n12, a12] = t11 === uZ.COLUMN ? [o11, o11 + i11.RowSpan - 1] : [e16, e16 + i11.ColSpan - 1];
          const s11 = [];
          for (let e17 = n12; e17 <= a12; e17++) s11.push(XJ(r11.Members, e17));
          return s11;
        }
      }
    }
    return [];
  }(e14, t10, n10))), i10;
}
function oQ(e14, t10) {
  const n10 = [];
  for (let r10 = e14; r10 < e14 + t10; r10++) n10.push(r10);
  return n10;
}
function aQ(e14, t10) {
  if (!e14) throw new Error("Body cannot be null");
  if (t10 !== dZ.ROW && t10 !== dZ.COLUMN) throw new Error(`Invalid argument: orientation (${t10})`);
  const n10 = [];
  for (let r10 = 0; r10 < e14.Rows.length; r10++) for (let o10 = 0; o10 < e14.Rows[r10].Cells.length; o10++) {
    const a10 = e14.Rows[r10].Cells[o10];
    a10 && a10.Item && rj(a10.Item) && n10.push(t10 === dZ.ROW ? oQ(r10, a10.RowSpan) : oQ(o10, a10.ColSpan));
  }
  return zV.flatten(n10);
}
function iQ(e14) {
  if (!e14) throw new Error("Hierarchy members cannot be null");
  const t10 = yj(e14);
  const n10 = t10.map((t11) => JJ(e14, ((e15) => "dynamictablixmember" === e15.Type ? e15.Group.Name : "statictablixmember" === e15.Type ? e15.Header && e15.Header.Item.Name || e15.BodyIndex : e15.Name)(t11)));
  return zV.flatten(n10.map((e15) => {
    const t11 = yQ(e15[e15.length - 1]);
    return oQ(t11.start, t11.end - t11.start + 1);
  }));
}
function sQ(e14) {
  const t10 = [];
  return function e15(n10, r10) {
    n10.forEach((n11) => {
      if (oj(n11)) {
        const o10 = ZJ(n11);
        (rj(n11) || n11.Header && n11.Header.Item && rj(n11.Header.Item)) && t10.push(oQ(r10, o10)), n11.Children.length > 0 && e15(n11.Children, r10 + o10);
      }
    });
  }(e14, 0), zV.flatten(t10);
}
function lQ(e14) {
  return ij(e14.RowHierarchy) ? hZ.RowHierarchy : ij(e14.ColumnHierarchy) ? hZ.ColumnHierarchy : ij(e14.Body) ? hZ.Body : e14.Corner && e14.Corner.some((e15) => e15.some((e16) => ij(e16))) ? hZ.Corner : null;
}
function cQ(e14, t10) {
  if (!e14) throw new Error("Members cannot be null");
  if (!zV.isFunction(t10)) throw new Error("Invalid predicate");
  for (let n10 = 0; n10 < e14.length; n10++) {
    const r10 = e14[n10];
    if (t10(r10)) {
      if (rj(r10) || r10.Header && r10.Header.Item && rj(r10.Header.Item)) return [r10];
      if (Array.isArray(r10.Children)) {
        const e15 = cQ(r10.Children, t10);
        if (e15) return e15.unshift(r10), e15;
      }
    }
  }
  return null;
}
function uQ(e14, t10) {
  switch (lQ(e14)) {
    case hZ.Corner:
      return false;
    case hZ.Body:
      return true;
    case hZ.RowHierarchy:
      return t10 === dZ.ROW;
    case hZ.ColumnHierarchy:
      return t10 === dZ.COLUMN;
  }
  throw new Error("Primary area not found");
}
function dQ(e14, t10, n10, r10 = pZ.PARENT, o10 = null, a10 = true) {
  if (t10 < 0) throw new Error("Invalid atLevel arg");
  if (r10 !== pZ.PARENT && r10 !== pZ.CHILD) throw new Error("Invalid position arg");
  const i10 = (e15, t11) => t11 && t11.length > 0 && t11[0] === e15 ? t11 : null;
  return function e15(o11, s10, l10 = null) {
    const c10 = ZJ(o11);
    const u10 = "dynamictablixmember" === o11.Type && 0 === c10;
    if (!l10 && u10 && a10 && o11.Children.length) return AV(o11, { Children: { $set: o11.Children.map((t11) => e15(t11, s10)) } });
    if (l10 && l10.length > 1) {
      const t11 = l10.slice(1);
      return AV(o11, { Children: { $set: o11.Children.map((n11) => e15(n11, s10 + c10, i10(n11, t11))) } });
    }
    const d10 = l10 && 1 === l10.length;
    if (r10 === pZ.PARENT && (d10 || t10 === s10)) return n10(o11);
    if (s10 + c10 > t10) return AV(o11, { Header: { LevelCount: { $set: c10 + 1 } } });
    if (r10 === pZ.CHILD && (d10 || s10 + c10 === t10)) {
      const e16 = [n10(o11)];
      return AV(o11, { Children: { $set: e16 } });
    }
    return Array.isArray(o11.Children) && 0 !== o11.Children.length ? AV(o11, { Children: { $set: o11.Children.map((t11) => e15(t11, s10 + c10)) } }) : (console.log("expected more children to perform insertion"), o11);
  }(e14, 0, i10(e14, o10));
}
function pQ(e14, { r: t10, c: n10 }) {
  if (e14[t10][n10]) return { r: t10, c: n10 };
  for (let r10 = t10; r10 >= 0; r10--) for (let o10 = n10; o10 >= 0; o10--) {
    const a10 = e14[r10][o10];
    if (!a10) continue;
    const i10 = a10.ColSpan || 1;
    const s10 = a10.RowSpan || 1;
    if (r10 <= t10 && r10 + s10 > t10 && o10 <= n10 && o10 + i10 > n10) return { r: r10, c: o10 };
  }
  throw new Error("Cannot find corner cell parent");
}
function mQ(e14, t10) {
  return e14.r === t10.r && e14.c === t10.c;
}
function hQ(e14, t10, n10, r10, o10) {
  if (!(e14 == null ? void 0 : e14.length)) return r10 > 0 ? Array.from(new Array(r10)).map(() => [{ Item: n10(o10), RowSpan: 1, ColSpan: 1 }]) : e14;
  const a10 = [];
  for (let r11 = 0; r11 < e14.length; r11++) {
    const i10 = e14[r11];
    let s10 = [];
    a10.push(s10);
    let l10 = false;
    for (let n11 = 0; n11 < i10.length; n11++) {
      const o11 = i10[n11];
      if (s10.push(o11), n11 === t10 - 1 && n11 + 1 < i10.length) {
        const t11 = pQ(e14, { r: r11, c: n11 });
        if (mQ(t11, pQ(e14, { r: r11, c: n11 + 1 }))) {
          const n12 = e14[t11.r][t11.c];
          const r12 = n12.ColSpan || 1;
          if (r12 === (a10[t11.r][t11.c].ColSpan || 1)) {
            const e15 = AV(n12, { ColSpan: { $set: r12 + 1 } });
            const o12 = AV(a10[t11.r], { $splice: [[t11.c, 1, e15]] });
            a10.splice(t11.r, 1, o12), s10 = a10[a10.length - 1];
          }
          l10 = true, s10.push(null);
        }
      }
    }
    l10 || s10.splice(t10, 0, { Item: n10(o10), RowSpan: 1, ColSpan: 1 });
  }
  return a10;
}
function fQ(e14, t10, n10, r10, o10) {
  if (!(e14 == null ? void 0 : e14.length)) return r10 > 0 ? [Array.from(new Array(r10)).map(() => ({ Item: n10(o10), RowSpan: 1, ColSpan: 1 }))] : e14;
  const a10 = [];
  const i10 = Array.from(new Array(e14[0].length)).fill(false);
  for (let n11 = 0; n11 < e14.length; n11++) {
    const r11 = e14[n11];
    let o11 = [];
    a10.push(o11);
    for (let s11 = 0; s11 < r11.length; s11++) {
      const l10 = r11[s11];
      if (o11.push(l10), n11 === t10 - 1 && n11 + 1 < e14.length) {
        const t11 = pQ(e14, { r: n11, c: s11 });
        if (mQ(t11, pQ(e14, { r: n11 + 1, c: s11 }))) {
          const n12 = e14[t11.r][t11.c];
          const r12 = n12.RowSpan || 1;
          if (r12 === (a10[t11.r][t11.c].RowSpan || 1)) {
            const e15 = AV(n12, { RowSpan: { $set: r12 + 1 } });
            const i11 = AV(a10[t11.r], { $splice: [[t11.c, 1, e15]] });
            a10.splice(t11.r, 1, i11), o11 = a10[a10.length - 1];
          }
          i10.splice(s11, 1, true);
        }
      }
    }
  }
  const s10 = i10.map((e15) => e15 ? null : { Item: n10(o10), RowSpan: 1, ColSpan: 1 });
  return a10.splice(t10, 0, s10), a10;
}
function gQ(e14, t10, n10, r10, o10) {
  function a10(e15) {
    if (e15 && e15.length > 0) {
      const t11 = e15[0];
      const n11 = a10(t11.Children);
      const r11 = ZJ(t11);
      return r11 > 0 ? [zJ(null, { Item: o10(), LevelCount: r11 }, n11)] : n11;
    }
    return [];
  }
  return CQ(function e15(i10, s10) {
    const l10 = t10[s10];
    const c10 = i10.indexOf(l10);
    if (c10 < 0) throw new Error(`Invalid path, member not found at ${s10}`);
    if (s10 < t10.length - 1) {
      const t11 = AV(l10, { Children: { $set: e15(l10.Children, s10 + 1) } });
      return AV(i10, { $splice: [[c10, 1, AV(t11, { BodyCount: { $set: GJ(l10) + 1 } })]] });
    }
    const u10 = ZJ(l10);
    const d10 = r10 && r10.apply && r10() || null;
    const p10 = u10 > 0 ? { Item: o10(), LevelCount: u10 } : null;
    const m10 = a10(l10.Children);
    const h10 = d10 || u10 > 0 || !SQ(m10) ? zJ(d10, p10, m10) : m10[0];
    const f10 = n10 === pZ.BEFORE ? c10 : c10 + 1;
    return AV(i10, { $splice: [[f10, 0, h10]] });
  }(e14, 0));
}
function yQ(e14) {
  let t10 = e14;
  let n10 = e14;
  for (; SQ(n10.Children); ) n10 = n10.Children[n10.Children.length - 1];
  for (; SQ(t10.Children); ) [t10] = t10.Children;
  const r10 = { start: t10 && t10.BodyIndex, end: n10 && n10.BodyIndex };
  if (r10.start >= 0 && r10.end >= 0) return r10;
  throw new Error("Failed to obtain body range");
}
function vQ(e14, { start: t10, end: n10 }, r10, o10 = pZ.BEFORE, a10 = 1, i10) {
  const s10 = o10 === pZ.BEFORE ? t10 : n10 + 1;
  const { cellHeight: l10 } = zq(i10);
  const c10 = Array.from(new Array(a10)).map((t11, n11) => ({ Height: l10, Cells: e14.Columns.map((e15, t12) => r10(s10 + n11, t12)) }));
  return AV(e14, { Rows: { $splice: [[s10, 0, ...c10]] } });
}
function bQ(e14, { start: t10, end: n10 }, r10, o10 = pZ.BEFORE, a10 = 1, i10) {
  const s10 = o10 === pZ.BEFORE ? t10 : n10 + 1;
  const l10 = e14.Rows.map((e15, t11) => {
    const n11 = [];
    let o11 = false;
    for (let t12 = 0; t12 < e15.Cells.length; t12++) {
      const r11 = e15.Cells[t12];
      const i11 = r11 && r11.ColSpan || 1;
      r11 && t12 < s10 && t12 + i11 > s10 ? (n11.push(AV(r11, { ColSpan: { $set: i11 + a10 } })), n11.push(...Array.from(new Array(a10)).fill(null)), o11 = true) : n11.push(r11);
    }
    if (!o11) {
      const e16 = Array.from(new Array(a10)).map((e17, n12) => r10(t11, s10 + n12));
      n11.splice(s10, 0, ...e16);
    }
    return AV(e15, { Cells: { $set: n11 } });
  });
  const { cellWidth: c10 } = zq(i10);
  const u10 = Array.from(new Array(a10)).map(() => c10);
  return AV(e14, { Columns: { $splice: [[s10, 0, ...u10]] }, Rows: { $set: l10 } });
}
function SQ(e14) {
  return e14 && Array.isArray(e14) && e14.length > 0;
}
function CQ(e14, t10 = 0) {
  let n10 = t10;
  const r10 = function e15(t11) {
    const r11 = {};
    return t11.forEach((t12, o10) => {
      if (SQ(t12.Children)) {
        const n11 = {};
        const a10 = e15(t12.Children);
        a10 && Object.assign(n11, { Children: a10 }), (t12.BodyIndex || 0 === t12.BodyIndex) && Object.assign(n11, { BodyIndex: { $set: -1 } }), jJ(n11) || Object.assign(r11, { [o10]: n11 });
      } else {
        const e16 = n10++;
        if (t12.BodyIndex === e16) return;
        Object.assign(r11, { [o10]: { BodyIndex: { $set: e16 } } });
      }
    }), jJ(r11) ? null : r11;
  }(e14);
  return null === r10 ? e14 : AV(e14, r10);
}
function xQ(e14) {
  function t10(e15) {
    return e15 ? (yj(e15) || []).length : 0;
  }
  if (!e14) return null;
  const n10 = t10(e14);
  if (n10 <= 1) return null;
  const r10 = Object.getOwnPropertyNames(hZ);
  for (let o10 = 0; o10 < r10.length; o10++) {
    const a10 = r10[o10];
    const i10 = t10(e14[a10]);
    if (i10 === n10) return a10;
    if (i10 > 0) return null;
  }
  return null;
}
function wQ(e14, t10 = zV.identity, n10 = zV.identity) {
  const r10 = {};
  const o10 = {};
  const a10 = [];
  const i10 = t10(e14);
  for (let e15 = 0; e15 < i10.length; e15++) {
    const t11 = n10(i10[e15]);
    for (let n11 = 0; n11 < t11.length; n11++) {
      const i11 = t11[n11];
      i11 && (rj(i11.Item) && (a10.push(i11), zV.isEmpty(r10) && (r10.rowIndex = e15, r10.cellIndex = n11), o10.rowIndex = Math.max(o10.rowIndex || 0, e15 + i11.RowSpan), o10.cellIndex = Math.max(o10.cellIndex || 0, n11 + i11.ColSpan)));
    }
  }
  return { start: r10, end: o10, selectedCells: a10 };
}
function TQ(e14) {
  return wQ(e14);
}
function EQ(e14) {
  return wQ(e14, (e15) => e15.Rows, (e15) => e15.Cells);
}
function FQ(e14) {
  const t10 = yj(e14).map((t11) => JJ(e14.Members, t11.Name));
  if (t10.some((e15) => !e15 || 0 === e15.length)) throw new Error("Invalid hierarchy members to be merged");
  return t10;
}
function MQ(e14) {
  const t10 = FQ(e14);
  const n10 = t10.map((e15) => e15[e15.length - 1]);
  const r10 = n10.filter((e15) => e15.Group).length > 1;
  const o10 = t10[0][t10[0].length - 2];
  return !r10 && (() => {
    const e15 = t10[0].length;
    for (let n11 = 1; n11 < t10.length; n11++) {
      const r11 = t10[n11];
      const a10 = r11.length;
      const i10 = r11[r11.length - 2];
      if (e15 !== a10 || o10 !== i10) return false;
    }
    return true;
  })() && (() => {
    const t11 = o10 && o10.Children || e14.Members;
    let r11 = null;
    for (let e15 = 0; e15 < t11.length; e15++) if (n10.includes(t11[e15])) {
      if (null !== r11 && e15 - r11 != 1) return false;
      r11 = e15;
    }
    return true;
  })();
}
function kQ(e14) {
  const t10 = FQ(e14);
  const n10 = t10.map((e15) => e15[e15.length - 1]);
  const r10 = t10.reduce((e15, t11) => t11.length < e15.length ? t11 : e15);
  const o10 = t10.reduce((e15, t11) => t11.length > e15.length ? t11 : e15);
  const a10 = r10[r10.length - 1];
  const i10 = o10[o10.length - 1];
  const s10 = t10.every((e15) => {
    for (let t11 = 0; t11 < e15.length; t11++) if (e15[t11] !== o10[t11]) return false;
    return true;
  });
  const l10 = n10.every((e15) => (e15 === a10 || !e15.Group) && !(e15 !== i10 && e15.Children.length > 1));
  return s10 && l10 && (() => {
    let e15 = a10;
    do {
      if (e15 = e15.Children[0], !n10.includes(e15)) return false;
    } while (e15 !== i10);
    return true;
  })();
}
const PQ = (e14, t10) => {
  const n10 = [];
  const r10 = t10 === hZ.ColumnHierarchy;
  const o10 = r10 ? e14.$rows.collection.length - e14.Body.Rows.length : e14.Body.Rows.length;
  for (let e15 = 0; e15 < o10; e15++) n10[e15] = [];
  const a10 = yj(e14);
  const i10 = [];
  VQ(e14, () => {
  }, (o11) => {
    var _a2, _b2;
    const { itemPath: s11, item: l11, cix: c11, rix: u11, cspan: d10, rspan: p10 } = o11;
    if (!(s11 && s11.indexOf(t10) >= 0 || false)) return;
    const m10 = r10 ? u11 : u11 - (((_a2 = e14 == null ? void 0 : e14.Corner) == null ? void 0 : _a2.length) || 0);
    const h10 = r10 ? c11 - (((_b2 = e14 == null ? void 0 : e14.Corner[0]) == null ? void 0 : _b2.length) || 0) : c11;
    for (let e15 = 0; e15 < d10; e15++) for (let t11 = 0; t11 < p10; t11++) n10[m10 + t11][h10 + e15] = { Name: l11.Name, cspan: d10 - e15, rspan: p10 - t11 };
    for (let e15 = 0; e15 < a10.length; e15++) a10[e15].Name === l11.Name && i10.push({ row: m10, col: h10, rspan: p10, cspan: d10 });
  });
  const s10 = r10 ? i10[0].col : i10[0].row;
  for (let e15 = 1; e15 < i10.length; e15++) if (s10 !== (r10 ? i10[e15].col : i10[e15].row)) return true;
  const l10 = Math.min(...i10.map((e15) => r10 ? e15.row : e15.col));
  const c10 = r10 ? n10[0].length : n10.length;
  let u10 = null;
  for (let e15 = 0; e15 < c10 && !u10; e15++) {
    if (e15 === s10) {
      u10 = false;
      continue;
    }
    const t11 = i10.reduce((e16, t12) => e16 + (r10 ? t12.rspan : t12.cspan), 0);
    for (let o11 = 0; o11 < t11; o11++) {
      if ((r10 ? n10[l10 + o11][e15].rspan : n10[e15][l10 + o11].cspan) > 1) {
        u10 = false;
        break;
      }
      u10 = true;
    }
  }
  return u10;
};
function NQ(e14) {
  const t10 = bj(e14);
  if (!t10) throw new Error("No primary leaf for split cells opertion");
  return Hj(t10) ? function(e15, t11) {
    function n10(e16) {
      const n11 = JJ(e16.Members, t11);
      if (n11 && n11.length > 0) {
        const e17 = n11[n11.length - 1];
        const t12 = ZJ(e17);
        if (GJ(e17) > 1 && e17.Children.length > 1 || t12 > 1) return { memberPath: n11 };
      }
      return null;
    }
    const r10 = function(e16) {
      for (let n11 = 0; n11 < e16.length; n11++) for (let r11 = 0; r11 < e16[n11].Cells.length; r11++) {
        const o11 = e16[n11].Cells[r11];
        if (o11 && o11.Item && o11.Item.Name === t11 && (o11.ColSpan || 1) > 1) return { rowIndex: n11, cellIndex: r11 };
      }
      return null;
    }(e15.Body.Rows);
    if (r10) return { area: hZ.Body, location: { rowIndex: r10.rowIndex, cellIndex: r10.cellIndex } };
    const o10 = function(e16) {
      if (!e16) return null;
      for (let n11 = 0; n11 < e16.length; n11++) for (let r11 = 0; r11 < e16[n11].length; r11++) {
        const o11 = e16[n11][r11];
        if (o11 && o11.Item && o11.Item.Name === t11 && ((o11.ColSpan || 1) > 1 || (o11.RowSpan || 1) > 1)) return { rowIndex: n11, cellIndex: r11 };
      }
      return null;
    }(e15.Corner);
    return o10 ? { area: hZ.Corner, location: { rowIndex: o10.rowIndex, cellIndex: o10.cellIndex } } : n10(e15.RowHierarchy) ? { area: hZ.RowHierarchy, location: { name: t11 } } : n10(e15.ColumnHierarchy) ? { area: hZ.ColumnHierarchy, location: { name: t11 } } : null;
  }(e14, t10.Name) : null;
}
function DQ(e14) {
  const [t10, n10] = [e14.RowHierarchy.LevelSizes, e14.Body.Columns];
  return t10.concat(n10).length;
}
function LQ(e14) {
  const [t10, n10] = [e14.ColumnHierarchy.LevelSizes, e14.Body.Rows.map((e15) => e15.Height)];
  return t10.concat(n10).length;
}
function HQ(e14) {
  const [t10, n10] = [e14.RowHierarchy.LevelSizes, e14.Body.Columns];
  return t10.concat(n10).map((e15) => L$.parse(e15));
}
function IQ(e14) {
  const [t10, n10] = [e14.ColumnHierarchy.LevelSizes, e14.Body.Rows.map((e15) => e15.Height)];
  return t10.concat(n10).map((e15) => L$.parse(e15));
}
function _Q(e14, t10) {
  RQ(e14, (e15) => (t10(e15), e15.item));
}
function VQ(e14, t10, n10) {
  AQ(e14, (e15) => (t10(e15), e15.item), (e15) => (n10(e15), e15.member));
}
function RQ(e14, t10) {
  return AQ(e14, t10);
}
function AQ(e14, t10, n10 = ({ member: e15 }) => e15) {
  const r10 = e14.RowHierarchy.LevelSizes.length || 0;
  const o10 = e14.ColumnHierarchy.LevelSizes.length || 0;
  const a10 = {};
  e14.Corner && e14.Corner.forEach((e15, n11) => {
    const r11 = {};
    e15.forEach((e16, o11) => {
      if (!e16) return;
      const a11 = { item: e16.Item, cix: o11, cspan: e16.ColSpan, rix: n11, rspan: e16.RowSpan, itemPath: e16.Item && qj(n11, o11) || null };
      const i11 = t10(a11);
      i11 !== e16.Item && (r11[o11] = { Item: { $set: i11 } });
    }), jJ(r11) || (a10[n11] = r11);
  });
  const i10 = {};
  e14.Body.Rows.forEach((e15, n11) => {
    const a11 = {};
    e15.Cells.forEach((e16, i11) => {
      if (!e16) return;
      const s11 = { item: e16.Item, cix: r10 + i11, cspan: e16.ColSpan, rix: o10 + n11, rspan: e16.RowSpan, itemPath: e16.Item && Yj(n11, i11) || null, autoMergeMode: e16.AutoMergeMode };
      const l11 = t10(s11);
      l11 !== e16.Item && (a11[i11] = { Item: { $set: l11 } });
    }), jJ(a11) || (i10[n11] = { Cells: a11 });
  });
  function s10(e15, r11, o11, a11) {
    const i11 = {};
    return e15.forEach((e16, l11) => {
      let c11 = {};
      const u11 = ((e17, t11) => `${e17}.${t11}`)(a11, l11);
      const d10 = o11(e16, r11, u11);
      const p10 = n10(d10);
      if (e16.Header) {
        const n11 = t10(d10);
        n11 !== e16.Header.Item && (c11.Header = { Item: { $set: n11 } });
      }
      if (SQ(p10.Children)) {
        const e17 = ((e18) => `${e18}.Children`)(u11);
        const t11 = s10(p10.Children, r11 + ZJ(p10), o11, e17);
        jJ(t11) || (c11.Children = t11);
      }
      p10 !== e16 && (c11 = { $set: jJ(c11) ? p10 : AV(p10, c11) }), jJ(c11) || Object.assign(i11, { [l11]: c11 });
    }), i11;
  }
  const l10 = s10(e14.RowHierarchy.Members, 0, function(e15, t11, n11) {
    const r11 = yQ(e15);
    return { member: e15, memberPath: n11, item: e15.Header && e15.Header.Item || null, cix: t11, cspan: ZJ(e15), rix: o10 + r11.start, rspan: r11.end - r11.start + 1, itemPath: e15.Header && e15.Header.Item && Uj(n11) || null };
  }, `${uZ.ROW}.Members`);
  const c10 = s10(e14.ColumnHierarchy.Members, 0, function(e15, t11, n11) {
    const o11 = yQ(e15);
    return { member: e15, memberPath: n11, item: e15.Header && e15.Header.Item || null, rix: t11, rspan: ZJ(e15), cix: r10 + o11.start, cspan: o11.end - o11.start + 1, itemPath: e15.Header && e15.Header.Item && Uj(n11) || null };
  }, `${uZ.COLUMN}.Members`);
  if ([a10, i10, l10, c10].every(jJ)) return e14;
  const u10 = { Body: { Rows: i10 }, RowHierarchy: { Members: l10 }, ColumnHierarchy: { Members: c10 } };
  return jJ(a10) || (u10.Corner = a10), AV(e14, u10);
}
function OQ(e14, t10) {
  const n10 = (e15) => {
    let r11 = 0;
    return e15.forEach((e16) => {
      aj(e16) && ((rj(e16) && !t10 || e16.Header && rj(e16.Header.Item)) && r11++, SQ(e16.Children) && (r11 += n10(e16.Children)));
    }), r11;
  };
  const r10 = e14.Corner && e14.Corner.reduce((e15, t11) => e15 + t11.reduce((e16, t12) => t12 && rj(t12.Item) && e16 + 1 || e16, 0), 0) || 0;
  const o10 = e14.Body.Rows.reduce((e15, t11) => aj(t11) && e15 + t11.Cells.reduce((e16, t12) => t12 && rj(t12.Item) && e16 + 1 || e16, 0) || e15, 0);
  const a10 = n10(e14.RowHierarchy.Members) + n10(e14.ColumnHierarchy.Members) + r10 + o10;
  if (t10) return a10;
  const i10 = e14.$rows.collection.reduce((e15, t11) => rj(t11) && e15 + 1 || e15, 0) + e14.$columns.collection.reduce((e15, t11) => rj(t11) && e15 + 1 || e15, 0);
  return a10 + i10;
}
function BQ(e14, t10 = false) {
  const n10 = yj(e14);
  if (0 === n10.length) return false;
  const r10 = OQ(e14, t10);
  return n10.length === r10;
}
function zQ(e14) {
  const [t10, n10] = [HQ(e14), IQ(e14)];
  const r10 = RQ(e14, ({ item: e15, rix: r11, rspan: o10, cix: a10, cspan: i10 }) => {
    const s10 = L$.sum(t10, a10, i10).css;
    const l10 = L$.sum(n10, r11, o10).css;
    const { $place: c10, $place: { Width: u10, Height: d10 } } = e15;
    const p10 = __spreadProps(__spreadValues({}, c10), { Width: L$.isZeroLike(u10) ? s10 : u10, Height: L$.isZeroLike(d10) ? l10 : d10 });
    return __spreadProps(__spreadValues({}, e15), { $width: s10, $height: l10, $place: p10 });
  });
  return __spreadProps(__spreadValues({}, r10), { $width: L$.sum(t10).css, $height: L$.sum(n10).css, $columns: { collection: t10.map((e15) => ({ Type: "tablixcolumn", Width: e15.css })) }, $rows: { collection: n10.map((e15) => ({ Type: "tablixrow", Height: e15.css })) } });
}
const $Q = (e14, t10) => {
  const n10 = {};
  if (e14.Header) {
    const r11 = t10(e14.Header, "Header");
    e14.Header !== r11 && (n10.Header = { $set: r11 });
  }
  if (e14.Details) {
    const r11 = t10(e14.Details, "Details");
    e14.Details !== r11 && (n10.Details = { $set: r11 });
  }
  if (e14.Footer) {
    const r11 = t10(e14.Footer, "Footer");
    e14.Footer !== r11 && (n10.Footer = { $set: r11 });
  }
  const r10 = {};
  return e14.TableGroups.forEach((e15, n11) => {
    const o10 = t10(e15, `TableGroups.${n11}`);
    e15 !== o10 && (r10[n11] = { $set: o10 });
  }), zV.isEmpty(r10) || (n10.TableGroups = r10), zV.isEmpty(n10) ? e14 : AV(e14, n10);
};
const WQ = (e14, t10) => {
  $Q(e14, (e15, n10) => (t10(e15, n10), e15));
};
const jQ = (e14, t10) => {
  const n10 = {};
  return e14.TableColumns.forEach((e15, r10) => {
    const o10 = t10(e15, `TableColumns.${r10}`);
    o10 !== e15 && (n10[r10] = { $set: o10 });
  }), zV.isEmpty(n10) ? e14 : AV(e14, { TableColumns: n10 });
};
const ZQ = (e14, t10) => {
  jQ(e14, (e15, n10) => (t10(e15, n10), e15));
};
const GQ = (e14, t10) => {
  let n10 = 0;
  const r10 = (e15, r11) => {
    if (!e15) return {};
    const o11 = t10(e15.TableRows, n10, `${r11}.TableRows`);
    return n10 += e15.TableRows.length, o11 === e15.TableRows ? {} : 0 === o11.length ? { $set: null } : { TableRows: { $set: o11 } };
  };
  const o10 = r10(e14.Header, "Header");
  const a10 = {};
  e14.TableGroups.forEach((e15, t11) => {
    const n11 = r10(e15.Header, `TableGroups.${t11}.Header`);
    zV.isEmpty(n11) || (a10[t11] = { Header: n11 });
  });
  const i10 = r10(e14.Details, "Details");
  const s10 = {};
  zV.forEachRight(e14.TableGroups, (e15, t11) => {
    const n11 = r10(e15.Footer, `TableGroups.${t11}.Footer`);
    zV.isEmpty(n11) || (s10[t11] = { Footer: n11 });
  });
  const l10 = zV.merge({}, a10, s10);
  const c10 = r10(e14.Footer, "Footer");
  const u10 = {};
  zV.isEmpty(l10) || (u10.TableGroups = l10), zV.isEmpty(o10) || (u10.Header = o10), zV.isEmpty(c10) || (u10.Footer = c10), zV.isEmpty(i10) || (u10.Details = i10);
  return zV.isEmpty(u10) ? e14 : AV(e14, u10);
};
const UQ = (e14, t10) => GQ(e14, (e15, n10, r10) => {
  const o10 = [];
  return e15.forEach((e16, a10) => {
    const i10 = t10(e16, n10 + a10, `${r10}.${a10}`);
    1 === i10.length && i10[0] === e16 || o10.push([a10, 1, ...i10]);
  }), o10.length ? AV(e15, { $splice: o10.reverse() }) : e15;
});
const qQ = (e14, t10) => UQ(e14, (e15, n10, r10) => [t10(e15, n10, r10)]);
const YQ = (e14, t10) => {
  qQ(e14, (e15, n10, r10) => (t10(e15, n10, r10), e15));
};
const KQ = (e14, t10) => qQ(e14, (e15, n10, r10) => {
  const o10 = {};
  return e15.TableCells.forEach((e16, a10) => {
    if (!e16) return;
    const i10 = t10({ item: e16.Item, rowIdx: n10, colIdx: a10, colSpan: e16.ColSpan, rowSpan: e16.RowSpan, itemPath: `${r10}.TableCells.${a10}.Item`, autoMergeMode: e16.AutoMergeMode });
    i10 !== e16.Item && (o10[a10] = { Item: { $set: i10 } });
  }), zV.isEmpty(o10) ? e15 : AV(e15, { TableCells: o10 });
});
const XQ = (e14, t10) => {
  KQ(e14, (e15) => (t10(e15), e15.item));
};
const JQ = (e14) => {
  const t10 = (e15) => e15 && e15.TableRows.length || 0;
  let n10 = 0;
  return n10 += t10(e14.Header), n10 += t10(e14.Footer), n10 += t10(e14.Details), e14.TableGroups.forEach((e15) => {
    n10 += t10(e15.Header), n10 += t10(e15.Footer);
  }), n10;
};
const QQ = (e14) => e14.TableColumns.length;
const e1 = (e14) => {
  const t10 = new Array(JQ(e14));
  return YQ(e14, (e15, n10) => {
    t10[n10] = L$.parse(e15.Height);
  }), t10;
};
const t1 = (e14) => e14.TableColumns.map((e15) => L$.parse(e15.Width));
const n1 = (e14) => {
  const t10 = [];
  return YQ(e14, (e15, n10) => {
    rj(e15) && (ij(e15) ? t10.unshift(n10) : t10.push(n10));
  }), t10;
};
const r1 = (e14) => {
  const t10 = [];
  return YQ(e14, (e15, n10) => {
    aj(e15) && (ij(e15) ? t10.unshift(n10) : t10.push(n10));
  }), t10;
};
const o1 = (e14) => {
  const t10 = [];
  return e14.TableColumns.forEach((e15, n10) => {
    rj(e15) && (ij(e15) ? t10.unshift(n10) : t10.push(n10));
  }), t10;
};
const a1 = (e14) => {
  const t10 = [];
  return XQ(e14, ({ item: e15, rowIdx: n10, rowSpan: r10 }) => {
    for (let o10 = n10; o10 < n10 + r10; o10++) rj(e15) && !t10.includes(o10) && (ij(e15) ? t10.unshift(o10) : t10.push(o10));
  }), t10;
};
const i1 = (e14) => {
  const t10 = [];
  return XQ(e14, ({ item: e15, colIdx: n10, colSpan: r10 }) => {
    for (let o10 = n10; o10 < n10 + r10; o10++) rj(e15) && !t10.includes(o10) && (ij(e15) ? t10.unshift(o10) : t10.push(o10));
  }), t10;
};
const s1 = (e14) => {
  let t10 = 0;
  return YQ(e14, (e15) => rj(e15) && t10++), t10;
};
const l1 = (e14) => {
  let t10 = 0;
  return e14.TableColumns.forEach((e15) => rj(e15) && t10++), t10;
};
const c1 = (e14) => {
  let t10 = 0;
  return XQ(e14, ({ item: e15 }) => rj(e15) && t10++), t10;
};
const u1 = (e14) => a1(e14).length;
const d1 = (e14) => i1(e14).length;
const p1 = (e14) => s1(e14) > 0;
const m1 = (e14) => c1(e14) > 0;
const h1 = (e14) => {
  let t10 = s1(e14) + l1(e14) + c1(e14);
  return ((e15) => rj(e15.Details))(e14) && t10++, e14.TableGroups.forEach((e15) => {
    rj(e15) && t10++;
  }), t10;
};
const f1 = (e14) => {
  const t10 = yj(e14);
  if (0 === t10.length) return false;
  const n10 = h1(e14);
  return t10.length === n10;
};
var g1 = { exports: {} };
!function(e14) {
  (function() {
    var t10, n10, r10, o10, a10, i10 = {}.hasOwnProperty, s10 = [].slice;
    t10 = function(e15) {
      function t11(e16) {
        this.message = e16;
      }
      return function(e16, t12) {
        for (var n11 in t12) i10.call(t12, n11) && (e16[n11] = t12[n11]);
        function r11() {
          this.constructor = e16;
        }
        r11.prototype = t12.prototype, e16.prototype = new r11(), e16.__super__ = t12.prototype;
      }(t11, Error), t11.prototype.name = "ValueError", t11;
    }(), n10 = function(e15) {
      return null == e15 && (e15 = {}), function() {
        var n11, r11, a11, i11, l10;
        return l10 = arguments[0], n11 = 2 <= arguments.length ? s10.call(arguments, 1) : [], a11 = 0, r11 = i11 = false, l10.replace(/([{}])\1|[{](.*?)(?:!(.+?))?[}]/g, function(s11, l11, c10, u10) {
          var d10, p10, m10;
          if (l11) return l11;
          if (c10.length) {
            if (i11) throw new t10("cannot switch from implicit to explicit numbering");
            r11 = true, d10 = null != (p10 = o10(n11, c10)) ? p10 : "";
          } else {
            if (r11) throw new t10("cannot switch from explicit to implicit numbering");
            i11 = true, d10 = null != (m10 = n11[a11++]) ? m10 : "";
          }
          return Object.prototype.hasOwnProperty.call(e15, u10) ? e15[u10](d10) : d10;
        });
      };
    }, o10 = function(e15, t11) {
      var n11;
      for (/^(\d+)([.]|$)/.test(t11) || (t11 = "0." + t11); n11 = /(.+?)[.](.+)/.exec(t11); ) e15 = a10(e15, n11[1]), t11 = n11[2];
      return a10(e15, t11);
    }, a10 = function(e15, t11) {
      var n11;
      return "function" == typeof (n11 = e15[t11]) ? n11.call(e15) : n11;
    }, (r10 = n10({})).create = n10, r10.extend = function(e15, t11) {
      var r11;
      r11 = n10(t11), e15.format = function() {
        return r11.apply(null, [this].concat(s10.call(arguments)));
      };
    }, e14.exports = r10;
  }).call($);
}(g1);
var y1 = W(g1.exports);
const v1 = "^((?:\\pL[\\pL_\\d]*)|(?:_[\\pL_\\d]+))$";
const b1 = "Fields!([\\pL_\\d]+)\\.Value";
const S1 = 'Fields\\.Item\\("([^"]+)"\\)\\.Value';
const C1 = (e14 = "simpleFieldPath", t10 = "complexFieldPath") => `(?:Fields!(?<${e14}>[\\pL_\\d]+)\\.Value)|(?:Fields\\.Item\\("(?<${t10}>[^"]+)"\\)\\.Value)`;
const x1 = C1();
const w1 = (e14, t10) => t10 ? Jc(e14, t10) : Jc(e14);
const T1 = (e14, t10, n10) => {
  const r10 = w1(t10, n10);
  return Jc.match(e14, r10);
};
function E1(e14) {
  if (!e14) return false;
  const t10 = !!T1(e14, `^=${b1}$`, "i");
  const n10 = !!T1(e14, `^=${S1}$`, "i");
  return t10 || n10;
}
const F1 = (e14, t10) => ({ pattern: e14, flags: t10 });
const M1 = [F1(S1, "ig"), F1(b1, "ig")];
const k1 = (e14) => e14 && e14.length > 1 && e14.slice(1) || [];
const P1 = (e14, t10) => {
  const n10 = [];
  let r10;
  do {
    r10 = e14.exec(t10);
    const o10 = r10 && k1(r10);
    o10 && n10.push(...o10);
  } while (r10);
  return n10;
};
const N1 = (e14) => {
  const t10 = [];
  return M1.map((e15) => Jc(e15.pattern, e15.flags)).forEach((n10) => {
    const r10 = P1(n10, e14);
    t10.push(...r10);
  }), t10;
};
const D1 = ["Avg", "Count", "CountDistinct", "First", "Last", "Max", "Median", "Min", "Mode", "StDev", "StDevP", "Sum", "Var", "VarP"].reduce((e14, t10) => Object.assign(e14, { [t10.toLowerCase()]: t10 }), {});
const L1 = Object.keys(D1);
const H1 = (e14) => e14 && L1.includes(e14.toLowerCase()) || false;
const I1 = '(?:Fields![\\pL_\\d]+\\.Value|Fields\\.Item\\("[^"]+"\\)\\.Value)';
const _1 = `^=?\\s*(${L1.join("|")})\\s*\\(\\s*${I1}\\s*(?:,\\s*"(?:[^"]+|\\\\\\")+"\\s*)?\\)\\s*$`;
const V1 = `(?:${L1.join("|")})\\s*\\(\\s*${I1}\\s*,\\s*"([^"]+)"\\s*\\)`;
const R1 = `Lookup\\s*\\(\\s*"(?:[^"]+)"\\s*,\\s*(?:${I1})\\s*,\\s*(?:${I1})\\s*,\\s*"([^"]+)"\\s*\\)`;
const A1 = (e14) => {
  const t10 = w1(_1, "i").exec(e14);
  return t10 && 2 === t10.length ? (n10 = t10[1], D1[n10.toLowerCase()] || n10) : "";
  var n10;
};
function O1(e14, t10 = null, n10 = null) {
  const r10 = A1(e14);
  if (!r10) return B1(e14, t10, n10);
  const o10 = N1(e14);
  if (1 !== o10.length) return B1(e14, t10, n10);
  const a10 = o10[0];
  const i10 = G1(a10);
  return `=${`${H1(t10) ? t10 : r10 || "Count"}(${i10 || '""'}${n10 && `, "${n10}"` || ""})`}`;
}
function B1(e14, t10 = null, n10 = null) {
  let r10 = e14 || "";
  const o10 = r10.length > 0 && "=" === r10[0] || false;
  o10 && (r10 = r10.substring(1));
  const a10 = `${H1(t10) ? t10 : "Count"}(${r10 || '""'}${n10 && `, "${n10}"` || ""})`;
  return o10 && `=${a10}` || a10;
}
function z1(e14) {
  if (!e14) return e14;
  if (!A1(e14)) return e14;
  const t10 = N1(e14);
  if (1 !== t10.length) return e14;
  return `${"=" === e14[0] ? "=" : ""}${G1(t10[0])}`;
}
const $1 = w1(V1, "ig");
function W1(e14) {
  if (!e14) return [];
  return P1($1, e14);
}
const j1 = w1(R1, "ig");
const Z1 = (e14, t10, n10) => {
  let r10 = e14;
  return r10 = ((e15, t11, n11) => {
    const r11 = w1(`(?<aggregate>${L1.join("|")})\\s*\\(\\s*(${x1})\\s*,\\s*"${t11}"\\s*\\)`, "ig");
    const o10 = Jc.replace(e15, r11, (e16) => {
      const { aggregate: t12, simpleFieldPath: r12, complexFieldPath: o11 } = e16;
      return G1(r12 || o11, n11, t12);
    });
    return o10;
  })(r10, t10, n10), r10 = ((e15, t11, n11) => {
    const r11 = C1("destSimplePath", "destComplexPath");
    const o10 = C1("resultSimplePath", "resultComplexPath");
    const a10 = w1(`Lookup\\s*\\(\\s*"(?<source>[^"]+)"\\s*,\\s*(?:${r11})\\s*,\\s*(?:${o10})\\s*,\\s*"${t11}"\\s*\\)`);
    const i10 = Jc.replace(e15, a10, (e16) => {
      const { source: t12, destSimplePath: r12, destComplexPath: o11, resultSimplePath: a11, resultComplexPath: i11 } = e16;
      const [s10, l10] = [r12 || o11, a11 || i11];
      const [c10, u10] = [s10, l10].map((e17) => G1(e17));
      return `Lookup("${t12}", ${c10}, ${u10}, "${n11}")`;
    });
    return i10;
  })(r10, t10, n10), r10;
};
const G1 = (e14, t10 = null, n10 = null) => {
  if (!e14) throw new Error("Field name cannot be null/undefined/empty");
  let r10;
  if (Jc.match(e14, w1(v1)) ? r10 = ((e15) => `Fields!${e15}.Value`)(e14) : Jc.match(e14, w1('^([^"]+)$')) && (r10 = ((e15) => `Fields.Item("${e15}").Value`)(e14)), !r10) throw new Error(`Field name has invalid/unsupported structure: ${e14}`);
  return n10 || t10 ? B1(r10, n10, t10) : r10;
};
function U1(e14, t10, n10 = null, r10 = null) {
  if (!t10) throw new Error("Field variation format cannot be null/undefined/empty");
  const o10 = G1(e14);
  const a10 = t10.startsWith("=") ? t10.substring(1) : t10;
  const i10 = y1(a10, { fieldExpression: o10 });
  return r10 || n10 ? B1(i10, r10 || "First", n10) : i10;
}
const q1 = (e14) => {
  if (!e14) return "";
  const t10 = (e15) => e15 !== e15.toLowerCase();
  const n10 = (e15) => e15 !== e15.toUpperCase();
  const r10 = (e15) => !Number.isNaN(e15);
  return [...e14].reduce((o10, a10, i10) => {
    if (!o10) return a10;
    const s10 = o10[o10.length - 1];
    const l10 = i10 + 1 < e14.length - 1 && e14[i10 + 1] || "";
    if (" " === s10 && ("." === a10 || " " === a10)) return o10;
    if (" " !== s10 && " " === a10) return `${o10}${a10}`;
    if (" " === s10) return `${o10}${a10}`;
    if ("." === a10) return `${o10} `;
    return !r10(s10) && r10(a10) || r10(s10) && !r10(a10) || n10(s10) && t10(a10) || l10 && t10(s10) && t10(a10) && n10(l10) ? `${o10} ${a10}` : `${o10}${a10}`;
  }, "");
};
const Y1 = "!#%&@$^\xBF";
const K1 = "\xBF^$@&%#!";
const X1 = (e14 = "") => {
  if (e14.length > 0 && "=" !== e14[0]) return e14;
  if ('=""' === e14) return "";
  let t10 = e14;
  const n10 = w1(b1, "g");
  t10 = Jc.replace(t10, n10, (e15) => `[${e15.slice(7, -6)}]`);
  const r10 = w1(S1, "g");
  return t10 = Jc.replace(t10, r10, (e15) => {
    let t11 = e15.slice(13, -8);
    return t11 = t11.replace(/\[/g, "\\["), t11 = t11.replace(/\]/g, "\\]"), `[${t11}]`;
  }), t10;
}, J1 = (e14) => {
  if (e14.length > 0 && "=" !== e14[0]) return e14;
  let t10 = e14;
  return t10 = t10.replace(/\\\[/g, Y1), t10 = t10.replace(/\\\]/g, K1), t10 = t10.replace(/\[[^[\]]+\]/g, (e15) => G1(e15.slice(1, -1))), t10 = t10.split(Y1).join("["), t10 = t10.split(K1).join("]"), t10;
};
const Q1 = ["Bookmark", "Label", "ToolTip"];
const e0 = ["Border.Width", "LeftBorder.Width", "RightBorder.Width", "TopBorder.Width", "BottomBorder.Width", "Border.Style", "LeftBorder.Style", "RightBorder.Style", "TopBorder.Style", "BottomBorder.Style", "Border.Color", "LeftBorder.Color", "RightBorder.Color", "TopBorder.Color", "BottomBorder.Color", "FontFamily", "FontSize", "FontStyle", "FontWeight", "PaddingLeft", "PaddingRight", "PaddingTop", "PaddingBottom", "BackgroundColor", "BackgroundImage.Source", "BackgroundImage.Value", "BackgroundImage.MIMEType", "BackgroundImage.BackgroundRepeat", "BackgroundGradientType", "BackgroundGradientEndColor", "Calendar", "CharacterSpacing", "Color", "Direction", "Format", "Language", "LineHeight", "NumeralLanguage", "NumeralVariant", "ShrinkToFit", "TextAlign", "TextDecoration", "TextJustify", "VerticalAlign", "WrapMode", "WritingMode", "LeadingChar", "MaxLevel", "HeadingLevel"];
const t0 = ["Hyperlink", "BookmarkLink"];
const n0 = ["ParentGroup", "DocumentMapLabel", "GroupExpressions"];
const r0 = ["Visibility.Hidden"];
const o0 = ["NoRowsMessage"];
const a0 = ["Value"];
const i0 = ["Value"];
const s0 = ["Value"];
const l0 = { [rW.dvchart]: ["Legend.Style", "Legend.TextStyle", "Legend.TitleStyle"], [rW.dvchartGlobalLegend]: ["TextStyle", "TitleStyle"], [rW.dvchartLegend]: ["TextStyle", "TitleStyle"], [rW.dvchartPlot]: ["Config.Style", "Config.SymbolStyle", "Config.Text.ConnectingLine", "Config.Text.Style"], [rW.dvchartAxis]: ["LabelStyle", "LineStyle", "MajorGridStyle", "MajorTickStyle", "MinorGridStyle", "MinorTickStyle", "TextStyle", "TitleStyle"] };
const c0 = (e14, t10) => ({ path: e14, value: t10 });
const u0 = (e14, t10 = "") => ({ dataSetName: t10, descriptors: e14 });
const d0 = (e14, t10) => ({ path: e14, item: t10 });
function p0(e14) {
  const t10 = [];
  return e14.forEach((e15) => {
    const n10 = t10.findIndex((t11) => t11.dataSetName === e15.dataSetName);
    n10 >= 0 ? t10[n10].descriptors.push(...e15.descriptors) : t10.push(e15);
  }), t10;
}
const m0 = [(e14) => e14.includes("DataSetParameters"), (e14) => /Filters.items.\w+.value/.test(e14) && !e14.includes("Group.Filters")];
const h0 = (e14) => m0.some((t10) => t10(e14));
function f0(e14, t10) {
  const n10 = [];
  const r10 = e14.item;
  const o10 = e14.path;
  const a10 = (e15, t11) => {
    (function(e16) {
      return e16 && "string" == typeof e16 && e16.length > 0 && "=" === e16[0] || false;
    })(t11) && n10.push(c0($j(o10, e15), t11));
  };
  return t10.forEach((e15) => {
    let t11 = r10;
    e15.split(".").forEach((e16) => {
      t11 = t11 && t11[e16];
    }), zV.isArrayLikeObject(t11) ? t11.forEach((t12, n11) => a10($j(e15, `${n11}`), t12)) : a10(e15, t11);
  }), n10;
}
function g0(e14, t10) {
  if (!e14 || !e14.items) return [];
  const n10 = [];
  return e14.items.forEach((e15, r10) => {
    e15.items ? n10.push(...g0(e15, `${t10}.items.${r10}`)) : e15.field && e15.value && (n10.push(c0(`${t10}.items.${r10}.field`, e15.field)), n10.push(c0(`${t10}.items.${r10}.value`, e15.value)));
  }), n10;
}
function y0(e14) {
  if (!e14 && 0 === e14.length) return [];
  const t10 = [];
  return e14.forEach((e15, n10) => {
    const r10 = [];
    const o10 = e15.Query && e15.Query.QueryParameters || [];
    const a10 = `DataSets.${n10}.Query.QueryParameters`;
    o10.forEach((e16, t11) => {
      const n11 = f0(d0(`${a10}.${t11}`, e16), i0);
      r10.push(...n11);
    });
    const i10 = e15.Filters;
    const s10 = `DataSets.${n10}.Filters`;
    r10.push(...g0(i10, s10));
    const l10 = e15.Fields || [];
    const c10 = `DataSets.${n10}.Fields`;
    l10.forEach((e16, t11) => {
      if (e16 && e16.hasOwnProperty("Value")) {
        const n11 = f0(d0(`${c10}.${t11}`, e16), ["Value"]);
        r10.push(...n11);
      }
    });
    const u10 = e15.$calculatedFields || [];
    const d10 = `DataSets.${n10}.$calculatedFields`;
    u10.forEach((e16, t11) => {
      if (e16 && e16.hasOwnProperty("Value")) {
        const n11 = f0(d0(`${d10}.${t11}`, e16), ["Value"]);
        r10.push(...n11);
      }
    }), r10.length > 0 && t10.push(u0(r10, e15.Name));
  }), t10;
}
function v0(e14, t10) {
  const n10 = [];
  return e14.items.forEach((e15, r10) => {
    e15.items ? n10.push(...v0(e15, `${t10}.items.${r10}`)) : e15.field && e15.value && (n10.push(`${t10}.items.${r10}.field`), n10.push(`${t10}.items.${r10}.value`));
  }), n10;
}
const b0 = (e14) => [rW.tableHeader, rW.tableDetails, rW.tableFooter].includes(e14);
function S0(e14) {
  const { item: t10 } = e14;
  const n10 = t10.Type && tz.getFeature(t10.Type, "getExpressionProperties");
  const r10 = n10 ? [...n10(t10)] : [];
  (UW(t10.Type) || [rW.dynamicTablixMember, rW.tableDetails, rW.tableGroup, rW.bandedListGroup].includes(t10.Type)) && r10.push(...function(e15) {
    const t11 = [];
    return e15.SortExpressions && e15.SortExpressions.forEach((e16, n11) => {
      a0.forEach((e17) => {
        e17 && t11.push(`SortExpressions.${n11}.${e17}`);
      });
    }), e15.Filters && t11.push(...v0(e15.Filters, "Filters")), e15.DataSetParameters && e15.DataSetParameters.forEach((e16, n11) => {
      i0.forEach((e17) => {
        e17 && t11.push(`DataSetParameters.${n11}.${e17}`);
      });
    }), t11.concat(o0);
  }(t10)), GW(t10.Type) && r10.push(...Q1), XW(t10.Type) && r10.push(...function(e15) {
    const t11 = (l0[e15.Type] || []).concat("Style").reduce((e16, t12) => e16.concat(e0.map((e17) => `${t12}.${e17}`)), []);
    return t11;
  }(t10)), KW(t10.Type) && r10.push(...function(e15) {
    if (!e15) return [];
    const t11 = [];
    return e15.Drillthrough && e15.Drillthrough.Parameters && e15.Drillthrough.Parameters.forEach((e16, n11) => {
      tz.getFeature(e16.Type, "getExpressionProperties")(e16).forEach((e17) => {
        e17 && t11.push(`Drillthrough.Parameters.${n11}.${e17}`);
      });
    }), t11.concat(t0);
  }(t10.Action).map((e15) => `Action.${e15}`)), qW(t10.Type) && r10.push(...function(e15) {
    if (!e15) return [];
    const t11 = [];
    return e15.Filters && t11.push(...v0(e15.Filters, "Filters")), t11.concat(n0);
  }(t10.Group).map((e15) => `Group.${e15}`)), YW(t10.Type) && r10.push(...r0), t10.Type === rW.formattedText && r10.push(...function(e15) {
    const t11 = [];
    return e15.MailMergeFields && e15.MailMergeFields.forEach((e16, n11) => {
      s0.forEach((e17) => {
        e17 && t11.push(`MailMergeFields.${n11}.${e17}`);
      });
    }), t11;
  }(t10));
  const o10 = f0(e14, r10);
  const a10 = o10.length ? [u0(o10)] : [];
  RW(t10.Type) && (a10.push(...y0(t10.DataSets)), a10.push(...function(e15) {
    if (!e15 && 0 === e15.length) return [];
    const t11 = (e16) => e16 && `=${G1(e16)}` || "";
    const n11 = [];
    return e15.forEach((e16, r11) => {
      const o11 = `ReportParameters.${r11}`;
      const a11 = e16.ValidValues;
      if (a11 && a11.DataSetReference) {
        const e17 = a11.DataSetReference;
        const r12 = `${o11}.ValidValues.DataSetReference`;
        const i12 = t11(e17.LabelField);
        const s10 = t11(e17.ValueField);
        n11.push(u0([c0(`${r12}.LabelField`, i12), c0(`${r12}.ValueField`, s10)], e17.DataSetName));
      }
      const i11 = e16.DefaultValue;
      if (i11 && i11.DataSetReference) {
        const e17 = i11.DataSetReference;
        const r12 = `${o11}.DefaultValue.DataSetReference`;
        const a12 = t11(e17.ValueField);
        n11.push(u0([c0(`${r12}.ValueField`, a12)], e17.DataSetName));
      }
    }), n11;
  }(t10.ReportParameters)));
  const i10 = function(e15) {
    const t11 = [];
    const n11 = e15.item;
    const r11 = e15.path;
    const o11 = (e16, o12) => {
      t11.push(d0($j(r11, e16), o12 || n11[e16]));
    };
    const a11 = (e16, t12) => {
      (t12 || n11[e16]).forEach((t13, n12) => {
        o11($j(e16, `${n12}`), t13);
      });
    };
    RW(n11.Type) ? (a11("ReportParameters"), n11.Type === rW.report ? (n11.Body && o11("Body"), n11.PageHeader && o11("PageHeader"), n11.PageFooter && o11("PageFooter")) : n11.Type === rW.fplReport ? a11("Pages") : n11.Type !== rW.mslReport && n11.Type !== rW.dashboard || a11("ReportSections")) : n11.Type === rW.mslCplSection || n11.Type === rW.dashboardSection ? (n11.Body && o11("Body"), n11.PageHeader && o11("PageHeader"), n11.PageFooter && o11("PageFooter")) : n11.Type === rW.mslFplSection ? a11("FixedPage.Pages", n11.FixedPage.Pages) : _W(n11.Type) ? a11("ReportItems") : $W(n11.Type) ? (WQ(n11, (e16, t12) => {
      e16 && o11(t12, e16);
    }), ZQ(n11, (e16, t12) => {
      e16 && o11(t12, e16);
    })) : n11.Type === rW.tableGroup ? (n11.Header && o11("Header"), n11.Footer && o11("Footer")) : b0(n11.Type) ? (n11.TableRows || []).forEach((e16, t12) => {
      o11(`TableRows.${t12}`, e16);
    }) : n11.Type === rW.tableRow ? (n11.TableCells || []).forEach((e16, t12) => {
      const n12 = e16 && e16.Item || null;
      n12 && o11(`TableCells.${t12}.Item`, n12);
    }) : zW(n11.Type) ? VQ(n11, ({ item: e16, itemPath: t12 }) => {
      e16 && o11(t12, e16);
    }, ({ member: e16, memberPath: t12 }) => {
      e16 && o11(t12, e16);
    }) : WW(n11.Type) ? a11("Levels") : tj(n11.Type) ? (n11.Header && o11("Header"), n11.Footer && o11("Footer"), n11.Details && o11("Details"), n11.Groups && a11("Groups")) : n11.Type === rW.bandedListGroup ? (n11.Header && o11("Header"), n11.Footer && o11("Footer")) : ZW(n11.Type) ? (a11("Plots"), n11.Header && o11("Header"), n11.Footer && o11("Footer"), n11.Legend && o11("Legend"), n11.PlotArea && o11("PlotArea")) : n11.Type === rW.dvchartPlot ? (o11("Encodings.Category", n11.Encodings.Category), o11("Encodings.Color", n11.Encodings.Color), o11("Encodings.Shape", n11.Encodings.Shape), o11("Encodings.Size", n11.Encodings.Size), a11("Encodings.Values", n11.Encodings.Values), a11("Encodings.Details", n11.Encodings.Details)) : n11.Type === rW.dvchartPlotArea ? (a11("Axes"), a11("Legends")) : n11.Type === rW.dvchartCategoryEncoding || n11.Type === rW.dvchartAggregateEncoding ? a11("Field.Value", n11.Field.Value || []) : jW(n11.Type) && a11("Parameters");
    return t11;
  }(e14);
  i10.forEach((e15) => {
    const t11 = S0(e15);
    a10.push(...t11);
  });
  return UW(t10.Type) ? function(e15, t11) {
    const n11 = t11 || "";
    const r11 = [];
    return e15.forEach((e16) => {
      if (!e16.dataSetName || e16.dataSetName === n11) return void r11.push(u0(e16.descriptors || [], n11));
      const t12 = [];
      const o11 = [];
      (e16.descriptors || []).forEach((e17) => {
        if (h0(e17.path) && !e17.$movedUp) {
          const n12 = Object.assign({}, e17, { $movedUp: true });
          t12.push(n12);
        } else o11.push(e17);
      }), o11.length > 0 && r11.push(u0(o11, e16.dataSetName)), t12.length > 0 && r11.push(u0(t12, n11));
    }), p0(r11);
  }(a10, t10.DataSetName) : p0(a10);
}
function C0(e14) {
  const t10 = (e14.DataSets || []).map((e15) => e15.Name);
  const n10 = (e15) => {
    const { descriptors: n11, dataSetName: r11 } = e15;
    const o11 = n11.reduce((e16, n12) => {
      let o12 = W1(n12.value);
      0 === o12.length && (o12 = function(e17) {
        return e17 ? P1(j1, e17) : [];
      }(n12.value));
      const a10 = o12.length && ((e17) => t10.includes(e17))(o12[0]) ? o12[0] : r11;
      let i10 = e16.find((e17) => e17.dataSetName === a10);
      return i10 || (i10 = u0([], a10), e16.push(i10)), i10.descriptors.push(n12), e16;
    }, []);
    return o11;
  };
  const r10 = function(e15) {
    const t11 = S0(d0("", e15)) || [];
    if (0 === (e15.DataSets || []).length) return t11;
    const n11 = t11.findIndex((e16) => !e16.dataSetName);
    if (n11 < 0) return t11;
    const r11 = e15.DataSets[0].Name;
    if (!r11) throw new Error("Data set name cannot be empty/null/undefined");
    const o11 = t11.findIndex((e16) => e16.dataSetName === r11);
    if (o11 < 0) return AV(t11, { [n11]: { dataSetName: { $set: r11 } } });
    let a10 = AV(t11, { [o11]: { descriptors: { $push: t11[n11].descriptors } } });
    return a10 = AV(a10, { $splice: [[n11, 1]] }), a10;
  }(e14);
  const o10 = r10.reduce((e15, t11) => [...e15, ...n10(t11)], []);
  return p0(o10);
}
function x0(e14) {
  const t10 = function(e15) {
    const t11 = C0(e15).map((e16) => ({ dataSetName: e16.dataSetName, values: zV.uniq(e16.descriptors.map((e17) => e17.value)) }));
    return t11;
  }(e14);
  const n10 = [];
  return t10.forEach((e15) => {
    const t11 = [];
    e15.values.forEach((e16) => {
      const n11 = N1(e16);
      t11.push(...n11);
    }), t11.length > 0 && n10.push({ dataSetName: e15.dataSetName, values: zV.uniq(t11) });
  }), n10;
}
const w0 = FZ.resultOf(ad.decode({ Name: "", DataType: "String" }));
const T0 = (e14, t10, n10, r10 = w0) => __spreadValues(__spreadProps(__spreadValues({}, r10), { Name: e14, Prompt: e14, DataType: "String" }), n10);
const E0 = (e14, t10) => {
  const n10 = TG("reportParameter");
  return DG(e14, t10 || [], n10);
};
const F0 = (e14) => "fixedpagesection" === e14.Type;
const M0 = (e14) => "Continuous" === e14.Type;
const k0 = (e14) => ((e15) => "FixedPage" === e15.Type)(e14) || M0(e14);
const P0 = (e14) => "dashboardsection" === e14.Type;
function N0(e14) {
  return "multisectionreport" === e14.Type;
}
function D0(e14) {
  return "dashboard" === e14.Type;
}
function L0(e14) {
  return "fixedpagereport" === e14.Type;
}
const H0 = ["rectangle", "fixedpagerectangle", "checkbox", "line", "shape", "image", "bullet", "barcode", "formattedtext", "sparkline", "subreport", "fixedpagesubreport", "overflowplaceholder", "bandedlist", "fixedpagebandedlist", "inputfield", "richtext", "textbox", "dvchart", "fixedpagedvchart", "tableofcontents", "fixedpagetableofcontents", "partitem", "fixedpagepartitem", "contentplaceholder", "bandedlist", "fixedpagebandedlist", "dvchart", "fixedpagedvchart", "list", "fixedpagelist", "table", "fixedpagetable", "tablix", "fixedpagetablix"];
const I0 = (e14) => H0.includes(e14.Type);
const _0 = ["bandedlistheader", "bandedlistdetails", "bandedlistfooter", "contentplaceholder", "fixedpagelist", "fixedpagerectangle", "fixedpagesection"];
const V0 = (e14) => _0.includes(e14.Type);
const R0 = () => hG().t;
const A0 = { warning: "warning", error: "error", internalError: "internalError" };
function O0(e14, t10, n10) {
  return { type: e14, name: t10, message: n10 };
}
function B0(e14, t10) {
  return O0(A0.warning, e14, t10);
}
function z0(e14) {
  return O0(A0.error, fG("innerException", R0()), e14);
}
function $0(e14, t10) {
  const n10 = R0();
  const r10 = (e15) => n10(tz.getLabelKey(e15));
  return new B0(fG("addReportItem", n10, { reportItemType: r10(e14), containerType: r10(t10) }), "");
}
function W0() {
  return new B0(fG("invalidPageSizes", R0()), fG("invalidPageSizes", R0()));
}
function j0(e14, t10, n10) {
  const r10 = t10.split(".");
  const o10 = r10.length;
  let a10 = e14;
  let i10;
  let s10 = 0;
  for (; s10 < o10 - 1; ) i10 = r10[s10], a10[i10] || (a10[i10] = {}), a10 = a10[i10], s10++;
  return a10[r10[s10]] = n10, e14;
}
const Z0 = ["PageHeader", "Body", "PageFooter"];
const G0 = _V("@rdlx/report/addDataSet", (e14) => e14);
const U0 = _V("@rdlx/report/removeDataSet", (e14) => e14);
const q0 = _V("@rdlx/report/setDataSet", (e14) => e14);
const Y0 = _V("@rdlx/report/addDataSource", (e14) => e14);
const K0 = _V("@rdlx/report/removeDataSource", (e14) => e14);
const X0 = _V("@rdlx/report/setDataSource", (e14) => e14);
const J0 = _V("@rdlx/report/addDataSourceAndDataSet", (e14) => e14);
const Q0 = _V("@rdlx/report/addParameter", (e14) => e14);
const e22 = _V("@rdlx/report/addParameters", (e14) => e14);
const t2 = _V("@rdlx/report/removeParameter", (e14) => e14);
const n2 = _V("@rdlx/report/moveParameter", (e14) => e14);
const r2 = _V("@rdlx/report/changeSectionHeight", (e14) => e14);
const o2 = _V("@rdlx/report/setPropertyValue", (e14) => e14);
const a2 = (e14, t10, n10, r10, o10) => o2({ descriptor: e14, value: t10, dataSetName: n10, fieldName: r10, fieldInfo: o10 });
const i2 = (e14, t10, n10, r10, o10, a10) => o2({ descriptor: e14, value: t10, dataSetName: n10, fieldName: r10, preventGroupUpdate: o10, fieldInfo: a10 });
const s2 = (e14, t10) => o2({ descriptor: e14, value: t10, forPrimaryOnly: true });
const l2 = _V("@rdlx/report/SetPropertiesValues", (e14) => e14);
const c2 = _V("@rdlx/report/setPropertyByPath", (e14) => e14);
const u2 = _V("@rdlx/report/setPropertiesByPath", (e14) => e14, (e14 = { skipFplRestrictionsValidation: false }) => e14);
const d2 = _V("@rdlx/report/setLocSizePropertyValue", (e14) => e14);
const p2 = _V("@rdlx/report/addNewReportItemTransaction", (e14) => e14);
const m2 = _V("@rdlx/report/clearThemes", () => {
}, (e14) => e14);
const h2 = _V("@rdlx/report/getTheme", () => {
}, (e14) => e14);
const f2 = _V("@rdlx/report/setTheme", (e14) => e14, (e14) => e14);
const g2 = (e14) => e14 ? f2({ themeId: e14 }, {}) : m2(void 0, {});
const y2 = _V("@rdlx/report/setAndApplyStyle", (e14) => e14);
const v2 = _V("@rdlx/report/rdlxSetStyle", (e14) => e14);
const b2 = _V("@rdlx/report/rdlxApplyStyle", (e14) => e14);
const S2 = _V("@rdlx/report/applyStyleSoft ");
const C2 = _V("@rdlx/report/addLayer");
const x2 = _V("@rdlx/report/removeLayer", (e14) => e14);
const w2 = _V("@rdlx/report/setCurrentLayer", (e14) => e14);
const T2 = _V("@rdlx/report/rdlxSetLayerProperty", (e14) => e14);
const E2 = _V("@rdlx/report/setItemsLayerName", (e14) => e14);
const F2 = _V("@rdlx/report/actualizePropertyValue", (e14) => e14);
const M2 = _V("@rdlx/report/renameLayer", (e14) => e14);
const k2 = _V("@rdlx/report/addEmbeddedImage", (e14) => e14);
const P2 = _V("@rdlx/report/removeEmbeddedImage", (e14) => e14);
const N2 = _V("@rdlx/report/renameEmbeddedImage", (e14) => e14);
const D2 = _V("@rdlx/report/setAutoMergeMode", (e14) => e14);
const L2 = IV(({ itemPaths: e14, reportLink: t10, reportParameters: n10, nameDescriptor: r10, parameterDescriptor: o10 }) => ({ type: "@rdlx/report/selectSubreportName", payload: { itemPaths: e14, reportLink: t10, reportParameters: n10, nameDescriptor: r10, parameterDescriptor: o10 } }), "@rdlx/report/selectSubreportName");
const H2 = _V("@rdlx/report/setMargins", (e14) => ({ margins: e14 }));
const I2 = _V("@rdlx/report/setPageSize", (e14) => ({ pageSize: e14 }));
const _2 = _V("@rdlx/report/setPageHeight", (e14) => ({ height: e14 }));
const V2 = _V("@rdlx/report/addReportPartsLibrary", (e14) => e14, () => ({ skipUndo: true }));
const R2 = _V("@rdlx/report/removeReportPartsLibrary", (e14) => ({ libToRemove: e14 }));
const A2 = _V("@rdlx/report/correlateSizes", (e14) => e14);
const O2 = _V("@rdlx/multiReport/section/add", (e14) => e14);
const B2 = _V("@rdlx/multiReport/section/remove", (e14) => e14);
const z2 = _V("@rdlx/multiReport/section/move", (e14) => e14);
const $2 = _V("@rdlx/multiReport/section/duplicate", (e14) => e14);
const W2 = _V("@rdlx/multiReport/section/toggle", (e14) => e14);
const j2 = _V("@rdlx/multiReport/reportParts/add", (e14) => e14);
const Z2 = _V("@rdlx/multiReport/convertToMasterReport", (e14) => e14);
const G2 = _V("@rdlx/report/setMasterById", (e14) => e14);
const U2 = { rdlxReportSetPropertyByPath: c2, rdlxReportSetPropertiesByPath: u2, rdlxSelectSubreportName: L2, rdlxAddDataSet: G0, rdlxActualizeDataSetName: (e14, t10) => F2({ propertyName: "DataSetName", oldValue: e14, newValue: t10 }), rdlxAddDataSourcesAndDataSets: J0, rdlxRemoveDataSet: U0, rdlxRemoveDataSource: K0, rdlxSetDataSet: q0, rdlxAddDataSource: Y0, rdlxSetDataSource: X0, rdlxAddParameter: Q0, rdlxRemoveParameter: t2, rdlxMoveParamUp: (e14) => n2({ index: e14, direction: "up" }), rdlxMoveParamDown: (e14) => n2({ index: e14, direction: "down" }), rdlxAddReportPartsLibrary: V2, rdlxRemoveReportPartsLibrary: R2, rdlxSetMasterById: G2, rdlxConvertToMasterReport: Z2 };
function q2(e14, t10, n10) {
  if ("string" != typeof n10 || !gc("rdl", n10)) return n10;
  const r10 = "textbox" === e14.Type && `${e14.Value}` || "";
  const o10 = fc("rdl", n10);
  const a10 = hc(r10 || "");
  return "invalid" === o10.type || "invalid" === a10.type ? n10 : pu(gK(o10, "$$", a10));
}
const Y2 = (e14, t10, n10) => {
  const { Type: r10 } = e14;
  return void 0 !== n10 ? n10 : ((e15, t11) => {
    const { defaultModel: n11 } = tz.of("rdlx").getDescriptor(r10);
    if (!n11) throw new Error(`The type '${r10}' does not provide default model`);
    return function(e16, t12) {
      const n12 = t12 == null ? void 0 : t12.valuePath;
      if ("" === n12) return e16;
      if (!n12) throw new Error(`Invalid property descriptor: ${t12 == null ? void 0 : t12.category}/${t12 == null ? void 0 : t12.label}`);
      let r11 = e16;
      const o10 = n12.split(".");
      for (let e17 = 0; e17 < o10.length; e17++) {
        if (e17 === o10.length - 1 && (r11 == null ? void 0 : r11.hasOwnProperty(o10[e17]))) return r11[o10[e17]];
        if (r11 = r11 && r11[o10[e17]], null == r11) return null;
      }
      return r11;
    }(n11, t11);
  })(0, t10);
};
const K2 = (e14, t10, n10, r10 = false, o10 = "", a10 = null, i10 = null) => {
  if (n10 === jN(t10.valuePath)(e14)) return null;
  const s10 = t10.valuePath.split(".");
  let l10;
  return s10.reduce((e15, t11, c10) => {
    0 === c10 && (l10 = e15), l10[t11] = {}, l10 = l10[t11];
    let u10 = n10;
    if (r10 && i10) {
      const e16 = N1(n10);
      if (e16.length > 0) {
        u10 = `=${U1(e16[0], i10, o10, a10)}`;
      }
    } else r10 && (u10 = O1(n10, a10, o10));
    return c10 === s10.length - 1 && (l10.$set = u10), e15;
  }, {});
};
function X2(e14, t10, n10, r10 = false, o10 = false, a10 = "", i10 = null, s10 = null) {
  if (r10 && !sj(e14)) return e14;
  const l10 = K2(e14, t10, Y2(e14, t10, n10), o10, a10, i10, s10);
  return l10 ? AV(e14, l10) : e14;
}
function J2(e14, t10) {
  var _a2;
  if (!c2.match(t10)) return e14;
  const { descriptor: n10, value: r10, path: o10 } = t10.payload;
  const a10 = $j(o10, n10.valuePath);
  const i10 = j0({}, a10, { $set: ((_a2 = n10.meta) == null ? void 0 : _a2.withTextboxExpressionValue) ? q2(e14, 0, r10) : r10 });
  return AV(e14, i10);
}
function Q2(e14, t10) {
  return t10.payload.descriptorValuePairs.reduce((e15, n10) => J2(e15, { type: c2.type, payload: __spreadProps(__spreadValues({}, n10), { path: t10.payload.path }) }), e14);
}
const e5 = [l2.type, o2.type];
const t5 = (e14) => e5.indexOf(e14) >= 0;
function n5(e14, t10) {
  const { Type: n10 } = e14;
  const r10 = tz == null ? void 0 : tz.getDescriptor(n10);
  if (!r10) return console.error(`'${n10}' is not report item`), e14;
  let o10 = e14;
  if (rj(e14)) {
    const n11 = t10 && t10.type;
    if (b2.type === n11 && (o10 = AV(o10, { $style: { $set: t10.payload.style } })), t5(n11) && UW(e14.Type)) {
      const { dataSetName: e15 } = t10.payload;
      e15 && !o10.DataSetName && (o10 = AV(o10, { DataSetName: { $set: e15 } }));
    }
    switch (n11) {
      case o2.type:
        return function(e15, t11) {
          var _a2;
          if (!rj(e15)) return e15;
          const { descriptor: n12, value: r11, forPrimaryOnly: o11, dataSetName: a11, fieldInfo: i10, withScope: s10 } = t11.payload;
          const l10 = i10 && i10.aggregate;
          const c10 = i10 && i10.variationFormat;
          return X2(e15, n12, ((_a2 = n12 == null ? void 0 : n12.meta) == null ? void 0 : _a2.withTextboxExpressionValue) ? q2(e15, 0, r11) : r11, o11, s10, a11, l10, c10);
        }(o10, t10);
      case l2.type:
        return function(e15, t11) {
          if (!rj(e15)) return e15;
          const { descriptorValuePairs: n12, withScope: r11, fieldInfo: o11 } = t11.payload;
          const a11 = t11.payload.dataSetName;
          const i10 = o11 && o11.aggregate;
          const s10 = o11 && o11.variationFormat;
          const l10 = n12 && zV.isArray(n12) && n12.length > 0 ? ((e16) => {
            if (!e16 || !zV.isArray(e16) || 0 === e16.length) return null;
            const t12 = e16.filter((e17) => !!e17);
            return zV.merge(...t12);
          })(n12.map((t12) => K2(e15, t12.descriptor, Y2(e15, t12.descriptor, t12.value), r11, a11, i10, s10))) : null;
          return l10 ? AV(e15, l10) : e15;
        }(o10, t10);
    }
  }
  const a10 = tz == null ? void 0 : tz.of("rdlx").getReducer(n10);
  return a10 ? a10(o10, t10) : o10;
}
const r5 = "SELECTION/EXPAND";
const o5 = "SELECTION/REPLACE";
const a5 = "SELECTION/CLEAR";
const i5 = "SELECTION/SECONDARY_CLEAR";
const s5 = "SELECTION/RESTORE_PRIMARY";
function l5(e14, t10) {
  return { type: r5, payload: { items: [{ path: e14, type: t10 }] }, meta: { skipFplRestrictionsValidation: true } };
}
function c5(e14, t10) {
  return { type: o5, payload: { items: [{ path: e14, type: t10 }] }, meta: { skipFplRestrictionsValidation: true } };
}
function u5() {
  return { type: a5, meta: { skipFplRestrictionsValidation: true } };
}
function d5(e14) {
  return { type: r5, payload: { items: e14 }, meta: { skipFplRestrictionsValidation: true } };
}
function p5(e14) {
  return { type: o5, payload: { items: e14 }, meta: { skipFplRestrictionsValidation: true } };
}
function m5(e14) {
  return { type: r5, payload: { names: e14 }, meta: { skipFplRestrictionsValidation: true } };
}
function h5(e14) {
  return { type: o5, payload: { names: e14 }, meta: { skipFplRestrictionsValidation: true } };
}
function f5() {
  return { type: s5, meta: { skipFplRestrictionsValidation: true } };
}
const g5 = (e14) => F0(e14) || k0(e14) || P0(e14);
const y5 = (e14) => L0(e14) || N0(e14) || D0(e14);
function v5(e14) {
  return y5(e14) ? L0(e14) ? function(e15) {
    const t10 = Array.isArray(e15.Pages) ? e15.Pages.findIndex((e16) => e16.$active) : 0;
    return AV(e15, { $activePageIndex: { $set: t10 } });
  }(e14) : function(e15) {
    const t10 = Array.isArray(e15.ReportSections) ? e15.ReportSections.findIndex((e16) => e16.$active) : 0;
    return AV(e15, { $activeSectionIndex: { $set: t10 } });
  }(e14) : e14;
}
function b5(e14, t10) {
  return e14 && zV.isObject(e14) ? (t10 || zV.keys(e14)).reduce((e15, t11) => {
    if (!e15.hasOwnProperty(t11)) return e15;
    const n10 = e15[t11];
    const r10 = lj(n10);
    return n10 !== r10 ? AV(e15, { [t11]: { $set: r10 } }) : e15;
  }, e14) : e14;
}
function S5(e14, t10, n10) {
  if (!e14 || !zV.isObject(e14)) throw new Error("Invalid argument for setting selection properties");
  if (zV.isArray(e14)) return e14;
  const r10 = {};
  return e14.$selected !== t10 && (r10.$selected = { $set: t10 }), e14.$primary !== n10 && (r10.$primary = { $set: n10 }), g5(e14) && (r10.$active = { $set: true }), zV.isEmpty(r10) ? e14 : AV(e14, r10);
}
function C5(e14, t10, n10) {
  if (!e14 || !zV.isObject(e14)) return e14;
  if (!t10 || 0 === t10.length || t10.some((e15) => !e15 || !zV.isArray(e15) || 0 === e15.length)) throw new Error("Invalid paths for selection applying");
  if (t10.some((e15) => "partitem" === e15[0] || "fixedpagepartitem" === e15[0])) return e14;
  if (t10.some((t11) => !e14.hasOwnProperty(t11[0]))) throw new Error("Invalid paths for selection applying");
  const r10 = zV.groupBy(t10, (e15) => e15[0]);
  const o10 = zV.keys(r10);
  const a10 = zV.keys(e14).filter((e15) => o10.indexOf(e15) < 0);
  let i10 = b5(e14, a10);
  g5(e14[o10[0]]) && (i10 = function(e15, t11) {
    const n11 = {};
    return t11.forEach((e16) => {
      n11[e16] = { $unset: ["$active"] };
    }), t11.length ? AV(e15, n11) : e15;
  }(i10, a10));
  const s10 = (e15) => r10[e15].map((e16) => zV.tail(e16));
  return o10.map((e15) => ({ key: e15, paths: s10(e15) })).reduce((e15, r11) => {
    const o11 = r11.key;
    const a11 = 1 === r11.paths.length && 0 === r11.paths[0].length;
    const i11 = a11 ? cj : uj;
    const s11 = n10 && r11.key === t10[0][0] && (a11 || r11.paths[0][0] === t10[0][1]);
    const l10 = e15[o11];
    if (!l10 || !zV.isObject(l10)) return e15;
    let c10 = S5(l10, i11, s11);
    return c10 = a11 ? b5(c10) : C5(c10, r11.paths, s11), l10 !== c10 ? AV(e15, { [o11]: { $set: c10 } }) : e15;
  }, i10);
}
function x5(e14, t10) {
  return zV.findLastIndex(e14, (e15) => ((e16, t11) => {
    if ("" === e16 || "" === t11 || e16 === t11) return true;
    if (!e16 || !t11) throw new Error("Selection paths cannot be null or undefined");
    return e16.length > t11.length ? e16.indexOf(`${t11}.`) >= 0 : e16.length < t11.length && t11.indexOf(`${e16}.`) >= 0;
  })(e15.path, t10));
}
const w5 = [rW.staticTablixMember, rW.dynamicTablixMember, rW.tableDetails, rW.tableGroup, rW.bandedListGroup, "Continuous"];
const T5 = (e14) => w5.includes(e14);
const E5 = [rW.tablixColumn, rW.tablixRow, rW.gridColumn, rW.gridRow, rW.tableColumn, rW.tableRow];
const F5 = (e14) => E5.includes(e14);
const M5 = [[rW.bandedListHeader, rW.bandedListDetails, rW.bandedListFooter]];
const k5 = M5.reduce((e14, t10) => t10.reduce((e15, n10) => Object.assign({}, e15, { [n10]: t10 }), e14), {});
const P5 = [...w5, ...E5, ...zV.flatten(M5)];
const N5 = (e14) => P5.includes(e14);
function D5(e14, t10, n10 = false) {
  if (!t10 || 0 === t10.length) throw new Error("No items specified for selection " + (n10 ? "expansion" : "replacement"));
  const r10 = [];
  let o10 = false;
  rj(e14) ? r10.push({ path: "", type: e14.Type }) : Sj(e14, (e15, t11) => {
    if (rj(e15)) {
      const n11 = { path: t11, type: e15.Type };
      ij(e15) ? (r10.unshift(n11), o10 = true) : r10.push(n11);
    }
  });
  const a10 = function(e15, t11 = []) {
    const n11 = [...t11, ...e15];
    const r11 = [n11[n11.length - 1]];
    for (let e16 = n11.length - 2; e16 >= 0; e16--) {
      const o11 = n11[e16];
      if (t11.length > 0 && (r11.length > 1 || e16 > 0)) {
        const e17 = r11.findIndex((e18) => e18.path === o11.path);
        if (e17 >= 0 && n11.some((e18) => e18.path !== o11.path)) {
          r11.splice(e17, 1);
          continue;
        }
      }
      if (o11.path.startsWith("ReportSections")) {
        const e17 = o11.path.split(".")[1];
        if (!r11.every((t12) => t12.path.split(".")[1] === e17)) continue;
      }
      const a11 = x5(r11, o11.path);
      if (a11 < 0) {
        if (T5(o11.type) && 0 === r11.length) {
          r11.push(o11);
          break;
        }
        if (F5(o11.type) && r11.every((e18) => e18.type === o11.type)) {
          r11.push(o11);
          continue;
        }
        const e17 = k5[o11.type];
        if (e17) {
          const t12 = r11.every((t13) => e17.includes(t13.type));
          if (t12) {
            r11.push(o11);
            continue;
          }
        }
        if (!N5(o11.type) && r11.every((e18) => !N5(e18.type))) {
          r11.push(o11);
          continue;
        }
      } else r11.push(r11.splice(a11, 1)[0]);
    }
    return r11.reverse();
  }(t10, n10 ? r10 : []);
  return o10 && ((e15, t11) => {
    const n11 = e15 || [];
    const r11 = t11 || [];
    return n11.length === r11.length && n11.every((e16) => r11.findIndex((t12) => t12.path === e16.path) >= 0);
  })(r10, a10) ? e14 : function(e15, t11) {
    if (!e15 || !zV.isObject(e15)) throw new Error("Invalid object for selecting items");
    if (!t11 || 0 === t11.length) throw new Error("No items specified for being selected");
    const n11 = t11.map((e16) => e16.path ? e16.path.split(".") : [""]);
    if (1 === n11.length && 1 === n11[0].length && "" === n11[0][0]) return I5(e15);
    let r11;
    return r11 = S5(e15, uj, true), r11 = C5(r11, n11, true), r11 = v5(r11), r11;
  }(e14, a10);
}
const L5 = (e14, t10) => D5(e14, t10, true);
const H5 = (e14, t10) => D5(e14, t10);
const I5 = (e14) => {
  let t10;
  return t10 = S5(e14, cj, true), t10 = b5(t10), t10 = v5(t10), t10;
};
function _5(e14, t10) {
  if (!t10 || 0 === t10.length) throw new Error("No report item names specified for selection modification");
  const n10 = (e15, t11, r11 = "") => {
    if (!e15 || !zV.isObject(e15)) return [];
    const o11 = [];
    if (Hj(e15) && "reportparameter" !== e15.Type) {
      const n11 = t11.indexOf(e15.Name);
      n11 >= 0 && (o11.push({ path: r11, type: e15.Type, name: e15.Name }), t11.splice(n11, 1));
    }
    return zV.keys(e15).forEach((a10) => o11.push(...n10(e15[a10], t11, $j(r11, a10)))), o11;
  };
  const r10 = [...t10];
  const o10 = n10(e14, r10);
  if (r10.length > 0) throw new Error(`Report item names ${r10.map((e15) => `'${e15}'`).join(", ")} do not belong to this report`);
  return o10.sort((e15, n11) => t10.indexOf(e15.name) - t10.indexOf(n11.name)).map((e15) => ({ path: e15.path, type: e15.type }));
}
function V5(e14, t10) {
  (/* @__PURE__ */ new Date()).getTime();
  const n10 = t10 && t10.payload && t10.payload.items || [];
  const r10 = t10 && t10.payload && t10.payload.names || [];
  let o10 = e14;
  switch (t10 && t10.type) {
    case r5:
      o10 = L5(e14, r10.length > 0 ? _5(e14, r10) : n10);
      break;
    case o5:
      o10 = H5(e14, r10.length > 0 ? _5(e14, r10) : n10);
      break;
    case a5:
      o10 = I5(e14);
      break;
    case i5:
      o10 = Cj(e14);
      break;
    case s5:
      o10 = function(e15) {
        const t11 = [];
        if (Sj(e15, (e16, n11) => {
          rj(e16) && t11.push({ path: n11, type: e16.Type });
        }), 0 === t11.length) if (e15.Body) t11.push({ path: "Body", type: rW.section });
        else {
          if (!e15.Pages) throw new Error("Invalid report structure");
          t11.push({ path: "Pages.0", type: rW.fplSection });
        }
        return H5(e15, t11);
      }(e14);
  }
  return o10;
}
const R5 = "RDLX/OPEN_REPORT_ITEM_WIZARD";
const A5 = _V("@rdlx/report/setInnerItemSize", (e14) => e14);
const O5 = _V("@rdlx/report/pickDataField", (e14) => e14);
const B5 = _V("@rdlx/report/pickDataField", (e14) => e14);
const z5 = (e14, t10, n10 = true, r10 = true) => {
  var _a2, _b2;
  if (!e14) return e14;
  const o10 = {};
  n10 && ((_a2 = e14.$place) == null ? void 0 : _a2.Width) && (o10.Width = e14.$place.Width), r10 && ((_b2 = e14.$place) == null ? void 0 : _b2.Height) && (o10.Height = e14.$place.Height);
  const a10 = __spreadProps(__spreadValues({}, t10), { $fixedPlace: __spreadValues(__spreadValues({}, t10.$fixedPlace), o10) });
  return __spreadValues(__spreadValues({}, e14), a10);
};
const $5 = "table";
const W5 = FZ.resultOf(wq.decode({ Type: $5, Name: "table1" }));
const j5 = FZ.resultOf(wq.decode({ Type: $5, Name: "table1", TableColumns: [{}], Details: { TableRows: [], Group: {} }, Header: {}, Footer: {}, TableGroups: [{}] }));
const Z5 = (e14, t10, n10, r10 = W5) => {
  const { units: o10 } = KO.of(t10).userPreferences;
  return __spreadProps(__spreadValues(__spreadValues({}, r10), n10), { $place: __spreadProps(__spreadValues({}, r10.$place), { Top: `0${o10}`, Left: `0${o10}` }), Name: e14 });
};
const G5 = L$.parse("2pt");
function U5(e14, t10) {
  return e14.lowerThan(t10) ? t10 : e14;
}
function q5(e14) {
  const t10 = eK.of(e14);
  return (e15, n10) => {
    const { type: r10, payload: o10 } = n10;
    switch (r10) {
      case A5.type: {
        const { width: t11, height: n11 } = o10;
        const r11 = {};
        const a10 = e15;
        return Q$(a10) && (J$(a10) || (t11 && (e15.$width !== t11 && "line" !== a10.Type ? r11.$width = U5(L$.parse(t11), G5).css : e15.$place.Width !== t11 && (r11.$place = __spreadProps(__spreadValues({}, r11.$place), { Width: U5(L$.parse(t11), G5).css }))), n11 && (e15.$height !== n11 && "line" !== a10.Type ? r11.$height = U5(L$.parse(n11), G5).css : e15.$place.Height && e15.$place.Height !== n11 && (r11.$place = __spreadProps(__spreadValues({}, r11.$place), { Height: U5(L$.parse(n11), G5).css }))))), __spreadProps(__spreadValues(__spreadValues({}, e15), r11), { $place: __spreadValues(__spreadValues({}, e15.$place), r11.$place) });
      }
      case O5.type:
        if (t10.isDataRegion(e15.Type)) {
          if (!gj(e15, (n11) => n11.Type && t10.isDataRegion(n11.Type) && n11 !== e15)) return __spreadProps(__spreadValues({}, e15), { DataSetName: o10.dataSet });
        } else {
          const { fieldName: t11, fieldPath: n11, format: r11, withScope: a10, dataSet: i10, fieldInfo: s10, shouldAddAggregate: l10 } = o10;
          const c10 = ((e16) => {
            switch (e16.Type) {
              case "checkbox":
                return "Text";
              case "textbox":
              case "image":
                return "Value";
              case "inputfield":
                return "Text" === e16.InputType ? "Value" : "Checked";
            }
            return "";
          })(e15);
          if (c10) {
            let o11 = AV(e15, { [c10]: { $set: `=${G1(n11 || t11, a10 ? i10 : "", s10 && l10 ? s10.aggregate : null)}` } });
            return "image" === o11.Type && (o11 = AV(o11, { Source: { $set: "Database" } })), "textbox" === o11.Type && "string" == typeof r11 && (o11 = AV(o11, { Style: { Format: { $set: r11 } } })), o11;
          }
        }
        return e15;
    }
    return e15;
  };
}
const Y5 = [Zq(cY, "table.autoWidth", "enum", "AutoWidth", "advanced", { enumKey: "auto_width" }), CY.Width, EY.Visibility];
const K5 = j5.TableColumns[0];
function X5(e14 = {}) {
  return __spreadValues(__spreadProps(__spreadValues({}, K5), { Width: "1in" }), e14);
}
const J5 = { type: "tablecolumn", labelKey: "reportItems:tableColumn", defaultModel: K5, getProperties: () => Y5 };
const Q5 = ["PageBreak", "Group.PageBreak", "NewPage", "Group.NewPage", "PageName", "PrintOnFirstPage", "PrintOnLastPage"];
const e4 = ["", "Text", "ConsumeWhiteSpace"];
const t4 = (e14, t10) => e14.filter((e15) => !t10.includes(e15.valuePath));
const n4 = (e14) => t4(e14, Q5);
const r4 = (e14, t10, n10, r10 = false) => e14.map((e15) => {
  const o10 = __spreadProps(__spreadValues({}, e15), { meta: __spreadValues(__spreadValues({}, e15 == null ? void 0 : e15.meta), t10) });
  return (n10 == null ? void 0 : n10.includes(e15.valuePath)) ? r10 ? o10 : e15 : r10 ? e15 : o10;
});
const o4 = ["EmbeddedImages", "Layers", "Author", "Description", "Language", "DataElementName", "DataElementStyle", "Themes.0"];
const a4 = (e14, t10) => {
  var _a2, _b2, _c2, _d2, _e2;
  const n10 = nz.of(e14);
  const r10 = n10.getTemplate("table", t10);
  const o10 = n10.getTemplate("textbox");
  const a10 = ((_e2 = (_d2 = (_c2 = (_b2 = (_a2 = r10.Details) != null ? _a2 : r10.Header) != null ? _b2 : r10.Footer) == null ? void 0 : _c2.TableRows[0]) == null ? void 0 : _d2.TableCells[0]) == null ? void 0 : _e2.Item) || o10;
  return a10 == null ? void 0 : a10.Style;
};
const i4 = (e14, t10) => {
  var _a2, _b2, _c2, _d2, _e2;
  const n10 = nz.of(e14);
  const r10 = n10.getTemplate("table", t10);
  const o10 = n10.getTemplate("textbox");
  const a10 = ((_e2 = (_d2 = (_c2 = (_b2 = (_a2 = r10.Details) != null ? _a2 : r10.Header) != null ? _b2 : r10.Footer) == null ? void 0 : _c2.TableRows[0]) == null ? void 0 : _d2.TableCells[0]) == null ? void 0 : _e2.Item) || o10;
  return { width: a10.$place.Width, height: a10.$place.Height };
};
const s4 = (e14, t10, n10) => (r10, o10) => {
  const a10 = ((e15, t11, n11, r11) => {
    const o11 = nz.of(e15).create("textbox", KB(TG("textbox")));
    const a11 = __spreadValues(__spreadValues({}, o11.Style), a4(e15, r11));
    return __spreadProps(__spreadValues({}, o11), { $place: __spreadProps(__spreadValues({}, o11.$place), { Width: t11, Height: n11 }), Style: a11 });
  })(e14, r10, o10, n10);
  return __spreadProps(__spreadValues({}, a10), { LayerName: t10 });
};
const l4 = (e14, t10) => {
  const { width: n10, height: r10, createCellItem: o10 } = t10;
  return { Item: o10(n10, r10), ColSpan: 1, RowSpan: 1, AutoMergeMode: "Never" };
};
const c4 = [CY.Height, EY.Action, Zq("tableHeader", "", "table_header", ""), Zq("tableFooter", "", "table_footer", ""), EY.Visibility];
const u4 = { Type: "tablerow", Action: { ActionType: "None" }, Height: "0in", TableCells: [], Visibility: { Hidden: "False", ToggleItem: "" } };
function d4(e14, t10) {
  const { cellsWidth: n10, cellHeight: r10, createCellItem: o10 } = t10;
  return __spreadProps(__spreadValues({}, u4), { Height: r10, TableCells: n10.map((t11) => l4(e14, { width: t11, height: r10, createCellItem: o10 })) });
}
const p4 = { type: "tablerow", labelKey: "reportItems:tableRow", defaultModel: u4, getProperties: () => c4 };
const m4 = [MY.Name, MY.GroupExpressionsExt, MY.PageBreakWithBetween, MY.NewPage, MY.Parent, MY.DocumentMapLabel, MY.DataElementName, MY.DataElementOutput, MY.NewSection, MY.Filters, FY.SortExpressions, EY.Visibility];
const h4 = j5.Details;
const f4 = (e14, t10) => {
  const { cellsWidth: n10, cellsHeight: r10, createCellItem: o10 } = t10;
  return __spreadProps(__spreadValues({}, h4), { TableRows: r10.map((t11) => d4(e14, { cellsWidth: n10, cellHeight: t11, createCellItem: o10 })) });
};
const g4 = { type: "tabledetails", labelKey: "reportItems:tableDetails", defaultModel: h4, getProperties: (e14, t10, n10) => (n10 == null ? void 0 : n10.isDashboard) ? n4(m4) : m4 };
const y4 = [];
const v4 = j5.Header;
const b4 = (e14, t10) => {
  const { cellsWidth: n10, cellsHeight: r10, createCellItem: o10 } = t10;
  return __spreadProps(__spreadValues({}, v4), { RepeatOnNewPage: true, TableRows: r10.map((t11) => d4(e14, { cellsWidth: n10, cellHeight: t11, createCellItem: o10 })) });
};
const S4 = { type: v4.Type, labelKey: "reportItems:tableHeader", defaultModel: v4, getProperties: () => y4 };
const C4 = (e14, t10, n10, r10 = 0, o10 = null) => {
  let a10 = n10;
  const i10 = null === o10 ? e14.length : r10 + o10;
  const s10 = e14.map((n11, o11) => {
    if (o11 < r10 || o11 >= i10) return n11;
    if (o11 === e14.length - 1) return n11.multiply(0).add(a10).normalize();
    const s11 = n11.multiply(t10).normalize();
    return a10 = a10.subtract(s11), s11;
  });
  return s10;
};
const x4 = (e14, t10, n10) => KQ(e14, ({ item: e15, colIdx: r10, colSpan: o10, rowIdx: a10, rowSpan: i10 }) => {
  let s10 = e15;
  const [l10, c10] = [L$.sum(n10, r10, o10).css, L$.sum(t10, a10, i10).css];
  if (s10.$width === l10 && s10.$place.Width === l10 && s10.$height === c10 && s10.$place.Height === c10) return s10;
  s10 = n5(s10, A5({ width: l10, height: c10 }));
  const u10 = {};
  return s10.$width && e15.$place.Width !== s10.$width && (u10.Width = { $set: s10.$width }), s10.$height && e15.$place.Height !== s10.$height && (u10.Height = { $set: s10.$height }), zV.isEmpty(u10) || (s10 = AV(s10, { $place: u10 })), s10;
});
const w4 = (e14, t10) => qQ(e14, (e15, n10) => {
  const r10 = t10[n10].css;
  return e15.Height !== r10 ? AV(e15, { Height: { $set: r10 } }) : e15;
});
const T4 = (e14, t10) => {
  const n10 = {};
  return e14.TableColumns.forEach((e15, r10) => {
    const o10 = t10[r10].css;
    e15.Width !== o10 && (n10[r10] = { Width: { $set: o10 } });
  }), zV.isEmpty(n10) ? e14 : AV(e14, { TableColumns: n10 });
};
const E4 = (e14) => {
  const [t10, n10] = [e1(e14), t1(e14)];
  let [r10, o10] = [t10, n10];
  XQ(e14, ({ item: e15, colIdx: t11, colSpan: n11, rowIdx: a11, rowSpan: i10 }) => {
    const [s10, l10] = [L$.sum(r10, a11, i10), L$.sum(o10, t11, n11)];
    const [c10, u10] = [L$.parse(e15.$width || e15.$place.Width), L$.parse(e15.$height || e15.$place.Height)];
    const [d10, p10] = [u10.divide(s10), c10.divide(l10)];
    [r10, o10] = [d10 > 1 ? C4(r10, d10, u10, a11, i10) : r10, p10 > 1 ? C4(o10, p10, c10, t11, n11) : o10];
  });
  let a10 = e14;
  return a10 = x4(a10, r10, o10), a10 = w4(a10, r10), a10 = T4(a10, o10), a10;
};
const F4 = (e14, t10, n10) => {
  const [r10, o10] = [L$.parse(t10), L$.parse(n10)];
  const [a10, i10] = [e1(e14), t1(e14)];
  const [s10, l10] = [o10.divide(L$.sum(a10)), r10.divide(L$.sum(i10))];
  const [c10, u10] = [1 !== s10 ? C4(a10, s10, o10) : a10, 1 !== l10 ? C4(i10, l10, r10) : i10];
  let d10 = e14;
  return d10 = x4(d10, c10, u10), d10 = w4(d10, c10), d10 = T4(d10, u10), d10 !== e14 && (d10 = E4(d10)), d10;
};
const M4 = (e14) => {
  const [t10, n10] = [e1(e14), t1(e14)];
  const [r10, o10] = [L$.sum(t10).css, L$.sum(n10).css];
  const a10 = {};
  return e14.$width !== o10 && (a10.$width = { $set: o10 }), e14.$height !== r10 && (a10.$height = { $set: r10 }), zV.isEmpty(a10) ? e14 : AV(e14, a10);
};
const k4 = (e14) => {
  const [t10, n10] = [e1(e14), t1(e14)];
  let r10 = e14;
  return r10 = x4(r10, t10, n10), r10 !== e14 && (r10 = E4(r10)), r10;
};
const P4 = (e14, t10) => {
  const n10 = (e15) => e15 && L$.parse(e15) || L$.zero;
  const r10 = [];
  const o10 = [];
  const a10 = (e15, t11, r11) => {
    if (e15 === t11) return;
    const o11 = n10(t11).subtract(n10(e15));
    0 !== o11.value && r11(o11);
  };
  const i10 = (e15) => {
    var _a2;
    return e15.$width || ((_a2 = e15.$place) == null ? void 0 : _a2.Width);
  };
  const s10 = (e15) => {
    var _a2;
    return e15.$height || ((_a2 = e15.$place) == null ? void 0 : _a2.Height);
  };
  let l10 = KQ(e14, (e15) => {
    const n11 = t10(e15);
    const { item: l11, colIdx: c10, colSpan: u10, rowIdx: d10, rowSpan: p10 } = e15;
    return n11 === l11 ? l11 : (a10(i10(l11), i10(n11), (e16) => {
      r10[c10 + u10 - 1] = e16;
    }), a10(s10(l11), s10(n11), (e16) => {
      o10[d10 + p10 - 1] = e16;
    }), n11);
  });
  if (l10 === e14) return e14;
  if (!zV.isEmpty(r10)) {
    const t11 = t1(e14).map((e15, t12) => {
      if (!r10[t12]) return e15;
      const n11 = e15.multiply(0).add(G5);
      return L$.max([e15.add(r10[t12]), n11]);
    });
    l10 = T4(l10, t11);
  }
  if (!zV.isEmpty(o10)) {
    const t11 = e1(e14).map((e15, t12) => {
      if (!o10[t12]) return e15;
      const n11 = e15.multiply(0).add(G5);
      return L$.max([e15.add(o10[t12]), n11]);
    });
    l10 = w4(l10, t11);
  }
  return l10 = k4(l10), l10 = M4(l10), l10;
};
const N4 = [];
const D4 = j5.Footer;
const L4 = (e14, t10) => {
  const { cellsWidth: n10, cellsHeight: r10, createCellItem: o10 } = t10;
  return __spreadProps(__spreadValues({}, D4), { TableRows: r10.map((t11) => d4(e14, { cellsWidth: n10, cellHeight: t11, createCellItem: o10 })) });
};
const H4 = { type: D4.Type, labelKey: "reportItems:tableFooter", defaultModel: D4, getProperties: () => N4 };
const I4 = [MY.Name, MY.GroupExpressions, MY.PageBreakWithBetween, MY.NewPage, MY.Parent, MY.DocumentMapLabel, MY.DataElementName, MY.DataElementOutput, MY.NewSection, MY.Filters, FY.SortExpressions, Zq(cY, "table.keepTogether", "boolean", "KeepTogether"), Zq(cY, "table.preventOrphanedFooter", "boolean", "PreventOrphanedFooter"), EY.Visibility];
const _4 = __spreadProps(__spreadValues({}, j5.TableGroups[0]), { PreventOrphanedFooter: true });
const V4 = (e14, t10, n10, r10, o10) => {
  const a10 = __spreadProps(__spreadValues({}, _4), { Header: b4(e14, t10), Footer: L4(e14, t10), Group: __spreadProps(__spreadValues({}, _4.Group), { Name: MG(n10, r10 || TG("tableGroup")), GroupExpressions: [o10 || ""] }) });
  return o10 ? AV(a10, { Header: { TableRows: { 0: { TableCells: { 0: { Item: { Value: { $set: o10 } } } } } } } }) : a10;
};
const R4 = { type: "tablegroup", labelKey: "reportItems:tableGroup", nameTemplateKey: "nameTemplates:tableGroup", defaultModel: _4, getProperties: (e14, t10, n10) => (n10 == null ? void 0 : n10.isDashboard) ? I4.filter((e15) => "Group.PageBreak" !== e15.valuePath) : I4 };
const A4 = (e14, t10, n10, r10) => {
  const { group: o10, columns: a10, details: i10 } = r10;
  const s10 = (e15) => {
    const t11 = e15.TableRows[0].TableCells.map((e16, t12) => {
      const { label: n11 } = a10[t12];
      return AV(e16, { Item: { Value: { $set: n11 || "" } } });
    });
    return AV(e15, { TableRows: { 0: { TableCells: { $set: t11 } } } });
  };
  const l10 = (e15) => {
    const n11 = e15.TableRows[0].TableCells.map((e16, t11) => {
      const { expr: n12, format: r12, label: o12 } = a10[t11];
      return AV(e16, { Item: { Value: { $set: n12 || "" }, Style: { Format: { $set: r12 || "" } }, DataElementName: { $set: o12 || "" } } });
    });
    const r11 = i10 && i10.expressions || [];
    const o11 = r11.length > 0 ? MG(t10, TG("tableDetailsGroup")) : "";
    return AV(e15, { Group: { Name: { $set: o11 }, GroupExpressions: { $set: r11 } }, TableRows: { 0: { TableCells: { $set: n11 } } } });
  };
  const c10 = (() => {
    var _a2;
    const i11 = o10 ? 3 : 2;
    const c11 = a10.length || 1;
    const u10 = nz.of(e14).create("table", t10, void 0, n10);
    const [d10, p10] = [u10.TableColumns[0].Width, ((_a2 = u10.Details) == null ? void 0 : _a2.TableRows[0].Height) || "0.25in"];
    const m10 = zV.times(c11, () => d10);
    const h10 = L$.parse(d10).multiply(c11).css;
    const f10 = L$.parse(p10).multiply(i11).css;
    const g10 = { cellsWidth: m10, cellsHeight: [p10], createCellItem: s4(e14, u10.LayerName) };
    const y10 = [];
    if (o10) {
      const n11 = AV(V4(e14, g10, t10, o10.name || ""), { Group: { GroupExpressions: { $set: o10.expressions || [] } }, Header: { $apply: (e15) => ((e16, { label: t11, format: n12 }) => {
        const r11 = e16.TableRows[0].TableCells;
        const o11 = L$.sum(r11.map((e17) => e17 && e17.Item ? L$.parse(e17.Item.$place.Width) : L$.zero));
        const a11 = AV(r11[0], { ColSpan: { $set: r11.length }, Item: { Value: { $set: t11 || "" }, Style: { Format: { $set: n12 || "" } }, $place: { Width: { $set: o11.css } } } });
        const i12 = zV.times(r11.length, (e17) => 0 === e17 ? a11 : null);
        return AV(e16, { TableRows: { 0: { TableCells: { $set: i12 } } } });
      })(e15, o10) }, Footer: { $set: null } });
      y10.push(n11);
    }
    const v10 = __spreadValues(__spreadProps(__spreadValues({}, W5), { Name: t10, $place: __spreadProps(__spreadValues({}, u10.$place), { Width: h10, Height: f10 }), Header: s10(b4(e14, g10)), Details: l10(f4(e14, g10)), TableGroups: y10, TableColumns: m10.map((e15) => X5({ Width: e15 })) }), n10);
    const b10 = ((e15, t11) => {
      if (!t11) return e15;
      const { Width: n11, Height: r11 } = t11;
      const o11 = L$.parse(e15.$place.Width);
      const a11 = L$.parse(n11);
      const i12 = G5.multiply(QQ(e15));
      const s11 = L$.parse(e15.$place.Height);
      const l11 = L$.parse(r11);
      const c12 = G5.multiply(JQ(e15));
      if (a11.lowerThan(i12) || l11.lowerThan(c12)) return e15;
      const u11 = o11.greaterThan(a11) ? a11 : o11;
      const d11 = s11.greaterThan(l11) ? l11 : s11;
      if (u11.equal(o11) && d11.equal(s11)) return e15;
      const p11 = u11.css;
      const m11 = d11.css;
      return AV(F4(e15, p11, m11), { $place: { Width: { $set: p11 }, Height: { $set: m11 } } });
    })(v10, r10.maxSize);
    return b10;
  })();
  return c10;
};
const O4 = { RepeatBlankRows: "None", $fixedPlace: { Width: "3in", Height: "0.75in", OverflowName: "" } };
const B4 = __spreadValues(__spreadProps(__spreadValues({}, W5), { Type: "fixedpagetable" }), O4);
const z4 = (e14 = 0) => (t10) => {
  const n10 = __pow(10, e14);
  return Math.round(t10 * n10) / n10;
};
const $4 = (e14, t10 = -1 / 0, n10 = 1 / 0) => Math.min(Math.max(e14, t10), n10);
const W4 = (e14, t10, n10) => {
  let r10 = Math.round;
  return "floor" === n10 && (r10 = Math.floor), "ceil" === n10 && (r10 = Math.ceil), z4(6)(r10(e14 / t10) * t10);
};
const j4 = (e14, t10, n10, r10, o10, a10) => {
  const i10 = r10 ? n10 : W4(n10, t10, "ceil");
  const s10 = a10 ? o10 : W4(o10, t10, "floor");
  const l10 = W4(e14, t10);
  return $4(l10, i10, s10);
};
const Z4 = (e14, t10, n10 = true) => {
  const r10 = Math.round(e14 / t10);
  return (0 !== r10 || n10 ? r10 : Math.ceil(e14 / t10)) * t10;
};
const G4 = (e14, t10) => {
  if (t10.length < 3) return t10;
  const n10 = "vertical" === e14 ? "Top" : "Left";
  const r10 = "vertical" === e14 ? "Height" : "Width";
  const o10 = t10.sort((e15, t11) => e15.place[n10] - t11.place[n10]);
  const a10 = o10[0].place[n10] + o10[0].place[r10];
  const i10 = o10[o10.length - 1].place[n10];
  const s10 = o10.slice(1, o10.length - 1);
  let l10 = (i10 - a10 - s10.reduce((e15, t11) => e15 + t11.place[r10], 0)) / (s10.length + 1);
  l10 = l10 > 0 ? l10 : 0;
  let c10 = a10;
  return o10.map((e15, t11) => {
    if (0 === t11) return e15;
    if (t11 === o10.length - 1 && l10) return e15;
    const a11 = e15.place;
    const i11 = AV(e15, { place: { [n10]: { $set: c10 + l10 } } });
    return c10 += a11[r10] + l10, i11;
  });
};
const U4 = (e14, t10) => {
  const n10 = "vertical" === e14 ? "Top" : "Left";
  const r10 = "vertical" === e14 ? "Height" : "Width";
  const o10 = t10.sort((e15, t11) => e15.place[n10] - t11.place[n10]);
  let a10 = 0;
  return o10.map((e15, t11) => {
    const o11 = e15.place;
    if (0 === t11) return a10 = o11[n10] + o11[r10], e15;
    const i10 = AV(e15, { place: { [n10]: { $set: a10 } } });
    return a10 += o11[r10], i10;
  });
};
const q4 = (e14, t10, n10, r10, o10) => {
  const a10 = "vertical" === e14 ? "Top" : "Left";
  const i10 = z4(4)(n10.place[a10]);
  const s10 = t10.place;
  const l10 = s10[a10];
  if (n10.path === t10.path) return t10;
  const c10 = o10 ? l10 > i10 ? -r10 : r10 : l10 <= i10 ? -r10 : r10;
  const u10 = s10[a10] + c10;
  return AV(t10, { place: { [a10]: { $set: Math.max(u10, 0) } } });
};
function Y4(e14, t10, n10) {
  const r10 = t10.Left;
  const o10 = t10.Left + t10.Width / 2;
  const a10 = t10.Left + t10.Width;
  const { place: { Width: i10 } } = e14;
  switch (n10) {
    case "left":
      return AV(e14, { place: { Left: { $set: r10 } } });
    case "center":
      return AV(e14, { place: { Left: { $set: Math.max(o10 - i10 / 2, 0) } } });
    case "right":
      return AV(e14, { place: { Left: { $set: Math.max(a10 - i10, 0) } } });
    default:
      return e14;
  }
}
function K4(e14, t10, n10) {
  const r10 = t10.Top;
  const o10 = t10.Top + t10.Height / 2;
  const a10 = t10.Top + t10.Height;
  const { place: { Height: i10 } } = e14;
  switch (n10) {
    case "top":
      return AV(e14, { place: { Top: { $set: r10 } } });
    case "middle":
      return AV(e14, { place: { Top: { $set: Math.max(o10 - i10 / 2, 0) } } });
    case "bottom":
      return AV(e14, { place: { Top: { $set: Math.max(a10 - i10, 0) } } });
    default:
      return e14;
  }
}
function X4(e14) {
  const { Left: t10, Top: n10, Width: r10, Height: o10 } = e14;
  return { Top: L$.parseSafe(n10).value, Left: L$.parseSafe(t10).value, Width: L$.parseSafe(r10).value, Height: L$.parseSafe(o10).value };
}
function J4(e14, t10) {
  const { Left: n10, Top: r10, Width: o10, Height: a10 } = e14;
  return { Top: new L$(r10, t10).css, Left: new L$(n10, t10).css, Width: new L$(o10, t10).css, Height: new L$(a10, t10).css };
}
const Q4 = (e14) => ((e15) => e15.Groups.some((e16) => rj(e16) || rj(e16.Header) || rj(e16.Footer)))(e14) || rj(e14.Header) || rj(e14.Footer) || rj(e14.Details);
const e32 = (e14) => o3(e14).filter(rj);
const t3 = (e14) => o3(e14).reduce((e15, t10) => {
  if (!aj(t10)) return e15;
  const n10 = t10.ReportItems.filter(rj);
  return [...e15, ...n10];
}, []);
const n3 = (e14) => {
  const t10 = yj(e14);
  if (0 === t10.length) return false;
  const n10 = [...e14.Groups.filter(rj), ...t3(e14), ...e32(e14)];
  return t10.length === n10.length;
};
function r3(e14) {
  const t10 = [];
  e14.Details && t10.push({ band: e14.Details });
  for (let n10 = e14.Groups.length; n10--; ) {
    const r10 = e14.Groups[n10];
    r10.Header && t10.unshift({ band: r10.Header, groupIndex: n10 }), r10.Footer && t10.push({ band: r10.Footer, groupIndex: n10 });
  }
  return e14.Header && t10.unshift({ band: e14.Header }), e14.Footer && t10.push({ band: e14.Footer }), t10;
}
function o3(e14) {
  const t10 = [e14, ...e14.Groups];
  const n10 = t10.map((e15) => e15.Header);
  const r10 = t10.map((e15) => e15.Footer);
  return [...n10, ...r10, e14.Details].filter(Boolean);
}
const a3 = { [rW.bandedListHeader]: "Header", [rW.bandedListFooter]: "Footer", [rW.bandedListDetails]: "Details" };
function i3({ band: e14, groupIndex: t10 }) {
  let n10 = a3[e14.Type];
  return void 0 !== t10 && (n10 = `Groups.${t10}.${n10}`), n10;
}
function s3(e14) {
  const t10 = (e15) => L$.parse(e15);
  const { Width: n10, Page: r10 } = e14;
  const { TopMargin: o10, BottomMargin: a10, LeftMargin: i10, RightMargin: s10, PageWidth: l10, PageHeight: c10 } = r10;
  const [u10, d10, p10, m10, h10, f10, g10] = [t10(o10), t10(a10), t10(i10), t10(s10), t10(n10), t10(l10), t10(c10)];
  const y10 = g10.subtract(u10).subtract(d10);
  const v10 = f10.subtract(p10).subtract(m10);
  const b10 = e14.PageHeader && t10(e14.PageHeader.$place.Height) || L$.zero;
  const S10 = e14.PageFooter && t10(e14.PageFooter.$place.Height) || L$.zero;
  const C10 = t10(e14.Body.$place.Height);
  const x10 = y10.subtract(b10).subtract(S10);
  const w10 = C10.greaterThan(x10) ? C10 : x10;
  const T10 = (e15) => {
    const [t11, n11] = "x" === e15 ? [v10, h10] : [x10, C10];
    return t11.lowerThanOrEqual(L$.zero) ? 1 : Math.ceil(n11.divide(t11)) || 1;
  };
  const E10 = T10("x");
  const F10 = T10("y");
  const M10 = v10.multiply(E10);
  const k10 = M10.add(p10).add(m10);
  const P10 = w10.add(b10).add(S10);
  return { pageWidth: k10, pageHeight: P10.add(u10).add(d10), sectionWidth: M10, sectionHeight: P10, headerHeight: b10, footerHeight: S10, bodyHeight: w10, pageBodyHeight: x10, verticalPageNumber: F10, horizontalPageNumber: E10 };
}
const l3 = (e14) => {
  if (!e14) return [];
  return e14.$calculatedFields || [];
};
const c3 = (e14) => `[+] ${e14.Name}`;
const u3 = (e14, t10) => ({ Name: e14, Value: `=Parameters!${t10}.Value` });
const d3 = (e14, t10) => {
  var _a2, _b2;
  const n10 = T0(e14, 0, ((e15) => {
    var _a3, _b3, _c2, _d2, _e2, _f2, _g2;
    return { DataType: ((_a3 = e15.$legacy) == null ? void 0 : _a3.DbType) || "String", AllowBlank: Bj((_b3 = e15.$legacy) == null ? void 0 : _b3.AllowBlank), Nullable: Bj((_c2 = e15.$legacy) == null ? void 0 : _c2.IsNullable), MultiValue: Bj((_d2 = e15.$legacy) == null ? void 0 : _d2.IsMultiValued), Multiline: Bj((_e2 = e15.$legacy) == null ? void 0 : _e2.IsMultiline), Hidden: Bj((_f2 = e15.$legacy) == null ? void 0 : _f2.IsHidden), Prompt: ((_g2 = e15.$legacy) == null ? void 0 : _g2.Caption) || e15.Name || "" };
  })(t10));
  const r10 = ((_b2 = (_a2 = t10.$legacy) == null ? void 0 : _a2.DefaultValue) == null ? void 0 : _b2.Values) || [];
  return AV(n10, { DefaultValue: { Values: { $set: r10 } } });
};
function p3(e14, t10 = "") {
  let n10;
  return t10 && "fixedpagereport" === e14.Type && (n10 = e14.Pages.find((e15) => e15.Name === t10)), { Width: h3(e14, n10).css, Height: f3(e14, n10).css };
}
const m3 = (e14, t10) => {
  const { Page: n10 } = e14;
  return { height: L$.parse((t10 == null ? void 0 : t10.Height) || n10.PageHeight), topMargin: L$.parse((t10 == null ? void 0 : t10.TopMargin) || n10.TopMargin), bottomMargin: L$.parse((t10 == null ? void 0 : t10.BottomMargin) || n10.BottomMargin), width: L$.parse((t10 == null ? void 0 : t10.Width) || n10.PageWidth), leftMargin: L$.parse((t10 == null ? void 0 : t10.LeftMargin) || n10.LeftMargin), rightMargin: L$.parse((t10 == null ? void 0 : t10.RightMargin) || n10.RightMargin) };
};
const h3 = (e14, t10) => {
  const { width: n10, leftMargin: r10, rightMargin: o10 } = m3(e14, t10);
  return n10.subtract(r10).subtract(o10);
};
const f3 = (e14, t10) => {
  const { height: n10, topMargin: r10, bottomMargin: o10 } = m3(e14, t10);
  return n10.subtract(r10).subtract(o10);
};
function g3(e14, t10, n10, r10, o10) {
  if (!t10 || "string" != typeof t10.Type) return;
  const a10 = n10(r10, t10, e14, o10);
  if (null !== a10) switch (t10.Type) {
    case "Continuous":
    case "dashboardsection":
      Z0.forEach((e15) => {
        const r11 = t10[e15];
        r11 && g3(t10, r11, n10, a10, { sectionName: e15 });
      });
      break;
    case "fixedpagereport":
      t10.Pages.forEach((e15, r11) => g3(t10, e15, n10, a10, { index: r11 }));
      break;
    case "multisectionreport":
    case "dashboard":
      t10.ReportSections.forEach((e15, r11) => g3(t10, e15, n10, a10, { index: r11 }));
      break;
    case "rectangle":
    case "contentplaceholder":
    case "fixedpagerectangle":
    case "pagesection":
    case "fixedpagesection":
    case "section":
    case "fixedpagelist":
    case "list":
    case "bandedlistdetails":
    case "bandedlistfooter":
    case "bandedlistheader":
      t10.ReportItems.forEach((e15, r11) => g3(t10, e15, n10, a10, { index: r11 }));
      break;
    case "table":
    case "fixedpagetable":
      XQ(t10, (e15) => {
        const { item: r11 } = e15;
        g3(t10, r11, n10, a10, { cellInfo: e15 });
      }), WQ(t10, (e15, r11) => {
        g3(t10, e15, n10, a10, { sectionPath: r11 });
      }), YQ(t10, (e15, r11, o11) => {
        g3(t10, e15, n10, a10, { rowIdx: r11, rowPath: o11 });
      }), t10.TableColumns.forEach((e15, r11) => {
        g3(t10, e15, n10, a10, { index: r11 });
      });
      break;
    case "fixedpagetablix":
    case "tablix":
      AQ(t10, (e15) => {
        const { item: r11 } = e15;
        return g3(t10, r11, n10, a10, { tablixCell: e15 }), r11;
      }, (e15) => {
        const { member: r11 } = e15;
        return g3(t10, r11, n10, a10, { memberInfo: e15 }), r11;
      }), t10.$rows.collection.forEach((e15, r11) => {
        g3(t10, e15, n10, a10, { index: r11 });
      }), t10.$columns.collection.forEach((e15, r11) => {
        g3(t10, e15, n10, a10, { index: r11 });
      });
      break;
    case "bandedlist":
    case "fixedpagebandedlist":
      r3(t10).forEach((e15, r11) => {
        g3(t10, e15.band, n10, a10, { bandInfo: e15, idx: r11 });
      });
      break;
    case "fixedpagedvchart":
    case "dvchart":
      ["PlotArea", "Header", "Footer"].forEach((e15) => {
        const r11 = t10[e15];
        r11 && g3(t10, r11, n10, a10, { sectionPath: e15 });
      }), t10.Plots.forEach((e15, r11) => {
        g3(t10, e15, n10, a10, { index: r11 });
      });
      break;
    case "dvchartplot": {
      const e15 = t10.Encodings;
      ["Color", "Shape", "Size", "Category"].forEach((r11) => {
        const o11 = e15[r11];
        o11 && g3(t10, o11, n10, a10, { encodingPath: `Encodings.${r11}` });
      }), e15.Values.forEach((e16, r11) => {
        g3(t10, e16, n10, a10, { encodingPath: `Encodings.Values.${r11}` });
      }), e15.Details.forEach((e16, r11) => {
        g3(t10, e16, n10, a10, { encodingPath: `Encodings.Details.${r11}` });
      });
      break;
    }
    case "dvchartplotarea":
      t10.Axes.forEach((e15, r11) => {
        g3(t10, e15, n10, a10, { index: r11 });
      }), t10.Legends.forEach((e15, r11) => {
        g3(t10, e15, n10, a10, { index: r11 });
      });
  }
}
const y3 = (e14) => {
  try {
    return L$.parse(e14 != null ? e14 : L$.zero.css);
  } catch (e15) {
    return L$.zero;
  }
};
const v3 = (e14, t10, n10) => ({ Left: L$.zero, Top: L$.sum(e14, 0, t10), Width: n10.Width, Height: e14[t10] });
const b3 = (e14, t10, n10) => ({ Left: L$.sum(e14, 0, t10), Top: L$.zero, Width: e14[t10], Height: n10.Height });
const S3 = (e14, t10, n10, r10, o10, a10) => ({ Left: L$.sum(t10, 0, r10), Top: L$.sum(e14, 0, n10), Width: L$.sum(t10, r10, r10 + a10), Height: L$.sum(e14, n10, n10 + o10) });
function C3(e14, t10, n10 = {}) {
  g3(null, e14, t10, n10);
}
const x3 = (e14) => (t10, n10, r10, o10 = {}) => {
  const { parentPath: a10 } = t10;
  const i10 = $j(a10, function(e15, t11, n11 = {}) {
    if (!e15) return "";
    const r11 = e15 == null ? void 0 : e15.Type;
    const o11 = t11 == null ? void 0 : t11.Type;
    const { index: a11 } = n11;
    switch (r11) {
      case "Continuous":
      case "dashboardsection": {
        const { sectionName: e16 } = n11;
        return e16;
      }
      case "multisectionreport":
      case "dashboard":
        return `ReportSections.${a11}`;
      case "fixedpagereport":
        return `Pages.${a11}`;
      case "rectangle":
      case "contentplaceholder":
      case "fixedpagerectangle":
      case "pagesection":
      case "fixedpagesection":
      case "section":
      case "fixedpagelist":
      case "list":
      case "bandedlistdetails":
      case "bandedlistfooter":
      case "bandedlistheader":
        return `ReportItems.${a11}`;
      case "bandedlist":
      case "fixedpagebandedlist": {
        const { bandInfo: e16 } = n11;
        return i3(e16);
      }
      case "table":
      case "fixedpagetable":
        switch (o11) {
          case "tablerow": {
            const { rowPath: e16 } = n11;
            return e16;
          }
          case "tablecolumn":
            return `TableColumns.${a11}`;
          case "tableheader":
          case "tablefooter":
          case "tabledetails":
          case "tablegroup": {
            const { sectionPath: e16 } = n11;
            return e16;
          }
          default: {
            const { cellInfo: e16 } = n11;
            return e16.itemPath;
          }
        }
      case "fixedpagetablix":
      case "tablix":
        switch (o11) {
          case "tablixrow":
            return `$rows.collection.${a11}`;
          case "tablixcolumn":
            return `$columns.collection.${a11}`;
          default: {
            const { tablixCell: e16, memberInfo: t12 } = n11;
            return (e16 == null ? void 0 : e16.itemPath) || (t12 == null ? void 0 : t12.itemPath);
          }
        }
      case "fixedpagedvchart":
      case "dvchart":
        switch (o11) {
          case "dvchartheader":
          case "dvchartfooter":
          case "dvchartplotarea": {
            const { sectionPath: e16 } = n11;
            return e16;
          }
          case "dvchartplot":
            return `Plot.${a11}`;
        }
        break;
      case "dvchartplot": {
        const { encodingPath: e16 } = n11;
        return e16;
      }
      case "dvchartaggregateencoding":
      case "dvchartcategoryencoding":
        return `Field.Value.${a11}`;
      case "dvchartplotarea":
        switch (o11) {
          case "dvchartaxis":
            return `Axes.${a11}`;
          case "dvchartlegend":
            return `Legends.${a11}`;
        }
        break;
      default:
        throw new Error(`walkReportNodes::getRelativeChildPath(): Could not find child path for parent:${e15.Type} child:${t11.Type}`);
    }
    return "";
  }(r10, n10, o10));
  let s10 = e14(t10, n10, r10, __spreadProps(__spreadValues({}, o10), { path: i10 }));
  return null === s10 ? null : (s10 || (s10 = {}), s10.parentPath = i10, s10);
};
const w3 = (e14) => (t10, n10, r10, o10 = {}) => {
  const a10 = function(e15, t11, n11, r11) {
    var _a2, _b2;
    if (!n11 || !n11.Type) switch (t11.Type) {
      case "fixedpagereport":
        return t11.Pages.map((e16) => ({ Left: y3(e16.LeftMargin || t11.Page.LeftMargin), Top: y3(e16.TopMargin || t11.Page.TopMargin) }));
      case "multisectionreport":
        return t11.ReportSections.map((e16) => ({ Left: y3(e16.Page.LeftMargin), Top: y3(e16.Page.TopMargin) }));
      case "dashboard":
        return t11.ReportSections.map(() => ({ Left: L$.zero, Top: L$.zero }));
      default:
        return Q$(t11) ? J$(t11) ? { Left: L$.zero, Top: L$.zero, Width: L$.zero, Height: y3(t11.$place.Height) } : { Left: L$.zero, Top: L$.zero, Width: y3(t11.$place.Width), Height: y3(t11.$place.Height) } : { Left: L$.zero, Top: L$.zero, Width: L$.zero, Height: L$.zero };
    }
    switch (n11.Type) {
      case "multisectionreport":
        return { Left: y3(t11.Page.LeftMargin), Top: y3(t11.Page.TopMargin) };
      case "dashboard": {
        const { Body: e16, PageHeader: n12, PageFooter: r12 } = t11;
        const o11 = L$.sum([y3(e16.$place.Height), y3((_a2 = n12 == null ? void 0 : n12.$place) == null ? void 0 : _a2.Height), y3((_b2 = r12 == null ? void 0 : r12.$place) == null ? void 0 : _b2.Height)]);
        return { Left: L$.zero, Top: L$.zero, Width: y3(t11.Width), Height: o11 };
      }
      case "Continuous": {
        const { reportViewModel: t12, sectionTops: n12, sectionHeights: o11 } = e15;
        const { sectionName: a11 } = r11;
        return { Left: L$.zero, Top: n12[a11], Width: t12.sectionWidth, Height: o11[a11] };
      }
      case "dashboardsection": {
        const { sectionTops: t12, sectionHeights: n12, width: o11 } = e15;
        const { sectionName: a11 } = r11;
        return { Left: L$.zero, Top: t12[a11], Width: o11, Height: n12[a11] };
      }
      case "fixedpagereport": {
        const { pagesPlace: t12 } = e15;
        const { index: n12 } = r11;
        return t12[n12];
      }
      case "bandedlist":
      case "fixedpagebandedlist": {
        const { bandHeights: o11 } = e15;
        const { idx: a11 } = r11;
        return { Left: L$.zero, Top: L$.sum(o11, 0, a11), Width: y3(n11.$place.Width), Height: y3(t11.$place.Height) };
      }
      case "table":
      case "fixedpagetable": {
        const { rowSizes: n12, columnSizes: o11, parentPlace: a11 } = e15;
        switch (t11.Type) {
          case "tablerow": {
            const { rowIdx: e16 } = r11;
            return v3(n12, e16, a11);
          }
          case "tablecolumn": {
            const { index: e16 } = r11;
            return b3(o11, e16, a11);
          }
          default: {
            const { cellInfo: e16 } = r11;
            if (!e16) return a11;
            const { colIdx: t12, rowIdx: i11, colSpan: s11, rowSpan: l10 } = e16;
            return S3(n12, o11, i11, t12, l10, s11);
          }
        }
      }
      case "tablix":
      case "fixedpagetablix": {
        const { rowSizes: n12, columnSizes: o11, parentPlace: a11 } = e15;
        const { index: i11 } = r11;
        switch (t11.Type) {
          case "tablixrow":
            return v3(n12, i11, a11);
          case "tablixcolumn":
            return b3(o11, i11, a11);
          default: {
            const { tablixCell: e16 } = r11;
            if (!e16) return a11;
            const { cix: t12, cspan: i12, rix: s11, rspan: l10 } = e16;
            return S3(n12, o11, s11, t12, l10, i12);
          }
        }
      }
      default: {
        const e16 = t11;
        return e16.$place ? { Left: y3(e16.$place.Left || ""), Top: y3(e16.$place.Top || ""), Width: y3(e16.$place.Width || ""), Height: y3(e16.$place.Height || "") } : {};
      }
    }
  }(t10, n10, r10, o10);
  let i10 = e14(t10, n10, r10, __spreadProps(__spreadValues({}, o10), { place: a10 }));
  if (null === i10) return null;
  i10 || (i10 = {}), i10.parentPlace = a10;
  const s10 = function(e15) {
    const t11 = {};
    switch (e15.Type) {
      case "Continuous": {
        const n11 = t11;
        const r11 = s3(e15);
        n11.reportViewModel = r11, n11.sectionTops = {}, n11.sectionHeights = {};
        let o11 = L$.zero;
        Z0.filter((t12) => !!e15[t12]).forEach((t12) => {
          const a11 = e15[t12];
          const i11 = "section" === a11.Type ? r11.bodyHeight : L$.parse(a11.$place.Height) || L$.zero;
          n11.sectionHeights[t12] = i11, n11.sectionTops[t12] = o11, o11 = o11.add(i11);
        });
        break;
      }
      case "dashboardsection": {
        const n11 = t11;
        n11.sectionTops = {}, n11.sectionHeights = {}, n11.width = y3(e15.Width);
        let r11 = L$.zero;
        Z0.filter((t12) => !!e15[t12]).forEach((t12) => {
          const o11 = e15[t12];
          const a11 = y3(o11.$place.Height);
          n11.sectionHeights[t12] = a11, n11.sectionTops[t12] = r11, r11 = r11.add(a11);
        });
        break;
      }
      case "fixedpagereport": {
        const { Pages: n11, Page: r11 } = e15;
        const o11 = n11.map((t12) => __spreadProps(__spreadValues({}, p3(e15, t12.Name)), { Top: t12.TopMargin, Left: t12.LeftMargin }));
        t11.pagesPlace = o11.map((e16) => ({ Top: y3(e16.Top || r11.TopMargin), Left: y3(e16.Left || r11.LeftMargin), Width: y3(e16.Width || r11.PageWidth), Height: y3(e16.Height || r11.PageHeight) }));
        break;
      }
      case "bandedlist":
      case "fixedpagebandedlist":
        t11.bandHeights = r3(e15).map((e16) => y3(e16.band.$place.Height));
        break;
      case "table":
      case "fixedpagetable":
        t11.rowSizes = e1(e15), t11.columnSizes = t1(e15);
        break;
      case "fixedpagetablix":
      case "tablix":
        t11.rowSizes = IQ(e15), t11.columnSizes = HQ(e15);
        break;
      default:
        return null;
    }
    return t11;
  }(n10);
  return null === s10 ? i10 : __spreadValues(__spreadValues({}, i10), s10);
};
const T3 = { isLocked: false, isVisible: true, opacity: 1, dataFieldVisible: false };
function E3(e14) {
  return { isLocked: e14.DesignerLock, isVisible: e14.DesignerVisible, opacity: 1 - e14.DesignerTransparency, dataFieldVisible: e14.DesignerDataFieldVisible };
}
function F3(e14, t10) {
  const n10 = __spreadValues({}, T3);
  if (!t10 || !e14 || !e14.length) return n10;
  const r10 = e14.find((e15) => e15.Name === t10);
  return r10 ? E3(r10) : n10;
}
const M3 = ({ Layers: e14 }, t10) => {
  if (0 === e14.length) throw new Error("Report contains no layers");
  const n10 = e14.find((e15) => e15.Name === t10);
  if (!n10) throw new Error(`Layer ${t10} not found`);
  return n10;
};
function k3(e14, t10) {
  if (e14.$layerInfo) return e14.$layerInfo;
  if (J7(e14) || "contentplaceholder" === e14.Type) return T3;
  const n10 = e14 && e14.LayerName || "";
  if (!n10) return T3;
  return E3(M3(t10, n10));
}
const P3 = (e14, t10) => {
  const n10 = [];
  return C3(e14, x3((e15, r10, o10, { path: a10 }) => {
    if (!r10 || !r10.LayerName) return null;
    const i10 = a10 && `${a10}.LayerName` || "LayerName";
    return n10.push({ descriptor: { valuePath: i10 }, value: t10 }), {};
  }), { path: "" }), n10.length > 0 ? n10.reduce((e15, { descriptor: t11, value: n11 }) => J2(e15, c2({ descriptor: t11, value: n11, path: "" })), e14) : e14;
};
const N3 = (e14, t10) => ({ Width: e14.Width.greaterThan(t10.Width) ? e14.Width : t10.Width, Height: e14.Height.greaterThan(t10.Height) ? e14.Height : t10.Height });
const D3 = (e14) => ({ Width: e14.$place && e14.$place.Left && e14.$place.Width && L$.parse(e14.$place.Left).add(L$.parse(e14.$place.Width)) || L$.zero, Height: e14.$place && e14.$place.Top && e14.$place.Height && L$.parse(e14.$place.Top).add(L$.parse(e14.$place.Height)) || L$.zero });
function L3(e14) {
  let t10 = { Width: L$.zero, Height: L$.zero };
  return e14.ReportItems.forEach((e15) => {
    const n10 = D3(e15);
    t10 = N3(n10, t10);
  }), t10;
}
const H3 = (e14) => {
  const t10 = e14.ReportItems;
  return t10.length > 0 ? L$.max(t10.map((e15) => L$.sum([L$.parseSafe(e15.$place.Top), L$.parseSafe(e15.$place.Height)]))) : L$.zero;
};
const I3 = (e14) => {
  const t10 = e14.ReportItems;
  return t10.length > 0 ? L$.max(t10.map((e15) => L$.sum([L$.parseSafe(e15.$place.Width), L$.parseSafe(e15.$place.Left)]))) : L$.zero;
};
const _3 = (e14) => {
  const t10 = nz.of(e14).getTemplate("rectangle");
  const { BackgroundColor: n10, Border: r10, TopBorder: o10, BottomBorder: a10, LeftBorder: i10, RightBorder: s10 } = t10.Style;
  return { BackgroundColor: n10, Border: r10, TopBorder: o10, BottomBorder: a10, LeftBorder: i10, RightBorder: s10 };
};
const V3 = (e14, t10, n10) => {
  const r10 = {};
  return ["Color", "Width", "Style"].forEach((o10) => {
    ((e15, t11, n11, r11) => Oj(e15, t11, r11) && (!n11 || !n11[r11] || e15[r11] && n11[r11] !== e15[r11] || Oj(n11, t11, r11)))(e14, t10, n10, o10) && (r10[o10] = { $set: t10[o10] });
  }), Object.keys(r10).length > 0 ? r10 : null;
};
const R3 = (e14, t10) => {
  const n10 = {};
  if (t10.Border) {
    const r10 = V3(e14.Style.Border, t10.Border, {});
    r10 && (n10.Border = r10);
  }
  return Oj(e14.Style, t10, "BackgroundColor") && (n10.BackgroundColor = { $set: t10.BackgroundColor }), Object.keys(n10).length > 0 ? n10 : null;
};
const A3 = (e14, t10) => {
  const n10 = e14 && e14.$targetType === wj.Rectangle;
  const r10 = _3(t10);
  return n10 ? __spreadValues(__spreadValues({}, r10), e14) : r10;
};
const O3 = (e14, t10) => e14 && e14.subtract(t10);
const B3 = (e14, t10) => {
  const n10 = t10 && nz.of(t10).getFeature(e14.Type, "getMinContentSize");
  return n10 ? n10(e14) : L3(e14);
};
function z3(e14) {
  let t10 = e14;
  return e14.$width && (t10 = AV(t10, { $place: { Width: { $set: e14.$width } } })), e14.$height && (t10 = AV(t10, { $place: { Height: { $set: e14.$height } } })), t10;
}
const $3 = (e14) => ({ Left: e14.Left, Top: e14.Top, Width: O3(e14.Right, e14.Left), Height: O3(e14.Bottom, e14.Top) });
function W3(e14, t10, n10) {
  const { Left: r10, Top: o10, Bottom: a10, Right: i10 } = t10;
  let [s10, l10] = [r10 || L$.parse(e14.$place.Left), o10 || L$.parse(e14.$place.Top)];
  let [c10, u10] = [i10 || s10.add(L$.parse(e14.$place.Width)), a10 || l10.add(L$.parse(e14.$place.Height))];
  const d10 = (e15, t11) => e15.greaterThan(t11) ? e15 : t11;
  const p10 = (e15, t11) => e15.lowerThan(t11) ? e15 : t11;
  n10.indexOf(qG.W) >= 0 ? s10 = p10(s10, c10) : n10.indexOf(qG.E) >= 0 && (c10 = d10(c10, s10)), n10.indexOf(qG.N) >= 0 ? l10 = p10(l10, u10) : n10.indexOf(qG.S) >= 0 && (u10 = d10(u10, l10));
  const m10 = O3(u10, l10);
  const h10 = O3(c10, s10);
  const f10 = {};
  return r10 && (f10.Left = { $set: s10.css }), o10 && (f10.Top = { $set: l10.css }), i10 && (f10.Width = { $set: h10.css }), a10 && (f10.Height = { $set: m10.css }), AV(e14, { $place: f10 });
}
function j3(e14, t10) {
  const { Left: n10, Top: r10, Bottom: o10, Right: a10 } = t10;
  const [i10, s10] = [n10 || L$.parse(e14.$place.Left), r10 || L$.parse(e14.$place.Top)];
  const [l10, c10] = [a10 || i10.add(L$.parse(e14.$place.Width)), o10 || s10.add(L$.parse(e14.$place.Height))];
  const u10 = s10.greaterThan(c10);
  const d10 = i10.greaterThan(l10);
  const p10 = { Left: i10.lowerThanOrEqual(l10) ? i10 : l10, Top: s10.lowerThanOrEqual(c10) ? s10 : c10, Bottom: c10.greaterThanOrEqual(s10) ? c10 : s10, Right: l10.greaterThanOrEqual(i10) ? l10 : i10 };
  const { Width: m10, Height: h10 } = $3(p10);
  const { startPoint: f10, endPoint: g10 } = function(e15) {
    return { startPoint: { x: L$.parse(e15.StartPoint.X), y: L$.parse(e15.StartPoint.Y) }, endPoint: { x: L$.parse(e15.EndPoint.X), y: L$.parse(e15.EndPoint.Y) } };
  }(e14);
  const y10 = u10 ? !f10.y.lowerThan(g10.y) : f10.y.lowerThan(g10.y);
  const v10 = d10 ? !f10.x.lowerThan(g10.x) : f10.x.lowerThan(g10.x);
  const b10 = { X: { $set: (v10 ? p10.Left : p10.Right).css }, Y: { $set: (y10 ? p10.Top : p10.Bottom).css } };
  const S10 = { X: { $set: (v10 ? p10.Right : p10.Left).css }, Y: { $set: (y10 ? p10.Bottom : p10.Top).css } };
  return AV(e14, { StartPoint: b10, EndPoint: S10, $place: { Top: { $set: p10.Top.css }, Left: { $set: p10.Left.css }, Height: { $set: h10.css }, Width: { $set: m10.css } } });
}
const Z3 = (e14, t10, n10) => {
  const r10 = n10.subtract(t10.subtract(e14));
  if (r10.greaterThan(L$.zero)) {
    const t11 = L$.max([e14.subtract(r10), L$.zero]);
    const o10 = t11.add(n10);
    return [t11, o10];
  }
  return [e14, t10];
};
function G3(e14, t10, n10, r10, o10) {
  const [a10, i10] = [L$.parse(t10.x), L$.parse(t10.y)];
  const [s10, l10, c10, u10] = [L$.parse(e14.$place.Left), L$.parse(e14.$place.Top), L$.parse(e14.$place.Width), L$.parse(e14.$place.Height)];
  const [d10, p10] = [s10.add(c10), l10.add(u10)];
  let [m10, h10, f10, g10] = [s10, l10, d10, p10];
  const y10 = (e15, t11) => ((e16) => e16 && e16.greaterThan(L$.zero) && e16 || L$.zero)(e15.add(t11));
  n10.indexOf(qG.W) >= 0 ? m10 = r10 && r10.Left || y10(m10, a10) : n10.indexOf(qG.E) >= 0 ? f10 = r10 && r10.Right || y10(f10, a10) : n10.indexOf(qG.M) >= 0 && (r10 && r10.Left ? (m10 = r10.Left, f10 = m10.add(c10)) : r10 && r10.Right ? (f10 = L$.max([r10.Right, c10]), m10 = f10.subtract(c10)) : (m10 = y10(m10, a10), f10 = m10.add(c10))), n10.indexOf(qG.N) >= 0 ? h10 = r10 && r10.Top || y10(h10, i10) : n10.indexOf(qG.S) >= 0 ? g10 = r10 && r10.Bottom || y10(g10, i10) : n10.indexOf(qG.C) >= 0 && (r10 && r10.Top ? (h10 = r10.Top, g10 = h10.add(u10)) : r10 && r10.Bottom ? (g10 = L$.max([r10.Bottom, u10]), h10 = g10.subtract(u10)) : (h10 = y10(h10, i10), g10 = h10.add(u10)));
  let v10 = e14;
  if ("line" !== e14.Type) {
    _W(e14.Type) && (n10.indexOf(qG.W) >= 0 || n10.indexOf(qG.N) >= 0) && (v10 = function(e15, t12, n11) {
      const [r12, o11] = [L$.parse(e15.$place.Left), L$.parse(e15.$place.Top)];
      let [a11, i11] = [t12.Left || r12, t12.Top || o11];
      let s11 = n11.indexOf(qG.W) >= 0 && a11.subtract(r12) || null;
      let l11 = n11.indexOf(qG.N) >= 0 && i11.subtract(o11) || null;
      const c11 = (e16, t13) => e16.ReportItems.reduce((e17, n12) => {
        const r13 = L$.parse(n12.$place[t13]);
        return e17 ? r13.lowerThan(e17) ? r13 : e17 : r13;
      }, null);
      const u11 = c11(e15, "Left");
      const d11 = c11(e15, "Top");
      const p11 = (e16, t13) => e16 && t13 && (e16.greaterThan(t13) ? t13 : e16) || null;
      s11 = p11(s11, u11), l11 = p11(l11, d11), a11 = s11 && r12.add(s11) || a11, i11 = l11 && o11.add(l11) || i11;
      const m11 = (e16) => AV(e16, { $place: { Left: { $set: s11 && L$.parse(e16.$place.Left).subtract(s11).css || e16.$place && e16.$place.Left }, Top: { $set: l11 && L$.parse(e16.$place.Top).subtract(l11).css || e16.$place && e16.$place.Top } } });
      const h11 = e15.ReportItems.map(m11);
      return AV(e15, { ReportItems: { $set: h11 }, $place: { Left: { $set: a11.css }, Top: { $set: i11.css } } });
    }(e14, { Left: m10, Top: h10 }, n10), [m10, h10] = [L$.parse(v10.$place.Left), L$.parse(v10.$place.Top)]);
    let [t11, r11] = [f10.subtract(m10), g10.subtract(h10)];
    if (!c10.equal(t11) || !u10.equal(r11)) {
      const e15 = n5(v10, A5({ width: c10.equal(t11) ? void 0 : t11.css, height: u10.equal(r11) ? void 0 : r11.css }));
      (e15.$width || e15.$height) && (e15.$width && (t11 = L$.parse(e15.$width), n10.includes(qG.W) && a10.greaterThan(L$.zero) && ([m10, f10] = Z3(m10, f10, t11))), e15.$height && (r11 = L$.parse(e15.$height), n10.includes(qG.N) && i10.greaterThan(L$.zero) && ([h10, g10] = Z3(h10, g10, r11)))), v10 = e15;
    }
  }
  return o10(v10, { Left: m10, Top: h10, Bottom: g10, Right: f10 }, n10);
}
function U3(e14) {
  const t10 = e14.x && L$.parse(e14.x);
  const n10 = e14.y && L$.parse(e14.y);
  const r10 = {};
  return t10 && (e14.xs === qG.W ? r10.Left = t10 : e14.xs === qG.E && (r10.Right = t10)), n10 && (e14.ys === qG.N ? r10.Top = n10 : e14.ys === qG.S && (r10.Bottom = n10)), r10;
}
const q3 = 5;
const Y3 = L$.parse("10pt");
function K3(e14) {
  let t10 = e14;
  return t10.$place && t10.$width && t10.$width !== t10.$place.Width && (t10 = AV(t10, { $place: { Width: { $set: t10.$width } } })), t10.$place && t10.$height && t10.$height !== t10.$place.Height && (t10 = AV(t10, { $place: { Height: { $set: t10.$height } } })), t10;
}
function X3(e14, t10) {
  const n10 = B3(e14, t10);
  const r10 = ((e15, t11) => ({ Width: L$.parse(e15), Height: L$.parse(t11) }))(e14.$width || e14.$place && e14.$place.Width || "0in", e14.$height || e14.$place && e14.$place.Height || "0in");
  const o10 = N3(r10, n10);
  return AV(e14, { $width: { $set: o10.Width.css }, $height: { $set: o10.Height.css } });
}
const J3 = (e14) => sj(e14) || e14.ReportItems.some((e15) => sj(e15) && !_W(e15.Type));
const Q3 = (e14) => {
  const t10 = [];
  const n10 = [];
  return e14.ReportItems.forEach((e15) => {
    "leaf" === e15.$selected ? t10.push(e15.ZIndex || 0) : n10.push(e15.ZIndex || 0);
  }), { selectedLeavesZIndexes: t10.sort((e15, t11) => e15 - t11), notSelectedLeavesIndexes: n10.sort((e15, t11) => e15 - t11) };
};
const e7 = (e14, t10) => {
  const { ReportItems: n10 } = e14;
  const { selectedLeavesZIndexes: r10 } = Q3(e14);
  const o10 = n10.length ? Math.max(...n10.map((e15) => e15.ZIndex || 0)) : 0;
  const a10 = [];
  return n10.forEach((e15, n11) => {
    if (!aj(e15)) return;
    let i10 = e15;
    oj(e15) ? i10 = n5(e15, t10) : rj(e15) && (i10 = AV(i10, { ZIndex: { $set: r10.findIndex((t11) => e15.ZIndex === t11) + o10 + 1 } })), i10 !== e15 && (a10[n11] = { $set: i10 });
  }), a10.length > 0 ? AV(e14, { ReportItems: a10 }) : e14;
};
const t7 = (e14, t10) => {
  const { ReportItems: n10 } = e14;
  const { selectedLeavesZIndexes: r10, notSelectedLeavesIndexes: o10 } = Q3(e14);
  const a10 = [];
  const i10 = r10[r10.length - 1];
  const s10 = r10.length;
  const l10 = o10[0];
  const c10 = i10 >= l10;
  const u10 = l10 <= s10;
  return n10.forEach((e15, n11) => {
    let o11 = e15;
    const i11 = e15.ZIndex;
    rj(e15) && c10 ? o11 = AV(o11, { ZIndex: { $set: r10.findIndex((e16) => i11 === e16) } }) : u10 && (o11 = AV(o11, { ZIndex: { $set: i11 + s10 } }), oj(o11) && (o11 = n5(o11, t10))), o11 !== e15 && (a10[n11] = { $set: o11 });
  }), a10.length > 0 ? AV(e14, { ReportItems: a10 }) : e14;
};
const n7 = Zq("", "", "length_locsize", "$place.Left", void 0, OY);
const r7 = Zq("", "", "length_locsize", "$place.Top", void 0, OY);
const o7 = (e14, t10, n10) => {
  var _a2;
  const { units: r10 } = KO.of(n10).userPreferences;
  const o10 = e14.ReportItems.some(sj);
  const a10 = vj(e14).filter(({ item: e15 }) => I0(e15));
  const i10 = (_a2 = a10.find(({ item: e15 }) => ij(e15))) == null ? void 0 : _a2.item;
  if (!i10) return e14;
  return u7(e14, t10, n10, (e15) => {
    if (!o10 || !I0(e15) || ij(e15)) return e15;
    const n11 = function(e16, t11, n12, r11) {
      const o11 = X4(e16);
      const a12 = X4(t11);
      let i11 = o11;
      return r11.horizontal && (i11 = Y4({ place: i11 }, a12, r11.horizontal).place), r11.vertical && (i11 = K4({ place: i11 }, a12, r11.vertical).place), J4(i11, n12);
    }(e15.$place, i10.$place, r10, t10.payload);
    let a11 = e15;
    return n11 !== e15.$place && (a11 = p7(a11, n7, n11.Left), a11 = p7(a11, r7, n11.Top)), a11;
  });
};
const a7 = (e14, t10, n10) => {
  const r10 = V$(L$.parseSafe(e14), n10);
  const o10 = V$(L$.parseSafe(t10), n10);
  return new L$(Z4(r10, o10), n10).css;
};
const i7 = Zq("", "", "length_locsize", "$place.Width", void 0, OY);
const s7 = Zq("", "", "length_locsize", "$place.Height", void 0, OY);
const l7 = (e14, t10, n10) => {
  const { payload: { keepSizes: r10 } } = t10;
  const { surface: { gridSize: o10 }, units: a10 } = KO.of(n10).userPreferences;
  return u7(e14, t10, n10, (e15) => {
    if (!I0(e15)) return e15;
    let t11 = e15;
    return r10 || (t11 = p7(t11, i7, a7(t11.$place.Width, o10, a10)), t11 = p7(t11, s7, a7(t11.$place.Height, o10, a10))), t11 = p7(t11, n7, a7(t11.$place.Left, o10, a10)), t11 = p7(t11, r7, a7(t11.$place.Top, o10, a10)), t11;
  });
};
const c7 = (e14) => (t10, n10, r10) => {
  const { spacingAdjustment: o10 } = n10.payload;
  const { units: a10, surface: { gridSize: i10 } } = KO.of(r10).userPreferences;
  const s10 = L$.parseSafe(i10).value;
  const l10 = t10.ReportItems.some(sj);
  const c10 = vj(t10).filter(({ item: e15 }) => I0(e15));
  const u10 = c10.find(({ item: e15 }) => ij(e15));
  if (!(u10 == null ? void 0 : u10.item)) return t10;
  const d10 = (e15) => e15.slice(0, e15.lastIndexOf("ReportParts"));
  const p10 = c10.filter(({ path: e15 }) => d10(u10.path) === d10(e15));
  if (p10.length <= 1) return t10;
  const m10 = /* @__PURE__ */ new Map();
  p10.forEach(({ item: e15, path: t11 }) => m10.set(e15.Name, t11));
  const h10 = p10.map(({ item: e15, path: t11 }) => ({ place: X4(e15.$place), path: t11 }));
  return u7(t10, n10, r10, (t11) => {
    var _a2, _b2;
    if (!l10 || !I0(t11)) return t11;
    const n11 = "horizontal" === e14 ? n7 : r7;
    const r11 = "vertical" === e14 ? "Top" : "Left";
    switch (o10) {
      case "equal":
      case "remove": {
        const i11 = ("equal" === o10 ? G4 : U4)(e14, h10).map(({ place: e15, path: t12 }) => ({ place: J4(e15, a10), path: t12 }));
        const s11 = (_a2 = i11.find(({ path: e15 }) => e15 === m10.get(t11.Name))) == null ? void 0 : _a2.place[r11];
        return p7(t11, n11, s11 != null ? s11 : t11.$place[r11]);
      }
      case "increase":
      case "decrease": {
        const i11 = { place: X4(u10.item.$place), path: m10.get(u10.item.Name) };
        const l11 = { place: X4(t11.$place), path: m10.get(t11.Name) };
        const c11 = (_b2 = q4(e14, l11, i11, s10, "decrease" === o10)) == null ? void 0 : _b2.place[r11];
        return p7(t11, n11, `${c11}${a10}`);
      }
      default:
        return t11;
    }
  });
};
const u7 = (e14, t10, n10, r10) => {
  const o10 = [];
  return e14.ReportItems.forEach((e15, n11) => {
    if (!aj(e15)) return;
    let a10 = e15;
    oj(e15) ? a10 = n5(e15, t10) : rj(e15) && (a10 = r10(a10)), a10 !== e15 && (o10[n11] = { $set: z3(a10) });
  }), o10.length > 0 ? X3(AV(e14, { ReportItems: o10 }), n10) : e14;
};
const d7 = (e14, t10, n10) => {
  const { StartPoint: r10, EndPoint: o10, $place: a10 } = e14;
  const i10 = "$place.Width" === t10.valuePath ? n10 : a10.Width;
  const s10 = "$place.Height" === t10.valuePath ? n10 : a10.Height;
  const l10 = ((e15, t11, n11) => {
    const [r11, o11, a11, i11] = [L$.parseSafe(e15.X).value, L$.parseSafe(e15.Y).value, L$.parseSafe(t11.X).value, L$.parseSafe(t11.Y).value];
    const [s11, l11, c11, u11] = [L$.parseSafe(n11.Top).value, L$.parseSafe(n11.Left).value, L$.parseSafe(n11.Width).value, L$.parseSafe(n11.Height).value];
    const { units: d10 } = L$.parseSafe(e15.X);
    return { startPoint: { X: r11 >= a11 ? new L$(l11 + c11, d10).css : new L$(l11, d10).css, Y: o11 >= i11 ? new L$(s11 + u11, d10).css : new L$(s11, d10).css }, endPoint: { X: r11 < a11 ? new L$(l11 + c11, d10).css : new L$(l11, d10).css, Y: o11 < i11 ? new L$(s11 + u11, d10).css : new L$(s11, d10).css } };
  })(r10, o10, __spreadProps(__spreadValues({}, a10), { Width: i10, Height: s10 }));
  const c10 = [{ descriptor: $N("", "", "", "StartPoint.X"), value: l10.startPoint.X }, { descriptor: $N("", "", "", "StartPoint.Y"), value: l10.startPoint.Y }, { descriptor: $N("", "", "", "EndPoint.X"), value: l10.endPoint.X }, { descriptor: $N("", "", "", "EndPoint.Y"), value: l10.endPoint.Y }];
  let u10;
  return u10 = n5(e14, l2({ descriptorValuePairs: c10 })), u10 = uU(u10), u10;
};
const p7 = (e14, t10, n10) => {
  if (!t10.valuePath) throw new Error(`Invalid descriptor value path for location-size property: ${t10.valuePath}`);
  let r10 = e14;
  if ("$place.Width" === t10.valuePath || "$place.Height" === t10.valuePath) if ("line" === e14.Type) r10 = d7(e14, t10, n10);
  else {
    const o10 = { [t10.valuePath.split(".")[1].toLowerCase()]: n10 };
    r10 = n5(e14, A5(o10));
  }
  else {
    const e15 = t10.valuePath.split(".");
    const o10 = {};
    let a10 = o10;
    e15.forEach((t11, r11) => {
      a10[t11] = r11 === e15.length - 1 ? { $set: n10 } : {}, a10 = a10[t11];
    }), r10 = AV(r10, o10), "line" === r10.Type && (r10 = t10.valuePath.startsWith("StartPoint") || t10.valuePath.startsWith("EndPoint") ? uU(r10) : d7(r10, t10, n10));
  }
  return r10;
};
const m7 = (e14, t10) => {
  const { payload: { items: n10 }, meta: r10 } = t10;
  const { ReportItems: o10 } = e14;
  const a10 = e14.LayerName || (r10 == null ? void 0 : r10.currentLayerName) || "default";
  const i10 = o10.length ? Math.max(...o10.map((e15) => e15.ZIndex || 0)) + 1 : 0;
  let s10 = e14;
  if (!rj(e14)) {
    const e15 = {};
    let t11 = false;
    o10.forEach((n11, r11) => {
      aj(n11) && (e15[r11] = { $set: lj(n11) }, t11 = true);
    }), t11 && (s10 = AV(s10, { ReportItems: e15 }));
  }
  const l10 = n10.map((e15, t11) => {
    let n11 = dj(e15, true, 0 === t11);
    return n11 = P3(n11, a10), n11.hasOwnProperty("ZIndex") ? AV(n11, { ZIndex: { $set: i10 + t11 } }) : n11;
  });
  return mj(AV(s10, { ReportItems: { $push: l10 } }));
};
const h7 = (e14, t10, n10, r10) => {
  const o10 = "mc" === r10;
  const a10 = (a11) => {
    const i10 = "x" === a11 ? t10.Left : t10.Top;
    const s10 = "x" === a11 ? e14.Width : e14.Height;
    const l10 = "x" === a11 ? t10.Width : t10.Height;
    if (!s10 || !i10) return n10[a11];
    const c10 = L$.parse(i10).add(l10);
    const u10 = s10.subtract(c10);
    const d10 = s10.subtract(c10.add(L$.parse(n10[a11])));
    if (o10) return d10.greaterThan(L$.zero) ? n10[a11] : u10.css;
    const p10 = "x" === a11 ? r10 === qG.MW || r10 === qG.NW || r10 === qG.SW : r10 === qG.NC || r10 === qG.NW || r10 === qG.NE;
    return d10.add(p10 ? l10 : L$.zero).greaterThan(L$.zero) ? n10[a11] : u10.css;
  };
  return { x: a10("x"), y: a10("y") };
};
const f7 = (e14, t10) => {
  const { meta: _a2 } = e14, _b2 = _a2, { sizeLimitation: n10 = {} } = _b2, r10 = __objRest(_b2, ["sizeLimitation"]);
  const { LeftOffset: o10, TopOffset: a10 } = n10;
  const { Left: i10, Top: s10 } = t10;
  return __spreadProps(__spreadValues({}, e14), { meta: __spreadProps(__spreadValues({}, r10), { sizeLimitation: __spreadProps(__spreadValues({}, n10), { LeftOffset: o10 ? o10.add(L$.parse(i10)) : void 0, TopOffset: a10 ? a10.add(L$.parse(s10)) : void 0 }) }) });
};
const g7 = (e14, t10, n10, r10) => {
  const { LeftOffset: o10, MaxWidth: a10, MaxHeight: i10, TopOffset: s10 } = r10;
  const { Left: l10, Top: c10, Height: u10, Width: d10 } = n10;
  return h7({ Width: a10, Height: i10 }, { Left: o10 ? o10.add(L$.parse(l10)) : void 0, Top: s10 ? s10.add(L$.parse(c10)) : void 0, Width: L$.parse(d10), Height: L$.parse(u10) }, e14, t10);
};
const y7 = (e14) => ["contentplaceholder", "list", "rectangle", "fixedpagerectangle"].includes(e14);
const v7 = (e14, { payload: { items: t10 } }) => {
  if (y7(e14.Type) && t10.some((e15) => "contentplaceholder" === e15.Type)) throw $0("contentplaceholder", e14.Type);
  return e14;
};
function b7(e14) {
  return function t10(n10, r10) {
    switch (r10.type) {
      case XG.type: {
        const { payload: { Type: o11, Name: a10, TemplateId: i10, Extra: s10 }, meta: l10 } = r10;
        const c10 = nz.of(e14).create(o11, a10, i10, s10);
        return t10(n10, KG({ items: [c10] }, l10));
      }
      case tU.type: {
        const { payload: { properties: o11, fillData: a10 }, meta: i10 } = r10;
        if ("pagesection" === n10.Type) throw $0(o11.Type, n10.Type);
        const s10 = FG(TG("table"));
        const l10 = __spreadValues({}, A4(e14, s10, o11, a10));
        return t10(n10, KG({ items: [l10] }, i10));
      }
      case KG.type:
        if (J3(v7(n10, r10))) return X3(m7(n10, r10), e14);
        break;
      case eU.type:
        if (J3(v7(n10, r10))) {
          const { payload: { items: o11, pasteId: a10, contextAction: i10 }, meta: s10 } = r10;
          if (!o11.length) break;
          let l10 = o11;
          if (y7(n10.Type) && i10) {
            const { Left: e15, Top: t11 } = n10.$place;
            l10 = o11.map((n11) => __spreadProps(__spreadValues({}, n11), { $place: __spreadProps(__spreadValues({}, n11.$place), { Left: L$.parse(n11.$place.Left).subtract(L$.parse(e15)).css, Top: L$.parse(n11.$place.Top).subtract(L$.parse(t11)).css }) }));
          }
          const c10 = n10;
          const u10 = c10.$pasteId === a10 ? c10.$pasteCount : 0;
          const d10 = Math.floor(u10 / q3);
          const p10 = u10 % q3;
          const m10 = Y3.multiply(p10 + d10);
          const h10 = Y3.multiply(p10);
          const { userPreferences: { units: f10 } } = KO.of(e14);
          const g10 = new L$(0, f10);
          const y10 = i10 ? { x: g10.css, y: g10.css } : { x: m10.css, y: h10.css };
          let v10 = AV(c10, { $pasteId: { $set: a10 }, $pasteCount: { $set: u10 + 1 } });
          return v10 = n5(v10, KG({ items: l10 }, s10)), t10(v10, YG({ grip: qG.MC, delta: y10 }));
        }
        break;
      case ZG:
        return function(e15, t11, n11, r11) {
          let o11 = e15;
          const a10 = (o11.ReportItems || []).filter(t11);
          if (a10.length > 0) {
            const e16 = { $splice: [] };
            a10.reverse(), a10.forEach((t12) => {
              const n12 = o11.ReportItems.indexOf(t12);
              e16.$splice.push([n12, 1]);
            }), o11 = AV(o11, { ReportItems: e16 });
          }
          o11 = Vj(o11, n11, r11);
          const i10 = (o11.ReportItems || []).some(aj);
          return e15 === o11 || i10 ? o11 : pj(o11);
        }(n10, rj, n5, r10);
      case GG: {
        if (!ij(n10)) return n10;
        const t11 = n10.ReportItems.findIndex((e15) => sj(e15));
        if (t11 < 0) break;
        const { item: o11 } = r10.payload;
        const a10 = hj(o11, n10.ReportItems[t11]);
        return X3(AV(n10, { ReportItems: { $splice: [[t11, 1, a10]] } }), e14);
      }
      case A5.type: {
        const { width: t11, height: o11 } = r10.payload;
        const [a10, i10] = [t11 && L$.parse(t11), o11 && L$.parse(o11)];
        const s10 = {};
        const l10 = B3(n10, e14);
        const c10 = (e15, t12) => e15.lowerThan(t12) ? t12 : e15;
        return a10 && (s10.$width = { $set: c10(a10, l10.Width).css }), i10 && (s10.$height = { $set: c10(i10, l10.Height).css }), zV.isEmpty(s10) ? n10 : AV(n10, s10);
      }
      case $G: {
        const { payload: t11, meta: o11 } = r10;
        const { delta: a10 } = t11;
        const { sizeLimitation: i10 } = o11 != null ? o11 : {};
        const s10 = L$.isZeroLike(a10 && a10.x);
        const l10 = L$.isZeroLike(a10 && a10.y);
        if (s10 && l10) return n10;
        const c10 = {};
        return n10.ReportItems.forEach((e15, n11) => {
          if (oj(e15)) {
            let t12 = r10;
            i10 && (t12 = f7(r10, e15.$place)), c10[n11] = { $set: K3(n5(e15, t12)) };
          } else if (rj(e15)) {
            const { grip: r11 } = t11;
            const o12 = t11.snaps && t11.snaps[e15.Name];
            const s11 = o12 ? U3(o12) : null;
            let l11 = a10;
            i10 && (l11 = g7(a10, r11, e15.$place, i10));
            const u10 = G3(e15, l11, r11, s11, "line" === e15.Type ? j3 : W3);
            c10[n11] = { $set: K3(u10) };
          }
        }), zV.isEmpty(c10) ? n10 : X3(AV(n10, { ReportItems: c10 }), e14);
      }
      case d2.type: {
        const { value: t11, descriptor: o11 } = r10.payload;
        return u7(n10, r10, e14, (e15) => p7(e15, o11, t11));
      }
      case v2.type:
        if (!rj(n10)) break;
        return AV(n10, { ReportStyle: { StyleId: { $set: r10.payload.id || "" }, StyleName: { $set: r10.payload.name || "" } } });
      case b2.type: {
        if (!rj(n10)) break;
        const t11 = A3(r10.payload.style, e14);
        return t11 ? function(e15, t12, n11, r11 = false) {
          const o11 = _3(e15);
          const a10 = r11 ? Aj(n11, o11) : n11;
          const i10 = R3(t12, a10);
          return null !== i10 ? AV(t12, { Style: i10 }) : t12;
        }(e14, n10, t11) : n10;
      }
      case nU.type:
        return e7(n10, r10);
      case rU.type:
        return t7(n10, r10);
      case iU.type:
        return o7(n10, r10, e14);
      case oU.type:
        return c7("horizontal")(n10, r10, e14);
      case aU.type:
        return c7("vertical")(n10, r10, e14);
      case sU.type:
        return l7(n10, r10, e14);
    }
    const o10 = {};
    return n10.ReportItems.forEach((e15, t11) => {
      if (!aj(e15)) return;
      const n11 = K3(n5(e15, r10));
      n11 !== e15 && (o10[t11] = { $set: n11 });
    }), zV.isEmpty(o10) ? n10 : X3(AV(n10, { ReportItems: o10 }), e14);
  };
}
const S7 = { snapToLine: U3, relocate: G3, updatedSizeByInnerSize: K3, applyLineLocation: j3, applyLocation: W3, shouldApplyAddReportItem: J3 };
const C7 = _V("@rdlx/container/fitContainerContent", (e14) => e14);
const x7 = (e14, t10 = false) => {
  const n10 = b7(e14);
  return (r10, o10, a10, i10, s10, l10) => {
    let c10 = {};
    let u10 = r10;
    t10 && (u10 = V5(u10, h5(u10.ReportItems.map((e15) => e15.Name))));
    const [d10, p10] = [o10.subtract(i10), a10.subtract(s10)];
    const m10 = (e15, t11) => e15.$fixedPlace && e15.$fixedPlace[t11] && L$.parse(e15.$fixedPlace[t11]);
    const h10 = (e15) => (t11) => t11 && e15 && AV(t11, { $set: e15 }) || t11;
    const f10 = (e15) => (t11) => t11 && e15 && AV(t11, { $set: e15.css }) || t11;
    const g10 = (e15, t11, n11, r11, o11, a11) => {
      const i11 = {};
      return i11.$place = { Top: { $apply: f10(e15) }, Left: { $apply: f10(t11) }, Width: { $apply: h10(n11) }, Height: { $apply: h10(r11) } }, o11 && a11 && (i11.$fixedPlace = { Width: { $apply: f10(o11) }, Height: { $apply: f10(a11) } }), i11;
    };
    return u10.ReportItems.forEach((t11, r11) => {
      if (!aj(t11)) return;
      let u11 = t11;
      let h11 = {};
      const [f11, y10] = [L$.parse(u11.$place.Top), L$.parse(u11.$place.Left)];
      const [v10, b10] = [L$.parse(u11.$place.Height), L$.parse(u11.$place.Width)];
      if (rj(u11)) {
        const e15 = (e16, t12, n12, r13) => {
          const o11 = L$.max([e16.add(r13 || t12).subtract(n12), L$.zero]);
          return { updStartPosition: L$.max([e16.subtract(o11), L$.zero]), updSize: L$.min([t12, n12]), updFixedSize: !l10 && r13 && L$.min([r13, n12]) || null };
        };
        const { updStartPosition: n11, updSize: r12, updFixedSize: i11 } = e15(y10, b10, o10, m10(t11, "Width"));
        const { updStartPosition: s11, updSize: c11, updFixedSize: d11 } = e15(f11, v10, a10, m10(t11, "Height"));
        u11 = n5(u11, A5({ width: r12.css, height: c11.css })), h11 = g10(s11, n11, u11.$width, u11.$height, i11, d11), "line" === t11.Type && (u11 = d7(u11, Zq("", "", "length", "$place.Width"), r12), u11 = d7(u11, Zq("", "", "length", "$place.Height"), c11));
      } else if (_W(t11.Type)) {
        const r12 = (e15, t12, n11, r13, o11) => {
          const a11 = L$.max([e15.add(n11).subtract(r13), L$.zero]);
          const i11 = L$.max([e15.subtract(a11), L$.zero]);
          const s11 = L$.max([i11.add(t12).subtract(r13), L$.zero]);
          const l12 = s11.greaterThan(L$.zero) ? L$.max([t12.subtract(s11), n11]) : t12;
          const c12 = o11 && L$.max([i11.add(o11).subtract(r13), L$.zero]);
          return { updStartPosition: i11, updSize: l12, updFixedSize: o11 && c12 && c12.greaterThan(L$.zero) ? L$.max([o11.subtract(c12), n11]) : o11 };
        };
        const l11 = UW(t11.Type);
        u11 = n5(u11, C7({ maxWidth: o10, maxHeight: a10, offsetLeft: i10.add(y10), offsetTop: s10.add(f11), inDataRegion: l11 }));
        const { Width: c11, Height: S10 } = F7(u11, e14, l11);
        const { updStartPosition: C10, updSize: x10, updFixedSize: w10 } = r12(y10, b10, c11, d10, m10(t11, "Width"));
        const { updStartPosition: T10, updSize: E10, updFixedSize: F10 } = r12(f11, v10, S10, p10, m10(t11, "Height"));
        u11 = _W(u11.Type) && l11 ? n10(u11, A5({ width: x10.css, height: E10.css })) : n5(u11, A5({ width: x10.css, height: E10.css })), h11 = g10(T10, C10, u11.$width, u11.$height, w10, F10);
      }
      h11 && !zV.isEmpty(h11) && (u11 = AV(u11, h11)), u11 !== t11 && (c10 = __spreadProps(__spreadValues({}, c10), { [r11]: { $set: u11 } }));
    }), zV.isEmpty(c10) ? u10 : E7(AV(u10, { ReportItems: c10 }), e14);
  };
};
const w7 = (e14, t10, n10, r10, o10 = false) => {
  const { grip: a10, delta: i10 } = n10.payload;
  const s10 = {};
  return t10.ReportItems.forEach((t11, l10) => {
    const c10 = e14.ReportItems[l10];
    if (oj(t11)) {
      const e15 = V0(c10) && V0(t11) ? w7(c10, t11, n10, r10, o10) : t11;
      const a11 = [T7, P7].reduce((e16, t12) => t12(e16, o10), e15);
      s10[l10] = { $set: a11 };
    }
    if (rj(t11)) {
      const e15 = function(e16, t12, n11, r11 = "", o11 = false) {
        if (!t12.$fixedPlace) return t12;
        const { x: a11, y: i11 } = n11;
        const s11 = r11 == null ? void 0 : r11.includes("fpl");
        const [l11, c11] = s11 ? [L$.parse(a11).negative(), L$.parse(i11).negative()] : [L$.parse(a11), L$.parse(i11)];
        const u10 = (e17, t13) => L$.parse(e17).subtract(L$.parse(t13));
        const d10 = (e17, n12) => {
          const r12 = {};
          return n12.Width && (r12.Width = { $set: L$.max([L$.parse(t12.$place.Width), n12.Width]).css }), n12.Height && (r12.Height = { $set: L$.max([L$.parse(t12.$place.Height), n12.Height]).css }), zV.isEmpty(r12) ? e17 : AV(e17, { $fixedPlace: r12 });
        };
        const p10 = (n12, o12) => {
          const [a12, i12, s12, l12, c12] = "x" === n12 ? [[qG.MW, qG.NW, qG.SW], t12.$place.Left, e16.$place.Left, t12.$place.Width, e16.$place.Width] : [[qG.NW, qG.NC, qG.NE], t12.$place.Top, e16.$place.Top, t12.$place.Height, e16.$place.Height];
          if (a12.some((e17) => e17 === r11)) {
            if (o12.lowerThan(L$.zero)) {
              const e18 = L$.parse(i12).subtract(L$.parse(s12));
              return o12.greaterThan(e18) ? o12.css : e18.css;
            }
            const e17 = L$.parse(c12).subtract(L$.parse(l12));
            return o12.lowerThanOrEqual(e17) ? o12.css : e17.css;
          }
          return o12.css;
        };
        const m10 = (e17, t13) => {
          if (!e17.$fixedPlace.Width) return e17;
          const n12 = u10(e17.$fixedPlace.Width, p10("x", t13));
          return d10(e17, { Width: n12.css });
        };
        const h10 = (e17, t13) => {
          if (!e17.$fixedPlace.Height) return e17;
          const n12 = u10(e17.$fixedPlace.Height, p10("y", t13));
          return d10(e17, { Height: n12.css });
        };
        let f10 = t12;
        (r11.indexOf(qG.W) >= 0 || r11.indexOf(qG.E) >= 0 && s11) && (f10 = m10(f10, l11));
        (r11.indexOf(qG.N) >= 0 || r11.indexOf(qG.S) >= 0 && s11) && (f10 = h10(f10, c11));
        return f10 = P7(f10, o11), f10;
      }(c10, t11, i10, a10, o10);
      e15 !== t11 && (s10[l10] = { $set: e15 });
    }
  }), E7(zV.isEmpty(s10) ? t10 : AV(t10, { ReportItems: s10 }), r10);
};
function T7(e14, t10) {
  let n10 = e14;
  return n10.$place && n10.$width && n10.$width !== n10.$place.Width && (n10 = AV(n10, { $place: { Width: { $set: n10.$width } } })), n10.$place && n10.$height && n10.$height !== n10.$place.Height && (n10 = AV(n10, { $place: { Height: { $set: n10.$height } } })), n10;
}
function E7(e14, t10) {
  var _a2, _b2;
  const n10 = F7(e14, t10);
  const r10 = ((e15, t11) => ({ Width: L$.parse(e15), Height: L$.parse(t11) }))(e14.$width || ((_a2 = e14.$place) == null ? void 0 : _a2.Width) || "0in", e14.$height || ((_b2 = e14.$place) == null ? void 0 : _b2.Height) || "0in");
  const o10 = M7(r10, n10);
  return AV(e14, { $width: { $set: o10.Width.css }, $height: { $set: o10.Height.css } });
}
function F7(e14, t10, n10 = false) {
  const r10 = nz.of(t10).getFeature(e14.Type, "getMinContentSize");
  if (r10) {
    return r10(e14);
  }
  const o10 = e14.ReportItems.reduce((e15, t11) => {
    const r11 = k7(t11, n10);
    return M7(r11, e15);
  }, { Width: L$.zero, Height: L$.zero });
  return { Width: o10.Width, Height: o10.Height };
}
const M7 = (e14, t10) => ({ Width: e14.Width.greaterThan(t10.Width) ? e14.Width : t10.Width, Height: e14.Height.greaterThan(t10.Height) ? e14.Height : t10.Height });
const k7 = (e14, t10) => ({ Width: L$.parse(e14.$place.Left).add(L$.parse(!t10 && e14.$fixedPlace && e14.$fixedPlace.Width || e14.$place.Width)) || L$.zero, Height: L$.parse(e14.$place.Top).add(L$.parse(!t10 && e14.$fixedPlace && e14.$fixedPlace.Height || e14.$place.Height)) || L$.zero });
const P7 = (e14, t10 = false) => {
  const n10 = "fixedpagepartitem" !== e14.Type;
  if (!e14.$fixedPlace) return e14;
  const r10 = {};
  const o10 = (e15, t11) => L$.parse(e15).lowerThan(L$.parse(t11));
  return n10 ? (e14.$fixedPlace.Width && o10(e14.$fixedPlace.Width, e14.$place.Width) && (r10.Width = { $set: e14.$place.Width }), e14.$fixedPlace.Height && o10(e14.$fixedPlace.Height, e14.$place.Height) && (r10.Height = { $set: e14.$place.Height }), e14.$fixedPlace && sj(e14) && t10 && (r10.Width = { $set: e14.$place.Width }, r10.Height = { $set: e14.$place.Height })) : (r10.Width = { $set: e14.$place.Width }, r10.Height = { $set: e14.$place.Height }), zV.isEmpty(r10) ? e14 : AV(e14, { $fixedPlace: r10 });
};
const N7 = (e14, t10 = false) => {
  const n10 = {};
  return e14.ReportItems.forEach((e15, r10) => {
    if (e15.$fixedPlace && (oj(e15) || rj(e15))) {
      const o10 = P7(e15, t10);
      o10 !== e15 && (n10[r10] = { $set: o10 });
    }
  }), zV.isEmpty(n10) ? e14 : AV(e14, { ReportItems: n10 });
};
const D7 = (e14) => {
  const t10 = b7(e14);
  const n10 = x7(e14);
  const r10 = (o10, a10) => {
    if (YG.match(a10)) {
      const { grip: n11, delta: r11, isItemInFixedArea: i11 } = a10.payload;
      const s10 = L$.isZeroLike(r11 && r11.x);
      const l10 = L$.isZeroLike(r11 && r11.y);
      if (s10 && l10) return o10;
      const c10 = n11 == null ? void 0 : n11.includes("fpl");
      const u10 = c10 ? o10 : t10(o10, a10);
      return w7(o10, u10, a10, e14, i11);
    }
    if (A5.match(a10)) {
      const { width: t11, height: n11 } = a10.payload;
      const [r11, i11] = [t11 && L$.parse(t11), n11 && L$.parse(n11)];
      const s10 = {};
      const l10 = F7(o10, e14);
      const c10 = (e15, t12) => e15.lowerThan(t12) ? t12 : e15;
      return r11 && (s10.$width = { $set: c10(r11, l10.Width).css }), i11 && (s10.$height = { $set: c10(i11, l10.Height).css }), zV.isEmpty(s10) ? o10 : AV(o10, s10);
    }
    if (tU.match(a10)) {
      const { properties: t11, fillData: n11 } = a10.payload;
      const i11 = FG(TG("table"));
      const s10 = ((e15, t12, n12, r11) => {
        const o11 = __spreadProps(__spreadValues({}, A4(e15, t12, n12, r11)), { Type: B4.Type });
        return z5(o11, O4);
      })(e14, i11, t11, n11);
      return r10(o10, KG({ items: [s10] }, a10.meta));
    }
    if (C7.match(a10)) {
      const { maxWidth: e15, maxHeight: t11, offsetLeft: r11, offsetTop: i11, inDataRegion: s10 } = a10.payload;
      return n10(o10, e15, t11, r11, i11, s10);
    }
    const i10 = t10(o10, a10);
    if (d2.match(a10)) {
      const { isItemInFixedArea: t11 } = a10.payload;
      return i10 === o10 ? o10 : N7(E7(i10, e14), t11);
    }
    return i10 === o10 ? o10 : N7(E7(i10, e14));
  };
  return r10;
};
const L7 = "BULLET/INS_VALUE";
const H7 = "BULLET/INS_TARGET_VALUE";
const I7 = (e14, t10 = "") => ({ item: e14, path: t10 });
const _7 = (e14) => {
  const t10 = [];
  XQ(e14, ({ item: e15, autoMergeMode: n11, itemPath: r10 }) => {
    let o10 = e15;
    "textbox" === o10.Type && (o10 = __spreadProps(__spreadValues({}, o10), { $options: { autoMergeMode: n11 } })), t10.push(I7(o10, r10));
  });
  const n10 = (e15, n11) => {
    e15.TableRows.forEach((r10, o10) => {
      t10.push(I7(__spreadProps(__spreadValues({}, r10), { $options: { printAtBottom: e15.PrintAtBottom, repeatOnNewPage: e15.RepeatOnNewPage, sectionType: e15.Type } }), `${n11}.TableRows.${o10}`));
    });
  };
  return WQ(e14, (e15, r10) => {
    if ("tablegroup" === e15.Type ? (e15.Header && n10(e15.Header, `${r10}.Header`), e15.Footer && n10(e15.Footer, `${r10}.Footer`)) : n10(e15, r10), "tabledetails" === e15.Type || "tablegroup" === e15.Type) {
      if (!e15.Group) return;
      t10.push(I7(__spreadProps(__spreadValues({}, e15.Group), { Type: "grouping" }), r10));
    }
  }), t10;
};
const V7 = (e14) => {
  const t10 = [];
  const n10 = zV.times(e14.$rows.collection.length, () => []);
  const r10 = zV.times(e14.$columns.collection.length, () => []);
  const o10 = (e15) => ({ name: e15.Name, type: e15.Type, style: e15.Style });
  VQ(e14, ({ item: e15, rix: a11, cix: i11, autoMergeMode: s11, itemPath: l11 }) => {
    let c11 = e15;
    "textbox" === c11.Type && (c11 = __spreadProps(__spreadValues({}, c11), { $options: { autoMergeMode: s11 } })), t10.push(I7(c11, l11)), n10[a11].push(o10(c11)), r10[i11].push(o10(c11));
  }, ({ member: e15, memberPath: n11 }) => {
    t10.push(I7(__spreadProps(__spreadValues({}, e15.Group), { Type: "grouping" }), n11));
  });
  const a10 = nQ(e14.RowHierarchy.Members, e14.Body.Rows.length);
  const i10 = nQ(e14.ColumnHierarchy.Members, e14.Body.Columns.length);
  const s10 = (e15) => {
    if (!e15) return null;
    return tW(e15) ? { isStaticMember: true, keepTogether: e15.KeepTogether, keepWithGroup: e15.KeepWithGroup, repeatOnNewPage: e15.RepeatOnNewPage } : { isStaticMember: false, keepTogether: e15.KeepTogether };
  };
  const l10 = (e14.Corner || []).length;
  const c10 = (e14.Corner || []).length && e14.Corner[0].length || 0;
  return e14.$rows.collection.forEach((e15, r11) => {
    const o11 = r11 - l10;
    t10.push(I7(__spreadProps(__spreadValues({}, e15), { $options: { memberInfo: s10(a10[o11]), itemsInfo: n10[r11] } }), `$rows.collection.${r11}`));
  }), e14.$columns.collection.forEach((e15, n11) => {
    const o11 = n11 - c10;
    t10.push(I7(__spreadProps(__spreadValues({}, e15), { $options: { memberInfo: s10(i10[o11]), itemsInfo: r10[n11] } }), `$columns.collection.${n11}`));
  }), t10;
};
const R7 = (e14) => {
  const t10 = [];
  return e14.PlotArea.Axes.forEach((e15, n10) => t10.push(I7(e15, `PlotArea.Axes.${n10}`))), e14.Plots.forEach((e15, n10) => t10.push(I7(__spreadProps(__spreadValues({}, e15), { $name: e15.PlotName, $options: { plotChartType: e15.PlotChartType, plotChartSubtype: e15.PlotChartSubtype, textEncodingTemplateKeys: e15.Encodings.Texts.map((e16) => ({ templateKey: e16.Field.TemplateKey, target: e16.Target })) } }), `Plots.${n10}`))), t10;
};
const A7 = (e14) => {
  const t10 = [];
  return e14.Encodings.Values.forEach((e15, n10) => t10.push(I7(e15, `Encodings.Values.${n10}`))), t10;
};
const O7 = (e14) => {
  const t10 = [];
  const n10 = r3(e14).map((e15) => I7(e15.band, i3(e15)));
  t10.push(...n10);
  const r10 = e14.Groups.map((e15, t11) => I7(__spreadProps(__spreadValues({}, e15.Group), { Type: "grouping" }), `Groups.${t11}`));
  return t10.push(...r10), t10;
};
const B7 = [H7, L7, $G, r2, d2, r5, o5, a5];
const z7 = (e14, t10) => {
  if (!b6(t10) && !e14.DataSetName) return null;
  const n10 = (t10.DataSets || []).find((t11) => t11.Name === e14.DataSetName);
  return n10 && S6(n10) || null;
};
function $7(e14, t10 = false) {
  const n10 = (r11, o11 = "") => {
    const a10 = ((t11, n11) => {
      var _a2;
      return { name: t11.Name || t11.$name, $options: t11.$options, $path: n11, type: t11.Type, overflowName: (_a2 = t11.$fixedPlace) == null ? void 0 : _a2.OverflowName, fieldName: "inputfield" === t11.Type ? t11.FieldName : void 0, baseEntity: z7(t11, e14), bookmark: t11.Bookmark, layerName: t11.LayerName, palette: t11.Palette, customPalette: t11.CustomPalette };
    })(r11, o11);
    return a10.children = function(e15, t11 = false) {
      switch (e15 == null ? void 0 : e15.Type) {
        case "Continuous":
        case "dashboardsection": {
          const t12 = [];
          return e15.PageHeader && t12.push(I7(e15.PageHeader, "PageHeader")), e15.Body && t12.push(I7(e15.Body, "Body")), e15.PageFooter && t12.push(I7(e15.PageFooter, "PageFooter")), t12;
        }
        case "fixedpagereport":
          return e15.Pages.map((e16, t12) => I7(e16, `Pages.${t12}`));
        case "multisectionreport": {
          const n11 = [];
          return e15.$masterReportContent && !t11 && e15.$masterReportContent.ReportSections.forEach((e16, t12) => {
            n11.push(I7(e16, `ReportSections.${t12}`));
          }), e15.ReportSections.forEach((e16, t12) => {
            n11.push(I7(e16, `ReportSections.${t12}`));
          }), n11;
        }
        case "dashboard":
        case "$masterReportContent":
          return t11 ? [] : e15.ReportSections.map((e16, t12) => I7(e16, `ReportSections.${t12}`));
        case "pagesection":
        case "section":
        case "fixedpagesection":
        case "rectangle":
        case "contentplaceholder":
        case "fixedpagerectangle":
        case "bandedlistdetails":
        case "bandedlistfooter":
        case "bandedlistheader":
          return e15.ReportItems.map((e16, t12) => I7(e16, `ReportItems.${t12}`));
        case "list":
        case "fixedpagelist":
          return e15.ReportItems.map((e16, t12) => I7(e16, `ReportItems.${t12}`)).concat(I7(__spreadProps(__spreadValues({}, e15.Group), { Type: "grouping" })));
        case "table":
        case "fixedpagetable":
          return _7(e15);
        case "tablix":
        case "fixedpagetablix":
          return V7(e15);
        case "fixedpagedvchart":
        case "dvchart":
          return R7(e15);
        case "dvchartplot":
          return A7(e15);
        case "sparkline":
          return [I7(__spreadProps(__spreadValues({}, e15.Group), { Type: "grouping" }))];
        case "tableofcontents":
        case "fixedpagetableofcontents":
          return e15.Levels.map((e16, t12) => I7(e16, `Levels.${t12}`));
        case "bandedlist":
        case "fixedpagebandedlist":
          return O7(e15);
      }
      return [];
    }(r11, t10).filter((e15) => e15).map((e15) => n10(e15.item, $j(o11, e15.path))), a10;
  };
  const r10 = (e15, t11 = 1, n11 = 1) => {
    const o11 = [];
    const { name: a10, type: i10, overflowName: s10, fieldName: l10, baseEntity: c10, children: u10, bookmark: d10, layerName: p10, $options: m10, $path: h10, palette: f10, customPalette: g10 } = e15;
    const y10 = { name: a10, type: i10, overflowName: s10, fieldName: l10, baseEntity: c10, level: t11, bookmark: d10, layerName: p10, $options: m10, $path: h10, palette: f10, customPalette: g10, leftKey: -1, rightKey: -1 };
    o11.push(y10), y10.leftKey = n11;
    let v10 = -1;
    return u10 == null ? void 0 : u10.forEach((e16) => {
      const { itemArray: a11, key: i11 } = r10(e16, t11 + 1, (-1 === v10 ? n11 : v10) + 1);
      v10 = i11, o11.push(...a11);
    }), y10.rightKey = (-1 === v10 ? n11 : v10) + 1, { itemArray: o11, key: y10.rightKey };
  };
  const o10 = n10(e14);
  return r10(o10).itemArray;
}
const W7 = (e14) => (t10, n10) => {
  const r10 = e14(t10, n10);
  if (r10 === t10 || B7.includes(n10.type)) return r10;
  let o10 = r10;
  return o10.$index || (o10 = AV(o10, { $index: { $set: {} } })), o10.DataSources !== o10.$index.DataSources && (o10 = AV(o10, { $index: { DataSources: { $set: o10.DataSources } } })), o10.DataSets !== o10.$index.DataSets && (o10 = AV(o10, { $index: { DataSets: { $set: o10.DataSets } } })), o10.ReportParameters !== o10.$index.ReportParameters && (o10 = AV(o10, { $index: { ReportParameters: { $set: o10.ReportParameters } } })), o10.EmbeddedImages !== o10.$index.EmbeddedImages && (o10 = AV(o10, { $index: { EmbeddedImages: { $set: o10.EmbeddedImages } } })), o10.Layers !== o10.$index.Layers && (o10 = AV(o10, { $index: { Layers: { $set: o10.Layers } } })), AV(o10, { $index: { NamedItems: { $set: $7(o10) } } });
};
const j7 = ["Body", "PageFooter", "PageHeader"];
const Z7 = (e14) => "contentplaceholder" === e14.Type && e14.$inChildReport;
const G7 = (e14) => "contentplaceholder" === e14.Type && !e14.$inChildReport;
const U7 = (e14) => "multisectionreport" === e14.Type && !!e14.$isMasterReport;
const q7 = (e14) => "multisectionreport" === e14.Type && !!e14.$masterReportContent;
const Y7 = (e14, t10) => ["multisectionreport", "pagesection", "section", "Continuous"].includes(e14.Type) && q7(t10);
const K7 = (e14) => {
  var _a2;
  return !(!("meta" in e14) || !((_a2 = e14 == null ? void 0 : e14.meta) == null ? void 0 : _a2.isChildReport));
};
const X7 = (e14 = []) => e14.map((e15) => __spreadProps(__spreadValues({}, e15), { $isMasterReport: true }));
const J7 = (e14) => !!e14.$isMasterReport;
const Q7 = (e14) => e14.filter((e15) => !J7(e15));
const e8 = (e14, t10) => {
  const { DataSets: n10 = [], DataSources: r10 = [], ReportParameters: o10 = [], EmbeddedImages: a10 = [], Layers: i10 = [] } = e14;
  const { DataSets: s10 = [], DataSources: l10 = [], ReportParameters: c10 = [], EmbeddedImages: u10 = [], Layers: d10 = [] } = t10 != null ? t10 : {};
  return { DataSources: [...X7(l10), ...Q7(r10)], DataSets: [...X7(s10), ...Q7(n10)], ReportParameters: [...X7(c10), ...Q7(o10)], EmbeddedImages: [...X7(u10), ...Q7(a10)], Layers: [...X7(d10), ...Q7(i10).filter((e15) => "default" !== e15.Name)] };
};
const t8 = (e14) => {
  const t10 = e14;
  if ("multisectionreport" !== t10.Type) return e14;
  const { DataSets: n10 = [], DataSources: r10 = [], ReportParameters: o10 = [], EmbeddedImages: a10 = [], Layers: i10 = [] } = t10;
  return __spreadProps(__spreadValues({}, e14), { DataSources: Q7(r10), DataSets: Q7(n10), ReportParameters: Q7(o10), EmbeddedImages: Q7(a10), Layers: Q7(i10) });
};
const n8 = (e14, t10, n10) => {
  const r10 = t10("documentsAPI:textRenamedItemPrefix", "Content_{{originalName}}", { originalName: e14 });
  return n10.includes(r10) ? kG(r10, n10) : r10;
};
const r8 = (e14) => e14.map((e15) => e15.Name);
const o8 = (e14, t10, n10, r10, o10) => {
  const a10 = [];
  const i10 = [];
  const s10 = [];
  const l10 = { duplicatedParamsNames: [], duplicatedDataSetNames: [], duplicatedDataSourceNames: [], duplicatedReportItemNames: [], duplicatedEmbeddedImagesNames: [], duplicatedLayersNames: [] };
  const { dataSets: c10, dataSources: u10, reportParameters: d10, embeddedImages: p10, layers: m10 } = ((e15, t11) => {
    var _a2, _b2, _c2, _d2, _e2;
    const n11 = (e16, t12) => e16.filter((e17) => t12.some((t13) => !J7(e17) && e17.Name === t13.Name));
    return { dataSets: n11((_a2 = t11 == null ? void 0 : t11.DataSets) != null ? _a2 : [], e15.DataSets), dataSources: n11((_b2 = t11 == null ? void 0 : t11.DataSources) != null ? _b2 : [], e15.DataSources), reportParameters: n11((_c2 = t11 == null ? void 0 : t11.ReportParameters) != null ? _c2 : [], e15.ReportParameters), embeddedImages: n11((_d2 = t11 == null ? void 0 : t11.EmbeddedImages) != null ? _d2 : [], e15.EmbeddedImages), layers: (r11 = (_e2 = t11 == null ? void 0 : t11.Layers) != null ? _e2 : [], o11 = e15.Layers, r11.filter((e16) => o11.some((t12) => !J7(e16) && "default" !== e16.Name && e16.Name === t12.Name))) };
    var r11, o11;
  })(t10, n10);
  const h10 = $7(o10 ? AV(n10, { ReportSections: { $set: p8(e14, t10, o10, false) } }) : n10, true);
  const f10 = h10.map((e15) => e15.name);
  const g10 = (y10 = h10, v10 = $7(t10), y10.filter((e15) => !!e15.name && !["multisectionreport", "section", "Continuous", "contentplaceholder", "pagesection"].includes(e15.type) && v10.some((t11) => e15.name === t11.name)));
  var y10, v10;
  if (g10.length && (s10.push("DuplicatedReportItemNamesError"), i10.push(u2({ path: "", descriptorValuePairs: [...g10.map((e15) => {
    const t11 = n8(e15.name, r10, f10);
    return f10.push(t11), { descriptor: Zq("", "", "string", `${e15.$path || ""}${"grouping" === e15.type ? ".Group" : ""}.Name`), value: t11 };
  })] })), g10.forEach(({ name: e15 }) => {
    var _a2;
    return (_a2 = l10.duplicatedReportItemNames) == null ? void 0 : _a2.push(e15);
  })), d10.length) {
    s10.push("DuplicatedParamsNamesError");
    const e15 = r8([...n10.ReportParameters, ...t10.ReportParameters]);
    a10.push(...d10.map((t11) => {
      var _a2;
      const o11 = Zq("", "", "reportparameter_name", "Name");
      const a11 = ((_a2 = n10.ReportParameters) != null ? _a2 : []).findIndex(({ Name: e16 }) => e16 === t11.Name);
      const i11 = `ReportParameters.${a11}`;
      const s11 = n8(t11.Name, r10, e15);
      return e15.push(s11), c2({ path: i11, descriptor: o11, value: s11 });
    })), d10.forEach(({ Name: e16 }) => {
      var _a2;
      return (_a2 = l10.duplicatedParamsNames) == null ? void 0 : _a2.push(e16);
    });
  }
  if (c10.length) {
    s10.push("DuplicatedDataSetsError");
    const e15 = r8([...n10.DataSets, ...t10.DataSets]);
    a10.push(...c10.map((t11) => {
      const n11 = n8(t11.Name, r10, e15);
      return e15.push(n11), q0({ dataSetName: t11.Name, dataSet: __spreadProps(__spreadValues({}, t11), { Name: n11 }) });
    })), c10.forEach(({ Name: e16 }) => {
      var _a2;
      return (_a2 = l10.duplicatedDataSetNames) == null ? void 0 : _a2.push(e16);
    });
  }
  if (u10.length) {
    s10.push("DuplicatedDataSourcesError");
    const e15 = r8([...n10.DataSources, ...t10.DataSources]);
    a10.push(...u10.map((t11) => {
      const n11 = n8(t11.Name, r10, e15);
      return e15.push(n11), X0({ name: t11.Name, dataSource: __spreadProps(__spreadValues({}, t11), { Name: n11 }) });
    })), u10.forEach(({ Name: e16 }) => {
      var _a2;
      return (_a2 = l10.duplicatedDataSourceNames) == null ? void 0 : _a2.push(e16);
    });
  }
  if (p10.length) {
    s10.push("DuplicatedEmbeddedImagesNamesError");
    const e15 = r8([...n10.EmbeddedImages, ...t10.EmbeddedImages]);
    a10.push(...p10.map((t11) => {
      const o11 = n10.EmbeddedImages.findIndex((e16) => e16.Name === t11.Name);
      const a11 = n8(t11.Name, r10, e15);
      return e15.push(a11), c2({ path: `EmbeddedImages.${o11}`, descriptor: Zq("", "", "string", "Name"), value: a11 });
    })), p10.forEach(({ Name: e16 }) => {
      var _a2;
      return (_a2 = l10.duplicatedEmbeddedImagesNames) == null ? void 0 : _a2.push(e16);
    });
  }
  if (m10.length) {
    s10.push("DuplicatedLayerNamesError");
    const e15 = r8([...n10.Layers, ...t10.Layers]);
    a10.push(...m10.map((t11) => {
      const n11 = n8(t11.Name, r10, e15);
      return e15.push(n11), M2({ layerName: t11.Name, newLayerName: n11 });
    })), m10.forEach(({ Name: e16 }) => {
      var _a2;
      return (_a2 = l10.duplicatedLayersNames) == null ? void 0 : _a2.push(e16);
    });
  }
  return { dataRenameActions: a10, reportItemRenameActions: i10, errors: s10, meta: l10 };
};
const a8 = { table: true, tablix: true, bandedlist: true };
const i8 = (e14, t10) => {
  const { t: n10 } = hG();
  if ((e14 == null ? void 0 : e14.length) && t10) {
    const r10 = e14 == null ? void 0 : e14.map((e15) => e15.Name).join(", ");
    const o10 = t10 == null ? void 0 : t10.Name;
    throw B0(fG("contentPlaceholderSize", n10), gG("contentPlaceholderSizeWithDetails", n10, { items: r10, contentPlaceholder: o10 }));
  }
  throw B0(fG("contentPlaceholderSize", n10), gG("contentPlaceholderSize", n10));
};
const s8 = (e14, t10) => {
  const { Width: n10, Height: r10 } = t10.$place;
  const o10 = { Width: L$.parseSafe(n10), Height: L$.parseSafe(r10) };
  const a10 = D3(e14);
  return a10.Width.greaterThan(o10.Width) || a10.Height.greaterThan(o10.Height);
};
const l8 = (e14, t10, n10 = false) => {
  const r10 = { foundBannedLargeItems: [], foundContainersWithItems: [], foundLargeItems: [] };
  return e14.forEach((e15) => {
    const n11 = s8(e15, t10);
    a8[e15.Type] && n11 && r10.foundBannedLargeItems.push(e15), ((e16) => "rectangle" === e16.Type && e16.ReportItems && e16.ReportItems.length)(e15) && n11 && r10.foundContainersWithItems.push(e15), n11 && r10.foundLargeItems.push(e15);
  }), r10.foundContainersWithItems.length && i8(r10.foundContainersWithItems, t10), r10.foundBannedLargeItems.length && !n10 && i8(r10.foundBannedLargeItems, t10), !!r10.foundLargeItems.length;
};
const c8 = (e14, t10, n10 = false) => {
  let r10 = t10;
  const { Width: o10, Height: a10 } = r10.$place;
  const i10 = x7(e14, n10);
  return l8(r10.ReportItems, r10, n10) && (r10 = i10(r10, L$.parse(o10), L$.parse(a10), L$.zero, L$.zero)), r10;
};
const u8 = (e14, t10, n10, r10 = true) => {
  const o10 = (e15) => L$.parse(e15).toTwips;
  const a10 = [];
  return C3(t10, w3((t11, i10, s10, l10) => {
    if ("contentplaceholder" === i10.Type) {
      const o11 = (({ x: e15, y: t12 }, n11, r11) => {
        var _a2;
        const { Top: o12, Left: a11 } = (_a2 = r11.place) != null ? _a2 : n11.$place;
        const i11 = L$.parseSafe(a11);
        const s12 = L$.parseSafe(o12);
        const l11 = L$.fromTwips(i11.toTwips + e15, i11.units);
        const c11 = L$.fromTwips(s12.toTwips + t12, s12.units);
        return BV.cloneDeep(__spreadProps(__spreadValues({}, n11), { $place: __spreadProps(__spreadValues({}, n11.$place), { Top: c11.css, Left: l11.css }) }));
      })(t11, i10, l10);
      const s11 = __spreadProps(__spreadValues({}, o11), { ReportItems: n10.get(i10.Name) || [], $inChildReport: true, LayerName: "default" });
      let c10 = nz.of(e14).create("contentplaceholder", i10.Name, void 0, s11);
      r10 && (c10 = c8(e14, c10, true)), a10.push(c10);
    }
    return t11 && (({ x: e15, y: t12, parent: n11 }, r11, a11) => ({ x: a11.place.Left ? e15 + o10(a11.place.Left) : e15, y: a11.place.Top ? t12 + o10(a11.place.Top) : t12, parent: VW(r11.Type) ? r11 : n11 }))(t11, i10, l10);
  }), { x: 0, y: 0, parent: null }), __spreadProps(__spreadValues({}, t10), { ReportItems: a10 });
};
const d8 = (e14, t10) => {
  const n10 = /* @__PURE__ */ new Map();
  const r10 = /* @__PURE__ */ new Map();
  const o10 = /* @__PURE__ */ new Map();
  const a10 = (e15) => e15.split(".").slice(0, 3).join(".");
  return C3(e14, x3((e15, t11, r11, i10) => {
    if ("contentplaceholder" === t11.Type) {
      const e16 = a10(i10.path);
      o10.set(t11.Name, t11.ReportItems), n10.set(t11.Name, e16);
    }
  })), C3(t10, x3((e15, t11, i10, s10) => {
    var _a2;
    if ("contentplaceholder" === t11.Type) {
      const e16 = a10(s10.path);
      if (n10.get(t11.Name) === e16) {
        const e17 = (_a2 = o10.get(t11.Name)) == null ? void 0 : _a2.filter((e18) => s8(e18, t11)).map((e18) => e18.Name);
        (e17 == null ? void 0 : e17.length) && r10.set(t11.Name, e17), n10.delete(t11.Name);
      } else n10.set(t11.Name, s10.path), o10.delete(t11.Name);
    }
  })), { itemsOutsideFromPlaceholder: r10, includeMisMatchItems: 0 !== n10.size, copyContent: o10 };
};
const p8 = (e14, t10, n10 = /* @__PURE__ */ new Map(), r10 = true) => t10.ReportSections.map((t11) => {
  const o10 = __spreadValues({}, t11);
  return Object.keys(o10).forEach((t12) => {
    if (j7.includes(t12) && o10[t12]) {
      const a10 = o10[t12];
      o10[t12] = u8(e14, a10, n10, r10);
    }
  }), o10;
});
const m8 = (e14, t10) => {
  let n10 = e14;
  const r10 = (e14.$index && e14.$index.NamedItems || []).reduce((e15, n11) => {
    const r11 = t10.map(({ Name: e16 }) => e16);
    if (n11.type && n11.name && n11.layerName && !r11.includes(n11.layerName)) {
      if (!e15.some((e16) => e16.leftKey < n11.leftKey && e16.rightKey > n11.rightKey)) return [...e15, n11];
    }
    return e15;
  }, []);
  if (r10.length > 0) {
    n10 = V5(n10, h5(r10.map((e16) => e16.name)));
    const e15 = ((e16) => {
      const t11 = [];
      return C3(e16, x3((e17, n11) => {
        n11 && rj(n11) && t11.push((e17 == null ? void 0 : e17.parentPath) || "");
      })), [...new Set(t11)].reverse();
    })(n10);
    e15.forEach((e16) => {
      const t11 = ((e17, t12) => {
        const n11 = t12.split(".").reduce((e18, t13) => e18 == null ? void 0 : e18[t13], e17);
        if (!n11) throw new Error(`Container with path "${t12}" does not exist`);
        return n11;
      })(n10, e16);
      const o10 = ((e17, t12) => {
        const n11 = { $splice: [] };
        return e17.slice().reverse().forEach((e18) => {
          if ((t12 == null ? void 0 : t12.ReportItems) && (t12 == null ? void 0 : t12.ReportItems.some(({ Name: t13 }) => t13 === e18.name))) {
            const r11 = t12.ReportItems.findIndex(({ Name: t13 }) => t13 === e18.name);
            n11.$splice.push([r11, 1]);
          }
        }), n11;
      })(r10, t11);
      const a10 = e16.split(".").reduceRight((e17, t12) => ({ [t12]: e17 }), { $set: AV(t11, { ReportItems: o10 }) });
      n10 = AV(n10, a10);
    });
  }
  return n10;
};
const h8 = { NULL: "Null", DATE_TIME: "DateTime", DATE: "Date", FLOAT: "Float", DECIMAL: "Decimal", INTEGER: "Integer", BOOLEAN: "Boolean", STRING: "String", BINARY: "Binary", ALL: "All" };
const f8 = (e14, t10, n10 = [], r10 = 0, o10 = false) => ({ DataType: e14, ArgumentsCount: t10, ArgumentsTypes: n10, ArgumentsExpansion: r10, IsSimple: o10 });
const g8 = { Count: f8(h8.INTEGER, 1, [[h8.ALL]]), CountDistinct: f8(h8.INTEGER, 1, [[h8.ALL]]), Max: f8(h8.ALL, 1, [[h8.DECIMAL, h8.FLOAT, h8.INTEGER, h8.DATE_TIME]]), Min: f8(h8.ALL, 1, [[h8.DECIMAL, h8.FLOAT, h8.INTEGER, h8.DATE_TIME]]), SqSum: f8(h8.ALL, 1, [[h8.DECIMAL, h8.FLOAT, h8.INTEGER]]), Sum: f8(h8.ALL, 1, [[h8.DECIMAL, h8.FLOAT, h8.INTEGER]]), Average: f8(h8.ALL, 1, [[h8.DECIMAL, h8.FLOAT, h8.INTEGER]]), StDev: f8(h8.FLOAT, 1, [[h8.DECIMAL, h8.FLOAT, h8.INTEGER]]), StDevP: f8(h8.FLOAT, 1, [[h8.DECIMAL, h8.FLOAT, h8.INTEGER]]), Var: f8(h8.FLOAT, 1, [[h8.DECIMAL, h8.FLOAT, h8.INTEGER]]), VarP: f8(h8.FLOAT, 1, [[h8.DECIMAL, h8.FLOAT, h8.INTEGER]]), Aggregate: f8(h8.ALL, 1, [[h8.ALL]]) };
const y8 = [h8.DATE_TIME, h8.DATE];
const v8 = { If: f8(h8.ALL, 3, [[h8.BOOLEAN], [h8.ALL], [h8.ALL]]), Switch: f8(h8.ALL, 2, [[h8.BOOLEAN], [h8.ALL]], 2), In: f8(h8.BOOLEAN, 2, [[h8.ALL], [h8.ALL]], 1, true), NotIn: f8(h8.BOOLEAN, 2, [[h8.ALL], [h8.ALL]], 1, true), Between: f8(h8.BOOLEAN, 3, [y8, y8, y8], 0, true) };
const b8 = { Binary16: f8(h8.BINARY, 1, [[h8.STRING]]), Decimal: f8(h8.DECIMAL, 1, [[h8.BOOLEAN, h8.FLOAT, h8.INTEGER, h8.STRING]]), Int: f8(h8.INTEGER, 1, [[h8.BOOLEAN, h8.DECIMAL, h8.FLOAT, h8.STRING]]), Float: f8(h8.FLOAT, 1, [[h8.BOOLEAN, h8.DECIMAL, h8.INTEGER, h8.STRING]]), Text: f8(h8.STRING, 1, [[h8.BOOLEAN, h8.DATE_TIME, h8.DECIMAL, h8.FLOAT, h8.INTEGER, h8.BINARY]]) };
const S8 = { DateAdd: f8(h8.DATE_TIME, 3, [[h8.STRING], [h8.INTEGER], [h8.DATE_TIME]]), DateDiff: f8(h8.DATE_TIME, 3, [[h8.STRING], [h8.DATE_TIME], [h8.DATE_TIME]]), Date: f8(h8.DATE_TIME, 3, [[h8.INTEGER], [h8.INTEGER], [h8.INTEGER]]), DateOnly: f8(h8.DATE_TIME, 1, [[h8.DATE_TIME]]), DateTime: f8(h8.DATE_TIME, 5, [[h8.INTEGER], [h8.INTEGER], [h8.INTEGER], [h8.INTEGER], [h8.INTEGER]]), Now: f8(h8.DATE_TIME, 0), Today: f8(h8.DATE_TIME, 0), Day: f8(h8.INTEGER, 1, [[h8.DATE_TIME]]), DayOfWeek: f8(h8.INTEGER, 1, [[h8.DATE_TIME]]), Week: f8(h8.INTEGER, 1, [[h8.DATE_TIME]]), DayOfYear: f8(h8.INTEGER, 1, [[h8.DATE_TIME]]), Month: f8(h8.INTEGER, 1, [[h8.DATE_TIME]]), Quarter: f8(h8.INTEGER, 1, [[h8.DATE_TIME]]), Year: f8(h8.INTEGER, 1, [[h8.DATE_TIME]]), Hour: f8(h8.INTEGER, 1, [[h8.DATE_TIME]]), Minute: f8(h8.INTEGER, 1, [[h8.DATE_TIME]]), Second: f8(h8.INTEGER, 1, [[h8.DATE_TIME]]) };
const C8 = { And: f8(h8.BOOLEAN, 2, [[h8.BOOLEAN], [h8.BOOLEAN]], 0, true), Or: f8(h8.BOOLEAN, 2, [[h8.BOOLEAN], [h8.BOOLEAN]], 0, true), Not: f8(h8.BOOLEAN, 1) };
const x8 = { Mod: f8(h8.INTEGER, 2, [[h8.INTEGER], [h8.INTEGER]]), Trunc: f8(h8.ALL, 2, [[h8.INTEGER, h8.DECIMAL, h8.FLOAT], [h8.INTEGER, h8.DECIMAL, h8.FLOAT]]), Round: f8(h8.ALL, 2, [[h8.INTEGER, h8.DECIMAL, h8.FLOAT], [h8.INTEGER, h8.DECIMAL, h8.FLOAT]]) };
const w8 = [h8.INTEGER, h8.DECIMAL, h8.FLOAT, h8.DATE_TIME, h8.DATE];
const T8 = { Add: f8(h8.ALL, 2, [[h8.INTEGER, h8.DECIMAL, h8.FLOAT], [h8.INTEGER, h8.DECIMAL, h8.FLOAT]]), Subtract: f8(h8.ALL, 2, [[h8.INTEGER, h8.DECIMAL, h8.FLOAT], [h8.INTEGER, h8.DECIMAL, h8.FLOAT]]), Multiply: f8(h8.ALL, 2, [[h8.INTEGER, h8.DECIMAL, h8.FLOAT], [h8.INTEGER, h8.DECIMAL, h8.FLOAT]]), Divide: f8(h8.ALL, 2, [[h8.INTEGER, h8.DECIMAL, h8.FLOAT], [h8.INTEGER, h8.DECIMAL, h8.FLOAT]]), EqualTo: f8(h8.BOOLEAN, 2, [[h8.ALL], [h8.ALL]], 0, true), NotEqualTo: f8(h8.BOOLEAN, 2, [[h8.ALL], [h8.ALL]], 0, true), GreaterThan: f8(h8.BOOLEAN, 2, [w8, w8], 0, true), GreaterThanOrEqualTo: f8(h8.BOOLEAN, 2, [w8, w8], 0, true), LessThan: f8(h8.BOOLEAN, 2, [w8, w8], 0, true), LessThanOrEqualTo: f8(h8.BOOLEAN, 2, [w8, w8], 0, true), Exponential: f8(h8.ALL, 2, [[h8.INTEGER, h8.DECIMAL, h8.FLOAT], [h8.INTEGER, h8.DECIMAL, h8.FLOAT]]), Negate: f8(h8.ALL, 1, [[h8.INTEGER, h8.DECIMAL, h8.FLOAT]]) };
const E8 = { Substring: f8(h8.STRING, 3, [[h8.STRING], [h8.INTEGER], [h8.INTEGER]]), Left: f8(h8.STRING, 2, [[h8.STRING], [h8.INTEGER]]), Right: f8(h8.STRING, 2, [[h8.STRING], [h8.INTEGER]]), Upper: f8(h8.STRING, 1, [[h8.STRING]]), Lower: f8(h8.STRING, 1, [[h8.STRING]]), LeftTrim: f8(h8.STRING, 1, [[h8.STRING]]), RightTrim: f8(h8.STRING, 1, [[h8.STRING]]), Concat: f8(h8.STRING, 2, [[h8.STRING], [h8.STRING]]), Find: f8(h8.INTEGER, 2, [[h8.STRING], [h8.STRING]]), Length: f8(h8.INTEGER, 1, [[h8.STRING]]), Replace: f8(h8.STRING, 3, [[h8.STRING], [h8.STRING], [h8.STRING]]), Contains: f8(h8.BOOLEAN, 2, [[h8.STRING], [h8.STRING]], 0, true), DoesNotContain: f8(h8.BOOLEAN, 2, [[h8.STRING], [h8.STRING]], 0, true), BeginsWith: f8(h8.BOOLEAN, 2, [[h8.STRING], [h8.STRING]], 0, true), DoesNotBeginWith: f8(h8.BOOLEAN, 2, [[h8.STRING], [h8.STRING]], 0, true) };
const F8 = { Filter: f8(h8.ALL, 1, [[h8.BOOLEAN]]) };
const M8 = { GetUserValue: f8(h8.ALL, 1, [[h8.STRING]]), GetUserValues: f8(h8.ALL, 1, [[h8.STRING]]) };
const k8 = __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, g8), v8), b8), S8), C8), x8), T8), E8), F8), M8);
Object.values(g8), Object.values(v8), Object.values(b8), Object.values(S8), Object.values(C8), Object.values(x8), Object.values(T8), Object.values(E8), Object.values(F8), Object.values(M8), Object.values(k8);
const P8 = { VALUE: "value", VARIABLE: "variable", CONSTANT: "constant", FUNCTION: "function", OPERATOR: "operator", SEPARATOR: "separator", LEFT_BRACKET: "left_bracket", RIGHT_BRACKET: "right_bracket" };
const N8 = { "+": { priority: 1 }, "-": { priority: 1 }, "*": { priority: 2 }, "/": { priority: 2 }, "%": { priority: 1 }, "<": { priority: 1 }, ">": { priority: 1 }, "<=": { priority: 1 }, ">=": { priority: 1 }, "=": { priority: 1 }, "<>": { priority: 1 }, "\\": { priority: 2 }, Mod: { priority: 1 }, And: { priority: 0 }, Or: { priority: 0 } };
const D8 = { E: Math.E, PI: Math.PI };
const L8 = "+-/*=<>&,()\\";
const H8 = /^[0-9]+e$/i;
const I8 = /^[0-9]$/;
function _8(e14) {
  const t10 = (e15) => e15[e15.length - 1];
  const n10 = [];
  const r10 = [];
  const o10 = [];
  let a10;
  return e14.reduce((i10, s10, l10) => {
    if (0 === l10 && "=" === s10) return i10;
    const c10 = function(e15, t11, n11) {
      const r11 = (t12) => {
        let n12;
        switch (t12) {
          case P8.CONSTANT:
            n12 = e15;
            break;
          case P8.VALUE:
            n12 = e15.replace(/^"|"$/g, ""), n12 = n12.replace(/\\"/g, '"');
            break;
          default:
            n12 = e15;
        }
        return { value: n12, type: t12, arity: 0 };
      };
      return ((e16) => null == e16 || "string" != typeof e16 || !(Number.isNaN(parseFloat(e16)) || !Number.isFinite(parseFloat(e16))) || "true" === e16.toLowerCase() || "false" === e16.toLowerCase() || "null" === e16.toLowerCase() || !!(e16.toString().length > 0 && e16.startsWith('"')))(e15) ? r11(P8.VALUE) : e15.toUpperCase() in D8 ? r11(P8.CONSTANT) : r11(e15 in k8 ? ")" === n11 && e15 in N8 ? P8.OPERATOR : "(" === t11 ? P8.FUNCTION : P8.VALUE : e15 in N8 ? P8.OPERATOR : "," === e15 ? P8.SEPARATOR : "(" === e15 ? P8.LEFT_BRACKET : ")" === e15 ? P8.RIGHT_BRACKET : P8.VARIABLE);
    }(s10, e14[l10 + 1], l10 > 0 ? e14[l10 - 1] : "");
    switch (c10.type) {
      case P8.VARIABLE:
      case P8.CONSTANT:
      case P8.VALUE:
        i10.push(c10), r10.length > 0 && (r10.pop(), r10.push(true));
        break;
      case P8.FUNCTION:
        c10.arity = 1, n10.push(c10), o10.push(0), r10.length > 0 && (r10.pop(), r10.push(true)), r10.push(false);
        break;
      case P8.SEPARATOR:
        for (; n10.length > 0 && t10(n10).type !== P8.LEFT_BRACKET; ) {
          const e15 = n10.pop();
          void 0 !== e15 && i10.push(e15);
        }
        if (r10.pop()) {
          let e15 = o10.pop();
          void 0 !== e15 && (e15++, o10.push(e15));
        }
        r10.push(false);
        break;
      case P8.OPERATOR:
        if (a10 && a10.type !== P8.OPERATOR && a10.type !== P8.LEFT_BRACKET) for (c10.arity = 2; n10.length > 0 && t10(n10).type === P8.OPERATOR && N8[c10.value.toString()].priority <= N8[t10(n10).value.toString()].priority; ) {
          const e15 = n10.pop();
          void 0 !== e15 && i10.push(e15);
        }
        else c10.arity = 1;
        n10.push(c10);
        break;
      case P8.LEFT_BRACKET:
        if (a10 && a10.type === P8.VARIABLE) throw new Error(`Syntax error at token ${a10.value.toString()}`);
        n10.push(c10);
        break;
      case P8.RIGHT_BRACKET:
        for (; n10.length > 0 && t10(n10).type !== P8.LEFT_BRACKET; ) {
          const e15 = n10.pop();
          void 0 !== e15 && i10.push(e15);
        }
        if (n10.pop(), n10.length > 0 && t10(n10).type === P8.FUNCTION) {
          const e15 = n10.pop();
          let t11 = o10.pop();
          r10.pop() && void 0 !== t11 && t11++, void 0 !== e15 && void 0 !== t11 && (e15.arity = t11, i10.push(e15));
        }
        break;
      default:
        throw new Error(`Unknown token: ${c10.value.toString()}`);
    }
    return a10 = c10, i10;
  }, []).concat(n10.reverse());
}
function V8(e14) {
  if (!e14) return [];
  const t10 = function(e15) {
    const t11 = e15.replace(/(\s\s+)|(\t)/g, " ").trim();
    const n10 = (e16) => e16 && H8.test(e16);
    const r10 = (e16) => e16 && I8.test(e16);
    const o10 = [];
    let a10 = "";
    let i10 = false;
    let s10 = 0;
    for (let e16 = 0; e16 < t11.length; e16++) {
      const c10 = t11[e16];
      const u10 = t11[e16 + 1];
      if ('"' !== c10 || 0 !== a10.length && a10.endsWith("\\") || (i10 = !i10), i10 || '"' === c10) a10 += c10;
      else if (i10 || 0 !== a10.length && a10.endsWith("\\") || ("[" === c10 ? s10++ : "]" === c10 && s10 > 0 && s10--), s10 > 0) a10 += c10;
      else if (" " !== c10) if ((l10 = c10) && L8.includes(l10)) {
        if (("+" === c10 || "-" === c10) && n10(a10)) {
          a10 += c10;
          continue;
        }
        if (("+" === c10 || "-" === c10) && r10(u10)) {
          "" !== a10 && o10.push(a10), a10 = c10;
          continue;
        }
        if ("" !== a10 && o10.push(a10), a10 = "", "=" !== c10 && "<" !== c10 && ">" !== c10 || !(o10.length > 0) || "<" !== o10[o10.length - 1] && ">" !== o10[o10.length - 1]) if ("(" === c10 && o10.length > 0) {
          const e17 = o10[o10.length - 1];
          const t12 = Math.max(e17.lastIndexOf("."), e17.lastIndexOf("!"));
          t12 > 0 && (o10[o10.length - 1] = e17.substr(0, t12), o10.push(e17.substr(t12))), o10.push(c10);
        } else o10.push(c10);
        else o10[o10.length - 1] += c10;
      } else a10 += c10;
      else "" !== a10 && o10.push(a10), a10 = "";
    }
    var l10;
    return "" !== a10 && o10.push(a10), o10;
  }(e14);
  return _8(t10);
}
const R8 = { FUNCTION: "function", OPERATOR: "operator", ATTRIBUTE: "attribute", CONSTANT: "constant", PARAMETER: "parameter" };
const A8 = (e14) => e14.Type === R8.PARAMETER ? `@${e14.Value}` : `${e14.Value}`;
const O8 = (e14, t10) => hG().t(`error:expressionNode.${e14}`, t10);
const B8 = (e14, t10, n10, r10) => O8("argumentValueNotFitFunctionValueDataType", { argument: A8(e14), functionName: t10, expectedTypes: n10, actualType: r10 });
const z8 = (e14, t10) => O8("typeMismatch", { value: A8(e14), expectedType: t10 });
const $8 = { "+": "Add", "-": "Subtract", "*": "Multiply", "/": "Divide", "%": "Mod", "<": "LessThan", ">": "GreaterThan", "<=": "LessThanOrEqualTo", ">=": "GreaterThanOrEqualTo", "=": "EqualTo", "<>": "NotEqualTo", And: "And", Or: "Or", Mod: "Mod" };
const W8 = (e14 = R8.CONSTANT, t10 = "", n10 = []) => ({ Type: e14, Value: t10, ValueType: "", Arguments: n10 });
const j8 = (e14) => e14.length > 0 && "@" === e14[0];
const Z8 = (e14) => e14.length > 1 && "[" === e14[0] && "]" === e14[e14.length - 1];
const G8 = (e14) => e14.length > 1 && '"' === e14[0] && '"' === e14[e14.length - 1];
function U8(e14) {
  if (!e14) return null;
  return function(e15) {
    var _a2, _b2;
    const t10 = [];
    for (let n10 = 0; n10 < e15.length; n10++) {
      const r10 = e15[n10];
      const o10 = (_b2 = (_a2 = r10.value) == null ? void 0 : _a2.toString()) != null ? _b2 : "";
      let a10;
      if (r10.type === P8.VARIABLE) if (j8(r10.value)) a10 = W8(R8.PARAMETER, o10.slice(1));
      else {
        if (!Z8(r10.value)) throw new Error(`Unknown variable: ${r10.value}`);
        a10 = W8(R8.ATTRIBUTE, o10.slice(1, -1));
      }
      else if (r10.type === P8.VALUE || r10.type === P8.CONSTANT) a10 = G8(r10.value) ? W8(R8.CONSTANT, o10.slice(1, -1)) : W8(R8.CONSTANT, o10);
      else {
        if (r10.type !== P8.FUNCTION && r10.type !== P8.OPERATOR) throw new Error(`Unknown token: [type: ${r10.type}, value:${r10.value}]`);
        {
          let e16 = o10;
          if (r10.type === P8.OPERATOR && (e16 = $8[o10], !e16)) throw new Error(`Unable to convert operator '${r10.value}' to function`);
          a10 = W8(R8.FUNCTION, e16);
          for (let e17 = 0; e17 < r10.arity; e17++) a10.Arguments.push(t10.pop());
          a10.Arguments.reverse();
        }
      }
      t10.push(a10);
    }
    if (1 !== t10.length) throw new Error("Invalid tokens structure");
    return t10[0];
  }(V8(e14));
}
const q8 = ["true", "false", "null"];
const Y8 = /^(-?\d+(?:|\.\d+))$/;
const K8 = (e14) => Y8.test(e14);
const X8 = (e14) => {
  if ("string" != typeof e14) throw new Error(`Constant value cannot be of other type but string (value ${e14} of type '${typeof e14}')`);
  if (((e15) => q8.includes(e15))(e14) || K8(e14)) return e14;
  return `"${e14.replace(/"/g, '\\"')}"`;
};
const J8 = (e14) => {
  if ("string" != typeof e14.Value) throw new Error(`Constant value cannot be of other type but string (value ${e14.Value} of type '${typeof e14.Value}')`);
  if ("null" === e14.Value.trim().toLocaleLowerCase()) return "null";
  switch (e14.ValueType) {
    case h8.STRING:
      return `"${e14.Value.replace(/"/g, '\\"')}"`;
    case h8.BOOLEAN: {
      const t10 = e14.Value.trim().toLocaleLowerCase();
      if ("true" !== t10 && "false" !== t10) throw new Error(z8(e14, e14.ValueType));
      return t10;
    }
    case h8.DECIMAL:
    case h8.FLOAT: {
      const t10 = e14.Value.trim();
      if (!K8(t10)) throw new Error(z8(e14, e14.ValueType));
      return t10;
    }
    case h8.INTEGER: {
      const t10 = e14.Value.trim();
      if (!(parseFloat(t10) % 1 == 0) || !K8(t10)) throw new Error(z8(e14, e14.ValueType));
      return t10;
    }
    case h8.NULL: {
      const t10 = e14.Value.trim().toLocaleLowerCase();
      if ("null" !== t10) throw new Error(z8(e14, e14.ValueType));
      return t10;
    }
    case h8.DATE: {
      const t10 = e14.Value.trim();
      if (!(K8(t10) || !Number.isNaN(Date.parse(t10)))) throw new Error(z8(e14, e14.ValueType));
      return `"${t10}"`;
    }
    case h8.DATE_TIME: {
      const t10 = e14.Value.trim();
      if (!(K8(t10) || !Number.isNaN(Date.parse(t10)))) throw new Error(z8(e14, e14.ValueType));
      return `"${t10}"`;
    }
    default:
      return X8(e14.Value);
  }
};
function Q8(e14) {
  return [...e14].reverse().reduce((e15, t10) => e15 ? `And(${t10}, ${e15})` : t10, "");
}
function e6(e14) {
  const t10 = e14.Arguments.map(e6).filter(Ie);
  if (e14.Type === R8.FUNCTION && ("And" === e14.Value || "Or" === e14.Value)) {
    if (1 === t10.length) return t10[0];
    if (0 === t10.length) return null;
  }
  return __spreadProps(__spreadValues({}, e14), { Arguments: t10 });
}
function t6(e14, t10) {
  if (!e14) return [];
  const n10 = [];
  switch (e14.Type) {
    case R8.FUNCTION: {
      const r10 = e14.Arguments.map((e15) => t6(e15, t10));
      t10 && "And" === e14.Value ? (n10.push(Q8(r10[0])), r10.forEach((e15, t11) => {
        0 !== t11 && e15.forEach((e16) => n10.push(e16));
      })) : n10.push(`${e14.Value}(${r10.map((e15) => Q8(e15)).join(", ")})`);
      break;
    }
    case R8.ATTRIBUTE:
      n10.push(`[${e14.Value}]`);
      break;
    case R8.PARAMETER:
      n10.push(`@${e14.Value}`);
      break;
    case R8.CONSTANT: {
      const t11 = J8(e14);
      n10.push(t11);
      break;
    }
    default:
      throw new Error("Unknown node type");
  }
  return n10;
}
const n6 = (e14, t10 = false) => t6(e6(e14), t10);
const r6 = (e14, t10) => {
  const { semanticModel: n10, entityName: r10, reportParameters: o10, queryParameters: a10 } = t10;
  const i10 = [];
  return e14.Arguments.forEach((t11, s10) => {
    var _a2;
    const l10 = ((e15, t12) => {
      const n11 = k8[e15.Value];
      const r11 = t12 < n11.ArgumentsCount ? t12 : n11.ArgumentsCount - (t12 % n11.ArgumentsExpansion + 1);
      return n11.ArgumentsTypes[r11];
    })(e14, s10) || [];
    let c10 = null;
    if (((e15) => e15 && e15.Type && e15.Type === R8.ATTRIBUTE)(t11)) {
      if (c10 = d6(t11.Value, r10, n10), !c10) throw Error(`Could not determine data type of attribute '${t11.Value}' in function '${e14.Value}'`);
    } else if (((e15) => e15 && e15.Type && e15.Type === R8.PARAMETER)(t11)) {
      const i11 = a10.find((e15) => e15.Name === t11.Value);
      const s11 = i11 ? i11.Value : "";
      if (c10 = M6((_a2 = s11 == null ? void 0 : s11.toString()) != null ? _a2 : "", o10, r10, n10), !c10) throw Error(`Could not determine data type of parameter '${t11.Value}' in function '${e14.Value}'`);
    } else if (((e15) => e15 && e15.Type && e15.Type === R8.FUNCTION)(t11)) {
      const e15 = k8[t11.Value];
      if (!e15) throw Error(`Invalid function name '${t11.Value}'`);
      c10 = e15.DataType;
    }
    i10.push(/* @__PURE__ */ ((e15, t12, n11) => ({ dataType: e15, validDataTypes: t12, index: n11 }))(c10, l10, s10));
  }), i10;
};
const o6 = (e14) => e14.validDataTypes.length > 1 || 1 === e14.validDataTypes.length && e14.validDataTypes[0] === h8.ALL;
const a6 = ["In", "NotIn", "Between", "EqualTo", "NotEqualTo", "GreaterThan", "GreaterThanOrEqualTo", "LessThan", "LessThanOrEqualTo"];
const i6 = (e14, t10, n10) => {
  let r10 = null;
  let o10 = false;
  const a10 = t10.filter(o6);
  if (a10.forEach(({ dataType: t11, validDataTypes: a11, index: i10 }) => {
    const s10 = ((e15, t12) => t12 === h8.DATE && a6.includes(e15) ? h8.DATE_TIME : t12)(e14.Value, t11);
    if (!s10 || s10 === h8.ALL) return;
    r10 && r10 !== s10 && (o10 = true);
    a11.includes(s10) || 1 === a11.length && a11[0] === h8.ALL || n10(i10, B8(e14.Arguments[i10], e14.Value, a11.join(", "), s10)), r10 || (r10 = s10);
  }), o10) {
    const t11 = ((e15, t12) => {
      const n11 = e15.map((e16) => `'${A8(e16)}'`).join(", ");
      return O8("argumentsShouldHaveSameDataType", { arguments: n11, functionName: t12 });
    })(a10.map((t12) => e14.Arguments[t12.index]), e14.Value);
    a10.forEach((e15) => {
      n10(e15.index, t11);
    });
  }
  return !r10 && a10.length && (r10 = [h8.STRING, h8.INTEGER, h8.FLOAT, h8.DECIMAL, h8.BOOLEAN, h8.DATE_TIME, h8.DATE, h8.BINARY, h8.NULL].find((e15) => a10.every((t11) => t11.validDataTypes.some((t12) => t12 === h8.ALL || e15))) || null), r10;
};
const s6 = (e14, t10) => {
  if (!k8[e14.Value].ArgumentsTypes.length) return { node: e14, errors: {} };
  const n10 = {};
  const r10 = (e15, t11) => {
    n10[e15] || (n10[e15] = t11);
  };
  const o10 = r6(e14, t10);
  const a10 = i6(e14, o10, r10);
  const i10 = {};
  return e14.Arguments.forEach((t11, n11) => {
    const s10 = o10[n11];
    let l10 = t11;
    let c10;
    if (o6(s10) ? a10 && (c10 = a10) : ((e15) => 1 === e15.validDataTypes.length && e15.validDataTypes[0] !== h8.ALL)(s10) && (s10.dataType ? s10.validDataTypes[0] === s10.dataType ? c10 = s10.dataType : r10(n11, B8(t11, e14.Value, s10.validDataTypes[0], s10.dataType)) : c10 = s10.validDataTypes[0]), c10 && l10.ValueType !== c10 && (l10 = AV(l10, { ValueType: { $set: c10 } })), ((e15) => e15 && e15.Type && e15.Type === R8.CONSTANT)(l10)) try {
      J8(l10);
    } catch (o11) {
      r10(n11, ((e15, t12, n12) => O8("argumentIsNotValid", { argument: A8(e15), functionName: t12, details: n12 }))(t11, e14.Value, o11.message));
    }
    t11 !== l10 && (i10[n11] = { $set: l10 });
  }), { node: zV.isEmpty(i10) ? e14 : AV(e14, { Arguments: i10 }), errors: n10 };
};
function l6(e14, t10, n10 = true) {
  let r10 = e14;
  if (e14.Type === R8.FUNCTION) {
    const e15 = s6(r10, t10);
    const o11 = e15.errors;
    if (!zV.isEmpty(o11) && n10) throw Error(Object.values(o11).join("\r\n"));
    r10 = ((e16, t11) => {
      const n11 = {};
      return e16.Arguments.forEach((e17, r11) => {
        t11[r11] ? t11[r11] !== e17.$error && (n11[r11] = { $error: { $set: t11[r11] } }) : e17.$error && (n11[r11] = { $error: { $set: "" } });
      }), zV.isEmpty(n11) ? e16 : AV(e16, { Arguments: n11 });
    })(e15.node, o11);
  }
  const o10 = {};
  return r10.Arguments.forEach((e15, r11) => {
    const a10 = l6(e15, t10, n10);
    e15 !== a10 && (o10[r11] = { $set: a10 });
  }), r10 = zV.isEmpty(o10) ? r10 : AV(r10, { Arguments: o10 }), r10;
}
function c6(e14, t10) {
  if (e14) {
    for (const n10 in e14) if (e14.hasOwnProperty(n10) && e14[n10].Name === t10) return e14[n10];
  }
  return null;
}
const u6 = ({ RelatedEntityId: e14 }, t10) => {
  var _a2;
  return (_a2 = t10 == null ? void 0 : t10[e14]) != null ? _a2 : null;
};
const d6 = (e14, t10, n10) => {
  var _a2;
  const r10 = T6(e14);
  const o10 = c6((_a2 = n10 == null ? void 0 : n10.entities) != null ? _a2 : {}, t10);
  if (!o10) return "";
  let a10 = o10;
  for (let e15 = 0; e15 < r10.length; e15++) {
    if (e15 === r10.length - 1) {
      for (const t12 of a10.Attributes || []) {
        const n11 = "Date" === t12.LogicalDataType;
        if (r10[e15] === t12.FormattedName) return n11 ? "Date" : t12.DataType;
        for (const o12 of t12.Variations || []) if (r10[e15] === o12.FormattedName) return n11 && "DateTime" === o12.DataType ? "Date" : o12.DataType;
      }
      return "";
    }
    const t11 = (a10.Relations || []).find((t12) => t12.FormattedName === r10[e15]);
    if (!t11) return "";
    const o11 = u6(t11, n10 == null ? void 0 : n10.entities);
    if (!o11) return "";
    a10 = o11;
  }
  return "";
};
function p6(e14, t10) {
  const n10 = t10[e14];
  if (!n10) throw new Error(`Entity with id=${e14} not loaded yet`);
  return function(e15, t11, n11) {
    return !!(e15 && t11 && e15.Id in t11) && !!e15.$scopeLoaded && (!n11 || e15.Relations.every((e16) => {
      const n12 = u6(e16, t11);
      return n12 && n12.$scopeLoaded;
    }));
  }(n10, t10, true) ? null : { scopes: [{ baseEntityName: n10.Name, withRelations: true }], excludedIds: Object.keys(t10) };
}
const m6 = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const h6 = (e14) => e14 && m6.test(e14);
const f6 = (e14) => {
  let t10;
  try {
    t10 = U8(e14);
  } catch (e15) {
    return null;
  }
  return t10;
};
const g6 = 1, y6 = 2;
const v6 = (e14) => (e14 || []).find((e15) => b$(e15)) || null;
const b6 = (e14) => !!v6(e14.DataSources);
const S6 = (e14) => {
  var _a2;
  if (!((_a2 = e14 == null ? void 0 : e14.Query) == null ? void 0 : _a2.CommandText)) return null;
  const t10 = e14.Query.CommandText.split("\n", 2);
  if (t10.length <= 1) return null;
  return t10[1].trim();
};
const C6 = (e14, t10) => {
  const n10 = e14.Query.DataSourceName;
  const r10 = t10.find((e15) => e15.Name === n10);
  return r10 && b$(r10) || false;
};
const x6 = (e14) => {
  const t10 = ((e15) => x0(e15))(e14);
  const n10 = e14.DataSources || [];
  const r10 = e14.DataSets.map((e15, r11) => {
    if (J7(e15) || !C6(e15, n10)) return e15;
    const o10 = [];
    const a10 = t10.find((t11) => t11.dataSetName === e15.Name);
    if (a10 && a10.values.length > 0 && o10.push(...a10.values), 0 === r11) {
      const e16 = t10.find((e17) => !e17.dataSetName);
      e16 && e16.values.length > 0 && o10.push(...e16.values);
    }
    const i10 = ((e16, t11) => {
      var _a2;
      if (!e16) return null;
      const n11 = (((_a2 = e16.Query) == null ? void 0 : _a2.CommandText) || "").split("\n", 3).join("\n");
      const r12 = BV.uniq(t11 || []).sort();
      const o11 = yK(e16).filter((e17) => !e17.DataField);
      const a11 = [];
      r12.forEach((e17) => {
        const t12 = o11.find((t13) => t13.Name === e17);
        t12 || a11.push({ Name: e17, DataField: e17 });
      }), a11.push(...o11);
      const i11 = a11.filter((e17) => !!e17.DataField).map((e17) => e17.Name).filter((e17) => e17);
      const s10 = BV.uniq(i11).sort().map((e17) => `	${e17}`).join("\n");
      return AV(e16, { Query: { CommandText: { $set: `${n11}
${s10}` } }, Fields: { $set: a11 } });
    })(e15, o10);
    return ((e16) => {
      let t11 = e16;
      let n11 = t11.Query.CommandText;
      t11.$queryFilter && (n11 = `${n11}
where
	${n6(t11.$queryFilter, true).join("\n	")}`);
      return t11 = AV(t11, { Query: { CommandText: { $set: n11 } } }), Object.getOwnPropertyNames(t11).filter((e17) => e17.length > 0 && "$" !== e17[0]).reduce((e17, n12) => __spreadProps(__spreadValues({}, e17), { [n12]: t11[n12] }), {});
    })(i10);
  });
  return AV(e14, { DataSets: { $set: r10 } });
};
const w6 = (e14) => {
  if (!b6(e14)) return e14;
  let t10 = e14;
  const n10 = t10.DataSets || [];
  const r10 = {};
  return n10.forEach((e15, t11) => {
    const n11 = ((e16) => {
      const t12 = e16 && e16.Query && e16.Query.CommandText || "";
      const n12 = t12.split("\n").map((e17) => e17 && e17.trimRight() || "");
      const r11 = ((e17) => (e17 || []).findIndex((e18) => e18 && "where" === e18.toLowerCase()))(n12);
      const o10 = r11 >= 0 ? n12.slice(0, r11).join("\n") : t12;
      const a10 = (e16.Query.QueryParameters || []).map((e17) => h6(e17.Name) ? AV(e17, { Name: { $set: e17.Name.toLowerCase() } }) : e17);
      const i10 = r11 >= 0 && r11 < n12.length - 1 ? Q8(n12.slice(r11 + 1)) : "";
      return AV(e16, { Query: { CommandText: { $set: o10 }, QueryParameters: { $set: a10 } }, $queryFilter: { $set: f6(i10) } });
    })(e15);
    r10[t11] = { $set: n11 };
  }), BV.isEmpty(r10) || (t10 = AV(t10, { DataSets: r10 })), t10;
};
const T6 = (e14) => {
  const t10 = [];
  let n10 = "";
  let r10 = 0;
  for (let o10 = 0; o10 < e14.length; o10++) {
    const a10 = e14[o10];
    0 !== n10.length && "\\" === n10[n10.length - 1] || ("[" === a10 ? r10++ : "]" === a10 && r10 > 0 && r10--), r10 > 0 ? n10 += a10 : "." !== a10 ? (n10 += a10, o10 === e14.length - 1 && t10.push(n10)) : (t10.push(n10), n10 = "");
  }
  return t10;
};
const E6 = ({ Cardinality: e14 }) => "One" === e14 || "OptionalOne" === e14;
const F6 = ({ Cardinality: e14 }) => "Many" === e14 || "OptionalMany" === e14;
const M6 = (e14, t10, n10, r10) => {
  const o10 = "string" == typeof e14 ? e14 : "";
  if (!o10) return h8.ALL;
  const a10 = ((e15) => {
    const t11 = /^=Parameters!([\w_]+).*$/.exec(e15);
    return t11 && t11[1] || null;
  })(o10);
  if (a10) {
    const e15 = t10.find((e16) => e16.Name === a10);
    if (e15) return e15.DataType || h8.ALL;
  }
  if (E1(o10)) {
    const e15 = N1(o10);
    const t11 = e15 && e15[0] || null;
    if (t11) return d6(t11, n10, r10) || h8.ALL;
  }
  return h8.ALL;
};
const k6 = (e14) => G1(e14);
const P6 = (e14) => `=${e14}`;
const N6 = (e14) => P6(k6(e14));
const D6 = (e14, t10, n10) => {
  const r10 = ((e15, t11) => {
    const n11 = e15 || 0;
    return n11 <= 0 ? "" : t11("components:dataPanel.semantic.textAttributesCount", "{{count}} attribute", { count: n11 });
  })(e14, n10);
  const o10 = ((e15, t11) => {
    const n11 = e15 || 0;
    return n11 <= 0 ? "" : t11("components:dataPanel.semantic.textRelationsCount", "{{count}} relation", { count: n11 });
  })(t10, n10);
  return r10 && o10 ? `${r10}, ${o10}` : !r10 && o10 ? o10 : r10 && !o10 ? r10 : [n10("components:dataPanel.semantic.textNoAttributes", "no attributes"), n10("components:dataPanel.semantic.textNoRelations", "no relations")].join(", ");
};
const L6 = (e14) => e14.Variations.length > 0;
const H6 = (e14) => e14.$rebalance && !e14.$rebalance.canRebalance && !e14.IsAggregate;
const I6 = (...e14) => e14.filter(Boolean).join(".");
const _6 = (e14, t10, n10, r10) => {
  const o10 = n10.split("/");
  let a10 = t10;
  const i10 = o10.length;
  const s10 = [r10];
  for (let t11 = 0; t11 < i10 - 1; t11++) {
    const n11 = o10[t11];
    const r11 = a10.Relations.find((e15) => e15.Id === n11);
    if (!r11) throw Error(`The entity '${a10.Name}' does not contain relation '${n11}'.`);
    s10.push(r11.FormattedName);
    const i11 = u6(r11, e14);
    if (!i11) throw Error(`The related entity of the relation '${r11.Name}' is not loaded yet.`);
    a10 = i11;
  }
  const l10 = o10[i10 - 1];
  const c10 = ((e15, t11) => {
    const n11 = e15.Attributes || [];
    for (const e16 of n11) {
      if (e16.Id === t11) return e16;
      const n12 = e16.Variations || [];
      for (const e17 of n12) if (e17.Id === t11) return e17;
    }
    return null;
  })(a10, l10);
  if (!c10) throw Error(`The entity '${a10.Name}' does not contain attribute or variation ${l10}`);
  return ((e15, t11) => ({ id: e15.Id, label: e15.Name, path: I6(t11, e15.FormattedName), format: e15.Format }))(c10, I6(...s10));
};
const V6 = (e14, t10, n10, r10 = "") => (n10 || []).map((n11) => _6(e14, t10, n11, r10));
const R6 = (e14) => Jc.replace(e14, Jc("[^\\pL_\\d]", "g"), "");
const A6 = (e14) => {
  const { DefaultDetailAttributesIds: t10, IdentifyingAttributesIds: n10 } = e14;
  return t10.length > 0 ? t10 : n10;
};
const O6 = (e14, t10) => {
  const n10 = S6(e14);
  if (!n10) throw new Error(`Invalid semantic data set: ${e14.Name}`);
  const r10 = c6(t10, n10);
  if (!r10) throw new Error(`Invalid entity name: ${n10}`);
  return r10;
};
const B6 = { columns: [{ label: "", expr: "", format: "" }], details: { expressions: [] } };
const z6 = { properties: { DataSetName: "", Type: "table" }, fillData: B6, type: "entity_relation", reportItemType: "table" };
const $6 = (e14, t10) => (n10, r10) => {
  var _a2;
  const o10 = t10 && t10.entities || {};
  const a10 = ((_a2 = r10 == null ? void 0 : r10.$rebalance) == null ? void 0 : _a2.canRebalance) ? r10.$rebalance.getInfo().path : null;
  const i10 = O6(e14, o10);
  const s10 = { DataSetName: e14.Name, Type: n10 };
  let l10 = {};
  switch (n10) {
    case "table":
    case "fixedpagetable": {
      let e15 = B6;
      try {
        e15 = r10 && a10 ? ((e16, t11, n11) => {
          const r11 = t11 && t11.entities || {};
          const o11 = u6(n11, r11);
          if (!o11) throw Error(`The related entity of the relation '${n11.Name}' is not loaded yet.`);
          const a11 = V6(r11, o11, A6(o11), n11.$path);
          const i11 = V6(r11, o11, o11.IdentifyingAttributesIds, n11.$path);
          const s11 = V6(r11, e16, e16.IdentifyingAttributesIds);
          const l11 = P6(s11.map((e17) => k6(e17.path)).join(' & "; " & '));
          const c11 = 1 === s11.length && s11[0].format || "";
          return { columns: a11.map((e17) => ({ label: e17.label, expr: N6(e17.path), format: e17.format })), details: { expressions: i11.map((e17) => N6(e17.path)) }, group: { label: l11, name: R6(e16.Name), expressions: s11.map((e17) => N6(e17.path)), format: c11 } };
        })(i10, t10, r10) : ((e16, t11, n11) => {
          const r11 = t11 && t11.entities || {};
          const o11 = V6(r11, e16, A6(e16));
          const a11 = V6(r11, e16, e16.IdentifyingAttributesIds);
          const i11 = { columns: o11.map((e17) => ({ label: e17.label, expr: N6(e17.path), format: e17.format })), details: { expressions: a11.map((e17) => N6(e17.path)) } };
          if (n11) {
            const e17 = u6(n11, r11);
            if (!e17) throw Error(`The related entity of the relation '${n11.Name}' is not loaded yet.`);
            const t12 = V6(r11, e17, e17.IdentifyingAttributesIds, n11.$path);
            const o12 = P6(t12.map((e18) => k6(e18.path)).join(' & "; " & '));
            const a12 = 1 === t12.length && t12[0].format || "";
            i11.group = { label: o12, name: R6(e17.Name), expressions: t12.map((e18) => N6(e18.path)), format: a12 };
          }
          return i11;
        })(i10, t10, r10);
      } catch (e16) {
      }
      l10 = e15;
      break;
    }
  }
  let c10;
  return a10 && (c10 = [z$({ semanticModel: t10, dataSetName: e14.Name, path: a10 })]), { properties: s10, fillData: l10, type: "entity_relation", dropActions: c10, reportItemType: n10 };
};
const W6 = (e14, t10 = "", n10 = null) => {
  const r10 = e14.filter((e15) => !e15.Hidden).map((e15) => __spreadProps(__spreadValues({}, e15), { Variations: W6(e15.Variations || [], t10, n10), $rebalance: e15.IsAggregate ? null : n10, $relationsPath: t10, $path: I6(t10, e15.FormattedName) }));
  return r10;
};
const j6 = (e14) => "Many" === e14 || "OptionalMany" === e14;
const Z6 = (e14, t10, n10, r10, o10 = [], a10 = "") => {
  const i10 = t10.reduce((t11, i11) => {
    if (!i11.Hidden && (!j6(i11.Cardinality) || r10)) {
      const r11 = q6(e14, i11, n10, o10, a10);
      r11 && t11.push(r11);
    }
    return t11;
  }, []);
  return i10;
};
const G6 = (e14, t10) => (e14 || []).indexOf(t10.Id) >= 0;
const U6 = (e14, t10) => (t10.HiddenFields || []).includes(e14.Id);
const q6 = (e14, t10, n10, r10, o10) => {
  if (G6(r10, t10)) return null;
  const a10 = [...r10, t10.Id];
  const i10 = u6(t10, e14);
  if (!i10) return null;
  const s10 = i10.Attributes || [];
  const l10 = (i10.Relations || []).filter((e15) => e15 && !G6(a10, e15));
  const c10 = s10.filter((e15) => !e15.Hidden && !U6(e15, t10));
  const u10 = l10.filter((e15) => !e15.Hidden && !U6(e15, t10));
  const d10 = I6(o10, t10.FormattedName);
  return n10(__spreadProps(__spreadValues({}, t10), { $path: d10, $usedRelationIds: r10 || [], $attributesCount: c10.length, $relationsCount: u10.length, $baseRef: null, $rebalance: null }));
};
const Y6 = (e14, t10, n10) => {
  const r10 = (e15) => (t11) => t11.FormattedName === e15;
  const o10 = (e15) => (t11) => t11.RelatedEntityId === e15;
  const a10 = c6(n10 == null ? void 0 : n10.entities, t10);
  if (!a10) throw Error(`Invalid entity name: ${t10}`);
  const i10 = T6(e14);
  let s10 = a10;
  let l10 = 0;
  for (; l10 < i10.length; ) {
    const e15 = (s10.Relations || []).find(r10(i10[l10]));
    if (!e15) throw Error(`The entity '${s10.Name}' does not contain relation '${i10[l10]}'.`);
    const t11 = u6(e15, n10 == null ? void 0 : n10.entities);
    if (!t11) throw Error(`The relation '${i10[l10]}' of the entity '${s10.Name}' does not refer to the entity.`);
    const a11 = (t11.Relations || []).find(o10(s10.Id));
    if (!a11) throw Error(`Relation from the entity '${t11.Name}' to '${s10.Name}' does not exist.`);
    const c10 = a11.Cardinality;
    if ("Many" === c10 || "OptionalMany" === c10) break;
    s10 = t11, l10++;
  }
  return i10.slice(0, l10).join(".");
};
const K6 = (e14, t10, n10) => {
  let r10 = n10;
  const o10 = [];
  const a10 = [];
  do {
    const n11 = u6(r10, e14);
    if (!n11) return false;
    const i11 = r10.$baseRef ? u6(r10.$baseRef, e14) : t10;
    if (!i11) return false;
    const s11 = (n11.Relations || []).find((e15) => e15.RelatedEntityId === i11.Id);
    if (!s11) return false;
    o10.splice(0, 0, r10.Cardinality), a10.splice(0, 0, s11.Cardinality), r10 = r10.$baseRef;
  } while (r10);
  const i10 = BV.findLastIndex(o10, j6);
  const s10 = a10.findIndex(j6);
  return s10 < 0 || i10 < s10;
};
const X6 = (e14, t10, n10, r10) => (o10) => {
  const a10 = __spreadProps(__spreadValues({}, o10), { $baseRef: n10 });
  if (!((e15) => {
    let t11 = e15;
    do {
      const e16 = t11.Cardinality;
      if ("Many" === e16 || "OptionalMany" === e16) return true;
      t11 = t11.$baseRef;
    } while (t11);
    return false;
  })(a10)) return a10.$rebalance ? __spreadProps(__spreadValues({}, a10), { $rebalance: null }) : a10;
  const i10 = { canRebalance: r10 && K6(e14.entities, t10, a10), getInfo: () => ({ semanticModel: e14, path: Y6(a10.$path, t10.Name, e14) }) };
  return __spreadProps(__spreadValues({}, a10), { $rebalance: i10 });
};
const J6 = (e14, t10, n10 = true, r10 = true) => {
  const o10 = t10 && t10.entities || {};
  const a10 = O6(e14, o10);
  return { Name: a10.Name, Description: a10.Description, Attributes: W6(a10.Attributes || []), Relations: Z6(o10, a10.Relations || [], X6(t10, a10, null, n10), r10) };
};
const Q6 = (e14, t10, n10 = true, r10 = true) => {
  const o10 = e14 && e14.entities || {};
  const a10 = c6(o10, t10);
  if (!a10) throw new Error(`There is no entity with this name: ${t10}.`);
  return (t11) => {
    const i10 = u6(t11, o10);
    if (!i10) return null;
    const s10 = t11.Id;
    const l10 = t11.$path;
    const c10 = t11.$usedRelationIds || [];
    const u10 = __spreadProps(__spreadValues({}, t11), { Attributes: W6((i10.Attributes || []).filter((e15) => !U6(e15, t11)), l10, t11.$rebalance), Relations: Z6(o10, (i10.Relations || []).filter((e15) => !U6(e15, t11)), X6(e14, a10, t11, n10), r10, [...c10, s10], l10) });
    return u10;
  };
};
const e9 = (e14, t10) => t10 ? `${e14} \u2013 ${t10}` : e14;
const t9 = (e14, t10) => t10 ? e14.filter((e15) => e15.Name.toLowerCase().includes(t10)) : e14;
const n9 = (e14, t10) => {
  var _a2;
  return t9((_a2 = e14 == null ? void 0 : e14.Attributes) != null ? _a2 : [], t10);
};
const r9 = (e14, t10, n10) => {
  const r10 = e14 && e14.Relations || [];
  if (t10) {
    const e15 = r10.find((e16) => e16.Name === t10);
    return e15 ? [e15] : [];
  }
  return t9(r10, n10);
};
const o9 = tp.createElement("svg", { viewBox: "0 0 24 24" }, tp.createElement("path", { className: km.text, d: "M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z" }));
const a9 = tp.createElement("svg", { viewBox: "0 0 24 24" }, tp.createElement("path", { className: km.text, d: "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M16.2,16.2L11,13V7H12.5V12.2L17,14.9L16.2,16.2Z" }));
const i9 = tp.createElement("svg", { viewBox: "0 0 24 24" }, tp.createElement("path", { className: km.text, d: "M14.6,16.6L19.2,12L14.6,7.4L16,6L22,12L16,18L14.6,16.6M9.4,16.6L4.8,12L9.4,7.4L8,6L2,12L8,18L9.4,16.6Z" }));
const s9 = tp.createElement("svg", { viewBox: "0 0 24 24" }, tp.createElement("path", { className: km.text, d: "M12.36,6L12.76,8H18V14H14.64L14.24,12H7V6H12.36M14,4H5V21H7V14H12.6L13,16H20V6H14.4" }));
const l9 = $A((e14) => e14, (e14) => e14.core);
const c9 = $A((e14) => e14, (e14) => e14.core.rdlx.theme);
const u9 = $A((e14) => e14.core, (e14) => e14.document);
$A((e14) => e14.core, (e14) => e14.rdlx.propertyGrid);
const d9 = () => LA(l9);
const p9 = () => LA(c9);
const m9 = {};
const h9 = () => {
  const { present: { content: e14 } } = LA(u9);
  return e14 != null ? e14 : m9;
};
const f9 = (e14, t10, n10) => Kz.action("@semanticModel/load entity scope", { semanticModelInfo: e14, entityScopeRequest: t10, onLoad: n10 });
const [g9] = Dp("ar-data-field-picker-dropdown-search");
const y9 = (e14) => {
  const { value: t10, placeholder: n10, onChange: r10 } = e14;
  const o10 = ep.useRef(null);
  const a10 = { type: "text", value: t10, placeholder: n10, onChange: (e15) => {
    r10(e15.target.value);
  }, onKeyDown: (e15) => {
    e15.stopPropagation();
  }, onClick: (e15) => {
    e15.stopPropagation();
  } };
  const i10 = t10 ? { type: "button", onClick: (e15) => {
    var _a2;
    r10(""), e15.stopPropagation(), (_a2 = o10.current) == null ? void 0 : _a2.focus();
  } } : null;
  return tp.createElement("div", { className: g9 }, tp.createElement(Fm, { icon: nf(Eh), customCSS: "wd-svg" }), tp.createElement(KF, __spreadValues({ ref: o10 }, a10)), i10 && tp.createElement(qm, __spreadValues({}, i10), tp.createElement(Fm, { icon: nf(xh), customCSS: "wd-svg" })));
};
const v9 = function(e14, t10) {
  return e14 === t10 ? null : t10;
};
const b9 = "Date", S9 = "DateTime", C9 = "Float", x9 = "Decimal", w9 = "Integer", T9 = "Boolean", E9 = "String", F9 = "binary";
const M9 = (e14, t10 = "") => {
  const n10 = e14.toLowerCase().indexOf(t10);
  if (!t10 || n10 < 0) return tp.createElement("span", null, e14);
  const r10 = n10 + t10.length;
  return tp.createElement("span", null, e14.substring(0, n10), tp.createElement("b", null, e14.substring(n10, r10)), e14.substring(r10));
};
const k9 = (e14) => {
  const { field: t10, dataSetName: n10, handleCalculatedFieldClick: r10, handleCalculatedFieldDoubleClick: o10, showLabels: a10 } = e14;
  const i10 = c3(t10);
  return tp.createElement("div", { className: "ar-semantic-data-field-picker-attribute" }, tp.createElement("div", { className: "ar-semantic-data-field-picker-attribute-title", onClick: (e15) => {
    r10 == null ? void 0 : r10(n10, t10.Name), e15.stopPropagation();
  }, onDoubleClick: (e15) => {
    o10 == null ? void 0 : o10(n10, t10.Name), e15.stopPropagation();
  } }, a10 && tp.createElement("span", { className: "datatype-label" }, tp.createElement(Fm, { icon: Pm(i9), customCSS: "wd-svg" })), tp.createElement("span", { className: "ar-semantic-data-field-picker-attribute-title-text" + (a10 ? " with-label" : "") }, i10)));
};
const P9 = (e14) => {
  const { attribute: t10, dataSetName: n10, selectedAttributeId: r10, checkAttribute: o10, expanded: a10, filter: i10, handleAttributeClick: s10, handleAttributeDoubleClick: l10, handleToggle: c10, showAggregates: u10, showLabels: d10 } = e14;
  if (!u10 && t10.IsAggregate) return null;
  const p10 = H6(t10);
  const m10 = L6(t10);
  const h10 = m10 && t10.Variations.some((e15) => !H6(e15));
  const f10 = "Date" === t10.LogicalDataType;
  if (p10 && !h10) return null;
  const g10 = m10 && (u10 || (t10.Variations || []).some((e15) => !e15.IsAggregate));
  const y10 = o10 == null ? void 0 : o10(t10);
  const v10 = p10 || (y10 == null ? void 0 : y10.isDisabled);
  const b10 = `ar-semantic-data-field-picker-attribute-title${v10 ? " ar-semantic-data-field-picker-attribute-disabled" : ""}${r10 === t10.Id ? " ar-semantic-data-field-picker-attribute-selected" : ""}${g10 ? " ar-semantic-data-field-picker-attribute-with-variation" : ""}`;
  return tp.createElement("div", { className: "ar-semantic-data-field-picker-attribute" + (a10 ? " variations-expanded" : "") }, tp.createElement("div", { className: b10, onClick: !v10 && ((e15) => {
    s10 == null ? void 0 : s10(n10, t10), e15.stopPropagation();
  }) || void 0, onDoubleClick: !v10 && ((e15) => {
    l10 == null ? void 0 : l10(n10, t10), e15.stopPropagation();
  }) || void 0, title: (y10 == null ? void 0 : y10.Message) || t10.Name }, d10 && (() => {
    switch (f10 ? "Date" : t10.DataType) {
      case w9:
        return tp.createElement("span", { className: "datatype-label" }, "123");
      case x9:
      case C9:
        return tp.createElement("span", { className: "datatype-label" }, "0.1");
      case E9:
        return tp.createElement("span", { className: "datatype-label" }, "abc");
      case F9:
        return tp.createElement("span", { className: "datatype-label" }, "010");
      case b9:
        return tp.createElement("span", { className: "datatype-label" }, tp.createElement(Fm, { icon: Pm(o9), customCSS: "wd-svg" }));
      case S9:
        return tp.createElement("span", { className: "datatype-label" }, tp.createElement(Fm, { icon: Pm(a9), customCSS: "wd-svg" }));
      case T9:
        return tp.createElement("span", { className: "datatype-label" }, tp.createElement(Fm, { icon: Pm(s9), customCSS: "wd-svg" }));
      default:
        return null;
    }
  })(), d10 && t10.IsAggregate && tp.createElement("div", { className: "aggregate-label" }, tp.createElement("span", null, "{"), tp.createElement("span", null, "}")), tp.createElement("span", { className: "ar-semantic-data-field-picker-attribute-title-text" + (d10 ? " with-label" : "") }, M9(t10.Name, i10)), g10 && tp.createElement("div", { className: "ar-semantic-data-field-picker-attribute-variations-toggle", onClick: c10, onDoubleClick: c10, title: "" }, tp.createElement(Fm, { icon: nf(a10 ? fh : hh), customCSS: "wd-svg" }))), a10 && g10 && tp.createElement("div", { className: "ar-semantic-data-field-picker-attribute-variations" }, (t10.Variations || []).map((e15) => {
    const t11 = e15.Id;
    const a11 = f10 && "DateTime" === e15.DataType ? "Date" : e15.DataType;
    const i11 = { attribute: __spreadProps(__spreadValues({}, e15), { DataType: a11 }), handleAttributeClick: s10, handleAttributeDoubleClick: l10, dataSetName: n10, showAggregates: u10, showLabels: d10, selectedAttributeId: r10, checkAttribute: o10 };
    return tp.createElement(P9, __spreadValues({ key: t11 }, i11));
  })));
};
const N9 = (e14) => {
  e14.stopPropagation();
};
const D9 = (e14) => {
  const { dataSetName: t10, getViewModel: n10, getRelationViewModel: r10, loadScopeForEntity: o10, title: a10, t: i10, checkAttribute: s10, expanded: l10, expandPath: c10, filter: u10, handleAttributeClick: d10, handleAttributeDoubleClick: p10, handleToggle: m10, isBase: h10, makeCalculatedFields: f10, maxHeight: g10, showAggregates: y10, showLabels: v10, treeView: b10 } = e14;
  const [S10, C10] = ep.useState(void 0);
  const [x10, w10] = ep.useState(null);
  const [T10, E10] = ep.useState(null);
  const [F10, M10] = ep.useState(null);
  const [k10, P10] = ep.useState(null);
  ep.useEffect(() => {
    let e15 = null;
    let t11 = null;
    let r11 = null;
    let o11 = null;
    if (l10) if (e15 = n10(), c10 && c10.length >= 2) {
      const t12 = ((e15 == null ? void 0 : e15.Relations) || []).find((e16) => e16.FormattedName === c10[0]);
      t12 && (r11 = t12.Id);
    } else c10 && 1 === c10.length && ((e15 == null ? void 0 : e15.Attributes) || []).find((e16) => {
      const n11 = (e16.Variations || []).find((e17) => e17.FormattedName === c10[0]);
      return n11 ? (t11 = e16.Id, o11 = n11.Id, true) : e16.FormattedName === c10[0] && (o11 = e16.Id, true);
    });
    C10(l10), w10(e15), E10(t11), M10(r11), P10(o11);
  }, []), ep.useEffect(() => {
    if (l10 !== S10) {
      if (l10) return C10(l10), void w10(n10());
      C10(void 0), E10(null), M10(null);
    }
  }, [l10, n10, S10]);
  const N10 = (e15) => (t11) => {
    t11.stopPropagation(), E10(v9(T10, e15));
  };
  const D10 = (e15) => (t11) => {
    t11.stopPropagation(), E10(null), M10(v9(F10, e15.Id)), o10(e15.RelatedEntityId);
  };
  const L10 = x10 && (() => {
    const e15 = (x10 == null ? void 0 : x10.Attributes) || [];
    return u10 && e15.filter((e16) => e16.Name.toLowerCase().includes(u10)) || e15;
  })() || [];
  const H10 = x10 && (() => {
    const e15 = (x10 == null ? void 0 : x10.Relations) || [];
    if (F10) {
      const t11 = e15.find((e16) => e16.Id === F10);
      if (t11) return [t11];
    }
    return u10 && e15.filter((e16) => e16.Name.toLowerCase().includes(u10)) || e15;
  })() || [];
  let I10 = {};
  g10 && "number" == typeof g10 && (I10 = { maxHeight: `${g10}px`, overflowY: "auto" });
  const _10 = ["ar-semantic-data-field-picker-entity"];
  l10 && _10.push("ar-semantic-data-field-picker-entity-expanded"), b10 && _10.push("ar-semantic-data-field-picker-entity-tree-view"), h10 && _10.push("ar-semantic-data-field-picker-entity-base");
  const V10 = (() => {
    const e15 = [];
    return F10 || (L10.forEach((n11) => {
      const r11 = n11.Id;
      const o11 = { attribute: n11, handleAttributeClick: d10, handleAttributeDoubleClick: p10, dataSetName: t10, expanded: T10 === r11, handleToggle: N10(r11), showAggregates: y10, showLabels: v10, selectedAttributeId: k10, checkAttribute: s10, filter: u10 };
      e15.push(tp.createElement(P9, __spreadValues({ key: r11 }, o11)));
    }), f10 && "function" == typeof f10 && e15.push(...f10())), H10.forEach((n11) => {
      const a11 = n11.Id;
      if (F10 && F10 !== a11) return;
      const l11 = { getViewModel: () => r10(n11), getRelationViewModel: r10, expanded: F10 === a11, dataSetName: t10, handleToggle: D10(n11), title: n11.Name, handleAttributeClick: d10, handleAttributeDoubleClick: p10, treeView: b10, showAggregates: y10, showLabels: v10, expandPath: c10 && c10.slice(1), checkAttribute: s10, filter: u10, loadScopeForEntity: o10, t: i10 };
      e15.push(tp.createElement(D9, __spreadValues({ key: a11 }, l11)));
    }), e15;
  })();
  return tp.createElement("div", { className: _10.join(" ") }, tp.createElement("div", { className: "ar-semantic-data-field-picker-entity-title", title: a10, onClick: m10 }, !h10 && !l10 && !b10 && tp.createElement("span", null, tp.createElement(Fm, { icon: nf(oh, { rotate: "270" }), customCSS: "wd-svg" })), b10 && tp.createElement("span", { className: l10 ? " entity-expanded" : "" }, tp.createElement(Fm, { icon: nf(oh), customCSS: "wd-svg" })), tp.createElement("div", { className: "ar-semantic-data-field-picker-entity-title-text" }, !V10.length && M9(a10, u10) || a10), l10 && !b10 && tp.createElement("div", { className: "ar-semantic-data-field-picker-attribute-title-arrow" })), l10 && !V10.length && u10 && tp.createElement("div", { className: "ar-data-field-picker-dropdown-no-fields-message", onClick: N9 }, i10("components:dataFieldPickerDropdown.semantic.noMatchingAttributesRelationsFound", "No matching items found")) || tp.createElement("div", { className: "ar-semantic-data-field-picker-entity-fields", style: I10 }, l10 && V10));
};
const L9 = (e14) => {
  const { dataSets: t10, allowRebalancing: n10 = true, collapsible: r10 = true, checkAttribute: o10, handleAttributeClick: a10, handleAttributeDoubleClick: i10, handleCalculatedFieldClick: s10, handleCalculatedFieldDoubleClick: l10, maxHeight: c10, path: u10 = "", showAggregates: d10 = true, showCalculatedFields: p10 = true, showLabels: m10 = false, showSearchBox: h10 = true, treeView: f10 = false } = e14;
  const g10 = h9();
  const y10 = A$();
  const [v10, b10] = ep.useState(r10 ? null : 0);
  const [S10, C10] = ep.useState("");
  const x10 = PA();
  const { t: w10 } = vp();
  ep.useEffect(() => {
    r10 || null === v10 && b10(0);
  }, [r10, v10]);
  const T10 = (e15) => (t11) => {
    const n11 = v9(v10, e15);
    b10(n11), t11.stopPropagation();
  };
  const E10 = (e15) => {
    const t11 = (g10.DataSources || []).find(b$);
    if (!t11) return;
    const n11 = (r11 = t11, f$.getSemanticDataSourceInfo({ dataSource: r11 }));
    var r11;
    const o11 = p6(e15, (y10 == null ? void 0 : y10.entities) || {});
    o11 && x10(f9(n11, o11));
  };
  if (!y10) return null;
  const F10 = h10 ? { value: S10, placeholder: w10("components:dataFieldPickerDropdown.semantic.searchPlaceholder", "enter item name here..."), onChange: (e15) => {
    C10(e15.toLowerCase());
  } } : null;
  const M10 = T6(u10);
  const k10 = [];
  return t10.forEach((e15, r11) => {
    const u11 = S6(e15);
    if (!u11) return;
    const h11 = J7(e15);
    const g11 = !h11 && n10;
    const b11 = { makeCalculatedFields: () => p10 ? l3(e15).map((t11, n11) => {
      const r12 = { dataSetName: e15.Name, field: t11, handleCalculatedFieldClick: s10, handleCalculatedFieldDoubleClick: l10, showLabels: m10 };
      const o11 = `${t11.Name}.${n11}`;
      return tp.createElement(k9, __spreadValues({ key: o11 }, r12));
    }) : [], getViewModel: () => J6(e15, y10, g11, d10), getRelationViewModel: Q6(y10, u11, g11, d10), expanded: v10 === r11, handleToggle: T10(r11), dataSetName: e15.Name, title: e15.Name, handleAttributeClick: a10, handleAttributeDoubleClick: i10, maxHeight: c10, treeView: f10, isBase: true, showAggregates: d10, showLabels: m10, expandPath: M10, checkAttribute: (t11) => {
      var _a2;
      const n11 = (_a2 = o10 == null ? void 0 : o10(t11)) != null ? _a2 : { isDisabled: false };
      if (!h11) return n11;
      return e15.Fields.map((e16) => e16.Name).includes(t11.$path) ? n11 : { isDisabled: true, Message: `${t11.Name} (${w10("propertyEditors:picker.warnings.masterReportAttributes", "only attributes used in the master report are available for content reports")})` };
    }, filter: S10, loadScopeForEntity: E10, t: w10 };
    const C11 = `${e15.Name}${r11}`;
    if (k10.push(tp.createElement(D9, __spreadValues({ key: C11 }, b11))), !f10) {
      r11 === t10.length - 1 || k10.push(tp.createElement("div", { key: `${C11}-separator`, className: "ar-semantic-data-field-picker-dropdown-content-separator" }));
    }
  }), tp.createElement("div", { className: "ar-semantic-data-field-picker-dropdown-content" }, F10 && tp.createElement(y9, __spreadValues({}, F10)), k10);
};
const H9 = "wd-if-c-white";
const I9 = "wd-if-c-text";
const _9 = "wd-icon-color-none";
const V9 = "wd-icon-color-white";
const R9 = "wd-icon-color-light-blue";
const A9 = "wd-icon-color-blue";
const O9 = "wd-icon-color-blue-second";
const B9 = "wd-icon-color-dark-blue";
const z9 = "wd-icon-color-gray-blue";
const $9 = "wd-icon-color-gray";
const W9 = "wd-icon-color-gray-second";
const j9 = "wd-icon-color-dark-gray";
const Z9 = "wd-icon-color-dark-yellow";
const G9 = "wd-icon-color-red";
const U9 = "wd-icon-color-light-gray-blue";
const q9 = "wd-toolbox-icon--main";
const Y9 = "wd-toolbox-icon--accent";
const K9 = "wd-toolbox-icon--secondary-accent";
const X9 = "wd-if-rdlx-c-parameter";
const J9 = "wd-if-rdlx-c-expression";
const Q9 = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: "wd-if-rdlx-c-field", d: "M19 4.25C19 2.456 17.544 1 15.75 1H4.25C2.456 1 1 2.456 1 4.25v11.5C1 17.544 2.456 19 4.25 19h11.5c1.794 0 3.25-1.456 3.25-3.25V4.25Z" }), tp.createElement("path", { className: H9, d: "M10 5C7.149 5 6 6.075 6 7.5v5c0 1.425 1.149 2.5 4 2.5s4-1.075 4-2.5v-5C14 6.075 12.851 5 10 5Zm0 1c2.441 0 3 .888 3 1.5S12.441 9 10 9s-3-.888-3-1.5S7.558 6 10 6Zm0 8c-2.442 0-3-.889-3-1.5v-.963c.897.593 1.328.963 3 .963s2.103-.37 3-.963v.963c0 .611-.559 1.5-3 1.5Zm0-2.5c-2.442 0-3-.888-3-1.5v-.979c1.214.698 1.601 1.037 3 .979 1.399.058 1.786-.281 3-.979V10c0 .612-.558 1.5-3 1.5Z" }));
const eee = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: X9, d: "M19 4.25C19 2.456 17.544 1 15.75 1H4.25C2.456 1 1 2.456 1 4.25v11.5C1 17.544 2.456 19 4.25 19h11.5c1.794 0 3.25-1.456 3.25-3.25V4.25Z" }), tp.createElement("path", { className: H9, d: "M8 10c.932 0 1.715.637 1.937 1.5H14.5c.276 0 .5.224.5.5 0 .245-.177.45-.41.492l-.09.008-4.563.001C9.714 13.363 8.932 14 8 14c-.932 0-1.714-.637-1.937-1.499L5.5 12.5c-.276 0-.5-.224-.5-.5 0-.245.177-.45.41-.492l.09-.008h.563C6.285 10.637 7.068 10 8 10Zm0 1c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1Zm4-5c.932 0 1.715.637 1.937 1.5h.563c.276 0 .5.224.5.5 0 .245-.177.45-.41.492l-.09.008-.563.001C13.714 9.363 12.932 10 12 10c-.932 0-1.714-.637-1.937-1.499L5.5 8.5c-.276 0-.5-.224-.5-.5 0-.245.177-.45.41-.492L5.5 7.5h4.563C10.285 6.637 11.068 6 12 6Zm0 1c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1Z" }));
const tee = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, opacity: ".38", d: "M9.058 13.697c-.038.262-.058.53-.058.803 0 1.859.925 3.504 2.339 4.5H4.25C2.456 19 1 17.544 1 15.75V4.25C1 2.456 2.456 1 4.25 1h11.5C17.544 1 19 2.456 19 4.25v7.089C18.004 9.925 16.359 9 14.5 9c-.273 0-.541.02-.803.058.107-.17.188-.357.24-.557L14.5 8.5l.09-.008c.233-.042.41-.247.41-.492 0-.276-.224-.5-.5-.5h-.563C13.715 6.637 12.932 6 12 6c-.932 0-1.715.637-1.937 1.5H5.5l-.09.008C5.177 7.55 5 7.755 5 8c0 .276.224.5.5.5l4.563.001c.177.686.708 1.229 1.387 1.422-.604.404-1.123.923-1.527 1.527C9.685 10.613 8.914 10 8 10c-.932 0-1.715.637-1.937 1.5H5.5l-.09.008c-.233.042-.41.247-.41.492 0 .276.224.5.5.5l.563.001C6.286 13.363 7.068 14 8 14c.389 0 .751-.111 1.058-.303ZM8 11c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1Zm4-4c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1Z" }), tp.createElement("path", { className: X9, d: "M14.5 19c2.485 0 4.5-2.015 4.5-4.5S16.985 10 14.5 10 10 12.015 10 14.5s2.015 4.5 4.5 4.5Zm0-7c.276 0 .5.224.5.5V14h1.5c.276 0 .5.224.5.5s-.224.5-.5.5H15v1.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5V15h-1.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H14v-1.5c0-.276.224-.5.5-.5Z" }));
const nee = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: J9, d: "M19 4.25C19 2.456 17.544 1 15.75 1H4.25C2.456 1 1 2.456 1 4.25v11.5C1 17.544 2.456 19 4.25 19h11.5c1.794 0 3.25-1.456 3.25-3.25V4.25Z" }), tp.createElement("path", { className: I9, d: "M11.344 7.316c.21-1.272 1.476-2.08 2.717-1.736l.805.223c.266.074.542-.082.616-.348.073-.266-.082-.542-.349-.615l-.805-.224c-1.814-.503-3.664.679-3.97 2.537l-.547 2.318H8c-.276 0-.5.224-.5.5 0 .277.224.5.5.5h1.646l-.524 2.184c-.243 1.479-1.879 2.269-3.189 1.542l-.691-.383c-.241-.134-.545-.047-.679.195-.134.241-.047.546.194.68l.691.383c1.915 1.063 4.305-.093 4.661-2.255l.551-2.346H12c.276 0 .5-.223.5-.5 0-.276-.224-.5-.5-.5h-1.175l.519-2.155Z" }));
const ree = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: J9, d: "M19 4.25C19 2.456 17.544 1 15.75 1H4.25C2.456 1 1 2.456 1 4.25v11.5C1 17.544 2.456 19 4.25 19h11.5c1.794 0 3.25-1.456 3.25-3.25V4.25Z" }), tp.createElement("path", { className: I9, opacity: "0.62", d: "M15 13.75c0-.414-.336-.75-.75-.75h-8.5c-.414 0-.75.336-.75.75s.336.75.75.75h8.5c.414 0 .75-.336.75-.75Z" }), tp.createElement("path", { className: I9, opacity: "0.38", d: "M10 10.25c0-.414-.336-.75-.75-.75h-3.5c-.414 0-.75.336-.75.75s.336.75.75.75h3.5c.414 0 .75-.336.75-.75Z" }), tp.createElement("path", { className: I9, d: "M12 6.75c0-.414-.336-.75-.75-.75h-5.5c-.414 0-.75.336-.75.75s.336.75.75.75h5.5c.414 0 .75-.336.75-.75Z" }));
const oee = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: I9, d: "M19 4.25v11.5c0 1.794-1.456 3.25-3.25 3.25H4.25C2.456 19 1 17.544 1 15.75V4.25C1 2.456 2.456 1 4.25 1h11.5C17.544 1 19 2.456 19 4.25ZM5.5 10c-.276 0-.5.224-.5.5s.224.5.5.5h10c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-10ZM5 7.5c0 .276.224.5.5.5h8c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-8c-.276 0-.5.224-.5.5Zm0 6c0 .276.224.5.5.5h7c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-7c-.276 0-.5.224-.5.5Z" }));
const aee = (e14 = "", t10 = "", n10 = "", r10 = "") => ({ dataSetName: e14, baseEntityName: n10, parentDataSetName: t10, parentBaseEntityName: r10 });
const iee = aee();
function see(e14) {
  const { DataSets: t10 } = e14;
  const n10 = (e15) => {
    let n11 = "";
    if (e15) {
      const r11 = t10.find((t11) => t11.Name === e15);
      r11 && (n11 = S6(r11) || "");
    }
    return n11;
  };
  if (!t10.length) return iee;
  const { dataSetName: r10, parentDataSetName: o10 } = function(e15) {
    let t11 = "";
    let n11 = false;
    let r11 = "";
    let o11 = false;
    return C3(e15, (e16, a10) => {
      if (n11 && o11) return null;
      const { parentDataSetName: i10 } = e16;
      const s10 = UW(a10.Type) && a10.DataSetName || i10;
      return rj(a10) && (s10 && (t11 ? t11 !== s10 && (n11 = true) : t11 = s10), i10 && (r11 ? r11 !== i10 && (o11 = true) : r11 = i10)), { parentDataSetName: s10 };
    }, { parentDataSetName: "" }), { dataSetName: n11 ? "" : t11, parentDataSetName: o11 ? "" : r11 };
  }(e14);
  if (b6(e14)) {
    const e15 = n10(r10);
    const t11 = n10(o10);
    return aee(r10, o10, e15, t11);
  }
  return aee(r10, o10);
}
const lee = "tablixHierarchy", cee = "tablixCorner", uee = "tablixBody", dee = "tableDetails", pee = "tableHeader", mee = "tableFooter", hee = "tableGroups", fee = "tableGroupsHeader", gee = "tableGroupsFooter", yee = "rectangle", vee = "list", bee = "reportSection", See = "bandedListDetails", Cee = "bandedListHeader", xee = "bandedListFooter";
const wee = (e14) => {
  if (!e14) return false;
  switch (e14) {
    case cee:
    case uee:
    case mee:
    case gee:
    case bee:
    case yee:
    case xee:
      return true;
    default:
      return false;
  }
};
const Tee = (e14, t10) => {
  let n10 = null;
  let r10 = null;
  let o10 = e14;
  const a10 = t10.split(".");
  return a10.forEach((e15, t11) => {
    if (o10 = o10[e15], o10 && t11 !== a10.length - 1) if (GW(o10.Type)) n10 = o10, r10 = null;
    else if (n10) {
      if (zW(n10.Type)) switch (e15) {
        case "ColumnHierarchy":
        case "RowHierarchy":
          r10 = lee;
          break;
        case "Corner":
          r10 = cee;
          break;
        case "Body":
          r10 = uee;
      }
      if ($W(n10.Type)) switch (e15) {
        case "Header":
          r10 = r10 === hee ? fee : pee;
          break;
        case "Footer":
          r10 = r10 === hee ? gee : mee;
          break;
        case "Details":
          r10 = dee;
          break;
        case "TableGroups":
          r10 = hee;
      }
      else OW(n10.Type) ? r10 = yee : BW(n10.Type) ? r10 = vee : tj(n10.Type) && (r10 = { Header: Cee, Footer: xee, Details: See }[e15] || r10);
    } else r10 = bee;
  }), r10;
};
const Eee = (e14, t10) => {
  if (!t10) return false;
  let n10 = e14;
  const r10 = t10.split(".");
  for (const e15 of r10.slice(0, -2)) if (n10 = n10[e15], n10 && GW(n10.Type) && Y$(n10)) return true;
  return false;
};
const Fee = (e14, t10) => {
  const n10 = ((e15) => {
    for (let t11 = 0; t11 < document.styleSheets.length; t11++) {
      const n11 = document.styleSheets[t11];
      if (n11.title === e15) return n11;
    }
    return null;
  })(e14) || ((e15) => {
    var _a2;
    const t11 = document.createElement("style");
    return t11.type = "text/css", t11.title = e15, window.customSheet = t11, ((_a2 = document.head) != null ? _a2 : document.getElementsByTagName("head")[0]).appendChild(t11), t11.sheet;
  })(e14);
  n10 && (((e15) => {
    for (; 0 !== e15.cssRules.length; ) e15.deleteRule(0);
  })(n10), t10.forEach((e15) => {
    n10.insertRule(e15, 0);
  }));
};
const Mee = "non-scalable";
const kee = _V("@rdlx/fieldPicker/open", ({ path: e14, type: t10 }) => ({ path: e14, type: t10 }));
const Pee = $A((e14) => e14, (e14) => e14.rdlxFieldPicker);
const Nee = (e14, t10) => ({ type: "button", text: e14.Name, icon: nf(Q9), value: { field: e14, dataSetName: t10 } });
const [Dee, , Lee] = Dp("rdlx-field-picker");
const [Hee, Iee] = Lee("toggle");
const _ee = ({ color: e14, backgroundColor: t10 }) => {
  const n10 = { color: e14, backgroundColor: t10 };
  const r10 = rf(vh);
  return tp.createElement("div", { style: n10 }, tp.createElement(Fm, { icon: r10 }));
};
const Vee = ({ item: e14, path: t10, itemSelected: n10, itemBackgroundColor: r10, children: o10 }) => {
  const { Type: a10, $place: { Left: i10 } } = e14;
  const [s10, l10] = ep.useState(false);
  const [c10, u10] = ep.useState("");
  const { API: d10 } = ep.useContext(Sm);
  const p10 = h9();
  const { selectionInfo: m10 } = LA(Pee);
  const h10 = A$();
  const { t: f10 } = vp("components");
  const { DataSources: g10 = [], DataSets: y10 = [] } = p10;
  const v10 = ep.useMemo(() => see(p10), [p10]);
  const b10 = ep.useMemo(() => ((e15 = [], t11) => {
    const n11 = e15.find((e16) => e16.Name === t11.dataSetName);
    return void 0 !== n11 ? [n11] : e15;
  })(y10, v10), [v10, y10]);
  const S10 = PA();
  const C10 = ep.useRef(null);
  const x10 = ep.useRef(null);
  const w10 = ep.useCallback(({ target: { value: e15 } }) => {
    u10(e15);
  }, []);
  ep.useEffect(() => {
    x10.current = window.document.activeElement;
  }, [n10]), ep.useEffect(() => {
    !s10 && n10 && x10.current instanceof HTMLTextAreaElement && x10.current.focus(), C10.current && s10 && C10.current.focusInput();
  }, [s10, n10]);
  const T10 = ep.useCallback((e15) => {
    l10(e15), e15 && (u10(""), S10(c5(t10, a10)), S10(kee({ path: t10, type: a10 })));
  }, [S10, t10, a10]);
  const E10 = ep.useCallback(({ dataSetName: e15, field: { Aggregate: t11, DataType: n11, Name: r11, Format: o11 } }) => {
    const a11 = Tee(p10, m10.path);
    const i11 = [O5({ dataSet: e15, fieldName: r11, fieldInfo: { aggregate: t11 || "Count", type: n11 }, shouldAddAggregate: wee(a11) })];
    "string" == typeof o11 && i11.push(o2({ descriptor: { valuePath: "Style.Format", category: "", label: "", type: "", mode: "both" }, value: o11 })), S10(rz(i11));
  }, [S10, p10, m10.path]);
  const F10 = ep.useCallback((e15, t11) => {
    const n11 = [B5({ dataSet: e15, fieldName: t11.Name, fieldPath: t11.$path, format: t11.Format, preventGroupUpdate: t11.DiscourageGrouping })];
    if (t11.$rebalance && t11.$rebalance.canRebalance) {
      const { path: r11 } = t11.$rebalance.getInfo();
      n11.push(z$({ semanticModel: h10, dataSetName: e15, path: r11 }));
    }
    S10(rz(n11)), d10.dropdowns.open(null);
  }, [S10, h10, d10]);
  const M10 = ep.useCallback((e15, t11) => {
    S10(O5({ dataSet: e15, fieldName: t11 })), d10.dropdowns.open(null);
  }, [S10, d10]);
  const k10 = ep.useMemo(() => b10[0] || null, [b10]);
  const P10 = ep.useMemo(() => g10.find(b$) && k10 && C6(k10, g10), [g10, k10]);
  const N10 = ep.useMemo(() => P10 ? [] : b10.flatMap((e15) => [{ type: "header", header: e15.Name }, ...e15.Fields.map((t11) => Nee(t11, e15.Name)), ...e15.$calculatedFields.map((t11) => Nee(t11, e15.Name))]), [b10, P10]);
  let D10;
  if (P10) {
    const e15 = { dataSets: [k10], collapsible: false, maxHeight: 300, handleAttributeClick: F10, handleCalculatedFieldClick: M10 };
    D10 = tp.createElement(L9, __spreadValues({}, e15));
  }
  const L10 = ep.useMemo(() => {
    const { R: e15, G: t11, B: n11, A: o11 } = dm.fromString(r10 || "White");
    return 0 === o11 ? dm.fromRGB(255, 255, 255, 158) : dm.fromRGB(e15, t11, n11, 158);
  }, [r10]);
  const H10 = ep.useMemo(() => dm.isLight(L10) ? dm.fromString("Black") : dm.fromString("White"), [L10]);
  const I10 = ep.useMemo(() => tp.createElement(_ee, { color: H10.hex, backgroundColor: L10.rgba }), [L10, H10]);
  const _10 = kp(Hee, Mee, { [Iee("open")]: s10 && n10, [Iee("offset-to-start")]: s10 && n10 && (V10 = i10, 200 > L$.toPixels(V10)), [Iee("semantic")]: P10, [Iee("hidden")]: !s10, [Iee("non-selected")]: !n10 });
  var V10;
  if (P10) {
    const e15 = { size: "small", hiddenChevron: true, menuWidth: "auto", menuMaxHeight: "none", toggleContent: I10, content: D10, customCSS: _10, onToggle: T10 };
    return tp.createElement("div", { className: Dee }, o10, tp.createElement(UF, __spreadValues({}, e15)));
  }
  const R10 = { items: N10, size: "small", menuWidth: "default", menuMaxHeight: "default", value: c10, placeholder: f10("fieldPicker.placeholderEnterFieldName", "enter field name here..."), toggleContent: I10, scrollToSelection: true, filterOnInput: true, customCSS: _10, customFilter: (e15, t11) => {
    const n11 = [];
    const r11 = t11.filter((t12) => {
      var _a2;
      const n12 = "header" === t12.type;
      const r12 = e15.toLowerCase();
      const o11 = !n12 && ((_a2 = t12.text) == null ? void 0 : _a2.toLowerCase()) || "";
      return n12 || o11.indexOf(r12) > -1;
    });
    for (let e16 = 0; e16 < r11.length; e16++) {
      const t12 = r11[e16];
      const o11 = r11[e16 + 1];
      "button" !== t12.type && "button" !== (o11 == null ? void 0 : o11.type) || n11.push(t12);
    }
    return n11;
  }, onChange: w10, onSelect: E10, onToggle: T10, dataAid: "rdlx-field-picker" };
  return tp.createElement("div", { className: Dee }, o10, tp.createElement(tM, __spreadProps(__spreadValues({}, R10), { ref: C10 })));
};
const Ree = (e14 = { selectionInfo: { path: "", type: "" } }, t10) => {
  if (!t10) return e14;
  const { type: n10, payload: r10 } = t10;
  return n10 === kee.type ? AV(e14, { selectionInfo: { $set: { path: r10.path, type: r10.type } } }) : n10.startsWith("SELECTION/") ? { selectionInfo: { path: "", type: "" } } : e14;
};
const Aee = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Km.secondary, d: "M4.25 16v-1.75A2.25 2.25 0 0 1 6.5 12h4.75V8.5h1.5V12h4.75a2.25 2.25 0 0 1 2.25 2.25V16h-1.5v-1.75a.75.75 0 0 0-.75-.75h-4.75V16h-1.5v-2.5H6.5a.75.75 0 0 0-.75.75V16h-1.5Z" }), tp.createElement("path", { className: Ym.accent, d: "M5 15a3.001 3.001 0 0 1 0 6 3.001 3.001 0 0 1 0-6Zm0 1.5a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 5 16.5Zm7-1.5a3.001 3.001 0 0 1 0 6 3.001 3.001 0 0 1 0-6Zm0 1.5a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 12 16.5Zm7-1.5a3.001 3.001 0 0 1 0 6 3.001 3.001 0 0 1 0-6Zm0 1.5a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 19 16.5Zm-7-13a3.001 3.001 0 0 1 0 6 3.001 3.001 0 0 1 0-6ZM12 5a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 12 5Z" }));
const Oee = tp.createElement("svg", { width: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { fill: "white", d: "m13.363 4.169-4.727-2.73c-.394-.227-.879-.227-1.272 0l-4.728 2.73C2.243 4.396 2 4.816 2 5.271v5.458c0 .455.243.875.636 1.103l4.728 2.729c.196.114.416.17.636.17.22 0 .439-.056.636-.17l4.727-2.729c.395-.228.637-.648.637-1.103V5.271c0-.455-.242-.875-.637-1.102M8.13 9l-2.557 1.974c-.042.032-.092.049-.141.049-.051 0-.1-.016-.142-.048-.084-.064-.114-.177-.073-.275l2.566-6.13c.036-.087.12-.143.214-.143s.179.056.215.143l.818 1.954s.009.02.023.055c.046.12.14.427.093.825-.024.208-.088.441-.216.685-.156.295-.406.606-.8.911m2.596 1.968c-.044.036-.098.055-.151.055-.044 0-.086-.011-.125-.036l-1.061-.674c-.337-.211-.465-.414-.493-.589-.003-.013-.004-.026-.005-.039-.023-.282.21-.477.21-.477l.541-.448c.056-.047.132-.064.203-.047.072.018.131.067.16.135l.784 1.852c.04.093.014.202-.063.268" }));
const [Bee] = Dp("wd-menu");
const [zee, , $ee] = Dp("wd-menu-toggle");
const [Wee] = $ee("burger");
const [jee] = $ee("text");
const [Zee, , Gee] = Dp("wd-menu-logo");
const [Uee] = Gee("icon");
const [qee] = Gee("text");
const Yee = ({ toggleText: e14 }) => tp.createElement("div", { className: zee }, tp.createElement("div", { className: Wee }, tp.createElement("div", null, tp.createElement("span", null), tp.createElement("span", null), tp.createElement("span", null))), tp.createElement("span", { className: jee }, e14));
const Kee = ({ applicationName: e14, logo: { visible: t10, custom: n10 } = {} }) => tp.createElement("div", { className: Zee }, t10 && tp.createElement(Fm, { icon: n10 != null ? n10 : nf(Oee), customCSS: Uee }), tp.createElement("span", { className: qee }, e14));
const Xee = ({ textBack: e14, titleBack: t10, onClick: n10 }) => {
  const r10 = { accent: "full", block: true, size: "small", icon: rf(bh, { rotate: "90" }), text: e14, title: t10, width: "100%", onClick: n10, customCSS: "wd-menu-back-button" };
  return tp.createElement(qm, __spreadValues({}, r10));
};
const Jee = ({ applicationName: e14, logo: t10, hiddenElements: n10, items: r10, children: o10, supportedMenuPanels: a10, onToggle: i10, onBackButtonClick: s10 }) => {
  var _a2;
  const { id: l10, workspaceId: c10, menu: { editor: u10, workspaces: d10 } } = Mz();
  const p10 = PA();
  const { t: m10 } = vp("components");
  const { pinned: h10, status: f10, panelId: g10 } = (_a2 = d10[c10]) != null ? _a2 : u10;
  ep.useEffect(() => {
    h10 && !(a10 == null ? void 0 : a10.find((e15) => e15 === g10)) && (p10(eB({ workspaceId: c10, pinned: false })), p10(tB({ workspaceId: c10, status: "collapsed" })));
  }, []);
  const y10 = tp.createElement(Kee, { applicationName: e14, logo: t10 });
  const v10 = tp.createElement(Xee, { textBack: m10("menu.btnBack", "Back"), titleBack: m10("menu.titleBack", "Back"), onClick: s10 });
  const b10 = __spreadProps(__spreadValues({}, { mode: "panel", size: "large", dataAid: "Menu", toggleContent: tp.createElement(Yee, { toggleText: m10("menu.btnClose", "Close") }), logo: { appBarId: `${l10}_main-app-bar`, size: "small", content: s10 ? v10 : y10 } }), { items: (n10 == null ? void 0 : n10.toolbox) ? [] : r10, activePanelId: g10, pinned: h10, status: f10, pinBtnTitle: m10("menu.titlePin", "Pin"), onPinClick: () => p10(eB({ workspaceId: c10, pinned: !h10 })), onToggleClick: () => {
    const e15 = /* @__PURE__ */ ((e16, t11) => "expanded" !== e16 ? "expanded" : t11 ? "panel" : "collapsed")(f10, h10);
    p10(tB({ workspaceId: c10, status: e15 })), i10 == null ? void 0 : i10(e15);
  }, onPanelChange: (e15) => {
    p10(tB({ workspaceId: c10, status: e15 ? "panel" : "collapsed" })), e15 !== g10 && p10(QO({ workspaceId: c10, panelId: e15 }));
  }, customCSS: Bee });
  return tp.createElement(oN, __spreadValues({}, b10), o10);
};
var Qee;
function ete(e14, t10) {
  for (var n10 = arguments.length, r10 = new Array(n10 > 2 ? n10 - 2 : 0), o10 = 2; o10 < n10; o10++) r10[o10 - 2] = arguments[o10];
  if (!e14) {
    var a10;
    if (void 0 === t10) a10 = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var i10 = 0;
      (a10 = new Error(t10.replace(/%s/g, function() {
        return r10[i10++];
      }))).name = "Invariant Violation";
    }
    throw a10.framesToPop = 1, a10;
  }
}
!function(e14) {
  e14.SOURCE = "SOURCE", e14.TARGET = "TARGET";
}(Qee || (Qee = {}));
var tte = "dnd-core/INIT_COORDS";
var nte = "dnd-core/BEGIN_DRAG";
var rte = "dnd-core/PUBLISH_DRAG_SOURCE";
var ote = "dnd-core/HOVER";
var ate = "dnd-core/DROP";
var ite = "dnd-core/END_DRAG";
function ste(e14, t10) {
  return { type: tte, payload: { sourceClientOffset: t10 || null, clientOffset: e14 || null } };
}
function lte(e14) {
  return lte = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e15) {
    return typeof e15;
  } : function(e15) {
    return e15 && "function" == typeof Symbol && e15.constructor === Symbol && e15 !== Symbol.prototype ? "symbol" : typeof e15;
  }, lte(e14);
}
function cte(e14, t10) {
  return e14.filter(function(e15) {
    return e15 !== t10;
  });
}
function ute(e14) {
  return "object" === lte(e14);
}
var dte = { type: tte, payload: { clientOffset: null, sourceClientOffset: null } };
function pte(e14) {
  return function() {
    var t10 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
    var n10 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : { publishSource: true };
    var r10 = n10.publishSource, o10 = void 0 === r10 || r10, a10 = n10.clientOffset, i10 = n10.getSourceClientOffset;
    var s10 = e14.getMonitor();
    var l10 = e14.getRegistry();
    e14.dispatch(ste(a10)), function(e15, t11, n11) {
      ete(!t11.isDragging(), "Cannot call beginDrag while dragging."), e15.forEach(function(e16) {
        ete(n11.getSource(e16), "Expected sourceIds to be registered.");
      });
    }(t10, s10, l10);
    var c10 = function(e15, t11) {
      var n11 = null;
      for (var r11 = e15.length - 1; r11 >= 0; r11--) if (t11.canDragSource(e15[r11])) {
        n11 = e15[r11];
        break;
      }
      return n11;
    }(t10, s10);
    if (null !== c10) {
      var u10 = null;
      if (a10) {
        if (!i10) throw new Error("getSourceClientOffset must be defined");
        !function(e15) {
          ete("function" == typeof e15, "When clientOffset is provided, getSourceClientOffset must be a function.");
        }(i10), u10 = i10(c10);
      }
      e14.dispatch(ste(a10, u10));
      var d10 = l10.getSource(c10).beginDrag(s10, c10);
      !function(e15) {
        ete(ute(e15), "Item must be an object.");
      }(d10), l10.pinSource(c10);
      var p10 = l10.getSourceType(c10);
      return { type: nte, payload: { itemType: p10, item: d10, sourceId: c10, clientOffset: a10 || null, sourceClientOffset: u10 || null, isSourcePublic: !!o10 } };
    }
    e14.dispatch(dte);
  };
}
function mte(e14) {
  return function() {
    if (e14.getMonitor().isDragging()) return { type: rte };
  };
}
function hte(e14, t10) {
  return null === t10 ? null === e14 : Array.isArray(e14) ? e14.some(function(e15) {
    return e15 === t10;
  }) : e14 === t10;
}
function fte(e14) {
  return function(t10) {
    var n10 = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).clientOffset;
    !function(e15) {
      ete(Array.isArray(e15), "Expected targetIds to be an array.");
    }(t10);
    var r10 = t10.slice(0);
    var o10 = e14.getMonitor();
    var a10 = e14.getRegistry();
    return function(e15, t11, n11) {
      ete(t11.isDragging(), "Cannot call hover while not dragging."), ete(!t11.didDrop(), "Cannot call hover after drop.");
      for (var r11 = 0; r11 < e15.length; r11++) {
        var o11 = e15[r11];
        ete(e15.lastIndexOf(o11) === r11, "Expected targetIds to be unique in the passed array."), ete(n11.getTarget(o11), "Expected targetIds to be registered.");
      }
    }(r10, o10, a10), function(e15, t11, n11) {
      for (var r11 = e15.length - 1; r11 >= 0; r11--) {
        var o11 = e15[r11];
        hte(t11.getTargetType(o11), n11) || e15.splice(r11, 1);
      }
    }(r10, a10, o10.getItemType()), function(e15, t11, n11) {
      e15.forEach(function(e16) {
        n11.getTarget(e16).hover(t11, e16);
      });
    }(r10, o10, a10), { type: ote, payload: { targetIds: r10, clientOffset: n10 || null } };
  };
}
function gte(e14, t10) {
  var n10 = Object.keys(e14);
  if (Object.getOwnPropertySymbols) {
    var r10 = Object.getOwnPropertySymbols(e14);
    t10 && (r10 = r10.filter(function(t11) {
      return Object.getOwnPropertyDescriptor(e14, t11).enumerable;
    })), n10.push.apply(n10, r10);
  }
  return n10;
}
function yte(e14) {
  for (var t10 = 1; t10 < arguments.length; t10++) {
    var n10 = null != arguments[t10] ? arguments[t10] : {};
    t10 % 2 ? gte(Object(n10), true).forEach(function(t11) {
      vte(e14, t11, n10[t11]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e14, Object.getOwnPropertyDescriptors(n10)) : gte(Object(n10)).forEach(function(t11) {
      Object.defineProperty(e14, t11, Object.getOwnPropertyDescriptor(n10, t11));
    });
  }
  return e14;
}
function vte(e14, t10, n10) {
  return t10 in e14 ? Object.defineProperty(e14, t10, { value: n10, enumerable: true, configurable: true, writable: true }) : e14[t10] = n10, e14;
}
function bte(e14) {
  return function() {
    var t10 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    var n10 = e14.getMonitor();
    var r10 = e14.getRegistry();
    !function(e15) {
      ete(e15.isDragging(), "Cannot call drop while not dragging."), ete(!e15.didDrop(), "Cannot call drop twice during one drag operation.");
    }(n10);
    var o10 = function(e15) {
      var t11 = e15.getTargetIds().filter(e15.canDropOnTarget, e15);
      return t11.reverse(), t11;
    }(n10);
    o10.forEach(function(o11, a10) {
      var i10 = function(e15, t11, n11, r11) {
        var o12 = n11.getTarget(e15);
        var a11 = o12 ? o12.drop(r11, e15) : void 0;
        (function(e16) {
          ete(void 0 === e16 || ute(e16), "Drop result must either be an object or undefined.");
        })(a11), void 0 === a11 && (a11 = 0 === t11 ? {} : r11.getDropResult());
        return a11;
      }(o11, a10, r10, n10);
      var s10 = { type: ate, payload: { dropResult: yte(yte({}, t10), i10) } };
      e14.dispatch(s10);
    });
  };
}
function Ste(e14) {
  return function() {
    var t10 = e14.getMonitor();
    var n10 = e14.getRegistry();
    !function(e15) {
      ete(e15.isDragging(), "Cannot call endDrag while not dragging.");
    }(t10);
    var r10 = t10.getSourceId();
    null != r10 && (n10.getSource(r10, true).endDrag(t10, r10), n10.unpinSource());
    return { type: ite };
  };
}
var Cte = function(e14, t10) {
  return e14 === t10;
};
function xte(e14, t10) {
  var n10 = Object.keys(e14);
  if (Object.getOwnPropertySymbols) {
    var r10 = Object.getOwnPropertySymbols(e14);
    t10 && (r10 = r10.filter(function(t11) {
      return Object.getOwnPropertyDescriptor(e14, t11).enumerable;
    })), n10.push.apply(n10, r10);
  }
  return n10;
}
function wte(e14) {
  for (var t10 = 1; t10 < arguments.length; t10++) {
    var n10 = null != arguments[t10] ? arguments[t10] : {};
    t10 % 2 ? xte(Object(n10), true).forEach(function(t11) {
      Tte(e14, t11, n10[t11]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e14, Object.getOwnPropertyDescriptors(n10)) : xte(Object(n10)).forEach(function(t11) {
      Object.defineProperty(e14, t11, Object.getOwnPropertyDescriptor(n10, t11));
    });
  }
  return e14;
}
function Tte(e14, t10, n10) {
  return t10 in e14 ? Object.defineProperty(e14, t10, { value: n10, enumerable: true, configurable: true, writable: true }) : e14[t10] = n10, e14;
}
var Ete = { initialSourceClientOffset: null, initialClientOffset: null, clientOffset: null };
function Fte() {
  var e14 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Ete;
  var t10 = arguments.length > 1 ? arguments[1] : void 0;
  var n10 = t10.payload;
  switch (t10.type) {
    case tte:
    case nte:
      return { initialSourceClientOffset: n10.sourceClientOffset, initialClientOffset: n10.clientOffset, clientOffset: n10.clientOffset };
    case ote:
      return r10 = e14.clientOffset, o10 = n10.clientOffset, !r10 && !o10 || r10 && o10 && r10.x === o10.x && r10.y === o10.y ? e14 : wte(wte({}, e14), {}, { clientOffset: n10.clientOffset });
    case ite:
    case ate:
      return Ete;
    default:
      return e14;
  }
  var r10, o10;
}
var Mte = "dnd-core/ADD_SOURCE";
var kte = "dnd-core/ADD_TARGET";
var Pte = "dnd-core/REMOVE_SOURCE";
var Nte = "dnd-core/REMOVE_TARGET";
function Dte(e14, t10) {
  var n10 = Object.keys(e14);
  if (Object.getOwnPropertySymbols) {
    var r10 = Object.getOwnPropertySymbols(e14);
    t10 && (r10 = r10.filter(function(t11) {
      return Object.getOwnPropertyDescriptor(e14, t11).enumerable;
    })), n10.push.apply(n10, r10);
  }
  return n10;
}
function Lte(e14) {
  for (var t10 = 1; t10 < arguments.length; t10++) {
    var n10 = null != arguments[t10] ? arguments[t10] : {};
    t10 % 2 ? Dte(Object(n10), true).forEach(function(t11) {
      Hte(e14, t11, n10[t11]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e14, Object.getOwnPropertyDescriptors(n10)) : Dte(Object(n10)).forEach(function(t11) {
      Object.defineProperty(e14, t11, Object.getOwnPropertyDescriptor(n10, t11));
    });
  }
  return e14;
}
function Hte(e14, t10, n10) {
  return t10 in e14 ? Object.defineProperty(e14, t10, { value: n10, enumerable: true, configurable: true, writable: true }) : e14[t10] = n10, e14;
}
var Ite = { itemType: null, item: null, sourceId: null, targetIds: [], dropResult: null, didDrop: false, isSourcePublic: null };
function _te() {
  var e14 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Ite;
  var t10 = arguments.length > 1 ? arguments[1] : void 0;
  var n10 = t10.payload;
  switch (t10.type) {
    case nte:
      return Lte(Lte({}, e14), {}, { itemType: n10.itemType, item: n10.item, sourceId: n10.sourceId, isSourcePublic: n10.isSourcePublic, dropResult: null, didDrop: false });
    case rte:
      return Lte(Lte({}, e14), {}, { isSourcePublic: true });
    case ote:
      return Lte(Lte({}, e14), {}, { targetIds: n10.targetIds });
    case Nte:
      return -1 === e14.targetIds.indexOf(n10.targetId) ? e14 : Lte(Lte({}, e14), {}, { targetIds: cte(e14.targetIds, n10.targetId) });
    case ate:
      return Lte(Lte({}, e14), {}, { dropResult: n10.dropResult, didDrop: true, targetIds: [] });
    case ite:
      return Lte(Lte({}, e14), {}, { itemType: null, item: null, sourceId: null, dropResult: null, didDrop: false, isSourcePublic: null, targetIds: [] });
    default:
      return e14;
  }
}
function Vte() {
  var e14 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
  switch ((arguments.length > 1 ? arguments[1] : void 0).type) {
    case Mte:
    case kte:
      return e14 + 1;
    case Pte:
    case Nte:
      return e14 - 1;
    default:
      return e14;
  }
}
var Rte = [];
var Ate = [];
function Ote() {
  var e14 = arguments.length > 1 ? arguments[1] : void 0;
  switch (e14.type) {
    case ote:
      break;
    case Mte:
    case kte:
    case Nte:
    case Pte:
      return Rte;
    default:
      return Ate;
  }
  var t10 = e14.payload, n10 = t10.targetIds, r10 = void 0 === n10 ? [] : n10, o10 = t10.prevTargetIds, a10 = void 0 === o10 ? [] : o10;
  var i10 = function(e15, t11) {
    var n11 = /* @__PURE__ */ new Map();
    var r11 = function(e16) {
      n11.set(e16, n11.has(e16) ? n11.get(e16) + 1 : 1);
    };
    e15.forEach(r11), t11.forEach(r11);
    var o11 = [];
    return n11.forEach(function(e16, t12) {
      1 === e16 && o11.push(t12);
    }), o11;
  }(r10, a10);
  var s10 = i10.length > 0 || !function(e15, t11) {
    var n11 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Cte;
    if (e15.length !== t11.length) return false;
    for (var r11 = 0; r11 < e15.length; ++r11) if (!n11(e15[r11], t11[r11])) return false;
    return true;
  }(r10, a10);
  if (!s10) return Rte;
  var l10 = a10[a10.length - 1];
  var c10 = r10[r10.length - 1];
  return l10 !== c10 && (l10 && i10.push(l10), c10 && i10.push(c10)), i10;
}
function Bte() {
  return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0) + 1;
}
function zte(e14, t10) {
  var n10 = Object.keys(e14);
  if (Object.getOwnPropertySymbols) {
    var r10 = Object.getOwnPropertySymbols(e14);
    t10 && (r10 = r10.filter(function(t11) {
      return Object.getOwnPropertyDescriptor(e14, t11).enumerable;
    })), n10.push.apply(n10, r10);
  }
  return n10;
}
function $te(e14) {
  for (var t10 = 1; t10 < arguments.length; t10++) {
    var n10 = null != arguments[t10] ? arguments[t10] : {};
    t10 % 2 ? zte(Object(n10), true).forEach(function(t11) {
      Wte(e14, t11, n10[t11]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e14, Object.getOwnPropertyDescriptors(n10)) : zte(Object(n10)).forEach(function(t11) {
      Object.defineProperty(e14, t11, Object.getOwnPropertyDescriptor(n10, t11));
    });
  }
  return e14;
}
function Wte(e14, t10, n10) {
  return t10 in e14 ? Object.defineProperty(e14, t10, { value: n10, enumerable: true, configurable: true, writable: true }) : e14[t10] = n10, e14;
}
function jte() {
  var e14 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
  var t10 = arguments.length > 1 ? arguments[1] : void 0;
  return { dirtyHandlerIds: Ote(e14.dirtyHandlerIds, { type: t10.type, payload: $te($te({}, t10.payload), {}, { prevTargetIds: (n10 = e14, r10 = "dragOperation.targetIds", o10 = [], r10.split(".").reduce(function(e15, t11) {
    return e15 && e15[t11] ? e15[t11] : o10 || null;
  }, n10)) }) }), dragOffset: Fte(e14.dragOffset, t10), refCount: Vte(e14.refCount, t10), dragOperation: _te(e14.dragOperation, t10), stateId: Bte(e14.stateId) };
  var n10, r10, o10;
}
function Zte(e14, t10) {
  return { x: e14.x - t10.x, y: e14.y - t10.y };
}
function Gte(e14, t10) {
  for (var n10 = 0; n10 < t10.length; n10++) {
    var r10 = t10[n10];
    r10.enumerable = r10.enumerable || false, r10.configurable = true, "value" in r10 && (r10.writable = true), Object.defineProperty(e14, r10.key, r10);
  }
}
Rte.__IS_NONE__ = true, Ate.__IS_ALL__ = true;
var Ute = function() {
  function e14(t11, n11) {
    !function(e15, t12) {
      if (!(e15 instanceof t12)) throw new TypeError("Cannot call a class as a function");
    }(this, e14), this.store = t11, this.registry = n11;
  }
  var t10, n10, r10;
  return t10 = e14, n10 = [{ key: "subscribeToStateChange", value: function(e15) {
    var t11 = this;
    var n11 = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : { handlerIds: void 0 }).handlerIds;
    ete("function" == typeof e15, "listener must be a function."), ete(void 0 === n11 || Array.isArray(n11), "handlerIds, when specified, must be an array of strings.");
    var r11 = this.store.getState().stateId;
    return this.store.subscribe(function() {
      var o10 = t11.store.getState();
      var a10 = o10.stateId;
      try {
        var i10 = a10 === r11 || a10 === r11 + 1 && !function(e16, t12) {
          if (e16 === Rte) return false;
          if (e16 === Ate || void 0 === t12) return true;
          var n12 = (r12 = e16, t12.filter(function(e17) {
            return r12.indexOf(e17) > -1;
          }));
          var r12;
          return n12.length > 0;
        }(o10.dirtyHandlerIds, n11);
        i10 || e15();
      } finally {
        r11 = a10;
      }
    });
  } }, { key: "subscribeToOffsetChange", value: function(e15) {
    var t11 = this;
    ete("function" == typeof e15, "listener must be a function.");
    var n11 = this.store.getState().dragOffset;
    return this.store.subscribe(function() {
      var r11 = t11.store.getState().dragOffset;
      r11 !== n11 && (n11 = r11, e15());
    });
  } }, { key: "canDragSource", value: function(e15) {
    if (!e15) return false;
    var t11 = this.registry.getSource(e15);
    return ete(t11, "Expected to find a valid source."), !this.isDragging() && t11.canDrag(this, e15);
  } }, { key: "canDropOnTarget", value: function(e15) {
    if (!e15) return false;
    var t11 = this.registry.getTarget(e15);
    return ete(t11, "Expected to find a valid target."), !(!this.isDragging() || this.didDrop()) && hte(this.registry.getTargetType(e15), this.getItemType()) && t11.canDrop(this, e15);
  } }, { key: "isDragging", value: function() {
    return Boolean(this.getItemType());
  } }, { key: "isDraggingSource", value: function(e15) {
    if (!e15) return false;
    var t11 = this.registry.getSource(e15, true);
    return ete(t11, "Expected to find a valid source."), !(!this.isDragging() || !this.isSourcePublic()) && this.registry.getSourceType(e15) === this.getItemType() && t11.isDragging(this, e15);
  } }, { key: "isOverTarget", value: function(e15) {
    if (!e15) return false;
    var t11 = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : { shallow: false }).shallow;
    if (!this.isDragging()) return false;
    var n11 = this.registry.getTargetType(e15);
    var r11 = this.getItemType();
    if (r11 && !hte(n11, r11)) return false;
    var o10 = this.getTargetIds();
    if (!o10.length) return false;
    var a10 = o10.indexOf(e15);
    return t11 ? a10 === o10.length - 1 : a10 > -1;
  } }, { key: "getItemType", value: function() {
    return this.store.getState().dragOperation.itemType;
  } }, { key: "getItem", value: function() {
    return this.store.getState().dragOperation.item;
  } }, { key: "getSourceId", value: function() {
    return this.store.getState().dragOperation.sourceId;
  } }, { key: "getTargetIds", value: function() {
    return this.store.getState().dragOperation.targetIds;
  } }, { key: "getDropResult", value: function() {
    return this.store.getState().dragOperation.dropResult;
  } }, { key: "didDrop", value: function() {
    return this.store.getState().dragOperation.didDrop;
  } }, { key: "isSourcePublic", value: function() {
    return Boolean(this.store.getState().dragOperation.isSourcePublic);
  } }, { key: "getInitialClientOffset", value: function() {
    return this.store.getState().dragOffset.initialClientOffset;
  } }, { key: "getInitialSourceClientOffset", value: function() {
    return this.store.getState().dragOffset.initialSourceClientOffset;
  } }, { key: "getClientOffset", value: function() {
    return this.store.getState().dragOffset.clientOffset;
  } }, { key: "getSourceClientOffset", value: function() {
    return function(e15) {
      var t11 = e15.clientOffset, n11 = e15.initialClientOffset, r11 = e15.initialSourceClientOffset;
      return t11 && n11 && r11 ? Zte(function(e16, t12) {
        return { x: e16.x + t12.x, y: e16.y + t12.y };
      }(t11, r11), n11) : null;
    }(this.store.getState().dragOffset);
  } }, { key: "getDifferenceFromInitialOffset", value: function() {
    return function(e15) {
      var t11 = e15.clientOffset, n11 = e15.initialClientOffset;
      return t11 && n11 ? Zte(t11, n11) : null;
    }(this.store.getState().dragOffset);
  } }], n10 && Gte(t10.prototype, n10), r10 && Gte(t10, r10), e14;
}();
var qte = 0;
function Yte(e14) {
  return Yte = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e15) {
    return typeof e15;
  } : function(e15) {
    return e15 && "function" == typeof Symbol && e15.constructor === Symbol && e15 !== Symbol.prototype ? "symbol" : typeof e15;
  }, Yte(e14);
}
function Kte(e14, t10) {
  t10 && Array.isArray(e14) ? e14.forEach(function(e15) {
    return Kte(e15, false);
  }) : ete("string" == typeof e14 || "symbol" === Yte(e14), t10 ? "Type can only be a string, a symbol, or an array of either." : "Type can only be a string or a symbol.");
}
const Xte = "undefined" != typeof global ? global : self;
const Jte = Xte.MutationObserver || Xte.WebKitMutationObserver;
function Qte(e14) {
  return function() {
    const t10 = setTimeout(r10, 0);
    const n10 = setInterval(r10, 50);
    function r10() {
      clearTimeout(t10), clearInterval(n10), e14();
    }
  };
}
const ene = "function" == typeof Jte ? function(e14) {
  let t10 = 1;
  const n10 = new Jte(e14);
  const r10 = document.createTextNode("");
  return n10.observe(r10, { characterData: true }), function() {
    t10 = -t10, r10.data = t10;
  };
} : Qte;
class tne {
  call() {
    try {
      this.task && this.task();
    } catch (e14) {
      this.onError(e14);
    } finally {
      this.task = null, this.release(this);
    }
  }
  constructor(e14, t10) {
    this.onError = e14, this.release = t10, this.task = null;
  }
}
const nne = new class {
  enqueueTask(e14) {
    const { queue: t10, requestFlush: n10 } = this;
    t10.length || (n10(), this.flushing = true), t10[t10.length] = e14;
  }
  constructor() {
    this.queue = [], this.pendingErrors = [], this.flushing = false, this.index = 0, this.capacity = 1024, this.flush = () => {
      const { queue: e14 } = this;
      for (; this.index < e14.length; ) {
        const t10 = this.index;
        if (this.index++, e14[t10].call(), this.index > this.capacity) {
          for (let t11 = 0, n10 = e14.length - this.index; t11 < n10; t11++) e14[t11] = e14[t11 + this.index];
          e14.length -= this.index, this.index = 0;
        }
      }
      e14.length = 0, this.index = 0, this.flushing = false;
    }, this.registerPendingError = (e14) => {
      this.pendingErrors.push(e14), this.requestErrorThrow();
    }, this.requestFlush = ene(this.flush), this.requestErrorThrow = Qte(() => {
      if (this.pendingErrors.length) throw this.pendingErrors.shift();
    });
  }
}();
const rne = new class {
  create(e14) {
    const t10 = this.freeTasks;
    const n10 = t10.length ? t10.pop() : new tne(this.onError, (e15) => t10[t10.length] = e15);
    return n10.task = e14, n10;
  }
  constructor(e14) {
    this.onError = e14, this.freeTasks = [];
  }
}(nne.registerPendingError);
function one(e14, t10) {
  for (var n10 = 0; n10 < t10.length; n10++) {
    var r10 = t10[n10];
    r10.enumerable = r10.enumerable || false, r10.configurable = true, "value" in r10 && (r10.writable = true), Object.defineProperty(e14, r10.key, r10);
  }
}
function ane(e14, t10) {
  return function(e15) {
    if (Array.isArray(e15)) return e15;
  }(e14) || function(e15, t11) {
    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e15))) return;
    var n10 = [];
    var r10 = true;
    var o10 = false;
    var a10 = void 0;
    try {
      for (var i10, s10 = e15[Symbol.iterator](); !(r10 = (i10 = s10.next()).done) && (n10.push(i10.value), !t11 || n10.length !== t11); r10 = true) ;
    } catch (e16) {
      o10 = true, a10 = e16;
    } finally {
      try {
        r10 || null == s10.return || s10.return();
      } finally {
        if (o10) throw a10;
      }
    }
    return n10;
  }(e14, t10) || function(e15, t11) {
    if (!e15) return;
    if ("string" == typeof e15) return ine(e15, t11);
    var n10 = Object.prototype.toString.call(e15).slice(8, -1);
    "Object" === n10 && e15.constructor && (n10 = e15.constructor.name);
    if ("Map" === n10 || "Set" === n10) return Array.from(e15);
    if ("Arguments" === n10 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n10)) return ine(e15, t11);
  }(e14, t10) || function() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function ine(e14, t10) {
  (null == t10 || t10 > e14.length) && (t10 = e14.length);
  for (var n10 = 0, r10 = new Array(t10); n10 < t10; n10++) r10[n10] = e14[n10];
  return r10;
}
function sne(e14) {
  var t10 = (qte++).toString();
  switch (e14) {
    case Qee.SOURCE:
      return "S".concat(t10);
    case Qee.TARGET:
      return "T".concat(t10);
    default:
      throw new Error("Unknown Handler Role: ".concat(e14));
  }
}
function lne(e14) {
  switch (e14[0]) {
    case "S":
      return Qee.SOURCE;
    case "T":
      return Qee.TARGET;
    default:
      ete(false, "Cannot parse handler ID: ".concat(e14));
  }
}
function cne(e14, t10) {
  var n10 = e14.entries();
  var r10 = false;
  do {
    var o10 = n10.next(), a10 = o10.done;
    if (ane(o10.value, 2)[1] === t10) return true;
    r10 = !!a10;
  } while (!r10);
  return false;
}
var une = function() {
  function e14(t11) {
    !function(e15, t12) {
      if (!(e15 instanceof t12)) throw new TypeError("Cannot call a class as a function");
    }(this, e14), this.types = /* @__PURE__ */ new Map(), this.dragSources = /* @__PURE__ */ new Map(), this.dropTargets = /* @__PURE__ */ new Map(), this.pinnedSourceId = null, this.pinnedSource = null, this.store = t11;
  }
  var t10, n10, r10;
  return t10 = e14, n10 = [{ key: "addSource", value: function(e15, t11) {
    Kte(e15), function(e16) {
      ete("function" == typeof e16.canDrag, "Expected canDrag to be a function."), ete("function" == typeof e16.beginDrag, "Expected beginDrag to be a function."), ete("function" == typeof e16.endDrag, "Expected endDrag to be a function.");
    }(t11);
    var n11 = this.addHandler(Qee.SOURCE, e15, t11);
    return this.store.dispatch(/* @__PURE__ */ function(e16) {
      return { type: Mte, payload: { sourceId: e16 } };
    }(n11)), n11;
  } }, { key: "addTarget", value: function(e15, t11) {
    Kte(e15, true), function(e16) {
      ete("function" == typeof e16.canDrop, "Expected canDrop to be a function."), ete("function" == typeof e16.hover, "Expected hover to be a function."), ete("function" == typeof e16.drop, "Expected beginDrag to be a function.");
    }(t11);
    var n11 = this.addHandler(Qee.TARGET, e15, t11);
    return this.store.dispatch(/* @__PURE__ */ function(e16) {
      return { type: kte, payload: { targetId: e16 } };
    }(n11)), n11;
  } }, { key: "containsHandler", value: function(e15) {
    return cne(this.dragSources, e15) || cne(this.dropTargets, e15);
  } }, { key: "getSource", value: function(e15) {
    var t11 = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    return ete(this.isSourceId(e15), "Expected a valid source ID."), t11 && e15 === this.pinnedSourceId ? this.pinnedSource : this.dragSources.get(e15);
  } }, { key: "getTarget", value: function(e15) {
    return ete(this.isTargetId(e15), "Expected a valid target ID."), this.dropTargets.get(e15);
  } }, { key: "getSourceType", value: function(e15) {
    return ete(this.isSourceId(e15), "Expected a valid source ID."), this.types.get(e15);
  } }, { key: "getTargetType", value: function(e15) {
    return ete(this.isTargetId(e15), "Expected a valid target ID."), this.types.get(e15);
  } }, { key: "isSourceId", value: function(e15) {
    return lne(e15) === Qee.SOURCE;
  } }, { key: "isTargetId", value: function(e15) {
    return lne(e15) === Qee.TARGET;
  } }, { key: "removeSource", value: function(e15) {
    var t11 = this;
    var n11;
    ete(this.getSource(e15), "Expected an existing source."), this.store.dispatch(/* @__PURE__ */ function(e16) {
      return { type: Pte, payload: { sourceId: e16 } };
    }(e15)), n11 = function() {
      t11.dragSources.delete(e15), t11.types.delete(e15);
    }, nne.enqueueTask(rne.create(n11));
  } }, { key: "removeTarget", value: function(e15) {
    ete(this.getTarget(e15), "Expected an existing target."), this.store.dispatch(/* @__PURE__ */ function(e16) {
      return { type: Nte, payload: { targetId: e16 } };
    }(e15)), this.dropTargets.delete(e15), this.types.delete(e15);
  } }, { key: "pinSource", value: function(e15) {
    var t11 = this.getSource(e15);
    ete(t11, "Expected an existing source."), this.pinnedSourceId = e15, this.pinnedSource = t11;
  } }, { key: "unpinSource", value: function() {
    ete(this.pinnedSource, "No source is pinned at the time."), this.pinnedSourceId = null, this.pinnedSource = null;
  } }, { key: "addHandler", value: function(e15, t11, n11) {
    var r11 = sne(e15);
    return this.types.set(r11, t11), e15 === Qee.SOURCE ? this.dragSources.set(r11, n11) : e15 === Qee.TARGET && this.dropTargets.set(r11, n11), r11;
  } }], n10 && one(t10.prototype, n10), r10 && one(t10, r10), e14;
}();
function dne(e14, t10) {
  for (var n10 = 0; n10 < t10.length; n10++) {
    var r10 = t10[n10];
    r10.enumerable = r10.enumerable || false, r10.configurable = true, "value" in r10 && (r10.writable = true), Object.defineProperty(e14, r10.key, r10);
  }
}
var pne = function() {
  function e14() {
    var t11 = this;
    var n11 = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
    !function(e15, t12) {
      if (!(e15 instanceof t12)) throw new TypeError("Cannot call a class as a function");
    }(this, e14), this.isSetUp = false, this.handleRefCountChange = function() {
      var e15 = t11.store.getState().refCount > 0;
      t11.backend && (e15 && !t11.isSetUp ? (t11.backend.setup(), t11.isSetUp = true) : !e15 && t11.isSetUp && (t11.backend.teardown(), t11.isSetUp = false));
    };
    var r11 = function(e15) {
      var t12 = "undefined" != typeof window && window.__REDUX_DEVTOOLS_EXTENSION__;
      return sA(jte, e15 && t12 && t12({ name: "dnd-core", instanceId: "dnd-core" }));
    }(n11);
    this.store = r11, this.monitor = new Ute(r11, new une(r11)), r11.subscribe(this.handleRefCountChange);
  }
  var t10, n10, r10;
  return t10 = e14, n10 = [{ key: "receiveBackend", value: function(e15) {
    this.backend = e15;
  } }, { key: "getMonitor", value: function() {
    return this.monitor;
  } }, { key: "getBackend", value: function() {
    return this.backend;
  } }, { key: "getRegistry", value: function() {
    return this.monitor.registry;
  } }, { key: "getActions", value: function() {
    var e15 = this;
    var t11 = this.store.dispatch;
    var n11 = function(e16) {
      return { beginDrag: pte(e16), publishDragSource: mte(e16), hover: fte(e16), drop: bte(e16), endDrag: Ste(e16) };
    }(this);
    return Object.keys(n11).reduce(function(r11, o10) {
      var a10 = n11[o10];
      return r11[o10] = /* @__PURE__ */ function(n12) {
        return function() {
          for (var r12 = arguments.length, o11 = new Array(r12), a11 = 0; a11 < r12; a11++) o11[a11] = arguments[a11];
          var i10 = n12.apply(e15, o11);
          void 0 !== i10 && t11(i10);
        };
      }(a10), r11;
    }, {});
  } }, { key: "dispatch", value: function(e15) {
    this.store.dispatch(e15);
  } }], n10 && dne(t10.prototype, n10), r10 && dne(t10, r10), e14;
}();
function mne(e14, t10, n10, r10) {
  var o10 = new pne(r10);
  var a10 = e14(o10, t10, n10);
  return o10.receiveBackend(a10), o10;
}
var hne = ep.createContext({ dragDropManager: void 0 });
function fne(e14, t10) {
  return function(e15) {
    if (Array.isArray(e15)) return e15;
  }(e14) || function(e15, t11) {
    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e15))) return;
    var n10 = [];
    var r10 = true;
    var o10 = false;
    var a10 = void 0;
    try {
      for (var i10, s10 = e15[Symbol.iterator](); !(r10 = (i10 = s10.next()).done) && (n10.push(i10.value), !t11 || n10.length !== t11); r10 = true) ;
    } catch (e16) {
      o10 = true, a10 = e16;
    } finally {
      try {
        r10 || null == s10.return || s10.return();
      } finally {
        if (o10) throw a10;
      }
    }
    return n10;
  }(e14, t10) || function(e15, t11) {
    if (!e15) return;
    if ("string" == typeof e15) return gne(e15, t11);
    var n10 = Object.prototype.toString.call(e15).slice(8, -1);
    "Object" === n10 && e15.constructor && (n10 = e15.constructor.name);
    if ("Map" === n10 || "Set" === n10) return Array.from(e15);
    if ("Arguments" === n10 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n10)) return gne(e15, t11);
  }(e14, t10) || function() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function gne(e14, t10) {
  (null == t10 || t10 > e14.length) && (t10 = e14.length);
  for (var n10 = 0, r10 = new Array(t10); n10 < t10; n10++) r10[n10] = e14[n10];
  return r10;
}
function yne(e14, t10) {
  if (null == e14) return {};
  var n10 = function(e15, t11) {
    if (null == e15) return {};
    var n11 = {};
    var r11 = Object.keys(e15);
    var o11, a11;
    for (a11 = 0; a11 < r11.length; a11++) o11 = r11[a11], t11.indexOf(o11) >= 0 || (n11[o11] = e15[o11]);
    return n11;
  }(e14, t10);
  var r10, o10;
  if (Object.getOwnPropertySymbols) {
    var a10 = Object.getOwnPropertySymbols(e14);
    for (o10 = 0; o10 < a10.length; o10++) r10 = a10[o10], t10.indexOf(r10) >= 0 || Object.prototype.propertyIsEnumerable.call(e14, r10) && (n10[r10] = e14[r10]);
  }
  return n10;
}
var vne = 0;
var bne = ep.memo(function(e14) {
  var t10 = e14.children;
  var n10 = function(e15) {
    if ("manager" in e15) {
      return [{ dragDropManager: e15.manager }, false];
    }
    var t11 = function(e16) {
      var t12 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Cne();
      var n12 = arguments.length > 2 ? arguments[2] : void 0;
      var r11 = arguments.length > 3 ? arguments[3] : void 0;
      var o11 = t12;
      o11[Sne] || (o11[Sne] = function(e17, t13, n13, r12) {
        return { dragDropManager: mne(e17, t13, n13, r12) };
      }(e16, t12, n12, r11));
      return o11[Sne];
    }(e15.backend, e15.context, e15.options, e15.debugMode);
    var n11 = !e15.context;
    return [t11, n11];
  }(yne(e14, ["children"])), r10 = fne(n10, 2), o10 = r10[0], a10 = r10[1];
  return ep.useEffect(function() {
    return a10 && vne++, function() {
      a10 && (0 === --vne && (Cne()[Sne] = null));
    };
  }, []), ep.createElement(hne.Provider, { value: o10 }, t10);
});
bne.displayName = "DndProvider";
var Sne = Symbol.for("__REACT_DND_CONTEXT_INSTANCE__");
function Cne() {
  return "undefined" != typeof global ? global : window;
}
var xne = "undefined" != typeof window ? ep.useLayoutEffect : ep.useEffect;
function wne(e14, t10, n10, r10) {
  var o10 = n10 ? n10.call(r10, e14, t10) : void 0;
  if (void 0 !== o10) return !!o10;
  if (e14 === t10) return true;
  if ("object" != typeof e14 || !e14 || "object" != typeof t10 || !t10) return false;
  var a10 = Object.keys(e14);
  var i10 = Object.keys(t10);
  if (a10.length !== i10.length) return false;
  var s10 = Object.prototype.hasOwnProperty.bind(t10);
  for (var l10 = 0; l10 < a10.length; l10++) {
    var c10 = a10[l10];
    if (!s10(c10)) return false;
    var u10 = e14[c10];
    var d10 = t10[c10];
    if (false === (o10 = n10 ? n10.call(r10, u10, d10, c10) : void 0) || void 0 === o10 && u10 !== d10) return false;
  }
  return true;
}
function Tne(e14, t10) {
  return function(e15) {
    if (Array.isArray(e15)) return e15;
  }(e14) || function(e15, t11) {
    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e15))) return;
    var n10 = [];
    var r10 = true;
    var o10 = false;
    var a10 = void 0;
    try {
      for (var i10, s10 = e15[Symbol.iterator](); !(r10 = (i10 = s10.next()).done) && (n10.push(i10.value), !t11 || n10.length !== t11); r10 = true) ;
    } catch (e16) {
      o10 = true, a10 = e16;
    } finally {
      try {
        r10 || null == s10.return || s10.return();
      } finally {
        if (o10) throw a10;
      }
    }
    return n10;
  }(e14, t10) || function(e15, t11) {
    if (!e15) return;
    if ("string" == typeof e15) return Ene(e15, t11);
    var n10 = Object.prototype.toString.call(e15).slice(8, -1);
    "Object" === n10 && e15.constructor && (n10 = e15.constructor.name);
    if ("Map" === n10 || "Set" === n10) return Array.from(e15);
    if ("Arguments" === n10 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n10)) return Ene(e15, t11);
  }(e14, t10) || function() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function Ene(e14, t10) {
  (null == t10 || t10 > e14.length) && (t10 = e14.length);
  for (var n10 = 0, r10 = new Array(t10); n10 < t10; n10++) r10[n10] = e14[n10];
  return r10;
}
function Fne(e14, t10, n10) {
  var r10 = Tne(ep.useState(function() {
    return t10(e14);
  }), 2), o10 = r10[0], a10 = r10[1];
  var i10 = ep.useCallback(function() {
    var r11 = t10(e14);
    wne(o10, r11) || (a10(r11), n10 && n10());
  }, [o10, e14, n10]);
  return xne(i10, []), [o10, i10];
}
function Mne(e14, t10) {
  return function(e15) {
    if (Array.isArray(e15)) return e15;
  }(e14) || function(e15, t11) {
    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e15))) return;
    var n10 = [];
    var r10 = true;
    var o10 = false;
    var a10 = void 0;
    try {
      for (var i10, s10 = e15[Symbol.iterator](); !(r10 = (i10 = s10.next()).done) && (n10.push(i10.value), !t11 || n10.length !== t11); r10 = true) ;
    } catch (e16) {
      o10 = true, a10 = e16;
    } finally {
      try {
        r10 || null == s10.return || s10.return();
      } finally {
        if (o10) throw a10;
      }
    }
    return n10;
  }(e14, t10) || function(e15, t11) {
    if (!e15) return;
    if ("string" == typeof e15) return kne(e15, t11);
    var n10 = Object.prototype.toString.call(e15).slice(8, -1);
    "Object" === n10 && e15.constructor && (n10 = e15.constructor.name);
    if ("Map" === n10 || "Set" === n10) return Array.from(e15);
    if ("Arguments" === n10 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n10)) return kne(e15, t11);
  }(e14, t10) || function() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function kne(e14, t10) {
  (null == t10 || t10 > e14.length) && (t10 = e14.length);
  for (var n10 = 0, r10 = new Array(t10); n10 < t10; n10++) r10[n10] = e14[n10];
  return r10;
}
function Pne(e14, t10, n10) {
  var r10 = Mne(Fne(e14, t10, n10), 2), o10 = r10[0], a10 = r10[1];
  return xne(function() {
    var t11 = e14.getHandlerId();
    if (null != t11) return e14.subscribeToStateChange(a10, { handlerIds: [t11] });
  }, [e14, a10]), o10;
}
function Nne(e14, t10, n10) {
  var r10 = n10.getRegistry();
  var o10 = r10.addTarget(e14, t10);
  return [o10, function() {
    return r10.removeTarget(o10);
  }];
}
function Dne(e14, t10, n10) {
  var r10 = n10.getRegistry();
  var o10 = r10.addSource(e14, t10);
  return [o10, function() {
    return r10.removeSource(o10);
  }];
}
function Lne() {
  var e14 = ep.useContext(hne).dragDropManager;
  return ete(null != e14, "Expected drag drop context"), e14;
}
function Hne(e14, t10) {
  for (var n10 = 0; n10 < t10.length; n10++) {
    var r10 = t10[n10];
    r10.enumerable = r10.enumerable || false, r10.configurable = true, "value" in r10 && (r10.writable = true), Object.defineProperty(e14, r10.key, r10);
  }
}
var Ine = false;
var _ne = false;
var Vne = function() {
  function e14(t11) {
    !function(e15, t12) {
      if (!(e15 instanceof t12)) throw new TypeError("Cannot call a class as a function");
    }(this, e14), this.sourceId = null, this.internalMonitor = t11.getMonitor();
  }
  var t10, n10, r10;
  return t10 = e14, (n10 = [{ key: "receiveHandlerId", value: function(e15) {
    this.sourceId = e15;
  } }, { key: "getHandlerId", value: function() {
    return this.sourceId;
  } }, { key: "canDrag", value: function() {
    ete(!Ine, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
    try {
      return Ine = true, this.internalMonitor.canDragSource(this.sourceId);
    } finally {
      Ine = false;
    }
  } }, { key: "isDragging", value: function() {
    if (!this.sourceId) return false;
    ete(!_ne, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
    try {
      return _ne = true, this.internalMonitor.isDraggingSource(this.sourceId);
    } finally {
      _ne = false;
    }
  } }, { key: "subscribeToStateChange", value: function(e15, t11) {
    return this.internalMonitor.subscribeToStateChange(e15, t11);
  } }, { key: "isDraggingSource", value: function(e15) {
    return this.internalMonitor.isDraggingSource(e15);
  } }, { key: "isOverTarget", value: function(e15, t11) {
    return this.internalMonitor.isOverTarget(e15, t11);
  } }, { key: "getTargetIds", value: function() {
    return this.internalMonitor.getTargetIds();
  } }, { key: "isSourcePublic", value: function() {
    return this.internalMonitor.isSourcePublic();
  } }, { key: "getSourceId", value: function() {
    return this.internalMonitor.getSourceId();
  } }, { key: "subscribeToOffsetChange", value: function(e15) {
    return this.internalMonitor.subscribeToOffsetChange(e15);
  } }, { key: "canDragSource", value: function(e15) {
    return this.internalMonitor.canDragSource(e15);
  } }, { key: "canDropOnTarget", value: function(e15) {
    return this.internalMonitor.canDropOnTarget(e15);
  } }, { key: "getItemType", value: function() {
    return this.internalMonitor.getItemType();
  } }, { key: "getItem", value: function() {
    return this.internalMonitor.getItem();
  } }, { key: "getDropResult", value: function() {
    return this.internalMonitor.getDropResult();
  } }, { key: "didDrop", value: function() {
    return this.internalMonitor.didDrop();
  } }, { key: "getInitialClientOffset", value: function() {
    return this.internalMonitor.getInitialClientOffset();
  } }, { key: "getInitialSourceClientOffset", value: function() {
    return this.internalMonitor.getInitialSourceClientOffset();
  } }, { key: "getSourceClientOffset", value: function() {
    return this.internalMonitor.getSourceClientOffset();
  } }, { key: "getClientOffset", value: function() {
    return this.internalMonitor.getClientOffset();
  } }, { key: "getDifferenceFromInitialOffset", value: function() {
    return this.internalMonitor.getDifferenceFromInitialOffset();
  } }]) && Hne(t10.prototype, n10), r10 && Hne(t10, r10), e14;
}();
function Rne(e14, t10) {
  "function" == typeof e14 ? e14(t10) : e14.current = t10;
}
function Ane(e14) {
  return function() {
    var t10 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
    var n10 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
    if (!ep.isValidElement(t10)) {
      var r10 = t10;
      return e14(r10, n10), r10;
    }
    var o10 = t10;
    !function(e15) {
      if ("string" != typeof e15.type) {
        var t11 = e15.type.displayName || e15.type.name || "the component";
        throw new Error("Only native element nodes can now be passed to React DnD connectors." + "You can either wrap ".concat(t11, " into a <div>, or turn it into a ") + "drag source or a drop target itself.");
      }
    }(o10);
    var a10 = n10 ? function(t11) {
      return e14(t11, n10);
    } : e14;
    return function(e15, t11) {
      var n11 = e15.ref;
      return ete("string" != typeof n11, "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute"), n11 ? ep.cloneElement(e15, { ref: function(e16) {
        Rne(n11, e16), Rne(t11, e16);
      } }) : ep.cloneElement(e15, { ref: t11 });
    }(o10, a10);
  };
}
function One(e14) {
  var t10 = {};
  return Object.keys(e14).forEach(function(n10) {
    var r10 = e14[n10];
    if (n10.endsWith("Ref")) t10[n10] = e14[n10];
    else {
      var o10 = Ane(r10);
      t10[n10] = function() {
        return o10;
      };
    }
  }), t10;
}
function Bne(e14) {
  return Bne = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e15) {
    return typeof e15;
  } : function(e15) {
    return e15 && "function" == typeof Symbol && e15.constructor === Symbol && e15 !== Symbol.prototype ? "symbol" : typeof e15;
  }, Bne(e14);
}
function zne(e14) {
  return null !== e14 && "object" === Bne(e14) && Object.prototype.hasOwnProperty.call(e14, "current");
}
function $ne(e14, t10) {
  for (var n10 = 0; n10 < t10.length; n10++) {
    var r10 = t10[n10];
    r10.enumerable = r10.enumerable || false, r10.configurable = true, "value" in r10 && (r10.writable = true), Object.defineProperty(e14, r10.key, r10);
  }
}
var Wne = function() {
  function e14(t11) {
    var n11 = this;
    !function(e15, t12) {
      if (!(e15 instanceof t12)) throw new TypeError("Cannot call a class as a function");
    }(this, e14), this.hooks = One({ dragSource: function(e15, t12) {
      n11.clearDragSource(), n11.dragSourceOptions = t12 || null, zne(e15) ? n11.dragSourceRef = e15 : n11.dragSourceNode = e15, n11.reconnectDragSource();
    }, dragPreview: function(e15, t12) {
      n11.clearDragPreview(), n11.dragPreviewOptions = t12 || null, zne(e15) ? n11.dragPreviewRef = e15 : n11.dragPreviewNode = e15, n11.reconnectDragPreview();
    } }), this.handlerId = null, this.dragSourceRef = null, this.dragSourceOptionsInternal = null, this.dragPreviewRef = null, this.dragPreviewOptionsInternal = null, this.lastConnectedHandlerId = null, this.lastConnectedDragSource = null, this.lastConnectedDragSourceOptions = null, this.lastConnectedDragPreview = null, this.lastConnectedDragPreviewOptions = null, this.backend = t11;
  }
  var t10, n10, r10;
  return t10 = e14, (n10 = [{ key: "receiveHandlerId", value: function(e15) {
    this.handlerId !== e15 && (this.handlerId = e15, this.reconnect());
  } }, { key: "reconnect", value: function() {
    this.reconnectDragSource(), this.reconnectDragPreview();
  } }, { key: "reconnectDragSource", value: function() {
    var e15 = this.dragSource;
    var t11 = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
    t11 && this.disconnectDragSource(), this.handlerId && (e15 ? t11 && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragSource = e15, this.lastConnectedDragSourceOptions = this.dragSourceOptions, this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, e15, this.dragSourceOptions)) : this.lastConnectedDragSource = e15);
  } }, { key: "reconnectDragPreview", value: function() {
    var e15 = this.dragPreview;
    var t11 = this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
    t11 && this.disconnectDragPreview(), this.handlerId && (e15 ? t11 && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragPreview = e15, this.lastConnectedDragPreviewOptions = this.dragPreviewOptions, this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, e15, this.dragPreviewOptions)) : this.lastConnectedDragPreview = e15);
  } }, { key: "didHandlerIdChange", value: function() {
    return this.lastConnectedHandlerId !== this.handlerId;
  } }, { key: "didConnectedDragSourceChange", value: function() {
    return this.lastConnectedDragSource !== this.dragSource;
  } }, { key: "didConnectedDragPreviewChange", value: function() {
    return this.lastConnectedDragPreview !== this.dragPreview;
  } }, { key: "didDragSourceOptionsChange", value: function() {
    return !wne(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
  } }, { key: "didDragPreviewOptionsChange", value: function() {
    return !wne(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
  } }, { key: "disconnectDragSource", value: function() {
    this.dragSourceUnsubscribe && (this.dragSourceUnsubscribe(), this.dragSourceUnsubscribe = void 0);
  } }, { key: "disconnectDragPreview", value: function() {
    this.dragPreviewUnsubscribe && (this.dragPreviewUnsubscribe(), this.dragPreviewUnsubscribe = void 0, this.dragPreviewNode = null, this.dragPreviewRef = null);
  } }, { key: "clearDragSource", value: function() {
    this.dragSourceNode = null, this.dragSourceRef = null;
  } }, { key: "clearDragPreview", value: function() {
    this.dragPreviewNode = null, this.dragPreviewRef = null;
  } }, { key: "connectTarget", get: function() {
    return this.dragSource;
  } }, { key: "dragSourceOptions", get: function() {
    return this.dragSourceOptionsInternal;
  }, set: function(e15) {
    this.dragSourceOptionsInternal = e15;
  } }, { key: "dragPreviewOptions", get: function() {
    return this.dragPreviewOptionsInternal;
  }, set: function(e15) {
    this.dragPreviewOptionsInternal = e15;
  } }, { key: "dragSource", get: function() {
    return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
  } }, { key: "dragPreview", get: function() {
    return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
  } }]) && $ne(t10.prototype, n10), r10 && $ne(t10, r10), e14;
}();
function jne(e14, t10) {
  return function(e15) {
    if (Array.isArray(e15)) return e15;
  }(e14) || function(e15, t11) {
    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e15))) return;
    var n10 = [];
    var r10 = true;
    var o10 = false;
    var a10 = void 0;
    try {
      for (var i10, s10 = e15[Symbol.iterator](); !(r10 = (i10 = s10.next()).done) && (n10.push(i10.value), !t11 || n10.length !== t11); r10 = true) ;
    } catch (e16) {
      o10 = true, a10 = e16;
    } finally {
      try {
        r10 || null == s10.return || s10.return();
      } finally {
        if (o10) throw a10;
      }
    }
    return n10;
  }(e14, t10) || function(e15, t11) {
    if (!e15) return;
    if ("string" == typeof e15) return Zne(e15, t11);
    var n10 = Object.prototype.toString.call(e15).slice(8, -1);
    "Object" === n10 && e15.constructor && (n10 = e15.constructor.name);
    if ("Map" === n10 || "Set" === n10) return Array.from(e15);
    if ("Arguments" === n10 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n10)) return Zne(e15, t11);
  }(e14, t10) || function() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function Zne(e14, t10) {
  (null == t10 || t10 > e14.length) && (t10 = e14.length);
  for (var n10 = 0, r10 = new Array(t10); n10 < t10; n10++) r10[n10] = e14[n10];
  return r10;
}
function Gne(e14) {
  return Gne = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e15) {
    return typeof e15;
  } : function(e15) {
    return e15 && "function" == typeof Symbol && e15.constructor === Symbol && e15 !== Symbol.prototype ? "symbol" : typeof e15;
  }, Gne(e14);
}
function Une(e14, t10) {
  return function(e15) {
    if (Array.isArray(e15)) return e15;
  }(e14) || function(e15, t11) {
    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e15))) return;
    var n10 = [];
    var r10 = true;
    var o10 = false;
    var a10 = void 0;
    try {
      for (var i10, s10 = e15[Symbol.iterator](); !(r10 = (i10 = s10.next()).done) && (n10.push(i10.value), !t11 || n10.length !== t11); r10 = true) ;
    } catch (e16) {
      o10 = true, a10 = e16;
    } finally {
      try {
        r10 || null == s10.return || s10.return();
      } finally {
        if (o10) throw a10;
      }
    }
    return n10;
  }(e14, t10) || function(e15, t11) {
    if (!e15) return;
    if ("string" == typeof e15) return qne(e15, t11);
    var n10 = Object.prototype.toString.call(e15).slice(8, -1);
    "Object" === n10 && e15.constructor && (n10 = e15.constructor.name);
    if ("Map" === n10 || "Set" === n10) return Array.from(e15);
    if ("Arguments" === n10 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n10)) return qne(e15, t11);
  }(e14, t10) || function() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function qne(e14, t10) {
  (null == t10 || t10 > e14.length) && (t10 = e14.length);
  for (var n10 = 0, r10 = new Array(t10); n10 < t10; n10++) r10[n10] = e14[n10];
  return r10;
}
function Yne(e14) {
  var t10 = ep.useRef(e14);
  t10.current = e14, ete(null != e14.item, "item must be defined"), ete(null != e14.item.type, "item type must be defined");
  var n10 = Une((a10 = Lne(), [ep.useMemo(function() {
    return new Vne(a10);
  }, [a10]), ep.useMemo(function() {
    return new Wne(a10.getBackend());
  }, [a10])]), 2), r10 = n10[0], o10 = n10[1];
  var a10;
  !function(e15, t11, n11) {
    var r11 = Lne();
    var o11 = ep.useMemo(function() {
      return { beginDrag: function() {
        var n12 = e15.current, r12 = n12.begin, o12 = n12.item;
        if (r12) {
          var a11 = r12(t11);
          return ete(null == a11 || "object" === Gne(a11), "dragSpec.begin() must either return an object, undefined, or null"), a11 || o12 || {};
        }
        return o12 || {};
      }, canDrag: function() {
        return "boolean" == typeof e15.current.canDrag ? e15.current.canDrag : "function" != typeof e15.current.canDrag || e15.current.canDrag(t11);
      }, isDragging: function(n12, r12) {
        var o12 = e15.current.isDragging;
        return o12 ? o12(t11) : r12 === n12.getSourceId();
      }, endDrag: function() {
        var r12 = e15.current.end;
        r12 && r12(t11.getItem(), t11), n11.reconnect();
      } };
    }, []);
    xne(function() {
      var a11 = jne(Dne(e15.current.item.type, o11, r11), 2), i11 = a11[0], s11 = a11[1];
      return t11.receiveHandlerId(i11), n11.receiveHandlerId(i11), s11;
    }, []);
  }(t10, r10, o10);
  var i10 = Pne(r10, t10.current.collect || function() {
    return {};
  }, function() {
    return o10.reconnect();
  });
  var s10 = ep.useMemo(function() {
    return o10.hooks.dragSource();
  }, [o10]);
  var l10 = ep.useMemo(function() {
    return o10.hooks.dragPreview();
  }, [o10]);
  return xne(function() {
    o10.dragSourceOptions = t10.current.options || null, o10.reconnect();
  }, [o10]), xne(function() {
    o10.dragPreviewOptions = t10.current.previewOptions || null, o10.reconnect();
  }, [o10]), [i10, s10, l10];
}
function Kne(e14, t10) {
  for (var n10 = 0; n10 < t10.length; n10++) {
    var r10 = t10[n10];
    r10.enumerable = r10.enumerable || false, r10.configurable = true, "value" in r10 && (r10.writable = true), Object.defineProperty(e14, r10.key, r10);
  }
}
var Xne = function() {
  function e14(t11) {
    var n11 = this;
    !function(e15, t12) {
      if (!(e15 instanceof t12)) throw new TypeError("Cannot call a class as a function");
    }(this, e14), this.hooks = One({ dropTarget: function(e15, t12) {
      n11.clearDropTarget(), n11.dropTargetOptions = t12, zne(e15) ? n11.dropTargetRef = e15 : n11.dropTargetNode = e15, n11.reconnect();
    } }), this.handlerId = null, this.dropTargetRef = null, this.dropTargetOptionsInternal = null, this.lastConnectedHandlerId = null, this.lastConnectedDropTarget = null, this.lastConnectedDropTargetOptions = null, this.backend = t11;
  }
  var t10, n10, r10;
  return t10 = e14, (n10 = [{ key: "reconnect", value: function() {
    var e15 = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
    e15 && this.disconnectDropTarget();
    var t11 = this.dropTarget;
    this.handlerId && (t11 ? e15 && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDropTarget = t11, this.lastConnectedDropTargetOptions = this.dropTargetOptions, this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, t11, this.dropTargetOptions)) : this.lastConnectedDropTarget = t11);
  } }, { key: "receiveHandlerId", value: function(e15) {
    e15 !== this.handlerId && (this.handlerId = e15, this.reconnect());
  } }, { key: "didHandlerIdChange", value: function() {
    return this.lastConnectedHandlerId !== this.handlerId;
  } }, { key: "didDropTargetChange", value: function() {
    return this.lastConnectedDropTarget !== this.dropTarget;
  } }, { key: "didOptionsChange", value: function() {
    return !wne(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
  } }, { key: "disconnectDropTarget", value: function() {
    this.unsubscribeDropTarget && (this.unsubscribeDropTarget(), this.unsubscribeDropTarget = void 0);
  } }, { key: "clearDropTarget", value: function() {
    this.dropTargetRef = null, this.dropTargetNode = null;
  } }, { key: "connectTarget", get: function() {
    return this.dropTarget;
  } }, { key: "dropTargetOptions", get: function() {
    return this.dropTargetOptionsInternal;
  }, set: function(e15) {
    this.dropTargetOptionsInternal = e15;
  } }, { key: "dropTarget", get: function() {
    return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
  } }]) && Kne(t10.prototype, n10), r10 && Kne(t10, r10), e14;
}();
function Jne(e14, t10) {
  for (var n10 = 0; n10 < t10.length; n10++) {
    var r10 = t10[n10];
    r10.enumerable = r10.enumerable || false, r10.configurable = true, "value" in r10 && (r10.writable = true), Object.defineProperty(e14, r10.key, r10);
  }
}
var Qne = false;
var ere = function() {
  function e14(t11) {
    !function(e15, t12) {
      if (!(e15 instanceof t12)) throw new TypeError("Cannot call a class as a function");
    }(this, e14), this.targetId = null, this.internalMonitor = t11.getMonitor();
  }
  var t10, n10, r10;
  return t10 = e14, (n10 = [{ key: "receiveHandlerId", value: function(e15) {
    this.targetId = e15;
  } }, { key: "getHandlerId", value: function() {
    return this.targetId;
  } }, { key: "subscribeToStateChange", value: function(e15, t11) {
    return this.internalMonitor.subscribeToStateChange(e15, t11);
  } }, { key: "canDrop", value: function() {
    if (!this.targetId) return false;
    ete(!Qne, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
    try {
      return Qne = true, this.internalMonitor.canDropOnTarget(this.targetId);
    } finally {
      Qne = false;
    }
  } }, { key: "isOver", value: function(e15) {
    return !!this.targetId && this.internalMonitor.isOverTarget(this.targetId, e15);
  } }, { key: "getItemType", value: function() {
    return this.internalMonitor.getItemType();
  } }, { key: "getItem", value: function() {
    return this.internalMonitor.getItem();
  } }, { key: "getDropResult", value: function() {
    return this.internalMonitor.getDropResult();
  } }, { key: "didDrop", value: function() {
    return this.internalMonitor.didDrop();
  } }, { key: "getInitialClientOffset", value: function() {
    return this.internalMonitor.getInitialClientOffset();
  } }, { key: "getInitialSourceClientOffset", value: function() {
    return this.internalMonitor.getInitialSourceClientOffset();
  } }, { key: "getSourceClientOffset", value: function() {
    return this.internalMonitor.getSourceClientOffset();
  } }, { key: "getClientOffset", value: function() {
    return this.internalMonitor.getClientOffset();
  } }, { key: "getDifferenceFromInitialOffset", value: function() {
    return this.internalMonitor.getDifferenceFromInitialOffset();
  } }]) && Jne(t10.prototype, n10), r10 && Jne(t10, r10), e14;
}();
function tre(e14, t10) {
  return function(e15) {
    if (Array.isArray(e15)) return e15;
  }(e14) || function(e15, t11) {
    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e15))) return;
    var n10 = [];
    var r10 = true;
    var o10 = false;
    var a10 = void 0;
    try {
      for (var i10, s10 = e15[Symbol.iterator](); !(r10 = (i10 = s10.next()).done) && (n10.push(i10.value), !t11 || n10.length !== t11); r10 = true) ;
    } catch (e16) {
      o10 = true, a10 = e16;
    } finally {
      try {
        r10 || null == s10.return || s10.return();
      } finally {
        if (o10) throw a10;
      }
    }
    return n10;
  }(e14, t10) || function(e15, t11) {
    if (!e15) return;
    if ("string" == typeof e15) return nre(e15, t11);
    var n10 = Object.prototype.toString.call(e15).slice(8, -1);
    "Object" === n10 && e15.constructor && (n10 = e15.constructor.name);
    if ("Map" === n10 || "Set" === n10) return Array.from(e15);
    if ("Arguments" === n10 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n10)) return nre(e15, t11);
  }(e14, t10) || function() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function nre(e14, t10) {
  (null == t10 || t10 > e14.length) && (t10 = e14.length);
  for (var n10 = 0, r10 = new Array(t10); n10 < t10; n10++) r10[n10] = e14[n10];
  return r10;
}
function rre(e14, t10) {
  return function(e15) {
    if (Array.isArray(e15)) return e15;
  }(e14) || function(e15, t11) {
    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e15))) return;
    var n10 = [];
    var r10 = true;
    var o10 = false;
    var a10 = void 0;
    try {
      for (var i10, s10 = e15[Symbol.iterator](); !(r10 = (i10 = s10.next()).done) && (n10.push(i10.value), !t11 || n10.length !== t11); r10 = true) ;
    } catch (e16) {
      o10 = true, a10 = e16;
    } finally {
      try {
        r10 || null == s10.return || s10.return();
      } finally {
        if (o10) throw a10;
      }
    }
    return n10;
  }(e14, t10) || function(e15, t11) {
    if (!e15) return;
    if ("string" == typeof e15) return ore(e15, t11);
    var n10 = Object.prototype.toString.call(e15).slice(8, -1);
    "Object" === n10 && e15.constructor && (n10 = e15.constructor.name);
    if ("Map" === n10 || "Set" === n10) return Array.from(e15);
    if ("Arguments" === n10 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n10)) return ore(e15, t11);
  }(e14, t10) || function() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function ore(e14, t10) {
  (null == t10 || t10 > e14.length) && (t10 = e14.length);
  for (var n10 = 0, r10 = new Array(t10); n10 < t10; n10++) r10[n10] = e14[n10];
  return r10;
}
function are(e14) {
  var t10 = ep.useRef(e14);
  t10.current = e14, ete(null != e14.accept, "accept must be defined");
  var n10 = rre((a10 = Lne(), [ep.useMemo(function() {
    return new ere(a10);
  }, [a10]), ep.useMemo(function() {
    return new Xne(a10.getBackend());
  }, [a10])]), 2), r10 = n10[0], o10 = n10[1];
  var a10;
  !function(e15, t11, n11) {
    var r11 = Lne();
    var o11 = ep.useMemo(function() {
      return { canDrop: function() {
        var n12 = e15.current.canDrop;
        return !n12 || n12(t11.getItem(), t11);
      }, hover: function() {
        var n12 = e15.current.hover;
        n12 && n12(t11.getItem(), t11);
      }, drop: function() {
        var n12 = e15.current.drop;
        if (n12) return n12(t11.getItem(), t11);
      } };
    }, [t11]);
    xne(function() {
      var a11 = tre(Nne(e15.current.accept, o11, r11), 2), i11 = a11[0], s11 = a11[1];
      return t11.receiveHandlerId(i11), n11.receiveHandlerId(i11), s11;
    }, [t11, n11]);
  }(t10, r10, o10);
  var i10 = Pne(r10, t10.current.collect || function() {
    return {};
  }, function() {
    return o10.reconnect();
  });
  var s10 = ep.useMemo(function() {
    return o10.hooks.dropTarget();
  }, [o10]);
  return xne(function() {
    o10.dropTargetOptions = e14.options || null, o10.reconnect();
  }, [e14.options]), [i10, s10];
}
function ire(e14, t10) {
  return function(e15) {
    if (Array.isArray(e15)) return e15;
  }(e14) || function(e15, t11) {
    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e15))) return;
    var n10 = [];
    var r10 = true;
    var o10 = false;
    var a10 = void 0;
    try {
      for (var i10, s10 = e15[Symbol.iterator](); !(r10 = (i10 = s10.next()).done) && (n10.push(i10.value), !t11 || n10.length !== t11); r10 = true) ;
    } catch (e16) {
      o10 = true, a10 = e16;
    } finally {
      try {
        r10 || null == s10.return || s10.return();
      } finally {
        if (o10) throw a10;
      }
    }
    return n10;
  }(e14, t10) || function(e15, t11) {
    if (!e15) return;
    if ("string" == typeof e15) return sre(e15, t11);
    var n10 = Object.prototype.toString.call(e15).slice(8, -1);
    "Object" === n10 && e15.constructor && (n10 = e15.constructor.name);
    if ("Map" === n10 || "Set" === n10) return Array.from(e15);
    if ("Arguments" === n10 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n10)) return sre(e15, t11);
  }(e14, t10) || function() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function sre(e14, t10) {
  (null == t10 || t10 > e14.length) && (t10 = e14.length);
  for (var n10 = 0, r10 = new Array(t10); n10 < t10; n10++) r10[n10] = e14[n10];
  return r10;
}
function lre(e14) {
  return lre = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e15) {
    return typeof e15;
  } : function(e15) {
    return e15 && "function" == typeof Symbol && e15.constructor === Symbol && e15 !== Symbol.prototype ? "symbol" : typeof e15;
  }, lre(e14);
}
function cre(e14) {
  return "function" == typeof e14;
}
function ure() {
}
function dre(e14) {
  if (!function(e15) {
    return "object" === lre(e15) && null !== e15;
  }(e14)) return false;
  if (null === Object.getPrototypeOf(e14)) return true;
  var t10 = e14;
  for (; null !== Object.getPrototypeOf(t10); ) t10 = Object.getPrototypeOf(t10);
  return Object.getPrototypeOf(e14) === t10;
}
function pre(e14) {
  var t10 = e14.current;
  return null == t10 ? null : t10.decoratedRef ? t10.decoratedRef.current : t10;
}
function mre(e14) {
  return function(e15) {
    return e15 && e15.prototype && "function" == typeof e15.prototype.render;
  }(e14) || function(e15) {
    var t10;
    var n10 = e15;
    return "Symbol(react.forward_ref)" === (null == n10 || null === (t10 = n10.$$typeof) || void 0 === t10 ? void 0 : t10.toString());
  }(e14);
}
function hre(e14, t10) {
  if (!(e14 instanceof t10)) throw new TypeError("Cannot call a class as a function");
}
function fre(e14, t10) {
  for (var n10 = 0; n10 < t10.length; n10++) {
    var r10 = t10[n10];
    r10.enumerable = r10.enumerable || false, r10.configurable = true, "value" in r10 && (r10.writable = true), Object.defineProperty(e14, r10.key, r10);
  }
}
function gre(e14, t10, n10) {
  return t10 && fre(e14.prototype, t10), n10 && fre(e14, n10), e14;
}
var yre = function() {
  var e14 = function() {
    function e15(t10) {
      hre(this, e15), this.isDisposed = false, this.action = cre(t10) ? t10 : ure;
    }
    return gre(e15, [{ key: "dispose", value: function() {
      this.isDisposed || (this.action(), this.isDisposed = true);
    } }], [{ key: "isDisposable", value: function(e16) {
      return Boolean(e16 && cre(e16.dispose));
    } }, { key: "_fixup", value: function(t10) {
      return e15.isDisposable(t10) ? t10 : e15.empty;
    } }, { key: "create", value: function(t10) {
      return new e15(t10);
    } }]), e15;
  }();
  return e14.empty = { dispose: ure }, e14;
}();
var vre = function() {
  function e14() {
    hre(this, e14), this.isDisposed = false;
    for (var t10 = arguments.length, n10 = new Array(t10), r10 = 0; r10 < t10; r10++) n10[r10] = arguments[r10];
    this.disposables = n10;
  }
  return gre(e14, [{ key: "add", value: function(e15) {
    this.isDisposed ? e15.dispose() : this.disposables.push(e15);
  } }, { key: "remove", value: function(e15) {
    var t10 = false;
    if (!this.isDisposed) {
      var n10 = this.disposables.indexOf(e15);
      -1 !== n10 && (t10 = true, this.disposables.splice(n10, 1), e15.dispose());
    }
    return t10;
  } }, { key: "clear", value: function() {
    if (!this.isDisposed) {
      var e15 = this.disposables.length;
      var t10 = new Array(e15);
      for (var n10 = 0; n10 < e15; n10++) t10[n10] = this.disposables[n10];
      this.disposables = [];
      for (var r10 = 0; r10 < e15; r10++) t10[r10].dispose();
    }
  } }, { key: "dispose", value: function() {
    if (!this.isDisposed) {
      this.isDisposed = true;
      var e15 = this.disposables.length;
      var t10 = new Array(e15);
      for (var n10 = 0; n10 < e15; n10++) t10[n10] = this.disposables[n10];
      this.disposables = [];
      for (var r10 = 0; r10 < e15; r10++) t10[r10].dispose();
    }
  } }]), e14;
}();
var bre = function() {
  function e14() {
    hre(this, e14), this.isDisposed = false;
  }
  return gre(e14, [{ key: "getDisposable", value: function() {
    return this.current;
  } }, { key: "setDisposable", value: function(e15) {
    var t10 = this.isDisposed;
    if (!t10) {
      var n10 = this.current;
      this.current = e15, n10 && n10.dispose();
    }
    t10 && e15 && e15.dispose();
  } }, { key: "dispose", value: function() {
    if (!this.isDisposed) {
      this.isDisposed = true;
      var e15 = this.current;
      this.current = void 0, e15 && e15.dispose();
    }
  } }]), e14;
}();
function Sre(e14) {
  return Sre = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e15) {
    return typeof e15;
  } : function(e15) {
    return e15 && "function" == typeof Symbol && e15.constructor === Symbol && e15 !== Symbol.prototype ? "symbol" : typeof e15;
  }, Sre(e14);
}
function Cre(e14, t10) {
  return function(e15) {
    if (Array.isArray(e15)) return e15;
  }(e14) || function(e15, t11) {
    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e15))) return;
    var n10 = [];
    var r10 = true;
    var o10 = false;
    var a10 = void 0;
    try {
      for (var i10, s10 = e15[Symbol.iterator](); !(r10 = (i10 = s10.next()).done) && (n10.push(i10.value), !t11 || n10.length !== t11); r10 = true) ;
    } catch (e16) {
      o10 = true, a10 = e16;
    } finally {
      try {
        r10 || null == s10.return || s10.return();
      } finally {
        if (o10) throw a10;
      }
    }
    return n10;
  }(e14, t10) || function(e15, t11) {
    if (!e15) return;
    if ("string" == typeof e15) return xre(e15, t11);
    var n10 = Object.prototype.toString.call(e15).slice(8, -1);
    "Object" === n10 && e15.constructor && (n10 = e15.constructor.name);
    if ("Map" === n10 || "Set" === n10) return Array.from(e15);
    if ("Arguments" === n10 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n10)) return xre(e15, t11);
  }(e14, t10) || function() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function xre(e14, t10) {
  (null == t10 || t10 > e14.length) && (t10 = e14.length);
  for (var n10 = 0, r10 = new Array(t10); n10 < t10; n10++) r10[n10] = e14[n10];
  return r10;
}
function wre(e14, t10) {
  for (var n10 = 0; n10 < t10.length; n10++) {
    var r10 = t10[n10];
    r10.enumerable = r10.enumerable || false, r10.configurable = true, "value" in r10 && (r10.writable = true), Object.defineProperty(e14, r10.key, r10);
  }
}
function Tre(e14, t10) {
  return Tre = Object.setPrototypeOf || function(e15, t11) {
    return e15.__proto__ = t11, e15;
  }, Tre(e14, t10);
}
function Ere(e14) {
  var t10 = function() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if ("function" == typeof Proxy) return true;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), true;
    } catch (e15) {
      return false;
    }
  }();
  return function() {
    var n10, r10 = Fre(e14);
    if (t10) {
      var o10 = Fre(this).constructor;
      n10 = Reflect.construct(r10, arguments, o10);
    } else n10 = r10.apply(this, arguments);
    return function(e15, t11) {
      if (t11 && ("object" === Sre(t11) || "function" == typeof t11)) return t11;
      return function(e16) {
        if (void 0 === e16) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e16;
      }(e15);
    }(this, n10);
  };
}
function Fre(e14) {
  return Fre = Object.setPrototypeOf ? Object.getPrototypeOf : function(e15) {
    return e15.__proto__ || Object.getPrototypeOf(e15);
  }, Fre(e14);
}
function Mre(e14) {
  var t10 = e14.DecoratedComponent, n10 = e14.createHandler, r10 = e14.createMonitor, o10 = e14.createConnector, a10 = e14.registerHandler, i10 = e14.containerDisplayName, s10 = e14.getType, l10 = e14.collect;
  var c10 = e14.options.arePropsEqual, u10 = void 0 === c10 ? wne : c10;
  var d10 = t10;
  var p10 = t10.displayName || t10.name || "Component";
  var m10 = function() {
    var e15 = function(e16) {
      !function(e17, t12) {
        if ("function" != typeof t12 && null !== t12) throw new TypeError("Super expression must either be null or a function");
        e17.prototype = Object.create(t12 && t12.prototype, { constructor: { value: e17, writable: true, configurable: true } }), t12 && Tre(e17, t12);
      }(i11, ep.Component);
      var t11 = Ere(i11);
      function i11(e17) {
        var n11;
        return function(e18, t12) {
          if (!(e18 instanceof t12)) throw new TypeError("Cannot call a class as a function");
        }(this, i11), (n11 = t11.call(this, e17)).decoratedRef = ep.createRef(), n11.handleChange = function() {
          var e18 = n11.getCurrentState();
          wne(e18, n11.state) || n11.setState(e18);
        }, n11.disposable = new bre(), n11.receiveProps(e17), n11.dispose(), n11;
      }
      var c11, m11, h10;
      return c11 = i11, m11 = [{ key: "getHandlerId", value: function() {
        return this.handlerId;
      } }, { key: "getDecoratedComponentInstance", value: function() {
        return ete(this.decoratedRef.current, "In order to access an instance of the decorated component, it must either be a class component or use React.forwardRef()"), this.decoratedRef.current;
      } }, { key: "shouldComponentUpdate", value: function(e17, t12) {
        return !u10(e17, this.props) || !wne(t12, this.state);
      } }, { key: "componentDidMount", value: function() {
        this.disposable = new bre(), this.currentType = void 0, this.receiveProps(this.props), this.handleChange();
      } }, { key: "componentDidUpdate", value: function(e17) {
        u10(this.props, e17) || (this.receiveProps(this.props), this.handleChange());
      } }, { key: "componentWillUnmount", value: function() {
        this.dispose();
      } }, { key: "receiveProps", value: function(e17) {
        this.handler && (this.handler.receiveProps(e17), this.receiveType(s10(e17)));
      } }, { key: "receiveType", value: function(e17) {
        if (this.handlerMonitor && this.manager && this.handlerConnector && e17 !== this.currentType) {
          this.currentType = e17;
          var t12 = Cre(a10(e17, this.handler, this.manager), 2), n11 = t12[0], r11 = t12[1];
          this.handlerId = n11, this.handlerMonitor.receiveHandlerId(n11), this.handlerConnector.receiveHandlerId(n11);
          var o11 = this.manager.getMonitor().subscribeToStateChange(this.handleChange, { handlerIds: [n11] });
          this.disposable.setDisposable(new vre(new yre(o11), new yre(r11)));
        }
      } }, { key: "dispose", value: function() {
        this.disposable.dispose(), this.handlerConnector && this.handlerConnector.receiveHandlerId(null);
      } }, { key: "getCurrentState", value: function() {
        return this.handlerConnector ? l10(this.handlerConnector.hooks, this.handlerMonitor, this.props) : {};
      } }, { key: "render", value: function() {
        var e17 = this;
        return ep.createElement(hne.Consumer, null, function(t12) {
          var n11 = t12.dragDropManager;
          return e17.receiveDragDropManager(n11), "undefined" != typeof requestAnimationFrame && requestAnimationFrame(function() {
            var t13;
            return null === (t13 = e17.handlerConnector) || void 0 === t13 ? void 0 : t13.reconnect();
          }), ep.createElement(d10, Object.assign({}, e17.props, e17.getCurrentState(), { ref: mre(d10) ? e17.decoratedRef : null }));
        });
      } }, { key: "receiveDragDropManager", value: function(e17) {
        void 0 === this.manager && (ete(void 0 !== e17, "Could not find the drag and drop manager in the context of %s. Make sure to render a DndProvider component in your top-level component. Read more: http://react-dnd.github.io/react-dnd/docs/troubleshooting#could-not-find-the-drag-and-drop-manager-in-the-context", p10, p10), void 0 !== e17 && (this.manager = e17, this.handlerMonitor = r10(e17), this.handlerConnector = o10(e17.getBackend()), this.handler = n10(this.handlerMonitor, this.decoratedRef)));
      } }], m11 && wre(c11.prototype, m11), h10 && wre(c11, h10), i11;
    }();
    return e15.DecoratedComponent = t10, e15.displayName = "".concat(i10, "(").concat(p10, ")"), e15;
  }();
  return WR(m10, t10);
}
function kre(e14) {
  return kre = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e15) {
    return typeof e15;
  } : function(e15) {
    return e15 && "function" == typeof Symbol && e15.constructor === Symbol && e15 !== Symbol.prototype ? "symbol" : typeof e15;
  }, kre(e14);
}
function Pre(e14, t10) {
  return "string" == typeof e14 || "symbol" === kre(e14) || !!t10 && Array.isArray(e14) && e14.every(function(e15) {
    return Pre(e15, false);
  });
}
function Nre(e14, t10) {
  for (var n10 = 0; n10 < t10.length; n10++) {
    var r10 = t10[n10];
    r10.enumerable = r10.enumerable || false, r10.configurable = true, "value" in r10 && (r10.writable = true), Object.defineProperty(e14, r10.key, r10);
  }
}
var Dre = ["canDrag", "beginDrag", "isDragging", "endDrag"];
var Lre = ["beginDrag"];
var Hre = function() {
  function e14(t11, n11, r11) {
    var o10 = this;
    !function(e15, t12) {
      if (!(e15 instanceof t12)) throw new TypeError("Cannot call a class as a function");
    }(this, e14), this.props = null, this.beginDrag = function() {
      if (o10.props) return o10.spec.beginDrag(o10.props, o10.monitor, o10.ref.current);
    }, this.spec = t11, this.monitor = n11, this.ref = r11;
  }
  var t10, n10, r10;
  return t10 = e14, (n10 = [{ key: "receiveProps", value: function(e15) {
    this.props = e15;
  } }, { key: "canDrag", value: function() {
    return !!this.props && (!this.spec.canDrag || this.spec.canDrag(this.props, this.monitor));
  } }, { key: "isDragging", value: function(e15, t11) {
    return !!this.props && (this.spec.isDragging ? this.spec.isDragging(this.props, this.monitor) : t11 === e15.getSourceId());
  } }, { key: "endDrag", value: function() {
    this.props && this.spec.endDrag && this.spec.endDrag(this.props, this.monitor, pre(this.ref));
  } }]) && Nre(t10.prototype, n10), r10 && Nre(t10, r10), e14;
}();
function Ire(e14, t10, n10) {
  var r10 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
  var o10 = e14;
  "function" != typeof e14 && (ete(Pre(e14), 'Expected "type" provided as the first argument to DragSource to be a string, or a function that returns a string given the current props. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', e14), o10 = function() {
    return e14;
  }), ete(dre(t10), 'Expected "spec" provided as the second argument to DragSource to be a plain object. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', t10);
  var a10 = function(e15) {
    return Object.keys(e15).forEach(function(t11) {
      ete(Dre.indexOf(t11) > -1, 'Expected the drag source specification to only have some of the following keys: %s. Instead received a specification with an unexpected "%s" key. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', Dre.join(", "), t11), ete("function" == typeof e15[t11], "Expected %s in the drag source specification to be a function. Instead received a specification with %s: %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source", t11, t11, e15[t11]);
    }), Lre.forEach(function(t11) {
      ete("function" == typeof e15[t11], "Expected %s in the drag source specification to be a function. Instead received a specification with %s: %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source", t11, t11, e15[t11]);
    }), function(t11, n11) {
      return new Hre(e15, t11, n11);
    };
  }(t10);
  return ete("function" == typeof n10, 'Expected "collect" provided as the third argument to DragSource to be a function that returns a plain object of props to inject. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', n10), ete(dre(r10), 'Expected "options" provided as the fourth argument to DragSource to be a plain object when specified. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', n10), function(e15) {
    return Mre({ containerDisplayName: "DragSource", createHandler: a10, registerHandler: Dne, createConnector: function(e16) {
      return new Wne(e16);
    }, createMonitor: function(e16) {
      return new Vne(e16);
    }, DecoratedComponent: e15, getType: o10, collect: n10, options: r10 });
  };
}
function _re(e14, t10) {
  for (var n10 = 0; n10 < t10.length; n10++) {
    var r10 = t10[n10];
    r10.enumerable = r10.enumerable || false, r10.configurable = true, "value" in r10 && (r10.writable = true), Object.defineProperty(e14, r10.key, r10);
  }
}
var Vre = ["canDrop", "hover", "drop"];
var Rre = function() {
  function e14(t11, n11, r11) {
    !function(e15, t12) {
      if (!(e15 instanceof t12)) throw new TypeError("Cannot call a class as a function");
    }(this, e14), this.props = null, this.spec = t11, this.monitor = n11, this.ref = r11;
  }
  var t10, n10, r10;
  return t10 = e14, (n10 = [{ key: "receiveProps", value: function(e15) {
    this.props = e15;
  } }, { key: "receiveMonitor", value: function(e15) {
    this.monitor = e15;
  } }, { key: "canDrop", value: function() {
    return !this.spec.canDrop || this.spec.canDrop(this.props, this.monitor);
  } }, { key: "hover", value: function() {
    this.spec.hover && this.props && this.spec.hover(this.props, this.monitor, pre(this.ref));
  } }, { key: "drop", value: function() {
    if (this.spec.drop) return this.spec.drop(this.props, this.monitor, this.ref.current);
  } }]) && _re(t10.prototype, n10), r10 && _re(t10, r10), e14;
}();
function Are(e14, t10, n10) {
  var r10 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
  var o10 = e14;
  "function" != typeof e14 && (ete(Pre(e14, true), 'Expected "type" provided as the first argument to DropTarget to be a string, an array of strings, or a function that returns either given the current props. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', e14), o10 = function() {
    return e14;
  }), ete(dre(t10), 'Expected "spec" provided as the second argument to DropTarget to be a plain object. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', t10);
  var a10 = function(e15) {
    return Object.keys(e15).forEach(function(t11) {
      ete(Vre.indexOf(t11) > -1, 'Expected the drop target specification to only have some of the following keys: %s. Instead received a specification with an unexpected "%s" key. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', Vre.join(", "), t11), ete("function" == typeof e15[t11], "Expected %s in the drop target specification to be a function. Instead received a specification with %s: %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target", t11, t11, e15[t11]);
    }), function(t11, n11) {
      return new Rre(e15, t11, n11);
    };
  }(t10);
  return ete("function" == typeof n10, 'Expected "collect" provided as the third argument to DropTarget to be a function that returns a plain object of props to inject. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', n10), ete(dre(r10), 'Expected "options" provided as the fourth argument to DropTarget to be a plain object when specified. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', n10), function(e15) {
    return Mre({ containerDisplayName: "DropTarget", createHandler: a10, registerHandler: Nne, createMonitor: function(e16) {
      return new ere(e16);
    }, createConnector: function(e16) {
      return new Xne(e16);
    }, DecoratedComponent: e15, getType: o10, collect: n10, options: r10 });
  };
}
function Ore(e14) {
  return Ore = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e15) {
    return typeof e15;
  } : function(e15) {
    return e15 && "function" == typeof Symbol && e15.constructor === Symbol && e15 !== Symbol.prototype ? "symbol" : typeof e15;
  }, Ore(e14);
}
function Bre(e14, t10) {
  for (var n10 = 0; n10 < t10.length; n10++) {
    var r10 = t10[n10];
    r10.enumerable = r10.enumerable || false, r10.configurable = true, "value" in r10 && (r10.writable = true), Object.defineProperty(e14, r10.key, r10);
  }
}
function zre(e14, t10) {
  return zre = Object.setPrototypeOf || function(e15, t11) {
    return e15.__proto__ = t11, e15;
  }, zre(e14, t10);
}
function $re(e14) {
  var t10 = function() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if ("function" == typeof Proxy) return true;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), true;
    } catch (e15) {
      return false;
    }
  }();
  return function() {
    var n10, r10 = Wre(e14);
    if (t10) {
      var o10 = Wre(this).constructor;
      n10 = Reflect.construct(r10, arguments, o10);
    } else n10 = r10.apply(this, arguments);
    return function(e15, t11) {
      if (t11 && ("object" === Ore(t11) || "function" == typeof t11)) return t11;
      return function(e16) {
        if (void 0 === e16) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e16;
      }(e15);
    }(this, n10);
  };
}
function Wre(e14) {
  return Wre = Object.setPrototypeOf ? Object.getPrototypeOf : function(e15) {
    return e15.__proto__ || Object.getPrototypeOf(e15);
  }, Wre(e14);
}
function jre(e14) {
  var t10 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  return ete("function" == typeof e14, 'Expected "collect" provided as the first argument to DragLayer to be a function that collects props to inject into the component. ', "Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-layer", e14), ete(dre(t10), 'Expected "options" provided as the second argument to DragLayer to be a plain object when specified. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-layer', t10), function(n10) {
    var r10 = n10;
    var o10 = t10.arePropsEqual, a10 = void 0 === o10 ? wne : o10;
    var i10 = r10.displayName || r10.name || "Component";
    var s10 = function() {
      var t11 = function(t12) {
        !function(e15, t13) {
          if ("function" != typeof t13 && null !== t13) throw new TypeError("Super expression must either be null or a function");
          e15.prototype = Object.create(t13 && t13.prototype, { constructor: { value: e15, writable: true, configurable: true } }), t13 && zre(e15, t13);
        }(o11, ep.Component);
        var n11 = $re(o11);
        function o11() {
          var e15;
          return function(e16, t13) {
            if (!(e16 instanceof t13)) throw new TypeError("Cannot call a class as a function");
          }(this, o11), (e15 = n11.apply(this, arguments)).isCurrentlyMounted = false, e15.ref = ep.createRef(), e15.handleChange = function() {
            if (e15.isCurrentlyMounted) {
              var t13 = e15.getCurrentState();
              wne(t13, e15.state) || e15.setState(t13);
            }
          }, e15;
        }
        var s11, l10, c10;
        return s11 = o11, (l10 = [{ key: "getDecoratedComponentInstance", value: function() {
          return ete(this.ref.current, "In order to access an instance of the decorated component, it must either be a class component or use React.forwardRef()"), this.ref.current;
        } }, { key: "shouldComponentUpdate", value: function(e15, t13) {
          return !a10(e15, this.props) || !wne(t13, this.state);
        } }, { key: "componentDidMount", value: function() {
          this.isCurrentlyMounted = true, this.handleChange();
        } }, { key: "componentWillUnmount", value: function() {
          this.isCurrentlyMounted = false, this.unsubscribeFromOffsetChange && (this.unsubscribeFromOffsetChange(), this.unsubscribeFromOffsetChange = void 0), this.unsubscribeFromStateChange && (this.unsubscribeFromStateChange(), this.unsubscribeFromStateChange = void 0);
        } }, { key: "render", value: function() {
          var e15 = this;
          return ep.createElement(hne.Consumer, null, function(t13) {
            var n12 = t13.dragDropManager;
            return void 0 === n12 ? null : (e15.receiveDragDropManager(n12), e15.isCurrentlyMounted ? ep.createElement(r10, Object.assign({}, e15.props, e15.state, { ref: mre(r10) ? e15.ref : null })) : null);
          });
        } }, { key: "receiveDragDropManager", value: function(e15) {
          if (void 0 === this.manager) {
            this.manager = e15, ete("object" === Ore(e15), "Could not find the drag and drop manager in the context of %s. Make sure to render a DndProvider component in your top-level component. Read more: http://react-dnd.github.io/react-dnd/docs/troubleshooting#could-not-find-the-drag-and-drop-manager-in-the-context", i10, i10);
            var t13 = this.manager.getMonitor();
            this.unsubscribeFromOffsetChange = t13.subscribeToOffsetChange(this.handleChange), this.unsubscribeFromStateChange = t13.subscribeToStateChange(this.handleChange);
          }
        } }, { key: "getCurrentState", value: function() {
          if (!this.manager) return {};
          var t13 = this.manager.getMonitor();
          return e14(t13, this.props);
        } }]) && Bre(s11.prototype, l10), c10 && Bre(s11, c10), o11;
      }();
      return t11.displayName = "DragLayer(".concat(i10, ")"), t11.DecoratedComponent = n10, t11;
    }();
    return WR(s10, n10);
  };
}
function Zre(e14) {
  var t10 = null;
  return function() {
    return null == t10 && (t10 = e14()), t10;
  };
}
function Gre(e14, t10) {
  for (var n10 = 0; n10 < t10.length; n10++) {
    var r10 = t10[n10];
    r10.enumerable = r10.enumerable || false, r10.configurable = true, "value" in r10 && (r10.writable = true), Object.defineProperty(e14, r10.key, r10);
  }
}
var Ure = function() {
  function e14(t11) {
    !function(e15, t12) {
      if (!(e15 instanceof t12)) throw new TypeError("Cannot call a class as a function");
    }(this, e14), this.entered = [], this.isNodeInDocument = t11;
  }
  var t10, n10, r10;
  return t10 = e14, n10 = [{ key: "enter", value: function(e15) {
    var t11 = this;
    var n11 = this.entered.length;
    return this.entered = function(e16, t12) {
      var n12 = /* @__PURE__ */ new Set();
      var r11 = function(e17) {
        return n12.add(e17);
      };
      e16.forEach(r11), t12.forEach(r11);
      var o10 = [];
      return n12.forEach(function(e17) {
        return o10.push(e17);
      }), o10;
    }(this.entered.filter(function(n12) {
      return t11.isNodeInDocument(n12) && (!n12.contains || n12.contains(e15));
    }), [e15]), 0 === n11 && this.entered.length > 0;
  } }, { key: "leave", value: function(e15) {
    var t11 = this.entered.length;
    return this.entered = function(e16, t12) {
      return e16.filter(function(e17) {
        return e17 !== t12;
      });
    }(this.entered.filter(this.isNodeInDocument), e15), t11 > 0 && 0 === this.entered.length;
  } }, { key: "reset", value: function() {
    this.entered = [];
  } }], n10 && Gre(t10.prototype, n10), r10 && Gre(t10, r10), e14;
}();
var qre = Zre(function() {
  return /firefox/i.test(navigator.userAgent);
});
var Yre = Zre(function() {
  return Boolean(window.safari);
});
function Kre(e14, t10) {
  for (var n10 = 0; n10 < t10.length; n10++) {
    var r10 = t10[n10];
    r10.enumerable = r10.enumerable || false, r10.configurable = true, "value" in r10 && (r10.writable = true), Object.defineProperty(e14, r10.key, r10);
  }
}
var Xre = function() {
  function e14(t11, n11) {
    !function(e15, t12) {
      if (!(e15 instanceof t12)) throw new TypeError("Cannot call a class as a function");
    }(this, e14);
    var r11 = t11.length;
    var o10 = [];
    for (var a10 = 0; a10 < r11; a10++) o10.push(a10);
    o10.sort(function(e15, n12) {
      return t11[e15] < t11[n12] ? -1 : 1;
    });
    var i10 = [];
    var s10 = [];
    var l10;
    var c10;
    for (var u10 = 0; u10 < r11 - 1; u10++) l10 = t11[u10 + 1] - t11[u10], c10 = n11[u10 + 1] - n11[u10], i10.push(l10), s10.push(c10 / l10);
    var d10 = [s10[0]];
    for (var p10 = 0; p10 < i10.length - 1; p10++) {
      var m10 = s10[p10];
      var h10 = s10[p10 + 1];
      if (m10 * h10 <= 0) d10.push(0);
      else {
        l10 = i10[p10];
        var f10 = i10[p10 + 1];
        var g10 = l10 + f10;
        d10.push(3 * g10 / ((g10 + f10) / m10 + (g10 + l10) / h10));
      }
    }
    d10.push(s10[s10.length - 1]);
    var y10 = [];
    var v10 = [];
    var b10;
    for (var S10 = 0; S10 < d10.length - 1; S10++) {
      b10 = s10[S10];
      var C10 = d10[S10];
      var x10 = 1 / i10[S10];
      var w10 = C10 + d10[S10 + 1] - b10 - b10;
      y10.push((b10 - C10 - w10) * x10), v10.push(w10 * x10 * x10);
    }
    this.xs = t11, this.ys = n11, this.c1s = d10, this.c2s = y10, this.c3s = v10;
  }
  var t10, n10, r10;
  return t10 = e14, n10 = [{ key: "interpolate", value: function(e15) {
    var t11 = this.xs, n11 = this.ys, r11 = this.c1s, o10 = this.c2s, a10 = this.c3s;
    var i10 = t11.length - 1;
    if (e15 === t11[i10]) return n11[i10];
    var s10 = 0;
    var l10 = a10.length - 1;
    var c10;
    for (; s10 <= l10; ) {
      var u10 = t11[c10 = Math.floor(0.5 * (s10 + l10))];
      if (u10 < e15) s10 = c10 + 1;
      else {
        if (!(u10 > e15)) return n11[c10];
        l10 = c10 - 1;
      }
    }
    var d10 = e15 - t11[i10 = Math.max(0, l10)];
    var p10 = d10 * d10;
    return n11[i10] + r11[i10] * d10 + o10[i10] * p10 + a10[i10] * d10 * p10;
  } }], n10 && Kre(t10.prototype, n10), r10 && Kre(t10, r10), e14;
}();
var Jre = 1;
function Qre(e14) {
  var t10 = e14.nodeType === Jre ? e14 : e14.parentElement;
  if (!t10) return null;
  var n10 = t10.getBoundingClientRect(), r10 = n10.top;
  return { x: n10.left, y: r10 };
}
function eoe(e14) {
  return { x: e14.clientX, y: e14.clientY };
}
function toe(e14, t10, n10, r10, o10) {
  var a10 = "IMG" === (i10 = t10).nodeName && (qre() || !(null === (s10 = document.documentElement) || void 0 === s10 ? void 0 : s10.contains(i10)));
  var i10, s10;
  var l10 = Qre(a10 ? e14 : t10);
  var c10 = { x: n10.x - l10.x, y: n10.y - l10.y };
  var u10 = e14.offsetWidth, d10 = e14.offsetHeight;
  var p10 = r10.anchorX, m10 = r10.anchorY;
  var h10 = function(e15, t11, n11, r11) {
    var o11 = e15 ? t11.width : n11;
    var a11 = e15 ? t11.height : r11;
    return Yre() && e15 && (a11 /= window.devicePixelRatio, o11 /= window.devicePixelRatio), { dragPreviewWidth: o11, dragPreviewHeight: a11 };
  }(a10, t10, u10, d10), f10 = h10.dragPreviewWidth, g10 = h10.dragPreviewHeight;
  var y10 = o10.offsetX, v10 = o10.offsetY;
  var b10 = 0 === v10 || v10;
  return { x: 0 === y10 || y10 ? y10 : new Xre([0, 0.5, 1], [c10.x, c10.x / u10 * f10, c10.x + f10 - u10]).interpolate(p10), y: b10 ? v10 : function() {
    var e15 = new Xre([0, 0.5, 1], [c10.y, c10.y / d10 * g10, c10.y + g10 - d10]).interpolate(m10);
    return Yre() && a10 && (e15 += (window.devicePixelRatio - 1) * g10), e15;
  }() };
}
var noe = "__NATIVE_FILE__";
var roe = "__NATIVE_URL__";
var ooe = "__NATIVE_TEXT__";
var aoe = Object.freeze({ __proto__: null, FILE: noe, URL: roe, TEXT: ooe });
function ioe(e14, t10, n10) {
  var r10 = t10.reduce(function(t11, n11) {
    return t11 || e14.getData(n11);
  }, "");
  return null != r10 ? r10 : n10;
}
var soe;
function loe(e14, t10, n10) {
  return t10 in e14 ? Object.defineProperty(e14, t10, { value: n10, enumerable: true, configurable: true, writable: true }) : e14[t10] = n10, e14;
}
var coe = (loe(soe = {}, noe, { exposeProperties: { files: function(e14) {
  return Array.prototype.slice.call(e14.files);
}, items: function(e14) {
  return e14.items;
} }, matchesTypes: ["Files"] }), loe(soe, roe, { exposeProperties: { urls: function(e14, t10) {
  return ioe(e14, t10, "").split("\n");
} }, matchesTypes: ["Url", "text/uri-list"] }), loe(soe, ooe, { exposeProperties: { text: function(e14, t10) {
  return ioe(e14, t10, "");
} }, matchesTypes: ["Text", "text/plain"] }), soe);
function uoe(e14, t10) {
  for (var n10 = 0; n10 < t10.length; n10++) {
    var r10 = t10[n10];
    r10.enumerable = r10.enumerable || false, r10.configurable = true, "value" in r10 && (r10.writable = true), Object.defineProperty(e14, r10.key, r10);
  }
}
var doe = function() {
  function e14(t11) {
    !function(e15, t12) {
      if (!(e15 instanceof t12)) throw new TypeError("Cannot call a class as a function");
    }(this, e14), this.config = t11, this.item = {}, this.initializeExposedProperties();
  }
  var t10, n10, r10;
  return t10 = e14, (n10 = [{ key: "initializeExposedProperties", value: function() {
    var e15 = this;
    Object.keys(this.config.exposeProperties).forEach(function(t11) {
      Object.defineProperty(e15.item, t11, { configurable: true, enumerable: true, get: function() {
        return console.warn(`Browser doesn't allow reading "`.concat(t11, '" until the drop event.')), null;
      } });
    });
  } }, { key: "loadDataTransfer", value: function(e15) {
    var t11 = this;
    if (e15) {
      var n11 = {};
      Object.keys(this.config.exposeProperties).forEach(function(r11) {
        n11[r11] = { value: t11.config.exposeProperties[r11](e15, t11.config.matchesTypes), configurable: true, enumerable: true };
      }), Object.defineProperties(this.item, n11);
    }
  } }, { key: "canDrag", value: function() {
    return true;
  } }, { key: "beginDrag", value: function() {
    return this.item;
  } }, { key: "isDragging", value: function(e15, t11) {
    return t11 === e15.getSourceId();
  } }, { key: "endDrag", value: function() {
  } }]) && uoe(t10.prototype, n10), r10 && uoe(t10, r10), e14;
}();
function poe(e14) {
  if (!e14) return null;
  var t10 = Array.prototype.slice.call(e14.types || []);
  return Object.keys(coe).filter(function(e15) {
    return coe[e15].matchesTypes.some(function(e16) {
      return t10.indexOf(e16) > -1;
    });
  })[0] || null;
}
function moe(e14, t10) {
  for (var n10 = 0; n10 < t10.length; n10++) {
    var r10 = t10[n10];
    r10.enumerable = r10.enumerable || false, r10.configurable = true, "value" in r10 && (r10.writable = true), Object.defineProperty(e14, r10.key, r10);
  }
}
var hoe = function() {
  function e14(t11) {
    !function(e15, t12) {
      if (!(e15 instanceof t12)) throw new TypeError("Cannot call a class as a function");
    }(this, e14), this.globalContext = t11;
  }
  var t10, n10, r10;
  return t10 = e14, (n10 = [{ key: "window", get: function() {
    return this.globalContext ? this.globalContext : "undefined" != typeof window ? window : void 0;
  } }, { key: "document", get: function() {
    if (this.window) return this.window.document;
  } }]) && moe(t10.prototype, n10), r10 && moe(t10, r10), e14;
}();
function foe(e14, t10) {
  var n10 = Object.keys(e14);
  if (Object.getOwnPropertySymbols) {
    var r10 = Object.getOwnPropertySymbols(e14);
    t10 && (r10 = r10.filter(function(t11) {
      return Object.getOwnPropertyDescriptor(e14, t11).enumerable;
    })), n10.push.apply(n10, r10);
  }
  return n10;
}
function goe(e14) {
  for (var t10 = 1; t10 < arguments.length; t10++) {
    var n10 = null != arguments[t10] ? arguments[t10] : {};
    t10 % 2 ? foe(Object(n10), true).forEach(function(t11) {
      yoe(e14, t11, n10[t11]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e14, Object.getOwnPropertyDescriptors(n10)) : foe(Object(n10)).forEach(function(t11) {
      Object.defineProperty(e14, t11, Object.getOwnPropertyDescriptor(n10, t11));
    });
  }
  return e14;
}
function yoe(e14, t10, n10) {
  return t10 in e14 ? Object.defineProperty(e14, t10, { value: n10, enumerable: true, configurable: true, writable: true }) : e14[t10] = n10, e14;
}
function voe(e14, t10) {
  for (var n10 = 0; n10 < t10.length; n10++) {
    var r10 = t10[n10];
    r10.enumerable = r10.enumerable || false, r10.configurable = true, "value" in r10 && (r10.writable = true), Object.defineProperty(e14, r10.key, r10);
  }
}
var boe = function() {
  function e14(t11, n11) {
    var r11 = this;
    !function(e15, t12) {
      if (!(e15 instanceof t12)) throw new TypeError("Cannot call a class as a function");
    }(this, e14), this.sourcePreviewNodes = /* @__PURE__ */ new Map(), this.sourcePreviewNodeOptions = /* @__PURE__ */ new Map(), this.sourceNodes = /* @__PURE__ */ new Map(), this.sourceNodeOptions = /* @__PURE__ */ new Map(), this.dragStartSourceIds = null, this.dropTargetIds = [], this.dragEnterTargetIds = [], this.currentNativeSource = null, this.currentNativeHandle = null, this.currentDragSourceNode = null, this.altKeyPressed = false, this.mouseMoveTimeoutTimer = null, this.asyncEndDragFrameId = null, this.dragOverTargetIds = null, this.getSourceClientOffset = function(e15) {
      var t12 = r11.sourceNodes.get(e15);
      return t12 && Qre(t12) || null;
    }, this.endDragNativeItem = function() {
      r11.isDraggingNativeItem() && (r11.actions.endDrag(), r11.currentNativeHandle && r11.registry.removeSource(r11.currentNativeHandle), r11.currentNativeHandle = null, r11.currentNativeSource = null);
    }, this.isNodeInDocument = function(e15) {
      return Boolean(e15 && r11.document && r11.document.body && document.body.contains(e15));
    }, this.endDragIfSourceWasRemovedFromDOM = function() {
      var e15 = r11.currentDragSourceNode;
      r11.isNodeInDocument(e15) || r11.clearCurrentDragSourceNode() && r11.actions.endDrag();
    }, this.handleTopDragStartCapture = function() {
      r11.clearCurrentDragSourceNode(), r11.dragStartSourceIds = [];
    }, this.handleTopDragStart = function(e15) {
      if (!e15.defaultPrevented) {
        var t12 = r11.dragStartSourceIds;
        r11.dragStartSourceIds = null;
        var n12 = eoe(e15);
        r11.monitor.isDragging() && r11.actions.endDrag(), r11.actions.beginDrag(t12 || [], { publishSource: false, getSourceClientOffset: r11.getSourceClientOffset, clientOffset: n12 });
        var o10 = e15.dataTransfer;
        var a10 = poe(o10);
        if (r11.monitor.isDragging()) {
          if (o10 && "function" == typeof o10.setDragImage) {
            var i10 = r11.monitor.getSourceId();
            var s10 = r11.sourceNodes.get(i10);
            var l10 = r11.sourcePreviewNodes.get(i10) || s10;
            if (l10) {
              var c10 = r11.getCurrentSourcePreviewNodeOptions();
              var u10 = toe(s10, l10, n12, { anchorX: c10.anchorX, anchorY: c10.anchorY }, { offsetX: c10.offsetX, offsetY: c10.offsetY });
              o10.setDragImage(l10, u10.x, u10.y);
            }
          }
          try {
            null == o10 || o10.setData("application/json", {});
          } catch (e16) {
          }
          r11.setCurrentDragSourceNode(e15.target), r11.getCurrentSourcePreviewNodeOptions().captureDraggingState ? r11.actions.publishDragSource() : setTimeout(function() {
            return r11.actions.publishDragSource();
          }, 0);
        } else if (a10) r11.beginDragNativeItem(a10);
        else {
          if (o10 && !o10.types && (e15.target && !e15.target.hasAttribute || !e15.target.hasAttribute("draggable"))) return;
          e15.preventDefault();
        }
      }
    }, this.handleTopDragEndCapture = function() {
      r11.clearCurrentDragSourceNode() && r11.actions.endDrag();
    }, this.handleTopDragEnterCapture = function(e15) {
      if (r11.dragEnterTargetIds = [], r11.enterLeaveCounter.enter(e15.target) && !r11.monitor.isDragging()) {
        var t12 = e15.dataTransfer;
        var n12 = poe(t12);
        n12 && r11.beginDragNativeItem(n12, t12);
      }
    }, this.handleTopDragEnter = function(e15) {
      var t12 = r11.dragEnterTargetIds;
      (r11.dragEnterTargetIds = [], r11.monitor.isDragging()) && (r11.altKeyPressed = e15.altKey, qre() || r11.actions.hover(t12, { clientOffset: eoe(e15) }), t12.some(function(e16) {
        return r11.monitor.canDropOnTarget(e16);
      }) && (e15.preventDefault(), e15.dataTransfer && (e15.dataTransfer.dropEffect = r11.getCurrentDropEffect())));
    }, this.handleTopDragOverCapture = function() {
      r11.dragOverTargetIds = [];
    }, this.handleTopDragOver = function(e15) {
      var t12 = r11.dragOverTargetIds;
      if (r11.dragOverTargetIds = [], !r11.monitor.isDragging()) return e15.preventDefault(), void (e15.dataTransfer && (e15.dataTransfer.dropEffect = "none"));
      r11.altKeyPressed = e15.altKey, r11.actions.hover(t12 || [], { clientOffset: eoe(e15) }), (t12 || []).some(function(e16) {
        return r11.monitor.canDropOnTarget(e16);
      }) ? (e15.preventDefault(), e15.dataTransfer && (e15.dataTransfer.dropEffect = r11.getCurrentDropEffect())) : r11.isDraggingNativeItem() ? e15.preventDefault() : (e15.preventDefault(), e15.dataTransfer && (e15.dataTransfer.dropEffect = "none"));
    }, this.handleTopDragLeaveCapture = function(e15) {
      r11.isDraggingNativeItem() && e15.preventDefault(), r11.enterLeaveCounter.leave(e15.target) && r11.isDraggingNativeItem() && r11.endDragNativeItem();
    }, this.handleTopDropCapture = function(e15) {
      var t12;
      (r11.dropTargetIds = [], e15.preventDefault(), r11.isDraggingNativeItem()) && (null === (t12 = r11.currentNativeSource) || void 0 === t12 || t12.loadDataTransfer(e15.dataTransfer));
      r11.enterLeaveCounter.reset();
    }, this.handleTopDrop = function(e15) {
      var t12 = r11.dropTargetIds;
      r11.dropTargetIds = [], r11.actions.hover(t12, { clientOffset: eoe(e15) }), r11.actions.drop({ dropEffect: r11.getCurrentDropEffect() }), r11.isDraggingNativeItem() ? r11.endDragNativeItem() : r11.endDragIfSourceWasRemovedFromDOM();
    }, this.handleSelectStart = function(e15) {
      var t12 = e15.target;
      "function" == typeof t12.dragDrop && ("INPUT" === t12.tagName || "SELECT" === t12.tagName || "TEXTAREA" === t12.tagName || t12.isContentEditable || (e15.preventDefault(), t12.dragDrop()));
    }, this.options = new hoe(n11), this.actions = t11.getActions(), this.monitor = t11.getMonitor(), this.registry = t11.getRegistry(), this.enterLeaveCounter = new Ure(this.isNodeInDocument);
  }
  var t10, n10, r10;
  return t10 = e14, n10 = [{ key: "profile", value: function() {
    var e15, t11;
    return { sourcePreviewNodes: this.sourcePreviewNodes.size, sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size, sourceNodeOptions: this.sourceNodeOptions.size, sourceNodes: this.sourceNodes.size, dragStartSourceIds: (null === (e15 = this.dragStartSourceIds) || void 0 === e15 ? void 0 : e15.length) || 0, dropTargetIds: this.dropTargetIds.length, dragEnterTargetIds: this.dragEnterTargetIds.length, dragOverTargetIds: (null === (t11 = this.dragOverTargetIds) || void 0 === t11 ? void 0 : t11.length) || 0 };
  } }, { key: "setup", value: function() {
    if (void 0 !== this.window) {
      if (this.window.__isReactDndBackendSetUp) throw new Error("Cannot have two HTML5 backends at the same time.");
      this.window.__isReactDndBackendSetUp = true, this.addEventListeners(this.window);
    }
  } }, { key: "teardown", value: function() {
    void 0 !== this.window && (this.window.__isReactDndBackendSetUp = false, this.removeEventListeners(this.window), this.clearCurrentDragSourceNode(), this.asyncEndDragFrameId && this.window.cancelAnimationFrame(this.asyncEndDragFrameId));
  } }, { key: "connectDragPreview", value: function(e15, t11, n11) {
    var r11 = this;
    return this.sourcePreviewNodeOptions.set(e15, n11), this.sourcePreviewNodes.set(e15, t11), function() {
      r11.sourcePreviewNodes.delete(e15), r11.sourcePreviewNodeOptions.delete(e15);
    };
  } }, { key: "connectDragSource", value: function(e15, t11, n11) {
    var r11 = this;
    this.sourceNodes.set(e15, t11), this.sourceNodeOptions.set(e15, n11);
    var o10 = function(t12) {
      return r11.handleDragStart(t12, e15);
    };
    var a10 = function(e16) {
      return r11.handleSelectStart(e16);
    };
    return t11.setAttribute("draggable", "true"), t11.addEventListener("dragstart", o10), t11.addEventListener("selectstart", a10), function() {
      r11.sourceNodes.delete(e15), r11.sourceNodeOptions.delete(e15), t11.removeEventListener("dragstart", o10), t11.removeEventListener("selectstart", a10), t11.setAttribute("draggable", "false");
    };
  } }, { key: "connectDropTarget", value: function(e15, t11) {
    var n11 = this;
    var r11 = function(t12) {
      return n11.handleDragEnter(t12, e15);
    };
    var o10 = function(t12) {
      return n11.handleDragOver(t12, e15);
    };
    var a10 = function(t12) {
      return n11.handleDrop(t12, e15);
    };
    return t11.addEventListener("dragenter", r11), t11.addEventListener("dragover", o10), t11.addEventListener("drop", a10), function() {
      t11.removeEventListener("dragenter", r11), t11.removeEventListener("dragover", o10), t11.removeEventListener("drop", a10);
    };
  } }, { key: "addEventListeners", value: function(e15) {
    e15.addEventListener && (e15.addEventListener("dragstart", this.handleTopDragStart), e15.addEventListener("dragstart", this.handleTopDragStartCapture, true), e15.addEventListener("dragend", this.handleTopDragEndCapture, true), e15.addEventListener("dragenter", this.handleTopDragEnter), e15.addEventListener("dragenter", this.handleTopDragEnterCapture, true), e15.addEventListener("dragleave", this.handleTopDragLeaveCapture, true), e15.addEventListener("dragover", this.handleTopDragOver), e15.addEventListener("dragover", this.handleTopDragOverCapture, true), e15.addEventListener("drop", this.handleTopDrop), e15.addEventListener("drop", this.handleTopDropCapture, true));
  } }, { key: "removeEventListeners", value: function(e15) {
    e15.removeEventListener && (e15.removeEventListener("dragstart", this.handleTopDragStart), e15.removeEventListener("dragstart", this.handleTopDragStartCapture, true), e15.removeEventListener("dragend", this.handleTopDragEndCapture, true), e15.removeEventListener("dragenter", this.handleTopDragEnter), e15.removeEventListener("dragenter", this.handleTopDragEnterCapture, true), e15.removeEventListener("dragleave", this.handleTopDragLeaveCapture, true), e15.removeEventListener("dragover", this.handleTopDragOver), e15.removeEventListener("dragover", this.handleTopDragOverCapture, true), e15.removeEventListener("drop", this.handleTopDrop), e15.removeEventListener("drop", this.handleTopDropCapture, true));
  } }, { key: "getCurrentSourceNodeOptions", value: function() {
    var e15 = this.monitor.getSourceId();
    var t11 = this.sourceNodeOptions.get(e15);
    return goe({ dropEffect: this.altKeyPressed ? "copy" : "move" }, t11 || {});
  } }, { key: "getCurrentDropEffect", value: function() {
    return this.isDraggingNativeItem() ? "copy" : this.getCurrentSourceNodeOptions().dropEffect;
  } }, { key: "getCurrentSourcePreviewNodeOptions", value: function() {
    var e15 = this.monitor.getSourceId();
    return goe({ anchorX: 0.5, anchorY: 0.5, captureDraggingState: false }, this.sourcePreviewNodeOptions.get(e15) || {});
  } }, { key: "isDraggingNativeItem", value: function() {
    var e15 = this.monitor.getItemType();
    return Object.keys(aoe).some(function(t11) {
      return aoe[t11] === e15;
    });
  } }, { key: "beginDragNativeItem", value: function(e15, t11) {
    this.clearCurrentDragSourceNode(), this.currentNativeSource = function(e16, t12) {
      var n11 = new doe(coe[e16]);
      return n11.loadDataTransfer(t12), n11;
    }(e15, t11), this.currentNativeHandle = this.registry.addSource(e15, this.currentNativeSource), this.actions.beginDrag([this.currentNativeHandle]);
  } }, { key: "setCurrentDragSourceNode", value: function(e15) {
    var t11 = this;
    this.clearCurrentDragSourceNode(), this.currentDragSourceNode = e15, this.mouseMoveTimeoutTimer = setTimeout(function() {
      return t11.window && t11.window.addEventListener("mousemove", t11.endDragIfSourceWasRemovedFromDOM, true);
    }, 1e3);
  } }, { key: "clearCurrentDragSourceNode", value: function() {
    return !!this.currentDragSourceNode && (this.currentDragSourceNode = null, this.window && (this.window.clearTimeout(this.mouseMoveTimeoutTimer || void 0), this.window.removeEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, true)), this.mouseMoveTimeoutTimer = null, true);
  } }, { key: "handleDragStart", value: function(e15, t11) {
    e15.defaultPrevented || (this.dragStartSourceIds || (this.dragStartSourceIds = []), this.dragStartSourceIds.unshift(t11));
  } }, { key: "handleDragEnter", value: function(e15, t11) {
    this.dragEnterTargetIds.unshift(t11);
  } }, { key: "handleDragOver", value: function(e15, t11) {
    null === this.dragOverTargetIds && (this.dragOverTargetIds = []), this.dragOverTargetIds.unshift(t11);
  } }, { key: "handleDrop", value: function(e15, t11) {
    this.dropTargetIds.unshift(t11);
  } }, { key: "window", get: function() {
    return this.options.window;
  } }, { key: "document", get: function() {
    return this.options.document;
  } }], n10 && voe(t10.prototype, n10), r10 && voe(t10, r10), e14;
}();
var Soe;
function Coe() {
  return Soe || ((Soe = new Image()).src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="), Soe;
}
var xoe = function(e14, t10) {
  return new boe(e14, t10);
};
const [woe] = Dp("wd-toolbox-item");
const [Toe, Eoe, Foe] = Dp("wd-multiple-menu-item");
const [Moe] = Foe("chevron");
const [koe, Poe] = Foe("dd");
const [Noe] = Foe("custom-dd-menu-item");
const Doe = (e14) => {
  const { item: t10, reportItemType: n10, templateId: r10 } = e14;
  const [, o10, a10] = Yne({ item: { type: "toolboxItem", itemType: n10, templateId: r10 } });
  return ep.useEffect(() => {
    a10(Coe(), { captureDraggingState: true });
  }, [a10]), tp.createElement("div", { ref: o10, className: Noe }, t10.icon && tp.createElement(Fm, { icon: t10.icon }), t10.text && tp.createElement("span", null, t10.text));
};
Doe.displayName = "CustomMenuItem";
const Loe = ({ type: e14, icon: t10, text: n10, templates: r10, onClick: o10 }) => {
  const [a10, i10] = ep.useState(false);
  const [s10, l10] = ep.useState(false);
  const c10 = ep.useRef(null);
  const u10 = rf(oh, { rotate: "270" });
  const d10 = { items: r10.map((e15) => ({ type: "button", key: e15.id, text: e15.name, icon: t10, onClick: () => {
    o10(e15.id);
  } })), customButtonRenderer: (t11) => {
    var _a2;
    return tp.createElement(Doe, { item: t11, reportItemType: e14, templateId: (_a2 = t11.key) == null ? void 0 : _a2.toString() });
  }, align: "left", dropOnSide: true, offset: 0, parent: { type: "element", element: c10.current || null }, customCSS: kp(koe, { [Poe("hidden")]: !a10 && !s10, [Poe("transition")]: s10 }), onItemClick: (e15) => {
    i10(false), e15.onClick && e15.onClick();
  }, onTransitionEnd: () => {
    a10 && s10 && (i10(false), l10(false));
  } };
  const p10 = a10 || s10;
  const m10 = kp(Toe, woe, { [Eoe("selected")]: p10 });
  const h10 = { icon: u10, customCSS: Moe };
  return tp.createElement("div", { className: m10, ref: c10, key: e14, onClick: () => {
    i10(!a10);
  }, onMouseEnter: () => {
    a10 || i10(true), s10 && l10(false);
  }, onMouseLeave: () => {
    s10 || l10(true);
  }, title: n10, "data-aid": n10 }, tp.createElement(Fm, { icon: t10, customCSS: "gc-btn__icon" }), tp.createElement("span", { className: "gc-btn__text" }, n10), tp.createElement(Fm, __spreadValues({}, h10)), p10 && tp.createElement(RF, __spreadValues({}, d10)));
};
Loe.displayName = "MultipleMenuItem";
const Hoe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M8 3h7a2 2 0 0 1 2 2v1c0 .597-.262 1.134-.677 1.5.415.366.677.903.677 1.5v2c0 .597-.262 1.134-.677 1.5.415.366.677.903.677 1.5v1a2 2 0 0 1-2 2H8v-1h7a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H8v-1h7a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H8V7h7a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H8V3Z" }), tp.createElement("path", { className: Km.secondary, d: "M8 17H5a2 2 0 0 1-2-2v-1c0-.597.262-1.134.677-1.5A1.996 1.996 0 0 1 3 11V9c0-.597.262-1.134.677-1.5A1.996 1.996 0 0 1 3 6V5a2 2 0 0 1 2-2h3v14Zm-4-3v1a1 1 0 0 0 1 1h2v-3H5a1 1 0 0 0-1 1Zm3-7V4H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2Zm0 1H5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2V8Z" }));
const Ioe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, fillOpacity: ".62", d: "M8.5 21V3h10.263a2.24 2.24 0 0 1 1.582.655c.419.42.655.989.655 1.582V7.75c0 .55-.202 1.079-.566 1.487.364.408.566.937.566 1.487v2.526c0 .553-.204 1.084-.572 1.494.368.409.572.94.572 1.493v2.526a2.24 2.24 0 0 1-.655 1.582 2.24 2.24 0 0 1-1.582.655H8.5Zm0-16.5v3.987V4.5Zm0 5.487v4-4Zm0 5.513v4-4Zm1.5 4h8.763a.738.738 0 0 0 .737-.737v-2.526a.738.738 0 0 0-.737-.737H10v4Zm0-5.513h8.763a.738.738 0 0 0 .737-.737v-2.526a.738.738 0 0 0-.737-.737H10v4Zm0-5.5h8.763a.738.738 0 0 0 .737-.737V5.237a.738.738 0 0 0-.737-.737H10v3.987Z" }), tp.createElement("path", { className: Km.secondary, d: "M3.566 9.237A2.233 2.233 0 0 1 3 7.75V5.237c0-.593.236-1.162.655-1.582A2.24 2.24 0 0 1 5.237 3H10v18H5.237a2.24 2.24 0 0 1-1.582-.655A2.24 2.24 0 0 1 3 18.763v-2.526c0-.553.204-1.084.572-1.493A2.235 2.235 0 0 1 3 13.25v-2.526c0-.55.202-1.079.566-1.487ZM8.5 4.5H5.237a.738.738 0 0 0-.737.737V7.75a.738.738 0 0 0 .737.737H8.5V4.5Zm0 5.487H5.237a.738.738 0 0 0-.737.737v2.526a.738.738 0 0 0 .737.737H8.5v-4Zm0 5.513H5.237a.738.738 0 0 0-.737.737v2.526a.738.738 0 0 0 .737.737H8.5v-4Zm1.5 4v-4 4Zm0-5.513v-4 4Zm0-5.5V4.5v3.987Z" }));
const _oe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M2 5.5A2.5 2.5 0 0 1 4.5 3h1a.5.5 0 0 1 0 1h-1A1.5 1.5 0 0 0 3 5.5v1a.5.5 0 0 1-1 0v-1Zm12-2a.5.5 0 0 1 .5-.5h1A2.5 2.5 0 0 1 18 5.5v1a.5.5 0 0 1-1 0v-1A1.5 1.5 0 0 0 15.5 4h-1a.5.5 0 0 1-.5-.5ZM2.5 13a.5.5 0 0 1 .5.5v1A1.5 1.5 0 0 0 4.5 16h1a.5.5 0 0 1 0 1h-1A2.5 2.5 0 0 1 2 14.5v-1a.5.5 0 0 1 .5-.5Zm15 0a.5.5 0 0 1 .5.5v1a2.5 2.5 0 0 1-2.5 2.5h-1a.5.5 0 0 1 0-1h1a1.5 1.5 0 0 0 1.5-1.5v-1a.5.5 0 0 1 .5-.5Z" }), tp.createElement("path", { className: Km.secondary, d: "M5.5 6a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5Zm3.5.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7Zm2.5-.5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5Zm3.5.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7Z" }));
const Voe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "M2 5.75A2.75 2.75 0 0 1 4.75 3h1.5a.75.75 0 0 1 0 1.5h-1.5c-.69 0-1.25.56-1.25 1.25v1.5a.75.75 0 0 1-1.5 0v-1.5Zm15-2a.75.75 0 0 1 .75-.75h1.5A2.75 2.75 0 0 1 22 5.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.69-.56-1.25-1.25-1.25h-1.5a.75.75 0 0 1-.75-.75ZM2.75 16a.75.75 0 0 1 .75.75v1.5c0 .69.56 1.25 1.25 1.25h1.5a.75.75 0 0 1 0 1.5h-1.5A2.75 2.75 0 0 1 2 18.25v-1.5a.75.75 0 0 1 .75-.75Zm18.5 0a.75.75 0 0 1 .75.75v1.5A2.75 2.75 0 0 1 19.25 21h-1.5a.75.75 0 0 1 0-1.5h1.5c.69 0 1.25-.56 1.25-1.25v-1.5a.75.75 0 0 1 .75-.75Z" }), tp.createElement("path", { className: Km.secondary, d: "M5.75 7a.75.75 0 0 1 .75.75v8.5a.75.75 0 0 1-1.5 0v-8.5A.75.75 0 0 1 5.75 7Zm4.75.75a.75.75 0 0 0-1.5 0v8.5a.75.75 0 0 0 1.5 0v-8.5ZM13.75 7a.75.75 0 0 1 .75.75v8.5a.75.75 0 0 1-1.5 0v-8.5a.75.75 0 0 1 .75-.75Zm4.75.75a.75.75 0 0 0-1.5 0v8.5a.75.75 0 0 0 1.5 0v-8.5Z" }));
const Roe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M15 4c1.656 0 3 1.344 3 3v6c0 1.656-1.344 3-3 3H4.5a.5.5 0 0 1 0-1H15a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H4.5a.5.5 0 0 1 0-1H15Z" }), tp.createElement("path", { className: Km.secondary, d: "M13 8.75v2.5A1.75 1.75 0 0 1 11.25 13h-7.5A1.75 1.75 0 0 1 2 11.25v-2.5C2 7.784 2.784 7 3.75 7h7.5c.966 0 1.75.784 1.75 1.75Zm-1 0a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0-.75.75v2.5c0 .414.336.75.75.75h7.5a.75.75 0 0 0 .75-.75v-2.5Z" }));
const Aoe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "M18.75 4A3.251 3.251 0 0 1 22 7.25v9.5A3.251 3.251 0 0 1 18.75 20h-12a.75.75 0 0 1 0-1.5h12a1.75 1.75 0 0 0 1.75-1.75v-9.5a1.75 1.75 0 0 0-1.75-1.75h-12a.75.75 0 0 1 0-1.5h12Z" }), tp.createElement("path", { className: Km.secondary, d: "M16 10.375v3.25A2.376 2.376 0 0 1 13.625 16h-9.25A2.376 2.376 0 0 1 2 13.625v-3.25A2.376 2.376 0 0 1 4.375 8h9.25A2.376 2.376 0 0 1 16 10.375Zm-1.5 0a.875.875 0 0 0-.875-.875h-9.25a.875.875 0 0 0-.875.875v3.25c0 .483.392.875.875.875h9.25a.875.875 0 0 0 .875-.875v-3.25Z" }));
tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M17 5.5A2.5 2.5 0 0 0 14.5 3h-9A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9ZM4 7h12v7.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 4 14.5V7Zm1.5-3h9A1.5 1.5 0 0 1 16 5.5V6H4v-.5A1.5 1.5 0 0 1 5.5 4Z" }), tp.createElement("path", { className: Km.secondary, d: "M7 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" })), tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "M17.75 3A3.25 3.25 0 0 1 21 6.25v11.5A3.25 3.25 0 0 1 17.75 21H6.25A3.25 3.25 0 0 1 3 17.75V6.25A3.25 3.25 0 0 1 6.25 3h11.5Zm1.75 5.5h-15v9.25c0 .967.784 1.75 1.75 1.75h11.5a1.75 1.75 0 0 0 1.75-1.75V8.5Zm-1.75-4H6.25A1.75 1.75 0 0 0 4.5 6.25V7h15v-.75a1.75 1.75 0 0 0-1.75-1.75Z" }), tp.createElement("path", { className: Km.secondary, d: "M7.75 14.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm4.25 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm-4.25-4a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm4.25 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm4.25 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z" }));
const Ooe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M9 12a1 1 0 0 1-1-1V5.083A6.001 6.001 0 1 0 14.917 12H9Zm-.997-7.93C8.55 3.992 9 4.448 9 5v6h6c.552 0 1.008.45.93.997A7.001 7.001 0 1 1 8.003 4.07Z" }), tp.createElement("path", { className: Km.secondary, d: "M11 9V3a6 6 0 0 1 6 6h-6Zm6.062 1c.498 0 .927-.366.937-.864A7 7 0 0 0 11 2l-.136.001c-.498.01-.864.439-.864.937V9a1 1 0 0 0 1 1h6.062Z" }));
const Boe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "M11.25 3.25A.75.75 0 0 1 12 4v8h8a.75.75 0 0 1 .743.648l.007.102c0 4.971-4.029 8.5-9 8.5a9 9 0 0 1-9-9c0-4.971 3.529-9 8.5-9Zm-.75 1.537-.209.024C6.602 5.282 4.25 8.433 4.25 12.25a7.5 7.5 0 0 0 7.5 7.5c3.817 0 6.969-2.352 7.439-6.041l.023-.209H11.25a.75.75 0 0 1-.743-.648l-.007-.102V4.787Z" }), tp.createElement("path", { className: Km.secondary, d: "M14.25.75a9 9 0 0 1 9 9 .75.75 0 0 1-.75.75h-8.25a.75.75 0 0 1-.75-.75V1.5a.75.75 0 0 1 .75-.75ZM15 2.287V9h6.712l-.023-.209a7.503 7.503 0 0 0-6.48-6.48L15 2.287Z" }));
const zoe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM4 6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Zm9.854 1.854a.502.502 0 0 0-.708-.708L8.5 11.793l-1.646-1.647a.502.502 0 0 0-.708.708l2 2a.502.502 0 0 0 .708 0l5-5Z" }), tp.createElement("path", { className: Km.secondary, d: "M13.854 7.854a.502.502 0 0 0-.708-.708L8.5 11.793l-1.646-1.647a.502.502 0 0 0-.708.708l2 2a.502.502 0 0 0 .708 0l5-5Z" }));
const $oe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5A3.25 3.25 0 0 0 6.25 21h11.5A3.25 3.25 0 0 0 21 17.75V6.25A3.25 3.25 0 0 0 17.75 3H6.25ZM4.5 6.25c0-.967.784-1.75 1.75-1.75h11.5c.967 0 1.75.783 1.75 1.75v11.5a1.75 1.75 0 0 1-1.75 1.75H6.25a1.75 1.75 0 0 1-1.75-1.75V6.25Z" }), tp.createElement("path", { className: Km.secondary, d: "M17.28 9.281a.751.751 0 0 0-1.06-1.062l-6.223 6.217-2.216-2.216a.75.75 0 0 0-1.061 1.06l2.746 2.746a.75.75 0 0 0 1.06.001l6.754-6.746Z" }));
const Woe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Km.secondary, d: "M6 4a2 2 0 0 0-2 2v1.5a.5.5 0 0 1-1 0V6a3 3 0 0 1 3-3h1.5a.5.5 0 0 1 0 1H6Zm6.5-1a.5.5 0 0 0 0 1H14a2 2 0 0 1 2 2v1.5a.5.5 0 0 0 1 0V6a3 3 0 0 0-3-3h-1.5Zm-9 9a.5.5 0 0 1 .5.5V14a2 2 0 0 0 2 2h1.5a.5.5 0 0 1 0 1H6a3 3 0 0 1-3-3v-1.5a.5.5 0 0 1 .5-.5Zm13.5.5a.5.5 0 0 0-1 0V14a2 2 0 0 1-2 2h-1.5a.5.5 0 0 0 0 1H14a3 3 0 0 0 3-3v-1.5Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M14 8a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V8Z" }));
const joe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Km.secondary, d: "M6.25 3A3.25 3.25 0 0 0 3 6.25v2.12a.75.75 0 0 0 1.5 0V6.25c0-.967.784-1.75 1.75-1.75h2.12a.75.75 0 0 0 0-1.5H6.25Zm9.38 1.5a.75.75 0 0 1 0-1.5h2.12A3.25 3.25 0 0 1 21 6.25v2.12a.75.75 0 0 1-1.5 0V6.25a1.75 1.75 0 0 0-1.75-1.75h-2.12ZM3 15.63a.75.75 0 0 1 1.5 0v2.12a1.75 1.75 0 0 0 1.75 1.75h2.12a.75.75 0 0 1 0 1.5H6.25A3.25 3.25 0 0 1 3 17.75v-2.12Zm16.5 0a.75.75 0 0 1 1.5 0v2.12A3.25 3.25 0 0 1 17.75 21h-2.12a.75.75 0 0 1 0-1.5h2.12a1.75 1.75 0 0 0 1.75-1.75v-2.12Z" }), tp.createElement("path", { className: Ym.accent, fillOpacity: ".38", d: "M17 10.535A3.537 3.537 0 0 0 13.465 7h-2.93A3.537 3.537 0 0 0 7 10.535v2.93A3.537 3.537 0 0 0 10.535 17h2.93A3.537 3.537 0 0 0 17 13.465v-2.93Z" }));
const Zoe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M4 9V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3v-1h3a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v5H4Zm9-2.5a.5.5 0 0 1-.41.492L12.5 7h-5a.5.5 0 0 1-.09-.992L7.5 6h5a.5.5 0 0 1 .5.5Z" }), tp.createElement("path", { className: Km.secondary, d: "M10 12.1a.5.5 0 0 1-1 0V11H7.9a.5.5 0 0 1 0-1h1.6a.5.5 0 0 1 .5.5v1.6ZM6.3 10a.5.5 0 0 1 0 1H4.7a.5.5 0 0 1 0-1h1.6Zm-3.2 0a.5.5 0 0 1 0 1H2v1.1a.5.5 0 0 1-1 0v-1.6a.5.5 0 0 1 .5-.5h1.6ZM1 13.7a.5.5 0 0 1 1 0v1.6a.5.5 0 0 1-1 0v-1.6Zm0 3.2a.5.5 0 0 1 1 0V18h1.1a.5.5 0 0 1 0 1H1.5a.5.5 0 0 1-.5-.5v-1.6ZM4.7 19a.5.5 0 0 1 0-1h1.6a.5.5 0 0 1 0 1H4.7Zm3.2 0a.5.5 0 0 1 0-1H9v-1.1a.5.5 0 0 1 1 0v1.6a.5.5 0 0 1-.5.5H7.9Zm2.1-3.7a.5.5 0 0 1-1 0v-1.6a.5.5 0 0 1 1 0v1.6Z" }), tp.createElement("path", { className: Km.accent, d: "M7.5 13.5A.5.5 0 0 0 7 13H4a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5Z" }), tp.createElement("path", { className: Km.accent, fillOpacity: ".62", d: "M7.5 15.5A.5.5 0 0 0 7 15H4a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5Z" }));
const Goe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "M4 9.5V4.25A2.25 2.25 0 0 1 6.25 2h11.5A2.25 2.25 0 0 1 20 4.25v15.5A2.25 2.25 0 0 1 17.75 22H14.5v-1.5h3.25a.75.75 0 0 0 .75-.75V4.25a.75.75 0 0 0-.75-.75H6.25a.75.75 0 0 0-.75.75V9.5H4Zm12.25-3a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5h8.5Z" }), tp.createElement("path", { className: Km.secondary, d: "M13.5 13.45a.75.75 0 0 1-1.5 0V12h-1.45a.75.75 0 0 1 0-1.5h2.2a.75.75 0 0 1 .75.75v2.2ZM8.35 10.5a.75.75 0 0 1 0 1.5h-2.2a.75.75 0 0 1 0-1.5h2.2Zm-4.4 0a.75.75 0 0 1 0 1.5H2.5v1.45a.75.75 0 0 1-1.5 0v-2.2a.75.75 0 0 1 .75-.75h2.2ZM1 15.65a.75.75 0 0 1 1.5 0v2.2a.75.75 0 0 1-1.5 0v-2.2Zm0 4.4a.75.75 0 0 1 1.5 0v1.45h1.45a.75.75 0 0 1 0 1.5h-2.2a.75.75 0 0 1-.75-.75v-2.2ZM6.15 23a.75.75 0 0 1 0-1.5h2.2a.75.75 0 0 1 0 1.5h-2.2Zm4.4 0a.75.75 0 0 1 0-1.5H12v-1.45a.75.75 0 0 1 1.5 0v2.2a.75.75 0 0 1-.75.75h-2.2Zm2.95-5.15a.75.75 0 0 1-1.5 0v-2.2a.75.75 0 0 1 1.5 0v2.2Z" }), tp.createElement("path", { className: Ym.accent, d: "M10 15.75a.75.75 0 0 0-.75-.75h-4a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 .75-.75Z" }), tp.createElement("path", { className: Ym.accent, fillOpacity: ".38", d: "M10 18.25a.75.75 0 0 0-.75-.75h-4a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 .75-.75Z" }));
const Uoe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Km.secondary, d: "M13.971 3A2.03 2.03 0 0 1 16 5.029v.552a.5.5 0 0 1-1 0v-.552A1.03 1.03 0 0 0 13.971 4h-.662a.5.5 0 0 1 0-1h.662ZM6.029 3h.662a.5.5 0 0 1 0 1h-.662A1.03 1.03 0 0 0 5 5.029v.552a.5.5 0 0 1-1 0v-.552A2.03 2.03 0 0 1 6.029 3ZM5 14.971A1.03 1.03 0 0 0 6.029 16h.662a.5.5 0 0 1 0 1h-.662A2.03 2.03 0 0 1 4 14.971v-.552a.5.5 0 0 1 1 0v.552ZM13.971 16A1.03 1.03 0 0 0 15 14.971v-.552a.5.5 0 0 1 1 0v.552A2.03 2.03 0 0 1 13.971 17h-.662a.5.5 0 0 1 0-1h.662ZM10.662 3a.5.5 0 0 1 0 1H9.338a.5.5 0 0 1 0-1h1.324ZM9.338 17a.5.5 0 0 1 0-1h1.324a.5.5 0 0 1 0 1H9.338Z" }), tp.createElement("path", { className: Ym.text, d: "M18 11.495v.01a.495.495 0 0 1-.495.495H2.496a.495.495 0 0 1-.495-.495v-.01c0-.273.221-.495.495-.495h15.009c.273 0 .495.222.495.495Zm0-3v.01a.495.495 0 0 1-.495.495H2.496a.495.495 0 0 1-.495-.495v-.01c0-.273.221-.495.495-.495h15.009c.273 0 .495.222.495.495Z" }));
const qoe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "M2 15a.75.75 0 0 1 .648-.743l.102-.007h18.5a.75.75 0 0 1 .102 1.493l-.102.007H2.75A.75.75 0 0 1 2 15Zm0-6a.75.75 0 0 1 .648-.743l.102-.007h18.5a.75.75 0 0 1 .102 1.493l-.102.007H2.75A.75.75 0 0 1 2 9Z" }), tp.createElement("path", { className: Km.secondary, d: "M16.725 3A2.776 2.776 0 0 1 19.5 5.775v1.037a.75.75 0 0 1-1.5 0V5.787l.75.738-.75-.75c0-.704-.571-1.275-1.275-1.275h-.787a.75.75 0 0 1 0-1.5h.787Zm-9.45 0h.787a.75.75 0 0 1 0 1.5h-.787C6.571 4.5 6 5.071 6 5.775v1.037a.75.75 0 0 1-1.5 0V5.787l.75.738-.75-.75A2.776 2.776 0 0 1 7.275 3ZM6 18.225c0 .704.571 1.275 1.275 1.275h.787a.75.75 0 0 1 0 1.5h-.787A2.776 2.776 0 0 1 4.5 18.225v-1.037a.75.75 0 0 1 1.5 0v1.037ZM16.725 19.5c.704 0 1.275-.571 1.275-1.275v-1.037a.75.75 0 0 1 1.5 0v1.037A2.776 2.776 0 0 1 16.725 21h-.787a.75.75 0 0 1 0-1.5h.787ZM12.788 3a.75.75 0 0 1 0 1.5h-1.575a.75.75 0 0 1 0-1.5h1.575ZM4.5 10.962a.75.75 0 0 1 1.5 0v2.075a.75.75 0 0 1-1.5 0v-2.075ZM11.212 21a.75.75 0 0 1 0-1.5h1.575a.75.75 0 0 1 0 1.5h-1.575Zm8.288-7.962a.75.75 0 0 1-1.5 0v-2.075a.75.75 0 0 1 1.5 0v2.075Z" }));
const Yoe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M7.502 15H4a2 2 0 1 1 0-4h3.502c.275 0 .498.223.498.498v.004a.498.498 0 0 1-.498.498H4a1 1 0 0 0 0 2h3.502c.275 0 .498.223.498.498v.004a.498.498 0 0 1-.498.498ZM16 12h-3.502a.498.498 0 0 1-.498-.498v-.004c0-.275.223-.498.498-.498H16a2 2 0 1 1 0 4h-3.502a.498.498 0 0 1-.498-.498v-.004c0-.275.223-.498.498-.498H16a1 1 0 0 0 0-2ZM7.502 9H4a2 2 0 1 1 0-4h3.502c.275 0 .498.223.498.498v.004A.498.498 0 0 1 7.502 6H4a1 1 0 0 0 0 2h3.502c.275 0 .498.223.498.498v.004A.498.498 0 0 1 7.502 9ZM16 6h-3.502A.498.498 0 0 1 12 5.502v-.004c0-.275.223-.498.498-.498H16a2 2 0 1 1 0 4h-3.502A.498.498 0 0 1 12 8.502v-.004c0-.275.223-.498.498-.498H16a1 1 0 0 0 0-2Z" }), tp.createElement("path", { className: Km.secondary, d: "M9.5 17a.5.5 0 0 0 1 0v-1.2a.5.5 0 0 0-1 0V17Zm0-3.2a.5.5 0 0 0 1 0v-1.2a.5.5 0 0 0-1 0v1.2Zm.5-2.7a.5.5 0 0 1-.5-.5V9.4a.5.5 0 0 1 1 0v1.2a.5.5 0 0 1-.5.5Zm-.5-3.7a.5.5 0 0 0 1 0V6.2a.5.5 0 0 0-1 0v1.2Zm.5-2.7a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 1 0v1.2a.5.5 0 0 1-.5.5Z" }));
const Koe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "M8.75 21h-3.5A3.251 3.251 0 0 1 2 17.75v-1.5A3.251 3.251 0 0 1 5.25 13h3.5a.75.75 0 0 1 0 1.5h-3.5a1.75 1.75 0 0 0-1.75 1.75v1.5c0 .966.784 1.75 1.75 1.75h3.5a.75.75 0 0 1 0 1.5Zm10-6.5h-3.5a.75.75 0 0 1 0-1.5h3.5A3.251 3.251 0 0 1 22 16.25v1.5A3.251 3.251 0 0 1 18.75 21h-3.5a.75.75 0 0 1 0-1.5h3.5a1.75 1.75 0 0 0 1.75-1.75v-1.5a1.75 1.75 0 0 0-1.75-1.75Zm-10-3.5h-3.5A3.251 3.251 0 0 1 2 7.75v-1.5A3.251 3.251 0 0 1 5.25 3h3.5a.75.75 0 0 1 0 1.5h-3.5A1.75 1.75 0 0 0 3.5 6.25v1.5c0 .966.784 1.75 1.75 1.75h3.5a.75.75 0 0 1 0 1.5Zm10-6.5h-3.5a.75.75 0 0 1 0-1.5h3.5A3.251 3.251 0 0 1 22 6.25v1.5A3.251 3.251 0 0 1 18.75 11h-3.5a.75.75 0 0 1 0-1.5h3.5a1.75 1.75 0 0 0 1.75-1.75v-1.5a1.75 1.75 0 0 0-1.75-1.75Z" }), tp.createElement("path", { className: Km.secondary, d: "M11.25 2.25a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0v-1.5Zm0 4.5a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0v-1.5Zm0 4.5a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0v-1.5Zm0 4.5a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0v-1.5Zm0 4.5a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0v-1.5Z" }));
const Xoe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-2a2 2 0 0 0-2 2v8c0 .373.102.722.279 1.02l4.67-4.588a1.5 1.5 0 0 1 2.102 0l4.67 4.588c.177-.298.279-.647.279-1.02V6a2 2 0 0 0-2-2H6Zm0 12h8c.369 0 .715-.1 1.012-.274l-4.662-4.581a.5.5 0 0 0-.7 0l-4.662 4.581C5.285 15.9 5.631 16 6 16Z" }), tp.createElement("path", { className: Km.secondary, d: "M14 7.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 14 7.5Zm-1 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0Z" }));
const Joe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "M17.75 3A3.25 3.25 0 0 1 21 6.25v11.5A3.25 3.25 0 0 1 17.75 21H6.25A3.25 3.25 0 0 1 3 17.75V6.25A3.25 3.25 0 0 1 6.25 3h11.5Zm.581 16.401-5.806-5.686a.75.75 0 0 0-.966-.071l-.084.071-5.807 5.686c.182.064.378.099.582.099h11.5c.203 0 .399-.035.581-.099l-5.806-5.686 5.806 5.686ZM17.75 4.5H6.25A1.75 1.75 0 0 0 4.5 6.25v11.5c0 .208.036.408.103.594l5.823-5.701a2.249 2.249 0 0 1 3.02-.116l.128.116 5.822 5.702c.067-.186.104-.386.104-.595V6.25a1.75 1.75 0 0 0-1.75-1.75Z" }), tp.createElement("path", { className: Km.secondary, d: "M15.252 6.5a2.252 2.252 0 1 1 0 4.503 2.252 2.252 0 0 1 0-4.503Zm0 1.5a.752.752 0 1 0 0 1.505.752.752 0 0 0 0-1.505Z" }));
const Qoe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M11.001 17H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v6.714l-1-.942V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h5.002l-.001 1Z" }), tp.createElement("path", { className: Km.secondary, d: "M12.312 10.04a.499.499 0 0 1 .544.106l5.995 5.941a.499.499 0 0 1-.46.843l-3.497-.776-1.995 2.647A.5.5 0 0 1 12 18.5l.004-7.999a.503.503 0 0 1 .308-.461Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M13.854 7.854a.502.502 0 0 0-.708-.708L8.5 11.793l-1.646-1.647a.502.502 0 0 0-.708.708l2 2a.502.502 0 0 0 .708 0l5-5Z" }));
const eae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "M14.001 21H6.25A3.25 3.25 0 0 1 3 17.75V6.25A3.25 3.25 0 0 1 6.25 3h11.5A3.25 3.25 0 0 1 21 6.25v9.398l-1.5-1.546V6.25a1.75 1.75 0 0 0-1.75-1.75H6.25A1.75 1.75 0 0 0 4.5 6.25v11.5c0 .966.784 1.75 1.75 1.75h7.752l-.001 1.5Z" }), tp.createElement("path", { className: Ym.accent, fillOpacity: ".38", d: "M17.28 9.281a.751.751 0 0 0-1.06-1.062l-6.223 6.217-2.216-2.216a.75.75 0 0 0-1.061 1.06l2.746 2.746a.75.75 0 0 0 1.06.001l6.754-6.746Z" }), tp.createElement("path", { className: Km.secondary, d: "M16.312 12.248a.75.75 0 0 0-1.307.502L15 22.252a.75.75 0 0 0 1.372.419l2.03-3.014 3.537.878a.75.75 0 0 0 .738-1.23l-6.365-7.057Z" }));
const tae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M11.001 17H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v7.656l-1-.942V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h6.002l-.001 1Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M10.5 7H12v.5a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0V7h1.5v6H9a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-.5V7Z" }), tp.createElement("path", { className: Km.secondary, d: "M12.312 10.04a.499.499 0 0 1 .544.106l5.995 5.941a.499.499 0 0 1-.46.843l-3.497-.776-1.995 2.647A.5.5 0 0 1 12 18.5l.004-7.999a.503.503 0 0 1 .308-.461Z" }));
const nae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "M14.001 21H5.75A3.75 3.75 0 0 1 2 17.25V6.75A3.75 3.75 0 0 1 5.75 3h12.5A3.75 3.75 0 0 1 22 6.75v9.929l-1.5-1.546V6.75a2.25 2.25 0 0 0-2.25-2.25H5.75A2.25 2.25 0 0 0 3.5 6.75v10.5a2.25 2.25 0 0 0 2.25 2.25h8.252l-.001 1.5Z" }), tp.createElement("path", { className: Ym.accent, fillOpacity: ".38", d: "M15.5 7.5h-2.75v9h.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5h.5v-9H8.5v.75a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 7.75 6h8.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0V7.5Z" }), tp.createElement("path", { className: Km.secondary, d: "M16.312 12.248a.75.75 0 0 0-1.307.502L15 22.252a.75.75 0 0 0 1.372.419l2.03-3.014 3.537.878a.75.75 0 0 0 .738-1.23l-6.365-7.057Z" }));
const rae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M12.5 3.5a.5.5 0 0 1 .5.5v4.891C13.531 8.337 14.232 8 15 8c1.657 0 3 1.567 3 3.5S16.657 15 15 15c-.768 0-1.469-.337-2-.891v.391a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5ZM15 14c.965 0 2-.969 2-2.5C17 9.969 15.965 9 15 9c-.966 0-2 .969-2 2.5 0 1.531 1.034 2.5 2 2.5Z" }), tp.createElement("path", { className: Km.secondary, d: "M6.957 3.836a.5.5 0 0 0-.94-.013L3.293 11h-.02v.054l-1.24 3.269a.499.499 0 1 0 .935.354L3.984 12h4.754l.926 2.664a.5.5 0 0 0 .945-.328l-3.652-10.5ZM4.363 11l2.101-5.537L8.39 11H4.363Z" }));
const oae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "M15.75 3a.75.75 0 0 0-.75.75v15.5a.75.75 0 0 0 1.5 0v-.237c.685.618 1.554.987 2.5.987 2.209 0 4-2.015 4-4.5S21.209 11 19 11c-.946 0-1.815.369-2.5.987V3.75a.75.75 0 0 0-.75-.75Zm.75 12.5c0-1.828 1.28-3 2.5-3 1.219 0 2.5 1.172 2.5 3s-1.281 3-2.5 3c-1.22 0-2.5-1.172-2.5-3Z" }), tp.createElement("path", { className: Km.secondary, d: "M7.761 3a.752.752 0 0 1 .696.499l5.5 15.5a.751.751 0 0 1-1.414.502L11.124 15.5H4.006L2.45 19.521a.75.75 0 0 1-1.399-.542l6-15.5A.75.75 0 0 1 7.761 3ZM7.72 5.907 4.587 14h6.004L7.72 5.907Z" }));
const aae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M17.854 2.146a.502.502 0 0 1 0 .708l-15 15a.502.502 0 0 1-.708-.708l15-15a.502.502 0 0 1 .708 0Z" }));
const iae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "M21.784 2.216a.75.75 0 0 1 0 1.061L3.28 21.78a.749.749 0 1 1-1.06-1.06L20.723 2.216a.75.75 0 0 1 1.061 0Z" }));
const sae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M5.75 3h8.5A2.75 2.75 0 0 1 17 5.75v8.5A2.75 2.75 0 0 1 14.25 17h-8.5A2.75 2.75 0 0 1 3 14.25v-8.5A2.75 2.75 0 0 1 5.75 3ZM4 5.75v8.5c0 .967.783 1.75 1.75 1.75h8.5A1.75 1.75 0 0 0 16 14.25v-8.5A1.75 1.75 0 0 0 14.25 4h-8.5A1.75 1.75 0 0 0 4 5.75Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M9 7.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4ZM9 13.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Z" }), tp.createElement("path", { className: Km.secondary, d: "M6.75 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm.75 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM6.75 14a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" }));
const lae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "M6.25 2.5A3.25 3.25 0 0 0 3 5.75v11.5a3.25 3.25 0 0 0 3.25 3.25h11.5A3.25 3.25 0 0 0 21 17.25V5.75a3.25 3.25 0 0 0-3.25-3.25H6.25ZM4.5 5.75C4.5 4.783 5.284 4 6.25 4h11.5c.967 0 1.75.783 1.75 1.75v11.5A1.75 1.75 0 0 1 17.75 19H6.25a1.75 1.75 0 0 1-1.75-1.75V5.75Z" }), tp.createElement("path", { className: Ym.accent, fillOpacity: ".38", d: "M11.25 7a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5Zm0 3.75a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5Zm-.75 4.5a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75Z" }), tp.createElement("path", { className: Km.secondary, d: "M7.75 8.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 2.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 4.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" }));
tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M12.399 16.99a.51.51 0 0 1-.186-.08L7.5 13.61l-4.713 3.3A.5.5 0 0 1 2 16.5V7c0-.163.08-.316.213-.41l5-3.5a.503.503 0 0 1 .574 0l4.713 3.3 4.713-3.3A.5.5 0 0 1 18 3.5v6.307a4.074 4.074 0 0 0-1-.542V4.46l-4 2.8v2.549c-.39.288-.727.644-1 1.052V7.26l-4-2.8v8.28l3.519 2.463c.193.578.484 1.18.88 1.787ZM7 12.74V4.46l-4 2.8v8.28l4-2.8Z" }), tp.createElement("path", { className: Km.secondary, d: "M15.501 10.001c2.034 0 3.499 1.648 3.499 3.681 0 1.524-.979 3.53-3.253 5.236a.41.41 0 0 1-.491 0C12.981 17.212 12 15.206 12 13.682c0-2.033 1.468-3.681 3.501-3.681ZM15.5 15a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 15.5 15Z" })), tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "m14.366 19.896-.01-.006-5.105-3.591-5.07 3.565a.75.75 0 0 1-1.174-.509L3 19.25V8.618c0-.21.087-.408.238-.548l.081-.066 5.5-3.866a.748.748 0 0 1 .199-.101l.123-.028.063-.008L9.251 4l.046.001.068.007.016.004c.085.014.17.044.251.092l.052.034 5.07 3.565 5.067-3.562a.75.75 0 0 1 1.174.509l.007.105v6.869a5.301 5.301 0 0 0-1.5-.53V6.199l-4 2.812v2.914a5.354 5.354 0 0 0-1.5 1.554V9.007l-4-2.812v8.799l3.282 2.308c.165.817.526 1.697 1.082 2.594ZM8.5 6.195l-4 2.812v8.799l4-2.812V6.195Z" }), tp.createElement("path", { className: Km.secondary, d: "M23 16.5a4.5 4.5 0 0 0-9 0c0 1.863 1.42 4.315 4.2 6.4a.501.501 0 0 0 .6 0c2.78-2.085 4.2-4.537 4.2-6.4Zm-6 0a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 17 16.5Z" }));
const cae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M8 16H5c-1.656 0-3-1.344-3-3V7c0-1.656 1.344-3 3-3h3a.5.5 0 0 1 0 1H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h3a.5.5 0 0 1 0 1Zm4-11a.5.5 0 0 1 0-1h3c1.656 0 3 1.344 3 3v6c0 1.656-1.344 3-3 3h-3a.5.5 0 0 1 0-1h3a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-3Z" }), tp.createElement("path", { className: Km.secondary, d: "M9.5 5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0V5Zm0 3a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0V8Zm0 3a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0v-1Zm0 3a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0v-1Zm0 3a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0v-1Zm0-15a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0V2Z" }));
const uae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "M9.75 20h-4.5A3.251 3.251 0 0 1 2 16.75v-9.5A3.251 3.251 0 0 1 5.25 4h4.5a.75.75 0 0 1 0 1.5h-4.5A1.75 1.75 0 0 0 3.5 7.25v9.5c0 .966.784 1.75 1.75 1.75h4.5a.75.75 0 0 1 0 1.5Zm9-14.5h-4.5a.75.75 0 0 1 0-1.5h4.5A3.251 3.251 0 0 1 22 7.25v9.5A3.251 3.251 0 0 1 18.75 20h-4.5a.75.75 0 0 1 0-1.5h4.5a1.75 1.75 0 0 0 1.75-1.75v-9.5a1.75 1.75 0 0 0-1.75-1.75Z" }), tp.createElement("path", { className: Km.secondary, d: "M11.25 2a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0V2Zm0 4.5a.75.75 0 0 1 1.5 0V8a.75.75 0 0 1-1.5 0V6.5Zm0 4.5a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0V11Zm0 4.5a.75.75 0 0 1 1.5 0V17a.75.75 0 0 1-1.5 0v-1.5Zm0 4.5a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0V20Z" }));
const dae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M16 2.5V6c0 .828-.679 1.5-1.5 1.5H5.488A1.495 1.495 0 0 1 4 6V2.5c0-.276.222-.5.496-.5s.496.224.496.5V6c0 .275.222.5.496.5H14.5c.274 0 .5-.225.5-.5V2.5c0-.276.226-.5.5-.5s.5.224.5.5ZM16 14v3.5c0 .276-.226.5-.5.5a.501.501 0 0 1-.5-.5V14c0-.275-.226-.5-.5-.5H5.488a.499.499 0 0 0-.496.5v3.5c0 .276-.222.5-.496.5A.498.498 0 0 1 4 17.5V14c0-.828.667-1.5 1.488-1.5H14.5c.821 0 1.5.672 1.5 1.5Z" }), tp.createElement("path", { className: Km.secondary, d: "M3 9.5a.5.5 0 0 0 0 1h1.2a.5.5 0 0 0 0-1H3Zm3.2 0a.5.5 0 0 0 0 1h1.2a.5.5 0 0 0 0-1H6.2Zm2.7.5a.5.5 0 0 1 .5-.5h1.2a.5.5 0 0 1 0 1H9.4a.5.5 0 0 1-.5-.5Zm3.7-.5a.5.5 0 0 0 0 1h1.2a.5.5 0 0 0 0-1h-1.2Zm2.7.5a.5.5 0 0 1 .5-.5H17a.5.5 0 0 1 0 1h-1.2a.5.5 0 0 1-.5-.5Z" }));
const pae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "M4.75 2.003a.75.75 0 0 0-.75.75v4.25a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4.25a.75.75 0 0 0-1.5 0v4.25a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5v-4.25a.75.75 0 0 0-.75-.75Zm14.5 20a.75.75 0 0 0 .75-.75v-4.25a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4.25a.75.75 0 1 0 1.5 0v-4.25a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5v4.25c0 .415.336.75.75.75Z" }), tp.createElement("path", { className: Km.secondary, d: "M2.5 12.003a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Z" }));
const mae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M6 2a2 2 0 0 0-2 2v5.207a5.5 5.5 0 0 1 1-.185V4a1 1 0 0 1 1-1h4v3.5A1.5 1.5 0 0 0 11.5 8H15v8a1 1 0 0 1-1 1h-3.6a5.533 5.533 0 0 1-.657 1H14a2 2 0 0 0 2-2V7.414c0-.398-.158-.779-.439-1.06l-3.915-3.915A1.499 1.499 0 0 0 10.586 2H6Zm8.793 5H11.5a.5.5 0 0 1-.5-.5V3.207L14.793 7Z" }), tp.createElement("path", { className: Km.secondary, d: "M10 14.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0ZM5.5 17a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 1 0v2a.5.5 0 0 1-.5.5Zm0-5.125a.625.625 0 1 1 0 1.25.625.625 0 0 1 0-1.25Z" }));
const hae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "M18.5 20a.5.5 0 0 1-.5.5h-5.732A6.49 6.49 0 0 1 11.19 22H18a2 2 0 0 0 2-2V9.828a2 2 0 0 0-.586-1.414l-5.829-5.828a.483.483 0 0 0-.049-.041l-.036-.029a2.072 2.072 0 0 0-.219-.18c-.025-.017-.053-.03-.08-.044l-.048-.024-.05-.029c-.054-.031-.109-.063-.166-.087a1.977 1.977 0 0 0-.624-.138c-.02-.001-.039-.004-.059-.007C12.227 2.004 12.2 2 12.172 2H6a2 2 0 0 0-2 2v7.498a6.452 6.452 0 0 1 1.5-.422V4a.5.5 0 0 1 .5-.5h6V8a2 2 0 0 0 2 2h4.5v10Zm-5-15.379L17.378 8.5H14a.5.5 0 0 1-.5-.5V4.621Z" }), tp.createElement("path", { className: Km.secondary, d: "M12 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 1 0 11 0ZM6.5 21a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5Zm0-6.125a.625.625 0 1 1 0 1.25.625.625 0 0 1 0-1.25Z" }));
const fae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Km.secondary, d: "M8.443 5a.5.5 0 0 1 .464.333l1.774 5a.5.5 0 0 1-.942.334L9.502 10H7.23l-.264.68a.499.499 0 1 1-.932-.361l1.935-5A.5.5 0 0 1 8.443 5Zm-.028 1.938L7.617 9h1.53l-.732-2.062Z" }), tp.createElement("path", { className: Ym.text, d: "M17 5.5A2.5 2.5 0 0 0 14.5 3h-9A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9ZM5.5 4h9A1.5 1.5 0 0 1 16 5.5v9a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 4 14.5v-9A1.5 1.5 0 0 1 5.5 4Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M12 6a.5.5 0 0 0 0 1h1.5a.5.5 0 0 0 0-1H12Zm-.5 3.5A.5.5 0 0 1 12 9h1.5a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5Zm-5 2.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Z" }));
const gae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "M18.25 3A2.75 2.75 0 0 1 21 5.75v12.5A2.75 2.75 0 0 1 18.25 21H5.75A2.75 2.75 0 0 1 3 18.25V5.75A2.75 2.75 0 0 1 5.75 3h12.5Zm0 1.5H5.75c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V5.75c0-.69-.56-1.25-1.25-1.25Z" }), tp.createElement("path", { className: Ym.accent, fillOpacity: ".38", d: "M17.25 11.5h-3.5l-.102.007A.75.75 0 0 0 13.75 13h3.5l.102-.007a.75.75 0 0 0-.102-1.493Zm-10.5 4h10.5a.75.75 0 0 1 .102 1.493L17.25 17H6.75a.75.75 0 0 1-.102-1.493l.102-.007Zm10.5-8h-3.5l-.102.007A.75.75 0 0 0 13.75 9h3.5l.102-.007A.75.75 0 0 0 17.25 7.5Z" }), tp.createElement("path", { className: Km.secondary, d: "M9.277 6a.748.748 0 0 1 .696.499l2.307 6.5a.751.751 0 0 1-1.414.502l-.338-.953H7.826l-.376.973a.75.75 0 0 1-1.399-.542l2.516-6.5A.75.75 0 0 1 9.277 6Zm-.041 2.906-.829 2.142h1.589l-.76-2.142Z" }));
const yae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M10.5 8A2.5 2.5 0 0 0 8 10.5v5a2.5 2.5 0 0 0 2.5 2.5h5a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 15.5 8h-5ZM9 10.5A1.5 1.5 0 0 1 10.5 9h5a1.5 1.5 0 0 1 1.5 1.5v5a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 9 15.5v-5Z" }), tp.createElement("path", { className: Km.secondary, d: "M7.5 3a4.5 4.5 0 0 0-.5 8.973v1.005A5.501 5.501 0 0 1 7.5 2a5.501 5.501 0 0 1 5.478 5h-1.005A4.502 4.502 0 0 0 7.5 3Z" }));
const vae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "M12.25 8.997A3.25 3.25 0 0 0 9 12.247v6.5a3.25 3.25 0 0 0 3.25 3.25h6.5a3.25 3.25 0 0 0 3.25-3.25v-6.5a3.25 3.25 0 0 0-3.25-3.25h-6.5Zm-1.75 3.25c0-.967.784-1.75 1.75-1.75h6.5c.967 0 1.75.783 1.75 1.75v6.5a1.75 1.75 0 0 1-1.75 1.75h-6.5a1.75 1.75 0 0 1-1.75-1.75v-6.5Z" }), tp.createElement("path", { className: Km.secondary, d: "M8.75 3.497A5.25 5.25 0 0 0 8 13.943v1.512a6.75 6.75 0 1 1 7.459-7.458h-1.512a5.25 5.25 0 0 0-5.197-4.5Z" }));
const bae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M4 3.5a.5.5 0 0 0-1 0v11A2.5 2.5 0 0 0 5.5 17h11a.5.5 0 0 0 0-1h-11A1.5 1.5 0 0 1 4 14.5v-11Z" }), tp.createElement("path", { className: Km.secondary, d: "M12.5 5a.5.5 0 0 0 0 1h2.793L11 10.293 9.354 8.646a.504.504 0 0 0-.708 0l-3.5 3.5a.502.502 0 0 0 .708.708L9 9.707l1.646 1.647a.504.504 0 0 0 .708 0L16 6.707V9.5a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5h-4Z" }));
const Sae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "M4.5 3.75a.75.75 0 0 0-1.5 0v14A3.25 3.25 0 0 0 6.25 21h14a.75.75 0 0 0 0-1.5h-14a1.75 1.75 0 0 1-1.75-1.75v-14Z" }), tp.createElement("path", { className: Km.secondary, d: "M14.75 6a.75.75 0 0 0 0 1.5h3.189l-4.689 4.689-1.97-1.969a.749.749 0 0 0-1.06 0l-3.75 3.75a.749.749 0 1 0 1.06 1.06l3.22-3.219 1.97 1.969a.749.749 0 0 0 1.06 0l5.222-5.221v3.196a.75.75 0 1 0 1.5 0V6.75a.75.75 0 0 0-.75-.75H14.75Z" }));
const Cae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M4 9V4a2 2 0 0 1 2-2h4.586c.398 0 .779.158 1.06.439l3.915 3.915c.281.281.439.662.439 1.06V16a2 2 0 0 1-2 2h-3v-1h3a1 1 0 0 0 1-1V8h-3.5A1.5 1.5 0 0 1 10 6.5V3H6a1 1 0 0 0-1 1v5H4Zm10.793-2L11 3.207V6.5a.5.5 0 0 0 .5.5h3.293Z" }), tp.createElement("path", { className: Km.secondary, d: "M10 12.1a.5.5 0 0 1-1 0V11H7.9a.5.5 0 0 1 0-1h1.6a.5.5 0 0 1 .5.5v1.6ZM6.3 10a.5.5 0 0 1 0 1H4.7a.5.5 0 0 1 0-1h1.6Zm-3.2 0a.5.5 0 0 1 0 1H2v1.1a.5.5 0 0 1-1 0v-1.6a.5.5 0 0 1 .5-.5h1.6ZM1 13.7a.5.5 0 0 1 1 0v1.6a.5.5 0 0 1-1 0v-1.6Zm0 3.2a.5.5 0 0 1 1 0V18h1.1a.5.5 0 0 1 0 1H1.5a.5.5 0 0 1-.5-.5v-1.6ZM4.7 19a.5.5 0 0 1 0-1h1.6a.5.5 0 0 1 0 1H4.7Zm3.2 0a.5.5 0 0 1 0-1H9v-1.1a.5.5 0 0 1 1 0v1.6a.5.5 0 0 1-.5.5H7.9Zm2.1-3.7a.5.5 0 0 1-1 0v-1.6a.5.5 0 0 1 1 0v1.6Z" }), tp.createElement("path", { className: Km.accent, d: "M6 13a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0v-3Z" }), tp.createElement("path", { className: Km.accent, fillOpacity: ".62", d: "M7.5 14a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0v-2Z" }), tp.createElement("path", { className: Km.accent, fillOpacity: ".38", d: "M4.5 15a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0v-1Z" }));
const xae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "M18.5 20a.5.5 0 0 1-.5.5h-3.5V22H18a2 2 0 0 0 2-2V9.828a2 2 0 0 0-.586-1.414l-5.829-5.828a.483.483 0 0 0-.049-.041l-.036-.029a2.072 2.072 0 0 0-.219-.18.623.623 0 0 0-.08-.044l-.048-.024-.05-.029c-.054-.031-.109-.063-.166-.087a1.977 1.977 0 0 0-.624-.138c-.02-.001-.039-.004-.059-.007C12.227 2.004 12.2 2 12.172 2H6a2 2 0 0 0-2 2v5.5h1.5V4a.5.5 0 0 1 .5-.5h6V8a2 2 0 0 0 2 2h4.5v10Zm-5-15.379L17.378 8.5H14a.5.5 0 0 1-.5-.5V4.621Z" }), tp.createElement("path", { className: Km.secondary, d: "M13.5 13.45a.75.75 0 0 1-1.5 0V12h-1.45a.75.75 0 0 1 0-1.5h2.2a.75.75 0 0 1 .75.75v2.2ZM8.35 10.5a.75.75 0 0 1 0 1.5h-2.2a.75.75 0 0 1 0-1.5h2.2Zm-4.4 0a.75.75 0 0 1 0 1.5H2.5v1.45a.75.75 0 0 1-1.5 0v-2.2a.75.75 0 0 1 .75-.75h2.2ZM1 15.65a.75.75 0 0 1 1.5 0v2.2a.75.75 0 0 1-1.5 0v-2.2Zm0 4.4a.75.75 0 0 1 1.5 0v1.45h1.45a.75.75 0 0 1 0 1.5h-2.2a.75.75 0 0 1-.75-.75v-2.2ZM6.15 23a.75.75 0 0 1 0-1.5h2.2a.75.75 0 0 1 0 1.5h-2.2Zm4.4 0a.75.75 0 0 1 0-1.5H12v-1.45a.75.75 0 0 1 1.5 0v2.2a.75.75 0 0 1-.75.75h-2.2Zm2.95-5.15a.75.75 0 0 1-1.5 0v-2.2a.75.75 0 0 1 1.5 0v2.2Z" }), tp.createElement("path", { className: Ym.accent, fillOpacity: ".38", d: "M5.5 17.25a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0v-1.5Z" }), tp.createElement("path", { className: Ym.accent, d: "M8 14.75a.75.75 0 0 0-1.5 0v4a.75.75 0 0 0 1.5 0v-4Z" }), tp.createElement("path", { className: Ym.accent, fillOpacity: ".62", d: "M10.5 15.75a.75.75 0 0 0-1.5 0v3a.75.75 0 0 0 1.5 0v-3Z" }));
const wae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, fillOpacity: ".85", d: "M17 8v6.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5V8h1v4h3V8h1v4h4V8h1v4h3V8h1Zm-1 5h-3v3h1.5a1.5 1.5 0 0 0 1.493-1.356L16 14.5V13Zm-4 0H8v3h4v-3Zm-8 1.5a1.5 1.5 0 0 0 1.356 1.493L5.5 16H7v-3H4v1.5Z" }), tp.createElement("path", { className: Km.secondary, d: "M3 8V5.5A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5V8H3Zm13-1V5.5a1.5 1.5 0 0 0-1.356-1.493L14.5 4h-9a1.5 1.5 0 0 0-1.493 1.356L4 5.5V7h12Z" }));
const Tae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, fillOpacity: ".62", d: "M21 10v7.75A3.25 3.25 0 0 1 17.75 21H6.25A3.25 3.25 0 0 1 3 17.75V10h1.5v4h4v-4H10v4h4v-4h1.5v4h4v-4H21Zm-5.5 5.5v4h2.25a1.75 1.75 0 0 0 1.75-1.75V15.5h-4Zm-7 0h-4v2.25c0 .966.784 1.75 1.75 1.75H8.5v-4Zm1.5 4h4v-4h-4v4Z" }), tp.createElement("path", { className: Km.secondary, d: "M3 10V6.25A3.25 3.25 0 0 1 6.25 3h11.5A3.25 3.25 0 0 1 21 6.25V10H3Zm1.5-3.75V8.5h15V6.25a1.75 1.75 0 0 0-1.75-1.75H6.25A1.75 1.75 0 0 0 4.5 6.25Z" }));
const Eae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, fillOpacity: ".85", d: "M17 8v6.5a2.5 2.5 0 0 1-2.5 2.5H8v-1h4v-3H8v-1h4V8h1v4h3V8h1Zm-2.5 8a1.5 1.5 0 0 0 1.493-1.356L16 14.5V13h-3v3h1.5Z" }), tp.createElement("path", { className: Km.secondary, d: "M8 17H5.5A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5V8H8v9Zm-4-2.5a1.5 1.5 0 0 0 1.356 1.493L5.5 16H7v-3H4v1.5ZM13 4v3h3V5.5a1.5 1.5 0 0 0-1.356-1.493L14.5 4H13Zm-1 0H8v3h4V4ZM7 4H5.5a1.5 1.5 0 0 0-1.493 1.356L4 5.5V7h3V4Zm0 4H4v4h3V8Z" }));
const Fae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, fillOpacity: ".62", d: "M21 10v7.75A3.25 3.25 0 0 1 17.75 21H10v-1.5h4v-4h-4V14h4v-4h1.5v4h4v-4H21Zm-5.5 9.5h2.25a1.75 1.75 0 0 0 1.75-1.75V15.5h-4v4Z" }), tp.createElement("path", { className: Km.secondary, d: "M10 21H6.25A3.25 3.25 0 0 1 3 17.75V6.25A3.25 3.25 0 0 1 6.25 3h11.5A3.25 3.25 0 0 1 21 6.25V10H10v11Zm-5.5-5.5v2.25c0 .966.784 1.75 1.75 1.75H8.5v-4h-4Zm11-7h4V6.25a1.75 1.75 0 0 0-1.75-1.75H15.5v4ZM4.5 10v4h4v-4h-4Zm1.75-5.5A1.75 1.75 0 0 0 4.5 6.25V8.5h4v-4H6.25Zm7.75 0h-4v4h4v-4Z" }));
const Mae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6Zm3-2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H5Z" }), tp.createElement("path", { className: Km.secondary, d: "M10.5 7H12v.5a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0V7h1.5v6H9a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-.5V7Z" }));
const kae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "M5.75 3A3.75 3.75 0 0 0 2 6.75v10.5A3.75 3.75 0 0 0 5.75 21h12.5A3.75 3.75 0 0 0 22 17.25V6.75A3.75 3.75 0 0 0 18.25 3H5.75ZM3.5 6.75A2.25 2.25 0 0 1 5.75 4.5h12.5a2.25 2.25 0 0 1 2.25 2.25v10.5a2.25 2.25 0 0 1-2.25 2.25H5.75a2.25 2.25 0 0 1-2.25-2.25V6.75Z" }), tp.createElement("path", { className: Km.secondary, d: "M15.5 7.5h-2.75v9h.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5h.5v-9H8.5v.75a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 7.75 6h8.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0V7.5Z" }));
const Pae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.414c0-.398-.158-.779-.439-1.06l-3.915-3.915A1.499 1.499 0 0 0 10.586 2H6ZM5 4a1 1 0 0 1 1-1h4v3.5A1.5 1.5 0 0 0 11.5 8H15v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4Zm9.793 3H11.5a.5.5 0 0 1-.5-.5V3.207L14.793 7Z" }), tp.createElement("path", { className: Km.secondary, d: "M14 10.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0Zm-.5 1.5a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm.5 2.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0ZM11.5 10a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5Zm.5 2.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5Zm-.5 1.5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5Z" }));
const Nae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "m19.414 8.414-5.829-5.828a.483.483 0 0 0-.049-.041l-.036-.029a2.072 2.072 0 0 0-.219-.18c-.025-.017-.053-.03-.08-.044l-.048-.024-.05-.029c-.054-.031-.109-.063-.166-.087a1.977 1.977 0 0 0-.624-.138c-.02-.001-.039-.004-.059-.007C12.227 2.004 12.2 2 12.172 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9.828a2 2 0 0 0-.586-1.414ZM18.5 20a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .5-.5h6V8a2 2 0 0 0 2 2h4.5v10Zm-5-15.379L17.378 8.5H14a.5.5 0 0 1-.5-.5V4.621Z" }), tp.createElement("path", { className: Km.secondary, d: "M17 12.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Zm-.75 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm.75 3.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Zm-3.75-6.75a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5h5.5Zm.75 3.75a.75.75 0 0 0-.75-.75h-5.5a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 .75-.75Zm-.75 2.25a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5h5.5Z" }));
const Dae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M4 13.5a.5.5 0 0 1 1 0v.5a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-.5a.5.5 0 0 1 1 0v.5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-.5Zm0-5V4a2 2 0 0 1 2-2h3.586c.398 0 .779.158 1.06.439l3.915 3.915c.281.281.439.662.439 1.06V8.5a.5.5 0 0 1-1 0V8h-3.5A1.5 1.5 0 0 1 9 6.5V3H6a1 1 0 0 0-1 1v4.5a.5.5 0 0 1-1 0Zm6-2a.5.5 0 0 0 .5.5h3.293L10 3.207V6.5ZM16 8a1 1 0 0 1 1 1v5.061A3.94 3.94 0 0 1 13.061 18H7a1 1 0 0 1-1-1h7a3 3 0 0 0 3-3V8Z" }), tp.createElement("path", { className: Km.secondary, d: "M5 10.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 1 0Zm10 0v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 1 0Z" }));
const Lae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.414c0-.398-.158-.779-.439-1.06l-3.915-3.915A1.499 1.499 0 0 0 10.586 2H6ZM5 4a1 1 0 0 1 1-1h4v3.5A1.5 1.5 0 0 0 11.5 8H15v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4Zm9.793 3H11.5a.5.5 0 0 1-.5-.5V3.207L14.793 7Z" }), tp.createElement("path", { className: Km.accent, d: "M10.5 9.5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0v-6Z" }), tp.createElement("path", { className: Km.secondary, d: "M13 11.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0v-4Z" }), tp.createElement("path", { className: Km.accent, fillOpacity: ".62", d: "M8 13.5a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0v-2Z" }));
const Hae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Km.secondary, fillOpacity: ".38", d: "M10 3v3H5V3h5Zm5 11v3H5v-3h10Z" }), tp.createElement("path", { className: Km.secondary, d: "M8.5 5.5A.5.5 0 0 1 8 6H7a.5.5 0 0 1 0-1h1a.5.5 0 0 1 .5.5Zm-.5 9a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 .5.5Zm3 0a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 .5.5Zm3 0a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 .5.5Z" }), tp.createElement("path", { className: Ym.text, d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.414c0-.398-.158-.779-.439-1.06l-3.915-3.915A1.499 1.499 0 0 0 10.586 2H6ZM5 4a1 1 0 0 1 1-1h4v3.5A1.5 1.5 0 0 0 11.5 8H15v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4Zm9.793 3H11.5a.5.5 0 0 1-.5-.5V3.207L14.793 7Z" }), tp.createElement("path", { className: Km.accent, d: "M14 9.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1 0-1h7a.5.5 0 0 1 .5.5Zm-4.5 2a.5.5 0 0 1-.5.5H6.5a.5.5 0 0 1 0-1H9a.5.5 0 0 1 .5.5Zm4.5 0a.5.5 0 0 1-.5.5H11a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 .5.5Z" }));
const Iae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Km.accent, d: "M12.835 6.183a2 2 0 1 0 .982.982L12 8l.835-1.817Z" }), tp.createElement("path", { className: Km.secondary, d: "M9 9.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0v-4Z" }), tp.createElement("path", { className: Km.secondary, fillOpacity: ".38", d: "M11 11.5a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0v-2Z" }), tp.createElement("path", { className: Km.accent, fillOpacity: ".62", d: "M7 12.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0v-1Z" }), tp.createElement("path", { className: Ym.text, d: "M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3h-9ZM4 5.5A1.5 1.5 0 0 1 5.5 4h9A1.5 1.5 0 0 1 16 5.5v9a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 4 14.5v-9Z" }));
const _ae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M6 4a2 2 0 0 0-2 2v1.5a.5.5 0 0 1-1 0V6a3 3 0 0 1 3-3h1.5a.5.5 0 0 1 0 1H6Zm6.5-1a.5.5 0 0 0 0 1H14a2 2 0 0 1 2 2v1.5a.5.5 0 0 0 1 0V6a3 3 0 0 0-3-3h-1.5Zm-9 9a.5.5 0 0 1 .5.5V14a2 2 0 0 0 2 2h1.5a.5.5 0 0 1 0 1H6a3 3 0 0 1-3-3v-1.5a.5.5 0 0 1 .5-.5Zm13.5.5a.5.5 0 0 0-1 0V14a2 2 0 0 1-2 2h-1.5a.5.5 0 0 0 0 1H14a3 3 0 0 0 3-3v-1.5Z" }), tp.createElement("path", { className: Km.secondary, d: "M10 14.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm.624-1.995a.624.624 0 1 0-1.249-.001.624.624 0 0 0 1.249.001Zm1.229-3.552c0-1.104-.822-1.95-1.853-1.95-1.048 0-1.864.818-1.853 1.955a.501.501 0 0 0 1-.01c-.006-.579.359-.945.853-.945.472 0 .853.392.853.95 0 .202-.071.315-.359.544l-.278.215c-.506.404-.716.717-.716 1.288a.5.5 0 0 0 .992.09l.011-.156c.017-.148.1-.254.346-.448l.277-.214c.513-.411.727-.733.727-1.319Z" }));
const Vae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M3.5 8.502V7.498c0-.275.223-.498.498-.498h.004c.275 0 .498.223.498.498v1.004A.498.498 0 0 1 4.002 9h-.004a.498.498 0 0 1-.498-.498Zm12-1.004v1.004a.498.498 0 0 1-.498.498h-.004a.498.498 0 0 1-.498-.498V7.498c0-.275.223-.498.498-.498h.004c.275 0 .498.223.498.498ZM13.5 3h-8a1 1 0 0 0-1 1v1.502A.498.498 0 0 1 4.002 6h-.004a.498.498 0 0 1-.498-.498V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1.502a.498.498 0 0 1-.498.498h-.004a.498.498 0 0 1-.498-.498V4a1 1 0 0 0-1-1Zm0 15h-8a2 2 0 0 1-2-2v-1.502c0-.275.223-.498.498-.498h.004c.275 0 .498.223.498.498V16a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1.502c0-.275.223-.498.498-.498h.004c.275 0 .498.223.498.498V16a2 2 0 0 1-2 2Zm-10-6.502c0-.275.223-.498.498-.498h.004c.275 0 .498.223.498.498v1.004a.498.498 0 0 1-.498.498h-.004a.498.498 0 0 1-.498-.498v-1.004Zm12 0v1.004a.498.498 0 0 1-.498.498h-.004a.498.498 0 0 1-.498-.498v-1.004c0-.275.223-.498.498-.498h.004c.275 0 .498.223.498.498Z" }));
const Rae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M4 16V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2ZM14 3H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1Zm-1.41 3.992L12.5 7h-5a.5.5 0 0 1-.09-.992L7.5 6h5a.5.5 0 0 1 .09.992ZM7.5 10h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1Z" }));
const Aae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M14 18H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2Zm0-15H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1Z" }), tp.createElement("path", { className: Km.secondary, d: "M7 4a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2H7Z" }));
const Oae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M14 18H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2Zm0-15H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1Z" }), tp.createElement("path", { className: Km.secondary, d: "M14 7.52A1.52 1.52 0 0 0 12.48 6H7.52A1.52 1.52 0 0 0 6 7.52v4.96c0 .839.681 1.52 1.52 1.52h4.96A1.52 1.52 0 0 0 14 12.48V7.52Z" }));
const Bae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M14 18H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2Zm0-15H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1Z" }), tp.createElement("path", { className: Km.secondary, d: "M7 14a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2H7Z" }));
const zae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M9.5 8v6h2V8a1 1 0 0 0-2 0Zm-1 3V8a2 2 0 1 1 4 0v1h1a2 2 0 0 1 2 2v3.5a.5.5 0 0 1-.5.5H5.5a.5.5 0 0 1-.5-.5V13a2 2 0 0 1 2-2h1.5Zm0 3v-2H7a1 1 0 0 0-1 1v1h2.5Zm4 0h2v-3a1 1 0 0 0-1-1h-1v4Z" }), tp.createElement("path", { className: Km.secondary, d: "M17.5 16a.5.5 0 0 1 0 1h-14a.5.5 0 0 1-.5-.5v-14a.5.5 0 0 1 1 0V16h13.5Z" }));
const $ae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M8.5 9v6h3V9a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1Zm-1 3V9a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v1H14a2 2 0 0 1 2 2v3.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V14a2 2 0 0 1 2-2h1.5Zm0 3v-2H6a1 1 0 0 0-1 1v1h2.5Zm5 0H15v-3a1 1 0 0 0-1-1h-1.5v4Z" }), tp.createElement("path", { className: Km.secondary, d: "M4 3a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2H4Z" }));
const Wae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Km.secondary, d: "M4 15a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2H4Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M8.5 6v6h3V6a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1Zm-1 3V6a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v1H14a2 2 0 0 1 2 2v3.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V11a2 2 0 0 1 2-2h1.5Zm0 3v-2H6a1 1 0 0 0-1 1v1h2.5Zm5 0H15V9a1 1 0 0 0-1-1h-1.5v4Z" }));
const jae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M9 6v5h2V6a1 1 0 0 0-2 0ZM8 8V6a2 2 0 1 1 4 0v1h1a2 2 0 0 1 2 2v2.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10c0-1.105.395-2 1.5-2H8Zm0 3V9H6.5c-.552 0-.5.448-.5 1v1h2Zm4 0h2V9a1 1 0 0 0-1-1h-1v3Z" }), tp.createElement("path", { className: Km.secondary, d: "M5.5 16a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 5.5 16Zm8 0a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 13.5 16Z" }), tp.createElement("path", { className: Ym.text, d: "M9 15.997v.006a.496.496 0 0 1-.497.497H6.497A.496.496 0 0 1 6 16.003v-.006c0-.275.222-.497.497-.497h2.006c.275 0 .497.222.497.497Zm8 0v.006a.496.496 0 0 1-.497.497h-2.006a.496.496 0 0 1-.497-.497v-.006c0-.275.222-.497.497-.497h2.006c.275 0 .497.222.497.497Z" }));
const Zae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Km.secondary, d: "M8.5 7v7h3V7a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1Zm-1 3V7a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v1H14a2 2 0 0 1 2 2v4.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V12a2 2 0 0 1 2-2h1.5Zm0 4v-3H6a1 1 0 0 0-1 1v2h2.5Zm5 0H15v-4a1 1 0 0 0-1-1h-1.5v5Z" }));
const Gae = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Km.secondary, d: "M14.971 3A2.03 2.03 0 0 1 17 5.029v.552a.5.5 0 0 1-1 0v-.552A1.03 1.03 0 0 0 14.971 4h-.662a.5.5 0 0 1 0-1h.662ZM5.029 3h.662a.5.5 0 0 1 0 1h-.662A1.03 1.03 0 0 0 4 5.029v.552a.5.5 0 0 1-1 0v-.552A2.03 2.03 0 0 1 5.029 3ZM4 14.971A1.03 1.03 0 0 0 5.029 16h.662a.5.5 0 0 1 0 1h-.662A2.03 2.03 0 0 1 3 14.971v-.552a.5.5 0 0 1 1 0v.552ZM14.971 16A1.03 1.03 0 0 0 16 14.971v-.552a.5.5 0 0 1 1 0v.552A2.03 2.03 0 0 1 14.971 17h-.662a.5.5 0 0 1 0-1h.662ZM11.662 3a.5.5 0 0 1 0 1H8.338a.5.5 0 0 1 0-1h3.324ZM8.338 17a.5.5 0 0 1 0-1h3.324a.5.5 0 0 1 0 1H8.338Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M9 8v5h2V8a1 1 0 0 0-2 0Zm-1 2V8a2 2 0 1 1 4 0v1h1a2 2 0 0 1 2 2v2.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V12c0-1.105.395-2 1.5-2H8Zm0 3v-2H6.5c-.552 0-.5.448-.5 1v1h2Zm4 0h2v-2a1 1 0 0 0-1-1h-1v3Z" }));
const Uae = () => ep.useContext(FO);
const qae = (e14, t10) => e14.Group ? `DynamicMember_GroupName#${e14.Group.Name}` : e14.Header ? `VisibleStaticMember_ItemName#${e14.Header.Item.Name}` : `HiddenStaticMember_Body${t10 ? "Row" : "Column"}Index#${e14.BodyIndex}`;
const Yae = (e14, t10, n10) => e14.reduce((e15, r10) => {
  const o10 = ((e16, t11, n11) => {
    const r11 = [];
    const o11 = (e17) => {
      var _a2;
      const a10 = qae(e17, t11);
      if (n11 == null ? void 0 : n11.includes(e17.BodyIndex)) return a10 && r11.push(a10), true;
      if (rj(e17) || rj((_a2 = e17.Header) == null ? void 0 : _a2.Item)) return a10 && r11.push(a10), true;
      if (e17.Children.length) {
        let t12 = false;
        for (const n12 of e17.Children) o11(n12) && (!r11.includes(a10) && a10 && r11.push(a10), t12 = true);
        return t12;
      }
      return false;
    };
    return o11(e16), r11;
  })(r10, t10, n10);
  return o10.length && e15.push(...o10), e15;
}, []);
function Kae(e14) {
  const t10 = e14.Body;
  const n10 = e14.RowHierarchy;
  const r10 = e14.ColumnHierarchy;
  const o10 = e14.$columns;
  const a10 = e14.$rows;
  if (oj(o10)) {
    const t11 = e14.Corner.length ? e14.Corner[0].length : 0;
    const n11 = o10.collection.slice(t11).map((e15, t12) => e15.$selected ? t12 : null).filter(Ie);
    return { selectedColumnItems: Yae(r10.Members, false, n11), selectedRowItems: [] };
  }
  if (oj(a10)) {
    const t11 = e14.Corner.length ? e14.Corner.length : 0;
    const r11 = a10.collection.slice(t11).map((e15, t12) => e15.$selected ? t12 : null).filter(Ie);
    return { selectedColumnItems: [], selectedRowItems: Yae(n10.Members, true, r11) };
  }
  const i10 = [];
  const s10 = [];
  if (oj(t10)) {
    const e15 = ((e16) => {
      const t11 = [];
      return e16.Rows.forEach((e17, n11) => {
        aj(e17) && e17.Cells.forEach((e18, r11) => {
          rj(e18 == null ? void 0 : e18.Item) && t11.push({ row: n11, column: r11 });
        });
      }), t11;
    })(t10);
    const o11 = e15.map((e16) => e16.column);
    const a11 = e15.map((e16) => e16.row);
    i10.push(...Yae(r10.Members, false, o11)), s10.push(...Yae(n10.Members, true, a11));
  }
  return oj(n10) && s10.push(...Yae(n10.Members, true)), oj(r10) && i10.push(...Yae(r10.Members, false)), { selectedColumnItems: i10, selectedRowItems: s10 };
}
const [Xae, Jae] = Dp("wd-group-editor-member-container");
const [Qae, eie, tie] = Dp("wd-group-editor-member");
const [nie] = tie("items");
const rie = (e14) => {
  var _a2;
  const { member: t10, path: n10, hierarchy: r10, advancedMode: o10, dispatch: a10, noBranch: i10, canToggleMemberType: s10, selectedItemsIds: l10 } = e14;
  const { instanceId: c10, lockLayout: u10 } = Uae();
  const { t: d10 } = vp("groupEditor");
  const p10 = () => {
    a10(c5(`${n10}`, t10.Type));
  };
  const m10 = () => {
    if (!g10(t10)) return;
    const e15 = { descriptor: Zq(sY, "group.groupExpressions", "string_expr", "Group.GroupExpressions.0"), objectValues: [t10], defaultValues: [{ Group: { GroupExpressions: [""] } }] };
    a10(_A.of(c10).open("connectedExpressionEditor", e15));
  };
  const h10 = () => ({ type: "button", value: "expr", text: d10("btnEditExpression", "Edit Expression") });
  const f10 = () => s10(t10) ? { type: "button", value: "toggle.member.type", text: t10.Type === rW.staticTablixMember ? d10("btnEnableGroup", "Enable Group") : d10("btnDisableGroup", "Disable Group") } : null;
  const g10 = ({ Type: e15 }) => e15 === rW.dynamicTablixMember;
  if (!o10 && !t10.Header && !g10(t10)) return null;
  const y10 = (g10(t10) ? "dynamic" : ((_a2 = t10.Header) == null ? void 0 : _a2.Item) && "static") || "hidden";
  const v10 = rj(t10) || t10.Header && rj(t10.Header.Item);
  const b10 = ((e15) => e15.Group ? e15.Header ? e15.Group.Name : `(${e15.Group.Name})` : e15.Header ? e15.Header.Item.Name : d10("textHiddenStatic", "(Static)"))(t10);
  const S10 = (() => {
    if (!u10) {
      const e15 = g10(t10) ? [f10(), { type: "header", header: d10("headingAddGroup", "Add Group") }, { type: "button", value: "group.parent", text: d10("addGroup.btnParent", "Parent") }, { type: "button", value: "group.child", text: d10("addGroup.btnChild", "Child") }, { type: "button", value: "group.before", text: d10("addGroup.btnAdjacentBefore", "Adjacent Before") }, { type: "button", value: "group.after", text: d10("addGroup.btnAdjacentAfter", "Adjacent After") }, { type: "header", header: d10("headingAddTotal", "Add Total") }, { type: "button", value: "total.before", text: d10("addTotal.btnBefore", "Before") }, { type: "button", value: "total.after", text: d10("addTotal.btnAfter", "After") }, { type: "splitter" }, h10(), { type: "button", value: "delete", text: d10("btnDelete", "Delete") }] : [f10()];
      return e15.every((e16) => !e16) ? null : e15.filter((e16) => null != e16);
    }
    return g10(t10) ? [h10()] : null;
  })();
  const C10 = { id: b10, items: S10 || void 0, icon: nf(vh, { rotate: "90" }), hiddenChevron: true, size: "small", menuWidth: 160, accent: v10 ? "full" : "none", background: "transparent", onSelect: (e15) => {
    switch (e15) {
      case "toggle.member.type":
        a10(EZ());
        break;
      case "group.parent":
        a10(fZ(r10, pZ.PARENT));
        break;
      case "group.child":
        a10(fZ(r10, pZ.CHILD));
        break;
      case "group.before":
        a10(fZ(r10, pZ.BEFORE));
        break;
      case "group.after":
        a10(fZ(r10, pZ.AFTER));
        break;
      case "total.before":
        a10(xZ(pZ.BEFORE));
        break;
      case "total.after":
        a10(xZ(pZ.AFTER));
        break;
      case "expr":
        m10();
        break;
      case "delete":
        a10((r10 === uZ.ROW && CZ || SZ)());
    }
  }, onToggle: (e15) => e15 && p10() };
  const x10 = kp(Xae, { [Jae("no-branch")]: i10 });
  const w10 = qae(t10, r10 === uZ.ROW);
  const T10 = kp(Qae, eie(y10), { [eie("selected")]: v10, [eie("tree-selected")]: l10 == null ? void 0 : l10.includes(w10) });
  return tp.createElement("div", { className: x10 }, tp.createElement("div", { className: "branch" }, tp.createElement("span", { className: "corner" }), tp.createElement("span", { className: "line" })), tp.createElement("div", { className: T10, onClick: p10, onDoubleClick: m10 }, tp.createElement("div", { className: "icon" }, tp.createElement("span", null)), tp.createElement("div", { className: "text" }, b10), JW(t10.Type) && S10 && tp.createElement("div", { className: "action" }, tp.createElement(UF, __spreadValues({}, C10)))), tp.createElement("div", { className: nie }, t10.Children && ((e15) => e15.map((e16, t11) => {
    const i11 = { dispatch: a10, advancedMode: o10, member: e16, path: `${n10}.Children.${t11}`, hierarchy: r10, canToggleMemberType: s10, selectedItemsIds: l10 };
    return tp.createElement(rie, __spreadValues({ key: `${i11.path}_${t11}` }, i11));
  }))(t10.Children)));
};
rie.displayName = "MemberItem";
const [oie, aie, iie] = Dp("wd-group-editor-hierarchy");
const [sie] = iie("content");
const lie = (e14) => {
  const { type: t10, title: n10, hierarchy: r10, path: o10, advancedMode: a10, dispatch: i10, canToggleMemberType: s10, selectedItemsIds: l10 } = e14;
  const [c10, u10] = ep.useState(true);
  const d10 = rf(oh);
  const p10 = rf(oh, { rotate: "180" });
  if (!a10 && !r10.Members.some((e15) => e15.Header) && !r10.Members.some((e15) => "dynamictablixmember" === e15.Type)) return null;
  const m10 = (r10 && r10.Members && r10.Members || []).map((e15, n11) => {
    const r11 = { dispatch: i10, advancedMode: a10, member: e15, path: `${o10}.Members.${n11}`, hierarchy: t10, canToggleMemberType: s10, noBranch: true, selectedItemsIds: l10 };
    return tp.createElement(rie, __spreadValues({ key: `${r11.path}_${n11}` }, r11));
  });
  const h10 = { text: n10, level: "info", actions: { rounded: true, defaultBackground: "transparent", items: [{ type: "button", accent: "icon", icon: c10 ? p10 : d10, onClick: () => {
    u10(!c10);
  } }] } };
  const f10 = kp(oie, { [aie("collapsed")]: !c10 });
  return 0 === m10.length ? null : tp.createElement("div", { className: f10 }, tp.createElement(LE, __spreadValues({}, h10)), tp.createElement("div", { className: sie }, m10));
};
rie.displayName = "Hierarchy";
const [cie, , uie] = Dp("wd-group-editor");
const [die] = uie("content");
const pie = (e14) => {
  const { item: t10, advancedMode: n10, toggleModeFn: r10, dispatch: o10 } = e14;
  const a10 = ((e15) => {
    const t11 = [];
    return Sj(e15, (e16, n11) => {
      e16.Type && zW(e16.Type) && (BQ(e16) || rj(e16)) && t11.push({ item: e16, path: n11 });
    }), 1 === t11.length ? t11[0] : null;
  })(t10);
  const { t: i10 } = vp("groupEditor");
  if (!a10) return tp.createElement("div", { className: cie }, tp.createElement("p", null, i10("textSelectTablix", "Select a tablix to edit its groups")));
  const s10 = a10.item;
  const l10 = a10.path;
  const c10 = (e15, t11) => ({ dispatch: o10, advancedMode: n10, type: e15, title: e15 === uZ.ROW ? i10("headingRowGroups", "Row Groups") : i10("headingColumnGroups", "Column Groups"), hierarchy: s10 && s10[e15], path: `${l10}.${e15}`, canToggleMemberType: (t12) => {
    if (!t12 || !JW(t12.Type)) return false;
    return (t12.Type === rW.staticTablixMember ? tQ : eQ)(s10, e15, () => t12);
  }, selectedItemsIds: t11 });
  const { selectedColumnItems: u10, selectedRowItems: d10 } = Kae(s10);
  const p10 = c10(uZ.ROW, d10);
  const m10 = c10(uZ.COLUMN, u10);
  const h10 = { block: true, size: "small", text: i10("labelAdvancedMode", "Advanced Mode"), checked: n10, textAlign: "left", onToggle: r10 };
  return tp.createElement("div", { className: cie }, tp.createElement("div", { className: die }, tp.createElement(bF, null, tp.createElement(lie, __spreadValues({}, p10)), tp.createElement(lie, __spreadValues({}, m10)))), tp.createElement(SM, __spreadValues({}, h10)));
};
pie.displayName = "GroupEditor";
const [mie, , hie] = Dp("wd-layer-list");
const [fie] = hie("content");
const [gie, yie, vie] = Dp("wd-layer-item");
const bie = yie("selected");
const [Sie] = vie("button");
const Cie = () => {
  const { Layers: e14, $currentLayerName: t10 } = h9();
  const n10 = PA();
  const { t: r10 } = vp("components");
  const o10 = rf(hh);
  const a10 = rf(fh);
  const i10 = rf(gh);
  const s10 = rf(yh);
  const l10 = rf(Xm);
  const c10 = rf(dh);
  const u10 = rf(uh);
  const d10 = ep.useCallback((e15, t11, r11) => () => {
    n10(T2({ layerName: e15, propertyName: t11, value: r11 }));
  }, [n10]);
  const p10 = ep.useCallback(() => {
    n10(C2());
  }, [n10]);
  const m10 = ep.useCallback((e15) => () => {
    e15 > 0 && n10(x2({ index: e15 }));
  }, [n10]);
  const h10 = ep.useCallback((t11) => () => {
    const r11 = e14[t11].Name;
    n10(w2({ layerName: r11 }));
  }, [e14, n10]);
  const f10 = ep.useCallback((e15, t11) => () => {
    n10(rz([w2({ layerName: e15 }), c5(`Layers.${t11}`)]));
  }, [n10]);
  const g10 = ep.useCallback((e15) => e15 === t10, [t10]);
  const y10 = ep.useCallback((e15) => g10(e15.Name) ? "full" : e15.DesignerVisible ? "none" : "icon", [g10]);
  const v10 = ep.useCallback((e15) => g10(e15.Name) ? "full" : e15.DesignerLock ? "icon" : "none", [g10]);
  const b10 = (e15, t11) => [{ type: "button", icon: e15.DesignerVisible ? o10 : a10, onClick: d10(e15.Name, "DesignerVisible", !e15.DesignerVisible), accent: y10(e15), title: e15.DesignerVisible ? r10("layerList.titleHideLayer", "Hide Layer") : r10("layerList.titleShowLayer", "Show Layer") }, { type: "button", icon: e15.DesignerLock ? i10 : s10, onClick: d10(e15.Name, "DesignerLock", !e15.DesignerLock), accent: v10(e15), title: e15.DesignerLock ? r10("layerList.titleUnlockLayer", "Unlock Layer") : r10("layerList.titleLockLayer", "Lock Layer") }, { type: "button", icon: c10, onClick: f10(e15.Name, t11), accent: g10(e15.Name) ? "full" : "none", title: r10("layerList.titleEditLayer", "Edit Layer") }, { type: "button", icon: u10, onClick: m10(t11), accent: g10(e15.Name) ? "full" : "none", disabled: 0 === t11 || J7(e15), title: 0 === t11 ? r10("layerList.titleDefaultLayerCannotBeDeleted", "Default layer can't be deleted") : r10("layerList.titleDeleteLayer", "Delete layer") }];
  return tp.createElement("div", { className: mie }, tp.createElement(qm, { onClick: p10, size: "small", icon: l10, text: r10("layerList.btnAddLayer", "Add Layer"), width: "100%", accent: "icon", block: true }), tp.createElement(bF, { direction: "vertical" }, tp.createElement("div", { className: fie }, e14.map((e15, n11) => tp.createElement("div", { key: `layer-${e15.Name}`, className: kp(gie, { [bie]: g10(e15.Name) }) }, tp.createElement(qm, { block: true, width: "100%", size: "small", text: e15.Name, background: "transparent", accent: e15.Name === t10 ? "full" : "none", onClick: h10(n11), customCSS: Sie }), tp.createElement(sM, { size: "small", defaultBackground: "transparent", items: b10(e15, n11), disabled: J7(e15) }))))));
};
Cie.displayName = "LayerList";
const xie = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M4 5.002c0-1.007.875-1.755 1.9-2.223 1.298-.54 2.694-.804 4.1-.777 1.406-.027 2.802.237 4.1.777 1.025.468 1.9 1.216 1.9 2.223v4.207c-.322-.091-.657-.154-1-.185V6.702c-.281.206-.582.382-.9.525-1.298.539-2.694.802-4.1.775-1.406.027-2.802-.238-4.1-.777-.318-.142-.619-.317-.9-.523v8.3c0 .374.356.875 1.318 1.313 1.044.428 2.156.66 3.281.686.184.359.405.695.659 1.003-.086 0-.172 0-.258-.002-1.406.027-2.802-.238-4.1-.777-1.025-.468-1.9-1.216-1.9-2.223v-10Zm1 0c0 .374.356.875 1.318 1.313 1.167.479 2.421.713 3.682.687 1.261.026 2.515-.208 3.682-.687C14.644 5.877 15 5.376 15 5.002s-.356-.875-1.318-1.313c-1.167-.479-2.421-.713-3.682-.687-1.261-.026-2.515.208-3.682.687C5.356 4.127 5 4.628 5 5.002Z" }), tp.createElement("path", { className: Km.accent, d: "M14.5 19c2.485 0 4.5-2.015 4.5-4.5S16.985 10 14.5 10 10 12.015 10 14.5s2.015 4.5 4.5 4.5Zm0-7c.276 0 .5.224.5.5V14h1.5c.276 0 .5.224.5.5s-.224.5-.5.5H15v1.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5V15h-1.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H14v-1.5c0-.276.224-.5.5-.5Z" }));
const wie = tp.createElement("svg", { width: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.accent, d: "M4 6c0-.691.315-1.293.774-1.78.455-.482 1.079-.883 1.793-1.202C7.996 2.377 9.917 2 12 2c2.083 0 4.004.377 5.433 1.018.714.319 1.338.72 1.793 1.202.459.487.774 1.089.774 1.78v12c0 .691-.315 1.293-.774 1.78-.455.482-1.079.883-1.793 1.203C16.004 21.623 14.083 22 12 22c-2.083 0-4.004-.377-5.433-1.017-.714-.32-1.338-.721-1.793-1.203C4.315 19.293 4 18.691 4 18V6Zm1.5 0c0 .207.09.459.365.75.279.296.717.596 1.315.864 1.195.535 2.899.886 4.82.886 1.921 0 3.625-.351 4.82-.886.598-.268 1.036-.568 1.315-.864.275-.291.365-.543.365-.75 0-.207-.09-.459-.365-.75-.279-.296-.717-.596-1.315-.864C15.625 3.851 13.921 3.5 12 3.5c-1.921 0-3.625.351-4.82.886-.598.268-1.036.568-1.315.864-.275.291-.365.543-.365.75Zm13 2.392c-.321.221-.681.417-1.067.59C16.004 9.623 14.083 10 12 10c-2.083 0-4.004-.377-5.433-1.018-.386-.173-.746-.369-1.067-.59V18c0 .207.09.459.365.75.279.296.717.596 1.315.864 1.195.535 2.899.886 4.82.886 1.921 0 3.625-.351 4.82-.886.598-.268 1.036-.568 1.315-.864.275-.291.365-.543.365-.75V8.392Z" }));
const Tie = tp.createElement("svg", { width: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M11 21.971c-1.693-.1-3.236-.452-4.433-.988-.714-.32-1.338-.721-1.793-1.203C4.315 19.293 4 18.691 4 18V6c0-.691.315-1.293.774-1.78.455-.482 1.079-.883 1.793-1.202C7.996 2.377 9.917 2 12 2c2.083 0 4.004.377 5.433 1.018.714.319 1.338.72 1.793 1.202.459.487.774 1.089.774 1.78v5h-1.5V8.392c-.321.221-.681.417-1.067.59C16.004 9.623 14.083 10 12 10c-2.083 0-4.004-.377-5.433-1.018-.386-.173-.746-.369-1.067-.59V18c0 .207.09.459.365.75.279.296.717.596 1.315.864.983.44 2.31.756 3.82.854v1.503ZM5.5 6c0 .207.09.459.365.75.279.296.717.596 1.315.864 1.195.535 2.899.886 4.82.886 1.921 0 3.625-.351 4.82-.886.598-.268 1.036-.568 1.315-.864.275-.291.365-.543.365-.75 0-.207-.09-.459-.365-.75-.279-.296-.717-.596-1.315-.864C15.625 3.851 13.921 3.5 12 3.5c-1.921 0-3.625.351-4.82.886-.598.268-1.036.568-1.315.864-.275.291-.365.543-.365.75Z" }), tp.createElement("path", { className: Km.accent, d: "M23 14.201v6.598C23 22.014 22.014 23 20.799 23h-6.598C12.986 23 12 22.014 12 20.799v-6.598c0-1.215.986-2.201 2.201-2.201h6.598c1.215 0 2.201.986 2.201 2.201ZM21 15.5c0-.276-.224-.5-.5-.5h-6c-.276 0-.5.224-.5.5s.224.5.5.5h6c.276 0 .5-.224.5-.5Zm0 2c0-.276-.224-.5-.5-.5h-6c-.276 0-.5.224-.5.5s.224.5.5.5h6c.276 0 .5-.224.5-.5Zm0 2c0-.276-.224-.5-.5-.5h-6c-.276 0-.5.224-.5.5s.224.5.5.5h6c.276 0 .5-.224.5-.5Z" }));
tp.createElement("svg", { width: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M14.25 13.5h-7.5l-.102.007c-.366.05-.648.363-.648.743 0 .414.336.75.75.75h7.5l.102-.007c.366-.05.648-.363.648-.743 0-.414-.336-.75-.75-.75Zm3-4H6.75l-.102.007c-.366.05-.648.363-.648.743 0 .414.336.75.75.75h10.5l.102-.007c.366-.05.648-.363.648-.743 0-.414-.336-.75-.75-.75Z" }), tp.createElement("path", { className: Km.accent, d: "M18.25 5C19.769 5 21 6.231 21 7.75v8.5c0 1.519-1.231 2.75-2.75 2.75H5.75C4.231 19 3 17.769 3 16.25v-8.5C3 6.231 4.231 5 5.75 5h12.5Zm0 1.5H5.75c-.69 0-1.25.56-1.25 1.25v8.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-8.5c0-.69-.56-1.25-1.25-1.25Z" }));
const Eie = tp.createElement("svg", { width: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M5.5 7c-.276 0-.5.224-.5.5s.224.5.5.5h5c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-5Zm0 2c-.276 0-.5.224-.5.5s.224.5.5.5h3c.276 0 .5-.224.5-.5S8.776 9 8.5 9h-3Z" }), tp.createElement("path", { className: Km.accent, d: "M4.5 4C3.119 4 2 5.119 2 6.5v4C2 11.881 3.119 13 4.5 13h7c1.381 0 2.5-1.119 2.5-2.5v-4C14 5.119 12.881 4 11.5 4h-7ZM3 6.5C3 5.672 3.672 5 4.5 5h7c.828 0 1.5.672 1.5 1.5v4c0 .828-.672 1.5-1.5 1.5h-7c-.828 0-1.5-.672-1.5-1.5v-4Z" }));
tp.createElement("svg", { width: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M14 19H5.75C4.231 19 3 17.769 3 16.25v-8.5C3 6.231 4.231 5 5.75 5h12.5C19.769 5 21 6.231 21 7.75V11h-1.5V7.75c0-.69-.56-1.25-1.25-1.25H5.75c-.69 0-1.25.56-1.25 1.25v8.5c0 .69.56 1.25 1.25 1.25H14V19Zm0-4H6.75c-.414 0-.75-.336-.75-.75 0-.38.282-.694.648-.743l.102-.007H14V15Zm3.25-5.5c.414 0 .75.336.75.75 0 .38-.282.693-.648.743L17.25 11H6.75c-.414 0-.75-.336-.75-.75 0-.38.282-.693.648-.743L6.75 9.5h10.5Z" }), tp.createElement("path", { className: Km.accent, d: "M16.5 12c-.828 0-1.5.672-1.5 1.5v8c0 .828.672 1.5 1.5 1.5h5c.828 0 1.5-.672 1.5-1.5v-8c0-.828-.672-1.5-1.5-1.5h-5Zm.5 4.5h1c.276 0 .5.224.5.5s-.224.5-.5.5h-1c-.276 0-.5-.224-.5-.5s.224-.5.5-.5Zm3 0h1c.276 0 .5.224.5.5s-.224.5-.5.5h-1c-.276 0-.5-.224-.5-.5s.224-.5.5-.5Zm-3 2h1c.276 0 .5.224.5.5s-.224.5-.5.5h-1c-.276 0-.5-.224-.5-.5s.224-.5.5-.5Zm3 0h1c.276 0 .5.224.5.5s-.224.5-.5.5h-1c-.276 0-.5-.224-.5-.5s.224-.5.5-.5Zm-3 2h1c.276 0 .5.224.5.5s-.224.5-.5.5h-1c-.276 0-.5-.224-.5-.5s.224-.5.5-.5Zm3 0h1c.276 0 .5.224.5.5s-.224.5-.5.5h-1c-.276 0-.5-.224-.5-.5s.224-.5.5-.5ZM16.5 14c0-.276.224-.5.5-.5h4c.276 0 .5.224.5.5v1c0 .276-.224.5-.5.5h-4c-.276 0-.5-.224-.5-.5v-1Z" }));
const Fie = tp.createElement("svg", { width: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M7 12H4.5C3.119 12 2 10.881 2 9.5v-4C2 4.119 3.119 3 4.5 3h7c.818 0 1.544.393 2 1h-9C3.672 4 3 4.672 3 5.5v4c0 .828.672 1.5 1.5 1.5H7v1Zm0-5H5.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H7v1Zm0 2H5.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H7v1Z" }), tp.createElement("path", { className: Km.accent, d: "M9.5 5C8.672 5 8 5.672 8 6.5v7c0 .828.672 1.5 1.5 1.5h4c.828 0 1.5-.672 1.5-1.5v-7c0-.828-.672-1.5-1.5-1.5h-4ZM9 9.5c0-.276.224-.5.5-.5h1c.276 0 .5.224.5.5s-.224.5-.5.5h-1c-.276 0-.5-.224-.5-.5Zm4.5-.5c.276 0 .5.224.5.5s-.224.5-.5.5h-1c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h1ZM9 11.5c0-.276.224-.5.5-.5h1c.276 0 .5.224.5.5s-.224.5-.5.5h-1c-.276 0-.5-.224-.5-.5Zm4.5-.5c.276 0 .5.224.5.5s-.224.5-.5.5h-1c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h1ZM9 13.5c0-.276.224-.5.5-.5h1c.276 0 .5.224.5.5s-.224.5-.5.5h-1c-.276 0-.5-.224-.5-.5Zm4.5-.5c.276 0 .5.224.5.5s-.224.5-.5.5h-1c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h1ZM9 6.5c0-.276.224-.5.5-.5h4c.276 0 .5.224.5.5v1c0 .276-.224.5-.5.5h-4c-.276 0-.5-.224-.5-.5v-1Z" }));
const Mie = tp.createElement("svg", { width: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, opacity: "0.62", d: "M5.587 13.001 3.75 13c-.414 0-.75-.336-.75-.75 0-.38.282-.694.648-.743l.102-.007 1.837-.001c-.057.241-.087.493-.087.751s.03.51.087.751Zm6.326-1.503 8.337.002c.414 0 .75.336.75.75 0 .38-.282.694-.648.743L20.25 13l-8.337.001c.057-.241.087-.493.087-.751 0-.259-.03-.51-.087-.752Zm.174-4.997L3.75 6.5c-.414 0-.75-.336-.75-.75 0-.38.282-.693.648-.743L3.75 5l8.337-.002c-.057.242-.087.493-.087.752 0 .258.03.51.087.751Zm6.326-1.502L20.25 5c.414 0 .75.336.75.75 0 .38-.282.693-.648.743l-.102.007-1.837.001c.057-.241.087-.493.087-.751s-.03-.51-.087-.751Zm-6.326 14.502L3.75 19.5c-.414 0-.75-.336-.75-.75 0-.38.282-.693.648-.743L3.75 18l8.337-.002c-.057.242-.087.493-.087.752 0 .258.03.51.087.751Zm6.326-1.502L20.25 18c.414 0 .75.336.75.75 0 .38-.282.693-.648.743l-.102.007-1.837.001c.057-.241.087-.493.087-.751s-.03-.51-.087-.751Z" }), tp.createElement("path", { className: Km.accent, d: "M8.75 9C10.544 9 12 10.456 12 12.25s-1.456 3.25-3.25 3.25-3.25-1.456-3.25-3.25S6.956 9 8.75 9Zm0 1.5c-.966 0-1.75.784-1.75 1.75S7.784 14 8.75 14s1.75-.784 1.75-1.75-.784-1.75-1.75-1.75Zm6.5-8c1.794 0 3.25 1.456 3.25 3.25S17.044 9 15.25 9 12 7.544 12 5.75s1.456-3.25 3.25-3.25Zm0 1.5c-.966 0-1.75.784-1.75 1.75s.784 1.75 1.75 1.75S17 6.716 17 5.75 16.216 4 15.25 4Zm0 11.5c1.794 0 3.25 1.456 3.25 3.25S17.044 22 15.25 22 12 20.544 12 18.75s1.456-3.25 3.25-3.25Zm0 1.5c-.966 0-1.75.784-1.75 1.75s.784 1.75 1.75 1.75S17 19.716 17 18.75 16.216 17 15.25 17Z" }));
const kie = tp.createElement("svg", { width: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, opacity: "0.62", d: "M5.587 13.001 3.75 13c-.414 0-.75-.336-.75-.75 0-.38.282-.694.648-.743l.102-.007 1.837-.001c-.057.241-.087.493-.087.751s.03.51.087.751Zm6.326-1.503 8.337.002c.414 0 .75.336.75.75 0 .38-.282.694-.648.743L20.25 13l-8.337.001c.057-.241.087-.493.087-.751 0-.259-.03-.51-.087-.752Zm.174-4.997L3.75 6.5c-.414 0-.75-.336-.75-.75 0-.38.282-.693.648-.743L3.75 5l8.337-.002c-.057.242-.087.493-.087.752 0 .258.03.51.087.751Zm6.326-1.502L20.25 5c.414 0 .75.336.75.75 0 .38-.282.693-.648.743l-.102.007-1.837.001c.057-.241.087-.493.087-.751s-.03-.51-.087-.751Zm-6.326 14.502L3.75 19.5c-.414 0-.75-.336-.75-.75 0-.38.282-.693.648-.743L3.75 18l8.337-.002c-.057.242-.087.493-.087.752 0 .258.03.51.087.751Zm6.326-1.502L20.25 18c.414 0 .75.336.75.75 0 .38-.282.693-.648.743l-.102.007-1.837.001c.057-.241.087-.493.087-.751s-.03-.51-.087-.751Z" }), tp.createElement("path", { className: Ym.text, d: "M8.75 9C10.544 9 12 10.456 12 12.25s-1.456 3.25-3.25 3.25-3.25-1.456-3.25-3.25S6.956 9 8.75 9Zm0 1.5c-.966 0-1.75.784-1.75 1.75S7.784 14 8.75 14s1.75-.784 1.75-1.75-.784-1.75-1.75-1.75Zm6.5-8c1.794 0 3.25 1.456 3.25 3.25S17.044 9 15.25 9 12 7.544 12 5.75s1.456-3.25 3.25-3.25Zm0 1.5c-.966 0-1.75.784-1.75 1.75s.784 1.75 1.75 1.75S17 6.716 17 5.75 16.216 4 15.25 4Zm0 11.5c1.794 0 3.25 1.456 3.25 3.25S17.044 22 15.25 22 12 20.544 12 18.75s1.456-3.25 3.25-3.25Zm0 1.5c-.966 0-1.75.784-1.75 1.75s.784 1.75 1.75 1.75S17 19.716 17 18.75 16.216 17 15.25 17Z" }));
const Pie = tp.createElement("svg", { width: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, opacity: "0.62", d: "M4.063 11.501 2.5 11.5c-.276 0-.5-.224-.5-.5 0-.245.177-.45.41-.492l.09-.008h1.563c-.041.16-.063.327-.063.5s.022.341.063.501ZM7.937 10.5H13.5c.276 0 .5.224.5.5 0 .245-.177.45-.41.492l-.09.008-5.563.001c.041-.16.063-.328.063-.501s-.022-.34-.063-.5Zm.126-4.999L2.5 5.5c-.276 0-.5-.224-.5-.5 0-.245.177-.45.41-.492L2.5 4.5h5.563C8.022 4.66 8 4.827 8 5s.022.341.063.501ZM11.937 4.5H13.5c.276 0 .5.224.5.5 0 .245-.177.45-.41.492l-.09.008-1.563.001c.041-.16.063-.328.063-.501s-.022-.34-.063-.5Z" }), tp.createElement("path", { className: Km.accent, d: "M6 9c1.104 0 2 .896 2 2s-.896 2-2 2-2-.896-2-2 .896-2 2-2Zm0 1c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1Zm4-7c1.104 0 2 .896 2 2s-.896 2-2 2-2-.896-2-2 .896-2 2-2Zm0 1c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1Z" }));
const Nie = tp.createElement("svg", { width: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, opacity: "0.62", d: "M4 4V2.5c0-.276.224-.5.5-.5s.5.224.5.5V4h14V2.5c0-.276.224-.5.5-.5s.5.224.5.5V4h1.5c.276 0 .5.224.5.5s-.224.5-.5.5H20v14h1.5c.276 0 .5.224.5.5s-.224.5-.5.5H20v1.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5V20H5v1.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5V20H2.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H4V5H2.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H4Zm1 15h14V5H5v14Z" }), tp.createElement("path", { className: Km.accent, d: "M17 8.6v6.8c0 .883-.717 1.6-1.6 1.6H8.6c-.883 0-1.6-.717-1.6-1.6V8.6C7 7.717 7.717 7 8.6 7h6.8c.883 0 1.6.717 1.6 1.6Zm-1.5.9c0-.552-.448-1-1-1h-5c-.552 0-1 .448-1 1v5c0 .552.448 1 1 1h5c.552 0 1-.448 1-1v-5Z" }));
const [Die] = Dp("wd-bool-editor");
const Lie = (e14) => {
  var _a2, _b2, _c2, _d2;
  const { t: t10 } = vp("propertyEditors");
  const n10 = () => {
    var _a3;
    const { meta: n11 } = e14.descriptor;
    const r11 = t10("boolean.textTrue", "True");
    return (n11 == null ? void 0 : n11.customType) ? n11.customType.localizationKey ? t10(`${n11.customType.localizationKey}.textTrue`) : (_a3 = n11.customType.textTrue) != null ? _a3 : r11 : r11;
  };
  const r10 = () => {
    var _a3;
    const { descriptor: { meta: n11 } } = e14;
    const r11 = t10("boolean.textFalse", "False");
    return (n11 == null ? void 0 : n11.customType) ? n11.customType.localizationKey ? t10(`${n11.customType.localizationKey}.textFalse`) : (_a3 = n11.customType.textFalse) != null ? _a3 : r11 : r11;
  };
  const { descriptor: o10, value: a10, setProperty: i10, disabled: s10 = false, textTrue: l10 = n10(), textFalse: c10 = r10(), textUndefined: u10 = t10("boolean.textUndefined", "Undefined"), labelPosition: d10 = "left" } = e14;
  const p10 = (_b2 = (_a2 = o10.meta) == null ? void 0 : _a2.withUndefined) != null ? _b2 : false;
  const m10 = (_d2 = (_c2 = o10.meta) == null ? void 0 : _c2.valueMode) != null ? _d2 : "boolean";
  "string" == typeof a10 && "string" !== m10 && console.warn('[Core] BooleanEditor: valueMode is set to "boolean", but the actual value is a "string"'), "boolean" == typeof a10 && "string" === m10 && console.warn('[Core] BooleanEditor: valueMode is set to "string", but the actual value is a "boolean"');
  const h10 = ep.useCallback((e15) => void 0 === e15 || ("string" === m10 ? "False" === e15 : false === e15), [m10]);
  const f10 = { block: true, onToggle: ep.useCallback(() => {
    const e15 = "boolean" === m10 || "True";
    const t11 = "boolean" !== m10 && "False";
    i10(o10, sK(a10) || h10(a10) ? e15 : t11);
  }, [o10, h10, i10, a10, m10]), value: a10, customCSS: Die, text: sK(a10) ? a10.toString() : void 0 === a10 && p10 ? u10 : h10(a10) ? c10 : l10, indeterminate: sK(a10) || p10 && void 0 === a10, checked: !h10(a10), size: "small", textAlign: "top" === d10 ? "right" : "left", disabled: s10 };
  return tp.createElement(SM, __spreadValues({}, f10));
};
Lie.displayName = "BooleanEditor";
const Hie = _D(Lie);
const Iie = (e14) => e14("propertyEditors:common.textMultipleValues", "<Multiple Values>");
const _ie = (e14) => e14("propertyEditors:common.textEmpty", "<Empty>");
const Vie = (e14, t10) => e14 ? Iie(t10) : _ie(t10);
const Rie = (e14, t10) => (n10) => {
  if (n10.stopPropagation(), "Enter" === n10.key) {
    e14();
    const { currentTarget: t11 } = n10;
    n10.preventDefault(), setTimeout(() => {
      t11.blur();
    }, 300);
  }
  "Escape" === n10.key && (t10(), n10.preventDefault());
};
const Aie = [dm.shades(dm.fromHEX("#f44336")), dm.shades(dm.fromHEX("#ff9800")), dm.shades(dm.fromHEX("#ffeb3b")), dm.shades(dm.fromHEX("#8bc34a")), dm.shades(dm.fromHEX("#4caf50")), dm.shades(dm.fromHEX("#00bcd4")), dm.shades(dm.fromHEX("#2196f3")), dm.shades(dm.fromHEX("#9c27b0")), [dm.fromHEX("#ffffff"), dm.fromHEX("#888"), dm.fromHEX("#aaa"), dm.fromHEX("#ccc"), dm.fromHEX("#e6e6e6"), dm.fromHEX("#f7f7f7")], [dm.fromHEX("#000000"), dm.fromHEX("#090909"), dm.fromHEX("#1a1a1a"), dm.fromHEX("#3c3c3c"), dm.fromHEX("#5e5e5e"), dm.fromHEX("#808080")]];
const Oie = ({ value: e14, onSelect: t10 }) => {
  const { API: n10 } = ep.useContext(Sm);
  const { t: r10 } = vp("propertyEditors");
  const o10 = { value: e14, palettes: [{ name: r10("colorDropdown.headingStandard", "Standard Colors"), colors: Aie }], textPalettes: r10("colorDropdown.btnPalettes", "Palettes"), textColorPicker: r10("colorDropdown.btnColorPicker", "Other Colors"), textWebColors: r10("colorDropdown.btnWebColors", "Web Colors"), textHue: r10("colorDropdown.labelHue", "Hue"), textSaturation: r10("colorDropdown.labelSaturation", "Saturation"), textLightness: r10("colorDropdown.labelLightness", "Lightness"), textHex: r10("colorDropdown.labelHex", "Hex"), onSelect: (e15) => {
    t10(e15), n10.dropdowns.open(null);
  } };
  return tp.createElement(xH, __spreadValues({}, o10));
};
const [Bie, , zie] = Dp("wd-color-editor");
const [$ie] = zie("preview");
const Wie = (e14, t10) => sK(e14) ? Iie(t10) : _ie(t10);
const jie = (e14) => {
  const { descriptor: t10, descriptor: { type: n10, meta: r10 }, value: o10, setProperty: a10, generatePreview: i10, onChange: s10, onValidate: l10 } = e14;
  const { API: c10 } = ep.useContext(Sm);
  const { t: u10 } = vp();
  const d10 = sK(o10);
  const p10 = hK(o10, n10, void 0, r10);
  const [m10, h10] = ep.useState(p10);
  ep.useEffect(() => {
    h10(p10);
  }, [p10, o10]);
  const f10 = ep.useMemo(() => d10 || !m10 ? new dm(0, 0, 0, 255) : m10.startsWith("#") ? dm.fromHEX(m10) : dm.fromWeb(m10), [m10, d10]);
  const g10 = ep.useCallback(() => c10.current.dropdowns.open(null), [c10]);
  const y10 = { value: f10, onSelect: ep.useCallback((e15) => {
    const n11 = e15.customValue || dm.toWeb(e15) || e15.hex;
    s10 ? s10(n11) : a10(t10, n11), g10();
  }, [t10, g10, s10, a10]) };
  const v10 = ep.useMemo(() => () => {
    if (i10) return i10;
    return d10 ? void 0 : (e15) => tp.createElement("div", { className: kp("gc-color__main", $ie), style: { backgroundColor: e15 } });
  }, [i10, d10]);
  const b10 = ep.useCallback(() => !(!d10 || "" !== m10) || (l10 ? l10(m10) : ((e15, t11) => {
    if (sK(t11)) return true;
    const { isValid: n11 } = JY(t11, e15.type, {}, e15.meta);
    return !!n11;
  })(t10, m10)), [m10, t10, d10, l10]);
  const S10 = ep.useCallback((e15) => {
    h10(e15.target.value), g10();
  }, [g10]);
  const C10 = ep.useCallback((e15) => {
    if (e15.target.value === p10) return;
    if (!b10()) return void h10(p10);
    const n11 = pK(e15.target.value, t10.type, {}, t10.meta, e15.target.value);
    s10 ? s10(n11) : a10(t10, n11), h10(p10);
  }, [t10, p10, s10, a10, b10]);
  const x10 = { dataAid: "color-editor", value: m10, block: true, size: "small", menuWidth: "auto", openOnFocus: false, invalid: !b10(), content: tp.createElement(Oie, __spreadValues({}, y10)), customCSS: kp(Bie), placeholder: Wie(o10, u10), onChange: S10, onBlur: C10, generatePreview: v10() };
  return tp.createElement(tM, __spreadValues({}, x10));
};
const Zie = _D(jie);
const [Gie, Uie] = Dp("wd-enum-editor");
const qie = (e14, t10) => t10 ? e14 == null ? void 0 : e14.sort((e15, t11) => {
  const [n10, r10] = "string" == typeof e15 ? [e15, e15] : [e15.value, e15.label];
  const [o10, a10] = "string" == typeof t11 ? [t11, t11] : [t11.value, t11.label];
  return "Default" === n10 ? -1 : "Default" === o10 ? 1 : r10.localeCompare(a10, void 0, { sensitivity: "base" });
}) : e14;
const Yie = (e14, t10) => sK(e14) ? Iie(t10) : _ie(t10);
const Kie = (e14, t10) => (e14 != null ? e14 : []).map((e15) => {
  const [n10, r10] = "string" == typeof e15 ? [e15, e15] : [e15.value, e15.label];
  return { type: "button", value: n10, text: r10, selected: t10 === r10 };
});
const Xie = (e14, t10, n10 = false) => e14.find((e15) => {
  const r10 = "string" == typeof e15 ? e15 : n10 && e15.label || e15.value;
  return 0 === t10.localeCompare(r10, void 0, { sensitivity: "base" });
});
const Jie = (e14, t10, n10) => {
  var _a2;
  if (sK(t10)) return "";
  const r10 = (_a2 = t10 == null ? void 0 : t10.toString()) != null ? _a2 : "";
  const o10 = Xie(e14 || [], r10);
  return o10 ? "string" == typeof o10 ? o10 : o10.label : n10(r10);
};
const Qie = (e14) => {
  const { value: t10, descriptor: n10, currentEnum: r10, setProperty: o10, generatePreview: a10, generateItemPreview: i10, customButtonRenderer: s10, toDisplayValue: l10 = (e15) => e15, disabled: c10 } = e14;
  const { API: u10 } = ep.useContext(Sm);
  const { t: d10 } = vp();
  const p10 = Jie(r10 || [], t10, l10);
  const [m10, h10] = ep.useState(p10);
  ep.useEffect(() => {
    h10(p10);
  }, [p10]);
  const f10 = { value: m10, block: true, size: "small", menuWidth: "100%", filterOnInput: true, openOnFocus: true, menuMaxHeight: "default", scrollToSelection: true, items: Kie(r10, m10), customCSS: kp(Gie), placeholder: Yie(t10, d10), disabled: c10, generatePreview: a10, generateItemPreview: i10, customButtonRenderer: s10, onSelect: (e15) => {
    h10(Jie(r10 || [], e15, l10)), o10(n10, e15), u10.current.dropdowns.open(null);
  }, onChange: (e15) => {
    h10(e15.target.value);
  }, onBlur: (e15) => {
    const t11 = e15.target.value;
    if (p10 === t11) return;
    const a11 = Xie(r10 || [], t11, true);
    a11 ? o10(n10, "string" == typeof a11 ? a11 : a11.value) : h10(p10);
  } };
  return tp.createElement(tM, __spreadValues({}, f10));
};
Qie.displayName = "SearchableEnumEditor";
const ese = (e14) => (e14 != null ? e14 : []).reduce(({ values: e15, friendlyNames: t10 }, n10) => {
  const [r10, o10] = "string" == typeof n10 ? [n10, n10] : [n10.value, n10.label];
  return e15.push(r10), t10.push({ value: r10, name: o10 }), { values: e15, friendlyNames: t10 };
}, { values: [], friendlyNames: [] });
const tse = (e14) => {
  const { value: t10, descriptor: { type: n10, meta: r10 }, currentEnum: o10, filterEnum: a10, doSort: i10, toDisplayValue: s10 = (e15) => e15 } = e14;
  const { t: l10 } = vp();
  const c10 = o10 || OO((r10 == null ? void 0 : r10.enumKey) || n10, l10);
  const u10 = a10 ? c10.filter(a10) : c10;
  const d10 = qie(u10, i10);
  if ((d10 != null ? d10 : []).length > 5) return tp.createElement(Qie, __spreadProps(__spreadValues({}, e14), { currentEnum: d10, toDisplayValue: s10 }));
  const p10 = sK(t10);
  const m10 = __spreadProps(__spreadValues({}, e14), { value: p10 ? Iie(l10) : s10(t10), friendlyEnum: ese(d10), menuMaxHeight: "default", textEmpty: _ie(l10), placeholderText: p10 });
  return tp.createElement("div", { className: kp(Gie) }, tp.createElement(AL, __spreadValues({}, m10)));
};
const nse = _D(tse);
const rse = (e14, t10) => sK(e14) ? Iie(t10) : _ie(t10);
const ose = (e14, t10) => {
  if (sK(t10)) return "";
  const n10 = e14.find((e15) => e15.value === t10);
  return n10 ? n10.label : t10;
};
const ase = (e14) => {
  var _a2;
  const { value: t10, descriptor: n10, disabled: r10 } = e14;
  const { dateFormats: o10 } = MO();
  const { API: a10 } = ep.useContext(Sm);
  const { t: i10 } = vp();
  const s10 = (_a2 = n10.meta) == null ? void 0 : _a2.dateType;
  const l10 = ep.useMemo(() => o10.map((e15) => ({ label: e15, value: e15 })), [o10]);
  const c10 = ose(l10 || [], t10);
  const [u10, d10] = ep.useState(c10);
  const p10 = (t11, n11) => {
    e14.setProperty(t11, n11);
  };
  ep.useEffect(() => p10(n10, t10), [s10]), ep.useEffect(() => d10(c10), [c10]);
  const m10 = { value: u10, block: true, size: "small", menuWidth: "100%", filterOnInput: true, openOnFocus: true, menuMaxHeight: "default", scrollToSelection: true, items: (h10 = l10, f10 = u10, (h10 != null ? h10 : []).map((e15) => ({ type: "button", value: e15.value, text: e15.label, selected: f10 === e15.label }))), customCSS: kp(Gie), placeholder: rse(t10, i10), disabled: r10, onSelect: (e15) => {
    d10(ose(l10 || [], e15)), p10(n10, e15), a10.current.dropdowns.open(null);
  }, onChange: (e15) => {
    d10(e15.target.value);
  }, onBlur: (e15) => {
    const t11 = e15.target.value;
    if (c10 === t11) return;
    const r11 = ((e16, t12) => e16.find((e17) => 0 === t12.localeCompare(e17.value, void 0, { sensitivity: "base" })))(l10 || [], t11);
    r11 ? p10(n10, "string" == typeof r11 ? r11 : r11.value) : (d10(ose(l10 != null ? l10 : [], t11)), p10(n10, t11));
  } };
  var h10, f10;
  return tp.createElement(tM, __spreadValues({}, m10));
};
ase.displayName = "ReportParameterFormatEditor";
const ise = _D(ase);
function sse(e14, t10, n10) {
  const r10 = t10(e14);
  const { isValid: o10 } = n10(r10);
  const [a10, i10] = ep.useState(r10);
  const [s10, l10] = ep.useState(o10);
  const [c10, u10] = ep.useState(false);
  ep.useEffect(() => {
    l10(o10);
  }, [o10]);
  return { inputValue: a10, setInputValue: i10, inputValid: s10, setInputValid: l10, inputDirty: c10, setInputDirty: u10, initInputValue: r10, initInputValid: o10, resetInputValue: () => {
    a10 !== r10 && (i10(r10), l10(o10), u10(false));
  }, onInputChange: ({ target: { value: e15 } }) => {
    i10(e15), u10(true);
    const { isValid: t11 } = n10(e15);
    l10(t11);
  } };
}
HD(ase);
const [lse, , cse] = Dp("wd-length-editor");
const [use] = cse("input");
const dse = (e14) => {
  const { disabled: t10, descriptor: n10, value: r10, setProperty: o10, toDisplayValue: a10 = hK, fromDisplayValue: i10 = pK, validateConstant: s10 = JY } = e14;
  const { type: l10, meta: c10 } = n10;
  const { t: u10 } = vp();
  const { userPreferences: { units: d10 } } = MO();
  const p10 = sK(r10);
  const { inputValue: m10, inputValid: h10, inputDirty: f10, setInputValid: g10, setInputValue: y10, setInputDirty: v10, resetInputValue: b10, onInputChange: S10, initInputValue: C10, initInputValid: x10 } = sse(r10, (e15) => p10 ? "" : a10(e15, l10, { units: d10 }, c10, String(e15 != null ? e15 : "")), (e15) => p10 && !e15 ? zY.success() : s10(e15, l10, { units: d10 }, c10));
  ep.useEffect(() => {
    y10(C10), g10(x10), v10(false);
  }, [p10, C10, x10]);
  const w10 = { disabled: t10, size: "small", value: m10, invalid: !h10, onChange: S10, onBlur: () => {
    if (b10(), !h10 || p10 && !f10 && !m10) return;
    const e15 = i10(m10, l10, { units: d10 }, c10, r10);
    e15 !== r10 && o10(n10, e15);
  }, onKeyDown: Rie(() => {
  }, b10), customCSS: use, placeholder: Vie(p10, u10), width: "100%" };
  return tp.createElement("div", { className: lse }, tp.createElement(KF, __spreadValues({}, w10)));
};
dse.displayName = "LengthEditor";
const pse = _D(dse);
const mse = HD(dse);
const hse = () => {
  throw new Error("TransactionContext not initialized");
};
const fse = ep.createContext({ startTransaction: hse, commitTransaction: hse });
const gse = () => {
  throw new Error("DrillContext not initialized");
};
const yse = ep.createContext({ drill: gse, undrill: gse });
const vse = (e14) => {
  const { descriptor: t10, value: n10, defaultValue: r10, disabled: o10, setProperty: a10, nestedDescriptors: i10, createMainEditor: s10, createSideEditor: l10, combineMainValue: c10, splitMainValue: u10, validateSingleValue: d10 = () => true } = e14;
  const { t: p10 } = vp();
  const { startTransaction: m10, commitTransaction: h10 } = ep.useContext(fse);
  const f10 = 5 === i10.length;
  const g10 = ep.useMemo(() => i10.map((e15) => WN(e15, t10.valuePath)), [i10, t10]);
  const y10 = ep.useMemo(() => i10.map((e15) => {
    const t11 = jN(e15.valuePath);
    return { value: n10 && t11(n10), defaultValue: r10 && t11(r10) || "" };
  }), [i10, n10, r10]);
  let v10 = y10.slice(0, 4);
  if (f10) {
    const e15 = jN(i10[4].valuePath)(n10);
    v10 = v10.map((t11) => ({ value: t11.value || e15, defaultValue: r10 }));
  }
  const b10 = c10(v10);
  const S10 = (e15) => {
    const t11 = u10(e15);
    return t11.length > 4 && t11.splice(4), t11.length > 1 && t11.length < 4 && t11.splice(1), t11;
  };
  const C10 = s10(b10, (e15) => {
    const t11 = S10(e15);
    let n11 = [];
    if (1 === t11.length) if (f10) {
      for (let e16 = 0; e16 < 4; e16++) {
        const t12 = jN(i10[e16].valuePath)(r10);
        n11.push(t12);
      }
      n11.push(t11[0]);
    } else for (let e16 = 0; e16 < 4; e16++) n11.push(t11[0]);
    else 4 === t11.length && (n11 = t11);
    m10(), n11.forEach((e16, t12) => {
      a10(g10[t12], e16);
    }), h10();
  }, (e15) => {
    if (sK(e15)) return true;
    const t11 = S10(e15);
    return 1 === t11.length && f10 ? d10(t11[0], y10[4].defaultValue, i10[4]) : t11.every((e16, t12) => d10(e16, y10[t12].defaultValue, i10[t12]));
  });
  const x10 = g10.map((e15, t11) => ({ descriptor: e15, value: y10[t11].value, defaultValue: y10[t11].defaultValue, disabled: o10, setProperty: a10, t: p10 }));
  const w10 = __spreadProps(__spreadValues({}, e14), { value: b10, mainEditor: C10, sides: { left: l10(x10[0]), top: l10(x10[1]), right: l10(x10[2]), bottom: l10(x10[3]), default: f10 ? l10(x10[4]) : void 0 }, titleCollapse: p10("propertyEditors:common.titleCollapse", "Collapse"), titleExpand: p10("propertyEditors:common.titleExpand", "Expand") });
  return tp.createElement(HL, __spreadValues({}, w10));
};
vse.displayName = "SideEditor";
const bse = (e14) => {
  const { descriptor: t10, placeholder: n10, placeholderEmpty: r10, placeholderMultipleValues: o10, disabled: a10, value: i10, onChange: s10, validate: l10, setProperty: c10 } = e14;
  const { t: u10 } = vp();
  const d10 = { value: i10 || "", disabled: a10, placeholder: n10, placeholderEmpty: r10 || _ie(u10), placeholderMultipleValues: o10 || Iie(u10), onChange: (e15) => {
    const n11 = pK(e15, t10.type, {}, t10.meta);
    s10 && "function" == typeof s10 ? s10(t10, n11) : c10(t10, n11);
  }, validate: l10 };
  return tp.createElement(UD, __spreadValues({}, d10));
};
bse.displayName = "StringEditor";
const Sse = _D(bse);
const Cse = (e14) => {
  const { nestedDescriptors: t10, toDisplayValue: n10 = hK, fromDisplayValue: r10 = pK } = e14;
  const { t: o10 } = vp();
  const { userPreferences: { units: a10 } } = MO();
  const i10 = (e15, n11) => r10(e15, t10[n11].type, { units: a10 }, t10[n11].meta, e15);
  const s10 = (e15, r11) => n10(e15, t10[r11].type, { units: a10 }, t10[r11].meta, e15);
  const l10 = __spreadProps(__spreadValues({}, e14), { createSideEditor: (e15) => tp.createElement(mse, __spreadProps(__spreadValues({}, e15), { toDisplayValue: n10, fromDisplayValue: r10 })), createMainEditor: (t11, n11, r11) => {
    const a11 = __spreadProps(__spreadValues({}, e14), { value: t11, validate: r11, onChange: (e15, t12) => n11(t12), t: o10 });
    return tp.createElement(Sse, __spreadValues({}, a11));
  }, splitMainValue: (e15) => "string" != typeof e15 ? [""] : e15.trim().split(" ").slice(0, 4).map((e16) => e16.trim()).map(i10), combineMainValue: (e15) => {
    if (e15.some((e16) => sK(e16.value))) return XN;
    const t11 = e15.map((e16) => e16.value).map(s10);
    const n11 = t11.every((e16) => t11[0] === e16);
    return n11 ? t11[0] : t11.join(" ");
  }, validateSingleValue: (e15, t11, n11) => {
    const { isValid: r11 } = JY(e15, "length", { units: a10 }, n11.meta);
    return r11;
  } });
  return tp.createElement(vse, __spreadValues({}, l10));
};
Cse.displayName = "LengthEditorSide";
var xse = { exports: {} };
/** @license React v16.13.1
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wse = hd, Tse = ep;
function Ese(e14) {
  for (var t10 = "https://reactjs.org/docs/error-decoder.html?invariant=" + e14, n10 = 1; n10 < arguments.length; n10++) t10 += "&args[]=" + encodeURIComponent(arguments[n10]);
  return "Minified React error #" + e14 + "; visit " + t10 + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var Fse = "function" == typeof Symbol && Symbol.for, Mse = Fse ? Symbol.for("react.portal") : 60106, kse = Fse ? Symbol.for("react.fragment") : 60107, Pse = Fse ? Symbol.for("react.strict_mode") : 60108, Nse = Fse ? Symbol.for("react.profiler") : 60114, Dse = Fse ? Symbol.for("react.provider") : 60109, Lse = Fse ? Symbol.for("react.context") : 60110, Hse = Fse ? Symbol.for("react.concurrent_mode") : 60111, Ise = Fse ? Symbol.for("react.forward_ref") : 60112, _se = Fse ? Symbol.for("react.suspense") : 60113, Vse = Fse ? Symbol.for("react.suspense_list") : 60120, Rse = Fse ? Symbol.for("react.memo") : 60115, Ase = Fse ? Symbol.for("react.lazy") : 60116, Ose = Fse ? Symbol.for("react.block") : 60121, Bse = Fse ? Symbol.for("react.fundamental") : 60117, zse = Fse ? Symbol.for("react.scope") : 60119;
function $se(e14) {
  if (null == e14) return null;
  if ("function" == typeof e14) return e14.displayName || e14.name || null;
  if ("string" == typeof e14) return e14;
  switch (e14) {
    case kse:
      return "Fragment";
    case Mse:
      return "Portal";
    case Nse:
      return "Profiler";
    case Pse:
      return "StrictMode";
    case _se:
      return "Suspense";
    case Vse:
      return "SuspenseList";
  }
  if ("object" == typeof e14) switch (e14.$$typeof) {
    case Lse:
      return "Context.Consumer";
    case Dse:
      return "Context.Provider";
    case Ise:
      var t10 = e14.render;
      return t10 = t10.displayName || t10.name || "", e14.displayName || ("" !== t10 ? "ForwardRef(" + t10 + ")" : "ForwardRef");
    case Rse:
      return $se(e14.type);
    case Ose:
      return $se(e14.render);
    case Ase:
      if (e14 = 1 === e14._status ? e14._result : null) return $se(e14);
  }
  return null;
}
var Wse = Tse.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Wse.hasOwnProperty("ReactCurrentDispatcher") || (Wse.ReactCurrentDispatcher = { current: null }), Wse.hasOwnProperty("ReactCurrentBatchConfig") || (Wse.ReactCurrentBatchConfig = { suspense: null });
var jse = {};
function Zse(e14, t10) {
  for (var n10 = 0 | e14._threadCount; n10 <= t10; n10++) e14[n10] = e14._currentValue2, e14._threadCount = n10 + 1;
}
for (var Gse = new Uint16Array(16), Use = 0; 15 > Use; Use++) Gse[Use] = Use + 1;
Gse[15] = 0;
var qse = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Yse = Object.prototype.hasOwnProperty, Kse = {}, Xse = {};
function Jse(e14) {
  return !!Yse.call(Xse, e14) || !Yse.call(Kse, e14) && (qse.test(e14) ? Xse[e14] = true : (Kse[e14] = true, false));
}
function Qse(e14, t10, n10, r10, o10, a10) {
  this.acceptsBooleans = 2 === t10 || 3 === t10 || 4 === t10, this.attributeName = r10, this.attributeNamespace = o10, this.mustUseProperty = n10, this.propertyName = e14, this.type = t10, this.sanitizeURL = a10;
}
var ele = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e14) {
  ele[e14] = new Qse(e14, 0, false, e14, null, false);
}), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e14) {
  var t10 = e14[0];
  ele[t10] = new Qse(t10, 1, false, e14[1], null, false);
}), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e14) {
  ele[e14] = new Qse(e14, 2, false, e14.toLowerCase(), null, false);
}), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e14) {
  ele[e14] = new Qse(e14, 2, false, e14, null, false);
}), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e14) {
  ele[e14] = new Qse(e14, 3, false, e14.toLowerCase(), null, false);
}), ["checked", "multiple", "muted", "selected"].forEach(function(e14) {
  ele[e14] = new Qse(e14, 3, true, e14, null, false);
}), ["capture", "download"].forEach(function(e14) {
  ele[e14] = new Qse(e14, 4, false, e14, null, false);
}), ["cols", "rows", "size", "span"].forEach(function(e14) {
  ele[e14] = new Qse(e14, 6, false, e14, null, false);
}), ["rowSpan", "start"].forEach(function(e14) {
  ele[e14] = new Qse(e14, 5, false, e14.toLowerCase(), null, false);
});
var tle = /[\-:]([a-z])/g;
function nle(e14) {
  return e14[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e14) {
  var t10 = e14.replace(tle, nle);
  ele[t10] = new Qse(t10, 1, false, e14, null, false);
}), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e14) {
  var t10 = e14.replace(tle, nle);
  ele[t10] = new Qse(t10, 1, false, e14, "http://www.w3.org/1999/xlink", false);
}), ["xml:base", "xml:lang", "xml:space"].forEach(function(e14) {
  var t10 = e14.replace(tle, nle);
  ele[t10] = new Qse(t10, 1, false, e14, "http://www.w3.org/XML/1998/namespace", false);
}), ["tabIndex", "crossOrigin"].forEach(function(e14) {
  ele[e14] = new Qse(e14, 1, false, e14.toLowerCase(), null, false);
}), ele.xlinkHref = new Qse("xlinkHref", 1, false, "xlink:href", "http://www.w3.org/1999/xlink", true), ["src", "href", "action", "formAction"].forEach(function(e14) {
  ele[e14] = new Qse(e14, 1, false, e14.toLowerCase(), null, true);
});
var rle = /["'&<>]/;
function ole(e14) {
  if ("boolean" == typeof e14 || "number" == typeof e14) return "" + e14;
  e14 = "" + e14;
  var t10 = rle.exec(e14);
  if (t10) {
    var n10, r10 = "", o10 = 0;
    for (n10 = t10.index; n10 < e14.length; n10++) {
      switch (e14.charCodeAt(n10)) {
        case 34:
          t10 = "&quot;";
          break;
        case 38:
          t10 = "&amp;";
          break;
        case 39:
          t10 = "&#x27;";
          break;
        case 60:
          t10 = "&lt;";
          break;
        case 62:
          t10 = "&gt;";
          break;
        default:
          continue;
      }
      o10 !== n10 && (r10 += e14.substring(o10, n10)), o10 = n10 + 1, r10 += t10;
    }
    e14 = o10 !== n10 ? r10 + e14.substring(o10, n10) : r10;
  }
  return e14;
}
function ale(e14, t10) {
  var n10 = ele.hasOwnProperty(e14) ? ele[e14] : null;
  var r10;
  return (r10 = "style" !== e14) && (r10 = null !== n10 ? 0 === n10.type : 2 < e14.length && ("o" === e14[0] || "O" === e14[0]) && ("n" === e14[1] || "N" === e14[1])), r10 || function(e15, t11, n11, r11) {
    if (null == t11 || function(e16, t12, n12, r12) {
      if (null !== n12 && 0 === n12.type) return false;
      switch (typeof t12) {
        case "function":
        case "symbol":
          return true;
        case "boolean":
          return !r12 && (null !== n12 ? !n12.acceptsBooleans : "data-" !== (e16 = e16.toLowerCase().slice(0, 5)) && "aria-" !== e16);
        default:
          return false;
      }
    }(e15, t11, n11, r11)) return true;
    if (r11) return false;
    if (null !== n11) switch (n11.type) {
      case 3:
        return !t11;
      case 4:
        return false === t11;
      case 5:
        return isNaN(t11);
      case 6:
        return isNaN(t11) || 1 > t11;
    }
    return false;
  }(e14, t10, n10, false) ? "" : null !== n10 ? (e14 = n10.attributeName, 3 === (r10 = n10.type) || 4 === r10 && true === t10 ? e14 + '=""' : (n10.sanitizeURL && (t10 = "" + t10), e14 + '="' + ole(t10) + '"')) : Jse(e14) ? e14 + '="' + ole(t10) + '"' : "";
}
var ile = "function" == typeof Object.is ? Object.is : function(e14, t10) {
  return e14 === t10 && (0 !== e14 || 1 / e14 == 1 / t10) || e14 != e14 && t10 != t10;
}, sle = null, lle = null, cle = null, ule = false, dle = false, ple = null, mle = 0;
function hle() {
  if (null === sle) throw Error(Ese(321));
  return sle;
}
function fle() {
  if (0 < mle) throw Error(Ese(312));
  return { memoizedState: null, queue: null, next: null };
}
function gle() {
  return null === cle ? null === lle ? (ule = false, lle = cle = fle()) : (ule = true, cle = lle) : null === cle.next ? (ule = false, cle = cle.next = fle()) : (ule = true, cle = cle.next), cle;
}
function yle(e14, t10, n10, r10) {
  for (; dle; ) dle = false, mle += 1, cle = null, n10 = e14(t10, r10);
  return lle = sle = null, mle = 0, cle = ple = null, n10;
}
function vle(e14, t10) {
  return "function" == typeof t10 ? t10(e14) : t10;
}
function ble(e14, t10, n10) {
  if (sle = hle(), cle = gle(), ule) {
    var r10 = cle.queue;
    if (t10 = r10.dispatch, null !== ple && void 0 !== (n10 = ple.get(r10))) {
      ple.delete(r10), r10 = cle.memoizedState;
      do {
        r10 = e14(r10, n10.action), n10 = n10.next;
      } while (null !== n10);
      return cle.memoizedState = r10, [r10, t10];
    }
    return [cle.memoizedState, t10];
  }
  return e14 = e14 === vle ? "function" == typeof t10 ? t10() : t10 : void 0 !== n10 ? n10(t10) : t10, cle.memoizedState = e14, e14 = (e14 = cle.queue = { last: null, dispatch: null }).dispatch = Sle.bind(null, sle, e14), [cle.memoizedState, e14];
}
function Sle(e14, t10, n10) {
  if (!(25 > mle)) throw Error(Ese(301));
  if (e14 === sle) if (dle = true, e14 = { action: n10, next: null }, null === ple && (ple = /* @__PURE__ */ new Map()), void 0 === (n10 = ple.get(t10))) ple.set(t10, e14);
  else {
    for (t10 = n10; null !== t10.next; ) t10 = t10.next;
    t10.next = e14;
  }
}
function Cle() {
}
var xle = 0, wle = { readContext: function(e14) {
  var t10 = xle;
  return Zse(e14, t10), e14[t10];
}, useContext: function(e14) {
  hle();
  var t10 = xle;
  return Zse(e14, t10), e14[t10];
}, useMemo: function(e14, t10) {
  if (sle = hle(), t10 = void 0 === t10 ? null : t10, null !== (cle = gle())) {
    var n10 = cle.memoizedState;
    if (null !== n10 && null !== t10) {
      e: {
        var r10 = n10[1];
        if (null === r10) r10 = false;
        else {
          for (var o10 = 0; o10 < r10.length && o10 < t10.length; o10++) if (!ile(t10[o10], r10[o10])) {
            r10 = false;
            break e;
          }
          r10 = true;
        }
      }
      if (r10) return n10[0];
    }
  }
  return e14 = e14(), cle.memoizedState = [e14, t10], e14;
}, useReducer: ble, useRef: function(e14) {
  sle = hle();
  var t10 = (cle = gle()).memoizedState;
  return null === t10 ? (e14 = { current: e14 }, cle.memoizedState = e14) : t10;
}, useState: function(e14) {
  return ble(vle, e14);
}, useLayoutEffect: function() {
}, useCallback: function(e14) {
  return e14;
}, useImperativeHandle: Cle, useEffect: Cle, useDebugValue: Cle, useResponder: function(e14, t10) {
  return { props: t10, responder: e14 };
}, useDeferredValue: function(e14) {
  return hle(), e14;
}, useTransition: function() {
  return hle(), [function(e14) {
    e14();
  }, false];
} }, Tle = "http://www.w3.org/1999/xhtml";
var Ele = { area: true, base: true, br: true, col: true, embed: true, hr: true, img: true, input: true, keygen: true, link: true, meta: true, param: true, source: true, track: true, wbr: true }, Fle = wse({ menuitem: true }, Ele), Mle = { animationIterationCount: true, borderImageOutset: true, borderImageSlice: true, borderImageWidth: true, boxFlex: true, boxFlexGroup: true, boxOrdinalGroup: true, columnCount: true, columns: true, flex: true, flexGrow: true, flexPositive: true, flexShrink: true, flexNegative: true, flexOrder: true, gridArea: true, gridRow: true, gridRowEnd: true, gridRowSpan: true, gridRowStart: true, gridColumn: true, gridColumnEnd: true, gridColumnSpan: true, gridColumnStart: true, fontWeight: true, lineClamp: true, lineHeight: true, opacity: true, order: true, orphans: true, tabSize: true, widows: true, zIndex: true, zoom: true, fillOpacity: true, floodOpacity: true, stopOpacity: true, strokeDasharray: true, strokeDashoffset: true, strokeMiterlimit: true, strokeOpacity: true, strokeWidth: true }, kle = ["Webkit", "ms", "Moz", "O"];
Object.keys(Mle).forEach(function(e14) {
  kle.forEach(function(t10) {
    t10 = t10 + e14.charAt(0).toUpperCase() + e14.substring(1), Mle[t10] = Mle[e14];
  });
});
var Ple = /([A-Z])/g, Nle = /^ms-/, Dle = Tse.Children.toArray, Lle = Wse.ReactCurrentDispatcher, Hle = { listing: true, pre: true, textarea: true }, Ile = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, _le = {}, Vle = {};
var Rle = Object.prototype.hasOwnProperty, Ale = { children: null, dangerouslySetInnerHTML: null, suppressContentEditableWarning: null, suppressHydrationWarning: null };
function Ole(e14, t10) {
  if (void 0 === e14) throw Error(Ese(152, $se(t10) || "Component"));
}
function Ble(e14, t10, n10) {
  function r10(r11, o11) {
    var a11 = o11.prototype && o11.prototype.isReactComponent, i10 = function(e15, t11, n11, r12) {
      if (r12 && "object" == typeof (r12 = e15.contextType) && null !== r12) return Zse(r12, n11), r12[n11];
      if (e15 = e15.contextTypes) {
        for (var o12 in n11 = {}, e15) n11[o12] = t11[o12];
        t11 = n11;
      } else t11 = jse;
      return t11;
    }(o11, t10, n10, a11), s10 = [], l10 = false, c10 = { isMounted: function() {
      return false;
    }, enqueueForceUpdate: function() {
      if (null === s10) return null;
    }, enqueueReplaceState: function(e15, t11) {
      l10 = true, s10 = [t11];
    }, enqueueSetState: function(e15, t11) {
      if (null === s10) return null;
      s10.push(t11);
    } };
    if (a11) {
      if (a11 = new o11(r11.props, i10, c10), "function" == typeof o11.getDerivedStateFromProps) {
        var u10 = o11.getDerivedStateFromProps.call(null, r11.props, a11.state);
        null != u10 && (a11.state = wse({}, a11.state, u10));
      }
    } else if (sle = {}, a11 = o11(r11.props, i10, c10), null == (a11 = yle(o11, r11.props, a11, i10)) || null == a11.render) return void Ole(e14 = a11, o11);
    if (a11.props = r11.props, a11.context = i10, a11.updater = c10, void 0 === (c10 = a11.state) && (a11.state = c10 = null), "function" == typeof a11.UNSAFE_componentWillMount || "function" == typeof a11.componentWillMount) if ("function" == typeof a11.componentWillMount && "function" != typeof o11.getDerivedStateFromProps && a11.componentWillMount(), "function" == typeof a11.UNSAFE_componentWillMount && "function" != typeof o11.getDerivedStateFromProps && a11.UNSAFE_componentWillMount(), s10.length) {
      c10 = s10;
      var d10 = l10;
      if (s10 = null, l10 = false, d10 && 1 === c10.length) a11.state = c10[0];
      else {
        u10 = d10 ? c10[0] : a11.state;
        var p10 = true;
        for (d10 = d10 ? 1 : 0; d10 < c10.length; d10++) {
          var m10 = c10[d10];
          null != (m10 = "function" == typeof m10 ? m10.call(a11, u10, r11.props, i10) : m10) && (p10 ? (p10 = false, u10 = wse({}, u10, m10)) : wse(u10, m10));
        }
        a11.state = u10;
      }
    } else s10 = null;
    if (Ole(e14 = a11.render(), o11), "function" == typeof a11.getChildContext && "object" == typeof (r11 = o11.childContextTypes)) {
      var h10 = a11.getChildContext();
      for (var f10 in h10) if (!(f10 in r11)) throw Error(Ese(108, $se(o11) || "Unknown", f10));
    }
    h10 && (t10 = wse({}, t10, h10));
  }
  for (; Tse.isValidElement(e14); ) {
    var o10 = e14, a10 = o10.type;
    if ("function" != typeof a10) break;
    r10(o10, a10);
  }
  return { child: e14, context: t10 };
}
var zle = function() {
  function e14(e15, t11) {
    Tse.isValidElement(e15) ? e15.type !== kse ? e15 = [e15] : (e15 = e15.props.children, e15 = Tse.isValidElement(e15) ? [e15] : Dle(e15)) : e15 = Dle(e15), e15 = { type: null, domNamespace: Tle, children: e15, childIndex: 0, context: jse, footer: "" };
    var n10 = Gse[0];
    if (0 === n10) {
      var r10 = Gse;
      var o10 = 2 * (n10 = r10.length);
      if (!(65536 >= o10)) throw Error(Ese(304));
      var a10 = new Uint16Array(o10);
      for (a10.set(r10), (Gse = a10)[0] = n10 + 1, r10 = n10; r10 < o10 - 1; r10++) Gse[r10] = r10 + 1;
      Gse[o10 - 1] = 0;
    } else Gse[0] = Gse[n10];
    this.threadID = n10, this.stack = [e15], this.exhausted = false, this.currentSelectValue = null, this.previousWasTextNode = false, this.makeStaticMarkup = t11, this.suspenseDepth = 0, this.contextIndex = -1, this.contextStack = [], this.contextValueStack = [];
  }
  var t10 = e14.prototype;
  return t10.destroy = function() {
    if (!this.exhausted) {
      this.exhausted = true, this.clearProviders();
      var e15 = this.threadID;
      Gse[e15] = Gse[0], Gse[0] = e15;
    }
  }, t10.pushProvider = function(e15) {
    var t11 = ++this.contextIndex, n10 = e15.type._context, r10 = this.threadID;
    Zse(n10, r10);
    var o10 = n10[r10];
    this.contextStack[t11] = n10, this.contextValueStack[t11] = o10, n10[r10] = e15.props.value;
  }, t10.popProvider = function() {
    var e15 = this.contextIndex, t11 = this.contextStack[e15], n10 = this.contextValueStack[e15];
    this.contextStack[e15] = null, this.contextValueStack[e15] = null, this.contextIndex--, t11[this.threadID] = n10;
  }, t10.clearProviders = function() {
    for (var e15 = this.contextIndex; 0 <= e15; e15--) this.contextStack[e15][this.threadID] = this.contextValueStack[e15];
  }, t10.read = function(e15) {
    if (this.exhausted) return null;
    var t11 = xle;
    xle = this.threadID;
    var n10 = Lle.current;
    Lle.current = wle;
    try {
      for (var r10 = [""], o10 = false; r10[0].length < e15; ) {
        if (0 === this.stack.length) {
          this.exhausted = true;
          var a10 = this.threadID;
          Gse[a10] = Gse[0], Gse[0] = a10;
          break;
        }
        var i10 = this.stack[this.stack.length - 1];
        if (o10 || i10.childIndex >= i10.children.length) {
          var s10 = i10.footer;
          if ("" !== s10 && (this.previousWasTextNode = false), this.stack.pop(), "select" === i10.type) this.currentSelectValue = null;
          else if (null != i10.type && null != i10.type.type && i10.type.type.$$typeof === Dse) this.popProvider(i10.type);
          else if (i10.type === _se) {
            this.suspenseDepth--;
            var l10 = r10.pop();
            if (o10) {
              o10 = false;
              var c10 = i10.fallbackFrame;
              if (!c10) throw Error(Ese(303));
              this.stack.push(c10), r10[this.suspenseDepth] += "<!--$!-->";
              continue;
            }
            r10[this.suspenseDepth] += l10;
          }
          r10[this.suspenseDepth] += s10;
        } else {
          var u10 = i10.children[i10.childIndex++], d10 = "";
          try {
            d10 += this.render(u10, i10.context, i10.domNamespace);
          } catch (e16) {
            if (null != e16 && "function" == typeof e16.then) throw Error(Ese(294));
            throw e16;
          }
          r10.length <= this.suspenseDepth && r10.push(""), r10[this.suspenseDepth] += d10;
        }
      }
      return r10[0];
    } finally {
      Lle.current = n10, xle = t11;
    }
  }, t10.render = function(e15, t11, n10) {
    if ("string" == typeof e15 || "number" == typeof e15) return "" === (n10 = "" + e15) ? "" : this.makeStaticMarkup ? ole(n10) : this.previousWasTextNode ? "<!-- -->" + ole(n10) : (this.previousWasTextNode = true, ole(n10));
    if (e15 = (t11 = Ble(e15, t11, this.threadID)).child, t11 = t11.context, null === e15 || false === e15) return "";
    if (!Tse.isValidElement(e15)) {
      if (null != e15 && null != e15.$$typeof) {
        if ((n10 = e15.$$typeof) === Mse) throw Error(Ese(257));
        throw Error(Ese(258, n10.toString()));
      }
      return e15 = Dle(e15), this.stack.push({ type: null, domNamespace: n10, children: e15, childIndex: 0, context: t11, footer: "" }), "";
    }
    var r10 = e15.type;
    if ("string" == typeof r10) return this.renderDOM(e15, t11, n10);
    switch (r10) {
      case Pse:
      case Hse:
      case Nse:
      case Vse:
      case kse:
        return e15 = Dle(e15.props.children), this.stack.push({ type: null, domNamespace: n10, children: e15, childIndex: 0, context: t11, footer: "" }), "";
      case _se:
        throw Error(Ese(294));
    }
    if ("object" == typeof r10 && null !== r10) switch (r10.$$typeof) {
      case Ise:
        sle = {};
        var o10 = r10.render(e15.props, e15.ref);
        return o10 = yle(r10.render, e15.props, o10, e15.ref), o10 = Dle(o10), this.stack.push({ type: null, domNamespace: n10, children: o10, childIndex: 0, context: t11, footer: "" }), "";
      case Rse:
        return e15 = [Tse.createElement(r10.type, wse({ ref: e15.ref }, e15.props))], this.stack.push({ type: null, domNamespace: n10, children: e15, childIndex: 0, context: t11, footer: "" }), "";
      case Dse:
        return n10 = { type: e15, domNamespace: n10, children: r10 = Dle(e15.props.children), childIndex: 0, context: t11, footer: "" }, this.pushProvider(e15), this.stack.push(n10), "";
      case Lse:
        r10 = e15.type, o10 = e15.props;
        var a10 = this.threadID;
        return Zse(r10, a10), r10 = Dle(o10.children(r10[a10])), this.stack.push({ type: e15, domNamespace: n10, children: r10, childIndex: 0, context: t11, footer: "" }), "";
      case Bse:
        throw Error(Ese(338));
      case Ase:
        switch (function(e16) {
          if (-1 === e16._status) {
            e16._status = 0;
            var t12 = e16._ctor;
            t12 = t12(), e16._result = t12, t12.then(function(t13) {
              0 === e16._status && (t13 = t13.default, e16._status = 1, e16._result = t13);
            }, function(t13) {
              0 === e16._status && (e16._status = 2, e16._result = t13);
            });
          }
        }(r10 = e15.type), r10._status) {
          case 1:
            return e15 = [Tse.createElement(r10._result, wse({ ref: e15.ref }, e15.props))], this.stack.push({ type: null, domNamespace: n10, children: e15, childIndex: 0, context: t11, footer: "" }), "";
          case 2:
            throw r10._result;
          default:
            throw Error(Ese(295));
        }
      case zse:
        throw Error(Ese(343));
    }
    throw Error(Ese(130, null == r10 ? r10 : typeof r10, ""));
  }, t10.renderDOM = function(e15, t11, n10) {
    var r10 = e15.type.toLowerCase();
    if (!_le.hasOwnProperty(r10)) {
      if (!Ile.test(r10)) throw Error(Ese(65, r10));
      _le[r10] = true;
    }
    var o10 = e15.props;
    if ("input" === r10) o10 = wse({ type: void 0 }, o10, { defaultChecked: void 0, defaultValue: void 0, value: null != o10.value ? o10.value : o10.defaultValue, checked: null != o10.checked ? o10.checked : o10.defaultChecked });
    else if ("textarea" === r10) {
      var a10 = o10.value;
      if (null == a10) {
        a10 = o10.defaultValue;
        var i10 = o10.children;
        if (null != i10) {
          if (null != a10) throw Error(Ese(92));
          if (Array.isArray(i10)) {
            if (!(1 >= i10.length)) throw Error(Ese(93));
            i10 = i10[0];
          }
          a10 = "" + i10;
        }
        null == a10 && (a10 = "");
      }
      o10 = wse({}, o10, { value: void 0, children: "" + a10 });
    } else if ("select" === r10) this.currentSelectValue = null != o10.value ? o10.value : o10.defaultValue, o10 = wse({}, o10, { value: void 0 });
    else if ("option" === r10) {
      i10 = this.currentSelectValue;
      var s10 = function(e16) {
        if (null == e16) return e16;
        var t12 = "";
        return Tse.Children.forEach(e16, function(e17) {
          null != e17 && (t12 += e17);
        }), t12;
      }(o10.children);
      if (null != i10) {
        var l10 = null != o10.value ? o10.value + "" : s10;
        if (a10 = false, Array.isArray(i10)) {
          for (var c10 = 0; c10 < i10.length; c10++) if ("" + i10[c10] === l10) {
            a10 = true;
            break;
          }
        } else a10 = "" + i10 === l10;
        o10 = wse({ selected: void 0, children: void 0 }, o10, { selected: a10, children: s10 });
      }
    }
    if (a10 = o10) {
      if (Fle[r10] && (null != a10.children || null != a10.dangerouslySetInnerHTML)) throw Error(Ese(137, r10, ""));
      if (null != a10.dangerouslySetInnerHTML) {
        if (null != a10.children) throw Error(Ese(60));
        if ("object" != typeof a10.dangerouslySetInnerHTML || !("__html" in a10.dangerouslySetInnerHTML)) throw Error(Ese(61));
      }
      if (null != a10.style && "object" != typeof a10.style) throw Error(Ese(62, ""));
    }
    for (y10 in a10 = o10, i10 = this.makeStaticMarkup, s10 = 1 === this.stack.length, l10 = "<" + e15.type, a10) if (Rle.call(a10, y10)) {
      var u10 = a10[y10];
      if (null != u10) {
        if ("style" === y10) {
          c10 = void 0;
          var d10 = "", p10 = "";
          for (c10 in u10) if (u10.hasOwnProperty(c10)) {
            var m10 = 0 === c10.indexOf("--"), h10 = u10[c10];
            if (null != h10) {
              if (m10) var f10 = c10;
              else if (f10 = c10, Vle.hasOwnProperty(f10)) f10 = Vle[f10];
              else {
                var g10 = f10.replace(Ple, "-$1").toLowerCase().replace(Nle, "-ms-");
                f10 = Vle[f10] = g10;
              }
              d10 += p10 + f10 + ":", p10 = c10, d10 += m10 = null == h10 || "boolean" == typeof h10 || "" === h10 ? "" : m10 || "number" != typeof h10 || 0 === h10 || Mle.hasOwnProperty(p10) && Mle[p10] ? ("" + h10).trim() : h10 + "px", p10 = ";";
            }
          }
          u10 = d10 || null;
        }
        c10 = null;
        e: if (m10 = r10, h10 = a10, -1 === m10.indexOf("-")) m10 = "string" == typeof h10.is;
        else switch (m10) {
          case "annotation-xml":
          case "color-profile":
          case "font-face":
          case "font-face-src":
          case "font-face-uri":
          case "font-face-format":
          case "font-face-name":
          case "missing-glyph":
            m10 = false;
            break e;
          default:
            m10 = true;
        }
        m10 ? Ale.hasOwnProperty(y10) || (c10 = Jse(c10 = y10) && null != u10 ? c10 + '="' + ole(u10) + '"' : "") : c10 = ale(y10, u10), c10 && (l10 += " " + c10);
      }
    }
    i10 || s10 && (l10 += ' data-reactroot=""');
    var y10 = l10;
    a10 = "", Ele.hasOwnProperty(r10) ? y10 += "/>" : (y10 += ">", a10 = "</" + e15.type + ">");
    e: {
      if (null != (i10 = o10.dangerouslySetInnerHTML)) {
        if (null != i10.__html) {
          i10 = i10.__html;
          break e;
        }
      } else if ("string" == typeof (i10 = o10.children) || "number" == typeof i10) {
        i10 = ole(i10);
        break e;
      }
      i10 = null;
    }
    return null != i10 ? (o10 = [], Hle.hasOwnProperty(r10) && "\n" === i10.charAt(0) && (y10 += "\n"), y10 += i10) : o10 = Dle(o10.children), e15 = e15.type, n10 = null == n10 || "http://www.w3.org/1999/xhtml" === n10 ? function(e16) {
      switch (e16) {
        case "svg":
          return "http://www.w3.org/2000/svg";
        case "math":
          return "http://www.w3.org/1998/Math/MathML";
        default:
          return "http://www.w3.org/1999/xhtml";
      }
    }(e15) : "http://www.w3.org/2000/svg" === n10 && "foreignObject" === e15 ? "http://www.w3.org/1999/xhtml" : n10, this.stack.push({ domNamespace: n10, type: r10, children: o10, childIndex: 0, context: t11, footer: a10 }), this.previousWasTextNode = false, y10;
  }, e14;
}(), $le = { renderToString: function(e14) {
  e14 = new zle(e14, false);
  try {
    return e14.read(1 / 0);
  } finally {
    e14.destroy();
  }
}, renderToStaticMarkup: function(e14) {
  e14 = new zle(e14, true);
  try {
    return e14.read(1 / 0);
  } finally {
    e14.destroy();
  }
}, renderToNodeStream: function() {
  throw Error(Ese(207));
}, renderToStaticNodeStream: function() {
  throw Error(Ese(208));
}, version: "16.13.1" };
var Wle = $le.default || $le;
xse.exports = Wle;
var jle = W(xse.exports);
const Zle = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", fill: "none" }), tp.createElement("path", { d: "M24,9H0V8H24Zm0,7H0v1H24ZM24,0H0V1H24Z", fill: "black" }));
const Gle = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("title", null, "vertical_black_24px"), tp.createElement("path", { d: "M0,0V24H24V0Z", fill: "none" }), tp.createElement("path", { d: "M16,24V0h1V24ZM9,24V0H8V24ZM1,24V0H0V24Z", fill: "black" }));
const Ule = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("title", null, "forward-diagonal_black_24px"), tp.createElement("path", { d: "M0,0V24H24V0Z", fill: "none" }), tp.createElement("path", { d: "M.71,0,24,23.29V24h-.71L0,.71V0ZM0,8.71,15.29,24h1.41L0,7.29ZM7.29,0,24,16.71V15.29L8.71,0ZM24,7.29,16.71,0H15.29L24,8.71ZM0,16.71,7.29,24H8.71L0,15.29ZM23.29,0,24,.71V0ZM0,24H.71L0,23.29Z", fill: "black" }));
const qle = tp.createElement("svg", { id: "hatchIcon", width: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", fill: "none" }), tp.createElement("path", { d: "M24,.71.71,24H0v-.71L23.29,0H24ZM15.29,0,0,15.29v1.41L16.71,0ZM24,7.29,7.29,24H8.71L24,8.71ZM16.71,24,24,16.71V15.29L15.29,24ZM7.29,0,0,7.29V8.71L8.71,0ZM24,23.29l-.71.71H24ZM0,0V.71L.71,0Z", fill: "black" }));
const Yle = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", fill: "none" }), tp.createElement("path", { d: "M24,1V0H0V24H1V17H8v7H9V17h7v7h1V17h7V16H17V9h7V8H17V1ZM1,1H8V8H1ZM1,16V9H8v7Zm15,0H9V9h7Zm0-8H9V1h7Z", fill: "black" }));
const Kle = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", fill: "none" }), tp.createElement("path", { d: "M24,0h-.71L20,3.29,16.71,0H15.29L12,3.29,8.71,0H7.29L4,3.29.71,0H0V.71L3.29,4,0,7.29V8.71L3.29,12,0,15.29v1.41H0L3.29,20,0,23.29V24H.71L4,20.71,7.29,24H8.71L12,20.71,15.29,24h1.41L20,20.71,23.29,24H24v-.71L20.71,20,24,16.71V15.29h0L20.71,12,24,8.71V7.29L20.71,4,24,.71ZM16,.71,19.29,4,16,7.29,12.71,4Zm-4,12L15.29,16,12,19.29,8.71,16ZM8,15.29,4.71,12,8,8.71,11.29,12ZM12.71,12,16,8.71,19.29,12,16,15.29ZM12,11.29,8.71,8,12,4.71,15.29,8ZM8,.71,11.29,4,8,7.29,4.71,4ZM.71,8,4,4.71,7.29,8,4,11.29Zm0,8L4,12.71,7.29,16,4,19.29ZM8,23.29,4.71,20,8,16.71,11.29,20Zm8,0L12.71,20,16,16.71,19.29,20ZM23.29,16,20,19.29,16.71,16,20,12.71Zm0-8L20,11.29,16.71,8,20,4.71Z", fill: "black" }));
const Xle = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", fill: "none" }), tp.createElement("path", { d: "M5,5H4V4H5Zm8-1H12V5h1Zm8,0H20V5h1ZM9,8H8V9H9Zm8,0H16V9h1ZM5,12H4v1H5Zm8,0H12v1h1Zm8,0H20v1h1ZM9,16H8v1H9Zm8,0H16v1h1ZM5,20H4v1H5Zm8,0H12v1h1Zm8,0H20v1h1ZM1,8H0V9H1Zm0,8H0v1H1ZM9,0H8V1H9Zm8,0H16V1h1ZM1,0H0V1H1Z", fill: "black" }));
const Jle = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", fill: "none" }), tp.createElement("path", { d: "M1,13H0V12H1Zm8-1H8v1H9Zm8,0H16v1h1ZM5,14H4v1H5Zm8,0H12v1h1ZM1,16H0v1H1Zm8,0H8v1H9Zm8,0H16v1h1ZM5,18H4v1H5Zm8,0H12v1h1ZM1,20H0v1H1Zm8,0H8v1H9Zm8,0H16v1h1ZM1,0H0V1H1ZM9,0H8V1H9Zm8,0H16V1h1ZM5,2H4V3H5Zm8,0H12V3h1ZM1,4H0V5H1ZM9,4H8V5H9Zm8,0H16V5h1ZM5,6H4V7H5Zm8,0H12V7h1ZM1,8H0V9H1ZM9,8H8V9H9Zm8,0H16V9h1ZM5,10H4v1H5Zm8,0H12v1h1ZM5,22H4v1H5Zm8,0H12v1h1Zm8-8H20v1h1Zm0,4H20v1h1ZM21,2H20V3h1Zm0,4H20V7h1Zm0,4H20v1h1Zm0,12H20v1h1Z", fill: "black" }));
const Qle = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", fill: "none" }), tp.createElement("path", { d: "M9,5H8V4H9Zm8-1H16V5h1ZM5,4H4V5H5Zm8,0H12V5h1Zm8,0H20V5h1ZM9,8H8V9H9Zm8,0H16V9h1ZM5,8H4V9H5Zm8,0H12V9h1Zm8,0H20V9h1ZM9,12H8v1H9Zm8,0H16v1h1ZM5,12H4v1H5Zm8,0H12v1h1Zm8,0H20v1h1ZM9,16H8v1H9Zm8,0H16v1h1ZM5,16H4v1H5Zm8,0H12v1h1Zm8,0H20v1h1ZM9,20H8v1H9Zm8,0H16v1h1ZM5,20H4v1H5Zm8,0H12v1h1Zm8,0H20v1h1ZM11,2H10V3h1Zm8,0H18V3h1ZM7,2H6V3H7Zm8,0H14V3h1Zm8,0H22V3h1ZM3,2H2V3H3Zm8,4H10V7h1Zm8,0H18V7h1ZM7,6H6V7H7Zm8,0H14V7h1Zm8,0H22V7h1ZM3,6H2V7H3Zm8,4H10v1h1Zm8,0H18v1h1ZM7,10H6v1H7Zm8,0H14v1h1Zm8,0H22v1h1ZM3,10H2v1H3Zm8,4H10v1h1Zm8,0H18v1h1ZM7,14H6v1H7Zm8,0H14v1h1Zm8,0H22v1h1ZM3,14H2v1H3Zm8,4H10v1h1Zm8,0H18v1h1ZM7,18H6v1H7Zm8,0H14v1h1Zm8,0H22v1h1ZM3,18H2v1H3Zm8,4H10v1h1Zm8,0H18v1h1ZM7,22H6v1H7Zm8,0H14v1h1Zm8,0H22v1h1ZM3,22H2v1H3ZM1,4H0V5H1ZM1,8H0V9H1Zm0,4H0v1H1Zm0,4H0v1H1Zm0,4H0v1H1ZM9,0H8V1H9Zm8,0H16V1h1ZM5,0H4V1H5Zm8,0H12V1h1Zm8,0H20V1h1ZM1,0H0V1H1Z", fill: "black" }));
const ece = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", fill: "none" }), tp.createElement("path", { d: "M3,6H2V5H3ZM3,9H2v1H3Zm0,4H2v1H3Zm0,4H2v1H3Zm0,4H2v1H3ZM3,1H2V2H3ZM3,7H2V8H3Zm0,4H2v1H3Zm0,4H2v1H3Zm0,4H2v1H3Zm0,4H2v1H3ZM3,3H2V4H3ZM7,5H6V6H7ZM7,9H6v1H7Zm0,4H6v1H7Zm0,4H6v1H7Zm0,4H6v1H7ZM7,1H6V2H7ZM7,7H6V8H7Zm0,4H6v1H7Zm0,4H6v1H7Zm0,4H6v1H7Zm0,4H6v1H7ZM7,3H6V4H7ZM5,4H4V5H5ZM5,8H4V9H5Zm0,4H4v1H5Zm0,4H4v1H5Zm0,4H4v1H5ZM5,0H4V1H5ZM5,6H4V7H5Zm0,4H4v1H5Zm0,4H4v1H5Zm0,4H4v1H5Zm0,4H4v1H5ZM5,2H4V3H5ZM1,4H0V5H1ZM1,8H0V9H1Zm0,4H0v1H1Zm0,4H0v1H1Zm0,4H0v1H1ZM1,0H0V1H1ZM1,6H0V7H1Zm0,4H0v1H1Zm0,4H0v1H1Zm0,4H0v1H1Zm0,4H0v1H1ZM1,2H0V3H1ZM11,5H10V6h1Zm0,4H10v1h1Zm0,4H10v1h1Zm0,4H10v1h1Zm0,4H10v1h1ZM11,1H10V2h1Zm0,6H10V8h1Zm0,4H10v1h1Zm0,4H10v1h1Zm0,4H10v1h1Zm0,4H10v1h1ZM11,3H10V4h1Zm4,2H14V6h1Zm0,4H14v1h1Zm0,4H14v1h1Zm0,4H14v1h1Zm0,4H14v1h1ZM15,1H14V2h1Zm0,6H14V8h1Zm0,4H14v1h1Zm0,4H14v1h1Zm0,4H14v1h1Zm0,4H14v1h1ZM15,3H14V4h1ZM13,4H12V5h1Zm0,4H12V9h1Zm0,4H12v1h1Zm0,4H12v1h1Zm0,4H12v1h1ZM13,0H12V1h1Zm0,6H12V7h1Zm0,4H12v1h1Zm0,4H12v1h1Zm0,4H12v1h1Zm0,4H12v1h1ZM13,2H12V3h1ZM9,4H8V5H9ZM9,8H8V9H9Zm0,4H8v1H9Zm0,4H8v1H9Zm0,4H8v1H9ZM9,0H8V1H9ZM9,6H8V7H9Zm0,4H8v1H9Zm0,4H8v1H9Zm0,4H8v1H9Zm0,4H8v1H9ZM9,2H8V3H9ZM19,5H18V6h1Zm0,4H18v1h1Zm0,4H18v1h1Zm0,4H18v1h1Zm0,4H18v1h1ZM19,1H18V2h1Zm0,6H18V8h1Zm0,4H18v1h1Zm0,4H18v1h1Zm0,4H18v1h1Zm0,4H18v1h1ZM19,3H18V4h1Zm4,2H22V6h1Zm0,4H22v1h1Zm0,4H22v1h1Zm0,4H22v1h1Zm0,4H22v1h1ZM23,1H22V2h1Zm0,6H22V8h1Zm0,4H22v1h1Zm0,4H22v1h1Zm0,4H22v1h1Zm0,4H22v1h1ZM23,3H22V4h1ZM21,4H20V5h1Zm0,4H20V9h1Zm0,4H20v1h1Zm0,4H20v1h1Zm0,4H20v1h1ZM21,0H20V1h1Zm0,6H20V7h1Zm0,4H20v1h1Zm0,4H20v1h1Zm0,4H20v1h1Zm0,4H20v1h1ZM21,2H20V3h1ZM17,4H16V5h1Zm0,4H16V9h1Zm0,4H16v1h1Zm0,4H16v1h1Zm0,4H16v1h1ZM17,0H16V1h1Zm0,6H16V7h1Zm0,4H16v1h1Zm0,4H16v1h1Zm0,4H16v1h1Zm0,4H16v1h1ZM17,2H16V3h1Z", fill: "black" }));
const tce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", fill: "none" }), tp.createElement("path", { d: "M2,2H1V1H2ZM2,5H1V6H2ZM2,9H1v1H2Zm0,4H1v1H2Zm0,4H1v1H2Zm0,4H1v1H2ZM3,2H2V3H3ZM3,6H2V7H3Zm0,4H2v1H3Zm0,4H2v1H3Zm0,4H2v1H3Zm0,4H2v1H3ZM3,4H2V5H3ZM3,8H2V9H3Zm0,4H2v1H3Zm0,4H2v1H3Zm0,4H2v1H3ZM4,3H3V4H4ZM4,7H3V8H4Zm0,4H3v1H4Zm0,4H3v1H4Zm0,4H3v1H4Zm0,4H3v1H4ZM3,0H2V1H3ZM6,1H5V2H6ZM6,5H5V6H6ZM6,9H5v1H6Zm0,4H5v1H6Zm0,4H5v1H6Zm0,4H5v1H6ZM7,2H6V3H7ZM7,6H6V7H7Zm0,4H6v1H7Zm0,4H6v1H7Zm0,4H6v1H7Zm0,4H6v1H7ZM7,4H6V5H7ZM7,8H6V9H7Zm0,4H6v1H7Zm0,4H6v1H7Zm0,4H6v1H7ZM8,3H7V4H8ZM8,7H7V8H8Zm0,4H7v1H8Zm0,4H7v1H8Zm0,4H7v1H8Zm0,4H7v1H8ZM7,0H6V1H7ZM5,2H4V3H5ZM5,6H4V7H5Zm0,4H4v1H5Zm0,4H4v1H5Zm0,4H4v1H5Zm0,4H4v1H5ZM5,4H4V5H5ZM5,8H4V9H5Zm0,4H4v1H5Zm0,4H4v1H5Zm0,4H4v1H5ZM5,0H4V1H5ZM1,2H0V3H1ZM1,6H0V7H1Zm0,4H0v1H1Zm0,4H0v1H1Zm0,4H0v1H1Zm0,4H0v1H1ZM1,4H0V5H1ZM1,8H0V9H1Zm0,4H0v1H1Zm0,4H0v1H1Zm0,4H0v1H1ZM1,0H0V1H1Zm9,1H9V2h1Zm0,4H9V6h1Zm0,4H9v1h1Zm0,4H9v1h1Zm0,4H9v1h1Zm0,4H9v1h1ZM11,2H10V3h1Zm0,4H10V7h1Zm0,4H10v1h1Zm0,4H10v1h1Zm0,4H10v1h1Zm0,4H10v1h1ZM11,4H10V5h1Zm0,4H10V9h1Zm0,4H10v1h1Zm0,4H10v1h1Zm0,4H10v1h1ZM12,3H11V4h1Zm0,4H11V8h1Zm0,4H11v1h1Zm0,4H11v1h1Zm0,4H11v1h1Zm0,4H11v1h1ZM11,0H10V1h1Zm3,1H13V2h1Zm0,4H13V6h1Zm0,4H13v1h1Zm0,4H13v1h1Zm0,4H13v1h1Zm0,4H13v1h1ZM13,2H12V3h1Zm0,4H12V7h1Zm0,4H12v1h1Zm0,4H12v1h1Zm0,4H12v1h1Zm0,4H12v1h1ZM13,4H12V5h1Zm0,4H12V9h1Zm0,4H12v1h1Zm0,4H12v1h1Zm0,4H12v1h1ZM13,0H12V1h1ZM9,2H8V3H9ZM9,6H8V7H9Zm0,4H8v1H9Zm0,4H8v1H9Zm0,4H8v1H9Zm0,4H8v1H9ZM9,4H8V5H9ZM9,8H8V9H9Zm0,4H8v1H9Zm0,4H8v1H9Zm0,4H8v1H9ZM9,0H8V1H9Zm9,1H17V2h1Zm0,4H17V6h1Zm0,4H17v1h1Zm0,4H17v1h1Zm0,4H17v1h1Zm0,4H17v1h1ZM19,2H18V3h1Zm0,4H18V7h1Zm0,4H18v1h1Zm0,4H18v1h1Zm0,4H18v1h1Zm0,4H18v1h1ZM19,4H18V5h1Zm0,4H18V9h1Zm0,4H18v1h1Zm0,4H18v1h1Zm0,4H18v1h1ZM20,3H19V4h1Zm0,4H19V8h1Zm0,4H19v1h1Zm0,4H19v1h1Zm0,4H19v1h1Zm0,4H19v1h1ZM19,0H18V1h1Zm3,1H21V2h1Zm0,4H21V6h1Zm0,4H21v1h1Zm0,4H21v1h1Zm0,4H21v1h1Zm0,4H21v1h1ZM23,2H22V3h1Zm0,4H22V7h1Zm0,4H22v1h1Zm0,4H22v1h1Zm0,4H22v1h1Zm0,4H22v1h1ZM23,4H22V5h1Zm0,4H22V9h1Zm0,4H22v1h1Zm0,4H22v1h1Zm0,4H22v1h1ZM24,3H23V4h1Zm0,4H23V8h1Zm0,4H23v1h1Zm0,4H23v1h1Zm0,4H23v1h1Zm0,4H23v1h1ZM23,0H22V1h1ZM21,2H20V3h1Zm0,4H20V7h1Zm0,4H20v1h1Zm0,4H20v1h1Zm0,4H20v1h1Zm0,4H20v1h1ZM21,4H20V5h1Zm0,4H20V9h1Zm0,4H20v1h1Zm0,4H20v1h1Zm0,4H20v1h1ZM21,0H20V1h1ZM17,2H16V3h1Zm0,4H16V7h1Zm0,4H16v1h1Zm0,4H16v1h1Zm0,4H16v1h1Zm0,4H16v1h1ZM17,4H16V5h1Zm0,4H16V9h1Zm0,4H16v1h1Zm0,4H16v1h1Zm0,4H16v1h1ZM17,0H16V1h1ZM15,2H14V3h1Zm0,4H14V7h1Zm0,4H14v1h1Zm0,4H14v1h1Zm0,4H14v1h1Zm0,4H14v1h1ZM15,4H14V5h1Zm0,4H14V9h1Zm0,4H14v1h1Zm0,4H14v1h1Zm0,4H14v1h1ZM16,3H15V4h1Zm0,4H15V8h1Zm0,4H15v1h1Zm0,4H15v1h1Zm0,4H15v1h1Zm0,4H15v1h1ZM15,0H14V1h1Z", fill: "black" }));
const nce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", fill: "none" }), tp.createElement("path", { d: "M16,8H15V7h1Zm2-3H17V6h1Zm0,4H17v1h1Zm1-3H18V7h1Zm0,2H18V9h1Zm1-1H19V8h1ZM17,6H16V7h1Zm0,2H16V9h1Zm-1,7H15v1h1Zm2-2H17v1h1Zm0,4H17v1h1Zm1-3H18v1h1Zm0,2H18v1h1Zm1-1H19v1h1Zm-3-1H16v1h1Zm0,2H16v1h1ZM18,1H17V2h1Zm1-1H18V1h1ZM17,0H16V1h1ZM16,23H15v1h1Zm2-2H17v1h1Zm1,1H18v1h1Zm1,1H19v1h1Zm-3-1H16v1h1ZM8,7H7V8H8Zm2-2H9V6h1Zm0,4H9v1h1Zm1-3H10V7h1Zm0,2H10V9h1Zm1-1H11V8h1ZM9,6H8V7H9ZM9,8H8V9H9ZM8,15H7v1H8Zm2-2H9v1h1Zm0,4H9v1h1Zm1-3H10v1h1Zm0,2H10v1h1Zm1-1H11v1h1ZM9,14H8v1H9Zm0,2H8v1H9ZM10,1H9V2h1Zm1-1H10V1h1ZM9,0H8V1H9ZM8,23H7v1H8Zm2-2H9v1h1Zm1,1H10v1h1Zm1,1H11v1h1ZM9,22H8v1H9ZM2,5H1V6H2ZM2,9H1v1H2ZM3,6H2V7H3ZM3,8H2V9H3ZM4,7H3V8H4ZM1,6H0V7H1ZM1,8H0V9H1Zm1,5H1v1H2Zm0,4H1v1H2Zm1-3H2v1H3Zm0,2H2v1H3Zm1-1H3v1H4ZM1,14H0v1H1Zm0,2H0v1H1ZM2,1H1V2H2ZM3,0H2V1H3ZM1,0H0V1H1ZM2,21H1v1H2Zm1,1H2v1H3Zm1,1H3v1H4ZM1,22H0v1H1ZM12,3H11V4h1Zm2-2H13V2h1Zm0,4H13V6h1Zm1-3H14V3h1Zm0,2H14V5h1Zm1-1H15V4h1ZM13,2H12V3h1Zm0,2H12V5h1Zm-1,7H11v1h1Zm2-2H13v1h1Zm0,4H13v1h1Zm1-3H14v1h1Zm0,2H14v1h1Zm1-1H15v1h1Zm-3-1H12v1h1Zm0,2H12v1h1Zm-1,7H11v1h1Zm2-2H13v1h1Zm0,4H13v1h1Zm1-3H14v1h1Zm0,2H14v1h1Zm1-1H15v1h1Zm-3-1H12v1h1Zm0,2H12v1h1ZM4,3H3V4H4ZM6,1H5V2H6ZM6,5H5V6H6ZM7,2H6V3H7ZM7,4H6V5H7ZM8,3H7V4H8ZM5,2H4V3H5ZM5,4H4V5H5ZM4,11H3v1H4ZM6,9H5v1H6Zm0,4H5v1H6Zm1-3H6v1H7Zm0,2H6v1H7Zm1-1H7v1H8ZM5,10H4v1H5Zm0,2H4v1H5ZM4,19H3v1H4Zm2-2H5v1H6Zm0,4H5v1H6Zm1-3H6v1H7Zm0,2H6v1H7Zm1-1H7v1H8ZM5,18H4v1H5Zm0,2H4v1H5Zm18-4h1V15H23Zm0-8h1V7H23Zm0,16h1V23H23Zm0-4h1V19H23Zm-2,2h1V21H21Zm0-4h1V17H21Zm-1,3h1V20H20Zm0-2h1V18H20Zm-1,1h1V19H19Zm3,1h1V20H22Zm0-2h1V18H22Zm1-7h1V11H23Zm-2,2h1V13H21Zm0-4h1V9H21Zm-1,3h1V12H20Zm0-2h1V10H20Zm-1,1h1V11H19Zm3,1h1V12H22Zm0-2h1V10H22Zm1-7h1V3H23ZM21,6h1V5H21Zm0-4h1V1H21ZM20,5h1V4H20Zm0-2h1V2H20ZM19,4h1V3H19Zm3,1h1V4H22Zm0-2h1V2H22ZM8,1H7V2H8ZM7,0H6V1H7Zm3,3H9V4h1ZM9,2H8V3H9Zm3,3H11V6h1ZM11,4H10V5h1Zm3,3H13V8h1ZM13,6H12V7h1Zm3,3H15v1h1ZM15,8H14V9h1Zm3,3H17v1h1Zm-1-1H16v1h1Zm3,3H19v1h1Zm-1-1H18v1h1Zm3,3H21v1h1Zm-1-1H20v1h1Zm3,3H23v1h1Zm-1-1H22v1h1ZM2,3H1V4H2ZM1,2H0V3H1ZM4,5H3V6H4ZM3,4H2V5H3ZM6,7H5V8H6ZM5,6H4V7H5ZM8,9H7v1H8ZM7,8H6V9H7Zm3,3H9v1h1ZM9,10H8v1H9Zm3,3H11v1h1Zm-1-1H10v1h1Zm3,3H13v1h1Zm-1-1H12v1h1Zm3,3H15v1h1Zm-1-1H14v1h1Zm3,3H17v1h1Zm-1-1H16v1h1Zm3,3H19v1h1Zm-1-1H18v1h1Zm3,3H21v1h1Zm-1-1H20v1h1ZM2,11H1v1H2ZM1,10H0v1H1Zm3,3H3v1H4ZM3,12H2v1H3Zm3,3H5v1H6ZM5,14H4v1H5Zm3,3H7v1H8ZM7,16H6v1H7Zm3,3H9v1h1ZM9,18H8v1H9Zm3,3H11v1h1Zm-1-1H10v1h1Zm3,3H13v1h1Zm-1-1H12v1h1ZM16,1H15V2h1ZM15,0H14V1h1Zm3,3H17V4h1ZM17,2H16V3h1Zm3,3H19V6h1ZM19,4H18V5h1Zm3,3H21V8h1ZM21,6H20V7h1Zm3,3H23v1h1ZM23,8H22V9h1ZM1,18H0v1H1Zm2,2H2v1H3ZM1,20H0v1H1Zm4,2H4v1H5ZM4,21H3v1H4Zm2,2H5v1H6ZM1,4H0V5H1ZM3,2H2V3H3ZM5,0H4V1H5ZM4,1H3V2H4ZM1,12H0v1H1Zm2-2H2v1H3ZM4,9H3v1H4ZM5,8H4V9H5ZM7,6H6V7H7ZM8,5H7V6H8ZM9,4H8V5H9Zm2-2H10V3h1Zm1-1H11V2h1Zm1-1H12V1h1ZM2,19H1v1H2Zm1-1H2v1H3Zm1-1H3v1H4Zm1-1H4v1H5Zm4-4H8v1H9ZM7,14H6v1H7Zm1-1H7v1H8Zm5-5H12V9h1Zm-2,2H10v1h1Zm1-1H11v1h1Zm5-5H16V5h1ZM15,6H14V7h1Zm1-1H15V6h1Zm5-5H20V1h1ZM19,2H18V3h1Zm1-1H19V2h1Zm3-1H22V1h1Zm1,1H23V2h1ZM9,20H8v1H9ZM7,22H6v1H7Zm1-1H7v1H8Zm5-5H12v1h1Zm-2,2H10v1h1Zm1-1H11v1h1Zm5-5H16v1h1Zm-2,2H14v1h1Zm1-1H15v1h1Zm5-5H20V9h1Zm-2,2H18v1h1Zm1-1H19v1h1Zm3-3H22V7h1Zm1-1H23V6h1ZM17,20H16v1h1Zm-2,2H14v1h1Zm1-1H15v1h1Zm5-5H20v1h1Zm-2,2H18v1h1Zm1-1H19v1h1Zm3-3H22v1h1Zm1-1H23v1h1Zm-1,9H22v1h1Zm1-1H23v1h1Z", fill: "black" }));
const rce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", fill: "none" }), tp.createElement("path", { d: "M10,2H9V1h1Zm8-1H17V2h1ZM6,1H5V2H6Zm8,0H13V2h1Zm8,0H21V2h1ZM2,1H1V2H2ZM12,1H11V2h1Zm8,0H19V2h1ZM8,1H7V2H8Zm8,0H15V2h1Zm8,0H23V2h1ZM4,1H3V2H4Zm7,1H10V3h1Zm8,0H18V3h1ZM7,2H6V3H7Zm8,0H14V3h1Zm8,0H22V3h1ZM3,2H2V3H3ZM13,2H12V3h1Zm8,0H20V3h1ZM9,2H8V3H9Zm8,0H16V3h1ZM5,2H4V3H5ZM1,2H0V3H1ZM11,0H10V1h1Zm8,0H18V1h1ZM7,0H6V1H7Zm8,0H14V1h1Zm8,0H22V1h1ZM3,0H2V1H3ZM13,0H12V1h1Zm8,0H20V1h1ZM9,0H8V1H9Zm8,0H16V1h1ZM5,0H4V1H5ZM1,0H0V1H1Zm9,5H9V6h1Zm8,0H17V6h1ZM6,5H5V6H6Zm8,0H13V6h1Zm8,0H21V6h1ZM2,5H1V6H2ZM12,5H11V6h1Zm8,0H19V6h1ZM8,5H7V6H8Zm8,0H15V6h1Zm8,0H23V6h1ZM4,5H3V6H4Zm7,1H10V7h1Zm8,0H18V7h1ZM7,6H6V7H7Zm8,0H14V7h1Zm8,0H22V7h1ZM3,6H2V7H3ZM13,6H12V7h1Zm8,0H20V7h1ZM9,6H8V7H9Zm8,0H16V7h1ZM5,6H4V7H5ZM1,6H0V7H1ZM11,4H10V5h1Zm8,0H18V5h1ZM7,4H6V5H7Zm8,0H14V5h1Zm8,0H22V5h1ZM3,4H2V5H3ZM13,4H12V5h1Zm8,0H20V5h1ZM9,4H8V5H9Zm8,0H16V5h1ZM5,4H4V5H5ZM1,4H0V5H1ZM12,3H11V4h1Zm8,0H19V4h1ZM8,3H7V4H8Zm8,0H15V4h1Zm8,0H23V4h1ZM4,3H3V4H4ZM14,3H13V4h1Zm8,0H21V4h1ZM10,3H9V4h1Zm8,0H17V4h1ZM6,3H5V4H6ZM2,3H1V4H2Zm8,6H9v1h1Zm8,0H17v1h1ZM6,9H5v1H6Zm8,0H13v1h1Zm8,0H21v1h1ZM2,9H1v1H2ZM12,9H11v1h1Zm8,0H19v1h1ZM8,9H7v1H8Zm8,0H15v1h1Zm8,0H23v1h1ZM4,9H3v1H4Zm7,1H10v1h1Zm8,0H18v1h1ZM7,10H6v1H7Zm8,0H14v1h1Zm8,0H22v1h1ZM3,10H2v1H3Zm10,0H12v1h1Zm8,0H20v1h1ZM9,10H8v1H9Zm8,0H16v1h1ZM5,10H4v1H5ZM1,10H0v1H1ZM11,8H10V9h1Zm8,0H18V9h1ZM7,8H6V9H7Zm8,0H14V9h1Zm8,0H22V9h1ZM3,8H2V9H3ZM13,8H12V9h1Zm8,0H20V9h1ZM9,8H8V9H9Zm8,0H16V9h1ZM5,8H4V9H5ZM1,8H0V9H1Zm9,5H9v1h1Zm8,0H17v1h1ZM6,13H5v1H6Zm8,0H13v1h1Zm8,0H21v1h1ZM2,13H1v1H2Zm10,0H11v1h1Zm8,0H19v1h1ZM8,13H7v1H8Zm8,0H15v1h1Zm8,0H23v1h1ZM4,13H3v1H4Zm7,1H10v1h1Zm8,0H18v1h1ZM7,14H6v1H7Zm8,0H14v1h1Zm8,0H22v1h1ZM3,14H2v1H3Zm10,0H12v1h1Zm8,0H20v1h1ZM9,14H8v1H9Zm8,0H16v1h1ZM5,14H4v1H5ZM1,14H0v1H1Zm10-2H10v1h1Zm8,0H18v1h1ZM7,12H6v1H7Zm8,0H14v1h1Zm8,0H22v1h1ZM3,12H2v1H3Zm10,0H12v1h1Zm8,0H20v1h1ZM9,12H8v1H9Zm8,0H16v1h1ZM5,12H4v1H5ZM1,12H0v1H1Zm11-1H11v1h1Zm8,0H19v1h1ZM8,11H7v1H8Zm8,0H15v1h1Zm8,0H23v1h1ZM4,11H3v1H4Zm10,0H13v1h1Zm8,0H21v1h1ZM10,11H9v1h1Zm8,0H17v1h1ZM6,11H5v1H6ZM2,11H1v1H2Zm8,6H9v1h1Zm8,0H17v1h1ZM6,17H5v1H6Zm8,0H13v1h1Zm8,0H21v1h1ZM2,17H1v1H2Zm10,0H11v1h1Zm8,0H19v1h1ZM8,17H7v1H8Zm8,0H15v1h1Zm8,0H23v1h1ZM4,17H3v1H4Zm7,1H10v1h1Zm8,0H18v1h1ZM7,18H6v1H7Zm8,0H14v1h1Zm8,0H22v1h1ZM3,18H2v1H3Zm10,0H12v1h1Zm8,0H20v1h1ZM9,18H8v1H9Zm8,0H16v1h1ZM5,18H4v1H5ZM1,18H0v1H1Zm10-2H10v1h1Zm8,0H18v1h1ZM7,16H6v1H7Zm8,0H14v1h1Zm8,0H22v1h1ZM3,16H2v1H3Zm10,0H12v1h1Zm8,0H20v1h1ZM9,16H8v1H9Zm8,0H16v1h1ZM5,16H4v1H5ZM1,16H0v1H1Zm9,5H9v1h1Zm8,0H17v1h1ZM6,21H5v1H6Zm8,0H13v1h1Zm8,0H21v1h1ZM2,21H1v1H2Zm10,0H11v1h1Zm8,0H19v1h1ZM8,21H7v1H8Zm8,0H15v1h1Zm8,0H23v1h1ZM4,21H3v1H4Zm7,1H10v1h1Zm8,0H18v1h1ZM7,22H6v1H7Zm8,0H14v1h1Zm8,0H22v1h1ZM3,22H2v1H3Zm10,0H12v1h1Zm8,0H20v1h1ZM9,22H8v1H9Zm8,0H16v1h1ZM5,22H4v1H5ZM1,22H0v1H1Zm10-2H10v1h1Zm8,0H18v1h1ZM7,20H6v1H7Zm8,0H14v1h1Zm8,0H22v1h1ZM3,20H2v1H3Zm10,0H12v1h1Zm8,0H20v1h1ZM9,20H8v1H9Zm8,0H16v1h1ZM5,20H4v1H5ZM1,20H0v1H1Zm11-1H11v1h1Zm8,0H19v1h1ZM8,19H7v1H8Zm8,0H15v1h1Zm8,0H23v1h1ZM4,19H3v1H4Zm10,0H13v1h1Zm8,0H21v1h1ZM10,19H9v1h1Zm8,0H17v1h1ZM6,19H5v1H6ZM2,19H1v1H2ZM10,7H9V8h1Zm8,0H17V8h1ZM6,7H5V8H6Zm8,0H13V8h1Zm8,0H21V8h1ZM2,7H1V8H2ZM12,7H11V8h1Zm8,0H19V8h1ZM8,7H7V8H8Zm8,0H15V8h1Zm8,0H23V8h1ZM4,7H3V8H4Zm6,8H9v1h1Zm8,0H17v1h1ZM6,15H5v1H6Zm8,0H13v1h1Zm8,0H21v1h1ZM2,15H1v1H2Zm10,0H11v1h1Zm8,0H19v1h1ZM8,15H7v1H8Zm8,0H15v1h1Zm8,0H23v1h1ZM4,15H3v1H4Zm6,8H9v1h1Zm8,0H17v1h1ZM6,23H5v1H6Zm8,0H13v1h1Zm8,0H21v1h1ZM2,23H1v1H2Zm10,0H11v1h1Zm8,0H19v1h1ZM8,23H7v1H8Zm8,0H15v1h1Zm8,0H23v1h1ZM4,23H3v1H4Z", fill: "black" }));
const oce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", fill: "none" }), tp.createElement("path", { d: "M5,2V3H4V4H3V3H2V2H3V1H4V2ZM4,6V5H3V6H2V7H3V8H4V7H5V6Zm0,4V9H3v1H2v1H3v1H4V11H5V10Zm0,4V13H3v1H2v1H3v1H4V15H5V14Zm0,4V17H3v1H2v1H3v1H4V19H5V18Zm0,4V21H3v1H2v1H3v1H4V23H5V22ZM8,2V1H7V2H6V3H7V4H8V3H9V2ZM8,6V5H7V6H6V7H7V8H8V7H9V6Zm0,4V9H7v1H6v1H7v1H8V11H9V10Zm0,4V13H7v1H6v1H7v1H8V15H9V14Zm0,4V17H7v1H6v1H7v1H8V19H9V18Zm0,4V21H7v1H6v1H7v1H8V23H9V22ZM12,2V1H11V2H10V3h1V4h1V3h1V2Zm0,4V5H11V6H10V7h1V8h1V7h1V6Zm0,4V9H11v1H10v1h1v1h1V11h1V10Zm0,4V13H11v1H10v1h1v1h1V15h1V14Zm0,4V17H11v1H10v1h1v1h1V19h1V18Zm0,4V21H11v1H10v1h1v1h1V23h1V22ZM16,2V1H15V2H14V3h1V4h1V3h1V2Zm0,4V5H15V6H14V7h1V8h1V7h1V6Zm0,4V9H15v1H14v1h1v1h1V11h1V10Zm0,4V13H15v1H14v1h1v1h1V15h1V14Zm0,4V17H15v1H14v1h1v1h1V19h1V18Zm0,4V21H15v1H14v1h1v1h1V23h1V22ZM20,2V1H19V2H18V3h1V4h1V3h1V2Zm0,4V5H19V6H18V7h1V8h1V7h1V6Zm0,4V9H19v1H18v1h1v1h1V11h1V10Zm0,4V13H19v1H18v1h1v1h1V15h1V14Zm0,4V17H19v1H18v1h1v1h1V19h1V18Zm0,4V21H19v1H18v1h1v1h1V23h1V22ZM0,0V1H1V2H2V1H3V0ZM4,0V1H5V2H6V1H7V0ZM8,0V1H9V2h1V1h1V0Zm4,0V1h1V2h1V1h1V0Zm4,0V1h1V2h1V1h1V0Zm4,0V1h1V2h1V1h1V0ZM2,4V3H1V4H0V5H1V6H2V5H3V4ZM6,4V3H5V4H4V5H5V6H6V5H7V4Zm4,0V3H9V4H8V5H9V6h1V5h1V4Zm4,0V3H13V4H12V5h1V6h1V5h1V4Zm4,0V3H17V4H16V5h1V6h1V5h1V4Zm4,0V3H21V4H20V5h1V6h1V5h1V4ZM2,8V7H1V8H0V9H1v1H2V9H3V8ZM6,8V7H5V8H4V9H5v1H6V9H7V8Zm4,0V7H9V8H8V9H9v1h1V9h1V8Zm4,0V7H13V8H12V9h1v1h1V9h1V8Zm4,0V7H17V8H16V9h1v1h1V9h1V8Zm4,0V7H21V8H20V9h1v1h1V9h1V8ZM2,12V11H1v1H0v1H1v1H2V13H3V12Zm4,0V11H5v1H4v1H5v1H6V13H7V12Zm4,0V11H9v1H8v1H9v1h1V13h1V12Zm4,0V11H13v1H12v1h1v1h1V13h1V12Zm4,0V11H17v1H16v1h1v1h1V13h1V12Zm4,0V11H21v1H20v1h1v1h1V13h1V12ZM2,16V15H1v1H0v1H1v1H2V17H3V16Zm4,0V15H5v1H4v1H5v1H6V17H7V16Zm4,0V15H9v1H8v1H9v1h1V17h1V16Zm4,0V15H13v1H12v1h1v1h1V17h1V16Zm4,0V15H17v1H16v1h1v1h1V17h1V16Zm4,0V15H21v1H20v1h1v1h1V17h1V16ZM2,20V19H1v1H0v1H1v1H2V21H3V20Zm4,0V19H5v1H4v1H5v1H6V21H7V20Zm4,0V19H9v1H8v1H9v1h1V21h1V20Zm4,0V19H13v1H12v1h1v1h1V21h1V20Zm4,0V19H17v1H16v1h1v1h1V21h1V20Zm4,0V19H21v1H20v1h1v1h1V21h1V20ZM24,1H23V2H22V3h1V4h1Zm0,4H23V6H22V7h1V8h1Zm0,4H23v1H22v1h1v1h1Zm0,4H23v1H22v1h1v1h1Zm0,4H23v1H22v1h1v1h1Zm0,4H23v1H22v1h1v1h1ZM1,22H0v1H1Zm0-4H0v1H1Zm0-4H0v1H1Zm0-4H0v1H1ZM1,6H0V7H1ZM1,2H0V3H1ZM6,23H5v1H6Zm4,0H9v1h1Zm4,0H13v1h1Zm4,0H17v1h1Zm4,0H21v1h1ZM2,23H1v1H2Z", fill: "black" }));
const ace = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", fill: "none" }), tp.createElement("path", { d: "M23,0H21V1H20V0H17V1H16V0H13V1H12V0H9V1H8V0H5V1H4V0H1V1H0V2H1V3H0V4H1V5H0V6H1V7H0V8H1V9H0v1H1v1H0v1H1v1H0v1H1v1H0v1H1v1H0v1H1v1H0v1H1v1H0v1H1v1H0v1H2V23H3v1H6V23H7v1h3V23h1v1h3V23h1v1h3V23h1v1h3V23h1v1h1V0ZM3,22H2V21H3Zm0-2H2V19H3Zm0-2H2V17H3Zm0-2H2V15H3Zm0-2H2V13H3Zm0-2H2V11H3Zm0-2H2V9H3ZM3,8H2V7H3ZM3,6H2V5H3ZM3,4H2V3H3ZM3,2H2V1H3ZM5,23H4V22H5Zm0-2H4V20H5Zm0-2H4V18H5Zm0-2H4V16H5Zm0-2H4V14H5Zm0-2H4V12H5Zm0-2H4V10H5ZM5,9H4V8H5ZM5,7H4V6H5ZM5,5H4V4H5ZM5,3H4V2H5ZM7,22H6V21H7Zm0-2H6V19H7Zm0-2H6V17H7Zm0-2H6V15H7Zm0-2H6V13H7Zm0-2H6V11H7Zm0-2H6V9H7ZM7,8H6V7H7ZM7,6H6V5H7ZM7,4H6V3H7ZM7,2H6V1H7ZM9,23H8V22H9Zm0-2H8V20H9Zm0-2H8V18H9Zm0-2H8V16H9Zm0-2H8V14H9Zm0-2H8V12H9Zm0-2H8V10H9ZM9,9H8V8H9ZM9,7H8V6H9ZM9,5H8V4H9ZM9,3H8V2H9Zm2,19H10V21h1Zm0-2H10V19h1Zm0-2H10V17h1Zm0-2H10V15h1Zm0-2H10V13h1Zm0-2H10V11h1Zm0-2H10V9h1Zm0-2H10V7h1Zm0-2H10V5h1Zm0-2H10V3h1Zm0-2H10V1h1Zm2,21H12V22h1Zm0-2H12V20h1Zm0-2H12V18h1Zm0-2H12V16h1Zm0-2H12V14h1Zm0-2H12V12h1Zm0-2H12V10h1Zm0-2H12V8h1Zm0-2H12V6h1Zm0-2H12V4h1Zm0-2H12V2h1Zm2,19H14V21h1Zm0-2H14V19h1Zm0-2H14V17h1Zm0-2H14V15h1Zm0-2H14V13h1Zm0-2H14V11h1Zm0-2H14V9h1Zm0-2H14V7h1Zm0-2H14V5h1Zm0-2H14V3h1Zm0-2H14V1h1Zm2,21H16V22h1Zm0-2H16V20h1Zm0-2H16V18h1Zm0-2H16V16h1Zm0-2H16V14h1Zm0-2H16V12h1Zm0-2H16V10h1Zm0-2H16V8h1Zm0-2H16V6h1Zm0-2H16V4h1Zm0-2H16V2h1Zm2,19H18V21h1Zm0-2H18V19h1Zm0-2H18V17h1Zm0-2H18V15h1Zm0-2H18V13h1Zm0-2H18V11h1Zm0-2H18V9h1Zm0-2H18V7h1Zm0-2H18V5h1Zm0-2H18V3h1Zm0-2H18V1h1Zm2,21H20V22h1Zm0-2H20V20h1Zm0-2H20V18h1Zm0-2H20V16h1Zm0-2H20V14h1Zm0-2H20V12h1Zm0-2H20V10h1Zm0-2H20V8h1Zm0-2H20V6h1Zm0-2H20V4h1Zm0-2H20V2h1Zm2,19H22V21h1Zm0-2H22V19h1Zm0-2H22V17h1Zm0-2H22V15h1Zm0-2H22V13h1Zm0-2H22V11h1Zm0-2H22V9h1Zm0-2H22V7h1Zm0-2H22V5h1Zm0-2H22V3h1Zm0-2H22V1h1Z", fill: "black" }));
const ice = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", fill: "none" }), tp.createElement("path", { d: "M21,0V1H20V0H17V1H16V0H13V1H12V0H9V1H8V0H5V1H4V0H1V1H0V4H1V5H0V8H1V9H0v3H1v1H0v3H1v1H0v3H1v1H0v3H24V0ZM3,23H2V22H3Zm0-4H2V18H3Zm0-4H2V14H3Zm0-4H2V10H3ZM3,7H2V6H3ZM3,3H2V2H3ZM5,21H4V20H5Zm0-4H4V16H5Zm0-4H4V12H5ZM5,9H4V8H5ZM5,5H4V4H5ZM7,23H6V22H7Zm0-4H6V18H7Zm0-4H6V14H7Zm0-4H6V10H7ZM7,7H6V6H7ZM7,3H6V2H7ZM9,21H8V20H9Zm0-4H8V16H9Zm0-4H8V12H9ZM9,9H8V8H9ZM9,5H8V4H9Zm2,18H10V22h1Zm0-4H10V18h1Zm0-4H10V14h1Zm0-4H10V10h1Zm0-4H10V6h1Zm0-4H10V2h1Zm2,18H12V20h1Zm0-4H12V16h1Zm0-4H12V12h1Zm0-4H12V8h1Zm0-4H12V4h1Zm2,18H14V22h1Zm0-4H14V18h1Zm0-4H14V14h1Zm0-4H14V10h1Zm0-4H14V6h1Zm0-4H14V2h1Zm2,18H16V20h1Zm0-4H16V16h1Zm0-4H16V12h1Zm0-4H16V8h1Zm0-4H16V4h1Zm2,18H18V22h1Zm0-4H18V18h1Zm0-4H18V14h1Zm0-4H18V10h1Zm0-4H18V6h1Zm0-4H18V2h1Zm2,18H20V20h1Zm0-4H20V16h1Zm0-4H20V12h1Zm0-4H20V8h1Zm0-4H20V4h1Zm2,18H22V22h1Zm0-4H22V18h1Zm0-4H22V14h1Zm0-4H22V10h1Zm0-4H22V6h1Zm0-4H22V2h1Z", fill: "black" }));
const sce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", fill: "none" }), tp.createElement("path", { d: "M20,0V1H19V0H12V1H11V0H4V1H3V0H0V24H24V0ZM4,21H3V20H4Zm0-4H3V16H4Zm0-4H3V12H4ZM4,9H3V8H4ZM4,5H3V4H4ZM8,23H7V22H8Zm0-4H7V18H8Zm0-4H7V14H8Zm0-4H7V10H8ZM8,7H7V6H8ZM8,3H7V2H8Zm4,18H11V20h1Zm0-4H11V16h1Zm0-4H11V12h1Zm0-4H11V8h1Zm0-4H11V4h1Zm4,18H15V22h1Zm0-4H15V18h1Zm0-4H15V14h1Zm0-4H15V10h1Zm0-4H15V6h1Zm0-4H15V2h1Zm4,18H19V20h1Zm0-4H19V16h1Zm0-4H19V12h1Zm0-4H19V8h1Zm0-4H19V4h1Zm4,18H23V22h1Zm0-4H23V18h1Zm0-4H23V14h1Zm0-4H23V10h1Zm0-4H23V6h1Zm0-4H23V2h1Z", fill: "black" }));
const lce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", fill: "none" }), tp.createElement("path", { d: "M0,0V24H24V0ZM2,23H1V22H2Zm0-8H1V14H2ZM2,7H1V6H2ZM6,19H5V18H6Zm0-8H5V10H6ZM6,3H5V2H6Zm4,20H9V22h1Zm0-8H9V14h1Zm0-8H9V6h1Zm4,12H13V18h1Zm0-8H13V10h1Zm0-8H13V2h1Zm4,20H17V22h1Zm0-8H17V14h1Zm0-8H17V6h1Zm4,12H21V18h1Zm0-8H21V10h1Zm0-8H21V2h1Z", fill: "black" }));
const cce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M24,0H0V24H24Z", fill: "none" }), tp.createElement("path", { d: "M.35,0,24,23.65V24h-.35L0,.35V0ZM3.65,0,24,20.35v-.71L4.35,0Zm4,0L24,16.35v-.71L8.35,0Zm4,0L24,12.35v-.71L12.35,0Zm4,0L24,8.35V7.65L16.35,0Zm4,0L24,4.35V3.65L20.35,0ZM24,0h-.35L24,.35ZM0,24H.35L0,23.65Zm0-3.65L3.65,24h.71L0,19.65Zm0-4L7.65,24h.71L0,15.65Zm0-4L11.65,24h.71L0,11.65Zm0-4L15.65,24h.71L0,7.65Zm0-4L19.65,24h.71L0,3.65Z", fill: "black" }));
const uce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,24H24V0H0Z", fill: "none" }), tp.createElement("path", { d: "M24,.35.35,24H0v-.35L23.65,0H24Zm0,3.29L3.65,24h.71L24,4.35Zm0,4L7.65,24h.71L24,8.35Zm0,4L11.65,24h.71L24,12.35Zm0,4L15.65,24h.71L24,16.35Zm0,4L19.65,24h.71L24,20.35ZM24,24v-.35l-.35.35ZM0,0V.35L.35,0ZM3.65,0,0,3.65v.71L4.35,0Zm4,0L0,7.65v.71L8.35,0Zm4,0L0,11.65v.71L12.35,0Zm4,0L0,15.65v.71L16.35,0Zm4,0L0,19.65v.71L20.35,0Z", fill: "black" }));
const dce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", fill: "none" }), tp.createElement("path", { d: "M0,11.29,12.71,24H11.29L0,12.71Zm0,5.41L7.29,24H8.71L0,15.29Zm0,4L3.29,24H4.71L0,19.29ZM0,24H.71L0,23.29ZM11.29,0,24,12.71V11.29L12.71,0Zm4,0L24,8.71V7.29L16.71,0Zm4,0L24,4.71V3.29L20.71,0ZM24,0h-.71L24,.71ZM0,0V.71L23.29,24H24v-.71L.71,0ZM3.29,0,24,20.71V19.29L4.71,0ZM0,4.71,19.29,24h1.41L0,3.29Zm0,4L15.29,24h1.41L0,7.29ZM7.29,0,24,16.71V15.29L8.71,0Z", fill: "black" }));
const pce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,24V0H24V24Z", fill: "none" }), tp.createElement("path", { d: "M12.71,0,0,12.71V11.29L11.29,0ZM7.29,0,0,7.29V8.71L8.71,0Zm-4,0L0,3.29V4.71L4.71,0ZM0,0V.71L.71,0ZM24,11.29,11.29,24h1.41L24,12.71Zm0,4L15.29,24h1.41L24,16.71Zm0,4L19.29,24h1.41L24,20.71ZM24,24v-.71l-.71.71ZM24,0h-.71L0,23.29V24H.71L24,.71Zm0,3.29L3.29,24H4.71L24,4.71ZM19.29,0,0,19.29v1.41L20.71,0Zm-4,0L0,15.29v1.41L16.71,0ZM24,7.29,7.29,24H8.71L24,8.71Z", fill: "black" }));
const mce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,24V0H24V24Z", fill: "none" }), tp.createElement("path", { d: "M1.41,0,24,22.59V24H22.59L0,1.41V0ZM0,9.41,14.59,24h2.83L0,6.59ZM6.59,0,24,17.41V14.59L9.41,0Zm8,0L24,9.41V6.59L17.41,0ZM24,0H22.59L24,1.41ZM0,24H1.41L0,22.59Zm0-6.59L6.59,24H9.41L0,14.59Z", fill: "black" }));
const hce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,24V0H24V24Z", fill: "none" }), tp.createElement("path", { d: "M0,22.59,22.59,0H24V1.41L1.41,24H0ZM9.41,24,24,9.41V6.59L6.59,24ZM0,17.41,17.41,0H14.59L0,14.59Zm0-8L9.41,0H6.59L0,6.59ZM0,0V1.41L1.41,0ZM24,24V22.59L22.59,24Zm-6.59,0L24,17.41V14.59L14.59,24Z", fill: "black" }));
const fce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,24V0H24V24Z", fill: "none" }), tp.createElement("path", { d: "M5,24H4V0H5ZM9,0H8V24H9Zm4,0H12V24h1Zm4,0H16V24h1Zm4,0H20V24h1ZM1,0H0V24H1Z", fill: "black" }));
const gce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,24V0H24V24Z", fill: "none" }), tp.createElement("path", { d: "M24,16v1H0V16ZM0,12v1H24V12ZM0,8V9H24V8ZM0,4V5H24V4ZM0,0V1H24V0ZM0,20v1H24V20Z", fill: "black" }));
const yce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,24V0H24V24Z", fill: "none" }), tp.createElement("path", { d: "M2,24H1V0H2ZM4,0H3V24H4ZM6,0H5V24H6ZM8,0H7V24H8Zm2,0H9V24h1Zm2,0H11V24h1Zm2,0H13V24h1Zm2,0H15V24h1Zm2,0H17V24h1Zm2,0H19V24h1Zm2,0H21V24h1Zm2,0H23V24h1Z", fill: "black" }));
const vce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,24V0H24V24Z", fill: "none" }), tp.createElement("path", { d: "M0,1V0H24V1ZM24,3V2H0V3Zm0,2V4H0V5Zm0,2V6H0V7Zm0,2V8H0V9Zm0,2V10H0v1Zm0,2V12H0v1Zm0,2V14H0v1Zm0,2V16H0v1Zm0,2V18H0v1Zm0,2V20H0v1Zm0,2V22H0v1Z", fill: "black" }));
const bce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,24V0H24V24Z", fill: "none" }), tp.createElement("path", { d: "M14,24H12V0h2ZM10,0H8V24h2Zm0,0H8V24h2ZM6,0H4V24H6ZM22,0H20V24h2ZM18,0H16V24h2ZM2,0H0V24H2Z", fill: "black" }));
const Sce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,24V0H24V24Z", fill: "none" }), tp.createElement("path", { d: "M0,14V12H24v2Zm24-4V8H0v2Zm0,0V8H0v2Zm0-4V4H0V6Zm0,16V20H0v2Zm0-4V16H0v2ZM24,2V0H0V2Z", fill: "black" }));
const Cce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", fill: "none" }), tp.createElement("path", { d: "M8,13.33,7.33,14,4,10.67,4.67,10ZM.67,10,0,10.67,3.33,14,4,13.33Zm12,0-.67.67L15.33,14l.67-.67Zm-4,0L8,10.67,11.33,14l.67-.67Zm12,0-.67.67L23.33,14l.67-.67Zm-4,0-.67.67L19.33,14l.67-.67Zm-12,8L4,18.67,7.33,22,8,21.33Zm-4,0L0,18.67,3.33,22,4,21.33Zm12,0-.67.67L15.33,22l.67-.67Zm-4,0L8,18.67,11.33,22l.67-.67Zm12,0-.67.67L23.33,22l.67-.67Zm-4,0-.67.67L19.33,22l.67-.67ZM4.67,2,4,2.67,7.33,6,8,5.33Zm-4,0L0,2.67,3.33,6,4,5.33Zm12,0L12,2.67,15.33,6,16,5.33Zm-4,0L8,2.67,11.33,6,12,5.33Zm12,0L20,2.67,23.33,6,24,5.33Zm-4,0L16,2.67,19.33,6,20,5.33Z", fill: "black" }));
const xce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,24V0H24V24Z", fill: "none" }), tp.createElement("path", { d: "M4.67,14,4,13.33,7.33,10l.67.67ZM4,10.67,3.33,10,0,13.33.67,14Zm12,0L15.33,10,12,13.33l.67.67Zm-4,0L11.33,10,8,13.33l.67.67Zm12,0L23.33,10,20,13.33l.67.67Zm-4,0L19.33,10,16,13.33l.67.67Zm-12-8L7.33,2,4,5.33,4.67,6Zm-4,0L3.33,2,0,5.33.67,6Zm12,0L15.33,2,12,5.33l.67.67Zm-4,0L11.33,2,8,5.33,8.67,6Zm12,0L23.33,2,20,5.33l.67.67Zm-4,0L19.33,2,16,5.33l.67.67Zm-12,16L7.33,18,4,21.33l.67.67Zm-4,0L3.33,18,0,21.33.67,22Zm12,0L15.33,18,12,21.33l.67.67Zm-4,0L11.33,18,8,21.33l.67.67Zm12,0L23.33,18,20,21.33l.67.67Zm-4,0L19.33,18,16,21.33l.67.67Z", fill: "black" }));
const wce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,24V0H24V24Z", fill: "none" }), tp.createElement("path", { d: "M4,4H8V5H4Zm8,1h4V4H12Zm8-1V5h4V4ZM4,8H0V9H4Zm8,0H8V9h4Zm4,1h4V8H16ZM4,13H8V12H4Zm12-1H12v1h4Zm4,1h4V12H20ZM4,0H0V1H4Zm8,0H8V1h4Zm8,0H16V1h4ZM4,21H8V20H4Zm8,0h4V20H12Zm8,0h4V20H20ZM4,16H0v1H4Zm8,0H8v1h4Zm8,0H16v1h4Z", fill: "black" }));
const Tce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,24V0H24V24Z", fill: "none" }), tp.createElement("path", { d: "M8,16H9v4H8Zm0-4H9V8H8ZM8,4H9V0H8Zm4,20h1V20H12Zm0-8h1V12H12Zm0-8h1V4H12Zm4,12h1V16H16Zm0-8h1V8H16Zm0-8h1V0H16ZM4,24H5V20H4Zm0-8H5V12H4ZM4,8H5V4H4ZM0,20H1V16H0Zm0-8H1V8H0ZM0,4H1V0H0ZM20,24h1V20H20Zm0-8h1V12H20Zm0-8h1V4H20Z", fill: "black" }));
const Ece = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,24V0H24V24Z", fill: "none" }), tp.createElement("path", { d: "M0,18H1v1H0Zm0-7H1V10H0ZM0,3H1V2H0ZM1,23H2V22H1Zm0-8H2V14H1ZM1,7H2V6H1ZM3,18H4V17H3Zm0-8H4V9H3ZM3,2H4V1H3ZM4,24H5V23H4Zm0-8H5V15H4ZM4,8H5V7H4ZM2,5H3V4H2Zm0,8H3V12H2Zm0,8H3V20H2ZM5,4H6V3H5Zm0,8H6V11H5Zm0,8H6V19H5ZM6,6H7V5H6Zm0,8H7V13H6Zm0,8H7V21H6ZM7,9H8V8H7Zm0,8H8V16H7ZM7,1H8V0H7ZM8,19H9V18H8Zm0-8H9V10H8ZM8,3H9V2H8ZM9,23h1V22H9Zm0-8h1V14H9ZM9,7h1V6H9Zm2,11h1V17H11Zm0-8h1V9H11Zm0-8h1V1H11Zm1,22h1V23H12Zm0-8h1V15H12Zm0-8h1V7H12ZM10,5h1V4H10Zm0,8h1V12H10Zm0,8h1V20H10ZM13,4h1V3H13Zm0,8h1V11H13Zm0,8h1V19H13ZM14,6h1V5H14Zm0,8h1V13H14Zm0,8h1V21H14ZM15,9h1V8H15Zm0,8h1V16H15ZM15,1h1V0H15Zm1,18h1V18H16Zm0-8h1V10H16Zm0-8h1V2H16Zm1,20h1V22H17Zm0-8h1V14H17Zm0-8h1V6H17Zm2,11h1V17H19Zm0-8h1V9H19Zm0-8h1V1H19Zm1,22h1V23H20Zm0-8h1V15H20Zm0-8h1V7H20ZM18,5h1V4H18Zm0,8h1V12H18Zm0,8h1V20H18ZM21,4h1V3H21Zm0,8h1V11H21Zm0,8h1V19H21ZM22,6h1V5H22Zm0,8h1V13H22Zm0,8h1V21H22ZM23,9h1V8H23Zm0,8h1V16H23ZM23,1h1V0H23Z", fill: "black" }));
const Fce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,24V0H24V24Z", fill: "none" }), tp.createElement("path", { d: "M5,5H3V3H5ZM6,6H4V8H6ZM3,9H1v2H3Zm2,2H3v2H5Zm1,3H4v2H6ZM4,16H2v2H4Zm1,3H3v2H5Zm1,3H4v2H6ZM2,22H0v2H2Zm0-9H0v2H2ZM2,5H0V7H2ZM8,2H6V4H8Zm2,2H8V6h2ZM9,7H7V9H9ZM8,10H6v2H8Zm2,2H8v2h2ZM9,15H7v2H9ZM8,18H6v2H8Zm2,2H8v2h2Zm6,2H14v2h2Zm-3-3H11v2h2Zm-1-3H10v2h2Zm2-2H12v2h2Zm-1-3H11v2h2ZM12,8H10v2h2Zm3-2H13V8h2ZM13,4H11V6h2ZM10,0H8V2h2Zm7,2H15V4h2ZM16,9H14v2h2Zm2,3H16v2h2Zm-1,3H15v2h2Zm-1,3H14v2h2Zm2,2H16v2h2Zm4,2H20v2h2Zm-1-3H19v2h2Zm3-3H22v2h2Zm-4,0H18v2h2Zm1-5H19v2h2Zm3-3H22v2h2ZM20,8H18v2h2Zm2-2H20V8h2ZM18,5H16V7h2Zm2-5H18V2h2Zm3,3H21V5h2ZM12,22H10v2h2Zm10-8H20v2h2ZM3,1H1V3H3ZM2,18H0v2H2ZM14,1H12V3h2ZM24,20H22v2h2Zm0-9H22v2h2ZM20,3H18V5h2Zm4-3H22V2h2Z", fill: "black" }));
const Mce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,24V0H24V24Z", fill: "none" }), tp.createElement("path", { d: "M20,11.94a3,3,0,0,1-2.41-1.66c-.53-.76-.89-1.23-1.59-1.23s-1.06.47-1.59,1.23A3,3,0,0,1,12,11.94a3,3,0,0,1-2.41-1.66C9.06,9.53,8.7,9.06,8,9.06s-1.06.47-1.59,1.23A3,3,0,0,1,4,11.94a3,3,0,0,1-2.41-1.66C1.06,9.53.7,9.06,0,9.06v-1A3,3,0,0,1,2.41,9.71c.53.76.89,1.23,1.59,1.23s1.06-.47,1.59-1.23A3,3,0,0,1,8,8.06,3,3,0,0,1,10.4,9.71c.53.76.89,1.23,1.59,1.23s1.06-.47,1.59-1.23A3,3,0,0,1,16,8.06,3,3,0,0,1,18.4,9.71c.53.76.89,1.23,1.59,1.23s1.06-.47,1.59-1.23A3,3,0,0,1,24,8.06v1c-.7,0-1.06.47-1.59,1.23A3,3,0,0,1,20,11.94Zm2.41,2.34c.53-.76.89-1.23,1.59-1.23v-1a3,3,0,0,0-2.41,1.66c-.53.76-.89,1.23-1.59,1.23s-1.06-.47-1.59-1.23A3,3,0,0,0,16,12.06a3,3,0,0,0-2.41,1.66c-.53.76-.89,1.23-1.59,1.23s-1.06-.47-1.59-1.23A3,3,0,0,0,8,12.06a3,3,0,0,0-2.41,1.66c-.53.76-.89,1.23-1.59,1.23s-1.06-.47-1.59-1.23A3,3,0,0,0,0,12.06v1c.7,0,1.06.47,1.59,1.23A3,3,0,0,0,4,15.94a3,3,0,0,0,2.41-1.66c.53-.76.89-1.23,1.59-1.23s1.06.47,1.59,1.23A3,3,0,0,0,12,15.94a3,3,0,0,0,2.41-1.66c.53-.76.89-1.23,1.59-1.23s1.06.47,1.59,1.23A3,3,0,0,0,20,15.94,3,3,0,0,0,22.41,14.29Zm0,4c.53-.76.89-1.23,1.59-1.23v-1a3,3,0,0,0-2.41,1.66c-.53.76-.89,1.23-1.59,1.23s-1.06-.47-1.59-1.23A3,3,0,0,0,16,16.06a3,3,0,0,0-2.41,1.66c-.53.76-.89,1.23-1.59,1.23s-1.06-.47-1.59-1.23A3,3,0,0,0,8,16.06a3,3,0,0,0-2.41,1.66c-.53.76-.89,1.23-1.59,1.23s-1.06-.47-1.59-1.23A3,3,0,0,0,0,16.06v1c.7,0,1.06.47,1.59,1.23A3,3,0,0,0,4,19.94a3,3,0,0,0,2.41-1.66c.53-.76.89-1.23,1.59-1.23s1.06.47,1.59,1.23A3,3,0,0,0,12,19.94a3,3,0,0,0,2.41-1.66c.53-.76.89-1.23,1.59-1.23s1.06.47,1.59,1.23A3,3,0,0,0,20,19.94,3,3,0,0,0,22.41,18.29Zm0,4c.53-.76.89-1.23,1.59-1.23v-1a3,3,0,0,0-2.41,1.66c-.53.76-.89,1.23-1.59,1.23s-1.06-.47-1.59-1.23A3,3,0,0,0,16,20.06a3,3,0,0,0-2.41,1.66c-.53.76-.89,1.23-1.59,1.23s-1.06-.47-1.59-1.23A3,3,0,0,0,8,20.06a3,3,0,0,0-2.41,1.66c-.53.76-.89,1.23-1.59,1.23s-1.06-.47-1.59-1.23A3,3,0,0,0,0,20.06v1c.7,0,1.06.47,1.59,1.23A3,3,0,0,0,4,23.94a3,3,0,0,0,2.41-1.66c.53-.76.89-1.23,1.59-1.23s1.06.47,1.59,1.23A3,3,0,0,0,12,23.94a3,3,0,0,0,2.41-1.66c.53-.76.89-1.23,1.59-1.23s1.06.47,1.59,1.23A3,3,0,0,0,20,23.94,3,3,0,0,0,22.41,22.29Zm0-16c.53-.76.89-1.23,1.59-1.23v-1a3,3,0,0,0-2.41,1.66c-.53.76-.89,1.23-1.59,1.23s-1.06-.47-1.59-1.23A3,3,0,0,0,16,4.06a3,3,0,0,0-2.41,1.66c-.53.76-.89,1.23-1.59,1.23s-1.06-.47-1.59-1.23A3,3,0,0,0,8,4.06,3,3,0,0,0,5.59,5.71C5.06,6.47,4.7,6.94,4,6.94S2.94,6.47,2.41,5.71A3,3,0,0,0,0,4.06v1c.7,0,1.06.47,1.59,1.23A3,3,0,0,0,4,7.94,3,3,0,0,0,6.41,6.29c.53-.76.89-1.23,1.59-1.23s1.06.47,1.59,1.23A3,3,0,0,0,12,7.94,3,3,0,0,0,14.4,6.29c.53-.76.89-1.23,1.59-1.23s1.06.47,1.59,1.23A3,3,0,0,0,20,7.94,3,3,0,0,0,22.41,6.29Zm0-4c.53-.76.89-1.23,1.59-1.23v-1a3,3,0,0,0-2.41,1.66c-.53.76-.89,1.23-1.59,1.23s-1.06-.47-1.59-1.23A3,3,0,0,0,16,.06a3,3,0,0,0-2.41,1.66c-.53.76-.89,1.23-1.59,1.23s-1.06-.47-1.59-1.23A3,3,0,0,0,8,.06,3,3,0,0,0,5.59,1.71C5.06,2.47,4.7,2.94,4,2.94S2.94,2.47,2.41,1.71A3,3,0,0,0,0,.06v1c.7,0,1.06.47,1.59,1.23A3,3,0,0,0,4,3.94,3,3,0,0,0,6.41,2.29c.53-.76.89-1.23,1.59-1.23s1.06.47,1.59,1.23A3,3,0,0,0,12,3.94,3,3,0,0,0,14.4,2.29c.53-.76.89-1.23,1.59-1.23s1.06.47,1.59,1.23A3,3,0,0,0,20,3.94,3,3,0,0,0,22.41,2.29Z", fill: "black" }));
const kce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0H24V24H0Z", fill: "none" }), tp.createElement("path", { d: "M15,17.95l-.07-.08A2.26,2.26,0,0,0,13,17a2.32,2.32,0,0,0-1.9,1.2c-.38.51-.62.8-1.1.8a1.28,1.28,0,0,1-1.18-.52A1.08,1.08,0,0,0,8,18v1.05l.07.08A2.26,2.26,0,0,0,10,20a2.32,2.32,0,0,0,1.9-1.2c.38-.51.62-.8,1.1-.8a1.28,1.28,0,0,1,1.18.52A1.08,1.08,0,0,0,15,19Z", fill: "black" }), tp.createElement("path", { d: "M23,17.95l-.07-.08A2.26,2.26,0,0,0,21,17a2.32,2.32,0,0,0-1.9,1.2c-.38.51-.62.8-1.1.8a1.28,1.28,0,0,1-1.18-.52A1.08,1.08,0,0,0,16,18v1.05l.07.08A2.26,2.26,0,0,0,18,20a2.32,2.32,0,0,0,1.9-1.2c.38-.51.62-.8,1.1-.8a1.28,1.28,0,0,1,1.18.52A1.08,1.08,0,0,0,23,19Z", fill: "black" }), tp.createElement("path", { d: "M7,17.95l-.07-.08A2.26,2.26,0,0,0,5,17a2.32,2.32,0,0,0-1.9,1.2c-.38.51-.62.8-1.1.8a1.28,1.28,0,0,1-1.18-.52A1.08,1.08,0,0,0,0,18v1.05l.07.08A2.26,2.26,0,0,0,2,20a2.32,2.32,0,0,0,1.9-1.2c.38-.51.62-.8,1.1-.8a1.28,1.28,0,0,1,1.18.52A1.08,1.08,0,0,0,7,19Z", fill: "black" }), tp.createElement("path", { d: "M15,13.95l-.07-.08A2.26,2.26,0,0,0,13,13a2.32,2.32,0,0,0-1.9,1.2c-.38.51-.62.8-1.1.8a1.28,1.28,0,0,1-1.18-.52A1.08,1.08,0,0,0,8,14v1.05l.07.08A2.26,2.26,0,0,0,10,16a2.32,2.32,0,0,0,1.9-1.2c.38-.51.62-.8,1.1-.8a1.28,1.28,0,0,1,1.18.52A1.08,1.08,0,0,0,15,15Z", fill: "black" }), tp.createElement("path", { d: "M23,13.95l-.07-.08A2.26,2.26,0,0,0,21,13a2.32,2.32,0,0,0-1.9,1.2c-.38.51-.62.8-1.1.8a1.28,1.28,0,0,1-1.18-.52A1.08,1.08,0,0,0,16,14v1.05l.07.08A2.26,2.26,0,0,0,18,16a2.32,2.32,0,0,0,1.9-1.2c.38-.51.62-.8,1.1-.8a1.28,1.28,0,0,1,1.18.52A1.08,1.08,0,0,0,23,15Z", fill: "black" }), tp.createElement("path", { d: "M7,13.95l-.07-.08A2.26,2.26,0,0,0,5,13a2.32,2.32,0,0,0-1.9,1.2c-.38.51-.62.8-1.1.8a1.28,1.28,0,0,1-1.18-.52A1.08,1.08,0,0,0,0,14v1.05l.07.08A2.26,2.26,0,0,0,2,16a2.32,2.32,0,0,0,1.9-1.2c.38-.51.62-.8,1.1-.8a1.28,1.28,0,0,1,1.18.52A1.08,1.08,0,0,0,7,15Z", fill: "black" }), tp.createElement("path", { d: "M15,21.95l-.07-.08A2.26,2.26,0,0,0,13,21a2.32,2.32,0,0,0-1.9,1.2c-.38.51-.62.8-1.1.8a1.28,1.28,0,0,1-1.18-.52A1.08,1.08,0,0,0,8,22v1.05l.07.08A2.26,2.26,0,0,0,10,24a2.32,2.32,0,0,0,1.9-1.2c.38-.51.62-.8,1.1-.8a1.28,1.28,0,0,1,1.18.52A1.08,1.08,0,0,0,15,23Z", fill: "black" }), tp.createElement("path", { d: "M23,21.95l-.07-.08A2.26,2.26,0,0,0,21,21a2.32,2.32,0,0,0-1.9,1.2c-.38.51-.62.8-1.1.8a1.28,1.28,0,0,1-1.18-.52A1.08,1.08,0,0,0,16,22v1.05l.07.08A2.26,2.26,0,0,0,18,24a2.32,2.32,0,0,0,1.9-1.2c.38-.51.62-.8,1.1-.8a1.28,1.28,0,0,1,1.18.52A1.08,1.08,0,0,0,23,23Z", fill: "black" }), tp.createElement("path", { d: "M7,21.95l-.07-.08A2.26,2.26,0,0,0,5,21a2.32,2.32,0,0,0-1.9,1.2c-.38.51-.62.8-1.1.8a1.28,1.28,0,0,1-1.18-.52A1.08,1.08,0,0,0,0,22v1.05l.07.08A2.26,2.26,0,0,0,2,24a2.32,2.32,0,0,0,1.9-1.2c.38-.51.62-.8,1.1-.8a1.28,1.28,0,0,1,1.18.52A1.08,1.08,0,0,0,7,23Z", fill: "black" }), tp.createElement("path", { d: "M15,9.95l-.07-.08A2.26,2.26,0,0,0,13,9a2.32,2.32,0,0,0-1.9,1.2c-.38.51-.62.8-1.1.8a1.28,1.28,0,0,1-1.18-.52A1.08,1.08,0,0,0,8,10v1.05l.07.08A2.26,2.26,0,0,0,10,12a2.32,2.32,0,0,0,1.9-1.2c.38-.51.62-.8,1.1-.8a1.28,1.28,0,0,1,1.18.52A1.08,1.08,0,0,0,15,11Z", fill: "black" }), tp.createElement("path", { d: "M23,9.95l-.07-.08A2.26,2.26,0,0,0,21,9a2.32,2.32,0,0,0-1.9,1.2c-.38.51-.62.8-1.1.8a1.28,1.28,0,0,1-1.18-.52A1.08,1.08,0,0,0,16,10v1.05l.07.08A2.26,2.26,0,0,0,18,12a2.32,2.32,0,0,0,1.9-1.2c.38-.51.62-.8,1.1-.8a1.28,1.28,0,0,1,1.18.52A1.08,1.08,0,0,0,23,11Z", fill: "black" }), tp.createElement("path", { d: "M7,9.95l-.07-.08A2.26,2.26,0,0,0,5,9a2.32,2.32,0,0,0-1.9,1.2c-.38.51-.62.8-1.1.8a1.28,1.28,0,0,1-1.18-.52A1.08,1.08,0,0,0,0,10v1.05l.07.08A2.26,2.26,0,0,0,2,12a2.32,2.32,0,0,0,1.9-1.2c.38-.51.62-.8,1.1-.8a1.28,1.28,0,0,1,1.18.52A1.08,1.08,0,0,0,7,11Z", fill: "black" }), tp.createElement("path", { d: "M15,5.95l-.07-.08A2.26,2.26,0,0,0,13,5a2.32,2.32,0,0,0-1.9,1.2c-.38.51-.62.8-1.1.8a1.28,1.28,0,0,1-1.18-.52A1.08,1.08,0,0,0,8,6V7.05l.07.08A2.26,2.26,0,0,0,10,8a2.32,2.32,0,0,0,1.9-1.2c.38-.51.62-.8,1.1-.8a1.28,1.28,0,0,1,1.18.52A1.08,1.08,0,0,0,15,7Z", fill: "black" }), tp.createElement("path", { d: "M23,5.95l-.07-.08A2.26,2.26,0,0,0,21,5a2.32,2.32,0,0,0-1.9,1.2c-.38.51-.62.8-1.1.8a1.28,1.28,0,0,1-1.18-.52A1.08,1.08,0,0,0,16,6V7.05l.07.08A2.26,2.26,0,0,0,18,8a2.32,2.32,0,0,0,1.9-1.2c.38-.51.62-.8,1.1-.8a1.28,1.28,0,0,1,1.18.52A1.08,1.08,0,0,0,23,7Z", fill: "black" }), tp.createElement("path", { d: "M7,5.95l-.07-.08A2.26,2.26,0,0,0,5,5,2.32,2.32,0,0,0,3.1,6.2c-.38.51-.62.8-1.1.8A1.28,1.28,0,0,1,.82,6.48,1.08,1.08,0,0,0,0,6V7.05l.07.08A2.26,2.26,0,0,0,2,8,2.32,2.32,0,0,0,3.9,6.8C4.28,6.29,4.52,6,5,6a1.28,1.28,0,0,1,1.18.52A1.08,1.08,0,0,0,7,7Z", fill: "black" }), tp.createElement("path", { d: "M15,1.95l-.07-.08A2.26,2.26,0,0,0,13,1a2.32,2.32,0,0,0-1.9,1.2c-.38.51-.62.8-1.1.8a1.28,1.28,0,0,1-1.18-.52A1.08,1.08,0,0,0,8,2V3.05l.07.08A2.26,2.26,0,0,0,10,4a2.32,2.32,0,0,0,1.9-1.2c.38-.51.62-.8,1.1-.8a1.28,1.28,0,0,1,1.18.52A1.08,1.08,0,0,0,15,3Z", fill: "black" }), tp.createElement("path", { d: "M23,1.95l-.07-.08A2.26,2.26,0,0,0,21,1a2.32,2.32,0,0,0-1.9,1.2c-.38.51-.62.8-1.1.8a1.28,1.28,0,0,1-1.18-.52A1.08,1.08,0,0,0,16,2V3.05l.07.08A2.26,2.26,0,0,0,18,4a2.32,2.32,0,0,0,1.9-1.2c.38-.51.62-.8,1.1-.8a1.28,1.28,0,0,1,1.18.52A1.08,1.08,0,0,0,23,3Z", fill: "black" }), tp.createElement("path", { d: "M7,1.95l-.07-.08A2.26,2.26,0,0,0,5,1,2.32,2.32,0,0,0,3.1,2.2c-.38.51-.62.8-1.1.8A1.28,1.28,0,0,1,.82,2.48,1.08,1.08,0,0,0,0,2V3.05l.07.08A2.26,2.26,0,0,0,2,4,2.32,2.32,0,0,0,3.9,2.8C4.28,2.29,4.52,2,5,2a1.28,1.28,0,0,1,1.18.52A1.08,1.08,0,0,0,7,3Z", fill: "black" }));
const Pce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", fill: "none" }), tp.createElement("rect", { x: "12.84", y: "7.67", width: "10.31", height: "4.66", transform: "translate(-1.8 15.66) rotate(-45)", fill: "none" }), tp.createElement("rect", { x: "12.84", y: "15.67", width: "10.31", height: "4.66", transform: "translate(-7.46 18) rotate(-45)", fill: "none" }), tp.createElement("rect", { x: "4.84", y: "15.67", width: "10.31", height: "4.66", transform: "translate(-9.8 12.34) rotate(-45)", fill: "none" }), tp.createElement("rect", { x: "4.84", y: "7.67", width: "10.31", height: "4.66", transform: "translate(-4.14 10) rotate(-45)", fill: "none" }), tp.createElement("path", { d: "M24,0h-.71L16,7.29,12.71,4l4-4H15.29L8,7.29,4.71,4l4-4H7.29L0,7.29V8.71l4-4L7.29,8,0,15.29v1.41l4-4L7.29,16,0,23.29V24H.71L4,20.71,7.29,24H8.71L12,20.71,15.29,24h1.41L20,20.71,23.29,24H24v-.71L20.71,20,24,16.71V15.29L20.71,12,24,8.71V7.29L20.71,4,24,.71ZM4.71,12,12,4.71,15.29,8,8,15.29ZM8,23.29,4.71,20,12,12.71,15.29,16ZM23.29,16,16,23.29,12.71,20,20,12.71Zm0-8L16,15.29,12.71,12,20,4.71Z", fill: "black" }), tp.createElement("polygon", { points: "0 0 0 0.71 0.71 0 0 0", fill: "black" }));
const Nce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0H24V24H0Z", fill: "none" }), tp.createElement("path", { d: "M24,1V0H0V5H4V8H0v5H4v3H0v5H4v3H5V21h7v3h1V21h7v3h1V21h3V20H17V17h7V16H21V13h3V12H17V9h7V8H21V5h3V4H17V1ZM1,4V1H8V4H1ZM5,5h7V8H5ZM1,12V9H8v3H1Zm4,1h7v3H5Zm0,7H1V17H8v3Zm11,0H9V17h7Zm4-7v3H13V13h7Zm-4-1H9V9h7Zm4-7V8H13V5h7ZM16,4H9V1h7Z", fill: "black" }));
const Dce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0H24V24H0Z", fill: "none" }), tp.createElement("polygon", { points: "23.29 0 23.79 0.5 24 0.71 24 0 23.29 0", fill: "black" }), tp.createElement("path", { d: "M22.5,1.79,21.21.5l-.5-.5H19.29l.5.5L18.5,1.79,17.21.5l.5-.5H15.29l.5.5.71.71L17.79,2.5,16.5,3.79,15.21,2.5l-.71-.71L13.21.5l-.5-.5H11.29l.5.5L10.5,1.79,9.21.5l.5-.5H7.29l.5.5.71.71L9.79,2.5,8.5,3.79,7.21,2.5,6.5,1.79,5.21.5,4.71,0H3.29l.5.5L2.5,1.79,1.21.5l.5-.5H0V.71l.5.5L1.79,2.5.5,3.79,0,3.29V4.71l.5.5.71-.71L2.5,3.21l.71-.71L4.5,1.21,5.79,2.5,4.5,3.79l-.71.71L2.5,5.79l-.71.71L.5,7.79,0,7.29V8.71l.5.5L1.79,10.5.5,11.79l-.5-.5v1.41l.5.5.71-.71L2.5,11.21l.71-.71L4.5,9.21,5.79,10.5,4.5,11.79l-.71.71L2.5,13.79l-.71.71L.5,15.79l-.5-.5v1.41l.5.5L1.79,18.5.5,19.79l-.5-.5v1.41l.5.5.71-.71L2.5,19.21l.71-.71L4.5,17.21,5.79,18.5,4.5,19.79l-.71.71L2.5,21.79l-.71.71L.5,23.79l-.5-.5V24H1.71l.79-.79.79.79H4.71l-.21-.21L3.21,22.5,4.5,21.21,7.29,24H9.71l.79-.79.79.79h1.41l-.21-.21L11.21,22.5l1.29-1.29L15.29,24h2.41l.79-.79.79.79h1.41l-.21-.21L19.21,22.5l1.29-1.29L23.29,24H24v-.71L21.21,20.5l1.29-1.29,1.29,1.29.21.21V19.29l-.79-.79-.71-.71L21.21,16.5l-.71-.71L19.21,14.5l1.29-1.29,3.29,3.29.21.21V15.29L21.21,12.5l1.29-1.29,1.29,1.29.21.21V11.29l-.79-.79-.71-.71L21.21,8.5l-.71-.71L19.21,6.5,20.5,5.21,23.79,8.5l.21.21V7.29L21.21,4.5,22.5,3.21,23.79,4.5l.21.21V3.29l-.79-.79ZM6.5,3.21,7.79,4.5l.71.71.71-.71L10.5,3.21l.71-.71L12.5,1.21,13.79,2.5,12.5,3.79l-.71.71L10.5,5.79l-.71.71L8.5,7.79,5.21,4.5Zm8,6.59L13.21,8.5l-.71-.71L11.21,6.5,12.5,5.21,15.79,8.5l.71.71,1.29,1.29L16.5,11.79,15.21,10.5ZM11.79,8.5,10.5,9.79,9.21,8.5,10.5,7.21ZM2.5,9.79,1.21,8.5,2.5,7.21,3.79,8.5ZM5.21,8.5,4.5,7.79,3.21,6.5,4.5,5.21,7.79,8.5l.71.71L9.79,10.5,8.5,11.79,7.21,10.5,6.5,9.79ZM6.5,11.21,7.79,12.5l.71.71.71-.71,1.29-1.29.71-.71L12.5,9.21l1.29,1.29L12.5,11.79l-.71.71L10.5,13.79l-.71.71L8.5,15.79,5.21,12.5Zm8,6.59L13.21,16.5l-.71-.71L11.21,14.5l1.29-1.29,3.29,3.29.71.71,1.29,1.29L16.5,19.79,15.21,18.5ZM11.79,16.5,10.5,17.79,9.21,16.5l1.29-1.29ZM2.5,17.79,1.21,16.5,2.5,15.21,3.79,16.5ZM5.21,16.5l-.71-.71L3.21,14.5,4.5,13.21,7.79,16.5l.71.71L9.79,18.5,8.5,19.79,7.21,18.5l-.71-.71Zm6.59,4L10.5,21.79l-.71.71L8.5,23.79,5.21,20.5,6.5,19.21,7.79,20.5l.71.71.71-.71,1.29-1.29.71-.71,1.29-1.29,1.29,1.29L12.5,19.79Zm10-2L20.5,19.79l-.71.71L18.5,21.79l-.71.71L16.5,23.79,13.21,20.5l1.29-1.29,1.29,1.29.71.71.71-.71,1.29-1.29.71-.71,1.29-1.29Zm-2-2L18.5,17.79,17.21,16.5l1.29-1.29Zm2-6L20.5,11.79l-.71.71L18.5,13.79l-.71.71L16.5,15.79,13.21,12.5l1.29-1.29,1.29,1.29.71.71.71-.71,1.29-1.29.71-.71L20.5,9.21Zm-2-2L18.5,9.79,17.21,8.5,18.5,7.21Zm.71-4.71-.71.71L18.5,5.79l-.71.71L16.5,7.79,13.21,4.5,14.5,3.21,15.79,4.5l.71.71.71-.71L18.5,3.21l.71-.71L20.5,1.21,21.79,2.5Z", fill: "black" }));
const Lce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0H24V24H0Z", fill: "none" }), tp.createElement("polygon", { points: "2 8 2 9 3 9 3 8 4 8 4 4 4 3 3 3 3 4 2 4 2 3 1 3 1 4 0 4 0 8 0 9 1 9 1 8 2 8", fill: "black" }), tp.createElement("polygon", { points: "2 16 2 17 3 17 3 16 4 16 4 12 4 11 3 11 3 12 2 12 2 11 1 11 1 12 0 12 0 16 0 17 1 17 1 16 2 16", fill: "black" }), tp.createElement("rect", { x: "1", y: "9", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "2", y: "10", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "3", y: "9", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { y: "10", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "5", y: "9", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "5", y: "11", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "6", y: "10", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "6", y: "8", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "7", y: "11", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "7", y: "9", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "4", y: "10", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "4", y: "8", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "9", y: "9", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "10", y: "10", width: "1", height: "1", fill: "black" }), tp.createElement("polygon", { points: "11 12 10 12 10 11 9 11 9 12 8 12 8 16 8 17 9 17 9 16 10 16 10 17 11 17 11 16 12 16 12 12 12 11 11 11 11 12", fill: "black" }), tp.createElement("rect", { x: "11", y: "9", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "8", y: "10", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "13", y: "9", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "13", y: "11", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "14", y: "10", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "14", y: "8", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "15", y: "11", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "15", y: "9", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "12", y: "10", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "12", y: "8", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "17", y: "9", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "18", y: "10", width: "1", height: "1", fill: "black" }), tp.createElement("polygon", { points: "19 12 18 12 18 11 17 11 17 12 16 12 16 16 16 17 17 17 17 16 18 16 18 17 19 17 19 16 20 16 20 12 20 11 19 11 19 12", fill: "black" }), tp.createElement("rect", { x: "19", y: "9", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "16", y: "10", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "21", y: "9", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "21", y: "11", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "22", y: "10", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "22", y: "8", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "23", y: "11", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "23", y: "9", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "20", y: "10", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "20", y: "8", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "1", y: "17", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "2", y: "18", width: "1", height: "1", fill: "black" }), tp.createElement("polygon", { points: "3 20 2 20 2 19 1 19 1 20 0 20 0 24 4 24 4 20 4 19 3 19 3 20", fill: "black" }), tp.createElement("rect", { x: "3", y: "17", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { y: "18", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "5", y: "17", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "5", y: "19", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "6", y: "18", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "6", y: "16", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "7", y: "19", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "7", y: "17", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "4", y: "18", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "4", y: "16", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "9", y: "17", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "10", y: "18", width: "1", height: "1", fill: "black" }), tp.createElement("polygon", { points: "11 20 10 20 10 19 9 19 9 20 8 20 8 24 12 24 12 20 12 19 11 19 11 20", fill: "black" }), tp.createElement("rect", { x: "11", y: "17", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "8", y: "18", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "13", y: "17", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "13", y: "19", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "14", y: "18", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "14", y: "16", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "15", y: "19", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "15", y: "17", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "12", y: "18", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "12", y: "16", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "17", y: "17", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "18", y: "18", width: "1", height: "1", fill: "black" }), tp.createElement("polygon", { points: "19 20 18 20 18 19 17 19 17 20 16 20 16 24 20 24 20 20 20 19 19 19 19 20", fill: "black" }), tp.createElement("rect", { x: "19", y: "17", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "16", y: "18", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "21", y: "17", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "21", y: "19", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "22", y: "18", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "22", y: "16", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "23", y: "19", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "23", y: "17", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "20", y: "18", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "20", y: "16", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "1", y: "1", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "2", y: "2", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "2", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "3", y: "1", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { y: "2", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "5", y: "1", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "5", y: "3", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "6", y: "2", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "6", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "7", y: "3", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "7", y: "1", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "4", y: "2", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "4", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "9", y: "1", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "10", y: "2", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "10", width: "1", height: "1", fill: "black" }), tp.createElement("polygon", { points: "11 4 10 4 10 3 9 3 9 4 8 4 8 8 8 9 9 9 9 8 10 8 10 9 11 9 11 8 12 8 12 4 12 3 11 3 11 4", fill: "black" }), tp.createElement("rect", { x: "11", y: "1", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "8", y: "2", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "8", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "13", y: "1", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "13", y: "3", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "14", y: "2", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "14", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "15", y: "3", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "15", y: "1", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "12", y: "2", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "12", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "17", y: "1", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "18", y: "2", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "18", width: "1", height: "1", fill: "black" }), tp.createElement("polygon", { points: "19 4 18 4 18 3 17 3 17 4 16 4 16 8 16 9 17 9 17 8 18 8 18 9 19 9 19 8 20 8 20 4 20 3 19 3 19 4", fill: "black" }), tp.createElement("rect", { x: "19", y: "1", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "16", y: "2", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "16", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "21", y: "1", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "21", y: "3", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "22", y: "2", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "22", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "23", y: "3", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "23", y: "1", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "20", y: "2", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "20", width: "1", height: "1", fill: "black" }));
const Hce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0H24V24H0Z", fill: "none" }), tp.createElement("path", { d: "M6.29,16.79,7,17.5l-.71.71L5.5,19H4.09l1.5-1.5L4.09,16H5.5ZM13.5,16H12.09l1.5,1.5L12.09,19H13.5l.79-.79L15,17.5l-.71-.71Zm8,0H20.09l1.5,1.5L20.09,19H21.5l.79-.79L23,17.5l-.71-.71ZM5.5,8H4.09l1.5,1.5L4.09,11H5.5l.79-.79L7,9.5l-.71-.71Zm8,0H12.09l1.5,1.5L12.09,11H13.5l.79-.79L15,9.5l-.71-.71Zm8,0H20.09l1.5,1.5L20.09,11H21.5l.79-.79L23,9.5l-.71-.71ZM5.5,0H4.09l1.5,1.5L4.09,3H5.5l.79-.79L7,1.5,6.29.79Zm8,0H12.09l1.5,1.5L12.09,3H13.5l.79-.79L15,1.5,14.29.79Zm8,0H20.09l1.5,1.5L20.09,3H21.5l.79-.79L23,1.5,22.29.79ZM17.59,15H19l-1.5-1.5L19,12H17.59l-.79.79-.71.71.71.71Zm-8,0H11L9.5,13.5,11,12H9.59l-.79.79-.71.71.71.71Zm-8,0H3L1.5,13.5,3,12H1.59l-.79.79-.71.71.71.71Zm16,8H19l-1.5-1.5L19,20H17.59l-.79.79-.71.71.71.71Zm-8,0H11L9.5,21.5,11,20H9.59l-.79.79-.71.71.71.71Zm-8,0H3L1.5,21.5,3,20H1.59l-.79.79-.71.71.71.71Zm16-16H19L17.5,5.5,19,4H17.59l-.79.79-.71.71.71.71Zm-8,0H11L9.5,5.5,11,4H9.59l-.79.79-.71.71.71.71Zm-8,0H3L1.5,5.5,3,4H1.59l-.79.79L.09,5.5l.71.71Z", fill: "black" }));
const Ice = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("rect", { width: "24", height: "24", fill: "none" }), tp.createElement("path", { d: "M9,3H8V2H9ZM9,4H8V5H9ZM9,6H8V7H9ZM9,0H8V1H9Zm8,2H16V3h1Zm0,2H16V5h1Zm0,2H16V7h1Zm0-6H16V1h1ZM9,18H8v1H9Zm0,2H8v1H9Zm0,2H8v1H9Zm0-6H8v1H9Zm8,2H16v1h1Zm0,2H16v1h1Zm0,2H16v1h1Zm0-6H16v1h1ZM9,10H8v1H9Zm0,2H8v1H9Zm0,2H8v1H9ZM9,8H8V9H9Zm8,2H16v1h1Zm0,2H16v1h1Zm0,2H16v1h1Zm0-6H16V9h1ZM7,16H6v1H7ZM7,8H6V9H7ZM5,16H4v1H5ZM5,8H4V9H5ZM3,16H2v1H3ZM3,8H2V9H3ZM1,16H0v1H1ZM1,8H0V9H1Zm10,8H10v1h1Zm0-8H10V9h1Zm2,8H12v1h1Zm0-8H12V9h1Zm2,8H14v1h1Zm0-8H14V9h1Zm4,8H18v1h1Zm0-8H18V9h1Zm2,8H20v1h1Zm0-8H20V9h1Zm2,8H22v1h1Zm0-8H22V9h1ZM1,2H0V3H1ZM1,4H0V5H1ZM1,6H0V7H1ZM1,0H0V1H1ZM1,18H0v1H1Zm0,2H0v1H1Zm0,2H0v1H1ZM1,10H0v1H1Zm0,2H0v1H1Zm0,2H0v1H1ZM7,0H6V1H7ZM5,0H4V1H5ZM3,0H2V1H3Zm8,0H10V1h1Zm2,0H12V1h1Zm2,0H14V1h1Zm4,0H18V1h1Zm2,0H20V1h1Zm2,0H22V1h1Z", fill: "black" }));
const _ce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("rect", { width: "24", height: "24", fill: "none" }), tp.createElement("path", { d: "M9,9H8V8H9Zm8-1H16V9h1ZM1,8H0V9H1ZM7,2H6V3H7ZM5,4H4V5H5ZM3,2H2V3H3Zm8,0H10V3h1Zm2,2H12V5h1Zm2-2H14V3h1Zm4,0H18V3h1Zm2,2H20V5h1Zm2-2H22V3h1ZM7,6H6V7H7ZM3,6H2V7H3Zm8,0H10V7h1Zm4,0H14V7h1Zm4,0H18V7h1Zm4,0H22V7h1ZM9,16H8v1H9Zm8,0H16v1h1ZM1,16H0v1H1Zm6-6H6v1H7ZM5,12H4v1H5ZM3,10H2v1H3Zm8,0H10v1h1Zm2,2H12v1h1Zm2-2H14v1h1Zm4,0H18v1h1Zm2,2H20v1h1Zm2-2H22v1h1ZM7,14H6v1H7ZM3,14H2v1H3Zm8,0H10v1h1Zm4,0H14v1h1Zm4,0H18v1h1Zm4,0H22v1h1ZM7,18H6v1H7ZM5,20H4v1H5ZM3,18H2v1H3Zm8,0H10v1h1Zm2,2H12v1h1Zm2-2H14v1h1Zm4,0H18v1h1Zm2,2H20v1h1Zm2-2H22v1h1ZM7,22H6v1H7ZM3,22H2v1H3Zm8,0H10v1h1Zm4,0H14v1h1Zm4,0H18v1h1Zm4,0H22v1h1ZM9,0H8V1H9Zm8,0H16V1h1ZM1,0H0V1H1Z", fill: "black" }));
const Vce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("rect", { width: "24", height: "24", fill: "none" }), tp.createElement("path", { d: "M0,23.7c0,.16.06.3.13.3s.08-.09,0-.2S0,23.54,0,23.7Z", fill: "black" }), tp.createElement("path", { d: "M23.17,0h-.6l-.09.08L22,.44l-.43.34L21.34,1,21.27,1l0,0-.08.08-.5.5a5.91,5.91,0,0,1-1,.74A2.24,2.24,0,0,1,19,2.5a3,3,0,0,1-1.65-.85,4.82,4.82,0,0,1-.56-.7l0-.08,0,0A8.31,8.31,0,0,1,16.25,0H14.57l-.09.08L14,.44l-.43.34L13.34,1,13.27,1l0,0-.08.08-.5.5a5.91,5.91,0,0,1-1,.74A2.24,2.24,0,0,1,11,2.5a3,3,0,0,1-1.65-.85A4.82,4.82,0,0,1,8.8.94l0-.08L8.64.69C8.5.47,8.37.23,8.25,0H6.57L6.47.08,6,.44,5.56.78,5.34,1,5.27,1l0,0-.08.08-.5.5a5.91,5.91,0,0,1-1,.74A2.24,2.24,0,0,1,3,2.5a3,3,0,0,1-1.65-.85A4.82,4.82,0,0,1,.8.94l0-.08C.66.71.57.57.49.44S.33.15.25,0H0V1.71l.65.65A9.91,9.91,0,0,0,2.78,3.95l.37.18c.2.1,2.83,1.55,3,1.72A1.25,1.25,0,0,1,6.28,6a4.61,4.61,0,0,1,.24.45,2.25,2.25,0,0,1,.17,1.39.9.9,0,0,1-.21.22L6,8.44l-.43.34L5.34,9,5.27,9l0,0-.08.08-.5.5a5.91,5.91,0,0,1-1,.74A2.24,2.24,0,0,1,3,10.5a3,3,0,0,1-1.65-.85A4,4,0,0,1,1,9.27a7.39,7.39,0,0,1-.6-1A1.13,1.13,0,0,0,.27,8,5.75,5.75,0,0,1,0,7.4v2.3l.65.65a9.91,9.91,0,0,0,2.13,1.59l.37.18c.2.1,2.83,1.55,3,1.72a1.25,1.25,0,0,1,.13.18,4.61,4.61,0,0,1,.24.45,2.25,2.25,0,0,1,.17,1.39.9.9,0,0,1-.21.22L6,16.44l-.43.34L5.34,17,5.27,17l0,0-.08.08-.5.5a5.91,5.91,0,0,1-1,.74A2.24,2.24,0,0,1,3,18.5a3,3,0,0,1-1.65-.85A4,4,0,0,1,1,17.27a7.39,7.39,0,0,1-.6-1,2.78,2.78,0,0,0-.23-.39c-.08-.18-.16-.35-.22-.51v2.3l.65.65a9.91,9.91,0,0,0,2.13,1.59l.37.18c.2.1,2.83,1.55,3,1.72a1.25,1.25,0,0,1,.13.18,4.61,4.61,0,0,1,.24.45,2.48,2.48,0,0,1,.31,1.14h0a1.39,1.39,0,0,1-.25.38H8.25A5.44,5.44,0,0,1,8,23.34H8a1.06,1.06,0,0,1,0-.23V23a2.48,2.48,0,0,0-1-1.92l-.37-.23-.07,0-.24-.14c-.37-.22-.78-.44-1.12-.61l-.43-.21h0c-.24-.12-.4-.31-.36-.42a3.27,3.27,0,0,1,.38-.52l0,0h0l.49-.49.5-.5,0,0,.44-.39.3-.22L6.93,17a1.73,1.73,0,0,1,1,.59l.73.73a9.91,9.91,0,0,0,2.13,1.59l.37.18c.2.1,2.83,1.55,3,1.72a1.25,1.25,0,0,1,.13.18,4.61,4.61,0,0,1,.24.45,2.48,2.48,0,0,1,.31,1.14h0a1.39,1.39,0,0,1-.25.38h1.69a5.44,5.44,0,0,1-.28-.66h0a1.06,1.06,0,0,1,0-.23V23a2.48,2.48,0,0,0-1-1.92l-.37-.23-.07,0-.24-.14c-.37-.22-.78-.44-1.12-.61l-.43-.21h0c-.24-.12-.4-.31-.36-.42a3.27,3.27,0,0,1,.38-.52l0,0h0l.49-.49.5-.5,0,0,.44-.39.3-.22.29-.17a1.73,1.73,0,0,1,1,.59l.73.73a9.91,9.91,0,0,0,2.13,1.59l.37.18c.2.1,2.83,1.55,3,1.72a1.25,1.25,0,0,1,.13.18,4.61,4.61,0,0,1,.24.45,2.48,2.48,0,0,1,.31,1.14h0a1.39,1.39,0,0,1-.25.38H24v-.6l0-.06h0a1.06,1.06,0,0,1,0-.23V23a2.48,2.48,0,0,0-1-1.92l-.37-.23-.07,0-.24-.14c-.37-.22-.78-.44-1.12-.61l-.43-.21h0c-.24-.12-.4-.31-.36-.42a3.27,3.27,0,0,1,.38-.52l0,0h0l.49-.49.5-.5,0,0,.44-.39.3-.22.3-.17a.88.88,0,0,1,.67.29l.39.39V15.4l0-.06h0a1.06,1.06,0,0,1,0-.23V15a2.48,2.48,0,0,0-1-1.92l-.37-.23-.07,0-.24-.14c-.37-.22-.78-.44-1.12-.61l-.43-.21h0c-.24-.12-.4-.31-.36-.42a3.27,3.27,0,0,1,.38-.52l0,0h0l.49-.49.5-.5,0,0,.44-.39.3-.22.3-.17a.88.88,0,0,1,.67.29l.39.39V7.4l0-.06h0a1.06,1.06,0,0,1,0-.23V7a2.48,2.48,0,0,0-1-1.92l-.37-.23-.07,0-.24-.14c-.37-.22-.78-.44-1.12-.61l-.43-.21h0c-.24-.12-.4-.31-.36-.42a3.27,3.27,0,0,1,.38-.52l0,0h0l.49-.49.5-.5,0,0,.44-.39.3-.22.3-.17a.88.88,0,0,1,.67.29l.39.39V0ZM5.85,1.85l0,0,.44-.39.3-.22L6.93,1a1.73,1.73,0,0,1,1,.59l.73.73a9.91,9.91,0,0,0,2.13,1.59l.37.18c.2.1,2.83,1.55,3,1.72a1.25,1.25,0,0,1,.13.18,4.61,4.61,0,0,1,.24.45,2.25,2.25,0,0,1,.17,1.39.9.9,0,0,1-.21.22L14,8.44l-.43.34L13.34,9,13.27,9l0,0-.08.08-.5.5a5.91,5.91,0,0,1-1,.74,2.24,2.24,0,0,1-.68.12,3,3,0,0,1-1.65-.85A7.07,7.07,0,0,1,8,7.34H8A1.06,1.06,0,0,1,8,7.1V7A2.48,2.48,0,0,0,7,5.08l-.37-.23-.07,0-.24-.14c-.37-.22-.78-.44-1.12-.61l-.43-.21h0c-.24-.12-.4-.31-.36-.42a3.27,3.27,0,0,1,.38-.52l0,0h0l.49-.49Zm7.7,14.93-.21.19-.07.06,0,0-.08.08-.5.5a5.91,5.91,0,0,1-1,.74,2.24,2.24,0,0,1-.68.12,3,3,0,0,1-1.65-.85A7.07,7.07,0,0,1,8,15.34H8a1.06,1.06,0,0,1,0-.23V15a2.48,2.48,0,0,0-1-1.92l-.37-.23-.07,0-.24-.14c-.37-.22-.78-.44-1.12-.61l-.43-.21h0c-.24-.12-.4-.31-.36-.42a3.27,3.27,0,0,1,.38-.52l0,0h0l.49-.49.5-.5,0,0,.44-.39.3-.22L6.93,9a1.73,1.73,0,0,1,1,.59l.73.73a9.91,9.91,0,0,0,2.13,1.59l.37.18c.2.1,2.83,1.55,3,1.72a1.25,1.25,0,0,1,.13.18,4.61,4.61,0,0,1,.24.45,2.25,2.25,0,0,1,.17,1.39.9.9,0,0,1-.21.22l-.49.35Zm8,0-.21.19-.07.06,0,0-.08.08-.5.5a5.91,5.91,0,0,1-1,.74,2.24,2.24,0,0,1-.68.12,3,3,0,0,1-1.65-.85A7.07,7.07,0,0,1,16,15.34h0a1.06,1.06,0,0,1,0-.23V15a2.48,2.48,0,0,0-1-1.92l-.37-.23-.07,0-.24-.14c-.37-.22-.78-.44-1.12-.61l-.43-.21h0c-.24-.12-.4-.31-.36-.42a3.27,3.27,0,0,1,.38-.52l0,0h0l.49-.49.5-.5,0,0,.44-.39.3-.22L14.93,9a1.73,1.73,0,0,1,1,.59l.73.73a9.91,9.91,0,0,0,2.13,1.59l.37.18c.2.1,2.83,1.55,3,1.72a1.25,1.25,0,0,1,.13.18,4.61,4.61,0,0,1,.24.45,2.25,2.25,0,0,1,.17,1.39.9.9,0,0,1-.21.22l-.49.35Zm0-8L21.34,9,21.27,9l0,0-.08.08-.5.5a5.91,5.91,0,0,1-1,.74,2.24,2.24,0,0,1-.68.12,3,3,0,0,1-1.65-.85A7.07,7.07,0,0,1,16,7.34h0a1.06,1.06,0,0,1,0-.23V7a2.48,2.48,0,0,0-1-1.92l-.37-.23-.07,0-.24-.14c-.37-.22-.78-.44-1.12-.61l-.43-.21h0c-.24-.12-.4-.31-.36-.42a3.27,3.27,0,0,1,.38-.52l0,0h0l.49-.49.5-.5,0,0,.44-.39.3-.22L14.93,1a1.73,1.73,0,0,1,1,.59l.73.73a9.91,9.91,0,0,0,2.13,1.59l.37.18c.2.1,2.83,1.55,3,1.72a1.25,1.25,0,0,1,.13.18,4.61,4.61,0,0,1,.24.45,2.25,2.25,0,0,1,.17,1.39.9.9,0,0,1-.21.22L22,8.44Z", fill: "black" }));
const Rce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", fill: "none" }), tp.createElement("path", { d: "M24,1V0H0V1H1V2H0V5H1V6H0V9H1v1H0v3H1v1H0v3H1v1H0v3H1v1H0v2H1V23H3v1H5V23H7v1H9V23h2v1h2V23h2v1h2V23h2v1h2V23h2v1h1V22H23V21h1V18H23V17h1V14H23V13h1V10H23V9h1V6H23V5h1V2H23V1ZM19,1h2V2H19ZM3,14V13H5v1Zm2,3v1H3V17ZM17,8V7h2V8Zm2,3v1H17V11ZM17,6H15V5h2Zm0,3v1H15V9ZM15,8H13V7h2Zm0,3v1H13V11ZM13,6H11V5h2Zm0,3v1H11V9ZM11,8H9V7h2Zm0,3v1H9V11ZM9,6H7V5H9ZM9,9v1H7V9ZM7,8H5V7H7Zm0,3v1H5V11ZM5,6H3V5H5ZM5,9v1H3V9Zm0,6H7v1H5Zm2,2H9v1H7Zm0-3V13H9v1Zm2,1h2v1H9Zm2,2h2v1H11Zm0-3V13h2v1Zm2,1h2v1H13Zm2,2h2v1H15Zm0-3V13h2v1Zm2,1h2v1H17Zm2,2h2v1H19Zm0-3V13h2v1Zm0-4V9h2v1Zm0-4V5h2V6Zm0-2H17V3h2ZM15,1h2V2H15Zm0,3H13V3h2ZM11,1h2V2H11Zm0,3H9V3h2ZM7,1H9V2H7ZM7,4H5V3H7ZM3,1H5V2H3ZM1,3H3V4H1ZM1,7H3V8H1Zm0,4H3v1H1Zm0,4H3v1H1Zm0,5V19H3v1Zm4,2H3V21H5Zm0-2V19H7v1Zm4,2H7V21H9Zm0-2V19h2v1Zm4,2H11V21h2Zm0-2V19h2v1Zm4,2H15V21h2Zm0-2V19h2v1Zm4,2H19V21h2Zm2-2H21V19h2Zm0-4H21V15h2Zm0-4H21V11h2Zm0-4H21V7h2Zm0-4H21V3h2Z", fill: "black" }));
const Ace = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("rect", { width: "24", height: "24", fill: "none" }), tp.createElement("path", { d: "M5,4.5A2.5,2.5,0,1,0,7.5,2,2.5,2.5,0,0,0,5,4.5ZM6.5,3h1a.5.5,0,0,1,0,1h-1a.5.5,0,0,1,0-1Z", fill: "black" }), tp.createElement("path", { d: "M2,4.5A2.5,2.5,0,0,0,0,2.05v4.9A2.5,2.5,0,0,0,2,4.5Z", fill: "black" }), tp.createElement("path", { d: "M19.5,3a2.5,2.5,0,0,0,2.45-3h-4.9A2.5,2.5,0,0,0,19.5,3Z", fill: "black" }), tp.createElement("path", { d: "M11.5,11A2.5,2.5,0,1,0,9,8.5,2.5,2.5,0,0,0,11.5,11Zm-1-4h1a.5.5,0,0,1,0,1h-1a.5.5,0,0,1,0-1Z", fill: "black" }), tp.createElement("path", { d: "M6,8.5A2.5,2.5,0,1,0,3.5,11,2.5,2.5,0,0,0,6,8.5ZM3.5,8h-1a.5.5,0,0,1,0-1h1a.5.5,0,0,1,0,1Z", fill: "black" }), tp.createElement("path", { d: "M18,12.5A2.5,2.5,0,1,0,15.5,15,2.5,2.5,0,0,0,18,12.5Zm-4-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,0,1h-1A.5.5,0,0,1,14,11.5Z", fill: "black" }), tp.createElement("path", { d: "M10,12.5A2.5,2.5,0,1,0,7.5,15,2.5,2.5,0,0,0,10,12.5Zm-4-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,0,1h-1A.5.5,0,0,1,6,11.5Z", fill: "black" }), tp.createElement("path", { d: "M2,12.5a2.5,2.5,0,0,0-2-2.45v4.9A2.5,2.5,0,0,0,2,12.5Z", fill: "black" }), tp.createElement("path", { d: "M22,8.5A2.5,2.5,0,1,0,19.5,11,2.5,2.5,0,0,0,22,8.5ZM19.5,8h-1a.5.5,0,0,1,0-1h1a.5.5,0,0,1,0,1Z", fill: "black" }), tp.createElement("path", { d: "M11.5,19A2.5,2.5,0,1,0,9,16.5,2.5,2.5,0,0,0,11.5,19Zm-1-4h1a.5.5,0,0,1,0,1h-1a.5.5,0,0,1,0-1Z", fill: "black" }), tp.createElement("path", { d: "M1,16.5A2.5,2.5,0,1,0,3.5,14,2.5,2.5,0,0,0,1,16.5ZM2.5,15h1a.5.5,0,0,1,0,1h-1a.5.5,0,0,1,0-1Z", fill: "black" }), tp.createElement("path", { d: "M18,20.5A2.5,2.5,0,1,0,15.5,23,2.5,2.5,0,0,0,18,20.5ZM15.5,20h-1a.5.5,0,0,1,0-1h1a.5.5,0,0,1,0,1Z", fill: "black" }), tp.createElement("path", { d: "M10,20.5A2.5,2.5,0,1,0,7.5,23,2.5,2.5,0,0,0,10,20.5ZM7.5,20h-1a.5.5,0,0,1,0-1h1a.5.5,0,0,1,0,1Z", fill: "black" }), tp.createElement("path", { d: "M2,20.5a2.5,2.5,0,0,0-2-2.45v4.9A2.5,2.5,0,0,0,2,20.5Z", fill: "black" }), tp.createElement("path", { d: "M19.5,19A2.5,2.5,0,1,0,17,16.5,2.5,2.5,0,0,0,19.5,19Zm-1-4h1a.5.5,0,0,1,0,1h-1a.5.5,0,0,1,0-1Z", fill: "black" }), tp.createElement("path", { d: "M11.5,3a2.5,2.5,0,0,0,2.45-3H9.05A2.5,2.5,0,0,0,11.5,3Z", fill: "black" }), tp.createElement("path", { d: "M3.5,3A2.5,2.5,0,0,0,5.95,0H1.05A2.5,2.5,0,0,0,3.5,3Z", fill: "black" }), tp.createElement("path", { d: "M13,4.5A2.5,2.5,0,1,0,15.5,2,2.5,2.5,0,0,0,13,4.5ZM14.5,3h1a.5.5,0,0,1,0,1h-1a.5.5,0,0,1,0-1Z", fill: "black" }), tp.createElement("path", { d: "M23.5,2A2.5,2.5,0,1,0,24,6.95V3.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1,0-1h1a.5.5,0,0,1,.5.5V2.05A2.51,2.51,0,0,0,23.5,2Z", fill: "black" }), tp.createElement("path", { d: "M21,12.5a2.5,2.5,0,0,0,3,2.45V11.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1,0-1h1a.5.5,0,0,1,.5.5V10.05a2.5,2.5,0,0,0-3,2.45Z", fill: "black" }), tp.createElement("path", { d: "M21,20.5a2.5,2.5,0,0,0,3,2.45V19.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1,0-1h1a.5.5,0,0,1,.5.5V18.05a2.5,2.5,0,0,0-3,2.45Z", fill: "black" }), tp.createElement("path", { d: "M11.5,22a2.5,2.5,0,0,0-2.45,2H10.5a.5.5,0,0,1,0-1h1a.5.5,0,0,1,0,1h2.45A2.5,2.5,0,0,0,11.5,22Z", fill: "black" }), tp.createElement("path", { d: "M3.5,22a2.5,2.5,0,0,0-2.45,2H2.5a.5.5,0,0,1,0-1h1a.5.5,0,0,1,0,1H5.95A2.5,2.5,0,0,0,3.5,22Z", fill: "black" }), tp.createElement("path", { d: "M19.5,22a2.5,2.5,0,0,0-2.45,2H18.5a.5.5,0,0,1,0-1h1a.5.5,0,0,1,0,1h2.45A2.5,2.5,0,0,0,19.5,22Z", fill: "black" }));
const Oce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", fill: "none" }), tp.createElement("path", { d: "M24,1V0H0V24H1V21H4v3H5V21H8v3H9V21h3v3h1V21h3v3h1V21h3v3h1V21h3V20H21V17h3V16H21V13h3V12H21V9h3V8H21V5h3V4H21V1ZM16,1V4H13V1ZM9,8V5h3V8Zm3,1v3H9V9ZM8,8H5V5H8ZM8,9v3H5V9Zm0,4v3H5V13Zm1,0h3v3H9Zm4,0h3v3H13Zm0-1V9h3v3Zm0-4V5h3V8ZM12,1V4H9V1ZM8,1V4H5V1ZM1,1H4V4H1ZM1,5H4V8H1ZM1,9H4v3H1Zm0,4H4v3H1Zm0,7V17H4v3Zm4,0V17H8v3Zm4,0V17h3v3Zm4,0V17h3v3Zm7,0H17V17h3Zm0-4H17V13h3Zm0-4H17V9h3Zm0-4H17V5h3Zm0-4H17V1h3Z", fill: "black" }));
const Bce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", fill: "none" }), tp.createElement("rect", { x: "1", y: "1", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "5", y: "1", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "13", y: "1", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "9", y: "1", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "17", y: "1", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "21", y: "1", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "1", y: "5", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "5", y: "5", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "13", y: "5", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "9", y: "5", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "17", y: "5", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "21", y: "5", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "1", y: "9", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "5", y: "9", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "13", y: "9", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "9", y: "9", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "17", y: "9", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "21", y: "9", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "1", y: "13", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "5", y: "13", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "13", y: "13", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "9", y: "13", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "17", y: "13", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "21", y: "13", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "1", y: "17", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "5", y: "17", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "13", y: "17", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "9", y: "17", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "17", y: "17", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "21", y: "17", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "1", y: "21", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "5", y: "21", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "13", y: "21", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "9", y: "21", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "17", y: "21", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "21", y: "21", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "3", width: "2", height: "1", fill: "black" }), tp.createElement("rect", { x: "7", width: "2", height: "1", fill: "black" }), tp.createElement("rect", { x: "15", width: "2", height: "1", fill: "black" }), tp.createElement("rect", { x: "11", width: "2", height: "1", fill: "black" }), tp.createElement("rect", { x: "19", width: "2", height: "1", fill: "black" }), tp.createElement("rect", { x: "23", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { x: "3", y: "3", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "7", y: "3", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "15", y: "3", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "11", y: "3", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "19", y: "3", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "23", y: "3", width: "1", height: "2", fill: "black" }), tp.createElement("rect", { x: "3", y: "7", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "7", y: "7", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "15", y: "7", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "11", y: "7", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "19", y: "7", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "23", y: "7", width: "1", height: "2", fill: "black" }), tp.createElement("rect", { x: "3", y: "11", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "7", y: "11", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "15", y: "11", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "11", y: "11", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "19", y: "11", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "23", y: "11", width: "1", height: "2", fill: "black" }), tp.createElement("rect", { x: "3", y: "15", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "7", y: "15", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "15", y: "15", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "11", y: "15", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "19", y: "15", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "23", y: "15", width: "1", height: "2", fill: "black" }), tp.createElement("rect", { x: "3", y: "19", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "7", y: "19", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "15", y: "19", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "11", y: "19", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "19", y: "19", width: "2", height: "2", fill: "black" }), tp.createElement("rect", { x: "23", y: "19", width: "1", height: "2", fill: "black" }), tp.createElement("rect", { width: "1", height: "1", fill: "black" }), tp.createElement("rect", { y: "3", width: "1", height: "2", fill: "black" }), tp.createElement("rect", { y: "7", width: "1", height: "2", fill: "black" }), tp.createElement("rect", { y: "11", width: "1", height: "2", fill: "black" }), tp.createElement("rect", { y: "15", width: "1", height: "2", fill: "black" }), tp.createElement("rect", { y: "19", width: "1", height: "2", fill: "black" }), tp.createElement("rect", { x: "3", y: "23", width: "2", height: "1", fill: "black" }), tp.createElement("rect", { x: "7", y: "23", width: "2", height: "1", fill: "black" }), tp.createElement("rect", { x: "15", y: "23", width: "2", height: "1", fill: "black" }), tp.createElement("rect", { x: "11", y: "23", width: "2", height: "1", fill: "black" }), tp.createElement("rect", { x: "19", y: "23", width: "2", height: "1", fill: "black" }), tp.createElement("rect", { x: "23", y: "23", width: "1", height: "1", fill: "black" }), tp.createElement("rect", { y: "23", width: "1", height: "1", fill: "black" }));
const zce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("rect", { width: "24", height: "24", fill: "none" }), tp.createElement("rect", { x: "4", y: "4", width: "4", height: "4", fill: "black" }), tp.createElement("rect", { x: "4", y: "12", width: "4", height: "4", fill: "black" }), tp.createElement("rect", { x: "4", y: "20", width: "4", height: "4", fill: "black" }), tp.createElement("rect", { width: "4", height: "4", fill: "black" }), tp.createElement("rect", { y: "8", width: "4", height: "4", fill: "black" }), tp.createElement("rect", { y: "16", width: "4", height: "4", fill: "black" }), tp.createElement("rect", { x: "8", width: "4", height: "4", fill: "black" }), tp.createElement("rect", { x: "8", y: "8", width: "4", height: "4", fill: "black" }), tp.createElement("rect", { x: "8", y: "16", width: "4", height: "4", fill: "black" }), tp.createElement("rect", { x: "12", y: "4", width: "4", height: "4", fill: "black" }), tp.createElement("rect", { x: "12", y: "12", width: "4", height: "4", fill: "black" }), tp.createElement("rect", { x: "12", y: "20", width: "4", height: "4", fill: "black" }), tp.createElement("rect", { x: "20", y: "4", width: "4", height: "4", fill: "black" }), tp.createElement("rect", { x: "20", y: "12", width: "4", height: "4", fill: "black" }), tp.createElement("rect", { x: "20", y: "20", width: "4", height: "4", fill: "black" }), tp.createElement("rect", { x: "16", width: "4", height: "4", fill: "black" }), tp.createElement("rect", { x: "16", y: "8", width: "4", height: "4", fill: "black" }), tp.createElement("rect", { x: "16", y: "16", width: "4", height: "4", fill: "black" }));
const $ce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("rect", { width: "24", height: "24", fill: "none" }), tp.createElement("path", { d: "M20.35,12,24,8.35V7.65L20.35,4,24,.35V0h-.35L20,3.65,16.35,0h-.71L12,3.65,8.35,0H7.65L4,3.65.35,0H0V.35L3.65,4,0,7.65v.71L3.65,12,0,15.65v.71L3.65,20,0,23.65V24H.35L4,20.35,7.65,24h.71L12,20.35,15.65,24h.71L20,20.35,23.65,24H24v-.35L20.35,20,24,16.35v-.71Zm3.29-4L20,11.65,16.35,8,20,4.35Zm-4,4L16,15.65,12.35,12,16,8.35ZM16,.35,19.65,4,16,7.65,12.35,4ZM15.65,8,12,11.65,8.35,8,12,4.35Zm-4,4L8,15.65,4.35,12,8,8.35ZM8,.35,11.65,4,8,7.65,4.35,4ZM.35,8,4,4.35,7.65,8,4,11.65Zm0,8L4,12.35,7.65,16,4,19.65ZM8,23.65,4.35,20,8,16.35,11.65,20ZM8.35,16,12,12.35,15.65,16,12,19.65ZM16,23.65,12.35,20,16,16.35,19.65,20Zm4-4L16.35,16,20,12.35,23.65,16Z", fill: "black" }));
const Wce = tp.createElement("svg", { viewBox: "0 0 24 24", width: "24px", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("rect", { width: "24", height: "24", fill: "none" }), tp.createElement("path", { d: "M15,11.5,11.5,15,8,11.5,11.5,8ZM19.5,8,16,11.5,19.5,15,23,11.5Zm0,8L16,19.5,19.5,23,23,19.5Zm-8,0L8,19.5,11.5,23,15,19.5Zm-8-8L0,11.5,3.5,15,7,11.5Zm0,8L0,19.5,3.5,23,7,19.5Zm16-16L16,3.5,19.5,7,23,3.5Zm-8,0L8,3.5,11.5,7,15,3.5Zm-8,0L0,3.5,3.5,7,7,3.5Z", fill: "black" }));
const jce = ["dashed", "dotted", "solid", "double", "groove", "ridge", "inset", "outset"];
const Zce = { windowinset: "solid", dashdot: "dashed", dashdotdot: "dashed", dash: "dashed", dot: "dotted", thicksolid: "solid", thickdashdotdot: "dotted", thickdash: "dashed", thickdashdot: "dotted", thickdot: "dotted", extrathicksolid: "solid", thickdouble: "double" };
const Gce = { Default: null, None: null, BackwardDiagonal: qle, Cross: Yle, DarkDownwardDiagonal: dce, DarkHorizontal: Sce, DarkUpwardDiagonal: pce, DarkVertical: bce, DashedDownwardDiagonal: Cce, DashedHorizontal: wce, DashedUpwardDiagonal: xce, DashedVertical: Tce, DiagonalBrick: Pce, DiagonalCross: Kle, Divot: Hce, DottedDiamond: _ce, DottedGrid: Ice, ForwardDiagonal: Ule, Horizontal: Zle, HorizontalBrick: Nce, LargeCheckerBoard: zce, LargeConfetti: Fce, LargeGrid: Yle, LightDownwardDiagonal: cce, LightHorizontal: gce, LightUpwardDiagonal: uce, LightVertical: fce, NarrowHorizontal: vce, NarrowVertical: yce, OutlinedDiamond: $ce, Percent05: Xle, Percent10: Jle, Percent20: Qle, Percent25: ece, Percent30: tce, Percent40: nce, Percent50: rce, Percent60: oce, Percent70: ace, Percent75: ice, Percent80: sce, Percent90: lce, Plaid: Lce, Shingle: Vce, SmallCheckerBoard: Bce, SmallConfetti: Ece, SmallGrid: Oce, SolidDiamond: Wce, Sphere: Ace, Trellis: Rce, Vertical: Gle, Wave: kce, Weave: Dce, WideDownwardDiagonal: mce, WideUpwardDiagonal: hce, ZigZag: Mce };
const Uce = ["black", "#000", "#000000"];
const qce = (e14, t10) => {
  if (!t10 || ((e15) => Uce.includes((e15 || "").toLowerCase()))(t10)) return e14;
  return e14.replace(/fill="black"/gi, `fill="${t10}"`);
};
const Yce = /[\r\n"%#()<>?[\\\]^`{|}]/g;
const Kce = (e14, t10) => {
  const n10 = jle.renderToStaticMarkup(e14);
  return `url("data:image/svg+xml,${((e15) => e15.replace(/"/g, "'").replace(Yce, encodeURIComponent))(qce(n10, t10))}"`;
};
const Xce = (e14, t10, n10) => {
  const r10 = Gce[e14];
  return { backgroundColor: r10 ? t10 : "white", backgroundImage: r10 ? Kce(r10, n10) : "" };
};
const Jce = (e14, t10, n10) => {
  switch (e14) {
    case "Horizontal":
      return { backgroundImage: `linear-gradient(to right, ${t10}, ${n10})` };
    case "Vertical":
      return { backgroundImage: `linear-gradient(${t10}, ${n10})` };
    case "DiagonalDown":
      return { backgroundImage: `linear-gradient(to bottom right, ${t10}, ${n10})` };
    case "DiagonalUp":
      return { backgroundImage: `linear-gradient(to top right, ${t10}, ${n10})` };
    case "FromCenter":
      return { backgroundImage: ` radial-gradient(${t10}, ${n10})` };
    case "FromCorner":
      return { backgroundImage: ` radial-gradient(${n10}, ${t10})` };
    default:
      return {};
  }
};
const [Qce, , eue] = Dp("wd-line-style-editor");
const [tue] = eue("preview-box");
const [nue, rue] = eue("preview-content");
const oue = rue("double");
const aue = (e14, t10) => sK(e14) ? Iie(t10) : _ie(t10);
const iue = (e14) => {
  if (sK(e14)) return null;
  const t10 = ((e15 = "") => {
    const t11 = e15.toLowerCase();
    return t11 in Zce ? Zce[t11] : jce.find((e16) => e16 === t11) || "none";
  })(e14);
  return t10 ? tp.createElement("div", { className: tue }, tp.createElement("div", { className: kp(nue, { [oue]: "double" === t10 }), style: { borderTopStyle: t10 } })) : null;
};
const sue = (e14, t10, n10) => {
  if (sK(t10)) return "";
  const r10 = e14.find((e15) => e15.value === t10);
  return r10 ? r10.text : n10(t10);
};
const lue = (e14) => {
  const { value: t10, descriptor: n10, setProperty: r10, toDisplayValue: o10 = (e15) => e15, availableBorderStyles: a10, disabled: i10 } = e14;
  const { enumKey: s10 } = n10.meta;
  const { t: l10 } = vp();
  const c10 = ((e15, t11, n11) => {
    const r11 = OO(e15, t11);
    return n11 ? r11.filter(({ value: e16 }) => e16 && n11.includes(e16)) : r11;
  })(s10, l10, a10).map((e15) => ({ type: "button", value: e15.value, text: e15.label, selected: e15.value === t10 }));
  const u10 = sue(c10, t10, o10);
  const [d10, p10] = ep.useState(u10);
  ep.useEffect(() => {
    p10(u10);
  }, [u10]);
  const m10 = ep.useCallback((e15) => {
    p10(sue(c10, e15, o10)), r10(n10, e15);
  }, [n10, c10, r10, o10]);
  const h10 = ep.useCallback((e15) => {
    const t11 = c10.find((t12) => t12.text === e15);
    return t11 ? iue(t11.value) : null;
  }, [c10]);
  const f10 = { dataAid: "line-style-editor", block: true, size: "small", menuWidth: "100%", openOnFocus: true, menuMaxHeight: "default", value: d10, items: c10, customCSS: Qce, placeholder: aue(t10, l10), filterOnInput: true, onSelect: m10, generatePreview: h10, generateItemPreview: iue, disabled: i10 };
  return tp.createElement(tM, __spreadValues({}, f10));
};
lue.displayName = "LineStyleEditor";
const cue = _D(lue);
const uue = { up: nf(Xm), down: nf(Jm) };
const due = (e14, t10, n10, r10) => {
  const [o10, a10] = "Integer" === n10 ? [-2147483648, 2147483647] : [-1 / 0, 1 / 0];
  let [i10, s10] = [void 0 === e14 ? o10 : e14, void 0 === t10 ? a10 : t10];
  return r10 == null ? void 0 : r10.forEach((e15) => {
    i10 = Math.min(i10, e15.min), s10 = Math.max(s10, e15.max);
  }), { minValue: i10, maxValue: s10 };
};
const pue = (e14) => {
  const t10 = `${e14}`.split(".");
  return 2 === t10.length ? t10[1].length : 0;
};
const mue = (e14, t10, n10, r10 = 0, o10 = false, a10 = false) => {
  if (o10) {
    if (e14 <= t10) return t10 + r10;
  } else if (e14 < t10) return t10;
  if (a10) {
    if (e14 >= n10) return n10 - r10;
  } else if (e14 > n10) return n10;
  return e14;
};
const hue = (e14, t10, n10, r10, o10, a10, i10, s10, l10 = false, c10 = false) => {
  let u10 = t10 + e14;
  if ("Float" === r10) {
    const e15 = Math.max(pue(t10), pue(i10));
    u10 = parseFloat(u10.toFixed(e15));
  }
  return s10 && (u10 = ((e15, t11, n11, r11) => {
    if (t11 === e15) return t11;
    const o11 = r11.findIndex((t12) => e15 >= t12.min && e15 <= t12.max);
    if (o11 < 0) return n11();
    const a11 = r11[o11];
    return t11 > e15 ? t11 <= a11.max ? t11 : o11 < r11.length - 1 ? r11[o11 + 1].min : a11.max : t11 >= a11.min ? t11 : o11 > 0 ? r11[o11 - 1].max : a11.min;
  })(t10, u10, n10, s10)), mue(u10, o10, a10, i10, l10, c10);
};
const fue = (e14, t10) => {
  var _a2, _b2;
  const { descriptor: n10, setProperty: r10 } = t10;
  if ("" !== e14.trim() || !((_a2 = n10.meta) == null ? void 0 : _a2.emptyValue)) return false;
  switch ((_b2 = n10.meta) == null ? void 0 : _b2.emptyValue) {
    case "EmptyString":
      return r10(n10, ""), true;
    case "Null":
      return r10(n10, null), true;
    default:
      return r10(n10, void 0), true;
  }
};
const [gue, , yue] = Dp("wd-number-editor");
const [vue] = yue("input");
const [bue] = yue("button");
const Sue = (e14, t10, n10) => {
  let r10 = NaN;
  return "Integer" === n10 ? /^(-|\+)?([0-9]+)$/.test(e14) && (r10 = parseInt(e14, 10)) : "Float" === n10 && (r10 = Number(e14)), Number.isNaN(r10) ? t10() : r10;
};
const Cue = (e14, t10) => "string" === t10 ? `${e14}` : e14;
const xue = (e14) => {
  const { setProperty: t10, value: n10, disabled: r10, descriptor: o10, defaultValue: a10 } = e14;
  const { meta: i10, type: s10, meta: { numberType: l10, step: c10 = RY.step, minValue: u10, maxValue: d10, emptyValue: p10, intervals: m10, valueMode: h10 = RY.valueMode } } = o10;
  const { t: f10 } = vp();
  const { minValue: g10, maxValue: y10 } = due(u10, d10, l10, m10);
  const v10 = sK(n10);
  const { inputValue: b10, inputValid: S10, inputDirty: C10, setInputValid: x10, setInputValue: w10, setInputDirty: T10, resetInputValue: E10, onInputChange: F10, initInputValue: M10, initInputValid: k10 } = sse(n10, (e15) => v10 ? "" : hK(e15, s10, void 0, i10, String(e15 != null ? e15 : "")), (e15) => v10 && !e15 ? zY.success() : JY(e15, s10, {}, i10));
  ep.useEffect(() => {
    w10(M10), x10(k10), T10(false);
  }, [n10, p10, v10, M10, k10]);
  const P10 = (e15) => () => {
    const r11 = () => 0;
    const i11 = () => Sue(a10, r11, l10);
    const s11 = Sue(n10, i11, l10);
    const u11 = hue(e15, s11, i11, l10, g10, y10, c10, m10);
    t10(o10, Cue(u11, h10));
  };
  const N10 = () => {
    if (E10(), !S10 || v10 && !C10 && !b10) return;
    if (fue(b10, e14)) return;
    const r11 = pK(b10, o10.type, {}, o10.meta, n10);
    r11 !== n10 && t10(o10, r11);
  };
  const D10 = { icon: uue.down, disabled: r10, onClick: P10(-c10), title: `-${c10}`, dataAid: "Decrease" };
  const L10 = { icon: uue.up, disabled: r10, onClick: P10(c10), title: `+${c10}`, dataAid: "Increase" };
  const H10 = { disabled: r10, size: "small", value: b10, invalid: !S10, onChange: F10, onBlur: N10, onKeyDown: Rie(N10, E10), customCSS: vue, placeholder: Vie(v10, f10), width: "0px" };
  return tp.createElement("div", { className: gue }, tp.createElement(qm, __spreadProps(__spreadValues({}, D10), { customCSS: bue, size: "small" })), tp.createElement(KF, __spreadValues({}, H10)), tp.createElement(qm, __spreadProps(__spreadValues({}, L10), { customCSS: bue, size: "small" })));
};
xue.displayName = "NumberEditor";
const wue = _D(xue);
const Tue = HD(xue);
const [Eue, , Fue] = Dp("wd-number-editor");
const [Mue] = Fue("input");
const [kue] = Fue("button");
const Pue = (e14, t10, n10) => {
  const r10 = parseFloat(e14);
  return Number.isNaN(r10) ? t10 : r10 * n10;
};
const Nue = (e14, t10) => e14 / t10;
const Due = (e14) => {
  const { defaultValue: t10, value: n10, setProperty: r10, descriptor: o10, disabled: a10 } = e14;
  const { type: i10, meta: s10, meta: { min: l10 = AY.min, max: c10 = AY.max, step: u10 = AY.step, scale: d10 = AY.scale, defaultValue: p10 = t10 } = {} } = o10;
  const { t: m10 } = vp();
  const h10 = sK(n10);
  const { inputValue: f10, inputValid: g10, inputDirty: y10, setInputValid: v10, setInputValue: b10, setInputDirty: S10, resetInputValue: C10, onInputChange: x10, initInputValue: w10, initInputValid: T10 } = sse(n10, (e15) => h10 ? "" : hK(e15, i10, void 0, s10, String(e15 != null ? e15 : "")), (e15) => h10 && !e15 ? zY.success() : JY(e15, i10, {}, s10));
  ep.useEffect(() => {
    b10(w10), v10(T10), S10(false);
  }, [n10, h10, w10, T10]);
  const E10 = () => {
    if (C10(), !g10 || h10 && !y10 && !f10) return;
    if (fue(f10, e14)) return;
    const t11 = pK(f10, o10.type, {}, o10.meta, n10);
    t11 !== n10 && r10(o10, t11);
  };
  const F10 = (e15) => () => {
    const t11 = Pue(p10, 0, d10);
    const a11 = Pue(n10, t11, d10);
    const i11 = mue(a11 + e15, l10, c10);
    const s11 = Nue(i11, d10);
    r10(o10, s11);
  };
  const M10 = { icon: uue.down, disabled: a10, onClick: F10(-u10), title: `-${u10}%`, dataAid: "Decrease" };
  const k10 = { icon: uue.up, disabled: a10, onClick: F10(u10), title: `+${u10}%`, dataAid: "Increase" };
  const P10 = { disabled: a10, size: "small", value: f10, invalid: !g10, onChange: x10, onBlur: E10, onKeyDown: Rie(E10, C10), customCSS: Mue, placeholder: Vie(h10, m10), width: "0px" };
  return tp.createElement("div", { className: Eue }, tp.createElement(qm, __spreadProps(__spreadValues({}, M10), { customCSS: kue, size: "small" })), tp.createElement(KF, __spreadValues({}, P10)), tp.createElement(qm, __spreadProps(__spreadValues({}, k10), { customCSS: kue, size: "small" })));
};
Due.displayName = "PercentageEditor";
const Lue = _D(Due);
const Hue = { boolean: (e14, t10) => tp.createElement(Hie, __spreadValues({ key: t10 }, e14)), color: (e14, t10) => tp.createElement(Zie, __spreadValues({ key: t10 }, e14)), enum: (e14, t10) => tp.createElement(nse, __spreadValues({ key: t10 }, e14)), length: (e14, t10) => tp.createElement(pse, __spreadValues({ key: t10 }, e14)), line_style: (e14, t10) => tp.createElement(cue, __spreadValues({ key: t10 }, e14)), number: (e14, t10) => tp.createElement(wue, __spreadProps(__spreadValues({}, e14), { key: t10 })), percent: (e14, t10) => tp.createElement(Lue, __spreadProps(__spreadValues({}, e14), { key: t10 })), string: (e14, t10) => {
  var _a2;
  return tp.createElement(Sse, __spreadProps(__spreadValues({ key: t10 }, e14), { disabled: e14.disabled || ((_a2 = e14.descriptor.meta) == null ? void 0 : _a2.disabled) }));
}, date_format: (e14, t10) => tp.createElement(ise, __spreadValues({ key: t10 }, e14)) };
const Iue = ep.createContext({ setProperties: () => {
  throw new Error("You forgot to initialize CommonEditorsContext somewhere");
} });
const _ue = { instanceId: "", expressionSyntax: "i11n", units: "in", validationContext: {}, dataScope: iee, dataSets: [], dataSources: [] };
const Vue = ep.createContext(_ue);
const Rue = ep.createContext({ namedItems: [], selectedItemsInfo: [] });
const Aue = ep.createContext({ theme: null });
const Oue = ep.createContext({ dvplot: null });
const Bue = (e14 = [], t10) => e14.map((e15) => {
  const [n10, r10] = "string" == typeof e15 ? [e15, e15] : [e15.label, e15.value];
  return { type: "button", value: r10, text: n10, selected: t10 === n10 };
});
const zue = ({ toDisplayValue: e14, fromDisplayValue: t10, validateValue: n10, defaultValue: r10, descriptor: { type: o10, meta: a10 }, descriptor: i10, value: s10, setProperty: l10, items: c10, currentEnum: u10, sort: d10 = false, disabled: p10, generatePreview: m10, generateItemPreview: h10, onChange: f10, onSelect: g10, onToggle: y10 }) => {
  const { API: v10 } = ep.useContext(Sm);
  const { t: b10 } = vp();
  const S10 = sK(s10);
  const { inputValue: C10, inputValid: x10, inputDirty: w10, setInputValid: T10, setInputValue: E10, setInputDirty: F10, resetInputValue: M10, onInputChange: k10, initInputValue: P10, initInputValid: N10 } = sse(s10, e14, (e15) => e15 === r10 || S10 && !e15 ? zY.success() : n10(e15));
  ep.useEffect(() => {
    E10(P10), T10(N10), F10(false);
  }, [s10, S10, P10, N10]);
  const D10 = ep.useMemo(() => c10 || Bue(qie(u10 || OO((a10 == null ? void 0 : a10.enumKey) || o10, b10), d10), C10), [u10, C10, c10, a10, d10, b10, o10]);
  const L10 = () => {
    if (M10(), !x10 || S10 && !w10 && !C10) return;
    const e15 = t10(C10);
    e15 !== s10 && (f10 ? f10(e15) : l10(i10, e15));
  };
  const H10 = { value: C10, invalid: !x10, disabled: p10, items: D10, placeholder: Vie(S10, b10), block: true, size: "small", menuWidth: "100%", menuMaxHeight: "default", filterOnInput: true, openOnFocus: true, scrollToSelection: true, generatePreview: m10, generateItemPreview: h10, onChange: k10, onBlur: L10, onKeyDown: Rie(L10, M10), onSelect: (e15) => {
    g10 ? g10(e15) : l10(i10, e15), v10.current.dropdowns.open(null);
  }, onToggle: y10 };
  return tp.createElement("div", { className: kp(Gie) }, tp.createElement(tM, __spreadValues({}, H10)));
};
zue.displayName = "EditableEnumEditor";
const $ue = (e14) => {
  const { descriptor: t10, descriptor: { type: n10, meta: r10 }, value: o10, defaultValue: a10 } = e14;
  const { validationContext: i10, expressionSyntax: s10, units: l10 } = ep.useContext(Vue);
  const c10 = __spreadProps(__spreadValues({}, e14), { validateValue: (e15) => FJ(fc(s10, e15), { descriptor: t10, defaultValue: a10, validationContext: i10, expressionSyntax: s10, units: l10 }), toDisplayValue: (e15) => HJ(e15, n10, { expressionSyntax: s10, units: l10 }, r10, ""), fromDisplayValue: (e15) => NJ(e15, n10, { expressionSyntax: s10, units: l10 }, r10, o10) });
  return tp.createElement(zue, __spreadValues({}, c10));
};
const Wue = _D($ue);
const jue = (e14) => "string" == typeof e14 && e14.startsWith("=");
const Zue = (e14) => String(e14 != null ? e14 : "");
const Gue = (e14, t10) => e14 === t10;
function Uue(e14, t10, n10 = Gue) {
  const { value: r10, defaultValue: o10, itemTypes: a10 } = e14;
  const i10 = e14.descriptor;
  if (sK(r10)) return "Modified";
  if (n10(r10, o10)) return "Default";
  const { expressionSyntax: s10, validationContext: l10, units: c10, instanceId: u10 } = t10;
  let d10 = r10;
  if (jue(r10)) {
    const e15 = fc("rdl", r10);
    if ("const" !== e15.type) {
      const t11 = { descriptor: i10, defaultValue: o10, expressionSyntax: s10, validationContext: l10, itemTypes: a10 };
      const { isValid: n11 } = FJ(e15, t11);
      return n11 ? "Expression" : "Error";
    }
    d10 = e15.value;
  }
  const p10 = HJ(d10, i10.type, { expressionSyntax: s10 }, i10.meta);
  const { isValid: m10 } = aK(p10, { units: c10 }, { descriptor: i10, defaultValue: o10, itemTypes: a10, instanceId: u10 });
  return m10 ? "Modified" : "Error";
}
function que(e14, t10 = Gue) {
  return Uue(e14, ep.useContext(Vue), t10);
}
function Yue(e14, t10, n10 = Gue) {
  const { value: r10, descriptor: o10 } = e14;
  return { displayValue: HJ(r10, o10.type, { expressionSyntax: t10.expressionSyntax }, o10.meta, Zue(r10)), valueState: Uue(e14, t10, n10) };
}
const Kue = (e14, t10) => __spreadProps(__spreadValues({}, e14), { category: t10.category || e14.category, meta: __spreadProps(__spreadValues({}, e14.meta), { parentLabel: t10.label }) });
const Xue = (e14, t10, n10, r10, o10) => {
  const a10 = jN(t10.valuePath);
  const { value: i10, defaultValue: s10, descriptor: l10 } = e14;
  return __spreadProps(__spreadValues({}, e14), { value: i10 && a10(i10), defaultValue: r10 || s10 && a10(s10), descriptor: __spreadProps(__spreadValues({}, WN(t10, l10.valuePath)), { category: l10.category || t10.category, meta: __spreadProps(__spreadValues({}, t10.meta), { parentLabel: o10 ? l10.label : void 0 }) }), t: n10 });
};
const Jue = (e14, t10) => ({ text: t10(`propertyDescriptors:labels.${e14}_help.text`) || "", icon: nf(Ih) });
const Que = (e14) => e14("propertyEditors:common.textExpression", "<Expression>");
const ede = iJ;
const tde = { ICON_SET: "iconSet", RANGE_BAR: "rangeBar", DATA_BAR: "dataBar", GRADIENT: "gradient", HATCH: "hatch" };
const nde = Object.values(tde);
const rde = { COLOR_SCALE: "colorScale" };
const ode = Object.values(rde);
const ade = __spreadValues(__spreadValues({}, tde), rde);
const ide = { [ade.ICON_SET]: { IconSet: "GrayArrows", Icon1Value: "True", Icon2Value: "False", Icon3Value: "False", Icon4Value: "False", Icon5Value: "False" }, [ade.RANGE_BAR]: { Minimum: "0", Maximum: "100", StartingValue: "25", Length: "50", Color: "Green", DisplayProgressIndicator: true, ProgressIndicatorLength: "30", ProgressIndicatorColor: "Red" }, [ade.DATA_BAR]: { Value: "50", Minimum: "0", ZeroValue: "0", Maximum: "100", Color: "Green", UseAlternateColor: false, AlternateColor: "Transparent" }, [ade.GRADIENT]: { GradientType: "Vertical", Color1: "White", Color2: "Black" }, [ade.HATCH]: { HatchStyle: "LargeGrid", Color1: "White", Color2: "Black" }, [ade.COLOR_SCALE]: { Value: "", Minimum: "0", MinimumColor: "Silver", UseMiddleColor: false, Middle: "50", MiddleColor: "Gainsboro", Maximum: "100", MaximumColor: "WhiteSmoke" } };
const sde = (e14, t10) => {
  const n10 = ide[e14];
  if (!n10) throw new Error(`Data Visualizer type '${e14}' is not valid`);
  return { Type: e14, Content: __spreadValues(__spreadValues({}, n10), t10) };
};
const lde = "Style.BackgroundColor", cde = "Style.BackgroundImage.Value", ude = "Style.BackgroundImage.Source", dde = "Style.BackgroundImage.BackgroundRepeat", pde = "Value", mde = "Source";
const hde = { [lde]: [rW.textbox, rW.checkbox], [cde]: [rW.textbox, rW.checkbox, rW.shape, rW.rectangle, rW.fplRectangle], [pde]: [rW.image] };
const fde = (e14, t10) => e14 && e14.length >= 0 && e14.every((e15) => (t10 || []).includes(e15));
const gde = (e14, t10) => e14 === lde && fde(t10, hde[e14]);
const yde = (e14, t10) => e14 === cde && fde(t10, hde[e14]);
const vde = (e14, t10) => e14 === pde && t10.length > 0 && fde(t10, hde[e14]);
const bde = (e14, t10) => e14.length ? gde(t10, e14) ? Object.values(rde) : yde(t10, e14) || vde(t10, e14) ? Object.values(tde) : [] : [];
const Sde = (e14, ...t10) => {
  if (!e14) throw new Error(`Function name cannot be '${e14}'`);
  const n10 = (t10 || []).map((e15) => ((e16) => {
    let t11 = e16;
    const n11 = ((e17) => e17 && e17.length > 1 && e17.startsWith("=") || false)(t11);
    n11 && (t11 = t11.slice(1));
    const r10 = ((e17) => /^-?\d+\.?\d*$/.test(e17))(t11);
    return r10 || n11 || (t11 = `"${t11}"`), t11;
  })(e15)).join(", ");
  return `=${e14}(${n10})`;
};
const Cde = { [ade.ICON_SET]: (e14) => {
  const { IconSet: t10, Icon1Value: n10, Icon2Value: r10, Icon3Value: o10, Icon4Value: a10, Icon5Value: i10 } = e14.Content;
  return Sde(ede.ICON_SET, t10, n10, r10, o10, a10, i10);
}, [ade.RANGE_BAR]: (e14) => {
  const { DisplayProgressIndicator: t10, Minimum: n10, Maximum: r10, Color: o10, StartingValue: a10, Length: i10, ProgressIndicatorColor: s10, ProgressIndicatorLength: l10 } = e14.Content;
  return t10 ? Sde(ede.RANGE_BAR_PROGRESS, n10, r10, o10, a10, i10, s10, l10) : Sde(ede.RANGE_BAR, n10, r10, o10, a10, i10);
}, [ade.DATA_BAR]: (e14) => {
  const { UseAlternateColor: t10, Value: n10, Minimum: r10, Maximum: o10, ZeroValue: a10, Color: i10, AlternateColor: s10 } = e14.Content;
  return t10 ? Sde(ede.DATA_BAR, n10, r10, o10, a10, i10, s10) : Sde(ede.DATA_BAR, n10, r10, o10, a10, i10);
}, [ade.GRADIENT]: (e14) => {
  const { GradientType: t10, Color1: n10, Color2: r10 } = e14.Content;
  return Sde(ede.GRADIENT, t10, n10, r10);
}, [ade.HATCH]: (e14) => {
  const { HatchStyle: t10, Color1: n10, Color2: r10 } = e14.Content;
  return Sde(ede.HATCH, t10, n10, r10);
}, [ade.COLOR_SCALE]: (e14) => {
  const { UseMiddleColor: t10, Value: n10, Minimum: r10, Middle: o10, Maximum: a10, MinimumColor: i10, MiddleColor: s10, MaximumColor: l10 } = e14.Content;
  return t10 ? Sde(ede.COLOR_SCALE_3, n10, r10, o10, a10, i10, s10, l10) : Sde(ede.COLOR_SCALE_2, n10, r10, a10, i10, l10);
} };
const xde = (e14) => {
  const t10 = Cde[e14.Type];
  if (!t10) throw new Error(`Data Visualizer type '${e14.Type}' is not valid`);
  return t10(e14);
};
const wde = (e14) => {
  const { icon: t10, text: n10, onItemSelect: r10 } = e14;
  const o10 = { icon: t10, text: n10, block: true, rounded: false, size: "small", width: "100%", onClick: () => r10() };
  return tp.createElement(qm, __spreadValues({}, o10));
};
const Tde = (e14, t10) => e14.length && e14.every((e15) => ((e16, t11) => {
  switch (e16) {
    case "textbox":
    case "image":
      return "Value" === t11;
    case "checkbox":
      return "Text" === t11;
    default:
      return false;
  }
})(e15, t10));
const Ede = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { descriptor: n10, withReset: r10, setProperty: o10, editExpression: a10, dataSets: i10, isExpression: s10, allowRebalancing: l10, showAggregates: c10, showCalculatedFields: u10, selectedItemTypes: d10, semanticModel: p10 } = e14;
  const { API: m10 } = ep.useContext(Sm);
  const { setProperties: h10, performTransaction: f10 } = ep.useContext(Iue);
  const g10 = ep.useCallback(() => {
    a10 && a10(n10), m10.dropdowns.open(null);
  }, [m10.dropdowns, n10, a10]);
  const y10 = ep.useCallback(() => {
    o10(n10, ""), m10.dropdowns.open(null);
  }, [m10.dropdowns, n10, o10]);
  const v10 = ep.useCallback((e15, t11) => {
    const r11 = s10 ? gu({ type: "field", fieldName: t11.$path }) : t11.$path;
    const o11 = Tde(d10, n10.valuePath);
    const a11 = ((e16) => e16.length && e16.every((e17) => "textbox" === e17))(d10);
    if (l10) {
      if ("function" != typeof f10) throw new Error("SemanticFieldDropdownContent requires performTransaction() in CommonEditorsContext if allowRebalancing is enabled.");
      const i11 = [];
      if (a11 && o11 && "string" == typeof t11.Format && i11.push(o2({ descriptor: { valuePath: "Style.Format" }, value: t11.Format })), o11 ? i11.push(i2(n10, r11, e15, t11.Name, !!t11.DiscourageGrouping)) : i11.push(a2(n10, r11, e15)), t11.$rebalance && t11.$rebalance.canRebalance) {
        const { path: n11 } = t11.$rebalance.getInfo();
        i11.push(z$({ semanticModel: p10, dataSetName: e15, path: n11 }));
      }
      f10(i11);
    } else {
      const i11 = [{ descriptor: n10, value: r11 }];
      a11 && o11 && "string" == typeof t11.Format && i11.push({ descriptor: __spreadProps(__spreadValues({}, n10), { valuePath: "Style.Format" }), value: t11.Format }), o11 ? h10(i11, e15, t11.Name, t11.$path) : h10(i11, e15);
    }
    m10.dropdowns.open(null);
  }, [m10.dropdowns, l10, n10, s10, f10, d10, p10, h10]);
  const b10 = ep.useCallback((e15, t11) => {
    const r11 = s10 ? gu({ type: "field", fieldName: t11 }) : t11;
    const o11 = Tde(d10, n10.valuePath);
    const a11 = [{ descriptor: n10, value: r11 }];
    o11 ? h10(a11, e15, t11) : h10(a11, e15), m10.dropdowns.open(null);
  }, [m10.dropdowns, n10, s10, d10, h10]);
  const S10 = { dataSets: i10, checkAttribute: (e15) => {
    if ((n10.valuePath || "").indexOf("GroupExpressions") < 0) return { isDisabled: false };
    if (e15.IsAggregate || false) return { isDisabled: true, Message: `${e15.Name} (${t10("picker.warnings.groupingByAggregate", "grouping by aggregate attributes is discouraged")})` };
    return e15.DiscourageGrouping || false ? { isDisabled: true, Message: `${e15.Name} (${t10("picker.warnings.groupingIsDiscouraged", "grouping by this attribute is discouraged")})` } : { isDisabled: false };
  }, handleAttributeClick: v10, handleCalculatedFieldClick: b10, collapsible: false, allowRebalancing: l10, showAggregates: c10, showCalculatedFields: u10, showLabels: true };
  return tp.createElement("div", null, r10 && tp.createElement(wde, { icon: nf(Bh), text: t10("picker.btnReset"), onItemSelect: y10 }), s10 && tp.createElement(wde, { icon: nf(nee), text: t10("picker.btnExpression"), onItemSelect: g10 }), tp.createElement(L9, __spreadValues({}, S10)));
};
const Fde = (e14) => {
  switch (e14) {
    case "Modified":
      return "modified";
    case "Expression":
      return "bind";
    case "Error":
      return { cssClass: "wd-binding-wrapper--error" };
    default:
      return "default";
  }
};
const Mde = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { descriptor: n10, defaultValue: r10, setProperty: o10, status: a10, menuId: i10 } = e14;
  const { meta: { disableDataFields: s10 } = {}, valuePath: l10 } = n10;
  const { API: c10 } = ep.useContext(Sm);
  const { editExpression: u10, showDataVisualizer: d10, dataSources: p10, dataSets: m10, dataScope: h10, hideDataPicker: f10, reportParameters: g10, semanticInfo: y10 } = ep.useContext(Vue);
  const v10 = rf(xie);
  const { setDataFieldProperty: b10 } = ep.useContext(Iue);
  const { selectedItemsInfo: S10 } = ep.useContext(Rue);
  const C10 = S10.map(({ type: e15 }) => e15);
  const x10 = b$(p10[0]);
  const w10 = ep.useMemo(() => bde(C10, l10).length > 0, [C10, l10]);
  const T10 = ((e15, t11, n11) => {
    if (!e15 || !(t11 == null ? void 0 : t11.length)) return;
    const { path: r11 } = t11[0];
    return e15.parentDataSetName && h0($j(r11, n11)) ? e15.parentDataSetName : e15.dataSetName;
  })(h10, S10, l10);
  const E10 = ep.useMemo(() => T10 ? m10.filter((e15) => e15.Name === T10) : m10, [T10, m10]);
  const F10 = ep.useCallback(() => {
    u10 && u10(n10);
  }, [n10, u10]);
  const M10 = ep.useCallback(() => {
    o10(n10, r10);
  }, [r10, n10, o10]);
  const k10 = ep.useCallback(() => {
    d10 == null ? void 0 : d10(n10);
  }, [n10, d10]);
  const P10 = ep.useCallback(() => {
    c10.sidebar.open("dataTab");
  }, [c10.sidebar]);
  const N10 = ep.useCallback(({ name: e15, dataSetName: t11, dataType: r11, aggregate: o11, format: a11 }) => {
    const i11 = C10.length > 0 && C10.every((e16) => ((e17, t12) => {
      switch (e17) {
        case "textbox":
        case "image":
          return "Value" === t12;
        case "checkbox":
          return "Text" === t12;
        default:
          return false;
      }
    })(e16, l10));
    const s11 = { aggregate: o11, type: r11, parentDataSetName: (h10 == null ? void 0 : h10.parentDataSetName) || "", format: a11 };
    const c11 = gu({ type: "field", fieldName: e15 });
    if ("function" != typeof b10) throw new Error("StatusWrapper requires setDataFieldProperty in CommonEditorsContext");
    b10(n10, c11, t11, i11 ? e15 : null, s11);
  }, [h10 == null ? void 0 : h10.parentDataSetName, n10, C10, b10, l10]);
  const D10 = ep.useCallback((e15) => {
    o10(n10, gu({ type: "parameter", name: e15 }));
  }, [n10, o10]);
  const L10 = ep.useMemo(() => [{ type: "button", onClick: M10, text: t10("picker.btnReset"), icon: nf(Bh) }, { type: "splitter" }, w10 && { type: "button", onClick: k10, text: t10("picker.btnDataVisualizer"), icon: nf(ree, { size: "custom" }) }, { type: "button", onClick: F10, text: t10("picker.btnExpression"), icon: nf(nee, { size: "custom" }) }], [F10, k10, M10, t10, w10]);
  const H10 = ep.useMemo(() => {
    if (s10 || f10) return [];
    if (0 === E10.length) return [{ type: "splitter" }, { type: "button", onClick: P10, text: t10("picker.btnPickData"), icon: v10 }];
    const e15 = [];
    return E10.forEach((t11) => {
      e15.push({ type: "header", header: t11.Name }), e15.push(...yK(t11).map((e16) => ({ type: "button", icon: nf(Q9), text: e16.Name, value: { name: e16.Name, dataSetName: t11.Name, aggregate: e16.Aggregate, dataType: e16.DataType, format: e16.Format } })));
    }), e15;
  }, [s10, f10, v10, P10, t10, E10]);
  const I10 = ep.useMemo(() => {
    const e15 = [];
    return (g10 == null ? void 0 : g10.length) ? (e15.push({ type: "header", header: t10("picker.headingParameters") }), e15.push(...g10.map((e16) => ({ type: "button", text: e16.Name, value: e16.Name, icon: nf(eee), onClick: () => D10(e16.Name) }))), e15) : e15;
  }, [D10, g10, t10]);
  const _10 = ep.useMemo(() => x10 && !s10 ? { default: [] } : { default: [...L10, ...H10], parameters: [...L10, ...I10] }, [L10, H10, s10, x10, I10]);
  const V10 = __spreadProps(__spreadValues({}, e14), { onSelect: N10, environment: { bindingMenus: _10 }, status: Fde(a10), menuId: i10 != null ? i10 : "default", menuMaxHeight: "default", titleToggle: t10("picker.titleDataBinding") });
  if (x10 && y10) {
    const { allowRebalancing: e15, showAggregates: t11, showCalculatedFields: r11, semanticModel: a11 } = y10;
    const i11 = { dataSets: E10, withReset: true, editExpression: u10, setProperty: o10, allowRebalancing: e15, showAggregates: t11, showCalculatedFields: r11, isExpression: true, descriptor: n10, semanticModel: a11, selectedItemTypes: C10 };
    V10.content = tp.createElement(Ede, __spreadValues({}, i11));
  }
  return tp.createElement(jD, __spreadValues({}, V10));
};
const kde = (e14) => (t10) => {
  const _a2 = t10, { menuId: n10 } = _a2, r10 = __objRest(_a2, ["menuId"]);
  const o10 = que(t10);
  const a10 = { descriptor: r10.descriptor, status: o10, menuId: n10, defaultValue: r10.defaultValue, setProperty: r10.setProperty };
  return ep.createElement(Mde, __spreadValues({}, a10), ep.createElement(e14, __spreadValues({}, r10)));
};
const Pde = ({ descriptor: { type: e14, meta: t10 }, descriptor: n10, value: r10, defaultValue: o10, setProperty: a10, items: i10, currentEnum: s10, sort: l10 = false, disabled: c10, generatePreview: u10, generateItemPreview: d10, onChange: p10, onSelect: m10, onToggle: h10 }) => {
  const { validationContext: f10, expressionSyntax: g10, units: y10 } = ep.useContext(Vue);
  const { API: v10 } = ep.useContext(Sm);
  const { t: b10 } = vp();
  const S10 = sK(r10);
  const { inputValue: C10, inputValid: x10, inputDirty: w10, setInputValid: T10, setInputValue: E10, setInputDirty: F10, resetInputValue: M10, onInputChange: k10, initInputValue: P10, initInputValid: N10 } = sse(r10, (n11) => S10 ? "" : HJ(n11, e14, { expressionSyntax: g10, units: y10 }, t10, String(r10 != null ? r10 : "")), (e15) => {
    if (e15 === o10 || S10 && !e15) return zY.success();
    return FJ(fc(g10, e15), { descriptor: n10, defaultValue: o10, validationContext: f10, expressionSyntax: g10, units: y10 });
  });
  ep.useEffect(() => {
    E10(P10), T10(N10), F10(false);
  }, [r10, S10, P10, N10]);
  const D10 = qie(s10 || OO((t10 == null ? void 0 : t10.enumKey) || e14, b10), l10);
  const L10 = (() => {
    const e15 = D10 == null ? void 0 : D10.find((e16) => ("string" == typeof e16 ? e16 : e16.value) === C10);
    return e15 ? "string" == typeof e15 ? e15 : e15.label : C10;
  })();
  const H10 = ep.useMemo(() => i10 || Bue(D10, L10), [D10, i10, L10]);
  const I10 = () => {
    if (M10(), !x10 || S10 && !w10 && !C10) return;
    const o11 = NJ(C10, e14, { expressionSyntax: g10, units: y10 }, t10, r10);
    o11 !== r10 && (p10 ? p10(o11) : a10(n10, o11));
  };
  const _10 = { value: L10, invalid: !x10, disabled: c10, items: H10, placeholder: Vie(S10, b10), block: true, size: "small", menuWidth: "100%", menuMaxHeight: "default", filterOnInput: true, openOnFocus: true, scrollToSelection: true, generatePreview: u10, generateItemPreview: d10, onChange: k10, onBlur: I10, onKeyDown: Rie(I10, M10), onSelect: (e15) => {
    m10 ? m10(e15) : a10(n10, e15), v10.current.dropdowns.open(null);
  }, onToggle: h10 };
  return tp.createElement("div", { className: kp(Gie) }, tp.createElement(tM, __spreadValues({}, _10)));
};
Pde.displayName = "EditableEnumExprEditor", _D(Pde);
const Nde = kde(Pde);
const Dde = _D(kde(Pde));
const Lde = (e14) => {
  const { descriptor: t10 } = e14;
  const { expressionSyntax: n10 } = ep.useContext(Vue);
  return tp.createElement(tse, __spreadProps(__spreadValues({}, e14), { toDisplayValue: (e15) => HJ(e15, t10.type, { expressionSyntax: n10 }, t10.meta) }));
};
Lde.displayName = "EnumExprEditor";
const Hde = _D(kde(Lde));
const Ide = HD(kde(Lde));
const _de = { Type: "parameter", Omit: "false", Value: "" };
const Vde = (e14, t10) => __spreadProps(__spreadValues({}, _de), { ParameterName: e14 });
const [Rde, , Ade] = Dp("wd-collection-editor-row");
const [Ode] = Ade("element");
const Bde = (e14) => {
  const { addBtnText: t10, addBtnTitle: n10, deleteBtnTitle: r10, showBtnTitle: o10, closeBtnTitle: a10, textEmpty: i10, textItems: s10 } = e14;
  const { t: l10 } = vp("propertyEditors");
  const c10 = { addBtnText: t10 || l10("collection.btnAdd", "Add"), addBtnTitle: n10 || l10("collection.titleAdd", "Add Item"), deleteBtnTitle: r10 || l10("collection.titleDelete", "Delete"), showBtnTitle: o10 || l10("collection.titleShowItems", "Show Items"), closeBtnTitle: a10 || l10("collection.titleClose", "Close"), textEmpty: i10 || l10("collection.textEmpty", "Collection is empty"), textItems: s10 || ((e15) => l10("collection.textItemsCount", "{{count}} items", { count: e15 })) };
  return tp.createElement(bL, __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, e14), { t: l10 }), c10), { shouldUpdate: true }));
};
Bde.displayName = "CollectionEditorWithLabel";
const zde = (e14) => e14 && "string" == typeof e14 && e14.trim().toLowerCase() || "";
const $de = (e14, t10) => zde(e14) === zde(t10);
const Wde = (e14) => {
  const { descriptor: t10, value: n10, disabled: r10, setProperty: o10, allowEmpty: a10, allowNonAlphaNumeric: i10, occupiedNames: s10 } = e14;
  const { t: l10 } = vp();
  const c10 = { value: n10, disabled: r10, placeholderEmpty: _ie(l10), placeholderMultipleValues: Iie(l10), onChange: (e15) => {
    const n11 = e15.trim();
    o10(t10, n11);
  }, validate: (e15) => {
    const t11 = zde(e15);
    return 0 === t11.length ? !!a10 : !!$de(t11, n10) || !s10.find((e16) => $de(e16, t11)) && (!!i10 || NG(t11));
  } };
  return tp.createElement(UD, __spreadValues({}, c10));
};
Wde.displayName = "NameEditor";
const jde = _D(Wde);
const Zde = _D((e14) => {
  const { $index: { DataSets: t10 = [] } } = h9();
  const n10 = ep.useMemo(() => t10.map((e15) => e15.Name), [t10]);
  return tp.createElement(Wde, __spreadProps(__spreadValues({}, e14), { occupiedNames: n10 }));
});
const Gde = _D((e14) => {
  const { namedItemFilter: t10 } = e14;
  const { namedItems: n10 } = ep.useContext(Rue);
  const r10 = ep.useMemo(() => n10.filter(t10).map((e15) => e15.name), [t10, n10]);
  return tp.createElement(Wde, __spreadProps(__spreadValues({}, e14), { occupiedNames: r10 }));
});
const Ude = (e14) => `propertyDescriptors:labels.reportParameter.${e14}`;
const qde = ep.createContext({ valid_value_data_scope: { dataSetName: "", baseEntityName: "" }, default_value_data_scope: { dataSetName: "", baseEntityName: "" }, names: [], default_dataset_fields: [], valid_parameter_dataset_fields: [], dataset_name: [] });
const Yde = (e14) => {
  const { names: t10 } = ep.useContext(qde);
  return tp.createElement(Wde, __spreadProps(__spreadValues({}, e14), { occupiedNames: t10 }));
};
const Kde = _D(Yde);
const Xde = _D((e14) => {
  const { descriptor: { meta: t10 } } = e14;
  const { occupiedNames: n10 } = t10;
  return tp.createElement(Wde, __spreadProps(__spreadValues({}, e14), { allowNonAlphaNumeric: true, occupiedNames: n10 }));
});
const [, , Jde] = Dp("wd-editor-params-collection");
const [Qde] = Jde("item");
const [epe] = Jde("item-toggle");
const tpe = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { descriptor: n10, value: r10, setProperty: o10 } = e14;
  const { drillPropertiesPath: a10 } = ep.useContext(Iue);
  const i10 = rf(dh);
  const s10 = (e15) => kG(e15("nameTemplates:parameterCollection"), r10.map((e16) => e16.ParameterName));
  const l10 = __spreadProps(__spreadValues({}, e14), { value: r10 || [], createEditor: (e15, r11) => {
    const s11 = { descriptor: AV(n10, { valuePath: { $set: `${n10.valuePath}.${r11}.ParameterName` } }), value: e15.ParameterName, setProperty: o10 };
    const l11 = { block: true, size: "small", icon: i10, customCSS: epe, onClick: () => {
      a10 && a10(`${n10.valuePath}.${r11}`, t10("parameterCollection.titleProperties"));
    } };
    return tp.createElement("div", { className: Qde }, tp.createElement(Yde, __spreadValues({}, s11)), tp.createElement(qm, __spreadValues({}, l11)));
  }, onDelete: (e15) => o10(n10, AV(r10, { $splice: [[e15, 1]] })), onAdd: () => {
    return o10(n10, AV(r10 || [], { $push: [(e15 = s10(t10), Vde(e15))] }));
    var e15;
  } });
  return tp.createElement(Bde, __spreadValues({}, l10));
};
tpe.displayName = "ParameterCollectionEditor";
const npe = (e14, t10, n10, r10, o10, a10) => {
  const i10 = { locale: r10.language, onSuccess: ({ value: n11 }) => {
    n11 && (e14 && e14 === n11 || t10(n11));
  }, onClose: n10 || (() => {
  }), value: e14 };
  return { type: "button", key: "resource-provider", text: o10 || r10.t("common:textOpen"), onClick: () => a10 == null ? void 0 : a10(i10) };
};
const rpe = (e14, t10, n10, r10) => () => {
  const o10 = _V(e14, () => {
  }, () => ({ skipDirty: true }));
  const a10 = _V(t10, (e15) => ({ response: e15 }), () => ({ skipDirty: true }));
  const i10 = _V(n10, (e15) => ({ error: e15 }), () => ({ skipDirty: true }));
  const s10 = _V(r10, () => {
  }, () => ({ skipDirty: true }));
  return { constants: { request: e14, success: t10, failure: n10, clear: r10 }, actionMakers: { request: o10, success: a10, failure: i10, clear: s10 } };
};
const ope = (e14, t10, n10) => (r10 = n10, o10) => {
  switch (o10.type) {
    case e14.clear:
      return n10;
    case e14.request:
      return t10.request(r10, o10);
    case e14.success:
      return t10.success(r10, o10);
    case e14.failure:
      return t10.failure(r10, o10);
    default:
      return r10;
  }
};
const ape = _V("@core/documents/rdlx/init", ({ name: e14, type: t10, content: n10, dataSets: r10, dataSources: o10 }) => ({ name: e14, type: t10, content: n10, dataSets: r10, dataSources: o10 }), () => ({ skipDirty: true, skipUndo: true }));
const ipe = _V("@core/documents/rdlx/load", ({ name: e14, type: t10, content: n10 }) => ({ name: e14, type: t10, content: n10 }), () => ({ skipDirty: true, skipUndo: true }));
const spe = _V("@core/documents/rdlx/loadTemplate", ({ content: e14, dataSets: t10, dataSources: n10 }) => ({ content: e14, dataSets: t10, dataSources: n10 }), () => ({ skipDirty: true }));
const lpe = _V("@core/documents/rdlx/setMasterReport", ({ masterReport: e14, id: t10 }) => ({ masterReport: e14, id: t10 }));
const cpe = _V("@core/documents/rdlx/setMasterReportContent", ({ masterReport: e14, copyContent: t10 }) => ({ masterReport: e14, copyContent: t10 }));
const upe = _V("@core/documents/rdlx/updateMasterReport", ({ masterReport: e14, copyContent: t10, id: n10 }) => ({ masterReport: e14, copyContent: t10, id: n10 }));
const dpe = _V("@core/rdlx/setGroupEditorMode", (e14) => e14, () => ({ skipDirty: true }));
const ppe = _V("@core/rdlx/resources/sharedThemes/set", (e14) => e14, () => ({ skipDirty: true }));
const mpe = _V("@core/rdlx/resources/sharedDataSources/set", (e14) => e14);
const hpe = _V("@core/rdlx/resources/theme/set", (e14) => e14, () => ({ skipDirty: true, skipFplRestrictionsValidation: true }));
const fpe = _V("@core/rdlx/resources/defaultTheme/set", (e14) => e14, () => ({ skipDirty: true }));
const gpe = _V("@core/rdlx/resources/reportThemes/set", () => {
}, () => ({ skipDirty: true }));
const { constants: ype, actionMakers: vpe } = rpe("@core/rdlx/resources/images/request", "@core/rdlx/resources/images/success", "@core/rdlx/resources/images/failure", "@core/rdlx/resources/images/clear")();
const { constants: bpe, actionMakers: Spe } = rpe("@core/rdlx/resources/reports/request", "@core/rdlx/resources/reports/success", "@core/rdlx/resources/reports/failure", "@core/rdlx/resources/reports/clear")();
const { constants: Cpe, actionMakers: xpe } = rpe("@core/rdlx/resources/masterReports/request", "@core/rdlx/resources/masterReports/success", "@core/rdlx/resources/masterReports/failure", "@core/rdlx/resources/masterReports/clear")();
const wpe = () => {
  const { rdlx: { serverReports: e14 } } = d9();
  const t10 = PA();
  return ep.useMemo(() => ({ reportResources: e14, requestReports: () => t10(Spe.request()), dispatch: t10 }), [t10, e14]);
};
const Tpe = (e14, t10) => {
  if (!e14) return "";
  if (!t10.length || sK(e14)) return e14;
  const n10 = xX(e14).id || "";
  return n10 && (t10.find((e15) => e15.id === n10) || {}).name || e14;
};
const Epe = (e14) => {
  const { descriptor: t10, value: n10, onSelect: r10, setProperty: o10, filterItems: a10 } = e14;
  const { reportResources: i10, requestReports: s10 } = wpe();
  const { API: l10 } = ep.useContext(Sm);
  const { items: c10, loading: u10, error: d10 } = i10;
  const { t: p10, i18n: m10 } = vp("propertyEditors");
  const h10 = ep.useCallback(() => {
    const e15 = kX();
    if (!e15) return null;
    const { label: a11, open: i11 } = e15;
    const s11 = (c10 || []).find((e16) => e16.name === n10);
    const u11 = s11 ? s11.id : null;
    return npe(u11, (e16) => {
      r10 ? r10(e16) : o10(t10, CX(e16));
    }, () => {
      l10.current.dropdowns.open(null);
    }, m10, a11, i11);
  }, [c10, m10, n10, r10, o10, t10, l10]);
  const f10 = ep.useMemo(() => {
    const e15 = !d10 && u10;
    const t11 = Tpe(n10, c10);
    const r11 = (a10 && a10(c10) || c10).map(({ name: e16, id: n11 }) => ({ type: "button", key: n11, value: e16, text: e16, selected: e16 === t11 }));
    const o11 = d10 || u10 ? null : h10();
    return [o11, !!(!!o11 && (d10 || u10 || r11.length > 0)) && { type: "splitter" }, !!d10 && { type: "button", key: "loading-status", text: p10("reports.textLoadingError", "Error {{status}}: {{statusText}}", { status: d10.status, statusText: d10.statusText }), disabled: true }, !!e15 && { type: "button", key: "loading-status", text: p10("reports.textLoading", "Loading..."), disabled: true }, ...r11];
  }, [d10, u10, n10, c10, a10, h10, p10]);
  const g10 = { descriptor: t10, value: Tpe(n10, c10), items: f10, setProperty: o10, onSelect: r10, onChange: (e15) => {
    if (c10.length) {
      const n11 = c10.find((t11) => t11.name === e15);
      if (n11) return void o10(t10, CX(n11.id));
    }
    o10(t10, e15);
  }, onToggle: (e15) => {
    e15 && s10();
  } };
  return tp.createElement($ue, __spreadValues({}, g10));
};
Epe.displayName = "ReportsEditor";
const Fpe = _D(Epe);
const Mpe = _D(kde(Epe));
const kpe = (e14) => {
  const { value: t10, descriptor: { valuePath: n10 }, nameDescriptor: r10, parametersDescriptor: o10, isExpression: a10, setProperty: i10 } = e14;
  const { reportResources: s10, requestReports: l10, dispatch: c10 } = wpe();
  const { selectedItemsInfo: u10 } = ep.useContext(Rue);
  const { expressionSyntax: d10 } = ep.useContext(Vue);
  ep.useEffect(() => {
    null === s10.loading && l10();
  }, [s10, l10]);
  const p10 = WN(r10, n10);
  const m10 = WN(o10, n10);
  const h10 = __spreadProps(__spreadValues({}, e14), { descriptor: p10, value: t10 == null ? void 0 : t10.ReportName, defaultValue: "", onSelect: (e15) => {
    if ("" === e15 || 0 === s10.items.length) return;
    const n11 = s10.items.find((t11) => t11.name === e15);
    if (!n11) return;
    const r11 = u10.map((e16) => e16.path);
    const o11 = CX(n11.id);
    c10(L2({ itemPaths: r11, reportLink: o11, reportParameters: t10.Parameters, nameDescriptor: p10, parameterDescriptor: m10 }));
  }, setProperty: a10 ? (e15, t11) => i10(e15, NJ(t11, e15.type, { expressionSyntax: d10 })) : i10 });
  return a10 ? tp.createElement(Mpe, __spreadValues({}, h10)) : tp.createElement(Fpe, __spreadValues({}, h10));
};
kpe.displayName = "ReportWithParametersEditor";
const Ppe = Zq(tY, "", "subreport_parameters", "Parameters");
const Npe = Zq(tY, "subreport.reportName", "string", "ReportName");
const Dpe = (e14) => {
  const { documentName: t10 } = d9();
  const { Type: n10 } = h9();
  const r10 = __spreadProps(__spreadValues({}, e14), { filterItems: (e15) => e15.filter(({ name: e16, type: r11 }) => e16 !== t10 && ("dashboard" === n10 ? "DBL" === r11 : !["DBL", "RPX", "MSL_MASTER"].includes(r11))), nameDescriptor: Npe, parametersDescriptor: Ppe });
  return tp.createElement(kpe, __spreadValues({}, r10));
};
Dpe.displayName = "SubReportEditor";
const Lpe = kde((e14) => {
  const { descriptor: t10, placeholder: n10, placeholderEmpty: r10, placeholderMultipleValues: o10, disabled: a10, value: i10, onChange: s10, validate: l10, setProperty: c10 } = e14;
  const { type: u10, meta: d10 } = t10;
  const { expressionSyntax: p10 } = ep.useContext(Vue);
  const { t: m10 } = vp();
  const h10 = ep.useCallback((e15) => {
    const n11 = NJ(e15, u10, { expressionSyntax: p10 }, d10);
    s10 && "function" == typeof s10 ? s10(t10, n11) : c10(t10, n11);
  }, [t10, p10, d10, s10, c10, u10]);
  const f10 = { value: HJ(i10, u10, { expressionSyntax: p10 }, d10, Zue(i10)), disabled: a10, placeholder: n10, placeholderEmpty: r10 || _ie(m10), placeholderMultipleValues: o10 || Iie(m10), onChange: h10, validate: l10 };
  return tp.createElement(UD, __spreadValues({}, f10));
});
Lpe.displayName = "StringExprEditor";
const Hpe = _D(Lpe);
const Ipe = HD(Lpe);
const _pe = (e14) => {
  const { descriptor: t10, value: { ApplyParameters: { Parameters: n10 } }, setProperty: r10 } = e14;
  const { t: o10 } = vp("propertyEditors");
  const { expressionSyntax: a10 } = ep.useContext(Vue);
  const { $index: { ReportParameters: i10 = [] } } = h9();
  const s10 = ep.useMemo(() => WN(Zq(Yq, "action.applyParameters", "apply_parameters", "ApplyParameters.Parameters", "advanced", { parentLabel: t10.label }), t10.valuePath), [t10]);
  const l10 = ep.useCallback(() => {
    i10.length < 1 || r10(s10, AV(n10, { $push: [{ Name: i10[0].Name, Type: "Set", Value: "" }] }));
  }, [n10, i10, s10, r10]);
  const c10 = ep.useCallback((e15) => {
    r10(s10, AV(n10, { $splice: [[e15, 1]] }));
  }, [n10, s10, r10]);
  const u10 = ep.useCallback(({ Name: e15, Type: t11, Value: n11 }, l11) => {
    const c11 = { descriptor: Zq("", "", "enum", `${s10.valuePath}.${l11}.Name`), value: e15, defaultValue: "", currentEnum: i10.map(({ Name: e16 }) => e16), setProperty: r10 };
    const u11 = { descriptor: Zq("", "", "enum", `${s10.valuePath}.${l11}.Type`, "both", { enumKey: "action_apply_value_cmd" }), value: t11, defaultValue: "Set", setProperty: r10 };
    const d11 = { descriptor: Zq("", "", "string_expr", `${s10.valuePath}.${l11}.Value`), value: "Reset" === t11 ? HJ(n11, "string_expr", { expressionSyntax: a10 }) : n11, defaultValue: "", placeholderEmpty: _ie(o10), setProperty: r10, disabled: "Reset" === t11 };
    return tp.createElement("div", { className: Rde }, tp.createElement("div", { className: Ode }, tp.createElement(tse, __spreadValues({}, c11))), tp.createElement("div", { className: Ode }, tp.createElement(tse, __spreadValues({}, u11))), tp.createElement("div", { className: Ode }, "Reset" === t11 && tp.createElement(bse, __spreadValues({}, d11)), "Reset" !== t11 && tp.createElement(Lpe, __spreadValues({}, d11))));
  }, [i10, s10.valuePath, a10, r10, o10]);
  const d10 = __spreadProps(__spreadValues({}, e14), { descriptor: s10, value: n10, defaultValue: [], onAdd: i10.length > 0 ? l10 : void 0, onDelete: c10, createEditor: u10 });
  return tp.createElement(Bde, __spreadValues({}, d10));
};
const Vpe = (e14) => `action.${e14}`;
const Rpe = Zq(Yq, Vpe("jumpToReport"), "string_expr", "Drillthrough.ReportName");
const Ape = Zq(Yq, Vpe("parameters"), "parameter_collection", "Drillthrough.Parameters");
const Ope = Zq(Yq, Vpe("jumpToBookmark"), "string_expr", "BookmarkLink");
const Bpe = Zq(Yq, Vpe("jumpToUrl"), "string_expr", "Hyperlink");
const zpe = (e14, t10 = "", n10, r10) => {
  const { descriptor: o10 } = e14;
  const a10 = WN(Ope, o10.valuePath);
  a10.meta = { parentLabel: o10.label };
  const { selectedItemsInfo: i10, namedItems: s10 } = n10;
  const l10 = s10.filter((e15) => {
    return e15.type && (t11 = e15.name, !i10.some((e16) => e16.name === t11)) && e15.bookmark;
    var t11;
  });
  const c10 = __spreadProps(__spreadValues({}, e14), { descriptor: a10, value: t10, defaultValue: "", currentEnum: l10.map((e15) => {
    const t11 = HJ(e15.bookmark || "", "string_expr", { expressionSyntax: r10 });
    return { label: t11, value: t11 };
  }) });
  return tp.createElement(Dde, __spreadValues({}, c10));
};
const $pe = (e14) => {
  const { descriptor: t10, value: n10, setProperty: r10 } = e14;
  const { expressionSyntax: o10 } = ep.useContext(Vue);
  const a10 = ep.useContext(Rue);
  const { rdlx: { reportItemsFeatures: { prohibitApplyParametersAction: i10 } } } = Uae();
  const s10 = __spreadProps(__spreadValues({}, e14), { value: n10.ActionType, setProperty: (e15, n11) => r10(t10, ((e16 = "None") => {
    switch (e16) {
      case "BookmarkLink":
        return { ActionType: e16, BookmarkLink: "" };
      case "Drillthrough":
        return { ActionType: e16, Drillthrough: { ReportName: "", Parameters: [] } };
      case "Hyperlink":
        return { ActionType: e16, Hyperlink: "" };
      case "ApplyParameters":
        return { ActionType: e16, ApplyParameters: { Parameters: [] } };
      default:
        return { ActionType: e16 };
    }
  })(n11)), filterEnum: i10 ? (e15) => "ApplyParameters" !== ("string" == typeof e15 ? e15 : e15.value) : void 0 });
  return tp.createElement(tp.Fragment, null, tp.createElement(nse, __spreadValues({}, s10)), (() => {
    switch (n10.ActionType) {
      case "BookmarkLink":
        return zpe(e14, n10.BookmarkLink, a10, o10);
      case "Drillthrough":
        return ((e15, t11) => {
          const { descriptor: n11 } = e15;
          const r11 = WN(Ape, n11.valuePath);
          Ape.meta = { parentLabel: n11.label }, Rpe.meta = { parentLabel: n11.label };
          const o11 = __spreadProps(__spreadValues({}, e15), { parametersDescriptor: Ape, nameDescriptor: Rpe, descriptor: n11, isExpression: true, value: t11, filterItems: (e16) => e16.filter((e17) => !e17.name.endsWith(".rdlx-master")) });
          const a11 = __spreadProps(__spreadValues({}, e15), { descriptor: r11, value: t11 == null ? void 0 : t11.Parameters });
          return tp.createElement(tp.Fragment, null, tp.createElement(kpe, __spreadValues({}, o11)), (t11 == null ? void 0 : t11.ReportName) && tp.createElement(tpe, __spreadValues({}, a11)));
        })(e14, n10.Drillthrough);
      case "Hyperlink":
        return ((e15, t11 = "") => {
          const { descriptor: n11 } = e15;
          const r11 = WN(Bpe, n11.valuePath);
          r11.meta = { parentLabel: n11.label };
          const o11 = __spreadProps(__spreadValues({}, e15), { value: t11, descriptor: r11, defaultValue: "" });
          return tp.createElement(Hpe, __spreadValues({}, o11));
        })(e14, n10.Hyperlink);
      case "ApplyParameters":
        return tp.createElement(_pe, __spreadProps(__spreadValues({}, e14), { value: n10 }));
      default:
        return null;
    }
  })());
};
$pe.displayName = "ActionEditor";
const Wpe = ({ namedItems: e14, selectedItemsInfo: t10 }) => {
  var _a2, _b2, _c2;
  let n10 = "";
  let r10 = false;
  for (let o10 = 0; o10 < e14.length; o10++) {
    const a10 = e14[o10];
    if (((_a2 = a10.$options) == null ? void 0 : _a2.autoMergeMode) && "textbox" === a10.type && !t10.every((e15) => e15.name !== a10.name)) {
      if ("" !== n10) {
        if (n10 === ((_b2 = a10.$options) == null ? void 0 : _b2.autoMergeMode)) continue;
        r10 = true;
        break;
      }
      n10 = (_c2 = a10.$options) == null ? void 0 : _c2.autoMergeMode;
    }
  }
  return r10 ? XN : n10;
};
const jpe = (e14) => {
  const t10 = ep.useContext(Rue);
  const n10 = PA();
  const { t: r10 } = vp();
  const o10 = __spreadProps(__spreadValues({}, e14), { value: Wpe(t10), tooltip: Jue("tablixBodyCell.autoMergeMode", r10), setProperty: (e15, t11) => {
    n10(D2({ autoMergeMode: t11 }));
  } });
  return tp.createElement(nse, __spreadValues({}, o10));
};
const [Zpe, Gpe] = Dp("wd-bool-editor");
const Upe = Gpe("expr");
const qpe = /^=?(true)$/i;
const Ype = /^=?(false)$/i;
const Kpe = (e14) => "string" == typeof e14 ? -1 !== e14.search(qpe) : !!e14;
const Xpe = (e14) => "string" == typeof e14 ? -1 !== e14.search(Ype) : !e14;
const Jpe = (e14, t10) => Kpe(e14) ? -1 !== (t10 == null ? void 0 : t10.search(qpe)) : !!Xpe(e14) && -1 !== (t10 == null ? void 0 : t10.search(Ype));
const Qpe = { boolean_expr: { textTrue: "boolean.textTrue", textFalse: "boolean.textFalse" }, toggle_state: { textTrue: "toggleState.textExpanded", textFalse: "toggleState.textCollapsed" } };
const eme = (e14) => {
  var _a2, _b2, _c2;
  const { t: t10 } = vp("propertyEditors");
  const { descriptor: n10, value: r10, setProperty: o10, defaultValue: a10, disabled: i10 = false, labelPosition: s10 = "left", textExpression: l10 = t10("common.textExpression") } = e14;
  const c10 = ((_a2 = n10.meta) == null ? void 0 : _a2.booleanType) || n10.type;
  const u10 = t10((_b2 = Qpe[c10]) == null ? void 0 : _b2.textTrue);
  const d10 = t10((_c2 = Qpe[c10]) == null ? void 0 : _c2.textFalse);
  const p10 = que(e14, Jpe);
  const m10 = { block: true, onToggle: () => {
    o10(n10, !sK(r10) && Kpe(r10) ? "False" : "True");
  }, value: r10, customCSS: Zpe, text: sK(r10) ? r10.toString() : Kpe(r10) && u10 || Xpe(r10) && d10 || l10, indeterminate: sK(r10) || null == r10 || "" === r10, checked: r10 && Kpe(r10), size: "small", textAlign: "top" === s10 ? "right" : "left", disabled: i10 };
  const h10 = { descriptor: n10, status: p10, defaultValue: a10, setProperty: o10 };
  return tp.createElement(Mde, __spreadValues({}, h10), "Expression" === p10 ? tp.createElement("div", { className: Upe }, l10) : tp.createElement(SM, __spreadValues({}, m10)));
};
eme.displayName = "BooleanExprEditor";
const tme = _D(eme);
const nme = { Width: "1px", Style: "dotted", Color: "darkgray" };
const rme = { borderStyle: "dotted none none none", borderColor: "darkgray", borderWidth: "1.5pt" };
const ome = (e14) => {
  const t10 = (e14 && e14.LineStyle || "").toLowerCase();
  return "transparent" === t10 || "none" === t10;
};
const ame = ["dashed", "dotted", "solid", "double", "groove", "ridge", "inset", "outset"];
const ime = { windowinset: "solid", dashdot: "dashed", dashdotdot: "dashed" };
const sme = { 0: "Dark1", 1: "Light1", 2: "Dark2", 3: "Light2", 4: "Accent1", 5: "Accent2", 6: "Accent3", 7: "Accent4", 8: "Accent5", 9: "Accent6", 10: "Hyperlink", 11: "HyperlinkFollowed" };
const lme = Object.keys(sme).reduce((e14, t10) => Object.assign(e14, { [sme[t10]]: t10 }), {});
const cme = "1", ume = "2", dme = "3", pme = "4", mme = "5";
const hme = (e14) => sme[e14];
function fme(e14, t10) {
  const n10 = parseInt(e14.slice(1), 16);
  const r10 = t10 < 0 ? 0 : 255;
  const o10 = n10 >> 8 & 255;
  const a10 = 255 & n10;
  const i10 = (e15) => Math.round((r10 - e15) * Math.abs(t10)) + e15;
  return `#${(16777216 + 65536 * i10(n10 >> 16 & 255) + 256 * i10(o10) + i10(a10)).toString(16).slice(1)}`;
}
const gme = (e14, t10) => {
  const n10 = ((e15, t11) => {
    const n11 = function(e16) {
      return e16 && { aliceblue: "#f0f8ff", antiquewhite: "#faebd7", aqua: "#00ffff", aquamarine: "#7fffd4", azure: "#f0ffff", beige: "#f5f5dc", bisque: "#ffe4c4", black: "#000000", blanchedalmond: "#ffebcd", blue: "#0000ff", blueviolet: "#8a2be2", brown: "#a52a2a", burlywood: "#deb887", cadetblue: "#5f9ea0", chartreuse: "#7fff00", chocolate: "#d2691e", coral: "#ff7f50", cornflowerblue: "#6495ed", cornsilk: "#fff8dc", crimson: "#dc143c", cyan: "#00ffff", darkblue: "#00008b", darkcyan: "#008b8b", darkgoldenrod: "#b8860b", darkgray: "#a9a9a9", darkgreen: "#006400", darkkhaki: "#bdb76b", darkmagenta: "#8b008b", darkolivegreen: "#556b2f", darkorange: "#ff8c00", darkorchid: "#9932cc", darkred: "#8b0000", darksalmon: "#e9967a", darkseagreen: "#8fbc8f", darkslateblue: "#483d8b", darkslategray: "#2f4f4f", darkturquoise: "#00ced1", darkviolet: "#9400d3", deeppink: "#ff1493", deepskyblue: "#00bfff", dimgray: "#696969", dodgerblue: "#1e90ff", firebrick: "#b22222", floralwhite: "#fffaf0", forestgreen: "#228b22", fuchsia: "#ff00ff", gainsboro: "#dcdcdc", ghostwhite: "#f8f8ff", gold: "#ffd700", goldenrod: "#daa520", gray: "#808080", green: "#008000", greenyellow: "#adff2f", honeydew: "#f0fff0", hotpink: "#ff69b4", "indianred ": "#cd5c5c", indigo: "#4b0082", ivory: "#fffff0", khaki: "#f0e68c", lavender: "#e6e6fa", lavenderblush: "#fff0f5", lawngreen: "#7cfc00", lemonchiffon: "#fffacd", lightblue: "#add8e6", lightcoral: "#f08080", lightcyan: "#e0ffff", lightgoldenrodyellow: "#fafad2", lightgrey: "#d3d3d3", lightgreen: "#90ee90", lightpink: "#ffb6c1", lightsalmon: "#ffa07a", lightseagreen: "#20b2aa", lightskyblue: "#87cefa", lightslategray: "#778899", lightsteelblue: "#b0c4de", lightyellow: "#ffffe0", lime: "#00ff00", limegreen: "#32cd32", linen: "#faf0e6", magenta: "#ff00ff", maroon: "#800000", mediumaquamarine: "#66cdaa", mediumblue: "#0000cd", mediumorchid: "#ba55d3", mediumpurple: "#9370d8", mediumseagreen: "#3cb371", mediumslateblue: "#7b68ee", mediumspringgreen: "#00fa9a", mediumturquoise: "#48d1cc", mediumvioletred: "#c71585", midnightblue: "#191970", mintcream: "#f5fffa", mistyrose: "#ffe4e1", moccasin: "#ffe4b5", navajowhite: "#ffdead", navy: "#000080", oldlace: "#fdf5e6", olive: "#808000", olivedrab: "#6b8e23", orange: "#ffa500", orangered: "#ff4500", orchid: "#da70d6", palegoldenrod: "#eee8aa", palegreen: "#98fb98", paleturquoise: "#afeeee", palevioletred: "#d87093", papayawhip: "#ffefd5", peachpuff: "#ffdab9", peru: "#cd853f", pink: "#ffc0cb", plum: "#dda0dd", powderblue: "#b0e0e6", purple: "#800080", rebeccapurple: "#663399", red: "#ff0000", rosybrown: "#bc8f8f", royalblue: "#4169e1", saddlebrown: "#8b4513", salmon: "#fa8072", sandybrown: "#f4a460", seagreen: "#2e8b57", seashell: "#fff5ee", sienna: "#a0522d", silver: "#c0c0c0", skyblue: "#87ceeb", slateblue: "#6a5acd", slategray: "#708090", snow: "#fffafa", springgreen: "#00ff7f", steelblue: "#4682b4", tan: "#d2b48c", teal: "#008080", thistle: "#d8bfd8", tomato: "#ff6347", turquoise: "#40e0d0", violet: "#ee82ee", wheat: "#f5deb3", white: "#ffffff", whitesmoke: "#f5f5f5", yellow: "#ffff00", yellowgreen: "#9acd32" }[e16.toLowerCase()];
    }(e15) || e15;
    if (!n11 || !n11.startsWith("#")) return "";
    switch (t11) {
      case cme:
        return fme(n11, 0.75);
      case ume:
        return fme(n11, 0.5);
      case dme:
        return fme(n11, 0.25);
      case pme:
        return fme(n11, -0.25);
      case mme:
        return fme(n11, -0.5);
      default:
        return n11;
    }
  })(e14, t10);
  return (n10 || "transparent").toString();
};
const yme = "Theme.Colors";
function vme(e14) {
  return e14 && e14.includes(yme);
}
const bme = /Theme.Colors(\(([\d\s]+),([\d\s]+)\)|!(\w+))/;
function Sme(e14, t10) {
  if (t10 && e14) {
    const n10 = e14 == null ? void 0 : e14.match(bme);
    if (!n10) return e14;
    const [, , r10, o10, a10] = n10.map((e15) => e15 == null ? void 0 : e15.trim());
    if (r10 && o10) {
      const e15 = hme(o10);
      return gme(t10.Colors[e15], r10);
    }
    if (a10) return t10.Colors[a10];
  }
  return e14;
}
function Cme(e14) {
  if (!e14) return "";
  const t10 = e14.toLowerCase();
  return ame.some((e15) => e15 === t10) ? e14 : ime[t10];
}
const xme = (e14) => e14 && !e14.startsWith("=");
const wme = (e14, t10, n10, r10) => t10 && t10[e14] || n10 && n10[e14] || r10[e14];
const Tme = (e14, t10, n10, r10) => t10 && xme(t10[e14]) ? t10[e14] : n10 && xme(n10[e14]) ? n10[e14] : r10[e14];
function Eme(e14, t10, n10, r10, o10) {
  const a10 = Tme("Style", n10, t10, r10);
  if ("None" === a10) return { [`${e14}Style`]: r10.Style, [`${e14}Color`]: r10.Color, [`${e14}Width`]: r10.Width };
  const i10 = wme("Color", n10, t10, r10);
  const s10 = Tme("Width", n10, t10, r10);
  return { [`${e14}Style`]: Cme(a10), [`${e14}Color`]: Sme(i10, o10), [`${e14}Width`]: s10 };
}
function Fme(e14, t10, n10 = nme) {
  const { Border: r10, LeftBorder: o10, TopBorder: a10, RightBorder: i10, BottomBorder: s10 } = e14;
  return __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, Eme("borderLeft", r10, o10, n10, t10)), Eme("borderTop", r10, a10, n10, t10)), Eme("borderRight", r10, i10, n10, t10)), Eme("borderBottom", r10, s10, n10, t10));
}
function Mme(e14, t10, n10 = nme, r10 = "100%", o10 = "100%") {
  const a10 = Fme(e14, t10, n10);
  const { borderTopWidth: i10, borderBottomWidth: s10, borderLeftWidth: l10, borderRightWidth: c10 } = a10;
  return __spreadProps(__spreadValues({}, a10), { width: `calc(${r10} + (${l10} + ${c10})/2)`, height: `calc(${o10} + (${i10} + ${s10})/2)`, top: `calc(-${i10} / 2)`, left: `calc(-${l10} / 2)` });
}
function kme({ PaddingLeft: e14, PaddingTop: t10, PaddingRight: n10, PaddingBottom: r10 }, o10 = "0pt") {
  return { paddingLeft: e14 || o10, paddingTop: t10 || o10, paddingRight: n10 || o10, paddingBottom: r10 || o10 };
}
function Pme(e14) {
  let t10;
  switch (e14) {
    case "Lighter":
      t10 = "lighter";
      break;
    case "Thin":
      t10 = "100";
      break;
    case "ExtraLight":
      t10 = "200";
      break;
    case "Light":
      t10 = "300";
      break;
    case "Normal":
    default:
      t10 = "normal";
      break;
    case "Medium":
      t10 = "500";
      break;
    case "SemiBold":
      t10 = "600";
      break;
    case "Bold":
      t10 = "700";
      break;
    case "ExtraBold":
      t10 = "800";
      break;
    case "Heavy":
      t10 = "900";
      break;
    case "Bolder":
      t10 = "bolder";
  }
  return t10;
}
const Nme = "=Theme.Fonts!";
const Dme = "=Theme.Fonts!MajorFont.";
const Lme = "=Theme.Fonts!MinorFont.";
function Hme(e14) {
  return !(!e14 || "string" != typeof e14) && e14.startsWith(Nme);
}
function Ime(e14, t10) {
  if (!t10) return e14;
  if (!Hme(e14)) return e14;
  let n10;
  let r10;
  if (e14.startsWith(Dme) && (n10 = t10.Fonts.MajorFont, r10 = e14.slice(Dme.length)), e14.startsWith(Lme) && (n10 = t10.Fonts.MinorFont, r10 = e14.slice(Lme.length)), !n10 || !r10) return e14;
  switch (r10) {
    case "Family":
      return n10.Family || "Arial";
    case "Size":
      return n10.Size || "10pt";
    case "Style":
      return n10.Style || "Normal";
    case "Weight":
      return n10.Weight || "Normal";
  }
  return e14;
}
function _me(e14, t10, n10 = Pme) {
  const { family: r10, size: o10, style: a10, weight: i10 } = e14;
  const s10 = { fontFamily: r10, fontSize: o10, fontStyle: a10, fontWeight: n10(i10) };
  if (t10) {
    const e15 = (e16) => e16 && e16.includes("Theme.Fonts!");
    const l10 = (e16) => e16.includes("Theme.Fonts!MajorFont");
    const c10 = (n11, r11, o11) => e15(n11) ? l10(n11) ? t10.Fonts.MajorFont[r11] : t10.Fonts.MinorFont[r11] : o11 ? o11(n11) : n11;
    s10.fontFamily = `"${c10(r10, "Family")}"`, s10.fontSize = c10(o10, "Size"), s10.fontStyle = c10(a10, "Style"), s10.fontWeight = c10(i10, "Weight", n10);
  }
  return s10;
}
const Vme = { LineThrough: "line-through", Overline: "overline", None: "none", Underline: "underline", DoubleUnderline: "double underline" };
function Rme(e14) {
  const t10 = Vme[e14] || Vme.None;
  return { textDecoration: t10, WebkitTextDecoration: t10 };
}
function Ame(e14, t10) {
  const n10 = (e15, t11) => {
    const n11 = L$.isValidString(e15) ? e15 : t11;
    return L$.parse(n11).toTwips;
  };
  const r10 = n10(e14, "0pt");
  const o10 = n10(t10, "10pt");
  return (0 === r10 ? L$.fromTwips(1.15 * o10, "pt") : L$.fromTwips(o10 + r10 / 1.15, "pt")).css;
}
const Ome = (e14) => !((e15) => (e15 || "transparent").match(/^=?transparent$/i))(e14) && !jme(e14);
function Bme(e14, t10, n10) {
  const r10 = Sme(e14, n10);
  const o10 = Sme(t10, n10);
  const a10 = Ome(o10) ? o10 : "White";
  return Ome(r10) ? r10 : a10;
}
function zme(e14, t10, n10, r10) {
  if (!e14 || !t10) return "";
  switch (e14) {
    case "External":
      if (((e16) => {
        if ("" === e16 || "" === e16.trim()) return false;
        try {
          const t11 = e16.split(",")[1];
          return btoa(atob(t11)) === t11;
        } catch (e17) {
          return false;
        }
      })(t10)) return `url("${t10}")`;
      const e15 = xX(t10);
      if (e15.id) {
        return `url("${r10(e15.id)}")`;
      }
      break;
    case "Embedded":
      const o10 = n10.find((e16) => e16.Name === t10);
      return o10 ? `url("data:${o10.MIMEType};base64, ${o10.ImageData}")` : null;
  }
  return "";
}
function $me(e14) {
  if (!e14 || !e14.BackgroundRepeat) return "";
  switch (e14.BackgroundRepeat.toLowerCase()) {
    case "repeat":
      return "bg-repeat";
    case "norepeat":
      return "bg-no-repeat";
    case "repeatx":
      return "bg-repeat-x";
    case "repeaty":
      return "bg-repeat-y";
  }
  return "";
}
function Wme(e14, t10) {
  return e14 ? " dnd-is-over" : t10 ? " dnd-can-drop" : "";
}
function jme(e14) {
  return e14 && "string" == typeof e14 && e14.length > 0 && "=" === e14[0];
}
const Zme = (e14, t10, n10) => {
  const r10 = !jme(e14) && e14 || "LeftRight";
  const o10 = !jme(t10) && t10 || "Transparent";
  const a10 = !jme(n10) && n10 || "Transparent";
  if ("None" === r10 || "Transparent" === a10) return "";
  const i10 = (e15) => `linear-gradient(${e15}, ${o10}, ${a10})`;
  const s10 = (e15) => `linear-gradient(${e15}, ${o10}, ${a10}, ${o10})`;
  let l10 = "";
  switch (r10) {
    case "LeftRight":
      l10 = i10("to right");
      break;
    case "TopBottom":
      l10 = i10("to bottom");
      break;
    case "Center":
      l10 = ((e15) => `radial-gradient(${e15}, ${o10}, ${a10})`)("circle");
      break;
    case "DiagonalLeft":
      l10 = i10("to bottom right");
      break;
    case "DiagonalRight":
      l10 = i10("to bottom left");
      break;
    case "HorizontalCenter":
      l10 = s10("to bottom");
      break;
    case "VerticalCenter":
      l10 = s10("to right");
  }
  return l10;
};
const Gme = "=Theme.Colors";
const Ume = ["Dark1", "Dark2", "Light1", "Light2", "Hyperlink", "HyperlinkFollowed", "Accent1", "Accent2", "Accent3", "Accent4", "Accent5", "Accent6"];
const qme = ["Base", "Lighter75", "Lighter50", "Lighter25", "Darker25", "Darker50"];
const Yme = [dm.shades(dm.fromHEX("#f44336")), dm.shades(dm.fromHEX("#ff9800")), dm.shades(dm.fromHEX("#ffeb3b")), dm.shades(dm.fromHEX("#8bc34a")), dm.shades(dm.fromHEX("#4caf50")), dm.shades(dm.fromHEX("#00bcd4")), dm.shades(dm.fromHEX("#2196f3")), dm.shades(dm.fromHEX("#9c27b0")), [dm.fromHEX("#ffffff"), dm.fromHEX("#888"), dm.fromHEX("#aaa"), dm.fromHEX("#ccc"), dm.fromHEX("#e6e6e6"), dm.fromHEX("#f7f7f7")], [dm.fromHEX("#000000"), dm.fromHEX("#090909"), dm.fromHEX("#1a1a1a"), dm.fromHEX("#3c3c3c"), dm.fromHEX("#5e5e5e"), dm.fromHEX("#808080")]];
const Kme = ({ theme: e14, value: t10, onSelect: n10 }) => {
  const { API: r10 } = ep.useContext(Sm);
  const { t: o10 } = vp("propertyEditors");
  const a10 = ep.useCallback((e15) => {
    n10(e15), r10.dropdowns.open(null);
  }, [n10, r10.dropdowns]);
  const i10 = ep.useMemo(() => ({ name: o10("colorDropdown.headingStandard", "Standard Colors"), colors: Yme }), [o10]);
  const s10 = ep.useMemo(() => {
    const t11 = [i10];
    if (e14 && !e14.$isFallback) {
      const n11 = Ume.map((t12) => dm.shades(dm.fromHEX(e14 == null ? void 0 : e14.Colors[t12])).map((e15, n12, r11) => {
        const a11 = n12 > 0 ? r11.length - n12 : 0;
        const i11 = e15;
        return i11.customValue = n12 > 0 ? ((e16, t13) => `${Gme}(${t13},${lme[e16]})`)(t12, a11) : ((e16) => `${Gme}!${e16}`)(t12), i11.title = ((e16, t13, n13) => n13(`colorDropdown.themeColors.title${qme[t13]}`, { colorKey: e16 }))(t12, a11, o10), i11;
      }));
      t11.unshift({ name: o10("colorDropdown.headingTheme", "Theme Colors"), colors: n11 });
    }
    return t11;
  }, [i10, o10, e14]);
  const l10 = { value: t10, palettes: s10, textPalettes: o10("colorDropdown.btnPalettes", "Palettes"), textColorPicker: o10("colorDropdown.btnColorPicker", "Other Colors"), textWebColors: o10("colorDropdown.btnWebColors", "Web Colors"), textHue: o10("colorDropdown.labelHue", "Hue"), textSaturation: o10("colorDropdown.labelSaturation", "Saturation"), textLightness: o10("colorDropdown.labelLightness", "Lightness"), textHex: o10("colorDropdown.labelHex", "Hex"), onSelect: a10 };
  return tp.createElement(xH, __spreadValues({}, l10));
};
const [Xme, , Jme] = Dp("wd-color-editor");
const [Qme] = Jme("preview");
const ehe = (e14, t10) => sK(e14) || e14 === Que(t10);
const the = (e14, t10) => sK(e14) ? Iie(t10) : e14 === Que(t10) ? Que(t10) : _ie(t10);
const nhe = (e14) => {
  const { descriptor: t10, defaultValue: n10, value: r10, setProperty: o10, generatePreview: a10, onChange: i10, onValidate: s10, disabled: l10 } = e14;
  const c10 = ep.useContext(Vue);
  const { theme: u10 } = ep.useContext(Aue);
  const { API: d10 } = ep.useContext(Sm);
  const { t: p10 } = vp();
  const m10 = sK(r10);
  const { displayValue: h10, valueState: f10 } = ehe(r10, p10) ? { displayValue: "", valueState: "Modified" } : Yue(e14, c10);
  const [g10, y10] = ep.useState(h10);
  ep.useEffect(() => {
    y10(h10);
  }, [r10]);
  const v10 = ep.useCallback(() => d10.current.dropdowns.open(null), [d10]);
  const b10 = ep.useCallback((e15) => {
    const n11 = e15.customValue || dm.toWeb(e15) || e15.hex;
    i10 ? i10(n11) : o10(t10, n11), v10();
  }, [t10, v10, i10, o10]);
  const S10 = { theme: u10, value: m10 || !g10 ? new dm(0, 0, 0, 255) : g10.startsWith("#") ? dm.fromHEX(g10) : dm.fromWeb(g10), onSelect: b10 };
  const C10 = ep.useCallback((e15) => {
    const t11 = Sme(e15, u10);
    return "Expression" === f10 && t11 === e15 ? null : tp.createElement("div", { className: kp("gc-color__main", Qme), style: { backgroundColor: t11 } });
  }, [u10, f10]);
  const x10 = ep.useCallback(() => !(!ehe(r10, p10) || "" !== g10) || (s10 ? s10(g10) : ((e15, t11, n11, r11) => {
    if (sK(t11)) return true;
    const { validationContext: o11, expressionSyntax: a11 } = r11;
    const i11 = fc(a11, t11);
    const { isValid: s11 } = FJ(i11, { descriptor: e15, defaultValue: n11, validationContext: o11, expressionSyntax: a11 });
    return !!s11;
  })(t10, g10, n10, c10)), [g10, n10, t10, c10, s10, p10, r10]);
  const w10 = ep.useCallback((e15) => {
    y10(e15.target.value), v10();
  }, [v10]);
  const T10 = ep.useCallback((e15) => {
    if (e15.target.value === h10) return;
    if (!x10()) return void y10(h10);
    const n11 = NJ(e15.target.value, t10.type, { expressionSyntax: c10.expressionSyntax }, t10.meta, e15.target.value);
    i10 ? i10(n11) : o10(t10, n11), y10(h10);
  }, [t10, h10, c10.expressionSyntax, i10, o10, x10]);
  const E10 = { dataAid: "color-editor", value: g10, block: true, size: "small", menuWidth: "auto", openOnFocus: false, invalid: !x10(), content: tp.createElement(Kme, __spreadValues({}, S10)), customCSS: kp(Xme), placeholder: the(r10, p10), onChange: w10, onBlur: T10, generatePreview: a10 || (ehe(r10, p10) || "Error" === f10 ? void 0 : C10), disabled: l10 };
  return tp.createElement(tM, __spreadValues({}, E10));
};
const rhe = (e14) => {
  const { descriptor: t10, defaultValue: n10, setProperty: r10 } = e14;
  const o10 = { descriptor: t10, status: que(e14), defaultValue: n10, setProperty: r10 };
  return tp.createElement(Mde, __spreadValues({}, o10), tp.createElement(nhe, __spreadValues({}, e14)));
};
const ohe = _D(nhe);
const ahe = _D(rhe);
const ihe = HD(rhe);
const [, , she] = Dp("wd-color-editor-side");
const [lhe, che] = she("preview");
function uhe(e14) {
  return "string" == typeof e14 && e14.startsWith("=");
}
const dhe = (e14) => {
  const { nestedDescriptors: t10 } = e14;
  const { t: n10 } = vp("propertyEditors");
  const { expressionSyntax: r10, validationContext: o10 } = ep.useContext(Vue);
  const a10 = ep.useCallback((e15, n11) => NJ(e15, t10[n11].type, { expressionSyntax: r10 }, t10[n11].meta, e15), [r10, t10]);
  const i10 = ep.useCallback((e15, n11) => HJ(e15, t10[n11].type, { expressionSyntax: r10 }, t10[n11].meta, e15), [r10, t10]);
  const s10 = ep.useCallback((e15, t11, n11) => {
    const r11 = fc("rdl", e15);
    const { isValid: a11 } = FJ(r11, { descriptor: n11, defaultValue: t11, validationContext: o10, expressionSyntax: "rdl" });
    return a11;
  }, [o10]);
  const l10 = ep.useCallback((e15) => "string" != typeof e15 ? [""] : uhe(e15) ? [e15] : e15.trim().split(" ").slice(0, 4).map((e16) => e16.trim()).map(a10), [a10]);
  const c10 = ep.useCallback((e15) => {
    if (e15.some((e16) => uhe(e16.value))) return [Que(n10)];
    if (e15.some((e16) => sK(e16.value))) return XN;
    const t11 = e15.map((e16) => e16.value).map(i10);
    const r11 = t11.every((e16) => t11[0] === e16);
    return r11 ? [t11[0]] : t11;
  }, [n10, i10]);
  const u10 = ep.useCallback((t11, n11, a11) => {
    const { descriptor: i11, defaultValue: s11 } = e14;
    const l11 = __spreadProps(__spreadValues({}, e14), { value: sK(t11) ? t11.toString() : t11.join(" "), onValidate: (e15) => {
      const t12 = fc(r10, e15);
      const { isValid: n12 } = FJ(t12, { descriptor: i11, defaultValue: s11, validationContext: o10, expressionSyntax: r10 });
      return n12 || a11(e15);
    }, onChange: n11, generatePreview: Array.isArray(t11) && t11.length > 1 ? () => {
      return (e15 = t11) ? tp.createElement("div", { className: lhe }, e15.map((e16, t12) => "string" == typeof e16 ? tp.createElement("span", { key: che(t12.toString()), style: { backgroundColor: e16 } }) : null)) : null;
      var e15;
    } : void 0 });
    return tp.createElement(ohe, __spreadValues({}, l11));
  }, [r10, e14, o10]);
  const d10 = ep.useCallback((e15) => tp.createElement(ihe, __spreadValues({}, e15)), []);
  const p10 = __spreadProps(__spreadValues({}, e14), { createSideEditor: d10, createMainEditor: u10, splitMainValue: l10, combineMainValue: c10, validateSingleValue: s10 });
  return tp.createElement(vse, __spreadValues({}, p10));
};
dhe.displayName = "ColorExprEditorSide";
const phe = (e14) => {
  const { descriptor: t10, value: n10, setProperty: r10 } = e14;
  const o10 = __spreadProps(__spreadValues({}, e14), { value: n10 || [], reordering: { type: "drag" }, createEditor: (e15, n11) => {
    const o11 = { descriptor: $N("", "", "color_expr", `${t10.valuePath}.${n11}`), value: e15, defaultValue: "Black", setProperty: r10 };
    return tp.createElement(rhe, __spreadValues({}, o11));
  }, onAdd: () => r10(t10, AV(n10 || [], { $push: ["Black"] })), onDelete: (e15) => r10(t10, AV(n10, { $splice: [[e15, 1]] })) });
  return tp.createElement(Bde, __spreadValues({}, o10));
};
const [mhe, , hhe] = Dp("wd-length-expr-editor");
const [fhe] = hhe("input");
const ghe = kde((e14) => {
  const { disabled: t10, descriptor: n10, value: r10, defaultValue: o10, setProperty: a10 } = e14;
  const { type: i10, meta: s10 } = n10;
  const { t: l10 } = vp();
  const c10 = ep.useContext(Vue);
  const { expressionSyntax: u10, validationContext: d10, units: p10 } = c10;
  const m10 = sK(r10);
  const { inputValue: h10, inputValid: f10, inputDirty: g10, setInputValid: y10, setInputValue: v10, setInputDirty: b10, resetInputValue: S10, onInputChange: C10, initInputValue: x10, initInputValid: w10 } = sse(r10, (e15) => m10 ? "" : HJ(e15, i10, { expressionSyntax: u10, units: p10 }, s10, String(r10 != null ? r10 : "")), (e15) => {
    if (e15 === o10 || m10 && !e15) return zY.success();
    return FJ(fc(u10, e15), { descriptor: n10, defaultValue: o10, validationContext: d10, expressionSyntax: u10, units: p10 });
  });
  ep.useEffect(() => {
    v10(x10), y10(w10), b10(false);
  }, [r10, m10, x10, w10]);
  const T10 = () => {
    if (S10(), !f10 || m10 && !g10 && !h10) return;
    const e15 = NJ(h10, n10.type, { expressionSyntax: u10, units: p10 }, n10.meta, r10);
    e15 !== r10 && (a10(n10, e15), v10(e15));
  };
  const E10 = { disabled: t10, size: "small", value: h10, invalid: !f10, onChange: C10, onBlur: T10, onKeyDown: Rie(T10, S10), customCSS: fhe, placeholder: Vie(m10, l10), width: "100%" };
  return tp.createElement("div", { className: mhe }, tp.createElement(KF, __spreadValues({}, E10)));
});
ghe.displayName = "LengthExprEditor";
const yhe = _D(ghe);
const vhe = HD(ghe);
const bhe = (e14) => {
  const { disabled: t10, descriptor: n10 } = e14;
  const { lockLayout: r10 } = Uae();
  const o10 = PA();
  const a10 = h9();
  const { path: i10 } = vj(a10).filter((e15) => sj(e15.item))[0];
  const s10 = Eee(a10, i10);
  const l10 = __spreadProps(__spreadValues({}, e14), { descriptor: BY(n10.category, n10.label, "length", n10.valuePath, n10.mode, n10.meta), setProperty: (e15, t11) => {
    o10(d2({ descriptor: n10, value: t11, isItemInFixedArea: s10 }));
  }, disabled: t10 || r10 });
  return tp.createElement(dse, __spreadValues({}, l10));
};
bhe.displayName = "LengthLocSizeEditor";
const She = _D(bhe);
const Che = (e14) => {
  const { expressionSyntax: t10, validationContext: n10 } = ep.useContext(Vue);
  const { userPreferences: { units: r10 } } = MO();
  const { t: o10 } = vp("propertyEditors");
  const { nestedDescriptors: a10 } = e14;
  const i10 = (e15, n11) => NJ(e15, a10[n11].type, { expressionSyntax: t10, units: r10 }, a10[n11].meta, e15);
  const s10 = (e15, n11) => HJ(e15, a10[n11].type, { expressionSyntax: t10, units: r10 }, a10[n11].meta, e15);
  let l10 = false;
  const c10 = __spreadProps(__spreadValues({}, e14), { createSideEditor: (e15) => tp.createElement(vhe, __spreadValues({}, e15)), createMainEditor: (t11, n11, r11) => {
    const a11 = __spreadProps(__spreadValues({}, e14), { value: t11, validate: (e15) => !(!l10 || "" !== e15) || r11(e15), onChange: (e15, t12) => l10 && "" === t12 || n11(t12), placeholderEmpty: l10 ? o10("common.textExpression") : "" });
    return tp.createElement(Sse, __spreadValues({}, a11));
  }, splitMainValue: (e15) => "string" != typeof e15 ? [""] : gc(t10, e15) ? [e15].map(i10) : e15.trim().split(" ").slice(0, 4).map((e16) => e16.trim()).map(i10), combineMainValue: (e15) => {
    if (l10 = e15.some((e16) => jue(e16.value)), l10) return "";
    if (e15.some((e16) => sK(e16.value))) return XN;
    const t11 = e15.map((e16) => e16.value).map(s10);
    const n11 = t11.every((e16) => t11[0] === e16);
    return n11 ? t11[0] : t11.join(" ");
  }, validateSingleValue: (e15, t11, o11) => {
    const a11 = fc("rdl", e15);
    const { isValid: i11 } = FJ(a11, { descriptor: o11, defaultValue: t11, validationContext: n10, expressionSyntax: "rdl", units: r10 });
    return i11;
  } });
  return tp.createElement(vse, __spreadValues({}, c10));
};
Che.displayName = "LengthExprEditorSide";
const xhe = (e14) => {
  const { descriptor: { type: t10, meta: n10 } } = e14;
  const { expressionSyntax: r10 } = ep.useContext(Vue);
  return tp.createElement(lue, __spreadProps(__spreadValues({}, e14), { toDisplayValue: (e15) => HJ(e15, t10, { expressionSyntax: r10 }, n10, e15) }));
};
xhe.displayName = "LineStyleExprEditor";
const whe = kde(xhe);
const The = _D(whe);
const Ehe = HD(whe);
const Fhe = (e14) => {
  const { descriptor: t10, nestedDescriptors: n10 } = e14;
  const { t: r10 } = vp("propertyEditors");
  const { expressionSyntax: o10 } = ep.useContext(Vue);
  const { selectedItemsInfo: a10 } = ep.useContext(Rue);
  const { instanceId: i10 } = Uae();
  const s10 = (e15, t11) => NJ(e15, n10[t11].type, { expressionSyntax: o10 }, n10[t11].meta, e15);
  const l10 = ep.useMemo(() => a10.map((e15) => e15.type), [a10]);
  const c10 = eK.of(i10).getBorderStyles(l10);
  const u10 = __spreadProps(__spreadValues({}, e14), { createSideEditor: (e15) => tp.createElement(Ehe, __spreadProps(__spreadValues({}, e15), { availableBorderStyles: c10 })), createMainEditor: (t11, n11) => {
    const r11 = __spreadProps(__spreadValues({}, e14), { value: t11, setProperty: (e15, t12) => n11(t12), availableBorderStyles: c10 });
    return tp.createElement(cue, __spreadValues({}, r11));
  }, splitMainValue: (e15) => "string" != typeof e15 ? [""] : e15.trim().split(" ").map((e16) => e16.trim()).map(s10), combineMainValue: (e15) => {
    if (e15.some((e16) => jue(e16.value))) return r10("common.textExpression");
    if (e15.some((e16) => sK(e16.value))) return XN;
    const n11 = e15.map((e16) => {
      return (n12 = e16.value) ? RO(t10.type, n12, r10) : "None";
      var n12;
    });
    const o11 = n11.every((e16) => n11[0] === e16);
    return o11 ? n11[0] : n11.join(" ");
  } });
  return tp.createElement(vse, __spreadValues({}, u10));
};
Fhe.displayName = "LineStyleEditorSide";
const Mhe = (e14) => `border.${e14}`;
const khe = Mhe("left");
const Phe = Mhe("top");
const Nhe = Mhe("right");
const Dhe = Mhe("bottom");
const Lhe = Mhe("default");
const Hhe = "borderColor", Ihe = "borderStyle", _he = "borderWidth";
const Vhe = [Zq(_he, khe, "length_expr", "LeftBorder.Width", void 0, qq.borderWidthWithEmptyValue), Zq(_he, Phe, "length_expr", "TopBorder.Width", void 0, qq.borderWidthWithEmptyValue), Zq(_he, Nhe, "length_expr", "RightBorder.Width", void 0, qq.borderWidthWithEmptyValue), Zq(_he, Dhe, "length_expr", "BottomBorder.Width", void 0, qq.borderWidthWithEmptyValue), Zq(_he, Lhe, "length_expr", "Border.Width", void 0, qq.borderWidth)];
const Rhe = [Zq(Ihe, khe, "border_style", "LeftBorder.Style", void 0, { enumKey: "border_style", allowEmpty: true }), Zq(Ihe, Phe, "border_style", "TopBorder.Style", void 0, { enumKey: "border_style", allowEmpty: true }), Zq(Ihe, Nhe, "border_style", "RightBorder.Style", void 0, { enumKey: "border_style", allowEmpty: true }), Zq(Ihe, Dhe, "border_style", "BottomBorder.Style", void 0, { enumKey: "border_style", allowEmpty: true }), Zq(Ihe, Lhe, "border_style", "Border.Style", void 0, { enumKey: "border_style" })];
const Ahe = [Zq(Hhe, khe, "color_expr", "LeftBorder.Color", void 0, { allowEmpty: true }), Zq(Hhe, Phe, "color_expr", "TopBorder.Color", void 0, { allowEmpty: true }), Zq(Hhe, Nhe, "color_expr", "RightBorder.Color", void 0, { allowEmpty: true }), Zq(Hhe, Dhe, "color_expr", "BottomBorder.Color", void 0, { allowEmpty: true }), Zq(Hhe, Lhe, "color_expr", "Border.Color")];
const Ohe = (e14) => {
  const { descriptor: t10 } = e14;
  const n10 = __spreadProps(__spreadValues({}, t10), { label: "propertyDescriptors:labels.border.width" });
  const r10 = __spreadProps(__spreadValues({}, t10), { label: "propertyDescriptors:labels.border.style", type: "border_style", meta: { enumKey: "border_style" } });
  const o10 = __spreadProps(__spreadValues({}, t10), { label: "propertyDescriptors:labels.border.color", type: "color_expr" });
  const a10 = __spreadProps(__spreadValues({}, e14), { nestedDescriptors: Vhe.map((e15) => Kue(e15, n10)), descriptor: n10 });
  const i10 = __spreadProps(__spreadValues({}, e14), { nestedDescriptors: Rhe.map((e15) => Kue(e15, r10)), descriptor: r10 });
  const s10 = __spreadProps(__spreadValues({}, e14), { nestedDescriptors: Ahe.map((e15) => Kue(e15, o10)), descriptor: o10 });
  return tp.createElement(tp.Fragment, null, tp.createElement(Che, __spreadValues({}, a10)), tp.createElement(Fhe, __spreadValues({}, i10)), tp.createElement(dhe, __spreadValues({}, s10)));
};
Ohe.displayName = "BorderEditor";
const Bhe = (e14) => `roundingRadius.${e14}`;
const zhe = { allowEmptyString: true };
const $he = [Zq("borderRoundingRadius", Bhe("topLeft"), "length_expr", "TopLeft", void 0, zhe), Zq("borderRoundingRadius", Bhe("topRight"), "length_expr", "TopRight", void 0, zhe), Zq("borderRoundingRadius", Bhe("bottomLeft"), "length_expr", "BottomLeft", void 0, zhe), Zq("borderRoundingRadius", Bhe("bottomRight"), "length_expr", "BottomRight", void 0, zhe), Zq("borderRoundingRadius", Bhe("default"), "length_expr", "Default", void 0, zhe)];
const Whe = (e14) => {
  const { descriptor: t10 } = e14;
  const n10 = rf(Hh);
  const r10 = rf(Hh, { rotate: "90" });
  const o10 = rf(Hh, { rotate: "180" });
  const a10 = rf(Hh, { rotate: "270" });
  const i10 = __spreadProps(__spreadValues({}, e14), { nestedDescriptors: $he.map((e15) => Kue(e15, t10)), descriptor: t10, sideIcons: { left: n10, top: r10, right: a10, bottom: o10 } });
  return tp.createElement(Che, __spreadProps(__spreadValues({}, i10), { shouldUpdate: true }));
};
Whe.displayName = "CornerEditor";
const jhe = (e14) => {
  const { dataSets: t10 } = ep.useContext(Vue);
  const n10 = __spreadProps(__spreadValues({}, e14), { currentEnum: t10.map((e15) => ({ label: e15.Name, value: e15.Name })) });
  return tp.createElement($ue, __spreadValues({}, n10));
};
jhe.displayName = "DataSetNameEditor";
const Zhe = _D(jhe);
const Ghe = ({ value: e14, setProperty: t10, descriptor: n10 }) => {
  const r10 = { icon: rf(dh), size: "small", accent: "icon" };
  return tp.createElement("div", { style: { display: "flex", flexDirection: "column", gap: "4px" } }, Array.isArray(e14) && e14.map((e15) => tp.createElement(qm, __spreadProps(__spreadValues({}, r10), { text: e15, key: e15, onClick: () => t10(n10, e15) }))));
};
Ghe.displayName = "DataSetNestedDataSetsEditor";
const Uhe = _D(Ghe);
const [qhe] = Dp("wd-multiline-editor");
const [Yhe] = Dp("wd-textarea");
const Khe = _D((e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { value: n10, descriptor: r10, setProperty: o10 } = e14;
  const { expressionSyntax: a10 } = ep.useContext(Vue);
  const [i10, s10] = ep.useState(HJ(n10, r10.type, { expressionSyntax: a10 }));
  const l10 = { placeholder: t10("dataSetQuery.placeholder", "enter query here..."), onChange: ({ target: { value: e15 } }) => {
    s10(e15);
  }, onKeyUp: ({ keyCode: e15 }) => {
    27 === e15 && s10(n10);
  }, onBlur: ({ target: { value: e15 } }) => {
    const t11 = NJ(e15, r10.type, { expressionSyntax: a10 });
    t11 !== n10 && o10(r10, t11);
  }, value: i10, width: "100%", height: "100%", customCSS: Yhe, rows: 5, resize: "vertical" };
  return tp.createElement("div", { className: qhe }, tp.createElement(zN, __spreadValues({}, l10)));
});
const [Xhe] = Dp("wd-dv-preview-container");
const [Jhe, Qhe, efe] = Dp("wd-dv-preview");
const tfe = (e14 = "", t10 = "", n10) => {
  if ("transparent" === e14.toLowerCase()) return "#00000000";
  if (e14.startsWith("=")) return t10;
  try {
    const r10 = Sme(e14, n10);
    if (!r10) return t10;
    return dm.fromString(r10).hex;
  } catch (e15) {
    return t10;
  }
};
const nfe = (e14 = "", t10) => {
  const n10 = parseFloat(e14);
  return Number.isNaN(n10) ? parseFloat(t10 || "") : n10;
};
const rfe = (e14) => `calc(${e14} * 100%)`;
const ofe = { Horizontal: "to right", Vertical: "to bottom", DiagonalUp: "to top right", DiagonalDown: "to bottom right", FromCenter: "to right", FromCorner: "to right" };
const afe = ({ MinimumColor: e14, MaximumColor: t10, MiddleColor: n10, gradientType: r10, defaults: o10, theme: a10 }) => {
  const i10 = tfe(e14, o10.MinimumColor, a10);
  const s10 = tfe(t10, o10.MaximumColor, a10);
  const l10 = n10 ? tfe(n10, o10.MiddleColor, a10) : "";
  const c10 = e14 ? ` ${"FromCorner" !== r10 ? i10 : s10} 0%, ` : "";
  const u10 = n10 ? ` ${l10} 50%, ` : "";
  const d10 = t10 ? ` ${"FromCorner" !== r10 ? s10 : i10} 100% ` : "";
  const p10 = ["FromCenter", "FromCorner"].includes(r10);
  const m10 = `${p10 ? "radial-gradient" : "linear-gradient"}(${p10 ? "circle" : ofe[r10]}, ${c10} ${u10} ${d10})`;
  const h10 = kp(Jhe, Qhe("gradient"));
  return tp.createElement("div", { className: h10, style: { backgroundImage: m10 }, "data-aid": "preview-color-scale" });
};
const [ife] = efe("data-bar");
const sfe = (e14) => {
  const { Color: t10, UseAlternateColor: n10, AlternateColor: r10, defaults: o10, theme: a10 } = e14;
  const [i10, s10, l10, c10] = ["Minimum", "Maximum", "Value", "ZeroValue"].map((t11) => nfe(e14[t11], o10[t11]));
  if (s10 <= i10) return tp.createElement("div", { className: Jhe });
  const u10 = s10 - i10;
  const d10 = l10 < c10;
  const p10 = Math.abs(l10 - c10) / u10;
  const m10 = (c10 - i10 + Math.min(l10 - c10, 0)) / u10;
  const h10 = { backgroundColor: tfe(d10 && n10 ? r10 : t10, "Green", a10), width: rfe(p10), left: rfe(m10) };
  return tp.createElement("div", { className: Jhe, "data-aid": "preview-data-bar" }, tp.createElement("div", { className: ife, style: h10 }));
};
const lfe = ({ GradientType: e14, Color1: t10, Color2: n10, defaults: r10, theme: o10 }) => {
  const a10 = tfe(t10, r10.Color1, o10);
  const i10 = tfe(n10, r10.Color2, o10);
  const s10 = t10 ? ` ${"FromCorner" !== e14 ? a10 : i10} 0%, ` : "";
  const l10 = n10 ? ` ${"FromCorner" !== e14 ? i10 : a10} 100% ` : "";
  const c10 = ["FromCenter", "FromCorner"].includes(e14);
  const u10 = `${c10 ? "radial-gradient" : "linear-gradient"}(${c10 ? "circle" : ofe[e14]}, ${s10} ${l10})`;
  const d10 = kp(Jhe, Qhe("gradient"));
  return tp.createElement("div", { className: d10, style: { backgroundImage: u10 }, "data-aid": "preview-gradient" });
};
const cfe = ({ HatchStyle: e14, Color1: t10, Color2: n10, defaults: r10, theme: o10 }) => {
  const a10 = tfe(t10, r10.Color1, o10);
  const i10 = tfe(n10, r10.Color2, o10);
  const s10 = Xce(e14, i10, a10);
  return tp.createElement("div", { className: Jhe, style: s10, "data-aid": "preview-hatch" });
};
const [ufe] = efe("bar");
const [dfe] = efe("progress-line");
const pfe = (e14) => {
  const { Color: t10, DisplayProgressIndicator: n10, Length: r10, ProgressIndicatorLength: o10, ProgressIndicatorColor: a10, defaults: i10, theme: s10 } = e14;
  const l10 = kp(Jhe, Qhe("range-bar"));
  const [c10, u10, d10] = ["Minimum", "Maximum", "StartingValue"].map((t11) => nfe(e14[t11], i10[t11]));
  if (u10 <= c10) return tp.createElement("div", { className: l10 });
  const p10 = u10 - c10;
  const m10 = Math.max(d10 - c10, 0) / p10;
  const h10 = nfe(r10, i10.Length) / p10;
  const f10 = nfe(o10, i10.ProgressIndicatorLength) / p10;
  const g10 = f10 < 0 ? m10 - Math.abs(f10) : m10;
  const y10 = { backgroundColor: tfe(t10, i10.Color, s10), left: rfe(m10), width: rfe(h10) };
  const v10 = { backgroundColor: tfe(a10, i10.ProgressIndicatorColor || "", s10), left: rfe(g10), width: 0 !== f10 ? rfe(Math.abs(f10)) : "15px" };
  return 0 === f10 && (v10.transform = "rotate(45deg)", v10.transformOrigin = "left top", v10.height = "15px"), tp.createElement("div", { className: l10, "data-aid": "preview-range-bar" }, tp.createElement("div", { className: ufe, style: y10 }), n10 && tp.createElement("div", { className: dfe, style: v10 }));
};
const mfe = (e14) => {
  const { type: t10, theme: n10 } = e14;
  let r10;
  switch (t10) {
    case ade.COLOR_SCALE: {
      const t11 = e14;
      const { MiddleColor: o10, UseMiddleColor: a10, defaults: i10 } = t11;
      r10 = tp.createElement(afe, __spreadProps(__spreadValues({}, t11), { gradientType: "Horizontal", MiddleColor: a10 ? o10 : void 0, defaults: i10, theme: n10 }));
      break;
    }
    case ade.GRADIENT: {
      const t11 = e14;
      const { GradientType: o10, defaults: a10 } = t11;
      r10 = tp.createElement(lfe, __spreadProps(__spreadValues({}, t11), { defaults: { GradientType: o10, Color1: a10.Color1, Color2: a10.Color2 }, theme: n10 }));
      break;
    }
    case ade.RANGE_BAR: {
      const t11 = e14;
      r10 = tp.createElement(pfe, __spreadProps(__spreadValues({}, t11), { defaults: t11.defaults, theme: n10 }));
      break;
    }
    case ade.DATA_BAR: {
      const t11 = e14;
      r10 = tp.createElement(sfe, __spreadProps(__spreadValues({}, t11), { defaults: t11.defaults, theme: n10 }));
      break;
    }
    case ade.HATCH: {
      const t11 = e14;
      r10 = tp.createElement(cfe, __spreadProps(__spreadValues({}, t11), { defaults: t11.defaults, theme: n10 }));
      break;
    }
    default:
      r10 = tp.createElement("div", null);
  }
  return tp.createElement("div", { className: Xhe }, r10);
};
const hfe = (e14) => `propertyDescriptors:labels.dataVisualizer.colorScale.${e14}`;
const ffe = $N("", hfe("value"), "string_expr", "Value");
const gfe = $N("", hfe("minimum"), "string_expr", "Minimum");
const yfe = $N("", hfe("minimumColor"), "color_expr", "MinimumColor");
const vfe = $N("", hfe("useMiddleColor"), "boolean", "UseMiddleColor");
const bfe = $N("", hfe("middle"), "string_expr", "Middle");
const Sfe = $N("", hfe("middleColor"), "color_expr", "MiddleColor");
const Cfe = $N("", hfe("maximum"), "string_expr", "Maximum");
const xfe = $N("", hfe("maximumColor"), "color_expr", "MaximumColor");
const wfe = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { theme: n10 } = ep.useContext(Aue);
  const { value: r10, value: { UseMiddleColor: o10 }, defaultValue: a10 } = e14;
  return tp.createElement(tp.Fragment, null, tp.createElement(mfe, __spreadProps(__spreadValues({}, r10), { theme: n10, defaults: a10, type: "colorScale" })), tp.createElement(Hie, __spreadValues({}, Xue(e14, vfe, t10))), tp.createElement(Hpe, __spreadValues({}, Xue(e14, ffe, t10))), tp.createElement(Hpe, __spreadValues({}, Xue(e14, gfe, t10))), tp.createElement(ahe, __spreadValues({}, Xue(e14, yfe, t10))), o10 && tp.createElement(Hpe, __spreadValues({}, Xue(e14, bfe, t10))), o10 && tp.createElement(ahe, __spreadValues({}, Xue(e14, Sfe, t10))), tp.createElement(Hpe, __spreadValues({}, Xue(e14, Cfe, t10))), tp.createElement(ahe, __spreadValues({}, Xue(e14, xfe, t10))));
};
const [Tfe, , Efe] = Dp("wd-gradient-style-editor");
const [Ffe] = Efe("preview-box");
const Mfe = (e14) => {
  if (sK(e14)) return null;
  const t10 = Jce(e14, "transparent", "black");
  return tp.createElement("div", { className: Ffe, style: t10 });
};
const kfe = (e14) => {
  const { descriptor: t10 } = e14;
  const { enumKey: n10 } = t10.meta;
  const { t: r10 } = vp();
  const o10 = OO(n10, r10);
  const a10 = ep.useCallback((e15) => {
    const t11 = o10.find((t12) => t12.label === e15);
    return t11 ? Mfe(t11.value) : null;
  }, [o10]);
  const i10 = __spreadProps(__spreadValues({}, e14), { customCSS: Tfe, generatePreview: a10, generateItemPreview: Mfe });
  return tp.createElement(tse, __spreadValues({}, i10));
};
kfe.displayName = "GradientStyleEditor";
const Pfe = _D(kfe);
const Nfe = (e14) => `propertyDescriptors:labels.dataVisualizer.gradient.${e14}`;
const Dfe = $N("", Nfe("gradientType"), "enum", "GradientType", void 0, { enumKey: "data_visualizer_gradient_type" });
const Lfe = $N("", Nfe("color1"), "color_expr", "Color1");
const Hfe = $N("", Nfe("color2"), "color_expr", "Color2");
const Ife = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { theme: n10 } = ep.useContext(Aue);
  const { value: r10, defaultValue: o10 } = e14;
  return tp.createElement(tp.Fragment, null, tp.createElement(mfe, __spreadProps(__spreadValues({}, r10), { theme: n10, defaults: o10, type: "gradient" })), tp.createElement(Pfe, __spreadValues({}, Xue(e14, Dfe, t10))), tp.createElement(ahe, __spreadValues({}, Xue(e14, Lfe, t10))), tp.createElement(ahe, __spreadValues({}, Xue(e14, Hfe, t10))));
};
const _fe = (e14) => `propertyDescriptors:labels.dataVisualizer.rangeBar.${e14}`;
const Vfe = $N("", _fe("minimum"), "string_expr", "Minimum");
const Rfe = $N("", _fe("maximum"), "string_expr", "Maximum");
const Afe = $N("", _fe("startingValue"), "string_expr", "StartingValue");
const Ofe = $N("", _fe("length"), "string_expr", "Length");
const Bfe = $N("", _fe("color"), "color_expr", "Color");
const zfe = $N("", _fe("displayProgressIndicator"), "boolean", "DisplayProgressIndicator");
const $fe = $N("", _fe("progressIndicatorLength"), "string_expr", "ProgressIndicatorLength");
const Wfe = $N("", _fe("progressIndicatorColor"), "color_expr", "ProgressIndicatorColor");
const jfe = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { theme: n10 } = ep.useContext(Aue);
  const { value: r10, value: { DisplayProgressIndicator: o10 }, defaultValue: a10 } = e14;
  return tp.createElement(tp.Fragment, null, tp.createElement(mfe, __spreadProps(__spreadValues({}, r10), { theme: n10, defaults: a10, type: "rangeBar" })), tp.createElement(Hpe, __spreadValues({}, Xue(e14, Vfe, t10))), tp.createElement(Hpe, __spreadValues({}, Xue(e14, Rfe, t10))), tp.createElement(Hpe, __spreadValues({}, Xue(e14, Afe, t10))), tp.createElement(Hpe, __spreadValues({}, Xue(e14, Ofe, t10))), tp.createElement(ahe, __spreadValues({}, Xue(e14, Bfe, t10))), tp.createElement(Hie, __spreadValues({}, Xue(e14, zfe, t10))), o10 && tp.createElement(Hpe, __spreadValues({}, Xue(e14, $fe, t10))), o10 && tp.createElement(ahe, __spreadValues({}, Xue(e14, Wfe, t10))));
};
const Zfe = (e14) => `propertyDescriptors:labels.dataVisualizer.dataBar.${e14}`;
const Gfe = $N("", Zfe("value"), "string_expr", "Value");
const Ufe = $N("", Zfe("minimum"), "string_expr", "Minimum");
const qfe = $N("", Zfe("zeroValue"), "string_expr", "ZeroValue");
const Yfe = $N("", Zfe("maximum"), "string_expr", "Maximum");
const Kfe = $N("", Zfe("color"), "color_expr", "Color");
const Xfe = $N("", Zfe("useAlternateColor"), "boolean", "UseAlternateColor");
const Jfe = $N("", Zfe("alternateColor"), "color_expr", "AlternateColor");
const Qfe = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { theme: n10 } = ep.useContext(Aue);
  const { value: r10, value: { UseAlternateColor: o10 }, defaultValue: a10 } = e14;
  return tp.createElement(tp.Fragment, null, tp.createElement(mfe, __spreadProps(__spreadValues({}, r10), { theme: n10, defaults: a10, type: "dataBar" })), tp.createElement(Hpe, __spreadValues({}, Xue(e14, Gfe, t10))), tp.createElement(Hpe, __spreadValues({}, Xue(e14, Ufe, t10))), tp.createElement(Hpe, __spreadValues({}, Xue(e14, qfe, t10))), tp.createElement(Hpe, __spreadValues({}, Xue(e14, Yfe, t10))), tp.createElement(ahe, __spreadValues({}, Xue(e14, Kfe, t10))), tp.createElement(Hie, __spreadValues({}, Xue(e14, Xfe, t10))), o10 && tp.createElement(ahe, __spreadValues({}, Xue(e14, Jfe, t10))));
};
const [ege, , tge] = Dp("wd-hatch-style-editor");
const [nge] = tge("preview-box");
const rge = (e14) => {
  if (sK(e14)) return null;
  const t10 = Xce(e14, "transparent", "black");
  return tp.createElement("div", { className: nge, style: t10 });
};
const oge = (e14) => {
  const { descriptor: t10 } = e14;
  const { enumKey: n10 } = t10.meta;
  const { t: r10 } = vp();
  const o10 = OO(n10, r10);
  const a10 = ep.useCallback((e15) => {
    const t11 = o10.find((t12) => t12.label === e15);
    return t11 ? rge(t11.value) : null;
  }, [o10]);
  const i10 = __spreadProps(__spreadValues({}, e14), { customCSS: ege, generatePreview: a10, generateItemPreview: rge });
  return tp.createElement(tse, __spreadValues({}, i10));
};
oge.displayName = "HatchStyleEditor";
const age = _D(oge);
const ige = (e14) => `propertyDescriptors:labels.dataVisualizer.hatch.${e14}`;
const sge = $N("", ige("hatchStyle"), "enum", "HatchStyle", void 0, { enumKey: "data_visualizer_hatch_style" });
const lge = $N("", ige("color1"), "color_expr", "Color1");
const cge = $N("", ige("color2"), "color_expr", "Color2");
const uge = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { theme: n10 } = ep.useContext(Aue);
  const { value: r10, defaultValue: o10 } = e14;
  return tp.createElement(tp.Fragment, null, tp.createElement(mfe, __spreadProps(__spreadValues({}, r10), { theme: n10, defaults: o10, type: "hatch" })), tp.createElement(age, __spreadValues({}, Xue(e14, sge, t10))), tp.createElement(ahe, __spreadValues({}, Xue(e14, lge, t10))), tp.createElement(ahe, __spreadValues({}, Xue(e14, cge, t10))));
};
const dge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("radialGradient", { id: "Symbols11_a", cx: "11", cy: "12.96", r: "8.5", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0.22", stopColor: "#93ce90" }), tp.createElement("stop", { offset: "0.28", stopColor: "#88ca8a" }), tp.createElement("stop", { offset: "0.46", stopColor: "#6bbf7a" }), tp.createElement("stop", { offset: "0.65", stopColor: "#56b76e" }), tp.createElement("stop", { offset: "0.83", stopColor: "#49b367" }), tp.createElement("stop", { offset: "1", stopColor: "#45b165" }))), tp.createElement("path", { d: "M11,4.5A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z", fill: "url(#Symbols11_a)" }), tp.createElement("path", { fill: "#225f1e", d: "M11,5.5A7.5,7.5,0,1,1,3.5,13,7.51,7.51,0,0,1,11,5.5m0-1A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z" }), tp.createElement("polygon", { fill: "#fff", points: "16 9.17 10 15.17 7 12.18 7 15 10 18 16 12 16 9.17" }));
const pge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("linearGradient", { id: "Symbols12_a", x1: "2.5", y1: "13", x2: "19.5", y2: "13", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0.05", stopColor: "#f2bd04" }), tp.createElement("stop", { offset: "0.42", stopColor: "#f2b90b" }), tp.createElement("stop", { offset: "0.96", stopColor: "#f2af1f" }), tp.createElement("stop", { offset: "1", stopColor: "#f2ae21" }))), tp.createElement("path", { d: "M11,4.5A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z", fill: "url(#Symbols12_a)" }), tp.createElement("path", { d: "M11,5.5A7.5,7.5,0,1,1,3.5,13,7.51,7.51,0,0,1,11,5.5m0-1A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z", fill: "#cf7a10" }), tp.createElement("path", { d: "M12.28,16.15a1.09,1.09,0,0,1-.38.86,1.47,1.47,0,0,1-1,.33,1.47,1.47,0,0,1-1-.34,1.08,1.08,0,0,1-.39-.85,1,1,0,0,1,.38-.83,1.52,1.52,0,0,1,1-.32,1.52,1.52,0,0,1,1,.32A1,1,0,0,1,12.28,16.15Zm-.4-2.08h-2L9.56,8.5h2.63Z", fill: "#fff" }));
const mge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("linearGradient", { id: "Symbols13_a", x1: "2.5", y1: "13", x2: "19.5", y2: "13", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0", stopColor: "#ff9084" }), tp.createElement("stop", { offset: "0.24", stopColor: "#fd8a7d" }), tp.createElement("stop", { offset: "0.59", stopColor: "#f87869" }), tp.createElement("stop", { offset: "1", stopColor: "#ef5d49" }))), tp.createElement("circle", { cx: "11", cy: "13", r: "8.5", fill: "url(#Symbols13_a)" }), tp.createElement("path", { d: "M11,5.5A7.5,7.5,0,1,1,3.5,13,7.51,7.51,0,0,1,11,5.5m0-1A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z", fill: "#902a1a" }), tp.createElement("path", { d: "M12.45,13l2.47-2.47a.5.5,0,0,0,0-.71l-.71-.71a.5.5,0,0,0-.71,0L11,11.62,8.56,9.15a.5.5,0,0,0-.71,0l-.71.71a.5.5,0,0,0,0,.71L9.62,13,7.15,15.51a.5.5,0,0,0,0,.71l.71.71a.5.5,0,0,0,.71,0L11,14.45l2.47,2.47a.5.5,0,0,0,.71,0l.71-.71a.5.5,0,0,0,0-.71Z", fill: "#fff" }));
const hge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("polygon", { points: "18 7.17 10 15.17 5 10.18 5 14 10 19 18 11 18 7.17", fill: "#55bd78" }));
const fge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M13.5,18A2,2,0,0,1,13,19.43,1.91,1.91,0,0,1,11.5,20a1.92,1.92,0,0,1-1.44-.58A2,2,0,0,1,9.5,18,1.93,1.93,0,0,1,10,16.55,2,2,0,0,1,11.5,16a2,2,0,0,1,1.44.55A1.91,1.91,0,0,1,13.5,18Zm-.34-3H9.85L9.5,5h4Z", fill: "#fc9c03" }));
const gge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M13.88,12.53l3.47-3.47a.5.5,0,0,0,0-.71L15.65,6.65a.5.5,0,0,0-.71,0l-3.47,3.47L8,6.65a.5.5,0,0,0-.71,0L5.58,8.35a.5.5,0,0,0,0,.71l3.47,3.47L5.58,16a.5.5,0,0,0,0,.71l1.71,1.71a.5.5,0,0,0,.71,0l3.47-3.47,3.47,3.47a.5.5,0,0,0,.71,0l1.71-1.71a.5.5,0,0,0,0-.71Z", fill: "#f03d2a" }));
const yge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("radialGradient", { id: "3TrafficLights1_a", cx: "8.12", cy: "10.49", r: "9.77", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0.03", stopColor: "#d7ecd6" }), tp.createElement("stop", { offset: "0.07", stopColor: "#d0e9cf" }), tp.createElement("stop", { offset: "0.12", stopColor: "#bce0bb" }), tp.createElement("stop", { offset: "0.19", stopColor: "#9dd29a" }), tp.createElement("stop", { offset: "0.21", stopColor: "#93ce90" }), tp.createElement("stop", { offset: "0.25", stopColor: "#8bcb8a" }), tp.createElement("stop", { offset: "0.6", stopColor: "#4aae5b" }), tp.createElement("stop", { offset: "0.76", stopColor: "#31a349" }), tp.createElement("stop", { offset: "1", stopColor: "#6ac14b" })), tp.createElement("radialGradient", { id: "3TrafficLights1_b", cx: "4.71", cy: "7.22", r: "13.26", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0.03", stopColor: "#928f8f" }), tp.createElement("stop", { offset: "0.04", stopColor: "#8e8c8c" }), tp.createElement("stop", { offset: "0.09", stopColor: "#767373" }), tp.createElement("stop", { offset: "0.16", stopColor: "#636060" }), tp.createElement("stop", { offset: "0.23", stopColor: "#555353" }), tp.createElement("stop", { offset: "0.33", stopColor: "#4d4b4b" }), tp.createElement("stop", { offset: "0.5", stopColor: "#4b4949" }), tp.createElement("stop", { offset: "0.75", stopColor: "#363434" }), tp.createElement("stop", { offset: "1" }))), tp.createElement("circle", { cx: "11", cy: "13", r: "6.26", fill: "url(#3TrafficLights1_a)" }), tp.createElement("path", { d: "M11,4.5A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Zm0,15A6.49,6.49,0,1,1,17.49,13,6.49,6.49,0,0,1,11,19.49Z", fill: "url(#3TrafficLights1_b)" }));
const vge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("radialGradient", { id: "3TrafficLights2_a", cx: "8.12", cy: "10.49", r: "9.77", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0.03", stopColor: "#fdfadf" }), tp.createElement("stop", { offset: "0.05", stopColor: "#fdf9d8" }), tp.createElement("stop", { offset: "0.09", stopColor: "#fcf4c4" }), tp.createElement("stop", { offset: "0.12", stopColor: "#faeea3" }), tp.createElement("stop", { offset: "0.17", stopColor: "#f7e475" }), tp.createElement("stop", { offset: "0.21", stopColor: "#f5db48" }), tp.createElement("stop", { offset: "0.27", stopColor: "#f5d842" }), tp.createElement("stop", { offset: "0.59", stopColor: "#f3cd2a" }), tp.createElement("stop", { offset: "0.79", stopColor: "#f2c921" }), tp.createElement("stop", { offset: "0.84", stopColor: "#f4d12f" }), tp.createElement("stop", { offset: "0.92", stopColor: "#f8e553" }), tp.createElement("stop", { offset: "1", stopColor: "#fdfa79" })), tp.createElement("radialGradient", { id: "3TrafficLights2_b", cx: "4.71", cy: "7.22", r: "13.26", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0.03", stopColor: "#928f8f" }), tp.createElement("stop", { offset: "0.04", stopColor: "#8e8c8c" }), tp.createElement("stop", { offset: "0.09", stopColor: "#767373" }), tp.createElement("stop", { offset: "0.16", stopColor: "#636060" }), tp.createElement("stop", { offset: "0.23", stopColor: "#555353" }), tp.createElement("stop", { offset: "0.33", stopColor: "#4d4b4b" }), tp.createElement("stop", { offset: "0.5", stopColor: "#4b4949" }), tp.createElement("stop", { offset: "0.75", stopColor: "#363434" }), tp.createElement("stop", { offset: "1" }))), tp.createElement("circle", { cx: "11", cy: "13", r: "6.26", fill: "url(#3TrafficLights2_a)" }), tp.createElement("path", { d: "M11,4.5A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Zm0,15A6.49,6.49,0,1,1,17.49,13,6.49,6.49,0,0,1,11,19.49Z", fill: "url(#3TrafficLights2_b)" }));
const bge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("radialGradient", { id: "3TrafficLights3_a", cx: "8.12", cy: "10.49", r: "9.77", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0.03", stopColor: "#fde7e5" }), tp.createElement("stop", { offset: "0.07", stopColor: "#fce0de" }), tp.createElement("stop", { offset: "0.13", stopColor: "#fbcdca" }), tp.createElement("stop", { offset: "0.2", stopColor: "#f8aea9" }), tp.createElement("stop", { offset: "0.21", stopColor: "#f8aaa5" }), tp.createElement("stop", { offset: "0.22", stopColor: "#f8a6a1" }), tp.createElement("stop", { offset: "0.33", stopColor: "#f57977" }), tp.createElement("stop", { offset: "0.44", stopColor: "#f35655" }), tp.createElement("stop", { offset: "0.55", stopColor: "#f13d3d" }), tp.createElement("stop", { offset: "0.64", stopColor: "#f02e2f" }), tp.createElement("stop", { offset: "0.72", stopColor: "#f0292a" }), tp.createElement("stop", { offset: "0.76", stopColor: "#f02e2f" }), tp.createElement("stop", { offset: "0.81", stopColor: "#f13e3e" }), tp.createElement("stop", { offset: "0.87", stopColor: "#f35756" }), tp.createElement("stop", { offset: "0.93", stopColor: "#f57b78" }), tp.createElement("stop", { offset: "1", stopColor: "#f8a8a3" }), tp.createElement("stop", { offset: "1", stopColor: "#f8aaa5" })), tp.createElement("radialGradient", { id: "3TrafficLights3_b", cx: "4.71", cy: "7.22", r: "13.26", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0.03", stopColor: "#928f8f" }), tp.createElement("stop", { offset: "0.04", stopColor: "#8e8c8c" }), tp.createElement("stop", { offset: "0.09", stopColor: "#767373" }), tp.createElement("stop", { offset: "0.16", stopColor: "#636060" }), tp.createElement("stop", { offset: "0.23", stopColor: "#555353" }), tp.createElement("stop", { offset: "0.33", stopColor: "#4d4b4b" }), tp.createElement("stop", { offset: "0.5", stopColor: "#4b4949" }), tp.createElement("stop", { offset: "0.75", stopColor: "#363434" }), tp.createElement("stop", { offset: "1" }))), tp.createElement("circle", { cx: "11", cy: "13", r: "6.26", fill: "url(#3TrafficLights3_a)" }), tp.createElement("path", { d: "M11,4.5A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Zm0,15A6.49,6.49,0,1,1,17.49,13,6.49,6.49,0,0,1,11,19.49Z", fill: "url(#3TrafficLights3_b)" }));
const Sge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("linearGradient", { id: "Arrows1", x1: "11.5", y1: "4.22", x2: "11.5", y2: "20.49", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0.03", stopColor: "#76c288" }), tp.createElement("stop", { offset: "0.29", stopColor: "#6fbf83" }), tp.createElement("stop", { offset: "0.68", stopColor: "#5bb975" }), tp.createElement("stop", { offset: "1", stopColor: "#45b165" }))), tp.createElement("polygon", { points: "8.5 21.5 8.5 12 3.21 12 11.5 3.71 19.79 12 14.5 12 14.5 21.5 8.5 21.5", fill: "url(#Arrows1)" }), tp.createElement("path", { d: "M11.5,4.41l7.09,7.09H14V21H9V11.5H4.41L11.5,4.41M11.5,3,2,12.5H8V22h7V12.5h6L11.5,3Z", fill: "#2d6727" }));
const Cge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("linearGradient", { id: "Arrows2", x1: "197.32", y1: "112.82", x2: "197.32", y2: "129.09", gradientTransform: "translate(-42.39 -212.65) rotate(45)", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0", stopColor: "#f5db48" }), tp.createElement("stop", { offset: "0.32", stopColor: "#f4d841" }), tp.createElement("stop", { offset: "0.78", stopColor: "#f3ce2d" }), tp.createElement("stop", { offset: "1", stopColor: "#f2c921" }))), tp.createElement("polygon", { points: "3.02 16.74 9.73 10.03 5.99 6.28 17.72 6.28 17.72 18.01 13.97 14.27 7.26 20.98 3.02 16.74", fill: "url(#Arrows2)" }), tp.createElement("path", { d: "M17.22,6.78v10l-2.54-2.54L14,13.56l-.71.71-6,6L3.72,16.74l6-6,.71-.71-.71-.71L7.2,6.78h10m1-1H4.78L9,10,2.31,16.74l4.95,4.95L14,15l4.24,4.24V5.78Z", fill: "#cf7a10" }));
const xge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("linearGradient", { id: "Arrows3", x1: "473.54", y1: "24.17", x2: "473.54", y2: "40.45", gradientTransform: "translate(43.96 -461.04) rotate(90)", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0", stopColor: "#f5db48" }), tp.createElement("stop", { offset: "0.32", stopColor: "#f4d841" }), tp.createElement("stop", { offset: "0.78", stopColor: "#f3ce2d" }), tp.createElement("stop", { offset: "1", stopColor: "#f2c921" }))), tp.createElement("polygon", { points: "2.5 9.5 12 9.5 12 4.21 20.29 12.5 12 20.79 12 15.5 2.5 15.5 2.5 9.5", fill: "url(#Arrows3)" }), tp.createElement("path", { d: "M19.59,12.5,12.5,19.59V15H3V10h9.5V5.41l7.09,7.09m1.41,0L11.5,3V9H2v7h9.5v6L21,12.5Z", fill: "#cf7a10" }));
const wge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("linearGradient", { id: "Arrows4", x1: "648.45", y1: "-287.78", x2: "648.45", y2: "-271.51", gradientTransform: "translate(272.39 -643.66) rotate(135)", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0", stopColor: "#f5db48" }), tp.createElement("stop", { offset: "0.32", stopColor: "#f4d841" }), tp.createElement("stop", { offset: "0.78", stopColor: "#f3ce2d" }), tp.createElement("stop", { offset: "1", stopColor: "#f2c921" }))), tp.createElement("polygon", { points: "7.26 4.01 13.97 10.73 17.72 6.99 17.72 18.72 5.99 18.72 9.73 14.97 3.02 8.26 7.26 4.01", fill: "url(#Arrows4)" }), tp.createElement("path", { d: "M17.22,18.22H7.2l2.54-2.54.71-.71-.71-.71-6-6L7.26,4.72l6,6,.71.71.71-.71L17.22,8.2v10m1,1V5.78L14,10,7.26,3.31,2.31,8.26,9,15,4.78,19.22Z", fill: "#cf7a10" }));
const Tge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("linearGradient", { id: "Arrows5", x1: "561.5", y1: "-665.09", x2: "561.5", y2: "-681.37", gradientTransform: "translate(573 -661.08) rotate(180)", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0", stopColor: "#f36868" }), tp.createElement("stop", { offset: "0.23", stopColor: "#f36361" }), tp.createElement("stop", { offset: "0.57", stopColor: "#f2554d" }), tp.createElement("stop", { offset: "0.98", stopColor: "#f03e2c" }), tp.createElement("stop", { offset: "1", stopColor: "#f03d2a" }))), tp.createElement("polygon", { points: "14.5 3.5 14.5 13 19.79 13 11.5 21.29 3.21 13 8.5 13 8.5 3.5 14.5 3.5", fill: "url(#Arrows5)" }), tp.createElement("path", { d: "M11.5,20.59,4.41,13.5H9V4h5v9.5h4.59L11.5,20.59m0,1.41L21,12.5H15V3H8v9.5H2L11.5,22Z", fill: "#903825" }));
const Ege = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("linearGradient", { id: "a", x1: "4", y1: "12.5", x2: "19", y2: "12.5", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0", stopColor: "#e4e4e0" }), tp.createElement("stop", { offset: "0.47", stopColor: "#eaeae7" }), tp.createElement("stop", { offset: "1", stopColor: "#f7f7f6" }))), tp.createElement("rect", { x: "4", y: "5", width: "15", height: "15", fill: "url(#a)" }), tp.createElement("path", { d: "M18,6V19H5V6H18m1-1H4V20H19V5Z", fill: "#214d7f" }), tp.createElement("polygon", { points: "16 8.17 10 14.17 7 11.18 7 14 10 17 16 11 16 8.17", fill: "#31a349" }));
const Fge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("linearGradient", { id: "a", x1: "4", y1: "12.5", x2: "19", y2: "12.5", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0", stopColor: "#e4e4e0" }), tp.createElement("stop", { offset: "0.47", stopColor: "#eaeae7" }), tp.createElement("stop", { offset: "1", stopColor: "#f7f7f6" }))), tp.createElement("rect", { x: "4", y: "5", width: "15", height: "15", fill: "url(#a)" }), tp.createElement("path", { d: "M18,6V19H5V6H18m1-1H4V20H19V5Z", fill: "#214d7f" }));
const Mge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M10.19,5.65c-1.66-.55-4.31.77-4.31.77l2.62,6.3a3.07,3.07,0,0,1,3.5-.15c2.8,1.55,5.71-2.21,5.71-2.21a4.27,4.27,0,0,1-3-.88C13.15,8.42,11,5.92,10.19,5.65Z", fill: "#9ad47d" }), tp.createElement("path", { d: "M8.31,13.56,5.24,6.19,5.66,6c.12-.06,2.85-1.41,4.69-.8h0A8.74,8.74,0,0,1,12.6,7,22.18,22.18,0,0,0,15,9.07a3.81,3.81,0,0,0,2.61.81l1.28-.23-.79,1c-.13.17-3.21,4.08-6.35,2.34a2.58,2.58,0,0,0-2.92.08Zm2-1.94a4.24,4.24,0,0,1,2,.51c1.66.92,3.43-.39,4.38-1.31a5.7,5.7,0,0,1-2.17-.92,22.82,22.82,0,0,1-2.53-2.18A11.2,11.2,0,0,0,10,6.13h0a6,6,0,0,0-3.5.55L8.73,12A3.4,3.4,0,0,1,10.27,11.62Z", fill: "#31a349" }), tp.createElement("path", { d: "M11.11,19.77a.5.5,0,0,1-.46-.31L5.28,6.16a.5.5,0,1,1,.93-.37l5.36,13.29a.5.5,0,0,1-.28.65A.51.51,0,0,1,11.11,19.77Z" }));
const kge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M10.19,5.65c-1.66-.55-4.31.77-4.31.77l2.62,6.3a3.07,3.07,0,0,1,3.5-.15c2.8,1.55,5.71-2.21,5.71-2.21a4.27,4.27,0,0,1-3-.88C13.15,8.42,11,5.92,10.19,5.65Z", fill: "#f5db48" }), tp.createElement("path", { d: "M8.31,13.56,5.24,6.19,5.66,6c.12-.06,2.85-1.41,4.69-.8h0A8.74,8.74,0,0,1,12.6,7,22.18,22.18,0,0,0,15,9.07a3.81,3.81,0,0,0,2.61.81l1.28-.23-.79,1c-.13.17-3.21,4.08-6.35,2.34a2.58,2.58,0,0,0-2.92.08Zm2-1.94a4.24,4.24,0,0,1,2,.51c1.66.92,3.43-.39,4.38-1.31a5.7,5.7,0,0,1-2.17-.92,22.82,22.82,0,0,1-2.53-2.18A11.2,11.2,0,0,0,10,6.13h0a6,6,0,0,0-3.5.55L8.73,12A3.4,3.4,0,0,1,10.27,11.62Z", fill: "#f2b621" }), tp.createElement("path", { d: "M11.11,19.77a.5.5,0,0,1-.46-.31L5.28,6.16a.5.5,0,1,1,.93-.37l5.36,13.29a.5.5,0,0,1-.28.65A.51.51,0,0,1,11.11,19.77Z" }));
const Pge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M10.19,5.65c-1.66-.55-4.31.77-4.31.77l2.62,6.3a3.07,3.07,0,0,1,3.5-.15c2.8,1.55,5.71-2.21,5.71-2.21a4.27,4.27,0,0,1-3-.88C13.15,8.42,11,5.92,10.19,5.65Z", fill: "#f36868" }), tp.createElement("path", { d: "M8.31,13.56,5.24,6.19,5.66,6c.12-.06,2.85-1.41,4.69-.8h0A8.74,8.74,0,0,1,12.6,7,22.18,22.18,0,0,0,15,9.07a3.81,3.81,0,0,0,2.61.81l1.28-.23-.79,1c-.13.17-3.21,4.08-6.35,2.34a2.58,2.58,0,0,0-2.92.08Zm2-1.94a4.24,4.24,0,0,1,2,.51c1.66.92,3.43-.39,4.38-1.31a5.7,5.7,0,0,1-2.17-.92,22.82,22.82,0,0,1-2.53-2.18A11.2,11.2,0,0,0,10,6.13h0a6,6,0,0,0-3.5.55L8.73,12A3.4,3.4,0,0,1,10.27,11.62Z", fill: "#f03d2a" }), tp.createElement("path", { d: "M11.11,19.77a.5.5,0,0,1-.46-.31L5.28,6.16a.5.5,0,1,1,.93-.37l5.36,13.29a.5.5,0,0,1-.28.65A.51.51,0,0,1,11.11,19.77Z" }));
const Nge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("linearGradient", { id: "GrayArrows1", x1: "11.5", y1: "4.22", x2: "11.5", y2: "20.49", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0.03", stopColor: "#b5b5b5" }), tp.createElement("stop", { offset: "0.37", stopColor: "#aeaeae" }), tp.createElement("stop", { offset: "0.86", stopColor: "#9a9a9a" }), tp.createElement("stop", { offset: "1", stopColor: "#939393" }))), tp.createElement("polygon", { points: "8.5 21.5 8.5 12 3.21 12 11.5 3.71 19.79 12 14.5 12 14.5 21.5 8.5 21.5", fill: "url(#GrayArrows1)" }), tp.createElement("path", { d: "M11.5,4.41l7.09,7.09H14V21H9V11.5H4.41L11.5,4.41M11.5,3,2,12.5H8V22h7V12.5h6L11.5,3Z", fill: "#404040" }));
const Dge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("linearGradient", { id: "GrayArrows2", x1: "315.13", y1: "309.23", x2: "315.13", y2: "325.51", gradientTransform: "translate(13.19 -434.85) rotate(45)", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0.03", stopColor: "#b5b5b5" }), tp.createElement("stop", { offset: "0.37", stopColor: "#aeaeae" }), tp.createElement("stop", { offset: "0.86", stopColor: "#9a9a9a" }), tp.createElement("stop", { offset: "1", stopColor: "#939393" }))), tp.createElement("polygon", { points: "3.02 16.74 9.73 10.03 5.99 6.28 17.72 6.28 17.72 18.01 13.97 14.27 7.26 20.98 3.02 16.74", fill: "url(#GrayArrows2)" }), tp.createElement("path", { d: "M17.22,6.78v10l-2.54-2.54L14,13.56l-.71.71-6,6L3.72,16.74l6-6,.71-.71-.71-.71L7.2,6.78h10m1-1H4.78L9,10,2.31,16.74l4.95,4.95L14,15l4.24,4.24V5.78Z", fill: "#404040" }));
const Lge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("linearGradient", { id: "GrayArrows3", x1: "813.54", y1: "292.95", x2: "813.54", y2: "276.68", gradientTransform: "translate(295.96 -801.04) rotate(90)", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0.03", stopColor: "#b5b5b5" }), tp.createElement("stop", { offset: "0.37", stopColor: "#aeaeae" }), tp.createElement("stop", { offset: "0.86", stopColor: "#9a9a9a" }), tp.createElement("stop", { offset: "1", stopColor: "#939393" }))), tp.createElement("polygon", { points: "2.5 9.5 12 9.5 12 4.21 20.29 12.5 12 20.79 12 15.5 2.5 15.5 2.5 9.5", fill: "url(#GrayArrows3)" }), tp.createElement("path", { d: "M19.59,12.5,12.5,19.59V15H3V10h9.5V5.41l7.09,7.09m1.41,0L11.5,3V9H2v7h9.5v6L21,12.5Z", fill: "#404040" }));
const Hge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("linearGradient", { id: "GrayArrows4", x1: "1179.67", y1: "-138.51", x2: "1191.18", y2: "-150.02", gradientTransform: "translate(746.58 -928.08) rotate(135)", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0.03", stopColor: "#b5b5b5" }), tp.createElement("stop", { offset: "0.37", stopColor: "#aeaeae" }), tp.createElement("stop", { offset: "0.86", stopColor: "#9a9a9a" }), tp.createElement("stop", { offset: "1", stopColor: "#939393" }))), tp.createElement("polygon", { points: "7.26 4.01 13.97 10.73 17.72 6.99 17.72 18.72 5.99 18.72 9.73 14.97 3.02 8.26 7.26 4.01", fill: "url(#GrayArrows4)" }), tp.createElement("path", { d: "M17.22,18.22H7.2l2.54-2.54.71-.71-.71-.71-6-6L7.26,4.72l6,6,.71.71.71-.71L17.22,8.2v10m1,1V5.78L14,10,7.26,3.31,2.31,8.26,9,15,4.78,19.22Z", fill: "#404040" }));
const Ige = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("linearGradient", { id: "GrayArrows5", x1: "1153.5", y1: "-753.09", x2: "1153.5", y2: "-769.37", gradientTransform: "translate(1165 -749.08) rotate(180)", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0.03", stopColor: "#b5b5b5" }), tp.createElement("stop", { offset: "0.37", stopColor: "#aeaeae" }), tp.createElement("stop", { offset: "0.86", stopColor: "#9a9a9a" }), tp.createElement("stop", { offset: "1", stopColor: "#939393" }))), tp.createElement("polygon", { points: "14.5 3.5 14.5 13 19.79 13 11.5 21.29 3.21 13 8.5 13 8.5 3.5 14.5 3.5", fill: "url(#GrayArrows5)" }), tp.createElement("path", { d: "M11.5,20.59,4.41,13.5H9V4h5v9.5h4.59L11.5,20.59m0,1.41L21,12.5H15V3H8v9.5H2L11.5,22Z", fill: "#404040" }));
const _ge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M11,4.5A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z" }));
const Vge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M11,4.5V13H2.5A8.5,8.5,0,1,0,11,4.5Z" }), tp.createElement("path", { d: "M11,5.5A7.5,7.5,0,1,1,3.5,13,7.51,7.51,0,0,1,11,5.5m0-1A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z" }));
const Rge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M11,4.5v17a8.5,8.5,0,0,0,0-17Z" }), tp.createElement("path", { d: "M11,5.5A7.5,7.5,0,1,1,3.5,13,7.51,7.51,0,0,1,11,5.5m0-1A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z" }));
const Age = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M11,5.5A7.5,7.5,0,1,1,3.5,13,7.51,7.51,0,0,1,11,5.5m0-1A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z" }), tp.createElement("path", { d: "M11,4.5V13h8.5A8.5,8.5,0,0,0,11,4.5Z" }));
const Oge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M11,5.5A7.5,7.5,0,1,1,3.5,13,7.51,7.51,0,0,1,11,5.5m0-1A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z" }));
const Bge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M11,4.5A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Zm0,10.78A2.28,2.28,0,1,1,13.28,13,2.28,2.28,0,0,1,11,15.28Z", fill: "#ff1900" }), tp.createElement("path", { d: "M11,5.5A7.5,7.5,0,1,1,3.5,13,7.51,7.51,0,0,1,11,5.5m0-1A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z", fill: "#d71400" }));
const zge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M11,4.5A8.5,8.5,0,0,0,2.5,13h17A8.5,8.5,0,0,0,11,4.5Z", fill: "#ff1900" }), tp.createElement("path", { d: "M11,5.5A7.5,7.5,0,1,1,3.5,13,7.51,7.51,0,0,1,11,5.5m0-1A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z", fill: "#d71400" }));
const $ge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M11,4.5A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z" }));
const Wge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M11,4.5A8.5,8.5,0,0,0,2.5,13h17A8.5,8.5,0,0,0,11,4.5Z" }), tp.createElement("path", { d: "M11,5.5A7.5,7.5,0,1,1,3.5,13,7.51,7.51,0,0,1,11,5.5m0-1A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z" }));
const jge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M11,5.5A7.5,7.5,0,1,1,3.5,13,7.51,7.51,0,0,1,11,5.5m0-1A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z" }));
const Zge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M11,4.5A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z", fill: "#ff1900" }), tp.createElement("path", { d: "M11,5.5A7.5,7.5,0,1,1,3.5,13,7.51,7.51,0,0,1,11,5.5m0-1A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z", fill: "#d71400" }));
const Gge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M11,4.5A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z", fill: "#ff8f89" }), tp.createElement("path", { d: "M11,5.5A7.5,7.5,0,1,1,3.5,13,7.51,7.51,0,0,1,11,5.5m0-1A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z", fill: "#eb8b88" }));
const Uge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M11,4.5A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z", fill: "#b5b5b5" }), tp.createElement("path", { d: "M11,5.5A7.5,7.5,0,1,1,3.5,13,7.51,7.51,0,0,1,11,5.5m0-1A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z", fill: "#a7a7a7" }));
const qge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M11,4.5A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z" }));
const Yge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("radialGradient", { id: "Signs1", cx: "11", cy: "12.96", r: "8.5", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0.22", stopColor: "#93ce90" }), tp.createElement("stop", { offset: "0.28", stopColor: "#88ca8a" }), tp.createElement("stop", { offset: "0.46", stopColor: "#6bbf7a" }), tp.createElement("stop", { offset: "0.65", stopColor: "#56b76e" }), tp.createElement("stop", { offset: "0.83", stopColor: "#49b367" }), tp.createElement("stop", { offset: "1", stopColor: "#45b165" }))), tp.createElement("path", { d: "M11,4.5A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z", fill: "url(#Signs1)" }), tp.createElement("path", { d: "M11,5.5A7.5,7.5,0,1,1,3.5,13,7.51,7.51,0,0,1,11,5.5m0-1A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z", fill: "#225f1e" }));
const Kge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("linearGradient", { id: "Signs2", x1: "7.33", y1: "12.72", x2: "13.51", y2: "19.79", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0.1", stopColor: "#f5db48" }), tp.createElement("stop", { offset: "0.38", stopColor: "#f4d841" }), tp.createElement("stop", { offset: "0.8", stopColor: "#f3ce2d" }), tp.createElement("stop", { offset: "1", stopColor: "#f2c921" }))), tp.createElement("path", { d: "M10.19,6.46l-7,12A1,1,0,0,0,4.06,20H18a1,1,0,0,0,.86-1.5l-7-12A1,1,0,0,0,10.19,6.46Z", fill: "url(#Signs2)" }), tp.createElement("path", { d: "M18,20.49h-14a1.5,1.5,0,0,1-1.3-2.25l7-12a1.5,1.5,0,0,1,2.59,0l7,12A1.5,1.5,0,0,1,18,20.49ZM10.62,6.71l-7,12a.5.5,0,0,0,.43.75H18a.5.5,0,0,0,.43-.75l-7-12a.5.5,0,0,0-.86,0Z", fill: "#cf7a10" }));
const Xge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("linearGradient", { id: "Signs3", x1: "6.68", y1: "8.68", x2: "14.96", y2: "16.96", gradientTransform: "translate(12.41 -3.97) rotate(45)", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0.1", stopColor: "#f9a8a9" }), tp.createElement("stop", { offset: "0.3", stopColor: "#f8a1a2" }), tp.createElement("stop", { offset: "0.59", stopColor: "#f78e8e" }), tp.createElement("stop", { offset: "0.94", stopColor: "#f46f6d" }), tp.createElement("stop", { offset: "1", stopColor: "#f46967" }))), tp.createElement("rect", { x: "4.9", y: "6.9", width: "12.21", height: "12.21", rx: "1.53", ry: "1.53", transform: "translate(-5.97 11.59) rotate(-45)", fill: "url(#Signs3)" }), tp.createElement("path", { d: "M11,21.5a2,2,0,0,1-1.43-.59L3.09,14.43a2,2,0,0,1,0-2.86L9.57,5.09a2,2,0,0,1,2.87,0l6.48,6.48a2,2,0,0,1,0,2.86l-6.48,6.48A2,2,0,0,1,11,21.5Zm0-16a1,1,0,0,0-.73.3L3.8,12.27a1,1,0,0,0,0,1.45l6.48,6.48a1,1,0,0,0,1.45,0l6.48-6.48a1,1,0,0,0,0-1.45L11.73,5.8A1,1,0,0,0,11,5.5Z", fill: "#902a1a" }));
const Jge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("radialGradient", { id: "TrafficLights1", cx: "11", cy: "12.96", r: "8.5", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0.22", stopColor: "#93ce90" }), tp.createElement("stop", { offset: "0.28", stopColor: "#88ca8a" }), tp.createElement("stop", { offset: "0.46", stopColor: "#6bbf7a" }), tp.createElement("stop", { offset: "0.65", stopColor: "#56b76e" }), tp.createElement("stop", { offset: "0.83", stopColor: "#49b367" }), tp.createElement("stop", { offset: "1", stopColor: "#45b165" }))), tp.createElement("path", { d: "M11,4.5A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z", fill: "url(#TrafficLights1)" }), tp.createElement("path", { d: "M11,5.5A7.5,7.5,0,1,1,3.5,13,7.51,7.51,0,0,1,11,5.5m0-1A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z", fill: "#225f1e" }));
const Qge = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("radialGradient", { id: "TrafficLights2", cx: "11.84", cy: "13.36", r: "8.5", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0", stopColor: "#f2ed36" }), tp.createElement("stop", { offset: "0.12", stopColor: "#f2ea32" }), tp.createElement("stop", { offset: "0.24", stopColor: "#f2e325" }), tp.createElement("stop", { offset: "0.37", stopColor: "#f2d60f" }), tp.createElement("stop", { offset: "0.43", stopColor: "#f2cf04" }), tp.createElement("stop", { offset: "0.48", stopColor: "#f2cc07" }), tp.createElement("stop", { offset: "1", stopColor: "#f2ae21" }))), tp.createElement("path", { d: "M11,4.5A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z", fill: "url(#TrafficLights2)" }), tp.createElement("path", { d: "M11,5.5A7.5,7.5,0,1,1,3.5,13,7.51,7.51,0,0,1,11,5.5m0-1A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z", fill: "#cf7a10" }));
const eye = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("radialGradient", { id: "TrafficLights3", cx: "11.84", cy: "13.36", r: "8.5", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0.03", stopColor: "#ff936a" }), tp.createElement("stop", { offset: "0.14", stopColor: "#fe8c66" }), tp.createElement("stop", { offset: "0.3", stopColor: "#fb7859" }), tp.createElement("stop", { offset: "0.5", stopColor: "#f65746" }), tp.createElement("stop", { offset: "0.71", stopColor: "#f0292a" }), tp.createElement("stop", { offset: "0.72", stopColor: "#f0292a" }), tp.createElement("stop", { offset: "0.76", stopColor: "#f02e2f" }), tp.createElement("stop", { offset: "0.81", stopColor: "#f13e3e" }), tp.createElement("stop", { offset: "0.87", stopColor: "#f35756" }), tp.createElement("stop", { offset: "0.93", stopColor: "#f57b78" }), tp.createElement("stop", { offset: "1", stopColor: "#f8a8a3" }), tp.createElement("stop", { offset: "1", stopColor: "#f8aaa5" }))), tp.createElement("path", { d: "M11,4.5A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z", fill: "url(#TrafficLights3)" }), tp.createElement("path", { d: "M11,5.5A7.5,7.5,0,1,1,3.5,13,7.51,7.51,0,0,1,11,5.5m0-1A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z", fill: "#8d2b1b" }));
const tye = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("radialGradient", { id: "TrafficLights4", cx: "11.84", cy: "13.36", r: "8.5", gradientUnits: "userSpaceOnUse" }, tp.createElement("stop", { offset: "0.03", stopColor: "#928f8f" }), tp.createElement("stop", { offset: "0.04", stopColor: "#8e8c8c" }), tp.createElement("stop", { offset: "0.09", stopColor: "#767373" }), tp.createElement("stop", { offset: "0.16", stopColor: "#636060" }), tp.createElement("stop", { offset: "0.23", stopColor: "#555353" }), tp.createElement("stop", { offset: "0.33", stopColor: "#4d4b4b" }), tp.createElement("stop", { offset: "0.5", stopColor: "#4b4949" }), tp.createElement("stop", { offset: "0.75", stopColor: "#363434" }), tp.createElement("stop", { offset: "1" }))), tp.createElement("path", { d: "M11,4.5A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z", fill: "url(#TrafficLights4)" }), tp.createElement("path", { d: "M11,5.5A7.5,7.5,0,1,1,3.5,13,7.51,7.51,0,0,1,11,5.5m0-1A8.5,8.5,0,1,0,19.5,13,8.5,8.5,0,0,0,11,4.5Z", fill: "#040404" }));
const [nye] = Dp("wd-editor-icon-set-value");
const rye = (e14) => `propertyDescriptors:labels.dataVisualizer.iconSet.${e14}`;
const oye = $N("", rye("iconSet"), "enum_expr", "IconSet", void 0, { enumKey: "data_visualizer_icon_set_type" });
const aye = { IconDataVisualizerIconSetSymbols11: dge, IconDataVisualizerIconSetSymbols12: pge, IconDataVisualizerIconSetSymbols13: mge, IconDataVisualizerIconSetSymbols21: hge, IconDataVisualizerIconSetSymbols22: fge, IconDataVisualizerIconSetSymbols23: gge, IconDataVisualizerIconSetArrows1: Sge, IconDataVisualizerIconSetArrows2: Cge, IconDataVisualizerIconSetArrows3: xge, IconDataVisualizerIconSetArrows4: wge, IconDataVisualizerIconSetArrows5: Tge, IconDataVisualizerIconSetCheckbox1: Ege, IconDataVisualizerIconSetCheckbox2: Fge, IconDataVisualizerIconSetFlags1: Mge, IconDataVisualizerIconSetFlags2: kge, IconDataVisualizerIconSetFlags3: Pge, IconDataVisualizerIconSetGrayArrows1: Nge, IconDataVisualizerIconSetGrayArrows2: Dge, IconDataVisualizerIconSetGrayArrows3: Lge, IconDataVisualizerIconSetGrayArrows4: Hge, IconDataVisualizerIconSetGrayArrows5: Ige, IconDataVisualizerIconSetQuarters1: _ge, IconDataVisualizerIconSetQuarters2: Vge, IconDataVisualizerIconSetQuarters3: Rge, IconDataVisualizerIconSetQuarters4: Age, IconDataVisualizerIconSetQuarters5: Oge, IconDataVisualizerIconSetRatings1: Bge, IconDataVisualizerIconSetRatings2: zge, IconDataVisualizerIconSetRatings3: $ge, IconDataVisualizerIconSetRatings4: Wge, IconDataVisualizerIconSetRatings5: jge, IconDataVisualizerIconSetRedToBlack1: Zge, IconDataVisualizerIconSetRedToBlack2: Gge, IconDataVisualizerIconSetRedToBlack3: Uge, IconDataVisualizerIconSetRedToBlack4: qge, IconDataVisualizerIconSetSigns1: Yge, IconDataVisualizerIconSetSigns2: Kge, IconDataVisualizerIconSetSigns3: Xge, IconDataVisualizerIconSet3TrafficLights1: yge, IconDataVisualizerIconSet3TrafficLights2: vge, IconDataVisualizerIconSet3TrafficLights3: bge, IconDataVisualizerIconSetTrafficLights1: Jge, IconDataVisualizerIconSetTrafficLights2: Qge, IconDataVisualizerIconSetTrafficLights3: eye, IconDataVisualizerIconSetTrafficLights4: tye };
const iye = (e14) => [1, 2, 3, 4, 5].map((t10) => ((e15, t11) => ({ category: "", label: rye(`icon${t11}Value`), type: "enum_expr", valuePath: `Icon${t11}Value`, mode: "both", meta: { icon: aye[`IconDataVisualizerIconSet${e15}${t11}`], enumKey: "data_visualizer_icon_set_value" } }))(e14, t10));
const sye = (e14) => {
  const { descriptor: { meta: { icon: t10 } } } = e14;
  return tp.createElement("div", { className: nye }, t10 && tp.createElement(Fm, { icon: nf(t10) }), tp.createElement(Hde, __spreadValues({}, e14)));
};
const lye = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  return tp.createElement(tp.Fragment, null, tp.createElement(Hde, __spreadValues({}, Xue(e14, oye, t10))), iye(e14.value.IconSet).map((n10) => tp.createElement(sye, __spreadValues({ key: n10.valuePath }, Xue(e14, n10, t10)))));
};
const cye = { Type: "dvchartvalueaggregateencoding", Field: { FieldType: "Simple", Value: [] }, Aggregate: "None" };
const uye = { Type: "dvchartaggregateencoding", Field: { FieldType: "Simple", Value: [] }, Aggregate: "None", Action: { ActionType: "None" } };
const dye = { Type: "dvchartdetailsencoding", Field: { FieldType: "Simple", Value: [] }, Group: "None", ExcludeNulls: false, Sort: "None", SortingField: "", SortingAggregate: "None" };
const pye = { Type: "dvchartcategoryencoding", Field: { FieldType: "Simple", Value: [] }, Sort: "None", SortingField: "", SortingAggregate: "None" };
const mye = { Type: "dvcharttextencoding", Field: { Value: "", TemplateKey: "" }, Aggregate: "None", Target: "Label" };
const hye = { Type: "dvchartencodingfieldvalue", Value: "" };
const fye = (e14 = {}) => __spreadValues(__spreadValues({}, uye), e14);
const gye = (e14 = {}) => __spreadValues(__spreadValues({}, cye), e14);
const yye = (e14 = {}) => __spreadValues(__spreadValues({}, dye), e14);
const vye = (e14 = {}) => __spreadValues(__spreadValues({}, pye), e14);
const bye = (e14 = "") => __spreadProps(__spreadValues({}, hye), { Value: e14 });
const Sye = (e14) => !e14.includes("aggregate") && !e14.includes("documentMap");
const Cye = (e14 = 0) => {
  const { selectedItemsInfo: t10 } = ep.useContext(Rue);
  if (1 === t10.length) {
    const e15 = t10[0].path.split(".Plots.");
    if (2 === e15.length) {
      const t11 = +e15[1];
      if (!Number.isNaN(t11)) return { plotIndex: t11 };
    }
  }
  return { plotIndex: e14 };
};
const xye = (e14) => {
  const { descriptor: t10, value: n10, setProperty: r10, onAdd: o10, onDelete: a10 } = e14;
  const i10 = __spreadProps(__spreadValues({}, e14), { reordering: { type: "drag" }, onAdd: () => {
    o10 ? o10() : r10(t10, AV(n10 || [], { $push: [bye()] }));
  }, onDelete: (e15) => {
    a10 ? a10(e15) : r10(t10, AV(n10, { $splice: [[e15, 1]] }));
  }, createEditor: (e15, n11) => {
    const o11 = { value: e15.Value, defaultValue: "", descriptor: __spreadProps(__spreadValues({}, t10), { type: "string_expr", valuePath: `${t10.valuePath}.${n11}.Value`, meta: { exprEditorFilter: Sye } }), setProperty: r10 };
    return tp.createElement(Lpe, __spreadValues({}, o11));
  } });
  return tp.createElement(Bde, __spreadValues({}, i10));
};
xye.displayName = "DVChartAggregateEncodingFieldCollection";
const wye = "RDLX/CHART/ADD_AXIS";
const Tye = "RDLX/CHART/DELETE_AXIS";
const Eye = "RDLX/CHART/ADD_LEGEND";
const Fye = "RDLX/CHART/DELETE_LEGEND";
const Mye = "RDLX/CHART/ADD_PLOT";
const kye = "RDLX/CHART/DELETE_PLOT";
const Pye = "RDLX/CHART/UPDATE_PLOT";
const Nye = "RDLX/CHART/SET_PLOT_TEMPLATE";
const Dye = "RDLX/CHART/CHART_ADD_PLOT_RULE";
const Lye = "RDLX/CHART/CHART_DELETE_PLOT_RULE";
const Hye = "RDLX/CHART/CHART_UPDATE_PLOT_RULE";
const Iye = "RDLX/CHART/CHART_ADD_PLOT_OVERLAY";
const _ye = "RDLX/CHART/CHART_DELETE_PLOT_OVERLAY";
const Vye = "RDLX/CHART/CHART_UPDATE_PLOT_OVERLAY";
const Rye = "RDLX/CHART/ADD_ENCODING_VALUE";
const Aye = "RDLX/CHART/DELETE_ENCODING";
const Oye = "CHART/SET_DATASET_NAME";
const Bye = "RDLX/CHART/SET_PALETTE";
const zye = "RDLX/CHART_SET_UNPIVOT_DATA";
const $ye = { addAxis: (e14, t10) => Kz.action(wye, { axisType: e14, title: t10 }), deleteAxis: (e14) => Kz.action(Tye, { index: e14 }), addLegend: () => Kz.action(Eye), deleteLegend: (e14) => Kz.action(Fye, { index: e14 }), addPlot: () => Kz.action(Mye), deletePlot: (e14) => Kz.action(kye, { index: e14 }), updatePlotName: (e14, t10) => Kz.action(Pye, { plotName: e14, updPlotName: t10 }), setPlotTemplate: (e14) => Kz.action(Nye, { templateType: e14 }), addPlotRule: (e14) => Kz.action(Dye, { name: e14 }), deletePlotRule: (e14) => Kz.action(Lye, { ruleIndex: e14 }), updatePlotRule: (e14, t10) => Kz.action(Hye, { ruleIndex: e14, rule: t10 }), addPlotOverlay: (e14) => Kz.action(Iye, { name: e14 }), deletePlotOverlay: (e14) => Kz.action(_ye, { overlayIndex: e14 }), updatePlotOverlay: (e14, t10) => Kz.action(Vye, { overlayIndex: e14, overlay: t10 }), addPlotCustomLabel: _V("@rdlx/chart/plot/addCustomLabel", (e14) => ({ name: e14 })), deletePlotCustomLabel: _V("@rdlx/chart/plot/deleteCustomLabel", (e14) => ({ labelIndex: e14 })), addPlotPointer: _V("@rdlx/chart/plot/addPointer", (e14) => ({ name: e14 })), deletePlotPointer: _V("@rdlx/chart/plot/deletePointer", (e14) => ({ pointerIndex: e14 })), addEncodingValue: (e14, t10, n10) => Kz.action(Rye, { encodingName: e14, value: t10, plotIndex: n10 }), deleteEncoding: (e14, t10, n10) => Kz.action(Aye, { plotIndex: e14, encodingName: t10, valueIndex: n10 }), setDataSetName: (e14) => Kz.action(Oye, { dataSetName: e14 }), setPalette: ({ palette: e14, customPalette: t10 = [], customPaletteInfo: n10 = { customPaletteId: "", customPaletteName: "" } }) => Kz.action(Bye, { palette: e14, customPalette: t10, customPaletteInfo: n10 }), setUnpivotData: (e14) => Kz.action(zye, { value: e14 }) };
const Wye = (e14, t10) => Gye(e14, n5, t10);
function jye(e14, t10, n10) {
  let r10 = e14;
  for (let o10 = e14.length; o10--; ) {
    const a10 = e14[o10];
    if (!a10.$selected) continue;
    const i10 = Zye(a10, t10, n10);
    i10 !== a10 && (r10 = AV(r10, { [o10]: { $set: i10 } }));
  }
  return r10;
}
function Zye(e14, t10, n10) {
  return e14.hasOwnProperty("Type") ? $V(t10, e14, n10) : Gye(e14, t10, n10);
}
function Gye(e14, t10, n10) {
  if (!aj(e14)) return e14;
  let r10 = e14;
  const o10 = function(e15) {
    switch (e15.Type) {
      case "multisectionreport":
      case "dashboard":
        return ["ReportSections", "Layers"];
      case "Continuous":
      case "dashboardsection":
        return ["Body", "PageHeader", "PageFooter"];
      case "fixedpagereport":
        return ["Pages", "Layers"];
      case "section":
      case "fixedpagesection":
      case "rectangle":
      case "contentplaceholder":
      case "fixedpagerectangle":
      case "pagesection":
      case "list":
      case "fixedpagelist":
      case "bandedlistheader":
      case "bandedlistdetails":
      case "bandedlistfooter":
        return ["ReportItems"];
      case "bandedlist":
      case "fixedpagebandedlist":
        return ["Header", "Footer", "Details", "Groups"];
      case "bandedlistgroup":
        return ["Header", "Footer"];
      case "dvchart":
      case "fixedpagedvchart":
        return ["Bar", "Header", "Footer", "Legend", "PlotArea", "Plots"];
      default:
        return Object.keys(e15);
    }
  }(e14);
  for (const a10 of o10) {
    const o11 = e14[a10];
    let i10 = o11;
    Array.isArray(o11) ? i10 = jye(o11, t10, n10) : o11 && o11.$selected && (i10 = Zye(o11, t10, n10)), o11 !== i10 && (r10 = AV(r10, { [a10]: { $set: i10 } }));
  }
  return r10;
}
function Uye(e14, t10, n10) {
  return WV(0, t10, n10);
}
const qye = "dvchart";
const Yye = FZ.resultOf(wq.decode({ Type: qye, Name: "dvChart1", Bar: { BottomWidth: 0.55, NeckHeight: 1, Overlap: 0, TopWidth: 0.55, Width: 0.55 } }));
const Kye = FZ.resultOf(wq.decode({ Type: qye, Name: "dvChart1", Plots: [{}], PlotArea: { Axes: [{ AxisType: "X", Format: "" }, { AxisType: "Y", Format: "" }], Legends: [{}] } }));
const Xye = (e14, t10) => ({ barBottomWidth: Yye.Bar.BottomWidth, barTopWidth: Yye.Bar.TopWidth, barWidth: Yye.Bar.Width });
const Jye = (e14, t10, n10, r10 = Kye) => {
  let o10 = r10.Header.Title;
  let a10 = r10.PlotArea.Axes;
  return o10 || (o10 = hG().t("captions:dvchartChartTitle", "Chart Title")), a10 = a10.map((e15) => {
    if (e15.Title) return e15;
    const t11 = "X" === e15.AxisType ? hG().t("captions:dvchartAxis.category", "Category") : hG().t("captions:dvchartAxis.value", "Value");
    return __spreadProps(__spreadValues({}, e15), { Title: t11 });
  }), __spreadProps(__spreadValues(__spreadValues({}, r10), n10), { Header: __spreadProps(__spreadValues({}, r10.Header), { Title: o10 }), PlotArea: __spreadProps(__spreadValues({}, r10.PlotArea), { Axes: a10 }), Name: e14 });
};
const Qye = Kye.PlotArea.Axes[0];
const eve = (e14, t10 = {}, n10) => {
  var _a2, _b2, _c2;
  const r10 = ((_a2 = tz == null ? void 0 : tz.getTemplate("dvchart", n10)) != null ? _a2 : Kye).PlotArea.Axes;
  const o10 = (_b2 = r10.find((t11) => t11.AxisType === e14)) != null ? _b2 : r10[0];
  const a10 = "X" === e14 ? hG().t("captions:dvchartAxis.category", "Category") : hG().t("captions:dvchartAxis.value", "Value");
  return __spreadProps(__spreadValues(__spreadValues({}, o10), t10), { Title: (_c2 = o10.Title) != null ? _c2 : a10, AxisType: e14 });
};
const tve = Kye.PlotArea.Legends[0];
const nve = (e14 = {}, t10 = tve) => __spreadValues(__spreadValues({}, t10), e14);
const rve = __spreadProps(__spreadValues({}, Kye.Plots[0]), { PlotName: "" });
const ove = () => {
  const e14 = ((e15) => Dj[e15])("chart");
  return { InnerRadius: e14.innerRadius, StartAngle: e14.startAngle };
};
const ave = (e14, t10, n10 = {}, r10 = rve) => __spreadValues(__spreadValues({}, __spreadProps(__spreadValues({}, r10), { PlotChartType: "Column", PlotChartSubtype: "Clustered", PlotName: e14, Encodings: __spreadProps(__spreadValues({}, r10.Encodings), { Category: vye(), Color: fye(), Shape: fye(), Size: fye(), Texts: [] }) })), n10);
const ive = "VALUESNAME";
const sve = ["Column", "Bar", "Line", "Area", "Pie", "PolarColumn", "PolarBar", "RadarArea", "RadarBubble", "RadarScatter", "RadarLine", "Pyramid", "Funnel", "Bubble", "Scatter", "Gantt", "Candlestick", "HighLowClose", "HighLowOpenClose", "RangeArea", "RangeBar", "RangeColumn", "Gauge", "Custom"];
const lve = { Column: ["column", "columnStacked", "columnPercentStacked"], Bar: ["bar", "barStacked", "barPercentStacked"], Line: ["line", "lineSmooth"], Area: ["area", "areaStacked", "areaPercentStacked"], Pie: ["pie", "doughnut"], PolarColumn: ["polarColumn", "polarColumnStacked", "polarColumnPercentStacked"], PolarBar: ["polarBar", "polarBarStacked", "polarBarPercentStacked"], RadarArea: ["radarArea"], RadarBubble: ["radarBubble"], RadarScatter: ["radarScatter"], RadarLine: ["radarLine"], Pyramid: ["pyramid"], Funnel: ["funnel"], Bubble: ["bubble"], Scatter: ["scatter"], Gantt: ["gantt"], Candlestick: ["candlestick"], HighLowClose: ["highLowClose"], HighLowOpenClose: ["highLowOpenClose"], RangeArea: ["rangeArea"], RangeBar: ["rangeBar"], RangeColumn: ["rangeColumn"], Gauge: ["gauge"], Custom: void 0 };
const cve = { Values: true, Category: false, Details: false, Color: false, Shape: false, Size: false, Texts: false };
const uve = (...e14) => (e14 || []).reduce((e15, t10) => __spreadProps(__spreadValues({}, e15), { [t10]: true }), __spreadValues({}, cve));
const dve = uve("Category", "Details", "Color", "Shape", "Size", "Texts");
const pve = uve("Category");
const mve = uve("Category", "Details", "Color", "Texts");
const hve = uve("Details", "Color", "Texts");
const fve = uve("Category", "Details", "Color", "Shape", "Texts");
const gve = uve("Category", "Details", "Color", "Size", "Texts");
const yve = { Custom: dve, Column: mve, Bar: mve, Line: dve, Pie: hve, Area: mve, Pyramid: hve, Funnel: hve, Scatter: fve, Bubble: gve, Gantt: mve, Candlestick: pve, HighLowClose: pve, HighLowOpenClose: pve, PolarColumn: mve, PolarBar: mve, RadarArea: mve, RadarBubble: gve, RadarScatter: fve, RadarLine: dve, RangeArea: mve, RangeBar: mve, RangeColumn: mve, Gauge: uve() };
const vve = ({ Color: e14, Shape: t10, Size: n10 }) => ({ Color: e14, Shape: t10, Size: n10 });
const bve = Object.keys(yve).reduce((e14, t10) => __spreadProps(__spreadValues({}, e14), { [t10]: vve(yve[t10]) }), {});
const Sve = FZ.resultOf(OK.decode({}));
const Cve = { Type: "dvchartoverlay", Name: "", OverlayType: "ReferenceLine", Display: "Front", Style: { Border: __spreadProps(__spreadValues({}, Sve.Border), { Style: "Solid" }), BackgroundColor: Sve.BackgroundColor }, Field: "", DetailLevel: "Total", LegendLabel: "", Value: "", Axis: "Y", AggregateType: "Average", Start: 0, End: 0, Order: 1, Period: 2, ForwardForecastPeriod: 0, BackwardForecastPeriod: 0, Intercept: null };
const xve = (e14) => __spreadValues(__spreadValues({}, Cve), e14);
const wve = "common", Tve = "appearance", Eve = "configurations";
const Fve = { overlayType: Zq(wve, "dvPlotOverlays.type", "dvchart_plot_overlay_type", "OverlayType"), display: Zq(wve, "dvPlotOverlays.display", "enum", "Display", void 0, { enumKey: "dvchart_plot_overlay_display" }), lineStyleColor: Zq(Tve, "dvPlotOverlays.lineColor", "color", "Style.Border.Color"), lineStyleStyle: Zq(Tve, "dvPlotOverlays.lineStyle", "line_style", "Style.Border.Style", void 0, { enumKey: "border_style" }), lineStyleWidth: Zq(Tve, "dvPlotOverlays.lineWidth", "length", "Style.Border.Width", void 0, qq.lineWidth), backgroundColor: Zq(Tve, "dvPlotOverlays.backgroundColor", "color", "Style.BackgroundColor"), field: Zq(Eve, "dvPlotOverlays.field", "dvchart_overlay_fields", "Field"), detailLevel: Zq(Eve, "dvPlotOverlays.detailLevel", "enum", "DetailLevel", void 0, { enumKey: "dvchart_plot_overlay_detail_level" }), legendLabel: Zq(Eve, "dvPlotOverlays.legendLabel", "string", "LegendLabel"), axisAndValue: Zq(Eve, "dvPlotOverlays.value", "dvchart_overlay_axis_value", ""), value: Zq(Eve, "dvPlotOverlays.value", "string", "Value"), axis: Zq(Eve, "dvPlotOverlays.axis", "enum", "Axis", void 0, { enumKey: "dvchart_plot_overlay_axis" }), aggregateType: Zq(Eve, "dvPlotOverlays.aggregateType", "enum", "AggregateType", void 0, { enumKey: "dvchart_plot_overlay_aggregate_type" }), start: Zq(Eve, "dvPlotOverlays.start", "number", "Start", void 0, Gq.integer), end: Zq(Eve, "dvPlotOverlays.end", "number", "End", void 0, Gq.integer), order: Zq(Eve, "dvPlotOverlays.order", "number", "Order", void 0, Gq.integer), period: Zq(Eve, "dvPlotOverlays.period", "number", "Period", void 0, Gq.integerPositive), forwardForecastPeriod: Zq(Eve, "dvPlotOverlays.forwardForecastPeriod", "number", "ForwardForecastPeriod", void 0, Gq.integerPositive), backwardForecastPeriod: Zq(Eve, "dvPlotOverlays.backwardForecastPeriod", "number", "BackwardForecastPeriod", void 0, Gq.integerPositive), intercept: Zq(Eve, "dvPlotOverlays.intercept", "number", "Intercept", void 0, { numberType: "Integer", step: 1, emptyValue: "Null" }) };
const Mve = [Fve.overlayType, Fve.display, Fve.lineStyleWidth, Fve.lineStyleStyle, Fve.lineStyleColor];
const kve = (e14) => {
  switch (e14) {
    case "ReferenceLine":
      return [Fve.axisAndValue, Fve.field, Fve.aggregateType, Fve.legendLabel, Fve.detailLevel];
    case "ReferenceBand":
      return [Fve.axis, Fve.start, Fve.end, Fve.backgroundColor];
    case "MovingAnnualTotalTrendline":
    case "MovingAverageTrendline":
    case "CumulativeMovingAverageTrendline":
    case "ExponentialMovingAverageTrendline":
    case "WeightedMovingAverageTrendline":
      return [Fve.period, Fve.field, Fve.legendLabel, Fve.detailLevel];
    case "FourierTrendline":
    case "PolynomialTrendline":
      return [Fve.intercept, Fve.order, Fve.forwardForecastPeriod, Fve.backwardForecastPeriod, Fve.field, Fve.legendLabel, Fve.detailLevel];
    case "LinearTrendline":
    case "ExponentialTrendline":
      return [Fve.intercept, Fve.forwardForecastPeriod, Fve.backwardForecastPeriod, Fve.field, Fve.legendLabel, Fve.detailLevel];
    case "PowerTrendline":
    case "LogarithmicTrendline":
      return [Fve.forwardForecastPeriod, Fve.backwardForecastPeriod, Fve.field, Fve.legendLabel, Fve.detailLevel];
    default:
      return [];
  }
};
const Pve = (e14, t10, n10) => ({ Key: e14, Value: t10, Caption: n10 });
const Nve = (e14, t10, n10 = "", r10) => {
  if (!e14.Encodings.hasOwnProperty(t10)) throw Error(`Plot '${e14.PlotName}' does not have encoding '${t10}'`);
  switch (t10) {
    case "Category":
    case "Shape":
    case "Size": {
      const r11 = e14.Encodings[t10];
      const o11 = AV(r11, { Field: { Value: { $push: [bye(n10)] } } });
      return AV(e14, { Encodings: { [t10]: { $set: o11 } } });
    }
    case "Color": {
      const r11 = e14.Encodings[t10];
      const o11 = AV(r11.Field.Value.filter((e15) => e15.Value !== ive), { $push: [bye(n10)] });
      const a11 = AV(r11, { Field: { Value: { $set: o11 } } });
      return AV(e14, { Encodings: { [t10]: { $set: a11 } }, Config: { UnpivotData: { $set: false } } });
    }
    case "Texts": {
      const r11 = e14.Encodings.Texts.map((e15) => e15.Field.TemplateKey);
      const o11 = AV(((e15 = {}) => __spreadValues(__spreadValues({}, mye), e15))(), { Field: { Value: { $set: n10 }, TemplateKey: { $set: kG(TG("dvcharttextencoding"), r11, true) } } });
      return AV(e14, { Encodings: { [t10]: { $push: [o11] } } });
    }
  }
  if ("Details" === t10) {
    let r11 = "None";
    switch (e14.PlotChartType) {
      case "Pyramid":
        r11 = "Ascending";
        break;
      case "Funnel":
        r11 = "Descending";
    }
    let o11 = "None";
    switch (e14.PlotChartSubtype) {
      case "Clustered":
        o11 = "Cluster";
        break;
      case "Stacked":
        o11 = "Stack";
    }
    const a11 = AV(yye(), { Group: { $set: o11 }, Sort: { $set: r11 }, Field: { Value: { $set: [n10] } } });
    return AV(e14, { Encodings: { [t10]: { $push: [a11] } }, Config: { UnpivotData: { $set: false } } });
  }
  if ("Values" !== t10) throw new Error(`Invalid dv-chart encoding: ${t10}`);
  let o10;
  let a10 = e14.Encodings.Color;
  switch (e14.PlotChartType) {
    case "Custom":
    case "Column":
    case "PolarColumn":
    case "Bar":
    case "PolarBar":
    case "Area":
    case "Line":
    case "RadarLine":
    case "RadarArea":
    case "Pie":
    case "Pyramid":
    case "Funnel":
    case "Gauge":
      o10 = gye({ Field: { FieldType: "Simple", Value: [{ Value: n10, Caption: "" }] } });
      break;
    case "Bubble":
    case "Scatter":
    case "RadarBubble":
    case "RadarScatter":
      o10 = gye({ Field: { FieldType: "Simple", Value: [{ Value: n10, Caption: "" }, { Value: "", Caption: "" }] } });
      break;
    case "Gantt":
      o10 = gye({ Field: { FieldType: "Complex", Subfields: [Pve("lower", n10, ""), Pve("upper", "", "")] } });
      break;
    case "HighLowClose":
      o10 = gye({ Field: { FieldType: "Complex", Subfields: [Pve("high", n10, ""), Pve("low", "", ""), Pve("close", "", "")] } });
      break;
    case "Candlestick":
    case "HighLowOpenClose":
      o10 = gye({ Field: { FieldType: "Complex", Subfields: [Pve("high", n10, ""), Pve("low", "", ""), Pve("open", "", ""), Pve("close", "", "")] } });
      break;
    case "RangeArea":
    case "RangeBar":
    case "RangeColumn": {
      o10 = gye({ Field: { FieldType: "Complex", Subfields: [Pve("lower", n10, ""), Pve("upper", "", "")] } });
      const { Color: t11, Color: { Field: { Value: r11 } }, Values: i11 } = e14.Encodings;
      const s10 = i11.length >= 1;
      if (s10 && r11.some((e15) => e15.Value !== ive)) break;
      if (s10) {
        const e15 = AV(r11, { $set: [bye(ive)] });
        a10 = AV(t11, { Field: { Value: { $set: e15 } } });
      }
      break;
    }
  }
  const i10 = void 0 !== r10 ? r10 : e14.Encodings.Values.length;
  return AV(e14, { Encodings: { Values: { $splice: [[i10, 0, o10]] }, Color: { $set: a10 } } });
};
const Dve = { Type: "dvchartplotcustomlabel", Style: { Color: "Black", FontFamily: "Arial", FontSize: "10pt", FontStyle: "Normal", FontWeight: "Normal", TextDecoration: "None", WritingMode: "lr-tb" }, Text: "", OffsetX: "0in", OffsetY: "0.5in" };
const Lve = (e14) => __spreadValues(__spreadValues({}, Dve), e14);
const Hve = { Type: "dvchartplotpointer", Style: { BackgroundColor: "Black" }, NeedleWidth: "0in", NeedlePinWidth: "0in", End: "" };
const Ive = (e14) => __spreadValues(__spreadValues({}, Hve), e14);
const _ve = { TargetProperty: "BackgroundColor", Value: "Black" };
const Vve = { Type: "dvchartrule", Name: "", Condition: "", RuleProperties: [] };
const Rve = (e14) => __spreadValues(__spreadValues({}, _ve), e14);
const Ave = (e14) => __spreadValues(__spreadValues({}, Vve), e14);
const Ove = (e14, { payload: { ruleIndex: t10 } }) => !!e14.Config.Rules[t10];
const Bve = (e14, { payload: { name: t10 } }) => AV(e14, { Config: { Rules: { $push: [Ave({ Name: t10 })] } } });
const zve = (e14, { payload: { ruleIndex: t10 } }) => AV(e14, { Config: { Rules: { $splice: [[t10, 1]] } } });
const $ve = (e14, { payload: { ruleIndex: t10, rule: n10 } }) => AV(e14, { Config: { Rules: { [t10]: { $set: n10 } } } });
const Wve = (e14, { payload: { overlayIndex: t10 } }) => !!e14.Config.Overlays[t10];
const jve = (e14, { payload: { name: t10 } }) => AV(e14, { Config: { Overlays: { $push: [xve({ Name: t10 })] } } });
const Zve = (e14, { payload: { overlayIndex: t10 } }) => AV(e14, { Config: { Overlays: { $splice: [[t10, 1]] } } });
const Gve = (e14, { payload: { overlayIndex: t10, overlay: n10 } }) => AV(e14, { Config: { Overlays: { [t10]: { $set: n10 } } } });
const Uve = (e14, { payload: { name: t10 = "" } }) => AV(e14, { Config: { CustomLabels: { $push: [Lve({ Text: t10 })] } } });
const qve = (e14, { payload: { labelIndex: t10 } }) => {
  const n10 = ij(e14) ? dj(lj(e14), true, true) : e14;
  return AV(n10, { Config: { CustomLabels: { $splice: [[t10, 1]] } } });
};
const Yve = (e14, { payload: { name: t10 = "" } }) => AV(e14, { Config: { Pointers: { $push: [Ive({ End: t10 })] } } });
const Kve = (e14, { payload: { pointerIndex: t10 } }) => {
  const n10 = ij(e14) ? dj(lj(e14), true, true) : e14;
  return AV(n10, { Config: { Pointers: { $splice: [[t10, 1]] } } });
};
const Xve = (e14, { payload: { encodingName: t10, value: n10 } }) => Nve(e14, t10, n10);
const Jve = (e14, { payload: { encodingName: t10, valueIndex: n10 } }) => {
  const r10 = {};
  let o10 = true;
  switch (t10) {
    case "Color":
    case "Shape":
    case "Size":
    case "Category":
      r10[t10] = { Field: { Value: { $splice: [[n10, 1]] } } }, o10 = false;
      break;
    case "Texts":
    case "Details":
    case "Values":
      if (r10[t10] = { $splice: [[n10, 1]] }, o10 = false, e14.Encodings.Values.length <= 2) {
        const { Value: t11 } = e14.Encodings.Color.Field;
        const n11 = "Color";
        t11.some((e15) => e15.Value === ive) && (r10[n11] = { Field: { Value: { $set: [] } } });
      }
  }
  if (o10) return e14;
  const a10 = ij(e14) ? dj(lj(e14), true, true) : e14;
  return AV(a10, { Encodings: r10 });
};
const Qve = (e14, { payload: { value: t10 } }) => AV(e14, t10 ? { Config: { UnpivotData: { $set: true } }, Encodings: { Color: { Field: { Value: { $set: [] } } }, Details: { $set: [] } } } : { Config: { UnpivotData: { $set: false } } });
const ebe = Wye;
function tbe(e14) {
  const t10 = nz.of(e14).of("rdlx").getDefaultReducer();
  const n10 = Uye(0, { [Dye]: Bve, [Lye]: GV(Ove, zve), [Hye]: GV(Ove, $ve), [Iye]: jve, [_ye]: GV(Wve, Zve), [Vye]: GV(Wve, Gve), [$ye.addPlotCustomLabel.type]: GV(ij, Uve), [$ye.deletePlotCustomLabel.type]: qve, [$ye.addPlotPointer.type]: GV(ij, Yve), [$ye.deletePlotPointer.type]: Kve, [Rye]: GV(ij, Xve), [Aye]: Jve, [zye]: Qve }, t10);
  return GV(rj, n10, Uye(0, { [Rye]: Xve, [Aye]: Jve, [$ye.addPlotCustomLabel.type]: Uve, [$ye.addPlotPointer.type]: Yve, [$ye.deletePlotPointer.type]: Kve, [$ye.deletePlotCustomLabel.type]: qve }, ebe));
}
const nbe = { Values: ["{valueField.name}", "{valueField.value}", "{PercentageDetail:p0}", "{PercentageCategory:p0}"], Category: ["{categoryField.name}", "{categoryField.value}"], Details: ["{detailFields.name}", "{detailFields.value}"], Color: ["{colorField.name}", "{colorField.value}"], Shape: ["{shapeField.name}", "{shapeField.value}"], Size: ["{sizeField.name}", "{sizeField.value}"], Texts: [] };
const rbe = (e14) => yve[e14] || yve.Custom;
const obe = (e14) => {
  const t10 = zV.uniq(e14).map((e15) => ((e16) => {
    const t11 = rbe(e16);
    return Object.keys(t11).filter((e17) => t11[e17]).flatMap((e17) => nbe[e17]);
  })(e15));
  return zV.intersection(...t10);
};
const abe = (e14) => {
  const t10 = e14.Encodings.Values || [];
  const n10 = e14.Encodings.Category.Field.Value || [];
  switch (e14.PlotChartType) {
    case "Candlestick":
    case "HighLowClose":
    case "HighLowOpenClose":
      return t10.length > 0 && n10.length > 0;
    default:
      return t10.length > 0;
  }
};
const ibe = (e14) => e14.reduce((e15, t10) => {
  var _a2;
  return [...e15, ...(_a2 = lve[t10]) != null ? _a2 : []];
}, []);
const sbe = (e14, t10) => {
  let n10 = e14;
  return t10.includes("Color") || (n10 = AV(n10, { Encodings: { Color: { $set: fye() } } })), t10.includes("Shape") || (n10 = AV(n10, { Encodings: { Shape: { $set: fye() } } })), t10.includes("Size") || (n10 = AV(n10, { Encodings: { Size: { $set: fye() } } })), t10.includes("Category") || (n10 = AV(n10, { Encodings: { Category: { $set: vye() } } })), t10.includes("Details") || (n10 = AV(n10, { Encodings: { Details: { $set: [] } } })), t10.includes("Values") || (n10 = AV(n10, { Encodings: { Values: { $set: [] } } })), t10.includes("Texts") || (n10 = AV(n10, { Encodings: { Texts: { $set: [] } } })), n10;
};
const lbe = ["Column", "Bar", "Gantt", "PolarColumn", "PolarBar"];
const cbe = (e14) => {
  const { PlotChartType: t10, Config: { BarLines: n10 } } = e14;
  return n10 && !lbe.includes(t10) ? AV(e14, { Config: { BarLines: { $set: false } } }) : e14;
};
const ube = (e14) => AV(e14, { PlotType: { $set: "Bar" }, Config: { Bar: { Overlap: { $set: "Gauge" === e14.PlotChartType ? void 0 : e14.Config.Bar.Overlap } }, AxisMode: { $set: "Cartesian" }, SwapAxes: { $set: false }, InnerRadius: { $set: 0 }, StartAngle: { $set: 0 }, Sweep: { $set: 360 }, LineAspect: { $set: "Default" }, Symbols: { $set: false }, SymbolShape: { $set: "Auto" }, Pointers: { $set: [] }, CustomLabels: { $set: [] }, LineStyle: { Style: { $set: "None" } } } });
const dbe = (e14, t10 = "None", n10 = "None") => {
  const { Encodings: { Details: r10 } } = e14;
  if (0 === r10.length) return e14;
  const o10 = (e15) => {
    const r11 = [...e15.Field.Value];
    return r11.length || r11.push(""), AV(e15, { Field: { Value: { $set: r11 } }, Group: { $set: t10 }, Sort: { $set: n10 } });
  };
  return r10.length ? AV(e14, { Encodings: { Details: { $apply: (e15) => e15.map(o10) } } }) : AV(e14, { Encodings: { Details: { $push: [yye()] } } });
};
const pbe = (e14, t10) => {
  const n10 = [...e14];
  return n10.length < t10 ? n10.push(...Array(t10 - n10.length).fill({ Value: "", Caption: "" })) : n10.length > t10 && n10.splice(t10), n10;
};
const mbe = (e14, t10 = 1) => {
  const { Encodings: { Values: n10 } } = e14;
  return 0 === n10.length ? e14 : n10.length ? AV(e14, { Encodings: { Values: { $apply: (e15) => e15.map((e16) => ((e17, t11) => {
    const { Field: n11 } = e17;
    return "Complex" === n11.FieldType ? AV(e17, { Field: { $set: { FieldType: "Simple", Value: pbe(n11.Subfields.map((e18) => ({ Value: e18.Value, Caption: e18.Caption })), t11) } } }) : AV(e17, { Field: { Value: { $set: pbe(n11.Value, t11) } } });
  })(e16, t10)) } } }) : AV(e14, { Encodings: { Values: { $push: [gye()] } } });
};
const hbe = (e14, t10) => {
  const { Encodings: { Values: n10 } } = e14;
  return 0 === n10.length ? e14 : n10.length ? AV(e14, { Encodings: { Values: { $set: n10.map((e15) => ((e16, t11) => {
    const { Field: n11 } = e16;
    const r10 = [];
    const o10 = [];
    return "Simple" === n11.FieldType && n11.Value.forEach((e17) => r10.push(e17)), t11.forEach((e17) => {
      var _a2;
      const t12 = "Complex" === n11.FieldType && n11.Subfields.find((t13) => t13.Key === e17);
      const a10 = t12 ? t12.Value : ((_a2 = r10.shift()) == null ? void 0 : _a2.Value) || "";
      o10.push({ Key: e17, Value: a10, Caption: "" });
    }), __spreadProps(__spreadValues({}, e16), { Field: { FieldType: "Complex", Subfields: o10 } });
  })(e15, t10)) } } }) : AV(e14, { Encodings: { Values: { $push: [gye()] } } });
};
const fbe = (e14, t10, n10) => {
  const { Encodings: r10 } = e14;
  if (0 === r10[t10].Field.Value.length) return e14;
  const o10 = [...r10[t10].Field.Value];
  o10.length || o10.push(bye());
  const a10 = void 0 !== n10 ? n10 : o10.length;
  return o10.length > a10 && o10.splice(a10), AV(e14, { Encodings: { [t10]: { Field: { Value: { $set: o10 } } } } });
};
const gbe = (e14) => fbe(e14, "Category");
const ybe = (e14) => fbe(e14, "Color");
const vbe = (e14) => fbe(e14, "Shape");
const bbe = (e14) => fbe(e14, "Size");
const Sbe = (e14, t10, n10) => {
  var _a2, _b2;
  const r10 = e14.Plots.map((e15, r11) => {
    return o11 = r11 !== t10 ? e15.PlotChartType : n10, bve[o11] || bve.Custom;
    var o11;
  });
  const o10 = ((_a2 = e14.PlotArea) == null ? void 0 : _a2.Legends) || [];
  const a10 = o10.filter((t11) => {
    return n11 = t11, e14.Plots.some((e15, t12) => r10[t12][n11.LegendType]);
    var n11;
  });
  const i10 = Object.keys(r10[t10]).filter((e15) => r10[t10][e15]);
  const s10 = zV.difference(i10, a10.map((e15) => e15.LegendType));
  const l10 = { Orientation: "Vertical", Style: __spreadProps(__spreadValues({}, (((_b2 = e14.PlotArea) == null ? void 0 : _b2.Legends[0]) || tve).Style), { PaddingLeft: "0pt", PaddingRight: "10pt", PaddingTop: "4pt", PaddingBottom: "2pt" }) };
  const c10 = s10.map((t11) => nve(__spreadValues({ LegendType: t11 }, l10), e14.PlotArea.Legends[0]));
  return AV(e14, { PlotArea: { Legends: { $set: [...a10, ...c10] } } });
};
const Cbe = (e14, t10, n10, r10) => {
  const { PlotArea: o10, Plots: a10 } = e14;
  const i10 = a10[n10].PlotName;
  const s10 = ((o10 == null ? void 0 : o10.Axes) || []).findIndex((e15) => e15.AxisType === t10 && e15.Plots.includes(i10));
  const l10 = o10 == null ? void 0 : o10.Axes[s10];
  let c10 = l10;
  const u10 = eve(t10, { Plots: [i10] }, e14.$templateId);
  return c10 || (c10 = u10), c10 = __spreadProps(__spreadValues({}, c10), { Position: u10.Position, MajorTicks: u10.MajorTicks }), "function" == typeof r10 && (c10 = r10(c10)), c10 === l10 ? e14 : AV(e14, -1 === s10 ? { PlotArea: { Axes: { $push: [c10] } } } : { PlotArea: { Axes: { [s10]: { $set: c10 } } } });
};
const xbe = (e14) => "None" !== e14.Position ? e14.Position : "Near";
const wbe = /p\d/;
const Tbe = (e14, t10) => Cbe(e14, "Y", t10, (e15) => {
  let t11 = e15;
  return t11 = AV(t11, { Scale: { $set: "Linear" }, Position: { $set: xbe(t11) } }), wbe.test(e15.Format) && (t11.Format = ""), t11;
});
const Ebe = (e14, t10) => Cbe(e14, "Y", t10, (e15) => {
  let t11 = e15;
  return t11 = AV(t11, { Scale: { $set: "Percentage" }, Format: { $set: "p0" }, Position: { $set: xbe(t11) } }), t11;
});
const Fbe = (e14, t10) => Cbe(e14, "Y", t10, (e15) => {
  let t11 = e15;
  return t11 = AV(t11, { Scale: { $set: "Percentage" }, Format: { $set: "p0" }, Position: { $set: "None" } }), t11;
});
const Mbe = (e14, t10) => Cbe(e14, "X", t10, (e15) => {
  let t11 = e15;
  return t11 = AV(t11, { Scale: { $set: "Linear" }, Position: { $set: xbe(t11) } }), wbe.test(e15.Format) && (t11.Format = ""), t11;
});
const kbe = (e14, t10) => Cbe(e14, "X", t10, (e15) => {
  let t11 = e15;
  return t11 = AV(t11, { Scale: { $set: "Linear" }, Position: { $set: "None" } }), wbe.test(e15.Format) && (t11.Format = ""), t11;
});
const Pbe = (e14, t10, n10, r10, o10, a10) => AV(e14, { Bar: { BottomWidth: { $set: t10 }, NeckHeight: { $set: n10 }, Overlap: { $set: r10 }, TopWidth: { $set: o10 }, Width: { $set: a10 } } });
const Nbe = { bar: (e14, t10) => {
  let n10 = e14;
  n10 = Sbe(n10, t10, "Bar");
  const { barBottomWidth: r10, barTopWidth: o10, barWidth: a10 } = Xye();
  return n10 = Pbe(n10, r10, 1, 0, o10, a10), n10 = Mbe(n10, t10), n10 = Tbe(n10, t10), n10 = AV(n10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    return t11 = ube(t11), t11 = AV(t11, { PlotType: { $set: "Bar" }, PlotChartType: { $set: "Bar" }, PlotChartSubtype: { $set: "Clustered" }, Config: { SwapAxes: { $set: true } } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category", "Details", "Color", "Texts"]), t11 = mbe(t11, 1), t11 = dbe(t11, "Cluster"), t11 = gbe(t11), t11 = ybe(t11), t11;
  } } } }), n10;
}, barStacked: (e14, t10) => {
  let n10 = e14;
  n10 = Sbe(n10, t10, "Bar");
  const { barBottomWidth: r10, barTopWidth: o10, barWidth: a10 } = Xye();
  return n10 = Pbe(n10, r10, 1, 0, o10, a10), n10 = Mbe(n10, t10), n10 = Tbe(n10, t10), n10 = AV(n10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    return t11 = ube(t11), t11 = AV(t11, { PlotType: { $set: "Bar" }, PlotChartType: { $set: "Bar" }, PlotChartSubtype: { $set: "Stacked" }, Config: { SwapAxes: { $set: true } } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category", "Details", "Color", "Texts"]), t11 = mbe(t11, 1), t11 = dbe(t11, "Stack"), t11 = gbe(t11), t11 = ybe(t11), t11;
  } } } }), n10;
}, barPercentStacked: (e14, t10) => {
  let n10 = e14;
  n10 = Sbe(n10, t10, "Bar");
  const { barBottomWidth: r10, barTopWidth: o10, barWidth: a10 } = Xye();
  return n10 = Pbe(n10, r10, 1, 0, o10, a10), n10 = Mbe(n10, t10), n10 = Ebe(n10, t10), n10 = AV(n10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    return t11 = ube(t11), t11 = AV(t11, { PlotType: { $set: "Bar" }, PlotChartType: { $set: "Bar" }, PlotChartSubtype: { $set: "Stacked" }, Config: { SwapAxes: { $set: true } } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category", "Details", "Color", "Texts"]), t11 = mbe(t11, 1), t11 = dbe(t11, "Stack"), t11 = gbe(t11), t11 = ybe(t11), t11;
  } } } }), n10;
}, column: (e14, t10) => {
  const n10 = "Column";
  let r10 = e14;
  r10 = Sbe(r10, t10, n10);
  const { barBottomWidth: o10, barTopWidth: a10, barWidth: i10 } = Xye();
  return r10 = Pbe(r10, o10, 1, 0, a10, i10), r10 = Mbe(r10, t10), r10 = Tbe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    return t11 = ube(t11), t11 = AV(t11, { PlotType: { $set: "Bar" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Clustered" } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category", "Details", "Color", "Texts"]), t11 = mbe(t11, 1), t11 = dbe(t11, "Cluster"), t11 = gbe(t11), t11 = ybe(t11), t11;
  } } } }), r10;
}, columnStacked: (e14, t10) => {
  const n10 = "Column";
  let r10 = e14;
  r10 = Sbe(r10, t10, n10);
  const { barBottomWidth: o10, barTopWidth: a10, barWidth: i10 } = Xye();
  return r10 = Pbe(r10, o10, 1, 0, a10, i10), r10 = Mbe(r10, t10), r10 = Tbe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    return t11 = ube(t11), t11 = AV(t11, { PlotType: { $set: "Bar" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Stacked" } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category", "Details", "Color", "Texts"]), t11 = mbe(t11, 1), t11 = dbe(t11, "Stack"), t11 = gbe(t11), t11 = ybe(t11), t11;
  } } } }), r10;
}, columnPercentStacked: (e14, t10) => {
  const n10 = "Column";
  let r10 = e14;
  r10 = Sbe(r10, t10, n10);
  const { barBottomWidth: o10, barTopWidth: a10, barWidth: i10 } = Xye();
  return r10 = Pbe(r10, o10, 1, 0, a10, i10), r10 = Mbe(r10, t10), r10 = Ebe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    return t11 = ube(t11), t11 = AV(t11, { PlotType: { $set: "Bar" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Stacked" } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category", "Details", "Color", "Texts"]), t11 = mbe(t11, 1), t11 = dbe(t11, "Stack"), t11 = gbe(t11), t11 = ybe(t11), t11;
  } } } }), r10;
}, line: (e14, t10) => {
  const n10 = "Line";
  let r10 = e14;
  return r10 = Sbe(r10, t10, n10), r10 = Mbe(r10, t10), r10 = Tbe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    return t11 = ube(t11), t11 = AV(t11, { PlotType: { $set: "Line" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Clustered" }, Config: { Symbols: { $set: true }, SymbolShape: { $set: "Auto" }, LineAspect: { $set: "Default" }, LineStyle: { Style: { $set: "Solid" } }, UnpivotData: { $set: false } } }), t11 = cbe(t11), t11 = mbe(t11, 1), t11 = gbe(t11), t11 = dbe(t11, "Cluster"), t11 = ybe(t11), t11;
  } } } }), r10;
}, lineSmooth: (e14, t10) => {
  const n10 = "Line";
  let r10 = e14;
  return r10 = Sbe(r10, t10, n10), r10 = Mbe(r10, t10), r10 = Tbe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    return t11 = ube(t11), t11 = AV(t11, { PlotType: { $set: "Line" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Clustered" }, Config: { Symbols: { $set: true }, SymbolShape: { $set: "Auto" }, LineAspect: { $set: "Spline" }, LineStyle: { Style: { $set: "Solid" } }, UnpivotData: { $set: false } } }), t11 = cbe(t11), t11 = mbe(t11, 1), t11 = gbe(t11), t11 = dbe(t11, "Cluster"), t11 = ybe(t11), t11;
  } } } }), r10;
}, area: (e14, t10) => {
  const n10 = "Area";
  let r10 = e14;
  return r10 = Sbe(r10, t10, n10), r10 = Mbe(r10, t10), r10 = Tbe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    return t11 = ube(t11), t11 = AV(t11, { PlotType: { $set: "Area" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Clustered" } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category", "Details", "Color", "Texts"]), t11 = mbe(t11, 1), t11 = dbe(t11, "Cluster"), t11 = gbe(t11), t11 = ybe(t11), t11;
  } } } }), r10;
}, areaStacked: (e14, t10) => {
  const n10 = "Area";
  let r10 = e14;
  return r10 = Sbe(r10, t10, n10), r10 = Mbe(r10, t10), r10 = Tbe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    return t11 = ube(t11), t11 = AV(t11, { PlotType: { $set: "Area" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Stacked" } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category", "Details", "Color", "Texts"]), t11 = mbe(t11, 1), t11 = dbe(t11, "Stack"), t11 = gbe(t11), t11 = ybe(t11), t11;
  } } } }), r10;
}, areaPercentStacked: (e14, t10) => {
  const n10 = "Area";
  let r10 = e14;
  return r10 = Sbe(r10, t10, n10), r10 = Mbe(r10, t10), r10 = Ebe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    return t11 = ube(t11), t11 = AV(t11, { PlotType: { $set: "Area" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Stacked" } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category", "Details", "Color", "Texts"]), t11 = mbe(t11, 1), t11 = dbe(t11, "Stack"), t11 = gbe(t11), t11 = ybe(t11), t11;
  } } } }), r10;
}, pie: (e14, t10) => {
  let n10 = e14;
  n10 = Sbe(n10, t10, "Pie");
  const { barBottomWidth: r10, barTopWidth: o10 } = Xye();
  return n10 = Pbe(n10, r10, 1, 0, o10, 1), n10 = kbe(n10, t10), n10 = Fbe(n10, t10), n10 = AV(n10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    t11 = ube(t11);
    const { StartAngle: n11 } = ove();
    return t11 = AV(t11, { PlotType: { $set: "Bar" }, PlotChartType: { $set: "Pie" }, PlotChartSubtype: { $set: "Stacked" }, Config: { AxisMode: { $set: "Radial" }, StartAngle: { $set: n11 } } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Details", "Color", "Texts"]), t11 = mbe(t11, 1), t11 = dbe(t11, "Stack"), t11 = ybe(t11), t11;
  } } } }), n10;
}, doughnut: (e14, t10) => {
  let n10 = e14;
  n10 = Sbe(n10, t10, "Pie");
  const { barBottomWidth: r10, barTopWidth: o10 } = Xye();
  return n10 = Pbe(n10, r10, 1, 0, o10, 1), n10 = kbe(n10, t10), n10 = Fbe(n10, t10), n10 = AV(n10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    t11 = ube(t11);
    const { InnerRadius: n11, StartAngle: r11 } = ove();
    return t11 = AV(t11, { PlotType: { $set: "Bar" }, PlotChartType: { $set: "Pie" }, PlotChartSubtype: { $set: "Stacked" }, Config: { AxisMode: { $set: "Radial" }, InnerRadius: { $set: n11 }, StartAngle: { $set: r11 } } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Details", "Color", "Texts"]), t11 = mbe(t11, 1), t11 = dbe(t11, "Stack"), t11 = ybe(t11), t11;
  } } } }), n10;
}, pyramid: (e14, t10) => {
  const n10 = "Pyramid";
  let r10 = e14;
  return r10 = Sbe(r10, t10, n10), r10 = Pbe(r10, 0.9, 0, 0, 0, 0), r10 = kbe(r10, t10), r10 = Ebe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    return t11 = ube(t11), t11 = AV(t11, { PlotType: { $set: "Bar" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Stacked" } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Details", "Color", "Texts"]), t11 = mbe(t11, 1), t11 = dbe(t11, "Stack", "Ascending"), t11 = ybe(t11), t11;
  } } } }), r10;
}, funnel: (e14, t10) => {
  const n10 = "Funnel";
  let r10 = e14;
  return r10 = Sbe(r10, t10, n10), r10 = Pbe(r10, 0.3, 0, 0, 0.9, 0.9), r10 = kbe(r10, t10), r10 = Ebe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    return t11 = ube(t11), t11 = AV(t11, { PlotType: { $set: "Bar" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Stacked" } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Details", "Color", "Texts"]), t11 = mbe(t11, 1), t11 = dbe(t11, "Stack", "Descending"), t11 = ybe(t11), t11;
  } } } }), r10;
}, scatter: (e14, t10) => {
  const n10 = "Scatter";
  let r10 = e14;
  return r10 = Sbe(r10, t10, n10), r10 = Mbe(r10, t10), r10 = Tbe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    return t11 = ube(t11), t11 = AV(t11, { PlotType: { $set: "Scatter" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Clustered" }, Config: { SymbolShape: { $set: "Auto" }, UnpivotData: { $set: false } } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category", "Color", "Details", "Shape", "Texts"]), t11 = mbe(t11, 2), t11 = dbe(t11, "Cluster"), t11 = vbe(t11), t11;
  } } } }), r10;
}, bubble: (e14, t10) => {
  const n10 = "Bubble";
  let r10 = e14;
  return r10 = Sbe(r10, t10, n10), r10 = Mbe(r10, t10), r10 = Tbe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    return t11 = ube(t11), t11 = AV(t11, { PlotType: { $set: "Scatter" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Clustered" }, Config: { SymbolShape: { $set: "Dot" }, UnpivotData: { $set: false } } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category", "Color", "Details", "Size", "Texts"]), t11 = mbe(t11, 2), t11 = dbe(t11, "Cluster"), t11 = bbe(t11), t11;
  } } } }), r10;
}, gantt: (e14, t10) => {
  const n10 = "Gantt";
  let r10 = e14;
  r10 = Sbe(r10, t10, n10);
  const { barBottomWidth: o10, barTopWidth: a10, barWidth: i10 } = Xye();
  return r10 = Pbe(r10, o10, 1, 0, a10, i10), r10 = Mbe(r10, t10), r10 = Tbe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    return t11 = ube(t11), t11 = AV(t11, { PlotType: { $set: "Bar" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Clustered" }, Config: { SwapAxes: { $set: true }, UnpivotData: { $set: false } } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category", "Color", "Details", "Texts"]), t11 = hbe(t11, ["lower", "upper"]), t11 = gbe(t11), t11 = dbe(t11, "Cluster"), t11 = ybe(t11), t11;
  } } } }), r10;
}, candlestick: (e14, t10) => {
  const n10 = "Candlestick";
  let r10 = e14;
  r10 = Sbe(r10, t10, n10);
  const { barBottomWidth: o10, barTopWidth: a10, barWidth: i10 } = Xye();
  return r10 = Pbe(r10, o10, 1, 0, a10, i10), r10 = Mbe(r10, t10), r10 = Tbe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    return t11 = ube(t11), t11 = AV(t11, { PlotType: { $set: "Candlestick" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Plain" }, Config: { LineStyle: { Style: { $set: "Solid" } }, UnpivotData: { $set: false } } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category"]), t11 = hbe(t11, ["high", "low", "open", "close"]), t11 = gbe(t11), t11;
  } } } }), r10;
}, highLowClose: (e14, t10) => {
  const n10 = "HighLowClose";
  let r10 = e14;
  r10 = Sbe(r10, t10, n10);
  const { barBottomWidth: o10, barTopWidth: a10, barWidth: i10 } = Xye();
  return r10 = Pbe(r10, o10, 1, 0, a10, i10), r10 = Mbe(r10, t10), r10 = Tbe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    return t11 = ube(t11), t11 = AV(t11, { PlotType: { $set: "HighLowOpenClose" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Plain" }, Config: { LineStyle: { Style: { $set: "Solid" } }, UnpivotData: { $set: false } } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category"]), t11 = hbe(t11, ["high", "low", "close"]), t11 = gbe(t11), t11;
  } } } }), r10;
}, highLowOpenClose: (e14, t10) => {
  const n10 = "HighLowOpenClose";
  let r10 = e14;
  r10 = Sbe(r10, t10, n10);
  const { barBottomWidth: o10, barTopWidth: a10, barWidth: i10 } = Xye();
  return r10 = Pbe(r10, o10, 1, 0, a10, i10), r10 = Mbe(r10, t10), r10 = Tbe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    return t11 = ube(t11), t11 = AV(t11, { PlotType: { $set: "HighLowOpenClose" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Plain" }, Config: { LineStyle: { Style: { $set: "Solid" } }, UnpivotData: { $set: false } } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category"]), t11 = hbe(t11, ["high", "low", "open", "close"]), t11 = gbe(t11), t11;
  } } } }), r10;
}, polarColumn: (e14, t10) => {
  const n10 = "PolarColumn";
  let r10 = e14;
  r10 = Sbe(r10, t10, n10);
  const { barBottomWidth: o10, barTopWidth: a10, barWidth: i10 } = Xye();
  return r10 = Pbe(r10, o10, 1, 0, a10, i10), r10 = Mbe(r10, t10), r10 = Tbe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    t11 = ube(t11);
    const { StartAngle: r11 } = ove();
    return t11 = AV(t11, { PlotType: { $set: "Bar" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Clustered" }, Config: { AxisMode: { $set: "Radial" }, StartAngle: { $set: r11 } } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category", "Details", "Color", "Texts"]), t11 = mbe(t11, 1), t11 = dbe(t11, "Cluster"), t11 = gbe(t11), t11 = ybe(t11), t11;
  } } } }), r10;
}, polarColumnStacked: (e14, t10) => {
  const n10 = "PolarColumn";
  let r10 = e14;
  r10 = Sbe(r10, t10, n10);
  const { barBottomWidth: o10, barTopWidth: a10, barWidth: i10 } = Xye();
  return r10 = Pbe(r10, o10, 1, 0, a10, i10), r10 = Mbe(r10, t10), r10 = Tbe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    t11 = ube(t11);
    const { StartAngle: r11 } = ove();
    return t11 = AV(t11, { PlotType: { $set: "Bar" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Stacked" }, Config: { AxisMode: { $set: "Radial" }, StartAngle: { $set: r11 } } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category", "Details", "Color", "Texts"]), t11 = mbe(t11, 1), t11 = dbe(t11, "Stack"), t11 = gbe(t11), t11 = ybe(t11), t11;
  } } } }), r10;
}, polarColumnPercentStacked: (e14, t10) => {
  const n10 = "PolarColumn";
  let r10 = e14;
  r10 = Sbe(r10, t10, n10);
  const { barBottomWidth: o10, barTopWidth: a10, barWidth: i10 } = Xye();
  return r10 = Pbe(r10, o10, 1, 0, a10, i10), r10 = Mbe(r10, t10), r10 = Ebe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    t11 = ube(t11);
    const { StartAngle: r11 } = ove();
    return t11 = AV(t11, { PlotType: { $set: "Bar" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Stacked" }, Config: { AxisMode: { $set: "Radial" }, StartAngle: { $set: r11 } } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category", "Details", "Color", "Texts"]), t11 = mbe(t11, 1), t11 = dbe(t11, "Stack"), t11 = gbe(t11), t11 = ybe(t11), t11;
  } } } }), r10;
}, polarBar: (e14, t10) => {
  const n10 = "PolarBar";
  let r10 = e14;
  r10 = Sbe(r10, t10, n10);
  const { barBottomWidth: o10, barTopWidth: a10, barWidth: i10 } = Xye();
  return r10 = Pbe(r10, o10, 1, 0, a10, i10), r10 = Mbe(r10, t10), r10 = Tbe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    t11 = ube(t11);
    const { StartAngle: r11 } = ove();
    return t11 = AV(t11, { PlotType: { $set: "Bar" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Clustered" }, Config: { SwapAxes: { $set: true }, AxisMode: { $set: "Radial" }, StartAngle: { $set: r11 } } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category", "Details", "Color", "Texts"]), t11 = mbe(t11, 1), t11 = dbe(t11, "Cluster"), t11 = gbe(t11), t11 = ybe(t11), t11;
  } } } }), r10;
}, polarBarStacked: (e14, t10) => {
  const n10 = "PolarBar";
  let r10 = e14;
  r10 = Sbe(r10, t10, n10);
  const { barBottomWidth: o10, barTopWidth: a10, barWidth: i10 } = Xye();
  return r10 = Pbe(r10, o10, 1, 0, a10, i10), r10 = Mbe(r10, t10), r10 = Tbe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    t11 = ube(t11);
    const { StartAngle: r11 } = ove();
    return t11 = AV(t11, { PlotType: { $set: "Bar" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Stacked" }, Config: { SwapAxes: { $set: true }, AxisMode: { $set: "Radial" }, StartAngle: { $set: r11 } } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category", "Details", "Color", "Texts"]), t11 = mbe(t11, 1), t11 = dbe(t11, "Stack"), t11 = gbe(t11), t11 = ybe(t11), t11;
  } } } }), r10;
}, polarBarPercentStacked: (e14, t10) => {
  const n10 = "PolarBar";
  let r10 = e14;
  r10 = Sbe(r10, t10, n10);
  const { barBottomWidth: o10, barTopWidth: a10, barWidth: i10 } = Xye();
  return r10 = Pbe(r10, o10, 1, 0, a10, i10), r10 = Mbe(r10, t10), r10 = Ebe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    t11 = ube(t11);
    const { StartAngle: r11 } = ove();
    return t11 = AV(t11, { PlotType: { $set: "Bar" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Stacked" }, Config: { SwapAxes: { $set: true }, AxisMode: { $set: "Radial" }, StartAngle: { $set: r11 } } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category", "Details", "Color", "Texts"]), t11 = mbe(t11, 1), t11 = dbe(t11, "Stack"), t11 = gbe(t11), t11 = ybe(t11), t11;
  } } } }), r10;
}, radarArea: (e14, t10) => {
  const n10 = "RadarArea";
  let r10 = e14;
  r10 = Sbe(r10, t10, n10);
  const { barBottomWidth: o10, barTopWidth: a10, barWidth: i10 } = Xye();
  return r10 = Pbe(r10, o10, 1, 0, a10, i10), r10 = Mbe(r10, t10), r10 = Tbe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    t11 = ube(t11);
    const { StartAngle: r11 } = ove();
    return t11 = AV(t11, { PlotType: { $set: "Area" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Clustered" }, Config: { SwapAxes: { $set: true }, AxisMode: { $set: "Polygonal" }, StartAngle: { $set: r11 } } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category", "Details", "Color", "Texts"]), t11 = mbe(t11, 1), t11 = dbe(t11, "Cluster"), t11 = gbe(t11), t11 = ybe(t11), t11;
  } } } }), r10;
}, radarBubble: (e14, t10) => {
  const n10 = "RadarBubble";
  let r10 = e14;
  return r10 = Sbe(r10, t10, n10), r10 = Mbe(r10, t10), r10 = Tbe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    t11 = ube(t11);
    const { StartAngle: r11 } = ove();
    return t11 = AV(t11, { PlotType: { $set: "Scatter" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Clustered" }, Config: { SwapAxes: { $set: true }, AxisMode: { $set: "Polygonal" }, StartAngle: { $set: r11 }, SymbolShape: { $set: "Dot" }, UnpivotData: { $set: false } } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category", "Color", "Details", "Size", "Texts"]), t11 = mbe(t11, 2), t11 = dbe(t11, "Cluster"), t11 = bbe(t11), t11;
  } } } }), r10;
}, radarScatter: (e14, t10) => {
  const n10 = "RadarScatter";
  let r10 = e14;
  return r10 = Sbe(r10, t10, n10), r10 = Mbe(r10, t10), r10 = Tbe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    t11 = ube(t11);
    const { StartAngle: r11 } = ove();
    return t11 = AV(t11, { PlotType: { $set: "Scatter" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Clustered" }, Config: { SwapAxes: { $set: true }, AxisMode: { $set: "Polygonal" }, StartAngle: { $set: r11 }, SymbolShape: { $set: "Auto" }, UnpivotData: { $set: false } } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category", "Color", "Details", "Shape", "Texts"]), t11 = mbe(t11, 2), t11 = dbe(t11, "Cluster"), t11 = vbe(t11), t11;
  } } } }), r10;
}, radarLine: (e14, t10) => {
  const n10 = "RadarLine";
  let r10 = e14;
  return r10 = Sbe(r10, t10, n10), r10 = Mbe(r10, t10), r10 = Tbe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    t11 = ube(t11);
    const { StartAngle: r11 } = ove();
    return t11 = AV(t11, { PlotType: { $set: "Line" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Clustered" }, Config: { SwapAxes: { $set: true }, AxisMode: { $set: "Polygonal" }, StartAngle: { $set: r11 }, Symbols: { $set: true }, SymbolShape: { $set: "Auto" }, LineAspect: { $set: "Default" }, LineStyle: { Style: { $set: "Solid" } }, UnpivotData: { $set: false } } }), t11 = cbe(t11), t11 = mbe(t11, 1), t11 = gbe(t11), t11 = dbe(t11, "Cluster"), t11 = ybe(t11), t11;
  } } } }), r10;
}, rangeBar: (e14, t10) => {
  const n10 = "RangeBar";
  let r10 = e14;
  r10 = Sbe(r10, t10, n10);
  const { barBottomWidth: o10, barTopWidth: a10, barWidth: i10 } = Xye();
  return r10 = Pbe(r10, o10, 1, 0, a10, i10), r10 = Mbe(r10, t10), r10 = Tbe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    return t11 = ube(t11), t11 = AV(t11, { PlotType: { $set: "Bar" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Clustered" }, Config: { SwapAxes: { $set: true }, UnpivotData: { $set: false } } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category", "Details", "Color", "Texts"]), t11 = hbe(t11, ["lower", "upper"]), t11 = dbe(t11, "Cluster"), t11 = gbe(t11), t11 = ybe(t11), t11;
  } } } }), r10;
}, rangeColumn: (e14, t10) => {
  const n10 = "RangeColumn";
  let r10 = e14;
  r10 = Sbe(r10, t10, n10);
  const { barBottomWidth: o10, barTopWidth: a10, barWidth: i10 } = Xye();
  return r10 = Pbe(r10, o10, 1, 0, a10, i10), r10 = Mbe(r10, t10), r10 = Tbe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    return t11 = ube(t11), t11 = AV(t11, { PlotType: { $set: "Bar" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Clustered" }, Config: { UnpivotData: { $set: false } } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category", "Details", "Color", "Texts"]), t11 = hbe(t11, ["lower", "upper"]), t11 = dbe(t11, "Cluster"), t11 = gbe(t11), t11 = ybe(t11), t11;
  } } } }), r10;
}, rangeArea: (e14, t10) => {
  const n10 = "RangeArea";
  let r10 = e14;
  return r10 = Sbe(r10, t10, n10), r10 = Mbe(r10, t10), r10 = Tbe(r10, t10), r10 = AV(r10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    return t11 = ube(t11), t11 = AV(t11, { PlotType: { $set: "Area" }, PlotChartType: { $set: n10 }, PlotChartSubtype: { $set: "Clustered" }, Config: { UnpivotData: { $set: false } } }), t11 = cbe(t11), t11 = sbe(t11, ["Values", "Category", "Details", "Color", "Texts"]), t11 = hbe(t11, ["lower", "upper"]), t11 = dbe(t11, "Cluster"), t11 = gbe(t11), t11 = ybe(t11), t11;
  } } } }), r10;
}, gauge: (e14, t10) => {
  let n10 = e14;
  const { barBottomWidth: r10, barTopWidth: o10, barWidth: a10 } = Xye();
  return n10 = Pbe(n10, r10, 1, 0, o10, a10), n10 = kbe(n10, t10), n10 = ((e15, t11) => Cbe(e15, "Y", t11, (e16) => {
    let t12 = e16;
    return t12 = AV(t12, { MajorGrid: { $set: false }, Scale: { $set: "Linear" }, Position: { $set: "Far" }, LineStyle: { Border: { Style: { $set: "None" } } }, Title: { $set: "" } }), wbe.test(e16.Format) && (t12.Format = ""), t12;
  }))(n10, t10), n10 = AV(n10, { Plots: { [t10]: { $apply: (e15) => {
    let t11 = e15;
    return t11 = ube(t11), t11 = AV(t11, { PlotType: { $set: "Bar" }, PlotChartType: { $set: "Gauge" }, PlotChartSubtype: { $set: "Plain" }, Config: { Bar: { Overlap: { $set: 1 } }, AxisMode: { $set: "Radial" }, InnerRadius: { $set: 0.8 }, LineAspect: { $set: "Default" }, StartAngle: { $set: -45 }, Symbols: { $set: false }, SymbolShape: { $set: "Auto" }, SwapAxes: { $set: false }, Sweep: { $set: 270 }, UnpivotData: { $set: false }, Pointers: { $set: [] } } }), t11 = cbe(t11), t11 = mbe(t11, 1), t11 = sbe(t11, ["Values"]), t11;
  } } } }), n10;
} };
const Dbe = (e14, t10, n10) => Nbe[n10](e14, t10);
const Lbe = (e14, { payload: { axisType: t10, title: n10 } }) => {
  var _a2;
  const r10 = ((_a2 = e14.Plots[0]) == null ? void 0 : _a2.PlotName) || null;
  const o10 = eve(t10 || "Y", { Plots: null !== r10 ? [r10] : [], Title: n10 }, e14.$templateId);
  return AV(e14, { PlotArea: { Axes: { $push: [o10] } } });
};
const Hbe = (e14, { payload: { index: t10 } }) => t10 >= e14.PlotArea.Axes.length ? e14 : AV(e14, { PlotArea: { Axes: { $splice: [[t10, 1]] } } });
const Ibe = (e14) => AV(e14, { PlotArea: { Legends: { $push: [nve({}, e14.PlotArea.Legends[0])] } } });
const _be = (e14, { payload: { index: t10 } }) => t10 >= e14.PlotArea.Legends.length ? e14 : AV(e14, { PlotArea: { Legends: { $splice: [[t10, 1]] } } });
const Vbe = (e14) => {
  const t10 = e14.Plots.map((e15) => e15.PlotName);
  const n10 = ((e15, t11) => {
    let n11 = 1;
    let r11 = "";
    do {
      r11 = `${e15} ${n11}`, n11++;
    } while (t11.includes(r11));
    return r11;
  })(TG("dvchartPlot"), t10);
  const r10 = ave(n10, 0, {});
  let o10 = AV(e14, { Plots: { $push: [r10] } });
  return o10 = Dbe(o10, o10.Plots.length - 1, "column"), o10;
};
const Rbe = (e14, { payload: { index: t10 } }) => {
  if (t10 >= e14.Plots.length) return e14;
  const n10 = e14.Plots[t10].PlotName;
  const r10 = e14.PlotArea.Axes.map((e15) => {
    const { Plots: t11 } = e15;
    return 1 === t11.length && t11[0] === n10 ? null : AV(e15, { Plots: { $set: t11.filter((e16) => e16 !== n10) } });
  }).filter((e15) => null !== e15);
  return AV(e14, { Plots: { $splice: [[t10, 1]] }, PlotArea: { Axes: { $set: r10 } } });
};
const Abe = (e14, { payload: { plotName: t10, updPlotName: n10 } }) => {
  const r10 = e14.Plots.findIndex((e15) => e15.PlotName === t10);
  if (-1 === r10) throw Error("Invalid plot name");
  const o10 = {};
  e14.PlotArea.Axes.forEach((e15, r11) => {
    const a10 = {};
    let i10 = true;
    e15.Plots.forEach((e16, r12) => {
      e16 === t10 && (a10[r12] = { $set: n10 }, i10 = false);
    }), i10 || (o10[r11] = { Plots: a10 });
  });
  return AV(e14, { Plots: { [r10]: { PlotName: { $set: n10 } } }, PlotArea: { Axes: o10 } });
};
const Obe = (e14, { payload: { templateType: t10 } }) => {
  if (!e14.Plots.length) throw new Error("No plots for this action");
  let n10 = e14.Plots.findIndex(aj);
  -1 === n10 && (n10 = 0);
  const r10 = ij(e14);
  let o10 = dj(lj(e14), false, r10);
  return o10 = AV(o10, { Plots: { [n10]: { $apply: (e15) => dj(e15, true, r10) } } }), Dbe(o10, n10, t10);
};
const Bbe = (e14, { payload: { dataSetName: t10 } }) => AV(e14, { DataSetName: { $set: t10 } });
const zbe = (e14, { payload: { palette: t10, customPalette: n10, customPaletteInfo: { customPaletteId: r10, customPaletteName: o10 } } }) => AV(e14, { Palette: { $set: t10 }, CustomPalette: { $set: n10 }, CustomPaletteInfo: { PaletteId: { $set: r10 }, PaletteName: { $set: o10 } } });
const $be = (e14, { payload: { id: t10, name: n10 } }) => !(!t10 || !n10) ? AV(e14, { Palette: { $set: "Custom" }, CustomPaletteInfo: { PaletteId: { $set: t10 }, PaletteName: { $set: n10 } } }) : e14;
const Wbe = (e14, { payload: { style: t10 } }) => Array.isArray(t10) && t10.length ? AV(e14, { CustomPalette: { $set: t10 } }) : e14;
const jbe = (e14, t10) => e14.Plots[0] ? AV(e14, { Plots: { 0: { $set: Xve(e14.Plots[0], t10) } } }) : e14;
const Zbe = (e14, t10) => e14.Plots[0] && "Gauge" === e14.Plots[0].PlotChartType ? AV(e14, { Plots: { 0: { $set: Uve(e14.Plots[0], t10) } } }) : e14;
const Gbe = (e14, t10) => e14.Plots[0] && "Gauge" === e14.Plots[0].PlotChartType ? AV(e14, { Plots: { 0: { $set: Yve(e14.Plots[0], t10) } } }) : e14;
const Ube = (e14, { payload: t10 }) => t10.dataSetName && !e14.DataSetName ? AV(e14, { DataSetName: { $set: t10.dataSetName } }) : e14;
const [, , qbe] = Dp("wd-color-encoding-editor");
const [Ybe, Kbe] = qbe("collection");
const Xbe = Kbe("disabled");
const Jbe = "VALUESNAME";
const Qbe = (e14) => {
  const { value: t10, descriptor: n10, descriptor: { meta: r10 = {} }, setProperty: o10 } = e14;
  const { t: a10 } = vp("propertyEditors");
  const { plotIndex: i10 } = Cye();
  const s10 = PA();
  const l10 = __spreadProps(__spreadValues({}, n10), { valuePath: `${n10.valuePath}.Value`, meta: __spreadProps(__spreadValues({}, r10), { exprEditorFilter: Sye }) });
  const c10 = t10.Value || [];
  const u10 = c10.filter((e15) => e15.Value !== Jbe);
  const d10 = c10.length !== u10.length;
  const p10 = __spreadProps(__spreadValues({}, e14), { value: d10, descriptor: $N("", "propertyEditors:dvchartEncodingCollection.color.valuesName", "", ""), setProperty: (e15, t11) => {
    o10(l10, t11 ? [bye(Jbe)] : []);
  }, t: a10 });
  const m10 = __spreadProps(__spreadValues({}, e14), { descriptor: l10, value: u10, setProperty: (e15, t11) => {
    t11 !== Jbe ? o10(e15, t11) : o10(l10, [bye(Jbe)]);
  }, onAdd: () => {
    s10($ye.addEncodingValue("Color", "", i10));
  }, onDelete: (e15) => {
    s10($ye.deleteEncoding(i10, "Color", e15));
  }, customCSS: kp(Ybe, { [Xbe]: d10 }) });
  return tp.createElement(tp.Fragment, null, tp.createElement(Hie, __spreadValues({}, p10)), tp.createElement(xye, __spreadValues({}, m10)));
};
Qbe.displayName = "DVChartColorEncodingCollectionEditor";
const [eSe, , tSe] = Dp("wd-editor-line");
const [nSe] = tSe("block");
const rSe = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { descriptor: n10, descriptor: { type: r10 }, value: o10, setProperty: a10, validateKeys: i10, tooltipKey: s10, allowEmptyKeys: l10 } = e14;
  const { keyPath: c10, valuePath: u10, valueHeader: d10, keyHeader: p10, keyPlaceholder: m10, valueIsExpression: h10, valuePlaceholder: f10, keyPattern: g10 } = ((e15, t11) => {
    const n11 = t11;
    switch (e15) {
      case "dataset_calculated_field_collection":
        return { keyPath: "Name", valuePath: "Value", valueIsExpression: true, keyHeader: t11("propertyEditors:dataSetFieldCollection.fieldHeader"), valueHeader: t11("propertyEditors:dataSetFieldCollection.valueHeader"), keyPlaceholder: t11("propertyEditors:dataSetFieldCollection.fieldPlaceholder"), valuePlaceholder: t11("propertyEditors:dataSetFieldCollection.valuePlaceholder"), keyPattern: n11("nameTemplates:calculatedField") };
      case "dataset_field_collection":
        return { keyPath: "Name", valuePath: "DataField", keyHeader: t11("propertyEditors:dataSetFieldCollection.fieldHeader"), valueHeader: t11("propertyEditors:dataSetFieldCollection.dataFieldHeader"), keyPlaceholder: t11("propertyEditors:dataSetFieldCollection.fieldPlaceholder"), valuePlaceholder: t11("propertyEditors:dataSetFieldCollection.dataFieldPlaceholder"), keyPattern: n11("nameTemplates:field") };
      case "dataset_parameter_collection":
      case "dataset_query_parameter_collection":
        return { keyPath: "Name", valuePath: "Value", valueIsExpression: true, keyHeader: t11("propertyEditors:dataSetParameterCollection.nameHeader"), valueHeader: t11("propertyEditors:dataSetParameterCollection.valueHeader"), keyPlaceholder: t11("propertyEditors:dataSetParameterCollection.namePlaceholder"), valuePlaceholder: t11("propertyEditors:dataSetParameterCollection.valuePlaceholder"), keyPattern: n11("nameTemplates:parameter") };
      case "subreport_parameters":
        return { keyPath: "ParameterName", valuePath: "Value", valueIsExpression: true, keyPattern: t11("propertyEditors:subreport.parameter"), keyPlaceholder: t11("propertyEditors:subreport.parameterNamePlaceholder"), valuePlaceholder: t11("propertyEditors:subreport.parameterValuePlaceholder"), keyHeader: t11("propertyEditors:subreport.parameterNameHeader"), valueHeader: t11("propertyEditors:subreport.parameterValueHeader") };
      case "dvchart_encoding_subfield_collection":
        return { keyPath: "Key", valuePath: "Value", valueIsExpression: true, keyPattern: n11("nameTemplates:field"), keyPlaceholder: t11("propertyEditors:dvchartEncodingCollection.fieldPlaceholder"), valuePlaceholder: t11("propertyEditors:dvchartEncodingCollection.valuePlaceholder") };
      case "mail_merge_fields_collection":
        return { keyPath: "Name", valuePath: "Value", valueIsExpression: true, keyHeader: t11("propertyEditors:mailMergeFieldsCollection.nameHeader"), valueHeader: t11("propertyEditors:mailMergeFieldsCollection.valueHeader"), keyPlaceholder: t11("propertyEditors:mailMergeFieldsCollection.namePlaceholder"), valuePlaceholder: t11("propertyEditors:mailMergeFieldsCollection.valuePlaceholder"), keyPattern: n11("nameTemplates:mailMergeField") };
      case "dvchart_legend_range_options_collection":
        return { keyPath: "Title", valuePath: "To", valueIsExpression: false, keyHeader: t11("propertyEditors:dvcartLegendRangeOptionsCollection.titleHeader"), valueHeader: t11("propertyEditors:dvcartLegendRangeOptionsCollection.toHeader"), keyPlaceholder: t11("propertyEditors:dvcartLegendRangeOptionsCollection.titlePlaceholder") };
      default:
        return { keyPath: "Name", valuePath: "Value" };
    }
  })(r10, t10);
  const y10 = s10 ? Jue(s10, t10) : void 0;
  const v10 = (e15) => (e15 || []).map((e16) => e16[c10]);
  const b10 = () => {
    if (!g10) return "";
    const e15 = (e16) => e16 === r11;
    const t11 = v10(o10);
    let n11 = 1;
    let r11 = "";
    do {
      r11 = `${g10}${n11}`, n11++;
    } while (t11.some(e15));
    return r11;
  };
  const S10 = __spreadProps(__spreadValues({}, e14), { tooltip: y10, value: o10, createEditor: (e15, t11) => {
    const s11 = { descriptor: Zq("", "", "string", `${n10.valuePath}.${t11}.${c10}`), value: e15[c10], defaultValue: "", setProperty: a10, placeholderEmpty: m10, validate: i10 && ((e16) => {
      return n11 = e16, l10 && "" === n11 || false || ((e17) => e17 && !Jc('^\\s+$|["]').test(e17) || false)(e16) && ((e17) => !v10(o10).some((n12, r11) => n12 === e17 && r11 !== t11))(e16);
      var n11;
    }) || void 0 };
    return tp.createElement("div", { className: eSe }, tp.createElement("div", { className: nSe }, tp.createElement(bse, __spreadValues({}, s11))), tp.createElement("div", { className: nSe }, (() => {
      if (h10) {
        const r11 = { descriptor: __spreadProps(__spreadValues({}, n10), { valuePath: `${n10.valuePath}.${t11}.${u10}`, type: "string_expr" }), value: e15[u10], defaultValue: "", setProperty: a10, placeholderEmpty: f10 };
        return tp.createElement(Lpe, __spreadValues({}, r11));
      }
      if ("dvchart_legend_range_options_collection" === r10) {
        const r11 = { descriptor: Zq("", "", "number", `${n10.valuePath}.${t11}.${u10}`, void 0, { numberType: "Float" }), value: e15[u10], setProperty: a10 };
        return tp.createElement(xue, __spreadValues({}, r11));
      }
      const o11 = { descriptor: Zq("", "", "string", `${n10.valuePath}.${t11}.${u10}`), value: e15[u10], defaultValue: "", setProperty: a10, placeholderEmpty: f10 };
      return tp.createElement(bse, __spreadValues({}, o11));
    })()));
  }, onAdd: () => {
    a10(n10, AV(o10 || [], { $push: [{ [c10]: b10(), [u10]: "dvchart_legend_range_options_collection" !== r10 ? "" : 0 }] }));
  }, onDelete: (e15) => {
    a10(n10, AV(o10, { $splice: [[e15, 1]] }));
  }, header: (p10 || d10) && (C10 = p10, x10 = d10, tp.createElement("div", { className: eSe }, C10 && tp.createElement(LE, { text: C10, strikeThrough: false, customCSS: nSe }), x10 && tp.createElement(LE, { text: x10, strikeThrough: false, customCSS: nSe }))) });
  var C10, x10;
  return tp.createElement(Bde, __spreadValues({}, S10));
};
rSe.displayName = "KeyValuePairCollectionEditor";
const oSe = (e14) => {
  const { descriptor: { valuePath: t10, label: n10 }, value: r10 } = e14;
  const o10 = $N("", n10, "dvchart_encoding_subfield_collection", `${t10}.Subfields`);
  const a10 = __spreadProps(__spreadValues({}, e14), { descriptor: o10, value: r10.Subfields });
  return tp.createElement(rSe, __spreadValues({}, a10));
};
oSe.displayName = "DVChartComplexEncodingFieldCollectionEditor";
const aSe = (e14) => {
  const { descriptor: t10, value: n10, setProperty: r10 } = e14;
  const o10 = __spreadProps(__spreadValues({}, e14), { value: n10.Value, reordering: { type: "drag", onReorder: (e15) => {
    r10(__spreadProps(__spreadValues({}, t10), { valuePath: `${t10.valuePath}.Value` }), e15);
  } }, createEditor: (e15, n11) => {
    const o11 = { descriptor: __spreadProps(__spreadValues({}, t10), { type: "string_expr", valuePath: `${t10.valuePath}.Value.${n11}`, meta: __spreadProps(__spreadValues({}, t10.meta), { exprEditorFilter: Sye }) }), value: e15, defaultValue: "", setProperty: r10 };
    return tp.createElement(Lpe, __spreadValues({}, o11));
  }, onAdd: () => {
    r10(t10, AV(n10, { Value: { $push: [""] } }));
  }, onDelete: (e15) => {
    r10(t10, AV(n10, { Value: { $splice: [[e15, 1]] } }));
  } });
  return tp.createElement(Bde, __spreadValues({}, o10));
};
aSe.displayName = "DVChartDetailsEncodingFieldCollectionEditor";
const [, , iSe] = Dp("wd-editor-encoding-collection");
const [sSe] = iSe("item");
const [lSe] = iSe("item-toggle");
const [cSe] = iSe("item-title");
const uSe = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { descriptor: n10, value: r10, encodingName: o10 = "Values", setProperty: a10 } = e14;
  const { drillPropertiesPath: i10 } = ep.useContext(Iue);
  const { plotIndex: s10 } = Cye();
  const l10 = PA();
  const c10 = rf(dh);
  const u10 = (e15) => t10("Values" === o10 ? `dvchartEncodingCollection.value.${e15}` : "Details" === o10 ? `dvchartEncodingCollection.details.${e15}` : "Texts" === o10 ? `dvchartEncodingCollection.text.${e15}` : `dvchartEncodingCollection.aggregate.${e15}`);
  const d10 = __spreadProps(__spreadValues({}, e14), { value: r10 || [], reordering: { type: "drag" }, createEditor: (e15, t11) => {
    const a11 = { block: true, size: "small", icon: c10, customCSS: lSe, onClick: () => {
      i10 && i10(`${n10.valuePath}.${t11}`, u10("propertiesTitle"));
    } };
    const s11 = "Texts" === o10 ? r10[t11].Field.TemplateKey : `${u10("prefix")} ${t11}`;
    return tp.createElement("div", { className: sSe }, tp.createElement("div", { className: cSe }, s11), tp.createElement(qm, __spreadValues({}, a11)));
  }, onAdd: () => {
    let e15 = "";
    if ("Texts" === o10) {
      const t11 = r10.map((e16) => e16.Field.TemplateKey);
      e15 = kG(TG("dvcharttextencoding"), t11, true);
    }
    l10($ye.addEncodingValue(o10, e15));
  }, onDelete: (e15) => {
    "Encodings.Values" === n10.valuePath ? l10($ye.deleteEncoding(s10, "Values", e15)) : a10(n10, AV(r10, { $splice: [[e15, 1]] }));
  } });
  return tp.createElement(Bde, __spreadValues({}, d10));
};
uSe.displayName = "DVChartEncodingCollectionEditor";
const [dSe] = Dp("wd-nested-property-grid-panel");
const pSe = "nestedPropertyGridPanel";
const mSe = () => {
  const { rdlx: { propertyGrid: { objectValue: e14, defaultValue: t10, objectPath: n10 } } } = d9();
  const { state: { descriptors: r10, exprEditorContext: o10, commonEditorsContext: a10, setProperty: i10 } } = i$(pSe, n10, e14);
  const { t: s10 } = vp();
  const l10 = { descriptors: r10, objectValue: e14, defaultValue: t10, propertyEditors: QVe, setProperty: i10, t: s10, customCSS: Lz };
  return tp.createElement("div", { className: dSe }, tp.createElement(bF, null, tp.createElement(Iue.Provider, { value: a10 }, tp.createElement(Vue.Provider, { value: o10 }, tp.createElement(wD, __spreadValues({}, l10))))));
};
mSe.displayName = "NestedPropertyGridPanel";
const hSe = { descriptors: [], exprEditorContext: { instanceId: "", units: "in", expressionSyntax: "i11n", validationContext: {}, dataSets: [], dataSources: [] }, setProperty: () => {
} };
const fSe = (e14 = hSe, t10) => {
  if (!t10) return e14;
  switch (t10.type) {
    case "@core/panels/INIT_PANEL":
      return AV(e14, { $merge: t10.payload });
    case "@nestedPropGrid/UPDATE_DESCRIPTORS": {
      const { payload: { descriptors: n10, meta: r10 } } = t10;
      const o10 = { descriptors: { $set: n10 } };
      return r10 && (o10.meta = { $set: r10 }), AV(e14, o10);
    }
    default:
      return e14;
  }
};
const [, , gSe] = Dp("wd-editor-encoding-collection");
const [ySe] = gSe("item");
const [vSe] = gSe("item-toggle");
const [bSe] = gSe("item-title");
const SSe = (e14) => {
  const { t: t10 } = vp();
  const { descriptor: n10, value: r10, mode: o10, setProperty: a10 } = e14;
  const i10 = rf(dh);
  const s10 = PA();
  const l10 = ep.useContext(Vue);
  const c10 = ep.useContext(Iue);
  const u10 = (e15) => {
    a10(n10, AV(r10, { Subfields: { $splice: [[e15, 1]] } }));
  };
  const d10 = () => {
    a10(n10, AV(r10, { Subfields: { $push: [{ Key: "", Value: "", Name: "" }] } }));
  };
  let p10 = __spreadProps(__spreadValues({}, e14), { value: r10.Subfields || [], createEditor: (u11, d11) => {
    const p11 = { block: true, size: "small", icon: i10, customCSS: vSe, onClick: () => ((t11) => {
      const r11 = [$N("", "propertyDescriptors:labels.dvchartValueEncoding.field.caption", "string_expr", `${n10.valuePath}.Subfields.${t11}.Caption`, "both", { exprEditorFilter: Sye }), $N("", "propertyDescriptors:labels.dvchartValueEncoding.field.value", "dvchart_without_aggregate_field", `${n10.valuePath}.Subfields.${t11}.Value`)];
      "advanced" === o10 && r11.unshift($N("", "propertyDescriptors:labels.dvchartValueEncoding.field.key", "string", `${n10.valuePath}.Subfields.${t11}.Key`)), s10(Xz(pSe, e14.descriptor.label, void 0, { exprEditorContext: l10, commonEditorsContext: c10, setProperty: a10, descriptors: r11 }));
    })(d11) };
    const m10 = r10.Subfields[d11].Key || `${t10("propertyEditors:chartComplexEncodingFieldCollectionEditor.prefix")} ${d11}`;
    return tp.createElement("div", { className: ySe }, tp.createElement("div", { className: bSe }, m10), tp.createElement(qm, __spreadValues({}, p11)));
  } });
  return "advanced" === o10 && (p10 = __spreadProps(__spreadValues({}, p10), { onAdd: d10, onDelete: u10 })), tp.createElement(Bde, __spreadValues({}, p10));
};
SSe.displayName = "DVChartGanttComplexEncodingFieldCollectionEditor";
const [CSe, , xSe] = Dp("wd-editor-line");
const [wSe] = xSe("block");
const TSe = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { descriptor: n10, value: r10, setProperty: o10 } = e14;
  const a10 = t10("propertyEditors:chartSimpleEncodingFieldCollectionEditor.captionHeader", "Caption");
  const i10 = t10("propertyEditors:chartSimpleEncodingFieldCollectionEditor.valueHeader", "Value");
  const s10 = __spreadProps(__spreadValues({}, e14), { value: r10.Value, createEditor: ({ Caption: e15, Value: t11 }, r11) => {
    const a11 = { descriptor: __spreadProps(__spreadValues({}, n10), { valuePath: `${n10.valuePath}.Value.${r11}.Caption`, meta: __spreadProps(__spreadValues({}, n10.meta), { exprEditorFilter: Sye }) }), value: e15, defaultValue: "", setProperty: o10 };
    const i11 = { descriptor: __spreadProps(__spreadValues({}, n10), { valuePath: `${n10.valuePath}.Value.${r11}.Value`, meta: __spreadProps(__spreadValues({}, n10.meta), { exprEditorFilter: Sye }) }), value: t11, defaultValue: "", setProperty: o10 };
    return tp.createElement("div", { className: CSe }, tp.createElement("div", { className: wSe }, tp.createElement(Lpe, __spreadValues({}, a11))), tp.createElement("div", { className: wSe }, tp.createElement(Lpe, __spreadValues({}, i11))));
  }, onAdd: () => {
    o10(n10, AV(r10, { Value: { $push: [{ Value: "", Caption: "" }] } }));
  }, onDelete: (e15) => {
    o10(n10, AV(r10, { Value: { $splice: [[e15, 1]] } }));
  }, header: tp.createElement("div", { className: CSe }, tp.createElement(LE, { text: a10, strikeThrough: false, customCSS: wSe }), tp.createElement(LE, { text: i10, strikeThrough: false, customCSS: wSe })) });
  return tp.createElement(Bde, __spreadValues({}, s10));
};
TSe.displayName = "DVChartSimpleEncodingFieldCollectionEditor";
const ESe = ["high", "low", "open", "close", "lower", "upper"];
const FSe = (e14) => e14 && "string" == typeof e14 && e14.trim().toLowerCase() || "";
const MSe = (e14) => {
  const { descriptor: t10, value: n10, disabled: r10, setProperty: o10 } = e14;
  const { t: a10 } = vp();
  const { selectedItemsInfo: i10, namedItems: s10 } = ep.useContext(Rue);
  const l10 = i10[0].path.split(".Encodings.Texts")[0];
  const c10 = s10.find((e15) => e15.$path === l10);
  const u10 = [...ESe, ...((c10 == null ? void 0 : c10.$options.textEncodingTemplateKeys) || []).map((e15) => e15.templateKey).filter((e15) => e15 !== n10)];
  const d10 = { value: n10, disabled: r10, placeholderEmpty: _ie(a10), placeholderMultipleValues: Iie(a10), onChange: (e15) => {
    const n11 = e15.trim();
    o10(t10, n11);
  }, validate: (e15) => {
    const t11 = FSe(e15);
    return 0 !== t11.length && (!u10.find((e16) => ((e17, t12) => FSe(e17) === FSe(t12))(e16, t11)) && ((n11 = t11) && Jc("^[\\p{Letter}\\d]*$").test(n11) || false));
    var n11;
  } };
  return tp.createElement(UD, __spreadValues({}, d10));
};
MSe.displayName = "DVTextEncodingTemplateKeyEditor";
const kSe = _D(MSe);
const [, , PSe] = Dp("wd-editor-encoding-collection");
const [NSe] = PSe("item-title");
const [DSe, , LSe] = Dp("wd-editor-line");
const [HSe] = LSe("block");
const ISe = [{ key: "upper", text: "chartWizard:settings.labels.upper" }, { key: "lower", text: "chartWizard:settings.labels.lower" }];
const _Se = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { descriptor: n10, value: r10, setProperty: o10, mode: a10 } = e14;
  const i10 = t10("propertyEditors:chartSimpleEncodingFieldCollectionEditor.keyHeader", "Key");
  const s10 = t10("propertyEditors:chartSimpleEncodingFieldCollectionEditor.valueHeader", "Value");
  const l10 = (e15) => {
    o10(n10, AV(r10, { Subfields: { $splice: [[e15, 1]] } }));
  };
  const c10 = () => {
    o10(n10, AV(r10, { Subfields: { $push: [{ Key: "", Value: "" }] } }));
  };
  let u10 = __spreadProps(__spreadValues({}, e14), { value: r10.Subfields || [], createEditor: ({ Value: e15, Key: r11, Caption: a11 }, i11) => {
    const s11 = (l11 = r11, ISe.find((e16) => e16.key === l11.toLocaleLowerCase()));
    var l11;
    const c11 = { descriptor: __spreadProps(__spreadValues({}, n10), { valuePath: `${n10.valuePath}.Subfields.${i11}.Key` }), value: r11, defaultValue: "", setProperty: o10 };
    const u11 = { descriptor: __spreadProps(__spreadValues({}, n10), { valuePath: `${n10.valuePath}.Subfields.${i11}.Value`, meta: __spreadProps(__spreadValues({}, n10.meta), { exprEditorFilter: Sye }) }), value: e15, defaultValue: "", setProperty: o10 };
    return tp.createElement("div", { className: DSe }, tp.createElement("div", { className: HSe }, s11 ? tp.createElement("div", { className: NSe }, t10(s11.text)) : tp.createElement(bse, __spreadValues({}, c11))), tp.createElement("div", { className: HSe }, tp.createElement(Lpe, __spreadValues({}, u11))));
  }, header: tp.createElement("div", { className: DSe }, tp.createElement(LE, { text: i10, strikeThrough: false, customCSS: HSe }), tp.createElement(LE, { text: s10, strikeThrough: false, customCSS: HSe })) });
  return "advanced" === a10 && (u10 = __spreadProps(__spreadValues({}, u10), { onAdd: c10, onDelete: l10 })), tp.createElement(Bde, __spreadValues({}, u10));
};
_Se.displayName = "DVChartRangeComplexEncodingFieldCollectionEditor";
const VSe = (e14) => `propertyDescriptors:labels.dvchartValueEncoding.field.${e14}`;
const RSe = (e14) => {
  const { descriptor: t10, value: n10 } = e14;
  const r10 = ep.useContext(Rue);
  const { t: o10 } = vp();
  const a10 = ((e15) => {
    const t11 = e15.namedItems || [];
    const n11 = e15.selectedItemsInfo || [];
    const r11 = t11.filter((e16) => n11.some((t12) => t12.path === e16.$path));
    if (!r11.length) return null;
    const o11 = t11.find((e16) => r11.every((t12) => e16.leftKey < t12.leftKey && t12.rightKey < e16.rightKey && e16.level === t12.level - 1));
    return o11 ? { plotChartType: o11.$options.plotChartType, plotChartSubtype: o11.$options.plotChartSubtype } : null;
  })(r10);
  if (!a10) return null;
  return (() => {
    const r11 = (t11) => Xue(e14, t11, o10, "");
    const i10 = (e15) => r11($N("", VSe(e15), "string_expr", "", "simple", { exprEditorFilter: Sye }));
    const s10 = (e15) => r11($N("", VSe(e15), "string_expr", "Value.0.Value", "simple", { exprEditorFilter: Sye }));
    const l10 = (e15) => r11($N("", VSe(e15), "string_expr", `Subfields.${Math.max(0, n10.Subfields.findIndex((t11) => t11.Key === e15))}.Value`, "simple", { exprEditorFilter: Sye }));
    if ("advanced" === t10.mode) switch (a10.plotChartType) {
      case "Candlestick":
      case "HighLowOpenClose":
      case "HighLowClose":
        return tp.createElement(oSe, __spreadValues({}, i10("value")));
      case "Gantt":
        return tp.createElement(SSe, __spreadProps(__spreadValues({}, i10("value")), { mode: "advanced" }));
      case "RangeArea":
      case "RangeBar":
      case "RangeColumn":
        return tp.createElement(_Se, __spreadProps(__spreadValues({}, i10("value")), { mode: "advanced" }));
      default:
        return tp.createElement(TSe, __spreadValues({}, i10("value")));
    }
    switch (a10.plotChartType) {
      case "Column":
      case "Bar":
      case "Line":
      case "Pie":
      case "Area":
      case "Pyramid":
      case "Funnel":
      case "PolarBar":
      case "PolarColumn":
        return tp.createElement(tp.Fragment, null, tp.createElement(Hpe, __spreadValues({}, (c10 = "caption", r11($N("", VSe(c10), "string_expr", "Value.0.Caption", "simple", { exprEditorFilter: Sye }))))), tp.createElement(Hpe, __spreadValues({}, s10("value"))));
      case "Gantt":
        return tp.createElement(SSe, __spreadProps(__spreadValues({}, i10("value")), { mode: "basic" }));
      case "Candlestick":
      case "HighLowOpenClose":
        return tp.createElement(tp.Fragment, null, tp.createElement(Hpe, __spreadValues({}, l10("high"))), tp.createElement(Hpe, __spreadValues({}, l10("low"))), tp.createElement(Hpe, __spreadValues({}, l10("open"))), tp.createElement(Hpe, __spreadValues({}, l10("close"))));
      case "HighLowClose":
        return tp.createElement(tp.Fragment, null, tp.createElement(Hpe, __spreadValues({}, l10("high"))), tp.createElement(Hpe, __spreadValues({}, l10("low"))), tp.createElement(Hpe, __spreadValues({}, l10("close"))));
      case "RangeArea":
      case "RangeBar":
      case "RangeColumn":
        return tp.createElement(_Se, __spreadProps(__spreadValues({}, i10("value")), { mode: "basic" }));
      default:
        return tp.createElement(TSe, __spreadValues({}, i10("value")));
    }
    var c10;
  })();
};
RSe.displayName = "DVChartValueEncodingFieldsEditor";
const ASe = "VALUESNAME";
const OSe = (e14) => {
  var _a2, _b2, _c2;
  const { descriptor: t10, value: n10, setProperty: r10 } = e14;
  const { t: o10 } = vp();
  const a10 = __spreadProps(__spreadValues({}, t10), { valuePath: "Encodings.Color.Field.Value", meta: { exprEditorFilter: Sye } });
  const i10 = ((_c2 = (_b2 = (_a2 = n10.Encodings) == null ? void 0 : _a2.Color) == null ? void 0 : _b2.Field) == null ? void 0 : _c2.Value) || [];
  const s10 = i10.filter((e15) => e15.Value !== ASe);
  const l10 = i10.length !== s10.length;
  const c10 = __spreadProps(__spreadValues({}, e14), { value: l10, descriptor: t10, setProperty: (e15, t11) => {
    r10(a10, t11 ? [bye(ASe)] : []);
  }, t: o10 });
  return tp.createElement(Hie, __spreadValues({}, c10));
};
OSe.displayName = "DVChartPlotShowValuesNamesInLegendEditor";
const [, , BSe] = Dp("wd-editor-sub-item-collection");
const [zSe] = BSe("item");
const [$Se] = BSe("item-toggle");
const WSe = (e14) => {
  const { value: t10, createEditor: n10, onSelect: r10, disableItemButtons: o10 } = e14;
  const a10 = rf(dh);
  const i10 = ep.useCallback((e15, t11) => {
    const i11 = { block: true, size: "small", icon: a10, customCSS: $Se, onClick: () => r10(t11), disabled: o10 == null ? void 0 : o10(t11) };
    return tp.createElement("div", { className: zSe }, n10(e15, t11), tp.createElement(qm, __spreadValues({}, i11)));
  }, [n10, o10, a10, r10]);
  const s10 = __spreadProps(__spreadValues({}, e14), { value: t10 || [], createEditor: i10 });
  return tp.createElement(Bde, __spreadValues({}, s10));
};
const [, , jSe] = Dp("wd-editor-chart-collection-editor");
const [ZSe] = jSe("item");
const GSe = (e14) => {
  const { lockLayout: t10 } = MO();
  const { selectedItemsInfo: n10 } = ep.useContext(Rue);
  const r10 = PA();
  const { t: o10 } = vp("labels");
  const a10 = n10.find((e15) => e15.type === rW.dvchartPlotArea);
  const i10 = __spreadProps(__spreadValues({}, e14), { createEditor: (e15) => {
    const t11 = e15;
    const n11 = "X" === t11.AxisType ? o10("dvchartXAxis", "X Axis") : o10("dvchartYAxis", "Y Axis");
    const r11 = t11.Plots.filter((e16) => !!e16).join(", ");
    const a11 = r11 ? `${n11} - [${r11}]` : n11;
    return tp.createElement("div", { className: ZSe }, a11);
  }, onSelect: (e15) => r10(c5($j(a10.path, `Axes.${e15}`), rW.dvchartAxis)), onAdd: () => {
    t10 || r10($ye.addAxis());
  }, onDelete: (e15) => {
    t10 || r10($ye.deleteAxis(e15));
  }, reordering: { type: "drag" } });
  return tp.createElement(WSe, __spreadValues({}, i10));
};
const USe = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const n10 = (({ selectedItemsInfo: e15, namedItems: t11 }) => {
    const n11 = e15.length && e15[0].type === rW.dvchartAxis && e15[0].path;
    const r11 = t11.find((e16) => e16.$path === n11);
    const o10 = r11 && t11.find((e16) => ZW(e16.type) && e16.leftKey < r11.leftKey && r11.rightKey < e16.rightKey);
    const a10 = o10 && t11.filter((e16) => e16.type === rW.dvchartPlot && o10.leftKey < e16.leftKey && e16.rightKey < o10.rightKey) || [];
    return a10.map((e16) => e16.name);
  })(ep.useContext(Rue));
  const r10 = [{ value: "", label: t10("common.textNone") }, ...n10.map((e15) => ({ value: e15, label: e15 }))];
  return tp.createElement(tse, __spreadProps(__spreadValues({}, e14), { currentEnum: r10 }));
};
const qSe = (e14) => {
  const { descriptor: t10, value: n10, setProperty: r10 } = e14;
  const o10 = __spreadProps(__spreadValues({}, e14), { value: n10 || [], createEditor: (e15, n11) => {
    const o11 = { descriptor: AV(t10, { valuePath: { $set: `${t10.valuePath}.${n11}` }, type: { $set: "dvchart_axis_plot_name" } }), value: e15, setProperty: r10 };
    return tp.createElement(USe, __spreadValues({}, o11));
  }, onAdd: () => {
    r10(t10, AV(n10 || [], { $push: [""] }));
  }, onDelete: (e15) => {
    r10(t10, AV(n10, { $splice: [[e15, 1]] }));
  } });
  return tp.createElement(Bde, __spreadValues({}, o10));
};
const [YSe, , KSe] = Dp("wd-number-editor");
const [XSe] = KSe("input");
const [JSe] = KSe("button");
const QSe = kde((e14) => {
  const { setProperty: t10, value: n10, disabled: r10, descriptor: o10, defaultValue: a10 } = e14;
  const { type: i10, meta: s10, meta: { numberType: l10, step: c10 = RY.step, minValue: u10, maxValue: d10, intervals: p10, excludeMax: m10, excludeMin: h10 } } = o10;
  const { t: f10 } = vp();
  const { minValue: g10, maxValue: y10 } = due(u10, d10, l10, p10);
  const v10 = ep.useContext(Vue);
  const { expressionSyntax: b10, validationContext: S10 } = v10;
  const C10 = sK(n10);
  const { inputValue: x10, inputValid: w10, inputDirty: T10, setInputValid: E10, setInputValue: F10, setInputDirty: M10, resetInputValue: k10, onInputChange: P10, initInputValue: N10, initInputValid: D10 } = sse(n10, (e15) => C10 ? "" : HJ(e15, i10, { expressionSyntax: b10 }, s10, String(n10 != null ? n10 : "")), (e15) => {
    if (e15 === a10 || C10 && !e15) return zY.success();
    return FJ(fc(b10, e15), { descriptor: o10, defaultValue: a10, validationContext: S10, expressionSyntax: b10 });
  });
  ep.useEffect(() => {
    F10(N10), E10(D10), M10(false);
  }, [n10, N10]);
  const L10 = (e15) => () => {
    const r11 = () => mue(0, g10, y10, c10, h10, m10);
    const i11 = () => Sue(a10, r11, l10);
    const s11 = Sue(n10, i11, l10);
    const u11 = hue(e15, s11, i11, l10, g10, y10, c10, p10, h10, m10);
    t10(o10, Cue(u11, "string"));
  };
  const H10 = () => {
    if (k10(), !w10 || C10 && !T10 && !x10) return;
    if (fue(x10, e14)) return;
    const r11 = NJ(x10, o10.type, { expressionSyntax: b10 }, o10.meta, n10);
    r11 !== n10 && t10(o10, r11);
  };
  const I10 = { icon: uue.down, disabled: r10, onClick: L10(-c10), title: `-${c10}`, dataAid: "Decrease" };
  const _10 = { icon: uue.up, disabled: r10, onClick: L10(c10), title: `+${c10}`, dataAid: "Increase" };
  const V10 = { disabled: r10, size: "small", value: x10, invalid: !w10, onChange: P10, onBlur: H10, onKeyDown: Rie(H10, k10), customCSS: XSe, placeholder: Vie(C10, f10), width: "0px" };
  return tp.createElement("div", { className: YSe }, tp.createElement(qm, __spreadProps(__spreadValues({}, I10), { customCSS: JSe, size: "small" })), tp.createElement(KF, __spreadValues({}, V10)), tp.createElement(qm, __spreadProps(__spreadValues({}, _10), { customCSS: JSe, size: "small" })));
});
QSe.displayName = "NumberExprEditor";
const eCe = _D(QSe);
const [tCe, , nCe] = Dp("wd-number-editor");
const [rCe] = nCe("input");
const [oCe] = nCe("button");
const aCe = kde((e14) => {
  const { defaultValue: t10, value: n10, setProperty: r10, descriptor: o10, disabled: a10 } = e14;
  const { type: i10, meta: s10, meta: { min: l10 = AY.min, max: c10 = AY.max, step: u10 = AY.step, scale: d10 = AY.scale } = {} } = o10;
  const p10 = ep.useContext(Vue);
  const { expressionSyntax: m10, validationContext: h10 } = p10;
  const { t: f10 } = vp();
  const g10 = sK(n10);
  const { inputValue: y10, inputValid: v10, inputDirty: b10, setInputValid: S10, setInputValue: C10, setInputDirty: x10, resetInputValue: w10, onInputChange: T10, initInputValue: E10, initInputValid: F10 } = sse(n10, (e15) => g10 ? "" : HJ(e15, i10, { expressionSyntax: m10 }, s10, String(n10 != null ? n10 : "")), (e15) => {
    if (e15 === t10 || g10 && !e15) return zY.success();
    return FJ(fc(m10, e15), { descriptor: o10, defaultValue: t10, validationContext: h10, expressionSyntax: m10 });
  });
  ep.useEffect(() => {
    C10(E10), S10(F10), x10(false);
  }, [n10, d10, u10, l10, c10]);
  const M10 = () => {
    if (w10(), !v10 || g10 && !b10 && !y10) return;
    if (fue(y10, e14)) return;
    const t11 = NJ(y10, o10.type, { expressionSyntax: m10 }, o10.meta, n10);
    t11 !== n10 && r10(o10, t11);
  };
  const k10 = (e15) => () => {
    const a11 = Pue(t10, 0, d10);
    const i11 = Pue(n10, a11, d10);
    const s11 = mue(i11 + e15, l10, c10);
    const u11 = Nue(s11, d10);
    r10(o10, u11);
  };
  const P10 = { icon: uue.down, disabled: a10, onClick: k10(-u10), title: `-${u10}%`, dataAid: "Decrease" };
  const N10 = { icon: uue.up, disabled: a10, onClick: k10(u10), title: `+${u10}%`, dataAid: "Increase" };
  const D10 = { disabled: a10, size: "small", value: y10, invalid: !v10, onChange: T10, onBlur: M10, onKeyDown: Rie(M10, w10), customCSS: rCe, placeholder: Vie(g10, f10), width: "0px" };
  return tp.createElement("div", { className: tCe }, tp.createElement(qm, __spreadProps(__spreadValues({}, P10), { customCSS: oCe, size: "small" })), tp.createElement(KF, __spreadValues({}, D10)), tp.createElement(qm, __spreadProps(__spreadValues({}, N10), { customCSS: oCe, size: "small" })));
});
aCe.displayName = "PercentageExprEditor";
const iCe = _D(aCe);
const sCe = (e14) => `dvchartAxis.${e14}`;
const lCe = Zq("", sCe("min"), "number_expr", "Min", void 0, { numberType: "Float", emptyValue: "EmptyString" });
const cCe = Zq("", sCe("max"), "number_expr", "Max", void 0, { numberType: "Float", emptyValue: "EmptyString" });
const uCe = Zq("", sCe("logBase"), "number", "LogBase", void 0, { numberType: "Float" });
const dCe = Zq("", sCe("min"), "percent_expr", "Min", void 0, { emptyValue: "EmptyString", min: 0, max: 100, scale: 100 });
const pCe = Zq("", sCe("max"), "percent_expr", "Max", void 0, { emptyValue: "EmptyString", min: 0, max: 100, scale: 100 });
const mCe = Zq("", sCe("scale"), "dvchart_scale", "Scale");
function hCe(e14, t10) {
  const n10 = Sue(e14, () => Sue(t10, () => NaN, "Float"), "Float");
  return Number.isNaN(n10) ? void 0 : n10;
}
const fCe = (e14) => {
  const { t: t10 } = vp();
  const { value: n10, value: { Min: r10, Max: o10 }, setProperty: a10, defaultValue: { Min: i10, Max: s10 } } = e14;
  const { setProperties: l10 } = ep.useContext(Iue);
  const c10 = (n11, r11) => Xue(e14, __spreadProps(__spreadValues({}, n11), { meta: __spreadValues(__spreadValues({}, n11.meta), r11) }), t10);
  const { maxValue: u10, minValue: d10 } = ((e15, t11, n11, r11) => ({ minValue: "" === e15 ? void 0 : hCe(e15, n11), maxValue: "" === t11 ? void 0 : hCe(t11, r11) }))(r10, o10, i10, s10);
  const p10 = __spreadProps(__spreadValues({}, Xue(e14, mCe, t10)), { setProperty: (e15, t11) => {
    const r11 = "Logarithmic" === n10.Scale && "Logarithmic" !== t11;
    const o11 = "Percentage" !== n10.Scale && "Percentage" === t11;
    if (r11 || o11) {
      const n11 = [{ descriptor: e15, value: t11 }];
      r11 && n11.push({ descriptor: uCe, value: 10 }), o11 && [dCe, pCe].forEach((e16) => n11.push({ descriptor: e16, value: "" })), l10(n11);
    } else a10(e15, t11);
  } });
  return tp.createElement(tp.Fragment, null, tp.createElement(nse, __spreadValues({}, p10)), (() => {
    switch (n10.Scale) {
      case "Ordinal":
      case "Linear":
        return [tp.createElement(eCe, __spreadProps(__spreadValues({}, c10(lCe, { maxValue: u10 })), { key: "linear-min-editor" })), tp.createElement(eCe, __spreadProps(__spreadValues({}, c10(cCe, { minValue: d10 })), { key: "linear-max-editor" }))];
      case "Logarithmic":
        return [tp.createElement(eCe, __spreadProps(__spreadValues({}, c10(lCe, { maxValue: u10 })), { key: "logarithmic-min-editor" })), tp.createElement(eCe, __spreadProps(__spreadValues({}, c10(cCe, { minValue: d10 })), { key: "logarithmic-max-editor" })), tp.createElement(wue, __spreadProps(__spreadValues({}, c10(uCe)), { key: "logarithmic-log-base-editor" }))];
      case "Percentage": {
        const e15 = "number" == typeof d10 ? 100 * d10 : 0;
        const t11 = "number" == typeof u10 ? 100 * u10 : 100;
        return [tp.createElement(iCe, __spreadProps(__spreadValues({}, c10(dCe, { max: t11 })), { key: "percentage-min-editor" })), tp.createElement(iCe, __spreadProps(__spreadValues({}, c10(pCe, { min: e15 })), { key: "percentage-max-editor" }))];
      }
      default:
        return null;
    }
  })());
};
fCe.displayName = "DVChartAxisScaleEditor";
const gCe = (e14) => `dvchartAxis.${e14}`;
const yCe = Zq("", gCe("height"), "percent", "Height", void 0, { min: 0, emptyValue: "Null", step: 10 });
const vCe = Zq("", gCe("maxHeight"), "percent", "MaxHeight", void 0, { min: 0, step: 10 });
const bCe = Zq("", gCe("width"), "percent", "Width", void 0, { min: 0, emptyValue: "Null", step: 10 });
const SCe = Zq("", gCe("maxWidth"), "percent", "MaxWidth", void 0, { min: 0, step: 10 });
const CCe = (e14) => {
  const { t: t10 } = vp();
  const { value: n10, setProperty: r10 } = e14;
  const o10 = (n11, o11, a10) => __spreadProps(__spreadValues({}, Xue(e14, __spreadProps(__spreadValues({}, n11), { meta: __spreadProps(__spreadValues({}, n11.meta), { max: a10 }) }), t10)), { value: o11, setProperty: r10 });
  return tp.createElement(tp.Fragment, null, tp.createElement(Lue, __spreadValues({}, o10(yCe, n10.Height, 100 * n10.MaxHeight))), tp.createElement(Lue, __spreadValues({}, o10(vCe, n10.MaxHeight))), tp.createElement(Lue, __spreadValues({}, o10(SCe, n10.MaxWidth))), tp.createElement(Lue, __spreadValues({}, o10(bCe, n10.Width, 100 * n10.MaxWidth))));
};
CCe.displayName = "DVChartAxisSizesEditor";
const xCe = (e14) => {
  const { descriptor: t10, descriptor: { meta: n10 } } = e14;
  const r10 = __spreadProps(__spreadValues({}, e14), { defaultValue: "", descriptor: __spreadProps(__spreadValues({}, t10), { type: "string_expr", meta: __spreadProps(__spreadValues({}, n10), { exprEditorFilter: Sye }) }) });
  return tp.createElement(Hpe, __spreadValues({}, r10));
};
xCe.displayName = "DVChartFieldWithoutAggregateEditor";
const wCe = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const n10 = (() => {
    const { rdlx: { expressionSyntax: e15 } } = Uae();
    const { rdlx: { propertyGrid: { objectValue: t11 } } } = d9();
    const n11 = t11[0];
    if ("dvchartplot" !== n11.Type) return [];
    switch (n11.PlotChartType) {
      case "Candlestick":
      case "HighLowOpenClose":
        return ["High", "Low", "Open", "Close"];
      case "HighLowClose":
        return ["High", "Low", "Close"];
      case "Gantt":
        return ["Upper", "Lower"];
      default: {
        const t12 = [];
        const r11 = n11.Encodings.Values.map((e16) => e16.Field);
        return r11.forEach((n12) => {
          "Simple" === n12.FieldType && n12.Value.forEach((n13) => {
            (n13.Caption || n13.Value) && t12.push({ label: n13.Caption || HJ(`${n13.Value}`, "string_expr", { expressionSyntax: e15 }), value: n13.Caption || `${n13.Value}` });
          });
        }), t12;
      }
    }
  })();
  const r10 = __spreadProps(__spreadValues({}, e14), { currentEnum: [{ value: "", label: t10("common.textNone") }, ...n10] });
  return tp.createElement(nse, __spreadValues({}, r10));
};
wCe.displayName = "DVChartOverlayFieldEditor";
const TCe = Zq("", "dvPlotOverlays.value", "string", "Value");
const ECe = Zq("", "dvPlotOverlays.value", "number", "Value", void 0, { numberType: "Float", emptyValue: "EmptyString", valueMode: "string" });
const FCe = Zq("", "dvPlotOverlays.axis", "enum", "Axis", void 0, { enumKey: "dvchart_plot_overlay_axis" });
const MCe = (e14) => {
  const { t: t10 } = vp();
  const { value: { Axis: n10 } } = e14;
  return tp.createElement(tp.Fragment, null, tp.createElement(nse, __spreadValues({}, Xue(e14, FCe, t10))), (() => {
    switch (n10) {
      case "X":
        return tp.createElement(Sse, __spreadValues({}, Xue(e14, TCe, t10)));
      case "Y":
        return tp.createElement(wue, __spreadValues({}, Xue(e14, ECe, t10)));
      default:
        return null;
    }
  })());
};
MCe.displayName = "DVChartOverlaysValue";
const kCe = (e14) => {
  const { value: t10, disabled: n10, plotNames: r10 } = e14;
  const [o10, a10] = ep.useState(t10);
  const i10 = ep.useContext(Rue);
  const s10 = PA();
  const { t: l10 } = vp();
  ep.useEffect(() => {
    t10 !== o10 && a10(t10);
  }, [o10, t10]);
  const c10 = r10 || ((e15) => {
    const t11 = e15.namedItems || [];
    const n11 = e15.selectedItemsInfo[0];
    const r11 = t11.find((e16) => e16.$path === n11.path);
    const o11 = r11 && t11.find((e16) => "dvchart" === e16.type && e16.leftKey < r11.leftKey && r11.rightKey < e16.rightKey);
    const a11 = o11 && t11.filter((e16) => "dvchartplot" === e16.type && o11.leftKey < e16.leftKey && e16.rightKey < o11.rightKey) || [];
    return a11.filter((e16) => e16.$path !== n11.path).map((e16) => e16.name);
  })(i10);
  const u10 = { value: o10, disabled: n10, placeholderEmpty: _ie(l10), placeholderMultipleValues: Iie(l10), onChange: (e15) => {
    a10(e15);
    const n11 = e15.trim();
    s10($ye.updatePlotName(t10, n11));
  }, validate: (e15) => {
    const t11 = e15.trim();
    return "" !== t11 && !c10.find((e16) => t11 === e16);
  } };
  return tp.createElement(UD, __spreadValues({}, u10));
};
const PCe = _D(kCe);
const NCe = (e14) => {
  const { selectedItemsInfo: t10 } = ep.useContext(Rue);
  const { lockLayout: n10 } = MO();
  const r10 = PA();
  const { descriptor: o10, value: a10, setProperty: i10 } = e14;
  const s10 = t10.find((e15) => ZW(e15.type));
  const l10 = __spreadProps(__spreadValues({}, e14), { value: a10, createEditor: (e15, t11) => {
    const r11 = e15;
    const s11 = { descriptor: AV(o10, { valuePath: { $set: `${o10.valuePath}.${t11}` } }), value: r11.PlotName, setProperty: i10, defaultValue: "", plotNames: a10.map((e16) => e16.PlotName).filter((e16) => e16 !== r11.PlotName), disabled: n10 };
    return tp.createElement(kCe, __spreadValues({}, s11));
  }, onSelect: (e15) => r10(c5($j(s10.path, `Plots.${e15}`), "dvchartplot")), onAdd: () => {
    n10 || r10($ye.addPlot());
  }, onDelete: (e15) => {
    n10 || r10($ye.deletePlot(e15));
  }, reordering: { type: "drag" } });
  return tp.createElement(WSe, __spreadValues({}, l10));
};
const [, , DCe] = Dp("wd-editor-chart-collection-editor");
const [LCe] = DCe("item");
const HCe = (e14) => {
  const { descriptor: { label: t10, valuePath: n10 } } = e14;
  const { t: r10 } = vp();
  const { drillPropertiesPath: o10 } = ep.useContext(Iue);
  const a10 = PA();
  const i10 = __spreadProps(__spreadValues({}, e14), { createEditor: ({ Text: e15 }, t11) => tp.createElement("div", { className: LCe }, `${r10("nameTemplates:label")} ${t11}`), onSelect: (e15) => {
    o10 == null ? void 0 : o10(`${n10}.${e15}`, r10(t10));
  }, onAdd: () => {
    a10($ye.addPlotCustomLabel());
  }, onDelete: (e15) => {
    a10($ye.deletePlotCustomLabel(e15));
  }, reordering: { type: "drag" } });
  return tp.createElement(WSe, __spreadValues({}, i10));
};
const [ICe] = Dp("wd-nested-property-grid-panel");
const _Ce = xve();
const VCe = "plotOverlayPanel";
const RCe = () => {
  var _a2, _b2;
  const { rdlx: { propertyGrid: { objectValue: e14, objectPath: t10 } } } = d9();
  const { state: { descriptors: n10, setProperty: r10, overlayIndex: o10 }, closePanel: a10 } = i$(VCe, t10, e14);
  const { t: i10 } = vp();
  const s10 = e14[0];
  const l10 = (_b2 = (_a2 = s10 == null ? void 0 : s10.Config) == null ? void 0 : _a2.Overlays) == null ? void 0 : _b2[o10];
  if (ep.useEffect(() => {
    l10 || a10();
  }, [a10, l10]), !l10) return null;
  const c10 = { descriptors: n10, objectValue: __spreadProps(__spreadValues({}, l10), { name: l10.Name }), defaultValue: _Ce, propertyEditors: QVe, setProperty: (e15, t11) => r10(WN(e15, `Config.Overlays.${o10}`), t11), t: i10, customCSS: Lz };
  const u10 = { dvplot: s10 };
  return tp.createElement("div", { className: ICe }, tp.createElement(bF, null, tp.createElement(Oue.Provider, { value: u10 }, tp.createElement(wD, __spreadValues({}, c10)))));
};
RCe.displayName = "PlotOverlayPanel";
const ACe = { descriptors: [], setProperty: () => {
}, overlayIndex: 0 };
const OCe = (e14 = ACe, t10) => {
  if (!t10) return e14;
  switch (t10.type) {
    case "@core/panels/INIT_PANEL":
      return AV(e14, { $merge: t10.payload });
    case "@overlayPanel/UPDATE_DESCRIPTORS": {
      const { payload: { descriptors: n10 } } = t10;
      return AV(e14, { descriptors: { $set: n10 } });
    }
    default:
      return e14;
  }
};
const [, , BCe] = Dp("wd-editor-chart-collection-editor");
const [zCe] = BCe("item");
const $Ce = (e14) => {
  const t10 = PA();
  const { dispatchPanelAction: n10 } = a$(VCe);
  const r10 = (t11, n11) => {
    return [(r11 = e14.value.filter((e15, t12) => t12 !== n11).map((e15) => e15.Name), Zq(wve, "dvPlotOverlays.name", "dvchart_plot_overlay_name", "Name", "both", { occupiedNames: r11 })), ...Mve, ...kve(t11)];
    var r11;
  };
  const o10 = (t11) => (o11, a11) => {
    const { setProperty: i10 } = e14;
    i10(o11, a11), "dvchart_plot_overlay_type" === o11.type && n10(function(e15) {
      return Kz.action("@overlayPanel/UPDATE_DESCRIPTORS", { descriptors: e15 });
    }(r10(a11, t11)));
  };
  const a10 = __spreadProps(__spreadValues({}, e14), { createEditor: ({ Name: e15 }) => tp.createElement("div", { className: zCe }, e15), onSelect: (n11) => {
    const { descriptor: { label: a11 }, value: i10 } = e14;
    const { OverlayType: s10 } = i10[n11];
    const l10 = r10(s10, n11);
    t10(Xz(VCe, a11, void 0, { setProperty: o10(n11), descriptors: l10, overlayIndex: n11 }));
  }, onAdd: () => {
    t10($ye.addPlotOverlay(kG(TG("dvchartoverlay"), e14.value.map(({ Name: e15 }) => e15))));
  }, onDelete: (e15) => {
    t10($ye.deletePlotOverlay(e15));
  }, reordering: { type: "drag" } });
  return tp.createElement(WSe, __spreadValues({}, a10));
};
const WCe = ["Candlestick", "HighLowOpenClose", "HighLowClose"];
const jCe = ["ReferenceBand"];
const ZCe = (e14) => {
  var _a2;
  const { descriptor: t10 } = e14;
  const { t: n10 } = vp();
  const r10 = ep.useContext(Oue);
  const o10 = (_a2 = r10.dvplot) == null ? void 0 : _a2.PlotChartType;
  let a10 = OO(t10.type, n10);
  o10 && WCe.includes(o10) && (a10 = a10.filter((e15) => !jCe.includes(e15.value)));
  const i10 = __spreadProps(__spreadValues({}, e14), { currentEnum: a10 });
  return tp.createElement(nse, __spreadValues({}, i10));
};
ZCe.displayName = "DVChartPlotOverlayType";
const [, , GCe] = Dp("wd-editor-chart-collection-editor");
const [UCe] = GCe("item");
const [, , qCe] = Dp("wd-editor-chart-plot-pointers");
const [YCe] = qCe("item");
const KCe = (e14) => {
  const { descriptor: { label: t10, valuePath: n10 } } = e14;
  const { t: r10 } = vp();
  const o10 = PA();
  const { drillPropertiesPath: a10 } = ep.useContext(Iue);
  const i10 = __spreadProps(__spreadValues({}, e14), { createEditor: (e15, t11) => tp.createElement("div", { className: kp(UCe, YCe) }, tp.createElement("div", { className: "gc-color__main", style: { backgroundColor: e15.Style.BackgroundColor } }), tp.createElement("span", null, `${r10("nameTemplates:pointer")} ${t11}`)), onSelect: (e15) => {
    a10 == null ? void 0 : a10(`${n10}.${e15}`, r10(t10));
  }, onAdd: () => {
    o10($ye.addPlotPointer());
  }, onDelete: (e15) => {
    o10($ye.deletePlotPointer(e15));
  }, reordering: { type: "drag" } });
  return tp.createElement(WSe, __spreadValues({}, i10));
};
function XCe(e14) {
  return e14.hasOwnProperty("type");
}
const [JCe] = Dp("gc-treeview");
const [QCe, , exe] = Dp("gc-treenode");
const [txe, nxe] = exe("subtree");
const [rxe, , oxe] = Dp("gc-treeitem");
const [axe] = oxe("text");
const [ixe] = oxe("icon");
const sxe = (e14) => {
  const { node: t10, handlers: n10, selectedNode: r10, pathToSelectedNode: o10, resetPath: a10, selectNode: i10, expandedByDefault: s10 } = e14;
  const { children: l10 = [], isLeaf: c10, disabled: u10 } = t10;
  const d10 = rf(Xm);
  const p10 = rf(Jm);
  const [m10, h10] = ep.useState(!!s10);
  const f10 = ep.useRef(null);
  ep.useEffect(() => {
    o10.includes(t10.key) && !m10 && (h10(true), (r10 == null ? void 0 : r10.key) === t10.key && setTimeout(() => {
      var _a2;
      (_a2 = f10.current) == null ? void 0 : _a2.scrollIntoView({ block: "nearest" }), a10 == null ? void 0 : a10();
    }, 150));
  }, [m10, t10.key, o10, a10, r10 == null ? void 0 : r10.key]);
  const g10 = !!l10.length;
  const y10 = kp(rxe, axe);
  const v10 = (r10 == null ? void 0 : r10.key) === t10.key;
  const b10 = () => {
    ("function" != typeof n10.onNodeClick || n10.onNodeClick(t10)) && (u10 || (c10 ? i10(t10) : h10(!m10)));
  };
  const S10 = { customCSS: axe, block: true, size: "small", accent: v10 ? "full" : "none", background: v10 ? "default" : "transparent", disabled: u10, onClick: b10, text: t10.label };
  const C10 = { customCSS: ixe, disabled: u10, icon: m10 ? p10 : d10, size: "small", accent: "icon", background: "transparent", onClick: b10 };
  const x10 = kp(txe, nxe("outline"));
  return tp.createElement("div", { className: QCe, key: t10.label }, tp.createElement("div", { ref: f10, className: y10, onClick: b10, onDoubleClick: () => {
    "function" == typeof n10.onNodeDoubleClick && n10.onNodeDoubleClick(t10), u10 || c10 || i10(t10);
  }, title: t10.label }, tp.createElement(qm, __spreadValues({}, S10)), !c10 && tp.createElement(qm, __spreadValues({}, C10))), g10 && m10 && tp.createElement("div", { className: x10 }, l10.map((e15) => XCe(e15) ? e15.renderNode(n10) : tp.createElement(sxe, { key: e15.label, node: e15, selectNode: i10, selectedNode: r10, pathToSelectedNode: o10, resetPath: a10, handlers: n10 }))));
};
const lxe = (e14) => {
  const { nodes: t10, handlers: n10, selectedNode: r10, pathToSelectedNode: o10 = [], resetPath: a10, selectNode: i10 } = e14;
  const s10 = 1 === t10.length;
  return tp.createElement("div", { className: JCe }, t10.map((e15, t11) => {
    if (XCe(e15)) return e15.renderNode(n10);
    const l10 = { node: e15, handlers: n10, selectedNode: r10, pathToSelectedNode: o10, resetPath: a10, selectNode: i10, expandedByDefault: s10 };
    return tp.createElement(sxe, __spreadProps(__spreadValues({}, l10), { key: t11 }));
  }));
};
lxe.displayName = "TextEditorTree";
const [cxe, , uxe] = Dp("expression-functions");
const [dxe] = uxe("tree");
const pxe = (e14) => {
  const { nodes: t10, handlers: n10, selectedNode: r10, pathToSelectedNode: o10, resetPath: a10, selectNode: i10 } = e14;
  const { t: s10 } = vp("dialogs");
  const l10 = __spreadProps(__spreadValues({}, n10), { onNodeClick: (e15) => (!XCe(e15) && e15.isLeaf && i10(e15), true) });
  return tp.createElement("div", { className: cxe }, tp.createElement(LE, { text: s10("expressionEditor.headingFunctions"), strikeThrough: false, level: "info", weight: "bold", headingLevel: "h2" }), tp.createElement("div", { className: dxe }, tp.createElement(bF, { autoHide: true }, tp.createElement(lxe, { nodes: t10, handlers: l10, selectedNode: r10, pathToSelectedNode: o10, resetPath: a10, selectNode: i10 }))));
};
pxe.displayName = "ExpressionEditorFunctions";
const [mxe] = Dp("expression-info");
const hxe = ({ nodeInfo: e14 }) => {
  const { t: t10 } = vp("dialogs");
  return tp.createElement("div", { className: mxe }, tp.createElement(LE, { text: `${t10("expressionEditor.headingInfo")}`, strikeThrough: false, level: "info", weight: "bold", headingLevel: "h2" }), tp.createElement("div", null, tp.createElement(bF, { autoHide: true }, e14 == null ? void 0 : e14.map((e15) => tp.createElement(ep.Fragment, { key: e15.label }, tp.createElement(LE, { text: e15.label, key: e15.label, uppercase: false, strikeThrough: false, weight: "bold" }), tp.createElement("div", { "data-label": e15.label }, e15.content))))));
};
hxe.displayName = "ExpressionEditorInfo";
const [, , fxe] = Dp("wd-text-editor-dialog");
const [gxe] = fxe("search");
const [yxe, vxe] = fxe("searchItem");
const bxe = ({ text: e14, highlight: [t10, n10] }) => {
  const r10 = e14.substring(0, t10);
  const o10 = e14.substring(t10, t10 + n10);
  const a10 = e14.substring(t10 + n10);
  return tp.createElement("span", null, r10, tp.createElement("b", null, o10), a10);
};
const Sxe = ({ text: e14, highlight: t10, path: n10 }) => void 0 !== t10 ? tp.createElement("div", { className: kp(yxe) }, tp.createElement(bxe, { text: e14, highlight: t10 }), tp.createElement("span", null, n10)) : tp.createElement("div", { className: kp(yxe, vxe("disabled")) }, tp.createElement("span", null, e14));
const Cxe = (e14, t10, n10, r10, o10) => ({ type: r10, text: e14.label || "", path: t10, keys: n10, highlight: o10, node: e14 });
const xxe = (e14, t10, n10 = "", r10 = [], o10 = "") => e14.reduce((e15, a10) => {
  var _a2, _b2;
  if (XCe(a10)) return e15;
  if (a10.children && a10.children.length > 0) return [...e15, ...xxe(a10.children, t10, "" === n10 ? a10.label || "" : `${n10} \xB7 ${a10.label || ""}`, [...r10, a10.key], o10)];
  if (true !== a10.isLeaf) return e15;
  const i10 = (_b2 = (_a2 = a10.label) == null ? void 0 : _a2.toLowerCase().indexOf(o10)) != null ? _b2 : -1;
  return i10 < 0 ? e15 : [...e15, Cxe(a10, n10, [...r10, a10.key], t10, [i10, o10.length])];
}, []);
const wxe = (e14, t10, n10) => [...xxe(e14, "function", "", [], n10), ...xxe(t10, "value", "", [], n10)];
const Txe = ({ functionNodes: e14, valueNodes: t10, onResultSelected: n10 }) => {
  const [r10, o10] = ep.useState({ results: [], text: "" });
  const { t: a10 } = vp("dialogs");
  const i10 = ep.useCallback(({ target: { value: n11 } }) => {
    o10({ results: n11.length > 0 ? wxe(e14, t10, n11.toLowerCase()) : [], text: n11 });
  }, [e14, t10]);
  const s10 = ep.useCallback((e15) => {
    o10({ results: [], text: "" }), n10(e15);
  }, [n10]);
  const l10 = ep.useMemo(() => {
    const { text: e15, results: t11 } = r10;
    if (0 === t11.length) return 0 === e15.length ? [{ type: "button", disabled: true, text: a10("expressionEditor.search.textStartTyping", "start typing to see results") }] : [{ type: "button", disabled: true, text: a10("expressionEditor.search.textNoResults", `no results for "${e15}"`, { query: e15 }) }];
    const n11 = [];
    const o11 = [];
    return t11.forEach(({ type: e16, text: t12, path: r11, highlight: a11, node: i11, keys: s11 }) => {
      ("function" === e16 ? n11 : o11).push({ type: "button", text: t12, highlight: a11, path: r11, value: { node: i11, keys: s11 } });
    }), [n11.length > 0 ? { type: "header", header: a10("expressionEditor.headingFunctions", "Functions") } : void 0, ...n11, o11.length > 0 ? { type: "header", header: a10("expressionEditor.headingValues", "Values") } : void 0, ...o11];
  }, [r10, a10]);
  const c10 = { value: r10.text, items: l10, block: true, rounded: true, size: "small", itemSize: "default", width: "120px", menuWidth: "default", menuMaxHeight: "default", placeholder: a10("expressionEditor.search.placeholderSearch", "search..."), customCSS: gxe, customButtonRenderer: Sxe, onChange: i10, onSelect: s10 };
  return tp.createElement(tM, __spreadValues({}, c10));
};
const [Exe, , Fxe] = Dp("wd-text-editor-dialog");
const [Mxe] = Fxe("tree-container");
const [kxe] = Fxe("heading-container");
const [Pxe] = Fxe("error-container");
const [Nxe, Dxe] = Fxe("textarea");
const [Lxe] = Fxe("function-list");
const [Hxe] = Fxe("info");
const Ixe = (e14) => {
  let t10 = ih;
  return "error" === e14 ? t10 = Dh : "warning" === e14 && (t10 = Nh), nf(t10, { size: "small" });
};
const _xe = (e14) => ({ onNodeDoubleClick: (t10) => {
  if (t10.disabled || !t10.isLeaf || !t10.value) return false;
  const { editorValue: n10, selection: { current: r10 }, setEditorValue: o10, setEditorSelection: a10, focusEditor: i10 } = e14;
  const s10 = n10.substring(0, r10.start);
  const l10 = n10.substring(r10.end);
  const c10 = `${s10}${t10.value}${l10}`;
  const u10 = r10.start + t10.value.length;
  const d10 = { start: u10, end: u10 };
  return o10(c10), i10(), setTimeout(() => a10(d10), 0), true;
} });
const Vxe = "dialogsProperties";
const Rxe = "expressionEditor";
const Axe = (e14, t10, n10) => {
  const r10 = localStorage.getItem(Vxe);
  if (r10) {
    const o11 = JSON.parse(r10);
    const a10 = o11[e14] ? AV(o11, { [e14]: { [t10]: { $set: n10 } } }) : __spreadProps(__spreadValues({}, o11), { [e14]: { [t10]: n10 } });
    return void localStorage.setItem(Vxe, JSON.stringify(a10));
  }
  const o10 = { [e14]: { [t10]: n10 } };
  localStorage.setItem(Vxe, JSON.stringify(o10));
};
const Oxe = (e14) => {
  var _a2;
  const { title: t10, subtitle: n10, value: r10, treeNodes: o10, fnNodes: a10, onSave: i10, onCancel: s10, validate: l10 = zY.success, treeAdapter: c10 = _xe, customCSS: u10, localizeCustomValidationMessage: d10, preValidate: p10 } = e14;
  const [m10, h10] = ep.useState(r10);
  const [f10, g10] = ep.useState(l10(r10, true));
  const [y10, v10] = ep.useState(null);
  const [b10, S10] = ep.useState([]);
  const { closeDialog: C10 } = RA();
  const { t: x10 } = vp("dialogs");
  const w10 = ep.useRef({ start: 0, end: 0 });
  const T10 = ep.useRef(null);
  const E10 = c10({ editorValue: m10, selection: w10, setEditorValue: h10, setEditorSelection: (e15) => {
    var _a3;
    (_a3 = T10.current) == null ? void 0 : _a3.setSelectionRange(e15.start, e15.end), w10.current = e15;
  }, focusEditor: () => {
    var _a3;
    (_a3 = T10.current) == null ? void 0 : _a3.focus();
  } });
  const F10 = () => {
    "function" == typeof s10 && s10(), C10();
  };
  const M10 = ep.useCallback(() => {
    S10([]);
  }, []);
  const k10 = ep.useCallback(({ keys: e15, node: t11 }) => {
    S10(e15), v10(t11);
  }, []);
  const { position: P10, size: N10 } = (() => {
    const e15 = localStorage.getItem(Vxe);
    return e15 ? JSON.parse(e15)[Rxe] : { position: void 0, size: void 0 };
  })();
  const D10 = { open: true, title: t10, subtitle: n10, controls: { align: "right", buttons: [{ text: x10("common:btnSave", "Save"), onClick: () => {
    let e15 = l10(m10);
    if (e15.isValid && p10) {
      for (const e16 of p10(m10)) {
        const t11 = l10(e16);
        if (!t11.isValid) return void g10(t11);
      }
      e15 = { isValid: true };
    }
    i10(m10, e15) ? C10() : g10(e15);
  }, accent: "full" }, { text: x10("common:btnCancel", "Cancel"), onClick: F10, accent: "none" }] }, onClose: F10, style: { content: { width: "800px", height: "500px" } }, customCSS: kp("gcs-zi", u10), shouldCloseOnOverlayClick: false, shouldCloseOnEsc: true, canResize: true, minWidth: 600, minHeight: 500, customScroll: true, position: P10, size: N10, onUpdatePosition: (e15) => {
    Axe(Rxe, "position", e15);
  }, onUpdateSize: (e15) => {
    Axe(Rxe, "size", e15);
  } };
  const L10 = { handlers: E10, selectedNode: y10, pathToSelectedNode: b10, resetPath: M10, selectNode: v10 };
  const H10 = __spreadProps(__spreadValues({}, L10), { nodes: o10 });
  const I10 = __spreadProps(__spreadValues({}, L10), { nodes: a10 });
  const _10 = { value: m10, onChange: (e15) => h10(e15.target.value), onSelect: (e15) => {
    w10.current = { start: e15.target.selectionStart, end: e15.target.selectionEnd };
  }, autoFocus: true, spellCheck: false, placeholder: x10("expressionEditor.placeholderExpression", "Enter expression"), className: kp(Nxe, { [Dxe("invalid")]: !f10.isValid }), ref: T10 };
  const V10 = (f10.messages || []).sort((e15, t11) => e15.level.localeCompare(t11.level)).slice(0, 2).map((e15) => {
    const t11 = d10 == null ? void 0 : d10(e15);
    return t11 != null ? t11 : ((e16, t12, n11) => {
      const { level: r11, valueType: o11, key: a11, args: i11, pattern: s11, positionInfo: l11 } = e16;
      let c11 = i11;
      if (l11 && n11) {
        const e17 = t12(n11, l11);
        c11 = __spreadProps(__spreadValues({}, i11), { positionInfo: e17 });
      }
      const u11 = a11 ? t12(`validationErrors:${o11}.${a11}`, c11) : "";
      let d11 = u11;
      return s11 && (d11 = t12(s11, { type: o11, info: u11 })), { level: r11, text: d11 };
    })(e15, x10, "propertyEditors:validationErrors.errorPosition");
  });
  const R10 = kp(kxe);
  const A10 = { strikeThrough: false, level: "info", headingLevel: "h2", weight: "bold" };
  const O10 = __spreadProps(__spreadValues({}, A10), { level: f10.isValid ? "info" : "error" });
  const B10 = { functionNodes: a10, valueNodes: o10, onResultSelected: k10 };
  const z10 = y10 && !XCe(y10) ? (_a2 = y10.getInfo) == null ? void 0 : _a2.call(y10, x10) : void 0;
  const $10 = a10.length > 0;
  const W10 = z10 && z10.length > 0;
  return tp.createElement(Hk, __spreadValues({}, D10), V10.length > 0 && tp.createElement("div", { className: Pxe }, V10.map(({ text: e15, level: t11 }, n11) => tp.createElement(sV, { key: `modal-error-${n11}-${e15}`, size: "small", icon: Ixe(t11), title: e15, level: t11 }))), tp.createElement("div", { className: Exe }, tp.createElement("div", { className: Mxe }, tp.createElement(LE, __spreadProps(__spreadValues({}, A10), { text: x10("expressionEditor.headingValues", "Values") })), tp.createElement("div", null, tp.createElement(bF, { autoHide: true }, tp.createElement(lxe, __spreadValues({}, H10))))), tp.createElement("div", { className: R10 }, tp.createElement(LE, __spreadProps(__spreadValues({}, O10), { text: x10("expressionEditor.headingExpression", "Expression") })), tp.createElement(Txe, __spreadValues({}, B10))), tp.createElement("textarea", __spreadValues({}, _10)), $10 && tp.createElement("div", { className: Lxe }, tp.createElement(pxe, __spreadValues({}, I10))), W10 && z10 && tp.createElement("div", { className: Hxe }, tp.createElement(hxe, { nodeInfo: z10 }))));
};
Oxe.displayName = "TextEditorDialog";
const [Bxe] = Dp("wd-expression-editor-dialog");
const [zxe] = Dp("wd-chart-template-editor-dialog");
const $xe = Bxe;
const Wxe = zxe;
function jxe(e14) {
  const t10 = e14[0];
  for (let n10 = 1; n10 < e14.length; n10++) if (e14[n10] !== t10) return XN;
  return String(t10 != null ? t10 : "");
}
function Zxe(e14, t10) {
  const n10 = jN(e14);
  return t10.map((e15) => n10(e15));
}
function Gxe(e14, t10, n10) {
  const { valuePath: r10 } = e14;
  return { value: jxe(Zxe(r10, t10)), defaultValue: jxe(Zxe(r10, n10)) };
}
function Uxe(e14, t10 = [], n10) {
  const r10 = jxe(e14);
  return uJ(sK(r10) ? "" : r10, t10, n10[0].Name);
}
function qxe(e14) {
  const t10 = e14.map((e15) => e15.Type).filter(Boolean);
  return 0 === t10.length && e14[0].RuleProperties ? ["dvchartplot"] : t10;
}
function Yxe(e14, t10, n10, r10) {
  var _a2, _b2;
  if ("multisectionreport" !== n10.Type || e14.length > 1) return [];
  const o10 = t10[0] || e14[0].Name && ((_a2 = r10 == null ? void 0 : r10.find((t11) => t11.name === e14[0].Name)) == null ? void 0 : _a2.$path);
  const a10 = /^ReportSections.\d*.Body.ReportItems.\d*$/.exec(o10);
  if (!a10) return [];
  const i10 = jN(a10[0])(n10);
  return ((_b2 = n10.ReportParts.find((e15) => e15.ReportItemName === i10.Name)) == null ? void 0 : _b2.Properties) || [];
}
const Kxe = (e14) => e14.split("").reduce((t10, n10, r10) => 0 === r10 && "{" !== n10 ? `"${n10}` : "{" === n10 && 0 !== r10 ? `${t10}" & ` : "}" === n10 && r10 !== e14.length - 1 ? `${t10} & "` : `${t10}${"{" === n10 || "}" === n10 ? "" : n10}`, "");
function Xxe(e14, t10, n10) {
  const { editorValue: r10, selection: { current: o10 }, setEditorValue: a10, setEditorSelection: i10, focusEditor: s10 } = t10;
  let l10 = e14;
  const c10 = l10.includes("()");
  const u10 = e14.startsWith(".");
  const d10 = e14.startsWith('"') && e14.endsWith('"');
  const p10 = e14.includes("&") && "&" !== e14;
  const m10 = function(e15) {
    var _a2, _b2;
    const t11 = e15.replace(/".*"/g, "");
    const n11 = (_a2 = t11.match(/{/g)) == null ? void 0 : _a2.length;
    const r11 = (_b2 = t11.match(/}/g)) == null ? void 0 : _b2.length;
    return n11 && (!r11 || n11 > r11);
  }(r10.substring(0, o10.end));
  const h10 = "i11n" === n10;
  const f10 = r10 && o10.end - o10.start === r10.length;
  const g10 = !u10 && !!r10 && o10.start > 0 && !["(", " ", "="].some((e15) => e15 === r10[o10.start - 1]);
  const y10 = () => c10 ? h10 && !m10 ? r10 ? 2 : 3 : 1 : 0;
  u10 && "." === r10[o10.start - 1] && (l10 = l10.substring(1)), h10 && (l10 = hu(`=${e14}`), l10 = l10.startsWith("=") ? l10.substring(1) : l10, m10 ? d10 ? l10 = `"${l10}"` : p10 ? l10 = Kxe(l10) : l10.startsWith("{") && (l10 = l10.substring(1, l10.length - 1)) : u10 && (l10 = `{${l10}}`));
  const v10 = r10 && `${r10.substring(0, o10.start)}${g10 ? " " : ""}${l10}${r10.substring(o10.end)}` || l10;
  const b10 = `${r10 && !f10 || h10 ? "" : "="}${v10}`;
  const S10 = g10 ? y10() - 1 : y10();
  const C10 = (r10 ? o10.start + l10.length : o10.start + l10.length + 1) - S10;
  const x10 = { start: C10, end: C10 };
  a10(b10), s10(), setTimeout(() => i10(x10), 0);
}
const Jxe = (e14) => (t10) => ({ onNodeDoubleClick: (n10) => !(n10.disabled || !n10.isLeaf || !n10.value) && (n10.isConstant ? function(e15, t11, n11) {
  const { editorValue: r10, selection: { current: o10 }, setEditorValue: a10, setEditorSelection: i10 } = t11;
  if (!r10 || 0 === o10.start && o10.end === (r10 || "").length) {
    const t12 = o10.start + e15.length;
    i10({ start: t12, end: t12 }), a10(e15);
  } else Xxe(`"${e15}"`, t11, n11);
}(n10.value, t10, e14) : Xxe(n10.value, t10, e14), true) });
const Qxe = (e14) => "string" != typeof e14 && (void 0 !== e14.label && void 0 !== e14.value);
const ewe = (e14, t10) => ({ key: e14, value: t10 });
const twe = { ArithmeticOperations: [ewe("power", "^"), ewe("multiply", "*"), ewe("divide", "/"), ewe("integerDivide", "\\"), ewe("mod", "Mod"), ewe("add", "+"), ewe("subtract", "-")], ComparisonOperations: [ewe("lowerThan", "<"), ewe("lowerThanOrEqual", "<="), ewe("greaterThan", ">"), ewe("greaterThanOrEqual", ">="), ewe("equal", "="), ewe("notEqual", "<>"), ewe("like", "Like"), ewe("is", "Is")], ConcatenationOperations: [ewe("concat", "&"), ewe("add", "+")], LogicalOperations: [ewe("and", "And"), ewe("not", "Not"), ewe("or", "Or"), ewe("xor", "Xor"), ewe("andAlso", "AndAlso"), ewe("orElse", "OrElse")], BitShiftOperations: [ewe("leftShift", "<<"), ewe("rightShift", ">>")] };
const nwe = (e14) => (t10) => {
  const n10 = { dataSets: e14, handleAttributeDoubleClick: (e15, n11) => {
    const r10 = t10.onNodeDoubleClick;
    "function" == typeof r10 && r10({ key: "", label: "", isLeaf: true, value: G1(n11.$path) });
  }, handleCalculatedFieldDoubleClick: (e15, n11) => {
    const r10 = t10.onNodeDoubleClick;
    "function" == typeof r10 && r10({ key: "", label: "", isLeaf: true, value: G1(n11) });
  }, treeView: true, allowRebalancing: false, showSearchBox: false };
  return tp.createElement(L9, __spreadProps(__spreadValues({}, n10), { key: "semanticFieldPicker" }));
};
const rwe = (e14, t10, n10) => {
  var _a2;
  return "i11n" === t10 ? (_a2 = n10(`${e14}_i11n`, { defaultValue: null })) != null ? _a2 : n10(e14).split("; ").map(hu).join("; ") : n10(e14, { defaultValue: null });
};
const owe = (e14, t10) => t10 && { label: e14, content: t10 } || null;
const awe = (e14, t10) => {
  var _a2;
  return t10(e14.key) ? XCe(e14) || !((_a2 = e14.children) == null ? void 0 : _a2.length) ? e14 : __spreadProps(__spreadValues({}, e14), { children: e14.children.map((e15) => awe(e15, t10)).filter(Ie) }) : null;
};
const iwe = (e14, t10) => {
  var _a2;
  if (XCe(e14)) return e14;
  const n10 = (e14 == null ? void 0 : e14.label) || t10(e14.key);
  return ((_a2 = e14.children) == null ? void 0 : _a2.length) ? __spreadProps(__spreadValues({}, e14), { label: n10, children: e14.children.map((e15) => iwe(e15, t10)) }) : __spreadProps(__spreadValues({}, e14), { label: n10 });
};
const swe = (e14) => {
  return /* @__PURE__ */ ((e15) => (t11, n10, r10) => {
    const o10 = e15(t11, n10);
    return "function" != typeof r10 ? o10 : Array.isArray(o10) ? o10.map((e16) => awe(e16, r10)).filter(Ie) : awe(o10, r10);
  })(/* @__PURE__ */ ((e15) => {
    let t11;
    let n10;
    return (r10, o10) => (r10 === t11 && void 0 !== n10 || (t11 = r10, n10 = e15(r10, o10)), n10);
  })((t10 = e14, (e15, n10) => {
    const r10 = t10(e15, n10);
    return Array.isArray(r10) ? r10.map((e16) => iwe(e16, n10)) : iwe(r10, n10);
  })));
  var t10;
};
const lwe = (e14) => `expressionFields:${e14}`;
const cwe = (e14, t10, n10) => ({ key: `${e14}.label`, value: t10, isLeaf: true, isConstant: false, getInfo: (t11) => {
  const r10 = t11;
  return [owe(t11("dialogs:expressionEditor.infoPanel.labelSyntax"), r10(`${e14}.syntax`, { defaultValue: null })), owe(t11("dialogs:expressionEditor.infoPanel.labelDescription"), r10(`${e14}.description`, { defaultValue: null })), owe(t11("dialogs:expressionEditor.infoPanel.labelExample"), rwe(`${e14}.example`, n10, r10))].filter(Ie);
} });
const uwe = [{ groupKey: "dateTime", fnList: aJ.DateTimeFunctions }, { groupKey: "math", fnList: aJ.MathFunctions }, { groupKey: "text", fnList: aJ.TextFunctions }, { groupKey: "inspection", fnList: aJ.InspectionFunctions }, { groupKey: "programFlow", fnList: aJ.ProgramFlowFunctions }, { groupKey: "aggregate", fnList: aJ.AggregateFunctions }, { groupKey: "conversion", fnList: aJ.ConversionFunctions }, { groupKey: "miscellaneous", fnList: aJ.MiscellaneousFunctions }];
const dwe = (e14, t10) => ({ key: lwe(`functions.titles.${e14}`), value: e14, isLeaf: false, children: t10, disabled: 0 === t10.length });
const pwe = (e14) => uwe.map(({ groupKey: t10, fnList: n10 }) => dwe(t10, ((e15, t11, n11) => t11.map(({ key: t12, value: r10 }) => cwe(lwe(`functions.info.${e15}.${t12}`), r10, n11)))(t10, n10, e14)));
const mwe = swe((e14) => {
  const t10 = pwe(e14);
  return DX().forEach((n10) => {
    const r10 = cwe(lwe(`functions.info.customFunctions.${n10.key}`), n10.value, e14);
    let o10 = t10.find((e15) => n10.group === e15.value);
    if (!o10) return o10 = dwe(n10.group, [r10]), void t10.push(o10);
    o10.children || (o10.children = []), o10.children.push(r10);
  }), t10;
});
const hwe = [{ groupKey: "arithmetic", fnList: twe.ArithmeticOperations }, { groupKey: "comparison", fnList: twe.ComparisonOperations }, { groupKey: "concatenation", fnList: twe.ConcatenationOperations }, { groupKey: "logicalBitwise", fnList: twe.LogicalOperations }, { groupKey: "bitShift", fnList: twe.BitShiftOperations }];
const fwe = (e14, t10) => {
  const n10 = G1(e14);
  return t10 ? `First(${n10}, "${t10}")` : n10;
};
const gwe = (e14, t10 = e14, n10) => ({ value: e14, label: t10, key: t10, getInfo: n10, isLeaf: true, isConstant: true });
const ywe = (e14, t10) => t10(`propertyEditors:${e14}`);
const vwe = (e14, t10, n10) => [owe(n10("dialogs:expressionEditor.infoPanel.labelName"), t10), owe(n10("dialogs:expressionEditor.infoPanel.labelConstant"), e14)].filter(Ie);
const bwe = (e14, t10, n10) => ({ key: lwe(`documentMap.info.${e14}.label`), value: t10, isLeaf: true, getInfo: (t11) => {
  const r10 = t11;
  return [owe(t11("dialogs:expressionEditor.infoPanel.labelDescription"), r10(lwe(`documentMap.info.${e14}.description`), { defaultValue: null })), owe(t11("dialogs:expressionEditor.infoPanel.labelExample"), rwe(lwe(`documentMap.info.${e14}.example`), n10, r10))].filter(Ie);
} });
const Swe = (e14) => `Theme.Colors!${e14}`;
const Cwe = (e14, t10) => `Theme.Fonts!${e14}.${t10}`;
const xwe = (e14) => cu("themeimages", e14, "ImageData");
const wwe = (e14) => `Theme.Constants("${e14}")`;
const Twe = { operators: swe((e14) => {
  const t10 = hwe.map(({ groupKey: t11, fnList: n10 }) => {
    const r10 = ((e15, t12, n11) => t12.map(({ key: t13, value: r11 }) => cwe(lwe(`operations.info.${e15}.${t13}`), r11, n11)))(t11, n10, e14);
    return ((e15, t12) => ({ key: lwe(`operations.titles.${e15}`), value: e15, isLeaf: false, children: t12, disabled: 0 === t12.length }))(t11, r10);
  });
  return { key: lwe("operations.titles.label"), isLeaf: false, children: t10 };
}), dataSets: swe((e14) => {
  const { dataSets: t10, dataSources: n10 } = e14;
  const r10 = t10[0] && C6(t10[0], n10);
  const o10 = 1 === t10.length ? (e15) => fwe(e15) : fwe;
  return r10 ? ((e15) => ({ key: lwe("dataSets.titles.label"), children: [{ type: "custom", key: "labelDataSets.fields", renderNode: nwe(e15) }], disabled: 0 === e15.length }))(t10) : { key: lwe("dataSets.titles.label"), children: t10.map((e15) => {
    const t11 = yK(e15);
    return { key: e15.Name, label: e15.Name, children: t11.map((t12) => ({ key: t12.Name, label: t12.Name, value: o10(t12.Name, e15.Name), isLeaf: true })), disabled: 0 === t11.length };
  }), disabled: 0 === t10.length };
}), constants: (e14, t10, n10, r10, o10, a10, i10) => {
  const s10 = ((e15, t11, n11, r11, o11, a11) => {
    switch (e15) {
      case "border_style": {
        const r12 = qxe(t11);
        return eK.of("global").getBorderStyles(r12).map((t12) => {
          const r13 = RO(e15, t12, n11);
          return gwe(t12, r13, () => vwe(t12, r13, n11));
        });
      }
      case "text_decoration": {
        const r12 = qxe(t11);
        return eK.of("global").getTextDecorations(r12).map((t12) => {
          const r13 = RO(e15, t12, n11);
          return gwe(t12, r13, () => vwe(t12, r13, n11));
        });
      }
      case "color_expr":
        return dm.webColors().map((e16) => gwe(e16));
      case "boolean_expr":
        return [{ value: "True", label: ywe("boolean.textTrue", n11) }, { value: "False", label: ywe("boolean.textFalse", n11) }].map((e16) => gwe(e16.value, e16.label, () => vwe(e16.value, e16.label, n11)));
      case "toggle_state":
        return [{ value: "True", label: ywe("toggleState.textExpanded", n11) }, { value: "False", label: ywe("toggleState.textCollapsed", n11) }].map((e16) => gwe(e16.value, e16.label, () => vwe(e16.value, e16.label, n11)));
      case "integer_positive_expr":
        return ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"].map((e16) => gwe(e16));
      case "mime_type":
        return (r11 || []).map((e16) => gwe(e16));
      case "language":
        return (o11 ? [{ value: "Default", label: RO("language", "Default", n11) }, ...o11] : OO("language", n11)).map(({ label: e16, value: t12 }) => gwe(t12, e16, () => vwe(t12, e16, n11)));
      case "font_family":
        return a11 ? a11.map((e16) => "string" == typeof e16 ? gwe(e16) : Qxe(e16) ? gwe(e16.value, e16.label) : null).filter(Ie) : [];
      default:
        return _O(e15) ? OO(e15, n11).map(({ label: e16, value: t12 }) => gwe(t12, e16, () => vwe(t12, e16, n11))) : [];
    }
  })(e14, t10, n10, o10, a10, i10);
  const l10 = iwe({ key: lwe("constants.titles.label"), children: s10, isLeaf: false, disabled: 0 === s10.length }, n10);
  return "function" == typeof r10 ? awe(l10, r10) : l10;
}, documentsMap: swe((e14) => ({ key: lwe("documentMap.titles.label"), isLeaf: false, children: [bwe(qX.key, qX.value, e14)] })), chart: swe(({ expressionSyntax: e14, chartType: t10 }) => {
  const n10 = (t11) => (n11) => {
    const r11 = n11;
    return [owe(n11("dialogs:expressionEditor.infoPanel.labelSyntax"), r11(lwe(`chart.${t11}.syntax`), { defaultValue: null })), owe(n11("dialogs:expressionEditor.infoPanel.labelDescription"), r11(lwe(`chart.${t11}.description`), { defaultValue: null })), owe(n11("dialogs:expressionEditor.infoPanel.labelExample"), rwe(lwe(`chart.${t11}.example`), e14, r11))].filter(Ie);
  };
  const r10 = (e15) => "Functions" === e15 ? ["CurrentValue", "NextValue", "PreviousValue"].map((t11) => ({ key: lwe(`chart.${e15}.${t11}.label`), value: `${t11}()`, getInfo: n10(`${e15}.${t11}`), isLeaf: true, isConstant: false })) : ((e16) => {
    switch (e16) {
      case "Candlestick":
      case "HighLowOpenClose":
      case "HighLowClose":
        return ["DataHigh", "DataLow", "DataOpen", "DataClose", "Detail", "Category"];
      case "Gantt":
      case "RangeColumn":
      case "RangeArea":
      case "RangeBar":
        return ["DataUpper", "DataLower", "Detail", "Category"];
      default:
        return ["Data", "Detail", "Category"];
    }
  })(t10).map((t11) => ({ key: lwe(`chart.${e15}.${t11}.label`), value: `Chart!${e15}${t11}`, getInfo: n10(`${e15}.${t11}`), isLeaf: true, isConstant: false }));
  const o10 = ["Current", "Next", "Previous", "Functions"].map((e15) => ({ key: lwe(`chart.${e15}.label`), children: r10(e15), isLeaf: false }));
  return { key: lwe("chart.label"), children: o10 };
}), commonValues: swe(({ reportType: e14, objectValue: t10, expressionSyntax: n10 }) => {
  const r10 = ZX(e14).map((e15) => ({ key: e15.Key, label: e15.Name, value: e15.Expr, isLeaf: true, getInfo: (t11) => {
    const n11 = t11;
    return [owe(t11("dialogs:expressionEditor.infoPanel.labelDescription"), n11(lwe(`commonValues.info.${e15.Key}.description`), { defaultValue: null }))].filter(Ie);
  } }));
  return t10.every((e15) => "textbox" === e15.Type) && r10.push({ key: lwe("commonValues.info.textboxValue.label"), label: "", value: "i11n" === n10 ? "$$$" : "$$", isLeaf: true, getInfo: (e15) => {
    const t11 = e15;
    return [owe(e15("dialogs:expressionEditor.infoPanel.labelDescription"), t11(lwe("commonValues.info.textboxValue.description"), { defaultValue: null })), owe(e15("dialogs:expressionEditor.infoPanel.labelExample"), rwe(lwe("commonValues.info.textboxValue.example"), n10, t11))].filter(Ie);
  } }), { key: lwe("commonValues.titles.label"), isLeaf: false, children: r10 };
}), parameters: swe((e14 = []) => ({ key: lwe("parameters.titles.label"), children: e14.map((e15) => ({ key: e15.Name, label: e15.Name, value: `Parameters!${e15.Name}.Value`, isLeaf: true })), disabled: 0 === e14.length })), theme: swe((e14) => {
  let t10 = [];
  if (e14 && !e14.$isFallback) {
    const { Constants: n10 = [], Images: r10 = [], Fonts: { MajorFont: o10, MinorFont: a10 }, Colors: i10 } = e14;
    t10 = [{ key: lwe("theme.titles.font"), children: [{ key: lwe("theme.titles.majorFont"), children: Object.keys(o10).map((e15) => ({ key: `majorFont.${e15}`, label: e15, value: Cwe("MajorFont", e15), isLeaf: true })) }, { key: lwe("theme.titles.minorFont"), children: Object.keys(a10).map((e15) => ({ key: `minorFont.${e15}`, label: e15, value: Cwe("MinorFont", e15), isLeaf: true })) }] }, { key: lwe("theme.titles.color"), children: Object.keys(i10).map((e15) => ({ key: `color.${e15}`, label: e15, value: Swe(e15), isLeaf: true })) }, { key: lwe("theme.titles.constant"), children: n10.map((e15) => ({ key: `constant.${e15.Key}`, label: e15.Key, value: wwe(e15.Key), isLeaf: true })), disabled: 0 === n10.length }, { key: lwe("theme.titles.image"), children: r10.map((e15) => ({ key: `image.${e15.Name}`, label: e15.Name, value: xwe(e15.Name), isLeaf: true })), disabled: 0 === r10.length }];
  }
  return { key: lwe("theme.titles.label"), children: t10, disabled: 0 === t10.length };
}), reportItems: swe((e14) => {
  const t10 = e14.map((e15) => ({ key: e15, label: e15, value: `ReportItems!${e15}.Value`, isLeaf: true }));
  return { key: lwe("reportItems.titles.label"), children: t10, disabled: 0 === t10.length };
}), dvchartTemplateConstants: swe(function(e14, t10) {
  const n10 = e14.map((e15) => e15.PlotChartType);
  const r10 = obe(n10);
  const o10 = /\{(.*)\}/;
  const a10 = t10;
  const i10 = r10.map((e15) => {
    const n11 = o10.exec(e15);
    const r11 = n11 && n11[1] || e15;
    const i11 = RO("dvchart_template", r11, t10);
    return { key: i11, label: i11, isLeaf: true, isConstant: true, value: e15, getInfo: () => [owe(t10("dialogs:expressionEditor.infoPanel.labelName"), i11), owe(t10("dialogs:expressionEditor.infoPanel.labelConstant"), e15), owe(t10("dialogs:expressionEditor.infoPanel.labelDescription"), a10(`expressionFields:constants.dvchart_template.${r11.replace(":", "_")}.description`))].filter(Ie) };
  });
  return { key: lwe("constants.titles.label"), children: i10, isLeaf: false, disabled: 0 === i10.length };
}), textEncodings: function(e14, t10, n10 = "Label") {
  if (e14.length > 1) return null;
  const r10 = e14[0].Encodings.Texts.filter((e15) => e15.Target === n10);
  if (0 === r10.length) return null;
  const o10 = r10.map((e15) => ({ key: e15.Field.TemplateKey, label: e15.Field.TemplateKey, isLeaf: true, isConstant: true, value: `{${e15.Field.TemplateKey}}` }));
  return iwe({ key: lwe("textEncodingFields.titles.label"), children: o10, isLeaf: false, disabled: 0 === o10.length }, t10);
}, reportPartProperties: function(e14, t10, n10 = [], r10) {
  if (e14.length > 1 || 0 === n10.length) return null;
  const o10 = n10.map((e15) => ({ key: e15.Name, label: e15.Name, isLeaf: true, value: `PartProperties!${e15.Name}.Value`, getInfo: (n11) => [owe(n11("dialogs:expressionEditor.infoPanel.labelDescription"), e15.Description), owe(n11("dialogs:expressionEditor.infoPanel.labelExample"), rwe(lwe("reportPartProperties.info.example"), r10, t10))].filter(Ie) }));
  return iwe({ key: lwe("reportPartProperties.titles.label"), children: o10, isLeaf: false, disabled: 0 === o10.length }, t10);
} };
const Ewe = (e14, t10, n10, r10, o10, a10 = (e15) => e15, i10, s10, l10 = "i11n", c10, u10, d10, p10) => {
  const { ReportParameters: m10, DataSets: h10 = [], NamedItems: f10, DataSources: g10 = [] } = o10;
  return [Twe.constants(n10, e14, a10, i10, c10, u10, d10), Twe.commonValues({ reportType: r10, objectValue: e14, expressionSyntax: l10 }, a10, i10), Twe.parameters(m10, a10, i10), Twe.dataSets({ dataSets: h10, dataSources: g10 }, a10, i10), Twe.operators(l10, a10, i10), Twe.documentsMap(l10, a10, i10), Twe.theme(s10, a10, i10), Twe.reportItems(Uxe(t10, f10, e14), a10, i10), Twe.reportPartProperties(e14, a10, p10, l10)].filter(Boolean);
};
const Fwe = (e14) => {
  var _a2, _b2;
  const { title: t10, subtitle: n10, descriptor: r10, objectValues: o10, objectPaths: a10, defaultValues: i10, reportIndex: s10, reportType: l10, theme: c10, validationContext: u10, setProperty: d10, localizeCustomValidationMessage: p10 } = e14;
  const { rdlx: { expressionSyntax: m10, expressionEditorNodesFilter: h10, reportLanguages: f10 }, imageMimeTypes: g10, userPreferences: { units: y10 }, fonts: v10 } = Uae();
  const { t: b10 } = vp("dialogs");
  const S10 = h9();
  const { value: C10, defaultValue: x10 } = Gxe(r10, o10, i10);
  const w10 = HJ(C10, r10.type, { expressionSyntax: m10 }, r10.meta, "").trim();
  const T10 = HJ(x10, r10.type, { expressionSyntax: m10 }, r10.meta, "");
  const E10 = sK(C10);
  const F10 = o10.every((e15) => "textbox" === e15.Type);
  const M10 = o10.map((e15) => e15.Type).filter(Boolean);
  const k10 = ((_a2 = r10.meta) == null ? void 0 : _a2.exprEditorFilter) ? /* @__PURE__ */ ((e15, t11) => (n11) => e15(n11) && (!t11 || t11(n11)))((_b2 = r10.meta) == null ? void 0 : _b2.exprEditorFilter, h10) : h10;
  const P10 = (({ type: e15, meta: t11 }) => {
    switch (e15) {
      case "enum_expr":
      case "font_size_expr":
        return t11 == null ? void 0 : t11.enumKey;
      case "boolean_expr":
        return (t11 == null ? void 0 : t11.booleanType) || e15;
      default:
        return e15;
    }
  })(r10);
  const N10 = Yxe(o10, a10, S10, s10.NamedItems);
  const D10 = Ewe(o10, a10, P10, l10, s10, b10, k10, c10, m10, g10, f10, v10, N10);
  const L10 = mwe(m10, b10, k10);
  const H10 = t10 || (({ category: e15, label: t11, meta: n11 }, r11) => {
    const o11 = n11 && (n11 == null ? void 0 : n11.parentLabel) ? `${r11(n11 == null ? void 0 : n11.parentLabel)} - ${r11(t11)}` : r11(t11);
    return e15 ? `${r11(e15)} - ${r11(o11)}` : r11(o11);
  })(r10, b10);
  const I10 = { title: H10 || b10("expressionEditor.subtitle", "Expression Editor"), subtitle: H10 ? n10 || b10("expressionEditor.subtitle", "Expression Editor") : void 0, treeNodes: D10, fnNodes: L10, treeAdapter: Jxe(m10), value: w10, preValidate: F10 ? (e15) => F10 ? o10.map((t11) => HJ(q2(t11, 0, ("i11n" === m10 ? NJ(e15, r10.type, { expressionSyntax: m10, units: y10 }, r10.meta) : e15) || e15), r10.type, { expressionSyntax: m10, units: y10 }, r10.meta)) : [e15] : void 0, validate: (e15, t11) => {
    if (t11 && E10) return zY.success();
    const n11 = { descriptor: r10, defaultValue: T10, itemTypes: M10, validationContext: u10, expressionSyntax: m10, units: y10 };
    return FJ(fc(m10, e15), n11);
  }, onSave: (e15, t11) => {
    if (!t11.isValid) return false;
    const n11 = NJ(e15, r10.type, { expressionSyntax: m10, units: y10 }, r10.meta).toString().trim();
    return d10(__spreadProps(__spreadValues({}, r10), { meta: __spreadProps(__spreadValues({}, r10.meta), { withTextboxExpressionValue: F10 }) }), n11), true;
  }, customCSS: $xe, localizeCustomValidationMessage: p10 };
  return tp.createElement(Oxe, __spreadValues({}, I10));
};
Fwe.displayName = "ExpressionEditorDialog";
const Mwe = (e14) => {
  var _a2;
  const t10 = h9();
  const { Type: n10, $index: r10 } = t10;
  const { rdlx: { theme: o10 } } = d9();
  const a10 = PA();
  const i10 = dJ(n10, r10, o10, "", ((_a2 = e14.objectValues[0]) == null ? void 0 : _a2.Name) || "");
  const s10 = __spreadProps(__spreadValues({}, e14), { reportIndex: r10, reportType: n10, objectPaths: [""], validationContext: i10, theme: o10, setProperty: (e15, t11) => {
    a10(o2({ descriptor: e15, value: t11 }));
  } });
  return tp.createElement(Fwe, __spreadValues({}, s10));
};
Mwe.displayName = "ConnectedExpressionEditorDialog";
const kwe = (e14) => Kz.action("@plotRules/UPDATE_RULE_INDEX", { ruleIndex: e14 });
const Pwe = { plotIndex: 0, ruleIndex: 0 };
const Nwe = (e14 = Pwe, t10) => {
  if (!t10) return e14;
  switch (t10.type) {
    case "@core/panels/INIT_PANEL":
      return AV(e14, { $merge: t10.payload });
    case "@plotRules/UPDATE_RULE_INDEX": {
      const { payload: { ruleIndex: n10 } } = t10;
      return AV(e14, { ruleIndex: { $set: n10 } });
    }
    default:
      return e14;
  }
};
const [Dwe] = Dp("wd-plot-rules-panel");
const [Lwe, , Hwe] = Dp("wd-plot-rules");
const [Iwe] = Hwe("nav");
const [_we] = Hwe("props");
const Vwe = "plotRules";
const Rwe = Ave();
const Awe = () => {
  var _a2;
  const { instanceId: e14, userPreferences: { units: t10 }, rdlx: { expressionSyntax: n10, expressionEditorNodesFilter: r10 } } = Uae();
  const { rdlx: { theme: o10, propertyGrid: { objectValue: a10, objectPath: i10 } } } = d9();
  const s10 = h9();
  const l10 = A$();
  const { state: { ruleIndex: c10 }, dispatchPanelAction: u10, closePanel: d10 } = a$(Vwe);
  const { Type: p10, $index: m10 } = s10;
  const h10 = ep.useMemo(() => see(s10), [s10]);
  const { DataSets: f10 = [], DataSources: g10 = [], ReportParameters: y10 = [] } = m10;
  const { t: v10, t: b10 } = vp();
  const S10 = ep.useMemo(() => dJ(p10, m10, o10, i10[0], a10[0].Name), [p10, m10, o10, i10, a10]);
  const C10 = ep.useMemo(() => ({ parameters: y10.map((e15) => e15.Name.toLowerCase()), constants: ["Chart"], fields: false, reportItems: false, themeImages: false }), [y10]);
  const x10 = (({ $index: { NamedItems: e15 = [] } }, t11, n11) => ep.useMemo(() => ({ namedItems: e15, selectedItemsInfo: t11.map(({ Type: e16, Name: t12 }, r11) => ({ type: e16, name: t12, path: n11[r11] })) }), [e15, n11, t11]))(s10, a10, i10);
  const { selectedPlot: w10, selectedPlotPath: T10 } = (_a2 = ((e15, t11) => ep.useMemo(() => {
    if (1 !== e15.length) return null;
    const n11 = e15[0];
    return "dvchartplot" !== (n11 == null ? void 0 : n11.Type) ? null : { selectedPlot: n11, selectedPlotPath: t11[0] };
  }, [t11, e15]))(a10, i10)) != null ? _a2 : { selectedPlot: null, selectedPlotPath: null };
  const E10 = PA();
  const [F10, M10] = ep.useState(null);
  const k10 = F10 && F10 !== T10 ? 0 : c10;
  if (ep.useEffect(() => {
    null !== w10 && 0 !== w10.Config.Rules.length || d10();
  }, [w10]), ep.useEffect(() => {
    F10 && u10(kwe(0)), M10(T10);
  }, [T10]), null === w10) return null;
  const { Config: { Rules: P10 } } = w10;
  const N10 = P10[k10];
  if (!N10) return null;
  const D10 = (e15) => () => {
    k10 !== e15 && u10(kwe(e15));
  };
  const L10 = ({ valuePath: e15 }, t11) => {
    const n11 = ZN(e15);
    const r11 = AV(N10, n11(t11));
    E10($ye.updatePlotRule(k10, r11));
  };
  const H10 = (l11) => {
    var _a3;
    const { value: c11, defaultValue: u11 } = Gxe(l11, [N10], [Rwe]);
    const d11 = "dvchart_plot_rule_condition" === l11.type;
    const h11 = "dvchart_template" === l11.type;
    const f11 = HJ(c11, l11.type, { expressionSyntax: n10, units: t10 }, l11.meta);
    const g11 = (e15, r11) => {
      if (!r11.isValid) return false;
      const o11 = NJ(e15, l11.type, { expressionSyntax: n10, units: t10 }, l11.meta);
      return L10(l11, o11), true;
    };
    const x11 = Yxe(a10, i10, s10, m10.NamedItems);
    const w11 = d11 ? [Twe.chart({ expressionSyntax: n10, chartType: a10[0].PlotChartType }, v10, r10), Twe.parameters(y10, v10, r10), Twe.operators(n10, v10, r10)] : Ewe(a10, i10, l11.type, p10, m10, v10, r10, o10, n10, void 0, void 0, void 0, x11);
    const T11 = (e15) => {
      const r11 = d11 ? C10 : S10;
      const o11 = d11 ? ["dvchartplot"] : a10.map((e16) => e16.Type).filter(Boolean);
      const i11 = { descriptor: l11, defaultValue: u11, itemTypes: o11, validationContext: r11, expressionSyntax: n10, units: t10 };
      return FJ(fc(n10, e15), i11);
    };
    const F11 = { title: `${b10("propertyDescriptors:labels.dvchartPlot.rules")} - ${l11.category ? b10(l11.category) : b10(l11.label)}`, subtitle: v10("dialogs:expressionEditor.subtitle", "Expression Editor"), value: f11 };
    let M11;
    if (h11) {
      const e15 = [Twe.dvchartTemplateConstants(a10, v10, r10)];
      const t11 = Twe.textEncodings(a10, v10, (_a3 = l11.meta) == null ? void 0 : _a3.target);
      t11 && e15.push(t11), M11 = __spreadProps(__spreadValues({}, F11), { onSave: (e16) => (L10(l11, e16), true), treeNodes: e15, fnNodes: [], customCSS: Wxe });
    } else M11 = __spreadProps(__spreadValues({}, F11), { onSave: g11, treeNodes: w11, fnNodes: mwe(n10, v10, r10), validate: T11, treeAdapter: Jxe(n10), customCSS: $xe });
    const k11 = _A.of(e14).open("textEditor", M11);
    E10(k11);
  };
  const I10 = { instanceId: e14, units: t10, expressionSyntax: n10, validationContext: S10, dataSets: f10, dataSources: g10, dataScope: h10, semanticInfo: { semanticModel: l10, allowRebalancing: false, showAggregates: true, showCalculatedFields: true }, editExpression: H10 };
  const _10 = { expressionSyntax: n10, validationContext: C10, editExpression: H10 };
  const V10 = { setProperties: () => {
  }, setDataFieldProperty: (e15, t11, n11, r11, o11) => {
    const a11 = WN(e15, `Config.Rules.${c10}`);
    E10(a2(a11, t11, n11, r11, o11));
  } };
  const R10 = { theme: o10 };
  const A10 = $N("", "propertyDescriptors:labels.dvchartPlotRules.name", "dvchart_plot_rule_name", "Name");
  const O10 = $N("", "propertyDescriptors:labels.dvchartPlotRules.condition", "dvchart_plot_rule_condition", "Condition", void 0, { disableDataFields: true });
  const B10 = $N("", "propertyDescriptors:labels.dvchartPlotRules.ruleProperties", "dvchart_plot_rule_properties", "RuleProperties");
  const z10 = P10.filter((e15, t11) => t11 !== k10).map((e15) => e15.Name);
  const $10 = { dvchart_plot_rule_name: (e15, t11) => tp.createElement(jde, __spreadProps(__spreadValues({ key: t11 }, e15), { allowNonAlphaNumeric: true, occupiedNames: z10 })), dvchart_plot_rule_condition: QVe.dvchart_plot_rule_condition, dvchart_plot_rule_properties: QVe.dvchart_plot_rule_properties };
  const W10 = { descriptors: [A10, O10, B10], objectValue: __spreadValues({ name: "rule" }, N10), defaultValue: Rwe, propertyEditors: $10, setProperty: L10, t: v10, customCSS: Lz };
  return tp.createElement("div", { className: Dwe }, tp.createElement(bF, null, tp.createElement("div", { className: Lwe }, P10.length > 1 && tp.createElement("div", { className: Iwe }, P10.map((e15, t11) => {
    const n11 = { block: true, size: "small", accent: t11 === k10 ? "full" : "none", text: `${t11 + 1}`, textAlign: "center", onClick: D10(t11) };
    return tp.createElement(qm, __spreadValues({ key: `${T10}.${t11}` }, n11));
  })), tp.createElement("div", { className: _we }, tp.createElement(Iue.Provider, { value: V10 }, tp.createElement(Vue.Provider, { value: I10 }, tp.createElement(ATe.Provider, { value: _10 }, tp.createElement(Aue.Provider, { value: R10 }, tp.createElement(Rue.Provider, { value: x10 }, tp.createElement(wD, __spreadValues({}, W10)))))))))));
};
Awe.displayName = "PlotRulesPanel";
const [, , Owe] = Dp("wd-editor-chart-plot-rules");
const [Bwe, zwe] = Owe("item");
const $we = (e14) => {
  const { rdlx: { expressionSyntax: t10 } } = Uae();
  const { t: n10 } = vp("labels");
  const r10 = PA();
  const o10 = __spreadProps(__spreadValues({}, e14), { createEditor: (e15) => {
    const { Name: r11, Condition: o11 } = e15;
    const a10 = "" === o11;
    const i10 = a10 ? n10("dvchartPlotRuleNoCondition", "Empty Condition") : ((e16, t11) => "i11n" === e16 ? hu(t11) : t11)(t10, o11);
    const s10 = kp(Bwe, { [zwe("empty")]: a10 });
    return tp.createElement("div", { className: s10, title: i10 }, r11);
  }, onSelect: (t11) => {
    r10(Xz(Vwe, e14.descriptor.label, void 0, { ruleIndex: t11 }));
  }, onAdd: () => {
    r10($ye.addPlotRule(kG(TG("dvchartrule"), e14.value.map(({ Name: e15 }) => e15))));
  }, onDelete: (e15) => {
    r10($ye.deletePlotRule(e15));
  }, reordering: { type: "drag" } });
  return tp.createElement(WSe, __spreadValues({}, o10));
};
const Wwe = (e14, t10) => "" === e14 ? null : jme(e14) ? vme(e14) ? Sme(e14, t10) : null : e14;
const jwe = ({ children: e14 }) => tp.createElement("div", { style: { display: "flex" } }, tp.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 60 60", fill: "none" }, e14));
const Zwe = ({ axisColor: e14 }) => tp.createElement("path", { id: "defaultCoordsAxis", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M6 3C6.55228 3 7 3.44771 7 4V14C7.55228 14 8 14.4477 8 15C8 15.5523 7.55228 16 7 16V28C7.55228 28 8 28.4477 8 29C8 29.5523 7.55228 30 7 30V42C7.55228 42 8 42.4477 8 43C8 43.5523 7.55228 44 7 44V53H16C16 52.4477 16.4477 52 17 52C17.5523 52 18 52.4477 18 53H30C30 52.4477 30.4477 52 31 52C31.5523 52 32 52.4477 32 53H44C44 52.4477 44.4477 52 45 52C45.5523 52 46 52.4477 46 53H56C56.5523 53 57 53.4477 57 54C57 54.5523 56.5523 55 56 55H46C46 55.5523 45.5523 56 45 56C44.4477 56 44 55.5523 44 55H32C32 55.5523 31.5523 56 31 56C30.4477 56 30 55.5523 30 55H18C18 55.5523 17.5523 56 17 56C16.4477 56 16 55.5523 16 55H7V57C7 57.5523 6.55228 58 6 58C5.44772 58 5 57.5523 5 57V55H3.00001C2.44773 55 2.00002 54.5523 2.00002 54C2.00002 53.4477 2.44773 53 3.00002 53H5V44C4.44772 44 4 43.5523 4 43C4 42.4477 4.44772 42 5 42V30C4.44772 30 4 29.5523 4 29C4 28.4477 4.44772 28 5 28V16C4.44772 16 4 15.5523 4 15C4 14.4477 4.44772 14 5 14V4C5 3.44772 5.44772 3 6 3Z" });
const Gwe = ({ axisColor: e14 }) => tp.createElement("g", { id: "ellipseCoordsAxis" }, tp.createElement("path", { id: "Circle", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M30.0212 58.1442C45.4852 58.1442 58.0212 45.6082 58.0212 30.1442C58.0212 14.6802 45.4852 2.1442 30.0212 2.1442C14.5573 2.1442 2.02124 14.6802 2.02124 30.1442C2.02124 45.6082 14.5573 58.1442 30.0212 58.1442ZM30.0207 56.1579C44.3801 56.1579 56.0207 44.5143 56.0207 30.1511C56.0207 15.7879 44.3801 4.1442 30.0207 4.1442C15.6613 4.1442 4.02071 15.7879 4.02071 30.1511C4.02071 44.5143 15.6613 56.1579 30.0207 56.1579Z" }));
const Uwe = { default: ({ accentColor1: e14, accentColor2: t10, accentColor3: n10, accentColor4: r10, accentColor5: o10, accentColor6: a10, label: i10 }) => tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 103 50", fill: "none" }, tp.createElement("path", { id: "accentColor1", fill: e14, d: "M6 10C6 9.44772 6.44772 9 7 9H21.0833V25H7C6.44771 25 6 24.5523 6 24V10Z" }), tp.createElement("rect", { id: "accentColor2", fill: t10, x: "21.0833", y: "9", width: "15.0833", height: "16" }), tp.createElement("rect", { id: "accentColor3", fill: n10, x: "36.1667", y: "9", width: "15.0833", height: "16" }), tp.createElement("rect", { id: "accentColor4", fill: r10, x: "51.25", y: "9", width: "15.0833", height: "16" }), tp.createElement("rect", { id: "accentColor5", fill: o10, x: "66.3333", y: "9", width: "15.0833", height: "16" }), tp.createElement("path", { id: "accentColor6", fill: a10, d: "M81.4167 9H95.5C96.0523 9 96.5 9.44772 96.5 10V24C96.5 24.5523 96.0523 25 95.5 25H81.4167V9Z" }), tp.createElement("rect", { id: "palette-stroke", x: "5.5", y: "8.5", width: "91.5", height: "17", rx: "3", strokeWidth: "1" }), i10 && tp.createElement("text", { id: "palette-label", x: "51.5", y: "45" }, i10)), column: ({ accentColor1: e14, axisColor: t10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Rectangles", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M42 10C40.8954 10 40 10.8954 40 12V46C40 47.1046 40.8954 48 42 48H48C49.1046 48 50 47.1046 50 46V12C50 10.8954 49.1046 10 48 10H42ZM26 23C26 21.8954 26.8954 21 28 21H34C35.1046 21 36 21.8954 36 23V46C36 47.1046 35.1046 48 34 48H28C26.8954 48 26 47.1046 26 46V23ZM12 31C12 29.8954 12.8954 29 14 29H20C21.1046 29 22 29.8954 22 31V46C22 47.1046 21.1046 48 20 48H14C12.8954 48 12 47.1046 12 46V31Z" }), tp.createElement(Zwe, { axisColor: t10 })), columnStacked: ({ accentColor1: e14, accentColor2: t10, accentColor3: n10, axisColor: r10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Bottom", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M50 37H40V46C40 47.1046 40.8954 48 42 48H48C49.1046 48 50 47.1046 50 46V37ZM26 40H36V46C36 47.1046 35.1046 48 34 48H28C26.8954 48 26 47.1046 26 46V40ZM12 42H22V46C22 47.1046 21.1046 48 20 48H14C12.8954 48 12 47.1046 12 46V42Z" }), tp.createElement("path", { id: "Middle", fill: t10, fillRule: "evenodd", clipRule: "evenodd", d: "M50 21H40V37H50V21ZM26 29H36V40H26V29ZM12 35H22V42H12V35Z" }), tp.createElement("path", { id: "Top", fill: n10, fillRule: "evenodd", clipRule: "evenodd", d: "M42 10C40.8954 10 40 10.8954 40 12V21H50V12C50 10.8954 49.1046 10 48 10H42ZM26 23C26 21.8954 26.8954 21 28 21H34C35.1046 21 36 21.8954 36 23V29H26V23ZM12 31C12 29.8954 12.8954 29 14 29H20C21.1046 29 22 29.8954 22 31V35H12V31Z" }), tp.createElement(Zwe, { axisColor: r10 })), columnPercentStacked: ({ accentColor1: e14, accentColor2: t10, accentColor3: n10, axisColor: r10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Bottom", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M50 32H40V46C40 47.1046 40.8954 48 42 48H48C49.1046 48 50 47.1046 50 46V32ZM26 35H36V46C36 47.1046 35.1046 48 34 48H28C26.8954 48 26 47.1046 26 46V35ZM12 38H22V46C22 47.1046 21.1046 48 20 48H14C12.8954 48 12 47.1046 12 46V38Z" }), tp.createElement("path", { id: "Middle", fill: t10, fillRule: "evenodd", clipRule: "evenodd", d: "M12 20H22V38H12V20ZM26 23H36V35H26V23ZM50 26H40V32H50V26Z" }), tp.createElement("path", { id: "Top", fill: n10, fillRule: "evenodd", clipRule: "evenodd", d: "M12 12C12 10.8954 12.8954 10 14 10H20C21.1046 10 22 10.8954 22 12V20H12V12ZM26 12C26 10.8954 26.8954 10 28 10H34C35.1046 10 36 10.8954 36 12V23H26V12ZM42 10C40.8954 10 40 10.8954 40 12V26H50V12C50 10.8954 49.1046 10 48 10H42Z" }), tp.createElement(Zwe, { axisColor: r10 })), bar: ({ accentColor1: e14, axisColor: t10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Rectangles", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M50 18C50 19.1046 49.1046 20 48 20L14 20C12.8954 20 12 19.1046 12 18V12C12 10.8954 12.8954 10 14 10L48 10C49.1046 10 50 10.8954 50 12V18ZM37 34C38.1046 34 39 33.1046 39 32V26C39 24.8954 38.1046 24 37 24L14 24C12.8954 24 12 24.8954 12 26L12 32C12 33.1046 12.8954 34 14 34L37 34ZM29 48C30.1046 48 31 47.1046 31 46V40C31 38.8954 30.1046 38 29 38L14 38C12.8954 38 12 38.8954 12 40V46C12 47.1046 12.8954 48 14 48H29Z" }), tp.createElement(Zwe, { axisColor: t10 })), barStacked: ({ accentColor1: e14, accentColor2: t10, accentColor3: n10, axisColor: r10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Left", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M23 10L23 20H14C12.8954 20 12 19.1046 12 18L12 12C12 10.8954 12.8954 10 14 10H23ZM20 34V24H14C12.8954 24 12 24.8954 12 26V32C12 33.1046 12.8954 34 14 34H20ZM18 48V38H14C12.8954 38 12 38.8954 12 40L12 46C12 47.1046 12.8954 48 14 48H18Z" }), tp.createElement("path", { id: "Middle", fill: t10, fillRule: "evenodd", clipRule: "evenodd", d: "M39 10V20L23 20V10H39ZM31 34V24L20 24V34H31ZM25 48V38H18L18 48L25 48Z" }), tp.createElement("path", { id: "Right", fill: n10, fillRule: "evenodd", clipRule: "evenodd", d: "M50 18C50 19.1046 49.1046 20 48 20L39 20V10H48C49.1046 10 50 10.8954 50 12V18ZM37 34C38.1046 34 39 33.1046 39 32V26C39 24.8954 38.1046 24 37 24H31V34H37ZM29 48C30.1046 48 31 47.1046 31 46V40C31 38.8954 30.1046 38 29 38L25 38L25 48H29Z" }), tp.createElement(Zwe, { axisColor: r10 })), barPercentStacked: ({ accentColor1: e14, accentColor2: t10, accentColor3: n10, axisColor: r10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Left", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M28 10L28 20L14 20C12.8954 20 12 19.1046 12 18L12 12C12 10.8954 12.8954 10 14 10H28ZM25 34V24L14 24C12.8954 24 12 24.8954 12 26V32C12 33.1046 12.8954 34 14 34H25ZM22 48V38H14C12.8954 38 12 38.8954 12 40L12 46C12 47.1046 12.8954 48 14 48H22Z" }), tp.createElement("path", { id: "Middle", fill: t10, fillRule: "evenodd", clipRule: "evenodd", d: "M40 48V38H22L22 48H40ZM37 34L37 24L25 24L25 34H37ZM34 10V20L28 20V10H34Z" }), tp.createElement("path", { id: "Right", fill: n10, fillRule: "evenodd", clipRule: "evenodd", d: "M48 48C49.1046 48 50 47.1046 50 46V40C50 38.8954 49.1046 38 48 38H40V48H48ZM48 34C49.1046 34 50 33.1046 50 32L50 26C50 24.8954 49.1046 24 48 24L37 24V34H48ZM50 18C50 19.1046 49.1046 20 48 20L34 20V10H48C49.1046 10 50 10.8954 50 12V18Z" }), tp.createElement(Zwe, { axisColor: r10 })), line: ({ accentColor1: e14, axisColor: t10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Line", stroke: e14, strokeWidth: "4", strokeLinecap: "round", d: "M13.5 46.5L22.7886 24.8265C23.3585 23.4968 25.1081 23.1933 26.0925 24.2535L34.9833 33.8281C35.9478 34.8669 37.657 34.6003 38.2593 33.3171L48.5 11.5" }), tp.createElement(Zwe, { axisColor: t10 })), lineSmooth: ({ accentColor1: e14, axisColor: t10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Smooth", stroke: e14, strokeWidth: "4", strokeLinecap: "round", d: "M13.5 46.5L21.0908 28.788C22.4843 25.5367 26.7208 24.7208 29.2221 27.2221L32.7779 30.7779C35.2792 33.2792 39.5157 32.4633 40.9092 29.212L48.5 11.5" }), tp.createElement(Zwe, { axisColor: t10 })), area: ({ accentColor1: e14, axisColor: t10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Area", fill: e14, d: "M23.0876 23.9884L12.7956 35.1381C12.2841 35.6923 12 36.4188 12 37.173V46C12 47.1046 12.8954 48 14 48H48C49.1046 48 50 47.1046 50 46V12C50 10.8954 49.1046 10 48 10H47.8665C47.3136 10 46.7855 10.2288 46.4074 10.6321L32.9123 25.0269C32.3599 25.6161 31.5073 25.8152 30.751 25.5316L25.2595 23.4723C24.4979 23.1867 23.6393 23.3908 23.0876 23.9884Z" }), tp.createElement(Zwe, { axisColor: t10 })), areaStacked: ({ accentColor1: e14, accentColor2: t10, accentColor3: n10, axisColor: r10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Top", fill: n10, d: "M23.1751 25.7562L12.9728 35.1082C12.3529 35.6765 12 36.4788 12 37.3197V46C12 47.1046 12.8954 48 14 48H48C49.1046 48 50 47.1046 50 46V12C50 10.8954 49.1046 10 48 10H47.8641C47.3127 10 46.7857 10.2277 46.4077 10.6293L31.8347 26.1131C31.322 26.6578 30.5482 26.8709 29.8289 26.6654L25.076 25.3074C24.4074 25.1164 23.6876 25.2863 23.1751 25.7562Z" }), tp.createElement("path", { id: "Middle", fill: t10, d: "M23.6912 32.6692L12 39.0737V46C12 47.1046 12.8954 48 14 48H48C49.1046 48 50 47.1046 50 46V19L37.4402 30.1106C37.1528 30.3648 36.7984 30.531 36.4191 30.5894L24.348 32.4465C24.1178 32.4819 23.8955 32.5572 23.6912 32.6692Z" }), tp.createElement("path", { id: "Bottom", fill: e14, d: "M23.5139 38.162L12 42V46C12 47.1046 12.8954 48 14 48H48C49.1046 48 50 47.1046 50 46V33L35.577 39.7307C35.2016 39.9059 34.7811 39.9602 34.3735 39.8861L24.5041 38.0917C24.1734 38.0315 23.8328 38.0557 23.5139 38.162Z" }), tp.createElement(Zwe, { axisColor: r10 })), areaPercentStacked: ({ accentColor1: e14, accentColor2: t10, accentColor3: n10, axisColor: r10 }) => tp.createElement(jwe, null, tp.createElement("rect", { id: "Top", fill: n10, x: "12", y: "10", width: "38", height: "38", rx: "2" }), tp.createElement("path", { id: "Middle", fill: t10, d: "M23.379 22.523L12 32.1058V46C12 47.1046 12.8954 48 14 48H48C49.1046 48 50 47.1046 50 46V15L38.5694 22.6204C38.2003 22.8665 37.7599 22.9829 37.3175 22.9512L24.8098 22.0578C24.2905 22.0208 23.7772 22.1876 23.379 22.523Z" }), tp.createElement("path", { id: "Bottom", fill: e14, d: "M23.2973 31.4684L12 39V46C12 47.1046 12.8954 48 14 48H48C49.1046 48 50 47.1046 50 46V28L38.6275 33.6862C38.2213 33.8893 37.7581 33.9481 37.314 33.853L24.8258 31.1769C24.2978 31.0638 23.7466 31.1689 23.2973 31.4684Z" }), tp.createElement(Zwe, { axisColor: r10 })), pie: ({ accentColor1: e14, accentColor2: t10, accentColor3: n10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Top", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M4 30L29 30L41.7202 8.47346C37.9937 6.26668 33.6448 5 29 5C15.1929 5 4 16.1929 4 30Z" }), tp.createElement("path", { id: "Right", fill: t10, fillRule: "evenodd", clipRule: "evenodd", d: "M41.7202 51.5265C49.0711 47.1734 54 39.1623 54 30C54 20.8377 49.0711 12.8265 41.7202 8.47345L29 30L41.7202 51.5265Z" }), tp.createElement("path", { id: "Bottom", fill: n10, fillRule: "evenodd", d: "M41.7202 51.5265C37.9937 53.7333 33.6448 55 29 55C15.1929 55 4 43.8071 4 30H29L41.7202 51.5265Z" })), doughnut: ({ accentColor1: e14, accentColor2: t10, accentColor3: n10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Top", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M17.273 30L5 30C5 16.1929 16.1929 5 30 5C34.6448 5 38.9937 6.26668 42.7202 8.47345L35.9108 19.9972C34.0515 18.8618 31.8663 18.2076 29.5283 18.2076C22.913 18.2076 17.521 23.4453 17.273 30Z" }), tp.createElement("path", { id: "Bottom", fill: t10, fillRule: "evenodd", clipRule: "evenodd", d: "M55 30C55 39.1623 50.0711 47.1734 42.7202 51.5265L36.3157 40.6881C39.617 38.4904 41.7925 34.7351 41.7925 30.4718C41.7925 26.0364 39.438 22.151 35.9108 19.9972L42.7202 8.47345C50.0711 12.8265 55 20.8377 55 30Z" }), tp.createElement("path", { id: "Right", fill: n10, fillRule: "evenodd", clipRule: "evenodd", d: "M36.3157 40.6881C34.3721 41.9819 32.0382 42.7359 29.5283 42.7359C22.755 42.7359 17.2641 37.2451 17.2641 30.4717C17.2641 30.3138 17.2671 30.1565 17.273 30H5C5 43.8071 16.1929 55 30 55C34.6448 55 38.9937 53.7333 42.7202 51.5265L36.3157 40.6881Z" })), polarColumn: ({ accentColor1: e14, axisColor: t10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Ellipses", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M53 29.9999C53 42.029 43.7655 51.9012 31.999 52.9143C30.8985 53.009 30 52.1045 30 50.9999V48.9999C30 47.8954 30.8994 47.0123 31.9965 46.8839C40.4445 45.8956 47 38.7133 47 29.9999C47 20.6111 39.3888 12.9999 30 12.9999C21.2866 12.9999 14.1043 19.5554 13.116 28.0034C12.9877 29.1005 12.1046 29.9999 11 29.9999H9C7.89543 29.9999 6.99092 29.1014 7.08567 28.0009C8.0987 16.2344 17.9709 6.99994 30 6.99994C42.7025 6.99994 53 17.2974 53 29.9999ZM44.8685 28.0047C45.014 29.0997 44.1046 29.9999 43 29.9999H41C39.8954 29.9999 39.023 29.0932 38.7805 28.0155C37.8768 23.9997 34.2887 20.9999 30 20.9999C25.7113 20.9999 22.1232 23.9997 21.2195 28.0155C20.977 29.0932 20.1046 29.9999 19 29.9999H17C15.8954 29.9999 14.986 29.0997 15.1315 28.0047C16.1072 20.6637 22.3922 14.9999 30 14.9999C37.6078 14.9999 43.8928 20.6637 44.8685 28.0047ZM28 29.9999C29.1046 29.9999 30 29.1045 30 27.9999V24.9999C30 23.8954 29.0863 22.9711 28.0264 23.282C25.7473 23.9505 23.9505 25.7472 23.2821 28.0263C22.9712 29.0863 23.8954 29.9999 25 29.9999H28Z" }), tp.createElement(Gwe, { axisColor: t10 })), polarColumnStacked: ({ accentColor1: e14, accentColor2: t10, accentColor3: n10, axisColor: r10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Top", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M41.7026 10.1955C38.2742 8.16529 34.2732 6.99994 30 6.99994C17.9709 6.99994 8.09869 16.2344 7.08565 28.0009C6.99091 29.1014 7.89542 29.9999 8.99999 29.9999H11C12.1046 29.9999 12.9876 29.1005 13.116 28.0034C14.1043 19.5554 21.2866 12.9999 30 12.9999C33.1584 12.9999 36.1157 13.8613 38.6497 15.3619L41.7026 10.1955ZM28.1233 15.1162C21.3791 15.958 16.0257 21.277 15.1315 28.0047C14.986 29.0997 15.8954 29.9999 17 29.9999H19C20.1045 29.9999 20.977 29.0932 21.2195 28.0155C22.0533 24.31 25.1729 21.4695 29.0195 21.0527L28.1233 15.1162ZM23.282 28.0264C23.7524 26.4227 24.7814 25.0578 26.1441 24.1568L30 29.9999L29.9276 30.1484C29.6898 30.0513 29.4333 30 29.1715 30H25C23.8954 30 22.9712 29.0863 23.282 28.0264Z" }), tp.createElement("path", { id: "Right", fill: t10, fillRule: "evenodd", clipRule: "evenodd", d: "M41.7026 49.8044C48.4654 45.7995 53 38.4293 53 29.9999C53 21.5706 48.4654 14.2004 41.7026 10.1955L38.6497 15.3619C43.6483 18.322 47 23.7696 47 29.9999C47 36.2303 43.6483 41.6779 38.6497 44.638L41.7026 49.8044ZM44.1371 35.0263C44.6958 33.4549 45 31.7629 45 29.9999C45 21.7157 38.2842 14.9999 30 14.9999C29.3644 14.9999 28.738 15.0395 28.1233 15.1162L29.0195 21.0527C29.3415 21.0178 29.6687 20.9999 30 20.9999C34.9705 20.9999 39 25.0294 39 29.9999C39 31.0325 38.8261 32.0244 38.506 32.9481L44.1371 35.0263ZM30 23C33.6778 23 36.6932 25.8364 36.978 29.441L30 29.9999L26.1441 24.1568C27.2498 23.4257 28.5752 23 30 23Z" }), tp.createElement("path", { id: "Bottom", fill: n10, fillRule: "evenodd", clipRule: "evenodd", d: "M33.5355 33.5355C34.3166 34.3165 35.6151 34.3238 36.1452 33.3547C36.6902 32.3586 37 31.2155 37 30C37 29.8118 36.9925 29.6255 36.978 29.4411L30 30L29.9276 30.1484C30.1716 30.248 30.3958 30.3958 30.5858 30.5858L33.5355 33.5355ZM38.506 32.9481L44.1371 35.0263C42.2849 40.2355 37.635 44.1188 31.9952 44.8684C30.9003 45.0139 30 44.1045 30 42.9999V40.9999C30 39.8954 30.9067 39.0229 31.9844 38.7804C35.0333 38.0943 37.4966 35.8608 38.506 32.9481ZM41.7026 49.8043L38.6497 44.638C36.1157 46.1386 33.1584 46.9999 30 46.9999C26.0246 46.9999 22.3679 45.6354 19.4728 43.3491C18.6059 42.6646 17.346 42.6539 16.5649 43.4349L15.1507 44.8491C14.3697 45.6302 14.3645 46.9041 15.2101 47.6148C19.2086 50.9755 24.3679 52.9999 30 52.9999C34.2732 52.9999 38.2742 51.8346 41.7026 49.8043Z" }), tp.createElement(Gwe, { axisColor: r10 })), polarColumnPercentStacked: ({ accentColor1: e14, accentColor2: t10, accentColor3: n10, axisColor: r10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Top", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M41.7026 10.1956C38.2742 8.16535 34.2732 7 30 7C17.2975 7 7 17.2975 7 30H13C13 20.6112 20.6112 13 30 13C33.1585 13 36.1157 13.8613 38.6498 15.362L41.7026 10.1956ZM37.6321 17.0841C35.3962 15.76 32.7869 15 30 15C21.7157 15 15 21.7157 15 30H21C21 25.0294 25.0294 21 30 21C31.6721 21 33.2377 21.456 34.5793 22.2504L37.6321 17.0841ZM33.5617 23.9726C32.5182 23.3547 31.3005 23 30 23C26.134 23 23 26.134 23 30H30L33.5617 23.9726Z" }), tp.createElement("path", { id: "Right", fill: t10, fillRule: "evenodd", clipRule: "evenodd", d: "M41.7026 10.1956L38.6498 15.362C43.6484 18.3221 47 23.7696 47 30C47 36.2304 43.6484 41.678 38.6498 44.6381L41.7026 49.8044C48.4654 45.7996 53 38.4293 53 30C53 21.5707 48.4654 14.2004 41.7026 10.1956ZM37.6321 17.0841L34.5793 22.2505C37.2256 23.8176 39 26.7016 39 30C39 33.2984 37.2256 36.1824 34.5793 37.7496L37.6321 42.9159C42.0427 40.3041 45 35.4974 45 30C45 24.5026 42.0427 19.6959 37.6321 17.0841ZM33.5617 36.0274C35.6199 34.8086 37 32.5655 37 30C37 27.4346 35.6199 25.1914 33.5617 23.9726L30 30L33.5617 36.0274Z" }), tp.createElement("path", { id: "Bottom", fill: n10, fillRule: "evenodd", clipRule: "evenodd", d: "M41.7026 49.8044C38.2742 51.8347 34.2732 53 30 53C17.2975 53 7 42.7025 7 30H13C13 39.3888 20.6112 47 30 47C33.1585 47 36.1157 46.1387 38.6498 44.638L41.7026 49.8044ZM15 30C15 38.2843 21.7157 45 30 45C32.7869 45 35.3962 44.24 37.6321 42.9159L34.5793 37.7496C33.2377 38.544 31.6721 39 30 39C25.0294 39 21 34.9706 21 30H15ZM33.5617 36.0274L30 30H23C23 33.866 26.134 37 30 37C31.3005 37 32.5182 36.6453 33.5617 36.0274Z" }), tp.createElement(Gwe, { axisColor: r10 })), polarBar: ({ accentColor1: e14, accentColor2: t10, accentColor3: n10, axisColor: r10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Big", fill: n10, fillRule: "evenodd", clipRule: "evenodd", d: "M28.003 7.34753C29.1033 7.25254 30 8.15687 30 9.2612V22.7183L30 22.7218V30.2494L26.269 23.7201L26.2635 23.7106L24 19.7494L19.5818 12.0176C19.0338 11.0586 19.3639 9.82815 20.3672 9.36613C22.7986 8.2464 25.3852 7.57353 28.003 7.34753ZM39.8536 36.1737L39.8536 36.1738L29.9961 30.2508L37.5069 30.4154L37.5255 30.4157L50.9898 30.7107C52.094 30.7349 52.9786 31.6516 52.858 32.7495C52.5655 35.4103 51.8101 37.974 50.6555 40.3344C50.1702 41.3264 48.9333 41.6293 47.9866 41.0605L39.8536 36.1737ZM23.7302 40.6032L19.1097 48.216C18.5366 49.1602 17.3004 49.468 16.4099 48.8145C14.2518 47.2308 12.4093 45.2947 10.9425 43.1146C10.326 42.1984 10.6822 40.9757 11.6481 40.4403L19.9468 35.8403L19.9467 35.8402L30.0048 30.2649L26.1013 36.6965L26.0973 36.7031L23.7302 40.6032Z" }), tp.createElement("path", { id: "Middle", fill: t10, fillRule: "evenodd", clipRule: "evenodd", d: "M29.9993 30.249L29.9961 30.2508L47.9949 30.6451C48.0425 28.3777 47.6605 26.1242 46.8798 24.0086L46.5511 23.2574C46.1337 22.3034 45.1017 21.904 44.1807 22.3054L29.9996 30.2488L21.068 14.6184C19.0999 15.7455 17.365 17.2335 15.9537 18.9923L15.4791 19.6609C14.8763 20.51 15.0654 21.6004 15.8839 22.1831L29.9993 30.249ZM30.0048 30.265L20.664 45.6552C22.6038 46.8301 24.7464 47.626 26.9689 48.0078L27.7838 48.0987C28.8187 48.2142 29.6806 47.5202 29.7935 46.5219L30.0048 30.265Z" }), tp.createElement("path", { id: "Small", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M39.2046 19.7348L39.579 20.0677L39.5872 20.0666C40.6661 21.0372 41.5677 22.1532 42.2798 23.3661L29.9952 30.2473L35.8755 20.4608L36.3325 19.8424C36.9157 19.0531 37.9333 18.8697 38.734 19.3583C38.8941 19.4808 39.051 19.6064 39.2046 19.7348ZM34.2977 43.6247L34.0272 43.7085C32.6443 44.1216 31.2279 44.3103 29.8261 44.2884L30.0084 30.266L35.6368 40.4199L35.8954 41.0474C36.2684 41.9524 35.902 42.9155 35.0744 43.3498C34.817 43.4495 34.558 43.5411 34.2977 43.6247ZM16.3255 27.2412L16.2642 27.5347C16.2123 27.7986 16.1677 28.0651 16.1308 28.3341C16.1091 29.2687 16.7739 30.0563 17.7465 30.1688L18.4658 30.2521H29.9974L17.8434 23.3069C17.1505 24.5165 16.6329 25.8395 16.3254 27.241L16.3255 27.2412Z" }), tp.createElement(Gwe, { axisColor: r10 })), polarBarStacked: ({ accentColor1: e14, accentColor2: t10, accentColor3: n10, axisColor: r10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Big", fill: n10, fillRule: "evenodd", clipRule: "evenodd", d: "M28.0144 16.0872C29.1093 15.9431 30.0075 16.8528 30.0066 17.9571L30.0059 18.9673L29.9983 29.0212C29.9975 30.1258 29.1013 31.0205 27.9968 31.0197L17.9611 31.0121L16.924 31.0113C15.8192 31.0105 14.9108 30.1101 15.0574 29.0151C15.4808 25.8536 16.9072 22.8008 19.3368 20.3712C21.7751 17.9329 24.841 16.505 28.0144 16.0872ZM44.5713 39.7531C45.5175 40.3226 46.7567 40.021 47.2245 39.0207C49.0071 35.2096 49.5415 30.7848 48.4444 26.3843C47.3509 21.9986 44.8152 18.3524 41.4688 15.8252C40.5872 15.1594 39.3502 15.4728 38.7804 16.4194L37.8369 17.987L31.0423 29.2758C30.4726 30.2222 30.7781 31.4511 31.7244 32.0207L43.033 38.8272L44.5713 39.7531ZM11.6448 41.15C10.6785 41.6846 10.3214 42.907 10.9371 43.8237C13.8543 48.1667 18.2613 51.5432 23.684 53.0982C29.0891 54.648 34.5973 54.1284 39.3619 52.0087C40.3714 51.5596 40.7187 50.3337 40.1839 49.367L38.9076 47.0604L30.9817 32.7362C30.4469 31.7697 29.2299 31.4197 28.2634 31.9545L13.9148 39.8939L11.6448 41.15Z" }), tp.createElement("path", { id: "Middle", fill: t10, fillRule: "evenodd", clipRule: "evenodd", d: "M29.9975 29.2767C29.9971 29.829 29.5491 30.2764 28.9968 30.276L19.1228 30.2685C19.1317 27.4651 20.2056 24.6644 22.3445 22.5255C24.4625 20.4075 27.2293 19.3338 30.0051 19.3043L29.9975 29.2767ZM30.5266 29.388C30.2418 29.8612 30.3945 30.4757 30.8677 30.7605L41.1429 36.945C42.863 34.0906 43.4922 30.5791 42.6223 27.09C41.7553 23.6127 39.5632 20.8149 36.7185 19.1006L30.5266 29.388ZM16.0092 37.9905L29.1384 30.7259C29.6217 30.4585 30.2302 30.6335 30.4976 31.1167L37.7577 44.2377C36.5638 44.8974 35.2654 45.4141 33.8792 45.7597C26.6938 47.5513 19.4314 44.177 16.0092 37.9905Z" }), tp.createElement("path", { id: "Small", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M29.9975 29.2768C29.9971 29.829 29.5491 30.2764 28.9968 30.276L24.2926 30.2724C24.3254 28.7814 24.9107 27.3001 26.0485 26.1623C27.1463 25.0644 28.5637 24.481 30.0012 24.4119L29.9975 29.2768ZM30.5266 29.3881C30.2418 29.8613 30.3945 30.4757 30.8677 30.7605L34.968 33.2285C35.8292 31.8008 36.1445 30.044 35.7093 28.2983C35.3377 26.8081 34.4794 25.5675 33.3461 24.7036L30.5266 29.3881ZM23.0108 34.1164L29.1384 30.7259C29.6217 30.4585 30.2302 30.6335 30.4976 31.1167L33.8835 37.2361C33.2865 37.5661 32.6371 37.8245 31.9438 37.9974C28.3525 38.8928 24.7227 37.2073 23.0108 34.1164Z" }), tp.createElement(Gwe, { axisColor: r10 })), polarBarPercentStacked: ({ accentColor1: e14, accentColor2: t10, accentColor3: n10, axisColor: r10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Big", fill: n10, fillRule: "evenodd", clipRule: "evenodd", d: "M28.0211 7.34834C29.1214 7.25422 30.0174 8.15921 30.0165 9.26353L30.0146 11.8579L30.0022 28.2566C30.0013 29.3611 29.1052 30.2559 28.0007 30.255L11.6298 30.2427L8.99377 30.2407C7.88894 30.2398 6.9851 29.3416 7.08171 28.2411C7.5377 23.0462 9.75368 17.9767 13.7296 14.0007C17.7186 10.0117 22.8083 7.79426 28.0211 7.34834ZM47.9961 41.0831C48.9423 41.6525 50.1795 41.3506 50.6655 40.359C52.968 35.6612 53.6887 30.1564 52.3239 24.6827C50.9636 19.2268 47.7595 14.7164 43.5414 11.6499C42.6478 11.0003 41.4124 11.3124 40.8427 12.259L39.4833 14.5175L31.0411 28.5437C30.4715 29.49 30.7769 30.719 31.7232 31.2886L45.7733 39.7451L47.9961 41.0831ZM11.6434 40.4173C10.6772 40.9519 10.32 42.1743 10.9358 43.091C13.853 47.434 18.2599 50.8105 23.6827 52.3654C29.0877 53.9153 34.596 53.3957 39.3606 51.276C40.37 50.8269 40.7174 49.6009 40.1825 48.6342L38.9063 46.3277L30.9804 32.0034C30.4456 31.037 29.2286 30.687 28.2621 31.2218L13.9135 39.1612L11.6434 40.4173Z" }), tp.createElement("path", { id: "Middle", fill: t10, fillRule: "evenodd", clipRule: "evenodd", d: "M30.0014 29.2564C30.001 29.8087 29.553 30.2561 29.0007 30.2557L15.0355 30.2451C15.1391 24.0609 19.3635 18.472 25.6499 16.9046C27.1144 16.5394 28.5826 16.4195 30.0111 16.5189L30.0014 29.2564ZM30.5254 29.4004C30.2406 29.8736 30.3933 30.4881 30.8665 30.7729L44.5684 39.0199C46.8172 35.2875 47.6396 30.6962 46.5021 26.1341C45.3682 21.5863 42.501 17.9272 38.7803 15.6855L30.5254 29.4004ZM14.3377 38.9264L29.1371 30.7376C29.6203 30.4702 30.2288 30.6452 30.4962 31.1284L38.7302 46.0094C37.3892 46.7631 35.929 47.3508 34.3686 47.7398C26.3972 49.7273 18.3036 45.9109 14.3377 38.9264Z" }), tp.createElement("path", { id: "Small", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M30.0014 29.2565C30.001 29.8088 29.5529 30.2562 29.0007 30.2558L19.003 30.2482C19.1407 24.2928 24.0115 19.5074 30 19.5074L30.0088 19.5074L30.0014 29.2565ZM30.5254 29.4004C30.2406 29.8736 30.3933 30.4881 30.8665 30.7729L36.966 34.4441C37.6242 33.2818 38 31.9385 38 30.5074C38 27.5555 36.4012 24.977 34.0223 23.5906L30.5254 29.4004ZM17.5111 37.1705L29.1371 30.7376C29.6203 30.4702 30.2288 30.6452 30.4962 31.1285L37.3498 43.5147C36.2132 44.2024 34.9595 44.7321 33.6088 45.0689C27.0557 46.7028 20.3866 43.2543 17.5111 37.1705Z" }), tp.createElement(Gwe, { axisColor: r10 })), radarArea: ({ accentColor1: e14, accentColor2: t10, axisColor: n10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Hexagon-1", fill: e14, fillOpacity: "0.5", stroke: e14, strokeWidth: "3", d: "M11.3586 29.0696L21.9995 14.3759C22.2816 13.9863 22.7335 13.7557 23.2144 13.7557H37.481C38.0251 13.7557 38.5266 14.0504 38.7914 14.5257L46.9774 29.2206C47.2021 29.6241 47.2285 30.1086 47.0489 30.534L40.5872 45.8391C40.3526 46.3946 39.8083 46.7557 39.2053 46.7557L21.459 46.7557C20.9244 46.7557 20.4302 46.4711 20.1618 46.0087L11.2762 30.7025C10.9786 30.1898 11.0109 29.5498 11.3586 29.0696Z" }), tp.createElement("path", { id: "Hexagon-2", fill: t10, fillOpacity: "0.5", stroke: t10, strokeWidth: "3", d: "M23.1041 27.1616L25.4971 19.6434C25.6829 19.0596 26.2051 18.6475 26.8161 18.6024L37.0919 17.8447C37.4954 17.8149 37.8939 17.9495 38.1968 18.2178L50.4442 29.0663C51.0271 29.5826 51.118 30.4591 50.6534 31.084L40.592 44.6177C40.2054 45.1378 39.5286 45.3507 38.9139 45.1458L24.8753 40.4663C24.2999 40.2745 23.8966 39.7551 23.8534 39.1501L23.0372 27.7235C23.0237 27.5336 23.0464 27.343 23.1041 27.1616Z" }), tp.createElement("path", { id: "HexagonCoordAxis", stroke: n10, strokeWidth: "2", d: "M4.75377 29.2433L16.4929 9.24327C16.852 8.63147 17.5083 8.25568 18.2177 8.25568H41.7823C42.4917 8.25568 43.148 8.63147 43.5071 9.24327L55.2462 29.2433C55.6131 29.8683 55.6131 30.643 55.2462 31.2681L43.5071 51.2681C43.148 51.8799 42.4917 52.2557 41.7823 52.2557L18.2177 52.2557C17.5083 52.2557 16.852 51.8799 16.4929 51.2681L4.75377 31.2681C4.38688 30.643 4.38688 29.8683 4.75377 29.2433Z" })), radarBubble: ({ accentColor1: e14, accentColor2: t10, axisColor: n10 }) => tp.createElement(jwe, null, tp.createElement("circle", { id: "Medium under big", cx: "42", cy: "23", r: "6.5", fill: e14, fillOpacity: "0.5", stroke: e14, strokeWidth: "3" }), tp.createElement("circle", { id: "Big", cx: "37", cy: "34", r: "11.5", fill: t10, fillOpacity: "0.5", stroke: t10, strokeWidth: "3" }), tp.createElement("circle", { id: "Small in Big", fill: e14, fillOpacity: "0.5", stroke: e14, strokeWidth: "3", cx: "35", cy: "34", r: "3.5" }), tp.createElement("circle", { id: "Left", cx: "15.5", fill: e14, fillOpacity: "0.5", stroke: e14, strokeWidth: "3", cy: "29.5", r: "4" }), tp.createElement("circle", { id: "Top", fill: e14, fillOpacity: "0.5", stroke: e14, strokeWidth: "3", cx: "26", cy: "14", r: "3.5" }), tp.createElement("path", { id: "Pentagon", fill: n10, fillRule: "evenodd", clipRule: "evenodd", d: "M25.6198 7.02174L52.2974 16.4288C52.7182 16.5772 52.9972 16.9773 52.9844 17.414L52.1885 44.6058C52.176 45.0325 51.8877 45.3971 51.4726 45.5111L24.2399 52.9879C23.8249 53.1019 23.3763 52.9396 23.1262 52.5849L7.19069 29.9869C6.93474 29.6239 6.94616 29.1441 7.21882 28.8053L24.5053 7.32773C24.7679 7.00151 25.2146 6.87886 25.6198 7.02174ZM22.916 6.07205C23.7037 5.09339 25.0438 4.72544 26.2594 5.15409L52.937 14.5611C54.1994 15.0063 55.0364 16.2067 54.9981 17.5169L54.2022 44.7087C54.1647 45.9887 53.2996 47.0827 52.0545 47.4246L24.8218 54.9014C23.5766 55.2433 22.2308 54.7563 21.4806 53.6925L5.5451 31.0945C4.77723 30.0055 4.81149 28.5659 5.62947 27.5496L22.916 6.07205Z" })), radarScatter: ({ accentColor1: e14, accentColor2: t10, axisColor: n10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Pentagon", fill: n10, fillRule: "evenodd", clipRule: "evenodd", d: "M25.6198 7.02174L52.2974 16.4288C52.7182 16.5772 52.9972 16.9773 52.9844 17.414L52.1885 44.6058C52.176 45.0325 51.8877 45.3971 51.4726 45.5111L24.2399 52.9879C23.8249 53.1019 23.3763 52.9396 23.1262 52.5849L7.19069 29.9869C6.93474 29.6239 6.94616 29.1441 7.21882 28.8053L24.5053 7.32773C24.7679 7.00151 25.2146 6.87886 25.6198 7.02174ZM22.916 6.07205C23.7037 5.09339 25.0438 4.72544 26.2594 5.15409L52.937 14.5611C54.1994 15.0063 55.0364 16.2067 54.9981 17.5169L54.2022 44.7087C54.1647 45.9887 53.2996 47.0827 52.0545 47.4246L24.8218 54.9014C23.5766 55.2433 22.2308 54.7563 21.4806 53.6925L5.5451 31.0945C4.77723 30.0055 4.81149 28.5659 5.62947 27.5496L22.916 6.07205Z" }), tp.createElement("path", { id: "Rectangles", fill: t10, fillRule: "evenodd", clipRule: "evenodd", d: "M22 5C20.8954 5 20 5.89543 20 7V16C20 17.1046 20.8954 18 22 18H31C32.1046 18 33 17.1046 33 16V7C33 5.89543 32.1046 5 31 5H22ZM37 32C35.8954 32 35 32.8954 35 34V43C35 44.1046 35.8954 45 37 45H46C47.1046 45 48 44.1046 48 43V34C48 32.8954 47.1046 32 46 32H37Z" }), tp.createElement("path", { id: "Ellipses", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M49 21C49 24.3137 46.3137 27 43 27C39.6863 27 37 24.3137 37 21C37 17.6863 39.6863 15 43 15C46.3137 15 49 17.6863 49 21ZM17 30C17 33.3137 14.3137 36 11 36C7.68629 36 5 33.3137 5 30C5 26.6863 7.68629 24 11 24C14.3137 24 17 26.6863 17 30ZM35 41C38.3137 41 41 38.3137 41 35C41 31.6863 38.3137 29 35 29C31.6863 29 29 31.6863 29 35C29 38.3137 31.6863 41 35 41Z" })), radarLine: ({ accentColor1: e14, accentColor2: t10, axisColor: n10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Hexagon-1", stroke: e14, strokeWidth: "3", d: "M11.3586 29.0696L21.9995 14.3759C22.2816 13.9863 22.7335 13.7557 23.2144 13.7557H37.481C38.0251 13.7557 38.5266 14.0504 38.7914 14.5257L46.9774 29.2206C47.2021 29.6241 47.2285 30.1086 47.0489 30.534L40.5872 45.8391C40.3526 46.3946 39.8083 46.7557 39.2053 46.7557L21.459 46.7557C20.9244 46.7557 20.4302 46.4711 20.1618 46.0087L11.2762 30.7025C10.9786 30.1898 11.0109 29.5498 11.3586 29.0696Z" }), tp.createElement("path", { id: "Hexagon-2", stroke: t10, strokeWidth: "3", d: "M23.1041 27.1616L25.4971 19.6434C25.6829 19.0596 26.2051 18.6475 26.8161 18.6024L37.0919 17.8447C37.4954 17.8149 37.8939 17.9495 38.1968 18.2178L50.4442 29.0663C51.0271 29.5826 51.118 30.4591 50.6534 31.084L40.592 44.6177C40.2054 45.1378 39.5286 45.3507 38.9139 45.1458L24.8753 40.4663C24.2999 40.2745 23.8966 39.7551 23.8534 39.1501L23.0372 27.7235C23.0237 27.5336 23.0464 27.343 23.1041 27.1616Z" }), tp.createElement("path", { id: "HexagonCoordAxis", stroke: n10, strokeWidth: "2", d: "M4.75377 29.2433L16.4929 9.24327C16.852 8.63147 17.5083 8.25568 18.2177 8.25568H41.7823C42.4917 8.25568 43.148 8.63147 43.5071 9.24327L55.2462 29.2433C55.6131 29.8683 55.6131 30.643 55.2462 31.2681L43.5071 51.2681C43.148 51.8799 42.4917 52.2557 41.7823 52.2557L18.2177 52.2557C17.5083 52.2557 16.852 51.8799 16.4929 51.2681L4.75377 31.2681C4.38688 30.643 4.38688 29.8683 4.75377 29.2433Z" })), pyramid: ({ accentColor1: e14, accentColor2: t10, accentColor3: n10, axisColor: r10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Bottom", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M14.2361 48.7443H47.7639C49.2507 48.7443 50.2177 47.1797 49.5528 45.8499L47 40.7443H15L12.4472 45.8499C11.7823 47.1797 12.7493 48.7443 14.2361 48.7443Z" }), tp.createElement("path", { id: "Middle", fill: t10, fillRule: "evenodd", clipRule: "evenodd", d: "M15 40.7443L20.5 29.7443H41.5L47 40.7443H15Z" }), tp.createElement("path", { id: "Top", fill: n10, fillRule: "evenodd", clipRule: "evenodd", d: "M32.4472 11.6388C32.1731 11.0906 31.6129 10.7443 31 10.7443C30.3871 10.7443 29.8269 11.0906 29.5528 11.6387L20.5 29.7443H41.5L32.4472 11.6388Z" }), tp.createElement(Zwe, { axisColor: r10 })), funnel: ({ accentColor1: e14, accentColor2: t10, accentColor3: n10, axisColor: r10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Bottom", fill: n10, fillRule: "evenodd", clipRule: "evenodd", d: "M36.7494 46.8458C36.2972 47.9915 35.1906 48.7443 33.9589 48.7443H28.0411C26.8094 48.7443 25.7028 47.9915 25.2506 46.8458L18.5 29.7443H43.5L36.7494 46.8458Z" }), tp.createElement("path", { id: "Middle", fill: t10, fillRule: "evenodd", clipRule: "evenodd", d: "M18.5 29.7443H43.5L47.8421 18.7443H14.1579L18.5 29.7443Z" }), tp.createElement("path", { id: "Top", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M14.1579 18.7443H47.8421L49.9207 13.4787C49.9527 13.3975 49.9791 13.3159 50 13.2342V12.2512C49.7838 11.4102 49.026 10.7443 48.0603 10.7443H13.9397C12.974 10.7443 12.2162 11.4102 12 12.2512V13.2342C12.0209 13.3159 12.0473 13.3975 12.0793 13.4787L14.1579 18.7443Z" }), tp.createElement(Zwe, { axisColor: r10 })), bubble: ({ accentColor1: e14, axisColor: t10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Ellipses", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M30 10.7443C29.4477 10.7443 29 11.192 29 11.7443C29 22.79 37.9543 31.7443 49 31.7443C49.5523 31.7443 50 31.2966 50 30.7443V12.7443C50 11.6398 49.1046 10.7443 48 10.7443H30ZM16.5 21.7443C18.9853 21.7443 21 19.7296 21 17.2443C21 14.759 18.9853 12.7443 16.5 12.7443C14.0147 12.7443 12 14.759 12 17.2443C12 19.7296 14.0147 21.7443 16.5 21.7443ZM44 44.7443C46.2091 44.7443 48 42.9535 48 40.7443C48 38.5352 46.2091 36.7443 44 36.7443C41.7909 36.7443 40 38.5352 40 40.7443C40 42.9535 41.7909 44.7443 44 44.7443ZM29 40.2443C29 44.9387 25.1944 48.7443 20.5 48.7443C15.8056 48.7443 12 44.9387 12 40.2443C12 35.5499 15.8056 31.7443 20.5 31.7443C25.1944 31.7443 29 35.5499 29 40.2443Z" }), tp.createElement(Zwe, { axisColor: t10 })), scatter: ({ accentColor1: e14, axisColor: t10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Ellipses", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M31.7273 10.7443C31.3256 10.7443 31 11.0699 31 11.4716C31 15.4882 34.2561 18.7443 38.2727 18.7443H38.7273C42.7439 18.7443 46 15.4882 46 11.4716C46 11.0699 45.6744 10.7443 45.2727 10.7443H31.7273ZM17.5 27.7443C20.5376 27.7443 23 25.2819 23 22.2443C23 19.2068 20.5376 16.7443 17.5 16.7443C14.4624 16.7443 12 19.2068 12 22.2443C12 25.2819 14.4624 27.7443 17.5 27.7443ZM26 48.7443C28.7614 48.7443 31 46.5057 31 43.7443C31 40.9829 28.7614 38.7443 26 38.7443C23.2386 38.7443 21 40.9829 21 43.7443C21 46.5057 23.2386 48.7443 26 48.7443ZM50 34.7443C50 37.5057 47.7614 39.7443 45 39.7443C42.2386 39.7443 40 37.5057 40 34.7443C40 31.9829 42.2386 29.7443 45 29.7443C47.7614 29.7443 50 31.9829 50 34.7443Z" }), tp.createElement(Zwe, { axisColor: t10 })), gantt: ({ accentColor1: e14, axisColor: t10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Rectangles", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M31 10.7443C29.8954 10.7443 29 11.6398 29 12.7443V18.7443C29 19.8489 29.8954 20.7443 31 20.7443H43C44.1046 20.7443 45 19.8489 45 18.7443V12.7443C45 11.6398 44.1046 10.7443 43 10.7443H31ZM24 26.7443C24 25.6398 24.8954 24.7443 26 24.7443H48C49.1046 24.7443 50 25.6398 50 26.7443V32.7443C50 33.8489 49.1046 34.7443 48 34.7443H26C24.8954 34.7443 24 33.8489 24 32.7443V26.7443ZM12 40.7443C12 39.6398 12.8954 38.7443 14 38.7443H26C27.1046 38.7443 28 39.6398 28 40.7443V46.7443C28 47.8489 27.1046 48.7443 26 48.7443H14C12.8954 48.7443 12 47.8489 12 46.7443V40.7443Z" }), tp.createElement(Zwe, { axisColor: t10 })), candlestick: ({ accentColor1: e14, axisColor: t10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Rectangles", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M45 12.2443C45 11.4159 45.6716 10.7443 46.5 10.7443C47.3284 10.7443 48 11.4159 48 12.2443V14.7443C49.1046 14.7443 50 15.6398 50 16.7443V18.7443C50 19.8489 49.1046 20.7443 48 20.7443V27.2443C48 28.0728 47.3284 28.7443 46.5 28.7443C45.6716 28.7443 45 28.0728 45 27.2443V20.7443C43.8954 20.7443 43 19.8489 43 18.7443V16.7443C43 15.6398 43.8954 14.7443 45 14.7443V12.2443ZM36.5 16.7443C35.6716 16.7443 35 17.4159 35 18.2443V19.7443C33.8954 19.7443 33 20.6398 33 21.7443V35.7443C33 36.8489 33.8954 37.7443 35 37.7443V41.2443C35 42.0728 35.6716 42.7443 36.5 42.7443C37.3284 42.7443 38 42.0728 38 41.2443V37.7443C39.1046 37.7443 40 36.8489 40 35.7443V21.7443C40 20.6398 39.1046 19.7443 38 19.7443V18.2443C38 17.4159 37.3284 16.7443 36.5 16.7443ZM14 26.2443C14 25.4159 14.6716 24.7443 15.5 24.7443C16.3284 24.7443 17 25.4159 17 26.2443V29.7443C18.1046 29.7443 19 30.6398 19 31.7443V39.7443C19 40.8489 18.1046 41.7443 17 41.7443V47.2443C17 48.0728 16.3284 48.7443 15.5 48.7443C14.6716 48.7443 14 48.0728 14 47.2443L14 41.7443C12.8954 41.7443 12 40.8489 12 39.7443V31.7443C12 30.6398 12.8954 29.7443 14 29.7443V26.2443ZM24 29.2443C24 28.4159 24.6716 27.7443 25.5 27.7443C26.3284 27.7443 27 28.4159 27 29.2443V33.7443C28.1046 33.7443 29 34.6398 29 35.7443V39.7443C29 40.8489 28.1046 41.7443 27 41.7443V44.2443C27 45.0728 26.3284 45.7443 25.5 45.7443C24.6716 45.7443 24 45.0728 24 44.2443V41.7443C22.8954 41.7443 22 40.8489 22 39.7443V35.7443C22 34.6398 22.8954 33.7443 24 33.7443V29.2443Z" }), tp.createElement(Zwe, { axisColor: t10 })), highLowClose: ({ accentColor1: e14, axisColor: t10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Rectangles", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M44 12.2443C44 11.4159 44.6716 10.7443 45.5 10.7443C46.3284 10.7443 47 11.4159 47 12.2443V18.7443H48.5C49.3284 18.7443 50 19.4159 50 20.2443C50 21.0728 49.3284 21.7443 48.5 21.7443H47V27.2443C47 28.0728 46.3284 28.7443 45.5 28.7443C44.6716 28.7443 44 28.0728 44 27.2443V20.2443V12.2443ZM35.5 16.7443C34.6716 16.7443 34 17.4159 34 18.2443V41.2443C34 42.0728 34.6716 42.7443 35.5 42.7443C36.3284 42.7443 37 42.0728 37 41.2443V19.7443H38.5C39.3284 19.7443 40 19.0728 40 18.2443C40 17.4159 39.3284 16.7443 38.5 16.7443H35.5ZM23 24.2443C23 23.4159 23.6716 22.7443 24.5 22.7443C25.3284 22.7443 26 23.4159 26 24.2443V32.7443H27.5C28.3284 32.7443 29 33.4159 29 34.2443C29 35.0728 28.3284 35.7443 27.5 35.7443H26V38.2443C26 39.0728 25.3284 39.7443 24.5 39.7443C23.6716 39.7443 23 39.0728 23 38.2443V34.2443V24.2443ZM12 26.2443C12 25.4159 12.6716 24.7443 13.5 24.7443C14.3284 24.7443 15 25.4159 15 26.2443V38.7443H16.5C17.3284 38.7443 18 39.4159 18 40.2443C18 41.0728 17.3284 41.7443 16.5 41.7443H15V47.2443C15 48.0728 14.3284 48.7443 13.5 48.7443C12.6716 48.7443 12 48.0728 12 47.2443V40.2443V26.2443Z" }), tp.createElement(Zwe, { axisColor: t10 })), highLowOpenClose: ({ accentColor1: e14, axisColor: t10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Rectangles", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M46.5 10.7443C45.6716 10.7443 45 11.4159 45 12.2443V14.7443H44.5C43.6716 14.7443 43 15.4159 43 16.2443C43 17.0728 43.6716 17.7443 44.5 17.7443H45V21.2443V27.2443C45 28.0728 45.6716 28.7443 46.5 28.7443C47.3284 28.7443 48 28.0728 48 27.2443V22.7443H48.5C49.3284 22.7443 50 22.0728 50 21.2443C50 20.4159 49.3284 19.7443 48.5 19.7443H48V16.2443V12.2443C48 11.4159 47.3284 10.7443 46.5 10.7443ZM35 19.2443C35 18.4159 35.6716 17.7443 36.5 17.7443H38.5C39.3284 17.7443 40 18.4159 40 19.2443C40 20.0728 39.3284 20.7443 38.5 20.7443H38V35.2443V42.2443C38 43.0728 37.3284 43.7443 36.5 43.7443C35.6716 43.7443 35 43.0728 35 42.2443V36.7443H34.5C33.6716 36.7443 33 36.0728 33 35.2443C33 34.4159 33.6716 33.7443 34.5 33.7443H35V19.2443ZM15.5 24.7443C14.6716 24.7443 14 25.4159 14 26.2443V27.7443H13.5C12.6716 27.7443 12 28.4159 12 29.2443C12 30.0728 12.6716 30.7443 13.5 30.7443H14V41.2443V47.2443C14 48.0728 14.6716 48.7443 15.5 48.7443C16.3284 48.7443 17 48.0728 17 47.2443V42.7443H17.5C18.3284 42.7443 19 42.0728 19 41.2443C19 40.4159 18.3284 39.7443 17.5 39.7443H17V29.2443V26.2443C17 25.4159 16.3284 24.7443 15.5 24.7443ZM25.5 27.7443C24.6716 27.7443 24 28.4159 24 29.2443V33.7443H23.5C22.6716 33.7443 22 34.4159 22 35.2443C22 36.0728 22.6716 36.7443 23.5 36.7443H24V41.2443V43.2443C24 44.0728 24.6716 44.7443 25.5 44.7443C26.3284 44.7443 27 44.0728 27 43.2443V42.7443H27.5C28.3284 42.7443 29 42.0728 29 41.2443C29 40.4159 28.3284 39.7443 27.5 39.7443H27V35.2443V29.2443C27 28.4159 26.3284 27.7443 25.5 27.7443Z" }), tp.createElement(Zwe, { axisColor: t10 })), gauge: ({ accentColor1: e14, accentColor2: t10, accentColor3: n10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Left", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M20.2699 43.707C20.8751 42.923 20.8149 41.7892 20.2239 40.9606C18.8237 38.9975 18 36.595 18 34C18 30.6799 19.3483 27.6748 21.5272 25.5022L12.3279 16.3168C7.80051 20.8413 5 27.0936 5 34C5 40.1843 7.24556 45.8442 10.9658 50.2087C11.6401 50.9998 12.8074 51.0421 13.5936 50.3934L20.2699 43.707Z" }), tp.createElement("path", { id: "Top", fill: t10, fillRule: "evenodd", clipRule: "evenodd", d: "M21.5147 25.5147C23.6863 23.3431 26.6863 22 30 22C30.341 22 30.6787 22.0142 31.0126 22.0421C31.8316 22.1105 32.6531 21.7778 33.0979 21.0867L35.6822 17.0713C36.2816 16.1399 37.4768 15.7945 38.4806 16.2626C39.4844 16.7307 39.9881 17.8683 39.66 18.9261L38.1994 23.6343C38.0024 24.2692 38.1436 24.944 38.5118 25.4882L47.6777 16.3223C43.1536 11.7982 36.9036 9 30 9C23.0964 9 16.8464 11.7982 12.3223 16.3223L21.5147 25.5147Z" }), tp.createElement("path", { id: "Right", fill: n10, fillRule: "evenodd", clipRule: "evenodd", d: "M39.7302 43.7071L46.4063 50.3933C47.1924 51.0421 48.3599 50.9999 49.0342 50.2087C52.75 45.8494 54.9947 40.1978 55 34.0221V33.9779C54.994 27.0803 52.1947 20.8365 47.6721 16.3168L38.4728 25.5022C40.6517 27.6748 42 30.6799 42 34C42 36.595 41.1763 38.9975 39.7761 40.9606C39.1851 41.7892 39.1249 42.9231 39.7302 43.7071Z" }), tp.createElement("path", { id: "GaugeIndicator", fill: "var(--cui-text)", d: "M27.8236 32.9773C26.9648 34.3117 27.4807 36.0972 28.9189 36.7678C30.3571 37.4385 32.0565 36.686 32.5267 35.1704L37.7498 18.3336C37.7816 18.231 37.7328 18.1206 37.6354 18.0752C37.5381 18.0298 37.4221 18.0633 37.364 18.1537L27.8236 32.9773Z" })), rangeArea: ({ accentColor1: e14, axisColor: t10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Area", fill: e14, d: "M33.0179 15.25L12.1972 41.7491C12.0694 41.9116 12 42.1124 12 42.3191C12 43.0472 12.8038 43.4885 13.4181 43.0976L33.3338 30.4239C33.7619 30.1515 34.2774 30.052 34.7761 30.1455L48.8157 32.7779C49.4311 32.8933 50 32.4212 50 31.7951V22.7713C50 21.9955 49.5513 21.2897 48.8489 20.9604L35.4394 14.6747C34.5967 14.2797 33.5929 14.5182 33.0179 15.25Z" }), tp.createElement(Zwe, { axisColor: t10 })), rangeBar: ({ accentColor1: e14, axisColor: t10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Bar", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M19 10C17.8954 10 17 10.8954 17 12V18C17 19.1046 17.8954 20 19 20H36C37.1046 20 38 19.1046 38 18V12C38 10.8954 37.1046 10 36 10H19ZM29 26C29 24.8954 29.8954 24 31 24H48C49.1046 24 50 24.8954 50 26V32C50 33.1046 49.1046 34 48 34H31C29.8954 34 29 33.1046 29 32V26ZM12 40C12 38.8954 12.8954 38 14 38H31C32.1046 38 33 38.8954 33 40V46C33 47.1046 32.1046 48 31 48H14C12.8954 48 12 47.1046 12 46V40Z" }), tp.createElement(Zwe, { axisColor: t10 })), rangeColumn: ({ accentColor1: e14, axisColor: t10 }) => tp.createElement(jwe, null, tp.createElement("path", { id: "Column", fill: e14, fillRule: "evenodd", clipRule: "evenodd", d: "M42 39C40.8954 39 40 38.1046 40 37L40 23C40 21.8954 40.8954 21 42 21H48C49.1046 21 50 21.8954 50 23L50 37C50 38.1046 49.1046 39 48 39H42ZM26 31C26 32.1046 26.8954 33 28 33H34C35.1046 33 36 32.1046 36 31L36 12C36 10.8954 35.1046 10 34 10L28 10C26.8954 10 26 10.8954 26 12L26 31ZM12 46C12 47.1046 12.8954 48 14 48H20C21.1046 48 22 47.1046 22 46L22 31C22 29.8954 21.1046 29 20 29H14C12.8954 29 12 29.8954 12 31V46Z" }), tp.createElement(Zwe, { axisColor: t10 })) };
const qwe = ["#5b9bd5", "#ed7d31", "#a5a5a5", "#ffc000", "#4472c4", "#70ad47"];
const Ywe = (e14, t10, n10) => {
  let r10 = qwe;
  t10.length && (r10 = t10);
  const [o10, a10, i10, s10, l10, c10] = r10;
  const u10 = { accentColor1: o10, accentColor2: a10, accentColor3: i10, accentColor4: s10, accentColor5: l10, accentColor6: c10, axisColor: "var(--cui-text-semi-40)", label: n10 };
  const d10 = Uwe[e14];
  return d10 ? tp.createElement(d10, __spreadValues({}, u10)) : null;
};
const [Kwe] = Dp("wd-chart-editor");
const [Xwe, , Jwe] = Dp("wd-chart-editor-group");
const [Qwe] = Jwe("heading");
const [eTe] = Jwe("content");
const [tTe, nTe, rTe] = Dp("wd-chart-editor-tile");
const [oTe] = rTe("label");
const aTe = ({ templateName: e14, palette: t10, groupLabel: n10, label: r10 }) => {
  const o10 = ep.useRef(null);
  const a10 = ep.useRef();
  let l10 = null;
  let c10;
  switch (n10) {
    case "Theme Palettes":
    case "Standard Palettes":
      c10 = "default";
      break;
    default:
      c10 = e14;
  }
  if ("string" == typeof t10) {
    const e15 = i.getPaletteColors(t10);
    e15.length, 0, l10 = Ywe(c10, e15, r10);
  }
  return Array.isArray(t10) && (l10 = Ywe(c10, t10, r10)), ep.useLayoutEffect(() => {
    null !== o10 && null !== o10.current && (a10.current = new s(o10.current));
  }, []), l10 != null ? l10 : tp.createElement("div", { ref: o10 });
};
const iTe = ({ groupLabel: e14, chart: { key: t10, label: n10, model: r10, selected: o10 }, showLabel: a10, onPick: i10 }) => {
  const s10 = ep.useCallback(() => i10 == null ? void 0 : i10(t10), [t10, i10]);
  const l10 = a10 && !e14;
  const c10 = kp(tTe, { [nTe("selected")]: o10, [nTe("wizard")]: l10 });
  return tp.createElement("li", { className: c10, title: a10 ? void 0 : n10, onClick: s10 }, tp.createElement(aTe, { templateName: t10, palette: r10.config.palette, groupLabel: e14, label: n10 }), l10 && tp.createElement("span", { className: oTe }, n10));
};
iTe.displayName = "ChartDropdownTile";
const sTe = ({ groupLabel: e14, group: { label: t10, charts: n10 }, showLabel: r10, onPick: o10 }) => {
  const a10 = { text: t10, size: "small", uppercase: false, customCSS: Qwe };
  return tp.createElement("div", { className: Xwe }, tp.createElement(LE, __spreadValues({}, a10)), tp.createElement("div", { className: eTe }, n10.map((t11) => tp.createElement(iTe, { key: t11.key, groupLabel: e14, chart: t11, showLabel: r10, onPick: o10 }))));
};
sTe.displayName = "ChartDropdownGroup";
const lTe = ({ chartGroups: e14, showItemLabels: t10, customStyle: n10, customCSS: r10, onItemPick: o10 }) => {
  const a10 = kp(Kwe, r10);
  return tp.createElement("div", { className: a10, style: n10 }, e14.map((e15) => tp.createElement(sTe, { key: e15.label, groupLabel: e15.groupType || e15.label, group: e15, showLabel: t10, onPick: o10 })));
};
lTe.displayName = "ChartDropdown";
var cTe = [{ name: "column", content: { plots: [{ type: "Bar", name: "p1", encodings: { values: [{ field: "Value" }], category: { field: "Category" } } }], config: { plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], title: "", type: "X", majorGrid: false, majorTicks: "Cross", labels: false }, { plots: ["p1"], title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false }] }] }, data: { values: [{ Category: "Category1", Value: 10 }, { Category: "Category2", Value: 20 }, { Category: "Category3", Value: 30 }] } } }, { name: "columnStacked", content: { plots: [{ type: "Bar", name: "p1", encodings: { values: [{ field: "Value" }], details: { field: "CategoryGroup", group: "Stack" }, category: { field: "Category" } } }], config: { plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], title: "", type: "X", majorGrid: false, majorTicks: "Cross", labels: false }, { plots: ["p1"], title: "", type: "Y", max: 50, majorGrid: false, majorTicks: "Cross", labels: false }] }] }, data: { values: [{ Category: "Category1", CategoryGroup: "CategoryGroup1", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup1", Value: 20 }, { Category: "Category3", CategoryGroup: "CategoryGroup1", Value: 30 }, { Category: "Category1", CategoryGroup: "CategoryGroup2", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup2", Value: 10 }, { Category: "Category3", CategoryGroup: "CategoryGroup2", Value: 10 }, { Category: "Category1", CategoryGroup: "CategoryGroup3", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup3", Value: 10 }, { Category: "Category3", CategoryGroup: "CategoryGroup3", Value: 10 }] } } }, { name: "columnPercentStacked", content: { plots: [{ type: "Bar", name: "p1", encodings: { values: [{ field: "Value" }], details: { field: "CategoryGroup", group: "Stack" }, category: { field: "Category" } } }], config: { plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], title: "", type: "X", majorGrid: false, majorTicks: "Cross", labels: false }, { plots: ["p1"], title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false, scale: { type: "Percentage" } }] }] }, data: { values: [{ Category: "Category1", CategoryGroup: "CategoryGroup1", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup1", Value: 20 }, { Category: "Category3", CategoryGroup: "CategoryGroup1", Value: 30 }, { Category: "Category1", CategoryGroup: "CategoryGroup2", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup2", Value: 10 }, { Category: "Category3", CategoryGroup: "CategoryGroup2", Value: 10 }, { Category: "Category1", CategoryGroup: "CategoryGroup3", Value: 5 }, { Category: "Category2", CategoryGroup: "CategoryGroup3", Value: 10 }, { Category: "Category3", CategoryGroup: "CategoryGroup3", Value: 15 }] } } }, { name: "bar", content: { plots: [{ type: "Bar", name: "p1", encodings: { values: [{ field: "Value" }], category: { field: "Category" } }, config: { swapAxes: true } }], config: { plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], title: "", type: "X", majorGrid: false, majorTicks: "Cross", labels: false }, { plots: ["p1"], title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false }] }] }, data: { values: [{ Category: "Category1", Value: 10 }, { Category: "Category2", Value: 20 }, { Category: "Category3", Value: 30 }] } } }, { name: "barStacked", content: { plots: [{ type: "Bar", name: "p1", encodings: { values: [{ field: "Value" }], details: { field: "CategoryGroup", group: "Stack" }, category: { field: "Category" } }, config: { swapAxes: true } }], config: { plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], title: "", type: "X", majorGrid: false, majorTicks: "Cross", labels: false }, { plots: ["p1"], title: "", type: "Y", max: 50, majorGrid: false, majorTicks: "Cross", labels: false }] }] }, data: { values: [{ Category: "Category1", CategoryGroup: "CategoryGroup1", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup1", Value: 20 }, { Category: "Category3", CategoryGroup: "CategoryGroup1", Value: 30 }, { Category: "Category1", CategoryGroup: "CategoryGroup2", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup2", Value: 10 }, { Category: "Category3", CategoryGroup: "CategoryGroup2", Value: 10 }, { Category: "Category1", CategoryGroup: "CategoryGroup3", Value: 15 }, { Category: "Category2", CategoryGroup: "CategoryGroup3", Value: 15 }, { Category: "Category3", CategoryGroup: "CategoryGroup3", Value: 15 }] } } }, { name: "barPercentStacked", content: { plots: [{ type: "Bar", name: "p1", encodings: { values: [{ field: "Value" }], details: { field: "CategoryGroup", group: "Stack" }, category: { field: "Category" } }, config: { swapAxes: true } }], config: { plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], title: "", type: "X", majorGrid: false, majorTicks: "Cross", labels: false, scale: { type: "Percentage" } }, { plots: ["p1"], title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false, scale: { type: "Percentage" } }] }] }, data: { values: [{ Category: "Category1", CategoryGroup: "CategoryGroup1", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup1", Value: 20 }, { Category: "Category3", CategoryGroup: "CategoryGroup1", Value: 30 }, { Category: "Category1", CategoryGroup: "CategoryGroup2", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup2", Value: 10 }, { Category: "Category3", CategoryGroup: "CategoryGroup2", Value: 10 }, { Category: "Category1", CategoryGroup: "CategoryGroup3", Value: 5 }, { Category: "Category2", CategoryGroup: "CategoryGroup3", Value: 10 }, { Category: "Category3", CategoryGroup: "CategoryGroup3", Value: 15 }] } } }, { name: "area", content: { plots: [{ type: "Area", name: "p1", encodings: { values: [{ field: "Value" }], category: { field: "Category" } } }], config: { plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], title: "", type: "X", majorGrid: false, majorTicks: "Cross", labels: false }, { plots: ["p1"], title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false }] }] }, data: { values: [{ Category: "Category1", Value: 10 }, { Category: "Category2", Value: 30 }, { Category: "Category3", Value: 20 }, { Category: "Category4", Value: 40 }] } } }, { name: "areaStacked", content: { plots: [{ type: "Area", name: "p1", encodings: { values: [{ field: "Value" }], details: { field: "CategoryGroup", group: "Stack" }, category: { field: "Category" } } }], config: { plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], title: "", type: "X", majorGrid: false, majorTicks: "Cross", labels: false }, { plots: ["p1"], title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false }] }] }, data: { values: [{ Category: "Category1", CategoryGroup: "CategoryGroup1", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup1", Value: 30 }, { Category: "Category3", CategoryGroup: "CategoryGroup1", Value: 20 }, { Category: "Category4", CategoryGroup: "CategoryGroup1", Value: 40 }, { Category: "Category1", CategoryGroup: "CategoryGroup2", Value: 5 }, { Category: "Category2", CategoryGroup: "CategoryGroup2", Value: 10 }, { Category: "Category3", CategoryGroup: "CategoryGroup2", Value: 15 }, { Category: "Category4", CategoryGroup: "CategoryGroup2", Value: 20 }, { Category: "Category1", CategoryGroup: "CategoryGroup3", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup3", Value: 10 }, { Category: "Category3", CategoryGroup: "CategoryGroup3", Value: 10 }, { Category: "Category4", CategoryGroup: "CategoryGroup3", Value: 10 }] } } }, { name: "areaPercentStacked", content: { plots: [{ type: "Area", name: "p1", encodings: { values: [{ field: "Value" }], details: { field: "CategoryGroup", group: "Stack" }, category: { field: "Category" } } }], config: { plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], title: "", type: "X", majorGrid: false, majorTicks: "Cross", labels: false }, { plots: ["p1"], title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false, scale: { type: "Percentage" } }] }] }, data: { values: [{ Category: "Category1", CategoryGroup: "CategoryGroup1", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup1", Value: 30 }, { Category: "Category3", CategoryGroup: "CategoryGroup1", Value: 20 }, { Category: "Category4", CategoryGroup: "CategoryGroup1", Value: 40 }, { Category: "Category1", CategoryGroup: "CategoryGroup2", Value: 5 }, { Category: "Category2", CategoryGroup: "CategoryGroup2", Value: 10 }, { Category: "Category3", CategoryGroup: "CategoryGroup2", Value: 15 }, { Category: "Category4", CategoryGroup: "CategoryGroup2", Value: 20 }, { Category: "Category1", CategoryGroup: "CategoryGroup3", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup3", Value: 10 }, { Category: "Category3", CategoryGroup: "CategoryGroup3", Value: 10 }, { Category: "Category4", CategoryGroup: "CategoryGroup3", Value: 10 }] } } }, { name: "line", content: { plots: [{ type: "Line", name: "p1", encodings: { values: [{ field: "Value" }], category: { field: "Category" } }, config: { style: { strokeDashArray: "Solid", strokeWidth: 2 } } }], config: { plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], title: "", type: "X", majorGrid: false, majorTicks: "Cross", labels: false }, { plots: ["p1"], title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false }] }] }, data: { values: [{ Category: "Category1", Value: 10 }, { Category: "Category2", Value: 30 }, { Category: "Category3", Value: 20 }, { Category: "Category4", Value: 40 }] } } }, { name: "lineSmooth", content: { plots: [{ type: "Line", name: "p1", encodings: { values: [{ field: "Value" }], category: { field: "Category" } }, config: { lineAspect: "Spline", style: { strokeDashArray: "Solid", strokeWidth: 2 } } }], config: { plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], title: "", type: "X", majorGrid: false, majorTicks: "Cross", labels: false }, { plots: ["p1"], title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false }] }] }, data: { values: [{ Category: "Category1", Value: 10 }, { Category: "Category2", Value: 30 }, { Category: "Category3", Value: 20 }, { Category: "Category4", Value: 40 }] } } }, { name: "scatter", content: { plots: [{ type: "Scatter", name: "p1", encodings: { values: [{ field: "Category,Value" }] }, config: { style: { symbolShape: "Dot" } } }], config: { plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], type: "X", majorGrid: false, majorTicks: "Cross", labels: false, title: "", min: 8, max: 32 }, { plots: ["p1"], title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false, min: 8, max: 32 }] }] }, data: { values: [{ Category: 17, Value: 35 }, { Category: 15, Value: 25 }, { Category: 28, Value: 20 }, { Category: 25, Value: 30 }, { Category: 20, Value: 15 }] } } }, { name: "bubble", content: { plots: [{ type: "Scatter", name: "p1", encodings: { values: [{ field: "Category,Value" }], size: { field: "Size" } } }], config: { legend: { position: "None" }, plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], type: "X", majorGrid: false, majorTicks: "Cross", labels: false, title: "", min: 8, max: 32 }, { plots: ["p1"], title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false, min: 8, max: 32 }] }] }, data: { values: [{ Size: 10, Category: 30, Value: 15 }, { Size: 15, Category: 15, Value: 30 }, { Size: 20, Category: 17, Value: 17 }, { Size: 40, Category: 30, Value: 30 }] } } }, { name: "pie", content: { plots: [{ type: "Bar", name: "p1", encodings: { values: [{ field: "Value" }], details: { field: "Category", group: "Stack" } }, config: { style: { strokeWidth: 1 }, axisMode: "Radial", startAngle: -90 } }], config: { bar: { width: 1 }, plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], type: "X", scale: { type: "Percentage" } }, { plots: ["p1"], type: "Y", scale: { type: "Percentage" }, position: "None" }] }] }, data: { values: [{ Category: "Category1", Value: 10 }, { Category: "Category2", Value: 10 }, { Category: "Category3", Value: 10 }] } } }, { name: "doughnut", content: { plots: [{ type: "Bar", name: "p1", encodings: { values: [{ field: "Value" }], details: { field: "Category", group: "Stack" } }, config: { innerRadius: 0.5, style: { strokeWidth: 1 }, axisMode: "Radial", startAngle: -90 } }], config: { bar: { width: 1 }, plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], type: "X", scale: { type: "Percentage" } }, { plots: ["p1"], type: "Y", scale: { type: "Percentage" }, position: "None" }] }] }, data: { values: [{ Category: "Category1", Value: 10 }, { Category: "Category2", Value: 10 }, { Category: "Category3", Value: 10 }] } } }, { name: "gantt", content: { plots: [{ type: "Bar", name: "p1", encodings: { values: [{ field: { lower: "Value1", upper: "Value2" } }], category: { field: "Category" } }, config: { swapAxes: true } }], config: { plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], type: "X", majorGrid: false, majorTicks: "Cross", labels: false, title: "" }, { plots: ["p1"], title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false, min: 0, max: 25 }] }] }, data: { values: [{ Category: "Category1", Value1: 2, Value2: 10 }, { Category: "Category2", Value1: 5, Value2: 20 }, { Category: "Category3", Value1: 8, Value2: 15 }] } } }, { name: "candlestick", content: { plots: [{ type: "Candlestick", name: "p1", encodings: { values: [{ field: { high: "high", low: "low", open: "open", close: "close" } }], category: { field: "date" } }, config: { style: { strokeDashArray: "Solid", strokeWidth: 1 } } }], config: { plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], type: "X", majorGrid: false, majorTicks: "Cross", labels: false, title: "" }, { plots: ["p1"], min: 75, max: 80, title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false }] }] }, data: { values: [{ date: "1/1/1", open: 77.98, high: 79.25, low: 76.86, close: 77.19 }, { date: "2/1/1", open: 77.23, high: 77.59, low: 75.36, close: 76.15 }, { date: "3/1/1", open: 76.76, high: 77.36, low: 75.82, close: 76.15 }, { date: "4/1/1", open: 76.74, high: 78.23, low: 76.08, close: 78.18 }, { date: "5/1/1", open: 78.2, high: 78.62, low: 77.2, close: 77.74 }, { date: "6/1/1", open: 77.9, high: 79, low: 77.4, close: 78.5 }] } } }, { name: "highLowOpenClose", content: { plots: [{ type: "HighLowOpenClose", name: "p1", encodings: { values: [{ field: { high: "high", low: "low", open: "open", close: "close" } }], category: { field: "date" } }, config: { style: { strokeDashArray: "Solid", strokeWidth: 1 } } }], config: { plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], type: "X", majorGrid: false, majorTicks: "Cross", labels: false, title: "" }, { plots: ["p1"], min: 75, max: 80, title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false }] }] }, data: { values: [{ date: "1/1/1", open: 77.98, high: 79.25, low: 76.86, close: 77.19 }, { date: "2/1/1", open: 77.23, high: 77.59, low: 75.36, close: 76.15 }, { date: "3/1/1", open: 76.76, high: 77.36, low: 75.82, close: 76.15 }, { date: "4/1/1", open: 76.74, high: 78.23, low: 76.08, close: 78.18 }, { date: "5/1/1", open: 78.2, high: 78.62, low: 77.2, close: 77.74 }, { date: "6/1/1", open: 77.9, high: 79, low: 77.4, close: 78.5 }] } } }, { name: "highLowClose", content: { plots: [{ type: "HighLowOpenClose", name: "p1", encodings: { values: [{ field: { high: "high", low: "low", close: "close" } }], category: { field: "date" } }, config: { style: { strokeDashArray: "Solid", strokeWidth: 1 } } }], config: { plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], type: "X", majorGrid: false, majorTicks: "Cross", labels: false, title: "" }, { plots: ["p1"], min: 75, max: 80, title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false }] }] }, data: { values: [{ date: "1/1/1", open: 77.98, high: 79.25, low: 76.86, close: 77.19 }, { date: "2/1/1", open: 77.23, high: 77.59, low: 75.36, close: 76.15 }, { date: "3/1/1", open: 76.76, high: 77.36, low: 75.82, close: 76.15 }, { date: "4/1/1", open: 76.74, high: 78.23, low: 76.08, close: 78.18 }, { date: "5/1/1", open: 78.2, high: 78.62, low: 77.2, close: 77.74 }, { date: "6/1/1", open: 77.9, high: 79, low: 77.4, close: 78.5 }] } } }, { name: "pyramid", content: { plots: [{ type: "Bar", name: "p1", encodings: { values: [{ field: "Value" }], details: { field: "CategoryGroup", group: "Stack", sort: { field: "CategoryGroup", order: 0 } } } }], config: { bar: { neckHeight: 0, bottomWidth: 0.9, width: 0.9, topWidth: 0, overlap: 0 }, plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], title: "", type: "X", majorGrid: false, majorTicks: "None", labels: false }, { plots: ["p1"], title: "", type: "Y", max: 60, majorUnit: 20, majorGrid: false, majorTicks: "Cross", labels: false }] }] }, data: { values: [{ CategoryGroup: "CategoryGroup1", Value: 10 }, { CategoryGroup: "CategoryGroup2", Value: 20 }, { CategoryGroup: "CategoryGroup3", Value: 30 }] } } }, { name: "funnel", content: { plots: [{ type: "Bar", name: "p1", encodings: { values: [{ field: "Value" }], details: { field: "CategoryGroup", group: "Stack", sort: { field: "CategoryGroup", order: 1 } } } }], config: { bar: { neckHeight: 0, bottomWidth: 0.3, width: 0.9 }, plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], title: "", type: "X", majorGrid: false, majorTicks: "None", labels: false }, { plots: ["p1"], title: "", type: "Y", max: 60, majorUnit: 20, majorGrid: false, majorTicks: "Cross", labels: false }] }] }, data: { values: [{ CategoryGroup: "CategoryGroup1", Value: 10 }, { CategoryGroup: "CategoryGroup2", Value: 20 }, { CategoryGroup: "CategoryGroup3", Value: 30 }] } } }, { name: "polarColumn", content: { plots: [{ type: "Bar", name: "p1", encodings: { values: [{ field: "Value" }], category: { field: "Category" } }, config: { axisMode: "Radial", startAngle: -90 } }], config: { plotAreas: [{ axes: [{ plots: ["p1"], title: "", type: "X", majorGrid: false, majorTicks: "Cross", labels: false }, { plots: ["p1"], title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false }] }] }, data: { values: [{ Category: "Category1", Value: 10 }, { Category: "Category2", Value: 20 }, { Category: "Category3", Value: 30 }] } } }, { name: "polarColumnStacked", content: { plots: [{ type: "Bar", name: "p1", encodings: { values: [{ field: "Value" }], details: { field: "CategoryGroup", group: "Stack" }, category: { field: "Category" } }, config: { axisMode: "Radial", startAngle: -90 } }], config: { plotAreas: [{ axes: [{ plots: ["p1"], title: "", type: "X", majorGrid: false, majorTicks: "Cross", labels: false }, { plots: ["p1"], title: "", type: "Y", max: 50, majorGrid: false, majorTicks: "Cross", labels: false }] }] }, data: { values: [{ Category: "Category1", CategoryGroup: "CategoryGroup1", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup1", Value: 12 }, { Category: "Category3", CategoryGroup: "CategoryGroup1", Value: 15 }, { Category: "Category1", CategoryGroup: "CategoryGroup2", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup2", Value: 12 }, { Category: "Category3", CategoryGroup: "CategoryGroup2", Value: 15 }, { Category: "Category1", CategoryGroup: "CategoryGroup3", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup3", Value: 14 }, { Category: "Category3", CategoryGroup: "CategoryGroup3", Value: 15 }] } } }, { name: "polarColumnPercentStacked", content: { plots: [{ type: "Bar", name: "p1", encodings: { values: [{ field: "Value" }], details: { field: "CategoryGroup", group: "Stack" }, category: { field: "Category" } }, config: { axisMode: "Radial", startAngle: -90 } }], config: { plotAreas: [{ axes: [{ plots: ["p1"], title: "", type: "X", majorGrid: false, majorTicks: "Cross", labels: false }, { plots: ["p1"], title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false, scale: { type: "Percentage" } }] }] }, data: { values: [{ Category: "Category1", CategoryGroup: "CategoryGroup1", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup1", Value: 12 }, { Category: "Category3", CategoryGroup: "CategoryGroup1", Value: 15 }, { Category: "Category1", CategoryGroup: "CategoryGroup2", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup2", Value: 12 }, { Category: "Category3", CategoryGroup: "CategoryGroup2", Value: 15 }, { Category: "Category1", CategoryGroup: "CategoryGroup3", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup3", Value: 12 }, { Category: "Category3", CategoryGroup: "CategoryGroup3", Value: 15 }] } } }, { name: "polarBar", content: { plots: [{ type: "Bar", name: "p1", encodings: { values: [{ field: "Value" }], details: { field: "CategoryGroup", group: "Cluster" }, category: { field: "Category" } }, config: { swapAxes: true, axisMode: "Radial", startAngle: -90 } }], config: { bar: { bottomWidth: 0.9 }, plotAreas: [{ axes: [{ plots: ["p1"], title: "", type: "X", majorGrid: false, majorTicks: "Cross", labels: false }, { plots: ["p1"], title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false }] }] }, data: { values: [{ Category: "Category1", CategoryGroup: "CategoryGroup1", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup1", Value: 10 }, { Category: "Category3", CategoryGroup: "CategoryGroup1", Value: 10 }, { Category: "Category1", CategoryGroup: "CategoryGroup2", Value: 15 }, { Category: "Category2", CategoryGroup: "CategoryGroup2", Value: 15 }, { Category: "Category3", CategoryGroup: "CategoryGroup2", Value: 15 }, { Category: "Category1", CategoryGroup: "CategoryGroup3", Value: 20 }, { Category: "Category2", CategoryGroup: "CategoryGroup3", Value: 20 }, { Category: "Category3", CategoryGroup: "CategoryGroup3", Value: 20 }] } } }, { name: "polarBarStacked", content: { plots: [{ type: "Bar", name: "p1", encodings: { values: [{ field: "Value" }], details: { field: "CategoryGroup", group: "Stack" }, category: { field: "Category" } }, config: { swapAxes: true, axisMode: "Radial", startAngle: -90 } }], config: { plotAreas: [{ axes: [{ plots: ["p1"], title: "", type: "X", majorGrid: false, majorTicks: "Cross", labels: false }, { plots: ["p1"], title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false }] }] }, data: { values: [{ Category: "Category1", CategoryGroup: "CategoryGroup1", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup1", Value: 12 }, { Category: "Category3", CategoryGroup: "CategoryGroup1", Value: 15 }, { Category: "Category1", CategoryGroup: "CategoryGroup2", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup2", Value: 12 }, { Category: "Category3", CategoryGroup: "CategoryGroup2", Value: 16 }, { Category: "Category1", CategoryGroup: "CategoryGroup3", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup3", Value: 12 }, { Category: "Category3", CategoryGroup: "CategoryGroup3", Value: 17 }] } } }, { name: "polarBarPercentStacked", content: { plots: [{ type: "Bar", name: "p1", encodings: { values: [{ field: "Value" }], details: { field: "CategoryGroup", group: "Stack" }, category: { field: "Category" } }, config: { swapAxes: true, axisMode: "Radial", startAngle: -90 } }], config: { plotAreas: [{ axes: [{ plots: ["p1"], title: "", type: "X", majorGrid: false, majorTicks: "Cross", labels: false, scale: { type: "Percentage" } }, { plots: ["p1"], title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false, scale: { type: "Percentage" } }] }] }, data: { values: [{ Category: "Category1", CategoryGroup: "CategoryGroup1", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup1", Value: 20 }, { Category: "Category3", CategoryGroup: "CategoryGroup1", Value: 30 }, { Category: "Category1", CategoryGroup: "CategoryGroup2", Value: 10 }, { Category: "Category2", CategoryGroup: "CategoryGroup2", Value: 10 }, { Category: "Category3", CategoryGroup: "CategoryGroup2", Value: 10 }, { Category: "Category1", CategoryGroup: "CategoryGroup3", Value: 5 }, { Category: "Category2", CategoryGroup: "CategoryGroup3", Value: 10 }, { Category: "Category3", CategoryGroup: "CategoryGroup3", Value: 15 }] } } }, { name: "radarArea", content: { plots: [{ type: "Area", name: "p1", encodings: { values: [{ field: "Value" }], category: { field: "Category" }, details: [{ field: "CategoryGroup", group: "Cluster" }] }, config: { swapAxes: true, axisMode: "Polygonal", startAngle: -90, style: { opacity: 0.6 } } }], config: { bar: { bottomWidth: 0.9 }, plotAreas: [{ axes: [{ plots: ["p1"], title: "", type: "X", majorGrid: false, majorTicks: "Cross", labels: false }, { plots: ["p1"], title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false }] }] }, data: { name: "sample", values: [{ CategoryGroup: "CategoryGroup1", Value: 44, Category: "Category1" }, { CategoryGroup: "CategoryGroup1", Value: 37, Category: "Category2" }, { CategoryGroup: "CategoryGroup1", Value: 36, Category: "Category3" }, { CategoryGroup: "CategoryGroup1", Value: 36, Category: "Category4" }, { CategoryGroup: "CategoryGroup1", Value: 46, Category: "Category5" }, { CategoryGroup: "CategoryGroup1", Value: 46, Category: "Category6" }, { CategoryGroup: "CategoryGroup2", Value: 16, Category: "Category1" }, { CategoryGroup: "CategoryGroup2", Value: 28, Category: "Category2" }, { CategoryGroup: "CategoryGroup2", Value: 32, Category: "Category3" }, { CategoryGroup: "CategoryGroup2", Value: 48, Category: "Category4" }, { CategoryGroup: "CategoryGroup2", Value: 38, Category: "Category5" }, { CategoryGroup: "CategoryGroup2", Value: 26, Category: "Category6" }] } } }, { name: "radarBubble", content: { plots: [{ type: "Scatter", name: "p1", encodings: { values: [{ field: "Category,Value" }], size: { field: "Size" }, color: { field: "Size" } }, config: { clippingMode: "Clip", swapAxes: true, axisMode: "Polygonal", startAngle: -90, style: { symbolOpacity: 0.7 } } }], config: { legend: { position: "None" }, plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], type: "X", majorGrid: false, majorTicks: "Cross", labels: false, title: "" }, { plots: ["p1"], title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false }] }] }, data: { values: [{ Size: 10, Category: "Category1", Value: 45 }, { Size: 15, Category: "Category2", Value: 35 }, { Size: 20, Category: "Category3", Value: 25 }, { Size: 40, Category: "Category4", Value: 15 }, { Size: 15, Category: "Category5", Value: 5 }] } } }, { name: "radarScatter", content: { plots: [{ type: "Scatter", name: "p1", encodings: { values: [{ field: "Category,Value" }], shape: { field: "Shape" }, color: { field: "Shape" } }, config: { swapAxes: true, axisMode: "Polygonal", startAngle: -90 } }], config: { legend: { position: "None" }, plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], type: "X", majorGrid: false, majorTicks: "Cross", labels: false, title: "" }, { plots: ["p1"], title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false }] }] }, data: { values: [{ Shape: "Shape1", Category: "Category1", Value: 45 }, { Shape: "Shape2", Category: "Category2", Value: 35 }, { Shape: "Shape1", Category: "Category3", Value: 25 }, { Shape: "Shape2", Category: "Category4", Value: 15 }, { Shape: "Shape1", Category: "Category5", Value: 5 }] } } }, { name: "radarLine", content: { plots: [{ type: "Line", name: "p1", encodings: { values: [{ field: "Value" }], category: { field: "Category" }, details: [{ field: "CategoryGroup", group: "Cluster" }] }, config: { swapAxes: true, axisMode: "Polygonal", startAngle: -90 } }], config: { bar: { bottomWidth: 0.9 }, plotAreas: [{ axes: [{ plots: ["p1"], title: "", type: "X", majorGrid: false, majorTicks: "Cross", labels: false }, { plots: ["p1"], title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false }] }] }, data: { name: "sample", values: [{ CategoryGroup: "CategoryGroup1", Value: 44, Category: "Category1" }, { CategoryGroup: "CategoryGroup1", Value: 37, Category: "Category2" }, { CategoryGroup: "CategoryGroup1", Value: 36, Category: "Category3" }, { CategoryGroup: "CategoryGroup1", Value: 36, Category: "Category4" }, { CategoryGroup: "CategoryGroup1", Value: 46, Category: "Category5" }, { CategoryGroup: "CategoryGroup1", Value: 46, Category: "Category6" }, { CategoryGroup: "CategoryGroup2", Value: 16, Category: "Category1" }, { CategoryGroup: "CategoryGroup2", Value: 28, Category: "Category2" }, { CategoryGroup: "CategoryGroup2", Value: 32, Category: "Category3" }, { CategoryGroup: "CategoryGroup2", Value: 48, Category: "Category4" }, { CategoryGroup: "CategoryGroup2", Value: 38, Category: "Category5" }, { CategoryGroup: "CategoryGroup2", Value: 26, Category: "Category6" }] } } }, { name: "gauge", content: { plots: [{ name: "p1", type: "Bar", encodings: { values: [{ field: "HighRange" }, { field: "MidRange" }, { field: "LowRange" }] }, config: { axisMode: 1, symbols: false, startAngle: -135, sweep: 270, innerRadius: 0.6, overlays: [{ type: "Needle", display: "Front", start: "center", end: "1,9", width: 2, style: { stroke: "none", fill: "#595959" } }, { type: "Ellipse", display: "Front", start: "center", width: 8, height: 8, style: { stroke: "none", fill: "#595959" } }] } }], config: { palette: [], bar: { width: 0.6, overlap: 1 }, plotAreas: [{ axes: [{ plots: ["p1", "p2"], type: "X", lineStyle: { strokeWidth: 0 } }, { plots: ["p1", "p2"], type: "Y", min: 0, max: 15, position: 0 }], row: 0, column: 0 }] }, data: { name: "sample", values: [{ LowRange: 5, MidRange: 10, HighRange: 15, Value: 9 }] } } }, { name: "rangeArea", content: { plots: [{ type: "Area", name: "p1", encodings: { values: [{ field: { lower: "Value1", upper: "Value2" } }], category: { field: "Category" } } }], config: { plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], type: "X", majorGrid: false, majorTicks: "Cross", labels: false, title: "" }, { plots: ["p1"], title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false, min: 0, max: 25 }] }] }, data: { values: [{ Category: "Category1", Value1: 2, Value2: 5 }, { Category: "Category2", Value1: 10, Value2: 20 }, { Category: "Category3", Value1: 8, Value2: 15 }] } } }, { name: "rangeColumn", content: { plots: [{ type: "Bar", name: "p1", encodings: { values: [{ field: { lower: "Value1", upper: "Value2" } }], category: { field: "Category" } } }], config: { plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], title: "", type: "X", majorGrid: false, majorTicks: "Cross", labels: false }, { plots: ["p1"], title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false }] }] }, data: { values: [{ Category: "Category1", Value1: 2, Value2: 15 }, { Category: "Category2", Value1: 22, Value2: 33 }, { Category: "Category3", Value1: 8, Value2: 22 }] } } }, { name: "rangeBar", content: { plots: [{ type: "Bar", name: "p1", encodings: { values: [{ field: { lower: "Value1", upper: "Value2" } }], category: { field: "Category" } }, config: { swapAxes: true } }], config: { plotAreas: [{ padding: { top: 3, left: 3, right: 3, bottom: 3 }, axes: [{ plots: ["p1"], title: "", type: "X", majorGrid: false, majorTicks: "Cross", labels: false }, { plots: ["p1"], title: "", type: "Y", majorGrid: false, majorTicks: "Cross", labels: false }] }] }, data: { values: [{ Category: "Category1", Value1: 2, Value2: 5 }, { Category: "Category2", Value1: 10, Value2: 20 }, { Category: "Category3", Value1: 8, Value2: 15 }] } } }];
const uTe = (e14, t10) => ({ label: e14, templateTypes: t10 });
const dTe = [uTe("column", ["column", "columnStacked", "columnPercentStacked"]), uTe("bar", ["bar", "barStacked", "barPercentStacked"]), uTe("line", ["line", "lineSmooth"]), uTe("area", ["area", "areaStacked", "areaPercentStacked"]), uTe("pie", ["pie", "doughnut"]), uTe("polarColumn", ["polarColumn", "polarColumnStacked", "polarColumnPercentStacked"]), uTe("polarBar", ["polarBar", "polarBarStacked", "polarBarPercentStacked"]), uTe("radar", ["radarArea", "radarBubble", "radarScatter", "radarLine"]), uTe("misc", ["pyramid", "funnel", "bubble", "scatter", "gantt", "candlestick", "highLowClose", "highLowOpenClose", "gauge"]), uTe("range", ["rangeArea", "rangeBar", "rangeColumn"])];
const [pTe] = Dp("wd-chart-plot-template-editor");
const mTe = ({ theme: e14, paletteInfo: t10, onPick: n10 }) => {
  const { t: r10 } = vp("contextActions");
  const { rdlx: { reportItemsFeatures: { chart: { plotChartTypes: o10 } } } } = Uae();
  const a10 = ((e15, t11) => e15 && e15.colors ? e15.colors.split("|").map((e16) => Wwe(e16, t11)).filter((e16) => null !== e16) : e15 && e15.name && "Custom" !== e15.name ? e15.name : null)(t10, e14);
  const i10 = ((e15) => {
    if (!e15) return dTe;
    const t11 = ibe(e15);
    return 0 === t11.length ? dTe : dTe.reduce((e16, n11) => {
      const r11 = n11.templateTypes.filter((e17) => t11.includes(e17));
      return r11.length > 0 && e16.push(uTe(n11.label, r11)), e16;
    }, []);
  })(o10);
  const s10 = i10.map((e15) => ({ label: r10(`dvchart.presetGroups.${e15.label}`), charts: e15.templateTypes.map((e16) => {
    const t11 = cTe.find((t12) => t12.name === e16);
    if (!t11) return null;
    let n11 = t11.content;
    return null !== a10 && "Custom" !== a10 && (n11 = AV(t11.content, { config: { palette: { $set: a10 } } })), { key: e16, label: r10(`dvchart.presets.${e16}`), model: n11 };
  }).filter((e16) => null !== e16) })).filter((e15) => e15.charts.length);
  return tp.createElement(lTe, { chartGroups: s10, onItemPick: n10, customCSS: pTe });
};
mTe.displayName = "ChartPlotTemplateDropdown";
const [hTe] = Dp("wd-editor-chart-plot-template");
const fTe = (e14) => (e14.CustomPalette || []).join("|");
const gTe = (e14) => e14.length && e14[0] ? { name: e14[0].Palette, colors: fTe(e14[0]) } : null;
const yTe = (e14) => ("dvchart" === e14.Type || "fixedpagedvchart" === e14.Type) && ij(e14);
const vTe = ({ value: e14 }) => {
  const { t: t10 } = vp("propertyEditors");
  const n10 = h9();
  const { theme: r10 } = ep.useContext(Aue);
  const { API: o10 } = ep.useContext(Sm);
  const a10 = PA();
  const i10 = gTe([gj(n10, yTe)]);
  const s10 = { block: true, size: "small", width: "100%", text: t10("dvchartPlotTemplate.textSelect", "Select..."), content: tp.createElement(mTe, { paletteInfo: i10, theme: r10, onPick: (e15) => {
    a10($ye.setPlotTemplate(e15)), o10.dropdowns.open(null);
  } }), menuWidth: "100%", menuAlign: "left", menuMaxHeight: 300, customCSS: hTe, dataAid: "property-grid-plot-template-dropdown" };
  return tp.createElement(UF, __spreadValues({}, s10));
};
vTe.displayName = "DVChartPlotTemplateEditorImpl";
const bTe = _D(vTe);
const [STe] = Dp("wd-editor-chart-template");
function CTe(e14, t10) {
  if (sK(e14)) return Iie(t10);
  if (!e14) return t10("propertyEditors:common.textNone");
  const n10 = /^\{([^\{\}]+)\}$/g;
  const r10 = [];
  let o10;
  do {
    o10 = n10.exec(e14);
    const t11 = o10 && o10[1] || null;
    t11 && r10.push(t11);
  } while (o10 && r10.length <= 1);
  const a10 = 1 === r10.length ? r10[0] : e14;
  return VO("dvchart_template").includes(a10) ? RO("dvchart_template", a10, t10) : t10("propertyEditors:dvchartTemplate.custom");
}
const xTe = (e14, t10) => ({ type: "button", text: e14 || t10, value: t10 });
const wTe = (e14) => "dvchartplot" === e14.type;
const TTe = ({ descriptor: e14, value: t10, defaultValue: n10, setProperty: r10 }) => {
  var _a2, _b2;
  const { t: o10 } = vp("propertyEditors");
  const a10 = ((e15, t11 = "Label") => {
    const { namedItems: n11, selectedItemsInfo: r11 } = ep.useContext(Rue);
    const o11 = ep.useMemo(() => {
      const o12 = r11.map((e16) => e16.path);
      const a11 = n11.filter(wTe).filter((e16) => wTe(e16) && o12.includes(e16.$path));
      const i11 = obe(a11.map((e16) => e16.$options.plotChartType)).map((t12) => xTe(CTe(t12, e15), t12));
      return 1 === a11.length && i11.unshift(...a11[0].$options.textEncodingTemplateKeys.filter((e16) => e16.target === t11).map((e16) => xTe(e16.templateKey, `{${e16.templateKey}}`))), i11;
    }, [n11, r11]);
    return o11;
  })(o10, (_a2 = e14.meta) == null ? void 0 : _a2.target);
  const i10 = (e15) => e15.value === t10;
  const s10 = [xTe(o10("common.textNone"), ""), ...a10].map((e15) => __spreadProps(__spreadValues({}, e15), { selected: i10(e15) }));
  const l10 = (_b2 = s10.find((e15) => e15.value === t10)) == null ? void 0 : _b2.text;
  const c10 = { block: true, size: "small", menuWidth: "100%", menuMaxHeight: "default", items: s10, scrollToSelection: true, text: l10 || CTe(t10, o10), placeholderText: !t10, onSelect: (t11) => {
    r10(e14, "" === t11 ? n10 : t11);
  }, customCSS: STe };
  return tp.createElement(UF, __spreadValues({}, c10));
};
TTe.displayName = "DVChartTemplateEditor";
const ETe = (FTe = TTe, (e14) => {
  const _a2 = e14, { menuId: t10 } = _a2, n10 = __objRest(_a2, ["menuId"]);
  const r10 = que(e14);
  const o10 = { descriptor: n10.descriptor, status: r10, menuId: t10, defaultValue: n10.defaultValue, setProperty: n10.setProperty };
  return tp.createElement(Mde, __spreadValues({}, o10), tp.createElement(FTe, __spreadValues({}, n10)));
});
var FTe;
const MTe = _D(ETe);
const [kTe] = Dp("wd-editor-rule-property");
const PTe = (e14) => {
  switch (e14) {
    case "BackgroundColor":
    case "LineColor":
    case "SymbolBackgroundColor":
    case "SymbolLineColor":
      return "Black";
    case "LineStyle":
    case "SymbolLineStyle":
      return "Solid";
    case "LineWidth":
    case "SymbolLineWidth":
      return "1pt";
  }
  return "";
};
const NTe = $N("", "", "dvchart_plot_rule_properties", "");
const DTe = Rve();
const LTe = ({ descriptor: e14, value: { TargetProperty: t10, Value: n10 }, setProperty: r10 }) => {
  const o10 = ep.useCallback((t11, n11) => {
    r10(e14, Rve({ TargetProperty: n11, Value: PTe(n11) }));
  }, [e14, r10]);
  const a10 = { descriptor: NTe, value: t10, defaultValue: DTe.TargetProperty, setProperty: o10 };
  const i10 = ((e15) => {
    switch (e15) {
      case "BackgroundColor":
      case "LineColor":
      case "SymbolBackgroundColor":
      case "SymbolLineColor":
        return "color_expr";
      case "LineStyle":
      case "SymbolLineStyle":
        return "border_style";
      case "LineWidth":
      case "SymbolLineWidth":
        return "length_expr";
      case "LabelTemplate":
      case "TooltipTemplate":
        return "dvchart_template";
    }
    return "length_expr";
  })(t10);
  const s10 = { descriptor: $N(e14.label, "", i10, `${e14.valuePath}.Value`, void 0, __spreadProps(__spreadValues({ disableDataFields: "dvchart_template" === i10 }, "border_style" === i10 && { enumKey: "border_style" }), { target: "dvchart_template" === i10 && ("TooltipTemplate" === t10 ? "ToolTip" : "Label") })), value: n10, setProperty: r10, defaultValue: PTe(t10) };
  return tp.createElement("div", { className: kTe }, tp.createElement(tse, __spreadValues({}, a10)), "color_expr" === i10 && tp.createElement(rhe, __spreadValues({}, s10)), "length_expr" === i10 && tp.createElement(ghe, __spreadValues({}, s10)), "border_style" === i10 && tp.createElement(whe, __spreadValues({}, s10)), "dvchart_template" === i10 && tp.createElement(ETe, __spreadValues({}, s10)));
};
LTe.displayName = "DVChartRulePropertyEditor";
const [HTe, , ITe] = Dp("wd-chart-rule-header");
const [_Te] = ITe("block");
const VTe = ({ descriptor: e14, value: t10, setProperty: n10 }) => {
  const { t: r10 } = vp("propertyEditors");
  const o10 = { descriptor: e14, value: t10 || [], setProperty: n10, createEditor: (t11, r11) => {
    const o11 = { descriptor: AV(e14, { valuePath: { $set: `${e14.valuePath}.${r11}` } }), value: t11, setProperty: n10 };
    return tp.createElement(LTe, __spreadValues({}, o11));
  }, onAdd: () => {
    n10(e14, AV(t10 || [], { $push: [Rve()] }));
  }, onDelete: (r11) => {
    n10(e14, AV(t10, { $splice: [[r11, 1]] }));
  }, header: tp.createElement("div", { className: HTe }, tp.createElement(LE, { text: r10("dvchartRuleProperties.headingTargetProperty", "Target Property"), strikeThrough: false, customCSS: _Te, uppercase: false }), tp.createElement(LE, { text: r10("dvchartRuleProperties.headingValueProperty", "Value"), strikeThrough: false, customCSS: _Te, uppercase: false })) };
  return tp.createElement(Bde, __spreadValues({}, o10));
};
VTe.displayName = "DVChartRulePropertiesEditor";
const RTe = (e14) => {
  const t10 = PA();
  const n10 = __spreadProps(__spreadValues({}, e14), { setProperty: (e15, n11) => {
    t10($ye.setUnpivotData(n11));
  } });
  return tp.createElement(Hie, __spreadValues({}, n10));
};
RTe.displayName = "DVChartUnpivotDataEditor";
const ATe = ep.createContext({ expressionSyntax: "i11n", validationContext: {} });
const OTe = _D((e14) => {
  const { value: t10, descriptor: n10, defaultValue: r10, disabled: o10, setProperty: a10 } = e14;
  const { expressionSyntax: i10 } = ep.useContext(ATe);
  const { t: s10 } = vp();
  const l10 = que(e14);
  const c10 = HJ(t10, n10.type, { expressionSyntax: i10 }, n10.meta);
  const u10 = { descriptor: n10, status: l10, defaultValue: r10, setProperty: a10 };
  const d10 = { value: c10, disabled: o10, placeholderEmpty: _ie(s10), placeholderMultipleValues: Iie(s10), onChange: (e15) => {
    const t11 = NJ(e15, n10.type, { expressionSyntax: i10 }, n10.meta);
    a10(n10, t11);
  } };
  return tp.createElement(Mde, __spreadValues({}, u10), tp.createElement(UD, __spreadValues({}, d10)));
});
const BTe = _D((e14) => {
  const { descriptor: t10, value: n10, disabled: r10, setProperty: o10 } = e14;
  const { namedItems: a10 } = ep.useContext(Rue);
  const { t: i10 } = vp();
  const s10 = { value: n10, disabled: r10, placeholderEmpty: _ie(i10), placeholderMultipleValues: Iie(i10), onChange: (e15) => {
    const n11 = e15.trim();
    o10(t10, n11);
  }, validate: (e15) => {
    const t11 = e15.trim();
    if (t11 === n10) return true;
    const r11 = a10.reduce((e16, t12) => (t12.fieldName && e16.push(t12.fieldName), e16), []);
    return !r11.includes(t11);
  } };
  return tp.createElement(UD, __spreadValues({}, s10));
});
const [zTe] = Dp("wd-filters-btn");
const $Te = _D((e14) => {
  const { t: t10 } = vp("filters");
  const { descriptor: n10, value: r10 } = e14;
  const { label: o10, valuePath: a10 } = n10;
  const i10 = PA();
  const s10 = rf(Xm);
  const l10 = rf(dh);
  const c10 = !r10.items.length;
  const u10 = { icon: c10 ? s10 : l10, size: "small", text: t10(c10 ? "add" : "edit"), width: "100%", onClick: () => {
    i10(Xz("filtersEditor", t10(o10), void 0, { valuePath: a10 }));
  }, customCSS: zTe, dataAid: "filters-button" };
  return tp.createElement(qm, __spreadValues({}, u10));
});
const WTe = ep.createContext({ fontFamily: [] });
const jTe = (e14 = "", t10) => {
  const n10 = t10.find((t11) => "string" == typeof t11 ? t11 === e14 : !!Qxe(t11) && t11.value === e14);
  return n10 ? "string" == typeof n10 ? n10 : n10.label : e14;
};
const ZTe = (e14) => {
  const { fontFamily: t10 } = ep.useContext(WTe);
  const n10 = (e15) => "string" == typeof e15 ? { label: e15, value: e15 } : e15;
  const r10 = ep.useMemo(() => t10.filter((e15) => Qxe(e15) || "string" == typeof e15).map(n10), [t10]);
  return tp.createElement(Dde, __spreadProps(__spreadValues({}, e14), { currentEnum: r10 }));
};
ZTe.displayName = "FontFamilyEditor";
const GTe = (e14) => `font.${e14}`;
const UTe = Zq(gY, GTe("fontFamily"), "font_family", "FontFamily");
const qTe = Zq(gY, GTe("fontSize"), "font_size_expr", "FontSize", void 0, { enumKey: "font_size", unit: "pt" });
const YTe = Zq(gY, GTe("fontStyle"), "enum_expr", "FontStyle", void 0, { enumKey: "font_style" });
const KTe = Zq(gY, GTe("fontWeight"), "enum_expr", "FontWeight", void 0, { enumKey: "font_weight" });
const XTe = (e14) => {
  const { t: t10 } = vp();
  const n10 = (n11) => Xue(e14, n11, t10, void 0, true);
  return tp.createElement(tp.Fragment, null, tp.createElement(ZTe, __spreadValues({}, n10(UTe))), tp.createElement(Dde, __spreadValues({}, n10(qTe))), tp.createElement(Dde, __spreadValues({}, n10(YTe))), tp.createElement(Dde, __spreadValues({}, n10(KTe))));
};
XTe.displayName = "FontEditor";
const [JTe] = Dp("wd-editor-format");
const [QTe, , eEe] = Dp("wd-editor-format-digits");
const [tEe] = eEe("input");
const [nEe] = eEe("button");
const rEe = (e14, t10, n10, r10) => ({ labelKey: e14, charKey: t10, preview: n10, digits: r10 });
const oEe = (e14, t10) => (/* @__PURE__ */ new Date()).toLocaleDateString(e14("propertyEditors:format.$locale"), t10);
const aEe = (e14, t10) => (/* @__PURE__ */ new Date()).toLocaleTimeString(e14("propertyEditors:format.$locale"), t10);
const iEe = (e14) => {
  let t10 = "";
  for (let n10 = 0; n10 < e14; n10++) t10 = t10.concat("0");
  return t10;
};
const sEe = (e14) => {
  const t10 = "1234";
  return 0 === e14 ? t10 : `${e14 >= 4 ? t10 : `1.${t10.slice(1, e14)}e+003`}`;
};
const lEe = (e14, t10) => 1234 .toLocaleString(t10("propertyEditors:format.$locale"), { style: "currency", currency: t10("propertyEditors:format.$localeCurrency"), minimumFractionDigits: e14, maximumFractionDigits: e14 });
const cEe = (e14, t10) => 0.12.toLocaleString(t10("propertyEditors:format.$locale"), { style: "percent", minimumFractionDigits: e14, maximumFractionDigits: e14 });
const uEe = (e14, t10) => 1234 .toLocaleString(t10("propertyEditors:format.$locale"), { style: "decimal", minimumFractionDigits: e14, maximumFractionDigits: e14 });
const dEe = (e14) => {
  const t10 = /\D+/.exec(e14);
  return t10 ? t10[0] : "";
};
const [pEe, mEe] = [0, 99];
const hEe = (e14) => _e(e14) && !Number.isNaN(e14);
const fEe = (e14, t10) => e14 ? `${e14.charKey}${hEe(e14.digits) ? t10 : ""}` : "";
const gEe = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { formatObject: n10, setVal: r10, onChangeItems: o10, formatItems: a10 } = e14;
  const { digits: i10, labelKey: s10 } = n10;
  const [l10, c10] = ep.useState(i10);
  ep.useEffect(() => c10(i10), [i10]);
  const u10 = !hEe(i10);
  if (u10) return null;
  const d10 = (e15) => () => {
    const t11 = l10 + e15;
    if (!((i11 = t11) >= pEe && i11 <= mEe)) return;
    var i11;
    const u11 = fEe(n10, t11);
    const d11 = a10.findIndex((e16) => e16.labelKey === s10);
    o10(d11, t11), c10(t11), r10(u11);
  };
  const p10 = { block: true, size: "small", background: "transparent", customCSS: nEe };
  const m10 = __spreadProps(__spreadValues({}, p10), { icon: nf(Jm), disabled: u10 || l10 === pEe, onClick: d10(-1), title: "-1" });
  const h10 = __spreadProps(__spreadValues({}, p10), { icon: nf(Xm), disabled: u10 || l10 === mEe, onClick: d10(1), title: "+1" });
  const f10 = { disabled: true, size: "small", value: `${i10}`, customCSS: tEe, title: t10("format.digitsLabel") };
  return tp.createElement("div", { className: QTe }, tp.createElement(qm, __spreadValues({}, m10)), tp.createElement(KF, __spreadValues({}, f10)), tp.createElement(qm, __spreadValues({}, h10)));
};
const yEe = (e14) => {
  const { descriptor: t10, value: n10, defaultValue: r10, setProperty: o10 } = e14;
  const { t: a10 } = vp("propertyEditors");
  const { expressionSyntax: i10, validationContext: s10 } = ep.useContext(Vue);
  const l10 = [rEe("default", ""), rEe("currency", "c", lEe, 2), rEe("decimal", "d", (e15) => `${e15 > 4 ? iEe(e15 - 4) : ""}1234`, 4), rEe("scientific", "e", (e15) => {
    const t11 = iEe(e15);
    return `1${t11 ? `.${t11}` : ""}e+003`;
  }, 6), rEe("fixedPoint", "f", (e15) => {
    const t11 = iEe(e15);
    return "1234" + (t11 ? `.${t11}` : "");
  }, 2), rEe("general", "g", sEe, 15), rEe("number", "n", uEe, 2), rEe("percent", "p", cEe, 2), rEe("hexadecimal", "x", (e15) => `${e15 > 3 ? iEe(e15 - 3) : ""}4d2`, 0), rEe("shortDate", "d", () => oEe(a10)), rEe("longDate", "D", () => oEe(a10, { weekday: "long", year: "numeric", month: "long", day: "numeric" })), rEe("fullDateShortTime", "f", () => oEe(a10, { weekday: "long", year: "numeric", month: "long", day: "numeric", hour: "numeric", minute: "numeric" })), rEe("generalDateShortTime", "g", () => oEe(a10, { year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric" })), rEe("generalDateLongTime", "G", () => oEe(a10, { year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric", second: "numeric" })), rEe("shortTime", "t", () => aEe(a10, { hour: "numeric", minute: "numeric" })), rEe("longTime", "T", () => aEe(a10, { hour: "numeric", minute: "numeric", second: "numeric" })), rEe("monthDay", "m", () => oEe(a10, { month: "long", day: "numeric" })), rEe("yearMonth", "y", () => oEe(a10, { year: "numeric", month: "long" })), rEe("custom", a10("format.customFormatMask"))];
  const c10 = (e15, t11 = l10) => {
    const n11 = dEe(e15);
    const r11 = t11.filter((e16) => e16.charKey === n11);
    const o11 = /\d+$/.test(e15);
    const a11 = /^\w{1}\d{1,2}$/.test(e15);
    if (1 === r11.length) return r11[0].digits ? a11 ? r11[0] : null : r11[0];
    const i11 = r11.find((e16) => o11 === hEe(e16.digits)) || null;
    return i11 && a11 ? i11 : null;
  };
  const u10 = (e15) => {
    var _a2;
    const t11 = e15 && e15.match(/\d+/);
    return t11 ? parseInt(t11[0], 10) : (n11 = dEe(e15), (_a2 = c10(n11)) == null ? void 0 : _a2.digits);
    var n11;
  };
  const d10 = (e15) => o10(t10, e15);
  const p10 = ep.useContext(Vue);
  const { API: m10 } = ep.useContext(Sm);
  const h10 = (e15) => {
    if (sK(e15)) return true;
    const n11 = fc(i10, e15);
    const { isValid: o11 } = FJ(n11, { descriptor: t10, defaultValue: r10, validationContext: s10, expressionSyntax: i10 });
    return o11;
  };
  const f10 = sK(n10);
  const g10 = f10 ? "" : HJ(n10, t10.type, { expressionSyntax: p10.expressionSyntax });
  const y10 = h10(n10);
  const [v10, b10] = ep.useState(g10);
  const [S10, C10] = ep.useState(y10);
  const [x10, w10] = ep.useState(l10);
  const T10 = ((e15) => {
    const t11 = c10(e15);
    if (!t11) return;
    const n11 = u10(e15);
    return __spreadProps(__spreadValues({}, t11), { digits: n11 });
  })(g10);
  ep.useEffect(() => {
    b10(g10);
  }, [g10, n10]);
  const E10 = x10.map((e15) => {
    const t11 = (e16, t12) => fEe(e16, t12);
    const n11 = (e16) => () => d10(e16);
    if (e15.labelKey === (T10 == null ? void 0 : T10.labelKey)) {
      const e16 = t11(T10, T10.digits);
      return { type: "button", value: T10, text: a10(`format.${T10.labelKey}`), onClick: n11(e16), selected: e16 === v10 };
    }
    const r11 = t11(e15, e15.digits);
    return { type: "button", value: e15, text: a10(`format.${e15.labelKey}`), onClick: n11(r11), selected: r11 === v10 };
  });
  const F10 = (e15, t11) => {
    const n11 = x10.map((n12, r11) => e15 !== r11 ? n12 : __spreadProps(__spreadValues({}, n12), { digits: t11 }));
    w10(n11);
  };
  const M10 = { dataAid: "", value: v10, block: true, size: "small", width: "100%", menuWidth: "100%", openOnFocus: false, menuMaxHeight: "default", scrollToSelection: true, invalid: !S10, items: E10, placeholder: f10 ? Iie(a10) : _ie(a10), onChange: ({ target: { value: e15 } }) => {
    b10(e15), C10(h10(e15)), m10.current.dropdowns.open(null);
  }, onBlur: () => {
    if (v10 === g10) return;
    if (!h10(v10)) return b10(g10), void C10(true);
    let e15;
    const n11 = c10(v10);
    n11 && v10 === n11.charKey ? (e15 = fEe(n11, n11.digits), e15 === g10 && b10(g10)) : e15 = NJ(v10, t10.type, { expressionSyntax: p10.expressionSyntax }), d10(e15);
  } };
  if (T10 && T10.preview && "function" == typeof T10.preview) {
    const e15 = { formatObject: T10, setVal: d10, formatItems: x10, onChangeItems: F10 };
    return tp.createElement("div", { className: JTe }, tp.createElement(tM, __spreadValues({}, M10)), tp.createElement(gEe, __spreadValues({}, e15)));
  }
  return tp.createElement(tM, __spreadValues({}, M10));
};
const vEe = _D((e14) => {
  const { descriptor: t10, defaultValue: n10, setProperty: r10 } = e14;
  const o10 = { descriptor: t10, status: que(e14), defaultValue: n10, setProperty: r10 };
  return tp.createElement(Mde, __spreadValues({}, o10), tp.createElement(yEe, __spreadValues({}, e14)));
});
const bEe = "propertyDescriptors:labels.group.groupExpressions";
const SEe = (e14, t10) => ({ descriptor: e14, value: t10 });
const CEe = { groupExpressionsDescriptor: $N("", bEe, "group_expr_ext_collection", "GroupExpressions"), nameDescriptor: $N("", bEe, "string", "Name") };
const xEe = (e14) => {
  const { t: t10 } = vp();
  const { descriptor: { category: n10, valuePath: r10 }, value: { Name: o10, GroupExpressions: a10 }, setProperty: i10 } = e14;
  const s10 = ep.useContext(Rue);
  const { setProperties: l10 } = ep.useContext(Iue);
  const c10 = WN(CEe.groupExpressionsDescriptor, r10);
  const u10 = WN(CEe.nameDescriptor, r10);
  const d10 = __spreadProps(__spreadValues({}, e14), { descriptor: c10, value: a10 || [], reordering: { type: "drag" }, createEditor: (e15, o11) => {
    const a11 = { descriptor: $N(n10, bEe, "string_expr", `${r10}.GroupExpressions.${o11}`), value: e15, defaultValue: "", setProperty: i10, t: t10 };
    return tp.createElement(Lpe, __spreadValues({}, a11));
  }, onAdd: () => {
    if (o10) i10(c10, AV(a10 || [], { $push: [""] }));
    else {
      const e15 = (({ namedItems: e16, selectedItemsInfo: t11 }) => {
        const n12 = t11[0];
        if (!n12) return null;
        const r12 = (e17 = "", t12 = "") => ({ type: e17, name: t12 });
        if (n12.name) return r12(n12.type, n12.name);
        if (n12.path) {
          const t12 = e16.find((e17) => e17.$path === n12.path);
          if (!t12) return null;
          const o11 = e16.find((e17) => e17.level === t12.level - 1 && e17.leftKey < t12.leftKey && e17.rightKey > t12.leftKey);
          return o11 ? r12(o11.type, o11.name) : null;
        }
        return null;
      })(s10);
      const n11 = e15 && e15.type === rW.fplReport ? MG(t10("nameTemplates:fixedPage"), t10("nameTemplates:group")) : MG(e15 && e15.name || "", t10("nameTemplates:detailsGroup"));
      const r11 = [SEe(c10, AV(a10 || [], { $push: [""] })), SEe(u10, n11)];
      l10(r11);
    }
  }, onDelete: (e15) => {
    if (1 === (a10 || []).length) {
      const e16 = [SEe(c10, AV(a10, { $splice: [[0, 1]] })), SEe(u10, "")];
      l10(e16);
    } else i10(c10, AV(a10, { $splice: [[e15, 1]] }));
  }, t: t10 });
  return tp.createElement(Bde, __spreadValues({}, d10));
};
xEe.displayName = "GroupExpressionsEditor";
const wEe = (e14) => {
  const { defaultValue: t10, descriptor: n10 } = e14;
  const { expressionSyntax: r10, validationContext: o10 } = ep.useContext(Vue);
  return tp.createElement(Hpe, __spreadProps(__spreadValues({}, e14), { validate: (e15) => {
    const a10 = fc(r10, e15);
    const i10 = { defaultValue: t10, descriptor: n10, expressionSyntax: r10, validationContext: o10 };
    const { isValid: s10 } = FJ(a10, i10);
    return s10;
  } }));
};
const TEe = (e14) => `image.${e14}`;
const EEe = { source: Zq("", TEe("source"), "enum_expr", "Source", void 0, { enumKey: "image_source" }), value: Zq("", TEe("value"), "string_expr", "Value"), mimeType: Zq("", TEe("mimeType"), "mime_type", "MIMEType"), repeat: Zq("", TEe("backgroundRepeat"), "enum_expr", "BackgroundRepeat", void 0, { enumKey: "image_repeat" }) };
const FEe = (e14, t10, n10) => ({ type: e14.type, label: e14.label, mode: e14.mode, category: t10.category, valuePath: t10.valuePath ? `${t10.valuePath}.${e14.valuePath}` : e14.valuePath, meta: __spreadProps(__spreadValues(__spreadValues({}, e14.meta), n10), { parentLabel: t10.label }) });
const [MEe, , kEe] = Dp("wd-dropdown-image-db-panel");
const [PEe] = kEe("empty");
const [NEe] = Dp("wd-dropdown-image-db-group");
const [DEe, LEe] = Dp("wd-dropdown-image-db-item");
const HEe = ({ item: e14, selected: t10, onClick: n10 }) => {
  const r10 = kp(DEe, { [LEe("selected")]: t10 });
  return tp.createElement("li", { className: r10, onClick: () => n10(e14) }, tp.createElement(Fm, { icon: nf(Q9) }), tp.createElement("span", null, e14.Name));
};
HEe.displayName = "DatabaseListItem";
const IEe = ({ items: e14, isItemSelected: t10, onFieldSelected: n10 }) => {
  const { t: r10 } = vp("propertyEditors");
  const o10 = e14.map((e15) => {
    const r11 = yK(e15) || [];
    return tp.createElement("div", { key: e15.Name, className: NEe }, tp.createElement(LE, { align: "center", size: "small", text: e15.Name }), r11.map((r12, o11) => {
      const a11 = (i10 = r12.Name, s10 = e15.Name, `=First(${G1(i10)}, "${s10}")`);
      var i10, s10;
      return tp.createElement(HEe, { key: `db_item_${r12.Name}_${o11}`, item: r12, selected: t10(a11), onClick: () => {
        n10(a11);
      } });
    }));
  });
  const a10 = { autoHeight: true, autoHeightMax: "200px", style: { view: { maxHeight: "200px" } }, customCSS: FF };
  return tp.createElement("div", { className: MEe }, o10.length > 0 && tp.createElement(bF, __spreadValues({}, a10), o10), 0 === o10.length && tp.createElement("span", { className: PEe }, r10("image.textNoDataFieldsFound", "No data fields found")));
};
IEe.displayName = "DatabaseList";
const _Ee = { "image/bmp": [".bmp"], "image/cis-cod": [".cod"], "image/emf": [".emf"], "image/gif": [".gif"], "image/ief": [".ief"], "image/jpeg": [".jpeg", ".jpg", ".jpe"], "image/png": [".png"], "image/svg+xml": [".svg"], "image/tiff": [".tif", ".tiff"], "image/webp": [".webp"], "image/wmf": [".wmf"], "image/x-emf": [".emf"], "image/x-icon": [".ico"], "image/x-png": [".png"], "image/x-wmf": [".wmf"] };
const VEe = (e14 = []) => e14.reduce((e15, t10) => {
  const n10 = _Ee[t10];
  return n10 ? `${e15}, ${n10}` : e15;
}, "");
const REe = (e14, t10, n10, r10, o10) => {
  if (!e14) return;
  if (!((e15, t11, n11, r11) => {
    if (!r11.includes(e15.type)) return n11(e15.type ? t11("warning:embeddedImage.badFileType", "Selected file '{{name}}' ({{type}}) is not supported.", { name: e15.name, type: e15.type }) : t11("warning:embeddedImage.badFile", "Selected file '{{name}}' is not an image.", { name: e15.name })), false;
    return e15.size <= 0 ? (n11(t11("warning:embeddedImage.badImageFile", "Selected image file '{{name}}' is invalid.", { name: e15.name })), false) : !(e15.size > 2097152 && (n11(t11("warning:embeddedImage.badImageSize", "Selected image file '{{name}}' exceeds limit of {{limit}} MB.", { name: e15.name, limit: 2 })), 1));
  })(e14, t10, r10, o10)) return;
  const a10 = new FileReader();
  a10.onloadend = () => {
    let o11;
    "string" == typeof a10.result && (o11 = ((a10.result || "").split(";base64,")[1] || "").trim()), o11 ? n10(((e15) => {
      const { t: t11 } = hG();
      const n11 = t11("reportItems:image");
      if (!e15) return n11;
      const r11 = e15.lastIndexOf(".");
      return r11 < 0 ? e15 : e15.slice(0, r11) || n11;
    })(e14.name), o11, e14.type) : r10(t10("warning:embeddedImage.badImageFile", "Selected image file '{{name}}' is invalid.", { name: e14.name }));
  }, a10.readAsDataURL(e14);
};
const AEe = (e14, t10, { onSuccess: n10, onError: r10, onFinish: o10 }, a10 = []) => {
  REe(e14, t10, n10, r10, a10), o10();
};
const [OEe] = Dp("wd-dropdown-image-uploader");
const BEe = ({ textUpload: e14 }) => {
  const t10 = PA();
  const { API: n10 } = ep.useContext(Sm);
  const { imageMimeTypes: r10 } = Uae();
  const o10 = ep.useRef(null);
  const a10 = VEe(r10);
  const { t: i10 } = vp();
  const s10 = rf(Xm);
  return tp.createElement("div", { className: OEe, onClick: () => {
    var _a2;
    (_a2 = o10.current) == null ? void 0 : _a2.click();
  } }, tp.createElement("input", { ref: o10, type: "file", accept: a10, onChange: (e15) => {
    e15.preventDefault();
    const { target: { files: a11 } } = e15;
    a11 && 0 !== (a11 == null ? void 0 : a11.length) && AEe(a11[0], i10, { onSuccess: (e16, n11, r11) => {
      t10(k2({ name: e16, imageData: n11, mimeType: r11 }));
    }, onError: (e16) => {
      n10.notifications.send({ type: "notification", payload: { level: "warning", caption: e16 } });
    }, onFinish: () => {
      o10.current && (o10.current.value = "");
    } }, r10);
  } }), tp.createElement(Fm, { icon: s10 }), tp.createElement("span", null, e14));
};
BEe.displayName = "EmbeddedImageUploader";
const [zEe, , $Ee] = Dp("wd-dropdown-image-panel");
const [WEe] = $Ee("loader");
const [jEe] = $Ee("content");
const [ZEe] = $Ee("empty");
const [GEe, UEe, qEe] = Dp("wd-dropdown-image-tile");
const [YEe] = qEe("img");
const [KEe] = qEe("stub");
const XEe = ({ itemName: e14, itemIndex: t10 }) => {
  const n10 = PA();
  const { t: r10 } = vp("propertyEditors");
  const o10 = { block: true, size: "small", accent: "full", rounded: true, icon: rf(uh), title: r10("image.titleRemove", "Remove '{{name}}'...", { name: e14 }), onClick: (e15) => {
    e15.stopPropagation(), n10(P2({ index: t10 }));
  } };
  return tp.createElement(qm, __spreadValues({}, o10));
};
const JEe = ({ item: e14, itemIndex: t10, source: n10, selected: r10, onClick: o10 }) => {
  const [a10, i10] = ep.useState(false);
  const s10 = rf(tf);
  const l10 = kp(GEe, { [UEe("selected")]: r10 });
  return tp.createElement("li", { className: l10, title: e14.name, onClick: () => o10(e14, n10) }, e14.thumbnail && !a10 ? (() => {
    const t11 = { src: `data:${e14.mimeType || "image/jpg"};base64, ${e14.thumbnail}`, onError: () => i10(true) };
    return tp.createElement("img", __spreadProps(__spreadValues({ className: YEe }, t11), { alt: e14.name }));
  })() : tp.createElement("div", { className: KEe }, tp.createElement(Fm, { icon: s10 }), tp.createElement("span", null, e14.name)), "Embedded" === n10 && !e14.$isMasterReport && tp.createElement(XEe, { itemName: e14.name, itemIndex: t10 }));
};
JEe.displayName = "ImageListItem";
const QEe = ({ items: e14, source: t10, isItemSelected: n10, onItemClick: r10 }) => {
  const { t: o10 } = vp("propertyEditors");
  const a10 = e14.map((e15, o11) => tp.createElement(JEe, { key: `${e15.id}-${o11}`, item: e15, itemIndex: o11, source: t10, selected: n10(e15, t10), onClick: r10 }));
  const i10 = { autoHeight: true, autoHeightMax: "200px", style: { view: { maxHeight: "200px" } }, customCSS: FF };
  return tp.createElement("div", { className: zEe }, "Embedded" === t10 && tp.createElement("div", { className: WEe }, tp.createElement(BEe, { textUpload: o10("image.textLoad", "Load...") })), tp.createElement("div", { className: jEe }, a10.length > 0 && tp.createElement(bF, __spreadValues({}, i10), a10), 0 === a10.length && tp.createElement("span", { className: ZEe }, o10("image.textNoImagesFound", "No images found"))));
};
QEe.displayName = "ImageList";
const [eFe, tFe, nFe] = Dp("wd-dropdown-image");
const [rFe] = nFe("provider");
const [oFe] = nFe("loader");
const aFe = ({ loading: e14, valueInfo: t10, mainSource: n10, provider: r10, requestImages: o10, dataSets: a10, sharedImages: i10, embeddedImages: s10, onImageSelected: l10, onFieldSelected: c10 }) => {
  const u10 = sK(t10.source) ? "External" : t10.source;
  const [d10, p10] = ep.useState(n10 || u10);
  const { t: m10 } = vp("propertyEditors");
  ep.useEffect(() => {
    o10();
  }, []);
  const h10 = (e15) => () => {
    p10(e15);
  };
  const f10 = ({ name: e15 }, n11) => t10 && t10.source === n11 && t10.label === e15 || false;
  const g10 = m10("image.btnShared", "Shared");
  const y10 = m10("image.btnEmbedded", "Embedded");
  const v10 = m10("image.btnDatabase", "Database");
  const b10 = { block: true, size: "small", align: "justify", items: [{ type: "button", width: "100%", accent: "External" === d10 ? "full" : "none", text: g10, onClick: h10("External"), title: g10 }, { type: "button", width: "100%", accent: "Embedded" === d10 ? "full" : "none", text: y10, onClick: h10("Embedded"), title: y10 }, { type: "button", width: "100%", accent: "Database" === d10 ? "full" : "none", text: v10, onClick: h10("Database"), title: v10 }] };
  const { text: S10, onClick: C10 } = r10 || {};
  const x10 = { block: true, size: "small", text: S10, onClick: C10, customCSS: rFe };
  const w10 = kp(eFe, { [tFe("single-source")]: n10 });
  return tp.createElement("div", { className: w10 }, !n10 && tp.createElement(sM, __spreadValues({}, b10)), r10 && tp.createElement(qm, __spreadValues({}, x10)), "External" === d10 && tp.createElement(QEe, { items: i10, source: "External", isItemSelected: f10, onItemClick: l10 }), "Embedded" === d10 && tp.createElement(QEe, { items: s10, source: "Embedded", isItemSelected: f10, onItemClick: l10 }), "Database" === d10 && tp.createElement(IEe, { items: a10, isItemSelected: (e15) => t10 && "Database" === t10.source && t10.label === e15 || false, onFieldSelected: c10 }), e14 && tp.createElement(TE, { block: true, level: "info", width: "100%", height: "100%", customCSS: oFe }));
};
aFe.displayName = "ImageDropdown";
const iFe = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { rdlx: { expressionSyntax: n10 } } = Uae();
  const { API: r10 } = ep.useContext(Sm);
  const { setProperties: o10 } = ep.useContext(Iue);
  const { descriptor: a10, value: i10, disabled: s10, requestImages: l10, dataSets: c10, sharedImages: u10, embeddedImages: d10, loading: p10, error: m10 } = e14;
  const h10 = { valueInfo: i10, requestImages: l10, error: m10, loading: p10, dataSets: c10, sharedImages: u10, embeddedImages: d10, onImageSelected: (e15, t11) => {
    var _a2;
    o10([{ descriptor: FEe(EEe.source, a10), value: t11 }, { descriptor: FEe(EEe.value, a10), value: e15.value }, { descriptor: FEe(EEe.mimeType, a10), value: e15.mimeType }]), (_a2 = r10.dropdowns.current) == null ? void 0 : _a2.close();
  }, onFieldSelected: (e15) => {
    var _a2;
    o10([{ descriptor: FEe(EEe.source, a10), value: "Database" }, { descriptor: FEe(EEe.value, a10), value: e15 }, { descriptor: FEe(EEe.mimeType, a10), value: null }]), (_a2 = r10.dropdowns.current) == null ? void 0 : _a2.close();
  } };
  const f10 = HJ(i10.label, a10.type, { expressionSyntax: n10 }, a10.meta);
  const g10 = { block: true, size: "small", text: f10 || t10("common.textEmpty"), placeholderText: !f10, disabled: s10, menuWidth: "auto", customScroll: true, content: tp.createElement(aFe, __spreadValues({}, h10)) };
  return tp.createElement(UF, __spreadValues({}, g10));
};
iFe.displayName = "ImageEditorMainDropdown";
const sFe = _D(iFe);
const lFe = (e14) => {
  const { descriptor: t10, disabled: n10, value: r10, valueInfo: o10, setProperty: a10, requestImages: i10, dataSets: s10, sharedImages: l10, embeddedImages: c10, loading: u10, error: d10 } = e14;
  const { API: p10 } = ep.useContext(Sm);
  const { expressionSyntax: m10 } = ep.useContext(Vue);
  const { i18n: h10, t: f10 } = vp("propertyEditors");
  const g10 = HJ(r10, t10.type, { expressionSyntax: m10 });
  const [y10, v10] = ep.useState(g10);
  const b10 = sK(r10);
  ep.useEffect(() => {
    v10(b10 ? "" : g10);
  }, [g10, b10, r10]);
  const S10 = d10 || u10 ? null : (() => {
    if ("External" !== o10.source) return null;
    const e15 = PX();
    if (!e15) return null;
    const { label: n11, open: i11 } = e15;
    const s11 = l10.find((e16) => e16.name === r10);
    const c11 = s11 ? s11.id : null;
    return npe(c11, (e16) => a10(t10, bX(e16)), () => {
      var _a2;
      (_a2 = p10.dropdowns.current) == null ? void 0 : _a2.close();
    }, h10, n11, i11);
  })();
  const C10 = { valueInfo: o10, mainSource: o10.source, provider: S10, error: d10, loading: u10, requestImages: i10, dataSets: s10, sharedImages: l10, embeddedImages: c10, onImageSelected: (e15) => {
    var _a2;
    a10(t10, e15.value), (_a2 = p10.dropdowns.current) == null ? void 0 : _a2.close();
  }, onFieldSelected: (e15) => {
    var _a2;
    a10(t10, e15), (_a2 = p10.dropdowns.current) == null ? void 0 : _a2.close();
  } };
  const x10 = () => {
    const e15 = NJ(y10, t10.type, { expressionSyntax: m10 });
    a10(t10, e15);
  };
  const w10 = { block: true, size: "small", value: y10, placeholder: b10 ? Iie(f10) : _ie(f10), disabled: n10, menuWidth: "auto", onKeyDown: (e15) => {
    var _a2;
    "Enter" === e15.key && ((_a2 = p10.dropdowns.current) == null ? void 0 : _a2.close(), x10());
  }, onChange: (e15) => v10(e15.target.value), onBlur: () => {
    b10 && "" === y10 || x10();
  }, customScroll: true, content: tp.createElement(aFe, __spreadValues({}, C10)) };
  return tp.createElement(tM, __spreadValues({}, w10));
};
lFe.displayName = "ImageValueEditor";
const cFe = HD(kde(lFe));
const uFe = (e14) => {
  const { descriptor: t10, value: n10, defaultValue: r10, valueInfo: { source: o10 } } = e14;
  const a10 = __spreadProps(__spreadValues({}, e14), { descriptor: FEe(EEe.source, t10), value: n10.Source, defaultValue: r10.Source });
  const i10 = __spreadProps(__spreadValues({}, e14), { descriptor: FEe(EEe.value, t10), value: n10.Value, defaultValue: r10.Value });
  return tp.createElement(tp.Fragment, null, tp.createElement(Ide, __spreadValues({}, a10)), "Database" === o10 && tp.createElement(Ipe, __spreadValues({}, i10)), "Database" !== o10 && tp.createElement(cFe, __spreadValues({}, i10)));
};
uFe.displayName = "ImageSourceValueEditor";
const [dFe] = Dp("wd-editor-image");
const pFe = () => {
  const { $index: { DataSets: e14 = [] }, EmbeddedImages: t10 = [] } = h9();
  const { rdlx: { sharedImages: n10 } } = d9();
  const r10 = PA();
  const o10 = (e15) => e15.Value ? "External" === e15.Source && ((e16) => {
    var _a2;
    return ((_a2 = n10.items.find(({ value: t11 }) => t11 === e16.Value)) == null ? void 0 : _a2.name) || "";
  })(e15) || e15.Value : "";
  return ep.useMemo(() => ({ dataSets: e14, sharedImages: n10, embeddedImages: t10.map((e15, t11) => ({ id: `${t11}`, name: e15.Name, thumbnail: e15.ImageData, value: e15.Name, mimeType: e15.MIMEType, $isMasterReport: J7(e15) })), requestImages: () => r10(vpe.request()), getImageName: o10, dispatch: r10 }), [n10, t10, e14]);
};
const mFe = (e14) => {
  const { dataSets: t10, sharedImages: n10, embeddedImages: r10, getImageName: o10, requestImages: a10 } = pFe();
  const { imageMimeTypes: i10 } = Uae();
  const { t: s10 } = vp("propertyEditors");
  const { descriptor: l10, value: c10, defaultValue: u10, features: d10 } = e14;
  ep.useEffect(() => {
    const e15 = "External" === c10.Source;
    const t11 = null !== n10.loading;
    e15 && !t11 && c10.Value && a10();
  }, []);
  const p10 = __spreadProps(__spreadValues({}, e14), { value: { label: o10(c10), source: c10.Source }, requestImages: a10, loading: n10.loading, error: n10.error, dataSets: t10, sharedImages: n10.items, embeddedImages: r10 });
  const m10 = __spreadProps(__spreadValues({}, e14), { valueInfo: { label: o10(c10), source: c10.Source }, requestImages: a10, loading: n10.loading, error: n10.error, dataSets: t10, sharedImages: n10.items, embeddedImages: r10 });
  const h10 = __spreadProps(__spreadValues({}, e14), { descriptor: FEe(EEe.mimeType, l10, { imageMimeTypes: i10 }), value: c10.MIMEType, defaultValue: u10.MIMEType, currentEnum: i10 });
  const f10 = __spreadProps(__spreadValues({}, e14), { descriptor: FEe(EEe.repeat, l10), value: c10.BackgroundRepeat, defaultValue: u10.BackgroundRepeat });
  const g10 = __spreadProps(__spreadValues({}, e14), { mainEditor: tp.createElement(sFe, __spreadProps(__spreadValues({}, p10), { shouldUpdate: true })), customCSS: kp(dFe), shouldUpdate: true, titleCollapse: s10("common.titleCollapse"), titleExpand: s10("common.titleExpand") });
  return tp.createElement(ML, __spreadValues({}, g10), d10.includes("source_value") && tp.createElement(uFe, __spreadValues({}, m10)), d10.includes("mime_type") && tp.createElement(Ide, __spreadValues({}, h10)), d10.includes("repeat") && tp.createElement(Ide, __spreadValues({}, f10)));
};
mFe.displayName = "ImageEditor";
const [hFe] = Dp("wd-embedded-collection-input");
const [fFe, , gFe] = Dp("wd-embedded-collection");
const [yFe, , vFe] = gFe("item");
const [bFe] = vFe("preview");
const [SFe] = vFe("img");
const [CFe] = vFe("stub");
const xFe = ({ Name: e14, ImageData: t10, MIMEType: n10 }) => {
  const [r10, o10] = ep.useState(false);
  const a10 = rf(tf);
  return tp.createElement("div", { className: bFe }, t10 && !r10 ? (() => {
    const r11 = { src: `data:${n10 || "image/jpg"};base64, ${t10}`, onError: () => o10(true) };
    return tp.createElement("img", __spreadProps(__spreadValues({ className: SFe }, r11), { alt: e14 }));
  })() : tp.createElement("div", { className: CFe }, tp.createElement(Fm, { icon: a10 })));
};
const wFe = (e14) => {
  const { descriptor: t10, value: n10 } = e14;
  const { API: r10 } = ep.useContext(Sm);
  const { imageMimeTypes: o10 } = MO();
  const a10 = PA();
  const { t: i10 } = vp("propertyEditors");
  const s10 = ep.useRef(null);
  const l10 = VEe(o10);
  const c10 = (e15, t11) => (n11) => {
    const r11 = n11.trim();
    return "" !== r11 && (r11 === t11[e15] || !t11.includes(r11));
  };
  const u10 = __spreadProps(__spreadValues({}, e14), { value: n10 || [], customCSS: fFe, createEditor: (e15, r11) => {
    const o11 = (n10 || []).map((e16) => e16.Name);
    const i11 = { descriptor: $N("", "", "string", `${t10.valuePath}.${r11}.Name`), value: e15.Name, setProperty: (e16, t11) => a10(N2({ index: r11, newName: t11 })), validate: c10(r11, o11), disabled: J7(e15) };
    return tp.createElement("div", { className: yFe }, tp.createElement(xFe, __spreadValues({}, e15)), tp.createElement(bse, __spreadValues({}, i11)));
  }, onAdd: () => {
    var _a2;
    (_a2 = s10.current) == null ? void 0 : _a2.click();
  }, onDelete: (e15) => {
    a10(P2({ index: e15 }));
  }, disableItemButtons: (e15) => J7(n10[e15]) });
  return tp.createElement(tp.Fragment, null, tp.createElement("input", { className: hFe, ref: s10, type: "file", accept: l10, onChange: (e15) => {
    e15.preventDefault();
    const { target: { files: t11 } } = e15;
    t11 && 0 !== (t11 == null ? void 0 : t11.length) && AEe(t11[0], i10, { onSuccess: (e16, t12, n11) => {
      a10(k2({ name: e16, imageData: t12, mimeType: n11 }));
    }, onError: (e16) => {
      r10.notifications.send({ type: "notification", payload: { level: "warning", caption: e16 } });
    }, onFinish: () => {
      s10.current && (s10.current.value = "");
    } }, o10);
  } }), tp.createElement(Bde, __spreadValues({}, u10)));
};
wFe.displayName = "EmbeddedImagesCollection";
const TFe = ID(wFe);
const EFe = { reportItem: void 0, valuePath: "", fullPath: "", semanticMode: false, parameters: [] };
const FFe = ep.createContext(EFe);
function MFe(e14, t10, n10, r10) {
  var _a2;
  if (t10) {
    if (!r10) return "";
    const t11 = S6(n10) || "";
    return d6(e14, t11, r10);
  }
  if (!n10) return "";
  const o10 = yK(n10).find((t11) => t11.Name === e14);
  return (_a2 = o10 == null ? void 0 : o10.DataType) != null ? _a2 : "";
}
function kFe(e14, t10, n10, r10, o10) {
  const a10 = o10 == null ? void 0 : o10.find((t11) => t11.Name === e14);
  const i10 = a10 ? a10.Value : "";
  const s10 = S6(n10) || "";
  return M6(i10, t10, s10, r10);
}
const PFe = (e14, t10, n10) => {
  const { instanceId: r10, rdlx: { expressionSyntax: o10, expressionEditorNodesFilter: a10 } } = Uae();
  const { $index: i10, Type: s10, DataSources: l10 } = h9();
  const { reportItem: c10, dataSet: u10, parentDataSet: d10 } = ep.useContext(FFe);
  const p10 = PA();
  const { t: m10 } = vp();
  const h10 = ep.useCallback((h11 = "") => {
    const f10 = "i11n" === o10 ? hu(h11) : h11;
    let g10 = u10 ? [u10] : [];
    d10 && "value" === t10 && (g10 = [d10]);
    const y10 = __spreadProps(__spreadValues({}, i10), { DataSets: g10 });
    const v10 = dJ(s10, y10, null, "", c10.Name);
    const b10 = [Twe.commonValues({ reportType: s10, objectValue: [], expressionSyntax: o10 }, m10, a10), Twe.parameters(y10.ReportParameters, m10, a10), Twe.dataSets({ dataSets: g10, dataSources: l10 }, m10, a10), Twe.operators(o10, m10, a10), Twe.documentsMap(o10, m10, a10), Twe.reportItems(uJ("", y10.NamedItems || [], c10.Name), m10, a10)];
    const S10 = mwe(o10, m10, a10);
    const C10 = { title: m10("dialogs:expressionEditor.subtitle", "Expression Editor"), value: f10, validate: (e15) => {
      const t11 = { descriptor: Zq("", "", "string_expr", ""), defaultValue: "", itemTypes: [c10.Type], validationContext: v10, expressionSyntax: o10 };
      return FJ(fc(o10, e15), t11);
    }, onSave: (r11, a11) => {
      if (!a11.isValid) return false;
      const i11 = "i11n" === o10 ? fu(r11) : r11;
      return n10(e14, t10, { type: "expression", value: i11 }), true;
    }, treeNodes: b10, fnNodes: S10, treeAdapter: Jxe(o10), customCSS: $xe };
    const x10 = _A.of(r10).open("textEditor", C10);
    p10(x10);
  }, [e14, u10, l10, p10, a10, o10, i10, t10, r10, n10, d10, c10.Name, c10.Type, s10, m10]);
  return h10;
};
const NFe = (e14 = "", t10) => "generic" !== t10 && "parameter" !== t10 ? e14 : `=${cu("parameter" === t10 ? "parameters" : "fields", e14, "Value")}`;
const DFe = (e14 = "", t10) => "i11n" === t10 ? hu(e14) : e14;
const LFe = (e14, t10) => {
  if (0 === e14.length) return t10;
  const n10 = e14.map((e15) => `items.${e15}`).join(".");
  return t10 ? `${n10}.${t10}` : n10;
};
const HFe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M19,10H5V8H19V10M19,16H5V14H19V16Z" }));
const IFe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M14.08,4.61L15.92,5.4L14.8,8H19V10H13.95L12.23,14H19V16H11.38L9.92,19.4L8.08,18.61L9.2,16H5V14H10.06L11.77,10H5V8H12.63L14.08,4.61Z" }));
const _Fe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M16,16.92C15.67,16.97 15.34,17 15,17C14.66,17 14.33,16.97 14,16.92V13.41L11.5,15.89C11,15.5 10.5,15 10.11,14.5L12.59,12H9.08C9.03,11.67 9,11.34 9,11C9,10.66 9.03,10.33 9.08,10H12.59L10.11,7.5C10.3,7.25 10.5,7 10.76,6.76V6.76C11,6.5 11.25,6.3 11.5,6.11L14,8.59V5.08C14.33,5.03 14.66,5 15,5C15.34,5 15.67,5.03 16,5.08V8.59L18.5,6.11C19,6.5 19.5,7 19.89,7.5L17.41,10H20.92C20.97,10.33 21,10.66 21,11C21,11.34 20.97,11.67 20.92,12H17.41L19.89,14.5C19.7,14.75 19.5,15 19.24,15.24V15.24C19,15.5 18.75,15.7 18.5,15.89L16,13.41V16.92H16V16.92M5,19A2,2 0 0,1 7,17A2,2 0 0,1 9,19A2,2 0 0,1 7,21A2,2 0 0,1 5,19H5Z" }));
const VFe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M5.5,4.14L4.5,5.86L15,12L4.5,18.14L5.5,19.86L19,12L5.5,4.14Z" }));
const RFe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M6.5,2.27L20,10.14L6.5,18L5.5,16.27L16.03,10.14L5.5,4L6.5,2.27M20,20V22H5V20H20Z" }));
const AFe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M18.5,4.14L19.5,5.86L8.97,12L19.5,18.14L18.5,19.86L5,12L18.5,4.14Z" }));
const OFe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M18.5,2.27L5,10.14L18.5,18L19.5,16.27L8.97,10.14L19.5,4L18.5,2.27M5,20V22H20V20H5Z" }));
const BFe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M3 19h18v2H3z" }), tp.createElement("path", { className: Ym.text, fillRule: "nonzero", d: "M17.415 17H14.81L8.417 6.641h-.072l.045.578c.083 1.102.124 2.11.124 3.023V17H6.585V4h2.578l6.376 10.306h.053c-.012-.137-.035-.633-.071-1.49-.035-.856-.053-1.525-.053-2.005V4h1.947v13z" }));
const zFe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M3 3h18v2H3z" }), tp.createElement("path", { className: Ym.text, fillRule: "nonzero", d: "M17.415 20H14.81L8.417 9.641h-.072l.045.578c.083 1.102.124 2.11.124 3.023V20H6.585V7h2.578l6.376 10.306h.053c-.012-.137-.035-.633-.071-1.49-.035-.856-.053-1.525-.053-2.005V7h1.947v13z" }));
const $Fe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, fillRule: "nonzero", d: "M16.971 4L5.5 15.471 7.029 17 18.5 5.529M8.176 4.382c-1.258 0-2.294 1.036-2.294 2.294 0 1.259 1.036 2.295 2.294 2.295 1.259 0 2.295-1.036 2.295-2.295 0-1.258-1.036-2.294-2.295-2.294m7.648 7.647c-1.259 0-2.295 1.036-2.295 2.295 0 1.258 1.036 2.294 2.295 2.294 1.258 0 2.294-1.036 2.294-2.294 0-1.259-1.036-2.295-2.294-2.295z" }), tp.createElement("path", { className: Ym.text, d: "M3 19h18v2H3z" }));
const WFe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, fillRule: "nonzero", d: "M16.971 7L5.5 18.471 7.029 20 18.5 8.529M8.176 7.382c-1.258 0-2.294 1.036-2.294 2.294 0 1.259 1.036 2.295 2.294 2.295 1.259 0 2.295-1.036 2.295-2.295 0-1.258-1.036-2.294-2.295-2.294m7.648 7.647c-1.259 0-2.295 1.036-2.295 2.295 0 1.258 1.036 2.294 2.295 2.294 1.258 0 2.294-1.036 2.294-2.294 0-1.259-1.036-2.295-2.294-2.295z" }), tp.createElement("path", { className: Ym.text, d: "M3 3h18v2H3z" }));
const jFe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M15,4V6H18V18H15V20H20V4M4,4V20H9V18H6V6H9V4H4Z" }));
const ZFe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, fillRule: "nonzero", d: "M18 8v10h-3v2h5V4M4 4v16l2-3V6h3V4H4zM16.04 3h2.31L7.96 21H5.65L16.04 3z" }));
const GFe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M3 15h2V5h2v10h10V5h2v10h2v2h-2v2h-2v-2H7v2H5v-2H3v-2z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M7 7h10v8H7z" }));
const UFe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, fillRule: "nonzero", d: "M17.62 3C19.13 5.27 20 8.55 20 12c0 3.44-.87 6.72-2.38 9L16 19.96c1.26-1.89 2-4.83 2-7.96s-.74-6.08-2-7.97L17.62 3M6.38 3L8 4.04C6.74 5.92 6 8.87 6 12s.74 6.08 2 7.96L6.38 21C4.87 18.73 4 15.45 4 12s.87-6.73 2.38-9z" }));
const qFe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, fillRule: "nonzero", d: "M16.04 3h2.31L7.96 21H5.65L16.04 3zM18.47 4.525C19.452 6.629 20 9.261 20 12c0 3.44-.87 6.72-2.38 9L16 19.96c1.26-1.89 2-4.83 2-7.96 0-1.906-.275-3.746-.774-5.32l1.244-2.155zM5.518 19.448C4.544 17.348 4 14.727 4 12c0-3.45.87-6.73 2.38-9L8 4.04C6.74 5.92 6 8.87 6 12c0 1.894.271 3.723.765 5.288l-1.247 2.16z" }));
const YFe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, fillRule: "nonzero", d: "M12.343 17.234l-1.24-3.448H6.355L5.14 17.234H3L7.646 4.766h2.208L14.5 17.234h-2.157zm-1.775-5.198l-1.164-3.38c-.085-.227-.202-.583-.352-1.07-.151-.487-.254-.844-.31-1.07-.153.696-.377 1.458-.671 2.284l-1.122 3.236h3.619zM18.32 8.752l-.24 2.238 2.256-.633.164 1.272-2.109.17 1.382 1.822-1.166.627-.972-1.98-.873 1.98-1.201-.627 1.353-1.822-2.098-.17.205-1.272 2.204.633-.241-2.238h1.336z" }));
const KFe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, fillRule: "nonzero", d: "M18.32 8.752l-.24 2.238 2.256-.633.164 1.272-2.109.17 1.382 1.822-1.166.627-.972-1.98-.873 1.98-1.201-.627 1.353-1.822-2.098-.17.205-1.272 2.204.633-.241-2.238h1.336zM16.04 3h2.31L7.96 21H5.65L16.04 3zM11.478 9.123l-1.199 2.076-.875-2.543c-.085-.227-.202-.583-.352-1.07-.151-.487-.254-.844-.31-1.07-.153.696-.377 1.458-.671 2.284l-1.122 3.236h2.847l-1.01 1.75H6.355L5.14 17.234H3L7.646 4.766h2.208l1.624 4.357zm.401 6.821l1.3-2.254 1.321 3.544h-2.157l-.464-1.29z" }));
const XFe = ["Date", "DateTime"];
const JFe = [...XFe, "Number", "Integer", "Float", "Decimal"];
const QFe = { Equal: { icon: Pm(HFe), name: "operators.equalTo", available: ({ queryFilterMode: e14 }) => !e14 }, NotEqual: { icon: Pm(IFe), name: "operators.notEqualTo", available: ({ queryFilterMode: e14 }) => !e14 }, EqualTo: { icon: Pm(HFe), name: "operators.equalTo", available: ({ queryFilterMode: e14 }) => e14 }, NotEqualTo: { icon: Pm(IFe), name: "operators.notEqualTo", available: ({ queryFilterMode: e14 }) => e14 }, GreaterThan: { icon: Pm(VFe), name: "operators.greaterThan", available: ({ dataType: e14, queryFilterMode: t10 }) => !t10 || JFe.includes(e14) }, GreaterThanOrEqual: { icon: Pm(RFe), name: "operators.greaterThanOrEqualTo", available: ({ queryFilterMode: e14 }) => !e14 }, GreaterThanOrEqualTo: { icon: Pm(RFe), name: "operators.greaterThanOrEqualTo", available: ({ dataType: e14, queryFilterMode: t10 }) => t10 && JFe.includes(e14) }, LessThan: { icon: Pm(AFe), name: "operators.lessThan", available: ({ dataType: e14, queryFilterMode: t10 }) => !t10 || JFe.includes(e14) }, LessThanOrEqual: { icon: Pm(OFe), name: "operators.lessThanOrEqualTo", available: ({ queryFilterMode: e14 }) => !e14 }, LessThanOrEqualTo: { icon: Pm(OFe), name: "operators.lessThanOrEqualTo", available: ({ dataType: e14, queryFilterMode: t10 }) => t10 && JFe.includes(e14) }, Between: { icon: Pm(GFe), name: "operators.between", available: ({ topLevel: e14, dataType: t10, queryFilterMode: n10 }) => n10 ? XFe.includes(t10) : e14 }, In: { icon: Pm(jFe), name: "operators.in", available: ({ topLevel: e14, queryFilterMode: t10 }) => !!t10 || e14 }, NotIn: { icon: Pm(ZFe), name: "operators.notIn", available: ({ queryFilterMode: e14 }) => e14 }, TopN: { icon: Pm(BFe), name: "operators.topN", available: ({ topLevel: e14, queryFilterMode: t10 }) => !t10 && e14 }, BottomN: { icon: Pm(zFe), name: "operators.bottomN", available: ({ topLevel: e14, queryFilterMode: t10 }) => !t10 && e14 }, TopPercent: { icon: Pm($Fe), name: "operators.topPercent", available: ({ topLevel: e14, queryFilterMode: t10 }) => !t10 && e14 }, BottomPercent: { icon: Pm(WFe), name: "operators.bottomPercent", available: ({ topLevel: e14, queryFilterMode: t10 }) => !t10 && e14 }, Like: { icon: Pm(_Fe), name: "operators.like", available: ({ dataType: e14, queryFilterMode: t10 }) => !t10 && ("" === e14 || "String" === e14) }, Contains: { icon: Pm(UFe), name: "operators.contains", available: ({ dataType: e14, queryFilterMode: t10 }) => !!t10 && "String" === e14 }, DoesNotContain: { icon: Pm(qFe), name: "operators.doesNotContain", available: ({ dataType: e14, queryFilterMode: t10 }) => !!t10 && "String" === e14 }, BeginsWith: { icon: Pm(YFe), name: "operators.beginsWith", available: ({ dataType: e14, queryFilterMode: t10 }) => !!t10 && "String" === e14 }, DoesNotBeginWith: { icon: Pm(KFe), name: "operators.doesNotBeginWith", available: ({ dataType: e14, queryFilterMode: t10 }) => !!t10 && "String" === e14 } };
const eMe = /^[+-]?([0-9]*[.])?[0-9]+$/;
const tMe = /^[+-]?[0-9]+$/;
const nMe = () => true;
const rMe = (e14) => {
  const t10 = e14.toLowerCase();
  return "true" === t10 || "false" === t10;
};
const oMe = (e14) => eMe.test(e14);
const aMe = (e14) => tMe.test(e14);
const iMe = (e14, t10) => (n10) => !!(t10 == null ? void 0 : t10.some((e15) => e15.toLowerCase() === n10.toLowerCase())) || ((e15) => {
  if (!e15) return nMe;
  switch (e15) {
    case "Boolean":
      return rMe;
    case "Number":
    case "Float":
    case "Decimal":
      return oMe;
    case "Integer":
      return aMe;
    default:
      return nMe;
  }
})(e14)(n10);
const sMe = (e14) => {
  if (!e14) return "";
  switch (e14) {
    case "Boolean":
      return "True";
    case "Number":
    case "Float":
    case "Integer":
    case "Decimal":
      return "0";
    default:
      return "";
  }
};
const lMe = (e14, t10) => {
  if (!e14 || "between" === e14.type) return;
  const { type: n10, value: r10 } = e14;
  return "list" === n10 ? { type: "list", value: t10("filters:listItemsCount", { count: r10.length }) } : { type: n10, value: r10 };
};
const cMe = tp.createElement("svg", { width: "20px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M9,5A7,7 0 0,0 2,12A7,7 0 0,0 9,19C10.04,19 11.06,18.76 12,18.32C12.94,18.76 13.96,19 15,19A7,7 0 0,0 22,12A7,7 0 0,0 15,5C13.96,5 12.94,5.24 12,5.68C11.06,5.24 10.04,5 9,5M9,7C9.34,7 9.67,7.03 10,7.1C8.72,8.41 8,10.17 8,12C8,13.83 8.72,15.59 10,16.89C9.67,16.96 9.34,17 9,17A5,5 0 0,1 4,12A5,5 0 0,1 9,7M15,7A5,5 0 0,1 20,12A5,5 0 0,1 15,17C14.66,17 14.33,16.97 14,16.9C15.28,15.59 16,13.83 16,12C16,10.17 15.28,8.41 14,7.11C14.33,7.04 14.66,7 15,7Z" }));
const uMe = tp.createElement("svg", { width: "20px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M9,5C10.04,5 11.06,5.24 12,5.68C12.94,5.24 13.96,5 15,5A7,7 0 0,1 22,12A7,7 0 0,1 15,19C13.96,19 12.94,18.76 12,18.32C11.06,18.76 10.04,19 9,19A7,7 0 0,1 2,12A7,7 0 0,1 9,5M8.5,12C8.5,13.87 9.29,15.56 10.56,16.75L11.56,16.29C10.31,15.29 9.5,13.74 9.5,12C9.5,10.26 10.31,8.71 11.56,7.71L10.56,7.25C9.29,8.44 8.5,10.13 8.5,12M15.5,12C15.5,10.13 14.71,8.44 13.44,7.25L12.44,7.71C13.69,8.71 14.5,10.26 14.5,12C14.5,13.74 13.69,15.29 12.44,16.29L13.44,16.75C14.71,15.56 15.5,13.87 15.5,12Z" }));
const dMe = (e14) => {
  const { icon: t10, text: n10, onSelect: r10 } = e14;
  const o10 = { icon: t10, text: n10, block: true, rounded: false, size: "small", width: "100%", onClick: () => r10() };
  return tp.createElement(qm, __spreadValues({}, o10));
};
const pMe = ({ onSelect: e14, extraItems: t10 = [], expandedPath: n10 }) => {
  const { dataSet: r10, queryFilterMode: o10 } = ep.useContext(FFe);
  const { API: a10 } = ep.useContext(Sm);
  const i10 = (t11) => {
    e14(t11), a10.dropdowns.open(null);
  };
  const s10 = { dataSets: r10 ? [r10] : [], handleAttributeClick: (e15, t11) => i10(t11.$path), handleCalculatedFieldClick: (e15, t11) => i10(t11), collapsible: false, allowRebalancing: false, showAggregates: !o10, showLabels: true, showCalculatedFields: !o10, path: n10 };
  return tp.createElement("div", null, tp.createElement(L9, __spreadValues({}, s10)), t10.map((e15) => {
    return tp.createElement(dMe, __spreadProps(__spreadValues({}, e15), { key: `extraItem-${e15.text}`, onSelect: (t11 = e15.onSelect, () => {
      t11(), a10.dropdowns.open(null);
    }) }));
    var t11;
  }));
};
const [mMe, , hMe] = Dp("wd-filter-add");
const [fMe] = hMe("field-dd");
const [gMe] = hMe("operator-stub");
const [yMe] = hMe("value-stub");
const [vMe] = hMe("delete-stub");
const bMe = ({ onAddItem: e14, path: t10, group: n10 }) => {
  var _a2;
  const { t: r10 } = vp("filters");
  const { dataSet: o10, semanticMode: a10, queryFilterMode: i10, queryParameters: s10, parameters: l10, semanticModel: c10 } = ep.useContext(FFe);
  const u10 = [...t10, n10.items.length];
  const d10 = i10 ? "EqualTo" : "Equal";
  const p10 = rf(Xm);
  const m10 = ep.useCallback((t11, n11, { value: r11 }) => {
    e14({ operator: d10, field: { type: "expression", value: r11 }, value: null });
  }, [e14, d10]);
  const h10 = PFe(u10, "field", m10);
  const f10 = ep.useCallback(() => {
    e14({ operator: "and", items: [] });
  }, [e14]);
  const g10 = ep.useCallback(() => {
    h10("");
  }, [h10]);
  const y10 = ep.useCallback((t11) => {
    const n11 = MFe(t11, a10, o10, c10);
    const r11 = sMe(n11);
    e14({ operator: d10, field: { type: "generic", value: t11, valueType: n11 }, value: { type: "simple", value: r11 } });
  }, [o10, e14, d10, a10, c10]);
  const v10 = ep.useCallback((t11) => {
    const n11 = { type: "parameter", value: t11, valueType: kFe(t11, l10, o10, c10, s10) };
    e14({ operator: "EqualTo", field: n11, value: null });
  }, [o10, e14, l10, s10, c10]);
  const b10 = { text: r10("add"), icon: p10, block: true, accent: "icon", size: "small", hiddenChevron: true, customCSS: fMe, menuMaxHeight: 300 };
  const S10 = ep.useMemo(() => {
    if (i10 || a10) return;
    const e15 = yK(o10);
    return [{ type: "header", header: r10("addCriterion") }, ...e15.map(({ Name: e16 }) => ({ type: "button", icon: nf(Q9), text: e16, value: e16 })), e15.length > 0 ? { type: "splitter" } : null, { type: "button", icon: nf(nee), text: r10("expressionText"), onClick: g10 }, { type: "splitter" }, { type: "button", icon: p10, text: r10("addGroup"), onClick: f10 }];
  }, [o10, f10, g10, i10, a10, r10]);
  if (i10) {
    const e15 = [...(_a2 = s10 == null ? void 0 : s10.map(({ Name: e16 }) => ({ icon: nf(eee), text: e16, value: e16, onSelect: () => v10(e16) }))) != null ? _a2 : [], { icon: p10, text: r10("addGroup"), onSelect: f10 }];
    b10.content = tp.createElement(pMe, { onSelect: y10, extraItems: e15 }), b10.menuMaxHeight = 300;
  } else if (a10) {
    const e15 = [{ icon: nf(nee), text: r10("expressionText"), onSelect: g10 }, { icon: p10, text: r10("addGroup"), onSelect: f10 }];
    b10.content = tp.createElement(pMe, { onSelect: y10, extraItems: e15 }), b10.menuMaxHeight = 300;
  } else b10.items = S10, b10.onSelect = y10;
  return tp.createElement("div", { className: mMe, "data-aid": "Add filter" }, tp.createElement(UF, __spreadValues({}, b10)), tp.createElement("div", { className: gMe }), tp.createElement("div", { className: yMe }), tp.createElement("div", { className: vMe }));
};
const SMe = { block: true, accent: "icon", size: "small", chevronIcon: nf(vh, { rotate: "90" }) };
const CMe = (e14) => "generic" === (e14 == null ? void 0 : e14.type) ? e14.value : "";
const xMe = (e14) => {
  var _a2;
  const { t: t10 } = vp("filters");
  const { field: n10, onFieldSelect: r10, onReset: o10, onExpressionSelect: a10, onParameterSelect: i10, customCSS: s10, dropdownCustomCSS: l10 } = e14;
  const { dataSet: c10, semanticMode: u10, queryFilterMode: d10, queryParameters: p10 } = ep.useContext(FFe);
  const { rdlx: { expressionSyntax: m10 } } = Uae();
  const h10 = __spreadProps(__spreadValues({}, SMe), { onSelect: r10, customCSS: s10, dataAid: "Filter expression", menuMaxHeight: 300 });
  if (d10) {
    const e15 = [...(_a2 = p10 == null ? void 0 : p10.map(({ Name: e16 }) => ({ icon: nf(eee), text: e16, value: e16, onSelect: () => i10(e16) }))) != null ? _a2 : []];
    h10.content = tp.createElement(pMe, { onSelect: r10, extraItems: e15, expandedPath: CMe(n10) });
  } else if (u10) {
    const e15 = [{ type: "button", icon: nf(Bh), text: t10("reset"), onSelect: o10 }, { icon: nf(nee), text: t10("expressionText"), onSelect: a10 }];
    h10.content = tp.createElement(pMe, { onSelect: r10, extraItems: e15, expandedPath: CMe(n10) });
  } else {
    const e15 = yK(c10);
    const n11 = ep.useMemo(() => [{ type: "button", icon: nf(Bh), text: t10("reset"), onClick: o10 }, { type: "splitter" }, ...e15.map(({ Name: e16 }) => ({ type: "button", icon: nf(Q9), text: e16, value: e16 })), e15.length > 0 ? { type: "splitter" } : null, { type: "button", icon: nf(nee), text: t10("expressionText"), onClick: a10 }], [e15]);
    h10.items = n11;
  }
  return null !== n10 && ("expression" === n10.type ? (h10.icon = nf(nee), h10.text = DFe(n10.value, m10), h10.customCSS = l10) : "parameter" === n10.type ? (h10.icon = nf(eee), h10.text = n10.value) : (h10.icon = nf(Q9), h10.text = n10.value)), tp.createElement(UF, __spreadValues({}, h10));
};
const [wMe, TMe] = Dp("wd-filter-icon");
const [EMe, FMe] = Dp("wd-filter-value");
Dp("wd-fill-field"), Dp("wd-fill-parameter"), Dp("wd-fill-expression"), Dp("wd-fill-list");
const [, MMe, kMe] = Dp("wd-filter-value-editor");
const PMe = MMe("with-btn");
const [NMe] = kMe("input");
const DMe = ({ value: e14, defaultValue: t10, dataType: n10, validate: r10, onValueChanged: o10, onRemoveItem: a10 }) => {
  const { rdlx: { expressionSyntax: i10 } } = Uae();
  const { queryFilterMode: s10 } = ep.useContext(FFe);
  const l10 = s10 ? ["null"] : void 0;
  const c10 = DFe(e14, i10);
  const [u10, d10] = ep.useState(c10);
  const [p10, m10] = ep.useState(c10);
  const [h10, f10] = ep.useState(true);
  ep.useEffect(() => {
    const t11 = DFe(e14, i10);
    d10(t11), m10(t11), f10(true);
  }, [e14]);
  const g10 = ep.useCallback(({ target: { value: e15 } }) => {
    m10(e15), f10(iMe(n10, l10)(e15));
  }, [n10]);
  const y10 = ep.useCallback(() => {
    const e15 = p10.trim();
    if (e15.length < 1) return o10(t10), m10(DFe(t10, i10)), void f10(true);
    h10 ? o10(((e16 = "") => HX() ? fu(e16) : e16)(e15)) : (m10(u10), f10(true));
  }, [p10, t10, o10]);
  const v10 = ep.useCallback((e15) => {
    e15.stopPropagation();
  }, [p10]);
  const b10 = { block: true, autoFocus: false, spellCheck: false, size: "small", width: "100%", value: p10, invalid: !h10 || r10 && !r10(p10), onChange: g10, onBlur: y10, onKeyDown: v10 };
  const S10 = { size: "small", icon: nf(uh), onClick: a10 };
  const C10 = tp.createElement("div", { className: NMe }, tp.createElement(KF, __spreadValues({}, b10)));
  return a10 ? tp.createElement("div", { className: PMe }, C10, tp.createElement(qm, __spreadValues({}, S10))) : C10;
};
DMe.displayName = "ValueEditor";
const [LMe, , HMe] = Dp("wd-filter-value-editor");
const [IMe, _Me] = HMe("overlay");
const VMe = { Float: "Float", Number: "Float", Integer: "Integer", Decimal: "Float", Date: "Date", DateTime: "DateTime", Boolean: "Boolean" };
const RMe = [["Decimal", "Float", "Integer", "Number"], ["Date", "DateTime"], ["String", "Guid", "Binary"], ["Boolean"]];
const AMe = (e14, t10) => RMe.some((n10) => n10.includes(e14) && n10.includes(t10));
const OMe = ({ icon: e14, value: { type: t10, value: n10 }, invalid: r10 }) => {
  const { rdlx: { expressionSyntax: o10 } } = Uae();
  return tp.createElement("div", { className: kp(IMe, { [_Me("invalid")]: r10 }) }, tp.createElement(Fm, { customCSS: kp(wMe, TMe(t10)), icon: e14 }), tp.createElement("span", null, DFe(n10, o10)));
};
const BMe = (e14, t10, n10) => tp.createElement(OMe, { icon: nf(e14), value: t10, invalid: n10 });
const zMe = (e14) => {
  const { t: t10, t: n10 } = vp("filters");
  const { dataType: r10, specialValue: o10, path: a10, onReset: i10, onParameterSelected: s10, onExpressionSelected: l10, onFieldSelected: c10 } = e14;
  const { queryFilterMode: u10, queryParameters: d10, parameters: p10, fullPath: m10, onOpenParameterPanel: h10 } = ep.useContext(FFe);
  const { instanceId: f10, userPreferences: { units: g10 } } = Uae();
  const y10 = PA();
  const v10 = ep.useCallback((e15) => {
    var _a2, _b2;
    if ("#reset" !== e15) {
      if ("#param" === e15) {
        const e16 = kG(n10("nameTemplates:reportParameter", "Parameter"), p10.map((e17) => e17.Name));
        const t11 = ((e17) => VMe[e17 || "String"] || "String")(r10);
        const o11 = (_b2 = (_a2 = nz.of(f10).getDescriptor("reportParameter")) == null ? void 0 : _a2.init) == null ? void 0 : _b2.call(_a2, e16, g10, { DataType: t11 });
        y10(Q0({ param: o11 }));
        const i11 = `${m10}.${LFe(a10 || [], "value")}`;
        return s10(e16), void (h10 && h10(e16, i11));
      }
      "#expr" !== e15 ? s10(e15) : l10();
    } else i10();
  }, [i10, s10, l10]);
  const b10 = ((e15, t11, n11) => e15 && "simple" !== e15.type ? "parameter" === e15.type ? BMe(eee, e15, n11) : "list" === e15.type ? BMe(oee, e15) : BMe(t11 ? Q9 : nee, e15) : null)(o10, u10, (() => {
    var _a2;
    if (u10) return false;
    if (!r10 || !o10 || "parameter" !== o10.type) return false;
    const e15 = ((_a2 = p10.find((e16) => e16.Name === o10.value)) == null ? void 0 : _a2.DataType) || "";
    return !AMe(e15, r10);
  })());
  const S10 = { block: true, size: "small", itemSize: "small", hiddenChevron: true, icon: nf(vh, { rotate: "90" }), onSelect: v10, menuMaxHeight: 300 };
  if (u10) {
    const e15 = d10 == null ? void 0 : d10.map(({ Name: e16 }) => ({ icon: nf(eee), text: e16, value: e16, onSelect: () => s10(e16) }));
    S10.content = tp.createElement(pMe, { onSelect: c10, extraItems: e15 });
  } else S10.items = (({ parameters: e15, dataType: t11, specialValue: n11 }, r11) => [{ type: "button", icon: nf(Bh), text: r11("reset", "Reset"), value: "#reset" }, { type: "splitter" }, ...e15.map(({ Name: e16, DataType: r12 }) => ({ type: "button", icon: nf(eee), text: e16, value: e16, selected: "parameter" === (n11 == null ? void 0 : n11.type) && e16 === (n11 == null ? void 0 : n11.value), disabled: !!t11 && !AMe(t11, r12) })), e15.length > 0 ? { type: "splitter" } : null, { type: "button", icon: nf(tee), text: r11("newParameter", "New Parameter"), value: "#param" }, { type: "splitter" }, { type: "button", icon: nf(nee), text: r11("expressionText", "Expression..."), value: "#expr" }])({ parameters: p10, dataType: r10, specialValue: o10 }, t10);
  return tp.createElement("div", { className: LMe }, b10 || tp.createElement(DMe, __spreadValues({}, e14)), tp.createElement(UF, __spreadValues({}, S10)));
};
zMe.displayName = "ValueEditorWithDropdown";
const $Me = ({ path: e14, innerPath: t10, criterionValue: n10, dataType: r10, validate: o10, onSetValue: a10 }) => {
  const { t: i10 } = vp("filters");
  const { queryFilterMode: s10, parameters: l10, queryParameters: c10, dataSet: u10, semanticModel: d10 } = ep.useContext(FFe);
  const p10 = sMe(r10);
  const m10 = lMe(n10, i10);
  const h10 = PFe(e14, t10, a10);
  const f10 = ep.useCallback((n11) => {
    a10(e14, t10, { type: "simple", value: n11 });
  }, [a10]);
  const g10 = ep.useCallback(() => {
    a10(e14, t10, { type: "simple", value: p10 });
  }, [p10, a10]);
  const y10 = ep.useCallback((n11) => {
    const r11 = { type: "parameter", value: n11 };
    s10 && (r11.valueType = kFe(n11, l10, u10, d10, c10)), a10(e14, t10, r11);
  }, [a10]);
  const v10 = ep.useCallback((n11) => {
    const r11 = { type: "field", value: n11, valueType: kFe(n11, l10, u10, d10, c10) };
    a10(e14, t10, r11);
  }, [a10]);
  const b10 = ep.useCallback(() => {
    const e15 = NFe(m10 == null ? void 0 : m10.value, m10 == null ? void 0 : m10.type);
    h10(e15);
  }, [h10, m10 == null ? void 0 : m10.type, m10 == null ? void 0 : m10.value]);
  const S10 = { value: "simple" === (n10 == null ? void 0 : n10.type) ? n10.value : p10, path: e14, dataType: r10, defaultValue: p10, specialValue: m10, validate: o10, onReset: g10, onValueChanged: f10, onParameterSelected: y10, onExpressionSelected: b10, onFieldSelected: v10 };
  return tp.createElement("div", { className: EMe, "data-aid": "Simple value" }, tp.createElement(zMe, __spreadValues({}, S10)));
};
const WMe = ({ path: e14, criterionValue: t10, dataType: n10, onSetValue: r10 }) => {
  const { language: o10 } = Uae();
  const a10 = { type: "simple", value: sMe(n10) };
  const i10 = { type: "between", from: a10, to: a10 };
  const s10 = "between" === (t10 == null ? void 0 : t10.type) ? t10 : i10;
  const l10 = ep.useCallback((e15) => sI(e15).locale(o10), [o10]);
  const c10 = (e15) => /^-?\d+\.?\d*$/.test(e15);
  const u10 = "simple" === s10.from.type && "simple" === s10.to.type;
  const d10 = (e15, t11, n11) => !u10 || t11.localeCompare(e15, void 0, { sensitivity: "base", numeric: n11 }) >= 0;
  const p10 = (e15, t11) => d10(e15, t11, false);
  const m10 = (e15, t11) => {
    switch (n10) {
      case "Date":
      case "DateTime": {
        const n11 = l10(e15);
        const r11 = l10(t11);
        return n11.isValid() && r11.isValid() ? n11.isSameOrBefore(r11) : p10(e15, t11);
      }
      case "Integer":
      case "Float":
      case "Number":
        return !(!c10(e15) || !c10(t11)) && ((e16, t12) => d10(e16, t12, true))(e15, t11);
      case "Boolean":
        return true;
      default:
        return p10(e15, t11);
    }
  };
  const h10 = { path: e14, innerPath: "value.from", criterionValue: s10.from, dataType: n10, validate: (e15) => m10(e15, s10.to.value), onSetValue: (t11, n11, o11) => {
    r10(e14, "value", { type: "between", from: o11, to: s10.to });
  } };
  const f10 = { path: e14, innerPath: "value.to", criterionValue: s10.to, dataType: n10, validate: (e15) => m10(s10.from.value, e15), onSetValue: (t11, n11, o11) => {
    r10(e14, "value", { type: "between", from: s10.from, to: o11 });
  } };
  return tp.createElement("div", { className: kp(EMe, FMe("between")), "data-aid": "Between value" }, tp.createElement($Me, __spreadValues({}, h10)), tp.createElement($Me, __spreadValues({}, f10)));
};
const jMe = ({ path: e14, criterionValue: t10, dataType: n10, onSetValue: r10 }) => {
  const { t: o10 } = vp("filters");
  const { queryFilterMode: a10, parameters: i10, queryParameters: s10, dataSet: l10, semanticModel: c10 } = ep.useContext(FFe);
  const u10 = sMe(n10);
  const d10 = lMe(t10, o10);
  const p10 = PFe(e14, "value", r10);
  const m10 = "list" === (t10 == null ? void 0 : t10.type) ? t10 : void 0;
  const h10 = ep.useCallback((t11) => (n11) => {
    r10(e14, "value", { type: "list", value: AV(m10 == null ? void 0 : m10.value, { [t11]: { $set: n11 } }) });
  }, [m10, r10]);
  const f10 = ep.useCallback(() => {
    r10(e14, "value", { type: "list", value: [u10] });
  }, [u10, r10]);
  const g10 = ep.useCallback((t11) => {
    const n11 = { type: "parameter", value: t11 };
    a10 && (n11.valueType = kFe(t11, i10, l10, c10, s10)), r10(e14, "value", n11);
  }, [r10]);
  const y10 = ep.useCallback((t11) => {
    const n11 = { type: "field", value: t11, valueType: kFe(t11, i10, l10, c10, s10) };
    r10(e14, "value", n11);
  }, [r10]);
  const v10 = ep.useCallback(() => {
    r10(e14, "value", { type: "list", value: AV(m10 == null ? void 0 : m10.value, { $push: [u10] }) });
  }, [m10, u10, r10]);
  const b10 = ep.useCallback((t11) => () => {
    r10(e14, "value", { type: "list", value: AV(m10 == null ? void 0 : m10.value, { $set: m10 == null ? void 0 : m10.value.filter((e15, n11) => n11 !== t11) }) });
  }, [m10, r10]);
  const S10 = { value: u10, dataType: n10, defaultValue: u10, specialValue: d10, onReset: f10, onValueChanged: h10(0), onParameterSelected: g10, onExpressionSelected: () => {
    const e15 = NFe(d10 == null ? void 0 : d10.value, d10 == null ? void 0 : d10.type);
    p10("list" !== (t10 == null ? void 0 : t10.type) ? e15 : void 0);
  }, onFieldSelected: y10 };
  const C10 = { block: true, size: "small", width: "100%", icon: nf(Xm), text: o10("addItem"), onClick: v10 };
  return m10 ? tp.createElement("div", { className: EMe, "data-aid": "List value" }, tp.createElement(zMe, __spreadValues({}, S10)), m10.value.map((e15, t11) => {
    const r11 = { value: m10.value[t11], dataType: n10, defaultValue: u10, onValueChanged: h10(t11), onRemoveItem: m10.value.length > 1 ? b10(t11) : void 0 };
    return tp.createElement(DMe, __spreadValues({ key: `${e15}-${t11}` }, r11));
  }), tp.createElement(qm, __spreadValues({}, C10))) : tp.createElement("div", { className: EMe, "data-aid": "List value" }, tp.createElement(zMe, __spreadValues({}, S10)));
};
const ZMe = (e14) => {
  const { path: t10, criterion: { field: n10, operator: r10, value: o10 }, onSetValue: a10 } = e14;
  const { dataSet: i10, semanticModel: s10, semanticMode: l10 } = ep.useContext(FFe);
  let c10 = "";
  "generic" === (n10 == null ? void 0 : n10.type) && (c10 = MFe(n10.value, l10, i10, s10));
  let u10 = null;
  if ("Between" === r10) {
    const e15 = { path: t10, dataType: c10, criterionValue: o10, onSetValue: a10 };
    u10 = tp.createElement(WMe, __spreadValues({}, e15));
  } else if ("In" === r10 || "NotIn" === r10) {
    const e15 = { path: t10, dataType: c10, criterionValue: o10, onSetValue: a10 };
    u10 = tp.createElement(jMe, __spreadValues({}, e15));
  } else {
    const e15 = { path: t10, innerPath: "value", dataType: c10, criterionValue: o10, onSetValue: a10 };
    u10 = tp.createElement($Me, __spreadValues({}, e15));
  }
  return u10;
};
const [GMe, , UMe] = Dp("wd-filter-criterion");
const [qMe, YMe] = UMe("field-dd");
const [KMe] = UMe("operator-dd");
const XMe = { block: true, accent: "icon", size: "small" };
const JMe = ({ path: e14, criterion: t10, topLevel: n10, onSetValue: r10, onDelete: o10 }) => {
  var _a2;
  const { t: a10 } = vp("filters");
  const { field: i10, operator: s10 } = t10;
  const { dataSet: l10, semanticModel: c10, semanticMode: u10, queryFilterMode: d10 = false, parameters: p10, queryParameters: m10 } = ep.useContext(FFe);
  const h10 = "generic" === (i10 == null ? void 0 : i10.type) ? function(e15, t11, n11, r11) {
    return e15.valueType ? e15.valueType : MFe(e15.value, t11, n11, r11);
  }(i10, u10, l10, c10) : "";
  const f10 = PFe(e14, "field", r10);
  const g10 = { field: i10, onFieldSelect: (t11) => {
    const n11 = MFe(t11, u10, l10, c10);
    r10(e14, "field", { type: "generic", value: t11, valueType: n11 });
  }, onParameterSelect: (t11) => {
    const n11 = { type: "parameter", value: t11, valueType: kFe(t11, p10, l10, c10, m10) };
    r10(e14, "field", n11);
  }, onReset: () => {
    r10(e14, "field", { type: "expression", value: "" });
  }, onExpressionSelect: () => {
    const e15 = NFe(i10 == null ? void 0 : i10.value, i10 == null ? void 0 : i10.type);
    f10(e15);
  }, customCSS: qMe, dropdownCustomCSS: kp(qMe, YMe("expression")) };
  const y10 = ((e15, t11) => {
    const n11 = __spreadValues({ dataType: e15 }, t11);
    return Object.keys(QFe).filter((e16) => QFe[e16].available(n11));
  })(h10, { topLevel: n10, queryFilterMode: d10 });
  const v10 = null !== s10 ? QFe[s10] : null;
  const b10 = __spreadProps(__spreadValues({}, XMe), { icon: (_a2 = v10 == null ? void 0 : v10.icon) != null ? _a2 : void 0, title: (v10 == null ? void 0 : v10.name) ? a10(v10.name) : void 0, hiddenChevron: true, onSelect: (t11) => {
    if (s10 === t11) return;
    const n11 = (e15) => "In" === e15 || "NotIn" === e15;
    const o11 = sMe(h10);
    "Between" === t11 ? r10(e14, "", { field: i10, operator: t11, value: { type: "between", from: { type: "simple", value: o11 }, to: { type: "simple", value: o11 } } }) : n11(t11) ? n11(s10) ? r10(e14, "operator", t11) : r10(e14, "", { field: i10, operator: t11, value: { type: "list", value: [o11] } }) : n11(s10) || "Between" === s10 ? r10(e14, "", { field: i10, operator: t11, value: { type: "simple", value: o11 } }) : r10(e14, "operator", t11);
  }, items: y10.map((e15) => {
    const t11 = QFe[e15];
    return { type: "button", icon: t11.icon, text: a10(t11.name), value: e15 };
  }), customCSS: KMe, dataAid: "Filter operator" });
  const S10 = { path: e14, criterion: t10, onSetValue: r10 };
  return tp.createElement("div", { className: GMe }, tp.createElement(xMe, __spreadValues({}, g10)), tp.createElement(UF, __spreadValues({}, b10)), tp.createElement(ZMe, __spreadValues({}, S10)), tp.createElement(qm, { block: true, size: "small", icon: nf(uh), title: a10("delete"), onClick: o10 }));
};
const [QMe, , eke] = Dp("wd-filters-group");
const [tke] = eke("header");
const [nke, rke] = eke("container");
const oke = kp(nke, rke("last"));
const ake = kp(nke, rke("new"));
const ike = ({ path: e14, group: t10, onSetValue: n10, onDelete: r10 }) => {
  const { t: o10 } = vp("filters");
  const a10 = () => {
    n10(e14, "operator", "and" === t10.operator ? "or" : "and");
  };
  const i10 = (r11) => () => {
    const o11 = [...t10.items];
    o11.splice(r11, 1), n10(e14, "items", o11);
  };
  const s10 = o10("allOf");
  const l10 = o10("anyOf");
  const c10 = { size: "small", items: [{ type: "button", accent: "full", icon: nf("and" === t10.operator ? cMe : uMe), text: "and" === t10.operator ? s10 : l10, onClick: a10 }, { type: "button", text: "or" === t10.operator ? s10 : l10, onClick: a10 }] };
  const u10 = { onAddItem: (r11) => n10(e14, "items", [...t10.items, r11]), path: e14, group: t10 };
  return tp.createElement("div", { className: QMe }, tp.createElement("div", { className: tke, "data-aid": "Filter group button" }, tp.createElement(sM, __spreadValues({}, c10)), r10 && tp.createElement(qm, { block: true, size: "small", icon: nf(uh), onClick: r10 })), t10.items.map((r11, o11) => {
    const a11 = o11 === t10.items.length - 1 ? oke : nke;
    if ("items" in r11) {
      const t11 = { path: [...e14, o11], group: r11, onSetValue: n10, onDelete: i10(o11) };
      return tp.createElement("div", { key: o11, className: a11, "data-aid": "Filter group container" }, tp.createElement(ike, __spreadValues({}, t11)));
    }
    const s11 = { path: [...e14, o11], criterion: r11, topLevel: 0 === e14.length && "and" === t10.operator, onSetValue: n10, onDelete: i10(o11) };
    return tp.createElement("div", { key: o11, className: a11, "data-aid": "Filter criterion container" }, tp.createElement(JMe, __spreadValues({}, s11)));
  }), tp.createElement("div", { className: ake }, tp.createElement(bMe, __spreadValues({}, u10))));
};
const [ske] = Dp("wd-filters");
const lke = (e14) => {
  const { reportItem: t10, valuePath: n10, fullPath: r10, parameters: o10, filters: a10, semanticMode: i10 = false, semanticModel: s10, queryFilterMode: l10, onSetValue: c10, dataSet: u10, parentDataSet: d10, filterEditorRef: p10, onOpenParameterPanel: m10, queryParameters: h10 } = e14;
  if (null === a10) return null;
  const f10 = { path: [], group: a10, onSetValue: c10 };
  const g10 = s10 && i10 && l10 ? h10 == null ? void 0 : h10.filter(({ Name: e15 }) => !h6(e15)) : h10;
  const y10 = { reportItem: t10, valuePath: n10, fullPath: r10 || "", parameters: o10, dataSet: u10, parentDataSet: d10, semanticModel: s10, semanticMode: i10, queryFilterMode: l10, onOpenParameterPanel: m10, queryParameters: g10 };
  return tp.createElement("div", { className: ske, ref: p10 }, tp.createElement(FFe.Provider, { value: y10 }, tp.createElement(ike, __spreadValues({}, f10))));
};
const [cke, uke, dke] = Dp("wd-data-set-filters");
const pke = uke("expanded");
const [mke] = dke("container");
const hke = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { valuePath: n10, dataSet: r10, filters: o10, onSetValue: a10, queryFilterMode: i10 = false, semanticModel: s10, queryParameters: l10, reportParameters: c10 } = e14;
  const u10 = rf(Xm);
  const d10 = rf(dh);
  const p10 = rf(xh);
  const [m10, h10] = ep.useState(false);
  const [f10, g10] = ep.useState(0);
  const y10 = ep.useRef(null);
  ep.useEffect(() => {
    m10 && y10.current && g10(y10.current.clientHeight + 5);
  }, [m10, o10]);
  const v10 = t10("propertyDescriptors:labels.dataSet.filters");
  const b10 = { reportItem: r10, valuePath: n10, parameters: c10, filters: o10, onSetValue: a10, dataSet: r10, queryFilterMode: i10, semanticMode: i10, semanticModel: s10, queryParameters: l10 };
  const S10 = o10.items.length;
  const C10 = { icon: S10 > 0 ? d10 : u10, size: "small", text: t10(S10 > 0 ? "filters:edit" : "filters:add"), width: "100%", onClick: () => h10(true) };
  const x10 = m10 ? { height: f10 } : {};
  const w10 = { label: v10, block: true, size: "small", tooltip: { text: t10("collection.titleClose"), icon: p10, onClick: () => h10(false) } };
  const T10 = kp(cke, { [pke]: m10 });
  return tp.createElement("div", { className: T10, "data-aid": "Filters", style: x10 }, m10 ? tp.createElement("div", { className: mke, ref: y10 }, tp.createElement(AN, __spreadValues({}, w10), tp.createElement(lke, __spreadValues({}, b10)))) : tp.createElement(AN, { label: v10, position: "left", block: true, size: "small" }, tp.createElement(qm, __spreadValues({}, C10))));
};
const fke = ep.createContext({ dataSet: null, setDataSetProperty: () => {
}, reportParameters: [] });
const gke = (e14) => {
  const { descriptor: { valuePath: t10 } } = e14;
  const { reportParameters: n10, dataSet: r10, setDataSetProperty: o10 } = ep.useContext(fke);
  const a10 = { valuePath: t10, dataSet: r10, filters: r10.Filters, onSetValue: (e15, n11, r11) => {
    const a11 = LFe(e15, n11);
    o10({ valuePath: `${t10}.${a11}` }, r11);
  }, reportParameters: n10, queryFilterMode: false };
  return tp.createElement(hke, __spreadValues({}, a10));
};
const yke = "RDLX/INPUT_FIELD/SET_INPUT_TYPE";
const vke = _V(yke, (e14) => ({ inputType: e14 }));
const bke = (e14) => {
  const t10 = PA();
  const n10 = ep.useCallback((e15, n11) => {
    t10(vke(n11));
  }, [t10]);
  const r10 = __spreadProps(__spreadValues({}, e14), { setProperty: n10 });
  return tp.createElement(nse, __spreadValues({}, r10));
};
const Ske = (e14) => {
  const { rdlx: { reportLanguages: t10 } } = Uae();
  const { descriptor: n10 } = e14;
  const { t: r10 } = vp();
  const o10 = t10 ? [{ value: "Default", label: RO("language", "Default", r10) }, ...t10] : void 0;
  const a10 = o10 != null ? o10 : OO("language", r10);
  const i10 = __spreadProps(__spreadValues({}, e14), { descriptor: __spreadProps(__spreadValues({}, n10), { meta: o10 ? __spreadProps(__spreadValues({}, n10 == null ? void 0 : n10.meta), { reportLanguages: o10 }) : n10 == null ? void 0 : n10.meta }), currentEnum: a10 });
  return tp.createElement(Hde, __spreadValues({}, i10));
};
Ske.displayName = "LanguageEditor";
const Cke = ep.createContext({ layers: [] });
const xke = Zq("", "layer.name", "string", "Name");
const wke = Zq("", "layer.designerLock", "boolean", "DesignerLock");
const Tke = Zq("", "layer.designerVisible", "boolean", "DesignerVisible");
const Eke = Zq("", "layer.designerDataFieldVisible", "boolean", "DataFieldVisible");
const Fke = Zq("", "layer.designerTransparency", "percent", "DesignerTransparency", void 0, { min: 0, max: 100 });
const Mke = (e14) => {
  const { Layers: t10 } = h9();
  const { value: n10, defaultValue: r10, descriptor: { valuePath: o10 } } = e14;
  const a10 = n10;
  const i10 = r10;
  const s10 = PA();
  const l10 = (e15) => (t11, r11) => {
    sK(n10.Name) || s10(T2({ layerName: a10.Name, propertyName: e15, value: r11 }));
  };
  const c10 = "default" === a10.Name;
  const u10 = __spreadProps(__spreadValues({}, e14), { value: a10.Name, descriptor: WN(xke, o10), occupiedNames: t10.map((e15) => e15.Name), setProperty: (e15, t11) => {
    s10(M2({ layerName: a10.Name, newLayerName: t11 }));
  } });
  const d10 = __spreadProps(__spreadValues({}, e14), { descriptor: WN(wke, o10), value: a10.DesignerLock, defaultValue: i10.DesignerLock, setProperty: l10("DesignerLock") });
  const p10 = __spreadProps(__spreadValues({}, e14), { descriptor: WN(Tke, o10), value: a10.DesignerVisible, defaultValue: i10.DesignerVisible, setProperty: l10("DesignerVisible") });
  const m10 = __spreadProps(__spreadValues({}, e14), { descriptor: WN(Eke, o10), value: a10.DesignerDataFieldVisible, defaultValue: i10.DesignerDataFieldVisible, setProperty: l10("DesignerDataFieldVisible") });
  const h10 = __spreadProps(__spreadValues({}, e14), { descriptor: WN(Fke, o10), value: a10.DesignerTransparency, defaultValue: i10.DesignerTransparency, setProperty: (e15, t11) => {
    sK(n10.Name) || s10(T2({ layerName: a10.Name, propertyName: "DesignerTransparency", value: t11 }));
  } });
  return tp.createElement(tp.Fragment, null, !c10 && tp.createElement(jde, __spreadValues({}, u10)), tp.createElement(Hie, __spreadValues({}, d10)), tp.createElement(Hie, __spreadValues({}, p10)), tp.createElement(Hie, __spreadValues({}, m10)), tp.createElement(Lue, __spreadValues({}, h10)));
};
Mke.displayName = "LayerEditor";
const kke = ({ index: e14, layerNames: t10, lockLayout: n10, layer: r10, dispatch: o10 }) => {
  const a10 = t10[e14];
  const i10 = { disabled: n10 || 0 === e14 || J7(r10), value: a10, defaultValue: "", descriptor: $N("", "", "", `Layers.${e14}.Name`), setProperty: (e15, t11) => {
    t11 !== a10 && o10(M2({ layerName: a10, newLayerName: t11 }));
  } };
  return tp.createElement(Wde, __spreadProps(__spreadValues({}, i10), { occupiedNames: t10 }));
};
kke.displayName = "LayerCollectionEditorItem";
const Pke = (e14) => {
  const { descriptor: t10, disabled: n10 } = e14;
  const { lockLayout: r10 } = Uae();
  const { drillPropertiesPath: o10 } = ep.useContext(Iue);
  const { layers: a10 } = ep.useContext(Cke);
  const { API: i10 } = ep.useContext(Sm);
  const s10 = PA();
  const { t: l10 } = vp("propertyEditors");
  const c10 = a10.map((e15) => e15.Name);
  const u10 = __spreadProps(__spreadValues({}, e14), { disabled: r10 || n10, onSelect: (e15) => {
    o10 && o10(`${t10.valuePath}.${e15}`, l10("propertyEditors:layerCollection.propertiesTitle", "Layer properties: {{layerName}}", { layerName: a10[e15].Name }));
  }, onAdd: () => {
    s10(C2());
  }, onDelete: (e15) => {
    e15 > 0 ? s10(x2({ index: e15 })) : i10.notifications.send({ type: "notification", payload: { level: "warning", caption: l10("notifications:removeDefaultLayer.caption") } });
  }, createEditor: (e15, t11) => tp.createElement(kke, { index: t11, layerNames: c10, dispatch: s10, layer: a10[t11] }), disableItemButtons: (e15) => J7(a10[e15]) });
  return tp.createElement(WSe, __spreadValues({}, u10));
};
Pke.displayName = "LayerCollectionEditor";
const Nke = (e14) => {
  const { layers: t10 } = ep.useContext(Cke);
  const n10 = PA();
  const r10 = __spreadProps(__spreadValues({}, e14), { setProperty: (e15, t11) => n10(E2({ layerName: t11 })), currentEnum: t10.map((e15) => e15.Name) });
  return tp.createElement(tse, __spreadValues({}, r10));
};
Nke.displayName = "LayerNameEditor";
const Dke = _D(Nke);
const Lke = "All", Hke = "Screen", Ike = "Paper", _ke = "Export", Vke = "None";
const Rke = (e14 = false, t10 = false, n10 = false) => ({ screen: e14, paper: t10, export: n10 });
const Ake = (e14) => {
  const t10 = e14.split(",").map((e15) => e15.trim());
  const n10 = (e15, t11) => e15.toLowerCase() === t11.toLowerCase();
  if (1 === t10.length && n10(t10[0], Lke)) return Rke(true, true, true);
  if (1 === t10.length && n10(t10[0], Vke)) return Rke(false, false, false);
  const r10 = (e15) => t10.some((t11) => n10(e15, t11));
  return Rke(r10(Hke), r10(Ike), r10(_ke));
};
const Oke = $N("targetDevice", "propertyDescriptors:labels.layer.targetDevice.all", "boolean", "TargetDevice");
const Bke = $N("targetDevice", "propertyDescriptors:labels.layer.targetDevice.screen", "boolean", "TargetDevice");
const zke = $N("targetDevice", "propertyDescriptors:labels.layer.targetDevice.paper", "boolean", "TargetDevice");
const $ke = $N("targetDevice", "propertyDescriptors:labels.layer.targetDevice.export", "boolean", "TargetDevice");
const Wke = (e14) => {
  const { value: t10, descriptor: n10, defaultValue: r10, setProperty: o10 } = e14;
  const a10 = Ake(t10 || r10);
  const [i10, s10] = ep.useState(a10);
  ep.useEffect(() => {
    s10(Ake(t10 || r10));
  }, [t10, r10]);
  const l10 = (e15) => (t11, r11) => {
    const a11 = (e16) => {
      const t12 = __spreadProps(__spreadValues({}, i10), { [e16]: r11 });
      s10(t12), o10(n10, ((e17) => {
        const { screen: t13, paper: n11, export: r12 } = e17;
        if (t13 && n11 && r12) return Lke;
        if (!t13 && !n11 && !r12) return Vke;
        const o11 = [];
        return t13 && o11.push(Hke), n11 && o11.push(Ike), r12 && o11.push(_ke), o11.join(", ");
      })(t12));
    };
    switch (e15) {
      case Hke:
        return a11("screen");
      case Ike:
        return a11("paper");
      case _ke:
        return a11("export");
    }
    return () => {
    };
  };
  const { screen: c10, paper: u10, export: d10 } = i10;
  const p10 = __spreadProps(__spreadValues({}, e14), { descriptor: WN(Oke, n10.valuePath), setProperty: (e15, t11) => {
    if (t11) return s10(Rke(true, true, true)), void o10(n10, Lke);
    s10(Rke(false, false, false)), o10(n10, Vke);
  }, value: c10 && u10 && d10 });
  const m10 = __spreadProps(__spreadValues({}, e14), { descriptor: WN(Bke, n10.valuePath), value: c10, setProperty: l10(Hke) });
  const h10 = __spreadProps(__spreadValues({}, e14), { descriptor: WN(zke, n10.valuePath), value: u10, setProperty: l10(Ike) });
  const f10 = __spreadProps(__spreadValues({}, e14), { descriptor: WN($ke, n10.valuePath), value: d10, setProperty: l10(_ke) });
  return tp.createElement(tp.Fragment, null, tp.createElement(Hie, __spreadValues({}, p10)), tp.createElement(Hie, __spreadValues({}, m10)), tp.createElement(Hie, __spreadValues({}, h10)), tp.createElement(Hie, __spreadValues({}, f10)));
};
const jke = $N("", "propertyDescriptors:labels.report.level", "enum_expr", "", void 0, { enumKey: "documentmap_numbering_style" });
const Zke = (e14) => {
  const { $masterReportContent: t10 } = h9();
  const { descriptor: n10, value: r10, setProperty: o10 } = e14;
  const { t: a10 } = vp();
  const i10 = __spreadProps(__spreadValues({}, e14), { value: r10 || [], createEditor: (e15, r11) => {
    const i11 = WN(jke, n10.valuePath);
    const s10 = { descriptor: __spreadProps(__spreadValues({}, i11), { valuePath: `${n10.valuePath}.${r11}`, label: `${a10(i11.label)}.${r11}` }), value: e15, setProperty: o10, disabled: !!t10 };
    return tp.createElement(nse, __spreadValues({}, s10));
  }, onAdd: () => o10(n10, AV(r10 || [], { $push: ["Decimal"] })), onDelete: (e15) => o10(n10, AV(r10, { $splice: [[e15, 1]] })) });
  return tp.createElement(Bde, __spreadValues({}, i10));
};
const Gke = _D((e14) => {
  const { namedItems: t10, selectedItemsInfo: n10 } = ep.useContext(Rue);
  const { t: r10 } = vp("propertyEditors");
  const o10 = ep.useMemo(() => function(e15, t11 = []) {
    if (0 === e15.length) return [];
    if (1 !== t11.length) return [];
    const n11 = t11[0];
    const r11 = e15.find((e16) => e16.name === n11.name);
    if (!r11) throw new Error(`The collection index.NamedItems does not contain element named '${n11.name}'`);
    const o11 = e15.filter((e16) => function(e17, t12) {
      const { leftKey: n12 = 0, rightKey: r12 = 0, level: o12 } = e17;
      const { leftKey: a12 = 0, rightKey: i10 = 0, level: s10 } = t12;
      return a12 > n12 && i10 < r12 && s10 === o12 + 1;
    }(r11, e16));
    const a11 = o11.map((e16) => ({ value: e16.name, label: e16.name }));
    return a11;
  }(t10, n10), [t10, n10]);
  const a10 = [{ value: "", label: r10("common.textNone") }, ...o10];
  return tp.createElement(tse, __spreadProps(__spreadValues({}, e14), { currentEnum: a10 }));
});
const Uke = (e14) => {
  var _a2;
  return (_a2 = qY[e14]) != null ? _a2 : qY.in;
};
const qke = (e14) => e14.reduce((e15, t10) => t10.greaterThan(e15) ? t10 : e15, e14[0]);
const Yke = (e14) => e14.map((e15) => L$.parse(e15));
const Kke = (e14) => e14.map((e15) => e15.css);
const Xke = (e14) => e14.greaterThan(L$.zero);
const Jke = (e14, t10, n10, r10, o10) => ({ name: e14, label: t10, cur: n10, exp: r10, res: o10 });
const Qke = (e14, t10, n10) => {
  const { makeCaption: r10, makeMessage: o10 } = n10;
  const a10 = {};
  let i10 = false;
  const s10 = t10.reduce((e15, t11) => {
    const { name: n11, label: r11, cur: s11, exp: l10, res: c10 } = t11;
    return c10 !== s11 && (a10[n11] = { $set: c10 }, i10 = true), c10 !== l10 && e15.push(o10(r11, c10)), e15;
  }, []);
  if (s10.length) throw ePe(r10(), s10);
  return i10 ? AV(e14, { Page: a10 }) : e14;
};
const ePe = (e14, t10) => B0(e14, t10.join("\n"));
const tPe = { makeCaption: () => hG().t("warning:margins.caption", "The specified margins cannot be set"), makeMessage: (e14, t10) => hG().t("warning:margins.info", "- '{{name}}' cannot be greater than {{value}}.", { name: hG().t(`warning:margins.labels.${e14}`), value: t10 }) };
const nPe = (e14, t10) => ({ a: e14, b: t10 });
const rPe = (e14, t10, n10) => {
  const { a: r10, b: o10 } = e14;
  const { a: a10, b: i10 } = t10;
  const s10 = r10.add(o10).subtract(n10);
  if (!Xke(s10)) return e14;
  const [l10, c10] = [r10.subtract(a10), o10.subtract(i10)];
  const u10 = l10.add(c10);
  if (!Xke(u10)) return e14;
  const [d10, p10] = [l10, c10].map(Xke);
  let m10 = 0;
  d10 && p10 ? m10 = l10.divide(u10) : d10 && (m10 = 1);
  const h10 = s10.multiply(m10);
  const f10 = s10.subtract(h10);
  const [g10, y10] = [r10.subtract(h10), o10.subtract(f10)];
  return nPe(g10, y10);
};
const oPe = (e14, t10, n10) => {
  const { LeftMargin: r10, TopMargin: o10, RightMargin: a10, BottomMargin: i10 } = e14.Page;
  const { left: s10, top: l10, right: c10, bottom: u10 } = t10;
  const { width: d10, height: p10 } = n10;
  const [m10, h10, f10, g10] = Yke([r10, o10, a10, i10]);
  const [y10, v10, b10, S10] = [s10 || r10, l10 || o10, c10 || a10, u10 || i10];
  const [C10, x10, w10, T10] = Yke([y10, v10, b10, S10]);
  const { a: E10, b: F10 } = rPe(nPe(C10, w10), nPe(m10, f10), d10);
  const { a: M10, b: k10 } = rPe(nPe(x10, T10), nPe(h10, g10), p10);
  const [P10, N10, D10, L10] = Kke([E10, M10, F10, k10]);
  return Qke(e14, [Jke("LeftMargin", "left", r10, y10, P10), Jke("TopMargin", "top", o10, v10, N10), Jke("RightMargin", "right", a10, b10, D10), Jke("BottomMargin", "bottom", i10, S10, L10)], tPe);
};
const aPe = (e14) => Y$(e14) ? X$(e14) ? null : e14.$fixedPlace.Width : null;
const iPe = (e14) => Y$(e14) ? K$(e14) ? null : e14.$fixedPlace.Height : null;
const sPe = (e14, t10) => {
  const n10 = ((e15) => {
    const t11 = (e15.ReportItems || []).reduce((e16, t12) => {
      const [n11, r10] = [aPe(t12), iPe(t12)];
      const [o10, a10, i10, s10] = Yke([t12.$place.Left, t12.$place.Top, n11 || t12.$place.Width, r10 || t12.$place.Height]);
      const [l10, c10] = [o10.add(i10), a10.add(s10)];
      return { width: qke([l10, e16.width]), height: qke([c10, e16.height]) };
    }, { width: L$.zero, height: L$.zero });
    return t11;
  })(t10);
  return { width: qke([n10.width, e14.width]), height: qke([n10.height, e14.height]) };
};
const lPe = (e14) => {
  const t10 = (e14.Pages || []).reduce((e15, t11) => sPe(e15, t11), { width: L$.zero, height: L$.zero });
  return t10;
};
const cPe = { makeCaption: () => hG().t("warning:pageSize.caption", "The specified page size cannot be set"), makeMessage: (e14, t10) => hG().t("warning:pageSize.info", "- '{{name}}' cannot be less than {{value}}.", { name: hG().t(`warning:pageSize.labels.${e14}`), value: t10 }) };
const uPe = (e14, t10, n10) => {
  const { PageWidth: r10, PageHeight: o10 } = e14.Page;
  const { width: a10, height: i10 } = t10;
  const { width: s10, height: l10 } = n10;
  const [c10, u10] = [a10 || r10, i10 || o10];
  const [d10, p10] = Yke([c10, u10]);
  const [m10, h10] = [[d10, s10], [p10, l10]].map(qke);
  const [f10, g10] = Kke([m10, h10]);
  return Qke(e14, [Jke("PageWidth", "width", r10, c10, f10), Jke("PageHeight", "height", o10, u10, g10)], cPe);
};
const dPe = (e14, t10) => ({ LeftMargin: e14.LeftMargin || t10.LeftMargin, TopMargin: e14.TopMargin || t10.TopMargin, RightMargin: e14.RightMargin || t10.RightMargin, BottomMargin: e14.BottomMargin || t10.BottomMargin });
const pPe = (e14) => `margins.${e14}`;
const mPe = Zq(uY, "report.marginsStyle", "enum", "");
const hPe = Zq(uY, "report.marginsSizes", "margins", "");
const fPe = ["LeftMargin", "TopMargin", "RightMargin", "BottomMargin"];
const gPe = [Zq(uY, pPe("left"), "length", "LeftMargin"), Zq(uY, pPe("top"), "length", "TopMargin"), Zq(uY, pPe("right"), "length", "RightMargin"), Zq(uY, pPe("bottom"), "length", "BottomMargin")];
const yPe = (e14) => ({ LeftMargin: L$.parse(e14.left), TopMargin: L$.parse(e14.top), RightMargin: L$.parse(e14.right), BottomMargin: L$.parse(e14.bottom) });
const vPe = (e14) => (e14("marginsSizes:values", { returnObjects: true }) || []).filter((e15) => [...Object.values(e15.cm), ...Object.values(e15.in)].every((e16) => L$.isValidString(e16))).map((e15) => {
  return t10 = e15._name, n10 = yPe(e15.in), r10 = yPe(e15.cm), { name: t10, in: n10, cm: r10 };
  var t10, n10, r10;
});
const bPe = (e14) => {
  const { userPreferences: { units: t10 }, lockLayout: n10 } = Uae();
  const { setProperties: r10 } = ep.useContext(Iue);
  const { Page: o10 } = h9();
  const { t: a10 } = vp();
  const { value: i10, descriptor: s10, setProperty: l10, disabled: c10 } = e14;
  const u10 = dPe(i10, o10);
  const d10 = ep.useCallback((e15, n11) => {
    const o11 = vPe(a10).find((e16) => e16.name === n11);
    if (!o11) throw new Error();
    const i11 = gPe.map((n12) => ({ descriptor: WN(n12, e15.valuePath), value: o11[t10][n12.valuePath].css }));
    r10(i11);
  }, [r10, a10, t10]);
  const p10 = ((e15, t11, n11) => {
    const r11 = vPe(t11).find((t12) => fPe.every((r12) => t12[n11][r12].equal(L$.parse(e15[r12]))));
    const o11 = t11("propertyEditors:marginsSizes.custom", "(Custom)");
    return r11 && r11.name || o11;
  })(u10, a10, t10);
  const m10 = WN(mPe, s10.valuePath);
  const h10 = __spreadProps(__spreadValues({}, e14), { disabled: n10 || c10, descriptor: m10, value: p10, currentEnum: vPe(a10).map((e15) => e15.name), setProperty: d10, t: a10 });
  return tp.createElement(tp.Fragment, null, tp.createElement(nse, __spreadValues({}, h10)), ((t11) => {
    const n11 = WN(hPe, s10.valuePath);
    const r11 = ((...e15) => {
      const t12 = e15.every((t13) => t13 === e15[0]);
      return t12 ? e15[0] : e15.join(" ");
    })(u10.LeftMargin, u10.TopMargin, u10.RightMargin, u10.BottomMargin);
    if (t11) {
      const t12 = __spreadProps(__spreadValues({}, e14), { disabled: true, descriptor: n11, value: r11 });
      return tp.createElement(Sse, __spreadValues(__spreadValues({}, e14), t12));
    }
    const o11 = __spreadProps(__spreadValues({}, e14), { value: u10, descriptor: n11, nestedDescriptors: gPe, setProperty: l10 });
    return tp.createElement(Cse, __spreadValues({}, o11));
  })(n10));
};
bPe.displayName = "MarginsEditor";
const SPe = (e14) => {
  const { value: t10, placeholderEmpty: n10, placeholder: r10 } = e14;
  const { t: o10 } = vp();
  const { rdlx: { masterReports: { items: a10 } } } = d9();
  const [i10, s10] = ep.useState(t10);
  ep.useEffect(() => {
    var _a2, _b2, _c2;
    s10((_c2 = (_b2 = (_a2 = a10.find((e15) => e15.id === t10)) == null ? void 0 : _a2.name) != null ? _b2 : t10) != null ? _c2 : "");
  }, [t10, a10]);
  const l10 = { value: i10, disabled: true, placeholder: r10, placeholderEmpty: n10 || _ie(o10) };
  return tp.createElement(UD, __spreadValues({}, l10));
};
SPe.displayName = "MasterReportEditor";
const CPe = _D(SPe);
const xPe = (e14 = "", t10, n10) => {
  let r10 = false;
  return Jc.forEach(e14, /\.ReportItems\.\d+/, (o10) => {
    if (r10) return;
    const a10 = t10.find((t11) => t11.$path === e14.substring(0, o10.index).concat(o10[0]));
    r10 = a10 && ((e15) => !!eK.of(n10).isDataRegion(e15))(a10.type) || false;
  }), r10;
};
const wPe = (e14, t10, n10) => {
  const r10 = e14.map((e15) => e15.overflowName).filter(Boolean);
  return e14.filter((e15) => e15.type && "overflowplaceholder" === e15.type.toLowerCase()).filter((o10) => !((e15) => t10.some((t11) => t11.name === e15.name))(o10) && !r10.includes(o10.name) && !xPe(o10.$path, e14, n10)).map((e15) => ({ value: e15.name, label: e15.name }));
};
const TPe = _D((e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { namedItems: n10, selectedItemsInfo: r10 } = ep.useContext(Rue);
  const { instanceId: o10 } = Uae();
  const a10 = [{ value: "", label: t10("common.textNone") }];
  const i10 = ep.useMemo(() => wPe(n10, r10, o10), [o10, n10, r10]);
  return 1 === r10.length && a10.push(...i10), tp.createElement(tse, __spreadProps(__spreadValues({}, e14), { currentEnum: a10 }));
});
const EPe = (e14) => `padding.${e14}`;
const FPe = { unit: "pt" };
const MPe = [Zq(cY, EPe("left"), "length_expr", "PaddingLeft", void 0, FPe), Zq(cY, EPe("top"), "length_expr", "PaddingTop", void 0, FPe), Zq(cY, EPe("right"), "length_expr", "PaddingRight", void 0, FPe), Zq(cY, EPe("bottom"), "length_expr", "PaddingBottom", void 0, FPe)];
const kPe = (e14) => {
  const { descriptor: t10 } = e14;
  const n10 = __spreadProps(__spreadValues({}, e14), { nestedDescriptors: MPe.map((e15) => __spreadProps(__spreadValues({}, e15), { category: t10.category || e15.category, meta: __spreadProps(__spreadValues({}, e15.meta), { parentLabel: t10.label }) })) });
  return tp.createElement(Che, __spreadValues({}, n10));
};
const PPe = (e14, t10, n10, r10, o10, a10) => {
  const { Width: i10, Height: s10 } = e14;
  const { Width: l10, Height: c10 } = t10;
  const u10 = { width: L$.zero, height: L$.zero };
  const { BottomMargin: d10, LeftMargin: p10, RightMargin: m10, TopMargin: h10 } = dPe(e14, n10);
  const f10 = sPe(u10, e14);
  const g10 = Uke(a10);
  const y10 = { width: qke([f10.width, g10]), height: qke([f10.height, g10]) };
  const v10 = { width: L$.parse(p10).add(L$.parse(m10)).add(y10.width), height: L$.parse(h10).add(L$.parse(d10)).add(y10.height) };
  const { width: b10, height: S10 } = v10;
  const [C10, x10] = [l10 || i10, c10 || s10];
  const [w10, T10] = Yke([C10, x10]);
  const [E10, F10] = [[w10, b10], [T10, S10]].map(qke);
  const [M10, k10] = Kke([E10, F10]);
  return NPe([Jke("Width", "width", i10 || "", C10, M10), Jke("Height", "height", s10 || "", x10, k10)], r10, o10);
};
const NPe = (e14, t10, n10) => {
  const { makeCaption: r10, makeMessage: o10 } = t10;
  const a10 = {};
  const i10 = e14.reduce((e15, t11) => {
    const { name: n11, label: r11, cur: i11, exp: s10, res: l10 } = t11;
    return l10 !== i11 && (a10[n11] = l10), l10 !== s10 && (a10[n11] = i11, e15.push(o10(r11, l10))), e15;
  }, []);
  return i10.length && DPe(r10(), i10, n10), a10;
};
const DPe = (e14, t10, n10) => {
  var _a2;
  const r10 = t10.join("\n");
  (_a2 = hm.of(n10)) == null ? void 0 : _a2.notifications.send({ type: "notification", payload: { level: "warning", caption: e14, content: r10 } });
};
const LPe = (e14, t10) => ({ descriptor: e14, value: t10 });
const HPe = (e14, t10) => ({ width: L$.parse(e14), height: L$.parse(t10) });
function IPe(e14) {
  let t10 = null;
  return (n10) => (null !== t10 || (t10 = e14(n10)), t10);
}
const _Pe = IPe((e14) => (e14("pageSizes:values", { returnObjects: true }) || []).filter((e15) => [e15.in.width, e15.in.height, e15.cm.width, e15.cm.height].every((e16) => L$.isValidString(e16))).map((e15) => {
  return t10 = e15._name, n10 = HPe(e15.in.width, e15.in.height), r10 = HPe(e15.cm.width, e15.cm.height), { name: t10, in: n10, cm: r10 };
  var t10, n10, r10;
}));
const VPe = IPe((e14) => _Pe(e14).map((e15) => e15.name));
const RPe = (e14, t10, n10, r10) => e14.equal(n10) && t10.equal(r10) || e14.equal(r10) && t10.equal(n10);
const APe = (e14) => {
  const { value: t10, defaultValue: n10, disabled: r10, compactMode: o10, setProperty: a10, setOrientation: i10, setWidth: s10, setHeight: l10, descriptors: c10, autoPageHeight: u10 } = e14;
  const { setProperties: d10 } = ep.useContext(Iue);
  const { userPreferences: { units: p10 }, lockLayout: m10 } = MO();
  const { t: h10 } = vp("propertyEditors");
  const f10 = u10 ? h10("pageSize.custom") : function(e15, t11, n11, r11) {
    const o11 = r11("pageSize.custom");
    const a11 = L$.parse(e15);
    const i11 = L$.parse(t11);
    if (a11.lowerThan(i11) && "Landscape" === n11) return o11;
    if (a11.greaterThan(i11) && "Portrait" === n11) return o11;
    const s11 = _Pe(r11).find((e16) => RPe(e16.in.width, e16.in.height, a11, i11) || RPe(e16.cm.width, e16.cm.height, a11, i11));
    return s11 && s11.name || o11;
  }(t10.width, t10.height, t10.orientation, h10);
  const g10 = __spreadProps(__spreadValues({}, e14), { setProperty: (e15, n11) => {
    const r11 = _Pe(h10).find((e16) => e16.name === n11);
    if (!r11) throw new Error(`PageSize ${t10} not found`);
    const o11 = r11[p10];
    const { orientation: a11 } = t10;
    const i11 = "Portrait" === a11;
    const s11 = i11 ? o11.width : o11.height;
    const l11 = i11 ? o11.height : o11.width;
    const u11 = [LPe(c10.width, s11.css), LPe(c10.height, l11.css)];
    d10(u11);
  }, disabled: m10 || r10, descriptor: c10.size, value: f10, currentEnum: VPe(h10) });
  const y10 = __spreadProps(__spreadValues({}, e14), { setProperty: i10 || ((e15, n11) => {
    const { width: r11, height: o11, orientation: a11 } = t10;
    if (n11 === a11) return;
    const i11 = [LPe(c10.orientation, n11), LPe(c10.height, r11), LPe(c10.width, o11)];
    d10(i11);
  }), disabled: m10 || u10 || r10, descriptor: c10.orientation, value: t10.orientation, defaultValue: n10.PageOrientation });
  const v10 = __spreadProps(__spreadValues({}, e14), { disabled: m10 || r10, descriptor: c10.width, value: t10.width, defaultValue: n10.PageWidth, setProperty: s10 || a10 });
  const b10 = __spreadProps(__spreadValues({}, e14), { disabled: m10 || r10, descriptor: c10.height, value: u10 ? "Auto" : t10.height, defaultValue: n10.PageHeight, setProperty: l10 || a10 });
  return tp.createElement(tp.Fragment, null, tp.createElement(nse, __spreadValues({ key: "page-size" }, g10)), tp.createElement(nse, __spreadValues({ key: "page-orientation" }, y10)), !o10 && [tp.createElement(pse, __spreadValues({ key: "page-width" }, v10)), tp.createElement(pse, __spreadValues({ key: "page-height" }, b10))]);
};
APe.displayName = "PageSizeEditor";
const OPe = (e14, t10) => ({ descriptor: e14, value: t10 });
const BPe = { width: Zq(oY, "dimensions.width", "length", "Width"), height: Zq(oY, "dimensions.height", "length", "Height"), orientation: Zq(oY, "fplPage.orientation", "page_orientation", "PaperOrientation"), size: Zq(oY, "fplPage.size", "page_size", "") };
const zPe = (e14) => {
  var _a2, _b2;
  const { value: t10, descriptor: n10, descriptor: { valuePath: r10 }, setProperty: o10 } = e14;
  const a10 = (_b2 = (_a2 = n10.meta) == null ? void 0 : _a2.compactMode) != null ? _b2 : false;
  const { setProperties: i10 } = ep.useContext(Iue);
  const { Page: s10 } = h9();
  const { instanceId: l10, userPreferences: { units: c10 } } = Uae();
  const { t: u10 } = vp();
  const d10 = ep.useMemo(() => ({ width: WN(BPe.width, r10), height: WN(BPe.height, r10), orientation: WN(BPe.orientation, r10), size: WN(BPe.size, r10) }), [r10]);
  const p10 = t10.Width || s10.PageWidth;
  const m10 = t10.Height || s10.PageHeight;
  const h10 = t10.PaperOrientation;
  const f10 = ep.useMemo(() => ({ width: p10, height: m10, orientation: h10 }), [m10, p10, h10]);
  const g10 = ep.useCallback((e15, t11) => {
    const { width: n11, height: r11, orientation: o11 } = f10;
    if (t11 === o11) return;
    const a11 = [OPe(d10.height, n11), OPe(d10.width, r11), OPe(d10.orientation, t11)];
    i10(a11);
  }, [d10.height, d10.orientation, d10.width, i10, f10]);
  const y10 = (e15, n11) => {
    const r11 = { makeCaption: () => u10("warning:pageSize.caption"), makeMessage: (e16, t11) => u10("warning:pageSize.info", { name: u10(`warning:pageSize.labels.${e16}`), value: t11 }) };
    if (t10.Width) {
      const a11 = __spreadProps(__spreadValues({}, t10), { [e15.valuePath]: n11 });
      const i11 = PPe(t10, a11, s10, r11, l10, c10);
      o10(e15, i11[e15.valuePath]);
    } else {
      const o11 = { Width: f10.width, Height: f10.height };
      const a11 = __spreadProps(__spreadValues({}, o11), { [e15.valuePath]: n11 });
      const u11 = __spreadValues(__spreadValues({}, t10), o11);
      const p11 = PPe(u11, a11, s10, r11, l10, c10);
      i10([OPe(d10.height, p11.Height || o11.Height), OPe(d10.width, p11.Width || o11.Width)]);
    }
  };
  const v10 = __spreadProps(__spreadValues({}, e14), { descriptors: d10, compactMode: a10, value: f10, setOrientation: g10, setHeight: y10, setWidth: y10 });
  return tp.createElement(APe, __spreadValues({}, v10));
};
zPe.displayName = "FplPageSizeEditor";
const $Pe = (e14) => `report.${e14}`;
const WPe = (e14, t10) => ({ descriptor: e14, value: t10 });
const jPe = (e14) => {
  var _a2, _b2;
  const { value: t10, descriptor: n10 } = e14;
  const r10 = (_b2 = (_a2 = n10.meta) == null ? void 0 : _a2.compactMode) != null ? _b2 : false;
  const { setProperties: o10 } = ep.useContext(Iue);
  const a10 = PA();
  const { Page: i10 } = h9();
  const s10 = ep.useMemo(() => n10.valuePath ? (e15) => `${n10.valuePath}.${e15}` : (e15) => e15, [n10.valuePath]);
  const l10 = ep.useMemo(() => ({ width: Zq(mY, $Pe("pageWidth"), "length", s10("PageWidth"), void 0, { minValueMap: qY }), height: Zq(mY, $Pe("pageHeight"), "length", s10("PageHeight"), void 0, { allowAutoValue: true, minValue: L$.parse("0in") }), orientation: Zq(mY, $Pe("pageOrientation"), "page_orientation", s10("PaperOrientation")), size: Zq(mY, $Pe("pageSize"), "page_size", "") }), [s10]);
  const c10 = t10.PageWidth || i10.PageWidth;
  const u10 = t10.PageHeight || i10.PageHeight;
  const d10 = t10.PaperOrientation;
  const p10 = ep.useMemo(() => ({ width: c10, height: u10, orientation: d10 }), [u10, d10, c10]);
  const m10 = ep.useCallback((e15, t11) => {
    const { width: n11, height: r11, orientation: a11 } = p10;
    if (t11 === a11) return;
    const i11 = [WPe(l10.height, n11), WPe(l10.width, r11), WPe(l10.orientation, t11)];
    o10(i11);
  }, [l10.height, l10.orientation, l10.width, o10, p10]);
  const h10 = __spreadProps(__spreadValues({}, e14), { descriptors: l10, compactMode: r10, value: p10, autoPageHeight: t10.$autoPageHeight, setOrientation: m10, setHeight: (e15, t11) => {
    a10(_2(t11));
  } });
  return tp.createElement(APe, __spreadValues({}, h10));
};
jPe.displayName = "MslPageSizeEditor";
const ZPe = $N("", "propertyDescriptors:labels.dvchart.palette", "dvchart_palette_type", "Palette");
const GPe = $N("", "propertyDescriptors:labels.dvchart.customPaletteColors", "color_expr_collection", "CustomPalette");
const UPe = $N("", "", "", "CustomPaletteInfo");
const qPe = (e14 = "", t10 = "") => ({ PaletteId: e14, PaletteName: t10 });
const YPe = _D((e14) => {
  const { instanceId: t10 } = Uae();
  const { t: n10 } = vp();
  const { descriptor: r10, value: o10, setProperty: a10, disabled: i10, reportStyles: s10 } = e14;
  const { theme: l10 } = ep.useContext(Aue);
  const c10 = l10 && !l10.$isFallback;
  const u10 = ep.useMemo(() => ((e15, t11, n11, r11) => {
    const o11 = [{ type: "button", text: r11("propertyEditors:palette.customPaletteLabel"), value: "Custom" }];
    return e15 && o11.push({ type: "header", header: r11("propertyEditors:palette.extraPalettesHeader") }, ...Pj(t11).map((e16) => ({ type: "button", text: e16.name, value: e16.id }))), o11.push({ type: "header", header: r11("propertyEditors:palette.standardPalettesHeader") }, ...OO("dvchart_palette", r11).filter((e16) => "Custom" !== e16.value).map((e16) => ({ type: "button", text: e16.label, value: e16.value }))), o11;
  })(!!c10, s10, 0, n10), [s10, n10, c10]);
  const d10 = { value: sK(o10) ? "" : o10, items: u10, onSelect: (e15) => a10(r10, e15), disabled: i10, size: "small", menuMaxHeight: 300, placeholder: Vie(sK(o10), n10) };
  return tp.createElement(tM, __spreadValues({}, d10));
});
const KPe = (e14) => {
  var _a2;
  const { descriptor: { valuePath: t10 }, value: n10 } = e14;
  const { rdlx: { reportStyles: r10 } } = d9();
  const { instanceId: o10 } = Uae();
  const { setProperties: a10 } = ep.useContext(Iue);
  const { t: i10 } = vp();
  const s10 = (_a2 = n10 == null ? void 0 : n10.CustomPaletteInfo) == null ? void 0 : _a2.PaletteId;
  const l10 = s10 && Pj(r10).find((e15) => e15.id === s10 && !!e15.name) || null;
  const c10 = n10.CustomPalette && "Custom" === n10.Palette && !l10;
  const u10 = ep.useMemo(() => ({ paletteType: WN(ZPe, t10), customPaletteColors: WN(GPe, t10), customPaletteInfo: WN(UPe, t10) }), [t10]);
  const d10 = ep.useCallback((e15, t11) => {
    if (VO("dvchart_palette").includes(t11)) return void a10([{ descriptor: u10.paletteType, value: t11 }, { descriptor: u10.customPaletteColors, value: [] }, { descriptor: u10.customPaletteInfo, value: qPe() }]);
    const n11 = Pj(r10);
    const o11 = n11.find((e16) => e16.id === t11);
    o11 && a10([{ descriptor: u10.paletteType, value: "Custom" }, { descriptor: u10.customPaletteColors, value: Nj(o11.id, n11) }, { descriptor: u10.customPaletteInfo, value: qPe(o11.id, o11.name) }]);
  }, [o10, u10.customPaletteColors, u10.customPaletteInfo, u10.paletteType, r10, a10]);
  const p10 = __spreadProps(__spreadValues({}, e14), { value: "Custom" === n10.Palette ? sK(s10) ? s10 : l10 ? l10.name : RO("dvchart_palette", "Custom", i10) : sK(n10.Palette) ? n10.Palette : RO("dvchart_palette", n10.Palette, i10), descriptor: u10.paletteType, reportStyles: r10, setProperty: d10 });
  return tp.createElement(tp.Fragment, null, tp.createElement(YPe, __spreadValues({}, p10)), c10 && ((e15, t11) => {
    const { value: n11 } = t11;
    const r11 = __spreadProps(__spreadValues({}, t11), { descriptor: e15, value: n11.CustomPalette });
    return tp.createElement(phe, __spreadValues({}, r11));
  })(u10.customPaletteColors, e14));
};
KPe.displayName = "PaletteEditor";
const [XPe, , JPe] = Dp("wd-parameter-valid-value-collection");
const [QPe] = JPe("element");
const eNe = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { descriptor: n10, descriptor: { meta: r10 }, value: o10, setProperty: a10 } = e14;
  const { API: i10 } = ep.useContext(Sm);
  const s10 = { descriptor: n10, value: o10 || [], reordering: { type: "drag" }, createEditor: (e15, r11) => {
    const o11 = { descriptor: $N(t10(n10.category), Ude("value"), "string_expr", `${n10.valuePath}.${r11}.Value`, void 0, { disableDataFields: true, parentLabel: n10.label }), value: e15.Value, defaultValue: "", placeholderEmpty: t10("reportParameter.placeholderValue"), setProperty: a10 };
    const i11 = { descriptor: $N(t10(n10.category), Ude("label"), "string_expr", `${n10.valuePath}.${r11}.Label`, void 0, { disableDataFields: true, parentLabel: n10.label }), value: e15.Label, defaultValue: "", placeholderEmpty: t10("reportParameter.placeholderLabel"), setProperty: a10 };
    return tp.createElement("div", { className: XPe }, tp.createElement("div", { className: QPe }, tp.createElement(Lpe, __spreadValues({}, o11))), tp.createElement("div", { className: QPe }, tp.createElement(Lpe, __spreadValues({}, i11))));
  }, onAdd: () => {
    a10(n10, AV(o10 || [], { $push: [{ Label: "", Value: "" }] }));
  }, onDelete: (e15) => {
    (r10 == null ? void 0 : r10.isBound) && 1 === (o10 == null ? void 0 : o10.length) ? i10.notifications.send({ type: "notification", payload: { level: "warning", caption: t10("notifications:removeLastValidValue.caption") } }) : a10(n10, AV(o10, { $splice: [[e15, 1]] }));
  }, setProperty: a10 };
  return tp.createElement(Bde, __spreadValues({}, s10));
};
eNe.displayName = "ParameterValuesCollectionEditor";
const [, , tNe] = Dp("wd-parameter-order");
const [nNe] = tNe("label");
const [rNe] = tNe("button");
const oNe = Zq("", "", "enum", "Condition", void 0, { enumKey: "order_by_condition" });
const aNe = Zq("", "", "string", "Direction");
const iNe = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { descriptor: { valuePath: n10, label: r10 }, value: o10, defaultValue: a10, setProperty: i10, disabled: s10 } = e14;
  const { setProperties: l10 } = ep.useContext(Iue);
  const c10 = rf(Vh);
  const u10 = rf(Vh, { rotate: "180" });
  const d10 = ep.useMemo(() => ({ vConditionDescriptor: WN(oNe, n10), vDirectionDescriptor: WN(aNe, n10) }), [n10]);
  const p10 = { block: true, position: "left", size: "small", disabled: s10, customCSS: nNe };
  const m10 = { descriptor: d10.vConditionDescriptor, value: o10 && o10.Condition, defaultValue: a10 && a10.Condition, setProperty: (e15, t11) => {
    "None" !== t11 ? i10(e15, t11) : l10([{ descriptor: d10.vConditionDescriptor, value: t11 }, { descriptor: d10.vDirectionDescriptor, value: a10.Direction }]);
  }, disabled: s10 };
  const h10 = ep.useCallback(() => {
    const e15 = "Ascending" === o10.Direction ? "Descending" : "Ascending";
    i10(d10.vDirectionDescriptor, e15);
  }, [d10.vDirectionDescriptor, i10, o10.Direction]);
  const f10 = ep.useMemo(() => "Ascending" === o10.Direction, [o10.Direction]);
  const g10 = { background: "transparent", icon: f10 ? c10 : u10, size: "small", onClick: h10, accent: "icon", block: false, customCSS: rNe, width: "fit-content", disabled: s10, title: f10 ? t10("parameterValuesOrder.ascending", "Ascending") : t10("parameterValuesOrder.descending", "Descending"), dataAid: "parameter-order-direction" };
  return tp.createElement(AN, __spreadProps(__spreadValues({}, p10), { label: t10(r10) }), tp.createElement(tse, __spreadValues({}, m10)), "None" !== o10.Condition && tp.createElement(qm, __spreadValues({}, g10)));
};
const [sNe] = Dp("wd-parameter-valid-value-reference");
const lNe = $N("", Ude("dataSetName"), "dataset_name", "DataSetName");
const cNe = $N("availableValues", Ude("valueField"), "valid_parameter_dataset_fields", "ValueField");
const uNe = $N("availableValues", Ude("labelField"), "valid_parameter_dataset_fields", "LabelField");
const dNe = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { descriptor: { valuePath: n10 }, value: r10, defaultValue: o10, setProperty: a10, disabled: i10 } = e14;
  const { setProperties: s10 } = ep.useContext(Iue);
  const { editExpression: l10, dataSets: c10, dataSources: u10, semanticInfo: d10 } = ep.useContext(Vue);
  const p10 = ep.useContext(qde);
  const m10 = ep.useMemo(() => ({ dataSetName: WN(lNe, n10), vValue: WN(cNe, n10), vLabel: WN(uNe, n10) }), [n10]);
  const h10 = { menuMaxHeight: 300, size: "small", disabled: i10 };
  const f10 = { block: true, position: "left", size: "small", disabled: i10 };
  const g10 = b$(u10[0]);
  const y10 = p10[lNe.type];
  const v10 = __spreadProps(__spreadValues({}, h10), { text: r10.DataSetName || t10("reportParameter.placeholderEmpty"), placeholderText: !r10.DataSetName, items: [...y10.map((e15) => ({ type: "button", text: e15, value: e15 }))], onSelect: (e15) => {
    r10 && r10.DataSetName !== e15 && s10([{ descriptor: m10.dataSetName, value: e15 }, { descriptor: m10.vValue, value: o10 && o10.ValueField || "" }, { descriptor: m10.vLabel, value: o10 && o10.LabelField || "" }]);
  } });
  const b10 = __spreadProps(__spreadValues({}, h10), { text: r10.ValueField || t10("reportParameter.placeholderEmpty"), placeholderText: !r10.ValueField, onSelect: (e15) => {
    a10(m10.vValue, e15);
  } });
  const S10 = __spreadProps(__spreadValues({}, h10), { text: r10.LabelField || t10("reportParameter.placeholderEmpty"), placeholderText: !r10.LabelField, onSelect: (e15) => {
    a10(m10.vLabel, e15);
  } });
  if (g10 && d10) {
    const { semanticModel: e15, showAggregates: t11, showCalculatedFields: n11, allowRebalancing: r11 } = d10;
    const o11 = { dataSets: c10.filter((e16) => p10.valid_value_data_scope.dataSetName === e16.Name), withReset: true, editExpression: l10, setProperty: a10, allowRebalancing: r11, showAggregates: t11, showCalculatedFields: n11, isExpression: false, semanticModel: e15, selectedItemTypes: [] };
    b10.content = tp.createElement(Ede, __spreadProps(__spreadValues({}, o11), { descriptor: m10.vValue })), S10.content = tp.createElement(Ede, __spreadProps(__spreadValues({}, o11), { descriptor: m10.vLabel }));
  } else {
    const e15 = p10[cNe.type];
    const t11 = p10[uNe.type];
    b10.items = [...e15.map((e16) => ({ type: "button", text: e16, value: e16 }))], S10.items = [...t11.map((e16) => ({ type: "button", text: e16, value: e16 }))];
  }
  return tp.createElement("div", { className: sNe }, tp.createElement(AN, __spreadProps(__spreadValues({}, f10), { label: t10(m10.dataSetName.label) }), tp.createElement(UF, __spreadValues({}, v10))), tp.createElement(AN, __spreadProps(__spreadValues({}, f10), { label: t10(m10.vValue.label) }), tp.createElement(UF, __spreadValues({}, b10))), tp.createElement(AN, __spreadProps(__spreadValues({}, f10), { label: t10(m10.vLabel.label) }), tp.createElement(UF, __spreadValues({}, S10))));
};
dNe.displayName = "ValidValueDataSetReference";
const [, , pNe] = Dp("wd-parameter-valid-value");
const [mNe] = pNe("checklist-item");
const hNe = Zq("availableValues", "reportParameter.parameterValues", "string", "ParameterValues");
const fNe = Zq("availableValues", "", "string", "DataSetReference");
const gNe = Zq("", "reportParameter.orderBy", "string", "OrderBy");
const yNe = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { descriptor: { meta: n10, valuePath: r10 }, value: o10, defaultValue: a10, setProperty: i10 } = e14;
  const [s10, l10] = ep.useState(!o10 || 0 === o10.ParameterValues.length);
  const c10 = n10 == null ? void 0 : n10.disabled;
  const u10 = !!(n10 == null ? void 0 : n10.boundEditorType);
  const d10 = ep.useMemo(() => ({ vParameterValuesDescriptor: WN(hNe, r10), vDataSetReferenceDescriptor: WN(fNe, r10), vOrderByDescriptor: WN(gNe, r10) }), [r10]);
  const p10 = { descriptor: d10.vDataSetReferenceDescriptor, value: o10 && o10.DataSetReference, defaultValue: a10 && a10.DataSetReference, setProperty: i10, disabled: c10 };
  const m10 = { descriptor: d10.vOrderByDescriptor, value: o10 && o10.OrderBy, defaultValue: a10 && a10.OrderBy, setProperty: i10, disabled: c10 };
  const h10 = { descriptor: __spreadProps(__spreadValues({}, d10.vParameterValuesDescriptor), { meta: { isBound: u10 } }), value: o10 && o10.ParameterValues, defaultValue: a10 && a10.ParameterValues, setProperty: i10, disabled: c10 };
  const f10 = { label: t10("reportParameter.labelSource"), position: "left", block: true, size: "small", disabled: c10 || u10 };
  const g10 = { block: true, onChange: () => {
    if (s10) {
      (o10.DataSetReference.DataSetName !== a10.DataSetReference.DataSetName || o10.DataSetReference.ValueField !== a10.DataSetReference.ValueField) && i10(d10.vDataSetReferenceDescriptor, __spreadValues({}, a10.DataSetReference));
    } else o10.ParameterValues.length > 0 && i10(d10.vParameterValuesDescriptor, []);
    l10(!s10);
  }, value: "", customCSS: mNe };
  const y10 = { type: "radios", size: "small", items: [__spreadProps(__spreadValues({}, g10), { text: t10("reportParameter.labelFromQuery"), checked: s10 }), __spreadProps(__spreadValues({}, g10), { text: t10("reportParameter.labelNonQueried"), checked: !s10 })], layout: { direction: "horizontal", columns: 2 }, disabled: c10 || u10 };
  return tp.createElement(tp.Fragment, null, tp.createElement(AN, __spreadValues({}, f10), tp.createElement(rI, __spreadValues({}, y10))), s10 ? tp.createElement(dNe, __spreadValues({}, p10)) : tp.createElement(eNe, __spreadValues({}, h10)), tp.createElement(iNe, __spreadValues({}, m10)));
};
yNe.displayName = "ReportParameterValidValueEditor";
const vNe = (e14) => "Hour" === e14 || "Minute" === e14 || "Second" === e14;
const bNe = void 0;
var SNe;
!function(e14) {
  e14[e14.ok = 0] = "ok", e14[e14.expectValue = 1] = "expectValue", e14[e14.hasOutstandingDependencies = 2] = "hasOutstandingDependencies", e14[e14.validationFailed = 3] = "validationFailed", e14[e14.dynamicValuesUnavailable = 4] = "dynamicValuesUnavailable", e14[e14.communicating = 5] = "communicating", e14[e14.isValidation = 6] = "isValidation";
}(SNe || (SNe = {}));
function CNe(e14, t10) {
  return e14.length ? e14[0] : t10 ? null : bNe;
}
function xNe(e14, t10) {
  const n10 = { state: { $set: SNe.ok }, error: { $set: null } };
  return null != t10 && (n10.values = { $set: t10 }), AV(e14, n10);
}
function wNe(e14, t10) {
  return AV(e14, { state: { $set: SNe.validationFailed }, error: { $set: t10 } });
}
const TNe = { Date: { accepted: ["yyyy-MM-dd", "yyyyMMdd", "M/d/yyyy", "d.M.yyyy", "yyyy-MM-dd'T'HH:mm:ss", "yyyy-MM-dd'T'HH:mm:ssXX", "yyyy-MM-dd'T'HH:mm:ssXXX", "yyyy-MM-dd'T'HH:mm:ss.SSSXXX", "yyyy-MM-dd'T'HH:mm:ss.SSSXX"], valid: "yyyy-MM-dd" }, DateTime: { accepted: ["yyyy-MM-dd'T'HH:mm:ss", "yyyy-MM-dd'T'HH:mm:ssXX", "yyyy-MM-dd'T'HH:mm:ssXXX", "yyyy-MM-dd'T'HH:mm:ss.SSSXX", "yyyy-MM-dd'T'HH:mm:ss.SSSXXX", "yyyy-MM-dd'T'HH:mm:ss.SSSSSSS"], valid: "yyyy-MM-dd'T'HH:mm:ss" } };
function ENe(e14, t10) {
  const { descriptor: { dataType: n10, allowBlank: r10 } } = e14;
  switch (n10) {
    case "Boolean":
      return "true" === t10.toLowerCase() ? xNe(e14, [true]) : "false" === t10.toLowerCase() ? xNe(e14, [false]) : wNe(e14, "invalidBoolean");
    case "String":
      return "" === t10 ? r10 ? xNe(e14, [""]) : wNe(e14, "stringEmpty") : xNe(e14, [t10]);
    case "Integer": {
      const n11 = ((e15) => /^[-+]?\d+$/gi.test(e15) ? parseInt(e15, 10) : Number.NaN)(t10);
      return isNaN(n11) ? wNe(e14, "invalidInteger") : (o10 = n11, Math.abs(o10) <= 9007199254740991 ? xNe(e14, [n11]) : wNe(e14, "integerTooBig"));
    }
    case "Float": {
      const n11 = ((e15) => {
        const t11 = parseFloat(e15);
        return isNaN(e15 - t11) ? Number.NaN : t11;
      })(t10);
      return isNaN(n11) ? wNe(e14, "invalidFloat") : xNe(e14, [n11]);
    }
    case "Date":
    case "DateTime": {
      const r11 = function(e15, t11) {
        try {
          if (!t11 || Array.isArray(t11) && 0 === t11.length) return Ka(e15);
          for (const n11 of t11) {
            const t12 = Da(e15, n11, /* @__PURE__ */ new Date());
            if ($t(t12)) return t12;
          }
        } catch (e16) {
          return console.warn(e16), /* @__PURE__ */ new Date(NaN);
        }
        return /* @__PURE__ */ new Date(NaN);
      }(t10, TNe[n10].accepted);
      return function(e15) {
        return $t(e15);
      }(r11) ? xNe(e14, [r11]) : wNe(e14, "invalidDateTime");
    }
    default:
      return wNe(e14, "unknown");
  }
  var o10;
}
const FNe = () => ({ view: { controls: [], preferredLayout: "free-form" }, parameters: { byName: {}, all: [], validating: false }, initialParams: {}, withModel: false, ready: true, valid: true, softValidation: true, previewIsDelayed: false, layout: "stack" });
const MNe = { dddd: "dddd", ddd: "ddd", dd: "DD", d: "D", yyyy: "YYYY", yy: "YY", fffffff: "SSSSSS", ffffff: "SSSSSS", fffff: "SSSSS", ffff: "SSSS", fff: "SSS", ff: "SS", f: "S", zzz: "ZZ", zz: "ZZ", z: "Z", tt: "A", t: "a", gg: "GGGG", g: "GG", K: "Z" };
const kNe = { d: "MM/D/YYYY", D: "dddd, MMMM D, YYYY", f: "dddd, MMMM D, YYYY h:mm A", F: "dddd, MMMM D, YYYY h:mm:ss A", g: "M/D/YYYY h:mm A", G: "M/D/YYYY h:mm:ss A", M: "MMMM D", m: "MMMM D", O: "YYYY-MM-DDTHH:mm:ss.SSSZ", o: "YYYY-MM-DDTHH:mm:ss.SSSZ", R: "ddd, DD MMM YYYY HH:mm:ss [GMT]", r: "ddd, DD MMM YYYY HH:mm:ss [GMT]", s: "YYYY-MM-DDTHH:mm:ss", t: "h:mm A", T: "h:mm:ss A", u: "YYYY-MM-DD HH:mm:ss[Z]", U: "dddd, MMMM D, YYYY h:mm:ss A", Y: "MMMM YYYY", y: "MMMM YYYY" };
const PNe = (e14, t10) => {
  if (!e14) return "";
  if (1 === e14.length) return ((e15, t11) => {
    const n11 = { d: t11.t("singleDateFormat:d", "MM/D/YYYY"), D: t11.t("singleDateFormat:D", "dddd, MMMM D, YYYY"), f: t11.t("singleDateFormat:f", "dddd, MMMM D, YYYY h:mm A"), F: t11.t("singleDateFormat:F", "dddd, MMMM D, YYYY h:mm:ss A"), g: t11.t("singleDateFormat:g", "M/D/YYYY h:mm A"), G: t11.t("singleDateFormat:G", "M/D/YYYY h:mm:ss A"), M: t11.t("singleDateFormat:M", "MMMM D"), m: t11.t("singleDateFormat:m", "MMMM D"), O: t11.t("singleDateFormat:O", "YYYY-MM-DDTHH:mm:ss.SSSZ"), o: t11.t("singleDateFormat:o", "YYYY-MM-DDTHH:mm:ss.SSSZ"), R: t11.t("singleDateFormat:R", "ddd, DD MMM YYYY HH:mm:ss [GMT]"), r: t11.t("singleDateFormat:r", "ddd, DD MMM YYYY HH:mm:ss [GMT]"), s: t11.t("singleDateFormat:s", "YYYY-MM-DDTHH:mm:ss"), t: t11.t("singleDateFormat:t", "h:mm A"), T: t11.t("singleDateFormat:T", "h:mm:ss A"), u: t11.t("singleDateFormat:u", "YYYY-MM-DD HH:mm:ss[Z]"), U: t11.t("singleDateFormat:U", "dddd, MMMM D, YYYY h:mm:ss A"), Y: t11.t("singleDateFormat:Y", "MMMM YYYY"), y: t11.t("singleDateFormat:y", "MMMM YYYY") };
    return (t11 ? n11[e15] : kNe[e15]) || "";
  })(e14, t10);
  const n10 = DNe(e14, Object.keys(MNe)).map((e15) => {
    var _a2;
    return (_a2 = MNe[e15]) != null ? _a2 : `${e15}`;
  });
  return n10.join("");
};
let NNe = /* @__PURE__ */ new Map();
const DNe = (e14, t10) => {
  const n10 = NNe.get(e14);
  if (n10) return n10;
  const r10 = (e14 && "%" === e14[0] ? e14.replace("%", "") : e14) || "";
  const o10 = (e15) => {
    for (let n11 = 0; n11 < t10.length; n11++) if (e15.endsWith(t10[n11])) {
      if (!(e15.length > t10[n11].length && "\\" === e15[e15.length - 1 - t10[n11].length])) return t10[n11];
      {
        const e16 = t10.find((e17) => e17 === t10[n11].substr(1, t10[n11].length - 1));
        if (e16) return e16;
      }
    }
    return "";
  };
  const a10 = (e15) => {
    const t11 = [];
    let n11 = o10(e15);
    for (; n11; ) e15 = e15.substr(0, e15.length - n11.length), t11.push(n11), n11 = o10(e15);
    return e15 && t11.push(e15), t11.reverse(), t11;
  };
  const i10 = [];
  let s10 = "";
  let l10;
  let c10 = false;
  for (let e15 = 0; e15 < r10.length; e15++) {
    if ('"' === r10[e15]) {
      c10 = !c10, c10 || (s10 += '"'), l10 = o10(s10), l10 ? i10.push(...a10(s10)) : (i10.push(s10), s10 = ""), c10 && (s10 = '"');
      continue;
    }
    if (c10) {
      s10 += r10[e15];
      continue;
    }
    const t11 = o10(s10);
    const n11 = o10(s10 + r10[e15]);
    t11 && !n11 && (i10.push(...a10(s10)), s10 = ""), s10 += r10[e15];
  }
  return c10 && s10 && !s10.endsWith('"') && (s10 += '"'), l10 = o10(s10), l10 ? i10.push(...a10(s10)) : s10 && i10.push(s10), ((e15, t11) => {
    NNe.set(e15, t11), NNe.size > 1e4 && (NNe = new Map(LNe(NNe).slice(NNe.size - 1e3)));
  })(e14, i10), i10;
};
const LNe = (e14) => {
  const t10 = [];
  for (let n10 of e14) t10.push([n10[0], n10[1]]);
  return t10;
};
const HNe = (e14, t10, n10) => {
  const r10 = PNe(n10, t10);
  return sI(e14).format(r10);
};
const INe = (e14, t10) => {
  var _a2;
  return (_a2 = e14.label) != null ? _a2 : ((e15, t11) => {
    const { rangeType: n10, unit: r10, amount: o10 } = e15;
    const a10 = t11.getFixedT(t11.language);
    return "Current" === n10 || "ToDate" === n10 ? a10(`paramsView:dateTimeRange.rangeTypes.${n10}`, { context: r10 }) : 1 === o10 ? a10(`paramsView:dateTimeRange.rangeTypes.${n10}Simple`, { context: r10 }) : a10(`paramsView:dateTimeRange.rangeTypes.${n10}`, { context: r10, count: o10 });
  })(e14, t10);
};
function _Ne(e14, t10, n10) {
  switch (e14) {
    case "Second":
      return new Date(t10.getFullYear(), t10.getMonth(), t10.getDate(), t10.getHours(), t10.getMinutes(), t10.getSeconds());
    case "Minute":
      return new Date(t10.getFullYear(), t10.getMonth(), t10.getDate(), t10.getHours(), t10.getMinutes());
    case "Hour":
      return new Date(t10.getFullYear(), t10.getMonth(), t10.getDate(), t10.getHours());
    case "Day":
      return new Date(t10.getFullYear(), t10.getMonth(), t10.getDate());
    case "Week":
      return new Date(t10.getFullYear(), t10.getMonth(), t10.getDate() - t10.getDay() + n10);
    case "Month":
      return new Date(t10.getFullYear(), t10.getMonth(), 1);
    case "Quarter":
      return new Date(t10.getFullYear(), t10.getMonth() - t10.getMonth() % 3, 1);
    case "Year":
      return new Date(t10.getFullYear(), 0, 1);
    default:
      throw new Error(`Unknown portion ${e14}`);
  }
}
function VNe(e14, t10, n10) {
  switch (t10) {
    case "Second":
      return new Date(e14.getFullYear(), e14.getMonth(), e14.getDate(), e14.getHours(), e14.getMinutes(), e14.getSeconds() + n10);
    case "Minute":
      return new Date(e14.getFullYear(), e14.getMonth(), e14.getDate(), e14.getHours(), e14.getMinutes() + n10);
    case "Hour":
      return new Date(e14.getFullYear(), e14.getMonth(), e14.getDate(), e14.getHours() + n10);
    case "Day":
      return new Date(e14.getFullYear(), e14.getMonth(), e14.getDate() + n10);
    case "Week":
      return new Date(e14.getFullYear(), e14.getMonth(), e14.getDate() + 7 * n10);
    case "Month":
      return new Date(e14.getFullYear(), e14.getMonth() + n10, e14.getDate());
    case "Quarter":
      return new Date(e14.getFullYear(), e14.getMonth() - e14.getMonth() % 3 + 3 * n10, e14.getDate());
    case "Year":
      return new Date(e14.getFullYear() + n10, e14.getMonth(), e14.getDate());
    default:
      throw new Error(`Unknown portion ${t10}`);
  }
}
function RNe(e14, { unit: t10, rangeType: n10, amount: r10, anchor: o10, offset: a10, includeEndpoint: i10 = false }, s10 = 0) {
  let l10 = "" !== o10 ? new Date(o10) : e14;
  isNaN(l10.getTime()) && (l10 = e14), 0 !== a10 && (l10 = VNe(l10, t10, a10));
  const c10 = r10 < 1 ? 1 : r10;
  const u10 = s10 < 7 && s10 >= 0 ? s10 : 0;
  let d10 = l10;
  let p10 = l10;
  switch (n10) {
    case "Current":
      d10 = _Ne(t10, l10, u10), p10 = VNe(d10, t10, 1);
      break;
    case "Last":
      d10 = _Ne(t10, l10, u10), p10 = VNe(d10, t10, 1), [d10, p10] = [VNe(d10, t10, -c10), VNe(p10, t10, -1)];
      break;
    case "Next":
      d10 = _Ne(t10, l10, u10), p10 = VNe(d10, t10, 1), [d10, p10] = [VNe(d10, t10, 1), VNe(p10, t10, c10)];
      break;
    case "ToDate":
      d10 = _Ne(t10, l10, u10), p10 = VNe(_Ne("Day", l10, u10), "Day", 1);
      break;
    case "LastToDate":
      d10 = VNe(l10, t10, -c10), p10 = VNe(_Ne("Day", l10, u10), "Day", 1);
      break;
    default:
      throw new Error(`Unknown range type ${n10}`);
  }
  return p10 = function(e15, t11, n11 = false) {
    return vNe(t11) ? "Second" === t11 && n11 ? e15 : VNe(e15, n11 ? "Second" : t11, -1) : VNe(e15, n11 ? "Second" : "Day", -1);
  }(p10, t10, i10), [d10, p10];
}
const ANe = (e14, t10) => {
  switch (t10) {
    case "integerTooBig":
      return e14.t("paramsValidation:integerTooBig", "* Value cannot exceed 53-bit integer");
    case "invalidBoolean":
      return e14.t("paramsValidation:invalidBoolean", "* Wrong value. Make sure that you enter a valid boolean");
    case "invalidDateTime":
      return e14.t("paramsValidation:invalidDateTime", "* Wrong value. Make sure that you enter a valid date");
    case "invalidFloat":
      return e14.t("paramsValidation:invalidFloat", "* Wrong value. Make sure that you enter a valid float");
    case "invalidInteger":
      return e14.t("paramsValidation:invalidInteger", "* Wrong value. Make sure that you enter a valid integer");
    case "outstandingDependencies":
      return e14.t("paramsValidation:outstandingDependencies", "* Parameter has outstanding dependencies");
    case "requiredSingleValue":
      return e14.t("paramsValidation:requiredSingleValue", "* Single value expected");
    case "requiredValue":
      return e14.t("paramsValidation:requiredValue", "* Value Expected");
    case "stringEmpty":
      return e14.t("paramsValidation:stringEmpty", "* Wrong value. Empty strings are not allowed");
    case "valueIsNull":
      return e14.t("paramsValidation:valueIsNull", "* Value cannot be null");
    case "valueOutOfRange":
      return e14.t("paramsValidation:valueOutOfRange", "* Wrong value. Pick the right one from the list");
    default:
      return e14.t("paramsValidation:unknown", "! Unknown validation error");
  }
};
const [ONe] = Dp("gcv-label");
const BNe = (e14) => class extends tp.Component {
  render() {
    const { control: { label: { display: t10, text: n10 } }, parameters: r10, i18n: o10, highlightRequired: a10 } = this.props;
    if ("none" === t10) return tp.createElement(e14, __spreadValues({}, this.props));
    const [{ definition: { descriptor: { name: i10 } } }] = r10;
    const s10 = { block: true, size: "small", label: n10, position: t10, customCSS: ONe, htmlFor: i10 };
    const l10 = r10.map(({ expected: e15, invalid: t11, validationMessage: n11 }) => e15 || t11 ? n11 || o10.t("paramsView:lblTextInvalidValue", "Invalid Value") : null).filter((e15) => null !== e15);
    return !a10 && l10.length && (s10.tooltip = { text: l10[0] }), tp.createElement(AN, __spreadValues({}, s10), tp.createElement(e14, __spreadValues({}, this.props)));
  }
};
const [zNe, , $Ne] = Dp("gcv-nullable");
const [WNe] = $Ne("content");
const jNe = (e14) => class extends tp.Component {
  constructor() {
    super(...arguments), this.onChange = () => {
      const { control: { binding: e15 }, parameters: t10, onSetValues: n10 } = this.props;
      const r10 = t10[0], { nullValue: o10, definition: { descriptor: { allowBlank: a10 } } } = r10;
      n10(o10 ? { [e15]: [a10 ? "" : bNe] } : { [e15]: [null] });
    };
  }
  render() {
    const { parameters: t10, i18n: n10, highlightRequired: r10 } = this.props;
    if (1 === this.props.parameters.length) {
      const o10 = t10[0], { invalid: a10, expected: i10, nullValue: s10, definition: { descriptor: { name: l10, nullable: c10 } } } = o10;
      if (!c10) return tp.createElement(e14, __spreadValues({}, this.props));
      const u10 = { id: `${l10}_check`, block: true, size: "small", text: n10.t("paramsView:nwrpTextNull", "Null"), value: "null", checked: s10, invalid: !r10 && (a10 || i10), onChange: this.onChange };
      return tp.createElement("div", { className: zNe }, tp.createElement("div", { className: WNe }, tp.createElement(e14, __spreadValues({}, this.props))), tp.createElement(CE, __spreadValues({}, u10)));
    }
    return tp.createElement(e14, __spreadValues({}, this.props));
  }
};
const ZNe = BNe(jNe(({ control: { type: e14, binding: t10, placeholder: n10 }, parameters: [r10], onSetValues: o10, highlightRequired: a10, rounded: i10 }) => {
  const { value: s10, nullValue: l10, hasOutstandingDependencies: c10, definition: { descriptor: u10 } } = r10, d10 = u10.dateOnly || "Date" === u10.dataType;
  const p10 = !a10 && (r10.invalid || r10.expected);
  const [m10, h10] = ep.useState(GNe(s10, d10));
  ep.useEffect(() => {
    const e15 = GNe(r10.value, d10);
    e15 !== m10 && h10(e15);
  }, [r10.value]);
  const f10 = (e15) => {
    e15.target && "Enter" === e15.key && o10({ [t10]: [m10] });
  };
  const g10 = (e15) => {
    e15.target && h10(e15.target.value);
  };
  const y10 = (e15) => {
    e15.target && o10({ [t10]: [m10] });
  };
  if (u10.multiline) {
    const e15 = { block: true, size: "small", width: "100%", rows: 6, value: m10, invalid: p10, disabled: l10 || c10, onKeyDown: f10, onChange: g10, onBlur: y10, customCSS: "gcv-textarea", rounded: i10 };
    return tp.createElement(zN, __spreadValues({}, e15));
  }
  const v10 = { id: u10.name, block: true, size: "small", width: "100%", type: "text", value: m10, invalid: p10, disabled: l10 || c10, placeholder: n10, onKeyDown: f10, onChange: g10, onBlur: y10, rounded: i10 };
  return tp.createElement(KF, __spreadValues({}, v10));
}));
const GNe = (e14, t10) => e14 instanceof Date ? ((e15, t11) => {
  const n10 = (e16) => (e16 < 10 ? "0" : "") + e16.toString();
  const r10 = `${e15.getFullYear()}-${n10(e15.getMonth() + 1)}-${n10(e15.getDate())}`;
  return t11 ? r10 : `${r10}T${n10(e15.getHours())}:${n10(e15.getMinutes())}:${n10(e15.getSeconds())}`;
})(e14, t10) : null != e14 ? `${e14}` : "";
const UNe = BNe(jNe(({ onSetValues: e14, parameters: [t10], i18n: n10, control: { binding: r10, subType: o10, text: a10, textTrue: i10, textFalse: s10, layout: l10 }, highlightRequired: c10 }) => {
  const { value: u10, nullValue: d10, definition: { descriptor: { name: p10 } } } = t10;
  const m10 = !c10 && (t10.invalid || t10.expected);
  let h10;
  d10 || void 0 === u10 || (h10 = u10);
  const f10 = (t11) => {
    null !== u10 && e14({ [r10]: ["number" == typeof t11 ? Boolean(t11) : !h10] });
  };
  const g10 = i10 || n10.t("paramsView:boolTextTrue", "True");
  const y10 = s10 || n10.t("paramsView:boolTextFalse", "False");
  const v10 = n10.t("paramsView:boolTextUnspecified", "Unspecified");
  let b10 = null;
  switch (o10) {
    case "toggle": {
      const e15 = { id: p10, size: "small", invalid: m10, block: true, disabled: d10, checked: h10 || false, indeterminate: void 0 === h10, onToggle: f10, text: void 0 === h10 ? v10 : h10 ? g10 : y10 };
      b10 = tp.createElement(SM, __spreadValues({}, e15));
      break;
    }
    case "checkbox": {
      const e15 = { id: p10, size: "small", invalid: m10, block: true, disabled: d10, value: "", checked: h10 || false, indeterminate: void 0 === h10, onChange: f10, text: a10 };
      b10 = tp.createElement(CE, __spreadValues({}, e15));
      break;
    }
    case "radio": {
      const e15 = { size: "small", type: "radios", disabled: d10, invalid: m10, layout: "horizontal" === l10 ? { direction: "horizontal", columnsDefault: 2 } : { direction: "vertical" }, items: [{ text: g10, value: 1, checked: true === h10 }, { text: y10, value: 0, checked: false === h10 }], onChange: f10 };
      b10 = tp.createElement(rI, __spreadValues({}, e15));
      break;
    }
  }
  return b10;
}));
const qNe = BNe(jNe(({ onSetValues: e14, parameters: [t10], control: { binding: n10 }, highlightRequired: r10, rounded: o10 }) => {
  const { nullValue: a10, hasOutstandingDependencies: i10, definition: { descriptor: { name: s10 }, values: l10 } } = t10;
  const [c10, u10] = ep.useState("");
  const [d10, p10] = ep.useState([]);
  ep.useEffect(() => {
    const e15 = c10.split(/\r?\n/).filter((e16) => e16 && e16.trim());
    p10(e15);
  }, [c10]), ep.useEffect(() => {
    if ((() => {
      if (l10.length !== d10.length) return true;
      const e15 = (e16) => sI.isDate(e16) ? sI(e16).toISOString() : `${e16}`;
      const n11 = d10.map((n12) => {
        const r11 = ENe(t10.definition, e15(n12));
        return r11.error ? n12 : r11.values[0];
      });
      for (let t11 = 0; t11 < l10.length; t11++) {
        if (e15(l10[t11]) !== e15(n11[t11])) return true;
      }
      return false;
    })()) {
      const e15 = l10.join("\n");
      u10(e15);
    }
  }, [l10]);
  const m10 = !r10 && (t10.invalid || t10.expected);
  const h10 = { value: c10, onChange: ({ target: { value: e15 } }) => {
    u10(e15);
  }, customCSS: "gcv-multivalue-textarea", onKeyDown: (e15) => {
    [Vp, Lp, Hp].some((t11) => t11 === e15.which) && e15.stopPropagation();
  } };
  const f10 = tp.createElement(zN, __spreadValues({}, h10));
  const g10 = { id: s10, block: true, size: "small", width: "100%", menuWidth: "100%", menuMaxHeight: 300, text: d10.join(", "), invalid: m10, onToggle: (t11) => {
    t11 || e14({ [n10]: d10 });
  }, disabled: a10 || i10, content: f10, rounded: o10 };
  return tp.createElement(UF, __spreadValues({}, g10));
}));
function YNe(e14, t10, n10) {
  return e14 === t10 || null != e14 && null != t10 && ("Date" === n10 || "DateTime" === n10 ? e14 instanceof Date && t10 instanceof Date && e14.valueOf() === t10.valueOf() : "object" == typeof e14 || "object" == typeof t10 ? JSON.stringify(e14) === JSON.stringify(t10) : "String" !== n10 ? e14.toString().toLowerCase() === t10.toString().toLowerCase() : e14.toString() === t10.toString());
}
const KNe = (e14, t10, n10) => e14.some((e15) => YNe(t10, e15, n10));
const [XNe] = Dp("gcv-custom-content");
const JNe = BNe(jNe(({ onSetValues: e14, parameters: [t10], i18n: n10, control: { binding: r10 }, highlightRequired: o10, rounded: a10 }) => {
  const { nullValue: i10, hasOutstandingDependencies: s10, definition: { descriptor: { name: l10, dataType: c10, selectAllValue: u10, multiValue: d10, nullable: p10 }, values: m10, isValidValuesLoaded: h10, validValues: f10 } } = t10;
  const [g10, y10] = ep.useState([]);
  const v10 = QNe(m10, d10, p10);
  ep.useEffect(() => {
    if (v10) {
      const e15 = d10 && 1 === m10.length && YNe(m10[0], u10, c10);
      const t11 = F10.filter((t12) => e15 || v10.some((e16) => YNe(t12.value, e16, c10))).map(({ value: e16, label: t12 }) => ({ value: e16, label: t12 }));
      y10(t11);
    } else y10([]);
  }, [m10]);
  const b10 = n10.t("paramsView:ddeTextNull", "(null)");
  const S10 = n10.t("paramsView:ddeTextSelectValue", "(select value)");
  const C10 = n10.t("paramsView:ddeTextAllValues", "(all)");
  const x10 = n10.t("paramsView:ddeTextSelectAllValues", "(select all)");
  const w10 = n10.t("paramsView:lblTextNoAvailableValues", "No available values");
  const T10 = !o10 && (t10.invalid || t10.expected);
  const E10 = f10.filter((e15, t11) => t11 === f10.findIndex((t12) => t12.label === e15.label && YNe(e15.value, t12.value, c10)));
  const F10 = d10 && E10.length > 0 ? [{ value: u10, label: x10 }, ...E10] : E10;
  const M10 = F10.map(({ label: e15, value: t11 }) => ({ type: "button", text: e15, value: t11, selected: g10.some((e16) => YNe(e16.value, t11, c10)) }));
  const k10 = d10 && M10.every((e15) => true === e15.selected);
  const P10 = g10.length > 0 ? F10.filter((e15) => g10.some((t11) => YNe(e15.value, t11.value, c10))).filter((e15) => !k10 || e15.value === u10).map((e15) => e15.value === u10 ? C10 : e15.label || e15.value).filter((e15, t11, n11) => n11.indexOf(e15) === t11).join(", ") : null === v10 ? b10 : "";
  const N10 = { id: l10, multiselect: d10, items: M10, placeholder: S10, block: true, size: "small", width: "100%", menuWidth: "100%", menuMaxHeight: 300, filterOnInput: true, openOnFocus: true, titleToggle: n10.t("paramsView:ddTitleToggle", "Expand"), value: P10, invalid: T10, onSelect: d10 ? /* @__PURE__ */ ((e15) => (t11) => {
    const n11 = e15.find((e16) => e16.value === t11);
    const r11 = e15[0];
    const o11 = !n11.selected;
    let a11;
    if (n11 === r11) a11 = (e16) => o11;
    else if (o11) {
      const t12 = e15.every((e16) => e16.selected || e16 === n11 || e16 === r11);
      a11 = (e16) => t12 || e16.selected || e16 === n11;
    } else a11 = (e16) => true === e16.selected && e16 !== n11 && e16 !== r11;
    y10(e15.filter(a11).map((e16) => ({ value: e16.value, label: e16.text || e16.value })));
  })(M10) : (t11) => {
    if (m10[0] === t11) return;
    e14({ [r10]: [t11] });
    const n11 = E10.find((e15) => e15.value === t11);
    y10(n11 ? [n11] : [{ value: t11, label: t11 }]);
  }, onToggle: (t11) => {
    if (d10 && !t11) {
      const t12 = k10 ? [u10] : g10.map(({ value: e15 }) => e15);
      (m10.length !== t12.length || m10.some((e15, n11) => e15 !== t12[n11])) && e14({ [r10]: t12 });
    }
  }, disabled: i10 || s10 || !h10, content: 0 === M10.length ? tp.createElement("div", { className: XNe }, w10) : void 0, rounded: a10 };
  return tp.createElement(tM, __spreadValues({}, N10));
}));
const QNe = (e14, t10, n10) => {
  if (t10) return e14.length > 0 ? e14 : bNe;
  const r10 = CNe(e14, n10);
  return null === r10 || r10 === bNe ? r10 : [r10];
};
const eDe = (e14) => {
  const t10 = e14.language.toLowerCase();
  return "zh" === t10 ? "zh-cn" : t10;
};
const tDe = (e14) => {
  switch (e14) {
    case "accent":
      return "info";
    case "warning":
      return "warning";
    case "error":
      return "error";
    default:
      return;
  }
};
const nDe = (e14, t10, n10 = true) => {
  const r10 = [{ type: "last-week", label: t10.t("paramsView:drShortcutsLabelLastWeek", "Last week") }, { type: "last-month", label: t10.t("paramsView:drShortcutsLabelLastMonth", "Last month") }, { type: "last-year", label: t10.t("paramsView:drShortcutsLabelLastYear", "Last year") }, { type: "last-week-to-date", label: t10.t("paramsView:drShortcutsLabelLastWeekToDate", "Last week to date") }, { type: "last-month-to-date", label: t10.t("paramsView:drShortcutsLabelLastMonthToDate", "Last month to date") }, { type: "last-year-to-date", label: t10.t("paramsView:drShortcutsLabelLastYearToDate", "Last year to date") }, { type: "week-to-date", label: t10.t("paramsView:drShortcutsLabelWeekToDate", "Week-to-date") }, { type: "month-to-date", label: t10.t("paramsView:drShortcutsLabelMonthToDate", "Month-to-date") }, { type: "year-to-date", label: t10.t("paramsView:drShortcutsLabelYearToDate", "Year-to-date") }];
  const o10 = (e15) => {
    if (vNe(e15)) return "time";
    switch (e15) {
      case "Year":
        return "years";
      case "Quarter":
      case "Month":
        return "months";
      default:
        return "days";
    }
  };
  const a10 = (e15) => (t11, n11) => RNe(t11, e15, n11 == null ? void 0 : n11.firstDayOfWeek);
  const i10 = (e14 == null ? void 0 : e14.map((e15) => {
    var _a2;
    return { type: "custom", shortcut: { label: (_a2 = e15.label) != null ? _a2 : INe(e15, t10), viewMode: o10(e15.unit), getValue: a10(e15) } };
  })) || [];
  return n10 ? [...i10, ...r10] : i10;
};
const rDe = BNe(jNe(({ onSetValues: e14, parameters: [t10], i18n: n10, control: { binding: r10, daysViewHeaderFormat: o10, placeholder: a10 }, highlightRequired: i10, rounded: s10 }) => {
  const { value: l10, nullValue: c10, hasOutstandingDependencies: u10, definition: { descriptor: d10 } } = t10;
  const p10 = !i10 && (t10.invalid || t10.expected);
  const m10 = "DateTime" === d10.dataType ? "date-time" : "date";
  const h10 = ep.useMemo(() => PNe(d10.displayFormat, n10), [d10.displayFormat, n10]);
  const f10 = { id: d10.name, placeholder: a10 || n10.t("paramsView:dtTextSelectDate", "Select Date..."), pickerMode: m10, daysViewHeaderFormat: o10 || n10.t("paramsView:dtDaysViewHeaderFormat", "MMMM YYYY"), invalid: p10, rounded: s10, disabled: c10 || u10, locale: eDe(n10), withShortcuts: true, monthYearOrder: n10.t("paramsView:dtMonthYearOrder", "M-Y"), textShortcutClear: n10.t("paramsView:dtTextClear", "Clear"), textShortcutToday: n10.t("paramsView:dtTextToday", "Today"), textBack: n10.t("paramsView:dtTextBack", "Back to Calendar"), titleToggle: n10.t("paramsView:dtTitleToggle", "Expand Calendar"), onChange: (t11) => {
    e14({ [r10]: ["string" == typeof t11 ? t11 : t11.toISOString(true)] });
  }, valueFormat: lI, value: l10 || "", dateTimeFormat: h10 };
  return tp.createElement(E_, __spreadProps(__spreadValues({}, f10), { block: true, size: "small" }));
}));
const oDe = BNe(jNe(({ onSetValues: e14, parameters: [t10, n10], parameters: [{ definition: { descriptor: r10 } }, { definition: { descriptor: o10 } }], i18n: a10, control: { binding: i10, daysViewHeaderFormat: s10, placeholders: l10, ranges: c10, showDefaultRanges: u10 }, highlightRequired: d10, rounded: p10 }) => {
  var _a2, _b2, _c2;
  const [m10, h10] = tp.useState(((e15) => {
    if (!e15) return "days";
    if (vNe(e15)) return "time";
    switch (e15) {
      case "Year":
        return "years";
      case "Quarter":
      case "Month":
        return "months";
      default:
        return "days";
    }
  })((_a2 = c10 == null ? void 0 : c10[0]) == null ? void 0 : _a2.unit));
  const f10 = ep.useMemo(() => eDe(a10), [a10]);
  const g10 = ep.useCallback(() => sI().locale(f10), [f10]);
  const { API: y10 } = ep.useContext(Sm);
  const v10 = rf(Oh);
  const b10 = (t11) => (n11) => {
    e14({ [i10[t11]]: ["string" == typeof n11 ? n11 : n11.toISOString(true)] });
  };
  const S10 = ep.useCallback(() => y10.current.dropdowns.open(null), [y10]);
  const C10 = ep.useMemo(() => nDe(c10, a10, u10), [c10, a10, u10]);
  const x10 = { daysViewHeaderFormat: s10 || a10.t("paramsView:dtDaysViewHeaderFormat", "MMMM YYYY"), rounded: p10, locale: eDe(a10), withShortcuts: true, monthYearOrder: a10.t("paramsView:dtMonthYearOrder", "M-Y"), textShortcutClear: a10.t("paramsView:dtTextClear", "Clear"), textShortcutToday: a10.t("paramsView:dtTextToday", "Today"), textBack: a10.t("paramsView:dtTextBack", "Back to Calendar"), titleToggle: a10.t("paramsView:dtTitleToggle", "Expand Calendar"), valueFormat: lI, block: true, size: "small" };
  const w10 = __spreadProps(__spreadValues({}, x10), { id: r10.name, pickerMode: "DateTime" === r10.dataType ? "date-time" : "date", placeholder: (l10 == null ? void 0 : l10[0]) || a10.t("paramsView:dtTextSelectFromDate", 'Select "From" Date...'), invalid: !d10 && (t10.invalid || t10.expected), disabled: t10.nullValue || t10.hasOutstandingDependencies, value: (_b2 = t10.value) != null ? _b2 : "", dateTimeFormat: PNe(r10.displayFormat, a10), onChange: b10(0), customCSS: "gcv-date-time-range-input" });
  const T10 = __spreadProps(__spreadValues({}, x10), { id: o10.name, pickerMode: "DateTime" === o10.dataType ? "date-time" : "date", placeholder: (l10 == null ? void 0 : l10[1]) || a10.t("paramsView:dtTextSelectToDate", 'Select "To" Date...'), invalid: !d10 && (n10.invalid || n10.expected), disabled: n10.nullValue || n10.hasOutstandingDependencies, value: (_c2 = n10.value) != null ? _c2 : "", dateTimeFormat: PNe(o10.displayFormat, a10), onChange: b10(1) });
  const E10 = { currentView: m10, shortcuts: C10, textShortcutsList: a10.t("paramsView:drTextShortcutsList", "Common Ranges"), textModeDaily: a10.t("paramsView:drTabLabelDaily", "Daily"), textModeMonthly: a10.t("paramsView:drTabLabelMonthly", "Monthly"), textModeYearly: a10.t("paramsView:drTabLabelAnnually", "Annually"), textModeTime: a10.t("paramsView:drTabLabelTime", "Time"), localMoment: g10, onViewChange: (e15) => () => h10(e15), onShortcutClick: (t11) => () => {
    const [n11, r11] = t11(g10().toDate(), { firstDayOfWeek: g10().localeData().firstDayOfWeek() });
    e14({ [i10[0]]: ["string" == typeof n11 ? n11 : n11.toISOString(true)], [i10[1]]: ["string" == typeof r11 ? r11 : r11.toISOString(true)] }), S10();
  } };
  const F10 = { content: tp.createElement(G_, __spreadValues({}, E10)), customScroll: true, icon: v10, size: "small", background: "transparent", hiddenChevron: true, title: a10.t("paramsView:dtTitleQuickRangePicker", "Common Ranges"), menuWidth: "auto", menuAlign: "center", menuCustomCSS: "gcv-date-time-range-dropdown", customCSS: "gcv-date-time-range-toggle" };
  return tp.createElement("div", { className: "gcv-date-time-range" }, tp.createElement(E_, __spreadValues({}, w10)), tp.createElement(E_, __spreadValues({}, T10)), C10 && C10.length > 0 && tp.createElement(UF, __spreadValues({}, F10)));
}));
const [aDe, iDe] = Dp("gcv-date-range");
const sDe = BNe((e14) => {
  const { onSetValues: t10, parameters: n10, i18n: r10, highlightRequired: o10, rounded: a10, parameters: [{ value: i10, definition: { descriptor: { name: s10, displayFormat: l10 } } }, { value: c10, definition: { descriptor: { displayFormat: u10 } } }], control: { binding: d10, viewMode: p10, daysViewHeaderFormat: m10, ranges: h10, showDefaultRanges: f10 } } = e14;
  const g10 = ((e15) => {
    const { onSetValues: t11, parameters: [{ value: n11 }, { value: r11 }], control: { binding: o11, maxRange: a11, viewMode: i11 } } = e15;
    const s11 = ep.useRef("default" === i11 ? "days" : i11);
    return ep.useMemo(() => {
      if ("none" === a11[0]) return { isActive: false };
      const e16 = [];
      const i12 = sI(n11 || "");
      const l11 = sI(r11 || "");
      i12.isValid() && e16.push(i12), l11.isValid() && e16.push(l11);
      const c11 = 1 === e16.length && ((e17, [t12, n12], r12) => {
        const o12 = e17.clone().subtract(n12, t12);
        const a12 = e17.clone().startOf(r12).add(n12, t12);
        return { start: o12, end: a12, startYear: o12.year(), endYear: a12.year() };
      })(e16[0], a11, s11.current);
      return { isActive: true, onViewModeChange: (e17) => {
        s11.current = e17, c11 && t11({ [o11[0]]: [], [o11[1]]: [] });
      }, isValidDate: (e17, t12) => {
        if (!c11) return true;
        const { start: n12, end: r12, startYear: o12, endYear: a12 } = c11;
        return "number" == typeof e17 ? e17 >= o12 && e17 <= a12 : e17.isBetween(n12, r12, t12);
      } };
    }, [n11, r11, a11]);
  })(e14);
  const y10 = ep.useMemo(() => nDe(h10, r10, f10), [h10]);
  const v10 = kp(aDe, { [iDe("limited")]: g10.isActive });
  const b10 = ep.useMemo(() => [i10 || "", c10 || ""], [i10, c10]);
  const S10 = l10 || u10 || "";
  const C10 = ep.useMemo(() => PNe(S10, r10), [S10, r10]);
  const x10 = { id: s10, value: b10, menuCustomCSS: v10, rounded: a10, block: true, size: "small", valueFormat: lI, disabled: n10.some((e15) => e15.hasOutstandingDependencies), invalid: !o10 && n10.some((e15) => e15.invalid || e15.expected), daysViewHeaderFormat: m10 || r10.t("paramsView:drDaysViewHeaderFormat", "MMMM YYYY"), locale: eDe(r10), onChange: ([e15, n11]) => {
    t10({ [d10[0]]: e15 ? [e15.toISOString(true)] : [], [d10[1]]: n11 ? [n11.toISOString(true)] : [] });
  }, isValidDate: g10.isActive ? g10.isValidDate : void 0, viewMode: "default" !== p10 ? p10 : void 0, onViewModeChange: g10.isActive ? g10.onViewModeChange : void 0, textModeDaily: r10.t("paramsView:drTabLabelDaily", "Daily"), textModeMonthly: r10.t("paramsView:drTabLabelMonthly", "Monthly"), textModeYearly: r10.t("paramsView:drTabLabelAnnually", "Annually"), textBack: r10.t("paramsView:drTextBack", "Back to Calendar"), textShortcutsList: r10.t("paramsView:drTextShortcutsList", "Common Ranges"), placeholderDateStart: r10.t("paramsView:drPlaceholderDateStart", "Start"), placeholderDateEnd: r10.t("paramsView:drPlaceholderDateEnd", "End"), titleToggle: r10.t("paramsView:drTitleToggle", "Expand Calendar"), shortcuts: y10, monthYearOrder: r10.t("paramsView:drMonthYearOrder", "M-Y"), dateFormat: C10, icon: nf(Ah) };
  return tp.createElement(J_, __spreadValues({}, x10));
});
const [lDe, cDe] = Dp("gcv-slider-container");
const [uDe] = Dp("gcv-slider");
const dDe = ({ children: e14, mode: t10 }) => {
  const n10 = kp(lDe, cDe(`mode-${t10}`));
  return tp.createElement("div", { className: n10 }, e14);
};
const pDe = BNe((e14) => {
  var _a2, _b2;
  const { onSetValues: t10, parameters: n10, control: { binding: r10, range: [o10, a10], step: i10, layout: s10 }, highlightRequired: l10 } = e14;
  const [c10, u10] = ep.useState(false);
  const d10 = s10 || "X";
  const p10 = { id: n10[0].definition.descriptor.name, value: [(_a2 = n10[0].value) != null ? _a2 : o10, (_b2 = n10[1].value) != null ? _b2 : a10], min: o10, max: a10, step: i10, mode: d10, customCSS: uDe, withTooltip: true, invalid: !l10 && !c10 && n10.some((e15) => e15.invalid || e15.expected), onGrab: () => {
    u10(true);
  }, onRelease: ([e15, n11]) => {
    t10({ [r10[0]]: [e15], [r10[1]]: [n11] }), u10(false);
  } };
  return tp.createElement(dDe, { mode: d10 }, tp.createElement(sH, __spreadValues({}, p10)));
});
const mDe = ({ text: e14, action: t10, background: n10, onPreview: r10, onReset: o10, onClear: a10, isValid: i10, i18n: s10, rounded: l10 }) => {
  let c10, u10 = "";
  switch (t10) {
    case "preview":
      c10 = r10, u10 = s10.t("paramsView:btnTextPreview", "Preview");
      break;
    case "reset":
      c10 = o10, u10 = s10.t("paramsView:btnTextReset", "Reset");
      break;
    case "clear":
      c10 = a10, u10 = s10.t("paramsView:btnTextClear", "Clear");
  }
  const d10 = { block: true, size: "small", width: "100%", type: "preview" === t10 ? "submit" : "button", onClick: () => i10 && (c10 == null ? void 0 : c10()), customCSS: i10 ? void 0 : Um, accent: "default" === n10 ? "none" : "full", level: "error" === n10 ? "error" : "warning" === n10 ? "warning" : void 0, text: e14 && "" !== e14 ? e14 : u10, textAlign: "center", rounded: l10 };
  return tp.createElement(qm, __spreadValues({}, d10));
};
const hDe = ({ onSetValues: e14, parameters: [t10], i18n: n10, control: { binding: r10, layout: o10, columns: a10 }, highlightRequired: i10 }) => {
  const s10 = n10.t("paramsView:listTextSelectAllValues", "(select all)");
  const { nullValue: l10, hasOutstandingDependencies: c10, definition: { descriptor: { dataType: u10, selectAllValue: d10 }, values: p10, validValues: m10 } } = t10;
  const h10 = !i10 && (t10.invalid || t10.expected);
  const f10 = m10.filter((e15, t11) => t11 === m10.findIndex((t12) => t12.label === e15.label && YNe(e15.value, t12.value, u10)));
  const g10 = [{ value: d10, label: s10 }, ...f10];
  const y10 = 1 === (p10 == null ? void 0 : p10.length) && YNe(p10[0], d10, u10);
  const v10 = g10.map((e15) => ({ checked: y10 || (p10 == null ? void 0 : p10.some((t11) => YNe(t11, e15.value, u10))), text: e15.label, value: e15.value }));
  const b10 = { type: "checkboxes", layout: { direction: o10, columns: a10 }, size: "small", items: v10, invalid: h10, onChange: /* @__PURE__ */ ((t11) => (n11) => {
    const o11 = t11.find((e15) => e15.value === n11);
    const a11 = t11[0];
    const i11 = !o11.checked;
    let s11;
    if (o11 === a11) s11 = (e15) => i11;
    else if (i11) {
      const e15 = t11.every((e16) => e16.checked || e16 === o11 || e16 === a11);
      s11 = (t12) => e15 || t12.checked || t12 === o11;
    } else s11 = (e15) => true === e15.checked && e15 !== o11 && e15 !== a11;
    e14({ [r10]: t11.filter(s11).map((e15) => e15.value) });
  })(v10), disabled: l10 || c10 };
  return tp.createElement(rI, __spreadValues({}, b10));
};
const fDe = ({ onSetValues: e14, parameters: [t10], control: { binding: n10, layout: r10, columns: o10 }, highlightRequired: a10 }) => {
  const { nullValue: i10, hasOutstandingDependencies: s10, definition: { values: l10, validValues: c10, descriptor: { dataType: u10 } } } = t10;
  const d10 = !a10 && (t10.invalid || t10.expected);
  const p10 = c10.filter((e15, t11) => t11 === c10.findIndex((t12) => t12.label === e15.label && YNe(e15.value, t12.value, u10)));
  const m10 = p10.map((e15) => ({ text: e15.label, value: e15.value, checked: l10 && l10.some((t11) => YNe(t11, e15.value, u10)) }));
  const h10 = { type: "radios", layout: { direction: r10, columns: o10 }, size: "small", items: m10, invalid: d10, onChange: (t11) => {
    e14({ [n10]: [t11] });
  }, disabled: i10 || s10 };
  return tp.createElement(rI, __spreadValues({}, h10));
};
const gDe = BNe(jNe((e14) => {
  const { parameters: [{ definition: { descriptor: { multiValue: t10 } } }] } = e14;
  return tp.createElement(bF, null, tp.createElement(t10 ? hDe : fDe, e14));
}));
const yDe = (e14) => {
  const { onSetValues: t10, parameters: [{ value: n10, nullValue: r10, invalid: o10, expected: a10, hasOutstandingDependencies: i10, definition: { descriptor: { name: s10 } } }], control: { binding: l10, layout: c10, range: [u10, d10], step: p10 }, highlightRequired: m10 } = e14;
  const h10 = !m10 && (o10 || a10);
  const [f10, g10] = ep.useState(false);
  const y10 = c10 || "X";
  const v10 = { id: s10, min: u10, max: d10, step: p10, mode: y10, value: !r10 && "number" == typeof n10 && n10 || u10, withTooltip: true, invalid: !f10 && h10, disabled: r10 || i10, onGrab: () => {
    g10(true);
  }, onRelease: (e15) => {
    t10({ [l10]: [e15] }), g10(false);
  }, customCSS: uDe };
  return tp.createElement(dDe, { mode: y10 }, tp.createElement(iH, __spreadValues({}, v10)));
};
const [vDe, , bDe] = Dp("gcv-number-editor");
const [SDe] = bDe("input");
const [CDe] = bDe("button");
const xDe = /^[+-]?([0-9]+)$/;
const wDe = /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/;
const TDe = (e14) => {
  const t10 = `${e14}`.split(".");
  return 2 === t10.length ? t10[1].length : 0;
};
const EDe = (e14, t10) => parseFloat(e14.toFixed(t10));
const FDe = (e14) => {
  const { onSetValues: t10, parameters: [{ value: n10, nullValue: r10, invalid: o10, expected: a10, hasOutstandingDependencies: i10, definition: { descriptor: { dataType: s10, name: l10 } } }], control: { binding: c10, range: [u10, d10], step: p10, strictInput: m10, placeholder: h10 }, highlightRequired: f10, rounded: g10 } = e14;
  const y10 = !f10 && (o10 || a10);
  const v10 = ep.useMemo(() => {
    const e15 = TDe(p10);
    return { isFloat: e15 > 0, fractionLength: e15 };
  }, []);
  const b10 = (e15) => e15 < u10 ? u10 : e15 > d10 ? d10 : e15;
  const S10 = (e15) => {
    const t11 = parseFloat(e15);
    return b10(m10 ? ((e16) => {
      const t12 = Math.round(e16 / p10) * p10;
      return v10.isFloat ? EDe(t12, v10.fractionLength) : t12;
    })(t11) : t11);
  };
  const C10 = (e15) => () => {
    if (void 0 === n10) return void t10({ [c10]: [e15 < 0 ? d10 : u10] });
    let r11 = n10 + e15;
    if (v10.isFloat) {
      const e16 = m10 ? v10.fractionLength : Math.max(TDe(n10), v10.fractionLength);
      r11 = EDe(r11, e16);
    }
    t10({ [c10]: [b10(r11)] });
  };
  const x10 = void 0 !== n10 ? `${n10}` : "";
  const [w10, T10] = ep.useState(x10);
  const [E10, F10] = ep.useState(y10);
  const [M10, k10] = ep.useState(false);
  ep.useEffect(() => {
    x10 !== w10 && T10(x10);
  }, [n10]), ep.useEffect(() => F10(y10), [y10]);
  const P10 = () => {
    if (E10) T10(x10), F10(y10);
    else {
      const e15 = S10(w10);
      if (isNaN(e15)) return;
      if (m10) {
        const t11 = e15.toString();
        t11 !== w10 && T10(t11);
      }
      t10({ [c10]: [e15] });
    }
  };
  const N10 = r10 || i10;
  const D10 = { icon: Pm(Im), disabled: N10 || n10 === u10, onClick: C10(-p10), title: `-${p10}`, rounded: g10 };
  const L10 = { icon: Pm(_m), disabled: N10 || n10 === d10, onClick: C10(p10), title: `+${p10}`, rounded: g10 };
  const H10 = { id: l10, disabled: N10, size: "small", value: w10, invalid: M10 ? E10 : y10, placeholder: h10, onChange: ({ target: { value: e15 } }) => {
    const t11 = !("Float" === s10 ? wDe : xDe).test(e15);
    let n11 = false;
    if (!t11) {
      const t12 = parseFloat(e15);
      n11 = t12 < u10 || t12 > d10;
    }
    T10(e15), F10(t11 || n11);
  }, onFocus: () => {
    k10(true);
  }, onBlur: () => {
    k10(false), P10();
  }, onKeyDown: (e15) => {
    "Enter" === e15.key && P10();
  }, customCSS: SDe };
  return tp.createElement("div", { className: vDe }, tp.createElement(qm, __spreadProps(__spreadValues({}, D10), { customCSS: CDe, size: "small" })), tp.createElement(KF, __spreadValues({}, H10)), tp.createElement(qm, __spreadProps(__spreadValues({}, L10), { customCSS: CDe, size: "small" })));
};
const MDe = BNe(jNe((e14) => {
  switch (e14.control.subType) {
    case "slider":
      return tp.createElement(yDe, __spreadValues({}, e14));
    case "up-down":
      return tp.createElement(FDe, __spreadValues({}, e14));
    default:
      return null;
  }
}));
const kDe = ({ text: e14, font: t10, color: n10, align: r10, strikeThrough: o10 }) => {
  const a10 = { text: e14, size: "small", level: tDe(n10), uppercase: "uppercase" === t10.transform, weight: t10.bold ? "bold" : "normal", align: r10, strikeThrough: o10 };
  return tp.createElement(LE, __spreadValues({}, a10));
};
const [PDe, NDe] = Dp("gcv-plain-text");
const DDe = ({ text: e14, font: { bold: t10, italic: n10, transform: r10, underline: o10 }, color: a10, align: i10, multiline: s10 }) => {
  const l10 = tDe(a10);
  const c10 = kp(PDe, { [NDe(l10)]: void 0 !== l10 });
  const u10 = { textOverflow: "ellipsis", whiteSpace: s10 ? "pre-wrap" : "nowrap", wordWrap: s10 ? "break-word" : "normal", fontWeight: t10 ? "bold" : "normal", fontStyle: n10 ? "italic" : "normal", textAlign: i10, textDecoration: o10 ? "underline" : "none", textTransform: r10 || "none" };
  return tp.createElement("p", { className: c10, style: u10 }, e14);
};
const LDe = ({ value: e14, label: t10 }) => ({ label: t10, value: e14 });
const HDe = { nodes: [] };
const [IDe, , _De] = Dp("gcv-tree-node");
const [VDe] = _De("toggle");
const [RDe] = _De("control");
const ADe = ({ fields: e14, mode: t10 }, n10, r10, o10) => {
  const [a10, i10] = ep.useState(HDe);
  const s10 = ({ label: e15, value: t11, nodes: n11 }) => ({ id: t11, text: e15, value: t11, nodes: (n11 == null ? void 0 : n11.map(s10)) || void 0 });
  return ep.useEffect(() => {
    const o11 = r10 || [];
    const a11 = o11.indexOf(e14[0]);
    let l10 = [];
    switch (t10) {
      case "recursive":
        l10 = function(e15) {
          const t12 = e15.reduce((e16, t13) => __spreadProps(__spreadValues({}, e16), { [t13.value]: LDe(t13) }), {});
          const n11 = [];
          return e15.forEach((e16) => {
            const r12 = t12[e16.value];
            const o12 = null != e16.parent && t12[e16.parent] || null;
            null == o12 ? n11.push(r12) : (null == o12.nodes && (o12.nodes = []), o12.nodes.push(r12));
          }), n11;
        }(n10.map(({ value: e15, label: t12, fields: n11 }) => ({ value: e15, label: t12, parent: n11 == null ? void 0 : n11[a11] })));
        break;
      case "groupby":
        const t11 = e14.map((e15) => o11.indexOf(e15));
        l10 = function(e15) {
          if (0 === e15.length) return [];
          const t12 = e15[0].groupBy.length;
          return 0 == t12 ? e15.map(LDe) : function e16(n11, r12, o12) {
            const a12 = function(e17, t13) {
              const n12 = {};
              return e17.map((e18) => ({ i: e18, key: t13(e18) })).forEach(({ i: e18, key: t14 }) => (n12[t14] = n12[t14] || []).push(e18)), n12;
            }(n11, (e17) => e17.groupBy[r12]);
            return Object.keys(a12).map((n12, i11) => {
              const s11 = `${o12}${i11}`;
              return { value: s11, label: n12, nodes: r12 === t12 - 1 ? a12[n12].map(LDe) : e16(a12[n12], r12 + 1, `${s11}_`) };
            });
          }(e15, 0, "$#");
        }(n10.map(({ value: e15, label: n11, fields: r12 }) => ({ value: e15, label: n11, groupBy: t11.map((e16) => r12 == null ? void 0 : r12[e16]) })));
        break;
      case "pathstring":
        const r11 = n10.map(({ value: e15, label: t12, fields: n11 }) => {
          var _a2;
          return { value: e15, label: t12, path: (_a2 = n11 == null ? void 0 : n11[a11]) == null ? void 0 : _a2.toString() };
        });
        l10 = function(e15) {
          const t12 = { nodes: {}, items: [] };
          return e15.forEach(function(e16) {
            var _a2;
            for (let n11 = t12, r12 = (_a2 = e16.path) == null ? void 0 : _a2.toString(); ; r12 = r12.slice(1)) {
              if ("string" != typeof r12 || 0 == r12.length) {
                n11.items.push(e16);
                break;
              }
              const t13 = r12[0];
              n11 = n11.nodes[t13] = n11.nodes[t13] || { nodes: {}, items: [] };
            }
          }), function e16(t13) {
            const n11 = Object.keys(t13.nodes).map((n12) => e16(t13.nodes[n12]));
            const r12 = [].concat(...n11);
            if (0 === t13.items.length) return r12;
            const { value: o12, label: a12 } = t13.items[0];
            const i11 = [0 === r12.length ? { value: o12, label: a12 } : { value: o12, label: a12, nodes: r12 }];
            return i11.push(...t13.items.slice(1).map(LDe)), i11;
          }(t12);
        }(r11);
    }
    i10({ nodes: l10.map(s10) });
  }, [n10]), [a10.nodes, (e15, t11, n11) => {
    const { nodes: r11, expanded: s11 } = e15;
    let l10;
    r11 && r11.length > 0 && (l10 = Pm(s11 ? Im : _m));
    const c10 = { customCSS: VDe, icon: l10, disabled: n11, size: "small", accent: "icon", background: "transparent", onClick: () => ((e16, t12) => {
      !e16.nodes || e16.nodes.length < 1 || i10(AV(a10, (/* @__PURE__ */ ((e17, t13) => (n12) => n12.reduceRight((e18, t14) => ({ nodes: { [t14]: __spreadValues({}, e18) } }), { [e17]: { $set: t13 } }))("expanded", !e16.expanded))(t12)));
    })(e15, t11) };
    return tp.createElement("div", { className: IDe }, r11 && r11.length && tp.createElement(qm, __spreadValues({}, c10)), tp.createElement("div", { className: RDe }, o10 && o10(e15, t11, n11)));
  }];
};
const [ODe] = Dp("gcv-tree-node-text");
Dp("gcv-tree-content");
const BDe = ({ control: e14, control: { binding: t10 }, parameters: [n10], onSetValues: r10, treeHeight: o10 }) => {
  const { definition: { descriptor: { extraFields: a10, dataType: i10 }, values: s10, validValues: l10 } } = n10;
  const c10 = ({ nodes: e15, value: n11 }) => () => {
    e15 || r10({ [t10]: KNe(s10, n11, i10) ? [] : [n11] });
  };
  const [u10, d10] = ADe(e14, l10, a10, (e15, t11, n11) => {
    const { nodes: r11, text: o11, value: a11 } = e15;
    if (r11 && r11.length) return tp.createElement("span", { className: ODe }, o11);
    const l11 = { block: true, size: "small", text: o11, disabled: n11, checked: KNe(s10, a11, i10), onChange: c10(e15) };
    return tp.createElement(CE, __spreadValues({}, l11));
  });
  const p10 = { outline: true, nodes: u10, renderNode: d10 };
  return tp.createElement("div", { style: { height: o10 } }, tp.createElement(eI, __spreadValues({}, p10)));
};
const zDe = ({ control: e14, control: { binding: t10 }, parameters: [n10], onSetValues: r10, treeHeight: o10 }) => {
  const { definition: { descriptor: { extraFields: a10, dataType: i10, selectAllValue: s10 }, values: l10, validValues: c10 } } = n10;
  const u10 = l10[0] === s10 ? [...c10.map(({ value: e15 }) => e15)] : l10;
  const d10 = (e15) => {
    let t11 = [];
    return e15.forEach((e16) => {
      e16.nodes && e16.nodes.length ? t11 = [...t11, ...d10(e16.nodes)] : t11.push(e16.value);
    }), t11;
  };
  const p10 = ({ nodes: e15, value: n11 }) => () => {
    if (e15) {
      const n12 = [...u10];
      const o12 = d10(e15);
      return void (o12.every((e16) => KNe(u10, e16, i10)) ? (o12.forEach((e16) => {
        const t11 = n12.findIndex((t12) => YNe(t12, e16, i10));
        -1 !== t11 && n12.splice(t11, 1);
      }), r10({ [t10]: n12 })) : (o12.forEach((e16) => !KNe(u10, e16, i10) && n12.push(e16)), r10({ [t10]: n12 })));
    }
    const o11 = u10.findIndex((e16) => YNe(e16, n11, i10));
    r10(-1 !== o11 ? { [t10]: AV(u10, { $splice: [[o11, 1]] }) } : { [t10]: AV(u10, { $push: [n11] }) });
  };
  const [m10, h10] = ADe(e14, c10, a10, (e15, t11, n11) => {
    const { text: r11, value: o11, nodes: a11 } = e15;
    let s11 = false, l11 = false;
    if (a11 && a11.length > 0) {
      let e16 = true, t12 = false;
      const n12 = d10(a11);
      for (let r12 = 0; r12 < n12.length && (!t12 || e16); r12++) KNe(u10, n12[r12], i10) ? t12 = true : e16 = false;
      s11 = e16, l11 = t12 && !e16;
    } else s11 = KNe(u10, o11, i10);
    const c11 = { block: true, size: "small", text: r11, disabled: n11, checked: s11, indeterminate: l11, onChange: p10(e15) };
    return tp.createElement(CE, __spreadValues({}, c11));
  });
  const f10 = { outline: true, nodes: m10, renderNode: h10, onNodeClick: p10 };
  return tp.createElement("div", { style: { height: o10 } }, tp.createElement(eI, __spreadValues({}, f10)));
};
const [$De] = Dp("gcv-tree");
const WDe = BNe(jNe((e14) => {
  const { control: { subType: t10 }, parameters: [n10], i18n: r10, rounded: o10 } = e14;
  const { nullValue: a10, definition: { values: i10, validValues: s10 } } = n10;
  const l10 = ep.useMemo(() => s10.length > 7 ? "210px" : 30 * s10.length + "px", [s10]);
  const c10 = r10.t("paramsView:ddeTextNull", "(null)");
  const u10 = n10.definition.descriptor.multiValue ? tp.createElement(zDe, __spreadProps(__spreadValues({}, e14), { treeHeight: l10 })) : tp.createElement(BDe, __spreadProps(__spreadValues({}, e14), { treeHeight: l10 }));
  if ("dropdown" === t10) {
    const e15 = s10.filter((e16) => KNe(i10, e16.value)).map((e16) => e16.label) || [];
    const t11 = { text: a10 ? c10 : e15.join(", "), block: true, size: "small", width: "100%", menuAlign: "right", menuWidth: "100%", menuMaxHeight: 210, content: u10, disabled: a10, rounded: o10 };
    return tp.createElement(UF, __spreadValues({}, t11));
  }
  return tp.createElement("div", { className: $De }, tp.createElement(bF, null, u10));
}));
const jDe = BNe(jNe((e14) => e14.editor(e14)));
const [ZDe, GDe, UDe] = Dp("gcv-parameters");
const [qDe, YDe] = UDe("control");
const KDe = (e14, t10, n10) => (Array.isArray(t10) ? t10 : [t10]).map((t11) => ((e15, t12, n11) => {
  const r10 = e15.byName[t12];
  if (!r10) return null;
  const { descriptor: o10, values: a10, state: i10, error: s10, validValues: l10 } = r10;
  const c10 = CNe(a10 || [], o10.nullable);
  const { displayFormat: u10 } = o10;
  let d10 = r10;
  return u10 && (d10 = __spreadProps(__spreadValues({}, r10), { validValues: l10.map((e16) => __spreadProps(__spreadValues({}, e16), { label: e16.label || HNe(e16.value, n11, u10) })) })), { definition: d10, value: c10, nullValue: !!o10.nullable && null === c10, invalid: i10 === SNe.validationFailed, validationMessage: null !== s10 ? ANe(n11, s10) : s10, hasOutstandingDependencies: i10 === SNe.hasOutstandingDependencies, expected: i10 === SNe.expectValue };
})(e14, t11, n10));
const XDe = (e14) => {
  switch (e14.label.display) {
    case "bottom":
      return "bottom-left";
    case "right":
      return "top-right";
    default:
      return "top-left";
  }
};
const JDe = ({ children: e14, style: t10, modifier: n10 }) => tp.createElement("div", { style: t10, className: kp(qDe, n10 && YDe(n10)) }, e14);
const QDe = ({ freeForm: e14, onRun: t10, onReset: n10, onClear: r10, onSetValues: o10, parameters: a10, i18n: i10, control: s10, allowPreview: l10, top: c10, left: u10, width: d10, height: p10, softValidation: m10, customControls: h10, rounded: f10 }) => {
  const g10 = e14 ? { top: c10, left: u10, width: d10, height: p10 } : { height: p10 };
  if ("button" === s10.type || "heading" === s10.type || "plain-text" === s10.type || "nullify" === s10.type) switch (s10.type) {
    case "button": {
      const e15 = "preview" === s10.action && !l10 || a10.validating;
      return tp.createElement(JDe, { style: g10, modifier: "preview" }, tp.createElement(mDe, __spreadProps(__spreadValues({ onPreview: t10, onClear: r10, onReset: n10 }, s10), { isValid: !e15, i18n: i10, rounded: f10 })));
    }
    case "heading":
      return tp.createElement(JDe, { style: g10 }, tp.createElement(kDe, __spreadValues({}, s10)));
    case "plain-text":
      return tp.createElement(JDe, { style: g10 }, tp.createElement(DDe, __spreadValues({}, s10)));
    default:
      return null;
  }
  const y10 = KDe(a10, s10.binding, i10);
  if (y10.some((e15) => null === e15)) return null;
  const v10 = m10 && y10.some((e15) => e15.expected);
  const b10 = { control: s10, onSetValues: o10, parameters: y10, i18n: i10, highlightRequired: v10, rounded: f10 };
  let S10 = null;
  switch (s10.type) {
    case "number":
      S10 = tp.createElement(MDe, __spreadValues({}, b10));
      break;
    case "text":
      S10 = tp.createElement(ZNe, __spreadValues({}, b10));
      break;
    case "boolean":
      S10 = tp.createElement(UNe, __spreadValues({}, b10));
      break;
    case "multivalue":
      S10 = tp.createElement(qNe, __spreadValues({}, b10));
      break;
    case "dropdown":
      S10 = tp.createElement(JNe, __spreadValues({}, b10));
      break;
    case "date-time":
      S10 = tp.createElement(rDe, __spreadValues({}, b10));
      break;
    case "date-range":
      S10 = tp.createElement(sDe, __spreadValues({}, b10));
      break;
    case "date-time-range":
      S10 = tp.createElement(oDe, __spreadValues({}, b10));
      break;
    case "number-range":
      S10 = tp.createElement(pDe, __spreadValues({}, b10));
      break;
    case "list":
      S10 = tp.createElement(gDe, __spreadValues({}, b10));
      break;
    case "tree":
      S10 = tp.createElement(WDe, __spreadValues({}, b10));
      break;
    case "custom":
      if (h10 && h10[s10.subtype]) {
        const e15 = __spreadValues({ editor: h10[s10.subtype] }, b10);
        S10 = tp.createElement(jDe, __spreadValues({}, e15));
        break;
      }
      return null;
    default:
      return null;
  }
  return tp.createElement(JDe, { style: g10, modifier: v10 ? `required-${XDe(s10)}` : void 0 }, S10);
};
class eLe extends tp.Component {
  constructor() {
    super(...arguments), this.props = this.props, this.state = FNe(), this.getControlsHeight = () => {
      const { view: { controls: e14 } } = this.state;
      return e14.reduce((e15, t10) => {
        const n10 = t10.top + t10.height;
        return n10 > e15 ? n10 : e15;
      }, 0);
    }, this.hasRequiredDependentParams = () => {
      const { parameters: e14 } = this.state;
      return Object.values(e14.byName).reduce((t10, n10) => !!t10 || !n10.descriptor.nullable && n10.descriptor.dependsOn.some((t11) => 0 === e14.byName[t11].values.length), false);
    }, this.onRun = () => {
      const { state: { softValidation: e14, valid: t10, parameters: { validating: n10 } }, props: { dispatch: r10, onRun: o10 } } = this;
      e14 && r10({ type: "@paramsView/TOGGLE_SOFT_ERRORS" }), n10 ? r10({ type: "@paramsView/PREVIEW_DELAYED" }) : t10 && (o10(), r10({ type: "@paramsView/PREVIEW_REQUESTED" }));
    }, this.onClear = () => {
      (0, this.props.onSetValues)(this.state.parameters.all.reduce((e14, t10) => __spreadProps(__spreadValues({}, e14), { [t10]: [] }), {}));
    }, this.onReset = () => this.props.dispatch({ type: "@paramsView/RESET" }), this.onSubmit = (e14) => {
      e14.preventDefault();
    };
  }
  componentDidUpdate(e14, t10) {
    this.state.previewIsDelayed && t10.parameters.validating && !this.state.parameters.validating && this.onRun();
  }
  render() {
    var _a2, _b2;
    const { props: { rounded: e14 }, state: { withModel: t10, view: { controls: n10 }, parameters: r10, valid: o10, softValidation: a10, layout: i10 } } = this;
    const s10 = n10.length ? n10 : (({ parameters: e15 }) => {
      const t11 = 300, n11 = 2 * Rp;
      let r11 = 0;
      let o11 = [];
      return e15.all.forEach((a11) => {
        const { descriptor: { dataType: i11, name: s11, prompt: l11, hidden: c11, multiValue: u11, hasValidValues: d11, displayFormat: p10 } } = e15.byName[a11];
        if (c11) return;
        const m10 = { display: "top", text: l11, color: "default", font: { bold: false, italic: false, underline: false, transform: "none" } };
        d11 ? o11.push({ left: 0, width: t11, top: r11, height: n11, control: { type: "dropdown", binding: s11, label: m10 } }) : u11 ? o11.push({ left: 0, width: t11, top: r11, height: n11, control: { type: "multivalue", binding: s11, label: m10 } }) : "Boolean" === i11 ? o11.push({ left: 0, width: t11, top: r11, height: n11, control: { type: "boolean", binding: s11, label: m10, subType: "radio", layout: "horizontal", text: "", textTrue: "", textFalse: "" } }) : "Date" === i11 || "DateTime" === i11 ? o11.push({ left: 0, width: t11, top: r11, height: n11, control: { type: "date-time", binding: s11, label: m10, daysViewHeaderFormat: "", displayFormat: p10 } }) : o11.push({ left: 0, width: t11, top: r11, height: n11, control: { type: "text", binding: s11, label: m10 } }), r11 += n11;
      }), o11.push({ left: 0, width: t11, top: r11, height: Rp, control: { type: "button", action: "preview", text: "", background: "accent" } }), o11;
    })(this.state);
    if (!s10.length) return null;
    const l10 = (_a2 = this.props.i18n) != null ? _a2 : dG;
    this.props.i18n || dG.isInitialized || dG.init({});
    const c10 = t10 && "free-form" === i10;
    const u10 = kp(ZDe, { [GDe("free-form")]: c10, [GDe("layout-" + ("free-form" === i10 ? "horizontal" : "vertical"))]: !c10 });
    const d10 = o10 || a10 && !this.hasRequiredDependentParams() && s10.reduce((e15, { control: t11 }) => {
      if (!e15) return e15;
      switch (t11.type) {
        case "button":
        case "heading":
        case "plain-text":
        case "nullify":
          return e15;
        default: {
          if (r10.validating) return false;
          const n11 = KDe(r10, t11.binding, l10);
          return (n11.some((e16) => null === e16) || !n11.some((e16) => e16.invalid)) && e15;
        }
      }
    }, true);
    return tp.createElement("form", { className: u10, style: c10 ? { height: ((_b2 = this.state.view.canvas) == null ? void 0 : _b2.height) || this.getControlsHeight() } : void 0, onSubmit: this.onSubmit }, s10.map((t11, n11) => {
      const o11 = __spreadProps(__spreadValues(__spreadValues({}, this.props), t11), { i18n: l10, parameters: r10, allowPreview: d10, freeForm: c10, onRun: this.onRun, onClear: this.onClear, onReset: this.onReset, softValidation: a10, rounded: e14 });
      return tp.createElement(QDe, __spreadValues({ key: n11 }, o11));
    }));
  }
}
eLe.defaultProps = { rounded: false };
HD(QD);
HD(_L);
HD(XD);
HD(AL);
tp.Component;
tp.Component;
const [tLe] = Dp("pve-datetime-editor");
const nLe = (e14) => !e14 || sI(e14, iI.ISO_8601).isValid();
const rLe = ({ setProperty: e14, descriptor: t10, value: n10, disabled: r10, dateOnly: o10 = false, displayFormat: a10, disabledValidation: i10 }) => {
  const { t: s10, i18n: l10 } = vp("parametersViewEditor");
  const [c10, u10] = ep.useState(false);
  ep.useEffect(() => {
    i10 || u10(!nLe(n10));
  }, [i10, n10]);
  const d10 = l10.language.toLowerCase();
  const p10 = { value: n10, valueFormat: lI, onChange: (n11) => {
    const r11 = nLe(n11);
    u10(!r11);
    const o11 = "string" == typeof n11 ? n11 : n11.toISOString(true);
    e14(t10, o11);
  }, pickerMode: o10 ? "date" : "date-time", locale: "zh" === d10 ? "zh-cn" : d10, block: true, size: "small", disabled: r10, customCSS: tLe, monthYearOrder: "Y-M" === s10("dateTimeParameterLabels.monthYearOrder") ? "Y-M" : "M-Y", textShortcutClear: s10("dateTimeParameterLabels.textClear"), textShortcutToday: s10("dateTimeParameterLabels.textToday"), textBack: s10("dateTimeParameterLabels.textBack"), dateTimeFormat: a10, invalid: c10 };
  return ep.createElement(E_, __spreadValues({}, p10));
};
const oLe = _D(rLe);
const aLe = kde((e14) => {
  const { descriptor: t10, value: n10 } = e14;
  const { meta: r10, type: o10 } = t10;
  const { expressionSyntax: a10 } = ep.useContext(Vue);
  const i10 = que(e14);
  const s10 = __spreadProps(__spreadValues({}, e14), { value: HJ(n10, o10, { expressionSyntax: a10 }, r10, String(n10 != null ? n10 : "")) });
  return tp.createElement(rLe, __spreadValues({ disabledValidation: "Expression" === i10 }, s10));
});
const iLe = (e14) => ({ placeholderEmpty: e14("parametersViewEditor:placeholderEmpty"), placeholderMultipleValues: e14("parametersViewEditor:placeholderMultipleValues") });
const sLe = (e14) => {
  switch (e14) {
    case "Date":
    case "DateTime":
    case "String":
    case "Integer":
    case "Float":
      return "";
    case "Boolean":
      return "False";
    default:
      return;
  }
};
const lLe = ({ value: e14, currentControl: t10, dataType: n10, props: r10, setProperty: o10, t: a10 }) => {
  let i10 = __spreadProps(__spreadValues({}, r10), { setProperty: o10, value: e14, defaultValue: sLe(n10) });
  const s10 = r10.descriptor;
  if ("text" !== t10.type) switch (n10) {
    case "Integer":
    case "Float":
      switch (i10 = __spreadProps(__spreadValues({}, r10), { setProperty: o10, value: e14, defaultValue: sLe(n10) }), t10.type) {
        case "number":
        case "number-range": {
          const [e15, r11] = t10.range;
          const o11 = __spreadProps(__spreadValues({}, s10.meta), { numberType: n10, minValue: e15, maxValue: r11, step: t10.step, valueMode: "string", emptyValue: "EmptyString" });
          i10.descriptor = $N(s10.category, s10.label, "number_expr", s10.valuePath, void 0, o11);
          break;
        }
        case "tree":
        case "list":
        case "dropdown":
        case "multivalue": {
          const e15 = "Integer" === n10 ? 5 : 0.1;
          const t11 = __spreadProps(__spreadValues({}, s10.meta), { numberType: n10, step: e15, valueMode: "string", emptyValue: "EmptyString" });
          i10.descriptor = $N(s10.category, s10.label, "number_expr", s10.valuePath, void 0, t11);
          break;
        }
      }
      return tp.createElement(QSe, __spreadValues({}, i10));
    case "Boolean": {
      const { descriptor: t11 } = r10;
      return tp.createElement(eme, __spreadProps(__spreadValues({}, i10), { value: e14 || sLe(n10), descriptor: __spreadProps(__spreadValues({}, t11), { type: "boolean_expr", meta: __spreadProps(__spreadValues({}, s10.meta), { valueMode: "string" }) }) }));
    }
    case "Date":
    case "DateTime": {
      const e15 = PNe(r10.value.DisplayFormat, { t: a10 });
      return i10.descriptor = $N(s10.category, s10.label, "string_expr", s10.valuePath, void 0, s10.meta), tp.createElement(aLe, __spreadProps(__spreadValues({}, i10), { displayFormat: e15, dateOnly: "Date" === n10 }));
    }
  }
  return tp.createElement(Lpe, __spreadValues(__spreadProps(__spreadValues({}, i10), { descriptor: __spreadProps(__spreadValues({}, r10.descriptor), { type: "string_expr" }) }), iLe(a10)));
};
const cLe = (e14) => {
  const { t: t10 } = vp("parametersViewEditor");
  const { descriptor: n10, value: r10, placeholderEmpty: o10, setProperty: a10 } = e14;
  const { meta: i10 } = n10;
  const s10 = (i10 == null ? void 0 : i10.parameterType) || "String";
  const l10 = ep.useCallback((e15, r11) => {
    let l11 = { descriptor: __spreadProps(__spreadValues({}, n10), { type: "string_expr", valuePath: `${n10.valuePath}.${r11}` }), value: e15, setProperty: a10, defaultValue: sLe(s10) };
    switch (s10) {
      case "Integer":
      case "Float": {
        const t11 = "Integer" === s10 ? 5 : 0.1;
        return l11 = __spreadProps(__spreadValues({}, l11), { descriptor: __spreadProps(__spreadValues({}, l11.descriptor), { type: "number_expr", meta: { numberType: s10, valueMode: "string", step: t11, emptyValue: "EmptyString" } }), value: e15 }), tp.createElement(QSe, __spreadValues({}, l11));
      }
      case "Boolean":
        return l11 = __spreadProps(__spreadValues({}, l11), { descriptor: __spreadProps(__spreadValues({}, l11.descriptor), { type: "boolean_expr" }), value: e15 || sLe(s10) }), tp.createElement(eme, __spreadValues({}, l11));
      case "Date":
      case "DateTime": {
        const n11 = PNe((i10 == null ? void 0 : i10.displayFormat) || "", { t: t10 });
        const r12 = "Date" === s10;
        return l11 = __spreadProps(__spreadValues({}, l11), { value: e15, dateOnly: r12, displayFormat: n11 }), tp.createElement(aLe, __spreadValues({}, l11));
      }
    }
    return l11 = __spreadProps(__spreadValues({}, l11), { placeholderEmpty: o10 }), tp.createElement(Lpe, __spreadValues({}, l11));
  }, [n10, i10 == null ? void 0 : i10.displayFormat, s10, o10, a10, t10]);
  const c10 = __spreadProps(__spreadValues({}, e14), { value: r10 || [], reordering: { type: "drag" }, createEditor: l10, onAdd: () => a10(n10, AV(r10 || [], { $push: [""] })), onDelete: (e15) => a10(n10, AV(r10, { $splice: [[e15, 1]] })) });
  return tp.createElement(Bde, __spreadValues({}, c10));
};
cLe.displayName = "ParameterTypeCollectionEditor";
const [uLe] = Dp("wd-parameter-default-value-reference");
const dLe = $N("", Ude("dataSetName"), "dataset_name", "DataSetName");
const pLe = $N("defaultValue", Ude("valueField"), "default_dataset_fields", "ValueField");
const mLe = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { descriptor: { valuePath: n10 }, value: r10, defaultValue: o10, setProperty: a10, disabled: i10 } = e14;
  const { setProperties: s10 } = ep.useContext(Iue);
  const { editExpression: l10, dataSets: c10, dataSources: u10, semanticInfo: d10 } = ep.useContext(Vue);
  const p10 = ep.useContext(qde);
  const m10 = ep.useMemo(() => ({ dataSetName: WN(dLe, n10), dValueField: WN(pLe, n10) }), [n10]);
  const h10 = { menuMaxHeight: 300, size: "small", disabled: i10 };
  const f10 = { block: true, position: "left", size: "small", disabled: i10 };
  const g10 = b$(u10[0]);
  const y10 = p10[dLe.type];
  const v10 = __spreadProps(__spreadValues({}, h10), { text: r10.DataSetName || t10("reportParameter.placeholderEmpty"), placeholderText: !r10.DataSetName, items: [...y10.map((e15) => ({ type: "button", text: e15, value: e15 }))], onSelect: (e15) => {
    r10 && r10.DataSetName !== e15 && s10([{ descriptor: m10.dataSetName, value: e15 }, { descriptor: m10.dValueField, value: o10 && o10.ValueField || "" }]);
  } });
  const b10 = __spreadProps(__spreadValues({}, h10), { text: r10.ValueField || t10("reportParameter.placeholderEmpty"), placeholderText: !r10.ValueField, onSelect: (e15) => {
    a10(m10.dValueField, e15);
  } });
  if (g10 && d10) {
    const { semanticModel: e15, allowRebalancing: t11, showAggregates: n11, showCalculatedFields: r11 } = d10;
    const o11 = { descriptor: m10.dValueField, dataSets: c10.filter((e16) => p10.default_value_data_scope.dataSetName === e16.Name), withReset: true, editExpression: l10, setProperty: a10, allowRebalancing: t11, showAggregates: n11, showCalculatedFields: r11, isExpression: false, semanticModel: e15, selectedItemTypes: [] };
    b10.content = tp.createElement(Ede, __spreadValues({}, o11));
  } else {
    const e15 = p10[pLe.type];
    b10.items = [...e15.map((e16) => ({ type: "button", text: e16, value: e16 }))];
  }
  return tp.createElement("div", { className: uLe }, tp.createElement(AN, __spreadProps(__spreadValues({}, f10), { label: t10(m10.dataSetName.label) }), tp.createElement(UF, __spreadValues({}, v10))), tp.createElement(AN, __spreadProps(__spreadValues({}, f10), { label: t10(m10.dValueField.label) }), tp.createElement(UF, __spreadValues({}, b10))));
};
mLe.displayName = "DefaultValueDataSetReference";
const [, , hLe] = Dp("wd-parameter-default-value");
const [fLe] = hLe("checklist-item");
const gLe = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { descriptor: n10, descriptor: { meta: r10 }, value: o10, defaultValue: a10, setProperty: i10 } = e14;
  const [s10, l10] = ep.useState(!o10 || 0 === o10.Values.length);
  const c10 = r10 == null ? void 0 : r10.disabled;
  const u10 = { descriptor: $N(t10(n10.category), "", "", `${n10.valuePath}.DataSetReference`), value: o10 && o10.DataSetReference, defaultValue: a10 && a10.DataSetReference, setProperty: i10, disabled: c10 };
  const d10 = { descriptor: $N(t10(n10.category), Ude("values"), "string_expr", `${n10.valuePath}.Values`, void 0, __spreadProps(__spreadValues({}, r10), { disableDataFields: true })), value: o10 && o10.Values, defaultValue: a10 && a10.Values, placeholderEmpty: t10("reportParameter.placeholderEmpty"), setProperty: i10, disabled: c10 };
  const p10 = { label: t10("reportParameter.labelSource"), position: "left", block: true, size: "small", disabled: c10 };
  const m10 = { block: true, onChange: () => {
    if (s10) {
      (o10.DataSetReference.DataSetName !== a10.DataSetReference.DataSetName || o10.DataSetReference.ValueField !== a10.DataSetReference.ValueField) && i10(__spreadProps(__spreadValues({}, n10), { valuePath: `${n10.valuePath}.DataSetReference` }), __spreadValues({}, a10.DataSetReference));
    } else o10.Values.length > 0 && i10(__spreadProps(__spreadValues({}, n10), { valuePath: `${n10.valuePath}.Values` }), []);
    l10(!s10);
  }, value: "", customCSS: fLe };
  const h10 = { type: "radios", size: "small", items: [__spreadProps(__spreadValues({}, m10), { text: t10("reportParameter.labelFromQuery"), checked: s10 }), __spreadProps(__spreadValues({}, m10), { text: t10("reportParameter.labelNonQueried"), checked: !s10 })], layout: { direction: "horizontal", columns: 2 }, disabled: c10 };
  return tp.createElement(tp.Fragment, null, tp.createElement(AN, __spreadValues({}, p10), tp.createElement(rI, __spreadValues({}, h10))), s10 ? tp.createElement(mLe, __spreadValues({}, u10)) : tp.createElement(cLe, __spreadValues({}, d10)));
};
gLe.displayName = "ReportParameterDefaultValueEditor";
const yLe = (e14) => {
  const { value: t10, defaultValue: n10, nestedDescriptors: r10, descriptor: { valuePath: o10 } } = e14;
  const a10 = jN(r10[0].valuePath);
  const i10 = jN(r10[1].valuePath);
  const s10 = WN(r10[0], o10);
  const l10 = WN(r10[1], o10);
  const c10 = __spreadProps(__spreadValues({}, e14), { descriptor: s10, value: a10(t10), defaultValue: a10(n10) });
  const u10 = __spreadProps(__spreadValues({}, e14), { descriptor: l10, value: i10(t10), defaultValue: i10(n10) });
  return tp.createElement(tp.Fragment, null, tp.createElement(She, __spreadValues({}, c10)), tp.createElement(She, __spreadValues({}, u10)));
};
const vLe = { EndPointX: Zq(cY, "dimensions.endPointX", "length_locsize", "EndPoint.X", void 0, OY), EndPointY: Zq(cY, "dimensions.endPointY", "length_locsize", "EndPoint.Y", void 0, qq.length340), FixedHeight: Zq(oY, "dimensions.fixedHeight", "length_locsize", "$fixedPlace.Height", void 0, OY), FixedWidth: Zq(oY, "dimensions.fixedWidth", "length_locsize", "$fixedPlace.Width", void 0, OY), Height: Zq(oY, "dimensions.height", "length_locsize", "$place.Height", void 0, OY), Left: Zq(oY, "dimensions.left", "length_locsize", "$place.Left", void 0, OY), Top: Zq(oY, "dimensions.top", "length_locsize", "$place.Top", void 0, qq.length340), StartPointX: Zq(cY, "dimensions.startPointX", "length_locsize", "StartPoint.X", void 0, OY), StartPointY: Zq(cY, "dimensions.startPointY", "length_locsize", "StartPoint.Y", void 0, qq.length340), Width: Zq(oY, "dimensions.width", "length_locsize", "$place.Width", void 0, OY) };
const bLe = (e14) => tp.createElement(yLe, __spreadProps(__spreadValues({}, e14), { nestedDescriptors: [vLe.StartPointX, vLe.StartPointY] }));
bLe.displayName = "StartPointEditor";
const SLe = (e14) => tp.createElement(yLe, __spreadProps(__spreadValues({}, e14), { nestedDescriptors: [vLe.EndPointX, vLe.EndPointY] }));
SLe.displayName = "EndPointEditor";
const CLe = (e14) => tp.createElement(yLe, __spreadProps(__spreadValues({}, e14), { nestedDescriptors: [vLe.Left, vLe.Top] }));
CLe.displayName = "LocationEditor";
const xLe = (e14) => tp.createElement(yLe, __spreadProps(__spreadValues({}, e14), { nestedDescriptors: [vLe.Width, vLe.Height] }));
function wLe(e14) {
  return "available" === e14.status;
}
function TLe(e14) {
  return "loading" === e14.status;
}
function ELe(e14) {
  return "loaded" === e14.status;
}
function FLe(e14) {
  return "error" === e14.status;
}
xLe.displayName = "SizeEditor";
const MLe = (e14, t10) => {
  if ("partitem" !== e14.Type && "fixedpagepartitem" !== e14.Type) return true;
  const { Library: n10, ReportPart: r10 } = e14;
  const o10 = t10 == null ? void 0 : t10.find((e15) => e15.Name === n10);
  const a10 = (o10 && ELe(o10) ? o10.reportParts : []).find((e15) => e15.Name === r10);
  return "line" !== (a10 == null ? void 0 : a10.item.Type);
};
const kLe = (e14) => {
  const { value: t10 } = e14;
  const { rdlx: { reportPartsLibraries: { libraries: n10 } } } = d9();
  return tp.createElement(yLe, __spreadProps(__spreadValues({}, e14), { disabled: !MLe(t10, n10), nestedDescriptors: [vLe.Width, vLe.Height] }));
};
kLe.displayName = "PartItemSizeEditor";
const PLe = (e14, ...t10) => console.warn(`[queryFilterConverter] ${e14}`, ...t10);
const NLe = (e14) => e14.hasOwnProperty("items");
const DLe = (e14, t10) => ({ operator: e14, items: t10 });
const LLe = (e14, t10) => ({ Type: "filter", operator: e14, items: t10 });
const HLe = (e14, t10, n10) => ({ field: e14, operator: t10, value: n10 });
const ILe = (e14, t10) => ({ type: "generic", value: e14, valueType: t10 });
const _Le = (e14) => ({ type: "expression", value: e14 });
const VLe = (e14, t10) => ({ type: "parameter", value: e14, valueType: t10 });
const RLe = (e14) => ({ type: "simple", value: e14 });
const ALe = (e14) => ({ type: "parameter", value: e14 });
const OLe = (e14, t10) => ({ type: "field", value: e14, valueType: t10 });
const BLe = (e14, t10) => ({ type: "between", from: e14, to: t10 });
const zLe = (e14) => ({ type: "list", value: e14 });
const $Le = ["EqualTo", "NotEqualTo", "GreaterThan", "LessThan", "GreaterThanOrEqualTo", "LessThanOrEqualTo", "In", "Between", "NotIn", "Contains", "DoesNotContain", "BeginsWith", "DoesNotBeginWith", "TopN", "BottomN", "TopPercent", "BottomPercent"];
function WLe(e14) {
  return $Le.includes(e14);
}
function jLe(e14) {
  const t10 = e14.Value;
  if ("And" === t10 || "Or" === t10) return function(e15, t11) {
    const n10 = e15.toLowerCase();
    const r10 = [];
    return t11.map(jLe).forEach((e16) => {
      NLe(e16) && e16.operator === n10 ? r10.push(...e16.items) : r10.push(e16);
    }), DLe(n10, r10);
  }(t10, e14.Arguments);
  if (!WLe(t10)) return PLe(`Unknown operator ${t10} in node`, e14), DLe("and", []);
  if ("In" === t10 || "NotIn" === t10) {
    const [n10, ...r10] = e14.Arguments;
    return HLe(ZLe(n10), t10, 1 === r10.length && "constant" !== r10[0].Type ? GLe(r10[0]) : zLe(r10.map((e15) => e15.Value)));
  }
  return HLe(ZLe(e14.Arguments[0]), t10, "Between" === t10 ? function(e15, t11) {
    const n10 = GLe(e15) || RLe("");
    const r10 = GLe(t11) || RLe("");
    return BLe(n10, r10);
  }(e14.Arguments[1], e14.Arguments[2]) : GLe(e14.Arguments[1]));
}
function ZLe(e14) {
  return e14 ? "function" === e14.Type || "operator" === e14.Type ? (PLe("Unexpected function node", e14), _Le("")) : "attribute" === e14.Type ? ILe(e14.Value, e14.ValueType) : "parameter" === e14.Type ? VLe(e14.Value, e14.ValueType) : _Le(e14.Value) : _Le("");
}
function GLe(e14) {
  return e14 ? "function" === e14.Type || "operator" === e14.Type ? (PLe("Unexpected function node", e14), RLe("")) : "attribute" === e14.Type ? OLe(e14.Value, e14.ValueType) : "parameter" === e14.Type ? ALe(e14.Value) : RLe(e14.Value) : null;
}
const ULe = (e14, t10, n10) => ({ Type: "function", Value: e14, ValueType: h8.BOOLEAN, Arguments: [t10, n10] });
const qLe = (e14, t10, n10 = []) => ({ Type: "function", Value: e14, ValueType: t10, Arguments: n10 });
const YLe = (e14, t10 = h8.STRING) => ({ Type: "attribute", Value: e14, ValueType: t10, Arguments: [] });
const KLe = (e14, t10 = h8.STRING) => ({ Type: "constant", Value: e14, ValueType: t10, Arguments: [] });
const XLe = (e14, t10 = h8.STRING) => ({ Type: "parameter", Value: e14, ValueType: t10, Arguments: [] });
function JLe(e14) {
  return NLe(e14) ? QLe(e14) : function(e15) {
    if (!e15.operator) return PLe("criterionToNode: no criterion operator!", e15), null;
    if (WLe(e15.operator)) {
      const t10 = [tHe(e15.field), ...oHe(e15.value)];
      return qLe(e15.operator, h8.BOOLEAN, t10);
    }
    return PLe("criterionToNode: unknown criterion.operator!", e15), null;
  }(e14);
}
function QLe(e14) {
  var _a2;
  const t10 = (_a2 = e14.items.map(JLe).filter(Ie)) != null ? _a2 : [];
  return eHe({ and: "And", or: "Or" }[e14.operator], t10);
}
function eHe(e14, t10) {
  if (0 === t10.length) return qLe(e14, h8.BOOLEAN, t10);
  if (t10.length > 1) {
    const [n10, ...r10] = t10;
    return ULe(e14, n10, eHe(e14, r10));
  }
  return t10[0];
}
function tHe(e14) {
  return e14 ? "generic" === e14.type ? YLe(e14.value, e14.valueType || h8.STRING) : "parameter" === e14.type ? XLe(e14.value, e14.valueType || h8.STRING) : KLe(e14.value, h8.STRING) : KLe("", h8.STRING);
}
const nHe = (e14) => {
  const { value: t10, type: n10 } = e14;
  return !t10 && ("field" === n10 || "parameter" === n10);
};
function rHe(e14, t10 = h8.STRING) {
  return nHe(e14) ? null : "field" === e14.type ? YLe(e14.value, e14.valueType) : "parameter" === e14.type ? XLe(e14.value, e14.valueType) : KLe(e14.value, t10);
}
function oHe(e14) {
  let t10 = [];
  return e14 && (t10 = "between" === e14.type ? [rHe(e14.from, h8.DATE_TIME), rHe(e14.to, h8.DATE_TIME)] : "list" === e14.type ? e14.value.map((e15) => KLe(e15, h8.STRING)) : [rHe(e14)]), t10.filter(Ie);
}
const aHe = ep.createContext({ updateQueryFilter: () => {
}, queryParameters: [], reportParameters: [], dataSet: null, semanticModel: { id: "", version: "", name: "", entities: {} } });
const iHe = (e14) => {
  const { descriptor: { valuePath: t10 } } = e14;
  const { dataSet: n10, semanticModel: r10, queryParameters: o10, reportParameters: a10, updateQueryFilter: i10 } = ep.useContext(aHe);
  const [s10, l10] = ep.useState(function(e15) {
    if (!e15) return LLe("and", []);
    const t11 = jLe(e15);
    return NLe(t11) ? LLe(t11.operator, t11.items) : LLe("and", [t11]);
  }(n10.$queryFilter));
  let c10 = s10;
  const u10 = { valuePath: t10, dataSet: n10, filters: c10, onSetValue: (e15, t11, s11) => {
    const u11 = j0({}, LFe(e15, t11), { $set: s11 });
    c10 = AV(c10, u11), l10(c10);
    let d10 = function(e16) {
      const t12 = QLe(e16);
      return t12 && t12.Arguments.length ? t12 : null;
    }(c10);
    if (d10) {
      d10 = l6(d10, { semanticModel: r10, entityName: S6(n10) || "", reportParameters: a10, queryParameters: o10 }, false);
    }
    i10(d10);
  }, queryFilterMode: true, semanticModel: r10, queryParameters: o10, reportParameters: a10 };
  return tp.createElement(hke, __spreadValues({}, u10));
};
const sHe = (e14) => `barcode.quietZone.${e14}`;
const lHe = [Zq(Kq, sHe("left"), "length", "Left"), Zq(Kq, sHe("top"), "length", "Top"), Zq(Kq, sHe("right"), "length", "Right"), Zq(Kq, sHe("bottom"), "length", "Bottom")];
const cHe = (e14) => {
  const t10 = __spreadProps(__spreadValues({}, e14), { nestedDescriptors: lHe });
  return tp.createElement(Cse, __spreadValues({}, t10));
};
cHe.displayName = "QuietZoneEditor";
const uHe = (e14, t10, n10) => {
  let r10 = [];
  switch (t10) {
    case "text":
    case "plain-text":
      r10 = "String" === n10 ? ["Prompt", "Hidden", "DataType", "Nullable", "Multiline", "AllowBlank", "DefaultValue"] : ["Prompt", "Hidden", "DataType", "Nullable", "DefaultValue"];
      break;
    case "date-time":
      r10 = "String" === n10 ? ["Prompt", "Hidden", "DataType", "Nullable", "Multiline", "AllowBlank", "DefaultValue", "DisplayFormat"] : ["Prompt", "Hidden", "DataType", "Nullable", "DefaultValue", "DisplayFormat"];
      break;
    case "number":
      r10 = ["Prompt", "Hidden", "DataType", "Nullable", "DefaultValue"];
      break;
    case "number-range":
    case "boolean":
      r10 = ["Prompt", "Hidden", "Nullable", "DefaultValue"];
      break;
    case "date-range":
      r10 = ["Prompt", "Hidden", "DefaultValue"];
      break;
    case "list":
    case "dropdown":
    case "tree":
      r10 = ["Prompt", "Hidden", "DataType", "Nullable", "DefaultValue", "ValidValues"];
      break;
    default:
      return [];
  }
  return !e14.valuePath || r10.includes(e14.valuePath);
};
const dHe = (e14) => `reportParameter.${e14}`;
const pHe = Zq("", dHe("dataType"), "enum", "DataType", void 0, { enumKey: "reportparameter_datatype" });
const mHe = Zq("", dHe("allowNullValue"), "boolean", "Nullable");
const hHe = Zq("", dHe("multivalue"), "boolean", "MultiValue");
const fHe = Zq("", dHe("multiline"), "boolean", "Multiline");
const gHe = Zq("", dHe("allowBlankValue"), "boolean", "AllowBlank");
const yHe = Zq("", dHe("hidden"), "boolean", "Hidden");
const vHe = Zq("", dHe("selectAllValue"), "string_expr", "SelectAllValue", void 0, { disableDataFields: true });
const bHe = Zq("", dHe("parameterFormat"), "date_format", "DisplayFormat", void 0, { allowEmpty: true });
const SHe = (e14, t10) => OO(pHe.meta.enumKey, t10).filter((t11) => "number" === e14 ? ["Integer", "Float"].includes(t11.value) : "date-time" !== e14 || ["Date", "DateTime"].includes(t11.value));
const CHe = (e14) => "string" == typeof e14 && "" !== e14 && "" !== e14.trim();
const xHe = ({ ParameterValues: e14, DataSetReference: t10 }) => e14.length > 0 || (({ DataSetName: e15, ValueField: t11 }) => CHe(e15) && CHe(t11))(t10);
const wHe = (e14) => {
  var _a2;
  const { value: t10, setProperty: n10, descriptor: { meta: r10 } } = e14;
  const { rdlx: { reportParameters: o10 } } = Uae();
  const { t: a10 } = vp();
  const i10 = t10;
  const s10 = (e15) => (r10 == null ? void 0 : r10.disabled) || (r10 == null ? void 0 : r10.boundEditorType) && !uHe(e15, r10 == null ? void 0 : r10.boundEditorType, t10.DataType);
  const l10 = (e15) => {
    (e15 || []).forEach((e16) => n10(e16.descriptor, e16.value));
  };
  const c10 = __spreadProps(__spreadValues({}, Xue(e14, hHe, a10, "")), { setProperty: (e15, t11) => {
    const n11 = [{ descriptor: e15, value: t11 }];
    t11 && (n11.push({ descriptor: mHe, value: w0.Nullable }), n11.push({ descriptor: fHe, value: w0.MultiValue }), n11.push({ descriptor: gHe, value: w0.AllowBlank })), l10(n11);
  } });
  const u10 = Xue(e14, yHe, a10, "");
  const d10 = __spreadProps(__spreadValues({}, Xue(e14, pHe, a10, "")), { setProperty: (e15, t11) => {
    const n11 = [{ descriptor: e15, value: t11 }, { descriptor: mHe, value: w0.Nullable }, { descriptor: fHe, value: w0.MultiValue }, { descriptor: gHe, value: w0.AllowBlank }, { descriptor: bHe, value: w0.DisplayFormat }];
    l10(n11);
  }, currentEnum: (r10 == null ? void 0 : r10.boundEditorType) && SHe(r10.boundEditorType, a10) });
  const p10 = (_a2 = o10 == null ? void 0 : o10.hiddenProperties) != null ? _a2 : [];
  const m10 = t10.MultiValue;
  const h10 = "String" === t10.DataType;
  const f10 = ("DateTime" === t10.DataType || "Date" === t10.DataType) && !p10.includes(bHe.valuePath);
  const g10 = __spreadProps(__spreadValues({}, bHe), { meta: __spreadProps(__spreadValues({}, bHe.meta), { dateType: i10.DataType }) });
  const y10 = Xue(e14, g10, a10, "");
  return tp.createElement(tp.Fragment, null, tp.createElement(nse, __spreadProps(__spreadValues({}, d10), { disabled: s10(pHe) })), tp.createElement(Hie, __spreadProps(__spreadValues({}, c10), { disabled: s10(hHe) })), tp.createElement(Hie, __spreadProps(__spreadValues({}, u10), { disabled: s10(yHe) })), m10 ? (() => {
    const n11 = p10.includes(vHe.valuePath);
    const o11 = __spreadProps(__spreadValues({}, Xue(e14, vHe, a10, "")), { tooltip: Jue("reportParameter.selectAllValue", a10), placeholderEmpty: _ie(a10), disabled: s10(vHe) });
    return xHe(t10.ValidValues) && !n11 && tp.createElement(Hpe, __spreadProps(__spreadValues({}, o11), { disabled: r10 == null ? void 0 : r10.disabled }));
  })() : (() => {
    const t11 = Xue(e14, mHe, a10, "");
    const n11 = Xue(e14, fHe, a10, "");
    const r11 = Xue(e14, gHe, a10, "");
    return tp.createElement(tp.Fragment, null, tp.createElement(Hie, __spreadProps(__spreadValues({}, t11), { disabled: s10(mHe) })), h10 && tp.createElement(Hie, __spreadProps(__spreadValues({}, n11), { disabled: s10(fHe) })), h10 && tp.createElement(Hie, __spreadProps(__spreadValues({}, r11), { disabled: s10(gHe) })));
  })(), f10 && tp.createElement(ise, __spreadProps(__spreadValues({}, y10), { disabled: s10(bHe) })));
};
wHe.displayName = "ReportParameterDataEditor";
const THe = (e14, t10) => {
  var _a2, _b2, _c2, _d2;
  switch (e14) {
    case "boolean":
      return "False";
    case "float":
    case "integer":
      return 0;
    case "string":
    default:
      return "";
    case "color":
      return "Black";
    case "length":
      return "0in";
    case "fontFamily":
      return "Arial";
    case "fontSize":
      return (_a2 = OO("font_size", t10)[0]) == null ? void 0 : _a2.value;
    case "fontStyle":
      return (_b2 = OO("font_style", t10)[0]) == null ? void 0 : _b2.value;
    case "fontWeight":
      return (_c2 = OO("font_weight", t10)[0]) == null ? void 0 : _c2.value;
    case "textDecoration":
      return (_d2 = OO("text_decoration", t10)[0]) == null ? void 0 : _d2.value;
    case "lineWidth":
      return "2pt";
    case "borderStyle":
    case "lineStyle":
      return OO("border_style", t10)[0].value;
  }
};
const EHe = (e14) => {
  const { propertyType: t10, descriptor: n10, value: r10 } = e14;
  const { t: o10 } = vp();
  const a10 = ep.useMemo(() => THe(t10, o10), [t10, o10]);
  const i10 = ep.useMemo(() => __spreadProps(__spreadValues({}, e14), { descriptor: __spreadProps(__spreadValues({}, n10), { type: "string_expr" }), value: r10 != null ? r10 : a10, defaultValue: a10 }), [a10, e14, r10, n10]);
  return ep.useMemo(() => {
    switch (t10) {
      case "boolean": {
        const e15 = __spreadProps(__spreadValues({}, i10), { descriptor: __spreadProps(__spreadValues({}, n10), { type: "boolean_expr", meta: { numberType: t10 } }) });
        return tp.createElement(tme, __spreadValues({}, e15));
      }
      case "float": {
        const e15 = __spreadProps(__spreadValues({}, i10), { descriptor: __spreadProps(__spreadValues({}, n10), { type: "number_expr", meta: { numberType: "Float", step: 0.1 } }) });
        return tp.createElement(eCe, __spreadValues({}, e15));
      }
      case "integer": {
        const e15 = __spreadProps(__spreadValues({}, i10), { descriptor: __spreadProps(__spreadValues({}, n10), { type: "number_expr", meta: { numberType: "Integer", step: 1 } }) });
        return tp.createElement(eCe, __spreadValues({}, e15));
      }
      case "color": {
        const e15 = __spreadProps(__spreadValues({}, i10), { descriptor: __spreadProps(__spreadValues({}, n10), { type: "color_expr" }) });
        return tp.createElement(ahe, __spreadValues({}, e15));
      }
      case "length": {
        const e15 = __spreadProps(__spreadValues({}, i10), { descriptor: __spreadProps(__spreadValues({}, n10), { type: "length_expr" }) });
        return tp.createElement(yhe, __spreadValues({}, e15));
      }
      case "fontFamily": {
        const e15 = __spreadProps(__spreadValues({}, i10), { descriptor: __spreadProps(__spreadValues({}, n10), { type: "font_family" }) });
        return tp.createElement(ZTe, __spreadValues({}, e15));
      }
      case "fontSize": {
        const e15 = __spreadProps(__spreadValues({}, i10), { descriptor: __spreadProps(__spreadValues({}, n10), { type: "font_size_expr", meta: { enumKey: "font_size", unit: "pt" } }) });
        return tp.createElement(Hde, __spreadValues({}, e15));
      }
      case "fontStyle": {
        const e15 = __spreadProps(__spreadValues({}, i10), { descriptor: __spreadProps(__spreadValues({}, n10), { type: "enum_expr", meta: { enumKey: "font_style" } }) });
        return tp.createElement(Hde, __spreadValues({}, e15));
      }
      case "fontWeight": {
        const e15 = __spreadProps(__spreadValues({}, i10), { descriptor: __spreadProps(__spreadValues({}, n10), { type: "enum_expr", meta: { enumKey: "font_weight" } }) });
        return tp.createElement(Hde, __spreadValues({}, e15));
      }
      case "textDecoration": {
        const e15 = __spreadProps(__spreadValues({}, i10), { descriptor: __spreadProps(__spreadValues({}, n10), { type: "text_decoration", meta: { enumKey: "text_decoration" } }) });
        return tp.createElement(Hde, __spreadValues({}, e15));
      }
      case "lineWidth": {
        const e15 = __spreadProps(__spreadValues({}, i10), { descriptor: __spreadProps(__spreadValues({}, n10), { type: "length_expr", meta: qq.lineWidth }) });
        return tp.createElement(yhe, __spreadValues({}, e15));
      }
      case "borderStyle": {
        const e15 = __spreadProps(__spreadValues({}, i10), { descriptor: __spreadProps(__spreadValues({}, n10), { type: "border_style", meta: { enumKey: "border_style" } }) });
        return tp.createElement(The, __spreadValues({}, e15));
      }
      case "lineStyle": {
        const e15 = __spreadProps(__spreadValues({}, i10), { descriptor: __spreadProps(__spreadValues({}, n10), { type: "border_style", meta: { enumKey: "line_control_style" } }) });
        return tp.createElement(The, __spreadValues({}, e15));
      }
      default:
        return tp.createElement(Hpe, __spreadValues({}, i10));
    }
  }, [t10, i10, n10]);
};
EHe.displayName = "ReportPartPropertyValueEditor";
const FHe = (e14) => {
  const { value: t10, descriptor: n10 } = e14;
  const { meta: { property: { PropertyType: r10, Name: o10, DefaultValue: a10, DisplayName: i10 } } } = n10;
  const s10 = t10;
  const l10 = ep.useMemo(() => {
    const e15 = s10.findIndex((e16) => e16.Name === o10);
    return -1 !== e15 ? e15 : s10.length;
  }, [s10, o10]);
  const c10 = $N("", i10 || o10, "string", `Properties.${l10}.Value`);
  const u10 = ep.useMemo(() => {
    var _a2, _b2;
    return __spreadProps(__spreadValues({}, e14), { descriptor: c10, value: (_b2 = (_a2 = s10[l10]) == null ? void 0 : _a2.Value) != null ? _b2 : a10, defaultValue: a10 != null ? a10 : "", propertyType: r10 });
  }, [a10, l10, c10, s10, r10, e14]);
  return tp.createElement(EHe, __spreadValues({}, u10));
};
FHe.displayName = "ReportPartPropertyEditor";
const MHe = { Name: "ReportPart1", Type: "reportpart", DisplayName: "", Description: "", ReportItemName: "", Properties: [] };
const kHe = { Name: "ReportPart1", Description: "", Category: "", Type: "reportpartproperty", PropertyType: "String", DefaultValue: "", DisplayName: "" };
const PHe = (e14) => {
  const { descriptor: t10, value: n10, setProperty: r10 } = e14;
  const { drillPropertiesPath: o10 } = ep.useContext(Iue);
  const { t: a10 } = vp("propertyEditors");
  const i10 = ep.useMemo(() => n10.map((e15) => e15.Name), [n10]);
  const s10 = __spreadProps(__spreadValues({}, e14), { onSelect: (e15) => {
    const n11 = a10("propertyEditors:reportPartPropertiesCollection.propertiesTitle", "Property: {{reportPartName}}", { reportPartName: i10[e15] });
    o10 && o10(`${t10.valuePath}.${e15}`, n11);
  }, onAdd: () => {
    const e15 = __spreadProps(__spreadValues({}, kHe), { Name: kG(TG("reportPartProperty"), i10) });
    r10(t10, AV(n10, { $push: [e15] }));
  }, onDelete: (e15) => {
    r10(t10, AV(n10, { $splice: [[e15, 1]] }));
  }, createEditor: (e15, t11) => {
    const n11 = { value: i10[t11], defaultValue: "", descriptor: $N("", "", "", `Properties.${t11}.Name`), setProperty: r10 };
    return tp.createElement(Wde, __spreadProps(__spreadValues({}, n11), { occupiedNames: i10 }));
  } });
  return tp.createElement(WSe, __spreadValues({}, s10));
};
PHe.displayName = "ReportPartPropertiesCollectionEditor";
const NHe = (e14) => {
  const { descriptor: t10, value: n10, setProperty: r10 } = e14;
  const { drillPropertiesPath: o10 } = ep.useContext(Iue);
  const { t: a10 } = vp("propertyEditors");
  const i10 = ep.useMemo(() => n10.map((e15) => e15.Name), [n10]);
  const s10 = __spreadProps(__spreadValues({}, e14), { onSelect: (e15) => {
    const n11 = a10("propertyEditors:reportPartsCollection.propertiesTitle", "Report Part: {{reportPartName}}", { reportPartName: i10[e15] });
    o10 && o10(`${t10.valuePath}.${e15}`, n11);
  }, onAdd: () => {
    const e15 = __spreadProps(__spreadValues({}, MHe), { Name: kG(TG("reportPart"), i10) });
    r10(t10, AV(n10, { $push: [e15] }));
  }, onDelete: (e15) => {
    r10(t10, AV(n10, { $splice: [[e15, 1]] }));
  }, createEditor: (e15, t11) => {
    const n11 = { value: i10[t11], defaultValue: "", descriptor: $N("", "", "", `ReportParts.${t11}.Name`), setProperty: r10 };
    return tp.createElement(Wde, __spreadProps(__spreadValues({}, n11), { occupiedNames: i10 }));
  } });
  return tp.createElement(WSe, __spreadValues({}, s10));
};
NHe.displayName = "ReportPartsCollectionEditor";
const DHe = (e14) => {
  const { namedItems: t10 } = ep.useContext(Rue);
  const n10 = __spreadProps(__spreadValues({}, e14), { defaultValue: "", currentEnum: t10.filter((e15) => e15.type && e15.$path && e15.name && /^ReportSections.[0-9]*.Body.ReportItems.[0-9]*$/.test(e15.$path)).map((e15) => ({ label: e15.name, value: e15.name })) });
  return tp.createElement(nse, __spreadValues({}, n10));
};
DHe.displayName = "ReportPartReportItemNameEditor";
const LHe = Zq("", "report.reportPart.properties.type", "enum", "PropertyType", void 0, { enumKey: "reportparts_property_type" });
const HHe = Zq("", "report.reportPart.properties.defaultValue", "string", "DefaultValue");
const IHe = (e14) => {
  const { value: t10, setProperty: n10 } = e14;
  const { t: r10 } = vp();
  const o10 = t10;
  const a10 = ep.useCallback((e15, t11) => {
    n10(__spreadProps(__spreadValues({}, e15), { valuePath: "" }), AV(o10, { PropertyType: { $set: t11 }, DefaultValue: { $set: THe(t11, r10) } }));
  }, [o10, n10, r10]);
  const i10 = __spreadProps(__spreadValues({}, e14), { descriptor: LHe, value: o10.PropertyType, setProperty: a10 });
  const s10 = __spreadProps(__spreadValues({}, e14), { descriptor: HHe, propertyType: o10.PropertyType, value: o10.DefaultValue });
  return tp.createElement(tp.Fragment, null, tp.createElement(nse, __spreadValues({}, i10)), tp.createElement(EHe, __spreadValues({}, s10)));
};
IHe.displayName = "ReportPartPropertyTypeEditor";
const _He = Zq("", "partItem.reportPart", "string", "ReportPart");
const VHe = Zq("", "partItem.library", "string", "Library");
const RHe = (e14) => {
  const { value: t10 } = e14;
  const { Library: n10, ReportPart: r10 } = t10;
  const { rdlx: { reportPartsLibraries: { libraries: o10 } } } = d9();
  const a10 = o10.find(({ Name: e15 }) => e15 === n10);
  const i10 = (a10 && ELe(a10) ? a10.reportParts : []).find(({ Name: e15 }) => e15 === r10);
  const s10 = __spreadProps(__spreadValues({}, e14), { descriptor: VHe, value: (a10 == null ? void 0 : a10.DisplayName) || n10, disabled: true });
  const l10 = __spreadProps(__spreadValues({}, e14), { descriptor: _He, value: (i10 == null ? void 0 : i10.DisplayName) || r10, disabled: true });
  return tp.createElement(tp.Fragment, null, tp.createElement(Sse, __spreadValues({}, s10)), tp.createElement(Sse, __spreadValues({}, l10)));
};
RHe.displayName = "ReportPartLibraryEditor";
const AHe = _V("@rdlx/reportItems/list/setRowsOrColumns", ({ rowsOrColumnsCount: e14, growDirection: t10 }) => ({ rowsOrColumnsCount: e14, growDirection: t10 }));
const OHe = Zq(cY, "list.rowsOrColumnsCount", "number", "RowsOrColumnsCount", "both", { numberType: "Integer", step: 1, minValue: 1, maxValue: 1e3 });
const BHe = Zq(cY, "list.growDirection", "enum", "GrowDirection", "both", { enumKey: "grow_direction" });
const zHe = (e14) => {
  const { t: t10 } = vp();
  const n10 = PA();
  const r10 = ep.useCallback((e15, t11) => {
    n10(AHe({ rowsOrColumnsCount: t11 }));
  }, []);
  const o10 = ep.useCallback((e15, t11) => {
    n10(AHe({ growDirection: t11 }));
  }, []);
  const a10 = (n11) => Xue(e14, n11, t10, void 0, false);
  return tp.createElement(tp.Fragment, null, tp.createElement(wue, __spreadProps(__spreadValues({}, a10(OHe)), { setProperty: r10 })), tp.createElement(nse, __spreadProps(__spreadValues({}, a10(BHe)), { setProperty: o10 })));
};
zHe.displayName = "FontEditor";
const $He = (e14) => `border.${e14}`;
const WHe = Zq(Qq, $He("width"), "length_expr", "Border.Width", void 0, qq.borderWidth);
const jHe = Zq(Qq, $He("style"), "border_style", "Border.Style", void 0, { enumKey: "border_style" });
const ZHe = Zq(Qq, $He("color"), "color_expr", "Border.Color");
const GHe = (e14) => {
  const { descriptor: t10, value: n10, defaultValue: r10 } = e14;
  const { instanceId: o10 } = Uae();
  const { selectedItemsInfo: a10 } = ep.useContext(Rue);
  const i10 = ep.useMemo(() => a10.map((e15) => e15.type), [a10]);
  const s10 = eK.of(o10).getBorderStyles(i10);
  const l10 = (o11) => {
    const { valuePath: a11 } = o11;
    const i11 = jN(a11);
    return __spreadProps(__spreadValues({}, e14), { value: i11(n10), defaultValue: i11(r10), descriptor: __spreadProps(__spreadValues({}, o11), { valuePath: `${t10.valuePath}.${o11.valuePath}`, category: t10.category || o11.category, meta: __spreadProps(__spreadValues({}, o11.meta), { parentLabel: t10.label }) }) });
  };
  return tp.createElement(tp.Fragment, null, tp.createElement(yhe, __spreadValues({}, l10(WHe))), tp.createElement(The, __spreadProps(__spreadValues({}, l10(jHe)), { availableBorderStyles: s10 })), tp.createElement(ahe, __spreadValues({}, l10(ZHe))));
};
const UHe = ep.createContext({ instanceId: "default" });
const qHe = () => ep.useContext(UHe);
const [YHe, , KHe] = Dp("wd-editor-simple-dropdown");
const [XHe] = KHe("item");
const [JHe] = KHe("preview");
const [QHe] = KHe("text");
const eIe = (e14) => {
  const { API: t10 } = ep.useContext(Sm);
  const { values: n10, selectedValue: r10, onSelect: o10, getTitle: a10 = (e15) => e15, getPreview: i10, customCSS: s10 } = e14;
  return tp.createElement("div", { className: kp(YHe, s10) }, n10.map((e15, n11) => {
    const s11 = e15 === r10;
    const l10 = { title: a10(e15), accent: s11 ? "full" : "none", background: s11 ? "default" : "transparent", size: "large", customCSS: XHe, onClick: (c10 = e15, () => {
      o10(c10), t10.dropdowns.open(null);
    }) };
    var c10;
    return tp.createElement(qm, __spreadValues({ key: `${l10.title}_${n11}` }, l10), tp.createElement("div", { className: JHe }, i10(e15)), tp.createElement("div", { className: QHe }, a10(e15)));
  }));
};
const [tIe] = Dp("wd-editor-simple-row");
const nIe = ({ children: e14, customCSS: t10 }) => tp.createElement("div", { className: kp(tIe, t10) }, e14);
const [rIe] = Dp("wd-editor-simple-section");
const [oIe] = Dp("wd-editor-simple-toggle");
const aIe = (e14) => __spreadProps(__spreadValues({ itemSize: "small", hiddenChevron: true, menuMaxHeight: 225, menuWidth: "auto", menuAlign: "center", scrollToSelection: true }, e14), { type: "dropdown", customCSS: kp(oIe, e14.customCSS) });
const iIe = (e14) => {
  const { withHeader: t10, withSplitters: n10, customCSS: r10 } = e14;
  const o10 = __spreadProps(__spreadValues({}, e14), { withSplitters: n10 || t10, customCSS: kp(rIe, r10) });
  return tp.createElement(sM, __spreadValues({}, o10));
};
const [sIe, , lIe] = Dp("wd-editor-simple-toggle-content");
const [cIe] = lIe("name");
const [uIe] = lIe("value");
const [dIe] = lIe("text");
const [pIe, mIe] = lIe("color");
const hIe = ({ text: e14, style: t10 }) => tp.createElement("div", { className: dIe, style: t10 }, e14);
const fIe = ({ color: e14 }) => {
  const t10 = 0 === e14.A;
  const n10 = kp(pIe, { [mIe("transparent")]: t10 });
  return tp.createElement("div", { className: n10, style: { backgroundColor: t10 ? "transparent" : e14.hex } });
};
const gIe = (e14) => {
  const { name: t10, preview: n10 } = e14;
  return tp.createElement("div", { className: sIe }, tp.createElement("span", { className: cIe }, t10), tp.createElement("div", { className: uIe }, n10));
};
const yIe = (e14) => e14("propertyEditors:simple.common.textExpressionCompact", "<\u{1D453}>");
const vIe = (e14) => `border.${e14}`;
const bIe = (e14, { displayValue: t10, valueState: n10 }, r10, o10) => {
  if (sK(e14)) return { value: "<...>", displayValue: t10, preview: false };
  if ("Error" === n10) return { value: yIe(o10), displayValue: t10, preview: false };
  const a10 = "Expression" === n10 ? Ime(e14, r10) : t10;
  return "Expression" === n10 && a10 === e14 ? { value: yIe(o10), displayValue: t10, preview: false } : { value: a10, displayValue: t10, preview: true };
};
const SIe = (e14, { displayValue: t10, valueState: n10 }, r10) => sK(e14) ? { value: "<...>", displayValue: t10, preview: false } : "Expression" === n10 || "Error" === n10 ? { value: yIe(r10), displayValue: t10, preview: false } : { value: t10, displayValue: t10, preview: true };
const CIe = (e14, { displayValue: t10, valueState: n10 }, r10, o10) => {
  if (sK(e14)) return { value: "<...>", displayValue: t10, preview: false };
  if ("Error" === n10) return { value: yIe(o10), displayValue: t10, preview: false };
  const a10 = "Expression" === n10 ? Sme(e14, r10) : t10;
  return null == a10 || "Expression" === n10 && a10 === e14 ? { value: yIe(o10), displayValue: t10, preview: false } : { value: a10.startsWith("#") ? dm.fromHEX(a10) : dm.fromWeb(a10), displayValue: t10, preview: true };
};
const xIe = ({ descriptor: e14, value: t10, defaultValue: n10, setProperty: r10, disabled: o10, exprContext: a10, theme: i10 }) => {
  const { t: s10 } = vp("propertyEditors");
  const l10 = ep.useCallback((t11) => {
    r10(e14, t11.customValue || dm.toWeb(t11) || t11.hex);
  }, [e14, r10]);
  const c10 = HJ(t10, e14.type, a10);
  const u10 = que({ descriptor: e14, value: t10, defaultValue: n10 });
  const { value: d10, displayValue: p10 } = CIe(t10, { displayValue: c10, valueState: u10 }, i10, s10);
  const m10 = "string" != typeof d10 ? tp.createElement(fIe, { color: d10 }) : tp.createElement(hIe, { text: d10 });
  const h10 = s10("simple.backgroundColor.label");
  return aIe({ content: tp.createElement(Kme, { theme: i10, value: "string" != typeof d10 ? d10 : dm.fromWeb("Black"), onSelect: l10 }), toggleContent: tp.createElement(gIe, { name: h10, preview: m10 }), title: `${s10("simple.backgroundColor.title")} - ${"string" != typeof d10 ? dm.toWeb(d10) || d10.hex : p10}`, disabled: o10, width: "60px", menuAlign: "left", menuMaxHeight: "none" });
};
const wIe = ({ descriptor: e14, value: t10, defaultValue: n10, setProperty: r10, disabled: o10, exprContext: a10, theme: i10 }) => {
  const { t: s10 } = vp("propertyEditors");
  const l10 = ep.useCallback((t11) => {
    r10(e14, t11.customValue || dm.toWeb(t11) || t11.hex);
  }, [e14, r10]);
  const c10 = HJ(t10, e14.type, a10);
  const u10 = que({ descriptor: e14, value: t10, defaultValue: n10 });
  const { value: d10, displayValue: p10 } = CIe(t10, { displayValue: c10, valueState: u10 }, i10, s10);
  const m10 = "string" != typeof d10 ? tp.createElement(fIe, { color: d10 }) : tp.createElement(hIe, { text: d10 });
  const h10 = s10("simple.borders.borderColor.label");
  return aIe({ content: tp.createElement(Kme, { theme: i10, value: "string" != typeof d10 ? d10 : dm.fromWeb("Black"), onSelect: l10 }), toggleContent: tp.createElement(gIe, { name: h10, preview: m10 }), title: `${s10("simple.borders.borderColor.title")} - ${"string" != typeof d10 ? dm.toWeb(d10) || d10.hex : p10}`, disabled: o10, menuAlign: "center", menuMaxHeight: "none", edgeSnapOffset: 15 });
};
const [, , TIe] = Dp("wd-editor-simple-border-style");
const [EIe] = TIe("preview");
const FIe = "border_style";
const MIe = (e14) => {
  const { instanceId: t10, descriptor: n10, value: r10, defaultValue: o10, setProperty: a10, disabled: i10, exprContext: s10, selectedItemTypes: l10, t: c10 } = e14;
  const u10 = HJ(r10, FIe, s10);
  const d10 = que({ descriptor: n10, value: r10, defaultValue: o10 });
  const { value: p10, displayValue: m10, preview: h10 } = SIe(r10, { displayValue: u10, valueState: d10 }, c10);
  const f10 = tp.createElement(hIe, { text: h10 && r10 ? RO(FIe, p10, c10) : p10 });
  const g10 = c10("propertyEditors:simple.borders.borderStyle.label");
  const y10 = ((e15, t11, n11) => {
    const r11 = eK.of(e15).getBorderStyles(t11);
    return n11.filter(({ value: e16 }) => e16 && r11.includes(e16));
  })(t10, l10, OO(FIe, c10)).map((e15) => ({ type: "button", value: e15.value, text: e15.label || e15.value, selected: p10 === e15.value }));
  return aIe({ items: y10, toggleContent: tp.createElement(gIe, { name: g10, preview: f10 }), title: `${c10("propertyEditors:simple.borders.borderStyle.title")} - ${h10 ? p10 : m10}`, disabled: i10, menuAlign: "center", menuMaxHeight: "default", edgeSnapOffset: 15, generateItemPreview: (e15) => {
    const t11 = Cme(e15);
    return t11 && "None" !== t11 ? tp.createElement("span", { className: EIe, style: { borderTopStyle: t11 } }) : null;
  }, onSelect: (e15) => a10(n10, e15) });
};
const [, , kIe] = Dp("wd-editor-simple-border-width");
const [PIe] = kIe("preview");
const NIe = ["0.25pt", "0.5pt", "1pt", "1.5pt", "2.25pt", "3pt", "4.5pt", "6pt"];
const DIe = ({ descriptor: e14, value: t10, defaultValue: n10, setProperty: r10, disabled: o10, exprContext: a10 }) => {
  const { t: i10 } = vp("propertyEditors");
  const { value: s10, displayValue: l10, preview: c10 } = SIe(t10, Yue({ descriptor: e14, value: t10, defaultValue: n10 }, a10), i10);
  const u10 = tp.createElement(hIe, { text: s10 });
  const d10 = i10("simple.borders.borderWidth.label");
  const p10 = NIe.map((e15) => ({ type: "button", value: e15, text: e15, selected: s10 === e15 }));
  return aIe({ items: p10, toggleContent: tp.createElement(gIe, { name: d10, preview: u10 }), title: `${i10("simple.borders.borderWidth.title")} - ${c10 ? s10 : l10}`, disabled: o10, menuAlign: "center", menuMaxHeight: "default", edgeSnapOffset: 15, generateItemPreview: (e15) => tp.createElement("span", { className: PIe, style: { borderTopWidth: e15 } }), onSelect: (t11) => r10(e14, t11) });
};
const [LIe, , HIe] = Dp("wd-editor-simple-toggle-sides");
const [IIe] = HIe("menu");
const [_Ie] = HIe("preview");
const VIe = ["Left", "Right", "Top", "Bottom", "All", "Reset"];
const RIe = { Left: $N(eY, vIe("left"), "", "Style.LeftBorder"), Top: $N(eY, vIe("top"), "", "Style.TopBorder"), Right: $N(eY, vIe("right"), "", "Style.RightBorder"), Bottom: $N(eY, vIe("bottom"), "", "Style.BottomBorder"), Default: $N(eY, vIe("default"), "", "Style.Border") };
const AIe = (e14) => tp.createElement("div", { className: _Ie, style: { Left: { borderLeftStyle: "solid" }, Right: { borderRightStyle: "solid" }, Top: { borderTopStyle: "solid" }, Bottom: { borderBottomStyle: "solid" }, All: { borderStyle: "solid" } }[e14] });
const OIe = ({ defaultValue: e14, disabled: t10, activeSide: n10, setProperties: r10, setActiveSide: o10 }) => {
  const { t: a10 } = vp("propertyEditors");
  const i10 = (e15) => a10(`simple.borders.sides.${{ All: "all", Left: "left", Right: "right", Top: "top", Bottom: "bottom", Reset: "reset" }[e15]}`);
  const s10 = tp.createElement(tp.Fragment, null, AIe(n10), i10(n10));
  const l10 = a10("simple.borders.borders");
  const c10 = { values: VIe, selectedValue: n10, onSelect: (t11) => {
    if ("Reset" === t11) {
      const t12 = [{ descriptor: RIe.Left, value: e14.LeftBorder }, { descriptor: RIe.Top, value: e14.TopBorder }, { descriptor: RIe.Right, value: e14.RightBorder }, { descriptor: RIe.Bottom, value: e14.BottomBorder }, { descriptor: RIe.Default, value: e14.Border }];
      r10(t12), o10("All");
    } else o10(t11);
  }, getPreview: AIe, getTitle: i10, customCSS: IIe };
  return aIe({ content: tp.createElement(eIe, __spreadValues({}, c10)), toggleContent: tp.createElement(gIe, { name: l10, preview: s10 }), disabled: t10, menuWidth: 160, menuMaxHeight: "none", customCSS: LIe });
};
const [BIe] = Dp("wd-editor-simple-buttons");
const zIe = $N(Jq, "style.backgroundColor", "color_expr", "BackgroundColor");
const $Ie = { Top: "TopBorder", Right: "RightBorder", Bottom: "BottomBorder", Left: "LeftBorder", All: "Border" };
const WIe = (e14, t10, n10) => ({ Top: Zq(eY, vIe("top"), t10, `${$Ie.Top}.${e14}`, void 0, n10), Right: Zq(eY, vIe("right"), t10, `${$Ie.Right}.${e14}`, void 0, n10), Bottom: Zq(eY, vIe("bottom"), t10, `${$Ie.Bottom}.${e14}`, void 0, n10), Left: $N(eY, vIe("left"), t10, `${$Ie.Left}.${e14}`, void 0, n10), All: $N(eY, vIe("default"), t10, `${$Ie.All}.${e14}`, void 0, n10) });
const jIe = { Width: WIe("Width", "length_expr"), Style: WIe("Style", "border_style", { enumKey: "border_style" }), Color: WIe("Color", "color_expr") };
const ZIe = ({ descriptor: e14, value: t10, defaultValue: n10, setProperty: r10, disabled: o10, sidePicker: a10 = true }) => {
  const { valuePath: i10 } = e14;
  const { t: s10 } = vp();
  const { instanceId: l10 } = qHe();
  const { selectedItemsInfo: c10 } = ep.useContext(Rue);
  const { setProperties: u10 } = ep.useContext(Iue);
  const d10 = ep.useContext(Vue);
  const { theme: p10 } = ep.useContext(Aue);
  const [m10, h10] = ep.useState(a10);
  const [f10, g10] = ep.useState("All");
  ep.useEffect(() => {
    a10 !== m10 && h10(a10);
  }, [a10, m10]);
  const y10 = ep.useMemo(() => c10.map((e15) => e15.type), [c10]);
  const v10 = (e15) => {
    const a11 = jIe[e15];
    return { instanceId: l10, descriptor: WN(a11[f10], i10), value: t10 && t10[$Ie[f10]][e15], defaultValue: n10 && n10[$Ie[f10]][e15], setProperty: (e16, t11) => {
      if ("All" === f10) {
        const n11 = [{ descriptor: WN(a11.Top, i10), value: t11 }, { descriptor: WN(a11.Right, i10), value: t11 }, { descriptor: WN(a11.Bottom, i10), value: t11 }, { descriptor: WN(a11.Left, i10), value: t11 }, { descriptor: e16, value: t11 }];
        u10(n11);
      } else r10(e16, t11);
    }, disabled: o10, exprContext: d10, theme: p10 };
  };
  const b10 = { items: [xIe(((e15) => ({ instanceId: l10, descriptor: WN(e15, i10), value: t10 && t10[e15.valuePath], defaultValue: n10 && n10[e15.valuePath], setProperty: r10, disabled: o10, exprContext: d10, theme: p10 }))(zIe))] };
  const S10 = { items: [OIe({ instanceId: l10, descriptor: e14, value: t10, defaultValue: n10, disabled: o10, setProperty: r10, setProperties: u10, activeSide: f10, setActiveSide: g10, exprContext: d10, theme: p10 }), DIe(v10("Width")), MIe(__spreadProps(__spreadValues({}, v10("Style")), { selectedItemTypes: y10, t: s10 })), wIe(v10("Color"))], block: true, withHeader: true };
  return tp.createElement(nIe, { customCSS: BIe }, tp.createElement(iIe, __spreadValues({}, b10)), tp.createElement(iIe, __spreadValues({}, S10)));
};
ZIe.displayName = "BackgroundAndBordersEditor";
const [GIe] = Dp("wd-editor-s-font-family");
const [UIe] = Dp("wd-font-dropdown__item");
const qIe = ({ descriptor: e14, value: t10, defaultValue: n10, setProperty: r10, disabled: o10, exprContext: a10, theme: i10, fonts: s10 }) => {
  const { t: l10 } = vp("propertyEditors");
  const { value: c10, displayValue: u10, preview: d10 } = bIe(t10, Yue({ descriptor: e14, value: t10, defaultValue: n10 }, a10), i10, l10);
  const p10 = tp.createElement(hIe, { text: d10 ? jTe(c10, s10) : c10, style: d10 ? { fontFamily: `"${c10}"` } : void 0 });
  const m10 = l10("simple.font.fontFamily.label");
  const h10 = s10.map((e15) => "string" == typeof e15 ? { type: "button", text: e15, value: e15, selected: e15 === t10 } : Qxe(e15) ? { type: "button", text: e15.label, value: e15.value, selected: e15.value === t10 } : "" === e15.header ? { type: "splitter" } : { type: "header", header: e15.header });
  return aIe({ items: h10, toggleContent: tp.createElement(gIe, { name: m10, preview: p10 }), title: `${l10("simple.font.fontFamily.title")} - ${d10 ? jTe(c10, s10) : u10}`, onSelect: (t11) => r10(e14, t11), customButtonRenderer: ({ text: e15, value: t11 }) => tp.createElement("div", { className: UIe, style: { fontFamily: `"${t11}"` } }, e15), disabled: o10, customCSS: GIe, menuAlign: "left", menuWidth: "default", menuCustomCSS: "wd-font-dropdown" });
};
const YIe = ["8pt", "9pt", "10pt", "11pt", "12pt", "14pt", "16pt", "18pt", "20pt", "22pt", "24pt", "26pt", "28pt", "36pt", "48pt", "72pt"];
const KIe = ({ descriptor: e14, value: t10, defaultValue: n10, setProperty: r10, disabled: o10, exprContext: a10, theme: i10 }) => {
  const { t: s10 } = vp("propertyEditors");
  const { value: l10, displayValue: c10, preview: u10 } = bIe(t10, Yue({ descriptor: e14, value: t10, defaultValue: n10 }, a10), i10, s10);
  const d10 = tp.createElement(hIe, { text: l10 });
  const p10 = s10("simple.font.fontSize.label");
  const m10 = YIe.map((e15) => ({ type: "button", value: e15, text: e15, selected: t10 === e15 }));
  return aIe({ items: m10, toggleContent: tp.createElement(gIe, { name: p10, preview: d10 }), title: `${s10("simple.font.fontSize.title")} - ${u10 ? l10 : c10}`, onSelect: (t11) => r10(e14, t11), disabled: o10, menuAlign: "center", menuWidth: 100 });
};
const XIe = ["Normal", "Italic"];
const JIe = ({ descriptor: e14, value: t10, defaultValue: n10, setProperty: r10, disabled: o10, exprContext: a10, theme: i10 }) => {
  const { t: s10 } = vp("propertyEditors");
  const { value: l10, displayValue: c10, preview: u10 } = bIe(t10, Yue({ descriptor: e14, value: t10, defaultValue: n10 }, a10), i10, s10);
  const d10 = tp.createElement(hIe, { text: l10, style: u10 ? { fontStyle: l10 } : void 0 });
  const p10 = s10("simple.font.fontStyle.label");
  const m10 = { values: XIe, selectedValue: t10, onSelect: (t11) => r10(e14, t11), getPreview: (e15) => tp.createElement("span", { style: { fontStyle: e15 } }, "I") };
  return aIe({ content: tp.createElement(eIe, __spreadValues({}, m10)), toggleContent: tp.createElement(gIe, { name: p10, preview: d10 }), title: `${s10("simple.font.fontStyle.title")} - ${u10 ? l10 : c10}`, disabled: o10, menuWidth: 160, menuMaxHeight: "none" });
};
const QIe = ["Normal", "Lighter", "Bold", "Heavy"];
const e_e = ({ descriptor: e14, value: t10, defaultValue: n10, setProperty: r10, disabled: o10, exprContext: a10, theme: i10 }) => {
  const { t: s10 } = vp("propertyEditors");
  const { value: l10, displayValue: c10, preview: u10 } = bIe(t10, Yue({ descriptor: e14, value: t10, defaultValue: n10 }, a10), i10, s10);
  const d10 = tp.createElement(hIe, { text: l10, style: u10 ? { fontWeight: l10 } : void 0 });
  const p10 = s10("simple.font.fontWeight.label");
  const m10 = { values: QIe, selectedValue: t10, onSelect: (t11) => r10(e14, t11), getPreview: (e15) => tp.createElement("span", { style: { fontWeight: e15 } }, "B") };
  return aIe({ content: tp.createElement(eIe, __spreadValues({}, m10)), toggleContent: tp.createElement(gIe, { name: p10, preview: d10 }), title: `${s10("simple.font.fontWeight.title")} - ${u10 ? l10 : c10}`, disabled: o10, menuWidth: 160, menuMaxHeight: "none" });
};
const t_e = ({ descriptor: e14, value: t10, defaultValue: n10, setProperty: r10, disabled: o10, exprContext: a10, theme: i10 }) => {
  const { t: s10 } = vp("propertyEditors");
  const l10 = ep.useCallback((t11) => {
    const n11 = NJ(t11.customValue || dm.toWeb(t11) || t11.hex, e14.type, { expressionSyntax: a10.expressionSyntax }, e14.meta);
    r10(e14, n11);
  }, [e14, a10.expressionSyntax, r10]);
  const { value: c10, displayValue: u10 } = CIe(t10, Yue({ descriptor: e14, value: t10, defaultValue: n10 }, a10), i10, s10);
  const d10 = "string" != typeof c10 ? tp.createElement(fIe, { color: c10 }) : tp.createElement(hIe, { text: c10 });
  const p10 = s10("simple.font.textColor.label");
  return aIe({ content: tp.createElement(Kme, { theme: i10, value: "string" != typeof c10 ? c10 : dm.fromWeb("Black"), onSelect: l10 }), toggleContent: tp.createElement(gIe, { name: p10, preview: d10 }), title: `${s10("simple.font.textColor.title")} - ${"string" != typeof c10 ? dm.toWeb(c10) || c10.hex : u10}`, disabled: o10, menuAlign: "center", menuMaxHeight: "none", edgeSnapOffset: 15 });
};
const n_e = { none: { textDecoration: "none", letter: "N" }, overline: { textDecoration: "overline", letter: "O" }, linethrough: { textDecoration: "line-through", letter: "S" }, underline: { textDecoration: "underline", letter: "U" }, doubleunderline: { textDecoration: "double underline", letter: "D" } };
const r_e = (e14) => {
  const { instanceId: t10, descriptor: n10, value: r10, defaultValue: o10, setProperty: a10, disabled: i10, exprContext: s10, selectedItemTypes: l10 } = e14;
  const { t: c10 } = vp("propertyEditors");
  const { value: u10, displayValue: d10, preview: p10 } = SIe(r10, Yue({ descriptor: n10, value: r10, defaultValue: o10 }, s10), c10);
  const m10 = tp.createElement(hIe, { text: u10, style: p10 ? { textDecoration: Rme(u10).textDecoration } : void 0 });
  const h10 = c10("simple.font.textDecoration.label");
  const f10 = ((e15, t11, n11) => {
    const r11 = eK.of(e15).getTextDecorations(t11);
    return n11.map((e16) => e16.value).filter((e16) => e16 && r11.includes(e16));
  })(t10, l10, OO("text_decoration", c10));
  const g10 = { values: f10, selectedValue: r10, onSelect: (e15) => a10(n10, e15), getPreview: (e15) => {
    const { textDecoration: t11, letter: n11 } = ((e16) => n_e[e16.toLowerCase()] || n_e.none)(e15);
    return tp.createElement("span", { style: { textDecoration: t11 } }, n11);
  } };
  return aIe({ content: tp.createElement(eIe, __spreadValues({}, g10)), toggleContent: tp.createElement(gIe, { name: h10, preview: m10 }), title: `${c10("simple.font.textDecoration.title")} - ${p10 ? u10 : d10}`, disabled: i10, menuWidth: 200, menuAlign: "right", menuMaxHeight: "none" });
};
const [o_e] = Dp("wd-editor-s-section-font");
const a_e = (e14) => `font.${e14}`;
const i_e = (e14) => `style.${e14}`;
const s_e = $N("", a_e("fontFamily"), "font_family_simple", "FontFamily");
const l_e = $N("", a_e("fontSize"), "font_size_simple", "FontSize");
const c_e = $N("", a_e("fontStyle"), "font_style_simple", "FontStyle");
const u_e = $N("", a_e("fontWeight"), "font_weight_simple", "FontWeight");
const d_e = $N("", i_e("textDecoration"), "text_decoration_simple", "TextDecoration");
const p_e = $N("", i_e("color"), "color_simple", "Color");
const m_e = ({ descriptor: e14, value: t10, defaultValue: n10, setProperty: r10, disabled: o10 }) => {
  var _a2;
  const { showTextDecoration: a10 } = (_a2 = e14 == null ? void 0 : e14.meta) != null ? _a2 : {};
  const { instanceId: i10 } = qHe();
  const s10 = ep.useContext(Vue);
  const { selectedItemsInfo: l10 } = ep.useContext(Rue);
  const { theme: c10 } = ep.useContext(Aue);
  const { fontFamily: u10 } = ep.useContext(WTe);
  const d10 = ep.useMemo(() => l10.map((e15) => e15.type), [l10]);
  const p10 = (a11) => ({ instanceId: i10, descriptor: WN(a11, e14.valuePath), value: t10 && t10[a11.valuePath], defaultValue: n10 && n10[a11.valuePath], setProperty: r10, disabled: o10, exprContext: s10, theme: c10 });
  const m10 = { items: [qIe(__spreadProps(__spreadValues({}, p10(s_e)), { fonts: u10 || [] })), KIe(p10(l_e)), t_e(p10(p_e))], block: true, withHeader: true, customCSS: o_e };
  const h10 = { items: [e_e(p10(u_e)), JIe(p10(c_e)), false !== a10 ? r_e(__spreadProps(__spreadValues({}, p10(d_e)), { selectedItemTypes: d10 })) : void 0].filter(Boolean), block: true, withSplitters: true };
  return tp.createElement(tp.Fragment, null, tp.createElement(nIe, null, tp.createElement(iIe, __spreadValues({}, m10))), tp.createElement(nIe, null, tp.createElement(iIe, __spreadValues({}, h10))));
};
m_e.displayName = "SimpleFontEditor";
const [h_e, , f_e] = Dp("wd-sort-expression-line");
const [g_e] = f_e("button");
const y_e = Zq(rY, "dataRegion.sortExpressions", "string_expr", "Value");
const v_e = $N("", "", "string", "Direction");
const b_e = (e14) => {
  const { descriptor: t10, value: { Value: n10, Direction: r10 }, defaultValue: o10, setProperty: a10 } = e14;
  const i10 = rf(Vh);
  const s10 = rf(Vh, { rotate: "180" });
  const l10 = { descriptor: WN(y_e, t10.valuePath), value: n10, setProperty: a10, defaultValue: o10.Value };
  const c10 = { background: "transparent", icon: "Ascending" === r10 ? i10 : s10, size: "small", onClick: () => {
    const e15 = "Ascending" === r10 ? "Descending" : "Ascending";
    a10(WN(v_e, t10.valuePath), e15);
  }, customCSS: g_e };
  return tp.createElement("div", { className: h_e }, tp.createElement(Lpe, __spreadValues({}, l10)), tp.createElement(qm, __spreadValues({}, c10)));
};
const S_e = (e14) => {
  const { descriptor: t10, value: n10, setProperty: r10 } = e14;
  const o10 = { Value: "", Direction: "Ascending" };
  const a10 = __spreadProps(__spreadValues({}, e14), { value: n10 || [], reordering: { type: "drag" }, createEditor: (e15, n11) => {
    const a11 = { descriptor: $N("", "", "string", `${t10.valuePath}.${n11}`), value: e15, defaultValue: o10, setProperty: r10 };
    return tp.createElement(b_e, __spreadValues({}, a11));
  }, onAdd: () => r10(t10, AV(n10 || [], { $push: [o10] })), onDelete: (e15) => r10(t10, AV(n10, { $splice: [[e15, 1]] })) });
  return tp.createElement(Bde, __spreadValues({}, a10));
};
const C_e = (e14) => {
  const { descriptor: t10, value: n10, placeholderEmpty: r10, setProperty: o10 } = e14;
  const a10 = __spreadProps(__spreadValues({}, e14), { value: n10 || [], reordering: { type: "drag" }, createEditor: (e15, n11) => {
    const a11 = { descriptor: __spreadProps(__spreadValues({}, t10), { type: "string_expr", valuePath: `${t10.valuePath}.${n11}` }), value: e15, defaultValue: "", placeholderEmpty: r10, setProperty: o10 };
    return tp.createElement(Lpe, __spreadValues({}, a11));
  }, onAdd: () => o10(t10, AV(n10 || [], { $push: [""] })), onDelete: (e15) => o10(t10, AV(n10, { $splice: [[e15, 1]] })) });
  return tp.createElement(Bde, __spreadValues({}, a10));
};
C_e.displayName = "StringExprCollectionEditor";
const x_e = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { value: { StyleId: n10, StyleName: r10 }, descriptor: o10 } = e14;
  const { meta: { target: a10 } } = o10;
  const { dispatch: i10, items: s10 } = ((e15) => {
    const { rdlx: { reportStyles: t11 } } = d9();
    const n11 = PA();
    return { items: t11.filter((t12) => t12.targetTypes.some((t13) => t13 === e15)), dispatch: n11 };
  })(a10);
  const l10 = $N(cY, "propertyDescriptors:labels.reportItem.style", "style_name", `${o10.valuePath}.StyleName`);
  const c10 = ep.useCallback(() => s10.map((e15) => e15.name), [s10]);
  const u10 = ep.useCallback(() => {
    const e15 = (s10 || []).find((e16) => e16.name === r10 || e16.id === n10);
    return (e15 == null ? void 0 : e15.name) || "";
  }, [n10, r10, s10]);
  const d10 = { value: "", label: t10("common.textNone") };
  const p10 = __spreadProps(__spreadValues({}, e14), { descriptor: l10, value: sK(r10) ? r10 : u10(), currentEnum: [d10, ...c10()], setProperty: (e15, t11) => {
    const n11 = s10.find((e16) => e16.name === t11) || void 0;
    if (void 0 === n11) return void i10(rz([v2({ id: null, name: null }), b2({ style: null })]));
    const { id: r11, name: o11 } = n11;
    i10(y2({ id: r11, name: o11 }));
  } });
  return tp.createElement(nse, __spreadValues({}, p10));
};
const w_e = (e14) => `barcode.${e14}`;
const T_e = ["Aztec"];
const E_e = ["Code49"];
const F_e = ["DataMatrix"];
const M_e = ["EAN128FNC1"];
const k_e = ["RSS14Stacked", "RSSLimited"];
const P_e = ["GS1DataMatrix"];
const N_e = ["MaxiCode"];
const D_e = ["MicroPDF417"];
const L_e = ["MicroQRCode"];
const H_e = ["Pdf417"];
const I_e = ["QRCode"];
const V_e = ["GS1QRCode"];
const R_e = ["RSSExpandedStacked"];
const A_e = ["EAN_13", "EAN_8", "UPC_A", "UPC_E0", "UPC_E1"];
const O_e = ["EAN_13", "EAN_8", "RSS14", "RSS14Stacked", "RSS14StackedOmnidirectional", "RSS14Truncated", "RSSExpanded", "RSSExpandedStacked", "RSSLimited", "UPC_A", "UPC_E0", "UPC_E1", "ISBN", "ISMN", "ISSN"];
const B_e = (e14, t10) => ({ min: e14, max: t10 });
const z_e = (e14, t10) => ({ numberType: "Integer", step: 1, minValue: e14, maxValue: t10 });
const $_e = (e14, t10) => ({ numberType: "Integer", step: 1, intervals: [{ min: e14[0], max: e14[1] }, { min: t10[0], max: t10[1] }] });
const W_e = (e14, t10) => ({ descriptor: e14, value: t10 });
const j_e = Zq(fY, w_e("symbology"), "barcode_symbology", "QrCodeOptions.Connection");
const Z_e = Zq(fY, w_e("symbology"), "barcode_symbology", "QrCodeOptions.ConnectionNumber");
const G_e = Zq(fY, w_e("symbology"), "barcode_symbology", "QrCodeOptions.Model");
const U_e = (e14, t10) => {
  if (!t10 || 0 === t10.length) return e14;
  const n10 = e14.filter((e15) => t10.includes(e15.value));
  return n10.length > 0 ? n10 : e14;
};
const q_e = (e14) => {
  const { t: t10 } = vp();
  const { rdlx: { reportItemsFeatures: { barcode: { symbologies: n10, hideUnsupportedBarcodeJSProperties: r10 } } } } = MO();
  const { descriptor: o10, value: a10, defaultValue: i10 } = e14;
  const { setProperties: s10 } = ep.useContext(Iue);
  const l10 = a10.Symbology;
  const c10 = __spreadProps(__spreadValues({}, e14), { descriptor: WN(o10, "Symbology"), value: a10.Symbology, defaultValue: i10.Symbology, setProperty: (e15, t11) => {
    const n11 = a10.Symbology || "";
    const r11 = [W_e(e15, t11)];
    t11 === V_e[0] && n11 !== t11 && r11.push(W_e(j_e, false), W_e(Z_e, 0), W_e(G_e, "Model2")), s10(r11);
  }, currentEnum: U_e(OO(o10.type, t10), n10) });
  const u10 = (t11, n11, r11) => __spreadProps(__spreadValues({}, e14), { descriptor: WN(t11, o10.valuePath), value: n11, defaultValue: r11 });
  const d10 = (e15, t11, n11, r11, o11) => {
    const a11 = u10(t11, n11, r11);
    return o11 && (a11.setProperty = o11), tp.createElement(Hie, __spreadValues({ key: e15 }, a11));
  };
  const p10 = (e15, t11, n11, r11, o11) => tp.createElement(wue, __spreadProps(__spreadValues({ key: e15 }, u10(t11, n11, r11)), { disabled: o11 }));
  const m10 = (e15, n11, o11, a11, i11) => {
    const s11 = u10(n11, o11, a11);
    if (i11 && "function" == typeof i11 && (s11.setProperty = i11), r10 && "barcode_encoding" === n11.type) {
      const e16 = ["932", "65001"];
      s11.currentEnum = OO(n11.type, t10).filter((t11) => e16.includes(t11.value));
    }
    return tp.createElement(nse, __spreadValues({ key: e15 }, s11));
  };
  const h10 = (e15, t11, n11, r11) => tp.createElement(Hpe, __spreadValues({ key: e15 }, u10(t11, n11, r11)));
  const f10 = (e15, t11, n11, r11) => tp.createElement(pse, __spreadValues({ key: e15 }, u10(t11, n11, r11)));
  return tp.createElement(tp.Fragment, null, tp.createElement(nse, __spreadValues({}, c10)), (() => {
    if (sK(l10)) return null;
    const e15 = [];
    const t11 = (e16) => (t12) => e16.toLowerCase() === t12.toLowerCase();
    const n11 = r10 && ["EAN_8", "EAN_13", "UPC_A", "UPC_E0", "UPC_E1"].includes(l10);
    if (O_e.some(t11(l10)) && !n11) {
      const t12 = Zq("", w_e("captionGrouping"), "boolean", "CaptionGrouping");
      e15.push(d10("caption", t12, a10.CaptionGrouping, i10.CaptionGrouping));
    }
    if (T_e.some(t11(l10))) {
      const t12 = Zq("", w_e("aztecOptions.layers"), "number", "AztecOptions.Layers", void 0, z_e(-4, 32));
      const n12 = Zq("", w_e("aztecOptions.errorCorrection"), "number", "AztecOptions.ErrorCorrection", void 0, z_e(5, 95));
      const o11 = a10.AztecOptions;
      const s11 = i10.AztecOptions;
      if (e15.push(p10("layers", t12, o11.Layers, s11.Layers), p10("errorCorrection", n12, o11.ErrorCorrection, s11.ErrorCorrection)), !r10) {
        const t13 = Zq("", w_e("aztecOptions.encoding"), "barcode_encoding", "AztecOptions.Encoding");
        e15.push(m10("encoding", t13, o11.Encoding, s11.Encoding));
      }
    }
    if (E_e.some(t11(l10))) {
      const t12 = Zq("", w_e("code49Options.grouping"), "boolean", "Code49Options.Grouping");
      const n12 = Zq("", w_e("code49Options.groupNumber"), "number", "Code49Options.GroupNumber", void 0, z_e(0, 8));
      const r11 = a10.Code49Options;
      const o11 = i10.Code49Options;
      e15.push(d10("grouping", t12, r11.Grouping, o11.Grouping), p10("groupNumber", n12, r11.GroupNumber, o11.GroupNumber));
    }
    if (F_e.some(t11(l10))) {
      const t12 = Zq("", w_e("dataMatrixOptions.eccMode"), "enum", "DataMatrixOptions.EccMode", void 0, { enumKey: "barcode_ecc_mode" });
      const n12 = Zq("", w_e("dataMatrixOptions.ecc200SymbolSize"), "barcode_ecc200_symbol_size", "DataMatrixOptions.Ecc200SymbolSize");
      const o11 = Zq("", w_e("dataMatrixOptions.ecc200EncodingMode"), "barcode_ecc200_encoding_mode", "DataMatrixOptions.Ecc200EncodingMode");
      const s11 = Zq("", w_e("dataMatrixOptions.ecc000_140SymbolSize"), "barcode_ecc000_140_symbol_size", "DataMatrixOptions.Ecc000_140SymbolSize");
      const l11 = Zq("", w_e("dataMatrixOptions.structuredAppend"), "boolean", "DataMatrixOptions.StructuredAppend");
      const c11 = Zq("", w_e("dataMatrixOptions.structureNumber"), "number", "DataMatrixOptions.StructureNumber", void 0, z_e(0, 15));
      const u11 = Zq("", w_e("dataMatrixOptions.fileIdentifier"), "number", "DataMatrixOptions.FileIdentifier", void 0, z_e(0, 254));
      const h11 = a10.DataMatrixOptions;
      const f11 = i10.DataMatrixOptions;
      if (e15.push(m10("eccMode", t12, h11.EccMode, f11.EccMode), m10("ecc200SymbolSize", n12, h11.Ecc200SymbolSize, f11.Ecc200SymbolSize), m10("ecc200EncodingMode", o11, h11.Ecc200EncodingMode, f11.Ecc200EncodingMode), m10("ecc000_140SymbolSize", s11, h11.Ecc000_140SymbolSize, f11.Ecc000_140SymbolSize), d10("structuredAppend", l11, h11.StructuredAppend, f11.StructuredAppend), p10("structureNumber", c11, h11.StructureNumber, f11.StructureNumber), p10("fileIdentifier", u11, h11.FileIdentifier, f11.FileIdentifier)), !r10) {
        const t13 = Zq("", w_e("dataMatrixOptions.encoding"), "barcode_encoding", "DataMatrixOptions.Encoding");
        e15.push(m10("encoding", t13, h11.Encoding, f11.Encoding));
      }
    }
    if (M_e.some(t11(l10))) {
      const t12 = Zq("", w_e("ean128Fnc1Options.resolution"), "number", "Ean128Fnc1Options.Resolution", void 0, z_e());
      const n12 = Zq("", w_e("ean128Fnc1Options.moduleSize"), "number", "Ean128Fnc1Options.ModuleSize", void 0, z_e());
      const r11 = Zq("", w_e("ean128Fnc1Options.barAdjust"), "number", "Ean128Fnc1Options.BarAdjust", void 0, z_e());
      const o11 = a10.Ean128Fnc1Options;
      const s11 = i10.Ean128Fnc1Options;
      e15.push(p10("resolution", t12, o11.Resolution, s11.Resolution), p10("moduleSize", n12, o11.ModuleSize, s11.ModuleSize), p10("barAdjust", r11, o11.BarAdjust, s11.BarAdjust));
    }
    if (k_e.some(t11(l10))) {
      const t12 = Zq("", w_e("gs1CompositeOptions.type"), "barcode_gs1_composite_type", "Gs1CompositeOptions.CompositeType");
      const n12 = Zq("", w_e("gs1CompositeOptions.value"), "string_expr", "Gs1CompositeOptions.Value");
      const r11 = a10.Gs1CompositeOptions;
      const o11 = i10.Gs1CompositeOptions;
      e15.push(m10("compositeType", t12, r11.CompositeType, o11.CompositeType), h10("value", n12, r11.Value, o11.Value));
    }
    if (P_e.some(t11(l10))) {
      const t12 = Zq("", w_e("dataMatrixOptions.symbolSize"), "barcode_ecc200_symbol_size", "DataMatrixOptions.Ecc200SymbolSize");
      const n12 = Zq("", w_e("dataMatrixOptions.encodingMode"), "barcode_ecc200_encoding_mode", "DataMatrixOptions.Ecc200EncodingMode");
      const r11 = Zq("", w_e("dataMatrixOptions.structuredAppend"), "boolean", "DataMatrixOptions.StructuredAppend");
      const o11 = Zq("", w_e("dataMatrixOptions.structureNumber"), "number", "DataMatrixOptions.StructureNumber", void 0, z_e(0, 15));
      const s11 = Zq("", w_e("dataMatrixOptions.fileIdentifier"), "number", "DataMatrixOptions.FileIdentifier", void 0, z_e(0, 254));
      const l11 = a10.DataMatrixOptions;
      const c11 = i10.DataMatrixOptions;
      e15.push(m10("symbolSize", t12, l11.Ecc200SymbolSize, c11.Ecc200SymbolSize), m10("encodingMode", n12, l11.Ecc200EncodingMode, c11.Ecc200EncodingMode), d10("structuredAppend", r11, l11.StructuredAppend, c11.StructuredAppend), p10("structureNumber", o11, l11.StructureNumber, c11.StructureNumber), p10("fileIdentifier", s11, l11.FileIdentifier, c11.FileIdentifier));
    }
    if (N_e.some(t11(l10))) {
      const t12 = Zq("", w_e("maxiCodeOptions.mode"), "barcode_maxicode_mode", "MaxiCodeOptions.Mode");
      const n12 = a10.MaxiCodeOptions;
      const r11 = i10.MaxiCodeOptions;
      e15.push(m10("mode", t12, n12.Mode, r11.Mode));
    }
    if (D_e.some(t11(l10))) {
      const t12 = Zq("", w_e("microPdf417Options.compactionMode"), "barcode_micro_pdf417_compaction_mode", "MicroPdf417Options.CompactionMode");
      const n12 = Zq("", w_e("microPdf417Options.version"), "barcode_micro_pdf417_version", "MicroPdf417Options.Version");
      const r11 = Zq("", w_e("microPdf417Options.segmentIndex"), "number", "MicroPdf417Options.SegmentIndex", void 0, z_e(0, 99998));
      const o11 = Zq("", w_e("microPdf417Options.segmentCount"), "number", "MicroPdf417Options.SegmentCount", void 0, z_e(0, 99999));
      const s11 = Zq("", w_e("microPdf417Options.fileId"), "number", "MicroPdf417Options.FileID", void 0, z_e(0, 899));
      const l11 = a10.MicroPdf417Options;
      const c11 = i10.MicroPdf417Options;
      e15.push(m10("compactionMode", t12, l11.CompactionMode, c11.CompactionMode), m10("version", n12, l11.Version, c11.Version), p10("segmentIndex", r11, l11.SegmentIndex, c11.SegmentIndex), p10("segmentCount", o11, l11.SegmentCount, c11.SegmentCount), p10("fileID", s11, l11.FileID, c11.FileID));
    }
    if (L_e.some(t11(l10))) {
      const t12 = Zq("", w_e("microQrCodeOptions.version"), "barcode_micro_qrcode_version", "MicroQrCodeOptions.Version");
      const n12 = Zq("", w_e("microQrCodeOptions.errorLevel"), "barcode_micro_qrcode_error_level", "MicroQrCodeOptions.ErrorLevel");
      const o11 = Zq("", w_e("microQrCodeOptions.mask"), "barcode_micro_qrcode_mask", "MicroQrCodeOptions.Mask");
      const s11 = a10.MicroQrCodeOptions;
      const l11 = i10.MicroQrCodeOptions;
      if (e15.push(m10("version", t12, s11.Version, l11.Version), m10("errorLevel", n12, s11.ErrorLevel, l11.ErrorLevel), m10("mask", o11, s11.Mask, l11.Mask)), !r10) {
        const t13 = Zq("", w_e("microQrCodeOptions.encoding"), "barcode_encoding", "MicroQrCodeOptions.Encoding");
        e15.push(m10("encoding", t13, s11.Encoding, l11.Encoding));
      }
    }
    if (H_e.some(t11(l10))) {
      const t12 = Zq("", w_e("pdf417Options.columns"), "number", "Pdf417Options.Columns", void 0, $_e([-1, -1], [1, 30]));
      const n12 = Zq("", w_e("pdf417Options.rows"), "number", "Pdf417Options.Rows", void 0, $_e([-1, -1], [3, 30]));
      const r11 = Zq("", w_e("pdf417Options.errorCorrectionLevel"), "barcode_pdf417_error_correction_level", "Pdf417Options.ErrorCorrectionLevel");
      const o11 = Zq("", w_e("pdf417Options.type"), "barcode_pdf417_type", "Pdf417Options.Pdf417Type");
      const s11 = a10.Pdf417Options;
      const l11 = i10.Pdf417Options;
      e15.push(p10("columns", t12, s11.Columns, l11.Columns), p10("rows", n12, s11.Rows, l11.Rows), m10("errorCorrectionLevel", r11, s11.ErrorCorrectionLevel, l11.ErrorCorrectionLevel), m10("pdf417Type", o11, s11.Pdf417Type, l11.Pdf417Type));
    }
    if (I_e.some(t11(l10))) {
      const t12 = a10.QrCodeOptions;
      const n12 = i10.QrCodeOptions;
      const r11 = (e16) => {
        const t13 = (e17, t14) => e17.toLowerCase() === t14.toLowerCase();
        return sK(e16) || t13(e16, "Model1") || t13(n12.Model, "Model1") ? 14 : 40;
      };
      const o11 = (e16 = t12.Connection, n13 = t12.Model) => true === e16 || sK(e16) ? [B_e(1, r11(n13))] : [B_e(-1, -1), B_e(1, r11(n13))];
      const l11 = (e16, n13 = t12.Version, r12 = t12.Model) => !!sK(n13) || o11(e16, r12).some(({ min: e17, max: t13 }) => e17 <= n13 && n13 <= t13);
      const c11 = (e16, n13 = t12.Model) => o11(e16, n13)[0].min;
      const u11 = (e16, n13) => {
        const r12 = [W_e(y10, n13)];
        n13 ? l11(n13) || r12.push(W_e(b10, c11(n13))) : 0 !== t12.ConnectionNumber && r12.push(W_e(v10, 0)), s10(r12);
      };
      const h11 = (e16, n13) => {
        const r12 = [{ descriptor: e16, value: n13 }];
        l11(t12.Connection, t12.Version, n13) || r12.push({ descriptor: b10, value: c11(t12.Connection, n13) }), s10(r12);
      };
      const f11 = sK(t12.Connection) || false === t12.Connection ? 0 : 15;
      const g10 = sK(t12.Connection) || true === t12.Connection ? 1 : n12.Version;
      const y10 = Zq("", w_e("qrCodeOptions.connection"), "boolean", "QrCodeOptions.Connection");
      const v10 = Zq("", w_e("qrCodeOptions.connectionNumber"), "number", "QrCodeOptions.ConnectionNumber", void 0, z_e(0, f11));
      const b10 = Zq("", w_e("qrCodeOptions.version"), "number", "QrCodeOptions.Version", void 0, { numberType: "Integer", step: 1, intervals: o11() });
      const S10 = Zq("", w_e("qrCodeOptions.errorLevel"), "barcode_qrcode_error_level", "QrCodeOptions.ErrorLevel");
      const C10 = Zq("", w_e("qrCodeOptions.mask"), "barcode_qrcode_mask", "QrCodeOptions.Mask");
      const x10 = Zq("", w_e("qrCodeOptions.model"), "barcode_qrcode_model", "QrCodeOptions.Model");
      const w10 = Zq("", w_e("qrCodeOptions.encoding"), "barcode_encoding", "QrCodeOptions.Encoding");
      e15.push(d10("connection", y10, t12.Connection, n12.Connection, u11), p10("connectionNumber", v10, t12.ConnectionNumber, n12.ConnectionNumber, sK(t12.Connection) || false === t12.Connection), p10("version", b10, t12.Version, g10), m10("errorLevel", S10, t12.ErrorLevel, n12.ErrorLevel), m10("mask", C10, t12.Mask, n12.Mask), m10("model", x10, t12.Model, n12.Model, h11), m10("encoding", w10, t12.Encoding, n12.Encoding));
    }
    if (V_e.some(t11(l10))) {
      const t12 = a10.QrCodeOptions;
      const n12 = i10.QrCodeOptions;
      const o11 = sK(t12.Connection) || true === t12.Connection ? 1 : n12.Version;
      const s11 = Zq("", w_e("gs1QrCodeOptions.version"), "number", "QrCodeOptions.Version", void 0, $_e([-1, -1], [1, 40]));
      const l11 = Zq("", w_e("gs1QrCodeOptions.errorLevel"), "barcode_qrcode_error_level", "QrCodeOptions.ErrorLevel");
      const c11 = Zq("", w_e("gs1QrCodeOptions.mask"), "barcode_qrcode_mask", "QrCodeOptions.Mask");
      if (e15.push(p10("version", s11, t12.Version, o11), m10("errorLevel", l11, t12.ErrorLevel, n12.ErrorLevel), m10("mask", c11, t12.Mask, n12.Mask)), !r10) {
        const r11 = Zq("", w_e("gs1QrCodeOptions.encoding"), "barcode_encoding", "QrCodeOptions.Encoding");
        e15.push(m10("encoding", r11, t12.Encoding, n12.Encoding));
      }
    }
    if (R_e.some(t11(l10))) {
      const t12 = Zq("", w_e("rssExpandedStacked.rowCount"), "number", "RssExpandedStacked.RowCount", void 0, z_e(1, 11));
      const n12 = a10.RssExpandedStacked;
      const r11 = i10.RssExpandedStacked;
      e15.push(p10("rowCount", t12, n12.RowCount, r11.RowCount));
    }
    if (A_e.some(t11(l10))) {
      const t12 = Zq("", w_e("supplementOptions.value"), "string_expr", "SupplementOptions.Value");
      const n12 = Zq("", w_e("supplementOptions.barHeight"), "length", "SupplementOptions.BarHeight");
      const r11 = Zq("", w_e("supplementOptions.spacing"), "length", "SupplementOptions.Spacing");
      const o11 = Zq("", w_e("supplementOptions.captionLocation"), "enum", "SupplementOptions.CaptionLocation", void 0, { enumKey: "barcode_caption_location" });
      const s11 = a10.SupplementOptions;
      const l11 = i10.SupplementOptions;
      e15.push(h10("value", t12, s11.Value, l11.Value), f10("barHeight", n12, s11.BarHeight, l11.BarHeight), f10("spacing", r11, s11.Spacing, l11.Spacing), m10("captionLocation", o11, s11.CaptionLocation, l11.CaptionLocation));
    }
    return e15;
  })());
};
const Y_e = "RDLX/TABLE/MERGE_CELLS";
const K_e = "RDLX/TABLE/SPLIT_CELLS";
const X_e = "RDLX/TABLE/INSERT_ROW";
const J_e = "RDLX/TABLE/INSERT_COLUMN";
const Q_e = "RDLX/TABLE/RELOCATE_COLUMNS";
const eVe = "RDLX/TABLE/INSERT_GROUP";
const tVe = "RDLX/TABLE/INSERT_ROW_AT_INDEX";
const nVe = "RDLX/TABLE/INSERT_COLUMN_AT_INDEX";
const rVe = "RDLX/TABLE/INSERT_GROUP_AT_INDEX";
const oVe = "RDLX/TABLE/DELETE_ROWS";
const aVe = "RDLX/TABLE/DELETE_COLUMNS";
const iVe = "RDLX/TABLE/DELETE_GROUPS";
const sVe = "RDLX/TABLE/TOGGLE_HEADER";
const lVe = "RDLX/TABLE/TOGGLE_FOOTER";
const cVe = "RDLX/TABLE/TOGGLE_DETAILS";
const uVe = "RDLX/TABLE/TOGGLE_GROUP_HEADER";
const dVe = "RDLX/TABLE/TOGGLE_GROUP_FOOTER";
const pVe = "RDLX/TABLE/SET_HEADER_FOOTER_PROPERTY";
const mVe = { BEFORE: "Before", AFTER: "After" };
function hVe(e14, t10 = 1) {
  return { type: X_e, payload: { position: e14, count: t10 } };
}
function fVe(e14, t10 = 1) {
  return { type: J_e, payload: { position: e14, count: t10 } };
}
function gVe(e14) {
  return { type: tVe, payload: { index: e14 } };
}
function yVe(e14) {
  return { type: nVe, payload: { index: e14 } };
}
function vVe() {
  return { type: oVe, payload: {} };
}
function bVe() {
  return { type: aVe, payload: {} };
}
function SVe() {
  return { type: iVe, payload: {} };
}
function CVe() {
  return { type: sVe, payload: {} };
}
function xVe() {
  return { type: lVe, payload: {} };
}
function wVe() {
  return { type: cVe, payload: {} };
}
function TVe() {
  return { type: uVe, payload: {} };
}
function EVe() {
  return { type: dVe, payload: {} };
}
function FVe(e14, t10) {
  return { type: pVe, payload: { valuePath: e14, value: t10 } };
}
const MVe = $N("", "propertyDescriptors:labels.table.printAtBottom", "boolean", "PrintAtBottom");
const kVe = $N("", "propertyDescriptors:labels.table.repeatOnNewPage", "boolean", "RepeatOnNewPage");
const PVe = (e14) => {
  const { descriptor: { valuePath: t10 } } = e14;
  const { getAreaByPath: n10 } = ep.useContext(Iue);
  const r10 = ep.useContext(Rue);
  const o10 = PA();
  if ("function" != typeof n10) throw new Error("TableFooterEditor requires getAreaByPath() in CommonEditorsContext");
  const a10 = (e15, t11) => {
    o10(FVe(e15.valuePath, t11));
  };
  const i10 = (({ namedItems: e15, selectedItemsInfo: t11 }) => {
    const n11 = e15.filter((e16) => t11.some((t12) => t12.path === e16.$path));
    if (!n11.length) return null;
    if (n11.some((e16) => "tablefooter" !== e16.$options.sectionType)) return null;
    if (!n11[0].$options) return null;
    let { printAtBottom: r11, repeatOnNewPage: o11 } = n11[0].$options;
    return n11.forEach((e16) => {
      e16.$options.printAtBottom !== r11 && (r11 = XN), e16.$options.repeatOnNewPage !== o11 && (o11 = XN);
    }), { printAtBottom: r11, repeatOnNewPage: o11 };
  })(r10);
  if (!i10) return null;
  const s10 = !!r10.namedItems.find((e15) => "fixedpagereport" === e15.type);
  const l10 = !r10.selectedItemsInfo.find((e15) => n10(e15.path) !== gee);
  const c10 = __spreadProps(__spreadValues({}, e14), { value: i10.printAtBottom, descriptor: WN(MVe, t10), setProperty: a10 });
  const u10 = __spreadProps(__spreadValues({}, e14), { value: i10.repeatOnNewPage, descriptor: WN(kVe, t10), setProperty: a10 });
  return tp.createElement(tp.Fragment, null, s10 && l10 && tp.createElement(Hie, __spreadValues({}, c10)), tp.createElement(Hie, __spreadValues({}, u10)));
};
PVe.displayName = "TableFooterEditor";
const NVe = $N("", "propertyDescriptors:labels.table.repeatOnNewPage", "boolean", "RepeatOnNewPage");
const DVe = (e14) => {
  const { descriptor: { valuePath: t10 } } = e14;
  const n10 = ep.useContext(Rue);
  const r10 = PA();
  const o10 = (({ namedItems: e15, selectedItemsInfo: t11 }) => {
    const n11 = e15.filter((e16) => t11.some((t12) => t12.path === e16.$path));
    if (!n11.length) return null;
    if (n11.some((e16) => "tableheader" !== e16.$options.sectionType)) return null;
    if (!n11[0].$options) return null;
    let { repeatOnNewPage: r11 } = n11[0].$options;
    return n11.forEach((e16) => {
      e16.$options.repeatOnNewPage !== r11 && (r11 = XN);
    }), { repeatOnNewPage: r11 };
  })(n10);
  if (!o10) return null;
  const a10 = __spreadProps(__spreadValues({}, e14), { value: o10.repeatOnNewPage, descriptor: WN(NVe, t10), setProperty: (e15, t11) => {
    r10(FVe(e15.valuePath, t11));
  } });
  return tp.createElement(Hie, __spreadValues({}, a10));
};
DVe.displayName = "TableHeaderEditor";
const LVe = (e14) => {
  const { rdlx: { propertyGrid: { objectPath: t10 } } } = d9();
  const { descriptor: n10 } = e14;
  return ((e15) => {
    const t11 = e15.split(".Members");
    return t11[t11.length - 2].endsWith("ColumnHierarchy");
  })(t10[0]) ? null : tp.createElement(nse, __spreadProps(__spreadValues({}, e14), { descriptor: __spreadProps(__spreadValues({}, n10), { type: "enum" }) }));
};
LVe.displayName = "TablixMemberNewPageEditor";
const HVe = (e14) => {
  const { value: { Header: t10, Children: n10, Type: r10 } } = e14;
  const { lockLayout: o10 } = MO();
  const a10 = PA();
  const i10 = "dynamictablixmember" === r10;
  const s10 = __spreadProps(__spreadValues({}, e14), { value: i10, disabled: !t10 && i10 && n10.length || o10, setProperty: () => {
    a10(EZ());
  } });
  return tp.createElement(Hie, __spreadValues({}, s10));
};
HVe.displayName = "TablixMemberTypeEditor";
const IVe = (e14) => {
  const { descriptor: t10 } = e14;
  const { selectedItemsInfo: n10 } = ep.useContext(Rue);
  const { instanceId: r10 } = qHe();
  const { t: o10 } = vp();
  const a10 = n10.map((e15) => e15.type);
  const i10 = ((e15, t11, n11) => {
    const r11 = eK.of(e15).getTextDecorations(n11);
    return t11.filter((e16) => e16 && r11.includes(e16.value));
  })(r10, OO(t10.type, o10), a10);
  return tp.createElement(Dde, __spreadProps(__spreadValues({}, e14), { currentEnum: i10 }));
};
IVe.displayName = "TextDecorationEditor";
const [, , _Ve] = Dp("wd-themes-editor");
const [VVe] = _Ve("preview-color");
const [RVe] = _Ve("preview-item");
const AVe = (e14) => (t10) => {
  if (!t10 && !e14) return null;
  const { Colors: n10 } = e14 || t10;
  const r10 = ((e15) => e15 && [e15.Accent1 || "white", e15.Accent2 || "white", e15.Accent3 || "white", e15.Accent4 || "white"])(n10);
  return tp.createElement("div", { className: e14 ? RVe : VVe }, r10.map((e15) => tp.createElement("span", { key: e15, style: { backgroundColor: e15 } })));
};
const OVe = (e14) => {
  var _a2;
  const { t: t10, i18n: n10 } = vp("propertyEditors");
  const { descriptor: r10, value: o10, setProperty: a10, withNoneValue: i10, disabled: s10 } = e14;
  const { API: l10 } = ep.useContext(Sm);
  const { expressionSyntax: c10 } = ep.useContext(Vue);
  const { items: u10, getThemeById: d10, makeComboBoxItems: p10, dispatch: m10 } = zVe();
  const h10 = h9();
  const f10 = 0 === (((_a2 = h10.$masterReportContent) == null ? void 0 : _a2.Themes) || []).length && i10;
  const g10 = ep.useMemo(() => () => ({ type: "button", text: t10("common.textNone"), value: "" }), [t10]);
  const y10 = ep.useCallback((e15, t11) => {
    var _a3;
    const n11 = gc(c10, t11);
    const r11 = !n11 && ((_a3 = u10.find((e16) => e16.name === t11 || e16.id === t11)) == null ? void 0 : _a3.id);
    n11 ? a10(e15, t11) : r11 && a10(e15, r11);
  }, [c10, a10, u10]);
  const v10 = ep.useMemo(() => {
    const e15 = NX();
    if (!e15) return null;
    const { label: t11, open: a11 } = e15;
    const i11 = u10.find((e16) => e16.name === o10);
    const s11 = i11 ? i11.id : null;
    return npe(s11, (e16) => y10(r10, SX(e16)), () => {
      var _a3;
      (_a3 = l10.dropdowns.current) == null ? void 0 : _a3.close();
    }, n10, t11, a11);
  }, [l10.dropdowns, r10, n10, u10, y10, o10]);
  const b10 = gc(c10, o10) ? o10 : xX(o10).id || "";
  const S10 = d10(b10);
  const C10 = p10(b10);
  const x10 = ep.useCallback((e15, t11) => y10(e15, NJ(t11, r10.type, { expressionSyntax: c10 })), [r10.type, c10, y10]);
  const w10 = ep.useCallback((e15) => {
    e15 ? y10(r10, e15.id ? SX(e15.id) : "") : m10(m2(void 0, {}));
  }, [r10, m10, y10]);
  const T10 = ep.useCallback((e15) => {
    e15 ? y10(r10, e15) : m10(m2(void 0, {}));
  }, [r10, m10, y10]);
  const E10 = ep.useMemo(() => null === v10 ? [f10 && g10(), ...C10] : [v10, { type: "splitter" }, f10 && g10(), ...C10], [g10, C10, v10, f10]);
  const F10 = { descriptor: r10, disabled: s10, setProperty: x10, value: S10 && S10.name || o10, items: E10, onSelect: w10, onChange: T10, generateItemPreview: AVe(), generatePreview: S10 ? AVe(S10) : void 0 };
  return tp.createElement(Nde, __spreadValues({}, F10));
};
OVe.displayName = "ThemesEditor";
const BVe = _D(OVe);
const zVe = () => {
  const { rdlx: { sharedThemes: { items: e14 } } } = d9();
  const t10 = PA();
  return { items: e14, getThemeById: (t11) => e14.find((e15) => e15.id === t11), makeComboBoxItems: (t11) => e14.map((e15) => ({ text: e15.name, selected: e15.id === t11, type: "button", value: e15 })), dispatch: t10 };
};
const $Ve = (e14) => {
  const { descriptor: t10, value: n10, setProperty: r10 } = e14;
  const o10 = h9();
  const { items: a10 } = zVe();
  const i10 = __spreadProps(__spreadValues({}, e14), { value: n10 || [], reordering: { type: "drag" }, createEditor: (e15, n11) => {
    var _a2, _b2;
    const a11 = ((_b2 = (_a2 = o10.$masterReportContent) == null ? void 0 : _a2.Themes) != null ? _b2 : []).length > 0 && n11 > 0;
    const i11 = Zq(cY, "report.themes", "string_expr", `${t10.valuePath}.${n11}`, "advanced");
    const s10 = { descriptor: __spreadProps(__spreadValues({}, i11), { meta: __spreadProps(__spreadValues({}, i11.meta), { disabled: a11 }) }), disabled: a11, value: e15, setProperty: r10 };
    return tp.createElement(OVe, __spreadValues({}, s10));
  }, onAdd: () => {
    const e15 = a10.length > 0 ? SX(a10[0].id) : "";
    r10(t10, AV(n10 || [], { $push: [e15] }));
  }, onDelete: (e15) => r10(t10, AV(n10, { $splice: [[e15, 1]] })) });
  return tp.createElement(Bde, __spreadValues({}, i10));
};
$Ve.displayName = "ThemesCollectionEditor";
const WVe = ep.createContext({ sortTarget: [], sortExpressionScope: [] });
const jVe = (e14) => `userSort.${e14}`;
const ZVe = Zq("", jVe("sortExpression"), "string_expr", "SortExpression");
const GVe = Zq("", jVe("sortExpressionScope"), "string", "SortExpressionScope");
const UVe = Zq("", jVe("sortTarget"), "string", "SortTarget");
const qVe = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { sortTarget: n10, sortExpressionScope: r10 } = ep.useContext(WVe);
  const o10 = (n11) => Xue(e14, n11, t10);
  const a10 = __spreadProps(__spreadValues({}, o10(GVe)), { currentEnum: r10.map((e15) => ({ value: e15, label: e15 })) });
  const i10 = __spreadProps(__spreadValues({}, o10(UVe)), { currentEnum: n10.map((e15) => ({ value: e15, label: e15 })) });
  return tp.createElement(tp.Fragment, null, tp.createElement(Hpe, __spreadValues({}, o10(ZVe))), tp.createElement(Wue, __spreadValues({}, a10)), tp.createElement(Wue, __spreadValues({}, i10)));
};
qVe.displayName = "UserSortEditor";
const YVe = (e14) => `propertyDescriptors:labels.visibility.${e14}`;
const KVe = $N(yY, YVe("hidden"), "boolean_expr", "Hidden");
const XVe = $N(yY, YVe("toggleItem"), "toggle_item", "ToggleItem");
const JVe = (e14) => {
  const { t: t10 } = vp("propertyEditors");
  const { namedItems: n10, selectedItemsInfo: r10 } = ep.useContext(Rue);
  const o10 = ep.useCallback((e15) => r10.some((t11) => t11.name === e15.name), [r10]);
  const a10 = ep.useMemo(() => n10.filter((e15) => e15.type && "textbox" === e15.type && !o10(e15)).map((e15) => ({ value: e15.name, label: e15.name })), [o10, n10]);
  const i10 = ep.useMemo(() => [{ value: "", label: t10("common.textNone") }, ...a10], [t10, a10]);
  const s10 = __spreadProps(__spreadValues({}, Xue(e14, XVe, t10)), { currentEnum: i10 });
  return tp.createElement(tp.Fragment, null, tp.createElement(tme, __spreadValues({}, Xue(e14, KVe, t10))), tp.createElement(Wue, __spreadValues({}, s10)));
};
JVe.displayName = "VisibilityEditor";
const QVe = __spreadProps(__spreadValues({}, Hue), { action: (e14, t10) => tp.createElement($pe, __spreadValues({ key: t10 }, e14)), auto_merge_mode: (e14, t10) => tp.createElement(jpe, __spreadValues({ key: t10 }, e14)), background_borders: (e14, t10) => tp.createElement(ZIe, __spreadValues({ key: t10 }, e14)), background_image: (e14, t10) => tp.createElement(mFe, __spreadProps(__spreadValues({ key: t10 }, e14), { features: ["source_value", "mime_type", "repeat"] })), barcode_symbology: (e14, t10) => tp.createElement(q_e, __spreadProps(__spreadValues({}, e14), { key: t10 })), barcode_quiet_zone: (e14, t10) => tp.createElement(cHe, __spreadValues({ key: t10 }, e14)), boolean_expr: (e14, t10) => tp.createElement(tme, __spreadValues({ key: t10 }, e14)), border: (e14, t10) => tp.createElement(Ohe, __spreadValues({ key: t10 }, e14)), border_style: (e14, t10) => tp.createElement(The, __spreadValues({ key: t10 }, e14)), color: (e14, t10) => tp.createElement(ohe, __spreadValues({ key: t10 }, e14)), color_expr: (e14, t10) => tp.createElement(ahe, __spreadValues({ key: t10 }, e14)), color_expr_collection: (e14, t10) => tp.createElement(phe, __spreadValues({ key: t10 }, e14)), corner: (e14, t10) => tp.createElement(Whe, __spreadValues({ key: t10 }, e14)), dataset_name: (e14, t10) => tp.createElement(Zhe, __spreadValues({ key: t10 }, e14)), dataset_nested_datasets_collection: (e14, t10) => tp.createElement(Uhe, __spreadProps(__spreadValues({}, e14), { key: t10 })), dataset_calculated_field_collection: (e14, t10) => tp.createElement(rSe, __spreadProps(__spreadValues({}, e14), { key: t10, validateKeys: true })), dataset_field_collection: (e14, t10) => tp.createElement(rSe, __spreadProps(__spreadValues({}, e14), { key: t10, validateKeys: true })), dataset_parameter_collection: (e14, t10) => tp.createElement(rSe, __spreadProps(__spreadValues({}, e14), { key: t10, tooltipKey: "dataRegion.dataSetParameters", validateKeys: true, allowEmptyKeys: true })), dataset_query_parameter_collection: (e14, t10) => tp.createElement(rSe, __spreadProps(__spreadValues({}, e14), { key: t10, tooltipKey: "dataRegion.dataSetParameters", validateKeys: true })), dataset_query: (e14, t10) => tp.createElement(Khe, __spreadValues({ key: t10 }, e14)), level_collection: (e14, t10) => tp.createElement(Zke, __spreadValues({ key: t10 }, e14)), data_visualizer_color_scale: (e14, t10) => tp.createElement(wfe, __spreadValues({ key: t10 }, e14)), data_visualizer_gradient: (e14, t10) => tp.createElement(Ife, __spreadValues({ key: t10 }, e14)), data_visualizer_range_bar: (e14, t10) => tp.createElement(jfe, __spreadValues({ key: t10 }, e14)), data_visualizer_data_bar: (e14, t10) => tp.createElement(Qfe, __spreadValues({ key: t10 }, e14)), data_visualizer_hatch: (e14, t10) => tp.createElement(uge, __spreadValues({ key: t10 }, e14)), data_visualizer_icon_set: (e14, t10) => tp.createElement(lye, __spreadValues({ key: t10 }, e14)), dvchart_axis_collection: (e14, t10) => tp.createElement(GSe, __spreadValues({ key: t10 }, e14)), dvchart_axis_plot_name_collection: (e14, t10) => tp.createElement(qSe, __spreadValues({ key: t10 }, e14)), dvchart_axis_sizes: (e14, t10) => tp.createElement(CCe, __spreadValues({ key: t10 }, e14)), dvchart_axis_scale: (e14, t10) => tp.createElement(fCe, __spreadValues({ key: t10 }, e14)), dvchart_color_encoding_collection: (e14, t10) => tp.createElement(Qbe, __spreadValues({ key: t10 }, e14)), dvchart_details_encoding_collection: (e14, t10) => tp.createElement(uSe, __spreadProps(__spreadValues({ key: t10 }, e14), { encodingName: "Details" })), dvchart_encoding_field_collection: (e14, t10) => tp.createElement(xye, __spreadValues({ key: t10 }, e14)), dvchart_encoding_field_details: (e14, t10) => tp.createElement(aSe, __spreadValues({ key: t10 }, e14)), dvchart_encoding_field_simple: (e14, t10) => tp.createElement(TSe, __spreadValues({ key: t10 }, e14)), dvchart_overlay_axis_value: (e14, t10) => tp.createElement(MCe, __spreadProps(__spreadValues({}, e14), { key: t10 })), dvchart_overlay_fields: (e14, t10) => tp.createElement(wCe, __spreadValues({ key: t10 }, e14)), dvchart_palette: (e14, t10) => tp.createElement(KPe, __spreadValues({ key: t10 }, e14)), dvchart_plot_collection: (e14, t10) => tp.createElement(NCe, __spreadValues({ key: t10 }, e14)), dvchart_plot_rules_collection: (e14, t10) => tp.createElement($we, __spreadValues({ key: t10 }, e14)), dvchart_plot_custom_labels: (e14, t10) => tp.createElement(HCe, __spreadValues({ key: t10 }, e14)), dvchart_plot_pointers: (e14, t10) => tp.createElement(KCe, __spreadValues({ key: t10 }, e14)), dvchart_plot_show_values_names_in_legend: (e14, t10) => tp.createElement(OSe, __spreadValues({ key: t10 }, e14)), dvchart_plot_overlay_name: (e14, t10) => tp.createElement(Xde, __spreadValues({ key: t10 }, e14)), dvchart_plot_overlay_type: (e14, t10) => tp.createElement(ZCe, __spreadValues({ key: t10 }, e14)), dvchart_plot_overlays_collection: (e14, t10) => tp.createElement($Ce, __spreadValues({ key: t10 }, e14)), dvchart_plot_rule_condition: (e14, t10) => tp.createElement(OTe, __spreadValues({ key: t10 }, e14)), dvchart_plot_rule_properties: (e14, t10) => tp.createElement(VTe, __spreadValues({ key: t10 }, e14)), dvchart_plot_name: (e14, t10) => tp.createElement(PCe, __spreadValues({ key: t10 }, e14)), dvchart_plot_template: (e14, t10) => tp.createElement(bTe, __spreadValues({ key: t10 }, e14)), dvchart_without_aggregate_field: (e14, t10) => tp.createElement(xCe, __spreadValues({ key: t10 }, e14)), dvchart_template: (e14, t10) => tp.createElement(MTe, __spreadValues({ key: t10 }, e14)), dvchart_text_encoding_collection: (e14, t10) => tp.createElement(uSe, __spreadProps(__spreadValues({ key: t10 }, e14), { encodingName: "Texts" })), dvchart_text_encoding_name: (e14, t10) => tp.createElement(kSe, __spreadValues({ key: t10 }, e14)), dvchart_value_encoding_fields_advanced: (e14, t10) => tp.createElement(RSe, __spreadValues({ key: t10 }, e14)), dvchart_value_encoding_fields_simple: (e14, t10) => tp.createElement(RSe, __spreadValues({ key: t10 }, e14)), dvchart_values_encoding_collection: (e14, t10) => tp.createElement(uSe, __spreadValues({ key: t10 }, e14)), dvchart_legend_range_options_collection: (e14, t10) => tp.createElement(rSe, __spreadProps(__spreadValues({}, e14), { key: t10 })), embedded_images_collection: (e14, t10) => tp.createElement(TFe, __spreadValues({ key: t10 }, e14)), end_point: (e14, t10) => tp.createElement(SLe, __spreadValues({ key: t10 }, e14)), enum_expr: (e14, t10) => tp.createElement(Hde, __spreadValues({ key: t10 }, e14)), field_name: (e14, t10) => tp.createElement(BTe, __spreadValues({ key: t10 }, e14)), filter_collection: (e14, t10) => tp.createElement($Te, __spreadValues({ key: t10 }, e14)), font: (e14, t10) => tp.createElement(XTe, __spreadValues({ key: t10 }, e14)), font_family: (e14, t10) => tp.createElement(ZTe, __spreadValues({ key: t10 }, e14)), font_simple: (e14, t10) => tp.createElement(m_e, __spreadValues({ key: t10 }, e14)), font_size_expr: (e14, t10) => tp.createElement(Hde, __spreadValues({ key: t10 }, e14)), fpl_page_size: (e14, t10) => tp.createElement(zPe, __spreadProps(__spreadValues({}, e14), { key: t10 })), format: (e14, t10) => tp.createElement(vEe, __spreadProps(__spreadValues({}, e14), { key: t10 })), group_expr_collection: (e14, t10) => tp.createElement(C_e, __spreadValues({ key: t10 }, e14)), group_expr_ext_collection: (e14, t10) => tp.createElement(xEe, __spreadValues({ key: t10 }, e14)), html_expr: (e14, t10) => tp.createElement(wEe, __spreadValues({ key: t10 }, e14)), image_data_advanced: (e14, t10) => tp.createElement(mFe, __spreadProps(__spreadValues({ key: t10 }, e14), { features: ["source_value", "mime_type"] })), inline_filters: (e14, t10) => tp.createElement(gke, __spreadValues({ key: t10 }, e14)), input_type: (e14, t10) => tp.createElement(bke, __spreadValues({ key: t10 }, e14)), language: (e14, t10) => tp.createElement(Ske, __spreadValues({ key: t10 }, e14)), layer: (e14, t10) => tp.createElement(Mke, __spreadValues({ key: t10 }, e14)), layer_collection: (e14, t10) => tp.createElement(Pke, __spreadValues({ key: t10 }, e14)), layer_name: (e14, t10) => tp.createElement(Dke, __spreadValues({ key: t10 }, e14)), length: (e14, t10) => tp.createElement(pse, __spreadValues({ key: t10 }, e14)), length_expr: (e14, t10) => tp.createElement(yhe, __spreadValues({ key: t10 }, e14)), length_locsize: (e14, t10) => tp.createElement(She, __spreadValues({ key: t10 }, e14)), report_parts_library: (e14, t10) => tp.createElement(RHe, __spreadValues({ key: t10 }, e14)), report_part_property: (e14, t10) => tp.createElement(FHe, __spreadValues({ key: t10 }, e14)), link_to_child: (e14, t10) => tp.createElement(Gke, __spreadValues({ key: t10 }, e14)), location: (e14, t10) => tp.createElement(CLe, __spreadValues({ key: t10 }, e14)), mail_merge_fields_collection: (e14, t10) => tp.createElement(rSe, __spreadProps(__spreadValues({}, e14), { key: t10 })), margins: (e14, t10) => tp.createElement(bPe, __spreadValues({ key: t10 }, e14)), msl_page_size: (e14, t10) => tp.createElement(jPe, __spreadProps(__spreadValues({}, e14), { key: t10 })), name_dataset: (e14, t10) => tp.createElement(Zde, __spreadValues({ key: t10 }, e14)), name_item: (e14, t10) => tp.createElement(Gde, __spreadProps(__spreadValues({ key: t10 }, e14), { namedItemFilter: (e15) => "grouping" !== e15.type })), name_group: (e14, t10) => tp.createElement(Gde, __spreadProps(__spreadValues({ key: t10 }, e14), { namedItemFilter: (e15) => "grouping" === e15.type, allowEmpty: true })), name_master_report: (e14, t10) => tp.createElement(CPe, __spreadValues({ key: t10 }, e14)), number_expr: (e14, t10) => tp.createElement(eCe, __spreadProps(__spreadValues({}, e14), { key: t10 })), overflow_name: (e14, t10) => tp.createElement(TPe, __spreadValues({ key: t10 }, e14)), padding: (e14, t10) => tp.createElement(kPe, __spreadValues({ key: t10 }, e14)), "partitem-size": (e14, t10) => tp.createElement(kLe, __spreadProps(__spreadValues({}, e14), { key: t10 })), percent_expr: (e14, t10) => tp.createElement(iCe, __spreadProps(__spreadValues({}, e14), { key: t10 })), reportparameter_data: (e14, t10) => tp.createElement(wHe, __spreadValues({ key: t10 }, e14)), reportparameter_default_value: (e14, t10) => tp.createElement(gLe, __spreadValues({ key: t10 }, e14)), reportparameter_name: (e14, t10) => {
  var _a2;
  return tp.createElement(Kde, __spreadProps(__spreadValues({ key: t10 }, e14), { disabled: e14.disabled || ((_a2 = e14.descriptor.meta) == null ? void 0 : _a2.disabled) }));
}, reportparameter_valid_value: (e14, t10) => tp.createElement(yNe, __spreadValues({ key: t10 }, e14)), report_parts_collection: (e14, t10) => tp.createElement(NHe, __spreadValues({ key: t10 }, e14)), report_part_reportitem_name: (e14, t10) => tp.createElement(DHe, __spreadValues({ key: t10 }, e14)), report_part_properties_collection: (e14, t10) => tp.createElement(PHe, __spreadValues({ key: t10 }, e14)), report_part_property_type: (e14, t10) => tp.createElement(IHe, __spreadValues({ key: t10 }, e14)), rows_columns_count: (e14, t10) => tp.createElement(zHe, __spreadValues({ key: t10 }, e14)), simple_border: (e14, t10) => tp.createElement(GHe, __spreadValues({ key: t10 }, e14)), size: (e14, t10) => tp.createElement(xLe, __spreadValues({ key: t10 }, e14)), sort_expression_expr_collection: (e14, t10) => tp.createElement(S_e, __spreadValues({ key: t10 }, e14)), start_point: (e14, t10) => tp.createElement(bLe, __spreadValues({ key: t10 }, e14)), string_expr: (e14, t10) => tp.createElement(Hpe, __spreadValues({ key: t10 }, e14)), styles: (e14, t10) => tp.createElement(x_e, __spreadValues({ key: t10 }, e14)), subreport: (e14, t10) => tp.createElement(Dpe, __spreadValues({ key: t10 }, e14)), subreport_parameters: (e14, t10) => tp.createElement(rSe, __spreadValues({ key: t10 }, e14)), table_footer: (e14, t10) => tp.createElement(PVe, __spreadValues({ key: t10 }, e14)), table_header: (e14, t10) => tp.createElement(DVe, __spreadValues({ key: t10 }, e14)), tablix_member_type: (e14, t10) => tp.createElement(HVe, __spreadValues({ key: t10 }, e14)), tablix_member_new_page: (e14, t10) => tp.createElement(LVe, __spreadValues({ key: t10 }, e14)), target_device: (e14, t10) => tp.createElement(Wke, __spreadValues({ key: t10 }, e14)), text_decoration: (e14, t10) => tp.createElement(IVe, __spreadValues({ key: t10 }, e14)), themes_collection: (e14, t10) => tp.createElement($Ve, __spreadValues({ key: t10 }, e14)), theme_uri: (e14, t10) => tp.createElement(BVe, __spreadProps(__spreadValues({ key: t10 }, e14), { withNoneValue: true })), theme_uri_legacy: (e14, t10) => tp.createElement(BVe, __spreadProps(__spreadValues({ key: t10 }, e14), { withNoneValue: true })), unpivot_data: (e14, t10) => tp.createElement(RTe, __spreadValues({ key: t10 }, e14)), user_sort: (e14, t10) => tp.createElement(qVe, __spreadValues({ key: t10 }, e14)), visibility: (e14, t10) => tp.createElement(JVe, __spreadValues({ key: t10 }, e14)), query_filters: (e14, t10) => tp.createElement(iHe, __spreadValues({ key: t10 }, e14)) });
const eRe = "pve-icon-color-accent";
const tRe = "pve-icon-color-secondary";
const nRe = tp.createElement("svg", { width: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M23 11.913a5.99 5.99 0 00-5.99-5.99H6.99A5.99 5.99 0 001 11.913v.02a5.993 5.993 0 005.99 5.99h10.02a5.993 5.993 0 005.99-5.99v-.02z", className: km.text }), tp.createElement("circle", { cx: "17", cy: "12", r: "5", className: eRe }));
const rRe = tp.createElement("svg", { width: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: tRe, d: "M19.895 5.923H4.105c-1.162 0-2.105.811-2.105 2v8c0 1.19.838 2.154 2 2.154h15.789c1.163 0 2.211-.964 2.211-2.154v-8c0-1.189-.943-2-2.105-2z" }), tp.createElement("path", { className: eRe, d: "M7 10.923h10v2H7z" }));
const oRe = tp.createElement("svg", { width: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: km.text, opacity: ".38", d: "M22 4a2 2 0 00-2-2H4a2 2 0 00-2 2v16a2 2 0 002 2h16a2 2 0 002-2V4z" }), tp.createElement("path", { className: eRe, opacity: ".38", d: "M13 16v-2H3v-1h18v1h-1v2h1v1h-1v2h1v1h-1v1h-1v-1h-2v1h-1v-1h-2v1h-1v-1h-2v1h-1v-1H8v1H7v-1H5v1H4v-1H3v-1h1v-2H3v-1h10zm-3 1H8v2h2v-2zm3 0h-2v2h2v-2zm6 0h-2v2h2v-2zm-3 0h-2v2h2v-2zm-9 0H5v2h2v-2zm9-3h-2v2h2v-2zm3 0h-2v2h2v-2zm-8-6v2h10v1H3v-1h1V8H3V7h1V5H3V4h1V3h1v1h2V3h1v1h2V3h1v1h2V3h1v1h2V3h1v1h2V3h1v1h1v1h-1v2h1v1H11zM7 8H5v2h2V8zm3 0H8v2h2V8zm3-3h-2v2h2V5zm3 0h-2v2h2V5zm3 0h-2v2h2V5zM7 5H5v2h2V5zm3 0H8v2h2V5z" }), tp.createElement("path", { className: tRe, fillOpacity: ".62", d: "M13 14v2H3v-2h10zm8-3v2H3v-2h18zm0-3v2H11V8h10z" }), tp.createElement("path", { className: tRe, d: "M16 16h-2v-2h2v2zm-6-6H8V8h2v2z" }));
const aRe = tp.createElement("svg", { width: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: km.text, opacity: ".38", d: "M22 13a2 2 0 00-2-2H4a2 2 0 00-2 2v7a2 2 0 002 2h16a2 2 0 002-2v-7z" }), tp.createElement("path", { className: eRe, fillOpacity: ".38", d: "M7 19v-2H5v2h2zm1-2v2h2v-2H8zm3 0v2h2v-2h-2zm6 0v2h2v-2h-2zm-1 0h-2v2h2v-2zm-8-3v2h2v-2H8zm3 0v2h2v-2h-2zm3 0v2h2v-2h-2zm3 0v2h2v-2h-2zM7 14H5v2h2v-2zm14 2v1h-1v2h1v1h-1v1h-1v-1h-2v1h-1v-1h-2v1h-1v-1h-2v1h-1v-1H8v1H7v-1H5v1H4v-1H3v-1h1v-2H3v-1h1v-2H3v-1h1v-1h1v1h2v-1h1v1h2v-1h1v1h2v-1h1v1h2v-1h1v1h2v-1h1v1h1v1h-1v2h1z" }), tp.createElement("path", { className: tRe, d: "M8 14h2v2H8z" }), tp.createElement("path", { className: km.text, d: "M22 4a2 2 0 00-2-2H4a2 2 0 00-2 2v3a2 2 0 002 2h16a2 2 0 002-2V4z" }), tp.createElement("path", { className: eRe, d: "M17.75 6.087l1.374-1.57a.499.499 0 11.752.658l-1.75 2a.498.498 0 01-.752 0l-1.75-2a.5.5 0 11.752-.658l1.374 1.57z" }));
const iRe = tp.createElement("svg", { width: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: km.text, opacity: ".38", d: "M22 13a2 2 0 00-2-2H4a2 2 0 00-2 2v7a2 2 0 002 2h16a2 2 0 002-2v-7z" }), tp.createElement("path", { className: eRe, d: "M15 18v1H5v-1h10zm4-4v1H5v-1h14z" }), tp.createElement("path", { className: km.text, d: "M22 4a2 2 0 00-2-2H4a2 2 0 00-2 2v3a2 2 0 002 2h16a2 2 0 002-2V4z" }), tp.createElement("path", { className: eRe, d: "M17.75 6.087l1.374-1.57a.499.499 0 11.752.658l-1.75 2a.498.498 0 01-.752 0l-1.75-2a.5.5 0 11.752-.658l1.374 1.57z" }));
const sRe = tp.createElement("svg", { width: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: km.text, fillRule: "nonzero", d: "M19.895 5.924H4.105c-1.162 0-2.105.81-2.105 2v7.999c0 1.19.838 2.154 2 2.154h15.79c1.162 0 2.21-.964 2.21-2.154v-8c0-1.189-.943-2-2.105-2z" }), tp.createElement("g", { className: eRe, fillOpacity: ".38" }, tp.createElement("path", { d: "M19 12.5h-4v-1h4v1zm-10 0H5v-1h4v1z" }), tp.createElement("path", { d: "M19 12.5h-4v-1h4v1zm-10 0H5v-1h4v1z" })), tp.createElement("path", { className: eRe, d: "M11 9v2.5h2V9h1v6h-1v-2.5h-2V15h-1V9h1z" }));
const lRe = tp.createElement("svg", { width: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: km.text, d: "M22 4a2 2 0 00-2-2H4a2 2 0 00-2 2v16a2 2 0 002 2h16a2 2 0 002-2V4z" }), tp.createElement("path", { className: eRe, opacity: ".62", d: "M15 18v1H9v-1h6zm-2-3H9v-1h4v1zm4-5v1H9v-1h8zm2-4v1H9V6h10z" }), tp.createElement("path", { className: eRe, d: "M7 19H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm0-4H5V5h2v2z" }));
const cRe = tp.createElement("svg", { width: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: km.text, d: "M22 13a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-7Z" }), tp.createElement("path", { className: eRe, opacity: ".62", d: "M17 19h-7v-1h7v1Zm-3-2h-4v-1h4v1Zm5-3v1h-9v-1h9Z" }), tp.createElement("path", { className: eRe, d: "M8 15v-1H5v1h1v3H5v1h3v-1H7v-3h1Z" }), tp.createElement("path", { className: km.text, opacity: ".38", d: "M22 4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4Z" }), tp.createElement("path", { className: eRe, d: "m17.75 6.087 1.374-1.57a.499.499 0 1 1 .752.658l-1.75 2a.498.498 0 0 1-.752 0l-1.75-2a.5.5 0 1 1 .752-.658l1.374 1.57Z" }));
const uRe = tp.createElement("svg", { width: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("g", { fillRule: "nonzero" }, tp.createElement("path", { className: km.text, d: "M19.895 6H4.105C2.943 6 2 6.811 2 8v8c0 1.19.943 2 2.105 2h15.79C21.057 18 22 17.19 22 16V8c0-1.189-.943-2-2.105-2z" }), tp.createElement("path", { className: eRe, d: "M18.186 10.459c0 .362-.106.663-.317.904-.211.241-.508.403-.89.487v.031c.458.057.802.2 1.031.428.229.227.344.53.344.908 0 .549-.194.973-.583 1.271-.388.298-.94.448-1.656.448-.633 0-1.166-.103-1.601-.309v-.816a3.684 3.684 0 001.55.375c.443 0 .774-.082.993-.247.218-.164.328-.418.328-.761 0-.305-.121-.529-.364-.672-.242-.143-.622-.215-1.14-.215h-.496v-.746h.504c.911 0 1.367-.315 1.367-.945 0-.245-.08-.434-.238-.567-.159-.133-.394-.199-.704-.199-.216 0-.424.031-.625.092-.2.061-.437.18-.71.357l-.45-.64c.524-.386 1.132-.579 1.825-.579.575 0 1.024.124 1.347.372.323.247.485.588.485 1.023zM8.092 14.857h-.918V11.17c0-.44.01-.789.031-1.047a2.93 2.93 0 01-.221.207c-.087.076-.379.315-.877.719l-.461-.582 1.68-1.321h.766v5.711zm5.742 0H9.963v-.695l1.473-1.48c.434-.446.723-.761.865-.948.142-.186.245-.361.31-.525.065-.164.098-.34.098-.527 0-.258-.077-.461-.232-.61-.155-.148-.37-.222-.643-.222-.219 0-.43.04-.635.121-.204.08-.441.226-.709.437l-.496-.605c.318-.268.626-.459.926-.571.299-.112.618-.168.957-.168.531 0 .957.139 1.277.416.321.278.481.651.481 1.12 0 .257-.046.502-.139.734a2.947 2.947 0 01-.426.717c-.191.246-.509.579-.955.998l-.992.961v.039h2.711v.808z" })));
const dRe = tp.createElement("svg", { width: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: km.text, fillRule: "nonzero", d: "M19.895 6H4.105C2.943 6 2 6.811 2 8v8c0 1.19.943 2 2.105 2h15.79C21.057 18 22 17.19 22 16V8c0-1.189-.943-2-2.105-2z" }), tp.createElement("path", { className: eRe, fillOpacity: ".32", d: "M4.991 11H7v2H4.991a.998.998 0 01-.666-.257 1.007 1.007 0 01-.261-.382 1.006 1.006 0 01-.056-.497.987.987 0 01.592-.784.993.993 0 01.384-.08h.007zm14.018 0c.547 0 .991.444.991.991v.018a.991.991 0 01-.991.991H17v-2h2.009z" }), tp.createElement("path", { className: eRe, fillOpacity: ".62", d: "M8 11h8v2H8z" }), tp.createElement("path", { className: eRe, d: "M8 9.499a.503.503 0 00-.146-.353A.503.503 0 007.501 9h-.002a.503.503 0 00-.353.146.503.503 0 00-.146.353v5.002c0 .132.053.259.146.353a.503.503 0 00.353.146h.002a.503.503 0 00.353-.146.503.503 0 00.146-.353V9.499zM17 9.5a.504.504 0 00-.146-.354.504.504 0 00-.708 0A.504.504 0 0016 9.5v5c0 .133.053.26.146.354a.504.504 0 00.708 0A.504.504 0 0017 14.5v-5z" }));
const pRe = tp.createElement("svg", { width: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: km.text, d: "M22 6c0-.398-.211-.779-.586-1.061C21.039 4.658 20.53 4.5 20 4.5H4c-.53 0-1.039.158-1.414.439C2.211 5.221 2 5.602 2 6v12c0 .398.211.779.586 1.061.375.281.884.439 1.414.439h16c.53 0 1.039-.158 1.414-.439.375-.282.586-.663.586-1.061V6z" }), tp.createElement("path", { className: eRe, d: "M15 15.5v1H5v-1h10zm4-4v1H5v-1h14zm0-4v1H5v-1h14z" }));
const mRe = tp.createElement("svg", { width: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("g", { fillRule: "nonzero" }, tp.createElement("path", { className: km.text, d: "M19.895 6H4.105C2.943 6 2 6.811 2 8v8c0 1.19.943 2 2.105 2h15.79C21.057 18 22 17.19 22 16V8c0-1.189-.943-2-2.105-2z" }), tp.createElement("path", { className: eRe, d: "M8 10V9H5v1h1v4H5v1h3v-1H7v-4h1z" })));
const hRe = tp.createElement("svg", { width: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { fill: "#fff", d: "M22 4a1.998 1.998 0 00-2-2H4a2.003 2.003 0 00-2 2v16a1.998 1.998 0 002 2h16a2.003 2.003 0 002-2V4z" }), tp.createElement("path", { className: eRe, opacity: ".38", d: "M10 17v1H6V9h1v3h3v1H7v4h3z" }), tp.createElement("path", { className: eRe, opacity: ".38", d: "M19 17v1h-4v-1h4zm0-5v1h-4v-1h4zm0-5v1h-9V7h9z" }), tp.createElement("path", { className: eRe, d: "M13 19h-3v-3h3v3zm0-5h-3v-3h3v3zM8 9H5V6h3v3z" }));
const fRe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "M22 12.811A6.48 6.48 0 0 0 17.5 11a6.504 6.504 0 0 0-6.5 6.5 6.48 6.48 0 0 0 1.811 4.5H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8.811Z", opacity: ".38" }), tp.createElement("path", { className: Km.accent, d: "M21 11H3v-1h1V8H3V7h1V5H3V4h1V3h1v1h2V3h1v1h2V3h1v1h2V3h1v1h2V3h1v1h2V3h1v1h1v1h-1v2h1v1H11v2h10v1Zm-9.501 9H11v1h-1v-1H8v1H7v-1H5v1H4v-1H3v-1h1v-2H3v-1h8.174a6.469 6.469 0 0 0-.155 1H11v2h.174c.082.345.191.679.325 1Zm.524-6H3v-1h9.811a6.52 6.52 0 0 0-.788 1ZM16 5h-2v2h2V5Zm3 0h-2v2h2V5ZM7 5H5v2h2V5Zm3 0H8v2h2V5Zm0 3H8v2h2V8ZM7 8H5v2h2V8Zm6-3h-2v2h2V5Zm-3 12H8v2h2v-2Zm-3 0H5v2h2v-2Z", opacity: ".38" }), tp.createElement("path", { className: Km.secondary, fillOpacity: ".62", d: "M12.811 13H3v-2h14.5a6.485 6.485 0 0 0-4.689 2Zm4.689-2H21v1.023A6.472 6.472 0 0 0 17.5 11Zm-6.326 5H3v-2h9.023a6.487 6.487 0 0 0-.849 2ZM21 8v2H11V8h10Z" }), tp.createElement("path", { className: Km.secondary, d: "M8 8h2v2H8zm15 9.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 1 0 11 0Zm-5.5 0h2a.5.5 0 0 1 0 1H17a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v2.5Z" }));
const gRe = tp.createElement("svg", { width: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M10.5 3H9.49999l-.08987.00806c-.23325.04233-.41013.24648-.41013.49194 0 .27614.22387.5.5.5H10.5l.1644.00532c1.2049.0782 2.1771 1.01001 2.318 2.19678.3545.09897.6945.23257 1.0162.39691C13.9995 6.56612 14 6.53311 14 6.5 14 4.567 12.433 3 10.5 3ZM6.5951 9.00903c-.15984.31412-.2904.64564-.38807.99097H5.5C3.567 10 2 8.433 2 6.5c0-1.86856 1.46428-3.39513 3.30796-3.49482L5.5 3h1c.27614 0 .5.22386.5.5 0 .24546-.17688.44961-.41012.49194L6.5 4h-1C4.11929 4 3 5.11929 3 6.5c0 1.32548 1.03154 2.41004 2.33562 2.49468L5.5 9h1c.03252 0 .06431.0031.0951.00903Zm4.1276-2.95453c-.88001.12449-1.69304.45725-2.38763.9468L5.49977 7c-.27614-.00013-.4999-.22409-.49977-.50023.00011-.24546.17708-.44953.41035-.49176L5.50023 6l4.99997.0023c.08.00003.1555.01882.2225.0522ZM11.5 16c2.4853 0 4.5-2.0147 4.5-4.5C16 9.01472 13.9853 7 11.5 7 9.01472 7 7 9.01472 7 11.5c0 2.4853 2.01472 4.5 4.5 4.5Zm1.8536-6.35355c.1952.19526.1952.51185 0 .70715L12.2071 11.5l1.1465 1.1464c.1952.1953.1952.5119 0 .7072-.1953.1952-.5119.1952-.7072 0L11.5 12.2071l-1.1464 1.1465c-.1953.1952-.51189.1952-.70715 0-.19527-.1953-.19527-.5119 0-.7072L10.7929 11.5l-1.14645-1.1464c-.19527-.1953-.19527-.51189 0-.70715.19526-.19527.51185-.19527.70715 0L11.5 10.7929l1.1464-1.14645c.1953-.19527.5119-.19527.7072 0" }));
const yRe = tp.createElement("svg", { width: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M9.25 7c.414 0 .75.336.75.75 0 .377-.278.688-.639.742L9.25 8.5H7c-1.933 0-3.5 1.567-3.5 3.5 0 1.864 1.457 3.388 3.294 3.494L7 15.5h2.25c.414 0 .75.336.75.75 0 .377-.278.688-.639.742L9.25 17H7c-2.761 0-5-2.239-5-5 0-2.678 2.105-4.864 4.75-4.994L7 7h2.25ZM17 7c2.761 0 5 2.239 5 5 0 2.678-2.105 4.864-4.75 4.994L17 17h-2.25c-.414 0-.75-.336-.75-.75 0-.377.277-.688.639-.742l.111-.008H17c1.933 0 3.5-1.567 3.5-3.5 0-1.864-1.457-3.388-3.294-3.494L17 8.5h-2.25c-.414 0-.75-.336-.75-.75 0-.377.277-.688.639-.742L14.75 7H17ZM7 11.25h10c.414 0 .75.336.75.75 0 .38-.282.694-.648.743L17 12.75H7c-.414 0-.75-.336-.75-.75 0-.38.282-.694.648-.743L7 11.25h10H7Z" }));
const vRe = tp.createElement("svg", { width: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, opacity: ".62", d: "M14.327 11.25H17c.414 0 .75.336.75.75 0 .38-.282.694-.648.743L17 12.75h-1.175l-1.498-1.5Zm3.988 3.994c1.282-.52 2.185-1.776 2.185-3.244 0-1.864-1.457-3.388-3.294-3.494L17 8.5h-2.25c-.414 0-.75-.336-.75-.75 0-.377.277-.688.639-.742L14.75 7H17c2.761 0 5 2.239 5 5 0 1.877-1.034 3.512-2.563 4.367l-1.122-1.123Z" }), tp.createElement("path", { className: Ym.text, d: "M6.033 7.093 2.004 3.064c-.293-.292-.293-.767 0-1.06.293-.293.768-.293 1.061 0l18.499 18.5c.293.293.293.768 0 1.061-.292.292-.768.292-1.06 0L15.939 17H14.75c-.414 0-.75-.336-.75-.75 0-.322.202-.596.487-.702l-2.798-2.798H7c-.414 0-.75-.336-.75-.75 0-.38.282-.694.648-.743L7 11.25h3.189L7.439 8.5H7c-1.933 0-3.5 1.567-3.5 3.5 0 1.864 1.457 3.388 3.294 3.494L7 15.5h2.25c.414 0 .75.336.75.75 0 .377-.278.688-.639.742L9.25 17H7c-2.761 0-5-2.239-5-5 0-2.431 1.734-4.456 4.033-4.907Z" }));
const bRe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Km.error, d: "M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm1.854-6.354a.502.502 0 0 1 0 .708L15.207 14.5l1.147 1.146a.502.502 0 0 1-.708.708L14.5 15.207l-1.146 1.147a.502.502 0 0 1-.708-.708l1.147-1.146-1.147-1.146a.502.502 0 0 1 .708-.708l1.146 1.147 1.146-1.147a.502.502 0 0 1 .708 0Z" }), tp.createElement("path", { className: Ym.text, d: "M9.022 15H5c-1.656 0-3-1.344-3-3V7c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3v3.259a5.485 5.485 0 0 0-1-.658V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h4.022a5.898 5.898 0 0 0 0 1Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M9.5 11.5A.5.5 0 0 0 9 11H5.5a.5.5 0 0 0 0 1H9a.5.5 0 0 0 .5-.5Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M11.5 9.5A.5.5 0 0 0 11 9H9.5a.5.5 0 0 0 0 1H11a.5.5 0 0 0 .5-.5Z" }), tp.createElement("path", { className: Ym.text, d: "M8 7.75A.75.75 0 0 0 7.25 7h-1.5a.75.75 0 0 0-.75.75v1.5c0 .414.336.75.75.75h1.5A.75.75 0 0 0 8 9.25v-1.5Z" }));
const SRe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M18 7v5c0 1.656-1.344 3-3 3H6c-1.656 0-3-1.344-3-3V7c0-1.656 1.344-3 3-3h9c1.656 0 3 1.344 3 3Zm-1 0a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V7Z" }), tp.createElement("path", { className: Km.accent, d: "M15.505 16c-.454.607-1.178 1-1.995 1H5.868A4.869 4.869 0 0 1 1 12.132V8.49c0-.817.393-1.541 1-1.995v5.637A3.868 3.868 0 0 0 5.868 16h9.637Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M15 11.5a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0 0 1h8a.5.5 0 0 0 .5-.5Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M15 9.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0 0 1h4a.5.5 0 0 0 .5-.5Z" }), tp.createElement("path", { className: Ym.text, d: "M9 7.75A.75.75 0 0 0 8.25 7h-1.5a.75.75 0 0 0-.75.75v1.5c0 .414.336.75.75.75h1.5A.75.75 0 0 0 9 9.25v-1.5Z" }));
const CRe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M9.601 17H6c-1.656 0-3-1.344-3-3V6c0-1.656 1.344-3 3-3h8c1.656 0 3 1.344 3 3v3.601a5.416 5.416 0 0 0-1-.394V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h3.207c.099.349.231.683.394 1Z" }), tp.createElement("path", { className: Ym.text, d: "M7 6a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H7Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M7 11a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H7Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M12 6a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1Z" }), tp.createElement("path", { className: Km.accent, d: "M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-7a.5.5 0 0 1 .5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5a.5.5 0 0 1 .5-.5Z" }));
const xRe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M7 6a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H7Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M7 11a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H7Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M12 6a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1Z" }), tp.createElement("path", { className: Ym.text, d: "M9.601 17H6c-1.656 0-3-1.344-3-3V6c0-1.656 1.344-3 3-3h8c1.656 0 3 1.344 3 3v3.601a5.416 5.416 0 0 0-1-.394V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h3.207c.099.349.231.683.394 1Z" }), tp.createElement("path", { className: Km.error, d: "M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm1.854-6.354a.502.502 0 0 1 0 .708L15.207 14.5l1.147 1.146a.502.502 0 0 1-.708.708L14.5 15.207l-1.146 1.147a.502.502 0 0 1-.708-.708l1.147-1.146-1.147-1.146a.502.502 0 0 1 .708-.708l1.146 1.147 1.146-1.147a.502.502 0 0 1 .708 0Z" }));
const wRe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Ym.text, d: "M7 6a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H7Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M7 11a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H7Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M12 6a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1Z" }), tp.createElement("path", { className: Ym.text, d: "M9.601 17H6c-1.656 0-3-1.344-3-3V6c0-1.656 1.344-3 3-3h8c1.656 0 3 1.344 3 3v3.601a5.416 5.416 0 0 0-1-.394V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h3.207c.099.349.231.683.394 1Z" }), tp.createElement("path", { className: Km.accent, fillRule: "evenodd", d: "M14.5 19a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm1.5-7a.5.5 0 0 1 1 0v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.468a2.017 2.017 0 0 0-.933-.25 2.003 2.003 0 0 0-1.449.586.5.5 0 0 1-.707-.707A2.995 2.995 0 0 1 16 12.152V12Zm-1.552 5.25a2.995 2.995 0 0 0 2.173-.879.5.5 0 0 0-.707-.707 1.99 1.99 0 0 1-1.449.586 2.017 2.017 0 0 1-.933-.25H14a.5.5 0 0 0 0-1h-1.5a.5.5 0 0 0-.5.5V17a.5.5 0 0 0 1 0v-.152a3.032 3.032 0 0 0 1.448.402Z" }));
const TRe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: "#212121", d: "M17 6v8c0 1.656-1.344 3-3 3H6c-1.656 0-3-1.344-3-3V6c0-1.656 1.344-3 3-3h8c1.656 0 3 1.344 3 3Zm-1 0a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M6.5 13a.5.5 0 0 0 0 1h7.004a.496.496 0 0 0 .496-.496v-.012a.492.492 0 0 0-.492-.492H6.5Z" }), tp.createElement("path", { className: Km.accent, d: "M7 8.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H7Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M6.5 6a.5.5 0 0 0 0 1h7.014A.487.487 0 0 0 14 6.514v-.019A.495.495 0 0 0 13.505 6H6.5Z" }));
const ERe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: "#212121", d: "M17 6v8c0 1.656-1.344 3-3 3H6c-1.656 0-3-1.344-3-3V6c0-1.656 1.344-3 3-3h8c1.656 0 3 1.344 3 3Zm-1 0a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M7 6a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H7Zm5 5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1Z" }), tp.createElement("path", { className: Km.accent, d: "M7 11a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H7Z" }), tp.createElement("path", { className: Km.accent, fillOpacity: ".62", d: "M12 6a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1Z" }));
const FRe = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, tp.createElement("path", { className: Km.accent, d: "M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm-.5-6.5a.5.5 0 0 1 1 0v2a.5.5 0 0 1-1 0v-2Zm1.125 4a.625.625 0 1 1-1.25 0 .625.625 0 0 1 1.25 0Z" }), tp.createElement("path", { className: Ym.text, d: "M9.022 15H5c-1.656 0-3-1.344-3-3V7c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3v3.259a5.485 5.485 0 0 0-1-.658V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h4.022a5.898 5.898 0 0 0 0 1Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M9.5 11.5A.5.5 0 0 0 9 11H5.5a.5.5 0 0 0 0 1H9a.5.5 0 0 0 .5-.5Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M11.5 9.5A.5.5 0 0 0 11 9H9.5a.5.5 0 0 0 0 1H11a.5.5 0 0 0 .5-.5Z" }), tp.createElement("path", { className: Ym.text, d: "M8 7.75A.75.75 0 0 0 7.25 7h-1.5a.75.75 0 0 0-.75.75v1.5c0 .414.336.75.75.75h1.5A.75.75 0 0 0 8 9.25v-1.5Z" }));
const MRe = (e14, t10) => {
  switch (e14) {
    case "Boolean":
      return t10("parametersViewEditor:dataType.boolean");
    case "String":
      return t10("parametersViewEditor:dataType.string");
    case "Integer":
      return t10("parametersViewEditor:dataType.integer");
    case "Float":
      return t10("parametersViewEditor:dataType.float");
    case "Date":
      return t10("parametersViewEditor:dataType.date");
    case "DateTime":
      return t10("parametersViewEditor:dataType.dateTime");
    default:
      return e14;
  }
};
const kRe = (e14) => "string" == typeof e14 && "" !== e14 && "" !== e14.trim();
const PRe = ({ ParameterValues: e14, DataSetReference: t10 }) => e14.length > 0 || (({ DataSetName: e15, ValueField: t11 }) => kRe(e15) && kRe(t11))(t10);
const NRe = ({ DataType: e14 }, t10, n10 = hG().t) => t10.some((t11) => t11 === e14) ? null : `'${MRe(e14, n10)}' ${n10("parametersViewEditor:msgString.notSupControl")}`;
const DRe = ({ MultiValue: e14 }, t10 = hG().t) => e14 ? null : t10("parametersViewEditor:msgString.controlNotSupportSingle");
const LRe = ({ ValidValues: e14 }) => PRe(e14) ? null : hG().t("parametersViewEditor:msgString.controlRequires");
const HRe = ({ ValidValues: e14 }) => PRe(e14) ? hG().t("parametersViewEditor:msgString.controlNotSupportParameters") : null;
const IRe = ({ reportParameters: e14, boundParameters: t10, editorControl: n10, control: r10 }) => {
  const o10 = e14.filter((e15) => !t10.some((t11) => null !== t11 && t11.Name === e15.Name)).map((e15) => {
    const o11 = n10.validateParameter(r10, e15, t10).filter((e16) => null !== e16);
    return { parameter: e15, valid: 0 === o11.length, errors: o11 };
  });
  return o10.sort((e15, t11) => {
    const n11 = e15.parameter.Name.toUpperCase();
    const r11 = t11.parameter.Name.toUpperCase();
    return n11 > r11 ? 1 : n11 < r11 ? -1 : 0;
  }), o10.sort((e15, t11) => e15.valid < t11.valid ? 1 : e15.valid > t11.valid ? -1 : 0), o10;
};
const _Re = (e14, t10) => void 0 === e14.binding ? [] : Array.isArray(e14.binding) ? e14.binding.map((e15) => t10.find((t11) => t11.Name === e15) || null) : [t10.find((t11) => t11.Name === e14.binding) || null];
const VRe = (e14, t10, n10, r10, o10) => $N(e14, t10, n10, r10, "both", __spreadValues({ _type: "control" }, o10));
const RRe = (e14, t10, n10, r10, o10) => $N(e14, t10, n10, r10, "both", __spreadValues({ _type: "options" }, o10));
const ARe = 200;
const ORe = 2 * Rp;
const BRe = 4 * Rp;
const zRe = Rp;
const $Re = 3 * Rp + 5;
const [WRe, , jRe] = Dp("pve-nullable");
const [ZRe] = jRe("content");
const GRe = (e14) => class extends tp.Component {
  render() {
    const { parameters: [t10] } = this.props;
    if (null === t10) return tp.createElement(e14, __spreadValues({}, this.props));
    const { Nullable: n10, DefaultValue: { Values: [r10] } } = t10;
    if (!n10) return tp.createElement(e14, __spreadValues({}, this.props));
    const o10 = { block: true, size: "small", text: hG().t("parametersViewEditor:editors.textNull"), value: "", checked: null === r10, onChange: () => {
    }, customCSS: "pve-no-events" };
    return tp.createElement("div", { className: WRe }, tp.createElement("div", { className: ZRe }, tp.createElement(e14, __spreadValues({}, this.props))), tp.createElement(CE, __spreadValues({}, o10)));
  }
};
const URe = { type: "boolean", name: () => hG().t("parametersViewEditor:editors.nameBoolean"), icon: nf(nRe), init: (e14, t10 = {}) => {
  const { t: n10 } = hG();
  return { left: 0, top: 0, width: ARe, height: ORe, control: __spreadValues({ type: "boolean", binding: e14, label: { display: "top", text: n10("parametersViewEditor:parameters.labelBoolean") }, subType: "toggle", text: n10("parametersViewEditor:parameters.labelBoolean"), textTrue: n10("parametersViewEditor:booleanProperties.trueText"), textFalse: n10("parametersViewEditor:booleanProperties.falseText"), layout: "horizontal" }, t10) };
}, bindings: () => [{ name: hG().t("parametersViewEditor:properties.labels.value"), dataType: hG().t("parametersViewEditor:bindingProperties.boolean") }], validateBinding: ([e14]) => null !== e14 && "Boolean" === e14.DataType, validateParameter: (e14, t10) => [NRe(t10, ["Boolean"]), HRe(t10)], component: GRe(({ parameters: e14, subType: t10, textTrue: n10, textFalse: r10, text: o10, layout: a10 }) => {
  const { t: i10 } = vp("parametersViewEditor");
  const s10 = n10 || i10("booleanProperties.trueText", "True");
  const l10 = r10 || i10("booleanProperties.falseText", "False");
  const c10 = i10("booleanProperties.undefinedText", "False");
  let u10;
  const d10 = () => null != u10;
  const p10 = 1 === e14.length ? e14[0] : null;
  if (p10) {
    const { DefaultValue: { Values: [e15] } } = p10;
    null != e15 && ("true" === e15.toString().toLowerCase() ? u10 = true : "false" === e15.toString().toLowerCase() && (u10 = false));
  }
  let m10 = null;
  switch (t10) {
    case "toggle": {
      let e15 = c10;
      true === u10 ? e15 = s10 : false === u10 && (e15 = l10);
      const t11 = { customCSS: "pve-no-events", block: true, size: "small", indeterminate: !d10(), checked: !!d10() && u10, onToggle: () => {
      }, text: e15 };
      m10 = tp.createElement(SM, __spreadValues({}, t11));
      break;
    }
    case "checkbox": {
      const e15 = { customCSS: "pve-no-events", block: true, size: "small", value: "", indeterminate: !d10(), checked: !!d10() && u10, onChange: () => {
      }, text: o10 };
      m10 = tp.createElement(CE, __spreadValues({}, e15));
      break;
    }
    case "radio": {
      const e15 = { size: "small", type: "radios", layout: "horizontal" === a10 ? { direction: "horizontal", columnsDefault: 2 } : { direction: "vertical" }, items: [{ text: s10, value: "true", checked: !!d10() && true === u10, customCSS: "pve-no-events" }, { text: l10, value: "false", checked: !!d10() && false === u10, customCSS: "pve-no-events" }], onChange: () => {
      } };
      m10 = tp.createElement(rI, __spreadValues({}, e15));
      break;
    }
  }
  return m10;
}), getProperties: (e14) => {
  const { subType: t10 } = e14;
  const { t: n10 } = hG();
  const r10 = n10("parametersViewEditor:properties.categories.details");
  const o10 = n10("parametersViewEditor:properties.categories.label");
  const a10 = n10("parametersViewEditor:properties.labels.trueText");
  const i10 = n10("parametersViewEditor:properties.labels.falseText");
  let s10;
  switch (t10) {
    case "checkbox":
      s10 = [$N(r10, n10("parametersViewEditor:properties.labels.text"), "label", "control.text")];
      break;
    case "toggle":
      s10 = [$N(r10, a10, "label", "control.textTrue"), $N(r10, i10, "label", "control.textFalse")];
      break;
    case "radio":
      s10 = [$N(r10, n10("parametersViewEditor:properties.labels.layout"), "layout", "control.layout"), $N(r10, a10, "label", "control.textTrue"), $N(r10, i10, "label", "control.textFalse")];
  }
  const l10 = { values: ["toggle", "checkbox", "radio"], friendlyNames: [{ value: "toggle", name: n10("parametersViewEditor:booleanProperties.toggle") }, { value: "checkbox", name: n10("parametersViewEditor:booleanProperties.checkbox") }, { value: "radio", name: n10("parametersViewEditor:booleanProperties.radio") }] };
  return [VRe("", n10("parametersViewEditor:properties.labels.type"), "type", "control.subType", { subtypes: l10 }), $N(o10, n10("parametersViewEditor:properties.labels.text"), "label", "control.label.text"), $N(o10, n10("parametersViewEditor:properties.labels.display"), "display", "control.label.display"), ...s10];
} };
const qRe = { type: "button", name: () => hG().t("parametersViewEditor:editors.nameButton"), icon: nf(rRe), init: (e14, t10 = {}) => ({ left: 0, top: 0, width: ARe, height: zRe, control: __spreadValues({ type: "button", action: "preview", background: "accent", text: "" }, t10) }), bindings: () => [], validateBinding: () => true, validateParameter: () => [], component: ({ action: e14, background: t10, text: n10 }) => {
  const { t: r10 } = vp("parametersViewEditor");
  let o10 = "";
  switch (e14) {
    case "preview":
      o10 = r10("buttonProperties.preview", "Preview");
      break;
    case "reset":
      o10 = r10("buttonProperties.reset", "Reset");
      break;
    case "clear":
      o10 = r10("buttonProperties.clear", "Clear");
  }
  const a10 = { customCSS: "pve-no-events", block: true, size: "small", width: "100%", accent: "default" === t10 ? "none" : "full", level: "error" === t10 ? "error" : "warning" === t10 ? "warning" : void 0, text: n10 && "" !== n10 ? n10 : o10, textAlign: "center" };
  return tp.createElement(qm, __spreadValues({}, a10));
}, getProperties: () => {
  const { t: e14 } = hG();
  return [$N("", e14("parametersViewEditor:properties.labels.action"), "action", "control.action"), $N("", e14("parametersViewEditor:properties.labels.background"), "level", "control.background"), $N("", e14("parametersViewEditor:properties.labels.text"), "label", "control.text")];
} };
const YRe = { type: "date-range", name: () => hG().t("parametersViewEditor:editors.nameDateRange"), icon: nf(oRe), init: (e14, t10 = {}) => ({ left: 0, top: 0, width: ARe, height: ORe, control: __spreadValues({ type: "date-range", binding: e14, maxRange: ["none"], ranges: [], showDefaultRanges: true, viewMode: "default", daysViewHeaderFormat: "", displayFormat: "", label: { display: "top", text: hG().t("parametersViewEditor:parameters.labelDateRange") } }, t10) }), bindings: () => [{ name: hG().t("parametersViewEditor:properties.labels.from"), dataType: hG().t("parametersViewEditor:bindingProperties.date") }, { name: hG().t("parametersViewEditor:properties.labels.to"), dataType: hG().t("parametersViewEditor:bindingProperties.date") }], validateBinding: ([e14, t10]) => null !== e14 && null !== t10 && "Date" === e14.DataType && "Date" === t10.DataType, validateParameter: (e14, t10) => [NRe(t10, ["Date"]), HRe(t10)], component: ({ parameters: e14 }) => {
  const { t: t10 } = vp("parametersViewEditor");
  const n10 = 2 === e14.length ? e14[0] : null;
  const r10 = 2 === e14.length ? e14[1] : null;
  let o10;
  let a10;
  if (n10) {
    const { DefaultValue: { Values: [e15] } } = n10;
    o10 = e15 || "";
  }
  if (r10) {
    const { DefaultValue: { Values: [e15] } } = r10;
    a10 = e15 || "";
  }
  const i10 = [o10, a10];
  const s10 = PNe((n10 == null ? void 0 : n10.DisplayFormat) || (r10 == null ? void 0 : r10.DisplayFormat) || "", { t: t10 });
  const l10 = { customCSS: "pve-no-events", block: true, size: "small", icon: nf(Ah), value: i10, valueFormat: lI, textModeDaily: t10("dateRangeParameterLabels.tabLabelDaily"), textModeMonthly: t10("dateRangeParameterLabels.tabLabelMonthly"), textModeYearly: t10("dateRangeParameterLabels.tabLabelAnnually"), textBack: t10("dateRangeParameterLabels.textBack"), textShortcutsList: t10("dateRangeParameterLabels.textShortcutsList"), placeholderDateStart: t10("dateRangeParameterLabels.placeholderDateStart"), placeholderDateEnd: t10("dateRangeParameterLabels.placeholderDateEnd"), shortcuts: [{ type: "last-week", label: t10("dateRangeParameterLabels.shortcuts.labelLastWeek") }, { type: "last-month", label: t10("dateRangeParameterLabels.shortcuts.labelLastMonth") }, { type: "last-year", label: t10("dateRangeParameterLabels.shortcuts.labelLastYear") }, { type: "week-to-date", label: t10("dateRangeParameterLabels.shortcuts.labelWeekToDate") }, { type: "month-to-date", label: t10("dateRangeParameterLabels.shortcuts.labelMonthToDate") }, { type: "year-to-date", label: t10("dateRangeParameterLabels.shortcuts.labelYearToDate") }], monthYearOrder: "Y-M" === t10("dateRangeParameterLabels.monthYearOrder") ? "Y-M" : "M-Y", dateFormat: s10 };
  return tp.createElement(J_, __spreadValues({}, l10));
}, getProperties: () => {
  const { t: e14 } = hG();
  const t10 = e14("parametersViewEditor:properties.categories.label");
  const n10 = e14("parametersViewEditor:properties.categories.details");
  return [$N(t10, e14("parametersViewEditor:properties.labels.text"), "label", "control.label.text"), $N(t10, e14("parametersViewEditor:properties.labels.display"), "display", "control.label.display"), $N(n10, e14("parametersViewEditor:properties.labels.maxRange"), "max-range", "control.maxRange"), $N(n10, e14("parametersViewEditor:properties.labels.viewMode"), "date-view", "control.viewMode"), $N(n10, e14("parametersViewEditor:properties.labels.daysHeaderFormat"), "string", "control.daysViewHeaderFormat")];
} };
function KRe(e14) {
  var _a2;
  if (!HX()) return e14;
  const t10 = fc("i11n", (_a2 = e14 == null ? void 0 : e14.toString()) != null ? _a2 : "");
  return "invalid" === t10.type ? e14 : mu("rdl", t10);
}
function XRe(e14) {
  if (!HX()) return e14;
  const t10 = fc("rdl", e14 != null ? e14 : "");
  return "invalid" === t10.type ? e14 : mu("i11n", t10);
}
const JRe = { type: "date-time", name: () => hG().t("parametersViewEditor:editors.nameDateTime"), icon: nf(aRe), init: (e14, t10 = {}) => ({ left: 0, top: 0, width: ARe, height: ORe, control: __spreadValues({ type: "date-time", daysViewHeaderFormat: "", displayFormat: "", binding: e14, label: { display: "top", text: hG().t("parametersViewEditor:parameters.labelDateTime") } }, t10) }), bindings: () => [{ name: hG().t("parametersViewEditor:properties.labels.value"), dataType: hG().t("parametersViewEditor:bindingProperties.dateDateTime") }], validateBinding: ([e14]) => null !== e14 && ("DateTime" === e14.DataType || "Date" === e14.DataType), validateParameter: (e14, t10) => [NRe(t10, ["DateTime", "Date"]), HRe(t10)], component: GRe(({ parameters: e14, placeholder: t10 }) => {
  const { t: n10 } = vp("parametersViewEditor");
  let r10;
  const o10 = 1 === e14.length ? e14[0] : null;
  if (o10) {
    const { DefaultValue: { Values: e15 } } = o10;
    r10 = e15.length > 0 ? e15[0] : void 0;
  }
  const a10 = "DateTime" === (o10 == null ? void 0 : o10.DataType) ? "date-time" : "date";
  const i10 = PNe(o10 == null ? void 0 : o10.DisplayFormat, { t: n10 });
  const s10 = { customCSS: "pve-no-events", pickerMode: a10, value: XRe(r10) || "", valueFormat: lI, placeholder: t10, onChange: () => {
  }, monthYearOrder: "Y-M" === n10("dateTimeParameterLabels.monthYearOrder") ? "Y-M" : "M-Y", textShortcutClear: n10("dateTimeParameterLabels.textClear"), textShortcutToday: n10("dateTimeParameterLabels.textToday"), textBack: n10("dateTimeParameterLabels.textBack"), dateTimeFormat: i10 };
  return tp.createElement(E_, __spreadProps(__spreadValues({}, s10), { block: true, size: "small" }));
}), getProperties: () => {
  const { t: e14 } = hG();
  const t10 = e14("parametersViewEditor:properties.categories.label");
  const n10 = e14("parametersViewEditor:properties.categories.details");
  return [$N("", e14("parametersViewEditor:properties.labels.placeholder", "Placeholder"), "placeholder", "control.placeholder"), $N(t10, e14("parametersViewEditor:properties.labels.text"), "label", "control.label.text"), $N(t10, e14("parametersViewEditor:properties.labels.display"), "display", "control.label.display"), $N(n10, e14("parametersViewEditor:properties.labels.daysHeaderFormat"), "string", "control.daysViewHeaderFormat")];
} };
const QRe = { type: "date-time-range", name: () => hG().t("parametersViewEditor:editors.nameDateTimeRange"), icon: nf(fRe), init: (e14, t10 = {}) => ({ left: 0, top: 0, width: ARe, height: $Re, control: __spreadValues({ type: "date-time-range", daysViewHeaderFormat: "", displayFormat: "", binding: e14, placeholders: ["", ""], ranges: [], showDefaultRanges: true, label: { display: "top", text: hG().t("parametersViewEditor:parameters.labelDateTimeRange") } }, t10) }), bindings: () => [{ name: hG().t("parametersViewEditor:properties.labels.from"), dataType: hG().t("parametersViewEditor:bindingProperties.dateDateTime") }, { name: hG().t("parametersViewEditor:properties.labels.to"), dataType: hG().t("parametersViewEditor:bindingProperties.dateDateTime") }], validateBinding: ([e14]) => null !== e14 && ("DateTime" === e14.DataType || "Date" === e14.DataType), validateParameter: (e14, t10) => [NRe(t10, ["DateTime", "Date"]), HRe(t10)], component: GRe(({ parameters: e14, placeholders: t10 }) => {
  var _a2, _b2, _c2, _d2, _e2, _f2;
  const { t: n10 } = vp("parametersViewEditor");
  const r10 = e14[0];
  const o10 = e14[1];
  const a10 = { valueFormat: lI, onChange: () => {
  }, monthYearOrder: "Y-M" === n10("dateTimeParameterLabels.monthYearOrder") ? "Y-M" : "M-Y", textShortcutClear: n10("dateTimeParameterLabels.textClear"), textShortcutToday: n10("dateTimeParameterLabels.textToday"), textBack: n10("dateTimeParameterLabels.textBack"), block: true, size: "small" };
  const i10 = __spreadProps(__spreadValues({}, a10), { customCSS: "pve-no-events pve-date-time-range-from-input", placeholder: (_a2 = t10[0]) != null ? _a2 : "", pickerMode: "DateTime" === (r10 == null ? void 0 : r10.DataType) || null === r10 ? "date-time" : "date", value: (_c2 = XRe((_b2 = r10 == null ? void 0 : r10.DefaultValue.Values[0]) != null ? _b2 : "")) != null ? _c2 : "", dateTimeFormat: PNe(r10 == null ? void 0 : r10.DisplayFormat, { t: n10 }) });
  const s10 = __spreadProps(__spreadValues({}, a10), { customCSS: "pve-no-events", placeholder: (_d2 = t10[1]) != null ? _d2 : "", pickerMode: "DateTime" === (o10 == null ? void 0 : o10.DataType) || null === o10 ? "date-time" : "date", value: (_f2 = XRe((_e2 = o10 == null ? void 0 : o10.DefaultValue.Values[0]) != null ? _e2 : "")) != null ? _f2 : "", dateTimeFormat: PNe(o10 == null ? void 0 : o10.DisplayFormat, { t: n10 }) });
  return tp.createElement(tp.Fragment, null, tp.createElement(E_, __spreadValues({}, i10)), tp.createElement(E_, __spreadValues({}, s10)));
}), getProperties: () => {
  const { t: e14 } = hG();
  const t10 = e14("parametersViewEditor:properties.categories.label");
  const n10 = e14("parametersViewEditor:properties.categories.details");
  return [$N("", e14("parametersViewEditor:properties.labels.placeholderFrom", '"From" Placeholder'), "placeholder", "control.placeholders.0"), $N("", e14("parametersViewEditor:properties.labels.placeholderTo", '"To" Placeholder'), "placeholder", "control.placeholders.1"), $N(t10, e14("parametersViewEditor:properties.labels.text"), "label", "control.label.text"), $N(t10, e14("parametersViewEditor:properties.labels.display"), "display", "control.label.display"), $N(n10, e14("parametersViewEditor:properties.labels.daysHeaderFormat"), "string", "control.daysViewHeaderFormat")];
} };
const eAe = { type: "dropdown", name: () => hG().t("parametersViewEditor:editors.nameDropdown"), icon: nf(iRe), init: (e14, t10 = {}) => {
  const { t: n10 } = hG();
  return { left: 0, top: 0, width: ARe, height: ORe, control: __spreadValues({ type: "dropdown", binding: e14, label: { display: "top", text: n10("parametersViewEditor:parameters.labelDropdown") } }, t10) };
}, bindings: () => [{ name: hG().t("parametersViewEditor:properties.labels.value"), dataType: hG().t("parametersViewEditor:bindingProperties.any") }], validateBinding: ([e14]) => null !== e14 && PRe(e14.ValidValues), validateParameter: (e14, t10) => [LRe(t10)], component: GRe(({ parameters: e14 }) => {
  let t10;
  const n10 = 1 === e14.length ? e14[0] : null;
  const r10 = (e15) => null != e15;
  if (n10) {
    const { DefaultValue: { Values: e15 } } = n10;
    t10 = r10(e15[0]) ? XRe(`${e15[0]}`) : "";
  }
  const o10 = { customCSS: "pve-no-events", items: [], block: true, size: "small", width: "100%", value: r10(t10) ? t10 : "", onChange: () => {
  } };
  return tp.createElement(tM, __spreadValues({}, o10));
}), getProperties: () => {
  const { t: e14 } = hG();
  const t10 = e14("parametersViewEditor:properties.categories.label");
  return [$N(t10, e14("parametersViewEditor:properties.labels.text"), "label", "control.label.text"), $N(t10, e14("parametersViewEditor:properties.labels.display"), "display", "control.label.display")];
} };
const tAe = (e14) => {
  switch (e14) {
    case "accent":
      return "info";
    case "warning":
      return "warning";
    case "error":
      return "error";
    default:
      return;
  }
};
const nAe = (e14, t10, n10, r10, o10) => {
  switch (t10) {
    case "Date":
    case "DateTime": {
      const a10 = sI(e14);
      const i10 = ((e15, t11, n11) => {
        const r11 = sI(t11);
        let o11 = r11.locale(n11).localeData().longDateFormat("L");
        return "DateTime" === e15 && (o11 += ` ${r11.locale(n11).localeData().longDateFormat("LTS")}`), o11;
      })(t10, e14, r10);
      const s10 = PNe(o10, { t: n10 }) || i10;
      return a10.isValid() ? a10.format(s10) : e14;
    }
    default:
      return e14;
  }
};
const rAe = { type: "heading", name: () => hG().t("parametersViewEditor:editors.nameHeading", "Heading"), icon: nf(sRe), init: (e14, t10 = {}) => ({ left: 0, top: 0, width: ARe, height: zRe, control: __spreadValues({ type: "heading", text: hG().t("parametersViewEditor:editors.textHeading"), font: {}, color: "default", align: "left", strikeThrough: true }, t10) }), bindings: () => [], validateBinding: () => true, validateParameter: () => [], component: ({ text: e14, font: t10, color: n10, strikeThrough: r10, align: o10 }) => {
  const a10 = { text: e14, size: "small", level: tAe(n10), uppercase: "uppercase" === t10.transform, weight: t10.bold ? "bold" : "normal", align: o10, strikeThrough: r10 };
  return tp.createElement(LE, __spreadValues({}, a10));
}, getProperties: () => {
  const { t: e14 } = hG();
  return [$N("", e14("parametersViewEditor:properties.labels.text"), "label", "control.text"), $N("", e14("parametersViewEditor:properties.labels.alignment"), "align", "control.align"), $N("", e14("parametersViewEditor:properties.labels.color"), "level", "control.color"), $N("", e14("parametersViewEditor:properties.labels.strikeThrough"), "boolean", "control.strikeThrough")];
} };
const oAe = { numberType: "Integer", minValue: 0, maxValue: 3e3, step: 5 };
const aAe = { numberType: "Integer", minValue: 30, maxValue: 3e3, step: 5 };
const iAe = { numberType: "Integer", step: 1 };
const sAe = { numberType: "Float", step: 0.1 };
const lAe = { numberType: "Integer", step: 1, minValue: 1 };
const cAe = { numberType: "Float", step: 0.1, minValue: 1e-13 };
const uAe = { numberType: "Integer", minValue: 2, maxValue: 300, step: 1 };
const dAe = (e14, t10, n10, r10, o10 = "both", a10) => ({ type: n10, label: t10, category: e14, valuePath: r10, mode: o10, meta: a10 });
const pAe = { type: "list", name: () => hG().t("parametersViewEditor:editors.nameList"), icon: nf(lRe), init: (e14, t10 = {}) => ({ left: 0, top: 0, width: ARe, height: BRe, control: __spreadValues({ type: "list", binding: e14, label: { display: "top", text: hG().t("parametersViewEditor:parameters.labelList") }, layout: "vertical", columns: 2 }, t10) }), bindings: () => [{ name: hG().t("parametersViewEditor:properties.labels.value"), dataType: hG().t("parametersViewEditor:bindingProperties.any") }], validateBinding: ([e14]) => null !== e14, validateParameter: (e14, t10) => [LRe(t10)], component: GRe(({ parameters: e14, layout: t10, columns: n10 }) => {
  const { t: r10 } = vp("parametersViewEditor");
  let o10 = ["Value 2"];
  let a10 = false;
  let i10 = [`${r10("properties.labels.value")} 1`, `${r10("properties.labels.value")} 2`, `${r10("properties.labels.value")} 3`].map((e15) => ({ Label: e15, Value: e15 }));
  const s10 = 1 === e14.length ? e14[0] : null;
  if (s10) {
    const { DefaultValue: { Values: e15 }, MultiValue: t11, ValidValues: { ParameterValues: n11 } } = s10;
    e15.length > 0 && (o10 = e15), n11.length > 0 && (i10 = n11), a10 = t11;
  }
  let l10 = null;
  const c10 = { direction: t10, columns: n10 };
  if (a10) {
    const e15 = i10.map((e16) => ({ text: XRe(`${e16.Label}`), value: e16.Value, checked: o10.some((t12) => t12 === e16.Value) }));
    const t11 = { type: "checkboxes", size: "small", items: e15, layout: c10, customCSS: "pve-no-events pve-checklist" };
    l10 = tp.createElement(rI, __spreadValues({ key: n10 }, t11));
  } else {
    const e15 = i10.map((e16) => ({ text: XRe(`${e16.Label}`), value: e16.Value, checked: o10.some((t12) => t12 === e16.Value) }));
    const t11 = { type: "radios", size: "small", items: e15, layout: c10, customCSS: "pve-no-events pve-checklist" };
    l10 = tp.createElement(rI, __spreadValues({ key: n10 }, t11));
  }
  return tp.createElement(bF, { autoHide: false }, l10);
}), getProperties: ({ layout: e14 }) => {
  const { t: t10 } = hG();
  const n10 = t10("parametersViewEditor:properties.categories.label");
  const r10 = t10("parametersViewEditor:properties.categories.common");
  const o10 = [$N(n10, t10("parametersViewEditor:properties.labels.text"), "label", "control.label.text"), $N(n10, t10("parametersViewEditor:properties.labels.display"), "display", "control.label.display"), $N(r10, t10("parametersViewEditor:properties.labels.layout"), "layout", "control.layout")];
  return "horizontal" === e14 && o10.push($N(r10, t10("parametersViewEditor:properties.labels.columns"), "number", "control.columns", void 0, uAe)), o10;
} };
const mAe = { type: "multivalue", name: () => hG().t("parametersViewEditor:editors.nameMultivalue"), icon: nf(cRe), init: (e14, t10 = {}) => {
  const { t: n10 } = hG();
  return { left: 0, top: 0, width: ARe, height: ORe, control: __spreadValues({ type: "multivalue", binding: e14, label: { display: "top", text: n10("parametersViewEditor:parameters.labelMultivalue") } }, t10) };
}, bindings: () => [{ name: hG().t("parametersViewEditor:properties.labels.value"), dataType: hG().t("parametersViewEditor:bindingProperties.any") }], validateBinding: ([e14]) => null !== e14 && e14.MultiValue && !PRe(e14.ValidValues), validateParameter: (e14, t10) => [DRe(t10), HRe(t10)], component: GRe(({ parameters: e14 }) => {
  const { t: t10, i18n: { language: n10 } } = vp();
  let r10;
  const o10 = 1 === e14.length ? e14[0] : null;
  if (o10) {
    const { DefaultValue: { Values: e15 }, DataType: a11, DisplayFormat: i10 } = o10;
    r10 = e15.length > 0 ? e15.map((e16) => XRe(`${nAe(e16, a11, t10, n10, i10)}`)).join(", ") : void 0;
  }
  const a10 = { customCSS: "pve-no-events", items: [], block: true, size: "small", width: "100%", text: null == r10 ? "" : r10 };
  return tp.createElement(UF, __spreadValues({}, a10));
}), getProperties: () => {
  const { t: e14 } = hG();
  const t10 = e14("parametersViewEditor:properties.categories.label");
  return [$N(t10, e14("parametersViewEditor:properties.labels.text"), "label", "control.label.text"), $N(t10, e14("parametersViewEditor:properties.labels.display"), "display", "control.label.display")];
} };
const [hAe, fAe] = Dp("pve-slider-container");
const [gAe] = Dp("pve-slider");
const yAe = ({ children: e14, mode: t10 }) => {
  const n10 = kp(hAe, fAe(`mode-${t10}`));
  return tp.createElement("div", { className: n10 }, e14);
};
const [vAe, , bAe] = Dp("pve-number-editor");
const [SAe] = bAe("input");
const [CAe] = bAe("button");
const xAe = { up: nf(Xm), down: nf(Jm) };
const wAe = { type: "number", name: () => hG().t("parametersViewEditor:editors.nameNumber"), icon: nf(uRe), init: (e14, t10 = {}) => ({ left: 0, top: 0, width: ARe, height: ORe, control: __spreadValues({ type: "number", binding: e14, label: { display: "top", text: hG().t("parametersViewEditor:parameters.labelNumber") }, subType: "up-down", range: [0, 100], step: 5, layout: "X", strictInput: false }, t10) }), bindings: () => [{ name: hG().t("parametersViewEditor:properties.labels.value"), dataType: hG().t("parametersViewEditor:bindingProperties.integerFloat") }], validateBinding: ([e14]) => null !== e14 && ("Integer" === e14.DataType || "Float" === e14.DataType), validateParameter: (e14, t10) => [NRe(t10, ["Integer", "Float"]), HRe(t10)], component: GRe(({ parameters: e14, subType: t10, range: [n10, r10], step: o10, layout: a10, placeholder: i10 }) => {
  let s10;
  const l10 = 1 === e14.length ? e14[0] : null;
  if (l10) {
    const { DefaultValue: { Values: [e15] } } = l10;
    s10 = null == e15 || Number.isNaN(Number(e15)) ? void 0 : Number(e15);
  }
  let c10 = null;
  switch (t10) {
    case "up-down": {
      const e15 = { icon: xAe.down };
      const t11 = { icon: xAe.up };
      const n11 = { size: "small", value: s10 && `${s10}` || "", placeholder: i10, onChange: () => {
      }, customCSS: SAe, width: "0px" };
      c10 = tp.createElement("div", { className: vAe }, tp.createElement(qm, __spreadProps(__spreadValues({}, e15), { customCSS: CAe, size: "small" })), tp.createElement(KF, __spreadValues({}, n11)), tp.createElement(qm, __spreadProps(__spreadValues({}, t11), { customCSS: CAe, size: "small" })));
      break;
    }
    case "slider": {
      const e15 = { min: n10, max: r10, step: o10, mode: a10, value: void 0 !== s10 ? s10 : n10, withTooltip: true, customCSS: gAe };
      c10 = tp.createElement(yAe, { mode: a10 || "X" }, tp.createElement(iH, __spreadValues({}, e15)));
      break;
    }
  }
  return c10;
}), getProperties: (e14, t10) => {
  var _a2;
  const { subType: n10 } = e14;
  const r10 = (_a2 = t10[0]) == null ? void 0 : _a2.DataType;
  const o10 = "Float" === r10 ? sAe : iAe;
  const a10 = "Float" === r10 ? cAe : lAe;
  const { t: i10 } = hG();
  const s10 = i10("parametersViewEditor:properties.categories.details");
  const l10 = i10("parametersViewEditor:properties.categories.label");
  let c10;
  switch (n10) {
    case "up-down":
      c10 = [$N(s10, i10("parametersViewEditor:properties.labels.min"), "number", "control.range.0", void 0, o10), $N(s10, i10("parametersViewEditor:properties.labels.max"), "number", "control.range.1", void 0, o10), $N(s10, i10("parametersViewEditor:properties.labels.step"), "number", "control.step", void 0, a10), $N(s10, i10("parametersViewEditor:properties.labels.roundInputToStep"), "boolean", "control.strictInput")];
      break;
    case "slider":
      c10 = [$N(s10, i10("parametersViewEditor:properties.labels.min"), "number", "control.range.0", void 0, o10), $N(s10, i10("parametersViewEditor:properties.labels.max"), "number", "control.range.1", void 0, o10), $N(s10, i10("parametersViewEditor:properties.labels.step"), "number", "control.step", void 0, a10)];
  }
  const u10 = { values: ["up-down", "slider"], friendlyNames: [{ value: "up-down", name: i10("parametersViewEditor:properties.labels.upDownEditor") }, { value: "slider", name: i10("parametersViewEditor:properties.labels.slider") }] };
  return [$N("", i10("parametersViewEditor:properties.labels.placeholder", "Placeholder"), "placeholder", "control.placeholder"), VRe("", i10("parametersViewEditor:properties.labels.type"), "type", "control.subType", { subtypes: u10 }), $N(l10, i10("parametersViewEditor:properties.labels.text"), "label", "control.label.text"), $N(l10, i10("parametersViewEditor:properties.labels.display"), "display", "control.label.display"), ...c10];
} };
const TAe = (e14, t10) => {
  const n10 = NRe(e14, ["Integer", "Float"]);
  return n10 || (t10.some((t11) => t11 && t11.DataType !== e14.DataType) ? hG().t("parametersViewEditor:editors.textCheckRangeType") : null);
};
const EAe = { type: "number-range", name: () => hG().t("parametersViewEditor:editors.nameNumberRange"), icon: nf(dRe), init: (e14, t10 = {}) => ({ left: 0, top: 0, width: ARe, height: ORe, control: __spreadValues({ type: "number-range", binding: e14, range: [0, 100], step: 5, layout: "X", label: { display: "top", text: hG().t("parametersViewEditor:parameters.labelNumberRange") } }, t10) }), bindings: () => [{ name: hG().t("parametersViewEditor:properties.labels.from"), dataType: hG().t("parametersViewEditor:bindingProperties.integerFloat") }, { name: hG().t("parametersViewEditor:properties.labels.to"), dataType: hG().t("parametersViewEditor:bindingProperties.integerFloat") }], validateBinding: ([e14, t10]) => !(null === e14 || null === t10 || "Float" !== e14.DataType && "Integer" !== e14.DataType || "Float" !== t10.DataType && "Integer" !== t10.DataType || e14.DataType !== t10.DataType), validateParameter: (e14, t10, n10) => [TAe(t10, n10), HRe(t10)], component: ({ parameters: e14, range: [t10, n10], step: r10, layout: o10 }) => {
  let a10 = [t10, n10];
  const i10 = (e15) => null != e15;
  const s10 = 2 === e14.length ? e14[0] : null;
  const l10 = 2 === e14.length ? e14[1] : null;
  const c10 = (e15) => {
    const r11 = e15 > t10 ? e15 : t10;
    return r11 > n10 ? n10 : r11;
  };
  if (s10 && l10) {
    const { DefaultValue: { Values: [e15] } } = s10;
    const { DefaultValue: { Values: [t11] } } = l10;
    i10(e15) && i10(t11) && (a10 = [c10(Number(e15)), c10(Number(t11))]);
  }
  const u10 = { min: t10, max: n10, step: r10, mode: o10, value: a10, onChange: () => {
  }, customCSS: gAe };
  return tp.createElement(yAe, { mode: o10 || "X" }, tp.createElement(sH, __spreadValues({}, u10)));
}, getProperties: (e14, t10) => {
  var _a2;
  const n10 = (_a2 = t10[0]) == null ? void 0 : _a2.DataType;
  const r10 = "Float" === n10 ? sAe : iAe;
  const o10 = "Float" === n10 ? cAe : lAe;
  const { t: a10 } = hG();
  const i10 = a10("parametersViewEditor:properties.categories.label");
  const s10 = a10("parametersViewEditor:properties.categories.details");
  return [$N(i10, a10("parametersViewEditor:properties.labels.text"), "label", "control.label.text"), $N(i10, a10("parametersViewEditor:properties.labels.display"), "display", "control.label.display"), $N(s10, a10("parametersViewEditor:properties.labels.min"), "number", "control.range.0", void 0, r10), $N(s10, a10("parametersViewEditor:properties.labels.max"), "number", "control.range.1", void 0, r10), $N(s10, a10("parametersViewEditor:properties.labels.step"), "number", "control.step", void 0, o10)];
} };
const [FAe, MAe] = Dp("pve-plain-text");
const kAe = { type: "plain-text", name: () => hG().t("parametersViewEditor:editors.namePlainText", "Plain Text"), icon: nf(pRe), init: (e14, t10 = {}) => ({ left: 0, top: 0, width: ARe, height: zRe, control: __spreadValues({ type: "plain-text", text: hG().t("parametersViewEditor:properties.labels.text"), font: {}, color: "default", align: "left", multiline: false }, t10) }), bindings: () => [], validateBinding: () => true, validateParameter: () => [], component: ({ text: e14, font: { bold: t10, italic: n10, transform: r10, underline: o10 }, color: a10, align: i10, multiline: s10 }) => {
  const l10 = tAe(a10);
  const c10 = kp(FAe, { [MAe(l10)]: void 0 !== l10 });
  const u10 = { textOverflow: "ellipsis", whiteSpace: s10 ? "pre-wrap" : "nowrap", wordWrap: s10 ? "break-word" : "normal", fontWeight: t10 ? "bold" : "normal", fontStyle: n10 ? "italic" : "normal", textAlign: i10, textDecoration: o10 ? "underline" : "none", textTransform: r10 || "none" };
  return tp.createElement("p", { className: c10, style: u10 }, e14);
}, getProperties: () => {
  const { t: e14 } = hG();
  return [$N("", e14("parametersViewEditor:properties.labels.text"), "label", "control.text"), $N("", e14("parametersViewEditor:properties.labels.color"), "level", "control.color"), $N("", e14("parametersViewEditor:properties.labels.alignment"), "text-align", "control.align"), $N("", e14("parametersViewEditor:properties.labels.multiline"), "boolean", "control.multiline")];
} };
const PAe = { type: "text", name: () => hG().t("parametersViewEditor:editors.nameText"), icon: nf(mRe), init: (e14, t10 = {}) => ({ left: 0, top: 0, width: ARe, height: ORe, control: __spreadValues({ type: "text", binding: e14, label: { display: "top", text: hG().t("parametersViewEditor:parameters.labelSingleLineParameter") } }, t10) }), bindings: () => [{ name: hG().t("parametersViewEditor:properties.labels.value"), dataType: hG().t("parametersViewEditor:bindingProperties.any") }], validateBinding: ([e14]) => null !== e14, validateParameter: (e14, t10) => [HRe(t10)], component: GRe(({ parameters: e14, placeholder: t10 }) => {
  let n10;
  let r10 = false;
  const o10 = (e15) => null == n10 ? e15 : n10;
  const a10 = 1 === e14.length ? e14[0] : null;
  if (a10) {
    const { DefaultValue: { Values: e15 }, Multiline: t11 } = a10;
    n10 = e15.length > 0 ? XRe(`${e15[0]}`) : void 0, r10 = t11;
  }
  if (r10) {
    const e15 = { block: true, size: "small", width: "100%", height: "100%", value: o10(""), onChange: () => {
    }, customCSS: "pve-textarea" };
    return tp.createElement(zN, __spreadValues({}, e15));
  }
  const i10 = { customCSS: "pve-no-events", block: true, size: "small", width: "100%", type: "text", value: o10(""), placeholder: t10, onChange: () => {
  } };
  return tp.createElement(KF, __spreadValues({}, i10));
}), getProperties: () => {
  const { t: e14 } = hG();
  const t10 = e14("parametersViewEditor:properties.categories.label");
  return [$N("", e14("parametersViewEditor:properties.labels.placeholder", "Placeholder"), "placeholder", "control.placeholder"), $N(t10, e14("parametersViewEditor:properties.labels.text"), "label", "control.label.text"), $N(t10, e14("parametersViewEditor:properties.labels.display"), "display", "control.label.display")];
} };
const [NAe] = Dp("pve-tree");
const DAe = { type: "tree", name: () => hG().t("parametersViewEditor:editors.nameTreeView"), icon: nf(hRe), init: (e14, t10 = {}) => ({ left: 0, top: 0, width: ARe, height: ORe, control: __spreadValues({ type: "tree", binding: e14, subType: "dropdown", mode: "recursive", fields: [], label: { display: "top", text: hG().t("parametersViewEditor:parameters.labelHierarchical") } }, t10) }), bindings: () => [{ name: hG().t("parametersViewEditor:properties.labels.value"), dataType: hG().t("parametersViewEditor:bindingProperties.any") }], validateBinding: ([e14]) => null !== e14, validateParameter: (e14, t10) => [LRe(t10)], component: GRe(({ subType: e14 }) => {
  const { t: t10 } = vp("parametersViewEditor");
  const n10 = t10("properties.labels.value");
  if ("list" === e14) {
    const e15 = { outline: true, nodes: [{ id: 1, text: `${n10} 1`, expanded: true, nodes: [{ id: 2, text: `${n10} 2` }, { id: 3, text: `${n10} 3`, expanded: true, nodes: [{ id: 4, text: `${n10} 4` }, { id: 5, text: `${n10} 5` }] }] }, { id: 6, text: `${n10} 6` }] };
    return tp.createElement("div", { className: kp(NAe, "pve-no-events") }, tp.createElement(eI, __spreadValues({}, e15)));
  }
  return tp.createElement(tM, { customCSS: "pve-no-events", items: [], block: true, size: "small", width: "100%", value: "", onChange: () => {
  } });
}), getProperties: () => {
  const { t: e14 } = hG();
  const t10 = { values: ["list", "dropdown"], friendlyNames: [{ value: "list", name: e14("parametersViewEditor:properties.labels.list") }, { value: "dropdown", name: e14("parametersViewEditor:properties.labels.dropdown") }] };
  const n10 = { values: ["recursive", "groupby", "pathstring"], friendlyNames: [{ value: "recursive", name: e14("parametersViewEditor:properties.labels.recursive") }, { value: "groupby", name: e14("parametersViewEditor:properties.labels.groupBy") }, { value: "pathstring", name: e14("parametersViewEditor:properties.labels.pathString") }] };
  const r10 = e14("parametersViewEditor:properties.categories.common");
  const o10 = e14("parametersViewEditor:properties.categories.label");
  return [VRe("", e14("parametersViewEditor:properties.labels.type"), "type", "control.subType", { subtypes: t10 }), $N(r10, e14("parametersViewEditor:properties.labels.mode"), "enum", "control.mode", "both", { enum: n10 }), $N(r10, e14("parametersViewEditor:properties.labels.fields"), "fields", "control.fields"), $N(o10, e14("parametersViewEditor:properties.labels.text"), "label", "control.label.text"), $N(o10, e14("parametersViewEditor:properties.labels.display"), "display", "control.label.display")];
} };
const LAe = { text: PAe, number: wAe, "number-range": EAe, boolean: URe, "date-time": JRe, "date-range": YRe, "date-time-range": QRe, multivalue: mAe, dropdown: eAe, list: pAe, tree: DAe, heading: rAe, "plain-text": kAe, button: qRe, custom: null, nullify: null };
const HAe = (e14) => ({ values: ["preview", "reset", "clear"], friendlyNames: [{ value: "preview", name: e14("parametersViewEditor:buttonProperties.preview") }, { value: "reset", name: e14("parametersViewEditor:buttonProperties.reset") }, { value: "clear", name: e14("parametersViewEditor:buttonProperties.clear") }] });
const IAe = _D((e14) => {
  const { t: t10 } = vp();
  return tp.createElement(AL, __spreadProps(__spreadValues({}, e14), { friendlyEnum: HAe(t10) }));
});
const _Ae = (e14) => ({ values: ["left", "center", "right"], friendlyNames: [{ value: "left", name: e14("parametersViewEditor:alignmentEnum.left") }, { value: "center", name: e14("parametersViewEditor:alignmentEnum.center") }, { value: "right", name: e14("parametersViewEditor:alignmentEnum.right") }] });
const VAe = (e14) => ({ values: [..._Ae(e14).values, "justify"], friendlyNames: [..._Ae(e14).friendlyNames, { value: "justify", name: e14("parametersViewEditor:alignmentEnum.justify") }] });
const RAe = _D((_cb) => {
  var _db = _cb, { textAlignment: e14 } = _db, t10 = __objRest(_db, ["textAlignment"]);
  const { t: n10 } = vp();
  return tp.createElement(AL, __spreadProps(__spreadValues({}, t10), { friendlyEnum: e14 ? VAe(n10) : _Ae(n10) }));
});
const AAe = _D((e14) => {
  const { t: t10 } = vp("parametersViewEditor");
  return tp.createElement(AL, __spreadProps(__spreadValues({}, e14), { friendlyEnum: { values: ["", ...e14.environment.validatedParameters.map((e15) => e15.parameter.Name)], friendlyNames: [{ name: t10("buttonProperties.reset"), value: "" }, ...e14.environment.validatedParameters.map((e15) => ({ name: e15.parameter.Name, value: e15.parameter.Name }))] }, value: e14.value || null }));
});
const OAe = (e14) => ({ values: ["default", "days", "months", "years"], friendlyNames: [{ value: "default", name: e14("parametersViewEditor:dateViewProperties.default") }, { value: "days", name: e14("parametersViewEditor:dateViewProperties.days") }, { value: "months", name: e14("parametersViewEditor:dateViewProperties.months") }, { value: "years", name: e14("parametersViewEditor:dateViewProperties.years") }] });
const BAe = _D((e14) => {
  const { t: t10 } = vp();
  return tp.createElement(AL, __spreadProps(__spreadValues({}, e14), { friendlyEnum: OAe(t10) }));
});
const zAe = (e14) => {
  const { t: t10 } = vp("parametersViewEditor");
  const { descriptor: n10, environment: r10, value: o10, setProperty: a10 } = e14;
  const { DataType: i10, DefaultValue: { Values: s10 } } = o10;
  const l10 = n10;
  const c10 = r10.currentControl;
  const u10 = null === s10[0];
  const d10 = __spreadProps(__spreadValues({}, e14), { createEditor: (n11, r11) => lLe({ currentControl: c10, props: __spreadProps(__spreadValues({}, e14), { descriptor: __spreadProps(__spreadValues({}, e14.descriptor), { valuePath: `DefaultValue.Values.${r11}`, meta: __spreadProps(__spreadValues({}, e14.descriptor.meta), { editorIdx: r11 }) }) }), value: n11, dataType: i10, setProperty: (e15, t11) => ((e16, t12) => {
    const n12 = o10.DefaultValue.Values;
    const r12 = [...n12.slice(0, t12), KRe(e16), ...n12.slice(t12 + 1)];
    return a10(__spreadProps(__spreadValues({}, l10), { meta: __spreadProps(__spreadValues({}, l10.meta), { valuePath: "DefaultValue", editorIdx: t12 }) }), { Values: r12, DataSetReference: { DataSetName: "", ValueField: "", LabelField: "" } });
  })(t11, r11), t: t10 }), value: s10, onDelete: (e15) => {
    a10(__spreadProps(__spreadValues({}, l10), { meta: __spreadProps(__spreadValues({}, l10.meta), { valuePath: "DefaultValue.Values" }) }), s10.filter((t11, n11) => n11 !== e15));
  }, onAdd: u10 ? void 0 : () => {
    a10(__spreadProps(__spreadValues({}, l10), { meta: __spreadProps(__spreadValues({}, l10.meta), { valuePath: "DefaultValue" }) }), { Values: [...s10, sLe(i10)], DataSetReference: { DataSetName: "", ValueField: "", LabelField: "" } });
  }, addBtnText: t10("fieldsProperties.addBtnText"), addBtnTitle: t10("fieldsProperties.addBtnTitle"), closeBtnTitle: t10("fieldsProperties.closeBtnTitle"), showBtnTitle: t10("fieldsProperties.showItem"), textEmpty: t10("fieldsProperties.collectionIsEmpty"), textItems: t10("fieldsProperties.items") });
  return tp.createElement(bL, __spreadValues({}, d10));
};
const [$Ae] = Dp("pve-default-editor");
const WAe = _D((e14) => {
  var _a2;
  const { t: t10 } = vp("parametersViewEditor");
  const { descriptor: n10, environment: r10, value: o10 } = e14;
  const { DataType: a10, DefaultValue: { Values: [i10] } } = o10;
  const s10 = n10;
  const l10 = r10.currentControl;
  const c10 = lLe({ currentControl: l10, props: __spreadProps(__spreadValues({}, e14), { descriptor: __spreadProps(__spreadValues({}, e14.descriptor), { valuePath: "DefaultValue.Values.0" }) }), setProperty: (t11, n11) => {
    e14.setProperty(__spreadProps(__spreadValues({}, s10), { meta: __spreadProps(__spreadValues({}, s10.meta), { valuePath: "DefaultValue" }) }), { Values: [KRe(n11)], DataSetReference: { DataSetName: "", ValueField: "", LabelField: "" } });
  }, value: (_a2 = o10.DefaultValue.Values[0]) != null ? _a2 : sLe(a10), dataType: a10, t: t10 });
  const u10 = { block: true, icon: nf(xh), size: "small", accent: "icon", background: "transparent", text: t10("labels.removeDefaultValue"), onClick: () => {
    e14.setProperty(__spreadProps(__spreadValues({}, s10), { meta: __spreadProps(__spreadValues({}, s10.meta), { valuePath: "DefaultValue.Values" }) }), []);
  } };
  return tp.createElement("div", { className: $Ae }, c10, void 0 !== i10 && "" !== i10 && tp.createElement(qm, __spreadValues({}, u10)));
});
const jAe = (e14) => {
  const { instanceId: t10, userPreferences: { units: n10 }, rdlx: { expressionSyntax: r10 } } = Uae();
  const { $index: o10, Type: a10 } = h9();
  const i10 = PA();
  const s10 = dJ(a10, o10, null, "");
  const { value: l10, environment: c10 } = e14;
  const u10 = ep.useCallback((e15, t11) => {
    var _a2;
    const { meta: n11 } = e15;
    const r11 = (_a2 = c10.currentControl) == null ? void 0 : _a2.binding;
    const o11 = Array.isArray(r11) ? r11.findIndex((e16) => e16 === l10.Name) : 0;
    const a11 = n11;
    if (-1 !== o11) if ("string" == typeof t11) {
      const n12 = (l10 == null ? void 0 : l10.MultiValue) ? [...l10.DefaultValue.Values.slice(0, a11.editorIdx), t11, ...l10.DefaultValue.Values.slice(a11.editorIdx + 1)] : [t11];
      const r12 = __spreadProps(__spreadValues({}, l10), { DefaultValue: { Values: n12, DataSetReference: { DataSetName: "", ValueField: "", LabelField: "" } } });
      i10(c2({ path: `ReportParameters.${o11}`, descriptor: __spreadProps(__spreadValues({}, e15), { valuePath: a11.valuePath }), value: r12 }));
    } else i10(c2({ path: `ReportParameters.${o11}`, descriptor: __spreadProps(__spreadValues({}, e15), { valuePath: a11.valuePath }), value: t11 }));
  }, [i10, c10, l10]);
  const d10 = ep.useCallback((e15) => {
    const n11 = { descriptor: e15, objectValues: [l10], defaultValues: [l10.DefaultValue], objectPaths: [""], reportIndex: o10, reportType: a10, theme: null, validationContext: s10, setProperty: u10 };
    const r11 = _A.of(t10).open("expressionEditor", n11);
    i10(r11);
  }, [l10, o10, a10, s10, u10, t10, i10]);
  const p10 = ep.useMemo(() => ({ instanceId: t10, units: n10, expressionSyntax: r10, hideDataPicker: true, dataSets: [], dataSources: [], validationContext: s10, editExpression: d10 }), [t10, n10, r10, s10, d10]);
  return tp.createElement(Vue.Provider, { value: p10 }, tp.createElement(e14.value.MultiValue ? zAe : WAe, e14));
};
const ZAe = (e14) => ({ values: ["none", "top", "right", "bottom", "left"], friendlyNames: [{ value: "none", name: e14("parametersViewEditor:alignmentEnum.none") }, { value: "top", name: e14("parametersViewEditor:alignmentEnum.top") }, { value: "right", name: e14("parametersViewEditor:alignmentEnum.right") }, { value: "bottom", name: e14("parametersViewEditor:alignmentEnum.bottom") }, { value: "left", name: e14("parametersViewEditor:alignmentEnum.left") }] });
const GAe = _D((e14) => {
  const { t: t10 } = vp();
  return tp.createElement(AL, __spreadProps(__spreadValues({}, e14), { friendlyEnum: ZAe(t10) }));
});
const UAe = _D((e14) => tp.createElement(AL, __spreadProps(__spreadValues({}, e14), { friendlyEnum: e14.descriptor.meta.enum })));
const qAe = (e14) => {
  const { t: t10 } = vp("parametersViewEditor");
  const { descriptor: n10, descriptor: { valuePath: r10 }, value: o10, setProperty: a10, environment: i10 } = e14;
  const s10 = (e15, t11) => a10(__spreadProps(__spreadValues({}, n10), { valuePath: `${r10}.${t11}` }), e15);
  const l10 = __spreadProps(__spreadValues({}, e14), { createEditor: i10.dataSet && !i10.isSemanticReport ? (t11, n11) => {
    var _a2;
    const r11 = i10.dataSet && i10.dataSet.Fields.map((e15) => e15.Name) || [];
    const o11 = [...r11.map((e15) => ({ value: e15, name: e15 }))];
    const a11 = { values: [...r11], friendlyNames: o11 };
    return tp.createElement(AL, __spreadProps(__spreadValues({}, e14), { setProperty: (e15, t12) => s10(t12, n11), value: ((_a2 = o11.find((e15) => e15.name === t11)) == null ? void 0 : _a2.name) || "", friendlyEnum: a11 }));
  } : (n11, r11) => tp.createElement(XD, __spreadValues(__spreadProps(__spreadValues({}, e14), { setProperty: (e15, t11) => s10(t11, r11), value: n11 }), iLe(t10))), value: o10, onDelete: (e15) => {
    a10(n10, o10.filter((t11, n11) => n11 !== e15));
  }, onAdd: () => {
    a10(n10, [...o10, ""]);
  }, addBtnText: t10("fieldsProperties.addBtnText"), addBtnTitle: t10("fieldsProperties.addBtnTitle"), closeBtnTitle: t10("fieldsProperties.closeBtnTitle"), showBtnTitle: t10("fieldsProperties.showItem"), textEmpty: t10("fieldsProperties.collectionIsEmpty"), textItems: t10("fieldsProperties.items") });
  return tp.createElement(bL, __spreadValues({}, l10));
};
const YAe = (e14, t10 = (e15) => e15) => HX() ? hu(e14) : t10(e14);
function KAe(e14) {
  var _a2;
  const { rdlx: { expressionSyntax: t10 } } = Uae();
  let n10 = (_a2 = e14 == null ? void 0 : e14.toString()) != null ? _a2 : "";
  return "i11n" === t10 && (n10 = hu(n10)), n10;
}
let XAe = null;
const JAe = "ar-adorner-secondary";
const QAe = "table-adorner-icon-group";
const eOe = (_eb) => {
  var _fb = _eb, { value: e14 } = _fb, t10 = __objRest(_fb, ["value"]);
  const { t: n10 } = vp();
  const r10 = __spreadProps(__spreadValues({}, t10), { value: KAe(e14), placeholderEmpty: _ie(n10) });
  return tp.createElement(XD, __spreadValues({}, r10));
};
const tOe = _D(eOe);
const nOe = ["aggregate", "commonValues", "constants", "dataSets", "documentMap", "parameters", "reportItems", "theme"];
const rOe = (e14) => {
  const { descriptor: t10 } = e14;
  const n10 = __spreadProps(__spreadValues({}, e14), { descriptor: __spreadProps(__spreadValues({}, t10), { type: "string_expr", meta: __spreadProps(__spreadValues({}, t10.meta), { exprEditorFilter: (e15) => nOe.every((t11) => !e15.includes(t11)) }) }) });
  return tp.createElement(Lpe, __spreadValues({}, n10));
};
const oOe = _D((e14) => {
  var _a2;
  const { rdlx: { reportParameters: t10 } } = Uae();
  const { allowExpressionLabels: n10 } = (_a2 = t10 == null ? void 0 : t10.parametersView) != null ? _a2 : {};
  const { descriptor: r10 } = e14;
  const o10 = { emptyValue: "control.label.text" === r10.valuePath ? "Undefined" : "EmptyString" };
  const a10 = __spreadProps(__spreadValues({}, e14), { descriptor: __spreadProps(__spreadValues({}, r10), { type: "string", meta: __spreadValues(__spreadValues({}, r10.meta), o10) }) });
  return n10 ? tp.createElement(rOe, __spreadValues({}, a10)) : tp.createElement(eOe, __spreadValues({}, a10));
});
const aOe = (e14) => ({ values: ["horizontal", "vertical"], friendlyNames: [{ value: "horizontal", name: e14("parametersViewEditor:alignmentEnum.horizontal") }, { value: "vertical", name: e14("parametersViewEditor:alignmentEnum.vertical") }] });
const iOe = _D((e14) => {
  const { t: t10 } = vp();
  return tp.createElement(AL, __spreadProps(__spreadValues({}, e14), { friendlyEnum: aOe(t10) }));
});
const sOe = (e14) => ({ values: ["default", "accent", "error", "warning"], friendlyNames: [{ value: "default", name: e14("parametersViewEditor:dateViewProperties.default") }, { value: "accent", name: e14("parametersViewEditor:dateViewProperties.accent") }, { value: "error", name: e14("parametersViewEditor:dateViewProperties.error") }, { value: "warning", name: e14("parametersViewEditor:dateViewProperties.warning") }] });
const lOe = _D((e14) => {
  const { t: t10 } = vp();
  return tp.createElement(AL, __spreadProps(__spreadValues({}, e14), { friendlyEnum: sOe(t10) }));
});
const cOe = (e14) => ({ values: ["none", "days", "months", "years"], friendlyNames: [{ value: "none", name: e14("parametersViewEditor:dateViewProperties.none") }, { value: "days", name: e14("parametersViewEditor:dateViewProperties.days") }, { value: "months", name: e14("parametersViewEditor:dateViewProperties.months") }, { value: "years", name: e14("parametersViewEditor:dateViewProperties.years") }] });
const [uOe, dOe] = Dp("pve-max-range-editor");
const pOe = _D((e14) => {
  const { t: t10 } = vp("parametersViewEditor");
  const { value: [n10, r10 = ""], setProperty: o10 } = e14;
  const a10 = (e15, t11) => {
    if ("none" === t11) o10(e15, [t11]);
    else if (r10) {
      const n11 = "string" == typeof t11 ? 0 : 1;
      o10(__spreadProps(__spreadValues({}, e15), { valuePath: `${e15.valuePath}.${n11}` }), t11);
    } else o10(e15, [t11, 1]);
  };
  const i10 = __spreadProps(__spreadValues({}, e14), { value: r10, setProperty: a10, disabled: !r10, minValue: 1, placeholderEmpty: "", step: 1, titleIncrease: "+1", titleDecrease: "-1" });
  const s10 = __spreadProps(__spreadValues({}, e14), { friendlyEnum: cOe(t10), value: n10, setProperty: a10 });
  const l10 = kp(uOe, { [dOe("unset")]: !r10 });
  return tp.createElement("div", { className: l10 }, tp.createElement(_L, __spreadValues({}, i10)), tp.createElement(AL, __spreadValues({}, s10)));
});
const mOe = _D((e14) => {
  var _a2;
  const { rdlx: { reportParameters: t10 } } = Uae();
  const { allowExpressionPlaceholders: n10 } = (_a2 = t10 == null ? void 0 : t10.parametersView) != null ? _a2 : {};
  const { descriptor: r10 } = e14;
  const o10 = __spreadProps(__spreadValues({}, e14), { descriptor: __spreadProps(__spreadValues({}, r10), { type: "string", meta: __spreadProps(__spreadValues({}, r10.meta), { emptyValue: "Undefined" }) }) });
  return n10 ? tp.createElement(rOe, __spreadValues({}, o10)) : tp.createElement(eOe, __spreadValues({}, o10));
});
const hOe = tp.createContext({ setRangeIndex: () => {
}, setDateTimeRange: () => {
} });
const fOe = (e14, t10) => {
  var _a2;
  return (_a2 = (({ label: e15 }, t11) => e15 && gc("rdl", e15) ? t11("propertyEditors:common.textExpression") : e15)(e14, t10)) != null ? _a2 : ((e15, t11) => {
    const { rangeType: n10, unit: r10, amount: o10 } = t11;
    return "Current" === n10 || "ToDate" === n10 ? e15(`dateTimeRange.rangeTypes.${n10}`, { context: r10 }) : 1 === o10 ? e15(`dateTimeRange.rangeTypes.${n10}Simple`, { context: r10 }) : e15(`dateTimeRange.rangeTypes.${n10}`, { context: r10, count: o10 });
  })(t10, e14);
};
const [, , gOe] = Dp("pve-editor-ranges");
const [yOe] = gOe("item");
const vOe = (e14) => {
  const { descriptor: t10, value: n10, setProperty: r10 } = e14;
  const { setRangeIndex: o10 } = ep.useContext(hOe);
  const { t: a10 } = vp("parametersViewEditor");
  const i10 = __spreadProps(__spreadValues({}, e14), { value: n10, reordering: { type: "drag", onReorder: (e15) => {
    r10(__spreadValues({}, t10), e15);
  } }, createEditor: (e15) => tp.createElement("div", { className: yOe }, fOe(e15, a10)), onAdd: () => {
    r10(t10, AV(n10, { $push: [{ type: "dynamic", unit: "Day", rangeType: "Last", amount: 1, anchor: "", offset: 0 }] }));
  }, onSelect: (e15) => {
    o10(e15);
  }, onDelete: (e15) => {
    r10(t10, AV(n10, { $splice: [[e15, 1]] }));
  } });
  return tp.createElement(WSe, __spreadValues({}, i10));
};
vOe.displayName = "RangesCollectionEditor";
const bOe = _D((e14) => {
  const { descriptor: { meta: { subtypes: t10 } } } = e14;
  return tp.createElement(AL, __spreadProps(__spreadValues({}, e14), { friendlyEnum: t10 }));
});
const SOe = { enum: (e14, t10) => tp.createElement(UAe, __spreadValues({ key: t10 }, e14)), string: (e14, t10) => tp.createElement(tOe, __spreadValues({ key: t10 }, e14)), boolean: (e14, t10) => tp.createElement(Hie, __spreadValues({ key: t10 }, e14)), number: (e14, t10) => tp.createElement(wue, __spreadValues({ key: t10 }, e14)), default: (e14, t10) => tp.createElement(jAe, __spreadValues({ key: t10 }, e14)), display: (e14, t10) => tp.createElement(GAe, __spreadValues({ key: t10 }, e14)), binding: (e14, t10) => tp.createElement(AAe, __spreadValues({ key: t10 }, e14)), label: (e14, t10) => tp.createElement(oOe, __spreadValues({ key: t10 }, e14)), placeholder: (e14, t10) => tp.createElement(mOe, __spreadValues({ key: t10 }, e14)), type: (e14, t10) => tp.createElement(bOe, __spreadValues({ key: t10 }, e14)), level: (e14, t10) => tp.createElement(lOe, __spreadValues({ key: t10 }, e14)), align: (e14, t10) => tp.createElement(RAe, __spreadValues({ key: t10 }, e14)), "text-align": (e14, t10) => tp.createElement(RAe, __spreadProps(__spreadValues({ key: t10 }, e14), { textAlignment: true })), action: (e14, t10) => tp.createElement(IAe, __spreadValues({ key: t10 }, e14)), layout: (e14, t10) => tp.createElement(iOe, __spreadValues({ key: t10 }, e14)), "max-range": (e14, t10) => tp.createElement(pOe, __spreadValues({ key: t10 }, e14)), "date-view": (e14, t10) => tp.createElement(BAe, __spreadValues({ key: t10 }, e14)), fields: (e14, t10) => tp.createElement(qAe, __spreadValues({ key: t10 }, e14)), ranges: (e14, t10) => tp.createElement(vOe, __spreadValues({ key: t10 }, e14)) };
const COe = { changeSelection: (e14) => Kz.action("@pve/CHANGE_SELECTION", { name: e14 }), changeLocation: (e14, t10) => Kz.action("@pve/CHANGE_LOCATION", { name: e14, location: t10 }), resize: (e14, t10) => Kz.action("@pve/RESIZE", { name: e14, size: t10 }), changeOrder: (e14, t10) => Kz.action("@pve/CHANGE_ORDER", { name: e14, index: t10 }), setProperty: (e14, t10) => Kz.action("@pve/SET_PROPERTY", { descriptor: e14, value: t10 }), removeView: () => Kz.action("@pve/REMOVE_VIEW"), populateView: (e14, t10 = false) => Kz.action("@pve/POPULATE_VIEW", { params: e14, partial: t10 }), bindControl: (e14, t10) => Kz.action("@pve/BIND_CONTROL", { bindingIndex: e14, parameterName: t10 }), addControl: (e14, t10, n10) => Kz.action("@pve/ADD_CONTROL", { type: e14, binding: t10, location: n10 }), deleteControl: () => Kz.action("@pve/DELETE_CONTROL"), duplicateControl: () => Kz.action("@pve/DUPLICATE_CONTROL"), pasteControl: (e14) => Kz.action("@pve/PASTE_CONTROL", { controlArea: e14 }), toggleView: () => ({ type: "@pve/TOGGLE_VIEW" }), toggleRequiredSign: () => Kz.action("@pve/TOGGLE_REQUIRED_SIGN"), moveByVector: ({ x: e14, y: t10 }) => Kz.action("@pve/MOVE_BY_VECTOR", { x: e14, y: t10 }) };
const xOe = 15;
const wOe = (e14) => {
  if (e14.height) return e14.height;
  switch (e14.control.type) {
    case "button":
    case "heading":
    case "plain-text":
    case "nullify":
      return Rp;
    default: {
      const t10 = "bottom" === e14.control.label.display || "top" === e14.control.label.display;
      return "date-time-range" === e14.control.type ? t10 ? 3 * Rp + 5 : 2 * Rp + 5 : t10 ? 2 * Rp : Rp;
    }
  }
};
const TOe = (e14) => ({ right: e14.left + e14.width, bottom: e14.top + wOe(e14) });
function EOe(e14) {
  const t10 = xOe + e14.reduce((e15, t11) => Math.max(e15, TOe(t11).right), 0);
  const n10 = e14.reduce((e15, t11) => Math.max(e15, TOe(t11).bottom), 0);
  return { width: t10, height: n10 };
}
const FOe = (e14, t10) => {
  var _a2, _b2, _c2;
  switch (e14.control.type) {
    case "button":
    case "heading":
    case "plain-text":
    case "nullify":
      return { minHeight: Rp, minWidth: 30 };
    default: {
      const n10 = "bottom" === e14.control.label.display || "top" === e14.control.label.display;
      let r10 = n10 ? 2 * Rp : Rp;
      let o10;
      switch (e14.control.type) {
        case "date-time":
        case "dropdown":
        case "list":
        case "text":
        case "number":
          o10 = ((_a2 = t10[0]) == null ? void 0 : _a2.Nullable) ? 170 : 30;
          break;
        case "date-time-range":
          o10 = ((_b2 = t10[0]) == null ? void 0 : _b2.Nullable) ? 170 : 30, r10 = n10 ? 3 * Rp + 5 : 2 * Rp + 5;
          break;
        case "boolean":
          o10 = ((_c2 = t10[0]) == null ? void 0 : _c2.Nullable) ? 170 : 30, r10 = "vertical" === e14.control.layout ? r10 + Rp : r10;
          break;
        default:
          o10 = 30;
      }
      return { minHeight: r10, minWidth: o10 };
    }
  }
};
const [MOe, kOe] = Dp("wd-data-item-container");
const [POe, NOe] = Dp("wd-data-item-data-set");
const [DOe, LOe, HOe] = Dp("wd-data-item");
const [IOe] = HOe("text");
const [_Oe] = HOe("title");
const [VOe] = HOe("subtitle");
const [ROe] = HOe("controls");
const [AOe, OOe] = Dp("wd-data-search");
const BOe = ({ value: e14, placeholder: t10, onChange: n10 }) => {
  const r10 = ep.useRef(null);
  const o10 = rf(Eh);
  const a10 = { type: "text", value: e14, placeholder: t10, block: true, size: "small", rounded: true, onChange: (e15) => n10(e15.target.value), onKeyDown: (e15) => e15.stopPropagation() };
  const i10 = { block: true, size: "small", background: "transparent", rounded: true, icon: rf(uh), onClick: (e15) => {
    var _a2;
    n10(""), e15.stopPropagation(), (_a2 = r10.current) == null ? void 0 : _a2.focus();
  } };
  const s10 = kp(AOe, { [OOe("has-value")]: e14 });
  return tp.createElement("div", { className: s10 }, tp.createElement(Fm, { icon: o10 }), tp.createElement(KF, __spreadValues({ ref: r10 }, a10)), e14 && tp.createElement(qm, __spreadValues({}, i10)));
};
const zOe = ({ name: e14, expr: t10 }) => {
  const [, n10, r10] = Yne({ item: { type: "value", label: e14, expr: t10 } });
  const o10 = rf(Nie);
  tp.useEffect(() => {
    r10(Coe(), { captureDraggingState: true });
  }, []);
  const a10 = kp(MOe, kOe("comm-value"));
  return tp.createElement("div", { className: a10, ref: n10 }, tp.createElement("div", { className: DOe }, tp.createElement(Fm, { icon: o10 }), tp.createElement("span", null, e14)));
};
const $Oe = ({ reportType: e14, commonNodesFilter: t10 = () => true }) => tp.createElement(tp.Fragment, null, ZX(e14).filter(({ Key: e15 }) => t10(e15)).map(({ Name: e15, Expr: t11 }) => tp.createElement(zOe, { key: e15, name: e15, expr: `=${t11}` })));
const WOe = (e14) => {
  const { text: t10, title: n10, icon: r10, disabled: o10, onClick: a10 } = e14;
  return { type: "button", text: t10, title: n10, icon: r10, disabled: o10, onClick: a10 };
};
const jOe = ({ customActions: e14 }) => {
  const { t: t10 } = vp("components");
  const n10 = rf(vh, { rotate: "90" });
  if (!e14 || 0 === e14.length) return null;
  const r10 = { icon: n10, items: e14.map(WOe), size: "small", menuMaxHeight: "default", hiddenChevron: true, rounded: true, background: "transparent", title: t10("dataPanel.titleMore", "More...") };
  return tp.createElement(UF, __spreadValues({}, r10));
};
const ZOe = ({ dataSource: e14, dataSource: { Name: t10 }, onDelete: n10, onEdit: r10, onAddDataSet: o10, customAdd: a10, customActions: i10, customCSS: s10 }) => {
  const { t: l10 } = vp("components");
  const c10 = rf(wie);
  const u10 = rf(Xm);
  const d10 = rf(dh);
  const p10 = rf(uh);
  const [m10, h10, f10] = [n10, r10, o10].map((e15) => "function" == typeof e15);
  const g10 = ((e15) => {
    var _a2;
    const t11 = (_a2 = e15.ConnectionProperties) == null ? void 0 : _a2.DataProvider;
    const n11 = e15.$dataProvider;
    if (e15.DataSourceReference) return l10("dataPanel.textSharedReference", "Shared Reference");
    {
      const e16 = v$(t11);
      const r11 = v$(n11);
      return t11 && n11 && t11 !== n11 ? `${e16} ${r11}` : e16 || r11 || "";
    }
  })(e14);
  const y10 = { block: true, size: "small", rounded: true, background: "transparent" };
  const v10 = kp(MOe, kOe("data-source"), s10);
  return tp.createElement("div", { className: v10 }, tp.createElement("div", { className: DOe }, tp.createElement(Fm, { icon: c10 }), tp.createElement("div", { className: IOe }, tp.createElement("span", { className: _Oe, title: t10 }, t10), g10 && tp.createElement("span", { className: VOe }, g10)), tp.createElement("div", { className: ROe }, tp.createElement(jOe, { customActions: i10 }), m10 && tp.createElement(qm, __spreadProps(__spreadValues({}, y10), { icon: p10, title: l10("common:textDelete", "Delete"), onClick: n10, dataAid: "datasource__delete-btn" })), h10 && tp.createElement(qm, __spreadProps(__spreadValues({}, y10), { icon: d10, title: l10("dataPanel.titleEditDataSource", "Edit Data Source..."), onClick: r10, dataAid: "datasource__edit-btn" })), a10 && a10, f10 && tp.createElement(qm, __spreadProps(__spreadValues({}, y10), { icon: u10, title: l10("dataPanel.titleAddDataSet", "Add Data Set..."), onClick: o10, dataAid: "datasource__add-dataset-btn" })))));
};
const GOe = (e14) => {
  const { field: t10, dataSetName: n10, variation: r10, expanded: o10, isCheckbox: a10, onToggleSelection: i10, index: s10, isSelectedField: l10, checked: c10, onFieldClick: u10, customFieldDragItemType: d10, prohibitDrag: p10 } = e14;
  const m10 = rf(t10.DataField ? Eie : Fie);
  const [h10, f10] = ep.useState(c10);
  const g10 = { name: t10.Name, value: t10.Name, dataType: t10.DataType, variationFormat: r10.format, index: s10 };
  const [, y10, v10] = Yne({ canDrag: !p10, item: { type: d10 || "field", field: g10, dataSetName: n10 } });
  ep.useEffect(() => {
    v10(Coe(), { captureDraggingState: true });
  }, []), ep.useEffect(() => {
    o10 && a10 && l10(s10) ? f10(true) : f10(false);
  }, [o10, a10]);
  const b10 = { text: r10.label, title: r10.label, size: "small", onChange: () => {
    f10(!h10), i10(g10)();
  }, checked: h10 };
  const S10 = kp(DOe, LOe("expanded"));
  const C10 = kp(MOe, kOe("field"), kOe("expanded"), { [kOe("checked")]: h10 });
  return tp.createElement("div", { className: C10 }, o10 && tp.createElement("div", { className: "branch offset" }, tp.createElement("span", { className: "line" }), tp.createElement("span", { className: "line" })), tp.createElement("div", { className: "branch" }, tp.createElement("span", { className: "corner" }), tp.createElement("span", { className: "line" })), a10 ? tp.createElement("div", { className: S10 }, tp.createElement(CE, __spreadValues({}, b10))) : tp.createElement("div", { ref: y10, onClick: u10(g10), className: S10 }, tp.createElement(Fm, { icon: m10 }), tp.createElement("span", null, r10.label)));
};
const [, , UOe] = Dp("wd-data-field");
const [qOe] = UOe("variations");
const [YOe] = UOe("variations-toggle");
const [, , KOe] = Dp("wd-data-field-custom-action");
const [XOe] = KOe("button");
const [JOe, QOe] = KOe("container");
const eBe = ({ text: e14, highlight: t10 }) => {
  const n10 = e14.toLowerCase().indexOf(t10);
  if (!t10 || n10 < 0) return tp.createElement("span", { title: e14 }, e14);
  const r10 = n10 + t10.length;
  return tp.createElement("span", { title: e14 }, e14.substring(0, n10), tp.createElement("b", null, e14.substring(n10, r10)), e14.substring(r10));
};
const tBe = ({ field: e14, highlight: t10, expanded: n10, isCheckbox: r10, index: o10, dataSetName: a10, isSelectedField: i10, onToggle: s10, onToggleSelection: l10, onFieldClick: c10, customFieldDragItemType: u10, customFieldActions: d10, prohibitDrag: p10 }) => {
  const { t: m10 } = vp();
  const h10 = rf(Eie);
  const f10 = rf(Fie);
  const g10 = rf(hh);
  const y10 = rf(Mh);
  const v10 = ((e15, t11) => e15(`components:dataPanel.fieldVariations.${t11}`, { defaultValue: {}, returnObjects: true }))(m10, e14.DataType) || [];
  const b10 = i10([o10]);
  const S10 = { name: e14.Name, value: e14.Name, dataType: e14.DataType, aggregate: e14.Aggregate || "Count", index: [o10], format: e14.Format };
  const [, C10, x10] = Yne({ canDrag: !p10, item: { type: u10 || "field", field: S10, dataSetName: a10, format: e14.Format } });
  ep.useEffect(() => {
    x10(Coe(), { captureDraggingState: true });
  }, []);
  const w10 = (t11, s11) => {
    const m11 = [o10, s11];
    return { variation: t11, index: m11, checked: r10 && i10(m11), expanded: n10, dataSetName: a10, field: e14, onToggleSelection: l10, isCheckbox: r10, isSelectedField: i10, onFieldClick: c10, customFieldDragItemType: u10, customFieldActions: d10, prohibitDrag: p10 };
  };
  const T10 = { fieldName: e14.Name, customCSS: XOe };
  const E10 = (d10 || []).map((e15) => e15(T10)).filter((e15) => e15);
  const F10 = E10.length > 0;
  const M10 = kp(MOe, kOe("field"), { [kOe("checked")]: b10 });
  const k10 = kp(JOe, { [QOe("with-variations")]: v10.length > 0 });
  const P10 = { block: true, size: "small", background: "transparent", rounded: true, icon: n10 ? y10 : g10, customCSS: YOe, onClick: s10 };
  return tp.createElement(tp.Fragment, null, tp.createElement("div", { key: e14.Name, className: M10 }, tp.createElement("div", { className: "branch" }, tp.createElement("span", { className: "corner" }), tp.createElement("span", { className: "line" })), r10 ? (() => {
    const t11 = { text: e14.Name, title: e14.Name, size: "small", onChange: l10(S10), checked: b10 };
    const n11 = kp(DOe, LOe("checkbox"));
    return tp.createElement("div", { className: n11 }, tp.createElement(CE, __spreadValues({}, t11)));
  })() : tp.createElement("div", { className: DOe, onClick: c10(S10), ref: C10 }, tp.createElement(Fm, { icon: e14.DataField ? h10 : f10 }), tp.createElement(eBe, { text: e14.Name, highlight: t10 })), v10.length > 0 && tp.createElement(qm, __spreadValues({}, P10)), F10 && tp.createElement("div", { className: k10 }, E10)), n10 && tp.createElement("div", { key: `${e14.Name}-group`, className: qOe }, v10.map((t11, n11) => tp.createElement(GOe, __spreadValues({ key: `${e14.Name}-${n11}` }, w10(t11, n11))))));
};
const nBe = ({ parameter: e14, onClick: t10 }) => {
  const n10 = kp(MOe, kOe("field"), kOe("parameter"));
  const r10 = rf(Pie);
  return tp.createElement("div", { className: n10 }, tp.createElement("div", { className: DOe, onClick: t10 }, tp.createElement(Fm, { icon: r10 }), tp.createElement("span", { className: "title" }, e14.Name), tp.createElement("span", { className: "subtitle" }, e14.DataType)));
};
const [, , rBe] = Dp("wd-data-item-data-set");
const [oBe] = rBe("search");
const [aBe, iBe] = rBe("fields");
const [sBe] = rBe("children");
const [lBe] = rBe("message");
const [cBe] = rBe("branch-corner");
const [uBe] = rBe("corner");
const [dBe] = rBe("no-branch-line");
const pBe = (e14) => {
  var _a2, _b2, _c2;
  const { dataSet: t10, expanded: n10, onClick: r10, onDelete: o10, onEdit: a10, onEditParameter: i10, disableEdit: s10, disableDelete: l10, basedOnOverride: c10, customCSS: u10, prohibitDrag: d10, prohibitDragDataSet: p10, prohibitDragFields: m10, hideQueryParameters: h10, customFieldActions: f10, customFieldDragItemType: g10, customActions: y10, selectedFields: v10, onSelectedFieldsChange: b10 } = e14;
  const [S10, C10] = ep.useState("");
  const [x10, w10] = ep.useState(null);
  const [T10, E10] = ep.useState(false);
  const [F10, M10] = ep.useState([]);
  const { t: k10 } = vp("components");
  const P10 = !!t10.$children && t10.$children.length > 0;
  const N10 = "function" == typeof n10 ? n10(t10) : Boolean(n10);
  const D10 = !!o10 && !l10;
  const L10 = !!a10 && !s10;
  const H10 = !d10 && !m10 && N10;
  ep.useLayoutEffect(() => {
    (d10 || m10 || N10) && (E10(false), (b10 != null ? b10 : M10)([]));
  }, [d10, m10, N10]), ep.useEffect(() => {
    ee2 == null ? void 0 : ee2(Coe(), { captureDraggingState: true }), J10 == null ? void 0 : J10(Coe(), { captureDraggingState: true });
  }, []);
  const I10 = rf(Tie);
  const _10 = rf(oh, { rotate: "180" });
  const V10 = rf(oh);
  const R10 = rf(dh);
  const A10 = rf(uh);
  const O10 = rf(wh);
  const B10 = rf(Th);
  const z10 = yK(t10) || [];
  const $10 = k10("dataPanel.textFieldsCount", "{{count}} fields", { count: z10.length });
  const W10 = (e15) => () => {
    const t11 = (v10 != null ? v10 : F10).filter((t12) => t12.index.length !== e15.index.length || t12.index.some((t13, n11) => t13 !== e15.index[n11]));
    t11.length === (v10 != null ? v10 : F10).length && t11.push(e15), (b10 != null ? b10 : M10)(t11);
  };
  const j10 = (e15) => (t11) => {
    H10 && !T10 && SB(t11) && (E10(true), W10(e15)());
  };
  N10 || !S10 && !x10 || (C10(""), w10(null));
  const Z10 = (_b2 = (_a2 = t10.$children) == null ? void 0 : _a2.map((e15) => e15.Name)) != null ? _b2 : [];
  const G10 = z10.filter((e15) => (!S10 || e15.Name.toLowerCase().includes(S10)) && !Z10.includes(e15.Name));
  const U10 = (e15) => ({ field: e15, dataSetName: t10.Name, highlight: S10, expanded: x10 === e15.Name, onToggle: () => w10(x10 === e15.Name ? null : e15.Name), isCheckbox: T10, onToggleSelection: W10, isSelectedField: (e16) => !!(v10 != null ? v10 : F10).find((t11) => t11.index.length === e16.length && t11.index.every((t12, n11) => t12 === e16[n11])), onFieldClick: j10, customFieldDragItemType: g10, customFieldActions: f10, prohibitDrag: d10 });
  const q10 = ((_c2 = t10.Query) == null ? void 0 : _c2.QueryParameters) || [];
  const Y10 = (e15) => ({ parameter: e15, onClick: i10 ? () => i10(e15, t10) : void 0 });
  const K10 = (t11, n11) => __spreadProps(__spreadValues({}, e14), { dataSet: t11, index: n11 });
  const { datasetDragRef: X10, datasetDragPreview: J10 } = ((e15, t11, n11) => {
    const r11 = PA();
    const [, o11, a11] = Yne({ item: { type: "dataset", reportItemType: "table", fillData: { columns: e15.map(({ Name: e16, Format: t12 }) => ({ label: e16, expr: `=${G1(e16)}`, format: t12 })) }, properties: { DataSetName: t11, Type: "table" } }, begin: () => {
      r11(u5());
    } });
    return n11 ? { datasetDragRef: null, datasetDragPreview: null } : { datasetDragRef: o11, datasetDragPreview: a11 };
  })(z10, t10.Name, d10 || p10);
  const { fieldsDragRef: Q10, fieldsDragPreview: ee2 } = ((e15, t11, n11) => {
    const r11 = PA();
    const [, o11, a11] = Yne({ item: { type: "fields", reportItemType: "table", fields: e15, dataSetName: t11, fillData: { columns: (() => {
      const t12 = [...e15].sort((e16, t13) => {
        const n12 = e16.index[0] - t13.index[0];
        return 0 !== n12 ? n12 : 1 === e16.index.length ? -1 : 1 === t13.index.length ? 1 : e16.index[1] - t13.index[1];
      });
      return t12.map(({ name: e16, variationFormat: t13, format: n12 }) => ({ label: e16, expr: t13 ? `=${U1(e16, t13)}` : `=${G1(e16)}`, format: n12 }));
    })() }, properties: { DataSetName: t11, Type: "table" } }, begin: () => {
      r11(u5());
    }, canDrag: () => 0 !== e15.length });
    return n11 ? { fieldsDragRef: null, fieldsDragPreview: null } : { fieldsDragRef: o11, fieldsDragPreview: a11 };
  })(v10 != null ? v10 : F10, t10.Name, d10 || m10);
  const te2 = t10.Query.DataSourceName;
  const ne2 = c10 || (te2 && !t10.$parentReference ? k10("dataPanel.textBasedOnDataSource", "based on {{dataSourceName}}", { dataSourceName: te2 }) : "");
  const re2 = kp(MOe, POe, kOe("data-set"), { [kOe("based-on-data-source")]: !!ne2, [kOe("expanded")]: N10, [NOe("with-children")]: P10 }, u10);
  const oe2 = { block: true, size: "small", rounded: true, background: "transparent" };
  return tp.createElement("div", { className: re2 }, tp.createElement("div", { className: DOe, onClick: () => r10(t10), ref: X10 }, tp.createElement(Fm, { icon: I10 }), tp.createElement("div", { className: IOe }, tp.createElement("span", { className: _Oe, title: t10.Name }, t10.Name), ne2 && tp.createElement("span", { key: "based-on", className: VOe, title: `${t10.Name} \u2013 ${ne2}` }, ne2), tp.createElement("span", { className: VOe }, $10)), tp.createElement("div", { className: ROe }, tp.createElement(jOe, { customActions: y10 }), D10 && tp.createElement(qm, __spreadProps(__spreadValues({}, oe2), { icon: A10, title: k10("common:textDelete", "Delete"), onClick: (e15) => {
    e15.stopPropagation(), o10 == null ? void 0 : o10(t10), E10(false), (b10 != null ? b10 : M10)([]);
  }, dataAid: "dataset__delete-btn" })), L10 && tp.createElement(qm, __spreadProps(__spreadValues({}, oe2), { icon: R10, title: k10("dataPanel.titleEditDataSet", "Edit Data Set..."), onClick: (e15) => {
    e15.stopPropagation(), a10 == null ? void 0 : a10(t10), E10(false), (b10 != null ? b10 : M10)([]);
  }, dataAid: "dataset__edit-btn" })), tp.createElement(qm, __spreadProps(__spreadValues({}, oe2), { icon: N10 ? _10 : V10, title: N10 ? k10("common:textCollapse", "Collapse") : k10("common:textExpand", "Expand"), dataAid: "dataset__toggle-btn" })), H10 && tp.createElement(qm, __spreadProps(__spreadValues({}, oe2), { icon: T10 ? B10 : O10, title: k10("dataPanel.titleSelectFields", "Select Fields..."), onClick: (e15) => {
    e15.stopPropagation(), E10(!T10), (b10 != null ? b10 : M10)([]);
  }, dataAid: "dataset__select-fields-btn" })))), N10 && tp.createElement("div", { className: oBe }, tp.createElement("div", { className: dBe }), tp.createElement(BOe, { value: S10, placeholder: k10("dataPanel.dataSets.placeholderEnterFieldName", "enter field name here..."), onChange: (e15) => C10(e15.toLowerCase()) })), N10 && !G10.length && !!z10.length && S10 && tp.createElement("div", { className: kp(aBe, iBe("empty")) }, tp.createElement("div", { className: uBe }), tp.createElement("span", { className: lBe }, k10("dataPanel.dataSets.textNoMatchingFieldsFound", "No matching fields found"))), N10 && tp.createElement("div", { className: aBe, ref: T10 ? Q10 : null }, G10.map((e15) => tp.createElement(tBe, __spreadValues({ key: e15.Name, index: e15.fieldIndex }, U10(e15))))), tp.createElement("div", { className: sBe }, t10.$children && t10.$children.map((e15, n11) => tp.createElement("div", { key: `${t10.Name}-${e15.Name}` }, tp.createElement("div", { className: cBe }), tp.createElement(pBe, __spreadValues({}, K10(e15, n11)))))), !h10 && N10 && q10.map((e15) => tp.createElement(nBe, __spreadValues({ key: e15.Name }, Y10(e15)))));
};
const [mBe] = Dp("wd-parameter-editor");
function hBe(e14, t10) {
  return "DataSetReference" in e14 ? t10(e14.DataSetReference) : null;
}
const fBe = (e14, t10) => {
  if (e14 && e14.length) {
    const n10 = e14.find((e15) => e15.Name === t10);
    if (n10) return (yK(n10) || []).map((e15) => e15.Name);
  }
  return [];
};
const gBe = (e14, t10, n10) => e14.map((e15) => t10.includes(e15.type) ? __spreadProps(__spreadValues({}, e15), { meta: __spreadValues(__spreadValues({}, e15.meta), n10) }) : e15);
const yBe = (e14) => {
  var _a2, _b2, _c2;
  const { rdlx: { expressionSyntax: t10 }, userPreferences: { units: n10 }, instanceId: r10 } = Uae();
  const { $paramsView: o10 } = h9();
  const { t: a10 } = vp();
  const { dispatch: i10, path: s10, updateParameterPanel: l10, filterValuePath: c10, reportParameter: u10, parametersNames: d10, dataSets: p10, dataSources: m10, semanticModel: h10, validationContext: f10, editExpression: g10 } = e14;
  if (!u10 || Object.keys(u10).length < 1) return null;
  const y10 = ((_b2 = (_a2 = nz.of(r10).getDescriptor("reportParameter")) == null ? void 0 : _a2.getProperties) == null ? void 0 : _b2.call(_a2, u10)) || [];
  const v10 = o10 == null ? void 0 : o10.controls.find((e15) => {
    const { binding: t11 } = e15.control;
    return !!t11 && (Array.isArray(t11) ? t11.includes(u10.Name) : t11 === u10.Name);
  });
  const b10 = v10 == null ? void 0 : v10.control.type;
  const S10 = b10 ? ((e15, t11, n11) => e15.map((e16) => uHe(e16, t11, n11) ? __spreadProps(__spreadValues({}, e16), { meta: __spreadProps(__spreadValues({}, e16.meta), { boundEditorType: t11 }) }) : __spreadProps(__spreadValues({}, e16), { meta: __spreadProps(__spreadValues({}, e16.meta), { disabled: true }) })))(y10, b10, u10.DataType) : y10;
  const C10 = { descriptors: gBe(S10, ["reportparameter_default_value"], { parameterType: u10.DataType, displayFormat: u10 == null ? void 0 : u10.DisplayFormat }), objectValue: __spreadProps(__spreadValues({}, u10), { name: s10 }), defaultValue: (_c2 = nz.of(r10).getDescriptor("reportParameter")) == null ? void 0 : _c2.defaultModel, setProperty: (e15, t11) => {
    "Name" === e15.valuePath && (c10 && i10(c2({ path: c10, descriptor: {}, value: { type: "parameter", value: t11 } })), l10 && l10(t11)), i10(c2({ path: s10, descriptor: e15, value: t11 }));
  }, propertyEditors: QVe, customCSS: kp(Lz, mBe), t: a10 };
  const x10 = { setProperties: (e15) => {
    i10(u2({ path: s10, descriptorValuePairs: e15 }));
  } };
  const w10 = { instanceId: r10, units: n10, dataSets: p10, dataSources: m10, semanticInfo: h10 ? { semanticModel: h10, allowRebalancing: false, showAggregates: false, showCalculatedFields: true } : void 0, validationContext: f10, expressionSyntax: t10, editExpression: g10 };
  const T10 = hBe(u10.ValidValues, (e15) => e15.DataSetName) || "";
  const E10 = hBe(u10.DefaultValue, (e15) => e15.DataSetName) || "";
  const F10 = { valid_value_data_scope: { dataSetName: T10, baseEntityName: S6(p10.find((e15) => e15.Name === T10)) || "" }, default_value_data_scope: { dataSetName: E10, baseEntityName: S6(p10.find((e15) => e15.Name === E10)) || "" }, names: d10, default_dataset_fields: fBe(p10, E10), valid_parameter_dataset_fields: fBe(p10, T10), dataset_name: p10 && p10.map((e15) => e15.Name) || [] };
  return tp.createElement(Iue.Provider, { value: x10 }, tp.createElement(Vue.Provider, { value: w10 }, tp.createElement(qde.Provider, { value: F10 }, tp.createElement(wD, __spreadValues({}, C10)))));
};
function vBe(e14, t10) {
  return t10.includes(".") ? `=${e14}.Item("${t10}").Value` : `=${e14}!${t10}.Value`;
}
yBe.displayName = "ParameterEditor";
const bBe = ({ parameter: e14, index: t10, onClick: n10, onDelete: r10, onMoveUp: o10, onMoveDown: a10 }) => {
  const [, i10, s10] = Yne({ item: { type: "value", label: e14.Name, expr: vBe("Parameters", e14.Name) } });
  const { t: l10 } = vp();
  const c10 = rf(Mie);
  const u10 = rf(bh, { rotate: "180" });
  const d10 = rf(bh);
  const p10 = rf(uh);
  ep.useEffect(() => {
    s10(Coe(), { captureDraggingState: true });
  }, []);
  const m10 = !!TX.dataTab.parameters.canModify && !J7(e14);
  const h10 = { block: true, size: "small", rounded: true, background: "transparent" };
  const f10 = kp(MOe, kOe("parameter"));
  return tp.createElement("div", { className: f10, ref: i10 }, tp.createElement("div", { className: DOe, onClick: () => {
    m10 && n10 && n10(e14, t10);
  } }, tp.createElement(Fm, { icon: c10 }), tp.createElement("div", { className: IOe }, tp.createElement("span", { className: _Oe, title: e14.Name }, e14.Name), tp.createElement("span", { className: VOe }, ((e15) => RO("reportparameter_datatype", e15, l10))(e14.DataType))), m10 && tp.createElement("div", { className: ROe }, tp.createElement(qm, __spreadProps(__spreadValues({}, h10), { icon: p10, title: l10("common:textDelete", "Delete"), onClick: (e15) => {
    e15.stopPropagation(), r10 && r10(t10);
  }, dataAid: "report-parameter__delete-btn" })), tp.createElement(qm, __spreadProps(__spreadValues({}, h10), { disabled: !a10, icon: d10, title: l10("components:dataPanel.titleMoveParameterDown", "Move Down"), onClick: (e15) => {
    e15.stopPropagation(), a10 && a10(t10);
  }, dataAid: "report-parameter__move-down-btn" })), tp.createElement(qm, __spreadProps(__spreadValues({}, h10), { disabled: !o10, icon: u10, title: l10("components:dataPanel.titleMoveParameterUp", "Move Up"), onClick: (e15) => {
    e15.stopPropagation(), o10 && o10(t10);
  }, dataAid: "report-parameter__move-up-btn" })))));
};
const SBe = ({ reportParameters: e14, onClick: t10, onDelete: n10, onMoveUp: r10, onMoveDown: o10 }) => tp.createElement(tp.Fragment, null, e14.map((a10, i10) => {
  const s10 = i10 <= 0 || J7(e14[i10 - 1]);
  const l10 = i10 === e14.length - 1;
  const c10 = { parameter: a10, index: i10, onClick: t10, onDelete: n10, onMoveUp: s10 ? null : r10, onMoveDown: l10 ? null : o10 };
  return tp.createElement(bBe, __spreadValues({ key: a10.Name }, c10));
}));
const CBe = (e14) => {
  const { value: t10, descriptor: n10, disabled: r10, setProperty: o10, defaultValue: a10 } = e14;
  const { t: i10 } = vp();
  const { expressionSyntax: s10 } = ep.useContext(Vue);
  const l10 = que(e14);
  const c10 = { value: HJ(t10, n10.type, { expressionSyntax: s10 }, n10.meta), disabled: r10, placeholderEmpty: _ie(i10), placeholderMultipleValues: Iie(i10), onChange: (e15) => {
    const t11 = NJ(e15, n10.type, { expressionSyntax: s10 }, n10.meta);
    o10(n10, t11);
  } };
  const u10 = { descriptor: n10, setProperty: o10, status: l10, defaultValue: a10, menuId: "parameters" };
  return tp.createElement(Mde, __spreadValues({}, u10), tp.createElement(UD, __spreadValues({}, c10)));
};
CBe.displayName = "QueryParameterValueEditor", _D(CBe);
const [xBe] = Dp("wd-edit-param-panel");
const wBe = "editParameter";
const TBe = () => {
  const { Type: e14, $index: t10, $index: { DataSources: n10 = [], DataSets: r10 = [], ReportParameters: o10 = [] } } = h9();
  const a10 = A$();
  const i10 = p9();
  const { state: { paramName: s10, filterValuePath: l10 } } = a$(wBe);
  const { instanceId: c10 } = Uae();
  const u10 = PA();
  const d10 = ep.useMemo(() => o10.findIndex((e15) => e15.Name === s10), [o10, s10]);
  if (ep.useEffect(() => {
    d10 < 0 && u10(Qz());
  }, [u10, d10]), d10 < 0) return null;
  const p10 = `ReportParameters.${d10}`;
  const m10 = dJ(e14, t10, i10, p10);
  const h10 = o10[d10];
  const f10 = { path: p10, filterValuePath: l10, reportParameter: h10, dispatch: u10, updateParameterPanel: (e15) => u10(t$(wBe, e$({ paramName: e15 }))), dataSets: r10, dataSources: n10, parametersNames: o10.map((e15) => e15.Name), semanticModel: a10, validationContext: m10, editExpression: (n11) => {
    const r11 = { descriptor: n11, objectValues: [h10], objectPaths: [""], defaultValues: [h10.DefaultValue], reportIndex: t10, reportType: e14, theme: i10, setProperty: (e15, t11) => u10(c2({ path: p10, descriptor: n11, value: t11 })), validationContext: m10 };
    const o11 = _A.of(c10).open("expressionEditor", r11);
    u10(o11);
  } };
  return tp.createElement("div", { className: xBe }, tp.createElement(bF, null, tp.createElement(yBe, __spreadValues({}, f10))));
};
TBe.displayName = "RdlxEditParameterPanel";
const EBe = { paramName: "" };
const FBe = (e14 = EBe, t10) => (t10 && t10.type) === Uz ? AV(e14, { $merge: t10.payload }) : e14;
var MBe = "pv-box", kBe = "pv-ctl", PBe = "pv-param", NBe = "pv-size", DBe = "pv-order";
const [, , LBe] = Dp("pve-parameters-panel");
const [HBe, IBe, _Be] = LBe("parameter");
const [VBe, , RBe] = _Be("text");
const [ABe] = _Be("controls");
const [OBe] = RBe("title");
const [BBe] = RBe("subtitle");
const [, zBe] = _Be("icon");
const $Be = Ire(PBe, { beginDrag: ({ parameter: e14 }) => ({ parameter: e14 }), canDrag: ({ parameter: e14 }) => !e14.Hidden }, ({ dragSource: e14, dragPreview: t10 }) => ({ connectDragSource: e14(), connectDragPreview: t10() }))(({ parameter: e14, isBound: t10, openEditParameter: n10, connectDragSource: r10, connectDragPreview: o10 }) => {
  const { t: a10 } = vp("parametersViewEditor");
  ep.useEffect(() => {
    o10 == null ? void 0 : o10(Coe(), { captureDraggingState: true });
  });
  const i10 = J7(e14);
  const s10 = ep.useCallback(() => n10(e14.Name), [n10, e14.Name]);
  const l10 = t10 ? tp.createElement(Fm, { icon: nf(yRe) }) : tp.createElement(Fm, { icon: nf(vRe), customCSS: kp({ [zBe("level-warning")]: !e14.Hidden }) });
  const c10 = { block: true, size: "small", rounded: true, background: "transparent", icon: rf(dh), title: a10("parametersPanel.titleEditParameter", "Edit Parameter..."), onClick: i10 ? void 0 : s10, disabled: i10 };
  return r10(tp.createElement("div", { className: kp(HBe, { [IBe("hidden-param")]: e14.Hidden }) }, l10, tp.createElement("div", { className: VBe }, tp.createElement("span", { className: OBe, title: e14.Name }, e14.Name), tp.createElement("span", { className: BBe }, RO("reportparameter_datatype", e14.DataType, a10))), tp.createElement("div", { className: ABe }, tp.createElement(qm, __spreadValues({}, c10)))));
});
const WBe = ({ heading: e14, onClose: t10 }) => {
  const n10 = { block: true, accent: "full", size: "small", icon: rf(bh, { rotate: "90" }), onClick: t10, customCSS: u$ };
  return tp.createElement("div", { className: l$ }, tp.createElement(qm, __spreadValues({}, n10)), tp.createElement("div", { className: d$ }, e14 && tp.createElement("span", null, e14)));
};
WBe.displayName = "SidebarPanelHeader";
const [jBe, ZBe] = Dp("pve-parameters-panel");
const GBe = ({ parameters: e14, boundParametersNames: t10 }) => {
  const { t: n10 } = vp("parametersViewEditor");
  const r10 = PA();
  const [o10, a10] = ep.useState(null);
  const i10 = (e15) => {
    a10(e15), r10(t$(wBe, e$({ paramName: e15 || "" })));
  };
  const s10 = [];
  const l10 = [];
  e14.forEach((e15) => (e15.Hidden ? l10 : s10).push(e15));
  const c10 = (e15) => {
    const n11 = { parameter: e15, isBound: t10.includes(e15.Name), openEditParameter: i10 };
    return tp.createElement($Be, __spreadValues({ key: e15.Name }, n11));
  };
  const u10 = n10("parametersPanel.headingEditParameter", "Edit Parameter");
  return tp.createElement("div", { className: s$ }, o10 ? tp.createElement(tp.Fragment, null, tp.createElement(WBe, { heading: u10, onClose: () => a10(null) }), tp.createElement("div", { className: p$ }, tp.createElement(TBe, null))) : tp.createElement(bF, null, (() => {
    if (l10.length > 0) {
      const e15 = { text: "", level: "info", size: "small", weight: "bold", strikeThrough: false };
      return tp.createElement("div", { className: kp(jBe, ZBe("with-headings")) }, tp.createElement(LE, __spreadProps(__spreadValues({}, e15), { text: n10("parametersPanel.headingEditable", "Editable") })), s10.map(c10), tp.createElement(LE, __spreadProps(__spreadValues({}, e15), { text: n10("parametersPanel.headingHidden", "Hidden") })), l10.map(c10));
    }
    return tp.createElement("div", { className: jBe }, e14.map(c10));
  })()));
};
GBe.displayName = "ParameterPanel";
const [UBe, , qBe] = Dp("pve-editor-range-preview");
const [YBe] = qBe("label");
const [KBe, XBe] = qBe("example");
const JBe = ({ date: e14, unit: t10 }) => {
  const n10 = kp(KBe, { [XBe("time")]: vNe(t10) });
  return tp.createElement("p", { className: n10 }, tp.createElement("span", null, e14.toLocaleDateString()), tp.createElement("span", null, e14.toLocaleTimeString()));
};
const QBe = ({ value: e14 }) => {
  const { t: t10, i18n: { language: n10 } } = vp("parametersViewEditor");
  const r10 = n10.toLowerCase();
  const o10 = ep.useMemo(() => sI().locale("zh" === r10 ? "zh-cn" : r10), [r10]);
  let [a10, i10] = [o10.toDate(), o10.toDate()];
  try {
    [a10, i10] = RNe(o10.toDate(), e14, o10.localeData().firstDayOfWeek());
  } catch (e15) {
  }
  return tp.createElement("div", { className: UBe }, tp.createElement("p", { className: YBe }, fOe(e14, t10)), tp.createElement(JBe, { date: a10, unit: e14.unit }), tp.createElement(JBe, { date: i10, unit: e14.unit }));
};
const eze = (e14) => {
  const { value: { rangeType: t10, unit: n10 } } = e14;
  const { t: r10 } = vp("parametersViewEditor");
  const o10 = ep.useMemo(() => vNe(n10) ? "Second" === n10 ? "pve_datetime_range_type_second" : "pve_datetime_range_type_time" : "pve_datetime_range_type", [n10]);
  const a10 = ep.useMemo(() => dAe("Common", r10("parametersViewEditor:properties.labels.unit", "Unit"), "enum", "unit", "both", { enumKey: "pve_datetime_range_unit" }), []);
  const i10 = ep.useMemo(() => dAe("Common", r10("parametersViewEditor:properties.labels.range", "Range"), "enum", "rangeType", "both", { enumKey: o10 }), [o10]);
  return tp.createElement(tp.Fragment, null, tp.createElement(nse, __spreadProps(__spreadValues({}, e14), { descriptor: a10, value: n10 })), tp.createElement(nse, __spreadProps(__spreadValues({}, e14), { descriptor: i10, value: t10 })));
};
const [tze] = Dp("pve-range-edit-panel");
const nze = { number: (e14, t10) => tp.createElement(wue, __spreadValues({ key: t10 }, e14)), boolean: (e14, t10) => tp.createElement(Hie, __spreadValues({ key: t10 }, e14)), label: (e14, t10) => tp.createElement(oOe, __spreadValues({ key: t10 }, e14)), "pve-preview": (e14, t10) => tp.createElement(QBe, __spreadValues({ key: t10 }, e14)), "pve-unit": (e14, t10) => tp.createElement(eze, __spreadValues({ key: t10 }, e14)), "pve-date-time": (e14, t10) => tp.createElement(oLe, __spreadValues({ key: t10 }, e14)) };
const rze = (e14, t10) => {
  const { rangeType: n10 } = e14;
  const r10 = t10("parametersViewEditor:properties.categories.preview", "Preview");
  const o10 = t10("parametersViewEditor:properties.categories.common", "Common");
  const a10 = t10("parametersViewEditor:properties.categories.appearance", "Appearance");
  const i10 = t10("parametersViewEditor:properties.categories.advanced", "Advanced");
  const s10 = [dAe(r10, "", "pve-preview", ""), dAe(o10, "", "pve-unit", "")];
  return "Current" !== n10 && "ToDate" !== n10 && s10.push(dAe(o10, t10("parametersViewEditor:properties.labels.amount", "Amount"), "number", "amount", "both", { numberType: "Integer", minValue: 1, step: 1 })), s10.push(dAe(a10, t10("parametersViewEditor:properties.labels.label", "Label"), "label", "label", "both"), dAe(i10, t10("parametersViewEditor:properties.labels.anchorDate", "Anchor Date"), "pve-date-time", "anchor"), dAe(i10, t10("parametersViewEditor:properties.labels.offset", "Offset"), "number", "offset", "both", { numberType: "Integer", step: 1 }), dAe(i10, t10("parametersViewEditor:properties.labels.endpoint", "Endpoint"), "boolean", "includeEndpoint", "both", { customType: { localizationKey: "parametersViewEditor:properties.labels.endpointStates" } })), s10;
};
const oze = ({ range: e14, onClose: t10 }) => {
  const { instanceId: n10, userPreferences: { units: r10 }, rdlx: { expressionSyntax: o10 } } = Uae();
  const { $index: a10, Type: i10 } = h9();
  const { setDateTimeRange: s10 } = ep.useContext(hOe);
  const { t: l10 } = vp("parametersViewEditor");
  const c10 = PA();
  const u10 = (t11, n11) => {
    const { valuePath: r11 } = t11;
    "unit" !== r11 ? s10(AV(e14, { [r11]: { $set: n11 } })) : ((t12) => {
      if (vNe(t12)) {
        const { rangeType: n12 } = e14;
        s10(AV(e14, { unit: { $set: t12 }, rangeType: { $set: "Last" === n12 || "Next" === n12 || "Second" !== t12 && "Current" === n12 ? n12 : "Last" } }));
      } else s10(AV(e14, { unit: { $set: t12 } }));
    })(n11);
  };
  const d10 = { type: "dynamic", unit: "Day", rangeType: "Last", amount: 1, anchor: "", offset: 0 };
  const p10 = { descriptors: rze(e14, l10), objectValue: __spreadProps(__spreadValues({}, e14), { name: "Range" }), defaultValue: d10, propertyEditors: nze, setProperty: u10, customCSS: Lz };
  const m10 = l10("parametersPanel.headingEditRange", "Edit Range");
  const h10 = dJ(i10, a10, null, "");
  const f10 = ep.useCallback((t11) => {
    const r11 = { descriptor: t11, objectValues: [e14], defaultValues: [void 0], objectPaths: [""], reportIndex: a10, reportType: i10, theme: null, validationContext: h10, setProperty: u10 };
    const o11 = _A.of(n10).open("expressionEditor", r11);
    c10(o11);
  }, [c10, n10, u10, e14, a10, i10, h10]);
  const g10 = ep.useMemo(() => ({ instanceId: n10, units: r10, expressionSyntax: o10, hideDataPicker: true, dataSets: [], dataSources: [], validationContext: h10, editExpression: f10 }), [n10, r10, o10, h10, f10]);
  return tp.createElement("div", { className: s$ }, tp.createElement(WBe, { heading: m10, onClose: t10 }), tp.createElement("div", { className: p$ }, tp.createElement(bF, null, tp.createElement("div", { className: tze }, tp.createElement(Vue.Provider, { value: g10 }, tp.createElement(wD, __spreadValues({}, p10)))))));
};
const aze = (e14, t10, n10) => {
  let { control: r10 } = e14;
  switch (r10.type) {
    case "boolean":
      r10 = AV(r10, { label: { text: n10 }, text: t10, textFalse: t10, textTrue: t10 });
      break;
    case "button":
    case "heading":
    case "nullify":
    case "plain-text":
      r10 = AV(r10, { text: t10 });
      break;
    case "custom":
    case "date-range":
    case "dropdown":
    case "list":
    case "multivalue":
    case "number-range":
    case "tree":
      r10 = AV(r10, { label: { text: n10 } });
      break;
    case "date-time":
    case "date-time-range":
    case "number":
    case "text":
      r10 = AV(r10, { label: { text: n10 }, placeholder: n10 });
  }
  return __spreadProps(__spreadValues({}, e14), { control: r10 });
};
const ize = "properties", sze = "parameters";
const lze = (e14, [t10, n10] = [0, 0], r10 = false) => {
  let o10 = t10;
  const a10 = n10;
  const i10 = 2 * Rp;
  const s10 = [];
  return e14.forEach((e15) => {
    const { Name: t11, Prompt: n11, DataType: r11, Hidden: l10, MultiValue: c10, ValidValues: u10, DisplayFormat: d10 } = e15;
    if (l10) return;
    const p10 = { left: a10, top: o10, width: 200, height: i10 };
    const m10 = { display: "top", text: n11, color: "default", font: { bold: false, italic: false, underline: false, transform: "none" } };
    c10 && !PRe(u10) ? s10.push(__spreadProps(__spreadValues({}, p10), { control: { type: "multivalue", binding: t11, label: m10 } })) : PRe(u10) ? s10.push(__spreadProps(__spreadValues({}, p10), { control: { type: "dropdown", binding: t11, label: m10 } })) : "Boolean" === r11 ? s10.push(__spreadProps(__spreadValues({}, p10), { control: { type: "boolean", binding: t11, label: m10, subType: "toggle", layout: "horizontal", text: "", textTrue: "", textFalse: "" } })) : "Integer" === r11 ? s10.push(__spreadProps(__spreadValues({}, p10), { control: { type: "number", binding: t11, label: m10, subType: "up-down", range: [0, 100], step: 5, strictInput: false } })) : "Float" === r11 ? s10.push(__spreadProps(__spreadValues({}, p10), { control: { type: "number", binding: t11, label: m10, subType: "slider", range: [0, 1], step: 0.1, strictInput: false } })) : "Date" === r11 || "DateTime" === r11 ? s10.push(__spreadProps(__spreadValues({}, p10), { control: { type: "date-time", binding: t11, label: m10, daysViewHeaderFormat: "", displayFormat: d10 } })) : s10.push(__spreadProps(__spreadValues({}, p10), { control: { type: "text", binding: t11, label: m10 } })), o10 += i10;
  }), !r10 && s10.push({ left: a10, top: o10, width: 200, height: Rp, control: { type: "button", action: "preview", text: "", background: "accent" } }), s10;
};
const cze = 5;
function uze(e14, t10) {
  return [Math.round(e14 / cze) * cze, Math.round(t10 / cze) * cze];
}
function dze(e14, { x: t10, y: n10 }) {
  let [r10, o10] = uze(Math.round(e14.left + t10), Math.round(e14.top + n10));
  return r10 < 0 && (r10 = 0), o10 < 0 && (o10 = 0), [r10, o10];
}
const pze = { position: "absolute", pointerEvents: "none", zIndex: 100, left: 0, top: 0, width: "100%", height: "100%" };
const [mze, hze] = Dp("pve-drag-box");
var fze = jre((e14) => ({ item: e14.getItem(), itemType: e14.getItemType(), delta: e14.getDifferenceFromInitialOffset(), coords: e14.getClientOffset(), isDragging: e14.isDragging() }))((e14) => {
  const { item: t10, itemType: n10, isDragging: r10, delta: o10, coords: a10 } = e14;
  if (!r10 || !o10) return null;
  const i10 = { position: "absolute", cursor: "move" };
  let s10 = null;
  switch (n10) {
    case MBe: {
      const { width: e15, height: n11 } = t10;
      const [r11, a11] = dze(t10, o10);
      s10 = tp.createElement("div", { className: mze, style: __spreadProps(__spreadValues({}, i10), { left: r11, top: a11, width: e15, height: n11 }) });
      break;
    }
    case NBe: {
      const { width: e15, height: n11, minHeight: r11, minWidth: a11, left: l10, top: c10, side: u10 } = t10;
      const [d10, p10] = uze(Math.round(e15 + o10.x), Math.round(n11 + o10.y));
      let m10 = e15;
      let h10 = n11;
      "e" !== u10 && "se" !== u10 || (m10 = Math.max(d10, a11)), "s" !== u10 && "se" !== u10 || (h10 = Math.max(p10, r11));
      const f10 = __spreadProps(__spreadValues({}, i10), { left: l10, top: c10, width: m10, height: h10 });
      s10 = tp.createElement("div", { className: kp(mze, hze("resize")), style: f10 });
      break;
    }
    case kBe:
      if (a10) {
        const { width: e15, height: n11 } = LAe[t10.type].init();
        const { left: r11, top: o11 } = document.getElementsByClassName("pve-surface")[0].getBoundingClientRect();
        const l10 = a10.x - r11;
        const c10 = a10.y - o11;
        s10 = tp.createElement("div", { className: mze, style: __spreadProps(__spreadValues({}, i10), { left: l10, top: c10, width: e15, height: n11 }) });
      }
  }
  return tp.createElement("div", { style: pze }, s10);
});
const [gze, yze] = Dp("pve-bound-item");
const [vze, , bze] = Dp("pve-binding-menu");
const [Sze] = bze("details");
const [Cze] = bze("params");
const [xze, , wze] = Dp("pve-binding");
const [Tze, Eze] = wze("dot");
const Fze = ({ parameter: e14, binding: { name: t10, dataType: n10 }, unnamed: r10, onRemove: o10 }) => {
  const { t: a10 } = vp("parametersViewEditor");
  let i10 = a10("bindingAdorner.textUnspecified", "Unspecified");
  let s10 = n10;
  e14 && (i10 = e14.Name, s10 = MRe(e14.DataType, a10));
  const l10 = { block: true, background: "transparent", customCSS: kp(gze, { [yze("unset")]: null === e14 }), onClick: o10, size: "large", width: "100%", disabled: null === e14 };
  return tp.createElement(qm, __spreadValues({}, l10), tp.createElement("p", null, !r10 && tp.createElement("b", null, t10), tp.createElement("span", null, s10)), tp.createElement("h4", null, i10), tp.createElement(Fm, { icon: nf(gRe) }));
};
const Mze = ({ bindings: e14, boundParameters: t10, validatedParameters: n10, onBindControl: r10 }) => {
  const { t: o10 } = vp("parametersViewEditor");
  const a10 = t10.findIndex((e15) => null === e15);
  return tp.createElement("div", { className: vze }, tp.createElement("div", { className: Sze }, tp.createElement(LE, { text: o10("bindingAdorner.headingBinding", "Binding"), align: "center" }), e14.map((e15, n11) => {
    const o11 = t10[n11];
    const a11 = { binding: e15, parameter: o11, unnamed: 1 === t10.length, onRemove: () => null !== o11 && r10(n11, "") };
    return tp.createElement(Fze, __spreadValues({ key: e15.name }, a11));
  })), tp.createElement("div", { className: Cze }, tp.createElement(bF, null, n10.map(({ parameter: e15, valid: t11, errors: n11 }) => {
    const o11 = { block: true, background: "transparent", size: "small", width: "100%", disabled: !t11, text: e15.Name, title: !t11 && n11.join(", ") || void 0 };
    return a10 > -1 && (o11.onClick = () => r10(a10, e15.Name)), tp.createElement(qm, __spreadValues({ key: e15.Name }, o11));
  }))));
};
const kze = ({ reportParameters: e14, boundParameters: t10, editorControl: n10, control: r10, onBindControl: o10 }) => {
  const { t: a10 } = vp("parametersViewEditor");
  if (0 === t10.length) return null;
  const i10 = t10.filter((e15) => null !== e15).length;
  const s10 = { bindings: n10.bindings(), boundParameters: t10, validatedParameters: IRe({ boundParameters: t10, reportParameters: e14, editorControl: n10, control: r10 }), onBindControl: o10 };
  const l10 = { content: tp.createElement(Mze, __spreadValues({}, s10)), block: true, size: "small", customScroll: true, hiddenChevron: true, menuAlign: "center", background: "transparent", offset: 0 };
  const c10 = t10.map((e15) => null === e15 ? a10("bindingAdorner.textUnspecified", "Unspecified") : e15.Name).join(" | ");
  const u10 = kp(Tze, { [Eze("partial")]: i10 > 0 && i10 !== t10.length, [Eze("full")]: i10 === t10.length });
  return l10.toggleContent = tp.createElement("div", { className: u10, title: c10 }), tp.createElement("div", { className: xze }, tp.createElement(UF, __spreadValues({}, l10)));
};
const Pze = (e14) => {
  switch (e14.label.display) {
    case "bottom":
      return "bottom-left";
    case "right":
      return "top-right";
    default:
      return "top-left";
  }
};
const Nze = (e14, t10, n10) => {
  if (!n10 || !t10.length) return { shouldShowSign: false, signPosition: "" };
  const r10 = t10.every((e15) => e15 && (e15.DefaultValue.Values.length || (({ DefaultValue: { DataSetReference: { DataSetName: e16, ValueField: t11 } } }) => kRe(e16) && kRe(t11))(e15)));
  const o10 = t10.some((e15) => e15 && !e15.Nullable && !e15.AllowBlank);
  return { shouldShowSign: o10 && !r10, signPosition: Pze(e14) };
};
const [Dze, Lze] = Dp("pve-control-simple-wrapper");
const Hze = Are([DBe], { drop({ index: e14, dispatch: t10 }, n10) {
  const { name: r10 } = n10.getItem();
  t10(COe.changeOrder(r10, e14));
} }, (e14) => ({ connectDropTarget: e14.dropTarget() }));
const Ize = Ire(DBe, { beginDrag: ({ index: e14, controlArea: { name: t10 } }) => ({ index: e14, name: t10 }) }, (e14, t10) => ({ connectDragSource: e14.dragSource(), isDragging: t10.isDragging() }));
const _ze = Hze(Ize(({ reportParameters: e14, controlArea: { name: t10, height: n10, control: r10, control: { type: o10 } }, selected: a10, dispatch: i10, onSelect: s10, connectDragSource: l10, connectDropTarget: c10, isDragging: u10, highlightRequired: d10 }) => {
  const { API: p10 } = ep.useContext(Sm);
  const m10 = LAe[o10];
  if (!m10) return null;
  const h10 = r10;
  const f10 = _Re(h10, e14);
  const g10 = __spreadValues({ parameters: f10 }, h10);
  const y10 = h10.label && "none" !== h10.label.display;
  const v10 = y10 && ("top" === h10.label.display || "bottom" === h10.label.display);
  const b10 = { reportParameters: e14, boundParameters: f10, editorControl: m10, control: h10, onBindControl: (e15, t11) => {
    i10(COe.bindControl(e15, t11));
  } };
  const { shouldShowSign: S10, signPosition: C10 } = Nze(h10, f10, d10);
  const x10 = kp(Dze, { [Lze("selected")]: a10, [Lze("invalid")]: !m10.validateBinding(f10), [Lze(`required-${C10}`)]: S10 });
  const w10 = { height: n10 || `${v10 ? 2 * Rp : Rp}px`, opacity: u10 ? 0 : 1 };
  return c10(l10(tp.createElement("div", { className: x10, style: w10, onMouseDown: (e15) => {
    var _a2;
    !a10 && s10 && s10(t10), (_a2 = p10.dropdowns.current) == null ? void 0 : _a2.close(), e15.stopPropagation();
  } }, !y10 && tp.createElement(m10.component, g10), y10 && tp.createElement(AN, { block: true, size: "small", label: h10.label.text, position: h10.label.display }, tp.createElement(m10.component, g10)), tp.createElement(kze, __spreadValues({}, b10)))));
}));
const [Vze, Rze] = Dp("pve-resize-grip");
const Aze = Ire(NBe, { beginDrag({ item: e14, side: t10, minWidth: n10, minHeight: r10 }) {
  const { name: o10, left: a10, top: i10, width: s10 } = e14;
  return { name: o10, left: a10, top: i10, width: s10, height: Oze(e14), side: t10, minHeight: r10, minWidth: n10 };
} }, (e14, t10) => ({ connectDragSource: e14.dragSource(), connectDragPreview: e14.dragPreview(), isDragging: t10.isDragging() }))(({ side: e14, connectDragSource: t10, connectDragPreview: n10 }) => {
  ep.useEffect(() => {
    n10 == null ? void 0 : n10(Coe(), { captureDraggingState: true });
  }, [n10]);
  const r10 = kp(Vze, Rze(e14));
  return t10(tp.createElement("div", { className: r10 }));
});
const Oze = (e14) => {
  if (null != e14.height) return e14.height;
  const t10 = e14.control;
  return t10.label && ("top" === t10.label.display || "bottom" === t10.label.display) ? 2 * Rp : Rp;
};
const [Bze, zze] = Dp("pve-control-wrapper");
const $ze = Ire(MBe, { beginDrag({ controlArea: e14 }) {
  const { name: t10, left: n10, top: r10, width: o10 } = e14;
  return { name: t10, left: n10, top: r10, width: o10, height: Oze(e14) };
} }, (e14, t10) => ({ connectDragSource: e14.dragSource(), connectDragPreview: e14.dragPreview(), isDragging: t10.isDragging() }))(({ reportParameters: e14, controlArea: t10, controlArea: { name: n10, left: r10, top: o10, width: a10, control: i10, control: { type: s10 } }, selected: l10, dispatch: c10, onSelect: u10, connectDragSource: d10, connectDragPreview: p10, isDragging: m10, highlightRequired: h10 }) => {
  var _a2, _b2;
  const { API: f10 } = ep.useContext(Sm);
  const g10 = (_b2 = (_a2 = i10.label) == null ? void 0 : _a2.text) != null ? _b2 : "";
  ep.useEffect(() => {
    p10 == null ? void 0 : p10(Coe(), { captureDraggingState: true });
  }, [p10]);
  const y10 = LAe[s10];
  if (!y10) return null;
  const v10 = i10;
  const b10 = _Re(v10, e14);
  const S10 = __spreadValues({ parameters: b10 }, v10);
  const { minHeight: C10, minWidth: x10 } = FOe(t10, b10);
  const w10 = v10.label && "none" !== v10.label.display;
  const T10 = { reportParameters: e14, boundParameters: b10, editorControl: y10, control: v10, onBindControl: (e15, t11) => {
    c10(COe.bindControl(e15, t11));
  } };
  const { shouldShowSign: E10, signPosition: F10 } = Nze(v10, b10, h10);
  const M10 = kp(Bze, { [zze("selected")]: l10, [zze("invalid")]: !y10.validateBinding(b10), [zze("dragging")]: m10, [zze(`required-${F10}`)]: E10 });
  const k10 = { left: r10, top: o10, width: `${a10}px`, height: `${Oze(t10)}px` };
  return d10(tp.createElement("div", { className: M10, style: k10, onMouseDown: (e15) => {
    var _a3;
    !l10 && (u10 == null ? void 0 : u10(n10)), (_a3 = f10.dropdowns.current) == null ? void 0 : _a3.close(), e15.stopPropagation();
  }, "data-aid": s10 }, l10 && tp.createElement(Aze, { item: t10, side: "e", minHeight: C10, minWidth: x10 }), l10 && null != t10.height && tp.createElement(Aze, { item: t10, side: "s", minHeight: C10, minWidth: x10 }), l10 && null != t10.height && tp.createElement(Aze, { item: t10, side: "se", minHeight: C10, minWidth: x10 }), !w10 && tp.createElement(y10.component, S10), w10 && tp.createElement(AN, { block: true, size: "small", label: g10, position: v10.label.display }, tp.createElement(y10.component, S10)), tp.createElement(kze, __spreadValues({}, T10))));
});
const [Wze] = Dp("pve-surface-container");
const [jze] = Dp("pve-surface-empty");
const [Zze, Gze] = Dp("pve-surface");
const [Uze] = Dp("pve-surface-message");
const [qze] = Dp("pve-surface-text");
const Yze = ({ unboundParameters: e14, dispatch: t10 }) => {
  const { t: n10 } = vp("parametersViewEditor");
  const r10 = { size: "small", accent: "full", text: n10("surface.btnAutoGenerate"), onClick: () => t10(COe.populateView(e14, true)) };
  return tp.createElement("div", { className: Uze }, tp.createElement("p", { className: qze }, n10("surface.messageBlock.textDescriptionOne")), tp.createElement("p", { className: qze }, n10("surface.messageBlock.textDescriptionButtonBefore"), tp.createElement(qm, __spreadValues({}, r10)), n10("surface.messageBlock.textDescriptionButtonAfter")));
};
const Kze = ({ parameters: e14, dispatch: t10 }) => {
  const { t: n10 } = vp("parametersViewEditor");
  if (e14.filter((e15) => !e15.Hidden).length > 0) {
    const r10 = { size: "small", accent: "full", text: n10("surface.btnGenerate", "Generate"), onClick: () => t10(COe.populateView(e14)) };
    return tp.createElement("div", { className: jze }, tp.createElement("p", { className: qze }, n10("surface.emptySurfaceBlock.textDescriptionOne")), tp.createElement("p", { className: qze }, n10("surface.emptySurfaceBlock.textDescriptionButtonBefore"), " ", tp.createElement(qm, __spreadValues({}, r10)), " ", n10("surface.emptySurfaceBlock.textDescriptionButtonAfter")));
  }
  return tp.createElement("div", { className: jze }, tp.createElement("p", { className: qze }, n10("surface.emptySurfaceBlock.textDescriptionOne")), tp.createElement("p", { className: qze }, n10("surface.emptySurfaceBlock.textDescriptionTwo")));
};
const Xze = () => {
  const { t: e14 } = vp("parametersViewEditor");
  return tp.createElement("p", null, e14("surface.scrollBar.textMessagesOne"), tp.createElement("br", null), e14("surface.scrollBar.textMessagesTwo"));
};
const Jze = (e14, t10) => "i11n" !== t10 ? e14 : aze(e14, { $apply: (e15) => hu(e15) }, { $apply: (e15) => e15 && hu(e15) });
class Qze extends tp.Component {
  render() {
    const { dispatch: e14, parameters: t10, canvas: n10, controls: r10, selection: o10, preferredLayout: a10, connectDropTarget: i10, highlightRequired: s10, expressionSyntax: l10 } = this.props;
    const c10 = (t11) => e14(COe.changeSelection(t11));
    if (!r10) return tp.createElement(Kze, __spreadValues({}, this.props));
    const u10 = r10.reduce((e15, t11) => {
      const n11 = t11.control;
      if (void 0 === n11.binding) return e15;
      const r11 = __spreadValues({}, e15);
      return Array.isArray(n11.binding) ? n11.binding.forEach((e16) => {
        r11[e16] = true;
      }) : r11[n11.binding] = true, r11;
    }, {});
    const d10 = t10.filter((e15) => !e15.Hidden && !u10[e15.Name]);
    const p10 = kp(Zze, { [Gze("vertical")]: "stack" === a10 });
    const m10 = "stack" === a10 ? {} : { width: `${n10.width}px`, height: `${n10.height}px` };
    return tp.createElement("div", { className: kp(Wze), onMouseDown: () => e14(COe.changeSelection(null)) }, tp.createElement(bF, null, i10(tp.createElement("div", { className: p10, style: m10 }, "stack" === a10 && tp.createElement(Xze, null), r10.map((n11, r11) => {
      const i11 = { index: r11, highlightRequired: s10, reportParameters: t10, controlArea: Jze(n11, l10), selected: n11.name === o10, dispatch: e14, onSelect: c10 };
      return "free-form" === a10 ? tp.createElement($ze, __spreadValues({ key: n11.name }, i11)) : tp.createElement(_ze, __spreadValues({ key: n11.name }, i11));
    }))), tp.createElement(fze, null)), d10.length > 0 && tp.createElement(Yze, { dispatch: e14, unboundParameters: d10 }));
  }
}
const e$e = Are([MBe, NBe, kBe, PBe], { drop({ dispatch: e14, canvas: t10, preferredLayout: n10 }, r10, o10) {
  var _a2;
  const a10 = r10.getItemType();
  const i10 = (_a2 = r10.getDifferenceFromInitialOffset()) != null ? _a2 : { x: 0, y: 0 };
  const s10 = () => {
    var _a3, _b2;
    if ("stack" === n10) return [0, t10.height];
    const e15 = (_a3 = hE.findDOMNode(o10)) == null ? void 0 : _a3.getBoundingClientRect();
    const a11 = (_b2 = r10.getClientOffset()) != null ? _b2 : { x: 0, y: 0 };
    return uze(a11.x - e15.left, a11.y - e15.top);
  };
  switch (a10) {
    case MBe: {
      const t11 = r10.getItem();
      const [n11, o11] = dze(t11, i10);
      e14(COe.changeLocation(t11.name, { left: n11, top: o11 }));
      break;
    }
    case NBe: {
      const t11 = r10.getItem();
      const [n11, o11] = uze(Math.round(t11.width + i10.x), Math.round(t11.height + i10.y));
      const a11 = {};
      "e" !== t11.side && "se" !== t11.side || (a11.width = Math.max(n11, t11.minWidth)), "s" !== t11.side && "se" !== t11.side || (a11.height = Math.max(o11, t11.minHeight)), e14(COe.resize(t11.name, a11));
      break;
    }
    case kBe: {
      const t11 = r10.getItem();
      const [n11, o11] = s10();
      const a11 = LAe[t11.type];
      if (null != a11) {
        const { type: t12, bindings: r11 } = a11;
        const i11 = 0 === r11().length ? "" : r11().map(() => "");
        e14(COe.addControl(t12, i11, { left: n11, top: o11 }));
      }
      break;
    }
    case PBe: {
      const t11 = r10.getItem();
      const [n11, o11] = s10();
      const a11 = lze([t11.parameter], [0, xOe])[0];
      if (null != a11) {
        const { type: t12, binding: r11 } = a11.control;
        e14(COe.addControl(t12, r11, { left: n11, top: o11 }));
      }
      break;
    }
  }
} }, (e14) => ({ connectDropTarget: e14.dropTarget() }));
const t$e = e$e(Qze);
const n$e = { block: true, size: "default", background: "transparent" };
const r$e = Ire(kBe, { beginDrag: ({ itype: e14 }) => ({ type: e14 }) }, ({ dragSource: e14, dragPreview: t10 }) => ({ connectDragSource: e14(), connectDragPreview: t10() }))(({ connectDragSource: e14, connectDragPreview: t10, icon: n10, text: r10, onClick: o10 }) => (ep.useEffect(() => {
  t10 == null ? void 0 : t10(Coe(), { captureDraggingState: true });
}, [t10]), e14(tp.createElement("div", { className: "wd-toolbox-item", key: r10, onClick: o10, title: r10, "data-aid": r10 }, tp.createElement(Fm, { icon: n10 || { type: "svg", content: null }, customCSS: "gc-btn__icon" }), tp.createElement("span", { className: "gc-btn__text" }, r10)))));
const o$e = (e14, t10) => Object.keys(LAe).filter((e15) => {
  var _a2;
  return true !== ((_a2 = t10 == null ? void 0 : t10.parametersView) == null ? void 0 : _a2.disableTreeView) || "tree" !== e15;
}).map((t11) => {
  const n10 = LAe[t11];
  if (!n10) return null;
  const { type: r10, icon: o10, name: a10, bindings: i10 } = n10;
  const s10 = 0 === i10().length ? "" : i10().map(() => "");
  const l10 = { itype: r10, icon: o10, text: a10(), onClick: () => e14(COe.addControl(r10, s10)), dragPreview: false };
  return { type: "custom", content: tp.createElement(r$e, __spreadValues({}, l10)) };
}).filter((e15) => null !== e15);
const a$e = { x: 1, y: 0 }, i$e = { x: -1, y: 0 }, s$e = { x: 0, y: -1 }, l$e = { x: 0, y: 1 };
const c$e = (e14) => ({ dispatch: t10 }) => t10(e14);
const u$e = COe.deleteControl();
const d$e = COe.moveByVector(a$e);
const p$e = COe.moveByVector(i$e);
const m$e = COe.moveByVector(s$e);
const h$e = COe.moveByVector(l$e);
const f$e = COe.duplicateControl();
const g$e = COe.toggleView();
const y$e = { Delete: c$e(u$e), "Ctrl+Backspace": bB ? c$e(u$e) : void 0, ArrowRight: c$e(d$e), ArrowLeft: c$e(p$e), ArrowUp: c$e(m$e), ArrowDown: c$e(h$e), "Ctrl+KeyD": c$e(f$e), "Ctrl+KeyL": c$e(g$e) };
const v$e = (e14, t10) => {
  const n10 = y$e[e14];
  return n10 || PB(e14, t10);
};
const b$e = "ParametersView";
function S$e(e14, t10) {
  const n10 = (e14.CustomProperties || []).filter((e15) => e15.Name !== b$e);
  if (null != t10) {
    const e15 = { controls: t10.controls.map((_a2) => {
      var _b2 = _a2, { name: e16 } = _b2, t11 = __objRest(_b2, ["name"]);
      var _a3;
      const n11 = __spreadValues({}, t11);
      const { control: r10 } = n11;
      return "date-range" !== r10.type && "date-time-range" !== r10.type || 0 !== ((_a3 = r10.ranges) == null ? void 0 : _a3.length) || (n11.control = AV(r10, { $unset: ["ranges"] })), n11;
    }), preferredLayout: t10.preferredLayout, canvas: t10.canvas };
    n10.push({ Name: b$e, Value: JSON.stringify(e15) });
  }
  return __spreadProps(__spreadValues({}, e14), { CustomProperties: n10 });
}
function C$e(e14) {
  var _a2;
  const t10 = (e14.CustomProperties || []).find((e15) => e15.Name === b$e);
  const n10 = null == t10 || null == t10.Value ? null : JSON.parse(t10.Value.toString());
  return null != n10 && (n10.controls.forEach((e15, t11) => {
    var _a3, _b2;
    e15.name = `pve-control-${t11}`, "date-range" !== e15.control.type && "date-time-range" !== e15.control.type || (e15.control.ranges = (_a3 = e15.control.ranges) != null ? _a3 : [], e15.control.showDefaultRanges = (_b2 = e15.control.showDefaultRanges) != null ? _b2 : true);
  }), n10.selection = null, n10.preferredLayout = (_a2 = n10.preferredLayout) != null ? _a2 : "free-form", null == n10.canvas && (n10.canvas = EOe(n10.controls))), n10;
}
const x$e = (e14, t10 = 0, n10 = false) => {
  const r10 = lze(e14, [0, xOe], n10).map((e15, n11) => __spreadProps(__spreadValues({}, e15), { name: `control-${n11 + t10}` }));
  return { canvas: EOe(r10), selection: r10 == null ? void 0 : r10[0].name, preferredLayout: "free-form", controls: r10, highlightRequired: true };
};
const w$e = (e14, t10) => {
  const n10 = LAe[t10.control.type];
  if (!n10) return e14;
  const r10 = t10.control;
  const o10 = `pve-control-${e14.controls.length}`;
  return AV(e14, { selection: { $set: o10 }, controls: { $push: [__spreadProps(__spreadValues({ name: o10 }, n10.init(r10.binding, __spreadValues({}, r10))), { left: t10.left + 15, top: t10.top + 15, width: t10.width, height: t10.height })] } });
};
const T$e = { width: 640, height: 480 };
const E$e = (e14 = null, t10 = null) => {
  const n10 = function(e15, t11) {
    if (null == e15) {
      if (null == t11) return null;
      if ("@pve/POPULATE_VIEW" === t11.type) return x$e(t11.payload.params);
      if ("@pve/ADD_CONTROL" === t11.type) {
        const { type: n11, binding: r10, location: o10 } = t11.payload;
        const a10 = LAe[n11];
        return a10 ? { canvas: T$e, controls: [__spreadValues({ name: "pve-control-0" }, a10.init(r10, o10 || {}))], selection: "pve-control-0", preferredLayout: "free-form", highlightRequired: true } : e15;
      }
      return e15;
    }
    switch (t11 == null ? void 0 : t11.type) {
      case "@pve/CHANGE_SELECTION":
        return AV(e15, { selection: { $set: t11.payload.name } });
      case "@pve/CHANGE_LOCATION": {
        const { name: n11, location: r10 } = t11.payload;
        const o10 = e15.controls.findIndex((e16) => e16.name === n11);
        return -1 === o10 ? e15 : AV(e15, { controls: { [o10]: { top: { $set: r10.top }, left: { $set: r10.left } } } });
      }
      case "@pve/MOVE_BY_VECTOR": {
        const { selection: n11, controls: r10 } = e15;
        const { x: o10, y: a10 } = t11.payload;
        const i10 = r10.findIndex((e16) => e16.name === n11);
        if (-1 === i10) return e15;
        const { left: s10, top: l10 } = r10[i10];
        const [c10, u10] = dze({ left: s10, top: l10 }, { x: o10 * cze, y: a10 * cze });
        return AV(e15, { controls: { [i10]: { top: { $set: u10 }, left: { $set: c10 } } } });
      }
      case "@pve/RESIZE": {
        const { name: n11, size: r10 } = t11.payload;
        const o10 = e15.controls.findIndex((e16) => e16.name === n11);
        if (-1 === o10) return e15;
        const a10 = {};
        return null != r10.width && (a10.width = { $set: r10.width }), null != r10.height && null != e15.controls[o10].height && (a10.height = { $set: r10.height }), zV.isEmpty(a10) ? e15 : AV(e15, { controls: { [o10]: a10 } });
      }
      case "@pve/CHANGE_ORDER": {
        const { name: n11, index: r10 } = t11.payload;
        const o10 = e15.controls.find((e16) => e16.name === n11);
        if (void 0 === o10) return e15;
        const a10 = e15.controls.indexOf(o10);
        return AV(e15, { controls: { $splice: [[a10, 1], [r10, 0, o10]] } });
      }
      case "@pve/SET_PROPERTY": {
        const { selection: n11 } = e15;
        const { descriptor: r10, value: o10 } = t11.payload;
        if (null === n11) {
          const t12 = AV(e15.canvas, ZN(r10.valuePath)(o10));
          return AV(e15, { canvas: { $set: t12 } });
        }
        const a10 = e15.controls.findIndex((e16) => e16.name === n11);
        if (-1 === a10) return e15;
        const i10 = AV(e15.controls[a10], ZN(r10.valuePath)(o10));
        return AV(e15, { controls: { [a10]: { $set: i10 } } });
      }
      case "@pve/REMOVE_VIEW":
        return null;
      case "@pve/POPULATE_VIEW": {
        const { params: n11, partial: r10 } = t11.payload;
        if (!r10) return x$e(n11);
        const { controls: o10, selection: a10 } = x$e(n11, e15.controls.length, true);
        return AV(e15, { controls: { $push: o10 }, selection: { $set: a10 } });
      }
      case "@pve/BIND_CONTROL": {
        const { selection: n11 } = e15;
        const { bindingIndex: r10, parameterName: o10 } = t11.payload;
        const a10 = e15.controls.findIndex((e16) => e16.name === n11);
        if (-1 === a10) return e15;
        const i10 = e15.controls[a10].control;
        if (void 0 === i10.binding) return e15;
        let s10 = i10;
        return s10 = Array.isArray(i10.binding) ? AV(i10, { binding: { [r10]: { $set: o10 } } }) : AV(i10, { binding: { $set: o10 } }), AV(e15, { controls: { [a10]: { control: { $set: s10 } } } });
      }
      case "@pve/ADD_CONTROL": {
        const { controls: n11 } = e15;
        const { type: r10, binding: o10, location: a10 } = t11.payload;
        const i10 = LAe[r10];
        if (!i10) return e15;
        const s10 = `pve-control-${n11.length}`;
        return AV(e15, { controls: { $push: [__spreadValues(__spreadValues({ name: s10 }, i10.init(o10, {})), a10 || {})] }, selection: { $set: s10 } });
      }
      case "@pve/DELETE_CONTROL": {
        const { selection: t12 } = e15;
        const n11 = e15.controls.findIndex((e16) => e16.name === t12);
        if (-1 === n11) return e15;
        let r10 = AV(e15, { controls: { $splice: [[n11, 1]] }, selection: { $set: null } });
        for (let e16 = 0; e16 < r10.controls.length; e16++) r10 = AV(r10, { controls: { [e16]: { name: { $set: `pve-control-${e16}` } } } });
        return r10;
      }
      case "@pve/DUPLICATE_CONTROL": {
        const { selection: t12 } = e15;
        const n11 = e15.controls.find((e16) => e16.name === t12);
        return void 0 === n11 ? e15 : w$e(e15, n11);
      }
      case "@pve/PASTE_CONTROL":
        return w$e(e15, t11.payload.controlArea);
      case "@pve/TOGGLE_VIEW": {
        const { preferredLayout: t12 } = e15;
        return AV(e15, { preferredLayout: { $set: "free-form" === t12 ? "stack" : "free-form" } });
      }
      case "@pve/TOGGLE_REQUIRED_SIGN":
        return AV(e15, { $toggle: ["highlightRequired"] });
      default:
        return e15;
    }
  }(e14, t10);
  if (null !== n10 && n10 !== e14) {
    const e15 = EOe(n10.controls);
    e15.width > n10.canvas.width && (n10.canvas = __spreadProps(__spreadValues({}, n10.canvas), { width: e15.width })), e15.height > n10.canvas.height && (n10.canvas = __spreadProps(__spreadValues({}, n10.canvas), { height: e15.height }));
  }
  return n10;
};
const F$e = "RDLX-Parameters";
const M$e = { useParametersViewSurface: () => {
  const { $paramsView: e14, ReportParameters: t10 } = h9();
  const { rdlx: { expressionSyntax: n10 } } = Uae();
  const r10 = PA();
  const o10 = ep.useMemo(() => {
    const { controls: o11, canvas: a10, selection: i10, preferredLayout: s10, highlightRequired: l10 } = e14 != null ? e14 : {};
    return { controls: o11, canvas: a10, selection: i10, preferredLayout: s10, highlightRequired: l10, parameters: t10, expressionSyntax: n10, dispatch: r10 };
  }, [e14, t10, n10, r10]);
  return o10;
}, workspaceId: F$e, reducer: E$e, persistence: { store: S$e, retrieve: C$e }, Surface: t$e, Sidebar: () => {
  const { instanceId: e14, userPreferences: { units: t10 }, rdlx: { expressionSyntax: n10 } } = Uae();
  const { $index: r10, $paramsView: o10, DataSources: a10, DataSets: i10, ReportParameters: s10, Type: l10 } = h9();
  const { controls: c10, canvas: u10, selection: d10 } = o10 != null ? o10 : {};
  const p10 = PA();
  const [m10, h10] = ep.useState(-1);
  const { t: f10 } = vp("parametersViewEditor");
  const g10 = rf(ef);
  const y10 = rf(kie);
  const v10 = ep.useCallback((e15, t11) => {
    if (e15.meta) switch (e15.meta._type) {
      case "options": {
        const { meta: n11 } = e15;
        const r11 = s10.findIndex((e16) => e16.Name === n11.name);
        if (-1 === r11) return;
        p10(c2({ path: `ReportParameters.${r11}`, descriptor: __spreadProps(__spreadValues({}, e15), { valuePath: n11.valuePath }), value: t11 }));
        break;
      }
      default:
        p10(COe.setProperty(e15, t11));
    }
    else p10(COe.setProperty(e15, t11));
  }, [p10, s10]);
  const b10 = { defaultPanelId: "properties", dataAid: "@pve/sidebar", controlsContainerId: `${e14}-sb-controls`, collapseTitle: f10("sideBar.collapse"), expandTitle: f10("sideBar.expand") };
  const S10 = { id: ize, customScroll: true, toggle: { icon: g10, text: f10("propertiesText"), title: f10("propertiesText") } };
  const C10 = { id: sze, customScroll: true, toggle: { icon: y10, text: f10("parametersText", "Parameters"), title: f10("parametersText", "Parameters") } };
  const x10 = null !== d10 ? c10 == null ? void 0 : c10.find((e15) => e15.name === d10) : void 0;
  const w10 = x10 ? aze(x10, { $set: "" }, { $set: void 0 }) : void 0;
  ep.useLayoutEffect(() => {
    if (x10) {
      const e15 = x10.control;
      const t11 = _Re(e15, s10);
      const { minWidth: n11, minHeight: r11 } = FOe(x10, t11);
      x10.width < n11 && p10(COe.setProperty({ valuePath: "width" }, n11)), x10.height < r11 && p10(COe.setProperty({ valuePath: "height" }, r11));
    }
  }, [p10, s10, x10]), ep.useEffect(() => {
    -1 !== m10 && h10(-1);
  }, [d10]);
  const T10 = dJ(l10, r10, null, "");
  const E10 = ep.useCallback((t11) => {
    const n11 = { descriptor: t11, objectValues: [x10], defaultValues: [w10], objectPaths: [""], reportIndex: r10, reportType: l10, theme: null, validationContext: T10, setProperty: v10 };
    const o11 = _A.of(e14).open("expressionEditor", n11);
    p10(o11);
  }, [x10, w10, r10, l10, T10, v10, e14, p10]);
  const F10 = ep.useMemo(() => ({ instanceId: e14, units: t10, expressionSyntax: n10, hideDataPicker: true, dataSets: [], dataSources: [], validationContext: T10, editExpression: E10 }), [e14, t10, n10, T10, E10]);
  const M10 = ep.useCallback(() => {
    h10(-1);
  }, []);
  const k10 = ep.useMemo(() => ({ setRangeIndex: (e15) => {
    h10(e15);
  }, setDateTimeRange: (e15) => {
    const t11 = { valuePath: `control.ranges.${m10}` };
    p10(COe.setProperty(t11, e15));
  } }), [p10, m10]);
  let P10;
  if (!c10) return null;
  const N10 = { validatedParameters: [], currentControl: null, isSemanticReport: false };
  const D10 = { dataAid: "@pve/properties", descriptors: [], objectValue: __spreadValues({ name: "canvas" }, u10), propertyEditors: SOe, environment: N10, setProperty: v10, key: "Canvas", selectionName: f10("canvas"), t: f10, customCSS: Dz };
  if (void 0 !== x10) {
    const e15 = LAe[x10.control.type];
    if (e15) {
      const t11 = x10.control;
      const n11 = _Re(t11, s10);
      const r11 = e15.getProperties(t11, n11);
      if (D10.selectionName = e15.name(), D10.objectValue = x10, D10.defaultValue = w10, D10.descriptors = [...1 === e15.bindings().length ? [$N("", "properties.labels.binding", "binding", "control.binding")] : e15.bindings().map((e16, t12) => $N("properties.categories.binding", e16.name, "binding", `control.binding.${t12}`)), ...r11], "date-range" === x10.control.type || "date-time-range" === x10.control.type) {
        const { ranges: e16 } = x10.control;
        P10 = (e16 != null ? e16 : [])[m10];
        const t12 = f10("parametersViewEditor:properties.categories.details");
        const n12 = f10("parametersViewEditor:properties.labels.ranges", "Ranges");
        D10.descriptors.push($N(t12, n12, "ranges", "control.ranges"));
        const r12 = f10("parametersViewEditor:properties.labels.showDefaultRanges.label", "Default Ranges");
        D10.descriptors.push($N(t12, r12, "boolean", "control.showDefaultRanges", "both", { customType: { localizationKey: "parametersViewEditor:properties.labels.showDefaultRanges" } }));
      }
      if (void 0 !== t11.binding) {
        D10.objectValue = __spreadProps(__spreadValues({}, x10), { boundParameters: n11.reduce((e16, t12) => null !== t12 ? __spreadProps(__spreadValues({}, e16), { [t12.Name]: t12 }) : e16, {}) }), n11.forEach((t12, r13) => {
          null === t12 || J7(t12) || D10.descriptors.push(...((e16, { Name: t13, DataType: n12, Nullable: r14, AllowBlank: o12, Multiline: a11, MultiValue: i11, ValidValues: s11 }, l12, c12 = true) => {
            const u11 = [RRe(l12, e16("parametersViewEditor:boundParameter.defaultValue"), "default", `boundParameters.${t13}`, { name: t13, valuePath: "" })];
            return PRe(s11) && (r14 || o12 || a11 || u11.push(RRe(l12, e16("parametersViewEditor:boundParameter.multiValue"), "boolean", `boundParameters.${t13}.MultiValue`, { name: t13, valuePath: "MultiValue" }))), i11 || ("String" === n12 && (u11.push(RRe(l12, e16("parametersViewEditor:boundParameter.multiline"), "boolean", `boundParameters.${t13}.Multiline`, { name: t13, valuePath: "Multiline" })), u11.push(RRe(l12, e16("parametersViewEditor:boundParameter.allowBlank"), "boolean", `boundParameters.${t13}.AllowBlank`, { name: t13, valuePath: "AllowBlank" }))), c12 && u11.push(RRe(l12, e16("parametersViewEditor:boundParameter.nullable"), "boolean", `boundParameters.${t13}.Nullable`, { name: t13, valuePath: "Nullable" }))), u11;
          })(f10, t12, 1 === n11.length ? f10("boundParameter.text", "Bound Parameter") : f10("boundParameter.parameter", "{{name}} Parameter", { name: `'${e15.bindings()[r13].name}'` }), 1 === n11.length));
        }), N10.validatedParameters = IRe({ boundParameters: n11, reportParameters: s10, editorControl: e15, control: t11 }).filter((e16) => e16.valid), N10.currentControl = t11;
        const r12 = i10.find((e16) => {
          var _a2;
          return e16.Name === ((_a2 = n11[0]) == null ? void 0 : _a2.ValidValues.DataSetReference.DataSetName);
        });
        N10.dataSet = r12, N10.isSemanticReport = !(!r12 || !r12.Query) && C6(r12, a10);
      }
      const { minHeight: o11, minWidth: l11 } = FOe(x10, n11);
      const c11 = "properties.categories.locationAndSize";
      D10.descriptors.push($N(c11, "properties.labels.left", "number", "left", void 0, oAe), $N(c11, "properties.labels.top", "number", "top", void 0, oAe), $N(c11, "properties.labels.width", "number", "width", "both", __spreadProps(__spreadValues({}, aAe), { minValue: l11 })), $N(c11, "properties.labels.height", "number", "height", "both", __spreadProps(__spreadValues({}, aAe), { minValue: o11 })));
    }
  } else D10.descriptors = [$N("", "properties.labels.width", "number", "width", void 0, aAe), $N("", "properties.labels.height", "number", "height", void 0, aAe)];
  const L10 = c10.reduce((e15, t11) => {
    const { binding: n11 } = t11.control;
    return n11 ? Array.isArray(n11) ? [...e15, ...n11] : [...e15, n11] : e15;
  }, []);
  return tp.createElement(PN, __spreadValues({ key: "@pve/sidebar" }, b10), tp.createElement(dN, __spreadValues({}, S10), tp.createElement(hOe.Provider, { value: k10 }, P10 && tp.createElement(oze, { range: P10, onClose: M10 }), !P10 && tp.createElement(Vue.Provider, { value: F10 }, tp.createElement(DD, __spreadProps(__spreadValues({}, D10), { closeSearchBtnTitle: f10("propertyGrid.btnCloseSearch", "Close"), emptyListPlaceholder: f10("propertyGrid.textEmptyList", "Select an item to see properties"), gridSearchPlaceholder: f10("propertyGrid.placeholderSearch", "enter property name here..."), noCommonProperties: f10("propertyGrid.textNoCommonProperties", "There are no common properties"), textUnknownProperty: f10("propertyGrid.textUnknownProperty", "Unknown Property:") }))))), tp.createElement(dN, __spreadValues({}, C10), tp.createElement(GBe, { parameters: s10, boundParametersNames: L10 })));
}, getToolbar: ({ dispatch: e14, paramsView: t10, reportParams: n10, t: r10 }) => {
  const o10 = __spreadProps(__spreadValues({}, n$e), { text: r10("parametersViewEditor:toolbar.btnDuplicate"), icon: nf(SRe), disabled: !t10 || null === t10.selection, onClick: () => e14(COe.duplicateControl()) });
  const a10 = __spreadProps(__spreadValues({}, n$e), { text: r10("parametersViewEditor:toolbar.btnDelete"), icon: nf(bRe), disabled: !t10 || null === t10.selection, onClick: () => e14(COe.deleteControl()) });
  const i10 = __spreadProps(__spreadValues({}, n$e), { text: "stack" === (t10 == null ? void 0 : t10.preferredLayout) ? r10("parametersViewEditor:toolbar.btnLayoutStack", "Stack") : r10("parametersViewEditor:toolbar.btnLayoutFreeForm", "Free Form"), icon: nf("stack" === (t10 == null ? void 0 : t10.preferredLayout) ? TRe : ERe), disabled: null === t10, onClick: () => e14(COe.toggleView()) });
  const s10 = __spreadProps(__spreadValues({}, n$e), { text: r10("parametersViewEditor:toolbar.btnHighlightRequired"), icon: nf(FRe), background: t10 && t10.highlightRequired ? "default" : "transparent", disabled: null === t10, onClick: () => e14(COe.toggleRequiredSign()) });
  const l10 = __spreadProps(__spreadValues({}, n$e), { text: r10(null === t10 ? "parametersViewEditor:toolbar.btnGenerateView" : "parametersViewEditor:toolbar.btnResetView"), icon: nf(null === t10 ? CRe : wRe), disabled: 0 === n10.length || n10.every((e15) => e15.Hidden), onClick: () => e14(COe.populateView(n10)) });
  const c10 = __spreadProps(__spreadValues({}, n$e), { text: r10("parametersViewEditor:toolbar.btnRemoveView"), icon: nf(xRe), disabled: null === t10, onClick: () => e14(COe.removeView()) });
  return [tp.createElement(qm, __spreadValues({ key: "pve/duplicate_control" }, o10)), tp.createElement(qm, __spreadValues({ key: "pve/delete_control" }, a10)), tp.createElement(DM, { key: "pve/splitter1" }), tp.createElement(qm, __spreadValues({ key: "pve/toggle_control" }, i10)), tp.createElement(DM, { key: "pve/splitter2" }), tp.createElement(qm, __spreadValues({ key: "pve/generate_view" }, l10)), tp.createElement(qm, __spreadValues({ key: "pve/remove_view" }, c10)), tp.createElement(DM, { key: "pve/splitter3" }), tp.createElement(qm, __spreadValues({ key: "pve/toggle_req" }, s10))];
}, getToolboxItems: o$e, getRdlxParametersHotkeyHandler: v$e };
const k$e = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, d: "M22 13.75v5.5A2.751 2.751 0 0 1 19.25 22h-5.5A2.751 2.751 0 0 1 11 19.25v-5.5A2.751 2.751 0 0 1 13.75 11h5.5A2.751 2.751 0 0 1 22 13.75ZM12.5 17v2.25c0 .69.56 1.25 1.25 1.25H16V17h-3.5Zm4.5 3.5h2.25c.69 0 1.25-.56 1.25-1.25V17H17v3.5Zm3.5-4.5v-2.25c0-.69-.56-1.25-1.25-1.25H17V16h3.5ZM16 12.5h-2.25c-.69 0-1.25.56-1.25 1.25V16H16v-3.5Z" }), tp.createElement("path", { className: Ym.accent, fillOpacity: ".62", d: "M9 17v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2Zm-1 0a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3ZM22 4v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2Zm-1 0a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V4Z" }), tp.createElement("path", { className: Km.secondary, d: "M6.25 12a.75.75 0 0 1-1.5 0V8.016c0-.866.344-1.697.957-2.309a3.263 3.263 0 0 1 2.309-.957H12a.75.75 0 0 1 0 1.5H8.016A1.766 1.766 0 0 0 6.25 8.016V12ZM5 19h-.5a.5.5 0 0 1 0-1H5v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1H6v.5a.5.5 0 0 1-1 0V19ZM18 6h-.5a.5.5 0 0 1 0-1h.5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1H19v.5a.5.5 0 0 1-1 0V6Z" }));
const P$e = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Km.secondary, d: "M20.257 13.745a1.994 1.994 0 0 1-.779 2.29l-6.049 4.084c-.846.57-1.953.57-2.798 0l-6.05-4.084a2.001 2.001 0 0 1-.779-2.29l6.841 4.56a2.498 2.498 0 0 0 2.613.098l.161-.098 6.84-4.56Z" }), tp.createElement("path", { className: Ym.accent, fillOpacity: ".38", d: "M20.055 12.187a1.982 1.982 0 0 1-.577.598l-6.049 4.084c-.846.57-1.953.57-2.798 0l-6.05-4.084a2.001 2.001 0 0 1-.779-2.29l6.841 4.56a2.498 2.498 0 0 0 2.613.098l.161-.098 6.84-4.56a1.994 1.994 0 0 1-.202 1.692Z" }), tp.createElement("path", { className: Ym.accent, d: "m13.417 3.42 6.365 4.243a1.001 1.001 0 0 1 0 1.664l-6.365 4.244a2.5 2.5 0 0 1-2.774 0L4.278 9.327a.998.998 0 0 1 0-1.664l6.365-4.243a2.5 2.5 0 0 1 2.774 0Zm-1.826 1.182-.116.066-5.74 3.827 5.74 3.828a1 1 0 0 0 .994.066l.116-.066 5.739-3.828-5.739-3.827a1 1 0 0 0-.994-.066Z" }));
const N$e = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" }, tp.createElement("path", { className: Ym.accent, fillOpacity: ".15", d: "M5.5 12.5h13v8.047h-13z" }), tp.createElement("path", { className: Ym.accent, d: "M20 5.25v13.5A3.251 3.251 0 0 1 16.75 22h-9.5A3.251 3.251 0 0 1 4 18.75V5.25A3.251 3.251 0 0 1 7.25 2h9.5A3.251 3.251 0 0 1 20 5.25ZM18.5 11V5.25a1.75 1.75 0 0 0-1.75-1.75h-9.5A1.75 1.75 0 0 0 5.5 5.25V11h13Zm-13 1.5v6.25c0 .966.784 1.75 1.75 1.75h9.5a1.75 1.75 0 0 0 1.75-1.75V12.5h-13Z" }), tp.createElement("path", { className: Km.secondary, d: "M9.2 7c-.386 0-.7-.336-.7-.75s.314-.75.7-.75h5.6c.386 0 .7.336.7.75s-.314.75-.7.75H9.2Zm0 9c-.386 0-.7-.336-.7-.75s.314-.75.7-.75h5.6c.386 0 .7.336.7.75s-.314.75-.7.75H9.2Z" }));
const [D$e] = Dp("wd-explorer");
const [L$e, H$e, I$e] = Dp("wd-explorer-node");
const [_$e, V$e] = I$e("button");
const [R$e, A$e] = I$e("chevron");
const O$e = nf(oh);
const B$e = ({ nodes: e14, onNodeClick: t10, onNodeToggle: n10 }) => {
  const r10 = { nodes: e14, outline: true, renderNode: ep.useCallback((e15) => {
    var _a2;
    const { expanded: r11, selected: o10, icon: a10, text: i10 } = e15;
    const s10 = kp(R$e, { [A$e("collapsed")]: !r11 });
    const l10 = { icon: O$e, size: "small", accent: "icon", background: "transparent", customCSS: s10, onClick: () => n10(e15) };
    const c10 = { block: true, size: "small", background: "transparent", icon: a10, text: i10, customCSS: kp(_$e, { [V$e("selected")]: o10 }), onClick: t10(e15) };
    return tp.createElement(tp.Fragment, null, tp.createElement(qm, __spreadValues({}, c10)), !!((_a2 = e15.nodes) == null ? void 0 : _a2.length) && tp.createElement(qm, __spreadValues({}, l10)));
  }, [t10, n10]) };
  return tp.createElement("div", { className: D$e }, tp.createElement(eI, __spreadValues({}, r10)));
};
const z$e = _V("@rdlx/propertyGrid/drillPath", (e14) => ({ path: e14 }));
const $$e = _V("@rdlx/propertyGrid/resetPath");
const W$e = _V("@rdlx/propertyGrid/shrinkPath");
function j$e(e14, t10) {
  return (e14 || []).map((e15, n10) => __spreadProps(__spreadValues({}, e15), { Name: `${t10("reportItems:dvchartPlot", "Plot")} - ${e15.PlotName}`, $path: `Plots.${n10}` }));
}
function Z$e(e14, t10) {
  return (e14 || []).map((e15, n10) => {
    let r10 = "X" === e15.AxisType ? t10("reportItems:dvchartXAxis", "X Axis") : t10("reportItems:dvchartYAxis", "Y Axis");
    return e15.Plots.length && (r10 = `${r10} - [${e15.Plots.filter((e16) => !!e16).join(", ")}]`), __spreadProps(__spreadValues({}, e15), { Name: r10, $path: `Axes.${n10}` });
  });
}
const G$e = (e14, t10) => {
  switch (e14) {
    case "Color":
      return t10("reportItems:dvchartColorLegend", "Legend - Color");
    case "Shape":
      return t10("reportItems:dvchartShapeLegend", "Legend - Shape");
    case "Size":
      return t10("reportItems:dvchartSizeLegend", "Legend - Size");
    default:
      return "";
  }
};
function U$e(e14, t10) {
  return (e14 || []).map((e15, n10) => __spreadProps(__spreadValues({}, e15), { Name: G$e(e15.LegendType, t10), $path: `Legends.${n10}` }));
}
const q$e = (e14) => {
  const t10 = (e15, n11) => {
    const r11 = [];
    return e15.Header && e15.Header.Item && r11.push(K$e(e15.Header.Item, Uj(n11))), e15.Children && e15.Children.forEach((e16, o10) => {
      r11.push(...t10(e16, Gj(n11, o10)));
    }), r11;
  };
  const n10 = (n11) => {
    const r11 = e14[n11];
    const o10 = [];
    return r11.Members.forEach((e15, r12) => {
      o10.push(...t10(e15, Zj(n11, r12)));
    }), o10;
  };
  const r10 = [];
  return e14.Corner && r10.splice(0, 0, ...function(e15) {
    const t11 = [];
    return e15.Corner && e15.Corner.forEach((e16, n11) => {
      e16.forEach((e17, r11) => {
        e17 && e17.Item && t11.push(K$e(e17.Item, qj(n11, r11)));
      });
    }), t11;
  }(e14)), e14.ColumnHierarchy && r10.push(...n10("ColumnHierarchy")), e14.RowHierarchy && r10.push(...n10("RowHierarchy")), e14.Body && e14.Body.Rows.forEach((e15, t11) => {
    e15.Cells.forEach((e16, n11) => {
      e16 && e16.Item && r10.push(K$e(e16.Item, Yj(t11, n11)));
    });
  }), r10;
};
const Y$e = (e14) => e14.ReportItems.map((t10, n10) => {
  const r10 = Wj(e14.$path, n10);
  return K$e(t10, $j(r10, t10.$path));
});
const K$e = (e14, t10) => __spreadProps(__spreadValues({}, e14), { $path: t10 });
function X$e(e14, t10) {
  switch (e14.Type) {
    case "fixedpagereport":
      return e14.Pages.map((e15, n10) => K$e(__spreadProps(__spreadValues({}, e15), { Name: `${t10("reportItems:Page", "Page")} ${n10 + 1}` }), Kj(n10)));
    case "multisectionreport": {
      const t11 = [];
      return e14.ReportSections.forEach((e15, n10) => t11.push(K$e(e15, `ReportSections.${n10}`))), t11;
    }
    case "dashboard": {
      const t11 = [];
      return e14.ReportSections.forEach((e15, n10) => t11.push(K$e(e15, `ReportSections.${n10}`))), t11;
    }
    case "Continuous": {
      const t11 = [];
      return e14.PageHeader && t11.push(K$e(e14.PageHeader, `${e14.$path}.PageHeader`)), t11.push(K$e(e14.Body, `${e14.$path}.Body`)), e14.PageFooter && t11.push(K$e(e14.PageFooter, `${e14.$path}.PageFooter`)), t11;
    }
    case "dashboardsection":
      return Y$e(K$e(e14.Body, $j(e14.$path, "Body")));
    case "FixedPage":
      return e14.FixedPage.Pages.map((n10, r10) => K$e(__spreadProps(__spreadValues({}, n10), { Name: `${t10("reportItems:Page", "Page")} ${r10 + 1}` }), `${e14.$path}.FixedPage.${Kj(r10)}`));
    case "section":
    case "pagesection":
    case "fixedpagesection":
    case "rectangle":
    case "fixedpagerectangle":
    case "list":
    case "contentplaceholder":
    case "fixedpagelist":
      return Y$e(e14);
    case "table":
    case "fixedpagetable":
      return ((e15) => {
        const t11 = [];
        return XQ(e15, ({ item: e16, itemPath: n10 }) => {
          const r10 = K$e(e16, n10);
          t11.push(r10);
        }), t11;
      })(e14).map((t11) => K$e(t11, $j(e14.$path, t11.$path)));
    case "tablix":
    case "fixedpagetablix":
      return q$e(e14).map((t11) => K$e(t11, $j(e14.$path, t11.$path)));
    case "fixedpagedvchart":
    case "dvchart":
      return function(e15, t11) {
        const n10 = e15.Plots.some((e16) => e16.Encodings.Color.Field.Value.some((e17) => "VALUESNAME" === ("string" == typeof e17 ? e17 : e17.Value)));
        return [__spreadProps(__spreadValues({}, e15.Header), { Name: t11("reportItems:dvchartHeader", "Header"), $path: "Header" }), __spreadProps(__spreadValues({}, e15.PlotArea), { Name: t11("reportItems:dvchartPlotArea", "Plot Area"), $path: "PlotArea" }), ...j$e(e15.Plots, t11), ...n10 && [__spreadProps(__spreadValues({}, e15.Legend), { Name: t11("reportItems:dvchartGlobalLegend", "Global Legend"), $path: "Legend" })] || [], __spreadProps(__spreadValues({}, e15.Footer), { Name: t11("reportItems:dvchartFooter", "Footer"), $path: "Footer" })];
      }(e14, t10).map((t11) => K$e(t11, $j(e14.$path, t11.$path)));
    case "dvchartplotarea":
      return function(e15, t11) {
        return [...Z$e(e15.Axes, t11), ...U$e(e15.Legends, t11)];
      }(e14, t10).map((t11) => K$e(t11, $j(e14.$path, t11.$path)));
    case "bandedlist":
    case "fixedpagebandedlist":
      return function(e15) {
        const t11 = r3(e15).map((t12) => {
          const n10 = $j(e15.$path, i3(t12));
          return t12.band.ReportItems.map((e16, t13) => {
            const r10 = Wj(n10, t13);
            return K$e(e16, r10);
          });
        });
        return t11.reduce((e16, t12) => e16.concat(t12), []);
      }(e14);
    default:
      return [];
  }
}
const J$e = ["PageHeader", "PageFooter", "Body", "Page"];
const Q$e = (e14, t10) => {
  var _a2, _b2, _c2;
  return "fixedpagereport" === e14.Type || "multisectionreport" === e14.Type ? t10("reportItems:Report", "Report") : "dashboard" === e14.Type ? t10("reportItems:dashboard", "Dashboard") : "Body" === e14.$path || ((_a2 = e14.$path) == null ? void 0 : _a2.endsWith(".Body")) ? t10("reportItems:body", "Body") : "PageHeader" === e14.$path || ((_b2 = e14.$path) == null ? void 0 : _b2.endsWith(".PageHeader")) ? e14.$dashboard ? t10("reportItems:dashboardPageHeader", "Header") : t10("reportItems:pageHeader", "Page Header") : "PageFooter" === e14.$path || ((_c2 = e14.$path) == null ? void 0 : _c2.endsWith(".PageFooter")) ? e14.$dashboard ? t10("reportItems:dashboardPageFooter", "Footer") : t10("reportItems:pageFooter", "Page Footer") : e14.$path && J$e.includes(e14.$path) ? t10(`reportItems:${e14.$path}`) : e14.Name;
};
const eWe = (e14, t10) => e14.endsWith("PageHeader") ? nf(Aae) : e14.endsWith("PageFooter") ? nf(Bae) : t10 || nf(_ae);
const tWe = (e14, t10, n10, r10) => {
  const o10 = nz.of(n10);
  const a10 = (e15, n11) => {
    const i10 = { name: Q$e(e15, r10), type: e15.Type, selected: rj(e15), path: e15.$path || "" };
    const s10 = X$e(e15, r10).map((e16, t11) => a10(e16, [...n11, "nodes", t11]));
    const { name: l10, type: c10, selected: u10 } = i10;
    const d10 = ((e16, n12) => {
      const r11 = n12.reduce((e17, t11) => e17 && e17[t11], t10);
      return !r11 || r11.value.name !== e16 || r11.expanded;
    })(l10, n11);
    const p10 = o10.getDescriptor(c10);
    return p10 ? { id: l10, text: l10, icon: eWe(i10.path, p10.icon), expanded: d10, selected: u10, value: i10, nodes: s10, customCSS: kp(L$e, H$e(s10.length ? "non-leaf" : "leaf")) } : { id: l10, value: i10 };
  };
  return a10(e14, [0]);
};
const nWe = () => {
  const { content: e14 } = kz();
  const { instanceId: t10 } = qHe();
  const n10 = PA();
  const { t: r10 } = vp();
  const [o10, a10] = ep.useState([]);
  ep.useEffect(() => {
    a10([tWe(e14, o10, t10, r10)]);
  }, [e14]);
  const i10 = { nodes: o10, onNodeClick: ({ value: { path: e15, type: t11 } }) => (r11) => {
    n10((SB(r11) ? l5 : c5)(e15, t11)), n10($$e());
  }, onNodeToggle: (e15) => {
    e15.expanded = !e15.expanded, a10([o10[0]]);
  } };
  return tp.createElement(B$e, __spreadValues({}, i10));
};
const rWe = _V("@core/rdlx/libraries/setAvailable", (e14) => e14);
const oWe = _V("@core/rdlx/libraries/setLoadingRequested");
const aWe = _V("@core/rdlx/libraries/setLibraryLoadingStarted", (e14) => e14);
const iWe = _V("@core/rdlx/libraries/setLibraryLoadingFailed", (e14) => e14);
const sWe = _V("@core/rdlx/libraries/setLibraryInvalid", (e14) => e14);
const lWe = { setAvailableLibraries: rWe, setLibrariesLoadingRequested: oWe, setLibraryLoadingStarted: aWe, setLibraryLoaded: _V("@core/rdlx/libraries/setLibraryLoaded", (e14) => e14), setLibraryLoadingFailed: iWe, setLibraryInvalid: sWe, setLibraryExpanded: _V("@core/rdlx/libraries/setExpanded", (e14) => e14) };
const cWe = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, opacity: "0.62", d: "M6.5 6c-.276 0-.5.224-.5.5s.224.5.5.5h7c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-7ZM6 9.5c0-.276.224-.5.5-.5h4c.276 0 .5.224.5.5s-.224.5-.5.5h-4c-.276 0-.5-.224-.5-.5Zm.5 2.5c-.276 0-.5.224-.5.5s.224.5.5.5h2.707c.099-.349.231-.683.393-1H6.5Z" }), tp.createElement("path", { className: Km.secondary, d: "M9.601 17H8.87c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h.337c.099.349.231.683.394 1ZM16 9.207V8.87c0-.276.224-.5.5-.5s.5.224.5.5v.731c-.317-.163-.651-.295-1-.394ZM14.522 3C15.89 3 17 4.11 17 5.478v1.131c0 .276-.224.5-.5.5s-.5-.224-.5-.5V5.478C16 4.662 15.338 4 14.522 4h-1.131c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h1.131ZM5.478 3h1.131c.276 0 .5.224.5.5s-.224.5-.5.5H5.478C4.662 4 4 4.662 4 5.478v1.131c0 .276-.224.5-.5.5s-.5-.224-.5-.5V5.478C3 4.11 4.11 3 5.478 3ZM4 14.522c0 .815.661 1.477 1.473 1.478H6.609c.276 0 .5.224.5.5s-.224.5-.5.5H5.478C4.11 17 3 15.89 3 14.522v-1.131c0-.276.224-.5.5-.5s.5.224.5.5v1.131ZM11.13 3c.276 0 .5.224.5.5s-.224.5-.5.5H8.87c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h2.26ZM3 8.87c0-.276.224-.5.5-.5s.5.224.5.5v2.26c0 .276-.224.5-.5.5s-.5-.224-.5-.5V8.87Z" }), tp.createElement("path", { className: Km.accent, d: "M12.065 11.442c.304 1.081-.342 2.2-1.43 2.478l-.461.118c-.015.152-.023.306-.023.462 0 .188.011.373.033.554l.349.083c1.12.265 1.786 1.417 1.456 2.519l-.126.423c.257.203.537.377.835.518l.325-.344c.789-.837 2.12-.836 2.909.001l.338.358c.292-.135.567-.302.821-.498l-.156-.556c-.303-1.081.343-2.2 1.431-2.478l.46-.118c.015-.152.023-.306.023-.462 0-.188-.011-.373-.033-.554l-.349-.083c-1.119-.265-1.785-1.417-1.456-2.519l.126-.422c-.257-.204-.537-.378-.834-.518l-.325.343c-.79.837-2.121.836-2.91-.001l-.337-.358c-.292.135-.568.302-.822.497l.156.557ZM14.5 15.5c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1Z" }));
const uWe = tp.createElement("svg", { width: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, opacity: "0.62", d: "M7.339 6H5.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h5c-1.176 0-2.267.37-3.161 1ZM5.601 8H5.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h.759c-.254.307-.475.642-.658 1Z" }), tp.createElement("path", { className: Km.secondary, d: "M14 4.48v1.006c0 .276-.224.5-.5.5s-.5-.224-.5-.5V4.48C13 3.663 12.337 3 11.52 3h-1.006c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h1.006C12.889 2 14 3.111 14 4.48ZM3 11.52c0 .816.662 1.478 1.479 1.48h1.007c.276 0 .5.224.5.5s-.224.5-.5.5H4.48C3.111 14 2 12.889 2 11.52v-1.006c0-.276.224-.5.5-.5s.5.224.5.5v1.006ZM8.503 2c.276 0 .5.224.5.5s-.224.5-.5.5H7.497c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h1.006ZM5.486 2c.276 0 .5.224.5.5s-.224.5-.5.5H4.463c-.808.009-1.461.667-1.463 1.474v1.012c0 .276-.224.5-.5.5s-.5-.224-.5-.5V4.48C2 3.111 3.111 2 4.48 2h1.006ZM2 7.497c0-.276.224-.5.5-.5s.5.224.5.5v1.006c0 .276-.224.5-.5.5s-.5-.224-.5-.5V7.497Z" }), tp.createElement("path", { className: Km.accent, fillRule: "evenodd", d: "M6.635 9.92c1.088-.278 1.734-1.397 1.43-2.478l-.156-.557c.254-.195.53-.362.822-.497l.337.358c.789.837 2.12.838 2.91.001l.325-.343c.297.14.577.314.834.518l-.126.422c-.329 1.102.337 2.254 1.456 2.519l.349.083c.022.181.033.366.033.554 0 .156-.008.31-.023.462l-.46.118c-1.088.278-1.734 1.397-1.431 2.478l.156.556c-.254.196-.529.363-.822.498l-.337-.358c-.789-.837-2.12-.838-2.909-.001l-.325.344c-.298-.141-.578-.315-.835-.518l.126-.423c.33-1.102-.336-2.254-1.456-2.519l-.349-.083c-.022-.181-.033-.366-.033-.554 0-.156.008-.31.023-.462l.461-.118Zm4.865.58c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1Z" }));
const dWe = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, opacity: "0.62", d: "M10 13.126c-.537-.006-1.077.203-1.477.627l-.325.344c-.298-.141-.578-.315-.835-.518l.126-.423c.33-1.102-.336-2.254-1.456-2.519l-.349-.083c-.022-.181-.033-.366-.033-.554 0-.156.008-.31.023-.462l.461-.118c1.088-.278 1.734-1.397 1.43-2.478l-.156-.557c.254-.195.53-.362.822-.497l.337.358c.789.837 2.12.838 2.91.001l.325-.343c.297.14.577.314.834.518l-.126.422c-.329 1.102.337 2.254 1.456 2.519l.349.083c.022.181.033.366.033.554 0 .156-.008.31-.023.462l-.46.118c-.727.185-1.256.746-1.437 1.42h-1.428c-.553 0-1.001.448-1.001 1.001v.125ZM11 10c0-.552-.448-1-1-1s-1 .448-1 1 .448 1 1 1 1-.448 1-1Z" }), tp.createElement("path", { className: Km.secondary, d: "M10 17H8.87c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H10v1Zm6-5V8.87c0-.276.224-.5.5-.5s.5.224.5.5V12h-1Zm-1.478-9C15.89 3 17 4.11 17 5.478v1.131c0 .276-.224.5-.5.5s-.5-.224-.5-.5V5.478C16 4.662 15.338 4 14.522 4h-1.131c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h1.131ZM5.478 3h1.131c.276 0 .5.224.5.5s-.224.5-.5.5H5.478C4.662 4 4 4.662 4 5.478v1.131c0 .276-.224.5-.5.5s-.5-.224-.5-.5V5.478C3 4.11 4.11 3 5.478 3ZM4 14.522c0 .815.661 1.477 1.473 1.478H6.609c.276 0 .5.224.5.5s-.224.5-.5.5H5.478C4.11 17 3 15.89 3 14.522v-1.131c0-.276.224-.5.5-.5s.5.224.5.5v1.131ZM11.13 3c.276 0 .5.224.5.5s-.224.5-.5.5H8.87c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h2.26ZM3 8.87c0-.276.224-.5.5-.5s.5.224.5.5v2.26c0 .276-.224.5-.5.5s-.5-.224-.5-.5V8.87Z" }), tp.createElement("path", { className: Km.accent, d: "M11.5 13c-.276 0-.5.224-.5.5s.224.5.5.5h6c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-6Zm0 2c-.276 0-.5.224-.5.5s.224.5.5.5h6c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-6Zm0 2c-.276 0-.5.224-.5.5s.224.5.5.5h6c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-6Z" }));
const [pWe] = Dp("wd-libraries-item");
const mWe = ({ library: e14, onClick: t10 }) => {
  const { t: n10 } = vp("components");
  let r10;
  const o10 = ELe(e14) && !e14.reportParts.length;
  FLe(e14) && (r10 = { size: "small", level: "error", position: "inline", nearIcon: true, title: e14.errorText, content: n10("libraries.textError", "Error") }), o10 && (r10 = { size: "small", level: "warning", position: "inline", content: n10("libraries.textEmpty", "Empty"), title: n10("libraries.textNoReportParts", "Library contains no report parts") });
  const a10 = { onClick: t10, icon: nf(dWe), text: e14.DisplayName || e14.Name, width: "100%", background: "transparent", disabled: FLe(e14) || o10, badge: r10, customCSS: pWe };
  return tp.createElement(qm, __spreadValues({}, a10));
};
const hWe = (e14) => {
  const [t10, , n10] = Dp("wd-report-parts-libraries-panel-item");
  const [r10] = n10("label");
  const [o10] = n10("icon");
  const { library: { Name: a10, Path: i10, EmbeddedImages: s10 }, reportPart: l10 } = e14;
  const { Name: c10, DisplayName: u10, Description: d10, width: p10, height: m10, dataSets: h10, dataSources: f10, reportParameters: g10, Properties: y10 } = l10;
  const { instanceId: v10 } = Uae();
  const b10 = h9();
  const S10 = PA();
  const C10 = q7(b10);
  const x10 = L0(b10) ? "fixedpagepartitem" : "partitem";
  const w10 = ep.useMemo(() => ({ Width: p10 != null ? p10 : "3in", Height: m10 != null ? m10 : "2in" }), [p10, m10]);
  const T10 = ep.useMemo(() => {
    var _a2;
    return (_a2 = h10.filter(({ Name: e15 }) => !b10.DataSets.some(({ Name: t11 }) => t11 === e15))) != null ? _a2 : [];
  }, [b10, h10]);
  const E10 = ep.useMemo(() => {
    var _a2;
    return (_a2 = f10.filter(({ Name: e15 }) => T10.some(({ Query: { DataSourceName: t11 } }) => t11 === e15))) != null ? _a2 : [];
  }, [T10, f10]);
  const F10 = ep.useMemo(() => {
    var _a2;
    return (_a2 = g10.filter(({ Name: e15 }) => !b10.ReportParameters.some(({ Name: t11 }) => t11 === e15))) != null ? _a2 : [];
  }, [b10, g10]);
  const M10 = !b10.Libraries.some(({ Name: e15 }) => e15 === a10);
  const k10 = ep.useMemo(() => y10.map((e15) => ({ Name: e15.Name, Value: e15.DefaultValue })), [y10]);
  const [, P10, N10] = Yne({ item: { type: "partItem", itemType: x10, partName: c10, library: { Name: a10, Path: i10 }, embeddedImages: s10, partItemProperties: k10, shouldAddLibrary: M10, $place: w10, dataSets: T10, dataSources: E10, reportParameters: F10 } });
  ep.useEffect(() => {
    N10(Coe(), { captureDraggingState: true });
  }, []);
  const D10 = ep.useCallback(() => {
    const e15 = nz.of(v10).create(x10, KB(TG(x10)), void 0, { ReportPart: c10, Library: a10, $place: w10, Properties: k10 });
    const t11 = [KG({ items: [e15] }, { currentLayerName: b10.$currentLayerName, isChildReport: C10 })];
    M10 && t11.push(V2({ library: { Name: a10, Path: i10 }, embeddedImages: s10 })), (E10.length || T10.length) && t11.push(J0({ dataSources: E10, dataSets: T10 })), F10.length && t11.push(e22({ params: F10 })), S10(p2({ actions: t11 }));
  }, [v10, x10, w10, c10, a10, i10, s10, E10, T10, M10, k10, S10]);
  const L10 = nf(uWe);
  const H10 = u10 || c10;
  const I10 = d10 || H10;
  return tp.createElement("div", { ref: P10, className: t10, title: I10, onClick: D10 }, tp.createElement(Fm, { customCSS: o10, icon: L10 }), tp.createElement("span", { className: r10 }, H10));
};
const [fWe, , gWe] = Dp("wd-report-parts-libraries-panel");
const [yWe] = gWe("no-elements-label");
const [vWe] = gWe("content");
const bWe = () => {
  const e14 = PA();
  const { t: t10 } = vp("components");
  const { rdlx: { reportPartsLibraries: { libraries: n10, panel: { expanding: r10 } } } } = d9();
  const o10 = n10.length < 1;
  const a10 = t10("libraries.textNoLibraries", "No available libraries");
  const i10 = n10.some((e15) => TLe(e15));
  const s10 = n10.some((e15) => wLe(e15));
  ep.useEffect(() => {
    !i10 && s10 && e14(lWe.setLibrariesLoadingRequested());
  }, [n10]);
  const l10 = { outline: true, nodes: n10.map((e15) => {
    var _a2;
    return { id: e15.Path, type: "library", library: e15, expanded: (_a2 = r10[e15.Path]) != null ? _a2 : true, nodes: ELe(e15) ? e15.reportParts.map((t11) => ((e16, t12) => ({ id: `${e16.Name}/${t12.Name}`, type: "reportPart", library: e16, reportPart: t12 }))(e15, t11)) : [] };
  }), renderNode: (t11) => {
    switch (t11.type) {
      case "library":
        return tp.createElement(mWe, { library: t11.library, onClick: () => {
          var _a2;
          return n11 = t11.library, void e14(lWe.setLibraryExpanded({ path: n11.Path, isExpanded: !((_a2 = r10[n11.Path]) != null ? _a2 : 1) }));
          var n11;
        } });
      case "reportPart":
        return tp.createElement(hWe, { library: t11.library, reportPart: t11.reportPart });
    }
    return tp.createElement("span", null);
  } };
  return tp.createElement("div", { className: fWe }, tp.createElement(bF, { direction: "vertical" }, tp.createElement("div", { className: vWe }, o10 && tp.createElement("p", { className: yWe }, a10), i10 && tp.createElement(TE, { block: true, level: "info", background: "transparent" }), !i10 && !s10 && tp.createElement(eI, __spreadValues({}, l10)))));
};
bWe.displayName = "ReportPartsLibraries";
const SWe = ["textbox", "checkbox", "inputfield", "line", "shape", "image", "dvchart", "fixedpagedvchart", "bullet", "barcode", "sparkline", "formattedtext", "richtext"];
const CWe = ["bandedlist", "fixedpagebandedlist", "list", "fixedpagelist", "table", "fixedpagetable", "tablix", "fixedpagetablix", "tableofcontents", "fixedpagetableofcontents", "subreport", "fixedpagesubreport", "rectangle", "fixedpagerectangle"];
const xWe = (e14) => {
  if (CWe.includes(e14)) return "Grow";
  if (SWe.includes(e14)) return "Fit";
  throw new Error(`Unable to define size mode for item type "${e14}"`);
};
const wWe = { HEADER: "header", GROUP: "group", DETAILS: "details", HIDDEN_DETAILS: "hidden_details", FOOTER: "footer" };
const TWe = Object.values(wWe);
const EWe = "_web_designer_type";
const FWe = "_web_designer_areas";
const MWe = (e14) => {
  var _a2;
  const t10 = (e14.CustomProperties || []).find((e15) => e15 && e15.Name === FWe);
  if (t10 && t10.Value) {
    const n10 = ((_a2 = t10.Value) == null ? void 0 : _a2.split(",")) || [];
    return n10.every((e15) => TWe.includes(e15)) ? n10 : (console && console.warn(`Areas '${n10.join(",")}' of table ${e14.Name} is not supported`), []);
  }
  return [];
};
const kWe = (e14) => {
  var _a2, _b2, _c2, _d2, _e2;
  const t10 = tz == null ? void 0 : tz.getTemplate("table", e14);
  const n10 = tz == null ? void 0 : tz.getTemplate("textbox");
  const r10 = ((_e2 = (_d2 = (_c2 = (_b2 = (_a2 = t10.Details) != null ? _a2 : t10.Header) != null ? _b2 : t10.Footer) == null ? void 0 : _c2.TableRows[0]) == null ? void 0 : _d2.TableCells[0]) == null ? void 0 : _e2.Item) || n10;
  return r10 == null ? void 0 : r10.Style;
};
const PWe = (e14, t10, n10) => {
  const r10 = tz == null ? void 0 : tz.create("textbox", KB(TG("textbox")));
  const o10 = __spreadValues(__spreadValues({}, r10.Style), kWe(n10));
  return __spreadProps(__spreadValues({}, r10), { $place: __spreadProps(__spreadValues({}, r10.$place), { Width: e14, Height: t10 }), Style: o10 });
};
const NWe = (e14) => {
  const { cellsWidth: t10, cellHeight: n10, createCellItem: r10 } = e14;
  return __spreadProps(__spreadValues({}, u4), { Height: n10, TableCells: t10.map((e15) => ((e16) => {
    const { width: t11, height: n11, createCellItem: r11 } = e16;
    return { Item: r11(t11, n11), ColSpan: 1, RowSpan: 1, AutoMergeMode: "Never" };
  })({ width: e15, height: n10, createCellItem: r10 })) });
};
const DWe = (e14) => e14.Children && e14.Children.length;
const LWe = (e14, t10, n10) => {
  if (!e14.length) return null;
  const r10 = { cellsWidth: t10, cellsHeight: e14.map((e15) => n10[e15.BodyIndex]), createCellItem: PWe };
  const o10 = Object.assign(((e15) => {
    const { cellsWidth: t11, cellsHeight: n11, createCellItem: r11 } = e15;
    return __spreadProps(__spreadValues({}, v4), { RepeatOnNewPage: true, TableRows: n11.map((e16) => NWe({ cellsWidth: t11, cellHeight: e16, createCellItem: r11 })) });
  })(r10), { RepeatOnNewPage: e14.some((e15) => "statictablixmember" === e15.Type && e15.RepeatOnNewPage) });
  return o10;
};
const HWe = (e14, t10, n10) => {
  if (!e14.length) return null;
  const r10 = { cellsWidth: t10, cellsHeight: e14.map((e15) => n10[e15.BodyIndex]), createCellItem: PWe };
  const o10 = Object.assign(((e15) => {
    const { cellsWidth: t11, cellsHeight: n11, createCellItem: r11 } = e15;
    return __spreadProps(__spreadValues({}, D4), { TableRows: n11.map((e16) => NWe({ cellsWidth: t11, cellHeight: e16, createCellItem: r11 })) });
  })(r10), { RepeatOnNewPage: e14.some((e15) => "statictablixmember" === e15.Type && e15.RepeatOnNewPage) });
  return o10;
};
const IWe = (e14, t10, n10) => {
  if (!e14) return null;
  const r10 = DWe(e14) ? e14.Children.map((e15) => n10[e15.BodyIndex]) : [n10[e14.BodyIndex]];
  const o10 = ((e15) => {
    const { cellsWidth: t11, cellsHeight: n11, createCellItem: r11 } = e15;
    return __spreadProps(__spreadValues({}, h4), { TableRows: n11.map((e16) => NWe({ cellsWidth: t11, cellHeight: e16, createCellItem: r11 })) });
  })({ cellsWidth: t10, cellsHeight: r10, createCellItem: PWe });
  const a10 = "dynamictablixmember" === e14.Type && e14.SortExpressions;
  return __spreadProps(__spreadValues({}, o10), { Group: e14.Group, Visibility: e14.Visibility, SortExpressions: a10 });
};
const _We = (e14, t10) => {
  const n10 = [];
  const r10 = [];
  return e14.forEach((e15) => {
    "statictablixmember" === e15.Type && (e15.BodyIndex < t10 ? n10.push(e15) : r10.push(e15));
  }), { headers: n10, footers: r10 };
};
const VWe = (e14, t10) => {
  e14.forEach((e15) => {
    t10(e15), DWe(e15) && VWe(e15.Children, t10);
  });
};
const RWe = (e14) => {
  const t10 = MWe(e14);
  const n10 = e14.$rows.collection.map((e15) => e15.Height);
  const r10 = e14.$columns.collection.map((e15) => e15.Width);
  const o10 = t10.findIndex((e15) => e15 === wWe.DETAILS || e15 === wWe.HIDDEN_DETAILS);
  const { headers: a10, footers: i10 } = _We(e14.RowHierarchy.Members, o10);
  const { tableDetailsTablixMember: s10, tableGroupTablixMembers: l10 } = ((e15, t11, n11) => {
    let r11 = null;
    const o11 = [];
    return VWe(e15.RowHierarchy.Members, (e16) => {
      if ("dynamictablixmember" === e16.Type) if (DWe(e16)) if (n11[e16.Children[0].BodyIndex] === wWe.DETAILS) r11 = e16;
      else {
        const { headers: n12, footers: r12 } = _We(e16.Children, t11);
        o11.push({ member: e16, headers: n12, footers: r12 });
      }
      else n11[e16.BodyIndex] === wWe.DETAILS ? r11 = e16 : e16.BodyIndex < t11 ? o11.push({ member: e16, headers: [e16], footers: [] }) : o11.push({ member: e16, headers: [], footers: [e16] });
    }), { tableDetailsTablixMember: r11, tableGroupTablixMembers: o11 };
  })(e14, o10, t10);
  const c10 = [];
  l10.forEach(({ member: e15, headers: t11, footers: o11 }) => {
    const a11 = ((e16, t12, n11, r11, o12) => {
      const a12 = __spreadProps(__spreadValues({}, _4), { Header: LWe(t12, r11, o12), Footer: HWe(n11, r11, o12) });
      return "dynamictablixmember" === e16.Type && (a12.SortExpressions = e16.SortExpressions), "statictablixmember" === e16.Type && (a12.PreventOrphanedFooter = "None" !== e16.KeepWithGroup), a12.Group = e16.Group, a12.KeepTogether = e16.KeepTogether, a12.Visibility = e16.Visibility, a12;
    })(e15, t11, o11, r10, n10);
    c10.push(a11);
  });
  const u10 = LWe(a10, r10, n10);
  const d10 = HWe(i10, r10, n10);
  const p10 = IWe(s10, r10, n10);
  const m10 = r10.map((e15) => X5({ Width: e15 }));
  let h10 = __spreadValues({}, W5);
  return ["Name", "$place", "FrozenColumns", "FrozenRows", "RepeatToFill", "DataSetName", "DataSetParameters", "Filters", "FixedHeight", "FixedWidth", "NewSection", "NoRows", "OverflowName", "PageBreak", "ZIndex", "Visibility", "LayerName", "KeepTogether", "ToolTip", "Label", "Bookmark", "DataElementName", "DataElementOutput", "ReportStyle", "Style"].forEach((t11) => {
    void 0 !== e14[t11] && (h10[t11] = e14[t11]);
  }), s10 && (h10.DetailDataElementName = s10.DataElementName, h10.DetailDataElementOutput = s10.DataElementOutput), h10.Header = u10, h10.Footer = d10, h10.Details = p10, h10.TableGroups = c10, h10.TableColumns = m10, h10 = qQ(h10, (t11, n11) => {
    const r11 = t11.TableCells.map((t12, r12) => {
      const o11 = e14.Body.Rows[n11].Cells[r12];
      return o11 ? __spreadProps(__spreadValues({}, t12), { Item: o11.Item, ColSpan: o11.ColSpan, AutoMergeMode: o11.AutoMergeMode }) : null;
    });
    return __spreadProps(__spreadValues({}, t11), { TableCells: r11 });
  }), h10;
};
var AWe = {};
/*!
 * assertion-error
 * Copyright(c) 2013 Jake Luer <jake@qualiancy.com>
 * MIT Licensed
 */
/*!
 * Return a function that will copy properties from
 * one object to another excluding any originally
 * listed. Returned function will create a new `{}`.
 *
 * @param {String} excluded properties ...
 * @return {Function}
 */
function OWe() {
  var e14 = [].slice.call(arguments);
  function t10(t11, n10) {
    Object.keys(n10).forEach(function(r10) {
      ~e14.indexOf(r10) || (t11[r10] = n10[r10]);
    });
  }
  return function() {
    var e15 = [].slice.call(arguments), n10 = 0, r10 = {};
    for (; n10 < e15.length; n10++) t10(r10, e15[n10]);
    return r10;
  };
}
/*!
 * Primary Exports
 */
var BWe = zWe;
function zWe(e14, t10, n10) {
  var r10 = OWe("name", "message", "stack", "constructor", "toJSON")(t10 || {});
  for (var o10 in this.message = e14 || "Unspecified AssertionError", this.showDiff = false, r10) this[o10] = r10[o10];
  if (n10 = n10 || zWe, Error.captureStackTrace) Error.captureStackTrace(this, n10);
  else try {
    throw new Error();
  } catch (e15) {
    this.stack = e15.stack;
  }
}
/*!
 * Inherit from Error.prototype
 */
zWe.prototype = Object.create(Error.prototype), /*!
 * Statically set name
 */
zWe.prototype.name = "AssertionError", /*!
 * Ensure correct constructor
 */
zWe.prototype.constructor = zWe, zWe.prototype.toJSON = function(e14) {
  var t10 = OWe("constructor", "toJSON", "stack")({ name: this.name }, this);
  return false !== e14 && this.stack && (t10.stack = this.stack), t10;
};
var $We = {};
function WWe(e14, t10) {
  return null != e14 && t10 in Object(e14);
}
function jWe(e14) {
  return e14.replace(/([^\\])\[/g, "$1.[").match(/(\\\.|[^.]+?)+/g).map(function(e15) {
    if ("constructor" === e15 || "__proto__" === e15 || "prototype" === e15) return {};
    var t10 = /^\[(\d+)\]$/.exec(e15);
    return t10 ? { i: parseFloat(t10[1]) } : { p: e15.replace(/\\([.[\]])/g, "$1") };
  });
}
function ZWe(e14, t10, n10) {
  var r10 = e14;
  var o10 = null;
  n10 = void 0 === n10 ? t10.length : n10;
  for (var a10 = 0; a10 < n10; a10++) {
    var i10 = t10[a10];
    r10 && (r10 = void 0 === i10.p ? r10[i10.i] : r10[i10.p], a10 === n10 - 1 && (o10 = r10));
  }
  return o10;
}
function GWe(e14, t10) {
  var n10 = jWe(t10);
  var r10 = n10[n10.length - 1];
  var o10 = { parent: n10.length > 1 ? ZWe(e14, n10, n10.length - 1) : e14, name: r10.p || r10.i, value: ZWe(e14, n10) };
  return o10.exists = WWe(o10.parent, o10.name), o10;
}
var UWe = { hasProperty: WWe, getPathInfo: GWe, getPathValue: function(e14, t10) {
  return GWe(e14, t10).value;
}, setPathValue: function(e14, t10, n10) {
  return function(e15, t11, n11) {
    var r10 = e15;
    var o10 = n11.length;
    var a10 = null;
    for (var i10 = 0; i10 < o10; i10++) {
      var s10 = null;
      var l10 = null;
      if (a10 = n11[i10], i10 === o10 - 1) r10[s10 = void 0 === a10.p ? a10.i : a10.p] = t11;
      else if (void 0 !== a10.p && r10[a10.p]) r10 = r10[a10.p];
      else if (void 0 !== a10.i && r10[a10.i]) r10 = r10[a10.i];
      else {
        var c10 = n11[i10 + 1];
        s10 = void 0 === a10.p ? a10.i : a10.p, l10 = void 0 === c10.p ? [] : {}, r10[s10] = l10, r10 = r10[s10];
      }
    }
  }(e14, n10, jWe(t10)), e14;
} };
/*!
 * Chai - flag utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
var qWe = function(e14, t10, n10) {
  var r10 = e14.__flags || (e14.__flags = /* @__PURE__ */ Object.create(null));
  if (3 !== arguments.length) return r10[t10];
  r10[t10] = n10;
};
/*!
 * Chai - test utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
/*!
 * Module dependencies
 */
var YWe = qWe;
var KWe = function(e14, t10) {
  var n10 = YWe(e14, "negate"), r10 = t10[0];
  return n10 ? !r10 : r10;
};
var XWe = { exports: {} };
XWe.exports = function() {
  var e14 = "function" == typeof Promise;
  var t10 = "object" == typeof self ? self : $;
  var n10 = "undefined" != typeof Symbol;
  var r10 = "undefined" != typeof Map;
  var o10 = "undefined" != typeof Set;
  var a10 = "undefined" != typeof WeakMap;
  var i10 = "undefined" != typeof WeakSet;
  var s10 = "undefined" != typeof DataView;
  var l10 = n10 && void 0 !== Symbol.iterator;
  var c10 = n10 && void 0 !== Symbol.toStringTag;
  var u10 = o10 && "function" == typeof Set.prototype.entries;
  var d10 = r10 && "function" == typeof Map.prototype.entries;
  var p10 = u10 && Object.getPrototypeOf((/* @__PURE__ */ new Set()).entries());
  var m10 = d10 && Object.getPrototypeOf((/* @__PURE__ */ new Map()).entries());
  var h10 = l10 && "function" == typeof Array.prototype[Symbol.iterator];
  var f10 = h10 && Object.getPrototypeOf([][Symbol.iterator]());
  var g10 = l10 && "function" == typeof String.prototype[Symbol.iterator];
  var y10 = g10 && Object.getPrototypeOf(""[Symbol.iterator]());
  var v10 = 8;
  var b10 = -1;
  function S10(n11) {
    var l11 = typeof n11;
    if ("object" !== l11) return l11;
    if (null === n11) return "null";
    if (n11 === t10) return "global";
    if (Array.isArray(n11) && (false === c10 || !(Symbol.toStringTag in n11))) return "Array";
    if ("object" == typeof window && null !== window) {
      if ("object" == typeof window.location && n11 === window.location) return "Location";
      if ("object" == typeof window.document && n11 === window.document) return "Document";
      if ("object" == typeof window.navigator) {
        if ("object" == typeof window.navigator.mimeTypes && n11 === window.navigator.mimeTypes) return "MimeTypeArray";
        if ("object" == typeof window.navigator.plugins && n11 === window.navigator.plugins) return "PluginArray";
      }
      if (("function" == typeof window.HTMLElement || "object" == typeof window.HTMLElement) && n11 instanceof window.HTMLElement) {
        if ("BLOCKQUOTE" === n11.tagName) return "HTMLQuoteElement";
        if ("TD" === n11.tagName) return "HTMLTableDataCellElement";
        if ("TH" === n11.tagName) return "HTMLTableHeaderCellElement";
      }
    }
    var u11 = c10 && n11[Symbol.toStringTag];
    if ("string" == typeof u11) return u11;
    var d11 = Object.getPrototypeOf(n11);
    return d11 === RegExp.prototype ? "RegExp" : d11 === Date.prototype ? "Date" : e14 && d11 === Promise.prototype ? "Promise" : o10 && d11 === Set.prototype ? "Set" : r10 && d11 === Map.prototype ? "Map" : i10 && d11 === WeakSet.prototype ? "WeakSet" : a10 && d11 === WeakMap.prototype ? "WeakMap" : s10 && d11 === DataView.prototype ? "DataView" : r10 && d11 === m10 ? "Map Iterator" : o10 && d11 === p10 ? "Set Iterator" : h10 && d11 === f10 ? "Array Iterator" : g10 && d11 === y10 ? "String Iterator" : null === d11 ? "Object" : Object.prototype.toString.call(n11).slice(v10, b10);
  }
  return S10;
}();
var JWe = XWe.exports;
/*!
 * Chai - expectTypes utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
var QWe = BWe;
var eje = qWe;
var tje = JWe;
var nje = function(e14, t10) {
  var n10 = eje(e14, "message");
  var r10 = eje(e14, "ssfi");
  n10 = n10 ? n10 + ": " : "", e14 = eje(e14, "object"), t10 = t10.map(function(e15) {
    return e15.toLowerCase();
  }), t10.sort();
  var o10 = t10.map(function(e15, n11) {
    var r11 = ~["a", "e", "i", "o", "u"].indexOf(e15.charAt(0)) ? "an" : "a";
    return (t10.length > 1 && n11 === t10.length - 1 ? "or " : "") + r11 + " " + e15;
  }).join(", ");
  var a10 = tje(e14).toLowerCase();
  if (!t10.some(function(e15) {
    return a10 === e15;
  })) throw new QWe(n10 + "object tested must be " + o10 + ", but " + a10 + " given", void 0, r10);
};
/*!
 * Chai - getActual utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
var rje = function(e14, t10) {
  return t10.length > 4 ? t10[4] : e14._obj;
};
var oje = Function.prototype.toString;
var aje = /\s*function(?:\s|\s*\/\*[^(?:*\/)]+\*\/\s*)*([^\s\(\/]+)/;
var ije = function(e14) {
  if ("function" != typeof e14) return null;
  var t10 = "";
  if (void 0 === Function.prototype.name && void 0 === e14.name) {
    var n10 = oje.call(e14);
    if (n10.indexOf("(") > 512) return t10;
    var r10 = n10.match(aje);
    r10 && (t10 = r10[1]);
  } else t10 = e14.name;
  return t10;
};
var sje = { exports: {} };
var lje = j(Object.freeze({ __proto__: null, default: {} }));
!function(e14) {
  function t10(e15) {
    return t10 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e16) {
      return typeof e16;
    } : function(e16) {
      return e16 && "function" == typeof Symbol && e16.constructor === Symbol && e16 !== Symbol.prototype ? "symbol" : typeof e16;
    }, t10(e15);
  }
  function n10(e15, t11) {
    return r10(e15) || o10(e15, t11) || a10(e15, t11) || s10();
  }
  function r10(e15) {
    if (Array.isArray(e15)) return e15;
  }
  function o10(e15, t11) {
    if ("undefined" != typeof Symbol && Symbol.iterator in Object(e15)) {
      var n11 = [];
      var r11 = true;
      var o11 = false;
      var a11 = void 0;
      try {
        for (var i11, s11 = e15[Symbol.iterator](); !(r11 = (i11 = s11.next()).done) && (n11.push(i11.value), !t11 || n11.length !== t11); r11 = true) ;
      } catch (e16) {
        o11 = true, a11 = e16;
      } finally {
        try {
          r11 || null == s11.return || s11.return();
        } finally {
          if (o11) throw a11;
        }
      }
      return n11;
    }
  }
  function a10(e15, t11) {
    if (e15) {
      if ("string" == typeof e15) return i10(e15, t11);
      var n11 = Object.prototype.toString.call(e15).slice(8, -1);
      return "Object" === n11 && e15.constructor && (n11 = e15.constructor.name), "Map" === n11 || "Set" === n11 ? Array.from(e15) : "Arguments" === n11 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n11) ? i10(e15, t11) : void 0;
    }
  }
  function i10(e15, t11) {
    (null == t11 || t11 > e15.length) && (t11 = e15.length);
    for (var n11 = 0, r11 = new Array(t11); n11 < t11; n11++) r11[n11] = e15[n11];
    return r11;
  }
  function s10() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var l10 = { bold: ["1", "22"], dim: ["2", "22"], italic: ["3", "23"], underline: ["4", "24"], inverse: ["7", "27"], hidden: ["8", "28"], strike: ["9", "29"], black: ["30", "39"], red: ["31", "39"], green: ["32", "39"], yellow: ["33", "39"], blue: ["34", "39"], magenta: ["35", "39"], cyan: ["36", "39"], white: ["37", "39"], brightblack: ["30;1", "39"], brightred: ["31;1", "39"], brightgreen: ["32;1", "39"], brightyellow: ["33;1", "39"], brightblue: ["34;1", "39"], brightmagenta: ["35;1", "39"], brightcyan: ["36;1", "39"], brightwhite: ["37;1", "39"], grey: ["90", "39"] };
  var c10 = { special: "cyan", number: "yellow", bigint: "yellow", boolean: "yellow", undefined: "grey", null: "bold", string: "green", symbol: "green", date: "magenta", regexp: "red" };
  var u10 = "\u2026";
  function d10(e15, t11) {
    var n11 = l10[c10[t11]] || l10[t11];
    return n11 ? "\x1B[".concat(n11[0], "m").concat(String(e15), "\x1B[").concat(n11[1], "m") : String(e15);
  }
  function p10() {
    var e15 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t11 = e15.showHidden, n11 = void 0 !== t11 && t11, r11 = e15.depth, o11 = void 0 === r11 ? 2 : r11, a11 = e15.colors, i11 = void 0 !== a11 && a11, s11 = e15.customInspect, l11 = void 0 === s11 || s11, c11 = e15.showProxy, u11 = void 0 !== c11 && c11, p11 = e15.maxArrayLength, m11 = void 0 === p11 ? 1 / 0 : p11, h11 = e15.breakLength, f11 = void 0 === h11 ? 1 / 0 : h11, g11 = e15.seen, y11 = void 0 === g11 ? [] : g11, v11 = e15.truncate, b11 = void 0 === v11 ? 1 / 0 : v11, S11 = e15.stylize, C11 = void 0 === S11 ? String : S11;
    var x11 = { showHidden: Boolean(n11), depth: Number(o11), colors: Boolean(i11), customInspect: Boolean(l11), showProxy: Boolean(u11), maxArrayLength: Number(m11), breakLength: Number(f11), truncate: Number(b11), seen: y11, stylize: C11 };
    return x11.colors && (x11.stylize = d10), x11;
  }
  function m10(e15, t11) {
    var n11 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : u10;
    e15 = String(e15);
    var r11 = n11.length;
    var o11 = e15.length;
    return r11 > t11 && o11 > r11 ? n11 : o11 > t11 && o11 > r11 ? "".concat(e15.slice(0, t11 - r11)).concat(n11) : e15;
  }
  function h10(e15, t11, n11) {
    var r11 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : ", ";
    n11 = n11 || t11.inspect;
    var o11 = e15.length;
    if (0 === o11) return "";
    var a11 = t11.truncate;
    var i11 = "";
    var s11 = "";
    var l11 = "";
    for (var c11 = 0; c11 < o11; c11 += 1) {
      var d11 = c11 + 1 === e15.length;
      var p11 = c11 + 2 === e15.length;
      l11 = "".concat(u10, "(").concat(e15.length - c11, ")");
      var m11 = e15[c11];
      t11.truncate = a11 - i11.length - (d11 ? 0 : r11.length);
      var h11 = s11 || n11(m11, t11) + (d11 ? "" : r11);
      var f11 = i11.length + h11.length;
      var g11 = f11 + l11.length;
      if (d11 && f11 > a11 && i11.length + l11.length <= a11) break;
      if (!d11 && !p11 && g11 > a11) break;
      if (s11 = d11 ? "" : n11(e15[c11 + 1], t11) + (p11 ? "" : r11), !d11 && p11 && g11 > a11 && f11 + s11.length > a11) break;
      if (i11 += h11, !d11 && !p11 && f11 + s11.length >= a11) {
        l11 = "".concat(u10, "(").concat(e15.length - c11 - 1, ")");
        break;
      }
      l11 = "";
    }
    return "".concat(i11).concat(l11);
  }
  function f10(e15) {
    return e15.match(/^[a-zA-Z_][a-zA-Z_0-9]*$/) ? e15 : JSON.stringify(e15).replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
  }
  function g10(e15, t11) {
    var r11 = n10(e15, 2), o11 = r11[0], a11 = r11[1];
    return t11.truncate -= 2, "string" == typeof o11 ? o11 = f10(o11) : "number" != typeof o11 && (o11 = "[".concat(t11.inspect(o11, t11), "]")), t11.truncate -= o11.length, a11 = t11.inspect(a11, t11), "".concat(o11, ": ").concat(a11);
  }
  function y10(e15, t11) {
    var n11 = Object.keys(e15).slice(e15.length);
    if (!e15.length && !n11.length) return "[]";
    t11.truncate -= 4;
    var r11 = h10(e15, t11);
    t11.truncate -= r11.length;
    var o11 = "";
    return n11.length && (o11 = h10(n11.map(function(t12) {
      return [t12, e15[t12]];
    }), t11, g10)), "[ ".concat(r11).concat(o11 ? ", ".concat(o11) : "", " ]");
  }
  var v10 = Function.prototype.toString;
  var b10 = /\s*function(?:\s|\s*\/\*[^(?:*\/)]+\*\/\s*)*([^\s\(\/]+)/;
  var S10 = 512;
  function C10(e15) {
    if ("function" != typeof e15) return null;
    var t11 = "";
    if (void 0 === Function.prototype.name && void 0 === e15.name) {
      var n11 = v10.call(e15);
      if (n11.indexOf("(") > S10) return t11;
      var r11 = n11.match(b10);
      r11 && (t11 = r11[1]);
    } else t11 = e15.name;
    return t11;
  }
  var x10 = C10;
  var w10 = function(e15) {
    return "function" == typeof Buffer && e15 instanceof Buffer ? "Buffer" : e15[Symbol.toStringTag] ? e15[Symbol.toStringTag] : x10(e15.constructor);
  };
  function T10(e15, t11) {
    var n11 = w10(e15);
    t11.truncate -= n11.length + 4;
    var r11 = Object.keys(e15).slice(e15.length);
    if (!e15.length && !r11.length) return "".concat(n11, "[]");
    var o11 = "";
    for (var a11 = 0; a11 < e15.length; a11++) {
      var i11 = "".concat(t11.stylize(m10(e15[a11], t11.truncate), "number")).concat(a11 === e15.length - 1 ? "" : ", ");
      if (t11.truncate -= i11.length, e15[a11] !== e15.length && t11.truncate <= 3) {
        o11 += "".concat(u10, "(").concat(e15.length - e15[a11] + 1, ")");
        break;
      }
      o11 += i11;
    }
    var s11 = "";
    return r11.length && (s11 = h10(r11.map(function(t12) {
      return [t12, e15[t12]];
    }), t11, g10)), "".concat(n11, "[ ").concat(o11).concat(s11 ? ", ".concat(s11) : "", " ]");
  }
  function E10(e15, t11) {
    var n11 = e15.toJSON();
    if (null === n11) return "Invalid Date";
    var r11 = n11.split("T");
    var o11 = r11[0];
    return t11.stylize("".concat(o11, "T").concat(m10(r11[1], t11.truncate - o11.length - 1)), "date");
  }
  function F10(e15, t11) {
    var n11 = x10(e15);
    return n11 ? t11.stylize("[Function ".concat(m10(n11, t11.truncate - 11), "]"), "special") : t11.stylize("[Function]", "special");
  }
  function M10(e15, t11) {
    var r11 = n10(e15, 2), o11 = r11[0], a11 = r11[1];
    return t11.truncate -= 4, o11 = t11.inspect(o11, t11), t11.truncate -= o11.length, a11 = t11.inspect(a11, t11), "".concat(o11, " => ").concat(a11);
  }
  function k10(e15) {
    var t11 = [];
    return e15.forEach(function(e16, n11) {
      t11.push([n11, e16]);
    }), t11;
  }
  function P10(e15, t11) {
    return e15.size - 1 <= 0 ? "Map{}" : (t11.truncate -= 7, "Map{ ".concat(h10(k10(e15), t11, M10), " }"));
  }
  var N10 = Number.isNaN || function(e15) {
    return e15 != e15;
  };
  function D10(e15, t11) {
    return N10(e15) ? t11.stylize("NaN", "number") : e15 === 1 / 0 ? t11.stylize("Infinity", "number") : e15 === -1 / 0 ? t11.stylize("-Infinity", "number") : 0 === e15 ? t11.stylize(1 / e15 == 1 / 0 ? "+0" : "-0", "number") : t11.stylize(m10(e15, t11.truncate), "number");
  }
  function L10(e15, t11) {
    var n11 = m10(e15.toString(), t11.truncate - 1);
    return n11 !== u10 && (n11 += "n"), t11.stylize(n11, "bigint");
  }
  function H10(e15, t11) {
    var n11 = e15.toString().split("/")[2];
    var r11 = t11.truncate - (2 + n11.length);
    var o11 = e15.source;
    return t11.stylize("/".concat(m10(o11, r11), "/").concat(n11), "regexp");
  }
  function I10(e15) {
    var t11 = [];
    return e15.forEach(function(e16) {
      t11.push(e16);
    }), t11;
  }
  function _10(e15, t11) {
    return 0 === e15.size ? "Set{}" : (t11.truncate -= 7, "Set{ ".concat(h10(I10(e15), t11), " }"));
  }
  var V10 = new RegExp("['\\u0000-\\u001f\\u007f-\\u009f\\u00ad\\u0600-\\u0604\\u070f\\u17b4\\u17b5\\u200c-\\u200f\\u2028-\\u202f\\u2060-\\u206f\\ufeff\\ufff0-\\uffff]", "g");
  var R10 = { "\b": "\\b", "	": "\\t", "\n": "\\n", "\f": "\\f", "\r": "\\r", "'": "\\'", "\\": "\\\\" };
  var A10 = 16;
  var O10 = 4;
  function B10(e15) {
    return R10[e15] || "\\u".concat("0000".concat(e15.charCodeAt(0).toString(A10)).slice(-O10));
  }
  function z10(e15, t11) {
    return V10.test(e15) && (e15 = e15.replace(V10, B10)), t11.stylize("'".concat(m10(e15, t11.truncate - 2), "'"), "string");
  }
  function $10(e15) {
    return "description" in Symbol.prototype ? e15.description ? "Symbol(".concat(e15.description, ")") : "Symbol()" : e15.toString();
  }
  var W10 = function() {
    return "Promise{\u2026}";
  };
  try {
    var j10 = process.binding("util"), Z10 = j10.getPromiseDetails, G10 = j10.kPending, U10 = j10.kRejected;
    Array.isArray(Z10(Promise.resolve())) && (W10 = function(e15, t11) {
      var r11 = n10(Z10(e15), 2), o11 = r11[0], a11 = r11[1];
      return o11 === G10 ? "Promise{<pending>}" : "Promise".concat(o11 === U10 ? "!" : "", "{").concat(t11.inspect(a11, t11), "}");
    });
  } catch (e15) {
  }
  var q10 = W10;
  function Y10(e15, t11) {
    var n11 = Object.getOwnPropertyNames(e15);
    var r11 = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e15) : [];
    if (0 === n11.length && 0 === r11.length) return "{}";
    if (t11.truncate -= 4, t11.seen = t11.seen || [], t11.seen.indexOf(e15) >= 0) return "[Circular]";
    t11.seen.push(e15);
    var o11 = h10(n11.map(function(t12) {
      return [t12, e15[t12]];
    }), t11, g10);
    var a11 = h10(r11.map(function(t12) {
      return [t12, e15[t12]];
    }), t11, g10);
    t11.seen.pop();
    var i11 = "";
    return o11 && a11 && (i11 = ", "), "{ ".concat(o11).concat(i11).concat(a11, " }");
  }
  var K10 = !("undefined" == typeof Symbol || !Symbol.toStringTag) && Symbol.toStringTag;
  function X10(e15, t11) {
    var n11 = "";
    return K10 && K10 in e15 && (n11 = e15[K10]), (n11 = n11 || x10(e15.constructor)) && "_class" !== n11 || (n11 = "<Anonymous Class>"), t11.truncate -= n11.length, "".concat(n11).concat(Y10(e15, t11));
  }
  function J10(e15, t11) {
    return 0 === e15.length ? "Arguments[]" : (t11.truncate -= 13, "Arguments[ ".concat(h10(e15, t11), " ]"));
  }
  var Q10 = ["stack", "line", "column", "name", "message", "fileName", "lineNumber", "columnNumber", "number", "description"];
  function ee2(e15, t11) {
    var n11 = Object.getOwnPropertyNames(e15).filter(function(e16) {
      return -1 === Q10.indexOf(e16);
    });
    var r11 = e15.name;
    t11.truncate -= r11.length;
    var o11 = "";
    "string" == typeof e15.message ? o11 = m10(e15.message, t11.truncate) : n11.unshift("message"), o11 = o11 ? ": ".concat(o11) : "", t11.truncate -= o11.length + 5;
    var a11 = h10(n11.map(function(t12) {
      return [t12, e15[t12]];
    }), t11, g10);
    return "".concat(r11).concat(o11).concat(a11 ? " { ".concat(a11, " }") : "");
  }
  function te2(e15, t11) {
    var r11 = n10(e15, 2), o11 = r11[0], a11 = r11[1];
    return t11.truncate -= 3, a11 ? "".concat(t11.stylize(o11, "yellow"), "=").concat(t11.stylize('"'.concat(a11, '"'), "string")) : "".concat(t11.stylize(o11, "yellow"));
  }
  function ne2(e15, t11) {
    return h10(e15, t11, re2, "\n");
  }
  function re2(e15, t11) {
    var n11 = e15.getAttributeNames();
    var r11 = e15.tagName.toLowerCase();
    var o11 = t11.stylize("<".concat(r11), "special");
    var a11 = t11.stylize(">", "special");
    var i11 = t11.stylize("</".concat(r11, ">"), "special");
    t11.truncate -= 2 * r11.length + 5;
    var s11 = "";
    n11.length > 0 && (s11 += " ", s11 += h10(n11.map(function(t12) {
      return [t12, e15.getAttribute(t12)];
    }), t11, te2, " ")), t11.truncate -= s11.length;
    var l11 = t11.truncate;
    var c11 = ne2(e15.children, t11);
    return c11 && c11.length > l11 && (c11 = "".concat(u10, "(").concat(e15.children.length, ")")), "".concat(o11).concat(s11).concat(a11).concat(c11).concat(i11);
  }
  var oe2 = "function" == typeof Symbol && "function" == typeof Symbol.for ? Symbol.for("chai/inspect") : "@@chai/inspect";
  var ae2 = false;
  try {
    var ie2 = lje;
    ae2 = !!ie2.inspect && ie2.inspect.custom;
  } catch (e15) {
    ae2 = false;
  }
  function se2() {
    this.key = "chai/loupe__" + Math.random() + Date.now();
  }
  se2.prototype = { get: function(e15) {
    return e15[this.key];
  }, has: function(e15) {
    return this.key in e15;
  }, set: function(e15, t11) {
    Object.isExtensible(e15) && Object.defineProperty(e15, this.key, { value: t11, configurable: true });
  } };
  var le2 = new ("function" == typeof WeakMap ? WeakMap : se2)();
  var ce2 = {};
  var ue2 = { undefined: function(e15, t11) {
    return t11.stylize("undefined", "undefined");
  }, null: function(e15, t11) {
    return t11.stylize(null, "null");
  }, boolean: function(e15, t11) {
    return t11.stylize(e15, "boolean");
  }, Boolean: function(e15, t11) {
    return t11.stylize(e15, "boolean");
  }, number: D10, Number: D10, bigint: L10, BigInt: L10, string: z10, String: z10, function: F10, Function: F10, symbol: $10, Symbol: $10, Array: y10, Date: E10, Map: P10, Set: _10, RegExp: H10, Promise: q10, WeakSet: function(e15, t11) {
    return t11.stylize("WeakSet{\u2026}", "special");
  }, WeakMap: function(e15, t11) {
    return t11.stylize("WeakMap{\u2026}", "special");
  }, Arguments: J10, Int8Array: T10, Uint8Array: T10, Uint8ClampedArray: T10, Int16Array: T10, Uint16Array: T10, Int32Array: T10, Uint32Array: T10, Float32Array: T10, Float64Array: T10, Generator: function() {
    return "";
  }, DataView: function() {
    return "";
  }, ArrayBuffer: function() {
    return "";
  }, Error: ee2, HTMLCollection: ne2, NodeList: ne2 };
  var de2 = function(e15, t11, n11) {
    return oe2 in e15 && "function" == typeof e15[oe2] ? e15[oe2](t11) : ae2 && ae2 in e15 && "function" == typeof e15[ae2] ? e15[ae2](t11.depth, t11) : "inspect" in e15 && "function" == typeof e15.inspect ? e15.inspect(t11.depth, t11) : "constructor" in e15 && le2.has(e15.constructor) ? le2.get(e15.constructor)(e15, t11) : ce2[n11] ? ce2[n11](e15, t11) : "";
  };
  var pe2 = Object.prototype.toString;
  function me2(e15, n11) {
    (n11 = p10(n11)).inspect = me2;
    var r11 = n11.customInspect;
    var o11 = null === e15 ? "null" : t10(e15);
    if ("object" === o11 && (o11 = pe2.call(e15).slice(8, -1)), ue2[o11]) return ue2[o11](e15, n11);
    if (r11 && e15) {
      var a11 = de2(e15, n11, o11);
      if (a11) return "string" == typeof a11 ? a11 : me2(a11, n11);
    }
    var i11 = !!e15 && Object.getPrototypeOf(e15);
    return i11 === Object.prototype || null === i11 ? Y10(e15, n11) : e15 && "function" == typeof HTMLElement && e15 instanceof HTMLElement ? re2(e15, n11) : "constructor" in e15 ? e15.constructor !== Object ? X10(e15, n11) : Y10(e15, n11) : e15 === Object(e15) ? Y10(e15, n11) : n11.stylize(String(e15), o11);
  }
  function he2(e15, t11) {
    return !le2.has(e15) && (le2.set(e15, t11), true);
  }
  function fe2(e15, t11) {
    return !(e15 in ce2) && (ce2[e15] = t11, true);
  }
  var ge2 = oe2;
  e14.custom = ge2, e14.default = me2, e14.inspect = me2, e14.registerConstructor = he2, e14.registerStringTag = fe2, Object.defineProperty(e14, "__esModule", { value: true });
}(sje.exports);
var cje = { includeStack: false, showDiff: true, truncateThreshold: 40, useProxy: true, proxyExcludedKeys: ["then", "catch", "inspect", "toJSON"], deepEqual: null };
var uje = sje.exports;
var dje = cje;
var pje = function(e14, t10, n10, r10) {
  var o10 = { colors: r10, depth: void 0 === n10 ? 2 : n10, showHidden: t10, truncate: dje.truncateThreshold ? dje.truncateThreshold : 1 / 0 };
  return uje.inspect(e14, o10);
};
var mje = pje;
var hje = cje;
var fje = function(e14) {
  var t10 = mje(e14), n10 = Object.prototype.toString.call(e14);
  if (hje.truncateThreshold && t10.length >= hje.truncateThreshold) {
    if ("[object Function]" === n10) return e14.name && "" !== e14.name ? "[Function: " + e14.name + "]" : "[Function]";
    if ("[object Array]" === n10) return "[ Array(" + e14.length + ") ]";
    if ("[object Object]" === n10) {
      var r10 = Object.keys(e14);
      return "{ Object (" + (r10.length > 2 ? r10.splice(0, 2).join(", ") + ", ..." : r10.join(", ")) + ") }";
    }
    return t10;
  }
  return t10;
};
/*!
 * Chai - message composition utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
/*!
 * Module dependencies
 */
var gje = qWe, yje = rje, vje = fje;
var bje = function(e14, t10) {
  var n10 = gje(e14, "negate"), r10 = gje(e14, "object"), o10 = t10[3], a10 = yje(e14, t10), i10 = n10 ? t10[2] : t10[1], s10 = gje(e14, "message");
  return "function" == typeof i10 && (i10 = i10()), i10 = (i10 = i10 || "").replace(/#\{this\}/g, function() {
    return vje(r10);
  }).replace(/#\{act\}/g, function() {
    return vje(a10);
  }).replace(/#\{exp\}/g, function() {
    return vje(o10);
  }), s10 ? s10 + ": " + i10 : i10;
};
/*!
 * Chai - transferFlags utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
var Sje = function(e14, t10, n10) {
  var r10 = e14.__flags || (e14.__flags = /* @__PURE__ */ Object.create(null));
  for (var o10 in t10.__flags || (t10.__flags = /* @__PURE__ */ Object.create(null)), n10 = 3 !== arguments.length || n10, r10) (n10 || "object" !== o10 && "ssfi" !== o10 && "lockSsfi" !== o10 && "message" != o10) && (t10.__flags[o10] = r10[o10]);
};
var Cje = { exports: {} };
/*!
 * deep-eql
 * Copyright(c) 2013 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
var xje = JWe;
function wje() {
  this._key = "chai/deep-eql__" + Math.random() + Date.now();
}
wje.prototype = { get: function(e14) {
  return e14[this._key];
}, set: function(e14, t10) {
  Object.isExtensible(e14) && Object.defineProperty(e14, this._key, { value: t10, configurable: true });
} };
var Tje = "function" == typeof WeakMap ? WeakMap : wje;
/*!
 * Check to see if the MemoizeMap has recorded a result of the two operands
 *
 * @param {Mixed} leftHandOperand
 * @param {Mixed} rightHandOperand
 * @param {MemoizeMap} memoizeMap
 * @returns {Boolean|null} result
*/
function Eje(e14, t10, n10) {
  if (!n10 || Rje(e14) || Rje(t10)) return null;
  var r10 = n10.get(e14);
  if (r10) {
    var o10 = r10.get(t10);
    if ("boolean" == typeof o10) return o10;
  }
  return null;
}
/*!
 * Set the result of the equality into the MemoizeMap
 *
 * @param {Mixed} leftHandOperand
 * @param {Mixed} rightHandOperand
 * @param {MemoizeMap} memoizeMap
 * @param {Boolean} result
*/
function Fje(e14, t10, n10, r10) {
  if (n10 && !Rje(e14) && !Rje(t10)) {
    var o10 = n10.get(e14);
    o10 ? o10.set(t10, r10) : ((o10 = new Tje()).set(t10, r10), n10.set(e14, o10));
  }
}
/*!
 * Primary Export
 */
function Mje(e14, t10, n10) {
  if (n10 && n10.comparator) return Pje(e14, t10, n10);
  var r10 = kje(e14, t10);
  return null !== r10 ? r10 : Pje(e14, t10, n10);
}
function kje(e14, t10) {
  return e14 === t10 ? 0 !== e14 || 1 / e14 == 1 / t10 : e14 != e14 && t10 != t10 || !Rje(e14) && !Rje(t10) && null;
}
/*!
 * The main logic of the `deepEqual` function.
 *
 * @param {Mixed} leftHandOperand
 * @param {Mixed} rightHandOperand
 * @param {Object} [options] (optional) Additional options
 * @param {Array} [options.comparator] (optional) Override default algorithm, determining custom equality.
 * @param {Array} [options.memoize] (optional) Provide a custom memoization object which will cache the results of
    complex objects for a speed boost. By passing `false` you can disable memoization, but this will cause circular
    references to blow the stack.
 * @return {Boolean} equal match
*/
function Pje(e14, t10, n10) {
  (n10 = n10 || {}).memoize = false !== n10.memoize && (n10.memoize || new Tje());
  var r10 = n10 && n10.comparator;
  var o10 = Eje(e14, t10, n10.memoize);
  if (null !== o10) return o10;
  var a10 = Eje(t10, e14, n10.memoize);
  if (null !== a10) return a10;
  if (r10) {
    var i10 = r10(e14, t10);
    if (false === i10 || true === i10) return Fje(e14, t10, n10.memoize, i10), i10;
    var s10 = kje(e14, t10);
    if (null !== s10) return s10;
  }
  var l10 = xje(e14);
  if (l10 !== xje(t10)) return Fje(e14, t10, n10.memoize, false), false;
  Fje(e14, t10, n10.memoize, true);
  var c10 = function(e15, t11, n11, r11) {
    switch (n11) {
      case "String":
      case "Number":
      case "Boolean":
      case "Date":
        return Mje(e15.valueOf(), t11.valueOf());
      case "Promise":
      case "Symbol":
      case "function":
      case "WeakMap":
      case "WeakSet":
        return e15 === t11;
      case "Error":
        return Vje(e15, t11, ["name", "message", "code"], r11);
      case "Arguments":
      case "Int8Array":
      case "Uint8Array":
      case "Uint8ClampedArray":
      case "Int16Array":
      case "Uint16Array":
      case "Int32Array":
      case "Uint32Array":
      case "Float32Array":
      case "Float64Array":
      case "Array":
        return Dje(e15, t11, r11);
      case "RegExp":
        return function(e16, t12) {
          return e16.toString() === t12.toString();
        }(e15, t11);
      case "Generator":
        return function(e16, t12, n12) {
          return Dje(Hje(e16), Hje(t12), n12);
        }(e15, t11, r11);
      case "DataView":
        return Dje(new Uint8Array(e15.buffer), new Uint8Array(t11.buffer), r11);
      case "ArrayBuffer":
        return Dje(new Uint8Array(e15), new Uint8Array(t11), r11);
      case "Set":
      case "Map":
        return Nje(e15, t11, r11);
      case "Temporal.PlainDate":
      case "Temporal.PlainTime":
      case "Temporal.PlainDateTime":
      case "Temporal.Instant":
      case "Temporal.ZonedDateTime":
      case "Temporal.PlainYearMonth":
      case "Temporal.PlainMonthDay":
        return e15.equals(t11);
      case "Temporal.Duration":
        return e15.total("nanoseconds") === t11.total("nanoseconds");
      case "Temporal.TimeZone":
      case "Temporal.Calendar":
        return e15.toString() === t11.toString();
      default:
        return function(e16, t12, n12) {
          var r12 = Ije(e16);
          var o11 = Ije(t12);
          var a11 = _je(e16);
          var i11 = _je(t12);
          if (r12 = r12.concat(a11), o11 = o11.concat(i11), r12.length && r12.length === o11.length) return false !== Dje(Aje(r12).sort(), Aje(o11).sort()) && Vje(e16, t12, r12, n12);
          var s11 = Lje(e16);
          var l11 = Lje(t12);
          if (s11.length && s11.length === l11.length) return s11.sort(), l11.sort(), Dje(s11, l11, n12);
          if (0 === r12.length && 0 === s11.length && 0 === o11.length && 0 === l11.length) return true;
          return false;
        }(e15, t11, r11);
    }
  }(e14, t10, l10, n10);
  return Fje(e14, t10, n10.memoize, c10), c10;
}
function Nje(e14, t10, n10) {
  if (e14.size !== t10.size) return false;
  if (0 === e14.size) return true;
  var r10 = [];
  var o10 = [];
  return e14.forEach(function(e15, t11) {
    r10.push([e15, t11]);
  }), t10.forEach(function(e15, t11) {
    o10.push([e15, t11]);
  }), Dje(r10.sort(), o10.sort(), n10);
}
/*!
 * Simple equality for flat iterable objects such as Arrays, TypedArrays or Node.js buffers.
 *
 * @param {Iterable} leftHandOperand
 * @param {Iterable} rightHandOperand
 * @param {Object} [options] (Optional)
 * @return {Boolean} result
 */
function Dje(e14, t10, n10) {
  var r10 = e14.length;
  if (r10 !== t10.length) return false;
  if (0 === r10) return true;
  var o10 = -1;
  for (; ++o10 < r10; ) if (false === Mje(e14[o10], t10[o10], n10)) return false;
  return true;
}
/*!
 * Gets all iterator entries from the given Object. If the Object has no @@iterator function, returns an empty array.
 * This will consume the iterator - which could have side effects depending on the @@iterator implementation.
 *
 * @param {Object} target
 * @returns {Array} an array of entries from the @@iterator function
 */
function Lje(e14) {
  if (function(e15) {
    return "undefined" != typeof Symbol && "object" == typeof e15 && void 0 !== Symbol.iterator && "function" == typeof e15[Symbol.iterator];
  }(e14)) try {
    return Hje(e14[Symbol.iterator]());
  } catch (e15) {
    return [];
  }
  return [];
}
/*!
 * Gets all entries from a Generator. This will consume the generator - which could have side effects.
 *
 * @param {Generator} target
 * @returns {Array} an array of entries from the Generator.
 */
function Hje(e14) {
  var t10 = e14.next();
  var n10 = [t10.value];
  for (; false === t10.done; ) t10 = e14.next(), n10.push(t10.value);
  return n10;
}
/*!
 * Gets all own and inherited enumerable keys from a target.
 *
 * @param {Object} target
 * @returns {Array} an array of own and inherited enumerable keys from the target.
 */
function Ije(e14) {
  var t10 = [];
  for (var n10 in e14) t10.push(n10);
  return t10;
}
function _je(e14) {
  var t10 = [];
  var n10 = Object.getOwnPropertySymbols(e14);
  for (var r10 = 0; r10 < n10.length; r10 += 1) {
    var o10 = n10[r10];
    Object.getOwnPropertyDescriptor(e14, o10).enumerable && t10.push(o10);
  }
  return t10;
}
/*!
 * Determines if two objects have matching values, given a set of keys. Defers to deepEqual for the equality check of
 * each key. If any value of the given key is not equal, the function will return false (early).
 *
 * @param {Mixed} leftHandOperand
 * @param {Mixed} rightHandOperand
 * @param {Array} keys An array of keys to compare the values of leftHandOperand and rightHandOperand against
 * @param {Object} [options] (Optional)
 * @return {Boolean} result
 */
function Vje(e14, t10, n10, r10) {
  var o10 = n10.length;
  if (0 === o10) return true;
  for (var a10 = 0; a10 < o10; a10 += 1) if (false === Mje(e14[n10[a10]], t10[n10[a10]], r10)) return false;
  return true;
}
function Rje(e14) {
  return null === e14 || "object" != typeof e14;
}
function Aje(e14) {
  return e14.map(function(e15) {
    return "symbol" == typeof e15 ? e15.toString() : e15;
  });
}
Cje.exports = Mje, Cje.exports.MemoizeMap = Tje;
var Oje = Cje.exports;
var Bje = cje;
/*!
 * Chai - isProxyEnabled helper
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
var zje = function() {
  return Bje.useProxy && "undefined" != typeof Proxy && "undefined" != typeof Reflect;
};
/*!
 * Chai - addProperty utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
var $je;
var Wje;
var jje = Object.getOwnPropertyDescriptor(function() {
}, "length");
/*!
 * Chai - addLengthGuard utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
var Zje = function(e14, t10, n10) {
  return jje.configurable ? (Object.defineProperty(e14, "length", { get: function() {
    if (n10) throw Error("Invalid Chai property: " + t10 + '.length. Due to a compatibility issue, "length" cannot directly follow "' + t10 + '". Use "' + t10 + '.lengthOf" instead.');
    throw Error("Invalid Chai property: " + t10 + '.length. See docs for proper usage of "' + t10 + '".');
  } }), e14) : e14;
};
/*!
 * Chai - getProperties utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
var Gje = cje;
var Uje = qWe;
var qje = function(e14) {
  var t10 = Object.getOwnPropertyNames(e14);
  function n10(e15) {
    -1 === t10.indexOf(e15) && t10.push(e15);
  }
  var r10 = Object.getPrototypeOf(e14);
  for (; null !== r10; ) Object.getOwnPropertyNames(r10).forEach(n10), r10 = Object.getPrototypeOf(r10);
  return t10;
};
var Yje = zje;
/*!
 * Chai - proxify utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
var Kje = ["__flags", "__methods", "_obj", "assert"];
var Xje = function(e14, t10) {
  return Yje() ? new Proxy(e14, { get: function e15(n10, r10) {
    if ("string" == typeof r10 && -1 === Gje.proxyExcludedKeys.indexOf(r10) && !Reflect.has(n10, r10)) {
      if (t10) throw Error("Invalid Chai property: " + t10 + "." + r10 + '. See docs for proper usage of "' + t10 + '".');
      var o10 = null;
      var a10 = 4;
      throw qje(n10).forEach(function(e16) {
        if (!Object.prototype.hasOwnProperty(e16) && -1 === Kje.indexOf(e16)) {
          var t11 = function(e17, t12, n11) {
            if (Math.abs(e17.length - t12.length) >= n11) return n11;
            var r11 = [];
            for (var o11 = 0; o11 <= e17.length; o11++) r11[o11] = Array(t12.length + 1).fill(0), r11[o11][0] = o11;
            for (var a11 = 0; a11 < t12.length; a11++) r11[0][a11] = a11;
            for (o11 = 1; o11 <= e17.length; o11++) {
              var i10 = e17.charCodeAt(o11 - 1);
              for (a11 = 1; a11 <= t12.length; a11++) Math.abs(o11 - a11) >= n11 ? r11[o11][a11] = n11 : r11[o11][a11] = Math.min(r11[o11 - 1][a11] + 1, r11[o11][a11 - 1] + 1, r11[o11 - 1][a11 - 1] + (i10 === t12.charCodeAt(a11 - 1) ? 0 : 1));
            }
            return r11[e17.length][t12.length];
          }(r10, e16, a10);
          t11 < a10 && (o10 = e16, a10 = t11);
        }
      }), null !== o10 ? Error("Invalid Chai property: " + r10 + '. Did you mean "' + o10 + '"?') : Error("Invalid Chai property: " + r10);
    }
    return -1 !== Kje.indexOf(r10) || Uje(n10, "lockSsfi") || Uje(n10, "ssfi", e15), Reflect.get(n10, r10);
  } }) : e14;
};
var Jje;
var Qje;
/*!
 * Chai - overwriteProperty utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
var eZe;
var tZe;
/*!
 * Chai - overwriteMethod utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
var nZe;
var rZe;
/*!
 * Chai - addChainingMethod utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
var oZe;
var aZe;
/*!
 * Chai - overwriteChainableMethod utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
var iZe;
var sZe;
/*!
 * Chai - compareByInspect utility
 * Copyright(c) 2011-2016 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
/*!
 * Module dependencies
 */
var lZe = pje;
var cZe = function(e14, t10) {
  return lZe(e14) < lZe(t10) ? -1 : 1;
};
/*!
 * Chai - getOwnEnumerablePropertySymbols utility
 * Copyright(c) 2011-2016 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
var uZe = function(e14) {
  return "function" != typeof Object.getOwnPropertySymbols ? [] : Object.getOwnPropertySymbols(e14).filter(function(t10) {
    return Object.getOwnPropertyDescriptor(e14, t10).enumerable;
  });
};
/*!
 * Chai - getOwnEnumerableProperties utility
 * Copyright(c) 2011-2016 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
/*!
 * Module dependencies
 */
var dZe = uZe;
var pZe = function(e14) {
  return Object.keys(e14).concat(dZe(e14));
};
var mZe = ije;
var hZe = { compatibleInstance: function(e14, t10) {
  return t10 instanceof Error && e14 === t10;
}, compatibleConstructor: function(e14, t10) {
  return t10 instanceof Error ? e14.constructor === t10.constructor || e14 instanceof t10.constructor : (t10.prototype instanceof Error || t10 === Error) && (e14.constructor === t10 || e14 instanceof t10);
}, compatibleMessage: function(e14, t10) {
  var n10 = "string" == typeof e14 ? e14 : e14.message;
  return t10 instanceof RegExp ? t10.test(n10) : "string" == typeof t10 && -1 !== n10.indexOf(t10);
}, getMessage: function(e14) {
  var t10 = "";
  return e14 && e14.message ? t10 = e14.message : "string" == typeof e14 && (t10 = e14), t10;
}, getConstructorName: function(e14) {
  var t10 = e14;
  if (e14 instanceof Error) t10 = mZe(e14.constructor);
  else if ("function" == typeof e14) {
    if ("" === (t10 = mZe(e14))) t10 = mZe(new e14()) || t10;
  }
  return t10;
} };
/*!
 * Chai - isNaN utility
 * Copyright(c) 2012-2015 Sakthipriyan Vairamani <thechargingvolcano@gmail.com>
 * MIT Licensed
 */
var fZe = Number.isNaN || function(e14) {
  return e14 != e14;
};
var gZe = JWe;
var yZe = qWe;
var vZe = function(e14, t10) {
  var n10 = yZe(e14, "operator");
  var r10 = yZe(e14, "negate");
  var o10 = t10[3];
  var a10 = r10 ? t10[2] : t10[1];
  if (n10) return n10;
  if ("function" == typeof a10 && (a10 = a10()), (a10 = a10 || "") && !/\shave\s/.test(a10)) {
    var i10 = function(e15) {
      var t11 = gZe(e15);
      return -1 !== ["Array", "Object", "function"].indexOf(t11);
    }(o10);
    return /\snot\s/.test(a10) ? i10 ? "notDeepStrictEqual" : "notStrictEqual" : i10 ? "deepStrictEqual" : "strictEqual";
  }
};
/*!
 * chai
 * Copyright(c) 2011 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
var bZe;
function SZe() {
  if (bZe) return $We;
  bZe = 1;
  /*!
  	 * Dependencies that are used for multiple exports are required here only once
  	 */
  var e14 = UWe;
  /*!
  	 * test utility
  	 */
  return $We.test = KWe, /*!
  	 * type utility
  	 */
  $We.type = JWe, /*!
  	 * expectTypes utility
  	 */
  $We.expectTypes = nje, /*!
  	 * message utility
  	 */
  $We.getMessage = bje, /*!
  	 * actual utility
  	 */
  $We.getActual = rje, /*!
  	 * Inspect util
  	 */
  $We.inspect = pje, /*!
  	 * Object Display util
  	 */
  $We.objDisplay = fje, /*!
  	 * Flag utility
  	 */
  $We.flag = qWe, /*!
  	 * Flag transferring utility
  	 */
  $We.transferFlags = Sje, /*!
  	 * Deep equal utility
  	 */
  $We.eql = Oje, /*!
  	 * Deep path info
  	 */
  $We.getPathInfo = e14.getPathInfo, /*!
  	 * Check if a property exists
  	 */
  $We.hasProperty = e14.hasProperty, /*!
  	 * Function name
  	 */
  $We.getName = ije, /*!
  	 * add Property
  	 */
  $We.addProperty = function() {
    if (Wje) return $je;
    Wje = 1;
    var e15 = kZe();
    var t10 = qWe;
    var n10 = zje;
    var r10 = Sje;
    return $je = function(o10, a10, i10) {
      i10 = void 0 === i10 ? function() {
      } : i10, Object.defineProperty(o10, a10, { get: function o11() {
        n10() || t10(this, "lockSsfi") || t10(this, "ssfi", o11);
        var a11 = i10.call(this);
        if (void 0 !== a11) return a11;
        var s10 = new e15.Assertion();
        return r10(this, s10), s10;
      }, configurable: true });
    }, $je;
  }(), /*!
  	 * add Method
  	 */
  $We.addMethod = function() {
    if (Qje) return Jje;
    Qje = 1;
    var e15 = Zje;
    var t10 = kZe();
    var n10 = qWe;
    var r10 = Xje;
    var o10 = Sje;
    return Jje = function(a10, i10, s10) {
      var l10 = function() {
        n10(this, "lockSsfi") || n10(this, "ssfi", l10);
        var e16 = s10.apply(this, arguments);
        if (void 0 !== e16) return e16;
        var r11 = new t10.Assertion();
        return o10(this, r11), r11;
      };
      e15(l10, i10, false), a10[i10] = r10(l10, i10);
    }, Jje;
  }(), /*!
  	 * overwrite Property
  	 */
  $We.overwriteProperty = function() {
    if (tZe) return eZe;
    tZe = 1;
    var e15 = kZe();
    var t10 = qWe;
    var n10 = zje;
    var r10 = Sje;
    return eZe = function(o10, a10, i10) {
      var s10 = Object.getOwnPropertyDescriptor(o10, a10), l10 = function() {
      };
      s10 && "function" == typeof s10.get && (l10 = s10.get), Object.defineProperty(o10, a10, { get: function o11() {
        n10() || t10(this, "lockSsfi") || t10(this, "ssfi", o11);
        var a11 = t10(this, "lockSsfi");
        t10(this, "lockSsfi", true);
        var s11 = i10(l10).call(this);
        if (t10(this, "lockSsfi", a11), void 0 !== s11) return s11;
        var c10 = new e15.Assertion();
        return r10(this, c10), c10;
      }, configurable: true });
    }, eZe;
  }(), /*!
  	 * overwrite Method
  	 */
  $We.overwriteMethod = function() {
    if (rZe) return nZe;
    rZe = 1;
    var e15 = Zje;
    var t10 = kZe();
    var n10 = qWe;
    var r10 = Xje;
    var o10 = Sje;
    return nZe = function(a10, i10, s10) {
      var l10 = a10[i10], c10 = function() {
        throw new Error(i10 + " is not a function");
      };
      l10 && "function" == typeof l10 && (c10 = l10);
      var u10 = function() {
        n10(this, "lockSsfi") || n10(this, "ssfi", u10);
        var e16 = n10(this, "lockSsfi");
        n10(this, "lockSsfi", true);
        var r11 = s10(c10).apply(this, arguments);
        if (n10(this, "lockSsfi", e16), void 0 !== r11) return r11;
        var a11 = new t10.Assertion();
        return o10(this, a11), a11;
      };
      e15(u10, i10, false), a10[i10] = r10(u10, i10);
    }, nZe;
  }(), /*!
  	 * Add a chainable method
  	 */
  $We.addChainableMethod = function() {
    if (aZe) return oZe;
    aZe = 1;
    /*!
    	 * Module dependencies
    	 */
    var e15 = Zje;
    var t10 = kZe();
    var n10 = qWe;
    var r10 = Xje;
    var o10 = Sje;
    /*!
    	 * Module variables
    	 */
    var a10 = "function" == typeof Object.setPrototypeOf;
    var i10 = function() {
    };
    var s10 = Object.getOwnPropertyNames(i10).filter(function(e16) {
      var t11 = Object.getOwnPropertyDescriptor(i10, e16);
      return "object" != typeof t11 || !t11.configurable;
    });
    var l10 = Function.prototype.call, c10 = Function.prototype.apply;
    return oZe = function(i11, u10, d10, p10) {
      "function" != typeof p10 && (p10 = function() {
      });
      var m10 = { method: d10, chainingBehavior: p10 };
      i11.__methods || (i11.__methods = {}), i11.__methods[u10] = m10, Object.defineProperty(i11, u10, { get: function() {
        m10.chainingBehavior.call(this);
        var d11 = function() {
          n10(this, "lockSsfi") || n10(this, "ssfi", d11);
          var e16 = m10.method.apply(this, arguments);
          if (void 0 !== e16) return e16;
          var r11 = new t10.Assertion();
          return o10(this, r11), r11;
        };
        if (e15(d11, u10, true), a10) {
          var p11 = Object.create(this);
          p11.call = l10, p11.apply = c10, Object.setPrototypeOf(d11, p11);
        } else Object.getOwnPropertyNames(i11).forEach(function(e16) {
          if (-1 === s10.indexOf(e16)) {
            var t11 = Object.getOwnPropertyDescriptor(i11, e16);
            Object.defineProperty(d11, e16, t11);
          }
        });
        return o10(this, d11), r10(d11);
      }, configurable: true });
    }, oZe;
  }(), /*!
  	 * Overwrite chainable method
  	 */
  $We.overwriteChainableMethod = function() {
    if (sZe) return iZe;
    sZe = 1;
    var e15 = kZe();
    var t10 = Sje;
    return iZe = function(n10, r10, o10, a10) {
      var i10 = n10.__methods[r10];
      var s10 = i10.chainingBehavior;
      i10.chainingBehavior = function() {
        var n11 = a10(s10).call(this);
        if (void 0 !== n11) return n11;
        var r11 = new e15.Assertion();
        return t10(this, r11), r11;
      };
      var l10 = i10.method;
      i10.method = function() {
        var n11 = o10(l10).apply(this, arguments);
        if (void 0 !== n11) return n11;
        var r11 = new e15.Assertion();
        return t10(this, r11), r11;
      };
    }, iZe;
  }(), /*!
  	 * Compare by inspect method
  	 */
  $We.compareByInspect = cZe, /*!
  	 * Get own enumerable property symbols method
  	 */
  $We.getOwnEnumerablePropertySymbols = uZe, /*!
  	 * Get own enumerable properties method
  	 */
  $We.getOwnEnumerableProperties = pZe, /*!
  	 * Checks error against a given set of criteria
  	 */
  $We.checkError = hZe, /*!
  	 * Proxify util
  	 */
  $We.proxify = Xje, /*!
  	 * addLengthGuard util
  	 */
  $We.addLengthGuard = Zje, /*!
  	 * isProxyEnabled helper
  	 */
  $We.isProxyEnabled = zje, /*!
  	 * isNaN method
  	 */
  $We.isNaN = fZe, /*!
  	 * getOperator method
  	 */
  $We.getOperator = vZe, $We;
}
/*!
 * chai
 * http://chaijs.com
 * Copyright(c) 2011-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
var CZe = cje;
var xZe = function(e14, t10) {
  /*!
     * Module dependencies.
     */
  var n10 = e14.AssertionError, r10 = t10.flag;
  /*!
     * Module export.
     */
  /*!
     * Assertion Constructor
     *
     * Creates object for chaining.
     *
     * `Assertion` objects contain metadata in the form of flags. Three flags can
     * be assigned during instantiation by passing arguments to this constructor:
     *
     * - `object`: This flag contains the target of the assertion. For example, in
     *   the assertion `expect(numKittens).to.equal(7);`, the `object` flag will
     *   contain `numKittens` so that the `equal` assertion can reference it when
     *   needed.
     *
     * - `message`: This flag contains an optional custom error message to be
     *   prepended to the error message that's generated by the assertion when it
     *   fails.
     *
     * - `ssfi`: This flag stands for "start stack function indicator". It
     *   contains a function reference that serves as the starting point for
     *   removing frames from the stack trace of the error that's created by the
     *   assertion when it fails. The goal is to provide a cleaner stack trace to
     *   end users by removing Chai's internal functions. Note that it only works
     *   in environments that support `Error.captureStackTrace`, and only when
     *   `Chai.config.includeStack` hasn't been set to `false`.
     *
     * - `lockSsfi`: This flag controls whether or not the given `ssfi` flag
     *   should retain its current value, even as assertions are chained off of
     *   this object. This is usually set to `true` when creating a new assertion
     *   from within another assertion. It's also temporarily set to `true` before
     *   an overwritten assertion gets called by the overwriting assertion.
     *
     * - `eql`: This flag contains the deepEqual function to be used by the assertion.
     *
     * @param {Mixed} obj target of the assertion
     * @param {String} msg (optional) custom error message
     * @param {Function} ssfi (optional) starting point for removing stack frames
     * @param {Boolean} lockSsfi (optional) whether or not the ssfi flag is locked
     * @api private
     */
  function o10(e15, n11, a10, i10) {
    return r10(this, "ssfi", a10 || o10), r10(this, "lockSsfi", i10), r10(this, "object", e15), r10(this, "message", n11), r10(this, "eql", CZe.deepEqual || t10.eql), t10.proxify(this);
  }
  e14.Assertion = o10, Object.defineProperty(o10, "includeStack", { get: function() {
    return console.warn("Assertion.includeStack is deprecated, use chai.config.includeStack instead."), CZe.includeStack;
  }, set: function(e15) {
    console.warn("Assertion.includeStack is deprecated, use chai.config.includeStack instead."), CZe.includeStack = e15;
  } }), Object.defineProperty(o10, "showDiff", { get: function() {
    return console.warn("Assertion.showDiff is deprecated, use chai.config.showDiff instead."), CZe.showDiff;
  }, set: function(e15) {
    console.warn("Assertion.showDiff is deprecated, use chai.config.showDiff instead."), CZe.showDiff = e15;
  } }), o10.addProperty = function(e15, n11) {
    t10.addProperty(this.prototype, e15, n11);
  }, o10.addMethod = function(e15, n11) {
    t10.addMethod(this.prototype, e15, n11);
  }, o10.addChainableMethod = function(e15, n11, r11) {
    t10.addChainableMethod(this.prototype, e15, n11, r11);
  }, o10.overwriteProperty = function(e15, n11) {
    t10.overwriteProperty(this.prototype, e15, n11);
  }, o10.overwriteMethod = function(e15, n11) {
    t10.overwriteMethod(this.prototype, e15, n11);
  }, o10.overwriteChainableMethod = function(e15, n11, r11) {
    t10.overwriteChainableMethod(this.prototype, e15, n11, r11);
  }, o10.prototype.assert = function(e15, o11, a10, i10, s10, l10) {
    var c10 = t10.test(this, arguments);
    if (false !== l10 && (l10 = true), void 0 === i10 && void 0 === s10 && (l10 = false), true !== CZe.showDiff && (l10 = false), !c10) {
      o11 = t10.getMessage(this, arguments);
      var u10 = { actual: t10.getActual(this, arguments), expected: i10, showDiff: l10 };
      var d10 = t10.getOperator(this, arguments);
      throw d10 && (u10.operator = d10), new n10(o11, u10, CZe.includeStack ? this.assert : r10(this, "ssfi"));
    }
  }, /*!
     * ### ._obj
     *
     * Quick reference to stored `actual` value for plugin developers.
     *
     * @api private
     */
  Object.defineProperty(o10.prototype, "_obj", { get: function() {
    return r10(this, "object");
  }, set: function(e15) {
    r10(this, "object", e15);
  } });
};
/*!
 * chai
 * http://chaijs.com
 * Copyright(c) 2011-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
var wZe = function(e14, t10) {
  var n10 = e14.Assertion, r10 = e14.AssertionError, o10 = t10.flag;
  function a10(e15, n11) {
    n11 && o10(this, "message", n11), e15 = e15.toLowerCase();
    var r11 = o10(this, "object"), a11 = ~["a", "e", "i", "o", "u"].indexOf(e15.charAt(0)) ? "an " : "a ";
    this.assert(e15 === t10.type(r11).toLowerCase(), "expected #{this} to be " + a11 + e15, "expected #{this} not to be " + a11 + e15);
  }
  function i10(e15, n11) {
    return t10.isNaN(e15) && t10.isNaN(n11) || e15 === n11;
  }
  function s10() {
    o10(this, "contains", true);
  }
  function l10(e15, a11) {
    a11 && o10(this, "message", a11);
    var s11 = o10(this, "object"), l11 = t10.type(s11).toLowerCase(), c11 = o10(this, "message"), u11 = o10(this, "negate"), d11 = o10(this, "ssfi"), p11 = o10(this, "deep"), m11 = p11 ? "deep " : "", h11 = p11 ? o10(this, "eql") : i10;
    c11 = c11 ? c11 + ": " : "";
    var f11 = false;
    switch (l11) {
      case "string":
        f11 = -1 !== s11.indexOf(e15);
        break;
      case "weakset":
        if (p11) throw new r10(c11 + "unable to use .deep.include with WeakSet", void 0, d11);
        f11 = s11.has(e15);
        break;
      case "map":
        s11.forEach(function(t11) {
          f11 = f11 || h11(t11, e15);
        });
        break;
      case "set":
        p11 ? s11.forEach(function(t11) {
          f11 = f11 || h11(t11, e15);
        }) : f11 = s11.has(e15);
        break;
      case "array":
        f11 = p11 ? s11.some(function(t11) {
          return h11(t11, e15);
        }) : -1 !== s11.indexOf(e15);
        break;
      default:
        if (e15 !== Object(e15)) throw new r10(c11 + "the given combination of arguments (" + l11 + " and " + t10.type(e15).toLowerCase() + ") is invalid for this assertion. You can use an array, a map, an object, a set, a string, or a weakset instead of a " + t10.type(e15).toLowerCase(), void 0, d11);
        var g11 = Object.keys(e15), y11 = null, v11 = 0;
        if (g11.forEach(function(a12) {
          var i11 = new n10(s11);
          if (t10.transferFlags(this, i11, true), o10(i11, "lockSsfi", true), u11 && 1 !== g11.length) try {
            i11.property(a12, e15[a12]);
          } catch (e16) {
            if (!t10.checkError.compatibleConstructor(e16, r10)) throw e16;
            null === y11 && (y11 = e16), v11++;
          }
          else i11.property(a12, e15[a12]);
        }, this), u11 && g11.length > 1 && v11 === g11.length) throw y11;
        return;
    }
    this.assert(f11, "expected #{this} to " + m11 + "include " + t10.inspect(e15), "expected #{this} to not " + m11 + "include " + t10.inspect(e15));
  }
  function c10() {
    var e15 = o10(this, "object");
    this.assert(null != e15, "expected #{this} to exist", "expected #{this} to not exist");
  }
  function u10() {
    var e15 = o10(this, "object"), n11 = t10.type(e15);
    this.assert("Arguments" === n11, "expected #{this} to be arguments but got " + n11, "expected #{this} to not be arguments");
  }
  function d10(e15, t11) {
    t11 && o10(this, "message", t11);
    var n11 = o10(this, "object");
    if (o10(this, "deep")) {
      var r11 = o10(this, "lockSsfi");
      o10(this, "lockSsfi", true), this.eql(e15), o10(this, "lockSsfi", r11);
    } else this.assert(e15 === n11, "expected #{this} to equal #{exp}", "expected #{this} to not equal #{exp}", e15, this._obj, true);
  }
  function p10(e15, t11) {
    t11 && o10(this, "message", t11);
    var n11 = o10(this, "eql");
    this.assert(n11(e15, o10(this, "object")), "expected #{this} to deeply equal #{exp}", "expected #{this} to not deeply equal #{exp}", e15, this._obj, true);
  }
  function m10(e15, a11) {
    a11 && o10(this, "message", a11);
    var i11, s11 = o10(this, "object"), l11 = o10(this, "doLength"), c11 = o10(this, "message"), u11 = c11 ? c11 + ": " : "", d11 = o10(this, "ssfi"), p11 = t10.type(s11).toLowerCase(), m11 = t10.type(e15).toLowerCase(), h11 = true;
    if (l11 && "map" !== p11 && "set" !== p11 && new n10(s11, c11, d11, true).to.have.property("length"), l11 || "date" !== p11 || "date" === m11) if ("number" === m11 || !l11 && "number" !== p11) if (l11 || "date" === p11 || "number" === p11) h11 = false;
    else {
      i11 = u11 + "expected " + ("string" === p11 ? "'" + s11 + "'" : s11) + " to be a number or a date";
    }
    else i11 = u11 + "the argument to above must be a number";
    else i11 = u11 + "the argument to above must be a date";
    if (h11) throw new r10(i11, void 0, d11);
    if (l11) {
      var f11, g11 = "length";
      "map" === p11 || "set" === p11 ? (g11 = "size", f11 = s11.size) : f11 = s11.length, this.assert(f11 > e15, "expected #{this} to have a " + g11 + " above #{exp} but got #{act}", "expected #{this} to not have a " + g11 + " above #{exp}", e15, f11);
    } else this.assert(s11 > e15, "expected #{this} to be above #{exp}", "expected #{this} to be at most #{exp}", e15);
  }
  function h10(e15, a11) {
    a11 && o10(this, "message", a11);
    var i11, s11 = o10(this, "object"), l11 = o10(this, "doLength"), c11 = o10(this, "message"), u11 = c11 ? c11 + ": " : "", d11 = o10(this, "ssfi"), p11 = t10.type(s11).toLowerCase(), m11 = t10.type(e15).toLowerCase(), h11 = true;
    if (l11 && "map" !== p11 && "set" !== p11 && new n10(s11, c11, d11, true).to.have.property("length"), l11 || "date" !== p11 || "date" === m11) if ("number" === m11 || !l11 && "number" !== p11) if (l11 || "date" === p11 || "number" === p11) h11 = false;
    else {
      i11 = u11 + "expected " + ("string" === p11 ? "'" + s11 + "'" : s11) + " to be a number or a date";
    }
    else i11 = u11 + "the argument to least must be a number";
    else i11 = u11 + "the argument to least must be a date";
    if (h11) throw new r10(i11, void 0, d11);
    if (l11) {
      var f11, g11 = "length";
      "map" === p11 || "set" === p11 ? (g11 = "size", f11 = s11.size) : f11 = s11.length, this.assert(f11 >= e15, "expected #{this} to have a " + g11 + " at least #{exp} but got #{act}", "expected #{this} to have a " + g11 + " below #{exp}", e15, f11);
    } else this.assert(s11 >= e15, "expected #{this} to be at least #{exp}", "expected #{this} to be below #{exp}", e15);
  }
  function f10(e15, a11) {
    a11 && o10(this, "message", a11);
    var i11, s11 = o10(this, "object"), l11 = o10(this, "doLength"), c11 = o10(this, "message"), u11 = c11 ? c11 + ": " : "", d11 = o10(this, "ssfi"), p11 = t10.type(s11).toLowerCase(), m11 = t10.type(e15).toLowerCase(), h11 = true;
    if (l11 && "map" !== p11 && "set" !== p11 && new n10(s11, c11, d11, true).to.have.property("length"), l11 || "date" !== p11 || "date" === m11) if ("number" === m11 || !l11 && "number" !== p11) if (l11 || "date" === p11 || "number" === p11) h11 = false;
    else {
      i11 = u11 + "expected " + ("string" === p11 ? "'" + s11 + "'" : s11) + " to be a number or a date";
    }
    else i11 = u11 + "the argument to below must be a number";
    else i11 = u11 + "the argument to below must be a date";
    if (h11) throw new r10(i11, void 0, d11);
    if (l11) {
      var f11, g11 = "length";
      "map" === p11 || "set" === p11 ? (g11 = "size", f11 = s11.size) : f11 = s11.length, this.assert(f11 < e15, "expected #{this} to have a " + g11 + " below #{exp} but got #{act}", "expected #{this} to not have a " + g11 + " below #{exp}", e15, f11);
    } else this.assert(s11 < e15, "expected #{this} to be below #{exp}", "expected #{this} to be at least #{exp}", e15);
  }
  function g10(e15, a11) {
    a11 && o10(this, "message", a11);
    var i11, s11 = o10(this, "object"), l11 = o10(this, "doLength"), c11 = o10(this, "message"), u11 = c11 ? c11 + ": " : "", d11 = o10(this, "ssfi"), p11 = t10.type(s11).toLowerCase(), m11 = t10.type(e15).toLowerCase(), h11 = true;
    if (l11 && "map" !== p11 && "set" !== p11 && new n10(s11, c11, d11, true).to.have.property("length"), l11 || "date" !== p11 || "date" === m11) if ("number" === m11 || !l11 && "number" !== p11) if (l11 || "date" === p11 || "number" === p11) h11 = false;
    else {
      i11 = u11 + "expected " + ("string" === p11 ? "'" + s11 + "'" : s11) + " to be a number or a date";
    }
    else i11 = u11 + "the argument to most must be a number";
    else i11 = u11 + "the argument to most must be a date";
    if (h11) throw new r10(i11, void 0, d11);
    if (l11) {
      var f11, g11 = "length";
      "map" === p11 || "set" === p11 ? (g11 = "size", f11 = s11.size) : f11 = s11.length, this.assert(f11 <= e15, "expected #{this} to have a " + g11 + " at most #{exp} but got #{act}", "expected #{this} to have a " + g11 + " above #{exp}", e15, f11);
    } else this.assert(s11 <= e15, "expected #{this} to be at most #{exp}", "expected #{this} to be above #{exp}", e15);
  }
  function y10(e15, n11) {
    n11 && o10(this, "message", n11);
    var a11 = o10(this, "object");
    var i11 = o10(this, "ssfi");
    var s11 = o10(this, "message");
    try {
      var l11 = a11 instanceof e15;
    } catch (n12) {
      if (n12 instanceof TypeError) throw new r10((s11 = s11 ? s11 + ": " : "") + "The instanceof assertion needs a constructor but " + t10.type(e15) + " was given.", void 0, i11);
      throw n12;
    }
    var c11 = t10.getName(e15);
    null === c11 && (c11 = "an unnamed constructor"), this.assert(l11, "expected #{this} to be an instance of " + c11, "expected #{this} to not be an instance of " + c11);
  }
  function v10(e15, n11, a11) {
    a11 && o10(this, "message", a11);
    var i11 = o10(this, "nested"), s11 = o10(this, "own"), l11 = o10(this, "message"), c11 = o10(this, "object"), u11 = o10(this, "ssfi"), d11 = typeof e15;
    if (l11 = l11 ? l11 + ": " : "", i11) {
      if ("string" !== d11) throw new r10(l11 + "the argument to property must be a string when using nested syntax", void 0, u11);
    } else if ("string" !== d11 && "number" !== d11 && "symbol" !== d11) throw new r10(l11 + "the argument to property must be a string, number, or symbol", void 0, u11);
    if (i11 && s11) throw new r10(l11 + 'The "nested" and "own" flags cannot be combined.', void 0, u11);
    if (null == c11) throw new r10(l11 + "Target cannot be null or undefined.", void 0, u11);
    var p11 = o10(this, "deep"), m11 = o10(this, "negate"), h11 = i11 ? t10.getPathInfo(c11, e15) : null, f11 = i11 ? h11.value : c11[e15], g11 = p11 ? o10(this, "eql") : (e16, t11) => e16 === t11;
    var y11 = "";
    var v11;
    p11 && (y11 += "deep "), s11 && (y11 += "own "), i11 && (y11 += "nested "), y11 += "property ", v11 = s11 ? Object.prototype.hasOwnProperty.call(c11, e15) : i11 ? h11.exists : t10.hasProperty(c11, e15), m11 && 1 !== arguments.length || this.assert(v11, "expected #{this} to have " + y11 + t10.inspect(e15), "expected #{this} to not have " + y11 + t10.inspect(e15)), arguments.length > 1 && this.assert(v11 && g11(n11, f11), "expected #{this} to have " + y11 + t10.inspect(e15) + " of #{exp}, but got #{act}", "expected #{this} to not have " + y11 + t10.inspect(e15) + " of #{act}", n11, f11), o10(this, "object", f11);
  }
  function b10(e15, t11, n11) {
    o10(this, "own", true), v10.apply(this, arguments);
  }
  function S10(e15, n11, r11) {
    "string" == typeof n11 && (r11 = n11, n11 = null), r11 && o10(this, "message", r11);
    var a11 = o10(this, "object");
    var i11 = Object.getOwnPropertyDescriptor(Object(a11), e15);
    var s11 = o10(this, "eql");
    i11 && n11 ? this.assert(s11(n11, i11), "expected the own property descriptor for " + t10.inspect(e15) + " on #{this} to match " + t10.inspect(n11) + ", got " + t10.inspect(i11), "expected the own property descriptor for " + t10.inspect(e15) + " on #{this} to not match " + t10.inspect(n11), n11, i11, true) : this.assert(i11, "expected #{this} to have an own property descriptor for " + t10.inspect(e15), "expected #{this} to not have an own property descriptor for " + t10.inspect(e15)), o10(this, "object", i11);
  }
  function C10() {
    o10(this, "doLength", true);
  }
  function x10(e15, r11) {
    r11 && o10(this, "message", r11);
    var a11, i11 = o10(this, "object"), s11 = t10.type(i11).toLowerCase(), l11 = o10(this, "message"), c11 = o10(this, "ssfi"), u11 = "length";
    switch (s11) {
      case "map":
      case "set":
        u11 = "size", a11 = i11.size;
        break;
      default:
        new n10(i11, l11, c11, true).to.have.property("length"), a11 = i11.length;
    }
    this.assert(a11 == e15, "expected #{this} to have a " + u11 + " of #{exp} but got #{act}", "expected #{this} to not have a " + u11 + " of #{act}", e15, a11);
  }
  function w10(e15, t11) {
    t11 && o10(this, "message", t11);
    var n11 = o10(this, "object");
    this.assert(e15.exec(n11), "expected #{this} to match " + e15, "expected #{this} not to match " + e15);
  }
  function T10(e15) {
    var n11, a11, i11 = o10(this, "object"), s11 = t10.type(i11), l11 = t10.type(e15), c11 = o10(this, "ssfi"), u11 = o10(this, "deep"), d11 = "", p11 = true, m11 = o10(this, "message");
    var h11 = (m11 = m11 ? m11 + ": " : "") + "when testing keys against an object or an array you must give a single Array|Object|String argument or multiple String arguments";
    if ("Map" === s11 || "Set" === s11) d11 = u11 ? "deeply " : "", a11 = [], i11.forEach(function(e16, t11) {
      a11.push(t11);
    }), "Array" !== l11 && (e15 = Array.prototype.slice.call(arguments));
    else {
      switch (a11 = t10.getOwnEnumerableProperties(i11), l11) {
        case "Array":
          if (arguments.length > 1) throw new r10(h11, void 0, c11);
          break;
        case "Object":
          if (arguments.length > 1) throw new r10(h11, void 0, c11);
          e15 = Object.keys(e15);
          break;
        default:
          e15 = Array.prototype.slice.call(arguments);
      }
      e15 = e15.map(function(e16) {
        return "symbol" == typeof e16 ? e16 : String(e16);
      });
    }
    if (!e15.length) throw new r10(m11 + "keys required", void 0, c11);
    var f11 = e15.length, g11 = o10(this, "any"), y11 = o10(this, "all"), v11 = e15, b11 = u11 ? o10(this, "eql") : (e16, t11) => e16 === t11;
    if (g11 || y11 || (y11 = true), g11 && (p11 = v11.some(function(e16) {
      return a11.some(function(t11) {
        return b11(e16, t11);
      });
    })), y11 && (p11 = v11.every(function(e16) {
      return a11.some(function(t11) {
        return b11(e16, t11);
      });
    }), o10(this, "contains") || (p11 = p11 && e15.length == a11.length)), f11 > 1) {
      var S11 = (e15 = e15.map(function(e16) {
        return t10.inspect(e16);
      })).pop();
      y11 && (n11 = e15.join(", ") + ", and " + S11), g11 && (n11 = e15.join(", ") + ", or " + S11);
    } else n11 = t10.inspect(e15[0]);
    n11 = (f11 > 1 ? "keys " : "key ") + n11, n11 = (o10(this, "contains") ? "contain " : "have ") + n11, this.assert(p11, "expected #{this} to " + d11 + n11, "expected #{this} to not " + d11 + n11, v11.slice(0).sort(t10.compareByInspect), a11.sort(t10.compareByInspect), true);
  }
  function E10(e15, r11, a11) {
    a11 && o10(this, "message", a11);
    var i11 = o10(this, "object"), s11 = o10(this, "ssfi"), l11 = o10(this, "message"), c11 = o10(this, "negate") || false;
    var u11;
    new n10(i11, l11, s11, true).is.a("function"), (e15 instanceof RegExp || "string" == typeof e15) && (r11 = e15, e15 = null);
    try {
      i11();
    } catch (e16) {
      u11 = e16;
    }
    var d11 = void 0 === e15 && void 0 === r11;
    var p11 = Boolean(e15 && r11);
    var m11 = false;
    var h11 = false;
    if (d11 || !d11 && !c11) {
      var f11 = "an error";
      e15 instanceof Error ? f11 = "#{exp}" : e15 && (f11 = t10.checkError.getConstructorName(e15)), this.assert(u11, "expected #{this} to throw " + f11, "expected #{this} to not throw an error but #{act} was thrown", e15 && e15.toString(), u11 instanceof Error ? u11.toString() : "string" == typeof u11 ? u11 : u11 && t10.checkError.getConstructorName(u11));
    }
    if (e15 && u11) {
      if (e15 instanceof Error) t10.checkError.compatibleInstance(u11, e15) === c11 && (p11 && c11 ? m11 = true : this.assert(c11, "expected #{this} to throw #{exp} but #{act} was thrown", "expected #{this} to not throw #{exp}" + (u11 && !c11 ? " but #{act} was thrown" : ""), e15.toString(), u11.toString()));
      t10.checkError.compatibleConstructor(u11, e15) === c11 && (p11 && c11 ? m11 = true : this.assert(c11, "expected #{this} to throw #{exp} but #{act} was thrown", "expected #{this} to not throw #{exp}" + (u11 ? " but #{act} was thrown" : ""), e15 instanceof Error ? e15.toString() : e15 && t10.checkError.getConstructorName(e15), u11 instanceof Error ? u11.toString() : u11 && t10.checkError.getConstructorName(u11)));
    }
    if (u11 && null != r11) {
      var g11 = "including";
      r11 instanceof RegExp && (g11 = "matching"), t10.checkError.compatibleMessage(u11, r11) === c11 && (p11 && c11 ? h11 = true : this.assert(c11, "expected #{this} to throw error " + g11 + " #{exp} but got #{act}", "expected #{this} to throw error not " + g11 + " #{exp}", r11, t10.checkError.getMessage(u11)));
    }
    m11 && h11 && this.assert(c11, "expected #{this} to throw #{exp} but #{act} was thrown", "expected #{this} to not throw #{exp}" + (u11 ? " but #{act} was thrown" : ""), e15 instanceof Error ? e15.toString() : e15 && t10.checkError.getConstructorName(e15), u11 instanceof Error ? u11.toString() : u11 && t10.checkError.getConstructorName(u11)), o10(this, "object", u11);
  }
  function F10(e15, n11) {
    n11 && o10(this, "message", n11);
    var r11 = o10(this, "object"), a11 = o10(this, "itself"), i11 = "function" != typeof r11 || a11 ? r11[e15] : r11.prototype[e15];
    this.assert("function" == typeof i11, "expected #{this} to respond to " + t10.inspect(e15), "expected #{this} to not respond to " + t10.inspect(e15));
  }
  function M10(e15, n11) {
    n11 && o10(this, "message", n11);
    var r11 = e15(o10(this, "object"));
    this.assert(r11, "expected #{this} to satisfy " + t10.objDisplay(e15), "expected #{this} to not satisfy" + t10.objDisplay(e15), !o10(this, "negate"), r11);
  }
  function k10(e15, t11, a11) {
    a11 && o10(this, "message", a11);
    var i11 = o10(this, "object"), s11 = o10(this, "message"), l11 = o10(this, "ssfi");
    if (new n10(i11, s11, l11, true).is.a("number"), "number" != typeof e15 || "number" != typeof t11) throw new r10((s11 = s11 ? s11 + ": " : "") + "the arguments to closeTo or approximately must be numbers" + (void 0 === t11 ? ", and a delta is required" : ""), void 0, l11);
    this.assert(Math.abs(i11 - e15) <= t11, "expected #{this} to be close to " + e15 + " +/- " + t11, "expected #{this} not to be close to " + e15 + " +/- " + t11);
  }
  function P10(e15, t11, r11) {
    r11 && o10(this, "message", r11);
    var a11 = o10(this, "object"), i11 = o10(this, "message"), s11 = o10(this, "ssfi");
    var l11;
    new n10(a11, i11, s11, true).is.a("function"), t11 ? (new n10(e15, i11, s11, true).to.have.property(t11), l11 = e15[t11]) : (new n10(e15, i11, s11, true).is.a("function"), l11 = e15()), a11();
    var c11 = null == t11 ? e15() : e15[t11];
    var u11 = null == t11 ? l11 : "." + t11;
    o10(this, "deltaMsgObj", u11), o10(this, "initialDeltaValue", l11), o10(this, "finalDeltaValue", c11), o10(this, "deltaBehavior", "change"), o10(this, "realDelta", c11 !== l11), this.assert(l11 !== c11, "expected " + u11 + " to change", "expected " + u11 + " to not change");
  }
  function N10(e15, t11, r11) {
    r11 && o10(this, "message", r11);
    var a11 = o10(this, "object"), i11 = o10(this, "message"), s11 = o10(this, "ssfi");
    var l11;
    new n10(a11, i11, s11, true).is.a("function"), t11 ? (new n10(e15, i11, s11, true).to.have.property(t11), l11 = e15[t11]) : (new n10(e15, i11, s11, true).is.a("function"), l11 = e15()), new n10(l11, i11, s11, true).is.a("number"), a11();
    var c11 = null == t11 ? e15() : e15[t11];
    var u11 = null == t11 ? l11 : "." + t11;
    o10(this, "deltaMsgObj", u11), o10(this, "initialDeltaValue", l11), o10(this, "finalDeltaValue", c11), o10(this, "deltaBehavior", "increase"), o10(this, "realDelta", c11 - l11), this.assert(c11 - l11 > 0, "expected " + u11 + " to increase", "expected " + u11 + " to not increase");
  }
  function D10(e15, t11, r11) {
    r11 && o10(this, "message", r11);
    var a11 = o10(this, "object"), i11 = o10(this, "message"), s11 = o10(this, "ssfi");
    var l11;
    new n10(a11, i11, s11, true).is.a("function"), t11 ? (new n10(e15, i11, s11, true).to.have.property(t11), l11 = e15[t11]) : (new n10(e15, i11, s11, true).is.a("function"), l11 = e15()), new n10(l11, i11, s11, true).is.a("number"), a11();
    var c11 = null == t11 ? e15() : e15[t11];
    var u11 = null == t11 ? l11 : "." + t11;
    o10(this, "deltaMsgObj", u11), o10(this, "initialDeltaValue", l11), o10(this, "finalDeltaValue", c11), o10(this, "deltaBehavior", "decrease"), o10(this, "realDelta", l11 - c11), this.assert(c11 - l11 < 0, "expected " + u11 + " to decrease", "expected " + u11 + " to not decrease");
  }
  ["to", "be", "been", "is", "and", "has", "have", "with", "that", "which", "at", "of", "same", "but", "does", "still", "also"].forEach(function(e15) {
    n10.addProperty(e15);
  }), n10.addProperty("not", function() {
    o10(this, "negate", true);
  }), n10.addProperty("deep", function() {
    o10(this, "deep", true);
  }), n10.addProperty("nested", function() {
    o10(this, "nested", true);
  }), n10.addProperty("own", function() {
    o10(this, "own", true);
  }), n10.addProperty("ordered", function() {
    o10(this, "ordered", true);
  }), n10.addProperty("any", function() {
    o10(this, "any", true), o10(this, "all", false);
  }), n10.addProperty("all", function() {
    o10(this, "all", true), o10(this, "any", false);
  }), n10.addChainableMethod("an", a10), n10.addChainableMethod("a", a10), n10.addChainableMethod("include", l10, s10), n10.addChainableMethod("contain", l10, s10), n10.addChainableMethod("contains", l10, s10), n10.addChainableMethod("includes", l10, s10), n10.addProperty("ok", function() {
    this.assert(o10(this, "object"), "expected #{this} to be truthy", "expected #{this} to be falsy");
  }), n10.addProperty("true", function() {
    this.assert(true === o10(this, "object"), "expected #{this} to be true", "expected #{this} to be false", !o10(this, "negate"));
  }), n10.addProperty("false", function() {
    this.assert(false === o10(this, "object"), "expected #{this} to be false", "expected #{this} to be true", !!o10(this, "negate"));
  }), n10.addProperty("null", function() {
    this.assert(null === o10(this, "object"), "expected #{this} to be null", "expected #{this} not to be null");
  }), n10.addProperty("undefined", function() {
    this.assert(void 0 === o10(this, "object"), "expected #{this} to be undefined", "expected #{this} not to be undefined");
  }), n10.addProperty("NaN", function() {
    this.assert(t10.isNaN(o10(this, "object")), "expected #{this} to be NaN", "expected #{this} not to be NaN");
  }), n10.addProperty("exist", c10), n10.addProperty("exists", c10), n10.addProperty("empty", function() {
    var e15, n11 = o10(this, "object"), a11 = o10(this, "ssfi"), i11 = o10(this, "message");
    switch (i11 = i11 ? i11 + ": " : "", t10.type(n11).toLowerCase()) {
      case "array":
      case "string":
        e15 = n11.length;
        break;
      case "map":
      case "set":
        e15 = n11.size;
        break;
      case "weakmap":
      case "weakset":
        throw new r10(i11 + ".empty was passed a weak collection", void 0, a11);
      case "function":
        var s11 = i11 + ".empty was passed a function " + t10.getName(n11);
        throw new r10(s11.trim(), void 0, a11);
      default:
        if (n11 !== Object(n11)) throw new r10(i11 + ".empty was passed non-string primitive " + t10.inspect(n11), void 0, a11);
        e15 = Object.keys(n11).length;
    }
    this.assert(0 === e15, "expected #{this} to be empty", "expected #{this} not to be empty");
  }), n10.addProperty("arguments", u10), n10.addProperty("Arguments", u10), n10.addMethod("equal", d10), n10.addMethod("equals", d10), n10.addMethod("eq", d10), n10.addMethod("eql", p10), n10.addMethod("eqls", p10), n10.addMethod("above", m10), n10.addMethod("gt", m10), n10.addMethod("greaterThan", m10), n10.addMethod("least", h10), n10.addMethod("gte", h10), n10.addMethod("greaterThanOrEqual", h10), n10.addMethod("below", f10), n10.addMethod("lt", f10), n10.addMethod("lessThan", f10), n10.addMethod("most", g10), n10.addMethod("lte", g10), n10.addMethod("lessThanOrEqual", g10), n10.addMethod("within", function(e15, a11, i11) {
    i11 && o10(this, "message", i11);
    var s11, l11 = o10(this, "object"), c11 = o10(this, "doLength"), u11 = o10(this, "message"), d11 = u11 ? u11 + ": " : "", p11 = o10(this, "ssfi"), m11 = t10.type(l11).toLowerCase(), h11 = t10.type(e15).toLowerCase(), f11 = t10.type(a11).toLowerCase(), g11 = true, y11 = "date" === h11 && "date" === f11 ? e15.toISOString() + ".." + a11.toISOString() : e15 + ".." + a11;
    if (c11 && "map" !== m11 && "set" !== m11 && new n10(l11, u11, p11, true).to.have.property("length"), c11 || "date" !== m11 || "date" === h11 && "date" === f11) if ("number" === h11 && "number" === f11 || !c11 && "number" !== m11) if (c11 || "date" === m11 || "number" === m11) g11 = false;
    else {
      s11 = d11 + "expected " + ("string" === m11 ? "'" + l11 + "'" : l11) + " to be a number or a date";
    }
    else s11 = d11 + "the arguments to within must be numbers";
    else s11 = d11 + "the arguments to within must be dates";
    if (g11) throw new r10(s11, void 0, p11);
    if (c11) {
      var v11, b11 = "length";
      "map" === m11 || "set" === m11 ? (b11 = "size", v11 = l11.size) : v11 = l11.length, this.assert(v11 >= e15 && v11 <= a11, "expected #{this} to have a " + b11 + " within " + y11, "expected #{this} to not have a " + b11 + " within " + y11);
    } else this.assert(l11 >= e15 && l11 <= a11, "expected #{this} to be within " + y11, "expected #{this} to not be within " + y11);
  }), n10.addMethod("instanceof", y10), n10.addMethod("instanceOf", y10), n10.addMethod("property", v10), n10.addMethod("ownProperty", b10), n10.addMethod("haveOwnProperty", b10), n10.addMethod("ownPropertyDescriptor", S10), n10.addMethod("haveOwnPropertyDescriptor", S10), n10.addChainableMethod("length", x10, C10), n10.addChainableMethod("lengthOf", x10, C10), n10.addMethod("match", w10), n10.addMethod("matches", w10), n10.addMethod("string", function(e15, r11) {
    r11 && o10(this, "message", r11);
    var a11 = o10(this, "object"), i11 = o10(this, "message"), s11 = o10(this, "ssfi");
    new n10(a11, i11, s11, true).is.a("string"), this.assert(~a11.indexOf(e15), "expected #{this} to contain " + t10.inspect(e15), "expected #{this} to not contain " + t10.inspect(e15));
  }), n10.addMethod("keys", T10), n10.addMethod("key", T10), n10.addMethod("throw", E10), n10.addMethod("throws", E10), n10.addMethod("Throw", E10), n10.addMethod("respondTo", F10), n10.addMethod("respondsTo", F10), n10.addProperty("itself", function() {
    o10(this, "itself", true);
  }), n10.addMethod("satisfy", M10), n10.addMethod("satisfies", M10), n10.addMethod("closeTo", k10), n10.addMethod("approximately", k10), n10.addMethod("members", function(e15, t11) {
    t11 && o10(this, "message", t11);
    var r11 = o10(this, "object"), a11 = o10(this, "message"), i11 = o10(this, "ssfi");
    new n10(r11, a11, i11, true).to.be.an("array"), new n10(e15, a11, i11, true).to.be.an("array");
    var s11 = o10(this, "contains");
    var l11 = o10(this, "ordered");
    var c11, u11, d11;
    s11 ? (u11 = "expected #{this} to be " + (c11 = l11 ? "an ordered superset" : "a superset") + " of #{exp}", d11 = "expected #{this} to not be " + c11 + " of #{exp}") : (u11 = "expected #{this} to have the same " + (c11 = l11 ? "ordered members" : "members") + " as #{exp}", d11 = "expected #{this} to not have the same " + c11 + " as #{exp}");
    var p11 = o10(this, "deep") ? o10(this, "eql") : void 0;
    this.assert(function(e16, t12, n11, r12, o11) {
      if (!r12) {
        if (e16.length !== t12.length) return false;
        t12 = t12.slice();
      }
      return e16.every(function(e17, a12) {
        if (o11) return n11 ? n11(e17, t12[a12]) : e17 === t12[a12];
        if (!n11) {
          var i12 = t12.indexOf(e17);
          return -1 !== i12 && (r12 || t12.splice(i12, 1), true);
        }
        return t12.some(function(o12, a13) {
          return !!n11(e17, o12) && (r12 || t12.splice(a13, 1), true);
        });
      });
    }(e15, r11, p11, s11, l11), u11, d11, e15, r11, true);
  }), n10.addMethod("oneOf", function(e15, t11) {
    t11 && o10(this, "message", t11);
    var r11 = o10(this, "object"), a11 = o10(this, "message"), i11 = o10(this, "ssfi"), s11 = o10(this, "contains"), l11 = o10(this, "deep"), c11 = o10(this, "eql");
    new n10(e15, a11, i11, true).to.be.an("array"), s11 ? this.assert(e15.some(function(e16) {
      return r11.indexOf(e16) > -1;
    }), "expected #{this} to contain one of #{exp}", "expected #{this} to not contain one of #{exp}", e15, r11) : l11 ? this.assert(e15.some(function(e16) {
      return c11(r11, e16);
    }), "expected #{this} to deeply equal one of #{exp}", "expected #{this} to deeply equal one of #{exp}", e15, r11) : this.assert(e15.indexOf(r11) > -1, "expected #{this} to be one of #{exp}", "expected #{this} to not be one of #{exp}", e15, r11);
  }), n10.addMethod("change", P10), n10.addMethod("changes", P10), n10.addMethod("increase", N10), n10.addMethod("increases", N10), n10.addMethod("decrease", D10), n10.addMethod("decreases", D10), n10.addMethod("by", function(e15, t11) {
    t11 && o10(this, "message", t11);
    var n11 = o10(this, "deltaMsgObj");
    var r11 = o10(this, "initialDeltaValue");
    var a11 = o10(this, "finalDeltaValue");
    var i11 = o10(this, "deltaBehavior");
    var s11 = o10(this, "realDelta");
    var l11;
    l11 = "change" === i11 ? Math.abs(a11 - r11) === Math.abs(e15) : s11 === Math.abs(e15), this.assert(l11, "expected " + n11 + " to " + i11 + " by " + e15, "expected " + n11 + " to not " + i11 + " by " + e15);
  }), n10.addProperty("extensible", function() {
    var e15 = o10(this, "object");
    var t11 = e15 === Object(e15) && Object.isExtensible(e15);
    this.assert(t11, "expected #{this} to be extensible", "expected #{this} to not be extensible");
  }), n10.addProperty("sealed", function() {
    var e15 = o10(this, "object");
    var t11 = e15 !== Object(e15) || Object.isSealed(e15);
    this.assert(t11, "expected #{this} to be sealed", "expected #{this} to not be sealed");
  }), n10.addProperty("frozen", function() {
    var e15 = o10(this, "object");
    var t11 = e15 !== Object(e15) || Object.isFrozen(e15);
    this.assert(t11, "expected #{this} to be frozen", "expected #{this} to not be frozen");
  }), n10.addProperty("finite", function(e15) {
    var t11 = o10(this, "object");
    this.assert("number" == typeof t11 && isFinite(t11), "expected #{this} to be a finite number", "expected #{this} to not be a finite number");
  });
};
/*!
 * chai
 * Copyright(c) 2011-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
var TZe = function(e14, t10) {
  e14.expect = function(t11, n10) {
    return new e14.Assertion(t11, n10);
  }, e14.expect.fail = function(t11, n10, r10, o10) {
    throw arguments.length < 2 && (r10 = t11, t11 = void 0), r10 = r10 || "expect.fail()", new e14.AssertionError(r10, { actual: t11, expected: n10, operator: o10 }, e14.expect.fail);
  };
};
/*!
 * chai
 * Copyright(c) 2011-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
var EZe = function(e14, t10) {
  var n10 = e14.Assertion;
  function r10() {
    Object.defineProperty(Object.prototype, "should", { set: function(e15) {
      Object.defineProperty(this, "should", { value: e15, enumerable: true, configurable: true, writable: true });
    }, get: function e15() {
      return this instanceof String || this instanceof Number || this instanceof Boolean || "function" == typeof Symbol && this instanceof Symbol || "function" == typeof BigInt && this instanceof BigInt ? new n10(this.valueOf(), null, e15) : new n10(this, null, e15);
    }, configurable: true });
    var t11 = {};
    return t11.fail = function(n11, r11, o10, a10) {
      throw arguments.length < 2 && (o10 = n11, n11 = void 0), o10 = o10 || "should.fail()", new e14.AssertionError(o10, { actual: n11, expected: r11, operator: a10 }, t11.fail);
    }, t11.equal = function(e15, t12, r11) {
      new n10(e15, r11).to.equal(t12);
    }, t11.Throw = function(e15, t12, r11, o10) {
      new n10(e15, o10).to.Throw(t12, r11);
    }, t11.exist = function(e15, t12) {
      new n10(e15, t12).to.exist;
    }, t11.not = {}, t11.not.equal = function(e15, t12, r11) {
      new n10(e15, r11).to.not.equal(t12);
    }, t11.not.Throw = function(e15, t12, r11, o10) {
      new n10(e15, o10).to.not.Throw(t12, r11);
    }, t11.not.exist = function(e15, t12) {
      new n10(e15, t12).to.not.exist;
    }, t11.throw = t11.Throw, t11.not.throw = t11.not.Throw, t11;
  }
  e14.should = r10, e14.Should = r10;
};
/*!
 * chai
 * Copyright(c) 2011-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
var FZe = function(e14, t10) {
  /*!
     * Chai dependencies.
     */
  var n10 = e14.Assertion, r10 = t10.flag;
  /*!
     * Module export.
     */
  var o10 = e14.assert = function(t11, r11) {
    new n10(null, null, e14.assert, true).assert(t11, r11, "[ negation message unavailable ]");
  };
  o10.fail = function(t11, n11, r11, a10) {
    throw arguments.length < 2 && (r11 = t11, t11 = void 0), r11 = r11 || "assert.fail()", new e14.AssertionError(r11, { actual: t11, expected: n11, operator: a10 }, o10.fail);
  }, o10.isOk = function(e15, t11) {
    new n10(e15, t11, o10.isOk, true).is.ok;
  }, o10.isNotOk = function(e15, t11) {
    new n10(e15, t11, o10.isNotOk, true).is.not.ok;
  }, o10.equal = function(e15, t11, a10) {
    var i10 = new n10(e15, a10, o10.equal, true);
    i10.assert(t11 == r10(i10, "object"), "expected #{this} to equal #{exp}", "expected #{this} to not equal #{act}", t11, e15, true);
  }, o10.notEqual = function(e15, t11, a10) {
    var i10 = new n10(e15, a10, o10.notEqual, true);
    i10.assert(t11 != r10(i10, "object"), "expected #{this} to not equal #{exp}", "expected #{this} to equal #{act}", t11, e15, true);
  }, o10.strictEqual = function(e15, t11, r11) {
    new n10(e15, r11, o10.strictEqual, true).to.equal(t11);
  }, o10.notStrictEqual = function(e15, t11, r11) {
    new n10(e15, r11, o10.notStrictEqual, true).to.not.equal(t11);
  }, o10.deepEqual = o10.deepStrictEqual = function(e15, t11, r11) {
    new n10(e15, r11, o10.deepEqual, true).to.eql(t11);
  }, o10.notDeepEqual = function(e15, t11, r11) {
    new n10(e15, r11, o10.notDeepEqual, true).to.not.eql(t11);
  }, o10.isAbove = function(e15, t11, r11) {
    new n10(e15, r11, o10.isAbove, true).to.be.above(t11);
  }, o10.isAtLeast = function(e15, t11, r11) {
    new n10(e15, r11, o10.isAtLeast, true).to.be.least(t11);
  }, o10.isBelow = function(e15, t11, r11) {
    new n10(e15, r11, o10.isBelow, true).to.be.below(t11);
  }, o10.isAtMost = function(e15, t11, r11) {
    new n10(e15, r11, o10.isAtMost, true).to.be.most(t11);
  }, o10.isTrue = function(e15, t11) {
    new n10(e15, t11, o10.isTrue, true).is.true;
  }, o10.isNotTrue = function(e15, t11) {
    new n10(e15, t11, o10.isNotTrue, true).to.not.equal(true);
  }, o10.isFalse = function(e15, t11) {
    new n10(e15, t11, o10.isFalse, true).is.false;
  }, o10.isNotFalse = function(e15, t11) {
    new n10(e15, t11, o10.isNotFalse, true).to.not.equal(false);
  }, o10.isNull = function(e15, t11) {
    new n10(e15, t11, o10.isNull, true).to.equal(null);
  }, o10.isNotNull = function(e15, t11) {
    new n10(e15, t11, o10.isNotNull, true).to.not.equal(null);
  }, o10.isNaN = function(e15, t11) {
    new n10(e15, t11, o10.isNaN, true).to.be.NaN;
  }, o10.isNotNaN = function(e15, t11) {
    new n10(e15, t11, o10.isNotNaN, true).not.to.be.NaN;
  }, o10.exists = function(e15, t11) {
    new n10(e15, t11, o10.exists, true).to.exist;
  }, o10.notExists = function(e15, t11) {
    new n10(e15, t11, o10.notExists, true).to.not.exist;
  }, o10.isUndefined = function(e15, t11) {
    new n10(e15, t11, o10.isUndefined, true).to.equal(void 0);
  }, o10.isDefined = function(e15, t11) {
    new n10(e15, t11, o10.isDefined, true).to.not.equal(void 0);
  }, o10.isFunction = function(e15, t11) {
    new n10(e15, t11, o10.isFunction, true).to.be.a("function");
  }, o10.isNotFunction = function(e15, t11) {
    new n10(e15, t11, o10.isNotFunction, true).to.not.be.a("function");
  }, o10.isObject = function(e15, t11) {
    new n10(e15, t11, o10.isObject, true).to.be.a("object");
  }, o10.isNotObject = function(e15, t11) {
    new n10(e15, t11, o10.isNotObject, true).to.not.be.a("object");
  }, o10.isArray = function(e15, t11) {
    new n10(e15, t11, o10.isArray, true).to.be.an("array");
  }, o10.isNotArray = function(e15, t11) {
    new n10(e15, t11, o10.isNotArray, true).to.not.be.an("array");
  }, o10.isString = function(e15, t11) {
    new n10(e15, t11, o10.isString, true).to.be.a("string");
  }, o10.isNotString = function(e15, t11) {
    new n10(e15, t11, o10.isNotString, true).to.not.be.a("string");
  }, o10.isNumber = function(e15, t11) {
    new n10(e15, t11, o10.isNumber, true).to.be.a("number");
  }, o10.isNotNumber = function(e15, t11) {
    new n10(e15, t11, o10.isNotNumber, true).to.not.be.a("number");
  }, o10.isFinite = function(e15, t11) {
    new n10(e15, t11, o10.isFinite, true).to.be.finite;
  }, o10.isBoolean = function(e15, t11) {
    new n10(e15, t11, o10.isBoolean, true).to.be.a("boolean");
  }, o10.isNotBoolean = function(e15, t11) {
    new n10(e15, t11, o10.isNotBoolean, true).to.not.be.a("boolean");
  }, o10.typeOf = function(e15, t11, r11) {
    new n10(e15, r11, o10.typeOf, true).to.be.a(t11);
  }, o10.notTypeOf = function(e15, t11, r11) {
    new n10(e15, r11, o10.notTypeOf, true).to.not.be.a(t11);
  }, o10.instanceOf = function(e15, t11, r11) {
    new n10(e15, r11, o10.instanceOf, true).to.be.instanceOf(t11);
  }, o10.notInstanceOf = function(e15, t11, r11) {
    new n10(e15, r11, o10.notInstanceOf, true).to.not.be.instanceOf(t11);
  }, o10.include = function(e15, t11, r11) {
    new n10(e15, r11, o10.include, true).include(t11);
  }, o10.notInclude = function(e15, t11, r11) {
    new n10(e15, r11, o10.notInclude, true).not.include(t11);
  }, o10.deepInclude = function(e15, t11, r11) {
    new n10(e15, r11, o10.deepInclude, true).deep.include(t11);
  }, o10.notDeepInclude = function(e15, t11, r11) {
    new n10(e15, r11, o10.notDeepInclude, true).not.deep.include(t11);
  }, o10.nestedInclude = function(e15, t11, r11) {
    new n10(e15, r11, o10.nestedInclude, true).nested.include(t11);
  }, o10.notNestedInclude = function(e15, t11, r11) {
    new n10(e15, r11, o10.notNestedInclude, true).not.nested.include(t11);
  }, o10.deepNestedInclude = function(e15, t11, r11) {
    new n10(e15, r11, o10.deepNestedInclude, true).deep.nested.include(t11);
  }, o10.notDeepNestedInclude = function(e15, t11, r11) {
    new n10(e15, r11, o10.notDeepNestedInclude, true).not.deep.nested.include(t11);
  }, o10.ownInclude = function(e15, t11, r11) {
    new n10(e15, r11, o10.ownInclude, true).own.include(t11);
  }, o10.notOwnInclude = function(e15, t11, r11) {
    new n10(e15, r11, o10.notOwnInclude, true).not.own.include(t11);
  }, o10.deepOwnInclude = function(e15, t11, r11) {
    new n10(e15, r11, o10.deepOwnInclude, true).deep.own.include(t11);
  }, o10.notDeepOwnInclude = function(e15, t11, r11) {
    new n10(e15, r11, o10.notDeepOwnInclude, true).not.deep.own.include(t11);
  }, o10.match = function(e15, t11, r11) {
    new n10(e15, r11, o10.match, true).to.match(t11);
  }, o10.notMatch = function(e15, t11, r11) {
    new n10(e15, r11, o10.notMatch, true).to.not.match(t11);
  }, o10.property = function(e15, t11, r11) {
    new n10(e15, r11, o10.property, true).to.have.property(t11);
  }, o10.notProperty = function(e15, t11, r11) {
    new n10(e15, r11, o10.notProperty, true).to.not.have.property(t11);
  }, o10.propertyVal = function(e15, t11, r11, a10) {
    new n10(e15, a10, o10.propertyVal, true).to.have.property(t11, r11);
  }, o10.notPropertyVal = function(e15, t11, r11, a10) {
    new n10(e15, a10, o10.notPropertyVal, true).to.not.have.property(t11, r11);
  }, o10.deepPropertyVal = function(e15, t11, r11, a10) {
    new n10(e15, a10, o10.deepPropertyVal, true).to.have.deep.property(t11, r11);
  }, o10.notDeepPropertyVal = function(e15, t11, r11, a10) {
    new n10(e15, a10, o10.notDeepPropertyVal, true).to.not.have.deep.property(t11, r11);
  }, o10.ownProperty = function(e15, t11, r11) {
    new n10(e15, r11, o10.ownProperty, true).to.have.own.property(t11);
  }, o10.notOwnProperty = function(e15, t11, r11) {
    new n10(e15, r11, o10.notOwnProperty, true).to.not.have.own.property(t11);
  }, o10.ownPropertyVal = function(e15, t11, r11, a10) {
    new n10(e15, a10, o10.ownPropertyVal, true).to.have.own.property(t11, r11);
  }, o10.notOwnPropertyVal = function(e15, t11, r11, a10) {
    new n10(e15, a10, o10.notOwnPropertyVal, true).to.not.have.own.property(t11, r11);
  }, o10.deepOwnPropertyVal = function(e15, t11, r11, a10) {
    new n10(e15, a10, o10.deepOwnPropertyVal, true).to.have.deep.own.property(t11, r11);
  }, o10.notDeepOwnPropertyVal = function(e15, t11, r11, a10) {
    new n10(e15, a10, o10.notDeepOwnPropertyVal, true).to.not.have.deep.own.property(t11, r11);
  }, o10.nestedProperty = function(e15, t11, r11) {
    new n10(e15, r11, o10.nestedProperty, true).to.have.nested.property(t11);
  }, o10.notNestedProperty = function(e15, t11, r11) {
    new n10(e15, r11, o10.notNestedProperty, true).to.not.have.nested.property(t11);
  }, o10.nestedPropertyVal = function(e15, t11, r11, a10) {
    new n10(e15, a10, o10.nestedPropertyVal, true).to.have.nested.property(t11, r11);
  }, o10.notNestedPropertyVal = function(e15, t11, r11, a10) {
    new n10(e15, a10, o10.notNestedPropertyVal, true).to.not.have.nested.property(t11, r11);
  }, o10.deepNestedPropertyVal = function(e15, t11, r11, a10) {
    new n10(e15, a10, o10.deepNestedPropertyVal, true).to.have.deep.nested.property(t11, r11);
  }, o10.notDeepNestedPropertyVal = function(e15, t11, r11, a10) {
    new n10(e15, a10, o10.notDeepNestedPropertyVal, true).to.not.have.deep.nested.property(t11, r11);
  }, o10.lengthOf = function(e15, t11, r11) {
    new n10(e15, r11, o10.lengthOf, true).to.have.lengthOf(t11);
  }, o10.hasAnyKeys = function(e15, t11, r11) {
    new n10(e15, r11, o10.hasAnyKeys, true).to.have.any.keys(t11);
  }, o10.hasAllKeys = function(e15, t11, r11) {
    new n10(e15, r11, o10.hasAllKeys, true).to.have.all.keys(t11);
  }, o10.containsAllKeys = function(e15, t11, r11) {
    new n10(e15, r11, o10.containsAllKeys, true).to.contain.all.keys(t11);
  }, o10.doesNotHaveAnyKeys = function(e15, t11, r11) {
    new n10(e15, r11, o10.doesNotHaveAnyKeys, true).to.not.have.any.keys(t11);
  }, o10.doesNotHaveAllKeys = function(e15, t11, r11) {
    new n10(e15, r11, o10.doesNotHaveAllKeys, true).to.not.have.all.keys(t11);
  }, o10.hasAnyDeepKeys = function(e15, t11, r11) {
    new n10(e15, r11, o10.hasAnyDeepKeys, true).to.have.any.deep.keys(t11);
  }, o10.hasAllDeepKeys = function(e15, t11, r11) {
    new n10(e15, r11, o10.hasAllDeepKeys, true).to.have.all.deep.keys(t11);
  }, o10.containsAllDeepKeys = function(e15, t11, r11) {
    new n10(e15, r11, o10.containsAllDeepKeys, true).to.contain.all.deep.keys(t11);
  }, o10.doesNotHaveAnyDeepKeys = function(e15, t11, r11) {
    new n10(e15, r11, o10.doesNotHaveAnyDeepKeys, true).to.not.have.any.deep.keys(t11);
  }, o10.doesNotHaveAllDeepKeys = function(e15, t11, r11) {
    new n10(e15, r11, o10.doesNotHaveAllDeepKeys, true).to.not.have.all.deep.keys(t11);
  }, o10.throws = function(e15, t11, a10, i10) {
    ("string" == typeof t11 || t11 instanceof RegExp) && (a10 = t11, t11 = null);
    var s10 = new n10(e15, i10, o10.throws, true).to.throw(t11, a10);
    return r10(s10, "object");
  }, o10.doesNotThrow = function(e15, t11, r11, a10) {
    ("string" == typeof t11 || t11 instanceof RegExp) && (r11 = t11, t11 = null), new n10(e15, a10, o10.doesNotThrow, true).to.not.throw(t11, r11);
  }, o10.operator = function(a10, i10, s10, l10) {
    var c10;
    switch (i10) {
      case "==":
        c10 = a10 == s10;
        break;
      case "===":
        c10 = a10 === s10;
        break;
      case ">":
        c10 = a10 > s10;
        break;
      case ">=":
        c10 = a10 >= s10;
        break;
      case "<":
        c10 = a10 < s10;
        break;
      case "<=":
        c10 = a10 <= s10;
        break;
      case "!=":
        c10 = a10 != s10;
        break;
      case "!==":
        c10 = a10 !== s10;
        break;
      default:
        throw l10 = l10 ? l10 + ": " : l10, new e14.AssertionError(l10 + 'Invalid operator "' + i10 + '"', void 0, o10.operator);
    }
    var u10 = new n10(c10, l10, o10.operator, true);
    u10.assert(true === r10(u10, "object"), "expected " + t10.inspect(a10) + " to be " + i10 + " " + t10.inspect(s10), "expected " + t10.inspect(a10) + " to not be " + i10 + " " + t10.inspect(s10));
  }, o10.closeTo = function(e15, t11, r11, a10) {
    new n10(e15, a10, o10.closeTo, true).to.be.closeTo(t11, r11);
  }, o10.approximately = function(e15, t11, r11, a10) {
    new n10(e15, a10, o10.approximately, true).to.be.approximately(t11, r11);
  }, o10.sameMembers = function(e15, t11, r11) {
    new n10(e15, r11, o10.sameMembers, true).to.have.same.members(t11);
  }, o10.notSameMembers = function(e15, t11, r11) {
    new n10(e15, r11, o10.notSameMembers, true).to.not.have.same.members(t11);
  }, o10.sameDeepMembers = function(e15, t11, r11) {
    new n10(e15, r11, o10.sameDeepMembers, true).to.have.same.deep.members(t11);
  }, o10.notSameDeepMembers = function(e15, t11, r11) {
    new n10(e15, r11, o10.notSameDeepMembers, true).to.not.have.same.deep.members(t11);
  }, o10.sameOrderedMembers = function(e15, t11, r11) {
    new n10(e15, r11, o10.sameOrderedMembers, true).to.have.same.ordered.members(t11);
  }, o10.notSameOrderedMembers = function(e15, t11, r11) {
    new n10(e15, r11, o10.notSameOrderedMembers, true).to.not.have.same.ordered.members(t11);
  }, o10.sameDeepOrderedMembers = function(e15, t11, r11) {
    new n10(e15, r11, o10.sameDeepOrderedMembers, true).to.have.same.deep.ordered.members(t11);
  }, o10.notSameDeepOrderedMembers = function(e15, t11, r11) {
    new n10(e15, r11, o10.notSameDeepOrderedMembers, true).to.not.have.same.deep.ordered.members(t11);
  }, o10.includeMembers = function(e15, t11, r11) {
    new n10(e15, r11, o10.includeMembers, true).to.include.members(t11);
  }, o10.notIncludeMembers = function(e15, t11, r11) {
    new n10(e15, r11, o10.notIncludeMembers, true).to.not.include.members(t11);
  }, o10.includeDeepMembers = function(e15, t11, r11) {
    new n10(e15, r11, o10.includeDeepMembers, true).to.include.deep.members(t11);
  }, o10.notIncludeDeepMembers = function(e15, t11, r11) {
    new n10(e15, r11, o10.notIncludeDeepMembers, true).to.not.include.deep.members(t11);
  }, o10.includeOrderedMembers = function(e15, t11, r11) {
    new n10(e15, r11, o10.includeOrderedMembers, true).to.include.ordered.members(t11);
  }, o10.notIncludeOrderedMembers = function(e15, t11, r11) {
    new n10(e15, r11, o10.notIncludeOrderedMembers, true).to.not.include.ordered.members(t11);
  }, o10.includeDeepOrderedMembers = function(e15, t11, r11) {
    new n10(e15, r11, o10.includeDeepOrderedMembers, true).to.include.deep.ordered.members(t11);
  }, o10.notIncludeDeepOrderedMembers = function(e15, t11, r11) {
    new n10(e15, r11, o10.notIncludeDeepOrderedMembers, true).to.not.include.deep.ordered.members(t11);
  }, o10.oneOf = function(e15, t11, r11) {
    new n10(e15, r11, o10.oneOf, true).to.be.oneOf(t11);
  }, o10.changes = function(e15, t11, r11, a10) {
    3 === arguments.length && "function" == typeof t11 && (a10 = r11, r11 = null), new n10(e15, a10, o10.changes, true).to.change(t11, r11);
  }, o10.changesBy = function(e15, t11, r11, a10, i10) {
    if (4 === arguments.length && "function" == typeof t11) {
      var s10 = a10;
      a10 = r11, i10 = s10;
    } else 3 === arguments.length && (a10 = r11, r11 = null);
    new n10(e15, i10, o10.changesBy, true).to.change(t11, r11).by(a10);
  }, o10.doesNotChange = function(e15, t11, r11, a10) {
    return 3 === arguments.length && "function" == typeof t11 && (a10 = r11, r11 = null), new n10(e15, a10, o10.doesNotChange, true).to.not.change(t11, r11);
  }, o10.changesButNotBy = function(e15, t11, r11, a10, i10) {
    if (4 === arguments.length && "function" == typeof t11) {
      var s10 = a10;
      a10 = r11, i10 = s10;
    } else 3 === arguments.length && (a10 = r11, r11 = null);
    new n10(e15, i10, o10.changesButNotBy, true).to.change(t11, r11).but.not.by(a10);
  }, o10.increases = function(e15, t11, r11, a10) {
    return 3 === arguments.length && "function" == typeof t11 && (a10 = r11, r11 = null), new n10(e15, a10, o10.increases, true).to.increase(t11, r11);
  }, o10.increasesBy = function(e15, t11, r11, a10, i10) {
    if (4 === arguments.length && "function" == typeof t11) {
      var s10 = a10;
      a10 = r11, i10 = s10;
    } else 3 === arguments.length && (a10 = r11, r11 = null);
    new n10(e15, i10, o10.increasesBy, true).to.increase(t11, r11).by(a10);
  }, o10.doesNotIncrease = function(e15, t11, r11, a10) {
    return 3 === arguments.length && "function" == typeof t11 && (a10 = r11, r11 = null), new n10(e15, a10, o10.doesNotIncrease, true).to.not.increase(t11, r11);
  }, o10.increasesButNotBy = function(e15, t11, r11, a10, i10) {
    if (4 === arguments.length && "function" == typeof t11) {
      var s10 = a10;
      a10 = r11, i10 = s10;
    } else 3 === arguments.length && (a10 = r11, r11 = null);
    new n10(e15, i10, o10.increasesButNotBy, true).to.increase(t11, r11).but.not.by(a10);
  }, o10.decreases = function(e15, t11, r11, a10) {
    return 3 === arguments.length && "function" == typeof t11 && (a10 = r11, r11 = null), new n10(e15, a10, o10.decreases, true).to.decrease(t11, r11);
  }, o10.decreasesBy = function(e15, t11, r11, a10, i10) {
    if (4 === arguments.length && "function" == typeof t11) {
      var s10 = a10;
      a10 = r11, i10 = s10;
    } else 3 === arguments.length && (a10 = r11, r11 = null);
    new n10(e15, i10, o10.decreasesBy, true).to.decrease(t11, r11).by(a10);
  }, o10.doesNotDecrease = function(e15, t11, r11, a10) {
    return 3 === arguments.length && "function" == typeof t11 && (a10 = r11, r11 = null), new n10(e15, a10, o10.doesNotDecrease, true).to.not.decrease(t11, r11);
  }, o10.doesNotDecreaseBy = function(e15, t11, r11, a10, i10) {
    if (4 === arguments.length && "function" == typeof t11) {
      var s10 = a10;
      a10 = r11, i10 = s10;
    } else 3 === arguments.length && (a10 = r11, r11 = null);
    return new n10(e15, i10, o10.doesNotDecreaseBy, true).to.not.decrease(t11, r11).by(a10);
  }, o10.decreasesButNotBy = function(e15, t11, r11, a10, i10) {
    if (4 === arguments.length && "function" == typeof t11) {
      var s10 = a10;
      a10 = r11, i10 = s10;
    } else 3 === arguments.length && (a10 = r11, r11 = null);
    new n10(e15, i10, o10.decreasesButNotBy, true).to.decrease(t11, r11).but.not.by(a10);
  }, /*!
     * ### .ifError(object)
     *
     * Asserts if value is not a false value, and throws if it is a true value.
     * This is added to allow for chai to be a drop-in replacement for Node's
     * assert class.
     *
     *     var err = new Error('I am a custom error');
     *     assert.ifError(err); // Rethrows err!
     *
     * @name ifError
     * @param {Object} object
     * @namespace Assert
     * @api public
     */
  o10.ifError = function(e15) {
    if (e15) throw e15;
  }, o10.isExtensible = function(e15, t11) {
    new n10(e15, t11, o10.isExtensible, true).to.be.extensible;
  }, o10.isNotExtensible = function(e15, t11) {
    new n10(e15, t11, o10.isNotExtensible, true).to.not.be.extensible;
  }, o10.isSealed = function(e15, t11) {
    new n10(e15, t11, o10.isSealed, true).to.be.sealed;
  }, o10.isNotSealed = function(e15, t11) {
    new n10(e15, t11, o10.isNotSealed, true).to.not.be.sealed;
  }, o10.isFrozen = function(e15, t11) {
    new n10(e15, t11, o10.isFrozen, true).to.be.frozen;
  }, o10.isNotFrozen = function(e15, t11) {
    new n10(e15, t11, o10.isNotFrozen, true).to.not.be.frozen;
  }, o10.isEmpty = function(e15, t11) {
    new n10(e15, t11, o10.isEmpty, true).to.be.empty;
  }, o10.isNotEmpty = function(e15, t11) {
    new n10(e15, t11, o10.isNotEmpty, true).to.not.be.empty;
  }, /*!
     * Aliases.
     */
  function e15(t11, n11) {
    return o10[n11] = o10[t11], e15;
  }("isOk", "ok")("isNotOk", "notOk")("throws", "throw")("throws", "Throw")("isExtensible", "extensible")("isNotExtensible", "notExtensible")("isSealed", "sealed")("isNotSealed", "notSealed")("isFrozen", "frozen")("isNotFrozen", "notFrozen")("isEmpty", "empty")("isNotEmpty", "notEmpty");
};
/*!
 * chai
 * Copyright(c) 2011-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
var MZe;
function kZe() {
  return MZe || (MZe = 1, function(e14) {
    var t10 = [];
    /*!
    		 * Chai version
    		 */
    e14.version = "4.3.8", /*!
    		 * Assertion Error
    		 */
    e14.AssertionError = BWe;
    /*!
    		 * Utils for plugins (not exported)
    		 */
    var n10 = SZe();
    e14.use = function(r11) {
      return ~t10.indexOf(r11) || (r11(e14, n10), t10.push(r11)), e14;
    }, /*!
    		 * Utility Functions
    		 */
    e14.util = n10;
    /*!
    		 * Configuration
    		 */
    var r10 = cje;
    e14.config = r10;
    /*!
    		 * Primary `Assertion` prototype
    		 */
    var o10 = xZe;
    e14.use(o10);
    /*!
    		 * Core Assertions
    		 */
    var a10 = wZe;
    e14.use(a10);
    /*!
    		 * Expect interface
    		 */
    var i10 = TZe;
    e14.use(i10);
    /*!
    		 * Should interface
    		 */
    var s10 = EZe;
    e14.use(s10);
    /*!
    		 * Assert interface
    		 */
    var l10 = FZe;
    e14.use(l10);
  }(AWe)), AWe;
}
var PZe = W(kZe());
const NZe = PZe.expect;
PZe.version, PZe.Assertion, PZe.AssertionError, PZe.util, PZe.config, PZe.use, PZe.should, PZe.assert, PZe.core;
const DZe = ["Corner", "RowHierarchy", "ColumnHierarchy", "Body"];
const LZe = ["Members", "LevelSizes"];
const HZe = ["Columns", "Rows"];
const IZe = ["Cells", "Height"];
const _Ze = Array.name;
function VZe(e14) {
  function t10(e15) {
    const t11 = [];
    return function e16(n11) {
      n11.forEach((n12) => {
        !function(e17) {
          return e17 && Array.isArray(e17) && e17.length > 0;
        }(n12.Children) ? t11.push(n12) : e16(n12.Children);
      });
    }(e15), t11;
  }
  function n10(e15) {
    return function e16(t11) {
      const n11 = GJ(t11);
      if ((t11.Children || []).length > 0) {
        return n11 === t11.Children.reduce((e17, t12) => e17 + GJ(t12), 0) && t11.Children.every((t12) => e16(t12));
      }
      return 1 === n11;
    }(e15);
  }
  function r10(e15) {
    return function e16(t11) {
      const n11 = !t11.Group && !t11.Header;
      const r11 = (t11.Children || []).length;
      return n11 ? 0 === r11 : !(r11 > 0) || t11.Children.every((t12) => e16(t12));
    }(e15);
  }
  function o10(e15, t11) {
    return function e16(n11, r11) {
      const o11 = (n11.Children || []).length;
      const a11 = r11 + ZJ(n11);
      return o11 > 0 ? n11.Children.every((t12) => e16(t12, a11)) : a11 === t11;
    }(e15, 0);
  }
  const a10 = (e15) => t10(e15.Members);
  const i10 = (t11, n11) => NZe(t11, `Tablix ${e14.Name}: ${n11}`);
  DZe.forEach((t11) => {
    i10(e14, `property ${t11} is not present`).to.contain.keys(t11);
  }), i10(e14.Corner || [], "Corner is invalid").to.be.an(_Ze), LZe.forEach((t11) => {
    i10(e14.RowHierarchy, `RowHierarchy property ${t11} is not present`);
  }), i10(e14.RowHierarchy.Members, "RowHierarchy.Members is not an array").to.be.an(_Ze), i10(e14.RowHierarchy.LevelSizes, "RowHierarchy.LevelSizes is not an array").to.be.an(_Ze), LZe.forEach((t11) => {
    i10(e14.ColumnHierarchy, `ColumnHierarchy property ${t11} is not present`);
  }), i10(e14.ColumnHierarchy.Members, "ColumnHierarchy.Members is not an array").to.be.an(_Ze), i10(e14.ColumnHierarchy.LevelSizes, "ColumnHierarchy.LevelSizes is not an array").to.be.an(_Ze), HZe.forEach((t11) => {
    i10(e14.Body, `Body property ${t11} is not present`);
  }), i10(e14.Body.Columns, "Body.Columns is not an array").to.be.an(_Ze), i10(e14.Body.Rows, "Body.Rows is not an array").to.be.an(_Ze);
  const s10 = e14.Corner;
  s10 && s10.length > 0 && (i10(s10.length, "Corner.length !== ColumnHierarchy.LevelSizes.length").to.equal(e14.ColumnHierarchy.LevelSizes.length), s10.forEach((t11, n11) => {
    i10(t11, `Corner[${n11}] is not an array`).to.be.an(_Ze), i10(t11.length, `Corner[${n11}].length !== RowHierarchy.LevelSizes.length`).to.equal(e14.RowHierarchy.LevelSizes.length);
  }), i10(function(e15) {
    if (0 === (e15 != null ? e15 : []).length) return true;
    let t11 = 0 !== e15.length ? e15.length * e15[0].length : 0;
    for (let n11 = 0; n11 < e15.length; n11++) {
      const r11 = e15[n11];
      for (let o11 = 0; o11 < r11.length; o11++) {
        const a11 = r11[o11];
        if (!a11) continue;
        t11--;
        const i11 = a11.RowSpan || 1;
        const s11 = a11.ColSpan || 1;
        for (let r12 = n11; r12 < n11 + i11; r12++) for (let a12 = o11; a12 < o11 + s11; a12++) if (r12 !== n11 || a12 !== o11) {
          if (e15[r12][a12]) return false;
          t11--;
        }
      }
    }
    return 0 === t11;
  }(s10), "some Corner cell span is invalid").to.be.true);
  const l10 = a10(e14.ColumnHierarchy);
  l10.forEach((e15, t11) => i10(e15.BodyIndex, `ColumnHierarchy ${t11}-th leaf member BodyIndex !== ${t11}`).to.equal(t11)), e14.ColumnHierarchy.Members.forEach((e15) => i10(n10(e15), "some ColumnHierarchy member BodyCount is invalid").to.be.true), e14.ColumnHierarchy.Members.forEach((e15) => {
    i10(r10(e15), "ColumnHierarchy structure is invalid - it contains hidden static members that are not leaves").to.be.true;
  }), e14.ColumnHierarchy.Members.forEach((t11) => {
    i10(o10(t11, e14.ColumnHierarchy.LevelSizes.length), "in some ColumnHierarchy branch LevelCount sum !== ColumnHierarchy.LevelSizes.length").to.be.true;
  });
  const c10 = a10(e14.RowHierarchy);
  c10.forEach((e15, t11) => i10(e15.BodyIndex, `RowHierarchy ${t11}-th leaf member BodyIndex !== ${t11}`).to.equal(t11)), e14.RowHierarchy.Members.forEach((e15) => i10(n10(e15), "some RowHierarchy member BodyCount is invalid").to.be.true), e14.RowHierarchy.Members.forEach((e15) => {
    i10(r10(e15), "RowHierarchy structure is invalid - it contains hidden static members that are not leaves").to.be.true;
  }), e14.RowHierarchy.Members.forEach((t11) => {
    i10(o10(t11, e14.RowHierarchy.LevelSizes.length), "in some RowHierarchy branch LevelCount sum !== RowHierarchy.LevelSizes.length").to.be.true;
  });
  const u10 = e14.Body;
  return i10(u10.Columns, "Body.Columns.length !== ColumnHierarchy leaf members count").to.have.length(l10.length), i10(u10.Rows, "Body.Rows.length !== RowHierarchy leaf members count").to.have.length(c10.length), i10(u10.Rows, "Body.Rows contains undefined").not.to.contain(void 0), u10.Rows.forEach((e15, t11) => {
    IZe.forEach((n11) => {
      i10(e15, `Body.Rows[${t11}] property ${n11} is not present`).to.contain.keys(n11);
    }), i10(e15.Cells, `Body.Rows[${t11}].Cells.length !== ColumnHierarchy leaf members count`).to.have.length(l10.length), i10(function(e16) {
      let t12 = e16.length;
      for (let n11 = 0; n11 < e16.length; n11++) {
        const r11 = e16[n11];
        if (!r11) continue;
        if (t12--, 1 !== (r11.RowSpan || 1)) return false;
        const o11 = r11.ColSpan || 1;
        for (let r12 = n11 + 1; r12 < n11 + o11; r12++) {
          if (e16[r12]) return false;
          t12--;
        }
      }
      return 0 === t12;
    }(e15.Cells), `some Body.Rows[${t11}] cell span is invalid`).to.be.true;
  }), true;
}
const RZe = [wWe.HEADER, wWe.GROUP, wWe.DETAILS, wWe.HIDDEN_DETAILS, wWe.GROUP, wWe.FOOTER];
const AZe = (e14, t10) => RZe.findIndex((n10, r10) => t10 <= r10 && e14 === n10);
const OZe = (e14, t10) => {
  let n10 = 0;
  const r10 = (e15, o10 = false) => {
    for (const a10 of e15) if (n10 < t10.length && t10[n10] === wWe.HIDDEN_DETAILS && n10++, NZe(n10, "Members count should not exceed areas count").not.to.equal(t10.length), a10.Children.length) {
      const e16 = t10[n10] === wWe.DETAILS || t10[n10] === wWe.GROUP;
      NZe(e16, "Only group and details area member can have children").to.equal(true), r10(a10.Children, true);
    } else {
      if (a10.Type === rW.dynamicTablixMember) {
        const e16 = t10[n10] === wWe.DETAILS || t10[n10] === wWe.GROUP;
        NZe(e16, "Only group and details area member can be dynamic").to.equal(true);
      } else if (o10) {
        const e16 = t10[n10] === wWe.DETAILS || t10[n10] === wWe.GROUP;
        NZe(e16, "Only group and details area can be bounded by member").to.equal(true);
      } else {
        const e16 = t10[n10] === wWe.HEADER || t10[n10] === wWe.FOOTER;
        NZe(e16, "Only header and footer area can be static without bound members").to.equal(true);
      }
      n10++;
    }
  };
  r10(e14.Members);
};
function BZe(e14) {
  let t10 = true;
  try {
    !function(e15) {
      var _a2;
      const t11 = MWe(e15);
      const n10 = (t12, n11) => NZe(t12, `Table ${e15.Name}: ${n11}`);
      const r10 = (e16) => {
        n10(!!e16.Header, "Hierarchy is not hidden").to.equal(false), e16.Children.forEach(r10);
      };
      n10(e15.ColumnHierarchy.Members.filter((e16) => !!e16.Group || !!e16.Header || !!e16.Children.length).length, "Column hierarchy member is not hidden static").to.equal(0), e15.RowHierarchy.Members.forEach(r10);
      const o10 = e15.RowHierarchy.Members.filter((e16) => !!e16.Group).length;
      n10(0 === o10 || 1 === o10, "Invalid row hierarchy structure").to.equal(true), n10((_a2 = e15.Corner) != null ? _a2 : [], "Corner is not null or empty").to.eql([]), n10(e15.Body.Rows.length).to.equal(t11.filter((e16) => e16 !== wWe.HIDDEN_DETAILS).length);
      let a10 = 0;
      t11.forEach((e16) => {
        a10 = AZe(e16, a10), NZe(a10).to.be.above(-1);
      }), OZe(e15.RowHierarchy, t11);
    }(e14), VZe(e14);
  } catch (e15) {
    t10 = false;
  }
  return t10;
}
const zZe = L$.fromTwips(G5.toTwips, "in");
const $Ze = { in: L$.parse("2in"), cm: L$.parse("5cm") };
const WZe = (e14) => $Ze[e14];
const jZe = (e14) => {
  const { Page: { TopMargin: t10, BottomMargin: n10 }, PageHeader: r10, Body: o10, PageFooter: a10 } = e14;
  const i10 = r10 ? L$.parse(r10.$place.Height) : L$.zero;
  const s10 = ((e15) => {
    const t11 = (e15.ReportItems || []).reduce((e16, t12) => {
      const { Left: n11, Top: r11, Width: o11, Height: a11 } = t12.$place;
      const [i11, s11, l11, c11] = [n11, r11, o11, a11].map((e17) => L$.parse(e17));
      const [u10, d10] = [i11.add(l11), s11.add(c11)];
      return { width: L$.max([u10, e16.width]), height: L$.max([d10, e16.height]) };
    }, { width: zZe, height: zZe });
    return t11;
  })(o10).height;
  const l10 = L$.max([s10, WZe(s10.units)]);
  const c10 = a10 ? L$.parse(a10.$place.Height) : L$.zero;
  return L$.sum([L$.parse(t10), i10, l10, c10, L$.parse(n10)]);
};
const ZZe = (e14) => {
  if ("fixedpagereport" === e14.Type || "dashboard" === e14.Type) return e14;
  const t10 = {};
  return e14.ReportSections.forEach((e15, n10) => {
    if ("Continuous" === e15.Type) {
      if (L$.parse(e15.Page.PageHeight).equal(L$.zero)) {
        const r10 = jZe(e15);
        j0(t10, "ReportSections", { [n10]: { Page: { $autoPageHeight: { $set: true }, PageHeight: { $set: r10.css } } } });
      }
    }
  }), AV(e14, t10);
};
const GZe = (e14) => {
  if ("fixedpagereport" === e14.Type) return __spreadProps(__spreadValues({}, e14), { Width: e14.Page.PageWidth });
  const t10 = {};
  return e14.ReportSections.forEach((e15, n10) => {
    var _a2;
    "Continuous" === e15.Type && ((_a2 = e15.Page) == null ? void 0 : _a2.$autoPageHeight) && j0(t10, "ReportSections", { [n10]: { Page: { PageHeight: { $set: L$.zero.css } } } });
  }), AV(e14, t10);
};
function UZe(e14, t10) {
  return t10(e14);
}
const qZe = (e14) => {
  const t10 = [];
  const n10 = YZe(e14, t10);
  return t10.length && (n10.$conversionInfo = t10), n10;
};
const YZe = (e14, t10 = []) => {
  if (!zV.isObject(e14)) return e14;
  if (zV.isArray(e14)) return e14.map((e15) => YZe(e15, t10));
  let n10 = {};
  Object.getOwnPropertyNames(e14).forEach((r11) => {
    n10[r11] = YZe(e14[r11], t10);
  });
  const r10 = e14;
  switch (r10.Type) {
    case "dvchart":
      n10 = ((e15) => {
        const t11 = TG("dvchartrule");
        for (let n11 = 0; n11 < e15.Plots.length; n11++) {
          const r11 = e15.Plots[n11].Config.Rules;
          const o10 = r11.map((e16) => e16.Name);
          for (let e16 = 0; e16 < r11.length; e16++) {
            const n12 = r11[e16];
            n12.Name && "" !== n12.Name.trim() || (n12.Name = kG(t11, o10), o10.push(n12.Name));
          }
        }
        return e15;
      })(n10);
      break;
    case "table":
    case "fixedpagetable":
      n10 = function(e15) {
        const [t11, n11] = [t1(e15), e1(e15)];
        return __spreadProps(__spreadValues({}, qQ(e15, (e16, r11) => (e16.TableCells.forEach((e17, o10) => {
          e17 && (e17.ColSpan = e17.ColSpan || 1, e17.RowSpan = e17.RowSpan || 1, e17.Item && (e17.Item = __spreadProps(__spreadValues({}, e17.Item), { $width: L$.sum(t11, o10, e17.ColSpan).css, $height: L$.sum(n11, r11, e17.RowSpan).css })));
        }), e16))), { $width: L$.sum(t11).css, $height: L$.sum(n11).css });
      }(n10);
      break;
    case "tablix":
    case "fixedpagetablix":
      n10 = zQ(n10), ((e15) => {
        const t11 = (e15.CustomProperties || []).find((e16) => e16 && e16.Name === EWe);
        return "table" === (t11 && t11.Value);
      })(n10) && (BZe(n10) ? n10 = RWe(n10) : (n10 = ((e15) => {
        const t11 = e15.CustomProperties || [];
        if (!t11.length) return e15;
        const n11 = t11.filter((e16) => e16 && e16.Name !== EWe && e16.Name !== FWe);
        return AV(e15, { CustomProperties: { $set: n11 } });
      })(n10), t10.push(gG("convertTableForClient", hG().t, { name: r10.Name }))));
  }
  return n10;
};
const KZe = (e14) => {
  const t10 = e14;
  if (t10.Name && (t10.Name = KB(t10.Name)), "multisectionreport" === t10.Type) {
    const e15 = t10.ReportSections.map((e16, t11) => {
      if ("Continuous" !== e16.Type) return e16;
      const n10 = __spreadValues({}, e16);
      return n10.Body && (n10.Body = __spreadProps(__spreadValues({}, n10.Body), { Name: KB(n10.Body.Type) })), n10.PageHeader && (n10.PageHeader = __spreadProps(__spreadValues({}, n10.PageHeader), { Name: KB(n10.PageHeader.Type) })), n10.PageFooter && (n10.PageFooter = __spreadProps(__spreadValues({}, n10.PageFooter), { Name: KB(n10.PageFooter.Type) })), __spreadValues({}, n10);
    });
    t10.ReportSections = e15;
  }
  return t10;
};
const XZe = (e14) => {
  const t10 = e14;
  const n10 = t10.ReportSections.map((e15) => {
    const t11 = __spreadValues({}, e15);
    return t11.Body && (t11.Body = __spreadProps(__spreadValues({}, t11.Body), { Name: KB(t11.Body.Type) })), t11.PageHeader && (t11.PageHeader = __spreadProps(__spreadValues({}, t11.PageHeader), { Name: KB(t11.PageHeader.Type) })), t11.PageFooter && (t11.PageFooter = __spreadProps(__spreadValues({}, t11.PageFooter), { Name: KB(t11.PageFooter.Type) })), __spreadValues({}, t11);
  });
  return t10.ReportSections = n10, t10;
};
const JZe = (e14) => x6(e14);
const QZe = Z.Dsl.pipe(lX, Z.Dsl.map((e14) => UZe(e14, (e15) => Z.Dsl.pipe(e15, w6, BG, KZe, qZe, OG)), (e14) => UZe(e14, JZe)), Z.Lenses.mapOfLens(Z.Lenses.prop("DataSources", Z.Lenses.array(Z.Lenses.make((e14) => __spreadProps(__spreadValues({}, e14), { $id: e14.$id || y$(e14).id || void 0 }), (e14) => e14)))), Z.Dsl.map((e14) => UZe(e14, (e15) => ZZe(e15)), (e14) => UZe(e14, (e15) => GZe(e15))), Z.Dsl.map((e14) => {
  const { DataSources: t10, DataSets: n10, ReportParameters: r10, EmbeddedImages: o10, Layers: a10 } = e14;
  const i10 = { DataSources: t10, DataSets: n10, ReportParameters: r10, EmbeddedImages: o10, Layers: a10, NamedItems: [] };
  return __spreadProps(__spreadValues({}, e14), { $index: i10 });
}, (_gb) => {
  var _hb = _gb, { $index: e14 } = _hb, t10 = __objRest(_hb, ["$index"]);
  return __spreadProps(__spreadValues({}, t10), { $index: {} });
}), Z.Dsl.map((e14) => e14, (e14) => UZe(e14, t8)), Z.Dsl.map((e14) => __spreadProps(__spreadValues({}, e14), { $paramsView: C$e(e14) }), (e14) => S$e(e14, e14.$paramsView)), Z.Dsl.recordFailures);
const eGe = Z.Dsl.pipe(dX, Z.Dsl.map((e14) => UZe(e14, (e15) => Z.Dsl.pipe(e15, w6, BG, XZe, qZe, OG)), (e14) => UZe(e14, JZe)), Z.Lenses.mapOfLens(Z.Lenses.prop("DataSources", Z.Lenses.array(Z.Lenses.make((e14) => __spreadProps(__spreadValues({}, e14), { $id: e14.$id || y$(e14).id || void 0 }), (e14) => e14)))), Z.Dsl.map((e14) => UZe(e14, (e15) => ZZe(e15)), (e14) => UZe(e14, (e15) => GZe(e15))), Z.Dsl.map((e14) => {
  const { DataSources: t10, DataSets: n10, ReportParameters: r10, EmbeddedImages: o10, Layers: a10 } = e14;
  const i10 = { DataSources: t10, DataSets: n10, ReportParameters: r10, EmbeddedImages: o10, Layers: a10, NamedItems: [] };
  return __spreadProps(__spreadValues({}, e14), { $index: i10 });
}, (_ib) => {
  var _jb = _ib, { $index: e14 } = _jb, t10 = __objRest(_jb, ["$index"]);
  return __spreadProps(__spreadValues({}, t10), { $index: {} });
}), Z.Dsl.map((e14) => __spreadProps(__spreadValues({}, e14), { $paramsView: C$e(e14) }), (e14) => S$e(e14, e14.$paramsView)), Z.Dsl.recordFailures);
const tGe = (e14, t10) => {
  const n10 = [];
  const r10 = (e15) => {
    const t11 = e15;
    for (const e16 in t11) "LayerName" === e16 ? t11[e16] = "default" : "object" == typeof t11[e16] && (t11[e16] = r10(t11[e16]));
    return t11;
  };
  const o10 = (e15) => e15.ReportSections.filter((e16) => "Continuous" === e16.Type).map((e16) => e16.Body.ReportItems).flat();
  const a10 = (e15) => ({ width: e15.$place.Width, height: e15.$place.Height });
  const i10 = (e15, n11, r11, o11) => {
    const a11 = e15.DataSetName || null;
    const i11 = s10(e15);
    if (i11.length && !n11.length) throw new Error(gG("libraries.noDataSetsFound", t10));
    const l10 = i11.map(W1).map((e16) => e16.length ? e16 : [...n11.map((e17) => e17.Name)]).flat();
    const c10 = ((e16, t11) => {
      const n12 = [];
      return function e17(t12, n13) {
        for (const r12 in t12) {
          const o12 = t12[r12];
          Array.isArray(o12) && o12.forEach((t13) => e17(t13, n13)), zV.isObject(o12) && e17(o12, n13), "string" == typeof o12 && (o12.startsWith("=") && n13(o12), "parameter" === o12 && t12.value && n13(t12.value, false));
        }
      }(e16, (e17, t12 = true) => {
        if (!e17) return;
        if (!t12) return void n12.push(e17);
        const r12 = ((e18) => e18.match(new RegExp("(?<=Parameters!)[^.]*", "g")))(e17);
        r12 && n12.push(...r12);
      }), t11.filter((e17) => [...new Set(n12)].includes(e17.Name));
    })(e15, o11);
    const u10 = c10.map((e16) => {
      const t11 = (e17, t12) => "DataSetReference" in e17 ? t12(e17.DataSetReference) : null;
      return [t11(e16.ValidValues, (e17) => e17.DataSetName), t11(e16.DefaultValue, (e17) => e17.DataSetName)];
    }).flat().filter(Boolean);
    const d10 = zV.uniq("string" == typeof a11 ? [a11, ...l10, ...u10] : [...l10, ...u10]).map((e16) => {
      const r12 = n11.find(({ Name: t11 }) => t11 === e16);
      if (!r12) throw new Error(gG("libraries.dataSetNotFound", t10, { dataSetName: e16 }));
      return r12;
    });
    const p10 = d10.filter((e16) => !e16.$parentReference).map(({ Query: { DataSourceName: e16 } }) => ((e17) => {
      const n12 = r11.find(({ Name: t11 }) => t11 === e17);
      if (!n12) throw new Error(gG("libraries.dataSourceNotFound", t10, { dataSourceName: e17 }));
      return n12;
    })(e16));
    return { reportParameters: c10, dataSets: d10, dataSources: p10 };
  };
  const s10 = (e15) => null == e15 ? [] : "string" == typeof e15 && gc("rdl", e15) && N1(e15).length > 0 ? [e15] : "object" == typeof e15 ? Object.keys(e15).map((t11) => s10(e15[t11])).flat() : [];
  return { registerLoadedLibrary: function(e15) {
    if (n10.find((t11) => t11.name === e15.name)) throw new Error(`Library ${e15.name} already registered`);
    n10.push(e15);
  }, isLibraryRegistered: function(e15) {
    return Boolean(n10.find((t11) => t11.name === e15));
  }, isReportPartWithOverflowName: (e15, t11) => {
    const r11 = ((e16, t12) => {
      const r12 = (n10 || []).find((e17) => (e17 == null ? void 0 : e17.name) === t12);
      return (r12 && r12.reportParts || []).find(({ Name: t13 }) => t13 === e16);
    })(e15, t11);
    return "Grow" === (r11 == null ? void 0 : r11.SizeMode) && "line" !== (r11 == null ? void 0 : r11.item.Type);
  }, parseLibrary: (e15, n11) => {
    const s11 = QZe.decode(n11);
    if ("error" === s11.type) throw new Error(s11.reason);
    const l10 = s11.value;
    if (!N0(l10)) throw new Error(gG("libraries.nonMslLibrary", t10));
    const { ReportParts: c10, DataSets: u10, DataSources: d10, EmbeddedImages: p10, ReportParameters: m10 } = l10;
    const h10 = o10(l10);
    const f10 = [];
    return c10.forEach((e16) => {
      const t11 = h10.find(({ Name: t12 }) => e16.ReportItemName === t12);
      t11 && f10.push(__spreadProps(__spreadValues(__spreadValues(__spreadValues({}, e16), a10(t11)), i10(t11, u10, d10, m10)), { item: r10(t11), SizeMode: xWe(t11.Type) }));
    }), { ReportParts: f10, EmbeddedImages: p10 };
  }, validateLibrary: (n11) => {
    const { rdlx: { reportParts: { libraries: r11 } } } = KO.of(e14);
    const o11 = r11.find((e15) => e15.path === n11);
    if (!o11) return;
    const { name: a11, path: i11 } = o11;
    if (!(s11 = a11, "string" == typeof s11 && s11.trim().length > 0 && NG(a11))) throw new Error(gG("libraries.invalidLibraryName", t10, { libName: a11 }));
    var s11;
    const l10 = r11.filter(({ name: e15 }) => e15 === a11);
    if (l10.length > 1) {
      const e15 = l10.findIndex((e16) => e16.path === i11);
      if (e15) throw new Error(gG("libraries.duplicateLibrary", t10, { libProp: "name", libValue: a11 }));
    }
  } };
};
const nGe = {};
tGe.create = (e14, t10) => {
  nGe[e14] = tGe(e14, t10);
}, tGe.of = (e14) => nGe[e14], tGe.destroy = (e14) => delete nGe[e14];
const [rGe] = Dp("wd-toolbox-item");
const oGe = ({ type: e14, icon: t10, text: n10, onClick: r10 }) => {
  const [, o10, a10] = Yne({ item: { type: "toolboxItem", reportItemType: e14, nameTemplate: TG(e14) }, collect: (e15) => ({ isDragging: e15.isDragging() }) });
  ep.useEffect(() => {
    a10(Coe(), { captureDraggingState: true });
  }, [a10]);
  return o10(((o11 = e14, a11) => tp.createElement("div", { className: kp(rGe), key: o11, style: a11, onClick: r10, title: n10, "data-aid": n10 }, tp.createElement(Fm, { icon: t10, customCSS: "gc-btn__icon" }), tp.createElement("span", { className: "gc-btn__text" }, n10)))());
};
oGe.displayName = "RdlxMenuItem";
const aGe = { bandedlist: "bandedlist", barcode: "barcode", bullet: "bullet", chart: "dvchart", checkbox: "checkbox", container: "rectangle", formattedtext: "formattedtext", image: "image", inputfield: "inputfield", line: "line", list: "list", richtext: "richtext", shape: "shape", sparkline: "sparkline", subreport: "subreport", table: "table", tableofcontents: "tableofcontents", tablix: "tablix", textbox: "textbox", overflowplaceholder: null, partitem: "partitem" };
const iGe = __spreadProps(__spreadValues({}, aGe), { bandedlist: "fixedpagebandedlist", chart: "fixedpagedvchart", container: "fixedpagerectangle", list: "fixedpagelist", subreport: "fixedpagesubreport", table: "fixedpagetable", tableofcontents: "fixedpagetableofcontents", tablix: "fixedpagetablix", overflowplaceholder: "overflowplaceholder" });
const sGe = __spreadProps(__spreadValues({}, aGe), { contentplaceholder: "contentplaceholder" });
const lGe = { documentExplorer: "document-explorer", groupEditor: "group-editor", layerList: "layer-list", librariesList: "libraries-list" };
const cGe = (e14) => {
  const { lockLayout: t10 } = MO();
  const { workspaceId: n10, rdlx: { groupEditorMode: r10, reportStyles: o10 } } = d9();
  const { userPreferences: { units: a10 }, instanceId: i10, rdlx: { toolBoxContent: s10, reportParameters: l10 } } = Uae();
  const c10 = h9();
  const u10 = nz.of(i10).of("rdlx");
  const d10 = PA();
  const { t: p10 } = vp("components");
  const m10 = p10;
  const h10 = rf(Aee);
  const f10 = ep.useCallback(() => d10(dpe({ mode: "advanced" === r10 ? "default" : "advanced" })), [d10, r10]);
  const g10 = U7(c10);
  const y10 = q7(c10);
  const v10 = ep.useCallback((e15, n11) => {
    if (t10) return;
    d10({ type: i5, payload: {} });
    const r11 = e15 && e15.toLowerCase();
    const a11 = XG({ Type: r11, Name: KB(TG(r11)), Style: _j(o10, r11), TemplateId: n11 }, { currentLayerName: c10.$currentLayerName, isChildReport: y10 });
    d10(a11);
    d10({ type: R5, payload: {} });
  }, [d10, t10, c10.$currentLayerName, o10, y10]);
  const b10 = ep.useMemo(() => function(e15, t11, n11 = false) {
    if (!t11) return [];
    let r11;
    let o11 = [];
    switch (e15) {
      case "fixedpagereport":
        r11 = iGe, o11 = t11.fpl;
        break;
      case "multisectionreport": {
        const e16 = n11 ? [...t11.cpl, "contentplaceholder"] : t11.cpl;
        r11 = n11 ? sGe : aGe, o11 = e16;
        break;
      }
      case "dashboard":
        r11 = aGe, o11 = t11.cpl;
        break;
      default:
        throw new Error(`Unknown report type: "${e15}"`);
    }
    return o11.map((e16) => r11[e16] || (console.warn(`Unknown item "${e16}" in settings.toolBoxContent!`), null)).filter(Ie);
  }(c10.Type || "multisectionreport", s10, g10), [s10, c10.Type, g10]);
  const S10 = ep.useMemo(() => b10.map((e15) => {
    var _a2;
    const t11 = u10.getDescriptor(e15);
    if (!t11) return null;
    const { icon: n11, icon24: r11, initTemplates: o11 } = t11;
    const i11 = o11 && o11[a10] || [];
    const s11 = (_a2 = r11 != null ? r11 : n11) != null ? _a2 : nf(_ae);
    const l11 = m10(u10.getLabelKey(t11.type));
    if (i11.length > 1) {
      const t12 = { type: e15, icon: s11, text: l11, templates: i11, onClick: (t13) => v10(e15, t13) };
      return { type: "custom", content: tp.createElement(Loe, __spreadValues({}, t12)) };
    }
    const c11 = { type: e15, icon: s11, text: l11, onClick: (t12) => {
      t12.preventDefault(), t12.stopPropagation(), v10(e15);
    } };
    return { type: "custom", content: tp.createElement(oGe, __spreadValues({}, c11)) };
  }).filter(Ie), [v10, u10, b10, m10, a10]);
  if (n10 === F$e) {
    const t11 = __spreadProps(__spreadValues({}, e14), { items: o$e(d10, l10), onBackButtonClick: () => d10(XO("editor")) });
    return tp.createElement(Jee, __spreadValues({}, t11));
  }
  const { hiddenElements: C10 } = e14;
  const x10 = p10("menu.btnLayerList", "Layers");
  const w10 = p10("menu.btnLibrariesList", "Libraries");
  const T10 = p10("menu.btnGroupEditor", "Group Editor");
  const E10 = p10("menu.btnReportExplorer", "Report Explorer");
  const F10 = __spreadProps(__spreadValues({}, e14), { supportedMenuPanels: Object.values(lGe), items: S10 });
  return tp.createElement(Jee, __spreadValues({}, F10), (C10 == null ? void 0 : C10.documentExplorer) ? null : tp.createElement(XM, { key: lGe.documentExplorer, id: lGe.documentExplorer, dataAid: E10, toggle: { icon: h10, text: E10, title: E10 }, customScroll: true }, tp.createElement(bF, null, tp.createElement(nWe, null))), true !== (C10 == null ? void 0 : C10.groupEditor) && tp.createElement(XM, { key: lGe.groupEditor, id: lGe.groupEditor, dataAid: T10, toggle: { icon: nf(k$e), text: T10, title: T10 }, customScroll: true }, tp.createElement(bF, null, tp.createElement(pie, { advancedMode: "advanced" === r10, item: c10, toggleModeFn: f10, dispatch: d10 }))), true !== (C10 == null ? void 0 : C10.layers) && tp.createElement(XM, { key: lGe.layerList, id: lGe.layerList, dataAid: x10, toggle: { icon: nf(P$e), text: x10, title: x10 }, customScroll: true }, tp.createElement(bF, null, tp.createElement(Cie, null))), true !== (C10 == null ? void 0 : C10.reportPartsLibraries) && tp.createElement(XM, { key: lGe.librariesList, id: lGe.librariesList, dataAid: w10, toggle: { icon: nf(N$e), text: w10, title: w10 }, customScroll: true }, tp.createElement(bF, null, tp.createElement(bWe, null))));
};
const [uGe] = Dp("wd-filters-panel");
const dGe = "filtersEditor";
const pGe = ({ semanticMode: e14, semanticModel: t10, queryFilterMode: n10 }) => {
  const { rdlx: { propertyGrid: { objectValue: r10, linkedProperties: o10, objectPath: a10 } } } = d9();
  const i10 = h9();
  const { state: { valuePath: s10 } } = a$(dGe);
  const l10 = PA();
  const { t: c10 } = vp("components");
  const u10 = ep.useCallback((e15, t11) => {
    const n11 = jN(s10)(e15);
    if ("filter" !== (n11 == null ? void 0 : n11.Type)) return {};
    return { filters: n11, reportItem: e15, path: t11 ? `${t11}.${s10}` : s10 };
  }, [s10]);
  const { filters: d10, reportItem: p10, path: m10 = "" } = ep.useMemo(() => {
    if (1 !== r10.length) return {};
    let e15 = u10(r10[0], a10[0]);
    return (e15 == null ? void 0 : e15.filters) || 1 !== o10.length || (e15 = u10(o10[0].objectValue[0], o10[0].objectPath[0])), e15;
  }, [u10, o10, r10, a10]);
  const { $index: { ReportParameters: h10 = [], DataSets: f10 = [] } } = i10;
  const { dataSet: g10, parentDataSet: y10, needSetDataSetName: v10 } = ep.useMemo(() => {
    const { dataSetName: e15, parentDataSetName: t11 } = see(i10);
    let n11;
    let r11 = false;
    let o11;
    return e15 && (n11 = f10.find((t12) => t12.Name === e15)), n11 || ([n11] = f10, r11 = true), t11 && (o11 = f10.find((e16) => e16.Name === t11)), { dataSet: n11, parentDataSet: o11, needSetDataSetName: r11 };
  }, [f10, i10]);
  const b10 = ep.useCallback((e15, t11, n11) => {
    const r11 = c2({ path: `${m10}.${LFe(e15, t11)}`, descriptor: {}, value: n11 });
    if (g10 && v10) {
      const e16 = ((e17) => o2({ descriptor: { valuePath: "DataSetName" }, value: e17, dataSetName: e17 }))(g10.Name);
      l10(rz([r11, e16]));
    } else l10(r11);
  }, [g10, l10, m10, v10]);
  const S10 = ep.useCallback((e15, t11) => {
    l10(Xz(wBe, c10("dataPanel.headingEditParameter", "Edit Parameter"), void 0, { paramName: e15, disableEditing: { dataType: true }, filterValuePath: t11 }));
  }, [l10, c10]);
  if (ep.useEffect(() => {
    void 0 === d10 && l10(Qz());
  }, [l10, d10]), !d10 || !p10) return null;
  const C10 = { reportItem: p10, filters: d10, valuePath: s10, fullPath: m10, dataSet: g10, parentDataSet: y10, parameters: h10, semanticMode: e14, semanticModel: t10, queryFilterMode: n10, onSetValue: b10, onOpenParameterPanel: S10 };
  return tp.createElement("div", { className: uGe }, tp.createElement(bF, null, tp.createElement(lke, __spreadValues({}, C10))));
};
pGe.displayName = "RdlxFiltersPanel";
const mGe = { valuePath: "" };
const hGe = (e14 = mGe, t10) => (t10 && t10.type) === Uz ? AV(e14, { $merge: t10.payload }) : e14;
var fGe = function(e14) {
  return "@@redux-saga/" + e14;
};
var gGe = fGe("CANCEL_PROMISE");
var yGe = fGe("CHANNEL_END");
var vGe = fGe("IO");
var bGe = fGe("MATCH");
var SGe = fGe("MULTICAST");
var CGe = fGe("SAGA_ACTION");
var xGe = fGe("SELF_CANCELLATION");
var wGe = fGe("TASK");
var TGe = fGe("TASK_CANCEL");
var EGe = fGe("TERMINATE");
var FGe = fGe("LOCATION");
var MGe = function(e14) {
  return null == e14;
};
var kGe = function(e14) {
  return null != e14;
};
var PGe = function(e14) {
  return "function" == typeof e14;
};
var NGe = function(e14) {
  return "string" == typeof e14;
};
var DGe = Array.isArray;
var LGe = function(e14) {
  return e14 && PGe(e14.then);
};
var HGe = function(e14) {
  return e14 && PGe(e14.next) && PGe(e14.throw);
};
var IGe = function e10(t10) {
  return t10 && (NGe(t10) || RGe(t10) || PGe(t10) || DGe(t10) && t10.every(e10));
};
var _Ge = function(e14) {
  return e14 && PGe(e14.take) && PGe(e14.close);
};
var VGe = function(e14) {
  return PGe(e14) && e14.hasOwnProperty("toString");
};
var RGe = function(e14) {
  return Boolean(e14) && "function" == typeof Symbol && e14.constructor === Symbol && e14 !== Symbol.prototype;
};
var AGe = function(e14) {
  return _Ge(e14) && e14[SGe];
};
var OGe = function(e14) {
  return function() {
    return e14;
  };
};
var BGe = OGe(true);
var zGe = function() {
};
var $Ge = function(e14) {
  return e14;
};
var WGe = function(e14, t10) {
  aR(e14, t10), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(t10).forEach(function(n10) {
    e14[n10] = t10[n10];
  });
};
function jGe(e14, t10) {
  var n10 = e14.indexOf(t10);
  n10 >= 0 && e14.splice(n10, 1);
}
var ZGe = function(e14) {
  throw e14;
};
var GGe = function(e14) {
  return { value: e14, done: true };
};
function UGe(e14, t10, n10) {
  void 0 === t10 && (t10 = ZGe), void 0 === n10 && (n10 = "iterator");
  var r10 = { meta: { name: n10 }, next: e14, throw: t10, return: GGe, isSagaIterator: true };
  return "undefined" != typeof Symbol && (r10[Symbol.iterator] = function() {
    return r10;
  }), r10;
}
function qGe(e14, t10) {
  var n10 = t10.sagaStack;
  console.error(e14), console.error(n10);
}
var YGe = function(e14) {
  return Array.apply(null, new Array(e14));
};
var KGe = function(e14) {
  return function(t10) {
    return e14(Object.defineProperty(t10, CGe, { value: true }));
  };
};
var XGe = function(e14) {
  return e14 === EGe;
};
var JGe = function(e14) {
  return e14 === TGe;
};
var QGe = function(e14) {
  return XGe(e14) || JGe(e14);
};
function eUe(e14, t10) {
  var n10 = Object.keys(e14);
  var r10 = n10.length;
  var o10 = 0;
  var a10;
  var i10 = DGe(e14) ? YGe(r10) : {};
  var s10 = {};
  return n10.forEach(function(e15) {
    var n11 = function(n12, s11) {
      a10 || (s11 || QGe(n12) ? (t10.cancel(), t10(n12, s11)) : (i10[e15] = n12, ++o10 === r10 && (a10 = true, t10(i10))));
    };
    n11.cancel = zGe, s10[e15] = n11;
  }), t10.cancel = function() {
    a10 || (a10 = true, n10.forEach(function(e15) {
      return s10[e15].cancel();
    }));
  }, s10;
}
function tUe(e14) {
  return { name: e14.name || "anonymous", location: nUe(e14) };
}
function nUe(e14) {
  return e14[FGe];
}
var rUe = function(e14) {
  return function(e15, t10) {
    void 0 === e15 && (e15 = 10);
    var n10 = new Array(e15);
    var r10 = 0;
    var o10 = 0;
    var a10 = 0;
    var i10 = function(t11) {
      n10[o10] = t11, o10 = (o10 + 1) % e15, r10++;
    };
    var s10 = function() {
      if (0 != r10) {
        var t11 = n10[a10];
        return n10[a10] = null, r10--, a10 = (a10 + 1) % e15, t11;
      }
    };
    var l10 = function() {
      var e16 = [];
      for (; r10; ) e16.push(s10());
      return e16;
    };
    return { isEmpty: function() {
      return 0 == r10;
    }, put: function(s11) {
      var c10;
      if (r10 < e15) i10(s11);
      else switch (t10) {
        case 1:
          throw new Error("Channel's Buffer overflow!");
        case 3:
          n10[o10] = s11, a10 = o10 = (o10 + 1) % e15;
          break;
        case 4:
          c10 = 2 * e15, n10 = l10(), r10 = n10.length, o10 = n10.length, a10 = 0, n10.length = c10, e15 = c10, i10(s11);
      }
    }, take: s10, flush: l10 };
  }(e14, 4);
};
var oUe = "TAKE";
var aUe = "PUT";
var iUe = "RACE";
var sUe = "CALL";
var lUe = "FORK";
var cUe = "CANCEL";
var uUe = "SELECT";
var dUe = function(e14, t10) {
  var n10;
  return (n10 = {})[vGe] = true, n10.combinator = false, n10.type = e14, n10.payload = t10, n10;
};
function pUe(e14, t10) {
  return void 0 === e14 && (e14 = "*"), IGe(e14) ? dUe(oUe, { pattern: e14 }) : AGe(e14) && kGe(t10) && IGe(t10) ? dUe(oUe, { channel: e14, pattern: t10 }) : _Ge(e14) ? dUe(oUe, { channel: e14 }) : void 0;
}
function mUe(e14, t10) {
  return MGe(t10) && (t10 = e14, e14 = void 0), dUe(aUe, { channel: e14, action: t10 });
}
function hUe(e14, t10) {
  var n10 = null;
  var r10;
  return PGe(e14) ? r10 = e14 : (DGe(e14) ? (n10 = e14[0], r10 = e14[1]) : (n10 = e14.context, r10 = e14.fn), n10 && NGe(r10) && PGe(n10[r10]) && (r10 = n10[r10])), { context: n10, fn: r10, args: t10 };
}
function fUe(e14) {
  for (var t10 = arguments.length, n10 = new Array(t10 > 1 ? t10 - 1 : 0), r10 = 1; r10 < t10; r10++) n10[r10 - 1] = arguments[r10];
  return dUe(sUe, hUe(e14, n10));
}
function gUe(e14) {
  for (var t10 = arguments.length, n10 = new Array(t10 > 1 ? t10 - 1 : 0), r10 = 1; r10 < t10; r10++) n10[r10 - 1] = arguments[r10];
  return dUe(lUe, hUe(e14, n10));
}
function yUe(e14) {
  void 0 === e14 && (e14 = $Ge);
  for (var t10 = arguments.length, n10 = new Array(t10 > 1 ? t10 - 1 : 0), r10 = 1; r10 < t10; r10++) n10[r10 - 1] = arguments[r10];
  return dUe(uUe, { selector: e14, args: n10 });
}
var vUe = function(e14) {
  return { done: true, value: e14 };
};
var bUe = {};
function SUe(e14) {
  return _Ge(e14) ? "channel" : VGe(e14) ? String(e14) : PGe(e14) ? e14.name : String(e14);
}
function CUe(e14, t10, n10) {
  var r10, o10, a10, i10 = t10;
  function s10(t11, n11) {
    if (i10 === bUe) return vUe(t11);
    if (n11 && !o10) throw i10 = bUe, n11;
    r10 && r10(t11);
    var s11 = n11 ? e14[o10](n11) : e14[i10]();
    return i10 = s11.nextState, a10 = s11.effect, r10 = s11.stateUpdater, o10 = s11.errorState, i10 === bUe ? vUe(t11) : a10;
  }
  return UGe(s10, function(e15) {
    return s10(null, e15);
  }, n10);
}
function xUe(e14, t10) {
  for (var n10 = arguments.length, r10 = new Array(n10 > 2 ? n10 - 2 : 0), o10 = 2; o10 < n10; o10++) r10[o10 - 2] = arguments[o10];
  var a10 = { done: false, value: pUe(e14) };
  var i10 = function(e15) {
    return { done: false, value: gUe.apply(void 0, [t10].concat(r10, [e15])) };
  };
  var s10, l10 = function(e15) {
    return s10 = e15;
  };
  return CUe({ q1: function() {
    return { nextState: "q2", effect: a10, stateUpdater: l10 };
  }, q2: function() {
    return { nextState: "q1", effect: i10(s10) };
  } }, "q1", "takeEvery(" + SUe(e14) + ", " + t10.name + ")");
}
function wUe(e14, t10) {
  for (var n10 = arguments.length, r10 = new Array(n10 > 2 ? n10 - 2 : 0), o10 = 2; o10 < n10; o10++) r10[o10 - 2] = arguments[o10];
  var a10 = { done: false, value: pUe(e14) };
  var i10 = function(e15) {
    return { done: false, value: fUe.apply(void 0, [t10].concat(r10, [e15])) };
  };
  var s10;
  var l10 = function(e15) {
    return s10 = e15;
  };
  return CUe({ q1: function() {
    return { nextState: "q2", effect: a10, stateUpdater: l10 };
  }, q2: function() {
    return { nextState: "q1", effect: i10(s10) };
  } }, "q1", "takeLeading(" + SUe(e14) + ", " + t10.name + ")");
}
function TUe(e14, t10) {
  for (var n10 = arguments.length, r10 = new Array(n10 > 2 ? n10 - 2 : 0), o10 = 2; o10 < n10; o10++) r10[o10 - 2] = arguments[o10];
  return gUe.apply(void 0, [xUe, e14, t10].concat(r10));
}
function EUe(e14, t10) {
  for (var n10 = arguments.length, r10 = new Array(n10 > 2 ? n10 - 2 : 0), o10 = 2; o10 < n10; o10++) r10[o10 - 2] = arguments[o10];
  return gUe.apply(void 0, [wUe, e14, t10].concat(r10));
}
const FUe = "@chartwizard/INIT";
const MUe = "@chartwizard/GO_TO_STEP";
const kUe = "@chartwizard/STEP_COMPLETE";
const PUe = "@chartwizard/CREATE_CHART";
const NUe = "@chartwizard/SET_PALETTE";
const DUe = "@chartwizard/SET_DATASET_NAME";
const LUe = "@chartwizard/SET_PLOT_TEMPLATE";
const HUe = "@chartwizard/ADD_ENCODING_VALUE";
const IUe = "@chartwizard/DELETE_ENCODING";
const _Ue = "@chartwizard/SET_PROPERTY";
const VUe = "@chartwizard/DELETE_EMPTY_ENCODINGS";
const RUe = "@chartwizard/SET_CHART_BREAK_DOWN_METHOD";
const AUe = "@chartwizard/ADD_CONFIG_VALUE";
const OUe = { init: (e14, t10, n10) => Kz.action(FUe, { chart: e14, path: t10, theme: n10 }), goToStep: (e14) => Kz.action(MUe, { step: e14 }), stepComplete: () => Kz.action(kUe, { stepCompleted: true }), createChart: (e14, t10, n10) => Kz.action(PUe, { chart: e14, path: t10, selection: n10 }), setPalette: ({ palette: e14, customPalette: t10 = [], customPaletteInfo: n10 = { customPaletteId: "", customPaletteName: "" } }) => Kz.action(NUe, { palette: e14, customPalette: t10, customPaletteInfo: n10 }), setDataSetName: (e14) => Kz.action(DUe, { dataSetName: e14 }), setPlotTemplate: (e14) => Kz.action(LUe, { templateType: e14 }), addEncodingValue: (e14, t10, n10, r10) => Kz.action(HUe, { encodingName: e14, value: t10, name: n10, index: r10 }), setEncodingValue: (e14, t10, n10, r10) => Kz.action(HUe, { encodingName: e14, value: t10, name: n10, index: r10, overrideEncoding: true }), deleteEncoding: (e14, t10) => Kz.action(IUe, { encodingName: e14, valueIndex: t10 }), setPropertyValue: (e14, t10) => Kz.action(_Ue, { descriptor: e14, value: t10 }), deleteEmptyEncodings: () => Kz.action(VUe, {}), setChartBreakDownMethod: (e14) => Kz.action(RUe, { chartBreakDownMethod: e14 }), setConfigValue: (e14, t10, n10, r10) => Kz.action(AUe, { configName: e14, value: t10, name: n10, index: r10 }) };
const BUe = $A((e14) => e14, (e14) => e14.chartWizard);
const zUe = () => LA(BUe);
const $Ue = { $isFallback: true, Colors: { Accent1: null, Accent2: null, Accent3: null, Accent4: null, Accent5: null, Accent6: null, Dark1: null, Dark2: null, Hyperlink: null, HyperlinkFollowed: null, Light1: null, Light2: null }, Fonts: { MajorFont: { Family: null, Size: null, Style: null, Weight: null }, MinorFont: { Family: null, Size: null, Style: null, Weight: null } }, Images: [], Constants: [] };
const WUe = (e14, t10 = "", n10 = false) => {
  const r10 = [t10 ? f2({ themeId: t10 }, { skipDirty: true, skipUndo: true }) : m2(void 0, { skipDirty: true, skipUndo: true }), hpe({ theme: e14, themeId: t10 })];
  return n10 ? hpe({ theme: e14, themeId: t10 }) : rz(r10);
};
const jUe = (e14, t10 = null, n10 = "") => ({ content: e14, id: t10, name: n10 });
const ZUe = (e14) => ({ column: e14("chartWizard:templates.types.column", "Column"), columnStacked: e14("chartWizard:templates.types.column", "Column"), columnPercentStacked: e14("chartWizard:templates.types.column", "Column"), bar: e14("chartWizard:templates.types.bar", "Bar"), barStacked: e14("chartWizard:templates.types.bar", "Bar"), barPercentStacked: e14("chartWizard:templates.types.bar", "Bar"), line: e14("chartWizard:templates.types.line", "Line"), area: e14("chartWizard:templates.types.area", "Area"), areaStacked: e14("chartWizard:templates.types.area", "Area"), areaPercentStacked: e14("chartWizard:templates.types.area", "Area"), pie: e14("chartWizard:templates.types.pie", "Pie"), doughnut: e14("chartWizard:templates.types.doughnut", "Doughnut"), polarColumn: e14("chartWizard:templates.types.polarColumn", "Spiral"), polarColumnStacked: e14("chartWizard:templates.types.polarColumn", "Spiral"), polarColumnPercentStacked: e14("chartWizard:templates.types.polarColumn", "Spiral"), polarBar: e14("chartWizard:templates.types.polarBar", "Polar"), polarBarStacked: e14("chartWizard:templates.types.polarBar", "Polar"), polarBarPercentStacked: e14("chartWizard:templates.types.polarBar", "Polar"), radarArea: e14("chartWizard:templates.types.radarArea", "Radar Area"), radarBubble: e14("chartWizard:templates.types.radarBubble", "Radar Bubble"), radarScatter: e14("chartWizard:templates.types.radarScatter", "Radar Scatter"), radarLine: e14("chartWizard:templates.types.radarLine", "Radar Line"), pyramid: e14("chartWizard:templates.types.pyramid", "Pyramid"), funnel: e14("chartWizard:templates.types.funnel", "Funnel"), bubble: e14("chartWizard:templates.types.bubble", "Bubble"), scatter: e14("chartWizard:templates.types.scatter", "Scatter"), gantt: e14("chartWizard:templates.types.gantt", "Gantt"), candlestick: e14("chartWizard:templates.types.candlestick", "Candlestick"), highLowClose: e14("chartWizard:templates.types.highLowClose", "High Low Close"), highLowOpenClose: e14("chartWizard:templates.types.highLowOpenClose", "High Low Open Close"), rangeArea: e14("chartWizard:templates.types.rangeArea", "Range Area"), rangeColumn: e14("chartWizard:templates.types.rangeColumn", "Range Column"), rangeBar: e14("chartWizard:templates.types.rangeBar", "Range Bar"), gauge: e14("chartWizard:templates.types.gauge", "Gauge") });
const GUe = (e14, t10, n10, r10, o10) => {
  const a10 = ((e15, t11) => {
    const { column: n11, bar: r11, line: o11, area: a11, pie: i11, doughnut: s10, polarColumn: l10, polarBar: c10, radarArea: u10, radarBubble: d10, radarScatter: p10, radarLine: m10, pyramid: h10, funnel: f10, bubble: g10, scatter: y10, gantt: v10, candlestick: b10, highLowClose: S10, highLowOpenClose: C10, rangeArea: x10, rangeBar: w10, rangeColumn: T10, gauge: E10 } = ZUe(t11);
    const F10 = [{ key: "column", label: n11 }, { key: "bar", label: r11 }, { key: "line", label: o11 }, { key: "area", label: a11 }, { key: "polarColumn", label: l10 }, { key: "polarBar", label: c10 }, { key: "pie", label: i11 }, { key: "doughnut", label: s10 }, { key: "radarArea", label: u10 }, { key: "radarBubble", label: d10 }, { key: "radarScatter", label: p10 }, { key: "radarLine", label: m10 }, { key: "pyramid", label: h10 }, { key: "funnel", label: f10 }, { key: "bubble", label: g10 }, { key: "scatter", label: y10 }, { key: "gantt", label: v10 }, { key: "candlestick", label: b10 }, { key: "highLowClose", label: S10 }, { key: "highLowOpenClose", label: C10 }, { key: "rangeArea", label: x10 }, { key: "rangeBar", label: w10 }, { key: "rangeColumn", label: T10 }, { key: "gauge", label: E10 }];
    let M10 = F10;
    if (e15) {
      const t12 = ibe(e15);
      M10 = t12.length > 0 ? F10.filter((e16) => t12.includes(e16.key)) : F10;
    }
    return [(k10 = "template", P10 = M10, { key: k10, templateTypes: P10 })];
    var k10, P10;
  })(e14, o10);
  const i10 = ((e15, t11, n11) => (n11 == null ? void 0 : n11.length) ? n11.map((t12) => Wwe(t12, e15)).filter((e16) => null !== e16) : t11 && "Custom" !== t11 ? t11 : null)(t10, n10, r10);
  return a10.map((e15) => ({ charts: e15.templateTypes.map((e16) => {
    const t11 = cTe.find((t12) => t12.name === e16.key);
    if (!t11) return null;
    let n11 = t11.content;
    return i10 && (n11 = AV(t11.content, { config: { palette: { $set: i10 } } })), { key: e16.key, label: e16.label, model: n11 };
  }).filter((e16) => null !== e16) })).filter((e15) => e15.charts.length);
};
const UUe = ({ chartModel: e14, dispatch: t10, chartPlotTemplateType: n10, shouldHidePlotTypeEditor: r10 }) => {
  const { $index: { DataSets: o10 = [] } } = h9();
  const a10 = p9();
  const { t: i10 } = vp("chartWizard");
  const { rdlx: { reportItemsFeatures: { chart: { plotChartTypes: s10 } } } } = Uae();
  const { Palette: l10, CustomPalette: c10 } = e14;
  const u10 = ep.useMemo(() => GUe(s10, a10, l10, c10, i10), [s10, a10, l10, c10, i10]);
  ep.useEffect(() => {
    e14.DataSetName || t10(OUe.setDataSetName(o10[0].Name));
  }, []);
  const d10 = (e15) => {
    t10(OUe.setPlotTemplate(e15));
  };
  const p10 = { text: e14.DataSetName || i10("textEmpty", "Empty"), placeholderText: !e14.DataSetName, items: o10.map((t11) => ({ type: "button", text: t11.Name, value: t11.Name, selected: t11.Name === e14.DataSetName })), onSelect: (e15) => {
    t10(OUe.setDataSetName(e15)), t10(OUe.stepComplete());
  }, menuWidth: "100%", size: "small", menuMaxHeight: "default" };
  const m10 = u10.map((e15) => __spreadProps(__spreadValues({}, e15), { charts: e15.charts.map((e16) => {
    const t11 = n10 === e16.key;
    return __spreadProps(__spreadValues({}, e16), { selected: t11 });
  }) }));
  return tp.createElement("div", { className: "select-type-view-container" }, tp.createElement(AN, { label: i10("labelSelectDataSet", "Select Data Set"), position: "left", block: true, size: "small" }, tp.createElement(UF, __spreadValues({}, p10))), !r10 && tp.createElement("div", { className: "charts-container" }, tp.createElement(bF, null, m10.map((e15, t11) => tp.createElement("div", { key: t11 }, tp.createElement("div", { style: { display: "flex", flexWrap: "wrap" } }, e15.charts.map((e16) => tp.createElement(iTe, { key: e16.key, chart: e16, showLabel: true, onPick: d10 }))))))));
};
UUe.displayName = "SelectTypeView";
const qUe = () => {
  var _a2;
  const { chartBreakDownMethod: e14 } = zUe();
  const { dispatch: t10 } = RA();
  const { t: n10 } = vp();
  const r10 = ep.useMemo(() => OO("dvchart_group_type_wizard", n10), [n10]);
  const o10 = r10.map(({ value: t11, label: n11 }) => ({ type: "button", text: n11, value: t11, selected: t11 === e14 }));
  const a10 = (_a2 = r10.find(({ value: t11 }) => t11 === e14)) == null ? void 0 : _a2.label;
  const i10 = { block: true, size: "small", menuWidth: "100%", menuMaxHeight: "default", items: o10, onSelect: (e15) => {
    t10(OUe.setChartBreakDownMethod(e15));
  }, text: a10 || _ie(n10), customCSS: "break-down-method-dropdown" };
  return tp.createElement(UF, __spreadValues({}, i10));
};
qUe.displayName = "BreakDownMethodEditorBase";
const YUe = _D(qUe);
const KUe = (e14) => {
  const { configName: t10, descriptor: n10, descriptor: { meta: r10 } } = e14;
  const { $index: { DataSets: o10 = [] } } = h9();
  const a10 = zUe();
  const i10 = PA();
  const s10 = ep.useCallback((e15, n11) => {
    var _a2;
    const r11 = a10.chartModel.DataSetName;
    const s11 = ((_a2 = o10.find((e16) => e16.Name === r11)) == null ? void 0 : _a2.Fields.filter((e16) => gu({ type: "field", fieldName: e16.Name }) === n11)[0]) || { Name: "" };
    i10(OUe.setConfigValue(t10, n11, s11.Name, 0));
  }, [o10, a10.chartModel.DataSetName, i10, t10]);
  const l10 = ep.useMemo(() => __spreadProps(__spreadValues({}, e14), { descriptor: __spreadProps(__spreadValues({}, n10), { type: "string_expr", meta: __spreadProps(__spreadValues({}, r10), { exprEditorFilter: Sye }) }), setProperty: s10 }), [n10, r10, e14, s10]);
  const c10 = ep.useMemo(() => ({ setProperties: () => {
  }, setDataFieldProperty: s10 }), [s10]);
  return tp.createElement(Iue.Provider, { value: c10 }, tp.createElement(Hpe, __spreadValues({}, l10)));
};
KUe.displayName = "FieldConfigEditor";
const XUe = (e14) => {
  const { encodingName: t10 } = e14;
  const { $index: { DataSets: n10 = [] } } = h9();
  const r10 = zUe();
  const o10 = PA();
  const a10 = ep.useCallback((e15, a11) => {
    var _a2;
    const i11 = r10.chartModel.DataSetName;
    const s11 = ((_a2 = n10.find((e16) => e16.Name === i11)) == null ? void 0 : _a2.Fields.filter((e16) => gu({ type: "field", fieldName: e16.Name }) === a11)[0]) || { Name: "" };
    o10(OUe.setEncodingValue(t10, a11, s11.Name));
  }, [n10, r10.chartModel.DataSetName, o10, t10]);
  const i10 = ep.useMemo(() => __spreadProps(__spreadValues({}, e14), { setProperty: a10 }), [e14, a10]);
  const s10 = ep.useMemo(() => ({ setProperties: () => {
  }, setDataFieldProperty: a10 }), [a10]);
  return tp.createElement(Iue.Provider, { value: s10 }, tp.createElement(xCe, __spreadValues({}, i10)));
};
XUe.displayName = "FieldEncodingEditor";
const [JUe, , QUe] = Dp("wd-editor-line");
const [eqe] = QUe("block");
const tqe = (e14) => {
  const { descriptor: t10, value: n10 } = e14;
  const r10 = PA();
  const { t: o10 } = vp();
  const a10 = ep.useCallback((e15) => r10(OUe.deleteEncoding("Values", e15)), [r10]);
  const i10 = ep.useCallback(() => r10(OUe.addEncodingValue("Values", "", "")), [r10]);
  const s10 = ep.useCallback((e15, t11) => r10(OUe.setPropertyValue(e15, t11)), [r10]);
  const l10 = ep.useMemo(() => ({ setProperties: () => {
  }, setDataFieldProperty: s10 }), [s10]);
  const c10 = ep.useCallback((e15, n11) => {
    if ("Complex" !== e15.Field.FieldType) return null;
    const r11 = { descriptor: $N("", o10("chartWizard:settings.labels.lower", "Lower"), "string_expr", `${t10.valuePath}.${n11}.Field.Subfields.0.Value`, "both", { exprEditorFilter: Sye }), value: e15.Field.Subfields[0].Value, defaultValue: "", setProperty: s10 };
    const a11 = { descriptor: $N("", o10("chartWizard:settings.labels.upper", "Upper"), "string_expr", `${t10.valuePath}.${n11}.Field.Subfields.1.Value`, "both", { exprEditorFilter: Sye }), value: e15.Field.Subfields[1].Value, defaultValue: "", setProperty: s10 };
    return tp.createElement("div", { className: JUe }, tp.createElement("div", { className: eqe }, tp.createElement(Iue.Provider, { value: l10 }, tp.createElement(Lpe, __spreadValues({}, r11)))), tp.createElement("div", { className: eqe }, tp.createElement(Iue.Provider, { value: l10 }, tp.createElement(Lpe, __spreadValues({}, a11)))));
  }, [l10, t10.valuePath, s10, o10]);
  const u10 = tp.createElement("div", { className: JUe }, tp.createElement(LE, { text: o10("chartWizard:settings.labels.lower", "Lower"), strikeThrough: false, customCSS: eqe, align: "center", size: "small", textSize: "small" }), tp.createElement(LE, { text: o10("chartWizard:settings.labels.upper", "Upper"), strikeThrough: false, customCSS: eqe, align: "center", size: "small", textSize: "small" }));
  const d10 = __spreadProps(__spreadValues({}, e14), { value: n10 || [], reordering: { type: "drag" }, createEditor: c10, onAdd: i10, onDelete: a10, header: u10 });
  return tp.createElement(Bde, __spreadValues({}, d10));
};
tqe.displayName = "RangeValuesCollectionEditor";
const nqe = (e14) => {
  const { setProperty: t10, descriptor: { category: n10, label: r10, valuePath: o10, mode: a10, meta: i10 } } = e14;
  const { $index: { DataSets: s10 = [] } } = h9();
  const l10 = zUe();
  const c10 = ep.useCallback((e15, n11) => {
    var _a2;
    t10(e15, n11);
    const r11 = e15.valuePath.split(".");
    const o11 = r11[r11.length - 2];
    const a11 = $N("", "", "", `PlotArea.Axes.${o11}.Title`);
    const i11 = l10.chartModel.DataSetName;
    const c11 = ((_a2 = s10.find((e16) => e16.Name === i11)) == null ? void 0 : _a2.Fields.filter((e16) => gu({ type: "field", fieldName: e16.Name }) === n11)[0]) || { Name: "" };
    t10(a11, c11.Name);
  }, [s10, l10.chartModel.DataSetName, t10]);
  const u10 = ep.useMemo(() => __spreadProps(__spreadValues({}, e14), { descriptor: $N(n10, r10, "string_expr", o10, a10, i10), setProperty: c10 }), [n10, r10, i10, a10, e14, c10, o10]);
  const d10 = ep.useMemo(() => ({ setProperties: () => {
  }, setDataFieldProperty: c10 }), [c10]);
  return tp.createElement(Iue.Provider, { value: d10 }, tp.createElement(Hpe, __spreadValues({}, u10)));
};
nqe.displayName = "ScatterValuesEncodingEditor";
const [rqe, , oqe] = Dp("wd-editor-line");
const [aqe] = oqe("block");
const iqe = (e14) => {
  const { descriptor: t10, value: n10 } = e14;
  const { $index: { DataSets: r10 = [] } } = h9();
  const o10 = zUe();
  const a10 = PA();
  const { t: i10 } = vp("chartWizard");
  const s10 = ep.useCallback((e15) => a10(OUe.deleteEncoding("Values", e15)), [a10]);
  const l10 = ep.useCallback(() => a10(OUe.addEncodingValue("Values", "", "")), [a10]);
  const c10 = ep.useCallback((e15, t11) => a10(OUe.setPropertyValue(e15, t11)), [a10]);
  const u10 = ep.useMemo(() => ({ setProperties: () => {
  }, setDataFieldProperty: c10 }), [c10]);
  const d10 = ep.useCallback((e15, n11) => {
    if ("Complex" === e15.Field.FieldType) return null;
    const s11 = { descriptor: $N("", i10("settings.labels.field", "Field"), "string_expr", `${t10.valuePath}.${n11}.Field.Value.0.Value`, "both", { exprEditorFilter: Sye }), value: e15.Field.Value[0].Value, defaultValue: "", setProperty: (e16, t11) => {
      var _a2;
      const i11 = o10.chartModel.DataSetName;
      const s12 = ((_a2 = r10.find((e17) => e17.Name === i11)) == null ? void 0 : _a2.Fields.filter((e17) => gu({ type: "field", fieldName: e17.Name }) === t11)[0]) || { Name: "" };
      a10(OUe.setEncodingValue("Values", t11, s12.Name, n11));
    } };
    const l11 = { descriptor: $N("", i10("settings.labels.aggregate", "Aggregate"), "dvchart_aggregate_type", `${t10.valuePath}.${n11}.Aggregate`, void 0, { enumKey: "dvchart_aggregate_type" }), value: e15.Aggregate, setProperty: c10 };
    return tp.createElement("div", { className: rqe }, tp.createElement("div", { className: aqe }, tp.createElement(Iue.Provider, { value: u10 }, tp.createElement(Lpe, __spreadValues({}, s11)))), tp.createElement("div", { className: aqe }, tp.createElement(tse, __spreadValues({}, l11))));
  }, [r10, u10, t10.valuePath, o10.chartModel.DataSetName, a10, c10, i10]);
  const p10 = tp.createElement("div", { className: rqe }, tp.createElement(LE, { text: i10("settings.labels.field", "Field"), strikeThrough: false, customCSS: aqe, align: "center", size: "small", textSize: "small" }), tp.createElement(LE, { text: i10("settings.labels.aggregate", "Aggregate"), strikeThrough: false, customCSS: aqe, align: "center", size: "small", textSize: "small" }));
  const m10 = __spreadProps(__spreadValues({}, e14), { value: n10 || [], reordering: { type: "drag" }, createEditor: d10, onAdd: l10, onDelete: s10, header: p10 });
  return tp.createElement(Bde, __spreadValues({}, m10));
};
iqe.displayName = "ValuesEncodingCollectionEditor";
const sqe = { values_encoding_collection: (e14, t10) => tp.createElement(iqe, __spreadValues({ key: t10 }, e14)), encoding_category_field: (e14, t10) => tp.createElement(XUe, __spreadProps(__spreadValues({ key: t10 }, e14), { encodingName: "Category" })), scatter_values_field: (e14, t10) => tp.createElement(nqe, __spreadValues({ key: t10 }, e14)), details_encoding_value: (e14, t10) => tp.createElement(XUe, __spreadProps(__spreadValues({ key: t10 }, e14), { encodingName: "Details" })), encoding_value: (e14, t10) => tp.createElement(xCe, __spreadValues({ key: t10 }, e14)), dvchart_group_type_wizard: (e14, t10) => tp.createElement(YUe, __spreadValues({ key: t10 }, e14)), enum: (e14, t10) => tp.createElement(nse, __spreadValues({ key: t10 }, e14)), encoding_size_field: (e14, t10) => tp.createElement(XUe, __spreadProps(__spreadValues({ key: t10 }, e14), { encodingName: "Size" })), config_pointer: (e14, t10) => tp.createElement(KUe, __spreadProps(__spreadValues({ key: t10 }, e14), { configName: "Pointers" })), config_label: (e14, t10) => tp.createElement(KUe, __spreadProps(__spreadValues({ key: t10 }, e14), { configName: "CustomLabels" })), range_values_collection: (e14, t10) => tp.createElement(tqe, __spreadValues({ key: t10 }, e14)) };
const lqe = ({ dispatch: e14, chartModel: t10 }) => {
  const { instanceId: n10, userPreferences: { units: r10 }, rdlx: { expressionSyntax: o10 } } = Uae();
  const { Type: a10, $index: i10 } = h9();
  const s10 = A$();
  const l10 = p9();
  const { stepCompleted: c10, defaultChartModel: u10 } = zUe();
  const { t: d10 } = vp("chartWizard");
  const { DataSets: p10 = [], DataSources: m10 = [] } = i10;
  ep.useEffect(() => {
    c10 || e14(OUe.stepComplete());
  });
  const h10 = ep.useCallback((t11, n11) => {
    e14(OUe.setPropertyValue(t11, n11));
  }, [e14]);
  const f10 = ((e15) => {
    const t11 = { Values: e15("chartWizard:settings.categories.values", "Data values"), Category: e15("chartWizard:settings.categories.category", "Data categories"), Subcategory: e15("chartWizard:settings.categories.subcategory", "Data subcategories") };
    const n11 = { valuesEncoding: $N(t11.Values, e15("chartWizard:settings.labels.fields", "Fields"), "values_encoding_collection", "Plots.0.Encodings.Values"), gaugeRanges: $N(t11.Values, e15("chartWizard:settings.labels.gaugeRanges", "Gauge Ranges"), "values_encoding_collection", "Plots.0.Encodings.Values"), fieldCategoryEncoding: $N(t11.Category, e15("chartWizard:settings.labels.field", "Field"), "encoding_category_field", "Plots.0.Encodings.Category.Field.Value.0.Value"), sortCategoryEncoding: $N(t11.Category, e15("chartWizard:settings.labels.sortDirection", "Sort Direction"), "enum", "Plots.0.Encodings.Category.Sort", void 0, { enumKey: "dvchart_encoding_sort" }), fieldDetailsEncodingSubcategories: $N(t11.Subcategory, e15("chartWizard:settings.labels.field", "Field"), "details_encoding_value", "Plots.0.Encodings.Details.0.Field.Value.0"), groupDetailsEncodingSubcategories: $N(t11.Subcategory, e15("chartWizard:settings.labels.group", "Break-down method"), "dvchart_group_type_wizard", ""), sortDirectionDetailsEncodingSubcategories: $N(t11.Subcategory, e15("chartWizard:settings.labels.sortDirection", "Sort Direction"), "enum", "Plots.0.Encodings.Details.0.Sort", void 0, { enumKey: "dvchart_encoding_sort" }), fieldDetailsEncodingCategories: $N(t11.Category, e15("chartWizard:settings.labels.field", "Field"), "details_encoding_value", "Plots.0.Encodings.Details.0.Field.Value.0"), groupDetailsEncodingCategories: $N(t11.Category, e15("chartWizard:settings.labels.group", "Break-down method"), "enum", "Plots.0.Encodings.Details.0.Group", void 0, { enumKey: "dvchart_group_type" }), sortDirectionDetailsEncodingCategories: $N(t11.Category, e15("chartWizard:settings.labels.sortDirection", "Sort Direction"), "enum", "Plots.0.Encodings.Details.0.Sort", void 0, { enumKey: "dvchart_encoding_sort" }), scatterValueXEncoding: $N(t11.Values, e15("chartWizard:settings.labels.fieldX", "X Field"), "scatter_values_field", "Plots.0.Encodings.Values.0.Field.Value.0.Value"), scatterValueYEncoding: $N(t11.Values, e15("chartWizard:settings.labels.fieldY", "Y Field"), "scatter_values_field", "Plots.0.Encodings.Values.0.Field.Value.1.Value"), bubbleValueSizeEncoding: $N(t11.Values, e15("chartWizard:settings.labels.fieldSize", "Size Field"), "encoding_size_field", "Plots.0.Encodings.Size.Field.Value.0.Value"), ganttValueStartEncoding: $N(t11.Values, e15("chartWizard:settings.labels.fieldStart", "Start Field"), "encoding_value", "Plots.0.Encodings.Values.0.Field.Subfields.0.Value"), ganttValueEndEncoding: $N(t11.Values, e15("chartWizard:settings.labels.fieldEnd", "End Field"), "encoding_value", "Plots.0.Encodings.Values.0.Field.Subfields.1.Value"), CandlestickHighValueEncoding: $N(t11.Values, e15("chartWizard:settings.labels.fieldHigh", "High Field"), "encoding_value", "Plots.0.Encodings.Values.0.Field.Subfields.0.Value"), CandlestickLowValueEncoding: $N(t11.Values, e15("chartWizard:settings.labels.fieldLow", "Low Field"), "encoding_value", "Plots.0.Encodings.Values.0.Field.Subfields.1.Value"), CandlestickOpenValueEncoding: $N(t11.Values, e15("chartWizard:settings.labels.fieldOpen", "Open Field"), "encoding_value", "Plots.0.Encodings.Values.0.Field.Subfields.2.Value"), CandlestickCloseValueEncoding: $N(t11.Values, e15("chartWizard:settings.labels.fieldClose", "Close Field"), "encoding_value", "Plots.0.Encodings.Values.0.Field.Subfields.3.Value"), HighLowClose_CloseValueEncoding: $N(t11.Values, e15("chartWizard:settings.labels.fieldClose", "Close Field"), "encoding_value", "Plots.0.Encodings.Values.0.Field.Subfields.2.Value"), rangeValueLowerEncoding: $N(t11.Values, e15("chartWizard:settings.labels.lower", "Lower"), "encoding_value", "Plots.0.Encodings.Values.0.Field.Subfields.0.Value"), rangeValueUpperEncoding: $N(t11.Values, e15("chartWizard:settings.labels.upper", "Upper"), "encoding_value", "Plots.0.Encodings.Values.0.Field.Subfields.1.Value"), pointerEndValueConfig: $N(t11.Values, e15("chartWizard:settings.labels.pointer", "Gauge Pointer"), "config_pointer", "Plots.0.Config.Pointers.0.End"), customLabelTextConfig: $N(t11.Values, e15("chartWizard:settings.labels.gaugeLabel", "Gauge Label"), "config_label", "Plots.0.Config.CustomLabels.0.Text"), rangeValue: $N(t11.Values, e15("chartWizard:settings.labels.fields", "Fields"), "range_values_collection", "Plots.0.Encodings.Values") };
    const r11 = [n11.valuesEncoding, n11.fieldCategoryEncoding, n11.sortCategoryEncoding, n11.fieldDetailsEncodingSubcategories, n11.groupDetailsEncodingSubcategories, n11.sortDirectionDetailsEncodingSubcategories];
    const o11 = [n11.valuesEncoding, n11.fieldCategoryEncoding, n11.sortCategoryEncoding, n11.fieldDetailsEncodingSubcategories, n11.sortDirectionDetailsEncodingSubcategories];
    const a11 = [n11.valuesEncoding, n11.fieldDetailsEncodingCategories, n11.groupDetailsEncodingCategories, n11.sortDirectionDetailsEncodingCategories];
    const i11 = [n11.scatterValueXEncoding, n11.scatterValueYEncoding, n11.fieldDetailsEncodingCategories, n11.sortDirectionDetailsEncodingCategories];
    const s11 = [n11.scatterValueXEncoding, n11.scatterValueYEncoding, n11.bubbleValueSizeEncoding, n11.fieldDetailsEncodingCategories, n11.sortDirectionDetailsEncodingCategories];
    const l11 = [n11.CandlestickHighValueEncoding, n11.CandlestickLowValueEncoding, n11.CandlestickOpenValueEncoding, n11.CandlestickCloseValueEncoding, n11.fieldCategoryEncoding, n11.sortCategoryEncoding];
    const c11 = [n11.rangeValue, n11.fieldCategoryEncoding, n11.sortCategoryEncoding, n11.fieldDetailsEncodingSubcategories, n11.sortDirectionDetailsEncodingSubcategories];
    return { Custom: [], Column: r11, Bar: r11, Line: o11, Pie: a11, Area: r11, Pyramid: a11, Funnel: a11, Scatter: i11, Bubble: s11, Gantt: [n11.ganttValueStartEncoding, n11.ganttValueEndEncoding, n11.fieldCategoryEncoding, n11.sortCategoryEncoding, n11.fieldDetailsEncodingSubcategories, n11.sortDirectionDetailsEncodingSubcategories], Candlestick: l11, HighLowClose: [n11.CandlestickHighValueEncoding, n11.CandlestickLowValueEncoding, n11.HighLowClose_CloseValueEncoding, n11.fieldCategoryEncoding, n11.sortCategoryEncoding], HighLowOpenClose: l11, PolarColumn: r11, PolarBar: r11, RadarArea: o11, RadarBubble: s11, RadarScatter: i11, RadarLine: o11, RangeArea: c11, RangeBar: c11, RangeColumn: c11, Gauge: [n11.gaugeRanges, n11.pointerEndValueConfig, n11.customLabelTextConfig] };
  })(d10);
  const g10 = { descriptors: f10[t10.Plots[0].PlotChartType], objectValue: __spreadValues({ name: t10.Name }, t10), defaultValue: u10, propertyEditors: sqe, setProperty: h10, t: d10, customCSS: Lz };
  const y10 = p10.find((e15) => e15.Name === t10.DataSetName);
  const v10 = dJ(a10, i10, l10, "");
  const b10 = ep.useCallback((r11) => {
    const o11 = { descriptor: r11, objectValues: [t10], defaultValues: [u10], objectPaths: [""], reportIndex: i10, reportType: a10, theme: l10, validationContext: v10, setProperty: h10 };
    const s11 = _A.of(n10).open("expressionEditor", o11);
    e14(s11);
  }, [t10, u10, e14, n10, i10, a10, h10, l10, v10]);
  const S10 = { instanceId: n10, units: r10, validationContext: v10, expressionSyntax: o10, dataSets: y10 ? [y10] : [], dataSources: m10, editExpression: b10, semanticInfo: { semanticModel: s10, allowRebalancing: false, showAggregates: true, showCalculatedFields: true } };
  const C10 = ep.useMemo(() => ({ setProperties: () => {
  }, setDataFieldProperty: h10 }), [h10]);
  return tp.createElement(Vue.Provider, { value: S10 }, tp.createElement(Iue.Provider, { value: C10 }, tp.createElement(wD, __spreadValues({}, g10))));
};
lqe.displayName = "SettingsView";
var cqe = { plots: [{ type: "Bar", name: "p1", encodings: { values: [{ field: "Value" }], details: [{ field: "Category" }] } }], config: { bar: { bottomWidth: 1, neckHeight: 1, overlap: -0.3, topWidth: 1, width: 1 }, plotAreas: [{ padding: { top: 11 }, axes: [{ plots: ["p1"], title: "", type: "X", majorGrid: false, labels: false, position: "None" }, { plots: ["p1"], title: "", type: "Y", min: 0, max: 3, majorGrid: false, labels: false, position: "None" }] }] }, data: { values: [{ Category: "Category1", Value: 3 }, { Category: "Category2", Value: 3 }, { Category: "Category3", Value: 3 }, { Category: "Category4", Value: 3 }, { Category: "Category5", Value: 3 }, { Category: "Category6", Value: 3 }] } };
const uqe = (e14) => {
  const { id: t10, name: n10, content: r10 } = e14;
  return { key: t10, name: n10, colors: Array.isArray(r10.palette) ? r10.palette : [] };
};
const [dqe] = Dp("wd-chart-palette-editor");
const pqe = ({ theme: e14, selectedPalette: t10, onPick: n10 }) => {
  const { instanceId: r10 } = Uae();
  const { rdlx: { reportStyles: o10 } } = d9();
  const { t: a10 } = vp();
  const i10 = ((e15, t11, n11) => ({ label: n11("components:chartPaletteDropdown.headingExtraPalettes", "Theme Palettes"), groupType: "Theme Palettes", palettes: Pj(e15).map(uqe) }))(o10, 0, a10);
  const s10 = ((e15) => ({ label: e15("components:chartPaletteDropdown.headingStandardPalettes", "Standard Palettes"), groupType: "Standard Palettes", palettes: VO("dvchart_palette").filter((e16) => "Custom" !== e16).map((e16) => ({ name: e16, key: e16 })) }))(a10);
  const l10 = [i10, s10].map((n11) => {
    const r11 = e14 && !e14.$isFallback ? n11.palettes : n11.palettes.filter((e15) => !(e15.colors || []).some(vme));
    return 0 === (r11 || []).length ? null : { label: n11.label, groupType: n11.groupType, charts: r11.map((n12) => {
      const r12 = n12.colors ? n12.colors.map((t11) => Wwe(t11, e14)) : n12.key;
      const o11 = AV(cqe, { config: { palette: { $set: r12 } } });
      return { key: n12.key, label: n12.name, model: o11, selected: t10 === n12.key };
    }) };
  }).filter((e15) => null !== e15);
  const c10 = { chartGroups: l10, showItemLabels: true, customCSS: dqe, onItemPick: (e15) => {
    if (!n10) return;
    const t11 = i10.palettes;
    const r11 = t11.findIndex((t12) => t12.key === e15);
    if (r11 >= 0) {
      const { key: e16, name: o12, colors: a12 } = t11[r11];
      return void n10({ palette: "Custom", customPalette: a12, customPaletteInfo: { customPaletteId: e16, customPaletteName: o12 } });
    }
    const o11 = s10.palettes;
    const a11 = o11.findIndex((t12) => t12.key === e15);
    a11 >= 0 && n10({ palette: o11[a11].key });
  } };
  return tp.createElement(lTe, __spreadValues({}, c10));
};
pqe.displayName = "ChartPaletteDropdown";
const mqe = tp.createElement("svg", { width: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M8.354.146C8.26.053 8.133 0 8 0c-.133 0-.26.053-.354.146l-2.5 2.5c-.195.196-.195.512 0 .708.196.195.512.195.708 0L7.5 1.707V5.5c0 .276.224.5.5.5s.5-.224.5-.5V1.707l1.646 1.647c.196.195.512.195.708 0 .195-.196.195-.512 0-.708l-2.5-2.5Zm-8.208 7.5C.053 7.74 0 7.867 0 8c0 .133.053.26.146.354l2.5 2.5c.196.195.512.195.708 0 .195-.196.195-.512 0-.708L1.707 8.5H5.5c.276 0 .5-.224.5-.5s-.224-.5-.5-.5H1.707l1.647-1.646c.195-.196.195-.512 0-.708-.196-.195-.512-.195-.708 0l-2.5 2.5ZM8 16c-.133 0-.26-.053-.354-.146l-2.5-2.5c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0L7.5 14.293V10.5c0-.276.224-.5.5-.5s.5.224.5.5v3.793l1.646-1.647c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-2.5 2.5C8.26 15.947 8.133 16 8 16Zm7.854-7.646C15.947 8.26 16 8.133 16 8c0-.133-.053-.26-.146-.354l-2.5-2.5c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708L14.293 7.5H10.5c-.276 0-.5.224-.5.5s.224.5.5.5h3.793l-1.647 1.646c-.195.196-.195.512 0 .708.196.195.512.195.708 0l2.5-2.5Z" }));
const hqe = "wd-icon-rdlx-adorner-move";
const fqe = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M9 2.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5v8c0 .828-.672 1.5-1.5 1.5S9 11.328 9 10.5v-8Zm1.5-.5c-.276 0-.5.224-.5.5v8c0 .276.224.5.5.5s.5-.224.5-.5v-8c0-.276-.224-.5-.5-.5Z" }), tp.createElement("path", { className: Ym.text, opacity: ".62", d: "M14.5 7c.828 0 1.5.672 1.5 1.5v2c0 .828-.672 1.5-1.5 1.5s-1.5-.672-1.5-1.5v-2c0-.828.672-1.5 1.5-1.5ZM14 8.5v2c0 .276.224.5.5.5s.5-.224.5-.5v-2c0-.276-.224-.5-.5-.5s-.5.224-.5.5Z" }), tp.createElement("path", { className: Ym.text, opacity: ".38", d: "M5 5.5C5 4.672 5.672 4 6.5 4S8 4.672 8 5.5v5c0 .828-.672 1.5-1.5 1.5S5 11.328 5 10.5v-5ZM6.5 5c-.276 0-.5.224-.5.5v5c0 .276.224.5.5.5s.5-.224.5-.5v-5c0-.276-.224-.5-.5-.5Z" }), tp.createElement("path", { className: Km.accent, d: "M17 16c0-.552-.448-1-1-1H5c-.552 0-1 .448-1 1s.448 1 1 1h11c.552 0 1-.448 1-1Z" }), tp.createElement("path", { className: Km.secondary, d: "M3 10.5c0-.276.224-.5.5-.5s.5.224.5.5v.273c0 .59.235 1.157.652 1.575.418.417.985.652 1.575.652h8.546c.59 0 1.157-.235 1.575-.652.417-.418.652-.985.652-1.575V10.5c0-.276.224-.5.5-.5s.5.224.5.5v.273c0 .856-.34 1.676-.945 2.282-.606.605-1.426.945-2.282.945H6.227c-.856 0-1.676-.34-2.282-.945C3.34 12.449 3 11.629 3 10.773V10.5Z" }));
const gqe = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.secondary, d: "M9 2.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5v8c0 .828-.672 1.5-1.5 1.5S9 11.328 9 10.5v-8Zm1.5-.5c-.276 0-.5.224-.5.5v8c0 .276.224.5.5.5s.5-.224.5-.5v-8c0-.276-.224-.5-.5-.5Z" }), tp.createElement("path", { className: Km.secondary, opacity: ".62", d: "M14.5 7c.828 0 1.5.672 1.5 1.5v2c0 .828-.672 1.5-1.5 1.5s-1.5-.672-1.5-1.5v-2c0-.828.672-1.5 1.5-1.5ZM14 8.5v2c0 .276.224.5.5.5s.5-.224.5-.5v-2c0-.276-.224-.5-.5-.5s-.5.224-.5.5Z" }), tp.createElement("path", { className: Km.secondary, opacity: ".38", d: "M5 5.5C5 4.672 5.672 4 6.5 4S8 4.672 8 5.5v5c0 .828-.672 1.5-1.5 1.5S5 11.328 5 10.5v-5ZM6.5 5c-.276 0-.5.224-.5.5v5c0 .276.224.5.5.5s.5-.224.5-.5v-5c0-.276-.224-.5-.5-.5Z" }), tp.createElement("path", { className: Km.accent, d: "M17 16c0-.552-.448-1-1-1H5c-.552 0-1 .448-1 1s.448 1 1 1h11c.552 0 1-.448 1-1Z" }), tp.createElement("path", { className: Ym.text, d: "M3 10.5c0-.276.224-.5.5-.5s.5.224.5.5v.273c0 .59.235 1.157.652 1.575.418.417.985.652 1.575.652h8.546c.59 0 1.157-.235 1.575-.652.417-.418.652-.985.652-1.575V10.5c0-.276.224-.5.5-.5s.5.224.5.5v.273c0 .856-.34 1.676-.945 2.282-.606.605-1.426.945-2.282.945H6.227c-.856 0-1.676-.34-2.282-.945C3.34 12.449 3 11.629 3 10.773V10.5Z" }));
const yqe = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M9 16.732c-.598-.345-1-.992-1-1.732V5c0-1.105.895-2 2-2s2 .895 2 2v5h-.5c-.171 0-.338.017-.5.05V5c0-.552-.448-1-1-1s-1 .448-1 1v11.732Z" }), tp.createElement("path", { className: Ym.text, opacity: ".62", d: "M13.268 10c.345-.598.992-1 1.732-1s1.387.402 1.732 1h-3.464Z" }), tp.createElement("path", { className: Ym.text, opacity: ".38", d: "M3 8c0-1.105.895-2 2-2s2 .895 2 2v7c0 1.105-.895 2-2 2s-2-.895-2-2V8Zm2-1c-.552 0-1 .448-1 1v7c0 .552.448 1 1 1s1-.448 1-1V8c0-.552-.448-1-1-1Z" }), tp.createElement("path", { className: Km.accent, d: "M10 13c0-1.105.895-2 2-2h5c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2h-5c-1.105 0-2-.895-2-2v-4Zm6.5 3h-4c-.276 0-.5.224-.5.5s.224.5.5.5h4c.276 0 .5-.224.5-.5s-.224-.5-.5-.5Zm-4-3c-.276 0-.5.224-.5.5s.224.5.5.5h4c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-4Z" }));
const vqe = { instanceId: "", renderItem: () => {
}, getSettings: () => {
}, makeImageUrl: () => {
}, embeddedImages: [], getReport: () => {
}, getAreaByPath: () => {
}, getItemLayerInfo: () => {
}, getDefaultStyle: () => {
}, isItemInFixedArea: () => {
}, setDecorations: () => {
}, update: () => {
} };
const bqe = tp.createContext(vqe);
let Sqe = [];
const Cqe = (e14) => (Sqe || []).find((t10) => t10.Name === e14) || null;
const xqe = (e14, t10) => {
  const n10 = ((e15, t11) => {
    const n11 = Cqe(e15);
    if (!n11) return null;
    const r10 = (n11.Fields || []).find((e16) => e16.Name === t11);
    if (r10) return r10;
    const o10 = (n11.$calculatedFields || []).find((e16) => e16.Name === t11);
    return o10 || null;
  })(e14, t10);
  return n10 && n10.Aggregate || "Count";
};
const [wqe, Tqe] = Dp("ar-chart-drop-target");
const [Eqe, Fqe, Mqe] = Dp("ar-chart-adorner-pane");
const [kqe] = Mqe("heading");
const [Pqe] = Mqe("content");
const [Nqe, Dqe] = Mqe("item");
const Lqe = ({ plotIndex: e14, panel: t10, children: n10 }) => {
  const { setDecorations: r10 } = ep.useContext(bqe);
  const o10 = PA();
  const { t: a10 } = vp("adorners");
  const [{ isDragging: i10, isHovering: s10 }, l10] = are({ accept: ["value", "field"], drop: (n11) => {
    let r11 = "";
    let a11 = "";
    let i11;
    if ("value" === n11.type) {
      const { expr: e15 } = n11;
      r11 = e15;
    } else {
      if ("field" !== n11.type) return;
      {
        const { field: { value: e15, aggregate: o11, variationFormat: s11 }, dataSetName: l11, dropActions: c11 } = n11;
        let u11;
        "Values" === t10 && (u11 = s11 ? "Count" : o11), "GaugePointer" !== t10 && "GaugeLabel" !== t10 || (u11 = "Sum"), r11 = s11 ? `=${U1(e15, s11, null, u11)}` : `=${G1(e15, null, u11)}`, i11 = c11, a11 = l11;
      }
    }
    if (t10) {
      const n12 = [];
      if ("GaugeLabel" === t10 || "GaugePointer" === t10) {
        const e15 = ((e16, t11) => {
          switch (e16) {
            case "GaugeLabel":
              return $ye.addPlotCustomLabel(t11);
            case "GaugePointer":
              return $ye.addPlotPointer(t11);
            default:
              throw new Error(`Invalid dv-chart item type: ${e16}`);
          }
        })(t10, r11);
        n12.push(e15);
      } else {
        const o11 = ((e15, t11, n13) => {
          switch (e15) {
            case "Category":
            case "Values":
            case "Details":
            case "Color":
            case "Shape":
            case "Size":
            case "Texts":
              return $ye.addEncodingValue(e15, t11, n13);
            default:
              throw new Error(`Invalid dv-chart encoding type: ${e15}`);
          }
        })(t10, r11, e14);
        n12.push(o11);
      }
      a11 && n12.push($ye.setDataSetName(a11)), i11 && n12.push(...i11), n12.length && o10(rz(n12));
    }
  }, collect: (e15) => ({ isDragging: e15.canDrop(), isHovering: e15.isOver({ shallow: true }), item: e15.getItem() }) });
  ep.useEffect(() => {
    i10 && s10 && setTimeout(() => r10("", []), 50);
  }, [i10, s10, r10]);
  const c10 = 0 === tp.Children.count(n10);
  const u10 = kp(_z(s10, i10), wqe, { [Tqe("empty")]: c10 });
  return tp.createElement("ul", { ref: l10, className: u10 }, c10 ? a10("common.dropFieldsAndValues", "Drop fields and values here") : n10);
};
Lqe.displayName = "DropPanel";
const Hqe = ({ text: e14, title: t10, selected: n10, path: r10, onClick: o10 }) => {
  const a10 = kp(Nqe, { [Dqe("selected")]: n10 });
  return tp.createElement("li", { className: a10, title: t10, role: "option", "aria-selected": n10, onClick: o10, onContextMenu: o10, "data-path": r10 }, e14);
};
Hqe.displayName = "AdornerPanelItem";
const Iqe = ({ icon: e14, title: t10, position: n10, children: r10 }) => {
  const o10 = { text: t10, uppercase: false, strikeThrough: false };
  const a10 = kp(Eqe, { [Fqe(n10)]: true }, "ar-adorner-primary");
  return tp.createElement("div", { className: a10 }, tp.createElement("div", { className: kqe }, tp.createElement(Fm, { icon: e14 }), tp.createElement(LE, __spreadValues({}, o10))), tp.createElement("div", { className: Pqe }, r10));
};
Iqe.displayName = "AdornerPanel";
const _qe = (e14) => ({ label: t10, tooltip: n10, selected: r10, onClick: o10 }, a10) => {
  const i10 = { key: `${t10}${n10}${a10}`, text: t10, title: n10, selected: r10, onClick: o10, path: e14(a10) };
  return tp.createElement(Hqe, __spreadValues({}, i10));
};
const Vqe = (e14, t10, n10) => "Values" === e14 ? n10("adorners:chart.valueEncoding.fieldStub", "Value {{index}}", { index: t10 }) : "Details" === e14 ? n10("adorners:chart.detailEncoding.fieldStub", "Details {{index}}", { index: t10 }) : "Category" === e14 ? n10("adorners:chart.categoryEncoding.fieldStub", "Category {{index}}", { index: t10 }) : "Color" === e14 ? n10("adorners:chart.colorEncoding.fieldStub", "Color {{index}}", { index: t10 }) : "Shape" === e14 ? n10("adorners:chart.shapeEncoding.fieldStub", "Shape {{index}}", { index: t10 }) : "Size" === e14 ? n10("adorners:chart.sizeEncoding.fieldStub", "Size {{index}}", { index: t10 }) : "";
const Rqe = (e14) => {
  if (!e14) return "";
  const t10 = N1(e14);
  if (t10.length) {
    const n10 = t10[0];
    const r10 = A1(e14);
    return r10 ? `${n10} (${r10})` : n10;
  }
  return `"${e14}"`;
};
const Aqe = (e14, t10) => {
  if (!e14.length || !e14[0]) return "";
  const n10 = YAe(e14[0].toString(), Rqe);
  return 1 === e14.length ? n10 : t10("adorners:chart.multiValueField", "{{firstFieldValue}}, ...", { firstFieldValue: n10 });
};
const Oqe = (e14, t10, n10, r10) => e14.map((e15, o10) => ({ label: e15 && YAe(e15.Value, Rqe) || Vqe(t10, o10, r10), selected: _e(e15.$selected), onClick: n10(t10, o10) }));
const Bqe = (e14, t10, n10, r10) => Oqe(e14.Field.Value, t10, n10, r10);
const zqe = (e14, t10, n10, r10) => Oqe(e14.Field.Value.filter((e15) => e15.Value !== ive), t10, n10, r10);
const $qe = (e14, t10, n10, r10, o10, a10) => ({ label: Aqe(r10, a10) || Vqe(t10, n10, a10), tooltip: r10.filter((e15) => !!e15).map((e15) => YAe(e15.toString(), Rqe)).join(", "), selected: _e(e14.$selected), onClick: o10(t10, n10) });
const Wqe = (e14, t10, n10, r10) => e14.map((e15, o10) => {
  const a10 = e15.Field.Value.map((e16) => e16 || "");
  return $qe(e15, t10, o10, a10, n10, r10);
});
const jqe = (e14, t10, n10, r10) => e14.map((e15, o10) => {
  const a10 = [e15.Field.TemplateKey];
  return $qe(e15, t10, o10, a10, n10, r10);
});
const Zqe = (e14, t10, n10, r10) => e14.map((e15, o10) => {
  const a10 = (((e16) => "Simple" === e16.FieldType)(e15.Field) ? e15.Field.Value : e15.Field.Subfields).map((e16) => e16.Value || "");
  return $qe(e15, t10, o10, a10, n10, r10);
});
const [Gqe] = Dp("chart-encodings-panel");
const [Uqe, qqe, Yqe] = Dp("chart-encodings-panel-group");
const [Kqe] = Yqe("header");
const [Xqe] = Yqe("content");
const Jqe = (e14) => e14.some((e15) => e15.selected);
const Qqe = (e14) => {
  const { plotIndex: t10, detailEncodings: n10, colorEncodings: r10, shapeEncodings: o10, sizeEncodings: a10, textEncodings: i10, visibilityInfo: s10, getPathByEncodingName: l10 } = e14;
  const [c10, u10] = ep.useState((({ colorEncodings: e15, shapeEncodings: t11, sizeEncodings: n11, textEncodings: r11 }) => Jqe(e15) ? "Color" : Jqe(t11) ? "Shape" : Jqe(n11) ? "Size" : Jqe(r11) ? "Texts" : "Details")(e14));
  const { t: d10 } = vp("adorners");
  const { rdlx: { reportItemsFeatures: { chart: { hiddenEncodings: p10 = [] } } } } = Uae();
  ep.useEffect(() => {
    if (!s10[c10]) {
      const e15 = ["Size", "Shape", "Color", "Details", "Texts"].find((e16) => s10[e16]) || "Details";
      u10(e15);
    }
  }, [c10, s10]);
  const m10 = (e15) => () => {
    c10 !== e15 && u10(e15);
  };
  const h10 = (e15, n11, r11) => {
    const o11 = (r11 || []).length;
    const a11 = e15 === c10;
    const i11 = { position: "inline", rounded: true, content: o11 };
    const s11 = kp(Uqe, { [qqe("expanded")]: a11 });
    return tp.createElement("div", { className: s11 }, tp.createElement("div", { className: Kqe, onClick: m10(e15) }, tp.createElement(Fm, { icon: nf(oh) }), tp.createElement("span", null, n11), o11 > 0 && tp.createElement(Am, __spreadValues({}, i11))), a11 && tp.createElement("div", { className: Xqe }, tp.createElement(bF, { direction: "vertical" }, tp.createElement(Lqe, { plotIndex: t10, panel: e15 }, r11.map(_qe(l10(e15)))))));
  };
  return tp.createElement("div", { className: Gqe }, s10.Details && !p10.includes("Details") && h10("Details", d10("chart.detailEncoding.title", "Details"), n10), s10.Color && !p10.includes("Color") && h10("Color", d10("chart.colorEncoding.title", "Color"), r10), s10.Shape && !p10.includes("Shape") && h10("Shape", d10("chart.shapeEncoding.title", "Shape"), o10), s10.Size && !p10.includes("Size") && h10("Size", d10("chart.sizeEncoding.title", "Size"), a10), s10.Texts && !p10.includes("Text") && h10("Texts", d10("chart.textEncoding.title", "Text"), i10));
};
Qqe.displayName = "EncodingsPanel";
const [eYe] = Dp("ar-chart-adorner");
const tYe = { Values: "dvchartvalueaggregateencoding", Details: "dvchartdetailsencoding", Texts: "dvcharttextencoding", Category: "dvchartencodingfieldvalue", Color: "dvchartencodingfieldvalue", Shape: "dvchartencodingfieldvalue", Size: "dvchartencodingfieldvalue" };
const nYe = ({ chart: { Plots: e14 }, path: t10, plotIndex: n10 }) => {
  const r10 = PA();
  const { t: o10 } = vp();
  const a10 = ((e15, t11) => {
    const n11 = ep.useCallback((n12) => (r11) => ["Category", "Color", "Shape", "Size"].includes(n12) ? `${e15}.Plots.${t11}.Encodings.${n12}.Field.Value.${r11}` : `${e15}.Plots.${t11}.Encodings.${n12}.${r11}`, [e15, t11]);
    return n11;
  })(t10, n10);
  const i10 = (e15, t11) => () => {
    const n11 = a10(e15)(t11);
    r10(c5(n11, tYe[e15]));
  };
  const s10 = e14[n10];
  const l10 = s10.Encodings;
  const c10 = rbe(s10.PlotChartType);
  const u10 = Zqe(l10.Values, "Values", i10, o10);
  const d10 = Bqe(l10.Category, "Category", i10, o10);
  const p10 = { plotIndex: n10, detailEncodings: Wqe(l10.Details, "Details", i10, o10), colorEncodings: zqe(l10.Color, "Color", i10, o10), shapeEncodings: Bqe(l10.Shape, "Shape", i10, o10), sizeEncodings: Bqe(l10.Size, "Size", i10, o10), textEncodings: jqe(l10.Texts, "Texts", i10, o10), visibilityInfo: c10, getPathByEncodingName: a10 };
  return tp.createElement("div", { className: eYe }, tp.createElement(Iqe, { title: o10("adorners:chart.dataFields", "Data Fields"), icon: nf(yqe), position: "top" }, tp.createElement(Lqe, { plotIndex: n10, panel: "Values" }, u10.map(_qe(a10("Values"))))), c10.Category && tp.createElement(Iqe, { title: o10("adorners:chart.categoryFields", "Category Fields"), icon: nf(fqe), position: "bottom" }, tp.createElement(Lqe, { plotIndex: n10, panel: "Category" }, d10.map(_qe(a10("Category"))))), ["Details", "Color", "Shape", "Size", "Texts"].some((e15) => c10[e15]) && tp.createElement(Iqe, { title: o10("adorners:chart.encodingFields", "Encodings"), icon: nf(gqe), position: "right" }, tp.createElement(Qqe, __spreadValues({}, p10))));
};
nYe.displayName = "ChartAdorner";
const rYe = ({ chart: { Type: e14 }, path: t10 }) => {
  const n10 = kp("ar-chart-move-adorner", "ar-adorner-primary");
  return tp.createElement("div", { className: n10, "data-type": e14, "data-path": t10 }, tp.createElement(Fm, { icon: nf(mqe) }));
};
rYe.displayName = "ChartMoveAdorner";
const oYe = ({ AxisType: e14, Plots: t10 }) => [e14, ...t10].filter((e15) => e15).join("|");
const aYe = ({ decoration: e14 }) => {
  const t10 = { top: `${e14.top + 2}px`, left: `${e14.left + 2}px`, width: `${e14.width + 2}px`, height: `${e14.height + 2}px` };
  return tp.createElement("div", { className: "selection-decoration", style: t10 });
};
aYe.displayName = "SelectionDecoration";
const iYe = ({ chart: e14, model: t10 }) => {
  const n10 = ((e15, t11) => {
    const n11 = [];
    return rj(e15.Header) && t11.header && n11.push(t11.header.place), rj(e15.Footer) && t11.footer && n11.push(t11.footer.place), rj(e15.Legend) && t11.globalLegend && n11.push(t11.globalLegend.place), rj(e15.PlotArea) && t11.plotArea && n11.push(t11.plotArea.place), e15.PlotArea.Axes.forEach((e16) => {
      if (rj(e16)) {
        const r10 = (t11.axes || []).find((t12) => t12 && t12.id === oYe(e16));
        r10 && n11.push(r10.place);
      }
    }), e15.PlotArea.Legends.forEach((e16) => {
      rj(e16) && (t11.legends || []).forEach((t12) => {
        t12.id === e16.LegendType && n11.push(t12.place);
      });
    }), e15.Plots.forEach((e16) => {
      if (rj(e16)) {
        const r10 = (t11.plots || []).find((t12) => t12 && t12.id === e16.PlotName);
        r10 && n11.push(r10.place);
      }
    }), n11;
  })(e14, t10);
  return tp.createElement("div", { className: "ar-chart-decoration-view" }, n10.map((e15, t11) => {
    const n11 = `${t11}: ${e15.top}_${e15.left}_${e15.width}_${e15.height}`;
    return tp.createElement(aYe, { key: n11, decoration: e15 });
  }));
};
iYe.displayName = "DecorationView";
const sYe = (e14, t10) => {
  if (!e14 || !e14.place || !t10) return false;
  const { top: n10, left: r10, width: o10, height: a10 } = e14.place;
  const { x: i10, y: s10 } = t10;
  return n10 <= s10 && s10 <= n10 + a10 && r10 <= i10 && i10 <= r10 + o10;
};
const lYe = ({ chart: e14, model: t10, path: n10 }) => {
  const { getSettings: r10 } = ep.useContext(bqe);
  const o10 = PA();
  const i10 = ep.useRef(null);
  const s10 = (s11) => {
    if (!i10.current) return;
    const l11 = i10.current.getBoundingClientRect();
    const { zoomFactor: c10 } = r10();
    ((r11, a10) => {
      const i11 = SB(a10) ? l5 : c5;
      if (!aj(e14) || 2 === a10.button) return void o10(i11(n10, e14.Type));
      const { header: s12, globalLegend: l12, footer: c11, legends: u10, axes: d10, plots: p10 } = t10;
      let m10 = i11(`${n10}.PlotArea`, "dvchartplotarea");
      if (sYe(c11, r11)) m10 = i11(`${n10}.Footer`, "dvchartfooter");
      else if (sYe(s12, r11)) m10 = i11(`${n10}.Header`, "dvchartheader");
      else if (sYe(l12, r11)) m10 = i11(`${n10}.Legend`, "dvchartgloballegend");
      else {
        const { PlotArea: { Axes: t11, Legends: o11 }, Plots: a11 } = e14;
        const s13 = zV.findLast(u10, (e15) => sYe(e15, r11));
        if (s13) {
          const e15 = o11.findIndex((e16) => e16.LegendType === s13.id);
          e15 >= 0 && e15 < o11.length && (m10 = i11(`${n10}.PlotArea.Legends.${e15}`, "dvchartlegend"));
        } else {
          const e15 = zV.findLast(p10, (e16) => sYe(e16, r11));
          if (e15) {
            const t12 = a11.findIndex((t13) => t13.PlotName === e15.id);
            t12 >= 0 && t12 < a11.length && (m10 = i11(`${n10}.Plots.${t12}`, "dvchartplot"));
          } else {
            const e16 = zV.findLast(d10, (e17) => sYe(e17, r11));
            if (e16) {
              const r12 = t11.findIndex((t12) => oYe(t12) === e16.id);
              r12 >= 0 && r12 < t11.length && (m10 = i11(`${n10}.PlotArea.Axes.${r12}`, "dvchartaxis"));
            }
          }
        }
      }
      o10(m10), o10($$e());
    })(new a.core.Point(s11.clientX / c10 - l11.left, s11.clientY / c10 - l11.top), s11);
  };
  const l10 = kp("ar-chart-clicker");
  return tp.createElement("div", { ref: i10, className: l10, "data-path": n10, onClick: s10, onContextMenu: s10 });
};
var cYe;
lYe.displayName = "DVChartClicker", function(e14) {
  e14[e14.PlotColor = 1] = "PlotColor", e14[e14.PlotShape = 2] = "PlotShape", e14[e14.PlotSize = 4] = "PlotSize", e14[e14.OverlayColor = 8] = "OverlayColor", e14[e14.BackgroundColor = 16] = "BackgroundColor";
}(cYe || (cYe = {}));
const uYe = (e14) => {
  var _a2;
  return null === ((_a2 = e14._option) == null ? void 0 : _a2.title);
};
const dYe = (e14) => e14 ? { left: e14.__left, top: e14.__top, width: e14.__width, height: e14.__height } : null;
const pYe = (e14) => {
  var _a2, _b2;
  return (_b2 = (_a2 = e14.plotAreas[0]) == null ? void 0 : _a2.legends) != null ? _b2 : [];
};
const mYe = (e14) => {
  var _a2, _b2;
  return (_b2 = (_a2 = e14.plotAreas[0]) == null ? void 0 : _a2.plotsPanes.reduce((e15, t10) => (e15.push(...t10.plots), e15), [])) != null ? _b2 : [];
};
const hYe = (e14, t10 = null) => ({ place: e14, id: t10 });
const fYe = (e14, t10 = null) => {
  var _a2;
  if (!e14) return null;
  const n10 = (_a2 = e14.queryInterface) == null ? void 0 : _a2.call(e14, "IShapeModel");
  if (n10) {
    const e15 = gYe(n10);
    if (e15) return hYe(e15, t10);
  }
  const r10 = dYe(e14._rectangle);
  return r10 ? hYe(r10, t10) : null;
};
const gYe = (e14) => {
  const { shapes: t10 } = e14;
  if (0 === t10.length) return null;
  const n10 = t10.reduce((e15, t11) => {
    if ("Rectangle" === t11.type) {
      const n11 = t11.queryInterface("IRectangleShape");
      if (!n11) return e15;
      const r11 = ((e16) => {
        const { leftTop: t12, leftBottom: n12, rightTop: r12, rightBottom: o11 } = e16;
        const a11 = [t12, n12, r12, o11].map((e17) => e17.x);
        const i11 = [t12, n12, r12, o11].map((e17) => e17.y);
        return { left: Math.min(...a11), top: Math.min(...i11), right: Math.max(...a11), bottom: Math.max(...i11) };
      })(n11);
      return e15.push(r11), e15;
    }
    return e15;
  }, []);
  const r10 = n10.map((e15) => e15.left);
  const o10 = n10.map((e15) => e15.top);
  const a10 = n10.map((e15) => e15.right);
  const i10 = n10.map((e15) => e15.bottom);
  const s10 = Math.min(...r10);
  const l10 = Math.min(...o10);
  return { left: s10, top: l10, width: Math.max(0, Math.max(...a10) - s10), height: Math.max(0, Math.max(...i10) - l10) };
};
const yYe = { [cYe.PlotColor]: "Color", [cYe.PlotShape]: "Shape", [cYe.PlotSize]: "Size" };
const vYe = (e14 = null, t10 = null, n10 = null, r10 = null, o10 = [], a10 = [], i10 = []) => ({ header: e14, footer: t10, globalLegend: n10, plotArea: r10, legends: o10, axes: a10, plots: i10 });
const bYe = (e14, t10) => __spreadProps(__spreadValues({}, e14), { place: { top: Math.max(e14.place.top, 0), left: Math.max(e14.place.left, 0), width: Math.min(e14.place.width, t10.maxRight - e14.place.left), height: Math.min(e14.place.height, t10.maxBottom - e14.place.top) } });
const SYe = (e14) => {
  const { model: t10 } = e14;
  if (!t10) return vYe();
  const { __width: n10, __height: r10 } = t10.__rectangle;
  const o10 = { maxRight: n10, maxBottom: r10 };
  const i10 = ((e15) => e15.header && fYe(e15.header))(t10);
  const s10 = ((e15) => e15.footer && fYe(e15.footer))(t10);
  const l10 = ((e15) => {
    const t11 = pYe(e15);
    for (const e16 of t11) {
      if (!uYe(e16)) continue;
      const t12 = fYe(e16, "GlobalLegend");
      if (t12) return t12;
    }
    return null;
  })(t10);
  const c10 = ((e15) => e15.plotAreas.length > 0 ? fYe(e15.plotAreas[0]) : null)(t10);
  const u10 = ((e15) => {
    var _a2;
    const t11 = pYe(e15);
    const n11 = [];
    for (const e16 of t11) {
      if (uYe(e16)) continue;
      const t12 = fYe(e16, (_a2 = yYe[e16.kind]) != null ? _a2 : "Unknown");
      t12 && n11.push(t12);
    }
    return n11;
  })(t10);
  const d10 = ((e15) => {
    const t11 = mYe(e15);
    const n11 = [];
    const r11 = (e16) => {
      var _a2, _b2, _c2, _d2, _e2, _f2, _g2;
      const t12 = dYe(e16.__rectangle);
      if (!t12) return;
      const r12 = (_f2 = (_e2 = (_d2 = (_b2 = (_a2 = e16.__definition) == null ? void 0 : _a2.option) == null ? void 0 : _b2.plots) != null ? _d2 : (_c2 = e16.__option) == null ? void 0 : _c2.plots) != null ? _e2 : e16._definition._option.__plots) != null ? _f2 : [];
      const o11 = [e16.axisType === a.AxisType.X ? "X" : "Y", ...r12].join("|");
      const i11 = (_g2 = e16.__option) == null ? void 0 : _g2.position;
      i11 === a.AxisPosition.None || n11.some((e17) => e17.id === o11) || n11.push(hYe(t12, o11));
    };
    for (const e16 of t11) {
      const { __horizontalAxisView: t12, __verticalAxisView: n12 } = e16;
      t12 && r11(t12), n12 && r11(n12);
    }
    return n11;
  })(t10);
  const p10 = ((e15) => {
    var _a2, _b2, _c2, _d2;
    const t11 = mYe(e15);
    const n11 = [];
    for (const e16 of t11) {
      const t12 = dYe(e16.__rectangle);
      if (!t12) continue;
      const { points: r11 } = e16;
      if (0 === r11.length) continue;
      let [o11, a10, i11, s11] = [Number.MAX_VALUE, Number.MAX_VALUE, Number.MIN_VALUE, Number.MIN_VALUE];
      r11.forEach((e17) => {
        const [t13, n12] = ["_xs", "_ys"].map((t14) => {
          var _a3;
          return (_a3 = e17[t14]) != null ? _a3 : [];
        });
        t13.forEach((e18) => {
          e18 < o11 && (o11 = e18), e18 > i11 && (i11 = e18);
        }), n12.forEach((e18) => {
          e18 < a10 && (a10 = e18), e18 > s11 && (s11 = e18);
        });
      });
      const l11 = dYe((_a2 = e16.__horizontalAxisView) == null ? void 0 : _a2.__rectangle);
      if (l11) {
        const { left: e17, width: t13 } = l11;
        const n12 = e17 + t13;
        o11 < e17 && (o11 = e17), i11 > n12 && (i11 = n12);
      }
      const c11 = dYe((_b2 = e16.__verticalAxisView) == null ? void 0 : _b2.__rectangle);
      if (c11) {
        const { top: e17, height: t13 } = c11;
        const n12 = e17 + t13;
        a10 < e17 && (a10 = e17), s11 > n12 && (s11 = n12);
      }
      const u11 = (_d2 = (_c2 = e16.option) == null ? void 0 : _c2.__option) == null ? void 0 : _d2.type;
      if ("Area" === u11 && c11) {
        const { top: e17, height: t13 } = c11;
        s11 = e17 + t13;
      }
      const { left: d11, top: p11, width: m11, height: h10 } = t12;
      const [f10, g10, y10, v10] = [o11 !== Number.MAX_VALUE, a10 !== Number.MAX_VALUE, i11 !== Number.MIN_VALUE, s11 !== Number.MIN_VALUE];
      const b10 = { left: f10 ? Math.max(o11, d11) : d11, top: g10 ? Math.max(a10, p11) : p11, width: y10 && f10 ? Math.min(i11 - o11, m11) : m11, height: v10 && g10 ? Math.min(s11 - a10, h10) : h10 };
      const S10 = e16._definition._plotOption.__name;
      n11.push(hYe(b10, S10));
    }
    return n11;
  })(t10);
  let m10 = vYe(i10, s10, l10, c10, u10, d10, p10);
  return m10 = (({ header: e15, footer: t11, globalLegend: n11, plotArea: r11, legends: o11, axes: a10, plots: i11 }, s11) => vYe(e15 && bYe(e15, s11), t11 && bYe(t11, s11), n11 && bYe(n11, s11), r11 && bYe(r11, s11), o11.map((e16) => bYe(e16, s11)), a10.map((e16) => bYe(e16, s11)), i11.map((e16) => bYe(e16, s11))))(m10, o10), m10;
};
const CYe = Yye.PlotArea;
var xYe = {};
var wYe = {};
var TYe = {};
Object.defineProperty(TYe, "__esModule", { value: true });
var EYe = 0;
function FYe() {
  return EYe || (EYe = MYe.in / function() {
    if ("undefined" == typeof document) return 96;
    var e14 = document.body.appendChild(document.createElement("div"));
    e14.style.width = "1in", e14.style.padding = "0";
    var t10 = e14.clientWidth;
    return document.body.removeChild(e14), t10;
  }(), EYe);
}
var MYe = { in: 1440, pt: 20, pc: 240, cm: 566.9291338582677, mm: 56.69291338582677 };
TYe.default = { parse: function(e14) {
  var t10 = e14.trim();
  var n10 = t10.substr(-2).toLowerCase();
  if (!MYe[n10]) throw new Error("Unable to parse length: ".concat(e14));
  var r10 = t10.substr(0, t10.length - 2);
  if (!function(e15) {
    return !isNaN(e15 - parseFloat(e15));
  }(r10)) throw new Error("Unable to parse length: ".concat(e14));
  var o10 = parseFloat(r10);
  return Math.trunc(o10 * MYe[n10]);
}, toPixels: function(e14) {
  return e14 / FYe();
} }, Object.defineProperty(wYe, "__esModule", { value: true }), wYe.convertPercentRange = wYe.hashCode = wYe.tryConvertToNumber = wYe.toPx = wYe.mapValues = wYe.toNumber = wYe.toStringOrNull = wYe.isExpression = void 0;
var kYe = TYe;
wYe.isExpression = function(e14) {
  return e14 && "string" == typeof e14 && "=" === e14.trim()[0];
};
wYe.toStringOrNull = function(e14) {
  return null != e14 ? "".concat(e14) : null;
}, wYe.toNumber = function(e14) {
  var t10 = "number" == typeof e14 ? e14 : parseFloat("".concat(e14));
  return isNaN(t10) ? 0 : t10;
}, wYe.mapValues = function(e14, t10) {
  var n10 = {};
  return Object.keys(e14 || {}).forEach(function(r10) {
    n10[r10] = t10(e14[r10]);
  }), n10;
}, wYe.toPx = function(e14) {
  if (!e14) return 0;
  if ("number" == typeof e14) return e14;
  if ("string" != typeof e14) return null;
  if ("Inherit" === e14) return 0;
  var t10 = kYe.default.parse(e14);
  return t10 ? Math.max(kYe.default.toPixels(t10), 1) : 0;
}, wYe.tryConvertToNumber = function(e14) {
  if (null == e14 || "string" != typeof e14) return e14;
  if ("" === e14) return null;
  var t10 = parseFloat(e14);
  return isNaN(t10) ? e14 : t10;
}, wYe.hashCode = function(e14) {
  var t10 = 0;
  if (e14) {
    var n10 = e14.toLowerCase();
    for (var r10 = 0; r10 < n10.length; r10++) t10 = (t10 << 5) - t10 + n10.charCodeAt(r10), t10 &= t10;
  }
  return "x" + (t10 >= 0 ? "" : "_") + Math.abs(t10).toString(16).toUpperCase();
}, wYe.convertPercentRange = function(e14) {
  if (void 0 !== e14) return "number" == typeof e14 ? { type: "Percentage", value: e14 } : null;
};
var PYe = {};
!function(e14) {
  var t10 = $ && $.__assign || function() {
    return t10 = Object.assign || function(e15) {
      for (var t11, n11 = 1, r11 = arguments.length; n11 < r11; n11++) for (var o11 in t11 = arguments[n11]) Object.prototype.hasOwnProperty.call(t11, o11) && (e15[o11] = t11[o11]);
      return e15;
    }, t10.apply(this, arguments);
  };
  var n10 = $ && $.__spreadArray || function(e15, t11, n11) {
    if (n11 || 2 === arguments.length) for (var r11, o11 = 0, a11 = t11.length; o11 < a11; o11++) !r11 && o11 in t11 || (r11 || (r11 = Array.prototype.slice.call(t11, 0, o11)), r11[o11] = t11[o11]);
    return e15.concat(r11 || Array.prototype.slice.call(t11));
  };
  Object.defineProperty(e14, "__esModule", { value: true }), e14.dateMode = e14.getOverlayField = e14.overlayStyle = e14.convertRuleTarget = e14.encodings = e14.mapAndEscapeField = e14.mapField = e14.dataPointStyle = e14.legendStyle = e14.style = e14.lineStyle = e14.backgroundStyle = e14.titleStyle = e14.labelStyle = e14.textStyle = e14.paddings = void 0;
  var r10 = Ll();
  e14.paddings = function(e15) {
    return { left: e15.PaddingLeft, right: e15.PaddingRight, top: e15.PaddingTop, bottom: e15.PaddingBottom };
  };
  e14.textStyle = function(e15) {
    return { color: e15.Color, fontFamily: e15.FontFamily, fontSize: e15.FontSize, fontStyle: e15.FontStyle, fontWeight: e15.FontWeight, textDecoration: e15.TextDecoration };
  };
  e14.labelStyle = function(n11) {
    return t10(t10({}, (0, e14.textStyle)(n11)), { padding: (0, e14.paddings)(n11), writingMode: n11.WritingMode });
  };
  e14.titleStyle = function(n11) {
    return t10(t10({}, (0, e14.textStyle)(n11)), { padding: (0, e14.paddings)(n11) });
  };
  e14.backgroundStyle = function(e15) {
    return { backgroundColor: e15.BackgroundColor, fill: e15.BackgroundColor };
  };
  e14.lineStyle = function(e15) {
    return { stroke: e15.Border.Color, strokeWidth: e15.Border.Width, strokeDasharray: e15.Border.Style };
  };
  e14.style = function(n11) {
    return t10(t10(t10({}, (0, e14.backgroundStyle)(n11)), (0, e14.lineStyle)(n11)), { borderStyle: (0, e14.lineStyle)(n11) });
  };
  e14.legendStyle = function(n11, r11) {
    return t10(t10({}, (0, e14.style)(n11)), { iconColor: r11 });
  };
  e14.dataPointStyle = function(e15) {
    return { symbolOpacity: e15.SymbolOpacity, symbolSize: e15.SymbolSize, opacity: e15.Opacity, strokeOpacity: e15.Opacity, fill: e15.Style.BackgroundColor, stroke: e15.LineStyle.Color, strokeWidth: e15.LineStyle.Width, strokeDasharray: e15.LineStyle.Style, symbolShape: e15.SymbolShape, symbolFill: e15.SymbolStyle.BackgroundColor, symbolStroke: e15.SymbolStyle.Border.Color, symbolStrokeWidth: e15.SymbolStyle.Border.Width, symbolStrokeDasharray: e15.SymbolStyle.Border.Style };
  };
  var o10 = ["Avg", "Count", "CountDistinct", "First", "Last", "Max", "Median", "Min", "Mode", "StDev", "StDevP", "Sum", "Var", "VarP"];
  var a10 = "(?<aggregateName>".concat(o10.join("|"), ")");
  var i10 = "Fields[\\.!](?<fieldName>[\\pL_\\d]+?)\\.Value";
  var s10 = 'Fields(?:\\.Item)?\\("(?<fieldName>[^"]+)"\\)\\.Value';
  var l10 = r10("^=\\s*".concat(i10, "\\s*$"), "gi");
  var c10 = r10("^=\\s*".concat(s10, "\\s*$"), "gi");
  var u10 = r10("^=\\s*".concat(a10, "\\s*\\(\\s*").concat(i10, "\\s*\\)\\s*$"), "gi");
  var d10 = r10("^=\\s*".concat(a10, "\\s*\\(\\s*").concat(s10, "\\s*\\)\\s*$"), "gi");
  function p10(e15, t11, n11) {
    void 0 === n11 && (n11 = false);
    var a11 = r10.exec(e15, t11);
    if (!a11) return null;
    var i11 = a11, s11 = i11.fieldName, l11 = i11.aggregateName;
    return s11 ? n11 && l11 ? "".concat(s11, " (").concat(function(e16) {
      var t12 = e16.toLowerCase();
      var n12 = o10.find(function(e17) {
        return e17.toLowerCase() === t12;
      });
      return n12 || e16;
    }(l11), ")") : s11 : null;
  }
  function m10(e15) {
    var t11 = e15 && e15.trim();
    return t11 ? '=""' === t11 ? "emptyField" : p10(t11, l10) || p10(t11, c10) || p10(t11, u10, true) || p10(t11, d10, true) || t11.replace(/^=/, "") : "stubField";
  }
  e14.mapField = m10;
  e14.mapAndEscapeField = function(e15) {
    return function(e16) {
      return e16.replace(/([,>])/g, "\\$1");
    }(m10(e15));
  };
  var h10 = function(e15, t11) {
    return void 0 === t11 && (t11 = "Sum"), e15 && "None" !== e15 ? e15 : t11;
  };
  var f10 = function(e15) {
    return e15 && "None" !== e15 ? e15 : null;
  };
  var g10 = function(e15) {
    return e15 && "None" !== e15 ? e15 : null;
  };
  function y10(t11, n11, r11) {
    var o11 = f10(t11);
    return n11 ? { field: (0, e14.mapAndEscapeField)(n11), order: o11, aggregate: r11 } : o11 || null;
  }
  var v10 = ["xField", "valueField", "categoryField", "detailFields", "colorField", "sizeField", "shapeField"].map(function(e15) {
    return e15.toLowerCase();
  });
  function b10(t11, o11, a11) {
    if (!a11) return null;
    var i11 = function(e15) {
      var t12 = r10("{s*((w+s+)*w+)([(d+)])?(.w*)*s*(:s*.+?)*s*}", "g");
      var n11 = [];
      var o12 = null;
      for (; o12 = t12.exec(e15); ) o12 && o12[1] && n11.push(o12[1]);
      return n11;
    }(a11.toString()).filter(function(e15) {
      return -1 === v10.indexOf(e15.toLowerCase());
    });
    var s11 = [];
    var l11 = function(e15, t12) {
      return s11.push({ field: e15, aggregate: t12 });
    };
    var c11 = n10(n10(n10([], o11.values, true), o11.details, true), [o11.category, o11.color, o11.shape, o11.size], false);
    return (t11.Values || []).forEach(function(t12) {
      var n11 = t12 && t12.Field;
      n11 && ("Complex" === n11.FieldType ? n11.Subfields.forEach(function(n12) {
        return l11((0, e14.mapAndEscapeField)(n12.Caption || n12.Value), h10(t12.Aggregate));
      }) : (n11.Value || []).forEach(function(r11, o12) {
        return l11((0, e14.mapAndEscapeField)(n11.Captions[o12] || r11), h10(t12.Aggregate));
      }));
    }), i11.forEach(function(t12) {
      var n11 = c11.find(function(e15) {
        return "string" == typeof e15.field && e15.field.toLowerCase() === t12.toLowerCase();
      });
      l11((0, e14.mapAndEscapeField)(n11 && n11.field || t12), n11 && n11.aggregate);
    }), s11;
  }
  var S10 = function(t11, n11) {
    var r11 = t11.map(function(t12) {
      return { field: t12.Field.Value.map(function(e15, n12) {
        return t12.Field.Captions[n12] || e15;
      }).map(e14.mapAndEscapeField).join(","), aggregate: "None" === t12.Aggregate ? null : h10(t12.Aggregate) };
    });
    return n11 && r11.push.apply(r11, n11), r11.length > 0 ? r11 : null;
  };
  e14.encodings = function(t11, n11, r11, o11) {
    var a11 = "Scatter" !== o11 && "Line" !== o11;
    var i11 = { values: t11.Values && t11.Values.map(function(t12) {
      return "Simple" === t12.Field.FieldType ? { field: t12.Field.Value.map(function(e15, n12) {
        return "Simple" === t12.Field.FieldType && t12.Field.Captions[n12] || e15;
      }).map(e14.mapAndEscapeField).join(","), aggregate: h10(t12.Aggregate) } : { field: t12.Field.Subfields.reduce(function(t13, n12) {
        return t13[n12.Key] = (0, e14.mapAndEscapeField)(n12.Caption || n12.Value), t13;
      }, {}), aggregate: h10(t12.Aggregate) };
    }), category: t11.Category && { field: t11.Category.Field.Value.length > 0 ? t11.Category.Field.Value.map(e14.mapAndEscapeField).join(">") : a11 ? "commonField" : "", sort: y10(t11.Category.Sort, t11.Category.SortingField, h10(t11.Category.SortingAggregate, "List")) }, color: t11.Color && { field: t11.Color.Field.Value.map(e14.mapAndEscapeField).join(","), aggregate: h10(t11.Color.Aggregate, "List") }, size: t11.Size && { field: t11.Size.Field.Value.map(e14.mapAndEscapeField).join(","), aggregate: h10(t11.Size.Aggregate) }, shape: t11.Shape && { field: t11.Shape.Field.Value.map(e14.mapAndEscapeField).join(","), aggregate: h10(t11.Shape.Aggregate, "List") }, details: t11.Details && t11.Details.map(function(t12) {
      return { field: t12.Field.Value.map(e14.mapAndEscapeField).join(","), excludeNulls: t12.ExcludeNulls, group: g10(t12.Group), sort: y10(t12.Sort, t12.SortingField, h10(t12.SortingAggregate, "List")) };
    }) };
    var s11 = b10(t11, i11, n11);
    i11.text = S10((t11.Texts || []).filter(function(e15) {
      return "Label" === e15.Target;
    }), s11);
    var l11 = b10(t11, i11, r11);
    return i11.tooltip = S10((t11.Texts || []).filter(function(e15) {
      return "ToolTip" === e15.Target;
    }), l11), i11;
  };
  var C10 = { BackgroundColor: "style.fill", LabelTemplate: "text.template", TooltipTemplate: "tooltip.template", LineColor: "style.stroke", LineStyle: "style.strokeDasharray", LineWidth: "style.strokeWidth", SymbolLineColor: "style.symbolStroke", SymbolLineStyle: "style.symbolStrokeDasharray", SymbolLineWidth: "style.symbolStrokeWidth", SymbolBackgroundColor: "style.symbolFill" };
  e14.convertRuleTarget = function(e15) {
    return C10[e15] || "style.fill";
  };
  e14.overlayStyle = function(e15) {
    return { stroke: e15.Border.Color, strokeWidth: e15.Border.Width, strokeDasharray: e15.Border.Style, strokeOpacity: 1, fill: e15.BackgroundColor };
  };
  var x10 = ["High", "Low", "Open", "Close", "Upper", "Lower"];
  e14.getOverlayField = function(t11) {
    return t11 ? x10.includes(t11) ? t11.toLowerCase() : (0, e14.mapAndEscapeField)(t11) : null;
  };
  e14.dateMode = function(e15, t11) {
    return "Y" === t11 || "Default" === e15 ? null : "Millisecond" === e15 ? "MilliSecond" : e15;
  };
}(PYe);
var NYe = {};
Object.defineProperty(NYe, "__esModule", { value: true }), NYe.compileAxesLabelsTemplates = NYe.compileEncodings = NYe.compileObject = void 0;
var DYe = wYe;
var LYe = PYe;
NYe.compileObject = function e11(t10, n10, r10) {
  var o10 = {};
  var a10 = function(a11) {
    var i11 = t10[a11];
    null === i11 ? o10[a11] = null : "object" == typeof i11 ? Array.isArray(i11) ? o10[a11] = i11.map(function(t11, o11) {
      return "object" == typeof t11 && null !== t11 ? e11(t11, n10, "".concat(r10, ".").concat(a11, "[").concat(o11, "]")) : DYe.isExpression(t11) ? n10(t11, "".concat(r10, ".").concat(a11, "[").concat(o11, "]")) : t11;
    }) : o10[a11] = e11(i11, n10, r10 + "." + a11) : o10[a11] = DYe.isExpression(i11) ? n10(i11, "".concat(r10, ".").concat(a11)) : i11;
  };
  for (var i10 = 0, s10 = Object.keys(t10); i10 < s10.length; i10++) {
    a10(s10[i10]);
  }
  return o10;
}, NYe.compileEncodings = function(e14, t10) {
  var n10 = {};
  var r10 = function(e15, r11, o11) {
    var a11 = t10(e15, o11);
    r11 && DYe.isExpression(r11) ? n10[LYe.mapField(r11)] = a11 : r11 ? n10[r11] = a11 : e15 && (n10[LYe.mapField(e15)] = a11);
  };
  var o10 = function(o11) {
    var a11 = e14[o11];
    var i10 = "model.plots[".concat(o11, "].encodings");
    a11.encodings.Color && a11.encodings.Color.Field.Value.forEach(function(e15, r11) {
      e15 && (n10[LYe.mapField(e15)] = DYe.isExpression(e15) ? t10(e15, "".concat(i10, ".color.field.value[").concat(r11, "]")) : e15);
    }), a11.encodings.Shape && a11.encodings.Shape.Field.Value.forEach(function(e15, r11) {
      e15 && (n10[LYe.mapField(e15)] = DYe.isExpression(e15) ? t10(e15, "".concat(i10, ".shape.field.value[").concat(r11, "]")) : e15);
    }), a11.encodings.Size && a11.encodings.Size.Field.Value.forEach(function(e15, r11) {
      e15 && (n10[LYe.mapField(e15)] = DYe.isExpression(e15) ? t10(e15, "".concat(i10, ".size.field.value[").concat(r11, "]")) : e15);
    }), a11.encodings.Category && a11.encodings.Category.Field.Value.forEach(function(e15, r11) {
      e15 && DYe.isExpression(e15) && (n10[LYe.mapField(e15)] = t10(e15, "".concat(i10, ".category.field.value[").concat(r11, "]")));
    }), a11.encodings.Category && a11.encodings.Category.SortingField && DYe.isExpression(a11.encodings.Category.SortingField) && (n10[LYe.mapField(a11.encodings.Category.SortingField)] = t10(a11.encodings.Category.SortingField, "".concat(i10, ".category.sortingField"))), a11.encodings.Details && a11.encodings.Details.forEach(function(e15, r11) {
      e15.Field.Value.forEach(function(e16, o12) {
        e16 && DYe.isExpression(e16) && (n10[LYe.mapField(e16)] = t10(e16, "".concat(i10, ".details[").concat(r11, "].field.value[").concat(o12, "]")));
      }), e15.SortingField && DYe.isExpression(e15.SortingField) && (n10[LYe.mapField(e15.SortingField)] = t10(e15.SortingField, "".concat(i10, ".details[").concat(r11, "].sortingField")));
    }), a11.encodings.Texts && a11.encodings.Texts.forEach(function(e15, t11) {
      var n11, o12, a12;
      for (var s10 = 0; s10 < e15.Field.Value.length; s10++) r10(null !== (o12 = null === (n11 = e15.Field.Value[s10]) || void 0 === n11 ? void 0 : n11.toString()) && void 0 !== o12 ? o12 : null, null !== (a12 = e15.Field.Captions[s10]) && void 0 !== a12 ? a12 : null, "".concat(i10, ".texts[").concat(t11, "].field.value[").concat(s10, "]"));
    }), a11.encodings.Values && a11.encodings.Values.forEach(function(e15, t11) {
      var n11, o12, a12;
      if ("Simple" === e15.Field.FieldType) for (var s10 = 0; s10 < e15.Field.Value.length; s10++) r10(null !== (o12 = null === (n11 = e15.Field.Value[s10]) || void 0 === n11 ? void 0 : n11.toString()) && void 0 !== o12 ? o12 : null, null !== (a12 = e15.Field.Captions[s10]) && void 0 !== a12 ? a12 : null, "".concat(i10, ".values[").concat(t11, "].field.value[").concat(s10, "]"));
      else e15.Field.Subfields && e15.Field.Subfields.forEach(function(e16) {
        var n12, o13;
        r10(null !== (n12 = e16.Value) && void 0 !== n12 ? n12 : null, null !== (o13 = e16.Caption) && void 0 !== o13 ? o13 : null, "".concat(i10, ".values[").concat(t11, "].field.value[").concat(e16.Key, "]"));
      });
    });
  };
  for (var a10 = 0; a10 < e14.length; a10++) o10(a10);
  return n10;
}, NYe.compileAxesLabelsTemplates = function(e14, t10) {
  var n10 = {};
  return e14.config.plotAreas.forEach(function(e15, r10) {
    e15.axes.forEach(function(e16, o10) {
      e16.labelTemplate && (n10[DYe.hashCode(e16.labelTemplate)] = t10(e16.labelTemplate, "model.config.plotAreas[".concat(r10, "].axes[").concat(o10, "].labelTemplate")));
    });
  }), n10;
};
var HYe = {};
var IYe = $ && $.__assign || function() {
  return IYe = Object.assign || function(e14) {
    for (var t10, n10 = 1, r10 = arguments.length; n10 < r10; n10++) for (var o10 in t10 = arguments[n10]) Object.prototype.hasOwnProperty.call(t10, o10) && (e14[o10] = t10[o10]);
    return e14;
  }, IYe.apply(this, arguments);
};
Object.defineProperty(HYe, "__esModule", { value: true }), HYe.resolveOverlay = HYe.resolveRule = HYe.dataPointStyle = HYe.overlayStyle = HYe.legendStyle = HYe.style = HYe.lineStyle = HYe.backgroundStyle = HYe.gaugeLabelStyle = HYe.titleStyle = HYe.labelStyle = HYe.textStyle = HYe.paddings = void 0;
var _Ye = wYe;
function VYe(e14, t10) {
  return { left: _Ye.toPx(t10(e14.left)), right: _Ye.toPx(t10(e14.right)), top: _Ye.toPx(t10(e14.top)), bottom: _Ye.toPx(t10(e14.bottom)) };
}
function RYe(e14, t10) {
  var n10 = t10(e14.textDecoration);
  return { color: t10(e14.color), fontFamily: t10(e14.fontFamily), fontSize: t10(e14.fontSize), fontStyle: t10(e14.fontStyle), fontWeight: jYe(t10(e14.fontWeight)), textDecoration: { overline: "Overline" === n10, lineThrough: "LineThrough" === n10, underline: "Underline" === n10 } };
}
function AYe(e14, t10) {
  return IYe(IYe({}, RYe(e14, t10)), { writingMode: "tb-rl" === t10(e14.writingMode) ? "Vertical" : "Horizontal" });
}
function OYe(e14, t10) {
  return { fill: t10(e14.fill), backgroundColor: t10(e14.backgroundColor) };
}
function BYe(e14, t10, n10) {
  var r10 = _Ye.toPx(n10(e14));
  var o10 = n10(t10);
  return "None" === o10 && (r10 = 0), { strokeWidth: r10, strokeStyle: o10 };
}
function zYe(e14, t10) {
  var n10 = BYe(e14.strokeWidth, e14.strokeDasharray, t10), r10 = n10.strokeWidth, o10 = n10.strokeStyle;
  return { stroke: t10(e14.stroke), strokeWidth: r10, strokeDasharray: GYe(o10, r10), strokeOpacity: 1 };
}
function $Ye(e14, t10) {
  return IYe(IYe({}, OYe(e14, t10)), zYe(e14, t10));
}
function WYe(e14, t10) {
  return IYe(IYe({}, zYe(e14, t10)), { strokeOpacity: t10(e14.strokeOpacity), fill: t10(e14.fill) });
}
HYe.paddings = VYe, HYe.textStyle = RYe, HYe.labelStyle = function(e14, t10) {
  return IYe(IYe({}, RYe(e14, t10)), { padding: VYe(e14.padding, t10), writingMode: "tb-rl" === t10(e14.writingMode) ? "Vertical" : "Horizontal" });
}, HYe.titleStyle = function(e14, t10) {
  return IYe(IYe({}, RYe(e14, t10)), { padding: VYe(e14.padding, t10) });
}, HYe.gaugeLabelStyle = AYe, HYe.backgroundStyle = OYe, HYe.lineStyle = zYe, HYe.style = $Ye, HYe.legendStyle = function(e14, t10) {
  return IYe(IYe({}, $Ye(e14, t10)), { iconColor: t10(e14.iconColor) });
}, HYe.overlayStyle = WYe;
HYe.dataPointStyle = function(e14, t10) {
  var n10 = t10(e14.symbolShape);
  var r10 = BYe(e14.symbolStrokeWidth, e14.symbolStrokeDasharray, t10), o10 = r10.strokeWidth, a10 = r10.strokeStyle;
  return "None" === a10 && (o10 = function(e15) {
    return ["X", "Dash", "Plus"].findIndex(function(t11) {
      return t11 === e15;
    }) >= 0;
  }(n10) ? null : 0), IYe(IYe({ symbolOpacity: t10(e14.symbolOpacity), symbolSize: t10(e14.symbolSize), symbolStrokeOpacity: t10(e14.symbolOpacity), fill: t10(e14.fill) }, zYe(e14, t10)), { opacity: t10(e14.opacity), strokeOpacity: t10(e14.strokeOpacity), symbolShape: "Auto" === n10 ? null : n10, symbolFill: t10(e14.symbolFill), symbolStroke: t10(e14.symbolStroke), symbolStrokeWidth: o10, symbolStrokeDasharray: GYe(a10, o10) });
};
var jYe = function(e14) {
  return ZYe[(e14 || "Normal").toLowerCase()].toString();
};
var ZYe = { lighter: 0, thin: 100, extralight: 200, light: 300, normal: 400, medium: 500, semibold: 600, bold: 700, extrabold: 800, heavy: 900, bolder: 1e3 };
function GYe(e14, t10) {
  if (!e14 || !t10) return null;
  switch (e14.toLowerCase()) {
    case "dotted":
      return "".concat(t10, ", ").concat(t10);
    case "dashed":
      return "".concat(4 * t10, ", ").concat(4 * t10);
    case "dashdot":
    case "dashdotdot":
      return "".concat(4 * t10, ", ").concat(4 * t10, ", ").concat(t10, ", ").concat(4 * t10);
    default:
      return null;
  }
}
HYe.resolveRule = function(e14, t10, n10, r10) {
  var o10 = r10(e14);
  switch (o10) {
    case "style.strokeWidth":
    case "style.symbolStrokeWidth":
      return { name: o10, value: _Ye.toPx(r10(t10)) };
    case "style.strokeDasharray":
      var a10 = BYe(n10.strokeWidth, t10, r10), i10 = a10.strokeWidth;
      return { name: o10, value: GYe(a10.strokeStyle, i10) };
    case "style.symbolStrokeDasharray":
      var s10 = BYe(n10.symbolStrokeWidth, t10, r10), l10 = s10.strokeWidth;
      return { name: o10, value: GYe(s10.strokeStyle, l10) };
    default:
      return { name: o10, value: r10(t10) };
  }
}, HYe.resolveOverlay = function(e14, t10) {
  switch (e14.type) {
    case "Needle":
      var n10 = _Ye.toPx(t10(e14.width));
      return { type: t10(e14.type), display: t10(e14.display), start: t10(e14.start), end: "1,".concat(_Ye.toNumber(t10(e14.end))), width: n10 ? n10 / 2 : null, style: { stroke: t10(e14.style.stroke), opacity: t10(e14.style.opacity), fill: t10(e14.style.fill) } };
    case "Ellipse":
      return { type: t10(e14.type), display: t10(e14.display), pointPath: t10(e14.pointPath), position: t10(e14.position), width: _Ye.toPx(t10(e14.width)), height: _Ye.toPx(t10(e14.height)), style: { stroke: t10(e14.style.stroke), opacity: t10(e14.style.opacity), fill: t10(e14.style.fill) } };
    case "Text":
      var r10 = e14.offset.map(function(e15) {
        return _Ye.toPx(t10(e15));
      }), o10 = r10[0], a10 = r10[1];
      return { type: t10(e14.type), display: t10(e14.display), pointPath: t10(e14.pointPath), position: t10(e14.position), text: _Ye.toStringOrNull(t10(e14.text)), offset: "".concat(o10, ",").concat(a10), textStyle: IYe({}, AYe(e14.textStyle, t10)) };
    default:
      return { label: t10(e14.label), legendText: t10(e14.legendText), type: t10(e14.type), display: t10(e14.display), style: WYe(e14.style, t10), field: t10(e14.field), detailLevel: t10(e14.detailLevel), axis: t10(e14.axis), aggregate: t10(e14.aggregate), start: t10(e14.start), end: t10(e14.end), order: t10(e14.order), period: t10(e14.period), intercept: t10(e14.intercept), forecast: { backwardPeriod: t10(e14.forecast.backwardPeriod), forwardPeriod: t10(e14.forecast.forwardPeriod) }, value: t10(e14.value) };
  }
};
var UYe = $ && $.__assign || function() {
  return UYe = Object.assign || function(e14) {
    for (var t10, n10 = 1, r10 = arguments.length; n10 < r10; n10++) for (var o10 in t10 = arguments[n10]) Object.prototype.hasOwnProperty.call(t10, o10) && (e14[o10] = t10[o10]);
    return e14;
  }, UYe.apply(this, arguments);
};
var qYe = $ && $.__spreadArray || function(e14, t10, n10) {
  if (n10 || 2 === arguments.length) for (var r10, o10 = 0, a10 = t10.length; o10 < a10; o10++) !r10 && o10 in t10 || (r10 || (r10 = Array.prototype.slice.call(t10, 0, o10)), r10[o10] = t10[o10]);
  return e14.concat(r10 || Array.prototype.slice.call(t10));
};
Object.defineProperty(xYe, "__esModule", { value: true });
var YYe = wYe;
var KYe = PYe;
var XYe = NYe;
var JYe = HYe;
var QYe = xYe.default = function(e14, t10, n10, r10) {
  var o10 = function(e15, t11) {
    var n11, r11;
    var o11, a11;
    var i10 = e15.Plots.map(function(e16) {
      return e16.PlotName;
    });
    var s10 = { bar: { bottomWidth: e15.Bar.BottomWidth, neckHeight: e15.Bar.NeckHeight, overlap: e15.Bar.Overlap, topWidth: e15.Bar.TopWidth, width: e15.Bar.Width }, header: { title: e15.Header.Title, height: void 0 === e15.Header.Height ? null : e15.Header.Height, style: KYe.style(e15.Header.Style), textStyle: KYe.textStyle(e15.Header.TextStyle), padding: KYe.paddings(e15.Header.Style), hAlign: e15.Header.HAlign, vAlign: e15.Header.VAlign }, footer: { title: e15.Footer.Title, height: void 0 === e15.Footer.Height ? null : e15.Footer.Height, style: KYe.style(e15.Footer.Style), textStyle: KYe.textStyle(e15.Footer.TextStyle), padding: KYe.paddings(e15.Footer.Style), hAlign: e15.Footer.HAlign, vAlign: e15.Footer.VAlign }, palette: "Custom" === e15.Palette ? e15.CustomPalette : e15.Palette, plotAreas: [{ axes: qYe([], e15.PlotArea.Axes, true).sort(function(e16, t12) {
      return e16.AxisType.charCodeAt(0) - t12.AxisType.charCodeAt(0);
    }).map(function(e16) {
      return { axisLine: e16.AxisLine, dateMode: KYe.dateMode(e16.DateMode, e16.AxisType), format: e16.Format, height: e16.Height, labelAngle: e16.LabelAngle, reversed: e16.Reversed, logBase: e16.LogBase, labelStyle: KYe.labelStyle(e16.LabelStyle), labels: e16.Labels, labelTemplate: e16.LabelField, lineStyle: KYe.lineStyle(e16.LineStyle), majorGrid: e16.MajorGrid, majorGridStyle: KYe.lineStyle(e16.MajorGridStyle), majorTicks: e16.MajorTicks, majorTickStyle: KYe.lineStyle(e16.MajorTickStyle), majorTickSize: e16.MajorTickSize, majorUnit: e16.MajorUnit, max: e16.Max, maxHeight: e16.MaxHeight, maxWidth: e16.MaxWidth, min: e16.Min, minorGrid: e16.MinorGrid, minorGridStyle: KYe.lineStyle(e16.MinorGridStyle), minorTicks: e16.MinorTicks, minorTickStyle: KYe.lineStyle(e16.MinorTickStyle), minorTickSize: e16.MinorTickSize, minorUnit: e16.MinorUnit, origin: e16.Origin, overlappingLabels: e16.OverlappingLabels, plots: e16.Plots.filter(function(e17) {
        return i10.indexOf(e17) > -1;
      }), position: e16.Position, scale: { type: e16.Scale }, textStyle: KYe.textStyle(e16.TextStyle), title: e16.Title, titleStyle: KYe.titleStyle(e16.TitleStyle), type: e16.AxisType, width: e16.Width };
    }), legends: e15.PlotArea.Legends.map(function(e16) {
      return { hidden: e16.Hidden, orientation: e16.Orientation, position: e16.Position, style: KYe.legendStyle(e16.Style, "Color" !== e16.LegendType ? e16.IconColor : null), textStyle: KYe.textStyle(e16.TextStyle), titleStyle: KYe.textStyle(e16.TitleStyle), padding: KYe.paddings(e16.Style), title: e16.Title, type: e16.LegendType, template: "Size" === e16.LegendType ? "{from:g}-{to:g}" : "{value:g}", maxHeight: e16.MaxHeight, maxWidth: e16.MaxWidth, ranges: e16.RangeOptions.map(function(e17) {
        var t12 = e17.To, n12 = e17.Title;
        return { to: t12, title: "" === n12 ? null : n12 };
      }).sort(function(e17, t12) {
        return e17.to - t12.to;
      }) };
    }), legend: { hidden: e15.Legend.Hidden, orientation: e15.Legend.Orientation, position: e15.Legend.Position, textStyle: KYe.textStyle(e15.Legend.TextStyle), titleStyle: KYe.textStyle(e15.Legend.TitleStyle), style: KYe.style(e15.Legend.Style), padding: KYe.paddings(e15.Legend.Style), wrapping: e15.Legend.Wrapping }, style: KYe.backgroundStyle(e15.PlotArea.Style), borderStyle: KYe.lineStyle(e15.PlotArea.Style), padding: KYe.paddings(e15.PlotArea.Style) }] };
    var l10 = e15.Plots.map(function(e16) {
      return function(e17, t12) {
        var n12, r12, o12, a12, i11, s11;
        var l11 = { name: e17.PlotName, type: e17.PlotType, config: { action: e17.Config.Action, bar: { bottomWidth: null !== (n12 = e17.Config.Bar.BottomWidth) && void 0 !== n12 ? n12 : null, neckHeight: null !== (r12 = e17.Config.Bar.NeckHeight) && void 0 !== r12 ? r12 : null, overlap: null !== (o12 = e17.Config.Bar.Overlap) && void 0 !== o12 ? o12 : null, topWidth: null !== (a12 = e17.Config.Bar.TopWidth) && void 0 !== a12 ? a12 : null, width: null !== (i11 = e17.Config.Bar.Width) && void 0 !== i11 ? i11 : null }, clippingMode: e17.Config.ClippingMode, offset: e17.Config.Offset, innerRadius: e17.Config.InnerRadius, lineAspect: e17.Config.LineAspect, axisMode: eKe(e17.Config.AxisMode, e17.Config.Radial), showNulls: e17.Config.ShowNulls, startAngle: e17.Config.StartAngle, style: KYe.dataPointStyle(e17.Config), swapAxes: e17.Config.SwapAxes, sweep: e17.Config.Sweep, symbols: e17.Config.Symbols, useGlobalLegend: !!(null === (s11 = e17.Encodings.Color.Field.Value[0]) || void 0 === s11 ? void 0 : s11.toString().includes("VALUESNAME")), unpivotData: e17.Config.UnpivotData, text: { connectingLine: KYe.lineStyle(e17.Config.Text.ConnectingLine), linePosition: e17.Config.Text.LinePosition, overlappingLabels: e17.Config.Text.OverlappingLabels, position: e17.Config.Text.TextPosition, template: e17.Config.Text.Template || null, offset: e17.Config.Text.Offset, style: KYe.style(e17.Config.Text.Style), textStyle: KYe.textStyle(e17.Config.Text.Style), angle: 0 }, tooltip: { template: e17.Config.Tooltip.Template }, overlays: e17.Config.Overlays.map(function(e18) {
          return { label: "ReferenceLine" !== e18.OverlayType && e18.LegendLabel ? e18.LegendLabel : null, legendText: "ReferenceLine" === e18.OverlayType && e18.LegendLabel ? e18.LegendLabel : null, type: e18.OverlayType, display: e18.Display, style: KYe.overlayStyle(e18.Style), field: KYe.getOverlayField(e18.Field), detailLevel: e18.DetailLevel, axis: e18.Axis, aggregate: e18.AggregateType, start: e18.Start, end: e18.End, order: e18.Order, period: e18.Period, intercept: e18.Intercept, forecast: { backwardPeriod: e18.BackwardForecastPeriod, forwardPeriod: e18.ForwardForecastPeriod }, value: e18.Value || null };
        }), rules: t12 ? e17.Config.Rules.map(function(e18) {
          return { condition: e18.Condition, type: "DataPoint", actions: e18.RuleProperties.map(function(e19) {
            return { targetElement: "DataPoint", properties: [{ name: KYe.convertRuleTarget(e19.TargetProperty), value: e19.Value }] };
          }) };
        }) : [] }, encodings: e17.Encodings };
        if (e17.Config.BarLines) {
          var c11 = e17.Config.BarLineStyle || {}, u11 = c11.Color, d11 = void 0 === u11 ? "Black" : u11, p10 = c11.Style, m10 = void 0 === p10 ? "Solid" : p10, h10 = c11.Width;
          var f10 = { label: null, legendText: null, display: "Front", field: "", detailLevel: "Total", type: "BarLine", axis: "Y", start: 1, end: 1, order: 2, period: 2, aggregate: "Average", value: "", intercept: null, forecast: { backwardPeriod: 0, forwardPeriod: 0 }, style: { stroke: d11, strokeDasharray: m10, strokeWidth: void 0 === h10 ? "1pt" : h10, strokeOpacity: e17.Config.Opacity, fill: "black" } };
          l11.config.overlays.push(f10);
        }
        var g10 = e17.Config.Pointers;
        Array.isArray(g10) && g10.forEach(function(t13) {
          var n13 = { type: "Needle", display: "Front", start: "center", end: t13.End, width: t13.NeedleWidth, style: { stroke: "none", opacity: e17.Config.Opacity, fill: t13.Style.BackgroundColor } };
          var r13 = { type: "Ellipse", display: "Front", pointPath: "center", position: "Center", width: t13.NeedlePinWidth, height: t13.NeedlePinWidth, style: { stroke: "none", opacity: e17.Config.Opacity, fill: t13.Style.BackgroundColor } };
          l11.config.overlays.push(n13, r13);
        });
        var y10 = e17.Config.CustomLabels;
        Array.isArray(y10) && y10.forEach(function(e18) {
          var t13 = { type: "Text", display: "Front", pointPath: "center", position: "Center", text: e18.Text, offset: [e18.OffsetX, e18.OffsetY], textStyle: { fontStyle: e18.Style.FontStyle, fontSize: e18.Style.FontSize, fontFamily: e18.Style.FontFamily, fontWeight: e18.Style.FontWeight, color: e18.Style.Color, textDecoration: e18.Style.TextDecoration, writingMode: e18.Style.WritingMode } };
          l11.config.overlays.push(t13);
        });
        return l11;
      }(e16, t11);
    });
    var c10 = s10.plotAreas[0].legends.filter(function(e16) {
      return "Color" == e16.type;
    });
    var u10 = c10[0];
    var d10 = l10.filter(function(e16) {
      return "HighLowOpenClose" !== e16.type && "Candlestick" !== e16.type;
    });
    u10 && d10.length > 1 ? d10.forEach(function(e16, t12) {
      c10.length <= t12 && s10.plotAreas[0].legends.push(UYe({}, u10));
    }) : !u10 && d10.length >= 1 && d10.forEach(function() {
      s10.plotAreas[0].legends.push(UYe(UYe({}, tKe), { type: "Color" }));
    });
    return l10.forEach(function(e16, t12) {
      var n12 = e16.config, r12 = n12.useGlobalLegend, o12 = n12.unpivotData;
      var a12 = 0;
      s10.plotAreas[0].legends.forEach(function(e17, n13) {
        "Color" === e17.type && (a12 === t12 && r12 && (s10.plotAreas[0].legends[n13] = UYe(UYe(UYe(UYe({}, tKe), { type: "Color", title: null }), s10.plotAreas[0].legend), { style: UYe(UYe({}, s10.plotAreas[0].legend.style), { iconColor: null }) }), o12 && (s10.plotAreas[0].legends[n13].titleStyle.fontSize = "0px")), a12++);
      });
    }), null === (o11 = s10.plotAreas[0].axes.find(function(e16) {
      return "X" === e16.type;
    })) || void 0 === o11 || (n11 = o11.plots).push.apply(n11, i10.filter(function(e16) {
      return !s10.plotAreas[0].axes.some(function(t12) {
        return "X" === t12.type && t12.plots.includes(e16);
      });
    })), null === (a11 = s10.plotAreas[0].axes.find(function(e16) {
      return "Y" === e16.type;
    })) || void 0 === a11 || (r11 = a11.plots).push.apply(r11, i10.filter(function(e16) {
      return !s10.plotAreas[0].axes.some(function(t12) {
        return "Y" === t12.type && t12.plots.includes(e16);
      });
    })), { config: s10, plots: l10 };
  }(e14, r10);
  var a10 = function(e15, t11, n11, r11) {
    var o11 = XYe.compileObject(e15.config, t11, "model.config");
    var a11 = e15.plots.map(function(e16, n12) {
      return { name: e16.name, type: e16.type, config: XYe.compileObject(UYe(UYe({}, e16.config), { rules: e16.config.rules.map(function(e17) {
        return UYe(UYe({}, e17), { condition: null });
      }) }), t11, "model.plots[".concat(n12, "]")), encodings: e16.encodings };
    });
    var i10 = XYe.compileEncodings(e15.plots, n11);
    var s10 = XYe.compileAxesLabelsTemplates(e15, n11);
    var l10 = {};
    r11 && e15.plots.forEach(function(e16) {
      e16.config.action && (l10["___action___" + e16.name] = rKe(e16.config.action, n11)), e16.encodings.Color.Action && (l10["___action___color-encoding___" + e16.name] = rKe(e16.encodings.Color.Action, n11)), e16.encodings.Size.Action && (l10["___action___size-encoding___" + e16.name] = rKe(e16.encodings.Size.Action, n11)), e16.encodings.Shape.Action && (l10["___action___shape-encoding___" + e16.name] = rKe(e16.encodings.Shape.Action, n11));
    });
    var c10 = [];
    var u10 = function(t12, n12) {
      var r12;
      var o12 = null === (r12 = t12.encodings) || void 0 === r12 ? void 0 : r12.values.map(function(e16) {
        return e16.field;
      });
      var a12 = "unpivotDataFields/".concat(t12.name);
      var i11 = "unpivotData/".concat(t12.name);
      var s11 = "unpivotDataCategory/".concat(t12.name);
      return c10.push({ category: { fieldAs: s11, from: o12 }, valueFieldAs: a12, outputAs: i11 }), UYe(UYe({}, t12), { data: i11, encodings: UYe(UYe({}, t12.encodings), { values: [{ field: a12 }], details: [{ field: s11, group: "Stack" }], color: e15.plots[n12].config.useGlobalLegend ? { field: s11 } : t12.encodings.color, text: t12.config.text.template ? { field: s11 } : t12.encodings.text }) });
    };
    return function(t12, n12) {
      var r12 = function(e16) {
        return nKe(e16, t12);
      };
      return { config: { bar: { bottomWidth: iKe(r12(o11.bar.bottomWidth)), neckHeight: iKe(r12(o11.bar.neckHeight)), overlap: iKe(r12(o11.bar.overlap)), topWidth: iKe(r12(o11.bar.topWidth)), width: iKe(r12(o11.bar.width)) }, header: { title: r12(o11.header.title), height: r12(o11.header.height), style: JYe.style(o11.header.style, r12), textStyle: JYe.textStyle(o11.header.textStyle, r12), borderStyle: JYe.lineStyle(o11.header.style, r12), padding: JYe.paddings(o11.header.padding, r12), hAlign: r12(o11.header.hAlign), vAlign: r12(o11.header.vAlign) }, footer: { title: r12(o11.footer.title), height: r12(o11.footer.height), style: JYe.style(o11.footer.style, r12), textStyle: JYe.textStyle(o11.footer.textStyle, r12), borderStyle: JYe.lineStyle(o11.footer.style, r12), padding: JYe.paddings(o11.footer.padding, r12), hAlign: r12(o11.footer.hAlign), vAlign: r12(o11.footer.vAlign) }, palette: Array.isArray(o11.palette) ? o11.palette.map(r12).filter(function(e16) {
        return e16;
      }) : r12(o11.palette), plotAreas: o11.plotAreas.map(function(t13, n13) {
        return { axes: t13.axes.map(function(t14, o12) {
          return { axisLine: r12(t14.axisLine), dateMode: r12(t14.dateMode), format: r12(t14.format), height: YYe.convertPercentRange(r12(t14.height)), labelAngle: [r12(t14.labelAngle)], reversed: r12(t14.reversed), logBase: r12(t14.logBase), labelStyle: JYe.labelStyle(t14.labelStyle, r12), labels: r12(t14.labels), labelTemplate: e15.config.plotAreas[n13].axes[o12].labelTemplate ? "{".concat(YYe.hashCode(e15.config.plotAreas[n13].axes[o12].labelTemplate), ".value}") : null, lineStyle: JYe.lineStyle(t14.lineStyle, r12), majorGrid: r12(t14.majorGrid), majorGridStyle: JYe.lineStyle(t14.majorGridStyle, r12), majorTicks: r12(t14.majorTicks), majorTickStyle: JYe.lineStyle(t14.majorTickStyle, r12), majorTickSize: YYe.toPx(r12(t14.majorTickSize)), majorUnit: YYe.tryConvertToNumber(r12(t14.majorUnit)), max: YYe.tryConvertToNumber(r12(t14.max)), maxHeight: YYe.convertPercentRange(r12(t14.maxHeight)), maxWidth: YYe.convertPercentRange(r12(t14.maxWidth)), min: YYe.tryConvertToNumber(r12(t14.min)), minorGrid: r12(t14.minorGrid), minorGridStyle: JYe.lineStyle(t14.minorGridStyle, r12), minorTicks: r12(t14.minorTicks), minorTickStyle: JYe.lineStyle(t14.minorTickStyle, r12), minorTickSize: YYe.toPx(r12(t14.minorTickSize)), minorUnit: YYe.tryConvertToNumber(r12(t14.minorUnit)), origin: YYe.tryConvertToNumber(r12(t14.origin)), overlappingLabels: r12(t14.overlappingLabels), plots: t14.plots.map(function(e16) {
            return r12(e16);
          }), position: r12(t14.position), scale: { type: r12(t14.scale.type) }, textStyle: JYe.textStyle(t14.textStyle, r12), title: r12(t14.title), titleStyle: JYe.titleStyle(t14.titleStyle, r12), type: r12(t14.type), width: YYe.convertPercentRange(r12(t14.width)) };
        }), legends: t13.legends.map(function(e16) {
          return { orientation: r12(e16.orientation), position: r12(e16.hidden) ? "None" : r12(e16.position), textStyle: JYe.textStyle(e16.textStyle, r12), titleStyle: JYe.textStyle(e16.titleStyle, r12), style: JYe.legendStyle(e16.style, r12), borderStyle: JYe.lineStyle(e16.style, r12), padding: JYe.paddings(e16.padding, r12), title: r12(e16.title), type: r12(e16.type), gradient: { enabled: false }, template: r12(e16.template), maxHeight: YYe.convertPercentRange(r12(e16.maxHeight)), maxWidth: YYe.convertPercentRange(r12(e16.maxWidth)), ranges: e16.ranges.length > 0 ? e16.ranges.map(function(e17) {
            var t14 = e17.to, n14 = e17.title;
            return { to: r12(t14), title: r12(n14) };
          }) : null };
        }), legend: { orientation: r12(t13.legend.orientation), position: r12(t13.legend.hidden) ? "None" : r12(t13.legend.position), textStyle: JYe.textStyle(t13.legend.textStyle, r12), titleStyle: JYe.textStyle(t13.legend.titleStyle, r12), style: JYe.style(t13.legend.style, r12), borderStyle: JYe.lineStyle(t13.legend.style, r12), padding: JYe.paddings(t13.legend.padding, r12), wrapping: r12(t13.legend.wrapping) }, style: JYe.backgroundStyle(t13.style, r12), borderStyle: JYe.lineStyle(t13.borderStyle, r12), padding: JYe.paddings(t13.padding, r12) };
      }) }, plots: a11.map(function(t13, n13) {
        var o12 = r12(t13.config.text.template);
        var a12 = r12(t13.config.tooltip.template);
        var i11 = { name: t13.name, type: t13.type, config: { bar: { bottomWidth: iKe(r12(t13.config.bar.bottomWidth)), neckHeight: iKe(r12(t13.config.bar.neckHeight)), overlap: iKe(r12(t13.config.bar.overlap)), topWidth: iKe(r12(t13.config.bar.topWidth)), width: iKe(r12(t13.config.bar.width)) }, clippingMode: r12(t13.config.clippingMode), offset: r12(t13.config.offset), innerRadius: r12(t13.config.innerRadius), lineAspect: r12(t13.config.lineAspect), axisMode: r12(t13.config.axisMode), showNulls: r12(t13.config.showNulls), startAngle: oKe(r12(t13.config.startAngle)), style: JYe.dataPointStyle(t13.config.style, r12), swapAxes: r12(t13.config.swapAxes), sweep: r12(t13.config.sweep), symbols: aKe(r12(t13.config.symbols), t13.type), text: { connectingLine: JYe.lineStyle(t13.config.text.connectingLine, r12), linePosition: r12(t13.config.text.linePosition), overlappingLabels: r12(t13.config.text.overlappingLabels), position: r12(t13.config.text.position), template: o12, offset: r12(t13.config.text.offset), style: JYe.style(t13.config.text.style, r12), textStyle: JYe.textStyle(t13.config.text.textStyle, r12), angle: r12(t13.config.text.angle) }, tooltip: { template: a12 }, rules: t13.config.rules.map(function(o13, a13) {
          return { condition: e15.plots[n13].config.rules[a13].condition, type: r12(o13.type), actions: o13.actions.map(function(e16) {
            return { targetElement: r12(e16.targetElement), properties: e16.properties.map(function(e17) {
              return JYe.resolveRule(e17.name, e17.value, t13.config.style, r12);
            }) };
          }) };
        }), overlays: t13.config.overlays.map(function(e16) {
          return JYe.resolveOverlay(e16, r12);
        }) }, encodings: KYe.encodings(t13.encodings, o12, a12, t13.type) };
        return e15.plots[n13].config.unpivotData && (i11 = u10(i11, n13)), i11;
      }), data: { values: n12.map(function(e16) {
        return UYe(UYe(UYe({ commonField: "" }, YYe.mapValues(i10, function(t13) {
          return nKe(t13, e16);
        })), YYe.mapValues(l10, function(t13) {
          return function(e17, t14) {
            var n13 = function(e18) {
              return nKe(e18, t14);
            };
            var r13 = "".concat(n13(e17.BookmarkLink));
            return { BookmarkLink: r13 ? "bm_".concat(encodeURIComponent(r13)) : "", Hyperlink: n13(e17.Hyperlink), Drillthrough: { ReportName: n13(e17.Drillthrough.ReportName), Parameters: e17.Drillthrough.Parameters.map(function(e18) {
              return { ParameterName: e18.ParameterName, Value: n13(e18.Value), Omit: n13(e18.Omit) };
            }) }, ApplyParameters: { Parameters: e17.ApplyParameters.Parameters.map(function(e18) {
              return UYe(UYe({}, e18), { Value: n13(e18.Value) });
            }) } };
          }(t13, e16);
        })), YYe.mapValues(s10, function(t13) {
          return nKe(t13, e16);
        }));
      }), dateFormats: false }, transform: c10 };
    };
  }(o10, t10, n10, r10);
  return a10;
};
function eKe(e14, t10) {
  return e14 || (t10 ? "Radial" : "Cartesian");
}
var tKe = { hidden: false, orientation: "Vertical", position: "Right", textStyle: { color: "Black", fontFamily: "Arial", fontSize: "10pt", fontStyle: "Normal", fontWeight: "Normal", textDecoration: "None" }, titleStyle: { color: "Black", fontFamily: "Arial", fontSize: "10pt", fontStyle: "Normal", fontWeight: "Normal", textDecoration: "None" }, style: { borderStyle: { stroke: "Black", strokeWidth: "0pt", strokeDasharray: "" }, stroke: "Black", strokeWidth: "0pt", strokeDasharray: "", backgroundColor: "Transparent", fill: "Transparent", iconColor: null }, padding: { left: "0pt", right: "0pt", top: "0pt", bottom: "0pt" }, title: "", template: "{value:g}", maxHeight: 1, maxWidth: 1, ranges: [] };
function nKe(e14, t10) {
  return "function" == typeof e14 ? e14(t10) : e14;
}
function rKe(e14, t10) {
  return { BookmarkLink: YYe.isExpression(e14.BookmarkLink) ? t10(e14.BookmarkLink, "Action.BookmarkLink") : e14.BookmarkLink, Hyperlink: YYe.isExpression(e14.Hyperlink) ? t10(e14.Hyperlink, "Action.Hyperlink") : e14.Hyperlink, Drillthrough: { ReportName: YYe.isExpression(e14.Drillthrough.ReportName) ? t10(e14.Drillthrough.ReportName, "Action.Drillthrough.ReportName") : e14.Drillthrough.ReportName, Parameters: e14.Drillthrough.Parameters.map(function(e15, n10) {
    return { ParameterName: e15.ParameterName, Value: YYe.isExpression(e15.Value) ? t10(e15.Value, "Action.Drillthrough.Parameters[".concat(n10, "].Value")) : e15.Value, Omit: YYe.isExpression(e15.Omit) ? t10(e15.Omit, "Action.Drillthrough.Parameters[".concat(n10, "].Omit")) : e15.Omit };
  }) }, ApplyParameters: { Parameters: e14.ApplyParameters.Parameters.map(function(e15, n10) {
    return UYe(UYe({}, e15), { Value: YYe.isExpression(e15.Value) ? t10(e15.Value, "Action.ApplyParameters.Parameters[".concat(n10, "].Value")) : e15.Value });
  }) } };
}
function oKe(e14) {
  var t10 = YYe.tryConvertToNumber(e14);
  return "number" == typeof t10 ? t10 - 90 : e14;
}
function aKe(e14, t10) {
  return "Scatter" === t10 || e14;
}
var iKe = function(e14) {
  return "number" == typeof e14 && isNaN(e14) ? null : e14;
};
var sKe = { exports: {} };
!function(e14, t10, n10) {
  function r10(e15) {
    var t11 = this, n11 = /* @__PURE__ */ function() {
      var e16 = 4022871197;
      var t12 = function(t13) {
        t13 = t13.toString();
        for (var n12 = 0; n12 < t13.length; n12++) {
          var r11 = 0.02519603282416938 * (e16 += t13.charCodeAt(n12));
          r11 -= e16 = r11 >>> 0, e16 = (r11 *= e16) >>> 0, e16 += 4294967296 * (r11 -= e16);
        }
        return 23283064365386963e-26 * (e16 >>> 0);
      };
      return t12;
    }();
    t11.next = function() {
      var e16 = 2091639 * t11.s0 + 23283064365386963e-26 * t11.c;
      return t11.s0 = t11.s1, t11.s1 = t11.s2, t11.s2 = e16 - (t11.c = 0 | e16);
    }, t11.c = 1, t11.s0 = n11(" "), t11.s1 = n11(" "), t11.s2 = n11(" "), t11.s0 -= n11(e15), t11.s0 < 0 && (t11.s0 += 1), t11.s1 -= n11(e15), t11.s1 < 0 && (t11.s1 += 1), t11.s2 -= n11(e15), t11.s2 < 0 && (t11.s2 += 1), n11 = null;
  }
  function o10(e15, t11) {
    return t11.c = e15.c, t11.s0 = e15.s0, t11.s1 = e15.s1, t11.s2 = e15.s2, t11;
  }
  function a10(e15, t11) {
    var n11 = new r10(e15), a11 = t11 && t11.state, i10 = n11.next;
    return i10.int32 = function() {
      return 4294967296 * n11.next() | 0;
    }, i10.double = function() {
      return i10() + 11102230246251565e-32 * (2097152 * i10() | 0);
    }, i10.quick = i10, a11 && ("object" == typeof a11 && o10(a11, n11), i10.state = function() {
      return o10(n11, {});
    }), i10;
  }
  t10 && t10.exports ? t10.exports = a10 : n10 && n10.amd ? n10(function() {
    return a10;
  }) : this.alea = a10;
}(0, sKe, false);
var lKe = sKe.exports;
var cKe = { exports: {} };
!function(e14, t10, n10) {
  function r10(e15) {
    var t11 = this, n11 = "";
    t11.x = 0, t11.y = 0, t11.z = 0, t11.w = 0, t11.next = function() {
      var e16 = t11.x ^ t11.x << 11;
      return t11.x = t11.y, t11.y = t11.z, t11.z = t11.w, t11.w ^= t11.w >>> 19 ^ e16 ^ e16 >>> 8;
    }, e15 === (0 | e15) ? t11.x = e15 : n11 += e15;
    for (var r11 = 0; r11 < n11.length + 64; r11++) t11.x ^= 0 | n11.charCodeAt(r11), t11.next();
  }
  function o10(e15, t11) {
    return t11.x = e15.x, t11.y = e15.y, t11.z = e15.z, t11.w = e15.w, t11;
  }
  function a10(e15, t11) {
    var n11 = new r10(e15), a11 = t11 && t11.state, i10 = function() {
      return (n11.next() >>> 0) / 4294967296;
    };
    return i10.double = function() {
      do {
        var e16 = ((n11.next() >>> 11) + (n11.next() >>> 0) / 4294967296) / (1 << 21);
      } while (0 === e16);
      return e16;
    }, i10.int32 = n11.next, i10.quick = i10, a11 && ("object" == typeof a11 && o10(a11, n11), i10.state = function() {
      return o10(n11, {});
    }), i10;
  }
  t10 && t10.exports ? t10.exports = a10 : n10 && n10.amd ? n10(function() {
    return a10;
  }) : this.xor128 = a10;
}(0, cKe, false);
var uKe = cKe.exports;
var dKe = { exports: {} };
!function(e14, t10, n10) {
  function r10(e15) {
    var t11 = this, n11 = "";
    t11.next = function() {
      var e16 = t11.x ^ t11.x >>> 2;
      return t11.x = t11.y, t11.y = t11.z, t11.z = t11.w, t11.w = t11.v, (t11.d = t11.d + 362437 | 0) + (t11.v = t11.v ^ t11.v << 4 ^ e16 ^ e16 << 1) | 0;
    }, t11.x = 0, t11.y = 0, t11.z = 0, t11.w = 0, t11.v = 0, e15 === (0 | e15) ? t11.x = e15 : n11 += e15;
    for (var r11 = 0; r11 < n11.length + 64; r11++) t11.x ^= 0 | n11.charCodeAt(r11), r11 == n11.length && (t11.d = t11.x << 10 ^ t11.x >>> 4), t11.next();
  }
  function o10(e15, t11) {
    return t11.x = e15.x, t11.y = e15.y, t11.z = e15.z, t11.w = e15.w, t11.v = e15.v, t11.d = e15.d, t11;
  }
  function a10(e15, t11) {
    var n11 = new r10(e15), a11 = t11 && t11.state, i10 = function() {
      return (n11.next() >>> 0) / 4294967296;
    };
    return i10.double = function() {
      do {
        var e16 = ((n11.next() >>> 11) + (n11.next() >>> 0) / 4294967296) / (1 << 21);
      } while (0 === e16);
      return e16;
    }, i10.int32 = n11.next, i10.quick = i10, a11 && ("object" == typeof a11 && o10(a11, n11), i10.state = function() {
      return o10(n11, {});
    }), i10;
  }
  t10 && t10.exports ? t10.exports = a10 : n10 && n10.amd ? n10(function() {
    return a10;
  }) : this.xorwow = a10;
}(0, dKe, false);
var pKe = dKe.exports;
var mKe = { exports: {} };
!function(e14, t10, n10) {
  function r10(e15) {
    var t11 = this;
    t11.next = function() {
      var e16, n11, r11 = t11.x, o11 = t11.i;
      return e16 = r11[o11], n11 = (e16 ^= e16 >>> 7) ^ e16 << 24, n11 ^= (e16 = r11[o11 + 1 & 7]) ^ e16 >>> 10, n11 ^= (e16 = r11[o11 + 3 & 7]) ^ e16 >>> 3, n11 ^= (e16 = r11[o11 + 4 & 7]) ^ e16 << 7, e16 = r11[o11 + 7 & 7], n11 ^= (e16 ^= e16 << 13) ^ e16 << 9, r11[o11] = n11, t11.i = o11 + 1 & 7, n11;
    }, function(e16, t12) {
      var n11, r11 = [];
      if (t12 === (0 | t12)) r11[0] = t12;
      else for (t12 = "" + t12, n11 = 0; n11 < t12.length; ++n11) r11[7 & n11] = r11[7 & n11] << 15 ^ t12.charCodeAt(n11) + r11[n11 + 1 & 7] << 13;
      for (; r11.length < 8; ) r11.push(0);
      for (n11 = 0; n11 < 8 && 0 === r11[n11]; ++n11) ;
      for (8 == n11 ? r11[7] = -1 : r11[n11], e16.x = r11, e16.i = 0, n11 = 256; n11 > 0; --n11) e16.next();
    }(t11, e15);
  }
  function o10(e15, t11) {
    return t11.x = e15.x.slice(), t11.i = e15.i, t11;
  }
  function a10(e15, t11) {
    null == e15 && (e15 = +/* @__PURE__ */ new Date());
    var n11 = new r10(e15), a11 = t11 && t11.state, i10 = function() {
      return (n11.next() >>> 0) / 4294967296;
    };
    return i10.double = function() {
      do {
        var e16 = ((n11.next() >>> 11) + (n11.next() >>> 0) / 4294967296) / (1 << 21);
      } while (0 === e16);
      return e16;
    }, i10.int32 = n11.next, i10.quick = i10, a11 && (a11.x && o10(a11, n11), i10.state = function() {
      return o10(n11, {});
    }), i10;
  }
  t10 && t10.exports ? t10.exports = a10 : n10 && n10.amd ? n10(function() {
    return a10;
  }) : this.xorshift7 = a10;
}(0, mKe, false);
var hKe = mKe.exports;
var fKe = { exports: {} };
!function(e14, t10, n10) {
  function r10(e15) {
    var t11 = this;
    t11.next = function() {
      var e16, n11, r11 = t11.w, o11 = t11.X, a11 = t11.i;
      return t11.w = r11 = r11 + 1640531527 | 0, n11 = o11[a11 + 34 & 127], e16 = o11[a11 = a11 + 1 & 127], n11 ^= n11 << 13, e16 ^= e16 << 17, n11 ^= n11 >>> 15, e16 ^= e16 >>> 12, n11 = o11[a11] = n11 ^ e16, t11.i = a11, n11 + (r11 ^ r11 >>> 16) | 0;
    }, function(e16, t12) {
      var n11, r11, o11, a11, i10, s10 = [], l10 = 128;
      for (t12 === (0 | t12) ? (r11 = t12, t12 = null) : (t12 += "\0", r11 = 0, l10 = Math.max(l10, t12.length)), o11 = 0, a11 = -32; a11 < l10; ++a11) t12 && (r11 ^= t12.charCodeAt((a11 + 32) % t12.length)), 0 === a11 && (i10 = r11), r11 ^= r11 << 10, r11 ^= r11 >>> 15, r11 ^= r11 << 4, r11 ^= r11 >>> 13, a11 >= 0 && (i10 = i10 + 1640531527 | 0, o11 = 0 == (n11 = s10[127 & a11] ^= r11 + i10) ? o11 + 1 : 0);
      for (o11 >= 128 && (s10[127 & (t12 && t12.length || 0)] = -1), o11 = 127, a11 = 512; a11 > 0; --a11) r11 = s10[o11 + 34 & 127], n11 = s10[o11 = o11 + 1 & 127], r11 ^= r11 << 13, n11 ^= n11 << 17, r11 ^= r11 >>> 15, n11 ^= n11 >>> 12, s10[o11] = r11 ^ n11;
      e16.w = i10, e16.X = s10, e16.i = o11;
    }(t11, e15);
  }
  function o10(e15, t11) {
    return t11.i = e15.i, t11.w = e15.w, t11.X = e15.X.slice(), t11;
  }
  function a10(e15, t11) {
    null == e15 && (e15 = +/* @__PURE__ */ new Date());
    var n11 = new r10(e15), a11 = t11 && t11.state, i10 = function() {
      return (n11.next() >>> 0) / 4294967296;
    };
    return i10.double = function() {
      do {
        var e16 = ((n11.next() >>> 11) + (n11.next() >>> 0) / 4294967296) / (1 << 21);
      } while (0 === e16);
      return e16;
    }, i10.int32 = n11.next, i10.quick = i10, a11 && (a11.X && o10(a11, n11), i10.state = function() {
      return o10(n11, {});
    }), i10;
  }
  t10 && t10.exports ? t10.exports = a10 : n10 && n10.amd ? n10(function() {
    return a10;
  }) : this.xor4096 = a10;
}(0, fKe, false);
var gKe = fKe.exports;
var yKe = { exports: {} };
!function(e14, t10, n10) {
  function r10(e15) {
    var t11 = this, n11 = "";
    t11.next = function() {
      var e16 = t11.b, n12 = t11.c, r12 = t11.d, o11 = t11.a;
      return e16 = e16 << 25 ^ e16 >>> 7 ^ n12, n12 = n12 - r12 | 0, r12 = r12 << 24 ^ r12 >>> 8 ^ o11, o11 = o11 - e16 | 0, t11.b = e16 = e16 << 20 ^ e16 >>> 12 ^ n12, t11.c = n12 = n12 - r12 | 0, t11.d = r12 << 16 ^ n12 >>> 16 ^ o11, t11.a = o11 - e16 | 0;
    }, t11.a = 0, t11.b = 0, t11.c = -1640531527, t11.d = 1367130551, e15 === Math.floor(e15) ? (t11.a = e15 / 4294967296 | 0, t11.b = 0 | e15) : n11 += e15;
    for (var r11 = 0; r11 < n11.length + 20; r11++) t11.b ^= 0 | n11.charCodeAt(r11), t11.next();
  }
  function o10(e15, t11) {
    return t11.a = e15.a, t11.b = e15.b, t11.c = e15.c, t11.d = e15.d, t11;
  }
  function a10(e15, t11) {
    var n11 = new r10(e15), a11 = t11 && t11.state, i10 = function() {
      return (n11.next() >>> 0) / 4294967296;
    };
    return i10.double = function() {
      do {
        var e16 = ((n11.next() >>> 11) + (n11.next() >>> 0) / 4294967296) / (1 << 21);
      } while (0 === e16);
      return e16;
    }, i10.int32 = n11.next, i10.quick = i10, a11 && ("object" == typeof a11 && o10(a11, n11), i10.state = function() {
      return o10(n11, {});
    }), i10;
  }
  t10 && t10.exports ? t10.exports = a10 : n10 && n10.amd ? n10(function() {
    return a10;
  }) : this.tychei = a10;
}(0, yKe, false);
var vKe = yKe.exports;
var bKe = { exports: {} };
!function(e14) {
  !function(t10, n10) {
    var r10, o10 = (0, eval)("this"), a10 = 256, i10 = "random", s10 = n10.pow(a10, 6), l10 = n10.pow(2, 52), c10 = 2 * l10, u10 = a10 - 1;
    function d10(e15, u11, d11) {
      var y10 = [];
      var v10 = f10(h10((u11 = 1 == u11 ? { entropy: true } : u11 || {}).entropy ? [e15, g10(t10)] : null == e15 ? function() {
        try {
          var e16;
          return r10 && (e16 = r10.randomBytes) ? e16 = e16(a10) : (e16 = new Uint8Array(a10), (o10.crypto || o10.msCrypto).getRandomValues(e16)), g10(e16);
        } catch (e17) {
          var n11 = o10.navigator, i11 = n11 && n11.plugins;
          return [+/* @__PURE__ */ new Date(), o10, i11, o10.screen, g10(t10)];
        }
      }() : e15, 3), y10);
      var b10 = new p10(y10);
      var S10 = function() {
        var e16 = b10.g(6), t11 = s10, n11 = 0;
        for (; e16 < l10; ) e16 = (e16 + n11) * a10, t11 *= a10, n11 = b10.g(1);
        for (; e16 >= c10; ) e16 /= 2, t11 /= 2, n11 >>>= 1;
        return (e16 + n11) / t11;
      };
      return S10.int32 = function() {
        return 0 | b10.g(4);
      }, S10.quick = function() {
        return b10.g(4) / 4294967296;
      }, S10.double = S10, f10(g10(b10.S), t10), (u11.pass || d11 || function(e16, t11, r11, o11) {
        return o11 && (o11.S && m10(o11, b10), e16.state = function() {
          return m10(b10, {});
        }), r11 ? (n10[i10] = e16, t11) : e16;
      })(S10, v10, "global" in u11 ? u11.global : this == n10, u11.state);
    }
    function p10(e15) {
      var t11, n11 = e15.length, r11 = this, o11 = 0, i11 = r11.i = r11.j = 0, s11 = r11.S = [];
      for (n11 || (e15 = [n11++]); o11 < a10; ) s11[o11] = o11++;
      for (o11 = 0; o11 < a10; o11++) s11[o11] = s11[i11 = u10 & i11 + e15[o11 % n11] + (t11 = s11[o11])], s11[i11] = t11;
      (r11.g = function(e16) {
        var t12, n12 = 0, o12 = r11.i, i12 = r11.j, s12 = r11.S;
        for (; e16--; ) t12 = s12[o12 = u10 & o12 + 1], n12 = n12 * a10 + s12[u10 & (s12[o12] = s12[i12 = u10 & i12 + t12]) + (s12[i12] = t12)];
        return r11.i = o12, r11.j = i12, n12;
      })(a10);
    }
    function m10(e15, t11) {
      return t11.i = e15.i, t11.j = e15.j, t11.S = e15.S.slice(), t11;
    }
    function h10(e15, t11) {
      var n11, r11 = [], o11 = typeof e15;
      if (t11 && "object" == o11) for (n11 in e15) try {
        r11.push(h10(e15[n11], t11 - 1));
      } catch (e16) {
      }
      return r11.length ? r11 : "string" == o11 ? e15 : e15 + "\0";
    }
    function f10(e15, t11) {
      var n11, r11 = e15 + "", o11 = 0;
      for (; o11 < r11.length; ) t11[u10 & o11] = u10 & (n11 ^= 19 * t11[u10 & o11]) + r11.charCodeAt(o11++);
      return g10(t11);
    }
    function g10(e15) {
      return String.fromCharCode.apply(0, e15);
    }
    if (n10["seed" + i10] = d10, f10(n10.random(), t10), e14.exports) {
      e14.exports = d10;
      try {
        r10 = lje;
      } catch (e15) {
      }
    }
  }([], Math);
}(bKe);
var SKe = lKe;
var CKe = uKe;
var xKe = pKe;
var wKe = hKe;
var TKe = gKe;
var EKe = vKe;
var FKe = bKe.exports;
FKe.alea = SKe, FKe.xor128 = CKe, FKe.xorwow = xKe, FKe.xorshift7 = wKe, FKe.xor4096 = TKe, FKe.tychei = EKe;
var MKe = W(FKe);
const kKe = 100;
const PKe = ["Scatter", "Candlestick", "HighLowOpenClose"];
const NKe = ["d", "D", "f", "g", "G", "t", "T", "m", "y"];
function DKe(e14, t10, n10) {
  const r10 = (e15) => {
    var _a2, _b2;
    return (_b2 = (_a2 = t10.find(({ AxisType: t11 }) => t11 === e15)) == null ? void 0 : _a2.Format) != null ? _b2 : "";
  };
  const o10 = NKe.includes(r10("X"));
  const a10 = NKe.includes(r10("Y"));
  const i10 = MKe("domdom");
  const s10 = () => parseFloat(i10().toPrecision(3));
  function l10(e15) {
    if (!jme(e15)) return e15;
    const t11 = (t12) => "Simple" === t12.Field.FieldType ? t12.Field.Value.some((t13) => e15 === t13) : t12.Field.Subfields.some((t13) => t13.Value === e15);
    return (n11, r11, o11) => {
      const a11 = o11.Encodings;
      return a11.Values.some(t11) || a11.Details.some((t12) => t12.Field.Value.includes(e15)) || (a11.Texts || []).some((t12) => t12.Field.Value.includes(e15)) || ["Size", "Shape", "Category", "Color"].some((t12) => a11[t12].Field.Value.some((t13) => t13 === e15)) ? s10() : null;
    };
  }
  const c10 = { commonField: "" };
  const u10 = (e15, t11) => {
    void 0 === c10[e15] && (c10[e15] = t11);
  };
  const d10 = { x: 0, high: 1, open: 2, close: 3, low: 4 };
  const p10 = (/* @__PURE__ */ new Date()).getFullYear();
  const m10 = (e15) => `1/${e15 + 1}/${p10}`;
  function h10(e15, t11) {
    if (e15) switch (t11.PlotChartType) {
      case "Candlestick":
      case "HighLowClose":
      case "HighLowOpenClose": {
        const t12 = new Array(16).fill(0).map((e16) => {
          let t13 = [1 + s10(), (s10() > 0.5 ? 1 : -1) * s10(), (s10() > 0.5 ? 1 : -1) * s10(), -1 - s10()];
          const { min: n12, max: r11 } = t13.reduce((e17, t14) => ({ min: Math.min(e17.min, t14), max: Math.max(e17.max, t14) }), { max: 0, min: Number.MAX_VALUE });
          const [o11, a11] = [0.5 * s10(), 0.5 + 0.5 * s10()];
          return t13 = t13.map((e17) => (e17 - n12) / (r11 - n12) * (a11 - o11) + o11), t13.unshift(m10(e16)), t13;
        });
        const n11 = e15.Field;
        "Simple" === n11.FieldType ? n11.Value.forEach((e16, n12) => {
          u10(e16, l10((e17) => t12[e17][n12]));
        }) : n11.Subfields.forEach((e16) => u10(e16.Caption || e16.Value, l10((n12) => t12[n12][d10[e16.Key]])));
        break;
      }
      default:
        !function(e16, t12) {
          if (!e16) return;
          const n11 = e16.Field;
          0 === t12.Encodings.Category.Field.Value.length && "Simple" === n11.FieldType && (o10 && n11.Value.length >= 1 && u10(n11.Value[0], m10), a10 && n11.Value.length >= 2 && u10(n11.Value[1], m10));
          "Simple" === n11.FieldType ? n11.Value.forEach((e17) => {
            u10(e17, l10(e17));
          }) : n11.Subfields.forEach((e17) => {
            u10(e17.Caption || e17.Value, l10(e17.Value));
          });
        }(e15, t11);
    }
  }
  const f10 = (e15) => {
    const t11 = e15.Field.Value.length - 1;
    e15.Field.Value.forEach((e16, n11) => {
      u10(e16, (e17) => o10 ? m10(e17) : String.fromCharCode(65 + Math.floor(e17 / __pow(2, t11 - n11))).repeat(n11 + 1));
    });
  };
  const g10 = (e15) => {
    e15.Field.Value.forEach((e16) => {
      u10(e16, (e17, t11) => n10("captions:dvchartColor", "Color [{{index}}]", { index: t11 }));
    });
  };
  const y10 = (e15) => (e15.Field.Value || []).forEach((e16) => {
    u10(e16, l10(e16));
  });
  const v10 = (e15) => {
    e15.Field.Value.forEach((e16, t11) => {
      u10(e16, l10(e16));
    });
  };
  if (e14) for (let t11 = 0; t11 < e14.length; t11++) (e14[t11].Encodings.Values || []).forEach((n11) => h10(n11, e14[t11])), (e14[t11].Encodings.Details || []).forEach((e15) => {
    e15.Field.Value.forEach((e16) => {
      u10(e16, (e17, t12) => n10("captions:dvchartDetails", "Details [{{index}}]", { index: t12 }));
    });
  }), f10(e14[t11].Encodings.Category), e14[t11].Encodings.Shape.Field.Value.forEach((e15) => {
    u10(e15, (e16, t12) => n10("captions:dvchartShape", "Shape [{{index}}]", { index: t12 }));
  }), y10(e14[t11].Encodings.Size), g10(e14[t11].Encodings.Color), (e14[t11].Encodings.Texts || []).forEach((e15) => v10(e15));
  return { Data: c10 };
}
const LKe = (e14) => Math.sign(e14) * Math.min(Math.abs(e14), Number.MAX_SAFE_INTEGER);
const HKe = (e14) => {
  const t10 = e14.match(/(?:\\,|[^,])+/g);
  return Array.isArray(t10) ? t10.map((e15) => e15.replace(/\\([,>])/g, "$1")) : [e14];
};
const IKe = (e14 = "", t10) => (e14 || "").startsWith("unpivotData/") ? t10.find(({ outputAs: t11 }) => t11 === e14) : null;
const _Ke = (e14, t10) => {
  const n10 = DKe(e14.Plots, e14.PlotArea.Axes, t10);
  const r10 = QYe(e14, null, (e15) => (t11) => null != n10.Data[e15] ? n10.Data[e15](t11.cid, t11.did, t11.plot) : e15, false);
  let o10 = ((e15, t11) => {
    var _a2, _b2;
    const n11 = [];
    const r11 = {};
    const o11 = {};
    e15.plots.forEach((t12) => {
      var _a3;
      const a11 = [];
      const i11 = "Scatter" === t12.type;
      const s11 = ((_a3 = IKe(t12.data, e15.transform)) == null ? void 0 : _a3.category.from) || [];
      t12.encodings.values.forEach((e16) => {
        const n12 = "string" == typeof e16.field ? HKe(e16.field) : Object.values(e16.field);
        if (i11 && n12.length > 1) {
          const e17 = zV.head(n12);
          const r12 = zV.tail(n12);
          e17 && (o11[e17] ? o11[e17].push(t12.name) : o11[e17] = [t12.name]), a11.push(...r12);
        } else a11.push(...n12);
      }), s11.length && a11.push(...s11), a11.length && a11.forEach((e16) => {
        r11[e16] ? r11[e16].includes(t12.name) || r11[e16].push(t12.name) : r11[e16] = [t12.name];
      });
      const l11 = t12.encodings.size.field;
      l11 && n11.push(...HKe(l11));
    });
    const a10 = {};
    const i10 = {};
    (_a2 = e15.config.plotAreas[0]) == null ? void 0 : _a2.axes.forEach((t12) => {
      const n12 = t12.plots.some((t13) => e15.plots.some((e16) => e16.name === t13 && "Scatter" === e16.type));
      if ("Y" !== t12.type && !n12) return;
      let [r12, o12] = [Number.MAX_VALUE, -Number.MAX_VALUE];
      null !== t12.min && (r12 = LKe(t12.min)), null !== t12.max && (o12 = LKe(t12.max));
      const s11 = "X" === t12.type ? a10 : i10;
      t12.plots.forEach((e16) => {
        const t13 = s11[e16];
        t13 ? (s11[e16].min = t13.min < r12 ? t13.min : r12, s11[e16].max = t13.max > o12 ? t13.max : o12) : s11[e16] = { min: r12, max: o12 };
      });
    });
    const s10 = (e16, t12) => zV.mapValues(e16, (e17) => {
      let [n12, r12] = [Number.MAX_VALUE, -Number.MAX_VALUE];
      return e17.forEach((e18) => {
        const o12 = t12[e18];
        o12 && (o12.min < n12 && (n12 = o12.min), o12.max > r12 && (r12 = o12.max));
      }), n12 === Number.MAX_VALUE && r12 !== -Number.MAX_VALUE && (n12 = r12 > 0 ? 0 : LKe(r12 - kKe)), r12 === -Number.MAX_VALUE && n12 !== Number.MAX_VALUE && (r12 = n12 < 0 ? 0 : LKe(n12 + kKe)), n12 === Number.MAX_VALUE && r12 === -Number.MAX_VALUE && ([n12, r12] = [0, kKe]), n12 === r12 && (n12 = r12 - kKe), { min: n12, max: r12 };
    });
    const l10 = s10(r11, i10);
    const c10 = s10(o11, a10);
    const u10 = Object.keys(l10).includes("Value0");
    const d10 = e15.plots.reduce((e16, t12) => __spreadProps(__spreadValues({}, e16), { [t12.name]: t12 }), {});
    const p10 = e15.data.values.map((t12) => zV.transform(t12, (t13, a11, i11) => {
      const s11 = l10[i11] || c10[i11];
      const u11 = (r11[i11] || o11[i11] || []).map((e16) => d10[e16]);
      const p11 = u11.some((e16) => e16.encodings.details.length && "Stack" === e16.encodings.details[0].group);
      const m11 = u11.filter((e16) => !("commonField" !== e16.encodings.category.field && e16.encodings.category.field || PKe.includes(e16.type)));
      let h11 = 0;
      let f11 = 0;
      u11.forEach((t14) => {
        const { details: n12 } = t14.encodings;
        const r12 = !!IKe(t14.data, e15.transform);
        const o12 = r12 ? 1 : n12.length;
        o12 && (f11 = Math.max(f11, o12), (r12 || "Stack" === n12[0].group) && (h11 = 0 === h11 ? o12 : Math.min(h11, o12)));
      });
      let g10 = a11;
      return "number" == typeof a11 && (s11 ? g10 = (s11.min + a11 * (s11.max - s11.min)) / (u11.length * __pow(3, p11 ? f11 : h11)) : n11.includes(i11) && (g10 *= 10), m11.length && (g10 /= 4)), Object.assign(t13, { [i11]: g10 });
    }, {}));
    let m10 = p10;
    let h10 = e15 == null ? void 0 : e15.plots;
    const f10 = (_b2 = t11 == null ? void 0 : t11.filter((e16) => "Gauge" === e16.PlotChartType)) == null ? void 0 : _b2.map((e16) => e16.PlotName);
    if (f10.length > 0) {
      const t12 = e15 == null ? void 0 : e15.plots.filter((e16) => f10.includes(e16.name)).map((e16) => e16.encodings.values.map((e17) => e17.field).join().split(",")).reduce((e16, t13) => t13.concat(e16));
      m10 = p10.map((e16) => {
        const n13 = Object.entries(e16).filter((e17) => t12.includes(e17[0]) && "number" == typeof e17[1]);
        let r12 = {};
        const o12 = n13.slice().sort((e17, t13) => t13[1] - e17[1]).map((e17) => e17[1]);
        return o12.forEach((e17, t13) => {
          0 === t13 && (r12 = __spreadProps(__spreadValues({}, r12), { [`${n13[t13][0]}`]: 25 })), t13 > 0 && (r12 = __spreadProps(__spreadValues({}, r12), { [`${n13[t13][0]}`]: e17 }));
        }), __spreadProps(__spreadValues(__spreadValues({}, e16), r12), { Gauge0: 25, Gauge1: 17.25, Gauge2: 8 });
      });
      const n12 = (e16) => ({ field: u10 ? e16.field.replace(/^Value/, "Gauge") : e16.field, aggregate: "Sum" });
      h10 = e15 == null ? void 0 : e15.plots.map((e16) => f10.includes(e16.name) ? __spreadProps(__spreadValues({}, e16), { encodings: __spreadProps(__spreadValues({}, e16.encodings), { values: e16.encodings.values.map((e17) => n12(e17)) }) }) : e16);
    }
    return AV(e15, { plots: { $set: h10 }, data: { values: { $set: m10 } } });
  })(r10(null, e14.Plots.reduce((e15, t11) => {
    const n11 = PKe.includes(t11.PlotType) ? 16 : 4;
    return e15.concat(Array(n11).fill(0).reduce((e16, n12, r11) => e16.concat(Array(__pow(3, t11.Encodings.Details.length)).fill(0).map((e17, n13) => ({ cid: r11, did: n13, plot: t11 }))), []));
  }, [])), e14.Plots);
  return o10 = ((e15) => {
    const { labelTemplate: t11 } = e15.config.plotAreas[0].axes[0];
    return __spreadProps(__spreadValues({}, e15), { data: __spreadProps(__spreadValues({}, e15.data), { values: e15.data.values.map((e16) => __spreadProps(__spreadValues({}, e16), { commonField: "" })), dateFormats: !t11 }) });
  })(o10), o10 = ((e15) => __spreadProps(__spreadValues({}, e15), { plots: e15.plots.map((e16) => AV(e16, { config: { style: { $unset: ["symbolSize"] } } })) }))(o10), o10;
};
const VKe = (e14) => new Array(e14).fill("");
const RKe = (e14, t10 = 1) => {
  if (e14.length > 0) return e14;
  return [gye({ Field: { FieldType: "Simple", Value: VKe(t10).map((e15, t11) => ({ Value: `=Fields!Value${t11}.Value`, Caption: "" })) } })];
};
const AKe = (e14) => {
  if (e14.length > 0) return e14;
  const t10 = [];
  for (let e15 = 0; e15 < 3; e15++) {
    const n10 = gye({ Field: { FieldType: "Simple", Value: [{ Value: `=Fields!Value${e15}.Value`, Caption: "" }] } });
    t10.push(n10);
  }
  return t10;
};
const OKe = (e14, t10) => {
  if (e14.length > 0) return e14;
  return [gye({ Field: { FieldType: "Complex", Subfields: t10.map((e15, t11) => ({ Key: e15, Value: `=Fields!Value${t11}.Value`, Caption: "" })) } })];
};
const BKe = (e14) => {
  if (e14.Field.Value.length > 0) return e14;
  return AV(e14, { Field: { Value: { $set: [bye("=Fields!Category.Value")] } } });
};
const zKe = (e14) => {
  if (e14.Field.Value.length > 0) return e14;
  return AV(e14, { Field: { Value: { $set: [bye("=Fields!Color.Value")] } } });
};
const $Ke = (e14) => {
  if (e14.Field.Value.length > 0) return e14;
  return AV(e14, { Field: { Value: { $set: [bye("=Fields!Shape.Value")] } } });
};
const WKe = (e14) => {
  if (e14.Field.Value.length > 0) return e14;
  return AV(e14, { Field: { Value: { $set: [bye("=Fields!Size.Value")] } } });
};
const jKe = (e14, t10, { Values: n10, Category: r10, Details: o10, Color: a10, Shape: i10, Size: s10, Texts: l10 }) => {
  const c10 = (u10 = "Stacked" === t10, (e15, t11) => {
    if (e15.length > 0) return e15;
    const n11 = { Group: u10 ? "Stack" : "Cluster" };
    t11 && Object.assign(n11, { Sort: t11 });
    const r11 = yye(n11);
    return [AV(r11, { Field: { Value: { $set: ["=Fields!Details.Value"] } } })];
  });
  var u10;
  switch (e14) {
    case "RadarArea":
    case "PolarColumn":
    case "PolarBar":
    case "Column":
    case "Bar":
    case "Area":
      return { Values: RKe(n10), Category: BKe(r10), Details: c10(o10), Color: zKe(a10), Shape: i10, Size: s10, Texts: l10 };
    case "RadarLine":
    case "Line":
      return { Values: RKe(n10), Category: BKe(r10), Details: c10(o10), Color: zKe(a10), Shape: i10, Size: s10, Texts: l10 };
    case "Pie":
      return { Values: RKe(n10), Category: r10, Details: c10(o10), Color: zKe(a10), Shape: i10, Size: s10, Texts: l10 };
    case "Pyramid":
      return { Values: RKe(n10), Category: r10, Details: c10(o10, "Ascending"), Color: zKe(a10), Shape: i10, Size: s10, Texts: l10 };
    case "Funnel":
      return { Values: RKe(n10), Category: r10, Details: c10(o10, "Descending"), Color: zKe(a10), Shape: i10, Size: s10, Texts: l10 };
    case "RadarBubble":
    case "Bubble":
      return { Values: RKe(n10, 2), Category: r10, Details: o10, Color: a10, Shape: i10, Size: WKe(s10), Texts: l10 };
    case "RadarScatter":
    case "Scatter":
      return { Values: RKe(n10, 2), Category: r10, Details: o10, Color: a10, Shape: $Ke(i10), Size: s10, Texts: l10 };
    case "Gantt":
      return { Values: OKe(n10, ["lower", "upper"]), Category: BKe(r10), Details: c10(o10), Color: zKe(a10), Shape: i10, Size: s10, Texts: l10 };
    case "Candlestick":
      return { Values: OKe(n10, ["high", "low", "open", "close"]), Category: BKe(r10), Details: o10, Color: a10, Shape: i10, Size: s10, Texts: l10 };
    case "HighLowClose":
      return { Values: OKe(n10, ["high", "low", "close"]), Category: BKe(r10), Details: o10, Color: a10, Shape: i10, Size: s10, Texts: l10 };
    case "HighLowOpenClose":
      return { Values: OKe(n10, ["high", "low", "open", "close"]), Category: BKe(r10), Details: o10, Color: a10, Shape: i10, Size: s10, Texts: l10 };
    case "RangeArea":
    case "RangeBar":
    case "RangeColumn":
      return { Values: OKe(n10, ["lower", "upper"]), Category: BKe(r10), Details: c10(o10), Color: zKe(a10), Shape: i10, Size: s10, Texts: l10 };
    case "Gauge":
      return { Values: AKe(n10), Category: r10, Details: o10, Color: a10, Shape: i10, Size: s10, Texts: l10 };
    default:
      return { Values: [], Category: r10, Details: o10, Color: a10, Shape: i10, Size: s10, Texts: l10 };
  }
};
const ZKe = (e14) => {
  const t10 = e14 && e14.Field && e14.Field.Value;
  const n10 = t10.map((e15) => e15.Value);
  return __spreadProps(__spreadValues({}, e14), { Field: __spreadProps(__spreadValues({}, e14.Field), { Value: n10, Captions: t10.map(() => "") }) });
};
const GKe = (e14, t10) => {
  const n10 = !e14.Field.Value.length && ((e15) => {
    switch (e15) {
      case "Scatter":
      case "RadarScatter":
      case "Bubble":
      case "RadarBubble":
      case "Line":
        return false;
      default:
        return true;
    }
  })(t10.PlotChartType);
  const r10 = ZKe(e14);
  return n10 ? AV(r10, { Field: { Value: { $set: ["commonField"] } } }) : r10;
};
const UKe = (e14) => e14.map((e15) => __spreadProps(__spreadValues({}, e15), { Field: { FieldType: "Simple", Value: e15.Field.Value, Captions: e15.Field.Value.map(() => "") } }));
const qKe = (e14) => e14.map((e15) => {
  const t10 = e15.Field;
  return __spreadProps(__spreadValues({}, e15), { Field: "Simple" === t10.FieldType ? { FieldType: "Simple", Value: t10.Value.map(({ Value: e16 }) => e16), Captions: t10.Value.map(({ Caption: e16 }) => e16) } : t10 });
});
const YKe = (e14) => e14.map((e15) => __spreadProps(__spreadValues({}, e15), { Field: { FieldType: "Simple", Value: [e15.Field.Value], Captions: [e15.Field.TemplateKey] } }));
const KKe = (e14) => {
  const t10 = {};
  return (e14.Plots || []).forEach((e15, n10) => {
    const r10 = e15.Encodings;
    t10[n10] = { Encodings: { Color: { $set: ZKe(r10.Color) }, Shape: { $set: ZKe(r10.Shape) }, Size: { $set: ZKe(r10.Size) }, Category: { $set: GKe(r10.Category, e15) }, Details: { $set: UKe(r10.Details) }, Values: { $set: qKe(r10.Values) }, Texts: { $set: YKe(r10.Texts || []) } } };
  }), AV(e14, { Plots: t10 });
};
const XKe = {};
const JKe = () => (XKe.defaultChart || (XKe.defaultChart = Jye("", 0, {}, tz == null ? void 0 : tz.getTemplate("dvchart")), XKe.defaultHeader = XKe.defaultChart.Header, XKe.defaultFooter = XKe.defaultChart.Footer, XKe.defaultLegend = nve(), XKe.defaultPlotArea = ((e14 = {}, t10 = CYe) => __spreadValues(__spreadValues({}, __spreadProps(__spreadValues({}, t10), { Legends: [nve({}, t10.Legends[0])] })), e14))(), XKe.defaultPlot = ave("")), XKe);
function QKe(e14, t10, n10) {
  const { defaultChart: r10, defaultHeader: o10, defaultFooter: a10, defaultLegend: i10, defaultPlotArea: s10, defaultPlot: l10 } = JKe();
  function c10(e15) {
    if (!jme(e15)) return e15;
    if (vme(e15)) {
      const n11 = Sme(e15, t10);
      return e15 !== n11 ? n11 : null;
    }
    if (Hme(e15)) {
      const n11 = Ime(e15, t10);
      return e15 !== n11 ? n11 : null;
    }
    return null;
  }
  function u10(e15, t11) {
    return "string" == typeof e15 ? c10(e15) : zV.isArray(e15) ? e15.map((e16) => u10(e16)) : zV.isObject(e15) ? zV.mapValues(e15, (e16, n11) => (t11 || []).includes(n11) ? e16 : u10(e16)) : "" === e15 ? null : e15;
  }
  function d10(e15, t11, n11 = (e16) => e16) {
    return t11 ? zV.mergeWith({}, n11(e15), n11(t11), (e16) => "string" == typeof e16 || "number" == typeof e16 || "boolean" == typeof e16 || zV.isArray(e16) ? e16 : void 0) : n11(e15);
  }
  const p10 = (e15) => {
    const t11 = (e15 || "").trim();
    return '=""' === t11 || "" === t11 ? "" : jme(t11) ? n10("propertyEditors:common.textExpression") : t11;
  };
  function m10(e15, t11) {
    function n11(e16, n12) {
      const r11 = (e17, r12) => jme(e17) ? e17 : "" === e17 ? `=Plot.${t11}.${n12}.${r12}` : `=${e17}`;
      if ("Simple" === e16.Field.FieldType) {
        const t12 = "Category" === n12 && "commonField" === e16.Field.Value[0];
        const o11 = "Color" === n12 && e16.Field.Value[0] === ive;
        return __spreadProps(__spreadValues({}, e16), { Field: __spreadProps(__spreadValues({}, e16.Field), { Value: t12 || o11 ? [e16.Field.Value[0]] : e16.Field.Value.map((e17, t13) => r11(e17, t13)) }), SortingField: c10(e16.SortingField) });
      }
      return __spreadProps(__spreadValues({}, e16), { Field: __spreadProps(__spreadValues({}, e16.Field), { Subfields: e16.Field.Subfields.map((e17, t12) => ({ Key: e17.Key, Value: r11(e17.Value, t12), Caption: e17.Caption })) }) });
    }
    return { Values: e15.Values.map((e16, t12) => n11(e16, `Values.${t12}`)), Category: n11(e15.Category, "Category"), Details: e15.Details.map((e16, t12) => n11(e16, `Details.${t12}`)), Color: n11(e15.Color, "Color"), Size: n11(e15.Size, "Size"), Shape: n11(e15.Shape, "Shape"), Texts: e15.Texts.map((e16, t12) => n11(e16, `Texts.${t12}`)) };
  }
  const h10 = (e15) => __spreadProps(__spreadValues({}, e15), { End: Number.isNaN(parseInt(e15.End, 10)) ? "0" : e15.End });
  function f10(e15) {
    const t11 = u10(function(e16) {
      return AV(e16, { CustomLabels: { $apply: function(e17) {
        return e17.map((e18) => __spreadProps(__spreadValues({}, e18), { Text: jme(e18.Text) ? n10("propertyEditors:common.textExpression") : e18.Text }));
      } } });
    }(e15));
    return Array.isArray(e15.Overlays) && (t11.Overlays = e15.Overlays.map((e16) => u10(e16, ["Field"]))), t11.Pointers = t11.Pointers.map(h10), t11;
  }
  const g10 = function(e15) {
    return AV(e15, { Header: { Title: { $set: p10(e15.Header.Title) } }, Footer: { Title: { $set: p10(e15.Footer.Title) } }, PlotArea: { Axes: { $set: e15.PlotArea.Axes.map((e16) => __spreadProps(__spreadValues({}, e16), { Title: p10(e16.Title) })) }, Legends: { $set: e15.PlotArea.Legends.map((e16) => __spreadProps(__spreadValues({}, e16), { Title: p10(e16.Title) })) } } });
  }(e14);
  const y10 = (g10.Plots || []).map((e15, t11) => d10(e15, l10, (e16) => function(e17, t12) {
    return __spreadProps(__spreadValues({}, u10(e17, ["Encodings"])), { Config: f10(e17.Config), Encodings: m10(e17.Encodings, t12) });
  }(e16, t11)));
  return { Bar: g10.Bar, Header: g10.Header && d10(u10(g10.Header), o10), Footer: g10.Footer && d10(u10(g10.Footer), a10), Palette: "Custom" === g10.Palette ? g10.CustomPalette.map(c10) : g10.Palette, Legend: g10.Legend && d10(u10(g10.Legend), r10.Legend), PlotArea: g10.PlotArea && d10(g10.PlotArea, s10, function(e15) {
    return __spreadProps(__spreadValues({}, u10(e15, ["Legends", "Axes"])), { Legends: e15.Legends && e15.Legends.map((e16) => d10(u10(e16), i10)), Axes: (e15.Axes || []).map((e16) => d10(u10(e16), eve(e16.AxisType))) });
  }), Style: d10(g10.Style, r10.Style), Plots: y10, Data: void 0 };
}
function eXe(e14, t10, n10) {
  const r10 = function(e15) {
    const t11 = (e15.Plots || []).map((e16) => {
      if (abe(e16)) return e16;
      const t12 = jKe(e16.PlotChartType, e16.PlotChartSubtype, e16.Encodings);
      if ("Gauge" === e16.PlotChartType) {
        const n12 = Ive({ End: "0" });
        return AV(e16, { Encodings: { $set: t12 }, Config: { Pointers: { $set: [n12] } } });
      }
      return AV(e16, { Encodings: { $set: t12 } });
    });
    const n11 = AV(e15, { Plots: { $set: t11 } });
    return KKe(n11);
  }(e14);
  const o10 = QKe(r10, t10, n10);
  return _Ke(o10, n10);
}
const tXe = ({ chart: e14, theme: t10, opacity: n10, onSuccess: r10, onError: o10 }) => {
  const i10 = ep.useRef(null);
  const s10 = ep.useRef();
  const { t: l10 } = vp();
  return ep.useLayoutEffect(() => {
    null !== i10 && null !== i10.current && (s10.current = new a.FlexDV(i10.current));
  }, []), ep.useEffect(() => {
    const { current: n11 } = s10;
    if (n11) try {
      const o11 = eXe(e14, t10, l10);
      n11.load(o11), n11.refresh();
      const a10 = SYe(n11);
      r10 && r10(a10);
    } catch (e15) {
      o10 && o10(e15.toString());
    }
  }, [e14, t10, n10]), tp.createElement("div", { className: "ar-chart-dvchart", ref: i10, style: { opacity: n10 } });
};
tXe.displayName = "DVChartRenderer";
const nXe = (e14) => {
  var _a2;
  const { viewChartModel: t10, dispatch: n10, absolutePath: r10, advancedCustomizationVisibility: o10 } = e14;
  const { API: a10 } = ep.useContext(Sm);
  const { rdlx: { reportStyles: i10, theme: s10 } } = d9();
  const { stepCompleted: l10 } = zUe();
  const { closeDialog: c10 } = RA();
  const { t: u10 } = vp("chartWizard");
  ep.useEffect(() => {
    l10 || n10(OUe.stepComplete());
  });
  const d10 = t10.CustomPaletteInfo.PaletteId || t10.Palette;
  const p10 = VO("dvchart_palette").filter((e15) => "Custom" !== e15).map((e15) => ({ name: e15, key: e15 }));
  const m10 = Pj(i10).map((e15) => ({ name: e15.name, key: e15.id }));
  const h10 = { customCSS: "pallete-dd", dataAid: "chart-wizard-palette-dropdown", content: tp.createElement(pqe, { onPick: (e15) => {
    n10(OUe.setPalette(e15)), a10.dropdowns.open(null);
  }, selectedPalette: d10, theme: s10 }), title: u10("labelSelectPalette", "Select chart palette"), text: ((_a2 = p10.concat(m10).find((e15) => e15.key === d10)) == null ? void 0 : _a2.name) || u10("textCustom", "Custom"), textAlign: "center", block: true, menuWidth: "100%", menuMaxHeight: 400, menuAlign: "center", itemSize: "default", size: "small" };
  const f10 = { chart: t10, opacity: 1, theme: s10 || void 0 };
  const g10 = ep.useCallback((e15) => () => {
    c10(), n10(OUe.createChart(t10, r10, `${r10}.${e15}`));
  }, [r10, c10, n10, t10]);
  const { header: y10, footer: v10, axisX: b10, axisY: S10, legend: C10, globalLegend: x10, plot: w10, plotArea: T10 } = o10;
  return tp.createElement("div", { className: "preview-view-container" }, tp.createElement(AN, { block: true, size: "small", label: u10("labelSelectPalette", "Select chart palette"), position: "left" }, tp.createElement(UF, __spreadValues({}, h10))), tp.createElement("div", { className: "chart-container" }, tp.createElement(tXe, __spreadValues({}, f10))), tp.createElement(LE, { text: u10("textAdvancedCustomization", "Advanced Customization"), size: "small", level: "info" }), tp.createElement("div", { className: "bt-group" }, T10 && tp.createElement(qm, { size: "small", text: u10("customization.labels.area", "Area"), onClick: g10("PlotArea") }), y10 && tp.createElement(qm, { size: "small", text: u10("customization.labels.header", "Header"), onClick: g10("Header") }), b10 && tp.createElement(qm, { size: "small", text: u10("customization.labels.axisX", "X axis"), onClick: g10("PlotArea.Axes.0") }), S10 && tp.createElement(qm, { size: "small", text: u10("customization.labels.axisY", "Y axis"), onClick: g10("PlotArea.Axes.1") }), C10 && tp.createElement(qm, { size: "small", text: u10("customization.labels.legend", "Legend"), onClick: g10("PlotArea.Legends.0") }), x10 && tp.createElement(qm, { size: "small", text: u10("customization.labels.legend", "Legend"), onClick: g10("Legend") }), w10 && tp.createElement(qm, { size: "small", text: u10("customization.labels.plot", "Plot Settings"), onClick: g10("Plots.0") }), v10 && tp.createElement(qm, { size: "small", text: u10("customization.labels.footer", "Footer"), onClick: g10("Footer") })));
};
nXe.displayName = "PreviewView";
const rXe = 0, oXe = 1, aXe = 2;
const iXe = ({ shouldSkipSelectTypeStep: e14, shouldHidePlotTypeEditor: t10, defaultDataSetName: n10 }) => {
  const { curStep: r10, stepCompleted: o10, chartModel: a10, viewChartModel: i10, path: s10, chartPlotTemplateType: l10, advancedCustomizationVisibility: c10 } = zUe();
  const { dispatch: u10, closeDialog: d10 } = RA();
  const { t: p10 } = vp("chartWizard");
  ep.useEffect(() => {
    var _a2, _b2;
    if (u10(OUe.setDataSetName(n10)), e14 || t10) {
      const { PlotChartType: t11, Config: n11 } = a10.Plots[0];
      let o11 = (r11 = t11, (_b2 = (_a2 = lve[r11]) == null ? void 0 : _a2[0]) != null ? _b2 : "column");
      "pie" === o11 && n11.InnerRadius && (o11 = "doughnut"), u10(OUe.setPlotTemplate(o11)), e14 && u10(OUe.goToStep(oXe));
    }
    var r11;
  }, []), ep.useEffect(() => {
    setTimeout(() => {
      var _a2;
      (_a2 = document.querySelector("#finish-button")) == null ? void 0 : _a2.focus();
    }, 0);
  }, [i10]);
  const m10 = () => d10();
  const h10 = (e15) => () => u10(OUe.goToStep(e15));
  const f10 = { text: p10("buttons.btnNext", "Next"), accent: "full", disabled: !o10, onClick: h10(r10 + 1) };
  const g10 = { text: p10("buttons.btnBack", "Back"), onClick: h10(r10 - 1) };
  const y10 = ep.useCallback(() => {
    d10(), u10(OUe.createChart(a10, s10));
  }, [a10, d10, u10, s10]);
  const v10 = { text: p10("buttons.btnFinish", "Finish"), accent: "full", disabled: !o10, onClick: y10, id: "finish-button" };
  const b10 = { text: p10("buttons.btnCancel", "Cancel"), onClick: m10 };
  const S10 = { [rXe]: [b10, f10], [oXe]: e14 ? [b10, f10] : [b10, g10, f10], [aXe]: [b10, g10, v10] };
  const C10 = ep.useMemo(() => ZUe(p10), [p10]);
  const x10 = { [rXe]: p10("titleSelectType", "Select Data and Chart type"), [oXe]: `${C10[l10]} ${p10("titleSettings", "Settings")}`, [aXe]: p10("titlePreview", "Preview") };
  const w10 = { open: true, subtitle: p10("titleChartWizard", "Chart Wizard"), title: x10[r10], controls: { align: "right", buttons: S10[r10] }, shouldCloseOnOverlayClick: false, onClose: m10 };
  const T10 = { steps: [{ text: p10("textTypeStep", "Data and Type"), moveToStep: h10(rXe) }, { text: x10[oXe], moveToStep: h10(oXe) }, { text: p10("textPreviewStep", "Preview"), moveToStep: h10(aXe) }], currentIndex: r10, defaultStepIcon: nf(Fh) };
  const E10 = { dispatch: u10, chartModel: a10 };
  return tp.createElement(Hk, __spreadValues({}, w10), tp.createElement("div", { className: "chart-wizard-container" }, tp.createElement(NH, __spreadValues({}, T10)), r10 === rXe && tp.createElement(UUe, __spreadProps(__spreadValues({}, E10), { chartPlotTemplateType: l10, shouldHidePlotTypeEditor: t10 })), r10 === oXe && tp.createElement(lqe, __spreadValues({}, E10)), r10 === aXe && tp.createElement(nXe, __spreadProps(__spreadValues({}, E10), { viewChartModel: i10, absolutePath: s10, advancedCustomizationVisibility: c10 }))));
};
iXe.displayName = "ChartWizardDialog";
const sXe = { header: true, footer: true, legend: true, globalLegend: false, plot: true, plotArea: true, axisX: true, axisY: true };
const lXe = { curStep: rXe, path: "", stepCompleted: false, chartModel: Yye, defaultChartModel: Yye, viewChartModel: Yye, chartPlotTemplateType: "column", advancedCustomizationVisibility: sXe, chartBreakDownMethod: "Cluster" };
const cXe = ["Scatter", "RadarScatter", "Bubble", "RadarBubble", "Gantt", "Candlestick", "HighLowClose", "HighLowOpenClose", "RangeArea", "RangeBar", "RangeColumn"];
const uXe = (e14, { payload: { stepCompleted: t10 } }) => AV(e14, { stepCompleted: { $set: t10 } });
const dXe = (e14) => (t10, n10) => __spreadProps(__spreadValues({}, t10), { chartModel: e14(t10.chartModel, n10) });
const pXe = (e14) => (t10, n10) => __spreadProps(__spreadValues({}, t10), { defaultChartModel: e14(t10.defaultChartModel, n10) });
const mXe = (e14, t10, n10) => {
  const r10 = e14.Plots[0].Encodings[t10];
  const o10 = e14.Plots[0].PlotChartType;
  if (!r10.length && n10(o10)) {
    const n11 = xXe(e14, OUe.deleteEncoding(t10, 0));
    return jbe(n11, $ye.addEncodingValue(t10, ""));
  }
  return e14;
};
const hXe = (e14, { payload: { chartBreakDownMethod: t10 } }) => {
  const { chartModel: n10, chartPlotTemplateType: r10 } = e14;
  let o10 = Dbe(n10, 0, "Cluster" !== t10 ? `${r10}${t10}` : r10);
  return "PercentStacked" === t10 && (o10 = AV(o10, { PlotArea: { Axes: { 1: { Format: { $set: "p2" } } } } })), __spreadProps(__spreadValues({}, e14), { chartBreakDownMethod: t10, chartModel: o10 });
};
const fXe = jV((e14) => mXe(e14, "Details", (e15) => !["Candlestick", "HighLowClose", "HighLowOpenClose"].includes(e15)), (e14) => mXe(e14, "Values", (e15) => cXe.includes(e15)), (e14) => mXe(e14, "Size", (e15) => ["Bubble", "RadarBubble"].includes(e15)), (e14) => mXe(e14, "Category", (e15) => !["Pie", "Pyramid", "Funnel", "Scatter", "RadarScatter"].includes(e15)), (e14) => {
  if ("Gauge" === e14.Plots[0].PlotChartType) {
    return AV(e14, { Plots: { 0: { Config: { CustomLabels: { $push: [Lve()] }, Pointers: { $push: [Ive()] } } } } });
  }
  return e14;
});
const gXe = jV((e14, { payload: { templateType: t10 } }) => Dbe(e14, 0, t10), fXe);
const yXe = jV((e14, { payload: { templateType: t10 } }) => AV(e14, { chartPlotTemplateType: { $set: t10 }, chartBreakDownMethod: { $set: "Cluster" } }), dXe(gXe), pXe(gXe));
const vXe = (e14, t10) => {
  const { payload: { descriptor: n10, value: r10 } } = t10;
  const o10 = ZN(n10.valuePath);
  const a10 = AV(e14.chartModel, o10(r10));
  return __spreadProps(__spreadValues({}, e14), { chartModel: a10 });
};
const bXe = (e14, t10, n10, r10) => {
  const o10 = e14.PlotArea.Axes.findIndex((e15) => e15.AxisType === t10);
  return AV(e14, { PlotArea: { Axes: { [o10]: { Title: { $set: r10 ? hG().t(`captions:dvchartAxis.${r10}`) : n10 } } } } });
};
const SXe = (e14, t10) => (n10, { payload: { name: r10 } }) => bXe(n10, e14, r10, t10);
const CXe = (e14, { payload: { encodingName: t10, value: n10, index: r10 } }) => Nve(e14, t10, n10, r10);
const xXe = (e14, t10) => {
  const { payload: { encodingName: n10, valueIndex: r10 } } = t10;
  return AV(e14, { Plots: { 0: { $set: Jve(e14.Plots[0], $ye.deleteEncoding(0, n10, r10)) } } });
};
const wXe = (e14) => (t10, { payload: { index: n10 } }) => Jve(t10, $ye.deleteEncoding(0, e14, n10 || 0));
const TXe = (e14, t10) => t10.payload.overrideEncoding;
const EXe = (e14) => jV(GV(TXe, wXe(e14)), /* @__PURE__ */ ((e15) => (t10, { payload: { value: n10, name: r10, index: o10 } }) => CXe(t10, OUe.setEncodingValue(e15, n10, r10, o10)))(e14));
const FXe = jV(EXe("Details"), EXe("Color"));
const MXe = EXe("Category");
const kXe = EXe("Values");
const PXe = (e14) => (t10, n10) => __spreadProps(__spreadValues({}, t10), { Plots: [e14(t10.Plots[0], n10)] });
const NXe = { Details: PXe(FXe), Category: jV(PXe(MXe), SXe("X")), Values: jV(PXe(kXe), GV((e14) => 1 === e14.Plots[0].Encodings.Values.length, SXe("Y"), SXe("Y", "value"))), Size: PXe(jV(wXe("Size"), CXe)), Color: PXe(jV(wXe("Color"), CXe)), Shape: PXe(jV(wXe("Shape"), CXe)) };
const DXe = (e14, t10) => {
  const n10 = NXe[t10.payload.encodingName];
  if (!n10) throw new Error(`Invalid chart encoding: ${t10.payload.encodingName}`);
  return n10(e14, t10);
};
const LXe = (e14) => (t10) => {
  const n10 = (e15) => e15.some((e16) => e16.Value);
  const r10 = "Details" === e14 || "Values" === e14 ? (t11) => t11.reduce((r11, o10, a10) => {
    var _a2;
    const i10 = "Details" === e14 && ((_a2 = o10.Field.Value) == null ? void 0 : _a2[0]);
    const s10 = "Values" === e14 && (o10.Field.Value && n10(o10.Field.Value) || o10.Field.Subfields && n10(o10.Field.Subfields));
    return i10 || s10 ? __spreadProps(__spreadValues({}, r11), { [a10]: { Field: { $set: o10.Field } } }) : a10 === t11.length - 1 ? __spreadProps(__spreadValues({}, r11), { $splice: [[a10, 1]] }) : r11;
  }, {}) : (e15) => {
    var _a2, _b2;
    return ((_b2 = (_a2 = e15.Field.Value) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.Value) ? { $set: e15 } : { Field: { Value: { $set: [] } } };
  };
  return AV(t10, { Encodings: { [e14]: r10(t10.Encodings[e14]) } });
};
const HXe = (e14, t10, n10) => AV(e14, { Config: { [t10]: { $set: n10 } } });
const IXe = PXe(jV(LXe("Details"), LXe("Category"), LXe("Color"), LXe("Size"), LXe("Values"), GV((e14) => "Gauge" === e14.PlotChartType, (e14) => {
  const t10 = "" === e14.Config.Pointers[0].End ? HXe(e14, "Pointers", []) : e14;
  return "" === t10.Config.CustomLabels[0].Text ? HXe(t10, "CustomLabels", []) : t10;
})));
const _Xe = { Pointers: PXe((e14, t10) => AV(e14, { Config: { Pointers: { [t10.payload.index]: { End: { $set: t10.payload.value } } } } })), CustomLabels: PXe((e14, t10) => AV(e14, { Config: { CustomLabels: { [t10.payload.index]: { Text: { $set: t10.payload.value } } } } })) };
const VXe = (e14, t10) => {
  const n10 = _Xe[t10.payload.configName];
  if (!n10) throw new Error(`Invalid chart encoding: ${t10.payload.configName}`);
  return n10(e14, t10);
};
const RXe = (e14) => {
  var _a2;
  return !(!((_a2 = e14.Plots[0].Encodings.Details[0]) == null ? void 0 : _a2.Field.Value[0]) || !e14.Plots[0].Encodings.Color.Field.Value[0]);
};
const AXe = (e14) => {
  const t10 = e14.Plots[0].Encodings.Values;
  return t10.length >= 2 && t10.reduce((e15, t11) => "Simple" === t11.Field.FieldType && t11.Field.Value ? e15 + 1 : e15, 0) >= 2;
};
const OXe = (e14) => !["Pie", "Pyramid", "Funnel", "Gauge"].includes(e14.Plots[0].PlotChartType);
const BXe = (e14) => "Pie" !== e14.Plots[0].PlotChartType;
const zXe = (e14, { payload: { step: t10 } }) => {
  var _a2;
  if (t10 === aXe) {
    let n10 = e14.chartModel;
    if (!cXe.includes(e14.chartModel.Plots[0].PlotChartType)) {
      if (n10 = PXe(LXe("Values"))(n10, {}), !RXe(n10) && AXe(n10) && (n10 = DXe(n10, OUe.addEncodingValue("Color", ive, ive))), ((e15) => !(1 !== e15.Plots[0].Encodings.Values.length || "Simple" !== e15.Plots[0].Encodings.Values[0].Field.FieldType))(n10)) {
        const e15 = fc("rdl", ((_a2 = n10.Plots[0].Encodings.Values[0].Field.Value[0]) == null ? void 0 : _a2.Value) || "");
        const t11 = "field" === e15.type ? e15.fieldName : "";
        n10 = bXe(n10, "Y", t11);
      }
      if (!n10.Plots[0].Encodings.Values.length) {
        const e15 = "Gauge" === n10.Plots[0].PlotChartType ? void 0 : "value";
        n10 = bXe(n10, "Y", "", e15);
      }
    }
    const r10 = IXe(n10, OUe.deleteEmptyEncodings());
    const o10 = ((e15) => {
      if (["Candlestick", "HighLowClose", "HighLowOpenClose"].includes(e15.Plots[0].PlotChartType)) return __spreadProps(__spreadValues({}, sXe), { legend: false, globalLegend: false });
      const t11 = RXe(e15);
      return __spreadProps(__spreadValues({}, sXe), { axisX: OXe(e15), axisY: BXe(e15), legend: t11, globalLegend: !t11 && AXe(e15) });
    })(r10);
    return AV(e14, { curStep: { $set: t10 }, stepCompleted: { $set: t10 < e14.curStep }, chartModel: { $set: n10 }, viewChartModel: { $set: r10 }, advancedCustomizationVisibility: { $set: o10 } });
  }
  return __spreadProps(__spreadValues({}, e14), { curStep: t10, stepCompleted: t10 < e14.curStep });
};
const $Xe = jV(/* @__PURE__ */ ((e14) => (t10, n10) => __spreadProps(__spreadValues({}, t10), { viewChartModel: e14(t10.viewChartModel, n10) }))(zbe), dXe(zbe));
const WXe = (e14) => {
  const t10 = (t11, { payload: n10 }) => {
    const { DataSetName: r10 } = t11.chartModel;
    const { chart: o10, path: a10 } = n10;
    if (!o10 || !a10) return t11;
    const { units: i10 } = KO.of(e14).userPreferences;
    const s10 = nz.of(e14).getTemplate("dvchart");
    return { path: a10, chartModel: __spreadProps(__spreadValues({}, Jye(o10.Name, 0, { CustomPalette: o10.CustomPalette, CustomPaletteInfo: o10.CustomPaletteInfo, Palette: o10.Palette, $place: o10.$place, ZIndex: o10.ZIndex, Plots: o10.Plots }, s10)), { DataSetName: r10 }), defaultChartModel: Jye("", 0, {}, s10), viewChartModel: Jye("", 0, {}, s10), chartPlotTemplateType: lXe.chartPlotTemplateType, curStep: lXe.curStep, stepCompleted: true, advancedCustomizationVisibility: lXe.advancedCustomizationVisibility, chartBreakDownMethod: lXe.chartBreakDownMethod };
  };
  return WV(0, { [FUe]: jV(t10, dXe(fXe), pXe(fXe)), [MUe]: zXe, [kUe]: uXe, [NUe]: $Xe, [DUe]: dXe(Bbe), [LUe]: jV((e15) => t10(e15, OUe.init(e15.chartModel, e15.path)), yXe), [HUe]: dXe(DXe), [IUe]: dXe(xXe), [_Ue]: vXe, [VUe]: dXe(IXe), [RUe]: hXe, [AUe]: dXe(VXe) }, (e15) => e15 || lXe);
};
const jXe = { totalsForRowGroups: false, subtotalsForRowGroups: false, totalsForColumnGroups: false, subtotalsForColumnGroups: false, showTotalsBeforeGroup: false };
const ZXe = { expandCollapseGroups: false, collapsedGroups: false, enableUserSort: false, steppedRowGroups: false, showValuesAsRows: false };
const GXe = "WizardModel";
const UXe = (e14) => {
  var _a2;
  return (_a2 = (e14.CustomProperties || []).find((e15) => e15.Name === GXe)) != null ? _a2 : null;
};
const qXe = (e14) => !!UXe(e14);
const YXe = (e14) => {
  if (!e14) return null;
  const { StyleId: t10, StyleName: n10 } = e14;
  return t10 && n10 ? { id: t10, name: n10 } : null;
};
const KXe = (e14) => ({ name: e14.Name, dataSetName: e14.DataSetName, isFpl: "fixedpagetablix" === e14.Type, style: YXe(e14.ReportStyle), frozenRows: e14.FrozenRows, frozenColumns: e14.FrozenColumns });
const XXe = (e14, t10) => (e14 || []).reduceRight((e15, n10) => {
  const [r10, o10] = e15.length ? [null, null] : [0, t10 - 1];
  const { name: a10, field: i10, sorting: s10, itemName: l10, itemValue: c10, format: u10, defaultFormat: d10 } = n10;
  let p10 = { name: a10, field: i10, sorting: s10, itemName: l10, itemValue: c10, format: u10 };
  d10 && (p10 = __spreadProps(__spreadValues({}, p10), { defaultFormat: d10 }));
  return [{ group: p10, children: e15, startBodyIndex: r10, endBodyIndex: o10 }];
}, []);
const JXe = (e14) => (e14 || []).map((e15) => {
  const { itemName: t10, field: n10, aggregate: r10, displayAs: o10, format: a10, defaultFormat: i10 } = e15;
  let s10 = { itemName: t10, field: n10, aggregate: r10, format: a10 };
  return null !== o10 && (s10 = __spreadProps(__spreadValues({}, s10), { displayAs: o10 })), i10 && (s10 = __spreadProps(__spreadValues({}, s10), { defaultFormat: i10 })), s10;
});
const QXe = (e14, t10) => {
  const n10 = ((e15) => {
    const { layoutOptions: t11, columnGroups: n11, rowGroups: r11, values: o10 } = e15;
    return { layoutOptions: t11, columnHierarchy: XXe(n11, o10.length || 1), rowHierarchy: XXe(r11, 1), body: [JXe(o10)] };
  })(t10);
  const r10 = ((e15, t11) => {
    var _a2, _b2;
    return __spreadProps(__spreadValues({}, e15), { DataSetName: t11.dataSetName, ReportStyle: (n11 = t11.style, { StyleId: (_a2 = n11 == null ? void 0 : n11.id) != null ? _a2 : "", StyleName: (_b2 = n11 == null ? void 0 : n11.name) != null ? _b2 : "" }), FrozenRows: t11.frozenRows, FrozenColumns: t11.frozenColumns });
    var n11;
  })(e14, t10);
  return ((e15, t11) => {
    const n11 = JSON.stringify(t11);
    const r11 = { Name: GXe, Value: n11 };
    const o10 = (e15.CustomProperties || []).filter((e16) => e16.Name !== GXe);
    return o10.push(r11), __spreadProps(__spreadValues({}, e15), { CustomProperties: o10 });
  })(r10, n10);
};
const eJe = (e14, t10) => {
  const { layoutOptions: n10, columnGroups: r10, rowGroups: o10, values: a10 } = t10;
  return __spreadProps(__spreadValues({}, e14), { layoutOptions: { totals: __spreadValues(__spreadValues({}, jXe), n10 == null ? void 0 : n10.totals), features: __spreadValues(__spreadValues({}, ZXe), n10 == null ? void 0 : n10.features) }, columnGroups: r10 || [], rowGroups: o10 || [], values: a10 || [] });
};
const tJe = (e14) => {
  var _a2;
  const t10 = [];
  let n10 = e14;
  for (; n10.length; ) {
    const e15 = n10[0];
    t10.push(__spreadProps(__spreadValues({}, e15.group), { defaultFormat: (_a2 = e15.group.defaultFormat) != null ? _a2 : "" })), n10 = e15.children;
  }
  return t10;
};
const nJe = (e14) => (e14 == null ? void 0 : e14.length) ? e14[0].map((e15) => {
  var _a2;
  return __spreadProps(__spreadValues({ displayAs: null }, e15), { defaultFormat: (_a2 = e15.defaultFormat) != null ? _a2 : "" });
}) : [];
const rJe = (e14) => {
  const t10 = ((e15) => {
    var _a2, _b2, _c2, _d2;
    const t11 = UXe(e15);
    if (!t11) throw new Error("Read Tablix Wizard Model only after checking that Tablix does have it!");
    const n10 = (_b2 = (_a2 = t11.Value) == null ? void 0 : _a2.toString()) != null ? _b2 : "";
    const r10 = JSON.parse(n10);
    return __spreadProps(__spreadValues({}, r10), { layoutOptions: { totals: __spreadValues(__spreadValues({}, jXe), (_c2 = r10.layoutOptions) == null ? void 0 : _c2.totals), features: __spreadValues(__spreadValues({}, ZXe), (_d2 = r10.layoutOptions) == null ? void 0 : _d2.features) } });
  })(e14);
  return ((e15, t11) => {
    const { layoutOptions: n10, columnHierarchy: r10, rowHierarchy: o10, body: a10 } = e15;
    return eJe(t11, { layoutOptions: n10, columnGroups: tJe(r10 != null ? r10 : []), rowGroups: tJe(o10 != null ? o10 : []), values: nJe(a10) });
  })(t10, KXe(e14));
};
const oJe = (e14, t10) => {
  const n10 = Rj(e14, t10);
  return n10 && zW(n10.Type) ? n10 : null;
};
const aJe = ["PercentGrandTotal", "PercentRowGroupTotal", "PercentParentRowGroupTotal", "PercentColumnGroupTotal", "PercentParentColumnGroupTotal"];
const iJe = (e14) => !!e14 && aJe.includes(e14);
const sJe = (e14) => {
  var _a2;
  return (_a2 = e14 == null ? void 0 : e14.toString()) != null ? _a2 : "";
};
const lJe = ({ SortExpressions: e14 }) => e14.length > 0 ? { value: sJe(e14[0].Value), direction: e14[0].Direction } : null;
const cJe = (e14, t10, n10) => {
  var _a2, _b2;
  const { sorting: r10, defaultFormat: o10 } = n10;
  const a10 = (_b2 = (_a2 = e14.Group.GroupExpressions[0]) == null ? void 0 : _a2.toString()) != null ? _b2 : "";
  return { name: e14.Group.Name, field: { name: N1(a10)[0] || "", expr: a10 }, sorting: r10, itemName: t10.Name, itemValue: sJe(t10.Value), format: t10.Style.Format, defaultFormat: o10 };
};
const uJe = (e14, t10) => {
  var _a2, _b2;
  const n10 = sJe(e14.Value);
  if (!((_a2 = t10 == null ? void 0 : t10.allowEmptyValue) != null ? _a2 : false) && !n10) return null;
  const r10 = N1(n10)[0] || "";
  const o10 = { itemName: e14.Name, field: { name: r10, expr: n10 }, aggregate: A1(n10) || null, displayAs: null, format: e14.Style.Format, defaultFormat: (_b2 = t10 == null ? void 0 : t10.defaultFormat) != null ? _b2 : "" };
  if (!t10 || !r10) return o10;
  const { aggregate: a10, displayAs: i10 } = t10;
  if (!a10 || !iJe(i10)) return o10;
  const s10 = `=${G1(r10, null, a10)}`;
  const l10 = `${s10} / `;
  return n10.startsWith(l10) ? __spreadProps(__spreadValues({}, o10), { field: { name: r10, expr: s10 }, aggregate: a10, displayAs: i10 }) : o10;
};
function dJe(e14) {
  const t10 = [];
  for (let n10 = 0; n10 < e14.Members.length; n10++) if (t10[n10] = [], mJe(e14.Members[n10], t10[n10]), pJe(t10)) return true;
  return false;
}
function pJe(e14) {
  if (Array.isArray(e14)) {
    const t10 = e14.filter((e15) => Array.isArray(e15) && e15.length > 0);
    if (t10.length >= 2) return true;
    for (let n10 = 0; n10 < t10.length; n10++) if (pJe(e14[n10])) return true;
  }
  return false;
}
function mJe(e14, t10) {
  const n10 = eW(e14);
  n10 && t10.push([e14.Group]);
  for (let r10 = 0; r10 < e14.Children.length; r10++) mJe(e14.Children[r10], n10 ? t10[t10.length - 1] : t10);
}
function hJe(e14) {
  let t10 = null;
  for (let n10 = 0; n10 < e14.length; n10++) {
    const r10 = fJe(e14[n10]);
    if (false === r10) return false;
    t10 = t10 || r10;
  }
  return t10;
}
function fJe(e14) {
  let t10 = null;
  return e14.Children.length > 0 ? (t10 = hJe(e14.Children), null === t10 && (t10 = eW(e14) ? 1 === e14.BodyCount : t10)) : t10 = eW(e14) ? 1 === e14.BodyCount : null, t10;
}
const gJe = (e14) => {
  if (!e14.every(tW)) return true;
  if (1 !== e14.length) return false;
  return 0 === (e14[0].Children || []).length;
};
const yJe = (e14) => function(e15) {
  return dJe(e15.ColumnHierarchy) || dJe(e15.RowHierarchy);
}(e14);
const vJe = (e14) => function(e15) {
  const t10 = hJe(e15.RowHierarchy.Members);
  if (false === t10 || null === t10 && 1 !== e15.Body.Rows.length) return false;
  const n10 = hJe(e15.ColumnHierarchy.Members);
  return false !== n10 && (null !== n10 || 1 === e15.Body.Columns.length);
}(e14);
const bJe = "NON_TEXT_BOX_CELL_EXCEPTION";
const SJe = "HIDDEN_MEMBER_EXCEPTION";
const CJe = "PARENT_DYNAMIC_MEMBER_WITHOUT_SINGLE_DYNAMIC_CHILD_EXCEPTION";
const xJe = (e14) => e14 && eW(e14) || false;
function wJe(e14) {
  let t10 = false;
  let n10 = false;
  let r10 = false;
  if (0 === (e14.Corner || []).length) return false;
  if (!gJe(e14.ColumnHierarchy.Members)) return false;
  if (!gJe(e14.RowHierarchy.Members)) return false;
  try {
    VQ(e14, (e15) => {
      if (!(({ item: e16 }) => e16 && "textbox" === e16.Type || false)(e15)) throw bJe;
    }, (e15) => {
      const { member: t11 } = e15;
      if (((e16) => e16 && !e16.Header || false)(t11)) throw SJe;
      if (!xJe(t11)) return;
      const n11 = t11 && t11.Children || [];
      if (0 === n11.length) return;
      if (1 !== n11.filter((e16) => xJe(e16)).length) throw CJe;
    });
  } catch (e15) {
    if (e15 === bJe) t10 = true;
    else if (e15 === SJe) n10 = true;
    else {
      if (e15 !== CJe) throw e15;
      r10 = true;
    }
  }
  return !t10 && !n10 && !r10 && !yJe(e14) && vJe(e14);
}
const TJe = (e14, t10) => {
  const n10 = e14.findIndex((e15) => {
    if (!eW(e15)) return false;
    if (t10.length) return true;
    return !(!e15.Group.GroupExpressions[0] && "" === e15.Header.Item.Value && 0 === e15.Children.length);
  });
  if (-1 === n10) return t10;
  const r10 = e14[n10];
  return t10.push({ member: r10, sorting: lJe(r10), hasBeforeTotal: n10 - 1 >= 0 && tW(e14[n10 - 1]), hasAfterTotal: n10 + 1 < e14.length && tW(e14[n10 + 1]) }), r10.Children.length && TJe(r10.Children, t10), t10;
};
const EJe = (e14) => e14.map((e15) => {
  const { member: t10, sorting: n10 } = e15;
  const r10 = t10.Header.Item;
  return cJe(t10, r10, { sorting: n10, defaultFormat: "" });
});
const FJe = (e14) => {
  const t10 = TJe(e14.RowHierarchy.Members, []);
  const n10 = TJe(e14.ColumnHierarchy.Members, []);
  const r10 = t10.length && t10[t10.length - 1].member.BodyIndex || 0;
  const o10 = n10.length && n10[n10.length - 1].member.BodyIndex || 0;
  const a10 = e14.Body.Rows[r10].Cells[o10];
  const i10 = t10[0];
  const s10 = t10.slice(1);
  const l10 = n10[0];
  const c10 = n10.slice(1);
  const u10 = (i10 == null ? void 0 : i10.hasBeforeTotal) || (i10 == null ? void 0 : i10.hasAfterTotal) || false;
  const d10 = !!s10.length && s10.every((e15) => e15.hasBeforeTotal || e15.hasAfterTotal);
  const p10 = (l10 == null ? void 0 : l10.hasBeforeTotal) || (l10 == null ? void 0 : l10.hasAfterTotal) || false;
  const m10 = !!c10.length && c10.every((e15) => e15.hasBeforeTotal || e15.hasAfterTotal);
  const h10 = u10 && i10.hasBeforeTotal || d10 && s10.every((e15) => e15.hasBeforeTotal) || p10 && l10.hasBeforeTotal || m10 && c10.every((e15) => e15.hasBeforeTotal) || false;
  const f10 = s10.every((e15) => e15.member.Visibility.ToggleItem);
  const g10 = c10.every((e15) => e15.member.Visibility.ToggleItem);
  const y10 = !(!s10.length && !c10.length) && (f10 && g10);
  const v10 = ((e15, t11) => {
    const n11 = (e15.Corner || [])[0];
    return !(n11 && !n11.every((e16) => !e16 || !!e16.Item.UserSort.SortExpression)) && !!(t11.length > 0 ? t11[0].member : e15.ColumnHierarchy.Members[0]).Header.Item.UserSort.SortExpression;
  })(e14, n10);
  const b10 = EJe(n10);
  const S10 = EJe(t10);
  const C10 = ((e15) => {
    const t11 = e15.Item;
    const n11 = uJe(t11);
    return n11 ? [n11] : [];
  })(a10);
  let x10 = KXe(e14);
  const w10 = [...b10.filter((e15) => e15.field.name), ...S10.filter((e15) => e15.field.name), ...C10.filter((e15) => e15.field.name)].length > 0;
  return w10 || (x10 = __spreadProps(__spreadValues({}, x10), { dataSetName: "" })), eJe(x10, { layoutOptions: { totals: { totalsForRowGroups: u10, subtotalsForRowGroups: d10, totalsForColumnGroups: p10, subtotalsForColumnGroups: m10, showTotalsBeforeGroup: h10 }, features: { expandCollapseGroups: y10, enableUserSort: v10 } }, columnGroups: b10, rowGroups: S10, values: C10 });
};
const MJe = (e14, t10 = "textbox") => {
  const n10 = TG(t10);
  return kG(n10, e14);
};
const kJe = Jc("[^\\p{L}\\p{N}_]", "g");
const PJe = (e14) => e14.replace(kJe, "");
const NJe = (e14, t10, n10) => {
  const r10 = [t10, PJe(n10), EG()].filter((e15) => e15).join("_");
  return e14.includes(r10) ? kG(r10, e14) : r10;
};
const DJe = (e14, t10) => {
  const n10 = Object.keys(t10).reduce((e15, n11) => {
    const r10 = t10[n11];
    return r10 ? j0(e15 || {}, n11, r10) : e15;
  }, null);
  return n10 ? AV(e14, n10) : e14;
};
const LJe = (e14, t10) => {
  const n10 = t10.reduce((t11, n11) => (t11[n11] = e14[n11], t11), {});
  return n10;
};
const HJe = (e14, { itemWidth: t10, itemHeight: n10 }) => ({ itemWidth: t10, itemHeight: n10, itemProps: __spreadProps(__spreadValues({}, LJe(e14, ["Action", "Bookmark", "CanGrow", "CanShrink", "DataElementOutput", "DataElementStyle", "KeepTogether", "Label", "LayerName", "ReportStyle", "ToggleImage", "ToolTip", "Visibility", "ZIndex"])), { Style: LJe(e14.Style, ["Angle", "BackgroundColor", "BackgroundImage", "Border", "BottomBorder", "Calendar", "CharacterSpacing", "Color", "Direction", "FontFamily", "FontSize", "FontStyle", "FontWeight", "HeadingLevel", "Language", "LeftBorder", "LineSpacing", "MinCondenseRate", "NumeralLanguage", "NumeralVariant", "PaddingBottom", "PaddingLeft", "PaddingRight", "PaddingTop", "RightBorder", "ShrinkToFit", "TextAlign", "TextDecoration", "TextJustify", "TopBorder", "UnicodeBiDi", "VerticalAlign", "WrapMode", "WritingMode"]) }) });
const IJe = (e14, t10) => __spreadProps(__spreadValues({}, t10), { memberProps: __spreadProps(__spreadValues({}, LJe(e14, ["DataElementName", "DataElementOutput", "KeepTogether"])), { Group: LJe(e14.Group, ["DataElementName", "DataElementOutput", "DocumentMapLabel", "Filters", "NewSection", "PageBreak", "PageBreakDisabled", "ParentGroup", "PrintFooterAtBottom"]) }) });
const _Je = (e14) => ({ tablixProps: "fixedpagetablix" !== e14.Type ? LJe(e14, ["Bookmark", "CustomProperties", "DataElementName", "DataElementOutput", "DataSetParameters", "Filters", "GroupsBeforeRowHeaders", "KeepTogether", "Label", "LayerName", "LayoutDirection", "NewSection", "NoRowsMessage", "PageBreak", "PageName", "RepeatColumnHeaders", "RepeatRowHeaders", "SortExpressions", "Style", "ToolTip", "Visibility", "ZIndex"]) : LJe(e14, ["Bookmark", "CustomProperties", "DataElementName", "DataElementOutput", "DataSetParameters", "Filters", "GroupsBeforeRowHeaders", "KeepTogether", "Label", "LayerName", "LayoutDirection", "NewSection", "NoRowsMessage", "PageBreak", "PageName", "RepeatColumnHeaders", "RepeatRowHeaders", "RepeatToFill", "SortExpressions", "Style", "ToolTip", "Visibility", "ZIndex"]) });
const VJe = (e14, t10) => ({ cix: n10, cspan: r10, rix: o10, rspan: a10 }, i10) => ({ itemWidth: "height" !== i10 ? L$.sum(e14, n10, r10) : null, itemHeight: "width" !== i10 ? L$.sum(t10, o10, a10) : null });
const RJe = (e14, t10) => {
  const n10 = Rj(e14, t10);
  return "dynamictablixmember" !== (n10 == null ? void 0 : n10.Type) ? null : n10;
};
const AJe = (e14, t10) => {
  if (e14 === t10) return true;
  const [n10, r10] = [e14, t10].map((e15) => !e15.Header);
  return n10 === r10;
};
const OJe = (e14, t10, n10) => {
  if (0 === t10.length) return [];
  const r10 = "row" === n10 ? "RowHierarchy" : "ColumnHierarchy";
  const o10 = e14[r10];
  const a10 = (e15, n11, r11) => {
    var _a2;
    const { name: o11, itemName: i10, defaultFormat: s10 } = t10[r11];
    const l10 = e15.findIndex((e16) => eW(e16) && e16.Group.Name === o11);
    if (l10 < 0) throw new Error(`[Unexpected Error] There must be a member with a group named ${o11}!`);
    const c10 = e15[l10];
    const u10 = `${n11}.${l10}`;
    let d10 = null;
    let p10 = null;
    if (((_a2 = c10.Header) == null ? void 0 : _a2.Item.Name) === i10) d10 = c10.Header, p10 = `${u10}.Header`;
    else {
      const e16 = c10.Children.findIndex((e17) => {
        var _a3;
        return tW(e17) && ((_a3 = e17.Header) == null ? void 0 : _a3.Item.Name) === i10;
      });
      e16 >= 0 && (d10 = c10.Children[e16].Header, p10 = `${u10}.Children.${e16}.Header`);
    }
    if (!d10 || !p10) throw new Error(`[Unexpected Error] There must be a header with an item named ${i10}!`);
    const m10 = { member: c10, memberPath: u10, item: d10.Item, itemPath: `${p10}.Item`, index: r11, defaultFormat: s10 };
    return r11 < t10.length - 1 ? [m10, ...a10(c10.Children, `${u10}.Children`, r11 + 1)] : [m10];
  };
  return a10(o10.Members, `${r10}.Members`, 0);
};
const BJe = (e14, t10) => {
  const n10 = Rj(e14, t10);
  return "textbox" !== (n10 == null ? void 0 : n10.Type) ? null : n10;
};
const zJe = (e14, { memberPath: t10, itemPath: n10 }) => ({ member: RJe(e14, t10), item: BJe(e14, n10) });
const $Je = (e14) => {
  const t10 = (e15) => e15.reduce((e16, n10) => {
    let r10 = t10(n10.Children);
    return eW(n10) && r10++, e16 + r10;
  }, 0);
  return t10(e14.Members);
};
const WJe = (e14, t10, n10, r10 = false) => {
  const { columnGroups: o10, rowGroups: a10, values: i10 } = n10;
  const s10 = r10 ? t10 : H3e(e14, n10, (e15) => e15, void 0, t10.$templateId);
  if (!r10) {
    const [e15, n11] = [s10, t10].map((e16) => DQ(e16));
    if (e15 !== n11) return null;
    const [r11, i11] = [s10, t10].map((e16) => LQ(e16));
    if (r11 !== i11) return null;
    if ($Je(t10.ColumnHierarchy) !== o10.length) return null;
    if ($Je(t10.RowHierarchy) !== a10.length) return null;
  }
  const l10 = OJe(s10, o10, "column");
  const c10 = OJe(s10, a10, "row");
  const u10 = ((e15, t11) => {
    if (0 === t11.length) return [];
    let n11 = 0;
    const r11 = [];
    const o11 = e15.Body.Rows;
    const a11 = (e16, t12) => `Body.Rows.${e16}.Cells.${t12}.Item`;
    for (let e16 = 0; e16 < o11.length; e16++) {
      const i11 = o11[e16].Cells;
      for (let o12 = 0; o12 < i11.length; o12++) {
        const s11 = i11[o12];
        if (!s11) continue;
        const l11 = s11.Item;
        if (l11.Name !== t11[n11].itemName) continue;
        const { aggregate: c11, displayAs: u11, defaultFormat: d11 } = t11[n11];
        if (r11.push({ item: l11, itemPath: a11(e16, o12), index: n11++, aggregate: c11, displayAs: u11, defaultFormat: d11 }), n11 === t11.length) return r11;
      }
    }
    throw new Error("[Unexpected Error] Some values are not present in body cells!");
  })(s10, i10);
  const d10 = {};
  for (const e15 of l10) {
    const { member: n11, itemPath: r11 } = e15;
    const { member: o11, item: a11 } = zJe(t10, e15);
    if (!o11 || !a11 || !AJe(n11, o11)) return null;
    d10[r11] = __spreadProps(__spreadValues({}, e15), { member: o11, item: a11 });
  }
  const p10 = {};
  for (const e15 of c10) {
    const { member: n11, itemPath: r11 } = e15;
    const { member: o11, item: a11 } = zJe(t10, e15);
    if (!o11 || !a11 || !AJe(n11, o11)) return null;
    p10[r11] = __spreadProps(__spreadValues({}, e15), { member: o11, item: a11 });
  }
  const m10 = {};
  for (const e15 of u10) {
    const { itemPath: n11 } = e15;
    const r11 = BJe(t10, n11);
    if (!r11) return null;
    m10[n11] = __spreadProps(__spreadValues({}, e15), { item: r11 });
  }
  let h10 = null;
  let f10 = null;
  let g10 = null;
  const y10 = VJe(HQ(t10), IQ(t10));
  let v10 = false;
  _Q(t10, (e15) => {
    const { itemPath: t11, item: n11 } = e15;
    const o11 = (t12, n12, r11, o12) => ({ $set: __spreadProps(__spreadValues({}, cJe(n12, r11, { sorting: lJe(n12), defaultFormat: o12 })), { $summary: IJe(n12, HJe(r11, y10(e15, "row" === t12 ? "width" : "height"))) }) });
    const a11 = d10[t11];
    if (a11) {
      const { member: e16, item: t12, index: n12, defaultFormat: r11 } = a11;
      return void (h10 = j0(h10 || {}, `${n12}`, o11("column", e16, t12, r11)));
    }
    const i11 = p10[t11];
    if (i11) {
      const { member: e16, item: t12, index: n12, defaultFormat: r11 } = i11;
      return void (f10 = j0(f10 || {}, `${n12}`, o11("row", e16, t12, r11)));
    }
    const s11 = m10[t11];
    if (!s11) return void (r10 || v10 || (v10 = "textbox" !== n11.Type));
    const { item: l11, index: c11, aggregate: u11, displayAs: b10, defaultFormat: S10 } = s11;
    const C10 = { $set: __spreadProps(__spreadValues({}, uJe(l11, { allowEmptyValue: true, aggregate: u11, displayAs: b10, defaultFormat: S10 })), { $summary: HJe(l11, y10(e15)) }) };
    g10 = j0(g10 || {}, `${c11}`, C10);
  });
  return { model: DJe(n10, { columnGroups: h10, rowGroups: f10, values: g10 }), hasNonTextBoxCells: v10 };
};
const jJe = (e14, t10) => {
  var _a2;
  const n10 = ((e15) => wJe(e15) ? FJe(e15) : null)(t10);
  if (!n10) return null;
  const r10 = WJe(e14, t10, n10, true);
  return (_a2 = r10 == null ? void 0 : r10.model) != null ? _a2 : null;
};
const ZJe = (e14, t10, n10) => {
  const { t: r10 } = hG();
  let o10 = null;
  let a10 = false;
  let i10 = false;
  if (qXe(t10)) {
    const r11 = rJe(t10);
    const s10 = WJe(e14, t10, r11);
    if (s10 && (o10 = s10.model, i10 = s10.hasNonTextBoxCells), o10 || (o10 = jJe(e14, t10), a10 = !!o10, i10 = !o10), !o10) {
      const e15 = ((e16, t11) => {
        const { columnGroups: n11, rowGroups: r12, values: o11 } = t11;
        let a11 = null;
        let i11 = null;
        let s11 = null;
        const l10 = VJe(HQ(e16), IQ(e16));
        const c10 = (e17, t12) => "textbox" !== e17.Type ? t12 : HJe(e17, t12);
        return _Q(e16, (e17) => {
          const { item: t12, member: u10 } = e17;
          const d10 = (n12, r13) => ({ $summary: { $apply: (o12) => {
            const a12 = c10(t12, l10(e17, "row" === r13 ? "width" : "height"));
            return o12 ? __spreadValues(__spreadValues({}, o12), a12) : "dynamictablixmember" === (u10 == null ? void 0 : u10.Type) && u10.Group.Name === n12.name ? IJe(u10, a12) : a12;
          } } });
          const p10 = u10 ? n11.findIndex((e18) => e18.itemName === t12.Name) : -1;
          if (p10 >= 0) {
            const e18 = n11[p10];
            return void (a11 = j0(a11 || {}, `${p10}`, d10(e18, "column")));
          }
          const m10 = u10 ? r12.findIndex((e18) => e18.itemName === t12.Name) : -1;
          if (m10 >= 0) {
            const e18 = r12[m10];
            return void (i11 = j0(i11 || {}, `${m10}`, d10(e18, "row")));
          }
          const h10 = u10 ? -1 : o11.findIndex((e18) => e18.itemName === t12.Name);
          h10 < 0 || (s11 = j0(s11 || {}, `${h10}`, { $summary: { $apply: (n12) => __spreadValues(__spreadValues({}, n12), c10(t12, l10(e17))) } }));
        }), DJe(t11, { columnGroups: a11, rowGroups: i11, values: s11 });
      })(t10, r11);
      o10 = ((e16, t11) => {
        const { name: n11, columnGroups: r12, rowGroups: o11, values: a11 } = e16;
        const { reportItemNames: i11, groupNames: s11 } = t11;
        const [l10, c10] = [[...i11], [...s11]];
        const u10 = (e17) => e17.reduce((e18, t12, r13) => {
          const { name: o12, itemName: a12, field: { name: i12 } } = t12;
          let s12 = null;
          if (c10.includes(o12)) {
            const e19 = NJe(c10, n11, i12);
            c10.push(e19), s12 = j0(s12 || {}, "name", { $set: e19 });
          }
          if (l10.includes(a12)) {
            const e19 = MJe(l10);
            l10.push(e19), s12 = j0(s12 || {}, "itemName", { $set: e19 });
          }
          return s12 ? j0(e18 || {}, `${r13}`, s12) : e18;
        }, null);
        return DJe(e16, { columnGroups: u10(r12), rowGroups: u10(o11), values: (d10 = a11, d10.reduce((e17, t12, n12) => {
          const { itemName: r13 } = t12;
          if (!l10.includes(r13)) return e17;
          const o12 = MJe(l10);
          return l10.push(o12), j0(e17 || {}, `${n12}.itemName`, { $set: o12 });
        }, null)) });
        var d10;
      })(e15, n10);
    }
  } else o10 = jJe(e14, t10), a10 = !!o10;
  if (!o10) throw new Error("[Unexpected Error] Tablix cannot be edited using Tablix Wizard!");
  return o10 = AV(o10, { $summary: { $set: _Je(t10) } }), { wizardModel: o10, synthesized: a10, warning: i10 ? [r10("tablixWizard:warning.textChangedStructure", "Tablix Wizard cannot edit the Tablix as its structure has been changed."), r10("tablixWizard:warning.textConfirmReverting", "Please confirm reverting to the previous Tablix state editable by Wizard."), r10("tablixWizard:warning.textOtherwiseCannotEdit", "Otherwise, it will not be possible to continue editing within Tablix Wizard.")].join("\n") : null };
};
const GJe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m19 3h-15c-1.104 0-2 .896-2 2v15c0 1.105.896 2 2 2h15c1.104 0 2-.895 2-2v-15c0-1.104-.896-2-2-2z", className: V9 }), tp.createElement("path", { d: "m20 21v-4h-8v1h-2l .001 2h-4.001v-2h-2v-1h-1v4z", className: Z9 }), tp.createElement("path", { d: "m19 10h-15v1h15", className: $9 }), tp.createElement("path", { d: "m21 20v-15c0-1.105-.896-2-2-2h-15c-1.104 0-2 .895-2 2v15c0 1.104.896 2 2 2h15c1.104 0 2-.896 2-2zm-1 0c0 .551-.449 1-1 1h-15c-.551 0-1-.449-1-1v-3.002h1v-1h-1v-10.998c0-.553.449-1 1-1h15c .551 0 1 .447 1 1v10.998h-8v1h8z", className: z9 }), tp.createElement("path", { d: "m11 17v-2h-2v-2h-2v2h-2v2h2v2h2v-2z", className: A9 }));
const UJe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m4 22h15c1.104 0 2-.896 2-2v-15c0-1.105-.896-2-2-2h-15c-1.104 0-2 .895-2 2v15c0 1.104.896 2 2 2z", className: V9 }), tp.createElement("path", { d: "m20 21v-4h-8v1h-8v-1h-1v4z", className: Z9 }), tp.createElement("path", { d: "m19 10h-15v1h15", className: $9 }), tp.createElement("path", { d: "m21 20v-15c0-1.105-.896-2-2-2h-15c-1.104 0-2 .895-2 2v15c0 1.104.896 2 2 2h15c1.104 0 2-.896 2-2zm-1 0c0 .551-.449 1-1 1h-15c-.551 0-1-.449-1-1v-3.002h1v-1h-1v-10.998c0-.553.449-1 1-1h15c .551 0 1 .447 1 1v10.998h-8v1h8z", className: z9 }), tp.createElement("path", { d: "m11 17v-2h-6v2z", className: A9 }));
const qJe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m21 10.714-.714-.714-1.786 1.786-1.785-1.786-.715.714 1.786 1.786-1.786 1.786.715.714 1.785-1.786 1.786 1.786.714-.714-1.785-1.786z", className: G9 }), tp.createElement("g", { className: $9 }, tp.createElement("path", { d: "m5 15v1h7v-1" }), tp.createElement("path", { d: "m5 9v1h7v-1" })), tp.createElement("path", { d: "m14 4v17h-11v-17zm-1 16v-15h-9v15z", className: G9 }));
const YJe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m21.002 15.002v-12h-19v12h2v-1h2v-2h4v2h2v1z", className: V9 }), tp.createElement("path", { d: "m20 21v-4h-8v1h-2l .001 2h-4.001v-2h-2v-1h-1v4z", className: U9 }), tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m19.002 9h-15v1h15", className: U9 }), tp.createElement("path", { d: "m11 17v-2h-2v-2h-2v2h-2v2h2v2h2v-2z", className: B9 }), tp.createElement("path", { d: "m21 20.5v-4.5h-.5-8.5v1h8v3.5c0 .551.051.5-.5.5h-16c-.551 0-.5.051-.5-.5v-3.5h1v-1h-.5-1.5v4.5c0 1.104.396 1.5 1.5 1.5h16c1.104 0 1.5-.396 1.5-1.5z", className: z9 }), tp.createElement("g", { className: W9 }, tp.createElement("path", { d: "m2 8h1v1h-1z" }), tp.createElement("path", { d: "m2 10h1v1h-1z" }), tp.createElement("path", { d: "m2 6h1v1h-1z" }), tp.createElement("path", { d: "m7 3h1v1h-1z" }), tp.createElement("path", { d: "m5 3h1v1h-1z" }), tp.createElement("path", { d: "m11 3h1v1h-1z" }), tp.createElement("path", { d: "m3 5h-1v-1-1h1 1v1h-1z" }), tp.createElement("path", { d: "m20 4h-1v-1h1 1v1 1h-1z" }), tp.createElement("path", { d: "m9 3h1v1h-1z" }), tp.createElement("path", { d: "m13 3h1v1h-1z" }), tp.createElement("path", { d: "m17 3h1v1h-1z" }), tp.createElement("path", { d: "m15 3h1v1h-1z" }), tp.createElement("path", { d: "m2 12h1v1h-1z" }), tp.createElement("path", { d: "m2 14h1v1h-1z" }), tp.createElement("path", { d: "m20 8h1v1h-1z" }), tp.createElement("path", { d: "m20 10h1v1h-1z" }), tp.createElement("path", { d: "m20 6h1v1h-1z" }), tp.createElement("path", { d: "m20 12h1v1h-1z" }), tp.createElement("path", { d: "m20 14h1v1h-1z" }), tp.createElement("path", { d: "m12 14h1v1h-1z" }), tp.createElement("path", { d: "m14 14h1v1h-1z" }), tp.createElement("path", { d: "m18 14h1v1h-1z" }), tp.createElement("path", { d: "m16 14h1v1h-1z" })));
const KJe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m21.001 15.002v-12h-19l-.001 11.998h2v-1h8v1z", className: V9 }), tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m19 9h-15v1h15", className: R9 }), tp.createElement("path", { d: "m20 21v-4h-8v1h-8v-1h-1v4z", className: R9 }), tp.createElement("path", { d: "m5 15h6v2h-6z", className: A9 }), tp.createElement("path", { d: "m21 20.5v-4.5h-.5-8.5v1h8v3.5c0 .551.051.5-.5.5h-16c-.551 0-.5.051-.5-.5v-3.5h1v-1h-2v4.5c0 1.104.396 1.5 1.5 1.5h16c1.104 0 1.5-.396 1.5-1.5z", className: z9 }), tp.createElement("g", { className: $9 }, tp.createElement("path", { d: "m2 8h1v1h-1z" }), tp.createElement("path", { d: "m2 10h1v1h-1z" }), tp.createElement("path", { d: "m2 6h1v1h-1z" }), tp.createElement("path", { d: "m7 3h1v1h-1z" }), tp.createElement("path", { d: "m5 3h1v1h-1z" }), tp.createElement("path", { d: "m11 3h1v1h-1z" }), tp.createElement("path", { d: "m3 5h-1v-2h2v1h-1z" }), tp.createElement("path", { d: "m20 4h-1v-1h2v2h-1z" }), tp.createElement("path", { d: "m9 3h1v1h-1z" }), tp.createElement("path", { d: "m13 3h1v1h-1z" }), tp.createElement("path", { d: "m17 3h1v1h-1z" }), tp.createElement("path", { d: "m15 3h1v1h-1z" }), tp.createElement("path", { d: "m2 12h1v1h-1z" }), tp.createElement("path", { d: "m2 14h1v1h-1z" }), tp.createElement("path", { d: "m20 8h1v1h-1z" }), tp.createElement("path", { d: "m20 10h1v1h-1z" }), tp.createElement("path", { d: "m20 6h1v1h-1z" }), tp.createElement("path", { d: "m20 12h1v1h-1z" }), tp.createElement("path", { d: "m20 14h1v1h-1z" }), tp.createElement("path", { d: "m12 14h1v1h-1z" }), tp.createElement("path", { d: "m14 14h1v1h-1z" }), tp.createElement("path", { d: "m18 14h1v1h-1z" }), tp.createElement("path", { d: "m16 14h1v1h-1z" })));
const XJe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m12.002 9.998v1h-2v2h-4v-2h-2v-1h-2v12h19v-12z", className: V9 }), tp.createElement("path", { d: "m3 4v4h1v-1h2v-2h4.001l-.001 2h2v1h8v-4z", className: U9 }), tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m19 15h-15v1h15", className: U9 }), tp.createElement("path", { d: "m9 8v-2h-2v2h-2v2h2v2h2v-2h2v-2z", className: B9 }), tp.createElement("path", { d: "m19.5 3h-16c-1.104 0-1.5.396-1.5 1.5v4.5h1.5.5v-1h-1v-3.5c0-.551-.051-.5.5-.5h16c .551 0 .5-.051.5.5v3.5h-8v1h8.5.5v-4.5c0-1.104-.396-1.5-1.5-1.5z", className: z9 }), tp.createElement("g", { className: W9 }, tp.createElement("path", { d: "m2 16h1v1h-1z" }), tp.createElement("path", { d: "m2 14h1v1h-1z" }), tp.createElement("path", { d: "m2 18h1v1h-1z" }), tp.createElement("path", { d: "m7 21h1v1h-1z" }), tp.createElement("path", { d: "m5 21h1v1h-1z" }), tp.createElement("path", { d: "m11 21h1v1h-1z" }), tp.createElement("path", { d: "m2 21h2v1h-2z" }), tp.createElement("path", { d: "m2 20h1v2h-1z" }), tp.createElement("path", { d: "m20 20h1v2h-1z" }), tp.createElement("path", { d: "m19 21h2v1h-2z" }), tp.createElement("path", { d: "m9 21h1v1h-1z" }), tp.createElement("path", { d: "m13 21h1v1h-1z" }), tp.createElement("path", { d: "m17 21h1v1h-1z" }), tp.createElement("path", { d: "m15 21h1v1h-1z" }), tp.createElement("path", { d: "m2 12h1v1h-1z" }), tp.createElement("path", { d: "m2 10h1v1h-1z" }), tp.createElement("path", { d: "m20 16h1v1h-1z" }), tp.createElement("path", { d: "m20 14h1v1h-1z" }), tp.createElement("path", { d: "m20 18h1v1h-1z" }), tp.createElement("path", { d: "m20 12h1v1h-1z" }), tp.createElement("path", { d: "m20 10h1v1h-1z" }), tp.createElement("path", { d: "m12 10h1v1h-1z" }), tp.createElement("path", { d: "m14 10h1v1h-1z" }), tp.createElement("path", { d: "m18 10h1v1h-1z" }), tp.createElement("path", { d: "m16 10h1v1h-1z" })));
const JJe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m12 10v1h-8v-1h-2l .001 11.998h19v-12z", className: V9 }), tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m19 15h-15v1h15", className: R9 }), tp.createElement("path", { d: "m3 4v4h1v-1h8v1h8v-4z", className: R9 }), tp.createElement("path", { d: "m5 8h6v2h-6z", className: A9 }), tp.createElement("path", { d: "m19.5 3h-16c-1.104 0-1.5.396-1.5 1.5v4.5h2v-1h-1v-3.5c0-.551-.051-.5.5-.5h16c .551 0 .5-.051.5.5v3.5h-8v1h8.5.5v-4.5c0-1.104-.396-1.5-1.5-1.5z", className: z9 }), tp.createElement("g", { className: $9 }, tp.createElement("path", { d: "m2 16h1v1h-1z" }), tp.createElement("path", { d: "m2 14h1v1h-1z" }), tp.createElement("path", { d: "m2 18h1v1h-1z" }), tp.createElement("path", { d: "m7 21h1v1h-1z" }), tp.createElement("path", { d: "m5 21h1v1h-1z" }), tp.createElement("path", { d: "m11 21h1v1h-1z" }), tp.createElement("path", { d: "m3 20h-1v2h2v-1h-1z" }), tp.createElement("path", { d: "m20 21h-1v1h2v-2h-1z" }), tp.createElement("path", { d: "m9 21h1v1h-1z" }), tp.createElement("path", { d: "m13 21h1v1h-1z" }), tp.createElement("path", { d: "m17 21h1v1h-1z" }), tp.createElement("path", { d: "m15 21h1v1h-1z" }), tp.createElement("path", { d: "m2 12h1v1h-1z" }), tp.createElement("path", { d: "m2 10h1v1h-1z" }), tp.createElement("path", { d: "m20 16h1v1h-1z" }), tp.createElement("path", { d: "m20 14h1v1h-1z" }), tp.createElement("path", { d: "m20 18h1v1h-1z" }), tp.createElement("path", { d: "m20 12h1v1h-1z" }), tp.createElement("path", { d: "m20 10h1v1h-1z" }), tp.createElement("path", { d: "m12 10h1v1h-1z" }), tp.createElement("path", { d: "m14 10h1v1h-1z" }), tp.createElement("path", { d: "m18 10h1v1h-1z" }), tp.createElement("path", { d: "m16 10h1v1h-1z" })));
const QJe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m10 5h3v15h-3z", className: R9 }), tp.createElement("path", { d: "m3 4v17h5v-17zm4 16h-3v-15h3zm2-16v17h5v-17zm4 16h-3v-15h3zm2-16v17h5v-17zm4 16h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3z", className: z9 }));
const eQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m5 17v-1h13v1zm0-8v-1h13v1zm0 4v-1h13v1z", className: z9 }), tp.createElement("path", { d: "m6 4h2v1h-2zm3 1h2v-1h-2zm3 0h2v-1h-2zm3 0h2v-1h-2zm-9 16h2v-1h-2zm3 0h2v-1h-2zm3 0h2v-1h-2zm3 0h2v-1h-2zm-12-3h1v-2h-1zm0-3h1v-2h-1zm1 5v-1h-1v1 1h1 1v-1zm-1-8h1v-2h-1zm0-3h1v-2h-1zm2-5h-1-1v1 1h1v-1h1zm14 14h1v-2h-1zm0-3h1v-2h-1zm0 5h-1v1h1 1v-1-1h-1zm0-8h1v-2h-1zm0-3h1v-2h-1zm0-5h-1v1h1v1h1v-1-1z", className: A9 }));
const tQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m19 3h-15c-1.104 0-2 .896-2 2v15c0 1.105.896 2 2 2h15c1.104 0 2-.895 2-2v-15c0-1.104-.896-2-2-2z", className: V9 }), tp.createElement("path", { d: "m3 4v4h1v-1h2v-2h4.001l-.001 2h2v1h8v-4z", className: Z9 }), tp.createElement("path", { d: "m19 14h-15v1h15", className: $9 }), tp.createElement("path", { d: "m19 3h-15c-1.104 0-2 .896-2 2v15c0 1.105.896 2 2 2h15c1.104 0 2-.895 2-2v-15c0-1.104-.896-2-2-2zm1 5.002h-8v1h8v10.998c0 .553-.449 1-1 1h-15c-.551 0-1-.447-1-1v-10.998h1v-1h-1v-3.002c0-.551.449-1 1-1h15c .551 0 1 .449 1 1z", className: z9 }), tp.createElement("path", { d: "m9 8v-2h-2v2h-2v2h2v2h2v-2h2v-2z", className: A9 }));
const nQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m19 3h-15c-1.104 0-2 .896-2 2v15c0 1.105.896 2 2 2h15c1.104 0 2-.895 2-2v-15c0-1.104-.896-2-2-2z", className: V9 }), tp.createElement("path", { d: "m3 4v4h1v-1h8v1h8v-4z", className: Z9 }), tp.createElement("path", { d: "m19 14h-15v1h15", className: $9 }), tp.createElement("path", { d: "m19 3h-15c-1.104 0-2 .896-2 2v15c0 1.105.896 2 2 2h15c1.104 0 2-.895 2-2v-15c0-1.104-.896-2-2-2zm1 5.002h-8v1h8v10.998c0 .553-.449 1-1 1h-15c-.551 0-1-.447-1-1v-10.998h1v-1h-1v-3.002c0-.551.449-1 1-1h15c .551 0 1 .449 1 1z", className: z9 }), tp.createElement("path", { d: "m5 8v2h6v-2z", className: A9 }));
tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", className: _9 }), tp.createElement("rect", { x: "6", y: "6", width: "3", height: "7", className: z9 }), tp.createElement("rect", { x: "10", y: "4", width: "3", height: "9", className: Z9 }), tp.createElement("path", { d: "M0,0V24H24V0Z", className: _9 }), tp.createElement("rect", { x: "14", y: "5", width: "3", height: "6", className: A9 }), tp.createElement("polygon", { points: "5 14 5 13 4 13 4 14 4 15 4 15 14 15 14 14 5 14", className: A9 }), tp.createElement("path", { d: "M6,18.5v2a.5.5,0,0,0,.5.5h10a.5.5,0,0,0,.5-.5V19H14V18H6.5A.5.5,0,0,0,6,18.5Z", className: V9 }), tp.createElement("path", { d: "M17,20.5a.5.5,0,0,1-.5.5H6.5a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5H14V17H6.5A1.5,1.5,0,0,0,5,18.5v2A1.5,1.5,0,0,0,6.5,22h10A1.5,1.5,0,0,0,18,20.5V19H17Z", className: R9 }), tp.createElement("polygon", { points: "21 16 21 14 19 14 19 12 17 12 17 14 15 14 15 16 17 16 17 18 19 18 19 16 21 16", className: A9 })), tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", className: _9 }), tp.createElement("path", { d: "M0,0V24H24V0Z", className: _9 }), tp.createElement("path", { d: "M18,10H10a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V12a2,2,0,0,0-2-2Z", className: V9 }), tp.createElement("path", { d: "M3,14.92v.77c0,.77,1.44,1.44,4,1.74V14.74A9.66,9.66,0,0,1,3.73,14C3.27,14.27,3,14.59,3,14.92Z", className: R9 }), tp.createElement("path", { d: "M15,6.82C15,5.81,12.31,5,9,5S3,5.81,3,6.82v.36C3,8.19,5.69,9,9,9s6-.81,6-1.82Z", className: R9 }), tp.createElement("path", { d: "M3.73,10c-.47.27-.73.58-.73.92v.77c0,.77,1.44,1.44,4,1.74V10.74A9.64,9.64,0,0,1,3.73,10Z", className: R9 }), tp.createElement("path", { d: "M0,0V24H24V0Z", className: _9 }), tp.createElement("path", { d: "M9,12v6a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V17H14V11H10A1,1,0,0,0,9,12Z", className: _9 }), tp.createElement("path", { d: "M19,18a1,1,0,0,1-1,1H10a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1h4V10H10a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V17H19Z", className: z9 }), tp.createElement("polygon", { points: "13 13 13 12 10 12 10 13 11 13 11 17 10 17 10 18 13 18 13 17 12 17 12 13 13 13", className: $9 }), tp.createElement("polygon", { points: "21 14 21 12 19 12 19 10 17 10 17 12 15 12 15 14 17 14 17 16 19 16 19 14 21 14", className: A9 })), tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M20,10V7a2,2,0,0,0-2-2H6A2,2,0,0,0,4,7v3Z", className: V9 }), tp.createElement("polygon", { points: "15 18 15 16 13 16 13 14 11 14 11 16 9 16 9 18 11 18 11 20 13 20 13 18 15 18", className: A9 }), tp.createElement("path", { d: "M0,0V24H24V0Z", className: _9 }), tp.createElement("path", { d: "M0,0V24H24V0Z", className: _9 }), tp.createElement("path", { d: "M5,7A1,1,0,0,1,6,6H18a1,1,0,0,1,1,1v3h1V7a2,2,0,0,0-2-2H6A2,2,0,0,0,4,7v3H5Z", className: R9 }), tp.createElement("path", { d: "M6,19a1,1,0,0,1-1-1V13H4v5a2,2,0,0,0,2,2H8V19Z", className: z9 }), tp.createElement("path", { d: "M19,13v5a1,1,0,0,1-1,1H16v1h2a2,2,0,0,0,2-2V13Z", className: z9 }), tp.createElement("rect", { x: "2", y: "11", width: "2", height: "1", className: O9 }), tp.createElement("rect", { x: "5", y: "11", width: "2", height: "1", className: O9 }), tp.createElement("rect", { x: "8", y: "11", width: "2", height: "1", className: O9 }), tp.createElement("rect", { x: "11", y: "11", width: "2", height: "1", className: O9 }), tp.createElement("rect", { x: "14", y: "11", width: "2", height: "1", className: O9 }), tp.createElement("rect", { x: "17", y: "11", width: "2", height: "1", className: O9 }), tp.createElement("rect", { x: "20", y: "11", width: "2", height: "1", className: O9 })), tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M4,15v3a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V15Z", className: V9 }), tp.createElement("polygon", { points: "9 7 9 9 11 9 11 11 13 11 13 9 15 9 15 7 13 7 13 5 11 5 11 7 9 7", className: A9 }), tp.createElement("path", { d: "M24,24V0H0V24Z", className: _9 }), tp.createElement("path", { d: "M24,24V0H0V24Z", className: _9 }), tp.createElement("path", { d: "M19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V15H4v3a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V15H19Z", className: R9 }), tp.createElement("path", { d: "M18,6a1,1,0,0,1,1,1v5h1V7a2,2,0,0,0-2-2H16V6Z", className: z9 }), tp.createElement("path", { d: "M5,12V7A1,1,0,0,1,6,6H8V5H6A2,2,0,0,0,4,7v5Z", className: z9 }), tp.createElement("rect", { x: "20", y: "13", width: "2", height: "1", className: O9 }), tp.createElement("rect", { x: "17", y: "13", width: "2", height: "1", className: O9 }), tp.createElement("rect", { x: "14", y: "13", width: "2", height: "1", className: O9 }), tp.createElement("rect", { x: "11", y: "13", width: "2", height: "1", className: O9 }), tp.createElement("rect", { x: "8", y: "13", width: "2", height: "1", className: O9 }), tp.createElement("rect", { x: "5", y: "13", width: "2", height: "1", className: O9 }), tp.createElement("rect", { x: "2", y: "13", width: "2", height: "1", className: O9 })), tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", className: _9 }), tp.createElement("path", { d: "M0,0V24H24V0Z", className: _9 }), tp.createElement("path", { d: "M8,11.5l-3-3,3-3V8h7.5A1.5,1.5,0,0,1,17,9.5v6A1.5,1.5,0,0,1,15.5,17H6V16h9.5a.5.5,0,0,0,.5-.5v-6a.5.5,0,0,0-.5-.5H8v2.5Z", className: A9 })), tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", className: _9 }), tp.createElement("path", { d: "M0,0V24H24V0Z", className: _9 }), tp.createElement("path", { d: "M14,13.5l3,3-3,3V17H6.5A1.5,1.5,0,0,1,5,15.5v-6A1.5,1.5,0,0,1,6.5,8H16V9H6.5a.5.5,0,0,0-.5.5v6a.5.5,0,0,0,.5.5H14V13.5Z", className: A9 })), tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", className: _9 }), tp.createElement("rect", { x: "6", y: "6", width: "3", height: "7", className: z9 }), tp.createElement("path", { d: "M0,0V24H24V0Z", className: _9 }), tp.createElement("rect", { x: "10", y: "4", width: "3", height: "9", className: z9 }), tp.createElement("rect", { x: "14", y: "5", width: "3", height: "6", className: z9 }), tp.createElement("polygon", { points: "5 14 5 13 4 13 4 14 4 15 4 15 14 15 14 14 5 14", className: A9 }), tp.createElement("path", { d: "M6,18.5v2a.5.5,0,0,0,.5.5h10a.5.5,0,0,0,.5-.5V19H14V18H6.5A.5.5,0,0,0,6,18.5Z", className: V9 }), tp.createElement("path", { d: "M17,20.5a.5.5,0,0,1-.5.5H6.5a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5H14V17H6.5A1.5,1.5,0,0,0,5,18.5v2A1.5,1.5,0,0,0,6.5,22h10A1.5,1.5,0,0,0,18,20.5V19H17Z", className: R9 }), tp.createElement("polygon", { points: "21 16 21 14 19 14 19 12 17 12 17 14 15 14 15 16 17 16 17 18 19 18 19 16 21 16", className: A9 })), tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("polygon", { points: "9 8 19 8 19 18 9 18 9 15 7 13 9 11 9 8", className: A9 }), tp.createElement("path", { d: "M0,0V24H24V0Z", className: _9 }), tp.createElement("rect", { x: "4", y: "15", width: "1", height: "2", className: j9 }), tp.createElement("rect", { x: "4", y: "12", width: "1", height: "2", className: j9 }), tp.createElement("rect", { x: "4", y: "9", width: "1", height: "2", className: j9 }), tp.createElement("rect", { x: "4", y: "6", width: "1", height: "2", className: j9 }), tp.createElement("rect", { x: "4", y: "18", width: "1", height: "2", className: j9 }), tp.createElement("path", { d: "M0,0V24H24V0Z", className: _9 }), tp.createElement("polygon", { points: "17 14 17 12 15 12 15 10 13 10 13 12 11 12 11 14 13 14 13 16 15 16 15 14 17 14", className: V9 }));
const rQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: q9, d: "M3 10h5v11H3z", opacity: ".7" }), tp.createElement("path", { className: K9, d: "M9 4h5v17H9z" }), tp.createElement("path", { className: "wd-toolbox-icon--main-accent", d: "M15 7h5v14h-5z" }));
const oQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: V9, d: "M5 21h13c.553 0 1-.447 1-1V5c0-.554-.447-1-1-1H5c-.553 0-1 .446-1 1v15c0 .553.447 1 1 1z" }), tp.createElement("path", { className: q9, d: "M18 19v1H5v-1H4v1c0 .553.447 1 1 1h13c.553 0 1-.447 1-1v-1zM5 6V5h13v1h1V5c0-.553-.447-1-1-1H5c-.553 0-1 .447-1 1v1z" }), tp.createElement("path", { className: Y9, d: "M8 12h2v4H8z" }), tp.createElement("path", { className: K9, d: "M10.5 10h2v6h-2z" }), tp.createElement("g", { className: Y9 }, tp.createElement("path", { d: "M13 11h2v5h-2zM6 7h2v1H6zM9 7.001h2v1H9zM12 7.001h2v1h-2zM15 7.001h2v1h-2zM6 17h2v1H6zM9 17.001h2v1H9zM12 17.001h2v1h-2zM15 17.001h2v1h-2zM4 16h1v2H4zM4 13h1v2H4zM4 10h1v2H4zM4 7h1v2H4zM18 16h1v2h-1zM18 13h1v2h-1zM18 10h1v2h-1zM18 7h1v2h-1z" })));
const aQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m7 16h-3v-3h3zm4-3h-3v3h3zm4 0h-3v3h3zm4 0h-3v3h3zm-12 4h-3v3h3zm4 0h-3v3h3zm4 0h-3v3h3zm4 0h-3v3h3zm-12-8h-3v3h3zm4 0h-3v3h3zm4 0h-3v3h3zm4 0h-3v3h3zm-12-4h-3v3h3zm4 0h-3v3h3zm4 0h-3v3h3zm4 0h-3v3h3z", className: z9 }));
const iQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m3 4v17h17v-17zm9 1h3v3h-3zm-4 0h3v3h-3zm-4 0h3v3h-3zm0 8h3v3h-3zm3.066 7h-3v-3h3zm3.934 0h-3v-3h3zm0-4h-3v-3h3zm4 4h-3v-3h3zm0-4h-3v-3h3zm4 4h-3v-3h3zm0-4h-3v-3h3zm0-4h-15v-3h15zm0-4h-3v-3h3z", className: z9 }));
const sQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m3 4v17h17v-17zm1 1h7v3h-7zm7 15h-7v-3h7zm0-4h-7v-3h7zm8 4h-7v-3h7zm0-4h-7v-3h7zm0-4h-15v-3h15zm0-4h-7v-3h7z", className: z9 }), tp.createElement("path", { d: "m7 9h1v3h-1zm4 0h1v3h-1zm4 0h1v3h-1z", className: A9 }));
const lQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m20 4h-17v17h17zm-16 16v-15h3v15zm4 0v-15h3v15zm4 0v-15h3v15zm4 0v-15h3v15z", className: z9 }));
const cQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m3 4v17h17v-17zm4 16h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm4 12h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm4 12h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm4 12h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3z", className: z9 }), tp.createElement("path", { d: "m7 21v-17h5v17zm1-16v15h3v-15z", className: G9 }));
const uQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m3 21h17v-17h-17zm16-4v3h-3v-3zm-4 0v3h-3v-3zm-4 0v3h-3v-3zm-4 0v3h-3v-3zm12-4v3h-3v-3zm-4 0v3h-3v-3zm-4 0v3h-3v-3zm-4 0v3h-3v-3zm12-4v3h-3v-3zm-4 0v3h-3v-3zm-4 0v3h-3v-3zm-4 0v3h-3v-3zm12-4v3h-3v-3zm-4 0v3h-3v-3zm-4 0v3h-3v-3zm-4 0v3h-3v-3z", className: z9 }), tp.createElement("g", { className: R9 }, tp.createElement("path", { d: "m8 17h3v3h-3z" }), tp.createElement("path", { d: "m8 13h3v3h-3z" }), tp.createElement("path", { d: "m8 9h3v3h-3z" }), tp.createElement("path", { d: "m8 5h3v3h-3z" })));
const dQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m4 20v-3h1c0-.335 0-.668 0-1h-1v-3h1c0-.333 0-.667 0-1h-1v-3h1c0-.332 0-.665 0-1h-1v-3h1c0-.334 0-.66 0-1h-2v17h2c0-.34 0-.666 0-1z", className: z9 }), tp.createElement("path", { d: "m8 4v1h3v3h-3v1h3v3h-3v1h3v3h-3v1h3v3h-3v1h12v-17zm7 16h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm4 12h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3z", className: z9 }), tp.createElement("path", { d: "m8 17h3v3h-3zm0-4h3v3h-3zm0-4h3v3h-3zm0-4h3v3h-3z", className: R9 }), tp.createElement("path", { d: "m7 21h-1v-1h1zm0-2h-1v-1h1zm0-2h-1v-1h1zm0-2h-1v-1h1zm0-2h-1v-1h1zm0-2h-1v-1h1zm0-2h-1v-1h1zm0-2h-1v-1h1zm0-2h-1v-1h1z", className: j9 }));
const pQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("g", { className: R9 }, tp.createElement("path", { d: "m4 17h3v3h-3z" }), tp.createElement("path", { d: "m4 13h3v3h-3z" }), tp.createElement("path", { d: "m4 9h3v3h-3z" }), tp.createElement("path", { d: "m4 5h3v3h-3z" })), tp.createElement("path", { d: "m4 20v-3h3c0-.335 0-.668 0-1h-3v-3h3c0-.333 0-.667 0-1h-3v-3h3c0-.332 0-.665 0-1h-3v-3h3c0-.334 0-.66 0-1h-4v17h4c0-.34 0-.666 0-1z", className: z9 }), tp.createElement("path", { d: "m10 4v1h1v3h-1v1h1v3h-1v1h1v3h-1v1h1v3h-1v1h10v-17zm5 16h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm4 12h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3z", className: z9 }), tp.createElement("path", { d: "m9 21h-1v-1h1zm0-2h-1v-1h1zm0-2h-1v-1h1zm0-2h-1v-1h1zm0-2h-1v-1h1zm0-2h-1v-1h1zm0-2h-1v-1h1zm0-2h-1v-1h1zm0-2h-1v-1h1z", className: j9 }));
const mQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m20 3.999h-17v17h17zm-16 3.999v-3h3v3zm4 0v-3h3v3zm4 0v-3h3v3zm4 0v-3h3v3zm-12 4v-3h3v3zm4 0v-3h3v3zm4 0v-3h3v3zm4 0v-3h3v3zm-12 4v-3h3v3zm4 0v-3h3v3zm4 0v-3h3v3zm4 0v-3h3v3zm-12 4v-3h3v3zm4 0v-3h3v3zm4 0v-3h3v3zm4 0v-3h3v3z", className: z9 }), tp.createElement("g", { className: R9 }, tp.createElement("path", { d: "m12 4.998h3v3h-3z" }), tp.createElement("path", { d: "m12 8.998h3v3h-3z" }), tp.createElement("path", { d: "m12 12.998h3v3h-3z" }), tp.createElement("path", { d: "m12 16.998h3v3h-3z" })));
const hQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m19 5v3h-1v1h1v3h-1v1h1v3h-1v1h1v3h-1v1h2v-17h-2v1z", className: z9 }), tp.createElement("path", { d: "m15 21s0 0 0-1h-3v-3h3s0 0 0-1h-3v-3h3s0 0 0-1h-3v-3h3s0 0 0-1h-3v-3h3s0 0 0-1h-12v17zm-7-16h3v3h-3zm0 4h3v3h-3zm0 4h3v3h-3zm0 4h3v3h-3zm-4-12h3v3h-3zm0 4h3v3h-3zm0 4h3v3h-3zm0 4h3v3h-3z", className: z9 }), tp.createElement("g", { className: R9 }, tp.createElement("path", { d: "m12 5h3v3h-3z" }), tp.createElement("path", { d: "m12 9h3v3h-3z" }), tp.createElement("path", { d: "m12 13h3v3h-3z" }), tp.createElement("path", { d: "m12 17h3v3h-3z" })), tp.createElement("path", { d: "m16 4h1v1h-1zm0 2h1v1h-1zm0 2h1v1h-1zm0 2h1v1h-1zm0 2h1v1h-1zm0 2h1v1h-1zm0 2h1v1h-1zm0 2h1v1h-1zm0 2h1v1h-1z", className: j9 }));
const fQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("g", { className: R9 }, tp.createElement("path", { d: "m16 5h3v3h-3z" }), tp.createElement("path", { d: "m16 9h3v3h-3z" }), tp.createElement("path", { d: "m16 13h3v3h-3z" }), tp.createElement("path", { d: "m16 17h3v3h-3z" })), tp.createElement("path", { d: "m19 5v3h-3v1h3v3h-3v1h3v3h-3v1h3v3h-3v1h4v-17h-4v1z", className: z9 }), tp.createElement("path", { d: "m13 21s0 0 0-1h-1v-3h1s0 0 0-1h-1v-3h1s0 0 0-1h-1v-3h1s0 0 0-1h-1v-3h1s0 0 0-1h-10v17zm-5-16h3v3h-3zm0 4h3v3h-3zm0 4h3v3h-3zm0 4h3v3h-3zm-4-12h3v3h-3zm0 4h3v3h-3zm0 4h3v3h-3zm0 4h3v3h-3z", className: z9 }), tp.createElement("path", { d: "m14 4h1v1h-1zm0 2h1v1h-1zm0 2h1v1h-1zm0 2h1v1h-1zm0 2h1v1h-1zm0 2h1v1h-1zm0 2h1v1h-1zm0 2h1v1h-1zm0 2h1v1h-1z", className: j9 }));
tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m7 6h1v13h-1zm8 0h1v13h-1zm-4 0h1v13h-1z", className: z9 }), tp.createElement("path", { d: "m6 4h2v1h-2zm3 1h2v-1h-2zm3 0h2v-1h-2zm3 0h2v-1h-2zm-9 16h2v-1h-2zm3 0h2v-1h-2zm3 0h2v-1h-2zm3 0h2v-1h-2zm-12-3h1v-2h-1zm0-3h1v-2h-1zm1 5v-1h-1v1 1h1 1v-1zm-1-8h1v-2h-1zm0-3h1v-2h-1zm2-5h-1-1v1 1h1v-1h1zm14 14h1v-2h-1zm0-3h1v-2h-1zm0 5h-1v1h1 1v-1-1h-1zm0-8h1v-2h-1zm0-3h1v-2h-1zm0-5h-1v1h1v1h1v-1-1z", className: A9 }));
const gQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m5 17v-1h13v1zm0-8v-1h13v1zm0 4v-1h13v1z", className: z9 }), tp.createElement("path", { d: "m6 4h2v1h-2zm3 1h2v-1h-2zm3 0h2v-1h-2zm3 0h2v-1h-2zm-9 16h2v-1h-2zm3 0h2v-1h-2zm3 0h2v-1h-2zm3 0h2v-1h-2zm-12-3h1v-2h-1zm0-3h1v-2h-1zm1 5v-1h-1v1 1h1 1v-1zm-1-8h1v-2h-1zm0-3h1v-2h-1zm2-5h-1-1v1 1h1v-1h1zm14 14h1v-2h-1zm0-3h1v-2h-1zm0 5h-1v1h1 1v-1-1h-1zm0-8h1v-2h-1zm0-3h1v-2h-1zm0-5h-1v1h1v1h1v-1-1z", className: A9 }));
const yQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m4 11h15v3h-15z", className: R9 }), tp.createElement("g", { className: z9 }, tp.createElement("path", { d: "m20 4h-17v5h17zm-16 4v-3h15v3z" }), tp.createElement("path", { d: "m20 10h-17v5h17zm-16 4v-3h15v3z" }), tp.createElement("path", { d: "m20 16h-17v5h17zm-16 4v-3h3v3zm4 0v-3h3v3zm4 0v-3h3v3zm4 0v-3h3v3z" })));
const vQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m4 5h3v15h-3z", className: R9 }), tp.createElement("path", { d: "m3 4v17h5v-17zm4 16h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm4-4v17h9v-17zm4 16h-3v-3h3zm0-4h-3v-3h3zm4 4h-3v-3h3zm0-4h-3v-3h3zm0-4h-7v-3h7zm0-4h-7v-3h7z", className: z9 }));
const bQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m4 5h15v3h-15z", className: R9 }), tp.createElement("path", { d: "m3 4v5h17v-5zm16 4h-15v-3h15zm-16 4v9h17v-9zm4 8h-3v-3h3zm4 0h-3v-3h3zm4 0h-3v-3h3zm4 0h-3v-3h3zm0-4h-15v-3h15z", className: z9 }));
const SQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m16 5h3v15h-3z", className: R9 }), tp.createElement("path", { d: "m15 4v17h5v-17zm4 16h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3z", className: z9 }), tp.createElement("path", { d: "m3 4v17h9v-17zm4 16h-3v-3h3zm0-4h-3v-3h3zm4 4h-3v-3h3zm0-4h-3v-3h3zm0-4h-7v-3h7zm0-4h-7v-3h7z", className: z9 }));
const CQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m21 4h-19v11h19z", className: V9 }), tp.createElement("path", { d: "m14 17.714-.714-.714-1.786 1.786-1.785-1.786-.715.714 1.786 1.786-1.786 1.786.715.714 1.785-1.786 1.786 1.786.714-.714-1.785-1.786z", className: G9 }), tp.createElement("path", { d: "m9 6h-1v3h-4v1h4v3h1v-3.002l5 .002v3h1v-3h4v-1h-4v-3h-1v3h-5z", className: $9 }), tp.createElement("path", { d: "m21 15h-19v-11h19zm-18-1h17v-9h-17z", className: G9 }));
const xQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m16 8v-3h3v3zm-12 0v-3h3v3zm8 0v-3h3v3zm-4 0v-3h3v3z", className: R9 }), tp.createElement("path", { d: "m3 12v9h17v-9zm4 8h-3v-7h3zm4 0h-3v-7h3zm4 0h-3v-3h3zm0-4h-3v-3h3zm4 4h-3v-3h3zm0-4h-3v-3h3zm-16-12v5h17v-5zm4 4h-3v-3h3zm4 0h-3v-3h3zm4 0h-3v-3h3zm4 0h-3v-3h3z", className: z9 }));
const wQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m7 17v3h-3v-3zm12 0v3h-3v-3zm-8 0v3h-3v-3zm4 0v3h-3v-3z", className: R9 }), tp.createElement("path", { d: "m3 4v9h17v-9zm4 8h-3v-7h3zm4 0h-3v-7h3zm4 0h-3v-3h3zm0-4h-3v-3h3zm4 4h-3v-3h3zm0-4h-3v-3h3zm1 13v-5h-17v5zm-4-4h3v3h-3zm-4 0h3v3h-3zm-4 0h3v3h-3zm-4 0h3v3h-3z", className: z9 }));
const TQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m10 5h3v15h-3z", className: R9 }), tp.createElement("path", { d: "m3 4v17h5v-17zm4 16h-3v-15h3zm2-16v17h5v-17zm4 16h-3v-15h3zm2-16v17h5v-17zm4 16h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3z", className: z9 }));
const EQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m4 5h3v15h-3z", className: R9 }), tp.createElement("path", { d: "m3 4v17h5v-17zm4 16h-3v-15h3zm4-16v17h9v-17zm4 16h-3v-15h3zm4 0h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3z", className: z9 }));
const FQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m21 10.714-.714-.714-1.786 1.786-1.785-1.786-.715.714 1.786 1.786-1.786 1.786.715.714 1.785-1.786 1.786 1.786.714-.714-1.785-1.786z", className: G9 }), tp.createElement("path", { d: "m5 15v1h3v3h1v-3h3v-1h-3.002l.002-5h3v-1h-3v-3h-1v3h-3v1h3v5z", className: $9 }), tp.createElement("path", { d: "m14 4v17h-11v-17zm-1 16v-15h-9v15z", className: G9 }));
const MQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m3 4v17h17v-17zm4 16h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm4 12h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm4 12h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm4 12h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3z", className: z9 }), tp.createElement("path", { d: "m3 12v5h17v-5zm16 4h-3-1-3-1-3-1-3v-3h3 1 3 1 3 1 3z", className: "wd-icon-color-red-second" }));
const kQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m3 4v17h17v-17zm4 16h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm4 12h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm4 12h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm4 12h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3zm0-4h-3v-3h3z", className: z9 }), tp.createElement("path", { d: "m4 12v-3h3v3zm7 0v-3h-3v3zm4 0v-3h-3v3zm4 0v-3h-3v3z", className: R9 }));
const PQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m4 5h3v1h1v-1h3v1h1v-1h3v1h1v-1h3v1h1v-2h-17v2h1zm16 4s0 0-1 0v3h-3v-3s0 0-1 0v3h-3v-3s0 0-1 0v3h-3v-3s0 0-1 0v3h-3v-3s0 0-1 0v12h17zm-16 7v-3h3v3zm4 0v-3h3v3zm4 0v-3h3v3zm4 0v-3h3v3zm-12 4v-3h3v3zm4 0v-3h3v3zm4 0v-3h3v3zm4 0v-3h3v3z", className: z9 }), tp.createElement("path", { d: "m4 9h3v3h-3zm4 0h3v3h-3zm4 0h3v3h-3zm4 0h3v3h-3z", className: R9 }), tp.createElement("path", { d: "m3 8v-1h1v1zm2 0v-1h1v1zm2 0v-1h1v1zm2 0v-1h1v1zm2 0v-1h1v1zm2 0v-1h1v1zm2 0v-1h1v1zm2 0v-1h1v1zm2 0v-1h1v1z", className: j9 }));
const NQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m4 5h3v3h-3zm4 0h3v3h-3zm4 0h3v3h-3zm4 0h3v3h-3z", className: R9 }), tp.createElement("path", { d: "m4 5h3v3h1v-3h3v3h1v-3h3v3h1v-3h3v3h1v-4h-17v4h1zm16 6s0 0-1 0v1h-3v-1s0 0-1 0v1h-3v-1s0 0-1 0v1h-3v-1s0 0-1 0v1h-3v-1s0 0-1 0v10h17zm-16 5v-3h3v3zm4 0v-3h3v3zm4 0v-3h3v3zm4 0v-3h3v3zm-12 4v-3h3v3zm4 0v-3h3v3zm4 0v-3h3v3zm4 0v-3h3v3z", className: z9 }), tp.createElement("path", { d: "m3 10v-1h1v1zm2 0v-1h1v1zm2 0v-1h1v1zm2 0v-1h1v1zm2 0v-1h1v1zm2 0v-1h1v1zm2 0v-1h1v1zm2 0v-1h1v1zm2 0v-1h1v1z", className: j9 }));
const DQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m20 21v-17h-17v17zm-4-16h3v3h-3zm0 4h3v3h-3zm0 4h3v3h-3zm0 4h3v3h-3zm-4-12h3v3h-3zm0 4h3v3h-3zm0 4h3v3h-3zm0 4h3v3h-3zm-4-12h3v3h-3zm0 4h3v3h-3zm0 4h3v3h-3zm0 4h3v3h-3zm-4-12h3v3h-3zm0 4h3v3h-3zm0 4h3v3h-3zm0 4h3v3h-3z", className: z9 }), tp.createElement("path", { d: "m19 13v3h-3v-3zm-7 0v3h3v-3zm-4 0v3h3v-3zm-4 0v3h3v-3z", className: R9 }));
const LQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m19 20h-3v-1c-.335 0-.668 0-1 0v1h-3v-1c-.333 0-.667 0-1 0v1h-3v-1c-.332 0-.665 0-1 0v1h-3v-1c-.334 0-.66 0-1 0v2h17v-2c-.34 0-.666 0-1 0zm-16-4h1v-3h3v3h1v-3h3v3h1v-3h3v3h1v-3h3v3h1v-12h-17zm16-7v3h-3v-3zm-4 0v3h-3v-3zm-4 0v3h-3v-3zm-4 0v3h-3v-3zm12-4v3h-3v-3zm-4 0v3h-3v-3zm-4 0v3h-3v-3zm-4 0v3h-3v-3z", className: z9 }), tp.createElement("path", { d: "m16 13h3v3h-3zm-4 0h3v3h-3zm-4 0h3v3h-3zm-4 0h3v3h-3z", className: R9 }), tp.createElement("path", { d: "m20 17v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1z", className: j9 }));
const HQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m16 17h3v3h-3zm-4 0h3v3h-3zm-4 0h3v3h-3zm-4 0h3v3h-3z", className: R9 }), tp.createElement("path", { d: "m19 20h-3v-3c-.335 0-.668 0-1 0v3h-3v-3c-.333 0-.667 0-1 0v3h-3v-3c-.332 0-.665 0-1 0v3h-3v-3c-.334 0-.66 0-1 0v4h17v-4c-.34 0-.666 0-1 0zm-16-6h1v-1h3v1h1v-1h3v1h1v-1h3v1h1v-1h3v1h1v-10h-17zm16-5v3h-3v-3zm-4 0v3h-3v-3zm-4 0v3h-3v-3zm-4 0v3h-3v-3zm12-4v3h-3v-3zm-4 0v3h-3v-3zm-4 0v3h-3v-3zm-4 0v3h-3v-3z", className: z9 }), tp.createElement("path", { d: "m20 15v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1z", className: j9 }));
const IQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m3 4v17h17v-17zm16 16h-15v-3h15zm0-4h-15v-3h15zm0-4h-15v-3h15zm0-4h-15v-3h15z", className: z9 }));
const _Qe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m19 3h-15c-1.104 0-2 .896-2 2v15c0 1.105.896 2 2 2h15c1.104 0 2-.895 2-2v-15c0-1.104-.896-2-2-2z", className: V9 }), tp.createElement("path", { d: "m21 20v-15c0-1.105-.896-2-2-2h-15c-1.104 0-2 .895-2 2v15c0 1.104.896 2 2 2h15c1.104 0 2-.896 2-2zm-1 0c0 .551-.449 1-1 1h-15c-.551 0-1-.449-1-1v-15c0-.553.449-1 1-1h15c .551 0 1 .447 1 1z", className: z9 }), tp.createElement("path", { d: "m10 17v-2h-2v-2h-2v2h-2v2h2v2h2v-2z", className: A9 }), tp.createElement("path", { d: "m15 10h4v-1h-4v-4h-1v4h-5v-4h-1v4h-4v1h4v1h1v-1h5v5h-2v1h2v4h1v-4h4v-1h-4z", className: $9 }));
const VQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m19 3h-15c-1.104 0-2 .896-2 2v15c0 1.105.896 2 2 2h15c1.104 0 2-.895 2-2v-15c0-1.104-.896-2-2-2z", className: V9 }), tp.createElement("path", { d: "m21 20v-15c0-1.105-.896-2-2-2h-15c-1.104 0-2 .895-2 2v15c0 1.104.896 2 2 2h15c1.104 0 2-.896 2-2zm-1 0c0 .551-.449 1-1 1h-15c-.551 0-1-.449-1-1v-15c0-.553.449-1 1-1h15c .551 0 1 .447 1 1z", className: z9 }), tp.createElement("path", { d: "m10 17v-2h-6v2z", className: A9 }), tp.createElement("path", { d: "m15 10h4v-1h-4v-4h-1v4h-5v-4h-1v4h-4v1h4v3h1v-3h5v5h-2v1h2v4h1v-4h4v-1h-4z", className: $9 }));
const RQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m19 3h-15c-1.104 0-2 .896-2 2v15c0 1.105.896 2 2 2h15c1.104 0 2-.895 2-2v-15c0-1.104-.896-2-2-2z", className: V9 }), tp.createElement("path", { d: "m20 21v-4h-8v1h-2l .001 2h-4.001v-2h-2v-1h-1v4z", className: Z9 }), tp.createElement("path", { d: "m19 10h-4v-5h-1v5h-5v-5h-1v5h-4v1h4v1h1v-1h5v4h1v-4h4z", className: $9 }), tp.createElement("path", { d: "m21 20v-15c0-1.105-.896-2-2-2h-15c-1.104 0-2 .895-2 2v15c0 1.104.896 2 2 2h15c1.104 0 2-.896 2-2zm-1 0c0 .551-.449 1-1 1h-15c-.551 0-1-.449-1-1v-3.002h1v-1h-1v-10.998c0-.553.449-1 1-1h15c .551 0 1 .447 1 1v10.998h-8v1h8z", className: z9 }), tp.createElement("path", { d: "m11 17v-2h-2v-2h-2v2h-2v2h2v2h2v-2z", className: A9 }));
const AQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m4 22h15c1.104 0 2-.896 2-2v-15c0-1.105-.896-2-2-2h-15c-1.104 0-2 .895-2 2v15c0 1.104.896 2 2 2z", className: V9 }), tp.createElement("path", { d: "m20 21v-4h-8v1h-8v-1h-1v4z", className: Z9 }), tp.createElement("path", { d: "m19 10h-4v-5h-1v5h-5v-5h-1v5h-4v1h4v3h1v-3h5v4h1v-4h4z", className: $9 }), tp.createElement("path", { d: "m21 20v-15c0-1.105-.896-2-2-2h-15c-1.104 0-2 .895-2 2v15c0 1.104.896 2 2 2h15c1.104 0 2-.896 2-2zm-1 0c0 .551-.449 1-1 1h-15c-.551 0-1-.449-1-1v-3.002h1v-1h-1v-10.998c0-.553.449-1 1-1h15c .551 0 1 .447 1 1v10.998h-8v1h8z", className: z9 }), tp.createElement("path", { d: "m11 17v-2h-6v2z", className: A9 }));
const OQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m21.002 15.002v-12h-19v12h2v-1h2v-2h4v2h2v1z", className: V9 }), tp.createElement("path", { d: "m20 21v-4h-8v1h-2l .001 2h-4.001v-2h-2v-1h-1v4z", className: U9 }), tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m19.002 9h-4v-4h-1v4h-5v-4h-1v4h-4v1h4v1h1v-1h5v3h1v-3h4z", className: U9 }), tp.createElement("path", { d: "m11 17v-2h-2v-2h-2v2h-2v2h2v2h2v-2z", className: B9 }), tp.createElement("path", { d: "m21 20.5v-4.5h-.5-8.5v1h8v3.5c0 .551.051.5-.5.5h-16c-.551 0-.5.051-.5-.5v-3.5h1v-1h-.5-1.5v4.5c0 1.104.396 1.5 1.5 1.5h16c1.104 0 1.5-.396 1.5-1.5z", className: z9 }), tp.createElement("g", { className: W9 }, tp.createElement("path", { d: "m2 8h1v1h-1z" }), tp.createElement("path", { d: "m2 10h1v1h-1z" }), tp.createElement("path", { d: "m2 6h1v1h-1z" }), tp.createElement("path", { d: "m7 3h1v1h-1z" }), tp.createElement("path", { d: "m5 3h1v1h-1z" }), tp.createElement("path", { d: "m11 3h1v1h-1z" }), tp.createElement("path", { d: "m3 5h-1v-1-1h1 1v1h-1z" }), tp.createElement("path", { d: "m20 4h-1v-1h1 1v1 1h-1z" }), tp.createElement("path", { d: "m9 3h1v1h-1z" }), tp.createElement("path", { d: "m13 3h1v1h-1z" }), tp.createElement("path", { d: "m17 3h1v1h-1z" }), tp.createElement("path", { d: "m15 3h1v1h-1z" }), tp.createElement("path", { d: "m2 12h1v1h-1z" }), tp.createElement("path", { d: "m2 14h1v1h-1z" }), tp.createElement("path", { d: "m20 8h1v1h-1z" }), tp.createElement("path", { d: "m20 10h1v1h-1z" }), tp.createElement("path", { d: "m20 6h1v1h-1z" }), tp.createElement("path", { d: "m20 12h1v1h-1z" }), tp.createElement("path", { d: "m20 14h1v1h-1z" }), tp.createElement("path", { d: "m12 14h1v1h-1z" }), tp.createElement("path", { d: "m14 14h1v1h-1z" }), tp.createElement("path", { d: "m18 14h1v1h-1z" }), tp.createElement("path", { d: "m16 14h1v1h-1z" })));
const BQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m21.001 15.002v-12h-19l-.001 11.998h2v-1h8v1z", className: V9 }), tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m19 9h-4v-4h-1v4h-5v-4h-1v4h-4v1h4v3h1v-3h5v3h1v-3h4z", className: R9 }), tp.createElement("path", { d: "m20 21v-4h-8v1h-8v-1h-1v4z", className: R9 }), tp.createElement("path", { d: "m5 15h6v2h-6z", className: A9 }), tp.createElement("path", { d: "m21 20.5v-4.5h-.5-8.5v1h8v3.5c0 .551.051.5-.5.5h-16c-.551 0-.5.051-.5-.5v-3.5h1v-1h-2v4.5c0 1.104.396 1.5 1.5 1.5h16c1.104 0 1.5-.396 1.5-1.5z", className: z9 }), tp.createElement("g", { className: $9 }, tp.createElement("path", { d: "m2 8h1v1h-1z" }), tp.createElement("path", { d: "m2 10h1v1h-1z" }), tp.createElement("path", { d: "m2 6h1v1h-1z" }), tp.createElement("path", { d: "m7 3h1v1h-1z" }), tp.createElement("path", { d: "m5 3h1v1h-1z" }), tp.createElement("path", { d: "m11 3h1v1h-1z" }), tp.createElement("path", { d: "m3 5h-1v-2h2v1h-1z" }), tp.createElement("path", { d: "m20 4h-1v-1h2v2h-1z" }), tp.createElement("path", { d: "m9 3h1v1h-1z" }), tp.createElement("path", { d: "m13 3h1v1h-1z" }), tp.createElement("path", { d: "m17 3h1v1h-1z" }), tp.createElement("path", { d: "m15 3h1v1h-1z" }), tp.createElement("path", { d: "m2 12h1v1h-1z" }), tp.createElement("path", { d: "m2 14h1v1h-1z" }), tp.createElement("path", { d: "m20 8h1v1h-1z" }), tp.createElement("path", { d: "m20 10h1v1h-1z" }), tp.createElement("path", { d: "m20 6h1v1h-1z" }), tp.createElement("path", { d: "m20 12h1v1h-1z" }), tp.createElement("path", { d: "m20 14h1v1h-1z" }), tp.createElement("path", { d: "m12 14h1v1h-1z" }), tp.createElement("path", { d: "m14 14h1v1h-1z" }), tp.createElement("path", { d: "m18 14h1v1h-1z" }), tp.createElement("path", { d: "m16 14h1v1h-1z" })));
const zQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m12.002 9.998v1h-2v2h-4v-2h-2v-1h-2v12h19v-12z", className: V9 }), tp.createElement("path", { d: "m3 4v4h1v-1h2v-2h4.001l-.001 2h2v1h8v-4z", className: U9 }), tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m19 15h-4v-3h-1v3h-5v-1h-1v1h-4v1h4v4h1v-4h5v4h1v-4h4z", className: U9 }), tp.createElement("path", { d: "m9 8v-2h-2v2h-2v2h2v2h2v-2h2v-2z", className: B9 }), tp.createElement("path", { d: "m19.5 3h-16c-1.104 0-1.5.396-1.5 1.5v4.5h1.5.5v-1h-1v-3.5c0-.551-.051-.5.5-.5h16c .551 0 .5-.051.5.5v3.5h-8v1h8.5.5v-4.5c0-1.104-.396-1.5-1.5-1.5z", className: z9 }), tp.createElement("g", { className: W9 }, tp.createElement("path", { d: "m2 16h1v1h-1z" }), tp.createElement("path", { d: "m2 14h1v1h-1z" }), tp.createElement("path", { d: "m2 18h1v1h-1z" }), tp.createElement("path", { d: "m7 21h1v1h-1z" }), tp.createElement("path", { d: "m5 21h1v1h-1z" }), tp.createElement("path", { d: "m11 21h1v1h-1z" }), tp.createElement("path", { d: "m2 21h2v1h-2z" }), tp.createElement("path", { d: "m2 20h1v2h-1z" }), tp.createElement("path", { d: "m20 20h1v2h-1z" }), tp.createElement("path", { d: "m19 21h2v1h-2z" }), tp.createElement("path", { d: "m9 21h1v1h-1z" }), tp.createElement("path", { d: "m13 21h1v1h-1z" }), tp.createElement("path", { d: "m17 21h1v1h-1z" }), tp.createElement("path", { d: "m15 21h1v1h-1z" }), tp.createElement("path", { d: "m2 12h1v1h-1z" }), tp.createElement("path", { d: "m2 10h1v1h-1z" }), tp.createElement("path", { d: "m20 16h1v1h-1z" }), tp.createElement("path", { d: "m20 14h1v1h-1z" }), tp.createElement("path", { d: "m20 18h1v1h-1z" }), tp.createElement("path", { d: "m20 12h1v1h-1z" }), tp.createElement("path", { d: "m20 10h1v1h-1z" }), tp.createElement("path", { d: "m12 10h1v1h-1z" }), tp.createElement("path", { d: "m14 10h1v1h-1z" }), tp.createElement("path", { d: "m18 10h1v1h-1z" }), tp.createElement("path", { d: "m16 10h1v1h-1z" })));
const $Qe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m12 10v1h-8v-1h-2l .001 11.998h19v-12z", className: V9 }), tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m19 15h-4v-3h-1v3h-5v-3h-1v3h-4v1h4v4h1v-4h5v4h1v-4h4z", className: R9 }), tp.createElement("path", { d: "m3 4v4h1v-1h8v1h8v-4z", className: R9 }), tp.createElement("path", { d: "m5 8h6v2h-6z", className: A9 }), tp.createElement("path", { d: "m19.5 3h-16c-1.104 0-1.5.396-1.5 1.5v4.5h2v-1h-1v-3.5c0-.551-.051-.5.5-.5h16c .551 0 .5-.051.5.5v3.5h-8v1h8.5.5v-4.5c0-1.104-.396-1.5-1.5-1.5z", className: z9 }), tp.createElement("g", { className: $9 }, tp.createElement("path", { d: "m2 16h1v1h-1z" }), tp.createElement("path", { d: "m2 14h1v1h-1z" }), tp.createElement("path", { d: "m2 18h1v1h-1z" }), tp.createElement("path", { d: "m7 21h1v1h-1z" }), tp.createElement("path", { d: "m5 21h1v1h-1z" }), tp.createElement("path", { d: "m11 21h1v1h-1z" }), tp.createElement("path", { d: "m3 20h-1v2h2v-1h-1z" }), tp.createElement("path", { d: "m20 21h-1v1h2v-2h-1z" }), tp.createElement("path", { d: "m9 21h1v1h-1z" }), tp.createElement("path", { d: "m13 21h1v1h-1z" }), tp.createElement("path", { d: "m17 21h1v1h-1z" }), tp.createElement("path", { d: "m15 21h1v1h-1z" }), tp.createElement("path", { d: "m2 12h1v1h-1z" }), tp.createElement("path", { d: "m2 10h1v1h-1z" }), tp.createElement("path", { d: "m20 16h1v1h-1z" }), tp.createElement("path", { d: "m20 14h1v1h-1z" }), tp.createElement("path", { d: "m20 18h1v1h-1z" }), tp.createElement("path", { d: "m20 12h1v1h-1z" }), tp.createElement("path", { d: "m20 10h1v1h-1z" }), tp.createElement("path", { d: "m12 10h1v1h-1z" }), tp.createElement("path", { d: "m14 10h1v1h-1z" }), tp.createElement("path", { d: "m18 10h1v1h-1z" }), tp.createElement("path", { d: "m16 10h1v1h-1z" })));
const WQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m19 3h-15c-1.104 0-2 .896-2 2v15c0 1.105.896 2 2 2h15c1.104 0 2-.895 2-2v-15c0-1.104-.896-2-2-2z", className: V9 }), tp.createElement("path", { d: "m3 4v4h1v-1h2v-2h4.001l-.001 2h2v1h8v-4z", className: Z9 }), tp.createElement("path", { d: "m19 14h-4v-4h-1v4h-5v-1h-1v1h-4v1h4v5h1v-5h5v5h1v-5h4z", className: $9 }), tp.createElement("path", { d: "m19 3h-15c-1.104 0-2 .896-2 2v15c0 1.105.896 2 2 2h15c1.104 0 2-.895 2-2v-15c0-1.104-.896-2-2-2zm1 5.002h-8v1h8v10.998c0 .553-.449 1-1 1h-15c-.551 0-1-.447-1-1v-10.998h1v-1h-1v-3.002c0-.551.449-1 1-1h15c .551 0 1 .449 1 1z", className: z9 }), tp.createElement("path", { d: "m9 8v-2h-2v2h-2v2h2v2h2v-2h2v-2z", fill: "#1c7cdc" }));
const jQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0h24v24h-24z", className: _9 }), tp.createElement("path", { d: "m19 3h-15c-1.104 0-2 .896-2 2v15c0 1.105.896 2 2 2h15c1.104 0 2-.895 2-2v-15c0-1.104-.896-2-2-2z", className: V9 }), tp.createElement("path", { d: "m3 4v4h1v-1h8v1h8v-4z", className: Z9 }), tp.createElement("path", { d: "m19 14h-4v-4h-1v4h-5v-3h-1v3h-4v1h4v5h1v-5h5v5h1v-5h4z", className: $9 }), tp.createElement("path", { d: "m19 3h-15c-1.104 0-2 .896-2 2v15c0 1.105.896 2 2 2h15c1.104 0 2-.895 2-2v-15c0-1.104-.896-2-2-2zm1 5.002h-8v1h8v10.998c0 .553-.449 1-1 1h-15c-.551 0-1-.447-1-1v-10.998h1v-1h-1v-3.002c0-.551.449-1 1-1h15c .551 0 1 .449 1 1z", className: z9 }), tp.createElement("path", { d: "m5 8v2h6v-2z", fill: "#1c7cdc" }));
const ZQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m17 5h-11c-1.104 0-2 .896-2 2v11c0 1.105.896 2 2 2h11c1.104 0 2-.895 2-2v-11c0-1.104-.896-2-2-2z", className: V9 }), tp.createElement("path", { d: "m17 6c .551 0 1 .449 1 1v11c0 .553-.449 1-1 1h-11c-.551 0-1-.447-1-1v-11c0-.551.449-1 1-1zm0-1h-11c-1.104 0-2 .896-2 2v11c0 1.105.896 2 2 2h11c1.104 0 2-.895 2-2v-11c0-1.104-.896-2-2-2z", className: z9 }), tp.createElement("g", { className: G9 }, tp.createElement("path", { d: "m6 12h11v1h-11z" })));
const GQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m17 5h-11c-1.104 0-2 .896-2 2v11c0 1.105.896 2 2 2h11c1.104 0 2-.895 2-2v-11c0-1.104-.896-2-2-2z", className: V9 }), tp.createElement("path", { d: "m17 6c .551 0 1 .449 1 1v11c0 .553-.449 1-1 1h-11c-.551 0-1-.447-1-1v-11c0-.551.449-1 1-1zm0-1h-11c-1.104 0-2 .896-2 2v11c0 1.105.896 2 2 2h11c1.104 0 2-.895 2-2v-11c0-1.104-.896-2-2-2z", className: z9 }), tp.createElement("g", { className: A9 }, tp.createElement("path", { d: "m6 12h11v1h-11z" }), tp.createElement("path", { d: "m11 7h1v11h-1z" })));
const UQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m4 5h7v15h-7z", className: R9 }), tp.createElement("path", { d: "m3 4v17h17v-17zm4 16h-3v-3h3zm0-4h-3v-3h3zm4 4h-3v-3h3zm0-4h-3v-3h3zm0-4h-7v-3h7zm0-4h-7v-3h7zm4 12h-3v-3h3zm0-4h-3v-3h3zm4 4h-3v-3h3zm0-4h-3v-3h3zm0-4h-7v-3h7zm0-4h-7v-3h7z", className: z9 }));
const qQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m12 5h7v15h-7z", className: R9 }), tp.createElement("path", { d: "m3 4v17h17v-17zm4 16h-3v-3h3zm0-4h-3v-3h3zm4 4h-3v-3h3zm0-4h-3v-3h3zm0-4h-7v-3h7zm0-4h-7v-3h7zm4 12h-3v-3h3zm0-4h-3v-3h3zm4 4h-3v-3h3zm0-4h-3v-3h3zm0-4h-7v-3h7zm0-4h-7v-3h7z", className: z9 }));
const YQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m4 5h15v7h-15z", className: R9 }), tp.createElement("path", { d: "m3 21h17v-17h-17zm16-4v3h-3v-3zm-4 0v3h-3v-3zm4-4v3h-3v-3zm-4 0v3h-3v-3zm-4 0v7h-3v-7zm-4 0v7h-3v-7zm12-4v3h-3v-3zm-4 0v3h-3v-3zm4-4v3h-3v-3zm-4 0v3h-3v-3zm-4 0v7h-3v-7zm-4 0v7h-3v-7z", className: z9 }));
const KQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m4 13h15v7h-15z", className: R9 }), tp.createElement("path", { d: "m3 21h17v-17h-17zm16-4v3h-3v-3zm-4 0v3h-3v-3zm4-4v3h-3v-3zm-4 0v3h-3v-3zm-4 0v7h-3v-7zm-4 0v7h-3v-7zm12-4v3h-3v-3zm-4 0v3h-3v-3zm4-4v3h-3v-3zm-4 0v3h-3v-3zm-4 0v7h-3v-7zm-4 0v7h-3v-7z", className: z9 }));
const XQe = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: _9 }), tp.createElement("path", { d: "m4 16.999h15v3h-15z", className: R9 }), tp.createElement("path", { d: "m20 13v-9h-17v9zm-4-8h3v3h-3zm0 4h3v3h-3zm-4-4h3v3h-3zm0 4h3v3h-3zm-4-4h3v3h-3zm0 4h3v3h-3zm-4-4h3v3h-3zm0 4h3v3h-3zm-1 7v5h17v-5zm4 4h-3v-3h3zm4 0h-3v-3h3zm4 0h-3v-3h3zm4 0h-3v-3h3z", className: z9 }), tp.createElement("path", { d: "m21 14v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1z", className: A9 }));
const JQe = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M5.919 2.228c-.15-.232-.46-.298-.691-.147-.232.15-.298.46-.147.691l4.323 6.657-1.923 2.961.779.637 1.74-2.68 1.74 2.68.779-.637-6.6-10.162Zm5.273 6.283-.596-.918 3.485-5.365c.15-.232.46-.298.691-.147.232.15.298.46.147.691l-3.727 5.739Z" }), tp.createElement("path", { className: Km.accent, d: "M6 12c1.656 0 3 1.344 3 3s-1.344 3-3 3-3-1.344-3-3 1.344-3 3-3Zm0 .974c-1.118 0-2.026.908-2.026 2.026 0 1.118.908 2.026 2.026 2.026 1.118 0 2.026-.908 2.026-2.026 0-1.118-.908-2.026-2.026-2.026ZM14 12c1.656 0 3 1.344 3 3s-1.344 3-3 3-3-1.344-3-3 1.344-3 3-3Zm0 .974c-1.118 0-2.026.908-2.026 2.026 0 1.118.908 2.026 2.026 2.026 1.118 0 2.026-.908 2.026-2.026 0-1.118-.908-2.026-2.026-2.026Z" }));
const QQe = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M8 2c-1.105 0-2 .895-2 2v10c0 1.105.895 2 2 2h6c1.105 0 2-.895 2-2V4c0-1.105-.895-2-2-2H8ZM7 4c0-.552.448-1 1-1h6c.552 0 1 .448 1 1v10c0 .552-.448 1-1 1H8c-.552 0-1-.448-1-1V4Z" }), tp.createElement("path", { className: Km.accent, d: "M4 6c0-.74.402-1.387 1-1.732V14.5C5 15.881 6.119 17 7.5 17h6.232c-.345.598-.992 1-1.732 1H7.5C5.567 18 4 16.433 4 14.5V6Z" }));
const e1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M10.5 7C9.672 7 9 7.672 9 8.5v8c0 .828.672 1.5 1.5 1.5h5c.828 0 1.5-.672 1.5-1.5v-8c0-.828-.672-1.5-1.5-1.5h-5ZM10 8.5c0-.276.224-.5.5-.5h5c.276 0 .5.224.5.5v8c0 .276-.224.5-.5.5h-5c-.276 0-.5-.224-.5-.5v-8Z" }), tp.createElement("path", { className: Km.accent, d: "M4.5 4h1.585c.206.583.762 1 1.415 1h3c.653 0 1.209-.417 1.415-1H13.5c.276 0 .5.224.5.5v1c0 .276.224.5.5.5s.5-.224.5-.5v-1c0-.828-.672-1.5-1.5-1.5h-1.585c-.206-.583-.762-1-1.415-1h-3c-.653 0-1.209.417-1.415 1H4.5C3.672 3 3 3.672 3 4.5v12c0 .828.672 1.5 1.5 1.5h3c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-3c-.276 0-.5-.224-.5-.5v-12c0-.276.224-.5.5-.5Zm3 0c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h3c.276 0 .5.224.5.5s-.224.5-.5.5h-3Z" }));
const t1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M8.5 4h3c0-.828-.672-1.5-1.5-1.5S8.5 3.172 8.5 4Zm-1 0c0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5h5c.276 0 .5.224.5.5s-.224.5-.5.5h-1.054l-1.194 10.344C15.077 16.858 13.796 18 12.272 18H7.728c-1.524 0-2.805-1.142-2.98-2.656L3.554 5H2.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h5ZM5.741 15.229C5.858 16.238 6.712 17 7.728 17h4.544c1.016 0 1.87-.762 1.987-1.771L15.439 5H4.561l1.18 10.229Z" }), tp.createElement("path", { className: Km.error, d: "M8.5 7.5c.276 0 .5.224.5.5v6c0 .276-.224.5-.5.5S8 14.276 8 14V8c0-.276.224-.5.5-.5ZM12 8c0-.276-.224-.5-.5-.5s-.5.224-.5.5v6c0 .276.224.5.5.5s.5-.224.5-.5V8Z" }));
const n1e = ({ fill: e14 }) => tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "m4.336 12 1 1H4c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1h12c.552 0 1-.448 1-1v-2c0-.078-.009-.154-.026-.227.231-.357.387-.759.465-1.162.348.36.561.85.561 1.389v2c0 1.105-.895 2-2 2H4c-1.105 0-2-.895-2-2v-2c0-1.105.895-2 2-2h.336ZM8.5 1c.276 0 .5.224.5.5v1.502c.377.074.736.256 1.028.548l2.829 2.829c.781.781.781 2.047 0 2.828l-3.536 3.536c-.781.781-2.047.781-2.828 0L3.664 9.914c-.781-.781-.781-2.047 0-2.828L7.2 3.55c.232-.232.507-.395.8-.489V1.5c0-.276.224-.5.5-.5ZM4.371 9.207 7.2 12.036c.39.39 1.023.39 1.414 0L12.149 8.5H4.078c0 .256.098.512.293.707ZM8 4.175c-.032.025-.063.053-.093.082L4.664 7.5h7.735c-.047-.152-.13-.294-.25-.414L9.321 4.257c-.095-.095-.204-.167-.321-.215V5.5c0 .276-.224.5-.5.5S8 5.776 8 5.5V4.175Z" }), tp.createElement("path", { className: Ym.text, d: "m14.377 9.167-.003.004c-.041.048-.151.178-.212.255-.124.158-.291.381-.458.642C13.386 10.564 13 11.295 13 12c0 1.009.672 2 1.75 2 1.078 0 1.75-.991 1.75-2 0-.705-.386-1.436-.704-1.932-.167-.261-.334-.484-.458-.642-.055-.07-.158-.191-.208-.249-.006-.008-.012-.015-.016-.02C15.019 9.05 14.892 9 14.75 9s-.278.061-.373.167Zm.373 1.14c.066.092.135.192.204.3.306.478.546.997.546 1.393 0 .293-.1.566-.248.749-.136.167-.299.251-.502.251s-.366-.084-.502-.251C14.1 12.566 14 12.293 14 12c0-.396.24-.915.546-1.393.069-.108.139-.208.204-.3Zm-.374-1.139.001-.001-.001.001Z" }), tp.createElement("path", { fill: e14 != null ? e14 : "transparent", d: "M4.836 12.5H4c-.828 0-1.5.672-1.5 1.5v2c0 .828.672 1.5 1.5 1.5h12c.828 0 1.5-.672 1.5-1.5v-2c0-.295-.085-.57-.232-.802-.38.969-1.226 1.802-2.518 1.802-1.597 0-2.512-1.273-2.709-2.5h-1.063l-.95.95c-1.172 1.171-3.071 1.171-4.243 0l-.949-.95Z" }));
const r1e = ({ fill: e14 }) => tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M4.5 12h11c.828 0 1.5.672 1.5 1.5v3c0 .828-.672 1.5-1.5 1.5h-11c-.828 0-1.5-.672-1.5-1.5v-3c0-.828.672-1.5 1.5-1.5ZM4 13.5v3c0 .276.224.5.5.5h11c.276 0 .5-.224.5-.5v-3c0-.276-.224-.5-.5-.5h-11c-.276 0-.5.224-.5.5Zm6.464-11.186 3 7.5c.103.257-.022.548-.278.65-.257.103-.548-.022-.65-.278l-1.073-2.682H8.537l-1.073 2.682c-.102.256-.393.381-.65.278-.256-.102-.381-.393-.278-.65l3-7.5C9.612 2.124 9.796 2 10 2c.204 0 .388.124.464.314ZM10 3.846 8.937 6.504h2.126L10 3.846Z" }), tp.createElement("path", { fill: e14 != null ? e14 : "transparent", d: "M3.5 13.125c0-.345.243-.625.542-.625h11.916c.3 0 .542.28.542.625v3.75c0 .345-.242.625-.542.625H4.042c-.299 0-.542-.28-.542-.625v-3.75Z" }));
const o1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.accent, d: "M5.251 4.252c0-.69.56-1.25 1.25-1.25h3.502c2.402 0 3.998 1.988 3.998 4 0 .872-.299 1.739-.834 2.441.905.702 1.582 1.801 1.582 3.309 0 2.864-2.438 4.246-4.245 4.246H6.501c-.69 0-1.25-.56-1.25-1.25V4.252Zm2.5 6.75v3.496h2.753c.811 0 1.745-.619 1.745-1.746 0-1.129-.938-1.75-1.745-1.75H7.751Zm0-2.5h2.248c.882 0 1.502-.721 1.502-1.5 0-.78-.62-1.5-1.498-1.5H7.751v3Z" }));
const a1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.accent, d: "M16 3c.276 0 .5.224.5.5s-.224.5-.5.5h-3.157L8.227 16H11.5c.276 0 .5.224.5.5s-.224.5-.5.5H4c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h3.156l4.615-12H8.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H16Z" }));
const i1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.accent, d: "M7 3.5c0-.276-.224-.5-.5-.5s-.5.224-.5.5V10c0 2.209 1.791 4 4 4s4-1.791 4-4V3.5c0-.276-.224-.5-.5-.5s-.5.224-.5.5V10c0 1.657-1.343 3-3 3s-3-1.343-3-3V3.5ZM5.5 16c-.276 0-.5.224-.5.5s.224.5.5.5h9c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-9Z" }));
const s1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M2 5c0-.276.224-.5.5-.5h11c.276 0 .5.224.5.5s-.224.5-.5.5h-11c-.276 0-.5-.224-.5-.5Zm0 5c0-.276.224-.5.5-.5h15c.276 0 .5.224.5.5s-.224.5-.5.5h-15c-.276 0-.5-.224-.5-.5Zm.5 4.5c-.276 0-.5.224-.5.5s.224.5.5.5h9c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-9Z" }));
const l1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M4 5c0-.276.224-.5.5-.5h11c.276 0 .5.224.5.5s-.224.5-.5.5h-11c-.276 0-.5-.224-.5-.5Zm-2 5c0-.276.224-.5.5-.5h15c.276 0 .5.224.5.5s-.224.5-.5.5h-15c-.276 0-.5-.224-.5-.5Zm4.5 4.5c-.276 0-.5.224-.5.5s.224.5.5.5h7c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-7Z" }));
const c1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M18 5c0-.276-.224-.5-.5-.5h-11c-.276 0-.5.224-.5.5s.224.5.5.5h11c.276 0 .5-.224.5-.5Zm0 5c0-.276-.224-.5-.5-.5h-15c-.276 0-.5.224-.5.5s.224.5.5.5h15c.276 0 .5-.224.5-.5Zm-.5 4.5c.276 0 .5.224.5.5s-.224.5-.5.5h-9c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h9Z" }));
const u1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M2 5c0-.276.224-.5.5-.5h15c.276 0 .5.224.5.5s-.224.5-.5.5h-15c-.276 0-.5-.224-.5-.5Zm0 5c0-.276.224-.5.5-.5h15c.276 0 .5.224.5.5s-.224.5-.5.5h-15c-.276 0-.5-.224-.5-.5Zm.5 4.5c-.276 0-.5.224-.5.5s.224.5.5.5h15c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-15Z" }));
const d1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.accent, d: "M6 6.5c0-.276.224-.5.5-.5h7c.276 0 .5.224.5.5s-.224.5-.5.5h-7c-.276 0-.5-.224-.5-.5ZM6.5 9c-.276 0-.5.224-.5.5s.224.5.5.5h7c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-7Z" }), tp.createElement("path", { className: Ym.text, d: "M14.5 3C15.881 3 17 4.119 17 5.5v9c0 1.381-1.119 2.5-2.5 2.5h-9C4.119 17 3 15.881 3 14.5v-9C3 4.119 4.119 3 5.5 3h9Zm0 1h-9C4.672 4 4 4.672 4 5.5v9c0 .828.672 1.5 1.5 1.5h9c.828 0 1.5-.672 1.5-1.5v-9c0-.828-.672-1.5-1.5-1.5Z" }));
const p1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.accent, d: "M6 8.5c0-.276.224-.5.5-.5h7c.276 0 .5.224.5.5s-.224.5-.5.5h-7c-.276 0-.5-.224-.5-.5Zm.5 2.5c-.276 0-.5.224-.5.5s.224.5.5.5h7c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-7Z" }), tp.createElement("path", { className: Ym.text, d: "M14.5 3C15.881 3 17 4.119 17 5.5v9c0 1.381-1.119 2.5-2.5 2.5h-9C4.119 17 3 15.881 3 14.5v-9C3 4.119 4.119 3 5.5 3h9Zm0 1h-9C4.672 4 4 4.672 4 5.5v9c0 .828.672 1.5 1.5 1.5h9c.828 0 1.5-.672 1.5-1.5v-9c0-.828-.672-1.5-1.5-1.5Z" }));
const m1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.accent, d: "M13.5 10c.276 0 .5.224.5.5s-.224.5-.5.5h-7c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h7Zm0 3h-7c-.276 0-.5.224-.5.5s.224.5.5.5h7c.276 0 .5-.224.5-.5s-.224-.5-.5-.5Z" }), tp.createElement("path", { className: Ym.text, d: "M17 14.5c0 1.381-1.119 2.5-2.5 2.5h-9C4.119 17 3 15.881 3 14.5v-9C3 4.119 4.119 3 5.5 3h9C15.881 3 17 4.119 17 5.5v9ZM5.5 16h9c.828 0 1.5-.672 1.5-1.5v-9c0-.828-.672-1.5-1.5-1.5h-9C4.672 4 4 4.672 4 5.5v9c0 .828.672 1.5 1.5 1.5Z" }));
const h1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M1 3c0-1.105.895-2 2-2h3c1.105 0 2 .895 2 2v1h-.5c-.17 0-.337.012-.5.035V3c0-.552-.448-1-1-1H3c-.552 0-1 .448-1 1v3c0 .552.448 1 1 1h1.035c-.023.163-.035.33-.035.5V8H3c-1.105 0-2-.895-2-2V3Zm11 13v1c0 1.105.895 2 2 2h3c1.105 0 2-.895 2-2v-3c0-1.105-.895-2-2-2h-1v.5c0 .17-.012.337-.035.5H17c.552 0 1 .448 1 1v3c0 .552-.448 1-1 1h-3c-.552 0-1-.448-1-1v-1.035c-.163.023-.33.035-.5.035H12Z" }), tp.createElement("path", { className: Km.secondary, d: "M5 7.5C5 6.119 6.119 5 7.5 5h5C13.881 5 15 6.119 15 7.5v5c0 1.381-1.119 2.5-2.5 2.5h-5C6.119 15 5 13.881 5 12.5v-5Z" }));
const f1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M12 14c0-1.105.895-2 2-2h3c1.105 0 2 .895 2 2v3c0 1.105-.895 2-2 2h-3c-1.105 0-2-.895-2-2v-3Zm2-1c-.552 0-1 .448-1 1v3c0 .552.448 1 1 1h3c.552 0 1-.448 1-1v-3c0-.552-.448-1-1-1h-3ZM1 3c0-1.105.895-2 2-2h3c1.105 0 2 .895 2 2v3c0 1.105-.895 2-2 2H3c-1.105 0-2-.895-2-2V3Zm2-1c-.552 0-1 .448-1 1v3c0 .552.448 1 1 1h3c.552 0 1-.448 1-1V3c0-.552-.448-1-1-1H3Z" }), tp.createElement("path", { className: Km.secondary, d: "M5 9h1.3C7.791 9 9 7.791 9 6.3V5h3.5C13.881 5 15 6.119 15 7.5V11h-1.3c-1.491 0-2.7 1.209-2.7 2.7V15H7.5C6.119 15 5 13.881 5 12.5V9Z" }));
const g1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M11 13c0 1.105.895 2 2 2h1c1.105 0 2-.895 2-2V8c0-1.105-.895-2-2-2h-1c-1.105 0-2 .895-2 2v5Zm2 1c-.552 0-1-.448-1-1V8c0-.552.448-1 1-1h1c.552 0 1 .448 1 1v5c0 .552-.448 1-1 1h-1Z" }), tp.createElement("path", { className: Ym.text, d: "M6 15c-1.105 0-2-.895-2-2V5c0-1.105.895-2 2-2h1c1.105 0 2 .895 2 2v8c0 1.105-.895 2-2 2H6Zm-1-2c0 .552.448 1 1 1h1c.552 0 1-.448 1-1V5c0-.552-.448-1-1-1H6c-.552 0-1 .448-1 1v8Z" }), tp.createElement("path", { className: Km.secondary, d: "M2 16.5c0 .276.224.5.5.5h15c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-15c-.276 0-.5.224-.5.5Z" }));
const y1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M7 11c-1.105 0-2 .895-2 2v1c0 1.105.895 2 2 2h5c1.105 0 2-.895 2-2v-1c0-1.105-.895-2-2-2H7Zm-1 2c0-.552.448-1 1-1h5c.552 0 1 .448 1 1v1c0 .552-.448 1-1 1H7c-.552 0-1-.448-1-1v-1Z" }), tp.createElement("path", { className: Ym.text, d: "M5 6c0-1.105.895-2 2-2h8c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2H7c-1.105 0-2-.895-2-2V6Zm2-1c-.552 0-1 .448-1 1v1c0 .552.448 1 1 1h8c.552 0 1-.448 1-1V6c0-.552-.448-1-1-1H7Z" }), tp.createElement("path", { className: Km.secondary, d: "M3.5 2c-.276 0-.5.224-.5.5v15c0 .276.224.5.5.5s.5-.224.5-.5v-15c0-.276-.224-.5-.5-.5Z" }));
const v1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M11 12V7c0-1.105.895-2 2-2h1c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2h-1c-1.105 0-2-.895-2-2Zm1 0c0 .552.448 1 1 1h1c.552 0 1-.448 1-1V7c0-.552-.448-1-1-1h-1c-.552 0-1 .448-1 1v5Z" }), tp.createElement("path", { className: Ym.text, d: "M9 5v9c0 1.105-.895 2-2 2H6c-1.105 0-2-.895-2-2V5c0-1.105.895-2 2-2h1c1.105 0 2 .895 2 2Zm-4 9c0 .552.448 1 1 1h1c.552 0 1-.448 1-1V5c0-.552-.448-1-1-1H6c-.552 0-1 .448-1 1v9Z" }), tp.createElement("path", { className: Km.secondary, d: "M4 9v1H2.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H4Zm7 0v1H9V9h2Zm5 1V9h1.5c.276 0 .5.224.5.5s-.224.5-.5.5H16Z" }));
const b1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M8 11h5c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2H8c-1.105 0-2-.895-2-2v-1c0-1.105.895-2 2-2Zm0 1c-.552 0-1 .448-1 1v1c0 .552.448 1 1 1h5c.552 0 1-.448 1-1v-1c0-.552-.448-1-1-1H8Z" }), tp.createElement("path", { className: Ym.text, d: "M15 9H6c-1.105 0-2-.895-2-2V6c0-1.105.895-2 2-2h9c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2ZM6 5c-.552 0-1 .448-1 1v1c0 .552.448 1 1 1h9c.552 0 1-.448 1-1V6c0-.552-.448-1-1-1H6Z" }), tp.createElement("path", { className: Km.secondary, d: "M11 4h-1V2.5c0-.276.224-.5.5-.5s.5.224.5.5V4Zm0 7h-1V9h1v2Zm-1 5h1v1.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5V16Z" }));
const S1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M8 11c-1.105 0-2 .895-2 2v1c0 1.105.895 2 2 2h5c1.105 0 2-.895 2-2v-1c0-1.105-.895-2-2-2H8Zm-1 2c0-.552.448-1 1-1h5c.552 0 1 .448 1 1v1c0 .552-.448 1-1 1H8c-.552 0-1-.448-1-1v-1Z" }), tp.createElement("path", { className: Ym.text, d: "M3 6c0-1.105.895-2 2-2h8c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2H5c-1.105 0-2-.895-2-2V6Zm2-1c-.552 0-1 .448-1 1v1c0 .552.448 1 1 1h8c.552 0 1-.448 1-1V6c0-.552-.448-1-1-1H5Z" }), tp.createElement("path", { className: Km.secondary, d: "M16.5 2c.276 0 .5.224.5.5v15c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-15c0-.276.224-.5.5-.5Z" }));
const C1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M11 7c0-1.105.895-2 2-2h1c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2h-1c-1.105 0-2-.895-2-2V7Zm2-1c-.552 0-1 .448-1 1v5c0 .552.448 1 1 1h1c.552 0 1-.448 1-1V7c0-.552-.448-1-1-1h-1Z" }), tp.createElement("path", { className: Ym.text, d: "M6 5c-1.105 0-2 .895-2 2v8c0 1.105.895 2 2 2h1c1.105 0 2-.895 2-2V7c0-1.105-.895-2-2-2H6ZM5 7c0-.552.448-1 1-1h1c.552 0 1 .448 1 1v8c0 .552-.448 1-1 1H6c-.552 0-1-.448-1-1V7Z" }), tp.createElement("path", { className: Km.secondary, d: "M2 3.5c0-.276.224-.5.5-.5h15c.276 0 .5.224.5.5s-.224.5-.5.5h-15c-.276 0-.5-.224-.5-.5Z" }));
const x1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M11 5.5C11 4.119 9.881 3 8.5 3h-3C4.119 3 3 4.119 3 5.5v9C3 15.881 4.119 17 5.5 17h3c1.381 0 2.5-1.119 2.5-2.5v-9ZM8.5 4c.828 0 1.5.672 1.5 1.5v9c0 .828-.672 1.5-1.5 1.5h-3c-.828 0-1.5-.672-1.5-1.5v-9C4 4.672 4.672 4 5.5 4h3Z" }), tp.createElement("path", { className: Km.secondary, d: "M16.354 5.354c-.196.195-.512.195-.708 0L15 4.707V7.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5V4.707l-.646.647c-.196.195-.512.195-.708 0-.195-.196-.195-.512 0-.708l1.5-1.5c.196-.195.512-.195.708 0l1.5 1.5c.195.196.195.512 0 .708Zm-.708 9.292c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-1.5 1.5c-.196.195-.512.195-.708 0l-1.5-1.5c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l.646.647V12.5c0-.276.224-.5.5-.5s.5.224.5.5v2.793l.646-.647Z" }));
const w1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M9.5 6C8.119 6 7 7.119 7 8.5v2C7 11.881 8.119 13 9.5 13h2c1.381 0 2.5-1.119 2.5-2.5v-2C14 7.119 12.881 6 11.5 6h-2ZM8 8.5C8 7.672 8.672 7 9.5 7h2c.828 0 1.5.672 1.5 1.5v2c0 .828-.672 1.5-1.5 1.5h-2c-.828 0-1.5-.672-1.5-1.5v-2Z" }), tp.createElement("path", { className: Km.secondary, d: "M3.354 7.646c.195.196.195.512 0 .708L2.707 9H5.5c.276 0 .5.224.5.5s-.224.5-.5.5H2.707l.647.646c.195.196.195.512 0 .708-.196.195-.512.195-.708 0l-1.5-1.5c-.195-.196-.195-.512 0-.708l1.5-1.5c.196-.195.512-.195.708 0Zm14.292.708c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l1.5 1.5c.195.196.195.512 0 .708l-1.5 1.5c-.196.195-.512.195-.708 0-.195-.196-.195-.512 0-.708l.647-.646H15.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h2.793l-.647-.646ZM12.354 2.354c-.196.195-.512.195-.708 0L11 1.707V4.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5V1.707l-.646.647c-.196.195-.512.195-.708 0-.195-.196-.195-.512 0-.708l1.5-1.5c.196-.195.512-.195.708 0l1.5 1.5c.195.196.195.512 0 .708Zm-.708 14.292c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-1.5 1.5c-.196.195-.512.195-.708 0l-1.5-1.5c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l.646.647V14.5c0-.276.224-.5.5-.5s.5.224.5.5v2.793l.646-.647Z" }));
const T1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M5.5 9C4.119 9 3 10.119 3 11.5v3C3 15.881 4.119 17 5.5 17h9c1.381 0 2.5-1.119 2.5-2.5v-3c0-1.381-1.119-2.5-2.5-2.5h-9ZM4 11.5c0-.828.672-1.5 1.5-1.5h9c.828 0 1.5.672 1.5 1.5v3c0 .828-.672 1.5-1.5 1.5h-9c-.828 0-1.5-.672-1.5-1.5v-3Z" }), tp.createElement("path", { className: Km.secondary, d: "M5.354 3.646c.195.196.195.512 0 .708L4.707 5H7.5c.276 0 .5.224.5.5s-.224.5-.5.5H4.707l.647.646c.195.196.195.512 0 .708-.196.195-.512.195-.708 0l-1.5-1.5c-.195-.196-.195-.512 0-.708l1.5-1.5c.196-.195.512-.195.708 0Zm9.292.708c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l1.5 1.5c.195.196.195.512 0 .708l-1.5 1.5c-.196.195-.512.195-.708 0-.195-.196-.195-.512 0-.708L15.293 6H12.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h2.793l-.647-.646Z" }));
const E1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M3 16c-1.105 0-2-.895-2-2V6c0-1.105.895-2 2-2h1c1.105 0 2 .895 2 2v8c0 1.105-.895 2-2 2H3Zm-1-2c0 .552.448 1 1 1h1c.552 0 1-.448 1-1V6c0-.552-.448-1-1-1H3c-.552 0-1 .448-1 1v8Z" }), tp.createElement("path", { className: Ym.text, d: "M15 16c-1.105 0-2-.895-2-2V6c0-1.105.895-2 2-2h1c1.105 0 2 .895 2 2v8c0 1.105-.895 2-2 2h-1Zm-1-2c0 .552.448 1 1 1h1c.552 0 1-.448 1-1V6c0-.552-.448-1-1-1h-1c-.552 0-1 .448-1 1v8Z" }), tp.createElement("path", { className: Km.secondary, d: "M9 16c-1.105 0-2-.895-2-2V6c0-1.105.895-2 2-2h1c1.105 0 2 .895 2 2v8c0 1.105-.895 2-2 2H9Zm-1-2c0 .552.448 1 1 1h1c.552 0 1-.448 1-1V6c0-.552-.448-1-1-1H9c-.552 0-1 .448-1 1v8Z" }));
const F1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M4 3c0-1.105.895-2 2-2h8c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2H6c-1.105 0-2-.895-2-2V3Zm2-1c-.552 0-1 .448-1 1v1c0 .552.448 1 1 1h8c.552 0 1-.448 1-1V3c0-.552-.448-1-1-1H6Z" }), tp.createElement("path", { className: Ym.text, d: "M4 15c0-1.105.895-2 2-2h8c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2H6c-1.105 0-2-.895-2-2v-1Zm2-1c-.552 0-1 .448-1 1v1c0 .552.448 1 1 1h8c.552 0 1-.448 1-1v-1c0-.552-.448-1-1-1H6Z" }), tp.createElement("path", { className: Km.secondary, d: "M4 9c0-1.105.895-2 2-2h8c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2H6c-1.105 0-2-.895-2-2V9Zm2-1c-.552 0-1 .448-1 1v1c0 .552.448 1 1 1h8c.552 0 1-.448 1-1V9c0-.552-.448-1-1-1H6Z" }));
const M1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M17 17v1.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5V17H1.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H16V1.5c0-.276.224-.5.5-.5s.5.224.5.5V16h1.5c.276 0 .5.224.5.5s-.224.5-.5.5H17Z" }), tp.createElement("path", { className: Ym.text, d: "M11 13H7c-1.105 0-2-.895-2-2V7c0-1.105.895-2 2-2h4c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2ZM7 6c-.552 0-1 .448-1 1v4c0 .552.448 1 1 1h4c.552 0 1-.448 1-1V7c0-.552-.448-1-1-1H7Z" }), tp.createElement("path", { className: Km.secondary, d: "M3 3V1.5c0-.276.224-.5.5-.5s.5.224.5.5V3h14.5c.276 0 .5.224.5.5s-.224.5-.5.5H4v14.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5V4H1.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H3Z" }));
const k1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M3 16V4H1.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H3V1.5c0-.276.224-.5.5-.5s.5.224.5.5V3h12V1.5c0-.276.224-.5.5-.5s.5.224.5.5V3h1.5c.276 0 .5.224.5.5s-.224.5-.5.5H17v12h1.5c.276 0 .5.224.5.5s-.224.5-.5.5H17v1.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5V17H4v1.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5V17H1.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H3ZM16 4H4v12h12V4Z" }), tp.createElement("path", { className: Km.secondary, d: "M13 15H7c-1.105 0-2-.895-2-2V7c0-1.105.895-2 2-2h6c1.105 0 2 .895 2 2v6c0 1.105-.895 2-2 2ZM7 6c-.552 0-1 .448-1 1v6c0 .552.448 1 1 1h6c.552 0 1-.448 1-1V7c0-.552-.448-1-1-1H7Z" }));
const P1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M16 12c-1.105 0-2-.895-2-2V6c0-1.105.895-2 2-2h1c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2h-1Zm-1-2c0 .552.448 1 1 1h1c.552 0 1-.448 1-1V6c0-.552-.448-1-1-1h-1c-.552 0-1 .448-1 1v4Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M4 12c-1.105 0-2-.895-2-2V6c0-1.105.895-2 2-2h1c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2H4Zm-1-2c0 .552.448 1 1 1h1c.552 0 1-.448 1-1V6c0-.552-.448-1-1-1H4c-.552 0-1 .448-1 1v4Z" }), tp.createElement("path", { className: Ym.text, d: "M10 12c-1.105 0-2-.895-2-2V6c0-1.105.895-2 2-2h1c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2h-1Zm-1-2c0 .552.448 1 1 1h1c.552 0 1-.448 1-1V6c0-.552-.448-1-1-1h-1c-.552 0-1 .448-1 1v4Z" }), tp.createElement("path", { className: Km.secondary, d: "m12.146 15.854 2 2c.196.195.512.195.708 0 .195-.196.195-.512 0-.708L13.707 16H17.5c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-3.793l1.147-1.146c.195-.196.195-.512 0-.708-.196-.195-.512-.195-.708 0l-2 2c-.195.196-.195.512 0 .708Zm-5.292 2 2-2c.195-.196.195-.512 0-.708l-2-2c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708L7.293 15H3.5c-.276 0-.5.224-.5.5s.224.5.5.5h3.793l-1.147 1.146c-.195.196-.195.512 0 .708.196.195.512.195.708 0Z" }));
const N1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M16 12c-1.105 0-2-.895-2-2V6c0-1.105.895-2 2-2h1c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2h-1Zm-1-2c0 .552.448 1 1 1h1c.552 0 1-.448 1-1V6c0-.552-.448-1-1-1h-1c-.552 0-1 .448-1 1v4Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M4 12c-1.105 0-2-.895-2-2V6c0-1.105.895-2 2-2h1c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2H4Zm-1-2c0 .552.448 1 1 1h1c.552 0 1-.448 1-1V6c0-.552-.448-1-1-1H4c-.552 0-1 .448-1 1v4Z" }), tp.createElement("path", { className: Ym.text, d: "M10 12c-1.105 0-2-.895-2-2V6c0-1.105.895-2 2-2h1c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2h-1Zm-1-2c0 .552.448 1 1 1h1c.552 0 1-.448 1-1V6c0-.552-.448-1-1-1h-1c-.552 0-1 .448-1 1v4Z" }), tp.createElement("path", { className: Km.secondary, d: "m16.37 16.001-1.179 1.139c-.199.192-.204.509-.013.707.192.199.509.204.707.013l1.886-1.821c.305-.295.305-.784 0-1.079l-1.886-1.821c-.198-.192-.515-.187-.707.012-.191.199-.186.515.013.707l1.183 1.143H12.5c-.276 0-.5.224-.5.5s.224.5.5.5h3.87ZM5.809 17.14 4.63 16.001H8.5c.276 0 .5-.224.5-.5s-.224-.5-.5-.5H4.626l1.183-1.143c.199-.192.204-.508.012-.707-.191-.199-.508-.204-.707-.012L3.229 14.96c-.305.295-.305.784 0 1.079l1.885 1.821c.199.191.516.186.707-.013.192-.198.187-.515-.012-.707Z" }));
const D1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M16 12c-1.105 0-2-.895-2-2V6c0-1.105.895-2 2-2h1c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2h-1Zm-1-2c0 .552.448 1 1 1h1c.552 0 1-.448 1-1V6c0-.552-.448-1-1-1h-1c-.552 0-1 .448-1 1v4Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M4 12c-1.105 0-2-.895-2-2V6c0-1.105.895-2 2-2h1c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2H4Zm-1-2c0 .552.448 1 1 1h1c.552 0 1-.448 1-1V6c0-.552-.448-1-1-1H4c-.552 0-1 .448-1 1v4Z" }), tp.createElement("path", { className: Ym.text, d: "M10 12c-1.105 0-2-.895-2-2V6c0-1.105.895-2 2-2h1c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2h-1Zm-1-2c0 .552.448 1 1 1h1c.552 0 1-.448 1-1V6c0-.552-.448-1-1-1h-1c-.552 0-1 .448-1 1v4Z" }), tp.createElement("path", { className: Km.secondary, d: "m12.146 15.854 2 2c.196.195.512.195.708 0 .195-.196.195-.512 0-.708L13.707 16H17.5c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-3.793l1.147-1.146c.195-.196.195-.512 0-.708-.196-.195-.512-.195-.708 0l-2 2c-.195.196-.195.512 0 .708Zm-5.292 2 2-2c.195-.196.195-.512 0-.708l-2-2c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708L7.293 15H3.5c-.276 0-.5.224-.5.5s.224.5.5.5h3.793l-1.147 1.146c-.195.196-.195.512 0 .708.196.195.512.195.708 0Z" }), tp.createElement("path", { className: Km.secondary, d: "M10.5 18c.276 0 .5-.224.5-.5v-4c0-.276-.224-.5-.5-.5s-.5.224-.5.5v4c0 .276.224.5.5.5Z" }));
const L1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M3 15c0-1.105.895-2 2-2h5c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2H5c-1.105 0-2-.895-2-2v-1Zm2-1c-.552 0-1 .448-1 1v1c0 .552.448 1 1 1h5c.552 0 1-.448 1-1v-1c0-.552-.448-1-1-1H5Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M3 3c0-1.105.895-2 2-2h5c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2H5c-1.105 0-2-.895-2-2V3Zm2-1c-.552 0-1 .448-1 1v1c0 .552.448 1 1 1h5c.552 0 1-.448 1-1V3c0-.552-.448-1-1-1H5" }), tp.createElement("path", { className: Ym.text, d: "M3 9c0-1.105.895-2 2-2h5c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2H5c-1.105 0-2-.895-2-2V9Zm2-1c-.552 0-1 .448-1 1v1c0 .552.448 1 1 1h5c.552 0 1-.448 1-1V9c0-.552-.448-1-1-1H5Z" }), tp.createElement("path", { className: Km.secondary, d: "m15.854 7.854 2-2c.195-.196.195-.512 0-.708-.196-.195-.512-.195-.708 0L16 6.293V2.5c0-.276-.224-.5-.5-.5s-.5.224-.5.5v3.793l-1.146-1.147c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708l2 2c.196.195.512.195.708 0Zm2 5.292-2-2c-.196-.195-.512-.195-.708 0l-2 2c-.195.196-.195.512 0 .708.196.195.512.195.708 0L15 12.707V16.5c0 .276.224.5.5.5s.5-.224.5-.5v-3.793l1.146 1.147c.196.195.512.195.708 0 .195-.196.195-.512 0-.708Z" }));
const H1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M2.998 15c0-1.105.896-2 2-2h5c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2h-5c-1.104 0-2-.895-2-2v-1Zm2-1c-.552 0-1 .448-1 1v1c0 .552.448 1 1 1h5c.553 0 1-.448 1-1v-1c0-.552-.447-1-1-1h-5Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M2.998 3c0-1.105.896-2 2-2h5c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2h-5c-1.104 0-2-.895-2-2V3Zm2-1c-.552 0-1 .448-1 1v1c0 .552.448 1 1 1h5c.553 0 1-.448 1-1V3c0-.552-.447-1-1-1h-5Z" }), tp.createElement("path", { className: Ym.text, d: "M2.998 9c0-1.105.896-2 2-2h5c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2h-5c-1.104 0-2-.895-2-2V9Zm2-1c-.552 0-1 .448-1 1v1c0 .552.448 1 1 1h5c.553 0 1-.448 1-1V9c0-.552-.447-1-1-1h-5Z" }), tp.createElement("path", { className: Km.secondary, d: "m16.001 3.63 1.139 1.179c.192.199.509.204.707.013.199-.192.204-.509.013-.707l-1.821-1.886c-.295-.305-.784-.305-1.079 0l-1.821 1.886c-.192.198-.187.515.012.707.199.191.515.186.707-.013l1.143-1.183V7.5c0 .276.224.5.5.5s.5-.224.5-.5V3.63Zm1.139 10.561-1.139 1.179V11.5c0-.276-.224-.5-.5-.5s-.5.224-.5.5v3.874l-1.143-1.183c-.192-.199-.508-.204-.707-.012-.199.191-.204.508-.012.707l1.821 1.885c.295.305.784.305 1.079 0l1.821-1.885c.191-.199.186-.516-.013-.707-.198-.192-.515-.187-.707.012Z" }));
const I1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, fillOpacity: ".38", d: "M3 15c0-1.105.895-2 2-2h5c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2H5c-1.105 0-2-.895-2-2v-1Zm2-1c-.552 0-1 .448-1 1v1c0 .552.448 1 1 1h5c.552 0 1-.448 1-1v-1c0-.552-.448-1-1-1H5Z" }), tp.createElement("path", { className: Ym.text, fillOpacity: ".62", d: "M3 3c0-1.105.895-2 2-2h5c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2H5c-1.105 0-2-.895-2-2V3Zm2-1c-.552 0-1 .448-1 1v1c0 .552.448 1 1 1h5c.552 0 1-.448 1-1V3c0-.552-.448-1-1-1H5Z" }), tp.createElement("path", { className: Ym.text, d: "M3 9c0-1.105.895-2 2-2h5c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2H5c-1.105 0-2-.895-2-2V9Zm2-1c-.552 0-1 .448-1 1v1c0 .552.448 1 1 1h5c.552 0 1-.448 1-1V9c0-.552-.448-1-1-1H5Z" }), tp.createElement("path", { className: Km.secondary, d: "m15.854 7.854 2-2c.195-.196.195-.512 0-.708-.196-.195-.512-.195-.708 0L16 6.293V2.5c0-.276-.224-.5-.5-.5s-.5.224-.5.5v3.793l-1.146-1.147c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708l2 2c.196.195.512.195.708 0Zm2 5.292-2-2c-.196-.195-.512-.195-.708 0l-2 2c-.195.196-.195.512 0 .708.196.195.512.195.708 0L15 12.707V16.5c0 .276.224.5.5.5s.5-.224.5-.5v-3.793l1.146 1.147c.196.195.512.195.708 0 .195-.196.195-.512 0-.708Z" }), tp.createElement("path", { className: Km.secondary, d: "M18 9.5c0-.276-.224-.5-.5-.5h-4c-.276 0-.5.224-.5.5s.224.5.5.5h4c.276 0 .5-.224.5-.5Z" }));
const _1e = Object.entries({ textbox: Zq(tY, "textbox.value", "string_expr", "Value"), checkbox: Zq(tY, "checkBox.checked", "boolean_expr", "Checked"), barcode: Zq(tY, "barcode.value", "string_expr", "Value"), image: Zq(Kq, "image.value", "string_expr", "Value"), formattedtext: Zq(nY, "formattedText.html", "html_expr", "Html"), richtext: Zq(tY, "richtext.value", "string_expr", "Value"), bullet: Zq(rY, "bullet.value", "number_expr", "Value", void 0, { numberType: "Float", emptyValue: "EmptyString" }), sparkline: Zq(tY, "sparkline.seriesValue", "number_expr", "SeriesValue", void 0, { numberType: "Float", emptyValue: "EmptyString" }) }).reduce((e14, t10) => {
  const [n10, r10] = t10;
  let o10 = { Value: "" };
  switch (n10) {
    case "checkbox":
      o10 = { Checked: "False" };
      break;
    case "formattedtext":
      o10 = { Html: "" };
      break;
    case "sparkline":
      o10 = { SeriesValue: "" };
  }
  return __spreadProps(__spreadValues({}, e14), { [n10]: { getPropertyDescriptor: () => r10, defaultValue: o10 } });
}, {});
const V1e = (e14, t10) => {
  const n10 = [];
  for (let r10 = 0; r10 < e14.length; r10++) {
    const o10 = e14[r10];
    const a10 = t10.find((e15) => o10.type === e15.type && o10.key === e15.key);
    void 0 !== a10 && n10.push(a10);
  }
  return n10;
};
const R1e = (e14 = "") => ({ type: "separator", key: e14 }), A1e = (e14, t10, n10, r10, o10, a10, i10) => ({ type: "button", key: t10, textKey: e14, icon: n10, action: r10 != null ? r10 : { type: "" }, disabled: o10, location: a10, meta: i10 }), O1e = (e14, t10, n10 = [], r10, o10, a10) => ({ type: "group", key: e14, icon: t10, actions: n10, disabled: r10, location: o10, meta: a10 });
const B1e = (e14) => ({ type: "header", header: e14 });
const z1e = (e14, t10, n10, r10) => {
  switch (e14.type) {
    case "group": {
      const o10 = (e14.actions || []).reduce((e15, o11) => e15.concat(z1e(o11, t10, n10, r10)), []);
      return o10.length > 0 ? [B1e(t10(e14.key)), ...o10] : o10;
    }
    case "dropdown": {
      const { key: o10, icon: a10, actions: i10 } = e14;
      const s10 = i10.reduce((e15, o11) => e15.concat(z1e(o11, t10, n10, r10)), []);
      const l10 = i10.findIndex((e15) => "separator" !== e15.type && !l10) < 0;
      const c10 = t10(o10);
      return i10 && [{ type: "group", text: c10, key: c10, title: c10, icon: a10, disabled: l10, items: s10 }];
    }
    case "button": {
      const { key: r11, icon: o10, action: a10, disabled: i10 } = e14;
      const s10 = t10(r11);
      return [{ type: "button", text: s10, key: s10, title: s10, icon: o10, disabled: i10, onClick: (e15, t11) => n10(__spreadProps(__spreadValues({}, a10), { payload: __spreadProps(__spreadValues({}, a10.payload), { mousePosition: t11, contextAction: true }) })) }];
    }
    case "dialog": {
      const { key: n11, icon: o10, dialogName: a10, disabled: i10, dialogProps: s10 } = e14;
      const l10 = t10(n11);
      return [{ type: "button", text: l10, key: l10, title: l10, icon: o10, disabled: i10, onClick: () => {
        r10(a10, s10);
      } }];
    }
    case "separator":
      return e14.key ? [B1e(t10(e14.key))] : [{ type: "splitter" }];
    default:
      return [];
  }
};
const $1e = (e14, t10, n10) => rj(e14) && !nz.of(t10).getFeature(e14.Type, n10);
const W1e = (e14) => Pm(e14, { size: "custom" });
const j1e = (e14) => {
  const t10 = [];
  const n10 = [];
  return e14.forEach((e15) => e15 && "group" === e15.type ? n10.push(e15) : t10.push(e15)), [...t10, ...n10];
};
const Z1e = (e14, t10) => {
  const n10 = [];
  return e14.forEach((e15) => {
    const r10 = __spreadValues({}, e15);
    const { type: o10, location: a10 } = r10;
    a10 && a10 !== t10 || ("dropdown" !== o10 && "group" !== o10 || (r10.actions = Z1e(r10.actions, t10)), n10.push(r10));
  }), n10;
};
const G1e = (e14, t10) => e14.map((e15) => "separator" === e15.type ? e15 : __spreadProps(__spreadValues({}, e15), { disabled: t10 }));
const U1e = (e14, t10) => e14.map((e15) => __spreadProps(__spreadValues({}, e15), { location: t10 }));
const q1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.accent, d: "M10.883 5.357c.292-1.705 2.03-2.752 3.674-2.215l.787.258c.263.086.545-.057.631-.32.086-.262-.057-.545-.32-.631l-.787-.257c-2.224-.728-4.575.69-4.97 2.997l-.654 3.819H5.5c-.276 0-.5.224-.5.5s.224.5.5.5h3.573l-.622 3.633c-.335 1.96-2.532 2.974-4.24 1.958l-.456-.271c-.237-.141-.544-.063-.685.175-.141.237-.063.544.174.685l.456.27c2.311 1.375 5.283.003 5.737-2.648l.651-3.802H13.5c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-3.241l.624-3.651Z" }), tp.createElement("path", { className: Ym.text, d: "m13.394 14.5-1.282-1.709c-.16-.214-.117-.518.097-.678.214-.161.518-.117.678.097L14 13.693l1.112-1.483c.161-.214.465-.258.678-.097.214.16.258.464.097.678L14.605 14.5l1.282 1.71c.161.213.117.517-.097.678-.213.16-.517.117-.678-.097L14 15.308l-1.113 1.483c-.16.214-.464.257-.678.097-.214-.161-.257-.465-.097-.678l1.282-1.71Z" }));
const Y1e = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.accent, d: "M14.5 19c2.485 0 4.5-2.015 4.5-4.5S16.985 10 14.5 10 10 12.015 10 14.5s2.015 4.5 4.5 4.5Zm0-7c.276 0 .5.224.5.5V14h1.5c.276 0 .5.224.5.5s-.224.5-.5.5H15v1.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5V15h-1.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H14v-1.5c0-.276.224-.5.5-.5Z" }), tp.createElement("path", { className: Km.secondary, d: "M9.601 17H8.87c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h.337c.099.349.231.683.394 1ZM16 9.207V8.87c0-.276.224-.5.5-.5s.5.224.5.5v.731c-.317-.163-.651-.295-1-.394ZM14.522 3C15.89 3 17 4.11 17 5.478v1.131c0 .276-.224.5-.5.5s-.5-.224-.5-.5V5.478C16 4.662 15.338 4 14.522 4h-1.131c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h1.131ZM5.478 3h1.131c.276 0 .5.224.5.5s-.224.5-.5.5H5.478C4.662 4 4 4.662 4 5.478v1.131c0 .276-.224.5-.5.5s-.5-.224-.5-.5V5.478C3 4.11 4.11 3 5.478 3ZM4 14.522c0 .815.661 1.477 1.473 1.478H6.609c.276 0 .5.224.5.5s-.224.5-.5.5H5.478C4.11 17 3 15.89 3 14.522v-1.131c0-.276.224-.5.5-.5s.5.224.5.5v1.131ZM11.13 3c.276 0 .5.224.5.5s-.224.5-.5.5H8.87c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h2.26ZM3 8.87c0-.276.224-.5.5-.5s.5.224.5.5v2.26c0 .276-.224.5-.5.5s-.5-.224-.5-.5V8.87Z" }), tp.createElement("path", { className: Ym.text, opacity: "0.62", d: "M6.5 6c-.276 0-.5.224-.5.5s.224.5.5.5h7c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-7ZM6 9.5c0-.276.224-.5.5-.5h4c.276 0 .5.224.5.5s-.224.5-.5.5h-4c-.276 0-.5-.224-.5-.5Zm.5 2.5c-.276 0-.5.224-.5.5s.224.5.5.5h2.707c.099-.349.231-.683.393-1H6.5Z" }));
const K1e = (e14, t10, n10 = "") => {
  if (aj(e14) || Array.isArray(e14)) for (const r10 in e14) {
    if (!e14.hasOwnProperty(r10)) continue;
    const o10 = e14[r10];
    if (aj(o10) || Array.isArray(o10)) {
      const e15 = `${n10}${n10 ? "." : ""}${r10}`;
      t10(K1e(o10, t10, e15), e15);
    }
  }
  return e14;
};
const X1e = (e14) => {
  if (rj(e14)) return [{ item: e14, path: "" }];
  const t10 = [];
  return K1e(e14, (e15, n10) => {
    rj(e15) && t10.push({ item: e15, path: n10 });
  }), t10;
};
const J1e = [{ type: "button", key: "contextActions:report.layout.alignToGrid", icon: nf(M1e), action: sU({ keepSizes: true }) }, { type: "button", key: "contextActions:report.layout.sizeToGrid", icon: nf(k1e), action: sU({ keepSizes: false }) }];
const Q1e = [{ type: "separator", key: "contextActions:report.layout.separator.sortControls", location: "toolbar" }, { type: "button", key: "contextActions:report.layout.bringToFront", icon: nf(h1e), action: nU() }, { type: "button", key: "contextActions:report.layout.sendToBack", icon: nf(f1e), action: rU() }];
const e0e = [{ type: "separator", key: "contextActions:report.layout.separator.corelateControlSizing" }, { type: "button", key: "contextActions:report.layout.makeSameWidth", icon: nf(T1e), action: A2({ correlateWidth: true }) }, { type: "button", key: "contextActions:report.layout.makeSameHeight", icon: nf(x1e), action: A2({ correlateHeight: true }) }, { type: "button", key: "contextActions:report.layout.makeSameSize", icon: nf(w1e), action: A2({ correlateWidth: true, correlateHeight: true }) }];
const t0e = [{ type: "separator", key: "contextActions:report.layout.horizontalAlignment" }, { type: "button", key: "contextActions:report.layout.alignToLefts", icon: nf(y1e), action: iU({ horizontal: "left" }) }, { type: "button", key: "contextActions:report.layout.alignToCenters", icon: nf(b1e), action: iU({ horizontal: "center" }) }, { type: "button", key: "contextActions:report.layout.alignToRights", icon: nf(S1e), action: iU({ horizontal: "right" }) }];
const n0e = [{ type: "separator", key: "contextActions:report.layout.verticalAlignment" }, { type: "button", key: "contextActions:report.layout.alignToTops", icon: nf(C1e), action: iU({ vertical: "top" }) }, { type: "button", key: "contextActions:report.layout.alignToMiddles", icon: nf(v1e), action: iU({ vertical: "middle" }) }, { type: "button", key: "contextActions:report.layout.alignToBottoms", icon: nf(g1e), action: iU({ vertical: "bottom" }) }];
const r0e = [{ type: "separator", key: "contextActions:report.layout.separator.horizontalSpacing" }, { type: "button", key: "contextActions:report.layout.horizontal.makeSpacingEqual", icon: nf(E1e), action: oU({ spacingAdjustment: "equal" }) }, { type: "button", key: "contextActions:report.layout.horizontal.increaseSpacing", icon: nf(N1e), action: oU({ spacingAdjustment: "increase" }) }, { type: "button", key: "contextActions:report.layout.horizontal.decreaseSpacing", icon: nf(P1e), action: oU({ spacingAdjustment: "decrease" }) }, { type: "button", key: "contextActions:report.layout.horizontal.removeSpacing", icon: nf(D1e), action: oU({ spacingAdjustment: "remove" }) }];
const o0e = [{ type: "separator", key: "contextActions:report.layout.separator.verticalSpacing" }, { type: "button", key: "contextActions:report.layout.vertical.makeSpacingEqual", icon: nf(F1e), action: aU({ spacingAdjustment: "equal" }) }, { type: "button", key: "contextActions:report.layout.vertical.increaseSpacing", icon: nf(H1e), action: aU({ spacingAdjustment: "increase" }) }, { type: "button", key: "contextActions:report.layout.vertical.decreaseSpacing", icon: nf(L1e), action: aU({ spacingAdjustment: "decrease" }) }, { type: "button", key: "contextActions:report.layout.vertical.removeSpacing", icon: nf(I1e), action: aU({ spacingAdjustment: "remove" }) }];
const a0e = (e14, t10) => {
  const { lockLayout: n10 } = KO.of(t10);
  const r10 = (() => {
    const t11 = X1e(e14).filter(({ item: e15 }) => I0(e15));
    return t11.some(({ item: e15 }) => e15.$primary) ? t11 : [];
  })();
  const o10 = r10.length > 0;
  const a10 = r10.length > 1;
  const i10 = !!r10.find(({ item: e15 }) => "contentplaceholder" === e15.Type && Z7(e15));
  return { type: "group", key: "contextActions:report.layout.title", actions: [...((e15) => G1e(e15, n10 || !o10 || i10))([...U1e(J1e, "toolbar"), ...Q1e]), ...((e15) => G1e(e15, n10 || !a10 || i10))(U1e([...e0e, ...t0e, ...n0e, ...r0e, ...o0e], "toolbar"))] };
};
const i0e = (e14, t10, n10) => {
  var _a2;
  const { lockLayout: r10, rdlx: o10 } = KO.of(t10);
  const a10 = $1e(e14, t10, "disableCopy");
  const i10 = $1e(e14, t10, "disablePaste");
  const s10 = ((e15, t11, n11) => {
    if (!n11 || "multisectionreport" !== t11.Type || "partitem" === e15.Type) return false;
    const r11 = t11.ReportSections.some((t12) => "Continuous" === t12.Type && t12.Body.ReportItems.some((t13) => e15.Name === t13.Name));
    const o11 = t11.ReportParts.some((t12) => t12.ReportItemName === e15.Name);
    return r11 && rj(e15) && !o11;
  })(e14, n10, (_a2 = o10 == null ? void 0 : o10.reportParts) == null ? void 0 : _a2.enabled);
  const l10 = Z7(e14);
  const c10 = [{ type: "button", key: "components:toolbar.home.titleCut", icon: nf(JQe), action: pB(), disabled: !a10 || r10 || l10 }, { type: "button", key: "components:toolbar.home.titleCopy", icon: nf(QQe), action: dB(), disabled: !a10 || r10 || l10 }, { type: "button", key: "components:toolbar.home.titlePaste", icon: nf(e1e), action: mB(), disabled: !i10 || r10 || G7(e14) || Y7(e14, n10) }, a0e(n10, t10)];
  return s10 && !l10 && c10.push({ type: "group", key: "contextActions:report.reportParts.title", actions: [{ type: "button", key: "contextActions:report.reportParts.titleCreateReportPart", textKey: "contextActions:report.reportParts.titleCreateReportPart", icon: nf(Y1e), action: j2(), disabled: r10 }] }), c10;
};
const s0e = (e14) => `contextActions:tablix.${e14}`;
const l0e = (e14, t10, n10, r10) => ({ type: "button", icon: e14, key: s0e(t10), disabled: n10, action: r10, textKey: s0e(t10) });
const c0e = (e14, t10, n10, r10, o10, a10) => ({ type: "dialog", icon: e14, key: s0e(t10), disabled: n10, dialogName: "addRowsColumns", dialogProps: { onSave: r10, positionEnum: o10, isRow: a10 } });
const u0e = (e14, t10, n10, r10) => ({ type: "button", icon: e14, key: t10, disabled: n10, action: r10 });
const d0e = (e14, t10, n10, r10) => ({ type: "dropdown", icon: e14, key: s0e(t10), disabled: n10, actions: r10 });
const p0e = (e14) => ({ type: "separator", key: e14 ? s0e(e14) : "" });
const m0e = { Cells: W1e(aQe), SplitCells: W1e(sQe), MergeCells: W1e(iQe), Columns: W1e(lQe), InsertColumnLeft: W1e(uQe), InsertColumnLeftInside: W1e(dQe), InsertColumnLeftOutside: W1e(pQe), InsertColumnRight: W1e(mQe), DeleteColumn: W1e(cQe), InsertColumnRightInside: W1e(hQe), InsertColumnRightOutside: W1e(fQe), Rows: W1e(IQe), InsertRowAbove: W1e(kQe), InsertRowAboveInside: W1e(PQe), InsertRowAboveOutside: W1e(NQe), InsertRowBelow: W1e(DQe), DeleteRow: W1e(MQe), InsertRowBelowInside: W1e(LQe), InsertRowBelowOutside: W1e(HQe), ColumnGroups: W1e(gQe), DeleteColumnGroup: W1e(CQe), ColumnGroupAddParent: W1e(bQe), ColumnGroupAddChild: W1e(yQe), ColumnGroupAddLeft: W1e(vQe), ColumnGroupAddRight: W1e(SQe), ColumnGroupEnable: W1e(GQe), ColumnGroupDisable: W1e(ZQe), RowGroups: W1e(gQe), DeleteRowGroup: W1e(FQe), RowGroupAddParent: W1e(EQe), RowGroupAddChild: W1e(TQe), RowGroupAddAbove: W1e(xQe), RowGroupAddBelow: W1e(wQe), RowGroupEnable: W1e(GQe), RowGroupDisable: W1e(ZQe), Totals: W1e(XQe), TotalColumnLeft: W1e(UQe), TotalColumnRight: W1e(qQe), TotalRowAbove: W1e(YQe), TotalRowBelow: W1e(KQe) };
function h0e(e14) {
  const t10 = xQ(e14);
  switch (t10) {
    case hZ.Corner:
      return function() {
        const t11 = e14[hZ.Corner];
        return !!t11 && ((e15) => {
          const { start: t12, end: n10, selectedCells: r10 } = TQ(e15);
          for (let o10 = t12.rowIndex; o10 < n10.rowIndex; o10++) {
            const a10 = e15[o10];
            for (let e16 = t12.cellIndex; e16 < n10.cellIndex; e16++) {
              const t13 = a10[e16];
              if (!t13) continue;
              const n11 = r10.indexOf(t13);
              if (n11 < 0) return false;
              r10.splice(n11, 1);
            }
          }
          return 0 === r10.length;
        })(t11);
      }();
    case hZ.ColumnHierarchy:
    case hZ.RowHierarchy:
      return function(t11) {
        const n10 = e14[t11];
        return !(!MQ(n10) && !kQ(n10)) && PQ(e14, t11);
      }(t10);
    case hZ.Body:
      return function() {
        const t11 = e14[hZ.ColumnHierarchy].Members;
        const n10 = (e15) => {
          const n11 = JJ(t11, e15);
          for (let e16 = n11.length - 1; e16 >= 0; e16--) {
            const t12 = n11[e16];
            if (t12 && t12.Group) return t12.Group;
          }
          return null;
        };
        return ((e15) => {
          const { start: t12, end: r10, selectedCells: o10 } = EQ(e15);
          const a10 = n10(t12.cellIndex);
          for (let i10 = t12.rowIndex; i10 < r10.rowIndex; i10++) {
            const s10 = e15.Rows[i10];
            for (let e16 = t12.cellIndex; e16 < r10.cellIndex; e16++) {
              const r11 = s10.Cells[e16];
              if (!r11) continue;
              if (i10 !== t12.rowIndex || a10 !== n10(e16)) return false;
              const l10 = o10.indexOf(r11);
              if (l10 < 0) return false;
              o10.splice(l10, 1);
            }
          }
          return 0 === o10.length;
        })(e14[hZ.Body]);
      }();
  }
  return false;
}
function f0e(e14) {
  return !!NQ(e14);
}
function g0e(e14, t10) {
  if (yj(t10).length > 1) return null;
  const n10 = lQ(t10) === hZ.Corner;
  const r10 = e14 === dZ.ROW;
  const o10 = uQ(t10, e14);
  const a10 = rQ(t10, o10 ? r10 ? uZ.ROW : uZ.COLUMN : r10 ? uZ.COLUMN : uZ.ROW, ij, o10 ? { searchInBody: true } : { searchInCorner: true });
  if (!a10 || !a10.length) throw new Error("Not found paths");
  const i10 = (e15) => a10.some((t11) => {
    const n11 = zV.findLastIndex(t11, (e16) => "dynamictablixmember" === (e16 == null ? void 0 : e16.Type));
    const r11 = n11 >= 0 ? t11[n11] : null;
    const o11 = t11[t11.length - 1];
    const a11 = (t12) => t12 === o11 || !!SQ(t12.Children) && a11(t12.Children[e15 ? 0 : t12.Children.length - 1]);
    return r11 && a11(r11);
  });
  const s10 = i10(true);
  const l10 = i10(false);
  const c10 = (o10 ? a10.some((e15) => e15.some((e16) => "dynamictablixmember" === e16.Type)) : a10.some((e15) => {
    const t11 = e15[e15.length - 1];
    const n11 = e15[e15.length - 2];
    return "dynamictablixmember" === t11.Type || n11 && !n11.Header && "dynamictablixmember" === n11.Type;
  })) && !n10 && (s10 || l10) ? [mZ.InsideBefore, mZ.InsideAfter, mZ.OutsideBefore, mZ.OutsideAfter, mZ.More] : [mZ.Before, mZ.After, mZ.More];
  return c10.map((t11) => {
    let a11, i11, c11, u10;
    switch (t11) {
      case mZ.After:
      case mZ.Before:
        return u10 = t11 === mZ.Before, a11 = r10 ? u10 ? "insertRow.above" : "insertRow.below" : u10 ? "insertColumn.left" : "insertColumn.right", i11 = (r10 ? gZ : vZ)(t11), c11 = r10 ? u10 ? m0e.InsertRowAbove : m0e.InsertRowBelow : u10 ? m0e.InsertColumnLeft : m0e.InsertColumnRight, l0e(c11, a11, false, i11);
      case mZ.InsideBefore:
      case mZ.InsideAfter:
        u10 = t11 === mZ.InsideBefore, a11 = r10 ? u10 ? "insertRow.insideGroupAbove" : "insertRow.insideGroupBelow" : u10 ? "insertColumn.insideGroupLeft" : "insertColumn.insideGroupRight";
        return i11 = (r10 ? gZ : vZ)(((e15) => {
          if (o10) {
            if (e15 === mZ.InsideBefore && l10 && !s10) return mZ.Before;
            if (e15 === mZ.InsideAfter && s10 && !l10) return mZ.After;
          }
          return t11;
        })(t11)), c11 = r10 ? u10 ? m0e.InsertRowAboveInside : m0e.InsertRowBelowInside : u10 ? m0e.InsertColumnLeftInside : m0e.InsertColumnRightInside, l0e(c11, a11, false, i11);
      case mZ.OutsideBefore:
      case mZ.OutsideAfter:
        u10 = t11 === mZ.OutsideBefore, a11 = r10 ? u10 ? "insertRow.outsideGroupAbove" : "insertRow.outsideGroupBelow" : u10 ? "insertColumn.outsideGroupLeft" : "insertColumn.outsideGroupRight";
        const d10 = o10 ? u10 ? s10 : l10 : u10;
        return i11 = (r10 ? gZ : vZ)(t11), c11 = r10 ? u10 ? m0e.InsertRowAboveOutside : m0e.InsertRowBelowOutside : u10 ? m0e.InsertColumnLeftOutside : m0e.InsertColumnRightOutside, l0e(c11, a11, !d10, i11);
      case mZ.More:
        return c0e(r10 ? m0e.Rows : m0e.Columns, "more", false, (e15, t12) => (r10 ? gZ : vZ)(t12, e15), n10 ? [{ name: s0e(r10 ? "insertRow.above" : "insertColumn.left"), value: mZ.Before }, { name: s0e(r10 ? "insertRow.below" : "insertColumn.right"), value: mZ.After }] : [{ name: s0e(r10 ? "insertRow.insideGroupAbove" : "insertColumn.insideGroupLeft"), value: mZ.InsideBefore }, { name: s0e(r10 ? "insertRow.insideGroupBelow" : "insertColumn.insideGroupRight"), value: mZ.InsideAfter }, (!o10 || s10) && { name: s0e(r10 ? "insertRow.outsideGroupAbove" : "insertColumn.outsideGroupLeft"), value: mZ.OutsideBefore }, o10 && l10 && { name: s0e(r10 ? "insertRow.outsideGroupBelow" : "insertColumn.outsideGroupRight"), value: mZ.OutsideAfter }].filter((e15) => e15), r10);
      default:
        throw new Error(`Invalid position for inserting ${e14}`);
    }
  });
}
function y0e(e14, t10) {
  if (t10 !== dZ.ROW && t10 !== dZ.COLUMN) throw new Error(`Invalid argument: orientation (${t10})`);
  const n10 = aQ(e14.Body, t10);
  const r10 = iQ(t10 === dZ.ROW ? e14.RowHierarchy.Members : e14.ColumnHierarchy.Members);
  const o10 = t10 === dZ.ROW ? e14.Body.Rows.length : e14.Body.Columns.length;
  return zV.uniq(n10.concat(r10)).length < o10;
}
function v0e(e14) {
  const t10 = [];
  function n10(t11) {
    const n11 = t11 === uZ.ROW;
    return [{ type: "button", icon: n11 ? m0e.RowGroupAddParent : m0e.ColumnGroupAddParent, key: s0e("addGroup.parent"), pos: pZ.PARENT }, { type: "button", icon: n11 ? m0e.RowGroupAddChild : m0e.ColumnGroupAddChild, key: s0e("addGroup.child"), pos: pZ.CHILD }, { type: "button", icon: n11 ? m0e.RowGroupAddAbove : m0e.ColumnGroupAddLeft, key: s0e("addGroup.adjacentBefore"), pos: pZ.BEFORE }, { type: "button", icon: n11 ? m0e.RowGroupAddBelow : m0e.ColumnGroupAddRight, key: s0e("addGroup.adjacentAfter"), pos: pZ.AFTER }].map((n12) => Object.assign({}, n12, { disabled: !b0e(e14, t11, n12.pos), action: fZ(t11, n12.pos) }));
  }
  const r10 = n10(uZ.COLUMN) || [];
  const o10 = [];
  tQ(e14, uZ.COLUMN) ? o10.push(l0e(m0e.ColumnGroupEnable, "enableGroup", false, EZ())) : eQ(e14, uZ.COLUMN) && o10.push(l0e(m0e.ColumnGroupDisable, "disableGroup", false, EZ())), r10.length && (o10.push(p0e("addGroupTitle")), o10.push(...r10), o10.push(p0e())), o10.push(l0e(m0e.DeleteColumnGroup, "delete", !S0e(uZ.COLUMN, e14), SZ())), t10.push(d0e(m0e.ColumnGroups, "columnGroup", !F0e(o10), o10));
  const a10 = n10(uZ.ROW) || [];
  const i10 = [];
  return tQ(e14, uZ.ROW) ? i10.push(l0e(m0e.RowGroupEnable, "enableGroup", false, EZ())) : eQ(e14, uZ.ROW) && i10.push(l0e(m0e.RowGroupDisable, "disableGroup", false, EZ())), a10.length && (i10.push(p0e("addGroupTitle")), i10.push(...a10), i10.push(p0e())), i10.push(l0e(m0e.DeleteRowGroup, "delete", !S0e(uZ.ROW, e14), CZ())), t10.push(d0e(m0e.RowGroups, "rowGroup", !F0e(i10), i10)), t10;
}
function b0e(e14, t10, n10) {
  if (t10 !== uZ.ROW && t10 !== uZ.COLUMN) throw new Error("Invalid hierarchy name");
  if (!Object.getOwnPropertyNames(pZ).find((e15) => pZ[e15] === n10)) throw new Error("Invalid position for adding a group");
  const r10 = rQ(e14, t10, ij, { searchInBody: true })[0];
  if (!r10 || !r10.length) return false;
  const o10 = ((e15) => {
    const t11 = zV.findLastIndex(e15, (e16) => e16.Group);
    return t11 >= 0 ? e15[t11] : e15[e15.length - 1];
  })(r10);
  return !!o10 && ((e15) => e15 && (e15.Group && e15.Group.Name || n10 !== pZ.CHILD))(o10);
}
function S0e(e14, t10) {
  const n10 = rQ(t10, e14, ij, { searchInBody: true })[0];
  return !(!n10 || !n10.length) && n10.some((e15) => e15 && e15.Type && "dynamictablixmember" === e15.Type.toLowerCase());
}
function C0e(e14) {
  const t10 = [];
  const n10 = !!x0e(e14, uZ.ROW);
  const r10 = !!x0e(e14, uZ.COLUMN);
  const o10 = n10 || r10;
  return t10.push({ type: "button", icon: n10 ? m0e.TotalRowBelow : m0e.TotalColumnRight, key: s0e("addTotal.contextMenuAfter"), disabled: !o10, action: xZ(pZ.AFTER) }), t10.push({ type: "button", icon: n10 ? m0e.TotalRowAbove : m0e.TotalColumnLeft, key: s0e("addTotal.contextMenuBefore"), disabled: !o10, action: xZ(pZ.BEFORE) }), [{ type: "dropdown", icon: m0e.Totals, key: s0e("totalTitle"), actions: t10 }];
}
function x0e(e14, t10) {
  const n10 = cQ(e14[t10 === uZ.ROW ? "RowHierarchy" : "ColumnHierarchy"].Members, ij);
  if (!n10 || !n10.length) return null;
  return n10.find((e15) => "dynamictablixmember" === e15.Type.toLowerCase());
}
function w0e(e14, t10, n10) {
  const r10 = [];
  t10.forEach((e15, t11) => {
    aj(e15) && r10.push(t11);
  });
  const o10 = t10.length - n10;
  return r10.filter((e15) => e15 >= o10).length < n10;
}
const T0e = (e14) => u0e(m0e.DeleteRow, "contextActions:tablix.deleteRow", !((e15) => w0e(0, e15.$rows.collection, e15.Body.Rows.length))(e14), yZ());
const E0e = (e14) => u0e(m0e.DeleteColumn, "contextActions:tablix.deleteColumn", !((e15) => w0e(0, e15.$columns.collection, e15.Body.Columns.length))(e14), bZ());
function F0e(e14) {
  return e14.some((e15) => "separator" !== e15.type && !e15.disabled);
}
function M0e(e14, t10) {
  e14 && F0e(e14.actions) && t10.push(e14);
}
const k0e = { ctrlPressed: false, altPressed: false };
try {
  void 0 !== window && (window.onkeydown = (e14) => {
    k0e.ctrlPressed = SB(e14), k0e.altPressed = e14.altKey;
  }, window.onkeyup = (e14) => {
    k0e.ctrlPressed = SB(e14), k0e.altPressed = e14.altKey;
  });
} catch (e14) {
}
const P0e = (e14, t10, n10) => {
  n10 && n10.apply ? n10(e14, t10) : console.error("Failed to setDecorations");
};
const N0e = (e14, t10) => {
  if (!e14 || !t10) throw new Error("Internal exception was occured: Invalid dnd-delta or zoom args");
  return 1 === t10 ? e14 : { x: e14.x / t10, y: e14.y / t10 };
};
var D0e = { REPORTITEM: "reportitem", DATASET: "dataset", FIELD: "field", FIELDS: "fields", VALUE: "value", RESIZEGRIP: "resizegrip", TOOLBOXITEM: "toolboxItem", SUGGESTIONITEM: "smartSuggestion", ENTITY_RELATION: "entity_relation" };
const L0e = (e14) => {
  const t10 = L$.parse(e14.Page.TopMargin);
  const n10 = L$.parse(e14.Page.BottomMargin);
  const r10 = e14.PageHeader ? L$.parse(e14.PageHeader.$place.Height) : new L$(0, "in");
  const o10 = e14.PageFooter ? L$.parse(e14.PageFooter.$place.Height) : new L$(0, "in");
  return L$.parse(e14.Page.PageHeight).subtract(t10).subtract(n10).subtract(r10).subtract(o10);
};
function H0e(e14, t10 = (...e15) => e15, n10 = void 0) {
  let r10;
  let o10;
  return function(...a10) {
    const i10 = n10 || this;
    const s10 = t10(...a10);
    return zV.isEqual(s10, r10) || (r10 = s10, o10 = e14.apply(i10, a10)), o10;
  };
}
function I0e(e14, t10 = 16, n10 = void 0) {
  let r10;
  let o10;
  return function(...a10) {
    const i10 = n10 || this;
    const s10 = +/* @__PURE__ */ new Date();
    r10 && s10 < r10 + t10 ? (clearTimeout(o10), o10 = setTimeout(() => {
      r10 = s10, e14.apply(i10, a10);
    }, t10)) : (r10 = s10, e14.apply(i10, a10));
  };
}
const _0e = "0pt";
const V0e = H0e((e14) => {
  var _a2, _b2, _c2, _d2;
  const t10 = [];
  const n10 = (e15) => L$.parse(e15).toTwips;
  const r10 = (e15) => e15 && ("partial" === e15.$selected || "leaf" === e15.$selected);
  const o10 = ({ x: e15, y: t11, parent: r11 }, o11, a11) => ({ x: a11.place.Left ? e15 + n10(a11.place.Left) : e15, y: a11.place.Top ? t11 + n10(a11.place.Top) : t11, parent: VW(o11.Type) ? o11 : r11 });
  const a10 = ({ x: e15, y: n11, parent: r11 }, o11, a11) => {
    var _a3;
    if ("leaf" !== o11.$selected || !o11.$place) return;
    const { Top: i11, Left: s11 } = (_a3 = a11.place) != null ? _a3 : o11.$place;
    const l11 = L$.parse(s11);
    const c10 = L$.parse(i11);
    const u10 = L$.fromTwips(l11.toTwips + e15, l11.units);
    const d10 = L$.fromTwips(c10.toTwips + n11, c10.units);
    const p10 = BV.cloneDeep(o11);
    t10.push({ item: p10, parent: r11, Top: d10, Left: u10 });
  };
  const i10 = { x: 0, y: 0, parent: null };
  switch (e14.Type) {
    case "multisectionreport":
    case "fixedpagereport": {
      const t11 = "multisectionreport" === e14.Type ? "ReportSections" : "Pages";
      e14[t11].forEach((t12) => C3(__spreadProps(__spreadValues({}, t12), { $place: { Top: _0e, Left: _0e, Width: e14.Page.PageWidth, Height: e14.Page.PageHeight } }), w3((e15, t13, n11, i11) => r10(t13) ? (e15 && a10(e15, t13, i11), e15 && o10(e15, t13, i11)) : null), i10));
      break;
    }
    case "dashboard": {
      const t11 = e14.ReportSections[e14.$activeSectionIndex];
      let n11 = L$.zero;
      [[t11.PageHeader, L$.parse((_b2 = (_a2 = t11.PageHeader) == null ? void 0 : _a2.$place.Height) != null ? _b2 : "0in")], [t11.Body, L0e(t11)], [t11.PageFooter, L$.parse((_d2 = (_c2 = t11.PageFooter) == null ? void 0 : _c2.$place.Height) != null ? _d2 : "0in")]].filter(([e15, t12]) => _e(e15)).forEach(([e15, s11]) => {
        C3(__spreadProps(__spreadValues({}, e15), { $place: __spreadProps(__spreadValues({}, e15 == null ? void 0 : e15.$place), { Left: _0e, Top: n11.css, Width: t11.Width }) }), w3((e16, t12, n12, i11) => r10(t12) ? (e16 && a10(e16, t12, i11), e16 && o10(e16, t12, i11)) : null), __spreadProps(__spreadValues({}, i10), { y: n11.toTwips })), n11 = n11.add(s11);
      });
      break;
    }
  }
  if (!t10.length) return [];
  const s10 = L$.min(t10.map((e15) => e15.Top));
  const l10 = L$.min(t10.map((e15) => e15.Left));
  return t10.map((e15) => {
    const t11 = "line" === e15.item.Type ? ((e16, t12, n11) => {
      const { StartPoint: r11, EndPoint: o11, $place: { Width: a11, Height: i11 } } = e16;
      const c10 = (e17) => L$.parse(e17);
      const u10 = c10(r11.X).value > c10(o11.X).value;
      const d10 = c10(r11.Y).value > c10(o11.Y).value;
      return { StartPoint: { X: u10 ? n11.subtract(l10).add(c10(a11)).css : n11.subtract(l10).css, Y: d10 ? t12.subtract(s10).add(c10(i11)).css : t12.subtract(s10).css }, EndPoint: { X: u10 ? n11.subtract(l10).css : n11.subtract(l10).add(c10(a11)).css, Y: d10 ? t12.subtract(s10).css : t12.subtract(s10).add(c10(i11)).css } };
    })(e15.item, e15.Top, e15.Left) : {};
    return __spreadValues(__spreadProps(__spreadValues({}, e15.item), { $place: __spreadProps(__spreadValues({}, e15.item.$place), { Top: e15.Top.subtract(s10).css, Left: e15.Left.subtract(l10).css }) }), t11);
  });
});
const R0e = "0pt";
function A0e(e14, t10, n10) {
  let r10 = n10;
  return e14.map((e15) => {
    const n11 = t10(e15, r10);
    return r10 = n11, n11;
  });
}
function O0e(e14, t10) {
  const n10 = (e15) => L$.parse(e15).toTwips;
  const r10 = [];
  function o10(n11, o11, a10) {
    const { path: i10, place: s10 } = a10;
    const { x: l10, y: c10 } = n11;
    const u10 = (e15) => `${Math.floor((L$.parse(e15).toTwips + l10) / 20)}pt`;
    const d10 = (e15) => `${Math.floor((L$.parse(e15).toTwips + c10) / 20)}pt`;
    const p10 = (e15) => ({ id: e15.Name, type: "box", left: u10(s10.Left || R0e), top: d10(s10.Top || R0e), width: s10.Width, height: s10.Height, highlightType: o11.Name === t10.target && t10.type || "", selected: rj(e15) });
    const m10 = (e15) => {
      const t11 = L$.parse(s10.Left).add(L$.fromTwips(l10));
      const n12 = L$.parse(s10.Top).add(L$.fromTwips(c10));
      const r11 = A0e(IQ(e15), (e16, t12) => e16.add(t12), L$.zero);
      const o12 = r11.pop();
      const a11 = A0e(HQ(e15), (e16, t12) => e16.add(t12), L$.zero);
      const i11 = a11.pop();
      return [p10(e15), ...a11.map((r12, a12) => ({ id: `${e15.Name}.Columns.${a12}`, type: "box", left: t11.add(r12).css, top: n12.css, width: R0e, height: o12.css, selected: rj(e15) })), ...r11.map((r12, o13) => ({ id: `${e15.Name}.Rows.${o13}`, type: "box", left: t11.css, top: n12.add(r12).css, width: i11.css, height: R0e, selected: rj(e15) }))];
    };
    const h10 = (e15) => {
      const t11 = L$.parse(s10.Left).add(L$.fromTwips(l10));
      const n12 = L$.parse(s10.Top).add(L$.fromTwips(c10));
      const r11 = A0e(e1(e15), (e16, t12) => e16.add(t12), L$.zero);
      const o12 = r11.pop();
      const a11 = A0e(t1(e15), (e16, t12) => e16.add(t12), L$.zero);
      const i11 = a11.pop();
      return [p10(e15), ...a11.map((r12, a12) => ({ id: `${e15.Name}.Columns.${a12}`, type: "box", left: t11.add(r12).css, top: n12.css, width: R0e, height: o12.css, selected: rj(e15) })), ...r11.map((r12, o13) => ({ id: `${e15.Name}.Rows.${o13}`, type: "box", left: t11.css, top: n12.add(r12).css, width: i11.css, height: R0e, selected: rj(e15) }))];
    };
    const f10 = o11 && o11.Type;
    var g10;
    if ((GW(f10) || _W(f10)) && (o11.$fixedPlace && !Eee(e14, i10) && r10.push({ id: (g10 = o11).Name, type: "box", left: u10(s10.Left), top: d10(s10.Top), width: g10.$fixedPlace.Width || g10.$place.Width, height: g10.$fixedPlace.Height || g10.$place.Height, selected: rj(g10) }), "fixedpagesection" === f10 || o11.$place)) {
      const e15 = ((e16) => {
        switch (e16) {
          case rW.line:
            return (e17) => {
              return [(t11 = e17, { id: t11.Name, type: "line", left: u10(s10.Left), top: d10(s10.Top), width: s10.Width, height: s10.Height, startPoint: { X: u10(t11.StartPoint.X), Y: d10(t11.StartPoint.Y) }, endPoint: { X: u10(t11.EndPoint.X), Y: d10(t11.EndPoint.Y) }, selected: rj(t11) })];
              var t11;
            };
          case rW.fplTable:
          case rW.table:
            return (e17) => [...h10(e17)];
          case rW.tablix:
          case rW.fplTablix:
            return (e17) => [...m10(e17)];
          default:
            return (e17) => [p10(e17)];
        }
      })(o11.Type);
      r10.push(...e15(o11));
    }
  }
  return C3(e14, w3(x3((e15, t11, r11, a10) => ((e16) => e16 && aj(e16) || e16.Type === rW.section || e16.Type === rW.pagesection)(t11) ? (o10(e15, t11, a10), function({ x: e16, y: t12 }, r12) {
    return { x: e16 + n10(r12.Left || R0e), y: t12 + n10(r12.Top || R0e) };
  }(e15, a10 == null ? void 0 : a10.place)) : null)), { x: 0, y: 0 }), r10;
}
function B0e(e14, t10, n10, r10) {
  const o10 = (e15) => `${Math.floor(e15 / 20)}pt`;
  const a10 = [...t10.adjacent.map((e15) => e15 + n10), t10.adjacent1];
  t10.adjacent2 && a10.push(t10.adjacent2), a10.sort((e15, t11) => e15 - t11);
  const i10 = null !== r10.min ? L$.max([L$.fromTwips(a10[0]), r10.min]).toTwips : a10[0];
  const s10 = null !== r10.max ? L$.min([L$.fromTwips(a10[a10.length - 1]), r10.max]).toTwips : a10[a10.length - 1];
  const l10 = o10(s10);
  const c10 = o10(t10.closest.pabs);
  return { left: "vsnap" === e14 ? c10 : l10, top: "vsnap" === e14 ? l10 : c10, length: o10(i10 - s10), type: e14 };
}
function z0e(e14, t10, n10) {
  const r10 = [];
  const { vLimits: o10, hLimits: a10 } = function(e15) {
    var _a2, _b2;
    const t11 = { min: null, max: null };
    const n11 = { min: null, max: null };
    const r11 = function(e16) {
      var _a3, _b3, _c2, _d2, _e2, _f2;
      switch (e16.Type) {
        case "multisectionreport":
          return e16.ReportSections[e16.$activeSectionIndex].Page;
        case "fixedpagereport": {
          const t12 = e16.Pages[e16.$activePageIndex];
          return __spreadProps(__spreadValues({}, t12), { PageHeight: (_a3 = t12.Height) != null ? _a3 : e16.Page.PageHeight, PageWidth: (_b3 = t12.Width) != null ? _b3 : e16.Page.PageWidth, TopMargin: (_c2 = t12.TopMargin) != null ? _c2 : e16.Page.TopMargin, RightMargin: (_d2 = t12.RightMargin) != null ? _d2 : e16.Page.RightMargin, BottomMargin: (_e2 = t12.BottomMargin) != null ? _e2 : e16.Page.BottomMargin, LeftMargin: (_f2 = t12.LeftMargin) != null ? _f2 : e16.Page.LeftMargin });
        }
        default:
          return e16.Page;
      }
    }(e15);
    if (!r11) return { vLimits: t11, hLimits: n11 };
    if (t11.min = L$.parseSafe(r11.TopMargin), n11.min = L$.parseSafe(r11.LeftMargin), "fixedpagereport" === e15.Type && (t11.max = L$.parse(r11.PageHeight).subtract(L$.parse(r11.BottomMargin)), n11.max = L$.parse(r11.PageWidth).subtract(L$.parse(r11.RightMargin))), "dashboard" === e15.Type) {
      const t12 = e15.ReportSections[e15.$activeSectionIndex];
      return { vLimits: { min: L$.parse(R0e), max: L$.parse((_a2 = t12 == null ? void 0 : t12.Body.$place.Height) != null ? _a2 : R0e) }, hLimits: { min: L$.parse(R0e), max: L$.parse((_b2 = t12 == null ? void 0 : t12.Width) != null ? _b2 : R0e) } };
    }
    return { vLimits: t11, hLimits: n11 };
  }(t10);
  if (e14) {
    const { dx: t11, dy: n11 } = e14;
    e14.vsnaps.forEach((e15) => {
      e15.snapType && "snapline" === e15.snapType && r10.push(B0e("vsnap", e15, n11, o10));
    }), e14.hsnaps.forEach((e15) => {
      e15.snapType && "snapline" === e15.snapType && r10.push(B0e("hsnap", e15, t11, a10));
    });
  }
  return r10.push(...O0e(t10, n10)), r10;
}
const $0e = (e14, t10, n10, r10, o10) => ({ item: e14, side: t10, pos: n10, adjacent: r10, pointType: o10 });
const W0e = (e14, t10) => {
  let n10 = e14.toTwips;
  return t10.loc && (n10 += t10.loc.pabs), { distance: e14, pabs: n10, rel: t10 };
};
const j0e = (e14) => ({ name: e14, loc: null });
const Z0e = (e14, t10, { x: n10, y: r10 } = { x: j0e(e14), y: j0e(e14) }) => {
  if (!t10.Width && !t10.Height) return { x: [], y: [] };
  const o10 = t10.Left;
  const a10 = t10.Top;
  const i10 = o10.add(t10.Width || L$.zero);
  const s10 = a10.add(t10.Height || L$.zero);
  const [l10, c10, u10, d10] = [W0e(a10, r10), W0e(s10, r10), W0e(o10, n10), W0e(i10, n10)];
  const p10 = [l10.pabs, c10.pabs];
  const m10 = [u10.pabs, d10.pabs];
  return { x: [$0e(e14, "w", u10, p10, "boundary"), $0e(e14, "e", d10, p10, "boundary")], y: [$0e(e14, "n", l10, m10, "boundary"), $0e(e14, "s", c10, m10, "boundary")] };
};
const G0e = (e14, t10) => t10 ? e14.Name === t10 : sj(e14);
const U0e = (e14, t10, n10, r10, o10, a10, i10, s10, l10) => {
  let c10 = { x: [], y: [] };
  const u10 = { x: [], y: [] };
  let d10;
  d10 = N0(e14) || D0(e14) ? e14.ReportSections[e14.$activeSectionIndex] : e14;
  const p10 = (e15, s11, p11) => {
    if (!GW(s11.Type) && !_W(s11.Type) && !QW(s11.Type)) return;
    const { place: m11 = {} } = p11;
    const { x: h11, y: f10 } = e15;
    if (m11 && h11 && f10) {
      if (o10) {
        const e16 = rj(s11) ? u10 : c10;
        const t11 = i10 && i10(s11, m11);
        if (!t11) return;
        const n11 = Z0e(s11.Name, t11, { x: h11, y: f10 });
        n11.x && n11.x.length && e16.x.push(...n11.x), n11.y && n11.y.length && e16.y.push(...n11.y);
      }
      if (a10 && r10) {
        if (G0e(s11, t10)) {
          const e16 = i10 && i10(s11, m11);
          if (!e16) return;
          const t11 = Z0e(s11.Name, e16, { x: h11, y: f10 });
          t11.x && t11.x.length && u10.x.push(...t11.x), t11.y && t11.y.length && u10.y.push(...t11.y);
        }
        (((e16, t11, n11) => e16.Name === n11 && t11 !== n11)(s11, t10, r10) || ((e16, t11, n11, r11) => {
          var _a2;
          return t11 === r11 && _W(n11 != null ? n11 : "") && _W(e16.Type) && ((_a2 = e16.ReportItems) == null ? void 0 : _a2.some((e17) => _W(e17.Type) && G0e(e17, t11)));
        })(s11, t10, n10, r10) || ((e16, t11, n11, r11) => {
          var _a2;
          return t11 !== r11 && tj(n11 != null ? n11 : "") && _W(e16.Type) && ((_a2 = e16.ReportItems) == null ? void 0 : _a2.some((e17) => tj(e17.Type) && G0e(e17, t11) && o3(e17).some((e18) => e18.Name === r11)));
        })(s11, t10, n10, r10)) && (c10 = function(e16, t11, n11, r11, o11, a11, i11) {
          const s12 = r11 || { x: [], y: [] };
          const l11 = n11.Left || L$.zero;
          const c11 = n11.Top || L$.zero;
          const u11 = L$.parse(i11 || "1in");
          const d11 = q0e(e16, t11.Name);
          const p12 = Math.floor(d11.Width.divide(u11));
          const m12 = Math.floor(d11.Height.divide(u11));
          for (let e17 = 0; e17 <= p12; e17++) {
            const [n12, r12] = [W0e(u11.multiply(0).add(c11), a11), W0e(u11.multiply(e17).add(l11), o11)];
            const i12 = [n12.pabs, n12.pabs];
            s12.x.push($0e(t11.Name, "w", r12, i12, "grid"));
          }
          for (let e17 = 0; e17 <= m12; e17++) {
            const [n12, r12] = [W0e(u11.multiply(e17).add(c11), a11), W0e(u11.multiply(0).add(l11), o11)];
            const i12 = [r12.pabs, r12.pabs];
            s12.y.push($0e(t11.Name, "n", n12, i12, "grid"));
          }
          return s12;
        }(d10, s11, m11, c10, h11, f10, l10));
      }
    }
  };
  const m10 = { x: { name: e14.Name || "report", loc: null }, y: { name: e14.Name || "report", loc: null }, parentPath: "" };
  C3(e14, w3((e15, t11, n11, r11) => "function" != typeof s10 || s10(t11) ? ((e16) => F0(e16) && !e16.$active)(t11) || ((e16) => (k0(e16) || P0(e16)) && !e16.$active)(t11) ? null : (p10(e15, t11, r11), ((e16) => e16 && !((IW(e16.Type) || tj(e16.Type)) && rj(e16)))(t11) ? ((e16, t12, n12, r12) => {
    const { x: o11, y: a11 } = e16;
    const { place: i11 } = r12;
    return { x: { name: t12.Name, loc: W0e(i11.Left || L$.zero, o11) }, y: { name: t12.Name, loc: W0e(i11.Top || L$.zero, a11) } };
  })(e15, t11, 0, r11) : null) : null), m10);
  const h10 = (e15, t11) => Math.sign(e15.pos.pabs - t11.pos.pabs);
  return c10.x.sort(h10), c10.y.sort(h10), u10.x.sort(h10), u10.y.sort(h10), { fixedPoints: c10, movingPoints: u10 };
};
const q0e = (e14, t10, n10 = 1, r10 = 1) => {
  const o10 = (e15, t11) => {
    var _a2;
    let n11;
    return "fixedpagereport" === e15.Type && t11 && (n11 = (_a2 = e15.Pages) == null ? void 0 : _a2.find((e16) => e16.Name === t11)), { Width: h3(e15, n11), Height: f3(e15, n11) };
  };
  if (e14.Type === rW.fplReport) return o10(e14, t10);
  const a10 = o10(e14);
  const i10 = { Width: L$.parse(e14.Width), Height: ((e15) => {
    const { Body: t11, PageHeader: n11, PageFooter: r11 } = e15;
    let o11 = L$.parse(t11.$place.Height);
    return n11 && (o11 = o11.add(L$.parse(n11.$place.Height))), r11 && (o11 = o11.add(L$.parse(r11.$place.Height))), o11;
  })(e14) };
  const s10 = Math.ceil(i10.Width.divide(a10.Width));
  const l10 = Math.ceil(i10.Height.divide(a10.Height));
  return { Width: a10.Width.multiply(s10 + n10), Height: a10.Height.multiply(l10 + r10) };
};
function Y0e(e14) {
  if (!e14) return [];
  const t10 = [];
  for (let n10 = e14; n10; n10 = n10.rel.loc) t10.push(n10.rel.name);
  return t10;
}
const K0e = (e14, t10) => {
  for (let n10 = e14.length - 1, r10 = t10.length - 1; n10 >= 0 && r10 >= 0; n10--, r10--) if (e14[n10] !== t10[r10]) return e14.length - n10 - 1;
  return Math.min(e14.length, t10.length);
};
const X0e = (e14, t10, n10, r10) => {
  const o10 = [];
  t10.forEach((t11) => {
    const a11 = t11.pos.pabs + n10;
    const i11 = ((e15, t12) => {
      let n11 = 0;
      let r11 = e15.length - 1;
      if (r11 < 0) return NaN;
      if (t12 <= e15[n11].pos.pabs) return e15[n11].pos.pabs;
      if (t12 >= e15[r11].pos.pabs) return e15[r11].pos.pabs;
      for (; r11 - n11 > 1; ) {
        const o12 = Math.floor((r11 + n11) / 2);
        const a13 = e15[o12].pos.pabs;
        if (a13 === t12) return a13;
        a13 > t12 ? r11 = o12 : n11 = o12;
      }
      const o11 = e15[n11].pos.pabs;
      const a12 = e15[r11].pos.pabs;
      return Math.abs(o11 - t12) < Math.abs(a12 - t12) ? o11 : a12;
    })(e14, a11);
    const s10 = a11 - i11;
    if (Math.abs(s10) > r10) return;
    if (t11.pos.distance.toTwips + n10 + s10 < 0) return;
    const l10 = e14.findIndex((e15) => e15.pos.pabs === i11);
    if (l10 < 0) return;
    const c10 = Y0e(t11.pos);
    let u10 = e14[l10].pos;
    let d10 = 0;
    let p10 = null;
    let m10 = 1 / 0;
    let h10 = 0;
    const f10 = (e15) => {
      [m10, h10] = [Math.min(e15, m10), Math.max(e15, h10)];
    };
    for (let t12 = l10, n11 = e14.length; t12 < n11 && e14[t12].pos.pabs === i11; t12++) {
      const n12 = e14[t12];
      const r11 = Y0e(n12.pos);
      const o11 = K0e(c10, r11);
      if (o11 <= 0) throw new Error("failed to find common parent");
      const a12 = "boundary" === n12.pointType;
      (o11 > d10 && "snapline" !== p10 || a12) && (o11 > d10 && (d10 = o11, u10 = n12.pos), p10 = a12 ? "snapline" : "snapgrid"), a12 && n12.adjacent.forEach(f10);
    }
    const g10 = ((e15, t12) => {
      const [n11, r11] = [Y0e(t12), Y0e(e15)];
      const o11 = K0e(n11, r11);
      let a12 = new L$(0, t12 && t12.distance && t12.distance.units || "in");
      for (let t13 = e15, n12 = r11.length - o11; t13 && n12-- >= 0; t13 = t13.rel.loc) a12 = a12.subtract(t13.distance);
      for (let e16 = t12, r12 = n11.length - o11; e16 && r12-- >= 0; e16 = e16.rel.loc) a12 = a12.add(e16.distance);
      return a12;
    })(t11.pos.rel.loc, u10);
    const { item: y10, side: v10, adjacent: b10 } = t11;
    o10.push({ item: y10, side: v10, adjacent: b10, closest: u10, relpos: g10, adjacent1: m10, adjacent2: m10 === h10 ? null : h10, deviation: s10, snapType: p10 });
  });
  const { nearestSnaps: a10, deltaToSnap: i10 } = J0e(o10);
  return { snaps: a10, delta: n10 - i10 };
};
const J0e = (e14) => {
  if (0 === e14.length) return { nearestSnaps: e14, deltaToSnap: 0 };
  const t10 = e14.reduce((e15, t11) => Math.abs(e15.deviation) < Math.abs(t11.deviation) ? e15 : t11).deviation;
  return { nearestSnaps: e14.filter((e15) => e15.deviation === t10), deltaToSnap: t10 };
};
const Q0e = L$.fromPixels(1).toTwips;
function e2e(e14, t10, n10 = "", r10 = [], o10 = []) {
  const a10 = N0e(e14.getDifferenceFromInitialOffset(), t10);
  const i10 = e14.getItem();
  const s10 = i10.move && r10.every((e15) => e15.Name !== n10) && o10.every((e15) => e15 !== n10);
  const l10 = s10 && i10.host !== n10;
  return { itemType: e14.getItemType(), item: i10, clientOffset: N0e(e14.getClientOffset(), t10), initialClientOffset: N0e(e14.getInitialClientOffset(), t10), initialSourceClientOffset: i10.byMoveGrip ? N0e(e14.getInitialSourceClientOffset(), t10) : e14.getInitialSourceClientOffset(), delta: a10, containerChanged: l10, isAllowedContainer: s10 };
}
const t2e = H0e(U0e);
const n2e = H0e((e14) => (t10) => k3(t10, e14).isVisible);
const r2e = H0e((e14, t10) => {
  if (!e14 || !t10) return null;
  if (!e14.$fixedPlace) return t10;
  const n10 = e14.$fixedPlace.Width ? L$.parse(e14.$fixedPlace.Width) : t10.Width;
  const r10 = e14.$fixedPlace.Height ? L$.parse(e14.$fixedPlace.Height) : t10.Height;
  return { Top: t10.Top, Left: t10.Left, Width: n10, Height: r10 };
});
function o2e(e14, t10, n10) {
  let [r10, o10] = [0, 0];
  if (e14.clientOffset && e14.initialClientOffset && e14.initialSourceClientOffset) {
    const a10 = e14.clientOffset;
    const i10 = t10 == null ? void 0 : t10.getBoundingClientRect();
    const s10 = nz.of(n10).create(e14.item.reportItemType || e14.item.itemType || "textbox", void 0, e14.item.templateId, "partitem" === e14.item.itemType || "fixedpagepartitem" === e14.item.itemType ? { $place: e14.item.$place } : void 0);
    const l10 = L$.toPixels(L$.parse(s10.$place.Width).divideByNum(2));
    const c10 = L$.toPixels(L$.parse(s10.$place.Height).divideByNum(2));
    [r10, o10] = [a10.x - i10.left - l10, a10.y - i10.top - c10];
  }
  return { dx: r10 * Q0e, dy: o10 * Q0e };
}
function a2e(e14, t10) {
  let [n10, r10] = [0, 0];
  if (e14.clientOffset && e14.initialClientOffset && e14.initialSourceClientOffset) {
    const o10 = e14.clientOffset;
    const a10 = t10.getBoundingClientRect();
    const { item: { name: i10, movedItems: s10 = [] } } = e14;
    const l10 = (e15) => L$.toPixels(L$.parse(e15));
    const c10 = (e15, t11) => e15 && t11 ? [t11.x - e15.x, t11.y - e15.y] : [0, 0];
    const u10 = s10.find((e15) => e15.Name === i10);
    const [d10, p10] = c10(e14.initialClientOffset, e14.initialSourceClientOffset);
    [n10, r10] = [o10.x - a10.left + d10 - l10(u10.$place.Left), o10.y - a10.top + p10 - l10(u10.$place.Top)];
  }
  return { dx: n10 * Q0e, dy: r10 * Q0e };
}
const i2e = (e14, t10, n10, r10) => {
  const { name: o10, path: a10, ref: i10 } = e14;
  if (!i10) return null;
  const { instanceId: s10, userPreferences: { surface: { snapToLines: l10, snapToGrid: c10, gridSize: u10 } } } = n10;
  const d10 = ["resizegrip", "placeHolderResizeGrip"].includes(t10.itemType) ? t10.item.grips : qG.MC;
  const p10 = L$.parse(c10 ? u10 : "1mm").toTwips;
  const { reportState: m10 = r10, movedItems: h10 = [] } = t10.item;
  const f10 = m10.$currentLayerName;
  const [g10, y10] = t10.delta && [t10.delta.x * Q0e, t10.delta.y * Q0e] || [0, 0];
  let v10;
  let b10 = m10;
  let S10;
  const C10 = ["field", "value", "toolboxItem", "smartSuggestion", "partItem", "entity_relation", "dataset", "fields"].includes(t10.itemType);
  const x10 = (e15, n11) => {
    const r11 = d10.includes("fpl");
    let a11 = t2e(b10, C10 ? null : t10.item.name, C10 ? null : t10.item.reportItemType || t10.item.itemType, o10, l10, c10, r11 ? r2e : (e16, t11) => t11, n2e(b10), u10);
    const i11 = r11 ? h10.filter((e16) => e16.$fixedPlace && (e16.$fixedPlace.Width || e16.$fixedPlace.Height)) : h10;
    return a11 = r11 ? function(e16, t11, n12) {
      const r12 = n12.map((e17) => e17.Name) || [];
      const o11 = { $apply: (e17) => e17.filter((e18) => r12.includes(e18.item)) };
      return AV(e16, { movingPoints: { x: o11, y: o11 } });
    }(a11, 0, i11) : a11, a11 = function(e16, t11, n12, r12) {
      const o11 = (e17) => ({ $apply: (t12) => t12.filter((t13) => t13.side === e17) });
      return t11.indexOf(qG.C) >= 0 && t11.indexOf(qG.M) >= 0 ? n12 ? e16 : r12 ? AV(e16, { movingPoints: { x: o11(qG.W), y: o11(qG.N) } }) : e16 : (() => {
        const n13 = {};
        return t11.includes(qG.W) ? n13.x = o11(qG.W) : t11.includes(qG.E) ? n13.x = o11(qG.E) : n13.x = { $set: [] }, t11.includes(qG.S) ? n13.y = o11(qG.S) : t11.includes(qG.N) ? n13.y = o11(qG.N) : n13.y = { $set: [] }, AV(e16, { movingPoints: n13 });
      })();
    }(a11, d10, l10, c10), (({ fixedPoints: e16, movingPoints: t11 }, { dx: n12, dy: r12 }, o11) => {
      const { snaps: a12, delta: i12 } = X0e(e16.x, t11.x, n12, o11);
      const { snaps: s11, delta: l11 } = X0e(e16.y, t11.y, r12, o11);
      return { vsnaps: a12, hsnaps: s11, dx: i12, dy: l11 };
    })(a11, n11, p10);
  };
  let w10 = [];
  try {
    let e15;
    if (C10 || t10.containerChanged) {
      const n12 = "reportitem" !== t10.itemType ? f10 : void 0;
      w10 = C10 ? function(e16, t11, n13, r11, o11) {
        const a11 = e16.item.reportItemType || e16.item.itemType || "textbox";
        const { templateId: i11 } = e16.item;
        const { reportItem: s11 } = e16.item;
        const l12 = s11 != null ? s11 : nz.of(n13).create(a11, FG(TG(a11)), i11, "partitem" === a11 || "fixedpagepartitem" === a11 ? { $place: e16.item.$place } : void 0);
        const { $place: c12, $place: { Top: u12, Left: d11 } } = l12;
        const p11 = __spreadProps(__spreadValues({}, l12), { $place: __spreadProps(__spreadValues({}, c12), { Top: new L$(0, L$.parse(u12).units).css, Left: new L$(0, L$.parse(d11).units).css }) });
        const m11 = [c5(t11)];
        const h11 = "entity_relation" === e16.itemType || "dataset" === e16.itemType || "fields" === e16.itemType ? tU({ properties: e16.item.properties, fillData: __spreadProps(__spreadValues({}, e16.item.fillData), { maxSize: r11 }) }, { currentLayerName: o11 }) : KG({ items: [p11] }, { currentLayerName: o11 });
        return m11.push(h11), m11;
      }(t10, a10, s10, "fixedpagereport" === b10.Type ? p3(b10, o10) : null, n12) : function(e16, t11, n13) {
        const { item: { movedItems: r11 = [] } } = e16;
        return [JG(), h5([t11]), KG({ items: r11 }, { currentLayerName: n13 })];
      }(t10, o10, n12), e15 = (C10 ? o2e : a2e)(t10, i10, s10), b10 = w10.reduce(n5, b10);
    } else e15 = { dx: g10, dy: y10 };
    switch (d10) {
      case qG.N:
      case qG.NC:
      case qG.S:
      case qG.SC:
        Object.assign(e15, { dx: 0 });
        break;
      case qG.E:
      case qG.ME:
      case qG.W:
      case qG.MW:
        Object.assign(e15, { dy: 0 });
    }
    v10 = x10(0, e15);
    const { userPreferences: { units: n11 } } = KO.of(s10);
    const { path: l11 } = vj(r10).filter((e16) => ij(e16.item))[0];
    const c11 = Eee(r10, l11);
    const u11 = function(e16, t11, n12, r11, o11 = false) {
      const a11 = {};
      const [i11, s11] = (r11 && [r11.dx, r11.dy] || e16 && [e16.dx, e16.dy] || [0, 0]).map((e17) => L$.fromTwips(e17, t11));
      return r11 && (r11.vsnaps.forEach(({ item: e17, relpos: t12, side: n13, snapType: r12 }) => {
        a11[e17] = { x: t12.css, xs: n13, snapType: r12 };
      }), r11.hsnaps.forEach(({ item: e17, relpos: t12, side: n13, snapType: r12 }) => {
        a11[e17] = __spreadValues({ y: t12.css, ys: n13, snapType: r12 }, a11[e17]);
      })), YG({ grip: n12, delta: { x: i11.css, y: s11.css }, snaps: a11, isItemInFixedArea: o11 });
    }(e15, n11, d10, v10, c11);
    w10.push(u11), b10 = n5(b10, u11);
  } catch (e15) {
    b10 = function(e16, t11) {
      var _a2, _b2;
      return [h5(["fixedpagereport" === t11.Type ? (_b2 = (_a2 = t11.Pages[t11.$activePageIndex]) == null ? void 0 : _a2.Name) != null ? _b2 : t11.Name : e16])];
    }(o10, m10).reduce(n5, b10), S10 = e15, w10 = S10 && S10.type ? w10 : [];
  }
  return { reportState: b10, snapResult: v10, actions: w10, error: S10 };
};
const s2e = H0e(I0e((e14, t10, n10, r10, o10) => {
  const a10 = i2e(e14, t10, n10, r10);
  if (!a10) return;
  const { snapResult: i10, reportState: s10, error: l10 } = a10;
  let c10 = {};
  ["reportitem", "toolboxItem", "smartSuggestion"].some((e15) => e15 === t10.itemType && t10.isAllowedContainer) && (c10 = { target: e14.name, type: l10 ? "error" : "can-drop" });
  const u10 = z0e(i10, s10, c10);
  P0e(e14.name, u10, o10);
}), (e14, t10) => t10.delta);
const l2e = (e14, t10) => e14.reduce((e15, n10) => e15.concat(((e16, t11) => {
  const n11 = t11.find((t12) => t12.name === e16);
  if (n11 && (VW(n11.type) || tj(n11.type))) {
    const e17 = t11.filter((e18) => e18.leftKey > n11.leftKey && e18.rightKey < n11.rightKey && e18.level > n11.level);
    return e17.map((e18) => e18.name);
  }
  return [];
})(n10, t10)), []);
const c2e = (e14) => {
  const { StartPoint: t10, EndPoint: n10, thickness: r10, regionLineProps: o10, lineStyle: a10, dataPath: i10, dataType: s10 } = e14;
  const l10 = { x: L$.parseSafe(t10.X), y: L$.parseSafe(t10.Y) };
  const c10 = { x: L$.parseSafe(n10.X), y: L$.parseSafe(n10.Y) };
  const u10 = l10.y.lowerThan(c10.y);
  const d10 = l10.x.lowerThan(c10.x);
  const p10 = l10.y.equal(c10.y);
  const m10 = l10.x.equal(c10.x);
  const h10 = (e15, t11) => e15.lowerThanOrEqual(t11) ? e15 : t11;
  const f10 = h10(l10.y, c10.y);
  const g10 = h10(l10.x, c10.x);
  const y10 = c10.x.subtract(l10.x);
  const v10 = c10.y.subtract(l10.y);
  const b10 = L$.parseSafe(r10 || "0pt");
  const S10 = y10.equal(L$.zero) ? Math.atan(v10.greaterThan(L$.zero) ? -1 / 0 : 1 / 0) : Math.atan(v10.divide(y10));
  const C10 = `(${Math.cos(S10).toFixed(4)} * ${b10.css}/2)`;
  const x10 = d10 && !u10 && !p10 || u10 && !d10 && !p10 ? `100% - ${C10}` : `0pt - ${C10}`;
  const w10 = `(${Math.sin(S10).toFixed(4)} * ${b10.css}/2)`;
  const T10 = b10.multiply(0.5);
  const E10 = __spreadProps(__spreadValues({}, o10), { "data-path": i10, "data-type": s10, style: { top: `calc(${f10.css} - ${p10 ? T10.css : "0pt"})`, left: `calc(${g10.css} - ${m10 ? T10.css : "0pt"})`, width: (y10.equal(L$.zero) ? b10 : y10.abs()).css, height: (v10.equal(L$.zero) ? b10 : v10.abs()).css } });
  const F10 = __spreadProps(__spreadValues({}, a10), { top: `calc(${x10} + ${p10 ? T10.css : "0pt"})`, left: `calc(${w10} + ${m10 ? T10.css : "0pt"})`, height: b10.css, width: (y10.equal(L$.zero) ? v10.abs() : v10.equal(L$.zero) ? y10.abs() : L$.fromTwips(Math.sqrt(__pow(y10.toTwips, 2) + __pow(v10.toTwips, 2)))).css, transform: `rotate(${S10}rad)`, transformOrigin: "top left" });
  return tp.createElement("div", __spreadValues({}, E10), tp.createElement("div", { "data-path": i10, "data-type": s10, style: F10 }));
};
const u2e = FZ.resultOf(wq.decode({ Type: "line", Name: "line1", StartPoint: { X: "0in", Y: "0in" }, EndPoint: { X: "1in", Y: "0in" } }));
var d2e;
!function(e14) {
  e14.TOP_LEFT = "TopLeft", e14.BOTTOM_LEFT = "BottomLeft", e14.TOP_RIGHT = "TopRight", e14.BOTTOM_RIGHT = "BottomRight";
}(d2e || (d2e = {}));
const p2e = (e14) => {
  const t10 = /^\d+(\.\d+)?(pt|in|px|cm|pc|mm)$/.exec(e14);
  const [n10, r10, o10] = t10 || [];
  return o10 ? "px" === o10 ? parseFloat(e14) : L$.toPixels(L$.parse(e14)) : 0;
};
const m2e = (e14, t10) => 2 * Math.PI * e14 * 0.25 / 4 * t10;
const h2e = { getOffset: (e14, t10) => {
  let n10 = 0;
  switch (t10) {
    case d2e.TOP_RIGHT:
      n10 = Math.max(-e14.x, e14.y);
      break;
    case d2e.BOTTOM_RIGHT:
      n10 = Math.max(-e14.x, -e14.y);
      break;
    case d2e.BOTTOM_LEFT:
      n10 = Math.max(e14.x, -e14.y);
      break;
    default:
      n10 = Math.max(e14.x, e14.y);
  }
  return n10;
}, rectAngleCalcs: (e14, t10) => {
  const { side: n10, allSidesMode: r10, zoomFactor: o10 } = t10;
  const a10 = e14.getBoundingClientRect();
  const { width: i10, height: s10 } = a10;
  const l10 = Math.min(i10, s10) / 2;
  const c10 = m2e(l10, o10);
  return { borderRadiusDirection: r10 ? n10 : "", maxGripPosition: c10 * Math.sin(Math.PI / 4), maxRadiusRect: l10, gripMargin: 0.3 * c10, guideSize: c10 };
}, getNewBorderRadius: (e14) => (t10) => p2e(t10.style[`border${e14 || d2e.TOP_LEFT}Radius`]), calcRadiusByGripPosition: (e14, t10) => e14 / t10 * 4 / 2 / Math.PI / 0.25 * Math.sin(Math.PI / 4) * 2, calcGripPosition: (e14, t10) => m2e(e14, t10) * Math.sin(Math.PI / 4), directGripBySide: (e14, t10, n10) => {
  const r10 = n10 > 1 ? 50 * Math.sin(Math.PI / 4) : 50;
  switch (e14) {
    case d2e.TOP_RIGHT:
      return `translate(-${t10}px, ${t10}px) translate(${r10}%,-${r10}%)`;
    case d2e.BOTTOM_RIGHT:
      return `translate(-${t10}px, -${t10}px) translate(${r10}%, ${r10}%)`;
    case d2e.BOTTOM_LEFT:
      return `translate(${t10}px, -${t10}px) translate(-${r10}%, ${r10}%)`;
  }
  return `translate(${t10}px, ${t10}px) translate(-${r10}%, -${r10}%)`;
}, getGripGuideRotationBySide: (e14) => {
  switch (e14) {
    case d2e.TOP_RIGHT:
      return "rotate(45deg) translateX(50%)";
    case d2e.BOTTOM_RIGHT:
      return "rotate(-45deg) translateX(50%)";
    case d2e.BOTTOM_LEFT:
      return "rotate(45deg) translateX(-50%)";
  }
  return "rotate(-45deg) translateX(-50%)";
}, translateSideToGripGuide: (e14) => {
  switch (e14) {
    case d2e.TOP_RIGHT:
      return "right top";
    case d2e.BOTTOM_RIGHT:
      return "right bottom";
    case d2e.BOTTOM_LEFT:
      return "left bottom";
  }
  return "left top";
}, checkEqualSides: (e14) => {
  const { BottomLeft: t10 = 0, TopLeft: n10 = 0, BottomRight: r10 = 0, TopRight: o10 = 0 } = e14 || {};
  const [a10, i10, s10, l10] = [t10, n10, r10, o10].map((e15) => "string" == typeof e15 ? +p2e(e15).toFixed() : e15);
  return (a10 + i10 + s10 + l10) / 4 === a10;
} };
const f2e = (e14) => {
  const { documentItem: t10, side: n10, rectRef: r10, setIsRounding: o10, allSidesMode: a10 } = e14;
  if (!(r10 == null ? void 0 : r10.current)) return null;
  const { t: i10 } = vp("adorners");
  const s10 = PA();
  const { userPreferences: { surface: { zoomFactor: l10 }, units: c10 } } = MO();
  const { rectAngleCalcs: u10, getNewBorderRadius: d10, calcGripPosition: p10, calcRadiusByGripPosition: m10, directGripBySide: h10, translateSideToGripGuide: f10, getGripGuideRotationBySide: g10 } = h2e;
  const { borderRadiusDirection: y10, maxGripPosition: v10, maxRadiusRect: b10, gripMargin: S10, guideSize: C10 } = u10(r10.current, { side: n10, allSidesMode: a10, zoomFactor: l10 });
  const x10 = d10(y10);
  const [w10, T10] = ep.useState($4(p10(x10(r10.current), l10), S10, v10));
  const E10 = (e15) => {
    if (r10.current) {
      const t11 = $4(e15 + w10, 0, v10);
      T10(t11), F10(m10(t11, l10));
    }
  };
  const F10 = (e15) => {
    if (r10.current) {
      const t11 = $4(e15, 0, b10);
      r10.current.style[`border${y10}Radius`] = `${t11}px`;
    }
  };
  const [{ isDragging: M10 }, k10, P10] = Yne({ item: { type: "rectRounding", gripSide: n10, transformGrip: E10 }, collect: (e15) => ({ isDragging: e15.isDragging() }), begin: () => ((r10 == null ? void 0 : r10.current) && (o10(true), r10.current.classList.add("shape-rounding")), { type: "rectRounding", gripSide: n10, transformGrip: E10 }), end: () => {
    (r10 == null ? void 0 : r10.current) && (o10(false), ((e15) => {
      let r11 = {};
      const o11 = L$.fromPixels(e15, c10).css;
      r11 = a10 ? __spreadProps(__spreadValues({}, t10.RoundingRadius), { [n10]: o11 }) : __spreadProps(__spreadValues({}, t10.RoundingRadius), { [d2e.TOP_LEFT]: o11, [d2e.TOP_RIGHT]: o11, [d2e.BOTTOM_LEFT]: o11, [d2e.BOTTOM_RIGHT]: o11 }), s10(s2(vY.Corners, r11));
    })(x10(r10.current)), r10.current.classList.remove("shape-rounding"));
  } });
  ep.useEffect(() => {
    P10(Coe(), { captureDraggingState: false });
  }, [P10]), ep.useEffect(() => {
    r10.current && T10($4(p10(x10(r10.current), l10), S10, v10));
  }, [t10.RoundingRadius, t10.Width, t10.Height, l10, v10, S10]);
  const N10 = { "grip-angle-tl": n10 === d2e.TOP_LEFT, "grip-angle-tr": n10 === d2e.TOP_RIGHT, "grip-angle-bl": n10 === d2e.BOTTOM_LEFT, "grip-angle-br": n10 === d2e.BOTTOM_RIGHT };
  const D10 = kp("grip-angle", N10);
  const L10 = { position: "absolute", cursor: "pointer", transform: h10(n10, w10, l10) };
  return tp.createElement(tp.Fragment, null, M10 && tp.createElement("div", { style: { height: C10, transformOrigin: f10(n10), transform: g10(n10) }, className: kp("grip-angle-guide", N10) }), tp.createElement("div", { className: D10, style: L10, ref: k10, title: i10(a10 ? "shapeRoundingTip.multiCornerMode" : "shapeRoundingTip.singleCornerMode") }));
};
const g2e = (e14) => {
  const { documentItem: t10 } = e14;
  const [n10, r10] = ep.useState(!h2e.checkEqualSides(t10.RoundingRadius));
  const o10 = ep.useCallback((e15) => {
    "Alt" === e15.key && (e15.preventDefault(), r10(!n10));
  }, [n10]);
  ep.useEffect(() => (window.addEventListener("keyup", o10), () => {
    window.removeEventListener("keyup", o10);
  }), [o10]);
  const a10 = __spreadProps(__spreadValues({}, e14), { allSidesMode: n10 });
  return tp.createElement("div", { style: { width: "100%", height: "100%" } }, tp.createElement(f2e, __spreadValues({ side: d2e.TOP_LEFT }, a10)), n10 && tp.createElement(tp.Fragment, null, tp.createElement(f2e, __spreadValues({ side: d2e.TOP_RIGHT }, a10)), tp.createElement(f2e, __spreadValues({ side: d2e.BOTTOM_LEFT }, a10)), tp.createElement(f2e, __spreadValues({ side: d2e.BOTTOM_RIGHT }, a10))));
};
const y2e = (e14) => {
  const { grips: t10 = "", cursor: n10, resizeEnabled: r10, item: { Name: o10, Type: a10 }, host: i10 } = e14;
  const [, s10, l10] = Yne({ item: { resize: true, grips: t10, name: o10, reportItemType: a10, host: i10, type: "resizegrip" }, collect: (e15) => ({ isDragging: e15.isDragging() }) });
  ep.useEffect(() => {
    l10(Coe(), { captureDraggingState: true });
  }, []);
  const c10 = `grip ${t10.replace(/(.)/g, " grip-$1")}`;
  return (r10 ? s10 : (e15) => e15)(tp.createElement("div", { className: c10, style: { cursor: n10 } }, tp.createElement("div", null)));
};
const v2e = ({ isPrimary: e14 }) => tp.createElement("div", { className: kp("ar-selection-marker", e14 ? "primary" : "") }, tp.createElement("div", null));
const b2e = (e14) => {
  const { dndEnabled: t10, item: { Name: n10, Type: r10 }, host: o10, path: a10 } = e14;
  const { getReport: i10 } = ep.useContext(bqe);
  const s10 = i10();
  const l10 = V0e(s10);
  const c10 = l2e(l10.map((e15) => e15.Name), s10.$index.NamedItems);
  const [, u10, d10] = Yne({ item: { move: true, name: n10, reportItemType: r10, host: o10, path: a10, type: "reportitem", reportState: s10, movedItems: l10, byMoveGrip: true, childItemNames: c10 }, collect: (e15) => ({ isDragging: e15.isDragging() }) });
  ep.useEffect(() => {
    d10(Coe(), { captureDraggingState: true });
  }, []);
  const p10 = t10 ? { cursor: "move" } : {};
  return (t10 ? u10 : (e15) => e15)(tp.createElement("div", { className: "move-grip-solid", style: p10 }, [qG.E, qG.N, qG.W, qG.S].map((e15) => tp.createElement("div", { key: e15, className: `overlay pos-${e15}` }))));
};
const S2e = { [qG.NW]: "nw-resize", [qG.NC]: "ns-resize", [qG.NE]: "ne-resize", [qG.MW]: "ew-resize", [qG.ME]: "ew-resize", [qG.SW]: "sw-resize", [qG.SC]: "ns-resize", [qG.SE]: "se-resize" };
const [C2e, , x2e] = Dp("sel-frame");
const [w2e] = x2e("rounding");
const T2e = (e14) => {
  const { isPrimary: t10, host: n10, item: r10, path: o10, dndEnabled: a10, resizeEnabled: i10, children: s10, isRounded: l10, rectRef: c10 } = e14;
  const [u10, d10] = ep.useState(false);
  const p10 = kp("ar-sel-adorner", Mee, { "ar-sel-primary": t10 });
  const m10 = kp(C2e, { [w2e]: u10 });
  const h10 = !i10 && a10 && !u10;
  const f10 = i10 && !u10;
  const g10 = l10 && t10 && a10 && i10;
  return tp.createElement("div", { className: p10, "data-path": o10, "data-type": r10.Type }, tp.createElement("div", { className: m10 }), tp.createElement(b2e, { item: r10, host: n10, path: o10, dndEnabled: a10 }), f10 && [qG.NW, qG.NC, qG.NE, qG.MW, qG.ME, qG.SW, qG.SC, qG.SE].map((e15) => tp.createElement(y2e, { key: e15, grips: e15, cursor: S2e[e15], resizeEnabled: i10, item: r10, host: n10 })), h10 && [qG.NW, qG.NE, qG.SW, qG.SE].map((e15) => tp.createElement(y2e, { key: e15, grips: e15, cursor: "move", item: r10, host: n10, resizeEnabled: i10 })), !a10 && tp.createElement(v2e, { isPrimary: t10 }), g10 && tp.createElement(g2e, { documentItem: r10, setIsRounding: d10, rectRef: c10 }), s10);
};
const E2e = (e14) => {
  const { item: t10, dndEnabled: n10, item: { Name: r10, Type: o10 }, host: a10, path: i10 } = e14;
  const { getReport: s10 } = ep.useContext(bqe);
  const l10 = s10();
  const c10 = V0e(l10);
  const u10 = l2e(c10.map((e15) => e15.Name), l10.$index.NamedItems);
  const [{ isDragging: d10 }, p10, m10] = Yne({ item: { move: true, name: r10, reportItemType: o10, host: a10, path: i10, type: "reportitem", reportState: l10, movedItems: c10, byMoveGrip: true, childItemNames: u10 }, collect: (e15) => ({ isDragging: e15.isDragging() }) });
  const { Top: h10, Left: f10 } = cU(t10);
  const g10 = n10 ? { cursor: "move" } : {};
  const y10 = lU(t10, f10.negative().css, h10.negative().css);
  const v10 = { StartPoint: y10.StartPoint, EndPoint: y10.EndPoint };
  const b10 = ome(t10) ? rme.borderWidth : !jme(t10.LineWidth) && t10.LineWidth || u2e.LineWidth;
  return ep.useEffect(() => {
    m10(Coe(), { captureDraggingState: true });
  }, []), (n10 ? p10 : (e15) => e15)(tp.createElement("div", { style: g10 }, tp.createElement(c2e, __spreadValues({ regionLineProps: { className: "line-move-grip scalable" }, thickness: b10, dataPath: i10, dataType: t10.Type, lineStyle: { pointerEvents: "none" } }, v10))));
};
const F2e = ({ isPrimary: e14 }) => tp.createElement("div", { className: kp("ar-line-selection-marker", e14 ? "primary" : "") }, tp.createElement("div", null));
const M2e = (e14) => {
  const { isPrimary: t10, host: n10, item: r10, path: o10, children: a10, dndEnabled: i10 } = e14;
  const { StartPoint: s10, EndPoint: l10 } = r10;
  const { startGrip: c10, endGrip: u10 } = function(e15, t11) {
    const n11 = { x: L$.parse(e15.X), y: L$.parse(e15.Y) };
    const r11 = { x: L$.parse(t11.X), y: L$.parse(t11.Y) };
    const o11 = n11.y.lowerThan(r11.y);
    const a11 = n11.x.lowerThan(r11.x);
    return o11 && a11 ? { startGrip: qG.NW, endGrip: qG.SE } : o11 && !a11 ? { startGrip: qG.NE, endGrip: qG.SW } : !o11 && a11 ? { startGrip: qG.SW, endGrip: qG.NE } : o11 || a11 ? { startGrip: qG.MC, endGrip: qG.MC } : { startGrip: qG.SE, endGrip: qG.NW };
  }(s10, l10);
  const d10 = kp("ar-sel-adorner", Mee, { "ar-sel-primary": t10 });
  return tp.createElement("div", { className: d10 }, tp.createElement(E2e, { item: r10, host: n10, path: o10, dndEnabled: i10 }), i10 ? tp.createElement(tp.Fragment, null, tp.createElement(y2e, { key: "start", item: r10, grips: c10, cursor: `${c10}-resize`, host: n10, resizeEnabled: true }), tp.createElement(y2e, { key: "end", item: r10, grips: u10, cursor: `${u10}-resize`, host: n10, resizeEnabled: true })) : tp.createElement(F2e, { isPrimary: t10 }), a10);
};
const k2e = (e14) => [rW.line, rW.shape, "partitem", "fixedpagepartitem"].includes(e14) || OW(e14);
const P2e = (e14) => [rW.line, rW.shape].includes(e14) || VW(e14);
const N2e = (e14) => {
  const { makeImageUrl: t10, getItemLayerInfo: n10, embeddedImages: r10, renderItem: o10, getReport: a10 } = ep.useContext(bqe);
  const { rdlx: { reportPartsLibraries: { libraries: i10 } } } = d9();
  const { item: s10, path: l10, host: c10, dataSets: u10, parentBackgroundColor: d10, theme: p10, onlyContent: m10, isMasterItem: h10 } = e14;
  const { $place: { Left: f10, Top: g10, Width: y10, Height: v10 }, Type: b10 } = s10;
  const S10 = s10.Style || {};
  const { isLocked: C10, isVisible: x10, opacity: w10, dataFieldVisible: T10 } = n10(s10);
  const { lockLayout: E10 } = MO();
  const F10 = Z7(s10);
  const M10 = h10 && !F10;
  const [, k10, P10] = Yne({ canDrag: () => !OW(s10.Type), item: { type: "reportitem", move: true, name: s10.Name, reportItemType: s10.Type, path: l10, host: c10 }, begin: () => {
    const e15 = s10.Type;
    const t11 = a10();
    let n11 = t11;
    const r11 = [];
    if (l10 && e15 !== rW.section && e15 !== rW.fplSection) {
      const t12 = l10.split(".").reduce((e16, t13) => e16 && e16[t13], n11);
      if (t12 && !rj(t12)) {
        const o12 = t12.Name ? h5([t12.Name]) : c5(l10, e15);
        const a11 = t12.Name ? m5([t12.Name]) : l5(l10, e15);
        const i12 = k0e.ctrlPressed ? a11 : o12;
        n11 = n5(n11, i12), r11.push(i12);
      }
    }
    const o11 = V0e(n11);
    const i11 = l2e(o11.map((e16) => e16.Name), t11.$index.NamedItems);
    return { type: "reportitem", move: true, name: s10.Name, reportItemType: e15, path: l10, host: c10, reportState: n11, startDndActions: r11, movedItems: o11, childItemNames: i11 };
  }, collect: (e15) => ({ isDragging: e15.isDragging() }) });
  ep.useEffect(() => {
    P10(Coe(), { captureDraggingState: true });
  }, []);
  const N10 = ep.useRef(null);
  const D10 = ep.useRef(null);
  const L10 = Bme(S10.BackgroundColor, d10, p10);
  const H10 = S10.BackgroundImage;
  const I10 = H0e(t10);
  const _10 = H10 ? I10(H10.Source, H10.Value, r10) : "";
  const V10 = rj(s10) ? 1 : x10 ? w10 : 0;
  const R10 = GW(b10) && x10 && !C10 && !E10 && !F10 && !h10;
  const A10 = R10 && MLe(s10, i10) && !F10 && !h10;
  const O10 = !P2e(b10);
  const B10 = { left: f10, top: g10, width: y10, height: v10, backgroundColor: O10 ? L10 : "transparent", backgroundImage: O10 ? _10 : "", pointerEvents: x10 && !M10 ? "all" : "none" };
  const z10 = S10.BackgroundGradientType;
  const $10 = S10.BackgroundGradientEndColor;
  if (O10 && !B10.backgroundImage && !!z10 && !!$10 && "None" !== z10) {
    const e15 = Bme($10, d10, p10);
    Object.assign(B10, { backgroundImage: Zme(z10, L10, e15) });
  }
  const W10 = Mme(S10, p10);
  VW(b10) || tj(b10) || ZW(b10) ? W10.opacity = V10 : B10.opacity = V10;
  let j10 = x10 || VW(b10) ? o10(s10, l10, u10, L10, T10, M10 || !!m10) : null;
  let Z10 = false;
  j10 && b10 === rW.shape && (j10 = tp.cloneElement(j10, { glyphRef: D10 }), Z10 = "RoundRect" === j10.props.item.ShapeStyle);
  const G10 = rj(s10) ? s10.Type === rW.line ? tp.createElement(M2e, { isPrimary: sj(s10), host: c10, item: s10, path: l10, dndEnabled: R10 }) : tp.createElement(T2e, { isPrimary: sj(s10), host: c10, item: s10, path: l10, dndEnabled: R10, resizeEnabled: A10, isRounded: Z10, rectRef: D10 }) : null;
  const U10 = kp("ar-reportitemplace", $me(H10), { "ar-decorative-item": M10 });
  return tp.createElement("div", { "data-aid": `${s10.Name}-site`, className: U10, style: B10, ref: R10 ? k10 : N10 }, G10, j10, !k2e(b10) && tp.createElement("div", { className: "ar-border", style: W10 }));
};
N2e.displayName = "ReportItemSite";
const D2e = (e14, t10) => () => AV(Wq(t10), { LayerName: { $set: e14 } });
const L2e = (e14, t10) => () => AV(jq(t10), { Item: { LayerName: { $set: e14 } } });
function H2e(e14, { operation: t10 }, n10) {
  const r10 = uQ(e14, n10);
  const o10 = rQ(e14, r10 ? n10 === dZ.ROW ? uZ.ROW : uZ.COLUMN : n10 === dZ.ROW ? uZ.COLUMN : uZ.ROW, ij, r10 ? { searchInBody: true } : { searchInCorner: true });
  return I2e(e14, n10, r10, t10 === mZ.InsideBefore || t10 === mZ.OutsideBefore || t10 === mZ.Before ? o10[0] : o10[o10.length - 1], t10);
}
function I2e(e14, t10, n10, r10, o10) {
  return (n10 ? _2e : V2e)(e14, t10, r10, o10);
}
function _2e(e14, t10, n10, r10) {
  const o10 = r10 === mZ.InsideAfter || r10 === mZ.OutsideAfter || r10 === mZ.After ? pZ.AFTER : pZ.BEFORE;
  const [a10, i10, s10] = t10 === dZ.ROW ? [e14.RowHierarchy, uZ.ROW, vQ] : [e14.ColumnHierarchy, uZ.COLUMN, bQ];
  let l10 = r10 === mZ.OutsideAfter || r10 === mZ.OutsideBefore || r10 === mZ.InsideAfter || r10 === mZ.InsideBefore ? KJ(n10) : n10;
  let c10;
  if (r10 === mZ.InsideAfter || r10 === mZ.InsideBefore) {
    let t11 = l10[l10.length - 1];
    if (!SQ(t11.Children)) {
      const n11 = (e15) => zJ(null, null, [], 1, e15.BodyIndex);
      c10 = CQ(AQ(e14, ({ item: e15 }) => e15, ({ member: e15 }) => e15 === t11 ? AV(e15, { Children: { $set: [n11(e15)] } }) : e15)[i10].Members);
      l10 = JJ(c10, t11.Header && t11.Header.Item.Name || t11.Group && t11.Group.Name), t11 = l10[l10.length - 1];
    }
    r10 === mZ.InsideBefore ? l10.push(t11.Children[0]) : l10.push(t11.Children[t11.Children.length - 1]);
  }
  const u10 = D2e(e14.LayerName, e14.$templateId);
  const d10 = L2e(e14.LayerName, e14.$templateId);
  const p10 = gQ(c10 || a10.Members, l10, o10, null, u10);
  const m10 = yQ(l10[l10.length - 1]);
  const h10 = s10(e14.Body, m10, d10, o10, void 0, e14.$templateId);
  return AV(e14, { [i10]: { Members: { $set: p10 } }, Body: { $set: h10 } });
}
function V2e(e14, t10, n10, r10) {
  const o10 = r10 === mZ.InsideAfter || r10 === mZ.After ? pZ.CHILD : pZ.PARENT;
  const { cellWidth: a10, cellHeight: i10 } = zq(e14.$templateId);
  const [s10, l10, c10, u10, d10] = t10 === dZ.ROW ? [e14.ColumnHierarchy, uZ.COLUMN, fQ, e14.RowHierarchy.LevelSizes.length, i10] : [e14.RowHierarchy, uZ.ROW, hQ, e14.ColumnHierarchy.LevelSizes.length, a10];
  const p10 = o10 === pZ.PARENT ? n10.length - 1 : n10.length;
  const m10 = n10.reduce((e15, t11, n11) => e15 + (n11 < p10 ? ZJ(t11) : 0), 0);
  const h10 = D2e(e14.LayerName, e14.$templateId);
  const f10 = (e15) => {
    const t11 = YJ(e15) && !qJ(e15) && [mZ.Before, mZ.InsideBefore].some((e16) => e16 === r10);
    const n11 = ((e16) => (r10 === mZ.InsideBefore || r10 === mZ.Before) && e16.Group || null)(e15);
    const a11 = t11 ? null : { Item: h10(), LevelCount: 1 };
    const i11 = function(e16) {
      switch (r10) {
        case mZ.InsideAfter:
        case mZ.After:
          return e16.Children;
        case mZ.InsideBefore:
        case mZ.Before: {
          const t12 = YJ(e16) && !qJ(e16) ? { Item: h10(), LevelCount: 1 } : e16.Header;
          return [hj(AV(e16, { $set: zJ(null, t12, e16.Children, GJ(e16)) }), e16)];
        }
        case mZ.OutsideBefore:
          return [e16];
        default:
          throw new Error(`Invalid tablix operation ${r10}`);
      }
    }(e15);
    return ((e16, t12) => o10 === pZ.PARENT ? mj(hj(e16, t12)) : hj(e16, t12))(zJ(n11, a11, i11, GJ(e15)), e15);
  };
  const g10 = r10 === mZ.OutsideBefore ? KJ(n10) : n10;
  if (!g10 || g10.length <= 0) throw new Error("Insertion path cannot be undefined");
  const y10 = r10 !== mZ.OutsideBefore;
  const v10 = CQ(s10.Members.map((e15) => dQ(e15, m10, f10, o10, g10, y10)));
  return AV(e14, { [l10]: { LevelSizes: { $splice: [[m10, 0, d10]] }, Members: { $set: v10 } }, Corner: { $set: c10(e14.Corner, m10, h10, u10, e14.$templateId) } });
}
const R2e = (e14, t10) => (n10, r10) => {
  const o10 = AV(function(e15 = "", t11 = "", n11) {
    const r11 = AV(Wq(n11), { Style: { Format: { $set: t11 } }, Value: { $apply: (t12) => e15 || t12 } });
    return r11;
  }(n10, r10, t10), { LayerName: { $set: e14 } });
  return o10;
};
function A2e(e14, { position: t10 }) {
  const n10 = function(e15) {
    return ij(e15.RowHierarchy) ? uZ.ROW : ij(e15.ColumnHierarchy) ? uZ.COLUMN : null;
  }(e14);
  if (!n10) throw new Error("Not found primary selection in the hierarchy");
  const r10 = cQ(e14[n10].Members, ij);
  if (!r10 || !r10.length) throw new Error(`Not found primary path in the hierarchy ${n10}`);
  const o10 = B2e(r10);
  if (!o10 || !o10.length) throw new Error("Not found dynamic member in primary path");
  const a10 = o10[o10.length - 1];
  const i10 = R2e(e14.LayerName, e14.$templateId);
  const s10 = function(e15, t11) {
    const n11 = t11 === pZ.BEFORE ? 0 : e15.length - 1;
    if (!e15[n11].Header) return e15;
    const r11 = AV(e15, { [n11]: { Header: { Item: { Value: { $set: hG().t("labels:total", "Total") } } } } });
    return r11;
  }($2e(a10, i10), t10);
  const l10 = function(e15, t11, n11, r11) {
    const o11 = n11.reduce((e16, t12) => e16 + GJ(t12), 0);
    const a11 = (e16, i11) => {
      const s11 = t11[i11];
      const l11 = e16.indexOf(s11);
      if (l11 < 0) throw new Error("Invalid path, member not found");
      if (i11 < t11.length - 1) {
        const t12 = AV(s11, { BodyCount: { $set: GJ(s11) + o11 }, Children: { $set: a11(s11.Children, i11 + 1) } });
        return AV(e16, { $splice: [[l11, 1, t12]] });
      }
      const c11 = r11 === pZ.BEFORE ? l11 : l11 + 1;
      return AV(e16, { $splice: [[c11, 0, ...n11]] });
    };
    return CQ(a11(e15, 0));
  }(e14[n10].Members, o10, s10, t10);
  const c10 = (t11) => {
    if (!t11 || !t11.Item) return t11;
    const { resultValue: n11, copyFormat: r11 } = ((t12) => {
      const n12 = O2e(t12);
      if (!n12) return { resultValue: "", copyFormat: true };
      if (A1(n12)) return { resultValue: n12, copyFormat: true };
      const r12 = zV.uniq(N1(n12));
      if (1 !== r12.length) return { resultValue: n12, copyFormat: true };
      const o12 = r12[0];
      const a12 = xqe(e14.DataSetName, o12);
      return { resultValue: a12 ? B1(n12, a12) : n12, copyFormat: "Count" !== a12 };
    })(t11.Item);
    const o11 = r11 && t11.Item.Style && t11.Item.Style.Format || "";
    const a11 = i10(n11, o11);
    return AV(t11, { Item: { $set: a11 } });
  };
  const { start: u10, end: d10 } = yQ(a10);
  const p10 = n10 === uZ.ROW ? vQ : bQ;
  const m10 = GJ(a10);
  const h10 = p10(e14.Body, { start: u10, end: d10 }, (r11, o11) => {
    const { start: i11, end: s11 } = yQ(a10);
    let l11;
    let u11;
    const d11 = i11 - 1 - s11;
    n10 === uZ.ROW ? (l11 = t10 === pZ.BEFORE ? r11 : r11 + d11, u11 = o11) : (l11 = r11, u11 = t10 === pZ.BEFORE ? o11 : o11 + d11);
    const p11 = e14.Body.Rows[l11];
    if (!p11) return null;
    const m11 = p11.Cells[u11];
    return m11 ? c10(m11) : null;
  }, t10, m10, e14.$templateId);
  return AV(e14, { [n10]: { Members: { $set: l10 } }, Body: { $set: h10 } });
}
const O2e = (e14) => {
  if (!e14) return "";
  switch (e14.Type) {
    case rW.textbox:
      return e14.Value || "";
    case rW.checkbox:
      return e14.Text || "";
  }
  return "";
};
const B2e = (e14) => {
  const t10 = ((e15) => {
    for (let t11 = e15.length - 1; t11 >= 0; t11--) if (e15[t11].Type === rW.dynamicTablixMember) return t11;
    return -1;
  })(e14);
  return t10 > -1 ? e14.slice(0, t10 + 1) : null;
};
const z2e = (e14) => {
  let t10 = [];
  for (let n10 = 0; n10 < e14.length; n10++) {
    const r10 = e14[n10];
    t10 = t10.concat(Array.isArray(r10) ? z2e(r10) : [r10]);
  }
  return t10;
};
function $2e(e14, t10) {
  const n10 = ZJ(e14);
  const r10 = z2e(e14.Children.map((e15) => $2e(e15, t10)));
  const o10 = n10 > 0 ? { Item: t10(e14.Header.Item.Value, e14.Header.Item.Style && e14.Header.Item.Style.Format), LevelCount: n10 } : null;
  let a10 = r10;
  for (let e15 = 0; e15 < r10.length; e15++) {
    const t11 = r10[e15];
    if (t11.Header && t11.Header.Item && N1(t11.Header.Item.Value).length > 0) {
      const n11 = AV(t11, { Header: { Item: { Value: { $set: "" } } } });
      a10 = AV(a10, { $splice: [[e15, 1, n11]] });
    }
  }
  return o10 ? [zJ(null, o10, a10, GJ(e14))] : a10.length > 0 ? a10 : [zJ(null, null, [], GJ(e14))];
}
const W2e = (e14, t10) => {
  if (!(lQ(e14) === hZ.RowHierarchy)) return e14;
  const n10 = sQ(e14.RowHierarchy.Members);
  return RQ(e14, ({ item: e15, cix: r10, rix: o10 }) => {
    if (!e15) return e15;
    let a10 = e15;
    if (r10 === n10[0] && 0 === o10) if (e15.Type !== rW.textbox || e15.Value) {
      if (e15.Type === rW.checkbox && !e15.Text) {
        const n11 = q1(t10);
        a10 = AV(e15, { Text: { $set: n11 } });
      }
    } else {
      const n11 = q1(t10);
      a10 = AV(e15, { Value: { $set: n11 } });
    }
    return a10;
  });
};
function j2e(e14, t10) {
  return Array.from(new Array(e14)).fill(t10);
}
function Z2e(e14) {
  if (!e14) throw new Error("Cannot perform merge cells in empty corner");
  const { start: t10, end: n10, selectedCells: r10 } = TQ(e14);
  const o10 = n10.rowIndex - t10.rowIndex;
  const a10 = n10.cellIndex - t10.cellIndex;
  const i10 = r10.find(ij);
  if (!i10) throw new Error("No primary cell for merge in Tablix Corner");
  const s10 = AV(i10, { RowSpan: { $set: o10 }, ColSpan: { $set: a10 } });
  const l10 = [];
  return e14.forEach((e15, r11) => {
    if (r11 < t10.rowIndex || r11 >= n10.rowIndex) return void l10.push(e15);
    const o11 = r11 === t10.rowIndex ? [s10, ...j2e(a10 - 1, null)] : j2e(a10, null);
    l10.push(AV(e15, { $splice: [[t10.cellIndex, a10, ...o11]] }));
  }), l10;
}
function G2e(e14) {
  const { start: t10, end: n10, selectedCells: r10 } = EQ(e14);
  const o10 = n10.cellIndex - t10.cellIndex;
  const a10 = r10.find(ij);
  if (!a10) throw new Error("No primary cell for merge in Tablix Body");
  const i10 = AV(a10, { ColSpan: { $set: o10 } });
  const s10 = e14.Rows[t10.rowIndex];
  const l10 = AV(s10.Cells, { $splice: [[t10.cellIndex, o10, i10, ...j2e(o10 - 1, null)]] });
  const c10 = AV(s10, { Cells: { $set: l10 } });
  const u10 = AV(e14.Rows, { $splice: [[t10.rowIndex, 1, c10]] });
  return AV(e14, { Rows: { $set: u10 } });
}
function U2e(e14) {
  const t10 = FQ(e14);
  if (MQ(e14)) return AV(e14, { Members: { $set: K2e(e14.Members, t10) } });
  if (kQ(e14)) return AV(e14, { Members: { $set: X2e(e14.Members, t10) } });
  throw new Error("Cannot apply merge in hierarchy");
}
function q2e(e14, t10, n10) {
  let r10 = e14;
  if (t10 && t10 !== e14) {
    const n11 = hj(t10.Header.Item, e14.Header.Item);
    const o10 = hj(AV(t10.Header, { Item: { $set: n11 } }), e14.Header);
    r10 = hj(AV(t10, { Header: { $set: o10 } }), e14);
  }
  return AV(r10, n10);
}
function Y2e(e14, t10, n10) {
  if (!e14 || !zV.isObject(e14)) throw new Error("Invalid Tablix hierarchy structure");
  if (t10(e14)) return n10(e14);
  let r10 = e14;
  zV.isArray(r10) && r10.forEach((e15, o11) => {
    if (!aj(e15)) return;
    const a10 = Y2e(e15, t10, n10);
    if (a10 !== e15) {
      const e16 = {};
      e16[o11] = { $set: a10 }, r10 = AV(r10, e16);
    }
  });
  const o10 = r10.Children;
  if (SQ(o10)) {
    const e15 = Y2e(o10, t10, n10);
    if (e15 !== o10) {
      const t11 = {};
      t11.Children = { $set: e15 }, r10 = AV(r10, t11);
    }
  }
  return r10;
}
function K2e(e14, t10) {
  const n10 = t10[0].slice(0, t10[0].length - 1);
  const r10 = t10.map((e15) => e15[e15.length - 1]);
  const o10 = r10.find((e15) => ij(e15.Header.Item));
  if (!o10) throw new Error("No primary member for horizontal merge in Tablix hierarchy");
  const a10 = r10.find((e15) => e15.Group);
  const i10 = [];
  let s10 = 0;
  r10.forEach((e15) => {
    s10 += GJ(e15);
    const t11 = SQ(e15.Children) ? e15.Children : [zJ()];
    i10.push(...t11);
  });
  const l10 = q2e(o10, a10, { BodyCount: { $set: s10 }, Children: { $set: i10 } });
  return CQ(Y2e(e14, (t11) => n10.length > 0 ? t11 === n10[n10.length - 1] : t11 === e14, (e15) => {
    const t11 = (n10.length > 0 ? e15.Children : e15).findIndex((e16) => e16 === r10[0]);
    const o11 = { $splice: [[t11, r10.length, l10]] };
    const a11 = n10.length > 0 ? { Children: o11 } : o11;
    return AV(e15, a11);
  }));
}
function X2e(e14, t10) {
  const n10 = t10.reduce((e15, t11) => t11.length < e15.length ? t11 : e15);
  const r10 = t10.reduce((e15, t11) => t11.length > e15.length ? t11 : e15);
  const o10 = n10.slice(0, n10.length - 1);
  const a10 = t10.map((e15) => e15[e15.length - 1]);
  const i10 = n10[n10.length - 1];
  const s10 = r10[r10.length - 1];
  const l10 = a10.find((e15) => ij(e15.Header.Item));
  if (!l10) throw new Error("No primary member for vertical merge in Tablix hierarchy");
  const c10 = a10.find((e15) => e15.Group);
  let u10 = 0;
  a10.forEach((e15) => {
    u10 += ZJ(e15);
  });
  const d10 = q2e(l10, c10, { Header: { LevelCount: { $set: u10 } }, BodyIndex: { $set: s10.BodyIndex }, Children: { $set: s10.Children } });
  return Y2e(e14, (t11) => o10.length > 0 ? t11 === o10[o10.length - 1] : t11 === e14, (e15) => {
    const t11 = (o10.length > 0 ? e15.Children : e15).findIndex((e16) => e16 === i10);
    const n11 = { $splice: [[t11, 1, d10]] };
    const r11 = o10.length > 0 ? { Children: n11 } : n11;
    return AV(e15, r11);
  });
}
const J2e = (e14, t10) => {
  if (!zV.isObjectLike(t10)) return e14;
  const n10 = {};
  return Object.getOwnPropertyNames(e14).forEach((r10) => {
    t10.hasOwnProperty(r10) ? n10[r10] = t10[r10] : n10[r10] = e14[r10];
  }), n10;
};
function Q2e(e14) {
  const { location: t10, area: n10 } = NQ(e14);
  const r10 = (t11) => (n11) => {
    const r11 = AV(((t12) => AV(Wq(e14.$templateId), { Style: { $apply: (e15) => J2e(e15, t12) } }))(n11), { LayerName: { $set: t11 } });
    return r11;
  };
  function o10(e15, t11, n11) {
    const r11 = t11[t11.length - 1];
    if (t11.length > 1) {
      const a12 = t11[t11.length - 2];
      const i11 = a12.Children.findIndex((e16) => e16 === r11);
      const s11 = AV(a12.Children, { $splice: [[i11, 1, ...n11]] });
      const l10 = AV(a12, { Children: { $set: s11 } });
      return o10(e15, t11.slice(0, t11.length - 1), [l10]);
    }
    const a11 = e15.findIndex((e16) => e16 === r11);
    return CQ(AV(e15, { $splice: [[a11, 1, ...n11]] }));
  }
  function a10(e15, t11, n11, a11, i11) {
    const s11 = AV(n11.Header, { LevelCount: { $set: 1 } });
    const l10 = AV(n11, { Header: { $set: s11 } });
    const c10 = [l10.Header.Item.Name];
    const u10 = r10(n11.Header.Item.LayerName);
    for (let e16 = 1, t12 = l10; e16 < a11; e16++) {
      const r11 = zJ(null, { Item: u10(n11.Header.Item.Style), LevelCount: 1 }, [], i11);
      t12.Children = [r11], t12 = r11, e16 === a11 - 1 && (t12.Children = n11.Children), c10.push(r11.Header.Item.Name);
    }
    return { newMembers: o10(e15, t11, [l10]), memberNamesInSplitArea: c10 };
  }
  function i10(e15, t11, n11, a11, i11) {
    const s11 = r10(n11.Header.Item.LayerName);
    if (n11.Group) {
      const r11 = AV(n11, { Header: { LevelCount: { $set: a11 } }, BodyCount: { $set: n11.Children[0].BodyCount }, Children: { $splice: [[1, n11.Children.length - 1]] }, Group: { $set: null } });
      const i12 = [hj(zJ(r11.Group, r11.Header, r11.Children, GJ(r11), r11.BodyIndex), n11)];
      for (let e16 = 1; e16 < n11.Children.length; e16++) {
        const t12 = { Item: s11(n11.Header.Item.Style), LevelCount: a11 };
        i12.push(zJ(null, t12, [n11.Children[e16]], GJ(n11.Children[e16])));
      }
      return o10(e15, t11, [hj(zJ(n11.Group, null, i12, GJ(n11)), n11)]);
    }
    const l10 = [AV(n11, { BodyCount: { $set: n11.Children[0].BodyCount }, Children: { $set: [n11.Children[0]] } })];
    for (let e16 = 1; e16 < n11.Children.length; e16++) {
      const t12 = zJ(null, { Item: s11(n11.Header.Item.Style), LevelCount: a11 }, [n11.Children[e16]], GJ(n11.Children[e16]));
      l10.push(t12);
    }
    return o10(e15, t11, l10);
  }
  function s10(e15, t11) {
    const n11 = JJ(e15.Members, t11);
    if (!n11 || 0 === n11.length) throw new Error("Member not found");
    const r11 = n11[n11.length - 1];
    const o11 = ZJ(r11);
    const s11 = o11 > 1;
    const l10 = GJ(r11);
    const c10 = l10 > 1 && r11.Children.length > 1;
    const u10 = s11 && c10;
    let d10 = e15.Members;
    return u10 ? d10 = function(e16, t12, n12, r12, o12) {
      const s12 = a10(e16, t12, n12, r12, o12);
      const l11 = s12.memberNamesInSplitArea;
      let c11 = s12.newMembers;
      for (let e17 = l11.length - 1; e17 >= 0; e17--) {
        const t13 = JJ(c11, l11[e17]);
        c11 = i10(c11, t13, t13[t13.length - 1], 1);
      }
      return c11;
    }(e15.Members, n11, r11, o11, l10) : s11 ? d10 = a10(e15.Members, n11, r11, o11, l10).newMembers : c10 && (d10 = i10(e15.Members, n11, r11, o11)), AV(e15, { Members: { $set: d10 } });
  }
  switch (n10) {
    case hZ.Body:
      return AV(e14, { Body: { $set: function(e15, t11, n11) {
        const o11 = e15.Rows[t11];
        const a11 = [];
        const i11 = o11.Cells[n11];
        const s11 = i11.ColSpan || 1;
        const l10 = i11.RowSpan || 1;
        const c10 = r10(i11.Item.LayerName);
        a11.push(AV(i11, { ColSpan: { $set: 1 } }));
        let u10 = s11 - 1;
        for (; u10 > 0; ) a11.push({ Item: c10(i11.Item.Style), RowSpan: l10, ColSpan: 1, AutoMergeMode: i11.AutoMergeMode }), u10--;
        const d10 = AV(o11, { Cells: { $splice: [[n11, s11, ...a11]] } });
        return AV(e15, { Rows: { $splice: [[t11, 1, d10]] } });
      }(e14.Body, t10.rowIndex, t10.cellIndex) } });
    case hZ.Corner:
      return AV(e14, { Corner: { $set: function(e15, t11, n11) {
        if (!e15) throw new Error("Cannot perform split cells in empty corner");
        const o11 = [];
        const a11 = e15[t11][n11];
        const i11 = a11.ColSpan || 1;
        const s11 = a11.RowSpan || 1;
        const l10 = r10(a11.Item.LayerName);
        for (let r11 = t11; r11 < t11 + s11; r11++) {
          const s12 = e15[r11];
          const c10 = [];
          c10.push(r11 === t11 ? AV(a11, { ColSpan: { $set: 1 }, RowSpan: { $set: 1 } }) : { Item: l10(a11.Item.Style), RowSpan: 1, ColSpan: 1 });
          let u10 = i11 - 1;
          for (; u10 > 0; ) c10.push({ Item: l10(a11.Item.Style), RowSpan: 1, ColSpan: 1 }), u10--;
          o11.push(AV(s12, { $splice: [[n11, i11, ...c10]] }));
        }
        return AV(e15, { $splice: [[t11, s11, ...o11]] });
      }(e14.Corner, t10.rowIndex, t10.cellIndex) } });
    case hZ.RowHierarchy:
      return AV(e14, { RowHierarchy: { $set: s10(e14.RowHierarchy, t10.name) } });
    case hZ.ColumnHierarchy:
      return AV(e14, { ColumnHierarchy: { $set: s10(e14.ColumnHierarchy, t10.name) } });
  }
  return e14;
}
const e5e = FZ.resultOf(wq.decode({ Type: "textbox", Name: "textbox", CanGrow: false, CanShrink: false }));
const t5e = ["Color", "FontFamily", "FontSize", "FontStyle", "FontWeight", "TextAlign", "VerticalAlign"];
const n5e = (e14, t10) => t5e.reduce((n10, r10) => Oj(e14.Style, t10, r10) ? __spreadProps(__spreadValues({}, n10), { [r10]: { $set: t10[r10] } }) : n10, null);
const r5e = (e14, t10) => {
  const n10 = t10.map((e15) => ((e16) => e16 && e16.length > 0 && "=" === e16[0] ? e16.substr(1) : `"${e16 || ""}"`)(e15));
  return y1(e14, ...n10);
};
const o5e = (e14, t10, n10) => {
  const r10 = {};
  return ["Color", "Width", "Style"].forEach((o10) => {
    ((e15, t11, n11, r11) => Oj(e15, t11, r11) && (!n11 || !n11[r11] || e15[r11] && n11[r11] !== e15[r11] || Oj(n11, t11, r11)))(e14, t10, n10, o10) && (r10[o10] = { $set: t10[o10] });
  }), zV.isEmpty(r10) ? null : r10;
};
const a5e = (e14, t10) => {
  const n10 = n5e(e14, t10.Body.Rows[0]) || {};
  if (t10.Border) {
    const r10 = o5e(e14.Style.Border, t10.Border);
    r10 && (n10.Border = r10);
  }
  return Oj(e14.Style, t10, "BackgroundColor") && (n10.BackgroundColor = { $set: t10.BackgroundColor }), zV.isEmpty(n10) ? null : n10;
};
const i5e = (e14, t10) => {
  if (!e14 || !e14.Item || !e14.Item.Style) return null;
  const n10 = {};
  return Object.keys(t10).forEach((r10) => {
    if (!e14.Item.Style.hasOwnProperty(r10)) return;
    const o10 = e14.Item.Style[r10];
    if (r10.includes("Border")) {
      const a10 = o5e(o10, t10[r10], e14.Item.Style[r10]);
      a10 && (n10[r10] = a10);
    } else Oj(e14.Item.Style, t10, r10) && (n10[r10] = { $set: t10[r10] });
  }), zV.isEmpty(n10) ? null : { Item: { Style: n10 } };
};
const s5e = (e14, t10) => {
  if (!e14 || !e14.length) return null;
  const n10 = {};
  return e14.forEach((e15, r10) => {
    e15 && e15.forEach((e16, o10) => {
      if (!e16) return;
      const a10 = i5e(e16, t10 || {});
      a10 && (n10[r10] || (n10[r10] = {}), n10[r10][o10] = a10);
    });
  }), zV.isEmpty(n10) ? null : n10;
};
const l5e = (e14, t10, n10, r10) => {
  const o10 = {};
  return e14.Rows.forEach((e15, a10) => {
    if (!e15 || !e15.Cells || !e15.Cells.length) return;
    const i10 = {};
    const s10 = (n10.find((e16) => e16.index === a10) || {}).style || null;
    e15.Cells.forEach((e16, n11) => {
      if (!e16) return;
      const o11 = s10 || (r10.find((e17) => e17.index === n11) || {}).style || t10;
      const a11 = i5e(e16, o11 || {});
      a11 && (i10[n11] = a11);
    }), zV.isEmpty(i10) || (o10[a10] = { Cells: i10 });
  }), zV.isEmpty(o10) ? null : { Rows: o10 };
};
const c5e = ["Border", "LeftBorder", "TopBorder", "RightBorder", "BottomBorder"];
const u5e = ["Color", "Style", "Width"];
const d5e = (e14, t10, n10) => {
  const r10 = {};
  return Object.keys(t10).forEach((o10) => {
    if ("$softfallback" === o10) return void (r10.$softfallback = d5e(e14, t10.$softfallback, n10.map((e15) => e15.$softfallback)));
    const a10 = t10[o10];
    const i10 = n10.map((e15) => e15[o10]);
    var s10;
    if (s10 = o10, c5e.includes(s10)) if (i10.every((e15) => zV.isEqual(e15, a10) || void 0 === e15)) r10[o10] = a10;
    else {
      const t11 = [a10, ...i10];
      r10[o10] = {}, u5e.forEach((n11) => {
        r10[o10][n11] = r5e(e14, t11.map((e15) => e15 && e15[n11] || ""));
      });
    }
    else if (i10.every((e15) => e15 === a10)) r10[o10] = a10;
    else {
      const t11 = [a10, ...i10];
      r10[o10] = r5e(e14, t11);
    }
  }), r10;
};
const p5e = (e14) => {
  if (!e14) return {};
  const { AlternatingExpression: t10, Rows: n10 } = e14;
  if (!n10 || 0 === n10.length) return {};
  if (!t10) return n10[0];
  const r10 = zV.head(n10);
  const o10 = zV.tail(n10);
  return d5e(t10, r10, o10);
};
const m5e = (e14, t10) => {
  const n10 = [];
  const r10 = (e15, t11) => t11.Type === rW.staticTablixMember && e15.some((e16) => e16.Type === rW.dynamicTablixMember) && (t11.Header && t11.Header.Item && ((e16) => HW(SW, e16))(t11.Header.Item.Type) || !t11.Header);
  const o10 = (e15, t11, a11, i10) => {
    if (!e15) return null;
    const s10 = i10 || e15.Type === rW.dynamicTablixMember;
    const l10 = {};
    const c10 = e15.Children || [];
    if (c10.length > 0) {
      const e16 = {};
      c10.forEach((n11, i11) => {
        let l11;
        const u11 = t11.ChildStyle && s10 ? t11.ChildStyle : t11;
        if (n11.Type === rW.staticTablixMember) {
          const e17 = r10(c10, n11);
          l11 = o10(n11, !a11 && e17 ? u11 : t11, a11 || e17, s10);
        } else l11 = o10(n11, u11, a11, s10);
        l11 && (e16[i11] = l11);
      }), zV.isEmpty(e16) || (l10.Children = e16);
    }
    const u10 = a11 && t11.TotalStyle || !s10 && t11.StaticStyle || t11.GroupStyle;
    const d10 = p5e(u10);
    const p10 = e15.Header;
    if (p10 && p10.Item) {
      const e16 = i5e(p10, d10 || {});
      e16 && (l10.Header = e16);
    }
    if (a11 && e15.BodyIndex >= 0) {
      const t12 = n10.findIndex((t13) => t13.index === e15.BodyIndex);
      -1 === t12 ? n10.push({ index: e15.BodyIndex, style: d10 }) : n10.splice(t12, 1, { index: e15.BodyIndex, style: d10 });
    }
    return zV.isEmpty(l10) ? null : l10;
  };
  const a10 = ((e15) => {
    const n11 = e15 && e15.Members || [];
    if (0 === n11.length) return null;
    const a11 = {};
    return n11.forEach((e16, i10) => {
      const s10 = o10(e16, t10, r10(n11, e16));
      s10 && (a11[i10] = s10);
    }), zV.isEmpty(a11) ? null : { Members: a11 };
  })(e14);
  return { hierarchySetters: a10, updatedBodyIndices: n10 };
};
const h5e = (e14) => {
  const t10 = {};
  return Object.getOwnPropertyNames(e14).forEach((n10) => {
    if ("Header" === n10) t10.Corner = e14.Header;
    else if ("Details" === n10) t10.Body = e14.Details;
    else if ("TableGroups" === n10 && e14.TableGroups.Styles && e14.TableGroups.Styles.length) {
      const n11 = e14.TableGroups.Styles;
      const r10 = (t11, o10) => {
        const a10 = n11[t11];
        const i10 = {};
        return a10.Header && (i10.GroupStyle = a10.Header), a10.Footer && (i10.TotalStyle = a10.Footer), o10 && e14.Footer ? i10.StaticStyle = e14.Footer : !o10 && e14.Header && (i10.StaticStyle = e14.Header), t11 + 1 < n11.length && (i10.ChildStyle = r10(t11 + 1, o10)), i10;
      };
      t10.RowGroup = r10(0, true), t10.ColumnGroup = r10(0, false);
    } else t10[n10] = e14[n10];
  }), t10;
};
const f5e = (e14) => {
  const t10 = function(e15, t11) {
    var _a2;
    const n11 = nz.of(e15);
    const r10 = n11.getTemplate("tablix", t11);
    const o10 = n11.getTemplate("textbox", t11);
    if (!r10 || !o10) return null;
    const a10 = ((_a2 = r10.Body.Rows[0].Cells[0].Item) == null ? void 0 : _a2.Style) || o10.Style;
    if (!a10) return null;
    const i10 = zV.merge({}, o10.style || {}, a10 || {});
    const s10 = [];
    i10.TextAlign && s10.push("TextAlign"), i10.VerticalAlign && s10.push("VerticalAlign");
    const l10 = ["BackgroundColor", "Color", "FontFamily", "FontSize", "FontStyle", "FontWeight", "Border", "LeftBorder", "TopBorder", "RightBorder", "BottomBorder"].concat(s10);
    const c10 = zV.pick(zV.merge({}, e5e.Style, i10), l10);
    return __spreadProps(__spreadValues({}, zV.merge({}, Bq.Style, r10.style)), { Header: c10, Details: c10, Footer: c10, TableGroups: { Header: c10, Footer: c10 } });
  }(e14);
  const n10 = { Header: { Rows: [t10.TableGroups.Header] }, Footer: { Rows: [t10.TableGroups.Footer] } };
  return Object.assign({}, t10, { Header: { Rows: [t10.Header] }, Details: { Rows: [t10.Details] }, Footer: { Rows: [t10.Footer] }, TableGroups: { Styles: new Array(3).fill(n10) } });
};
const g5e = (e14, t10) => {
  if (zV.isArray(e14) && zV.isArray(t10)) return zV.merge([], Array(t10.length).fill(e14[0]), t10, g5e);
};
const y5e = (e14, t10) => {
  if (t10 && t10.$targetType !== wj.Tablix) return null;
  const n10 = f5e(e14);
  const r10 = t10 ? zV.merge({}, n10, t10, g5e) : n10;
  return h5e(r10);
};
function v5e(e14, t10, n10, r10 = false) {
  const o10 = h5e(f5e(e14));
  const a10 = r10 ? Aj(n10, o10) : n10;
  const { hierarchySetters: i10, updatedBodyIndices: s10 } = m5e(t10.ColumnHierarchy, a10.ColumnGroup);
  const { hierarchySetters: l10, updatedBodyIndices: c10 } = m5e(t10.RowHierarchy, a10.RowGroup);
  const u10 = p5e(a10.Corner);
  const d10 = p5e(a10.Body);
  const p10 = s5e(t10.Corner, u10);
  const m10 = l5e(t10.Body, d10, c10, s10);
  const h10 = a5e(t10, a10);
  const f10 = {};
  return i10 && (f10.ColumnHierarchy = i10), l10 && (f10.RowHierarchy = l10), p10 && (f10.Corner = p10), m10 && (f10.Body = m10), h10 && (f10.Style = h10), zV.isEmpty(f10) ? t10 : AV(t10, f10);
}
function b5e(e14) {
  return function(e15, t10) {
    return Gye(e15, n5, t10);
  };
}
const S5e = "tablixrow";
const C5e = "tablixcolumn";
const x5e = [CY.Height];
const w5e = [CY.Width];
function T5e(e14) {
  return { Type: S5e, Height: e14 };
}
function E5e(e14) {
  return { Type: C5e, Width: e14 };
}
const F5e = { type: S5e, labelKey: "reportItems:tablixRow", defaultModel: T5e(null), getProperties: () => x5e, getReducer: b5e };
const M5e = { type: C5e, labelKey: "reportItems:tablixColumn", defaultModel: E5e(null), getProperties: () => w5e, getReducer: b5e };
function k5e(e14) {
  return e14.reduce((e15, t10) => e15.add(t10), L$.zero);
}
function P5e(e14, t10, n10 = false) {
  const [r10, o10] = [HQ(e14), IQ(e14)];
  const [a10, i10] = [HQ(t10), IQ(t10)];
  let s10 = t10;
  return !n10 && zV.isEqual(r10, a10) && zV.isEqual(o10, i10) || (s10 = RQ(s10, ({ item: e15, cix: t11, cspan: n11, rix: r11, rspan: o11 }) => {
    const s11 = L$.sum(a10, t11, n11);
    const l10 = L$.sum(i10, r11, o11);
    if (e15.$width === s11.css && e15.$height === l10.css) return e15;
    const c10 = n5(e15, A5({ width: s11.css, height: l10.css }));
    return c10.$width && (c10.$width, s11.css), c10.$height && (c10.$height, l10.css), c10;
  })), s10;
}
function N5e(e14, t10, n10, r10) {
  if (r10 !== dZ.ROW && r10 !== dZ.COLUMN) throw new Error("Invalid resize type");
  const [o10, a10] = [e14.RowHierarchy.LevelSizes.length, e14.ColumnHierarchy.LevelSizes.length];
  const [i10, s10] = [e14.Body.Columns.length, e14.Body.Rows.length];
  const l10 = r10 === dZ.ROW;
  if (t10 < 0 || t10 > (l10 ? a10 + s10 : o10 + i10)) return e14;
  function c10(e15) {
    const t11 = L$.parse(e15).add(n10);
    return (t11.value < 0 ? L$.zero : t11).css;
  }
  if (l10 ? a10 - 1 < t10 : o10 - 1 < t10) {
    return AV(e14, { Body: l10 ? { Rows: { [t10 - a10]: { Height: { $apply: c10 } } } } : { Columns: { [t10 - o10]: { $apply: c10 } } } });
  }
  const u10 = l10 ? uZ.COLUMN : uZ.ROW;
  return AV(e14, { [u10]: { LevelSizes: { [t10]: { $apply: c10 } } } });
}
function D5e(e14, { index: t10, delta: n10 }, r10) {
  if (r10 !== dZ.ROW && r10 !== dZ.COLUMN) throw new Error("Invalid resize type");
  const o10 = r10 === dZ.ROW;
  if (0 === n10.value) return e14;
  let a10 = e14;
  let i10 = n10;
  if (n10.value < 0) {
    const s10 = o10 ? IQ(e14) : HQ(e14);
    if (a10 = RQ(e14, (e15) => {
      const { cix: r11, cspan: a11, rix: l10, rspan: c10, item: u10 } = e15;
      if (o10 && l10 <= t10 && t10 < l10 + c10) {
        const e16 = L$.sum(s10, l10, c10);
        const t11 = e16.add(i10);
        const r12 = n5(u10, A5({ height: t11.css }));
        if (r12.$height && t11.css !== r12.$height) {
          const t12 = L$.parse(r12.$height).subtract(e16);
          t12.greaterThan(n10) && (i10 = t12);
        }
        return r12;
      }
      if (!o10 && r11 <= t10 && t10 < r11 + a11) {
        const e16 = L$.sum(s10, r11, a11);
        const t11 = (t12) => {
          const r12 = L$.parse(t12.$width).subtract(e16);
          r12.greaterThan(n10) && (i10 = r12);
        };
        const o11 = e16.add(i10);
        const l11 = n5(u10, A5({ width: o11.css }));
        return l11.$width && o11.css !== l11.$width && t11(l11), l11;
      }
      return u10;
    }), i10.equal(n10)) return N5e(a10, t10, n10, r10);
  }
  return P5e(e14, N5e(a10, t10, i10, r10), true);
}
function L5e(e14, { width: t10, height: n10 }) {
  function r10(e15, t11, n11, r11) {
    const o11 = ((e16, t12) => {
      if (0 === e16.length) return [];
      const n12 = t12.subtract(k5e(e16)).multiply(1 / e16.length);
      const r12 = e16.map((e17) => e17.add(n12).normalize());
      return r12[e16.length - 1] = t12.subtract(L$.sum(r12, 0, e16.length - 1)), r12;
    })(t11, n11);
    return o11.reduce((e16, n12, a10) => D5e(e16, { index: a10, delta: o11[a10].subtract(t11[a10]) }, r11), e15);
  }
  let o10 = e14;
  return t10 && (o10 = r10(o10, HQ(e14), t10, dZ.COLUMN)), n10 && (o10 = r10(o10, IQ(e14), n10, dZ.ROW)), o10;
}
function H5e(e14, t10 = null) {
  if (e14 === t10) return e14;
  const [n10, r10] = t10 ? [HQ(t10), IQ(t10)] : [];
  const [o10, a10] = [HQ(e14), IQ(e14)];
  if (zV.isEqual(n10, o10) && zV.isEqual(r10, a10)) return e14;
  const [i10, s10] = [k5e(o10).css, k5e(a10).css];
  const l10 = o10.map((t11, n11) => e14.$columns.collection[n11] ? __spreadProps(__spreadValues({}, e14.$columns.collection[n11]), { Width: t11.css }) : E5e(t11.css));
  const c10 = a10.map((t11, n11) => e14.$rows.collection[n11] ? Object.assign({}, e14.$rows.collection[n11], { Height: t11.css }) : T5e(t11.css));
  return AV(e14, { $rows: { collection: { $set: c10 } }, $columns: { collection: { $set: l10 } }, $width: { $set: i10 }, $height: { $set: s10 } });
}
function I5e(e14, t10) {
  return _5e(e14, t10);
}
function _5e(e14, t10, n10) {
  const r10 = e14.RowHierarchy.LevelSizes.length || 0;
  const o10 = e14.ColumnHierarchy.LevelSizes.length || 0;
  function a10(e15, t11, n11, r11) {
    const o11 = r11;
    if (n11 > 0) {
      const a11 = L$.sum(r11, t11, n11);
      const i11 = e15.subtract(a11);
      i11.value > 0 && (o11[t11 + n11 - 1] = r11[t11 + n11 - 1].add(i11));
    }
  }
  const [i10, s10] = [HQ(e14), IQ(e14)];
  const l10 = (e15) => e15 && L$.parse(e15) || L$.zero;
  const c10 = [];
  const u10 = [];
  let d10 = false;
  function p10(e15, t11, n11, r11) {
    if (n11[e15] && t11[e15] !== n11[e15]) {
      const o11 = l10(n11[e15]).subtract(l10(t11[e15]));
      0 !== o11.value && (d10 = true), o11.value < 0 && r11(o11);
    }
  }
  let m10 = AQ(e14, (e15) => {
    const n11 = t10(e15);
    const { cix: r11, cspan: o11, rix: d11, rspan: m11, item: h11 } = e15;
    return p10("$width", h11, n11, (e16) => {
      c10[r11 + o11 - 1] = e16;
    }), p10("$height", h11, n11, (e16) => {
      u10[d11 + m11 - 1] = e16;
    }), n11.$width && a10(l10(n11.$width), r11, o11, i10), n11.$height && a10(l10(n11.$height), d11, m11, s10), n11;
  }, n10);
  if (m10 === e14) return e14;
  const h10 = {};
  return s10.slice(o10).forEach((e15, t11) => {
    h10[[t11]] = { Height: { $set: e15.css } };
  }), m10 = AV(m10, { Body: { Rows: h10, Columns: { $set: i10.slice(r10).map((e15) => e15.css) } }, RowHierarchy: { LevelSizes: { $set: i10.slice(0, r10).map((e15) => e15.css) } }, ColumnHierarchy: { LevelSizes: { $set: s10.slice(0, o10).map((e15) => e15.css) } } }), m10 = P5e(e14, m10, d10), zV.isEmpty(c10) || c10.forEach((e15, t11) => {
    m10 = D5e(m10, { index: t11, delta: e15 }, dZ.COLUMN);
  }), zV.isEmpty(u10) || u10.forEach((e15, t11) => {
    m10 = D5e(m10, { index: t11, delta: e15 }, dZ.ROW);
  }), m10;
}
const V5e = (e14) => dj(lj(e14), true, true);
function R5e(e14, t10, n10, r10, o10, a10, i10) {
  let s10 = e14;
  for (let e15 = t10.length - 1; e15 >= 0; e15--) {
    const n11 = t10[e15];
    s10 = AV(s10, { [r10]: { Members: { $set: B5e(s10[r10].Members, n11) } }, Body: { $set: a10(s10.Body, n11) } });
  }
  for (let e15 = n10.length - 1; e15 >= 0; e15--) {
    const t11 = n10[e15];
    s10 = AV(s10, { [o10]: { Members: { $set: z5e(s10[o10].Members, t11) }, LevelSizes: { $splice: [[t11, 1]] } }, Corner: { $set: i10(s10.Corner, t11) } });
  }
  return s10;
}
function A5e(e14, t10) {
  const [n10, r10, o10, a10, i10, s10] = t10 === dZ.ROW ? [e14.RowHierarchy, uZ.ROW, e14.ColumnHierarchy, uZ.COLUMN, $5e, j5e] : [e14.ColumnHierarchy, uZ.COLUMN, e14.RowHierarchy, uZ.ROW, W5e, Z5e];
  const l10 = aQ(e14.Body, t10);
  const c10 = iQ(n10.Members);
  const u10 = zV.sortedUniq(l10.concat(c10));
  const d10 = function(e15, t11) {
    if (!e15) return [];
    if (t11 !== dZ.ROW && t11 !== dZ.COLUMN) throw new Error(`Invalid argument: orientation (${t11})`);
    const n11 = [];
    for (let r11 = 0; r11 < e15.length; r11++) for (let o11 = 0; o11 < e15[r11].length; o11++) {
      const a11 = e15[r11][o11];
      a11 && a11.Item && rj(a11.Item) && n11.push(t11 === dZ.ROW ? oQ(r11, a11.RowSpan) : oQ(o11, a11.ColSpan));
    }
    return zV.flatten(n11);
  }(e14.Corner, t10);
  const p10 = sQ(o10.Members);
  const m10 = zV.sortedUniq(d10.concat(p10));
  return R5e(V5e(e14), u10, m10, r10, a10, i10, s10);
}
function O5e(e14, t10) {
  const n10 = bj(e14);
  return n10 && (n10.Type === rW.tablixRow || n10.Type === rW.tablixColumn) ? function(e15, t11) {
    const [n11, r10, o10, a10, i10, s10] = t11 === dZ.ROW ? [e15.$rows.collection, e15.Body.Rows.length, uZ.ROW, uZ.COLUMN, $5e, j5e] : [e15.$columns.collection, e15.Body.Columns.length, uZ.COLUMN, uZ.ROW, W5e, Z5e];
    const l10 = n11.length - r10;
    const c10 = [];
    const u10 = [];
    return n11.forEach((e16, t12) => {
      aj(e16) && (t12 >= l10 ? c10.push(t12 - l10) : u10.push(t12));
    }), R5e(V5e(e15), c10, u10, o10, a10, i10, s10);
  }(e14, t10) : A5e(e14, t10);
}
function B5e(e14, t10) {
  if (t10 < 0) throw new Error(`Invalid argument: index (${t10})`);
  const n10 = (e15) => {
    const t11 = GJ(e15);
    return t11 && AV(e15, { BodyCount: { $set: t11 - 1 } }) || e15;
  };
  const r10 = (e15, t11, n11) => AV(e15, { Children: { [t11]: { $set: n11 } } });
  const o10 = JJ(e14, t10);
  const a10 = ((e15) => {
    for (let t11 = e15.length - 1; t11 >= 0; t11--) if (e15[t11].Children.length > 1) return t11;
    return -1;
  })(o10);
  if (-1 === a10) return CQ(AV(e14, { $splice: [[e14.indexOf(o10[0]), 1]] }));
  let i10 = n10(((e15, t11) => {
    const n11 = e15.Children.indexOf(t11);
    if (n11 < 0) throw new Error("Cannot find child to delete");
    return AV(e15, { Children: { $splice: [[n11, 1]] } });
  })(o10[a10], o10[a10 + 1]));
  for (let e15 = a10 - 1; e15 >= 0; e15--) {
    const t11 = o10[e15];
    const a11 = o10[e15 + 1];
    const s10 = t11.Children.indexOf(a11);
    i10 = n10(r10(t11, s10, i10));
  }
  return CQ(AV(e14, { [e14.indexOf(o10[0])]: { $set: i10 } }));
}
function z5e(e14, t10) {
  if (t10 < 0) throw new Error(`Invalid argument: level (${t10})`);
  const n10 = (e15, t11) => AV(e15, { Children: { $set: t11 } });
  const r10 = [];
  return e14.forEach((e15) => {
    const o10 = ZJ(e15);
    if (t10 < o10) if (0 === o10) r10.push(n10(e15, z5e(e15.Children, t10)));
    else if (1 === o10) {
      const t11 = e15.Group;
      const n11 = !e15.Children || 0 === e15.Children.length;
      t11 || n11 ? r10.push(((e16) => AV(e16, { Header: { $set: null } }))(e15)) : e15.Children.forEach((e16) => r10.push(e16));
    } else {
      if (!(o10 > 1)) throw new Error("Member is not valid. LevelCount of a Member is less than 0");
      r10.push(((e16) => AV(e16, { Header: { LevelCount: { $set: ZJ(e16) - 1 } } }))(e15));
    }
    else r10.push(n10(e15, z5e(e15.Children, t10 - o10)));
  }), CQ(r10);
}
function $5e(e14, t10) {
  return AV(e14, { Rows: { $splice: [[t10, 1]] } });
}
function W5e(e14, t10) {
  const n10 = e14.Rows.map((e15) => {
    let n11 = t10;
    const r10 = e15.Cells[n11] || (() => {
      let t11;
      do {
        t11 = e15.Cells[--n11];
      } while (!t11);
      return t11;
    })();
    if (r10.ColSpan > 1) {
      const t11 = AV(r10, { ColSpan: { $set: r10.ColSpan - 1 } });
      return AV(e15, { Cells: { $splice: [[n11, 2, t11]] } });
    }
    return AV(e15, { Cells: { $splice: [[n11, 1]] } });
  });
  return AV(e14, { Columns: { $splice: [[t10, 1]] }, Rows: { $set: n10 } });
}
function j5e(e14, t10) {
  if (!e14 || !e14.length) return e14;
  const n10 = (e15) => e15 && e15.RowSpan || 1;
  const r10 = e14.reduce((r11, o10, a10) => {
    if (a10 === t10) return r11;
    const i10 = a10 === t10 + 1 ? (s10 = e14[t10], l10 = e14[t10 + 1], s10.map((e15, t11) => {
      const r12 = n10(e15);
      return r12 > 1 ? AV(e15, { RowSpan: { $set: r12 - 1 } }) : l10[t11];
    })) : o10;
    var s10, l10;
    const c10 = i10.map((e15) => {
      const r12 = n10(e15);
      return a10 < t10 && t10 < a10 + r12 ? AV(e15, { RowSpan: { $set: r12 - 1 } }) : e15;
    });
    return AV(r11, { $push: [c10] });
  }, []);
  return 0 === r10.length ? [] : r10;
}
function Z5e(e14, t10) {
  if (!e14 || !e14.length) return e14;
  const n10 = e14.map((e15) => {
    const n11 = AV(e15, { $splice: [[t10, 1]] });
    const r10 = e15[t10] && e15[t10].ColSpan || 0;
    if (r10 > 1) return AV(n11, { [t10]: { $set: AV(e15[t10], { ColSpan: { $set: r10 - 1 } }) } });
    const o10 = n11.findIndex((e16, n12) => e16 && n12 < t10 && n12 + e16.ColSpan > t10);
    return o10 < 0 ? n11 : AV(n11, { [o10]: { ColSpan: { $apply: (e16) => e16 - 1 } } });
  });
  return n10.every((e15) => 0 === e15.length) ? [] : n10;
}
const G5e = (e14) => e14 && e14.Type && ("statictablixmember" === e14.Type.toLowerCase() || "dynamictablixmember" === e14.Type.toLowerCase());
const U5e = (e14) => ["string", "number", "function", "boolean", "undefined"].indexOf(typeof e14) >= 0 || null === e14;
function q5e(e14, t10, n10, r10) {
  let o10 = n10;
  return Object.getOwnPropertyNames(e14).forEach((a10) => {
    const i10 = e14[a10];
    const s10 = n10[a10];
    const l10 = t10 && t10[a10] || null;
    const c10 = r10 && r10[a10] || null;
    if (U5e(i10) || U5e(s10)) {
      if (i10 === l10) return;
      if (s10 !== c10) return;
      if (s10 === i10) return;
      o10 = AV(o10, { [a10]: { $set: i10 } });
    } else {
      const e15 = q5e(i10, l10, s10, c10);
      if (e15 === i10) return;
      o10 = AV(o10, { [a10]: { $set: e15 } });
    }
  }), o10;
}
function Y5e(e14) {
  const t10 = UJ(e14);
  if (1 === t10) {
    const t11 = e14.Children[0];
    if (function(e15) {
      return YJ(e15) && qJ(e15);
    }(t11) && !UJ(t11)) {
      if (!G5e(t11) || !G5e(e14)) throw new Error("Invalid argument");
      let n10 = q5e(t11, tz.getDescriptor(t11.Type).defaultModel, e14, tz.getDescriptor(e14.Type).defaultModel);
      return n10 = AV(n10, { BodyIndex: { $set: t11.BodyIndex } }), aj(t11) && (n10 = pj(n10)), AV(n10, { Children: { $set: [] } });
    }
  }
  if (t10 > 0) {
    const t11 = e14.Children.map((e15) => Y5e(e15));
    if (zV.xor(e14.Children, t11).length > 0) return AV(e14, { Children: { $set: t11 } });
  }
  return e14;
}
function K5e(e14) {
  const t10 = e14.Members.map((e15) => Y5e(e15));
  return zV.xor(t10, e14.Members).length > 0 ? AV(e14, { Members: { $set: t10 } }) : e14;
}
function X5e(e14) {
  let t10 = e14;
  const n10 = K5e(e14.RowHierarchy);
  n10 !== e14.RowHierarchy && (t10 = AV(t10, { RowHierarchy: { $set: n10 } }));
  const r10 = K5e(e14.ColumnHierarchy);
  return r10 !== e14.ColumnHierarchy && (t10 = AV(t10, { ColumnHierarchy: { $set: r10 } })), t10;
}
const J5e = (e14, t10) => {
  if (!t10) return e14;
  const n10 = vj(e14);
  if (!n10.length) return e14;
  const r10 = {};
  return n10.forEach(({ path: e15 }) => {
    j0(r10, `${e15}.DataElementName`, { $set: t10 });
  }), AV(e14, r10);
};
const Q5e = ["tableofcontents", "fixedpagetableofcontents", "contentplaceholder"];
function e4e(e14, t10, n10) {
  if (!e14) return e14;
  const r10 = zV.findIndex(e14, (e15) => e15 === t10);
  if (r10 >= 0) {
    const t11 = [...e14];
    const o10 = __spreadValues({}, t11[r10]);
    return o10.Group.GroupExpressions = n10 ? [n10] : [], o10.Header && o10.Header.Item && "textbox" === o10.Header.Item.Type && (o10.Header.Item.Value = n10), t11[r10] = o10, t11;
  }
  return e14.map((e15) => __spreadProps(__spreadValues({}, e15), { Children: e4e(e15.Children, t10, n10) }));
}
function t4e(e14) {
  const [t10, n10] = [e14.RowHierarchy, e14.ColumnHierarchy].map((e15) => ij(e15));
  if (!t10 && !n10) throw new Error("Could not toggle unselected hierarchy member");
  const [r10, o10] = t10 ? ["RowHierarchy", TG("rowGroup")] : ["ColumnHierarchy", TG("columnGroup")];
  const a10 = rQ(e14, r10, ij)[0];
  const i10 = (t11) => (n11, r11) => {
    const a11 = n11.Children && n11.Children.length ? n11.Children.reduce((e15, n12) => i10(t11)(n12, e15), []) : n11.Children;
    if (n11 === t11) {
      const t12 = n11.Type === rW.dynamicTablixMember;
      if (!n11.Header && t12 && a11.length) throw new Error("Hidden static members could not have children");
      let i11 = zJ(t12 ? null : { Name: MG(e14.Name, o10), GroupExpressions: [""] }, n11.Header, n11.Children, GJ(n11), n11.BodyIndex);
      return i11 = ((e15, t13) => {
        const n12 = Object.getOwnPropertyNames(e15);
        const r12 = Object.getOwnPropertyNames(t13);
        const o11 = zV.intersection(n12, r12).filter((n13) => "Type" !== n13 && null !== e15[n13] && null !== t13[n13]);
        let a12 = e15;
        return o11.forEach((n13) => {
          e15[n13] !== t13[n13] && (a12 = AV(a12, { [n13]: { $set: t13[n13] } }));
        }), a12;
      })(i11, n11), i11 = hj(i11, n11), r11.push(i11), r11;
    }
    return r11.push(AV(n11, { Children: { $set: a11 } })), r11;
  };
  const s10 = a10.length && a10[a10.length - 1];
  if (!s10) throw new Error(`Could not delete item by path: '${a10}'`);
  return AV(e14, { [r10]: { Members: { $apply: (e15) => e15.reduce((e16, t11) => i10(s10)(t11, e16), []) } } });
}
function n4e(e14, t10) {
  const [n10, r10] = aj(e14.$rows) ? [true, e14.$rows.collection] : [false, e14.$columns.collection];
  const o10 = r10.reduce((e15, r11, o11) => {
    if (rj(r11)) {
      return ((e16, t11, r12) => D5e(e16, { index: t11, delta: r12 }, n10 ? dZ.ROW : dZ.COLUMN))(e15, o11, L$.parse(t10).subtract(L$.parse(r11[n10 ? "Height" : "Width"])));
    }
    return e15;
  }, e14);
  return H5e(o10);
}
const r4e = (e14, t10, n10) => _5e(e14, ({ item: e15 }) => e15, ({ member: r10 }) => {
  const o10 = !(r10.Group && r10.Group.GroupExpressions.length && r10.Group.GroupExpressions[0]);
  const a10 = r10.Type === rW.dynamicTablixMember;
  return r10.Header && rj(r10.Header.Item) && a10 && o10 ? ((r11) => {
    const o11 = t10.replace(Jc("[^\\p{L}\\p{N}_]", "g"), "");
    return AV(r11, { Group: { Name: { $set: MG(e14.Name, o11) }, GroupExpressions: { $set: [n10] } } });
  })(r10) : r10;
});
const o4e = [O5.type, o2.type, l2.type];
function a4e(e14) {
  var _a2;
  const t10 = nz.of(e14).of("rdlx").getDefaultReducer();
  const { rdlx: n10 } = KO.of(e14);
  const r10 = (_a2 = n10 == null ? void 0 : n10.reportItemsFeatures) == null ? void 0 : _a2.tablix;
  function o10(t11, n11) {
    const r11 = function(e15) {
      const [t12, n12] = [HQ(e15), IQ(e15)];
      return function(e16 = 0, r12 = 0, o12 = 0, a11 = 0) {
        return { width: L$.sum(t12, e16, r12), height: L$.sum(n12, o12, a11) };
      };
    }(t11);
    const o11 = n11.payload.items.find((e15) => Q5e.includes(e15.Type));
    if (o11) throw $0(o11.Type, t11.Type);
    return I5e(t11, ({ item: o12, cix: a11, cspan: i11, rix: s10, rspan: l10 }) => {
      if (sj(o12)) {
        if (OW(o12.Type) || BW(o12.Type)) return n5(o12, n11);
        const c10 = n11.payload.items.map((e15, t12) => dj(__spreadValues({}, e15), true, 0 === t12));
        if (1 === c10.length && c10[0].Type !== rW.line) {
          const { width: e15, height: t12 } = r11(a11, i11, s10, l10);
          return n5(AV(c10[0], { $width: { $set: e15.css }, $height: { $set: t12.css } }), A5({ width: e15.css, height: t12.css }));
        }
        const u10 = L$.max(c10.map((e15) => L$.parse(e15.$place.Left).add(L$.parse(e15.$place.Width))).concat(L$.parse(o12.$width || o12.$place.Width)));
        const d10 = L$.max(c10.map((e15) => L$.parse(e15.$place.Top).add(L$.parse(e15.$place.Height))).concat(L$.parse(o12.$height || o12.$place.Height)));
        const p10 = t11.Type === rW.fplTablix ? rW.fplRectangle : rW.rectangle;
        return n5(hj(AV(nz.of(e14).create(p10, KB(TG(p10))), { $place: { Width: { $set: u10.css }, Height: { $set: d10.css } } }), o12), n11);
      }
      return o12;
    });
  }
  function a10(t11, n11) {
    const { type: r11, payload: s10 } = n11;
    switch (r11) {
      case Xj: {
        if (rj(t11)) return t11;
        const e15 = P5e(t11, function(e16, { hierarchyName: t12, position: n12 }) {
          if (t12 !== uZ.ROW && t12 !== uZ.COLUMN) throw new Error("Invalid hierarchy name");
          const r12 = TG("rowGroup");
          const o11 = TG("columnGroup");
          const { cellWidth: a11, cellHeight: i11 } = zq(e16.$templateId);
          const [s11, l10, c10, u10, d10, p10, m10] = t12 === uZ.ROW ? [e16.RowHierarchy, "RowHierarchy", r12, a11, hQ, e16.ColumnHierarchy.LevelSizes.length, vQ] : [e16.ColumnHierarchy, "ColumnHierarchy", o11, i11, fQ, e16.RowHierarchy.LevelSizes.length, bQ];
          const h10 = ((e17) => {
            const t13 = zV.findLastIndex(e17, (e18) => e18.Group);
            return t13 >= 0 ? e17.slice(0, t13 + 1) : e17;
          })(rQ(e16, t12, ij, { searchInBody: true })[0]);
          const f10 = () => ({ Name: MG(e16.Name, c10), GroupExpressions: [""] });
          const g10 = (y10 = e16.LayerName, () => AV(Wq(e16.$templateId), { LayerName: { $set: y10 } }));
          var y10;
          const v10 = /* @__PURE__ */ ((t13) => () => AV(jq(e16.$templateId), { Item: { LayerName: { $set: t13 } } }))(e16.LayerName);
          switch (n12) {
            case pZ.PARENT:
            case pZ.CHILD: {
              const t13 = n12 === pZ.PARENT ? h10.length - 1 : h10.length;
              const r13 = h10.reduce((e17, n13, r14) => e17 + (r14 < t13 ? ZJ(n13) : 0), 0);
              const o12 = (e17) => {
                const t14 = zJ(e17 === h10[h10.length - 1] ? f10() : null, { Item: g10(), LevelCount: 1 }, n12 === pZ.PARENT ? [e17] : e17.Children, GJ(e17));
                const r14 = SQ(t14.Children) && t14.Children.some((e18) => aj(e18));
                return r14 ? ((e18, t15) => mj(hj(e18, t15)))(t14, e17) : t14;
              };
              const a12 = n12 === pZ.CHILD;
              const i12 = s11.Members.map((e17) => dQ(e17, r13, o12, n12, h10, a12));
              return AV(e16, { [l10]: { Members: { $set: CQ(i12) }, LevelSizes: { $splice: [[r13, 0, u10]] } }, Corner: { $set: d10(e16.Corner, r13, g10, p10, e16.$templateId) } });
            }
            case pZ.AFTER:
            case pZ.BEFORE: {
              const t13 = gQ(s11.Members, h10, n12, f10, g10);
              const r13 = yQ(h10[h10.length - 1]);
              const o12 = m10(e16.Body, r13, v10, n12, void 0, e16.$templateId);
              return AV(e16, { [l10]: { Members: { $set: t13 } }, Body: { $set: o12 } });
            }
            default:
              throw new Error("Not implemented, only insert parent group is done");
          }
        }(t11, s10));
        return a10(e15, S2());
      }
      case Jj:
      case tZ: {
        if (rj(t11)) return t11;
        let e15 = t11;
        for (let t12 = 0; t12 < n11.payload.count; t12++) e15 = H2e(e15, s10, r11 === tZ ? dZ.ROW : dZ.COLUMN);
        return e15 = P5e(t11, e15), zW(t11.Type) ? a10(e15, S2()) : e15;
      }
      case Qj:
      case nZ: {
        const e15 = P5e(t11, function(e16, { index: t12 }, n12) {
          if (n12 !== dZ.ROW && n12 !== dZ.COLUMN) throw new Error(`Invalid Tablix entity type: ${n12}`);
          const r12 = n12 === dZ.ROW;
          const [o11, a11] = r12 ? [e16.ColumnHierarchy.LevelSizes.length, e16.Body.Rows.length] : [e16.RowHierarchy.LevelSizes.length, e16.Body.Columns.length];
          return o11 < t12 ? (() => {
            const i11 = t12 === o11 + a11;
            const [s11, l10] = i11 ? [t12 - o11 - 1, mZ.After] : [t12 - o11, mZ.Before];
            const c10 = ((e17) => {
              for (let t13 = e17.length - 1; t13 >= 0; t13--) if (e17[t13].Children.length > 1) return e17.slice(0, t13 + 2);
              return [e17[0]];
            })(JJ(r12 ? e16[uZ.ROW].Members : e16[uZ.COLUMN].Members, s11));
            return I2e(e16, n12, true, c10, l10);
          })() : (() => {
            const a12 = r12 ? e16[uZ.COLUMN].Members : e16[uZ.ROW].Members;
            if (0 === t12 && "dynamictablixmember" === (i11 = a12[0]).Type && 0 === ZJ(i11)) return I2e(e16, n12, false, [a12[0]], mZ.Before);
            var i11;
            const s11 = 0 !== o11 && t12 === o11;
            const [l10, c10] = s11 ? [t12 - 1, mZ.After] : [t12, mZ.Before];
            const u10 = XJ(a12, l10);
            return I2e(e16, n12, false, u10, c10);
          })();
        }(t11, s10, r11 === nZ ? dZ.ROW : dZ.COLUMN));
        return a10(e15, S2());
      }
      case $G: {
        const { delta: e15 } = n11.payload;
        const r12 = L$.isZeroLike(e15 && e15.x);
        const o11 = L$.isZeroLike(e15 && e15.y);
        if (r12 && o11) return t11;
        if (aj(t11.$columns) && !r12) {
          const n12 = t11.$columns.collection.findIndex((e16) => sj(e16));
          if (n12 >= 0) return D5e(t11, { index: n12, delta: L$.parse(e15.x) }, dZ.COLUMN);
        } else if (aj(t11.$rows) && !o11) {
          const n12 = t11.$rows.collection.findIndex((e16) => sj(e16));
          if (n12 >= 0) return D5e(t11, { index: n12, delta: L$.parse(e15.y) }, dZ.ROW);
        }
        break;
      }
      case eZ:
      case rZ: {
        if (rj(t11) || !ij(t11)) return t11;
        const n12 = r11 === rZ;
        const o11 = n12 ? dZ.ROW : dZ.COLUMN;
        const i11 = pj(P5e(t11, O5e(t11, o11)));
        const s11 = (n12 ? IQ : HQ)(i11);
        const l10 = (t12, n13) => n13(`reportItems:${nz.of(e14).getBaseItemType(t12)}`);
        return RQ(i11, ({ item: e15, cix: t12, cspan: r12, rix: o12, rspan: a11 }) => {
          if (!L$.sum(s11, n12 ? o12 : t12, n12 ? a11 : r12).equal(L$.parse(n12 ? e15.$height || e15.$place.Height : e15.$width || e15.$place.Width))) {
            const { t: t13 } = hG();
            const r13 = l10(n12 ? rW.tablixRow : rW.tablixColumn, t13);
            throw new B0(fG("deleteRowColumn", { rowColumn: r13 }), gG("deleteRowColumn", { rowColumn: r13, itemType: l10(e15.Type, t13), itemName: e15.Name }));
          }
          return e15;
        }), a10(i11, S2());
      }
      case "TABLIX/SET_GROUPBY":
        return function(e15, t12, n12) {
          return AV(e15, { RowHierarchy: { Members: { $apply: (e16) => e4e(e16, t12, n12) } }, ColumnHierarchy: { Members: { $apply: (e16) => e4e(e16, t12, n12) } } });
        }(t11, s10.targetMember, s10.value);
      case oZ:
      case aZ: {
        if (rj(t11)) return t11;
        const e15 = function(e16, t12) {
          if (t12 !== uZ.ROW && t12 !== uZ.COLUMN) throw new Error("Invalid hierarchy name");
          const n12 = t12 === uZ.ROW ? "RowHierarchy" : "ColumnHierarchy";
          const r12 = rQ(e16, n12, ij, { searchInBody: true })[0];
          const o11 = (e17) => (t13, n13) => {
            const r13 = t13.Children && t13.Children.length ? t13.Children.reduce((t14, n14) => o11(e17)(n14, t14), []) : t13.Children;
            return t13 === e17 ? t13.Header ? (n13.push(hj(zJ(null, t13.Header, t13.Children, GJ(t13), t13.BodyIndex), t13)), n13) : AV(n13, { $push: SQ(r13) ? r13 : [Object.assign(zJ(), { BodyIndex: t13.BodyIndex })] }) : (n13.push(AV(t13, { Children: { $set: r13 } })), n13);
          };
          let a11 = null;
          for (let e17 = r12.length - 1; e17 >= 0; e17--) if (r12[e17] && "dynamictablixmember" === r12[e17].Type) {
            a11 = r12[e17];
            break;
          }
          if (!a11) throw new Error(`Could not delete item by path: '${r12}'`);
          const i11 = AV(e16, { [n12]: { Members: { $apply: (e17) => e17.reduce((e18, t13) => o11(a11)(t13, e18), []) } } });
          return bj(i11) ? i11 : pj(i11);
        }(t11, r11 === oZ ? uZ.COLUMN : uZ.ROW);
        return a10(e15, S2());
      }
      case iZ:
        if (rj(t11)) return t11;
        return a10(P5e(t11, A2e(t11, s10)), S2());
      case sZ:
        if (rj(t11)) return t11;
        if (BQ(t11)) return P5e(t11, Q2e(t11), true);
        break;
      case lZ:
        if (rj(t11)) return t11;
        if (BQ(t11)) return P5e(t11, function(e15) {
          const t12 = { [hZ.Corner]: Z2e, [hZ.ColumnHierarchy]: U2e, [hZ.RowHierarchy]: U2e, [hZ.Body]: G2e };
          const n12 = xQ(e15);
          const r12 = t12[n12];
          return r12 ? AV(e15, { [n12]: { $set: r12(e15[n12]) } }) : e15;
        }(t11), true);
        break;
      case cZ:
        if (rj(t11)) return t11;
        return a10(t4e(t11), S2());
      case WG:
      case jG:
      case UG:
        if (BQ(t11)) {
          return a10(P3(o10(t11, n11), t11.LayerName), S2());
        }
        break;
      case ZG:
        if (BQ(t11)) {
          const e15 = (e16) => dj(Wq(t11.$templateId), true, ij(e16));
          let n12 = RQ(t11, ({ item: t12 }) => rj(t12) ? e15(t12) : t12);
          return n12 = P5e(t11, n12, true), zW(n12.Type) ? a10(n12, S2()) : n12;
        }
        break;
      case GG: {
        if (!ij(t11) || !BQ(t11, true)) break;
        const { item: e15 } = n11.payload;
        let r12 = I5e(t11, (t12) => {
          const n12 = t12.item;
          return sj(n12) ? hj(e15, n12) : n12;
        });
        return r12 = a10(r12, S2()), r12;
      }
      case d2.type:
        if (rj(t11)) {
          const { descriptor: e15, value: n12 } = s10;
          const r12 = { width: "Width" === e15.valuePath ? L$.parse(n12) : null, height: "Height" === e15.valuePath ? L$.parse(n12) : null };
          return L5e(t11, r12);
        }
        if (aj(t11.$rows) || aj(t11.$columns)) return n4e(t11, s10.value);
        break;
      case "TABLIX/SET_ROW_COLUMN_MEMBER_LAYOUT_PROPERTY":
        if (BQ(t11)) {
          const { propertyName: e15, value: n12 } = s10;
          const r12 = AQ(t11, ({ item: e16 }) => e16, ({ member: r13, memberPath: o11, rix: a11, cix: i11 }) => {
            if ("number" != typeof r13.BodyIndex) return r13;
            const [s11, l10] = o11.includes("RowHierarchy") ? [t11.$rows, a11] : [t11.$columns, i11];
            return aj(s11) && aj(s11.collection[l10]) ? AV(r13, { [e15]: { $set: n12 } }) : r13;
          });
          return r12;
        }
        break;
      case "TABLIX/SET_ROW_COLUMN_ITEM_PROPERTIES":
        if (BQ(t11)) {
          const { descriptorValuePairs: e15 } = s10;
          const n12 = (e16, t12, n13) => {
            const r13 = t12.split(".");
            let o11;
            return r13.reduce((e17, t13, a11) => (0 === a11 && (o11 = e17), o11[t13] = {}, o11 = o11[t13], a11 === r13.length - 1 && (o11.$set = n13), e17), {});
          };
          const r12 = RQ(t11, ({ item: r13, rix: o11, cix: a11 }) => {
            const i11 = [t11.$rows.collection[o11], t11.$columns.collection[a11]].some((e16) => aj(e16));
            if (!i11) return r13;
            const s11 = {};
            return e15.forEach(({ descriptor: { valuePath: e16 }, value: t12 }) => {
              const o12 = jN(e16)(r13);
              void 0 !== o12 && t12 !== o12 && zV.merge(s11, n12(r13, e16, t12));
            }), zV.isEmpty(s11) ? r13 : AV(r13, s11);
          });
          return r12;
        }
        break;
      case v2.type: {
        const { id: e15, name: r12 } = n11.payload;
        return AV(t11, { ReportStyle: { StyleId: { $set: e15 || "" }, StyleName: { $set: r12 || "" } } });
      }
      case b2.type: {
        const { style: r12 } = n11.payload;
        if (rj(t11)) {
          const n12 = y5e(e14, r12);
          return n12 ? v5e(e14, t11, n12) : t11;
        }
        break;
      }
      case S2.type: {
        if (!zW(t11.Type)) return t11;
        const n12 = y5e(e14, t11.$style);
        return n12 ? v5e(e14, t11, n12, true) : t11;
      }
      case D2.type: {
        const e15 = t11.RowHierarchy.LevelSizes.length || 0;
        const r12 = t11.ColumnHierarchy.LevelSizes.length || 0;
        const o11 = {};
        return t11.Body.Rows.forEach((a11, i11) => {
          const s11 = r12 + i11;
          const l10 = {};
          a11.Cells.forEach((r13, o12) => {
            const a12 = e15 + o12;
            (r13 && aj(r13.Item) || rj(t11.$rows.collection[s11]) || rj(t11.$columns.collection[a12])) && (l10[o12] = { AutoMergeMode: { $set: n11.payload.autoMergeMode } });
          }), zV.isEmpty(l10) || (o11[i11] = { Cells: l10 });
        }), zV.isEmpty(o11) ? t11 : AV(t11, { Body: { Rows: o11 } });
      }
      default:
        return i10(t11, n11);
    }
    return t11;
  }
  function i10(e15, n11) {
    const r11 = _5e(e15, ({ item: e16 }) => aj(e16) ? n5(e16, n11) : e16, ({ member: e16 }) => rj(e16) ? n5(e16, n11) : e16);
    return t10(r11, n11);
  }
  return (e15, t11) => {
    let n11 = e15;
    const { type: o11, payload: s10 } = t11;
    if (o4e.includes(o11)) {
      const e16 = s10.dataSetName || s10.dataSet;
      const t12 = vj(n11);
      t12.length && t12.some((e17) => !zj(n11, e17.path)) && e16 && !n11.DataSetName && (n11 = AV(n11, { DataSetName: { $set: e16 } }));
    }
    if (A5.match(t11)) {
      const { width: e16, height: t12 } = s10;
      n11 = L5e(n11, { width: e16 && L$.parse(e16), height: t12 && L$.parse(t12) });
    } else if (rj(n11)) n11 = X5e(a10(n11, t11));
    else if (BQ(n11)) {
      switch (t11.type) {
        case o2.type:
          s10.fieldName && !s10.preventGroupUpdate && (r10.autoFillCorner && (n11 = W2e(n11, s10.fieldName)), n11 = r4e(n11, s10.fieldName, s10.value));
          break;
        case O5.type:
        case l2.type:
          t11.payload.fieldName && !t11.payload.preventGroupUpdate && (r10.autoFillCorner && (n11 = W2e(n11, t11.payload.fieldName)), n11 = r4e(n11, s10.fieldName, `=${G1(s10.fieldPath || s10.fieldName)}`));
      }
      if (o4e.includes(o11)) {
        const { fieldName: e17 } = s10;
        n11 = J5e(n11, e17);
      }
      const e16 = i10(n11, t11);
      n11 = e16 === n11 ? X5e(a10(n11, t11)) : e16;
    } else n11 = i10(n11, t11);
    return n11 = H5e(n11, e15), n11;
  };
}
const i4e = [D0e.TOOLBOXITEM, D0e.REPORTITEM, D0e.SUGGESTIONITEM];
const s4e = (e14) => {
  const { makeImageUrl: t10, getItemLayerInfo: n10, instanceId: r10, getReport: o10, renderItem: a10, setDecorations: i10, getDefaultStyle: s10, embeddedImages: l10 } = ep.useContext(bqe);
  const { ColSpan: c10, RowSpan: u10, Content: d10, CellWidth: p10, CellHeight: m10, path: h10, dataSets: f10, parentBackgroundColor: g10, onlyContent: y10, onClick: v10, rowIdx: b10, colIdx: S10, theme: C10 } = e14;
  const { lockLayout: x10 } = KO.of(r10);
  const w10 = PA();
  const [{ isOver: T10, canDrop: E10, dragSourceItem: F10, dragSourceItemType: M10 }, k10] = are({ accept: ["reportitem", "toolboxItem", "smartSuggestion"], drop: (t11, n11) => {
    const { Content: { Type: a11, Name: i11 } } = e14;
    o10 || console.error("Failed to obtain getReport from context. Expected report glyph component somewhere above in the component tree.");
    const l11 = nz.of(r10).getReducer("multisectionreport");
    if (!l11) return;
    const c11 = n11.getItem();
    const u11 = n11.getItemType();
    let d11 = o10();
    const p11 = [];
    const { type: m11, path: f11 } = c11;
    if (f11 && m11 !== rW.section && m11 !== rW.fplSection) {
      const e15 = f11.split(".").reduce((e16, t12) => e16 && e16[t12], d11);
      if (e15 && !rj(e15)) {
        const t12 = e15.Name ? h5([e15.Name]) : c5(f11, m11);
        const n12 = e15.Name ? m5([e15.Name]) : l5(f11, m11);
        const r11 = k0e.ctrlPressed ? n12 : t12;
        d11 = l11(d11, r11), p11.push(r11);
      }
    }
    const g11 = V0e(d11);
    const y11 = u11 !== D0e.REPORTITEM;
    const v11 = p11.concat(y11 ? [c5(h10, a11), XG({ Type: c11.reportItemType, Name: KB(c11.nameTemplate), Style: s10(c11.reportItemType) })] : [JG(), h5([i11]), KG({ items: g11 })]);
    try {
      v11.reduce(l11, o10());
    } catch (e15) {
      return;
    }
    if (v11.length > 0) {
      const e15 = u11 === D0e.TOOLBOXITEM ? p2({ actions: v11 }) : rz(v11);
      w10(e15);
    }
  }, hover: (e15, t11) => {
    t11.isOver({ shallow: true }) && i10("", []);
  }, canDrop: (e15, t11) => {
    const n11 = t11.getItemType();
    const r11 = t11.getItem();
    const o11 = Q5e.includes((r11.reportItemType || r11.type).toLowerCase());
    const a11 = [D0e.FIELD, D0e.TOOLBOXITEM, D0e.REPORTITEM, D0e.SUGGESTIONITEM].some((e16) => e16 === n11);
    return a11 && !o11 && t11.isOver({ shallow: true });
  }, collect: (e15) => i4e.includes(e15.getItemType()) && (e15.didDrop() || e15.isOver({ shallow: true })) ? { canDrop: e15.canDrop(), isOver: e15.isOver(), dragSourceItem: e15.getItem(), dragSourceItemType: e15.getItemType() } : { canDrop: false, isOver: false, dragSourceItem: null, dragSourceItemType: null } });
  const P10 = () => {
    const { path: e15, type: t11 } = F10;
    o10 || console.error("Failed to obtain getReport from context. Expected report glyph component somewhere above in the component tree.");
    let n11 = o10();
    const a11 = nz.of(r10).getReducer("multisectionreport");
    if (!e15 || !a11) return false;
    if (t11 !== rW.section && t11 !== rW.fplSection) {
      const r11 = e15.split(".").reduce((e16, t12) => e16 && e16[t12], n11);
      if (r11 && !rj(r11)) {
        const o11 = r11.Name ? h5([r11.Name]) : c5(e15, t11);
        const i11 = r11.Name ? m5([r11.Name]) : l5(e15, t11);
        n11 = a11(n11, k0e.ctrlPressed ? i11 : o11);
      }
    }
    return vj(n11).some((e16) => h10.includes(e16.path));
  };
  const N10 = __spreadProps(__spreadValues({}, d10), { $place: __spreadProps(__spreadValues({}, d10.$place), { Width: p10, Height: m10 }) });
  const D10 = { Width: "1pt", Style: "dotted", Color: "#dedede" };
  const L10 = M10 !== D0e.REPORTITEM;
  const H10 = ["ar-tablix-cell"];
  rj(d10) && H10.push("selected"), T10 && E10 && (L10 || !P10()) && H10.push("ar-tablix-cell-hover");
  const { isVisible: I10, opacity: _10, dataFieldVisible: V10 } = n10(d10);
  const R10 = rj(d10) ? 1 : I10 ? _10 : 0;
  const A10 = N10.Style || {};
  const O10 = Bme(A10.BackgroundColor, g10, C10);
  const B10 = A10 == null ? void 0 : A10.BackgroundImage;
  const z10 = ep.useCallback(() => t10(B10.Source, B10.Value, l10), [B10 == null ? void 0 : B10.Source, B10 == null ? void 0 : B10.Value, l10, t10]);
  const $10 = B10 ? z10() : "";
  let W10 = { width: p10, height: m10, color: Sme(A10.Color, C10) || "black", pointerEvents: I10 ? "all" : "none" };
  let j10 = {};
  if (!k2e(N10.Type)) {
    j10 = Mme(A10, C10, D10), VW(N10.Type) && (j10.opacity = R10);
    const e15 = !P2e(N10.Type);
    W10 = __spreadProps(__spreadValues({}, W10), { backgroundColor: e15 ? O10 : "transparent", backgroundImage: e15 ? $10 : "" }), H10.push($me(B10));
  }
  VW(N10.Type) || (W10.opacity = R10);
  const Z10 = I10 || VW(N10.Type) ? tp.createElement("div", { onClick: (e15) => {
    v10(e15, b10, S10);
  } }, a10(N10, h10, f10, O10, V10, !!y10), tp.createElement("div", { style: j10 })) : null;
  const G10 = (L10 || !P10()) && I10;
  return tp.createElement("td", { className: H10.join(" "), style: W10, colSpan: c10, rowSpan: u10, ref: !G10 || x10 || y10 ? void 0 : k10 }, Z10);
};
const l4e = (e14, t10, n10) => {
  let [r10, o10] = [null, null];
  t10.lowerThan(L$.zero) && (r10 = 0), n10.lowerThan(L$.zero) && (o10 = 0);
  let a10 = L$.zero;
  for (let i10 = 0; i10 < e14.length; i10++) {
    const s10 = a10.add(e14[i10]);
    if (null === r10 && a10.absLowerThanOrEqual(t10) && t10.absLowerThanOrEqual(s10) && (r10 = i10), null === o10 && a10.absLowerThanOrEqual(n10) && n10.absLowerThanOrEqual(s10) && (o10 = i10), null !== r10 && null !== o10) break;
    a10 = s10;
  }
  return null === r10 && (r10 = e14.length - 1), null === o10 && (o10 = e14.length - 1), [r10, o10];
};
function c4e(e14, t10, n10, { left: r10, top: o10, width: a10, height: i10 }) {
  const [s10, l10] = [o10.add(i10), r10.add(a10)];
  const [c10, u10] = l4e(e14, o10, s10);
  const [d10, p10] = l4e(t10, r10, l10);
  let [m10, h10] = [Math.min(d10, p10), Math.max(d10, p10)];
  let [f10, g10] = [Math.min(c10, u10), Math.max(c10, u10)];
  return n10.forEach((e15) => {
    (m10 <= e15.ColumnIndex && e15.ColumnIndex <= h10 || e15.ColumnIndex < m10 && m10 < e15.ColumnIndex + e15.ColSpan) && (f10 <= e15.RowIndex && e15.RowIndex <= g10 || e15.RowIndex < f10 && f10 < e15.RowIndex + e15.RowSpan) && (e15.ColumnIndex < m10 && (m10 = e15.ColumnIndex), e15.ColumnIndex + e15.ColSpan > h10 + 1 && (h10 = e15.ColumnIndex + e15.ColSpan - 1), e15.RowIndex < f10 && (f10 = e15.RowIndex), e15.RowIndex + e15.RowSpan > g10 + 1 && (g10 = e15.RowIndex + e15.RowSpan - 1));
  }), { firstColumn: m10, lastColumn: h10, firstRow: f10, lastRow: g10 };
}
function u4e(e14, t10 = 1) {
  const [n10, r10, o10] = [N0e(e14.getDifferenceFromInitialOffset(), t10), N0e(e14.getInitialClientOffset(), t10), e14.getInitialSourceClientOffset()];
  let [a10, i10] = [n10.x, n10.y];
  let [s10, l10] = [r10.x - o10.x, r10.y - o10.y];
  return a10 < 0 && ([s10, a10] = [s10 + a10, -a10]), i10 < 0 && ([l10, i10] = [l10 + i10, -i10]), zV.mapValues({ left: s10, top: l10, width: a10, height: i10 }, (e15) => L$.fromPixels(e15));
}
const d4e = H0e(I0e((e14, t10, n10, r10, o10, a10) => {
  const i10 = function(e15, t11, n11, r11) {
    let [o11, a11, i11, s11] = [];
    const { firstColumn: l11, lastColumn: c10, firstRow: u10, lastRow: d10 } = c4e(e15, t11, n11, r11);
    let p10 = L$.zero;
    for (let t12 = 0; t12 < e15.length; t12++) {
      const n12 = p10.add(e15[t12]);
      if (t12 === u10 && (i11 = p10), t12 === d10 && (s11 = n12), void 0 !== i11 && void 0 !== s11) break;
      p10 = n12;
    }
    let m10 = L$.zero;
    for (let e16 = 0; e16 < t11.length; e16++) {
      const n12 = m10.add(t11[e16]);
      if (e16 === l11 && (o11 = m10), e16 === c10 && (a11 = n12), void 0 !== o11 && void 0 !== a11) break;
      m10 = n12;
    }
    return { left: o11, top: i11, width: a11.subtract(o11), height: s11.subtract(i11) };
  }(t10, n10, r10, e14);
  const s10 = function(e15) {
    let t11 = e15;
    const n11 = (t11 == null ? void 0 : t11.getBoundingClientRect()) || { left: 0, top: 0 };
    for (; t11 && (!t11.classList || !t11.classList.contains("is-report-area")); ) t11 = t11.parentElement;
    const r11 = t11 && t11.getBoundingClientRect() || n11;
    return zV.mapValues({ x: n11.left - r11.left, y: n11.top - r11.top }, (e16) => L$.fromPixels(e16));
  }(o10);
  const l10 = __spreadProps(__spreadValues({}, i10), { left: i10.left.add(s10.x), top: i10.top.add(s10.y) });
  P0e("", [__spreadValues({ type: "selarea" }, zV.mapValues(l10, (e15) => e15.css))], a10);
}), (e14) => e14);
const p4e = "px";
const m4e = `18${p4e}`;
const h4e = `24${p4e}`;
const f4e = `6${p4e}`;
const g4e = "8px";
const y4e = "16px";
const v4e = (e14, t10) => `${e14}.$rows.collection.${t10}`;
const b4e = (e14, t10) => `${e14}.$columns.collection.${t10}`;
const S4e = (e14) => {
  if (FX()) return null;
  const { tablix: t10, leftOffset: n10, index: r10, isCorner: o10, dndEnabled: a10, getElementPath: i10, path: s10, dataType: l10 } = e14;
  const c10 = { height: `calc(${t10.height.css} + ${h4e} + ${y4e} + 6px)` };
  const { getReport: u10 } = ep.useContext(bqe);
  const d10 = PA();
  let p10 = u10();
  const m10 = { left: n10, width: g4e };
  const h10 = [];
  const f10 = i10(s10, r10 > 0 ? r10 - 1 : r10);
  const g10 = f10.split(".").reduce((e15, t11) => e15 && e15[t11], p10);
  if (g10 && !sj(g10)) {
    const e15 = c5(f10, l10);
    p10 = n5(p10, e15), h10.push(e15);
  }
  const [, y10] = Yne({ item: { reportState: p10, startDndActions: h10, resize: true, path: f10, type: "resizegrip", grips: qG.E }, canDrag: () => true, collect: (e15) => ({ isDragging: e15.isDragging() }) });
  return tp.createElement("div", { className: "ar-tablix-adorner-spot-col", style: m10 }, tp.createElement("div", { className: "ar-tablix-add-column", style: c10 }, tp.createElement("div", { className: "ar-tablix-add-column-knob", onClick: () => {
    d10(/* @__PURE__ */ function(e15) {
      return { type: Qj, payload: { index: e15 } };
    }(r10));
  } }, tp.createElement(Fm, { icon: nf(Xm), customCSS: "wd-svg" })), tp.createElement("div", { className: "ar-tablix-add-column-deco" })), !o10 && 0 !== r10 && a10 && y10(tp.createElement("div", { className: "ar-tablix-add-column-grip" })));
};
const C4e = (e14) => {
  const { tablix: t10, topOffset: n10, index: r10, isCorner: o10, dndEnabled: a10, getElementPath: i10, path: s10, dataType: l10 } = e14;
  const { getReport: c10 } = ep.useContext(bqe);
  const u10 = PA();
  let d10 = c10();
  const p10 = [];
  const m10 = i10(s10, r10 > 0 ? r10 - 1 : r10);
  const h10 = m10.split(".").reduce((e15, t11) => e15 && e15[t11], d10);
  if (h10 && !sj(h10)) {
    const e15 = c5(m10, l10);
    d10 = n5(d10, e15), p10.push(e15);
  }
  const f10 = { width: `calc(${t10.width.css} + ${h4e} + ${y4e} + 6px)` };
  const g10 = { top: n10, height: g4e };
  const [, y10] = Yne({ item: { reportState: d10, startDndActions: p10, resize: true, path: m10, type: "resizegrip", grips: qG.S }, canDrag: () => true, collect: (e15) => ({ isDragging: e15.isDragging() }) });
  if (FX()) return null;
  return tp.createElement("div", { className: "ar-tablix-adorner-spot-row", style: g10 }, tp.createElement("div", { className: "ar-tablix-add-row", style: f10 }, tp.createElement("div", { className: "ar-tablix-add-row-knob", onClick: () => {
    u10(/* @__PURE__ */ function(e15) {
      return { type: nZ, payload: { index: e15 } };
    }(r10));
  } }, tp.createElement(Fm, { icon: nf(Xm), customCSS: "wd-svg" })), tp.createElement("div", { className: "ar-tablix-add-row-deco" })), !o10 && 0 !== r10 && a10 && y10(tp.createElement("div", { className: "ar-tablix-add-row-grip" })));
};
const x4e = (e14) => {
  const { path: t10, index: n10, isSelected: r10, isPrimary: o10, isCorner: a10, isSelectionProjection: i10, isLast: s10, getElementPath: l10, dataType: c10, width: u10, height: d10, adorners: p10 } = e14;
  const m10 = { width: u10, height: d10 };
  let h10;
  if (a10) h10 = { className: "ar-tablix-header-cell corner" };
  else {
    const e15 = ["ar-item", "ar-tablix-header-cell"];
    r10 && e15.push("ar-tablix-header-cell-selection-selected"), o10 && e15.push("ar-tablix-header-cell-selection-primary"), i10 && e15.push("ar-tablix-header-cell-selection-projection"), null !== p10.row && 1 === n10 ? e15.push("top") : null !== p10.column && 1 === n10 ? e15.push("left") : null !== p10.row && s10 ? e15.push("bottom") : null !== p10.column && s10 && e15.push("right"), h10 = { className: e15.join(" "), "data-path": l10(t10, n10 - 1), "data-type": c10 };
  }
  return tp.createElement("td", __spreadProps(__spreadValues({}, h10), { style: m10 }), tp.createElement("div", { className: "ar-tablix-adorner-spot" }, 0 === n10 && tp.createElement(Fm, { icon: nf(mqe, { cssClass: hqe }) }), null !== p10.row && 1 === n10 && tp.createElement(C4e, __spreadProps(__spreadValues({}, e14), { index: 0, topOffset: `calc(-${g4e} / 2)` })), null !== p10.row && n10 > 0 && tp.createElement(C4e, __spreadProps(__spreadValues({}, e14), { topOffset: `calc(100% - (${g4e} / 2))` })), null !== p10.column && 1 === n10 && tp.createElement(S4e, __spreadProps(__spreadValues({}, e14), { index: 0, leftOffset: `calc(-${g4e} / 2)` })), null !== p10.column && n10 > 0 && tp.createElement(S4e, __spreadProps(__spreadValues({}, e14), { leftOffset: `calc(100% - (${g4e} / 2))` }))));
};
const w4e = TA()(xp("tablixWizard")((e14) => {
  const { path: t10, viewModel: n10, item: r10, dndEnabled: o10 } = e14;
  const { instanceId: a10, getReport: i10 } = ep.useContext(bqe);
  const s10 = PA();
  const { t: l10 } = vp();
  const c10 = (e15, r11, a11, i11, s11 = false, l11 = false) => {
    const c11 = { tablix: { width: n10.width, height: n10.height }, path: t10, index: e15, isLast: e15 === r11, isSelected: a11, isPrimary: i11, isColumn: s11, isCorner: l11, dndEnabled: o10 };
    return l11 ? (c11.width = m4e, c11.height = m4e, c11.adorners = { row: { visible: n10.rowAdornerStates[e15] }, column: { visible: n10.colAdornerStates[e15] } }) : s11 ? (c11.width = n10.adornerCellWidths[e15 - 1] || n10.columns[e15 - 1].css, c11.height = m4e, c11.adorners = { row: null, column: { visible: n10.colAdornerStates[e15] } }, c11.isSelectionProjection = n10.cells.filter((t11) => t11.ColumnIndex === e15 - 1).some((e16) => e16.Selected)) : (c11.width = m4e, c11.height = n10.rows[e15 - 1].css, c11.adorners = { row: { visible: n10.rowAdornerStates[e15], label: n10.rowLabels && n10.rowLabels[e15 - 1] }, column: null }, c11.isSelectionProjection = n10.cells.filter((t11) => t11.RowIndex === e15 - 1).some((e16) => e16.Selected)), c11;
  };
  const u10 = (e15 = true, t11, r11) => {
    if (r11 >= t11) {
      const o11 = e15 ? n10.rows : n10.columns;
      let a11 = L$.zero;
      for (let e16 = t11; e16 <= r11; e16++) a11 = a11.add(o11[e16]);
      return a11;
    }
    return L$.zero;
  };
  const d10 = (e15 = true, t11) => t11 < 1 ? L$.zero : u10(e15, 0, t11 - 1);
  const p10 = (e15, t11, n11, r11, o11) => {
    if (e15.hasOwnProperty("level")) {
      let a11 = false;
      a11 = n11 ? e15.start <= r11.minRow && e15.end >= r11.maxRow : e15.start <= r11.minCol && e15.end >= r11.maxCol;
      let i11 = n11 ? "ar-tablix-row-group" : "ar-tablix-col-group";
      a11 && (i11 += " highlighted");
      const s11 = { left: d10(false, n11 ? e15.level : e15.start).css, top: d10(true, n11 ? e15.start : e15.level).css };
      n11 ? s11.height = u10(true, e15.start, e15.end).css : s11.width = u10(false, e15.start, e15.end).css, t11.push(tp.createElement("div", { className: i11, style: s11, key: `t${n11 ? "row" : "column"}group${o11}` }));
    }
  };
  const m10 = { left: `-${h4e}`, top: `-${h4e}`, width: `calc(${n10.width.css} + ${h4e})`, height: `calc(${n10.height.css} + ${h4e})` };
  const h10 = { tableLayout: "fixed", width: `calc(${n10.width.css} + ${h4e})`, height: `calc(${n10.height.css} + ${h4e})` };
  n10.isResizeMove && (h10.opacity = 0.2);
  const f10 = [];
  const g10 = [];
  g10.push(tp.createElement(x4e, __spreadValues({ key: "thaC" }, c10(0, n10.columns.length, false, false, false, true)))), g10.push(tp.createElement("td", { key: "columnOffset", style: { width: f4e } }));
  for (let e15 = 0; e15 < n10.columns.length; e15++) {
    const t11 = rj(r10.$columns.collection[e15]);
    const o11 = sj(r10.$columns.collection[e15]);
    const a11 = __spreadProps(__spreadValues({ key: `thaC${e15}` }, c10(e15 + 1, n10.columns.length, t11, o11, true, false)), { dataType: "tablixcolumn", getElementPath: b4e });
    g10.push(tp.createElement(x4e, __spreadValues({}, a11)));
  }
  if (((e15) => {
    const { lockLayout: t11, rdlx: { reportItemsFeatures: { tablix: { canUseWizard: n11 } } } } = KO.of(e15);
    return !t11 && !!n11;
  })(a10)) {
    const e15 = ((e16) => !!qXe(e16) || !!wJe(e16))(r10);
    const n11 = { className: "ar-tablix-adorner ar-tablix-header-cell edit" + (e15 ? "" : " disabled"), title: e15 ? l10("tablixWizard:textOpenWizard", "Open Tablix Wizard...") : l10("tablixWizard:textCannotEditInWizard", "Tablix has complex structure and cannot be edited in Wizard. Please use Group Editor instead."), onClick: e15 ? () => {
      s10(_A.of(a10).open("tablixWizard", { path: t10, report: i10() }));
    } : void 0 };
    g10.push(tp.createElement("td", { key: "wizard-adorner-offset", style: { width: f4e } })), g10.push(tp.createElement("td", { key: "wizard-adorner-component" }, tp.createElement("div", __spreadValues({ "data-aid": "tablix-wizard-adorner" }, n11), tp.createElement(Fm, { icon: nf(ch), customCSS: "wd-svg" }))));
  }
  f10.push(tp.createElement("tr", { key: "thaR", style: { height: f4e } }));
  for (let e15 = 0; e15 < n10.rows.length; e15++) {
    const t11 = 0 === e15 ? tp.createElement("td", { rowSpan: n10.rows.length, colSpan: n10.columns.length }) : null;
    const o11 = rj(r10.$rows.collection[e15]);
    const a11 = sj(r10.$rows.collection[e15]);
    const i11 = __spreadProps(__spreadValues({}, c10(e15 + 1, n10.rows.length, o11, a11, false, false)), { dataType: "tablixrow", getElementPath: v4e });
    f10.push(tp.createElement("tr", { key: `thaR${e15}`, style: { height: n10.adornerCellHeights[e15] || n10.rows[e15] } }, tp.createElement(x4e, __spreadValues({}, i11)), t11));
  }
  const y10 = { minRow: 99999, maxRow: -1, minCol: 99999, maxCol: -1 };
  const v10 = n10.rows.map(() => n10.columns.map(() => ({ selected: false })));
  const b10 = [];
  {
    let e15 = 0;
    const t11 = function(e16, t12) {
      return function(n11) {
        return n11.RowIndex === e16 && n11.ColumnIndex === t12 && n11.Selected;
      };
    };
    for (let r11 = 0; r11 < n10.rows.length; r11++) for (let o11 = 0; o11 < n10.columns.length; o11++) {
      const a11 = n10.cells.filter(t11(r11, o11));
      const i11 = 1 === a11.length ? a11[0] : null;
      if (i11) {
        const t12 = i11.Primary;
        e15++;
        for (let e16 = 0; e16 < i11.RowSpan; e16++) for (let n11 = 0; n11 < i11.ColSpan; n11++) v10[r11 + e16][o11 + n11] = { selected: true, isPrimary: t12 }, r11 + e16 < y10.minRow && (y10.minRow = r11 + e16), r11 + e16 > y10.maxRow && (y10.maxRow = r11 + e16), o11 + n11 < y10.minCol && (y10.minCol = o11 + n11), o11 + n11 > y10.maxCol && (y10.maxCol = o11 + n11);
      } else v10[r11][o11].selected || (v10[r11][o11].selected = false);
    }
    if (e15 > 0) for (let e16 = 0; e16 < n10.rows.length; e16++) {
      const t12 = [];
      for (let r11 = 0; r11 < n10.columns.length; r11++) {
        const o11 = { width: n10.columns[r11].css, height: n10.rows[e16].css };
        const a11 = {};
        const i11 = `ar-tablix-selection-cell ${v10[e16][r11].selected ? "ar-tablix-selection-selected" : ""} ${v10[e16][r11].isPrimary ? "ar-tablix-selection-primary" : ""}`;
        v10[e16][r11].selected && (0 !== e16 && v10[e16 - 1][r11].selected || (a11.borderTopStyle = "solid"), e16 !== n10.rows.length - 1 && v10[e16 + 1][r11].selected || (a11.borderBottomStyle = "solid"), 0 !== r11 && v10[e16][r11 - 1].selected || (a11.borderLeftStyle = "solid"), r11 !== n10.columns.length - 1 && v10[e16][r11 + 1].selected || (a11.borderRightStyle = "solid")), t12.push(tp.createElement("td", { className: i11, key: `cell${r11}`, style: o11 }, tp.createElement("div", null, tp.createElement("div", { style: a11 }))));
      }
      b10.push(tp.createElement("tr", { key: `tacr${e16}`, style: { height: n10.rows[e16].css } }, t12));
    }
  }
  const S10 = { tableLayout: "fixed", left: h4e, top: h4e, width: n10.width.css, height: n10.height.css };
  const C10 = [];
  const x10 = [];
  for (let e15 = 0; e15 < n10.colGroups.length; e15++) p10(n10.colGroups[e15], C10, false, y10, e15);
  for (let e15 = 0; e15 < n10.rowGroups.length; e15++) p10(n10.rowGroups[e15], x10, true, y10, e15);
  const w10 = { "data-path": t10, "data-type": r10.Type, className: "pointer-grip ar-adorner-primary" };
  const T10 = { left: h4e, top: h4e, width: n10.width.css, height: n10.height.css };
  const E10 = !r10.Body.Rows.length && !r10.Body.Columns.length;
  const F10 = r10.RowHierarchy.LevelSizes.length > 0 && !E10;
  const M10 = r10.ColumnHierarchy.LevelSizes.length > 0 && !E10;
  const k10 = d10(false, r10.RowHierarchy.LevelSizes.length);
  const P10 = d10(true, r10.ColumnHierarchy.LevelSizes.length);
  const N10 = { left: `calc(${k10.css} - 2.5px)`, top: "0px", height: n10.height.css };
  const D10 = { left: "0px", top: `calc(${P10.css} - 2.5px)`, width: n10.width.css };
  const L10 = ((e15) => !(rj(e15) || !ij(e15)) && BQ(e15))(r10);
  return tp.createElement("div", { className: "ar-tablix-adorner", style: m10 }, L10 && tp.createElement("table", { className: "ar-tablix-adorner-table ar-adorner-secondary", style: h10, key: "tadorner" }, tp.createElement("tbody", null, tp.createElement("tr", null, g10), f10)), L10 && tp.createElement("div", { className: "ar-tablix-sections", style: T10, key: "tsections" }, F10 && tp.createElement("div", { className: "ar-tablix-section-v", style: N10 }), M10 && tp.createElement("div", { className: "ar-tablix-section-h", style: D10 })), L10 && tp.createElement("div", { className: "ar-tablix-groups", style: S10, key: "tgroups" }, C10, x10), b10.length > 0 && tp.createElement("table", { className: "ar-tablix-selection", style: S10, key: "tselection" }, tp.createElement("colgroup", null, n10.columns.map((e15, t11) => tp.createElement("col", { key: `col-${t11}`, span: 1, style: { width: e15.css } }))), tp.createElement("tbody", null, b10)), tp.createElement("div", __spreadValues({}, w10)));
}));
const T4e = ({ item: e14 }, t10 = [], n10 = []) => {
  const r10 = { hierarchyName: null, bodyIndices: [] };
  const o10 = (t11, n11, a11, i11, s11, l11, c11, u11, d10 = false) => {
    let p10 = i11;
    let m10;
    t11.Group && (m10 = { level: a11, depth: p10 }, p10++);
    const h10 = t11.Children && t11.Children.length || 0;
    const f10 = !t11.Header;
    const g10 = rj(t11) || !f10 && rj(t11.Header.Item) || d10;
    const y10 = t11.Header && t11.Header.LevelCount || 1;
    let v10 = h10 > 0 ? 0 : 1;
    if (h10) for (let e15 = 0; e15 < h10; e15++) {
      const r11 = Gj(u11, e15);
      v10 += o10(t11.Children[e15], n11 + v10, a11 + (t11.Header ? y10 : 0), p10, s11, l11, c11, r11, f10 && g10);
    }
    else if (f10 && g10) {
      const e15 = u11.split(".");
      const n12 = e15.length > 0 && e15[0] || "";
      r10.hierarchyName || (r10.hierarchyName = n12), r10.bodyIndices.push(t11.BodyIndex);
    }
    if (m10 && (m10.start = n11, m10.end = n11 + v10 - 1, l11.push(m10)), f10) return v10;
    const b10 = rj(e14.$rows.collection[s11 ? n11 : a11]) || rj(e14.$columns.collection[s11 ? a11 : n11]);
    const S10 = sj(e14.$rows.collection[s11 ? n11 : a11]) || sj(e14.$columns.collection[s11 ? a11 : n11]);
    const C10 = s11 ? { ColumnIndex: a11, RowIndex: n11, ColSpan: y10, RowSpan: v10 } : { ColumnIndex: n11, RowIndex: a11, ColSpan: v10, RowSpan: y10 };
    return c11.push(__spreadProps(__spreadValues({}, C10), { Content: t11.Header.Item, ContentPath: Uj(u11), Selected: g10 || b10, Primary: sj(t11) || sj(t11.Header.Item) || d10 || S10 })), v10;
  };
  const [a10, i10] = [HQ(e14), IQ(e14)];
  const s10 = { original: e14, tablix: __spreadValues({}, e14), columns: a10, rows: i10, cells: [], colGroups: [], rowGroups: [], width: L$.sum(a10), height: L$.sum(i10), adornerCellWidths: t10, adornerCellHeights: n10, rowAdornerStates: [], colAdornerStates: [] };
  if (s10.rowAdornerStates = [false].concat(s10.rows.map(() => false)), s10.colAdornerStates = [false].concat(s10.columns.map(() => false)), e14.Corner) for (let t11 = 0; t11 < e14.Corner.length; t11++) {
    const n11 = e14.Corner[t11];
    const r11 = rj(e14.$rows.collection[t11]);
    const o11 = sj(e14.$rows.collection[t11]);
    for (let a11 = 0; a11 < n11.length; a11++) {
      const i11 = n11[a11];
      const l11 = r11 || rj(e14.$columns.collection[a11]);
      const c11 = o11 || sj(e14.$columns.collection[a11]);
      i11 && i11.Item && s10.cells.push({ ColumnIndex: a11, RowIndex: t11, ColSpan: i11.ColSpan && i11.ColSpan || 1, RowSpan: i11.RowSpan && i11.RowSpan || 1, Content: i11.Item, ContentPath: qj(t11, a11), Selected: rj(i11.Item) || l11, Primary: sj(i11.Item) || c11 });
    }
  }
  let l10 = s10.columns.length - e14.Body.Columns.length;
  for (let t11 = 0; t11 < e14.ColumnHierarchy.Members.length; t11++) {
    const n11 = e14.ColumnHierarchy.Members[t11];
    l10 += o10(n11, l10, 0, 0, false, s10.colGroups, s10.cells, Zj("ColumnHierarchy", t11));
  }
  let c10 = s10.rows.length - e14.Body.Rows.length;
  for (let t11 = 0; t11 < e14.RowHierarchy.Members.length; t11++) {
    const n11 = e14.RowHierarchy.Members[t11];
    c10 += o10(n11, c10, 0, 0, true, s10.rowGroups, s10.cells, Zj("RowHierarchy", t11));
  }
  const u10 = (e15, t11) => {
    if (r10) switch (r10.hierarchyName) {
      case "ColumnHierarchy":
        return 0 === e15 && r10.bodyIndices.indexOf(t11) >= 0;
      case "RowHierarchy":
        return r10.bodyIndices.indexOf(e15) >= 0 && 0 === t11;
    }
    return false;
  };
  for (let t11 = 0; t11 < e14.Body.Rows.length; t11++) {
    const n11 = e14.Body.Rows[t11];
    let r11 = 0;
    const o11 = rj(e14.$rows.collection[t11 + s10.rows.length - e14.Body.Rows.length]);
    const a11 = sj(e14.$rows.collection[t11 + s10.rows.length - e14.Body.Rows.length]);
    for (let i11 = 0; i11 < n11.Cells.length; i11++) {
      const l11 = n11.Cells[i11];
      if (!l11 || !l11.Item) continue;
      const c11 = o11 || rj(e14.$columns.collection[r11 + s10.columns.length - e14.Body.Columns.length]);
      const d10 = a11 || sj(e14.$columns.collection[r11 + s10.columns.length - e14.Body.Columns.length]);
      const p10 = u10(t11, i11);
      s10.cells.push({ ColumnIndex: r11 + s10.columns.length - e14.Body.Columns.length, RowIndex: t11 + s10.rows.length - e14.Body.Rows.length, ColSpan: l11.ColSpan && l11.ColSpan || 1, RowSpan: 1, Content: l11.Item, ContentPath: Yj(t11, i11), Selected: rj(l11.Item) || c11 || p10, Primary: sj(l11.Item) || d10 || p10 }), r11 += l11.ColSpan;
    }
  }
  return s10;
};
const E4e = (e14) => {
  const { rows: t10, columns: n10, cells: r10, name: o10, children: a10, hasSelection: i10 } = e14;
  const { instanceId: s10, setDecorations: l10 } = ep.useContext(bqe);
  const { userPreferences: { surface: { zoomFactor: c10 } } } = KO.of(s10);
  const u10 = ep.useRef(null);
  const d10 = PA();
  const [, p10, m10] = Yne({ item: { type: "tablixselect", name: o10 }, canDrag: (e15) => i10, end: (e15, t11) => {
    const n11 = t11.getDropResult();
    if (n11) {
      const { ctrlPressed: e16, selItemNames: t12 } = n11;
      t12 && t12.length > 0 && d10((e16 ? m5 : h5)(t12));
    }
  }, collect: (e15) => ({ isDragging: e15.isDragging() }) });
  ep.useEffect(() => {
    m10(Coe(), { captureDraggingState: true });
  }, []);
  const [h10, f10] = are({ accept: ["tablixselect"], drop: (e15, o11) => {
    const a11 = function(e16, t11, n11, r11) {
      const { firstColumn: o12, lastColumn: a12, firstRow: i11, lastRow: s11 } = c4e(e16, t11, n11, r11);
      const l11 = [];
      return n11.forEach((e17) => {
        (o12 <= e17.ColumnIndex && e17.ColumnIndex <= a12 || e17.ColumnIndex < o12 && o12 < e17.ColumnIndex + e17.ColSpan) && (i11 <= e17.RowIndex && e17.RowIndex <= s11 || e17.RowIndex < i11 && i11 < e17.RowIndex + e17.RowSpan) && l11.push(e17);
      }), l11.sort((e17, t12) => e17.RowIndex < t12.RowIndex ? -1 : e17.RowIndex > t12.RowIndex ? 1 : e17.ColumnIndex < t12.ColumnIndex ? -1 : e17.ColumnIndex > t12.ColumnIndex ? 1 : 0).map((e17) => {
        var _a2;
        return (_a2 = e17.Content) == null ? void 0 : _a2.Name;
      });
    }(t10, n10, r10, u4e(o11, c10));
    return { ctrlPressed: k0e.ctrlPressed, selItemNames: a11 };
  }, hover: (e15, o11) => {
    if (o11.isOver() && o11.canDrop()) {
      const e16 = u4e(o11, c10);
      d4e(e16, t10, n10, r10, u10.current, l10);
    }
  }, canDrop: (e15, t11) => t11.getItem().name === o10 });
  return p10(tp.createElement("div", { ref: f10 }, tp.createElement("div", { ref: u10 }, a10)));
};
const F4e = (e14) => {
  const t10 = [];
  for (let n10 = 0; n10 < e14.length; n10 += 1) t10.push(`${e14[n10].getBoundingClientRect().height}px`);
  return t10;
};
const M4e = (e14, t10) => {
  const n10 = [];
  for (let r10 = 0; r10 < e14.length; r10 += 1) {
    const o10 = Number(e14[r10].getAttribute("colspan"));
    if (1 === o10) n10.push(`${e14[r10].getBoundingClientRect().width}px`);
    else {
      const { width: a10 } = e14[r10].getBoundingClientRect();
      let i10 = t10.slice(r10, r10 + o10).map((e15) => Math.floor(L$.toPixels(e15)));
      const s10 = a10 - i10.reduce((e15, t11) => e15 + t11, 0);
      s10 >= o10 && (i10 = i10.map((e15) => e15 + Math.floor(s10 / o10)));
      const l10 = s10 % o10;
      for (let e15 = 0; e15 < o10; e15++) n10.push(`${i10[e15] + (l10 > e15 ? 1 : 0)}px`);
    }
  }
  return n10;
};
var k4e = TA()((e14) => {
  const { item: t10, item: { Type: n10, Style: r10, Name: o10 }, path: a10, dataSets: i10, parentBackgroundColor: s10, theme: l10, onlyContent: c10 } = e14;
  const [u10, d10] = ep.useState(T4e(e14));
  const { width: p10, height: m10, rows: h10, columns: f10, cells: g10, adornerCellWidths: y10, adornerCellHeights: v10 } = u10;
  const { getItemLayerInfo: b10, instanceId: S10 } = ep.useContext(bqe);
  const { isVisible: C10, isLocked: x10 } = b10(t10);
  const { lockLayout: w10 } = KO.of(S10);
  const T10 = PA();
  const E10 = ep.useRef(null);
  ep.useEffect(() => {
    d10(T4e(e14, u10.adornerCellWidths, u10.adornerCellHeights));
  }, [e14]), ep.useEffect(() => {
    F10();
  });
  const F10 = () => {
    if (!E10.current || !(() => {
      if (null === XAe) {
        const e16 = document.documentElement.appendChild(document.createElement("TABLE"));
        e16.style.width = "1cm";
        const { width: t12 } = e16.getBoundingClientRect();
        XAe = t12 === Math.round(t12), e16.parentNode && e16.parentNode.removeChild(e16);
      }
      return XAe;
    })()) return;
    const { widths: e15, heights: t11 } = ((e16, t12) => {
      const n11 = e16.current.children;
      return { widths: M4e(n11[0].children, t12), heights: F4e(n11) };
    })(E10, f10);
    y10.join() === e15.join() && v10.join() === t11.join() || d10(AV(u10, { adornerCellWidths: { $set: e15 }, adornerCellHeights: { $set: t11 } }));
  };
  const M10 = (e15 = true, t11, n11) => {
    if (n11 >= t11) {
      const r11 = e15 ? h10 : f10;
      let o11 = L$.zero;
      for (let e16 = t11; e16 <= n11; e16++) o11 = o11.add(r11[e16]);
      return o11.css;
    }
    return "";
  };
  const k10 = (e15, n11, r11) => {
    if (e15.shiftKey) {
      let [o11, a11] = [null, null];
      if (_Q(t10, (e16) => {
        sj(e16.item) && (o11 = e16), e16.rix === n11 && e16.cix === r11 && (a11 = e16);
      }), !o11 || !a11 || o11 === a11) return;
      const [i11, s11, l11, c11] = [Math.min(o11.rix, a11.rix), Math.min(o11.cix, a11.cix), Math.max(o11.rix + o11.rspan, a11.rix + a11.rspan), Math.max(o11.cix + o11.cspan, a11.cix + a11.cspan)];
      const u11 = [o11.item.Name];
      _Q(t10, (e16) => {
        if (e16.item.Name === o11.item.Name) return;
        (s11 <= e16.cix && e16.cix < c11 || e16.cix < s11 && s11 < e16.cix + e16.cspan) && (i11 <= e16.rix && e16.rix < l11 || e16.rix < i11 && i11 < e16.rix + e16.rspan) && u11.push(e16.item.Name);
      }), T10(h5(u11)), e15.stopPropagation();
    }
  };
  const P10 = r10 || {};
  const N10 = Bme(P10.BackgroundColor, s10, l10);
  const D10 = { tableLayout: "fixed", position: "absolute", borderCollapse: "collapse", width: p10.css, height: m10.css, color: P10.Color || "black", border: "none", pointerEvents: C10 ? "all" : "none" };
  rj(t10) && (D10.backgroundColor = N10);
  const L10 = (e15, t11) => {
    const n11 = __spreadProps(__spreadValues({ host: o10, key: t11 }, e15), { CellWidth: M10(false, e15.ColumnIndex, e15.ColumnIndex + e15.ColSpan - 1), CellHeight: M10(true, e15.RowIndex, e15.RowIndex + e15.RowSpan - 1), path: $j(a10, e15.ContentPath), parentBackgroundColor: N10, onClick: k10, dataSets: i10, dispatch: T10, theme: l10, rowIdx: e15.RowIndex, colIdx: e15.ColumnIndex, onlyContent: c10 });
    return tp.createElement(s4e, __spreadValues({}, n11));
  };
  const H10 = tp.createElement("table", { "data-path": a10, "data-type": n10, className: "ar-item ar-tablix", style: D10 }, tp.createElement("colgroup", null, f10.map((e15, t11) => tp.createElement("col", { key: `col-${t11}`, span: 1, style: { width: e15.css } }))), tp.createElement("tbody", { ref: E10 }, h10.map((e15, t11) => {
    const n11 = g10.filter((e16) => e16.RowIndex === t11).sort((e16, t12) => e16.ColumnIndex - t12.ColumnIndex);
    const r11 = { height: h10[t11].css };
    return tp.createElement("tr", { key: t11, style: r11 }, n11.map(L10));
  })));
  const I10 = { item: u10.tablix, viewModel: u10, path: a10, dndEnabled: !x10 && !w10 };
  const _10 = aj(t10) && function(e15, t11 = false) {
    return !!OQ(e15, t11);
  }(t10);
  return tp.createElement("div", null, _10 && tp.createElement(w4e, __spreadValues({}, I10)), tp.createElement(E4e, { hasSelection: _10, name: o10, rows: h10, columns: f10, cells: g10 }, H10));
});
const P4e = (e14) => `tablix.${e14}`;
const N4e = [FY.NoRowsMessage, vY.FontSimple, vY.Color, vY.Font, vY.TextDecoration, vY.TextAlign, vY.VerticalAlign, vY.Format].map((e14) => __spreadProps(__spreadValues({}, e14), { category: `propertyDescriptors:categories.${pY}` }));
const D4e = [EY.Name, FY.DataSetName, FY.DataSetParameters, EY.DataElementName, EY.DataElementOutput_AON, FY.SortExpressions, FY.Filters, vY.BackgroundAndBorders, vY.BackgroundColor, vY.BackgroundImage, vY.Borders, EY.Location, EY.Size, Zq(cY, "reportItem.style", "styles", "ReportStyle", void 0, { target: "Tablix" }), vY.Padding, EY.LayerName, FY.PageBreak, FY.NewPage, Zq(cY, P4e("layoutDirection"), "enum", "LayoutDirection", "advanced", { enumKey: "layout_direction" }), Zq(cY, P4e("groupsBeforeRowHeaders"), "number", "GroupsBeforeRowHeaders", "advanced", Gq.integerPositive), Zq(cY, P4e("frozenRows"), "number", "FrozenRows", void 0, Gq.integerPositive), Zq(cY, P4e("frozenColumns"), "number", "FrozenColumns", void 0, Gq.integerPositive), Zq(cY, P4e("repeatRowHeaders"), "boolean", "RepeatRowHeaders"), Zq(cY, P4e("repeatColumnHeaders"), "boolean", "RepeatColumnHeaders"), FY.NewSection, EY.KeepTogether, EY.ZIndex, ...N4e, EY.Visibility, vY.Calendar, vY.Direction, vY.Language, vY.NumeralLanguage, vY.NumeralVariant, vY.UnicodeBiDi, vY.UprightInVerticalText, vY.WritingMode, EY.PageName, EY.ToolTip, EY.Label, EY.Bookmark];
const L4e = (e14) => "FrozenRows" !== e14.valuePath && "FrozenColumns" !== e14.valuePath;
const H4e = (e14) => "PageBreak" !== e14.valuePath;
const I4e = { type: "tablix", labelKey: "reportItems:tablix", nameTemplateKey: "nameTemplates:tablix", init: (e14, t10, n10, r10 = Bq) => zQ(__spreadProps(__spreadValues(__spreadProps(__spreadValues({}, r10), { ColumnHierarchy: __spreadProps(__spreadValues({}, r10.ColumnHierarchy), { Members: r10.ColumnHierarchy.Members.map((t11) => __spreadProps(__spreadValues({}, t11), { Group: t11.Group ? __spreadProps(__spreadValues({}, t11.Group), { Name: MG(e14, TG("columnGroup")) }) : null })) }), RowHierarchy: __spreadProps(__spreadValues({}, r10.RowHierarchy), { Members: r10.RowHierarchy.Members.map((t11) => __spreadProps(__spreadValues({}, t11), { Group: t11.Group ? __spreadProps(__spreadValues({}, t11.Group), { Name: MG(e14, TG("rowGroup")) }) : null })) }) }), n10), { Name: e14 })), icon: nf(Eae), icon24: nf(Fae), defaultModel: Bq, glyph: k4e, getReducer: a4e, getProperties: (e14, t10, n10) => {
  var _a2, _b2, _c2, _d2;
  const r10 = (_d2 = (_c2 = (_b2 = (_a2 = n10 == null ? void 0 : n10.settings) == null ? void 0 : _a2.rdlx) == null ? void 0 : _b2.reportItemsFeatures) == null ? void 0 : _c2.tablix) == null ? void 0 : _d2.hideFrozenRowsColumns;
  const o10 = [];
  r10 && o10.push(L4e), (n10 == null ? void 0 : n10.isDashboard) && o10.push(H4e);
  const a10 = ((e15, t11, n11) => (n11 == null ? void 0 : n11.isDashboard) ? n4(D4e) : D4e)(0, 0, n10);
  const i10 = o10.length > 0 ? a10.filter((e15) => o10.every((t11) => t11(e15))) : a10;
  return i10;
}, getContextActions: function(e14, t10, n10) {
  if (KO.of(t10).lockLayout) return [];
  const r10 = i0e(e14, t10, n10);
  if (rj(e14)) return r10;
  if (!ij(e14)) return [];
  if (!BQ(e14)) return [];
  const o10 = [];
  const a10 = bj(e14);
  const i10 = a10 && ("dynamictablixmember" === a10.Type || "statictablixmember" === a10.Type);
  const s10 = a10 && "tablixrow" === a10.Type;
  const l10 = a10 && "tablixcolumn" === a10.Type;
  let c10;
  if (i10) v0e(e14).forEach((e15) => M0e(e15, o10)), C0e(e14).forEach((e15) => M0e(e15, o10));
  else if (s10) c10 = T0e(e14);
  else if (l10) c10 = E0e(e14);
  else {
    c10 = function(e15) {
      return BQ(e15) ? u0e(nf(t1e), "contextActions:container.delete", false, JG()) : null;
    }(e14);
    const n11 = ((e15, t11) => {
      const n12 = yj(e15);
      if (1 !== n12.length || !sj(n12[0])) return null;
      const r11 = n12[0];
      const o11 = r11.Type;
      if (!_1e[o11]) return null;
      const { getPropertyDescriptor: a11, defaultValue: i11 } = _1e[o11];
      const s11 = { descriptor: a11(), objectValues: [r11], defaultValues: [i11] };
      const l11 = _A.of(t11).open("connectedExpressionEditor", s11);
      return l0e(nf(q1e), "expression", false, l11);
    })(e14, t10);
    null !== n11 && o10.push(n11), function(e15) {
      const t11 = [l0e(m0e.MergeCells, "mergeCells", !h0e(e15), wZ()), l0e(m0e.SplitCells, "splitCells", !f0e(e15), TZ())];
      return [d0e(m0e.Cells, "cellsTitle", !F0e(t11), t11)];
    }(e14).forEach((e15) => M0e(e15, o10)), function(e15) {
      const t11 = [];
      if (!BQ(e15)) return null;
      const n12 = g0e(dZ.COLUMN, e15) || [];
      const r11 = [];
      n12.length && (r11.push(p0e("insertColumnTitle")), r11.push(...n12), r11.push(p0e())), r11.push(l0e(m0e.DeleteColumn, "delete", !y0e(e15, dZ.COLUMN), bZ())), t11.push(d0e(m0e.Columns, "columnTitle", !F0e(r11), r11));
      const o11 = g0e(dZ.ROW, e15) || [];
      const a11 = [];
      return o11.length && (a11.push(p0e("insertRowTitle")), a11.push(...o11), a11.push(p0e())), a11.push(l0e(m0e.DeleteRow, "delete", !y0e(e15, dZ.ROW), yZ())), t11.push(d0e(m0e.Rows, "rowTitle", !F0e(a11), a11)), t11;
    }(e14).forEach((e15) => M0e(e15, o10)), v0e(e14).forEach((e15) => M0e(e15, o10)), C0e(e14).forEach((e15) => M0e(e15, o10));
  }
  return [...o10.length ? [(u10 = null, d10 = TG(e14.Type), p10 = o10, { type: "group", icon: u10, key: d10, actions: p10 })] : [], ...r10, ...c10 ? [c10] : []];
  var u10, d10, p10;
}, features: { borderStyles: ["None", "Dotted", "Dashed", "Solid", "Double", "DashDot", "DashDotDot"], isDataRegion: true } };
const _4e = { RepeatToFill: false, $fixedPlace: { Width: "2in", Height: "0.5in", OverflowName: "" } };
const V4e = __spreadValues(__spreadProps(__spreadValues({}, I4e.defaultModel), { Type: "fixedpagetablix" }), _4e);
const R4e = (e14, t10) => {
  const { field: { expr: n10 }, displayAs: r10 } = e14;
  return t10 && iJe(r10) ? ((e15, t11) => {
    const { field: { expr: n11, name: r11 }, aggregate: o10 } = e15;
    const { columnGroupScope: a10, rowGroupScope: i10 } = t11;
    if (!a10 && !i10) return n11;
    let s10 = null;
    !a10 && i10 ? s10 = i10 : (a10 && !i10 || a10 === i10) && (s10 = a10);
    const l10 = n11.startsWith("=") ? n11.slice(1) : n11;
    const c10 = l10 === G1(r11, null, o10);
    const u10 = o10 != null ? o10 : "Count";
    const d10 = c10 ? G1(r11, null, u10) : B1(l10, u10);
    let p10;
    p10 = s10 ? c10 ? G1(r11, s10, u10) : B1(l10, u10, s10) : `CrossAggregate(${[c10 ? G1(r11) : l10, `"${u10}"`, `"${a10}"`, `"${i10}"`].join(", ")})`;
    return `=${d10} / ${p10}`;
  })(e14, t10) : n10;
};
const A4e = (e14, t10) => ({ path: e14, value: t10 });
const O4e = (e14) => (t10, n10) => A4e(t10 ? `${e14}.${t10}` : e14, n10);
const B4e = (e14) => {
  var _a2;
  const t10 = (_a2 = e14.split(".").map((e15) => e15.trim()).reverse().find((e15) => !!e15)) != null ? _a2 : "";
  return q1(t10);
};
const z4e = (e14, t10) => {
  const { name: n10, field: r10, sorting: o10 } = t10;
  const a10 = [e14("Group.Name", n10), e14("Group.GroupExpressions.0", r10.expr)];
  if (o10) {
    const { value: t11, direction: n11 } = o10;
    a10.push(e14("SortExpressions.0", { Value: t11, Direction: n11 }));
  }
  return a10;
};
const $4e = (e14, t10) => {
  const { itemName: n10, itemValue: r10, fieldName: o10, format: a10 } = t10;
  const i10 = [];
  return n10 && i10.push(e14("Name", n10)), i10.push(e14("Value", r10)), o10 && i10.push(e14("DataElementName", o10)), i10.push(e14("Style.Format", a10)), i10;
};
const W4e = (e14, t10) => {
  const { itemName: n10, itemValue: r10, field: { name: o10 }, format: a10 } = t10;
  return $4e(e14, { itemName: n10, itemValue: r10, fieldName: o10, format: a10 });
};
const j4e = (e14, t10, n10) => {
  const { field: r10, aggregate: o10, displayAs: a10, format: i10 } = t10;
  const s10 = R4e({ field: r10, aggregate: o10, displayAs: a10 }, n10);
  return $4e(e14, { itemValue: s10, format: i10 });
};
const Z4e = (e14, t10, n10) => {
  const { scope: r10, target: o10 } = n10;
  return [e14("UserSort.SortExpression", t10), e14("UserSort.SortExpressionScope", r10), e14("UserSort.SortTarget", o10)];
};
const G4e = (e14, t10) => {
  const { collapsed: n10 } = t10;
  return [e14("ToggleImage.InitialState", n10 ? "False" : "True")];
};
const U4e = (e14, t10) => {
  const { toggleItem: n10, collapsed: r10 } = t10;
  return [e14("Visibility.ToggleItem", n10), e14("Visibility.Hidden", r10 ? "True" : "False")];
};
const q4e = (e14, t10, n10) => {
  const { name: r10, columnGroups: o10, rowGroups: a10 } = e14;
  const i10 = (e15, t11) => {
    var _a2, _b2, _c2, _d2;
    return { columnGroupScope: (_b2 = (_a2 = o10[e15]) == null ? void 0 : _a2.name) != null ? _b2 : r10, rowGroupScope: (_d2 = (_c2 = a10[t11]) == null ? void 0 : _c2.name) != null ? _d2 : r10 };
  };
  const { displayAs: s10 } = t10;
  switch (s10) {
    case "PercentGrandTotal":
      return i10(-1, -1);
    case "PercentRowGroupTotal": {
      if (!n10) return i10(-1, a10.length - 1);
      const { rowGroupIndex: e15 } = n10;
      return i10(-1, e15);
    }
    case "PercentParentRowGroupTotal": {
      if (!n10) return i10(o10.length - 1, a10.length - 2);
      const { columnGroupIndex: e15, rowGroupIndex: t11 } = n10;
      return i10(e15, t11 - 1);
    }
    case "PercentColumnGroupTotal": {
      if (!n10) return i10(o10.length - 1, -1);
      const { columnGroupIndex: e15 } = n10;
      return i10(e15, -1);
    }
    case "PercentParentColumnGroupTotal": {
      if (!n10) return i10(o10.length - 2, a10.length - 1);
      const { columnGroupIndex: e15, rowGroupIndex: t11 } = n10;
      return i10(e15 - 1, t11);
    }
    default:
      return null;
  }
};
function Y4e(e14) {
  var _a2, _b2;
  if (!e14.$fixedPlace) return e14;
  const t10 = {};
  const n10 = e14.$width || ((_a2 = e14.$place) == null ? void 0 : _a2.Width);
  e14.$fixedPlace.Width && e14.$fixedPlace.Width !== n10 && (t10.Width = { $set: n10 });
  const r10 = e14.$height || ((_b2 = e14.$place) == null ? void 0 : _b2.Height);
  return e14.$fixedPlace.Height && e14.$fixedPlace.Height !== r10 && (t10.Height = { $set: r10 }), zV.isEmpty(t10) ? e14 : AV(e14, { $fixedPlace: t10 });
}
function K4e(e14) {
  return RQ(e14, ({ item: e15 }) => Y4e(e15));
}
function X4e(e14) {
  return (t10, n10) => {
    const { type: r10 } = n10;
    switch (r10) {
      case jG:
      case UG: {
        const r11 = n10.payload.items.map(Y4e);
        const o10 = AV(n10, { payload: { items: { $set: r11 } } });
        return K4e(I4e.getReducer(e14)(t10, o10));
      }
      case GG: {
        const { item: r11 } = n10.payload;
        const o10 = AV(n10, { payload: { item: { $set: Y4e(r11) } } });
        return K4e(I4e.getReducer(e14)(t10, o10));
      }
      default:
        return K4e(I4e.getReducer(e14)(t10, n10));
    }
  };
}
const J4e = (e14, t10, n10 = false) => (n10 ? l5 : c5)(e14, t10);
const Q4e = (e14) => __spreadProps(__spreadValues({}, e14), { payload: {} });
const e3e = "@tw/MERGE_VALUES";
const t3e = "@tw/SET_VALUES";
const n3e = { mergeValue: (e14, t10) => Kz.action(e3e, { pairs: [A4e(e14, t10)] }), mergeValues: (e14) => Kz.action(e3e, { pairs: e14 }), setValue: (e14, t10) => Kz.action(t3e, { pairs: [A4e(e14, t10)] }), setValues: (e14) => Kz.action(t3e, { pairs: e14 }) };
const r3e = { selectTablix: () => Q4e(u5()), selectDynamic: (e14) => J4e(e14, "dynamictablixmember"), selectStatic: (e14) => J4e(e14, "statictablixmember"), selectTextBox: (e14, t10 = false) => J4e(e14, "textbox", t10), selectTextBoxes: (e14) => ((e15, t10) => {
  if (!(e15 == null ? void 0 : e15.length)) throw new Error("Multi-selection must include one or more items!");
  return p5(e15.map((e16) => ({ path: e16, type: t10 })));
})(e14, "textbox"), selectColumn: (e14) => J4e(`$columns.collection.${e14}`, "tablixcolumn"), selectRow: (e14) => J4e(`$rows.collection.${e14}`, "tablixrow") };
const o3e = { setStyle: (e14) => {
  var _a2, _b2;
  return v2({ id: (_a2 = e14 == null ? void 0 : e14.id) != null ? _a2 : null, name: (_b2 = e14 == null ? void 0 : e14.name) != null ? _b2 : null });
}, applyStyle: (e14) => b2({ style: e14 }) };
const a3e = __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, n3e), r3e), { toggleDynamicStatic: () => EZ(), addParentColumnGroup: () => fZ(uZ.COLUMN, pZ.PARENT), addChildColumnGroup: () => fZ(uZ.COLUMN, pZ.CHILD), addParentRowGroup: () => fZ(uZ.ROW, pZ.PARENT), addChildRowGroup: () => fZ(uZ.ROW, pZ.CHILD) }), { addColumnBefore: (e14 = 1) => vZ(mZ.Before, e14), addColumnAfter: (e14 = 1) => vZ(mZ.After, e14), addColumnInsideGroupAfter: (e14 = 1) => vZ(mZ.InsideAfter, e14), deleteColumn: () => Q4e(bZ()) }), { addRowAbove: (e14 = 1) => gZ(mZ.Before, e14), addRowBelow: (e14 = 1) => gZ(mZ.After, e14), deleteRow: () => Q4e(yZ()) }), { addTotalBefore: () => xZ(pZ.BEFORE), addTotalAfter: () => xZ(pZ.AFTER) }), { mergeCells: () => Q4e(wZ()), splitCells: () => Q4e(TZ()) }), o3e);
const i3e = (e14, t10, n10) => {
  if (!e14) throw new Error("Tablix must have a valid state!");
  if (!t10) return e14;
  switch (t10.type) {
    case t3e:
    case e3e: {
      const { pairs: n11 } = t10.payload;
      return ((e15, t11, n12 = false) => {
        if (!t11.length) return e15;
        const r10 = t11.reduce((e16, t12) => {
          const { path: r11, value: o10 } = t12;
          const a10 = n12 ? { $apply: (e17) => zV.merge({}, e17, o10) } : { $set: o10 };
          return j0(e16, r11, a10);
        }, {});
        return AV(e15, r10);
      })(e14, n11, t10.type === e3e);
    }
    default:
      return V5("fixedpagetablix" === e14.Type ? X4e(n10)(e14, t10) : a4e(n10)(e14, t10), t10);
  }
};
const s3e = (e14, t10, n10) => {
  if (!e14) throw new Error("Tablix must have a valid state!");
  return (t10 || []).reduce((e15, t11) => i3e(e15, t11, n10), e14);
};
const l3e = (e14, t10, n10, r10) => {
  let o10 = s3e(e14, [a3e.selectTablix(), a3e.setStyle(t10), a3e.applyStyle(n10)], r10);
  return n10 && (o10 = AV(o10, { $style: { $set: n10 } })), o10;
};
const c3e = (e14) => `ColumnHierarchy.Members.${e14}.Header.Item`;
const u3e = (e14) => `RowHierarchy.Members.${e14}.Header.Item`;
const d3e = (e14) => `Body.Rows.${e14}.Cells.0.Item`;
const p3e = (e14) => `Body.Rows.0.Cells.${e14}.Item`;
const m3e = (e14, t10, n10, r10) => {
  var _a2, _b2;
  const { layoutOptions: { features: { enableUserSort: o10, showValuesAsRows: a10 } }, values: i10 } = e14;
  const s10 = (_a2 = n10 == null ? void 0 : n10.noValuesHeaders) != null ? _a2 : false;
  const l10 = (_b2 = n10 == null ? void 0 : n10.userSort) != null ? _b2 : null;
  const c10 = ((e15, t11, n11) => {
    const { name: r11, isFpl: o11, $summary: a11 } = t11;
    const i11 = o11 ? V4e : Bq;
    const s11 = nz.of(e15).getTemplate("tablix", n11);
    const { cellHeight: l11, cellWidth: c11 } = zq(n11);
    const u11 = L$.parse(c11).multiply(2).css;
    const d11 = L$.parse(l11).multiply(2).css;
    let p11 = __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, i11), { $templateId: n11, $place: __spreadProps(__spreadValues({}, s11.$place), { Width: u11, Height: d11 }) }), o11 ? { $fixedPlace: __spreadProps(__spreadValues({}, V4e.$fixedPlace), { Width: u11, Height: d11 }) } : {}), { Name: r11, Style: s11.Style, $columns: { collection: [1, 2].map(() => E5e(c11)) }, $rows: { collection: [1, 2].map(() => T5e(l11)) }, Corner: [[{ Item: Wq(n11), ColSpan: 1, RowSpan: 1 }]], ColumnHierarchy: { LevelSizes: [l11], Members: [zJ(null, { Item: Wq(n11), LevelCount: 1 }, [], 1, 0)] }, RowHierarchy: { LevelSizes: [c11], Members: [zJ(null, { Item: Wq(n11), LevelCount: 1 }, [], 1, 0)] }, Body: { Columns: [c11], Rows: [{ Height: l11, Cells: [jq(n11)] }] } });
    if (a11) {
      const { tablixProps: e16 } = a11;
      e16 && (p11 = zV.merge({}, p11, e16));
    }
    return p11;
  })(t10, e14, r10);
  const { selectTextBox: u10, addColumnAfter: d10, deleteColumn: p10, selectColumn: m10, addRowBelow: h10, deleteRow: f10, selectRow: g10, mergeValues: y10, setValues: v10 } = a3e;
  const [b10, S10, C10, x10, w10] = a10 ? [g10, f10, h10, u3e, d3e] : [m10, p10, d10, c3e, p3e];
  const T10 = [b10(0), S10()];
  if (s10) {
    const e15 = a10 ? [m10(0), p10()] : [g10(0), f10()];
    T10.push(...e15);
  }
  i10.length > 1 && T10.push(u10("Body.Rows.0.Cells.0.Item"), C10(i10.length - 1));
  const E10 = [];
  const F10 = i10.reduce((t11, n11, r11) => {
    const [a11, i11] = [w10(r11), x10(r11)];
    const [c11, u11] = [a11, i11].map((e15) => O4e(e15));
    const { field: d11, $summary: p11 } = n11;
    if (p11) {
      const { itemProps: e15 } = p11;
      e15 && E10.push(c11("", e15));
    }
    const m11 = ((e15, t12, n12) => {
      const { itemName: r12, field: o11, aggregate: a12, displayAs: i12, format: s11 } = t12;
      const l11 = R4e({ field: o11, aggregate: a12, displayAs: i12 }, n12);
      return $4e(e15, { itemName: r12, itemValue: l11, fieldName: o11.name, format: s11 });
    })(c11, n11, q4e(e14, n11));
    return s10 || (m11.push(u11("Value", ((e15, t12) => {
      const n12 = B4e(e15);
      return iJe(t12) ? `${n12}, %` : n12;
    })(d11.name, n11.displayAs))), o10 && l10 && m11.push(...Z4e(u11, d11.expr, l10))), [...t11, ...m11];
  }, []);
  T10.push(y10(E10)), T10.push(v10(F10));
  return s3e(c10, T10, t10);
};
const h3e = (e14, t10) => `Body.Rows.${e14}.Cells.${t10}.Item`;
const f3e = (e14) => {
  if (!e14.length) throw new Error("There must be at least a single element!");
  return e14.reduce((e15, t10, n10) => 0 === n10 ? `ColumnHierarchy.Members.${t10}` : `${e15}.Children.${t10}`, "");
};
const g3e = (e14, t10, n10, r10) => {
  var _a2, _b2;
  const { layoutOptions: { features: { enableUserSort: o10, expandCollapseGroups: a10, collapsedGroups: i10, showValuesAsRows: s10 }, totals: { totalsForColumnGroups: l10, subtotalsForColumnGroups: c10, showTotalsBeforeGroup: u10 } }, values: d10, columnGroups: p10, rowGroups: m10 } = e14;
  const { t: h10 } = hG();
  const f10 = (_a2 = n10 == null ? void 0 : n10.noValuesHeaders) != null ? _a2 : 1 === d10.length;
  const g10 = (_b2 = n10 == null ? void 0 : n10.userSort) != null ? _b2 : null;
  const y10 = m3e(e14, t10, { noValuesHeaders: f10, userSort: g10 }, r10);
  const v10 = y10.Body.Columns;
  let b10 = y10.ColumnHierarchy.LevelSizes.length;
  const { selectTextBox: S10, selectTextBoxes: C10, selectDynamic: x10, mergeCells: w10, addParentColumnGroup: T10, addChildColumnGroup: E10, mergeValues: F10, setValue: M10, setValues: k10, addTotalBefore: P10, addTotalAfter: N10 } = a3e;
  const D10 = u10 ? P10 : N10;
  const L10 = [S10("Body.Rows.0.Cells.0.Item"), T10()];
  if (b10++, v10.length > 1) {
    const e15 = v10.map((e16, t11) => ((e17) => `ColumnHierarchy.Members.${e17}.Header.Item`)(t11));
    L10.push(C10(e15), w10());
  }
  const H10 = s10 ? 1 : d10.length;
  const I10 = (t11, n11) => {
    const r11 = [];
    return d10.forEach((o11, a11) => {
      if (!o11.displayAs) return;
      const i11 = O4e(((e15) => s10 ? h3e(e15, n11) : h3e(0, n11 + e15))(a11));
      const l11 = q4e(e14, o11, { columnGroupIndex: t11, rowGroupIndex: m10.length - 1 });
      const c11 = j4e(i11, o11, l11);
      r11.push(...c11);
    }), r11;
  };
  const _10 = [0];
  let V10 = 0;
  if (p10.forEach((e15, t11, n11) => {
    const r11 = f3e(_10);
    L10.push(x10(r11));
    if (0 === t11 && l10 || t11 > 0 && c10) {
      L10.push(D10());
      const e16 = I10(t11 - 1, u10 ? V10 : V10 + H10);
      L10.push(k10(e16)), u10 && (_10[t11]++, V10 += H10);
    }
    t11 !== n11.length - 1 && (L10.push(E10()), b10++, _10.push(0));
  }), s10 && !f10 && b10 > 1) {
    const e15 = new Array(b10).fill("").map((e16, t11) => ((e17) => `Corner.${e17}.0.Item`)(t11));
    L10.push(C10(e15), w10());
  }
  const R10 = [];
  const A10 = _10.reduce((e15, t11, n11, r11) => {
    const s11 = r11.slice(0, n11 + 1);
    const l11 = f3e(s11);
    const c11 = `${l11}.Header.Item`;
    const [u11, m11] = [l11, c11].map((e16) => O4e(e16));
    const h11 = p10[n11];
    const { itemName: y11, $summary: v11 } = h11;
    if (v11) {
      const { memberProps: e16, itemProps: t12 } = v11;
      e16 && R10.push(u11("", e16)), t12 && R10.push(m11("", t12));
    }
    const b11 = [...z4e(u11, h11), ...W4e(m11, h11)];
    n11 === r11.length - 1 && f10 && o10 && g10 && b11.push(...Z4e(m11, d10[0].field.expr, g10));
    if (n11 < r11.length - 1 && a10) {
      b11.push(...G4e(m11, { collapsed: i10 }));
      const e16 = f3e([...s11, r11[n11 + 1]]);
      const t12 = O4e(e16);
      b11.push(...U4e(t12, { toggleItem: y11, collapsed: i10 }));
    }
    return [...e15, ...b11];
  }, []);
  L10.push(F10(R10)), L10.push(k10(A10)), s10 && !f10 && L10.push(M10("Corner.0.0.Item.Value", h10("tablixWizard:makeTablix.textValues", "Values")));
  return s3e(y10, L10, t10);
};
const y3e = "Corner.0.0.Item";
const v3e = "Body.Rows.0.Cells.0.Item";
const b3e = (e14, t10) => `Body.Rows.${e14}.Cells.${t10}.Item`;
const S3e = (e14) => `RowHierarchy.Members.${e14}.Header.Item`;
const C3e = (e14, t10) => `Corner.${e14}.${t10}.Item`;
const x3e = (e14) => {
  if (!e14.length) throw new Error("There must be at least a single element!");
  return e14.reduce((e15, t10, n10) => 0 === n10 ? `RowHierarchy.Members.${t10}` : `${e15}.Children.${t10}`, "");
};
const w3e = (e14, t10, n10, r10) => {
  const o10 = { $fixedPlace: { Width: { $set: t10 }, Height: { $set: n10 }, OverflowName: { $apply: (e15) => void 0 === r10 ? e15 : r10 } } };
  return AV(e14, o10);
};
const T3e = (e14) => {
  const [t10, n10] = [e14.$width || e14.$place.Width, e14.$height || e14.$place.Height];
  const r10 = AV(e14, { $place: { Width: { $set: t10 }, Height: { $set: n10 } } });
  return "fixedpagetablix" !== r10.Type ? r10 : w3e(r10, t10, n10);
};
const E3e = (e14, t10) => {
  const n10 = T3e(((e15, t11) => {
    if (!t11) return e15;
    const { width: n11, height: r10 } = t11;
    const o10 = G5;
    const [a10, i10] = [HQ(e15), IQ(e15)].map((e16) => L$.sum(e16));
    const [s10, l10] = [DQ(e15), LQ(e15)].map((e16) => o10.multiply(e16));
    if (n11.lowerThan(s10) || r10.lowerThan(l10)) throw new Error(`Tablix cannot fit available space - ${n11.css} x ${r10.css}.`);
    const [c10, u10] = [[a10, n11], [i10, r10]].map((e16) => L$.min(e16));
    return c10.equal(a10) && u10.equal(i10) ? e15 : H5e(L5e(e15, { width: c10, height: u10 }), e15);
  })(e14, t10));
  return n10;
};
const F3e = ["bandedlistheader", "bandedlistdetails", "bandedlistfooter"];
const M3e = ["dynamictablixmember", "statictablixmember"];
const k3e = (e14, t10) => {
  let [n10, r10, o10, a10] = [L$.zero, L$.zero, h3(e14), f3(e14)];
  C3(e14, x3(w3((e15, i11, s11, l10) => {
    const { path: c10, place: u10 } = l10;
    if (((e16) => M3e.includes(e16 == null ? void 0 : e16.Type))(i11)) return null;
    if (c10 && !t10.startsWith(`${c10}.`) && c10 !== t10) return null;
    const d10 = (p10 = i11, $$.includes(p10.Type) || ((e16) => F3e.includes(e16 == null ? void 0 : e16.Type))(i11));
    var p10;
    switch (d10 && ([n10, r10] = [(u10 == null ? void 0 : u10.Left) ? n10.add(u10.Left) : n10, (u10 == null ? void 0 : u10.Top) ? r10.add(u10.Top) : r10]), s11 == null ? void 0 : s11.Type) {
      case "fixedpagebandedlist": {
        const { bandInfo: t11, idx: n11 } = l10;
        if (!t11) break;
        const { bandHeights: r11 } = e15;
        const o11 = L$.sum(r11, n11 + 1);
        a10 = a10.subtract(o11);
        break;
      }
      case "fixedpagetable": {
        const { cellInfo: t11 } = l10;
        if (!t11) break;
        const { colIdx: n11, colSpan: r11, rowIdx: i12, rowSpan: s12 } = t11;
        const { columnSizes: c11, rowSizes: u11 } = e15;
        const [d11, p11] = [L$.sum(c11, n11 + r11), L$.sum(u11, i12 + s12)];
        [o10, a10] = [o10.subtract(d11), a10.subtract(p11)];
        break;
      }
      case "fixedpagetablix": {
        const { tablixCell: t11 } = l10;
        if (!t11) break;
        const { cix: n11, cspan: r11, rix: i12, rspan: s12 } = t11;
        const { columnSizes: c11, rowSizes: u11 } = e15;
        const [d11, p11] = [L$.sum(c11, n11 + r11), L$.sum(u11, i12 + s12)];
        [o10, a10] = [o10.subtract(d11), a10.subtract(p11)];
        break;
      }
    }
    return c10 !== t10 ? {} : null;
  })));
  const [i10, s10] = [o10.subtract(n10), a10.subtract(r10)];
  return { width: i10, height: s10 };
};
const P3e = (e14, t10, n10, r10) => {
  const { columnGroups: o10, rowGroups: a10, values: i10 } = t10;
  const { defaultColumnWidth: s10, defaultRowHeight: l10 } = ((e15) => {
    const { cellHeight: t11, cellWidth: n11 } = zq(e15);
    return { defaultColumnWidth: L$.parse(n11), defaultRowHeight: L$.parse(t11) };
  })(e14.$templateId);
  const [c10, u10] = [{}, {}];
  o10.forEach((e15) => {
    var _a2, _b2;
    c10[e15.itemName] = (_b2 = (_a2 = e15.$summary) == null ? void 0 : _a2.itemHeight) != null ? _b2 : l10;
  }), a10.forEach((e15) => {
    var _a2, _b2;
    u10[e15.itemName] = (_b2 = (_a2 = e15.$summary) == null ? void 0 : _a2.itemWidth) != null ? _b2 : s10;
  }), i10.forEach((e15) => {
    var _a2, _b2, _c2, _d2;
    c10[e15.itemName] = (_b2 = (_a2 = e15.$summary) == null ? void 0 : _a2.itemHeight) != null ? _b2 : l10, u10[e15.itemName] = (_d2 = (_c2 = e15.$summary) == null ? void 0 : _c2.itemWidth) != null ? _d2 : s10;
  });
  const d10 = new Array(n10).fill(null);
  const p10 = new Array(r10).fill(null);
  _Q(e14, ({ rix: e15, cix: t11, item: n11 }) => {
    const r11 = c10[n11.Name];
    if (r11) {
      const t12 = d10[e15];
      d10[e15] = null !== t12 ? L$.max([t12, r11]) : r11;
    }
    const o11 = u10[n11.Name];
    if (o11) {
      const e16 = p10[t11];
      p10[t11] = null !== e16 ? L$.max([e16, o11]) : o11;
    }
  });
  const m10 = d10.map((e15) => e15 != null ? e15 : l10);
  return { rowHeights: m10, columnWidths: p10.map((e15) => e15 != null ? e15 : s10) };
};
const N3e = (e14, t10) => e14.length === t10.length && e14.every((e15, n10) => e15.field.name === t10[n10].field.name);
const D3e = (e14, t10, n10, r10) => {
  if (!n10) return e14;
  let o10 = AV(e14, { $place: { Left: { $set: n10.$place.Left }, Top: { $set: n10.$place.Top } } });
  const [a10, i10] = [LQ(e14), DQ(e14)];
  const [s10, l10] = [LQ(n10), DQ(n10)];
  const c10 = !!r10 && a10 === s10 && i10 === l10 && N3e(t10.rowGroups, r10.rowGroups) && N3e(t10.columnGroups, r10.columnGroups) && N3e(t10.values, r10.values) && zV.isEqual(t10.layoutOptions.totals, r10.layoutOptions.totals) && (1 === t10.rowGroups.length || t10.layoutOptions.features.steppedRowGroups === r10.layoutOptions.features.steppedRowGroups) && (1 === t10.values.length || t10.layoutOptions.features.showValuesAsRows === r10.layoutOptions.features.showValuesAsRows) ? { rowHeights: IQ(n10), columnWidths: HQ(n10) } : P3e(e14, t10, a10, i10);
  const { rowHeights: u10, columnWidths: d10 } = c10;
  return o10 = ((e15, t11, n11) => {
    let r11 = RQ(e15, ({ rix: e16, rspan: r12, cix: o12, cspan: a12, item: i11 }) => {
      const s11 = L$.sum(n11, o12, a12).css;
      const l11 = L$.sum(t11, e16, r12).css;
      return AV(i11, { $width: { $set: s11 }, $height: { $set: l11 }, $place: { Width: { $set: s11 }, Height: { $set: l11 } } });
    });
    const o11 = e15.RowHierarchy.LevelSizes.length;
    const a11 = e15.ColumnHierarchy.LevelSizes.length;
    return r11 = AV(r11, { RowHierarchy: { LevelSizes: { $set: n11.slice(0, o11).map((e16) => e16.css) } }, ColumnHierarchy: { LevelSizes: { $set: t11.slice(0, a11).map((e16) => e16.css) } }, Body: { Columns: { $set: n11.slice(o11).map((e16) => e16.css) }, Rows: { $apply: (e16) => e16.map((e17, n12) => __spreadProps(__spreadValues({}, e17), { Height: t11[a11 + n12].css })) } }, $width: { $set: L$.sum(n11).css }, $height: { $set: L$.sum(t11).css }, $rows: { collection: { $set: t11.map((e16) => ({ Type: "tablixrow", Height: e16.css })) } }, $columns: { collection: { $set: n11.map((e16) => ({ Type: "tablixcolumn", Width: e16.css })) } } }), r11 = T3e(r11), r11;
  })(o10, u10, d10), o10;
};
const L3e = (e14, t10, n10, r10, o10) => {
  let a10 = D3e(e14, t10, n10, r10);
  return a10 = E3e(a10, o10), "fixedpagetablix" === a10.Type && (a10 = ((e15, t11) => {
    if (!t11 || "fixedpagetablix" !== t11.Type) return e15;
    const [n11, r11] = [e15.$fixedPlace.Width, e15.$fixedPlace.Height];
    const [o11, a11] = [t11.$fixedPlace.Width, t11.$fixedPlace.Height];
    const [i10, s10, l10, c10] = [n11, r11, o11, a11].map((e16) => L$.parse(e16));
    const [u10, d10] = [[i10, l10], [s10, c10]].map((e16) => L$.max(e16).css);
    return w3e(e15, u10, d10, t11.$fixedPlace.OverflowName);
  })(a10, n10)), a10;
};
const H3e = (e14, t10, n10, r10, o10) => {
  const { values: a10, rowGroups: i10, columnGroups: s10, style: l10 } = t10;
  if (!(a10.length > 0)) throw new Error("Tablix Wizard cannot create a Tablix without Values specified!");
  const c10 = i10.length > 0;
  const u10 = s10.length > 0;
  let d10;
  return d10 = c10 ? ((e15, t11, n11) => {
    const { layoutOptions: { features: { enableUserSort: r11, expandCollapseGroups: o11, collapsedGroups: a11, steppedRowGroups: i11, showValuesAsRows: s11 }, totals: { totalsForRowGroups: l11, subtotalsForRowGroups: c11, totalsForColumnGroups: u11, subtotalsForColumnGroups: d11, showTotalsBeforeGroup: p10 } }, values: m10, columnGroups: h10, rowGroups: f10 } = e15;
    const { t: g10 } = hG();
    const y10 = h10.length;
    const v10 = f10.length;
    const b10 = m10.length;
    const S10 = i11 && v10 > 1;
    const C10 = y10 > 0 ? s11 : s11 && b10 > 1;
    const x10 = e15.name;
    const w10 = AV(e15, { layoutOptions: { features: { showValuesAsRows: { $set: C10 } } } });
    const T10 = { noValuesHeaders: y10 > 0 && 1 === b10, userSort: r11 ? { scope: f10[v10 - 1].name, target: x10 } : null };
    const E10 = (y10 > 0 ? g3e : m3e)(w10, t11, T10, n11);
    const F10 = E10.ColumnHierarchy.Members.every((e16) => !e16.Header && tW(e16));
    const M10 = E10.Body.Rows;
    const [k10, P10] = [M10.length, E10.Body.Columns.length];
    let N10 = E10.ColumnHierarchy.LevelSizes.length;
    const { selectTextBox: D10, selectTextBoxes: L10, selectDynamic: H10, mergeCells: I10, addParentRowGroup: _10, addChildRowGroup: V10, addParentColumnGroup: R10, toggleDynamicStatic: A10, mergeValues: O10, setValue: B10, setValues: z10, addColumnInsideGroupAfter: $10, selectColumn: W10, deleteColumn: j10, addTotalBefore: Z10, addTotalAfter: G10 } = a3e;
    const U10 = p10 ? Z10 : G10;
    const q10 = [];
    if (F10) {
      const e16 = [D10(v3e), R10(), H10("ColumnHierarchy.Members.0"), A10()];
      q10.push(...e16), N10++, C10 && q10.push(B10(`${y3e}.Value`, g10("tablixWizard:makeTablix.textValues", "Values")));
    }
    if (q10.push(D10(v3e), _10()), k10 > 1) {
      const e16 = M10.map((e17, t12) => S3e(t12));
      q10.push(L10(e16), I10());
    }
    const [Y10, K10] = s11 ? [m10.length, 1] : [1, m10.length];
    const X10 = new Array(K10).fill(h10.length - 1);
    for (let e16 = h10.length - 1; e16 >= 0; e16--) {
      const [t12, n12] = [d11 && e16 > 0, u11 && 0 === e16];
      if (!t12 && !n12) continue;
      const r12 = new Array(K10).fill(e16 - 1);
      p10 ? X10.unshift(...r12) : X10.push(...r12);
    }
    if (X10.length !== P10) throw new Error("Tablix Body columns count is inconsistent!");
    const J10 = (t12, n12) => {
      const r12 = [];
      return X10.forEach((o12, a12) => {
        for (let i12 = 0; i12 < Y10; i12++) {
          const l12 = s11 ? i12 : a12 % m10.length;
          const c12 = m10[l12];
          if (!c12.displayAs) continue;
          const u12 = O4e(b3e(n12 + i12, a12));
          const d12 = q4e(e15, c12, { columnGroupIndex: o12, rowGroupIndex: t12 });
          const p11 = j4e(u12, c12, d12);
          r12.push(...p11);
        }
      }), r12;
    };
    const Q10 = [0];
    let ee2 = 0;
    if (f10.forEach((e16, t12, n12) => {
      const r12 = x3e(Q10);
      if (q10.push(H10(r12)), S10) {
        if (0 === t12 && l11) {
          q10.push(U10());
          const e17 = J10(t12 - 1, p10 ? ee2 : ee2 + Y10);
          q10.push(z10(e17)), p10 && (Q10[t12]++, ee2 += Y10);
        }
        if (t12 < n12.length - 1) {
          q10.push(V10()), Q10.push(0);
          const e17 = x3e(Q10);
          q10.push(H10(e17), Z10());
          const n13 = J10(t12, ee2);
          q10.push(z10(n13)), Q10[t12 + 1]++, ee2 += Y10;
        } else q10.push(D10(`${r12}.Header.Item`), $10());
        q10.push(W10(0), j10());
      } else {
        if (0 === t12 && l11 || t12 > 0 && c11) {
          q10.push(U10());
          const e17 = J10(t12 - 1, p10 ? ee2 : ee2 + Y10);
          q10.push(z10(e17)), p10 && (Q10[t12]++, ee2 += Y10);
        }
        if (t12 === n12.length - 1) return;
        q10.push(V10()), Q10.push(0);
      }
    }), N10 > 1) {
      const e16 = S10 ? 1 : f10.length;
      new Array(e16).fill("").forEach((e17, t12) => {
        const n12 = new Array(N10).fill("").map((e18, n13) => C3e(n13, t12));
        q10.push(L10(n12), I10());
      });
    }
    const te2 = [];
    const ne2 = Q10.reduce((e16, t12, n12, i12) => {
      const s12 = i12.slice(0, n12 + 1);
      const l12 = x3e(s12);
      const c12 = S10 ? x3e([...s12, 0]) : l12;
      const [u12, d12] = [l12, `${c12}.Header.Item`].map((e17) => O4e(e17));
      const p11 = f10[n12];
      const { name: m11, field: h11, itemName: g11, $summary: y11 } = p11;
      if (y11) {
        const { memberProps: e17, itemProps: t13 } = y11;
        e17 && te2.push(u12("", e17)), t13 && te2.push(d12("", t13));
      }
      const v11 = [...z4e(u12, p11), ...W4e(d12, p11)];
      const b11 = r11 ? { scope: m11, target: x10 } : null;
      if (S10) {
        if (v11.push(d12("Style.PaddingLeft", 2 + 15 * n12 + "pt")), n12 === i12.length - 1) {
          const e17 = O4e(y3e);
          v11.push(e17("Value", B4e(h11.name))), v11.push(e17("Style.TextAlign", "Right")), b11 && v11.push(...Z4e(e17, h11.expr, b11));
        }
      } else {
        const e17 = O4e(C3e(0, n12));
        v11.push(e17("Value", B4e(h11.name))), b11 && v11.push(...Z4e(e17, h11.expr, b11));
      }
      if (n12 < i12.length - 1 && o11) {
        v11.push(...G4e(d12, { collapsed: a11 }));
        const e17 = x3e([...s12, i12[n12 + 1]]);
        const t13 = O4e(e17);
        v11.push(...U4e(t13, { toggleItem: g11, collapsed: a11 }));
      }
      return [...e16, ...v11];
    }, []);
    if (S10 && l11) {
      const e16 = S3e(p10 ? 0 : 1);
      ne2.push(A4e(`${e16}.Value`, g10("tablixWizard:makeTablix.textTotal", "Total")));
    }
    return q10.push(O10(te2)), q10.push(z10(ne2)), s3e(E10, q10, t11);
  })(t10, e14, o10) : u10 ? g3e(t10, e14, void 0, o10) : m3e(t10, e14, void 0, o10), r10 && (d10 = l3e(d10, l10, r10(l10), e14)), d10 = n10(d10), d10;
};
const I3e = ["dataSetName", "style", "frozenRows", "frozenColumns"];
const _3e = (e14, t10, n10, r10, o10) => (a10) => {
  var _a2;
  const i10 = oJe(t10, n10);
  if (i10 && r10 && ((e15, t11) => {
    const [n11, r11] = [e15, t11].map((e16) => zV.omit(e16, I3e));
    return zV.isEqual(n11, r11);
  })(r10, a10)) {
    const { style: t11 } = a10;
    let n11 = i10;
    return !zV.isEqual(r10.style, t11) && o10 && (n11 = l3e(n11, t11, o10(t11), e14)), QXe(n11, a10);
  }
  const s10 = /* @__PURE__ */ ((e15, t11) => (n11) => {
    const r11 = j0({}, t11, { $set: n11 });
    const o11 = OG(AV(e15, r11));
    return oJe(o11, t11);
  })(t10, n10);
  const l10 = !!i10 && (!((_a2 = i10.ReportStyle) == null ? void 0 : _a2.StyleId) && !a10.style);
  const c10 = H3e(e14, a10, s10, l10 ? void 0 : o10, i10 == null ? void 0 : i10.$templateId);
  const u10 = ((e15, t11) => "fixedpagereport" !== e15.Type ? null : k3e(e15, t11))(t10, n10);
  const d10 = L3e(c10, a10, i10, r10, u10);
  return QXe(d10, a10);
};
const V3e = "@tw/init";
const R3e = "@tw/reset";
const A3e = "@tw/CLEAR_DATA_SET_NAME";
const O3e = "@tw/SET_DATA_SET_NAME";
const B3e = "@tw/CLEAR_TABLIX_STYLE";
const z3e = "@tw/SET_TABLIX_STYLE";
const $3e = "@tw/SET_FROZEN_ROWS";
const W3e = "@tw/SET_FROZEN_COLUMNS";
const j3e = "@tw/SWAP_HIERARCHIES";
const Z3e = "@tw/TOGGLE_EXPAND_COLLAPSE_GROUPS";
const G3e = "@tw/TOGGLE_COLLAPSED_GROUPS";
const U3e = "@tw/TOGGLE_ENABLE_USER_SORT";
const q3e = "@tw/TOGGLE_STEPPED_ROW_GROUPS";
const Y3e = "@tw/TOGGLE_SHOW_VALUES_AS_ROWS";
const K3e = "@tw/TOGGLE_ROW_TOTALS";
const X3e = "@tw/TOGGLE_COLUMN_TOTALS";
const J3e = "@tw/TOGGLE_ROW_SUBTOTALS";
const Q3e = "@tw/TOGGLE_COLUMN_SUBTOTALS";
const e7e = "@tw/TOGGLE_SHOW_TOTALS_BEFORE_GROUP";
const t7e = "@tw/DELETE_ROW_GROUP";
const n7e = "@tw/DELETE_COLUMN_GROUP";
const r7e = "@tw/DELETE_VALUE";
const o7e = "@tw/DELETE_FIELD";
const a7e = "@tw/ADD_ROW_GROUP";
const i7e = "@tw/ADD_COLUMN_GROUP";
const s7e = "@tw/ADD_VALUE";
const l7e = "@tw/INSERT_ROW_GROUP";
const c7e = "@tw/INSERT_COLUMN_GROUP";
const u7e = "@tw/INSERT_VALUE";
const d7e = "@tw/SET_ROW_GROUP_FORMAT";
const p7e = "@tw/SET_COLUMN_GROUP_FORMAT";
const m7e = "@tw/SET_VALUE_FORMAT";
const h7e = "@tw/SET_ROW_GROUP_SORTING_TYPE";
const f7e = "@tw/SET_COLUMN_GROUP_SORTING_TYPE";
const g7e = "@tw/SET_VALUE_AGGREGATE";
const y7e = "@tw/SET_VALUE_DISPLAY_AS";
const v7e = "@tw/MOVE_ROW_GROUP";
const b7e = "@tw/MOVE_COLUMN_GROUP";
const S7e = "@tw/MOVE_VALUE";
const C7e = "@tw/EDIT_FILTERS";
const x7e = "@tw/SET_FILTERS";
const w7e = "@tw/CLOSE_FILTERS";
const T7e = "@tw/CLEAR_WARNING";
const E7e = { initTablixWizard: (e14, t10) => Kz.action(V3e, { report: e14, path: t10 }), resetTablixWizard: () => Kz.action(R3e), clearDataSetName: () => Kz.action(A3e), setDataSetName: (e14) => Kz.action(O3e, { dataSetName: e14 }), clearTablixStyle: () => Kz.action(B3e), setTablixStyle: (e14, t10) => Kz.action(z3e, { id: e14, name: t10 }), setFrozenRows: (e14) => Kz.action($3e, { count: e14 }), setFrozenColumns: (e14) => Kz.action(W3e, { count: e14 }), swapHierarchies: () => Kz.action(j3e), toggleExpandCollapseGroups: () => Kz.action(Z3e), toggleCollapsedGroups: () => Kz.action(G3e), toggleEnableUserSort: () => Kz.action(U3e), toggleSteppedRowGroups: () => Kz.action(q3e), toggleShowValuesAsRows: () => Kz.action(Y3e), toggleRowTotals: () => Kz.action(K3e), toggleColumnTotals: () => Kz.action(X3e), toggleRowSubtotals: () => Kz.action(J3e), toggleColumnSubtotals: () => Kz.action(Q3e), toggleShowTotalsBeforeGroup: () => Kz.action(e7e), deleteRowGroup: (e14) => Kz.action(t7e, { index: e14 }), deleteColumnGroup: (e14) => Kz.action(n7e, { index: e14 }), deleteValue: (e14) => Kz.action(r7e, { index: e14 }), deleteField: (e14) => Kz.action(o7e, { fieldName: e14 }), addRowGroup: (e14, t10, n10) => Kz.action(a7e, { field: e14, index: t10, dataSetName: n10 }), addColumnGroup: (e14, t10, n10) => Kz.action(i7e, { field: e14, index: t10, dataSetName: n10 }), addValue: (e14, t10, n10) => Kz.action(s7e, { field: e14, index: t10, dataSetName: n10 }), insertRowGroup: (e14, t10) => Kz.action(l7e, { group: e14, index: t10 }), insertColumnGroup: (e14, t10) => Kz.action(c7e, { group: e14, index: t10 }), insertValue: (e14, t10) => Kz.action(u7e, { value: e14, index: t10 }), setRowGroupFormat: (e14, t10) => Kz.action(d7e, { format: e14, index: t10 }), setColumnGroupFormat: (e14, t10) => Kz.action(p7e, { format: e14, index: t10 }), setValueFormat: (e14, t10) => Kz.action(m7e, { format: e14, index: t10 }), setRowGroupSortingType: (e14, t10) => Kz.action(h7e, { sortingType: e14, index: t10 }), setColumnGroupSortingType: (e14, t10) => Kz.action(f7e, { sortingType: e14, index: t10 }), setValueAggregate: (e14, t10) => Kz.action(g7e, { aggregate: e14, index: t10 }), setValueDisplayAs: (e14, t10) => Kz.action(y7e, { displayAs: e14, index: t10 }), moveRowGroup: (e14, t10, n10) => Kz.action(v7e, { index: e14, targetType: t10, targetIndex: n10 }), moveColumnGroup: (e14, t10, n10) => Kz.action(b7e, { index: e14, targetType: t10, targetIndex: n10 }), moveValue: (e14, t10) => Kz.action(S7e, { index: e14, targetIndex: t10 }), editFilters: (e14) => Kz.action(C7e, { location: e14 }), setFilters: (e14) => Kz.action(x7e, { value: e14 }), closeFilters: () => Kz.action(w7e), clearWarning: () => Kz.action(T7e) };
const F7e = tp.createElement("svg", { viewBox: "0 0 24 24" }, tp.createElement("path", { className: km.text, d: "M18,6H8.83L14.83,12L8.83,18H18V20H6V18L12,12L6,6V4H18V6Z" }));
const M7e = "tw-icon-color-none";
const k7e = "tw-icon-color-blue";
const P7e = "tw-icon-color-light-blue";
const N7e = "tw-icon-color-gray-blue";
const D7e = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,0V24H24V0Z", className: M7e }), tp.createElement("path", { d: "M20,14H3v7H20ZM4,20V15H7v5Zm4,0V15h3v5Zm4,0V15h3v5Zm4,0V15h3v5ZM13,5a1.00192,1.00192,0,0,1,1,1V9a1.0007,1.0007,0,0,1-1,1H10A1.00067,1.00067,0,0,1,9,9V6a1.00189,1.00189,0,0,1,1-1h3m0-1H10A2.00136,2.00136,0,0,0,8,6V9a2.00008,2.00008,0,0,0,2,2h3a2.0001,2.0001,0,0,0,2-2V6a2.00138,2.00138,0,0,0-2-2Z", className: N7e }), tp.createElement("path", { d: "M7,8H4v4H3V7H7Zm5-1V6H11V7H10V8h1V9h1V8h1V7Zm8,5V7H16V8h3v4Z", className: k7e }));
const L7e = tp.createElement("svg", { viewBox: "0 0 24 24" }, tp.createElement("path", { className: km.text, d: "M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M7,6H17V19H7V6M9,8V17H11V8H9M13,8V17H15V8H13Z" }));
const H7e = tp.createElement("svg", { viewBox: "0 0 24 24" }, tp.createElement("path", { className: km.text, d: "M2,3H10A2,2 0 0,1 12,1A2,2 0 0,1 14,3H22V5H21V16H15.25L17,22H15L13.25,16H10.75L9,22H7L8.75,16H3V5H2V3M5,5V14H19V5H5M11.85,11.85C11.76,11.94 11.64,12 11.5,12A0.5,0.5 0 0,1 11,11.5V7.5A0.5,0.5 0 0,1 11.5,7C11.64,7 11.76,7.06 11.85,7.15L13.25,8.54C13.57,8.86 13.89,9.18 13.89,9.5C13.89,9.82 13.57,10.14 13.25,10.46L11.85,11.85Z" }));
const I7e = tp.createElement("svg", { viewBox: "0 0 24 24" }, tp.createElement("path", { className: k7e, d: "M15,19.88C15.04,20.18 14.94,20.5 14.71,20.71C14.32,21.1 13.69,21.1 13.3,20.71L9.29,16.7C9.06,16.47 8.96,16.16 9,15.87V10.75L4.21,4.62C3.87,4.19 3.95,3.56 4.38,3.22C4.57,3.08 4.78,3 5,3V3H19V3C19.22,3 19.43,3.08 19.62,3.22C20.05,3.56 20.13,4.19 19.79,4.62L15,10.75V19.88M7.04,5L11,10.06V15.58L13,17.58V10.05L16.96,5H7.04Z" }));
const _7e = tp.createElement("svg", { viewBox: "0 0 24 24" }, tp.createElement("path", { className: km.text, d: "M22.61,19L13.53,9.91C14.46,7.57 14,4.81 12.09,2.91C9.79,0.61 6.21,0.4 3.66,2.26L7.5,6.11L6.08,7.5L2.25,3.69C0.39,6.23 0.6,9.82 2.9,12.11C4.76,13.97 7.47,14.46 9.79,13.59L18.9,22.7C19.29,23.09 19.92,23.09 20.31,22.7L22.61,20.4C23,20 23,19.39 22.61,19M19.61,20.59L10.15,11.13C9.54,11.58 8.86,11.85 8.15,11.95C6.79,12.15 5.36,11.74 4.32,10.7C3.37,9.76 2.93,8.5 3,7.26L6.09,10.35L10.33,6.11L7.24,3C8.5,2.95 9.73,3.39 10.68,4.33C11.76,5.41 12.17,6.9 11.92,8.29C11.8,9 11.5,9.66 11.04,10.25L20.5,19.7L19.61,20.59Z" }));
const V7e = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: M7e }), tp.createElement("path", { d: "m11.5 4c-4.694 0-8.5 3.806-8.5 8.5 0 4.695 3.806 8.5 8.5 8.5s8.5-3.805 8.5-8.5c0-4.694-3.806-8.5-8.5-8.5zm1.5 14h-3v-7h3zm0-8h-3v-3h3z", className: N7e }));
const R7e = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M18.6055,3.5H4.3945A1.89508,1.89508,0,0,0,2.5,5.3945v14.211A1.89386,1.89386,0,0,0,4.39322,21.5H18.6055A1.89508,1.89508,0,0,0,20.5,19.6055V5.3945A1.8963,1.8963,0,0,0,18.6055,3.5Z", fill: "#fff" }), tp.createElement("path", { d: "M19,4a1.00191,1.00191,0,0,1,1,1V20a1.00069,1.00069,0,0,1-1,1H4a1.00069,1.00069,0,0,1-1-1V5A1.00191,1.00191,0,0,1,4,4H19m0-1H4A2.00137,2.00137,0,0,0,2,5V20a2.00009,2.00009,0,0,0,2,2H19a2.00009,2.00009,0,0,0,2-2V5A2.00137,2.00137,0,0,0,19,3Z", className: N7e }), tp.createElement("path", { d: "M17,12.211V15H15V12.211a2.49651,2.49651,0,0,0,0,4.578V19a1,1,0,0,0,2,0V16.789a2.498,2.498,0,0,0,0-4.578Z", className: k7e }), tp.createElement("path", { d: "M11,7h1V9H11Zm0,3h1v2H11Zm0,6h1v2H11Zm0,3h1v2H11Zm0-6h1v2H11Zm0-9h1V6H11Z", className: P7e }), tp.createElement("path", { d: "M0,0H24V24H0Z", className: M7e }));
const A7e = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "M0,24H24V0H0Z", className: M7e }), tp.createElement("path", { d: "M13,4V21h7V4Zm6,16H14V17h5Zm0-4H14V13h5Zm0-4H14V9h5Zm0-4H14V5h5ZM4,11a1.00192,1.00192,0,0,1,1-1H8a1.0007,1.0007,0,0,1,1,1v3a1.00068,1.00068,0,0,1-1,1H5a1.00189,1.00189,0,0,1-1-1V11M3,11v3a2.00136,2.00136,0,0,0,2,2H8a2.00008,2.00008,0,0,0,2-2V11A2.00011,2.00011,0,0,0,8,9H5a2.00138,2.00138,0,0,0-2,2Z", className: N7e }), tp.createElement("path", { d: "M7,17v3h4v1H6V17ZM6,12H5v1H6v1H7V13H8V12H7V11H6Zm5-8H6V8H7V5h4Z", className: k7e }));
const O7e = tp.createElement("svg", { viewBox: "0 0 24 24" }, tp.createElement("path", { className: km.text, d: "M18 21L14 17H17V7H14L18 3L22 7H19V17H22M2 19V17H12V19M2 13V11H9V13M2 7V5H6V7H2Z" }));
const B7e = tp.createElement("svg", { viewBox: "0 0 24 24" }, tp.createElement("path", { className: km.text, d: "M19 17H22L18 21L14 17H17V3H19M2 17H12V19H2M6 5V7H2V5M2 11H9V13H2V11Z" }));
const z7e = tp.createElement("svg", { viewBox: "0 0 24 24" }, tp.createElement("path", { className: km.text, d: "M19 7H22L18 3L14 7H17V21H19M2 17H12V19H2M6 5V7H2V5M2 11H9V13H2V11Z" }));
const $7e = tp.createElement("svg", { viewBox: "0 0 24 24" }, tp.createElement("path", { d: "M12,5C16.97,5 21,7.69 21,11C21,12.68 19.96,14.2 18.29,15.29C19.36,14.42 20,13.32 20,12.13C20,9.29 16.42,7 12,7V10L8,6L12,2V5M12,19C7.03,19 3,16.31 3,13C3,11.32 4.04,9.8 5.71,8.71C4.64,9.58 4,10.68 4,11.88C4,14.71 7.58,17 12,17V14L16,18L12,22V19Z", className: k7e }));
const W7e = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("rect", { x: "4", y: "12", width: "9", height: "9", className: k7e }), tp.createElement("polygon", { points: "19 14 15 14 15 10 9 10 9 5 19 5 19 14", className: P7e }), tp.createElement("path", { d: "M-.001,0V24h24V0Z", className: M7e }), tp.createElement("path", { d: "M-.001,0h24V24h-24Z", className: M7e }));
const j7e = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m0 0v24h24v-24z", className: M7e }), tp.createElement("path", { d: "m11.5 4c-4.694 0-8.5 3.806-8.5 8.5 0 4.695 3.806 8.5 8.5 8.5s8.5-3.805 8.5-8.5c0-4.694-3.806-8.5-8.5-8.5zm1.5 14h-3v-7h3zm0-8h-3v-3h3z", className: "tw-icon-color-yellow" }));
const [Z7e, , G7e] = Dp("wd-tablix-wizard-data-set");
const [U7e] = G7e("delete-field");
const q7e = (e14) => ({ fieldName: t10, customCSS: n10 }) => {
  const { canDeleteField: r10, handleDeleteField: o10 } = e14;
  const { t: a10 } = vp("tablixWizard");
  if (!r10(t10)) return null;
  const i10 = kp(U7e, n10);
  const s10 = Pm(L7e, { size: "small" });
  const l10 = a10("titleDelete", "Delete");
  const c10 = o10(t10);
  return tp.createElement("div", { key: l10, className: i10, title: l10, onClick: c10 }, tp.createElement(Fm, { icon: s10, customCSS: "wd-svg" }));
};
const Y7e = (e14) => {
  const { dataSet: t10, expanded: n10, onClick: r10, index: o10, isFieldUsed: a10 } = e14;
  const i10 = PA();
  const s10 = { dataSet: t10, expanded: n10, onClick: r10, index: o10, customCSS: Z7e, disableEdit: true, prohibitDragDataSet: true, prohibitDragFields: true, hideQueryParameters: true, customFieldDragItemType: "tablix_wizard_field", customFieldActions: [q7e({ canDeleteField: a10, handleDeleteField: (e15) => () => {
    i10(E7e.deleteField(e15));
  } })] };
  return tp.createElement(pBe, __spreadValues({}, s10));
};
Y7e.displayName = "DataSet";
const [K7e, , X7e] = Dp("wd-tablix-wizard-info");
const [J7e] = X7e("icon");
const [Q7e] = X7e("msg");
const e8e = (e14) => {
  const { lines: t10, customCSS: n10 } = e14;
  const r10 = t10.reduce((e15, t11, n11, r11) => n11 === r11.length - 1 ? [...e15, t11] : [...e15, t11, tp.createElement("br", { key: n11 })], []);
  return tp.createElement("div", { className: kp(K7e, n10) }, tp.createElement(Fm, { icon: Pm(V7e), customCSS: kp("wd-svg", J7e) }), tp.createElement("span", { className: Q7e }, r10));
};
const t8e = tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { d: "m18 10h-8c-1.104 0-2 .896-2 2v6c0 1.105.896 2 2 2h8c1.104 0 2-.895 2-2v-6c0-1.104-.896-2-2-2z", className: V9 }), tp.createElement("g", { className: km.text }, tp.createElement("path", { d: "m3 14.918v.767c0 .773 1.436 1.438 3.5 1.74 0-.707 0-1.575 0-2.324 0-.12 0-.246 0-.358-.999-.141-1.995-.375-2.768-.743-.466.272-.732.585-.732.918z" }), tp.createElement("path", { d: "m15 6.818c0-1.005-2.688-1.818-6-1.818-3.313 0-6 .813-6 1.818v.364c0 1.004 2.687 1.818 6 1.818 3.312 0 6-.814 6-1.817z" }), tp.createElement("path", { d: "m3.732 10c-.466.272-.732.584-.732.918v.767c0 .772 1.436 1.437 3.5 1.738 0-.886 0-1.663 0-2.681-.999-.14-1.995-.374-2.768-.742z" })), tp.createElement("path", { d: "m18 11c .551 0 1 .449 1 1v6c0 .553-.449 1-1 1h-8c-.551 0-1-.447-1-1v-6c0-.551.449-1 1-1zm0-1h-8c-1.104 0-2 .896-2 2v6c0 1.105.896 2 2 2h8c1.104 0 2-.895 2-2v-6c0-1.104-.896-2-2-2z", className: km.text }), tp.createElement("path", { d: "m13 13v-1h-3v1h1v4h-1v1h3v-1h-1v-4z", className: $9 }));
tp.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("g", null, tp.createElement("path", { className: km.text, d: "M13.6,11.3c-0.3,0.2-0.6,0.4-0.9,0.5l0.6,1c0.3-0.2,0.5-0.4,0.9-0.5L13.6,11.3z" }), tp.createElement("path", { className: km.text, d: "M12.1,16c0-0.2-0.1-0.4-0.1-0.5c0-0.2,0-0.3,0-0.5h-1c0,0.1,0,0.3,0,0.5s0,0.4-0.1,0.5H12.1z" }), tp.createElement("path", { className: km.text, d: "M9.6,12.8l0.6-1c-0.3-0.1-0.6-0.3-0.9-0.5l-0.6,1C9.1,12.4,9.4,12.5,9.6,12.8z" })), tp.createElement("path", { className: $9, d: "M22,5v15c0,0.5-0.5,1-1,1h-2v-1h2V5h-2V4h2C21.6,4,22,4.5,22,5z M2,21h2v-1H2V5h2V4H2C1.5,4,1,4.5,1,5v15C1,20.5,1.5,21,2,21z" }), tp.createElement("path", { className: km.text, d: "M15.5,18c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S16.9,18,15.5,18z M7.5,18C6.1,18,5,16.9,5,15.5S6.1,13,7.5,13s2.5,1.1,2.5,2.5S8.9,18,7.5,18zM11.5,11C10.1,11,9,9.9,9,8.5S10.1,6,11.5,6S14,7.1,14,8.5S12.9,11,11.5,11z" }));
const [n8e] = HOe("icon-drag");
const [, , r8e] = Dp("wd-data-attribute");
const [o8e] = r8e("variations-toggle");
const a8e = (e14) => {
  const { attribute: t10, dataSetName: n10, expanded: r10, filter: o10, isInner: a10, isAttributeEnabled: i10, customFieldDragItemType: s10, onToggle: l10, customCSS: c10 } = e14;
  const u10 = ep.useMemo(() => ((e15, t11) => {
    var _a2;
    if (!((_a2 = e15.$rebalance) == null ? void 0 : _a2.canRebalance)) return;
    const { semanticModel: n11, path: r11 } = e15.$rebalance.getInfo();
    return [z$({ semanticModel: n11, dataSetName: t11, path: r11 })];
  })(t10, n10), [t10, n10]);
  const d10 = rf(hh);
  const p10 = rf(fh);
  const m10 = L6(t10);
  const h10 = !i10(t10) || H6(t10);
  const [, f10, g10] = Yne({ canDrag: !h10, item: { type: s10 || "field", field: { name: t10.Name, value: t10.$path }, dataSetName: n10, format: t10.Format, dropActions: u10, isAggregate: t10.IsAggregate, preventGroupUpdate: t10.DiscourageGrouping } });
  ep.useEffect(() => {
    g10(Coe(), { captureDraggingState: true });
  });
  const y10 = e9(t10.Name, t10.Description);
  const v10 = { block: true, size: "small", background: "transparent", rounded: true, icon: r10 ? p10 : d10, customCSS: o8e, onClick: l10 };
  const b10 = kp(MOe, kOe("attribute"), c10, { [kOe("inner-attribute")]: a10 });
  const S10 = kp(DOe, LOe("attribute"), { [LOe("expanded")]: r10, [LOe("disabled-attribute")]: h10 });
  return tp.createElement("div", { className: b10 }, tp.createElement("div", { className: "branch" }, tp.createElement("span", { className: "corner" }), tp.createElement("span", { className: "line" })), tp.createElement("div", { className: S10, title: y10, ref: f10 }, tp.createElement("div", { className: n8e }, tp.createElement(Fm, { icon: Pm(t8e) })), (() => {
    const e15 = t10.Name;
    const n11 = e15.toLowerCase().indexOf(o10);
    if (!o10 || n11 < 0) return tp.createElement("span", null, e15);
    const r11 = n11 + o10.length;
    return tp.createElement("span", null, e15.substring(0, n11), tp.createElement("b", null, e15.substring(n11, r11)), e15.substring(r11));
  })()), m10 && tp.createElement(qm, __spreadValues({}, v10)));
};
const i8e = (e14, t10, n10) => {
  const r10 = ((e15) => {
    const _a3 = e15, { onToggleAttribute: t11 } = _a3, n11 = __objRest(_a3, ["onToggleAttribute"]);
    return (e16, r11) => __spreadValues({ attribute: e16, expanded: r11, onToggle: () => t11(e16) }, n11);
  })(n10);
  const _a2 = n10, { filter: o10, onToggleAttribute: a10 } = _a2, i10 = __objRest(_a2, ["filter", "onToggleAttribute"]);
  const s10 = /* @__PURE__ */ ((e15) => (t11) => __spreadValues({ attribute: t11, expanded: true, filter: "", customCSS: "variation" }, e15))(i10);
  const l10 = e14.reduce((e15, n11) => (t10 === n11.Name ? (e15.push(r10(n11, true)), L6(n11) && e15.push(...n11.Variations.map(s10))) : e15.push(r10(n11, false)), e15), []);
  return l10.map((e15) => tp.createElement(a8e, __spreadValues({ key: e15.attribute.Name }, e15)));
};
const [s8e] = HOe("icon-drag");
const l8e = (e14) => {
  const { dataSetName: t10, field: n10, customFieldDragItemType: r10 } = e14;
  const o10 = rf(Fie);
  const [, a10, i10] = Yne({ item: { type: r10 || "field", field: { name: n10.Name, value: n10.Name, dataType: n10.DataType, aggregate: n10.Aggregate || "Count" }, dataSetName: t10 } });
  ep.useEffect(() => {
    i10(Coe(), { captureDraggingState: true });
  });
  const s10 = c3(n10);
  const l10 = kp(MOe, kOe("attribute"));
  const c10 = kp(DOe, LOe("attribute"));
  return tp.createElement("div", { className: l10 }, tp.createElement("div", { className: "branch" }, tp.createElement("span", { className: "corner" }), tp.createElement("span", { className: "line" })), tp.createElement("div", { className: c10, title: s10, ref: a10 }, tp.createElement("div", { className: s8e }, tp.createElement(Fm, { icon: o10 })), tp.createElement("span", null, s10)));
};
const [c8e] = HOe("icon-drag");
const [, , u8e] = Dp("wd-data-item-relation");
const [d8e, p8e] = u8e("fields");
const [m8e] = u8e("message");
const [h8e] = u8e("branch-corner");
const f8e = (e14) => {
  const { relation: t10, dataSetName: n10, expanded: r10, filter: o10, isInner: a10, loadEntityScope: i10, onToggle: s10, prepareFillData: l10, prepareRelationViewModel: c10, isAttributeEnabled: u10, canDragRelation: d10, customFieldDragItemType: p10 } = e14;
  const { t: m10 } = vp();
  const [h10, f10] = ep.useState(null);
  const [g10, y10] = ep.useState(null);
  const v10 = ep.useMemo(() => r10 ? c10(t10) : null, [r10, c10, t10]);
  const [, b10, S10] = Yne({ begin: () => l10("table", t10), item: z6, canDrag: d10(t10) && (!t10.$rebalance || t10.$rebalance.canRebalance) });
  ep.useEffect(() => {
    S10(Coe(), { captureDraggingState: true });
  }), ep.useEffect(() => {
    r10 || C10();
  }, [r10]);
  const C10 = () => {
    f10(null), y10(null);
  };
  const x10 = !a10 || a10 && !r10 && !g10;
  const w10 = r10 && g10;
  const T10 = a10 && !r10;
  const E10 = n9(v10, o10);
  const F10 = r9(v10, g10, o10);
  const M10 = t10.$attributesCount || 0;
  const k10 = t10.$relationsCount || 0;
  const P10 = D6(M10, k10, m10);
  const N10 = kp(MOe, kOe("relation"), { [kOe("inner-relation")]: T10 });
  const D10 = kp(DOe, LOe("relation"), { [LOe("expanded-relation")]: w10 });
  const L10 = e9(t10.Name, t10.Description);
  return tp.createElement("div", { className: N10 }, x10 && tp.createElement("div", { className: "branch" }, tp.createElement("span", { className: "corner" }), tp.createElement("span", { className: "line" })), tp.createElement("div", { className: D10, onClick: () => {
    g10 ? C10() : (i10(t10.RelatedEntityId), s10(t10));
  }, title: L10, ref: b10 }, tp.createElement("div", { className: c8e }, tp.createElement(Fm, { icon: nf(oh, { rotate: r10 ? void 0 : "270" }) })), tp.createElement("div", { className: IOe }, (() => {
    const e15 = t10.Name;
    const n11 = e15.toLowerCase().indexOf(o10);
    if (F10.length || !o10 || n11 < 0) return tp.createElement("span", { className: _Oe }, e15);
    const r11 = n11 + o10.length;
    return tp.createElement("span", { className: _Oe }, e15.substring(0, n11), tp.createElement("b", null, e15.substring(n11, r11)), e15.substring(r11));
  })(), tp.createElement("span", { className: VOe }, P10))), r10 && !E10.length && !F10.length && o10 && tp.createElement("div", { className: kp(d8e, p8e("empty")) }, tp.createElement("div", { className: h8e }), tp.createElement("span", { className: m8e }, m10("components:dataPanel.dataSets.textNoMatchingFieldsFound", "No matching fields found"))), tp.createElement("div", { className: d8e }, r10 && !g10 && i8e(E10, h10, { dataSetName: n10, filter: o10, isInner: true, onToggleAttribute: (e15) => {
    if (!L6(e15)) return;
    const t11 = e15.Name;
    f10(h10 === t11 ? null : t11), y10(null);
  }, isAttributeEnabled: u10, customFieldDragItemType: p10 }), r10 && g8e(F10, g10, { dataSetName: n10, filter: o10, isInner: true, loadEntityScope: i10, onToggle: ({ Name: e15 }) => {
    f10(null), y10(g10 === e15 ? null : e15);
  }, prepareFillData: l10, prepareRelationViewModel: c10, isAttributeEnabled: u10, canDragRelation: d10, customFieldDragItemType: p10 })));
};
const g8e = (e14, t10, n10) => {
  const r10 = e14.reduce((e15, r11) => {
    const o10 = ((e16, t11, n11) => {
      const r12 = t11 === e16.Name;
      return !t11 || r12 ? __spreadValues({ relation: e16, expanded: r12 }, n11) : null;
    })(r11, t10, n10);
    return o10 && e15.push(o10), e15;
  }, []);
  return r10.map((e15) => tp.createElement(f8e, __spreadValues({ key: e15.relation.Name }, e15)));
};
const [y8e] = HOe("icon-drag");
const [, , v8e] = Dp("wd-data-item-data-set");
const [b8e] = v8e("search");
const [S8e, C8e] = v8e("fields");
const [x8e] = v8e("message");
const [w8e] = v8e("branch-line");
const [T8e] = v8e("branch-corner");
const E8e = (e14) => {
  const { semanticDataSet: t10, expanded: n10, isSemanticModelLoading: r10, loadEntityScope: o10, semanticModel: a10, onClick: i10, disableDelete: s10, onDelete: l10, disableEdit: c10, onEdit: u10, allowRebalancing: d10, customActions: p10, customCSS: m10, customFieldDragItemType: h10 } = e14;
  const f10 = J7(t10);
  const g10 = t10.Name;
  const y10 = !f10 && (d10 != null ? d10 : true);
  const { t: v10 } = vp();
  const b10 = rf(Tie);
  const S10 = rf(oh, { rotate: "180" });
  const C10 = rf(oh);
  const x10 = rf(dh);
  const w10 = rf(uh);
  const [T10, E10] = ep.useState("");
  const [F10, M10] = ep.useState(null);
  const [k10, P10] = ep.useState(null);
  const N10 = ep.useMemo(() => {
    var _a2;
    return r10 || !a10 || BV.isEmpty((_a2 = a10.entities) != null ? _a2 : {}) ? null : J6(t10, a10, y10);
  }, [r10, a10, t10, y10]);
  const [, D10, L10] = Yne({ canDrag: !f10, begin: () => $6(t10, a10)("table"), item: z6 });
  ep.useEffect(() => {
    L10(Coe(), { captureDraggingState: true });
  }), ep.useEffect(() => {
    n10 || H10();
  }, [n10]);
  const H10 = () => {
    M10(null), P10(null);
  };
  if (r10 || !a10 || !N10) return tp.createElement("div", { className: kp(MOe, kOe("data-set"), m10) }, tp.createElement("div", { className: DOe, ref: D10 }, tp.createElement("div", { className: y8e }, tp.createElement(Fm, { icon: b10 })), tp.createElement("div", { className: IOe }, tp.createElement("span", { className: _Oe }, g10), tp.createElement("span", { className: VOe }, v10("components:dataPanel.dataSets.semantic.loading", "Loading...")))));
  const I10 = (e15) => {
    if (!f10) return true;
    return t10.Fields.map((e16) => e16.Name).includes(e15.$path);
  };
  const _10 = n9(N10, T10);
  const V10 = r9(N10, k10, T10);
  const R10 = D6(N10.Attributes.length, N10.Relations.length, v10);
  const A10 = !!l10 && !s10;
  const O10 = !!u10 && !c10;
  const B10 = e9(g10, N10.Description);
  const z10 = kp(MOe, kOe("data-set"), kOe("semantic-data-set"), { [kOe("expanded")]: n10 }, m10);
  const $10 = { block: true, size: "small", rounded: true, background: "transparent" };
  return tp.createElement("div", { className: z10 }, tp.createElement("div", { className: DOe, onClick: () => {
    k10 ? H10() : i10();
  }, title: B10, ref: D10 }, tp.createElement("div", { className: y8e }, tp.createElement(Fm, { icon: b10 })), tp.createElement("div", { className: IOe }, tp.createElement("span", { className: _Oe }, g10), tp.createElement("span", { className: VOe }, R10)), tp.createElement("div", { className: ROe }, tp.createElement(jOe, { customActions: p10 }), A10 && tp.createElement(qm, __spreadProps(__spreadValues({}, $10), { icon: w10, onClick: (e15) => {
    e15.stopPropagation(), l10 == null ? void 0 : l10(e15);
  } })), O10 && tp.createElement(qm, __spreadProps(__spreadValues({}, $10), { icon: x10, title: v10("components:dataPanel.dataSets.semantic.editDataSet", "Edit Data Set..."), onClick: (e15) => {
    e15.stopPropagation(), u10 == null ? void 0 : u10(e15);
  } })), tp.createElement(qm, __spreadProps(__spreadValues({}, $10), { icon: n10 ? S10 : C10 })))), n10 && tp.createElement("div", { className: b8e }, tp.createElement("div", { className: w8e }), tp.createElement(BOe, { value: T10, placeholder: v10("components:dataPanel.dataSets.semantic.searchPlaceholder", "enter attribute or relation name here..."), onChange: (e15) => {
    E10(e15.toLowerCase());
  } })), n10 && !_10.length && !V10.length && T10 && tp.createElement("div", { className: kp(S8e, C8e("empty")) }, tp.createElement("div", { className: T8e }), tp.createElement("span", { className: x8e }, v10("components:dataPanel.dataSets.semantic.noMatchingAttributesRelationsFound", "No matching attributes or relations found"))), n10 && tp.createElement("div", { className: S8e }, !k10 && i8e(_10, F10, { dataSetName: g10, filter: T10, isInner: false, onToggleAttribute: (e15) => {
    if (!L6(e15)) return;
    const t11 = e15.Name;
    M10(F10 === t11 ? null : t11), P10(null);
  }, isAttributeEnabled: I10, customFieldDragItemType: h10 }), !k10 && ((e15, t11) => l3(e15).map((n11) => {
    const r11 = { dataSetName: e15.Name, field: n11, customFieldDragItemType: t11 };
    return tp.createElement(l8e, __spreadValues({ key: n11.Name }, r11));
  }))(t10, h10), g8e(V10, k10, { dataSetName: g10, filter: T10, isInner: false, loadEntityScope: o10, onToggle: ({ Name: e15 }) => {
    M10(null), P10(k10 === e15 ? null : e15);
  }, prepareFillData: $6(t10, a10), prepareRelationViewModel: Q6(a10, S6(t10) || "", y10), isAttributeEnabled: I10, canDragRelation: () => !f10, customFieldDragItemType: h10 })));
};
const [F8e] = Dp("wd-tablix-wizard-semantic-data-set");
const M8e = (e14) => {
  const { dataSet: t10, expanded: n10, onClick: r10, semanticModel: o10 } = e14;
  const a10 = PA();
  const i10 = { semanticDataSet: t10, expanded: n10, isSemanticModelLoading: false, loadEntityScope: (e15) => {
    const t11 = p6(e15, o10.entities);
    if (!t11) return;
    const { id: n11, name: r11, version: i11 } = o10;
    a10(f9({ id: n11, name: r11, version: i11 }, t11));
  }, semanticModel: o10, onClick: r10, disableEdit: true, allowRebalancing: false, customCSS: F8e, customFieldDragItemType: "tablix_wizard_field" };
  return tp.createElement(E8e, __spreadValues({}, i10));
};
M8e.displayName = "SemanticDataSet";
const [k8e, , P8e] = Dp("wd-tablix-wizard-data-set-panel");
const [N8e] = P8e("no-data-sets");
const D8e = (e14) => {
  const { dataSetName: t10, dataSets: n10, isFieldUsed: r10, semanticModel: o10 } = e14;
  const { t: a10 } = vp("tablixWizard");
  const [i10, s10] = ep.useState(t10 || 1 === n10.length && n10[0].Name || null);
  const l10 = (e15) => () => {
    s10(e15.Name !== i10 ? e15.Name : null);
  };
  const c10 = (e15, t11) => ({ dataSet: e15, expanded: i10 === e15.Name, index: t11, onClick: l10(e15), isFieldUsed: r10 });
  const u10 = (e15, t11, n11) => ({ dataSet: e15, expanded: i10 === e15.Name, index: t11, onClick: l10(e15), isFieldUsed: r10, semanticModel: n11 });
  const d10 = t10 ? n10.filter((e15) => e15.Name === t10) : n10;
  return tp.createElement("div", { className: k8e }, tp.createElement(bF, { direction: "vertical" }, d10.map((e15, t11) => o10 ? tp.createElement(M8e, __spreadValues({ key: e15.Name }, u10(e15, t11, o10))) : tp.createElement(Y7e, __spreadValues({ key: e15.Name }, c10(e15, t11)))), !n10.length && tp.createElement(e8e, { key: "no-data-sets", lines: [a10("textNoDataSets", "Report has no data sets."), a10("textAddDataSet", "Please add a data set to your report at first.")], customCSS: N8e })));
};
const L8e = { Type: "filter", operator: "and", items: [] };
const [H8e, , I8e] = Dp("wd-tablix-wizard-filters-panel");
const [_8e] = I8e("back-button");
const [V8e] = I8e("content");
const R8e = (e14) => {
  const { title: t10, value: n10, dataSet: r10, parentDataSet: o10, setValue: a10, onClose: i10, semanticModel: s10 } = e14;
  const { $index: { ReportParameters: l10 = [] } } = h9();
  const c10 = rf(bh, { rotate: "90" });
  const u10 = n10 != null ? n10 : __spreadValues({}, L8e);
  const d10 = "filters";
  const p10 = { [d10]: u10 };
  const m10 = { reportItem: p10, filters: u10, valuePath: d10, onSetValue: (e15, t11, n11) => {
    const r11 = j0({}, `${d10}.${LFe(e15, t11)}`, { $set: n11 });
    const o11 = AV(p10, r11);
    a10(o11[d10]);
  }, dataSet: r10, parentDataSet: o10, parameters: l10, semanticModel: s10, semanticMode: !!s10 };
  const h10 = { block: true, accent: "full", size: "small", text: t10, icon: c10, onClick: i10, customCSS: _8e };
  return tp.createElement("div", { className: H8e }, tp.createElement(qm, __spreadValues({}, h10)), tp.createElement("div", { className: V8e }, tp.createElement(bF, null, tp.createElement(lke, __spreadValues({}, m10)))));
};
const A8e = (e14, t10) => ({ value: e14, label: t10 });
const O8e = (e14, t10, n10) => ({ name: e14, expr: t10 ? `=${U1(e14, t10, null, n10)}` : `=${G1(e14, null, n10)}` });
const B8e = (e14, t10) => {
  var _a2, _b2;
  const { t: n10 } = hG();
  const r10 = n10("tablixWizard:titleFormat", "Format");
  const o10 = (_b2 = (_a2 = t10.find((t11) => t11.value === e14)) == null ? void 0 : _a2.label) != null ? _b2 : null;
  return o10 ? `${r10}: ${n10(`tablixWizard:formats.${o10}`)}` : r10;
};
const z8e = (e14, t10, n10) => {
  const r10 = ((e15) => [A8e(e15, "default"), A8e("c2", "currency"), A8e("d4", "decimal"), A8e("g15", "general"), A8e("n2", "number"), A8e("p2", "percent")])(t10);
  return { type: "dropdown", icon: Pm(_7e), title: B8e(e14, r10), isItemSelected: (t11) => t11.value === e14, items: r10.map((e15) => ((e16) => {
    const { t: t11 } = hG();
    return A8e(e16.value, t11(`tablixWizard:formats.${e16.label}`));
  })(e15)), handleAction: n10 };
};
const [$8e, W8e, j8e] = Dp("wd-tablix-wizard-drop-area");
const [Z8e, G8e] = j8e("color");
const U8e = ({ dragItemTypes: e14, canDrop: t10, onDrop: n10, shift: r10 = 0, fillArea: o10, customCSS: a10 }) => {
  const [{ isDragging: i10, isHovering: s10 }, l10] = are({ accept: e14, canDrop: t10, drop: n10, collect: (e15) => ({ isDragging: e15.canDrop(), isHovering: e15.isOver(), item: e15.getItem() }) });
  const c10 = kp($8e, { [W8e("hover")]: s10, [W8e("active")]: i10 }, a10);
  const u10 = { top: `${r10}px`, height: `calc(100% - ${r10}px)` };
  const d10 = kp(Z8e, { [G8e("line")]: !o10 });
  const p10 = o10 ? { height: u10.height } : {};
  return tp.createElement("div", { ref: l10, className: c10, style: u10 }, tp.createElement("div", { className: d10, style: p10 }));
};
const [q8e, , Y8e] = Dp("wd-tablix-wizard-tablix-area-item");
const [K8e] = Y8e("drop-area");
const [X8e, , J8e] = Dp("wd-tablix-wizard-tablix-area-item-title");
const [Q8e] = J8e("label");
const [e6e] = J8e("overlay");
const [t6e] = J8e("overlay-button");
const n6e = (e14) => {
  const { label: t10, title: n10, actions: r10, onDelete: o10, dragItem: a10, dragItemTypes: i10, canDrop: s10, onDrop: l10, customCSS: c10 } = e14;
  const { t: u10 } = vp("tablixWizard");
  const [, d10, p10] = Yne({ item: a10 });
  ep.useEffect(() => {
    p10(Coe(), { captureDraggingState: true });
  }, []);
  const m10 = (e15) => {
    const { icon: t11, title: n11, handleAction: r11 } = e15;
    return { accent: "none", size: "small", background: "transparent", icon: t11, title: n11, onClick: r11, customCSS: t6e };
  };
  const h10 = (e15) => {
    const { icon: t11, title: n11, isItemSelected: r11, items: o11, handleAction: a11 } = e15;
    return { accent: "none", size: "small", background: "transparent", hiddenChevron: true, menuWidth: "auto", icon: t11, title: n11, items: o11.map((e16) => ({ type: "button", onClick: a11, value: e16.value, text: e16.label, selected: r11(e16) })), customCSS: t6e };
  };
  const f10 = { accent: "none", size: "small", background: "transparent", icon: Pm(L7e), title: u10("titleDelete", "Delete"), onClick: o10, customCSS: t6e };
  const g10 = { dragItemTypes: i10, canDrop: s10, onDrop: l10, fillArea: false, customCSS: K8e };
  return tp.createElement("div", { ref: d10, className: kp(q8e, c10) }, tp.createElement(U8e, __spreadValues({ key: "drop-area" }, g10)), tp.createElement("div", { className: X8e }, tp.createElement("div", { key: "Label", className: Q8e, title: n10 }, t10), tp.createElement("div", { key: "Overlay", className: e6e }, r10 == null ? void 0 : r10.map((e15) => "button" === e15.type ? tp.createElement(qm, __spreadValues({ key: e15.title }, m10(e15))) : tp.createElement(UF, __spreadValues({ key: e15.title }, h10(e15)))), tp.createElement(qm, __spreadValues({ key: "Delete" }, f10)))));
};
const [r6e, o6e, a6e] = Dp("wd-tablix-wizard-tablix-value");
const [i6e] = a6e("accented");
const [s6e] = a6e("strong");
const { deleteValue: l6e, setValueAggregate: c6e, setValueDisplayAs: u6e, setValueFormat: d6e } = E7e;
const p6e = [A8e(null, "none"), A8e("Sum", "sum"), A8e("Count", "count"), A8e("Avg", "avg"), A8e("Min", "min"), A8e("Max", "max")];
const m6e = (e14, t10) => {
  var _a2, _b2;
  const n10 = t10("titleAggregate", "Aggregate");
  const r10 = (_b2 = (_a2 = p6e.find((t11) => t11.value === e14)) == null ? void 0 : _a2.label) != null ? _b2 : null;
  return r10 ? `${n10}: ${t10(`aggregates.${r10}`)}` : n10;
};
const h6e = (e14, t10, n10) => ({ type: "dropdown", icon: Pm(F7e), title: m6e(e14, n10), isItemSelected: (t11) => t11.value === e14, items: p6e.map((e15) => ((e16, t11) => {
  const { value: n11 } = e16;
  const r10 = t11(`aggregates.${e16.label}`);
  return A8e(n11, n11 && r10 !== n11 ? `${r10} - ${n11}` : r10);
})(e15, n10)), handleAction: t10 });
const f6e = [A8e(null, "default"), A8e("PercentGrandTotal", "percentGrandTotal"), A8e("PercentRowGroupTotal", "percentRowGroupTotal"), A8e("PercentParentRowGroupTotal", "percentParentRowGroupTotal"), A8e("PercentColumnGroupTotal", "percentColumnGroupTotal"), A8e("PercentParentColumnGroupTotal", "percentParentColumnGroupTotal")];
const g6e = (e14, t10) => {
  var _a2, _b2;
  const n10 = t10("titleDisplayAs", "Display As");
  const r10 = (_b2 = (_a2 = f6e.find((t11) => t11.value === e14)) == null ? void 0 : _a2.label) != null ? _b2 : null;
  return r10 ? `${n10}: ${t10(`displayAsOptions.${r10}`)}` : n10;
};
const y6e = (e14, t10, n10) => ({ type: "dropdown", icon: Pm(H7e), title: g6e(e14, n10), isItemSelected: (t11) => t11.value === e14, items: f6e.map((e15) => ((e16, t11) => {
  const { value: n11 } = e16;
  const r10 = t11(`displayAsOptions.${e16.label}`);
  return A8e(n11, r10);
})(e15, n10)), handleAction: t10 });
const v6e = ({ value: e14, index: t10, dragItemTypes: n10, canDrop: r10, onDrop: o10 }) => {
  const { field: { name: a10, expr: i10 }, aggregate: s10, displayAs: l10, format: c10, defaultFormat: u10 } = e14;
  const { t: d10 } = vp("tablixWizard");
  const { rdlx: { reportItemsFeatures: { tablix: { crossAggregates: p10 } } } } = MO();
  const m10 = PA();
  const h10 = (e15) => {
    const n11 = c6e(e15, t10);
    m10(n11);
  };
  const f10 = (e15) => {
    const n11 = u6e(e15, t10);
    m10(n11);
  };
  const g10 = [z8e(c10, u10, (e15) => {
    const n11 = d6e(e15, t10);
    m10(n11);
  })];
  (l10 || A1(i10) || E1(i10)) && (p10 && g10.unshift(y6e(l10, f10, d10)), g10.unshift(h6e(s10, h10, d10)));
  const y10 = { type: "tablix_wizard_value", index: t10 };
  const v10 = `<${d10("placeholderNoField", "no field")}>`;
  let b10 = null;
  let S10 = "";
  iJe(l10) && (b10 = tp.createElement(tp.Fragment, null, "\xA0", tp.createElement("span", { key: "percent", className: i6e }, "%")), S10 = " %");
  const C10 = { label: s10 ? tp.createElement(tp.Fragment, null, tp.createElement("span", { key: "aggregate", className: i6e }, s10), "\xA0", tp.createElement("span", { key: "name" }, `(${a10})`), b10) : a10 || tp.createElement("span", { key: "no-field", className: s6e }, v10), title: s10 ? `${s10} (${a10})${S10}` : a10 || v10, actions: g10, onDelete: () => {
    const e15 = l6e(t10);
    m10(e15);
  }, dragItem: y10, dragItemTypes: n10, canDrop: r10, onDrop: o10, customCSS: kp(r6e, { [o6e("wide")]: 1 === g10.length }) };
  return tp.createElement(n6e, __spreadValues({}, C10));
};
const [b6e, , S6e] = Dp("wd-tablix-wizard-tablix-area");
const [C6e] = S6e("drop-area");
const x6e = (e14) => {
  const { itemsCount: t10, dragItemTypes: n10, canDrop: r10, onDrop: o10, customCSS: a10, children: i10 } = e14;
  const s10 = { dragItemTypes: n10, canDrop: r10, onDrop: o10, shift: 40 * t10, fillArea: 0 === t10, customCSS: C6e };
  return tp.createElement("div", { className: kp(b6e, a10) }, tp.createElement(bF, { direction: "vertical" }, i10, tp.createElement(U8e, __spreadValues({ key: "base-drop-area" }, s10))));
};
const [w6e, , T6e] = Dp("wd-tablix-wizard-tablix-body");
const [E6e] = T6e("no-values");
const { addValue: F6e, moveValue: M6e } = E7e;
const k6e = ({ values: e14 }) => {
  const t10 = PA();
  const { t: n10 } = vp("tablixWizard");
  const r10 = (e15) => (t11) => {
    switch (t11.type) {
      case "tablix_wizard_field":
        return true;
      case "tablix_wizard_value": {
        const { index: n11 } = t11;
        return n11 !== (e15 > n11 ? e15 - 1 : e15);
      }
      default:
        return false;
    }
  };
  const o10 = (e15) => (n11) => {
    switch (n11.type) {
      case "tablix_wizard_field": {
        const { field: { value: r11, variationFormat: o11, aggregate: a11 }, format: i11, dataSetName: s11 } = n11;
        const l10 = __spreadProps(__spreadValues({}, O8e(r11, o11, o11 ? null : a11)), { aggregate: a11, defaultFormat: i11 });
        return t10(F6e(l10, e15, s11)), {};
      }
      case "tablix_wizard_value": {
        const { index: r11 } = n11;
        return t10(M6e(r11, e15)), {};
      }
      default:
        return;
    }
  };
  const a10 = ["tablix_wizard_field", "tablix_wizard_value"];
  const i10 = { itemsCount: e14.length, dragItemTypes: a10, canDrop: r10(e14.length), onDrop: o10(e14.length), customCSS: w6e };
  const s10 = (e15, t11) => ({ value: e15, index: t11, dragItemTypes: a10, canDrop: r10(t11), onDrop: o10(t11) });
  return tp.createElement(x6e, __spreadValues({}, i10), e14.map((e15, t11) => tp.createElement(v6e, __spreadValues({ key: `${e15.field.name}-${t11}` }, s10(e15, t11)))), !e14.length && tp.createElement(e8e, { key: "no-values", lines: [n10("textNoValues", "There are no values specified."), n10("textAddValue", "Please add at least a single value to create a Tablix.")], customCSS: E6e }));
};
const [P6e] = Dp("wd-tablix-wizard-tablix-group");
const { deleteRowGroup: N6e, deleteColumnGroup: D6e, setRowGroupSortingType: L6e, setColumnGroupSortingType: H6e, setRowGroupFormat: I6e, setColumnGroupFormat: _6e, editFilters: V6e } = E7e;
const R6e = { None: O7e, Ascending: B7e, Descending: z7e };
const A6e = Object.keys(R6e);
const O6e = (e14, t10) => t10(`sortings.${e14}`);
const B6e = (e14, t10, n10) => ({ type: "dropdown", icon: Pm(R6e[e14]), title: n10("titleSorting", "Sorting: {{sorting}}", { sorting: O6e(e14, n10) }), isItemSelected: (t11) => t11.value === e14, items: A6e.map((e15) => A8e(e15, O6e(e15, n10))), handleAction: t10 });
const z6e = (e14, t10) => ({ type: "button", icon: Pm(I7e), title: t10("filters.titleEditGroupFilters", "Edit Group Filters..."), handleAction: e14 });
const $6e = ({ type: e14, group: t10, index: n10, dragItemTypes: r10, canDrop: o10, onDrop: a10 }) => {
  var _a2;
  const { field: { name: i10 }, name: s10, sorting: l10, format: c10, defaultFormat: u10 } = t10;
  const { t: d10 } = vp("tablixWizard");
  const p10 = PA();
  const m10 = { type: "tablix_wizard_group", hierarchyType: e14, index: n10 };
  const h10 = i10 || s10;
  const f10 = { label: h10, title: h10, actions: [z6e(() => {
    p10(V6e({ type: e14, index: n10 }));
  }, d10), B6e((_a2 = l10 == null ? void 0 : l10.direction) != null ? _a2 : "None", (t11) => {
    const r11 = ("row" === e14 ? L6e : H6e)(t11, n10);
    p10(r11);
  }, d10), z8e(c10, u10, (t11) => {
    const r11 = ("row" === e14 ? I6e : _6e)(t11, n10);
    p10(r11);
  })], onDelete: () => {
    const t11 = ("row" === e14 ? N6e : D6e)(n10);
    p10(t11);
  }, dragItem: m10, dragItemTypes: r10, canDrop: o10, onDrop: a10, customCSS: P6e };
  return tp.createElement(n6e, __spreadValues({}, f10));
};
const [W6e] = Dp("wd-tablix-wizard-tablix-hierarchy");
const { addRowGroup: j6e, addColumnGroup: Z6e, moveRowGroup: G6e, moveColumnGroup: U6e } = E7e;
const q6e = ({ type: e14, groups: t10 }) => {
  const n10 = PA();
  const r10 = (t11) => (n11) => {
    switch (n11.type) {
      case "tablix_wizard_field": {
        const { isAggregate: e15 } = n11;
        return !e15;
      }
      case "tablix_wizard_group": {
        const { hierarchyType: r11, index: o11 } = n11;
        if (r11 !== e14) return true;
        return o11 !== (t11 > o11 ? t11 - 1 : t11);
      }
      default:
        return false;
    }
  };
  const o10 = (t11) => (r11) => {
    switch (r11.type) {
      case "tablix_wizard_field": {
        const { field: { value: o11, variationFormat: a11 }, format: i11, dataSetName: s11 } = r11;
        const l10 = "row" === e14 ? j6e : Z6e;
        const c10 = __spreadProps(__spreadValues({}, O8e(o11, a11)), { defaultFormat: i11 });
        return n10(l10(c10, t11, s11)), {};
      }
      case "tablix_wizard_group": {
        const { hierarchyType: o11, index: a11 } = r11;
        return n10(("row" === o11 ? G6e : U6e)(a11, e14, t11)), {};
      }
      default:
        return;
    }
  };
  const a10 = ["tablix_wizard_field", "tablix_wizard_group"];
  const i10 = { itemsCount: t10.length, dragItemTypes: a10, canDrop: r10(t10.length), onDrop: o10(t10.length), customCSS: W6e };
  const s10 = (t11, n11) => ({ type: e14, group: t11, index: n11, dragItemTypes: a10, canDrop: r10(n11), onDrop: o10(n11) });
  return tp.createElement(x6e, __spreadValues({}, i10), t10.map((e15, t11) => tp.createElement($6e, __spreadValues({ key: `${e15.field.name}-${t11}` }, s10(e15, t11)))));
};
const [Y6e, , K6e] = Dp("wd-tablix-wizard-integer-editor");
const [X6e] = K6e("title-container");
const [J6e] = K6e("title");
const [Q6e] = K6e("input-container");
const [e9e] = K6e("input");
const [t9e, n9e] = K6e("command-button");
const r9e = (e14) => e14.stopPropagation();
const o9e = ({ value: e14, title: t10, onChange: n10, range: r10, dataAid: o10, customCSS: a10 }) => {
  const [i10, s10] = ep.useState(e14);
  const l10 = (e15) => {
    n10(e15), s10(e15);
  };
  const c10 = (e15) => (t11) => {
    r9e(t11);
    const n11 = e15(i10);
    ((e16) => {
      const t12 = parseInt(e16, 10);
      return !Number.isNaN(t12) && t12 >= r10.min && t12 <= r10.max;
    })(n11) && l10(n11);
  };
  const u10 = { icon: Pm(Im), size: "small", onClick: c10((e15) => e15 - 1), disabled: i10 <= r10.min, customCSS: kp(t9e, n9e("left")) };
  const d10 = { icon: Pm(_m), size: "small", onClick: c10((e15) => e15 + 1), disabled: i10 >= r10.max, customCSS: kp(t9e, n9e("right")) };
  const p10 = kp(Y6e, a10);
  return tp.createElement("div", { className: p10, onClick: r9e, onMouseDown: r9e, "data-aid": o10 }, tp.createElement("div", { key: "title-container", className: X6e }, tp.createElement("span", { className: J6e }, t10)), tp.createElement("div", { key: "input-container", className: Q6e }, tp.createElement(qm, __spreadValues({ key: "left-button" }, u10)), tp.createElement("input", { key: "input", className: e9e, value: i10, title: `${i10}`, maxLength: 8, onChange: (e15) => {
    const t11 = e15.target.value;
    if (!t11) return void l10(0);
    const n11 = parseInt(t11, 10);
    Number.isNaN(n11) || l10(((e16) => e16 < r10.min ? r10.min : e16 > r10.max ? r10.max : e16)(n11));
  }, onKeyDown: r9e, onClick: r9e, onContextMenu: r9e }), tp.createElement(qm, __spreadValues({ key: "right-button" }, d10))));
};
const [a9e, , i9e] = Dp("wd-tablix-wizard-organization-options");
const [s9e] = i9e("frozen-editor");
const l9e = ({ value: e14, title: t10, onChange: n10 }) => {
  const r10 = { value: e14, title: t10, onChange: n10, range: { min: 0, max: 100 }, dataAid: t10, customCSS: s9e };
  return tp.createElement(o9e, __spreadValues({}, r10));
};
const c9e = /* @__PURE__ */ new Map();
c9e.set("expandCollapseGroups", E7e.toggleExpandCollapseGroups), c9e.set("collapsedGroups", E7e.toggleCollapsedGroups), c9e.set("enableUserSort", E7e.toggleEnableUserSort), c9e.set("steppedRowGroups", E7e.toggleSteppedRowGroups);
const u9e = ({ features: e14, isFpl: t10, frozenRows: n10, frozenColumns: r10, customCSS: o10 }) => {
  const { expandCollapseGroups: a10, collapsedGroups: i10, enableUserSort: s10, steppedRowGroups: l10 } = e14;
  const { t: c10 } = vp("tablixWizard");
  const { rdlx: { reportItemsFeatures: { tablix: { hideFrozenRowsColumns: u10 } } } } = MO();
  const d10 = PA();
  const p10 = (e15, t11, n11) => {
    return { id: e15, checked: t11, text: n11, onChange: (r11 = e15, () => {
      const e16 = c9e.get(r11);
      e16 && d10(e16());
    }), dataAid: n11 };
    var r11;
  };
  const m10 = { type: "checkboxes", size: "small", items: [p10("expandCollapseGroups", a10, c10("labelExpandCollapse", "Expand/Collapse Groups"))] };
  const h10 = { type: "checkboxes", size: "small", items: [p10("collapsedGroups", i10, c10("labelCollapsedGroups", "Collapsed Groups"))], disabled: !a10 };
  const f10 = { type: "checkboxes", size: "small", items: [p10("enableUserSort", s10, c10("labelUserSortEnabled", "Enable User Sort")), p10("steppedRowGroups", l10, c10("labelSteppedRowGroups", "Stepped Row Groups"))] };
  const g10 = { value: n10, title: c10("labelFrozenRows", "Frozen Rows"), onChange: (e15) => {
    d10(E7e.setFrozenRows(e15));
  } };
  const y10 = { value: r10, title: c10("labelFrozenColumns", "Frozen Columns"), onChange: (e15) => {
    d10(E7e.setFrozenColumns(e15));
  } };
  const v10 = kp(a9e, o10);
  return tp.createElement("div", { className: v10 }, tp.createElement(rI, __spreadValues({ key: "ExpandCollapseGroups" }, m10)), tp.createElement(rI, __spreadValues({ key: "CollapsedGroups" }, h10)), tp.createElement(rI, __spreadValues({ key: "OtherOptions" }, f10)), !t10 && !u10 && [tp.createElement(l9e, __spreadValues({ key: "FrozenRows" }, g10)), tp.createElement(l9e, __spreadValues({ key: "FrozenColumns" }, y10))]);
};
const [d9e] = Dp("wd-tablix-wizard-styling-options");
const p9e = ({ styles: e14, currentStyle: t10, customCSS: n10 }) => {
  const { t: r10 } = vp("tablixWizard");
  const o10 = PA();
  const a10 = (t11) => {
    const n11 = t11 ? E7e.setTablixStyle(t11, e14.find((e15) => e15.id === t11).name) : E7e.clearTablixStyle();
    o10(n11);
  };
  const i10 = (e15) => t10 ? e15 === t10.id : !e15;
  const s10 = (e15, t11) => ({ id: t11, checked: i10(t11), value: t11, text: e15, onChange: a10, dataAid: e15 });
  const l10 = { type: "radios", size: "small", items: [s10(r10("labelNone", "None")), ...e14.map((e15) => s10(e15.name, e15.id))], dataAid: "tablix-wizard-styles-list" };
  const c10 = kp(d9e, n10);
  return tp.createElement("div", { className: c10 }, tp.createElement(bF, { direction: "vertical" }, tp.createElement(rI, __spreadValues({}, l10))));
};
const [m9e] = Dp("wd-tablix-wizard-totals-options");
const h9e = /* @__PURE__ */ new Map();
h9e.set("totalsForRows", E7e.toggleRowTotals), h9e.set("subTotalsForRows", E7e.toggleRowSubtotals), h9e.set("totalsForColumns", E7e.toggleColumnTotals), h9e.set("subTotalsForColumns", E7e.toggleColumnSubtotals), h9e.set("showTotalsBeforeGroup", E7e.toggleShowTotalsBeforeGroup);
const f9e = ({ totals: e14, customCSS: t10 }) => {
  const { totalsForRowGroups: n10, subtotalsForRowGroups: r10, totalsForColumnGroups: o10, subtotalsForColumnGroups: a10, showTotalsBeforeGroup: i10 } = e14;
  const { t: s10 } = vp("tablixWizard");
  const l10 = PA();
  const c10 = (e15, t11, n11) => {
    return { id: e15, checked: t11, text: n11, onChange: (r11 = e15, () => {
      const e16 = h9e.get(r11);
      e16 && l10(e16());
    }), dataAid: n11 };
    var r11;
  };
  const u10 = { type: "checkboxes", size: "small", items: [c10("totalsForRows", n10, s10("labelTotalsForRows", "Totals for Row Groups")), c10("subTotalsForRows", r10, s10("labelSubTotalsForRows", "Subtotals for Row Groups")), c10("totalsForColumns", o10, s10("labelTotalsForColumns", "Totals for Column Groups")), c10("subTotalsForColumns", a10, s10("labelSubTotalsForColumns", "Subtotals for Column Groups")), c10("showTotalsBeforeGroup", i10, s10("labelShowTotalsBeforeGroup", "Show Totals before Groups"))], dataAid: "tablix-wizard-totals-options" };
  const d10 = kp(m9e, t10);
  return tp.createElement("div", { className: d10 }, tp.createElement(rI, __spreadValues({}, u10)));
};
const [g9e, , y9e] = Dp("wd-tablix-wizard-layout-options");
const [v9e] = y9e("tabs");
const [b9e] = y9e("content");
const S9e = (e14, t10) => ({ id: e14, text: t10 });
const C9e = (e14) => {
  const { totals: t10, features: n10, styles: r10, currentStyle: o10, isFpl: a10, frozenRows: i10, frozenColumns: s10 } = e14;
  const { t: l10 } = vp("tablixWizard");
  const [c10, u10] = ep.useState("totals");
  const d10 = { selectedTabId: c10, onTabSelect: (e15) => {
    u10(e15);
  }, tabs: [S9e("totals", l10("btnTotals", "Totals")), S9e("styling", l10("btnStyling", "Styling")), S9e("organization", l10("btnOrganization", "Organization"))], design: "simplified", size: "small", block: true, align: "justify", dataAid: "tablix-wizard-layout-options-tabs", customCSS: v9e };
  return tp.createElement("div", { className: g9e }, tp.createElement(IM, __spreadValues({ key: "Tabs" }, d10)), ((e15) => {
    const l11 = b9e;
    switch (e15) {
      case "totals": {
        const e16 = { totals: t10, customCSS: l11 };
        return tp.createElement(f9e, __spreadValues({ key: "Totals" }, e16));
      }
      case "styling": {
        const e16 = { styles: r10, currentStyle: o10, customCSS: l11 };
        return tp.createElement(p9e, __spreadValues({ key: "Styling" }, e16));
      }
      case "organization": {
        const e16 = { features: n10, isFpl: a10, frozenRows: i10, frozenColumns: s10, customCSS: l11 };
        return tp.createElement(u9e, __spreadValues({ key: "Organization" }, e16));
      }
      default:
        return null;
    }
  })(c10));
};
const [x9e, w9e, T9e] = Dp("wd-tablix-wizard-tablix-filters");
const [E9e] = T9e("icon");
const [F9e] = T9e("label");
const [M9e, , k9e] = Dp("wd-tablix-wizard-layout");
const [P9e] = k9e("column");
const [N9e] = k9e("as-rows-toggle");
const [D9e, L9e, H9e] = Dp("wd-tablix-wizard-row-column-swap");
const [I9e] = H9e("icon");
const [_9e] = H9e("label");
const [V9e, R9e, A9e] = Dp("wd-tablix-wizard-layout-cell");
const [O9e] = A9e("header");
const [B9e] = A9e("header-icon");
const [z9e] = A9e("header-label");
const $9e = (e14) => {
  const { modifierName: t10, name: n10, icon: r10, children: o10 } = e14;
  const a10 = kp(V9e, R9e(t10));
  return tp.createElement("div", { className: a10 }, tp.createElement("div", { className: O9e }, tp.createElement(Fm, { icon: r10, customCSS: B9e }), tp.createElement("span", { className: z9e }, n10)), o10);
};
const W9e = ({ canEdit: e14 }) => {
  const { t: t10 } = vp("tablixWizard");
  const n10 = PA();
  const r10 = e14 ? () => {
    n10(E7e.editFilters({ type: "tablix" }));
  } : void 0;
  const o10 = kp(x9e, { [w9e("disabled")]: !e14 });
  const a10 = kp(E9e, "wd-svg");
  const i10 = t10("filters.textFilters", "Filters");
  const s10 = t10("filters.titleEditTablixFilters", "Edit Tablix Filters...");
  return tp.createElement("div", { className: o10, title: s10, onClick: r10 }, tp.createElement("span", { className: F9e }, i10), tp.createElement(Fm, { icon: Pm(I7e), customCSS: a10 }));
};
const j9e = ({ canSwap: e14 }) => {
  const { t: t10 } = vp("tablixWizard");
  const n10 = PA();
  const r10 = e14 ? () => {
    n10(E7e.swapHierarchies());
  } : void 0;
  const o10 = kp(D9e, { [L9e("disabled")]: !e14 });
  const a10 = kp(I9e, "wd-svg");
  const i10 = t10("textSwap", "Swap");
  return tp.createElement("div", { className: o10, title: t10("titleSwapRowColumnGroups", "Swap Row/Column Groups"), onClick: r10 }, tp.createElement("span", { className: _9e }, i10), tp.createElement(Fm, { icon: Pm($7e), customCSS: a10 }));
};
const Z9e = ({ value: e14 }) => {
  const { t: t10 } = vp("tablixWizard");
  const n10 = PA();
  const r10 = { checked: e14, block: true, textAlign: "left", size: "small", text: t10("textAsRows", "As Rows"), title: t10("textShowValuesAsRows", "Show Values as Rows"), onToggle: () => {
    n10(E7e.toggleShowValuesAsRows());
  }, dataAid: "show-values-as-rows-toggle", customCSS: N9e };
  return tp.createElement(SM, __spreadValues({}, r10));
};
const G9e = ({ wizardModel: e14, tablixStyles: t10 }) => {
  const { layoutOptions: { totals: n10, features: r10 }, style: o10, isFpl: a10, frozenRows: i10, frozenColumns: s10, rowGroups: l10, columnGroups: c10, values: u10, dataSetName: d10 } = e14;
  const { t: p10 } = vp("tablixWizard");
  const { showValuesAsRows: m10 } = r10;
  const h10 = { type: "row", groups: l10 };
  const f10 = { type: "column", groups: c10 };
  const g10 = { values: u10 };
  const y10 = { totals: n10, features: r10, styles: t10, currentStyle: o10, isFpl: a10, frozenRows: i10, frozenColumns: s10 };
  const v10 = l10.length > 0 || c10.length > 0;
  return tp.createElement("div", { className: M9e }, tp.createElement("div", { className: P9e }, tp.createElement(W9e, { key: "Filters", canEdit: !!d10 }), tp.createElement($9e, { key: "Layout", name: p10("textLayoutOptions", "Layout Options"), icon: Pm(R7e), modifierName: "left" }, tp.createElement(C9e, __spreadValues({}, y10))), tp.createElement(j9e, { key: "Swap", canSwap: v10 }), tp.createElement($9e, { key: "Rows", name: p10("textRowGroups", "Row Groups"), icon: Pm(A7e), modifierName: "left" }, tp.createElement(q6e, __spreadValues({}, h10)))), tp.createElement("div", { className: P9e }, tp.createElement($9e, { key: "Columns", name: p10("textColumns", "Column Groups"), icon: Pm(D7e), modifierName: "right" }, tp.createElement(q6e, __spreadValues({}, f10))), tp.createElement(Z9e, { key: "AsRows", value: m10 }), tp.createElement($9e, { key: "Values", name: p10("textValues", "Values"), icon: Pm(W7e), modifierName: "right" }, tp.createElement(k6e, __spreadValues({}, g10)))));
};
const U9e = (e14) => (t10) => {
  const { rowGroups: n10, columnGroups: r10, values: o10 } = e14;
  const a10 = [...n10.map((e15) => e15.field.name), ...r10.map((e15) => e15.field.name), ...o10.map((e15) => e15.field.name)];
  return a10.includes(t10);
};
const q9e = (e14, t10, n10) => {
  if ("tablix" === t10.type) return n10("tablixWizard:filters.headingTablixFilters", "Tablix Filters");
  const r10 = ("column" === t10.type ? e14.columnGroups : e14.rowGroups)[t10.index];
  return n10("tablixWizard:filters.headingGroupFilters", "Group Filters \u2013 {{groupLabel}}", { groupLabel: r10.field.name || r10.name });
};
const Y9e = (e14, t10) => {
  var _a2, _b2, _c2, _d2, _e2;
  if ("tablix" === t10.type) return (_b2 = (_a2 = e14.$summary) == null ? void 0 : _a2.tablixProps) == null ? void 0 : _b2.Filters;
  const n10 = "column" === t10.type ? e14.columnGroups : e14.rowGroups;
  return (_e2 = (_d2 = (_c2 = n10[t10.index].$summary) == null ? void 0 : _c2.memberProps) == null ? void 0 : _d2.Group) == null ? void 0 : _e2.Filters;
};
const [K9e, , X9e] = Dp("wd-tablix-wizard");
const [J9e] = X9e("body");
const [Q9e] = X9e("layout-container");
const [eet] = X9e("layout-overlay");
const [tet] = X9e("data-set-panel-container");
const net = (e14) => {
  const { tablixStyles: t10, getTablixStyleContent: n10, stateSelector: r10, report: o10, path: a10, semanticModel: i10 } = e14;
  const { closeDialog: s10, openDialog: l10, dispatch: c10 } = RA();
  const { wizardModel: u10, prevWizardModel: d10, dirty: p10, warning: m10, filters: h10, parentDataSetName: f10 } = LA(r10);
  const { instanceId: g10 } = Uae();
  const { t: y10 } = vp();
  const [v10, b10] = ep.useState(false);
  const { name: S10, dataSetName: C10 } = u10 || { name: "", dataSetName: "" };
  const { DataSets: x10 = [] } = o10;
  if (ep.useEffect(() => {
    m10 && !v10 && (l10("tablixWizardWarning", { name: S10, warning: m10, onConfirm: () => {
      c10(E7e.clearWarning()), b10(false);
    }, onCancel: () => {
      s10(), c10(E7e.resetTablixWizard()), b10(false);
    } }), b10(true));
  }, [s10, c10, S10, m10, v10]), !u10) return c10(E7e.initTablixWizard(o10, a10)), null;
  const w10 = () => {
    c10(E7e.resetTablixWizard()), s10();
  };
  const T10 = 0 === x10.length;
  const E10 = T10 || !p10 || 0 === u10.values.length;
  const F10 = T10;
  const M10 = [{ text: y10("common:btnOk", "OK"), accent: "full", onClick: () => {
    const e15 = [];
    if (p10) {
      const t11 = _3e(g10, o10, a10, d10, n10)(u10);
      e15.push(c5(a10, t11.Type), QG(lj(t11)));
    }
    e15.push(c5(`${a10}.Body.Rows.0.Cells.0.Item`)), c10(rz(e15)), w10();
  }, disabled: E10, dataAid: "tablix-wizard-ok-button" }, { text: y10("common:btnCancel", "Cancel"), accent: "none", onClick: w10, disabled: false, dataAid: "tablix-wizard-cancel-button" }];
  const k10 = { open: true, title: S10, subtitle: y10("tablixWizard:headingTablixWizard", "Tablix Wizard"), controls: { align: "right", buttons: M10 }, onClose: w10, style: { content: { width: "900px", transform: "none", left: "calc(50% - 450px)" } }, dataAid: "tablix-wizard-dialog", customCSS: kp(K9e, "gcs-zi"), shouldCloseOnOverlayClick: false };
  const P10 = { wizardModel: u10, tablixStyles: t10 };
  const N10 = { dataSetName: C10, dataSets: x10, isFieldUsed: U9e(u10), semanticModel: i10 };
  const D10 = x10.find((e15) => e15.Name === C10);
  const L10 = x10.find((e15) => e15.Name === f10);
  const H10 = D10 && h10 ? { title: q9e(u10, h10.location, y10), value: Y9e(u10, h10.location), dataSet: D10, parentDataSet: L10, setValue: (e15) => {
    c10(E7e.setFilters(e15));
  }, onClose: () => {
    c10(E7e.closeFilters());
  }, semanticModel: i10 } : null;
  return tp.createElement(Hk, __spreadValues({}, k10), tp.createElement("div", { className: J9e }, tp.createElement("div", { className: Q9e }, F10 && tp.createElement("div", { className: eet }), tp.createElement("h2", null, y10("tablixWizard:headingLayoutDesign", "Layout Design")), H10 ? tp.createElement(R8e, __spreadValues({}, H10)) : tp.createElement(G9e, __spreadValues({}, P10))), tp.createElement("div", { className: tet }, tp.createElement("h2", null, y10("tablixWizard:headingDataSets", "Data Sets")), tp.createElement(D8e, __spreadValues({}, N10)))));
};
const ret = (e14) => {
  const { reportStyles: t10, report: n10, stateSelector: r10, path: o10 } = e14;
  const a10 = A$();
  const i10 = (t10 || []).filter((e15) => e15.targetTypes.some((e16) => "Tablix" === e16));
  const s10 = { tablixStyles: i10.map(({ id: e15, name: t11 }) => ({ id: e15, name: t11 })), getTablixStyleContent: (e15) => {
    var _a2;
    if (null === e15) return null;
    const t11 = i10.find((t12) => e15.id === t12.id || e15.name === t12.name);
    return (_a2 = t11 == null ? void 0 : t11.content) != null ? _a2 : null;
  }, report: n10, stateSelector: r10, path: o10, semanticModel: b6(n10) ? a10 : null };
  return tp.createElement(net, __spreadValues({}, s10));
};
const [oet, , aet] = Dp("wd-tablix-wizard-warning");
const [iet] = aet("body");
const [set] = aet("icon");
const [cet] = aet("msg");
const uet = (e14) => {
  const { name: t10, warning: n10, onConfirm: r10, onCancel: o10 } = e14;
  const { closeDialog: a10 } = RA();
  const { t: i10 } = vp("tablixWizard");
  const s10 = () => {
    a10(), o10();
  };
  const l10 = [{ text: i10("warning.btnRevert", "Revert"), accent: "full", onClick: () => {
    a10(), r10();
  }, dataAid: "tablix-wizard-warning-revert-button" }, { text: i10("warning.btnQuit", "Quit"), accent: "none", onClick: s10, dataAid: "tablix-wizard-warning-quit-button" }];
  const c10 = { open: true, level: "warning", title: t10, subtitle: i10("warning.headingWarning", "Warning"), controls: { align: "right", buttons: l10 }, onClose: s10, style: { content: { width: "600px", transform: "none", left: "calc(50% - 300px)", top: "25%" } }, dataAid: "tablix-wizard-warning-dialog", customCSS: oet, shouldCloseOnOverlayClick: false };
  const u10 = n10.split("\n").reduce((e15, t11, n11) => 0 === n11 ? [t11] : [...e15, tp.createElement("br", { key: n11 }), t11], []);
  return tp.createElement(Hk, __spreadValues({}, c10), tp.createElement("div", { className: iet }, tp.createElement(Fm, { icon: Pm(j7e), customCSS: kp("wd-svg", set) }), tp.createElement("span", { className: cet }, u10)));
};
const det = (e14, t10) => {
  const [n10, r10] = [[], []];
  const o10 = `${t10}.`;
  return (e14.$index.NamedItems || []).forEach(({ type: e15, name: t11, $path: a10 }) => {
    (a10 != null ? a10 : "").startsWith(o10) || ("grouping" === e15 ? r10 : n10).push(t11);
  }), { reportItemNames: n10, groupNames: r10 };
};
const pet = { $apply: (e14) => !e14 };
const met = (e14) => ({ $splice: [[e14, 1]] });
const het = (e14) => ({ $apply: (t10) => t10.filter((t11) => t11 !== e14) });
const fet = (e14) => ({ $push: [e14] });
const get = (e14, t10) => ({ $splice: [[t10, 0, e14]] });
const yet = (e14, t10) => ({ [t10]: { format: { $set: e14 } } });
const vet = (e14, t10) => ({ [t10]: { format: { $set: e14 } } });
const bet = (e14, t10) => {
  const { sorting: n10, field: { expr: r10 } } = e14;
  if (!n10 && "None" === t10 || (n10 == null ? void 0 : n10.direction) === t10) return null;
  switch (t10) {
    case "None":
      return { $set: null };
    case "Ascending":
    case "Descending":
      return { $set: { value: n10 ? n10.value : r10, direction: t10 } };
    default:
      return null;
  }
};
const { deleteRowGroup: Cet, deleteColumnGroup: xet, deleteValue: wet, insertRowGroup: Tet, insertColumnGroup: Eet, insertValue: Fet, clearDataSetName: Met, setDataSetName: ket, closeFilters: Pet } = E7e;
const Net = { report: null, path: null, wizardModel: null, prevWizardModel: null, reportItemNames: [], groupNames: [], dirty: false, warning: null, filters: null, parentDataSetName: null };
const Det = (e14) => {
  const t10 = (n11 = Net, r11) => {
    var _a2, _b2, _c2;
    switch (r11 == null ? void 0 : r11.type) {
      case V3e: {
        const { report: t11, path: n12 } = r11.payload;
        const o11 = V5(t11, c5(n12, "multisectionreport" === t11.Type ? "tablix" : "fixedpagetablix"));
        const a10 = oJe(o11, n12);
        if (!a10) throw new Error(`There must be a valid Tablix at path '${n12}'!`);
        const { reportItemNames: i10, groupNames: s10 } = det(o11, n12);
        const { wizardModel: l10, synthesized: c10, warning: u10 } = ZJe(e14, a10, { reportItemNames: i10, groupNames: s10 });
        const d10 = [...i10, ...l10.rowGroups.map((e15) => e15.itemName), ...l10.columnGroups.map((e15) => e15.itemName), ...l10.values.map((e15) => e15.itemName)];
        const p10 = [...s10, ...l10.rowGroups.map((e15) => e15.name), ...l10.columnGroups.map((e15) => e15.name)];
        return { report: o11, path: n12, wizardModel: l10, prevWizardModel: c10 || u10 ? null : l10, reportItemNames: d10, groupNames: p10, dirty: false, warning: u10, filters: null, parentDataSetName: see(o11).parentDataSetName || null };
      }
      case R3e:
        return Net;
      case A3e:
        return AV(n11, { wizardModel: { dataSetName: { $set: "" } } });
      case O3e: {
        const { dataSetName: e15 } = r11.payload;
        return ((_a2 = n11.wizardModel) == null ? void 0 : _a2.dataSetName) === e15 ? n11 : AV(n11, { wizardModel: { dataSetName: { $set: e15 } } });
      }
      case B3e:
        return AV(n11, { wizardModel: { style: { $set: null } } });
      case z3e: {
        const { id: e15, name: t11 } = r11.payload;
        return AV(n11, { wizardModel: { style: { $set: { id: e15, name: t11 } } } });
      }
      case $3e: {
        const { count: e15 } = r11.payload;
        return AV(n11, { wizardModel: { frozenRows: { $set: e15 } } });
      }
      case W3e: {
        const { count: e15 } = r11.payload;
        return AV(n11, { wizardModel: { frozenColumns: { $set: e15 } } });
      }
      case j3e: {
        const { rowGroups: e15, columnGroups: t11 } = n11.wizardModel;
        return AV(n11, { wizardModel: { rowGroups: { $set: t11 }, columnGroups: { $set: e15 } } });
      }
      case Z3e: {
        const { expandCollapseGroups: e15, collapsedGroups: t11 } = n11.wizardModel.layoutOptions.features;
        let r12 = { expandCollapseGroups: pet };
        return e15 && t11 && (r12 = __spreadProps(__spreadValues({}, r12), { collapsedGroups: pet })), AV(n11, { wizardModel: { layoutOptions: { features: r12 } } });
      }
      case G3e:
        return AV(n11, { wizardModel: { layoutOptions: { features: { collapsedGroups: pet } } } });
      case U3e:
        return AV(n11, { wizardModel: { layoutOptions: { features: { enableUserSort: pet } } } });
      case q3e:
        return AV(n11, { wizardModel: { layoutOptions: { features: { steppedRowGroups: pet } } } });
      case Y3e:
        return AV(n11, { wizardModel: { layoutOptions: { features: { showValuesAsRows: pet } } } });
      case K3e:
        return AV(n11, { wizardModel: { layoutOptions: { totals: { totalsForRowGroups: pet } } } });
      case X3e:
        return AV(n11, { wizardModel: { layoutOptions: { totals: { totalsForColumnGroups: pet } } } });
      case J3e:
        return AV(n11, { wizardModel: { layoutOptions: { totals: { subtotalsForRowGroups: pet } } } });
      case Q3e:
        return AV(n11, { wizardModel: { layoutOptions: { totals: { subtotalsForColumnGroups: pet } } } });
      case e7e:
        return AV(n11, { wizardModel: { layoutOptions: { totals: { showTotalsBeforeGroup: pet } } } });
      case t7e: {
        const { index: e15 } = r11.payload;
        const { name: t11, itemName: o11 } = n11.wizardModel.rowGroups[e15];
        return AV(n11, { wizardModel: { rowGroups: met(e15) }, reportItemNames: het(o11), groupNames: het(t11) });
      }
      case n7e: {
        const { index: e15 } = r11.payload;
        const { name: t11, itemName: o11 } = n11.wizardModel.columnGroups[e15];
        return AV(n11, { wizardModel: { columnGroups: met(e15) }, reportItemNames: het(o11), groupNames: het(t11) });
      }
      case r7e: {
        const { index: e15 } = r11.payload;
        const { itemName: t11 } = n11.wizardModel.values[e15];
        return AV(n11, { wizardModel: { values: met(e15) }, reportItemNames: het(t11) });
      }
      case o7e: {
        const { fieldName: e15 } = r11.payload;
        const { rowGroups: o11, columnGroups: a10, values: i10 } = n11.wizardModel;
        let s10 = n11;
        return s10 = o11.reduceRight((n12, r12, o12) => r12.field.name !== e15 ? n12 : t10(n12, Cet(o12)), s10), s10 = a10.reduceRight((n12, r12, o12) => r12.field.name !== e15 ? n12 : t10(n12, xet(o12)), s10), s10 = i10.reduceRight((n12, r12, o12) => r12.field.name !== e15 ? n12 : t10(n12, wet(o12)), s10), s10;
      }
      case a7e:
      case i7e: {
        const { field: { name: e15, expr: o11, defaultFormat: a10 }, index: i10, dataSetName: s10 } = r11.payload;
        const { reportItemNames: l10, groupNames: c10, wizardModel: u10 } = n11;
        const { name: d10 } = u10;
        const p10 = a10 != null ? a10 : "";
        const m10 = { name: NJe(c10, d10, e15), field: { name: e15, expr: o11 }, sorting: null, itemName: MJe(l10), itemValue: o11, format: p10, defaultFormat: p10 };
        const h10 = r11.type === a7e ? Tet : Eet;
        const f10 = t10(n11, h10(m10, i10));
        return t10(f10, ket(s10));
      }
      case s7e: {
        const { field: { name: e15, expr: o11, aggregate: a10, defaultFormat: i10 }, index: s10, dataSetName: l10 } = r11.payload;
        const { reportItemNames: c10 } = n11;
        const u10 = i10 != null ? i10 : "";
        const d10 = { itemName: MJe(c10), field: { name: e15, expr: a10 ? O1(o11, a10) : o11 }, aggregate: a10, displayAs: null, format: u10, defaultFormat: u10 };
        const p10 = t10(n11, Fet(d10, s10));
        return t10(p10, ket(l10));
      }
      case l7e: {
        const { group: e15, index: t11 } = r11.payload;
        const { name: o11, itemName: a10 } = e15;
        return AV(n11, { wizardModel: { rowGroups: get(e15, t11) }, reportItemNames: fet(a10), groupNames: fet(o11) });
      }
      case c7e: {
        const { group: e15, index: t11 } = r11.payload;
        const { name: o11, itemName: a10 } = e15;
        return AV(n11, { wizardModel: { columnGroups: get(e15, t11) }, reportItemNames: fet(a10), groupNames: fet(o11) });
      }
      case u7e: {
        const { value: e15, index: t11 } = r11.payload;
        const { itemName: o11 } = e15;
        return AV(n11, { wizardModel: { values: get(e15, t11) }, reportItemNames: fet(o11) });
      }
      case d7e: {
        const { format: e15, index: t11 } = r11.payload;
        return AV(n11, { wizardModel: { rowGroups: yet(e15, t11) } });
      }
      case p7e: {
        const { format: e15, index: t11 } = r11.payload;
        return AV(n11, { wizardModel: { columnGroups: yet(e15, t11) } });
      }
      case m7e: {
        const { format: e15, index: t11 } = r11.payload;
        return AV(n11, { wizardModel: { values: vet(e15, t11) } });
      }
      case h7e: {
        const { sortingType: e15, index: t11 } = r11.payload;
        const o11 = bet(n11.wizardModel.rowGroups[t11], e15);
        return o11 ? AV(n11, { wizardModel: { rowGroups: { [t11]: { sorting: o11 } } } }) : n11;
      }
      case f7e: {
        const { sortingType: e15, index: t11 } = r11.payload;
        const o11 = bet(n11.wizardModel.columnGroups[t11], e15);
        return o11 ? AV(n11, { wizardModel: { columnGroups: { [t11]: { sorting: o11 } } } }) : n11;
      }
      case g7e: {
        const { aggregate: e15, index: t11 } = r11.payload;
        const o11 = n11.wizardModel.values[t11];
        if (o11.aggregate === e15) return n11;
        const { field: { expr: a10 } } = o11;
        const i10 = e15 ? o11.displayAs : null;
        const s10 = { aggregate: { $set: e15 }, field: { expr: { $set: e15 ? O1(a10, e15) : z1(a10) } }, displayAs: { $set: i10 }, format: { $apply: (e16) => o11.displayAs && !i10 ? "" : e16 } };
        return AV(n11, { wizardModel: { values: { [t11]: s10 } } });
      }
      case y7e: {
        const { displayAs: e15, index: t11 } = r11.payload;
        const o11 = n11.wizardModel.values[t11];
        if (o11.displayAs === e15) return n11;
        const a10 = e15 ? (_b2 = o11.aggregate) != null ? _b2 : "Count" : o11.aggregate;
        const i10 = { displayAs: { $set: e15 }, format: { $apply: (t12) => e15 ? o11.displayAs ? t12 : "p2" : "" }, aggregate: { $set: a10 }, field: { expr: { $apply: (e16) => o11.aggregate === a10 ? e16 : a10 ? O1(e16, a10) : z1(e16) } } };
        return AV(n11, { wizardModel: { values: { [t11]: i10 } } });
      }
      case v7e: {
        const { index: e15, targetType: o11, targetIndex: a10 } = r11.payload;
        const i10 = "row" === o11 && a10 > e15 ? a10 - 1 : a10;
        if ("row" === o11 && e15 === i10) return n11;
        const { rowGroups: s10 } = n11.wizardModel;
        const l10 = s10[e15];
        return [Cet(e15), ("row" === o11 ? Tet : Eet)(l10, i10)].reduce((e16, n12) => t10(e16, n12), n11);
      }
      case b7e: {
        const { index: e15, targetType: o11, targetIndex: a10 } = r11.payload;
        const i10 = "column" === o11 && a10 > e15 ? a10 - 1 : a10;
        if ("column" === o11 && e15 === i10) return n11;
        const { columnGroups: s10 } = n11.wizardModel;
        const l10 = s10[e15];
        return [xet(e15), ("column" === o11 ? Eet : Tet)(l10, i10)].reduce((e16, n12) => t10(e16, n12), n11);
      }
      case S7e: {
        const { index: e15, targetIndex: o11 } = r11.payload;
        const a10 = o11 > e15 ? o11 - 1 : o11;
        if (e15 === a10) return n11;
        const { values: i10 } = n11.wizardModel;
        const s10 = i10[e15];
        return [wet(e15), Fet(s10, a10)].reduce((e16, n12) => t10(e16, n12), n11);
      }
      case C7e: {
        const { location: e15 } = r11.payload;
        return AV(n11, { filters: { $set: { location: e15 } } });
      }
      case x7e: {
        const { value: e15 } = r11.payload;
        const { filters: t11, wizardModel: o11 } = n11;
        const { $summary: a10, columnGroups: i10, rowGroups: s10 } = o11;
        const l10 = t11 == null ? void 0 : t11.location;
        if (!l10) return n11;
        if ("tablix" === l10.type) {
          const t12 = __spreadProps(__spreadValues({}, a10), { tablixProps: __spreadProps(__spreadValues({}, a10 == null ? void 0 : a10.tablixProps), { Filters: e15 }) });
          return AV(n11, { wizardModel: { $summary: { $set: t12 } } });
        }
        const { type: c10, index: u10 } = l10;
        const d10 = ("column" === c10 ? i10 : s10)[u10].$summary;
        const p10 = { [u10]: { $summary: { $set: __spreadProps(__spreadValues({}, d10), { memberProps: __spreadProps(__spreadValues({}, d10 == null ? void 0 : d10.memberProps), { Group: __spreadProps(__spreadValues({}, (_c2 = d10 == null ? void 0 : d10.memberProps) == null ? void 0 : _c2.Group), { Filters: e15 }) }) }) } } };
        return AV(n11, "column" === c10 ? { wizardModel: { columnGroups: p10 } } : { wizardModel: { rowGroups: p10 } });
      }
      case w7e:
        return n11.filters ? AV(n11, { filters: { $set: null } }) : n11;
      case T7e:
        return n11.warning ? AV(n11, { warning: { $set: null } }) : n11;
      default:
        return /* @__PURE__ */ ((e15, t11) => e15)(n11);
    }
  };
  const n10 = [t7e, n7e, r7e, o7e];
  const r10 = [o7e, A3e];
  const o10 = uA((e15) => (t11, n11) => {
    const r11 = e15(t11, n11);
    const { wizardModel: o11, prevWizardModel: a10 } = r11;
    return o11 === a10 ? r11 : AV(r11, { dirty: { $set: true } });
  }, (e15) => (n11, o11) => {
    const a10 = e15(n11, o11);
    return r10.includes(o11 == null ? void 0 : o11.type) && ((e16, { dataSetName: t11, rowGroups: n12, columnGroups: r11 }) => {
      if (!e16) return false;
      if (!t11) return true;
      const { location: o12 } = e16;
      if ("tablix" === o12.type) return false;
      const { type: a11, index: i10 } = o12;
      return i10 >= ("column" === a11 ? r11 : n12).length;
    })(a10.filters, a10.wizardModel) ? t10(a10, Pet()) : a10;
  }, (e15) => (r11, o11) => {
    const a10 = e15(r11, o11);
    if (!n10.includes(o11 == null ? void 0 : o11.type)) return a10;
    const { rowGroups: i10, columnGroups: s10, values: l10 } = a10.wizardModel;
    return i10.length > 0 || s10.length > 0 || l10.length > 0 ? a10 : t10(a10, Met());
  });
  return o10(t10);
};
const Let = { getStyleValue: () => {
} };
const Het = ep.createContext(Let);
const Iet = (e14, t10 = true) => t10 && e14 < 1 || !t10 && Math.abs(e14) < 1 ? 0 : z4(4)(e14);
const _et = (e14, t10, n10, r10) => {
  if (!t10.units) throw new Error('"rpxFromDisplayValue" requires "units" argument for length properties validation');
  if (!e14) return r10;
  let o10 = e14.trim().toLowerCase();
  return o10.startsWith(".") && (o10 = `0${o10}`), w$.test(o10) && (o10 = `${o10}${(n10 == null ? void 0 : n10.unit) || t10.units}`), L$.isValidString(o10) ? z4(4)(L$.parse(o10).toPreciseTwips) : r10;
};
const Vet = { rpx_length: _et, rpx_dimensions: _et };
function Ret(e14, t10, n10, r10, o10) {
  return t10 in Vet ? Vet[t10](e14, n10, r10, o10) : pK(e14, t10, n10, r10, o10);
}
const Aet = (e14, t10, n10, r10 = "") => {
  var _a2, _b2;
  const o10 = ((e15, t11) => {
    if (!(e15 == null ? void 0 : e15.units)) throw new Error('"rpxToDisplayValue" requires "units" argument for length properties validation');
    return (t11 == null ? void 0 : t11.unit) || e15.units;
  })(t10, n10);
  return ((e15, t11, n11, r11) => "number" != typeof e15 ? n11 : L$.fromTwips(e15, t11).round(r11).css)(e14, o10, r10, (_b2 = (_a2 = n10 == null ? void 0 : n10.fractionDigitsMap) == null ? void 0 : _a2[o10]) != null ? _b2 : E$[o10]);
};
const Oet = { rpx_length: Aet, rpx_dimensions: Aet };
function Bet(e14, t10, n10, r10, o10 = "") {
  return sK(e14) ? o10 : t10 in Oet ? Oet[t10](e14, n10, r10, o10) : hK(e14, t10, n10, r10, o10);
}
const zet = { background_pattern: (e14, t10, n10) => JY(e14, "enum", t10, n10), background_style: () => zY.success(), gradient_style: (e14, t10, n10) => JY(e14, "enum", t10, n10), image: () => zY.success(), rpx_length: KY.length, rpx_dimensions: KY.length, rpx_class_name: (e14, t10, n10) => e14 && "" !== e14.trim() ? YY(e14, "rpx_class_name", (n10 == null ? void 0 : n10.styleNames) || []) : { isValid: false }, rpx_data_field: () => zY.success(), rpx_format_string: () => zY.success(), rpx_font_size: () => zY.success(), rpx_font_family: () => zY.success(), rpx_line_style: KY.line_style, rpx_script_language: () => zY.success(), rpx_style_font_weight: () => zY.success(), rpx_style_font_style: () => zY.success(), shape: () => zY.success() };
function $et(e14, t10, n10, r10) {
  const o10 = zet[t10];
  return o10 ? o10(e14, n10, r10) : JY(e14, t10, n10, r10);
}
const Wet = (e14, t10) => {
  const { userPreferences: { units: n10 } } = MO();
  return (({ descriptor: e15, value: t11, defaultValue: n11 }, { parentStyle: r10, getStyleValue: o10 }, a10) => {
    if (r10 && void 0 === t11 && void 0 !== o10(r10, e15.valuePath)) return "Inherited";
    if (sK(t11)) return "Modified";
    if (t11 === n11) return "Default";
    const i10 = Bet(t11, e15.type, { units: a10 }, e15.meta);
    const { isValid: s10 } = $et(i10, e15.type, { units: a10 }, e15.meta);
    return s10 ? "Modified" : "Error";
  })(e14, t10, n10);
};
const jet = (e14) => {
  switch (e14) {
    case "Modified":
      return "modified";
    case "Error":
      return { cssClass: "wd-binding-wrapper--error" };
    case "Inherited":
      return { cssClass: "wd-binding-wrapper--inherited" };
    default:
      return "default";
  }
};
const Zet = (e14, t10) => {
  switch (e14) {
    case "Modified":
      return t10("propertyEditors-RPX:statusWrapper.titleModified", "Modified");
    case "Error":
      return t10("propertyEditors-RPX:statusWrapper.titleError", "Invalid");
    case "Inherited":
      return t10("propertyEditors-RPX:statusWrapper.titleInherited", "Inherited from Parent Style");
    default:
      return t10("propertyEditors-RPX:statusWrapper.titleDefault", "");
  }
};
const Get = ({ status: e14, defaultValue: t10, descriptor: n10, disabled: r10, setProperty: o10, children: a10 }) => {
  const { t: i10 } = vp("propertyEditors-RPX");
  const s10 = { onSelect: ep.useCallback(() => {
  }, []), environment: { bindingMenus: { default: [{ type: "button", disabled: r10, onClick: ep.useCallback(() => {
    sK(t10) || o10(n10, t10);
  }, [t10, n10, o10]), text: i10("statusWrapper.btnReset", "Reset"), icon: nf(Bh) }] } }, status: jet(e14), menuId: "default", menuMaxHeight: "default", titleToggle: Zet(e14, i10) };
  return tp.createElement(jD, __spreadValues({}, s10), a10);
};
Get.displayName = "RpxStatusWrapper";
const Uet = (e14) => (t10) => {
  const { descriptor: n10, defaultValue: r10, setProperty: o10, disabled: a10 } = t10;
  const { getStyleValue: i10, parentStyle: s10 } = ep.useContext(Het);
  const l10 = Wet(t10, { getStyleValue: i10, parentStyle: s10 });
  const c10 = __spreadValues({}, t10);
  "Inherited" === l10 && s10 && (c10.value = i10(s10, n10.valuePath));
  const u10 = { status: l10, descriptor: n10, defaultValue: r10, disabled: a10, setProperty: o10 };
  return ep.createElement(Get, __spreadValues({}, u10), ep.createElement(e14, __spreadValues({}, c10)));
};
const qet = _D(Uet(oge));
const [Yet, , Ket] = Dp("wd-rpx-background-style-editor");
const [Xet, Jet] = Ket("preview-box");
const Qet = { Solid: Jet("solid"), Gradient: Jet("gradient"), Pattern: Jet("pattern") };
const ett = (e14, t10) => sK(e14) ? Iie(t10) : _ie(t10);
const ttt = (e14) => sK(e14) ? null : tp.createElement("div", { className: kp(Xet, Qet[e14]) });
const ntt = (e14, t10, n10) => {
  if (sK(t10)) return "";
  const r10 = e14.find((e15) => e15.value === t10);
  return r10 ? r10.text : n10(t10);
};
const rtt = (e14) => {
  const { value: t10, descriptor: n10, setProperty: r10, toDisplayValue: o10 } = e14;
  const { enumKey: a10 } = n10.meta;
  const { t: i10 } = vp();
  const s10 = OO(a10, i10).map((e15) => ({ type: "button", value: e15.value, text: e15.label, selected: e15.value === t10 }));
  const l10 = ntt(s10, t10, o10);
  const [c10, u10] = ep.useState(l10);
  ep.useEffect(() => {
    u10(l10);
  }, [l10]);
  const d10 = ep.useCallback((e15) => {
    u10(ntt(s10, e15, o10)), r10(n10, e15);
  }, [n10, s10, r10, o10]);
  const p10 = ep.useCallback((e15) => {
    const t11 = s10.find((t12) => t12.text === e15);
    return t11 ? ttt(t11.value) : null;
  }, [s10]);
  const m10 = { dataAid: "shape-editor", block: true, size: "small", menuWidth: "100%", openOnFocus: true, menuMaxHeight: "default", value: c10, items: s10, customCSS: Yet, placeholder: ett(t10, i10), filterOnInput: true, onSelect: d10, generatePreview: p10, generateItemPreview: ttt };
  return tp.createElement(tM, __spreadValues({}, m10));
};
const ott = (e14) => tp.createElement(rtt, __spreadProps(__spreadValues({}, e14), { toDisplayValue: (e15) => e15 }));
ott.displayName = "BackgroundStyleEditor";
const att = _D(Uet(ott));
const itt = { mime_type: ["image/bmp", "image/jpeg", "image/gif", "image/png", "image/x-emf", "image/x-wmf"], barcode_style: ["None", "Ansi39", "Ansi39x", "Code_2_of_5", "Code25intlv", "Code25mat", "Matrix_2_of_5", "Code39", "Code39x", "Code_128_A", "Code_128_B", "Code_128_C", "Code_128auto", "Code_93", "Code93x", "MSI", "PostNet", "Codabar", "EAN_8", "EAN_13", "UPC_A", "UPC_E0", "UPC_E1", "RM4SCC", "UCCEAN128", "QRCode", "Code49", "JapanesePostal", "Pdf417", "EAN128FNC1", "RSS14", "RSS14Truncated", "RSS14Stacked", "RSS14StackedOmnidirectional", "RSSExpanded", "RSSExpandedStacked", "RSSLimited", "DataMatrix", "MicroPDF417", "MicroQRCode", "MaxiCode", "GS1QRCode", "GS1DataMatrix", "Aztec", "IntelligentMail", "ITF14", "Code_11", "SSCC_18", "Telepen", "Pharmacode", "PZN", "HIBCCode128", "HIBCCode39", "ISBN", "ISSN", "ISMN", "IATA_2_of_5", "BC412", "Plessey", "IntelligentMailPackage"], barcode_caption_position: ["None", "Above", "Below"], barcode_rotation: ["None", "Rotate90Degrees", "Rotate180Degrees", "Rotate270Degrees"], border_style_inputfield: ["None", "Solid", "Dashed", "Inset"], check_style: ["Check", "Circle", "Cross", "Diamond", "Square", "Star"], column_direction: ["DownAcross", "AcrossDown"], group_keep_together: ["None", "FirstDetail", "All"], repeat_style: ["None", "OnPage", "OnColumn", "All", "OnPageIncludeNoDetail"], new_page: ["None", "Before", "After", "BeforeAfter"], new_column: ["None", "Before", "After", "BeforeAfter"], script_language: ["C#", "VB.NET"], compatibility_mode: ["GDI", "CrossPlatform"], field_type: ["None", "String", "Date", "Int32", "Integer", "Float", "Double", "Boolean"], calculated_field_type: ["None", "String", "Date", "Int32", "Float", "Double", "Boolean"], parameter_type: ["String", "Date", "Boolean"], collate: ["Default", "Collate", "DontCollate"], duplex: ["Default", "Simplex", "Vertical", "Horizontal"], page_orientation: ["Default", "Portrait", "Landscape"], paper_source_kind: ["Upper", "Lower", "Middle", "Manual", "Envelope", "ManualFeed", "AutomaticFeed", "TractorFeed", "SmallFormat", "LargeFormat", "LargeCapacity", "Cassette", "FormSource", "Custom"], paper_kind: ["Custom", "Letter", "LetterSmall", "Tabloid", "Ledger", "Legal", "Statement", "Executive", "A3", "A4", "A4Small", "A5", "B4", "B5", "Folio", "Quarto", "Standard10x14", "Standard11x17", "Note", "Number9Envelope", "Number10Envelope", "Number11Envelope", "Number12Envelope", "Number14Envelope", "CSheet", "DSheet", "ESheet", "DLEnvelope", "C5Envelope", "C3Envelope", "C4Envelope", "C6Envelope", "C65Envelope", "B4Envelope", "B5Envelope", "B6Envelope", "ItalyEnvelope", "MonarchEnvelope", "PersonalEnvelope", "USStandardFanfold", "GermanStandardFanfold", "GermanLegalFanfold", "IsoB4", "JapanesePostcard", "Standard9x11", "Standard10x11", "Standard15x11", "InviteEnvelope", "LetterExtra", "LegalExtra", "TabloidExtra", "A4Extra", "LetterTransverse", "A4Transverse", "LetterExtraTransverse", "APlus", "BPlus", "LetterPlus", "A4Plus", "A5Transverse", "B5Transverse", "A3Extra", "A5Extra", "B5Extra", "A2", "A3Transverse", "A3ExtraTransverse", "JapaneseDoublePostcard", "A6", "JapaneseEnvelopeKakuNumber2", "JapaneseEnvelopeKakuNumber3", "JapaneseEnvelopeChouNumber3", "JapaneseEnvelopeChouNumber4", "LetterRotated", "A3Rotated", "A4Rotated", "A5Rotated", "B4JisRotated", "B5JisRotated", "JapanesePostcardRotated", "JapaneseDoublePostcardRotated", "A6Rotated", "JapaneseEnvelopeKakuNumber2Rotated", "JapaneseEnvelopeKakuNumber3Rotated", "JapaneseEnvelopeChouNumber3Rotated", "JapaneseEnvelopeChouNumber4Rotated", "B6Jis", "B6JisRotated", "Standard12x11", "JapaneseEnvelopeYouNumber4", "JapaneseEnvelopeYouNumber4Rotated", "Prc16K", "Prc32K", "Prc32KBig", "PrcEnvelopeNumber1", "PrcEnvelopeNumber2", "PrcEnvelopeNumber3", "PrcEnvelopeNumber4", "PrcEnvelopeNumber5", "PrcEnvelopeNumber6", "PrcEnvelopeNumber7", "PrcEnvelopeNumber8", "PrcEnvelopeNumber9", "PrcEnvelopeNumber10", "Prc16KRotated", "Prc32KRotated", "Prc32KBigRotated", "PrcEnvelopeNumber1Rotated", "PrcEnvelopeNumber2Rotated", "PrcEnvelopeNumber3Rotated", "PrcEnvelopeNumber4Rotated", "PrcEnvelopeNumber5Rotated", "PrcEnvelopeNumber6Rotated", "PrcEnvelopeNumber7Rotated", "PrcEnvelopeNumber8Rotated", "PrcEnvelopeNumber9Rotated", "PrcEnvelopeNumber10Rotated"], string_alignment: ["Near", "Center", "Far"], string_alignment_inputfield: ["Left", "Center", "Right"], content_alignment: ["TopLeft", "TopCenter", "TopRight", "MiddleLeft", "MiddleCenter", "MiddleRight", "BottomLeft", "BottomCenter", "BottomRight"], line_style: ["Transparent", "Solid", "Dash", "Dot", "DashDot", "DashDotDot", "Double"], size_mode: ["Clip", "Stretch", "Zoom"], picture_alignment: ["TopLeft", "TopRight", "Center", "BottomLeft", "BottomRight"], shape_style: ["Rectangle", "Ellipse", "RoundRect"], background_style: ["Solid", "Gradient", "Pattern"], gradient_style: ["Horizontal", "Vertical", "DiagonalUp", "DiagonalDown", "FromCenter", "FromCorner"], hatch_style: ["Horizontal", "Vertical", "ForwardDiagonal", "BackwardDiagonal", "LargeGrid", "DiagonalCross", "Percent05", "Percent10", "Percent20", "Percent25", "Percent30", "Percent40", "Percent50", "Percent60", "Percent70", "Percent75", "Percent80", "Percent90", "LightDownwardDiagonal", "LightUpwardDiagonal", "DarkDownwardDiagonal", "DarkUpwardDiagonal", "WideDownwardDiagonal", "WideUpwardDiagonal", "LightVertical", "LightHorizontal", "NarrowVertical", "NarrowHorizontal", "DarkVertical", "DarkHorizontal", "DashedDownwardDiagonal", "DashedUpwardDiagonal", "DashedHorizontal", "DashedVertical", "SmallConfetti", "LargeConfetti", "ZigZag", "Wave", "DiagonalBrick", "HorizontalBrick", "Weave", "Plaid", "Divot", "DottedGrid", "DottedDiamond", "Shingle", "Trellis", "Sphere", "SmallGrid", "SmallCheckerBoard", "LargeCheckerBoard", "OutlinedDiamond", "SolidDiamond"], summary_type: ["None", "GrandTotal", "PageTotal", "SubTotal", "PageCount"], summary_func: ["Sum", "Avg", "Count", "Min", "Max", "Var", "VarP", "StdDev", "StdDevP", "DSum", "DAvg", "DCount", "DVar", "DVarP", "DStdDev", "DStdDevP"], summary_running: ["None", "Group", "All"], richrext_rendering_type: ["RTF", "Metafile", "PNG", "TransparentPNG"], text_align: ["Left", "Right", "Center", "Justify"], text_justify: ["Auto", "Distribute", "Distribute_all_lines"], vertical_align: ["Top", "Middle", "Bottom"], format_string: ["Page {PageNumber} of {PageCount} on {RunDateTime}", "Page {PageNumber} of {PageCount}", "{RunDateTime:}", "{RunDateTime:M/d}", "{RunDateTime:M/d/yy}", "{RunDateTime:M/d/yyyy}", "{RunDateTime:MM/dd/yy}", "{RunDateTime:MM/dd/yyyy}", "{RunDateTime:d-MMM}", "{RunDateTime:d-MMM-yy}", "{RunDateTime:d-MMM-yyyy}", "{RunDateTime:dd-MMM-yy}", "{RunDateTime:dd-MMM-yyyy}", "{RunDateTime:MMM-yy}", "{RunDateTime:MMM-yyyy}", "{RunDateTime:MMMM-yy}", "{RunDateTime:MMMM-yyyy}", "{RunDateTime:MMMM d, yyyy}", "{RunDateTime:M/d/yy h:mm tt}", "{RunDateTime:M/d/yyyy h:mm tt}", "{RunDateTime:M/d/yy h:mm}", "{RunDateTime:M/d/yyyy h:mm}"], font_weight: ["Normal", "Bold"], font_style: ["Normal", "Italic"], font_size: ["8pt", "9pt", "10pt", "11pt", "12pt", "14pt", "16pt", "18pt", "20pt", "22pt", "24pt", "26pt", "28pt", "36pt", "48pt", "72pt"], white_space: ["Normal", "Pre", "NoWrap"], word_wrap: ["NoWrap", "WordWrap", "CharWrap"], kinsoku: ["Auto", "None", "True"], paper_size: ["Letter", "Tabloid", "Legal", "Executive", "A3", "A4", "A5", "A6", "JISB4", "JISB5", "JISB6", "ISOB5", "Custom"], paper_source: ["AutomaticFeed", "Manual", "Cassette"], calendar: ["Gregorian", "GregorianArabic", "GregorianArabic", "GregorianMiddleEastFrench", "GregorianTransliteratedEnglish", "GregorianTransliteratedFrench", "GregorianUSEnglish", "Hebrew", "Hijri", "Japanese", "Korea", "Taiwan", "ThaiBuddhist"], culture: ["af-ZA", "sq-AL", "ar-DZ", "ar-BH", "ar-EG", "ar-IQ", "ar-JO", "ar-KW", "ar-LB", "ar-LY", "ar-MA", "ar-OM", "ar-QA", "ar-SA", "ar-SY", "ar-TN", "ar-AE", "ar-YE", "hy-AM", "az-Cyrl-AZ", "az-Latn-AZ", "eu-ES", "be-BY", "bg-BG", "ca-ES", "zh-HK", "zh-MO", "zh-CN", "zh-SG", "zh-TW", "hr-BA", "hr-HR", "cs-CZ", "da-DK", "dv-MV", "nl-BE", "nl-NL", "en-AU", "en-BZ", "en-CA", "en-029", "en-IE", "en-JM", "en-NZ", "en-PH", "en-ZA", "en-TT", "en-GB", "en-US", "en-ZW", "et-EE", "fo-FO", "fi-FI", "fr-BE", "fr-CA", "fr-FR", "fr-LU", "fr-MC", "fr-CH", "gl-ES", "ka-GE", "de-AT", "de-DE", "de-LI", "de-LU", "de-CH", "el-GR", "gu-IN", "he-IL", "hi-IN", "hu-HU", "is-IS", "id-ID", "it-IT", "it-CH", "ja-JP", "kn-IN", "kk-KZ", "sw-KE", "kok-IN", "ko-KR", "ky-KG", "lv-LV", "lt-LT", "mk-MK", "ms-BN", "ms-MY", "mr-IN", "mn-MN", "nb-NO", "nn-NO", "fa-IR", "pl-PL", "pt-BR", "pt-PT", "pa-IN", "ro-RO", "ru-RU", "sa-IN", "sk-SK", "sl-SI", "es-AR", "es-BO", "es-CL", "es-CO", "es-CR", "es-DO", "es-EC", "es-SV", "es-GT", "es-HN", "es-MX", "es-NI", "es-PA", "es-PY", "es-PE", "es-PR", "es-ES", "es-UY", "es-VE", "sv-FI", "sv-SE", "syr-SY", "ta-IN", "tt-RU", "te-IN", "th-TH", "tr-TR", "uk-UA", "ur-PK", "uz-Cyrl-UZ", "uz-Latn-UZ", "vi-VN"], ddo_char_set: ["Baltic", "Greek", "Cyrillic", "Vietnamese", "Turkish", "Arab", "Hebrew", "CentralEuropean", "Western"], border_style: ["None", "Solid", "Dash", "Dot", "DashDot", "ThickSolid", "Double", "ThickDashDotDot", "ThickDash", "ThickDashDot", "ThickDot", "ExtraThickSolid", "ThickDouble"] };
const stt = (e14, t10, n10, r10, o10 = "both", a10) => ({ type: n10, label: t10 ? `properties-RPX:labels.${t10}` : "", category: e14 ? `properties-RPX:categories.${e14}` : "", valuePath: r10, mode: o10, meta: a10 });
const [, , ltt] = Dp("wd-color-editor-side");
const [ctt, utt] = ltt("preview");
const dtt = (e14) => `border.color.${e14}`;
const ptt = [stt("", dtt("left"), "color", "Border.LeftColor"), stt("", dtt("top"), "color", "Border.TopColor"), stt("", dtt("right"), "color", "Border.RightColor"), stt("", dtt("bottom"), "color", "Border.BottomColor")];
const mtt = (e14) => {
  const t10 = (e15, t11) => hK(e15, ptt[t11].type, {}, ptt[t11].meta, "");
  const n10 = __spreadProps(__spreadValues({}, e14), { nestedDescriptors: ptt, createSideEditor: (e15) => tp.createElement(Zie, __spreadValues({}, e15)), createMainEditor: (t11, n11, r10) => {
    const o10 = __spreadProps(__spreadValues({}, e14), { value: sK(t11) ? t11.toString() : t11.join(" "), onValidate: (e15) => r10(e15), onChange: n11, generatePreview: Array.isArray(t11) && t11.length > 1 ? () => {
      return (e15 = t11) ? tp.createElement("div", { className: ctt }, e15.map((e16, t12) => "string" == typeof e16 ? tp.createElement("span", { key: utt(t12.toString()), style: { backgroundColor: e16 } }) : null)) : null;
      var e15;
    } : void 0 });
    return tp.createElement(Zie, __spreadValues({}, o10));
  }, splitMainValue: (e15) => "string" != typeof e15 ? [""] : e15.trim().split(" ").slice(0, 4).map((e16) => e16.trim()), combineMainValue: (e15) => {
    if (e15.some((e16) => sK(e16.value))) return XN;
    const n11 = e15.map((e16) => e16.value).map(t10);
    const r10 = n11.every((e16) => n11[0] === e16);
    return r10 ? [n11[0]] : n11;
  }, validateSingleValue: (e15, t11, n11) => {
    const { isValid: r10 } = JY(e15, n11.type, {}, n11.meta);
    return r10;
  } });
  return tp.createElement(vse, __spreadValues({}, n10));
};
mtt.displayName = "BorderColorEditorSide";
const htt = (e14) => `border.style.${e14}`;
const ftt = [stt("", htt("left"), "line_style", "Border.LeftStyle", void 0, { enumKey: "border_style", allowEmpty: true }), stt("", htt("top"), "line_style", "Border.TopStyle", void 0, { enumKey: "border_style", allowEmpty: true }), stt("", htt("right"), "line_style", "Border.RightStyle", void 0, { enumKey: "border_style", allowEmpty: true }), stt("", htt("bottom"), "line_style", "Border.BottomStyle", void 0, { enumKey: "border_style", allowEmpty: true })];
const gtt = (e14) => {
  const { descriptor: t10 } = e14;
  const { t: n10 } = vp("propertyEditors");
  const r10 = __spreadProps(__spreadValues({}, e14), { nestedDescriptors: ftt, createSideEditor: (e15) => tp.createElement(cue, __spreadValues({}, e15)), createMainEditor: (t11, n11) => {
    const r11 = __spreadProps(__spreadValues({}, e14), { value: t11, setProperty: (e15, t12) => n11(t12) });
    return tp.createElement(cue, __spreadValues({}, r11));
  }, splitMainValue: (e15) => "string" != typeof e15 ? [""] : e15.trim().split(" ").map((e16) => e16.trim()), combineMainValue: (e15) => {
    if (e15.some((e16) => sK(e16.value))) return XN;
    const r11 = e15.map((e16) => {
      var _a2;
      return (r12 = e16.value) ? RO((_a2 = t10.meta) == null ? void 0 : _a2.enumKey, r12, n10) : "None";
      var r12;
    });
    const o10 = r11.every((e16) => r11[0] === e16);
    return o10 ? r11[0] : r11.join(" ");
  } });
  return tp.createElement(vse, __spreadValues({}, r10));
};
gtt.displayName = "BorderStyleEditorSide";
const ytt = _D(Uet(kfe));
const [vtt] = Dp("wd-image-editor-native-input");
const btt = (e14) => {
  const { descriptor: t10, value: n10 } = e14;
  const { t: r10 } = vp("propertyEditors-RPX");
  const o10 = PA();
  const a10 = rf(_h);
  const i10 = ep.useRef(null);
  const s10 = ep.useCallback((e15) => {
    var _a2;
    const n11 = (_a2 = e15.target) == null ? void 0 : _a2.result;
    n11 && o10(iB(t10, n11.split(",")[1]));
  }, [t10, o10]);
  const l10 = ep.useCallback((e15) => {
    const { target: { files: t11 } } = e15;
    if (t11 == null ? void 0 : t11[0]) {
      const e16 = new FileReader();
      e16.onload = s10, e16.onerror = () => console.warn("Image Editor: failed to load file"), e16.readAsDataURL(t11[0]);
    }
  }, [s10]);
  const c10 = ep.useCallback(() => {
    var _a2;
    (_a2 = i10.current) == null ? void 0 : _a2.click();
  }, []);
  const u10 = { size: "small", text: n10 ? r10("image.textChange", "Change...") : r10("image.textPick", "Pick..."), width: "100%", onClick: c10, dataAid: "image-editor-upload-button", icon: a10 };
  return tp.createElement(tp.Fragment, null, tp.createElement("input", { ref: i10, type: "file", accept: "image/*", onChange: l10, className: vtt }), tp.createElement(qm, __spreadValues({}, u10)));
};
btt.displayName = "ImageEditor";
const Stt = _D(Uet(btt));
const Ctt = _V("@core/documents/rpx/load", (e14) => e14, () => ({ skipDirty: true, naming: { update: true } }));
const xtt = _V("@core/documents/rpx/init", (e14) => e14, () => ({ skipDirty: true, naming: { update: true } }));
const wtt = IV((e14, t10) => ({ type: "@rpx/addControl", payload: __spreadProps(__spreadValues({}, e14), { id: e14.id || GB() }), meta: { path: t10, naming: { add: e14.name }, checkReportGeometry: true, checkSectionGeometry: true, checkCrossSectionItemGeometry: "CrossSectionBox" === e14.type || "CrossSectionLine" === e14.type } }), "@rpx/addControl");
const Ttt = IV((e14) => ({ type: "@rpx/removeControl", meta: { path: e14, naming: { update: true } } }), "@rpx/removeControl");
const Ett = IV((e14) => ({ type: "@rpx/addSections", payload: __spreadProps(__spreadValues({}, e14), { headerId: e14.headerId || GB(), footerId: e14.footerId || GB() }), meta: { naming: { add: [e14.headerName, e14.footerName] } } }), "@rpx/addSections");
const Ftt = IV((e14) => ({ type: "@rpx/removeSections", meta: { path: e14, naming: { update: true } } }), "@rpx/removeSections");
const Mtt = IV(({ left: e14, top: t10 }, n10) => ({ type: "@rpx/moveControl", payload: { left: e14, top: t10 }, meta: { path: n10, checkReportGeometry: true, checkSectionGeometry: true } }), "@rpx/moveControl");
const ktt = IV(({ left: e14, top: t10, width: n10, height: r10 }, o10) => ({ type: "@rpx/resizeControl", payload: { left: e14, top: t10, width: n10, height: r10 }, meta: { path: o10, checkReportGeometry: true, checkSectionGeometry: true } }), "@rpx/resizeControl");
const Ptt = IV((e14, t10, n10) => ({ type: "@core/setProperty", payload: { descriptor: e14, value: t10 }, meta: __spreadValues({ path: n10 }, e14.meta) }), "@core/setProperty");
const Ntt = IV((e14, t10) => ({ type: "@rpx/setPoint", payload: e14, meta: { path: t10, checkReportGeometry: true, checkSectionGeometry: true } }), "@rpx/setPoint");
const Dtt = IV((e14, t10, n10) => ({ type: "@rpx/setSectionPasteInfo", payload: { pasteId: e14, pasteCount: t10 }, meta: { path: n10 } }), "@rpx/setSectionPasteInfo");
const Ltt = IV((e14) => ({ type: "@rpx/horizontalAlign", payload: { alignTo: e14 }, meta: { path: "" } }), "@rpx/horizontalAlign");
const Htt = IV((e14) => ({ type: "@rpx/verticalAlign", payload: { alignTo: e14 }, meta: { path: "" } }), "@rpx/verticalAlign");
const Itt = IV((e14) => ({ type: "@rpx/rpxVerticalSpacing", payload: { spacingAdjustment: e14 }, meta: { path: "" } }), "@rpx/rpxVerticalSpacing");
const _tt = IV((e14) => ({ type: "@rpx/rpxHorizontalSpacing", payload: { spacingAdjustment: e14 }, meta: { path: "" } }), "@rpx/rpxHorizontalSpacing");
const Vtt = IV(() => ({ type: "@rpx/sendToBack", payload: {}, meta: {} }), "@rpx/sendToBack");
const Rtt = IV(() => ({ type: "@rpx/bringToFront", payload: {}, meta: {} }), "@rpx/bringToFront");
const Att = (e14) => {
  const t10 = PA();
  const n10 = __spreadProps(__spreadValues({}, e14), { toDisplayValue: Bet, fromDisplayValue: Ret, validateConstant: $et, setProperty: (e15, n11) => t10(Ptt(e15, n11)) });
  return tp.createElement(dse, __spreadValues({}, n10));
};
Att.displayName = "RpxLengthEditor";
const Ott = _D(Uet(Att));
const Btt = _D(Att);
const ztt = (e14) => {
  const { nestedDescriptors: t10 } = e14;
  const { t: n10 } = vp();
  const { userPreferences: { units: r10 } } = MO();
  const o10 = (e15, n11) => Ret(e15, t10[n11].type, { units: r10 }, t10[n11].meta, e15);
  const a10 = (e15, n11) => Bet(e15, t10[n11].type, { units: r10 }, t10[n11].meta, e15.toString());
  const i10 = __spreadProps(__spreadValues({}, e14), { createSideEditor: (e15) => tp.createElement(Ott, __spreadValues({}, e15)), createMainEditor: (t11, r11, o11) => {
    const a11 = __spreadProps(__spreadValues({}, e14), { value: t11, validate: o11, onChange: (e15, t12) => r11(t12), t: n10 });
    return tp.createElement(Sse, __spreadValues({}, a11));
  }, splitMainValue: (e15) => "string" != typeof e15 ? [0] : e15.trim().split(" ").slice(0, 4).map((e16) => e16.trim()).map(o10), combineMainValue: (e15) => {
    if (e15.some((e16) => sK(e16.value))) return XN;
    const t11 = e15.map((e16) => e16.value).map(a10);
    const n11 = t11.every((e16) => t11[0] === e16);
    return n11 ? t11[0] : t11.join(" ");
  }, validateSingleValue: (e15, t11, n11) => {
    const o11 = Bet(e15, "rpx_length", { units: r10 }, n11.meta);
    const { isValid: a11 } = $et(o11, "rpx_length", { units: r10 }, n11.meta);
    return a11;
  } });
  return tp.createElement(vse, __spreadValues({}, i10));
};
ztt.displayName = "LengthEditorSide";
const $tt = (e14) => stt("", "", "rpx_length", e14, void 0, { fractionDigitsMap: { cm: 2, in: 2 } });
const Wtt = [$tt("LeftMargin"), $tt("TopMargin"), $tt("RightMargin"), $tt("BottomMargin")];
const jtt = (e14) => {
  const t10 = __spreadProps(__spreadValues({}, e14), { nestedDescriptors: Wtt });
  return tp.createElement(ztt, __spreadValues({}, t10));
};
jtt.displayName = "MarginEditor";
const Ztt = (e14) => {
  const { instanceId: t10 } = qHe();
  const { value: n10, setProperty: r10 } = e14;
  const o10 = ep.useCallback((e15) => e15 === n10 || ((e16) => e16 && Jc("^\\pL[\\pL_\\d]*$").test(e16) || false)(e15) && az.of(t10).isNameAvailable(e15), [n10, t10]);
  const a10 = ep.useCallback((e15, t11) => {
    r10(e15, t11);
  }, [r10]);
  const i10 = __spreadProps(__spreadValues({}, e14), { validate: o10, setProperty: a10 });
  return tp.createElement(bse, __spreadValues({}, i10));
};
Ztt.displayName = "NameEditor";
const Gtt = _D(Ztt);
const Utt = "appearance", qtt = "behavior", Ytt = "common", Ktt = "data", Xtt = "layout", Jtt = "summary", Qtt = "format", ent = "misc", tnt = "page", nnt = "watermark", rnt = "printing", ont = "text", ant = "border", int = "pdf";
const snt = stt(Xtt, "padding", "padding", "");
const lnt = { Style: stt(ant, "border.style", "rpx_border_style", "", void 0, { enumKey: "border_style", allowEmpty: true }), Color: stt(ant, "border.color", "rpx_border_color", "") };
const cnt = { Name: stt(Ytt, "control.name", "name", "Name"), Visible: stt(qtt, "control.visible", "boolean", "Visible"), DataField: stt(Ktt, "control.dataField", "rpx_data_field", "DataField"), Tag: stt(Ktt, "control.tag", "string", "Tag"), Left: stt(Xtt, "control.left", "rpx_dimensions", "Left", void 0, { checkReportGeometry: true }), Top: stt(Xtt, "control.top", "rpx_dimensions", "Top", void 0, { checkSectionGeometry: true }), Width: stt(Xtt, "control.width", "rpx_dimensions", "Width", void 0, { checkReportGeometry: true }), Height: stt(Xtt, "control.height", "rpx_dimensions", "Height", void 0, { checkSectionGeometry: true }) };
const unt = stt(Utt, "styles", "styles", "Style");
const dnt = { ClassName: stt(Ytt, "style.className", "rpx_class_name", "Style.ClassName"), BackColor: stt(Ytt, "style.backColor", "color", "Style.BackColor"), ForeColor: stt(ont, "style.foreColor", "color", "Style.ForeColor"), FontFamily: stt(ont, "style.fontFamily", "rpx_font_family", "Style.FontFamily"), FontSize: stt(ont, "style.fontSize", "rpx_font_size", "Style.FontSize", void 0, { units: "pt" }), FontWeight: stt(ont, "style.fontWeight", "enum", "Style.FontWeight", void 0, { enumKey: "font_weight" }), FontStyle: stt(ont, "style.fontStyle", "enum", "Style.FontStyle", void 0, { enumKey: "font_style" }), ShrinkToFit: stt(ont, "style.shrinkToFit", "boolean", "Style.ShrinkToFit"), FontUnderline: stt(ont, "style.fontUnderline", "boolean", "Style.FontUnderline"), FontLinethrough: stt(ont, "style.fontLinethrough", "boolean", "Style.FontLinethrough"), TextAlign: stt(ont, "style.textAlign", "enum", "Style.TextAlign", void 0, { enumKey: "text_align" }), TextJustify: stt(ont, "style.textJustify", "enum", "Style.TextJustify", void 0, { enumKey: "text_justify" }), VerticalAlign: stt(ont, "style.verticalAlign", "enum", "Style.VerticalAlign", void 0, { enumKey: "vertical_align" }), WordWrap: stt(ont, "style.wrapMode", "enum", "Style.WordWrap", void 0, { enumKey: "word_wrap" }), VerticalText: stt(ont, "style.verticalText", "boolean", "Style.VerticalText"), DdoCharSet: stt(ont, "style.ddoCharSet", "enum", "Style.DdoCharSet", void 0, { enumKey: "ddo_char_set" }), Kinsoku: stt(ont, "style.kinsoku", "enum", "Style.Kinsoku", void 0, { enumKey: "kinsoku" }) };
const pnt = Object.values(cnt);
Object.values(dnt);
const mnt = Object.values(lnt);
const hnt = (e14) => {
  const { nestedDescriptors: t10 } = e14;
  const { t: n10 } = vp();
  const r10 = (e15, n11) => hK(e15, t10[n11].type, {}, t10[n11].meta, "");
  const o10 = __spreadProps(__spreadValues({}, e14), { createSideEditor: (e15) => tp.createElement(Tue, __spreadValues({}, e15)), createMainEditor: (t11, r11, o11) => {
    const a10 = __spreadProps(__spreadValues({}, e14), { value: t11, validate: o11, onChange: (e15, t12) => r11(t12), t: n10 });
    return tp.createElement(Sse, __spreadValues({}, a10));
  }, splitMainValue: (e15) => "string" != typeof e15 ? [""] : e15.trim().split(" ").slice(0, 4).map((e16) => e16.trim()), combineMainValue: (e15) => {
    if (e15.some((e16) => sK(e16.value))) return XN;
    const t11 = e15.map((e16) => e16.value).map(r10);
    const n11 = t11.every((e16) => t11[0] === e16);
    return n11 ? t11[0] : t11.join(" ");
  }, validateSingleValue: (e15, t11, n11) => {
    const { isValid: r11 } = JY(e15, "number", {}, n11.meta);
    return r11;
  } });
  return tp.createElement(vse, __spreadValues({}, o10));
};
hnt.displayName = "NumberEditorSide";
const fnt = (e14) => `padding.${e14}`;
const gnt = [stt(Xtt, fnt("left"), "number", "PaddingLeft", void 0, { numberType: "Integer", step: 1, minValue: 0 }), stt(Xtt, fnt("top"), "number", "PaddingTop", void 0, { numberType: "Integer", step: 1, minValue: 0 }), stt(Xtt, fnt("right"), "number", "PaddingRight", void 0, { numberType: "Integer", step: 1, minValue: 0 }), stt(Xtt, fnt("bottom"), "number", "PaddingBottom", void 0, { numberType: "Integer", step: 1, minValue: 0 })];
const ynt = (e14) => {
  const { descriptor: t10 } = e14;
  const n10 = __spreadProps(__spreadValues({}, e14), { nestedDescriptors: gnt.map((e15) => __spreadProps(__spreadValues({}, e15), { category: t10.category || e15.category, meta: __spreadProps(__spreadValues({}, e15.meta), { parentLabel: t10.label }) })) });
  return tp.createElement(hnt, __spreadValues({}, n10));
};
const vnt = _D(Uet(tse));
const bnt = stt("", "paperSize", "enum", "PaperSize.Size", void 0, { enumKey: "paper_size" });
const Snt = stt("", "paperWidth", "rpx_dimensions", "PaperSize.Width", void 0, { fractionDigitsMap: { cm: 2, in: 2 } });
const Cnt = stt("", "paperHeight", "rpx_dimensions", "PaperSize.Height", void 0, { fractionDigitsMap: { cm: 2, in: 2 } });
const xnt = stt("", "orientation", "enum", "Orientation", void 0, { enumKey: "page_orientation" });
const wnt = (e14, t10) => new L$(e14, t10).toTwips;
const Tnt = { Letter: [8.5, 11, "in"], Tabloid: [11, 17, "in"], Legal: [8.5, 14, "in"], Executive: [7.25, 10.5, "in"], A3: [29.7, 42, "cm"], A4: [21, 29.7, "cm"], A5: [14.8, 21, "cm"], A6: [10.5, 14.8, "cm"], JISB4: [25.7, 36.4, "cm"], JISB5: [18.2, 25.7, "cm"], JISB6: [12.8, 18.2, "cm"], ISOB5: [17.6, 25, "cm"] };
const Ent = (e14) => {
  const { descriptor: { valuePath: t10 }, value: { PaperSize: { Height: n10, Size: r10, Width: o10 }, Orientation: a10 }, defaultValue: i10 } = e14;
  const s10 = PA();
  const [l10, c10] = ep.useState("Custom" !== r10);
  const u10 = ep.useMemo(() => WN(Snt, t10), [t10]);
  const d10 = ep.useMemo(() => WN(Cnt, t10), [t10]);
  const p10 = (e15, t11) => {
    var _a2;
    const n11 = (_a2 = Tnt[t11]) == null ? void 0 : _a2[2];
    return __spreadProps(__spreadValues({}, e15), { meta: __spreadProps(__spreadValues({}, e15.meta), { unit: n11 }) });
  };
  const m10 = __spreadProps(__spreadValues({}, e14), { descriptor: WN(bnt, t10), value: r10, defaultValue: i10.PaperSize.Size, setProperty: (e15, t11) => {
    if ("Custom" === t11) return c10(false), void s10(iB(e15, t11));
    l10 || c10(true);
    const [n11, r11, o11] = Tnt[t11];
    const i11 = wnt(n11, o11);
    const m11 = wnt(r11, o11);
    s10(rz([iB(e15, t11), iB(xnt, "Portrait"), iB(p10(u10, t11), "Landscape" !== a10 ? i11 : m11), iB(p10(d10, t11), "Landscape" !== a10 ? m11 : i11)]));
  } });
  const h10 = __spreadProps(__spreadValues({}, e14), { descriptor: WN(xnt, t10), value: a10, defaultValue: i10.Orientation, setProperty: (e15, t11) => {
    t11 !== a10 && s10(rz([iB(e15, t11), iB(p10(u10, t11), "Landscape" !== t11 ? Math.min(o10, n10) : Math.max(o10, n10)), iB(p10(d10, t11), "Landscape" !== t11 ? Math.max(o10, n10) : Math.min(o10, n10))]));
  } });
  const f10 = __spreadProps(__spreadValues({}, e14), { descriptor: p10(u10, r10), disabled: l10, value: o10 });
  const g10 = __spreadProps(__spreadValues({}, e14), { descriptor: p10(d10, r10), disabled: l10, value: n10 });
  return tp.createElement(tp.Fragment, null, tp.createElement(vnt, __spreadValues({}, m10)), tp.createElement(Btt, __spreadValues({}, f10)), tp.createElement(Btt, __spreadValues({}, g10)), tp.createElement(vnt, __spreadValues({}, h10)));
};
Ent.displayName = "PaperSizeEditor";
const Fnt = [stt("", "", "number", "TopLeft", void 0, { numberType: "Integer", step: 1, minValue: 0, maxValue: 100, emptyValue: "Undefined" }), stt("", "", "number", "TopRight", void 0, { numberType: "Integer", step: 1, minValue: 0, maxValue: 100, emptyValue: "Undefined" }), stt("", "", "number", "BottomLeft", void 0, { numberType: "Integer", step: 1, minValue: 0, maxValue: 100, emptyValue: "Undefined" }), stt("", "", "number", "BottomRight", void 0, { numberType: "Integer", step: 1, minValue: 0, maxValue: 100, emptyValue: "Undefined" }), stt("", "radius.default", "number", "Default", void 0, { numberType: "Integer", step: 1, minValue: 0, maxValue: 100, emptyValue: "Undefined" })];
const Mnt = (e14) => {
  const { descriptor: t10 } = e14;
  const n10 = rf(Hh);
  const r10 = rf(Hh, { rotate: "90" });
  const o10 = rf(Hh, { rotate: "180" });
  const a10 = rf(Hh, { rotate: "270" });
  const i10 = __spreadProps(__spreadValues({}, e14), { nestedDescriptors: Fnt.map((e15) => __spreadProps(__spreadValues({}, e15), { category: t10.category || e15.category, meta: __spreadProps(__spreadValues({}, e15.meta), { parentLabel: t10.label }) })), sideIcons: { left: n10, top: r10, right: a10, bottom: o10 } });
  return tp.createElement(hnt, __spreadProps(__spreadValues({}, i10), { shouldUpdate: true }));
};
const knt = _D(Uet(Lie));
$A((e14) => e14, (e14) => e14.core);
const Pnt = $A((e14) => e14, (e14) => e14.core.document);
$A((e14) => e14, (e14) => {
  var _a2;
  return (_a2 = e14.core.document.present.content) == null ? void 0 : _a2.DataSource;
}), $A((e14) => e14, (e14) => {
  var _a2;
  return (_a2 = e14.core.document.present.content) == null ? void 0 : _a2.Fields;
}), $A((e14) => e14, (e14) => {
  var _a2;
  return (_a2 = e14.core.document.present.content) == null ? void 0 : _a2.CalculatedFields;
}), $A((e14) => e14, (e14) => {
  var _a2;
  return (_a2 = e14.core.document.present.content) == null ? void 0 : _a2.Parameters;
});
const Nnt = $A((e14) => e14, ({ core: { document: { present: { content: e14 } } } }) => ({ Script: e14 == null ? void 0 : e14.Script, ScriptLanguage: e14 == null ? void 0 : e14.ScriptLanguage }));
const Dnt = $A((e14) => e14, (e14) => {
  var _a2;
  return (_a2 = e14.core.document.present.content) == null ? void 0 : _a2.StyleSheet;
});
const Lnt = () => LA(Pnt);
const Hnt = {};
const Int = () => {
  const { present: { content: e14 } } = LA(Pnt);
  return e14 != null ? e14 : Hnt;
};
const _nt = (e14) => {
  const { present: { content: t10 } } = Lnt();
  const n10 = ep.useMemo(() => {
    var _a2;
    return ((_a2 = t10 == null ? void 0 : t10.StyleSheet) != null ? _a2 : []).map((e15) => e15.ClassName);
  }, [t10 == null ? void 0 : t10.StyleSheet]);
  const { descriptor: r10 } = e14;
  const o10 = __spreadProps(__spreadValues({}, r10), { meta: { styleNames: n10 } });
  return tp.createElement(vnt, __spreadProps(__spreadValues({}, e14), { descriptor: o10, currentEnum: n10 }));
};
const Vnt = _D(Uet(jie));
const Rnt = Uet((e14) => {
  const { descriptor: { type: t10, meta: n10 }, value: r10 } = e14;
  const o10 = __spreadProps(__spreadValues({}, e14), { validateValue: (e15) => $et(e15, t10, void 0, n10), toDisplayValue: (e15) => Bet(e15, t10, void 0, n10, r10), fromDisplayValue: (e15) => Ret(e15, t10, void 0, n10, r10) });
  return tp.createElement(zue, __spreadValues({}, o10));
});
const Ant = _D(Rnt);
const Ont = (e14) => {
  const { present: { content: t10 } } = Lnt();
  const n10 = ep.useMemo(() => {
    var _a2;
    return ((_a2 = t10 == null ? void 0 : t10.Fields) != null ? _a2 : []).map((e15) => e15.Name);
  }, [t10 == null ? void 0 : t10.Fields]);
  const r10 = ep.useMemo(() => {
    var _a2;
    return ((_a2 = t10 == null ? void 0 : t10.CalculatedFields) != null ? _a2 : []).map((e15) => e15.Name);
  }, [t10 == null ? void 0 : t10.CalculatedFields]);
  const o10 = ep.useMemo(() => {
    var _a2;
    return ((_a2 = t10 == null ? void 0 : t10.Parameters) != null ? _a2 : []).map((e15) => `param:${e15.Key}`);
  }, [t10 == null ? void 0 : t10.Parameters]);
  const a10 = ep.useMemo(() => [...n10, ...r10, ...o10], [r10, n10, o10]);
  const { descriptor: i10 } = e14;
  const s10 = __spreadProps(__spreadValues({}, i10), { meta: { dataFields: a10 } });
  return tp.createElement(Ant, __spreadProps(__spreadValues({}, e14), { descriptor: s10, currentEnum: a10 }));
};
Ont.displayName = "RpxDataFieldEditor";
const Bnt = (e14) => {
  const { fonts: t10 } = MO();
  return tp.createElement(tse, __spreadProps(__spreadValues({}, e14), { currentEnum: t10.filter((e15) => Qxe(e15) || "string" == typeof e15).map((e15) => "string" == typeof e15 ? { label: e15, value: e15 } : e15) }));
};
_D(Bnt);
const znt = _D(Uet(Bnt));
const $nt = { units: "pt" };
const Wnt = (e14, t10, n10) => {
  if (sK(t10)) return "";
  const r10 = e14.find((e15) => e15.value === t10);
  return r10 ? r10.text : n10(t10);
};
const jnt = Uet((e14) => {
  const { value: t10, setProperty: n10, descriptor: r10 } = e14;
  const { t: o10 } = vp();
  const a10 = ep.useCallback((e15) => Ret(e15, "length", $nt, $nt, t10), [t10]);
  const i10 = ep.useCallback((e15) => Bet(e15, "length", void 0, $nt, t10), [t10]);
  const s10 = ep.useMemo(() => OO("font_size", o10), [o10]);
  const l10 = ep.useMemo(() => s10.map((e15) => ({ type: "button", value: e15.value, text: e15.label, selected: e15.value === t10 })), [s10, t10]);
  const c10 = Wnt(l10, t10, i10);
  const [u10, d10] = ep.useState(c10);
  const p10 = sK(t10);
  ep.useEffect(() => {
    d10(c10);
  }, [c10]);
  const m10 = ep.useCallback((e15) => {
    e15 !== t10 && (d10(Wnt(l10, e15, i10)), n10(r10, e15));
  }, [r10, l10, n10, i10, t10]);
  const h10 = ep.useCallback((e15) => {
    const t11 = a10(e15.target.value);
    d10(Wnt(l10, t11, i10)), n10(r10, t11);
  }, [r10, a10, l10, n10, i10]);
  const f10 = __spreadProps(__spreadValues({}, e14), { dataAid: "line-style-editor", block: true, size: "small", menuWidth: "100%", openOnFocus: true, menuMaxHeight: "default", value: u10, items: l10, filterOnInput: true, onSelect: m10, onChange: h10, placeholder: p10 ? Iie(o10) : _ie(o10) });
  return tp.createElement(tM, __spreadValues({}, f10));
});
const Znt = _D(jnt);
const Gnt = (e14) => {
  const { t: t10 } = vp();
  const n10 = OO("format_string", t10).map(({ label: e15 }) => e15);
  const r10 = __spreadProps(__spreadValues({}, e14), { currentEnum: n10 });
  return tp.createElement(Ant, __spreadValues({}, r10));
};
const Unt = _D(Uet(lue));
const qnt = _D(Uet(xue));
const Ynt = _D(Uet(Due));
const Knt = _D(Uet(bse));
const Xnt = Uet((e14) => {
  const { descriptor: t10, value: n10, defaultValue: r10, setProperty: o10 } = e14;
  const a10 = n10;
  const i10 = ep.useMemo(() => r10 || "Normal", [r10]);
  const s10 = ep.useCallback((e15, n11) => o10(t10, n11 ? "Italic" : i10), [t10, i10, o10]);
  return tp.createElement(Lie, __spreadProps(__spreadValues({}, e14), { value: "Italic" === a10, defaultValue: !r10 && void 0, setProperty: s10 }));
});
const Jnt = _D(Xnt);
const Qnt = Uet((e14) => {
  const { descriptor: t10, value: n10, defaultValue: r10, setProperty: o10 } = e14;
  const a10 = n10;
  const i10 = ep.useMemo(() => r10 || "Normal", [r10]);
  const s10 = ep.useCallback((e15, n11) => o10(t10, n11 ? "Bold" : i10), [t10, i10, o10]);
  return tp.createElement(Lie, __spreadProps(__spreadValues({}, e14), { value: "Bold" === a10, defaultValue: !r10 && void 0, setProperty: s10 }));
});
const ert = _D(Qnt);
const trt = ["CheckBox", "Label", "ReportInfo", "TextBox"];
const nrt = (e14) => {
  const { setProperty: t10, value: n10 } = e14;
  const { present: { content: r10 } } = Lnt();
  const o10 = ep.useMemo(() => {
    var _a2;
    return (_a2 = r10 == null ? void 0 : r10.StyleSheet.map((e15) => e15.ClassName)) != null ? _a2 : [];
  }, [r10 == null ? void 0 : r10.StyleSheet]);
  const a10 = "Normal" === n10 || ((e15, t11) => {
    for (const n11 of Object.values(e15.Sections)) for (const e16 of Object.values(n11.Controls)) if (trt.includes(e16.Type) && e16.Style && e16.Style.ClassName === t11) return true;
    return false;
  })(r10, n10);
  const i10 = ep.useCallback((e15) => e15 === n10 || "" !== e15.trim() && XB(e15, o10), [n10, o10]);
  const s10 = ep.useCallback((e15, n11) => {
    t10(e15, n11);
  }, [t10]);
  const l10 = __spreadProps(__spreadValues({}, e14), { validate: i10, setProperty: s10, disabled: a10 });
  return tp.createElement(bse, __spreadValues({}, l10));
};
nrt.displayName = "RpxStyleNameEditor";
const rrt = _D(nrt);
const ort = (e14) => {
  const { t: t10 } = vp();
  const n10 = __spreadProps(__spreadValues({}, e14), { currentEnum: ep.useMemo(() => OO("script_language", t10).map((e15) => "VBNET" === e15.value ? { label: e15.label, value: "VB.NET" } : e15), [t10]) });
  return tp.createElement(vnt, __spreadValues({}, n10));
};
ort.displayName = "ScriptLanguageEditor";
const [art, , irt] = Dp("wd-rpx-shape-editor");
const [srt] = irt("preview-box");
const [lrt, crt] = irt("preview-content");
const urt = { Rectangle: crt("rectangle"), RoundRect: crt("round-rect"), Ellipse: crt("ellipse") };
const drt = (e14, t10) => sK(e14) ? Iie(t10) : _ie(t10);
const prt = (e14) => sK(e14) ? null : tp.createElement("div", { className: srt }, tp.createElement("div", { className: kp(lrt, urt[e14]) }));
const mrt = (e14, t10, n10) => {
  if (sK(t10)) return "";
  const r10 = e14.find((e15) => e15.value === t10);
  return r10 ? r10.text : n10(t10);
};
const hrt = (e14) => {
  const { value: t10, descriptor: n10, setProperty: r10, toDisplayValue: o10 } = e14;
  const { enumKey: a10 } = n10.meta;
  const { t: i10 } = vp();
  const s10 = OO(a10, i10).map((e15) => ({ type: "button", value: e15.value, text: e15.label, selected: e15.value === t10 }));
  const l10 = mrt(s10, t10, o10);
  const [c10, u10] = ep.useState(l10);
  ep.useEffect(() => {
    u10(l10);
  }, [l10]);
  const d10 = ep.useCallback((e15) => {
    u10(mrt(s10, e15, o10)), r10(n10, e15);
  }, [n10, s10, r10, o10]);
  const p10 = ep.useCallback((e15) => {
    const t11 = s10.find((t12) => t12.text === e15);
    return t11 ? prt(t11.value) : null;
  }, [s10]);
  const m10 = { dataAid: "shape-editor", block: true, size: "small", menuWidth: "100%", openOnFocus: true, menuMaxHeight: "default", value: c10, items: s10, customCSS: art, placeholder: drt(t10, i10), filterOnInput: true, onSelect: d10, generatePreview: p10, generateItemPreview: prt };
  return tp.createElement(tM, __spreadValues({}, m10));
};
const frt = (e14) => tp.createElement(hrt, __spreadProps(__spreadValues({}, e14), { toDisplayValue: (e15) => e15 }));
frt.displayName = "ShapeEditor";
const grt = _D(Uet(frt));
const yrt = () => {
  const { drill: e14 } = ep.useContext(yse);
  const { t: t10 } = vp("propertyEditors-RPX");
  const n10 = { size: "small", text: t10("style.textEdit", "Edit"), width: "100%", onClick: () => e14("Style", t10("style.drillCaptionStyle", "Style")), dataAid: "styles-button" };
  return tp.createElement(qm, __spreadValues({}, n10));
};
yrt.displayName = "StyleEditor";
const vrt = _D(yrt);
const brt = __spreadProps(__spreadValues({}, Hue), { boolean: (e14, t10) => tp.createElement(knt, __spreadValues({ key: t10 }, e14)), color: (e14, t10) => tp.createElement(Vnt, __spreadValues({ key: t10 }, e14)), enum: (e14, t10) => tp.createElement(vnt, __spreadValues({ key: t10 }, e14)), number: (e14, t10) => tp.createElement(qnt, __spreadProps(__spreadValues({}, e14), { key: t10 })), percent: (e14, t10) => tp.createElement(Ynt, __spreadProps(__spreadValues({}, e14), { key: t10 })), string: (e14, t10) => {
  var _a2;
  return tp.createElement(Knt, __spreadProps(__spreadValues({ key: t10 }, e14), { disabled: e14.disabled || ((_a2 = e14.descriptor.meta) == null ? void 0 : _a2.disabled) }));
}, rpx_border_color: (e14, t10) => tp.createElement(mtt, __spreadProps(__spreadValues({}, e14), { key: t10 })), rpx_border_style: (e14, t10) => tp.createElement(gtt, __spreadProps(__spreadValues({}, e14), { key: t10 })), rpx_data_field: (e14, t10) => tp.createElement(Ont, __spreadProps(__spreadValues({}, e14), { key: t10 })), rpx_class_name: (e14, t10) => tp.createElement(_nt, __spreadProps(__spreadValues({}, e14), { key: t10 })), rpx_format_string: (e14, t10) => tp.createElement(Gnt, __spreadProps(__spreadValues({}, e14), { key: t10 })), rpx_font_family: (e14, t10) => tp.createElement(znt, __spreadProps(__spreadValues({}, e14), { key: t10 })), rpx_font_size: (e14, t10) => tp.createElement(Znt, __spreadProps(__spreadValues({}, e14), { key: t10 })), rpx_style_font_style: (e14, t10) => tp.createElement(Jnt, __spreadProps(__spreadValues({}, e14), { key: t10 })), rpx_style_font_weight: (e14, t10) => tp.createElement(ert, __spreadProps(__spreadValues({}, e14), { key: t10 })), rpx_style_name: (e14, t10) => tp.createElement(rrt, __spreadProps(__spreadValues({}, e14), { key: t10 })), rpx_script_language: (e14, t10) => tp.createElement(ort, __spreadValues({ key: t10 }, e14)), rpx_line_style: (e14, t10) => tp.createElement(Unt, __spreadValues({ key: t10 }, e14)), rpx_length: (e14, t10) => tp.createElement(Ott, __spreadValues({ key: t10 }, e14)), rpx_dimensions: (e14, t10) => tp.createElement(Btt, __spreadValues({ key: t10 }, e14)), background_style: (e14, t10) => tp.createElement(att, __spreadValues({ key: t10 }, e14)), background_pattern: (e14, t10) => tp.createElement(qet, __spreadValues({ key: t10 }, e14)), gradient_style: (e14, t10) => tp.createElement(ytt, __spreadValues({ key: t10 }, e14)), image: (e14, t10) => tp.createElement(Stt, __spreadValues({ key: t10 }, e14)), margin: (e14, t10) => tp.createElement(jtt, __spreadValues({ key: t10 }, e14)), name: (e14, t10) => tp.createElement(Gtt, __spreadValues({ key: t10 }, e14)), padding: (e14, t10) => tp.createElement(ynt, __spreadValues({ key: t10 }, e14)), paperSize: (e14, t10) => tp.createElement(Ent, __spreadValues({ key: t10 }, e14)), radius: (e14, t10) => tp.createElement(Mnt, __spreadValues({ key: t10 }, e14)), shape: (e14, t10) => tp.createElement(grt, __spreadValues({ key: t10 }, e14)), styles: (e14, t10) => tp.createElement(vrt, __spreadValues({ key: t10 }, e14)) });
var Srt = {};
var Crt = {};
Object.defineProperty(Crt, "__esModule", { value: true });
var xrt = {};
Object.defineProperty(xrt, "__esModule", { value: true });
var wrt = {};
var Trt = {};
var Ert = {};
var Frt = {};
var Mrt = {};
!function(e14) {
  function t10(e15) {
    return null != e15 && "object" == typeof e15;
  }
  Object.defineProperty(e14, "__esModule", { value: true }), e14.isEqual = e14.isObjectLike = e14.isObject = e14.isArray = void 0, e14.isArray = Array.isArray, e14.isObject = function(e15) {
    var t11 = typeof e15;
    return null != e15 && ("object" == t11 || "function" == t11);
  }, e14.isObjectLike = t10, e14.isEqual = function n10(r10, o10) {
    return r10 === o10 || (null == r10 || null == o10 || !t10(r10) && !t10(o10) ? r10 != r10 && o10 != o10 : typeof r10 == typeof o10 && ("object" == typeof r10 && ((0, e14.isArray)(r10) ? r10.length === o10.length && r10.every(function(e15, t11) {
      return n10(e15, o10[t11]);
    }) : n10(Object.keys(r10).sort(), Object.keys(o10).sort()) && Object.keys(r10).every(function(e15) {
      return n10(r10[e15], o10[e15]);
    }))));
  };
}(Mrt), function(e14) {
  var t10 = $ && $.__assign || function() {
    return t10 = Object.assign || function(e15) {
      for (var t11, n11 = 1, r11 = arguments.length; n11 < r11; n11++) for (var o11 in t11 = arguments[n11]) Object.prototype.hasOwnProperty.call(t11, o11) && (e15[o11] = t11[o11]);
      return e15;
    }, t10.apply(this, arguments);
  };
  var n10 = $ && $.__spreadArray || function(e15, t11, n11) {
    if (n11 || 2 === arguments.length) for (var r11, o11 = 0, a11 = t11.length; o11 < a11; o11++) !r11 && o11 in t11 || (r11 || (r11 = Array.prototype.slice.call(t11, 0, o11)), r11[o11] = t11[o11]);
    return e15.concat(r11 || Array.prototype.slice.call(t11));
  };
  Object.defineProperty(e14, "__esModule", { value: true }), e14.orElse = e14.getLastRecordedFailures = e14.recordFailures = e14.upcast = e14.makeDefaultOf = e14.omit = e14.pick = e14.Enum = e14.members = e14.lazy = e14.iif = e14.alt = e14.intersectWith = e14.mapInput = e14.map = e14.arrayDef = e14.array = e14.typeDefReq = e14.typeReq = e14.required = e14.typeDef = e14.type = e14.withDefaultOf = e14.literalInit = e14.initValue = e14.DefaultOf = e14.Default = e14.nullable = e14.justRead = e14.optional = e14.boolean = e14.number = e14.string = e14.literal = e14.Temp = e14.Const = e14.unknown = e14.resultOf = e14.failure = e14.success = e14.pipe = e14.recordFailure = void 0;
  var r10 = Mrt;
  var o10 = [];
  function a10() {
    o10 = [];
  }
  function i10(e15) {
    o10.push(t10(t10({}, e15), { context: u10() }));
  }
  function s10(e15, t11, r11, o11) {
    var a11 = [];
    for (var i11 = 4; i11 < arguments.length; i11++) a11[i11 - 4] = arguments[i11];
    switch (arguments.length) {
      case 0:
        return;
      case 1:
        return e15;
      case 2:
        return t11(e15);
      case 3:
        return r11(t11(e15));
      case 4:
        return o11(r11(t11(e15)));
      default:
        return s10.apply(null, n10([o11(r11(t11(e15)))], a11, true));
    }
  }
  e14.recordFailure = i10, e14.pipe = s10;
  e14.success = function(e15, t11) {
    return void 0 === t11 && (t11 = []), { type: "success", value: e15, warnings: t11 };
  };
  e14.failure = function(e15) {
    return { type: "error", reason: e15 };
  };
  e14.resultOf = function(e15) {
    return "success" === e15.type ? e15.value : void 0;
  }, e14.unknown = { decode: function(t11) {
    return (0, e14.success)(t11);
  }, encode: function(e15) {
    return e15;
  } };
  e14.Const = function(t11) {
    return { decode: function() {
      return (0, e14.success)(t11);
    }, encode: function() {
    } };
  };
  var l10;
  function c10(e15, t11) {
    var n11 = l10;
    l10 = { part: e15, next: n11 };
    try {
      return t11();
    } finally {
      l10 = n11;
    }
  }
  function u10() {
    var e15 = [];
    for (var t11 = l10; null != t11 && t11.part; t11 = t11.next) e15.unshift(t11.part);
    return "".concat.apply("", e15);
  }
  e14.Temp = function(t11) {
    return { decode: function() {
      return (0, e14.success)(t11);
    }, encode: function() {
    } };
  };
  var d10 = function(e15) {
    var t11 = [];
    for (var n11 = 1; n11 < arguments.length; n11++) t11[n11 - 1] = arguments[n11];
    return -1 !== t11.findIndex(function(t12) {
      return t12 === e15;
    });
  };
  e14.literal = function() {
    var t11 = [];
    for (var r11 = 0; r11 < arguments.length; r11++) t11[r11] = arguments[r11];
    return { decode: function(r12) {
      return d10.apply(void 0, n10([r12], t11, false)) ? (0, e14.success)(r12) : (0, e14.failure)("expected ".concat(t11.map(function(e15) {
        return JSON.stringify(e15);
      }).join(" | "), ", got: '").concat(r12, "'"));
    }, encode: function(e15) {
      return "string" == typeof e15 || "number" == typeof e15 || null === e15 ? e15 : (i10({ type: "error", message: "expected a string value" }), null == e15 ? void 0 : e15.toString());
    } };
  }, e14.string = { decode: function(t11) {
    return "string" == typeof t11 ? (0, e14.success)(t11) : (0, e14.failure)("expected string");
  }, encode: function(e15) {
    return "string" == typeof e15 ? e15 : (i10({ type: "error", message: "expected a string value" }), null == e15 ? void 0 : e15.toString());
  } }, e14.number = { decode: function(t11) {
    return "number" != typeof t11 || Number.isNaN(t11) ? (0, e14.failure)("expected number") : (0, e14.success)(t11);
  }, encode: function(e15) {
    return "number" == typeof e15 ? e15 : (i10({ type: "error", message: "expected a numeric value" }), null == e15 || Number.isNaN(+e15) ? void 0 : +e15);
  } }, e14.boolean = { decode: function(t11) {
    return "boolean" == typeof t11 ? (0, e14.success)(t11) : (0, e14.failure)("expected boolean");
  }, encode: function(e15) {
    return "boolean" == typeof e15 ? e15 : (i10({ type: "error", message: "expected a bool value" }), null == e15 ? void 0 : !!e15);
  } };
  e14.optional = function(t11) {
    return { decode: function(n11) {
      return null == n11 ? (0, e14.success)(void 0) : t11.decode(n11);
    }, encode: function(e15) {
      return void 0 === e15 ? void 0 : t11.encode(e15);
    } };
  };
  e14.justRead = function(e15) {
    return { decode: e15.decode, encode: function() {
    } };
  };
  e14.nullable = function(t11) {
    return { decode: function(n11) {
      return null == n11 ? (0, e14.success)(null) : t11.decode(n11);
    }, encode: function(e15) {
      return null == e15 ? null : t11.encode(e15);
    } };
  };
  e14.Default = function(t11, n11) {
    return { decode: function(r11) {
      return void 0 === r11 ? (0, e14.success)(t11) : n11.decode(r11);
    }, encode: function(e15) {
      if (!Array.isArray(e15) || 0 !== e15.length || !Array.isArray(t11) || 0 !== t11.length) return (0, r10.isEqual)(e15, t11) ? void 0 : n11.encode(e15);
    } };
  };
  e14.DefaultOf = function(t11, n11) {
    var o11 = n11.decode(t11);
    if ("error" === o11.type) throw new Error("Failed to create a default result");
    var a11 = Object.freeze(o11.value);
    return { decode: function(t12) {
      return void 0 === t12 ? (0, e14.success)(a11) : n11.decode(t12);
    }, encode: function(e15) {
      var o12 = n11.encode(e15);
      return (0, r10.isEqual)(o12, t11) ? void 0 : o12;
    } };
  };
  e14.initValue = function(t11, n11) {
    return { decode: function(r11) {
      return void 0 === r11 ? (0, e14.success)(t11) : n11.decode(r11);
    }, encode: n11.encode };
  };
  e14.literalInit = function(t11) {
    return (0, e14.initValue)(t11, (0, e14.literal)(t11));
  };
  e14.withDefaultOf = function(t11) {
    return function(n11) {
      return (0, e14.DefaultOf)(t11, n11);
    };
  };
  e14.type = function(t11) {
    return { decode: function(n11) {
      if (null == n11) return (0, e14.failure)("non-null expected");
      var r11 = {};
      for (var o11 in t11) if ({}.hasOwnProperty.call(t11, o11)) {
        if (!t11[o11]) return (0, e14.failure)("".concat(o11, ": missing property"));
        var a11 = t11[o11].decode(n11[o11]);
        if ("error" === a11.type) return (0, e14.failure)("".concat(o11, ": ").concat(a11.reason));
        r11[o11] = a11.value;
      }
      return (0, e14.success)(r11);
    }, encode: function(e15) {
      if (null != e15) {
        var n11 = {};
        var r11 = function(r12) {
          if (!{}.hasOwnProperty.call(t11, r12)) return "continue";
          c10(".", function() {
            var o12 = c10(r12, function() {
              return t11[r12].encode(e15[r12]);
            });
            void 0 !== o12 && (n11[r12] = o12);
          });
        };
        for (var o11 in t11) r11(o11);
        return n11;
      }
      i10({ type: "error", message: "non-null value is expected" });
    } };
  };
  e14.typeDef = function(t11) {
    return (0, e14.DefaultOf)({}, (0, e14.type)(t11));
  };
  e14.required = function() {
    var e15 = [];
    for (var t11 = 0; t11 < arguments.length; t11++) e15[t11] = arguments[t11];
    return function(t12) {
      return { decode: function(n11) {
        var r11 = e15.find(function(e16) {
          return void 0 === n11[e16];
        });
        return null != r11 && i10({ type: "error", message: "Property ".concat(String(r11), " is marked as required, but not provided") }), t12.decode(n11);
      }, encode: function(e16) {
        return t12.encode(e16);
      } };
    };
  };
  e14.typeReq = function(t11, n11) {
    return s10((0, e14.type)(t11), e14.required.apply(void 0, n11));
  };
  e14.typeDefReq = function(t11, n11, r11) {
    return (0, e14.DefaultOf)(n11, (0, e14.typeReq)(t11, r11));
  };
  e14.array = function(t11) {
    return { decode: function(n11) {
      if (!(0, r10.isArray)(n11)) return (0, e14.failure)("array expected");
      var o11 = n11.map(t11.decode);
      var a11 = o11.find(function(e15) {
        return "error" === e15.type;
      });
      return a11 && "error" === a11.type ? (0, e14.failure)(a11.reason) : (0, e14.success)(o11.map(e14.resultOf));
    }, encode: function(e15) {
      if (null != e15) return (0, r10.isArray)(e15) ? e15.map(function(e16, n11) {
        return c10("[".concat(n11, "]"), function() {
          return t11.encode(e16);
        });
      }) : (i10({ type: "error", message: "array is expected" }), []);
    } };
  };
  e14.arrayDef = function(t11) {
    return (0, e14.Default)([], (0, e14.array)(t11));
  };
  e14.map = function(t11, n11) {
    return function(r11) {
      return { decode: function(n12) {
        var o11 = r11.decode(n12);
        return "error" === o11.type ? o11 : (0, e14.success)(t11(o11.value));
      }, encode: function(e15) {
        return r11.encode(n11(e15));
      } };
    };
  };
  e14.mapInput = function(e15, t11) {
    return function(n11) {
      return { decode: function(e16) {
        return n11.decode(t11(e16));
      }, encode: function(t12) {
        return e15(n11.encode(t12));
      } };
    };
  };
  e14.intersectWith = function(n11) {
    return function(r11) {
      return { decode: function(o11) {
        var a11 = r11.decode(o11);
        if ("error" === a11.type) return (0, e14.failure)(a11.reason);
        var i11 = n11.decode(o11);
        return "success" === i11.type ? (0, e14.success)(t10(t10({}, a11.value), i11.value)) : (0, e14.failure)(i11.reason);
      }, encode: function(e15) {
        return t10(t10({}, r11.encode(e15)), n11.encode(e15));
      } };
    };
  };
  e14.alt = function(t11, n11, r11) {
    return { decode: function(n12) {
      var o11 = t11(n12) || "";
      var a11 = r11[o11];
      return null == a11 ? (0, e14.failure)('Unknown or unsupported item type "'.concat(o11, '"')) : a11.decode(n12);
    }, encode: function(e15) {
      var t12 = r11[n11(e15)];
      if (null == t12) throw new Error("unknown item type '".concat(n11(e15), "'"));
      return t12.encode(e15);
    } };
  };
  e14.iif = function(e15, t11, n11, r11) {
    return { decode: function(t12) {
      return e15(t12) ? n11.decode(t12) : r11.decode(t12);
    }, encode: function(e16) {
      return t11(e16) ? n11.encode(e16) : r11.encode(e16);
    } };
  };
  e14.lazy = function() {
    var e15 = function() {
      throw new Error("Cannot get here");
    };
    var t11 = { decode: e15, encode: e15 };
    return [t11, function(e16) {
      t11.decode = e16.decode, t11.encode = e16.encode;
    }];
  };
  e14.members = function() {
    var t11 = [];
    for (var n11 = 0; n11 < arguments.length; n11++) t11[n11] = arguments[n11];
    var r11 = {};
    t11.forEach(function(e15) {
      r11[e15] = e15, r11[e15.toLowerCase()] = e15;
    });
    var o11 = "expected ".concat(t11.map(function(e15) {
      return JSON.stringify(e15);
    }).join(" | "));
    return { decode: function(t12) {
      var n12 = "string" == typeof t12 ? r11[t12] || r11[t12.toLowerCase()] : void 0;
      return void 0 !== n12 ? (0, e14.success)(n12) : (0, e14.failure)("".concat(o11, ", got: '").concat(t12, "'"));
    }, encode: function(e15) {
      return "string" == typeof e15 ? e15 : (i10({ type: "error", message: "expected a string value" }), null == e15 ? void 0 : e15.toString());
    } };
  };
  e14.Enum = function(t11, n11) {
    return { decode: function(r11) {
      if (void 0 === r11) return (0, e14.success)(t11);
      var o11 = n11.decode(r11);
      return "success" === o11.type ? o11 : (i10({ type: "error", message: o11.reason }), (0, e14.success)(t11));
    }, encode: function(e15) {
      return e15 === t11 ? void 0 : n11.encode(e15);
    } };
  }, e14.pick = function(e15) {
    var t11 = [];
    for (var n11 = 1; n11 < arguments.length; n11++) t11[n11 - 1] = arguments[n11];
    var r11 = {};
    for (var o11 = 0, a11 = t11; o11 < a11.length; o11++) {
      var i11 = a11[o11];
      r11[i11] = e15[i11];
    }
    return r11;
  }, e14.omit = function(e15) {
    var t11 = [];
    for (var n11 = 1; n11 < arguments.length; n11++) t11[n11 - 1] = arguments[n11];
    var r11 = {};
    var o11 = function(n12) {
      t11.find(function(e16) {
        return e16 === n12;
      }) || (r11[n12] = e15[n12]);
    };
    for (var a11 = 0, i11 = Object.keys(e15); a11 < i11.length; a11++) {
      o11(i11[a11]);
    }
    return r11;
  }, e14.makeDefaultOf = function(t11, n11) {
    return void 0 === n11 && (n11 = {}), Object.freeze((0, e14.resultOf)(t11.decode(n11)));
  };
  e14.upcast = function() {
    return function(e15) {
      return e15;
    };
  };
  e14.recordFailures = function(t11) {
    return { decode: function(n11) {
      a10();
      var r11 = t11.decode(n11);
      var i11 = o10;
      return "success" === r11.type ? (0, e14.success)(r11.value, i11) : r11;
    }, encode: function(e15) {
      return a10(), t11.encode(e15);
    } };
  };
  e14.getLastRecordedFailures = function() {
    return n10([], o10, true);
  };
  e14.orElse = function(e15, t11) {
    return function(n11) {
      return { decode: function(t12) {
        var r11 = n11.decode(t12);
        return "error" === r11.type ? (i10({ type: "warning", message: r11.reason }), e15.decode(t12)) : r11;
      }, encode: function(r11) {
        return t11(r11) ? e15.encode(r11) : n11.encode(r11);
      } };
    };
  };
}(Frt);
var krt = {};
var Prt = $ && $.__assign || function() {
  return Prt = Object.assign || function(e14) {
    for (var t10, n10 = 1, r10 = arguments.length; n10 < r10; n10++) for (var o10 in t10 = arguments[n10]) Object.prototype.hasOwnProperty.call(t10, o10) && (e14[o10] = t10[o10]);
    return e14;
  }, Prt.apply(this, arguments);
};
var Nrt = $ && $.__rest || function(e14, t10) {
  var n10 = {};
  for (var r10 in e14) Object.prototype.hasOwnProperty.call(e14, r10) && t10.indexOf(r10) < 0 && (n10[r10] = e14[r10]);
  if (null != e14 && "function" == typeof Object.getOwnPropertySymbols) {
    var o10 = 0;
    for (r10 = Object.getOwnPropertySymbols(e14); o10 < r10.length; o10++) t10.indexOf(r10[o10]) < 0 && Object.prototype.propertyIsEnumerable.call(e14, r10[o10]) && (n10[r10[o10]] = e14[r10[o10]]);
  }
  return n10;
};
Object.defineProperty(krt, "__esModule", { value: true }), krt.identity = krt.mapOfLens = krt.iif = krt.combine5 = krt.combine4 = krt.combine3 = krt.combine = krt.replace = krt.array = krt.nullable = krt.prop = krt.make = void 0;
var Drt = Frt;
krt.make = function(e14, t10) {
  return { f: e14, frev: t10 };
}, krt.prop = function(e14, t10) {
  return { f: function(n10) {
    var r10;
    var o10 = e14, a10 = n10[o10], i10 = Nrt(n10, ["symbol" == typeof o10 ? o10 : o10 + ""]);
    return Prt(Prt({}, i10), ((r10 = {})[e14] = t10.f(a10), r10));
  }, frev: function(n10) {
    var r10;
    var o10 = e14, a10 = n10[o10], i10 = Nrt(n10, ["symbol" == typeof o10 ? o10 : o10 + ""]);
    return Prt(Prt({}, i10), ((r10 = {})[e14] = t10.frev(a10), r10));
  } };
}, krt.nullable = function(e14) {
  return { f: function(t10) {
    return null === t10 ? null : e14.f(t10);
  }, frev: function(t10) {
    return null === t10 ? null : e14.frev(t10);
  } };
}, krt.array = function(e14) {
  return { f: function(t10) {
    return t10.map(e14.f);
  }, frev: function(t10) {
    return t10.map(e14.frev);
  } };
}, krt.replace = function(e14, t10) {
  return { f: function() {
    return t10;
  }, frev: function() {
    return e14;
  } };
}, krt.combine = function(e14, t10) {
  return { f: function(n10) {
    return t10.f(e14.f(n10));
  }, frev: function(n10) {
    return e14.frev(t10.frev(n10));
  } };
}, krt.combine3 = function(e14, t10, n10) {
  return { f: function(r10) {
    return n10.f(t10.f(e14.f(r10)));
  }, frev: function(r10) {
    return e14.frev(t10.frev(n10.frev(r10)));
  } };
}, krt.combine4 = function(e14, t10, n10, r10) {
  return { f: function(o10) {
    return r10.f(n10.f(t10.f(e14.f(o10))));
  }, frev: function(o10) {
    return e14.frev(t10.frev(n10.frev(r10.frev(o10))));
  } };
}, krt.combine5 = function(e14, t10, n10, r10, o10) {
  return { f: function(a10) {
    return o10.f(r10.f(n10.f(t10.f(e14.f(a10)))));
  }, frev: function(a10) {
    return e14.frev(t10.frev(n10.frev(r10.frev(o10.frev(a10)))));
  } };
}, krt.iif = function(e14, t10, n10, r10) {
  return { f: function(t11) {
    return e14(t11) ? n10.f(t11) : r10.f(t11);
  }, frev: function(e15) {
    return t10(e15) ? n10.frev(e15) : r10.frev(e15);
  } };
}, krt.mapOfLens = function(e14) {
  return (0, Drt.map)(e14.f, e14.frev);
}, krt.identity = function() {
  return { f: function(e14) {
    return e14;
  }, frev: function(e14) {
    return e14;
  } };
}, function(e14) {
  var t10 = $ && $.__createBinding || (Object.create ? function(e15, t11, n11, r10) {
    void 0 === r10 && (r10 = n11);
    var o10 = Object.getOwnPropertyDescriptor(t11, n11);
    o10 && !("get" in o10 ? !t11.__esModule : o10.writable || o10.configurable) || (o10 = { enumerable: true, get: function() {
      return t11[n11];
    } }), Object.defineProperty(e15, r10, o10);
  } : function(e15, t11, n11, r10) {
    void 0 === r10 && (r10 = n11), e15[r10] = t11[n11];
  });
  var n10 = $ && $.__exportStar || function(e15, n11) {
    for (var r10 in e15) "default" === r10 || Object.prototype.hasOwnProperty.call(n11, r10) || t10(n11, e15, r10);
  };
  Object.defineProperty(e14, "__esModule", { value: true }), e14.Helpers = e14.Lenses = void 0, n10(Frt, e14), e14.Lenses = krt, e14.Helpers = Mrt;
}(Ert);
var Lrt = {};
Object.defineProperty(Lrt, "__esModule", { value: true }), Lrt.string_optional = Lrt.string_empty = Lrt.number_default_zero = Lrt.color_default_transparent = Lrt.color_default_white = Lrt.color_default_black = Lrt.className_normal = Lrt.boolean_optional = Lrt.boolean_true = Lrt.boolean_false = void 0;
var Hrt = Ert;
Lrt.boolean_false = (0, Hrt.Default)(false, Hrt.boolean), Lrt.boolean_true = (0, Hrt.Default)(true, Hrt.boolean), Lrt.boolean_optional = (0, Hrt.optional)(Hrt.boolean), Lrt.className_normal = (0, Hrt.Default)("Normal", Hrt.string), Lrt.color_default_black = (0, Hrt.Default)("Black", Hrt.string), Lrt.color_default_white = (0, Hrt.Default)("White", Hrt.string), Lrt.color_default_transparent = (0, Hrt.Default)("Transparent", Hrt.string), Lrt.number_default_zero = (0, Hrt.Default)(0, Hrt.number), Lrt.string_empty = (0, Hrt.Default)("", Hrt.string), Lrt.string_optional = (0, Hrt.optional)(Hrt.string), function(e14) {
  var t10 = $ && $.__assign || function() {
    return t10 = Object.assign || function(e15) {
      for (var t11, n11 = 1, r11 = arguments.length; n11 < r11; n11++) for (var o11 in t11 = arguments[n11]) Object.prototype.hasOwnProperty.call(t11, o11) && (e15[o11] = t11[o11]);
      return e15;
    }, t10.apply(this, arguments);
  };
  Object.defineProperty(e14, "__esModule", { value: true }), e14.DataSource = e14.NonSerializableDataSource = e14.OleDbDataSource = e14.OdbcDataSource = e14.SqlDataSource = e14.XmlDataSource = e14.JsonDataSource = e14.CsvDataSource = void 0;
  var n10 = Ert;
  var r10 = Lrt;
  var o10 = function(e15) {
    return { Type: (0, n10.literalInit)(e15), DataMember: r10.string_optional };
  };
  e14.CsvDataSource = (0, n10.type)(t10(t10({}, o10("CSV")), { ConnectionString: n10.string })), e14.JsonDataSource = (0, n10.type)(t10(t10({}, o10("JSON")), { ConnectionString: n10.string, JsonPath: n10.string })), e14.XmlDataSource = (0, n10.type)(t10(t10({}, o10("XML")), { FileURL: n10.string, Pattern: n10.string })), e14.SqlDataSource = (0, n10.type)(t10(t10({}, o10("SQL")), { ConnectionString: n10.string, CommandText: n10.string, CommandTimeout: n10.number })), e14.OdbcDataSource = (0, n10.type)(t10(t10({}, o10("ODBC")), { ConnectionString: n10.string, CommandText: n10.string, CommandTimeout: n10.number })), e14.OleDbDataSource = (0, n10.type)(t10(t10({}, o10("OLEDB")), { ConnectionString: n10.string, CommandText: n10.string, CommandTimeout: n10.number })), e14.NonSerializableDataSource = (0, n10.type)(t10(t10({}, o10("NonSerializable")), { Name: n10.string })), e14.DataSource = (0, n10.alt)(function(e15) {
    return e15.Type;
  }, function(e15) {
    return e15.Type;
  }, { CSV: e14.CsvDataSource, JSON: e14.JsonDataSource, XML: e14.XmlDataSource, SQL: e14.SqlDataSource, ODBC: e14.OdbcDataSource, OLEDB: e14.OleDbDataSource, NonSerializable: e14.NonSerializableDataSource });
}(Trt);
var Irt = {};
var _rt = {};
var Vrt = {};
Object.defineProperty(Vrt, "__esModule", { value: true }), Vrt.Enums = void 0;
var Rrt = Ert;
Vrt.Enums = { BarCodeStyle: (0, Rrt.members)("None", "Ansi39", "Ansi39x", "Code_2_of_5", "Code25intlv", "Code25mat", "Matrix_2_of_5", "Code39", "Code39x", "Code_128_A", "Code_128_B", "Code_128_C", "Code_128auto", "Code_93", "Code93x", "MSI", "PostNet", "Codabar", "EAN_8", "EAN_13", "UPC_A", "UPC_E0", "UPC_E1", "RM4SCC", "UCCEAN128", "QRCode", "Code49", "JapanesePostal", "Pdf417", "EAN128FNC1", "RSS14", "RSS14Truncated", "RSS14Stacked", "RSS14StackedOmnidirectional", "RSSExpanded", "RSSExpandedStacked", "RSSLimited", "DataMatrix", "MicroPDF417", "MicroQRCode", "MaxiCode", "GS1QRCode", "GS1DataMatrix", "Aztec", "IntelligentMail", "ITF14", "Code_11", "SSCC_18", "Telepen", "Pharmacode", "PZN", "HIBCCode128", "HIBCCode39", "ISBN", "ISSN", "ISMN", "IATA_2_of_5", "BC412", "Plessey", "IntelligentMailPackage"), BarCodeCaptionPosition: (0, Rrt.members)("None", "Above", "Below"), BarCodeRotation: (0, Rrt.members)("None", "Rotate90Degrees", "Rotate180Degrees", "Rotate270Degrees"), Ecc200SymbolSize: (0, Rrt.members)("SquareAuto", "RectangularAuto", "Square10", "Square12", "Square14", "Square16", "Square18", "Square20", "Square22", "Square24", "Square26", "Square32", "Square36", "Square40", "Square44", "Square48", "Square52", "Square64", "Square72", "Square80", "Square88", "Square96", "Square104", "Square120", "Square132", "Square144", "Rectangular8x18", "Rectangular8x32", "Rectangular12x26", "Rectangular12x36", "Rectangular16x36", "Rectangular16x48"), Ecc000SymbolSize: (0, Rrt.members)("Auto", "Square9", "Square11", "Square13", "Square15", "Square17", "Square19", "Square21", "Square23", "Square25", "Square27", "Square29", "Square31", "Square33", "Square35", "Square37", "Square39", "Square41", "Square43", "Square45", "Square47", "Square49"), MicroPdf417Version: (0, Rrt.members)("ColumnPriorAuto", "RowPriorAuto", "Version1X11", "Version1X14", "Version1X17", "Version1X20", "Version1X24", "Version1X28", "Version2X8", "Version2X11", "Version2X14", "Version2X17", "Version2X20", "Version2X23", "Version2X26", "Version3X6", "Version3X8", "Version3X10", "Version3X12", "Version3X15", "Version3X20", "Version3X26", "Version3X32", "Version3X38", "Version3X44", "Version4X4", "Version4X6", "Version4X8", "Version4X10", "Version4X12", "Version4X15", "Version4X20", "Version4X26", "Version4X32", "Version4X38", "Version4X44"), ColumnDirection: (0, Rrt.members)("DownAcross", "AcrossDown"), GroupKeepTogether: (0, Rrt.members)("None", "FirstDetail", "All"), RepeatStyle: (0, Rrt.members)("None", "OnPage", "OnColumn", "All", "OnPageIncludeNoDetail"), NewPage: (0, Rrt.members)("None", "Before", "After", "BeforeAfter"), NewColumn: (0, Rrt.members)("None", "Before", "After", "BeforeAfter"), ScriptLanguage: (0, Rrt.members)("C#", "VB.NET"), CompatibilityMode: (0, Rrt.members)("GDI", "CrossPlatform"), FieldType: (0, Rrt.members)("None", "String", "Date", "Int32", "Float", "Double", "Boolean"), ParameterType: (0, Rrt.members)("String", "Date", "Boolean"), Collate: (0, Rrt.members)("Default", "Collate", "DontCollate"), Duplex: (0, Rrt.members)("Default", "Simplex", "Vertical", "Horizontal"), PageOrientation: (0, Rrt.members)("Default", "Portrait", "Landscape"), PaperSourceKind: (0, Rrt.members)("AutomaticFeed", "Manual", "Cassette"), PaperKind: (0, Rrt.members)("Letter", "Tabloid", "Legal", "Executive", "A3", "A4", "A5", "A6", "JISB4", "JISB4", "JISB4", "ISOB5", "Custom"), StringAlignment: (0, Rrt.members)("Near", "Center", "Far"), ContentAlignment: (0, Rrt.members)("TopLeft", "TopCenter", "TopRight", "MiddleLeft", "MiddleCenter", "MiddleRight", "BottomLeft", "BottomCenter", "BottomRight"), LineStyle: (0, Rrt.members)("Transparent", "Solid", "Dash", "Dot", "DashDot", "DashDotDot", "Double"), BorderStyle: (0, Rrt.members)("None", "Solid", "Dash", "Dot", "DashDot", "ThickSolid", "Double", "ThickDashDotDot", "ThickDash", "ThickDashDot", "ThickDot", "ExtraThickSolid", "ThickDouble"), SizeMode: (0, Rrt.members)("Clip", "Stretch", "Zoom"), PictureAlignment: (0, Rrt.members)("TopLeft", "TopRight", "Center", "BottomLeft", "BottomRight"), ShapeStyle: (0, Rrt.members)("Rectangle", "Ellipse", "RoundRect"), BackgroundStyle: (0, Rrt.members)("Solid", "Gradient", "Pattern"), GradientStyle: (0, Rrt.members)("Horizontal", "Vertical", "DiagonalUp", "DiagonalDown", "FromCenter", "FromCorner"), HatchStyle: (0, Rrt.members)("Horizontal", "Min", "Vertical", "ForwardDiagonal", "BackwardDiagonal", "Cross", "LargeGrid", "Max", "DiagonalCross", "Percent05", "Percent10", "Percent20", "Percent25", "Percent30", "Percent40", "Percent50", "Percent60", "Percent70", "Percent75", "Percent80", "Percent90", "LightDownwardDiagonal", "LightUpwardDiagonal", "DarkDownwardDiagonal", "DarkUpwardDiagonal", "WideDownwardDiagonal", "WideUpwardDiagonal", "LightVertical", "LightHorizontal", "NarrowVertical", "NarrowHorizontal", "DarkVertical", "DarkHorizontal", "DashedDownwardDiagonal", "DashedUpwardDiagonal", "DashedHorizontal", "DashedVertical", "SmallConfetti", "LargeConfetti", "ZigZag", "Wave", "DiagonalBrick", "HorizontalBrick", "Weave", "Plaid", "Divot", "DottedGrid", "DottedDiamond", "Shingle", "Trellis", "Sphere", "SmallGrid", "SmallCheckerBoard", "LargeCheckerBoard", "OutlinedDiamond", "SolidDiamond"), SectionType: (0, Rrt.members)("Detail", "PageHeader", "PageFooter", "ReportHeader", "ReportFooter", "GroupHeader", "GroupFooter"), SummaryType: (0, Rrt.members)("None", "GrandTotal", "PageTotal", "SubTotal", "PageCount"), SummaryFunc: (0, Rrt.members)("Sum", "Avg", "Count", "Min", "Max", "Var", "VarP", "StdDev", "StdDevP", "DSum", "DAvg", "DCount", "DVar", "DVarP", "DStdDev", "DStdDevP"), SummaryRunning: (0, Rrt.members)("None", "Group", "All"), RichTextType: (0, Rrt.members)("Rtf", "Html", "Text"), RichTextRenderingType: (0, Rrt.members)("RTF", "Metafile", "PNG", "TransparentPNG"), TextAlign: (0, Rrt.members)("Left", "Right", "Center", "Justify"), TextJustify: (0, Rrt.members)("Auto", "Inter_word", "Inter_ideograph", "Distribute", "Distribute_all_lines", "Newspaper"), VerticalAlign: (0, Rrt.members)("BaseLine", "Sub", "Super", "Top", "TextTop", "Middle", "TextBottom", "Bottom"), FontWeight: (0, Rrt.members)("Normal", "Bold"), FontStyle: (0, Rrt.members)("Normal", "Italic"), WhiteSpace: (0, Rrt.members)("Normal", "Pre", "NoWrap"), WordWrap: (0, Rrt.members)("NoWrap", "WordWrap", "CharWrap"), Kinsoku: (0, Rrt.members)("Auto", "None", "True"), BackdropStyle: (0, Rrt.members)("Transparent", "Solid", "Gradient", "Pattern", "Picture"), Gradient: (0, Rrt.members)("Horizontal", "Vertical", "DiagonalUp", "DiagonalDown", "FromCenter", "FromCorner"), Pattern: (0, Rrt.members)("Horizontal", "Vertical", "ForwardDiagonal", "BackwardDiagonal", "Cross", "DiagonalCross", "Percent05", "Percent10", "Percent20", "Percent25", "Percent30", "Percent40", "Percent50", "Percent60", "Percent70", "Percent75", "Percent80", "Percent90", "LightDownwardDiagonal", "LightUpwardDiagonal", "DarkDownwardDiagonal", "DarkUpwardDiagonal", "WideDownwardDiagonal", "WideUpwardDiagonal", "LightVertical", "LightHorizontal", "NarrowVertical", "NarrowHorizontal", "DarkVertical", "DarkHorizontal", "DashedDownwardDiagonal", "DashedUpwardDiagonal", "DashedHorizontal", "DashedVertical", "SmallConfetti", "LargeConfetti", "ZigZag", "Wave", "DiagonalBrick", "HorizontalBrick", "Weave", "Plaid", "Divot", "DottedGrid", "DottedDiamond", "Shingle", "Trellis", "Sphere", "SmallGrid", "SmallCheckerBoard", "LargeCheckerBoard", "OutlinedDiamond", "SolidDiamond", "LargeGrid", "Min", "Max"), BackdropPictureAlignment: (0, Rrt.members)("Streched", "Tiled", "Centered", "Top", "Left", "Bottom", "Right"), ProjectionType: (0, Rrt.members)("Identical", "Orthogonal", "Perspective"), LightType: (0, Rrt.members)("Ambient", "InfiniteDirectional", "FiniteDirectional"), ArrowType: (0, Rrt.members)("None", "Triangle", "Lines"), AxisKind: (0, Rrt.members)("Axis", "CustomAxis"), AxisType: (0, Rrt.members)("Categorical", "Numerical", "Logarithmic"), DockType: (0, Rrt.members)("Top", "Bottom", "Left", "Right"), Alignment: (0, Rrt.members)("Center", "Top", "Bottom", "Left", "Right", "TopLeft", "TopRight", "BottomLeft", "BottomRight"), ColorPalette: (0, Rrt.members)("None", "Default", "Cascade", "Springtime", "Iceburg", "Iceberg", "Confetti", "Greens", "Berries", "Autumn", "Murphy"), UIOptions: (0, Rrt.members)("None", "ContextCustomize", "UseCustomTooltips", "ForceHitTesting"), ChartType: (0, Rrt.members)("Area", "Area3D", "Bar2D", "Bar3D", "Bezier", "BezierXY", "BezierXY3D", "Bezier3D", "Bubble", "BubbleXY", "Candle", "ClusteredBar", "Doughnut", "Doughnut3D", "Funnel", "Funnel3D", "Gantt", "Gantt3D", "HiLo", "HiLoOpenClose", "HorizontalBar", "HorizontalBar3D", "Kagi", "Kagi3D", "Line", "Line3D", "LineXY", "LineXY3D", "PlotXY", "PointAndFigure", "Pyramid", "Pyramid3D", "Renko", "Renko3D", "Scatter", "StackedArea", "StackedArea3D", "StackedBar", "StackedBar3D", "StackedArea100Pct", "StackedArea3D100Pct", "StackedBar100Pct", "StackedBar3D100Pct", "ThreeLineBreak", "ThreeLineBreak3D"), AntiAliasMode: (0, Rrt.members)("Auto", "None", "Graphics", "Text", "Both"), LegendMode: (0, Rrt.members)("Auto", "Series", "Points"), MarkerStyle: (0, Rrt.members)("None", "Point", "Square", "Circle", "Triangle", "InvTriangle", "Diamond", "Pyramid", "Cross"), StdLegendMarker: (0, Rrt.members)("None", "Line", "Bar", "Area"), AnchorPlacementType: (0, Rrt.members)("TopLeft", "Top", "TopRight", "Left", "Center", "Right", "BottomLeft", "Bottom", "BottomRight"), LineJoin: (0, Rrt.members)("Miter", "Bevel", "Round", "MiterClipped"), BarType: (0, Rrt.members)("Bar", "Cone", "Custom", "Cylinder", "Pyramid"), BaseStyle: (0, Rrt.members)("CircularBase", "SquareBase"), LabelsPlacement: (0, Rrt.members)("Left", "Right"), FunnelStyle: (0, Rrt.members)("YIsWidth", "YIsHeight") };
var Art = {};
!function(e14) {
  var t10 = $ && $.__assign || function() {
    return t10 = Object.assign || function(e15) {
      for (var t11, n11 = 1, r11 = arguments.length; n11 < r11; n11++) for (var o11 in t11 = arguments[n11]) Object.prototype.hasOwnProperty.call(t11, o11) && (e15[o11] = t11[o11]);
      return e15;
    }, t10.apply(this, arguments);
  };
  Object.defineProperty(e14, "__esModule", { value: true }), e14.Control = e14.Border = e14.borderDecoders = e14.Padding = e14.ControlLocationProperties = e14.ControlProperties = void 0;
  var n10 = Ert;
  var r10 = Lrt;
  var o10 = Vrt;
  e14.ControlProperties = { Name: n10.string, Visible: r10.boolean_true, DataField: r10.string_optional, Tag: r10.string_optional }, e14.ControlLocationProperties = { Left: r10.number_default_zero, Top: r10.number_default_zero, Width: r10.number_default_zero, Height: r10.number_default_zero };
  e14.Padding = function() {
    return { PaddingTop: r10.number_default_zero, PaddingRight: r10.number_default_zero, PaddingBottom: r10.number_default_zero, PaddingLeft: r10.number_default_zero };
  }, e14.borderDecoders = { BottomColor: r10.color_default_black, LeftColor: r10.color_default_black, RightColor: r10.color_default_black, TopColor: r10.color_default_black, BottomStyle: (0, n10.optional)((0, n10.Enum)("None", o10.Enums.BorderStyle)), LeftStyle: (0, n10.optional)((0, n10.Enum)("None", o10.Enums.BorderStyle)), RightStyle: (0, n10.optional)((0, n10.Enum)("None", o10.Enums.BorderStyle)), TopStyle: (0, n10.optional)((0, n10.Enum)("None", o10.Enums.BorderStyle)) }, e14.Border = (0, n10.DefaultOf)({}, (0, n10.type)(e14.borderDecoders));
  e14.Control = function(r11) {
    return t10(t10({ Type: (0, n10.literalInit)(r11) }, e14.ControlProperties), e14.ControlLocationProperties);
  };
}(Art);
var Ort = $ && $.__assign || function() {
  return Ort = Object.assign || function(e14) {
    for (var t10, n10 = 1, r10 = arguments.length; n10 < r10; n10++) for (var o10 in t10 = arguments[n10]) Object.prototype.hasOwnProperty.call(t10, o10) && (e14[o10] = t10[o10]);
    return e14;
  }, Ort.apply(this, arguments);
};
Object.defineProperty(_rt, "__esModule", { value: true }), _rt.Barcode = void 0;
var Brt = Ert;
var zrt = Lrt;
var $rt = Vrt;
var Wrt = Art;
_rt.Barcode = (0, Brt.pipe)((0, Brt.type)(Ort(Ort({}, (0, Wrt.Control)("Barcode")), { Border: Wrt.Border, Style: (0, Brt.Enum)("Ansi39", $rt.Enums.BarCodeStyle), FontFamily: (0, Brt.DefaultOf)("Courier New", Brt.string), FontSize: (0, Brt.DefaultOf)("8pt", Brt.string), FontWeight: (0, Brt.Enum)("Normal", $rt.Enums.FontWeight), FontStyle: (0, Brt.Enum)("Normal", $rt.Enums.FontStyle), FontUnderline: zrt.boolean_false, FontLinethrough: zrt.boolean_false, BackColor: zrt.color_default_transparent, ForeColor: zrt.color_default_black, BarWidth: zrt.number_default_zero, BarHeight: zrt.number_default_zero, SupplementBarHeight: zrt.number_default_zero, Alignment: (0, Brt.Enum)("Center", $rt.Enums.StringAlignment), Text: zrt.string_empty, SupplementText: zrt.string_empty, CaptionGrouping: zrt.boolean_true, CaptionPosition: (0, Brt.Enum)("None", $rt.Enums.BarCodeCaptionPosition), SupplementCaptionPosition: (0, Brt.Enum)("Above", $rt.Enums.BarCodeCaptionPosition), Rotation: (0, Brt.Enum)("None", $rt.Enums.BarCodeRotation), AutoSize: zrt.boolean_true, CheckSumEnabled: zrt.boolean_true, QuietZoneLeft: zrt.number_default_zero, QuietZoneRight: zrt.number_default_zero, QuietZoneTop: zrt.number_default_zero, QuietZoneBottom: zrt.number_default_zero, NWRatio: zrt.number_default_zero, SupplementDataField: zrt.string_empty, SupplementSpacing: zrt.number_default_zero, ValueBinary: zrt.string_optional, AztecOptions: (0, Brt.typeDef)({ ErrorCorrection: (0, Brt.DefaultOf)(33, Brt.number), Layers: zrt.number_default_zero, Encoding: (0, Brt.DefaultOf)("65001", Brt.string) }), Code128Options: (0, Brt.typeDef)({ Dpi: zrt.number_default_zero, BarAdjust: zrt.number_default_zero, ModuleSize: zrt.number_default_zero }), Code49Options: (0, Brt.typeDef)({ Grouping: zrt.boolean_false, Group: zrt.number_default_zero }), DataMatrixOptions: (0, Brt.typeDef)({ EccMode: (0, Brt.Enum)("ECC200", (0, Brt.members)("ECC000", "ECC050", "ECC080", "ECC100", "ECC140", "ECC200")), Ecc200SymbolSize: (0, Brt.Enum)("SquareAuto", $rt.Enums.Ecc200SymbolSize), Ecc200EncodingMode: (0, Brt.Enum)("Auto", (0, Brt.members)("Auto", "ASCII", "C40", "Text", "X12", "EDIFACT", "Base256")), Ecc000_140SymbolSize: (0, Brt.Enum)("Auto", $rt.Enums.Ecc000SymbolSize), StructuredAppend: zrt.boolean_false, StructureNumber: zrt.number_default_zero, FileIdentifier: zrt.number_default_zero, Encoding: (0, Brt.DefaultOf)("65001", Brt.string) }), Gs1CompositeOptions: (0, Brt.typeDef)({ Type: (0, Brt.Enum)("None", (0, Brt.members)("None", "CCA")), Value: zrt.string_empty }), MaxiCodeOptions: (0, Brt.typeDef)({ Mode: (0, Brt.Enum)("Mode4", (0, Brt.members)("Mode2", "Mode3", "Mode4", "Mode5", "Mode6")) }), MicroPdf417Options: (0, Brt.typeDef)({ CompactionMode: (0, Brt.Enum)("Auto", (0, Brt.members)("Auto", "TextCompactionMode", "NumericCompactionMode", "ByteCompactionMode")), FileID: zrt.number_default_zero, SegmentCount: zrt.number_default_zero, SegmentIndex: zrt.number_default_zero, Version: (0, Brt.Enum)("ColumnPriorAuto", $rt.Enums.MicroPdf417Version) }), MicroQrCodeOptions: (0, Brt.typeDef)({ Encoding: (0, Brt.DefaultOf)("65001", Brt.string), ErrorLevel: (0, Brt.Enum)("L", (0, Brt.members)("L", "M", "Q")), Mask: (0, Brt.Enum)("Auto", (0, Brt.members)("Auto", "Mask00", "Mask01", "Mask10", "Mask11")), Version: (0, Brt.Enum)("Auto", (0, Brt.members)("Auto", "M1", "M2", "M3", "M4")) }), Pdf417Options: (0, Brt.typeDef)({ Column: (0, Brt.DefaultOf)(-1, Brt.number), Row: (0, Brt.DefaultOf)(-1, Brt.number), ErrorLevel: (0, Brt.DefaultOf)(-1, Brt.number), Type: (0, Brt.Enum)("Normal", (0, Brt.members)("Normal", "Simple")) }), QrCodeOptions: (0, Brt.typeDef)({ Connection: zrt.boolean_false, ConnectionNumber: zrt.number_default_zero, Encoding: (0, Brt.DefaultOf)("65001", Brt.string), ErrorLevel: (0, Brt.Enum)("L", (0, Brt.members)("M", "L", "H", "Q")), Mask: (0, Brt.Enum)("Auto", (0, Brt.members)("Auto", "Mask000", "Mask001", "Mask010", "Mask011", "Mask100", "Mask101", "Mask110", "Mask111")), Model: (0, Brt.Enum)("Model2", (0, Brt.members)("Model1", "Model2")), Version: (0, Brt.DefaultOf)(-1, Brt.number) }), RssExpandedStacked: (0, Brt.typeDef)({ RowCount: (0, Brt.DefaultOf)(2, Brt.number) }) })), (0, Brt.required)("Name"));
var jrt = {};
!function(e14) {
  var t10 = $ && $.__assign || function() {
    return t10 = Object.assign || function(e15) {
      for (var t11, n11 = 1, r11 = arguments.length; n11 < r11; n11++) for (var o11 in t11 = arguments[n11]) Object.prototype.hasOwnProperty.call(t11, o11) && (e15[o11] = t11[o11]);
      return e15;
    }, t10.apply(this, arguments);
  };
  Object.defineProperty(e14, "__esModule", { value: true }), e14.Chart = e14.Annotation = void 0;
  var n10 = Ert;
  var r10 = Lrt;
  var o10 = Vrt;
  var a10 = Art;
  var i10 = (0, n10.typeDef)({ Style: (0, n10.Enum)("Solid", o10.Enums.BackdropStyle), Color: r10.color_default_white, Gradient: (0, n10.Enum)("Vertical", o10.Enums.Gradient), Pattern: (0, n10.Enum)("DottedGrid", o10.Enums.Pattern), Color2: r10.color_default_white, Picture: r10.string_optional, PictureAlignment: (0, n10.Enum)("Stretched", o10.Enums.BackdropPictureAlignment), Alpha: (0, n10.Default)(255, n10.number), HasTransparancy: r10.boolean_false });
  var s10 = (0, n10.typeDef)({ Color: r10.color_default_black, Style: (0, n10.Enum)("Solid", o10.Enums.LineStyle), Weight: (0, n10.Default)(1, n10.number) });
  var l10 = (0, n10.typeDef)({ Line: s10, ShadowColor: (0, n10.Default)("Gray", n10.string), ShadowWeight: r10.number_default_zero });
  var c10 = (0, n10.typeDef)({ Line: s10, GridLine: s10, Step: (0, n10.Default)(1, n10.number), Length: (0, n10.Default)(5, n10.number), Visible: r10.boolean_true });
  var u10 = (0, n10.typeDef)({ Color: r10.color_default_black, Angle: r10.number_default_zero, FontFamily: r10.string_empty, FontSize: (0, n10.Default)("10pt", n10.string), FontWeight: (0, n10.Enum)("Inherit", o10.Enums.FontWeight), FontStyle: (0, n10.Enum)("Inherit", o10.Enums.FontStyle) });
  var d10 = (0, n10.typeDef)({ Name: r10.string_empty, Kind: (0, n10.initValue)("Axis", o10.Enums.AxisKind), TickOffset: (0, n10.Default)(NaN, n10.number), Position: (0, n10.Default)(NaN, n10.number), SmartLabels: r10.boolean_true, Arrow: (0, n10.Enum)("None", o10.Enums.ArrowType), AxisType: (0, n10.Enum)("Numerical", o10.Enums.AxisType), Min: (0, n10.Default)(NaN, n10.number), Max: (0, n10.Default)(NaN, n10.number), Title: r10.string_empty, TitleFont: u10, MajorTick: c10, MinorTick: c10, Line: s10, LabelFont: u10, LabelsGap: (0, n10.Default)(1, n10.number), LabelFormat: (0, n10.Default)("{0}", n10.string), Labels: (0, n10.arrayDef)(n10.string), LabelsInside: r10.boolean_false, LabelsAtBottom: r10.boolean_false, LabelsVisible: r10.boolean_true, Scale: (0, n10.Default)(1, n10.number), DisplayScale: r10.boolean_false, Visible: r10.boolean_true, StaggerLabels: r10.boolean_false });
  var p10 = n10.initValue;
  var m10 = (0, n10.typeDef)({ Width: (0, n10.Default)(0, n10.number), Backdrop: i10, Visible: r10.boolean_true, AntiAliasMode: (0, n10.Enum)("Auto", o10.Enums.AntiAliasMode) });
  var h10 = (0, n10.typeDef)({ Border: l10, Padding: (0, n10.typeDef)({ Top: p10(12, n10.number), Right: p10(12, n10.number), Bottom: p10(12, n10.number), Left: p10(12, n10.number) }), ZDepthRatio: (0, n10.Default)(1, n10.number), WallXZ: m10, WallXY: m10, WallYZ: m10, Projection: (0, n10.typeDef)({ ProjectionType: (0, n10.Enum)("Identical", o10.Enums.ProjectionType), ProjectionDX: p10(0.1, n10.number), ProjectionDY: p10(0.1, n10.number), HorizontalRotation: (0, n10.Default)(0, n10.number), VerticalRotation: (0, n10.Default)(0, n10.number) }), Light: (0, n10.typeDef)({ Type: (0, n10.Enum)("Ambient", o10.Enums.LightType), Source: (0, n10.typeDef)({ X: p10(10, n10.number), Y: p10(40, n10.number), Z: p10(20, n10.number) }), DirectionalRatio: (0, n10.Default)(0.5, n10.number) }), Axes: (0, n10.arrayDef)(d10), WallRanges: (0, n10.arrayDef)((0, n10.typeDef)({ AdjacentAxes: (0, n10.arrayDef)(r10.string_empty), PrimaryAxis: r10.string_empty, DrawOnTopOfGridLines: r10.boolean_false, StartValue: (0, n10.Default)(0, n10.number), EndValue: (0, n10.Default)(0, n10.number), Backdrop: i10, Visible: r10.boolean_true, Border: l10 })), SwapAxesDirection: r10.boolean_false, SeriesLine: (0, n10.typeDef)({ LineColor: r10.color_default_black, LineStyle: (0, n10.Enum)("None", o10.Enums.LineStyle), LineWeight: (0, n10.Default)(1, n10.number) }) });
  var f10 = (0, n10.typeDef)({ AntiAliasMode: (0, n10.Enum)("Auto", o10.Enums.AntiAliasMode), Border: s10, Backdrop: i10, Font: u10, Format: (0, n10.Default)("{Value}", n10.string), Alignment: (0, n10.Enum)("Bottom", o10.Enums.Alignment) });
  var g10 = (0, n10.typeDef)({ AntiAliasMode: (0, n10.Enum)("Auto", o10.Enums.AntiAliasMode), Backdrop: i10, Label: f10, LabelDistanceFactor: (0, n10.Default)(1, n10.number), Line: s10, Size: (0, n10.Default)(10, n10.number), Style: (0, n10.Enum)("Triangle", o10.Enums.MarkerStyle) });
  var y10 = (0, n10.type)({ Backdrop: i10, Line: s10, Marker: g10, Tooltip: f10, Gap: n10.number, ExplodeFactor: n10.number, OutsideLabels: n10.boolean, HoleSize: n10.number, StartAngle: n10.number, Clockwise: n10.boolean, LineBackdrop: i10, BorderLine: s10, Thickness: n10.number, Width: n10.number, LineJoin: o10.Enums.LineJoin, BarType: o10.Enums.BarType, BarTopPercent: n10.number, VertexNumber: n10.number, RotationAngle: n10.number, PointBarDepth: n10.number, BodyDownswingBackdrop: i10, BodyUpswingBackdrop: i10, WickLine: s10, BodyWidth: n10.number, CloseLine: s10, OpenLine: s10, HiLoLine: s10, TickLen: n10.number, Shape: o10.Enums.MarkerStyle, MaxSizeFactor: n10.number, MinValue: n10.number, MaxValue: n10.number, PointGapPct: n10.number, MinPointHeight: n10.number, BaseStyle: o10.Enums.BaseStyle, OutsideLabelsPlacement: o10.Enums.LabelsPlacement, FunnelStyle: o10.Enums.FunnelStyle, NeckWidth: n10.number, NeckHeight: n10.number, CalloutLine: s10, BoxSize: n10.number, ReversalAmount: n10.number, NewLineBreak: n10.number, UpswingLine: s10, DownswingLine: s10, Tension: n10.number, Radius: n10.number });
  var v10 = (0, n10.typeDef)({ DisplayInLegend: (0, n10.Default)(null, n10.boolean), IsEmpty: r10.boolean_false, LegendText: r10.string_empty, XValue: r10.string_empty, YValues: (0, n10.arrayDef)(n10.number) });
  var b10 = (0, n10.typeDef)({ X: r10.number_default_zero, Y: r10.number_default_zero });
  var S10 = (0, n10.typeDef)({ Type: (0, n10.literalInit)("Bar"), AnchorPlacement: (0, n10.Enum)("TopLeft", o10.Enums.AnchorPlacementType), Backdrop: i10, Line: s10, AnchorPoint: b10, Width: r10.number_default_zero, Height: r10.number_default_zero, RotationAngle: r10.number_default_zero, Font: u10, Text: r10.string_empty, Name: r10.string_empty, AntiAliasMode: (0, n10.Enum)("Auto", o10.Enums.AntiAliasMode) });
  var C10 = (0, n10.typeDef)({ Type: (0, n10.literalInit)("Line"), StartPoint: b10, EndPoint: b10, Line: s10, StartConnection: r10.string_empty, EndConnection: r10.string_empty, StartConnectionIndex: r10.number_default_zero, EndConnectionIndex: r10.number_default_zero, AntiAliasMode: (0, n10.Enum)("Auto", o10.Enums.AntiAliasMode) });
  e14.Annotation = (0, n10.alt)(function(e15) {
    return (null == e15 ? void 0 : e15.Type) || "Line";
  }, function(e15) {
    return e15.Type;
  }, { Line: C10, Bar: S10 });
  var x10 = (0, n10.type)({ ValueMemberX: r10.string_empty, ValueMembersY: r10.string_empty, Type: (0, n10.Enum)(null, o10.Enums.ChartType), AxisX: r10.string_empty, AxisY: r10.string_empty, ZOrder: (0, n10.Default)(null, n10.number), Visible: r10.boolean_true, ChartArea: r10.string_empty, Legend: r10.string_empty, Properties: y10, Points: (0, n10.arrayDef)(v10), Annotations: (0, n10.arrayDef)(e14.Annotation), ColorPalette: (0, n10.Enum)("None", o10.Enums.ColorPalette), LegendItemsMode: (0, n10.Enum)("Auto", o10.Enums.LegendMode), DisplayInLegend: r10.boolean_true, LegendText: r10.string_empty, Name: (0, n10.Default)(null, n10.string), AntiAliasMode: (0, n10.Enum)("Auto", o10.Enums.AntiAliasMode) });
  var w10 = (0, n10.typeDef)({ Text: r10.string_empty, Backdrop: i10, Visible: r10.boolean_true, Docking: (0, n10.Enum)("Top", o10.Enums.DockType), DockArea: r10.string_empty, Border: l10, Font: u10, Alignment: (0, n10.Enum)("TopLeft", o10.Enums.Alignment), Name: r10.string_empty });
  var T10 = (0, n10.typeDef)({ Text: r10.string_empty, Style: (0, n10.Enum)("Bar", o10.Enums.StdLegendMarker), Line: s10, Backdrop: i10, Border: l10, Marker: g10 });
  var E10 = (0, n10.typeDef)({ Rows: (0, n10.Default)(1, n10.number), Columns: (0, n10.Default)(1, n10.number) });
  var F10 = (0, n10.typeDef)({ Backdrop: i10, Border: l10, Visible: r10.boolean_true, Header: w10, Footer: w10, LabelsFont: u10, LegendItems: (0, n10.arrayDef)(T10), Alignment: (0, n10.Enum)("TopLegt", o10.Enums.Alignment), MarginX: (0, n10.Default)(0, n10.number), MarginY: (0, n10.Default)(0, n10.number), DockArea: r10.string_empty, DockInsideArea: r10.boolean_false, GridLayout: E10 });
  e14.Chart = (0, n10.pipe)((0, n10.type)(t10(t10({}, (0, a10.Control)("Chart")), { BlackAndWhiteMode: r10.boolean_false, Backdrop: i10, ChartBorder: l10, GridLayout: E10, Legends: (0, n10.arrayDef)(F10), ChartAreas: (0, n10.arrayDef)(h10), Series: (0, n10.arrayDef)(x10), Titles: (0, n10.arrayDef)(w10), AutoRefresh: r10.boolean_false, ColorPalette: (0, n10.Enum)("Default", o10.Enums.ColorPalette), UIOptions: (0, n10.Enum)("None", o10.Enums.UIOptions), Culture: r10.string_empty })));
}(jrt);
var Zrt = {};
var Grt = {};
!function(e14) {
  var t10 = $ && $.__spreadArray || function(e15, t11, n11) {
    if (n11 || 2 === arguments.length) for (var r11, o11 = 0, a11 = t11.length; o11 < a11; o11++) !r11 && o11 in t11 || (r11 || (r11 = Array.prototype.slice.call(t11, 0, o11)), r11[o11] = t11[o11]);
    return e15.concat(r11 || Array.prototype.slice.call(t11));
  };
  Object.defineProperty(e14, "__esModule", { value: true }), e14.StyleSheet = e14.RootStyle = e14.Style = e14.style = void 0;
  var n10 = Ert;
  var r10 = Lrt;
  var o10 = Vrt;
  var a10 = { ClassName: (0, n10.initValue)("Normal", n10.string), Parent: r10.string_optional, ForeColor: r10.string_optional, BackColor: r10.string_optional, FontFamily: r10.string_optional, FontSize: r10.string_optional, FontWeight: (0, n10.optional)(o10.Enums.FontWeight), FontStyle: (0, n10.optional)(o10.Enums.FontStyle), VerticalText: r10.boolean_optional, DdoCharSet: r10.string_optional, TextAlign: (0, n10.optional)(o10.Enums.TextAlign), TextJustify: (0, n10.optional)(o10.Enums.TextJustify), FontUnderline: r10.boolean_optional, FontLinethrough: r10.boolean_optional, VerticalAlign: (0, n10.optional)(o10.Enums.VerticalAlign), WhiteSpace: (0, n10.optional)(o10.Enums.WhiteSpace), WordWrap: (0, n10.optional)(o10.Enums.WordWrap), ShrinkToFit: r10.boolean_optional, Kinsoku: (0, n10.optional)(o10.Enums.Kinsoku) };
  var i10 = { ClassName: (0, n10.initValue)("Normal", n10.string), Parent: r10.string_optional, ForeColor: r10.color_default_black, BackColor: r10.color_default_transparent, FontFamily: r10.string_empty, FontSize: (0, n10.Default)("10pt", n10.string), FontWeight: (0, n10.Enum)("Normal", o10.Enums.FontWeight), FontStyle: (0, n10.Enum)("Normal", o10.Enums.FontStyle), VerticalText: r10.boolean_false, DdoCharSet: r10.string_empty, TextAlign: (0, n10.Enum)("Left", o10.Enums.TextAlign), TextJustify: (0, n10.Enum)("Auto", o10.Enums.TextJustify), FontUnderline: r10.boolean_false, FontLinethrough: r10.boolean_false, VerticalAlign: (0, n10.Enum)("Top", o10.Enums.VerticalAlign), WhiteSpace: (0, n10.Enum)("Normal", o10.Enums.WhiteSpace), WordWrap: (0, n10.Enum)("WordWrap", o10.Enums.WordWrap), ShrinkToFit: r10.boolean_false, Kinsoku: (0, n10.Enum)("Auto", o10.Enums.Kinsoku) };
  e14.style = function() {
    var e15 = [];
    for (var r11 = 0; r11 < arguments.length; r11++) e15[r11] = arguments[r11];
    return n10.pick.apply(void 0, t10([a10], e15, false));
  }, e14.Style = (0, n10.DefaultOf)({}, (0, n10.type)(a10)), e14.RootStyle = (0, n10.type)(i10), e14.StyleSheet = { decode: function(t11) {
    if (!Array.isArray(t11)) return (0, n10.failure)("array is expected");
    var r11 = t11.map(function(t12, r12) {
      if (0 !== r12) return e14.Style.decode(t12);
      var o12 = e14.RootStyle.decode(t12);
      return "success" === o12.type && "Normal" !== o12.value.ClassName ? (0, n10.failure)('Class "Normal" missing') : o12;
    });
    var o11 = r11.find(function(e15) {
      return "error" === e15.type;
    });
    return o11 && "error" === o11.type ? (0, n10.failure)(o11.reason) : (0, n10.success)(r11.map(n10.resultOf));
  }, encode: function(t11) {
    return Array.isArray(t11) ? t11.map(function(t12, n11) {
      return 0 === n11 ? e14.RootStyle.encode(t12) : e14.Style.encode(t12);
    }) : ((0, n10.recordFailure)({ type: "error", message: "array is expected" }), []);
  } };
}(Grt);
var Urt = $ && $.__assign || function() {
  return Urt = Object.assign || function(e14) {
    for (var t10, n10 = 1, r10 = arguments.length; n10 < r10; n10++) for (var o10 in t10 = arguments[n10]) Object.prototype.hasOwnProperty.call(t10, o10) && (e14[o10] = t10[o10]);
    return e14;
  }, Urt.apply(this, arguments);
};
Object.defineProperty(Zrt, "__esModule", { value: true }), Zrt.CheckBox = void 0;
var qrt = Ert;
var Yrt = Lrt;
var Krt = Vrt;
var Xrt = Grt;
var Jrt = Art;
Zrt.CheckBox = (0, qrt.pipe)((0, qrt.type)(Urt(Urt(Urt({}, (0, Jrt.Control)("CheckBox")), (0, Jrt.Padding)()), { Border: Jrt.Border, Style: Xrt.Style, Checked: Yrt.boolean_false, Text: Yrt.string_optional, CheckAlignment: (0, qrt.Enum)("MiddleLeft", Krt.Enums.ContentAlignment) })), (0, qrt.required)("Name"));
var Qrt = {};
var eot = $ && $.__assign || function() {
  return eot = Object.assign || function(e14) {
    for (var t10, n10 = 1, r10 = arguments.length; n10 < r10; n10++) for (var o10 in t10 = arguments[n10]) Object.prototype.hasOwnProperty.call(t10, o10) && (e14[o10] = t10[o10]);
    return e14;
  }, eot.apply(this, arguments);
};
Object.defineProperty(Qrt, "__esModule", { value: true }), Qrt.CrossSectionBox = Qrt.CrossSectionLine = void 0;
var tot = Ert;
var not = Lrt;
var rot = Vrt;
var oot = Art;
var aot = function(e14) {
  return eot(eot({ Type: (0, tot.literalInit)(e14) }, oot.ControlProperties), { Left: not.number_default_zero, Top: not.number_default_zero, Right: not.number_default_zero, Bottom: not.number_default_zero, LineColor: not.color_default_black, LineStyle: (0, tot.Enum)("Solid", rot.Enums.LineStyle), LineWeight: (0, tot.DefaultOf)(1, tot.number) });
};
Qrt.CrossSectionLine = (0, tot.pipe)((0, tot.type)(eot(eot({}, aot("CrossSectionLine")), { Border: oot.Border })), (0, tot.required)("Name")), Qrt.CrossSectionBox = (0, tot.pipe)((0, tot.type)(eot(eot({}, aot("CrossSectionBox")), { Border: oot.Border, CloseBorder: not.boolean_false, BackColor: not.color_default_transparent, Radius: (0, tot.typeDef)({ Default: not.number_default_zero, TopLeft: (0, tot.optional)(tot.number), TopRight: (0, tot.optional)(tot.number), BottomRight: (0, tot.optional)(tot.number), BottomLeft: (0, tot.optional)(tot.number) }) })), (0, tot.required)("Name"));
var iot = {};
var sot = $ && $.__assign || function() {
  return sot = Object.assign || function(e14) {
    for (var t10, n10 = 1, r10 = arguments.length; n10 < r10; n10++) for (var o10 in t10 = arguments[n10]) Object.prototype.hasOwnProperty.call(t10, o10) && (e14[o10] = t10[o10]);
    return e14;
  }, sot.apply(this, arguments);
};
Object.defineProperty(iot, "__esModule", { value: true }), iot.Label = void 0;
var lot = Ert;
var cot = Lrt;
var uot = Grt;
var dot = Art;
iot.Label = (0, lot.pipe)((0, lot.type)(sot(sot(sot({}, (0, dot.Control)("Label")), (0, dot.Padding)()), { Border: dot.Border, Style: uot.Style, Text: cot.string_optional, HyperLink: cot.string_optional, MultiLine: cot.boolean_true, RightToLeft: cot.boolean_false, Angle: cot.number_default_zero, MinCondenseRate: (0, lot.DefaultOf)(100, lot.number), CharacterSpacing: cot.number_default_zero, LineSpacing: cot.number_default_zero })), (0, lot.required)("Name"));
var pot = {};
var mot = $ && $.__assign || function() {
  return mot = Object.assign || function(e14) {
    for (var t10, n10 = 1, r10 = arguments.length; n10 < r10; n10++) for (var o10 in t10 = arguments[n10]) Object.prototype.hasOwnProperty.call(t10, o10) && (e14[o10] = t10[o10]);
    return e14;
  }, mot.apply(this, arguments);
};
Object.defineProperty(pot, "__esModule", { value: true }), pot.Line = void 0;
var hot = Ert;
var fot = Lrt;
var got = Vrt;
var yot = Art;
pot.Line = (0, hot.pipe)((0, hot.type)(mot(mot({ Type: (0, hot.literalInit)("Line") }, yot.ControlProperties), { X1: fot.number_default_zero, X2: fot.number_default_zero, Y1: fot.number_default_zero, Y2: fot.number_default_zero, LineColor: fot.color_default_black, LineStyle: (0, hot.Enum)("Solid", got.Enums.LineStyle), LineWeight: (0, hot.DefaultOf)(1, hot.number), AnchorBottom: fot.boolean_false })), (0, hot.required)("Name"));
var vot = {};
var bot = $ && $.__assign || function() {
  return bot = Object.assign || function(e14) {
    for (var t10, n10 = 1, r10 = arguments.length; n10 < r10; n10++) for (var o10 in t10 = arguments[n10]) Object.prototype.hasOwnProperty.call(t10, o10) && (e14[o10] = t10[o10]);
    return e14;
  }, bot.apply(this, arguments);
};
Object.defineProperty(vot, "__esModule", { value: true }), vot.PageBreak = void 0;
var Sot = Ert;
var Cot = Lrt;
var xot = Art;
vot.PageBreak = (0, Sot.pipe)((0, Sot.type)(bot(bot({}, (0, xot.Control)("PageBreak")), { Enabled: Cot.boolean_true })), (0, Sot.required)("Name"));
var wot = {};
var Tot = $ && $.__assign || function() {
  return Tot = Object.assign || function(e14) {
    for (var t10, n10 = 1, r10 = arguments.length; n10 < r10; n10++) for (var o10 in t10 = arguments[n10]) Object.prototype.hasOwnProperty.call(t10, o10) && (e14[o10] = t10[o10]);
    return e14;
  }, Tot.apply(this, arguments);
};
Object.defineProperty(wot, "__esModule", { value: true }), wot.Picture = void 0;
var Eot = Ert;
var Fot = Lrt;
var Mot = Vrt;
var kot = Art;
wot.Picture = (0, Eot.pipe)((0, Eot.type)(Tot(Tot({}, (0, kot.Control)("Picture")), { Border: kot.Border, Image: Fot.string_optional, MimeType: Fot.string_optional, HyperLink: Fot.string_optional, Title: Fot.string_optional, Description: Fot.string_optional, SizeMode: (0, Eot.Enum)("Clip", Mot.Enums.SizeMode), PictureAlignment: (0, Eot.Enum)("Center", Mot.Enums.PictureAlignment), BackColor: Fot.color_default_transparent, LineColor: Fot.color_default_transparent, LineStyle: (0, Eot.Enum)("Transparent", Mot.Enums.LineStyle), LineWeight: (0, Eot.DefaultOf)(0, Eot.number) })), (0, Eot.required)("Name"));
var Pot = {};
var Not = $ && $.__assign || function() {
  return Not = Object.assign || function(e14) {
    for (var t10, n10 = 1, r10 = arguments.length; n10 < r10; n10++) for (var o10 in t10 = arguments[n10]) Object.prototype.hasOwnProperty.call(t10, o10) && (e14[o10] = t10[o10]);
    return e14;
  }, Not.apply(this, arguments);
};
Object.defineProperty(Pot, "__esModule", { value: true }), Pot.ReportInfo = void 0;
var Dot = Ert;
var Lot = Lrt;
var Hot = Vrt;
var Iot = Grt;
var _ot = Art;
Pot.ReportInfo = (0, Dot.pipe)((0, Dot.type)(Not(Not({}, (0, _ot.Control)("ReportInfo")), { Border: _ot.Border, Style: Iot.Style, FormatString: Lot.string_empty, MultiLine: Lot.boolean_true, CanGrow: Lot.boolean_true, CanShrink: Lot.boolean_false, RightToLeft: Lot.boolean_false, SummaryRunning: (0, Dot.Enum)("None", Hot.Enums.SummaryRunning), SummaryGroup: Lot.string_empty, Culture: Lot.string_empty, Calendar: Lot.string_empty })), (0, Dot.required)("Name"));
var Vot = {};
var Rot = $ && $.__assign || function() {
  return Rot = Object.assign || function(e14) {
    for (var t10, n10 = 1, r10 = arguments.length; n10 < r10; n10++) for (var o10 in t10 = arguments[n10]) Object.prototype.hasOwnProperty.call(t10, o10) && (e14[o10] = t10[o10]);
    return e14;
  }, Rot.apply(this, arguments);
};
Object.defineProperty(Vot, "__esModule", { value: true }), Vot.RichTextBox = void 0;
var Aot = Ert;
var Oot = Lrt;
var Bot = Vrt;
var zot = Art;
Vot.RichTextBox = (0, Aot.pipe)((0, Aot.type)(Rot(Rot({}, (0, zot.Control)("RichTextBox")), { Border: zot.Border, AutoReplaceFields: Oot.boolean_false, BackColor: Oot.color_default_transparent, CanGrow: Oot.boolean_true, CanShrink: Oot.boolean_false, MaxLength: Oot.number_default_zero, MultiLine: Oot.boolean_true, RtfRenderingType: (0, Aot.Enum)("RTF", Bot.Enums.RichTextRenderingType), ContentType: (0, Aot.Enum)("Html", Bot.Enums.RichTextType), Data: Oot.string_optional })), (0, Aot.required)("Name"));
var $ot = {};
var Wot = $ && $.__assign || function() {
  return Wot = Object.assign || function(e14) {
    for (var t10, n10 = 1, r10 = arguments.length; n10 < r10; n10++) for (var o10 in t10 = arguments[n10]) Object.prototype.hasOwnProperty.call(t10, o10) && (e14[o10] = t10[o10]);
    return e14;
  }, Wot.apply(this, arguments);
};
Object.defineProperty($ot, "__esModule", { value: true }), $ot.Shape = void 0;
var jot = Ert;
var Zot = Lrt;
var Got = Vrt;
var Uot = Art;
$ot.Shape = (0, jot.pipe)((0, jot.type)(Wot(Wot({}, (0, Uot.Control)("Shape")), { Border: Uot.Border, Shape: (0, jot.Enum)("Rectangle", Got.Enums.ShapeStyle), BackColor: Zot.color_default_transparent, BackColor2: Zot.color_default_black, BackgroundStyle: (0, jot.Enum)("Solid", Got.Enums.BackgroundStyle), GradientStyle: (0, jot.Enum)("Vertical", Got.Enums.GradientStyle), BackgroundPattern: (0, jot.Enum)("DottedGrid", Got.Enums.HatchStyle), LineColor: Zot.color_default_black, LineStyle: (0, jot.Enum)("Solid", Got.Enums.LineStyle), LineWeight: (0, jot.DefaultOf)(1, jot.number), Radius: (0, jot.typeDef)({ Default: (0, jot.DefaultOf)(10, jot.number), TopLeft: (0, jot.optional)(jot.number), TopRight: (0, jot.optional)(jot.number), BottomRight: (0, jot.optional)(jot.number), BottomLeft: (0, jot.optional)(jot.number) }) })), (0, jot.required)("Name"));
var qot = {};
var Yot = $ && $.__assign || function() {
  return Yot = Object.assign || function(e14) {
    for (var t10, n10 = 1, r10 = arguments.length; n10 < r10; n10++) for (var o10 in t10 = arguments[n10]) Object.prototype.hasOwnProperty.call(t10, o10) && (e14[o10] = t10[o10]);
    return e14;
  }, Yot.apply(this, arguments);
};
Object.defineProperty(qot, "__esModule", { value: true }), qot.SubReport = void 0;
var Kot = Ert;
var Xot = Lrt;
var Jot = Art;
qot.SubReport = (0, Kot.pipe)((0, Kot.type)(Yot(Yot({}, (0, Jot.Control)("SubReport")), { Border: Jot.Border, ReportName: (0, Kot.initValue)("", Kot.string), CanGrow: Xot.boolean_true, CanShrink: Xot.boolean_true })), (0, Kot.required)("Name"));
var Qot = {};
var eat = $ && $.__assign || function() {
  return eat = Object.assign || function(e14) {
    for (var t10, n10 = 1, r10 = arguments.length; n10 < r10; n10++) for (var o10 in t10 = arguments[n10]) Object.prototype.hasOwnProperty.call(t10, o10) && (e14[o10] = t10[o10]);
    return e14;
  }, eat.apply(this, arguments);
};
Object.defineProperty(Qot, "__esModule", { value: true }), Qot.TextBox = void 0;
var tat = Ert;
var nat = Lrt;
var rat = Vrt;
var oat = Grt;
var aat = Art;
Qot.TextBox = (0, tat.pipe)((0, tat.type)(eat(eat(eat({}, (0, aat.Control)("TextBox")), (0, aat.Padding)()), { Border: aat.Border, Style: oat.Style, Text: nat.string_optional, HyperLink: nat.string_optional, OutputFormat: nat.string_optional, Culture: nat.string_optional, CurrencyCulture: nat.string_optional, Calendar: nat.string_optional, MultiLine: nat.boolean_true, CanGrow: nat.boolean_true, CanShrink: nat.boolean_false, RightToLeft: nat.boolean_false, SummaryType: (0, tat.Enum)("None", rat.Enums.SummaryType), SummaryFunc: (0, tat.Enum)("Sum", rat.Enums.SummaryFunc), SummaryRunning: (0, tat.Enum)("None", rat.Enums.SummaryRunning), SummaryGroup: nat.string_optional, DistinctField: nat.string_optional, CountNullValues: nat.boolean_false, CharacterSpacing: nat.number_default_zero, MinCondenseRate: (0, tat.DefaultOf)(100, tat.number), LineSpacing: nat.number_default_zero })), (0, tat.required)("Name"));
var iat = {};
var sat = $ && $.__assign || function() {
  return sat = Object.assign || function(e14) {
    for (var t10, n10 = 1, r10 = arguments.length; n10 < r10; n10++) for (var o10 in t10 = arguments[n10]) Object.prototype.hasOwnProperty.call(t10, o10) && (e14[o10] = t10[o10]);
    return e14;
  }, sat.apply(this, arguments);
};
Object.defineProperty(iat, "__esModule", { value: true }), iat.UnknownControl = void 0;
var lat = Ert;
var cat = Art;
var uat = { encode: function(e14) {
  return e14.Item;
}, decode: function(e14) {
  return (0, lat.success)({ Item: e14 });
} };
iat.UnknownControl = (0, lat.pipe)(uat, (0, lat.intersectWith)((0, lat.type)(sat({ Type: (0, lat.Const)("Unknown") }, cat.ControlProperties))), (0, lat.required)("Name"));
var dat = {};
var pat = $ && $.__assign || function() {
  return pat = Object.assign || function(e14) {
    for (var t10, n10 = 1, r10 = arguments.length; n10 < r10; n10++) for (var o10 in t10 = arguments[n10]) Object.prototype.hasOwnProperty.call(t10, o10) && (e14[o10] = t10[o10]);
    return e14;
  }, pat.apply(this, arguments);
};
Object.defineProperty(dat, "__esModule", { value: true }), dat.InputFieldCheckBox = dat.InputFieldText = void 0;
var mat = Ert;
var hat = Lrt;
var fat = Vrt;
var gat = Art;
var yat = function(e14) {
  return pat(pat({}, (0, gat.Control)(e14)), { BackColor: hat.color_default_transparent, BorderColor: hat.color_default_black, BorderStyle: (0, mat.Enum)("None", (0, mat.members)("None", "Solid", "Dashed", "Inset")), BorderWidth: (0, mat.DefaultOf)(1, mat.number), ForeColor: hat.color_default_black, FieldName: hat.string_empty, Readonly: hat.boolean_false, Required: hat.boolean_false, TabIndex: (0, mat.pipe)(mat.number, mat.nullable, (0, mat.withDefaultOf)(null)) });
};
dat.InputFieldText = (0, mat.pipe)((0, mat.type)(pat(pat({}, yat("InputFieldText")), { OutputFormat: hat.string_empty, Text: hat.string_empty, MaxLength: (0, mat.pipe)(mat.number, mat.nullable, (0, mat.withDefaultOf)(null)), MultiLine: hat.boolean_false, Password: hat.boolean_false, SpellCheck: hat.boolean_false, FontFamily: (0, mat.DefaultOf)("Arial", mat.string), FontSize: (0, mat.DefaultOf)("8pt", mat.string), FontWeight: (0, mat.Enum)("Normal", fat.Enums.FontWeight), FontStyle: (0, mat.Enum)("Normal", fat.Enums.FontStyle), Alignment: (0, mat.Enum)("Left", (0, mat.members)("Left", "Right", "Center")), FontUnderline: hat.boolean_false, FontLinethrough: hat.boolean_false })), (0, mat.required)("Name")), dat.InputFieldCheckBox = (0, mat.pipe)((0, mat.type)(pat(pat({}, yat("InputFieldCheckBox")), { CheckSize: (0, mat.DefaultOf)(10, mat.number), Checked: hat.boolean_false, CheckStyle: (0, mat.Enum)("Check", (0, mat.members)("Check", "Circle", "Cross", "Diamond", "Square", "Star")) })), (0, mat.required)("Name")), function(e14) {
  Object.defineProperty(e14, "__esModule", { value: true }), e14.RpxControlOrUnknown = e14.Control = e14.UnknownControl = e14.TextBox = e14.SubReport = e14.Shape = e14.RichTextBox = e14.InputFieldText = e14.InputFieldCheckBox = e14.ReportInfo = e14.Picture = e14.PageBreak = e14.Line = e14.Label = e14.CrossSectionLine = e14.CrossSectionBox = e14.CheckBox = e14.Chart = e14.Barcode = void 0;
  var t10 = Ert;
  var n10 = _rt;
  Object.defineProperty(e14, "Barcode", { enumerable: true, get: function() {
    return n10.Barcode;
  } });
  var r10 = jrt;
  Object.defineProperty(e14, "Chart", { enumerable: true, get: function() {
    return r10.Chart;
  } });
  var o10 = Zrt;
  Object.defineProperty(e14, "CheckBox", { enumerable: true, get: function() {
    return o10.CheckBox;
  } });
  var a10 = Qrt;
  Object.defineProperty(e14, "CrossSectionBox", { enumerable: true, get: function() {
    return a10.CrossSectionBox;
  } }), Object.defineProperty(e14, "CrossSectionLine", { enumerable: true, get: function() {
    return a10.CrossSectionLine;
  } });
  var i10 = iot;
  Object.defineProperty(e14, "Label", { enumerable: true, get: function() {
    return i10.Label;
  } });
  var s10 = pot;
  Object.defineProperty(e14, "Line", { enumerable: true, get: function() {
    return s10.Line;
  } });
  var l10 = vot;
  Object.defineProperty(e14, "PageBreak", { enumerable: true, get: function() {
    return l10.PageBreak;
  } });
  var c10 = wot;
  Object.defineProperty(e14, "Picture", { enumerable: true, get: function() {
    return c10.Picture;
  } });
  var u10 = Pot;
  Object.defineProperty(e14, "ReportInfo", { enumerable: true, get: function() {
    return u10.ReportInfo;
  } });
  var d10 = Vot;
  Object.defineProperty(e14, "RichTextBox", { enumerable: true, get: function() {
    return d10.RichTextBox;
  } });
  var p10 = $ot;
  Object.defineProperty(e14, "Shape", { enumerable: true, get: function() {
    return p10.Shape;
  } });
  var m10 = qot;
  Object.defineProperty(e14, "SubReport", { enumerable: true, get: function() {
    return m10.SubReport;
  } });
  var h10 = Qot;
  Object.defineProperty(e14, "TextBox", { enumerable: true, get: function() {
    return h10.TextBox;
  } });
  var f10 = iat;
  Object.defineProperty(e14, "UnknownControl", { enumerable: true, get: function() {
    return f10.UnknownControl;
  } });
  var g10 = dat;
  Object.defineProperty(e14, "InputFieldCheckBox", { enumerable: true, get: function() {
    return g10.InputFieldCheckBox;
  } }), Object.defineProperty(e14, "InputFieldText", { enumerable: true, get: function() {
    return g10.InputFieldText;
  } }), e14.Control = (0, t10.alt)(function(e15) {
    return e15.Type;
  }, function(e15) {
    return e15.Type;
  }, { Barcode: n10.Barcode, Chart: r10.Chart, CheckBox: o10.CheckBox, CrossSectionBox: a10.CrossSectionBox, CrossSectionLine: a10.CrossSectionLine, Label: i10.Label, Line: s10.Line, PageBreak: l10.PageBreak, Picture: c10.Picture, ReportInfo: u10.ReportInfo, RichTextBox: d10.RichTextBox, Shape: p10.Shape, SubReport: m10.SubReport, TextBox: h10.TextBox, InputFieldCheckBox: g10.InputFieldCheckBox, InputFieldText: g10.InputFieldText }), e14.RpxControlOrUnknown = (0, t10.pipe)(e14.Control, (0, t10.orElse)(f10.UnknownControl, function(e15) {
    return "Unknown" === e15.Type;
  }));
}(Irt);
var vat = {};
!function(e14) {
  Object.defineProperty(e14, "__esModule", { value: true }), e14.DefaultSectionDecoder = e14.Section = void 0;
  var t10 = Ert;
  var n10 = Lrt;
  var r10 = Vrt;
  var o10 = Irt;
  e14.Section = function(e15) {
    return (0, t10.type)({ Type: (0, t10.initValue)("Detail", r10.Enums.SectionType), Name: t10.string, Controls: (0, t10.arrayDef)(e15), Height: n10.number_default_zero, BackColor: (0, t10.Default)("Transparent", t10.string), CanGrow: n10.boolean_true, CanShrink: n10.boolean_false, KeepTogether: n10.boolean_false, NewPage: (0, t10.Enum)("None", r10.Enums.NewPage), NewColumn: (0, t10.Enum)("None", r10.Enums.NewColumn), PrintAtBottom: n10.boolean_false, Tag: n10.string_optional, UnderlayNext: n10.boolean_false, Visible: n10.boolean_true, ColumnCount: (0, t10.Default)(1, t10.number), ColumnDirection: (0, t10.Enum)("DownAcross", r10.Enums.ColumnDirection), ColumnSpacing: n10.number_default_zero, RepeatToFill: n10.boolean_false, DataField: n10.string_optional, GroupKeepTogether: (0, t10.Enum)("None", r10.Enums.GroupKeepTogether), ColKeepTogether: n10.boolean_false, RepeatStyle: (0, t10.Enum)("None", r10.Enums.RepeatStyle), ColumnLayout: n10.boolean_true });
  }, e14.DefaultSectionDecoder = (0, e14.Section)(o10.RpxControlOrUnknown);
}(vat);
var bat = {};
var Sat = {};
Object.defineProperty(Sat, "__esModule", { value: true }), Sat.version = void 0, Sat.version = "1.7.2", function(e14) {
  Object.defineProperty(e14, "__esModule", { value: true }), e14.DefaultReportDecoder = e14.Report = e14.Parameter = e14.CalculatedField = void 0;
  var t10 = Ert;
  var n10 = Lrt;
  var r10 = Trt;
  var o10 = Vrt;
  var a10 = Irt;
  var i10 = vat;
  var s10 = Grt;
  var l10 = Sat;
  var c10 = function(e15) {
    return { encode: function(t11) {
      return e15;
    }, decode: function(e16) {
      return (0, t10.success)(e16);
    } };
  };
  e14.CalculatedField = (0, t10.type)({ Name: t10.string, FieldType: (0, t10.Enum)("None", o10.Enums.FieldType), Formula: n10.string_optional, DefaultValue: n10.string_optional }), e14.Parameter = (0, t10.type)({ Key: t10.string, ParameterType: (0, t10.Enum)("String", o10.Enums.ParameterType), Prompt: n10.string_optional, DefaultValue: n10.string_optional, PromptUser: n10.boolean_false, QueryCreated: n10.boolean_false, DisplayFormat: (0, t10.Default)("", t10.string) });
  e14.Report = function(a11) {
    return (0, t10.pipe)((0, t10.type)({ Version: c10(l10.version), CompatibilityMode: (0, t10.Enum)("CrossPlatform", o10.Enums.CompatibilityMode), ExpressionErrorMessage: n10.string_optional, Culture: n10.string_optional, PrintWidth: (0, t10.initValue)(9360, t10.number), MaxPages: n10.number_default_zero, DocumentName: n10.string_empty, ScriptLanguage: (0, t10.initValue)("C#", o10.Enums.ScriptLanguage), ParamUI: n10.boolean_true, MasterReport: n10.string_optional, ReportServerUri: n10.string_optional, UserData: n10.string_optional, StyleSheet: s10.StyleSheet, Sections: (0, t10.DefaultOf)([{ Name: "Detail" }], (0, t10.array)(a11)), DataSource: (0, t10.optional)(r10.DataSource), CalculatedFields: (0, t10.arrayDef)(e14.CalculatedField), Script: n10.string_optional, PageSettings: (0, t10.DefaultOf)({}, (0, t10.type)({ TopMargin: (0, t10.Default)(1440, t10.number), RightMargin: (0, t10.Default)(1440, t10.number), BottomMargin: (0, t10.Default)(1440, t10.number), LeftMargin: (0, t10.Default)(1440, t10.number), GutterMargin: n10.number_default_zero, MirrorMargins: n10.boolean_false, PaperSize: (0, t10.typeDef)({ Size: (0, t10.Enum)("Letter", o10.Enums.PaperKind), Width: (0, t10.Default)(0, t10.number), Height: (0, t10.Default)(0, t10.number) }), Orientation: (0, t10.Enum)("Default", o10.Enums.PageOrientation), Collate: (0, t10.Enum)("Default", o10.Enums.Collate), Duplex: (0, t10.Enum)("Default", o10.Enums.Duplex) })), Watermark: (0, t10.typeDef)({ Alignment: (0, t10.Enum)("Center", o10.Enums.PictureAlignment), SizeMode: (0, t10.Enum)("Clip", o10.Enums.SizeMode), PrintOnPages: n10.string_optional, Image: n10.string_optional }), Parameters: (0, t10.arrayDef)(e14.Parameter) }), t10.recordFailures);
  }, e14.DefaultReportDecoder = (0, e14.Report)((0, i10.Section)(a10.RpxControlOrUnknown));
}(bat), function(e14) {
  Object.defineProperty(e14, "__esModule", { value: true }), e14.DefaultReportDecoder = e14.Report = e14.Parameter = e14.CalculatedField = e14.RootStyle = e14.Style = e14.DefaultSectionDecoder = e14.Section = e14.UnknownControl = e14.TextBox = e14.SubReport = e14.Shape = e14.RichTextBox = e14.ReportInfo = e14.Picture = e14.PageBreak = e14.Line = e14.Label = e14.CrossSectionLine = e14.CrossSectionBox = e14.CheckBox = e14.Chart = e14.Barcode = e14.RpxControlOrUnknown = e14.Control = e14.DataSource = void 0;
  var t10 = Trt;
  Object.defineProperty(e14, "DataSource", { enumerable: true, get: function() {
    return t10.DataSource;
  } });
  var n10 = Irt;
  Object.defineProperty(e14, "Control", { enumerable: true, get: function() {
    return n10.Control;
  } }), Object.defineProperty(e14, "RpxControlOrUnknown", { enumerable: true, get: function() {
    return n10.RpxControlOrUnknown;
  } }), Object.defineProperty(e14, "Barcode", { enumerable: true, get: function() {
    return n10.Barcode;
  } }), Object.defineProperty(e14, "Chart", { enumerable: true, get: function() {
    return n10.Chart;
  } }), Object.defineProperty(e14, "CheckBox", { enumerable: true, get: function() {
    return n10.CheckBox;
  } }), Object.defineProperty(e14, "CrossSectionBox", { enumerable: true, get: function() {
    return n10.CrossSectionBox;
  } }), Object.defineProperty(e14, "CrossSectionLine", { enumerable: true, get: function() {
    return n10.CrossSectionLine;
  } }), Object.defineProperty(e14, "Label", { enumerable: true, get: function() {
    return n10.Label;
  } }), Object.defineProperty(e14, "Line", { enumerable: true, get: function() {
    return n10.Line;
  } }), Object.defineProperty(e14, "PageBreak", { enumerable: true, get: function() {
    return n10.PageBreak;
  } }), Object.defineProperty(e14, "Picture", { enumerable: true, get: function() {
    return n10.Picture;
  } }), Object.defineProperty(e14, "ReportInfo", { enumerable: true, get: function() {
    return n10.ReportInfo;
  } }), Object.defineProperty(e14, "RichTextBox", { enumerable: true, get: function() {
    return n10.RichTextBox;
  } }), Object.defineProperty(e14, "Shape", { enumerable: true, get: function() {
    return n10.Shape;
  } }), Object.defineProperty(e14, "SubReport", { enumerable: true, get: function() {
    return n10.SubReport;
  } }), Object.defineProperty(e14, "TextBox", { enumerable: true, get: function() {
    return n10.TextBox;
  } }), Object.defineProperty(e14, "UnknownControl", { enumerable: true, get: function() {
    return n10.UnknownControl;
  } });
  var r10 = vat;
  Object.defineProperty(e14, "Section", { enumerable: true, get: function() {
    return r10.Section;
  } }), Object.defineProperty(e14, "DefaultSectionDecoder", { enumerable: true, get: function() {
    return r10.DefaultSectionDecoder;
  } });
  var o10 = Grt;
  Object.defineProperty(e14, "Style", { enumerable: true, get: function() {
    return o10.Style;
  } }), Object.defineProperty(e14, "RootStyle", { enumerable: true, get: function() {
    return o10.RootStyle;
  } });
  var a10 = bat;
  Object.defineProperty(e14, "CalculatedField", { enumerable: true, get: function() {
    return a10.CalculatedField;
  } }), Object.defineProperty(e14, "Parameter", { enumerable: true, get: function() {
    return a10.Parameter;
  } }), Object.defineProperty(e14, "Report", { enumerable: true, get: function() {
    return a10.Report;
  } }), Object.defineProperty(e14, "DefaultReportDecoder", { enumerable: true, get: function() {
    return a10.DefaultReportDecoder;
  } });
}(wrt), Object.defineProperty(Srt, "__esModule", { value: true });
var Cat = Srt.Decoders = Srt.Rpx = Srt.Rom = void 0;
Srt.Rom = Crt, Srt.Rpx = xrt, Cat = Srt.Decoders = wrt;
const xat = (e14, t10) => {
  const n10 = [];
  const { length: r10 } = e14;
  const o10 = (r10 - 1) / 2;
  const a10 = t10.length / 2;
  return e14.forEach((e15) => {
    "Detail" === e15.Type && (n10[o10] = e15), "ReportHeader" === e15.Type && (n10[0] = e15), "ReportFooter" === e15.Type && (n10[r10 - 1] = e15), "PageHeader" === e15.Type && (n10[o10 - a10 - 1] = e15), "PageFooter" === e15.Type && (n10[o10 + a10 + 1] = e15), "GroupHeader" === e15.Type && (n10[o10 - (a10 - t10.findIndex((t11) => t11 === e15.$path.split(".")[1]))] = e15), "GroupFooter" === e15.Type && (n10[o10 + (t10.findIndex((t11) => t11 === e15.$path.split(".")[1]) - a10 + 1)] = e15);
  }), n10;
};
const wat = FZ.Lenses;
const Tat = FZ.pipe(Cat.RpxControlOrUnknown, wat.mapOfLens({ f: (e14) => __spreadProps(__spreadValues({}, e14), { $path: "" }), frev: (_kb) => {
  var _lb = _kb, { $selected: e14, $primary: t10, $path: n10 } = _lb, r10 = __objRest(_lb, ["$selected", "$primary", "$path"]);
  return r10;
} }), FZ.map((e14) => {
  if ("Barcode" === e14.Type) {
    const _a2 = e14, { Style: t10 } = _a2, n10 = __objRest(_a2, ["Style"]);
    return __spreadProps(__spreadValues({}, n10), { Symbology: t10 });
  }
  return e14;
}, (e14) => {
  if ("Barcode" === e14.Type) {
    const _a2 = e14, { Symbology: t10 } = _a2, n10 = __objRest(_a2, ["Symbology"]);
    return __spreadProps(__spreadValues({}, n10), { Style: t10 });
  }
  return e14;
}));
const Eat = (e14) => FZ.pipe(Cat.Section(FZ.upcast()(Tat)), wat.mapOfLens({ f: (e15) => __spreadProps(__spreadValues({}, e15), { $path: "" }), frev: (_a2) => {
  var _b2 = _a2, { $selected: e15, $primary: t10, $path: n10 } = _b2, r10 = __objRest(_b2, ["$selected", "$primary", "$path"]);
  return r10;
} }), wat.mapOfLens({ f: (e15) => e15, frev: (_c2) => {
  var _d2 = _c2, { $pasteCount: e15, $pasteId: t10 } = _d2, n10 = __objRest(_d2, ["$pasteCount", "$pasteId"]);
  return n10;
} }), FZ.map((t10) => {
  const n10 = `Sections.${e14(t10)}`;
  return __spreadProps(__spreadValues({}, t10), { $path: n10, Controls: Fat(t10.Controls, n10, e14) });
}, (e15) => __spreadProps(__spreadValues({}, e15), { Controls: Object.values(e15.Controls) })));
const Fat = (e14, t10, n10) => {
  const r10 = {};
  return e14.forEach((e15) => {
    const o10 = n10(e15);
    r10[o10] = __spreadProps(__spreadValues({}, e15), { $path: `${t10}.Controls.${o10}` });
  }), r10;
};
const Mat = (e14) => FZ.pipe(Cat.Report(Eat(e14)), FZ.map((e15) => {
  const t10 = {};
  const n10 = [];
  return e15.Sections.forEach((e16) => {
    const r10 = e16.$path.split(".")[1];
    "GroupHeader" !== e16.Type && "GroupFooter" !== e16.Type || n10.push(r10), t10[r10] = e16;
  }), __spreadProps(__spreadValues({}, e15), { Type: "Report", Name: e15.DocumentName, Sections: t10, GroupsOrder: n10, Fields: [], $path: "", $selected: "leaf", $primary: true });
}, (e15) => {
  const _a2 = e15, { $selected: t10, $primary: n10, $path: r10, Type: o10, Name: a10, GroupsOrder: i10, Fields: s10 } = _a2, l10 = __objRest(_a2, ["$selected", "$primary", "$path", "Type", "Name", "GroupsOrder", "Fields"]);
  return __spreadProps(__spreadValues({}, l10), { Sections: xat(Object.values(l10.Sections), i10) });
}));
const kat = { Report: Mat(() => GB()), Section: Eat(() => GB()), Control: Tat, DataSource: Cat.DataSource, Parameter: Cat.Parameter, Style: Cat.Style, RootStyle: Cat.RootStyle, CalculatedField: Cat.CalculatedField };
Dp("wd-calc-field-editor");
const Pat = IV((e14) => ({ type: "@rpx/report/dataSource/update", payload: { dataSource: e14 }, meta: { path: "" } }), "@rpx/report/dataSource/update");
const Nat = IV((e14) => ({ type: "@rpx/report/fields/update", payload: { fields: e14 }, meta: { path: "" } }), "@rpx/report/fields/update");
const Dat = IV((e14) => ({ type: "@rpx/report/calcFields/add", payload: { calcField: e14 }, meta: { path: "", naming: { add: e14.Name } } }), "@rpx/report/calcFields/add");
const Lat = IV((e14) => ({ type: "@rpx/report/calcFields/delete", payload: { index: e14 }, meta: { path: "", naming: { update: true } } }), "@rpx/report/calcFields/delete");
const Hat = IV((e14) => ({ type: "@rpx/report/parameters/add", payload: { parameter: e14 }, meta: { path: "", naming: { add: e14.Key } } }), "@rpx/report/parameters/add");
const Iat = IV((e14, t10) => ({ type: "@rpx/report/parameters/move", payload: { index: e14, direction: t10 }, meta: { path: "" } }), "@rpx/report/parameters/move");
const _at = IV((e14) => ({ type: "@rpx/report/parameters/delete", payload: { index: e14 }, meta: { path: "", naming: { update: true } } }), "@rpx/report/parameters/delete");
const Vat = IV((e14) => ({ type: "@rpx/report/styles/add", payload: { style: e14 }, meta: { path: "" } }), "@rpx/report/styles/add");
const Rat = IV((e14) => ({ type: "@rpx/report/styles/delete", payload: { className: e14 }, meta: { path: "" } }), "@rpx/report/styles/delete");
const Aat = IV(({ correlateWidth: e14, correlateHeight: t10 }) => ({ type: "@rpx/report/correlateSizes", payload: { correlateWidth: e14, correlateHeight: t10 }, meta: { path: "" } }), "@rpx/report/correlateSizes");
const Oat = IV(() => ({ type: "@rpx/report/alignToGrid", payload: {}, meta: { path: "" } }), "@rpx/report/alignToGrid");
const Bat = IV(() => ({ type: "@rpx/report/sizeToGrid", payload: {}, meta: { path: "" } }), "@rpx/report/sizeToGrid");
function zat(e14, t10) {
  const n10 = e14.Left + e14.Width;
  const r10 = t10.Left + t10.Width;
  const o10 = e14.Top + e14.Height;
  const a10 = t10.Top + t10.Height;
  return e14.Left < r10 && t10.Left < n10 && e14.Top < a10 && t10.Top < o10;
}
const $at = (e14, t10) => ({ Top: e14.Top + t10.y, Left: e14.Left + t10.x, Width: e14.Width, Height: e14.Height });
const Wat = (e14, t10) => ({ Top: e14.Top - t10.y, Left: e14.Left - t10.x, Width: e14.Width, Height: e14.Height });
function jat(e14) {
  let t10 = 1 / 0;
  let n10 = 1 / 0;
  for (const r10 of e14) t10 = Math.min(r10.Left, t10), n10 = Math.min(r10.Top, n10);
  return { x: t10, y: n10 };
}
function Zat(e14, t10) {
  const { Left: n10, Top: r10, Width: o10, Height: a10 } = t10;
  return !(e14.x < n10 || e14.y < r10) && (e14.x < n10 + o10 && e14.y < r10 + a10);
}
function Gat(e14) {
  const t10 = jat(e14);
  const n10 = { x: Math.min(0, t10.x), y: Math.min(0, t10.y) };
  return n10.x || n10.y ? e14.map((e15) => Wat(e15, n10)) : e14;
}
const Uat = (e14, t10, n10) => {
  let { x: r10, y: o10 } = t10;
  return n10.Left > 0 && n10.Width < 0 && (t10.x >= e14.Width ? r10 = e14.Width - 1 : e14.Left + r10 < 0 && (r10 = -e14.Left)), n10.Top > 0 && n10.Height < 0 && (t10.y >= e14.Height ? o10 = e14.Height - 1 : e14.Top + o10 < 0 && (o10 = -e14.Top)), { Left: e14.Left + r10 * n10.Left, Top: e14.Top + o10 * n10.Top, Width: e14.Width + r10 * n10.Width, Height: e14.Height + o10 * n10.Height };
};
const qat = (e14) => e14.reduce((e15, t10) => Math.abs(t10) < Math.abs(e15) ? t10 : e15, e14[0]);
function Yat(e14) {
  const { Left: t10, Top: n10, Width: r10, Height: o10 } = e14;
  const a10 = t10 + r10;
  const i10 = n10 + o10;
  return [{ x: t10, y: n10 }, { x: a10, y: n10 }, { x: t10, y: i10 }, { x: a10, y: i10 }];
}
const Kat = (e14, t10) => t10.find((t11) => Zat(e14, t11));
function Xat(e14, t10) {
  const n10 = { x: e14.Left, y: e14.Top };
  const r10 = Kat(n10, t10);
  return r10 || t10.find((t11) => zat(t11, e14));
}
function Jat(e14, t10, n10, r10, o10, a10) {
  if (!Zat(e14, r10)) return [];
  const i10 = e14[n10] - o10;
  const s10 = Math.floor(i10 / t10) * t10;
  let l10 = Math.ceil(i10 / t10) * t10;
  return l10 > a10 && (l10 = a10), [s10 - i10, l10 - i10];
}
const Qat = (e14, t10, n10, r10) => {
  const o10 = Xat(e14, t10);
  if (!o10) return null;
  const a10 = "x" === r10 ? o10.Left : o10.Top;
  const i10 = "x" === r10 ? o10.Width : o10.Height;
  const s10 = Yat(e14).flatMap((e15) => Jat(e15, n10, r10, o10, a10, i10)).filter(Ie);
  return s10.length ? qat(s10) : null;
};
const eit = (e14, t10, n10, r10, o10 = { Left: 0, Top: 0, Width: 0, Height: 0 }) => {
  const a10 = Xat(e14, t10);
  if (!a10) return null;
  const i10 = "x" === r10 ? a10.Left : a10.Top;
  const s10 = "x" === r10 ? a10.Width : a10.Height;
  const [l10, c10, u10, d10] = Yat(e14);
  const p10 = [];
  "x" === r10 ? (o10.Left > 0 && p10.push(l10, u10), o10.Width > 0 && p10.push(c10, d10)) : "y" === r10 && (o10.Top > 0 && p10.push(l10, c10), o10.Height > 0 && p10.push(u10, d10));
  const m10 = p10.flatMap((e15) => Jat(e15, n10, r10, a10, i10, s10)).filter(Ie);
  return m10.length ? qat(m10) : null;
};
function tit(e14, t10, n10, r10) {
  const o10 = Kat(e14, t10);
  if (!o10) return null;
  const a10 = "x" === r10 ? o10.Left : o10.Top;
  const i10 = "x" === r10 ? o10.Width : o10.Height;
  const s10 = e14[r10] - a10;
  const l10 = Math.floor(s10 / n10) * n10;
  let c10 = Math.ceil(s10 / n10) * n10;
  c10 > i10 && (c10 = i10);
  return (Math.abs(l10 - s10) < Math.abs(c10 - s10) ? l10 : c10) + a10;
}
function nit(e14) {
  const { snapToGrid: t10, snapToLines: n10, gridStep: r10, containerRectangles: o10, fixedRectangles: a10 } = e14;
  function i10(e15, a11, i11) {
    const s10 = { shift: { x: 0, y: 0 }, snapLines: [] };
    if (!t10 && !n10) return s10;
    if (t10) {
      {
        const t11 = e15.map((e16) => a11(e16, o10, r10, "x", i11)).filter(Ie);
        t11.length && (s10.shift.x = qat(t11));
      }
      {
        const t11 = e15.map((e16) => a11(e16, o10, r10, "y", i11)).filter(Ie);
        t11.length && (s10.shift.y = qat(t11));
      }
    }
    return s10;
  }
  !function(e15) {
    const t11 = [];
    for (const n11 of e15) t11.push(...Yat(n11));
  }(a10);
  return { solveMove: (e15) => {
    const { shift: t11, snapLines: n11 } = i10(e15, Qat);
    return { movingRectangles: t11.x || t11.y ? e15.map((e16) => $at(e16, t11)) : e15, snapLines: n11 };
  }, solveResize: (e15, t11) => {
    const { shift: n11, snapLines: r11 } = i10(e15, eit, t11);
    return { movingRectangles: n11.x || n11.y ? e15.map((e16) => Uat(e16, n11, t11)) : e15, snapLines: r11 };
  }, solvePointMove: function(e15) {
    const a11 = { point: e15, snapLines: [] };
    if (!t10 && !n10) return a11;
    if (t10) {
      {
        const t11 = tit(e15, o10, r10, "x");
        null !== t11 && (a11.point.x = t11);
      }
      {
        const t11 = tit(e15, o10, r10, "y");
        null !== t11 && (a11.point.y = t11);
      }
    }
    return a11;
  } };
}
function rit(e14) {
  const { instanceId: t10, report: n10, draggedPaths: r10, gridSize: o10, snapToGrid: a10, snapToLines: i10 } = e14;
  const { units: s10 } = KO.of(t10).userPreferences;
  if (!a10 && !i10) return;
  const l10 = L$.parse(o10).toPreciseTwips;
  const c10 = function(e15, t11, n11) {
    const r11 = nz.of(e15);
    const o11 = [];
    for (const e16 of Object.values(t11.Sections)) {
      const a11 = { Top: 0, Left: 0, Width: t11.PrintWidth, Height: e16.Height };
      for (const t12 of Object.values(e16.Controls)) {
        if (n11.includes(t12.$path)) continue;
        const e17 = r11.getFeature(t12.Type, "getRectangle");
        if (!e17) continue;
        const i11 = e17(t12, a11);
        o11.push(i11);
      }
    }
    return o11;
  }(t10, n10, r10);
  const u10 = function(e15, t11) {
    var _a2;
    const n11 = [];
    const r11 = nz.of(e15).getFeature(t11.Type, "getChildren");
    const o11 = (_a2 = r11 == null ? void 0 : r11(t11)) != null ? _a2 : [];
    let a11 = 0;
    for (const e16 of o11) n11.push({ Left: 0, Top: a11, Width: t11.PrintWidth, Height: e16.Height }), a11 += e16.Height;
    return n11;
  }(t10, n10);
  const d10 = nit({ fixedRectangles: c10, containerRectangles: u10, gridStep: l10, snapToGrid: a10, snapToLines: i10, snapToLinesSensitivity: "in" === s10 ? L$.parse("0.1in").toTwips : L$.parse("0.25cm").toTwips, maxSnapToLinesDistance: "in" === s10 ? L$.parse("2in").toTwips : L$.parse("5cm").toTwips });
  return { solveMove: function(e15) {
    return d10.solveMove(e15);
  }, solveResize: function(e15, t11) {
    return d10.solveResize(e15, t11);
  }, solvePointMove: function(e15) {
    return d10.solvePointMove(e15);
  } };
}
function oit(e14) {
  const t10 = [];
  if (!e14) return t10;
  rj(e14) && t10.push({ path: e14.$path, primary: ij(e14) });
  for (const n10 of Object.values(e14.Sections)) if (rj(n10)) t10.push({ path: n10.$path, primary: ij(n10) });
  else for (const e15 of Object.values(n10.Controls)) rj(e15) && t10.push({ path: e15.$path, primary: ij(e15) });
  return t10;
}
function ait(e14) {
  const t10 = [];
  if (!e14) return t10;
  rj(e14) && t10.push(e14);
  for (const n10 of Object.values(e14.Sections)) if (rj(n10)) t10.push(n10);
  else for (const e15 of Object.values(n10.Controls)) rj(e15) && t10.push(e15);
  return t10;
}
Dp("wd-parameter-editor"), Dp("wd-style-editor"), tp.createElement("svg", { width: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.accent, d: "M3.83885 5.85764C6.77986 1.94203 12.8685.802644 17.2028 3.49752c4.2798 2.66101 5.8538 7.77708 4.1009 12.57738-1.6552 4.5326-6.0164 6.3284-9.1597 4.0484-1.1774-.8541-1.6339-1.9248-1.8545-3.6638l-.1054-.988-.0454-.3974c-.1227-.9341-.31108-1.3525-.70435-1.5717-.53559-.2986-.89222-.3055-1.59548-.033l-.35112.1456-.17873.078c-1.01378.4402-1.68817.5949-2.54116.4162l-.20025-.0472-.16354-.0466c-2.78896-.8642-3.20205-4.64713-.56522-8.15776Zm.98422 6.71646.12291.0364.13395.0309c.43907.0869.81432.0144 1.43702-.2419l.60217-.2572c1.20214-.4929 1.98524-.5411 3.04548.0498.9176.5115 1.2753 1.2976 1.4577 2.6597l.0532.4591.0542.5318.0471.4224c.1721 1.3612.4849 2.0905 1.248 2.644 2.2753 1.6504 5.5344.3084 6.8699-3.3487 1.5163-4.1522.1741-8.51459-3.484-10.78903C12.7365 2.4869 7.5123 3.46453 5.03822 6.75848 2.96343 9.52082 3.21791 12.038 4.82307 12.5741Zm11.22453-1.9944c-.1787-.66682.217-1.35224.8838-1.53092.6669-.17867 1.3523.21705 1.531.88389.1787.66683-.2171 1.35223-.8839 1.53093-.6668.1787-1.3523-.2171-1.5309-.8839Zm.4945 3.4887c-.1786-.6669.2171-1.3523.8839-1.531.6669-.1786 1.3523.2171 1.531.8839.1786.6669-.2171 1.3523-.8839 1.531-.6669.1786-1.3523-.2171-1.531-.8839Zm-2.473-6.49137c-.1787-.66683.217-1.35225.8838-1.53093.6669-.17868 1.3523.21705 1.531.88388.1786.66683-.2171 1.35226-.8839 1.53093-.6669.17868-1.3523-.21705-1.5309-.88388Zm-.0285 8.99837c-.1787-.6668.217-1.3522.8839-1.5309.6668-.1787 1.3522.217 1.5309.8839.1787.6668-.2171 1.3522-.8839 1.5309-.6668.1787-1.3523-.2171-1.5309-.8839Zm-3.497-9.96996c-.1786-.66684.2171-1.35226.8839-1.53093.6669-.17868 1.3523.21705 1.531.88388.1786.66683-.2171 1.35225-.8839 1.53093-.6669.17868-1.3523-.21705-1.531-.88388Z" })), tp.createElement("svg", { width: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M14.82 1.768c1.467-.393 2.975.478 3.368 1.945l3.718 12.142c.393 1.467-.478 2.975-1.945 3.368l-8.278 2.683c-1.467.393-2.975-.478-3.368-1.945L4.597 7.819c-.393-1.467.477-2.975 1.944-3.368l8.279-2.683ZM5.587 13.649l1.762 6.571c.181.675.535 1.258 1.002 1.713l-.443-.024c-1.517-.079-2.682-1.373-2.602-2.89l.281-5.37Zm9.621-10.432L6.93 5.9c-.667.178-1.063.864-.884 1.531l3.717 12.142c.179.667.865 1.062 1.531.884l8.279-2.683c.667-.178 1.062-.864.884-1.53L16.739 4.101c-.178-.667-.864-1.062-1.531-.884ZM4.662 12.171l-.355 6.796c-.037.698.12 1.362.424 1.94l-.414-.161c-1.418-.544-2.126-2.135-1.582-3.553l1.927-5.022Zm3.863-5.146c.534-.143 1.082.174 1.225.707.143.534-.174 1.082-.707 1.225-.533.143-1.082-.174-1.225-.707-.143-.534.174-1.082.707-1.225Z" }));
const iit = (e14) => {
  const t10 = [];
  return rj(e14) || Object.values(e14.Sections).forEach((e15) => Object.values(e15.Controls).forEach((e16) => {
    "leaf" === e16.$selected && t10.push(e16);
  })), t10;
};
const sit = (e14) => iit(e14).find((e15) => e15.$primary);
function lit(e14) {
  const t10 = [];
  if (!e14) return t10;
  for (const n10 of Object.values(e14.Sections)) for (const e15 of Object.values(n10.Controls)) rj(e15) && t10.push(e15.$path);
  return t10;
}
const cit = (e14, t10, n10, r10) => {
  const o10 = nz.of(n10);
  const a10 = (e15, n11) => {
    var _a2, _b2, _c2;
    const i10 = o10.getFeature(e15.Type, "getChildren");
    const s10 = ((_a2 = i10 == null ? void 0 : i10(e15)) != null ? _a2 : []).map((e16, t11) => a10(e16, [...n11, "nodes", t11]));
    const l10 = o10.getFeature(e15.Type, "getName");
    let c10 = (_b2 = l10 == null ? void 0 : l10(e15, r10)) != null ? _b2 : e15.Name || "";
    ["ReportHeader", "PageHeader", "GroupHeader", "GroupFooter", "PageFooter", "ReportFooter", "Detail"].includes(e15.Type) && (c10 = (_c2 = e15.Name) != null ? _c2 : c10);
    const u10 = { name: c10, type: e15.Type, selected: rj(e15), path: e15.$path };
    const { type: d10, selected: p10 } = u10;
    const m10 = ((e16, n12) => {
      const r11 = n12.reduce((e17, t11) => e17 && e17[t11], t10);
      return !r11 || r11.value.name !== e16 || r11.expanded;
    })(c10, n11);
    return { id: c10, text: c10, icon: o10.getIcon(d10), expanded: m10, selected: p10, value: u10, nodes: s10, customCSS: kp(L$e, H$e(s10.length ? "non-leaf" : "leaf")) };
  };
  return a10(e14, [0]);
};
const uit = () => {
  const e14 = Pz();
  const { instanceId: t10 } = qHe();
  const n10 = PA();
  const { t: r10 } = vp();
  const [o10, a10] = ep.useState([]);
  ep.useEffect(() => {
    if (!e14) return;
    const n11 = cit(e14, o10, t10, r10);
    a10([n11]);
  }, [e14]);
  const i10 = ep.useCallback((e15) => {
    e15.expanded = !e15.expanded, a10([o10[0]]);
  }, [o10]);
  const s10 = ep.useCallback(({ value: { path: t11 } }) => (r11) => {
    if (SB(r11)) {
      const r12 = jN(t11)(e14 || {});
      n10(rj(r12) ? cB(t11) : lB(t11));
    } else n10(sB(t11));
  }, [n10, e14]);
  const l10 = { nodes: o10, onNodeClick: s10, onNodeToggle: i10 };
  return tp.createElement(B$e, __spreadValues({}, l10));
};
uit.displayName = "RpxExplorer";
const dit = stt("", "", "string", "Script");
const pit = () => {
  const { Script: e14, ScriptLanguage: t10 } = LA(Nnt);
  const { t: n10 } = vp("components-RPX");
  const r10 = PA();
  const [o10, a10] = ep.useState(e14);
  ep.useEffect(() => {
    o10 !== e14 && a10(e14);
  }, [e14]);
  const i10 = (e15) => {
    r10(iB(dit, e15, ""));
  };
  const s10 = ep.useMemo(() => /* @__PURE__ */ function(e15, t11) {
    let n11 = null;
    return function(...r11) {
      n11 && clearTimeout(n11), n11 = window.setTimeout(() => {
        e15(...r11), n11 = null;
      }, t11);
    };
  }(i10, 500), []);
  const l10 = { block: true, width: "100%", height: "100%", rounded: false, placeholder: n10("components-RPX:scriptEditor.placeholder", "Enter {{ScriptLanguage}} code", { ScriptLanguage: t10 }), customCSS: "rpx-script-editor", onChange: (e15) => {
    const { value: t11 } = e15.currentTarget;
    a10(t11), s10(t11);
  }, value: o10 != null ? o10 : "" };
  return tp.createElement(zN, __spreadValues({}, l10));
};
const mit = "Script";
const [hit] = Dp("wd-toolbox-item");
const fit = ({ type: e14, icon: t10, text: n10, onClick: r10 }) => {
  const { instanceId: o10, userPreferences: a10 } = MO();
  const { surface: { gridSize: i10, snapToGrid: s10, snapToLines: l10 } } = a10;
  const c10 = Pz();
  const [, u10, d10] = Yne({ item: { type: "toolboxItem", itemType: e14 }, begin: () => {
    if (!c10) return;
    const t11 = rit({ instanceId: o10, report: c10, draggedPaths: [], gridSize: i10, snapToGrid: s10, snapToLines: l10 });
    return { type: "toolboxItem", itemType: e14, snapSolver: t11 };
  }, collect: (e15) => ({ isDragging: e15.isDragging() }) });
  ep.useEffect(() => {
    d10(Coe(), { captureDraggingState: true });
  }, []);
  return u10(((o11 = e14, a11) => tp.createElement("div", { className: kp(hit), key: o11, style: a11, onClick: r10, title: n10, "data-aid": n10 }, tp.createElement(Fm, { icon: t10, customCSS: "gc-btn__icon" }), tp.createElement("span", { className: "gc-btn__text" }, n10)))());
};
fit.displayName = "RpxMenuItem";
const git = (e14) => {
  const [t10, n10] = e14.split(".");
  if (n10) return [t10, n10].join(".");
};
const yit = ["Label", "TextBox", "CheckBox", "RichTextBox", "Shape", "Picture", "Line", "PageBreak", "Barcode", "SubReport", "ReportInfo", "CrossSectionLine", "CrossSectionBox", "InputFieldText", "InputFieldCheckBox"];
const vit = yit.reduce((e14, t10) => __spreadProps(__spreadValues({}, e14), { [t10]: t10 }), {});
const bit = { documentExplorer: "document-explorer" };
const Sit = (e14) => {
  const t10 = PA();
  const { t: n10 } = vp("components-RPX");
  const r10 = n10;
  const o10 = rf(Aee);
  const { userPreferences: { units: a10 }, instanceId: i10, lockLayout: s10, rpx: { toolBoxContent: l10 } } = MO();
  const { workspaceId: c10 } = Mz();
  const u10 = nz.of(i10);
  const d10 = c10 === mit;
  const p10 = Pz();
  const m10 = ep.useCallback((e15, n11) => {
    if (s10) return;
    const r11 = ((e16, t11, n12, r12, o11) => {
      var _a2;
      if (!o11) return [];
      const a11 = az.of(t11).getNextDocumentItemName(e16);
      const i11 = GB();
      const s11 = n12.getFeature(o11 == null ? void 0 : o11.Type, "getChildren")(o11);
      if (n12.getFeature(e16, "isCrossSectionItem")) {
        if (1 === s11.length) return console.error(`Cannot add ${e16} item: no header sections in report`), [];
        const t12 = oit(o11);
        const n13 = ((e17, t13) => {
          const n14 = e17[0].$path;
          const r13 = e17.find((e18) => e18.$path === t13);
          if (!t13 || !r13 || "Detail" === r13.Type) return n14;
          if ("ReportFooter" === (o12 = r13).Type || "PageFooter" === o12.Type || "GroupFooter" === o12.Type) {
            const n15 = e17.findIndex((e18) => e18.$path === t13);
            return e17[e17.length - n15 - 1].$path;
          }
          var o12;
          return t13;
        })(s11, t12.length > 1 ? void 0 : git(t12[0].path));
        const l12 = wtt({ type: e16, name: a11, id: i11, templateId: r12 }, n13);
        return l12.meta.path = n13, [l12, sB(`${n13}.Controls.${i11}`)];
      }
      const l11 = oit(o11).find((e17) => e17.primary);
      const c11 = git((l11 == null ? void 0 : l11.path) || ((_a2 = s11.find((e17) => "Detail" === e17.Type)) == null ? void 0 : _a2.$path) || "");
      return [wtt({ type: e16, name: a11, id: i11, templateId: r12 }, c11), sB(`${c11}.Controls.${i11}`)];
    })(e15, i10, u10, n11, p10);
    t10(rz(r11));
  }, [t10, u10, i10, s10, p10]);
  const h10 = ep.useMemo(() => (l10 ? ((e15) => e15.map((e16) => vit[e16] ? e16 : (console.warn(`Unknown item "${e16}" in settings.toolBoxContent!`), null)).filter(Ie))(l10) : yit).map((e15) => {
    var _a2;
    const t11 = u10.getDescriptorByBaseType(e15);
    if (!t11) return null;
    const { icon: n11, icon24: o11, initTemplates: i11 } = t11;
    const s11 = i11 && i11[a10] || [];
    const l11 = (_a2 = o11 != null ? o11 : n11) != null ? _a2 : nf(_ae);
    const c11 = r10(u10.getLabelKey(t11.type));
    if (s11.length > 1) {
      const t12 = { type: e15, icon: l11, text: c11, templates: s11, onClick: (t13) => m10(e15, t13) };
      return { type: "custom", content: tp.createElement(Loe, __spreadValues({}, t12)) };
    }
    const d11 = { type: e15, icon: l11, text: c11, onClick: (t12) => {
      t12.preventDefault(), t12.stopPropagation(), m10(e15);
    } };
    return { type: "custom", content: tp.createElement(fit, __spreadValues({}, d11)) };
  }).filter(Ie), [m10, u10, r10, l10, a10]);
  const { hiddenElements: f10 } = e14;
  const g10 = n10("menu.btnReportExplorer", "Explorer");
  const y10 = __spreadProps(__spreadValues({}, e14), { supportedMenuPanels: Object.values(bit), items: d10 ? [] : h10, onBackButtonClick: d10 ? () => t10(XO("editor")) : void 0 });
  return tp.createElement(Jee, __spreadValues({}, y10), (f10 == null ? void 0 : f10.documentExplorer) || d10 ? null : tp.createElement(XM, { key: bit.documentExplorer, id: bit.documentExplorer, dataAid: g10, toggle: { icon: o10, text: g10, title: g10 }, customScroll: true }, tp.createElement(bF, null, tp.createElement(uit, null))));
};
const Cit = (e14, t10) => {
  if (!e14) throw new Error(`Invalid ROM type: ${e14}`);
  return t10(`documentsAPI:romLabels.${e14.toLowerCase()}`) || e14;
};
const xit = (e14, t10, n10) => {
  if (0 === e14.length) return "";
  const r10 = e14.reduce((e15, n11) => {
    const r11 = ((e16, t11) => {
      const n12 = () => {
        throw new Error(`TransformationInfo entry is invalid: ${e16}`);
      };
      e16 || n12();
      const { SourceType: r12, Name: o12, ResultType: a11, Errors: i11 } = e16;
      r12 && o12 && a11 || n12();
      const s10 = (e17) => ({ Name: o12, SourceType: Cit(r12, t11), ResultType: Cit(e17, t11), Errors: i11 || [] });
      switch (r12.toLowerCase()) {
        case "chart":
          return s10("dvchart");
        case "table":
        case "matrix":
          return s10("tablix");
      }
      return s10(a11);
    })(n11, t10);
    const o11 = r11.Errors.map((e16) => ((e17, t11) => `&emsp;${e17("documentsAPI:transform.textError", "\u2013 [{{errorType}}] {{message}}", t11)}`)(t10, e16));
    const a10 = BV.omit(r11, "Errors");
    const i10 = [0 === o11.length ? t10("documentsAPI:transform.textReportItem", '\u2714 {{SourceType}} "{{Name}}" has been transformed to {{ResultType}}.', a10) : t10("documentsAPI:transform.textBadReportItem", `\u2718 {{SourceType}} "{{Name}}" couldn't have been transformed to {{ResultType}} due to internal issues:`, a10), ...o11].join("\n");
    return e15 ? [e15, i10].join("\n") : i10;
  }, "");
  const o10 = ((e15, t11) => t11 ? e15("documentsAPI:transform.helpLink", { link: `[url]${t11}[/url]` }) : null)(t10, n10);
  return o10 ? [r10, o10].join("\n\n") : r10;
};
const wit = (e14, t10) => (e14 != null ? e14 : []).map(() => ({ level: "warning", caption: t10("documentsAPI:textReportConversion", "There have been issues while opening this report"), content: (e14 != null ? e14 : []).join("\n") })), Tit = (e14, t10 = [], n10, r10) => {
  const o10 = [];
  if (t10.length) {
    const a10 = BV.sortBy(t10, ({ Errors: e15 }) => (e15 || []).length);
    o10.push({ level: a10.some(({ Errors: e15 }) => (e15 || []).length > 0) ? "warning" : "info", caption: n10("documentsAPI:transform.textReport", 'The report "{{reportName}}" has been transformed.', { reportName: e14 }), content: xit(a10, n10, r10) });
  }
  return o10;
};
const Eit = {};
const Fit = (e14, t10, n10) => {
  const r10 = ((e15) => {
    const t11 = [];
    return C3(e15, (e16, n11) => {
      const { ReportStyle: r11 } = n11;
      (r11 == null ? void 0 : r11.StyleId) && t11.push({ id: r11.StyleId, name: r11.StyleName });
    }), t11;
  })(e14);
  const o10 = BV.intersectionWith(r10, t10, (e15, t11) => e15.id === t11.id || e15.name === t11.name);
  const a10 = nz.of(n10).getReducer(e14.Type);
  return o10.length > 0 ? ((e15, t11, n11, r11) => {
    const o11 = [];
    return C3(e15, x3((e16, t12, a11, i10) => {
      var _a2;
      const { ReportStyle: s10 } = t12;
      if (s10 && s10.StyleId) {
        const e17 = i10 == null ? void 0 : i10.path;
        const a12 = kj(((_a2 = nz.of(r11)) == null ? void 0 : _a2.getBaseType(t12.Type)) || "", n11).find((e18) => e18.id === s10.StyleId || e18.name === s10.StyleName);
        a12 && (o11.push({ descriptor: { valuePath: `${e17}.$style` }, value: a12.content }), a12.id !== s10.StyleId && o11.push({ descriptor: { valuePath: `${e17}.ReportStyle.StyleId` }, value: a12.id }));
      }
    })), o11.length && t11 ? t11(e15, u2({ path: "", descriptorValuePairs: o11 }, { skipFplRestrictionsValidation: true })) : e15;
  })(e14, a10, t10, n10) : e14;
};
const Mit = (e14) => (e14 == null ? void 0 : e14.ReportItems.length) && !!(e14 == null ? void 0 : e14.ReportItems.find((e15) => "contentplaceholder" !== e15.Type));
const kit = (e14, t10) => {
  const { dispatch: n10 } = t10;
  if (e14 in Eit) throw new Error(`DocumentsAPI[id=${e14}] already exists, use DocumentsAPI.of(id)`);
  if (bB) {
    ["copy", "cut", "paste"].forEach((e15) => {
      window.addEventListener(e15, () => {
        switch (e15) {
          case "copy":
            n10(dB());
            break;
          case "cut":
            n10(pB());
            break;
          case "paste":
            n10(mB());
        }
      });
    });
  }
  const r10 = nz.of(e14);
  if (!r10) throw new Error(`Initialize documentItemsAPI for instanceId=${e14} first`);
  const o10 = () => {
    n10(XO("editor")), n10(JO("Home")), n10(n$());
  };
  function a10(e15, t11, o11) {
    IO("enums-RPX"), r10.useDocumentType("rpx"), n10(Ctt({ name: e15, type: t11, content: o11 }));
  }
  const i10 = (e15, t11) => "dashboard" === t11.type ? eGe.decode(e15) : QZe.decode(e15);
  function s10(o11, a11, i11) {
    IO("enums"), r10.useDocumentType("rdlx");
    const { rdlx: { reportStyles: s11 } } = l9(t10.getState());
    const l11 = Fit(i11, s11, e14);
    const c11 = a11;
    "fixedpagereport" === i11.Type ? c11.subType = "fpl" : c11.subType = "msl", n10(ipe({ name: o11, type: c11, content: l11 }));
  }
  function l10(a11, i11) {
    const { template: s11, templateData: l11, name: c11, type: u10 } = a11;
    IO("enums"), r10.useDocumentType("rdlx");
    const { dataSources: d10, dataSets: p10 } = ((e15 = []) => {
      const t11 = [];
      const n11 = [];
      return e15.forEach((e16) => {
        const r11 = {};
        e16.DataSources.forEach((e17) => {
          let n12 = e17;
          const o11 = t11.findIndex((t12) => t12.Name === e17.Name);
          if (o11 >= 0) {
            if (BV.isEqual(e17, t11[o11])) return;
            if (r11[e17.Name]) {
              const n13 = t11.find((t12) => t12.Name === r11[e17.Name]);
              if (BV.isEqual(e17, n13)) return;
              throw new Error(`The data source named '${e17.Name}' already exists.`);
            }
            const a12 = JB(e17.Name, t11.map((e18) => e18.Name));
            r11[e17.Name] = a12, n12 = __spreadProps(__spreadValues({}, e17), { Name: a12 });
          }
          t11.push(n12);
        }), e16.DataSets.forEach((e17) => {
          let t12 = e17;
          const o11 = n11.findIndex((t13) => t13.Name === e17.Name);
          if (o11 >= 0) {
            if (BV.isEqual(e17, n11[o11])) return;
            const r12 = JB(e17.Name, n11.map((e18) => e18.Name));
            t12 = __spreadProps(__spreadValues({}, e17), { Name: r12 });
          }
          const a12 = e17.Query && e17.Query.DataSourceName && r11[e17.Query.DataSourceName];
          a12 && (t12 = AV(t12, { Query: { DataSourceName: { $set: a12 } } })), n11.push(t12);
        });
      }), { dataSources: t11, dataSets: n11 };
    })(l11);
    if (s11) {
      const r11 = QZe.decode(s11);
      if ("error" === r11.type) throw new Error(r11.reason);
      const { value: a12, warnings: l12 } = r11;
      const { rdlx: { reportStyles: m11 } } = l9(t10.getState());
      const h10 = Fit(a12, m11, e14);
      return n10(ape({ name: c11, type: u10, content: h10, dataSets: p10, dataSources: d10 })), o10(), { success: true, messages: [...wit(h10.$conversionInfo, i11), ...Tit(c11, h10.TransformationInfo, i11)] };
    }
    let m10;
    switch (u10.subType) {
      case "fpl":
        m10 = r10.create("fixedpagereport");
        break;
      case "msl":
        m10 = "dashboard" === u10.type ? r10.create("dashboard") : r10.create("multisectionreport");
        break;
      default:
        throw new Error("Wrong report sub-type");
    }
    return n10(ape({ name: c11, type: u10, content: m10, dataSets: p10, dataSources: d10 })), n10(gpe()), o10(), { success: true };
  }
  const c10 = { loadDocument: function(e15, t11) {
    return ((e16) => "rpx" === e16.type.platform)(e15) ? function({ name: e16, type: t12, content: n11 }, r11) {
      const i11 = kat.Report.decode(n11);
      if ("error" === i11.type) return { success: false, messages: [{ level: "error", caption: "Error decoding report", content: i11.reason }] };
      const { value: s11, warnings: l11 } = i11;
      return a10(e16, t12, s11), o10(), { success: true, messages: [] };
    }(e15) : function({ name: e16, type: t12, content: n11, documentation: r11 }, a11) {
      var _a2;
      const l11 = i10(n11, t12);
      if ("error" === l11.type) return { success: false };
      const { value: c11, warnings: u10 } = l11;
      return s10(e16, t12, c11), o10(), { success: true, messages: [...wit(c11.$conversionInfo, a11), ...Tit(e16, c11.TransformationInfo, a11, (_a2 = r11 == null ? void 0 : r11.transformation) == null ? void 0 : _a2.url)], content: c11 };
    }(e15, t11);
  }, loadRpxDocumentContent: a10, loadRdlxDocumentContent: s10, createDocument: function(t11, a11) {
    return az.of(e14).update(), ((e15) => "rpx" === e15.type.platform)(t11) ? function({ name: e15, type: t12 }) {
      IO("enums-RPX"), r10.useDocumentType("rpx");
      const a12 = r10.create("Report");
      return n10(xtt({ name: e15, type: t12, content: a12 })), o10(), { success: true };
    }(t11) : l10(t11, a11);
  }, serializeDocument: (e15) => {
    const { documentType: t11, documentContent: n11, documentContent: { Type: r11 } } = e15;
    return "rpx" === t11 ? kat.Report.encode(n11) : "dashboard" === r11 ? eGe.encode(n11) : QZe.encode(n11);
  }, updateDocumentInfo: function(e15) {
    n10(nB(e15));
  }, setDirty: function() {
    n10(oB());
  }, removeDirty: function() {
    n10(rB(void 0));
  }, restoreUnsavedDocument: function() {
    return __async(this, null, function* () {
      return new Promise((e15) => {
        n10(aB((t11) => {
          e15(t11);
        }));
      });
    });
  }, setRdlxMasterReportContent: function(r11, a11) {
    const s11 = i10(r11, { type: "report", platform: "rdlx", subType: "msl" });
    if ("error" === s11.type) return { success: false, errors: ["DecodingError"] };
    const { value: l11, warnings: c11 } = s11;
    if ("multisectionreport" !== l11.Type) return { success: false, errors: ["ReportTypeError"] };
    let { present: { content: u10 } } = u9(t10.getState());
    if (!u10) return { success: false, errors: [] };
    const { Layers: d10 } = e8(u10, l11);
    "multisectionreport" === u10.Type && (u10 = m8(u10, d10));
    const { $activeSectionIndex: p10, ReportSections: m10 } = u10;
    const { copyContent: h10, itemsOutsideFromPlaceholder: f10 } = d8(u10, l11);
    const { dataRenameActions: g10, reportItemRenameActions: y10, errors: v10, meta: b10 } = o8(e14, l11, u10, a11, h10);
    const S10 = [];
    if (f10.size) {
      const e15 = [];
      let t11 = 1;
      f10 == null ? void 0 : f10.forEach((n11, r12) => {
        e15.push(a11("notifications:masterReports.reportItemsWereMovedOrResized.details", "{{num}}. {{items}} in the {{contentPlaceholder}}\n", { num: t11, items: n11.join(", "), contentPlaceholder: r12 })), t11++;
      }), S10.push({ level: "warning", caption: fG("masterReports.reportItemsWereMovedOrResized", a11), content: gG("masterReports.reportItemsWereMovedOrResized", a11, { outsideItems: e15.join(", ") }) });
    }
    return v10.includes("DuplicatedDataSetsError") && S10.push({ level: "warning", caption: fG("masterReports.dataSetsWereRenamed", a11), content: gG("masterReports.dataSetsWereRenamed", a11, { dataSetNames: b10.duplicatedDataSetNames.join(", ") }) }), v10.includes("DuplicatedDataSourcesError") && S10.push({ level: "warning", caption: fG("masterReports.dataSourcesWereRenamed", a11), content: gG("masterReports.dataSourcesWereRenamed", a11, { dataSourceNames: b10.duplicatedDataSourceNames.join(", ") }) }), v10.includes("DuplicatedParamsNamesError") && S10.push({ level: "warning", caption: fG("masterReports.parametersWereRenamed", a11), content: gG("masterReports.parametersWereRenamed", a11, { parameterNames: b10.duplicatedParamsNames.join(", ") }) }), v10.includes("DuplicatedReportItemNamesError") && S10.push({ level: "warning", caption: fG("masterReports.reportItemsWereRenamed", a11), content: gG("masterReports.reportItemsWereRenamed", a11, { reportItemNames: b10.duplicatedReportItemNames.join(", ") }) }), v10.includes("DuplicatedEmbeddedImagesNamesError") && S10.push({ level: "warning", caption: fG("masterReports.embeddedImagesWereRenamed", a11), content: gG("masterReports.embeddedImagesWereRenamed", a11, { embeddedImagesNames: b10.duplicatedEmbeddedImagesNames.join(", ") }) }), v10.includes("DuplicatedLayerNamesError") && S10.push({ level: "warning", caption: fG("masterReports.layersWereRenamed", a11), content: gG("masterReports.layersWereRenamed", a11, { layersNames: b10.duplicatedLayersNames.join(", ") }) }), n10(rz([...g10, cpe({ masterReport: l11, copyContent: h10 }), ...y10, c5(`ReportSections.${p10}`, m10[0].Type)])), o10(), { success: true, messages: S10 };
  }, setRdlxMasterReport: function(r11, a11, s11) {
    const l11 = i10(a11, { type: "report", platform: "rdlx", subType: "msl" });
    if ("error" === l11.type) return { success: false, errors: ["DecodingError"] };
    const { value: c11, warnings: u10 } = l11;
    const { present: { content: d10 } } = u9(t10.getState());
    const p10 = [];
    if ("multisectionreport" !== (d10 == null ? void 0 : d10.Type) || "multisectionreport" !== c11.Type) return { success: false, errors: ["ReportTypeError"] };
    const { includeMisMatchItems: m10, itemsOutsideFromPlaceholder: h10, copyContent: f10 } = d8(d10, c11);
    const { dataRenameActions: g10, reportItemRenameActions: y10, errors: v10, meta: b10 } = o8(e14, c11, d10, s11, f10);
    const { ReportSections: S10 } = d10;
    const C10 = S10.some(({ Body: e15, PageHeader: t11, PageFooter: n11 }) => Mit(e15) || Mit(t11) || Mit(n11));
    const x10 = d10.$masterReportContent && d10.$masterReport;
    x10 ? (m10 && v10.push("ContentMismatchError"), h10.size && (v10.push("ContentOutsideError"), b10.itemsOutsideFromPlaceholder = h10)) : C10 && v10.push("SectionsHaveItemsError");
    const w10 = [];
    return w10.push(...g10, x10 ? upe({ masterReport: c11, copyContent: f10, id: r11 }) : lpe({ masterReport: c11, id: r11 }), ...y10, u5()), v10.length ? { success: false, errors: v10, meta: b10, messages: p10, onConfirm: () => n10(rz(w10)) } : (n10(rz(w10)), o10(), { success: true, messages: p10 });
  }, destroy: function() {
    delete Eit[e14];
  } };
  return Eit[e14] = c10, c10;
};
kit.of = (e14) => Eit[e14], kit.destroy = (e14) => kit.of(e14).destroy();
const Pit = (e14, t10) => {
  const { lockLayout: n10 } = KO.of(t10);
  if (n10) return false;
  for (const n11 of e14) if (!$1e(n11, t10, "disableCopy")) return false;
  return true;
};
const Nit = (e14, t10) => {
  const n10 = () => t10.getState();
  const r10 = () => {
    const { core: { document: { past: e15 } } } = n10();
    return 0 !== (e15 != null ? e15 : []).length;
  };
  const o10 = () => {
    const { core: { document: { future: e15 } } } = n10();
    return 0 !== (e15 != null ? e15 : []).length;
  };
  const a10 = () => {
    const { core: { document: { present: { type: t11, content: r11 } } } } = n10();
    if (!t11 || !r11) return false;
    if ("rdlx" === t11.platform) {
      const t12 = yj(r11);
      return Pit(t12, e14);
    }
    if ("rpx" === t11.platform) {
      const t12 = ait(r11);
      return Pit(t12, e14);
    }
    return false;
  };
  return { canUndo: r10, canRedo: o10, canCut: a10, canCopy: a10, canPaste: () => true, canDelete: a10, undo: () => {
    r10() && t10.dispatch(lO.ActionCreators.undo());
  }, redo: () => {
    o10() && t10.dispatch(lO.ActionCreators.redo());
  }, cut: () => {
    a10() && t10.dispatch(pB());
  }, copy: () => {
    a10() && t10.dispatch(dB());
  }, paste: () => {
    t10.dispatch(mB());
  }, delete: () => {
    const { core: { document: { present: { type: e15 } } } } = n10();
    a10() && e15 && ("rdlx" === e15.platform && t10.dispatch({ type: ZG }), "rpx" === e15.platform && t10.dispatch({ type: "@rpx/removeControl" }));
  } };
};
const Dit = tp.createElement("svg", { width: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M5 1c-1.10457 0-2 .89543-2 2v10c0 1.1046.89543 2 2 2h6c1.1046 0 2-.8954 2-2V5.41421c0-.39782-.158-.77935-.4393-1.06066L9.64645 1.43934C9.36514 1.15804 8.98361 1 8.58579 1H5ZM4 3c0-.55228.44772-1 1-1h3v2.5C8 5.32843 8.67157 6 9.5 6H12v7c0 .5523-.4477 1-1 1H5c-.55228 0-1-.4477-1-1V3Zm7.7929 2H9.5c-.27614 0-.5-.22386-.5-.5V2.20711L11.7929 5Z" }));
const Lit = { File: "File", Home: "Home", Insert: "Insert", ContextActions: "ContextActions" };
const Hit = ({ hiddenMenuItems: e14 = {}, badge: t10, controlItems: n10, workspaceItems: r10, canUndo: o10, canRedo: a10, onUndo: i10, onRedo: s10, onPreview: l10, onFile: c10, onCreate: u10, onOpen: d10, onSave: p10, onSaveAs: m10 }) => {
  const { id: h10, workspaceId: f10, appBarItemId: g10, contextActions: y10, menu: { workspaces: v10 }, hasUnsavedChanges: b10, documentName: S10 } = Mz();
  const C10 = PA();
  const { t: x10 } = vp("components");
  const w10 = x10;
  const T10 = rf(Qm);
  const E10 = rf(eh);
  const F10 = rf(Dit);
  const M10 = rf(rh);
  const k10 = rf(th);
  const P10 = rf(nh);
  const N10 = rf(oh);
  const D10 = rf(ah);
  const L10 = ep.useMemo(() => [{ type: "button", dataAid: "undo-button", icon: T10, onClick: i10, title: x10("appBar.titleUndo", "Undo"), disabled: !o10 }, { type: "button", dataAid: "redo-button", icon: E10, onClick: s10, title: x10("appBar.titleRedo", "Redo"), disabled: !a10 }, u10 && { type: "splitter" }, u10 && { type: "button", dataAid: "create-button", icon: F10, onClick: u10, title: x10("appBar.titleNew", "New") }, d10 && { type: "splitter" }, d10 && { type: "button", dataAid: "open-button", icon: M10, onClick: d10, title: x10("appBar.titleOpen", "Open") }, p10 && { type: "splitter" }, p10 && { type: "group", items: [{ type: "button", dataAid: "save-button", icon: k10, onClick: p10, title: x10("appBar.titleSave", "Save"), disabled: !b10 }, m10 && { type: "dropdown", title: x10("appBar.btnSaveAs", "Save As"), items: [{ type: "button", icon: P10, text: x10("appBar.btnSaveAs", "Save As"), value: m10 }], menuWidth: "auto", hiddenChevron: true, icon: N10, dataAid: "save-as-dropdown", onSelect: (e15) => e15() }] }, l10 && { type: "splitter" }, l10 && { type: "button", dataAid: "preview-button", icon: D10, text: x10("appBar.btnPreview", "Preview"), onClick: l10 }], [a10, o10, b10, u10, d10, l10, s10, p10, m10, i10, x10]);
  const { File: H10, Home: I10, Insert: _10, ContextActions: V10 } = Lit;
  const R10 = Z1e(y10, "toolbar").filter((e15) => dz(e15)).reverse().sort((e15, t11) => e15.key.endsWith("report.layout.title") || e15.key.endsWith("labels.layout.title") ? -1 : t11.key.endsWith("report.layout.title") || t11.key.endsWith("labels.layout.title") ? 1 : 0);
  const A10 = ep.useMemo(() => [e14[H10] ? null : { id: H10, text: x10("appBar.btnFile", "File") }, e14[I10] ? null : { id: I10, text: x10("appBar.btnHome", "Home") }, e14[_10] ? null : { id: _10, text: x10("appBar.btnInsert", "Insert") }, ...e14[V10] ? [] : R10.map(({ key: e15 }) => ({ id: w10(e15), text: w10(e15) })), ...r10.filter(({ id: t11 }) => true !== e14[t11])].filter((e15) => !!e15), [V10, H10, I10, _10, R10, e14, x10, w10, r10]);
  let O10 = Lit.Home;
  "editor" !== f10 && A10.some((e15) => e15.id === f10) ? O10 = f10 : A10.some((e15) => e15.id === g10) && (O10 = g10);
  const B10 = ep.useCallback((e15) => {
    if (e15 === Lit.File) return void (c10 == null ? void 0 : c10());
    const t11 = r10.find(({ id: t12 }) => t12 === e15);
    if (t11) return C10(XO(e15)), void (v10[e15] || C10(tB({ workspaceId: e15, status: "collapsed" })));
    C10(JO(e15)), C10(XO("editor"));
  }, [C10, c10, r10, v10]);
  const z10 = { id: `${h10}_main-app-bar`, dataAid: "main-app-bar", size: "small", title: S10, subtitle: b10 ? x10("appBar.textUnsavedChanges", "Unsaved Changes") : void 0, badge: t10, mainItems: L10, controlItems: n10, menuItems: A10, selectedMenuItemId: O10, onMenuItemSelect: B10 };
  return tp.createElement(GM, __spreadValues({}, z10));
};
const Iit = (e14) => {
  var _a2;
  const { future: t10, past: n10 } = LA(u9);
  const { rdlx: { reportParameters: r10 } } = Uae();
  const o10 = PA();
  const { t: a10 } = vp("components");
  const i10 = (n10 != null ? n10 : []).length > 0;
  const s10 = (t10 != null ? t10 : []).length > 0;
  const l10 = ep.useCallback(() => o10(lO.ActionCreators.undo()), [o10]);
  const c10 = ep.useCallback(() => o10(lO.ActionCreators.redo()), [o10]);
  const u10 = false === ((_a2 = r10 == null ? void 0 : r10.parametersView) == null ? void 0 : _a2.enabled);
  const d10 = __spreadProps(__spreadValues({}, e14), { workspaceItems: ep.useMemo(() => u10 ? [] : [{ id: M$e.workspaceId, text: a10("appBar.btnParameters", "Parameters") }], [u10, a10]), canUndo: i10, canRedo: s10, onUndo: l10, onRedo: c10 });
  return tp.createElement(Hit, __spreadValues({}, d10));
};
const _it = (e14) => {
  const { future: t10, past: n10 } = Lnt();
  const r10 = PA();
  const { t: o10 } = vp("components-RPX");
  const a10 = (n10 != null ? n10 : []).length > 0;
  const i10 = (t10 != null ? t10 : []).length > 0;
  const s10 = ep.useCallback(() => r10(lO.ActionCreators.undo()), [r10]);
  const l10 = ep.useCallback(() => r10(lO.ActionCreators.redo()), [r10]);
  const c10 = __spreadProps(__spreadValues({}, e14), { workspaceItems: ep.useMemo(() => [{ id: mit, text: o10("appBar.btnScript", "Script") }], [o10]), canUndo: a10, canRedo: i10, onUndo: s10, onRedo: l10 });
  return tp.createElement(Hit, __spreadValues({}, c10));
};
const Vit = $A((e14) => e14, ({ core: e14 }) => e14);
const Rit = $A((e14) => e14, ({ core: { document: e14 } }) => e14.present);
const Ait = () => LA(Vit);
const Oit = () => LA(Rit);
const Bit = (e14) => {
  const { type: t10 } = Oit();
  const n10 = ep.useCallback(() => {
  }, []);
  if ("rdlx" === (t10 == null ? void 0 : t10.platform)) return tp.createElement(Iit, __spreadValues({}, e14));
  if ("rpx" === (t10 == null ? void 0 : t10.platform)) return tp.createElement(_it, __spreadValues({}, e14));
  const r10 = __spreadProps(__spreadValues({}, e14), { workspaceItems: [], canRedo: false, canUndo: false, onRedo: n10, onUndo: n10 });
  return tp.createElement(Hit, __spreadValues({}, r10));
};
const zit = (e14, t10, n10, r10) => (e14 == null ? void 0 : e14.length) ? e14.map((e15) => {
  switch (e15.type) {
    case "button": {
      const { icon: n11, key: o10, disabled: a10, action: i10 } = e15;
      const s10 = r10(o10);
      return { type: "button", dataAid: `${i10.text}-button`, icon: n11, text: s10, title: s10, disabled: a10, onClick: () => t10(i10) };
    }
    case "separator": {
      const { key: t11 } = e15;
      return t11 ? { type: "header", header: r10(t11) } : { type: "splitter" };
    }
    case "dialog": {
      const { icon: t11, key: o10, disabled: a10, dialogName: i10, dialogProps: s10 } = e15;
      const l10 = r10(o10);
      return { type: "button", dataAid: `${l10}-button`, icon: t11, text: l10, title: l10, disabled: a10, onClick: () => n10(i10, s10) };
    }
    default:
      throw Error(`Unknown element type: ${e15}`);
  }
}) : [];
const $it = ({ contextAction: e14, dispatch: t10, showDialog: n10, tFunction: r10 }) => {
  switch (e14.type) {
    case "button": {
      const { icon: n11, key: o10, disabled: a10, action: i10, textKey: s10 } = e14;
      const l10 = r10(o10);
      const c10 = { dataAid: `${l10}-button`, background: "transparent", icon: n11, text: s10 && r10(s10), title: l10, onClick: () => t10(i10), disabled: a10 };
      return tp.createElement(qm, __spreadValues({ key: l10 }, c10));
    }
    case "dialog": {
      const { icon: t11, key: o10, disabled: a10, dialogName: i10, dialogProps: s10 } = e14;
      const l10 = r10(o10);
      const c10 = { dataAid: `${l10}-button`, background: "transparent", icon: t11, text: l10, title: l10, onClick: () => n10(i10, s10), disabled: a10 };
      return tp.createElement(qm, __spreadValues({ key: l10 }, c10));
    }
    case "separator":
      return tp.createElement(DM, { key: "splitter" });
    case "dropdown": {
      const { icon: o10, key: a10, disabled: i10, actions: s10 } = e14;
      const l10 = r10(a10);
      const c10 = { dataAid: `${l10}-dropdown`, background: "transparent", icon: o10, text: l10, title: l10, items: zit(s10, t10, n10, r10), disabled: i10, itemSize: "small" };
      return tp.createElement(UF, __spreadValues({ key: l10 }, c10));
    }
    case void 0:
      throw Error("Element without type");
    default:
      return null;
  }
};
const Wit = ({ toolstripItems: e14, contextActionItems: t10 }) => {
  const { t: n10 } = vp("components");
  const r10 = { id: "main_toolbar", block: true, padding: true, size: "default", toggleBackground: "transparent", toggleTitle: n10("toolbar.titleExpand", "Expand") };
  return tp.createElement(NM, __spreadValues({}, r10), t10, e14);
};
Wit.displayName = "CoreToolbar";
const [jit, Zit, Git] = Dp("rdlx-theme-picker-item");
const [Uit] = Git("text");
const [qit] = Git("colors");
const [Yit] = Git("label");
const [Kit] = Git("icon-none");
const Xit = ({ id: e14, name: t10, selected: n10, Colors: r10, Fonts: { MajorFontFamily: o10, MinorFontFamily: a10 }, onSelect: i10 }) => {
  const s10 = kp(jit, { [Zit("selected")]: n10 });
  return tp.createElement("li", { className: s10, onClick: () => i10(e14) }, tp.createElement("div", { className: Uit }, tp.createElement("div", null, tp.createElement("span", { style: { fontFamily: o10 } }, "A"), tp.createElement("span", { style: { fontFamily: a10 } }, "a"))), tp.createElement("div", { className: qit }, Object.keys(r10).map((e15) => r10[e15] && tp.createElement("div", { key: `${e15}_${r10[e15]}`, style: { backgroundColor: r10[e15] } }))), tp.createElement("div", { className: Yit, title: t10 }, t10));
};
const Jit = ({ label: e14, selected: t10, onSelect: n10 }) => {
  const r10 = kp(jit, { [Zit("selected")]: t10 });
  return tp.createElement("li", { className: r10, onClick: () => n10("") }, tp.createElement("div", { className: Kit }, tp.createElement(Fm, { icon: nf(Kh) })), tp.createElement("div", { className: Yit }, tp.createElement("span", null, e14)));
};
const [Qit] = Dp("rdlx-theme-picker");
const est = ({ themes: e14, value: t10, onThemeSelected: n10, showNoThemeItem: r10 = true }) => {
  const { t: o10 } = vp("components");
  const a10 = xX(t10).id || "";
  return tp.createElement("ul", { className: Qit }, r10 && tp.createElement(Jit, { label: o10("themeEditor.labelNone"), selected: !a10, onSelect: n10 }), e14.map((e15, t11) => tp.createElement(Xit, __spreadProps(__spreadValues({ key: `${e15.name}_${t11}` }, e15), { selected: e15.id === a10, onSelect: n10 }))));
};
const tst = ["Checked", "CheckSize", "Value"];
const nst = ["Value", "MaxLength", "SpellCheck", "Multiline", "Password"];
const rst = ["FontFamily", "FontWeight", "FontStyle", "FontSize", "TextAlign", "Format"];
const ost = ["Checked", "CheckStyle", "CheckSize"];
const ast = [];
function ist(e14, t10, n10) {
  const r10 = zV.cloneDeep(e14);
  return t10.forEach((e15) => {
    delete r10[e15];
  }), n10 && n10.forEach((e15) => {
    delete r10.Style[e15];
  }), r10;
}
const sst = (e14) => "Text" === e14.InputType;
const lst = (e14) => {
  const t10 = (n10 = e14, __spreadProps(__spreadValues({}, zV.pick(n10, ost)), { Style: zV.pick(n10.Style, ast) }));
  var n10;
  return AV(ist(e14, ost, ast), { $hiddenCheckboxProps: { $set: t10 } });
};
const cst = (e14) => {
  const t10 = (n10 = e14, __spreadProps(__spreadValues({}, zV.pick(n10, nst)), { Style: zV.pick(n10.Style, rst) }));
  var n10;
  return AV(ist(e14, nst, rst), { $hiddenTextProps: { $set: t10 } });
};
const ust = (e14) => {
  const t10 = e14.$hiddenCheckboxProps;
  return zV.isEmpty(t10) ? e14 : zV.merge({}, e14, t10);
};
const dst = (e14) => {
  const t10 = e14.$hiddenTextProps;
  return zV.isEmpty(t10) ? e14 : zV.merge({}, e14, t10);
};
const pst = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" }, tp.createElement("path", { className: Ym.text, d: "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" }));
const mst = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" }, tp.createElement("path", { className: Ym.text, d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z" }));
const hst = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 352 512" }, tp.createElement("path", { className: Ym.text, d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z" }));
const fst = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 576 512" }, tp.createElement("path", { className: Ym.text, d: "M464 0H112c-4 0-7.8 2-10 5.4L2 152.6c-2.9 4.4-2.6 10.2.7 14.2l276 340.8c4.8 5.9 13.8 5.9 18.6 0l276-340.8c3.3-4.1 3.6-9.8.7-14.2L474.1 5.4C471.8 2 468.1 0 464 0zm-19.3 48l63.3 96h-68.4l-51.7-96h56.8zm-202.1 0h90.7l51.7 96H191l51.6-96zm-111.3 0h56.8l-51.7 96H68l63.3-96zm-43 144h51.4L208 352 88.3 192zm102.9 0h193.6L288 435.3 191.2 192zM368 352l68.2-160h51.4L368 352z" }));
const gst = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512" }, tp.createElement("path", { className: Ym.text, d: "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z" }));
const yst = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 576 512" }, tp.createElement("path", { className: Ym.text, d: "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z" }));
const vst = tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 384 512" }, tp.createElement("path", { className: Ym.text, d: "M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z" }));
const bst = (e14) => Are(["value", "field"], { hover(e15, t10, n10) {
  t10.isOver({ shallow: true }) && t10.canDrop() && n10.context.setDecorations("", []);
}, drop: (t10, n10, r10) => {
  const { dispatch: o10, item: { Type: a10 }, path: i10 } = t10;
  const s10 = n10.getItemType();
  if ("value" === s10) {
    const { expr: t11 } = n10.getItem();
    const r11 = [c5(i10, a10), o2({ descriptor: { valuePath: e14 }, value: t11 })];
    o10(rz(r11));
  } else if ("field" === s10) {
    const { field: { variationFormat: t11, value: s11, name: l10, aggregate: c10, dataType: u10 }, dataSetName: d10, format: p10, dropActions: m10, preventGroupUpdate: h10 } = n10.getItem();
    const f10 = function(e15) {
      let t12 = e15;
      for (t12 = e15; t12 && t12.getDecoratedComponentInstance; t12 = t12.getDecoratedComponentInstance()) ;
      return t12;
    }(r10).context.getAreaByPath(i10);
    const g10 = wee(f10) ? c10 : null;
    const y10 = t11 ? `=${U1(s11, t11)}` : `=${G1(s11, null, g10)}`;
    const v10 = c10 || u10 || t11 ? { aggregate: c10 != null ? c10 : "", type: u10 != null ? u10 : "", variationFormat: t11 } : null;
    const b10 = [c5(i10, a10), i2({ valuePath: e14 }, y10, d10, l10, !!h10, v10)];
    "string" == typeof p10 && b10.push(o2({ descriptor: { valuePath: "Style.Format" }, value: p10 })), m10 && b10.push(...m10), o10(rz(b10));
  }
} }, (e15, t10) => ({ connectDropTarget: e15.dropTarget(), isOver: t10.isOver(), canDrop: t10.canDrop() }));
const [Sst, Cst, xst] = Dp("rdlx-input-field-checkbox");
const [wst] = xst("icon");
const Tst = /^=?(true)$/i;
const Est = /^=?(false)$/i;
const Fst = (e14) => "string" == typeof e14 ? -1 !== e14.search(Tst) : !!e14;
const Mst = { Check: pst, Circle: mst, Cross: hst, Diamond: fst, Square: gst, Star: yst };
function kst(e14, t10) {
  return Fst(e14) ? Mst[t10] || Mst.Check : !((e15) => "string" == typeof e15 ? -1 !== e15.search(Est) : !e15)(e14) && jme(e14) ? vst : null;
}
class Pst extends tp.Component {
  constructor() {
    super(...arguments), this.handleCheckClick = (e14) => {
      const { dispatch: t10, item: n10 } = this.props;
      if (!sj(n10)) return;
      const r10 = Fst(n10.Checked) ? "=False" : "=True";
      t10(s2({ valuePath: "Checked" }, r10)), e14.stopPropagation();
    };
  }
  render() {
    const { connectDropTarget: e14, canDrop: t10, isOver: n10, theme: r10, onlyContent: o10 } = this.props;
    const { item: a10, item: { Style: i10, Checked: s10, Type: l10, CheckSize: c10, CheckStyle: u10 }, path: d10 } = this.props;
    const p10 = i10 || {};
    const m10 = kp("ar-item", Sst, o10 ? "" : Wme(n10, t10));
    const h10 = { color: Sme(p10.Color, r10) };
    const f10 = kp(wst, { selected: sj(a10) });
    const g10 = { fontSize: c10, borderColor: h10.color, height: c10 };
    const y10 = { type: "svg", content: kst(s10, u10), cssClass: kp(Cst("checked"), "wd-svg") };
    const v10 = tp.createElement("div", { "data-path": o10 ? void 0 : d10, "data-type": o10 ? void 0 : l10, className: m10, style: h10, onClick: o10 ? void 0 : this.handleCheckClick, title: X1(String(s10)) }, tp.createElement("div", { className: f10 }, tp.createElement("div", { style: g10 }, y10 && tp.createElement(Fm, { icon: y10 }))));
    return o10 ? v10 : e14(v10);
  }
}
Pst.contextType = bqe;
var Nst = TA()(bst("Checked")(Pst));
function Dst(e14) {
  return "object" == typeof e14 && null !== e14 && true === e14.__wd_core_clipboard__;
}
function Lst(e14) {
  if (!e14) return null;
  try {
    const t10 = JSON.parse(e14);
    if (Dst(t10)) return t10;
  } catch (e15) {
  }
  return null;
}
function Hst(e14, t10 = "") {
  const n10 = { __wd_core_clipboard__: true, platform: t10, data: e14 };
  try {
    return JSON.stringify(n10);
  } catch (e15) {
  }
  return null;
}
let Ist = "";
const _st = {};
function Vst(e14, t10) {
  let n10 = t10 ? null : function() {
    const e15 = navigator == null ? void 0 : navigator.clipboard;
    return e15 && "function" == typeof e15.readText && "function" == typeof e15.writeText ? { get: () => e15.readText().then(Lst), put: (t11, n11 = "") => e15.writeText(Hst(t11, n11) || "") } : null;
  }();
  const r10 = (o10 = "wd-core-clipboard", localStorage ? { get: () => {
    const e15 = Lst(localStorage.getItem(o10));
    return Promise.resolve(e15);
  }, put: (e15, t11 = "") => {
    const n11 = Hst(e15, t11);
    return localStorage.setItem(o10, n11 || ""), Promise.resolve();
  } } : null);
  var o10;
  const a10 = { get: () => {
    const e15 = Lst(Ist);
    return Promise.resolve(e15);
  }, put: (e15, t11 = "") => new Promise((n11) => {
    const r11 = Hst(e15, t11);
    Ist = r11 || "", n11();
  }) };
  const i10 = { get: function() {
    return __async(this, null, function* () {
      let e15;
      if (n10) try {
        return e15 = yield n10.get(), e15;
      } catch (e16) {
        n10 = null;
      }
      return r10 ? r10.get() : a10.get();
    });
  }, put: function(e15, t11 = "") {
    return __async(this, null, function* () {
      if (n10) try {
        yield n10.put(e15, t11);
      } catch (e16) {
        n10 = null;
      }
      return r10 ? r10.put(e15, t11) : a10.put(e15, t11);
    });
  } };
  return _st[e14] = i10, i10;
}
Vst.of = (e14) => _st[e14];
const [Rst, Ast, Ost] = Dp("quick-edit-box");
const [Bst] = Ost("clicker");
const zst = Ast("visible");
const $st = ({ dataPath: e14, value: t10, getTextAreaStyle: n10, commitValue: r10, parentClassName: o10 }) => {
  const a10 = ep.useRef(null);
  const [i10, s10] = ep.useState(true);
  const [l10, c10] = ep.useState(false);
  const [u10, d10] = ep.useState(t10);
  const p10 = () => {
    const e15 = a10.current;
    e15 && e15.focus({ preventScroll: true });
  };
  const m10 = ep.useCallback(() => {
    if (!a10.current || !o10) return null;
    const e15 = a10.current;
    const t11 = (e16) => {
      const n12 = e16.parentElement;
      return n12 ? n12.classList.contains(o10) ? n12 : t11(n12) : null;
    };
    const n11 = t11(e15);
    if (!n11) return null;
    return { observer: new MutationObserver(() => {
      c10(false), p10();
    }), observeElement: n11 };
  }, [o10]);
  ep.useEffect(() => {
    p10();
    const e15 = m10();
    if (e15) {
      const { observer: t11, observeElement: n11 } = e15;
      t11.observe(n11, { attributes: true });
    }
    return () => e15 == null ? void 0 : e15.observer.disconnect();
  }, [m10]), ep.useEffect(() => {
    t10 !== u10 && d10(t10);
  }, [t10]);
  const h10 = PA();
  const f10 = kp(Rst, { [zst]: l10 });
  const g10 = n10(l10);
  return tp.createElement("div", { className: Bst, onClick: () => {
    l10 || p10();
  }, onDoubleClick: () => {
    p10(), c10(true), s10(false), (() => {
      if (a10.current) {
        const e15 = u10.length;
        a10.current.setSelectionRange(e15, e15);
      }
    })();
  }, style: { pointerEvents: "all" }, "data-path": e14 }, tp.createElement("textarea", { ref: a10, value: u10, className: f10, style: g10, autoCapitalize: "off", autoComplete: "off", autoCorrect: "off", spellCheck: false, onChange: (e15) => {
    d10(e15.target.value);
  }, onBlur: () => {
    const e15 = a10.current;
    e15 && r10(e15.value);
  }, onKeyDown: (e15) => {
    const n11 = e15.nativeEvent.code;
    const o11 = SB(e15);
    if ("KeyV" === n11 && o11) e15.stopPropagation();
    else if (l10) {
      if ("Enter" === n11 && o11) return r10(u10), c10(false), void s10(true);
      "Escape" === n11 && (d10(t10), c10(false), s10(true)), "Tab" !== n11 ? e15.stopPropagation() : r10(u10);
    }
  }, onPaste: (e15) => {
    Lst(e15.clipboardData.getData("Text")) && (e15.preventDefault(), h10(mB()));
  }, onBeforeInput: () => {
    l10 || c10(true), i10 && (d10(""), s10(false));
  } }));
};
const Wst = /Theme.Colors(\(([\d\s]+),([\d\s]+)\)|!(\w+))/;
const jst = { 0: "Dark1", 1: "Light1", 2: "Dark2", 3: "Light2", 4: "Accent1", 5: "Accent2", 6: "Accent3", 7: "Accent4", 8: "Accent5", 9: "Accent6", 10: "Hyperlink", 11: "HyperlinkFollowed" };
Object.entries(jst).reduce((e14, [t10, n10]) => Object.assign(e14, { [n10]: t10 }), {});
const Zst = "1", Gst = "2", Ust = "3", qst = "4", Yst = "5";
const Kst = (e14, t10) => ((e15, t11) => {
  const n10 = dm.fromString(e15);
  switch (t11) {
    case Zst:
      return dm.shade(n10, 0.75);
    case Gst:
      return dm.shade(n10, 0.5);
    case Ust:
      return dm.shade(n10, 0.25);
    case qst:
      return dm.shade(n10, -0.25);
    case Yst:
      return dm.shade(n10, -0.5);
    default:
      return n10;
  }
})(e14, t10).hex;
const Xst = (e14, t10 = null) => {
  if (!t10) return e14;
  const n10 = Wst.exec(e14);
  if (!n10) return e14;
  const [, , r10, o10, a10] = n10.map((e15) => e15 == null ? void 0 : e15.trim());
  if (r10 && o10) {
    const e15 = ((e16) => jst[e16])(o10);
    return Kst(t10.Colors[e15], r10);
  }
  return a10 ? t10.Colors[a10] : e14;
};
const Jst = (e14) => {
  let t10;
  switch (e14) {
    case "Lighter":
      t10 = "lighter";
      break;
    case "Thin":
      t10 = 100;
      break;
    case "ExtraLight":
      t10 = 200;
      break;
    case "Light":
      t10 = 300;
      break;
    case "Normal":
    default:
      t10 = "normal";
      break;
    case "Medium":
      t10 = 500;
      break;
    case "SemiBold":
      t10 = 600;
      break;
    case "Bold":
      t10 = 700;
      break;
    case "ExtraBold":
      t10 = 800;
      break;
    case "Heavy":
      t10 = 900;
      break;
    case "Bolder":
      t10 = "bolder";
  }
  return t10;
};
const Qst = ({ fontFamily: e14, fontSize: t10, fontStyle: n10, fontWeight: r10, textAlign: o10 }, a10, i10 = Jst) => {
  const s10 = { fontFamily: e14, fontSize: t10, fontStyle: n10, fontWeight: i10(r10), textAlign: o10 };
  if (!a10) return s10;
  const l10 = (e15, t11, n11) => ((e16) => e16 && e16.includes("Theme.Fonts!"))(e15) ? ((e16) => e16.includes("Theme.Fonts!MajorFont"))(e15) ? a10.Fonts.MajorFont[t11] : a10.Fonts.MinorFont[t11] : n11 ? n11(e15) : e15;
  return s10.fontFamily = `"${l10(e14, "Family")}"`, s10.fontSize = l10(t10, "Size"), s10.fontStyle = l10(n10, "Style"), s10.fontWeight = l10(r10, "Weight", i10), s10;
};
const elt = ({ PaddingLeft: e14, PaddingTop: t10, PaddingRight: n10, PaddingBottom: r10 }, o10 = "0pt") => ({ paddingLeft: e14 || o10, paddingTop: t10 || o10, paddingRight: n10 || o10, paddingBottom: r10 || o10 });
const tlt = { LineThrough: "line-through", Overline: "overline", None: "none", Underline: "underline", DoubleUnderline: "double underline" };
const nlt = (e14, t10) => {
  const n10 = p9();
  const r10 = ep.useCallback((r11) => {
    if (!r11) return {};
    const { Style: { FontFamily: o10, FontSize: a10, FontStyle: i10, FontWeight: s10, Color: l10, BackgroundColor: c10 } } = e14;
    const { Style: { TextAlign: u10 } } = e14;
    const d10 = Qst({ fontFamily: o10, fontSize: a10, fontStyle: i10, fontWeight: s10, textAlign: u10 }, n10);
    const p10 = "TextDecoration" in e14.Style ? ((e15) => {
      var _a2;
      const t11 = (_a2 = tlt[e15]) != null ? _a2 : tlt.None;
      return { textDecoration: t11, WebkitTextDecoration: t11 };
    })(e14.Style.TextDecoration) : {};
    const m10 = "LineSpacing" in e14.Style ? ((e15, t11) => {
      const n11 = (e16, t12) => {
        const n12 = L$.isValidString(e16) ? e16 : t12;
        return L$.parse(n12).toTwips;
      };
      const r12 = n11(e15, "0pt");
      const o11 = n11(`${t11}`, "10pt");
      return (0 === r12 ? L$.fromTwips(1.15 * o11, "pt") : L$.fromTwips(o11 + r12 / 1.15, "pt")).css;
    })(e14.Style.LineSpacing, d10.fontSize) : void 0;
    const h10 = "PaddingTop" in e14.Style ? elt(e14.Style) : {};
    return __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, d10), h10), p10), { lineHeight: m10, color: Xst(l10, n10), backgroundColor: Bme(c10, t10, n10), pointerEvents: "all" });
  }, [e14, t10, n10]);
  return r10;
};
const rlt = ({ item: e14, path: t10, value: n10, valuePath: r10, parentBackgroundColor: o10 }) => {
  const { rdlx: { expressionSyntax: a10 } } = Uae();
  const i10 = PA();
  const s10 = ep.useCallback((e15) => {
    if (e15 === n10) return;
    const o11 = "i11n" === a10 ? fu(e15) : J1(e15);
    i10(c2({ path: t10, descriptor: Zq("", "", "string_expr", r10), value: o11 }));
  }, [i10, a10, n10, t10, r10]);
  const l10 = nlt(e14, o10);
  const c10 = { dataPath: t10, getTextAreaStyle: l10, commitValue: s10, value: n10, parentClassName: "ar-reportitemplace" };
  return tp.createElement($st, __spreadValues({}, c10));
};
const [olt, alt] = Dp("rdlx-input-field-text");
const ilt = (e14) => {
  const t10 = {};
  return "General" !== e14.TextAlign && (t10.textAlign = e14.TextAlign), t10;
};
class slt extends tp.PureComponent {
  render() {
    const { item: e14, path: t10, connectDropTarget: n10, canDrop: r10, isOver: o10, theme: a10, parentBackgroundColor: i10, onlyContent: s10 } = this.props;
    const { item: { Style: l10, Type: c10 } } = this.props;
    const u10 = __spreadValues(__spreadValues({ color: Sme(l10.Color, a10) }, _me({ family: l10.FontFamily, size: l10.FontSize, style: l10.FontStyle, weight: l10.FontWeight }, a10)), ilt(l10));
    const d10 = X1(YAe(String(e14.Value) || "")).split("\n");
    const p10 = tp.createElement("div", { "data-path": s10 ? void 0 : t10, "data-type": s10 ? void 0 : c10, className: kp("ar-item", olt, s10 ? "" : Wme(o10, r10)), style: u10, title: d10.toString() }, tp.createElement("div", { className: alt("text-wrapper") }, d10.map((e15, t11) => {
      const n11 = `${t11}`;
      return [e15, tp.createElement("br", { key: n11 })];
    })), !s10 && ij(e14) && tp.createElement(rlt, { item: e14, path: t10, value: d10.toString(), valuePath: "Value", parentBackgroundColor: i10 }));
    return s10 ? p10 : n10(p10);
  }
}
slt.contextType = bqe;
var llt = TA()(bst("Value")(slt));
const clt = __spreadProps(__spreadValues({}, FZ.resultOf(wq.decode({ Type: "inputfield", Name: "inputField", Width: "1in", Height: "0.25in" }))), { Checked: "False", CheckStyle: "Check", CheckSize: "10pt" });
const ult = (e14) => `inputField.${e14}`;
const dlt = "input";
const plt = { name: EY.Name, inputType: Zq(dlt, ult("inputType"), "input_type", "InputType"), fieldName: Zq(dlt, ult("fieldName"), "field_name", "FieldName"), readonly: Zq(dlt, ult("readonly"), "boolean", "Readonly"), required: Zq(dlt, ult("required"), "boolean", "Required"), tabIndex: Zq(dlt, ult("tabIndex"), "number", "TabIndex", void 0, { numberType: "Integer", minValue: 1, step: 1, emptyValue: "Null" }), value: Zq(dlt, ult("value"), "string_expr", "Value"), maxLength: Zq(dlt, ult("maxLength"), "number", "MaxLength", void 0, { numberType: "Integer", minValue: 1, maxValue: 1e9, step: 1, emptyValue: "Null" }), spellCheck: Zq(dlt, ult("spellCheck"), "boolean", "SpellCheck"), multiline: Zq(dlt, ult("multiline"), "boolean", "Multiline"), password: Zq(dlt, ult("password"), "boolean", "Password"), checked: Zq(dlt, ult("checked"), "boolean_expr", "Checked"), checkStyle: Zq(dlt, ult("checkStyle"), "enum", "CheckStyle", void 0, { enumKey: "check_style" }), checkSize: Zq(dlt, ult("checkSize"), "font_size_expr", "CheckSize", void 0, { enumKey: "font_size", unit: "pt" }), backgroundAndBorders: vY.BackgroundAndBorders, backgroundColor: vY.BackgroundColor, border: vY.Borders, fontSimple: Zq(gY, "style.font", "font_simple", "Style", "simple", { showTextDecoration: false }), color: vY.Color, checkBoxColor: Zq(gY, "style.color", "color_expr", "Style.Color"), font: vY.Font, textAlign: Zq(gY, "style.textAlign", "enum_expr", "Style.TextAlign", "advanced", { enumKey: "text_align_glcr" }), format: Zq(gY, "style.format", "format", "Style.Format"), location: EY.Location, size: EY.Size, style: Zq(cY, "reportItem.style", "styles", "ReportStyle", void 0, { target: "InputField" }), layerName: EY.LayerName, zIndex: EY.ZIndex, visibility: EY.Visibility, dataElementName: EY.DataElementName, dataElementOutput: EY.DataElementOutput, toolTip: EY.ToolTip, label: EY.Label, bookmark: EY.Bookmark };
const mlt = [plt.name, plt.inputType, plt.fieldName, plt.readonly, plt.required, plt.value, plt.maxLength, plt.spellCheck, plt.multiline, plt.password, plt.checked, plt.checkStyle, plt.checkSize, plt.backgroundColor, plt.border, plt.color, plt.font, plt.textAlign, plt.format, plt.location, plt.size, plt.style, plt.layerName, plt.zIndex, plt.visibility, plt.dataElementName, plt.dataElementOutput, plt.toolTip, plt.label, plt.bookmark];
const hlt = [plt.name, plt.inputType, plt.fieldName, plt.readonly, plt.required, plt.tabIndex, plt.value, plt.maxLength, plt.spellCheck, plt.multiline, plt.password, plt.backgroundColor, plt.border, plt.backgroundAndBorders, plt.fontSimple, plt.color, plt.font, plt.textAlign, plt.format, plt.location, plt.size, plt.style, plt.layerName, plt.zIndex, plt.visibility, plt.dataElementName, plt.dataElementOutput, plt.toolTip, plt.label, plt.bookmark];
const flt = [plt.name, plt.inputType, plt.fieldName, plt.readonly, plt.required, plt.tabIndex, plt.checked, plt.checkStyle, plt.checkSize, plt.backgroundColor, plt.border, plt.backgroundAndBorders, plt.checkBoxColor, plt.location, plt.size, plt.style, plt.layerName, plt.zIndex, plt.visibility, plt.dataElementName, plt.dataElementOutput, plt.toolTip, plt.label, plt.bookmark];
const glt = (e14, t10) => {
  if (e14 && e14.$targetType !== wj.InputField) return null;
  const n10 = ((e15) => {
    const t11 = nz.of(e15).getTemplate("inputfield");
    const { Style: { BackgroundColor: n11, Color: r10, FontFamily: o10, FontSize: a10, FontStyle: i10, FontWeight: s10 } } = t11;
    return { BackgroundColor: n11, Color: r10, FontFamily: o10, FontSize: a10, FontStyle: i10, FontWeight: s10 };
  })(t10);
  return e14 ? __spreadValues(__spreadValues({}, n10), e14) : n10;
};
const ylt = GV((e14, { payload: { inputType: t10 } }) => e14.InputType !== t10, jV(GV(sst, jV(cst, ust), jV(lst, dst)), (e14, { payload: { inputType: t10 } }) => AV(e14, { InputType: { $set: t10 } })));
const vlt = (e14, { payload: t10 }) => AV(e14, { ReportStyle: { $set: { StyleId: t10.id || "", StyleName: t10.name || "" } } });
const blt = (e14) => (t10, { payload: n10 }) => {
  const r10 = glt(n10.style, e14);
  return r10 ? function(e15, t11) {
    const n11 = __spreadValues(__spreadValues({}, e15.Style), t11);
    return AV(e15, { Style: { $set: n11 } });
  }(t10, r10) : t10;
};
const Slt = (e14) => jV(GV(sst, ust, dst), blt(e14), GV(sst, lst, cst));
const Clt = { type: "inputfield", labelKey: "reportItems:inputField", nameTemplateKey: "nameTemplates:inputField", init: (e14, t10, n10, r10 = clt) => __spreadProps(__spreadValues(__spreadValues({}, r10), n10), { Name: e14 || "" }), icon: nf(tae), icon24: nf(nae), defaultModel: clt, glyph: (e14) => {
  const { item: t10 } = e14;
  return sst(t10) ? tp.createElement(llt, __spreadValues({}, __spreadProps(__spreadValues({}, e14), { item: t10 }))) : tp.createElement(Nst, __spreadValues({}, __spreadProps(__spreadValues({}, e14), { item: t10 })));
}, getReducer: function(e14) {
  const t10 = nz.of(e14).of("rdlx").getDefaultReducer();
  return Uye(0, { [yke]: ylt, [v2.type]: GV(rj, vlt), [b2.type]: GV(rj, Slt(e14)) }, t10);
}, getProperties: (e14) => {
  switch (e14.InputType) {
    case "Text":
      return hlt;
    case "CheckBox":
      return flt;
    default:
      return mlt;
  }
}, getContextActions: i0e, features: { getExpressionProperties: function() {
  return tst;
}, borderStyles: ["None", "Dashed", "Solid", "Inset"] } };
const xlt = (e14, t10, n10) => {
  const { lockLayout: r10 } = KO.of(t10);
  const o10 = i0e(e14, t10, n10);
  if (r10) return o10;
  const a10 = (e14.ReportItems || []).filter((e15) => rj(e15));
  const i10 = (e14.ReportItems || []).filter((e15) => rj(e15) && Z7(e15));
  if (0 === a10.length) return o10;
  const s10 = ((e15, t11) => {
    if (1 !== e15.length || !sj(e15[0])) return null;
    const n11 = e15[0];
    const r11 = n11.Type;
    if (!_1e[r11]) return null;
    const { getPropertyDescriptor: o11, defaultValue: a11 } = _1e[r11];
    const i11 = { descriptor: o11(), objectValues: [n11], defaultValues: [a11] };
    const s11 = { type: "button", icon: nf(q1e), key: "contextActions:container.expression", textKey: "contextActions:container.expression", action: _A.of(t11).open("connectedExpressionEditor", i11) };
    return { type: "group", key: nz.of(t11).of("rdlx").getLabelKey(r11), actions: [s11] };
  })(a10, t10);
  if (null !== s10 && o10.push(s10), i10.length) return o10;
  const l10 = { type: "button", icon: nf(t1e), key: "contextActions:container.delete", action: JG() };
  return o10.push(l10), o10;
};
const wlt = ({ orientation: e14, documentItemPath: t10, type: n10, moveSide: r10, documentItemType: o10 }) => {
  const [, a10, i10] = Yne({ item: { type: n10 != null ? n10 : "resizeLine", moveSide: r10, path: t10 }, collect: (e15) => ({ isDragging: e15.isDragging() }) });
  ep.useEffect(() => {
    i10(Coe(), { captureDraggingState: true });
  }, []);
  const [s10, l10] = /* @__PURE__ */ ((e15, t11) => "dashboardsection" === t11 ? [void 0, void 0] : [e15, t11])(t10, o10);
  return tp.createElement("div", { ref: a10, "data-path": s10, "data-type": l10, className: `ar-resizeline ar-resizeline-${e14} ar-resizeline-${r10}` });
};
const Tlt = (e14) => {
  const t10 = h9();
  if (!("multisectionreport" === t10.Type && t10.$masterReport)) return;
  const n10 = jN(e14)(t10.$masterReportContent);
  return n10 ? __spreadProps(__spreadValues({}, n10), { ReportItems: ((n10 == null ? void 0 : n10.ReportItems) || []).filter((e15) => "contentplaceholder" !== e15.Type) }) : void 0;
};
const Elt = () => {
  const e14 = { initScroll: { x: void 0, y: void 0 }, scrolled: false, scrollOffset: { x: 0, y: 0 } };
  const t10 = ep.useRef(e14);
  return { detectScrollOffset: (e15) => {
    var _a2, _b2;
    const n10 = ((e16) => {
      let t11 = e16 == null ? void 0 : e16.parentElement;
      let n11 = 0;
      let r11 = 0;
      for (; t11; ) n11 += t11.scrollTop, r11 += t11.scrollLeft, t11 = t11.parentElement;
      return { x: r11, y: n11 };
    })(e15);
    const { initScroll: r10, scrollOffset: o10 } = t10.current;
    r10.x = (_a2 = r10.x) != null ? _a2 : n10.x, r10.y = (_b2 = r10.y) != null ? _b2 : n10.y, t10.current.scrolled || n10.x === r10.x && n10.y === r10.y || (t10.current.scrolled = true), t10.current.scrolled && (o10.x = n10.x - r10.x, o10.y = n10.y - r10.y);
  }, reset: () => {
    const { initScroll: e15, scrollOffset: n10 } = t10.current;
    t10.current.scrolled = false, e15.x = void 0, e15.y = void 0, n10.x = 0, n10.y = 0;
  }, scrollOffset: t10.current.scrollOffset };
};
class Flt extends tp.Component {
  constructor() {
    super(...arguments), this.zoomString = (e14, t10 = 1) => L$.parse(e14).multiply(t10).css;
  }
  render() {
    const { size: e14, id: t10, roundStyle: n10 } = this.props;
    const { getSettings: r10 } = this.context;
    const { zoomFactor: o10 } = r10();
    const a10 = this.zoomString(e14, o10);
    const i10 = { className: kp("bg-grid", Mee), style: __spreadValues({}, n10) };
    const s10 = L$.toPixels(a10);
    const l10 = `url('${window.location.pathname}${window.location.search}#${t10}')`;
    return tp.createElement("div", __spreadValues({}, i10), tp.createElement("svg", { width: "100%", height: "100%", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("pattern", { id: t10, width: s10, height: s10, patternUnits: "userSpaceOnUse" }, tp.createElement("path", { d: `M ${s10} 0 L 0 0 0 ${s10}`, fill: "none", stroke: "#AAA", strokeWidth: "1", strokeOpacity: "0.7" }))), tp.createElement("rect", { x: "1", y: "1", width: "100%", height: "100%", fill: l10 })));
  }
}
function Mlt({ left: e14, top: t10, width: n10, height: r10 }, { left: o10, top: a10, width: i10, height: s10 }) {
  const [l10, c10] = [e14.add(n10), t10.add(r10)];
  const [u10, d10] = [o10.add(i10), a10.add(s10)];
  return e14.lowerThan(u10) && o10.lowerThan(l10) && t10.lowerThan(d10) && a10.lowerThan(c10);
}
function klt(e14, t10, n10) {
  const r10 = [];
  return e14.ReportItems.forEach((o10, a10) => {
    var _a2, _b2, _c2, _d2;
    if (!k3(o10, n10).isVisible) return;
    const i10 = L$.parseSafe("fixedpagesection" === e14.Type ? n10.Page.PageHeight : e14.$height || e14.$place.Height).subtract(G5);
    const s10 = L$.parseSafe((_b2 = (_a2 = o10.$fixedPlace) == null ? void 0 : _a2.Width) != null ? _b2 : o10.$place.Width);
    const l10 = L$.parseSafe((_d2 = (_c2 = o10.$fixedPlace) == null ? void 0 : _c2.Height) != null ? _d2 : o10.$place.Height);
    Mlt({ left: L$.parseSafe(o10.$place.Left), top: L$.min([L$.parseSafe(o10.$place.Top), i10]), width: L$.max([G5, s10]), height: L$.max([G5, l10]) }, t10) && r10.push({ index: a10, type: o10.Type, name: o10.Name });
  }), r10;
}
Flt.propTypes = { show: JV.bool, size: JV.string, roundStyle: JV.object, id: JV.string }, Flt.contextType = bqe;
const Plt = (e14) => {
  let t10 = e14;
  let n10 = 0;
  let r10 = 0;
  do {
    const { offsetTop: e15, scrollTop: o10, offsetLeft: a10, scrollLeft: i10 } = t10;
    n10 += e15, o10 && (n10 -= o10), r10 += a10, i10 && (r10 -= i10), t10 = t10.offsetParent;
  } while (t10);
  return n10 -= window.scrollY, r10 -= window.scrollX, { top: n10, left: r10 };
};
const Nlt = (e14, t10, n10, r10 = { x: 0, y: 0 }) => {
  const o10 = e14.getInitialClientOffset() || { x: 0, y: 0 };
  const a10 = e14.getDifferenceFromInitialOffset() || { x: 0, y: 0 };
  const i10 = o10.x - n10.left;
  const s10 = o10.y - n10.top;
  const l10 = i10 + a10.x + r10.x;
  const c10 = s10 + a10.y + r10.y;
  return { left: Math.min(i10, l10) / t10, top: Math.min(s10, c10) / t10, right: Math.max(i10, l10) / t10, bottom: Math.max(s10, c10) / t10 };
};
const Dlt = (e14, t10) => {
  const { left: n10, top: r10, right: o10, bottom: a10 } = t10;
  const { left: i10, top: s10, right: l10, bottom: c10 } = e14;
  const [u10, d10, p10, m10] = [Math.max(0, n10 - i10), Math.max(0, r10 - s10), Math.min((l10 != null ? l10 : 0) - i10, (o10 != null ? o10 : 0) - i10), Math.min((c10 != null ? c10 : 0) - s10, (a10 != null ? a10 : 0) - s10)];
  return { left: u10, top: d10, right: p10, bottom: m10 };
};
const Llt = (e14) => ({ top: L$.fromPixels(e14.top), left: L$.fromPixels(e14.left), width: L$.fromPixels(e14.right - e14.left), height: L$.fromPixels(e14.bottom - e14.top) });
const Hlt = (e14, t10, n10, r10) => {
  const o10 = Dlt(t10, e14);
  const a10 = { top: t10.top + o10.top, left: t10.left + o10.left, right: t10.left + o10.right, bottom: t10.top + o10.bottom };
  const i10 = Llt(a10);
  r10(n10, [__spreadValues({ type: "selarea" }, zV.mapValues(i10, (e15) => e15.css))]);
};
const Ilt = (e14, t10, n10) => {
  const r10 = Dlt(e14.absolutePosition, t10);
  const o10 = Llt(r10);
  const a10 = klt(e14.item, o10, n10());
  const i10 = q7(n10());
  let s10 = [];
  if (a10.length) if (i10 && "contentplaceholder" !== e14.item.Type) {
    const t11 = e14.item.ReportItems.filter((e15) => "contentplaceholder" === e15.Type);
    s10 = a10.filter((e15) => "contentplaceholder" === e15.type).map((n11) => {
      const r11 = t11.findIndex((e15) => e15.Name === n11.name);
      return { path: `${e14.path}.ReportItems.${r11}`, type: n11.type };
    });
  } else s10 = a10.map((t11) => ({ path: `${e14.path}.ReportItems.${t11.index}`, type: t11.type }));
  return s10.length || (s10 = [{ path: e14.path, type: e14.type }]), { ctrlPressed: k0e.ctrlPressed, itemsToSelect: s10 };
};
const _lt = ["bullet", "dvchart", "sparkline", "subreport", "list", "tableofcontents", "table", "tablix", "bandedlist"];
function Vlt(e14) {
  let t10 = "";
  return C3(e14, (e15, n10) => (_lt.includes(n10.Type) && (t10 = n10.Type), t10 ? null : {})), t10;
}
const Rlt = (e14) => {
  var _a2;
  let t10 = X3(e14, void 0);
  const n10 = L$.parse(e14.$height || ((_a2 = e14.$place) == null ? void 0 : _a2.Height));
  const r10 = L3(e14);
  const o10 = r10.Width === L$.zero ? G5.css : r10.Width.css;
  t10 = o10 !== e14.$width ? AV(e14, { $width: { $set: o10 } }) : t10;
  const a10 = (i10 = t10) && i10.$height && L$.parse(i10.$height) || G5;
  var i10;
  const s10 = n10.greaterThan(a10) ? n10.css : a10.css;
  return s10 !== t10.$place.Height ? AV(t10, { $place: { Height: { $set: s10 } } }) : t10;
};
const Alt = (e14, t10) => {
  const { item: n10 } = t10.payload;
  const r10 = Vlt(n10);
  if (r10) throw $0(r10, e14.Type);
  return e14;
};
const Olt = (e14, t10) => {
  const { Type: n10 } = t10.payload;
  if (_lt.includes(n10)) throw $0(n10, e14.Type);
  return e14;
};
const Blt = (e14, t10) => {
  const { items: n10 } = t10.payload;
  return n10.forEach((t11) => {
    const n11 = Vlt(t11);
    if (n11) throw $0(n11, e14.Type);
  }), e14;
};
const zlt = (e14, t10) => {
  const n10 = KO.of(t10);
  const { lockLayout: r10, userPreferences: { surface: { zoomFactor: o10 } } } = n10;
  const { name: a10, type: i10, ref: s10 } = e14;
  const l10 = h9();
  const { setDecorations: c10, getDefaultStyle: u10 } = ep.useContext(bqe);
  const d10 = PA();
  const p10 = (e15, t11) => {
    if (r10) return false;
    if (!t11.isOver({ shallow: true })) return false;
    const n11 = t11.getItem();
    if ("resizegrip" === n11.type || "placeHolderResizeGrip" === n11.type) {
      if (n11.resize) return true;
    } else if ("reportitem" === n11.type) {
      const { movedItems: e16, reportItemType: r11 } = n11 || {};
      const o11 = t11.getItemType();
      const a11 = "pagesection" === o11 && (r11 && _lt.includes(r11) || e16 && e16.some(Vlt));
      const i11 = BW(o11) && WW(r11);
      return !(a11 || i11);
    }
    return true;
  };
  const m10 = { drop: (r11, s11) => {
    const c11 = s11.getItemType();
    const m11 = s11.getItem();
    const h10 = m11.reportItemType || m11.itemType || "textbox";
    if (p10(0, s11)) {
      const r12 = ("resizegrip" === m11.type || "placeHolderResizeGrip" === m11.type) && m11.resize ? m11.host : a10;
      const p11 = [...m11.startDndActions || []];
      const { movedItems: f10 = [], childItemNames: g10 = [] } = m11;
      const y10 = e2e(s11, o10, r12, f10, g10);
      const v10 = i2e(e14, y10, n10, l10);
      const b10 = v10 == null ? void 0 : v10.error;
      if (b10) hm.of(t10).notifications.send({ type: "notification", payload: { caption: b10.name, content: b10.message, level: b10.type } });
      else {
        const e15 = (v10 == null ? void 0 : v10.actions) || [];
        if (e15.length > 0 && (p11.push(...e15), ((e16) => ["field", "value", "partItem", "toolboxItem", "smartSuggestion", "dataset", "fields", "entity_relation"].includes(e16))(c11))) {
          const e16 = u10(h10 || "textbox");
          e16 && l10.Themes[0] && p11.push(v2({ id: e16.id, name: e16.name }), b2({ style: e16.content }));
        }
        if ("partItem" === m11.type) {
          const { partName: e16, library: t11, shouldAddLibrary: n11, dataSources: r13, dataSets: o11, reportParameters: a11, partItemProperties: i11, embeddedImages: s12 } = m11;
          n11 && p11.push(V2({ library: t11, embeddedImages: s12 })), p11.push(J0({ dataSources: r13, dataSets: o11 }), e22({ params: a11 }), o2({ descriptor: { valuePath: "ReportPart" }, value: e16 }), o2({ descriptor: { valuePath: "Library" }, value: t11.Name }), o2({ descriptor: { valuePath: "Properties" }, value: i11 }));
        }
        if ("value" === m11.type && p11.push(o2({ descriptor: { valuePath: "Value" }, value: m11.expr })), "field" === m11.type) {
          const { field: { variationFormat: e16, dataType: t11, name: n11, value: r13 } } = m11;
          const o11 = ((e17) => HW(PW, e17))(i10) ? m11.field.aggregate : null;
          const a11 = e16 ? `=${U1(r13, e16)}` : `=${G1(r13, null, o11)}`;
          const s12 = { variationFormat: e16 || "", type: t11 || "", aggregate: o11 || "" };
          p11.push(a2({ valuePath: "Value", category: "", label: "", type: "", mode: "both" }, a11, m11.dataSetName, n11, s12)), "string" == typeof m11.format && p11.push(o2({ descriptor: { valuePath: "Style.Format" }, value: m11.format }));
        }
        if ("field" !== m11.type && "entity_relation" !== m11.type || !m11.dropActions || p11.push(...m11.dropActions), p11.length > 0 && !b10) {
          const e16 = "toolboxItem" === c11 ? p2({ actions: p11 }) : rz(p11);
          d10(e16);
        }
      }
    }
  }, hover: (t11, i11) => {
    if (!i11.isOver({ shallow: true }) || r10) return;
    const u11 = i11.getItem();
    const d11 = ("resizegrip" === u11.type || "placeHolderResizeGrip" === u11.type) && u11.resize;
    const m11 = d11 ? u11.host : a10;
    if (p10(0, i11)) {
      const { movedItems: t12 = [], childItemNames: r11 = [] } = u11;
      const a11 = e2e(i11, o10, m11, t12, r11);
      s2e(e14, a11, n10, l10, c10);
    } else d11 || P0e(s10, m11, c10);
  }, canDrop: p10, collect: (e15) => ({ isOver: e15.isOver(), canDrop: e15.canDrop() }) };
  return m10;
};
const [$lt, , Wlt] = Dp("ar-rectangle-glyph");
const [jlt] = Wlt("draggable-area");
const [Zlt] = Wlt("overlay");
const Glt = (e14) => ((e15) => "" === e15 || e15 && L$.isValidString(e15) || false)(e14) ? e14 : "0pt";
const Ult = (e14) => {
  const { item: t10, path: n10 } = e14;
  const r10 = PA();
  const o10 = ep.useRef(null);
  const a10 = h9();
  const i10 = Elt();
  const [, s10, l10] = Yne({ item: { type: "rectselect" }, begin: () => {
    const e15 = ((e16) => {
      let t11 = e16;
      let n11 = 0;
      let r12 = 0;
      do {
        if (!t11.classList || !t11.classList.contains("ar-sel-adorner")) {
          const { offsetTop: e17, scrollTop: o11, offsetLeft: a11, scrollLeft: i11 } = t11;
          n11 += e17 || 0, o11 && (n11 -= o11), r12 += a11 || 0, i11 && (r12 -= i11);
        }
        t11 = t11.offsetParent;
      } while (t11 && !t11.classList.contains("is-report-area"));
      return { top: n11, left: r12 };
    })(o10.current);
    const r11 = ((e16, t11, n11) => {
      const { top: r12, left: o11 } = n11;
      let [a11, i11] = [null, null];
      if ("section" === t11.Type) {
        if ("dashboard" === e16.Type) {
          const t12 = e16.ReportSections[e16.$activeSectionIndex];
          a11 = r12 + L$.toPixels(t12.Body.$place.Height), i11 = o11 + L$.toPixels(t12.Width);
        } else if ("multisectionreport" === e16.Type) {
          const t12 = s3(e16.ReportSections[e16.$activeSectionIndex]);
          a11 = r12 + L$.toPixels(t12.bodyHeight), i11 = o11 + L$.toPixels(t12.sectionWidth);
        }
      } else if ("pagesection" === t11.Type) {
        if ("dashboard" === e16.Type) {
          const n12 = e16.ReportSections[e16.$activeSectionIndex];
          a11 = r12 + L$.toPixels(t11.$place.Height), i11 = o11 + L$.toPixels(n12.Width);
        } else if ("multisectionreport" === e16.Type) {
          const n12 = s3(e16.ReportSections[e16.$activeSectionIndex]);
          a11 = r12 + L$.toPixels(t11.$height || t11.$place.Height), i11 = o11 + L$.toPixels(n12.sectionWidth);
        }
      } else "fixedpagesection" === t11.Type ? (a11 = L$.toPixels(e16.Page.PageHeight) - L$.toPixels(e16.Page.BottomMargin), i11 = L$.toPixels(e16.Page.PageWidth) - L$.toPixels(e16.Page.RightMargin)) : (a11 = r12 + L$.toPixels(t11.$height || t11.$place.Height), i11 = o11 + L$.toPixels(t11.$width || t11.$place.Width));
      return { top: r12, left: o11, bottom: a11, right: i11 };
    })(a10, t10, e15);
    return i10.reset(), { type: "rectselect", path: n10, absolutePosition: r11, item: t10, scrollDetector: i10 };
  }, end: (e15, t11) => {
    const n11 = t11.getDropResult();
    if (!n11) return;
    const { ctrlPressed: o11, itemsToSelect: a11 } = n11;
    r10((o11 ? d5 : p5)(a11));
  }, collect: (e15) => ({ isDragging: e15.isDragging() }) });
  if (ep.useEffect(() => {
    l10(Coe(), { captureDraggingState: true });
  }, []), !t10) return null;
  const c10 = kp($lt);
  return tp.createElement("div", { ref: o10, className: jlt }, tp.createElement("div", { className: c10, "data-path": n10, "data-type": t10.Type, ref: s10 }));
};
const qlt = (e14, t10) => {
  const n10 = [...e14].map((e15, n11) => ({ item: e15, path: Wj(t10, n11) })).sort((e15, t11) => e15.item.ZIndex - t11.item.ZIndex);
  return n10;
};
const Ylt = (e14) => {
  const { item: t10, masterSection: n10, path: r10, dataSets: o10, parentBackgroundColor: a10, theme: i10, onlyContent: s10 } = e14;
  const l10 = t10;
  const { $place: c10 } = l10;
  const { Style: u10, RoundingRadius: d10 } = l10;
  const p10 = ep.useContext(bqe);
  const { makeImageUrl: m10, getItemLayerInfo: h10, instanceId: f10, embeddedImages: g10 } = p10;
  const y10 = ep.useRef(null);
  const v10 = ep.useCallback(() => t10 ? qlt(t10.ReportItems, r10) : [], [t10, r10]);
  const b10 = ep.useMemo(() => v10(), [v10]);
  const S10 = ep.useCallback(() => n10 ? qlt(n10.ReportItems, r10) : [], [n10, r10]);
  const C10 = ep.useMemo(() => S10(), [S10]);
  const x10 = zlt({ ref: y10.current, name: l10.Name, type: l10.Type, path: r10 }, f10);
  const [{ isOver: w10, canDrop: T10 }, E10] = are(__spreadValues({ accept: ["reportitem", "toolboxItem", "smartSuggestion", "value", "field", "fields", "resizegrip", "placeHolderResizeGrip", "entity_relation", "dataset", "partItem"] }, x10));
  const { isVisible: F10, opacity: M10 } = h10(l10);
  const { userPreferences: { surface: { gridSize: k10 = "0.25in", showGrid: P10 } } } = KO.of(f10);
  const [N10, D10] = [c10 && c10.Width, c10 && c10.Height];
  const L10 = rj(t10) ? 1 : F10 ? M10 : 0;
  let H10 = {};
  let I10 = {};
  N10 && D10 && d10 && (I10 = (() => {
    const e15 = {};
    const t11 = { width: L$.parse(N10).divideByNum(2), height: L$.parse(D10).divideByNum(2) };
    const n11 = t11.height.greaterThan(t11.width) ? t11.width : t11.height;
    const r11 = d10.Default || "0pt";
    const o11 = (e16) => {
      const t12 = Glt(e16 || r11);
      return L$.parse(t12).greaterThan(n11) ? n11.css : t12;
    };
    return e15.borderTopLeftRadius = o11(d10.TopLeft), e15.borderTopRightRadius = o11(d10.TopRight), e15.borderBottomLeftRadius = o11(d10.BottomLeft), e15.borderBottomRightRadius = o11(d10.BottomRight), e15;
  })(), H10 = Object.assign(Mme(u10, i10), I10, { opacity: L10 }));
  const _10 = u10 == null ? void 0 : u10.BackgroundImage;
  const V10 = ep.useCallback(() => m10(_10.Source, _10.Value, g10), [_10 == null ? void 0 : _10.Source, _10 == null ? void 0 : _10.Value, g10, m10]);
  const R10 = __spreadValues({ backgroundImage: _10 ? V10() : "", opacity: L10 }, I10);
  const A10 = __spreadValues({ backgroundColor: a10, opacity: L10 }, I10);
  const O10 = kp($lt, "ar-item", { "ar-drop-target-over": w10, "ar-drop-target-can": T10 });
  const B10 = { host: l10.Name, dataSets: o10, parentBackgroundColor: a10, theme: i10, onlyContent: s10 };
  const z10 = __spreadProps(__spreadValues({}, e14), { item: l10 });
  return tp.createElement("div", { className: O10, "data-path": r10, "data-type": l10.Type, style: { pointerEvents: F10 ? "all" : "none" }, ref: s10 || n10 ? void 0 : E10 }, tp.createElement("div", { ref: y10 }, tp.createElement("div", { className: "bg-color", style: A10 }), tp.createElement("div", { className: `bg-image ${$me(_10)}`, style: R10 }), 0 !== L10 && P10 && tp.createElement(Flt, { id: `${l10.Name}-bg-grid`, key: `${l10.Name}-${N10}-${D10}-${k10}`, size: k10, roundStyle: I10 }), F10 && !s10 && tp.createElement(Ult, __spreadValues({}, z10)), C10.map((e15) => tp.createElement(N2e, __spreadValues({ key: `${e15.item.Name}Place`, item: e15.item, path: e15.path, isMasterItem: true }, B10))), n10 && tp.createElement("div", { className: Zlt }), b10.map((e15) => tp.createElement(N2e, __spreadValues({ key: `${e15.item.Name}Place`, item: e15.item, path: e15.path }, B10))), N10 && D10 && d10 && H10 && tp.createElement("div", { className: "ar-border", style: H10 })));
};
const [Klt, , Xlt] = Dp("ar-border");
const [Jlt] = Xlt("primary");
const [Qlt] = Xlt("secondary");
const ect = ({ item: e14, path: t10, height: n10, dataSets: r10, width: o10, theme: a10 }) => {
  const { lockLayout: i10 } = Uae();
  const s10 = Tlt(t10);
  const l10 = s10 || e14;
  const c10 = __spreadProps(__spreadValues({ width: "100%", height: "100%" }, Fme(l10.Style || {}, a10, { Width: "1pt", Style: "solid", Color: "lightgray" })), { opacity: L$.parseSafe(n10).value ? 1 : 0 });
  const u10 = t10.includes("PageHeader");
  const d10 = t10.includes("PageFooter");
  const p10 = { item: e14, masterSection: s10, key: t10, path: t10, dataSets: r10, theme: a10, parentBackgroundColor: Bme(l10.Style.BackgroundColor, null, a10) };
  const m10 = l10.$dashboard;
  const h10 = m10 ? "freeResizeLine" : "resizeLine";
  const f10 = m10 ? "bottom" : "top";
  const g10 = ij(e14) ? Jlt : "";
  const y10 = aj(e14) && !ij(e14) ? Qlt : "";
  const v10 = i10 || !!s10;
  return tp.createElement("div", { style: { height: n10, width: o10, position: "relative" } }, !v10 && d10 && tp.createElement(wlt, { orientation: "horizontal", type: h10, documentItemPath: t10, documentItemType: l10.Type, moveSide: f10 }), tp.createElement(Ylt, __spreadValues({}, p10)), tp.createElement("div", { className: kp(Klt, y10, g10), style: c10 }), !v10 && u10 && tp.createElement(wlt, { orientation: "horizontal", type: h10, documentItemPath: t10, documentItemType: l10.Type, moveSide: "bottom" }));
};
const tct = FZ.resultOf(QZe.decode({ Width: "6.5in", ReportSections: [{ Type: "Continuous", Name: "ContinuousSection1", Body: {}, PageHeader: {}, PageFooter: {} }] })).ReportSections[0];
const nct = __spreadProps(__spreadValues({}, tct.PageHeader), { ReportItems: [] });
const rct = __spreadProps(__spreadValues({}, tct.PageHeader), { ReportItems: [], Name: "header" });
const oct = __spreadProps(__spreadValues({}, tct.PageFooter), { ReportItems: [], Name: "footer" });
const act = (e14) => `pageSection.${e14}`;
const ict = [xY.Height, vY.BackgroundAndBorders, vY.BackgroundColor, vY.BackgroundImage, vY.Borders, Zq(dY, act("printOnFirstPage"), "boolean", "PrintOnFirstPage"), Zq(dY, act("printOnLastPage"), "boolean", "PrintOnLastPage")];
const sct = { type: nct.Type, labelKey: "reportItems:pageSection", defaultModel: nct, init: (e14, t10, n10 = {}, r10) => __spreadProps(__spreadValues(__spreadValues({}, r10 != null ? r10 : "PageHeader" === e14 ? rct : oct), n10), { Name: e14 }), glyph: ect, getReducer: (e14) => {
  const t10 = b7(e14);
  const n10 = ZV(t10, Rlt);
  return Uye(0, { [d2.type]: GV(rj, jV((e15, n11) => {
    const { value: r10, descriptor: o10 } = n11.payload;
    if ("$place.Height" !== o10.valuePath) throw new Error("Attempt setting invalid property of section");
    return t10(e15, A5({ height: r10 }));
  }, Rlt), n10), [WG]: jV(Olt, n10), [GG]: jV(Alt, n10), [jG]: jV(Blt, n10), [UG]: jV(Blt, n10) }, n10);
}, getProperties: (e14, t10, n10) => (n10 == null ? void 0 : n10.isDashboard) ? n4(ict) : (n10 == null ? void 0 : n10.isChildReport) ? r4(ict, { disabled: true }) : ict, getContextActions: xlt, features: { disableCopy: true } };
const [lct, , cct] = Dp("ar-border");
const [uct] = cct("primary");
const [dct] = cct("secondary");
const pct = ({ item: e14, path: t10, height: n10, dataSets: r10, width: o10, theme: a10 }) => {
  const { lockLayout: i10 } = Uae();
  const s10 = Tlt(t10);
  const l10 = __spreadValues({ width: "100%", height: "100%" }, Fme(e14.Style || {}, a10, { Width: "1pt", Style: "solid", Color: "lightgray" }));
  const c10 = { item: e14, masterSection: s10, key: t10, path: t10, dataSets: r10, theme: a10, parentBackgroundColor: Bme(e14.Style.BackgroundColor, null, a10) };
  const u10 = e14.$dashboard;
  const d10 = u10 ? "freeResizeLine" : "resizeLine";
  const p10 = ij(e14) ? uct : "";
  const m10 = aj(e14) && !ij(e14) ? dct : "";
  return tp.createElement("div", { style: { height: n10, width: o10, position: "relative" } }, tp.createElement(Ylt, __spreadValues({}, c10)), tp.createElement("div", { className: kp(lct, m10, p10), style: l10 }), !i10 && u10 && tp.createElement(wlt, { orientation: "horizontal", type: d10, documentItemPath: t10, documentItemType: e14.Type, moveSide: "bottom" }));
};
const mct = FZ.resultOf(zK.decode({ ReportItems: [], Height: "2in" }));
const hct = [vY.BackgroundAndBorders, vY.BackgroundColor, vY.BackgroundImage, vY.Borders];
const fct = (e14) => {
  const t10 = L3(e14);
  const [n10, r10] = [L$.isZero(t10.Width) ? G5.css : t10.Width.css, L$.isZero(t10.Height) ? G5.css : t10.Height.css];
  return e14.$dashboard ? AV(e14, { $place: { Height: { $set: L$.max([t10.Height, L$.parse(e14.$place.Height)]).css } } }) : AV(e14, { $width: { $set: n10 }, $height: { $set: r10 }, $place: { Height: { $set: r10 } } });
};
const gct = { type: mct.Type, labelKey: "reportItems:body", defaultModel: mct, icon: nf(Oae), init: (e14, t10, n10, r10 = mct) => __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, mct), r10), n10), { $place: __spreadProps(__spreadValues({}, mct.$place), { Height: G5.css }), ReportItems: [], Name: e14 }), glyph: pct, getReducer: (e14) => {
  const t10 = b7(e14);
  const n10 = ZV(t10, fct);
  return Uye(0, { [d2.type]: GV(rj, jV((e15, n11) => {
    const { value: r10, descriptor: o10 } = n11.payload;
    if ("$place.Height" !== o10.valuePath) throw new Error("Attempt setting invalid property of section");
    return t10(e15, A5({ height: r10 }));
  }, fct), n10), [tU.type]: (e15, n11) => {
    if (rj(e15)) return t10(e15, n11);
    return Gye(e15, n5, n11);
  } }, n10);
}, getProperties: (e14, t10, n10) => (n10 == null ? void 0 : n10.isChildReport) ? r4(hct, { disabled: true }) : hct, getContextActions: xlt, features: { disableCopy: true } };
const yct = (e14, t10) => e14.every((e15) => void 0 !== jN(t10)(e15));
const vct = (e14, t10, n10) => ({ path: e14, type: t10, isSupported: "function" == typeof n10 ? n10 : yct });
const bct = [vct("Style.FontFamily", "font_family"), vct("Style.FontSize", "font_size"), vct("Style.FontWeight", "font_weight"), vct("Style.FontStyle", "font_style"), vct("Style.TextDecoration", "text_decoration"), vct("Style.Color", "color"), vct("Style.BackgroundColor", "background_color", (e14, t10, n10) => e14.every((e15) => (!n10.$masterReport || ![gct.type, sct.type].includes(e15.Type)) && void 0 !== jN(t10)(e15))), vct("Style.TextAlign", "text_align_left"), vct("Style.TextAlign", "text_align_center"), vct("Style.TextAlign", "text_align_right"), vct("Style.TextAlign", "text_align_justify", (e14, t10) => e14.every((e15) => e15.Type !== Clt.type && void 0 !== jN(t10)(e15))), vct("Style.VerticalAlign", "text_vertical_align_top"), vct("Style.VerticalAlign", "text_vertical_align_middle"), vct("Style.VerticalAlign", "text_vertical_align_bottom")];
function Sct(e14) {
  const t10 = yj(e14);
  const n10 = [];
  const r10 = (e15) => {
    let n11 = jN(e15)(t10[0]);
    for (let r11 = 1; r11 < t10.length; r11++) if (jN(e15)(t10[r11]) !== n11) {
      n11 = "< ... >";
      break;
    }
    return n11;
  };
  return bct.forEach((o10) => {
    const { path: a10, type: i10, isSupported: s10 } = o10;
    s10(t10, a10, e14) && n10.push({ type: i10, value: r10(a10), action: (e15) => o2({ descriptor: { valuePath: a10 }, value: e15 }) });
  }), n10;
}
const Cct = (e14, t10, n10) => tp.createElement(Kme, { value: e14, onSelect: t10, theme: n10 });
const xct = ({ actions: e14, reportTheme: t10, dropdownAPI: n10, dispatch: r10, t: o10, fonts: a10 }) => {
  const i10 = ({ icon: e15, text: t11, title: n11, disabled: o11, checked: a11, action: i11, dataAid: s11 }) => {
    const l10 = { id: n11, background: a11 ? "default" : "transparent", icon: e15, text: t11, title: n11, onClick: () => r10(i11), disabled: o11, dataAid: s11 };
    return tp.createElement(qm, __spreadValues({ key: n11 }, l10));
  };
  const s10 = (e15) => {
    const t11 = __spreadValues({ background: "transparent", menuMaxHeight: 300, scrollToSelection: true, onSelect: (e16) => r10(e16) }, e15);
    return tp.createElement(UF, __spreadValues({ key: e15.id }, t11));
  };
  return ["separator", "font_family", "separator", "font_size", "separator", "font_weight", "font_style", "text_decoration", "separator", "color", "background_color", "separator", "text_align_left", "text_align_center", "text_align_right", "text_align_justify", "separator", "text_vertical_align_top", "text_vertical_align_middle", "text_vertical_align_bottom"].map((l10, c10) => {
    const u10 = e14.find((e15) => e15.type === l10);
    const d10 = (e15 = false) => e15 ? o10("components:toolbar.home.textExpressionCompact", "<\u{1D453}>") : o10("components:toolbar.home.textExpression", "<Expression>");
    const p10 = (e15, t11 = false) => (e15 || "").startsWith("=") ? d10(t11) : e15;
    let m10 = { text: "", tooltip: "", disabled: true, action: () => {
    } };
    if (u10) {
      const { value: e15, action: t11 } = u10;
      m10 = { text: e15, action: t11 };
    }
    const { text: h10, tooltip: f10, disabled: g10, action: y10 } = m10;
    switch (l10) {
      case "separator":
        return tp.createElement(DM, { key: `splitter_${c10}` });
      case "font_family": {
        const { withPreview: e15, label: t11 } = ((e16 = "") => e16.startsWith("=") ? { withPreview: false, label: d10() } : { withPreview: true, label: jTe(e16, a10) })(h10);
        const n11 = { fontFamily: e15 ? `"${h10}"` : "inherit" };
        const i11 = a10.map((e16) => "string" == typeof e16 ? { type: "button", text: e16, value: e16, selected: e16 === h10 } : Qxe(e16) ? { type: "button", text: e16.label, value: e16.value, selected: e16.value === h10 } : "" === e16.header ? { type: "splitter" } : { type: "header", header: e16.header });
        return s10({ items: i11, id: l10, disabled: g10, toggleContent: tp.createElement("span", { style: n11 }, t11), title: o10("components:toolbar.home.titleFontFamily", "Font Family"), width: "150px", itemSize: "small", customButtonRenderer: ({ text: e16, value: t12 }) => tp.createElement("div", { className: "wd-font-dropdown__item", style: { fontFamily: `"${t12}"` } }, e16), onSelect: (e16) => r10(y10(e16)), menuAlign: "left" });
      }
      case "font_size":
        return s10({ items: OO("font_size", o10).map((e15) => ({ type: "button", text: e15.label, value: y10(e15.value), selected: e15.value === h10 })), id: l10, disabled: g10, text: p10(h10, true), title: o10("components:toolbar.home.titleFontSize", "Font Size"), width: "100px", menuWidth: 100, itemSize: "small", menuAlign: "left" });
      case "font_weight":
        return i10({ icon: nf(o1e), title: f10 || o10("components:toolbar.home.titleFontWeight", "Font Weight"), action: y10("Bold" !== h10 ? "Bold" : "Normal"), disabled: g10, checked: "Bold" === h10, dataAid: l10 });
      case "font_style":
        return i10({ icon: nf(a1e), title: f10 || o10("components:toolbar.home.titleFontStyle", "Font Style"), action: y10("Italic" !== h10 ? "Italic" : "Normal"), disabled: g10, checked: "Italic" === h10, dataAid: l10 });
      case "text_decoration":
        return i10({ icon: nf(i1e), title: f10 || o10("components:toolbar.home.titleTextDecoration", "Text Decoration Underline"), action: y10("Underline" !== h10 ? "Underline" : "None"), disabled: g10, checked: "Underline" === h10, dataAid: l10 });
      case "color": {
        const e15 = (e16) => {
          r10(y10(e16.customValue || dm.toWeb(e16) || e16.hex));
        };
        const a11 = p10(u10 && Xst(u10.value, t10) || "");
        return s10({ id: `${l10}.${a11}`, icon: nf(tp.createElement(r1e, { fill: a11 })), title: f10 || o10("components:toolbar.home.titleTextColor", "Text Color"), content: Cct(dm.fromString(a11), (t11) => {
          e15(t11), n10.open(null);
        }, t10), menuWidth: "auto", disabled: g10, hiddenChevron: true, menuMaxHeight: "none", menuAlign: "center" });
      }
      case "background_color": {
        const e15 = (e16) => {
          r10(y10(e16.customValue || dm.toWeb(e16) || e16.hex));
        };
        const a11 = p10(u10 && Xst(u10.value, t10) || "");
        return s10({ id: `${l10}.${a11}`, icon: nf(tp.createElement(n1e, { fill: a11 })), title: f10 || o10("components:toolbar.home.titleBackgroundColor", "Background Color"), content: Cct(dm.fromString(Xst(a11, t10)), (t11) => {
          e15(t11), n10.open(null);
        }, t10), menuWidth: "auto", disabled: g10, hiddenChevron: true, menuMaxHeight: "none", menuAlign: "center" });
      }
      case "text_align_left":
        return i10({ icon: nf(s1e), title: f10 || o10("components:toolbar.home.titleAlignLeft", "Text Align Left"), action: y10("Left" !== h10 ? "Left" : "General"), disabled: g10, checked: "Left" === h10, dataAid: l10 });
      case "text_align_center":
        return i10({ icon: nf(l1e), title: f10 || o10("components:toolbar.home.titleAlignCenter", "Text Align Center"), action: y10("Center" !== h10 ? "Center" : "General"), disabled: g10, checked: "Center" === h10, dataAid: l10 });
      case "text_align_right":
        return i10({ icon: nf(c1e), title: f10 || o10("components:toolbar.home.titleAlignRight", "Text Align Right"), action: y10("Right" !== h10 ? "Right" : "General"), disabled: g10, checked: "Right" === h10, dataAid: l10 });
      case "text_align_justify":
        return i10({ icon: nf(u1e), title: f10 || o10("components:toolbar.home.titleAlignJustify", "Text Align Justify"), action: y10("Justify" !== h10 ? "Justify" : "General"), disabled: g10, checked: "Justify" === h10, dataAid: l10 });
      case "text_vertical_align_top":
        return i10({ icon: nf(d1e), title: f10 || o10("components:toolbar.home.titleVerticalAlignTop", "Text Vertical Align Top"), action: y10("Top"), disabled: g10, checked: "Top" === h10, dataAid: l10 });
      case "text_vertical_align_middle":
        return i10({ icon: nf(p1e), title: f10 || o10("components:toolbar.home.titleVerticalAlignMiddle", "Text Vertical Align Middle"), action: y10("Middle" !== h10 ? "Middle" : "Top"), disabled: g10, checked: "Middle" === h10, dataAid: l10 });
      case "text_vertical_align_bottom":
        return i10({ icon: nf(m1e), title: f10 || o10("components:toolbar.home.titleVerticalAlignBottom", "Text Vertical Align Bottom"), action: y10("Bottom" !== h10 ? "Bottom" : "Top"), disabled: g10, checked: "Bottom" === h10, dataAid: l10 });
      default:
        return null;
    }
  });
};
const wct = (e14) => {
  const { actions: t10, dispatch: n10, showDialog: r10, tFunction: o10, report: a10, reportTheme: i10, masterReports: s10, themes: l10, uiAPI: c10 } = e14;
  return (t10 == null ? void 0 : t10.length) ? t10.map((e15) => $it({ contextAction: e15, dispatch: n10, showDialog: r10 || (() => {
  }), tFunction: o10 }) || (({ contextAction: e16, report: t11, reportTheme: n11, themes: r11, masterReports: o11, dispatch: a11, uiAPI: i11, tFunction: s11 }) => {
    if (!e16) return null;
    switch (e16.type) {
      case "theme": {
        const n12 = r11.items || [];
        if (0 === n12.length) return null;
        const { type: o12, icon: l11, key: c11, disabled: u10, action: d10 } = e16;
        const p10 = (e17) => {
          a11(d10(e17)), i11.dropdowns.open(null);
        };
        const m10 = !t11.$masterReportContent || 0 === t11.$masterReportContent.Themes.length;
        const h10 = s11(c11);
        const f10 = { background: "transparent", dataAid: "theme-dropdown", id: `${o12}.${h10}`, icon: l11, text: h10, title: h10, disabled: u10, content: tp.createElement(est, { value: t11.Themes[0], showNoThemeItem: m10, themes: n12, onThemeSelected: p10 }), menuWidth: "auto", menuAlign: "left", menuMaxHeight: 300, itemSize: "small" };
        return tp.createElement(UF, __spreadValues({ key: `${o12}.${h10}` }, f10));
      }
      case "masterReport": {
        const { type: n12, icon: r12, key: i12, disabled: l11, action: c11 } = e16;
        const { loading: u10, items: d10 } = o11;
        const p10 = s11(i12);
        const m10 = `${n12}.${p10}`;
        const h10 = (e17) => () => {
          a11(c11({ id: e17 }));
        };
        const f10 = (e17) => e17 ? a11(xpe.request()) : void 0;
        const g10 = { background: "transparent", dataAid: "master-report-dropdown", id: m10, icon: r12, text: p10, accent: u10 ? "icon" : "none", loading: u10, title: p10, disabled: l11 || !o11.items.length, items: d10.map((e17) => ({ type: "button", key: e17.id, text: e17.name, value: e17.id, selected: e17.id === (t11 == null ? void 0 : t11.$masterReport), onClick: e17.id !== (t11 == null ? void 0 : t11.$masterReport) ? h10(e17.id) : void 0 })), menuWidth: 240, menuAlign: "left", menuMaxHeight: 300, itemSize: "small", onToggle: f10 };
        return tp.createElement(UF, __spreadValues({ key: m10 }, g10));
      }
      case "plotTemplate": {
        const { type: r12, icon: o12, key: l11, disabled: c11, action: u10 } = e16;
        const d10 = gTe([gj(t11, yTe)]);
        const p10 = s11(l11);
        const m10 = (e17) => {
          a11(u10(e17)), i11.dropdowns.open(null);
        };
        const h10 = { background: "transparent", dataAid: "plot-template-dropdown", id: `${r12}.${p10}`, icon: o12, text: p10, title: p10, disabled: c11, content: tp.createElement(mTe, { onPick: m10, paletteInfo: d10, theme: n11 }), menuWidth: 240, menuMaxHeight: 400, menuAlign: "left", itemSize: "small" };
        return tp.createElement(UF, __spreadValues({ key: `${r12}.${p10}` }, h10));
      }
      case "chartPalette": {
        const { type: t12, icon: r12, key: o12, selectedPalette: l11, disabled: c11, action: u10 } = e16;
        const d10 = (e17) => {
          a11(u10(e17)), i11.dropdowns.open(null);
        };
        const p10 = s11(o12);
        const m10 = { background: "transparent", dataAid: "chart-palette-dropdown", id: `${t12}.${p10}`, icon: r12, text: p10, title: p10, disabled: c11, content: tp.createElement(pqe, { onPick: d10, selectedPalette: l11, theme: n11 }), menuWidth: 480, menuMaxHeight: 400, menuAlign: "left", itemSize: "small" };
        return tp.createElement(UF, __spreadValues({ key: `${t12}.${p10}` }, m10));
      }
      case void 0:
        throw Error("Element without type");
      default:
        throw Error(`Unknown element type: ${e16.type}`);
    }
  })({ contextAction: e15, report: a10, reportTheme: i10, themes: l10, masterReports: s10, dispatch: n10, uiAPI: c10, tFunction: o10 })).filter(Ie) : [];
};
const Tct = () => {
  const { id: e14, appBarItemId: t10, workspaceId: n10, contextActions: r10, rdlx: { theme: o10, sharedThemes: a10, masterReports: i10 } } = d9();
  const s10 = h9();
  const { API: l10 } = ep.useContext(Sm);
  const { fonts: c10 } = MO();
  const u10 = PA();
  const { t: d10 } = vp();
  const p10 = ep.useCallback((t11, n11) => {
    u10(_A.of(e14).open(t11, n11));
  }, [u10, e14]);
  const m10 = ep.useMemo(() => ({ reportParams: s10.ReportParameters, paramsView: s10.$paramsView, dispatch: u10, t: d10 }), [u10, s10.$paramsView, s10.ReportParameters, d10]);
  const h10 = ep.useMemo(() => Z1e(r10, "toolbar"), [r10]);
  const f10 = ep.useMemo(() => h10.filter(dz).some((e15) => d10(e15.key) === t10) ? t10 : "Home", [t10, h10, d10]);
  const g10 = ep.useMemo(() => {
    if (n10 === M$e.workspaceId) return [M$e.getToolbar(m10)];
    const e15 = "Home" === f10 ? h10.filter(({ type: e16 }) => "group" !== e16).map((e16) => {
      if ("button" !== e16.type) return null;
      const { icon: t11, key: n11, disabled: r11, action: o11 } = e16;
      const a11 = d10(n11);
      const i11 = { dataAid: `${a11}-button`, background: "transparent", icon: t11, title: a11, onClick: () => u10(o11), disabled: r11 };
      return tp.createElement(qm, __spreadValues({ key: a11 }, i11));
    }) : [];
    return [e15.filter(Ie), ...h10.filter(dz).map((e16) => t10 === d10(e16.key) ? wct({ actions: e16.actions, themes: a10, report: s10, reportTheme: o10, masterReports: i10, uiAPI: l10, dispatch: u10, showDialog: p10, tFunction: d10 }) : null)];
  }, [t10, h10, u10, m10, s10, o10, i10, f10, p10, d10, a10, l10, n10]);
  const y10 = { actions: Sct(s10), reportTheme: o10, dropdownAPI: l10.dropdowns, fonts: c10, dispatch: u10, t: d10 };
  const v10 = { toolstripItems: n10 !== M$e.workspaceId && "Home" === f10 ? xct(y10) : [], contextActionItems: g10 };
  return tp.createElement(tp.Fragment, null, tp.createElement(Wit, __spreadValues({}, v10)), n10 === M$e.workspaceId && tp.createElement(iN, { key: "@pve/sidebar", id: "sb-controls" }));
};
Tct.displayName = "RdlxToolbar";
const Ect = (e14 = {}) => {
  const t10 = {};
  for (const n10 in e14) void 0 !== e14[n10] && (t10[n10] = e14[n10]);
  return t10;
};
const Fct = (e14, t10) => __spreadValues(__spreadValues({}, e14), Ect(t10));
const Mct = (e14, t10) => {
  const n10 = t10.find((t11) => t11.ClassName === e14);
  if (!n10) throw new Error(`Class "${e14}" was not found!`);
  if (!n10.Parent) return n10;
  const r10 = t10.find((e15) => e15.ClassName === n10.Parent);
  if (!r10) throw new Error(`Parent class "${n10.Parent}" was not found!`);
  return Fct(r10, n10);
};
const kct = [{ type: "dropdown", key: "components-RPX:toolbar.home.fontFamily", descriptor: stt("", "", "enum", "Style.FontFamily", void 0, { enumKey: "font_family" }) }, { type: "separator" }, { type: "dropdown", key: "components-RPX:toolbar.home.fontSize", descriptor: stt("", "", "enum", "Style.FontSize", void 0, { enumKey: "font_size" }) }, { type: "separator" }, { type: "toggle", icon: nf(o1e), descriptor: stt("", "", "string", "Style.FontWeight"), key: "components-RPX:toolbar.home.fontWeight", checkedValue: "Bold", defaultValue: "Normal" }, { type: "toggle", icon: nf(a1e), descriptor: stt("", "", "string", "Style.FontStyle"), key: "components-RPX:toolbar.home.fontStyle", checkedValue: "Italic", defaultValue: "Normal" }, { type: "toggle", icon: nf(i1e), descriptor: stt("", "", "string", "Style.FontUnderline"), key: "components-RPX:toolbar.home.textDecoration", checkedValue: true, defaultValue: false }, { type: "separator" }, { type: "color", subType: "color", key: "components-RPX:toolbar.home.foreColor", descriptor: stt("", "", "string", "Style.ForeColor") }, { type: "color", subType: "backgroundColor", key: "components-RPX:toolbar.home.backColor", descriptor: stt("", "", "string", "Style.BackColor") }, { type: "separator" }, { type: "toggle", icon: nf(s1e), descriptor: stt("", "", "string", "Style.TextAlign"), key: "components-RPX:toolbar.home.titleAlignLeft", checkedValue: "Left", defaultValue: "Left" }, { type: "toggle", icon: nf(l1e), descriptor: stt("", "", "string", "Style.TextAlign"), key: "components-RPX:toolbar.home.titleAlignCenter", checkedValue: "Center", defaultValue: "Left" }, { type: "toggle", icon: nf(c1e), descriptor: stt("", "", "string", "Style.TextAlign"), key: "components-RPX:toolbar.home.titleAlignRight", checkedValue: "Right", defaultValue: "Left" }, { type: "toggle", icon: nf(u1e), descriptor: stt("", "", "string", "Style.TextAlign"), key: "components-RPX:toolbar.home.titleAlignJustify", checkedValue: "Justify", defaultValue: "Left" }, { type: "separator" }, { type: "toggle", icon: nf(d1e), descriptor: stt("", "", "string", "Style.VerticalAlign"), key: "components-RPX:toolbar.home.verticalAlignTop", checkedValue: "Top", defaultValue: "Top" }, { type: "toggle", icon: nf(p1e), descriptor: stt("", "", "string", "Style.VerticalAlign"), key: "components-RPX:toolbar.home.verticalAlignMiddle", checkedValue: "Middle", defaultValue: "Top" }, { type: "toggle", icon: nf(m1e), descriptor: stt("", "", "string", "Style.VerticalAlign"), key: "components-RPX:toolbar.home.verticalAlignBottom", checkedValue: "Bottom", defaultValue: "Top" }];
const Pct = (e14, t10) => {
  const n10 = t10.split(".");
  return e14.every((e15) => {
    var _a2;
    return (_a2 = jN(n10[0])(e15)) == null ? void 0 : _a2.hasOwnProperty(n10[1]);
  });
};
const Nct = (e14) => e14.hasOwnProperty("Style") ? e14.Style : null;
function Dct(e14) {
  if (!e14) return [];
  const t10 = ait(e14);
  const n10 = [];
  const { StyleSheet: r10 } = e14;
  return kct.forEach((e15, o10) => {
    var _a2;
    const { type: a10 } = e15;
    if ("separator" === a10) return void n10.push({ type: "separator", key: `separator-${o10}` });
    const { descriptor: i10, descriptor: { valuePath: s10 } } = e15;
    const [, l10] = s10.split(".");
    const c10 = ((e16, t11, n11) => {
      if (!e16.length) return null;
      const r11 = Nct(e16[0]);
      if (!r11) return null;
      const o11 = Fct(Mct(r11.ClassName, n11), r11)[t11];
      for (let r12 = 1; r12 < e16.length; r12++) {
        const a11 = Nct(e16[r12]);
        if (!a11) return null;
        if (Fct(Mct(a11.ClassName, n11), a11)[t11] !== o11) return "< ... >";
      }
      return o11;
    })(t10, l10, r10);
    if ("toggle" !== a10) if ("color" !== a10) n10.push({ type: a10, key: e15.key, enumKey: "enum" === i10.type ? (_a2 = i10.meta) == null ? void 0 : _a2.enumKey : "", disabled: !Pct(t10, s10), value: c10, createAction: (e16) => iB(i10, e16) });
    else {
      const { key: r11, subType: o11 } = e15;
      n10.push({ type: a10, subType: o11, key: r11, disabled: !Pct(t10, s10), value: c10, createAction: (e16) => iB(i10, e16) });
    }
    else {
      const { defaultValue: r11, checkedValue: o11, icon: l11, key: u10 } = e15;
      n10.push({ type: a10, icon: l11, key: u10, checked: c10 === o11, disabled: !Pct(t10, s10), action: iB(i10, c10 === o11 ? r11 : o11) });
    }
  }), n10;
}
const Lct = (e14) => {
  const t10 = __spreadValues({ background: "transparent", menuMaxHeight: 300, scrollToSelection: true }, e14);
  return tp.createElement(UF, __spreadValues({ key: e14.id }, t10));
};
const Hct = (e14, t10) => e14.map((e15) => ({ type: "button", text: e15.label, value: e15.value, selected: e15.value === t10 }));
const Ict = (e14, t10) => e14.map((e15) => "string" == typeof e15 ? { type: "button", text: e15, value: e15, selected: e15 === t10 } : Qxe(e15) ? { type: "button", text: e15.label, value: e15.value, selected: e15.value === t10 } : "" === e15.header ? { type: "splitter" } : { type: "header", header: e15.header });
const _ct = (e14, t10, n10, r10, o10) => {
  const a10 = e14.map((e15) => {
    if ("separator" === e15.type) return tp.createElement(DM, { key: e15.key });
    if ("toggle" === e15.type) {
      const { icon: t11, action: n11, key: a12, disabled: i11, checked: s10 } = e15;
      return (({ icon: e16, text: t12, title: n12, disabled: r11, checked: o11, onClick: a13, dataAid: i12 }) => {
        const s11 = { id: n12, background: o11 ? "default" : "transparent", icon: e16, text: t12, title: n12, onClick: a13, disabled: r11, dataAid: i12 };
        return tp.createElement(qm, __spreadValues({ key: n12 }, s11));
      })({ icon: t11, title: o10(a12 || ""), disabled: i11, checked: s10, onClick: () => r10(n11), dataAid: e15.type });
    }
    if ("color" === e15.type) {
      const { type: t11, createAction: s10, subType: l10, disabled: c10, value: u10, key: d10 } = e15;
      const p10 = (e16) => {
        r10(s10(e16.customValue || dm.toWeb(e16) || e16.hex));
      };
      const m10 = u10 || "Black";
      return Lct({ id: `${t11}.${u10}`, icon: nf("color" === l10 ? tp.createElement(r1e, { fill: m10 }) : tp.createElement(n1e, { fill: m10 })), title: o10(d10 || ""), content: (a11 = dm.fromString(m10), i10 = (e16) => {
        p10(e16), n10.dropdowns.open(null);
      }, tp.createElement(Oie, { value: a11, onSelect: i10 })), onSelect: (e16) => r10(s10(e16)), menuWidth: "auto", customCSS: "wd-toolstrip-color-dropdown", disabled: c10, hiddenChevron: true, menuMaxHeight: "none", menuAlign: "center" });
    }
    var a11, i10;
    if ("dropdown" === e15.type) {
      const { type: n11, createAction: a12, disabled: i11, value: s10, key: l10, enumKey: c10 } = e15;
      const u10 = { id: n11, disabled: i11, title: o10(l10), text: s10 || _ie(o10), width: "150px", itemSize: "small", onSelect: (e16) => r10(a12(e16)), menuAlign: "left", scrollToSelection: true };
      return Lct("font_family" === c10 ? __spreadProps(__spreadValues({}, u10), { items: Ict(t10, s10), customButtonRenderer: ({ text: e16, value: t11 }) => tp.createElement("div", { style: { fontFamily: `"${t11}"` } }, e16) }) : __spreadProps(__spreadValues({}, u10), { items: Hct(OO(c10, o10), s10) }));
    }
    return null;
  });
  return a10;
};
const Vct = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.secondary, d: "M8.043 2C7.467 2 7 2.467 7 3.043v6.914C7 10.533 7.467 11 8.043 11h.914c.576 0 1.043.467 1.043 1.043v5.475c0 .253.176.472.424.526.247.053.498-.073.603-.303.989-2.176 2.456-5.404 3.303-7.268.147-.322.12-.697-.072-.995-.192-.298-.522-.478-.876-.478h-.001c-.327 0-.635-.153-.831-.415-.197-.261-.26-.599-.17-.913.355-1.245.884-3.097 1.24-4.342.09-.315.027-.654-.17-.915S12.944 2 12.617 2H8.043Z" }));
const Rct = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.secondary, d: "M18 14.25v2.5c0 .69-.56 1.25-1.25 1.25h-2.5c-.69 0-1.25-.56-1.25-1.25v-2.5c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25Zm0-12v2.5C18 5.44 17.44 6 16.75 6h-2.5C13.56 6 13 5.44 13 4.75v-2.5c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25Zm0 6v2.5c0 .69-.56 1.25-1.25 1.25h-2.5c-.69 0-1.25-.56-1.25-1.25v-2.5c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25Z" }), tp.createElement("path", { className: Ym.text, opacity: "0.62", d: "M9.5 9.985c-.267 0-.485-.218-.485-.485s.218-.485.485-.485h2c.267 0 .485.218.485.485s-.218.485-.485.485h-2Zm-5-5c-.126 0-.241-.049-.327-.127-.087-.072-.158-.184-.158-.358 0-.82.665-1.485 1.485-1.485h6c.267 0 .485.218.485.485s-.218.485-.485.485h-6c-.285 0-.515.23-.515.515 0 .457-.485.485-.485.485ZM4.485 14s.484.028.484.485c0 .284.231.515.516.515h6c.267 0 .484.217.484.485 0 .267-.217.484-.484.484h-6c-.82 0-1.485-.665-1.485-1.484 0-.175.071-.286.158-.358.086-.079.201-.127.327-.127Z" }), tp.createElement("path", { className: Ym.text, d: "M8 7.4v4.2c0 .773-.627 1.4-1.4 1.4H2.4c-.773 0-1.4-.627-1.4-1.4V7.4C1 6.627 1.627 6 2.4 6h4.2C7.373 6 8 6.627 8 7.4Zm-1 0c0-.221-.179-.4-.4-.4H2.4c-.221 0-.4.179-.4.4v4.2c0 .221.179.4.4.4h4.2c.221 0 .4-.179.4-.4V7.4Z" }));
const Act = stt("", "", "string", "Script");
const Oct = ["ReportStart", "ReportEnd", "PageStart", "PageEnd", "DataInitialize", "FetchData", "NoData"];
const Bct = ["Format", "BeforePrint", "AfterPrint"];
const zct = () => {
  const { Script: e14, ScriptLanguage: t10, Sections: n10 } = Int();
  const r10 = PA();
  const { t: o10 } = vp("components-RPX");
  const [a10, i10] = ep.useState({ name: "", type: "" });
  const s10 = ep.useMemo(() => {
    return e15 = n10, [{ name: "ActiveReport", type: "Report" }, ...Object.values(e15).map((e16) => ({ name: e16.Name, type: e16.Type }))];
    var e15;
  }, [n10]);
  const l10 = ep.useMemo(() => a10.type ? "Report" === a10.type ? Oct : Bct : [], [a10.type]);
  const c10 = rf(Vct);
  const u10 = rf(Rct);
  ep.useEffect(() => {
    s10.find((e15) => e15.name === a10.name) || i10({ name: "", type: "" });
  }, [s10, a10.name]);
  const d10 = s10.map(({ name: e15, type: t11 }) => ({ type: "button", key: e15, text: e15, title: e15, selected: e15 === a10.name, onClick: () => {
    i10({ name: e15, type: t11 });
  } }));
  const p10 = { background: "transparent", width: "200px", itemSize: "small", menuMaxHeight: 300, scrollToSelection: true };
  const m10 = __spreadProps(__spreadValues({}, p10), { items: d10, title: o10("toolbar.script.titleObject", "Object"), text: a10.name || o10("toolbar.script.textObject", "Object"), icon: u10 });
  const h10 = ep.useMemo(() => l10.map((n11) => ({ type: "button", key: n11, text: o10(n11), disabled: e14 == null ? void 0 : e14.includes(`${a10.name}_${n11}`), onClick: () => {
    r10(iB(Act, ((e15, t11 = "") => t11 ? `${t11}
${e15}` : e15)(((e15, t11, n12) => {
      return "C#" === e15 ? "FetchData" === n12 ? `public bool ${t11}_FetchData(bool eof)
{
	return eof;
}
` : ((e16, t12) => `public void ${e16}_${t12}()
{

}
`)(t11, n12) : "FetchData" === n12 ? (r11 = t11, `Function ${r11}_FetchData(ByVal EOF as Boolean) as Boolean
	${r11}_FetchData = EOF
End Function
`) : ((e16, t12) => `Sub ${e16}_${t12}

End Sub
`)(t11, n12);
      var r11;
    })(t10, a10.name, n11), e14), ""));
  } })), [e14, t10, r10, l10, a10.name, o10]);
  const f10 = __spreadProps(__spreadValues({}, p10), { disabled: "" === a10.name, items: h10, title: o10("toolbar.script.titleEvent", "Event"), text: o10("toolbar.script.textEvent", "Event"), icon: c10 });
  return [tp.createElement(UF, __spreadValues({ key: "rpx.toolstrip.script.object" }, m10)), tp.createElement(DM, { key: "rpx.toolstrip.script.splitter" }), tp.createElement(UF, __spreadValues({ key: "rpx.toolstrip.script.event" }, f10))];
};
const $ct = () => {
  const { API: e14 } = ep.useContext(Sm);
  const { id: t10, appBarItemId: n10, workspaceId: r10, contextActions: o10 } = Mz();
  const { fonts: a10 } = MO();
  const i10 = Int();
  const s10 = PA();
  const { t: l10 } = vp();
  const c10 = ep.useCallback((e15, n11) => {
    s10(_A.of(t10).open(e15, n11));
  }, [s10, t10]);
  const u10 = zct();
  const d10 = ep.useMemo(() => Dct(i10), [i10]);
  const p10 = ep.useMemo(() => Z1e(o10, "toolbar"), [o10]);
  const m10 = ep.useMemo(() => r10 === mit ? [] : [...p10.filter(dz).map((e15) => n10 === l10(e15.key) ? ((e16, t11, n11, r11) => (e16 == null ? void 0 : e16.length) ? e16.map((e17) => $it({ contextAction: e17, dispatch: t11, showDialog: n11, tFunction: r11 })).filter(Ie) : [])(e15.actions, s10, c10, l10) : null)], [r10, p10, l10, s10, n10, c10]);
  const h10 = ep.useMemo(() => {
    if (r10 === mit) return u10;
    const t11 = p10.filter(({ type: e15 }) => "group" !== e15).map((e15) => {
      if ("button" !== e15.type) return null;
      const { icon: t12, key: n11, disabled: r11, action: o11 } = e15;
      const a11 = l10(n11);
      const i11 = { dataAid: `${a11}-button`, background: "transparent", icon: t12, title: a11, onClick: () => s10(o11), disabled: r11 };
      return tp.createElement(qm, __spreadValues({ key: a11 }, i11));
    });
    return t11.push(tp.createElement(DM, { key: "splitter" })), "Home" === n10 ? [...t11, ..._ct(d10, a10, e14, s10, l10)] : [];
  }, [r10, u10, p10, n10, d10, a10, e14, s10, l10]);
  const f10 = { toolstripItems: h10, contextActionItems: m10 };
  return tp.createElement(Wit, __spreadValues({}, f10));
};
$ct.displayName = "RpxToolbar";
const Wct = (e14) => {
  const { type: t10 } = Oit();
  return "rdlx" === (t10 == null ? void 0 : t10.platform) ? tp.createElement(Tct, __spreadValues({}, e14)) : "rpx" === (t10 == null ? void 0 : t10.platform) ? tp.createElement($ct, __spreadValues({}, e14)) : tp.createElement(Wit, { contextActionItems: [], toolstripItems: [] });
};
Wct.displayName = "FacadeToolBar";
const jct = ({ disabled: e14, custom: t10 }) => {
  const { hasUnsavedChanges: n10, documentName: r10 } = Mz();
  const { t: o10 } = vp("components");
  return ep.useEffect(() => {
    if (e14) return;
    const a10 = `${r10 || o10("title.textUntitled", "Untitled")}${n10 ? " *" : ""}`;
    document.title = (t10 == null ? void 0 : t10({ name: r10, hasUnsavedChanges: n10 })) || a10;
  }, [t10, e14, n10, r10, o10]), null;
};
const Zct = ({ identifiers: { instanceId: e14 }, focusTimer: t10, i18n: n10, title: r10, coreContext: o10, children: a10, onPreferencesChange: i10, useInlineThemeCSS: s10 }) => {
  const { theme: l10 } = Mz();
  const c10 = PA();
  const [u10, d10] = ep.useState(KO.of(e14));
  const p10 = ep.useCallback((e15) => {
    c10(fB(e15));
  }, [c10]);
  ep.useLayoutEffect(() => {
    const { userPreferences: { theme: e15 }, themes: { default: t11 } } = u10;
    e15 || l10.name === t11 || p10(t11), e15 && e15 !== l10.name && p10(e15);
  }, []);
  const m10 = () => {
    const t11 = KO.of(e14);
    d10(__spreadValues({}, t11)), i10 == null ? void 0 : i10(t11.userPreferences);
  };
  const h10 = () => {
    _$(KO.of(e14).userPreferences.units);
  };
  ep.useEffect(() => {
    const t11 = KO.subscribe(e14, m10);
    const n11 = KO.subscribeTo(e14, "units", h10);
    return h10(), () => {
      t11(), n11(), _A.destroy(e14), nz.destroy(e14), kit.destroy(e14), az.destroy(e14), tGe.destroy(e14), KO.destroy(e14);
    };
  }, []);
  const f10 = ep.useMemo(() => __spreadValues({}, o10), [o10]);
  const g10 = true === (t10 == null ? void 0 : t10.disabled);
  return tp.createElement(wp, { i18n: n10 }, tp.createElement(HV, { rootId: e14, gridTemplate: "designer", withFocusTimer: !g10, theme: lz(l10), useInlineThemeCSS: s10 != null ? s10 : true }, tp.createElement(jct, __spreadValues({}, r10)), tp.createElement(UHe.Provider, { value: f10 }, tp.createElement(FO.Provider, { value: u10 }, a10))));
};
const Gct = (e14) => {
  const { type: { platform: t10 } } = kz();
  return "rdlx" === t10 ? tp.createElement(cGe, __spreadValues({}, e14)) : "rpx" === t10 ? tp.createElement(Sit, __spreadValues({}, e14)) : tp.createElement(Jee, __spreadValues({}, e14));
};
Gct.displayName = "FacadeMenu";
const Uct = (e14) => zW(e14) || BW(e14) || $W(e14);
const qct = (e14) => [...e14].sort((e15, t10) => (e15 || "").localeCompare(t10 || ""));
const Yct = (e14 = [], { NamedItems: t10 = [], DataSets: n10 = [] } = {}, { dataSetName: r10 }) => {
  if (0 === e14.length || e14.some((e15) => "textbox" !== e15.Type)) return [];
  const o10 = [];
  const a10 = e14.map((e15) => ((e16, t11) => {
    const n11 = t11.find((t12) => e16.Name === t12.name);
    const r11 = n11 && t11.filter((e17) => (e17.level === n11.level || (e17.level === n11.level - 1 || e17.level === n11.level - 2) && e17.leftKey <= n11.leftKey && e17.rightKey >= n11.rightKey) && Uct(e17.type)) || [];
    const o11 = n11 && r11.length > 0 && t11.filter((e17) => e17.level <= n11.level && "grouping" === e17.type && e17.name && 0 !== r11.filter((t12) => t12.level === e17.level - 1 && t12.leftKey <= e17.leftKey && t12.rightKey >= e17.rightKey).length) || [];
    const a11 = qct(r11.map((e17) => e17.name));
    const i11 = qct(o11.map((e17) => e17.name));
    return [...a11, ...i11];
  })(e15, t10));
  const i10 = BV.intersection(...a10);
  o10.push(...i10);
  const s10 = (0 === o10.length ? n10 : n10.filter((e15) => e15.Name === r10)).map((e15) => e15.Name);
  return o10.push(...qct(s10)), o10;
};
const Kct = (e14 = [], { NamedItems: t10 = [] } = {}) => {
  if (0 === e14.length || e14.some((e15) => "textbox" !== e15.Type)) return [];
  const n10 = [];
  const r10 = e14.map((e15) => ((e16, t11) => {
    const n11 = t11.find((t12) => e16.Name === t12.name);
    const r11 = n11 && t11.filter((e17) => e17.level === n11.level - 1 && e17.leftKey <= n11.leftKey && e17.rightKey >= n11.rightKey && Uct(e17.type))[0];
    const o11 = r11 && t11.filter((e17) => e17.level === n11.level && "grouping" === e17.type && e17.name).filter((e17) => e17.level > r11.level && r11.leftKey <= e17.leftKey && r11.rightKey >= e17.rightKey) || [];
    const a10 = (r11 ? [r11] : []).map((e17) => e17.name);
    const i10 = qct(o11.map((e17) => e17.name));
    return [...a10, ...i10];
  })(e15, t10));
  const o10 = BV.intersection(...r10);
  return n10.push(...o10), n10;
};
const Xct = ({ category: e14, label: t10 }, n10) => e14 ? `${n10(e14)} - ${n10(t10)}` : n10(t10);
const Jct = (e14) => {
  const { instanceId: t10, rdlx: { expressionEditorNodesFilter: n10 } } = Uae();
  const r10 = PA();
  const { t: o10 } = vp();
  const a10 = ep.useCallback((a11) => {
    if ("dvchart_template" === a11.type) {
      const i11 = ((e15, t11, n11, r11) => {
        var _a2;
        const { properties: o11, setProperty: a12 } = t11;
        const { value: i12 } = Gxe(e15, o11.objectValue, o11.defaultValue);
        const s12 = [Twe.dvchartTemplateConstants(o11.objectValue, n11, r11)];
        const l10 = Twe.textEncodings(o11.objectValue, n11, (_a2 = e15.meta) == null ? void 0 : _a2.target);
        return l10 && s12.push(l10), { title: Xct(e15, n11), subtitle: n11("dialogs:expressionEditor.subtitle", "Expression Editor"), value: sK(i12) ? "" : i12, treeNodes: s12, fnNodes: [], onSave: (t12) => (a12(e15, t12), true), customCSS: Wxe };
      })(a11, e14, o10, n10);
      const s11 = _A.of(t10).open("textEditor", i11);
      return void r10(s11);
    }
    const i10 = ((e15, t11) => {
      const { properties: n11, index: r11, reportType: o11, setProperty: a12, theme: i11, validationContext: s11 } = t11;
      const { objectPath: l10, objectValue: c10, defaultValue: u10 } = n11;
      return { descriptor: e15, objectPaths: l10, objectValues: c10, defaultValues: u10, setProperty: a12, theme: i11, reportIndex: r11, reportType: o11, validationContext: s11 };
    })(a11, e14);
    const s10 = _A.of(t10).open("expressionEditor", i10);
    r10(s10);
  }, [e14, r10, n10, t10, o10]);
  return a10;
};
const Qct = (e14, t10, n10) => t10(n10.getLabelKey(e14));
const eut = (e14, t10, n10) => {
  const r10 = e14.length && Qct(e14[0].Type, t10, n10);
  if (!r10) return "";
  const o10 = e14.length > 1 && e14.some((e15) => Qct(e15.Type, t10, n10) !== r10);
  const a10 = o10 && e14.every((e15) => Lj({ Type: e15.Type }));
  return a10 && t10("components:propertyGrid.textReportItems", "<Report Items>") || o10 && t10("components:propertyGrid.textMultipleTypes", "<Multiple Types>") || r10;
};
const tut = ({ collapsibleCategories: e14, saveExpandEditorsState: t10 }) => {
  var _a2, _b2;
  const { instanceId: n10, fonts: r10, rdlx: { expressionSyntax: o10 }, userPreferences: a10 } = Uae();
  const { rdlx: { propertyGrid: i10, propertyGrid: { descriptors: s10, objectValue: l10, defaultValue: c10, objectPath: u10, linkedProperties: d10, path: p10 }, theme: m10 } } = d9();
  const h10 = h9();
  const f10 = A$();
  const { sidebar: { propertiesMode: g10, expandedCategoriesStates: y10, expandedEditorsStates: v10 }, units: b10 } = a10;
  const { expandedStates: S10, updateStates: C10, onCategoryToggle: x10, onEditorToggle: w10 } = xD({ categories: JSON.parse(y10), editors: JSON.parse(v10) });
  ep.useEffect(() => {
    e14 && (KO.of(n10).userPreferences.sidebar.expandedCategoriesStates = JSON.stringify(S10.categories)), t10 && (KO.of(n10).userPreferences.sidebar.expandedEditorsStates = JSON.stringify(S10.editors));
  }, [e14, t10, S10, n10]);
  const T10 = PA();
  const { t: E10 } = vp("components");
  const F10 = nz.of(n10);
  const [M10, k10] = ep.useState(null);
  const { $index: P10, Type: N10 } = h10;
  const { Layers: D10 = [], NamedItems: L10 = [], DataSets: H10 = [], DataSources: I10 = [] } = P10;
  ep.useEffect(() => {
    e14 && t10 || C10({ categories: e14 ? S10.categories : {}, editors: t10 ? S10.editors : {} });
  }, [N10, C10, e14, t10, l10]);
  const _10 = ep.useMemo(() => null !== M10 && d10.length > 0 ? d10[M10] : void 0, [d10, M10]);
  const V10 = ep.useMemo(() => _10 ? __spreadProps(__spreadValues({}, _10), { path: p10 }) : i10, [_10, p10, i10]);
  const R10 = ep.useMemo(() => _10 ? _10.descriptors : s10, [s10, _10]);
  ep.useEffect(() => {
    if (null === M10) return void (p10.length && !l10.length && T10($$e()));
    !d10.some((e15, t11) => t11.toString() === M10) && (p10.length && T10($$e()), k10(null));
  }, [p10, l10, d10, M10, T10]);
  const A10 = ep.useCallback((e15) => {
    M10 !== e15 && k10(e15);
  }, [M10]);
  const O10 = ep.useCallback(() => T10(W$e()), [T10]);
  const B10 = ep.useCallback((e15) => p10.length > 0 ? WN(e15, p10.map((e16) => e16.value).join(".")) : e15, [p10]);
  const z10 = ep.useCallback((e15, t11) => {
    if (_10) return _10.objectPath.map((n12) => c2({ path: n12, descriptor: e15, value: t11 }));
    const n11 = B10(e15);
    return [o2({ descriptor: n11, value: t11 })];
  }, [_10, B10]);
  const { setProperty: $10, startTransaction: W10, commitTransaction: j10 } = function(e15, t11) {
    return ep.useMemo(() => {
      let n11 = false;
      let r11 = [];
      const o11 = (t12) => {
        t12.length && (1 !== t12.length ? e15(rz(t12)) : e15(t12[0]));
      };
      return { setProperty(e16, a11) {
        const i11 = t11(e16, a11);
        n11 ? r11.push(...i11) : o11(i11);
      }, startTransaction() {
        n11 = true, r11 = [];
      }, commitTransaction() {
        n11 = false, o11(r11), r11 = [];
      } };
    }, [e15, t11]);
  }(T10, z10);
  const Z10 = ep.useCallback((e15, t11, n11, r11) => {
    let o11 = e15 || [];
    if (p10.length && o11.length > 0) {
      const e16 = p10.map((e17) => e17.value).join(".");
      o11 = o11.map((t12) => __spreadProps(__spreadValues({}, t12), { descriptor: WN(t12.descriptor, e16) }));
    }
    T10(l2({ descriptorValuePairs: o11, dataSetName: t11, fieldName: n11, fieldPath: r11 }));
  }, [T10, p10]);
  const G10 = ep.useCallback((e15) => {
    T10(rz(_10.objectPath.map((t11) => u2({ path: t11, descriptorValuePairs: e15 }))));
  }, [T10, _10]);
  const U10 = ep.useCallback((e15, t11) => T10(z$e({ value: e15, title: t11 })), [T10]);
  const q10 = ep.useMemo(() => {
    var _a3;
    return dJ(N10, P10, m10, u10[0], ((_a3 = l10[0]) == null ? void 0 : _a3.Name) || "");
  }, [P10, u10, l10, N10, m10]);
  const Y10 = Jct({ properties: V10, reportType: N10, index: P10, theme: m10, validationContext: q10, setProperty: $10 });
  const K10 = ep.useCallback((e15) => {
    T10(_A.of(n10).open("dataVisualizer", { descriptor: e15, properties: V10, byPath: !!_10 }));
  }, [T10, n10, _10, V10]);
  const X10 = ep.useCallback((e15, t11, n11, r11, o11) => {
    const a11 = B10(e15);
    const i11 = [a2(a11, t11, n11, r11, o11)];
    const s11 = "string" == typeof o11.format && "Value" === e15.valuePath && ((e16) => e16.every((e17) => "textbox" === e17.Type))(l10);
    s11 && i11.push(o2({ descriptor: { valuePath: "Style.Format" }, value: o11.format })), T10(rz(i11));
  }, [T10, l10, B10]);
  const J10 = ep.useCallback(({ objectPath: e15 }) => (t11, n11) => {
    T10(rz(e15.map((e16) => c2({ path: e16, descriptor: t11, value: n11 }))));
  }, [T10]);
  const Q10 = ep.useCallback((e15) => {
    const t11 = (e15 || []).reduce((e16, t12) => {
      const { type: n11 } = t12;
      switch (n11) {
        case o2.type: {
          const n12 = AV(t12, { payload: { descriptor: { $apply: (e17) => B10(e17) } } });
          e16.push(n12);
          break;
        }
        case l2.type: {
          const n12 = AV(t12, { payload: { descriptorValuePairs: { $apply: (e17) => e17.map((e18) => __spreadProps(__spreadValues({}, e18), { descriptor: B10(e18.descriptor) })) } } });
          e16.push(n12);
          break;
        }
        default:
          e16.push(t12);
      }
      return e16;
    }, []);
    1 === t11.length ? T10(t11[0]) : t11.length > 1 && T10(rz(t11));
  }, [T10, B10]);
  const ee2 = ep.useCallback((e15 = []) => {
    if (!_10) return;
    const { objectPath: t11 } = _10;
    const n11 = e15.reduce((e16, n12) => {
      const { type: r11, payload: o11 } = n12;
      switch (r11) {
        case o2.type: {
          const { descriptor: n13, value: r12 } = o11;
          const a11 = t11.map((e17) => c2({ path: e17, descriptor: n13, value: r12 }));
          e16.push(...a11);
          break;
        }
        case l2.type: {
          const { descriptorValuePairs: n13 } = o11;
          const r12 = t11.map((e17) => u2({ path: e17, descriptorValuePairs: n13 }));
          e16.push(...r12);
          break;
        }
        default:
          e16.push(n12);
      }
      return e16;
    }, []);
    1 === n11.length ? T10(n11[0]) : n11.length > 1 && T10(rz(n11));
  }, [T10, _10]);
  const te2 = ep.useMemo(() => see(h10), [h10]);
  const ne2 = ep.useMemo(() => ({ setProperties: _10 ? G10 : Z10, setDataFieldProperty: _10 ? J10(_10) : X10, drillPropertiesPath: U10, getAreaByPath: (e15) => Tee(h10, e15), performTransaction: _10 ? ee2 : Q10 }), [U10, _10, ee2, Q10, h10, J10, X10, G10, Z10]);
  const re2 = ep.useMemo(() => ({ fontFamily: r10 }), [r10]);
  const oe2 = ep.useMemo(() => ({ instanceId: n10, units: b10, expressionSyntax: o10, dataSets: H10, dataSources: I10, validationContext: q10, dataScope: te2, semanticInfo: { semanticModel: f10, allowRebalancing: true, showAggregates: true, showCalculatedFields: true }, editExpression: Y10, showDataVisualizer: K10 }), [n10, b10, o10, H10, I10, q10, te2, f10, Y10, K10]);
  const ae2 = ep.useMemo(() => ({ namedItems: L10, selectedItemsInfo: ((_10 == null ? void 0 : _10.objectValue) || l10).map(({ Type: e15, Name: t11 }, n11) => ({ type: e15, name: t11, path: ((_10 == null ? void 0 : _10.objectPath) || u10)[n11] })) }), [L10, _10, l10, u10]);
  const ie2 = { layers: D10 };
  const se2 = { theme: m10 };
  const le2 = ep.useMemo(() => ({ sortTarget: Yct(l10, P10, te2), sortExpressionScope: Kct(l10, P10) }), [l10, P10, te2]);
  const ce2 = ep.useMemo(() => ({ startTransaction: W10, commitTransaction: j10 }), [W10, j10]);
  const ue2 = p10.length ? [] : [{ id: null, text: eut(l10, E10, F10) }, ...d10.map((e15, t11) => ({ id: t11.toString(), text: eut(e15.objectValue, E10, F10) }))];
  const de2 = ep.useMemo(() => {
    var _a3;
    const e15 = (_a3 = R10[0]) == null ? void 0 : _a3.findIndex((e16) => e16.category);
    return -1 !== e15;
  }, [R10]);
  const pe2 = ep.useCallback((e15) => () => {
    const t11 = R10[0].reduce((t12, n11) => n11.category ? __spreadProps(__spreadValues({}, t12), { [fD(n11.category)]: e15 }) : t12, S10.categories);
    C10(__spreadProps(__spreadValues({}, S10), { categories: t11 }));
  }, [S10, C10, R10]);
  const me2 = ep.useCallback(() => {
    KO.of(n10).userPreferences.sidebar.propertiesMode = "simple" === g10 ? "advanced" : "simple";
  }, [n10, g10]);
  const he2 = ep.useMemo(() => {
    const t11 = [{ type: "button", onClick: me2, text: E10("simple" === g10 ? "propertyGrid.options.showAdvancedProperty" : "propertyGrid.options.hideAdvancedProperty"), icon: nf("simple" === g10 ? hh : fh) }, { type: "header", header: E10("propertyGrid.options.categories", "Categories") }, { type: "button", text: E10("propertyGrid.options.collapse"), icon: nf(lh), onClick: pe2(false), value: "collapsed" }, { type: "button", text: E10("propertyGrid.options.expand"), icon: nf(sh), onClick: pe2(true), value: "expanded" }];
    return e14 && de2 ? t11 : t11.slice(0, 1);
  }, [de2, e14, pe2, g10, E10, me2]);
  const fe2 = { key: "", descriptors: R10, objectValue: (_10 == null ? void 0 : _10.objectValue) || l10, defaultValue: (_10 == null ? void 0 : _10.defaultValue) || c10, propertyEditors: QVe, displayMode: g10 != null ? g10 : "simple", options: he2, optionsWidth: 210, tabs: ue2.length ? ue2 : void 0, selectedTabId: M10, selectionName: ue2.length > 0 && M10 && _10 ? ((_a2 = ue2[M10]) == null ? void 0 : _a2.text) || "" : ue2.length > 0 ? ue2[0].text || "" : ((_b2 = p10[p10.length - 1]) == null ? void 0 : _b2.title) || "", gridSearchPlaceholder: E10("propertyGrid.placeholderSearchBox", "enter property name here..."), closeSearchBtnTitle: "", setProperty: $10, onTabSelect: A10, onBackClick: p10.length > 0 ? O10 : void 0, t: E10, expandedStates: S10, onCategoryToggle: e14 ? x10 : void 0, onEditorToggle: t10 ? w10 : void 0, customCSS: Dz };
  return tp.createElement(Iue.Provider, { value: ne2 }, tp.createElement(WTe.Provider, { value: re2 }, tp.createElement(Vue.Provider, { value: oe2 }, tp.createElement(Rue.Provider, { value: ae2 }, tp.createElement(Cke.Provider, { value: ie2 }, tp.createElement(Aue.Provider, { value: se2 }, tp.createElement(WVe.Provider, { value: le2 }, tp.createElement(fse.Provider, { value: ce2 }, tp.createElement(DD, __spreadValues({}, fe2))))))))));
};
const nut = (e14, t10, n10, r10) => {
  if ("function" != typeof r10) return e14;
  const o10 = r10(e14, t10, n10);
  if (!Array.isArray(o10)) return e14;
  const a10 = /* @__PURE__ */ new Set();
  o10.forEach((t11) => {
    if (!t11 || "object" != typeof t11) return;
    const n11 = e14.find((e15) => e15.valuePath === t11.valuePath && e15.type === t11.type && e15.label === t11.label && e15.mode === t11.mode);
    n11 && a10.add(n11);
  });
  return [...a10];
};
function rut(e14, t10) {
  let n10 = e14;
  for (const e15 of t10) if (e15 && (n10 = n10[e15]), !n10) return null;
  return n10;
}
const out = ["Name"];
function aut(e14, t10) {
  return t10 ? e14.filter((e15) => !out.includes(e15.valuePath)) : e14;
}
function iut(e14, t10, n10, r10) {
  const o10 = nz.of(e14).of("rpx");
  const a10 = KO.of(e14);
  const { filterProperties: i10 } = a10;
  if (!(r10 == null ? void 0 : r10.length)) {
    const e15 = o10.getDescriptor(t10.Type);
    const r11 = e15 == null ? void 0 : e15.getProperties;
    let s11 = r11 ? aut(r11(t10, void 0, a10), n10) : [];
    const l11 = e15 == null ? void 0 : e15.defaultModel;
    return s11 = nut(s11, t10, "rpx", i10), { propertyDescriptors: s11, defaultModel: l11 };
  }
  const s10 = [...r10];
  const l10 = [];
  let c10 = [];
  let u10;
  for (; ; ) {
    const e15 = rut(t10, s10.join(".").split("."));
    const r11 = e15 == null ? void 0 : e15.Type;
    if (r11) {
      const t11 = o10.getDescriptor(r11);
      const i12 = t11 == null ? void 0 : t11.getProperties;
      if (i12) {
        c10 = aut(i12(e15, l10, a10), n10), u10 = t11 == null ? void 0 : t11.defaultModel;
        break;
      }
    }
    const i11 = s10.pop();
    if (!i11) {
      c10 = [], u10 = {};
      break;
    }
    l10.unshift(i11);
  }
  if (s10.length) {
    const e15 = s10.join(".");
    c10 = c10.map((t11) => WN(t11, e15));
  }
  return c10 = nut(c10, t10, "rpx", i10), { propertyDescriptors: c10, defaultModel: u10 };
}
const sut = ({ collapsibleCategories: e14, saveExpandEditorsState: t10 }) => {
  const { t: n10 } = vp();
  const { instanceId: r10 } = qHe();
  const o10 = Pz();
  const { userPreferences: { sidebar: { propertiesMode: a10, propertiesSort: i10, expandedCategoriesStates: s10, expandedEditorsStates: l10 } } } = MO();
  const { expandedStates: c10, onCategoryToggle: u10, onEditorToggle: d10 } = xD({ categories: JSON.parse(s10), editors: JSON.parse(l10) });
  ep.useEffect(() => {
    e14 && (KO.of(r10).userPreferences.sidebar.expandedCategoriesStates = JSON.stringify(c10.categories)), t10 && (KO.of(r10).userPreferences.sidebar.expandedEditorsStates = JSON.stringify(c10.editors));
  }, [e14, t10, c10, r10]);
  const { setPropertyFn: p10, transactionContextValue: m10 } = function() {
    const e15 = PA();
    let t11 = false;
    let n11 = [];
    return { setPropertyFn: (r11, o11) => {
      const a11 = "name" === r11.type ? { update: true } : void 0;
      const i11 = iB(r11, o11, void 0, a11);
      t11 ? n11.push(i11) : e15(i11);
    }, transactionContextValue: { startTransaction: () => {
      t11 = true, n11 = [];
    }, commitTransaction: () => {
      n11.length && (1 === n11.length ? e15(n11[0]) : e15(rz(n11)), n11 = []);
    } } };
  }();
  const { selectedItems: h10, drillSteps: f10, drillContextValue: g10, undrill: y10 } = function() {
    const e15 = Pz();
    const [t11, n11] = ep.useState([]);
    const r11 = ep.useMemo(() => ait(e15), [e15]);
    ep.useEffect(() => {
      const e16 = t11.map((e17) => e17.path);
      r11.some((t12) => void 0 === jN(e16.join("."))(t12)) && n11([]);
    }, [t11, r11]);
    const o11 = (e16, r12 = e16) => {
      const o12 = [...t11, { path: e16, caption: r12 }];
      n11(o12);
    };
    const a11 = (e16 = 1) => {
      const r12 = t11.slice(0, t11.length - e16);
      n11(r12);
    };
    return { selectedItems: r11, drill: o11, undrill: a11, drillSteps: t11, drillContextValue: { drill: o11, undrill: a11 } };
  }();
  const { descriptors: v10, defaultValue: b10, objectValue: S10 } = ep.useMemo(() => {
    const e15 = f10.map((e16) => e16.path);
    return function(e16, t11, n11, r11) {
      const o11 = { descriptors: [], objectValue: [], defaultValue: [], objectPath: [] };
      const a11 = t11.length > 1;
      for (const i11 of t11) {
        const { propertyDescriptors: t12, defaultModel: s11 } = iut(e16, i11, a11, n11);
        t12 && (o11.descriptors.push(r11 ? t12.map((e17) => __spreadProps(__spreadValues({}, e17), { category: "" })) : t12), o11.defaultValue.push(s11), o11.objectPath.push(i11.$path), o11.objectValue.push(__spreadProps(__spreadValues({}, i11), { name: i11.$path || "default" })));
      }
      return o11;
    }(r10, h10, e15, "alphabetical" === i10);
  }, [h10, r10, f10, i10]);
  const C10 = ep.useCallback((e15, t11) => {
    if (!t11.startsWith("Style.")) return;
    const [n11] = t11.split(".").slice(-1);
    return e15[n11];
  }, []);
  const x10 = ep.useMemo(() => {
    var _a2, _b2;
    if (!o10) return Let;
    const { StyleSheet: e15 } = o10;
    if (!(S10.length > 1)) {
      const t12 = S10[0];
      const n11 = (_a2 = t12 == null ? void 0 : t12.Style) == null ? void 0 : _a2.ClassName;
      return n11 ? { parentStyle: __spreadValues({}, Mct(t12.Style.ClassName, e15)), getStyleValue: C10 } : Let;
    }
    const t11 = [];
    for (const n11 of S10) {
      const r11 = (_b2 = n11.Style) == null ? void 0 : _b2.ClassName;
      if (!r11) return Let;
      t11.push(Mct(r11, e15));
    }
    return { parentStyle: __spreadValues({}, QN(t11)), getStyleValue: C10 };
  }, [C10, S10, o10]);
  const w10 = ep.useCallback((e15) => {
    if (0 === e15.length) return "";
    const t11 = e15[0].Type;
    if (e15.some(({ Type: e16 }) => e16 !== t11)) return n10("components-RPX:propertyGrid.textMultipleTypes", "<Multiple Types>");
    const { getLabelKey: o11 } = nz.of(r10);
    return n10(o11(t11)) || t11;
  }, [r10, n10]);
  const T10 = ep.useMemo(() => {
    let e15 = w10(S10);
    if (f10.length) {
      const t11 = f10.map((e16) => e16.caption || e16.path).join(" \u2192 ");
      e15 = e15 ? `${e15} \u2192 ${t11}` : t11;
    }
    return e15;
  }, [w10, S10, f10]);
  const E10 = ep.useMemo(() => [{ type: "header", header: n10("components-RPX:propertyGrid.textSort", "Sort") }, { type: "button", text: n10("components-RPX:propertyGrid.textCategorized", "Categorized"), onClick: () => {
    KO.of(r10).userPreferences.sidebar.propertiesSort = "categorized";
  }, selected: "categorized" === i10 }, { type: "button", text: n10("components-RPX:propertyGrid.textAlphabetical", "Alphabetical"), onClick: () => {
    KO.of(r10).userPreferences.sidebar.propertiesSort = "alphabetical";
  }, selected: "alphabetical" === i10 }], [r10, i10, n10]);
  const F10 = { key: "", descriptors: v10, objectValue: S10, defaultValue: b10, propertyEditors: brt, displayMode: a10, sort: "alphabetical" === i10, selectionName: T10, gridSearchPlaceholder: n10("components-RPX:propertyGrid.placeholderSearchBox", "enter property name here..."), closeSearchBtnTitle: "", options: E10, onBackClick: f10.length ? () => y10() : void 0, setProperty: p10, t: n10, expandedStates: { categories: e14 ? c10.categories : {}, editors: t10 ? c10.editors : {} }, onCategoryToggle: e14 ? u10 : void 0, onEditorToggle: t10 ? d10 : void 0, customCSS: Dz };
  return tp.createElement(fse.Provider, { value: m10 }, tp.createElement(yse.Provider, { value: g10 }, tp.createElement(Het.Provider, { value: x10 }, tp.createElement(DD, __spreadValues({}, F10)))));
};
sut.displayName = "RpxPropertyGrid";
const lut = ({ collapsibleCategories: e14 = false, saveExpandEditorsState: t10 = false }) => {
  const { type: n10 } = Oit();
  return "rpx" === (n10 == null ? void 0 : n10.platform) ? tp.createElement(sut, { collapsibleCategories: e14, saveExpandEditorsState: t10 }) : "rdlx" === (n10 == null ? void 0 : n10.platform) ? tp.createElement(tut, { collapsibleCategories: e14, saveExpandEditorsState: t10 }) : null;
};
lut.displayName = "FacadePropertyGrid";
const cut = tp.createElement("svg", { width: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M3 5.5C3 4.119 4.119 3 5.5 3h5C11.881 3 13 4.119 13 5.5v5c0 1.381-1.119 2.5-2.5 2.5h-5C4.119 13 3 11.881 3 10.5v-5ZM7 12h2v-2H7v2Zm-1-2H4v.5c0 .828.672 1.5 1.5 1.5H6v-2Zm1-1h2V7H7v2ZM6 7H4v2h2V7Zm1-1h2V4H7v2ZM6 4h-.5C4.672 4 4 4.672 4 5.5V6h2V4Zm6 3h-2v2h2V7Zm0 3h-2v2h.5c.828 0 1.5-.672 1.5-1.5V10Zm0-4v-.5c0-.828-.672-1.5-1.5-1.5H10v2h2Z" }));
const uut = tp.createElement("svg", { width: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "m3.146 3.853-2-1.999c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l2 2 9 9 2 2c.195.196.195.512 0 .708-.196.195-.512.195-.708 0l-2-2.001-.267-.267c-.395.262-.869.414-1.379.414h-5C4.119 13 3 11.881 3 10.5v-5c0-.51.153-.983.414-1.379l-.268-.268Zm8.001 8.001L10 10.707V12h.5c.232 0 .451-.052.647-.146ZM8.293 9 7 7.707V9h1.293Zm-3-3L4.146 4.853C4.053 5.049 4 5.268 4 5.5V6h1.293ZM6 7H4v2h2V7Zm0 3H4v.5c0 .828.672 1.5 1.5 1.5H6v-2Zm1 2h2v-2H7v2Z" }), tp.createElement("path", { className: Ym.text, opacity: "0.38", d: "M5.134 3.027C5.253 3.009 5.376 3 5.5 3h5C11.881 3 13 4.119 13 5.5v5c0 .124-.009.247-.027.366L11.107 9H12V7h-2v.893L8.107 6H9V4H7v.893L5.134 3.027ZM12 6v-.5c0-.828-.672-1.5-1.5-1.5H10v2h2Z" }));
const dut = tp.createElement("svg", { width: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M11 3.5c0-.829-.672-1.5-1.5-1.5h-3C5.672 2 5 2.671 5 3.5v9c0 .829.672 1.5 1.5 1.5h3c.828 0 1.5-.671 1.5-1.5v-9ZM9.5 3c.276 0 .5.224.5.5v9c0 .276-.224.5-.5.5h-3c-.276 0-.5-.224-.5-.5V11h1.5c.276 0 .5-.224.5-.5s-.224-.5-.5-.5H6V8.5h2c.276 0 .5-.224.5-.5s-.224-.5-.5-.5H6V6h1.5c.276 0 .5-.224.5-.5S7.776 5 7.5 5H6V3.5c0-.276.224-.5.5-.5h3Z" }));
const put = tp.createElement("svg", { width: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M5 5.707 1.146 1.854c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l13 13c.195.196.195.512 0 .708-.196.195-.512.195-.708 0L11 11.707v.794c0 .828-.672 1.5-1.5 1.5h-3c-.828 0-1.5-.672-1.5-1.5V5.707Zm5 5L7.793 8.5H6V10h1.5c.276 0 .5.224.5.5s-.224.5-.5.5H6v1.501c0 .276.224.5.5.5h3c.276 0 .5-.224.5-.5v-1.794ZM6.793 7.5 6 6.707V7.5h.793Z" }), tp.createElement("path", { className: Ym.text, opacity: "0.38", d: "M5.091 2.984C5.302 2.41 5.853 2 6.5 2h3c.828 0 1.5.672 1.5 1.5v5.393l-1-1V3.5c0-.276-.224-.5-.5-.5h-3c-.276 0-.5.224-.5.5v.393l-.746-.747-.163-.162Z" }));
const mut = tp.createElement("svg", { width: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M3 8.985v-4C3 3.889 3.905 3 5 3s2 .889 2 1.985v4C7 9.545 7.44 10 8 10s1-.455 1-1.015v-4C9 3.889 9.905 3 11 3s2 .889 2 1.985v4c0 2.751-2.249 4.984-5 4.984s-5-2.233-5-4.984Zm1-4V6h2V4.985c0-.561-.44-1.016-1-1.016s-1 .455-1 1.016ZM4 7v2.469C4 11.685 5.784 13 8 13s4-1.799 4-4.015V7h-2v1.985c0 1.095-.905 1.984-2 1.984s-2-.889-2-1.984V7H4Zm6-2.015V6h2V4.985c0-.561-.44-1.016-1-1.016s-1 .455-1 1.016Z" }));
const hut = tp.createElement("svg", { width: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M3.275 3.983 1.146 1.854c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l13 13c.195.196.195.512 0 .708-.196.195-.512.195-.708 0l-2.482-2.483c-.914.983-2.22 1.598-3.664 1.598-2.751 0-5-2.233-5-4.984v-4c0-.366.101-.708.275-1.002Zm7.695 7.694-1.43-1.43c-.368.441-.924.722-1.54.722-1.095 0-2-.889-2-1.984V7H4v2.469C4 11.685 5.784 13 8 13c1.181 0 2.239-.511 2.97-1.323ZM8.837 9.544 7 7.707v1.278C7 9.545 7.44 10 8 10c.354 0 .659-.181.837-.456ZM5.293 6 4.03 4.737c-.02.079-.03.162-.03.248V6h1.293Z" }), tp.createElement("path", { className: Ym.text, opacity: "0.38", d: "M5.11 3.003c1.014.055 1.84.872 1.888 1.888L5.11 3.003ZM9 6.893V4.985C9 3.889 9.905 3 11 3s2 .889 2 1.985v4c0 .571-.097 1.121-.276 1.632l-.808-.808c.055-.266.084-.542.084-.824V7h-2v.893l-1-1Zm1-1.908V6h2V4.985c0-.561-.44-1.016-1-1.016s-1 .455-1 1.016Z" }));
const fut = tp.createElement("svg", { width: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M7.5 5.5c.27614 0 .5-.22386.5-.5s-.22386-.5-.5-.5-.5.22386-.5.5.22386.5.5.5Zm2.5 0c0 .27614-.22386.5-.5.5S9 5.77614 9 5.5s.22386-.5.5-.5.5.22386.5.5ZM11.5 7c0 .27614-.2239.5-.5.5s-.5-.22386-.5-.5.2239-.5.5-.5.5.22386.5.5ZM11 9.5c.2761 0 .5-.22386.5-.5s-.2239-.5-.5-.5-.5.22386-.5.5.2239.5.5.5Zm-.5 1.5c0 .2761-.2239.5-.5.5-.27614 0-.5-.2239-.5-.5s.22386-.5.5-.5c.2761 0 .5.2239.5.5ZM8 2C4.68629 2 2 4.68629 2 8c0 1.10457.89543 2 2 2 .70765 0 1.08538-.37805 1.34047-.63336l.01308-.01309C5.5983 9.10881 5.71984 9 6 9c.55228 0 1 .44772 1 1v1c0 1.6569 1.34315 3 3 3 1.3336 0 2.3539-.7464 3.0169-1.8541C13.6724 11.0507 14 9.57925 14 8c0-3.31371-2.6863-6-6-6ZM3 8c0-2.76142 2.23858-5 5-5 2.7614 0 5 2.23858 5 5 0 1.45832-.3052 2.7368-.8411 3.6323C11.6305 12.5151 10.9008 13 10 13c-1.10457 0-2-.8954-2-2v-1c0-1.10457-.89543-2-2-2-.70765 0-1.08538.37805-1.34047.63336l-.01308.01309C4.4017 8.89119 4.28016 9 4 9c-.55228 0-1-.44772-1-1Z" }));
const gut = { minValue: L$.parse("0.025in"), maxValue: L$.parse("2in") };
const [yut, , vut] = Dp("wd-snap-settings");
const [but] = vut("container");
const Sut = ({ withGridSizeEditor: e14, withSnapToGuidesToggle: t10 }) => {
  const { id: n10 } = Mz();
  const r10 = rf(mut);
  const o10 = rf(hut);
  const { t: a10 } = vp("components");
  const i10 = a10;
  const { userPreferences: { units: s10, surface: { gridSize: l10, snapToGrid: c10, snapToLines: u10 } } } = MO();
  const d10 = ep.useRef(null);
  const p10 = hK(l10, "length");
  const m10 = (e15) => {
    KO.of(n10).userPreferences.surface.gridSize = pK(e15, "length", { units: s10 }, void 0, l10), d10.current = null;
  };
  const h10 = { block: true, size: "small", position: "top" };
  const f10 = (e15 = true) => i10("statusBar.common." + (e15 ? "textEnabled" : "textDisabled"));
  const g10 = tp.createElement("div", { className: yut }, e14 && tp.createElement("div", { className: but, "data-aid": "grid-size" }, tp.createElement(AN, __spreadProps(__spreadValues({}, h10), { label: a10("statusBar.snapSettings.labelGridSize", "Grid Size"), dataAid: "grid-size-label" }), tp.createElement(UD, { id: "grid-size-editor", placeholder: " ", value: p10, validate: (e15) => {
    const { isValid: t11 } = JY(e15, "length", { units: s10 }, gut);
    return d10.current = t11 ? e15 : null, t11;
  }, onChange: m10 }))), tp.createElement("div", { className: but, "data-aid": "snap-to-grid" }, tp.createElement(AN, __spreadProps(__spreadValues({}, h10), { label: a10("statusBar.snapSettings.labelSnapToGrid", "Snap To Grid"), dataAid: "snap-to-grid-label" }), tp.createElement(SM, { customCSS: "snap-to-grid-toggle" + (c10 ? " checked" : ""), size: "small", checked: c10, onToggle: () => {
    KO.of(n10).userPreferences.surface.snapToGrid = !c10;
  }, text: f10(c10) }))), t10 && tp.createElement("div", { className: but, "data-aid": "snap-to-guides" }, tp.createElement(AN, __spreadProps(__spreadValues({}, h10), { label: a10("statusBar.snapSettings.labelSnapToGuides", "Snap To Guides") }), tp.createElement(SM, { customCSS: "snap-to-guides-toggle" + (u10 ? " checked" : ""), size: "small", checked: u10, onToggle: () => {
    KO.of(n10).userPreferences.surface.snapToLines = !u10;
  }, text: f10(u10) }))));
  const y10 = { content: g10, icon: c10 || u10 ? r10 : o10, size: "small", background: "transparent", hiddenChevron: true, dropup: true, menuAlign: "center", menuWidth: 200, onToggle: (e15) => {
    !e15 && d10.current && m10(d10.current);
  }, dataAid: "snap-dropdown", title: c10 || u10 ? a10("statusBar.snapSettings.titleSnapEnabled", "Snap Enabled") : a10("statusBar.snapSettings.titleSnapDisabled", "Snap Disabled") };
  return tp.createElement(UF, __spreadValues({}, y10));
};
const Cut = () => {
  const { instanceId: e14, themes: { list: t10 }, userPreferences: { theme: n10 } } = MO();
  const { theme: r10 } = Mz();
  const o10 = PA();
  const a10 = rf(fut);
  const { t: i10, t: s10 } = vp("components");
  const l10 = t10.map((e15) => "string" == typeof e15 ? e15 : e15.name);
  const c10 = l10.indexOf("system") > -1;
  c10 && l10.splice(l10.indexOf("system"), 1);
  const u10 = { dataAid: "theme-dropdown", title: s10("statusBar.themePicker.titleTheme", "Theme"), items: [c10 && { type: "button", text: i10("statusBar.themePicker.themes.system", "System Theme"), value: "system", selected: "system" === (n10 || r10.name) }, c10 && { type: "splitter" }, ...l10.map((e15) => ({ type: "button", text: i10(`statusBar.themePicker.themes.${e15}`, { defaultValue: e15 }), value: e15, selected: (n10 || r10.name) === e15 }))], icon: a10, size: "small", background: "transparent", dropup: true, hiddenChevron: true, onSelect: (t11) => {
    t11 !== n10 && (o10(fB(t11)), KO.of(e14).userPreferences.theme = t11);
  } };
  return tp.createElement(UF, __spreadValues({}, u10));
};
const [xut, , wut] = Dp("wd-zoom-control");
const [Tut] = wut("value");
const Eut = ({ zoomPoints: e14 = yB }) => {
  const { userPreferences: { surface: { zoomFactor: t10 } }, instanceId: n10 } = MO();
  const { t: r10 } = vp("components");
  const o10 = (e15) => {
    KO.of(n10).userPreferences.surface.zoomFactor = e15;
  };
  const a10 = (n11 = true) => () => {
    o10(vB(t10, n11, e14));
  };
  const i10 = (e15) => () => o10(e15);
  const s10 = { dataAid: "zoom-dropdown", items: e14.map((e15) => ({ type: "button", text: `${Math.round(100 * e15)}%`, selected: e15 === t10, onClick: i10(e15), dataAid: `percent-${Math.floor(100 * e15)}` })), text: `${Math.round(100 * t10)}%`, size: "small", background: "transparent", dropup: true, hiddenChevron: true, menuWidth: "auto", menuAlign: "center", customCSS: Tut, title: `${Math.round(100 * t10)}%` };
  const l10 = { size: "small", background: "transparent", customCSS: "gc-statusbar__btn--with-icon" };
  const c10 = __spreadProps(__spreadValues({}, l10), { onClick: a10(false), title: r10("statusBar.titleZoomOut", "Zoom Out"), icon: nf(Jm), dataAid: "zoom-out-button" });
  const u10 = __spreadProps(__spreadValues({}, l10), { onClick: a10(), title: r10("statusBar.titleZoomIn", "Zoom In"), icon: nf(Xm), dataAid: "zoom-in-button" });
  return tp.createElement("span", { className: xut }, tp.createElement(DM, null), tp.createElement(qm, __spreadValues({}, c10)), tp.createElement(UF, __spreadValues({}, s10)), tp.createElement(qm, __spreadValues({}, u10)), tp.createElement(DM, null));
};
const [Fut] = Dp("wd-btn-units");
const Mut = ({ zoomPoints: e14, hiddenElements: t10 = {} }) => {
  const { workspaceId: n10 } = Mz();
  const { instanceId: r10, themes: { list: o10, picker: { enabled: a10 } }, userPreferences: { units: i10, surface: { showGrid: s10 }, rulers: { show: l10 } } } = MO();
  const c10 = rf(cut);
  const u10 = rf(uut);
  const d10 = rf(dut);
  const p10 = rf(put);
  const { t: m10 } = vp("components");
  const h10 = m10;
  const f10 = { text: h10(`common:units.${i10}.textShortName`, "sn"), title: h10(`common:units.${i10}.textFullName`, "Full Name"), onClick: () => {
    switch (i10) {
      case "in":
        KO.of(r10).userPreferences.units = "cm";
        break;
      case "cm":
        KO.of(r10).userPreferences.units = "in";
    }
  }, size: "small", background: "transparent", customCSS: Fut, dataAid: "units-button" };
  const g10 = { title: s10 ? m10("statusBar.titleHideGrid", "Hide Grid") : m10("statusBar.titleShowGrid", "Show Grid"), icon: s10 ? c10 : u10, size: "small", background: "transparent", onClick: () => {
    KO.of(r10).userPreferences.surface.showGrid = !s10;
  }, dataAid: "grid-button" };
  const y10 = { title: l10 ? m10("statusBar.titleHideRulers", "Hide Rulers") : m10("statusBar.titleShowRulers", "Show Rulers"), icon: l10 ? d10 : p10, size: "small", background: "transparent", onClick: () => {
    KO.of(r10).userPreferences.rulers.show = !l10;
  }, dataAid: "rulers-button" };
  const v10 = { dismissAllLabel: m10("notifications.btnDismissAll", "Dismiss all"), dismissLabel: m10("notifications.btnDismiss", "Dismiss"), expandTitle: m10("common:textExpand", "Expand"), collapseTitle: m10("common:textCollapse", "Collapse"), notificationCounterTitle: m10("notifications.titleNotifications", "Notifications"), errorCategoryLabel: (e15) => m10("notifications.headingError", "{{count}} Error", { count: e15 }), warningCategoryLabel: (e15) => m10("notifications.headingWarning", "{{count}} Warning", { count: e15 }), infoCategoryLabel: (e15) => m10("notifications.headingNotification", "{{count}} Notification", { count: e15 }), dataAid: "status-bar" };
  const b10 = n10 !== pz;
  return tp.createElement(WH, __spreadValues({}, v10), false, false, a10 && !t10.theme && o10.length > 0 && tp.createElement(Cut, null), !t10.theme && o10.length > 0 && tp.createElement(DM, null), !t10.units && !b10 && tp.createElement(qm, __spreadValues({ key: "sb-units" }, f10)), !t10.zoom && !b10 && tp.createElement(Eut, { key: "sb-zoom", zoomPoints: e14 }), !t10.rulersToggle && !b10 && tp.createElement(qm, __spreadValues({ key: "sb-rulers-toggle" }, y10)), !t10.snapSettings && !b10 && tp.createElement(Sut, { key: "sb-snap-settings", withGridSizeEditor: !t10.gridSizeEditor, withSnapToGuidesToggle: !t10.snapToGuidesToggle }), !t10.gridToggle && !b10 && tp.createElement(qm, __spreadValues({ key: "sb-grid-toggle" }, g10)));
};
const kut = (e14) => {
  const { type: { platform: t10 } } = kz();
  const { hiddenElements: n10 } = e14;
  const r10 = __spreadProps(__spreadValues({}, e14), { hiddenElements: __spreadProps(__spreadValues({}, n10), { snapToGuidesToggle: "rpx" === t10 }) });
  return tp.createElement(Mut, __spreadValues({}, r10));
};
kut.displayName = "FacadeStatusBar";
class Put extends tp.Component {
  constructor(e14) {
    super(e14), this.state = __spreadProps(__spreadValues({}, e14.value), { update: this.updateState.bind(this) });
  }
  static getDerivedStateFromProps(e14, t10) {
    return t10.contextValue === e14.value ? null : __spreadValues({}, e14.value);
  }
  updateState(e14) {
    this.setState(e14);
  }
  render() {
    const { children: e14 } = this.props;
    return tp.createElement(bqe.Provider, { value: this.state }, e14);
  }
}
const Nut = jre((e14) => ({ isDragging: e14.isDragging() }));
class Dut extends tp.Component {
  constructor(e14, t10) {
    super(e14, t10), this.onMenuTransition = (e15) => {
      this.setState({ isInTransition: e15 });
    }, this.state = { decorations: [], scrollOffset: { left: 0, top: 0 }, viewportOffset: { left: 0, top: 0 }, viewportInitialized: false, isInTransition: false }, this.setScrollOffset = this.setScrollOffset.bind(this), this.setDecorations = this.setDecorations.bind(this), this.setCanvasRef = this.setCanvasRef.bind(this), this.setDecoratedComponentRef = this.setDecoratedComponentRef.bind(this);
  }
  componentDidMount() {
    const { update: e14 } = this.context;
    e14({ setDecorations: this.setDecorations });
  }
  componentDidUpdate(e14, t10) {
    const { viewport: n10, isDragging: r10, decorationLayerRef: o10 } = this.props;
    const { viewportInitialized: a10, decorations: i10 } = this.state;
    if (n10 && !a10) {
      n10.addEventListener("scroll", this.setScrollOffset);
      const { scrollTop: e15, scrollLeft: t11 } = n10;
      const r11 = n10.getBoundingClientRect();
      const a11 = o10.current.decoratedComponent.getBoundingClientRect();
      const i11 = { left: e15 + a11.top - r11.top, top: t11 + a11.left - r11.left };
      this.setState({ viewportInitialized: true, viewportOffset: i11, scrollOffset: { left: -i11.left, top: -i11.top } });
    }
    i10 !== t10.decorations && this.drawDecorations(i10), r10 !== e14.isDragging && (this.setDecorations("", []), this.clearDecorations());
  }
  componentWillUnmount() {
    const { viewport: e14 } = this.props;
    e14 && e14.removeEventListener("scroll", this.setScrollOffset);
  }
  setCanvasRef(e14) {
    this.canvas = e14;
  }
  setDecoratedComponentRef(e14) {
    this.decoratedComponent = e14;
  }
  setDecorations(e14, t10) {
    this.setState({ decorations: t10 || [] });
  }
  setScrollOffset() {
    const { viewport: e14 } = this.props;
    if (!this.canvas || !e14) return;
    const { viewportOffset: t10 } = this.state;
    const { scrollTop: n10, scrollLeft: r10 } = e14;
    this.setState({ scrollOffset: { top: n10 - t10.top, left: r10 - t10.left } });
  }
  clearDecorations() {
    if (!this.canvas) return;
    this.canvas.getContext("2d").clearRect(0, 0, this.canvas.width, this.canvas.height);
  }
  drawDecorations(e14) {
    const { viewport: t10, colorAccent: n10, colorError: r10, isDragging: o10 } = this.props;
    const { scrollOffset: a10 } = this.state;
    const { getSettings: i10 } = this.context;
    if (!this.canvas || !t10 || !o10) return;
    this.clearDecorations();
    const { zoomFactor: s10 } = i10();
    const l10 = this.canvas.getContext("2d");
    if (t10 && (this.canvas.width !== t10.clientWidth || this.canvas.height !== t10.clientHeight)) {
      const e15 = window.devicePixelRatio;
      this.canvas.width = t10.clientWidth * e15, this.canvas.height = t10.clientHeight * e15, l10.scale(e15, e15);
    }
    const c10 = (e15) => e15 * s10 - a10.left;
    const u10 = (e15) => e15 * s10 - a10.top;
    e14.forEach((e15) => {
      const _a2 = e15, { type: t11 = "" } = _a2, o11 = __objRest(_a2, ["type"]);
      switch (l10.imageSmoothingEnabled = false, l10.lineWidth = 1, l10.strokeStyle = "black", l10.shadowBlur = 0, l10.fillStyle = "transparent", l10.globalAlpha = 1, t11) {
        case "line":
          l10.beginPath(), l10.strokeStyle = n10.rgba, l10.moveTo(c10(L$.toPixels(o11.startPoint.X)), u10(L$.toPixels(o11.startPoint.Y))), l10.lineTo(c10(L$.toPixels(o11.endPoint.X)), u10(L$.toPixels(o11.endPoint.Y))), l10.stroke(), l10.closePath();
          break;
        case "hsnap":
        case "vsnap": {
          const [e16, r11, a11] = [c10(L$.toPixels(o11.left)), u10(L$.toPixels(o11.top)), L$.toPixels(o11.length) * s10];
          l10.strokeStyle = n10.rgba, l10.beginPath(), l10.moveTo(e16, r11), l10.lineTo(e16 + ("hsnap" === t11 ? a11 : 0), r11 + ("vsnap" === t11 ? a11 : 0)), l10.stroke(), l10.closePath();
          break;
        }
        case "box":
        case "section":
        case "selarea": {
          const [e16, a11, i11, d10] = [c10(L$.toPixels(o11.left)), u10(L$.toPixels(o11.top)), L$.toPixels(o11.width) * s10, L$.toPixels(o11.height) * s10];
          "selarea" === t11 ? (l10.fillStyle = n10.transparentize(0.8).rgba, l10.strokeStyle = n10.rgba, l10.fillRect(e16, a11, i11, d10)) : o11.highlightType && (l10.shadowBlur = 7, "can-drop" === o11.highlightType ? l10.shadowColor = n10.rgba : "error" === o11.highlightType && (l10.shadowColor = r10.rgba, l10.fillStyle = "grey")), l10.strokeRect(e16, a11, i11, d10);
          break;
        }
      }
    });
  }
  render() {
    const { viewport: e14, children: t10 } = this.props;
    const { scrollOffset: n10, isInTransition: r10, viewportInitialized: o10 } = this.state;
    const a10 = { width: "100%", height: "100%", top: n10.top, left: n10.left };
    if (e14 && o10) {
      const { clientHeight: t11, clientWidth: n11 } = e14;
      a10.width = r10 ? "100%" : n11, a10.height = t11;
    }
    return tp.createElement("div", { className: "ar-decorationlayer" }, tp.createElement("div", { ref: this.setDecoratedComponentRef }, t10), tp.createElement("canvas", { className: "ar-decorationview", style: a10, ref: this.setCanvasRef }));
  }
}
Dut.propTypes = { isDragging: JV.bool.isRequired, viewport: JV.any, children: JV.element.isRequired }, Dut.contextType = bqe;
var Lut = Nut((e14) => tp.createElement(Dut, __spreadProps(__spreadValues({}, e14), { ref: e14.decorationLayerRef })));
const Hut = (e14) => {
  const { reportPageDomElement: t10, decorationLayerRef: n10, zoomFactor: r10, report: o10, children: a10, disabled: i10 = false } = e14;
  const s10 = PA();
  const { instanceId: l10 } = Uae();
  const c10 = nz.of(l10).getFeature(o10.Type, "getPageSectionsInfo");
  const u10 = Elt();
  const [, d10, p10] = Yne({ item: { type: "freeRectSelect", reportCornerPosition: { top: 0, left: 0 }, scrollDetector: u10 }, begin: () => {
    var _a2, _b2;
    const e15 = t10 == null ? void 0 : t10.getBoundingClientRect();
    const n11 = { top: (_a2 = e15 == null ? void 0 : e15.top) != null ? _a2 : 0, left: (_b2 = e15 == null ? void 0 : e15.left) != null ? _b2 : 0 };
    return u10.reset(), { type: "freeRectSelect", reportCornerPosition: n11, scrollDetector: u10 };
  } });
  const m10 = ep.useCallback((e15, o11) => {
    var _a2;
    const { reportCornerPosition: a11 } = e15;
    const { detectScrollOffset: i11, scrollOffset: s11 } = e15.scrollDetector;
    t10 && i11(t10);
    const l11 = Nlt(o11, r10, a11, s11);
    const c11 = zV.mapValues(Llt(l11), (e16) => e16.css);
    (_a2 = n10.current) == null ? void 0 : _a2.setDecorations("", [__spreadValues({ type: "selarea" }, c11)]);
  }, [n10, t10, r10]);
  const [, h10] = are({ accept: ["freeRectSelect", "rectRounding", "rdlxTab"], drop: (e15, t11) => {
    var _a2;
    if ("freeRectSelect" === e15.type) {
      const { reportCornerPosition: n11 } = e15;
      const { scrollOffset: a11 } = e15.scrollDetector;
      const { ctrlPressed: i11 } = k0e;
      const l11 = Nlt(t11, r10, n11, a11);
      const u11 = Llt(l11);
      const d11 = (_a2 = c10 == null ? void 0 : c10(o10)) != null ? _a2 : [];
      const p11 = [];
      if (d11.forEach((e16) => {
        const t12 = __spreadProps(__spreadValues({}, u11), { top: u11.top.subtract(e16.offset.top), left: u11.left.subtract(e16.offset.left) });
        const n12 = klt(e16.container, t12, o10);
        n12.length > 0 && p11.push(...n12.map((t13) => ({ path: `${e16.path}.ReportItems.${t13.index}`, type: t13.type })));
      }), p11.length > 0) return void s10((i11 ? d5 : p5)(p11));
      const m11 = [];
      if (d11.forEach((e16) => {
        var _a3;
        Mlt(e16.offset, u11) && m11.push({ path: e16.path, type: (_a3 = e16.container.Type) != null ? _a3 : "" });
      }), m11.length > 0) return void s10((i11 ? d5 : p5)(m11));
      s10(u5());
    }
  }, hover: (e15, t11) => {
    if ("freeRectSelect" === e15.type && I0e(m10(e15, t11)), "rdlxTab" === e15.type && e15.moveTab && I0e(e15.moveTab(e15, t11)), "rectRounding" === e15.type) {
      const { gripSide: n11, transformGrip: r11 } = e15;
      const o11 = t11.getDifferenceFromInitialOffset();
      if (o11) {
        r11(h2e.getOffset(o11, n11));
      }
    }
  } });
  return ep.useEffect(() => {
    p10(Coe(), { captureDraggingState: true });
  }, [p10]), tp.createElement("div", { ref: i10 ? void 0 : d10, style: { display: "grid", overflow: "hidden", minHeight: "100%" } }, tp.createElement("div", { ref: i10 ? void 0 : h10, className: "report-area-wrapper" }, a10));
};
const Iut = _V("@rdlx/dashboard/section/add", (e14) => e14);
const _ut = _V("@rdlx/dashboard/section/remove", (e14) => e14);
const Vut = _V("@rdlx/dashboard/section/move", (e14) => e14);
const Rut = _V("@rdlx/dashboard/section/duplicate", (e14) => e14);
const Aut = _V("@rdlx/dashboard/section/toggle", (e14) => e14);
const Out = _V("@rdlx/dashboard/section/changeWidthByDelta", ({ delta: e14, index: t10 }) => ({ delta: e14, index: t10 }));
const But = _V("@rdlx/dashboard/changeSectionHeight", ({ delta: e14, path: t10 }) => ({ delta: e14, path: t10 }));
const zut = (e14, { path: t10, moveSide: n10 }, r10) => r10 ? "right" === n10 || "left" === n10 ? Out({ delta: e14.x }) : But({ path: t10, delta: e14.y }) : r2({ path: t10, delta: e14.y });
const $ut = (e14, t10, n10, r10, o10) => {
  if (!o10) return;
  o10(t10, z0e(null, [c5(t10), r10].reduce(nz.of(e14).getReducer(n10.Type), n10), {}));
};
const Wut = (e14, t10, n10, { zoomFactor: r10, snapToGrid: o10, gridSize: a10 }) => {
  const i10 = N0e(n10.getDifferenceFromInitialOffset(), r10);
  const { units: s10 } = e14;
  const l10 = ((e15) => {
    switch (e15) {
      case "top":
      case "left":
        return -1;
      default:
        return 1;
    }
  })(t10.moveSide);
  const c10 = ((e15) => {
    switch (e15) {
      case "left":
      case "right":
        return "x";
      default:
        return "y";
    }
  })(t10.moveSide);
  const u10 = "x" === c10 ? "y" : "x";
  if (o10 && a10) {
    const t11 = L$.parse(a10);
    const n11 = L$.fromPixels(l10 * i10[c10], t11.units);
    return { [c10]: jut(n11, e14, t11), [u10]: L$.fromPixels(i10[u10], t11.units) };
  }
  return { [c10]: L$.fromPixels(l10 * i10[c10], s10), [u10]: L$.parse(`0${s10}`) };
};
const jut = (e14, t10, n10) => {
  const r10 = Math.round(e14.add(t10).divide(n10));
  return n10.multiply(r10).subtract(t10);
};
const Zut = (e14) => {
  if ("Continuous" !== e14.Type) return true;
  const { Page: { TopMargin: t10, BottomMargin: n10, PageHeight: r10 } } = e14;
  const [o10, a10, i10] = [L$.parse(t10), L$.parse(n10), L$.parse(r10)];
  const s10 = i10.subtract(o10).subtract(a10);
  const l10 = e14.PageHeader && L$.parse(e14.PageHeader.$place.Height) || L$.zero;
  const c10 = e14.PageFooter && L$.parse(e14.PageFooter.$place.Height) || L$.zero;
  return !s10.subtract(l10).subtract(c10).lowerThan(L$.zero);
};
const [Gut, , Uut] = Dp("section-header");
const [qut] = Uut("primary");
const [Yut] = Uut("hidden");
const Kut = { in: L$.parse("0.25in"), cm: L$.parse("0.5cm") };
const Xut = (e14) => L$.parse(e14);
const Jut = (e14) => {
  var _a2, _b2, _c2;
  const { section: t10, theme: n10, path: r10, dataSets: o10, section: { Body: a10, PageHeader: i10, PageFooter: s10 } } = e14;
  const { t: l10 } = vp();
  const c10 = PA();
  const u10 = ep.useContext(bqe);
  const { setDecorations: d10, getReport: p10 } = u10;
  const m10 = ep.useRef(null);
  const h10 = MO();
  const { lockLayout: f10, userPreferences: { surface: g10, units: y10 } } = h10;
  const { zoomFactor: v10 } = g10;
  const b10 = { name: t10.Name, path: r10, type: t10.Type, ref: m10.current };
  const S10 = h9();
  const [, C10] = are({ accept: ["resizegrip", "rectselect"], drop: (e15, t11) => {
    if ("rectselect" === e15.type) {
      let n11 = Plt(m10.current);
      const { scrollOffset: r11 } = e15.scrollDetector;
      n11 = { left: n11.left + r11.x, top: n11.top + r11.y };
      const o11 = Nlt(t11, v10, n11, r11);
      return Ilt(e15, o11, p10);
    }
    if ("resizegrip" === e15.type && t11.canDrop()) {
      const { movedItems: n11 = [], childItemNames: r11 = [], host: o11 } = e15;
      const a11 = e2e(t11, v10, o11, n11, r11);
      const i11 = i2e(b10, a11, h10, S10);
      const s11 = (i11 == null ? void 0 : i11.actions) || [];
      s11.length > 0 && c10(rz(s11));
    }
  }, hover: (e15, t11) => {
    if ("rectselect" === e15.type) {
      let n11 = Plt(m10.current);
      const { detectScrollOffset: r11, scrollOffset: o11 } = e15.scrollDetector;
      m10.current && r11(m10.current), n11 = { left: n11.left + o11.x, top: n11.top + o11.y };
      const a11 = Nlt(t11, g10.zoomFactor, n11, o11);
      return Hlt(a11, e15.absolutePosition, e15.item.Name, d10);
    }
    if ("resizegrip" === e15.type) {
      if (!t11.isOver({ shallow: true })) return;
      if (t11.canDrop()) {
        const { movedItems: n11 = [], childItemNames: r11 = [], host: o11 } = e15;
        const a11 = e2e(t11, v10, o11, n11, r11);
        s2e(b10, a11, h10, S10, d10);
      }
    }
  }, canDrop: (e15, t11) => {
    if ("resizegrip" === e15.type) {
      if (f10) return false;
      if (!t11.isOver({ shallow: true })) return false;
    }
    return true;
  }, collect: (e15) => ({ isDragging: e15.canDrop(), isHovering: e15.isOver(), item: e15.getItem() }) });
  const x10 = Xut(t10.Width).css;
  const w10 = Xut((_a2 = i10 == null ? void 0 : i10.$place.Height) != null ? _a2 : `0${y10}`);
  const T10 = Xut((_b2 = a10.$place.Height) != null ? _b2 : `0${y10}`);
  const E10 = Xut((_c2 = s10 == null ? void 0 : s10.$place.Height) != null ? _c2 : `0${y10}`);
  const F10 = kp(Gut, (i10 == null ? void 0 : i10.$primary) ? qut : "", !(i10 == null ? void 0 : i10.$primary) && w10.lowerThan(Kut[y10]) ? Yut : "");
  const M10 = kp(Gut, (a10 == null ? void 0 : a10.$primary) ? qut : "", !(a10 == null ? void 0 : a10.$primary) && T10.lowerThan(Kut[y10]) ? Yut : "");
  const k10 = kp(Gut, (s10 == null ? void 0 : s10.$primary) ? qut : "", !(s10 == null ? void 0 : s10.$primary) && E10.lowerThan(Kut[y10]) ? Yut : "");
  const P10 = L$.sum([w10, T10, E10]);
  return tp.createElement("div", { className: "is-report-area scalable", style: { width: "100%", height: "100%" }, ref: C10 }, tp.createElement("div", { className: "ar-page", style: { width: x10, height: P10.css }, ref: m10 }, i10 && tp.createElement(tp.Fragment, null, tp.createElement("div", { key: "headerLabel", className: F10 }, l10("labels:header", "Header")), tp.createElement(ect, { key: "header", item: i10, path: `${r10}.PageHeader`, dataSets: o10, width: x10, height: w10.css, theme: n10 })), (i10 || s10) && tp.createElement("div", { key: "bodyLabel", className: M10 }, l10("labels:body")), tp.createElement(pct, { key: "body", item: a10, path: `${r10}.Body`, dataSets: o10, width: x10, height: T10.css, theme: n10 }), s10 && tp.createElement(tp.Fragment, null, tp.createElement("div", { key: "footerLabel", className: k10 }, l10("labels:footer", "Footer")), tp.createElement(ect, { key: "footer", item: s10, path: `${r10}.PageFooter`, dataSets: o10, width: x10, height: E10.css, theme: n10 })), !f10 && tp.createElement(wlt, { orientation: "vertical", type: "freeResizeLine", documentItemPath: r10, documentItemType: t10.Type, moveSide: "right" })));
};
const Qut = "0pt";
const edt = (e14) => {
  const { grips: t10, path: n10, host: r10 } = e14;
  const { getReport: o10 } = ep.useContext(bqe);
  const a10 = o10();
  const i10 = V0e(a10);
  const s10 = l2e(i10.map((e15) => e15.Name), a10.$index.NamedItems);
  const [, l10, c10] = Yne({ item: { resize: true, path: n10, type: "placeHolderResizeGrip", host: r10, grips: t10, reportState: a10, movedItems: i10, childItemNames: s10 }, collect: (e15) => ({ isDragging: e15.isDragging() }) });
  return ep.useEffect(() => {
    c10(Coe(), { captureDraggingState: true });
  }, []), l10(tp.createElement("div", { className: `placeholder-grip ${t10}` }));
};
const tdt = (e14) => {
  const { path: t10, host: n10, item: r10 } = e14;
  const { getItemLayerInfo: o10 } = ep.useContext(bqe);
  const { $place: { Left: a10, Top: i10, Width: s10, Height: l10 }, $fixedPlace: { Width: c10, Height: u10 }, Type: d10 } = r10;
  const { isLocked: p10, isVisible: m10, opacity: h10 } = o10(r10);
  if (!m10 || 0 === h10) return tp.createElement(N2e, __spreadValues({}, e14));
  const f10 = "fixedpagepartitem" !== r10.Type;
  const g10 = { className: "ar-reportitemplace", "data-aid": "reportitemplace", style: { left: a10, top: i10, width: f10 && (c10 !== Qut ? c10 : s10) || s10, height: f10 && (u10 !== Qut ? u10 : l10) || l10 } };
  const y10 = { className: kp("ar-item", "ar-placeholder", Mee), "data-aid": "placeholder", "data-path": t10, "data-type": r10.Type };
  const v10 = __spreadProps(__spreadValues({}, r10.$place), { Left: Qut, Top: Qut, Width: s10, Height: l10 });
  const b10 = sj(r10) && !p10 && f10;
  return tp.createElement("div", __spreadValues({}, g10), b10 && tp.createElement("div", __spreadValues({}, y10), tp.createElement("div", { className: "placeholder-border" }), u10 && tp.createElement(edt, { grips: `fpl-${qG.S}`, path: t10, type: d10, host: n10 }), c10 && tp.createElement(edt, { grips: `fpl-${qG.E}`, path: t10, type: d10, host: n10 }), c10 && u10 && tp.createElement(edt, { grips: `fpl-${qG.SE}`, path: t10, type: d10, host: n10 })), tp.createElement(N2e, __spreadProps(__spreadValues({}, e14), { item: __spreadProps(__spreadValues({}, r10), { $place: v10 }) })));
};
const [ndt] = Dp("ar-rectangle-glyph");
const rdt = (e14) => {
  const { instanceId: t10, makeImageUrl: n10, getItemLayerInfo: r10, isItemInFixedArea: o10, embeddedImages: a10 } = ep.useContext(bqe);
  const { theme: i10 } = e14;
  const { item: s10, item: { Style: l10 }, path: c10, dataSets: u10, parentBackgroundColor: d10, onlyContent: p10 } = e14;
  const { $place: m10, RoundingRadius: h10 } = s10;
  const { isVisible: f10, opacity: g10 } = r10(s10);
  const { userPreferences: { surface: { showGrid: y10, gridSize: v10 = "0.25in" } } } = KO.of(t10);
  const b10 = ep.useRef(null);
  const [S10, C10] = [m10 && m10.Width, m10 && m10.Height];
  const x10 = ep.useCallback(() => s10 ? qlt(s10.ReportItems, c10) : [], [s10, c10]);
  const w10 = ep.useMemo(() => x10(), [x10]);
  const T10 = zlt({ ref: b10.current, name: s10.Name, type: s10.Type, path: c10 }, t10);
  const [{ isOver: E10, canDrop: F10 }, M10] = are(__spreadProps(__spreadValues({ accept: ["reportitem", "toolboxItem", "smartSuggestion", "value", "field", "fields", "resizegrip", "placeHolderResizeGrip", "entity_relation", "dataset", "partItem"] }, T10), { collect: (e15) => ({ isOver: false, canDrop: e15.canDrop() }) }));
  const k10 = rj(s10) ? 1 : f10 ? g10 : 0;
  let P10 = {};
  let N10 = {};
  S10 && C10 && h10 && (N10 = (() => {
    const e15 = {};
    const t11 = { width: L$.parse(S10).divideByNum(2), height: L$.parse(C10).divideByNum(2) };
    const n11 = t11.height.greaterThan(t11.width) ? t11.width : t11.height;
    const r11 = h10.Default || "0pt";
    const o11 = (e16) => {
      const t12 = e16 || r11;
      return L$.parse(t12).greaterThan(n11) ? n11.css : t12;
    };
    return e15.borderTopLeftRadius = o11(h10.TopLeft), e15.borderTopRightRadius = o11(h10.TopRight), e15.borderBottomLeftRadius = o11(h10.BottomLeft), e15.borderBottomRightRadius = o11(h10.BottomRight), e15;
  })(), P10 = Object.assign(Mme(l10, i10), N10, { opacity: k10 }));
  const D10 = l10 == null ? void 0 : l10.BackgroundImage;
  const L10 = ep.useCallback(() => n10(D10.Source, D10.Value, a10), [D10 == null ? void 0 : D10.Source, D10 == null ? void 0 : D10.Value, a10, n10]);
  const H10 = __spreadValues({ backgroundImage: D10 ? L10() : "", opacity: k10 }, N10);
  const I10 = __spreadValues({ backgroundColor: d10, opacity: k10 }, N10);
  const _10 = kp(ndt, { "ar-drop-target-over": E10, "ar-drop-target-can": F10 });
  const V10 = { pointerEvents: f10 ? "all" : "none" };
  const R10 = w10.map((e15) => {
    const t11 = e15.item.$fixedPlace && !o10(e15.path);
    const n11 = { key: `${e15.item.Name}Place`, host: s10.Name, item: e15.item, path: e15.path, dataSets: u10, parentBackgroundColor: d10, theme: i10, onlyContent: p10 };
    return t11 ? tp.createElement(tdt, __spreadValues({}, n11)) : tp.createElement(N2e, __spreadValues({}, n11));
  });
  return tp.createElement("div", { className: _10, "data-path": c10, "data-type": s10.Type, style: V10, ref: p10 ? void 0 : M10 }, tp.createElement("div", { className: "bg-color", style: I10, ref: b10 }), tp.createElement("div", { className: `bg-image ${$me(D10)}`, style: H10 }), 0 !== k10 && y10 && tp.createElement(Flt, { id: `${s10.Name}-bg-grid`, key: `${s10.Name}-${S10}-${C10}-${v10}`, size: v10, roundStyle: N10 }), !p10 && f10 && tp.createElement(Ult, __spreadValues({}, e14)), R10, S10 && C10 && h10 && P10 && tp.createElement("div", { className: "ar-border", style: P10 }));
};
function odt(e14) {
  const { item: t10, path: n10, dataSets: r10, theme: o10 } = e14;
  const a10 = __spreadValues({ width: "100%", height: "100%" }, Fme(t10.Style || {}, o10, { Width: "1pt", Style: "solid", Color: "lightgray" }));
  return tp.createElement("div", { style: { height: "100%", width: "100%", position: "relative" } }, tp.createElement(rdt, { key: n10, item: t10, path: n10, dataSets: r10, theme: o10, parentBackgroundColor: Bme(t10.Style.BackgroundColor, null, o10) }), tp.createElement("div", { className: "ar-border", style: a10 }));
}
const adt = (e14) => {
  const { item: t10, theme: n10, item: { Page: r10, DataSets: o10 } } = e14;
  return tp.createElement(idt, { key: "fixedPage", report: t10, page: r10, dataSets: o10, theme: n10 });
};
const idt = (e14) => {
  const { instanceId: t10, getReport: n10, setDecorations: r10 } = ep.useContext(bqe);
  const { report: o10, page: a10, dataSets: i10, theme: s10 } = e14;
  const l10 = ep.useRef(null);
  const { userPreferences: { surface: { zoomFactor: c10 } } } = MO();
  const u10 = o10.Pages[o10.$activePageIndex];
  const d10 = `Pages.${u10.Name}`;
  const p10 = `Pages.${o10.$activePageIndex}`;
  const m10 = { marginBottom: u10.BottomMargin || a10.BottomMargin, marginLeft: u10.LeftMargin || a10.LeftMargin, marginRight: u10.RightMargin || a10.RightMargin, marginTop: u10.TopMargin || a10.TopMargin };
  const h10 = __spreadProps(__spreadValues({}, m10), { width: `calc(100% - ${L$.parse(m10.marginLeft).add(L$.parse(m10.marginRight)).css})`, height: `calc(100% - ${L$.parse(m10.marginTop).add(L$.parse(m10.marginBottom)).css})` });
  const f10 = zlt({ ref: l10.current, name: o10.Name, type: "fixedpagereport", path: p10 }, t10);
  const [, g10] = are(__spreadValues({ accept: ["resizegrip", "placeHolderResizeGrip"] }, f10));
  const [, y10] = are({ accept: ["rectselect"], drop: (e15, t11) => {
    let r11 = Plt(l10.current);
    const { scrollOffset: o11 } = e15.scrollDetector;
    r11 = { left: r11.left + o11.x, top: r11.top + o11.y };
    const a11 = Nlt(t11, c10, r11, o11);
    return Ilt(e15, a11, n10);
  }, hover: (e15, t11) => {
    let n11 = Plt(l10.current);
    const { detectScrollOffset: o11, scrollOffset: a11 } = e15.scrollDetector;
    l10.current && o11(l10.current), n11 = { left: n11.left + a11.x, top: n11.top + a11.y };
    const i11 = Nlt(t11, c10, n11, a11);
    return Hlt(i11, e15.absolutePosition, e15.item.Name, r10);
  } });
  return tp.createElement("div", { className: "is-report-area scalable", style: { width: "100%", height: "100%" }, ref: (e15) => {
    g10(e15), y10(e15);
  } }, tp.createElement("div", { className: "ar-page", style: { width: u10.Width || a10.PageWidth || "1in", height: u10.Height || a10.PageHeight || "1in" }, ref: l10 }, tp.createElement("div", { style: { width: "100%", height: "100%", pointerEvents: "none" } }, tp.createElement("div", { style: h10 }, tp.createElement(odt, { key: d10, item: u10, path: p10, dataSets: i10, theme: s10 })))));
};
const [sdt, , ldt] = Dp("ar-page");
const [cdt] = ldt("overlay");
const [udt, , ddt] = Dp("section-header");
const [pdt] = ddt("primary");
const [mdt] = ddt("hidden");
const hdt = { in: L$.parse("0.25in"), cm: L$.parse("0.5cm") };
const fdt = (e14) => L$.parse(e14);
const gdt = (e14, t10) => {
  const n10 = jN(t10)(e14);
  return L$.parseSafe(n10.$place.Height);
};
const ydt = (e14) => {
  var _a2, _b2;
  const { section: t10, theme: n10, t: r10, path: o10, dataSets: a10 } = e14;
  const i10 = Tlt(o10) || t10;
  const { Body: s10, PageHeader: l10, PageFooter: c10, Page: u10 } = i10;
  const { TopMargin: d10, BottomMargin: p10, LeftMargin: m10, RightMargin: h10, PageWidth: f10, PageHeight: g10 } = u10;
  const [y10, v10, b10, S10, C10, x10] = [fdt(d10), fdt(p10), fdt(m10), fdt(h10), fdt(f10), fdt(g10)];
  const w10 = ep.useMemo(() => s3(i10), [i10]);
  const T10 = PA();
  const E10 = ep.useContext(bqe);
  const { instanceId: F10, setDecorations: M10, getReport: k10, getSettings: P10 } = E10;
  const N10 = h9();
  const D10 = ep.useRef(null);
  const L10 = MO();
  const { lockLayout: H10, userPreferences: { surface: I10, units: _10 } } = L10;
  const { zoomFactor: V10 } = P10();
  const R10 = { name: t10.Name, path: o10, type: "Continuous", ref: D10.current };
  const [, A10] = are({ accept: ["resizeLine", "resizegrip", "rectselect"], drop: (e15, t11) => {
    if ("resizeLine" === e15.type) {
      const n11 = Wut(gdt(k10(), e15.path), e15, t11, I10);
      const r11 = zut(n11, e15);
      T10(r11);
    } else {
      if ("rectselect" === e15.type) {
        let n11 = Plt(D10.current);
        const { scrollOffset: r11 } = e15.scrollDetector;
        n11 = { left: n11.left + r11.x, top: n11.top + r11.y };
        const o11 = Nlt(t11, I10.zoomFactor, n11, r11);
        return Ilt(e15, o11, k10);
      }
      if ("resizegrip" === e15.type && t11.canDrop()) {
        const { movedItems: n11 = [], childItemNames: r11 = [], host: o11, startDndActions: a11 } = e15;
        const i11 = e2e(t11, V10, o11, n11, r11);
        const s11 = i2e(R10, i11, L10, N10);
        const l11 = [...a11 || [], ...(s11 == null ? void 0 : s11.actions) || []];
        l11.length > 0 && T10(rz(l11));
      }
    }
  }, hover: (e15, t11) => {
    if ("resizeLine" === e15.type) {
      const n11 = Wut(gdt(k10(), e15.path), e15, t11, I10);
      const r11 = zut(n11, e15);
      $ut(F10, e15.path, k10(), r11, M10);
    } else {
      if ("rectselect" === e15.type) {
        let n11 = Plt(D10.current);
        const { detectScrollOffset: r11, scrollOffset: o11 } = e15.scrollDetector;
        D10.current && r11(D10.current), n11 = { left: n11.left + o11.x, top: n11.top + o11.y };
        const a11 = Nlt(t11, I10.zoomFactor, n11, o11);
        return Hlt(a11, e15.absolutePosition, e15.item.Name, M10);
      }
      if ("resizegrip" === e15.type) {
        if (!t11.isOver({ shallow: true })) return;
        if (t11.canDrop()) {
          const { movedItems: n11 = [], childItemNames: r11 = [], host: o11 } = e15;
          const a11 = e2e(t11, V10, o11, n11, r11);
          s2e(R10, a11, L10, N10, M10);
        }
      }
    }
  }, canDrop: (e15, t11) => {
    if ("resizegrip" === e15.type) {
      if (H10) return false;
      if (!t11.isOver({ shallow: true })) return false;
    }
    if ("resizeLine" === e15.type) {
      const n11 = Wut(gdt(k10(), e15.path), e15, t11, I10);
      const r11 = zut(n11, e15);
      const a11 = [c5(o10), r11].reduce(nz.of(F10).getReducer(N10.Type), N10);
      if (!a11.ReportSections.every(Zut)) return false;
    }
    return true;
  }, collect: (e15) => ({ isDragging: e15.canDrop(), isHovering: e15.isOver(), item: e15.getItem() }) });
  const O10 = x10.subtract(y10).subtract(v10);
  const B10 = C10.subtract(b10).subtract(S10);
  const z10 = (e15) => {
    const [t11, n11, r11, o11] = "x" === e15 ? [B10, b10, (e16) => ({ left: e16 }), w10.horizontalPageNumber] : [w10.pageBodyHeight, y10.add(w10.headerHeight), (e16) => ({ top: e16 }), w10.verticalPageNumber];
    return new Array(o11).fill(null).map((o12, a11) => 0 === a11 ? o12 : ((t12, n12) => tp.createElement("div", { key: n12, className: `ar-${"x" === e15 ? "vertical" : "horizontal"}-separator`, style: r11(t12) }))(t11.multiply(a11).add(n11).css, `separator.${e15}.${a11}`));
  };
  const $10 = { width: w10.pageWidth.css, height: w10.pageHeight.css };
  const W10 = w10.sectionWidth.css;
  const j10 = { marginBottom: v10.css, marginLeft: b10.css, marginRight: S10.css, marginTop: y10.css, width: `calc(100% - ${b10.add(S10).css})`, height: `calc(100% - ${y10.add(v10).css})` };
  const Z10 = fdt((_a2 = l10 == null ? void 0 : l10.$place.Height) != null ? _a2 : `0${_10}`);
  const G10 = fdt((_b2 = c10 == null ? void 0 : c10.$place.Height) != null ? _b2 : `0${_10}`);
  const U10 = O10.subtract(Z10).subtract(G10);
  const q10 = kp(udt, (l10 == null ? void 0 : l10.$primary) ? pdt : "", !(l10 == null ? void 0 : l10.$primary) && Z10.lowerThan(hdt[_10]) ? mdt : "");
  const Y10 = kp(udt, (s10 == null ? void 0 : s10.$primary) ? pdt : "", !(s10 == null ? void 0 : s10.$primary) && U10.lowerThan(hdt[_10]) ? mdt : "");
  const K10 = kp(udt, (c10 == null ? void 0 : c10.$primary) ? pdt : "", !(c10 == null ? void 0 : c10.$primary) && G10.lowerThan(hdt[_10]) ? mdt : "");
  const X10 = q7(N10);
  return tp.createElement("div", { className: "is-report-area scalable", style: { width: "100%", height: "100%" }, ref: A10 }, tp.createElement("div", { className: sdt, style: $10, ref: D10 }, X10 && tp.createElement("div", { className: cdt }), tp.createElement("div", { style: { width: "100%", height: "100%", pointerEvents: "none" } }, tp.createElement("div", { style: j10 }, l10 && tp.createElement(tp.Fragment, null, tp.createElement("div", { key: "headerLabel", className: q10 }, r10("labels:pageHeader")), tp.createElement(ect, { key: "header", item: t10.PageHeader, path: `${o10}.PageHeader`, dataSets: a10, width: W10, height: w10.headerHeight.css, theme: n10 })), (l10 || c10) && tp.createElement("div", { key: "bodyLabel", className: Y10 }, r10("labels:body")), tp.createElement(pct, { key: "body", item: t10.Body, path: `${o10}.Body`, dataSets: a10, width: W10, height: w10.bodyHeight.css, theme: n10 }), c10 && tp.createElement(tp.Fragment, null, tp.createElement("div", { key: "footerLabel", className: K10 }, r10("labels:pageFooter")), tp.createElement(ect, { key: "footer", item: t10.PageFooter, path: `${o10}.PageFooter`, dataSets: a10, width: W10, height: w10.footerHeight.css, theme: n10 }))), z10("x").concat(z10("y")))));
};
function vdt({ item: e14, theme: t10, path: n10, dataSets: r10 }) {
  const { t: o10 } = vp();
  return tp.createElement(ydt, { section: e14, theme: t10, t: o10, path: n10, dataSets: r10 });
}
const [bdt, Sdt] = Dp("ar-ruler-guide");
const Cdt = ({ position: e14, show: t10, bold: n10 }) => {
  const { pxPerUnit: r10, vertical: o10 } = ep.useContext(Odt);
  if (t10) {
    const t11 = e14 * r10;
    const a10 = o10 ? { top: `${t11}px` } : { left: `${t11}px` };
    return tp.createElement("div", { style: a10, className: kp(bdt, { [Sdt("vertical")]: !o10, [Sdt("horizontal")]: o10, [Sdt("bold")]: n10 }) });
  }
  return null;
};
Cdt.displayName = "Guide";
const [xdt, wdt, Tdt] = Dp("ar-ruler-marker");
const [Edt] = Tdt("tick");
const [Fdt] = Tdt("tooltip");
const Mdt = (e14, t10) => t10 ? { top: `${e14}px`, left: 0, height: "16px", marginTop: "-8px" } : { left: `${e14}px`, top: 0, width: "16px", marginLeft: "-8px" };
const kdt = (e14) => {
  const { position: t10, tooltip: n10, onMarkerDown: r10, onMarkerMove: o10, onMarkerUp: a10, dataAid: i10, customCSS: s10 } = e14;
  const [l10, c10] = ep.useState(false);
  const [u10, d10] = ep.useState(false);
  const { pxPerUnit: p10, units: m10, vertical: h10 } = ep.useContext(Odt);
  const f10 = ep.useRef(null);
  const g10 = ep.useRef();
  const y10 = ep.useRef(t10);
  ep.useEffect(() => {
    "number" == typeof y10.current && (y10.current = t10);
  }, [t10]);
  const v10 = ep.useCallback((e15) => z4(E$[m10])(e15), [m10]);
  const b10 = ep.useCallback((e15) => {
    var _a2;
    if ("number" == typeof g10.current) {
      const n11 = (h10 ? e15.pageY : e15.pageX) - g10.current;
      const r11 = v10(t10 + n11 / p10);
      const [a11, i11] = (_a2 = o10 == null ? void 0 : o10(r11, e15)) != null ? _a2 : [r11, false];
      d10(i11), y10.current = a11;
    }
  }, [o10, t10, p10, v10, h10]);
  const S10 = ep.useCallback((e15) => {
    c10(false), window.removeEventListener("pointermove", b10), window.removeEventListener("pointerup", S10), document.body.classList.remove("gc-disable-selection"), g10.current = void 0, a10 == null ? void 0 : a10(y10.current, e15), d10(false);
  }, [a10, b10]);
  const C10 = ep.useCallback((e15) => {
    c10(true), r10 == null ? void 0 : r10(), window.addEventListener("pointermove", b10), window.addEventListener("pointerup", S10), document.body.classList.add("gc-disable-selection");
    const t11 = h10 ? e15.pageY : e15.pageX;
    g10.current = t11;
  }, [r10, b10, S10, h10]);
  const x10 = t10 * p10;
  const w10 = document.querySelector(`.${Zdt}`);
  const T10 = { position: t10, show: l10, bold: u10 };
  return tp.createElement("div", { onPointerDown: C10, className: kp(xdt, wdt(h10 ? "left" : "top")), ref: f10, style: Mdt(x10, h10), "data-aid": i10, "data-position": t10 }, tp.createElement("div", { className: kp(Edt, s10) }), n10 && l10 && tp.createElement("span", { className: Fdt }, n10), w10 && mE.createPortal(tp.createElement(Cdt, __spreadValues({}, T10)), w10));
};
kdt.displayName = "Marker";
const Pdt = { cm: [0.5, 1], in: [0.25, 1] };
const [Ndt, Ddt, Ldt] = Dp("ar-ruler-scale");
const [Hdt] = Ldt("ticks");
const Idt = (e14) => {
  const { start: t10, end: n10 } = e14;
  const { pxPerUnit: r10, vertical: o10, units: a10 } = ep.useContext(Odt);
  const i10 = (n10 - t10) * r10;
  const s10 = Pdt[a10][0];
  const l10 = Pdt[a10][1];
  return tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: kp(Ndt, Ddt(o10 ? "left" : "top")), width: o10 ? 18 : i10, height: o10 ? i10 : 18, viewBox: o10 ? `0 ${t10 * r10} 18 ${i10}` : `${t10 * r10} 0 ${i10} 18` }, tp.createElement("g", { transform: o10 ? "rotate(-90)" : "" }, tp.createElement("path", { className: Hdt, d: (() => {
    const e15 = [];
    const a11 = (t11) => {
      if (t11 % l10 != 0) {
        const n11 = t11 * r10 * (o10 ? -1 : 1);
        const a12 = 5;
        e15.push(`M${n11} ${a12} l0 8`);
      }
    };
    for (let e16 = 0; e16 <= n10; e16 += s10) a11(e16);
    for (let e16 = -s10; e16 >= t10; e16 -= s10) a11(e16);
    return e15.join(" ");
  })() }), (() => {
    const e15 = [];
    const a11 = (t11) => {
      e15.push(tp.createElement("text", { key: t11, x: t11 * r10 * (o10 ? -1 : 1), y: 13, textAnchor: "middle" }, z4()(Math.abs(t11))));
    };
    for (let e16 = 0; e16 <= n10; e16 += l10) a11(e16);
    for (let e16 = -l10; e16 >= t10; e16 -= l10) a11(e16);
    return e15;
  })()));
};
Idt.displayName = "Scale";
const [_dt] = Dp("ar-ruler-span");
const Vdt = ({ start: e14, end: t10, customCSS: n10 }) => {
  const { pxPerUnit: r10, vertical: o10 } = ep.useContext(Odt);
  const a10 = e14 * r10;
  const i10 = t10 * r10;
  const s10 = o10 ? { top: a10, height: i10 - a10 } : { left: a10, width: i10 - a10 };
  return tp.createElement("div", { className: kp(_dt, n10), style: s10 });
};
const [Rdt, Adt] = Dp("ar-ruler");
const Odt = ep.createContext({ pxPerUnit: 0, snapStep: 0, units: "in", vertical: false, zeroOffset: 0 });
const Bdt = ({ length: e14, spans: t10, markers: n10, units: r10, pxPerUnit: o10, snapStep: a10, zeroOffset: i10 = 0, vertical: s10 = false }) => {
  const l10 = e14 * o10;
  const c10 = { start: -i10, end: e14 - i10 };
  const u10 = ep.useMemo(() => ({ pxPerUnit: o10, snapStep: a10, units: r10, vertical: s10, zeroOffset: i10 }), [o10, a10, r10, s10, i10]);
  return tp.createElement(Odt.Provider, { value: u10 }, tp.createElement("div", { className: kp(Rdt, { [Adt("top")]: !s10, [Adt("left")]: s10 }), style: s10 ? { height: l10 } : { width: l10 } }, t10.map((e15) => tp.createElement(Vdt, __spreadProps(__spreadValues({}, e15), { key: e15.key }))), tp.createElement(Idt, __spreadValues({}, c10)), n10.map((e15) => tp.createElement(kdt, __spreadProps(__spreadValues({}, e15), { key: e15.key })))));
};
Bdt.displayName = "Ruler";
const [zdt, , $dt] = Dp("ar-rulers");
const [Wdt] = $dt("pivot");
const [jdt] = $dt("disabled");
const [Zdt] = $dt("document-container");
const [Gdt, Udt] = Dp("ar-ruler-container");
const qdt = (e14) => {
  const { children: t10, disabled: n10 = false, show: r10 = false, units: o10 = "in", zoom: a10, snapStepMap: i10 = { in: 0.25, cm: 0.5 }, verticalRuler: s10, horizontalRuler: l10 } = e14;
  const c10 = ep.useMemo(() => ({ pxPerUnit: L$.toPixels(new L$(1, o10)) * a10, snapStep: i10[o10], units: o10 }), [i10, o10, a10]);
  const u10 = __spreadValues(__spreadValues({}, c10), l10);
  const d10 = __spreadProps(__spreadValues(__spreadValues({}, c10), s10), { vertical: true });
  return tp.createElement("div", { className: kp(zdt, { [jdt]: n10 }), "data-units": o10 }, r10 && tp.createElement(tp.Fragment, null, tp.createElement("div", { className: Wdt }), tp.createElement("div", { className: kp(Gdt, Udt("top")) }, tp.createElement(Bdt, __spreadValues({}, u10))), tp.createElement("div", { className: kp(Gdt, Udt("left")) }, tp.createElement(Bdt, __spreadValues({}, d10)))), tp.createElement("div", { className: Zdt }, t10));
};
qdt.displayName = "Rulers";
const Ydt = { in: 0.05, cm: 0.1 };
const Kdt = () => {
  const { userPreferences: { rulers: { snapStep: e14 }, units: t10 } } = MO();
  return (n10) => SB(n10) ? Ydt[t10] : e14[t10];
};
const Xdt = ({ PageHeader: e14, Body: t10, PageFooter: n10 }) => {
  const r10 = e14 ? I3(e14) : L$.zero;
  const o10 = I3(t10);
  const a10 = n10 ? I3(n10) : L$.zero;
  return L$.max([r10, o10, a10]);
};
const Jdt = () => {
  const { userPreferences: { units: e14 } } = MO();
  const t10 = ep.useCallback((t11) => z4(E$[e14])(t11), [e14]);
  const n10 = ep.useCallback((n11) => t10(V$(n11, e14)), [t10, e14]);
  return { roundUnits: t10, lengthToPrettyUnits: n10 };
};
const Qdt = ({ dashboard: e14, children: t10 }) => {
  const n10 = PA();
  const { userPreferences: { units: r10, rulers: { show: o10, snapStep: a10 }, surface: { zoomFactor: i10, snapToLines: s10 } } } = MO();
  const { roundUnits: l10, lengthToPrettyUnits: c10 } = Jdt();
  const u10 = Kdt();
  const d10 = V$(qY[r10], r10);
  const p10 = e14.ReportSections[e14.$activeSectionIndex];
  const { Body: m10, Width: h10 } = p10;
  const f10 = `ReportSections.${e14.$activeSectionIndex}`;
  const g10 = ep.useCallback(() => {
    const e15 = L$.parse(h10);
    const t11 = L$.parse(m10.$place.Height);
    return { sectionWidth: c10(e15), bodyHeight: c10(t11) };
  }, [m10.$place.Height, h10, c10]);
  const [y10, v10] = ep.useState(g10());
  ep.useEffect(() => v10(g10()), [g10]);
  const b10 = (e15, t11) => {
    n10(c2({ path: f10, descriptor: BY("", "", "length", t11), value: `${l10(e15)}${r10}` }));
  };
  const S10 = c10(Xdt(p10));
  const { sectionWidth: C10, bodyHeight: x10 } = y10;
  const w10 = { key: "marker-width", dataAid: "marker-width", position: C10, tooltip: C10.toString(), onMarkerMove: (e15, t11) => {
    const n11 = e15;
    const r11 = u10(t11);
    const o11 = Math.max(d10, S10);
    const a11 = j4(n11, r11, o11, s10, Infinity, false);
    return v10(__spreadProps(__spreadValues({}, y10), { sectionWidth: a11 })), [a11, !!s10 && a11 === o11];
  }, onMarkerUp: (e15) => b10(e15, "Width") };
  const T10 = Math.max(c10(H3(m10)), d10);
  const E10 = { key: "marker-body-height", dataAid: "marker-body-height", position: x10, tooltip: x10.toString(), onMarkerMove: (e15, t11) => {
    const n11 = u10(t11);
    const r11 = j4(e15, n11, T10, s10, 1 / 0, false);
    return v10(__spreadProps(__spreadValues({}, y10), { bodyHeight: r11 })), [r11, !!s10 && r11 === T10];
  }, onMarkerUp: (e15) => b10(e15, "Body.$place.Height") };
  const F10 = { show: o10, units: r10, zoom: i10, snapStepMap: a10, horizontalRuler: { length: C10, markers: [w10], spans: [{ start: 0, end: C10, key: "span-horizontal" }] }, verticalRuler: { length: x10, markers: [E10], spans: [{ start: 0, end: x10, key: "span-vertical" }] } };
  return tp.createElement(qdt, __spreadValues({}, F10), t10);
};
const ept = { pageWidth: L$.zero, pageHeight: L$.zero, margins: { top: L$.zero, left: L$.zero, bottom: L$.zero, right: L$.zero } };
const tpt = (e14) => {
  const { instanceId: t10 } = MO();
  const { lengthToPrettyUnits: n10 } = Jdt();
  const r10 = nz.of(t10).getFeature(e14.Type, "getPageDimensions");
  return ep.useMemo(() => {
    var _a2;
    const { pageWidth: t11, visualPageWidth: o10, pageHeight: a10, visualPageHeight: i10, margins: s10, body: l10, header: c10, footer: u10 } = (_a2 = r10 == null ? void 0 : r10(e14)) != null ? _a2 : ept;
    const d10 = { pageWidth: n10(o10 != null ? o10 : t11), pageHeight: n10(i10 != null ? i10 : a10), margins: { top: n10(s10.top), bottom: n10(s10.bottom), left: n10(s10.left), right: n10(s10.right) } };
    return l10 && (d10.body = { height: n10(l10.height), visualHeight: n10(l10.visualHeight), width: n10(l10.width), visualWidth: n10(l10.visualWidth) }), c10 && (d10.header = { height: (c10 == null ? void 0 : c10.height) ? n10(c10.height) : 0 }), u10 && (d10.footer = { height: (u10 == null ? void 0 : u10.height) ? n10(u10.height) : 0 }), d10;
  }, [r10, n10, e14]);
};
const npt = (e14) => {
  var _a2, _b2;
  const { userPreferences: { units: t10, surface: { snapToLines: n10 } } } = MO();
  const { roundUnits: r10, lengthToPrettyUnits: o10 } = Jdt();
  const a10 = PA();
  const { pageHeight: i10, margins: s10, header: l10, footer: c10, body: u10 } = tpt(e14);
  const [d10, p10] = ep.useState({ header: (_a2 = l10 == null ? void 0 : l10.height) != null ? _a2 : 0, footer: (_b2 = c10 == null ? void 0 : c10.height) != null ? _b2 : 0 });
  ep.useEffect(() => {
    var _a3, _b3;
    p10({ header: (_a3 = l10 == null ? void 0 : l10.height) != null ? _a3 : 0, footer: (_b3 = c10 == null ? void 0 : c10.height) != null ? _b3 : 0 });
  }, [c10, l10]);
  const m10 = Kdt();
  const h10 = o10(qY[t10]);
  const f10 = "multisectionreport" === e14.Type && "Continuous" === e14.ReportSections[e14.$activeSectionIndex].Type;
  const g10 = () => f10 ? `ReportSections.${e14.$activeSectionIndex}` : "";
  const y10 = (e15) => {
    const n11 = r10(e15 - s10.top);
    a10(c2({ path: g10(), descriptor: BY("", "", "length", "PageHeader.$place.Height"), value: `${n11}${t10}` }));
  };
  const v10 = (e15, t11) => {
    const o11 = r10(e15 - s10.top);
    const a11 = m10(t11);
    const i11 = r10(d10.header + ((u10 == null ? void 0 : u10.height) || 0) - h10);
    const l11 = j4(o11, a11, 0, true, i11, n10);
    return p10(__spreadProps(__spreadValues({}, d10), { header: l11 })), [r10(l11 + s10.top), !!n10 && l11 === i11];
  };
  const b10 = (e15) => {
    const n11 = r10(i10 - e15 - s10.bottom);
    a10(c2({ path: g10(), descriptor: BY("", "", "length", "PageFooter.$place.Height"), value: `${n11}${t10}` }));
  };
  const S10 = (e15, t11) => {
    const o11 = r10(i10 - e15 - s10.bottom);
    const a11 = m10(t11);
    const l11 = r10(d10.footer + ((u10 == null ? void 0 : u10.height) || 0) - h10);
    const c11 = j4(o11, a11, 0, true, l11, n10);
    return p10(__spreadProps(__spreadValues({}, d10), { footer: c11 })), [r10(i10 - c11 - s10.bottom), !!n10 && c11 === l11];
  };
  const C10 = { header: void 0, footer: void 0 };
  return l10 && l10.height > 0 && (C10.header = { position: r10(d10.header + s10.top), tooltip: d10.header.toString(), onMarkerMove: v10, onMarkerUp: y10, key: "rdlx-ruler-marker--header-height", dataAid: "rdlx-ruler-marker--header-height" }), c10 && c10.height > 0 && (C10.footer = { position: r10(i10 - s10.bottom - d10.footer), tooltip: d10.footer.toString(), onMarkerMove: S10, onMarkerUp: b10, key: "rdlx-ruler-marker--footer-height", dataAid: "rdlx-ruler-marker--footer-height" }), C10;
};
const [, , rpt] = Dp("rdlx-ruler-highlight-span");
const [opt] = rpt("primary");
const [apt] = rpt("secondary");
const [ipt] = Dp("rdlx-ruler-highlight-marker");
const spt = (e14) => {
  const { userPreferences: { units: t10, surface: { snapToLines: n10 } } } = MO();
  const { roundUnits: r10, lengthToPrettyUnits: o10 } = Jdt();
  const { pageHeight: a10, pageWidth: i10, margins: s10, body: l10 } = tpt(e14);
  const [c10, u10] = ep.useState(s10);
  ep.useEffect(() => {
    u10(s10);
  }, [s10]);
  const d10 = PA();
  const p10 = () => {
    switch (e14.Type) {
      case "fixedpagereport":
        return `Pages.${e14.$activePageIndex}`;
      case "multisectionreport":
        return `ReportSections.${e14.$activeSectionIndex}.Page`;
      default:
        return "";
    }
  };
  const m10 = o10(qY[t10]);
  const h10 = ((e15) => {
    const { userPreferences: { units: t11 } } = MO();
    const { lengthToPrettyUnits: n11 } = Jdt();
    const r11 = n11(qY[t11]);
    const o11 = { top: 0, left: 0, right: r11, bottom: r11 };
    if ("fixedpagereport" !== e15.Type) return o11;
    const a11 = e15.Pages[e15.$activePageIndex].ReportItems;
    if (a11.length < 1) return o11;
    const i11 = a11.map((e16) => e16.$place);
    const s11 = L$.min(i11.map(({ Left: e16 }) => L$.parse(e16)).filter(_e));
    const l11 = L$.max(i11.map(({ Left: e16, Width: t12 }) => L$.sum([L$.parse(e16), L$.parse(t12)])).filter(_e));
    const c11 = L$.min(i11.map(({ Top: e16 }) => L$.parse(e16)).filter(_e));
    const u11 = L$.max(i11.map(({ Top: e16, Height: t12 }) => L$.sum([L$.parse(e16), L$.parse(t12)])).filter(_e));
    return { left: n11(s11), top: n11(c11), right: n11(l11), bottom: n11(u11) };
  })(e14);
  const f10 = () => ({ top: r10(a10 - (c10.bottom + h10.bottom)), bottom: r10(a10 - (c10.top + h10.bottom)), left: r10(i10 - (c10.right + h10.right)), right: r10(i10 - (c10.left + h10.right)) });
  const g10 = (t11) => {
    switch (e14.Type) {
      case "fixedpagereport":
        return f10()[t11];
      case "multisectionreport": {
        const n11 = e14.ReportSections[e14.$activeSectionIndex];
        if ("Continuous" === n11.Type) return (() => {
          var _a2, _b2;
          const e15 = (_a2 = l10 == null ? void 0 : l10.height) != null ? _a2 : 0;
          const t12 = (_b2 = l10 == null ? void 0 : l10.width) != null ? _b2 : 0;
          return { top: r10(c10.top + e15 - m10), bottom: r10(c10.bottom + e15 - m10), left: r10(c10.left + t12 - m10), right: r10(c10.right + t12 - m10) };
        })()[t11];
        if ("FixedPage" === n11.Type) return f10()[t11];
      }
    }
    throw new Error("Invalid report type");
  };
  const y10 = (e15, t11) => {
    switch (t11) {
      case "bottom":
        return r10(a10 - e15);
      case "right":
        return r10(i10 - e15);
      default:
        return e15;
    }
  };
  const v10 = (e15, t11) => {
    switch (t11) {
      case "bottom":
        return r10(a10 - e15);
      case "right":
        return r10(i10 - e15);
      default:
        return e15;
    }
  };
  const b10 = (e15, n11) => (o11) => {
    const a11 = y10(o11, e15);
    d10(c2({ path: p10(), descriptor: BY("", "", "length", n11), value: `${r10(a11)}${t10}` }));
  };
  const S10 = Kdt();
  const C10 = (e15) => (t11, r11) => {
    const o11 = y10(t11, e15);
    const a11 = S10(r11);
    const i11 = g10(e15);
    const s11 = j4(o11, a11, 0, true, i11, n10);
    return ((e16, t12) => {
      u10(__spreadProps(__spreadValues({}, c10), { [e16]: t12 }));
    })(e15, s11), [v10(s11, e15), !!n10 && s11 === i11];
  };
  return { top: { position: c10.top, tooltip: c10.top.toString(), onMarkerMove: C10("top"), onMarkerUp: b10("top", "TopMargin"), key: "rdlx-ruler-marker--margin-top", dataAid: "rdlx-ruler-marker--margin-top" }, left: { position: c10.left, tooltip: c10.left.toString(), onMarkerMove: C10("left"), onMarkerUp: b10("left", "LeftMargin"), key: "rdlx-ruler-marker--margin-left", dataAid: "rdlx-ruler-marker--margin-left" }, bottom: { position: r10(a10 - c10.bottom), tooltip: c10.bottom.toString(), onMarkerMove: C10("bottom"), onMarkerUp: b10("bottom", "BottomMargin"), key: "rdlx-ruler-marker--margin-bottom", dataAid: "rdlx-ruler-marker--margin-bottom" }, right: { position: r10(i10 - c10.right), tooltip: c10.right.toString(), onMarkerMove: C10("right"), onMarkerUp: b10("right", "RightMargin"), key: "rdlx-ruler-marker--margin-right", dataAid: "rdlx-ruler-marker--margin-right" } };
};
const lpt = ({ report: e14, children: t10 }) => {
  const { lockLayout: n10, userPreferences: { units: r10, rulers: { show: o10, snapStep: a10 }, surface: { zoomFactor: i10 } } } = MO();
  const s10 = q7(e14);
  const { roundUnits: l10 } = Jdt();
  const { pageWidth: c10, pageHeight: u10, margins: d10 } = tpt(e14);
  const p10 = spt(e14);
  const m10 = npt(e14);
  const h10 = { marginTop: p10.top, header: m10.header, footer: m10.footer, marginBottom: p10.bottom };
  const { spans: f10, markers: g10 } = ((e15, t11) => {
    var _a2;
    const { lengthToPrettyUnits: n11 } = Jdt();
    const { instanceId: r11 } = MO();
    const o11 = (e16) => Object.values(e16).filter((e17) => !!e17);
    if (!((e16) => "multisectionreport" === e16.Type && "Continuous" === e16.ReportSections[e16.$activeSectionIndex].Type)(e15)) return { spans: [], markers: o11(t11) };
    const a11 = nz.of(r11).getFeature(e15.Type, "getPageSectionsInfo");
    const i11 = (_a2 = a11 == null ? void 0 : a11(e15)) != null ? _a2 : [];
    if (i11.filter(({ offset: { height: e16 } }) => e16.value > 0).length <= 1) return { spans: [], markers: o11(t11) };
    const s11 = [];
    i11.forEach(({ container: e16, offset: { top: t12, height: r12, visualHeight: o12, visualTop: a12 } }) => {
      aj(e16) && s11.push({ start: n11(a12 != null ? a12 : t12), end: n11((a12 != null ? a12 : t12).add(o12 != null ? o12 : r12)), key: `rdlx-ruler-${e16.Name}-highlight`, customCSS: ij(e16) ? opt : apt });
    });
    const l11 = i11.find(({ path: e16 }) => e16.endsWith("PageHeader"));
    const c11 = !!l11 && l11.offset.height.value > 0;
    const u11 = i11.find(({ path: e16 }) => e16.endsWith("Body"));
    const d11 = i11.find(({ path: e16 }) => e16.endsWith("PageFooter"));
    const p11 = !!d11 && d11.offset.height.value > 0;
    const m11 = (() => {
      if (c11 && p11) {
        if (ij(l11 == null ? void 0 : l11.container)) return ["marginTop", "header"];
        if (ij(u11 == null ? void 0 : u11.container)) return ["header", "footer"];
        if (ij(d11 == null ? void 0 : d11.container)) return ["footer", "marginBottom"];
      }
      if (!c11 && p11) {
        if (ij(l11 == null ? void 0 : l11.container)) return ["marginTop"];
        if (ij(u11 == null ? void 0 : u11.container)) return ["marginTop", "footer"];
        if (ij(d11 == null ? void 0 : d11.container)) return ["footer", "marginBottom"];
      }
      if (c11 && !p11) {
        if (ij(l11 == null ? void 0 : l11.container)) return ["marginTop", "header"];
        if (ij(u11 == null ? void 0 : u11.container)) return ["header", "marginBottom"];
        if (ij(d11 == null ? void 0 : d11.container)) return ["marginBottom"];
      }
      return [];
    })();
    const h11 = AV(t11, {});
    m11.forEach((e16) => {
      const t12 = h11[e16];
      t12 && (h11[e16] = __spreadProps(__spreadValues({}, t12), { customCSS: ipt }));
    });
    const f11 = o11(h11);
    return { spans: s11, markers: f11 };
  })(e14, h10);
  const y10 = { disabled: n10 || s10, show: o10, units: r10, zoom: i10, snapStepMap: a10, horizontalRuler: { length: c10, zeroOffset: d10.left, markers: [p10.left, p10.right], spans: [{ start: d10.left, end: l10(c10 - d10.right), key: "span-horizontal" }] }, verticalRuler: { length: u10, zeroOffset: d10.top, markers: g10, spans: [{ start: d10.top, end: l10(u10 - d10.bottom), key: "span-vertical" }, ...f10] } };
  return tp.createElement(qdt, __spreadValues({}, y10), t10);
};
const cpt = (e14) => {
  const { report: t10, children: n10 } = e14;
  switch (t10.Type) {
    case "fixedpagereport":
    case "multisectionreport":
      return tp.createElement(lpt, { report: t10 }, n10);
    case "dashboard":
      return tp.createElement(Qdt, { dashboard: t10 }, n10);
    default:
      return tp.createElement(tp.Fragment, null, n10);
  }
};
const upt = /^=?(true)$/i;
const dpt = (e14) => "string" == typeof e14 ? -1 !== e14.search(upt) : !!e14;
const ppt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.accent, d: "M14.5 19c2.485 0 4.5-2.015 4.5-4.5S16.985 10 14.5 10 10 12.015 10 14.5s2.015 4.5 4.5 4.5Zm0-7c.276 0 .5.224.5.5V14h1.5c.276 0 .5.224.5.5s-.224.5-.5.5H15v1.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5V15h-1.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H14v-1.5c0-.276.224-.5.5-.5Z" }), tp.createElement("path", { className: Km.secondary, d: "M7 4c-.552 0-1 .448-1 1s.448 1 1 1h6c.552 0 1-.448 1-1s-.448-1-1-1H7Z" }), tp.createElement("path", { className: Ym.text, d: "M6 2c-1.105 0-2 .895-2 2v12c0 1.105.895 2 2 2h4.257c-.253-.307-.474-.642-.657-1H6c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1h8c.552 0 1 .448 1 1v5.022c.343.031.678.094 1 .185V4c0-1.105-.895-2-2-2H6Z" }));
const mpt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.error, d: "M19 14.5c0 2.485-2.015 4.5-4.5 4.5S10 16.985 10 14.5s2.015-4.5 4.5-4.5 4.5 2.015 4.5 4.5Zm-2.646-1.146c.195-.196.195-.512 0-.708-.196-.195-.512-.195-.708 0L14.5 13.793l-1.146-1.147c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708l1.147 1.146-1.147 1.146c-.195.196-.195.512 0 .708.196.195.512.195.708 0l1.146-1.147 1.146 1.147c.196.195.512.195.708 0 .195-.196.195-.512 0-.708L15.207 14.5l1.147-1.146Z" }), tp.createElement("path", { className: Km.secondary, d: "M7 4c-.552 0-1 .448-1 1s.448 1 1 1h6c.552 0 1-.448 1-1s-.448-1-1-1H7Z" }), tp.createElement("path", { className: Ym.text, d: "M6 2c-1.105 0-2 .895-2 2v12c0 1.105.895 2 2 2h4.257c-.253-.307-.474-.642-.657-1H6c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1h8c.552 0 1 .448 1 1v5.022c.343.031.678.094 1 .185V4c0-1.105-.895-2-2-2H6Z" }));
const hpt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.accent, d: "M14.5 10c2.485 0 4.5-2.015 4.5-4.5S16.985 1 14.5 1 10 3.015 10 5.5s2.015 4.5 4.5 4.5Zm0-7c.276 0 .5.224.5.5V5h1.5c.276 0 .5.224.5.5s-.224.5-.5.5H15v1.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5V6h-1.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H14V3.5c0-.276.224-.5.5-.5Z" }), tp.createElement("path", { className: Km.secondary, d: "M7 14c-.552 0-1 .448-1 1s.448 1 1 1h6c.552 0 1-.448 1-1s-.448-1-1-1H7Z" }), tp.createElement("path", { className: Ym.text, d: "M15 16v-5.022c.343-.031.678-.094 1-.185V16c0 1.105-.895 2-2 2H6c-1.105 0-2-.895-2-2V4c0-1.105.895-2 2-2h4.257c-.253.307-.474.642-.657 1H6c-.552 0-1 .448-1 1v12c0 .552.448 1 1 1h8c.552 0 1-.448 1-1Z" }));
const fpt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.error, d: "M19 5.5c0 2.485-2.015 4.5-4.5 4.5S10 7.985 10 5.5 12.015 1 14.5 1 19 3.015 19 5.5Zm-2.646-1.146c.195-.196.195-.512 0-.708-.196-.195-.512-.195-.708 0L14.5 4.793l-1.146-1.147c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708L13.793 5.5l-1.147 1.146c-.195.196-.195.512 0 .708.196.195.512.195.708 0L14.5 6.207l1.146 1.147c.196.195.512.195.708 0 .195-.196.195-.512 0-.708L15.207 5.5l1.147-1.146" }), tp.createElement("path", { className: Km.secondary, d: "M7 14c-.552 0-1 .448-1 1s.448 1 1 1h6c.552 0 1-.448 1-1s-.448-1-1-1H7Z" }), tp.createElement("path", { className: Ym.text, d: "M15 16v-5.022c.343-.031.678-.094 1-.185V16c0 1.105-.895 2-2 2H6c-1.105 0-2-.895-2-2V4c0-1.105.895-2 2-2h4.257c-.253.307-.474.642-.657 1H6c-.552 0-1 .448-1 1v12c0 .552.448 1 1 1h8c.552 0 1-.448 1-1Z" }));
const gpt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M12 5.5c0 .245-.177.45-.41.492L11.5 6h-4c-.276 0-.5-.224-.5-.5 0-.245.177-.45.41-.492L7.5 5h4c.276 0 .5.224.5.5ZM12 9c0 .245-.177.45-.41.492l-.09.008h-4c-.276 0-.5-.224-.5-.5 0-.245.177-.45.41-.492L7.5 8.5h4c.276 0 .5.224.5.5Zm0 3.5c0 .245-.177.45-.41.492L11.5 13h-4c-.276 0-.5-.224-.5-.5 0-.245.177-.45.41-.492L7.5 12h4c.276 0 .5.224.5.5ZM6 2c-1.036 0-1.887.787-1.99 1.796C4.004 3.863 4 3.931 4 4v10c0 1.105.895 2 2 2h7c1.105 0 2-.895 2-2V4c0-1.105-.895-2-2-2H6ZM5 14V4c0-.037.002-.074.006-.111C5.061 3.389 5.485 3 6 3h7c.552 0 1 .448 1 1v10c0 .552-.448 1-1 1H6c-.552 0-1-.448-1-1Z" }), tp.createElement("path", { className: Km.accent, d: "M16 8c.552 0 1 .448 1 1v5.061C17 16.236 15.236 18 13.061 18H7c-.552 0-1-.448-1-1h7c1.657 0 3-1.343 3-3V8Z" }));
const ypt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M14 2H6c-1.105 0-2 .895-2 2v12c0 1.105.895 2 2 2h4.257c-.253-.307-.474-.642-.657-1H6c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1h8c.552 0 1 .448 1 1v5.022c.343.031.678.094 1 .185V4c0-1.105-.895-2-2-2Zm-1 4.5c0 .245-.177.45-.41.492L12.5 7h-5c-.276 0-.5-.224-.5-.5 0-.245.177-.45.41-.492L7.5 6h5c.276 0 .5.224.5.5ZM7.5 10h3.837c-.403.284-.767.621-1.08 1H7.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5Z" }), tp.createElement("path", { className: Km.accent, d: "M14.5 19c2.485 0 4.5-2.015 4.5-4.5S16.985 10 14.5 10 10 12.015 10 14.5s2.015 4.5 4.5 4.5Zm0-7c.276 0 .5.224.5.5V14h1.5c.276 0 .5.224.5.5s-.224.5-.5.5H15v1.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5V15h-1.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H14v-1.5c0-.276.224-.5.5-.5Z" }));
const vpt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M14 2H6c-1.105 0-2 .895-2 2v12c0 1.105.895 2 2 2h4.257c-.253-.307-.474-.642-.657-1H6c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1h8c.552 0 1 .448 1 1v5.022c.343.031.678.094 1 .185V4c0-1.105-.895-2-2-2Zm-1 4.5c0 .245-.177.45-.41.492L12.5 7h-5c-.276 0-.5-.224-.5-.5 0-.245.177-.45.41-.492L7.5 6h5c.276 0 .5.224.5.5ZM7.5 10h3.837c-.403.284-.767.621-1.08 1H7.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5Z" }), tp.createElement("path", { className: Km.error, d: "M19 14.5c0 2.485-2.015 4.5-4.5 4.5S10 16.985 10 14.5s2.015-4.5 4.5-4.5 4.5 2.015 4.5 4.5Zm-2.646-1.146c.195-.196.195-.512 0-.708-.196-.195-.512-.195-.708 0L14.5 13.793l-1.146-1.147c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708l1.147 1.146-1.147 1.146c-.195.196-.195.512 0 .708.196.195.512.195.708 0l1.146-1.147 1.146 1.147c.196.195.512.195.708 0 .195-.196.195-.512 0-.708L15.207 14.5l1.147-1.146Z" }));
const bpt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M10.259 18h-3.32C4.764 18 3 16.236 3 14.061V9c0-.552.448-1 1-1v6c0 1.657 1.343 3 3 3h2.601c.183.358.404.693.658 1Zm-1.052-2H7c-1.105 0-2-.895-2-2V4c0-1.105.895-2 2-2h7c1.036 0 1.887.787 1.99 1.796.007.067.01.135.01.204v5.207c-.322-.091-.657-.154-1-.185V4c0-.037-.002-.074-.006-.111C14.939 3.389 14.515 3 14 3H7c-.552 0-1 .448-1 1v10c0 .552.448 1 1 1h2.022c.031.343.094.678.185 1Zm0-3H8.5l-.09-.008C8.177 12.95 8 12.745 8 12.5c0-.276.224-.5.5-.5h1.101c-.163.317-.295.651-.394 1Zm3-3.5H8.5l-.09-.008C8.177 9.45 8 9.245 8 9c0-.276.224-.5.5-.5h4l.09.008c.233.042.41.247.41.492 0 .08-.019.155-.052.222-.255.075-.503.168-.741.278ZM8 5.5c0-.276.224-.5.5-.5h4l.09.008c.233.042.41.247.41.492 0 .276-.224.5-.5.5h-4l-.09-.008C8.177 5.95 8 5.745 8 5.5Z" }), tp.createElement("path", { className: Km.accent, d: "M14.5 10c2.485 0 4.5 2.015 4.5 4.5S16.985 19 14.5 19 10 16.985 10 14.5s2.015-4.5 4.5-4.5Zm2.353 4.854.003-.003c.047-.047.082-.101.106-.16.024-.058.038-.121.038-.188v-.006c0-.067-.014-.13-.038-.188-.024-.059-.061-.115-.108-.163l-2-2c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708L15.293 14H12.5c-.276 0-.5.224-.5.5s.224.5.5.5h2.793l-1.147 1.146c-.195.196-.195.512 0 .708.196.195.512.195.708 0l1.999-2Z" }));
const Spt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M14 2H6c-1.105 0-2 .895-2 2v12c0 1.105.895 2 2 2h4.257c-.253-.307-.474-.642-.657-1H6c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1h8c.552 0 1 .448 1 1v5.022c.343.031.678.094 1 .185V4c0-1.105-.895-2-2-2Zm-1 4.5c0 .245-.177.45-.41.492L12.5 7h-5c-.276 0-.5-.224-.5-.5 0-.245.177-.45.41-.492L7.5 6h5c.276 0 .5.224.5.5ZM7.5 10h3.837c-.403.284-.767.621-1.08 1H7.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5Z" }), tp.createElement("path", { className: Km.accent, d: "M14.5 10c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.015-4.5-4.5-4.5Zm-2.353 4.854-.003-.003c-.047-.047-.082-.101-.106-.16-.024-.058-.038-.121-.038-.188v-.006c0-.067.014-.13.038-.188.024-.059.061-.115.108-.163l2-2c.196-.195.512-.195.708 0 .195.196.195.512 0 .708L13.707 14H16.5c.276 0 .5.224.5.5s-.224.5-.5.5h-2.793l1.147 1.146c.195.196.195.512 0 .708-.196.195-.512.195-.708 0l-1.999-2Z" }));
const Cpt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M14 2H6c-1.105 0-2 .895-2 2v12c0 1.105.895 2 2 2h4.257c-.253-.307-.474-.642-.657-1H6c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1h8c.552 0 1 .448 1 1v5.022c.343.031.678.094 1 .185V4c0-1.105-.895-2-2-2Zm-1 4.5c0 .245-.177.45-.41.492L12.5 7h-5c-.276 0-.5-.224-.5-.5 0-.245.177-.45.41-.492L7.5 6h5c.276 0 .5.224.5.5ZM7.5 10h3.837c-.403.284-.767.621-1.08 1H7.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5Z" }), tp.createElement("path", { className: Km.accent, d: "M14.5 10c2.485 0 4.5 2.015 4.5 4.5S16.985 19 14.5 19 10 16.985 10 14.5s2.015-4.5 4.5-4.5Zm2.353 4.854.003-.003c.047-.047.082-.101.106-.16.024-.058.038-.121.038-.188v-.006c0-.067-.014-.13-.038-.188-.024-.059-.061-.115-.108-.163l-2-2c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708L15.293 14H12.5c-.276 0-.5.224-.5.5s.224.5.5.5h2.793l-1.147 1.146c-.195.196-.195.512 0 .708.196.195.512.195.708 0l1.999-2Z" }));
const xpt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd" }, tp.createElement("path", { className: Ym.text, d: "M7.502 2c.275 0 .498.223.498.498v.004C8 2.777 7.777 3 7.502 3H6c-.552 0-1 .448-1 1v1.502C5 5.777 4.777 6 4.502 6h-.004C4.223 6 4 5.777 4 5.502V4c0-1.105.895-2 2-2h1.502ZM4 7.498C4 7.223 4.223 7 4.498 7h.004c.275 0 .498.223.498.498v1.004C5 8.777 4.777 9 4.502 9h-.004C4.223 9 4 8.777 4 8.502V7.498Zm0 4c0-.275.223-.498.498-.498h.004c.275 0 .498.223.498.498v1.004c0 .275-.223.498-.498.498h-.004C4.223 13 4 12.777 4 12.502v-1.004Zm0 3c0-.275.223-.498.498-.498h.004c.275 0 .498.223.498.498V16c0 .552.448 1 1 1h1.502c.275 0 .498.223.498.498v.004c0 .275-.223.498-.498.498H6c-1.105 0-2-.895-2-2v-1.502ZM9.498 18C9.223 18 9 17.777 9 17.502v-.004c0-.275.223-.498.498-.498H9.6c.183.358.404.693.657 1h-.759ZM16 8.502c0 .275-.223.498-.498.498h-.004C15.223 9 15 8.777 15 8.502V7.498c0-.275.223-.498.498-.498h.004c.275 0 .498.223.498.498v1.004Zm0-3c0 .275-.223.498-.498.498h-.004C15.223 6 15 5.777 15 5.502V4c0-.552-.448-1-1-1h-1.502C12.223 3 12 2.777 12 2.502v-.004c0-.275.223-.498.498-.498H14c1.105 0 2 .895 2 2v1.502ZM10.502 2c.275 0 .498.223.498.498v.004c0 .275-.223.498-.498.498H9.498C9.223 3 9 2.777 9 2.502v-.004C9 2.223 9.223 2 9.498 2h1.004Zm2.088 4.992L12.5 7h-5c-.276 0-.5-.224-.5-.5 0-.245.177-.45.41-.492L7.5 6h5c.276 0 .5.224.5.5 0 .245-.177.45-.41.492ZM7.5 10h5c.276 0 .5.224.5.5s-.224.5-.5.5h-5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5Z" }), tp.createElement("path", { className: Km.accent, d: "M10 15.5c0-1.182 1.736-3.5 4.5-3.5 2.761 0 4.5 2.3 4.5 3.5 0 1.182-1.739 3.5-4.5 3.5S10 16.7 10 15.5Zm3.111 2.079c.411.274.895.421 1.389.421.663 0 1.299-.263 1.768-.732.469-.469.732-1.105.732-1.768 0-.494-.147-.978-.421-1.389-.275-.411-.665-.731-1.122-.921-.457-.189-.96-.238-1.445-.142-.485.097-.93.335-1.28.684-.349.35-.587.795-.684 1.28-.096.485-.047.988.142 1.445.19.457.51.847.921 1.122Zm2.636-1.246c.165-.246.253-.536.253-.833 0-.398-.158-.779-.439-1.061-.282-.281-.663-.439-1.061-.439-.297 0-.587.088-.833.253-.247.165-.439.399-.553.673-.113.274-.143.576-.085.867.058.291.201.558.41.768.21.209.477.352.768.41.291.058.593.028.867-.085.274-.114.508-.306.673-.553Z" }));
tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M6 2c-1.036 0-1.887.787-1.99 1.796C4.004 3.863 4 3.931 4 4v10c0 1.105.895 2 2 2h7c1.105 0 2-.895 2-2V4c0-1.105-.895-2-2-2H6ZM5 14V4c0-.037.002-.074.006-.111C5.061 3.389 5.485 3 6 3h7c.552 0 1 .448 1 1v10c0 .552-.448 1-1 1H6c-.552 0-1-.448-1-1Z" }), tp.createElement("path", { className: Km.accent, d: "M16 8c.552 0 1 .448 1 1v5.061C17 16.236 15.236 18 13.061 18H7c-.552 0-1-.448-1-1h7c1.657 0 3-1.343 3-3V8Z" }));
const wpt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M14 2H6c-1.105 0-2 .895-2 2v12c0 1.105.895 2 2 2h4.257c-.253-.307-.474-.642-.657-1H6c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1h8c.552 0 1 .448 1 1v5.022c.343.031.678.094 1 .185V4c0-1.105-.895-2-2-2Z" }), tp.createElement("path", { className: Km.accent, d: "M14.5 19c2.485 0 4.5-2.015 4.5-4.5S16.985 10 14.5 10 10 12.015 10 14.5s2.015 4.5 4.5 4.5Zm0-7c.276 0 .5.224.5.5V14h1.5c.276 0 .5.224.5.5s-.224.5-.5.5H15v1.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5V15h-1.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H14v-1.5c0-.276.224-.5.5-.5Z" }));
const Tpt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M5 16c0 .552.448 1 1 1h3.6c.183.358.404.693.657 1H6c-1.105 0-2-.895-2-2v-1.5c0-.276.224-.5.5-.5s.5.224.5.5V16ZM4 5.5V4c0-1.105.895-2 2-2h8c1.105 0 2 .895 2 2v1.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5V4c0-.552-.448-1-1-1H6c-.552 0-1 .448-1 1v1.5c0 .276-.224.5-.5.5S4 5.776 4 5.5Zm1 6v1c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-1c0-.276.224-.5.5-.5s.5.224.5.5Zm0-4v1c0 .276-.224.5-.5.5S4 8.776 4 8.5v-1c0-.276.224-.5.5-.5s.5.224.5.5Zm11 0v1c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-1c0-.276.224-.5.5-.5s.5.224.5.5Z" }), tp.createElement("path", { className: Km.accent, d: "M14.5 19c2.485 0 4.5-2.015 4.5-4.5S16.985 10 14.5 10 10 12.015 10 14.5s2.015 4.5 4.5 4.5Zm0-7c.276 0 .5.224.5.5V14h1.5c.276 0 .5.224.5.5s-.224.5-.5.5H15v1.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5V15h-1.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H14v-1.5c0-.276.224-.5.5-.5Z" }));
const Ept = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M14 2H6c-1.105 0-2 .895-2 2v12c0 1.105.895 2 2 2h4.257c-.253-.307-.474-.642-.657-1H6c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1h8c.552 0 1 .448 1 1v5.022c.343.031.678.094 1 .185V4c0-1.105-.895-2-2-2Z" }), tp.createElement("path", { className: Km.error, d: "M19 14.5c0 2.485-2.015 4.5-4.5 4.5S10 16.985 10 14.5s2.015-4.5 4.5-4.5 4.5 2.015 4.5 4.5Zm-2.646-1.146c.195-.196.195-.512 0-.708-.196-.195-.512-.195-.708 0L14.5 13.793l-1.146-1.147c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708l1.147 1.146-1.147 1.146c-.195.196-.195.512 0 .708.196.195.512.195.708 0l1.146-1.147 1.146 1.147c.196.195.512.195.708 0 .195-.196.195-.512 0-.708L15.207 14.5l1.147-1.146Z" }));
const Fpt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd" }, tp.createElement("path", { className: Ym.text, d: "M10.259 18h-3.32C4.764 18 3 16.236 3 14.061V9c0-.552.448-1 1-1v6c0 1.657 1.343 3 3 3h2.601c.183.358.404.693.658 1Zm-1.052-2H7c-1.105 0-2-.895-2-2V4c0-1.105.895-2 2-2h7c1.036 0 1.887.787 1.99 1.796.007.067.01.135.01.204v5.207c-.322-.091-.657-.154-1-.185V4c0-.037-.002-.074-.006-.111C14.939 3.389 14.515 3 14 3H7c-.552 0-1 .448-1 1v10c0 .552.448 1 1 1h2.022c.031.343.094.678.185 1Z" }), tp.createElement("path", { className: Km.accent, d: "M19 14.5c0 2.485-2.015 4.5-4.5 4.5S10 16.985 10 14.5s2.015-4.5 4.5-4.5 4.5 2.015 4.5 4.5Zm-4.146-2.354 1.999 2 .003.003c.047.047.082.102.106.16.024.058.038.121.038.188v.006c0 .067-.014.13-.038.188-.024.059-.061.115-.108.163l-2 2c-.196.195-.512.195-.708 0-.195-.196-.195-.512 0-.708L15.293 15H12.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h2.793l-1.147-1.146c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0Z" }));
const Mpt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd" }, tp.createElement("path", { className: Ym.text, d: "M14 2H6c-1.105 0-2 .895-2 2v12c0 1.105.895 2 2 2h4.257c-.253-.307-.474-.642-.657-1H6c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1h8c.552 0 1 .448 1 1v5.022c.343.031.678.094 1 .185V4c0-1.105-.895-2-2-2Z" }), tp.createElement("path", { className: Km.accent, d: "M10 14.5c0 2.485 2.015 4.5 4.5 4.5s4.5-2.015 4.5-4.5-2.015-4.5-4.5-4.5-4.5 2.015-4.5 4.5Zm4.146-2.354-1.999 2-.003.003c-.047.047-.082.102-.106.16-.024.058-.038.121-.038.188v.006c0 .067.014.13.038.188.024.059.061.115.108.163l2 2c.196.195.512.195.708 0 .195-.196.195-.512 0-.708L13.707 15H16.5c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-2.793l1.147-1.146c.195-.196.195-.512 0-.708-.196-.195-.512-.195-.708 0Z" }));
const kpt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd" }, tp.createElement("path", { className: Ym.text, d: "M14 2H6c-1.105 0-2 .895-2 2v12c0 1.105.895 2 2 2h4.257c-.253-.307-.474-.642-.657-1H6c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1h8c.552 0 1 .448 1 1v5.022c.343.031.678.094 1 .185V4c0-1.105-.895-2-2-2Z" }), tp.createElement("path", { className: Km.accent, d: "M19 14.5c0 2.485-2.015 4.5-4.5 4.5S10 16.985 10 14.5s2.015-4.5 4.5-4.5 4.5 2.015 4.5 4.5Zm-4.146-2.354 1.999 2 .003.003c.047.047.082.102.106.16.024.058.038.121.038.188v.006c0 .067-.014.13-.038.188-.024.059-.061.115-.108.163l-2 2c-.196.195-.512.195-.708 0-.195-.196-.195-.512 0-.708L15.293 15H12.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h2.793l-1.147-1.146c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0Z" }));
const Ppt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", clipRule: "evenodd" }, tp.createElement("path", { className: Ym.text, d: "M7.502 2c.275 0 .498.223.498.498v.004C8 2.777 7.777 3 7.502 3H6c-.552 0-1 .448-1 1v1.502C5 5.777 4.777 6 4.502 6h-.004C4.223 6 4 5.777 4 5.502V4c0-1.105.895-2 2-2h1.502ZM4 7.498C4 7.223 4.223 7 4.498 7h.004c.275 0 .498.223.498.498v1.004C5 8.777 4.777 9 4.502 9h-.004C4.223 9 4 8.777 4 8.502V7.498Zm0 4c0-.275.223-.498.498-.498h.004c.275 0 .498.223.498.498v1.004c0 .275-.223.498-.498.498h-.004C4.223 13 4 12.777 4 12.502v-1.004Zm0 3c0-.275.223-.498.498-.498h.004c.275 0 .498.223.498.498V16c0 .552.448 1 1 1h1.502c.275 0 .498.223.498.498v.004c0 .275-.223.498-.498.498H6c-1.105 0-2-.895-2-2v-1.502ZM9.498 18C9.223 18 9 17.777 9 17.502v-.004c0-.275.223-.498.498-.498H9.6c.183.358.404.693.657 1h-.759ZM16 8.502c0 .275-.223.498-.498.498h-.004C15.223 9 15 8.777 15 8.502V7.498c0-.275.223-.498.498-.498h.004c.275 0 .498.223.498.498v1.004Zm0-3c0 .275-.223.498-.498.498h-.004C15.223 6 15 5.777 15 5.502V4c0-.552-.448-1-1-1h-1.502C12.223 3 12 2.777 12 2.502v-.004c0-.275.223-.498.498-.498H14c1.105 0 2 .895 2 2v1.502ZM10.502 2c.275 0 .498.223.498.498v.004c0 .275-.223.498-.498.498H9.498C9.223 3 9 2.777 9 2.502v-.004C9 2.223 9.223 2 9.498 2h1.004Z" }), tp.createElement("path", { className: Km.accent, fillRule: "nonzero", d: "M10 15.5c0-1.182 1.736-3.5 4.5-3.5 2.761 0 4.5 2.3 4.5 3.5 0 1.182-1.739 3.5-4.5 3.5S10 16.7 10 15.5Zm3.111 2.079c.411.274.895.421 1.389.421.663 0 1.299-.263 1.768-.732.469-.469.732-1.105.732-1.768 0-.495-.147-.978-.421-1.389-.275-.411-.665-.732-1.122-.921-.457-.189-.96-.238-1.445-.142-.485.096-.93.335-1.28.684-.349.35-.588.795-.684 1.28-.096.485-.047.988.142 1.445.19.456.51.847.921 1.122Zm2.636-1.246c.165-.246.253-.536.253-.833 0-.398-.158-.779-.439-1.061-.282-.281-.663-.439-1.061-.439-.297 0-.587.088-.833.253-.247.165-.439.399-.553.673-.113.274-.143.576-.085.867.058.291.201.558.41.768.21.209.477.352.768.41.291.058.593.028.867-.085.274-.114.508-.306.673-.553Z" }));
const Npt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.accent, d: "M10 15H6v4h3c.552 0 1-.448 1-1v-3Z" }), tp.createElement("path", { className: Km.accent, opacity: "0.62", d: "M10 12c0-.552-.448-1-1-1H6v4h4v-3Z" }), tp.createElement("path", { className: Km.secondary, opacity: "0.62", d: "M6 15H2v3c0 .552.448 1 1 1h3v-4Z" }), tp.createElement("path", { className: Km.secondary, d: "M6 11H3c-.552 0-1 .448-1 1v3h4v-4Z" }), tp.createElement("path", { className: Ym.text, d: "M4 10V4c0-1.105.895-2 2-2h4.586c.398 0 .779.158 1.06.439l3.915 3.915c.281.281.439.662.439 1.06V16c0 1.105-.895 2-2 2h-3v-1h3c.552 0 1-.448 1-1V8h-3.5c-.828 0-1.5-.672-1.5-1.5V3H6c-.552 0-1 .448-1 1v6H4Zm7.5-3h3.293L11 3.207V6.5c0 .276.224.5.5.5Z" }));
tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.secondary, opacity: "0.38", d: "M10.978 15a5.496 5.496 0 0 0-2.317-5H15v5h-4.022Z" }), tp.createElement("path", { className: Km.secondary, d: "M9.589 10.823 10 10h1l-.812 1.624a5.588 5.588 0 0 0-.599-.801Zm1.274 2.452L12.5 10h1L11 15h-.022a5.495 5.495 0 0 0-.115-1.725ZM16 10l-2.5 5h-1l2.5-5h1Z" }), tp.createElement("path", { className: Ym.text, d: "M6 2a2 2 0 0 0-2 2v5.207a5.5 5.5 0 0 1 1-.185V4a1 1 0 0 1 1-1h4v3.5A1.5 1.5 0 0 0 11.5 8H15v8a1 1 0 0 1-1 1h-3.6a5.533 5.533 0 0 1-.657 1H14a2 2 0 0 0 2-2V7.414c0-.398-.158-.779-.439-1.06l-3.915-3.915A1.499 1.499 0 0 0 10.586 2H6Zm8.793 5H11.5a.5.5 0 0 1-.5-.5V3.207L14.793 7Z" }), tp.createElement("path", { fillRule: "evenodd", className: Km.accent, d: "M5.5 19a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9ZM7 12a.5.5 0 0 1 1 0v1.5a.5.5 0 0 1-.5.5H6a.5.5 0 0 1 0-1h.468a2.017 2.017 0 0 0-.933-.25 2.003 2.003 0 0 0-1.449.586.5.5 0 0 1-.707-.707A2.995 2.995 0 0 1 7 12.152V12Zm-1.552 5.25a2.995 2.995 0 0 0 2.173-.879.5.5 0 0 0-.707-.707 1.99 1.99 0 0 1-1.449.586 2.017 2.017 0 0 1-.933-.25H5a.5.5 0 0 0 0-1H3.5a.5.5 0 0 0-.5.5V17a.5.5 0 0 0 1 0v-.152a3.032 3.032 0 0 0 1.448.402Z" }));
const Dpt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.secondary, opacity: "0.38", d: "M10.978 15a5.496 5.496 0 0 0-2.317-5H15v5h-4.022Z" }), tp.createElement("path", { className: Km.secondary, d: "M9.589 10.823 10 10h1l-.812 1.624a5.588 5.588 0 0 0-.599-.801Zm1.274 2.452L12.5 10h1L11 15h-.022a5.495 5.495 0 0 0-.115-1.725ZM16 10l-2.5 5h-1l2.5-5h1Z" }), tp.createElement("path", { className: Ym.text, d: "M6 2a2 2 0 0 0-2 2v5.207a5.5 5.5 0 0 1 1-.185V4a1 1 0 0 1 1-1h4v3.5A1.5 1.5 0 0 0 11.5 8H15v8a1 1 0 0 1-1 1h-3.6a5.533 5.533 0 0 1-.657 1H14a2 2 0 0 0 2-2V7.414c0-.398-.158-.779-.439-1.06l-3.915-3.915A1.499 1.499 0 0 0 10.586 2H6Zm8.793 5H11.5a.5.5 0 0 1-.5-.5V3.207L14.793 7Z" }), tp.createElement("path", { className: Km.accent, d: "M5.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm.354-2.146a.502.502 0 0 1-.708-.708L6.293 15H3.5a.5.5 0 0 1 0-1h2.793l-1.147-1.146a.502.502 0 0 1 .708-.708l2 2a.51.51 0 0 1 .146.351v.006a.49.49 0 0 1-.144.348l-.003.003-1.999 2Z" }));
const Lpt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.secondary, opacity: "0.38", d: "M10.978 15a5.496 5.496 0 0 0-2.317-5H15v5h-4.022Z" }), tp.createElement("path", { className: Km.secondary, d: "M9.589 10.823 10 10h1l-.812 1.624a5.588 5.588 0 0 0-.599-.801Zm1.274 2.452L12.5 10h1L11 15h-.022a5.495 5.495 0 0 0-.115-1.725ZM16 10l-2.5 5h-1l2.5-5h1Z" }), tp.createElement("path", { className: Ym.text, d: "M6 2a2 2 0 0 0-2 2v5.207a5.5 5.5 0 0 1 1-.185V4a1 1 0 0 1 1-1h4v3.5A1.5 1.5 0 0 0 11.5 8H15v8a1 1 0 0 1-1 1h-3.6a5.533 5.533 0 0 1-.657 1H14a2 2 0 0 0 2-2V7.414c0-.398-.158-.779-.439-1.06l-3.915-3.915A1.499 1.499 0 0 0 10.586 2H6Zm8.793 5H11.5a.5.5 0 0 1-.5-.5V3.207L14.793 7Z" }), tp.createElement("path", { className: Km.accent, d: "M10 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14H3.5a.5.5 0 0 0 0 1H5v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H6v-1.5Z" }));
const Hpt = _V("REPORT/ADD_PAGE");
const Ipt = _V("REPORT/DELETE_PAGE", ({ page: e14 }) => ({ page: e14 }));
const _pt = _V("REPORT/MOVE_PAGE", ({ fromIndex: e14, toIndex: t10 }) => ({ fromIndex: e14, toIndex: t10 }));
const Vpt = _V("REPORT/INSERT_PAGE", ({ index: e14 }) => ({ index: e14 }));
const Rpt = _V("REPORT/DUPLICATE_PAGE", ({ index: e14 }) => ({ index: e14 }));
const Apt = _V("REPORT/TOGGLE_PAGE", ({ index: e14 }) => ({ index: e14 }));
const [Opt, Bpt, zpt] = Dp("rdlx-tab");
const [$pt] = zpt("name");
const [Wpt] = zpt("indicator");
const jpt = ({ item: { name: e14, selected: t10, hidden: n10 }, indicatorRef: r10, scrollRef: o10, index: a10, icons: i10, onNavigate: s10, onMoveLeft: l10, onMoveRight: c10, onMove: u10, onInsert: d10, onDuplicate: p10, onToggle: m10, onDelete: h10 }) => {
  const { API: f10 } = ep.useContext(Sm);
  const { t: g10 } = vp("components");
  const y10 = ep.useRef(null);
  const v10 = h9();
  const { isDragging: b10 } = ((e15, t11, n11) => {
    const r11 = ep.useRef(null);
    const { scrollRef: o11, beginAction: a11, endAction: i11 } = n11 || {};
    const s11 = (e16, t12) => {
      var _a2, _b2;
      return [...((_b2 = (_a2 = e16 == null ? void 0 : e16.current) == null ? void 0 : _a2.parentElement) == null ? void 0 : _b2.children) || []].filter((e17) => e17.classList.contains("rdlx-tab")).map((e17, t13) => {
        const n12 = e17.getBoundingClientRect();
        return { element: e17, index: t13, dimension: { start: n12.left, end: n12.left + n12.width } };
      }).filter((e17) => e17.index !== t12).map((e17, t13, n12) => __spreadProps(__spreadValues({}, e17), { isFirst: !t13, isLast: t13 === n12.length - 1 }));
    };
    const l11 = (n12, a12) => {
      var _a2, _b2, _c2, _d2, _e2;
      if (!e15.current) return;
      const i12 = a12.getDifferenceFromInitialOffset();
      const l12 = a12.getClientOffset();
      const c12 = a12.getInitialSourceClientOffset();
      const u12 = e15.current.getBoundingClientRect();
      const d12 = (_b2 = (_a2 = e15.current) == null ? void 0 : _a2.parentElement) == null ? void 0 : _b2.getBoundingClientRect();
      if (!(l12 && i12 && c12 && d12)) return;
      const p11 = s11(e15, t11);
      const m11 = () => {
        p11.forEach((e16) => {
          e16.element.style.margin = "0";
        });
      };
      const h11 = c12.x - d12.left + i12.x;
      if (n12.parentWidth && h11 > n12.parentWidth) return r11.current = { index: p11.length, isLast: true, direction: "Right", lastDeltaX: i12.x }, void m11();
      if (h11 < 0) return;
      if (e15.current.style.transform = `translateX(${h11}px)`, o11) {
        const e16 = (_c2 = o11.current) == null ? void 0 : _c2.getBaseRef();
        if (e16) {
          const t12 = e16.viewScrollLeft > 0;
          const n13 = 10;
          if (l12.x > d12.width || t12) {
            if (l12.x > d12.width) return e16.scrollLeft(t12 ? e16.viewScrollLeft + n13 : d12.width), void m11();
            if (l12.x - u12.width < e16.viewScrollLeft - Math.abs(d12.left) + u12.width) return e16.scrollLeft(e16.viewScrollLeft - n13), void m11();
          }
        }
      }
      const f11 = ((e16, t12) => e16.find((e17) => {
        const { start: n13, end: r12 } = e17.dimension;
        return t12 >= n13 && t12 <= r12;
      }))(p11, l12.x);
      if (!f11) return;
      const g11 = (y11 = i12.x) > (v11 = (_e2 = (_d2 = r11.current) == null ? void 0 : _d2.lastDeltaX) != null ? _e2 : 0) ? "Right" : y11 < v11 ? "Left" : void 0;
      var y11, v11;
      g11 && (m11(), f11.element.style.margin = `0 ${"Right" === g11 ? `${u12.width}px` : 0} 0 ${"Left" === g11 ? `${u12.width}px` : 0}`, r11.current = __spreadProps(__spreadValues({}, f11), { direction: g11, lastDeltaX: i12.x }));
    };
    const [{ isDragging: c11 }, u11, d11] = Yne({ item: { type: "rdlxTab" }, collect: (e16) => ({ isDragging: e16.isDragging() }), begin: () => {
      if (!e15.current) return;
      s11(e15).forEach((e16) => {
        e16.element.classList.remove(Bpt("selected"));
      });
      const t12 = ((e16) => {
        var _a2;
        const t13 = (_a2 = e16.current) == null ? void 0 : _a2.parentElement;
        if (!t13) return 0;
        const { children: n12 } = t13;
        return [...n12].reduce((e17, t14) => e17 + (t14.classList.contains("rdlx-tab") ? t14.clientWidth : 0), 0);
      })(e15);
      return a11 == null ? void 0 : a11(), { type: "rdlxTab", parentWidth: t12, moveTab: l11 };
    }, end: (t12, n12) => {
      var _a2, _b2;
      if (!e15.current) return;
      if (s11(e15).forEach((e16) => {
        e16.element.style.margin = "0";
      }), e15.current.style.transform = "", ((_a2 = r11.current) == null ? void 0 : _a2.isLast) && (t12 == null ? void 0 : t12.parentWidth)) {
        const e16 = (_b2 = o11 == null ? void 0 : o11.current) == null ? void 0 : _b2.getBaseRef();
        e16 == null ? void 0 : e16.scrollLeft(t12.parentWidth);
      }
      if (!r11.current) return;
      const a12 = ((e16) => {
        const { index: t13, direction: n13, isFirst: r12, lastDeltaX: o12 } = e16;
        return r12 && "Left" === n13 && 0 !== t13 ? t13 - 1 : r12 && "Right" === n13 && 0 === t13 || o12 && o12 < 0 && "Right" === n13 ? t13 + 1 : o12 && o12 > 0 && "Left" === n13 ? t13 - 1 : t13;
      })(r11.current);
      i11 == null ? void 0 : i11(a12, t12, n12);
    } });
    return ep.useEffect(() => {
      d11(Coe(), { captureDraggingState: false });
    }, [d11]), s11(e15).length > 1 && u11(e15), { isDragging: c11 };
  })(y10, a10, { scrollRef: o10, beginAction: () => {
    (r10 == null ? void 0 : r10.current) && r10.current.classList.add(Bpt("hide"));
  }, endAction: (e15) => {
    (r10 == null ? void 0 : r10.current) && r10.current.classList.remove(Bpt("hide")), a10 !== e15 ? u10 == null ? void 0 : u10(a10, e15) : !t10 && (s10 == null ? void 0 : s10(a10));
  } });
  const S10 = kp(Opt, { [Bpt("selected")]: !b10 && t10, [Bpt("hidden")]: n10, [Bpt("dragging")]: b10 });
  return tp.createElement("div", { ref: q7(v10) ? null : y10, className: S10, title: e14, onClick: () => s10 == null ? void 0 : s10(a10), onContextMenu: (e15) => {
    e15.preventDefault(), t10 || (s10 == null ? void 0 : s10(a10));
    const r11 = { x: e15.clientX, y: e15.clientY };
    f10.contextMenu.open(r11, [{ type: "button", icon: i10 == null ? void 0 : i10.left, text: g10("tabs.actions.textMoveLeft", "Move Left"), disabled: void 0 === l10, onClick: () => l10 == null ? void 0 : l10(a10) }, { type: "button", icon: i10 == null ? void 0 : i10.right, text: g10("tabs.actions.textMoveRight", "Move Right"), disabled: void 0 === c10, onClick: () => c10 == null ? void 0 : c10(a10) }, { type: "splitter" }, { type: "button", icon: i10 == null ? void 0 : i10.insert, text: g10("tabs.actions.textInsert", "Insert"), disabled: void 0 === d10, onClick: () => d10 == null ? void 0 : d10(a10) }, { type: "button", icon: i10 == null ? void 0 : i10.duplicate, text: g10("tabs.actions.textDuplicate", "Duplicate"), disabled: void 0 === p10, onClick: () => p10 == null ? void 0 : p10(a10) }, { type: "splitter" }, { type: "button", icon: i10 == null ? void 0 : i10.toggle, text: n10 ? g10("tabs.actions.textShow", "Show") : g10("tabs.actions.textHide", "Hide"), disabled: void 0 === m10, onClick: () => m10 == null ? void 0 : m10(a10) }, { type: "splitter" }, { type: "button", icon: i10 == null ? void 0 : i10.delete, text: g10("tabs.actions.textMDelete", "Delete"), disabled: void 0 === h10, onClick: () => h10 == null ? void 0 : h10(a10) }]);
  } }, tp.createElement("span", { className: $pt }, e14), tp.createElement("i", { className: Wpt }));
};
const Zpt = (e14) => void 0 !== e14.items;
const [Gpt, Upt, qpt] = Dp("rdlx-tabs");
const [Ypt] = qpt("container");
const [Kpt] = qpt("items");
const [Xpt] = qpt("add");
const [Jpt, Qpt] = qpt("separator");
const [emt] = qpt("indicator");
const tmt = (e14, t10) => e14 === t10.length - 1;
const nmt = ({ tabItems: e14, icons: t10, onAdd: n10, onNavigate: r10, onMoveLeft: o10, onMoveRight: a10, onMove: i10, onInsert: s10, onDuplicate: l10, onToggle: c10, onDelete: u10, textAddTab: d10 }) => {
  const { userPreferences: { rulers: { show: p10 } } } = Uae();
  const [m10, h10] = ep.useState({ left: 0, width: "0px" });
  const [f10, g10] = ep.useState(-1);
  const y10 = ep.useRef(null);
  const v10 = ep.useRef(null);
  const b10 = ep.useRef(null);
  const S10 = rf(Xm);
  const [, C10] = are({ accept: ["rdlxTab"], hover: (e15, t11) => {
    "rdlxTab" === e15.type && e15.moveTab && I0e(e15.moveTab(e15, t11));
  } });
  ep.useLayoutEffect(() => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2;
    const t11 = e14.findIndex((e15) => e15.selected);
    g10(t11);
    const n11 = (_b2 = (_a2 = y10.current) == null ? void 0 : _a2.getElementsByClassName("rdlx-tab--selected")) != null ? _b2 : [];
    if (1 !== n11.length) return;
    const r11 = n11[0];
    if (h10({ left: r11.offsetLeft, width: `${r11.clientWidth}px` }), t11 === f10) return;
    const o11 = (_c2 = b10.current) == null ? void 0 : _c2.getBaseRef();
    const a11 = (_d2 = o11 == null ? void 0 : o11.viewScrollLeft) != null ? _d2 : 0;
    const i11 = ((_e2 = o11 == null ? void 0 : o11.viewScrollLeft) != null ? _e2 : 0) + ((_g2 = (_f2 = y10.current) == null ? void 0 : _f2.clientWidth) != null ? _g2 : 0);
    const s11 = r11.offsetLeft;
    const l11 = r11.offsetLeft + r11.clientWidth;
    s11 >= a11 && l11 <= i11 || (o11 == null ? void 0 : o11.scrollLeft(s11 < a11 ? s11 : l11));
  }, [e14]);
  const x10 = (e15) => f10 >= 0 && (e15 === f10 || e15 === f10 - 1);
  const w10 = (n11, d11) => ({ item: n11, index: d11, icons: t10, indicatorRef: v10, scrollRef: b10, onNavigate: r10, onMoveLeft: d11 > 0 ? o10 : void 0, onMoveRight: tmt(d11, e14) ? void 0 : a10, onMove: i10, onInsert: s10, onDuplicate: l10, onToggle: c10, onDelete: u10 });
  const T10 = { icon: S10, text: d10, block: true, size: "small", accent: "icon", background: "transparent", onClick: n10, customCSS: Xpt };
  const E10 = kp(Gpt, { [Upt("with-rulers")]: p10 });
  return tp.createElement("div", { className: E10, ref: C10 }, tp.createElement("div", { className: Ypt, ref: y10 }, tp.createElement(bF, { ref: b10, direction: "horizontal", size: "small" }, tp.createElement("div", { className: Kpt, onWheel: (e15) => {
    var _a2;
    e15.stopPropagation();
    const t11 = (_a2 = b10.current) == null ? void 0 : _a2.getBaseRef();
    t11 == null ? void 0 : t11.scrollLeft(t11.getScrollLeft() + e15.deltaY);
  } }, e14.map((t11, n11) => [Zpt(t11) ? null : tp.createElement(jpt, __spreadValues({ key: t11.key }, w10(t11, n11))), !tmt(n11, e14) && tp.createElement("div", { key: `${t11.name}_separator`, className: kp(Jpt, { [Qpt("selected")]: x10(n11) }) })]), tp.createElement("i", { className: emt, ref: v10, style: m10 })))), n10 && tp.createElement(qm, __spreadValues({}, T10)));
};
const rmt = ({ pages: e14 }) => {
  const { lockLayout: t10 } = Uae();
  const n10 = PA();
  const { t: r10 } = vp("components");
  const o10 = rf(Spt);
  const a10 = rf(Cpt);
  const i10 = rf(ypt);
  const s10 = rf(bpt);
  const l10 = rf(xpt);
  const c10 = rf(vpt);
  const u10 = ep.useMemo(() => e14.findIndex((e15) => e15.$active), [e14]);
  const d10 = !t10 && e14.length > 1;
  const p10 = ep.useMemo(() => {
    const t11 = e14.map((t12, n11) => ({ key: GB(), name: `${r10("tabs.textPage", "Page")} ${n11 + 1}`, selected: n11 === u10, hidden: dpt(e14[n11].Visibility.Hidden) }));
    return t11;
  }, [u10, e14]);
  const m10 = () => {
    n10(rz([Hpt(), c5(`Pages.${e14.length}`, e14[0].Type)]));
  };
  const h10 = (e15) => {
    n10(_pt({ fromIndex: e15, toIndex: e15 - 1 }));
  };
  const f10 = (e15) => {
    n10(_pt({ fromIndex: e15, toIndex: e15 + 1 }));
  };
  const g10 = (t11) => {
    n10(rz([Vpt({ index: t11 }), c5(`Pages.${t11 + 1}`, e14[t11].Type)]));
  };
  const y10 = (t11) => {
    n10(rz([Rpt({ index: t11 }), c5(`Pages.${t11 + 1}`, e14[t11].Type)]));
  };
  const v10 = (t11) => {
    d10 && n10(Ipt({ page: e14[t11] }));
  };
  const b10 = { tabItems: p10, icons: { left: o10, right: a10, insert: i10, duplicate: s10, toggle: l10, delete: c10 }, onMove: (t11, r11) => {
    n10(rz([_pt({ fromIndex: t11, toIndex: r11 }), c5(`Pages.${r11}`, e14[r11].Type)]));
  }, onNavigate: (t11) => {
    const r11 = e14[t11];
    n10(c5(`Pages.${t11}`, r11.Type));
  }, onToggle: (e15) => {
    n10(Apt({ index: e15 }));
  }, textAddTab: r10("tabs.btnAddPage", "Add Page") };
  return t10 || (b10.onAdd = m10, b10.onMoveLeft = h10, b10.onMoveRight = f10, b10.onInsert = g10, b10.onDuplicate = y10, d10 && (b10.onDelete = v10)), tp.createElement(nmt, __spreadValues({}, b10));
};
const omt = ({ sections: e14, isDashboard: t10 }) => {
  const { lockLayout: n10 } = Uae();
  const r10 = h9();
  const o10 = PA();
  const { t: a10 } = vp("components");
  const i10 = rf(Mpt);
  const s10 = rf(kpt);
  const l10 = rf(wpt);
  const c10 = rf(Fpt);
  const u10 = rf(Ppt);
  const d10 = rf(Ept);
  const p10 = q7(r10);
  const m10 = ep.useMemo(() => e14.findIndex((e15) => e15.$active), [e14]);
  const h10 = ep.useMemo(() => !n10 && e14.length > 1, [n10, e14.length]);
  const f10 = ep.useMemo(() => {
    const t11 = e14.map(({ Name: t12 }, n11) => ({ key: GB(), name: t12, selected: n11 === m10, hidden: dpt(e14[n11].Visibility.Hidden) }));
    return t11;
  }, [m10, e14]);
  const g10 = (e15) => t10 ? Iut({ index: e15 }) : O2({ sectionType: "Continuous", index: e15 });
  const y10 = t10 ? _ut : B2;
  const v10 = t10 ? Vut : z2;
  const b10 = t10 ? Rut : $2;
  const S10 = t10 ? Aut : W2;
  const C10 = { icons: { left: i10, right: s10, insert: l10, duplicate: c10, toggle: u10, delete: d10 }, tabItems: f10, onNavigate: (e15) => {
    o10(c5(`ReportSections.${e15}`));
  }, textAddTab: a10("tabs.btnAddSection", "Add Section"), onDelete: h10 && !p10 ? (e15) => {
    h10 && o10(y10({ index: e15 }));
  } : void 0 };
  const x10 = p10 ? {} : { onToggle: (e15) => {
    o10(S10({ index: e15 }));
  }, onAdd: () => {
    o10(rz([g10(), c5(`ReportSections.${e14.length}`, e14[0].Type)]));
  }, onMoveLeft: (e15) => {
    o10(v10({ fromIndex: e15, toIndex: e15 - 1 }));
  }, onMoveRight: (e15) => {
    o10(v10({ fromIndex: e15, toIndex: e15 + 1 }));
  }, onMove: (t11, n11) => {
    o10(rz([v10({ fromIndex: t11, toIndex: n11 }), c5(`ReportSections.${n11}`, e14[0].Type)]));
  }, onInsert: (t11) => {
    const n11 = t11 + 1;
    o10(rz([g10(n11), c5(`ReportSections.${n11}`, e14[0].Type)]));
  }, onDuplicate: (t11) => {
    o10(rz([b10({ index: t11 }), c5(`ReportSections.${t11 + 1}`, e14[0].Type)]));
  } };
  const w10 = __spreadValues(__spreadValues({}, C10), x10);
  return tp.createElement(nmt, __spreadValues({}, w10));
};
const amt = (e14) => ({ type: "header", header: e14 });
const imt = (e14, t10, n10, r10, o10) => ({ type: "button", text: e14, key: e14, title: e14, icon: t10, disabled: r10, onClick: (e15, t11) => o10(__spreadProps(__spreadValues({}, n10), { payload: __spreadProps(__spreadValues({}, n10.payload), { mousePosition: t11, contextAction: true }) })) });
const smt = (e14, t10, n10, r10, o10, a10) => ({ type: "button", text: e14, key: e14, title: e14, icon: t10, disabled: n10, onClick: () => {
  o10(r10, a10);
} });
const lmt = (e14, t10, n10, r10 = false) => ({ type: "group", text: e14, key: e14, title: e14, icon: n10, disabled: r10, items: t10 });
const cmt = (e14, t10, n10, r10) => {
  switch (e14.type) {
    case "group":
      const o10 = (e14.actions || []).reduce((e15, o11) => e15.concat(cmt(o11, t10, n10, r10)), []);
      return o10.length > 0 ? [amt(r10(e14.key)), ...o10] : o10;
    case "dropdown": {
      const { key: o11, icon: a10, actions: i10 } = e14;
      const s10 = i10.reduce((e15, o12) => e15.concat(cmt(o12, t10, n10, r10)), []);
      const l10 = i10.findIndex((e15) => "separator" !== e15.type && !e15.disabled) < 0;
      return i10 && [lmt(r10(o11), s10, a10, l10)] || [];
    }
    case "button": {
      const { key: n11, icon: o11, action: a10, disabled: i10 } = e14;
      return [imt(r10(n11), o11, a10, i10, t10)];
    }
    case "dialog": {
      const { key: t11, icon: o11, dialogName: a10, disabled: i10, dialogProps: s10 } = e14;
      return [smt(r10(t11), o11, i10, a10, n10, s10)];
    }
    case "separator":
      return e14.key ? [amt(r10(e14.key))] : [{ type: "splitter" }];
    default:
      return [];
  }
};
const [umt] = Dp("ar-view");
const [dmt] = Dp("ar-report");
const pmt = (e14, t10) => {
  var _a2;
  return (_a2 = e14 == null ? void 0 : e14.classList.contains(t10)) != null ? _a2 : false;
};
const mmt = (e14) => {
  const { item: t10, decorationLayerRef: n10 } = e14;
  const { instanceId: r10, userPreferences: { surface: { zoomFactor: o10 } } } = Uae();
  const { contextActions: a10 } = d9();
  const { API: i10, theme: { current: { accentText: s10, accentError: l10, accentErrorText: c10 } } } = ep.useContext(Sm);
  const u10 = c10 != null ? c10 : l10;
  const d10 = PA();
  const { t: p10 } = vp();
  const [m10, h10] = ep.useState(false);
  const [f10, g10] = ep.useState(false);
  const [y10, v10] = ep.useState(null);
  const b10 = ep.useCallback((e15, t11) => {
    d10(_A.of(r10).open(e15, t11));
  }, [d10, r10]);
  const S10 = ep.useCallback((e15) => {
    if (!a10) return;
    const t11 = Z1e(a10, "contextmenu");
    const n11 = j1e(t11).flatMap((e16) => cmt(e16, d10, b10, p10));
    i10.contextMenu.open(e15, n11);
  }, [i10.contextMenu, a10, d10, b10, p10]);
  ep.useEffect(() => {
    const e15 = f10.scrollHeight > f10.clientHeight;
    m10 !== e15 && h10(e15);
  }, [f10, m10]), ep.useEffect(() => {
    y10 && (S10(y10), v10(null));
  }, [a10, y10, S10]);
  const C10 = "fixedpagereport" === t10.Type;
  const x10 = "dashboard" === t10.Type;
  const w10 = "multisectionreport" === t10.Type || "dashboard" === t10.Type;
  const T10 = ep.useCallback((e15, t11) => {
    if (((e16) => ["ar-item", "ar-rectangle-glyph", "pointer-grip", "ar-sel-adorner", "line-move-grip", "ar-chart-move-adorner", "ar-resizeline", "quick-edit-box__clicker"].some((t12) => pmt(e16, t12)))(e15)) {
      d10((t11 ? l5 : c5)(e15.getAttribute("data-path"), e15.getAttribute("data-type")));
    } else ((e16) => ["ar-page", "ar-report", "is-report-area", "ar-rulers__document-container", "report-area-wrapper"].some((t12) => pmt(e16, t12)))(e15) && d10(u5());
  }, [d10]);
  const E10 = ep.useCallback((e15) => {
    const { target: t11 } = e15;
    v10(null), T10(t11, SB(e15));
  }, [T10]);
  const F10 = ep.useCallback((e15) => {
    const n11 = { x: e15.clientX, y: e15.clientY };
    const { currentTarget: r11, target: o11 } = e15;
    let i11 = 0;
    let s11 = 0;
    if (pmt(r11, "ar-report") || pmt(r11, "is-report-area")) {
      const { clientHeight: t11, clientWidth: n12 } = e15.currentTarget;
      const { top: r12, left: o12 } = ((e16) => {
        let t12 = e16;
        let n13 = 0;
        let r13 = 0;
        if (!e16) return { top: n13, left: r13 };
        do {
          const { offsetTop: e17, offsetLeft: o13 } = t12;
          n13 += e17, r13 += o13, t12 = t12.offsetParent;
        } while (t12);
        return { top: n13, left: r13 };
      })(e15.currentTarget);
      i11 = r12 + t11, s11 = o12 + n12;
    }
    if (n11.x > s11 || n11.y > i11) return;
    e15.preventDefault();
    const l11 = Rj(t10, o11.getAttribute("data-path"));
    a10 && rj(l11) ? S10(n11) : (T10(o11, SB(e15)), v10(n11));
  }, [a10, S10, t10, T10]);
  const M10 = m10 && { width: "auto", height: "auto" } || {};
  const k10 = { viewport: f10, colorAccent: s10, colorError: u10, decorationLayerRef: n10 };
  const P10 = kp(dmt, { fpl: C10, msl: w10 });
  const N10 = ep.useMemo(() => {
    switch (t10.Type) {
      case "fixedpagereport":
        return tp.createElement(adt, __spreadProps(__spreadValues({}, e14), { item: t10, path: "", key: "FPLReportDataProvider" }));
      case "multisectionreport": {
        const n11 = t10.$activeSectionIndex;
        return tp.createElement(vdt, __spreadProps(__spreadValues({}, e14), { item: t10.ReportSections[n11], path: `ReportSections.${n11}`, dataSets: t10.DataSets }));
      }
      case "dashboard": {
        const n11 = t10.$activeSectionIndex;
        return tp.createElement(Jut, __spreadProps(__spreadValues({}, e14), { section: t10.ReportSections[n11], path: `ReportSections.${n11}`, dataSets: t10.DataSets }));
      }
      default:
        return null;
    }
  }, [t10.Type, t10.$activeSectionIndex, t10.ReportSections, t10.DataSets, e14]);
  const D10 = ep.useRef(null);
  const L10 = q7(t10);
  const H10 = { decorationLayerRef: n10, report: t10, zoomFactor: o10, reportPageDomElement: D10.current, disabled: L10 };
  const { setDecorations: I10, getReport: _10 } = ep.useContext(bqe);
  const { userPreferences: { surface: V10 } } = MO();
  const R10 = ep.useCallback((e15, n11) => {
    const r11 = jN(e15.path)(_10());
    const o11 = L$.parseSafe(((e16) => P0(e16) ? e16.Width : e16.$place.Height)(r11));
    const a11 = Wut(o11, e15, n11, V10);
    return zut(a11, e15, "dashboard" === t10.Type);
  }, [_10, t10.Type, V10]);
  const [, A10] = are({ accept: ["freeResizeLine", "rectRounding", "rdlxTab"], drop: (e15, t11) => {
    "freeResizeLine" === e15.type && d10(R10(e15, t11));
  }, hover: (e15, t11) => {
    if ("rectRounding" === e15.type) {
      const { gripSide: n11, transformGrip: r11 } = e15;
      const o11 = t11.getDifferenceFromInitialOffset();
      if (o11) {
        r11(h2e.getOffset(o11, n11));
      }
    }
    if ("rdlxTab" === e15.type && e15.moveTab && I0e(e15.moveTab(e15, t11)), "freeResizeLine" === e15.type) {
      const n11 = R10(e15, t11);
      $ut(r10, e15.path, _10(), n11, I10);
    }
  } });
  return tp.createElement("div", { className: umt, onClick: E10, ref: x10 ? A10 : null }, tp.createElement("div", { className: P10, ref: g10, onContextMenu: F10 }, tp.createElement(cpt, { report: t10 }, tp.createElement(Hut, __spreadValues({}, H10), tp.createElement("div", { className: "is-report-area ar-page-margin", style: M10, ref: D10 }, tp.createElement(Lut, __spreadValues({}, k10), N10))))), C10 && tp.createElement(rmt, { pages: t10.Pages }), w10 && tp.createElement(omt, { sections: t10.ReportSections, isDashboard: "dashboard" === t10.Type }));
};
function hmt(e14, t10, n10) {
  return (r10, o10, a10, i10, s10, l10 = false) => {
    const { Type: c10, Name: u10 } = r10;
    const d10 = r10 == null ? void 0 : r10.DataSetName;
    const p10 = d10 ? t10.filter((e15) => e15.Name === d10) : a10;
    const m10 = { key: `${u10}-glyph`, item: r10, path: o10, dataSets: p10, parentBackgroundColor: i10, theme: e14, onlyContent: l10 };
    const h10 = nz.of(n10).getGlyph(c10);
    const f10 = tp.createElement(h10, m10, {});
    if (l10) return f10;
    if (!(s10 && (p10 == null ? void 0 : p10.length) && ["checkbox", "textbox", "image", "inputfield"].includes(c10))) return f10;
    const g10 = { path: o10, item: r10, itemSelected: rj(r10), itemBackgroundColor: i10 };
    return tp.createElement(Vee, __spreadValues({}, g10), f10);
  };
}
mmt.displayName = "DesignerAdorner";
const fmt = (e14) => {
  const { item: t10, item: { Themes: n10, DataSets: r10 }, theme: o10, makeSharedImageUrl: a10, reportStyles: i10 } = e14;
  const { userPreferences: s10, userPreferences: { surface: { zoomFactor: l10 } } } = MO();
  const { instanceId: c10 } = Uae();
  const u10 = PA();
  ep.useEffect(() => {
    var e15;
    Fee("zoom", [`.scalable { zoom: ${e15 = l10} }`, `.${Mee} { zoom: ${1 / e15} }`, `.${Mee} .ar-item { zoom: ${e15} }`, `.${Mee} .ar-item .ar-item { zoom: 1 }`]);
  }, [l10]), ep.useEffect(() => {
    u10(h2(void 0, { skipFplRestrictionsValidation: false }));
  }, [n10[0]]);
  const d10 = ep.useMemo(() => ({ instanceId: c10, renderItem: hmt(o10, r10, c10), getSettings: () => (({ surface: { showGrid: e15, snapToGrid: t11, snapToLines: n11, zoomFactor: r11, gridSize: o11 }, sidebar: { propertiesMode: a11, width: i11 }, rulers: { show: s11 } }) => ({ gridSize: o11, showGrid: e15, snapToGrid: t11, snapToLines: n11, zoomFactor: r11, advancedMode: "advanced" === a11, sidebarWidth: i11, showRulers: s11 }))(s10), makeImageUrl: (e15, t11, n11) => zme(e15, t11, n11, a10), embeddedImages: t10.EmbeddedImages, getReport: () => t10, getAreaByPath: (e15) => Tee(t10, e15), isItemInFixedArea: (e15) => Eee(t10, e15), getItemLayerInfo: (e15) => k3(e15, t10), getDefaultStyle: (e15) => _j(i10, e15) }), [c10, o10, r10, t10, s10, a10, i10]);
  return tp.createElement(Put, { value: d10 }, tp.createElement(mmt, __spreadValues({}, e14)));
};
const gmt = { in: E$.in, cm: 2 };
const ymt = () => {
  const { userPreferences: { units: e14 } } = MO();
  const t10 = ep.useCallback((t11) => z4(E$[e14])(t11), [e14]);
  const n10 = (e15) => z4(4)(e15);
  const r10 = ep.useCallback((n11) => t10(V$(L$.fromTwips(n11), e14)), [t10, e14]);
  const o10 = ep.useCallback((t11) => z4(gmt[e14])(V$(L$.fromTwips(t11), e14)), [e14]);
  const a10 = ep.useCallback((t11) => n10(new L$(t11, e14).toPreciseTwips), [e14]);
  return { roundUnits: t10, roundTwips: n10, twipsToUnits: r10, integerTwipsToUnits: o10, unitsToTwips: a10 };
};
const vmt = stt(Ytt, "printWidth", "rpx_length", "PrintWidth", void 0, { minValueMap: qY, maxValue: L$.parse("800in") });
const [, , bmt] = Dp("rpx-ruler-highlighter");
const [Smt] = bmt("primary");
const [Cmt] = bmt("secondary");
const xmt = stt(Xtt, "height", "rpx_length", "Height", void 0, { minValue: L$.parse("0in"), maxValue: L$.parse("10000in"), checkSectionGeometry: true, checkCrossSectionItemGeometry: true });
const [, wmt] = Dp("rpx-ruler-marker");
const Tmt = wmt("accent");
const Emt = (e14, t10) => {
  const { userPreferences: { units: n10 } } = MO();
  const { twipsToUnits: r10, unitsToTwips: o10 } = ymt();
  const a10 = PA();
  const i10 = Kdt();
  ep.useEffect(() => {
    l10(e14.map(({ Height: e15 }) => r10(e15)));
  }, [e14, r10]);
  const [s10, l10] = ep.useState(e14.map(({ Height: e15 }) => r10(e15)));
  const c10 = (t11, o11) => (a11, c11) => {
    var _a2;
    const u11 = a11 - t11;
    const d11 = r10(((e15) => {
      const t12 = Object.values(e15.Controls);
      return t12.length > 0 ? Math.max(...t12.map((e16) => "Line" === e16.Type ? Math.max(e16 == null ? void 0 : e16.Y1, e16 == null ? void 0 : e16.Y2) : "Unknown" === e16.Type || "CrossSectionLine" === e16.Type || "CrossSectionBox" === e16.Type ? 0 : e16.Top + e16.Height)) : 0;
    })(e14[o11]));
    const p10 = (_a2 = xmt.meta) == null ? void 0 : _a2.maxValue;
    const m10 = p10 ? V$(p10, n10) : 1 / 0;
    const h10 = SB(c11);
    const f10 = j4(u11, i10(c11), d11, h10, m10, false);
    const g10 = s10.slice();
    return g10[o11] = f10, l10(g10), [f10 + t11, f10 === d11];
  };
  const u10 = [];
  let d10 = t10;
  return e14.forEach(({ Name: n11, Height: i11, $path: l11, $primary: p10 }, m10) => {
    if (0 === i11) return;
    const h10 = p10 && e14.length > 1;
    const f10 = u10.length - 1;
    h10 && f10 >= 0 && (u10[f10].customCSS = Tmt);
    const g10 = { position: t10 + s10.slice(0, m10 + 1).reduce((e15, t11) => e15 + t11, 0), tooltip: `${s10 == null ? void 0 : s10[m10]}`, onMarkerMove: c10(d10, m10), onMarkerUp: (y10 = d10, v10 = l11, (e15) => {
      const t11 = o10(e15 - y10);
      a10(iB(xmt, t11, v10));
    }), key: `rpx-marker-${n11}-height`, dataAid: `rpx-marker-${n11}-height`, customCSS: h10 ? Tmt : void 0 };
    var y10, v10;
    u10.push(g10), d10 += r10(i11);
  }), u10;
};
const Fmt = (e14) => {
  const { PrintWidth: t10, PageSettings: n10, Sections: r10, children: o10 } = e14;
  const { userPreferences: { surface: { zoomFactor: a10 }, rulers: { show: i10, snapStep: s10 }, units: l10 } } = MO();
  const { TopMargin: c10, BottomMargin: u10, LeftMargin: d10, RightMargin: p10, GutterMargin: m10 } = n10;
  const { roundUnits: h10, twipsToUnits: f10, integerTwipsToUnits: g10 } = ymt();
  const y10 = { top: g10(c10), bottom: g10(u10), left: g10(d10), right: g10(p10), gutter: g10(m10) };
  const v10 = f10(t10);
  const b10 = h10(y10.gutter + y10.left + v10 + y10.right);
  const S10 = f10(r10.reduce((e15, t11) => e15 + t11.Height, 0) + c10 + u10);
  const C10 = ((e15, t11) => {
    const { userPreferences: { surface: { snapToLines: n11 }, units: r11 } } = MO();
    const o11 = PA();
    const a11 = Kdt();
    const { roundUnits: i11, integerTwipsToUnits: s11, unitsToTwips: l11 } = ymt();
    const { LeftMargin: c11, RightMargin: u11, GutterMargin: d11 } = t11;
    const p11 = { left: s11(c11), right: s11(u11), gutter: s11(d11) };
    const m11 = s11(e15);
    ep.useEffect(() => {
      f11(p11.gutter + p11.left + m11);
    }, [p11.gutter, p11.left, m11]);
    const [h11, f11] = ep.useState(i11(p11.gutter + p11.left + m11));
    return [{ position: h11, tooltip: i11(h11 - p11.left - p11.gutter).toString(), onMarkerMove: (e16, t12) => {
      var _a2;
      const o12 = i11(e16 - p11.left - p11.gutter);
      const s12 = qY[r11].value;
      const l12 = (_a2 = vmt.meta) == null ? void 0 : _a2.maxValue;
      const c12 = l12 ? V$(l12, r11) : 1 / 0;
      const u12 = j4(o12, a11(t12), s12, n11, c12, false);
      return f11(u12 + p11.left + p11.gutter), [i11(u12 + p11.left + p11.gutter), !!n11 && u12 === s12];
    }, onMarkerUp: (e16) => {
      const t12 = l11(e16 - p11.left - p11.gutter);
      o11(iB(vmt, t12, ""));
    }, key: "rpx-marker-width", dataAid: "rpx-marker-width" }];
  })(t10, n10);
  const x10 = Emt(r10, y10.top);
  const w10 = ((e15, t11) => {
    const { twipsToUnits: n11 } = ymt();
    const r11 = [];
    let o11 = t11;
    return e15.length <= 1 || e15.forEach((e16) => {
      ij(e16) ? r11.push({ start: n11(o11), end: n11(e16.Height + o11), key: `rpx-ruler-span-highlighter-${e16.Name}--primary`, customCSS: Smt }) : aj(e16) && r11.push({ start: n11(o11), end: n11(o11 + e16.Height), key: `rpx-ruler-span-highlighter-${e16.Name}--secondary`, customCSS: Cmt }), o11 += e16.Height;
    }), r11;
  })(r10, c10);
  const T10 = { show: i10, snapStepMap: s10, units: l10, zoom: a10, horizontalRuler: { length: b10, zeroOffset: h10(y10.gutter + y10.left), markers: C10, spans: [{ key: "span-horizontal", start: h10(y10.gutter + y10.left), end: h10(b10 - y10.right) }] }, verticalRuler: { length: S10, zeroOffset: y10.top, markers: x10, spans: [{ key: "span-vertical", start: y10.top, end: h10(S10 - y10.bottom) }, ...w10] } };
  return tp.createElement(qdt, __spreadValues({}, T10), o10);
};
Fmt.displayName = "RpxRulers";
const Mmt = ep.createContext({ reportRef: { current: void 0 }, sections: [] });
const kmt = { x: 64, y: 64 };
const Pmt = (e14, t10) => e14 / C$() * T$.in / t10;
const Nmt = (e14, t10) => e14 / T$.in * C$() * t10;
function Dmt(e14, t10, n10) {
  const { GutterMargin: r10, TopMargin: o10, LeftMargin: a10 } = t10;
  return { x: Pmt(e14.x - kmt.x, n10) - a10 - r10, y: Pmt(e14.y - kmt.y, n10) - o10 };
}
function Lmt(e14, t10, n10) {
  const { GutterMargin: r10, TopMargin: o10, LeftMargin: a10 } = t10;
  return { x: Nmt(e14.x + a10 + r10, n10) + kmt.x, y: Nmt(e14.y + o10, n10) + kmt.y };
}
const Hmt = (e14, t10, n10 = { x: 0, y: 0 }) => {
  const r10 = { x: t10.x + n10.x, y: t10.y + n10.y };
  return { Top: r10.y > 0 ? e14.y : e14.y + r10.y, Left: r10.x > 0 ? e14.x : e14.x + r10.x, Width: Math.abs(r10.x), Height: Math.abs(r10.y) };
};
const [Imt] = Dp("wd-surface-grid");
const _mt = ({ id: e14 }) => {
  const { userPreferences: { surface: { gridSize: t10 } } } = MO();
  const n10 = `${e14}-bg-grid`;
  const r10 = ep.useMemo(() => L$.toPixels(t10), [t10]);
  const o10 = ep.useMemo(() => {
    const { location: { pathname: e15, search: t11 } } = window;
    return `url('${e15}${t11}#${n10}')`;
  }, [n10]);
  return tp.createElement("div", { className: Imt }, tp.createElement("svg", { width: "100%", height: "100%", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("defs", null, tp.createElement("pattern", { id: n10, width: r10, height: r10, patternUnits: "userSpaceOnUse" }, tp.createElement("path", { d: `M ${r10} 0 L 0 0 0 ${r10}`, fill: "none", stroke: "#AAA", strokeWidth: "1", strokeOpacity: "0.4" }))), tp.createElement("rect", { x: "1", y: "1", width: "100%", height: "100%", fill: o10 })));
};
function Vmt(e14) {
  const t10 = BV.cloneDeep(e14);
  return delete t10.$primary, delete t10.$selected, t10;
}
function Rmt(e14, t10, n10) {
  var _a2;
  const r10 = [];
  const o10 = nz.of(e14);
  let a10 = 0;
  const i10 = o10.getFeature(t10.Type, "getChildren");
  const s10 = (_a2 = i10 == null ? void 0 : i10(t10)) != null ? _a2 : [];
  for (const e15 of s10) {
    const i11 = { Left: 0, Top: 0, Width: t10.PrintWidth, Height: e15.Height };
    for (const t11 of Object.values(e15.Controls)) if (n10.includes(t11.$path)) {
      const e16 = o10.getFeature(t11.Type, "getRectangle");
      if (e16) {
        const n11 = e16(t11, i11);
        r10.push({ documentItem: Vmt(t11), isLeaf: rj(t11), isPrimary: ij(t11), rect: $at(n11, { x: 0, y: a10 }) });
      }
    }
    a10 += e15.Height;
  }
  return r10;
}
const Amt = { nw: { Left: 1, Top: 1, Width: -1, Height: -1 }, nm: { Left: 0, Top: 1, Width: 0, Height: -1 }, ne: { Left: 0, Top: 1, Width: 1, Height: -1 }, sw: { Left: 1, Top: 0, Width: -1, Height: 1 }, sm: { Left: 0, Top: 0, Width: 0, Height: 1 }, se: { Left: 0, Top: 0, Width: 1, Height: 1 }, mw: { Left: 1, Top: 0, Width: -1, Height: 0 }, me: { Left: 0, Top: 0, Width: 1, Height: 0 } };
function Omt(e14, t10, n10) {
  return n10 ? "default" : "m" === e14 ? "ew-resize" : "m" === t10 ? "ns-resize" : `${e14}${t10}-resize`;
}
const Bmt = (e14) => {
  const { vSide: t10, hSide: n10, primary: r10, documentItem: o10, disabled: a10 } = e14;
  const { reportRef: { current: i10 } } = ep.useContext(Mmt);
  const { instanceId: s10, userPreferences: l10 } = MO();
  const { surface: { gridSize: c10, snapToGrid: u10, snapToLines: d10 } } = l10;
  const p10 = kp("grip", { "grip-n": "n" === t10, "grip-vm": "m" === t10, "grip-s": "s" === t10, "grip-w": "w" === n10, "grip-hm": "m" === n10, "grip-e": "e" === n10 }, a10);
  const [, m10, h10] = Yne({ item: { type: "rpx-control-resize", resizedDocumentItems: [], resizeDirection: { Left: 0, Top: 0, Width: 0, Height: 0 } }, begin: () => {
    if (!i10 || a10) return;
    const e15 = lit(i10);
    rj(o10) || e15.push(o10.$path);
    const r11 = Amt[`${t10}${n10}`] || { Left: 0, Top: 0, Width: 0, Height: 0 };
    return { type: "rpx-control-resize", resizedDocumentItems: Rmt(s10, i10, e15), snapSolver: rit({ instanceId: s10, report: i10, draggedPaths: e15, gridSize: c10, snapToGrid: u10, snapToLines: d10 }), resizeDirection: r11 };
  } });
  ep.useEffect(() => {
    h10(Coe(), { captureDraggingState: true });
  }, [h10]);
  const f10 = { cursor: Omt(t10, n10, a10) };
  return tp.createElement("div", { className: p10, style: f10, ref: a10 ? () => {
  } : m10 }, r10 && tp.createElement("div", { className: "grip-marker" }));
};
Bmt.displayName = "RPX:CornerGrip";
const zmt = () => tp.createElement("div", { className: "mover" }, tp.createElement("div", { className: "mover-e" }), tp.createElement("div", { className: "mover-n" }), tp.createElement("div", { className: "mover-s" }), tp.createElement("div", { className: "mover-w" }));
zmt.displayName = "RPX:Mover";
const $mt = (e14) => {
  const { documentItem: t10, side: n10, rectRef: r10, setIsRounding: o10, allSidesMode: a10 } = e14;
  if (!(r10 == null ? void 0 : r10.current)) return null;
  const { t: i10 } = vp("adorners");
  const s10 = PA();
  const { userPreferences: { surface: { zoomFactor: l10 } } } = MO();
  const { rectAngleCalcs: c10, getNewBorderRadius: u10, calcGripPosition: d10, calcRadiusByGripPosition: p10, directGripBySide: m10, translateSideToGripGuide: h10, getGripGuideRotationBySide: f10 } = h2e;
  const { borderRadiusDirection: g10, maxGripPosition: y10, maxRadiusRect: v10, gripMargin: b10, guideSize: S10 } = c10(r10.current, { side: n10, allSidesMode: a10, zoomFactor: l10 });
  const C10 = u10(g10);
  const [x10, w10] = ep.useState($4(d10(C10(r10.current), l10), b10, y10));
  const T10 = (e15) => {
    if (r10.current) {
      const t11 = $4(e15 + x10, 0, y10);
      w10(t11), E10(p10(t11, l10));
    }
  };
  const E10 = (e15) => {
    if (r10.current) {
      const t11 = $4(e15, 0, v10);
      r10.current.style[`border${g10}Radius`] = `${t11}px`;
    }
  };
  const [{ isDragging: F10 }, M10, k10] = Yne({ item: { type: "rpx-rectangle-rounding", gripSide: n10, transformGrip: T10 }, collect: (e15) => ({ isDragging: e15.isDragging() }), begin: () => ((r10 == null ? void 0 : r10.current) && (o10(true), r10.current.classList.add("rpx-shape-rounding")), { type: "rpx-rectangle-rounding", gripSide: n10, transformGrip: T10 }), end: () => {
    if (r10 == null ? void 0 : r10.current) {
      o10(false);
      ((e15) => {
        let r11 = {};
        r11 = a10 ? __spreadProps(__spreadValues({}, t10.Radius), { [n10]: e15 }) : __spreadProps(__spreadValues({}, t10.Radius), { [d2e.TOP_LEFT]: e15, [d2e.TOP_RIGHT]: e15, [d2e.BOTTOM_LEFT]: e15, [d2e.BOTTOM_RIGHT]: e15 }), s10(iB(stt(Utt, "roundingRadius", "radius", "Radius"), r11));
      })(+(C10(r10.current) / v10 * 100).toFixed()), r10.current.classList.remove("rpx-shape-rounding");
    }
  } });
  ep.useEffect(() => {
    k10(Coe(), { captureDraggingState: false });
  }, [k10]), ep.useEffect(() => {
    if (r10.current) {
      const { maxGripPosition: e15, gripMargin: t11 } = c10(r10.current, { side: n10, allSidesMode: a10, zoomFactor: l10 });
      w10($4(d10(C10(r10.current), l10), t11, e15));
    }
  }, [t10.Radius, t10.Width, t10.Height, l10, y10, b10]);
  const P10 = { "grip-angle-tl": n10 === d2e.TOP_LEFT, "grip-angle-tr": n10 === d2e.TOP_RIGHT, "grip-angle-bl": n10 === d2e.BOTTOM_LEFT, "grip-angle-br": n10 === d2e.BOTTOM_RIGHT };
  const N10 = kp("grip-angle", P10);
  const D10 = { position: "absolute", cursor: "pointer", transform: m10(n10, x10, l10) };
  return tp.createElement(tp.Fragment, null, F10 && tp.createElement("div", { style: { height: S10, transformOrigin: h10(n10), transform: f10(n10) }, className: kp("grip-angle-guide", P10) }), tp.createElement("div", { className: N10, style: D10, ref: M10, title: i10(a10 ? "shapeRoundingTip.multiCornerMode" : "shapeRoundingTip.singleCornerMode") }));
};
$mt.displayName = "RPX:AngleGrip";
const Wmt = (e14) => {
  const { documentItem: t10 } = e14;
  const [n10, r10] = ep.useState(!h2e.checkEqualSides(t10.Radius));
  const o10 = ep.useCallback((e15) => {
    "Alt" === e15.key && (e15.preventDefault(), r10(!n10));
  }, [n10]);
  ep.useEffect(() => (window.addEventListener("keyup", o10), () => {
    window.removeEventListener("keyup", o10);
  }), [o10]);
  const a10 = __spreadProps(__spreadValues({}, e14), { allSidesMode: n10 });
  return tp.createElement("div", null, tp.createElement($mt, __spreadValues({ side: d2e.TOP_LEFT }, a10)), n10 && tp.createElement(tp.Fragment, null, tp.createElement($mt, __spreadValues({ side: d2e.TOP_RIGHT }, a10)), tp.createElement($mt, __spreadValues({ side: d2e.BOTTOM_LEFT }, a10)), tp.createElement($mt, __spreadValues({ side: d2e.BOTTOM_RIGHT }, a10))));
};
Wmt.displayName = "RPX:RoundedRectangleSelection";
const [jmt, , Zmt] = Dp("rpx-selection");
const [Gmt] = Dp("rpx-rectangle-selection");
const [Umt] = Zmt("primary");
const [qmt] = Zmt("secondary");
const [Ymt] = Zmt("rounding");
const Kmt = (e14) => {
  const { documentItem: t10, withMover: n10, withGrips: r10, dataPath: o10, gripsDisabled: a10, isSection: i10, isRounded: s10, isMultipleSections: l10, rectRef: c10 } = e14;
  const { userPreferences: { surface: { zoomFactor: u10 } } } = MO();
  const [d10, p10] = ep.useState(false);
  const m10 = ij(t10);
  const h10 = !m10 && aj(t10);
  const f10 = { zoom: 1 / u10 };
  const g10 = { primary: m10, documentItem: t10, disabled: a10 };
  const y10 = { documentItem: t10, setIsRounding: p10, rectRef: c10 };
  const v10 = i10 ? kp(m10 && l10 ? Umt : "", h10 ? qmt : "") : Umt;
  const b10 = kp(jmt, Gmt, v10, { [Ymt]: d10 });
  const S10 = n10 && !d10;
  const C10 = r10 && !d10;
  const x10 = s10 && !a10 && m10;
  return tp.createElement("div", { className: b10, style: f10, "data-path": o10 }, S10 && tp.createElement(zmt, null), C10 && tp.createElement(tp.Fragment, null, tp.createElement(Bmt, __spreadValues({ vSide: "n", hSide: "w" }, g10)), tp.createElement(Bmt, __spreadValues({ vSide: "n", hSide: "m" }, g10)), tp.createElement(Bmt, __spreadValues({ vSide: "n", hSide: "e" }, g10)), tp.createElement(Bmt, __spreadValues({ vSide: "m", hSide: "w" }, g10)), tp.createElement(Bmt, __spreadValues({ vSide: "m", hSide: "e" }, g10)), tp.createElement(Bmt, __spreadValues({ vSide: "s", hSide: "w" }, g10)), tp.createElement(Bmt, __spreadValues({ vSide: "s", hSide: "m" }, g10)), tp.createElement(Bmt, __spreadValues({ vSide: "s", hSide: "e" }, g10))), x10 && tp.createElement(Wmt, __spreadValues({}, y10)));
};
Kmt.displayName = "RPX:RectangleSelection";
function Xmt(e14, t10, n10) {
  var _a2;
  let r10 = 0;
  const o10 = nz.of(e14).getFeature(t10.Type, "getChildren");
  const a10 = (_a2 = o10 == null ? void 0 : o10(t10)) != null ? _a2 : [];
  for (const e15 of a10) {
    for (const t11 of Object.values(e15.Controls)) if (n10 === t11) return r10;
    r10 += e15.Height;
  }
  return 0;
}
const Jmt = (e14) => {
  const { point: t10, index: n10, itemRect: r10, primary: o10, disabled: a10, documentItem: i10 } = e14;
  const { instanceId: s10, userPreferences: l10 } = MO();
  const { reportRef: { current: c10 } } = ep.useContext(Mmt);
  const { surface: { gridSize: u10, snapToGrid: d10, snapToLines: p10, zoomFactor: m10 } } = l10;
  const [, h10] = Yne({ item: { type: "rpx-point-move", point: t10, index: n10, sectionTop: 0 }, begin: () => {
    if (c10 && !a10) return { type: "rpx-point-move", documentItem: i10, point: t10, index: n10, sectionTop: Xmt(s10, c10, i10), snapSolver: rit({ instanceId: s10, report: c10, draggedPaths: [i10.$path], gridSize: u10, snapToGrid: d10, snapToLines: p10 }) };
  } });
  const f10 = Nmt(t10.x - r10.Left, m10) - 5 + "px";
  const g10 = Nmt(t10.y - r10.Top, m10) - 5 + "px";
  const y10 = kp("grip grip-point", { disabled: a10 });
  return tp.createElement("div", { className: y10, style: { left: f10, top: g10 }, ref: a10 ? () => {
  } : h10 }, o10 && tp.createElement("div", null));
};
Jmt.displayName = "RPX:PointGrip";
const Qmt = (e14) => {
  const { documentItem: t10, parentRectangle: n10, withMover: r10, withGrips: o10, lineStyles: a10, dataPath: i10, gripsDisabled: s10 } = e14;
  const { userPreferences: { surface: { zoomFactor: l10 } } } = MO();
  const { instanceId: c10 } = qHe();
  const { sections: u10 } = ep.useContext(Mmt);
  const d10 = nz.of(c10);
  const p10 = d10.getFeature(t10.Type, "getPoints");
  const m10 = d10.getFeature(t10.Type, "getRectangle");
  if (!p10 || !m10) return null;
  const h10 = m10(t10, n10, u10);
  const f10 = p10(t10, n10, u10);
  const g10 = ij(t10);
  const y10 = { zoom: 1 / l10 };
  return tp.createElement(tp.Fragment, null, tp.createElement("div", { className: "rpx-selection rpx-line-selection", style: y10, "data-path": i10 }, r10 && tp.createElement(zmt, null), o10 && f10.map((e15, n11) => tp.createElement(Jmt, { documentItem: t10, point: e15, index: n11, itemRect: h10, disabled: s10, primary: g10, key: `${t10.$path}-point-${n11}` }))), a10 && tp.createElement("div", { className: "rpx-line-border", style: a10 }));
};
Qmt.displayName = "RPX:LineSelection";
const eht = (e14) => {
  if (!e14) return false;
  return !!/^(?![\d_\p{Nd}\p{Mn}\p{Mc}\p{Pc}])[\p{Lu}\p{Ll}\p{Lt}\p{Lm}\p{Lo}\p{Nd}\p{Mn}\p{Mc}\p{Pc}]*$/gu.test(e14);
};
const [tht, nht] = Dp("rpx-item");
const rht = new L$(2, "pt").toTwips;
const oht = (e14) => {
  const { item: t10, sectionRect: n10, parentBackgroundColor: r10 } = e14;
  const { Type: o10 } = t10;
  const { instanceId: a10, userPreferences: i10 } = MO();
  const { reportRef: { current: s10 }, sections: l10 } = ep.useContext(Mmt);
  const { surface: { gridSize: c10, snapToGrid: u10, snapToLines: d10 }, units: p10 } = i10;
  const m10 = PA();
  const h10 = nz.of(a10);
  const f10 = h10.getFeature(o10, "getRectangle");
  const [, g10, y10] = Yne({ item: { type: "rpx-control-move", copiedDocumentItems: [] }, begin: () => {
    if (!s10) return;
    const e15 = lit(s10);
    return { type: "rpx-control-move", copiedDocumentItems: Rmt(a10, s10, e15), snapSolver: rit({ instanceId: a10, report: s10, draggedPaths: e15, gridSize: c10, snapToGrid: u10, snapToLines: d10 }) };
  } });
  ep.useEffect(() => {
    y10(Coe(), { captureDraggingState: true });
  }, []);
  const [{ isOver: v10, canDrop: b10 }, S10] = are({ accept: ["field", "parameter"], drop: (e15) => {
    const n11 = "field" === e15.type ? e15.field.Name : e15.key;
    const r11 = eht(n11) ? az.of(a10).getNextNameByTemplate(`txt${n11}`) : az.of(a10).getNextDocumentItemName("TextBox");
    const o11 = [];
    o11.push(sB(t10.$path)), o11.push(iB(stt("", "", "string", "Name"), r11)), o11.push(iB(stt("", "", "string", "Text"), r11)), o11.push(iB(stt("", "", "string", "DataField"), "field" === e15.type ? n11 : `param:${n11}`)), m10(rz(o11));
  }, collect: (e15) => {
    const n11 = "TextBox" === t10.Type;
    return { isOver: n11 && e15.isOver({ shallow: true }), canDrop: n11 && e15.canDrop() };
  }, canDrop: () => "TextBox" === t10.Type });
  const C10 = ep.useMemo(() => {
    if (f10) {
      const { Top: e15, Left: r11, Width: o11, Height: a11 } = f10(t10, n10, l10);
      return { top: L$.fromTwips(e15, p10).css, left: L$.fromTwips(r11, p10).css, width: L$.fromTwips(Math.max(o11, rht), p10).css, height: L$.fromTwips(Math.max(a11, rht), p10).css };
    }
    return console.error(`"${o10}" doesn't implement getRectangle feature`), { top: 0, left: 0 };
  }, [f10, o10, t10, n10, l10, p10]);
  const x10 = { documentItem: t10, parentRectangle: n10, parentBackgroundColor: r10 };
  const w10 = h10.getFeature(o10, "isCrossSectionItem");
  const T10 = kp(tht, { [nht("over")]: v10, [nht("can-drop")]: b10 });
  const E10 = ep.useCallback((e15) => {
    SB(e15) ? m10(rj(t10) ? cB(t10.$path) : lB(t10.$path)) : m10(sB(t10.$path));
  }, [m10, t10]);
  return tp.createElement("div", { ref: S10 }, tp.createElement("div", { className: T10, style: C10, "data-item": o10, "data-path": t10.$path, ref: w10 ? () => {
  } : g10, onClick: E10, onDragStart: () => {
    rj(t10) || m10(sB(t10.$path));
  } }, tp.createElement(h10.getGlyph(o10), x10)));
};
function aht(e14, t10) {
  let n10 = 0;
  if (e14 <= 0) return { section: t10[0], sectionTop: n10 };
  for (const r11 of t10) {
    const t11 = Iet(n10 + r11.Height - e14, false) > 0;
    const o10 = Iet(n10 - e14, false) <= 0;
    if (t11 && o10) return { section: r11, sectionTop: n10 };
    n10 += r11.Height;
  }
  const r10 = t10[t10.length - 1];
  return { section: r10, sectionTop: n10 - r10.Height };
}
function iht(e14, t10, n10) {
  const r10 = e14.getInitialClientOffset();
  const o10 = e14.getClientOffset();
  if (!r10 || !o10) return null;
  const a10 = Dmt(r10, t10.PageSettings, n10);
  const i10 = Dmt(o10, t10.PageSettings, n10);
  return { x: i10.x - a10.x, y: i10.y - a10.y };
}
function sht(e14, t10, n10, r10, o10, a10, i10, s10) {
  var _b2;
  const l10 = [];
  const c10 = nz.of(r10);
  const u10 = c10.getFeature(e14, "getRectangle");
  const d10 = c10.getFeature(e14, "setRectangle");
  if (!u10 || !d10) return l10;
  const _a2 = c10.create(e14), { Text: p10 } = _a2, m10 = __objRest(_a2, ["Text"]);
  const h10 = n10.getClientOffset();
  if (!h10) return l10;
  const f10 = { x: Pmt(h10.x, s10) - Pmt(a10.Left, 1), y: Pmt(h10.y, s10) - Pmt(a10.Top, 1) };
  const g10 = { Top: 0, Left: 0, Width: o10.PrintWidth, Height: 0 };
  let y10 = [$at(u10(m10, g10), f10)];
  if (y10 = Gat(y10), i10) {
    y10 = i10.solveMove(y10).movingRectangles;
  }
  const [v10] = y10;
  const b10 = c10.getFeature(o10.Type, "getChildren");
  const S10 = (_b2 = b10 == null ? void 0 : b10(o10)) != null ? _b2 : [];
  const C10 = c10.getFeature(e14, "isCrossSectionItem");
  const { section: x10, sectionTop: w10 } = C10 ? { section: S10[0], sectionTop: 0 } : aht(v10.Top, S10);
  const T10 = d10(m10, { Left: v10.Left, Top: v10.Top - w10, Width: v10.Width, Height: v10.Height });
  const E10 = GB();
  l10.push(wtt({ type: e14, name: t10, id: E10, properties: T10 }, x10.$path));
  const F10 = `${x10.$path}.Controls.${E10}`;
  return l10.push(sB(F10)), l10;
}
oht.displayName = "RPX:Item";
const [lht] = Dp("rpx-section");
const [cht, , uht] = Dp("section-header");
const [dht] = uht("primary");
const [pht] = uht("hidden");
const mht = tp.memo((e14) => {
  var _a2, _b2;
  const { section: t10, section: { Height: n10, Controls: r10, Name: o10, Type: a10, BackColor: i10 }, getDropTargetRect: s10, showLabel: l10 } = e14;
  const { instanceId: c10, userPreferences: u10 } = MO();
  const { lockLayout: d10 } = KO.of(c10);
  const { surface: { showGrid: p10, zoomFactor: m10 }, units: h10 } = u10;
  const f10 = nz.of(c10);
  const { reportRef: g10 } = ep.useContext(Mmt);
  const y10 = PA();
  const v10 = ep.useMemo(() => L$.fromTwips(n10, h10).css, [n10, h10]);
  const b10 = (_b2 = (_a2 = g10.current) == null ? void 0 : _a2.PrintWidth) != null ? _b2 : 0;
  const S10 = ep.useMemo(() => ({ Left: 0, Top: 0, Width: b10, Height: n10 }), [b10, n10]);
  const [, C10] = are({ accept: ["rpx-control-move", "rpx-control-resize", "rpx-point-move", "rpx-rectangle-rounding", "toolboxItem", "field", "parameter"], canDrop: (e15) => {
    if (d10 || "toolboxItem" !== e15.type) return true;
    if (!!!f10.getFeature(e15.itemType, "isCrossSectionItem")) return true;
    return !!f10.getFeature(a10, "canContainCrossSectionItems");
  }, drop: (e15, t11) => {
    const n11 = g10.current;
    if (d10 || !n11) return;
    const { type: r11 } = e15;
    if ("rpx-control-move" === r11) {
      const r12 = function(e16, t12, n12, r13, o11) {
        var _a3;
        const a11 = [];
        const { copiedDocumentItems: i11, snapSolver: s11 } = e16;
        const l11 = iht(t12, r13, o11);
        if (!l11) return a11;
        let c11 = i11.map((e17) => $at(e17.rect, l11));
        if (c11 = Gat(c11).sort((e17, t13) => e17.Top - t13.Top), s11) {
          const e17 = s11.solveMove(c11);
          c11 = e17.movingRectangles.sort((e18, t13) => e18.Top - t13.Top);
        }
        const u11 = nz.of(n12);
        const d11 = u11.getFeature(r13.Type, "getChildren");
        const p11 = (_a3 = d11 == null ? void 0 : d11(r13)) != null ? _a3 : [];
        const m11 = t12.getClientOffset();
        if (!m11) return a11;
        const h11 = Dmt(m11, r13.PageSettings, o11);
        const f11 = document.querySelector(".rpx-page__content").getBoundingClientRect();
        const g11 = Dmt({ x: f11.left * o11, y: f11.top * o11 }, r13.PageSettings, o11);
        const y11 = h11.y - g11.y;
        let v11 = "";
        const b11 = [];
        const S11 = /* @__PURE__ */ new Map([[c11[0].Top, 0]]);
        for (let e17 = 1; e17 < c11.length; e17++) {
          const t13 = c11[0];
          const n13 = c11[e17];
          const r14 = n13.Top - t13.Top;
          S11.set(n13.Top, r14);
        }
        return i11.sort((e17, t13) => e17.rect.Top - t13.rect.Top).forEach(({ documentItem: e17, rect: t13, isPrimary: n13, isLeaf: r14 }, o12) => {
          var _a4;
          const i12 = c11[o12];
          const { section: s12, sectionTop: l12 } = aht(y11, p11);
          const d12 = i12.Top - l12;
          const m12 = (_a4 = S11.get(i12.Top)) != null ? _a4 : 0;
          const h12 = { Left: i12.Left, Top: d12 <= 0 ? m12 : d12, Width: t13.Width, Height: t13.Height };
          if (e17.$path.startsWith(s12.$path)) a11.push(Mtt({ left: h12.Left, top: h12.Top }, e17.$path)), n13 && r14 ? v11 = e17.$path : b11.push(e17.$path);
          else {
            const t14 = u11.getFeature(e17.Type, "setRectangle");
            if (!t14) return;
            const o13 = t14(e17, h12);
            a11.push(Ttt(e17.$path));
            const i13 = function(e18) {
              const t15 = e18.$path.split(".");
              return t15[t15.length - 1];
            }(e17);
            a11.push(wtt({ type: e17.Type, name: e17.Name, id: i13, properties: o13 }, s12.$path));
            const l13 = `${s12.$path}.Controls.${i13}`;
            n13 && r14 ? v11 = l13 : b11.push(l13);
          }
        }), v11 || ([v11] = b11, b11.splice(0, 1)), a11.push(uB(v11, b11)), a11;
      }(e15, t11, c10, n11, m10);
      y10(rz(r12));
    } else if ("rpx-control-resize" === r11) {
      const r12 = function(e16, t12, n12, r13, o11) {
        var _a3;
        const a11 = [];
        const { resizedDocumentItems: i11, snapSolver: s11, resizeDirection: l11 } = e16;
        const c11 = iht(t12, r13, o11);
        if (!c11) return a11;
        const u11 = nz.of(n12).getFeature(r13.Type, "getChildren");
        const d11 = (_a3 = u11 == null ? void 0 : u11(r13)) != null ? _a3 : [];
        let { sectionTop: p11 } = aht(0, d11);
        let m11 = i11.map((e17) => (p11 = aht(e17.rect.Top, d11).sectionTop, Uat(e17.rect, c11, l11)));
        if (s11) {
          const e17 = s11.solveResize(m11, l11);
          m11 = e17.movingRectangles;
        }
        return i11.forEach(({ documentItem: e17 }, t13) => {
          const n13 = m11[t13];
          const r14 = { left: n13.Left, top: n13.Top - p11, width: n13.Width, height: n13.Height };
          a11.push(ktt(r14, e17.$path));
        }), a11;
      }(e15, t11, c10, n11, m10);
      y10(rz(r12));
    } else if ("rpx-point-move" === r11) {
      const r12 = function(e16, t12, n12, r13) {
        const { documentItem: o11, point: a11, index: i11, sectionTop: s11, snapSolver: l11 } = e16;
        const c11 = iht(t12, n12, r13);
        if (!c11 || !o11) return;
        let u11 = { x: Math.max(0, a11.x + c11.x), y: Math.max(0, a11.y + c11.y) };
        l11 && (u11.y += s11, u11 = l11.solvePointMove(u11).point, u11.y -= s11);
        return Ntt({ point: u11, index: i11 }, o11.$path);
      }(e15, t11, n11, m10);
      r12 && y10(r12);
    } else {
      const r12 = az.of(c10);
      if ("toolboxItem" === e15.type) {
        const o11 = r12.getNextDocumentItemName(e15.itemType);
        const a11 = sht(e15.itemType, o11, t11, c10, n11, s10(), e15.snapSolver, m10);
        y10(rz(a11));
      }
      if ("field" === e15.type || "parameter" === e15.type) {
        const o11 = "field" === e15.type ? e15.field.Name : e15.key;
        const a11 = sht("TextBox", eht(o11) ? r12.getNextNameByTemplate(`txt${o11}`) : r12.getNextDocumentItemName("TextBox"), t11, c10, n11, s10(), e15.snapSolver, m10);
        a11.push(iB(stt("", "", "string", "Text"), o11)), a11.push(iB(stt("", "", "string", "DataField", "both"), "field" === e15.type ? o11 : `param:${o11}`)), y10(rz(a11));
      }
    }
  } });
  const x10 = { height: v10, backgroundColor: i10 };
  const w10 = { in: L$.parse("0.25in"), cm: L$.parse("0.5cm") };
  const T10 = !!t10.Height;
  const E10 = ij(t10);
  const F10 = !E10 && L$.fromTwips(t10.Height, h10).lowerThan(w10[h10]);
  const M10 = kp(cht, E10 ? dht : "", F10 ? pht : "");
  const k10 = "Transparent" === i10 ? "White" : i10;
  return tp.createElement("div", { className: lht, style: x10, "data-path": t10.$path, ref: C10, "data-type": a10, "data-name": o10 }, T10 && l10 && tp.createElement("div", { key: "sectionHeader", className: M10 }, o10), T10 && tp.createElement(Kmt, { documentItem: t10, isSection: true, isMultipleSections: l10 }), p10 && tp.createElement(_mt, { id: o10 }), Object.values(r10).map((e15) => tp.createElement(oht, { key: `${e15.$path}-${e15.Type}-${e15.Name}`, item: e15, sectionRect: S10, parentBackgroundColor: k10 })));
});
mht.displayName = "RPX:Section";
const hht = (e14) => {
  const { documentItem: t10, rect: n10 } = e14;
  const { instanceId: r10 } = qHe();
  const { lockLayout: o10 } = KO.of(r10);
  const { dndPreview: a10, setRectangle: i10 } = ep.useMemo(() => {
    const e15 = nz.of(r10);
    return { dndPreview: e15.getFeature(t10.Type, "dndPreview"), setRectangle: e15.getFeature(t10.Type, "setRectangle") };
  }, []);
  if (o10) return null;
  if (!a10) return null;
  const s10 = { documentItem: i10(t10, n10), rect: n10 };
  return tp.createElement(a10, s10);
};
const fht = (e14) => {
  const { dragItem: t10, dragItem: { type: n10, snapSolver: r10 }, pageMargins: o10, zoomFactor: a10, offset: i10 } = e14;
  const s10 = "toolboxItem" === n10 ? t10.itemType : "TextBox";
  const { instanceId: l10 } = MO();
  const c10 = nz.of(l10);
  const u10 = ep.useRef(null);
  const d10 = Pz();
  const p10 = ep.useMemo(() => {
    var _a2;
    const e15 = c10.getFeature(d10.Type, "getChildren");
    return ((_a2 = e15 == null ? void 0 : e15(d10)) != null ? _a2 : []).map((e16) => e16.Height);
  }, [d10]);
  const m10 = ep.useMemo(() => c10.create(s10), [s10]);
  const h10 = (u10 == null ? void 0 : u10.current) && (u10 == null ? void 0 : u10.current.getBoundingClientRect());
  const f10 = { Left: (h10 == null ? void 0 : h10.left) || 0, Top: (h10 == null ? void 0 : h10.top) || 0, Width: (h10 == null ? void 0 : h10.width) || 0, Height: (h10 == null ? void 0 : h10.height) || 0 };
  const g10 = ep.useMemo(() => {
    const e15 = Lmt({ x: 0, y: 0 }, o10, a10);
    return { x: Pmt(e15.x, a10), y: Pmt(e15.y, a10) };
  }, [o10, a10]);
  const y10 = { x: Pmt(i10.x, a10) - Pmt(f10.Left, 1) - g10.x, y: Pmt(i10.y, a10) - Pmt(f10.Top, 1) - g10.y };
  const v10 = c10.getFeature(s10, "getRectangle");
  if (!v10) return null;
  let b10 = v10(m10, { Top: 0, Left: 0, Width: d10.PrintWidth, Height: 0 });
  if (b10 = __spreadProps(__spreadValues({}, b10), { Left: y10.x, Top: y10.y }), [b10] = Gat([b10]), r10) {
    const e15 = r10.solveMove([b10]);
    [b10] = e15.movingRectangles;
  }
  return "toolboxItem" === n10 && c10.getFeature(s10, "isCrossSectionItem") && (b10.Height = ((e15, t11, n11) => {
    let r11 = 0;
    const o11 = e15.findIndex((e16) => (r11 += e16, t11 < r11));
    const a11 = e15.length - 1 - o11;
    let i11 = r11 - t11;
    for (let t12 = o11 + 1; t12 < a11; t12++) i11 += e15[t12];
    return i11 += n11, i11;
  })(p10, b10.Top, m10.Bottom)), tp.createElement("div", { className: "drag-layer", style: { zoom: a10 }, ref: u10 }, tp.createElement(hht, { documentItem: m10, rect: $at(b10, g10) }));
};
fht.displayName = "ControlCreateDragLayer";
const ght = (e14) => {
  const { dragItem: t10, pageMargins: n10, zoomFactor: r10, deltaXY: o10 } = e14;
  const { copiedDocumentItems: a10, snapSolver: i10 } = t10;
  const s10 = ep.useMemo(() => {
    const e15 = Lmt({ x: 0, y: 0 }, n10, r10);
    return { x: Pmt(e15.x, r10), y: Pmt(e15.y, r10) };
  }, [n10, r10]);
  const l10 = { x: Pmt(o10.x, r10), y: Pmt(o10.y, r10) };
  let c10 = a10.map((e15) => $at(e15.rect, l10));
  if (c10 = Gat(c10), i10) {
    const e15 = i10.solveMove(c10);
    c10 = e15.movingRectangles;
  }
  return tp.createElement("div", { className: "drag-layer", style: { zoom: r10 } }, a10.map((e15, t11) => tp.createElement(hht, { documentItem: e15.documentItem, rect: $at(c10[t11], s10), key: e15.documentItem.$path })));
};
ght.displayName = "ControlMoveDragLayer";
const yht = (e14) => {
  const { dragItem: t10, pageMargins: n10, zoomFactor: r10, deltaXY: o10 } = e14;
  const { resizedDocumentItems: a10, resizeDirection: i10, snapSolver: s10 } = t10;
  const l10 = ep.useMemo(() => {
    const e15 = Lmt({ x: 0, y: 0 }, n10, r10);
    return { x: Pmt(e15.x, r10), y: Pmt(e15.y, r10) };
  }, [n10, r10]);
  const c10 = { x: Pmt(o10.x, r10), y: Pmt(o10.y, r10) };
  let u10 = a10.map((e15) => Uat(e15.rect, c10, i10));
  if (s10) {
    const e15 = s10.solveResize(u10, i10);
    u10 = e15.movingRectangles;
  }
  return tp.createElement("div", { className: "drag-layer", style: { zoom: r10 } }, a10.map((e15, t11) => tp.createElement(hht, { documentItem: e15.documentItem, rect: $at(u10[t11], l10), key: e15.documentItem.$path })));
};
yht.displayName = "ControlMoveDragLayer";
const vht = (e14) => {
  const { dragItem: { documentItem: t10, point: n10, index: r10, sectionTop: o10, snapSolver: a10 }, pageMargins: i10, deltaXY: s10, zoomFactor: l10 } = e14;
  const { instanceId: c10 } = qHe();
  const u10 = ep.useMemo(() => {
    const e15 = Lmt({ x: 0, y: 0 }, i10, l10);
    return { x: Pmt(e15.x, l10), y: Pmt(e15.y, l10) + o10 };
  }, [i10, l10]);
  if (!t10) return null;
  const d10 = nz.of(c10);
  const p10 = d10.getFeature(t10.Type, "setPoint");
  const m10 = d10.getFeature(t10.Type, "dndPreview");
  const h10 = d10.getFeature(t10.Type, "getRectangle");
  if (!p10 || !m10 || !h10) return null;
  const f10 = Pmt(s10.x, l10), g10 = Pmt(s10.y, l10);
  let y10 = { x: Math.max(0, n10.x + f10), y: Math.max(0, n10.y + g10) };
  if (a10) {
    y10.y += o10;
    y10 = a10.solvePointMove(y10).point, y10.y -= o10;
  }
  const v10 = p10(t10, y10, r10);
  const b10 = h10(v10);
  const S10 = { documentItem: v10, rect: $at(b10, u10) };
  return tp.createElement("div", { className: "drag-layer", style: { zoom: l10 } }, tp.createElement(m10, S10));
};
vht.displayName = "PointMoveDragLayer";
const bht = (e14) => {
  const { deltaXY: t10, dragItem: n10 } = e14;
  const r10 = tp.useRef(null);
  const { startXY: o10, scrollDetector: a10 } = n10;
  const { scrollOffset: i10, detectScrollOffset: s10 } = a10;
  const l10 = Hmt(o10, t10, i10);
  r10.current && s10(r10.current);
  const c10 = { left: `${l10.Left}px`, top: `${l10.Top}px`, width: `${l10.Width}px`, height: `${l10.Height}px` };
  return tp.createElement("div", { ref: r10, className: "drag-layer" }, tp.createElement("div", { className: "rectangle-area-frame", style: c10 }));
};
bht.displayName = "RectangleAreaSelectDragLayer";
const Sht = ({ pageMargins: e14, zoomFactor: t10 }) => {
  const n10 = (r10 = (e15) => ({ isDragging: e15.isDragging(), dragItem: e15.getItem(), deltaXY: e15.getDifferenceFromInitialOffset(), offset: e15.getClientOffset() }), o10 = Lne().getMonitor(), a10 = ire(Fne(o10, r10), 2), i10 = a10[0], s10 = a10[1], ep.useEffect(function() {
    return o10.subscribeToOffsetChange(s10);
  }), ep.useEffect(function() {
    return o10.subscribeToStateChange(s10);
  }), i10);
  var r10, o10, a10, i10, s10;
  const { isDragging: l10, deltaXY: c10, dragItem: u10, offset: d10 } = n10;
  if (!(l10 && c10 && u10 && d10)) return null;
  const { type: p10 } = u10;
  return "rpx-control-move" === p10 ? tp.createElement(ght, { deltaXY: c10, dragItem: u10, pageMargins: e14, zoomFactor: t10 }) : "rpx-control-resize" === p10 ? tp.createElement(yht, { deltaXY: c10, dragItem: u10, pageMargins: e14, zoomFactor: t10 }) : "rectangle-area-select" === p10 ? tp.createElement(bht, { deltaXY: c10, dragItem: u10 }) : "rpx-point-move" === p10 ? tp.createElement(vht, { deltaXY: c10, dragItem: u10, pageMargins: e14, zoomFactor: t10 }) : "toolboxItem" === p10 || "field" === p10 || "parameter" === p10 ? tp.createElement(fht, { dragItem: u10, offset: d10, pageMargins: e14, zoomFactor: t10 }) : tp.createElement("div", { className: "drag-layer" }, " ");
};
Sht.displayName = "DragLayer";
const [Cht, , xht] = Dp("rpx-area-selector");
const [wht] = xht("drag-source");
const Tht = (e14) => {
  const { onSelect: t10, children: n10 } = e14;
  const r10 = Elt();
  const [, o10, a10] = Yne({ item: { type: "rectangle-area-select", startXY: { x: 0, y: 0 }, scrollDetector: r10 }, begin: (e15) => {
    const t11 = e15.getInitialClientOffset();
    const n11 = e15.getInitialSourceClientOffset();
    const o11 = { x: t11.x - n11.x, y: t11.y - n11.y };
    return r10.reset(), { type: "rectangle-area-select", startXY: o11, scrollDetector: r10 };
  } });
  const i10 = ep.useRef(null);
  const [, s10] = are({ accept: ["rectangle-area-select", "rpx-rectangle-rounding"], drop: (e15, n11) => {
    const r11 = n11.getDifferenceFromInitialOffset();
    const { startXY: o11, scrollDetector: a11 } = n11.getItem();
    if (!r11 || !o11) return;
    const { scrollOffset: i11 } = a11;
    const s11 = Hmt(o11, r11, i11);
    t10(s11);
  }, hover(e15, t11) {
    if ("rpx-rectangle-rounding" === e15.type) {
      const { gripSide: n11, transformGrip: r11 } = e15;
      const o11 = t11.getDifferenceFromInitialOffset();
      if (o11) {
        r11(h2e.getOffset(o11, n11));
      }
    }
  } });
  return s10(i10), ep.useEffect(() => {
    a10(Coe(), { captureDraggingState: true });
  }, [a10]), tp.createElement("div", { className: Cht, ref: i10 }, tp.createElement("div", { className: wht, ref: o10 }, n10));
};
const [Eht, , Fht] = Dp("rpx-page");
const [Mht] = Fht("content");
const [kht] = Fht("gutter");
const Pht = (e14) => {
  const { PrintWidth: t10, PageSettings: n10, Sections: r10 } = e14;
  const { instanceId: o10, userPreferences: a10 } = MO();
  const { surface: { zoomFactor: i10 }, units: s10 } = a10;
  const l10 = PA();
  const c10 = ep.useRef(null);
  const { paddingTop: u10, paddingRight: d10, paddingBottom: p10, paddingLeft: m10, gutter: h10, pageWidth: f10 } = ep.useMemo(() => function(e15, t11, n11, r11) {
    const { GutterMargin: o11, TopMargin: a11, RightMargin: i11, BottomMargin: s11, LeftMargin: l11 } = e15;
    const c11 = L$.fromTwips(l11, r11);
    const u11 = L$.fromTwips(i11, r11);
    const d11 = L$.fromTwips(o11, r11);
    const p11 = L$.fromTwips(a11, r11);
    const m11 = L$.fromTwips(s11, r11);
    const h11 = n11.reduce((e16, t12) => e16 + t12.Height, 0);
    const f11 = L$.fromTwips(h11, r11).add(p11).add(m11).css;
    const g11 = L$.fromTwips(t11, r11).add(c11).add(u11).add(d11).css;
    return { paddingTop: p11.css, paddingRight: u11.css, paddingBottom: m11.css, paddingLeft: c11.add(d11).css, gutter: o11 > 0 ? d11.css : void 0, pageWidth: g11, pageHeight: f11 };
  }(n10, t10, r10, s10), [n10, t10, r10, s10]);
  const g10 = { paddingTop: u10, paddingRight: d10, paddingBottom: p10, paddingLeft: m10, width: f10, zoom: i10 };
  const y10 = ep.useCallback(() => {
    const e15 = (c10 == null ? void 0 : c10.current) && (c10 == null ? void 0 : c10.current.getBoundingClientRect());
    return { Left: (e15 == null ? void 0 : e15.left) || 0, Top: (e15 == null ? void 0 : e15.top) || 0, Width: (e15 == null ? void 0 : e15.width) || 0, Height: (e15 == null ? void 0 : e15.height) || 0 };
  }, []);
  return tp.createElement(Tht, { onSelect: (e15) => {
    const a11 = function(e16, t11, n11) {
      const { topLeft: r11, bottomRight: o11 } = ((e17) => ({ topLeft: { x: e17.Left, y: e17.Top }, bottomRight: { x: e17.Left + e17.Width, y: e17.Top + e17.Height } }))(e16);
      return a12 = Dmt(r11, t11, n11), i11 = Dmt(o11, t11, n11), { Top: a12.y, Left: a12.x, Width: i11.x - a12.x, Height: i11.y - a12.y };
      var a12, i11;
    }(e15, n10, i10);
    const [s11, c11] = function(e16, t11, n11, r11) {
      const o11 = __spreadValues({}, r11);
      const a12 = { Top: 0, Left: 0, Width: n11, Height: 0 };
      const i11 = nz.of(e16);
      const s12 = [];
      const l11 = [];
      for (const e17 of t11) {
        a12.Height = e17.Height, zat(o11, a12) && l11.push(e17.$path);
        for (const n12 of Object.values(e17.Controls)) {
          const e18 = i11.getFeature(n12.Type, "getRectangle");
          e18 && (zat(o11, e18(n12, a12, t11)) && s12.push(n12.$path));
        }
        o11.Top -= e17.Height;
      }
      return [s12, l11];
    }(o10, r10, t10, a11);
    if (s11.length) {
      const [e16, ...t11] = s11;
      l10(uB(e16, t11));
    } else if (c11.length) {
      const [e16, ...t11] = c11;
      l10(uB(e16, t11));
    } else l10(sB(""));
  } }, tp.createElement("div", { className: "rpx-page-wrapper" }, tp.createElement("div", { className: Eht, style: g10 }, h10 && tp.createElement("div", { className: kht, style: { width: h10 } }), tp.createElement("div", { className: Mht, ref: c10 }, r10.map((e15) => tp.createElement(mht, { section: e15, showLabel: r10.length > 1, key: e15.$path, getDropTargetRect: y10 }))))), tp.createElement(Sht, { pageMargins: n10, zoomFactor: i10 }));
};
Pht.displayName = "RPX:Page";
const Nht = () => {
  const e14 = Pz();
  const { API: t10 } = ep.useContext(Sm);
  const { contextActions: n10 } = Mz();
  const { instanceId: r10 } = qHe();
  const o10 = PA();
  const { t: a10 } = vp();
  const i10 = ep.useRef(e14);
  i10.current = e14;
  const [s10, l10] = ep.useState(null);
  ep.useEffect(() => {
    s10 && (u10(s10), l10(null));
  }, [n10]);
  const c10 = (e15, t11) => {
    o10(_A.of(r10).open(e15, t11));
  };
  const u10 = (e15) => {
    if (!n10) return;
    const r11 = Z1e(n10, "contextmenu");
    const i11 = j1e(r11).flatMap((e16) => z1e(e16, a10, o10, c10));
    t10.contextMenu.open(e15, i11);
  };
  const d10 = (e15, t11) => {
    const { $path: n11 } = e15;
    o10(t11 ? rj(e15) ? cB(n11) : lB(n11) : sB(n11));
  };
  const p10 = (t11) => {
    const n11 = t11.closest("[data-path]");
    return jN((n11 == null ? void 0 : n11.getAttribute("data-path")) || "")(e14 || {});
  };
  const m10 = (e15) => Boolean(e15 == null ? void 0 : e15.closest(`.${Zdt}`));
  const h10 = ep.useMemo(() => {
    if (!e14) return [];
    const t11 = nz.of(r10).getFeature(e14.Type, "getChildren");
    return t11 ? t11(e14) : [];
  }, [r10, e14]);
  const f10 = ep.useMemo(() => ({ reportRef: i10, sections: h10 }), [h10]);
  if (!e14) return null;
  const { PrintWidth: g10, PageSettings: y10 } = e14;
  const v10 = { Sections: h10, PrintWidth: g10, PageSettings: y10 };
  const b10 = { Sections: h10, PrintWidth: g10, PageSettings: y10 };
  return tp.createElement("div", { className: "rpx-surface", onContextMenu: (e15) => {
    const { target: t11 } = e15;
    if (!m10(t11)) return;
    const r11 = p10(t11);
    e15.preventDefault();
    const o11 = { x: e15.clientX, y: e15.clientY };
    n10 && rj(r11) ? u10(o11) : (d10(r11, SB(e15)), l10(o11));
  }, onClick: (e15) => {
    const { target: t11 } = e15;
    if (!m10(t11)) return;
    const n11 = p10(t11);
    l10(null), d10(n11, SB(e15));
  } }, tp.createElement(Mmt.Provider, { value: f10 }, tp.createElement(bF, null, tp.createElement(Fmt, __spreadValues({}, b10), tp.createElement(Pht, __spreadValues({}, v10))))));
};
Nht.displayName = "RPX:Surface";
const Dht = ({ makeSharedImageUrl: e14, decorationLayerRef: t10, workspaceId: n10 }) => {
  const r10 = M$e.useParametersViewSurface();
  const { document: { present: { content: o10 } }, rdlx: { reportStyles: a10, theme: i10 } } = d9();
  const s10 = ep.useMemo(() => ({ item: o10, theme: i10, reportStyles: a10, decorationLayerRef: t10, makeSharedImageUrl: e14 }), [o10, t10, e14, a10, i10]);
  return n10 === M$e.workspaceId ? tp.createElement(M$e.Surface, __spreadValues({}, r10)) : tp.createElement(fmt, __spreadValues({}, s10));
};
const Lht = (e14) => {
  const { type: { platform: t10 } } = kz();
  const [n10] = Nz();
  let r10 = null;
  return r10 = "rdlx" === t10 ? tp.createElement(Dht, __spreadProps(__spreadValues({}, e14), { workspaceId: n10 })) : n10 === mit ? tp.createElement(pit, null) : tp.createElement(Nht, null), tp.createElement(tp.Fragment, null, r10, tp.createElement(YA, null));
};
const Hht = { right: { x: 1, y: 0 }, left: { x: -1, y: 0 }, up: { x: 0, y: -1 }, down: { x: 0, y: 1 } };
const Iht = (e14) => Hht[e14];
const _ht = (e14, t10, n10, r10) => {
  const o10 = t10 && L$.isValidString(t10) ? L$.parse(t10) : L$.parse(/* @__PURE__ */ ((e15) => "cm" !== e15 ? "0.25in" : "0.5cm")(r10));
  return YG({ grip: n10, delta: { x: o10.multiply(e14.x).css, y: o10.multiply(e14.y).css } });
};
const Vht = (e14, t10, n10, r10, o10) => {
  const { movedItems: a10, lockedItems: i10, primaryLeafIsLocked: s10 } = ((e15) => {
    let t11 = false;
    const n11 = !!e15.$masterReportContent;
    const r11 = [];
    const o11 = [];
    return C3(e15, (a11, i11) => {
      if (!aj(i11)) return null;
      if (rj(i11)) {
        const a12 = i11.Name;
        if (a12) {
          if ("contentplaceholder" === i11.Type && n11) return void o11.push(a12);
          k3(i11, e15).isLocked ? ij(i11) ? (o11.unshift(a12), t11 = true) : o11.push(a12) : ij(i11) ? r11.unshift(a12) : r11.push(a12);
        }
      }
    }), { movedItems: r11, lockedItems: o11, primaryLeafIsLocked: t11 };
  })(t10);
  return a10.length ? i10.length ? rz([h5(a10), _ht(e14, n10, r10, o10), h5(s10 ? i10.concat(a10) : a10.concat(i10))]) : _ht(e14, n10, r10, o10) : null;
};
const Rht = (e14, t10) => {
  const n10 = ((e15) => {
    let t11 = null;
    return C3(e15, (e16, n11, r11) => {
      if (sj(n11)) return t11 = { name: nW(n11) ? n11.Name : "", type: n11.Type || "", parentName: r11 && nW(r11) ? r11.Name : "" }, null;
    }), t11;
  })(e14);
  if (!n10 || !n10.name) return null;
  const { surface: { snapToGrid: r10, snapToLines: o10, gridSize: a10 } } = t10;
  return U0e(e14, n10.name, n10.type, n10.parentName, o10, r10, (e15, t11) => t11, (t11) => k3(t11, e14).isVisible, a10);
};
const Aht = (e14, t10, n10) => {
  const [r10, o10] = ["x", "y"].map((n11) => {
    const [r11, o11] = [e14.fixedPoints[n11], e14.movingPoints[n11]];
    if (t10[n11] <= 0 && r11.reverse(), !o11.length) return 0;
    let a10 = 0;
    return o11.forEach((e15) => {
      const o12 = r11.find((r12) => t10[n11] * r12.pos.pabs > t10[n11] * e15.pos.pabs + 20);
      if (!o12) return;
      const i10 = Math.abs(o12.pos.pabs - e15.pos.pabs);
      (!a10 || i10 < a10 && i10 > 20) && (a10 = i10);
    }), a10;
  }).map((e15) => L$.fromTwips(e15, n10).round(2).css);
  return { dx: r10, dy: o10 };
};
const Oht = (e14) => "in" === e14 ? "0.01in" : "0.025cm";
const Bht = (e14) => "up" === e14 || "down" === e14 ? qG.S : "left" === e14 || "right" === e14 ? qG.E : qG.ME;
const zht = (e14) => {
  let t10 = e14;
  return fj(e14, (e15) => (e15.Type && ij(e15) && (rj(e15) || !Lj(e15) && !VW(e15.Type) || (t10 = e15)), null)), t10;
};
const $ht = (e14) => {
  const t10 = zht(e14);
  const n10 = sj(e14);
  const r10 = [];
  const o10 = (n11) => n11 !== t10 && ((e15) => !!e15 && (Lj(e15) || nj(e15.Type)))(n11) && n11.Name && k3(n11, e14).isVisible;
  return C3(t10, (e15, a10) => o10(a10) ? (sj(a10) ? r10.unshift(a10.Name) : r10.push(a10.Name), null) : ((e16) => e16 === t10 || (ij(e16) || n10 || ((e17) => "section" === e17.Type && e17.$dashboard)(e16)) && AW(e16.Type))(a10) ? void 0 : null), r10;
};
function Wht(e14, t10, n10) {
  let r10 = null;
  const o10 = (t11, n11 = false) => {
    if (n11) {
      for (let n12 = e14.length - 1; n12 >= 0; n12--) if (e14[n12]) {
        for (let r11 = e14[n12].length - 1; r11 >= 0; r11--) if (e14[n12][r11] && t11(e14[n12][r11])) return e14[n12][r11];
      }
    } else for (let n12 = 0; n12 < e14.length; n12++) if (e14[n12]) {
      for (let r11 = 0; r11 < e14[n12].length; r11++) if (e14[n12][r11] && t11(e14[n12][r11])) return e14[n12][r11];
    }
    return null;
  };
  switch (n10) {
    case "down":
      r10 = o10((e15) => t10.rowIdx + t10.rowSpan === e15.rowIdx && e15.colIdx <= t10.colIdx && t10.colIdx < e15.colIdx + e15.colSpan);
      break;
    case "up":
      r10 = o10((e15) => t10.rowIdx === e15.rowIdx + e15.rowSpan && e15.colIdx <= t10.colIdx && t10.colIdx < e15.colIdx + e15.colSpan);
      break;
    case "right":
      r10 = o10((e15) => t10.colIdx + t10.colSpan === e15.colIdx && e15.rowIdx <= t10.rowIdx && t10.rowIdx < e15.rowIdx + e15.rowSpan);
      break;
    case "left":
      r10 = o10((e15) => t10.colIdx === e15.colIdx + e15.colSpan && e15.rowIdx <= t10.rowIdx && t10.rowIdx < e15.rowIdx + e15.rowSpan);
      break;
    case "next": {
      let e15 = false;
      r10 = o10((n11) => t10 === n11 ? (e15 = true, false) : !!e15), r10 || (r10 = o10(() => true));
      break;
    }
    case "prev": {
      let e15 = false;
      r10 = o10((n11) => t10 === n11 ? (e15 = true, false) : !!e15, true), r10 || (r10 = o10(() => true, true));
      break;
    }
    case "first":
      r10 = o10((e15) => 0 === e15.colIdx && 0 === e15.rowIdx, false);
      break;
    case "last":
      r10 = o10((t11) => t11.colIdx + t11.colSpan === e14[0].length && t11.rowIdx + t11.rowSpan === e14.length, true);
  }
  return r10;
}
const jht = (e14) => {
  const t10 = zht(e14);
  return "tablix" === t10.Type || "fixedpagetablix" === t10.Type ? ((e15) => {
    const t11 = e15.RowHierarchy.LevelSizes.length + e15.Body.Columns.length;
    const n10 = e15.ColumnHierarchy.LevelSizes.length + e15.Body.Rows.length;
    const r10 = zV.times(n10, () => zV.times(t11, () => null));
    const o10 = [];
    return RQ(e15, ({ rix: e16, rspan: t12, cix: n11, cspan: a10, item: i10 }) => {
      const s10 = { item: i10, colIdx: n11, colSpan: a10, rowIdx: e16, rowSpan: t12 };
      return r10[e16][n11] = s10, rj(i10) && o10.push(s10), i10;
    }), [r10, o10];
  })(t10) : "table" === t10.Type || "fixedpagetable" === t10.Type ? ((e15) => {
    const t11 = QQ(e15);
    const n10 = JQ(e15);
    const r10 = zV.times(n10, () => zV.times(t11, () => null));
    const o10 = [];
    return XQ(e15, ({ item: e16, rowIdx: t12, colIdx: n11, colSpan: a10, rowSpan: i10 }) => {
      const s10 = { item: e16, colIdx: n11, colSpan: a10, rowIdx: t12, rowSpan: i10 };
      return r10[t12][n11] = s10, rj(e16) && o10.push(s10), e16;
    }), [r10, o10];
  })(t10) : [null, null];
};
const Zht = (e14, t10) => {
  for (let n10 = 0; n10 < e14.length; n10++) if (e14[n10]) for (let r10 = 0; r10 < e14[n10].length; r10++) {
    const o10 = e14[n10][r10];
    o10 && t10(o10);
  }
};
const Ght = (e14, t10, n10, r10, o10) => e14.rowIdx + e14.rowSpan - 1 >= n10 && e14.rowIdx <= o10 && e14.colIdx + e14.colSpan - 1 >= t10 && e14.colIdx <= r10;
const Uht = (e14, t10, n10, r10, o10) => {
  let [a10, i10, s10, l10] = [e14[0].length, e14.length, 0, 0];
  return Zht(e14, (e15) => {
    Ght(e15, t10, n10, r10, o10) && (e15.rowIdx < i10 && (i10 = e15.rowIdx), e15.colIdx < a10 && (a10 = e15.colIdx), e15.rowIdx + e15.rowSpan - 1 > l10 && (l10 = e15.rowIdx + e15.rowSpan - 1), e15.colIdx + e15.colSpan - 1 > s10 && (s10 = e15.colIdx + e15.colSpan - 1));
  }), t10 !== a10 || n10 !== i10 || r10 !== s10 || o10 !== l10 ? Uht(e14, a10, i10, s10, l10) : [a10, i10, s10, l10];
};
const qht = (e14, t10, n10, r10, o10) => {
  let [a10, i10, s10, l10] = [t10, n10, r10, o10];
  return Zht(e14, (e15) => {
    Ght(e15, a10, i10, s10, l10) && (e15.rowIdx < i10 && e15.rowIdx + e15.rowSpan > i10 && (i10 = e15.rowIdx + e15.rowSpan), e15.rowIdx < l10 && e15.rowIdx + e15.rowSpan - 1 > l10 && (l10 = e15.rowIdx - 1), e15.colIdx < a10 && e15.colIdx + e15.colSpan > a10 && (a10 = e15.colIdx + e15.colSpan), e15.colIdx < s10 && e15.colIdx + e15.colSpan - 1 > s10 && (s10 = e15.colIdx - 1));
  }), t10 !== a10 || n10 !== i10 || r10 !== s10 || o10 !== l10 ? qht(e14, a10, i10, s10, l10) : [a10, i10, s10, l10];
};
const Yht = (e14, t10) => {
  const { document: n10 } = e14;
  const [r10, o10] = jht(n10);
  if (!r10 || !o10 || !o10.length) return null;
  const a10 = o10.find((e15) => sj(e15.item));
  if (!a10) return null;
  let [i10, s10, l10, c10] = [r10[0].length, r10.length, 0, 0];
  o10.forEach(({ rowIdx: e15, colIdx: t11, rowSpan: n11, colSpan: r11 }) => {
    e15 < s10 && (s10 = e15), t11 < i10 && (i10 = t11), e15 + n11 - 1 > c10 && (c10 = e15 + n11 - 1), t11 + r11 - 1 > l10 && (l10 = t11 + r11 - 1);
  });
  let [u10, d10, p10, m10] = t10(r10, a10, i10, s10, l10, c10);
  [u10, d10, p10, m10] = Uht(r10, u10, d10, p10, m10);
  const h10 = [];
  Zht(r10, (e15) => {
    e15.rowIdx >= d10 && e15.rowIdx + e15.rowSpan - 1 <= m10 && e15.colIdx >= u10 && e15.colIdx + e15.colSpan - 1 <= p10 && (sj(e15.item) ? h10.unshift(e15.item.Name) : h10.push(e15.item.Name));
  });
  const f10 = o10.length === h10.length && d10 === s10 && u10 === i10;
  return !h10.length || f10 ? null : h5(h10);
};
const Kht = ["textbox", "checkbox", "inputfield"];
const Xht = ["textbox", "checkbox", "inputfield"];
const Jht = ["textbox", "checkbox"];
const Qht = "Bold", eft = "Normal";
const tft = "Italic", nft = "Normal";
const rft = "Underline", oft = "None";
const aft = (e14) => {
  const t10 = zht(e14);
  let n10 = null;
  return C3(e14, x3((e15, r10, o10, { path: a10 }) => aj(r10) && t10.Name === r10.Name ? (n10 = a10, null) : {})), n10;
};
const ift = (e14) => {
  const t10 = zht(e14);
  return "tablix" === t10.Type || "fixedpagetablix" === t10.Type ? lft(t10) : "table" === t10.Type || "fixedpagetable" === t10.Type ? sft(t10) : null;
};
const sft = (e14) => {
  const t10 = n1(e14);
  const n10 = o1(e14);
  const r10 = [];
  return t10.length ? XQ(e14, ({ item: e15, rowIdx: n11, itemPath: o10 }) => {
    t10.includes(n11) && r10.push({ Style: e15.Style, Path: o10, Type: e15.Type });
  }) : n10.length && XQ(e14, ({ item: e15, colIdx: t11, itemPath: o10 }) => {
    n10.includes(t11) && r10.push({ Style: e15.Style, Path: o10, Type: e15.Type });
  }), r10;
};
const lft = (e14) => {
  const t10 = ((e15) => e15.$rows.collection.reduce((e16, t11, n11) => (rj(t11) && e16.push(n11), e16), []))(e14);
  const n10 = ((e15) => e15.$columns.collection.reduce((e16, t11, n11) => (rj(t11) && e16.push(n11), e16), []))(e14);
  const r10 = [];
  return t10.length ? _Q(e14, ({ item: e15, rix: n11, itemPath: o10 }) => {
    t10.includes(n11) && r10.push({ Style: e15.Style, Path: o10, Type: e15.Type });
  }) : n10.length && _Q(e14, ({ item: e15, cix: t11, itemPath: o10 }) => {
    n10.includes(t11) && r10.push({ Style: e15.Style, Path: o10, Type: e15.Type });
  }), r10;
};
const cft = (e14) => e14.some((e15) => e15.Style.FontWeight !== Qht) ? Qht : eft;
const uft = (e14) => e14.some((e15) => e15.Style.FontStyle !== tft) ? tft : nft;
const dft = (e14) => e14.some((e15) => e15.Style.TextDecoration !== rft) ? rft : oft;
const pft = (e14) => (t10) => ((e15, t11) => {
  const { document: n10, settings: { userPreferences: r10, userPreferences: { units: o10, surface: { snapToGrid: a10, snapToLines: i10, gridSize: s10 } } } } = t11;
  const l10 = Iht(e15);
  if (!a10 && !i10) return Vht(l10, n10, s10, qG.MC, o10);
  const c10 = Rht(n10, r10);
  if (!c10) return null;
  const { dx: u10, dy: d10 } = Aht(c10, l10, o10);
  return Vht(l10, n10, "up" === e15 || "down" === e15 ? d10 : u10, qG.MC, o10);
})(e14, t10);
const mft = (e14) => (t10) => ((e15, t11) => {
  const { document: n10, settings: { userPreferences: { units: r10 } } } = t11;
  const o10 = Iht(e15);
  const a10 = Oht(r10);
  return Vht(o10, n10, a10, qG.MC, r10);
})(e14, t10);
const hft = (e14) => (t10) => ((e15, t11) => {
  const { document: n10, settings: { userPreferences: r10, userPreferences: { units: o10, surface: { snapToGrid: a10, snapToLines: i10, gridSize: s10 } } } } = t11;
  const l10 = Iht(e15);
  const c10 = Bht(e15);
  if (!a10 && !i10) return Vht(l10, n10, s10, c10, o10);
  let u10 = Rht(n10, r10);
  if (!u10) return null;
  const d10 = (e16) => ({ $apply: (t12) => t12.filter((t13) => t13.side === e16) });
  u10 = AV(u10, { movingPoints: { x: d10(qG.E), y: d10(qG.S) } });
  const { dx: p10, dy: m10 } = Aht(u10, l10, o10);
  return Vht(l10, n10, "up" === e15 || "down" === e15 ? m10 : p10, c10, o10);
})(e14, t10);
const fft = (e14) => (t10) => ((e15, t11) => {
  const { document: n10, settings: { userPreferences: { units: r10 } } } = t11;
  const o10 = Iht(e15);
  const a10 = Oht(r10);
  return Vht(o10, n10, a10, Bht(e15), r10);
})(e14, t10);
const gft = (e14) => (t10) => ((e15, t11) => {
  const { document: n10 } = t11;
  const [r10, o10] = jht(n10);
  if (!r10 || !o10 || !o10.length) return null;
  const a10 = o10.find((e16) => sj(e16.item));
  if (!a10) return null;
  const i10 = Wht(r10, a10, e15);
  return i10 ? h5([i10.item.Name]) : null;
})(e14, t10);
const yft = (e14) => (t10) => ((e15, t11) => {
  const { document: n10 } = t11;
  const [r10, o10] = jht(n10);
  if (!r10 || !o10 || !o10.length) return null;
  const a10 = [];
  let i10 = null;
  if (o10.forEach((e16) => {
    sj(e16.item) && (i10 = e16), a10.push(e16.item.Name);
  }), !i10) return null;
  const s10 = Wht(r10, i10, e15);
  if (!s10) return null;
  const l10 = s10.item.Name;
  const c10 = a10.findIndex((e16) => e16 === l10);
  return -1 === c10 ? a10.unshift(l10) : (a10.splice(c10, 1), a10.unshift(l10), zV.remove(a10, (e16) => {
    var _a2;
    return e16 === ((_a2 = i10 == null ? void 0 : i10.item) == null ? void 0 : _a2.Name);
  })), h5(a10);
})(e14, t10);
const vft = (e14) => (t10) => ((e15, t11) => Yht(t11, (t12, n10, r10, o10, a10, i10) => {
  const s10 = (e16, t13, s11) => {
    if (!e16) return s11;
    const [l10, c10, u10, d10] = t13;
    return l10 > u10 || c10 > d10 || r10 === l10 && o10 === c10 && a10 === u10 && i10 === d10 || l10 > n10.colIdx || u10 < n10.colIdx || c10 > n10.rowIdx || d10 < n10.rowIdx ? s11 : t13;
  };
  return "down" === e15 ? s10(o10 < n10.rowIdx, qht(t12, r10, o10 + 1, a10, i10), [r10, o10, a10, i10 + 1]) : "up" === e15 ? s10(i10 > n10.rowIdx + n10.rowSpan - 1, qht(t12, r10, o10, a10, i10 - 1), [r10, o10 - 1, a10, i10]) : "right" === e15 ? s10(r10 < n10.colIdx, qht(t12, r10 + 1, o10, a10, i10), [r10, o10, a10 + 1, i10]) : "left" === e15 ? s10(a10 > n10.colIdx + n10.colSpan - 1, qht(t12, r10, o10, a10 - 1, i10), [r10 - 1, o10, a10, i10]) : [r10, o10, a10, i10];
}))(e14, t10);
const bft = (e14) => (t10) => ((e15, t11) => Yht(t11, (t12, n10, r10, o10, a10, i10) => {
  const [s10, l10] = [t12.length, t12[0].length];
  let [c10, u10, d10, p10] = [r10, o10, a10, i10];
  return "down" === e15 ? o10 < n10.rowIdx ? u10 = n10.rowIdx : p10 = s10 : "up" === e15 ? i10 > n10.rowIdx + n10.rowSpan - 1 ? p10 = n10.rowIdx + n10.rowSpan - 1 : u10 = 0 : "right" === e15 ? r10 < n10.colIdx ? c10 = n10.colIdx : d10 = l10 : "left" === e15 && (a10 > n10.colIdx + n10.colSpan - 1 ? d10 = n10.colIdx + n10.colSpan - 1 : c10 = 0), [c10, u10, d10, p10];
}))(e14, t10);
const Sft = (e14) => (t10) => ((e15, t11) => {
  const { document: n10 } = t11;
  const r10 = zht(n10);
  if (o10 = r10, !o10.hasOwnProperty("ReportItems") || !r10.ReportItems) return null;
  var o10;
  const a10 = r10.ReportItems.findIndex((e16) => sj(e16));
  if (-1 === a10) return null;
  const i10 = "next" === e15 ? 1 : -1;
  return h5([r10.ReportItems[(r10.ReportItems.length + a10 + i10) % r10.ReportItems.length].Name]);
})(e14, t10);
const Cft = ({ contextActions: e14 }) => {
  const t10 = e14.find((e15) => "button" === e15.type && "contextActions:container.delete" === e15.key);
  return t10 && !t10.disabled ? t10.action : null;
};
const xft = { ArrowRight: gft("right"), ArrowLeft: gft("left"), ArrowUp: gft("up"), ArrowDown: gft("down"), "Ctrl+ArrowRight": yft("right"), "Ctrl+ArrowLeft": yft("left"), "Ctrl+ArrowUp": yft("up"), "Ctrl+ArrowDown": yft("down"), "Shift+ArrowRight": vft("right"), "Shift+ArrowLeft": vft("left"), "Shift+ArrowUp": vft("up"), "Shift+ArrowDown": vft("down"), "Ctrl+Shift+ArrowRight": bft("right"), "Ctrl+Shift+ArrowLeft": bft("left"), "Ctrl+Shift+ArrowUp": bft("up"), "Ctrl+Shift+ArrowDown": bft("down"), Home: gft("first"), End: gft("last"), Tab: gft("next"), "Shift+Tab": gft("prev") };
const wft = { Tab: Sft("next"), "Shift+Tab": Sft("prev"), ArrowRight: pft("right"), ArrowLeft: pft("left"), ArrowUp: pft("up"), ArrowDown: pft("down"), "Ctrl+ArrowRight": mft("right"), "Ctrl+ArrowLeft": mft("left"), "Ctrl+ArrowUp": mft("up"), "Ctrl+ArrowDown": mft("down"), "Shift+ArrowRight": hft("right"), "Shift+ArrowLeft": hft("left"), "Shift+ArrowUp": hft("up"), "Shift+ArrowDown": hft("down"), "Ctrl+Shift+ArrowRight": fft("right"), "Ctrl+Shift+ArrowLeft": fft("left"), "Ctrl+Shift+ArrowUp": fft("up"), "Ctrl+Shift+ArrowDown": fft("down") };
const Tft = { "Ctrl+KeyA": (e14) => ((e15) => {
  const { document: t10 } = e15;
  const n10 = $ht(t10);
  return n10.length ? h5(n10) : null;
})(e14), "Ctrl+KeyB": (e14) => ((e15) => {
  const { document: t10 } = e15;
  const n10 = yj(t10);
  if (QW(n10[0].Type)) {
    const e16 = ift(t10);
    if (!e16 || e16.some((e17) => !Kht.includes(e17.Type))) return null;
    const n11 = aft(t10);
    const r11 = cft(e16);
    const o10 = e16.map((e17) => c2({ path: `${n11}.${e17.Path}`, descriptor: { valuePath: "Style.FontWeight" }, value: r11 }));
    return rz(o10);
  }
  if (n10.some((e16) => !Kht.includes(e16.Type))) return null;
  const r10 = cft(n10);
  return o2({ descriptor: { valuePath: "Style.FontWeight" }, value: r10 });
})(e14), "Ctrl+KeyI": (e14) => ((e15) => {
  const { document: t10 } = e15;
  const n10 = yj(t10);
  if (QW(n10[0].Type)) {
    const e16 = ift(t10);
    if (!e16 || e16.some((e17) => !Xht.includes(e17.Type))) return null;
    const n11 = aft(t10);
    const r11 = uft(e16);
    const o10 = e16.map((e17) => c2({ path: `${n11}.${e17.Path}`, descriptor: { valuePath: "Style.FontStyle" }, value: r11 }));
    return rz(o10);
  }
  if (n10.some((e16) => !Xht.includes(e16.Type))) return null;
  const r10 = uft(n10);
  return o2({ descriptor: { valuePath: "Style.FontStyle" }, value: r10 });
})(e14), "Ctrl+KeyU": (e14) => ((e15) => {
  const { document: t10 } = e15;
  const n10 = yj(t10);
  if (QW(n10[0].Type)) {
    const e16 = ift(t10);
    if (!e16 || e16.some((e17) => !Jht.includes(e17.Type))) return null;
    const n11 = aft(t10);
    const r11 = dft(e16);
    const o10 = e16.map((e17) => c2({ path: `${n11}.${e17.Path}`, descriptor: { valuePath: "Style.TextDecoration" }, value: r11 }));
    return rz(o10);
  }
  if (n10.some((e16) => !Jht.includes(e16.Type))) return null;
  const r10 = dft(n10);
  return o2({ descriptor: { valuePath: "Style.TextDecoration" }, value: r10 });
})(e14), Delete: Cft, "Ctrl+Backspace": bB ? Cft : void 0 };
const Eft = (e14, t10, n10) => {
  const r10 = function(e15) {
    if (!e15) return null;
    const t11 = zht(e15);
    return t11 ? IW(t11.Type) || tj(t11.Type) ? "grid" : _W(t11.Type) ? "container" : null : null;
  }(n10);
  return "grid" === r10 && xft[e14] ? xft[e14] : "container" === r10 && !t10.lockLayout && wft[e14] ? wft[e14] : Tft[e14] ? Tft[e14] : null;
};
const Fft = { right: { x: 1, y: 0 }, left: { x: -1, y: 0 }, up: { x: 0, y: -1 }, down: { x: 0, y: 1 } };
const Mft = (e14, t10) => e14 && L$.isValidString(e14) ? L$.parse(e14).toPreciseTwips : ((e15) => L$.parse("in" === e15 ? "0.25in" : "0.5cm").toPreciseTwips)(t10);
const kft = (e14) => (t10, n10, r10, o10) => {
  const a10 = Fft[r10];
  const i10 = iit(n10);
  if (!i10.length || KO.of(t10).lockLayout) return null;
  const s10 = nz.of(t10).of("rpx");
  const l10 = [];
  return i10.forEach((t11) => {
    const n11 = s10.getFeature(t11.Type, "getRectangle");
    if (!n11) return;
    const r11 = n11(t11, { Top: 0, Left: 0, Width: 0, Height: 0 });
    const i11 = e14(t11.$path, a10, o10, r11);
    i11 && l10.push(i11);
  }), rz(l10);
};
const Pft = kft((e14, t10, n10, { Left: r10, Top: o10 }) => Mtt({ left: r10 + n10 * t10.x, top: o10 + n10 * t10.y }, e14));
const Nft = kft((e14, t10, n10, { Left: r10, Top: o10, Width: a10, Height: i10 }) => ktt({ left: r10, top: o10, width: a10 + n10 * t10.x, height: i10 + n10 * t10.y }, e14));
const Dft = (e14) => L$.parse("in" === e14 ? "0.01in" : "0.025cm").toPreciseTwips;
const Lft = (e14) => {
  const t10 = ((e15) => {
    const t11 = [];
    if (rj(e15)) return Object.values(e15.Sections).forEach((e16) => Object.values(e16.Controls).forEach((e17) => t11.push(e17.$path))), t11;
    const n10 = Object.values(e15.Sections).find((e16) => e16.$primary);
    return n10 ? (Object.values(n10.Controls).forEach((e16) => {
      e16.$primary ? t11.unshift(e16.$path) : t11.push(e16.$path);
    }), t11) : t11;
  })(e14);
  if (t10.length) {
    const [e15, ...n10] = t10;
    return uB(e15, n10);
  }
  return null;
};
const Hft = (e14, t10) => {
  const n10 = Object.values(t10.Sections).find((e15) => e15.$primary);
  if (!n10) return null;
  const r10 = Object.values(n10.Controls);
  const o10 = r10.findIndex((e15) => e15.$primary);
  if (-1 === o10) return null;
  const a10 = r10[(r10.length + o10 + e14) % r10.length];
  return a10 ? sB(a10.$path) : null;
};
const Ift = "Bold", _ft = "Normal";
const Vft = "Italic", Rft = "Normal";
const Aft = (e14) => e14.every((e15) => e15.hasOwnProperty("Style"));
const Oft = (e14) => (t10) => ((e15, { document: t11, settings: { units: n10, instanceId: r10, userPreferences: o10 } }) => {
  const a10 = Mft(o10.surface.gridSize, n10);
  return Pft(r10, t11, e15, a10);
})(e14, t10);
const Bft = (e14) => (t10) => ((e15, { document: t11, settings: { units: n10, instanceId: r10 } }) => {
  const o10 = Dft(n10);
  return Pft(r10, t11, e15, o10);
})(e14, t10);
const zft = (e14) => (t10) => ((e15, { document: t11, settings: { units: n10, instanceId: r10, userPreferences: o10 } }) => {
  const a10 = Mft(o10.surface.gridSize, n10);
  return Nft(r10, t11, e15, a10);
})(e14, t10);
const $ft = (e14) => (t10) => ((e15, { document: t11, settings: { units: n10, instanceId: r10 } }) => {
  const o10 = Dft(n10);
  return Nft(r10, t11, e15, o10);
})(e14, t10);
const Wft = ({ document: e14 }) => ait(e14).every((e15) => ["ReportHeader", "ReportFooter", "PageHeader", "PageFooter", "GroupHeader", "GroupFooter", "Detail"].includes(e15.Type)) ? Ftt() : Ttt();
const jft = { Tab: ({ document: e14 }) => Hft(1, e14), "Shift+Tab": ({ document: e14 }) => Hft(-1, e14) };
const Zft = { ArrowRight: Oft("right"), ArrowLeft: Oft("left"), ArrowUp: Oft("up"), ArrowDown: Oft("down"), "Ctrl+ArrowRight": Bft("right"), "Ctrl+ArrowLeft": Bft("left"), "Ctrl+ArrowUp": Bft("up"), "Ctrl+ArrowDown": Bft("down"), "Shift+ArrowRight": zft("right"), "Shift+ArrowLeft": zft("left"), "Shift+ArrowUp": zft("up"), "Shift+ArrowDown": zft("down"), "Ctrl+Shift+ArrowRight": $ft("right"), "Ctrl+Shift+ArrowLeft": $ft("left"), "Ctrl+Shift+ArrowUp": $ft("up"), "Ctrl+Shift+ArrowDown": $ft("down"), Delete: Wft, "Ctrl+Backspace": bB ? Wft : void 0 };
const Gft = { "Ctrl+KeyA": ({ document: e14 }) => Lft(e14), "Ctrl+KeyB": ({ document: e14 }) => ((e15) => {
  const t10 = ait(e15);
  if (!Aft(t10)) return null;
  const n10 = t10.some((e16) => e16.Style.FontWeight !== Ift) ? Ift : _ft;
  return iB({ category: "", label: "", type: "string", valuePath: "Style.FontWeight", mode: "both" }, n10);
})(e14), "Ctrl+KeyI": ({ document: e14 }) => ((e15) => {
  const t10 = ait(e15);
  if (!Aft(t10)) return null;
  const n10 = t10.some((e16) => e16.Style.FontStyle !== Vft) ? Vft : Rft;
  return iB({ category: "", label: "", type: "string", valuePath: "Style.FontStyle", mode: "both" }, n10);
})(e14), "Ctrl+KeyU": ({ document: e14 }) => ((e15) => {
  const t10 = ait(e15);
  if (!Aft(t10)) return null;
  const n10 = t10.some((e16) => true !== e16.Style.FontUnderline);
  return iB({ category: "", label: "", type: "string", valuePath: "Style.FontUnderline", mode: "both" }, n10);
})(e14) };
const Uft = (e14, t10, n10) => {
  if (Gft[e14]) return Gft[e14];
  if (!t10.lockLayout) {
    if (jft[e14] && function(e15) {
      if (!e15 || e15.$primary && "leaf" === e15.$selected) return false;
      const t11 = Object.values(e15.Sections);
      const n11 = t11 && t11.find((e16) => e16.$primary);
      return !(!n11 || 0 === Object.keys(n11.Controls).length || !Object.values(n11.Controls).some((e16) => e16.$primary));
    }(n10)) return jft[e14];
    if (Zft[e14]) return Zft[e14];
  }
  return null;
};
const qft = (e14) => {
  var _a2;
  return !((_a2 = e14.meta) == null ? void 0 : _a2.skipUndo);
};
const Yft = ["action", "tablix_member_type", "field_name"];
const Kft = ["Name", "Group.Name", "AxisName", "PlotName"];
const Xft = (e14, t10) => ({ parentSelector: e14, descriptorTypes: t10 });
const Jft = [Xft((e14) => {
  var _a2;
  return zW((_a2 = e14 == null ? void 0 : e14.Type) != null ? _a2 : "");
}, ["size", "location", "fixed_size"]), Xft((e14) => {
  var _a2;
  return $W((_a2 = e14 == null ? void 0 : e14.Type) != null ? _a2 : "");
}, ["size", "location", "fixed_size"]), Xft((e14) => void 0 === e14 || !$W(e14.Type) && !((e15) => {
  if (!zW(e15.Type)) return false;
  if (aj(e15.RowHierarchy) || aj(e15.ColumnHierarchy)) return false;
  const t10 = e15.Corner && e15.Corner.some((e16) => e16.some((e17) => aj(e17))) || false;
  if (t10) return false;
  if (aj(e15.Body)) return true;
  const n10 = e15.RowHierarchy.LevelSizes.length || 0;
  const r10 = e15.ColumnHierarchy.LevelSizes.length || 0;
  const o10 = e15.$rows.collection.findIndex((e16) => aj(e16));
  if (0 === n10 && o10 >= r10) return true;
  const a10 = e15.$columns.collection.findIndex((e16) => aj(e16));
  return 0 === r10 && a10 >= n10;
})(e14), ["auto_merge_mode"]), Xft((e14) => {
  var _a2;
  return zW((_a2 = e14 == null ? void 0 : e14.Type) != null ? _a2 : "") && !((e15) => {
    if (!zW(e15.Type)) return false;
    const t10 = ij(e15.RowHierarchy);
    const n10 = ij(e15.ColumnHierarchy);
    if (!t10 && !n10) return false;
    const r10 = t10 ? uZ.ROW : uZ.COLUMN;
    return eQ(e15, r10) || tQ(e15, r10);
  })(e14);
}, ["tablix_member_type"])];
const Qft = (e14, t10) => ({ itemSelector: e14, descriptorKeys: t10 });
const egt = [Qft((e14, { isFpl: t10, isItemInFixedArea: n10 }) => true === t10 && true !== n10 && "textbox" === (e14 == null ? void 0 : e14.Type), ["CanGrow", "CanShrink"]), Qft((e14, { isFpl: t10, isItemInFixedArea: n10 }) => true === t10 && true !== n10 && "richtext" === (e14 == null ? void 0 : e14.Type), ["CanGrow"]), Qft((e14, { isFpl: t10 }) => {
  var _a2;
  return true === t10 && nj((_a2 = e14 == null ? void 0 : e14.Type) != null ? _a2 : "");
}, ["PageBreak"]), Qft((e14, { isLinked: t10 }) => true === t10, ["ReportStyle"]), Qft((e14, { isLinked: t10 }) => true === t10 && "inputfield" === (e14 == null ? void 0 : e14.Type), ["input_type"])];
const tgt = (e14, t10, n10, r10) => {
  var _a2, _b2;
  const o10 = nz.of(e14).of("rdlx").getDescriptor(t10.Type);
  const a10 = (_b2 = (_a2 = o10 == null ? void 0 : o10.getProperties) == null ? void 0 : _a2.call(o10, t10, void 0, r10)) != null ? _b2 : [];
  const { isMultiSelection: i10, isItemInFixedArea: s10, settings: l10 } = r10;
  const c10 = a10.filter((e15) => {
    if (!e15) return false;
    const o11 = !!i10 && ((e16) => {
      if (!e16) throw new Error(`Invalid property descriptor: ${e16}`);
      const { type: t11, valuePath: n11 } = e16;
      const r11 = ((e17) => {
        var _a3;
        return (_a3 = e17 == null ? void 0 : e17.endsWith("_collection")) != null ? _a3 : false;
      })(t11) || Yft.includes(t11) || Kft.includes(n11);
      return r11;
    })(e15);
    if (o11) return false;
    const a11 = Jft.some((t11) => t11.parentSelector(n10) && t11.descriptorTypes.includes(e15.type));
    if (a11) return false;
    const l11 = egt.some((n11) => n11.itemSelector(t10, r10) && (n11.descriptorKeys.includes(e15.valuePath) || n11.descriptorKeys.includes(e15.type)));
    if (l11) return false;
    return !(["$fixedPlace.Height", "$fixedPlace.Width"].includes(e15.valuePath) && s10);
  });
  if (!l10) return c10;
  const { filterProperties: u10 } = l10;
  return nut(c10, t10, "rdlx", u10);
};
const ngt = (e14, t10, n10, r10) => {
  const o10 = { descriptors: [], objectValue: [], defaultValue: [], objectPath: [], linkedProperties: [] };
  const a10 = __spreadProps(__spreadValues({}, r10), { isMultiSelection: t10.length > 1 });
  let i10;
  if (n10.length) {
    const e15 = n10.map((e16) => e16.value);
    if (i10 = t10.map(({ item: t11, path: n11, parentInfo: r11 }, o11) => ({ item: e15.reduce((e16, t12) => t12.split(".").reduce((e17, t13) => e17.hasOwnProperty(t13) ? e17[t13] : {}, e16), t11), path: $j(n11, e15[o11]), parentInfo: r11, isItemInFixedArea: false })), i10.some((e16) => {
      const t11 = BV.isEmpty(e16.item);
      const n11 = !e16.item.hasOwnProperty("Type");
      return t11 || n11;
    })) return { descriptors: [], objectValue: [], defaultValue: [], objectPath: [], linkedProperties: [] };
  } else i10 = t10;
  return i10.forEach(({ item: t11, path: n11, parentInfo: i11, isItemInFixedArea: s10 }) => {
    var _a2, _b2;
    const l10 = i11 && i11.item;
    const c10 = nz.of(e14).of("rdlx").getDescriptor(t11.Type);
    if (o10.objectValue.push(__spreadProps(__spreadValues({}, t11), { name: n11 || "default" })), (c10 == null ? void 0 : c10.getProperties) && (o10.defaultValue.push(c10.defaultModel), o10.descriptors.push(tgt(e14, t11, l10, __spreadProps(__spreadValues({}, a10), { isItemInFixedArea: s10 })))), o10.objectPath.push(n11), "partitem" === t11.Type || "fixedpagepartitem" === t11.Type) {
      const e15 = (_a2 = r10.libraries) == null ? void 0 : _a2.find((e16) => e16.Name === t11.Library);
      const n12 = e15 && ELe(e15) && e15.reportParts || [];
      const a11 = (((_b2 = n12.find((e16) => e16.Name === t11.ReportPart)) == null ? void 0 : _b2.Properties) || []).map((e16) => $N(e16.Category, e16.Name, "report_part_property", "Properties", void 0, { property: e16 }));
      o10.descriptors[0].push(...a11);
    }
  }), o10;
};
const rgt = (e14, t10, n10) => ({ parentSelector: e14, leafSelector: t10, collectLinkedProperties: n10 });
const ogt = [rgt(zW, (e14) => e14 === TW[0], (e14, t10, n10, r10) => {
  const { path: o10 } = t10;
  const a10 = t10.item;
  const i10 = [];
  a10.$rows.collection.forEach((e15, t11) => {
    aj(e15) && i10.push(t11);
  });
  const s10 = [];
  return _Q(a10, ({ item: e15, rix: n11, itemPath: r11 }) => {
    i10.some((e16) => e16 === n11) && s10.push({ item: e15, path: $j(o10, r11), parentInfo: t10, isItemInFixedArea: false });
  }), ngt(e14, s10, n10, r10);
}), rgt(zW, (e14) => e14 === TW[1], (e14, t10, n10, r10) => {
  const { path: o10 } = t10;
  const a10 = t10.item;
  const i10 = [];
  a10.$columns.collection.forEach((e15, t11) => {
    aj(e15) && i10.push(t11);
  });
  const s10 = [];
  return _Q(a10, ({ item: e15, cix: n11, itemPath: r11 }) => {
    i10.some((e16) => e16 === n11) && s10.push({ item: e15, path: $j(o10, r11), parentInfo: t10, isItemInFixedArea: false });
  }), ngt(e14, s10, n10, r10);
}), rgt(zW, GW, (e14, t10, n10, r10) => {
  const { path: o10 } = t10;
  const a10 = t10.item;
  const i10 = [];
  let s10 = 0;
  return VQ(a10, (e15) => {
    rj(e15.item) && s10++;
  }, (e15) => {
    e15.item && rj(e15.item) && i10.push({ item: e15.member, path: $j(o10, e15.memberPath), parentInfo: t10, isItemInFixedArea: false });
  }), i10.length !== s10 ? { descriptors: [], objectValue: [], defaultValue: [], objectPath: [], linkedProperties: [] } : ngt(e14, i10, n10, r10);
}), rgt($W, (e14) => e14 === EW[0], (e14, t10, n10, r10) => {
  const { item: o10, path: a10 } = t10;
  const i10 = r1(o10);
  const s10 = [];
  return XQ(o10, ({ item: e15, rowIdx: n11, itemPath: r11 }) => {
    i10.some((e16) => e16 === n11) && s10.push({ item: e15, path: $j(a10, r11), parentInfo: t10, isItemInFixedArea: false });
  }), ngt(e14, s10, n10, r10);
}), rgt($W, (e14) => e14 === EW[1], (e14, t10, n10, r10) => {
  const { path: o10 } = t10;
  const a10 = t10.item;
  const i10 = [];
  a10.TableColumns.forEach((e15, t11) => {
    aj(e15) && i10.push(t11);
  });
  const s10 = [];
  return XQ(a10, ({ item: e15, colIdx: n11, itemPath: r11 }) => {
    i10.some((e16) => e16 === n11) && s10.push({ item: e15, path: $j(o10, r11), parentInfo: t10, isItemInFixedArea: false });
  }), ngt(e14, s10, n10, r10);
})];
const agt = (e14, t10) => {
  let [n10, r10] = [-1, e14];
  let o10;
  const a10 = t10.split(".");
  return a10.forEach((e15, t11) => {
    r10 = r10[e15], r10 && t11 !== a10.length - 1 && GW(r10.Type) && (o10 = r10, n10 = t11);
  }), { item: o10, path: n10 >= 0 ? a10.slice(0, n10 + 1).join(".") : "" };
};
const igt = (e14, t10, n10 = [], r10 = []) => {
  const o10 = X1e(t10);
  if (0 === (o10 && o10.length || 0)) return { descriptors: [], objectValue: [], defaultValue: [], objectPath: [], linkedProperties: [] };
  const a10 = KO.of(e14);
  const i10 = o10.map((e15) => ({ item: e15.item, path: e15.path, parentInfo: agt(t10, e15.path), isItemInFixedArea: Eee(t10, e15.path) }));
  const s10 = { isFpl: "fixedpagereport" === t10.Type, isDashboard: "dashboard" === t10.Type, isChildReport: !!t10.$masterReportContent, settings: a10, reportParts: t10.ReportParts, libraries: r10 };
  const l10 = ngt(e14, i10, n10, s10);
  const c10 = i10.every((e15) => e15.parentInfo.item === i10[0].parentInfo.item);
  if (c10 && l10.linkedProperties.push(...((e15, t11, n11, r11) => {
    const { parentInfo: o11 } = t11[0];
    if (!o11.item) return [];
    const a11 = __spreadProps(__spreadValues({}, r11), { isLinked: true });
    const i11 = [];
    return ogt.forEach((r12) => {
      var _a2;
      if (!r12.parentSelector(((_a2 = o11.item) == null ? void 0 : _a2.Type) || "") || !t11.every((e16) => r12.leafSelector(e16.item.Type))) return;
      const s11 = r12.collectLinkedProperties(e15, o11, n11, a11);
      s11 && s11.objectValue.length && i11.push(s11);
    }), i11;
  })(e14, i10, n10, s10)), i10.every((e15) => /^ReportSections.[0-9]*.Body.ReportItems.[0-9]*$/.test(e15.path))) {
    const t11 = ((e15, t12, n11, r11, o11) => {
      var _a2, _b2, _c2;
      if (!((_b2 = (_a2 = r11.settings) == null ? void 0 : _a2.rdlx.reportParts) == null ? void 0 : _b2.enabled)) return null;
      const a11 = [];
      return (_c2 = r11.reportParts) == null ? void 0 : _c2.forEach((e16, t13) => {
        o11.some((t14) => e16.ReportItemName === t14.item.Name) && a11.push({ item: e16, path: `ReportParts.${t13}`, parentInfo: n11, isItemInFixedArea: false });
      }), a11.length ? ngt(e15, a11, t12, r11) : null;
    })(e14, n10, i10[0].parentInfo, s10, i10);
    t11 && l10.linkedProperties.push(t11);
  }
  return l10;
};
const sgt = (e14) => e14 && e14.name || "";
const lgt = (e14) => ((e15, t10) => [...e15 || []].sort(/* @__PURE__ */ ((e16) => (t11, n10) => {
  const r10 = e16(t11);
  const o10 = e16(n10);
  return r10.localeCompare(o10);
})(t10)))(e14, sgt);
const cgt = { request: (e14) => AV(e14, { loading: { $set: true }, error: { $set: false } }), success: (e14, { payload: { response: t10 } }) => AV(e14, { loading: { $set: false }, items: { $set: lgt(t10.filter(_e)) } }), failure: (e14, { payload: { error: t10 } }) => AV(e14, { loading: { $set: false }, error: { $set: t10 } }) };
const ugt = ope(ype, cgt, { loading: null, items: [], error: false });
const dgt = { request: (e14) => AV(e14, { loading: { $set: true }, error: { $set: false } }), success: (e14, { payload: { response: t10 } }) => AV(e14, { loading: { $set: false }, items: { $set: lgt(t10.filter(_e)) } }), failure: (e14, { payload: { error: t10 } }) => AV(e14, { loading: { $set: false }, error: { $set: t10 } }) };
const pgt = ope(Cpe, dgt, { loading: null, items: [], error: false });
const mgt = { request: (e14) => AV(e14, { loading: { $set: true }, error: { $set: false } }), success: (e14, { payload: { response: t10 } }) => AV(e14, { loading: { $set: false }, items: { $set: lgt(t10.filter(_e)) } }), failure: (e14, { payload: { error: t10 } }) => AV(e14, { loading: { $set: false }, error: { $set: t10 } }) };
const hgt = ope(bpe, mgt, { loading: null, items: [], error: false });
const fgt = { defaultTheme: { content: null, id: null, name: "" }, groupEditorMode: "default", propertyGrid: { descriptors: [], objectValue: [], defaultValue: [], objectPath: [], linkedProperties: [], path: [] }, reportPartsLibraries: { libraries: [], panel: { expanding: {} } }, reportStyles: [], sharedImages: { items: [], loading: null, error: false }, serverReports: { items: [], loading: null, error: false }, sharedThemes: { items: [] }, sharedDataSources: [], masterReports: { items: [], loading: null, error: false }, theme: null, themeId: null };
const ggt = (e14) => (t10, n10, r10) => {
  if (!t10 || !r10) {
    const { rdlx: { reportStyles: t11 } } = KO.of(e14);
    return __spreadProps(__spreadValues({}, fgt), { reportStyles: t11 });
  }
  if (dpe.match(r10)) return ((e15, { payload: { mode: t11 } }) => __spreadProps(__spreadValues({}, e15), { groupEditorMode: t11 }))(t10, r10);
  if (ppe.match(r10)) {
    const { payload: { themes: e15 } } = r10;
    return AV(t10, { sharedThemes: { items: { $set: lgt(e15) } } });
  }
  if (mpe.match(r10)) {
    const { payload: { dataSources: e15 } } = r10;
    return AV(t10, { sharedDataSources: { $set: e15 } });
  }
  if (hpe.match(r10)) {
    const { payload: { theme: e15, themeId: n11 } } = r10;
    return AV(t10, { theme: { $set: e15 }, themeId: { $set: n11 } });
  }
  if (fpe.match(r10)) return __spreadProps(__spreadValues({}, t10), { defaultTheme: r10.payload });
  const o10 = ((e15, t11, n11) => {
    var _a2;
    const { rdlx: r11 } = KO.of(n11);
    if (!((_a2 = r11 == null ? void 0 : r11.reportParts) == null ? void 0 : _a2.enabled)) return { libraries: [], panel: { expanding: {} } };
    const o11 = (t12) => {
      const n12 = e15.libraries.findIndex((e16) => e16.Path === t12);
      if (n12 < 0) throw new Error(`Unable to find loaded library ${t12} in current state`);
      return n12;
    };
    if (lWe.setAvailableLibraries.match(t11)) {
      const n12 = t11.payload.map(({ path: e16, name: t12, displayName: n13 }) => ({ Name: t12, Path: e16, DisplayName: n13, status: "available" }));
      return AV(e15, { libraries: { $set: n12 } });
    }
    if (lWe.setLibraryLoadingStarted.match(t11)) {
      const { path: n12 } = t11.payload;
      const r12 = o11(n12);
      const a11 = __spreadProps(__spreadValues({}, e15.libraries[r12]), { status: "loading" });
      return AV(e15, { libraries: { [r12]: { $set: a11 } } });
    }
    if (lWe.setLibraryLoaded.match(t11)) {
      const { path: r12, parsedLibrary: { EmbeddedImages: a11, ReportParts: i11 } } = t11.payload;
      const s11 = o11(r12);
      const l11 = __spreadProps(__spreadValues({}, e15.libraries[s11]), { status: "loaded", reportParts: i11, EmbeddedImages: a11 });
      const c10 = tGe.of(n11);
      return c10.isLibraryRegistered(l11.Name) || c10.registerLoadedLibrary({ name: l11.Name, reportParts: l11.reportParts }), AV(e15, { libraries: { [s11]: { $set: l11 } } });
    }
    if (lWe.setLibraryLoadingFailed.match(t11) || lWe.setLibraryInvalid.match(t11)) {
      const { path: n12, errorText: r12 } = t11.payload;
      const a11 = o11(n12);
      const i11 = __spreadProps(__spreadValues({}, e15.libraries[a11]), { status: "error", errorText: r12 });
      return AV(e15, { libraries: { [a11]: { $set: i11 } } });
    }
    if (lWe.setLibraryExpanded.match(t11)) {
      const { path: n12, isExpanded: r12 } = t11.payload;
      return o11(n12) > -1 ? AV(e15, { panel: { expanding: { [n12]: { $set: r12 } } } }) : e15;
    }
    return e15;
  })(t10.reportPartsLibraries, r10, e14);
  let { propertyGrid: a10 } = t10;
  if (n10 && "Report" !== n10.Type) {
    const i11 = ((e15 = { descriptors: [], objectValue: [], defaultValue: [], objectPath: [], linkedProperties: [], path: [] }, t11) => {
      if (!t11) return e15;
      switch (t11.type) {
        case "@rdlx/propertyGrid/drillPath": {
          const { payload: { path: n11 } } = t11;
          return AV(e15, { path: { $push: [n11] } });
        }
        case "@rdlx/propertyGrid/shrinkPath":
          return AV(e15, { path: { $splice: [[-1, 1]] } });
        case "@rdlx/propertyGrid/resetPath":
          return e15.path.length > 0 ? AV(e15, { path: { $set: [] } }) : e15;
      }
      return e15;
    })(t10.propertyGrid, r10);
    const s11 = igt(e14, n10, i11.path, o10.libraries);
    a10 = __spreadValues(__spreadValues({}, i11), s11);
  }
  const i10 = ugt(t10.sharedImages, r10);
  const s10 = hgt(t10.serverReports, r10);
  const l10 = pgt(t10.masterReports, r10);
  return __spreadProps(__spreadValues({}, t10), { sharedImages: i10, serverReports: s10, masterReports: l10, propertyGrid: a10, reportPartsLibraries: o10 });
};
const ygt = (e14) => {
  let t10 = {};
  if ([...Z0, "Pages", "Group", "ReportSections", "ReportParts", "$masterReportContent"].forEach((n11) => {
    e14[n11] && (t10[n11] = e14[n11]);
  }), zV.isEmpty(t10)) return e14;
  t10.Name = e14.Name, t10.Type = e14.Type, t10 = OG(t10);
  const n10 = {};
  return Object.getOwnPropertyNames(t10).forEach((r10) => {
    t10[r10] !== e14[r10] && (n10[r10] = { $set: t10[r10] });
  }), zV.isEmpty(n10) ? e14 : AV(e14, n10);
};
const vgt = [H7, L7, wye, Tye, Eye, Fye, Mye, kye, Pye, Dye, Lye, Hye, Rye, $G, r2, d2, r5, o5, a5, eZ, rZ, oZ, aZ, lZ];
function bgt(e14) {
  return (t10, n10) => {
    const r10 = e14(t10, n10);
    return r10 !== t10 && (o10 = n10.type, vgt.indexOf(o10) < 0) ? ygt(r10) : r10;
    var o10;
  };
}
const Sgt = (e14, t10) => (n10, r10) => {
  try {
    return e14(n10, r10);
  } catch (e15) {
    try {
      let n11 = "string" == typeof e15 ? { name: e15 } : e15;
      n11.type || console.error("Caught an exception!", e15), "internalError" !== n11.type && n11.type || (n11 = (({ name: e16, message: t11 }) => ({ type: "error", name: `Internal error occurred: ${e16}`, message: t11 }))(n11)), hm.of(t10).notifications.send({ type: "notification", payload: { caption: n11.name, content: n11.message, level: n11.type } });
    } catch (e16) {
      console.error("Got an exception trying to display application exception!", e16);
    } finally {
      return n10;
    }
  }
};
const Cgt = bgt((e14, t10) => {
  const { payload: { content: n10, dataSets: r10, dataSources: o10 } } = t10;
  return __spreadValues(__spreadValues(__spreadValues({}, n10), r10 && { DataSets: r10 }), o10 && { DataSources: o10 });
});
function xgt(e14) {
  return Sgt(W7(function(e15) {
    const t10 = nz.of(e15).of("rdlx");
    const n10 = t10.getReducer("fixedpagereport");
    const r10 = t10.getReducer("multisectionreport");
    const o10 = t10.getReducer("dashboard");
    if (!n10 || !r10 || !o10) throw new Error("RDLX reports not registered");
    const a10 = GV((e16) => "fixedpagereport" === e16.Type, n10, GV((e16) => "multisectionreport" === e16.Type, r10, o10));
    return WV(0, { [ape.type]: Cgt, [ipe.type]: (e16, { payload: { content: t11 } }) => t11, [spe.type]: Cgt, [cpe.type]: (t11, { payload: { masterReport: n11, copyContent: r11 } }) => {
      var _a2;
      if ("multisectionreport" !== t11.Type) return t11;
      const { DataSets: o11, DataSources: a11, ReportParameters: i10, EmbeddedImages: s10, Layers: l10 } = e8(t11, n11);
      const c10 = t11.Themes[0] || n11.Themes[0] || "";
      const u10 = "" !== c10 ? [c10] : [];
      const d10 = n11.Themes.length > 0 ? u10.concat(n11.Themes) : t11.Themes;
      return AV(t11, { ReportSections: { $set: p8(e15, n11, r11) }, DataSets: { $set: o11 }, DataSources: { $set: a11 }, ReportParameters: { $set: i10 }, $masterReportContent: { $set: n11 }, ThemeUri: { $set: c10 }, Themes: { $set: d10 }, EmbeddedImages: { $set: s10 }, Layers: { $set: l10 }, ReportParts: { $set: [] }, ConsumeContainerWhitespace: { $set: (_a2 = n11.ConsumeContainerWhitespace) != null ? _a2 : t11.ConsumeContainerWhitespace }, LayoutOrder: { $set: n11.LayoutOrder || t11.LayoutOrder }, StartPageNumber: { $set: n11.StartPageNumber || t11.StartPageNumber }, DocumentMap: { $set: n11.DocumentMap || t11.DocumentMap }, $sizeType: { $set: n11.$sizeType || t11.$sizeType }, $displayType: { $set: n11.$displayType || t11.$displayType } });
    }, [lpe.type]: (t11, { payload: { id: n11, masterReport: r11 } }) => {
      var _a2;
      if ("multisectionreport" !== t11.Type) return t11;
      const { DataSets: o11, DataSources: a11, ReportParameters: i10, EmbeddedImages: s10, Layers: l10 } = e8(t11, r11);
      const c10 = t11.Themes[0] || r11.Themes[0] || "";
      const u10 = "" !== c10 ? [c10] : [];
      const d10 = r11.Themes.length > 0 ? u10.concat(r11.Themes) : t11.Themes;
      return AV(t11, { ReportSections: { $set: p8(e15, r11) }, $masterReport: { $set: n11 }, $masterReportContent: { $set: r11 }, DataSets: { $set: o11 }, DataSources: { $set: a11 }, ReportParameters: { $set: i10 }, ThemeUri: { $set: c10 }, Themes: { $set: d10 }, EmbeddedImages: { $set: s10 }, Layers: { $set: l10 }, ReportParts: { $set: [] }, ConsumeContainerWhitespace: { $set: (_a2 = r11.ConsumeContainerWhitespace) != null ? _a2 : t11.ConsumeContainerWhitespace }, LayoutOrder: { $set: r11.LayoutOrder || t11.LayoutOrder }, StartPageNumber: { $set: r11.StartPageNumber || t11.StartPageNumber }, DocumentMap: { $set: r11.DocumentMap || t11.DocumentMap }, $sizeType: { $set: r11.$sizeType || t11.$sizeType }, $displayType: { $set: r11.$displayType || t11.$displayType } });
    }, [upe.type]: (t11, { payload: { id: n11, masterReport: r11, copyContent: o11 } }) => {
      var _a2;
      if ("multisectionreport" !== t11.Type) return t11;
      const { DataSets: a11, DataSources: i10, ReportParameters: s10, EmbeddedImages: l10, Layers: c10 } = e8(t11, r11);
      const u10 = t11.Themes[0] || r11.Themes[0] || "";
      const d10 = "" !== u10 ? [u10] : [];
      const p10 = r11.Themes.length > 0 ? d10.concat(r11.Themes) : t11.Themes;
      return AV(t11, { ReportSections: { $set: p8(e15, r11, o11) }, $masterReport: { $set: n11 }, DataSets: { $set: a11 }, DataSources: { $set: i10 }, ReportParameters: { $set: s10 }, $masterReportContent: { $set: r11 }, ThemeUri: { $set: u10 }, Themes: { $set: p10 }, EmbeddedImages: { $set: l10 }, Layers: { $set: c10 }, ReportParts: { $set: [] }, ConsumeContainerWhitespace: { $set: (_a2 = r11.ConsumeContainerWhitespace) != null ? _a2 : t11.ConsumeContainerWhitespace }, LayoutOrder: { $set: r11.LayoutOrder || t11.LayoutOrder }, StartPageNumber: { $set: r11.StartPageNumber || t11.StartPageNumber }, DocumentMap: { $set: r11.DocumentMap || t11.DocumentMap }, $sizeType: { $set: r11.$sizeType || t11.$sizeType }, $displayType: { $set: r11.$displayType || t11.$displayType } });
    } }, a10);
  }(e14)), e14);
}
function wgt(e14, t10) {
  const n10 = [];
  for (let r10 = 0; r10 < e14.length; r10++) {
    const o10 = e14[r10];
    const a10 = t10.find((e15) => o10.type === e15.type && o10.key === e15.key);
    if (void 0 === a10) continue;
    const i10 = Egt(o10, a10, ["icon"]);
    i10 && n10.push(i10);
  }
  return n10;
}
function Tgt(e14, t10) {
  const n10 = [];
  const r10 = t10;
  for (let t11 = 0; t11 < e14.length; t11++) {
    const o10 = e14[t11];
    const a10 = r10.find((e15) => o10.type === e15.type && o10.key === e15.key);
    void 0 !== a10 ? (r10.splice(r10.indexOf(a10), 1), n10.push(Fgt(o10, a10))) : n10.push(o10);
  }
  return n10.concat(r10);
}
function Egt(e14, t10, n10 = []) {
  if ("object" != typeof e14 || "object" != typeof t10 || Array.isArray(e14) !== Array.isArray(t10)) return null;
  if (Array.isArray(e14)) return wgt(e14, t10);
  const r10 = {};
  for (const o10 in e14) e14.hasOwnProperty(o10) && t10.hasOwnProperty(o10) && (n10.includes(o10) ? r10[o10] = e14[o10] : null === e14[o10] || null === t10[o10] ? r10[o10] = null : "object" == typeof e14[o10] && "object" == typeof t10[o10] ? r10[o10] = Egt(e14[o10], t10[o10]) : "disabled" === o10 ? r10[o10] = !!e14[o10] || !!t10[o10] : e14[o10] === t10[o10] && (r10[o10] = e14[o10]));
  return r10;
}
function Fgt(e14, t10) {
  if ("object" != typeof e14 || "object" != typeof t10 || Array.isArray(e14) !== Array.isArray(t10)) return null;
  if (Array.isArray(e14)) return Tgt(e14, t10);
  const n10 = {};
  for (const r10 in e14) e14.hasOwnProperty(r10) && t10.hasOwnProperty(r10) && ("object" == typeof e14[r10] && "object" == typeof t10[r10] && e14[r10] && t10[r10] && "icon" !== r10 ? n10[r10] = Fgt(e14[r10], t10[r10]) : n10[r10] = e14[r10] && t10[r10]);
  return n10;
}
function Mgt(e14, t10) {
  if (!t10) throw new Error("collectActions(): You should specify instanceId");
  const n10 = function(e15, t11) {
    const n11 = (r11) => {
      let o10 = null;
      if (aj(r11) || zV.isArray(r11)) {
        for (const e16 in r11) {
          if (!r11.hasOwnProperty(e16)) continue;
          const t12 = r11[e16];
          if (!aj(t12) && !zV.isArray(t12)) continue;
          const a10 = n11(t12);
          a10 && (o10 = o10 ? wgt(o10, a10) : a10);
        }
        if (Ij(r11)) {
          const n12 = nz.of(t11).getContextActions(r11, e15);
          if (!n12) throw Error("Item context actions should be type of array");
          o10 = o10 ? Tgt(o10, n12) : n12;
        }
      }
      return o10;
    };
    return n11(e15) || [];
  }(e14, t10);
  const r10 = n10.filter((e15) => {
    if (!e15) return false;
    if ("group" === e15.type) {
      const t11 = e15.actions || [];
      if (0 === t11.length) return false;
      const n11 = t11.filter((e16) => e16 && e16.hasOwnProperty("disabled") && e16.disabled || false);
      if (t11.length === n11.length) return false;
    }
    return true;
  });
  return r10;
}
const kgt = (e14) => {
  if (!_e(e14)) return false;
  if ("group" !== e14.type) return true;
  if (0 === e14.actions.length) return false;
  return e14.actions.filter((e15) => "separator" !== e15.type && e15.disabled || false).length !== e14.actions.length;
};
const Pgt = (e14, t10, n10) => {
  if (!n10) throw new Error("collectActions(): You should specify instanceId");
  if (!t10) return [];
  const r10 = "rdlx" === e14 ? Mgt(t10, n10) : ((e15, t11) => {
    const n11 = nz.of(t11);
    const r11 = (t12) => {
      var _a2;
      let o10 = [];
      if (aj(t12)) {
        const e16 = n11.getFeature(t12.Type, "getChildren");
        const a10 = (_a2 = e16 == null ? void 0 : e16(t12)) != null ? _a2 : [];
        for (const e17 of a10) if (aj(e17)) {
          const t13 = r11(e17);
          t13 && (o10 = o10.length ? V1e(o10, t13) : t13);
        }
      }
      if (t12.Type) {
        const r12 = n11.getContextActions(t12, e15);
        if (!r12) throw new Error("Item context actions should be type of array");
        o10 = o10.length ? [...o10, ...r12] : r12;
      }
      return o10;
    };
    return r11(e15) || [];
  })(t10, n10);
  return r10.filter(kgt);
};
const Ngt = __spreadProps(__spreadValues({}, hz), { rdlx: fgt, rpx: {} });
const Dgt = [r5, o5, a5, v2.type, h2.type, L2.type];
function Lgt(e14) {
  return qft(e14) && !Dgt.includes(e14.type);
}
function Hgt(e14) {
  var _a2;
  return !((_a2 = e14 == null ? void 0 : e14.meta) == null ? void 0 : _a2.skipDirty) && !Dgt.includes(e14.type);
}
const Igt = (e14) => __spreadProps(__spreadValues({}, e14), { type: __spreadProps(__spreadValues({}, e14.type), { type: "master" }), content: __spreadProps(__spreadValues({}, e14.content), { $isMasterReport: true }) });
function _gt(e14) {
  const t10 = { rdlx: xgt(e14) };
  nz.of(e14).hasDocumentType("rpx") && (t10.rpx = function(e15) {
    const t11 = nz.of(e15).of("rpx").getReducer("report");
    if (!t11) throw new Error("Register rpx report items first");
    const n11 = WV(0, { [xtt.type]: (e16, { payload: { content: t12 } }) => t12, [Ctt.type]: (e16, { payload: { content: t12 } }) => t12, [uB.type]: (e16, { payload: { primaryPath: n12, secondaryPaths: r11 = [] } }) => {
      let o11 = t11(e16, sB(n12));
      return o11 = r11.reduce((e17, n13) => t11(e17, lB(n13)), o11), o11;
    } }, t11);
    return n11;
  }(e14));
  const n10 = (e15, n11) => {
    var _a2;
    const r11 = (_a2 = e15.type) == null ? void 0 : _a2.platform;
    if (!r11) return e15;
    const o11 = t10[r11];
    if (!o11) return console.error(`coreReducer: Platform ${r11} is not supported`), e15;
    const a11 = o11(e15.content, n11);
    return a11 !== e15.content ? __spreadProps(__spreadValues({}, e15), { content: a11 }) : e15;
  };
  const r10 = WV(0, { [xtt.type]: jV(Cz, n10), [Ctt.type]: jV(Cz, n10), [ape.type]: jV(Cz, n10), [ipe.type]: jV(Cz, n10), [Z2.type]: Igt }, n10);
  const o10 = az.reducerDecorator(e14);
  const a10 = /* @__PURE__ */ ((e15 = qft) => (t11) => wO(t11, { filter: e15, syncFilter: true, debug: false }))(Lgt);
  const i10 = o10(a10(((e15) => GV((e16, t11) => t11.type === rz.type, (t11, n11) => {
    var _a2, _b2, _c2;
    return (_c2 = (_b2 = (_a2 = n11 == null ? void 0 : n11.payload) == null ? void 0 : _a2.actions) == null ? void 0 : _b2.reduce((t12, n12) => e15(t12, n12), t11)) != null ? _c2 : t11;
  }, e15))(r10)));
  const s10 = ggt(e14);
  const l10 = WV(0, __spreadValues({}, Sz), (t11, n11) => {
    if (!t11 || !n11) return __spreadProps(__spreadValues({}, Ngt), { id: e14, rdlx: s10() });
    let r11 = t11;
    const o11 = i10(t11.document, n11);
    o11 !== t11.document && (r11 = __spreadProps(__spreadValues({}, r11), { document: o11, contextActions: Pgt(o11.present.type.platform, o11.present.content, e14) })), o11.present !== t11.document.present && (r11 = __spreadProps(__spreadValues({}, r11), { hasUnsavedChanges: t11.hasUnsavedChanges || Hgt(n11) }));
    const a11 = s10(r11.rdlx, r11.document.present.content, n11);
    return a11 !== r11.rdlx && (r11 = __spreadProps(__spreadValues({}, r11), { rdlx: a11 })), rB.match(n11) && (r11 = __spreadProps(__spreadValues({}, r11), { hasUnsavedChanges: false })), oB.match(n11) && (r11 = __spreadProps(__spreadValues({}, r11), { hasUnsavedChanges: true })), (xtt.match(n11) || Ctt.match(n11) || ape.match(n11) || ipe.match(n11) || nB.match(n11)) && (r11 = __spreadProps(__spreadValues({}, r11), { documentName: n11.payload.name })), r11;
  });
  return l10;
}
const Vgt = (e14, t10, n10, r10) => ((e15) => {
  var _a2;
  return "rdlx" === ((_a2 = e15.type) == null ? void 0 : _a2.platform);
})(n10) && n10.content ? r10 === F$e ? v$e(e14, t10) : ((e15, t11, n11) => {
  const r11 = !U7(n11) && yj(n11).some((e16) => Z7(e16));
  if (["Ctrl+KeyC", "Ctrl+KeyX"].includes(e15) && r11) return null;
  const o10 = Eft(e15, t11, n11);
  return o10 ? kB(o10) : PB(e15, t11);
})(e14, t10, n10.content) : ((e15) => {
  var _a2;
  return "rpx" === ((_a2 = e15.type) == null ? void 0 : _a2.platform);
})(n10) ? ((e15, t11, n11) => {
  const r11 = Uft(e15, t11, n11);
  return r11 ? kB(r11) : PB(e15, t11);
})(e14, t10, n10.content) : PB(e14, t10);
const Rgt = (e14) => {
  var _a2;
  return "Body" in e14 ? ((_a2 = e14 == null ? void 0 : e14.Body) == null ? void 0 : _a2.ReportItems) || [] : "Pages" in e14 ? e14.Pages && e14.Pages[0].ReportItems || [] : "ReportSections" in e14 ? e14.ReportSections.flatMap(Rgt) : [];
};
const Agt = (e14) => {
  if ("Continuous" === e14.Type) {
    const t10 = __spreadProps(__spreadValues({}, e14), { Body: __spreadProps(__spreadValues({}, e14.Body), { ReportItems: [] }) });
    return t10.PageHeader && (t10.PageHeader = __spreadProps(__spreadValues({}, t10.PageHeader), { ReportItems: [] })), t10.PageFooter && (t10.PageFooter = __spreadProps(__spreadValues({}, t10.PageFooter), { ReportItems: [] })), t10;
  }
  return __spreadProps(__spreadValues({}, e14), { FixedPage: __spreadProps(__spreadValues({}, e14.FixedPage), { Pages: e14.FixedPage.Pages.map((e15) => __spreadProps(__spreadValues({}, e15), { ReportItems: [] })) }) });
};
const Ogt = (e14) => {
  const t10 = __spreadProps(__spreadValues({}, e14), { Body: __spreadProps(__spreadValues({}, e14.Body), { ReportItems: [] }) });
  return t10.PageHeader && (t10.PageHeader = __spreadProps(__spreadValues({}, t10.PageHeader), { ReportItems: [] })), t10.PageFooter && (t10.PageFooter = __spreadProps(__spreadValues({}, t10.PageFooter), { ReportItems: [] })), t10;
};
const Bgt = "TemplateName";
const zgt = (e14) => {
  var _a2, _b2;
  const t10 = (e14.CustomProperties || []).find((e15) => e15.Name === Bgt);
  return (_b2 = (_a2 = t10 == null ? void 0 : t10.Value) == null ? void 0 : _a2.toString()) != null ? _b2 : e14.Name;
};
const $gt = (e14) => Array.isArray(e14.CustomProperties) ? __spreadProps(__spreadValues({}, e14), { CustomProperties: e14.CustomProperties.filter((e15) => e15.Name !== Bgt) }) : e14;
const Wgt = (e14) => {
  const t10 = ((e15) => {
    if ("ReportSections" in e15 && ((e16) => {
      var _a2;
      return (_a2 = e16.CustomProperties) == null ? void 0 : _a2.some((e17) => "ViewerType" === e17.Name && "Dashboard" === e17.Value);
    })(e15)) {
      const t12 = eGe.decode(e15);
      if ("error" === t12.type) throw new Error(`Error decoding dashboard: "${t12.reason}"`);
      return FZ.resultOf(t12);
    }
    const t11 = QZe.decode(__spreadValues(__spreadValues({}, "ReportSections" in e15 ? { Width: "6.5in", ReportSections: [{ Type: "Continuous", Name: "ContinuousSection1", Body: {} }] } : { Width: "6.5in", FixedPage: {} }), e15));
    if ("error" === t11.type) throw new Error(`Error decoding report: "${t11.reason}"`);
    return FZ.resultOf(t11);
  })(e14);
  const n10 = Rgt(t10);
  const r10 = [];
  if (((e15) => "fixedpagereport" === e15.Type)(t10) && r10.push({ Type: "fixedpagereport", ConsumeContainerWhitespace: t10.ConsumeContainerWhitespace, Page: t10.Page }), ((e15) => "multisectionreport" === e15.Type)(t10)) {
    r10.push({ Type: "multisectionreport", ConsumeContainerWhitespace: t10.ConsumeContainerWhitespace, ReportSections: t10.ReportSections.map(Agt) });
    const e15 = t10.ReportSections.find((e16) => "Continuous" === e16.Type);
    e15 && (r10.push(Agt(zG(e15))), r10.push(__spreadProps(__spreadValues({}, e15.Body), { ReportItems: [] })), e15.PageHeader && r10.push(__spreadProps(__spreadValues({}, e15.PageHeader), { Name: "PageHeader", ReportItems: [] })), e15.PageFooter && r10.push(__spreadProps(__spreadValues({}, e15.PageFooter), { Name: "PageFooter", ReportItems: [] })));
    const n11 = t10.ReportSections.find((e16) => "FixedPage" === e16.Type);
    n11 && r10.push(Agt(n11));
  }
  if (((e15) => "dashboard" === e15.Type)(t10)) {
    r10.push(__spreadProps(__spreadValues({}, t10), { ReportSections: t10.ReportSections.map(Ogt) }));
    const e15 = t10.ReportSections.find((e16) => "dashboardsection" === e16.Type);
    e15 && (r10.push(Ogt(zG(e15))), e15.PageHeader && r10.push(__spreadProps(__spreadValues({}, e15.PageHeader), { Name: "PageHeader", ReportItems: [] })), e15.PageFooter && r10.push(__spreadProps(__spreadValues({}, e15.PageFooter), { Name: "PageFooter", ReportItems: [] })));
  }
  return n10.forEach((e15) => {
    const t11 = ((e16) => {
      const t12 = e16.CustomProperties;
      const n11 = t12 == null ? void 0 : t12.find((e17) => e17.Name === Bgt);
      return n11 ? (n11.Value || (n11.Value = e16.Name), e16) : (t12.push({ Name: Bgt, Value: e16.Name }), e16);
    })(e15);
    r10.push(zG(t11));
  }), r10;
};
const jgt = { imperialTemplates: [{ Name: "fplImperialTemplates.rdlx", Width: "8.5in", DocumentMap: { Source: "All" }, Layers: [{ Name: "default" }], CustomProperties: [{ Name: "DisplayType", Value: "Page" }, { Name: "SizeType", Value: "Default" }], Page: { PageWidth: "8.5in", PageHeight: "11in", RightMargin: "1in", LeftMargin: "1in", TopMargin: "1in", BottomMargin: "1in", Columns: 1, ColumnSpacing: "0.5in", PaperOrientation: "Portrait" }, FixedPage: { Pages: [{ PaperOrientation: "Portrait", ReportItems: [{ Type: "overflowplaceholder", Name: "OverflowPlaceholder1", Width: "1in", Height: "1in" }] }], Group: { PageBreakDisabled: "false" } } }, { Name: "MslImperialTemplates", Type: "report", StartPageNumber: 1, DataElementName: "Dashboard", DocumentMap: { Source: "All", NumberingStyle: "None" }, Layers: [{ Type: "layer", Name: "default", DesignerLock: false, DesignerTransparency: 0, DesignerVisible: true, DesignerDataFieldVisible: true, TargetDevice: "All" }], ConsumeContainerWhitespace: false, CollateBy: "Simple", LayoutOrder: "ZOrder", ReportSections: [{ Type: "Continuous", Name: "ReportSection1", Page: { PageWidth: "8.5in", PageHeight: "11in", RightMargin: "1in", LeftMargin: "1in", TopMargin: "1in", BottomMargin: "1in", ColumnSpacing: "0in", PaperOrientation: "Portrait" }, DataElementName: "", DataElementOutput: "Auto", PageHeader: { Name: "PageHeader", Height: "0.25in" }, Body: { Height: "3in", ReportItems: [{ Type: "textbox", Name: "TextBox1", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" }, { Type: "checkbox", Name: "CheckBox1", ZIndex: 1, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" }, { Type: "rectangle", Name: "Container1", ZIndex: 2, Width: "3in", Height: "2in" }, { Type: "line", Name: "Line1", ZIndex: 3, StartPoint: { X: "0in", Y: "0in" }, EndPoint: { X: "1in", Y: "0in" } }, { Type: "shape", Name: "Shape1", ZIndex: 4, Style: { Border: { Style: "Solid" } }, Width: "2in", Height: "1in" }, { Type: "inputfield", Name: "InputField1", ZIndex: 5, Width: "1in", Height: "0.25in" }, { Type: "tableofcontents", Name: "TableOfContents1", ZIndex: 6, Levels: [{ LevelName: "Level1" }], Width: "2in", Height: "1in" }, { Type: "image", Name: "Image1", ZIndex: 7, Sizing: "Clip", Width: "1in", Height: "1in" }, { Type: "list", Name: "List1", ZIndex: 8, Width: "1in", Height: "1in" }, { Type: "table", Name: "Table1", ZIndex: 9, TableColumns: [{ Width: "1in" }, { Width: "1in" }, { Width: "1in" }], Header: { TableRows: [{ Height: "0.25in", TableCells: [{ Item: { Type: "textbox", Name: "TextBox2", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" } }, { Item: { Type: "textbox", Name: "TextBox3", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" } }, { Item: { Type: "textbox", Name: "TextBox4", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" } }] }], RepeatOnNewPage: true }, Details: { TableRows: [{ Height: "0.25in", TableCells: [{ Item: { Type: "textbox", Name: "TextBox5", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" } }, { Item: { Type: "textbox", Name: "TextBox6", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" } }, { Item: { Type: "textbox", Name: "TextBox7", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" } }] }] }, Footer: { TableRows: [{ Height: "0.25in", TableCells: [{ Item: { Type: "textbox", Name: "TextBox8", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" } }, { Item: { Type: "textbox", Name: "TextBox9", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" } }, { Item: { Type: "textbox", Name: "TextBox10", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" } }] }] }, Width: "3in", Height: "0.75in" }, { Type: "tablix", Name: "Tablix1", ZIndex: 10, LayoutDirection: "Ltr", RowHierarchy: { LevelSizes: ["1in"], Members: [{ Header: { Item: { Type: "textbox", Name: "TextBox13", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" }, LevelCount: 1 }, BodyIndex: 0, Group: { Name: "Tablix1_RowGroup1", GroupExpressions: [""] } }] }, ColumnHierarchy: { LevelSizes: ["0.25in"], Members: [{ Header: { Item: { Type: "textbox", Name: "TextBox12", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" }, LevelCount: 1 }, BodyIndex: 0, Group: { Name: "Tablix1_ColumnGroup1", GroupExpressions: [""] } }] }, Corner: [[{ Item: { Type: "textbox", Name: "TextBox11", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" } }]], Body: { Columns: ["1in"], Rows: [{ Height: "0.25in", Cells: [{ Item: { Type: "textbox", Name: "TextBox14", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" } }] }] }, Width: "2in", Height: "0.5in" }, { Type: "dvchart", Name: "Chart1", ZIndex: 11, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Header: { Style: { PaddingTop: "4pt", PaddingBottom: "2pt" }, TextStyle: { FontWeight: "Bold" } }, Footer: { Style: { PaddingTop: "2pt", PaddingBottom: "4pt" } }, Legend: { Orientation: "Vertical", Style: { PaddingRight: "10pt", PaddingTop: "4pt", PaddingBottom: "2pt" }, Wrapping: true }, PlotArea: { Axes: [{ Format: "", LabelStyle: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, LineStyle: { Border: { Style: "Solid" } }, MajorGridStyle: { Border: { Color: "Gray", Style: "Solid" } }, Plots: ["Plot 1"], TitleStyle: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" } }, { AxisType: "Y", Format: "", LabelStyle: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, LineStyle: { Border: { Style: "Solid" } }, MajorGrid: true, MajorGridStyle: { Border: { Color: "Gray", Style: "Solid" } }, Plots: ["Plot 1"], TitleStyle: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" } }], Legends: [{ Orientation: "Vertical", Style: { PaddingRight: "10pt", PaddingTop: "4pt", PaddingBottom: "2pt" } }] }, Plots: [{ PlotName: "Plot 1", Encodings: { Category: { Field: { FieldType: "Simple" } }, Color: { Field: { FieldType: "Simple" } }, Shape: { Field: { FieldType: "Simple" } }, Size: { Field: { FieldType: "Simple" } } }, Config: { LineStyle: { Style: "None", Width: "1pt" } }, PlotChartType: "Column", PlotChartSubtype: "Clustered" }], Width: "4in", Height: "3in" }, { Type: "bullet", Name: "Bullet1", ZIndex: 12, Width: "2in", Height: "0.5in" }, { Type: "barcode", Name: "Barcode1", ZIndex: 13, Symbology: "QRCode", Style: { FontFamily: "Arial", FontSize: "8pt" }, Width: "1.5in", Height: "1.5in" }, { Type: "sparkline", Name: "Sparkline1", ZIndex: 14, Width: "2in", Height: "0.25in" }, { Type: "subreport", Name: "Subreport1", ZIndex: 15, Width: "2in", Height: "2in" }, { Type: "bandedlist", Name: "BandedList1", ZIndex: 16, Header: { Name: "$BandedListHeader1", Height: "0.25in", RepeatOnNewPage: true }, Details: { Name: "$BandedListDetails1", Height: "0.5in" }, Footer: { Name: "$BandedListFooter1", Height: "0.25in" }, Width: "2in", Height: "1in" }, { Type: "richtext", Name: "RichText1", ZIndex: 17, CanGrow: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, MarkupType: "HTML", Value: "", Width: "1in", Height: "0.5in" }, { Type: "formattedtext", Name: "FormattedText1", ZIndex: 13, Width: "2in", Height: "0.5in" }, { Type: "contentplaceholder", Name: "ContentPlaceHolder1", ZIndex: 19, Left: "0in", Top: "0in", Width: "1in", Height: "1in" }] }, PageFooter: { Name: "PageFooter", Height: "0.25in" } }] }, { DataElementName: "Dashboard", CustomProperties: [{ Name: "ViewerType", Value: "Dashboard" }], ReportSections: [{ Name: "Section1", Page: { ColumnSpacing: "0in" }, Body: { Height: "6in", Style: {} }, Width: "10in" }] }], metricTemplates: [{ Name: "fplMetricTemplates.rdlx", Width: "21cm", DocumentMap: { Source: "All" }, Layers: [{ Name: "default" }], CustomProperties: [{ Name: "DisplayType", Value: "Page" }, { Name: "SizeType", Value: "Default" }], Page: { PageWidth: "21cm", PageHeight: "29.7cm", RightMargin: "2.5cm", LeftMargin: "2.5cm", TopMargin: "2.5cm", BottomMargin: "2.5cm", Columns: 1, ColumnSpacing: "0.5in", PaperOrientation: "Portrait" }, FixedPage: { Pages: [{ PaperOrientation: "Portrait", ReportItems: [{ Type: "overflowplaceholder", Name: "OverflowPlaceholder1", Left: "0cm", Top: "0cm", Width: "2.5cm", Height: "2.5cm" }] }], Group: { PageBreakDisabled: "false" } } }, { Name: "MslMetricTemplates", Type: "report", StartPageNumber: 1, DataElementName: "Dashboard", DocumentMap: { Source: "All", NumberingStyle: "None" }, Layers: [{ Type: "layer", Name: "default", DesignerLock: false, DesignerTransparency: 0, DesignerVisible: true, DesignerDataFieldVisible: true, TargetDevice: "All" }], ConsumeContainerWhitespace: false, CollateBy: "Simple", LayoutOrder: "ZOrder", ReportSections: [{ Type: "Continuous", Name: "ReportSection1", Page: { PageWidth: "21cm", PageHeight: "29.7cm", RightMargin: "2.5cm", LeftMargin: "2.5cm", TopMargin: "2.5cm", BottomMargin: "2.5cm", ColumnSpacing: "0.5in", PaperOrientation: "Portrait" }, DataElementName: "", DataElementOutput: "Auto", PageHeader: { Name: "PageHeader", Height: "0.75cm" }, Body: { Height: "29.7cm", ReportItems: [{ Type: "textbox", Name: "TextBox1", DataElementName: "TextBox1", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Left: "0cm", Top: "0cm", Width: "2.5cm", Height: "0.75cm" }, { Type: "checkbox", Name: "CheckBox1", ZIndex: 1, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Left: "0cm", Top: "0cm", Width: "2.5cm", Height: "0.75cm" }, { Type: "rectangle", Name: "Container1", ZIndex: 2, Left: "0cm", Top: "0cm", Width: "7.5cm", Height: "5cm" }, { Type: "line", Name: "Line1", ZIndex: 3, StartPoint: { X: "0cm", Y: "0cm" }, EndPoint: { X: "2.5cm", Y: "0cm" } }, { Type: "shape", Name: "Shape1", ZIndex: 4, Style: { Border: { Style: "Solid" } }, Left: "0cm", Top: "0cm", Width: "5cm", Height: "2.5cm" }, { Type: "tableofcontents", Name: "TableOfContents1", ZIndex: 5, Levels: [{ LevelName: "Level1" }], Left: "0cm", Top: "0cm", Width: "5cm", Height: "2.5cm" }, { Type: "image", Name: "Image1", ZIndex: 6, Sizing: "Clip", Left: "0cm", Top: "0cm", Width: "2.5cm", Height: "2.5cm" }, { Type: "list", Name: "List1", ZIndex: 7, Group: { PageBreakDisabled: "false" }, Left: "0cm", Top: "0cm", Width: "2.5cm", Height: "2.5cm" }, { Type: "table", Name: "Table1", ZIndex: 8, TableColumns: [{ Width: "2.5cm" }, { Width: "2.5cm" }, { Width: "2.5cm" }], Header: { TableRows: [{ Height: "0.75cm", TableCells: [{ Item: { Type: "textbox", Name: "TextBox2", DataElementName: "TextBox2", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Left: "0cm", Top: "0cm", Width: "2.5cm", Height: "0.75cm" } }, { Item: { Type: "textbox", Name: "TextBox3", DataElementName: "TextBox3", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Left: "0cm", Top: "0cm", Width: "2.5cm", Height: "0.75cm" } }, { Item: { Type: "textbox", Name: "TextBox4", DataElementName: "TextBox4", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Left: "0cm", Top: "0cm", Width: "2.5cm", Height: "0.75cm" } }] }], RepeatOnNewPage: true }, Details: { TableRows: [{ Height: "0.75cm", TableCells: [{ Item: { Type: "textbox", Name: "TextBox5", DataElementName: "TextBox5", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Left: "0cm", Top: "0cm", Width: "2.5cm", Height: "0.75cm" } }, { Item: { Type: "textbox", Name: "TextBox6", DataElementName: "TextBox6", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Left: "0cm", Top: "0cm", Width: "2.5cm", Height: "0.75cm" } }, { Item: { Type: "textbox", Name: "TextBox7", DataElementName: "TextBox7", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Left: "0cm", Top: "0cm", Width: "2.5cm", Height: "0.75cm" } }] }], Group: { PageBreakDisabled: "false" } }, Footer: { TableRows: [{ Height: "0.75cm", TableCells: [{ Item: { Type: "textbox", Name: "TextBox8", DataElementName: "TextBox8", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Left: "0cm", Top: "0cm", Width: "2.5cm", Height: "0.75cm" } }, { Item: { Type: "textbox", Name: "TextBox9", DataElementName: "TextBox9", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Left: "0cm", Top: "0cm", Width: "2.5cm", Height: "0.75cm" } }, { Item: { Type: "textbox", Name: "TextBox10", DataElementName: "TextBox10", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Left: "0cm", Top: "0cm", Width: "2.5cm", Height: "0.75cm" } }] }] }, Left: "0cm", Top: "0cm", Width: "7.5cm", Height: "2.25cm" }, { Type: "tablix", Name: "Tablix1", ZIndex: 9, RowHierarchy: { LevelSizes: ["2.5cm"], Members: [{ Header: { Item: { Type: "textbox", Name: "TextBox13", DataElementName: "TextBox13", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Left: "0cm", Top: "0cm", Width: "2.5cm", Height: "0.75cm" }, LevelCount: 1 }, BodyIndex: 0, Group: { Name: "Tablix1_RowGroup1", GroupExpressions: [""], PageBreakDisabled: "false" } }] }, ColumnHierarchy: { LevelSizes: ["0.75cm"], Members: [{ Header: { Item: { Type: "textbox", Name: "TextBox12", DataElementName: "TextBox12", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Left: "0cm", Top: "0cm", Width: "2.5cm", Height: "0.75cm" }, LevelCount: 1 }, BodyIndex: 0, Group: { Name: "Tablix1_ColumnGroup1", GroupExpressions: [""], PageBreakDisabled: "false" } }] }, Corner: [[{ Item: { Type: "textbox", Name: "TextBox11", DataElementName: "TextBox11", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Left: "0cm", Top: "0cm", Width: "2.5cm", Height: "0.75cm" } }]], Body: { Columns: ["2.5cm"], Rows: [{ Height: "0.75cm", Cells: [{ Item: { Type: "textbox", Name: "TextBox14", DataElementName: "TextBox14", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Left: "0cm", Top: "0cm", Width: "2.5cm", Height: "0.75cm" } }] }] }, Left: "0cm", Top: "0cm", Width: "5cm", Height: "1.5cm" }, { Type: "dvchart", Name: "Chart1", ZIndex: 10, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Header: { Style: { PaddingTop: "4pt", PaddingBottom: "2pt" }, TextStyle: { FontWeight: "Bold" } }, Footer: { Style: { PaddingTop: "2pt", PaddingBottom: "4pt" } }, Legend: { Orientation: "Vertical", Style: { PaddingRight: "10pt", PaddingTop: "4pt", PaddingBottom: "2pt" }, Wrapping: true }, PlotArea: { Axes: [{ LabelStyle: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, LineStyle: { Border: { Style: "Solid" } }, MajorGridStyle: { Border: { Color: "Gray", Style: "Solid" } }, Plots: ["Plot 1"], TitleStyle: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" } }, { AxisType: "Y", LabelStyle: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, LineStyle: { Border: { Style: "Solid" } }, MajorGrid: true, MajorGridStyle: { Border: { Color: "Gray", Style: "Solid" } }, Plots: ["Plot 1"], TitleStyle: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" } }], Legends: [{ Orientation: "Vertical", Style: { PaddingRight: "10pt", PaddingTop: "4pt", PaddingBottom: "2pt" } }] }, Plots: [{ PlotName: "Plot 1", Encodings: { Category: { Field: { FieldType: "Simple" } }, Color: { Field: { FieldType: "Simple" }, Aggregate: "List" }, Shape: { Field: { FieldType: "Simple" } }, Size: { Field: { FieldType: "Simple" } } }, Config: { LineStyle: { Style: "None", Width: "1pt" } }, PlotChartType: "Column", PlotChartSubtype: "Clustered" }], Left: "0cm", Top: "0cm", Width: "10cm", Height: "7.5cm" }, { Type: "bullet", Name: "Bullet1", ZIndex: 11, Left: "0cm", Top: "0cm", Width: "5cm", Height: "1.5cm" }, { Type: "barcode", Name: "Barcode1", ZIndex: 12, Symbology: "QRCode", QuietZone: { Left: "0cm", Right: "0cm", Top: "0cm", Bottom: "0cm" }, SupplementOptions: { Spacing: "0cm" }, Style: { FontFamily: "Arial", FontSize: "8pt" }, Left: "0cm", Top: "0cm", Width: "4cm", Height: "4cm" }, { Type: "formattedtext", Name: "FormattedText1", ZIndex: 13, Left: "0cm", Top: "0cm", Width: "5cm", Height: "1.5cm" }, { Type: "sparkline", Name: "Sparkline1", ZIndex: 14, Group: { PageBreakDisabled: "false" }, Left: "0cm", Top: "0cm", Width: "5cm", Height: "0.75cm" }, { Type: "subreport", Name: "Subreport1", ZIndex: 15, Left: "0cm", Top: "0cm", Width: "5cm", Height: "5cm" }, { Type: "bandedlist", Name: "BandedList1", ZIndex: 16, Header: { Name: null, Height: "0.75cm", RepeatOnNewPage: true }, Details: { Name: null, Height: "1.5cm" }, Footer: { Name: null, Height: "0.75cm" }, Left: "0cm", Top: "0cm", Width: "5cm", Height: "3cm" }, { Type: "inputfield", Name: "InputField1", ZIndex: 17, Left: "0cm", Top: "0cm", Width: "2.5cm", Height: "0.75cm" }, { Type: "richtext", Name: "RichText1", ZIndex: 18, CanGrow: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, MarkupType: "HTML", Value: "", Left: "0cm", Top: "0cm", Width: "2.5cm", Height: "1.5cm" }, { Type: "contentplaceholder", Name: "ContentPlaceHolder1", ZIndex: 19, Left: "0cm", Top: "0cm", Width: "2.5cm", Height: "2.5cm" }] }, PageFooter: { Name: "PageFooter", Height: "0.75cm" } }] }, { DataElementName: "Dashboard", CustomProperties: [{ Name: "ViewerType", Value: "Dashboard" }], ReportSections: [{ Name: "Section1", Page: { ColumnSpacing: "0cm" }, Body: { Height: "15cm", Style: {} }, Width: "25cm" }] }] };
const Zgt = "RDLX/BANDED_LIST/TOGGLE_HEADER";
const Ggt = "RDLX/BANDED_LIST/TOGGLE_FOOTER";
const Ugt = "RDLX/BANDED_LIST/INSERT_GROUP";
const qgt = "RDLX/BANDED_LIST/DELETE_GROUP";
const Ygt = "RDLX/BANDED_LIST/TOGGLE_GROUP_HEADER";
const Kgt = "RDLX/BANDED_LIST/TOGGLE_GROUP_FOOTER";
const Xgt = "RDLX/BANDED_LIST/REMOVE_BAND";
const Jgt = _V(Zgt);
const Qgt = _V(Ggt);
const eyt = _V(Ugt, ({ insertIndex: e14 = 0, properties: t10 = {}, dataSetName: n10 = "" }) => ({ insertIndex: e14, properties: t10, dataSetName: n10 }));
const tyt = _V(qgt, (e14) => ({ deleteIndex: e14 }));
const nyt = _V(Ygt, (e14) => ({ groupIndex: e14 }));
const ryt = _V(Kgt, (e14) => ({ groupIndex: e14 }));
const oyt = _V(Xgt);
const ayt = { BandedListHeaderAdd: W1e(tQe), BandedListHeaderRemove: W1e(nQe), BandedListFooterAdd: W1e(GJe), BandedListFooterRemove: W1e(UJe), Groups: W1e(eQe), GroupInsertChild: W1e(QJe), DeleteGroup: W1e(qJe), GroupHeaderAdd: W1e(XJe), GroupHeaderRemove: W1e(JJe), GroupFooterAdd: W1e(YJe), GroupFooterRemove: W1e(KJe) };
const iyt = (e14) => e14.reduce((e15, t10) => e15 || !t10.disabled, false);
const syt = (e14, t10, n10) => ({ type: "dropdown", icon: e14, key: t10, disabled: !iyt(n10), actions: n10 });
const lyt = (e14, t10, n10) => ({ type: "group", icon: e14, key: t10, actions: n10.filter((e15) => "dropdown" !== e15.type || !e15.disabled) });
const cyt = (e14, t10, n10, r10) => ({ type: "button", icon: e14, key: t10, disabled: n10, action: r10, textKey: t10 });
const uyt = (e14) => [e14.Header ? cyt(ayt.BandedListHeaderRemove, "contextActions:bandedList.removeHeader", false, Jgt()) : cyt(ayt.BandedListHeaderAdd, "contextActions:bandedList.addHeader", false, Jgt()), e14.Footer ? cyt(ayt.BandedListFooterRemove, "contextActions:bandedList.removeFooter", false, Qgt()) : cyt(ayt.BandedListFooterAdd, "contextActions:bandedList.addFooter", false, Qgt())];
const dyt = (e14, t10) => e14 ? [e14.Header ? cyt(ayt.GroupHeaderRemove, "contextActions:bandedList.removeGroupHeader", false, nyt(t10)) : cyt(ayt.GroupHeaderAdd, "contextActions:bandedList.addGroupHeader", false, nyt(t10)), e14.Footer ? cyt(ayt.GroupFooterRemove, "contextActions:bandedList.removeGroupFooter", false, ryt(t10)) : cyt(ayt.GroupFooterAdd, "contextActions:bandedList.addGroupFooter", false, ryt(t10))] : [];
const pyt = (e14) => e14 && { type: "button", icon: nf(t1e), key: "contextActions:container.delete", action: e14 } || null;
const myt = (e14) => {
  if (((e15) => o3(e15).some((e16) => !rj(e16) && e16.ReportItems.some(rj)))(e14)) return pyt(JG());
  const t10 = o3(e14);
  if (rj(e14.Details)) return null;
  if (t10.some(rj)) return pyt(oyt());
  const n10 = (e14.Groups || []).findIndex(rj);
  return n10 >= 0 ? pyt(tyt(n10)) : null;
};
function hyt(e14, t10, n10) {
  const { lockLayout: r10 } = KO.of(t10);
  if (r10) return [];
  const o10 = i0e(e14, t10, n10);
  if (rj(e14)) return [lyt(null, "contextActions:bandedList.title", uyt(e14)), ...o10];
  if (!n3(e14)) return [];
  const a10 = o10;
  const i10 = myt(e14);
  i10 && a10.push(i10);
  const s10 = ((e15, t11) => {
    const n11 = t3(e15);
    if (1 !== n11.length || !ij(n11[0])) return null;
    const r11 = n11[0];
    const o11 = r11.Type;
    if (!_1e[o11]) return null;
    const { getPropertyDescriptor: a11, defaultValue: i11 } = _1e[o11];
    const s11 = { descriptor: a11(), objectValues: [r11], defaultValues: [i11] };
    const l11 = { type: "button", icon: nf(q1e), key: "contextActions:container.expression", action: _A.of(t11).open("connectedExpressionEditor", s11) };
    return { type: "group", key: nz.of(t11).getLabelKey(o11), actions: [l11] };
  })(e14, t10);
  s10 && a10.push(s10);
  if (!(ij(e14) && Q4(e14))) return a10;
  let l10;
  const c10 = e14.Groups.findIndex(ij);
  const u10 = -1 !== c10;
  l10 = u10 ? c10 + 1 : ij(e14.Header) || ij(e14.Footer) ? 0 : e14.Groups.length;
  const d10 = [syt(ayt.Groups, "contextActions:bandedList.groupTitle", [cyt(ayt.GroupInsertChild, "contextActions:bandedList.insertGroup", false, eyt({ insertIndex: l10 })), cyt(ayt.DeleteGroup, "contextActions:bandedList.deleteGroup", !u10, tyt(c10)), ...dyt(e14.Groups[c10], c10)])];
  return a10.push(lyt(null, "contextActions:bandedList.title", d10)), a10;
}
function fyt() {
  return [];
}
const gyt = { Width: "1pt", Style: "dotted", Color: "#dedede" };
const yyt = (e14) => {
  const { instanceId: t10, getItemLayerInfo: n10 } = ep.useContext(bqe);
  const { item: r10, theme: o10, path: a10, style: i10, children: s10, onlyContent: l10 } = e14;
  const { isVisible: c10, opacity: u10 } = n10(r10);
  const { userPreferences: { surface: { showGrid: d10, gridSize: p10 = "0.25in" } } } = KO.of(t10);
  const m10 = ep.useRef(null);
  const h10 = rj(r10) ? 1 : c10 ? u10 : 0;
  let f10 = Fme({}, o10, gyt);
  i10 && (f10 = zV.merge({}, f10, i10)), f10.left = `calc(0% - (${f10.borderLeftWidth} / 2) )`, f10.top = `calc(0% - (${f10.borderTopWidth} / 2) )`, f10.width = `calc(100% + (${f10.borderLeftWidth} / 2) + (${f10.borderRightWidth} / 2) )`, f10.height = `calc(100% + (${f10.borderTopWidth} / 2) + (${f10.borderBottomWidth} / 2) )`;
  const { Width: g10, Height: y10 } = r10.$place;
  const { Name: v10 } = r10;
  const b10 = { width: L$.toPixels(g10), height: L$.toPixels(y10) };
  const S10 = zlt({ ref: m10.current, name: v10 || "", type: r10.Type, path: a10 }, t10);
  const [, C10] = are(__spreadValues({ accept: ["reportitem", "toolboxItem", "smartSuggestion", "value", "field", "fields", "resizegrip", "placeHolderResizeGrip", "entity_relation", "dataset", "partItem"] }, S10));
  const x10 = kp("ar-item", "ar-banded-list-borders");
  return tp.createElement("tr", { style: b10 }, tp.createElement("td", { style: b10 }, tp.createElement("div", { className: "ar-banded-list-section", ref: l10 ? void 0 : C10 }, tp.createElement("div", { "data-path": a10, "data-type": r10.Type, style: f10, ref: m10, className: x10 }), 0 !== h10 && d10 && tp.createElement(Flt, { id: `${v10}-bg-grid`, key: `${v10}-${g10}-${y10}-${p10}`, size: p10, roundStyle: {} }), !l10 && c10 && tp.createElement(Ult, __spreadValues({}, e14)), s10)));
};
const vyt = tp.createElement("svg", { width: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M2 4.5C2 3.119 3.119 2 4.5 2h7C12.881 2 14 3.119 14 4.5v7c0 1.381-1.119 2.5-2.5 2.5h-7C3.119 14 2 12.881 2 11.5v-7ZM6 13h4v-2H6v2Zm-1-2H3v.5c0 .828.672 1.5 1.5 1.5H5v-2Zm1-1h4V6H6v4ZM5 6H3v4h2V6Zm1-1h4V3H6v2ZM5 3h-.5C3.672 3 3 3.672 3 4.5V5h2V3Zm8 3h-2v4h2V6Zm0 5h-2v2h.5c.828 0 1.5-.672 1.5-1.5V11Zm0-6v-.5c0-.828-.672-1.5-1.5-1.5H11v2h2Z" }), tp.createElement("path", { className: Km.accent, d: "M13 6v4h-2V6h2ZM5 6v4H3V6h2Zm1 4V6h4v4H6Z" }));
const byt = tp.createElement("svg", { width: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M2 4.5C2 3.119 3.119 2 4.5 2h7C12.881 2 14 3.119 14 4.5v7c0 1.381-1.119 2.5-2.5 2.5h-7C3.119 14 2 12.881 2 11.5v-7ZM6 13h4v-2H6v2Zm-1-2H3v.5c0 .828.672 1.5 1.5 1.5H5v-2Zm1-1h4V6H6v4ZM5 6H3v4h2V6Zm1-1h4V3H6v2ZM5 3h-.5C3.672 3 3 3.672 3 4.5V5h2V3Zm8 3h-2v4h2V6Zm0 5h-2v2h.5c.828 0 1.5-.672 1.5-1.5V11Zm0-6v-.5c0-.828-.672-1.5-1.5-1.5H11v2h2Z" }), tp.createElement("path", { className: Km.accent, d: "M5 11v2h-.5c-.828 0-1.5-.672-1.5-1.5V11h2Zm1 2v-2h4v2H6Zm7-2v.5c0 .828-.672 1.5-1.5 1.5H11v-2h2Z" }));
const Syt = tp.createElement("svg", { width: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.accent, d: "M5.5 13c.276 0 .5.224.5.5s-.224.5-.5.5H4.462c-.653 0-1.279-.259-1.741-.721C2.259 12.817 2 12.191 2 11.538V4.462c0-.653.259-1.279.721-1.741C3.183 2.259 3.809 2 4.462 2H5.5c.276 0 .5.224.5.5s-.224.5-.5.5H4.462c-.388 0-.76.154-1.034.428S3 4.074 3 4.462v7.076c0 .388.154.76.428 1.034S4.074 13 4.462 13H5.5Z" }));
const Cyt = tp.createElement("svg", { width: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Ym.text, d: "M2 4.5C2 3.119 3.119 2 4.5 2h7C12.881 2 14 3.119 14 4.5v7c0 1.381-1.119 2.5-2.5 2.5h-7C3.119 14 2 12.881 2 11.5v-7ZM6 13h4v-2H6v2Zm-1-2H3v.5c0 .828.672 1.5 1.5 1.5H5v-2Zm1-1h4V6H6v4ZM5 6H3v4h2V6Zm1-1h4V3H6v2ZM5 3h-.5C3.672 3 3 3.672 3 4.5V5h2V3Zm8 3h-2v4h2V6Zm0 5h-2v2h.5c.828 0 1.5-.672 1.5-1.5V11Zm0-6v-.5c0-.828-.672-1.5-1.5-1.5H11v2h2Z" }), tp.createElement("path", { className: Km.accent, d: "M13 5h-2V3h.5c.828 0 1.5.672 1.5 1.5V5ZM5 3v2H3v-.5C3 3.672 3.672 3 4.5 3H5Zm1 2V3h4v2H6Z" }));
const [xyt, , wyt] = Dp("ar-adorner-panel");
const [Tyt] = wyt("heading");
const [Eyt] = wyt("content");
const [Fyt, Myt] = wyt("item");
const [kyt] = wyt("item-icon");
const [Pyt] = wyt("item-icon-group");
const Nyt = ({ groupIndex: e14 }) => tp.createElement("div", { className: Pyt }, tp.createElement(Fm, { icon: nf(Syt) }), e14);
const Dyt = (e14) => ({ text: e14("adorners:table.newGroupLabel", "<New Group>"), selected: false });
const Lyt = ({ item: { icon: e14, text: t10, selected: n10, path: r10, action: o10 }, index: a10, onHover: i10 }) => {
  const s10 = ep.useRef(null);
  const l10 = PA();
  const [, c10] = are({ accept: ["value", "field"], hover: (e15, t11) => {
    t11.isOver({ shallow: true }) && i10(a10);
  }, collect: (e15) => ({ item: e15.getItem() }) });
  const u10 = () => {
    l10(o10);
  };
  const d10 = kp(Fyt, { [Myt("selected")]: n10 });
  return c10(s10), tp.createElement("div", { ref: s10, className: d10, "data-path": r10, onClick: u10, onContextMenu: u10 }, tp.createElement("div", { className: kyt }, e14), tp.createElement("span", { "data-path": r10 }, t10));
};
const Hyt = (e14, t10, n10 = false) => {
  const r10 = e14.length - 1;
  return 0 === e14.length ? 0 : 1 === e14.length ? n10 ? r10 : 0 : t10 < r10 ? t10 : n10 ? r10 : r10 - 1;
};
const Iyt = (e14, t10, n10) => AV(e14, { $splice: [[t10, 0, Dyt(n10)]] });
const _yt = ({ heading: e14, items: t10, insertAtTheEnd: n10, withDragDrop: r10 = true, createDragDropAction: o10, customCSS: a10 }) => {
  const { setDecorations: i10 } = ep.useContext(bqe);
  const s10 = PA();
  const { t: l10 } = vp();
  const [c10, u10] = ep.useState(t10);
  const [d10, p10] = ep.useState(-1);
  const m10 = ep.useRef(null);
  const h10 = (e15) => {
    if (!r10) return;
    let t11 = [...c10];
    const o11 = Hyt(c10, e15, n10);
    o11 !== d10 && (t11 = d10 < 0 ? Iyt(t11, o11, l10) : ((e16, t12, n11) => AV(e16, { $splice: [[n11, 1], [t12, 0, e16[n11]]] }))(t11, o11, d10), u10(t11), p10(o11));
  };
  const [{ isDragging: f10, isHovering: g10 }, y10] = are({ accept: ["value", "field"], drop: (e15) => {
    if (!r10) return;
    const t11 = ((e16) => {
      if ("field" === e16.type) {
        const { value: t12, variationFormat: n11 } = e16.field;
        const r11 = n11 ? `=${U1(t12, n11)}` : `=${G1(t12)}`;
        return { label: e16.field.name, expr: r11, dataSetName: e16.dataSetName };
      }
      return "value" === e16.type ? { label: e16.label, expr: e16.expr } : null;
    })(e15);
    t11 && s10(o10(d10, t11));
  }, hover: (e15, t11) => {
    if (t11.isOver() && t11.canDrop() && i10("", []), d10 >= 0) return;
    const r11 = Hyt(c10, c10.length - 1, n10);
    const o11 = Iyt(c10, r11, l10);
    requestAnimationFrame(() => {
      u10(o11), p10(r11);
    });
  }, collect: (e15) => {
    const t11 = e15.getItem();
    return { isDragging: !(!r10 || !t11) && e15.canDrop(), isHovering: !!r10 && e15.isOver(), item: t11 };
  } });
  ep.useEffect(() => {
    u10(t10);
  }, [t10]), ep.useEffect(() => {
    !g10 && d10 >= 0 && !f10 && (u10(t10), p10(-1));
  }, [f10, g10, d10, t10]);
  const v10 = { text: e14, uppercase: false, strikeThrough: false };
  const b10 = kp(xyt, a10);
  return y10(m10), tp.createElement("div", { className: b10 }, tp.createElement("div", { className: Tyt }, tp.createElement(LE, __spreadValues({}, v10))), tp.createElement("div", { className: Eyt }, tp.createElement("div", { ref: m10, className: _z(false, f10) }, tp.createElement(bF, null, c10.map((e15, t11) => {
    const n11 = { item: e15, index: t11, onHover: h10 };
    return tp.createElement(Lyt, __spreadValues({ key: `${e15.text}-${t11}` }, n11));
  })))));
};
const Vyt = (e14) => {
  const { bandedList: t10, bandedListPath: n10 } = e14;
  const { lockLayout: r10 } = Uae();
  const { t: o10 } = vp();
  const a10 = t10.Groups.map((e15, t11) => ({ text: e15.Group.Name, icon: tp.createElement(Nyt, { groupIndex: t11 + 1 }), selected: rj(e15), action: c5($j(n10, `Groups.${t11}`), rW.bandedListGroup), path: $j(n10, `Groups.${t11}`) }));
  t10.Details && a10.push({ text: o10("adorners:bandedList.detailsLabel", "<Details>"), icon: tp.createElement(Fm, { icon: nf(vyt) }), selected: rj(t10.Details), action: c5($j(n10, "Details"), rW.bandedListDetails), path: $j(n10, "Details") });
  const i10 = { heading: o10("adorners:bandedList.groupsLabel", "Groups"), items: a10, withDragDrop: !r10, createDragDropAction: (e15, n11) => {
    const { label: r11, expr: a11, dataSetName: i11 } = n11;
    const s10 = { Group: { Name: MG(t10.Name, r11 && r11.replace(Jc("[^\\p{L}\\p{N}_]", "g"), "") || o10("nameTemplates:bandedListGroup", "Group")), GroupExpressions: [a11] } };
    return eyt({ insertIndex: e15, properties: s10, dataSetName: i11 || "" });
  }, customCSS: JAe };
  return tp.createElement(_yt, __spreadValues({}, i10));
};
const Ryt = ({ path: e14, type: t10 }) => tp.createElement("div", { className: "ar-item banded-list-adorner-move-grip", "data-path": e14, "data-type": t10 }, tp.createElement(Fm, { icon: nf(mqe, { cssClass: hqe }) }));
const Ayt = (e14) => {
  const { index: t10, width: n10, dndEnabled: r10, type: o10, path: a10 } = e14;
  const { getReport: i10 } = ep.useContext(bqe);
  let s10 = i10();
  const l10 = [];
  if (a10) {
    const e15 = a10.split(".").reduce((e16, t11) => e16 && e16[t11], s10);
    if (e15 && !sj(e15)) {
      const e16 = c5(a10, o10);
      s10 = n5(s10, e16), l10.push(e16);
    }
  }
  const [, c10] = Yne({ item: { resize: true, type: "resizegrip", path: a10, reportState: s10, startDndActions: l10, grips: qG.S }, canDrag: () => true, collect: (e15) => ({ isDragging: e15.isDragging() }) });
  return r10 ? tp.createElement("div", { className: "banded-list-adorner-spot" }, tp.createElement("div", { className: "banded-list-adorner-spot__add" }, tp.createElement("div", { className: "banded-list-adorner-spot__add-deco" }, tp.createElement("div", { className: "banded-list-adorner-spot__add-deco-area" }, tp.createElement("div", { style: { width: n10 } })))), t10 >= 0 && c10(tp.createElement("div", { className: "banded-list-adorner-spot__grip" }))) : null;
};
const Oyt = { bandedlistdetails: vyt, bandedlistfooter: byt, bandedlistheader: Cyt };
const Byt = L$.parse("0.25in");
const zyt = ({ band: e14, groupIndex: t10 }) => {
  var n10;
  if (n10 = e14.$place.Height, L$.isValidString(n10) && !L$.parse(n10).lowerThan(Byt)) return "number" == typeof t10 ? tp.createElement("div", { className: QAe }, tp.createElement(Fm, { icon: nf(Syt) }), t10 + 1) : tp.createElement(Fm, { icon: nf(Oyt[e14.Type]) });
};
const $yt = ({ bandsInfo: e14, bandedListPath: t10, dndEnabled: n10 }) => tp.createElement("table", { className: "banded-list-row-adorner" }, tp.createElement("tbody", null, e14.map((e15, r10) => {
  const { band: o10, selected: a10 } = e15;
  const { Width: i10, Height: s10 } = o10.$place;
  const l10 = $j(t10, i3(e15));
  const c10 = o10.Type;
  const u10 = { width: i10, index: r10, dndEnabled: n10, path: l10, type: c10 };
  return tp.createElement("tr", { key: l10, className: kp("banded-list-row-adorner__row", { selected: a10 }) }, tp.createElement("td", { style: { height: s10 } }, tp.createElement(Ayt, __spreadValues({}, u10)), tp.createElement("div", { className: "ar-item banded-list-row-adorner__row-header", "data-path": l10, "data-type": c10 }), tp.createElement("div", { className: "banded-list-row-adorner__row-label", style: { pointerEvents: "none" } }, zyt(e15))));
})));
class Wyt extends tp.PureComponent {
  constructor() {
    super(...arguments), this.renderRow = ({ band: e14, selected: t10, primary: n10 }, r10) => {
      const { bandsInfo: o10 } = this.props;
      const a10 = o10[r10 - 1] && o10[r10 - 1].selected;
      const i10 = o10[r10 + 1] && o10[r10 + 1].selected;
      const s10 = { width: e14.$place.Width, height: e14.$place.Height };
      const l10 = kp({ selected: t10, primary: n10, "top-border": t10 && !a10, "bottom-border": t10 && !i10, "left-border": t10, "right-border": t10 });
      return tp.createElement("tr", { key: `band-adorner-${r10}`, style: s10 }, tp.createElement("td", { className: l10, style: s10 }));
    };
  }
  render() {
    const { bandedList: e14, bandsInfo: t10 } = this.props;
    const n10 = { layout: "fixed", width: e14.$place.Width, height: e14.$place.Height };
    return tp.createElement("table", { className: "banded-list-band-adorner", style: n10 }, tp.createElement("tbody", null, t10.map(this.renderRow)));
  }
}
Wyt.propTypes = { bandsInfo: JV.array.isRequired, bandedList: JV.object.isRequired };
const jyt = ({ bandedList: e14, bandedListPath: t10, dndEnabled: n10 }) => {
  const r10 = ((e15) => {
    const t11 = e15.Groups.findIndex(rj);
    return r3(e15).map((e16) => {
      const n11 = e16;
      return -1 !== t11 && ("bandedlistdetails" === e16.band.Type || "number" == typeof e16.groupIndex && e16.groupIndex >= t11) ? (n11.selected = true, n11.primary = true) : (n11.selected = rj(e16.band), n11.primary = ij(e16.band)), n11;
    });
  })(e14);
  const o10 = ((e15) => !(rj(e15) || !ij(e15)) && n3(e15))(e14);
  return tp.createElement("div", { className: "banded-list-adorner" }, o10 && tp.createElement(tp.Fragment, null, tp.createElement(Ryt, { path: t10, type: e14.Type }), tp.createElement(Vyt, { bandedList: e14, bandedListPath: t10 }), tp.createElement($yt, { bandsInfo: r10, bandedListPath: t10, dndEnabled: n10 })), tp.createElement(Wyt, { bandsInfo: r10, bandedList: e14 }));
};
class Zyt extends tp.PureComponent {
  constructor() {
    super(...arguments), this.renderBand = (e14, t10, n10) => {
      const { path: r10, theme: o10, dataSets: a10, parentBackgroundColor: i10, onlyContent: s10 } = this.props;
      const l10 = $j(r10, i3(e14));
      const c10 = this.sortByZIndex(e14.band.ReportItems);
      const u10 = { key: l10, item: e14.band, path: l10, theme: o10, style: { backgroundColor: i10 }, onlyContent: s10 };
      return 0 !== t10 && (u10.style.borderTopColor = "#aeaeae", u10.style.borderTopStyle = "solid"), t10 !== n10.length - 1 && (u10.style.borderBottomColor = "transparent"), tp.createElement(yyt, __spreadValues({}, u10), c10.map((t11, n11) => {
        const r11 = { item: t11, path: Wj(l10, n11), host: e14.band.Name, theme: o10, dataSets: a10, parentBackgroundColor: i10, onlyContent: s10 };
        return tp.createElement(N2e, __spreadProps(__spreadValues({}, r11), { key: `${t11.Name}Place` }));
      }));
    };
  }
  sortByZIndex(e14) {
    return e14.sort((e15, t10) => e15.ZIndex - t10.ZIndex);
  }
  render() {
    const { item: e14, path: t10, onlyContent: n10 } = this.props;
    const { getItemLayerInfo: r10, getSettings: o10 } = this.context;
    const { isVisible: a10, isLocked: i10 } = r10(e14);
    const { lockLayout: s10 } = o10();
    const l10 = { width: e14.$place.Width, height: e14.$place.Height, pointerEvents: a10 ? "all" : "none" };
    const c10 = { "data-path": t10, "data-type": e14.Type, className: "ar-item ar-banded-list", style: l10 };
    const u10 = r3(e14);
    return tp.createElement("div", { className: "ar-banded-list-glyph" }, tp.createElement("table", __spreadValues({}, c10), tp.createElement("tbody", null, u10.map(this.renderBand))), !n10 && tp.createElement(jyt, { bandedList: e14, bandedListPath: t10, dndEnabled: !i10 && !s10 }));
  }
}
Zyt.propTypes = { item: JV.object.isRequired, theme: JV.object, path: JV.string.isRequired }, Zyt.contextType = bqe;
const Gyt = FZ.resultOf(wq.decode({ Type: "bandedlist", Name: "bandedList1" }));
const Uyt = FZ.resultOf(wq.decode({ Type: "bandedlist", Name: "bandedList1", Header: { Name: "bandedlistheader" }, Details: { Name: "bandedlistdetails" }, Footer: { Name: "bandedlistfooter" }, Groups: [{}] }));
const qyt = (e14, t10, n10, r10 = Uyt) => __spreadProps(__spreadValues(__spreadValues({}, r10), n10), { Header: r10.Header && __spreadProps(__spreadValues({}, r10.Header), { Name: FG(TG("bandedlistheader")) }), Details: r10.Details && __spreadProps(__spreadValues({}, r10.Details), { Name: FG(TG("bandedlistdetails")) }), Footer: r10.Footer && __spreadProps(__spreadValues({}, r10.Footer), { Name: FG(TG("bandedlistfooter")) }), Name: e14 });
const Yyt = [EY.Name, FY.DataSetName, FY.DataSetParameters, EY.DataElementName, EY.DataElementOutput, FY.Filters, EY.Location, EY.Size, EY.LayerName, FY.PageBreak, FY.NewPage, kY.PreventOrphanedHeader, kY.PreventOrphanedFooter, FY.NewSection, EY.KeepTogether, Zq(cY, "bandedList.consumeWhiteSpace", "boolean", "ConsumeWhiteSpace", "advanced"), EY.ZIndex, EY.Visibility, EY.ToolTip, EY.Label, EY.Bookmark];
const Kyt = (e14) => L$.sum([L$.parse(e14.$place.Top), L$.parse(e14.$place.Height)]);
const Xyt = (e14) => L$.sum([L$.parse(e14.$place.Left), L$.parse(e14.$place.Width)]);
const Jyt = (e14) => e14 ? L$.parse(e14.$place.Width) : null;
const Qyt = (e14) => e14 ? L$.parse(e14.$place.Height) : null;
const evt = (e14, t10) => Array.isArray(e14) ? e14.reduce((e15, n10) => L$.max([e15, t10(n10)]), G5) : G5;
const tvt = ({ band: e14 }) => ({ current: Jyt(e14), min: evt(e14.ReportItems, Xyt) });
const nvt = ({ band: e14 }) => ({ current: Qyt(e14), min: evt(e14.ReportItems, Kyt) });
const rvt = (e14, t10) => r3(e14).map(t10);
function ovt(e14, t10) {
  let n10 = t10;
  const r10 = L$.sum(e14.map((e15) => e15.min));
  if (n10.lowerThanOrEqual(r10)) return e14.map(({ min: e15 }) => ({ current: e15, min: e15 }));
  const o10 = e14.reduce((e15, t11) => {
    var _a2;
    return ((_a2 = t11 == null ? void 0 : t11.current) == null ? void 0 : _a2.equal(t11.min)) ? (n10 = n10.subtract(t11.min), e15) : e15.add(t11.current);
  }, L$.zero);
  if (n10.lowerThanOrEqual(G5)) return e14;
  const a10 = n10.divide(o10);
  let i10 = true;
  let s10 = false;
  const l10 = e14.map((e15) => {
    var _a2;
    const t11 = (_a2 = e15 == null ? void 0 : e15.current) == null ? void 0 : _a2.multiply(a10);
    return (t11 == null ? void 0 : t11.lowerThan(e15.min)) ? (i10 = false, { min: e15.min, current: e15.min }) : (s10 = true, { min: e15.min, current: t11 });
  });
  return i10 ? l10 : s10 ? ovt(l10, t10) : l10;
}
const avt = (e14, t10) => {
  const n10 = L$.parse(t10);
  const r10 = ((e15) => rvt(e15, nvt))(e14);
  const o10 = L$.parse(e14.$place.Height);
  return n10.lowerThan(o10) ? ovt(r10, n10) : ((e15, t11, n11) => {
    const r11 = t11.divide(n11);
    return e15.map((e16) => {
      var _a2;
      return { min: e16.min, current: ((_a2 = e16 == null ? void 0 : e16.current) == null ? void 0 : _a2.multiply(r11)) || null };
    });
  })(r10, n10, o10);
};
const ivt = (e14) => {
  const t10 = e14 == null ? void 0 : e14.css;
  return { $place: { Height: { $set: t10 } }, $height: { $set: t10 } };
};
const svt = (e14, t10) => ((e15, t11) => {
  const n10 = e15.reduce((e16, t12) => L$.max([e16, t12.min]), G5);
  return L$.max([t11, n10]);
})(((e15) => rvt(e15, tvt))(e14), L$.parse(t10));
const lvt = (e14, t10) => {
  const n10 = ((e15) => {
    const t11 = e15 == null ? void 0 : e15.css;
    return { $place: { Width: { $set: t11 } }, $width: { $set: t11 } };
  })(t10);
  const r10 = __spreadValues({}, n10);
  e14.Header && (r10.Header = n10), e14.Footer && (r10.Footer = n10), e14.Details && (r10.Details = n10);
  const o10 = e14.Groups.length;
  if (o10) {
    r10.Groups = {};
    for (let t11 = o10; t11--; ) {
      const o11 = e14.Groups[t11];
      const a10 = {};
      o11.Header && (a10.Header = n10), o11.Footer && (a10.Footer = n10), r10.Groups[t11] = a10;
    }
  }
  return r10;
};
const cvt = [xY.Height, EY.Action, kY.RepeatOnNewPage, kY.CanGrow, kY.CanShrink, FY.PageBreak, EY.KeepTogether, EY.Visibility];
const uvt = Uyt.Header;
const dvt = (e14, t10, n10, r10) => {
  const o10 = nz.of(e14).getTemplate("bandedlist", r10).Header;
  return __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, o10), { $place: __spreadProps(__spreadValues({}, o10 == null ? void 0 : o10.$place), { Width: t10 || (o10 == null ? void 0 : o10.$place.Width) }) }), n10), { Name: FG(TG("bandedlistheader")) });
};
const pvt = { type: "bandedlistheader", labelKey: "reportItems:bandedListHeader", defaultModel: uvt, getProperties: (e14, t10, n10) => (n10 == null ? void 0 : n10.isDashboard) ? n4(cvt) : cvt, getContextActions: i0e, getReducer: b7, features: { disableCopy: true } };
const mvt = [xY.Height, EY.Action, kY.PrintAtBottom, kY.RepeatOnNewPage, kY.CanGrow, kY.CanShrink, FY.PageBreak, EY.KeepTogether, EY.Visibility];
const hvt = Uyt.Footer;
const fvt = (e14, t10, n10, r10) => {
  const o10 = nz.of(e14).getTemplate("bandedlist", r10).Footer;
  return __spreadValues(__spreadProps(__spreadValues({}, o10), { $place: __spreadProps(__spreadValues({}, o10 == null ? void 0 : o10.$place), { Width: t10 || (o10 == null ? void 0 : o10.$place.Width) }), Name: FG(TG("bandedlistfooter")) }), n10);
};
const gvt = { type: "bandedlistfooter", labelKey: "reportItems:bandedListFooter", defaultModel: hvt, getProperties: (e14, t10, n10) => (n10 == null ? void 0 : n10.isDashboard) ? n4(mvt) : mvt, getContextActions: i0e, getReducer: b7, features: { disableCopy: true } };
const yvt = [MY.Name, MY.GroupExpressions, MY.PageBreakWithBetween, MY.Parent, MY.DocumentMapLabel, MY.DataElementName, MY.DataCollectionName, MY.DataElementOutput, MY.NewSection, MY.Filters, kY.PreventOrphanedHeader, kY.PreventOrphanedFooter, EY.KeepTogether, FY.SortExpressions, EY.Visibility];
const vvt = Uyt.Groups[0];
const bvt = (e14, t10, n10, r10) => {
  var _a2;
  const o10 = nz.of(e14).getTemplate("bandedlist", r10);
  const a10 = ((_a2 = (o10 || Uyt).Groups[0]) == null ? void 0 : _a2.Header) || o10.Header;
  return __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, a10), { $place: __spreadProps(__spreadValues({}, a10 == null ? void 0 : a10.$place), { Width: t10 || (a10 == null ? void 0 : a10.$place.Width) }) }), n10), { Name: FG(TG("bandedlistheader")) });
};
const Svt = (e14, t10, n10, r10) => {
  var _a2;
  const o10 = nz.of(e14).getTemplate("bandedlist", r10);
  const a10 = ((_a2 = (o10 || Uyt).Groups[0]) == null ? void 0 : _a2.Footer) || o10.Footer;
  return __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, a10), { $place: __spreadProps(__spreadValues({}, a10 == null ? void 0 : a10.$place), { Width: t10 || (a10 == null ? void 0 : a10.$place.Width) }) }), n10), { Name: FG(TG("bandedlistfooter")) });
};
const Cvt = { type: "bandedlistgroup", labelKey: "reportItems:bandedListGroup", nameTemplateKey: "nameTemplates:bandedListGroup", defaultModel: vvt, getProperties: () => yvt, getContextActions: i0e, getReducer: function(e14) {
  return GV(rj, nz.of(e14).of("rdlx").getDefaultReducer(), Wye);
}, features: { disableCopy: true } };
const xvt = ["tableofcontents", "fixedpagetableofcontents", "contentplaceholder"];
const wvt = (e14) => {
  if (rj(e14)) return e14;
  const t10 = ij(e14);
  const n10 = AV(dj(lj(e14), false, t10), { Details: { $apply: (e15) => dj(e15, true, t10) } });
  return n10;
};
const Tvt = (e14) => {
  const t10 = {};
  const n10 = { LayerName: { $set: e14.LayerName } };
  return r3(e14).forEach((e15) => {
    const r10 = i3(e15);
    j0(t10, r10, n10);
  }), AV(e14, t10);
};
const Evt = (e14) => {
  const t10 = ((e15) => {
    const t11 = o3(e15).map(Qyt);
    return L$.sum(t11);
  })(e14).css;
  return t10 !== e14.$place.Height ? AV(e14, { $height: { $set: t10 }, $place: { Height: { $set: t10 } } }) : e14;
};
const Fvt = (e14) => {
  const t10 = ((e15) => {
    const t11 = o3(e15).map(Jyt);
    return L$.max(t11);
  })(e14).css;
  return t10 !== e14.$place.Width ? AV(e14, { $width: { $set: t10 }, $place: { Width: { $set: t10 } } }) : e14;
};
function Mvt(e14) {
  const t10 = {};
  const n10 = r3(e14).reduce((e15, n11) => function(e16, t11) {
    const n12 = e16;
    let r10 = false;
    const o10 = {};
    const { band: a10 } = t11;
    return a10.$width && a10.$place.Width !== a10.$width && (o10.Width = { $set: a10.$width }, r10 = true), a10.$height && a10.$place.Height !== a10.$height && (o10.Height = { $set: a10.$height }, r10 = true), r10 && j0(n12, i3(t11), { $place: o10 }), r10;
  }(t10, n11) || e15, false);
  return n10 ? AV(e14, t10) : e14;
}
function kvt(e14, t10) {
  const n10 = {};
  const { value: r10, descriptor: o10 } = t10.payload;
  const a10 = r3(e14);
  let i10 = false;
  return a10.forEach((e15) => {
    const { band: a11 } = e15;
    if (!aj(a11)) return;
    let s10 = a11;
    if (oj(a11)) s10 = n5(a11, t10);
    else if (rj(a11)) {
      if (!o10.valuePath) throw new Error(`Invalid descriptor value path for location-size property: ${o10.valuePath}`);
      if ("$place.Width" === o10.valuePath || "$place.Height" === o10.valuePath) {
        const e16 = { [o10.valuePath.split(".")[1].toLowerCase()]: r10 };
        s10 = n5(a11, A5(e16));
      } else {
        const e16 = o10.valuePath.split(".");
        const t11 = {};
        let n11 = t11;
        e16.forEach((t12, o11) => {
          n11[t12] = o11 === e16.length - 1 ? { $set: r10 } : {}, n11 = n11[t12];
        }), s10 = AV(s10, t11), "line" === s10.Type && (s10 = uU(s10));
      }
    }
    s10 !== a11 && (j0(n10, i3(e15), { $set: s10 }), i10 = true);
  }), i10 ? AV(e14, n10) : e14;
}
const Pvt = Uye(0, { [A5.type]: jV(ZV(function(e14, { payload: t10 }) {
  const { height: n10 } = t10;
  let r10 = e14;
  if (n10 && n10.css !== e14.$place.Height) {
    const e15 = ((e16, t11) => {
      var _a2, _b2, _c2, _d2, _e2;
      const n11 = {};
      e16.Header && (n11.Header = ivt((_a2 = t11 == null ? void 0 : t11.shift()) == null ? void 0 : _a2.current)), e16.Footer && (n11.Footer = ivt((_b2 = t11 == null ? void 0 : t11.pop()) == null ? void 0 : _b2.current));
      const r11 = e16.Groups.length;
      if (r11) {
        n11.Groups = {};
        for (let o10 = r11; o10--; ) {
          const r12 = e16.Groups[o10];
          const a10 = {};
          r12.Header && (a10.Header = ivt((_c2 = t11 == null ? void 0 : t11.shift()) == null ? void 0 : _c2.current)), r12.Footer && (a10.Footer = ivt((_d2 = t11 == null ? void 0 : t11.pop()) == null ? void 0 : _d2.current)), n11.Groups[o10] = a10;
        }
      }
      return e16.Details && (n11.Details = ivt((_e2 = t11 == null ? void 0 : t11.pop()) == null ? void 0 : _e2.current)), n11;
    })(r10, avt(r10, n10));
    r10 = AV(r10, e15);
  }
  return r10;
}, Evt), ZV(function(e14, { payload: t10 }) {
  const { width: n10 } = t10;
  let r10 = e14;
  if (n10 && n10.css !== e14.$place.Width) {
    const e15 = svt(r10, n10);
    const t11 = lvt(r10, e15);
    r10 = AV(r10, t11);
  }
  return r10;
}, Fvt)) });
function Nvt(e14) {
  let t10 = false;
  const n10 = {};
  return r3(e14).forEach((e15) => {
    if (!rj(e15.band)) return;
    if (e15.band.Type === rW.bandedListDetails) return;
    const r10 = i3(e15);
    j0(n10, r10, { $set: null }), t10 = true;
  }), t10 ? AV(e14, n10) : e14;
}
const Dvt = (e14, { payload: { deleteIndex: t10 } }) => AV(e14, { Groups: { $splice: [[t10, 1]] } });
const Lvt = jV(Mvt, Evt, ZV(Fvt, (e14) => {
  const t10 = L$.parse(e14.$place.Width);
  return AV(e14, lvt(e14, t10));
}));
function Hvt(e14, { payload: t10 }) {
  let n10 = e14;
  const r10 = function(e15, t11) {
    const { grip: n11, delta: r11 } = t11;
    if (n11 !== qG.S) throw new Error(`bandedList::resizeBand(): side=${n11} not supported`);
    const o10 = r11 && r11.y;
    return L$.isZeroLike(o10) ? null : L$.parse(e15).add(L$.parse(o10)).css;
  }(o3(n10).find(rj).$place.Height, t10);
  return r10 && (n10 = Wye(n10, A5({ height: r10 }))), n10;
}
function Ivt(e14, { payload: t10 }) {
  const n10 = t10.dataSetName || t10.dataSet;
  const r10 = vj(e14);
  return r10.length && r10.some((t11) => !zj(e14, t11.path)) && n10 && !e14.DataSetName ? AV(e14, { DataSetName: { $set: n10 } }) : e14;
}
function _vt(e14) {
  let t10 = "";
  return C3(e14, (e15, n10) => (xvt.includes(n10.Type) && (t10 = n10.Type), !t10 || null)), t10;
}
const Vvt = (e14, { payload: { items: t10 } }) => (t10.forEach((t11) => {
  const n10 = _vt(t11);
  if (n10) throw $0(n10, e14.Type);
}), e14);
const Rvt = (e14, { payload: { Type: t10, item: n10 } }) => {
  let r10 = "";
  if (n10 ? r10 = _vt(n10) : xvt.includes(t10) && (r10 = t10), r10) throw $0(r10, rW.bandedList);
  return e14;
};
const Avt = (e14) => ij(e14) && n3(e14);
const Ovt = ZV(Wye, Lvt);
const Bvt = (e14) => GV(Avt, e14, Ovt);
function zvt(e14) {
  const t10 = nz.of(e14).of("rdlx").getDefaultReducer();
  function n10(t11, n11, r11) {
    const o11 = t11[n11] ? null : r11(e14, t11.$place.Width, t11.$templateId);
    return AV(t11, { [n11]: { $set: o11 } });
  }
  function r10(t11, n11, r11, o11) {
    const a11 = t11.Groups[n11][r11] ? null : o11(e14, t11.$place.Width, {}, t11.$templateId);
    return AV(t11, { Groups: { [n11]: { [r11]: { $set: a11 } } } });
  }
  const o10 = jV((e15) => n10(e15, "Footer", fvt), Evt, Tvt);
  const a10 = jV((e15) => n10(e15, "Header", dvt), Evt, Tvt);
  const i10 = jV((t11, { payload: { insertIndex: n11, properties: r11, dataSetName: o11 } }) => {
    const a11 = ((e15, t12, n12, r12, o12) => {
      const a12 = nz.of(e15).getTemplate("bandedlist", o12).Groups[0] || vvt;
      const { t: i12 } = hG();
      const s11 = a12.Header || dvt(e15, n12, void 0, o12);
      const l11 = a12.Footer || fvt(e15, n12, void 0, o12);
      return __spreadProps(__spreadValues(__spreadValues({}, a12), r12), { Group: __spreadValues(__spreadProps(__spreadValues({}, a12.Group), { Name: MG(t12, i12("nameTemplates:bandedListGroup", "Group")) }), r12.Group), Header: __spreadValues(__spreadValues({}, s11), r12.Header), Footer: __spreadValues(__spreadValues({}, l11), r12.Footer) });
    })(e14, t11.Name, t11.$place.Width, r11, t11.$templateId);
    const i11 = { Groups: { $splice: [[n11, 0, a11]] } };
    return !t11.DataSetName && o11 && (i11.DataSetName = { $set: o11 }), AV(t11, i11);
  }, Evt, Tvt);
  const s10 = jV(Dvt, wvt, Evt);
  const l10 = jV((e15, { payload: t11 }) => r10(e15, t11.groupIndex, "Footer", Svt), Evt, Tvt);
  const c10 = jV((e15, { payload: t11 }) => r10(e15, t11.groupIndex, "Header", bvt), Evt, Tvt);
  const u10 = Uye(0, { [Ggt]: o10, [Zgt]: a10 }, t10);
  const d10 = Uye(0, { [Xgt]: GV(Q4, jV(Nvt, Ovt, wvt, Evt), Ovt), [Ugt]: Bvt(i10), [qgt]: Bvt(s10), [Kgt]: Bvt(l10), [Ygt]: Bvt(c10), [$G]: GV(Q4, ZV(Hvt, Mvt, Evt), Ovt), [d2.type]: jV(kvt, Lvt), [o2.type]: jV(Ivt, Ovt), [O5.type]: jV(Ivt, Ovt), [WG]: jV(Rvt, Ovt), [GG]: jV(Rvt, Ovt), [jG]: jV(Vvt, Ovt), [UG]: jV(Vvt, Ovt) }, Ovt);
  return function(e15, t11) {
    return A5.match(t11) ? Pvt(e15, t11) : GV(rj, u10, d10)(e15, t11);
  };
}
const $vt = { type: Gyt.Type, labelKey: "reportItems:bandedList", nameTemplateKey: "nameTemplates:bandedList", icon: nf(Hoe), icon24: nf(Ioe), defaultModel: Gyt, init: qyt, getReducer: zvt, getContextActions: hyt, glyph: Zyt, getProperties: (e14, t10, n10) => (n10 == null ? void 0 : n10.isDashboard) ? n4(Yyt) : Yyt, features: { getExpressionProperties: fyt, isDataRegion: true } };
const Wvt = [xY.Height, EY.Action, kY.CanGrow, kY.CanShrink, kY.PageBreakWithBetween, EY.KeepTogether, EY.Visibility];
const jvt = { type: "bandedlistdetails", labelKey: "reportItems:bandedListDetails", defaultModel: Uyt.Details, getProperties: (e14, t10, n10) => (n10 == null ? void 0 : n10.isDashboard) ? n4(Wvt) : Wvt, getContextActions: i0e, getReducer: b7, features: { disableCopy: true } };
const Zvt = ["Gs1CompositeOptions.Value", "InvalidBarcodeText", "SupplementOptions.Value", "Value"];
var Gvt = {};
var Uvt = {};
Object.defineProperty(Uvt, "__esModule", { value: true }), Uvt.set = Uvt.get = void 0, Uvt.get = function e12(t10, n10) {
  if (null == t10) return t10;
  var r10 = n10.split(".");
  var o10 = t10[r10[0]];
  return 1 === r10.length ? o10 : e12(o10, r10.slice(1).join("."));
}, Uvt.set = function e13(t10, n10, r10) {
  if ("object" == typeof t10 && null !== t10) {
    var o10 = n10.split(".");
    1 === o10.length ? t10[o10[0]] = r10 : ("object" == typeof t10[o10[0]] && null !== t10[o10[0]] || (t10[o10[0]] = {}), e13(t10[o10[0]], o10.slice(1).join("."), r10));
  }
};
var qvt = {};
Object.defineProperty(qvt, "__esModule", { value: true });
var Yvt = { in: 1440, pt: 20, pc: 240, cm: 566.9291338582677, mm: 56.69291338582677 };
qvt.default = { parse: function(e14) {
  var t10 = e14.trim();
  var n10 = t10.substr(-2).toLowerCase();
  if (!Yvt[n10]) throw new Error("Unable to parse length: ".concat(e14));
  var r10 = t10.substr(0, t10.length - 2);
  if (!function(e15) {
    return !isNaN(e15 - parseFloat(e15));
  }(r10)) throw new Error("Unable to parse length: ".concat(e14));
  var o10 = parseFloat(r10);
  return Math.trunc(o10 * Yvt[n10]);
}, toCss: function(e14) {
  return "".concat(Math.round(1e4 * e14 / 20) / 1e4, "pt");
} };
var Kvt = $ && $.__read || function(e14, t10) {
  var n10 = "function" == typeof Symbol && e14[Symbol.iterator];
  if (!n10) return e14;
  var r10, o10, a10 = n10.call(e14), i10 = [];
  try {
    for (; (void 0 === t10 || t10-- > 0) && !(r10 = a10.next()).done; ) i10.push(r10.value);
  } catch (e15) {
    o10 = { error: e15 };
  } finally {
    try {
      r10 && !r10.done && (n10 = a10.return) && n10.call(a10);
    } finally {
      if (o10) throw o10.error;
    }
  }
  return i10;
};
var Xvt = $ && $.__spreadArray || function(e14, t10, n10) {
  if (n10 || 2 === arguments.length) for (var r10, o10 = 0, a10 = t10.length; o10 < a10; o10++) !r10 && o10 in t10 || (r10 || (r10 = Array.prototype.slice.call(t10, 0, o10)), r10[o10] = t10[o10]);
  return e14.concat(r10 || Array.prototype.slice.call(t10));
};
Object.defineProperty(Gvt, "__esModule", { value: true });
var Jvt = Gvt.translateBarcodeModel = oSt = Gvt.isSymbologySupported = void 0;
var Qvt = Uvt;
var ebt = qvt;
var tbt = function(e14) {
  try {
    ebt.default.parse(e14);
  } catch (e15) {
    return false;
  }
  return true;
};
var nbt = function(e14, t10, n10) {
  return void 0 === n10 && (n10 = function() {
    var e15 = [];
    for (var t11 = 0; t11 < arguments.length; t11++) e15[t11] = arguments[t11];
    return e15[0];
  }), { from: t10, to: e14, converter: n10 };
};
function rbt(e14, t10, n10) {
  void 0 === t10 && (t10 = Number.MIN_VALUE), void 0 === n10 && (n10 = Number.MAX_VALUE);
  var r10 = "".concat(e14);
  return r10.length < t10 ? abt(r10, t10) : r10.length > n10 ? r10.substr(0, n10) : r10;
}
var obt = function(e14) {
  return e14 || void 0;
};
var abt = function(e14, t10) {
  return "0".repeat(Math.max(0, t10 - e14.length)) + e14;
};
var ibt = function(e14) {
  return "Above" === e14 ? "top" : "bottom";
};
var sbt = function(e14) {
  return "None" !== e14;
};
var lbt = function(e14, t10) {
  return "None" !== t10 ? e14 : "";
};
var cbt = function(e14, t10, n10, r10) {
  if (![e14, t10, n10, r10].every(tbt)) return e14;
  var o10 = ebt.default.parse(r10);
  if (!o10) return e14;
  var a10 = Kvt([e14, t10, n10].map(function(e15) {
    return ebt.default.parse(e15);
  }), 3), i10 = a10[0], s10 = a10[1];
  var l10 = (a10[2] - i10 - s10 - o10) / 2;
  return ebt.default.toCss(Math.max(0, i10 + l10));
};
var ubt = { Right: "right", Left: "left" };
var dbt = { Underline: "underline", Overline: "overline", LineThrough: "line-through", UnderlineLineThrough: "underline line-through" };
var pbt = { Lighter: "50", Thin: "100", ExtraLight: "200", Light: "300", Normal: "normal", Medium: "500", SemiBold: "600", Bold: "700", ExtraBold: "800", Heavy: "900", Bolder: "1000" };
var mbt = { Auto: "auto", Mask000: "0", Mask001: "1", Mask010: "2", Mask011: "3", Mask100: "4", Mask101: "5", Mask110: "6", Mask111: "7" };
var hbt = function(e14) {
  return mbt[e14];
};
var fbt = { 65001: "UTF-8", 932: "Shift_JIS" };
var gbt = function(e14) {
  return fbt[e14] || "UTF-8";
};
var ybt = { Level0: "0", Level1: "1", Level2: "2", Level3: "3", Level4: "4", Level5: "5", Level6: "6", Level7: "7", Level8: "8" };
var vbt = { SquareAuto: "squareAuto", RectangularAuto: "rectangularAuto", Square10: "square10", Square12: "square12", Square14: "square14", Square16: "square16", Square18: "square18", Square20: "square20", Square22: "square22", Square24: "square24", Square26: "square26", Square32: "square32", Square36: "square36", Square40: "square40", Square44: "square44", Square48: "square48", Square52: "square52", Square64: "square64", Square72: "square72", Square80: "square80", Square88: "square88", Square96: "square96", Square104: "square104", Square120: "square120", Square132: "square132", Square144: "square144", Rectangular8x18: "rectangular8x18", Rectangular8x32: "rectangular8x32", Rectangular12x26: "rectangular12x26", Rectangular12x36: "rectangular12x36", Rectangular16x36: "rectangular16x36", Rectangular16x48: "rectangular16x48" };
var bbt = function(e14) {
  return vbt[e14];
};
var Sbt = { Auto: "auto", Square9: "square9", Square11: "square11", Square13: "square13", Square15: "square15", Square17: "square17", Square19: "square19", Square21: "square21", Square23: "square23", Square25: "square25", Square27: "square27", Square29: "square29", Square31: "square31", Square33: "square33", Square35: "square35", Square37: "square37", Square39: "square39", Square41: "square41", Square43: "square43", Square45: "square45", Square47: "square47", Square49: "square49" };
var Cbt = [nbt("renderType", [], function() {
  return "svg";
}), nbt("color", ["Style.Color"]), nbt("backgroundColor", ["Style.BackgroundColor"]), nbt("hideExtraChecksum", [], function() {
  return true;
}), nbt("desiredSize.width", ["Width"]), nbt("desiredSize.height", ["Height"]), nbt("font.fontFamily", ["Style.FontFamily"]), nbt("font.fontStyle", ["Style.FontStyle"]), nbt("font.fontWeight", ["Style.FontWeight"], function(e14) {
  return pbt[e14];
}), nbt("font.fontSize", ["Style.FontSize"]), nbt("font.textDecoration", ["Style.TextDecoration"], function(e14) {
  return dbt[e14] || "none";
}), nbt("font.textAlign", ["Style.TextAlign"], function(e14) {
  return ubt[e14] || "center";
}), nbt("quietZone.left", ["QuietZone.Left"]), nbt("quietZone.right", ["QuietZone.Right"]), nbt("quietZone.top", ["QuietZone.Top", "QuietZone.Bottom", "Height", "BarHeight"], cbt), nbt("quietZone.bottom", ["QuietZone.Bottom", "QuietZone.Top", "Height", "BarHeight"], cbt)];
var xbt = [nbt("type", ["Symbology"], function() {
  return "AztecCode";
}), nbt("text", ["Value"], function(e14) {
  return rbt(e14);
}), nbt("errorCorrection", ["AztecOptions.ErrorCorrection"]), nbt("symbolSize", ["AztecOptions.Layers"], function(e14) {
  return e14 >= 0 ? e14 : "".concat(-e14, "*");
}), nbt("charset", ["AztecOptions.Encoding"], gbt)];
var wbt = [nbt("type", ["Symbology"], function() {
  return "EAN13";
}), nbt("text", ["Value"], function(e14) {
  return rbt(e14, 0, 13);
}), nbt("showLabel", ["CaptionLocation"], sbt), nbt("labelPosition", ["CaptionLocation"], ibt), nbt("hideExtraChecksum", [], function() {
  return false;
}), nbt("addOn", ["SupplementOptions.Value"], obt), nbt("addOnHeight", ["SupplementOptions.BarHeight"], function(e14) {
  return tbt(e14) && ebt.default.parse(e14) ? e14 : "auto";
}), nbt("addOnLabelPosition", ["SupplementOptions.CaptionLocation"], ibt), nbt("quietZone.addOn", ["SupplementOptions.Spacing"])];
var Tbt = [nbt("type", ["Symbology"], function() {
  return "EAN8";
}), nbt("text", ["Value"], function(e14) {
  return rbt(e14, 0, 8);
}), nbt("showLabel", ["CaptionLocation"], sbt), nbt("labelPosition", ["CaptionLocation"], ibt), nbt("hideExtraChecksum", [], function() {
  return false;
}), nbt("addOn", ["SupplementOptions.Value"], obt), nbt("addOnHeight", ["SupplementOptions.BarHeight"], function(e14) {
  return tbt(e14) && ebt.default.parse(e14) ? e14 : "auto";
}), nbt("addOnLabelPosition", ["SupplementOptions.CaptionLocation"], ibt), nbt("quietZone.addOn", ["SupplementOptions.Spacing"])];
var Ebt = [nbt("type", ["Symbology"], function() {
  return "QRCode";
}), nbt("text", ["Value"], function(e14) {
  return rbt(e14);
}), nbt("charset", ["QrCodeOptions.Encoding"], gbt), nbt("model", ["QrCodeOptions.Model"], function(e14) {
  return "Model1" === e14 ? 1 : 2;
}), nbt("version", ["QrCodeOptions.Version"], function(e14) {
  return e14 > 0 ? e14 : "auto";
}), nbt("errorCorrectionLevel", ["QrCodeOptions.ErrorLevel"]), nbt("mask", ["QrCodeOptions.Mask"], hbt), nbt("connection", ["QrCodeOptions.Connection"]), nbt("connectionNo", ["QrCodeOptions.ConnectionNumber"])];
var Fbt = [nbt("type", ["Symbology"], function() {
  return "GS1DataMatrix";
}), nbt("text", ["Value"], function(e14) {
  return rbt(e14);
}), nbt("unitSize", ["NarrowBarWidth"], function(e14) {
  return Gbt(e14) ? e14 : null;
}), nbt("symbolSize", ["DataMatrixOptions.Ecc200SymbolSize"], bbt), nbt("encodingMode", ["DataMatrixOptions.Ecc200EncodingMode"], function(e14) {
  return "Auto" === e14 ? "auto" : e14;
}), nbt("structuredAppend", ["DataMatrixOptions.StructuredAppend"]), nbt("structureNumber", ["DataMatrixOptions.StructureNumber"]), nbt("fileIdentifier", ["DataMatrixOptions.FileIdentifier"])];
var Mbt = [nbt("type", ["Symbology"], function() {
  return "QRCode";
}), nbt("text", ["Value"], function(e14) {
  return rbt(e14);
}), nbt("charset", ["QrCodeOptions.Encoding"], gbt), nbt("version", ["QrCodeOptions.Version"], function(e14) {
  return e14 > 0 ? e14 : "auto";
}), nbt("errorCorrectionLevel", ["QrCodeOptions.ErrorLevel"]), nbt("mask", ["QrCodeOptions.Mask"], hbt)];
var kbt = [nbt("type", ["Symbology"], function() {
  return "Codabar";
}), nbt("text", ["Value"], function(e14) {
  return rbt(e14);
}), nbt("showLabel", ["CaptionLocation"], sbt), nbt("labelPosition", ["CaptionLocation"], ibt), nbt("checkDigit", ["CheckSum"]), nbt("nwRatio", ["NWRation"], function(e14) {
  return 3 === e14 ? 3 : 2;
})];
var Pbt = [nbt("type", ["Symbology"], function() {
  return "Code39";
}), nbt("text", ["Value"], function(e14) {
  return rbt(e14).toUpperCase();
}), nbt("showLabel", ["CaptionLocation"], sbt), nbt("labelPosition", ["CaptionLocation"], ibt), nbt("checkDigit", ["CheckSum"]), nbt("nwRatio", ["NWRation"], function(e14) {
  return 3 === e14 ? 3 : 2;
}), nbt("fullASCII", [], function() {
  return false;
}), nbt("unitSize", ["NarrowBarWidth"], function(e14) {
  return Gbt(e14) ? e14 : null;
}), nbt("desiredSize.width", ["NarrowBarWidth"], function(e14) {
  return Gbt(e14) ? void 0 : null;
})];
var Nbt = Xvt(Xvt([], Kvt(Pbt), false), [nbt("text", ["Value"], function(e14) {
  return rbt(e14);
}), nbt("fullASCII", [], function() {
  return true;
})], false);
var Dbt = [nbt("type", ["Symbology"], function() {
  return "Code93";
}), nbt("text", ["Value"], function(e14) {
  return rbt(e14);
}), nbt("showLabel", ["CaptionLocation"], sbt), nbt("labelPosition", ["CaptionLocation"], ibt), nbt("checkDigit", ["CheckSum"]), nbt("fullASCII", [], function() {
  return false;
})];
var Lbt = Xvt(Xvt([], Kvt(Dbt), false), [nbt("fullASCII", [], function() {
  return true;
})], false);
var Hbt = [nbt("type", ["Symbology"], function() {
  return "Code128";
}), nbt("text", ["Value"], function(e14) {
  return rbt(e14);
}), nbt("showLabel", ["CaptionLocation"], sbt), nbt("labelPosition", ["CaptionLocation"], ibt), nbt("codeSet", [], function() {
  return "auto";
})];
var Ibt = Xvt(Xvt([], Kvt(Hbt), false), [nbt("codeSet", [], function() {
  return "A";
})], false);
var _bt = Xvt(Xvt([], Kvt(Hbt), false), [nbt("codeSet", [], function() {
  return "B";
})], false);
var Vbt = Xvt(Xvt([], Kvt(Hbt), false), [nbt("codeSet", [], function() {
  return "C";
})], false);
var Rbt = [nbt("type", ["Symbology"], function() {
  return "GS1_128";
}), nbt("text", ["Value"], function(e14) {
  return rbt(e14);
}), nbt("showLabel", ["CaptionLocation"], sbt), nbt("labelPosition", ["CaptionLocation"], ibt)];
var Abt = [nbt("type", ["Symbology"], function() {
  return "Code49";
}), nbt("text", ["Value"], function(e14) {
  return rbt(e14);
}), nbt("showLabel", ["CaptionLocation"], sbt), nbt("labelPosition", ["CaptionLocation"], ibt), nbt("grouping", ["Code49Options.Grouping"]), nbt("groupNo", ["Code49Options.GroupNumber"])];
var Obt = [nbt("type", ["Symbology"], function() {
  return "PDF417";
}), nbt("text", ["Value"], function(e14) {
  return rbt(e14);
}), nbt("errorCorrectionLevel", ["Pdf417Options.ErrorCorrectionLevel"], function(e14) {
  return ybt[e14];
}), nbt("columns", ["Pdf417Options.Columns"], function(e14) {
  return e14 >= 0 && e14 <= 30 ? e14 : "auto";
}), nbt("rows", ["Pdf417Options.Rows"], function(e14) {
  return e14 >= 3 && e14 <= 90 ? e14 : "auto";
}), nbt("compact", ["Pdf417Options.Pdf417Type"], function(e14) {
  return "Simple" === e14;
})];
var Bbt = [nbt("type", ["Symbology"], function() {
  return "DataMatrix";
}), nbt("text", ["Value"], function(e14) {
  return rbt(e14);
}), nbt("eccMode", ["DataMatrixOptions.EccMode"]), nbt("ecc200SymbolSize", ["DataMatrixOptions.Ecc200SymbolSize"], bbt), nbt("ecc200EncodingMode", ["DataMatrixOptions.Ecc200EncodingMode"], function(e14) {
  return "Auto" === e14 ? "auto" : e14;
}), nbt("ecc000140SymbolSize", ["DataMatrixOptions.Ecc000_140SymbolSize"], function(e14) {
  return Sbt[e14];
}), nbt("structuredAppend", ["DataMatrixOptions.StructuredAppend"]), nbt("structureNumber", ["DataMatrixOptions.StructureNumber"]), nbt("fileIdentifier", ["DataMatrixOptions.FileIdentifier"])];
var zbt = [nbt("type", ["Symbology"], function() {
  return "ITF-14";
}), nbt("text", ["Value"], function(e14) {
  return rbt(e14, 13, 14);
}), nbt("height", ["SupplementOptions.BarHeight"], function(e14) {
  return tbt(e14) && ebt.default.parse(e14) ? e14 : "auto";
}), nbt("showLabel", ["CaptionLocation"], sbt), nbt("labelPosition", ["CaptionLocation"], ibt), nbt("hideExtraChecksum", [], function() {
  return false;
}), nbt("nwRatio", ["NWRation"], function(e14) {
  return 3 === e14 ? 3 : 2;
})];
var $bt = [nbt("type", ["Symbology"], function() {
  return "UPC-A";
}), nbt("text", ["Value"], function(e14) {
  return rbt(e14, 0, 12);
}), nbt("height", ["SupplementOptions.BarHeight"], function(e14) {
  return tbt(e14) && ebt.default.parse(e14) ? e14 : "auto";
}), nbt("showLabel", ["CaptionLocation"], sbt), nbt("labelPosition", ["CaptionLocation"], ibt), nbt("nwRatio", ["NWRation"], function(e14) {
  return 3 === e14 ? 3 : 2;
}), nbt("addOn", ["SupplementOptions.Value"], obt), nbt("addOnHeight", ["SupplementOptions.BarHeight"], function(e14) {
  return tbt(e14) && ebt.default.parse(e14) ? e14 : "auto";
}), nbt("addOnLabelPosition", ["SupplementOptions.CaptionLocation"], ibt), nbt("quietZone.addOn", ["SupplementOptions.Spacing"]), nbt("hideExtraChecksum", [], function() {
  return false;
})];
var Wbt = [nbt("type", ["Symbology"], function() {
  return "UPC-E0";
}), nbt("text", ["Value"], function(e14) {
  return rbt(e14, 0, 6);
}), nbt("height", ["SupplementOptions.BarHeight"], function(e14) {
  return tbt(e14) && ebt.default.parse(e14) ? e14 : "auto";
}), nbt("showLabel", ["CaptionLocation"], sbt), nbt("labelPosition", ["CaptionLocation"], ibt), nbt("nwRatio", ["NWRation"], function(e14) {
  return 3 === e14 ? 3 : 2;
}), nbt("addOn", ["SupplementOptions.Value"], obt), nbt("addOnHeight", ["SupplementOptions.BarHeight"], function(e14) {
  return tbt(e14) && ebt.default.parse(e14) ? e14 : "auto";
}), nbt("addOnLabelPosition", ["SupplementOptions.CaptionLocation"], ibt), nbt("quietZone.addOn", ["SupplementOptions.Spacing"]), nbt("hideExtraChecksum", [], function() {
  return false;
})];
var jbt = [nbt("type", ["Symbology"], function() {
  return "UPC-E1";
}), nbt("text", ["Value"], function(e14) {
  return rbt(e14, 0, 6);
}), nbt("height", ["SupplementOptions.BarHeight"], function(e14) {
  return tbt(e14) && ebt.default.parse(e14) ? e14 : "auto";
}), nbt("showLabel", ["CaptionLocation"], sbt), nbt("labelPosition", ["CaptionLocation"], ibt), nbt("hideExtraChecksum", [], function() {
  return false;
}), nbt("nwRatio", ["NWRation"], function(e14) {
  return 3 === e14 ? 3 : 2;
}), nbt("addOn", ["SupplementOptions.Value"], obt), nbt("addOnHeight", ["SupplementOptions.BarHeight"], function(e14) {
  return tbt(e14) && ebt.default.parse(e14) ? e14 : "auto";
}), nbt("addOnLabelPosition", ["SupplementOptions.CaptionLocation"], ibt), nbt("quietZone.addOn", ["SupplementOptions.Spacing"])];
var Zbt = [nbt("type", ["Symbology"], function() {
  return "Interleaved2of5";
}), nbt("text", ["Value"], function(e14) {
  return rbt(e14, 0, 16);
}), nbt("height", ["SupplementOptions.BarHeight"], function(e14) {
  return tbt(e14) && ebt.default.parse(e14) ? e14 : "auto";
}), nbt("showLabel", ["CaptionLocation"], sbt), nbt("labelPosition", ["CaptionLocation"], ibt), nbt("nwRatio", ["NWRation"], function(e14) {
  return 3 === e14 ? 3 : 2;
})];
function Gbt(e14) {
  return !!e14 && (e14.length > 0 && ebt.default.parse(e14) > 0);
}
function Ubt(e14) {
  var t10 = rbt(e14);
  if (!/\(|\)/.test(t10)) {
    if (t10.length >= 15) {
      var n10 = Xvt([], Kvt(t10), false);
      return n10.splice(0, 0, "("), n10.splice(3, 0, ")"), n10.join("");
    }
    return "(01)" + rbt(e14, 13, 14);
  }
  return t10;
}
function qbt(e14, t10) {
  return tbt(e14) && ebt.default.parse(e14) > 0 ? ebt.default.toCss(ebt.default.parse(e14) / 4) : tbt(t10) && ebt.default.parse(t10) > 0 ? ebt.default.toCss(ebt.default.parse(t10) / 4) : "auto";
}
var Ybt = [nbt("linkage", ["Gs1CompositeOptions.Value", "Gs1CompositeOptions.CompositeType"], lbt), nbt("linkageVersion", ["Gs1CompositeOptions.CompositeType"], function(e14) {
  return "None" !== e14 ? e14 : "CCA";
}), nbt("hideLinkageText", [], function() {
  return true;
}), nbt("linkageHeight", ["BarHeight", "Height"], qbt), nbt("desiredSize.height", ["BarHeight", "Height", "Gs1CompositeOptions.Value", "Gs1CompositeOptions.CompositeType"], function(e14, t10, n10, r10) {
  if (!lbt(n10, r10)) return t10;
  var o10 = qbt(e14, t10);
  return "auto" !== o10 ? ebt.default.toCss(ebt.default.parse(t10) - ebt.default.parse(o10)) : t10;
})];
var Kbt = [nbt("type", ["Symbology"], function() {
  return "GS1 DataBar Omnidirectional";
}), nbt("text", ["Value"], function(e14) {
  return Ubt(e14);
}), nbt("height", ["SupplementOptions.BarHeight"], function(e14) {
  return tbt(e14) && ebt.default.parse(e14) ? e14 : "auto";
}), nbt("showLabel", ["CaptionLocation"], sbt), nbt("labelPosition", ["CaptionLocation"], ibt), nbt("hideExtraChecksum", [], function() {
  return false;
}), nbt("hideAIText", ["CaptionGrouping"], function(e14) {
  return !e14;
})];
var Xbt = Xvt([nbt("type", ["Symbology"], function() {
  return "GS1 DataBar Limited";
}), nbt("text", ["Value"], function(e14) {
  return Ubt(e14);
}), nbt("height", ["SupplementOptions.BarHeight"], function(e14) {
  return tbt(e14) && ebt.default.parse(e14) ? e14 : "auto";
}), nbt("showLabel", ["CaptionLocation"], sbt), nbt("labelPosition", ["CaptionLocation"], ibt), nbt("hideExtraChecksum", [], function() {
  return false;
}), nbt("hideAIText", ["CaptionGrouping"], function(e14) {
  return !e14;
})], Kvt(Ybt), false);
var Jbt = [nbt("type", ["Symbology"], function() {
  return "GS1 DataBar Truncated";
}), nbt("text", ["Value"], function(e14) {
  return Ubt(e14);
}), nbt("height", ["SupplementOptions.BarHeight"], function(e14) {
  return tbt(e14) && ebt.default.parse(e14) ? e14 : "auto";
}), nbt("showLabel", ["CaptionLocation"], sbt), nbt("labelPosition", ["CaptionLocation"], ibt), nbt("hideExtraChecksum", [], function() {
  return false;
}), nbt("hideAIText", ["CaptionGrouping"], function(e14) {
  return !e14;
})];
var Qbt = Xvt([nbt("type", ["Symbology"], function() {
  return "GS1 DataBar Stacked";
}), nbt("text", ["Value"], function(e14) {
  return Ubt(e14);
}), nbt("height", ["SupplementOptions.BarHeight"], function(e14) {
  return tbt(e14) && ebt.default.parse(e14) ? e14 : "auto";
}), nbt("showLabel", ["CaptionLocation"], sbt), nbt("labelPosition", ["CaptionLocation"], ibt), nbt("hideExtraChecksum", [], function() {
  return false;
}), nbt("hideAIText", ["CaptionGrouping"], function(e14) {
  return !e14;
})], Kvt(Ybt), false);
var eSt = [nbt("type", ["Symbology"], function() {
  return "GS1 DataBar StackedOmnidirectional";
}), nbt("text", ["Value"], function(e14) {
  return Ubt(e14);
}), nbt("height", ["SupplementOptions.BarHeight"], function(e14) {
  return tbt(e14) && ebt.default.parse(e14) ? e14 : "auto";
}), nbt("showLabel", ["CaptionLocation"], sbt), nbt("labelPosition", ["CaptionLocation"], ibt), nbt("hideExtraChecksum", [], function() {
  return false;
}), nbt("hideAIText", ["CaptionGrouping"], function(e14) {
  return !e14;
})];
var tSt = [nbt("type", ["Symbology"], function() {
  return "Japanese Postal";
}), nbt("text", ["Value"], function(e14) {
  return rbt(e14);
}), nbt("height", ["SupplementOptions.BarHeight"], function(e14) {
  return tbt(e14) && ebt.default.parse(e14) ? e14 : "auto";
}), nbt("showLabel", ["CaptionLocation"], sbt), nbt("labelPosition", ["CaptionLocation"], ibt)];
var nSt = { Aztec: xbt, EAN_13: wbt, EAN_8: Tbt, QRCode: Ebt, GS1DataMatrix: Fbt, GS1QRCode: Mbt, Codabar: kbt, Code39: Pbt, Code39x: Nbt, Code_93: Dbt, Code93x: Lbt, Code_128auto: Hbt, Code_128_A: Ibt, Code_128_B: _bt, Code_128_C: Vbt, UCCEAN128: Rbt, Code49: Abt, Pdf417: Obt, DataMatrix: Bbt, ITF14: zbt, UPC_A: $bt, UPC_E0: Wbt, UPC_E1: jbt, Code25intlv: Zbt, RSS14: Kbt, RSSLimited: Xbt, RSS14Truncated: Jbt, RSS14Stacked: Qbt, RSS14StackedOmnidirectional: eSt, JapanesePostal: tSt };
var rSt = function(e14) {
  return nSt[aSt[e14] || e14];
};
var oSt = Gvt.isSymbologySupported = function(e14) {
  return !!rSt(e14);
};
Jvt = Gvt.translateBarcodeModel = function(e14) {
  var t10 = rSt(e14.Symbology);
  if (!t10) return null;
  var n10 = {};
  var r10 = function(t11) {
    var r11 = t11.from.map(function(t12) {
      return Qvt.get(e14, t12);
    });
    var o10 = t11.converter.apply(t11, Xvt([], Kvt(r11), false));
    null !== o10 && Qvt.set(n10, t11.to, o10);
  };
  return Cbt.forEach(r10), t10.forEach(r10), n10;
};
var aSt = { Code2of5: "Code_2_of_5", Code2of5Interleaved: "Code25intlv", Matrix2of5: "Matrix_2_of_5", Code39Extended: "Code39x", Code128A: "Code_128_A", Code128B: "Code_128_B", Code128C: "Code_128_C", Code128Auto: "Code_128auto", Ansi39: "Code39", Code93: "Code_93", Code93Extended: "Code93x", Ansi39x: "Code39x", MsiPlessey: "MSI", Postnet: "PostNet", Ean8: "EAN_8", Ean13: "EAN_13", UpcA: "UPC_A", UpcE: "UPC_E0", RoyalMail4Scc: "RM4SCC", UccEan128: "UCCEAN128", PDF417: "Pdf417", Ean128Fnc1: "EAN128FNC1", Code11: "Code_11", SSCC18: "SSCC_18", IATA2of5: "IATA_2_of_5" };
const iSt = ["Rotate90Degrees", "Rotate270Degrees"];
function sSt(e14, t10, n10, r10) {
  if (!r10 || L$.zero.equal(r10)) return L$.zero;
  const o10 = e14.subtract(t10).subtract(n10);
  return o10.greaterThan(r10) ? o10.subtract(r10).divideByNum(2) : L$.zero;
}
function lSt(e14, t10) {
  return jme(e14) || !e14 ? t10 : e14;
}
const cSt = FZ.resultOf(wq.decode({ Type: "barcode", Name: "barcode1" }));
const uSt = (e14) => {
  switch ({ Code2of5: "Code_2_of_5", Code2of5Interleaved: "Code25intlv", Matrix2of5: "Matrix_2_of_5", Code39Extended: "Code39x", Code128A: "Code_128_A", Code128B: "Code_128_B", Code128C: "Code_128_C", Code128Auto: "Code_128auto", Ansi39: "Code39", Code93: "Code_93", Code93Extended: "Code93x", Ansi39x: "Code39x", MsiPlessey: "MSI", Postnet: "PostNet", Ean8: "EAN_8", Ean13: "EAN_13", UpcA: "UPC_A", UpcE: "UPC_E0", RoyalMail4Scc: "RM4SCC", UccEan128: "UCCEAN128", PDF417: "Pdf417", Ean128Fnc1: "EAN128FNC1", Code11: "Code_11", SSCC18: "SSCC_18", IATA2of5: "IATA_2_of_5" }[e14] || e14) {
    case "RSS14":
    case "RSSLimited":
    case "RSS14Truncated":
    case "RSS14Stacked":
    case "RSS14StackedOmnidirectional":
      return "(01)20012345678909";
    case "ITF14":
      return "1234567890123";
    case "UPC_A":
      return "12345678901";
    case "EAN_13":
      return "123456789012";
    case "Codabar":
      return "A1234567B";
    case "Code25intlv":
    case "Code_128auto":
    case "Code_128_A":
    case "Code_128_B":
    case "Code_128_C":
      return "12345678";
    case "EAN_8":
    case "UCCEAN128":
    case "DataMatrix":
      return "1234567";
    case "UPC_E0":
    case "UPC_E1":
    case "JapanesePostal":
      return "123456";
    case "Aztec":
    case "QRCode":
    case "GS1QRCode":
    case "GS1DataMatrix":
    case "Pdf417":
    case "Code39":
    case "Code39x":
    case "Code_93":
    case "Code93x":
    case "Code49":
      return "SAMPLE";
    default:
      return "";
  }
};
const dSt = ["QRCode", "DataMatrix"];
function pSt(e14, t10) {
  const { $place: n10, Value: r10, Rotation: o10, Symbology: a10, ToolTip: i10, BarHeight: s10, QuietZone: l10, Style: c10, InvalidBarcodeText: u10 } = e14;
  const d10 = { style: {}, position: {}, stubLabel: "" };
  if (!oSt(a10)) return { viewModel: null, assets: __spreadProps(__spreadValues({}, d10), { stubLabel: "Unsupported" }) };
  const p10 = dSt.includes(a10);
  const m10 = L$.parse(n10.Width);
  const h10 = L$.parse(n10.Height);
  const f10 = ((e15, t11) => {
    const n11 = {};
    return "Rotate90Degrees" === e15 ? (n11.transform = "rotate(90deg)", t11 || (n11.transformOrigin = "0 0", n11.left = "100%")) : "Rotate180Degrees" === e15 ? n11.transform = "rotate(180deg)" : "Rotate270Degrees" === e15 && (n11.transform = "rotate(270deg)", t11 || (n11.transformOrigin = "0 0", n11.top = "100%")), n11;
  })(o10, p10);
  const g10 = function(e15, t11, n11, r11, o11, a11) {
    const { PaddingLeft: i11, PaddingRight: s11, PaddingTop: l11, PaddingBottom: c11 } = n11;
    const u11 = L$.isValidString(e15) ? L$.parse(e15) : null;
    const [d11, p11, m11, h11, f11, g11, y11, v11] = [t11.Left, t11.Top, t11.Right, t11.Bottom, i11, l11, s11, c11].map((e16) => L$.parse(e16));
    let b11;
    let S11;
    let C11;
    let x10;
    switch (a11) {
      case "Rotate90Degrees":
        b11 = d11, S11 = m11, C11 = h11, x10 = p11;
        break;
      case "Rotate180Degrees":
        b11 = h11, S11 = p11, C11 = m11, x10 = d11;
        break;
      case "Rotate270Degrees":
        b11 = m11, S11 = d11, C11 = p11, x10 = h11;
        break;
      default:
        b11 = p11, S11 = h11, C11 = d11, x10 = m11;
    }
    let w10;
    return b11 = b11.add(g11), C11 = C11.add(f11), S11 = S11.add(v11), x10 = x10.add(y11), iSt.includes(a11) ? (w10 = sSt(r11, C11, x10, u11), C11 = C11.add(w10), x10 = x10.add(w10)) : (w10 = sSt(o11, b11, S11, u11), b11 = b11.add(w10), S11 = S11.add(w10)), { top: b11, left: C11, bottom: S11, right: x10 };
  }(s10, l10, c10, m10, h10, o10);
  const { availableWidth: y10, availableHeight: v10 } = function(e15, t11, n11, r11) {
    const o11 = e15.subtract(n11.left).subtract(n11.right);
    const a11 = t11.subtract(n11.top).subtract(n11.bottom);
    return iSt.includes(r11) ? { availableWidth: a11, availableHeight: o11 } : { availableWidth: o11, availableHeight: a11 };
  }(m10, h10, g10, o10);
  const b10 = function(e15) {
    const { top: t11, left: n11, right: r11, bottom: o11 } = e15;
    return { paddingTop: t11.css, paddingLeft: n11.css, paddingRight: r11.css, paddingBottom: o11.css };
  }(g10);
  const S10 = Qst({ fontFamily: c10.FontFamily, fontSize: c10.FontSize, fontStyle: c10.FontStyle, fontWeight: c10.FontWeight }, t10, (e15) => e15);
  const C10 = __spreadProps(__spreadValues({}, e14), { QuietZone: { Bottom: "0in", Left: "0in", Right: "0in", Top: "0in" }, Width: y10.css, Height: v10.css, InvalidBarcodeText: lSt(u10, cSt.InvalidBarcodeText), Tooltip: lSt(i10, cSt.ToolTip), Value: lSt(r10, uSt(a10)), Style: __spreadProps(__spreadValues({}, c10), { BackgroundColor: lSt(Xst(c10.BackgroundColor, t10), cSt.Style.BackgroundColor), Color: lSt(Xst(c10.Color, t10), cSt.Style.Color), FontFamily: lSt(S10.fontFamily, cSt.Style.FontFamily), FontSize: lSt(S10.fontSize, cSt.Style.FontSize), FontStyle: lSt(S10.fontStyle, cSt.Style.FontStyle), FontWeight: lSt(S10.fontWeight, cSt.Style.FontWeight), Format: lSt(c10.Format, cSt.Style.Format), TextAlign: lSt(c10.TextAlign, cSt.Style.TextAlign), TextDecoration: lSt(c10.TextDecoration, cSt.Style.TextDecoration) }) });
  return { viewModel: __spreadProps(__spreadValues({}, Jvt(C10)), { unitSize: "1in" }), assets: __spreadProps(__spreadValues({}, d10), { style: f10, position: b10 }) };
}
const mSt = ({ style: e14, viewModel: t10, onError: n10, onSuccess: r10 }) => {
  const o10 = ep.useRef(null);
  const a10 = ep.useRef(null);
  return ep.useEffect(() => {
    ((e15) => {
      try {
        o10.current ? o10.current.setOption(e15) : o10.current = new l(a10.current, e15), r10();
      } catch (e16) {
        n10(e16.message);
      }
    })(t10);
  }, [t10]), tp.createElement("div", { className: "ar-barcodejs" }, tp.createElement("div", { className: "ar-barcodejs-component", style: e14, ref: a10 }));
};
const hSt = ({ item: e14, theme: t10 }) => tp.createElement("div", { className: "ar-barcode-model-dumper", title: "Click to dump barcode JSON model to console...", onClick: () => {
  const n10 = pSt(e14, t10);
  console.log(JSON.stringify(n10));
} }, tp.createElement(Fm, { icon: nf(Rh) }));
const fSt = (e14) => `barcode.${e14}`;
const gSt = [EY.Name, Zq(tY, fSt("value"), "string_expr", "Value"), Zq(fY, fSt("symbology"), "barcode_symbology", ""), vY.BackgroundAndBorders, vY.BackgroundColor, vY.Borders, vY.FontSimple, vY.Color, vY.Font, vY.TextDecoration, vY.TextAlign, vY.Format, EY.Location, EY.Size, Zq(Kq, fSt("captionLocation"), "enum", "CaptionLocation", void 0, { enumKey: "barcode_caption_location" }), Zq(Kq, fSt("checksum"), "boolean", "CheckSum"), Zq(Kq, fSt("rotation"), "enum", "Rotation", void 0, { enumKey: "barcode_rotation" }), Zq(Kq, fSt("barHeight"), "length", "BarHeight", "advanced"), Zq(Kq, fSt("narrowBarWidth"), "length", "NarrowBarWidth", "advanced", { allowEmptyString: true }), Zq(Kq, fSt("nwRatio"), "number", "NWRation", "advanced", { numberType: "Float", tooltip: { text: `propertyDescriptors:labels.${fSt("nwRatio_help.text")}`, icon: nf(Ih) }, intervals: [{ min: 0, max: 0 }, { min: 2, max: 3 }] }), Zq(Kq, fSt("quietZone"), "barcode_quiet_zone", "QuietZone", "advanced"), vY.Padding, EY.LayerName, EY.ZIndex, EY.Visibility, Zq(rY, fSt("invalidBarcodeText"), "string_expr", "InvalidBarcodeText", "advanced"), EY.DataElementName, EY.DataElementOutput, TY, EY.ToolTip, EY.Label, EY.Bookmark, EY.AccessibleDescription];
const ySt = { type: "barcode", init: (e14, t10, n10, r10 = cSt) => __spreadProps(__spreadValues(__spreadValues({}, r10), n10), { Name: e14 || "" }), labelKey: "reportItems:barcode", nameTemplateKey: "nameTemplates:barcode", icon: nf(_oe), icon24: nf(Voe), defaultModel: cSt, glyph: ({ item: e14, path: t10, parentBackgroundColor: n10, theme: r10 }) => {
  Uae();
  const [o10, a10] = ep.useState(null);
  const [i10, s10] = ep.useState(e14);
  const { t: l10 } = vp("captions");
  ep.useEffect(() => {
    i10 !== e14 && (s10(e14), a10(null));
  }, [e14]);
  const { Type: c10, InvalidBarcodeText: u10 } = i10;
  const d10 = ((e15, t11, n11) => {
    var _a2, _b2;
    if (!e15.assets.stubLabel) return e15;
    const { Name: r11, Symbology: o11 } = t11;
    const { friendlyNames: a11 } = BO("barcode_symbology", n11);
    const i11 = n11("captions:barcodeUnsupportedSymbology", "[{{symbology}}] '{{itemName}}' preview is limited in design-time.", { itemName: r11, symbology: (_b2 = (_a2 = a11.find((e16) => e16.value === o11)) == null ? void 0 : _a2.name) != null ? _b2 : o11 });
    return AV(e15, { assets: { stubLabel: { $set: i11 } } });
  })(pSt(e14, r10), e14, l10);
  const p10 = (({ viewModel: e15, assets: { stubLabel: t11, style: n11 } }, r11, o11) => {
    if (!e15) return tp.createElement("div", { className: "ar-barcode-preview-stub-label" }, t11);
    const a11 = { viewModel: e15, style: n11, onSuccess: r11, onError: o11 };
    return tp.createElement(mSt, __spreadValues({}, a11));
  })(d10, () => o10 && a10(""), a10);
  const { viewModel: m10, assets: h10 } = d10;
  const f10 = kp("ar-item", "ar-barcode-glyph");
  const g10 = h10.position;
  const y10 = m10 ? void 0 : h10.stubLabel;
  const v10 = aj(e14) && false;
  return tp.createElement("div", { className: f10, style: g10, title: y10, "data-type": c10, "data-path": t10 }, p10, o10 && ((e15, t11, n11, r11) => {
    return tp.createElement("div", { className: "ar-barcodejs-error", style: { backgroundColor: e15 } }, n11 || (o11 = t11, `${r11("error:errorLabel", "Error")}: ${o11}`));
    var o11;
  })(n10, o10, u10, l10), v10 && tp.createElement(hSt, { item: e14, theme: r10 }));
}, getReducer: q5, getProperties: () => gSt, getContextActions: i0e, features: { getExpressionProperties: function() {
  return Zvt;
}, textDecorations: ["None", "Underline", "Overline", "LineThrough"] } };
const vSt = ["LabelFormat", "LabelFontFamily", "LabelFontSize", "LabelFontStyle", "LabelFontColor", "TargetLineColor", "TargetLineWidth", "TicksLineColor", "TicksLineWidth", "ValueColor", "BestValue", "Interval", "Range1Boundary", "Range2Boundary", "TargetValue", "Value", "WorstValue"];
const bSt = Are(["value", "field"], { hover(e14, t10, n10) {
  t10.isOver({ shallow: true }) && t10.canDrop() && n10.context.setDecorations("", []);
}, drop: (e14, t10, n10) => {
  const { dispatch: r10, path: o10 } = e14;
  const { getAreaByPath: a10 } = n10.context;
  const i10 = t10.getItemType();
  let s10 = "";
  let l10 = [];
  if ("value" === i10) {
    const { expr: e15 } = t10.getItem();
    s10 = e15;
  } else {
    if ("field" !== i10) return;
    {
      const { field: { value: e15, aggregate: n11, variationFormat: r11 }, dropActions: i11 } = t10.getItem();
      const c10 = a10(o10);
      let u10 = wee(c10) ? n11 : null;
      r11 && (u10 = "Count"), s10 = r11 ? `=${U1(e15, r11, null, u10)}` : `=${G1(e15, null, u10)}`, l10 = i11;
    }
  }
  if (e14.panel) {
    const t11 = [];
    "value" === e14.panel && t11.push(function(e15) {
      return Kz.action(L7, { expression: e15 });
    }(s10)), "targetValue" === e14.panel && t11.push(function(e15) {
      return Kz.action(H7, { expression: e15 });
    }(s10)), l10 && t11.push(...l10), t11.length && r10(rz(t11));
  }
} }, (e14, t10) => ({ connectDropTarget: e14.dropTarget(), isOver: t10.isOver(), canDrop: t10.canDrop() }));
class SSt extends tp.Component {
  render() {
    const { connectDropTarget: e14, value: t10, panel: n10, canDrop: r10, isOver: o10, t: a10 } = this.props;
    const i10 = kp("ar-bullet-adorner-element", "ar-adorner-primary", `ar-adorner-${n10}`, { can: r10, over: o10 });
    const s10 = n10 && ("value" === n10 && a10("adorners:bullet.value", "Value") || a10("adorners:bullet.targetValue", "Target value")) || "";
    return e14(tp.createElement("div", { className: i10 }, !!t10 && tp.createElement("div", { className: "ar-adorner-bullet-val", title: t10 }, t10), tp.createElement("span", null, s10)));
  }
}
SSt.contextType = bqe;
const CSt = bSt(SSt);
const xSt = TA()(({ value: e14, targetValue: t10, showPanels: n10, dispatch: r10, path: o10, children: a10 }) => {
  const i10 = X1(YAe(e14.toString()));
  const s10 = X1(YAe((t10 == null ? void 0 : t10.toString()) || ""));
  const { t: l10 } = vp();
  return tp.createElement("div", { className: "ar-bullet-adorner" }, n10 && tp.createElement(CSt, { value: i10, panel: "value", dispatch: r10, path: o10, t: l10 }), a10, n10 && tp.createElement(CSt, { value: s10, panel: "targetValue", dispatch: r10, path: o10, t: l10 }));
});
const wSt = 0.2;
const TSt = 5;
const ESt = (e14) => !(!e14 || jme(e14)) ? 1 : 0;
function FSt({ valPercent: e14, valueColor: t10, hasWorstVal: n10, graphHeight: r10, scaleHeight: o10, isHorizontal: a10 }) {
  const i10 = { [a10 ? "height" : "width"]: "40%", [a10 ? "width" : "height"]: e14, [a10 ? "top" : "left"]: "30%", backgroundColor: t10, position: "absolute" };
  a10 || (i10.bottom = "0px");
  const s10 = { height: `calc((${r10.css} - ${o10.css}) / 4)`, width: `calc((${r10.css} - ${o10.css}) / 4)`, [a10 ? "left" : "bottom"]: `calc(${e14} - (${r10.css} - ${o10.css}) / 8)`, [a10 ? "top" : "left"]: `calc(50% - ((${r10.css} - ${o10.css}) / 8))`, backgroundColor: t10, position: "absolute", borderRadius: "50%" };
  const l10 = n10 && i10 || s10;
  return tp.createElement("div", { style: l10 });
}
function MSt({ targetValuePercent: e14, targetLineColor: t10, targetLineWidth: n10, targetShape: r10, graphHeight: o10, scaleHeight: a10, isHorizontal: i10 }) {
  const s10 = e14 && "0%" !== e14 && n10 || "0pt";
  const l10 = { height: `calc((${o10.css} - ${a10.css}) / 2)`, width: `calc((${o10.css} - ${a10.css}) / 2)`, [i10 ? "left" : "bottom"]: `calc(${e14} - (${o10.css} - ${a10.css}) / 4)`, [i10 ? "top" : "left"]: `calc(50% - ((${o10.css} - ${a10.css}) / 4))`, backgroundColor: t10, position: "absolute" };
  const c10 = { [i10 ? "height" : "width"]: "60%", [i10 ? "width" : "height"]: s10, [i10 ? "left" : "bottom"]: `calc(${e14} - ${s10} / 2)`, [i10 ? "top" : "left"]: "20%", backgroundColor: t10, position: "absolute" };
  return tp.createElement("div", { style: ((e15) => {
    switch (e15) {
      case "Square":
        return l10;
      case "Dot":
        return l10.borderRadius = "50%", l10;
      default:
        return c10;
    }
  })(r10) });
}
class kSt extends tp.Component {
  render() {
    const { graphProperties: { targetValuePercent: e14, targetLineColor: t10, targetLineWidth: n10, isHorizontal: r10, range2Percent: o10, range1Percent: a10, targetShape: i10, scaleHeight: s10, graphHeight: l10, valPercent: c10, valueColor: u10, min: d10 } } = this.props;
    const p10 = (e15) => {
      const t11 = {};
      return t11[r10 ? "height" : "width"] = "100%", t11[r10 ? "width" : "height"] = e15, t11[r10 ? "top" : "bottom"] = "0px", t11;
    };
    const m10 = !Number.isNaN(d10);
    const h10 = { targetLineColor: t10, targetLineWidth: n10, targetShape: i10, graphHeight: l10, scaleHeight: s10, isHorizontal: r10, targetValuePercent: e14 };
    const f10 = { valPercent: c10, valueColor: u10, hasWorstVal: m10, graphHeight: l10, scaleHeight: s10, isHorizontal: r10 };
    return tp.createElement("div", null, tp.createElement("div", { className: "ar-bullet-range2", style: p10(o10) }), tp.createElement("div", { className: "ar-bullet-range1", style: p10(a10) }), tp.createElement(MSt, __spreadValues({}, h10)), tp.createElement(FSt, __spreadValues({}, f10)));
  }
}
function PSt(e14) {
  return null != e14 && e14.toString().length || 0;
}
function NSt(e14, t10) {
  let n10 = 100 * e14 / t10;
  return n10 = n10 < 0 ? 0 : n10, `${e14 && n10 || 0}%`;
}
function DSt(e14, t10, n10) {
  if (!Number.isNaN(e14) && e14 > 0) return e14;
  const r10 = Math.abs(t10 - n10);
  return 0 !== r10 ? r10 / 5 : 1;
}
const LSt = "3pt";
const HSt = "Outside";
class ISt extends tp.Component {
  render() {
    const { scaleProperties: e14 } = this.props;
    let { maximum: t10, minimum: n10 } = e14;
    const { interval: r10 } = e14;
    e14.maximum || e14.minimum || (t10 = 50, n10 = 10);
    const o10 = (t10 - n10) / r10;
    const a10 = o10 < 0 ? -1 : 1;
    const i10 = o10 * a10 + 1;
    const s10 = "none" !== e14.tickMarks.toLowerCase();
    const l10 = { fontSize: e14.labelsFontSize };
    const c10 = { height: LSt, width: e14.ticksLineWidth, backgroundColor: e14.ticksLineColor, position: "absolute", top: e14.tickMarks !== HSt && `-${LSt}` || "" };
    let u10 = { height: e14.scaleHeight.css, width: e14.scaleHeight.css, position: "absolute", fontSize: e14.labelsFontSize, fontFamily: e14.labelFontFamily, color: e14.labelFontColor, textAlign: "center" };
    return e14.isHorizontal ? (l10.display = "flex", l10.position = "relative", l10.width = "100%", c10.left = "50%") : (c10.top = "50%", c10.transform = "rotate(90deg)", u10.width = "100%", u10.height = `calc(${e14.scaleHeight.css} - ${VSt})`, l10.width = e14.showLabels ? `calc(${(() => {
      const e15 = t10 < 0 && -1 * t10 || t10;
      const r11 = n10 < 0 && -1 * n10 || n10;
      return PSt(Math.max(e15, r11)) + 2;
    })()}em / 2)` : "auto", c10.right = e14.tickMarks !== HSt && `-${LSt}` || "0px"), u10 = function(e15, t11) {
      const n11 = __spreadValues({}, e15);
      switch (t11) {
        case "Bold":
          return n11.fontStyle = "normal", n11.fontWeight = "bold", n11.textDecoration = "blink", n11;
        case "Italic":
          return n11.fontStyle = "italic", n11.fontWeight = "normal", n11.textDecoration = "blink", n11;
        case "Underline":
          return n11.fontStyle = "normal", n11.fontWeight = "normal", n11.textDecoration = "underline", e15;
        case "Strikeout":
          return n11.fontStyle = "normal", n11.fontWeight = "normal", n11.textDecoration = "line-through", n11;
        default:
          return n11.fontStyle = "normal", n11.fontWeight = "normal", n11.textDecoration = "blink", n11;
      }
    }(u10, e14.labelFontStyle), tp.createElement("div", { style: l10 }, ((() => {
      const e15 = [];
      for (let t11 = 0; t11 < Math.round(i10); t11++) 0 === t11 ? e15.push(n10) : e15.push(e15[t11 - 1] + r10 * a10);
      return e15;
    })() || []).map((r11, o11) => {
      const i11 = {};
      const l11 = __spreadValues({}, u10);
      const d10 = NSt((r11 - n10) * a10, (t10 - n10) * a10);
      e14.isHorizontal ? (l11.left = `calc(${d10} - ${e14.scaleHeight.css} / 2)`, "100%" === d10 && (i11.position = "absolute", i11.left = `calc(50% - ${PSt(r11)}em / 2)`), "0%" === d10 && (i11.position = "absolute", i11.left = "50%")) : l11.bottom = `calc(${d10} - (${e14.scaleHeight.css} - ${VSt}) / 2)`;
      const p10 = o11;
      return tp.createElement("div", { key: p10, style: l11 }, s10 && tp.createElement("div", { style: c10 }), e14.showLabels && tp.createElement("div", { style: i11 }, ((e15) => parseFloat(e15.toFixed(2)))(r11)));
    }));
  }
}
const _St = FZ.resultOf(wq.decode({ Type: "bullet", Name: "bullet", Width: "2in", Height: "0.5in" }));
const VSt = "5pt";
const RSt = (e14, t10, n10) => {
  const r10 = Xst(e14, n10);
  return !r10 || jme(r10) ? t10 : r10;
};
const ASt = (e14) => {
  var _a2;
  return (_a2 = e14 == null ? void 0 : e14.toString()) != null ? _a2 : "";
};
function OSt({ item: e14, theme: t10 }) {
  const { LabelFontSize: n10, LabelFormat: r10, LabelFontFamily: o10, LabelFontStyle: a10, LabelFontColor: i10, ShowLabels: s10, Orientation: l10, BestValue: c10, TargetValue: u10, Value: d10, WorstValue: p10, Range1Boundary: m10, Range2Boundary: h10, Interval: f10, ValueColor: g10, $place: y10, TargetLineColor: v10, TargetLineWidth: b10, TargetShape: S10, TickMarks: C10, TicksLineColor: x10, TicksLineWidth: w10 } = e14;
  const T10 = y10 == null ? void 0 : y10.Height;
  const E10 = y10 == null ? void 0 : y10.Width;
  const F10 = !l10 || "Horizontal" === l10;
  const { fontFamily: M10, fontSize: k10, fontStyle: P10 } = ((e15, t11, n11, r11, o11, a11, i11) => {
    const { fontFamily: s11, fontSize: l11, fontStyle: c11 } = Qst({ fontFamily: e15, fontSize: n11, fontStyle: o11, fontWeight: "" }, i11);
    return { fontFamily: !s11 || jme(s11) ? t11 : s11, fontSize: !l11 || jme(l11) ? r11 : l11.toString(), fontStyle: !c11 || jme(c11) ? a11 : c11 };
  })(o10, _St.LabelFontFamily, n10, _St.LabelFontSize, a10, _St.LabelFontStyle, t10);
  const N10 = s10 && k10 || "";
  const D10 = N10 ? L$.parse(N10).add(L$.parse(VSt)) : L$.zero;
  const L10 = { height: `calc(100% - ${D10.css})` };
  const H10 = { height: D10.css };
  const I10 = function(e15, t11, n11, r11) {
    const o11 = { interval: 0, max: 0, min: 0, value: 0 };
    switch (ESt(e15) + 2 * ESt(t11) + 4 * ESt(n11)) {
      case 0:
        o11.min = 64, o11.value = 65, o11.max = 69;
        break;
      case 1:
        o11.min = parseFloat(e15), o11.value = o11.min + 1, o11.max = o11.min + 5;
        break;
      case 2:
        o11.value = parseFloat(t11), o11.min = o11.value - 1, o11.max = o11.value + 4;
        break;
      case 3:
        o11.min = parseFloat(e15), o11.value = parseFloat(t11), o11.max = o11.min + (o11.value - o11.min) / wSt;
        break;
      case 4:
        o11.max = parseFloat(n11), o11.value = o11.max - 4, o11.min = o11.max - 5;
        break;
      case 5:
        o11.min = parseFloat(e15), o11.max = parseFloat(n11), o11.value = o11.min + (o11.max - o11.min) * wSt;
        break;
      case 6:
        o11.value = parseFloat(t11), o11.max = parseFloat(n11), o11.min = o11.max - (o11.max - o11.value) / (1 - wSt);
        break;
      case 7:
        o11.min = parseFloat(e15), o11.value = parseFloat(t11), o11.max = parseFloat(n11);
    }
    return o11.interval = r11 && !jme(r11) && parseFloat(r11) || Math.round((o11.max - o11.min) / TSt), o11;
  }(ASt(p10), ASt(d10), ASt(c10), ASt(f10));
  const { interval: _10, min: V10, max: R10, value: A10 } = I10;
  const O10 = parseFloat(String(m10));
  const B10 = parseFloat(String(h10));
  const z10 = parseFloat(String(u10));
  let $10 = Number.isFinite(V10) ? V10 : A10 && 0.8 * A10 || 0;
  $10 = parseFloat($10.toString()) || 0;
  const W10 = () => {
    let e15;
    return Number.isNaN(R10) ? (e15 = Math.max(O10 || 0, B10 || 0, A10 || 0, z10 || 0), O10 || B10 || z10 || (e15 = 1.5 * A10, e15 = Math.abs(e15))) : e15 = R10, e15;
  };
  const j10 = W10() - $10;
  const Z10 = B10 - $10;
  const G10 = A10 - $10;
  const U10 = z10 - $10;
  const q10 = NSt(O10 - $10, j10);
  const Y10 = NSt(Z10, j10);
  const K10 = NSt(G10, j10);
  const X10 = NSt(U10, j10);
  const J10 = W10();
  const Q10 = V10 || $10;
  const ee2 = { valPercent: K10, range1Percent: q10, range2Percent: Y10, targetValuePercent: X10, maxOfValues: j10, min: V10, isHorizontal: F10, valueColor: RSt(g10, _St.ValueColor, t10), graphHeight: L$.parse(F10 && T10 || E10), scaleHeight: L$.parse(D10), targetLineColor: RSt(v10, _St.TargetLineColor, t10), targetLineWidth: jme(b10) ? _St.TargetLineWidth : b10, targetShape: jme(S10) ? _St.TargetShape : S10 };
  const te2 = { labelsFontSize: N10, showLabels: s10, interval: DSt(_10, J10, Q10), maximum: J10, minimum: Q10, scaleHeight: L$.parse(D10), isHorizontal: F10, labelFormat: r10, labelFontFamily: M10, labelFontStyle: P10, labelFontColor: RSt(i10, _St.LabelFontColor, t10), tickMarks: jme(C10) ? _St.TickMarks : C10, ticksLineColor: RSt(x10, _St.TicksLineColor, t10), ticksLineWidth: jme(w10) ? _St.TicksLineWidth : w10 };
  const ne2 = { height: `calc(100% - ${N10})`, marginTop: `calc(${N10} / 2)` };
  const re2 = [tp.createElement(kSt, { key: "ar-bullet-graph", graphProperties: ee2 }), tp.createElement(ISt, { key: "ar-bullet-scale", scaleProperties: te2 })];
  return tp.createElement("div", { className: "ar-bullet-container" }, F10 && [tp.createElement("div", { key: 0, className: "ar-bullet-graph", style: L10 }, re2[0]), tp.createElement("div", { key: 1, style: H10 }, re2[1])], !F10 && [tp.createElement("div", { key: 0, style: ne2, className: "ar-bullet-container-vertical" }, tp.createElement("div", { className: "ar-bullet-vertical-scale" }, re2[1]), tp.createElement("div", { className: "ar-bullet-vertical-graph" }, re2[0]))]);
}
class BSt extends tp.PureComponent {
  render() {
    const { item: e14, item: { Type: t10, Value: n10, TargetValue: r10 }, path: o10, theme: a10 } = this.props;
    const i10 = kp("ar-item", "ar-bullet-glyph");
    return tp.createElement(xSt, { value: n10, targetValue: r10, showPanels: sj(e14), path: o10 }, tp.createElement("div", { "data-path": o10, className: i10, "data-type": t10, style: { padding: "2pt" } }, tp.createElement(OSt, { item: e14, theme: a10 })));
  }
}
const zSt = "labelStyle", $St = "targetStyle", WSt = "tickStyle", jSt = "valueStyle";
const ZSt = (e14) => `bullet.${e14}`;
const GSt = [EY.Name, Zq(Kq, ZSt("labelFormat"), "format", "LabelFormat"), Zq(Kq, ZSt("orientation"), "enum", "Orientation", void 0, { enumKey: "orientation" }), Zq(Kq, ZSt("showLabels"), "boolean", "ShowLabels"), EY.Location, EY.Size, Zq(cY, "reportItem.style", "styles", "ReportStyle", void 0, { target: "Bullet" }), EY.LayerName, EY.ZIndex, Zq(rY, ZSt("bestValue"), "number_expr", "BestValue", void 0, Gq.floatEmpty), Zq(rY, ZSt("interval"), "number_expr", "Interval", void 0, Gq.floatPositiveEmpty), Zq(rY, ZSt("range1Boundary"), "number_expr", "Range1Boundary", void 0, Gq.floatEmpty), Zq(rY, ZSt("range2Boundary"), "number_expr", "Range2Boundary", void 0, Gq.floatEmpty), Zq(rY, ZSt("targetValue"), "number_expr", "TargetValue", void 0, Gq.floatEmpty), Zq(rY, ZSt("value"), "number_expr", "Value", void 0, Gq.floatEmpty), Zq(rY, ZSt("worstValue"), "number_expr", "WorstValue", void 0, Gq.floatEmpty), Zq(jSt, ZSt("valueColor"), "color_expr", "ValueColor"), Zq($St, ZSt("targetShape"), "enum", "TargetShape", "advanced", { enumKey: "target_shape" }), Zq($St, ZSt("targetLineColor"), "color_expr", "TargetLineColor", "advanced"), Zq($St, ZSt("targetLineWidth"), "length_expr", "TargetLineWidth", "advanced"), Zq(zSt, ZSt("labelFontColor"), "color_expr", "LabelFontColor", "advanced"), Zq(zSt, ZSt("labelFontFamily"), "font_family", "LabelFontFamily", "advanced"), Zq(zSt, ZSt("labelFontSize"), "font_size_expr", "LabelFontSize", "advanced", { enumKey: "font_size", unit: "pt" }), Zq(zSt, ZSt("labelFontStyle"), "enum_expr", "LabelFontStyle", "advanced", { enumKey: "label_font_style" }), Zq(WSt, ZSt("tickMarks"), "enum", "TickMarks", "advanced", { enumKey: "bullet_tick_marks" }), Zq(WSt, ZSt("ticksLineColor"), "color_expr", "TicksLineColor", "advanced"), Zq(WSt, ZSt("ticksLineWidth"), "length_expr", "TicksLineWidth", "advanced"), EY.DataElementName, EY.DataElementOutput, EY.Visibility, EY.ToolTip, EY.Label, EY.Bookmark, EY.AccessibleDescription];
const USt = (e14) => {
  const t10 = nz.of(e14).getTemplate("bullet");
  const { ValueColor: n10, TargetLineColor: r10, LabelFontColor: o10, LabelFontFamily: a10, LabelFontSize: i10, LabelFontStyle: s10, TicksLineColor: l10 } = t10;
  return { ValueColor: n10, TargetLineColor: r10, LabelFontColor: o10, LabelFontFamily: a10, LabelFontSize: i10, LabelFontStyle: s10, TicksLineColor: l10 };
};
const qSt = (e14, t10) => {
  if (e14 && e14.$targetType !== wj.Bullet) return null;
  const n10 = USt(t10);
  return e14 ? __spreadValues(__spreadValues({}, n10), e14) : n10;
};
const YSt = (e14, t10) => {
  const n10 = {};
  return Object.keys(t10).forEach((r10) => {
    Oj(e14, t10, r10) && (n10[r10] = { $set: t10[r10] });
  }), Object.keys(n10).length > 0 ? n10 : null;
};
function KSt(e14, t10, n10 = false, r10) {
  const o10 = USt(r10);
  const a10 = n10 ? Aj(t10, o10) : t10;
  const i10 = YSt(e14, a10);
  return null === i10 ? e14 : AV(e14, i10);
}
function XSt(e14, t10, n10) {
  if (E1(n10)) return AV(e14, { [t10]: { $set: n10 } });
  const r10 = n10 ? n10.length > 0 && n10.startsWith("=") && n10 : '=""';
  return AV(e14, { [t10]: { $set: r10 } });
}
const JSt = { type: "bullet", init: (e14, t10, n10, r10 = _St) => __spreadProps(__spreadValues(__spreadValues({}, r10), n10), { Name: e14 || "" }), labelKey: "reportItems:bullet", nameTemplateKey: "nameTemplates:bullet", icon: nf(Roe), icon24: nf(Aoe), defaultModel: _St, glyph: BSt, getReducer: function(e14) {
  const t10 = nz.of(e14).of("rdlx").getDefaultReducer();
  return function(n10, { type: r10, payload: o10 }) {
    switch (r10) {
      case L7:
        return XSt(n10, "Value", o10.expression);
      case H7:
        return XSt(n10, "TargetValue", o10.expression);
      case v2.type:
        if (!rj(n10)) break;
        return AV(n10, { ReportStyle: { $set: { StyleId: o10.id || "", StyleName: o10.name || "" } } });
      case b2.type: {
        if (!rj(n10)) break;
        const t11 = qSt(o10.style, e14);
        return t11 ? KSt(n10, t11, false, e14) : n10;
      }
      case S2.type: {
        const t11 = qSt(o10.$style, e14);
        return t11 ? KSt(n10, t11, true, e14) : n10;
      }
      default:
        return t10(n10, { type: r10, payload: o10 });
    }
  };
}, getProperties: () => GSt, getContextActions: i0e, features: { getExpressionProperties: function() {
  return vSt;
} } };
const QSt = (e14) => ({ key: "contextActions:container.delete", type: "button", icon: nf(t1e), action: e14 });
const eCt = (e14) => e14.Field.Value.findIndex((e15) => ij(e15));
const tCt = (e14) => e14.findIndex((e15) => ij(e15));
const nCt = (e14) => {
  const t10 = e14.Plots.findIndex((e15) => ij(e15));
  if (-1 === t10) return [];
  const { CustomLabels: n10, Pointers: r10 } = e14.Plots[t10].Config;
  const o10 = r10.findIndex((e15) => ij(e15));
  const a10 = n10.findIndex((e15) => ij(e15));
  return o10 >= 0 ? [QSt($ye.deletePlotPointer(o10))] : a10 >= 0 ? [QSt($ye.deletePlotCustomLabel(a10))] : [];
};
const rCt = (e14) => {
  const t10 = e14.Plots.findIndex((e15) => ij(e15));
  if (-1 === t10) return [];
  const n10 = e14.Plots[t10].Encodings;
  let r10 = null;
  const o10 = (e15, o11) => {
    if (!r10) {
      const a10 = e15(n10[o11]);
      a10 >= 0 && (r10 = $ye.deleteEncoding(t10, o11, a10));
    }
  };
  return o10(eCt, "Color"), o10(eCt, "Shape"), o10(eCt, "Size"), o10(eCt, "Category"), o10(tCt, "Values"), o10(tCt, "Details"), o10(tCt, "Texts"), null !== r10 ? [QSt(r10)] : [];
};
const [oCt, aCt] = Dp("ar-chart-adorner");
const iCt = aCt("gauge");
const sCt = ({ chart: { Plots: e14 }, path: t10, plotIndex: n10 }) => {
  const r10 = PA();
  const { t: o10 } = vp();
  const { rdlx: { expressionSyntax: a10 } } = Uae();
  const i10 = e14[n10];
  const s10 = i10.Encodings;
  const l10 = (e15, r11, o11) => {
    let a11 = `${t10}.Plots.${n10}.Encodings.${e15}`;
    return null !== r11 && (a11 = `${a11}.${r11}`), null !== o11 && (a11 = `${a11}.Field.Value.${o11}`), a11;
  };
  const c10 = Zqe(s10.Values, "Values", (e15, t11) => () => {
    ((e16, t12, n11, o11) => {
      r10(c5(l10(e16, n11, o11), t12));
    })("Values", "dvchartvalueaggregateencoding", t11, null);
  }, o10);
  const u10 = ep.useCallback((e15) => () => {
    r10(c5(`${t10}.Plots.${n10}.Config.Pointers.${e15}`));
  }, [r10, t10, n10]);
  const d10 = ep.useCallback((e15) => () => {
    r10(c5(`${t10}.Plots.${n10}.Config.CustomLabels.${e15}`));
  }, [r10, t10, n10]);
  const p10 = ep.useCallback((e15, r11) => {
    const { End: i11 } = e15;
    const s11 = HJ(i11, "string_expr", { expressionSyntax: a10 }) || o10("adorners:chart.gaugePointer.fieldStub", "Pointer {{index}}", { index: r11 });
    const l11 = { key: `pointer-${s11}${r11}`, text: s11, title: s11, selected: _e(e15.$selected), onClick: u10(r11), path: `${t10}.Plots.${n10}.Config.Pointers.${r11}` };
    return tp.createElement(Hqe, __spreadValues({}, l11));
  }, [a10, u10, t10, n10, o10]);
  const m10 = ep.useCallback((e15, r11) => {
    const { Text: i11 } = e15;
    const s11 = HJ(i11, "string_expr", { expressionSyntax: a10 }) || o10("adorners:chart.gaugeLabel.fieldStub", "Label {{index}}", { index: r11 });
    const l11 = { key: `customLabel-${s11}${r11}`, text: s11, title: s11, selected: _e(e15.$selected), onClick: d10(r11), path: `${t10}.Plots.${n10}.Config.CustomLabels.${r11}` };
    return tp.createElement(Hqe, __spreadValues({}, l11));
  }, [a10, d10, t10, n10, o10]);
  const h10 = i10.Config.Pointers;
  const f10 = i10.Config.CustomLabels;
  return tp.createElement("div", { className: kp(oCt, iCt) }, tp.createElement(Iqe, { title: o10("adorners:chart.dataFields", "Data Fields"), icon: nf(yqe), position: "top" }, tp.createElement(Lqe, { plotIndex: n10, panel: "GaugePointer" }, h10.map(p10))), tp.createElement(Iqe, { title: o10("adorners:chart.gaugeRanges", "Gauge Ranges"), icon: nf(yqe), position: "bottom" }, tp.createElement(Lqe, { plotIndex: n10, panel: "Values" }, c10.map(_qe((g10 = "Values", (e15) => l10(g10, e15, null)))))), tp.createElement(Iqe, { title: o10("adorners:chart.labels", "Labels"), icon: nf(yqe), position: "right" }, tp.createElement(Lqe, { plotIndex: n10, panel: "GaugeLabel" }, f10.map(m10))));
  var g10;
};
sCt.displayName = "GaugePlotAdorner";
const lCt = ({ show: e14, label: t10 }) => {
  const n10 = kp("ar-chart-overlay", { visible: e14 });
  return tp.createElement("div", { className: n10, title: e14 ? t10 : void 0 });
};
const cCt = (e14, t10) => [Zq(e14, "style.font", "font_simple", t10, "simple"), Zq(e14, "style.color", "color_expr", `${t10}.Color`, "advanced"), Zq(e14, "style.font", "font", t10, "advanced"), Zq(e14, "style.textDecoration", "text_decoration", `${t10}.TextDecoration`, "advanced", { enumKey: "text_decoration" })];
const uCt = (e14) => `dvchart.${e14}`;
const dCt = [EY.Name, Zq(tY, uCt("plots"), "dvchart_plot_collection", "Plots"), Zq(tY, uCt("palette"), "dvchart_palette", "", "advanced"), Zq(tY, uCt("plotTemplate"), "dvchart_plot_template", ""), FY.DataSetName, FY.DataSetParameters, EY.DataElementName, EY.DataElementOutput_AON, FY.Filters, Zq(Jq, "style.backgroundAndBorders", "background_borders", "Style", "simple"), Zq(Xq, "style.backgroundColor", "color_expr", "Style.BackgroundColor", "advanced"), vY.BackgroundGradientType, vY.BackgroundGradientEndColor, vY.BackgroundImage, Zq(Qq, "style.border", "border", "Style", "advanced"), EY.Location, EY.Size, Zq("bar", uCt("bar.bottomWidth"), "percent", "Bar.BottomWidth", "advanced", Uq.positive), Zq("bar", uCt("bar.neckHeight"), "percent", "Bar.NeckHeight", "advanced", Uq.positive), Zq("bar", uCt("bar.overlap"), "percent", "Bar.Overlap", "advanced"), Zq("bar", uCt("bar.topWidth"), "percent", "Bar.TopWidth", "advanced", Uq.positive), Zq("bar", uCt("bar.width"), "percent", "Bar.Width", "advanced", Uq.positive), vY.Padding, EY.LayerName, FY.PageBreak, FY.NewPage, EY.ZIndex, Zq(pY, "dataRegion.noRowsMessage", "string_expr", "NoRowsMessage"), ...cCt(pY, "Style"), EY.Visibility, Zq("dvchartLegend", uCt("legendWrapping"), "boolean", "Legend.Wrapping"), vY.Calendar, vY.Direction, vY.Language, vY.NumeralLanguage, vY.NumeralVariant, vY.UnicodeBiDi, vY.UprightInVerticalText, vY.WritingMode, EY.ToolTip, EY.Bookmark, EY.Label, EY.AccessibleDescription];
const pCt = { type: "dvchart", labelKey: "reportItems:dvchart", nameTemplateKey: "nameTemplates:dvchart", init: Jye, icon: nf(Ooe), icon24: nf(Boe), defaultModel: Yye, glyph: ({ item: e14, theme: t10, path: n10 }) => {
  const { getItemLayerInfo: r10 } = ep.useContext(bqe);
  const [o10, a10] = ep.useState({ errorMessage: "", model: vYe() });
  Uae();
  const { opacity: i10 } = r10(e14);
  const s10 = { chart: __spreadValues({}, e14), theme: t10, opacity: i10, onSuccess: (e15) => {
    zV.isEqual(o10.model, e15) ? o10.errorMessage && a10(__spreadProps(__spreadValues({}, o10), { errorMessage: void 0 })) : a10({ errorMessage: void 0, model: e15 });
  }, onError: (e15) => {
    e15 !== o10.errorMessage && a10(__spreadProps(__spreadValues({}, o10), { errorMessage: e15 }));
  } };
  const l10 = { chart: e14, model: o10.model, path: n10 };
  const c10 = { chart: e14, model: o10.model };
  const { Type: u10, Plots: d10, Style: p10 } = e14;
  const m10 = d10.some((e15) => !abe(e15));
  const h10 = ij(e14) && d10.length ? Math.max(0, d10.findIndex((e15) => ij(e15))) : -1;
  const f10 = kp("ar-item", "ar-chart");
  const g10 = elt(p10);
  return tp.createElement("div", { className: f10, style: g10, "data-path": n10, "data-type": u10 }, tp.createElement(tXe, __spreadValues({}, s10)), tp.createElement(lCt, { show: m10 }), oj(e14) && tp.createElement(rYe, { chart: e14, path: n10 }), false, tp.createElement(lYe, __spreadValues({}, l10)), tp.createElement(iYe, __spreadValues({}, c10)), (() => {
    var _a2;
    if (h10 >= 0) {
      const t11 = { chart: e14, path: n10, plotIndex: h10 };
      return "Gauge" === ((_a2 = e14.Plots[h10]) == null ? void 0 : _a2.PlotChartType) ? tp.createElement(sCt, __spreadValues({}, t11)) : tp.createElement(nYe, __spreadValues({}, t11));
    }
    return null;
  })(), o10.errorMessage && tp.createElement("div", { className: "ar-chart-error" }, o10.errorMessage));
}, getReducer: function(e14) {
  const t10 = nz.of(e14).of("rdlx").getDefaultReducer();
  const n10 = Uye(0, { [Rye]: jbe, [$ye.addPlotPointer.type]: Gbe, [$ye.addPlotCustomLabel.type]: Zbe, [Mye]: Vbe, [kye]: Rbe, [Pye]: Abe, [Eye]: Ibe, [Fye]: _be, [Nye]: Obe, [Oye]: GV((e15, { dataSetName: t11 }) => !t11, Bbe), [Bye]: zbe, [v2.type]: $be, [b2.type]: Wbe }, t10);
  const r10 = Wye;
  const o10 = Uye(0, { [Rye]: GV((e15) => e15.Plots.some(rj), r10, jbe), [$ye.addPlotPointer.type]: GV((e15) => e15.Plots.some(rj), r10, Gbe), [$ye.addPlotCustomLabel.type]: GV((e15) => e15.Plots.some(rj), r10, Zbe), [Pye]: Abe, [Eye]: Ibe, [Fye]: _be, [Nye]: Obe, [Bye]: zbe, [wye]: Lbe, [Tye]: Hbe, [o2.type]: jV(Ube, r10), [l2.type]: jV(Ube, r10) }, r10);
  return GV(rj, n10, o10);
}, getProperties: (e14, t10, n10) => (n10 == null ? void 0 : n10.isDashboard) ? n4(dCt) : dCt, features: { getExpressionProperties: () => ["Bar.BottomWidth", "Bar.NeckHeight", "Bar.Overlap", "Bar.TopWidth", "Bar.Width", "Palette", "CustomPalette"], isDataRegion: true }, getContextActions: (e14, t10, n10) => {
  const r10 = [];
  return aj(e14) ? (r10.push(...((e15) => {
    const t11 = [];
    const n11 = { name: e15.Palette, colors: e15.CustomPalette.join("|") };
    return e15.Plots.length && t11.push({ paletteInfo: n11, key: "contextActions:dvchart.presets.title", type: "plotTemplate", icon: W1e(oQe), action: $ye.setPlotTemplate }, { selectedPalette: e15.CustomPaletteInfo.PaletteId || e15.Palette, type: "chartPalette", key: "contextActions:dvchart.palette", icon: W1e(rQe), action: $ye.setPalette }), t11;
  })(e14)), [...r10.length ? [{ type: "group", icon: null, key: "contextActions:chart", actions: r10 }] : [], ...rCt(e14), ...nCt(e14), ...i0e(e14, t10, n10)]) : r10;
} };
const mCt = "labels", hCt = "line", fCt = "majorGrid", gCt = "majorTicks", yCt = "minorTicks", vCt = "minorGrid", bCt = "scale", SCt = "title";
const CCt = (e14) => `dvchartAxis.${e14}`;
const xCt = [Zq(tY, CCt("axisType"), "enum", "AxisType", void 0, { enumKey: "dvchart_axis_type" }), Zq(tY, CCt("title"), "string_expr", "Title"), Zq(tY, CCt("dateMode"), "enum", "DateMode", void 0, { enumKey: "dvchart_axis_date_mode" }), Zq(tY, CCt("plots"), "dvchart_axis_plot_name_collection", "Plots"), Zq(Kq, "", "dvchart_axis_sizes", ""), ...cCt(SCt, "TitleStyle"), Zq(SCt, "style.padding", "padding", "TitleStyle"), Zq(hCt, CCt("lineStyle"), "simple_border", "LineStyle"), Zq(hCt, CCt("visible"), "boolean", "AxisLine", "advanced"), ...cCt(mCt, "LabelStyle"), Zq(mCt, "style.padding", "padding", "LabelStyle"), Zq(mCt, "style.format", "format", "Format"), Zq(mCt, CCt("labelAngle"), "number", "LabelAngle", "advanced", Gq.integer), Zq(mCt, CCt("labelField"), "string_expr", "LabelField", "advanced"), Zq(mCt, CCt("visible"), "boolean", "Labels", "advanced"), Zq(mCt, "style.writingMode", "enum_expr", "LabelStyle.WritingMode", "advanced", { enumKey: "writing_mode" }), Zq(fCt, CCt("showGridLines"), "boolean", "MajorGrid", "advanced"), Zq(fCt, CCt("gridLinesStyle"), "simple_border", "MajorGridStyle", "advanced"), Zq(fCt, CCt("majorInterval"), "number_expr", "MajorUnit", "advanced", Gq.floatPositiveEmpty), Zq(gCt, CCt("tickSize"), "length_expr", "MajorTickSize", "advanced", { unit: "pt" }), Zq(gCt, CCt("tickStyle"), "simple_border", "MajorTickStyle", "advanced"), Zq(gCt, CCt("tickMarks"), "enum", "MajorTicks", "advanced", { enumKey: "dvchart_tick_mark" }), Zq(vCt, CCt("showGridLines"), "boolean", "MinorGrid", "advanced"), Zq(vCt, CCt("gridLinesStyle"), "simple_border", "MinorGridStyle", "advanced"), Zq(vCt, CCt("minorInterval"), "number_expr", "MinorUnit", "advanced", Gq.floatPositiveEmpty), Zq(yCt, CCt("tickSize"), "length_expr", "MinorTickSize", "advanced", { unit: "pt" }), Zq(yCt, CCt("tickStyle"), "simple_border", "MinorTickStyle", "advanced"), Zq(yCt, CCt("tickMarks"), "enum", "MinorTicks", "advanced", { enumKey: "dvchart_tick_mark" }), Zq(bCt, "", "dvchart_axis_scale", "", "advanced"), Zq(cY, CCt("position"), "enum", "Position", "advanced", { enumKey: "dvchart_axis_position" }), Zq(cY, CCt("origin"), "number_expr", "Origin", "advanced", Gq.floatEmpty), Zq(cY, CCt("reversed"), "boolean", "Reversed", "advanced"), Zq(cY, CCt("overlappingLabels"), "enum", "OverlappingLabels", "advanced", { enumKey: "dvchart_axis_overlapping_labels" })];
const wCt = ["LabelField", "DateMode"];
const TCt = { type: Qye.Type, labelKey: "reportItems:dvchartAxis", defaultModel: Qye, icon: nf(zae), getProperties: (e14) => "Y" === e14.AxisType ? xCt.filter((e15) => !wCt.includes(e15.valuePath)) : xCt, features: { getExpressionProperties: () => ["Format", "LabelAngle", "LogBase", "MajorTickSize", "MajorTicks", "MajorUnit", "Max", "Min", "MinorTickSize", "MinorTicks", "MinorUnit", "Origin", "OverlappingLabels", "Position", "ValueScaleType", "Title", "AxisType"], textDecorations: ["None", "Underline", "Overline", "LineThrough"], disableCopy: true } };
const ECt = ["Value"];
const FCt = ["SortingField"];
const MCt = ["Field.Value", "SortExpression"];
const kCt = ["Field.Value"];
const PCt = ["Value"];
const NCt = ["Value"];
const DCt = (e14) => (t10) => {
  switch (e14) {
    case "dvchartaggregateencoding":
      return [];
    case "dvchartcategoryencoding":
      return FCt;
    case "dvchartdetailsencoding":
      return MCt;
    case "dvcharttextencoding":
      return kCt;
    case "dvchartvalueaggregateencoding":
      return ((e15) => {
        const t11 = [];
        return "Complex" === e15.Field.FieldType ? (e15.Field.Subfields || []).forEach((e16, n10) => NCt.forEach((e17) => {
          t11.push(`Field.Subfields.${n10}.${e17}`);
        })) : (e15.Field.Value || []).forEach((e16, n10) => PCt.forEach((e17) => {
          t11.push(`Field.Value.${n10}.${e17}`);
        })), t11;
      })(t10);
  }
  return [];
};
const LCt = (e14) => `dvchartEncoding.${e14}`;
const HCt = [Zq("", "", "dvchart_value_encoding_fields_simple", "Field", "simple"), Zq("", "", "dvchart_value_encoding_fields_advanced", "Field", "advanced"), Zq("", LCt("aggregateType"), "enum", "Aggregate", "advanced", { enumKey: "dvchart_aggregate_type" })];
const ICt = [Zq("", LCt("value"), "dvchart_encoding_field_collection", "Field"), Zq("", LCt("aggregateType"), "enum", "Aggregate", void 0, { enumKey: "dvchart_aggregate_type" })];
const _Ct = [Zq("", LCt("value"), "dvchart_encoding_field_details", "Field"), Zq("", LCt("excludeNulls"), "boolean", "ExcludeNulls"), Zq("", LCt("group"), "enum", "Group", void 0, { enumKey: "dvchart_group_type" }), Zq("", LCt("sortingField"), "dvchart_without_aggregate_field", "SortingField"), Zq("", LCt("sort"), "enum", "Sort", void 0, { enumKey: "dvchart_encoding_sort" }), Zq("", LCt("sortingAggregate"), "enum", "SortingAggregate", void 0, { enumKey: "dvchart_aggregate_type" })];
const VCt = [Zq("", LCt("value"), "dvchart_encoding_field_collection", "Field"), Zq("", LCt("sort"), "enum", "Sort", void 0, { enumKey: "dvchart_encoding_sort" }), Zq("", LCt("sortingField"), "dvchart_without_aggregate_field", "SortingField"), Zq("", LCt("sortingAggregate"), "enum", "SortingAggregate", void 0, { enumKey: "dvchart_aggregate_type" })];
const RCt = [Zq("", LCt("fieldValue"), "dvchart_without_aggregate_field", "Value")];
const ACt = [Zq("", LCt("value"), "string_expr", "Field.Value"), Zq("", LCt("templateKey"), "dvchart_text_encoding_name", "Field.TemplateKey"), Zq("", LCt("target"), "enum", "Target", void 0, { enumKey: "dvchart_target" }), Zq("", LCt("aggregateType"), "enum", "Aggregate", void 0, { enumKey: "dvchart_aggregate_type" })];
function OCt(e14) {
  return function(e15, t10) {
    return Vj(e15, n5, t10);
  };
}
const BCt = { type: cye.Type, labelKey: "reportItems:dvchartValueAggregateEncoding", defaultModel: cye, getProperties: () => HCt, features: { getExpressionProperties: DCt(cye.Type) } };
const zCt = { type: uye.Type, labelKey: "reportItems:dvchartAggregateEncoding", defaultModel: uye, getProperties: () => ICt, features: { getExpressionProperties: DCt(uye.Type) }, getReducer: OCt };
const $Ct = { type: dye.Type, labelKey: "reportItems:dvchartDetailsEncoding", defaultModel: dye, getProperties: () => _Ct, features: { getExpressionProperties: DCt(dye.Type) } };
const WCt = { type: mye.Type, labelKey: "reportItems:dvchartTextEncoding", defaultModel: mye, getProperties: () => ACt, features: { getExpressionProperties: DCt(mye.Type) } };
const jCt = { type: pye.Type, labelKey: "reportItems:dvchartCategoryEncoding", defaultModel: pye, getProperties: () => VCt, features: { getExpressionProperties: DCt(pye.Type) }, getReducer: OCt };
const ZCt = { type: hye.Type, labelKey: "reportItems:dvchartEncodingValue", defaultModel: hye, getProperties: () => RCt, features: { getExpressionProperties: () => {
  const e14 = [];
  return e14.push(...ECt), e14;
} } };
const GCt = __spreadProps(__spreadValues({}, Yye.Legend), { Wrapping: true });
const UCt = (e14) => `dvchart.${e14}`;
const qCt = "dvchartLegendTitle", YCt = "dvchartLegendText";
const KCt = [Zq(tY, UCt("legendOrientation"), "enum", "Orientation", void 0, { enumKey: "dvchart_orientation" }), Zq(tY, UCt("legendPosition"), "enum", "Position", void 0, { enumKey: "dvchart_legend_position" }), Zq(tY, "style.padding", "padding", "Style"), Zq(Xq, "style.backgroundColor", "color_expr", "Style.BackgroundColor"), Zq(Qq, "style.border", "simple_border", "Style"), ...cCt(YCt, "TextStyle"), ...cCt(qCt, "TitleStyle")];
const XCt = { type: GCt.Type, labelKey: "reportItems:dvchartGlobalLegend", defaultModel: GCt, icon: nf(jae), getProperties: () => KCt, features: { getExpressionProperties: () => ["Orientation", "Position"], textDecorations: ["None", "Underline", "Overline", "LineThrough"], disableCopy: true } };
const JCt = () => ["Title"];
const QCt = Yye.Header;
const ext = Yye.Footer;
const txt = (e14) => `dvchartHeaderFooter.${e14}`;
const nxt = [Zq(tY, txt("caption"), "string_expr", "Title"), Zq(Xq, "style.backgroundColor", "color_expr", "Style.BackgroundColor"), vY.Border, ...cCt(gY, "TextStyle"), Zq(gY, "style.textAlign", "enum", "HAlign", void 0, { enumKey: "dvchart_halign" }), Zq(gY, txt("height"), "percent", "Height", "advanced", { step: 1, min: 1, max: 99, scale: 100, emptyValue: "Undefined", defaultValue: 0.1 }), Zq(gY, "style.verticalAlign", "enum", "VAlign", "advanced", { enumKey: "dvchart_valign" }), vY.Padding];
const rxt = { type: QCt.Type, labelKey: "reportItems:dvchartHeader", icon: nf($ae), defaultModel: QCt, getProperties: () => nxt, features: { getExpressionProperties: JCt, textDecorations: ["None", "Underline", "Overline", "LineThrough"], disableCopy: true } };
const oxt = { type: ext.Type, labelKey: "reportItems:dvchartFooter", defaultModel: ext, icon: nf(Wae), getProperties: () => nxt, features: { getExpressionProperties: JCt, textDecorations: ["None", "Underline", "Overline", "LineThrough"], disableCopy: true } };
const axt = (e14) => `dvchartLegend.${e14}`;
const ixt = [Zq(tY, axt("title"), "string_expr", "Title"), Zq(Xq, "style.backgroundColor", "color_expr", "Style.BackgroundColor"), vY.Border, Zq(cY, axt("orientation"), "enum", "Orientation", void 0, { enumKey: "dvchart_orientation" }), Zq(cY, axt("position"), "enum", "Position", void 0, { enumKey: "dvchart_legend_position" }), vY.Padding, Zq(cY, axt("maxHeight"), "percent", "MaxHeight", void 0, Uq.positive), Zq(cY, axt("maxWidth"), "percent", "MaxWidth", void 0, Uq.positive), ...cCt("dvchartLegendTitle", "TitleStyle"), ...cCt("dvchartLegendText", "TextStyle"), Zq("dvchartLegendText", axt("iconColor"), "color_expr", "IconColor", void 0, { allowEmpty: true }), Zq(dY, axt("ranges"), "dvchart_legend_range_options_collection", "RangeOptions"), Zq(yY, axt("hidden"), "boolean", "Hidden", "advanced")];
const sxt = { type: tve.Type, labelKey: "reportItems:dvchartLegend", defaultModel: tve, icon: nf(jae), getProperties: function(e14) {
  return "Size" === e14.LegendType ? ixt : "Shape" === e14.LegendType ? ixt.filter((e15) => "RangeOptions" !== e15.valuePath) : ixt.filter((e15) => "IconColor" !== e15.valuePath && "RangeOptions" !== e15.valuePath);
}, features: { getExpressionProperties: () => ["Orientation", "Position", "Title", "IconColor", "LegendType"], textDecorations: ["None", "Underline", "Overline", "LineThrough"], disableCopy: true } };
const lxt = "dvchartPlotEncodings", cxt = "dvchartPlotColorEncodings", uxt = "dvchartPlotShapeEncodings", dxt = "dvchartPlotSizeEncodings", pxt = "dvchartPlotConfig", mxt = "dvchartPlotStyle", hxt = "dvchartPlotSymbols", fxt = "dvchartLabelText", gxt = "dvchartLabelLine", yxt = "dvchartLabelBorder";
const vxt = (e14) => `dvchartPlot.${e14}`;
const bxt = { plotName: Zq(tY, "reportItem.name", "dvchart_plot_name", "PlotName"), valuesEncoding: Zq(tY, vxt("values"), "dvchart_values_encoding_collection", "Encodings.Values"), gaugeRanges: Zq(tY, vxt("gaugeRanges"), "dvchart_values_encoding_collection", "Encodings.Values"), tooltipTemplate: Zq(tY, vxt("tooltipTemplate"), "dvchart_template", "Config.Tooltip.Template", void 0, { disableDataFields: true, target: "ToolTip" }), opacity: Zq(tY, vxt("opacity"), "percent", "Config.Opacity", void 0, Uq.positive), symbolOpacity: Zq(tY, vxt("symbolOpacity"), "percent", "Config.SymbolOpacity", void 0, Uq.positive), plotTemplate: Zq(tY, "dvchart.plotTemplate", "dvchart_plot_template", ""), action: Zq(Yq, "reportItem.actionType", "action", "Config.Action", "advanced"), categoryEncoding: Zq(lxt, vxt("category"), "dvchart_encoding_field_collection", "Encodings.Category.Field.Value"), categoryEncodingSortingField: Zq(lxt, vxt("categorySortingField"), "dvchart_without_aggregate_field", "Encodings.Category.SortingField"), categoryEncodingSort: Zq(lxt, vxt("categorySort"), "enum", "Encodings.Category.Sort", void 0, { enumKey: "dvchart_encoding_sort" }), categoryEncodingSortingAggregate: Zq(lxt, vxt("categorySortingAggregate"), "enum", "Encodings.Category.SortingAggregate", void 0, { enumKey: "dvchart_aggregate_type" }), detailsEncoding: Zq(lxt, vxt("details"), "dvchart_details_encoding_collection", "Encodings.Details"), colorEncoding: Zq(cxt, vxt("color"), "dvchart_color_encoding_collection", "Encodings.Color.Field"), colorEncodingAggregate: Zq(cxt, vxt("colorAggregate"), "enum", "Encodings.Color.Aggregate", "advanced", { enumKey: "dvchart_aggregate_type" }), colorEncodingAction: Zq(cxt, vxt("action"), "action", "Encodings.Color.Action", "advanced"), shapeEncoding: Zq(uxt, vxt("shape"), "dvchart_encoding_field_collection", "Encodings.Shape.Field.Value"), shapeEncodingAggregate: Zq(uxt, vxt("shapeAggregate"), "enum", "Encodings.Shape.Aggregate", "advanced", { enumKey: "dvchart_aggregate_type" }), shapeEncodingAction: Zq(uxt, vxt("action"), "action", "Encodings.Shape.Action", "advanced"), sizeEncoding: Zq(dxt, vxt("size"), "dvchart_encoding_field_collection", "Encodings.Size.Field.Value"), sizeEncodingAggregate: Zq(dxt, vxt("sizeAggregate"), "enum", "Encodings.Size.Aggregate", "advanced", { enumKey: "dvchart_aggregate_type" }), sizeEncodingAction: Zq(dxt, vxt("action"), "action", "Encodings.Size.Action", "advanced"), textEncoding: Zq(lxt, vxt("texts"), "dvchart_text_encoding_collection", "Encodings.Texts"), barBottomWidth: Zq("bar", "dvchart.bar.bottomWidth", "percent", "Config.Bar.BottomWidth", "advanced", Uq.positive), barNeckHeight: Zq("bar", "dvchart.bar.neckHeight", "percent", "Config.Bar.NeckHeight", "advanced", Uq.positive), barOverlap: Zq("bar", "dvchart.bar.overlap", "percent", "Config.Bar.Overlap", "advanced", { emptyValue: "Undefined" }), barTopWidth: Zq("bar", "dvchart.bar.topWidth", "percent", "Config.Bar.TopWidth", "advanced", Uq.positive), barWidth: Zq("bar", "dvchart.bar.width", "percent", "Config.Bar.Width", "advanced", Uq.positive), rules: Zq(pxt, vxt("rules"), "dvchart_plot_rules_collection", "Config.Rules", "advanced"), overlays: Zq(pxt, vxt("overlays"), "dvchart_plot_overlays_collection", "Config.Overlays", "advanced"), barLines: Zq(pxt, vxt("bar"), "boolean", "Config.BarLines", "advanced"), barLinesColor: Zq(pxt, "dvPlotOverlays.lineColor", "color_expr", "Config.BarLineStyle.Color", "advanced"), barLinesStyle: Zq(pxt, "dvPlotOverlays.lineStyle", "border_style", "Config.BarLineStyle.Style", "advanced", { enumKey: "border_style" }), barLinesWidth: Zq(pxt, "dvPlotOverlays.lineWidth", "length_expr", "Config.BarLineStyle.Width", "advanced", qq.lineWidth), clippingMode: Zq(pxt, vxt("clippingMode"), "enum", "Config.ClippingMode", "advanced", { enumKey: "dvchart_clipping_mode" }), innerRadius: Zq(pxt, vxt("innerRadius"), "percent", "Config.InnerRadius", "advanced", __spreadProps(__spreadValues({}, Uq.positive), { max: 99 })), lineAspect: Zq(pxt, vxt("lineAspect"), "enum", "Config.LineAspect", "advanced", { enumKey: "dvchart_line_aspect" }), offset: Zq(pxt, vxt("offset"), "percent", "Config.Offset", "advanced", Uq.positive), plotType: Zq(pxt, vxt("type"), "enum", "PlotType", "advanced", { enumKey: "dvchart_plot_type" }), axisMode: Zq(pxt, vxt("axisMode"), "enum", "Config.AxisMode", "advanced", { enumKey: "axis_mode" }), showNulls: Zq(pxt, vxt("showNulls"), "enum", "Config.ShowNulls", "advanced", { enumKey: "dvchart_show_nulls" }), startAngle: Zq(pxt, vxt("startAngle"), "number", "Config.StartAngle", "advanced", Gq.integer), swapAxes: Zq(pxt, vxt("swapAxes"), "boolean", "Config.SwapAxes", "advanced"), sweep: Zq(pxt, vxt("sweep"), "number", "Config.Sweep", "advanced", Gq.integerPositive), unpivotData: Zq(pxt, vxt("unpivotData"), "unpivot_data", "Config.UnpivotData", "advanced"), customLabels: Zq(pxt, vxt("customLabels"), "dvchart_plot_custom_labels", "Config.CustomLabels", "advanced"), pointers: Zq(pxt, vxt("pointers"), "dvchart_plot_pointers", "Config.Pointers", "advanced"), showValuesNamesInLegend: Zq(pxt, vxt("showValuesNamesInLegend"), "dvchart_plot_show_values_names_in_legend", "", "advanced"), labelTextTemplate: Zq(fxt, vxt("textTemplate"), "dvchart_template", "Config.Text.Template", void 0, { disableDataFields: true, target: "Label" }), labelTextBackgroundColorStyle: Zq(fxt, vxt("textBackgroundColorStyle"), "color_expr", "Config.Text.Style.BackgroundColor", "advanced"), labelTextFontSimple: Zq(fxt, "style.font", "font_simple", "Config.Text.Style", "simple"), labelTextColor: Zq(fxt, "style.color", "color_expr", "Config.Text.Style.Color", "advanced"), labelTextFont: Zq(fxt, "style.font", "font", "Config.Text.Style", "advanced"), labelTextDecoration: Zq(fxt, "style.textDecoration", "text_decoration", "Config.Text.Style.TextDecoration", "advanced", { enumKey: "text_decoration" }), labelTextPosition: Zq(fxt, vxt("textPosition"), "enum", "Config.Text.TextPosition", void 0, { enumKey: "dvchart_text_position" }), labelTextOffset: Zq(fxt, vxt("textOffset"), "number", "Config.Text.Offset", "advanced", Gq.float), labelTextOverlappingLabels: Zq(fxt, vxt("textOverlappingLabels"), "enum", "Config.Text.OverlappingLabels", "advanced", { enumKey: "dvchart_overlapping_labels" }), labelBorder: Zq(yxt, "", "simple_border", "Config.Text.Style", "advanced"), labelLineBorder: Zq(gxt, vxt("textConnectingLine"), "simple_border", "Config.Text.ConnectingLine", "advanced"), labelLinePosition: Zq(gxt, vxt("textLinePosition"), "enum", "Config.Text.LinePosition", "advanced", { enumKey: "dvchart_line_position" }), backgroundColor: Zq(Xq, "style.backgroundColor", "color_expr", "Config.Style.BackgroundColor", "both", { allowEmpty: true }), lineStyleColor: Zq(mxt, vxt("lineColor"), "color_expr", "Config.LineStyle.Color", "both", { allowEmpty: true }), lineStyleStyle: Zq(mxt, vxt("lineStyle"), "border_style", "Config.LineStyle.Style", void 0, { enumKey: "border_style" }), lineStyleWidth: Zq(mxt, vxt("lineWidth"), "length_expr", "Config.LineStyle.Width", void 0, qq.borderWidth), symbolsToggle: Zq(hxt, vxt("symbols"), "boolean", "Config.Symbols"), symbolsShape: Zq(hxt, vxt("symbolShape"), "enum", "Config.SymbolShape", void 0, { enumKey: "dvchart_symbol_shape" }), symbolsBackgroundColor: Zq(hxt, vxt("symbolBackgroundColor"), "color_expr", "Config.SymbolStyle.BackgroundColor", "advanced", { allowEmpty: true }), symbolsStyle: Zq(hxt, vxt("symbolStyle"), "simple_border", "Config.SymbolStyle", "advanced") };
const Sxt = [bxt.plotName, bxt.valuesEncoding, bxt.tooltipTemplate, bxt.opacity, bxt.symbolOpacity, bxt.plotTemplate, bxt.action, bxt.categoryEncoding, bxt.categoryEncodingSortingField, bxt.categoryEncodingSort, bxt.categoryEncodingSortingAggregate, bxt.detailsEncoding, bxt.colorEncoding, bxt.colorEncodingAggregate, bxt.colorEncodingAction, bxt.shapeEncoding, bxt.shapeEncodingAggregate, bxt.shapeEncodingAction, bxt.sizeEncoding, bxt.sizeEncodingAggregate, bxt.sizeEncodingAction, bxt.barBottomWidth, bxt.barNeckHeight, bxt.barOverlap, bxt.barTopWidth, bxt.barWidth, bxt.rules, bxt.overlays, bxt.barLines, bxt.barLinesColor, bxt.barLinesStyle, bxt.barLinesWidth, bxt.clippingMode, bxt.innerRadius, bxt.lineAspect, bxt.offset, bxt.plotType, bxt.axisMode, bxt.showNulls, bxt.startAngle, bxt.swapAxes, bxt.sweep, bxt.labelTextTemplate, bxt.labelTextBackgroundColorStyle, bxt.labelTextFontSimple, bxt.labelTextColor, bxt.labelTextFont, bxt.labelTextDecoration, bxt.labelTextPosition, bxt.labelTextOffset, bxt.labelTextOverlappingLabels, bxt.labelBorder, bxt.labelLineBorder, bxt.labelLinePosition, bxt.backgroundColor, bxt.lineStyleColor, bxt.lineStyleStyle, bxt.lineStyleWidth, bxt.symbolsToggle, bxt.symbolsShape, bxt.symbolsBackgroundColor, bxt.symbolsStyle];
const Cxt = [bxt.plotName, bxt.valuesEncoding, bxt.tooltipTemplate, bxt.plotTemplate];
const xxt = [bxt.categoryEncoding, bxt.categoryEncodingSortingField, bxt.categoryEncodingSort, bxt.categoryEncodingSortingAggregate];
const wxt = [bxt.detailsEncoding];
const Txt = [bxt.colorEncoding, bxt.colorEncodingAggregate, bxt.colorEncodingAction];
const Ext = [bxt.shapeEncoding, bxt.shapeEncodingAggregate, bxt.shapeEncodingAction];
const Fxt = [bxt.sizeEncoding, bxt.sizeEncodingAggregate, bxt.sizeEncodingAction];
const Mxt = [bxt.textEncoding];
const kxt = [bxt.barBottomWidth, bxt.barNeckHeight, bxt.barOverlap, bxt.barTopWidth, bxt.barWidth];
const Pxt = [bxt.labelTextTemplate, bxt.labelTextBackgroundColorStyle, bxt.labelTextFontSimple, bxt.labelTextColor, bxt.labelTextFont, bxt.labelTextDecoration, bxt.labelTextPosition, bxt.labelTextOffset, bxt.labelTextOverlappingLabels, bxt.labelBorder, bxt.labelLineBorder, bxt.labelLinePosition];
const Nxt = [bxt.lineStyleColor, bxt.lineStyleStyle, bxt.lineStyleWidth];
const Dxt = [bxt.symbolsShape, bxt.symbolsBackgroundColor, bxt.symbolsStyle];
const Lxt = [bxt.symbolsToggle, ...Dxt];
const Hxt = (e14) => {
  const t10 = rbe(e14);
  const n10 = [];
  return t10.Category && n10.push(...xxt), t10.Details && n10.push(...wxt), t10.Color && n10.push(...Txt), t10.Shape && n10.push(...Ext), t10.Size && n10.push(...Fxt), t10.Texts && n10.push(...Mxt), n10;
};
const Ixt = { Custom: [], Column: [], Bar: [], Line: [], Pie: [], Area: [], Pyramid: [], Funnel: [], Scatter: [], Bubble: [], Gantt: [], Candlestick: [], HighLowClose: [], HighLowOpenClose: [], PolarColumn: [], PolarBar: [], RadarArea: [], RadarBubble: [], RadarScatter: [], RadarLine: [], RangeArea: [], RangeBar: [], RangeColumn: [], Gauge: [] };
Object.keys(Ixt).forEach((e14) => {
  const t10 = (t11) => {
    Ixt[e14] = t11;
  };
  switch (e14) {
    case "Column":
    case "Bar":
      return t10([...Cxt, bxt.opacity, bxt.action, ...Hxt(e14), ...kxt, bxt.rules, bxt.overlays, bxt.barLines, bxt.barLinesColor, bxt.barLinesStyle, bxt.barLinesWidth, bxt.clippingMode, bxt.offset, bxt.showNulls, ...Pxt, bxt.backgroundColor, ...Nxt, bxt.unpivotData]);
    case "Gantt":
    case "RangeBar":
    case "RangeColumn":
      return t10([...Cxt, bxt.opacity, bxt.action, ...Hxt(e14), ...kxt, bxt.rules, bxt.overlays, bxt.barLines, bxt.barLinesColor, bxt.barLinesStyle, bxt.barLinesWidth, bxt.clippingMode, bxt.offset, bxt.showNulls, ...Pxt, bxt.backgroundColor, ...Nxt]);
    case "Area":
      return t10([...Cxt, bxt.opacity, bxt.action, ...Hxt(e14), bxt.rules, bxt.overlays, bxt.clippingMode, bxt.lineAspect, bxt.showNulls, ...Pxt, bxt.backgroundColor, ...Nxt, bxt.unpivotData]);
    case "Line":
      return t10([...Cxt, bxt.opacity, bxt.symbolOpacity, bxt.action, ...Hxt(e14), bxt.rules, bxt.overlays, bxt.clippingMode, bxt.lineAspect, bxt.showNulls, bxt.swapAxes, ...Pxt, ...Nxt, ...Lxt]);
    case "Pie":
      return t10([...Cxt, bxt.opacity, bxt.action, ...Hxt(e14), ...kxt, bxt.rules, bxt.overlays, bxt.clippingMode, bxt.innerRadius, bxt.offset, bxt.showNulls, bxt.startAngle, bxt.sweep, ...Pxt, bxt.backgroundColor, ...Nxt, bxt.unpivotData]);
    case "Scatter":
    case "Bubble":
      return t10([...Cxt, bxt.symbolOpacity, bxt.action, ...Hxt(e14), bxt.rules, bxt.overlays, bxt.clippingMode, bxt.showNulls, ...Pxt, ...Dxt]);
    case "Pyramid":
    case "Funnel":
      return t10([...Cxt, bxt.opacity, bxt.action, ...Hxt(e14), ...kxt, bxt.rules, bxt.overlays, bxt.clippingMode, bxt.showNulls, ...Pxt, bxt.backgroundColor, ...Nxt, bxt.unpivotData]);
    case "Candlestick":
    case "HighLowClose":
    case "HighLowOpenClose":
      return t10([...Cxt, bxt.opacity, bxt.action, ...Hxt(e14), bxt.rules, bxt.overlays, bxt.clippingMode, bxt.showNulls, bxt.backgroundColor, ...Nxt]);
    case "PolarColumn":
    case "PolarBar":
      return t10([...Cxt, bxt.opacity, bxt.action, ...Hxt(e14), ...kxt, bxt.rules, bxt.overlays, bxt.barLines, bxt.barLinesColor, bxt.barLinesStyle, bxt.barLinesWidth, bxt.clippingMode, bxt.innerRadius, bxt.offset, bxt.showNulls, bxt.startAngle, bxt.sweep, ...Pxt, bxt.backgroundColor, ...Nxt, bxt.unpivotData]);
    case "RadarArea":
      return t10([...Cxt, bxt.opacity, bxt.action, ...Hxt(e14), bxt.rules, bxt.overlays, bxt.clippingMode, bxt.lineAspect, bxt.showNulls, bxt.startAngle, ...Pxt, bxt.backgroundColor, ...Nxt, bxt.unpivotData]);
    case "RadarBubble":
    case "RadarScatter":
      return t10([...Cxt, bxt.symbolOpacity, bxt.action, ...Hxt(e14), bxt.rules, bxt.overlays, bxt.clippingMode, bxt.showNulls, bxt.startAngle, ...Pxt, ...Dxt]);
    case "RadarLine":
      return t10([...Cxt, bxt.opacity, bxt.symbolOpacity, bxt.action, ...Hxt(e14), bxt.rules, bxt.overlays, bxt.clippingMode, bxt.lineAspect, bxt.showNulls, bxt.startAngle, ...Pxt, ...Nxt, ...Lxt]);
    case "Gauge":
      return t10([bxt.plotName, bxt.gaugeRanges, bxt.tooltipTemplate, bxt.plotTemplate, bxt.opacity, bxt.action, bxt.rules, bxt.pointers, bxt.customLabels, bxt.innerRadius, bxt.startAngle, bxt.sweep, bxt.clippingMode, bxt.showValuesNamesInLegend, bxt.backgroundColor, ...Nxt]);
    case "RangeArea":
      return t10([...Cxt, bxt.opacity, bxt.action, ...Hxt(e14), bxt.rules, bxt.overlays, bxt.clippingMode, bxt.lineAspect, bxt.showNulls, ...Pxt, bxt.backgroundColor, ...Nxt]);
    default:
      return t10(Sxt);
  }
});
const _xt = { type: rve.Type, labelKey: "reportItems:dvchartPlot", nameTemplateKey: "nameTemplates:dvchartPlot", init: ave, icon: nf(Zae), defaultModel: rve, getProperties: function(e14) {
  return Ixt[e14.PlotChartType];
}, features: { getExpressionProperties: () => [], textDecorations: ["None", "Underline", "Overline", "LineThrough"], disableCopy: true }, getReducer: tbe };
const Vxt = [Zq(tY, "dvChartPlotCustomLabels.text", "string_expr", "Text", "advanced"), Zq(tY, "dvChartPlotCustomLabels.offsetX", "length", "OffsetX", "advanced"), Zq(tY, "dvChartPlotCustomLabels.offsetY", "length", "OffsetY", "advanced"), Zq(gY, "style.color", "color_expr", "Style.Color", "advanced"), Zq(gY, "font.fontFamily", "font_family", "Style.FontFamily", "advanced"), Zq(gY, "font.fontSize", "font_size_expr", "Style.FontSize", "advanced", { enumKey: "font_size", unit: "pt" }), Zq(gY, "font.fontStyle", "enum_expr", "Style.FontStyle", "advanced", { enumKey: "font_style" }), Zq(gY, "font.fontWeight", "enum_expr", "Style.FontWeight", "advanced", { enumKey: "font_weight" }), Zq(gY, "style.textDecoration", "text_decoration", "Style.TextDecoration", "advanced", { enumKey: "text_decoration" }), Zq(gY, "style.writingMode", "enum", "Style.WritingMode", "advanced", { enumKey: "writing_mode" })];
const Rxt = { type: Dve.Type, labelKey: "reportItems:dvchartPlotCustomLabel", defaultModel: Dve, getProperties: () => Vxt, getReducer: tbe };
const Axt = [Zq(Xq, "style.backgroundColor", "color_expr", "Style.BackgroundColor", "advanced"), Zq(tY, "dvChartPlotPointers.needleWidth", "length", "NeedleWidth", "advanced"), Zq(tY, "dvChartPlotPointers.needlePinWidth", "length", "NeedlePinWidth", "advanced"), Zq(tY, "dvChartPlotPointers.end", "string_expr", "End", "advanced")];
const Oxt = { type: Hve.Type, labelKey: "reportItems:dvchartPlotPointer", defaultModel: Hve, getProperties: () => Axt, getReducer: tbe };
const Bxt = [Zq(tY, (zxt = "axes", `dvchartPlotArea.${zxt}`), "dvchart_axis_collection", "Axes"), Zq(Xq, "style.backgroundColor", "color_expr", "Style.BackgroundColor"), vY.Border, vY.Padding];
var zxt;
const $xt = { type: CYe.Type, labelKey: "reportItems:dvchartPlotArea", defaultModel: CYe, icon: nf(Gae), getProperties: () => Bxt, features: { disableCopy: true }, getReducer: function(e14) {
  return function(e15, t10) {
    return Vj(e15, n5, t10);
  };
} };
const Wxt = ["Text", "Checked"];
const jxt = /^=?(true)$/i;
const Zxt = /^=?(false)$/i;
const Gxt = (e14) => "string" == typeof e14 ? -1 !== e14.search(jxt) : !!e14;
const Uxt = (e14) => "string" == typeof e14 ? -1 !== e14.search(Zxt) : !e14;
const qxt = { NoWrap: "no-wrap", WordWrap: "word-wrap", CharWrap: "char-wrap" };
const Yxt = { TopLeft: "top left", TopCenter: "top center", TopRight: "top right", MiddleCenter: "middle center", MiddleRight: "middle right", BottomLeft: "bottom left", BottomCenter: "bottom center", BottomRight: "bottom right" };
class Kxt extends tp.Component {
  constructor() {
    super(...arguments), this.handleCheckClick = (e14) => {
      const { dispatch: t10, item: { Checked: n10 } } = this.props;
      const r10 = Gxt(n10) ? "False" : "True";
      t10(s2({ valuePath: "Checked" }, r10)), e14.stopPropagation();
    };
  }
  render() {
    var _a2, _b2;
    const { connectDropTarget: e14, canDrop: t10, isOver: n10, theme: r10, parentBackgroundColor: o10, onlyContent: a10 } = this.props;
    const { item: i10, item: { Style: s10, Checked: l10, CheckAlignment: c10, Type: u10 }, path: d10 } = this.props;
    const p10 = sj(i10);
    const m10 = kp("ar-item", "ar-checkbox", Yxt[c10] || "middle left", Wme(n10, t10));
    const h10 = kp("ar-checkbox-inner", { selected: p10 });
    const f10 = kp("ar-checkbox-check", { expression: !Uxt(l10) && !Gxt(l10) && jme(l10) });
    const g10 = kp("ar-checkbox-text-wrapper", (y10 = s10.WrapMode, qxt[y10] || ""));
    var y10;
    const v10 = s10 || {};
    const b10 = __spreadValues(__spreadProps(__spreadValues(__spreadValues({}, kme(v10)), Rme(v10.TextDecoration)), { color: Sme(v10.Color, r10) }), _me({ family: v10.FontFamily, size: v10.FontSize, style: v10.FontStyle, weight: v10.FontWeight }, r10));
    const S10 = p10 ? this.handleCheckClick : void 0;
    const C10 = p10 ? this.handleCheckClick : void 0;
    const x10 = X1(YAe((_b2 = (_a2 = i10.Text) == null ? void 0 : _a2.toString()) != null ? _b2 : ""));
    const w10 = tp.createElement("div", { title: x10, "data-path": d10, "data-type": u10, className: m10, style: b10 }, tp.createElement("div", { className: h10 }, tp.createElement("div", { "data-path": d10, className: f10, style: { borderColor: b10.color }, onClick: S10, onDoubleClick: C10 }, Gxt(l10) && tp.createElement(Fm, { icon: nf(pst), customCSS: "wd-svg" })), tp.createElement("div", { "data-path": d10, className: g10 }, x10.split("\n").map((e15, t11) => {
      const n11 = `${t11}`;
      return [e15, tp.createElement("br", { key: n11 })];
    }))), p10 && !a10 && tp.createElement("div", { className: "ar-checkbox__textarea-area" }, tp.createElement(rlt, { item: i10, path: d10, value: x10, valuePath: "Text", parentBackgroundColor: o10 })));
    return a10 ? w10 : e14(w10);
  }
}
Kxt.contextType = bqe;
var Xxt = uA(TA(), bst("Text"))(Kxt);
const Jxt = FZ.resultOf(wq.decode({ Type: "checkbox", Name: "Checkbox" }));
const Qxt = (e14) => `checkBox.${e14}`;
const ewt = [EY.Name, Zq(tY, Qxt("text"), "string_expr", "Text"), Zq(tY, Qxt("checked"), "boolean_expr", "Checked"), Zq(tY, Qxt("checkAlignment"), "enum", "CheckAlignment", void 0, { enumKey: "check_alignment" }), EY.Action, vY.BackgroundAndBorders, vY.BackgroundColor, vY.BackgroundImage, vY.Color, vY.Borders, vY.FontSimple, vY.Font, vY.TextDecoration, vY.WrapMode, EY.Location, EY.Size, Zq(cY, "reportItem.style", "styles", "ReportStyle", void 0, { target: "CheckBox" }), vY.Padding, EY.LayerName, EY.ZIndex, EY.Visibility, EY.DataElementName, EY.DataElementOutput_AON, TY, EY.ToolTip, EY.Label, EY.Bookmark];
const twt = (e14, t10) => {
  if (e14 && e14.$targetType !== wj.CheckBox) return null;
  const n10 = ((e15) => {
    const t11 = nz.of(e15).getTemplate("checkbox");
    const { Style: { BackgroundColor: n11, Color: r10, FontFamily: o10, FontSize: a10, FontStyle: i10, FontWeight: s10 } } = t11;
    return { BackgroundColor: n11, Color: r10, FontFamily: o10, FontSize: a10, FontStyle: i10, FontWeight: s10 };
  })(t10);
  return e14 ? __spreadValues(__spreadValues({}, n10), e14) : n10;
};
const nwt = { type: "checkbox", init: (e14, t10, n10, r10 = Jxt) => __spreadProps(__spreadValues(__spreadValues({}, r10), n10), { Name: e14 }), labelKey: "reportItems:checkbox", nameTemplateKey: "nameTemplates:checkbox", icon: nf(zoe), icon24: nf($oe), defaultModel: Jxt, glyph: Xxt, getReducer: function(e14) {
  const t10 = nz.of(e14).of("rdlx").getDefaultReducer();
  return function(n10, { type: r10, payload: o10 }) {
    switch (r10) {
      case v2.type:
        if (!rj(n10)) break;
        return AV(n10, { ReportStyle: { $set: { StyleId: o10.id || "", StyleName: o10.name || "" } } });
      case b2.type: {
        if (!rj(n10)) break;
        const t11 = twt(o10.style, e14);
        return t11 ? function(e15, t12) {
          const n11 = __spreadValues(__spreadValues({}, e15.Style), t12);
          return AV(e15, { Style: { $set: n11 } });
        }(n10, t11) : n10;
      }
      default:
        return t10(n10, { type: r10, payload: o10 });
    }
  };
}, getContextActions: i0e, getProperties: () => ewt, features: { getExpressionProperties: function() {
  return Wxt;
} } };
const [rwt, , owt] = Dp("ar-contentplaceholder");
const [awt] = owt("text");
const iwt = FZ.resultOf(wq.decode({ Type: "contentplaceholder", Name: "ContentPlaceHolder1", Width: "1in", Height: "1in" }));
const swt = (e14) => `contentPlaceHolder.${e14}`;
const lwt = [bY.Name, Zq(tY, swt("text"), "string", "Text"), bY.Location, bY.Size, EY.ZIndex, Zq(cY, swt("consumeWhiteSpace"), "boolean", "ConsumeWhiteSpace", "advanced")];
const cwt = (e14, t10, n10) => {
  const { Width: r10, Height: o10 } = e14.$place;
  const { Left: a10, Top: i10 } = n10.$place;
  return __spreadProps(__spreadValues({}, t10), { meta: { sizeLimitation: { MaxWidth: L$.parse(r10), MaxHeight: L$.parse(o10), LeftOffset: L$.parse(a10), TopOffset: L$.parse(i10) } } });
};
const uwt = (e14, t10) => {
  const { relocate: n10, updatedSizeByInnerSize: r10, applyLineLocation: o10, applyLocation: a10 } = S7;
  const { payload: i10 } = t10;
  const { delta: s10 } = i10;
  const l10 = L$.isZeroLike(s10 && s10.x);
  const c10 = L$.isZeroLike(s10 && s10.y);
  if (l10 && c10) return e14;
  const { Width: u10, Height: d10 } = e14.$place;
  const p10 = {};
  e14.ReportItems.forEach((l11, c11) => {
    if (oj(l11)) p10[c11] = { $set: r10(n5(l11, cwt(e14, t10, l11))) };
    else if (rj(l11)) {
      const e15 = i10.snaps && i10.snaps[l11.Name];
      const { grip: t11 } = i10;
      const { Width: m11, Height: h10, Top: f10, Left: g10 } = l11.$place;
      const y10 = ((e16, t12) => {
        if (!t12) return null;
        const { snapToLine: n11 } = S7;
        const { Left: r11, Top: o11, Height: a11, Width: i11 } = e16.$place;
        const s11 = n11(t12);
        const { Left: l12, Top: c12, Bottom: u11, Right: d11 } = s11;
        return (l12 == null ? void 0 : l12.greaterThan(L$.parse(r11))) || (c12 == null ? void 0 : c12.greaterThan(L$.parse(o11))) || (u11 == null ? void 0 : u11.greaterThan(L$.parse(a11))) || (d11 == null ? void 0 : d11.greaterThan(L$.parse(i11))) ? null : s11;
      })(l11, e15);
      const v10 = h7({ Width: L$.parse(u10), Height: L$.parse(d10) }, { Width: L$.parse(m11), Height: L$.parse(h10), Left: L$.parse(g10), Top: L$.parse(f10) }, s10, t11);
      const b10 = n10(l11, v10, t11, y10, "line" === l11.Type ? o10 : a10);
      p10[c11] = { $set: r10(b10) };
    }
  });
  const m10 = Object.entries(p10).map(([, e15]) => e15.$set);
  return l8(m10, e14), zV.isEmpty(p10) ? e14 : AV(e14, { ReportItems: p10 });
};
const dwt = (e14) => (t10, n10) => {
  const r10 = m7(t10, n10);
  return c8(e14, r10);
};
const pwt = (e14) => (t10, n10) => {
  var _a2;
  const { Width: r10, Height: o10 } = t10.$place;
  const a10 = { Width: L$.parse(r10), Height: L$.parse(o10) };
  const i10 = __spreadProps(__spreadValues({}, n10.payload), { fillData: __spreadProps(__spreadValues({}, (_a2 = n10.payload) == null ? void 0 : _a2.fillData), { maxSize: a10 }) });
  return e14(t10, tU(i10));
};
function mwt(e14) {
  return function(t10, n10) {
    const r10 = b7(e14);
    const o10 = () => {
      const e15 = r10(t10, n10);
      return ((e16, t11) => {
        const { Width: n11, Height: r11 } = e16.$place;
        const { $width: o11, $height: a10 } = t11;
        return o11 && L$.parse(o11).greaterThan(L$.parse(n11)) || a10 && L$.parse(a10).greaterThan(L$.parse(r11));
      })(t10, e15) && i8(), e15;
    };
    return Uye(0, { [YG.type]: uwt, [KG.type]: GV(J3, dwt(e14), o10), [tU.type]: pwt(r10) }, o10)(t10, n10);
  };
}
const hwt = { type: "contentplaceholder", labelKey: "reportItems:contentplaceholder", nameTemplateKey: "nameTemplates:contentplaceholder", icon: nf(Zoe), icon24: nf(Goe), init: (e14, t10, n10, r10 = iwt) => {
  const o10 = __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, iwt), r10), n10), { Name: e14 || "" });
  const a10 = o10.Text || hG().t("reportItems:contentPlaceholderText", "Set the Text property to tell Content Report authors what to add here");
  return __spreadProps(__spreadValues({}, o10), { Text: a10 });
}, defaultModel: iwt, glyph: (_mb) => {
  var _nb = _mb, { item: e14, path: t10, dataSets: n10 = [] } = _nb, r10 = __objRest(_nb, ["item", "path", "dataSets"]);
  const o10 = h9();
  const { $masterReportContent: a10 } = o10;
  const { DataSets: i10 = [] } = a10 != null ? a10 : {};
  const { Text: s10, ReportItems: l10, Type: c10 } = e14;
  const u10 = q7(o10);
  const d10 = u10 && (l10 == null ? void 0 : l10.length);
  const p10 = kp("ar-item", rwt);
  const m10 = __spreadProps(__spreadValues({ item: e14, path: t10 }, r10), { dataSets: [...i10, ...n10] });
  const h10 = d10 && u10 ? null : tp.createElement("span", { className: awt }, s10);
  return tp.createElement("div", { className: p10, "data-path": u10 ? void 0 : t10, "data-type": u10 ? void 0 : c10 }, u10 && tp.createElement(Ylt, __spreadValues({}, m10)), h10);
}, getReducer: (e14) => {
  const t10 = q5(e14);
  const n10 = mwt(e14);
  return (e15, r10) => e15.$inChildReport ? n10(e15, r10) : t10(e15, r10);
}, getProperties: (e14, t10, n10) => {
  if (n10 == null ? void 0 : n10.isChildReport) {
    const e15 = ((e16) => t4(e16, e4))(lwt);
    return r4(e15, { disabled: true });
  }
  return lwt;
}, getContextActions: xlt };
const fwt = nf(Npt);
const gwt = nf(wpt);
const ywt = nf(Ept);
const vwt = nf(Mpt);
const bwt = nf(kpt);
const Swt = nf(Fpt);
const Cwt = nf(Ppt);
const xwt = FZ.resultOf(dX.decode({ Width: "10in", ReportSections: [{ Name: "Section1", Width: "10in", Body: { Height: "6in" } }] }));
const wwt = (e14) => `report.${e14}`;
const Twt = [PY];
const Ewt = [NY, DY];
const Fwt = [Zq(cY, wwt("embeddedImages"), "embedded_images_collection", "EmbeddedImages"), Zq(cY, wwt("consumeContainerWhitespace"), "boolean", "ConsumeContainerWhitespace", "advanced"), Zq(cY, wwt("layers"), "layer_collection", "Layers", "advanced"), HY, IY, _Y, wY, TY, SY.Levels, SY.NumberingStyle, SY.Source, Zq(dY, wwt("author"), "string", "Author"), Zq(dY, wwt("description"), "string", "Description"), Zq(dY, wwt("language"), "language", "Language"), Zq(dY, wwt("startPageNumber"), "number", "StartPageNumber", "advanced", Gq.integer)];
const Mwt = Zq(dY, wwt("reportParts"), "report_parts_collection", "ReportParts", "advanced");
const kwt = [...Twt, ...Fwt];
const Pwt = [...Ewt, ...Fwt];
const Nwt = Zq(cY, wwt("nameMasterReport"), "name_master_report", "$masterReport");
const Dwt = (e14, t10, n10) => {
  var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2;
  const r10 = (_c2 = (_b2 = (_a2 = n10 == null ? void 0 : n10.settings) == null ? void 0 : _a2.rdlx) == null ? void 0 : _b2.reportThemes) == null ? void 0 : _c2.prohibitMultipleThemes;
  let o10 = r10 ? kwt : Pwt;
  const a10 = ((_f2 = (_e2 = (_d2 = n10 == null ? void 0 : n10.settings) == null ? void 0 : _d2.rdlx) == null ? void 0 : _e2.reportParts) == null ? void 0 : _f2.enabled) && !(n10 == null ? void 0 : n10.isDashboard);
  return o10 = q7(e14) ? o10.concat(Nwt) : o10, o10 = a10 ? [...o10, Mwt] : o10, ((_h2 = (_g2 = n10 == null ? void 0 : n10.settings) == null ? void 0 : _g2.rdlx) == null ? void 0 : _h2.reportCollapseWhitespace) && o10.push(VY), (n10 == null ? void 0 : n10.isChildReport) ? ((e15) => r4(e15, { disabled: true }, o4))(o10) : o10;
};
const Lwt = (e14, t10, n10) => {
  const r10 = [];
  let o10 = t10;
  for (let t11 = 0; t11 < n10.length; t11++) {
    const a10 = n10[t11];
    const i10 = (e15) => e15.FormattedName === a10;
    if (t11 === n10.length - 1) {
      const e15 = (o10.Attributes || []).some((e16) => i10(e16) || (e16.Variations || []).some(i10));
      if (e15) break;
    }
    const s10 = (o10.Relations || []).find(i10);
    if (!s10) return null;
    const l10 = u6(s10, e14);
    if (!l10) return null;
    o10 = l10, r10.push(s10);
  }
  return r10;
};
const Hwt = (e14, t10, n10) => {
  const r10 = c6(e14, n10);
  if (!r10) throw Error(`Invalid entity name: ${n10}`);
  const o10 = T6(t10);
  const a10 = Lwt(e14, r10, o10);
  if (!a10) throw Error(`Invalid rebalancing path: ${t10}`);
  const { invertedRelations: i10, invertedBaseEntity: s10 } = ((e15, t11, n11) => {
    const r11 = [];
    let o11 = t11;
    return n11.forEach((t12) => {
      const n12 = u6(t12, e15);
      if (!n12) throw new Error(`There is no entity having this id: ${t12.RelatedEntityId}.`);
      const a11 = (n12.Relations || []).filter(E6).find((e16) => e16.RelatedEntityId === o11.Id);
      if (!a11) throw new Error(`Relation from entity '${o11.Name}' to '${n12.Name}' of cardinality 'One' or 'OptionalOne' does not exist.`);
      r11.splice(0, 0, a11), o11 = n12;
    }), { invertedRelations: r11, invertedBaseEntity: o11 };
  })(e14, r10, a10);
  return { relations: a10, baseEntity: r10, invertedRelations: i10, invertedBaseEntity: s10 };
};
const Iwt = (e14, t10, n10, r10, o10) => {
  const a10 = T6(e14);
  const i10 = Lwt(t10, n10, a10);
  if (!i10) return e14;
  let s10;
  const l10 = BV.findLastIndex(i10, (e15) => e15.Id === r10[r10.length - 1].Id);
  if (l10 >= 0) s10 = a10.slice(l10 + 1);
  else {
    const e15 = ((e16, t11) => {
      let n11 = -1;
      for (let r11 = 0; r11 < e16.length && r11 < t11.length && e16[r11].Id === t11[r11].Id; r11++) n11 = r11;
      return n11;
    })(r10, i10);
    if (e15 < 0) s10 = [...o10.map((e16) => e16.FormattedName), ...a10];
    else {
      const t11 = o10.slice(0, r10.length - e15 - 1).map((e16) => e16.FormattedName);
      s10 = [...t11, ...a10.slice(e15 + 1)];
    }
  }
  return s10.join(".");
};
const _wt = (e14, t10) => {
  if (!t10 || !t10.startsWith("ReportParameters.")) return e14;
  if (t10.indexOf("DefaultValue.DataSetReference") < 0 && t10.indexOf("ValidValues.DataSetReference") < 0) return e14;
  const n10 = N1(e14);
  return n10.length > 0 ? n10[0] : e14;
};
const Vwt = (e14, t10, n10, r10, o10, a10, i10, s10) => {
  const l10 = t10.DataSets.length > 0 && t10.DataSets[0].Name === n10;
  const c10 = (((e15) => C0(e15))(t10) || []).find((e15) => e15.dataSetName === n10 || !e15.dataSetName && l10);
  if (!c10) return t10;
  const u10 = c10.descriptors.reduce((e15, { path: t11, value: l11 }) => {
    let c11 = ((e16, t12) => {
      const n11 = ((e17, n12) => {
        const r11 = w1(x1, "g");
        return Jc.replace(e17, r11, (e18) => {
          const n13 = t12(e18.simpleFieldPath || e18.complexFieldPath);
          return G1(n13);
        });
      })(e16);
      return n11;
    })(l11, (e16) => Iwt(e16, o10, a10, i10, s10));
    return c11 = Z1(c11, n10, r10), l11 !== c11 && e15.push({ descriptor: { category: "", label: "", type: "string_expr", valuePath: t11, mode: "both" }, value: _wt(c11, t11) }), e15;
  }, []);
  return u10.length > 0 ? e14(t10, u2({ path: "", descriptorValuePairs: u10 })) : t10;
};
const Rwt = (e14, t10, n10, r10, o10, a10) => {
  let i10 = n10;
  const s10 = r10 && r10.entities || {};
  const l10 = i10.DataSets.find((e15) => e15.Name === o10);
  if (!l10) throw new Error(`There is no data set with this name: ${o10}.`);
  const c10 = S6(l10);
  if (!c10) throw new Error(`There is no base entity name in this data set: ${l10.Name}.`);
  const { relations: u10, baseEntity: d10, invertedRelations: p10, invertedBaseEntity: m10 } = Hwt(s10, a10, c10);
  const h10 = ((e15, t11, n11) => {
    const r11 = e15.DataSets.map((e16) => e16.Name);
    return DG(`${t11}_${n11}`, r11, TG("dataset"));
  })(n10, o10, m10.Name);
  return i10 = Vwt(e14, i10, o10, h10, s10, d10, u10, p10), i10 = ((e15, t11, n11, r11, o11, a11) => {
    const i11 = (e16) => {
      let t12 = e16;
      const s12 = t12.Arguments.reduce((e17, t13, n12) => {
        const r12 = i11(t13);
        return r12 !== t13 ? __spreadProps(__spreadValues({}, e17), { [n12]: { $set: r12 } }) : e17;
      }, {});
      if (BV.isEmpty(s12) || (t12 = AV(t12, { Arguments: s12 })), t12.Type === R8.ATTRIBUTE) {
        const e17 = Iwt(t12.Value, n11, r11, o11, a11);
        e17 !== t12.Value && (t12 = AV(t12, { Value: { $set: e17 } }));
      }
      return t12;
    };
    const s11 = e15.DataSets.findIndex((e16) => e16.Name === t11);
    if (s11 < 0) throw Error(`Invalid dataset name: ${t11}`);
    const l11 = e15.DataSets[s11].$queryFilter;
    if (!l11) return e15;
    const c11 = i11(l11);
    return l11 !== c11 ? AV(e15, { DataSets: { [s11]: { $queryFilter: { $set: c11 } } } }) : e15;
  })(i10, o10, s10, d10, u10, p10), i10 = ((e15, t11, n11, r11, o11) => {
    const a11 = t11.DataSets.findIndex((e16) => e16.Name === n11);
    if (a11 < 0) throw new Error(`There is no data set with this name: ${n11}.`);
    const i11 = t11.DataSets[a11];
    const s11 = i11.Query.CommandText.split("\n");
    const l11 = AV(s11, { 1: { $set: `	${o11}` } }).join("\n");
    let c11 = e15(t11, i11.Name, r11);
    return c11 = AV(c11, { DataSets: { [a11]: { Query: { CommandText: { $set: l11 } }, Name: { $set: r11 } } } }), c11;
  })(t10, i10, o10, h10, m10.Name), i10;
};
const Awt = "=null";
const Owt = "UserContext.";
const Bwt = (e14, t10) => ((e15) => {
  if (!e15 || !e15.startsWith(Owt)) return "";
  const t11 = e15.slice(12);
  return t11 ? (n10 = t11) && Jc.test(n10, w1(v1)) ? `=UserContext!${t11}` : `=UserContext.GetValue("${t11}")` : "";
  var n10;
})(e14) || /* @__PURE__ */ ((e15) => t10 && "(null)" === e15 ? Awt : "")(e14) || e14 || "";
const zwt = (e14, t10, n10) => t10 ? Bwt(e14, n10) : e14 || "";
const $wt = (e14) => {
  const { DefaultValue: t10, AllowNull: n10 } = e14;
  const { Value: r10, IsSpecial: o10 } = t10 != null ? t10 : { Value: "", IsSpecial: false };
  const { DefaultValue: a10 } = w0;
  const i10 = zwt(r10, o10, n10) || (n10 ? Awt : "");
  return i10 ? AV(a10, { Values: { $set: [i10] } }) : a10;
};
const Wwt = (e14, t10, n10) => {
  const { ValidValuesDomain: r10, ValidValues: o10, AllowNull: a10, AttributeReference: i10 } = e14;
  const { init: s10, commit: l10 } = t10;
  const { ValidValues: c10 } = w0;
  return r10 === y6 ? ((e15, t11) => {
    const n11 = (e15 || []).map((e16) => {
      const n12 = zwt(e16.Value, e16.IsSpecial, t11);
      return { Value: n12, Label: e16.Label || n12 };
    });
    return AV(c10, { ParameterValues: { $set: n11 } });
  })(o10, a10) : r10 === g6 ? ((e15) => {
    if (!e15) return c10;
    const { Path: t11 } = e15;
    if (!t11) return c10;
    const [r11, ...o11] = t11.split("/");
    if (0 === o11.length) return c10;
    const a11 = n10(r11);
    if (!a11) return c10;
    let i11 = "";
    let u10 = "";
    let d10 = "";
    let p10 = a11;
    for (let e16 = 0; e16 < o11.length; e16++) {
      const t12 = o11[e16];
      if (e16 < o11.length - 1) {
        const e17 = p10.Relations.find((e18) => e18.Id === t12);
        if (!e17) return c10;
        if (F6(e17)) return c10;
        const r13 = n10(e17.RelatedEntityId);
        if (!r13) return c10;
        p10 = r13, u10 = $j(u10, e17.FormattedName);
        continue;
      }
      const r12 = p10.Attributes.find((e17) => e17.Id === t12);
      if (!r12) return c10;
      i11 = r12.Format || "", u10 = $j(u10, r12.FormattedName), d10 = r12.FormattedName;
    }
    let m10 = s10(a11.Name);
    let h10;
    if (i11) {
      const { t: e16 } = hG();
      const t12 = a11.Attributes.map((e17) => e17.FormattedName);
      const n11 = `${d10} ${e16("propertyDescriptors:labels.reportParameter.label")}`;
      h10 = { Name: t12.includes(n11) ? kG(n11, t12) : n11, Value: `=${G1(u10)}.ToString("${i11}")` }, m10 = AV(m10, { $calculatedFields: { $set: [h10] } });
    }
    l10(m10);
    const f10 = { DataSetName: m10.Name, LabelField: (h10 == null ? void 0 : h10.Name) || u10, ValueField: u10 };
    return AV(c10, { DataSetReference: { $set: f10 } });
  })(i10) : c10;
};
const jwt = (e14, t10, n10) => {
  const { PageWidth: r10, PageHeight: o10 } = e14.Page;
  const a10 = Uke(n10);
  const i10 = { width: L$.parse(r10).subtract(a10), height: L$.parse(o10).subtract(a10) };
  return oPe(e14, t10, i10);
};
const Zwt = [o2.type, l2.type];
const Gwt = (e14) => Zwt.includes(e14);
const Uwt = /^Page\.(?:Left|Top|Right|Bottom)Margin$/;
const qwt = (e14) => {
  const { type: t10, payload: n10 } = e14;
  if (!Gwt(t10)) return null;
  const { descriptor: r10, value: o10, descriptorValuePairs: a10 } = n10;
  const i10 = r10 ? [{ descriptor: r10, value: o10 }] : a10;
  const s10 = i10.every((e15) => Uwt.test(e15.descriptor.valuePath || ""));
  if (!s10) return null;
  const l10 = ((e15) => {
    const t11 = (t12) => {
      var _a2;
      return (_a2 = e15.find((e16) => e16.descriptor.valuePath === `Page.${t12}Margin`)) == null ? void 0 : _a2.value;
    };
    const [n11, r11, o11, a11] = [t11("Left"), t11("Top"), t11("Right"), t11("Bottom")];
    const i11 = {};
    return n11 && (i11.left = n11), r11 && (i11.top = r11), o11 && (i11.right = o11), a11 && (i11.bottom = a11), i11;
  })(i10);
  return H2(l10);
};
const Ywt = /^Page\.Page(?:Width|Height)$/;
const Kwt = (e14) => {
  const { type: t10, payload: n10 } = e14;
  if (!Gwt(t10)) return null;
  const { descriptor: r10, value: o10, descriptorValuePairs: a10 } = n10;
  const i10 = r10 ? [{ descriptor: r10, value: o10 }] : a10;
  const s10 = i10.every((e15) => Ywt.test(e15.descriptor.valuePath || ""));
  if (!s10) return null;
  const l10 = ((e15) => {
    const t11 = (t12) => {
      var _a2;
      return (_a2 = e15.find((e16) => e16.descriptor.valuePath === `Page.Page${t12}`)) == null ? void 0 : _a2.value;
    };
    const [n11, r11] = [t11("Width"), t11("Height")];
    const o11 = {};
    return n11 && (o11.width = n11), r11 && (o11.height = r11), o11;
  })(i10);
  return I2(l10);
};
const Xwt = Zq("", "", "length_locsize", "$place.Height", void 0, OY);
const Jwt = Zq("", "", "length_locsize", "$place.Width", void 0, OY);
const Qwt = (e14, t10, n10, r10) => {
  const o10 = nz.of(r10);
  const { reducer: a10 } = o10.of("rdlx").getDescriptor("pagesection");
  const i10 = jN(n10)(e14);
  if (!i10) throw Error("Invalid path to the section");
  const s10 = t10.add(L$.parse(i10.$place.Height));
  const l10 = a10 ? a10(i10, A5({ height: s10 })) : i10;
  return AV(e14, j0({}, n10, { $set: l10 }));
};
const eTt = (e14) => {
  const t10 = Z0.filter((t11) => e14[t11]).map((t11) => {
    return (n11 = e14[t11]) && n11.$width && L$.parseSafe(n11.$width) || L$.parseSafe(e14.Width) || G5;
    var n11;
  });
  const n10 = (r10 = t10, r10.reduce((e15, t11) => {
    return r11 = t11, (n11 = e15).greaterThan(r11) ? n11 : r11;
    var n11, r11;
  }, L$.zero)).css;
  var r10;
  return n10 !== e14.Width ? AV(e14, { Width: { $set: n10 } }) : e14;
};
const tTt = (e14, t10 = "") => {
  const n10 = ((e15) => {
    switch (e15.Type) {
      case "Continuous":
      case "dashboardsection":
        return e15;
      case "multisectionreport":
      case "dashboard": {
        const t11 = e15.ReportSections[e15.$activeSectionIndex];
        return "FixedPage" === (t11 == null ? void 0 : t11.Type) ? null : t11;
      }
      default:
        return null;
    }
  })(e14);
  if (!n10) return L$.zero;
  const r10 = (e15) => L$.parseSafe(e15);
  const { TopMargin: o10, BottomMargin: a10, PageHeight: i10 } = n10.Page;
  const { units: s10 } = r10(i10);
  const l10 = qY[s10];
  const [c10, u10, d10] = [r10(o10), r10(a10), r10(i10)];
  const p10 = n10.PageHeader && r10(n10.PageHeader.$place.Height) || L$.zero;
  const m10 = n10.PageFooter && r10(n10.PageFooter.$place.Height) || L$.zero;
  const h10 = p10.add(m10).add(c10).add(u10).add(l10).subtract(d10);
  return t10 ? h10.add(L$.parse(t10)) : h10;
};
const nTt = (e14) => (t10, n10) => ((e15, t11, n11) => {
  const { payload: { correlateWidth: r10, correlateHeight: o10 } } = t11;
  const a10 = bj(e15);
  if (!a10 || !I0(a10)) return e15;
  const { $place: { Width: i10, Height: s10 } } = a10;
  let l10 = e15;
  return r10 && (l10 = n11(l10, d2({ descriptor: Jwt, value: i10 }))), o10 && (l10 = n11(l10, d2({ descriptor: Xwt, value: s10 }))), l10;
})(t10, n10, e14);
const rTt = _V("@rdlx/multiReport/section/toggleHeader");
const oTt = _V("@rdlx/multiReport/section/toggleFooter");
const aTt = (e14) => {
  const t10 = nz.of(e14).of("rdlx");
  const n10 = (r11, o10) => {
    if (rTt.match(o10)) return ((e15) => {
      if (e15.PageHeader) return V5(AV(e15, { PageHeader: { $set: null } }), f5());
      {
        const n11 = t10.create("pagesection", void 0, "PageHeader");
        return AV(e15, { PageHeader: { $set: n11 } });
      }
    })(r11);
    if (oTt.match(o10)) return ((e15) => {
      if (e15.PageFooter) return V5(AV(e15, { PageFooter: { $set: null } }), f5());
      {
        const n11 = t10.create("pagesection", void 0, "PageFooter");
        return AV(e15, { PageFooter: { $set: n11 } });
      }
    })(r11);
    if (H2.match(o10)) {
      const { margins: t11 } = o10.payload;
      const { units: n11 } = KO.of(e14).userPreferences;
      return r11.Page.$autoPageHeight ? ((e15, { left: t12, right: n12 }, r12) => t12 || n12 ? jwt(e15, { left: t12, right: n12 }, r12) : e15)(((e15, { top: t12, bottom: n12 }) => {
        if (!t12 && !n12) return e15;
        const { Page: { PageHeight: r12, TopMargin: o11, BottomMargin: a11 } } = e15;
        let i10 = L$.parse(r12);
        return t12 && (i10 = i10.subtract(L$.parse(o11)).add(L$.parse(t12))), n12 && (i10 = i10.subtract(L$.parse(a11)).add(L$.parse(n12))), AV(e15, { Page: { PageHeight: { $set: i10.css }, TopMargin: { $set: t12 || o11 }, BottomMargin: { $set: n12 || a11 } } });
      })(r11, t11), t11, n11) : jwt(r11, t11, n11);
    }
    if (I2.match(o10)) {
      const { pageSize: t11 } = o10.payload;
      const { units: n11 } = KO.of(e14).userPreferences;
      return ((e15, t12, n12) => {
        const { LeftMargin: r12, TopMargin: o11, RightMargin: a11, BottomMargin: i10 } = e15.Page;
        const s10 = Uke(n12);
        const l10 = { width: L$.parse(r12).add(L$.parse(a11)).add(s10), height: L$.parse(o11).add(L$.parse(i10)).add(s10) };
        return uPe(e15, t12, l10);
      })(r11.Page.$autoPageHeight && t11.height ? AV(r11, { Page: { $autoPageHeight: { $set: false } } }) : r11, t11, n11);
    }
    if (_2.match(o10)) {
      const { height: e15 } = o10.payload;
      if (L$.isValidString(e15) && L$.parse(e15).greaterThan(L$.zero)) return n10(r11, I2({ height: e15 }));
      const t11 = jZe(r11);
      return AV(r11, { Page: { $autoPageHeight: { $set: true }, PageHeight: { $set: t11.css } } });
    }
    if (XG.match(o10) || KG.match(o10) || eU.match(o10)) {
      let e15 = r11;
      if (K7(o10)) {
        if (j7.some((e16) => rj(r11[e16])) || rj(r11)) {
          const t11 = ((e16) => {
            let t12;
            let n11 = null;
            return j7.forEach((r12) => {
              var _a2;
              if (n11 && rj(n11)) return;
              let o11 = -1;
              const a11 = (((_a2 = e16[r12]) == null ? void 0 : _a2.ReportItems) || []).find((e17, t13) => "contentplaceholder" === e17.Type && (o11 = t13, true));
              const i10 = rj(e16[r12]);
              const s10 = rj(a11);
              a11 && (!n11 || s10 || i10) && (n11 = a11, t12 = { sectionType: r12, index: o11 });
            }), t12;
          })(r11);
          if (t11) {
            const { sectionType: n11, index: r12 } = t11;
            return e15 = V5(e15, c5(`${n11}.ReportItems.${r12}`, "contentplaceholder")), e15 = Gye(e15, n5, o10), e15;
          }
          return r11;
        }
      }
      return rj(r11) && (e15 = V5(e15, c5("Body", "section"))), e15 = Gye(e15, n5, o10), eTt(e15);
    }
    if (YG.match(o10)) {
      const { delta: e15 } = o10.payload;
      const t11 = L$.isZeroLike(e15 && e15.x);
      const n11 = L$.isZeroLike(e15 && e15.y);
      if (t11 && n11) return r11;
      const a11 = eTt(Gye(r11, n5, o10));
      if (!n11) {
        const t12 = tTt(a11);
        if (t12.greaterThan(L$.zero)) {
          const n12 = L$.parse(e15.y).subtract(t12).normalize();
          if (n12.equal(L$.zero)) return r11;
          const a12 = AV(o10, { payload: { delta: { y: { $set: n12.css } } } });
          return eTt(Gye(r11, n5, a12));
        }
      }
      return a11;
    }
    const a10 = Gye(r11, n5, o10);
    return a10 === r11 ? a10 : eTt(a10);
  };
  return /* @__PURE__ */ function(e15) {
    return (t11, n11) => {
      const r11 = e15(t11, n11);
      if (!r11.Page.$autoPageHeight) return r11;
      const { Page: { PageHeight: o10 } } = r11;
      const a10 = jZe(r11).css;
      return a10 === o10 ? r11 : AV(r11, { Page: { PageHeight: { $set: a10 } } });
    };
  }((r10 = n10, (e15, t11) => {
    const n11 = r10(e15, t11);
    if (!Zut(n11)) throw W0();
    return n11;
  }));
  var r10;
};
const iTt = (e14, t10, n10, r10) => {
  const o10 = [];
  return C3(e14, x3((e15, a10, i10, s10) => {
    const l10 = s10 == null ? void 0 : s10.path;
    if (a10 && l10 && a10.hasOwnProperty(t10) && a10[t10] === n10) {
      const e16 = r10(a10, l10);
      e16 && o10.push(e16);
    }
    return {};
  })), o10;
};
const sTt = (e14, t10, n10, r10) => {
  const o10 = iTt(e14, t10, n10, (e15, n11) => ({ descriptor: { valuePath: `${n11}.${t10}` }, value: r10 }));
  return o10.length ? Q2(e14, u2({ path: "", descriptorValuePairs: o10 })) : e14;
};
const lTt = (e14, t10, n10) => {
  if (t10 === n10) return e14;
  let r10 = e14;
  if ("fixedpagereport" === e14.Type && e14.DataSetName === t10 && (r10 = AV(r10, { DataSetName: { $set: n10 } })), !e14.ReportParameters.length) return r10;
  const o10 = { Values: [], DataSetReference: { DataSetName: "", ValueField: "", LabelField: "" } };
  const a10 = { ParameterValues: [], DataSetReference: { DataSetName: "", LabelField: "", ValueField: "" }, OrderBy: { Condition: "None", Direction: "Ascending" } };
  const i10 = "" === n10;
  return r10.ReportParameters.forEach((e15, s10) => {
    const { DefaultValue: l10, ValidValues: c10 } = e15;
    const u10 = {};
    l10.DataSetReference.DataSetName === t10 && (u10.DefaultValue = i10 ? o10 : AV(l10, { DataSetReference: { DataSetName: { $set: n10 } } })), c10.DataSetReference.DataSetName === t10 && (u10.ValidValues = i10 ? a10 : AV(c10, { DataSetReference: { DataSetName: { $set: n10 } } })), Object.entries(u10).length && (r10 = AV(r10, { ReportParameters: { [s10]: { $set: __spreadValues(__spreadValues({}, e15), u10) } } }));
  }), r10;
};
const cTt = (e14, { payload: { dataSet: t10 } }) => {
  let n10 = e14;
  return n10 = sTt(n10, "DataSetName", t10.Name, ""), n10 = lTt(n10, t10.Name, ""), n10 = ((e15, t11) => {
    const n11 = (t12) => [].concat(...e15.DataSets.map((e16) => {
      const r11 = vK(e16);
      return null != r11 && r11.dataSetName === t12 ? [e16.Name, ...n11(e16.Name)] : [];
    }));
    const r10 = [t11.Name, ...n11(t11.Name)];
    const o10 = SK((e15.DataSets || []).filter((e16) => r10.indexOf(e16.Name) < 0));
    const a10 = e15.DataSources || [];
    return AV(e15, { $merge: { DataSources: a10, DataSets: o10 } });
  })(n10, t10), n10;
};
const uTt = (e14, t10, n10 = -1) => {
  const r10 = e14.DataSets || [];
  const o10 = n10 >= 0 ? r10.filter((e15, t11) => t11 !== n10) : r10;
  const a10 = zV.merge({}, pX, t10);
  const i10 = a10.Query.QueryParameters || [];
  const s10 = e14.ReportParameters || [];
  const l10 = s10.map((e15) => e15.Name);
  const c10 = [];
  const u10 = [];
  const d10 = [];
  i10.forEach((e15) => {
    if (e15.Value) return void d10.push(e15);
    const t11 = ((e16, t12, n12) => {
      const r11 = E0(e16.Name);
      const o11 = t12.findIndex((e17) => e17.Name === r11);
      if (o11 < 0) return null;
      const a11 = t12[o11];
      const i11 = ((e17, t13) => {
        var _a2, _b2, _c2;
        return e17.DataType === ((_a2 = t13.$legacy) == null ? void 0 : _a2.DbType) && e17.MultiValue === ((_b2 = t13.$legacy) == null ? void 0 : _b2.IsMultiValued) && e17.Nullable === ((_c2 = t13.$legacy) == null ? void 0 : _c2.IsNullable);
      })(a11, e16);
      if (!i11) return null;
      const s11 = n12.some((e17) => e17.Query.QueryParameters.map((e18) => e18.Value).some((e18) => ((e19, t13) => {
        if (!e19 || !e19.startsWith("=")) return false;
        const n13 = `Parameters!${t13}.Value`;
        return e19.indexOf(n13) > 0;
      })(e18, a11.Name)));
      return s11 ? null : { rp: a11, idx: o11 };
    })(e15, s10, o10);
    if (t11) {
      const { rp: n12, idx: r11 } = t11;
      d10.push(u3(e15.Name, n12.Name));
      const o11 = e15.DefaultValue && e15.DefaultValue.Values || [];
      if (!zV.isEqual(n12.DefaultValue.Values, o11)) {
        const e16 = AV(n12, { DefaultValue: { Values: { $set: o11 } } });
        u10.push({ rp: e16, idx: r11 });
      }
      return;
    }
    const n11 = E0(e15.Name, l10);
    l10.push(n11), c10.push(d3(n11, e15)), d10.push(u3(e15.Name, n11));
  });
  const p10 = AV(a10, { Query: { QueryParameters: { $set: d10 } } });
  let m10 = e14;
  return u10.forEach((e15) => {
    const { rp: t11, idx: n11 } = e15;
    m10 = AV(m10, { ReportParameters: { $splice: [[n11, 1, t11]] } });
  }), m10 = c10.length > 0 ? AV(m10, { ReportParameters: { $push: c10 } }) : m10, { preparedReport: m10, preparedDataSet: p10 };
};
const dTt = (e14, { payload: { dataSetName: t10, dataSet: n10 } }) => {
  const r10 = (e14.DataSets || []).findIndex((e15) => e15.Name === t10);
  if (r10 < 0) throw z0(`Report doesn't contain data set named '${t10}'`);
  const { preparedReport: o10, preparedDataSet: a10 } = uTt(e14, n10, r10);
  let i10 = AV(o10, { DataSets: { $splice: [[r10, 1, a10]] } });
  if (t10 !== n10.Name) {
    let e15 = i10.DataSets;
    e15 = ((e16, t11, n11) => {
      const r11 = {};
      return e16.forEach((e17, o11) => {
        const a11 = vK(e17);
        (a11 == null ? void 0 : a11.dataSetName) === n11 && (r11[[o11]] = { Query: { DataSourceName: { $set: bK(t11, a11.fieldName) } } });
      }), SK(AV(e16, r11));
    })(e15, n10.Name, t10), e15 = SK(e15), i10 = AV(i10, { DataSets: { $set: e15 } });
  }
  return i10;
};
const pTt = (e14, { payload: { dataSet: t10 } }) => {
  if (q7(e14)) {
    const n11 = t10.Query.DataSourceName;
    if (e14.DataSources.find((e15) => e15.Name === n11 && J7(e15))) return e14;
  }
  const { preparedReport: n10, preparedDataSet: r10 } = uTt(e14, t10);
  return AV(n10, { DataSets: { $push: [r10] } });
};
const mTt = (e14, { payload: { dataSources: t10, dataSets: n10 } }) => {
  if (0 === t10.length && 0 === n10.length) return e14;
  const r10 = t10.reduce((e15, t11) => {
    const n11 = e15.find((e16) => e16.Name === t11.Name);
    if (n11 && !zV.isEqual(n11, t11)) throw new Error(`Cannot add different data sources having the same name - '${t11.Name}'!`);
    return n11 || e15.push(t11), e15;
  }, []);
  let o10 = e14;
  const { DataSources: a10 = [], DataSets: i10 = [] } = o10;
  const s10 = {};
  const l10 = (e15, t11) => {
    if (!!MX()) return false;
    const n11 = t11.findIndex((t12) => zV.isEqual(zV.omit(t12, "Name"), zV.omit(e15, "Name")));
    if (n11 >= 0) {
      const r11 = t11[n11];
      return s10[e15.Name] = r11.Name, true;
    }
    return false;
  };
  r10.forEach((e15) => {
    const t11 = a10.findIndex((t12) => t12.Name === e15.Name);
    if (t11 >= 0) {
      const n11 = a10[t11];
      if (zV.isEqual(n11, e15)) return;
      if (l10(e15, a10)) return;
      const r11 = kG(e15.Name, a10.map((e16) => e16.Name));
      s10[e15.Name] = r11;
      const i11 = AV(e15, { Name: { $set: r11 } });
      o10 = hTt(o10, Y0({ datasource: i11 }));
    } else l10(e15, a10) || (o10 = hTt(o10, Y0({ datasource: e15 })));
  }), n10.forEach((e15) => {
    let t11 = e15;
    const n11 = i10.findIndex((t12) => t12.Name === e15.Name);
    if (n11 >= 0) {
      if (zV.isEqual(e15, i10[n11])) return;
      const r12 = kG(e15.Name, i10.map((e16) => e16.Name));
      t11 = __spreadProps(__spreadValues({}, t11), { Name: r12 });
    }
    const r11 = e15.Query && e15.Query.DataSourceName && s10[e15.Query.DataSourceName];
    r11 && (t11 = AV(t11, { Query: { DataSourceName: { $set: r11 } } })), o10 = pTt(o10, G0({ dataSet: t11 }));
  });
  const c10 = SK(o10.DataSets);
  return ((e15, t11) => {
    e15.forEach((e16) => {
      var _a2;
      if (!e16.$parentReference) {
        const n11 = (_a2 = e16 == null ? void 0 : e16.Query.DataSourceName) != null ? _a2 : null;
        const r11 = t11.find(({ Name: e17 }) => e17 === n11);
        if (!r11) throw new Error(`There is no parent data source '${n11}' for data set '${e16.Name}'`);
      }
    });
  })(c10, o10.DataSources), c10.forEach((e15) => {
    o10 = dTt(o10, q0({ dataSetName: e15.Name, dataSet: e15 }));
  }), o10;
};
const hTt = (e14, { payload: { datasource: t10 } }) => {
  if (!t10) throw z0("Invalid argument in ADD_DATASOURCE reducer - datasource");
  return e14.DataSources.some((e15) => e15.Name === t10.Name) ? e14 : AV(e14, { DataSources: { $push: [t10] } });
};
const fTt = (e14, t10, n10, r10) => {
  const o10 = ((e15, t11, n11, r11) => {
    const o11 = (e16) => e16 && e16.Source === t11 && e16.Value === n11 || false;
    const a10 = (e16, t12) => ({ descriptor: { valuePath: `${e16}.${t12}` }, value: r11 });
    const i10 = [];
    return C3(e15, x3((e16, t12, n12, r12) => {
      var _a2;
      if (!t12 || !r12) return;
      const { path: s10 } = r12;
      if (!s10) return;
      if ("image" === t12.Type && o11(t12)) return void i10.push(a10(s10, "Value"));
      const l10 = ((_a2 = t12.Style) == null ? void 0 : _a2.BackgroundImage) || null;
      l10 && o11(l10) && i10.push(a10(s10, "Style.BackgroundImage.Value"));
    })), i10;
  })(e14, t10, n10, r10);
  return o10.length > 0 ? Q2(e14, u2({ path: "", descriptorValuePairs: o10 })) : e14;
};
const gTt = (e14, { payload: { name: t10, imageData: n10, mimeType: r10 } }) => {
  const o10 = (e14.EmbeddedImages || []).map((e15) => e15.Name);
  const a10 = ((e15, t11) => {
    if (PG(e15, t11)) return e15;
    let n11;
    let r11 = 0;
    do {
      n11 = `${e15} (${++r11})`;
    } while (!PG(n11, t11));
    return n11;
  })(t10, o10);
  return AV(e14, { EmbeddedImages: { $push: [{ Name: a10, ImageData: n10, MIMEType: r10 }] } });
};
const yTt = (e14, t10, n10, r10) => {
  const o10 = e14.Layers.findIndex((e15) => t10 === e15.Name && e15[n10] !== r10);
  return o10 >= 0 ? AV(e14, { Layers: { [o10]: { [n10]: { $set: r10 } } } }) : e14;
};
const vTt = (e14) => (t10, { payload: { index: n10 } }) => {
  const { Layers: r10, $currentLayerName: o10 } = t10;
  if (n10 < 1 && n10 >= r10.length) throw z0("Invalid layer index to remove");
  const a10 = r10[n10].Name;
  let i10 = ((e15, t11, n11) => {
    let r11 = e15;
    const o11 = (e15.$index && e15.$index.NamedItems || []).reduce((e16, n12) => {
      if (n12.type && n12.name && n12.layerName === t11) {
        const t12 = e16.some((e17) => e17.leftKey < n12.leftKey && e17.rightKey > n12.rightKey);
        if (!t12) return [...e16, n12];
      }
      return e16;
    }, []);
    return o11.length && (r11 = V5(r11, h5(o11.map((e16) => e16.name))), r11 = n11(r11, JG())), r11;
  })(t10, a10, e14);
  i10.Layers.some((e15) => aj(e15)) && (i10 = V5(i10, c5("", i10.Type)));
  let s10 = { Layers: { $splice: [[n10, 1]] } };
  return a10 === o10 && (s10 = __spreadProps(__spreadValues({}, s10), { $currentLayerName: { $set: "default" } })), AV(i10, s10);
};
const bTt = (e14, { payload: { layerName: t10, propertyName: n10, value: r10 } }) => {
  const o10 = yTt(e14, t10, n10, r10);
  return o10 !== e14 ? ((e15, t11) => {
    const n11 = iTt(e15, "LayerName", t11, (t12, n12) => ({ descriptor: { valuePath: `${n12}.$layerInfo` }, value: F3(e15.Layers, t12.LayerName) }));
    return n11.length ? Q2(e15, u2({ path: "", descriptorValuePairs: n11 })) : e15;
  })(o10, t10) : e14;
};
const STt = (e14, { payload: { layerName: t10 } }) => ((e15, t11) => {
  const n10 = yj(e15);
  if (!n10.length) return e15;
  const r10 = e15.$index && e15.$index.NamedItems || [];
  const o10 = r10.filter((e16) => n10.some((t12) => t12.Name === e16.name)) || [];
  const a10 = [];
  o10.forEach((e16) => {
    const t12 = r10.filter((t13) => e16.leftKey < t13.leftKey && t13.rightKey < e16.rightKey && t13.level > e16.level) || [];
    a10.push(e16.name, ...t12.map((e17) => e17.name));
  });
  const i10 = [];
  return C3(e15, x3((n11, r11, o11, s10) => {
    const { path: l10 } = s10;
    return r11.LayerName && a10.includes(r11.Name) && i10.push({ descriptor: { valuePath: `${l10}.LayerName` }, value: t11 }, { descriptor: { valuePath: `${l10}.$layerInfo` }, value: F3(e15.Layers, t11) }), {};
  })), i10.length ? Q2(e15, u2({ path: "", descriptorValuePairs: i10 })) : e15;
})(e14, t10);
const CTt = (e14) => (t10, { payload: n10 }) => {
  const { dataSource: r10, dataSets: o10, getEntityByName: a10, getEntityById: i10 } = n10;
  const s10 = t10.DataSets.map((e15) => e15.Name);
  const l10 = t10.ReportParameters.map((e15) => e15.Name);
  const c10 = (e15, t11) => {
    const n11 = t11 || e15.Name;
    const r11 = DG(n11, s10, TG("dataset"));
    return s10.push(r11), e15.Name !== r11 ? AV(e15, { Name: { $set: r11 } }) : e15;
  };
  const u10 = [];
  const d10 = o10.reduce((e15, t11) => {
    const n11 = (e16, t12) => (e16.push(c10(t12)), e16);
    const o11 = S6(t11) || "";
    const s11 = a10(o11);
    if (!s11) return n11(e15, t11);
    const d11 = s11.Parameters.filter((e16) => !e16.Value);
    if (0 === d11.length) return n11(e15, t11);
    const p11 = (e16, t12) => ({ init: (e17) => {
      const n12 = ((e18, t13, n13, r11) => {
        if (!e18) return null;
        const o12 = v6(n13);
        if (!o12) return null;
        const a11 = e18;
        const i11 = (r11 || []).map((e19) => e19.Name);
        let s12 = a11;
        let l11 = 1;
        for (; i11.includes(s12); ) s12 = `${a11}${l11++}`;
        return { Name: s12, Query: { DataSourceName: o12.Name, CommandText: `from
	${e18}
select`, CommandType: "Text", QueryParameters: t13, Timeout: 0 }, Fields: [], $parentReference: null, $childrenReferences: [], $calculatedFields: [], $queryFilter: null, Filters: { Type: "filter", operator: "and", items: [] }, AccentSensitivity: "Auto", CaseSensitivity: "Auto", Collation: "", KanatypeSensitivity: "Auto", WidthSensitivity: "Auto" };
      })(e17, [], [r10], []);
      return c10(n12, `${e17}_${t12}`);
    }, commit: (t13) => {
      e16.push(t13);
    } });
    const m10 = [];
    const h10 = d11.map((e16) => {
      const { Id: t12, Name: n12, DefaultValue: r11, ValidValuesDomain: o12, ValidValues: a11, AttributeReference: s12, AllowNull: c11, DataType: d12, Prompt: h11 } = e16;
      const f11 = ((e17) => {
        const t13 = DG(e17, l10, TG("reportParameter"));
        return l10.push(t13), t13;
      })(n12);
      const g10 = { Nullable: !!c11, DataType: d12, Prompt: h11 || f11, DefaultValue: $wt({ DefaultValue: r11, AllowNull: c11 }), ValidValues: Wwt({ ValidValuesDomain: o12, ValidValues: a11, AllowNull: c11, AttributeReference: s12 }, p11(m10, f11), i10) };
      const y10 = T0(f11, 0, g10);
      return u10.push(Q0({ param: y10 })), { Name: t12, Value: `=Parameters!${y10.Name}.Value` };
    });
    const f10 = n11(e15, AV(t11, { Query: { QueryParameters: { $set: h10 } } }));
    return f10.push(...m10), f10;
  }, []);
  const p10 = [J0({ dataSources: [r10], dataSets: d10 }), ...u10].reduce((t11, n11) => e14(t11, n11), t10);
  return p10;
};
const xTt = (e14, t10, n10, r10 = false) => {
  let o10 = r10 ? ((e15, t11, n11) => {
    const r11 = (C0(e15) || []).reduce((e16, r12) => {
      const { descriptors: o11 } = r12;
      const a10 = (o11 || []).reduce((e17, r13) => {
        const { value: o12, path: a11 } = r13;
        const i10 = "string" == typeof o12 ? Z1(o12, t11, n11) : o12;
        return o12 !== i10 && e17.push({ descriptor: { valuePath: a11 }, value: i10 }), e17;
      }, []);
      return e16.push(...a10), e16;
    }, []);
    return r11.length ? Q2(e15, u2({ path: "", descriptorValuePairs: r11 })) : e15;
  })(e14, t10, n10) : e14;
  return o10 = lTt(o10, t10, n10), o10 = sTt(o10, "DataSetName", t10, n10), o10;
};
const wTt = (e14, t10) => {
  if (b6(e14)) return false;
  if ((e14.DataSets || []).length < 2) return false;
  const { dataSet: n10, dataSetName: r10, fieldInfo: o10, descriptor: a10 } = t10 && t10.payload || {};
  const i10 = n10 || r10;
  if (!i10) return false;
  const s10 = (a10 == null ? void 0 : a10.valuePath) || "";
  const l10 = (o10 == null ? void 0 : o10.parentDataSetName) || "";
  let c10 = true;
  let u10 = null;
  return fj(e14, (e15) => {
    if (!e15 || !function(e16) {
      return q$.includes(e16);
    }(e15.Type)) return;
    const t11 = !e15.DataSetName || e15.DataSetName === i10 || u10 === l10 && h0(s10);
    c10 = !t11, u10 = e15.DataSetName;
  }), c10;
};
const TTt = (e14, t10) => {
  const n10 = wTt(e14, t10);
  const r10 = n10 ? AV(t10, { payload: { withScope: { $set: n10 } } }) : t10;
  return rj(e14) ? n5(e14, r10) : Gye(e14, n5, r10);
};
const ETt = (e14) => (e14.ReportSections || []).filter(M0).map((e15) => e15.Body.ReportItems).flat().filter(rj);
const FTt = [JG.type];
const MTt = (e14) => FTt.indexOf(e14) >= 0;
function kTt(e14) {
  return (t10, n10) => {
    const r10 = e14 ? e14(t10, n10) : t10;
    return r10 !== t10 && MTt(n10 && n10.type) ? V5(r10, f5()) : r10;
  };
}
const PTt = (e14) => {
  const t10 = aTt && aTt(e14);
  const n10 = (r10, o10) => {
    if (J0.match(o10)) return mTt(r10, o10);
    if (G0.match(o10)) return pTt(r10, o10);
    if (U0.match(o10)) return cTt(r10, o10);
    if (q0.match(o10)) return dTt(r10, o10);
    if (Y0.match(o10)) return hTt(r10, o10);
    if (X0.match(o10)) return ((e15, { payload: { name: t11, dataSource: n11 } }) => {
      if (!t11) throw z0(`Invalid payload for SET_DATA_SOURCE action: name=${t11}`);
      if (!n11) throw z0(`Invalid payload for SET_DATA_SOURCE action: dataSource=${n11}`);
      const r11 = e15.DataSources || [];
      const o11 = r11.findIndex((e16) => e16.Name === t11);
      if (o11 < 0) throw z0(`Report doesn't contain a data source named ${t11}.`);
      const a11 = r11.map((e16) => e16.Name);
      a11.splice(o11, 1);
      const i11 = a11.includes(n11.Name) ? kG(n11.Name, a11) : n11.Name;
      const s10 = n11.Name !== i11 ? AV(n11, { Name: { $set: i11 } }) : n11;
      const l10 = { DataSources: { $splice: [[o11, 1, s10]] } };
      if (t11 === s10.Name) return AV(e15, l10);
      const c10 = e15.DataSets || [];
      const u10 = {};
      return c10.forEach((e16, n12) => {
        e16.Query.DataSourceName === t11 && (u10[n12] = { Query: { DataSourceName: { $set: s10.Name } } });
      }), zV.isEmpty(u10) || Object.assign(l10, { DataSets: u10 }), AV(e15, l10);
    })(r10, o10);
    if (K0.match(o10)) return ((e15, { payload: { dataSource: t11 } }) => {
      if (!t11 || !t11.Name) throw z0(`Invalid payload for REMOVE_DATA_SOURCE action: dataSource=${t11}`);
      const { Name: n11 } = t11;
      const r11 = (e15.DataSources || []).findIndex((e16) => e16.Name === n11);
      if (r11 < 0) throw z0(`Report doesn't contain a data source named ${n11}.`);
      const o11 = (e15.DataSets || []).filter((e16) => e16.Query.DataSourceName === n11);
      let a11 = AV(e15, { DataSources: { $splice: [[r11, 1]] } });
      return o11.length > 0 && (a11 = o11.reduce((e16, t12) => cTt(e16, U0({ dataSet: t12 })), a11)), a11;
    })(r10, o10);
    if (Q0.match(o10)) return AV(r10, { ReportParameters: { $push: [o10.payload.param] } });
    if (e22.match(o10)) return AV(r10, { ReportParameters: { $set: [...r10.ReportParameters, ...o10.payload.params] } });
    if (t2.match(o10)) return AV(r10, { ReportParameters: { $splice: [[o10.payload.index, 1]] } });
    if (n2.match(o10)) return ((e15, { payload: { index: t11, direction: n11 } }) => {
      const r11 = e15.ReportParameters[t11];
      if ("up" === n11) {
        const n12 = e15.ReportParameters[t11 - 1];
        return AV(e15, { ReportParameters: { $splice: [[t11 - 1, 2, r11, n12]] } });
      }
      const o11 = e15.ReportParameters[t11 + 1];
      return AV(e15, { ReportParameters: { $splice: [[t11, 2, o11, r11]] } });
    })(r10, o10);
    if (C2.match(o10)) return (/* @__PURE__ */ ((e15) => (t11) => {
      const n11 = nz.of(e15);
      const r11 = kG(TG("layer"), t11.Layers.map((e16) => e16.Name));
      const o11 = n11.create("layer", r11);
      return AV(t11, { Layers: { $push: [o11] }, $currentLayerName: { $set: r11 } });
    })(e14))(r10, o10);
    if (x2.match(o10)) return vTt(n10)(r10, o10);
    if (M2.match(o10)) return (a10 = n10, (e15, { payload: { layerName: t11, newLayerName: n11 } }) => {
      let r11 = e15;
      return r11 = yTt(r11, t11, "Name", n11), r11 = a10(r11, F2({ propertyName: "LayerName", oldValue: t11, newValue: n11 })), r11.$currentLayerName === t11 && (r11 = a10(r11, w2({ layerName: n11 }))), r11;
    })(r10, o10);
    var a10;
    if (w2.match(o10)) return ((e15, { payload: { layerName: t11 } }) => AV(e15, { $currentLayerName: { $set: t11 } }))(r10, o10);
    if (T2.match(o10)) return bTt(r10, o10);
    if (E2.match(o10)) return STt(r10, o10);
    if (r2.match(o10)) return (/* @__PURE__ */ ((e15) => (t11, { payload: { delta: n11, path: r11 } }) => {
      if ("Continuous" !== t11.Type && "multisectionreport" !== t11.Type) return t11;
      if (n11.equal(L$.zero)) return t11;
      const o11 = tTt(t11, n11);
      if (o11.greaterThan(L$.zero)) {
        const a11 = n11.subtract(o11).normalize();
        return a11.equal(L$.zero) ? t11 : Qwt(t11, a11, r11, e15);
      }
      return Qwt(t11, n11, r11, e15);
    })(e14))(r10, o10);
    if (YG.match(o10)) return ((e15, t11) => {
      const { payload: { delta: n11 } } = t11;
      const r11 = L$.isZeroLike(n11 && n11.x);
      const o11 = L$.isZeroLike(n11 && n11.y);
      if (r11 && o11) return e15;
      const a11 = eTt(Gye(e15, n5, t11));
      if (!o11) {
        const r12 = tTt(a11);
        if (r12.greaterThan(L$.zero)) {
          const o12 = L$.parse(n11.y).subtract(r12).normalize();
          if (o12.equal(L$.zero)) return e15;
          const a12 = AV(t11, { payload: { delta: { y: { $set: o12.css } } } });
          return eTt(Gye(e15, n5, a12));
        }
      }
      return a11;
    })(r10, o10);
    if (f2.match(o10)) {
      const { themeId: e15 } = o10.payload;
      return AV(r10, { Themes: { 0: { $set: e15 ? SX(e15) : "" } } });
    }
    if (m2.match(o10)) return AV(r10, { Themes: { $set: [] } });
    if (F2.match(o10)) {
      const { propertyName: e15, oldValue: t11, newValue: n11 } = o10.payload;
      if (t11 === n11) return r10;
      return "DataSetName" === e15 ? xTt(r10, t11, n11, true) : sTt(r10, e15, t11, n11);
    }
    if (O5.match(o10) || B5.match(o10)) return TTt(r10, o10);
    if (o2.match(o10) || l2.match(o10)) {
      let e15 = r10;
      const n11 = qwt(o10);
      if (n11) return Vj(e15, t10, n11);
      const a11 = Kwt(o10);
      if (a11) return Vj(e15, t10, a11);
      return o2.match(o10) && "Name" === o10.payload.descriptor.valuePath && (e15 = ((e16, t11) => {
        const n12 = ETt(e16);
        if (0 === n12.length) return e16;
        const r11 = e16.ReportParts.findIndex((e17) => e17.ReportItemName === n12[0].Name);
        return -1 === r11 ? e16 : AV(e16, { ReportParts: { [r11]: { ReportItemName: { $set: t11.payload.value } } } });
      })(e15, o10)), TTt(e15, o10);
    }
    if (c2.match(o10)) return J2(r10, o10);
    if (u2.match(o10)) return Q2(r10, o10);
    if (p2.match(o10)) {
      const { actions: e15 } = o10.payload;
      if (!Array.isArray(e15)) throw new Error("Non-array structure of transaction actions");
      return e15.reduce((e16, t11) => n5(e16, t11), r10);
    }
    if (A2.match(o10)) return nTt(n10)(r10, o10);
    if (k2.match(o10)) return gTt(r10, o10);
    if (N2.match(o10)) return ((e15, { payload: { index: t11, newName: n11 } }) => {
      const r11 = e15.EmbeddedImages[t11];
      if (!r11) return e15;
      const o11 = AV(e15, { EmbeddedImages: { [t11]: { Name: { $set: n11 } } } });
      return fTt(o11, "Embedded", r11.Name, n11);
    })(r10, o10);
    if (P2.match(o10)) return ((e15, { payload: { index: t11 } }) => {
      const n11 = e15.EmbeddedImages[t11];
      if (!n11) return e15;
      const r11 = AV(e15, { EmbeddedImages: { $splice: [[t11, 1]] } });
      return fTt(r11, "Embedded", n11.Name, "");
    })(r10, o10);
    if (O$.match(o10)) return CTt(n10)(r10, o10);
    if (B$.match(o10)) return ((e15, { payload: { semanticDataSet: t11 } }) => {
      if (t11) {
        const n11 = e15.DataSets.findIndex((e16) => e16.Name === t11.Name);
        if (n11 >= 0) {
          let r11 = e15;
          return r11 = sTt(r11, "DataSetName", t11.Name, ""), r11 = lTt(r11, t11.Name, ""), r11 = AV(r11, { DataSets: { $splice: [[n11, 1]] } }), r11;
        }
      }
      return e15;
    })(r10, o10);
    if (z$.match(o10)) {
      const { semanticModel: e15, dataSetName: t11, path: a11 } = o10.payload;
      return Rwt(n10, xTt, r10, e15, t11, a11);
    }
    if (O2.match(o10)) return ((t11, { payload: { sectionType: n11 = "Continuous", index: r11 } }) => {
      const o11 = nz.of(e14).create(n11, FG(TG(n11)));
      return AV(t11, void 0 === r11 ? { ReportSections: { $push: [o11] }, $activeSectionIndex: { $set: t11.ReportSections.length } } : { ReportSections: { $splice: [[r11, 0, o11]] }, $activeSectionIndex: { $set: r11 } });
    })(r10, o10);
    if (B2.match(o10)) return ((e15, t11) => {
      if (1 === e15.ReportSections.length) return e15;
      const { payload: { index: n11 } } = t11;
      const r11 = n11 != null ? n11 : e15.$activeSectionIndex;
      return V5(AV(e15, { ReportSections: { $splice: [[r11, 1]] } }), c5(`ReportSections.${Math.max(0, r11 - 1)}`));
    })(r10, o10);
    if (z2.match(o10)) return ((e15, { payload: { fromIndex: t11, toIndex: n11 } }) => AV(e15, { $activeSectionIndex: { $set: n11 }, ReportSections: { $splice: [[t11, 1], [n11, 0, e15.ReportSections[t11]]] } }))(r10, o10);
    if ($2.match(o10)) return ((e15, { payload: { index: t11 } }) => {
      var _a2, _b2;
      const n11 = (_b2 = (_a2 = e15.$index) == null ? void 0 : _a2.NamedItems) != null ? _b2 : [];
      const r11 = e15.ReportSections[t11];
      const o11 = lj(zG(r11, n11));
      const a11 = [...e15.ReportParts];
      const i11 = r11.Body.ReportItems;
      const s10 = o11.Body.ReportItems;
      return i11.length && s10.length && i11.forEach(({ Name: e16, ZIndex: t12 }) => {
        const n12 = a11.findIndex((t13) => t13.ReportItemName === e16);
        const r12 = s10.find(({ ZIndex: e17 }) => e17 === t12);
        if (-1 !== n12 && r12) {
          const e17 = __spreadProps(__spreadValues({}, a11[n12]), { Name: FG("ReportPart"), ReportItemName: r12.Name });
          a11.push(e17);
        }
      }), AV(e15, { $activeSectionIndex: { $set: t11 + 1 }, ReportSections: { $splice: [[t11 + 1, 0, o11]] }, ReportParts: { $set: a11 } });
    })(r10, o10);
    if (W2.match(o10)) return ((e15, { payload: { index: t11 } }) => {
      const n11 = e15.ReportSections[t11];
      const r11 = dpt(n11.Visibility.Hidden);
      return AV(e15, { ReportSections: { [t11]: { Visibility: { Hidden: { $set: r11 ? "False" : "True" } } } } });
    })(r10, o10);
    if (j2.match(o10)) return ((e15) => {
      const t11 = ETt(e15);
      const n11 = e15.ReportParts.map((e16) => e16.Name);
      const r11 = t11.map((e16) => {
        const t12 = kG(TG("reportPart"), n11);
        return n11.push(t12), __spreadProps(__spreadValues({}, MHe), { Name: t12, ReportItemName: e16.Name, SizeMode: xWe(e16.Type) });
      });
      return AV(e15, { ReportParts: { $push: r11 } });
    })(r10);
    if (JG.match(o10) && "multisectionreport" === r10.Type) {
      const e15 = ((e16) => {
        const t11 = ETt(e16);
        if (0 === t11.length) return e16;
        const n11 = e16.ReportParts.filter((e17) => !t11.find((t12) => t12.Name === e17.ReportItemName));
        return AV(e16, { ReportParts: { $set: n11 } });
      })(r10);
      return Vj(e15, t10, o10);
    }
    if (_2.match(o10)) return Vj(r10, t10, o10);
    if (XG.match(o10) || KG.match(o10) || tU.match(o10)) {
      let e15 = r10;
      if ("multisectionreport" === r10.Type) {
        if ((rj(r10) || r10.Layers.some((e16) => rj(e16))) && (e15 = K7(o10) ? V5(e15, c5(`ReportSections.${r10.$activeSectionIndex}`, "Continuous")) : V5(e15, c5(`ReportSections.${r10.$activeSectionIndex}.Body`, "section"))), e15 = Vj(e15, t10, o10), e15 !== r10 && XG.match(o10)) {
          const { Style: t11 } = o10.payload;
          t11 && e15.Themes[0] && (e15 = n10(e15, v2({ id: t11.id, name: t11.name })), e15 = n10(e15, b2({ style: t11.content })));
        }
        return e15;
      }
    }
    if (eU.match(o10)) return ((e15, n11) => {
      let r11 = e15;
      const o11 = r11.ReportSections[e15.$activeSectionIndex];
      return "Continuous" === o11.Type ? ((rj(e15) || rj(o11)) && (r11 = V5(r11, c5(`ReportSections.${e15.$activeSectionIndex}.Body`, "section"))), Vj(r11, t10, n11)) : e15;
    })(r10, o10);
    if (V2.match(o10)) {
      const { library: e15, embeddedImages: t11 } = o10.payload;
      if (r10.Libraries.find((t12) => t12.Path === e15.Path)) return r10;
      const n11 = r10.EmbeddedImages;
      return AV(r10, { Libraries: { $push: [e15] }, EmbeddedImages: { $set: n11.concat(t11) } });
    }
    if (R2.match(o10)) {
      const { libToRemove: e15 } = o10.payload;
      return AV(r10, { Libraries: { $apply: (t11) => t11.filter((t12) => t12.Path !== e15.Path) } });
    }
    if (o10.type.startsWith("SELECTION/")) return V5(r10, o10);
    const i10 = Vj(r10, n5, o10);
    return i10 === r10 ? i10 : eTt(i10);
  };
  return n10;
};
function NTt(e14) {
  return (t10, n10) => {
    let r10 = t10;
    if (null != t10) {
      const e15 = E$e(t10.$paramsView, n10);
      e15 !== t10.$paramsView && (r10 = AV(r10, { $paramsView: { $set: e15 } }));
    }
    return r10 = e14(r10, n10), r10;
  };
}
const DTt = (e14) => {
  const t10 = PTt(e14);
  const n10 = uA(kTt, bgt, function(e15) {
    return (t11, n11) => {
      const r10 = e15(t11, n11);
      if (tTt(r10).greaterThan(L$.zero)) throw W0();
      return r10;
    };
  }, NTt);
  return n10(t10);
};
const LTt = (e14) => {
  nz.of(e14).of("rdlx");
  const t10 = (e15) => {
    const t11 = L$.parse(e15.Width);
    const n10 = Xdt(e15);
    const r10 = L$.max([n10, t11]);
    return AV(e15, { Width: { $set: r10.css } });
  };
  DTt(e14);
  return (e15, n10) => {
    var _a2, _b2;
    if (XG.match(n10) || KG.match(n10) || tU.match(n10)) {
      let t11 = e15;
      return rj(e15) && (t11 = V5(t11, c5("Body", "section"))), t11 = Gye(t11, n5, n10), t11;
    }
    if (YG.match(n10)) {
      const { delta: r11 } = n10.payload;
      const o11 = L$.isZeroLike(r11 && r11.x);
      const a11 = L$.isZeroLike(r11 && r11.y);
      if (o11 && a11) return e15;
      const i10 = Gye(e15, n5, n10);
      return t10(i10);
    }
    const { type: r10, payload: o10 } = n10;
    if (o2.match(n10)) return rj(e15) && "Width" === ((_a2 = o10.descriptor) == null ? void 0 : _a2.valuePath) ? ((e16, t11) => {
      const n11 = L$.parseSafe(t11.payload.value);
      const r11 = Xdt(e16);
      const o11 = Uke(n11.units);
      const a11 = L$.max([r11, o11, n11]);
      return AV(e16, { Width: { $set: a11.css } });
    })(e15, n10) : rj(e15.Body) && "$place.Height" === ((_b2 = o10.descriptor) == null ? void 0 : _b2.valuePath) ? ((e16, t11) => {
      var _a3;
      const n11 = L$.parseSafe((_a3 = t11.payload) == null ? void 0 : _a3.value);
      const r11 = H3(e16.Body);
      const o11 = Uke(n11.units);
      const a11 = L$.max([r11, o11, n11]);
      return AV(e16, { Body: { $place: { Height: { $set: a11.css } } } });
    })(e15, n10) : TTt(e15, n10);
    const a10 = Gye(e15, n5, n10);
    return t10(a10);
  };
};
const HTt = (e14) => {
  var _a2, _b2;
  const t10 = e14.$activeSectionIndex;
  const n10 = e14.ReportSections[t10];
  const r10 = Xdt(n10);
  const o10 = H3(n10.Body);
  let a10 = AV(e14, { ReportSections: { [t10]: { Width: { $set: L$.max([r10, n10.Width]).css }, Body: { $place: { Height: { $set: L$.max([o10, n10.Body.$place.Height]).css } } } } } });
  if ((_a2 = n10.PageHeader) == null ? void 0 : _a2.ReportItems.length) {
    const r11 = H3(n10.PageHeader);
    a10 = AV(e14, { ReportSections: { [t10]: { PageHeader: { $place: { Height: { $set: L$.max([r11, n10.PageHeader.$place.Height]).css } } } } } });
  }
  if ((_b2 = n10.PageFooter) == null ? void 0 : _b2.ReportItems.length) {
    const r11 = H3(n10.PageFooter);
    a10 = AV(e14, { ReportSections: { [t10]: { PageFooter: { $place: { Height: { $set: L$.max([r11, n10.PageFooter.$place.Height]).css } } } } } });
  }
  return a10;
};
const ITt = (e14) => {
  const t10 = DTt(e14);
  const n10 = LTt == null ? void 0 : LTt(e14);
  const r10 = new RegExp("^(?<reportSections>ReportSections).(?<sectionIndex>\\d+).(?<sectionType>Body|PageHeader|PageFooter)$");
  return (o10, a10) => Iut.match(a10) ? ((t11, { payload: { index: n11 } }) => {
    const r11 = nz.of(e14).create("dashboardsection");
    return AV(t11, void 0 === n11 ? { ReportSections: { $push: [r11] } } : { ReportSections: { $splice: [[n11, 0, r11]] } });
  })(o10, a10) : _ut.match(a10) ? ((e15, t11) => {
    if (1 === e15.ReportSections.length) return e15;
    const { payload: { index: n11 } } = t11;
    const r11 = n11 != null ? n11 : e15.$activeSectionIndex;
    return V5(AV(e15, { ReportSections: { $splice: [[r11, 1]] } }), c5(`ReportSections.${Math.max(0, r11 - 1)}`));
  })(o10, a10) : Vut.match(a10) ? ((e15, { payload: { fromIndex: t11, toIndex: n11 } }) => AV(e15, { $activeSectionIndex: { $set: n11 }, ReportSections: { $splice: [[t11, 1], [n11, 0, e15.ReportSections[t11]]] } }))(o10, a10) : Rut.match(a10) ? ((e15, { payload: { index: t11 } }) => {
    var _a2, _b2;
    const n11 = (_b2 = (_a2 = e15.$index) == null ? void 0 : _a2.NamedItems) != null ? _b2 : [];
    const r11 = lj(zG(e15.ReportSections[t11], n11));
    return AV(e15, { $activeSectionIndex: { $set: t11 + 1 }, ReportSections: { $splice: [[t11 + 1, 0, r11]] } });
  })(o10, a10) : Aut.match(a10) ? ((e15, { payload: { index: t11 } }) => {
    const n11 = e15.ReportSections[t11];
    const r11 = dpt(n11.Visibility.Hidden);
    return AV(e15, { ReportSections: { [t11]: { Visibility: { Hidden: { $set: r11 ? "False" : "True" } } } } });
  })(o10, a10) : Out.match(a10) ? ((e15, { payload: { delta: t11, index: n11 } }) => {
    const r11 = n11 != null ? n11 : e15.$activeSectionIndex;
    const o11 = e15.ReportSections[r11];
    const a11 = L$.sum([L$.parse(o11.Width), t11]);
    const i10 = Xdt(o11);
    const s10 = Uke(a11.units);
    const l10 = L$.max([i10, s10, a11]);
    return AV(e15, { ReportSections: { [r11]: { Width: { $set: l10.css } } } });
  })(o10, a10) : But.match(a10) ? ((e15, { payload: { delta: t11, path: n11 } }) => {
    var _a2;
    const o11 = jN(n11)(e15);
    const { groups: a11 } = (_a2 = r10.exec(n11.trim())) != null ? _a2 : {};
    if (!(o11 && a11 && a11.sectionIndex && a11.sectionType)) throw new Error("Invalid path to the section");
    const { sectionIndex: i10, sectionType: s10 } = a11;
    const l10 = t11.add(L$.parse(o11.$place.Height));
    const c10 = H3(o11);
    const u10 = Uke(l10.units);
    const d10 = L$.max([c10, u10, l10]);
    return AV(e15, { ReportSections: { [+i10]: { [s10]: { $place: { Height: { $set: d10.css } } } } } });
  })(o10, a10) : XG.match(a10) || KG.match(a10) || tU.match(a10) ? ((e15, r11) => {
    let o11 = e15;
    if ((rj(e15) || e15.Layers.some((e16) => rj(e16))) && (o11 = V5(o11, c5(`ReportSections.${e15.$activeSectionIndex}.Body`, "section"))), o11 = Vj(o11, n10, r11), XG.match(r11)) {
      const { Style: e16 } = r11.payload;
      e16 && o11.Themes[0] && (o11 = t10(o11, v2({ id: e16.id, name: e16.name })), o11 = t10(o11, b2({ style: e16.content })));
    }
    return o11;
  })(o10, a10) : eU.match(a10) ? HTt(((t11, n11) => {
    let r11 = t11;
    const o11 = r11.ReportSections[t11.$activeSectionIndex];
    (rj(t11) || rj(o11)) && (r11 = V5(r11, c5(`ReportSections.${t11.$activeSectionIndex}.Body`, "section")));
    const a11 = b7(e14);
    let i10 = r11.ReportSections[t11.$activeSectionIndex].Body;
    return i10 = a11(i10, n11), AV(r11, { ReportSections: { [t11.$activeSectionIndex]: { Body: { $set: i10 } } } });
  })(o10, a10)) : ((e15) => {
    for (const [t11, n11] of e15.ReportSections.entries()) if (rj(n11.Body)) {
      const r11 = __spreadProps(__spreadValues({}, dj(n11, true, true)), { Body: lj(n11.Body) });
      return AV(e15, { ReportSections: { [t11]: { $set: r11 } } });
    }
    return e15;
  })(HTt(t10(o10, a10)));
};
const _Tt = { type: "dashboard", labelKey: "reportItems:dashboard", init: (e14, t10, n10, r10) => {
  const o10 = r10 ? __spreadValues(__spreadValues({}, xwt), r10) : xwt;
  return __spreadValues(__spreadProps(__spreadValues({}, o10), { Name: e14 != null ? e14 : o10.Name, ReportSections: [__spreadProps(__spreadValues({}, o10.ReportSections[0]), { Name: KB(TG("dashboardsection")) })] }), n10);
}, icon: nf(Iae), defaultModel: xwt, getReducer: (e14) => bgt(ITt(e14)), getProperties: (e14, t10, n10) => Dwt(e14, 0, n10).filter((e15) => "StartPageNumber" !== e15.valuePath), getContextActions: function(e14, t10, n10) {
  const { lockLayout: r10 } = KO.of(t10);
  const o10 = [];
  if (!r10) {
    const e15 = n10.$activeSectionIndex;
    const t11 = n10.ReportSections[e15];
    const r11 = n10.ReportSections.length > 1;
    const a10 = A1e("contextActions:report.insertSection", "contextActions:report.insertSection", gwt, rz([Iut({ index: e15 + 1 }), c5(`ReportSections.${e15 + 1}`, n10.ReportSections[0].Type)]));
    const i10 = e15 >= 0;
    const s10 = i10 && e15 > 0;
    const l10 = "contextActions:dashboard.moveSectionLeft";
    const c10 = A1e(l10, l10, vwt, s10 ? Vut({ fromIndex: e15, toIndex: e15 - 1 }) : void 0, !s10);
    const u10 = i10 && e15 < n10.ReportSections.length - 1;
    const d10 = "contextActions:dashboard.moveSectionRight";
    const p10 = A1e(d10, d10, bwt, u10 ? Vut({ fromIndex: e15, toIndex: e15 + 1 }) : void 0, !u10);
    const m10 = e15 + 1;
    const h10 = e15 >= 0;
    const f10 = rz([Rut({ index: e15 }), c5(`ReportSections.${m10}`, n10.ReportSections[0].Type)]);
    const g10 = "contextActions:dashboard.duplicateSection";
    const y10 = A1e(g10, g10, Swt, h10 ? f10 : void 0, !h10);
    const v10 = dpt(t11.Visibility.Hidden);
    const b10 = "contextActions:dashboard.showSection";
    const S10 = "contextActions:dashboard.hideSection";
    const C10 = A1e(v10 ? b10 : S10, v10 ? b10 : S10, Cwt, Aut({ index: e15 }));
    const x10 = "contextActions:dashboard.removeSection";
    const w10 = A1e(x10, x10, ywt, _ut({}), !r11);
    o10.push(a10, R1e(), c10, p10, R1e(), y10, R1e(), C10, R1e(), w10, R1e());
  }
  return o10.push({ type: "theme", icon: fwt, key: "contextActions:dashboard.switchTheme", action: g2 }), [...i0e(e14, t10, n10), { type: "group", key: "contextActions:dashboard.title", actions: o10, location: "toolbar" }];
}, features: { getPageSectionsInfo: (e14) => {
  const t10 = e14.$activeSectionIndex;
  const n10 = e14.ReportSections[t10];
  return [{ container: n10.Body, path: `ReportSections.${t10}.Body`, offset: { top: L$.zero, left: L$.zero, width: L$.parseSafe(n10.Width), height: L$.parseSafe(n10.Body.$place.Height) } }];
}, disableCopy: true } };
const VTt = FZ.resultOf(uX.decode({ Name: "Section1", Body: {} }));
const RTt = [EY.Name, Zq(tY, "dashboardSection.displayName", "string_expr", "DisplayName", void 0, { disableDataFields: true, exprEditorFilter: (e14) => !e14.includes("dataSets") }), __spreadProps(__spreadValues({}, vY.BackgroundAndBorders), { valuePath: "Body.Style" }), Zq(oY, "dimensions.width", "length", "Width", "both", { minValueMap: qY }), Zq(oY, "dimensions.height", "length", "Body.$place.Height", "both", { minValueMap: qY }), __spreadProps(__spreadValues({}, vY.BackgroundColor), { valuePath: "Body.Style.BackgroundColor" }), __spreadProps(__spreadValues({}, vY.BackgroundImage), { valuePath: "Body.Style.BackgroundImage" }), __spreadProps(__spreadValues({}, vY.Borders), { valuePath: "Body.Style" }), Zq(yY, "visibility.hidden", "boolean_expr", "Visibility.Hidden"), wY, EY.DataElementOutput];
const ATt = { type: "dashboardsection", labelKey: "reportItems:dashboardSection", init: (e14, t10, n10, r10) => {
  const o10 = r10 ? __spreadValues(__spreadValues({}, VTt), r10) : VTt;
  const a10 = __spreadValues(__spreadProps(__spreadValues({}, o10.Body), { Name: KB(TG("Body")) }), n10 == null ? void 0 : n10.Body);
  return __spreadValues(__spreadProps(__spreadValues({}, o10), { Body: a10, Name: KB(TG("dashboardsection")) }), n10);
}, icon: nf(Vae), defaultModel: VTt, getProperties: () => RTt, getReducer: LTt, getContextActions: i0e, features: { disableCopy: true } };
const OTt = [EY.Name, EY.Location, EY.LayerName, EY.ZIndex, EY.Visibility, EY.DataElementName, EY.DataElementOutput_AON, EY.ToolTip, EY.Label, EY.Bookmark];
const BTt = { type: "unknown", glyph: ({ item: { Type: e14, Name: t10 }, path: n10 }) => {
  const { t: r10 } = vp("captions");
  const o10 = r10("reportItems:unknown", "Unknown Item");
  const a10 = r10("basicSupportReportItemInfo", "{{itemLabel}} '{{itemName}}' has limited support in design-time.", { itemLabel: o10, itemName: t10 });
  return tp.createElement("div", { className: "ar-item ar-default-report-item", "data-type": e14, "data-path": n10 }, a10);
}, getReducer: q5, icon: nf(_ae), nameTemplateKey: "nameTemplates:Item", labelKey: "reportItems:Unknown", getProperties: () => OTt, features: { borderStyles: ["None", "Dotted", "Dashed", "Solid", "Double", "Groove", "Ridge", "Inset", "WindowInset", "Outset", "DashDot", "DashDotDot"], textDecorations: ["None", "Underline", "DoubleUnderline", "Overline", "LineThrough"] } };
const zTt = { $fixedPlace: { Width: "2in", Height: "1in", OverflowName: "" } };
const $Tt = __spreadValues(__spreadProps(__spreadValues({}, Gyt), { Type: "fixedpagebandedlist" }), zTt);
const WTt = ["PageBreak", "NewPage", "KeepTogether", "ConsumeWhiteSpace"];
const jTt = [FY.FixedWidth, FY.FixedHeight, FY.OverflowName];
const ZTt = Yyt.filter((e14) => !WTt.includes(e14.valuePath)).concat(...jTt);
const GTt = { type: $Tt.Type, baseType: "bandedlist", labelKey: $vt.labelKey, nameTemplateKey: $vt.nameTemplateKey, defaultModel: $Tt, icon: $vt.icon, init: (e14, t10, n10, r10) => {
  const o10 = __spreadProps(__spreadValues({}, qyt(e14, 0, n10, r10 != null ? r10 : Gyt)), { Type: "fixedpagebandedlist" });
  return z5(o10, zTt);
}, getReducer: zvt, getContextActions: hyt, glyph: Zyt, getProperties: () => ZTt, features: { getExpressionProperties: fyt, isDataRegion: true, isFplItem: true } };
const UTt = ["PageBreak"];
const qTt = dCt.filter((e14) => !UTt.includes(e14.valuePath));
const YTt = __spreadProps(__spreadValues({}, pCt.defaultModel), { Type: "fixedpagedvchart" });
const KTt = __spreadProps(__spreadValues({}, pCt), { type: "fixedpagedvchart", baseType: "dvchart", defaultModel: YTt, init: (e14, t10, n10, r10) => {
  const o10 = r10 != null ? r10 : Kye;
  const { units: a10 } = KO.of(t10).userPreferences;
  return __spreadProps(__spreadValues({}, pCt.init && pCt.init(e14, a10, n10, o10)), { Type: "fixedpagedvchart" });
}, getProperties: () => qTt, features: { isFplItem: true, isDataRegion: true } });
const XTt = (e14) => {
  const { GrowDirection: t10, RowsOrColumnsCount: n10 } = e14;
  const r10 = L3(e14);
  return "Column" === t10 || "ColumnReverse" === t10 ? { Width: r10.Width.multiply(n10), Height: r10.Height } : { Width: r10.Width, Height: r10.Height.multiply(n10) };
};
const [JTt, QTt, eEt] = Dp("ar-list");
const tEt = QTt("rows");
const nEt = QTt("columns");
const [rEt] = eEt("work-area");
const [oEt] = eEt("segment");
const [aEt] = eEt("segment-caption");
const [iEt] = eEt("segment-caption-start");
const [sEt] = eEt("segment-caption-end");
const lEt = (e14) => {
  const { item: { Type: t10, RowsOrColumnsCount: n10, GrowDirection: r10, $place: { Width: o10, Height: a10 } }, path: i10 } = e14;
  const { t: s10 } = vp();
  const { userPreferences: { units: l10 } } = MO();
  const c10 = "Row" === r10 || "RowReverse" === r10 ? "row" : "column";
  const u10 = ep.useCallback(() => {
    switch (c10) {
      case "row":
        return "in" === l10 ? new L$(0.25, "in") : new L$(0.5, "cm");
      case "column":
        return "in" === l10 ? new L$(0.5, "in") : new L$(1, "cm");
      default:
        return new L$(0.25, "in");
    }
  }, [c10, l10]);
  const d10 = ep.useCallback(() => {
    switch (c10) {
      case "row":
        return s10("reportItems:listRow", "Row");
      case "column":
        return s10("reportItems:listColumn", "Column");
      default:
        return "";
    }
  }, [c10, s10]);
  const p10 = ep.useCallback(() => {
    switch (c10) {
      case "row":
        return s10("reportItems:listRowsStacked", "Rows 2-{{rowCount}}", { rowCount: `${n10}` });
      case "column":
        return s10("reportItems:listColumnsStacked", "Columns 2-{{columnCount}}", { columnCount: `${n10}` });
      default:
        return "";
    }
  }, [n10, c10, s10]);
  const m10 = ep.useCallback(() => tp.createElement("div", { className: oEt, title: p10() }, tp.createElement("span", { className: aEt }, tp.createElement("span", { className: iEt }, p10()))), [p10]);
  const h10 = ep.useCallback(() => {
    const e15 = [];
    for (let t11 = 2; t11 <= n10; t11++) e15.push(tp.createElement("div", { className: oEt, key: `segment-${t11}`, title: `${d10()} ${t11}` }, tp.createElement("span", { className: aEt }, tp.createElement("span", { className: iEt }, d10()), tp.createElement("span", { className: sEt }, ` ${t11}`))));
    return e15;
  }, [n10, d10]);
  const f10 = ep.useCallback(() => {
    switch (c10) {
      case "row":
        return Math.ceil(L$.parse(a10).divide(u10()));
      case "column":
        return Math.ceil(L$.parse(o10).divide(u10()));
      default:
        return 1 / 0;
    }
  }, [a10, o10, u10, c10]);
  const g10 = ep.useCallback(() => n10 > f10() ? m10() : h10(), [n10, f10, m10, h10]);
  return tp.createElement("div", { "data-path": i10, "data-type": t10, className: kp("ar-item", JTt, { [tEt]: "row" === c10, [nEt]: "column" === c10 }) }, tp.createElement("div", { className: rEt }, Ylt(e14)), g10());
};
lEt.displayName = "ListGlyph";
const cEt = FZ.resultOf(wq.decode({ Type: "list", Name: "list1", Width: "1in", Height: "1in" }));
const uEt = (e14, t10, n10, r10 = cEt) => __spreadProps(__spreadValues(__spreadValues({}, r10), n10), { Name: e14 || "" });
const dEt = (e14) => `list.${e14}`;
const pEt = [FY.NoRowsMessage, vY.FontSimple, vY.Color, vY.Font, vY.TextDecoration, vY.TextAlign, vY.VerticalAlign, vY.Format].map((e14) => __spreadProps(__spreadValues({}, e14), { category: `propertyDescriptors:categories.${pY}` }));
const mEt = [EY.Name, EY.Action, FY.DataSetName, FY.DataSetParameters, EY.DataElementName, EY.DataElementOutput, Zq(rY, dEt("dataInstanceName"), "string", "DataInstanceName", "advanced"), Zq(rY, dEt("dataInstanceElementOutput"), "enum", "DataInstanceElementOutput", "advanced", { enumKey: "data_element_output_on" }), FY.SortExpressions, FY.Filters, MY.Name, MY.GroupExpressionsExt, MY.PageBreakWithBetween, MY.Parent, MY.DocumentMapLabel, MY.DataElementName, MY.DataCollectionName, MY.DataElementOutput_ON, MY.NewSection, MY.Filters, vY.BackgroundAndBorders, vY.BackgroundColor, vY.BackgroundImage, vY.Borders, EY.Location, EY.Size, Zq(cY, "reportItem.style", "styles", "ReportStyle", void 0, { target: "List" }), vY.Padding, EY.LayerName, FY.PageBreak, FY.NewPage, FY.NewSection, EY.KeepTogether, Zq(cY, dEt("consumeWhiteSpace"), "boolean", "ConsumeWhiteSpace", "advanced"), Zq(cY, "", "rows_columns_count", ""), EY.ZIndex, ...pEt, EY.Visibility, vY.Calendar, vY.Direction, vY.Language, vY.NumeralLanguage, vY.NumeralVariant, vY.UnicodeBiDi, vY.UprightInVerticalText, vY.WritingMode, EY.ToolTip, EY.Label, EY.Bookmark];
const hEt = (e14) => {
  const t10 = nz.of(e14).getTemplate("list");
  const { BackgroundColor: n10, Border: r10, TopBorder: o10, BottomBorder: a10, LeftBorder: i10, RightBorder: s10, Color: l10, FontFamily: c10, FontSize: u10, FontStyle: d10, FontWeight: p10, TextAlign: m10, VerticalAlign: h10 } = t10.Style;
  return { BackgroundColor: n10, Border: r10, TopBorder: o10, BottomBorder: a10, LeftBorder: i10, RightBorder: s10, Color: l10, FontFamily: c10, FontSize: u10, FontStyle: d10, FontWeight: p10, TextAlign: m10, VerticalAlign: h10 };
};
const fEt = (e14, t10, n10) => {
  const r10 = {};
  return ["Color", "Width", "Style"].forEach((o10) => {
    ((e15, t11, n11, r11) => Oj(e15, t11, r11) && (!n11 || !n11[r11] || e15[r11] && n11[r11] !== e15[r11] || Oj(n11, t11, r11)))(e14, t10, n10, o10) && (r10[o10] = { $set: t10[o10] });
  }), Object.keys(r10).length > 0 ? r10 : null;
};
function gEt(e14, t10, n10 = false, r10) {
  const o10 = hEt(r10);
  const a10 = ((e15, t11) => {
    const n11 = t11.Border && fEt(e15.Style.Border, t11.Border, void 0);
    const r11 = n11 ? { Border: n11 } : null;
    const o11 = Oj(e15.Style, t11, "BackgroundColor") ? { BackgroundColor: { $set: t11.BackgroundColor } } : null;
    const a11 = __spreadValues(__spreadValues(__spreadValues({}, n5e(e15, t11)), r11), o11);
    return Object.keys(a11).length > 0 ? a11 : null;
  })(e14, n10 ? Aj(t10, o10) : t10);
  return null !== a10 ? AV(e14, { Style: a10 }) : e14;
}
const yEt = ["tableofcontents", "fixedpagetableofcontents", "contentplaceholder"];
const vEt = (e14, { payload: { items: t10 } }) => {
  const n10 = t10.find((e15) => yEt.includes(e15.Type));
  if (n10) throw $0(n10.Type, e14.Type);
  return e14;
};
const bEt = (e14, { payload: { Type: t10 } }) => {
  if (yEt.includes(t10)) throw $0(t10, e14.Type);
  return e14;
};
const SEt = (e14, { payload: t10 }) => {
  const n10 = t10.dataSetName || t10.dataSet;
  const r10 = vj(e14);
  if (!r10.length) return e14;
  return r10.some((t11) => !zj(e14, t11.path)) && n10 && !e14.DataSetName ? AV(e14, { DataSetName: { $set: n10 } }) : e14;
};
const CEt = (e14, { payload: t10 }) => AV(e14, { ReportStyle: { $set: { StyleId: t10.id || "", StyleName: t10.name || "" } } });
const xEt = (e14, { payload: { rowsOrColumnsCount: t10, growDirection: n10 } }) => {
  const { GrowDirection: r10, RowsOrColumnsCount: o10 } = e14;
  const a10 = n10 || r10;
  const i10 = t10 || o10;
  if (!((e15, t11, n11) => {
    const { $place: { Width: r11, Height: o11 } } = e15;
    const a11 = (i11 = L$.parse(r11), s10 = L$.parse(o11), l10 = t11, "Column" === (c10 = n11) || "ColumnReverse" === c10 ? { width: i11.divideByNum(l10), height: s10 } : { width: i11, height: s10.divideByNum(l10) });
    var i11, s10, l10, c10;
    const u10 = L3(e15);
    return a11.height.greaterThanOrEqual(u10.Height) && a11.width.greaterThanOrEqual(u10.Width);
  })(e14, i10, a10)) {
    const { t: e15 } = hG();
    throw B0(fG("listRowsOrColumnsCount", e15), gG("listRowsOrColumnsCount", e15));
  }
  return AV(e14, { RowsOrColumnsCount: { $set: i10 }, GrowDirection: { $set: a10 } });
};
const wEt = (e14) => (t10, { payload: n10 }) => {
  const r10 = ((e15, t11) => {
    const n11 = e15 && e15.$targetType === wj.List;
    const r11 = hEt(t11);
    return n11 ? __spreadValues(__spreadValues({}, r11), e15) : r11;
  })(n10.style, e14);
  return r10 ? gEt(t10, r10, void 0, e14) : t10;
};
const TEt = (e14, t10) => {
  const n10 = jV(vEt, t10);
  const r10 = jV(bEt, t10);
  const o10 = jV(SEt, t10);
  return Uye(0, { [UG]: n10, [jG]: n10, [WG]: r10, [O5.type]: o10, [l2.type]: o10, [o2.type]: o10, [v2.type]: GV(rj, CEt, t10), [b2.type]: GV(rj, wEt(e14), t10), [AHe.type]: GV(rj, xEt, t10) }, t10);
};
const EEt = { type: "list", defaultModel: cEt, labelKey: "reportItems:list", nameTemplateKey: "nameTemplates:list", icon: nf(sae), icon24: nf(lae), init: uEt, glyph: lEt, getReducer: (e14) => {
  const t10 = nz.of(e14).of("rdlx").getReducer("rectangle");
  if (!t10) throw new Error("Register rectangle before list");
  return TEt(e14, t10);
}, getProperties: (e14, t10, n10) => (n10 == null ? void 0 : n10.isDashboard) ? n4(mEt) : mEt, getContextActions: xlt, features: { isDataRegion: true, getMinContentSize: XTt } };
const FEt = ["PageBreak", "NewPage", "KeepTogether", "ConsumeWhiteSpace"];
const MEt = mEt.filter((e14) => !FEt.includes(e14.valuePath)).concat(FY.FixedWidth, FY.FixedHeight, FY.OverflowName);
const kEt = "fixedpagelist";
const PEt = { $fixedPlace: { Width: "1in", Height: "1in", OverflowName: "" } };
const NEt = __spreadValues(__spreadProps(__spreadValues({}, cEt), { Type: kEt }), PEt);
const DEt = { type: kEt, baseType: "list", labelKey: EEt.labelKey, nameTemplateKey: EEt.nameTemplateKey, icon: EEt.icon, icon24: EEt.icon24, defaultModel: NEt, init: (e14, t10, n10, r10) => {
  const { units: o10 } = KO.of(t10).userPreferences;
  const a10 = __spreadProps(__spreadValues({}, uEt(e14, 0, n10, r10 != null ? r10 : cEt)), { Type: kEt });
  return z5(a10, { $fixedPlace: __spreadValues(__spreadValues({}, PEt.$fixedPlace), n10 == null ? void 0 : n10.$fixedPlace) });
}, glyph: lEt, getReducer: function(e14) {
  const t10 = nz.of(e14).of("rdlx").getReducer("fixedpagerectangle");
  if (!t10) throw new Error("Register fixedpagerectangle before fixedpagelist");
  return TEt(e14, t10);
}, getProperties: () => MEt, getContextActions: xlt, features: { isDataRegion: true, isFplItem: true, getMinContentSize: XTt } };
const LEt = ({ item: e14, dataSets: t10, path: n10 }) => {
  var _a2, _b2;
  const { rdlx: { theme: r10 } } = d9();
  const { renderItem: o10, makeImageUrl: a10, embeddedImages: i10 } = ep.useContext(bqe);
  const s10 = (_a2 = e14.Style) == null ? void 0 : _a2.BackgroundColor;
  const l10 = (_b2 = e14.Style) == null ? void 0 : _b2.BackgroundImage;
  const c10 = Bme(s10, null, r10);
  const u10 = l10 ? a10(l10.Source, l10.Value, i10) : "";
  const d10 = !P2e(e14.Type);
  const p10 = { backgroundColor: d10 ? c10 : "transparent", backgroundImage: d10 ? u10 : "", width: "100%", height: "100%" };
  return tp.createElement("div", { style: p10 }, o10(e14, n10, t10, c10, false, true));
};
const [HEt, IEt, _Et] = Dp("ar-partitem");
const [VEt] = _Et("border-wrapper");
const [REt] = _Et("overlay");
const AEt = IEt("line");
const OEt = (e14) => {
  if (e14 && OW(e14.Type)) {
    const t10 = e14;
    const { RoundingRadius: { Default: n10, TopLeft: r10, TopRight: o10, BottomLeft: a10, BottomRight: i10 }, $place: s10 } = t10;
    const [l10, c10] = [s10 && s10.Width, s10 && s10.Height];
    const u10 = { width: L$.parseSafe(l10).divideByNum(2), height: L$.parseSafe(c10).divideByNum(2) };
    const d10 = L$.min([u10.height, u10.width]);
    const p10 = (e15) => L$.min([L$.parseSafe(e15 || n10), d10]).css;
    return { borderTopLeftRadius: p10(r10), borderTopRightRadius: p10(o10), borderBottomRightRadius: p10(i10), borderBottomLeftRadius: p10(a10) };
  }
  return {};
};
const BEt = FZ.resultOf(wq.decode({ Type: "partitem", Name: "PartItem1", Width: "3in", Height: "2in" }));
const zEt = [EY.Name, Zq(tY, "", "report_parts_library", ""), EY.Location, Zq(oY, "dimensions.size", "partitem-size", ""), EY.LayerName, EY.ZIndex, EY.Visibility, EY.ToolTip, EY.Label, EY.Bookmark];
const $Et = { type: BEt.Type, labelKey: "reportItems:partItem", nameTemplateKey: "nameTemplates:partItem", icon: nf(cWe), glyph: (e14) => {
  const { item: t10, path: n10, dataSets: r10 } = e14;
  const o10 = h9();
  const { ReportPart: a10, Library: i10, Type: s10 } = t10;
  const { rdlx: { reportPartsLibraries: { libraries: l10 }, theme: c10 } } = d9();
  const { library: u10, partItemGlyph: d10, partItemStyle: p10, partItemSize: m10, partItemType: h10, partItem: f10 } = ((e15, t11, n11, r11, o11) => {
    var _a2, _b2, _c2;
    if (r11 && o11) {
      const a11 = n11.find((e16) => e16.Name === o11);
      const i11 = (a11 && ELe(a11) ? a11.reportParts : []).find((e16) => e16.Name === r11);
      if (i11 == null ? void 0 : i11.item) {
        const n12 = { item: i11.item, dataSets: t11, path: e15 };
        return { library: a11, partItemGlyph: tp.createElement(LEt, __spreadValues({}, n12)), partItemStyle: i11.item.Style || {}, partItemType: i11.item.Type, partItem: i11.item, partItemSize: { sizeMode: (_a2 = i11.SizeMode) != null ? _a2 : null, width: (_b2 = i11.width) != null ? _b2 : "1in", height: (_c2 = i11.height) != null ? _c2 : "1in" } };
      }
    }
    return { partItemGlyph: null, partItemStyle: {}, partItemType: "", partItemSize: { sizeMode: "Fit", width: "1in", height: "1in" } };
  })(n10, r10, l10, a10, i10);
  const g10 = ((e15, t11, n11) => {
    var _a2, _b2;
    if ("line" === n11) return {};
    const r11 = (_a2 = L$.parseSafe("Grow" === t11.sizeMode ? t11.width : e15.$place.Width)) == null ? void 0 : _a2.css;
    const o11 = (_b2 = L$.parseSafe("Grow" === t11.sizeMode ? t11.height : e15.$place.Height)) == null ? void 0 : _b2.css;
    return { position: "relative", width: r11, height: o11, minWidth: r11, minHeight: o11 };
  })(t10, m10, h10);
  const y10 = PA();
  const v10 = ep.useMemo(() => !(!u10 || !ELe(u10)) && !o10.Libraries.some(({ Name: e15 }) => e15 === i10), [u10, i10, o10.Libraries]);
  ep.useEffect(() => {
    u10 && ELe(u10) && v10 && y10(V2({ library: { Name: i10, Path: u10.Path }, embeddedImages: u10.EmbeddedImages }));
  }, [v10]);
  const b10 = kp("ar-item", HEt, { [IEt(m10.sizeMode.toLowerCase())]: true }, { [AEt]: h10 === rW.line });
  const S10 = kp("ar-item", REt);
  const C10 = Mme(p10, c10, void 0, g10.width, g10.height);
  const x10 = Mme(p10, c10, void 0, t10.$place.Width, t10.$place.Height);
  const w10 = { left: C10.left, top: C10.top, width: x10.width, height: x10.height };
  const T10 = __spreadProps(__spreadValues(__spreadValues({}, C10), OEt(f10)), { top: 0, left: 0 });
  return tp.createElement(tp.Fragment, null, tp.createElement("div", { className: b10 }, tp.createElement("div", { style: g10 }, d10, tp.createElement("div", { className: S10, "data-type": s10, "data-path": n10 }))), (E10 = h10, ![rW.line, rW.shape].includes(E10) && tp.createElement("div", { className: VEt, style: w10 }, tp.createElement("div", { className: "ar-border", style: T10 }))));
  var E10;
}, init: (e14, t10, n10, r10) => {
  const o10 = r10 ? __spreadValues(__spreadValues({}, BEt), r10) : BEt;
  return __spreadProps(__spreadValues(__spreadValues({}, o10), n10), { $place: __spreadValues(__spreadValues({}, o10.$place), n10 == null ? void 0 : n10.$place), Name: e14 != null ? e14 : FG(TG("partItem")) });
}, defaultModel: BEt, getProperties: () => zEt, getContextActions: i0e };
const WEt = { $fixedPlace: { Width: "2in", Height: "3in", OverflowName: "" } };
const jEt = __spreadProps(__spreadValues(__spreadValues({}, $Et.defaultModel), WEt), { Type: "fixedpagepartitem" });
const ZEt = [];
const GEt = zEt.filter((e14) => !ZEt.includes(e14.valuePath));
const UEt = { type: "fixedpagepartitem", baseType: "partitem", labelKey: $Et.labelKey, nameTemplateKey: $Et.nameTemplateKey, icon: $Et.icon, icon24: $Et.icon24, glyph: $Et.glyph, init: (e14, t10, n10, r10 = jEt) => {
  const o10 = __spreadProps(__spreadValues({}, $Et.init(e14, t10, n10, r10)), { Type: "fixedpagepartitem" });
  return z5(o10, WEt);
}, defaultModel: jEt, getProperties: (e14, t10, n10) => {
  if (!n10 || !n10.settings) return GEt;
  return tGe.of(n10.settings.instanceId).isReportPartWithOverflowName(e14.ReportPart, e14.Library) ? GEt.concat(FY.OverflowName) : GEt;
}, getContextActions: i0e };
const qEt = ["RoundingRadius.Default", "RoundingRadius.TopLeft", "RoundingRadius.TopRight", "RoundingRadius.BottomLeft", "RoundingRadius.BottomRight"];
const YEt = FZ.resultOf(wq.decode({ Type: "rectangle", Name: "container1", Width: "3in", Height: "2in" }));
const KEt = (e14) => `container.${e14}`;
const XEt = [EY.Name, vY.BackgroundAndBorders, vY.BackgroundColor, vY.BackgroundImage, vY.Borders, vY.Corners, EY.Location, EY.Size, Zq(cY, "reportItem.style", "styles", "ReportStyle", void 0, { target: "Container" }), EY.LayerName, Zq(cY, KEt("pageBreak"), "enum", "PageBreak", void 0, { enumKey: "page_break" }), Zq(cY, KEt("newPage"), "enum", "NewPage", void 0, { enumKey: "new_page" }), EY.KeepTogether, Zq(cY, KEt("consumeWhiteSpace"), "boolean", "ConsumeWhiteSpace", "advanced"), EY.ZIndex, EY.Visibility, EY.DataElementName, EY.DataElementOutput, EY.PageName, EY.ToolTip, EY.Label, EY.Bookmark, Zq(dY, KEt("linkToChild"), "link_to_child", "LinkToChild", "advanced")];
const JEt = [...n4(XEt), Zq(cY, KEt("overflow"), "enum", "Overflow", "both", { enumKey: "overflow" })];
const QEt = (e14, t10, n10) => (n10 == null ? void 0 : n10.isDashboard) ? JEt : XEt;
const eFt = { type: YEt.Type, labelKey: "reportItems:container", nameTemplateKey: "nameTemplates:container", icon: nf(Woe), icon24: nf(joe), init: (e14, t10, n10, r10 = YEt) => __spreadProps(__spreadValues(__spreadValues({}, r10), n10), { Name: e14 || "" }), defaultModel: YEt, glyph: Ylt, getReducer: b7, getProperties: QEt, getContextActions: xlt, features: { getExpressionProperties: function() {
  return qEt;
} } };
const tFt = "fixedpagerectangle";
const nFt = ["ConsumeWhiteSpace", "KeepTogether", "PageBreak", "NewPage"];
const rFt = FZ.resultOf(Oq.decode({ Type: "rectangle", Name: "container1", Width: "3in", Height: "2in" }));
const oFt = { type: tFt, baseType: "rectangle", labelKey: eFt.labelKey, nameTemplateKey: eFt.nameTemplateKey, icon: eFt.icon, icon24: eFt.icon24, init: (e14, t10, n10, r10 = rFt) => __spreadProps(__spreadValues(__spreadValues({}, r10), n10), { Name: e14 || "", Type: tFt }), defaultModel: rFt, glyph: rdt, getReducer: D7, getContextActions: xlt, getProperties: (e14, t10, n10) => QEt(0, 0, n10).filter((e15) => !nFt.includes(e15.valuePath)), features: { isFplItem: true } };
const aFt = (e14) => `contextActions:report.${e14}`;
const iFt = { Pages: nf(gpt), PageDelete: nf(vpt), PageDuplicate: nf(bpt), PageInsert: nf(ypt), PageMoveBackward: nf(Spt), PageMoveForward: nf(Cpt), PageToggle: nf(xpt), SwitchTheme: nf(Npt) };
const sFt = (e14) => {
  const t10 = e14.filter((e15) => aj(e15));
  const n10 = e14.findIndex((e15) => ij(e15));
  return 1 === t10.length ? n10 : -1;
};
const lFt = (e14) => {
  const t10 = ((e15) => {
    const t11 = e15.Pages || [];
    const n11 = sFt(t11);
    const r11 = n11 >= 0;
    const o11 = r11 && n11 > 0;
    const a11 = o11 ? _pt({ fromIndex: n11, toIndex: n11 - 1 }) : { type: "" };
    const i10 = r11 && n11 < t11.length - 1;
    const s10 = i10 ? _pt({ fromIndex: n11, toIndex: n11 + 1 }) : { type: "" };
    return [{ type: "button", key: aFt("movePageBackward"), textKey: aFt("movePageBackward"), icon: iFt.PageMoveBackward, action: a11, disabled: !o11 }, { type: "button", key: aFt("movePageForward"), textKey: aFt("movePageForward"), icon: iFt.PageMoveForward, action: s10, disabled: !i10 }];
  })(e14);
  const n10 = ((e15) => {
    const t11 = e15.Pages || [];
    const n11 = sFt(t11);
    const r11 = n11 >= 0;
    const o11 = r11 ? rz([Vpt({ index: n11 }), c5(`Pages.${n11 + 1}`, t11[n11].Type)]) : { type: "" };
    return { type: "button", key: aFt("insertPage"), textKey: aFt("insertPage"), icon: iFt.PageInsert, action: o11, disabled: !r11 };
  })(e14);
  const r10 = ((e15) => {
    const t11 = e15.Pages || [];
    const n11 = sFt(t11);
    const r11 = n11 >= 0;
    const o11 = r11 ? rz([Rpt({ index: n11 }), c5(`Pages.${n11 + 1}`, t11[n11].Type)]) : { type: "" };
    return { type: "button", key: aFt("duplicatePage"), textKey: aFt("duplicatePage"), icon: iFt.PageDuplicate, action: o11, disabled: !r11 };
  })(e14);
  const o10 = ((e15) => {
    const t11 = e15.Pages || [];
    const n11 = sFt(t11);
    const r11 = n11 >= 0;
    const o11 = r11 ? Apt({ index: n11 }) : { type: "" };
    const a11 = r11 && dpt(t11[n11].Visibility.Hidden);
    return { type: "button", key: aFt(a11 ? "showPage" : "hidePage"), textKey: aFt(a11 ? "showPage" : "hidePage"), icon: iFt.PageToggle, action: o11, disabled: !r11 };
  })(e14);
  const a10 = ((e15) => {
    const t11 = e15.Pages || [];
    const n11 = sFt(t11);
    const r11 = t11.length > 1 && n11 >= 0;
    const o11 = r11 ? Ipt({ page: t11[n11] }) : { type: "" };
    return { type: "button", key: aFt("deletePage"), textKey: aFt("deletePage"), icon: iFt.PageDelete, action: o11, disabled: !r11 };
  })(e14);
  return [...t10, { type: "separator", key: "" }, n10, r10, { type: "separator", key: "" }, o10, { type: "separator", key: "" }, a10];
};
const cFt = ["DocumentMap.NumberingStyle", "DocumentMap.Source", "Language"];
const uFt = FZ.resultOf(lX.decode({ Width: "6.5in", FixedPage: {} }));
const dFt = (e14) => `report.${e14}`;
const pFt = [PY];
const mFt = [NY, DY, LY];
const hFt = [Zq(cY, dFt("embeddedImages"), "embedded_images_collection", "EmbeddedImages"), Zq(cY, dFt("layers"), "layer_collection", "Layers", "advanced"), IY, _Y, wY, TY, SY.Levels, SY.NumberingStyle, SY.Source, Zq(dY, dFt("author"), "string", "Author"), Zq(dY, dFt("description"), "string", "Description"), Zq(dY, dFt("language"), "language", "Language"), Zq(dY, dFt("startPageNumber"), "number", "StartPageNumber", "advanced", Gq.integer), FY.DataSetName, MY.Name, MY.GroupExpressionsExt, MY.DocumentMapLabel, MY.DataElementName, MY.DataCollectionName, MY.DataElementOutput_ON, MY.NewSection, MY.Filters, FY.SortExpressions, FY.Filters, Zq(rY, "fplReport.fixedElementName", "string", "FixedPageDataElementName", "advanced"), Zq(rY, "fplReport.fixedElementOutput", "enum", "FixedPageDataElementOutput", "advanced", { enumKey: "data_element_output_aon" })];
const fFt = [...pFt, ...hFt];
const gFt = [...mFt, ...hFt];
const yFt = uFt.Pages[0];
const vFt = (e14) => `fplPage.${e14}`;
const bFt = [vY.BackgroundAndBorders, vY.BackgroundColor, vY.BackgroundImage, vY.Borders, FY.ThrowIfPlaceHoldersEmpty, Zq(yY, "visibility.hidden", "boolean_expr", "Visibility.Hidden"), Zq(oY, vFt("size"), "fpl_page_size", "", "simple", { compactMode: true }), Zq(oY, vFt("size"), "fpl_page_size", "", "advanced"), Zq(uY, "", "margins", "")];
const SFt = { type: yFt.Type, baseType: "page", labelKey: "reportItems:page", defaultModel: yFt, icon: nf(Rae), init: (e14, t10, n10, r10 = yFt) => __spreadProps(__spreadValues(__spreadValues({}, r10), n10), { Name: e14 }), glyph: odt, getReducer: D7, getProperties: () => bFt, getContextActions: xlt, features: { isFplItem: true, disableCopy: true } };
const CFt = (e14) => {
  const t10 = e14.Pages || [];
  const n10 = {};
  let r10 = false;
  return t10.forEach((e15, t11) => {
    const o10 = `Page${t11 + 1}`;
    (e15.Name || "") !== o10 && (n10[t11] = { Name: { $set: o10 } }, r10 = true);
  }), r10 ? AV(e14, { Pages: n10 }) : e14;
};
function xFt(e14, t10, n10) {
  var _a2, _b2;
  if (n10 < 0 || n10 >= e14.Pages.length) throw new z0("Invalid page index");
  const r10 = (_b2 = (_a2 = e14.$index) == null ? void 0 : _a2.NamedItems) != null ? _b2 : [];
  let o10 = e14.Pages[n10];
  let a10 = lj(zG(o10, r10));
  if (e14.Type === rW.fplReport) {
    const e15 = function(e16, t11) {
      let { originalPage: n11, copiedPage: r11 } = t11;
      const o11 = /* @__PURE__ */ new Map();
      const a11 = /* @__PURE__ */ new Map();
      const i11 = /* @__PURE__ */ new Map();
      const s10 = /* @__PURE__ */ new Map();
      const l10 = /* @__PURE__ */ new Map();
      const c10 = (t12, n12, r12, l11) => {
        if (!ej(n12.Type)) return {};
        if (!n12.hasOwnProperty("$fixedPlace")) throw new Error("Fpl node without $fixedPlace");
        const { path: c11 } = l11;
        const u10 = n12.$fixedPlace.OverflowName;
        o11.set(n12.Name, c11), a11.set(c11, u10), u10 && i11.set(u10, n12.Name);
        const d10 = n12.$fixedPlace.Width || n12.$width || n12.$place.Width;
        const p10 = n12.$fixedPlace.Height || n12.$height || n12.$place.Height;
        const m10 = { $place: __spreadProps(__spreadValues({}, n12.$place), { Width: d10, Height: p10 }), $width: d10, $height: p10, LayerName: n12.LayerName };
        const h10 = FG(TG(rW.overflowPlaceHolder));
        const f10 = nz.of(e16).create("overflowplaceholder", h10, void 0, m10);
        return s10.set(c11, f10), null;
      };
      if (C3(n11, x3(c10), { path: "" }), 0 === o11.size) return { originalPage: n11, copiedPage: r11 };
      for (const e17 of a11.values()) o11.has(e17) || i11.delete(e17);
      for (const e17 of o11.values()) {
        const t12 = a11.get(e17);
        if ("" === t12) continue;
        const n12 = s10.get(e17);
        const r12 = o11.get(t12);
        const i12 = s10.get(r12);
        const l11 = AV(n12, { $fixedPlace: { OverflowName: { $set: i12 ? i12.Name : "" } } });
        s10.set(e17, l11);
      }
      for (const [e17, t12] of o11) {
        if ("" !== a11.get(t12)) continue;
        const n12 = t12;
        let r12 = e17;
        let c11 = i11.get(r12);
        for (; c11; ) r12 = c11, c11 = i11.get(r12);
        const u10 = o11.get(r12);
        const d10 = s10.get(u10).Name;
        l10.set(n12, d10);
      }
      if (s10.size > 0) {
        const e17 = {};
        for (const [t12, n12] of s10) j0(e17, t12, { $set: n12 });
        r11 = AV(r11, e17);
      }
      if (l10.size > 0) {
        const e17 = {};
        for (const [t12, n12] of l10) j0(e17, t12, { $fixedPlace: { OverflowName: { $set: n12 } } });
        n11 = AV(n11, e17);
      }
      return { originalPage: n11, copiedPage: r11 };
    }(t10, { originalPage: o10, copiedPage: a10 });
    o10 = e15.originalPage, a10 = e15.copiedPage;
  }
  const i10 = { Pages: {} };
  return o10 !== e14.Pages[n10] && (i10.Pages[n10] = { $set: o10 }), i10.Pages.$splice = [[n10 + 1, 0, a10]], CFt(AV(e14, i10));
}
function wFt(e14, t10) {
  const { Width: n10, Height: r10 } = p3(t10, e14.Name);
  const o10 = { Width: L$.parse(n10), Height: L$.parse(r10) };
  return e14.ReportItems.some((e15) => {
    const t11 = TFt(e15);
    return t11.Width.greaterThan(o10.Width) || t11.Height.greaterThan(o10.Height);
  });
}
const TFt = (e14) => ({ Width: L$.parse(e14.$place.Left).add(L$.parse(e14.$fixedPlace && e14.$fixedPlace.Width || e14.$place.Width)) || L$.zero, Height: L$.parse(e14.$place.Top).add(L$.parse(e14.$fixedPlace && e14.$fixedPlace.Height || e14.$place.Height)) || L$.zero });
const EFt = { type: uFt.Type, baseType: "fixedpagereport", labelKey: "reportItems:report", init: (e14, t10, n10, r10 = uFt) => {
  const { ConsumeContainerWhitespace: o10, Page: a10 } = r10;
  const i10 = a10 && { BottomMargin: a10.BottomMargin, LeftMargin: a10.LeftMargin, RightMargin: a10.RightMargin, TopMargin: a10.TopMargin, PageHeight: a10.PageHeight, PageWidth: a10.PageWidth, ColumnSpacing: a10.ColumnSpacing };
  return __spreadValues(__spreadProps(__spreadValues({}, uFt), { Name: e14 || "", ConsumeContainerWhitespace: o10, Page: __spreadValues(__spreadValues({}, uFt.Page), i10) }), n10);
}, icon: nf(Lae), defaultModel: uFt, getReducer: function(e14) {
  const t10 = DTt(e14);
  const n10 = nz.of(e14).getReducer(yFt.Type);
  return uA(kTt, bgt)(function r10(o10, a10) {
    var _a2;
    const { type: i10, payload: s10 } = a10;
    let l10 = o10 != null ? o10 : nz.of(e14).create("fixedpagereport");
    switch (i10) {
      case Hpt.type:
        return function(e15) {
          const t11 = AV(SFt.init(), { Name: { $set: `Page${e15.Pages.length + 1}` } });
          return AV(e15, { Pages: { $push: [t11] } });
        }(o10);
      case Ipt.type:
        return function(e15, t11) {
          if (1 === e15.Pages.length) throw new Error("Cannot delete the last page");
          const n11 = t11.Name;
          const r11 = e15.Pages.findIndex((e16) => e16.Name === n11);
          if (r11 < 0) throw new Error(`Page with name '${n11}' does not exist.`);
          let o11 = AV(e15, { Pages: { $splice: [[r11, 1]] } });
          return o11 = CFt(o11), V5(o11, h5([e15.Pages[r11 > 0 ? r11 - 1 : r11].Name]));
        }(o10, s10.page);
      case $G: {
        const { delta: e15 } = s10;
        const t11 = L$.isZeroLike(e15 && e15.x);
        const n11 = L$.isZeroLike(e15 && e15.y);
        if (t11 && n11) return o10;
        const r11 = {};
        return o10.Pages.forEach((t12, n12) => {
          let i11 = n5(t12, a10);
          if (i11 !== t12) {
            const s11 = function(e16, t13) {
              const { Width: n13, Height: r12 } = p3(t13, e16.Name);
              const o11 = { Width: L$.parse(n13), Height: L$.parse(r12) };
              let a11 = L$.zero;
              let i12 = L$.zero;
              return e16.ReportItems.forEach((e17) => {
                const t14 = TFt(e17);
                const n14 = t14.Width.subtract(o11.Width);
                const r13 = t14.Height.subtract(o11.Height);
                n14.greaterThan(a11) && (a11 = n14), r13.greaterThan(i12) && (i12 = r13);
              }), { x: a11, y: i12 };
            }(i11, o10);
            if (s11.x.greaterThan(L$.zero) || s11.y.greaterThan(L$.zero)) {
              const n13 = e15.y && L$.parse(e15.y).subtract(s11.y);
              const r12 = e15.x && L$.parse(e15.x).subtract(s11.x);
              if ((!n13 || n13.equal(L$.zero)) && (!r12 || r12.equal(L$.zero))) return;
              if (i11 = n5(t12, YG({ grip: a10.payload.grip, delta: { x: r12 && r12.css || e15.x, y: n13 && n13.css || e15.y } })), wFt(i11, o10)) {
                const { t: e16 } = hG();
                throw new B0(fG("fixedPageSize", e16), gG("fixedPageSize", e16));
              }
            }
            r11[n12] = { $set: i11 };
          }
        }), zV.isEmpty(r11) ? o10 : AV(o10, { Pages: r11 });
      }
      case XG.type:
      case KG.type: {
        (rj(l10) || l10.Layers.some((e16) => rj(e16))) && (l10 = V5(l10, c5("Pages.0", "fixedpagesection"))), l10 = Vj(l10, n10, a10);
        const e15 = l10.Pages.reduce((e16, t11) => e16 || wFt(t11, l10), false);
        if (e15) {
          const { t: e16 } = hG();
          throw new B0(fG("fixedPageSize", e16), gG("fixedPageSize", e16));
        }
        if (XG.match(a10)) {
          const { Style: e16 } = a10.payload;
          e16 && l10.Themes[0] && (l10 = t10(l10, v2({ id: e16.id, name: e16.name })), l10 = t10(l10, b2({ style: e16.content })));
        }
        return l10;
      }
      case O5.type:
      case o2.type:
      case l2.type: {
        const e15 = qwt(a10);
        if (e15) return r10(l10, e15);
        const t11 = Kwt(a10);
        if (t11) return r10(l10, t11);
        const { descriptor: n11, value: o11 } = s10;
        const i11 = s10.dataSetName || s10.dataSet;
        const c11 = vj(l10);
        if (0 === c11.length) break;
        n11 && "overflow_name" === n11.type && o11 && (l10 = ((e16, t12, n12) => {
          const r11 = e16.$index.NamedItems.find((e17) => e17.name === n12);
          if (!r11) return e16;
          const o12 = (e17, t13, n13, r12) => ({ path: e17, item: t13 || null, absLeft: n13, absTop: r12 });
          const a11 = (e17) => e17 === rW.fplSection || OW(e17);
          const i12 = [];
          let s11 = L$.zero;
          let l11 = L$.zero;
          const c12 = r11.$path.split(".");
          let u11 = e16;
          for (let t13 = 0; t13 < c12.length; t13++) {
            const n13 = c12[t13];
            if (u11 = u11[n13], u11.Type) {
              if (t13 < c12.length - 1 && !a11(u11.Type)) return e16;
              u11.Type !== rW.fplSection && (s11 = s11.add(L$.parse(u11.$place.Left)), l11 = l11.add(L$.parse(u11.$place.Top))), i12.unshift(o12(n13, u11, s11, l11));
            } else i12.unshift(o12(n13));
          }
          const d10 = h3(e16);
          const p10 = f3(e16);
          const m10 = L$.parse(t12.$fixedPlace.Width || t12.$width || t12.$place.Width);
          const h10 = L$.parse(t12.$fixedPlace.Height || t12.$height || t12.$place.Height);
          let [f10, g10, y10, v10] = [L$.zero, L$.zero, L$.zero, L$.zero];
          let b10 = {};
          return i12.forEach((e17, t13) => {
            const { path: n13, item: r12, absLeft: o13, absTop: a12 } = e17;
            if (!r12 || r12.Type === rW.fplSection) return void (b10 = { [n13]: b10 });
            const i13 = 0 === t13 ? m10 : f10.add(y10);
            f10 = L$.parse(r12.$place.Left), y10 = L$.parse(r12.$place.Width);
            let s12 = false;
            if (y10.lowerThan(i13)) {
              const e18 = d10.subtract(o13);
              if (e18.lowerThan(i13)) {
                const t14 = i13.subtract(e18);
                f10 = f10.greaterThan(t14) ? f10.subtract(t14) : L$.zero;
              }
              s12 = true;
            }
            (0 === t13 || s12) && (y10 = i13);
            const l12 = 0 === t13 ? h10 : g10.add(v10);
            g10 = L$.parse(r12.$place.Top), v10 = L$.parse(r12.$place.Height);
            let c13 = false;
            if (v10.lowerThan(l12)) {
              const e18 = p10.subtract(a12);
              if (e18.lowerThan(l12)) {
                const t14 = l12.subtract(e18);
                g10 = g10.greaterThan(t14) ? g10.subtract(t14) : L$.zero;
              }
              c13 = true;
            }
            (0 === t13 || c13) && (v10 = l12), b10 = { [n13]: __spreadValues({ $width: { $set: y10.css }, $height: { $set: v10.css }, $place: { Left: { $set: f10.css }, Top: { $set: g10.css }, Width: { $set: y10.css }, Height: { $set: v10.css } } }, b10) };
          }), AV(e16, b10);
        })(l10, c11[0].item, o11));
        c11.some((e16) => !zj(l10, e16.path)) && i11 && !l10.DataSetName && (l10 = AV(l10, { DataSetName: { $set: i11 } }));
        break;
      }
      case _pt.type: {
        const { fromIndex: e15, toIndex: t11 } = a10.payload;
        let n11 = AV(o10, { $activePageIndex: { $set: t11 }, Pages: { $splice: [[e15, 1], [t11, 0, o10.Pages[e15]]] } });
        return n11 = CFt(n11), n11;
      }
      case Vpt.type:
        return function(e15, t11) {
          if (t11 < 0 || t11 > e15.Pages.length) throw new z0("Invalid page index");
          let n11 = AV(e15, { Pages: { $splice: [[t11, 0, SFt.init()]] } });
          return n11 = CFt(n11), n11;
        }(o10, s10.index);
      case Rpt.type:
        return xFt(o10, e14, s10.index);
      case Apt.type:
        return function(e15, t11) {
          if (t11 < 0 || t11 > e15.Pages.length) throw new z0("Invalid page index");
          const n11 = dpt(e15.Pages[t11].Visibility.Hidden);
          return AV(e15, { Pages: { [t11]: { Visibility: { Hidden: { $set: n11 ? "False" : "True" } } } } });
        }(o10, s10.index);
      case UG: {
        const e15 = {};
        return o10.Pages.forEach((t11, n11) => {
          if (!aj(t11)) return;
          const r11 = p3(o10, t11.Name);
          let i11 = n5(t11, a10);
          if (i11 !== t11) {
            if (i11 = n5(i11, C7({ maxWidth: L$.parse(r11.Width), maxHeight: L$.parse(r11.Height), offsetLeft: L$.zero, offsetTop: L$.zero })), wFt(i11, o10)) {
              const { t: e16 } = hG();
              throw new B0(fG("fplPasteFailed", e16), gG("fplPasteFailed", e16));
            }
            e15[n11] = { $set: i11 };
          }
        }), zV.isEmpty(e15) ? o10 : AV(o10, { Pages: e15 });
      }
      case H2.type: {
        const { margins: t11 } = a10.payload;
        const { units: n11 } = KO.of(e14).userPreferences;
        return ((e15, t12, n12) => {
          const { PageWidth: r11, PageHeight: o11 } = e15.Page;
          const a11 = lPe(e15);
          const i11 = Uke(n12);
          const s11 = { width: qke([a11.width, i11]), height: qke([a11.height, i11]) };
          const l11 = { width: L$.parse(r11).subtract(s11.width), height: L$.parse(o11).subtract(s11.height) };
          return oPe(e15, t12, l11);
        })(l10, t11, n11);
      }
      case I2.type: {
        const { pageSize: t11 } = a10.payload;
        const { units: n11 } = KO.of(e14).userPreferences;
        return ((e15, t12, n12) => {
          const { LeftMargin: r11, TopMargin: o11, RightMargin: a11, BottomMargin: i11 } = e15.Page;
          const s11 = lPe(e15);
          const l11 = Uke(n12);
          const c11 = { width: qke([s11.width, l11]), height: qke([s11.height, l11]) };
          const u11 = { width: L$.parse(r11).add(L$.parse(a11)).add(c11.width), height: L$.parse(o11).add(L$.parse(i11)).add(c11.height) };
          return uPe(e15, t12, u11);
        })(l10, t11, n11);
      }
    }
    const c10 = t10(l10, a10);
    if ((_a2 = a10.meta) == null ? void 0 : _a2.skipFplRestrictionsValidation) return c10;
    const u10 = c10.Pages.reduce((e15, t11) => e15 || wFt(t11, c10), false);
    if (u10) {
      const { t: e15 } = hG();
      throw new B0(fG("fixedPageSize", e15), gG("fixedPageSize", e15));
    }
    return c10;
  });
}, getProperties: (e14, t10, n10) => {
  var _a2, _b2, _c2, _d2, _e2;
  const r10 = (_c2 = (_b2 = (_a2 = n10 == null ? void 0 : n10.settings) == null ? void 0 : _a2.rdlx) == null ? void 0 : _b2.reportThemes) == null ? void 0 : _c2.prohibitMultipleThemes;
  const o10 = r10 ? fFt : gFt;
  return ((_e2 = (_d2 = n10 == null ? void 0 : n10.settings) == null ? void 0 : _d2.rdlx) == null ? void 0 : _e2.reportCollapseWhitespace) && o10.push(VY), o10;
}, getContextActions: function(e14, t10, n10) {
  const { lockLayout: r10 } = KO.of(t10);
  const o10 = [];
  const a10 = [{ type: "theme", icon: iFt.SwitchTheme, key: aFt("switchTheme"), action: g2 }];
  const i10 = { type: "dropdown", key: aFt("pages"), icon: iFt.Pages, actions: [] };
  if (!r10) {
    const t11 = lFt(e14);
    a10.unshift(...t11, { type: "separator", key: "" }), i10.actions.push(...t11);
  }
  return i10.disabled = 0 === i10.actions.filter((e15) => "separator" !== e15.type && !e15.disabled).length, o10.push(i10), [...i0e(e14, t10, n10), { type: "group", key: aFt("title"), actions: a10, location: "toolbar" }, { type: "group", key: aFt("title"), actions: o10, location: "contextmenu" }];
}, features: { isDataRegion: true, isFplItem: true, getExpressionProperties: function() {
  return cFt;
}, getPageDimensions: (e14) => {
  var _a2, _b2, _c2, _d2, _e2, _f2;
  const t10 = e14.Pages[e14.$activePageIndex];
  const n10 = e14.Page;
  return { pageWidth: L$.parse((_a2 = t10 == null ? void 0 : t10.Width) != null ? _a2 : n10.PageWidth), pageHeight: L$.parse((_b2 = t10 == null ? void 0 : t10.Height) != null ? _b2 : n10.PageHeight), margins: { top: L$.parse((_c2 = t10 == null ? void 0 : t10.TopMargin) != null ? _c2 : n10.TopMargin), bottom: L$.parse((_d2 = t10 == null ? void 0 : t10.BottomMargin) != null ? _d2 : n10.BottomMargin), left: L$.parse((_e2 = t10 == null ? void 0 : t10.LeftMargin) != null ? _e2 : n10.LeftMargin), right: L$.parse((_f2 = t10 == null ? void 0 : t10.RightMargin) != null ? _f2 : n10.RightMargin) } };
}, getPageSectionsInfo: (e14) => {
  var _a2, _b2, _c2, _d2, _e2, _f2;
  const t10 = e14.Pages[e14.$activePageIndex];
  const n10 = L$.parse((_a2 = t10.TopMargin) != null ? _a2 : e14.Page.TopMargin);
  const r10 = L$.parse((_b2 = t10.BottomMargin) != null ? _b2 : e14.Page.BottomMargin);
  const o10 = L$.parse((_c2 = t10.LeftMargin) != null ? _c2 : e14.Page.LeftMargin);
  const a10 = L$.parse((_d2 = t10.RightMargin) != null ? _d2 : e14.Page.RightMargin);
  const i10 = L$.parse((_e2 = t10.Width) != null ? _e2 : e14.Page.PageWidth).subtract(o10).subtract(a10);
  const s10 = L$.parse((_f2 = t10.Height) != null ? _f2 : e14.Page.PageHeight).subtract(n10).subtract(r10);
  return [{ container: t10, path: `Pages.${e14.$activePageIndex}`, offset: { top: n10, left: o10, width: i10, height: s10 } }];
}, disableCopy: true } };
const FFt = ["NoRowsMessage"];
const MFt = FZ.resultOf(wq.decode({ Type: "subreport", Name: "subreport1", Width: "2in", Height: "2in" }));
const kFt = (e14) => `subreport.${e14}`;
const PFt = [FY.NoRowsMessage, vY.FontSimple, vY.Color, vY.Font, vY.TextDecoration, vY.TextAlign, vY.VerticalAlign, vY.Format].map((e14) => __spreadProps(__spreadValues({}, e14), { category: `propertyDescriptors:categories.${pY}` }));
const NFt = [EY.Name, Zq(tY, "", "subreport", ""), Zq(tY, kFt("reportParameters"), "subreport_parameters", "Parameters"), EY.DataElementName, EY.DataElementOutput_AON, Zq(rY, kFt("mergeTransactions"), "boolean", "MergeTransactions", "advanced"), vY.Borders, EY.Location, EY.Size, vY.Padding, EY.LayerName, EY.KeepTogether, EY.ZIndex, ...PFt, EY.Visibility, vY.Calendar, vY.Direction, vY.Language, vY.NumeralLanguage, vY.NumeralVariant, vY.UnicodeBiDi, vY.UprightInVerticalText, vY.WritingMode, EY.PageName, EY.ToolTip, EY.Label, EY.Bookmark, Zq(dY, kFt("inheritStyleSheet"), "boolean", "InheritStyleSheet", "advanced"), Zq(dY, kFt("substituteThemeOnSubreport"), "boolean", "SubstituteThemeOnSubreport", "advanced")];
const DFt = { type: "subreport", labelKey: "reportItems:subreport", nameTemplateKey: "nameTemplates:subreport", defaultModel: MFt, icon: nf(Cae), icon24: nf(xae), init: (e14, t10, n10, r10 = MFt) => __spreadProps(__spreadValues(__spreadValues({}, r10), n10), { Name: e14 || "" }), getReducer: q5, glyph: ({ item: { Type: e14, Name: t10 }, path: n10 }) => tp.createElement("div", { className: kp("ar-item", "ar-subreport"), "data-type": e14, "data-path": n10 }, tp.createElement("span", null, t10)), getProperties: (e14, t10, n10) => (n10 == null ? void 0 : n10.isDashboard) ? n4(NFt) : NFt, getContextActions: i0e, features: { getExpressionProperties: function() {
  return FFt;
} } };
const LFt = ["KeepTogether"];
const HFt = "fixedpagesubreport";
const IFt = { $fixedPlace: { OverflowName: "" } };
const _Ft = NFt.filter((e14) => !LFt.includes(e14.valuePath)).concat(FY.OverflowName);
const VFt = __spreadValues(__spreadProps(__spreadValues({}, DFt.defaultModel), { Type: HFt }), IFt);
const RFt = { type: HFt, baseType: "subreport", labelKey: DFt.labelKey, nameTemplateKey: DFt.nameTemplateKey, defaultModel: VFt, icon: DFt.icon, icon24: DFt.icon24, init: (e14, t10, n10, r10 = VFt) => {
  const { units: o10 } = KO.of(t10).userPreferences;
  const a10 = __spreadProps(__spreadValues({}, DFt.init && DFt.init(e14, o10, n10, r10)), { Type: HFt });
  return z5(a10, IFt, false, false);
}, getProperties: () => _Ft, glyph: DFt.glyph, getReducer: DFt.getReducer, features: { getExpressionProperties: DFt.getExpressionProperties, isFplItem: true } };
const AFt = (e14, t10) => {
  if (!t10) return e14;
  const n10 = {};
  return Object.getOwnPropertyNames(e14).forEach((r10) => {
    t10.hasOwnProperty(r10) ? n10[r10] = t10[r10] : n10[r10] = e14[r10];
  }), n10;
};
const OFt = (e14, t10) => {
  const { rdlx: { reportItemsFeatures: { table: n10 } } } = KO.of(t10);
  const r10 = n10.canMergeCellsVertically;
  let o10 = null;
  let [a10, i10, s10, l10] = [Number.MAX_VALUE, Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE];
  let c10 = false;
  let u10 = 0;
  if (((e15, t11) => {
    GQ(e15, (e16, n11, r11) => (t11(e16, n11, r11), e16));
  })(e14, (e15) => {
    if (c10) return;
    const t11 = {};
    e15.forEach((e16, n11) => {
      aj(e16) && e16.TableCells.forEach((e17, r11) => {
        if (e17 && aj(e17)) {
          u10++;
          for (let o11 = n11; o11 < n11 + e17.RowSpan; o11++) for (let n12 = r11; n12 < r11 + e17.ColSpan; n12++) t11[o11] || (t11[o11] = {}), t11[o11][n12] = true, n12 < i10 && (i10 = n12), n12 > l10 && (l10 = n12), o11 < a10 && (a10 = o11), o11 > s10 && (s10 = o11);
        }
      });
    }), Object.keys(t11).length > 0 && (o10 ? c10 = true : o10 = t11);
  }), !r10 && a10 !== s10) return false;
  if (c10 || u10 < 2) return false;
  for (let e15 = a10; e15 <= s10; e15++) for (let t11 = i10; t11 <= l10; t11++) if (!o10[e15] || !o10[e15][t11]) return false;
  return true;
};
const BFt = (e14) => {
  let t10 = false;
  return XQ(e14, ({ item: e15, colSpan: n10, rowSpan: r10 }) => {
    aj(e15) && (n10 > 1 || r10 > 1) && (t10 = true);
  }), t10;
};
const zFt = (e14) => `contextActions:table.${e14}`;
const $Ft = (e14) => e14.reduce((e15, t10) => e15 || !t10.disabled, false);
const WFt = (e14, t10, n10) => ({ type: "group", icon: e14, key: t10, actions: n10.filter((e15) => "dropdown" !== e15.type || !e15.disabled) });
const jFt = (e14, t10, n10, r10) => ({ type: "button", icon: e14, key: zFt(t10), disabled: n10, action: r10, textKey: zFt(t10) });
const ZFt = (e14, t10, n10, r10, o10, a10) => ({ type: "dialog", icon: e14, key: zFt(t10), disabled: n10, dialogName: "addRowsColumns", dialogProps: { onSave: r10, positionEnum: o10, isRow: a10 } });
const GFt = (e14, t10, n10) => ({ type: "dropdown", icon: e14, key: zFt(t10), disabled: !$Ft(n10), actions: n10 });
const UFt = (e14, t10, n10, r10) => ({ type: "button", icon: e14, key: t10, disabled: n10, action: r10 });
const qFt = (e14) => ({ type: "separator", key: e14 ? zFt(e14) : "" });
const YFt = { TableHeaderAdd: W1e(WQe), TableHeaderRemove: W1e(jQe), TableDetailsAdd: W1e(_Qe), TableDetailsRemove: W1e(VQe), TableFooterAdd: W1e(RQe), TableFooterRemove: W1e(AQe), Groups: W1e(gQe), GroupInsertChild: W1e(TQe), DeleteGroup: W1e(FQe), GroupHeaderAdd: W1e(zQe), GroupHeaderRemove: W1e($Qe), GroupFooterAdd: W1e(OQe), GroupFooterRemove: W1e(BQe), Cells: W1e(aQe), SplitCells: W1e(sQe), MergeCells: W1e(iQe), Columns: W1e(lQe), InsertColumnLeft: W1e(uQe), InsertColumnRight: W1e(mQe), DeleteColumn: W1e(cQe), Rows: W1e(IQe), InsertRowAbove: W1e(kQe), InsertRowBelow: W1e(DQe), DeleteRow: W1e(MQe) };
const KFt = (e14) => {
  const t10 = JQ(e14);
  const n10 = ((e15) => {
    let t11 = 0;
    return e15.TableGroups.forEach((e16) => {
      aj(e16) && e16.Header && (t11 += e16.Header.TableRows.length);
    }), t11;
  })(e14);
  const r10 = ((e15) => {
    let t11 = 0;
    return e15.TableGroups.forEach((e16) => {
      aj(e16) && e16.Footer && (t11 += e16.Footer.TableRows.length);
    }), t11;
  })(e14);
  return [n10 > 0 ? jFt(YFt.GroupHeaderRemove, "removeGroupHeader", n10 >= t10, TVe()) : jFt(YFt.GroupHeaderAdd, "addGroupHeader", false, TVe()), r10 > 0 ? jFt(YFt.GroupFooterRemove, "removeGroupFooter", r10 >= t10, EVe()) : jFt(YFt.GroupFooterAdd, "addGroupFooter", false, EVe())];
};
const XFt = (e14) => e14.TableGroups.some((e15) => aj(e15)) && ((e15) => e15.TableGroups.some((e16) => !aj(e16) && (e16.Header || e16.Footer)) || [e15.Header, e15.Footer, e15.Details].some((e16) => e16))(e14);
const JFt = (e14) => jFt(YFt.DeleteGroup, "deleteGroup", !XFt(e14), SVe());
const QFt = (e14, t10 = false) => {
  const n10 = e14.TableGroups.some((e15) => aj(e15));
  return [GFt(YFt.Groups, "groupTitle", [jFt(YFt.GroupInsertChild, "insertGroup", false, { type: eVe, payload: {} }), ...t10 && n10 ? [qFt(), ...KFt(e14)] : [], qFt(), JFt(e14)])];
};
const eMt = (e14, t10) => [GFt(YFt.Cells, "cellsTitle", [jFt(YFt.MergeCells, "mergeCells", !OFt(e14, t10), { type: Y_e, payload: {} }), jFt(YFt.SplitCells, "splitCells", !BFt(e14), { type: K_e, payload: {} })])];
const tMt = (e14, t10) => [GFt(YFt.Rows, "rowTitle", [qFt("insertRowTitle"), jFt(YFt.InsertRowAbove, "insertRow.above", false, hVe(mVe.BEFORE)), jFt(YFt.InsertRowBelow, "insertRow.below", false, hVe(mVe.AFTER)), ZFt(YFt.Rows, "more", false, (e15, t11) => hVe(t11, e15), [{ name: zFt("insertRow.above"), value: mVe.BEFORE }, { name: zFt("insertRow.below"), value: mVe.AFTER }], true), qFt(), jFt(YFt.DeleteRow, "deleteRow", !t10, vVe())])];
const nMt = (e14, t10) => [GFt(YFt.Columns, "columnTitle", [qFt("insertColumnTitle"), jFt(YFt.InsertColumnLeft, "insertColumn.left", false, fVe(mVe.BEFORE)), jFt(YFt.InsertColumnRight, "insertColumn.right", false, fVe(mVe.AFTER)), ZFt(YFt.Columns, "more", false, (e15, t11) => fVe(t11, e15), [{ name: zFt("insertColumn.left"), value: mVe.BEFORE }, { name: zFt("insertColumn.right"), value: mVe.AFTER }], false), qFt(), jFt(YFt.DeleteColumn, "deleteColumn", !t10, bVe())])];
const rMt = (e14) => [e14.Header, e14.Footer, e14.Details].filter((e15) => !!e15).length > 1 || e14.TableGroups.some((e15) => e15.Header || e15.Footer);
const oMt = (e14) => {
  const t10 = rMt(e14);
  return [e14.Header ? jFt(YFt.TableHeaderRemove, "removeHeader", !t10, CVe()) : jFt(YFt.TableHeaderAdd, "addHeader", false, CVe()), e14.Details ? jFt(YFt.TableDetailsRemove, "removeDetails", !t10, wVe()) : jFt(YFt.TableDetailsAdd, "addDetails", false, wVe()), e14.Footer ? jFt(YFt.TableFooterRemove, "removeFooter", !t10, xVe()) : jFt(YFt.TableFooterAdd, "addFooter", false, xVe())];
};
const aMt = (e14, t10, n10) => {
  let [r10, o10] = [null, null];
  t10.lowerThan(L$.zero) && (r10 = 0), n10.lowerThan(L$.zero) && (o10 = 0);
  let a10 = L$.zero;
  for (let i10 = 0; i10 < e14.length; i10++) {
    const s10 = a10.add(e14[i10]);
    if (null === r10 && a10.absLowerThanOrEqual(t10) && t10.absLowerThanOrEqual(s10) && (r10 = i10), null === o10 && a10.absLowerThanOrEqual(n10) && n10.absLowerThanOrEqual(s10) && (o10 = i10), null !== r10 && null !== o10) break;
    a10 = s10;
  }
  return null === r10 && (r10 = e14.length - 1), null === o10 && (o10 = e14.length - 1), [r10, o10];
};
const iMt = (e14, t10, n10, { left: r10, top: o10, width: a10, height: i10 }) => {
  const [s10, l10] = [o10.add(i10), r10.add(a10)];
  const [c10, u10] = aMt(e14, o10, s10);
  const [d10, p10] = aMt(t10, r10, l10);
  let [m10, h10] = [Math.min(d10, p10), Math.max(d10, p10)];
  let [f10, g10] = [Math.min(c10, u10), Math.max(c10, u10)];
  return n10.forEach((e15) => {
    (m10 <= e15.colIdx && e15.colIdx <= h10 || e15.colIdx < m10 && m10 < e15.colIdx + e15.colSpan) && (f10 <= e15.rowIdx && e15.rowIdx <= g10 || e15.rowIdx < f10 && f10 < e15.rowIdx + e15.rowSpan) && (e15.colIdx < m10 && (m10 = e15.colIdx), e15.colIdx + e15.colSpan > h10 + 1 && (h10 = e15.colIdx + e15.colSpan - 1), e15.rowIdx < f10 && (f10 = e15.rowIdx), e15.rowIdx + e15.rowSpan > g10 + 1 && (g10 = e15.rowIdx + e15.rowSpan - 1));
  }), { firstColumn: m10, lastColumn: h10, firstRow: f10, lastRow: g10 };
};
const sMt = (e14, t10 = 1) => {
  const [n10, r10, o10] = [N0e(e14.getDifferenceFromInitialOffset(), t10), N0e(e14.getInitialClientOffset(), t10), e14.getInitialSourceClientOffset() || { x: 0, y: 0 }];
  let [a10, i10] = [n10.x, n10.y];
  let [s10, l10] = [r10.x - o10.x, r10.y - o10.y];
  return a10 < 0 && ([s10, a10] = [s10 + a10, -a10]), i10 < 0 && ([l10, i10] = [l10 + i10, -i10]), zV.mapValues({ left: s10, top: l10, width: a10, height: i10 }, (e15) => L$.fromPixels(e15));
};
const lMt = H0e(I0e((e14, t10, n10, r10, o10, a10) => {
  const i10 = ((e15, t11, n11, r11) => {
    let [o11, a11, i11, s11] = [];
    const { firstColumn: l11, lastColumn: c10, firstRow: u10, lastRow: d10 } = iMt(e15, t11, n11, r11);
    let p10 = L$.zero;
    for (let t12 = 0; t12 < e15.length; t12++) {
      const n12 = p10.add(e15[t12]);
      if (t12 === u10 && (i11 = p10), t12 === d10 && (s11 = n12), void 0 !== i11 && void 0 !== s11) break;
      p10 = n12;
    }
    let m10 = L$.zero;
    for (let e16 = 0; e16 < t11.length; e16++) {
      const n12 = m10.add(t11[e16]);
      if (e16 === l11 && (o11 = m10), e16 === c10 && (a11 = n12), void 0 !== o11 && void 0 !== a11) break;
      m10 = n12;
    }
    return { left: o11, top: i11, width: a11.subtract(o11), height: s11.subtract(i11) };
  })(t10, n10, r10, e14);
  const s10 = ((e15) => {
    let t11 = e15;
    const n11 = (t11 == null ? void 0 : t11.getBoundingClientRect()) || { left: 0, top: 0 };
    for (; t11 && (!t11.classList || !t11.classList.contains("is-report-area")); ) t11 = t11.parentElement;
    const r11 = t11 && t11.getBoundingClientRect() || n11;
    return zV.mapValues({ x: n11.left - r11.left, y: n11.top - r11.top }, (e16) => L$.fromPixels(e16));
  })(o10);
  const l10 = __spreadProps(__spreadValues({}, i10), { left: i10.left.add(s10.x), top: i10.top.add(s10.y) });
  P0e("", [__spreadValues({ type: "selarea" }, zV.mapValues(l10, (e15) => e15.css))], a10);
}), (e14) => e14);
const cMt = (e14, t10) => {
  const n10 = t1(t10);
  const r10 = i4(e14, t10.$templateId);
  const o10 = { cellsWidth: n10.map((e15) => e15.css), cellHeight: r10.height, createCellItem: s4(e14, t10.LayerName, t10.$templateId) };
  return d4(e14, o10);
};
const uMt = (e14, t10, n10) => {
  const r10 = {};
  return e14.TableCells.forEach((e15, o10) => {
    e15 && 1 !== e15.RowSpan && n10 < t10 + e15.RowSpan && (r10[o10] = { RowSpan: { $apply: (e16) => e16 + 1 } });
  }), zV.isEmpty(r10) ? e14 : AV(e14, { TableCells: r10 });
};
const dMt = (e14) => {
  const t10 = (e15) => {
    const t11 = {};
    return e15.TableRows.forEach((n10, r10) => {
      n10.TableCells.forEach((n11, o10) => {
        if (!n11) return;
        const a10 = n11.ColSpan || 1;
        const i10 = n11.RowSpan || 1;
        for (let n12 = r10; n12 < r10 + i10; n12++) for (let i11 = o10; i11 < o10 + a10; i11++) {
          if (n12 === r10 && i11 === o10) continue;
          null !== e15.TableRows[n12].TableCells[i11] && (t11[n12] || (t11[n12] = {}), t11[n12].TableCells || (t11[n12].TableCells = {}), t11[n12].TableCells[i11] = { $set: null });
        }
      });
    }), zV.isEmpty(t11) ? e15 : AV(e15, { TableRows: t11 });
  };
  return $Q(e14, (e15) => {
    if ("tablegroup" === e15.Type) {
      const n10 = {};
      if (e15.Header) {
        const r10 = t10(e15.Header);
        e15.Header !== r10 && (n10.Header = { $set: r10 });
      }
      if (e15.Footer) {
        const r10 = t10(e15.Footer);
        e15.Footer !== r10 && (n10.Footer = { $set: r10 });
      }
      return zV.isEmpty(n10) ? e15 : AV(e15, n10);
    }
    return t10(e15);
  });
};
function pMt(e14, t10, n10, r10) {
  let o10 = t10;
  return o10 = UQ(t10, (o11, a10) => {
    if (r10 === mVe.AFTER) {
      if (a10 < n10 - 1) return [uMt(o11, a10, n10)];
      if (a10 === n10 - 1) return [uMt(o11, a10, n10), cMt(e14, t10)];
    } else if (r10 === mVe.BEFORE) {
      if (a10 < n10) return [uMt(o11, a10, n10)];
      if (a10 === n10) return [cMt(e14, t10), o11];
    }
    return [o11];
  }), o10 = dMt(o10), o10;
}
function mMt(e14, t10, n10) {
  const r10 = e1(t10);
  const o10 = i4(e14, t10.$templateId).width;
  let a10 = t10;
  return a10 = qQ(a10, (a11, i10) => {
    let s10 = a11.TableCells;
    const l10 = s10.findIndex((e15, t11) => e15 && t11 < n10 && t11 + e15.ColSpan > n10);
    if (l10 >= 0) s10 = AV(s10, { [l10]: { ColSpan: { $apply: (e15) => e15 + 1 } }, $splice: [[n10, 0, null]] });
    else {
      const a12 = { width: o10, height: r10[i10].css, createCellItem: s4(e14, t10.LayerName, t10.$templateId) };
      s10 = AV(s10, { $splice: [[n10, 0, l4(e14, a12)]] });
    }
    return AV(a11, { TableCells: { $set: s10 } });
  }), a10 = dMt(a10), a10 = AV(a10, { TableColumns: { $splice: [[n10, 0, X5({ Width: o10 })]] } }), a10;
}
const [hMt] = Dp("wd-table-overlay");
const [fMt, gMt, yMt] = Dp("wd-column-drop");
const [vMt] = yMt("icon");
const bMt = ({ columnSizes: e14, path: t10, table: n10, dispatch: r10 }) => {
  let o10 = new L$(0, "in");
  const a10 = { dispatch: r10, tablePath: t10 };
  return tp.createElement("div", { className: hMt }, e14.map((e15, t11) => {
    const r11 = o10.css;
    return o10 = e15.add(o10), tp.createElement(SMt, __spreadProps(__spreadValues({ key: t11 }, a10), { colIdx: t11, left: r11, colWidth: e15.css, table: n10 }));
  }), tp.createElement(SMt, __spreadProps(__spreadValues({}, a10), { colIdx: e14.length, left: o10.css, colWidth: 0, table: n10 })));
};
const SMt = ({ colIdx: e14, tablePath: t10, left: n10, dispatch: r10, colWidth: o10, table: a10 }) => {
  const { getReport: i10, instanceId: s10 } = ep.useContext(bqe);
  const l10 = rf(Xm);
  const [{ isDragging: c10, isHovering: u10, item: d10 }, p10] = are({ accept: ["field", "smartSuggestion", "fields", "table_column"], drop: (n11) => {
    if ("table_column" === n11.type) {
      return { dropIndex: "before" === n11.getDropSide(e14) ? e14 : e14 + 1 };
    }
    const { dataSetName: o11 } = n11;
    let i11 = [];
    if ("field" === n11.type) {
      const { field: e15 } = n11;
      i11 = [e15];
    }
    if ("fields" === n11.type) {
      const { fields: e15 } = n11;
      i11 = [...e15].sort((e16, t11) => {
        const n12 = t11.index[0] - e16.index[0];
        return 0 !== n12 ? n12 : 1 === t11.index.length ? -1 : 1 === e16.index.length ? 1 : t11.index[1] - e16.index[1];
      });
    }
    const l11 = i11.reduce((n12, r11) => {
      const { variationFormat: i12, value: l12, name: c11, aggregate: u11, dataType: d11, format: p11 } = r11;
      const m11 = ((e15, t11, n13) => {
        var _a2, _b2, _c2, _d2, _e2, _f2;
        if (!e15) return null;
        const r12 = e15.TableColumns.length === t11 ? mMt(n13, e15, t11) : e15;
        const o12 = (_b2 = (_a2 = r12.Details) == null ? void 0 : _a2.TableRows.findIndex((e16) => e16.TableCells[t11])) != null ? _b2 : -1;
        if (o12 >= 0) return `Details.TableRows.${o12}.TableCells.${t11}.Item`;
        const [a11, i13] = r12.TableGroups.reduce((e16, n14, r13) => {
          var _a3, _b3;
          const o13 = (_b3 = (_a3 = n14.Footer) == null ? void 0 : _a3.TableRows.findIndex((e17) => e17.TableCells[t11])) != null ? _b3 : -1;
          return n14.Footer && -1 !== o13 ? [r13, o13] : e16;
        }, [-1, -1]);
        if (a11 >= 0 && i13 >= 0) return `TableGroups.${a11}.Footer.TableRows.${i13}.TableCells.${t11}.Item`;
        const s11 = (_d2 = (_c2 = r12.Footer) == null ? void 0 : _c2.TableRows.findIndex((e16) => e16.TableCells[t11])) != null ? _d2 : -1;
        if (s11 >= 0) return `Footer.TableRows.${s11}.TableCells.${t11}.Item`;
        let l13 = -1;
        const c12 = r12.TableGroups.findIndex((e16) => {
          var _a3, _b3;
          return l13 = (_b3 = (_a3 = e16.Header) == null ? void 0 : _a3.TableRows.findIndex((e17) => e17.TableCells[t11])) != null ? _b3 : -1, -1 !== l13;
        });
        if (c12 >= 0) return `TableGroups.${c12}.Header.TableRows.${l13}.TableCells.${t11}.Item`;
        const u12 = (_f2 = (_e2 = r12.Header) == null ? void 0 : _e2.TableRows.findIndex((e16) => e16.TableCells[t11])) != null ? _f2 : -1;
        return u12 >= 0 ? `Header.TableRows.${u12}.TableCells.${t11}.Item` : null;
      })(a10, e14, s10);
      const h11 = `${t10}.${m11}`;
      const f11 = wee(((e15) => {
        if (!e15) return null;
        const t11 = e15.split(".");
        return t11.includes("Details") ? dee : t11.includes("Header") ? t11.includes("TableGroups") ? fee : pee : t11.includes("Footer") ? t11.includes("TableGroups") ? gee : mee : null;
      })(m11)) ? u11 : null;
      const g10 = i12 ? `=${U1(l12, i12)}` : `=${G1(l12, null, f11)}`;
      const y10 = u11 || d11 || i12 ? { aggregate: u11 || "", type: d11 || "string", variationFormat: i12 || "" } : null;
      return [...n12, yVe(e14), c5(h11, rW.textbox), i2({ valuePath: "Value" }, g10, o11, c11, false, y10), o2({ descriptor: { valuePath: "Style.Format" }, value: p11 || "" })];
    }, [c5(`${t10}.TableColumns.0`, rW.tableColumn)]);
    r10(rz(l11));
  }, canDrop: (t11) => "table_column" === t11.type ? t11.canDrop(e14) : !b6(i10()), collect: (e15) => ({ isDragging: e15.canDrop(), isHovering: e15.isOver(), item: e15.getItem() }) });
  const m10 = d10 && "table_column" === d10.type;
  const h10 = kp(fMt, { [gMt("hover")]: u10, [gMt("active")]: c10, [gMt("fill-column")]: m10 }, m10 && gMt(`drop-${d10.getDropSide(e14)}`));
  const f10 = m10 ? o10 : void 0;
  return tp.createElement("div", { ref: p10, className: h10, style: { left: n10, width: f10 } }, tp.createElement("div", { className: vMt }, tp.createElement(Fm, { icon: l10, customCSS: "wd-svg" })));
};
const CMt = ({ colIdx: e14, selection: { indices: t10, ranges: n10 }, hasMergedCells: r10 }) => {
  const o10 = PA();
  const [, a10, i10] = Yne({ item: { type: "table_column", canDrop: (n11) => !t10.includes(n11) && !r10(n11, n11 < e14 ? "before" : "after"), getDropSide: (t11) => t11 < e14 ? "before" : "after" }, end: (e15, n11) => {
    const r11 = n11.getDropResult();
    if (!r11) return;
    const { dropIndex: a11 } = r11;
    o10({ type: Q_e, payload: { from: t10, to: a11 } });
  }, canDrag: () => t10.includes(e14) && n10.every((e15) => !r10(e15, "both")) });
  return ep.useEffect(() => {
    i10(Coe());
  }, [i10]), { columnDragRef: a10 };
};
function xMt({ path: e14, type: t10 }) {
  const n10 = { className: "ar-item table-adorner-move-grip", "data-path": e14, "data-type": t10 };
  return tp.createElement("div", __spreadValues({}, n10), tp.createElement(Fm, { icon: nf(mqe, { cssClass: hqe }) }));
}
function wMt({ action: e14, index: t10, isColumn: n10, tableWidth: r10, tableHeight: o10, dndEnabled: a10, type: i10, path: s10 }) {
  const { getReport: l10 } = ep.useContext(bqe);
  const { lockLayout: c10 } = Uae();
  const u10 = PA();
  const d10 = rf(Xm);
  const [, p10] = Yne({ item: { type: D0e.RESIZEGRIP }, canDrag: () => true, begin: () => {
    let e15 = l10();
    const t11 = [];
    if (s10) {
      const n11 = s10.split(".").reduce((e16, t12) => e16 && e16[t12], e15);
      if (n11 && !sj(n11)) {
        const n12 = c5(s10, i10);
        e15 = n5(e15, n12), t11.push(n12);
      }
    }
    return { type: "resizegrip", path: s10, startDndActions: t11, resize: true, reportState: e15, grips: n10 ? qG.E : qG.S };
  } });
  if (c10) return null;
  const m10 = ep.useCallback(() => {
    u10(e14);
  }, [u10]);
  const h10 = n10 ? { height: o10 } : { width: r10 };
  return tp.createElement("div", { className: "table-adorner-spot" + (n10 ? " column-spot" : " row-spot") }, tp.createElement("div", { className: "table-adorner-spot-add" }, tp.createElement("div", { className: "table-adorner-spot-add-button", onClick: m10 }, tp.createElement(Fm, { icon: d10, customCSS: "wd-svg" })), tp.createElement("div", { className: "table-adorner-spot-add-deco" }, tp.createElement("div", { className: "table-adorner-spot-add-deco-area" }, tp.createElement("div", { style: h10 })))), t10 >= 0 && a10 && tp.createElement("div", { className: "table-adorner-spot-add-grip", ref: p10 }));
}
const TMt = L$.parse("0.25in");
class EMt extends tp.PureComponent {
  constructor() {
    super(...arguments), this.heightIsTooSmall = (e14) => !L$.isValidString(e14) || L$.parse(e14).lowerThan(TMt), this.getRowLabelByPath = (e14, t10) => {
      if (this.heightIsTooSmall(t10)) return "";
      const n10 = e14.split(".");
      if (n10.length >= 5 && "TableGroups" === n10[n10.length - 5]) return n10[n10.length - 4];
      if (n10.length >= 3) {
        const e15 = n10[n10.length - 3];
        if ("Header" === e15) return "h";
        if ("Footer" === e15) return "f";
        if ("Details" === e15) return "d";
      }
      return "";
    }, this.getRowIcon = (e14, t10) => {
      if (!this.heightIsTooSmall(t10)) return "h" === e14 ? tp.createElement(Fm, { icon: nf(Cyt) }) : "d" === e14 ? tp.createElement(Fm, { icon: nf(vyt) }) : "f" === e14 ? tp.createElement(Fm, { icon: nf(byt) }) : void 0;
    }, this.getRowIconCssClass = (e14, t10) => this.heightIsTooSmall(t10) ? "" : "h" === e14 ? "table-icon-header" : "d" === e14 ? "table-icon-details" : "f" === e14 ? "table-icon-footer" : Number.isFinite(Number(e14)) ? "table-icon-group" : "";
  }
  render() {
    const { item: e14, cellsInfo: t10, tableWidth: n10, tableHeight: r10, path: o10, dndEnabled: a10 } = this.props;
    const i10 = (e15, t11, i11 = false, s11 = null, l11 = "") => {
      const c10 = { key: e15, className: "table-adorner-row" + (i11 ? " selected" : ""), style: { height: t11 } };
      const u10 = `${o10}.${l11}`;
      const d10 = { className: "ar-item table-adorner-row-header", "data-path": u10, "data-type": s11 && s11.Type };
      const p10 = { isColumn: false, index: e15, tableWidth: n10, tableHeight: r10, action: gVe(e15 + 1), path: u10, type: s11 && s11.Type, dndEnabled: a10 };
      const m10 = this.getRowLabelByPath(l11, t11);
      return tp.createElement("tr", __spreadValues({}, c10), tp.createElement("td", { style: { height: t11 } }, tp.createElement(wMt, __spreadValues({}, p10)), s11 && tp.createElement("div", __spreadValues({}, d10)), m10 && tp.createElement("div", { className: `table-adorner-row-label ${this.getRowIconCssClass(m10, t11)}`, style: { pointerEvents: "none" } }, "number" != typeof m10 && this.getRowIcon(m10, t11), Number.isFinite(Number(m10)) && PMt(parseInt(m10, 10)))));
    };
    const s10 = [];
    s10.push(i10(-1, 0)), YQ(e14, (e15, n11, r11) => {
      const o11 = t10[n11].some((e16) => e16.selected);
      s10.push(i10(n11, e15.Height, o11, e15, r11));
    });
    const l10 = { tableLayout: "fixed", height: e14.$place.Height };
    return tp.createElement("table", { className: "table-adorner-rows", style: l10 }, tp.createElement("tbody", null, s10));
  }
}
function FMt(e14) {
  const { type: t10, path: n10 } = e14;
  const r10 = { className: "ar-item table-adorner-column-header", "data-path": n10, "data-type": t10 };
  const { columnDragRef: o10 } = CMt(e14);
  return tp.createElement("div", __spreadProps(__spreadValues({}, r10), { ref: o10 }));
}
function MMt({ item: e14, cellsInfo: t10, path: n10, tableWidth: r10, tableHeight: o10, dndEnabled: a10 }) {
  const { hasMergedCells: i10 } = ((e15) => {
    const t11 = e15.TableColumns.map((t12, n11, r11) => {
      const o11 = e15.TableGroups && e15.TableGroups.reduce((e16, t13) => e16.concat([t13.Header, t13.Footer]), []);
      return [e15.Header, e15.Details, e15.Footer, ...o11].reduce((e16, t13) => ((e17, t14, n12, r12) => {
        if (!e17) return r12;
        const o12 = (e18, t15) => {
          let n13 = e18 - 1;
          for (; n13 >= 0; ) {
            const r13 = t15[n13];
            if (r13) return n13 + r13.ColSpan > e18;
            n13--;
          }
          return false;
        };
        return e17.TableRows.reduce((e18, r13) => {
          if (e18.merged && "inner" === e18.position) return e18;
          const a11 = e18.merged && "first" === e18.position;
          const i11 = e18.merged && "last" === e18.position;
          const s11 = r13.TableCells[t14];
          return !s11 && o12(t14, r13.TableCells) ? t14 === n12.length - 1 || r13.TableCells[t14 + 1] || !o12(t14 + 1, r13.TableCells) ? { merged: true, position: a11 ? "inner" : "last" } : { merged: true, position: "inner" } : s11 && s11.ColSpan > 1 ? { merged: true, position: i11 ? "inner" : "first" } : e18;
        }, r12);
      })(t13, n11, r11, e16), { merged: false });
    });
    return { status: t11, hasMergedCells: (e16, n11) => {
      const r11 = (e17) => {
        if (e17 <= 0) return false;
        const n12 = t11[e17 - 1];
        return n12.merged && "last" !== n12.position;
      };
      const o11 = (e17) => {
        if (e17 >= t11.length - 1) return false;
        const n12 = t11[e17 + 1];
        return n12.merged && "first" !== n12.position;
      };
      switch (n11) {
        case "before":
          return r11(e16);
        case "after":
          return o11(e16);
        case "both": {
          const t12 = e16[0];
          const [n12] = e16.slice(-1);
          return r11(t12) || o11(n12);
        }
      }
    } };
  })(e14);
  const s10 = ((e15, t11) => {
    const n11 = e15.TableColumns.map((e16, n12) => t11.some((e17) => e17[n12].selected));
    const { indices: r11, ranges: o11 } = n11.reduce((e16, t12, n12) => {
      if (!t12) return e16.hasOpenRange = false, e16;
      if (e16.indices.push(n12), e16.hasOpenRange) {
        const [t13] = e16.ranges.slice(-1);
        t13.push(n12);
      } else e16.ranges.push([n12]), e16.hasOpenRange = true;
      return e16;
    }, { indices: [], ranges: [], hasOpenRange: false });
    return { byColumn: n11, indices: r11, ranges: o11 };
  })(e14, t10);
  const l10 = (e15, t11, l11 = false, c11 = null) => {
    const u11 = { key: e15, className: "table-adorner-column" + (l11 ? " selected" : ""), style: { width: t11 } };
    const d10 = `${n10}.TableColumns.${e15}`;
    const p10 = { isColumn: true, index: e15, tableWidth: r10, tableHeight: o10, action: yVe(e15 + 1), path: d10, type: c11 && c11.Type, dndEnabled: a10 };
    const m10 = { selection: s10, hasMergedCells: i10, colIdx: e15, path: d10, type: c11 && c11.Type };
    return tp.createElement("td", __spreadValues({}, u11), tp.createElement(wMt, __spreadValues({}, p10)), c11 && tp.createElement(FMt, __spreadValues({}, m10)));
  };
  const c10 = [];
  c10.push(l10(-1, 0)), e14.TableColumns.forEach((e15, t11) => {
    const n11 = s10.byColumn[t11];
    c10.push(l10(t11, e15.Width, n11, e15));
  });
  const u10 = { tableLayout: "fixed", width: e14.$place.Width };
  return tp.createElement("table", { className: "table-adorner-columns", style: u10 }, tp.createElement("colgroup", null, tp.createElement("col", { key: "col-stub", span: "1", style: { width: "0px" } }), e14.TableColumns.map((e15, t11) => tp.createElement("col", { key: `col-${t11}`, span: "1", style: { width: e15.Width } }))), tp.createElement("tbody", null, tp.createElement("tr", null, c10)));
}
function kMt({ item: e14, cellsInfo: t10, rowSizes: n10, columnSizes: r10 }) {
  const [o10, a10] = [n10.length, r10.length];
  const i10 = [];
  YQ(e14, (e15, s11) => {
    const l10 = [];
    e15.TableCells.forEach((e16, i11) => {
      const c10 = { width: r10[i11].css, height: n10[s11].css };
      const u10 = t10[s11][i11];
      let d10 = "table-adorner-cell-border";
      u10.selected && (0 !== s11 && t10[s11 - 1][i11].selected || (d10 += " top"), s11 !== o10 - 1 && t10[s11 + 1][i11].selected || (d10 += " bottom"), 0 !== i11 && t10[s11][i11 - 1].selected || (d10 += " left"), i11 !== a10 - 1 && t10[s11][i11 + 1].selected || (d10 += " right"));
      const p10 = { key: i11, className: `table-adorner-cell${u10.selected ? " table-adorner-cell-selected" : ""}${u10.isPrimary ? " primary" : ""}`, style: __spreadValues({}, c10) };
      l10.push(tp.createElement("td", __spreadValues({}, p10), tp.createElement("div", null, tp.createElement("div", { className: "table-adorner-cell-area" }), tp.createElement("div", { className: d10 }))));
    }), i10.push(tp.createElement("tr", { key: s11, style: { height: n10[s11].css } }, l10));
  });
  const s10 = { tableLayout: "fixed", width: e14.$place.Width, height: e14.$place.Height };
  return tp.createElement("table", { className: "table-adorner-cells-selection", style: s10 }, tp.createElement("colgroup", null, r10.map((e15, t11) => tp.createElement("col", { key: `col-${t11}`, span: "1", style: { width: e15.css } }))), tp.createElement("tbody", null, i10));
}
const PMt = (e14) => tp.createElement("div", { className: QAe }, tp.createElement(Fm, { icon: nf(Syt) }), e14 + 1);
let NMt = class extends tp.Component {
  constructor() {
    super(...arguments), this.makePanelElement = (e14, t10, n10 = false, r10 = null, o10 = "") => ({ text: e14, icon: t10, selected: n10, action: r10, path: o10 });
  }
  render() {
    const { item: e14, path: t10, t: n10 } = this.props;
    const r10 = [];
    if (e14.TableGroups.forEach((e15, n11) => {
      const o11 = this.makePanelElement(e15.Group.Name, tp.createElement(Nyt, { groupIndex: n11 + 1 }), rj(e15), c5(`${t10}.TableGroups.${n11}`, rW.tableGroup), `${t10}.TableGroups.${n11}`);
      r10.push(o11);
    }), e14.Details) {
      const o11 = this.makePanelElement(e14.Details.Group.Name || n10("adorners:table.detailsGroupLabel", "<Details Group>"), tp.createElement(Fm, { icon: nf(vyt) }), rj(e14.Details), c5(`${t10}.Details`, rW.tableDetails), `${t10}.Details`);
      r10.push(o11);
    }
    const o10 = { heading: n10("adorners:table.groupsLabel", "Groups"), items: r10, insertAtTheEnd: !e14.Details, withDragDrop: !FX(), createDragDropAction: (e15, t11) => function(e16, t12) {
      return { type: rVe, payload: { index: e16, label: t12.label, expr: t12.expr, dataSetName: t12.dataSetName } };
    }(e15, t11), customCSS: JAe };
    return tp.createElement(_yt, __spreadValues({}, o10));
  }
};
NMt = h([TA()], NMt);
const DMt = xp("adorners")(NMt);
class LMt extends tp.PureComponent {
  shouldShowAdorner(e14) {
    return !(rj(e14) || !ij(e14)) && f1(e14);
  }
  render() {
    const { item: e14, path: t10, dndEnabled: n10 } = this.props;
    const r10 = ((e15) => {
      const [t11, n11] = [JQ(e15), QQ(e15)];
      const r11 = zV.times(t11, () => zV.times(n11, () => ({ selected: false })));
      YQ(e15, (e16, t12) => {
        if (aj(e16)) if (rj(e16)) {
          const o12 = ij(e16);
          for (let e17 = 0; e17 < n11; e17++) r11[t12][e17] = { selected: true, isPrimary: o12 };
        } else e16.TableCells.forEach((e17, n12) => {
          if (e17 && rj(e17.Item)) for (let o12 = n12; o12 < n12 + e17.ColSpan; o12++) for (let n13 = t12; n13 < t12 + e17.RowSpan; n13++) r11[n13][o12] = { selected: true, isPrimary: ij(e17.Item) };
        });
      }), e15.TableColumns.forEach((e16, n12) => {
        if (!aj(e16)) return;
        const o12 = ij(e16);
        for (let e17 = 0; e17 < t11; e17++) r11[e17][n12] = { selected: true, isPrimary: o12 };
      });
      let [o11, a11] = [Number.MAX_VALUE, Number.MIN_VALUE];
      let i11 = e15.Header && e15.Header.TableRows.length || 0;
      if (e15.TableGroups.forEach((e16) => {
        rj(e16) && i11 < o11 && (o11 = i11), e16.Header && (i11 += e16.Header.TableRows.length);
      }), e15.Details && (rj(e15.Details) && i11 < o11 && (o11 = i11), i11 += e15.Details.TableRows.length, rj(e15.Details) && i11 - 1 > a11 && (a11 = i11 - 1)), zV.forEachRight(e15.TableGroups, (e16) => {
        e16.Footer && (i11 += e16.Footer.TableRows.length), rj(e16) && i11 - 1 > a11 && (a11 = i11 - 1);
      }), o11 !== Number.MAX_VALUE && a11 !== Number.MIN_VALUE) {
        for (let e16 = 0; e16 < t11; e16++) if (!(e16 < o11 || e16 > a11)) for (let t12 = 0; t12 < n11; t12++) r11[e16][t12] = { selected: true, isPrimary: true };
      }
      return r11;
    })(e14);
    const [o10, a10] = [e1(e14), t1(e14)];
    const i10 = { item: e14, cellsInfo: r10, rowSizes: o10, columnSizes: a10, tableHeight: L$.sum(o10).css, tableWidth: L$.sum(a10).css, path: t10, dndEnabled: n10 };
    const s10 = this.shouldShowAdorner(e14);
    return tp.createElement("div", { className: "table-adorner" }, s10 && tp.createElement(tp.Fragment, null, tp.createElement(xMt, { type: e14.Type, path: t10 }), tp.createElement(EMt, __spreadValues({}, i10)), tp.createElement(MMt, __spreadValues({}, i10)), tp.createElement(DMt, __spreadValues({}, i10))), tp.createElement(kMt, __spreadValues({}, i10)));
  }
}
LMt.propTypes = { item: JV.object.isRequired, path: JV.string.isRequired, dndEnabled: JV.bool };
const HMt = (e14) => {
  const { table: t10, children: n10 } = e14;
  const { instanceId: r10, setDecorations: o10 } = ep.useContext(bqe);
  const { userPreferences: { surface: { zoomFactor: a10 } } } = KO.of(r10);
  const i10 = ep.useRef(null);
  const s10 = PA();
  const [l10, c10] = [e1(t10), t1(t10)];
  const u10 = [];
  XQ(t10, ({ item: e15, rowIdx: t11, colIdx: n11, colSpan: r11, rowSpan: o11 }) => {
    u10.push({ item: e15, colIdx: n11, colSpan: r11, rowIdx: t11, rowSpan: o11 });
  });
  const [, d10, p10] = Yne({ item: { name: t10.Name, type: "tablixselect" }, canDrag: () => f1(t10), end: (e15, t11) => {
    const n11 = t11.getDropResult();
    if (n11) {
      const { ctrlPressed: e16, selItemNames: t12 } = n11;
      t12 && t12.length > 0 && s10((e16 ? m5 : h5)(t12));
    }
  }, collect: (e15) => ({ isDragging: e15.isDragging() }) });
  ep.useEffect(() => {
    p10(Coe(), { captureDraggingState: true });
  }, []);
  const [, m10] = are({ accept: ["tablixselect"], drop: (e15, t11) => {
    const n11 = ((e16, t12, n12, r11) => {
      const o11 = [];
      const { firstColumn: a11, lastColumn: i11, firstRow: s11, lastRow: l11 } = iMt(e16, t12, n12, r11);
      return n12.forEach((e17) => {
        (a11 <= e17.colIdx && e17.colIdx <= i11 || e17.colIdx < a11 && a11 < e17.colIdx + e17.colSpan) && (s11 <= e17.rowIdx && e17.rowIdx <= l11 || e17.rowIdx < s11 && s11 < e17.rowIdx + e17.rowSpan) && o11.push(e17.item.Name);
      }), o11;
    })(l10, c10, u10, sMt(t11, a10));
    return { ctrlPressed: k0e.ctrlPressed, selItemNames: n11 };
  }, hover: (e15, t11) => {
    if (t11.isOver() && t11.canDrop()) {
      const e16 = sMt(t11, a10);
      lMt(e16, l10, c10, u10, i10.current, o10);
    }
  }, canDrop: (e15, n11) => n11.getItem().name === t10.Name });
  return d10(tp.createElement("div", { ref: m10 }, tp.createElement("div", { ref: i10 }, n10)));
};
const IMt = (e14) => `table.${e14}`;
const _Mt = [FY.NoRowsMessage, vY.FontSimple, vY.Color, vY.Font, vY.TextDecoration, vY.TextAlign, vY.VerticalAlign, vY.Format].map((e14) => __spreadProps(__spreadValues({}, e14), { category: `propertyDescriptors:categories.${pY}` }));
const VMt = [EY.Name, FY.DataSetName, FY.DataSetParameters, EY.DataElementName, EY.DataElementOutput, Zq(rY, IMt("detailsDataElementName"), "string", "DetailDataElementName", "advanced"), Zq(rY, IMt("detailsDataCollectionName"), "string", "DetailDataCollectionName", "advanced"), Zq(rY, IMt("detailsDataElementOutput"), "enum", "DetailDataElementOutput", "advanced", { enumKey: "data_element_output" }), Zq(rY, "dataRegion.sortExpressions", "sort_expression_expr_collection", "Details.SortExpressions"), FY.Filters, vY.BackgroundAndBorders, vY.BackgroundColor, vY.BackgroundImage, vY.Borders, EY.Location, EY.Size, Zq(cY, "reportItem.style", "styles", "ReportStyle", void 0, { target: "Table" }), vY.Padding, EY.LayerName, FY.PageBreak, FY.NewPage, Zq(cY, "tablix.frozenRows", "number", "FrozenRows", void 0, Gq.integerPositive), Zq(cY, "tablix.frozenColumns", "number", "FrozenColumns", void 0, Gq.integerPositive), Zq(cY, "table.preventOrphanedFooter", "boolean", "PreventOrphanedFooter"), FY.NewSection, EY.KeepTogether, EY.ZIndex, ..._Mt, EY.Visibility, vY.Calendar, vY.Direction, vY.Language, vY.NumeralLanguage, vY.NumeralVariant, vY.UnicodeBiDi, vY.UprightInVerticalText, vY.WritingMode, EY.PageName, EY.ToolTip, EY.Label, EY.Bookmark];
const RMt = (e14) => "FrozenRows" !== e14.valuePath && "FrozenColumns" !== e14.valuePath;
const AMt = (e14) => "sort_expression_expr_collection" !== e14.type;
const OMt = (e14) => "PageBreak" !== e14.valuePath;
const BMt = (e14, t10, n10 = false) => {
  const r10 = GQ(e14, (e15, r11) => {
    if (!(r11 <= t10 && t10 < r11 + e15.length)) return e15;
    const o10 = [];
    return e15.forEach((a10, i10) => {
      const s10 = r11 + i10;
      if (s10 < t10) {
        const l10 = ((e16, t11) => {
          if (!t11) return null;
          for (let n11 = t11 - 1; n11 >= 0; n11--) if (e16[n11].TableCells.some((e17) => null !== e17)) return n11;
          return null;
        })(e15, t10 - r11);
        const c10 = n10 && l10 === i10;
        o10.push(((e16, t11, n11, r12) => {
          const o11 = {};
          let a11 = {};
          return e16.TableCells.forEach((i11, s11) => {
            i11 && 1 !== i11.RowSpan && n11 < t11 + i11.RowSpan && (o11[s11] = { RowSpan: { $apply: (e17) => e17 - 1 } }, r12 && (a11 = { Height: { $set: L$.parse(e16.Height).add(r12).css } }));
          }), 0 === Object.keys(o11).length ? e16 : AV(e16, __spreadValues({ TableCells: o11 }, a11));
        })(a10, s10, t10, c10 ? L$.parse(e15[t10 - r11].Height) : null));
      } else s10 === t10 + 1 ? o10.push(((e16, t11) => {
        const n11 = {};
        return t11.TableCells.forEach((e17, t12) => {
          if (!e17 || 1 === e17.RowSpan) return;
          const r12 = AV(e17, { RowSpan: { $set: e17.RowSpan - 1 } });
          n11[t12] = { $set: r12 };
        }), 0 === Object.keys(n11).length ? e16 : AV(e16, { TableCells: n11 });
      })(a10, e15[i10 - 1])) : s10 !== t10 && o10.push(a10);
    }), o10;
  });
  return r10;
};
function zMt(e14, t10, n10 = false) {
  let r10 = e14;
  return t10.sort().reverse().forEach((e15) => {
    r10 = BMt(r10, e15, n10);
  }), r10;
}
function $Mt(e14, t10, n10, r10 = "", o10 = "") {
  const a10 = t1(t10);
  const i10 = i4(e14, t10.$templateId).height;
  const s10 = { cellsWidth: a10.map((e15) => e15.css), cellsHeight: [i10], createCellItem: s4(e14, t10.LayerName, t10.$templateId) };
  const l10 = V4(e14, s10, t10.Name, r10, o10);
  return AV(t10, { TableGroups: { $splice: [[n10, 0, l10]] } });
}
const WMt = (e14, t10, n10) => {
  const r10 = t1(t10);
  const o10 = i4(e14, t10.$templateId).height;
  const a10 = { cellsWidth: r10.map((e15) => e15.css), cellsHeight: [o10], createCellItem: s4(e14, t10.LayerName, t10.$templateId) };
  return n10(e14, a10);
};
function jMt(e14, t10, n10, r10) {
  let o10 = t10;
  return o10 = o10[n10] ? AV(o10, { [n10]: { $set: null } }) : AV(o10, { [n10]: { $set: WMt(e14, o10, r10) } }), o10;
}
function ZMt(e14, t10, n10, r10, o10) {
  let a10 = t10;
  return a10 = AV(a10, { TableGroups: { [n10]: { [r10]: { $apply: (t11) => t11 ? null : WMt(e14, a10, o10) } } } }), a10;
}
const GMt = (e14, t10, n10) => {
  if (!aj(e14) || !e14.TableRows.some((e15) => rj(e15))) return e14;
  if (1 !== t10.split(".").length) throw new Error("Only simple path is supported");
  if (typeof e14[t10] != typeof n10) throw new Error("Value should be the same type with the property value");
  return e14[t10] === n10 ? e14 : AV(e14, { [t10]: { $set: n10 } });
};
const UMt = (e14, t10, n10) => {
  if (!aj(e14)) return e14;
  const r10 = {};
  if (e14.Header) {
    const o10 = GMt(e14.Header, t10, n10);
    o10 !== e14.Header && (r10.Header = { $set: o10 });
  }
  if (e14.Footer) {
    const o10 = GMt(e14.Footer, t10, n10);
    o10 !== e14.Footer && (r10.Footer = { $set: o10 });
  }
  return zV.isEmpty(r10) ? e14 : AV(e14, r10);
};
const qMt = ["tableofcontents", "fixedpagetableofcontents", "contentplaceholder"];
const YMt = (e14) => e14.Type === rW.inputField && sst(e14);
const KMt = (e14) => {
  const { Type: t10 } = e14;
  return t10 === rW.textbox || t10 === rW.image || YMt(e14) ? e14.Value : t10 === rW.checkbox ? e14.Text : null;
};
const XMt = (e14, t10) => {
  const n10 = KMt(e14);
  if (!n10) return true;
  if (!t10) return false;
  const r10 = ((e15) => {
    const t11 = N1(e15);
    return t11[0] || t11[1] || e15;
  })(t10);
  return n10 === q1(r10);
};
const JMt = (e14, t10, n10) => {
  const r10 = ((e15, t11) => {
    const n11 = { newValue: null, prevValue: null, colIdx: -1, rowIdx: -1 };
    const r11 = e15.Header && e15.Header.TableRows.length || 0;
    return XQ(e15, ({ item: e16, rowIdx: t12, colIdx: o10 }) => {
      sj(e16) && 0 !== t12 && t12 >= r11 && (n11.newValue = KMt(e16), n11.rowIdx = t12, n11.colIdx = o10);
    }), null === n11.newValue ? null : (XQ(t11, ({ item: e16, rowIdx: t12, colIdx: r12 }) => {
      t12 === n11.rowIdx && r12 === n11.colIdx && (n11.prevValue = KMt(e16));
    }), null === n11.prevValue ? null : n11);
  })(e14, t10);
  return null === r10 || r10.prevValue === r10.newValue ? e14 : KQ(e14, ({ item: e15, rowIdx: t11, colIdx: o10, colSpan: a10 }) => {
    if (!(!!e15 && r10.colIdx >= o10 && r10.colIdx < o10 + a10 && 0 === t11)) return e15;
    if (!XMt(e15, r10.prevValue)) return e15;
    return ((e16, t12) => {
      const { Type: n11 } = e16;
      return n11 === rW.textbox || YMt(e16) ? AV(e16, { Value: { $set: t12 } }) : n11 === rW.checkbox ? AV(e16, { Text: { $set: t12 } }) : e16;
    })(e15, q1(n10));
  });
};
const QMt = (e14, t10, n10, r10, o10) => {
  if (!n10) return e14;
  if (!e14.Details) return e14;
  let a10 = -1;
  for (const t11 of e14.Details.TableRows) {
    const e15 = t11.TableCells.findIndex(ij);
    if (-1 !== e15) {
      a10 = e15;
      break;
    }
  }
  const { variationFormat: i10 } = n10;
  const s10 = n10.aggregate || "Count";
  const l10 = i10 ? `=${U1(t10, i10, o10 ? r10 : null, s10)}` : `=${G1(t10, o10 ? r10 : null, s10)}`;
  const c10 = (e15) => e15 ? e15.Type !== rW.textbox || e15.Value ? e15.Type !== rW.checkbox || e15.Text ? e15 : AV(e15, { Text: { $set: l10 } }) : AV(e15, { Value: { $set: l10 } }) : e15;
  const u10 = (e15) => {
    if (!e15.Footer) return null;
    const t11 = e15.Footer.TableRows;
    let [n11, r11] = [-1, -1];
    for (let e16 = t11.length - 1; e16 >= 0; e16--) {
      const o11 = t11[e16].TableCells.findIndex((e17, t12) => e17 && t12 <= a10 && a10 < t12 + e17.ColSpan);
      if (-1 !== o11) {
        [n11, r11] = [e16, o11];
        break;
      }
    }
    return -1 === n11 || -1 === r11 ? null : { Footer: { TableRows: { [n11]: { TableCells: { [r11]: { Item: { $apply: c10 } } } } } } };
  };
  let d10 = e14;
  if (e14.TableGroups.length) {
    const t11 = e14.TableGroups.reduce((e15, t12, n11) => {
      if (!t12.Footer) return e15;
      const r11 = u10(t12);
      return zV.isEmpty(r11) ? e15 : __spreadProps(__spreadValues({}, e15), { [n11]: r11 });
    }, {});
    zV.isEmpty(t11) || (d10 = AV(d10, { TableGroups: t11 }));
  }
  if (e14.Footer) {
    const t11 = u10(e14);
    zV.isEmpty(t11) || (d10 = AV(d10, u10(e14)));
  }
  return d10;
};
const ekt = (e14) => {
  const t10 = function(e15) {
    const t11 = nz.of(e15);
    const n10 = t11.getTemplate("table");
    const r10 = t11.getTemplate("textbox");
    if (!n10 || !r10) return null;
    const o10 = a4(e15);
    if (!o10) return null;
    const a10 = zV.merge({}, r10.style || {}, o10 || {});
    const i10 = [];
    a10.TextAlign && i10.push("TextAlign"), a10.VerticalAlign && i10.push("VerticalAlign");
    const s10 = ["BackgroundColor", "Color", "FontFamily", "FontSize", "FontStyle", "FontWeight", "Border", "LeftBorder", "TopBorder", "RightBorder", "BottomBorder"].concat(i10);
    const l10 = zV.pick(zV.merge({}, e5e.Style, a10), s10);
    return __spreadProps(__spreadValues({}, zV.merge({}, W5.Style, n10.style)), { Header: l10, Details: l10, Footer: l10, TableGroups: { Header: l10, Footer: l10 } });
  }(e14);
  return Object.assign({}, t10, { Header: { Rows: [t10.Header] }, Details: { Rows: [t10.Details] }, Footer: { Rows: [t10.Footer] }, TableGroups: { Styles: [{ Header: { Rows: [t10.TableGroups.Header] }, Footer: { Rows: [t10.TableGroups.Footer] } }] } });
};
const tkt = (e14, t10) => {
  if (zV.isArray(e14) && zV.isArray(t10)) return zV.merge([], Array(t10.length).fill(e14[0]), t10, tkt);
};
const nkt = (e14, t10) => {
  if (e14 && e14.$targetType !== wj.Table) return null;
  const n10 = ekt(t10);
  return e14 ? zV.mergeWith({}, n10, e14, tkt) : n10;
};
const rkt = (e14, t10, n10) => {
  const r10 = {};
  return ["Color", "Width", "Style"].forEach((o10) => {
    ((e15, t11, n11, r11) => Oj(e15, t11, r11) && (!n11 || !n11[r11] || e15[r11] && n11[r11] !== e15[r11] || Oj(n11, t11, r11)))(e14, t10, n10, o10) && (r10[o10] = { $set: t10[o10] });
  }), zV.isEmpty(r10) ? null : r10;
};
const okt = (e14, t10) => {
  const n10 = n5e(e14, t10.Details.Rows[0]) || {};
  if (t10.Border) {
    const r10 = rkt(e14.Style.Border, t10.Border);
    r10 && (n10.Border = r10);
  }
  return Oj(e14.Style, t10, "BackgroundColor") && (n10.BackgroundColor = { $set: t10.BackgroundColor }), zV.isEmpty(n10) ? null : n10;
};
const akt = (e14, t10) => {
  const n10 = {};
  return Array.from(e14.TableCells).forEach((e15, r10) => {
    const o10 = ((e16, t11) => {
      if (!e16 || !e16.Item || !e16.Item.Style) return null;
      const n11 = {};
      return Object.keys(t11).forEach((r11) => {
        if (!e16.Item.Style.hasOwnProperty(r11)) return;
        const o11 = e16.Item.Style[r11];
        if (r11.includes("Border")) {
          const a10 = rkt(o11, t11[r11], e16.Item.Style[r11]);
          a10 && (n11[r11] = a10);
        } else Oj(e16.Item.Style, t11, r11) && (n11[r11] = { $set: t11[r11] });
      }), zV.isEmpty(n11) ? null : { Item: { Style: n11 } };
    })(e15, t10 || {});
    o10 && (n10[r10] = o10);
  }), zV.isEmpty(n10) ? null : { TableCells: n10 };
};
const ikt = (e14, t10) => {
  const n10 = {};
  return e14.TableRows.forEach((e15, r10) => {
    const o10 = akt(e15, t10 || {});
    o10 && (n10[r10] = o10);
  }), zV.isEmpty(n10) ? null : { TableRows: n10 };
};
const skt = (e14, t10) => {
  const n10 = t10.map((e15) => ((e16) => e16 && e16.length > 0 && "=" === e16[0] ? e16.substr(1) : `"${e16 || ""}"`)(e15));
  return y1(e14, ...n10);
};
const lkt = ["Border", "LeftBorder", "TopBorder", "RightBorder", "BottomBorder"];
const ckt = ["Color", "Style", "Width"];
const ukt = (e14, t10, n10) => {
  const r10 = {};
  return Object.keys(t10).forEach((o10) => {
    if ("$softfallback" === o10) return void (r10.$softfallback = ukt(e14, t10.$softfallback, n10.map((e15) => e15.$softfallback)));
    const a10 = t10[o10];
    const i10 = n10.map((e15) => e15[o10]);
    var s10;
    if (s10 = o10, lkt.includes(s10)) if (i10.every((e15) => zV.isEqual(e15, a10) || void 0 === e15)) r10[o10] = a10;
    else {
      const t11 = [a10, ...i10];
      r10[o10] = {}, ckt.forEach((n11) => {
        r10[o10][n11] = skt(e14, t11.map((e15) => e15 && e15[n11] || ""));
      });
    }
    else if (i10.every((e15) => e15 === a10)) r10[o10] = a10;
    else {
      const t11 = [a10, ...i10];
      r10[o10] = skt(e14, t11);
    }
  }), r10;
};
const dkt = (e14) => {
  if (!e14) return {};
  const { AlternatingExpression: t10, Rows: n10 } = e14;
  if (!n10 || 0 === n10.length) return {};
  if (!t10) return n10[0];
  const r10 = zV.head(n10);
  const o10 = zV.tail(n10);
  return ukt(t10, r10, o10);
};
function pkt(e14, t10, n10, r10 = false) {
  const o10 = ekt(e14);
  const a10 = r10 ? Aj(n10, o10) : n10;
  const i10 = (e15, t11, n11) => {
    const r11 = dkt(n11[t11]);
    return ikt(e15[t11], r11);
  };
  const s10 = t10.Header && i10(t10, "Header", a10) || {};
  const l10 = t10.Details && i10(t10, "Details", a10) || {};
  const c10 = t10.Footer && i10(t10, "Footer", a10) || {};
  const u10 = {};
  const d10 = a10.TableGroups && a10.TableGroups.Styles;
  d10 && t10.TableGroups.forEach((e15, t11) => {
    const n11 = d10[t11] || d10[d10.length - 1];
    const r11 = e15.Header && i10(e15, "Header", n11) || {};
    const o11 = e15.Footer && i10(e15, "Footer", n11) || {};
    [r11, o11].some((e16) => !zV.isEmpty(e16)) && (u10[t11] = { Header: r11, Footer: o11 });
  });
  const p10 = okt(t10, a10) || {};
  return [s10, l10, c10, u10, p10].some((e15) => !zV.isEmpty(e15)) ? AV(t10, { Style: p10, Header: s10, Details: l10, Footer: c10, TableGroups: u10 }) : t10;
}
const mkt = (e14, t10) => {
  let n10 = e14;
  return n10 = lj(n10), n10 = dj(n10, true, ij(t10)), n10;
};
const hkt = (e14, t10) => {
  const n10 = ij(e14);
  const r10 = t10.split(".");
  const o10 = {};
  let [a10, i10] = [o10, e14];
  return r10.forEach((e15, t11) => {
    i10 = i10[e15], a10[e15] = zV.isArray(i10) ? {} : { $selected: { $set: t11 < r10.length - 1 ? uj : cj }, $primary: { $set: n10 } }, a10 = a10[e15];
  }), zV.isEmpty(o10) ? e14 : (o10.$selected = { $set: uj }, AV(e14, o10));
};
const fkt = (e14, t10) => {
  let n10 = "";
  return YQ(e14, (e15, r10, o10) => {
    r10 <= t10 && (n10 = o10);
  }), hkt(e14, n10);
};
const gkt = (e14, t10) => {
  let n10 = "";
  return e14.TableGroups.forEach((e15, r10) => {
    r10 <= t10 && (n10 = `TableGroups.${r10}`);
  }), hkt(e14, n10);
};
const ykt = (e14, t10) => {
  if (!aj(e14)) return e14;
  return n5(e14, t10);
};
const vkt = [O5.type, o2.type, l2.type];
const bkt = { type: "table", labelKey: "reportItems:table", nameTemplateKey: "nameTemplates:table", defaultModel: W5, icon: nf(wae), icon24: nf(Tae), init: Z5, getReducer: function(e14) {
  var _a2;
  const { rdlx: t10 } = KO.of(e14);
  const n10 = (_a2 = t10 == null ? void 0 : t10.reportItemsFeatures) == null ? void 0 : _a2.table;
  const r10 = (t11, n11) => {
    switch (n11.type) {
      case oVe: {
        if (!f1(t11)) break;
        const e15 = [...n1(t11), ...a1(t11)];
        if (!e15.length) break;
        let n12 = t11;
        return n12 = mkt(n12, t11), n12 = zMt(n12, e15), n12 = k4(n12), n12 = M4(n12), n12 = fkt(n12, e15[0]), n12;
      }
      case aVe: {
        if (!f1(t11)) break;
        const e15 = [...o1(t11), ...i1(t11)];
        if (!e15.length) break;
        let n12 = t11;
        return n12 = mkt(n12, t11), n12 = function(e16, t12) {
          let n13 = e16;
          const r11 = t12.sort().reverse();
          return n13 = qQ(n13, (e17) => {
            let t13 = e17.TableCells;
            return r11.forEach((e18) => {
              var _a3;
              const n14 = t13;
              let r12 = n14;
              r12 = AV(r12, { $splice: [[e18, 1]] });
              const o11 = n14[e18] && ((_a3 = n14[e18]) == null ? void 0 : _a3.ColSpan) || 0;
              if (o11 > 1) r12 = AV(r12, { [e18]: { $set: AV(n14[e18], { ColSpan: { $set: o11 - 1 } }) } });
              else {
                const t14 = r12.findIndex((t15, n15) => t15 && n15 < e18 && n15 + t15.ColSpan > e18);
                t14 >= 0 && (r12 = AV(r12, { [t14]: { ColSpan: { $apply: (e19) => e19 - 1 } } }));
              }
              t13 = r12;
            }), AV(e17, { TableCells: { $set: t13 } });
          }), n13 = AV(n13, { TableColumns: { $splice: [...r11.map((e17) => [e17, 1])] } }), n13;
        }(n12, e15), n12 = k4(n12), n12 = M4(n12), n12 = ((e16, t12) => {
          let n13 = "";
          return e16.TableColumns.forEach((e17, r11) => {
            r11 <= t12 && (n13 = `TableColumns.${r11}`);
          }), hkt(e16, n13);
        })(n12, e15[0]), n12;
      }
      case iVe: {
        if (!f1(t11)) break;
        const e15 = ((e16) => {
          const t12 = [];
          return e16.TableGroups.forEach((e17, n13) => {
            aj(e17) && !t12.includes(n13) && (ij(e17) ? t12.unshift(n13) : t12.push(n13));
          }), t12;
        })(t11);
        const n12 = r1(t11);
        let r11 = t11;
        return r11 = mkt(r11, t11), r11 = function(e16, t12) {
          const n13 = [];
          return e16.TableGroups.forEach((e17, r12) => {
            t12.includes(r12) || n13.push(e17);
          }), AV(e16, { TableGroups: { $set: n13 } });
        }(r11, e15), r11 = M4(r11), n12.length ? r11 = fkt(r11, n12[0]) : r11.TableGroups.length && e15.length ? r11 = gkt(r11, e15[0]) : r11.Details && (r11 = ((e16) => hkt(e16, "Details"))(r11)), r11;
      }
      case X_e: {
        if (!f1(t11)) break;
        let o11 = t11;
        for (let r11 = 0; r11 < n11.payload.count; r11++) {
          const r12 = [...n1(t11), ...a1(t11)];
          if (!r12.length) break;
          const a10 = n11.payload.position === mVe.BEFORE ? Math.min(...r12) : Math.max(...r12) + 1;
          o11 = pMt(e14, o11, a10, n11.payload.position);
        }
        return o11 = k4(o11), o11 = M4(o11), o11 = r10(o11, S2()), o11;
      }
      case tVe: {
        if (!f1(t11)) break;
        let o11 = t11;
        return o11 = function(e15, t12, n12) {
          let r11 = t12;
          return r11 = UQ(t12, (r12, o12) => 0 === n12 && 0 === o12 ? [cMt(e15, t12), r12] : o12 + 1 < n12 ? [uMt(r12, o12, n12)] : o12 + 1 === n12 ? [uMt(r12, o12, n12), cMt(e15, t12)] : [r12]), r11 = dMt(r11), r11;
        }(e14, o11, n11.payload.index), o11 = k4(o11), o11 = M4(o11), o11 = r10(o11, S2()), o11;
      }
      case J_e: {
        if (!f1(t11)) break;
        let o11 = t11;
        for (let r11 = 0; r11 < n11.payload.count; r11++) {
          const r12 = [...o1(t11), ...i1(t11)];
          if (!r12.length) break;
          const a10 = n11.payload.position === mVe.BEFORE ? Math.min(...r12) : Math.max(...r12) + 1;
          o11 = mMt(e14, o11, a10);
        }
        return o11 = k4(o11), o11 = M4(o11), o11 = r10(o11, S2()), o11;
      }
      case nVe: {
        if (!f1(t11)) break;
        let o11 = t11;
        return o11 = mMt(e14, o11, n11.payload.index), o11 = k4(o11), o11 = M4(o11), o11 = r10(o11, S2()), o11;
      }
      case eVe: {
        if (!f1(t11)) break;
        let n12 = t11;
        return n12 = function(e15, t12) {
          const n13 = [t12.Header, t12.Footer].some((e16) => ij(e16));
          const r11 = !n13 && ij(t12.Details);
          const o11 = r11 ? -1 : t12.TableGroups.findIndex((e16) => ij(e16));
          let a10 = -1;
          return n13 ? a10 = 0 : r11 ? a10 = t12.TableGroups.length : o11 >= 0 && (a10 = o11 + 1), -1 !== a10 ? $Mt(e15, t12, a10) : t12;
        }(e14, n12), n12 = M4(n12), n12 = r10(n12, S2()), n12;
      }
      case rVe: {
        if (!f1(t11)) break;
        const { index: o11, label: a10, expr: i10 } = n11.payload;
        let s10 = t11;
        return s10 = $Mt(e14, s10, o11, ((e15) => e15 && e15.replace(Jc("[^\\p{L}\\p{N}_]", "g"), "") || TG("group"))(a10), i10), s10 = M4(s10), s10 = r10(s10, S2()), s10;
      }
      case sVe: {
        if (!p1(t11) && !rj(t11)) break;
        const n12 = r1(t11);
        let o11 = t11;
        return o11 = mkt(o11, t11), o11 = ((e15, t12) => jMt(e15, t12, "Header", b4))(e14, o11), o11 = M4(o11), o11 = r10(o11, S2()), n12.length && (o11 = fkt(o11, n12[0])), o11;
      }
      case lVe: {
        if (!p1(t11) && !rj(t11)) break;
        const n12 = r1(t11);
        let o11 = t11;
        return o11 = mkt(o11, t11), o11 = ((e15, t12) => jMt(e15, t12, "Footer", L4))(e14, o11), o11 = M4(o11), o11 = r10(o11, S2()), n12.length && (o11 = fkt(o11, n12[0])), o11;
      }
      case cVe: {
        if (!(p1(t11) || rj(t11) || rj(t11.Details))) break;
        let n12 = t11;
        if (n12 = mkt(n12, t11), n12 = ((e15, t12) => jMt(e15, t12, "Details", f4))(e14, n12), n12 = M4(n12), n12 = r10(n12, S2()), !rj(t11)) {
          const e15 = r1(t11);
          e15.length ? n12 = fkt(n12, e15[0]) : n12.TableGroups.length && (n12 = gkt(n12, t11.TableGroups.length - 1));
        }
        return n12;
      }
      case uVe: {
        if (!f1(t11)) break;
        const n12 = t11.TableGroups.findIndex((e15) => sj(e15));
        if (-1 === n12) break;
        let o11 = t11;
        return o11 = ((e15, t12, n13) => ZMt(e15, t12, n13, "Header", b4))(e14, o11, n12), o11 = M4(o11), o11 = r10(o11, S2()), o11;
      }
      case dVe: {
        if (!f1(t11)) break;
        const n12 = t11.TableGroups.findIndex((e15) => sj(e15));
        if (-1 === n12) break;
        let o11 = t11;
        return o11 = ((e15, t12, n13) => ZMt(e15, t12, n13, "Footer", L4))(e14, o11, n12), o11 = M4(o11), o11 = r10(o11, S2()), o11;
      }
      case K_e: {
        if (!m1(t11)) break;
        let n12 = t11;
        return n12 = ((e15, t12) => {
          const n13 = t1(t12);
          const r11 = GQ(t12, (r12) => {
            const o11 = {};
            for (let a10 = 0; a10 < r12.length; a10++) {
              const i10 = r12[a10];
              if (aj(i10)) for (let r13 = 0; r13 < i10.TableCells.length; r13++) {
                const s10 = i10.TableCells[r13];
                if (s10 && aj(s10)) for (let l10 = a10; l10 < a10 + s10.RowSpan; l10++) for (let c10 = r13; c10 < r13 + s10.ColSpan; c10++) if (o11[l10] || (o11[l10] = {}), o11[l10].TableCells || (o11[l10].TableCells = {}), l10 === a10 && c10 === r13) o11[l10].TableCells[c10] = { RowSpan: { $set: 1 }, ColSpan: { $set: 1 } };
                else {
                  const r14 = { width: n13[c10].css, height: i10.Height, createCellItem: s4(e15, s10.Item.LayerName, t12.$templateId) };
                  const a11 = AV(l4(e15, r14), { Item: { Style: { $apply: (e16) => {
                    return AFt(e16, (t13 = s10.Item).hasOwnProperty("Style") ? t13.Style : null);
                    var t13;
                  } } } });
                  o11[l10].TableCells[c10] = { $set: a11 };
                }
              }
            }
            return 0 === Object.keys(o11).length ? r12 : AV(r12, o11);
          });
          return r11;
        })(e14, n12), n12 = k4(n12), n12 = M4(n12), n12;
      }
      case Y_e: {
        if (!m1(t11)) break;
        let e15 = t11;
        e15 = ((e16) => GQ(e16, (e17) => {
          let [t12, n13, r11, o11] = [Number.MAX_VALUE, Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE];
          let a10 = null;
          if (e17.forEach((e18, i11) => {
            e18.TableCells.forEach((e19, s10) => {
              if (!e19 || !aj(e19)) return;
              !a10 && ij(e19) && (a10 = e19), i11 < t12 && (t12 = i11), s10 < n13 && (n13 = s10);
              const l10 = i11 + e19.RowSpan - 1;
              l10 > r11 && (r11 = l10), s10 + e19.ColSpan - 1 > o11 && (o11 = s10 + e19.ColSpan - 1);
            });
          }), t12 === Number.MAX_VALUE || n13 === Number.MAX_VALUE || r11 === -Number.MAX_VALUE || o11 === -Number.MAX_VALUE) return e17;
          if (!a10) return e17;
          const i10 = {};
          return e17.forEach((e18, s10) => {
            e18.TableCells.forEach((e19, l10) => {
              if (e19 && s10 >= t12 && l10 >= n13 && s10 + e19.RowSpan - 1 <= r11 && l10 + e19.ColSpan - 1 <= o11) if (i10[s10] || (i10[s10] = {}), i10[s10].TableCells || (i10[s10].TableCells = {}), s10 === t12 && l10 === n13) {
                const e20 = AV(a10, { ColSpan: { $set: o11 - n13 + 1 }, RowSpan: { $set: r11 - t12 + 1 } });
                i10[s10].TableCells[l10] = { $set: e20 };
              } else i10[s10].TableCells[l10] = { $set: null };
            });
          }), 0 === Object.keys(i10).length ? e17 : AV(e17, i10);
        }))(e15), e15 = k4(e15);
        const n12 = ((e16) => {
          const t12 = [];
          return YQ(e16, (e17, n13) => {
            e17.TableCells.every((e18) => null === e18) && t12.push(n13);
          }), t12;
        })(e15);
        return n12.length > 0 && (e15 = zMt(e15, n12, true)), e15 = M4(e15), e15;
      }
      case pVe: {
        if (!p1(t11)) break;
        const { valuePath: e15, value: r11 } = n11.payload;
        return function(e16, t12, n12) {
          return $Q(e16, (e17) => e17.Type === rW.tableGroup ? UMt(e17, t12, n12) : GMt(e17, t12, n12));
        }(t11, e15, r11);
      }
      case Q_e:
        if (!f1(t11)) break;
        return ((e15, { from: t12, to: n12 }) => {
          const r11 = n12 - t12.filter((e16) => e16 < n12).length;
          const o11 = (e16) => {
            const { baseItems: n13, itemsToMove: o12 } = e16.reduce((e17, n14, r12) => ((t12.includes(r12) ? e17.itemsToMove : e17.baseItems).push(n14), e17), { baseItems: [], itemsToMove: [] });
            return n13.splice(r11, 0, ...o12), { $set: n13 };
          };
          const a10 = (e16) => {
            if (!e16) return e16;
            const t13 = e16.TableRows.reduce((e17, t14, n13) => __spreadProps(__spreadValues({}, e17), { [n13]: { TableCells: o11(t14.TableCells) } }), {});
            return AV(e16, { TableRows: t13 });
          };
          const i10 = e15.TableGroups.map((e16) => __spreadProps(__spreadValues({}, e16), { Header: a10(e16.Header), Footer: a10(e16.Footer) }));
          return __spreadProps(__spreadValues({}, e15), { Header: a10(e15.Header), Details: a10(e15.Details), Footer: a10(e15.Footer), TableColumns: (s10 = e15.TableColumns, AV(s10, o11(s10))), TableGroups: i10 });
          var s10;
        })(t11, n11.payload);
      case jG:
      case UG: {
        if (!m1(t11)) break;
        let e15 = t11;
        return e15 = function(e16, t12) {
          const n12 = t12.payload.items.find((e17) => qMt.includes(e17.Type));
          if (n12) throw $0(n12.Type, e16.Type);
          return KQ(e16, ({ item: n13 }) => {
            if (!sj(n13)) return n13;
            if (OW(n13.Type) || BW(n13.Type)) return n5(n13, t12);
            const r11 = t12.payload.items.map((e17, t13) => dj(__spreadValues({}, e17), true, 0 === t13));
            if (1 === r11.length && r11[0].Type !== rW.line) return r11[0];
            const o11 = L$.max(r11.map((e17) => L$.parse(e17.$place.Left).add(L$.parse(e17.$place.Width))).concat(L$.parse(n13.$width || n13.$place.Width)));
            const a10 = L$.max(r11.map((e17) => L$.parse(e17.$place.Top).add(L$.parse(e17.$place.Height))).concat(L$.parse(n13.$height || n13.$place.Height)));
            const i10 = e16.Type === rW.fplTable ? rW.fplRectangle : rW.rectangle;
            const s10 = tz.create(i10, KB(TG(i10)));
            return n5(hj(AV(s10, { $place: { Width: { $set: o11.css }, Height: { $set: a10.css } } }), n13), t12);
          });
        }(t11, n11), e15 = k4(e15), e15 = M4(e15), e15 = r10(e15, S2()), e15 = P3(e15, t11.LayerName), e15;
      }
      case ZG: {
        if (!m1(t11)) break;
        let n12 = t11;
        return n12 = function(e15, t12) {
          return KQ(t12, ({ item: n13 }) => {
            if (!rj(n13)) return n13;
            let r11 = s4(e15, t12.LayerName, t12.$templateId)(n13.$place.Width, n13.$place.Height);
            return r11 = hj(r11, n13), r11;
          });
        }(e14, t11), n12 = k4(n12), n12 = M4(n12), n12 = r10(n12, S2()), n12;
      }
      case GG: {
        if (!ij(t11) || !m1(t11)) break;
        const { item: e15 } = n11.payload;
        let o11 = P4(t11, (t12) => {
          const n12 = t12.item;
          return sj(n12) ? hj(e15, n12) : n12;
        });
        return o11 = r10(o11, S2()), o11;
      }
      case $G: {
        const { delta: e15 } = n11.payload;
        const r11 = L$.isZeroLike(e15 && e15.x);
        const o11 = L$.isZeroLike(e15 && e15.y);
        if (r11 && o11) return t11;
        const a10 = o1(t11);
        if (a10.length && !r11) {
          const n12 = a10[0];
          const r12 = t1(t11);
          const o12 = r12[n12];
          const i11 = o12.multiply(0).add(G5);
          const s10 = L$.max([o12.add(L$.parse(e15.x)), i11]);
          const l10 = r12.map((e16, t12) => t12 === n12 ? s10 : e16);
          let c10 = t11;
          return c10 = T4(c10, l10), c10 = k4(c10), c10 = M4(c10), c10;
        }
        const i10 = n1(t11);
        if (i10.length && !o11) {
          const n12 = i10[0];
          const r12 = e1(t11);
          const o12 = r12[n12];
          const a11 = o12.multiply(0).add(G5);
          const s10 = L$.max([o12.add(L$.parse(e15.y)), a11]);
          const l10 = r12.map((e16, t12) => t12 === n12 ? s10 : e16);
          let c10 = t11;
          return c10 = w4(c10, l10), c10 = k4(c10), c10 = M4(c10), c10;
        }
        break;
      }
      case d2.type: {
        const e15 = n1(t11);
        if (e15.length) {
          let r12 = e1(t11);
          const o11 = {};
          e15.forEach((e16) => {
            const t12 = r12[e16].multiply(0).add(G5);
            o11[e16] = { $set: L$.max([n11.payload.value, t12]) };
          }), r12 = AV(r12, o11);
          let a10 = t11;
          return a10 = w4(a10, r12), a10 = k4(a10), a10 = M4(a10), a10;
        }
        const r11 = o1(t11);
        if (r11.length) {
          let e16 = t1(t11);
          const o11 = {};
          r11.forEach((t12) => {
            const r12 = e16[t12].multiply(0).add(G5);
            o11[t12] = { $set: L$.max([n11.payload.value, r12]) };
          }), e16 = AV(e16, o11);
          let a10 = t11;
          return a10 = T4(a10, e16), a10 = k4(a10), a10 = M4(a10), a10;
        }
        break;
      }
      case v2.type:
        if (!rj(t11)) break;
        return AV(t11, { ReportStyle: { StyleId: { $set: n11.payload.id || "" }, StyleName: { $set: n11.payload.name || "" } } });
      case b2.type: {
        if (!rj(t11)) break;
        const r11 = nkt(n11.payload.style, e14);
        return r11 ? pkt(e14, t11, r11) : t11;
      }
      case S2.type: {
        const n12 = nkt(t11.$style, e14);
        return n12 ? pkt(e14, t11, n12, true) : t11;
      }
      case D2.type:
        return qQ(t11, (e15) => {
          const r11 = {};
          return e15.TableCells.forEach((o11, a10) => {
            (o11 && aj(o11.Item) || rj(e15) || rj(t11.TableColumns[a10])) && (r11[a10] = { AutoMergeMode: { $set: n11.payload.autoMergeMode } });
          }), zV.isEmpty(r11) ? e15 : AV(e15, { TableCells: r11 });
        });
    }
    let o10 = t11;
    return o10 = qQ(o10, (e15) => ykt(e15, n11)), o10 = jQ(o10, (e15) => ykt(e15, n11)), o10 = $Q(o10, (e15) => ykt(e15, n11)), o10 = P4(o10, ({ item: e15 }) => ykt(e15, n11)), o10;
  };
  return function(e15, t11) {
    const { type: o10, payload: a10 } = t11;
    let i10 = e15;
    if (vkt.includes(o10) || o10 === rVe) {
      const e16 = a10.dataSetName || a10.dataSet;
      const t12 = vj(i10);
      t12.length && t12.some((e17) => !zj(i10, e17.path)) && e16 && !i10.DataSetName && (i10 = AV(i10, { DataSetName: { $set: e16 } }));
    }
    if (A5.match(t11)) {
      const { width: e16, height: t12 } = a10;
      const n11 = e16 && L$.max([e16, G5]);
      const r11 = t12 && L$.max([t12, G5]);
      i10 = F4(i10, n11 || i10.$width || i10.$place.Width, r11 || i10.$height || i10.$place.Height), i10 = M4(i10);
    } else {
      if (rj(i10) || f1(i10)) {
        if (i10 = r10(i10, t11), vkt.includes(o10)) {
          const { fieldName: r11 } = a10;
          i10 = function(e16, t12, n11, r12) {
            const { payload: o11 } = t12;
            const { fieldName: a11 } = o11;
            if (!a11) return e16;
            let i11 = e16;
            if (r12.autoFillHeader && (i11 = JMt(e16, n11, a11)), r12.autoFillFooter) {
              const { fieldInfo: e17, dataSetName: t13, withScope: n12 } = o11;
              i11 = QMt(i11, a11, e17, t13, n12);
            }
            return i11;
          }(i10, t11, e15, n10), i10 = J5e(i10, r11);
        }
        return i10;
      }
      i10 = P4(e15, ({ item: e16 }) => ykt(e16, t11));
    }
    return i10;
  };
}, getContextActions: function(e14, t10, n10) {
  const { lockLayout: r10 } = KO.of(t10);
  if (r10) return [];
  const o10 = i0e(e14, t10, n10);
  if (rj(e14)) return [WFt(null, zFt("title"), oMt(e14)), ...o10];
  if (!ij(e14)) return [];
  if (!f1(e14)) return [];
  const a10 = [];
  let i10 = null;
  if (p1(e14)) {
    const t11 = JQ(e14) > s1(e14);
    i10 = UFt(nf(t1e), "contextActions:container.delete", !t11, vVe()), a10.push(...tMt(e14, t11)), a10.push(...QFt(e14)), a10.push(...oMt(e14));
  } else if (((e15) => l1(e15) > 0)(e14)) {
    const t11 = QQ(e14) > l1(e14);
    i10 = UFt(nf(t1e), "contextActions:container.delete", !t11, bVe()), a10.push(...nMt(e14, t11));
  } else if (m1(e14)) {
    i10 = UFt(nf(t1e), "contextActions:container.delete", false, JG());
    const n11 = ((e15, t11) => {
      const n12 = yj(e15);
      if (1 !== n12.length || !sj(n12[0])) return null;
      const r11 = n12[0];
      const o11 = r11.Type;
      if (!_1e[o11]) return null;
      const { getPropertyDescriptor: a11, defaultValue: i11 } = _1e[o11];
      const s10 = { descriptor: a11(), objectValues: [r11], defaultValues: [i11] };
      const l10 = _A.of(t11).open("connectedExpressionEditor", s10);
      return jFt(nf(q1e), "expression", false, l10);
    })(e14, t10);
    null !== n11 && a10.push(n11), a10.push(...((e15, t11) => [...eMt(e15, t11), ...tMt(e15, JQ(e15) > u1(e15)), ...nMt(e15, QQ(e15) > d1(e15))])(e14, t10)), a10.push(...QFt(e14));
  } else ((e15) => e15.TableGroups.some(rj))(e14) ? (i10 = UFt(nf(t1e), "contextActions:container.delete", !XFt(e14), SVe()), a10.push(...QFt(e14, true))) : rj(e14.Details) && (i10 = UFt(YFt.TableDetailsRemove, "contextActions:table.removeDetails", !rMt(e14), wVe()));
  return [...a10.length ? [WFt(null, zFt("title"), a10)] : [], ...o10, ...i10 ? [i10] : []];
}, glyph: (e14) => {
  const { item: t10, path: n10, dataSets: r10, parentBackgroundColor: o10, theme: a10, onlyContent: i10 } = e14;
  const { instanceId: s10, getItemLayerInfo: l10 } = ep.useContext(bqe);
  const { isVisible: c10, isLocked: u10 } = l10(t10);
  const { lockLayout: d10 } = KO.of(s10);
  const p10 = PA();
  const m10 = (e15, n11, r11) => {
    if (e15.shiftKey) {
      let [o11, a11] = [null, null];
      if (XQ(t10, (e16) => {
        sj(e16.item) && (o11 = e16), e16.rowIdx === n11 && e16.colIdx === r11 && (a11 = e16);
      }), !o11 || !a11 || o11 === a11) return;
      const [i11, s11, l11, c11] = [Math.min(o11.rowIdx, a11.rowIdx), Math.min(o11.colIdx, a11.colIdx), Math.max(o11.rowIdx + o11.rowSpan, a11.rowIdx + a11.rowSpan), Math.max(o11.colIdx + o11.colSpan, a11.colIdx + a11.colSpan)];
      const u11 = [o11.item.Name];
      XQ(t10, (e16) => {
        if (e16.item.Name === o11.item.Name) return;
        (s11 <= e16.colIdx && e16.colIdx < c11 || e16.colIdx < s11 && s11 < e16.colIdx + e16.colSpan) && (i11 <= e16.rowIdx && e16.rowIdx < l11 || e16.rowIdx < i11 && i11 < e16.rowIdx + e16.rowSpan) && u11.push(e16.item.Name);
      }), p10(h5(u11)), e15.stopPropagation();
    }
  };
  const h10 = Bme(t10.Style.BackgroundColor, o10, a10);
  const f10 = { tableLayout: "fixed", width: t10.$place.Width, height: t10.$place.Height, position: "absolute", borderCollapse: "collapse", color: t10.Style.Color || "black", border: "none", pointerEvents: c10 ? "all" : "none" };
  rj(t10) && (f10.backgroundColor = h10);
  const [g10, y10] = [e1(t10), t1(t10)];
  const v10 = [];
  YQ(t10, (e15, o11, s11) => {
    const l11 = [];
    e15.TableCells.forEach((e16, c12) => {
      if (!e16) return;
      const u11 = $j(n10, `${s11}.TableCells.${c12}.Item`);
      const d11 = { host: t10.Name, key: u11, Content: e16.Item, RowSpan: e16.RowSpan, ColSpan: e16.ColSpan, CellWidth: L$.sum(y10, c12, e16.ColSpan).css, CellHeight: L$.sum(g10, o11, e16.RowSpan).css, path: u11, parentBackgroundColor: h10, onClick: m10, dataSets: r10, theme: a10, rowIdx: o11, colIdx: c12, onlyContent: i10 };
      l11.push(tp.createElement(s4e, __spreadValues({}, d11)));
    });
    const c11 = { height: g10[o11].css };
    v10.push(tp.createElement("tr", { key: s11, style: c11 }, l11));
  });
  const b10 = tp.createElement("table", { "data-path": n10, "data-type": t10.Type, className: kp("ar-item", "ar-table"), style: f10 }, tp.createElement("colgroup", null, y10.map((e15, t11) => tp.createElement("col", { key: `col-${t11}`, span: 1, style: { width: e15.css } }))), tp.createElement("tbody", null, v10));
  const S10 = !u10 && !d10 && !i10;
  return tp.createElement("div", { className: "ar-table-glyph" }, tp.createElement(HMt, { table: t10 }, b10), tp.createElement(LMt, { item: t10, path: n10, dndEnabled: S10 }), S10 && tp.createElement(bMt, { columnSizes: y10, path: n10, dispatch: p10, table: t10 }));
}, getProperties: (e14, t10, n10) => {
  var _a2, _b2, _c2, _d2;
  const r10 = (_d2 = (_c2 = (_b2 = (_a2 = n10 == null ? void 0 : n10.settings) == null ? void 0 : _a2.rdlx) == null ? void 0 : _b2.reportItemsFeatures) == null ? void 0 : _c2.table) == null ? void 0 : _d2.hideFrozenRowsColumns;
  const o10 = !e14.Details;
  const a10 = [];
  r10 && a10.push(RMt), o10 && a10.push(AMt), (n10 == null ? void 0 : n10.isDashboard) && a10.push(OMt);
  const i10 = ((e15, t11, n11) => (n11 == null ? void 0 : n11.isDashboard) ? n4(VMt) : VMt)(0, 0, n10);
  const s10 = a10.length > 0 ? i10.filter((e15) => a10.every((t11) => t11(e15))) : i10;
  return s10;
}, features: { getExpressionProperties: function() {
  return [];
}, borderStyles: ["None", "Dotted", "Dashed", "Solid", "Double", "DashDot", "DashDotDot"], isDataRegion: true } };
const Skt = ["PageBreak", "NewPage", "KeepTogether", "FrozenRows", "FrozenColumns"];
const Ckt = { RepeatBlankRows: Zq(cY, "table.repeatBlankRows", "enum", "RepeatBlankRows", void 0, { enumKey: "repeat_blank_rows" }) };
const xkt = VMt.filter((e14) => !Skt.includes(e14.valuePath)).concat(Ckt.RepeatBlankRows, FY.FixedWidth, FY.FixedHeight, FY.OverflowName);
function wkt(e14) {
  var _a2, _b2;
  if (!Y$(e14)) return e14;
  if (K$(e14)) return e14;
  const t10 = {};
  if (!X$(e14)) {
    const n11 = e14.$width || ((_a2 = e14.$place) == null ? void 0 : _a2.Width);
    e14.$fixedPlace.Width && e14.$fixedPlace.Width !== n11 && (t10.Width = { $set: n11 });
  }
  const n10 = e14.$height || ((_b2 = e14.$place) == null ? void 0 : _b2.Height);
  return e14.$fixedPlace.Height && e14.$fixedPlace.Height !== n10 && (t10.Height = { $set: n10 }), zV.isEmpty(t10) ? e14 : AV(e14, { $fixedPlace: t10 });
}
function Tkt(e14) {
  return KQ(e14, ({ item: e15 }) => wkt(e15));
}
const Ekt = { type: B4.Type, baseType: "table", labelKey: bkt.labelKey, nameTemplateKey: bkt.nameTemplateKey, icon: bkt.icon, icon24: bkt.icon24, init: (e14, t10, n10, r10 = B4) => {
  const o10 = __spreadProps(__spreadValues({}, Z5(e14, t10, n10, r10)), { Type: "fixedpagetable" });
  return z5(o10, O4);
}, defaultModel: B4, glyph: bkt.glyph, getReducer: function(e14) {
  return (t10, n10) => {
    switch (n10.type) {
      case jG:
      case UG: {
        const r10 = n10.payload.items.map(wkt);
        const o10 = AV(n10, { payload: { items: { $set: r10 } } });
        return Tkt(bkt.getReducer(e14)(t10, o10));
      }
      case GG: {
        const { item: r10 } = n10.payload;
        const o10 = AV(n10, { payload: { item: { $set: wkt(r10) } } });
        return Tkt(bkt.getReducer(e14)(t10, o10));
      }
      default:
        return Tkt(bkt.getReducer(e14)(t10, n10));
    }
  };
}, getContextActions: bkt.getContextActions, features: { getExpressionProperties: bkt.getExpressionProperties, borderStyles: ["None", "Dotted", "Dashed", "Solid", "Double", "DashDot", "DashDotDot"], isDataRegion: true, isFplItem: true }, getProperties: function(e14) {
  if (!e14.Details) {
    const e15 = xkt.filter((e16) => "sort_expression_expr_collection" !== e16.type);
    return e15;
  }
  return xkt;
} };
const Fkt = ["PageBreak", "NewPage", "KeepTogether", "FrozenRows", "FrozenColumns"];
const Mkt = D4e.filter((e14) => !Fkt.includes(e14.valuePath)).concat(FY.FixedWidth, FY.FixedHeight, FY.OverflowName, FY.RepeatToFill);
const kkt = { type: V4e.Type, baseType: "tablix", labelKey: I4e.labelKey, nameTemplateKey: I4e.nameTemplateKey, icon: I4e.icon, icon24: I4e.icon24, init: (e14, t10, n10, r10 = V4e) => {
  const o10 = __spreadProps(__spreadValues({}, I4e.init(e14, t10, n10, r10)), { Type: "fixedpagetablix" });
  return z5(o10, _4e);
}, defaultModel: V4e, glyph: I4e.glyph, getReducer: X4e, getProperties: () => Mkt, getContextActions: I4e.getContextActions, features: { isDataRegion: true, isFplItem: true, borderStyles: ["None", "Dotted", "Dashed", "Solid", "Double", "DashDot", "DashDotDot"] } };
const Pkt = _V("ITEM/ADD_TOC_ITEM");
const Nkt = _V("ITEM/REMOVE_TOC_ITEM", ({ index: e14 }) => ({ index: e14 }));
const Dkt = { None: "", Decimal: "1", DecimalLeadingZero: "01", LowerRoman: "i", UpperRoman: "I", LowerLatin: "a", UpperLatin: "A", CircledNumber: "\u2460", KatakanaBrackets: "(\u30A2)", KatakanaIrohaBrackets: "\u30A4)", Katakana: "\u30A2", KatakanaIroha: "\u30A4", KatakanaLower: "\uFF71", KatakanaIrohaLower: "\uFF68", LowerGreek: "\u03B1", UpperGreek: "\u0391", LowerArmenian: "\u0561", UpperArmenian: "\u0531", Georgian: "\u10D0" };
const [Lkt, , Hkt] = Dp("toc-level");
const [Ikt] = Hkt("body");
const [_kt] = Hkt("container");
const [Vkt] = Hkt("numbering");
const [Rkt] = Hkt("name");
const [Akt] = Hkt("fill-char");
const [Okt] = Hkt("page-number");
const [Bkt, zkt] = Hkt("selection");
const [$kt] = Dp("toc-level-delete");
class Wkt extends tp.Component {
  constructor() {
    super(...arguments), this.onRemoveLevel = () => {
      const { onRemoveLevel: e14, index: t10 } = this.props;
      e14(t10);
    };
  }
  render() {
    const { item: e14, parentBackgroundColor: t10, canRemove: n10, theme: r10, path: o10, index: a10 } = this.props;
    const { getReport: i10 } = this.context;
    const { Style: s10, Type: l10, LevelName: c10, DisplayFillCharacters: u10, DisplayPageNumber: d10 } = e14;
    const p10 = s10.LeadingChar.length > 1 && s10.LeadingChar.startsWith("=");
    const m10 = u10 && d10 && !p10 ? new Array(1001).join(s10.LeadingChar || " ") : "";
    const h10 = ((e15, t11) => {
      let n11 = "";
      if (!t11) return n11;
      const { Levels: r11, NumberingStyle: o11 } = t11;
      const a11 = "None" !== o11;
      const i11 = r11.length && r11.length > e15 && "None" !== r11[e15];
      if (a11 || i11) for (let t12 = 0; t12 <= e15; t12++) {
        const a12 = Dkt[r11[t12] || o11];
        n11 = n11.concat(a12), t12 !== e15 && (n11 = n11.concat("."));
      }
      return n11;
    })(a10, i10().DocumentMap);
    const f10 = rj(e14);
    const g10 = f10 && ij(e14);
    const y10 = Bme(s10.BackgroundColor, t10, r10);
    const v10 = __spreadProps(__spreadValues({}, _me({ family: s10.FontFamily, size: s10.FontSize, style: s10.FontStyle, weight: s10.FontWeight }, r10)), { textAlign: s10.TextAlign, color: Sme(s10.Color, r10) });
    const b10 = __spreadProps(__spreadValues({}, kme(s10)), { backgroundColor: y10 });
    const S10 = __spreadProps(__spreadValues({}, Rme(s10.TextDecoration)), { backgroundColor: y10 });
    const C10 = __spreadProps(__spreadValues({}, Rme(s10.TextDecoration)), { backgroundColor: y10 });
    const x10 = { minWidth: s10.TextIndent };
    const w10 = { block: true, size: "small", background: "transparent", rounded: true, icon: nf(uh), customCSS: $kt, onClick: this.onRemoveLevel };
    return tp.createElement("div", { className: Lkt, style: v10 }, tp.createElement("div", { title: c10, className: kp("ar-item", Ikt), "data-path": o10, "data-type": l10, style: { backgroundColor: y10 } }, tp.createElement("div", { className: "ar-item", style: b10 }, tp.createElement("div", { className: _kt, style: S10 }, h10 && tp.createElement("span", { className: Vkt, style: x10 }, h10), tp.createElement("span", { className: Rkt }, c10), u10 && tp.createElement("span", { className: Akt }, m10), !u10 && d10 && tp.createElement("span", null, "#")), u10 && d10 && tp.createElement("div", { className: Okt, style: C10 }, "#")), f10 && tp.createElement("div", { className: kp(Bkt, g10 && zkt("primary")) })), n10 && tp.createElement(qm, __spreadValues({}, w10)), tp.createElement("div", { style: { clear: "both" } }));
  }
}
Wkt.contextType = bqe;
class jkt extends tp.Component {
  constructor() {
    super(...arguments), this.onAddLevel = () => {
      const { dispatch: e14 } = this.props;
      e14(Pkt());
    }, this.onRemoveLevel = (e14) => {
      const { dispatch: t10 } = this.props;
      t10(Nkt({ index: e14 }));
    };
  }
  render() {
    const { item: e14, item: { Style: t10, Type: n10, Levels: r10 }, parentBackgroundColor: o10, theme: a10, t: i10 } = this.props;
    const { path: s10 } = this.props;
    const { getSettings: l10 } = this.context;
    const { lockLayout: c10 } = l10();
    const u10 = Bme(t10.BackgroundColor, o10, a10);
    const d10 = ij(e14);
    const p10 = !c10 && d10;
    const m10 = !c10 && d10;
    const h10 = kp("ar-item", "ar-toc");
    return tp.createElement("div", { className: h10, "data-path": s10, "data-type": n10 }, tp.createElement("div", { className: "toc-body" }, tp.createElement("div", { className: "toc-levels" }, r10.map((e15, t11) => {
      const n11 = `toc-level${t11}`;
      return tp.createElement(Wkt, { key: n11, item: e15, path: jj(s10, t11), index: t11, parentBackgroundColor: u10, canRemove: m10, theme: a10, onRemoveLevel: this.onRemoveLevel });
    }))), p10 && tp.createElement("div", { className: "toc-insert-wrapper" }, tp.createElement("div", { className: "toc-insert" }, tp.createElement(qm, { block: true, accent: "icon", background: "transparent", size: "small", width: "100%", icon: nf(Xm), text: i10("adorners:tableOfContents.addItem", "Add item"), onClick: this.onAddLevel }))));
  }
}
jkt.contextType = bqe;
var Zkt = TA()(xp()(jkt));
const Gkt = FZ.resultOf(wq.decode({ Type: "tableofcontents", Name: "toc1", Width: "2in", Height: "1in" }));
const Ukt = [EY.Name, Zq(Xq, "style.backgroundColor", "color_expr", "Style.BackgroundColor"), vY.Border, EY.Location, EY.Size, Zq(cY, "reportItem.style", "styles", "ReportStyle", void 0, { target: "TableOfContents" }), EY.LayerName, FY.PageBreak, FY.NewPage, EY.ZIndex, EY.Visibility, EY.DataElementName, EY.DataElementOutput, vY.MaxLevel, EY.ToolTip, EY.Label, EY.Bookmark];
const qkt = FZ.resultOf(wq.decode({ Type: "tableofcontents", Name: "toc1", Width: "2in", Height: "1in", Levels: [{ LevelName: "level1" }] })).Levels[0];
const Ykt = (e14) => `tocLevel.${e14}`;
const Kkt = [Zq(tY, Ykt("label"), "string", "LevelName"), Zq(Xq, "style.backgroundColor", "color_expr", "Style.BackgroundColor"), vY.FontSimple, vY.Color, vY.Font, vY.TextDecoration, vY.TextAlign, vY.TextIndent, vY.Padding, EY.DataElementName, Zq(iY, Ykt("fillCharacter"), "string_expr", "Style.LeadingChar"), Zq(iY, Ykt("displayFillCharacters"), "boolean", "DisplayFillCharacters"), Zq(iY, Ykt("displayPageNumber"), "boolean", "DisplayPageNumber")];
const Xkt = { type: "tableofcontentslevel", labelKey: "reportItems:tableOfContentsLevel", nameTemplateKey: "nameTemplates:tocLevel", init: (e14, t10, n10, r10 = qkt) => __spreadProps(__spreadValues(__spreadValues({}, r10), n10), { LevelName: e14 }), defaultModel: qkt, glyph: Wkt, getProperties: () => Kkt, features: { textDecorations: ["None", "Underline", "Overline", "LineThrough"] } };
const Jkt = ["BackgroundColor", "Border"];
const Qkt = ["BackgroundColor", "Color", "FontFamily", "FontSize", "FontStyle", "FontWeight", "PaddingLeft", "PaddingTop", "PaddingRight", "PaddingBottom"];
const ePt = (e14, t10, n10) => {
  var _a2;
  const r10 = ((e15) => {
    const t11 = nz.of(e15).getTemplate("tableofcontents").Levels[0];
    const { Style: { BackgroundColor: n11, Color: r11, FontFamily: o11, FontSize: a11, FontStyle: i10, FontWeight: s10, PaddingLeft: l10, PaddingTop: c10, PaddingRight: u10, PaddingBottom: d10 } } = t11;
    return { BackgroundColor: n11, Color: r11, FontFamily: o11, FontSize: a11, FontStyle: i10, FontWeight: s10, PaddingLeft: l10, PaddingTop: c10, PaddingRight: u10, PaddingBottom: d10 };
  })(e14);
  if (0 === (((_a2 = n10 == null ? void 0 : n10.Levels) == null ? void 0 : _a2.length) || 0)) return r10;
  const o10 = Math.min(Math.max(t10, 0), n10.Levels.length - 1);
  const a10 = n10.Levels[o10];
  return a10 ? __spreadValues(__spreadValues({}, r10), a10) : r10;
};
function tPt(e14, t10, n10) {
  const r10 = t10 ? zV.merge({}, e14.Levels[n10].Style, zV.pick(t10, Qkt)) : null;
  return r10 ? AV(e14, { Levels: { [n10]: { Style: { $set: r10 } } } }) : e14;
}
const nPt = (e14, t10) => {
  if (e14 && e14.$targetType !== wj.TableOfContents) return null;
  const n10 = ((e15) => {
    const t11 = nz.of(e15).getTemplate("tableofcontents");
    const { Style: { BackgroundColor: n11, Border: r10 } } = t11;
    return { BackgroundColor: n11, Border: r10 };
  })(t10);
  return e14 ? __spreadValues(__spreadValues({}, n10), e14) : n10;
};
const rPt = (e14, { payload: t10 }) => {
  const { index: n10 } = t10;
  const r10 = AV(e14, { Levels: { $splice: [[n10, 1]] } });
  return rj(e14.Levels[n10]) ? pj(r10) : r10;
};
const oPt = (e14, { payload: t10 }) => AV(e14, { ReportStyle: { $set: { StyleId: t10.id || "", StyleName: t10.name || "" } } });
const aPt = (e14, t10) => (e14.Levels || []).reduce((e15, n10, r10) => {
  const o10 = n5(n10, t10);
  return o10 !== n10 ? AV(e15, { Levels: { [r10]: { $set: o10 } } }) : e15;
}, e14);
const iPt = { type: "tableofcontents", labelKey: "reportItems:tableOfContents", nameTemplateKey: "nameTemplates:tableOfContents", icon: nf(Pae), icon24: nf(Nae), init: (e14, t10, n10, r10 = Gkt) => __spreadProps(__spreadValues(__spreadValues({}, r10), n10), { Name: e14 || "" }), defaultModel: Gkt, glyph: Zkt, getReducer: function(e14) {
  const t10 = nz.of(e14).of("rdlx").getDefaultReducer();
  return Uye(0, { [Pkt.type]: (t11) => {
    const n10 = TG("tocLevel");
    let r10 = 1;
    let o10 = `${n10}${r10}`;
    const a10 = t11.Levels.map((e15) => e15.LevelName);
    for (; a10.includes(o10); ) o10 = `${n10}${++r10}`;
    let i10 = AV(t11, { Levels: { $push: [Xkt.init(o10, "in", {})] } });
    return i10 = tPt(i10, ePt(e14, i10.Levels.length - 1, i10.$style), i10.Levels.length - 1), i10;
  }, [Nkt.type]: rPt, [v2.type]: GV(rj, oPt), [b2.type]: GV(rj, (t11, { payload: n10 }) => {
    const r10 = nPt(n10.style, e14);
    return r10 ? function(e15, t12, n11) {
      const r11 = zV.merge({}, t12.Style, zV.pick(n11, Jkt));
      const o10 = AV(t12, { Style: { $set: r11 } });
      return o10.Levels.reduce((t13, r12, o11) => tPt(t13, ePt(e15, o11, n11), o11), o10);
    }(e14, t11, r10) : t11;
  }) }, GV(rj, t10, aPt));
}, getProperties: (e14, t10, n10) => (n10 == null ? void 0 : n10.isDashboard) ? n4(Ukt) : Ukt, getContextActions: i0e, features: { borderStyles: ["None", "Dotted", "Dashed", "Solid", "Double", "DashDot", "DashDotDot"], textDecorations: ["None", "Underline", "Overline", "LineThrough"] } };
const sPt = "fixedpagetableofcontents";
const lPt = { $fixedPlace: { Height: "0.5in", OverflowName: "" } };
const cPt = __spreadValues(__spreadValues({}, iPt.defaultModel), __spreadValues({ Type: sPt }, lPt));
const uPt = ["PageBreak", "NewPage"];
const dPt = Ukt.filter((e14) => !uPt.includes(e14.valuePath)).concat(FY.FixedHeight, FY.OverflowName);
const pPt = { type: cPt.Type, baseType: "tableofcontents", labelKey: iPt.labelKey, nameTemplateKey: iPt.nameTemplateKey, icon: iPt.icon, icon24: iPt.icon24, init: (e14, t10, n10, r10 = cPt) => {
  const o10 = __spreadProps(__spreadValues({}, iPt.init(e14, t10, n10, r10)), { Type: sPt });
  return z5(o10, lPt, false);
}, defaultModel: cPt, glyph: iPt.glyph, getReducer: iPt.getReducer, getContextActions: i0e, getProperties: () => dPt, features: { borderStyles: ["None", "Dotted", "Dashed", "Solid", "Double", "DashDot", "DashDotDot"], textDecorations: ["None", "Underline", "Overline", "LineThrough"], isFplItem: true } };
const mPt = ["Html"];
const hPt = (e14) => `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.1//EN" "http://www.w3.org/TR/xhtml11/DTD/xhtml11.dtd">
<html xmlns="http://www.w3.org/1999/xhtml">
	<head>
		<meta http-equiv="Content-Type" content="application/xhtml+xml; charset=utf-8" />
	</head>
	<body>${e14}</body>
</html>`;
const fPt = "defaultStyle";
const gPt = (e14, t10, n10, r10) => e14.replace(/<\s*%\s*([^/]*)\s*\/\s*%\s*>/g, (e15, o10) => {
  const a10 = t10.find((e16) => e16.Name === o10);
  const i10 = HJ(a10 == null ? void 0 : a10.Value, "string_expr", { expressionSyntax: r10 });
  return a10 ? n10 && ((e16) => e16.replace(/[\u00A0-\u9999<>&]/g, (e17) => `&#${e17.charCodeAt(0)};`))(i10) || i10 : "";
});
const yPt = (e14) => {
  var _a2;
  const t10 = new DOMParser();
  try {
    const n10 = ((e15) => {
      const t11 = fc("rdl", e15);
      return "expression" === t11.type ? t11.pieces.filter((e16) => "literal" === e16.type).map((e16) => e16.text).join("") : e15;
    })(e14);
    const r10 = ((e15) => {
      const t11 = e15 && /<!DOCTYPE.*?>/.exec(e15);
      return t11 && t11[0] || null;
    })(n10);
    const o10 = t10.parseFromString(r10 ? n10 : hPt(n10), "application/xhtml+xml");
    const a10 = t10.parseFromString(r10 ? n10 : hPt(n10), "text/html");
    const i10 = o10.getElementsByTagName("parsererror");
    if (!a10 || !o10) return { isValid: false };
    const s10 = a10.getElementsByTagName("parsererror");
    return 0 === s10.length ? { isValid: true, parsedHtml: a10 } : i10.length > 0 ? { isValid: false } : ((_a2 = s10[0].parentNode) == null ? void 0 : _a2.removeChild(s10[0]), { isValid: false, parsedHtml: a10 });
  } catch (e15) {
    const t11 = new Document();
    const n10 = document.createElement("body");
    return t11.body = n10, { isValid: false, parsedHtml: t11 };
  }
};
const vPt = FZ.resultOf(wq.decode({ Type: "formattedtext", Name: "formattedText1", Width: "2in", Height: "1in" }));
const bPt = (e14) => `formattedText.${e14}`;
const SPt = [EY.Name, Zq(nY, bPt("html"), "html_expr", "Html"), Zq(nY, bPt("encodeMailMergeFields"), "boolean", "EncodeMailMergeFields"), Zq(nY, bPt("mailMergeFields"), "mail_merge_fields_collection", "MailMergeFields"), vY.BackgroundAndBorders, vY.BackgroundColor, vY.BackgroundImage, vY.Borders, EY.Location, EY.Size, Zq(cY, "reportItem.style", "styles", "ReportStyle", void 0, { target: "FormattedText" }), EY.LayerName, EY.ZIndex, EY.Visibility, EY.DataElementName, EY.DataElementOutput, EY.ToolTip, EY.Label, EY.Bookmark, EY.AccessibleDescription];
const CPt = (e14, t10) => {
  if (e14 && e14.$targetType !== wj.FormattedText) return null;
  const n10 = ((e15) => {
    const t11 = nz.of(e15).getTemplate("formattedtext");
    const { BackgroundColor: n11, Border: r10, TopBorder: o10, BottomBorder: a10, LeftBorder: i10, RightBorder: s10 } = t11.Style;
    return { BackgroundColor: n11, Border: r10, TopBorder: o10, BottomBorder: a10, LeftBorder: i10, RightBorder: s10 };
  })(t10);
  return e14 ? __spreadValues(__spreadValues({}, n10), e14) : n10;
};
const xPt = { type: "formattedtext", labelKey: "reportItems:formattedText", nameTemplateKey: "nameTemplates:formattedText", init: (e14, t10, n10, r10 = vPt) => __spreadProps(__spreadValues(__spreadValues({}, r10), n10), { Name: e14 || "" }), icon: nf(fae), icon24: nf(gae), defaultModel: vPt, glyph: ({ item: e14, path: t10 }) => {
  const { Type: n10, Html: r10, MailMergeFields: o10, EncodeMailMergeFields: a10 } = e14;
  const { userPreferences: { surface: { zoomFactor: i10 } }, rdlx: { expressionSyntax: s10 } } = MO();
  const [l10, c10] = ep.useState(yPt(gPt(r10, o10, a10, s10)));
  const u10 = ep.useRef(null);
  const { isValid: d10 } = l10;
  const { t: p10 } = vp();
  ep.useEffect(() => {
    h10(), m10();
  }, []);
  const m10 = ep.useCallback(() => {
    var _a2, _b2;
    const { parsedHtml: e15 } = l10;
    if (((_a2 = u10.current) == null ? void 0 : _a2.contentDocument) && e15) {
      const [t11, n11] = [(_b2 = u10.current) == null ? void 0 : _b2.contentDocument, e15];
      null !== n11.body && (t11.body = n11.body);
      for (let e16 = 0; e16 < t11.head.childNodes.length; ++e16) {
        const n12 = t11.head.childNodes[e16];
        n12.title !== fPt && t11.head.removeChild(n12);
      }
      for (let e16 = 0; e16 < n11.head.children.length; e16++) t11.head.appendChild(n11.head.children[e16]);
    }
  }, [l10]);
  ep.useEffect(() => {
    c10(yPt(gPt(r10, o10, a10, s10)));
  }, [r10, o10, a10, s10]), ep.useEffect(() => {
    m10();
  }, [l10, m10]);
  const h10 = ep.useCallback(() => {
    var _a2, _b2;
    if ((_a2 = u10.current) == null ? void 0 : _a2.contentDocument) {
      const e15 = (_b2 = u10.current) == null ? void 0 : _b2.contentDocument;
      const t11 = "\n				html, body, table  {\n					font-family: Arial;\n					font-size: 10pt;\n					font-style: normal;\n					font-weight: normal;\n					color: black;\n				}";
      const n11 = (e16) => {
        const t12 = document.createElement("style");
        return t12.type = "text/css", t12.title = e16, t12;
      };
      const r11 = e15.head || e15.getElementsByTagName("head")[0];
      const o11 = n11(fPt);
      o11.appendChild(document.createTextNode(t11)), r11.appendChild(o11);
    }
  }, []);
  const f10 = { transform: `scale(${i10})`, transformOrigin: "top left" };
  const g10 = kp("ar-item", "ar-formatted-text");
  return tp.createElement("div", { className: g10, "data-path": t10, "data-type": n10, title: d10 ? r10 : p10("adorners:formattedText.previewError") }, d10 ? tp.createElement("iframe", { scrolling: "no", className: "preview", style: f10, frameBorder: "0", sandbox: "allow-same-origin", ref: u10, title: "iframe-preview-title" }) : tp.createElement("div", { className: "preview error" }, p10("adorners:formattedText.previewError")));
}, getReducer: function(e14) {
  const t10 = nz.of(e14).of("rdlx").getDefaultReducer();
  return function(n10, { type: r10, payload: o10 }) {
    switch (r10) {
      case v2.type:
        if (!rj(n10)) break;
        return AV(n10, { ReportStyle: { $set: { StyleId: o10.id || "", StyleName: o10.name || "" } } });
      case b2.type: {
        if (!rj(n10)) break;
        const t11 = CPt(o10.style, e14);
        return t11 ? function(e15, t12) {
          const n11 = __spreadValues(__spreadValues({}, e15.Style), t12);
          return AV(e15, { Style: { $set: n11 } });
        }(n10, t11) : n10;
      }
      default:
        return t10(n10, { type: r10, payload: o10 });
    }
  };
}, getContextActions: i0e, getProperties: () => SPt, features: { getExpressionProperties: function() {
  return mPt;
} } };
const wPt = ["Value", "HorizontalAlignment", "VerticalAlignment", "MIMEType"];
const TPt = { Center: "center", Right: "right" };
const EPt = { Middle: "center", Bottom: "bottom" };
const FPt = { Fit: "fit", FitProportional: "fit-proportional", Clip: "", AutoSize: "" };
var MPt = TA()((e14) => {
  const { makeImageUrl: t10, embeddedImages: n10 } = ep.useContext(bqe);
  const { path: r10, item: o10 } = e14;
  const { VerticalAlignment: a10, HorizontalAlignment: i10, Sizing: s10, Type: l10 } = o10;
  const c10 = kme(o10.Style);
  const u10 = { backgroundImage: ep.useMemo(() => t10(o10.Source, o10.Value, n10), [o10.Source, o10.Value, n10]), backgroundPosition: `${p10 = a10, EPt[p10] || "top"} ${d10 = i10, TPt[d10] || "left"}` };
  var d10;
  var p10;
  const m10 = kp("ar-item", "ar-image-glyph");
  const h10 = `image-container ${f10 = s10, FPt[f10] || ""}`;
  var f10;
  const g10 = X1(YAe(o10.Value));
  return tp.createElement("div", { className: m10, "data-type": l10, "data-path": r10, style: c10 }, o10.Value.length > 0 && !o10.Value.startsWith("=") ? tp.createElement("div", { style: u10, className: h10 }) : tp.createElement("span", null, g10));
});
const kPt = FZ.resultOf(wq.decode({ Type: "image", Name: "image", Width: "1in", Height: "1in" }));
const PPt = (e14) => `image.${e14}`;
const NPt = [EY.Name, EY.Action, Zq(Kq, PPt("imageLabel"), "image_data_advanced", ""), Zq(Kq, PPt("sizing"), "enum", "Sizing", void 0, { enumKey: "image_sizing" }), Zq(Kq, PPt("horizontalAlignment"), "enum_expr", "HorizontalAlignment", void 0, { enumKey: "horizontal_align" }), Zq(Kq, PPt("verticalAlignment"), "enum_expr", "VerticalAlignment", void 0, { enumKey: "vertical_align" }), vY.Borders, EY.Location, EY.Size, vY.Padding, EY.LayerName, EY.ZIndex, EY.Visibility, EY.ToolTip, EY.Label, EY.Bookmark, EY.AccessibleDescription];
const DPt = { type: "image", init: (e14, t10, n10, r10 = kPt) => __spreadProps(__spreadValues(__spreadValues({}, r10), n10), { Name: e14 }), labelKey: "reportItems:image", nameTemplateKey: "nameTemplates:image", icon: nf(Xoe), icon24: nf(Joe), defaultModel: kPt, glyph: MPt, getReducer: q5, getProperties: () => NPt, getContextActions: i0e, features: { getExpressionProperties: function() {
  return wPt;
} } };
const LPt = { Type: "layer", DesignerLock: false, DesignerTransparency: 0, DesignerVisible: true, DesignerDataFieldVisible: true, TargetDevice: "All", Name: "" };
const HPt = [Zq("", "", "layer", ""), Zq("targetDevice", "layer.targetDevice", "target_device", "TargetDevice")];
const IPt = { type: "layer", labelKey: "reportItems:layer", nameTemplateKey: "nameTemplates:layer", init: (e14) => __spreadProps(__spreadValues({}, LPt), { Name: e14 }), defaultModel: LPt, getProperties: () => HPt };
const _Pt = ["LineWidth", "LineStyle", "LineColor"];
const VPt = (e14) => `line.${e14}`;
const RPt = [EY.Name, Zq(cY, VPt("startPoint"), "start_point", ""), Zq(cY, VPt("endPoint"), "end_point", ""), EY.LayerName, EY.ZIndex, Zq(Kq, VPt("lineColor"), "color_expr", "LineColor"), Zq(Kq, VPt("lineStyle"), "border_style", "LineStyle", void 0, { enumKey: "line_control_style" }), Zq(Kq, VPt("lineWidth"), "length_expr", "LineWidth", void 0, qq.lineWidth), EY.Visibility, EY.Label, EY.Bookmark, EY.AccessibleDescription];
const APt = { type: "line", init: (e14, t10, n10, r10 = u2e) => {
  const { units: o10 } = KO.of(t10).userPreferences;
  const a10 = { startPoint: { X: `0${o10}`, Y: `0${o10}` }, endPoint: { X: L$.parse(r10.EndPoint.X).subtract(L$.parse(r10.StartPoint.X)).css, Y: L$.parse(r10.EndPoint.Y).subtract(L$.parse(r10.StartPoint.Y)).css } };
  return __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, r10), { StartPoint: a10.startPoint, EndPoint: a10.endPoint }), n10), { Name: e14 });
}, labelKey: "reportItems:line", nameTemplateKey: "nameTemplates:line", icon: nf(aae), icon24: nf(iae), defaultModel: u2e, glyph: (e14) => {
  const { item: t10, item: { LineStyle: n10, LineColor: r10, LineWidth: o10 }, path: a10, theme: i10 } = e14;
  const { Top: s10, Left: l10 } = cU(t10);
  const c10 = lU(t10, l10.negative().css, s10.negative().css);
  const u10 = ome(t10) ? rme : ((e15, t11, n11, r11) => {
    const o11 = !jme(e15) && Cme(e15) || u2e.LineStyle;
    const a11 = Sme(t11, r11);
    const i11 = !jme(a11) && a11 || u2e.LineColor;
    const s11 = !jme(n11) && n11 || u2e.LineWidth;
    return { borderStyle: `${o11} none none none`.toLowerCase(), borderColor: i11.toLowerCase(), borderWidth: s11 };
  })(n10, r10, o10, i10);
  const d10 = { regionLineProps: { className: kp("ar-item", "ar-line") }, StartPoint: c10.StartPoint, EndPoint: c10.EndPoint, lineStyle: u10, thickness: u10.borderWidth, dataPath: a10, dataType: t10.Type };
  return tp.createElement(c2e, __spreadValues({}, d10));
}, getProperties: () => RPt, getContextActions: i0e, features: { getExpressionProperties: function() {
  return _Pt;
}, borderStyles: ["None", "Dotted", "Dashed", "Solid", "Double", "DashDot", "DashDotDot"] } };
const OPt = nf(ppt);
const BPt = nf(mpt);
const zPt = nf(hpt);
const $Pt = nf(fpt);
const WPt = nf(Mpt);
const jPt = nf(kpt);
const ZPt = nf(Tpt);
const GPt = nf(Fpt);
const UPt = nf(Ppt);
const qPt = nf(Ept);
const YPt = FZ.resultOf(lX.decode({ Width: "6.5in", ReportSections: [{ Type: "Continuous", Name: "ContinuousSection1", Body: {} }] }));
const KPt = YPt.ReportSections[0];
const XPt = (e14) => `report.${e14}`;
const JPt = [EY.Name, Zq(uY, "", "margins", "Page"), Zq(cY, XPt("columns"), "number", "Page.Columns", "advanced", { numberType: "Integer", minValue: 1, maxValue: 1e3, step: 1 }), Zq(cY, XPt("columnSpacing"), "length", "Page.ColumnSpacing", "advanced", OY), Zq(mY, XPt("pageSize"), "msl_page_size", "Page", "simple", { compactMode: true }), Zq(mY, XPt("pageSize"), "msl_page_size", "Page", "advanced"), Zq(yY, "visibility.hidden", "boolean_expr", "Visibility.Hidden"), wY, EY.DataElementOutput];
const QPt = { type: "Continuous", labelKey: "reportItems:continuousSection", init: (e14, t10, n10, r10 = KPt) => {
  const o10 = tz == null ? void 0 : tz.getTemplate("Continuous");
  const a10 = tz == null ? void 0 : tz.getTemplate("section");
  const { Page: i10 } = o10;
  return __spreadValues(__spreadProps(__spreadValues(__spreadValues({}, KPt), r10), { Page: __spreadValues(__spreadValues({}, i10), r10.Page), PageHeader: null, Body: __spreadProps(__spreadValues({}, r10.Body), { Name: KB(TG("Body")), Style: a10 == null ? void 0 : a10.Style }), PageFooter: null, Name: e14 || "", Width: G5.css }), n10);
}, icon: nf(Vae), defaultModel: KPt, getContextActions: function(e14, t10, n10) {
  const { lockLayout: r10 } = KO.of(t10);
  const o10 = [];
  const a10 = [];
  if (!r10 && !q7(n10)) {
    const t11 = e14.PageHeader ? "contextActions:reportSection.removeHeader" : "contextActions:reportSection.addHeader";
    const r11 = A1e(t11, t11, e14.PageHeader ? BPt : OPt, rTt());
    const i10 = e14.PageFooter ? "contextActions:reportSection.removeFooter" : "contextActions:reportSection.addFooter";
    const s10 = A1e(i10, i10, e14.PageFooter ? $Pt : zPt, oTt());
    const l10 = n10.$activeSectionIndex;
    const c10 = n10.ReportSections[l10];
    const u10 = n10.ReportSections.length > 1;
    const d10 = l10 >= 0;
    const p10 = d10 && l10 > 0;
    const m10 = "contextActions:report.moveSectionLeft";
    const h10 = A1e(m10, m10, WPt, p10 ? z2({ fromIndex: l10, toIndex: l10 - 1 }) : void 0, !p10);
    const f10 = d10 && l10 < n10.ReportSections.length - 1;
    const g10 = "contextActions:report.moveSectionRight";
    const y10 = A1e(g10, g10, jPt, f10 ? z2({ fromIndex: l10, toIndex: l10 + 1 }) : void 0, !f10);
    const v10 = l10 + 1;
    const b10 = l10 >= 0;
    const S10 = rz([O2({ sectionType: "Continuous", index: v10 }), c5(`ReportSections.${v10}`, n10.ReportSections[0].Type)]);
    const C10 = "contextActions:report.insertSection";
    const x10 = A1e(C10, C10, ZPt, b10 ? S10 : void 0, !b10);
    const w10 = l10 >= 0;
    const T10 = rz([$2({ index: l10 }), c5(`ReportSections.${v10}`, n10.ReportSections[0].Type)]);
    const E10 = "contextActions:report.duplicateSection";
    const F10 = A1e(E10, E10, GPt, w10 ? T10 : void 0, !w10);
    const M10 = dpt(c10.Visibility.Hidden);
    const k10 = "contextActions:report.showSection";
    const P10 = "contextActions:report.hideSection";
    const N10 = A1e(M10 ? k10 : P10, M10 ? k10 : P10, UPt, W2({ index: l10 }));
    const D10 = "contextActions:report.removeSection";
    const L10 = A1e(D10, D10, qPt, B2({}), !u10);
    o10.push(r11, s10, R1e(), h10, y10, R1e(), x10, F10, R1e(), N10, R1e(), L10), a10.push(r11, s10);
  }
  return [...i0e(e14, t10, n10), O1e("contextActions:reportSection.title", void 0, o10, void 0, "toolbar"), O1e("contextActions:reportSection.title", void 0, a10, void 0, "contextmenu")];
}, getReducer: aTt, getProperties: (e14, t10, n10) => (n10 == null ? void 0 : n10.isChildReport) ? r4(JPt, { disabled: true }) : JPt, features: { isDataRegion: true, disableCopy: true } };
const eNt = FZ.resultOf(lX.decode({ Width: "6.5in", ReportSections: [{ Type: "FixedPage", Name: "FixedPageSection1", FixedPage: {} }] })).ReportSections[0];
const tNt = [Zq(uY, "", "margins", "Page"), wY, TY];
const nNt = { type: "FixedPage", labelKey: "reportItems:fixedPageSection", init: (e14, t10, n10, r10 = eNt) => __spreadValues(__spreadProps(__spreadValues({}, r10), { Name: e14 || "" }), n10), icon: nf(Vae), defaultModel: eNt, getReducer: aTt, getProperties: () => tNt, features: { isDataRegion: true } };
const rNt = nf(Tpt);
const oNt = nf(Lpt);
const aNt = nf(Dpt);
const iNt = nf(Npt);
const sNt = { type: "multisectionreport", labelKey: "reportItems:report", init: (e14, t10, n10, r10 = YPt) => {
  const o10 = tz == null ? void 0 : tz.getTemplate("Continuous");
  const a10 = r10.ReportSections[0];
  const i10 = tz == null ? void 0 : tz.getTemplate("section");
  const { Page: s10 } = a10 || o10;
  const { Style: l10 } = a10.Body || i10;
  const { Page: c10 } = r10;
  const u10 = c10 && { BottomMargin: c10.BottomMargin, LeftMargin: c10.LeftMargin, RightMargin: c10.RightMargin, TopMargin: c10.TopMargin, PageHeight: c10.PageHeight, PageWidth: c10.PageWidth, ColumnSpacing: c10.ColumnSpacing };
  return __spreadValues(__spreadProps(__spreadValues(__spreadValues({}, YPt), r10), { Name: e14 || "", Width: G5.css, Page: __spreadValues(__spreadValues({}, YPt.Page), u10), ReportSections: r10.ReportSections.map((e15) => {
    let t11 = __spreadProps(__spreadValues({}, e15), { Name: KB(TG(e15.Type)), Width: G5.css, Page: __spreadValues(__spreadValues(__spreadValues({}, YPt.Page), u10), s10) });
    return "Continuous" === t11.Type && (t11 = __spreadProps(__spreadValues({}, t11), { PageHeader: null, PageFooter: null, Body: __spreadProps(__spreadValues({}, t11.Body), { Style: l10, $place: __spreadProps(__spreadValues({}, t11.Body.$place), { Height: G5.css }) }) })), t11;
  }) }), n10);
}, icon: nf(Dae), defaultModel: YPt, getContextActions: function(e14, t10, n10) {
  var _a2;
  const { lockLayout: r10, rdlx: { masterReports: { enabled: o10, canConvert: a10 } } } = KO.of(t10);
  const i10 = [];
  const s10 = (_a2 = e14.$isMasterReport) != null ? _a2 : false;
  const l10 = !!e14.$masterReport;
  return r10 || l10 || i10.push(A1e("contextActions:report.addContinuousSection", "contextActions:report.addContinuousSection", rNt, rz([O2({ sectionType: "Continuous" }), c5(`ReportSections.${n10.ReportSections.length}`, n10.ReportSections[0].Type)])), R1e()), o10 && a10 && !s10 && !l10 && i10.push(A1e("contextActions:report.convertToMasterReport", "contextActions:report.convertToMasterReport", aNt, Z2())), o10 && !s10 && (l10 ? i10.push({ type: "masterReport", key: "contextActions:report.changeMasterReport", icon: oNt, action: G2 }) : i10.push({ type: "masterReport", key: "contextActions:report.setMasterReport", icon: oNt, action: G2 })), i10.length > 2 && i10.push(R1e()), i10.push({ type: "theme", icon: iNt, key: "contextActions:report.switchTheme", action: g2 }), [...i0e(e14, t10, n10), { type: "group", key: "contextActions:report.title", actions: i10, location: "toolbar" }];
}, getReducer: DTt, getProperties: Dwt, features: { isDataRegion: true, disableCopy: true, getPageDimensions: (e14) => {
  const t10 = e14.ReportSections[e14.$activeSectionIndex];
  const n10 = t10.Page;
  const r10 = { pageWidth: L$.parse(n10.PageWidth), pageHeight: L$.parse(n10.PageHeight), margins: { top: L$.parse(n10.TopMargin), bottom: L$.parse(n10.BottomMargin), left: L$.parse(n10.LeftMargin), right: L$.parse(n10.RightMargin) } };
  if ("Continuous" === t10.Type) {
    const e15 = s3(t10);
    const { bodyHeight: n11, footerHeight: o10, headerHeight: a10, horizontalPageNumber: i10, pageHeight: s10, pageBodyHeight: l10, pageWidth: c10, sectionWidth: u10 } = e15;
    return __spreadProps(__spreadValues({}, r10), { visualPageWidth: c10, visualPageHeight: s10, body: { height: l10, width: u10.divideByNum(i10), visualHeight: n11, visualWidth: u10 }, header: { height: a10 }, footer: { height: o10 } });
  }
  return r10;
}, getPageSectionsInfo: (e14) => {
  var _a2, _b2, _c2, _d2, _e2, _f2;
  const t10 = e14.$activeSectionIndex;
  const n10 = e14.ReportSections[t10];
  if ("FixedPage" === n10.Type) {
    const r10 = t10;
    const o10 = n10.FixedPage.Pages[r10];
    const a10 = L$.parse((_a2 = o10.TopMargin) != null ? _a2 : e14.Page.TopMargin);
    const i10 = L$.parse((_b2 = o10.BottomMargin) != null ? _b2 : e14.Page.BottomMargin);
    const s10 = L$.parse((_c2 = o10.LeftMargin) != null ? _c2 : e14.Page.LeftMargin);
    const l10 = L$.parse((_d2 = o10.RightMargin) != null ? _d2 : e14.Page.RightMargin);
    return [{ container: o10, path: `ReportSections.${t10}.FixedPage.Pages.${r10}`, offset: { top: a10, left: s10, width: L$.parse((_e2 = o10.Width) != null ? _e2 : e14.Page.PageWidth).subtract(s10).subtract(l10), height: L$.parse((_f2 = o10.Height) != null ? _f2 : e14.Page.PageHeight).subtract(a10).subtract(i10) } }];
  }
  {
    const e15 = L$.parse(n10.Page.LeftMargin);
    const r10 = L$.parse(n10.Page.RightMargin);
    const o10 = L$.parse(n10.Page.TopMargin);
    const a10 = L$.parse(n10.Page.BottomMargin);
    const i10 = n10.PageHeader ? L$.parse(n10.PageHeader.$place.Height) : new L$(0, "in");
    const s10 = n10.PageFooter ? L$.parse(n10.PageFooter.$place.Height) : new L$(0, "in");
    const l10 = L$.parse(n10.Page.PageWidth).subtract(e15).subtract(r10);
    const c10 = L$.parse(n10.Page.PageHeight).subtract(o10).subtract(a10).subtract(i10).subtract(s10);
    const u10 = n10.PageHeader ? L$.parse(n10.Page.TopMargin).add(L$.parse(n10.PageHeader.$place.Height)) : L$.parse(n10.Page.TopMargin);
    const d10 = L$.max([L$.parseSafe(n10.Body.$place.Height), c10]);
    const p10 = [];
    if (p10.push({ container: n10.Body, path: `ReportSections.${t10}.Body`, offset: { top: u10, left: e15, width: l10, height: c10, visualHeight: d10 } }), n10.PageHeader && p10.push({ container: n10.PageHeader, path: `ReportSections.${t10}.PageHeader`, offset: { top: L$.parse(n10.Page.TopMargin), left: e15, width: l10, height: L$.parse(n10.PageHeader.$place.Height) } }), n10.PageFooter) {
      const r11 = L$.parse(n10.Page.PageHeight).subtract(L$.parse(n10.Page.BottomMargin)).subtract(L$.parse(n10.PageFooter.$place.Height));
      p10.push({ container: n10.PageFooter, path: `ReportSections.${t10}.PageFooter`, offset: { top: r11, visualTop: u10.add(d10), left: e15, width: l10, height: L$.parse(n10.PageFooter.$place.Height) } });
    }
    return p10;
  }
} } };
const lNt = [Zq("", "report.reportPart.displayName", "string", "DisplayName"), Zq("", "report.reportPart.description", "string", "Description"), Zq("", "report.reportPart.reportItemName", "report_part_reportitem_name", "ReportItemName"), Zq("", "report.reportPart.partProperties", "report_part_properties_collection", "Properties")];
const cNt = [Zq("", "report.reportPart.properties.displayName", "string", "DisplayName"), Zq("", "report.reportPart.properties.description", "string", "Description"), Zq("", "report.reportPart.properties.category", "string", "Category"), Zq("", "report.reportPart.properties.defaultValue", "report_part_property_type", "")];
const uNt = { type: "reportpart", labelKey: "reportItems:reportPart", nameTemplateKey: "nameTemplates:reportPart", defaultModel: MHe, getProperties: () => lNt };
const dNt = { type: "reportpartproperty", labelKey: "reportItems:reportPartProperty", nameTemplateKey: "nameTemplates:reportPartProperty", defaultModel: kHe, getProperties: () => cNt };
const pNt = FZ.resultOf(Oq.decode({ Type: "overflowplaceholder", Name: "placeholder1", Width: "1in", Height: "1in" }));
const mNt = [bY.Name, Zq(tY, ((e14) => `overflowPlaceHolder.${e14}`)("overflowName"), "overflow_name", "$fixedPlace.OverflowName"), bY.Location, bY.Size, bY.LayerName];
const hNt = { type: "overflowplaceholder", labelKey: "reportItems:overflowPlaceholder", nameTemplateKey: "nameTemplates:overflowPlaceholder", icon: nf(cae), icon24: nf(uae), init: (e14, t10, n10, r10 = pNt) => __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, pNt), r10), n10), { Name: e14 || "" }), defaultModel: pNt, glyph: ({ item: { Name: e14, Type: t10 }, path: n10 }) => {
  const { getReport: r10 } = ep.useContext(bqe);
  const { t: o10 } = vp("captions");
  const a10 = r10().$index.NamedItems.find((t11) => t11.overflowName === e14);
  const i10 = a10 == null ? void 0 : a10.name;
  const s10 = o10("overflowPlaceholder", "{{overflowedItemName}} Overflow Placeholder", { overflowedItemName: i10 });
  return tp.createElement("div", { "data-path": n10, "data-type": t10, className: "ar-item ar-overflowPlaceHolder-glyph", style: { padding: "2pt" } }, tp.createElement("span", null, s10));
}, getReducer: q5, getProperties: () => mNt, getContextActions: i0e, features: { isFplItem: true } };
const fNt = ["Omit", "Value"];
const gNt = [Zq("", "parameter.parametername", "reportparameter_name", "ParameterName"), Zq("", "parameter.value", "string_expr", "Value"), Zq("", "parameter.omit", "boolean_expr", "Omit")];
const yNt = { type: _de.Type, init: Vde, defaultModel: _de, getProperties: () => gNt, features: { getExpressionProperties: function() {
  return fNt;
} } };
const vNt = ["DefaultValue.Values"];
const bNt = ["Value", "Label"];
const SNt = (e14) => `reportParameter.${e14}`;
const CNt = "availableValues", xNt = "defaultValue";
const wNt = [Zq("", SNt("name"), "reportparameter_name", "Name"), Zq("", SNt("prompt"), "string_expr", "Prompt", void 0, { disableDataFields: true }), Zq("", SNt("dataType"), "reportparameter_data", ""), Zq(CNt, "", "reportparameter_valid_value", "ValidValues"), Zq(xNt, "", "reportparameter_default_value", "DefaultValue")];
const TNt = { type: w0.Type, init: T0, defaultModel: w0, getProperties: ({ DataType: e14 }) => "String" !== e14 ? wNt.filter((e15) => "AllowBlank" !== e15.valuePath) : wNt, features: { getExpressionProperties: function(e14) {
  const t10 = [];
  return e14.ValidValues.ParameterValues.forEach((e15, n10) => {
    bNt.forEach((e16) => {
      t10.push(`ValidValues.ParameterValues.${n10}.${e16}`);
    });
  }), t10.concat(vNt);
} } };
const ENt = ["Value"];
const FNt = (e14) => {
  const { PaddingLeft: t10 = "0", PaddingRight: n10 = "0", PaddingTop: r10 = "0", PaddingBottom: o10 = "0" } = e14;
  return { top: r10, left: t10, right: n10, bottom: o10 };
};
const MNt = FZ.resultOf(wq.decode({ Type: "richtext", Name: "RichText1", Width: "2in", Height: "1in", Value: "", MarkupType: "HTML" }));
const kNt = (e14) => `richtext.${e14}`;
const PNt = [EY.Name, Zq(tY, kNt("markup"), "enum", "MarkupType", void 0, { enumKey: "rich_text_markup" }), Zq(tY, kNt("value"), "string_expr", "Value"), vY.BackgroundAndBorders, vY.BackgroundColor, vY.BackgroundImage, vY.Borders, vY.FontSimple, vY.Color, vY.Font, EY.Location, EY.Size, Zq(cY, "reportItem.style", "styles", "ReportStyle", void 0, { target: "RichText" }), vY.Padding, EY.LayerName, EY.KeepTogether, Zq(cY, kNt("canGrow"), "boolean", "CanGrow", "advanced"), EY.ZIndex, EY.Visibility, EY.DataElementName, EY.DataElementOutput, EY.ToolTip, EY.Label, EY.Bookmark];
const NNt = (e14) => {
  const t10 = nz.of(e14).getTemplate("richtext");
  const { Style: { BackgroundColor: n10, Color: r10, FontFamily: o10, FontSize: a10, FontStyle: i10, FontWeight: s10 } } = t10;
  return { BackgroundColor: n10, Color: r10, FontFamily: o10, FontSize: a10, FontStyle: i10, FontWeight: s10 };
};
const DNt = (e14, t10) => {
  const n10 = {};
  return Object.keys(t10).forEach((r10) => {
    Oj(e14, t10, r10) && (n10[r10] = { $set: t10[r10] });
  }), Object.keys(n10).length > 0 ? n10 : null;
};
const LNt = (e14, t10) => {
  const n10 = t10 && t10.$targetType === wj.RichText;
  const r10 = NNt(e14);
  return n10 ? __spreadValues(__spreadValues({}, r10), t10) : r10;
};
function HNt(e14, t10, n10, r10 = false) {
  const o10 = NNt(e14);
  const a10 = r10 ? Aj(n10, o10) : n10;
  const i10 = DNt(t10, a10) || {};
  return [i10].some((e15) => Object.keys(e15).length > 0) ? AV(t10, { Style: i10 }) : t10;
}
const INt = { type: "richtext", init: (e14, t10, n10, r10 = MNt) => __spreadProps(__spreadValues(__spreadValues({}, r10), n10), { Name: e14 }), labelKey: "reportItems:richtext", nameTemplateKey: "nameTemplates:richtext", icon: nf(fae), icon24: nf(gae), defaultModel: MNt, glyph: ({ item: e14, path: t10, theme: n10 }) => {
  const { Type: r10, Style: o10 } = e14;
  const { FontFamily: a10, FontSize: i10, FontStyle: s10, FontWeight: l10, Color: c10 } = o10;
  const u10 = _me({ family: a10, size: i10, style: s10, weight: l10 }, n10);
  const d10 = __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, FNt(o10)), { color: Sme(c10, n10) }), u10), { lineHeight: Ame(void 0, u10.fontSize) });
  const p10 = kp("ar-item", "ar-rich-text");
  const m10 = kp("ar-rich-text-inner");
  const h10 = X1(YAe(e14.Value));
  const f10 = h10.split("\n").reduce((e15, t11, n11, r11) => n11 === r11.length - 1 ? [...e15, t11] : [...e15, t11, tp.createElement("br", { key: n11 })], []);
  return tp.createElement("div", { className: p10, title: h10, "data-path": t10, "data-type": r10 }, tp.createElement("div", { className: m10, style: d10 }, tp.createElement("div", { className: "text-wrapper" }, f10)));
}, getReducer: function(e14) {
  const t10 = nz.of(e14).of("rdlx").getDefaultReducer();
  return (n10, r10) => {
    const { type: o10, payload: a10 } = r10;
    switch (o10) {
      case v2.type:
        if (!rj(n10)) break;
        return AV(n10, { ReportStyle: { $set: { StyleId: a10.id || "", StyleName: a10.name || "" } } });
      case b2.type: {
        if (!rj(n10)) break;
        const t11 = LNt(e14, a10.style);
        return t11 ? HNt(e14, n10, t11) : n10;
      }
      case S2.type: {
        const t11 = LNt(e14, a10.$style);
        return t11 ? HNt(e14, n10, t11, true) : n10;
      }
      default:
        return t10(n10, r10);
    }
  };
}, getProperties: () => PNt, getContextActions: i0e, features: { getExpressionProperties: function() {
  return ENt;
} } };
const _Nt = ["RoundingRadius.Default", "RoundingRadius.TopLeft", "RoundingRadius.TopRight", "RoundingRadius.BottomLeft", "RoundingRadius.BottomRight", "ShapeStyle"];
const VNt = (e14) => ((e15) => "" === e15 || e15 && L$.isValidString(e15) || false)(e14) ? e14 : "0pt";
const RNt = FZ.resultOf(wq.decode({ Type: "shape", Name: "shape1", Width: "2in", Height: "1in" }));
const ANt = [EY.Name, Zq(Xq, "style.backgroundColor", "color_expr", "Style.BackgroundColor"), Zq(Xq, "style.backgroundImage", "background_image", "Style.BackgroundImage"), vY.Border, EY.Location, EY.Size, Zq(cY, "reportItem.style", "styles", "ReportStyle", void 0, { target: "Shape" }), vY.ShapeStyle, EY.LayerName, EY.ZIndex, EY.Visibility, EY.DataElementName, EY.DataElementOutput, EY.ToolTip, EY.Label, EY.Bookmark, EY.AccessibleDescription];
const ONt = vY.Corners;
const BNt = (e14, t10) => {
  if (e14 && e14.$targetType !== wj.Shape) return null;
  const n10 = ((e15) => {
    const t11 = nz.of(e15).getTemplate("shape");
    const { BackgroundColor: n11, Border: r10, TopBorder: o10, BottomBorder: a10, LeftBorder: i10, RightBorder: s10 } = t11.Style;
    return { BackgroundColor: n11, Border: r10, TopBorder: o10, BottomBorder: a10, LeftBorder: i10, RightBorder: s10 };
  })(t10);
  return e14 ? __spreadValues(__spreadValues({}, n10), e14) : n10;
};
const zNt = { type: "shape", labelKey: "reportItems:shape", nameTemplateKey: "nameTemplates:shape", init: (e14, t10, n10, r10 = RNt) => __spreadProps(__spreadValues(__spreadValues({}, r10), n10), { Name: e14 || "" }), icon: nf(yae), icon24: nf(vae), defaultModel: RNt, glyph: (e14) => {
  var _a2, _b2;
  const { makeImageUrl: t10, embeddedImages: n10, getItemLayerInfo: r10 } = ep.useContext(bqe);
  const { item: o10, item: { Style: a10, Type: i10, RoundingRadius: { Default: s10, TopLeft: l10, TopRight: c10, BottomLeft: u10, BottomRight: d10 }, ShapeStyle: p10 }, theme: m10, path: h10, parentBackgroundColor: f10, glyphRef: g10 } = e14;
  const y10 = (_a2 = o10.$place) == null ? void 0 : _a2.Width;
  const v10 = (_b2 = o10.$place) == null ? void 0 : _b2.Height;
  const b10 = { TopLeft: VNt(l10), TopRight: VNt(c10), BottomLeft: VNt(u10), BottomRight: VNt(d10), Default: VNt(s10 || "") };
  const S10 = a10.BackgroundImage;
  const C10 = ep.useMemo(() => t10(S10.Source, S10.Value, n10), [S10.Source, S10.Value, n10]);
  const x10 = S10 ? C10 : "";
  const w10 = { className: kp("ar-item", "ar-shape", $me(S10)), style: __spreadValues({ backgroundColor: f10, backgroundImage: x10 }, Fme(a10, m10)) };
  const T10 = ((e15, t11) => {
    const n11 = { width: L$.parse(e15).divideByNum(2), height: L$.parse(t11).divideByNum(2) };
    return n11.height.greaterThan(n11.width) ? n11.width : n11.height;
  })(y10, v10);
  switch (p10) {
    case "Ellipse": {
      const e15 = " ellipse";
      w10.className += e15;
      break;
    }
    case "RoundRect": {
      const e15 = ((e16, t11) => {
        const n11 = e16.Default || "0pt";
        const r11 = (e17) => {
          const r12 = e17 || n11;
          return L$.parse(r12).greaterThan(t11) ? t11.css : r12;
        };
        return { borderTopLeftRadius: r11(e16.TopLeft), borderTopRightRadius: r11(e16.TopRight), borderBottomLeftRadius: r11(e16.BottomLeft), borderBottomRightRadius: r11(e16.BottomRight) };
      })(b10, T10);
      w10.style = __spreadValues(__spreadValues({}, w10.style), e15);
      break;
    }
  }
  const { isLocked: E10 } = r10(o10);
  const { className: F10, style: M10 } = w10;
  return tp.createElement("div", { ref: E10 ? void 0 : g10, className: F10, "data-path": h10, "data-type": i10, style: M10 });
}, getReducer: function(e14) {
  const t10 = nz.of(e14).of("rdlx").getDefaultReducer();
  return function(n10, r10) {
    const { type: o10, payload: a10 } = r10;
    switch (o10) {
      case v2.type:
        if (!rj(n10)) break;
        return AV(n10, { ReportStyle: { $set: { StyleId: a10.id || "", StyleName: a10.name || "" } } });
      case b2.type: {
        if (!rj(n10)) break;
        const t11 = BNt(a10.style, e14);
        return t11 ? function(e15, t12) {
          const n11 = __spreadValues(__spreadValues({}, e15.Style), t12);
          return AV(e15, { Style: { $set: n11 } });
        }(n10, t11) : n10;
      }
      default:
        return t10(n10, r10);
    }
  };
}, getProperties: (e14) => "RoundRect" !== e14.ShapeStyle ? ANt : [...ANt, ONt], getContextActions: i0e, features: { getExpressionProperties: function() {
  return _Nt;
}, borderStyles: ["None", "Dotted", "Dashed", "Solid", "Double", "DashDot", "DashDotDot"] } };
const $Nt = ["SeriesValue", "GradientStyle", "FillColor", "GradientEndColor", "LineColor", "LineWidth", "MarkerColor", "MaximumColumnWidth", "RangeGradientStyle", "RangeGradientEndColor", "RangeFillColor", "RangeLowerBound", "RangeUpperBound"];
const WNt = FZ.resultOf(wq.decode({ Type: "sparkline", Name: "sparkline1", Width: "2in", Height: "0.25in" }));
const jNt = (e14) => `sparkline.${e14}`;
const ZNt = "column", GNt = "fillStyle", UNt = "line", qNt = "range";
const YNt = [EY.Name, Zq(tY, jNt("sparklineType"), "enum", "SparklineType", void 0, { enumKey: "sparkline_type" }), Zq(tY, jNt("seriesValue"), "number_expr", "SeriesValue", void 0, Gq.floatEmpty), EY.Location, EY.Size, Zq(cY, "reportItem.style", "styles", "ReportStyle", void 0, { target: "Sparkline" }), EY.LayerName, EY.ZIndex, MY.Name, MY.GroupExpressionsExt, MY.Parent, MY.DocumentMapLabel, Zq(UNt, jNt("lineColor"), "color_expr", "LineColor", "advanced"), Zq(UNt, jNt("lineWidth"), "length_expr", "LineWidth", "advanced"), Zq(UNt, jNt("markerColor"), "color_expr", "MarkerColor", "advanced"), Zq(UNt, jNt("markerVisibility"), "boolean", "MarkerVisibility", "advanced"), Zq(ZNt, jNt("maximumColumnWidth"), "length_expr", "MaximumColumnWidth", "advanced", { allowEmptyString: true }), Zq(GNt, jNt("fillColor"), "color_expr", "FillColor", "advanced"), Zq(GNt, jNt("gradientStyle"), "enum", "GradientStyle", "advanced", { enumKey: "gradient_type" }), Zq(GNt, jNt("gradientEndColor"), "color_expr", "GradientEndColor", "advanced"), Zq(qNt, jNt("rangeLowerBound"), "number_expr", "RangeLowerBound", "advanced", Gq.floatEmpty), Zq(qNt, jNt("rangeUpperBound"), "number_expr", "RangeUpperBound", "advanced", Gq.floatEmpty), Zq(qNt, jNt("rangeFillColor"), "color_expr", "RangeFillColor", "advanced"), Zq(qNt, jNt("rangeGradientStyle"), "enum", "RangeGradientStyle", "advanced", { enumKey: "gradient_type" }), Zq(qNt, jNt("rangeGradientEndColor"), "color_expr", "RangeGradientEndColor", "advanced"), Zq(qNt, jNt("rangeVisibility"), "boolean", "RangeVisibility", "advanced"), EY.Visibility, EY.DataElementName, EY.DataElementOutput, FY.DataSetName, FY.DataSetParameters, FY.SortExpressions, FY.Filters, EY.ToolTip, EY.Label, EY.Bookmark, EY.AccessibleDescription];
const KNt = "SPARKLINE/INS_VALUE";
const XNt = "SPARKLINE/INS_GROUPING_EXPRESSION";
const JNt = _V(KNt, ({ expression: e14, dataSetName: t10 }) => ({ expression: e14, dataSetName: t10 }));
const QNt = _V(XNt, ({ expression: e14, dataSetName: t10 }) => ({ expression: e14, dataSetName: t10 }));
const eDt = (e14, { payload: t10 }) => AV(e14, { SeriesValue: { $set: t10.expression } });
const tDt = (e14, { payload: t10 }) => t10.dataSetName && !e14.DataSetName ? AV(e14, { DataSetName: { $set: t10.dataSetName } }) : e14;
const nDt = (e14, { payload: { expression: t10 } }) => {
  const n10 = t10 && t10.length > 0 && t10.startsWith("=") ? t10 : '=""';
  return AV(e14, { Group: { GroupExpressions: { $push: [n10] }, Name: { $apply: (t11) => t11 || MG(e14.Name, TG("detailsGroup")) } } });
};
const rDt = (e14, { payload: t10 }) => AV(e14, { ReportStyle: { $set: { StyleId: t10.id || "", StyleName: t10.name || "" } } });
const oDt = "range", aDt = "columns", iDt = "whiskers", sDt = "area";
const lDt = (e14, t10) => `${e14}_${t10}_gradient`;
const cDt = (e14, t10) => `url(#${lDt(e14, t10)})`;
const uDt = (e14, t10, n10) => {
  const r10 = Sme(e14, n10);
  return jme(r10) ? t10 : r10;
};
class dDt extends tp.Component {
  constructor() {
    super(...arguments), this.whiskerValues = [-1, 1, 1, -1, -1, -1, 1, -1, 0, 0], this.columnValues = [9, 67, 97, 12.5, 42.5, 40, 91.5, 22.5, 75, 50], this.renderWhisker = (e14, t10, n10) => {
      const r10 = n10.multiply(0.125).multiply(2 * t10 + 1).add(n10.multiply(t10));
      const [o10, a10] = 0 === e14 ? [45, 10] : [e14 > 0 ? 5 : 50, 45];
      return tp.createElement("rect", { x: r10.css, width: n10.css, y: `${o10}%`, height: `${a10}%` });
    }, this.getColumnWidth = (e14, t10) => {
      const n10 = L$.parse(e14).subtract(L$.parse("4pt")).multiply(0.08);
      const r10 = t10 && L$.parse(t10);
      return r10 && n10.greaterThan(r10) ? r10 : n10;
    }, this.renderColumn = (e14, t10, n10) => tp.createElement("rect", { x: n10.multiply(0.125).multiply(2 * t10 + 1).add(n10.multiply(t10)).css, width: n10.css, y: 100 - e14 + "%", height: `${e14}%` }), this.renderLine = () => {
      const { item: { Type: e14, MarkerVisibility: t10, LineColor: n10, LineWidth: r10, RangeVisibility: o10, MarkerColor: a10 }, path: i10, theme: s10 } = this.props;
      const l10 = jme(r10) ? WNt.LineWidth : r10;
      const c10 = uDt(n10, WNt.LineColor, s10);
      const u10 = L$.parse(l10).divideByNum(2).css;
      const d10 = uDt(a10, WNt.MarkerColor, s10);
      const p10 = t10 ? tp.createElement("g", { fill: d10, stroke: d10, strokeWidth: l10 }, tp.createElement("circle", { cx: "95%", cy: "50%", r: l10 })) : null;
      const m10 = o10 ? this.renderRangeGradient(-100, 100) : null;
      const h10 = kp("ar-item", "ar-sparkline-glyph");
      return tp.createElement("div", { className: h10, "data-type": e14, "data-path": i10 }, tp.createElement("svg", { width: "100%", height: "100%", pointerEvents: "none" }, m10, tp.createElement("g", { stroke: c10 }, tp.createElement("g", { strokeWidth: l10 }, tp.createElement("line", { x1: "5%", y1: "91%", x2: "15%", y2: "33%" }), tp.createElement("line", { x1: "15%", y1: "33%", x2: "25%", y2: "3%" }), tp.createElement("line", { x1: "25%", y1: "3%", x2: "35%", y2: "87.5%" }), tp.createElement("line", { x1: "35%", y1: "87.5%", x2: "45%", y2: "57.5%" }), tp.createElement("line", { x1: "45%", y1: "57.5%", x2: "55%", y2: "60%" }), tp.createElement("line", { x1: "55%", y1: "60%", x2: "65%", y2: "8.5%" }), tp.createElement("line", { x1: "65%", y1: "8.5%", x2: "75%", y2: "77.5%" }), tp.createElement("line", { x1: "75%", y1: "77.5%", x2: "85%", y2: "25%" }), tp.createElement("line", { x1: "85%", y1: "25%", x2: "95%", y2: "50%" })), tp.createElement("g", { strokeWidth: "0", fill: c10 }, tp.createElement("circle", { cx: "5%", cy: "91%", r: u10 }), tp.createElement("circle", { cx: "15%", cy: "33%", r: u10 }), tp.createElement("circle", { cx: "25%", cy: "3%", r: u10 }), tp.createElement("circle", { cx: "35%", cy: "87.5%", r: u10 }), tp.createElement("circle", { cx: "45%", cy: "57.5%", r: u10 }), tp.createElement("circle", { cx: "55%", cy: "60%", r: u10 }), tp.createElement("circle", { cx: "65%", cy: "8.5%", r: u10 }), tp.createElement("circle", { cx: "75%", cy: "77.5%", r: u10 }), tp.createElement("circle", { cx: "85%", cy: "25%", r: u10 }), tp.createElement("circle", { cx: "95%", cy: "50%", r: u10 }))), p10));
    }, this.renderColumns = () => {
      var _a2;
      const { item: e14, item: { Type: t10, Name: n10, GradientStyle: r10, FillColor: o10, GradientEndColor: a10, RangeVisibility: i10, MaximumColumnWidth: s10 }, path: l10, theme: c10 } = this.props;
      const u10 = (_a2 = e14.$place) == null ? void 0 : _a2.Width;
      const d10 = uDt(o10, WNt.FillColor, c10);
      const p10 = uDt(a10, WNt.GradientEndColor, c10);
      const m10 = aDt;
      const h10 = this.getGradient(r10, d10, p10, m10);
      const f10 = h10 ? cDt(n10, m10) : d10;
      const g10 = jme(s10) ? WNt.MaximumColumnWidth : s10;
      const y10 = this.getColumnWidth(u10, g10);
      const v10 = i10 ? this.renderRangeGradient(0, 100) : null;
      return tp.createElement("div", { className: "ar-item ar-sparkline-glyph", "data-type": t10, "data-path": l10 }, tp.createElement("svg", { width: "100%", height: "100%", pointerEvents: "none" }, h10, tp.createElement("g", { fill: f10, strokeWidth: "0" }, v10, this.columnValues.map((e15, t11) => this.renderColumn(e15, t11, y10)))));
    }, this.renderWhiskers = () => {
      var _a2;
      const { item: e14, item: { Type: t10, Name: n10, GradientStyle: r10, FillColor: o10, GradientEndColor: a10, RangeVisibility: i10, MaximumColumnWidth: s10 }, path: l10, theme: c10 } = this.props;
      const u10 = (_a2 = e14.$place) == null ? void 0 : _a2.Width;
      const d10 = uDt(o10, WNt.FillColor, c10);
      const p10 = uDt(a10, WNt.GradientEndColor, c10);
      const m10 = iDt;
      const h10 = this.getGradient(r10, d10, p10, m10);
      const f10 = h10 ? cDt(n10, m10) : d10;
      const g10 = jme(s10) ? WNt.MaximumColumnWidth : s10;
      const y10 = this.getColumnWidth(u10, g10);
      const v10 = i10 ? this.renderRangeGradient(-100, 100) : null;
      return tp.createElement("div", { className: "ar-item ar-sparkline-glyph", "data-type": t10, "data-path": l10 }, tp.createElement("svg", { width: "100%", height: "100%", pointerEvents: "none" }, h10, tp.createElement("g", { fill: f10, strokeWidth: "0" }, v10, this.whiskerValues.map((e15, t11) => this.renderWhisker(e15, t11, y10)))));
    }, this.renderArea = () => {
      const { item: { Type: e14, Name: t10, GradientStyle: n10, FillColor: r10, GradientEndColor: o10, RangeVisibility: a10 }, path: i10, theme: s10 } = this.props;
      const l10 = uDt(r10, WNt.FillColor, s10);
      const c10 = uDt(o10, WNt.GradientEndColor, s10);
      const u10 = sDt;
      const d10 = this.getGradient(n10, l10, c10, u10);
      const p10 = d10 ? cDt(t10, u10) : l10;
      const m10 = a10 ? this.renderRangeGradient(0, 100) : null;
      return tp.createElement("div", { className: "ar-item ar-sparkline-glyph", "data-type": e14, "data-path": i10 }, tp.createElement("svg", { width: "100%", height: "100%", pointerEvents: "none", viewBox: "0 0 100 100", preserveAspectRatio: "none" }, d10, m10, tp.createElement("path", { fill: p10, vectorEffect: "non-scaling-stroke", d: "M 0 100 L 5 91 L 15 33 L 25 3 L 35 87.5 L 45 57.5 L 55 60 L 65 8.5 L 75 77.5 L 85 25 L 95 50 L 100 100 L 0 100" })));
    }, this.renderStackedBar = () => {
      const { item: { Type: e14, FillColor: t10 }, path: n10, theme: r10 } = this.props;
      const o10 = uDt(t10, WNt.FillColor, r10);
      return tp.createElement("div", { className: "ar-item ar-sparkline-glyph", "data-type": e14, "data-path": n10 }, tp.createElement("svg", { width: "100%", height: "100%", pointerEvents: "none" }, tp.createElement("g", { fill: o10, strokeWidth: "0" }, tp.createElement("rect", { x: "0%", y: "0%", width: "35%", height: "100%", fillOpacity: "1" }), tp.createElement("rect", { x: "35%", y: "0%", width: "20%", height: "100%", fillOpacity: ".8" }), tp.createElement("rect", { x: "55%", y: "0%", width: "15%", height: "100%", fillOpacity: ".64" }), tp.createElement("rect", { x: "70%", y: "0%", width: "5%", height: "100%", fillOpacity: ".512" }), tp.createElement("rect", { x: "75%", y: "0%", width: "10%", height: "100%", fillOpacity: ".4096" }), tp.createElement("rect", { x: "85%", y: "0%", width: "10%", height: "100%", fillOpacity: ".32768" }), tp.createElement("rect", { x: "95%", y: "0%", width: "5%", height: "100%", fillOpacity: ".262144" }))));
    };
  }
  renderRangeGradient(e14, t10) {
    const { item: { Name: n10, RangeGradientStyle: r10, RangeFillColor: o10, RangeGradientEndColor: a10, RangeLowerBound: i10, RangeUpperBound: s10 }, theme: l10 } = this.props;
    const c10 = jme(i10) ? null : i10;
    const u10 = jme(s10) ? null : s10;
    if (!u10 && 0 !== u10 || !c10 && 0 !== c10 || u10 < c10) return null;
    const d10 = t10 - e14;
    const p10 = 100 - (u10 - e14) / d10 * 100;
    const m10 = 100 * Math.abs((u10 - c10) / d10);
    const h10 = uDt(o10, WNt.RangeFillColor, l10);
    const f10 = uDt(a10, WNt.RangeGradientEndColor, l10);
    const g10 = oDt;
    const y10 = this.getGradient(r10, h10, f10, g10);
    const v10 = y10 ? cDt(n10, g10) : h10;
    return tp.createElement("g", null, y10, tp.createElement("rect", { fill: v10, x: "0%", y: `${p10}%`, width: "100%", height: `${m10}%` }));
  }
  getGradient(e14, t10, n10, r10) {
    const { item: { Name: o10 } } = this.props;
    const a10 = (e15, a11, i11, s11) => ({ id: lDt(o10, r10), key: `${t10}${n10}`, x1: e15, y1: a11, x2: i11, y2: s11 });
    const i10 = (e15) => () => {
      const { id: r11, key: o11, x1: a11, y1: i11, x2: s11, y2: l11 } = e15;
      return tp.createElement("linearGradient", { id: r11, key: o11, x1: a11, y1: i11, x2: s11, y2: l11 }, tp.createElement("stop", { offset: "0%", stopColor: t10 }), tp.createElement("stop", { offset: "100%", stopColor: n10 }));
    };
    const s10 = (e15) => () => {
      const { id: r11, key: o11, x1: a11, y1: i11, x2: s11, y2: l11 } = e15;
      return tp.createElement("linearGradient", { id: r11, key: o11, x1: a11, y1: i11, x2: s11, y2: l11 }, tp.createElement("stop", { offset: "0%", stopColor: t10 }), tp.createElement("stop", { offset: "50%", stopColor: n10 }), tp.createElement("stop", { offset: "100%", stopColor: t10 }));
    };
    const l10 = { LeftRight: i10(a10(0, 0, 1, 0)), TopBottom: i10(a10(0, 0, 0, 1)), DiagonalLeft: i10(a10(0, 0, 1, 1)), DiagonalRight: i10(a10(0, 1, 1, 0)), HorizontalCenter: s10(a10(0, 0, 0, 1)), VerticalCenter: s10(a10(0, 0, 1, 0)), Center: (c10 = a10(), () => {
      const { id: e15, key: r11, x1: o11, y1: a11, x2: i11, y2: s11 } = c10;
      return tp.createElement("radialGradient", { id: e15, key: r11, x1: o11, y1: a11, x2: i11, y2: s11 }, tp.createElement("stop", { offset: "0%", stopColor: t10 }), tp.createElement("stop", { offset: "100%", stopColor: n10 }));
    }), None: () => null };
    var c10;
    return l10[e14]();
  }
  render() {
    const { item: { SparklineType: e14 } } = this.props;
    const t10 = { Line: this.renderLine, Columns: this.renderColumns, Whiskers: this.renderWhiskers, Area: this.renderArea, StackedBar: this.renderStackedBar };
    return t10[e14]() || t10.Line();
  }
}
const pDt = Are(["value", "field"], { hover(e14, t10, n10) {
  t10.isOver({ shallow: true }) && t10.canDrop() && n10.context.setDecorations("", []);
}, drop: (e14, t10) => {
  const { dispatch: n10 } = e14;
  const r10 = t10.getItemType();
  let o10 = "";
  let a10 = "";
  let i10 = [];
  if ("value" === r10) {
    const { expr: e15 } = t10.getItem();
    o10 = e15;
  } else {
    if ("field" !== r10) return;
    {
      const { field: { value: n11, aggregate: r11, variationFormat: s10 }, dataSetName: l10, dropActions: c10 } = t10.getItem();
      let u10;
      "value" === e14.panel && (u10 = s10 ? "Count" : r11), o10 = s10 ? `=${U1(n11, s10, null, u10)}` : `=${G1(n11, null, u10)}`, i10 = c10, a10 = l10;
    }
  }
  if (e14.panel) {
    const t11 = [];
    "value" === e14.panel && t11.push(JNt({ expression: o10, dataSetName: a10 })), "groupingExpressions" === e14.panel && t11.push(QNt({ expression: o10, dataSetName: a10 })), i10 && i10.length > 0 && t11.push(...i10), t11.length > 0 && n10(rz(t11));
  }
}, canDrop: (e14, t10) => {
  if ("groupingExpressions" === e14.panel) {
    const { preventGroupUpdate: e15 } = t10.getItem();
    return !e15;
  }
  return true;
} }, (e14, t10) => ({ connectDropTarget: e14.dropTarget(), isOver: t10.isOver(), canDrop: t10.canDrop() }));
class mDt extends tp.Component {
  render() {
    const { connectDropTarget: e14, value: t10, panel: n10, canDrop: r10, isOver: o10, t: a10 } = this.props;
    const i10 = "value" === n10 ? a10("adorners:sparkline.seriesValue", "Series Value") : a10("adorners:sparkline.groupingExpressions", "Grouping Expressions");
    const s10 = (e15) => ({ className: "ar-sparkline-adorner-val", title: e15 || "" });
    const l10 = kp("ar-sparkline-adorner-element", "ar-adorner-primary", `ar-adorner-${n10}`, "ar-drop-target", { can: r10 }, { over: o10 });
    const c10 = t10 && Array.isArray(t10) ? t10.map((e15, t11) => tp.createElement("div", __spreadValues({ key: `sparkline-adorner-val-${t11}` }, s10(e15)), e15)) : !!t10 && tp.createElement("div", __spreadValues({}, s10(t10)), t10);
    return e14(tp.createElement("div", { className: l10 }, c10, tp.createElement("span", null, i10)));
  }
}
mDt.contextType = bqe;
const hDt = xp()(pDt(mDt));
const fDt = TA()((e14) => {
  const { item: t10, item: { SeriesValue: n10, Group: { GroupExpressions: r10 } }, dispatch: o10 } = e14;
  const a10 = sj(t10);
  const i10 = X1(YAe(n10.toString()));
  const s10 = (r10 || []).map((e15) => X1(YAe(e15)));
  return tp.createElement("div", { className: "ar-sparkline-adorner" }, a10 && tp.createElement(hDt, { value: i10, panel: "value", dispatch: o10 }), tp.createElement(dDt, __spreadValues({}, e14)), a10 && tp.createElement(hDt, { value: s10, panel: "groupingExpressions", dispatch: o10 }));
});
const gDt = { type: "sparkline", labelKey: "reportItems:sparkline", nameTemplateKey: "nameTemplates:sparkline", init: (e14, t10, n10, r10 = WNt) => __spreadProps(__spreadValues(__spreadValues({}, r10), n10), { Name: e14 || "" }), icon: nf(bae), icon24: nf(Sae), defaultModel: WNt, glyph: fDt, getReducer: function(e14) {
  const t10 = nz.of(e14).of("rdlx").getDefaultReducer();
  return Uye(0, { [KNt]: jV(eDt, tDt), [XNt]: jV(nDt, tDt), [v2.type]: GV(rj, rDt), [b2.type]: GV(rj, (t11, { payload: { style: n10 } }) => {
    if (n10) return AV(t11, { $merge: n10 });
    const { LineColor: r10, MarkerColor: o10, FillColor: a10, GradientEndColor: i10, RangeFillColor: s10, RangeGradientEndColor: l10 } = (() => {
      const t12 = nz.of(e14).of("rdlx").getTemplate("sparkline");
      const { LineColor: n11, MarkerColor: r11, FillColor: o11, GradientEndColor: a11, RangeFillColor: i11, RangeGradientEndColor: s11 } = t12;
      return { LineColor: n11, MarkerColor: r11, FillColor: o11, GradientEndColor: a11, RangeFillColor: i11, RangeGradientEndColor: s11 };
    })();
    return AV(t11, { $merge: { LineColor: r10, MarkerColor: o10, FillColor: a10, GradientEndColor: i10, RangeFillColor: s10, RangeGradientEndColor: l10 } });
  }) }, t10);
}, getProperties: () => YNt, getContextActions: i0e, features: { isDataRegion: true, getExpressionProperties: function() {
  return $Nt;
} } };
const yDt = ["Value", "ToggleImage.InitialState", "UserSort.SortExpression"];
const vDt = (e14) => (t10, n10) => {
  const r10 = [];
  let o10 = 0;
  let a10 = e14.exec(t10);
  for (; a10; ) r10.push(t10.slice(o10, a10.index)), r10.push(tp.createElement("span", { key: `${n10}-${a10.index}` }, a10[0])), o10 = e14.lastIndex, a10 = e14.exec(t10);
  return r10.push(t10.slice(o10)), r10;
};
const bDt = (e14, t10, n10, r10) => {
  if ("tb-rl" === t10 && ("Digits" === n10 || "DigitsAndLatinLetters" === n10)) {
    const t11 = "Digits" === n10 ? /[-+([]*[\d.,]*[\d]+[\d.,]*[%)\]}]*/g : /[-+([]*[\w.,]*[\d]+[\w.,]*[%)\]}]*/g;
    const o10 = fc(r10, e14);
    const a10 = "i11n" === r10 ? function(e15, t12) {
      switch (e15.type) {
        case "const":
          return "string" == typeof e15.value ? t12(uu(e15.value), 0) : [`{${iu(e15)}}`];
        case "field":
          return [`{${iu(e15)}}`];
        case "expression":
          return e15.pieces.flatMap((e16, n11) => {
            switch (e16.type) {
              case "ex":
                return [`{${iu(e16.expression)}}`];
              case "literal":
                return t12(uu(e16.text), n11);
              default:
                return [];
            }
          }, []);
        case "invalid":
          return [uu(e15.text)];
      }
      throw new Error("Invalid expression type");
    }(o10, vDt(t11)) : function(e15, t12) {
      switch (e15.type) {
        case "const":
          return "string" != typeof e15.value || e15.value.startsWith("=") ? [`=${du(e15)}`] : t12(e15.value, 0);
        case "field":
          return [`=${du(e15)}`];
        case "expression":
          return e15.pieces.flatMap((n11, r11) => {
            const o11 = r11 !== e15.pieces.length - 1 ? " & " : "";
            switch (n11.type) {
              case "ex":
                return [du(n11.expression), o11];
              case "literal": {
                const e16 = t12(ru(n11.text), r11);
                return e16.push(o11), e16;
              }
              default:
                return [];
            }
          }, ["="]);
        case "invalid":
          return [ru(e15.text)];
      }
      throw new Error("Invalid expression type");
    }(o10, vDt(t11));
    return a10.flatMap((e15, t12) => "string" != typeof e15 ? [e15] : e15.split("\n").flatMap((e16, n11, r11) => n11 === r11.length - 1 ? e16 : [e16, tp.createElement("br", { key: `${t12}-${n11}` })], []), []);
  }
  return e14.split("\n").flatMap((e15, t11, n11) => t11 === n11.length - 1 ? e15 : [e15, tp.createElement("br", { key: t11 })], []);
};
const SDt = (e14) => `textbox.${e14}`;
const CDt = [EY.Name, Zq(tY, SDt("value"), "string_expr", "Value"), EY.Action, vY.BackgroundAndBorders, vY.BackgroundColor, vY.BackgroundImage, vY.Borders, vY.FontSimple, vY.Color, vY.Font, vY.TextDecoration, vY.TextAlign, vY.TextJustify, vY.VerticalAlign, vY.WrapMode, vY.LineSpacing, vY.CharacterSpacing, Zq(gY, "style.format", "format", "Style.Format"), vY.Angle, vY.ShrinkToFit, Zq(gY, "style.minCondenseRate", "percent_expr", "Style.MinCondenseRate", "advanced", { min: 10, max: 100, scale: 1, tooltip: { text: "propertyDescriptors:labels.style.minCondenseRate_help.text", icon: nf(Ih) } }), EY.Location, EY.Size, Zq(cY, "reportItem.style", "styles", "ReportStyle", void 0, { target: "TextBox" }), Zq(cY, "tablixBodyCell.autoMergeMode", "auto_merge_mode", ""), vY.Padding, EY.LayerName, EY.KeepTogether, Zq(cY, SDt("canGrow"), "boolean", "CanGrow", "advanced"), Zq(cY, SDt("canShrink"), "boolean", "CanShrink", "advanced"), EY.ZIndex, EY.Visibility, Zq(yY, SDt("initialToggleState"), "boolean_expr", "ToggleImage.InitialState", "advanced", { booleanType: "toggle_state" }), EY.DataElementName, EY.DataElementOutput_AON, TY, Zq("userSort", "", "user_sort", "UserSort", "advanced"), vY.Calendar, vY.Direction, vY.Language, vY.NumeralLanguage, vY.NumeralVariant, vY.UnicodeBiDi, vY.UprightInVerticalText, vY.WritingMode, EY.ToolTip, EY.Label, EY.Bookmark, vY.HeadingLevel];
const xDt = (e14) => {
  const t10 = nz.of(e14).getTemplate("textbox");
  const { Style: { BackgroundColor: n10, Color: r10, FontFamily: o10, FontSize: a10, FontStyle: i10, FontWeight: s10 } } = t10;
  return { BackgroundColor: n10, Color: r10, FontFamily: o10, FontSize: a10, FontStyle: i10, FontWeight: s10 };
};
const wDt = (e14, t10) => {
  const n10 = {};
  return Object.keys(t10).forEach((r10) => {
    Oj(e14, t10, r10) && (n10[r10] = { $set: t10[r10] });
  }), Object.keys(n10).length > 0 ? n10 : null;
};
const TDt = (e14, t10) => {
  const n10 = t10 && t10.$targetType === wj.TextBox;
  const r10 = xDt(e14);
  return n10 ? __spreadValues(__spreadValues({}, r10), t10) : r10;
};
function EDt(e14, t10, n10, r10 = false) {
  const o10 = xDt(e14);
  const a10 = r10 ? Aj(n10, o10) : n10;
  const i10 = wDt(t10, a10) || {};
  return [i10].some((e15) => Object.keys(e15).length > 0) ? AV(t10, { Style: i10 }) : t10;
}
const FDt = { type: "textbox", labelKey: "reportItems:textbox", nameTemplateKey: "nameTemplates:textbox", icon: nf(Mae), icon24: nf(kae), init: (e14, t10, n10, r10 = e5e) => {
  const { units: o10 } = KO.of(t10).userPreferences;
  return __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, r10), { $place: __spreadProps(__spreadValues({}, r10.$place), { Top: `0${o10}`, Left: `0${o10}` }) }), n10), { Name: e14 });
}, defaultModel: e5e, glyph: (e14) => {
  const { item: t10, item: { Style: n10, Type: r10, Value: o10 }, path: a10, theme: i10, parentBackgroundColor: s10, onlyContent: l10 } = e14;
  const [{ canDrop: c10, isOver: u10 }, d10] = ((e15, t11, n11) => {
    const r11 = PA();
    const { getAreaByPath: o11, setDecorations: a11 } = ep.useContext(bqe);
    return are({ accept: ["value", "field"], drop: (a12) => {
      if ("value" === a12.type) {
        const { expr: o12 } = a12;
        const i11 = [c5(t11, e15), o2({ descriptor: { valuePath: n11 }, value: o12 })];
        r11(rz(i11));
      } else if ("field" === a12.type) {
        const { field: { variationFormat: i11, value: s11, name: l11, aggregate: c11, dataType: u11 }, dataSetName: d11, format: p11, dropActions: m11, preventGroupUpdate: h11 } = a12;
        const f11 = o11(t11);
        const g11 = wee(f11) ? c11 : null;
        const y11 = i11 ? `=${U1(s11, i11)}` : `=${G1(s11, null, g11)}`;
        const v11 = c11 || u11 || i11 ? { aggregate: c11 || "", type: u11 || "", variationFormat: i11 || "" } : null;
        const b11 = [c5(t11, e15), i2({ valuePath: n11 }, y11, d11, l11, !!h11, v11)];
        "string" == typeof p11 && b11.push(o2({ descriptor: { valuePath: "Style.Format" }, value: p11 })), m11 && b11.push(...m11), r11(rz(b11));
      }
    }, collect: (e16) => ({ canDrop: e16.canDrop(), isOver: e16.isOver({ shallow: true }), item: e16.getItem() }), hover: (e16, t12) => {
      t12.isOver({ shallow: true }) && t12.canDrop() && a11("", []);
    } });
  })(r10, a10, "Value");
  const { FontFamily: p10, FontSize: m10, FontStyle: h10, FontWeight: f10, PaddingBottom: g10, PaddingLeft: y10, PaddingRight: v10, PaddingTop: b10, TextDecoration: S10, Color: C10, WrapMode: x10, CharacterSpacing: w10, LineSpacing: T10, VerticalAlign: E10, WritingMode: F10, UprightInVerticalText: M10, TextAlign: k10, TextJustify: P10 } = n10;
  const N10 = ep.useMemo(() => _me({ family: p10, size: m10, style: h10, weight: f10 }, i10), [p10, m10, h10, f10, i10]);
  const D10 = ep.useMemo(() => /* @__PURE__ */ ((e15 = "0", t11 = "0", n11 = "0", r11 = "0") => ({ top: n11, left: e15, right: t11, bottom: r11 }))(y10, v10, b10, g10), [y10, v10, b10, g10]);
  const L10 = ep.useMemo(() => ((e15, t11) => {
    const n11 = {};
    if ("General" !== e15 && (n11.textAlign = e15), "Justify" === e15) switch (t11) {
      case "Distribute":
        n11.textJustify = "distribute";
        break;
      case "DistributeAllLines":
        n11.textAlignLast = "justify", n11.textJustify = "distribute";
        break;
      default:
        n11.textJustify = "auto";
    }
    return n11;
  })(k10, P10), [k10, P10]);
  const H10 = ep.useMemo(() => Sme(C10, i10), [C10, i10]);
  const I10 = ep.useMemo(() => Ame(T10, N10.fontSize), [T10, N10.fontSize]);
  const _10 = __spreadProps(__spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadValues({}, D10), L10), Rme(S10)), { color: H10 }), N10), { letterSpacing: w10, lineHeight: I10 });
  const V10 = kp("ar-item", "ar-textbox", l10 ? "" : Wme(u10, c10));
  const R10 = kp("ar-textbox-inner", ((e15) => {
    switch (e15) {
      case "Middle":
        return "middle";
      case "Bottom":
        return "bottom";
    }
    return "top";
  })(E10), ((e15) => {
    switch (e15) {
      case "NoWrap":
        return "no-wrap";
      case "WordWrap":
        return "word-wrap";
      case "CharWrap":
        return "char-wrap";
    }
    return "";
  })(x10), "tb-rl" === F10 ? "tb-rl" : "");
  const A10 = KAe(o10);
  const { rdlx: { expressionSyntax: O10 } } = Uae();
  const B10 = ep.useMemo(() => bDt(A10, F10, M10, O10), [A10, F10, M10, O10]);
  return tp.createElement("div", { className: V10, title: A10, "data-path": a10, "data-type": r10, ref: l10 ? void 0 : d10 }, tp.createElement("div", { className: R10, style: _10 }, tp.createElement("div", { className: "text-wrapper" }, B10)), !l10 && ij(t10) && tp.createElement(rlt, { item: t10, path: a10, value: A10, valuePath: "Value", parentBackgroundColor: s10 }));
}, getReducer: function(e14) {
  const t10 = nz.of(e14).of("rdlx").getDefaultReducer();
  return function(n10, { type: r10, payload: o10 }) {
    switch (r10) {
      case v2.type:
        if (!rj(n10)) break;
        return AV(n10, { ReportStyle: { StyleId: { $set: o10.id || "" }, StyleName: { $set: o10.name || "" } } });
      case b2.type:
        if (!rj(n10)) break;
        const a10 = TDt(e14, o10.style);
        return a10 ? EDt(e14, n10, a10) : n10;
      case S2.type: {
        const t11 = TDt(e14, o10.$style);
        return t11 ? EDt(e14, n10, t11, true) : n10;
      }
      default:
        return t10(n10, { type: r10, payload: o10 });
    }
  };
}, getProperties: () => CDt, getContextActions: i0e, features: { getExpressionProperties: function() {
  return yDt;
} } };
const MDt = { action: ["None", "ApplyParameters", "Drillthrough", "BookmarkLink", "Hyperlink"], action_apply_value_cmd: ["Set", "Reset", "Toggle"], auto_merge_mode: ["Never", "Always", "Restricted"], auto_width: ["None", "Proportional"], axis_location: ["Left", "Right"], axis_mode: ["Cartesian", "Radial", "Polygonal"], barcode_caption_location: ["None", "Above", "Below"], barcode_ecc000_140_symbol_size: ["Auto", "Square9", "Square11", "Square13", "Square15", "Square17", "Square19", "Square21", "Square23", "Square25", "Square27", "Square29", "Square31", "Square33", "Square35", "Square37", "Square39", "Square41", "Square43", "Square45", "Square47", "Square49"], barcode_ecc200_encoding_mode: ["Auto", "ASCII", "C40", "Text", "X12", "EDIFACT", "Base256"], barcode_ecc200_symbol_size: ["SquareAuto", "RectangularAuto", "Square10", "Square12", "Square14", "Square16", "Square18", "Square20", "Square22", "Square24", "Square26", "Square32", "Square36", "Square40", "Square44", "Square48", "Square52", "Square64", "Square72", "Square80", "Square88", "Square96", "Square104", "Square120", "Square132", "Square144", "Rectangular8x18", "Rectangular8x32", "Rectangular12x26", "Rectangular12x36", "Rectangular16x36", "Rectangular16x48"], barcode_ecc_mode: ["ECC000", "ECC050", "ECC080", "ECC100", "ECC140", "ECC200"], barcode_encoding: ["37", "437", "500", "708", "720", "737", "775", "850", "852", "855", "857", "858", "860", "861", "862", "863", "864", "865", "866", "869", "870", "874", "875", "932", "936", "949", "950", "1026", "1047", "1140", "1141", "1142", "1143", "1144", "1145", "1146", "1147", "1148", "1149", "1200", "1201", "1250", "1251", "1252", "1253", "1254", "1255", "1256", "1257", "1258", "1361", "10000", "10001", "10002", "10003", "10004", "10005", "10006", "10007", "10008", "10010", "10017", "10021", "10029", "10079", "10081", "10082", "12000", "12001", "20000", "20001", "20002", "20003", "20004", "20005", "20105", "20106", "20107", "20108", "20127", "20261", "20269", "20273", "20277", "20278", "20280", "20284", "20285", "20290", "20297", "20420", "20423", "20424", "20833", "20838", "20866", "20871", "20880", "20905", "20924", "20932", "20936", "20949", "21025", "21866", "28591", "28592", "28593", "28594", "28595", "28596", "28597", "28598", "28599", "28603", "28605", "29001", "38598", "50220", "50221", "50222", "50225", "50227", "51932", "51936", "51949", "52936", "54936", "57002", "57003", "57004", "57005", "57006", "57007", "57008", "57009", "57010", "57011", "65000", "65001"], barcode_gs1_composite_type: ["None", "CCA"], barcode_maxicode_mode: ["Mode2", "Mode3", "Mode4", "Mode5", "Mode6"], barcode_micro_pdf417_compaction_mode: ["Auto", "TextCompactionMode", "NumericCompactionMode", "ByteCompactionMode"], barcode_micro_pdf417_version: ["ColumnPriorAuto", "RowPriorAuto", "Version1X11", "Version1X14", "Version1X17", "Version1X20", "Version1X24", "Version1X28", "Version2X8", "Version2X11", "Version2X14", "Version2X17", "Version2X20", "Version2X23", "Version2X26", "Version3X6", "Version3X8", "Version3X10", "Version3X12", "Version3X15", "Version3X20", "Version3X26", "Version3X32", "Version3X38", "Version3X44", "Version4X4", "Version4X6", "Version4X8", "Version4X10", "Version4X12", "Version4X15", "Version4X20", "Version4X26", "Version4X32", "Version4X38", "Version4X44"], barcode_micro_qrcode_error_level: ["L", "M", "Q"], barcode_micro_qrcode_mask: ["Auto", "Mask00", "Mask01", "Mask10", "Mask11"], barcode_micro_qrcode_version: ["Auto", "M1", "M2", "M3", "M4"], barcode_pdf417_error_correction_level: ["Level0", "Level1", "Level2", "Level3", "Level4", "Level5", "Level6", "Level7", "Level8"], barcode_pdf417_type: ["Normal", "Simple"], barcode_qrcode_error_level: ["M", "L", "H", "Q"], barcode_qrcode_mask: ["Auto", "Mask000", "Mask001", "Mask010", "Mask011", "Mask100", "Mask101", "Mask110", "Mask111"], barcode_qrcode_model: ["Model1", "Model2"], barcode_rotation: ["None", "Rotate90Degrees", "Rotate180Degrees", "Rotate270Degrees"], barcode_symbology: ["None", "Ansi39", "Ansi39x", "Aztec", "BC412", "Codabar", "Code_11", "Code_128_A", "Code_128_B", "Code_128_C", "Code_128auto", "Code_2_of_5", "Code_93", "Code25intlv", "Code39", "Code39x", "Code49", "Code93x", "DataMatrix", "EAN_13", "EAN_8", "EAN128FNC1", "GS1DataMatrix", "GS1QRCode", "HIBCCode128", "HIBCCode39", "IATA_2_of_5", "IntelligentMail", "IntelligentMailPackage", "ISBN", "ISMN", "ISSN", "ITF14", "JapanesePostal", "Matrix_2_of_5", "MaxiCode", "MicroPDF417", "MicroQRCode", "MSI", "Pdf417", "Pharmacode", "Plessey", "PostNet", "PZN", "QRCode", "RM4SCC", "RSS14", "RSS14Stacked", "RSS14StackedOmnidirectional", "RSS14Truncated", "RSSExpanded", "RSSExpandedStacked", "RSSLimited", "SSCC_18", "Telepen", "UCCEAN128", "UPC_A", "UPC_E0", "UPC_E1"], border_style: ["None", "Dotted", "Dashed", "Solid", "Double", "Groove", "Ridge", "Inset", "WindowInset", "Outset", "DashDot", "DashDotDot"], bullet_tick_marks: ["None", "Inside", "Outside"], calendar: ["Gregorian", "GregorianArabic", "GregorianMiddleEastFrench", "GregorianTransliteratedEnglish", "GregorianTransliteratedFrench", "GregorianUSEnglish", "Hebrew", "Hijri", "Japanese", "Korean", "Taiwan", "ThaiBuddhist"], check_alignment: ["TopLeft", "TopCenter", "TopRight", "MiddleLeft", "MiddleCenter", "MiddleRight", "BottomLeft", "BottomCenter", "BottomRight"], check_style: ["Check", "Circle", "Cross", "Diamond", "Square", "Star"], collate_by: ["Simple", "ValueIndex", "Value"], collation: ["Default", "Albanian", "Arabic", "Chinese_PRC", "Chinese_PRC_Stroke", "Chinese_Taiwan_Bopomofo", "Chinese_Taiwan_Stroke", "Croatian", "Cyrillic_General", "Czech", "Danish_Norwegian", "Estonian", "Finnish_Swedish", "French", "Georgian_Modern_Sort", "German_PhoneBook", "Greek", "Hebrew", "Hindi", "Hungarian", "Hungarian_Technical", "Icelandic", "Japanese", "Japanese_Unicode", "Korean_Wansung", "Korean_Wansung_Unicode", "Latin1_General", "Latvian", "Lithuanian", "Lithuanian_Classic", "FYRO_Macedonian", "Polish", "Romanian", "Slovak", "Slovenian", "Spanish_Mexican_Trad", "Spanish_Modern", "Thai", "Turkish", "Ukrainian", "Vietnamese"], data_element_output: ["Auto", "Output", "NoOutput", "ContentsOnly"], data_element_output_aon: ["Auto", "Output", "NoOutput"], data_element_output_on: ["Output", "NoOutput"], data_element_style: ["Auto", "AttributeNormal", "ElementNormal"], data_label_position: ["Auto", "TopLeft", "Top", "TopRight", "Left", "Center", "Right", "BottomLeft", "Bottom", "BottomRight"], data_visualizer_color_type: ["colorScale"], data_visualizer_gradient_type: ["Horizontal", "Vertical", "DiagonalUp", "DiagonalDown", "FromCenter", "FromCorner"], data_visualizer_hatch_style: ["BackwardDiagonal", "Cross", "DarkDownwardDiagonal", "DarkHorizontal", "DarkUpwardDiagonal", "DarkVertical", "DashedDownwardDiagonal", "DashedHorizontal", "DashedUpwardDiagonal", "DashedVertical", "DiagonalBrick", "DiagonalCross", "Divot", "DottedDiamond", "DottedGrid", "ForwardDiagonal", "Horizontal", "HorizontalBrick", "LargeCheckerBoard", "LargeConfetti", "LargeGrid", "LightDownwardDiagonal", "LightHorizontal", "LightUpwardDiagonal", "LightVertical", "NarrowHorizontal", "NarrowVertical", "OutlinedDiamond", "Percent05", "Percent10", "Percent20", "Percent25", "Percent30", "Percent40", "Percent50", "Percent60", "Percent70", "Percent75", "Percent80", "Percent90", "Plaid", "Shingle", "SmallCheckerBoard", "SmallConfetti", "SmallGrid", "SolidDiamond", "Sphere", "Trellis", "Vertical", "Wave", "Weave", "WideDownwardDiagonal", "WideUpwardDiagonal", "ZigZag"], data_visualizer_icon_set_type: ["Checkbox", "3TrafficLights", "Arrows", "Blank", "Flags", "GrayArrows", "Quarters", "Ratings", "RedToBlack", "Signs", "Symbols1", "Symbols2", "TrafficLights"], data_visualizer_icon_set_value: ["true", "false"], data_visualizer_image_type: ["iconSet", "rangeBar", "dataBar", "gradient", "hatch"], dataset_option: ["true", "false", "Auto"], dataset_query_command_type: ["Text", "StoredProcedure"], direction: ["LTR", "RTL"], display_type: ["Galley", "Page"], documentmap_numbering_style: ["None", "Decimal", "DecimalLeadingZero", "LowerRoman", "UpperRoman", "LowerLatin", "UpperLatin", "CircledNumber", "KatakanaBrackets", "KatakanaIrohaBrackets", "Katakana", "KatakanaIroha", "KatakanaLower", "KatakanaIrohaLower", "LowerGreek", "UpperGreek", "LowerArmenian", "UpperArmenian", "Georgian"], documentmap_source: ["Labels", "Headings", "All", "None"], dvchart_aggregate_type: ["None", "Average", "Count", "CountDistinct", "CountOfAll", "List", "Max", "Min", "PopulationStandardDeviation", "PopulationVariance", "Range", "StandardDeviation", "Sum", "Variance"], dvchart_axis_position: ["None", "Near", "Far"], dvchart_axis_type: ["X", "Y"], dvchart_axis_date_mode: ["Default", "Millisecond", "Second", "Minute", "Hour", "Day", "Week", "Month", "Year"], dvchart_clipping_mode: ["None", "Clip", "Fit"], dvchart_encoding_field_type: ["Simple", "Complex"], dvchart_encoding_sort: ["None", "Ascending", "Descending"], dvchart_group_type: ["None", "Cluster", "Stack"], dvchart_group_type_wizard: ["Cluster", "Stacked", "PercentStacked"], dvchart_halign: ["Left", "Center", "Right"], dvchart_legend_position: ["Bottom", "Left", "Right", "Top"], dvchart_line_aspect: ["Default", "Spline", "StepCenter", "StepLeft", "StepRight"], dvchart_line_position: ["Auto", "Center"], dvchart_orientation: ["Horizontal", "Vertical"], dvchart_axis_overlapping_labels: ["Auto", "Show"], dvchart_overlapping_labels: ["Auto", "Show", "Hide"], dvchart_palette: ["Custom", "Aspect", "Blue", "Blue2", "BlueGreen", "BlueWarm", "Cerulan", "Cocoa", "Coral", "Cyborg", "Dark", "Darkly", "Flatly", "Grayscale", "Green", "GreenYellow", "HighContrast", "Light", "Marquee", "Median", "Midnight", "Modern", "Office", "Office2010", "Orange", "OrangeRed", "Organic", "Paper", "Red", "RedOrange", "RedViolet", "Slate", "Slipstream", "Standard", "Superhero", "Violet", "Violet2", "Yellow", "YellowOrange", "Zen"], dvchart_plot_overlay_type: ["ReferenceLine", "ReferenceBand", "LinearTrendline", "ExponentialTrendline", "PowerTrendline", "LogarithmicTrendline", "PolynomialTrendline", "FourierTrendline", "MovingAverageTrendline", "CumulativeMovingAverageTrendline", "ExponentialMovingAverageTrendline", "WeightedMovingAverageTrendline", "MovingAnnualTotalTrendline"], dvchart_plot_overlay_display: ["Front", "Back"], dvchart_plot_overlay_detail_level: ["Group", "Total"], dvchart_plot_overlay_axis: ["X", "Y"], dvchart_plot_overlay_aggregate_type: ["Sum", "Count", "Average", "Max", "Min", "Median", "Percentile"], dvchart_plot_rule_properties: ["BackgroundColor", "LabelTemplate", "LineColor", "LineStyle", "LineWidth", "SymbolBackgroundColor", "SymbolLineColor", "SymbolLineStyle", "SymbolLineWidth", "TooltipTemplate"], dvchart_plot_type: ["Bar", "Line", "Area", "Scatter", "HighLowOpenClose", "Candlestick"], dvchart_scale: ["Linear", "Logarithmic", "Ordinal", "Percentage"], dvchart_show_nulls: ["Connected", "Gaps", "Zeros"], dvchart_symbol_shape: ["Auto", "Dot", "Box", "Diamond", "Triangle", "X", "Dash", "Plus"], dvchart_target: ["Label", "ToolTip"], dvchart_template: ["valueField.name", "valueField.value", "PercentageDetail_p0", "PercentageCategory_p0", "categoryField.name", "categoryField.value", "detailFields.name", "detailFields.value", "colorField.name", "colorField.value", "shapeField.name", "shapeField.value", "sizeField.name", "sizeField.value"], dvchart_text_position: ["Auto", "Center", "Inside", "Outside"], dvchart_tick_mark: ["None", "Cross", "Inside", "Outside"], dvchart_valign: ["Top", "Middle", "Bottom"], end_cap: ["None", "Arrow"], font_size: ["8pt", "9pt", "10pt", "11pt", "12pt", "14pt", "16pt", "18pt", "20pt", "22pt", "24pt", "26pt", "28pt", "36pt", "48pt", "72pt"], font_style: ["Normal", "Italic"], font_weight: ["Lighter", "Thin", "ExtraLight", "Light", "Normal", "Medium", "SemiBold", "Bold", "ExtraBold", "Heavy", "Bolder"], gradient_type: ["None", "LeftRight", "TopBottom", "Center", "DiagonalLeft", "DiagonalRight", "HorizontalCenter", "VerticalCenter"], grid_mode: ["Dots", "Lines"], horizontal_align: ["Left", "Center", "Right"], image_repeat: ["Repeat", "NoRepeat", "RepeatX", "RepeatY"], image_sizing: ["AutoSize", "Fit", "FitProportional", "Clip"], image_source: ["External", "Embedded", "Database"], input_type: ["Text", "CheckBox"], keep_with_group: ["None", "Before", "After"], label_font_style: ["Regular", "Bold", "Italic", "Underline", "Strikeout"], labels_text_orientation: ["Auto", "Angled", "Horizontal", "Rotated90", "Rotated270", "Stacked"], language: ["Default", "af-ZA", "sq-AL", "gsw-FR", "am-ET", "ar-DZ", "ar-BH", "ar-EG", "ar-IQ", "ar-JO", "ar-KW", "ar-LB", "ar-LY", "ar-MA", "ar-OM", "ar-QA", "ar-SA", "ar-SY", "ar-TN", "ar-AE", "ar-YE", "hy-AM", "as-IN", "az-AZ-Cyrl", "az-AZ-Latn", "ba-RU", "eu-ES", "be-BY", "bn-BD", "bn-IN", "bs-Cyrl-BA", "bs-Latn-BA", "br-FR", "bg-BG", "ca-ES", "zh-HK", "zh-MO", "zh-CN", "zh-SG", "zh-TW", "co-FR", "hr-HR", "hr-BA", "cs-CZ", "da-DK", "prs-AF", "div-MV", "nl-BE", "nl-NL", "en-AU", "en-BZ", "en-CA", "en-CB", "en-IN", "en-IE", "en-JM", "en-MY", "en-NZ", "en-PH", "en-SG", "en-ZA", "en-TT", "en-GB", "en-US", "en-ZW", "et-EE", "fo-FO", "fil-PH", "fa-IR", "fi-FI", "fr-BE", "fr-CA", "fr-FR", "fr-LU", "fr-MC", "fr-CH", "fy-NL", "gl-ES", "ka-GE", "de-AT", "de-DE", "de-LI", "de-LU", "de-CH", "el-GR", "kl-GL", "gu-IN", "ha-Latn-NG", "he-IL", "hi-IN", "hu-HU", "is-IS", "ig-NG", "id-ID", "iu-Latn-CA", "iu-Cans-CA", "ga-IE", "xh-ZA", "zu-ZA", "it-IT", "it-CH", "ja-JP", "kn-IN", "kk-KZ", "km-KH", "qut-GT", "rw-RW", "sw-KE", "kok-IN", "ko-KR", "ky-KG", "lo-LA", "lv-LV", "lt-LT", "wee-DE", "lb-LU", "mk-MK", "ms-BN", "ms-MY", "ml-IN", "mt-MT", "mi-NZ", "arn-CL", "mr-IN", "moh-CA", "mn-Mong-MN", "mn-MN", "mn-Mong-CN", "ne-NP", "nb-NO", "nn-NO", "oc-FR", "or-IN", "ps-AF", "pl-PL", "pt-BR", "pt-PT", "pa-IN", "quz-BO", "quz-EC", "quz-PE", "ro-RO", "rm-CH", "ru-RU", "smn-FI", "smj-NO", "smj-SE", "se-FI", "se-NO", "se-SE", "sms-FI", "sma-NO", "sma-SE", "sa-IN", "gd-GB", "sr-SP-Cyrl", "sr-SP-Latn", "nso-ZA", "tn-ZA", "si-LK", "sk-SK", "sl-SI", "es-AR", "es-BO", "es-CL", "es-CO", "es-CR", "es-DO", "es-EC", "es-SV", "es-GT", "es-HN", "es-MX", "es-NI", "es-PA", "es-PY", "es-PE", "es-PR", "es-ES", "es-US", "es-UY", "es-VE", "sv-FI", "sv-SE", "syr-SY", "tg-Cyrl-TJ", "tzm-Latn-DZ", "ta-IN", "tt-RU", "te-IN", "th-TH", "bo-CN", "tr-TR", "tk-TM", "uk-UA", "wen-DE", "ur-PK", "ug-CN", "uz-UZ-Cyrl", "uz-UZ-Latn", "vi-VN", "cy-GB", "wo-SN", "sah-RU", "ii-CN", "yo-NG"], layout_direction: ["LTR", "RTL"], layout_order: ["ZOrder", "NOrder"], legend_layout: ["Column", "Row", "Table"], legend_position: ["TopLeft", "TopCenter", "TopRight", "LeftTop", "LeftCenter", "LeftBottom", "RightTop", "RightCenter", "RightBottom", "BottomRight", "BottomCenter", "BottomLeft"], line_control_style: ["None", "Solid", "Dashed", "Dotted", "DashDot", "DashDotDot", "Double"], marker_type: ["None", "Auto", "Circle", "Cross", "Diamond", "Square", "Triangle"], mime_type: ["image/bmp", "image/jpeg", "image/gif", "image/png", "image/x-emf", "image/x-wmf"], numeral_variant: ["1", "2", "3", "4", "5", "6", "7"], operator: ["Equal", "Like", "NotEqual", "GreaterThan", "GreaterThanOrEqual", "LessThan", "LessThanOrEqual", "TopN", "BottomN", "TopPercent", "BottomPercent", "In", "Between"], order_by_condition: ["None", "Label", "Value"], orientation: ["Horizontal", "Vertical"], page_break: ["None", "Start", "End", "StartAndEnd"], page_break_with_between: ["None", "Start", "End", "StartAndEnd", "Between"], page_orientation: ["Portrait", "Landscape"], plot_type: ["Auto", "Line", "Point"], projection_mode: ["Perspective", "Orthographic"], repeat_blank_rows: ["None", "FillPage", "FillGroup"], reportparameter_datatype: ["Boolean", "Date", "DateTime", "Integer", "Float", "String"], reportparts_property_type: ["boolean", "integer", "float", "string", "length", "color", "fontFamily", "fontSize", "fontStyle", "fontWeight", "textDecoration", "lineWidth", "borderStyle", "lineStyle"], reportparts_sizemode: ["Resizable", "Fixed"], rich_text_markup: ["HTML"], shading: ["None", "Simple", "Real"], shape_styles: ["Rectangle", "RoundRect", "Ellipse"], size_type: ["Default", "FitToPage", "FitToWidth"], sparkline_type: ["Line", "Columns", "Whiskers", "Area", "StackedBar"], new_page: ["Next", "Odd", "Even"], target_shape: ["Line", "Dot", "Square"], text_align: ["General", "Left", "Center", "Right", "Justify"], text_align_glcr: ["General", "Left", "Center", "Right"], text_decoration: ["None", "Underline", "DoubleUnderline", "Overline", "LineThrough"], text_justify: ["Auto", "Distribute", "DistributeAllLines"], text_orientation: ["Auto", "Horizontal", "Rotated90", "Rotated270", "Stacked"], tick_mark: ["None", "Inside", "Outside", "Cross"], title_position: ["Center", "Near", "Far"], unicode_bidi: ["Normal", "Embed", "BidiOverride"], upright_in_vertical_text: ["None", "Digits", "DigitsAndLatinLetters"], vertical_align: ["Top", "Middle", "Bottom"], wrap_mode: ["NoWrap", "CharWrap", "WordWrap"], writing_mode: ["lr-tb", "tb-rl"], grow_direction: ["Column", "ColumnReverse", "Row", "RowReverse"], overflow: ["Auto", "Clip", "Scroll", "Grow"], pve_datetime_range_unit: ["Year", "Quarter", "Month", "Week", "Day", "Hour", "Minute", "Second"], pve_datetime_range_type: ["Current", "Last", "Next", "ToDate", "LastToDate"], pve_datetime_range_type_time: ["Current", "Last", "Next"], pve_datetime_range_type_second: ["Last", "Next"] };
const kDt = (e14) => {
  if (!Array.isArray(e14)) return;
  const t10 = /* @__PURE__ */ new Set();
  e14.forEach((e15) => {
    ((e16) => sve.findIndex((t11) => t11 === e16) >= 0)(e15) && t10.add(e15);
  });
  const n10 = [...t10];
  return n10.length > 0 ? n10 : void 0;
};
const PDt = (e14) => {
  if (!Array.isArray(e14)) return;
  const t10 = /* @__PURE__ */ new Map();
  return e14.forEach((e15, n10) => {
    var r10;
    "string" == typeof (r10 = e15.path) && r10.trim().length > 0 && !t10.has(e15.path) && t10.set(e15.path, e15);
  }), Array.from(t10.values());
};
const NDt = (e14) => {
  var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2, _o3, _p3, _q2, _r2, _s2, _t2, _u2, _v2, _w2, _x2, _y2, _z2, _A2, _B2, _C2, _D2, _E2, _F2, _G2, _H2, _I2, _J2, _K2, _L2, _M2, _N2, _O2, _P2, _Q2, _R2, _S2, _T2, _U2, _V2, _W2, _X2, _Y2, _Z2, __2, _$2, _aa;
  return { expressionSyntax: (_a2 = e14 == null ? void 0 : e14.expressionSyntax) != null ? _a2 : "i11n", expressionEditorNodesFilter: e14 == null ? void 0 : e14.expressionEditorNodesFilter, reportParameters: e14 == null ? void 0 : e14.reportParameters, initTemplates: e14 == null ? void 0 : e14.initTemplates, reportLanguages: e14 == null ? void 0 : e14.reportLanguages, reportItemsFeatures: { barcode: (_c2 = (_b2 = e14 == null ? void 0 : e14.reportItemsFeatures) == null ? void 0 : _b2.barcode) != null ? _c2 : {}, chart: { canUseWizard: (_f2 = (_e2 = (_d2 = e14 == null ? void 0 : e14.reportItemsFeatures) == null ? void 0 : _d2.chart) == null ? void 0 : _e2.canUseWizard) != null ? _f2 : true, plotChartTypes: kDt((_h2 = (_g2 = e14 == null ? void 0 : e14.reportItemsFeatures) == null ? void 0 : _g2.chart) == null ? void 0 : _h2.plotChartTypes), hiddenEncodings: (_k2 = (_j2 = (_i2 = e14 == null ? void 0 : e14.reportItemsFeatures) == null ? void 0 : _i2.chart) == null ? void 0 : _j2.hiddenEncodings) != null ? _k2 : [] }, table: { autoFillHeader: (_n2 = (_m2 = (_l2 = e14 == null ? void 0 : e14.reportItemsFeatures) == null ? void 0 : _l2.table) == null ? void 0 : _m2.autoFillHeader) != null ? _n2 : true, autoFillFooter: (_q2 = (_p3 = (_o3 = e14 == null ? void 0 : e14.reportItemsFeatures) == null ? void 0 : _o3.table) == null ? void 0 : _p3.autoFillFooter) != null ? _q2 : false, canMergeCellsVertically: (_t2 = (_s2 = (_r2 = e14 == null ? void 0 : e14.reportItemsFeatures) == null ? void 0 : _r2.table) == null ? void 0 : _s2.canMergeCellsVertically) != null ? _t2 : true, hideFrozenRowsColumns: (_w2 = (_v2 = (_u2 = e14 == null ? void 0 : e14.reportItemsFeatures) == null ? void 0 : _u2.table) == null ? void 0 : _v2.hideFrozenRowsColumns) != null ? _w2 : false }, tablix: { crossAggregates: (_z2 = (_y2 = (_x2 = e14 == null ? void 0 : e14.reportItemsFeatures) == null ? void 0 : _x2.tablix) == null ? void 0 : _y2.crossAggregates) != null ? _z2 : true, autoFillCorner: (_C2 = (_B2 = (_A2 = e14 == null ? void 0 : e14.reportItemsFeatures) == null ? void 0 : _A2.tablix) == null ? void 0 : _B2.autoFillCorner) != null ? _C2 : true, canUseWizard: (_F2 = (_E2 = (_D2 = e14 == null ? void 0 : e14.reportItemsFeatures) == null ? void 0 : _D2.tablix) == null ? void 0 : _E2.canUseWizard) != null ? _F2 : true, hideFrozenRowsColumns: (_I2 = (_H2 = (_G2 = e14 == null ? void 0 : e14.reportItemsFeatures) == null ? void 0 : _G2.tablix) == null ? void 0 : _H2.hideFrozenRowsColumns) != null ? _I2 : false }, prohibitApplyParametersAction: (_K2 = (_J2 = e14 == null ? void 0 : e14.reportItemsFeatures) == null ? void 0 : _J2.prohibitApplyParametersAction) != null ? _K2 : false }, reportStyles: (_L2 = e14 == null ? void 0 : e14.reportStyles) != null ? _L2 : [], toolBoxContent: e14 == null ? void 0 : e14.toolBoxContent, msl: { enabled: (_N2 = (_M2 = e14 == null ? void 0 : e14.msl) == null ? void 0 : _M2.enabled) != null ? _N2 : true }, dashboard: { enabled: (_P2 = (_O2 = e14 == null ? void 0 : e14.dashboard) == null ? void 0 : _O2.enabled) != null ? _P2 : true }, fpl: { enabled: (_R2 = (_Q2 = e14 == null ? void 0 : e14.fpl) == null ? void 0 : _Q2.enabled) != null ? _R2 : true }, reportThemes: { prohibitMultipleThemes: (_T2 = (_S2 = e14 == null ? void 0 : e14.reportThemes) == null ? void 0 : _S2.prohibitMultipleThemes) != null ? _T2 : false }, reportParts: { enabled: (_V2 = (_U2 = e14 == null ? void 0 : e14.reportParts) == null ? void 0 : _U2.enabled) != null ? _V2 : false, libraries: (_X2 = PDt((_W2 = e14 == null ? void 0 : e14.reportParts) == null ? void 0 : _W2.libraries)) != null ? _X2 : [] }, masterReports: { enabled: (_Z2 = (_Y2 = e14 == null ? void 0 : e14.masterReports) == null ? void 0 : _Y2.enabled) != null ? _Z2 : true, canConvert: (_$2 = (__2 = e14 == null ? void 0 : e14.masterReports) == null ? void 0 : __2.canConvert) != null ? _$2 : true }, reportCollapseWhitespace: (_aa = e14 == null ? void 0 : e14.reportCollapseWhitespace) != null ? _aa : false };
};
const DDt = ["PageHeader", "Detail", "PageFooter"];
const LDt = (e14) => e14.Name;
const HDt = (e14, t10 = GB) => {
  var _a2;
  const n10 = Mat(t10).decode(e14);
  if ("error" === n10.type) throw new Error(`Error decoding report: "${n10.reason}"`);
  const r10 = n10.value;
  const o10 = Object.values(r10.Sections);
  const a10 = Object.values(((_a2 = o10.find((e15) => "Detail" === e15.Type)) == null ? void 0 : _a2.Controls) || {});
  const i10 = Object.entries(r10.Sections).filter(([e15, { Type: t11 }]) => DDt.includes(t11)).reduce((e15, [t11, n11]) => (e15[t11] = __spreadProps(__spreadValues({}, n11), { Controls: {}, $path: `Sections.${t11}` }), e15), {});
  return [__spreadProps(__spreadValues({}, r10), { Sections: i10, GroupsOrder: [] }), ...o10.map((e15) => __spreadProps(__spreadValues({}, e15), { $path: "", Controls: {} })), ...a10.map((e15) => __spreadProps(__spreadValues({}, e15), { $path: "", Left: 0, Top: 0 }))];
};
const IDt = { imperialTemplates: [{ PrintWidth: 9360, PageSettings: { PaperSize: { Width: 12240, Height: 15840 } }, DocumentName: "Report1", Sections: [{ Name: "Detail", Height: 2880, Controls: [{ Type: "TextBox", Name: "TextBox1", Width: 1440, Height: 360, Style: {}, Border: { BottomColor: "Black", Color: "Black", LeftColor: "Black", RightColor: "Black", TopColor: "Black" } }, { Type: "RichTextBox", Name: "RichTextBox1", Width: 4320, Height: 2160 }, { Type: "Shape", Name: "Shape1", Width: 1440, Height: 720 }, { Type: "Barcode", Name: "Barcode1", Width: 2160, Height: 720, FontFamily: "Arial", FontSize: "8pt" }, { Type: "Label", Name: "Label1", Width: 1440, Height: 360, Style: {}, Border: { BottomColor: "Black", Color: "Black", LeftColor: "Black", RightColor: "Black", TopColor: "Black" } }, { Type: "Line", Name: "Line1", X1: 0, Y1: 0, X2: 1440, Y2: 0 }, { Type: "CheckBox", Name: "CheckBox1", Width: 1440, Height: 360, Style: {}, Border: { BottomColor: "Black", Color: "Black", LeftColor: "Black", RightColor: "Black", TopColor: "Black" } }, { Type: "Picture", Name: "Picture1", Width: 1440, Height: 1440, Style: {}, Border: { BottomColor: "Black", Color: "Black", LeftColor: "Black", RightColor: "Black", TopColor: "Black" } }, { Type: "SubReport", Name: "SubReport1", Width: 4320, Height: 1440, Style: {}, Border: { BottomColor: "Black", Color: "Black", LeftColor: "Black", RightColor: "Black", TopColor: "Black" } }, { Type: "ReportInfo", Name: "ReportInfo1", Width: 1440, Height: 360, Style: {}, Border: { BottomColor: "Black", Color: "Black", LeftColor: "Black", RightColor: "Black", TopColor: "Black" } }, { Type: "CrossSectionBox", Name: "CrossSectionBox1", Bottom: 144, Right: 1440 }, { Type: "CrossSectionLine", Name: "CrossSectionLine1", Bottom: 144 }, { Type: "InputFieldText", Name: "InputFieldText", Width: 1440, Height: 360, FontSize: "10pt" }, { Type: "InputFieldCheckBox", Name: "InputFieldCheckBox1", Width: 1440, Height: 360 }] }, { Name: "PageHeader1", Type: "PageHeader", Height: 360 }, { Name: "PageFooter1", Type: "PageFooter", Height: 360 }, { Name: "ReportHeader1", Type: "ReportHeader", Height: 360 }, { Name: "ReportFooter1", Type: "ReportFooter", Height: 360 }, { Name: "GroupHeader1", Type: "GroupHeader", Height: 360 }, { Name: "GroupFooter1", Type: "GroupFooter", Height: 360 }], StyleSheet: [{ FontFamily: "Arial" }, { ClassName: "Heading1", Parent: "Normal", FontSize: "16pt", FontWeight: "Bold" }, { ClassName: "Heading2", Parent: "Normal", FontFamily: "Times New Roman", FontSize: "14pt", FontStyle: "Italic", FontWeight: "Bold" }, { ClassName: "Heading3", Parent: "Normal", FontSize: "13pt", FontWeight: "Bold" }] }], metricTemplates: [{ PrintWidth: 11906, PageSettings: { PaperSize: { Size: "A4", Width: 11905, Height: 16837 }, BottomMargin: 1417, LeftMargin: 1417, RightMargin: 1417, TopMargin: 1417 }, DocumentName: "Report1", Sections: [{ Name: "Detail", Height: 2834.6, Controls: [{ Type: "TextBox", Name: "TextBox1", Width: 1417.3, Height: 283.5, Style: {}, Border: { BottomColor: "Black", Color: "Black", LeftColor: "Black", RightColor: "Black", TopColor: "Black" } }, { Type: "RichTextBox", Name: "RichTextBox1", Width: 4252, Height: 2267.7 }, { Type: "Shape", Name: "Shape1", Width: 1417.3, Height: 708.7 }, { Type: "Barcode", Name: "Barcode1", Width: 2267.7, Height: 708.7, FontFamily: "Arial", FontSize: "8pt" }, { Type: "Label", Name: "Label1", Width: 1417.3, Height: 283.5, Style: {}, Border: { BottomColor: "Black", Color: "Black", LeftColor: "Black", RightColor: "Black", TopColor: "Black" } }, { Type: "Line", Name: "Line1", X1: 0, Y1: 0, X2: 1417.3, Y2: 0 }, { Type: "CheckBox", Name: "CheckBox1", Width: 1417.3, Height: 283.5, Style: {}, Border: { BottomColor: "Black", Color: "Black", LeftColor: "Black", RightColor: "Black", TopColor: "Black" } }, { Type: "Picture", Name: "Picture1", Width: 1417.3, Height: 1417.3, Style: {}, Border: { BottomColor: "Black", Color: "Black", LeftColor: "Black", RightColor: "Black", TopColor: "Black" } }, { Type: "SubReport", Name: "SubReport1", Width: 4252, Height: 1417.3, Style: {}, Border: { BottomColor: "Black", Color: "Black", LeftColor: "Black", RightColor: "Black", TopColor: "Black" } }, { Type: "ReportInfo", Name: "ReportInfo1", Width: 1417.3, Height: 283.5, Style: {}, Border: { BottomColor: "Black", Color: "Black", LeftColor: "Black", RightColor: "Black", TopColor: "Black" } }, { Type: "CrossSectionBox", Name: "CrossSectionBox1", Bottom: 141.7, Right: 1417.3 }, { Type: "CrossSectionLine", Name: "CrossSectionLine1", Bottom: 141.7 }, { Type: "InputFieldText", Name: "InputFieldText", Width: 1417.3, Height: 283.5, FontSize: "10pt" }, { Type: "InputFieldCheckBox", Name: "InputFieldCheckBox1", Width: 1417.3, Height: 283.5 }] }, { Name: "PageHeader1", Type: "PageHeader", Height: 283.5 }, { Name: "PageFooter1", Type: "PageFooter", Height: 283.5 }, { Name: "ReportHeader1", Type: "ReportHeader", Height: 283.5 }, { Name: "ReportFooter1", Type: "ReportFooter", Height: 283.5 }, { Name: "GroupHeader1", Type: "GroupHeader", Height: 283.5 }, { Name: "GroupFooter1", Type: "GroupFooter", Height: 283.5 }], StyleSheet: [{ FontFamily: "Arial" }, { ClassName: "Heading1", Parent: "Normal", FontSize: "16pt", FontWeight: "Bold" }, { ClassName: "Heading2", Parent: "Normal", FontFamily: "Times New Roman", FontSize: "14pt", FontStyle: "Italic", FontWeight: "Bold" }, { ClassName: "Heading3", Parent: "Normal", FontSize: "13pt", FontWeight: "Bold" }] }] };
const _Dt = [{ type: "button", key: "contextActions-RPX:labels.layout.alignToGrid", icon: nf(M1e), action: Oat() }, { type: "button", key: "contextActions-RPX:labels.layout.sizeToGrid", icon: nf(k1e), action: Bat() }];
const VDt = [{ type: "separator", key: "contextActions-RPX:labels.layout.separator.sortControls", location: "toolbar" }, { type: "button", key: "contextActions-RPX:labels.layout.bringToFront", icon: nf(h1e), action: Rtt() }, { type: "button", key: "contextActions-RPX:labels.layout.sendToBack", icon: nf(f1e), action: Vtt() }];
const RDt = [{ type: "separator", key: "contextActions-RPX:labels.layout.separator.corelateControlSizing" }, { type: "button", key: "contextActions-RPX:labels.layout.makeSameWidth", icon: nf(T1e), action: Aat({ correlateWidth: true }) }, { type: "button", key: "contextActions-RPX:labels.layout.makeSameHeight", icon: nf(x1e), action: Aat({ correlateHeight: true }) }, { type: "button", key: "contextActions-RPX:labels.layout.makeSameSize", icon: nf(w1e), action: Aat({ correlateWidth: true, correlateHeight: true }) }];
const ADt = [{ type: "separator", key: "contextActions-RPX:labels.layout.horizontalAlignment" }, { type: "button", key: "contextActions-RPX:labels.layout.alignToLefts", icon: nf(y1e), action: Ltt("left") }, { type: "button", key: "contextActions-RPX:labels.layout.alignToCenters", icon: nf(b1e), action: Ltt("center") }, { type: "button", key: "contextActions-RPX:labels.layout.alignToRights", icon: nf(S1e), action: Ltt("right") }];
const ODt = [{ type: "separator", key: "contextActions-RPX:labels.layout.verticalAlignment" }, { type: "button", key: "contextActions-RPX:labels.layout.alignToTops", icon: nf(C1e), action: Htt("top") }, { type: "button", key: "contextActions-RPX:labels.layout.alignToMiddles", icon: nf(v1e), action: Htt("middle") }, { type: "button", key: "contextActions-RPX:labels.layout.alignToBottoms", icon: nf(g1e), action: Htt("bottom") }];
const BDt = [{ type: "separator", key: "contextActions-RPX:labels.layout.separator.horizontalSpacing" }, { type: "button", key: "contextActions-RPX:labels.layout.horizontal.makeSpacingEqual", icon: nf(E1e), action: _tt("equal") }, { type: "button", key: "contextActions-RPX:labels.layout.horizontal.increaseSpacing", icon: nf(N1e), action: _tt("increase") }, { type: "button", key: "contextActions-RPX:labels.layout.horizontal.decreaseSpacing", icon: nf(P1e), action: _tt("decrease") }, { type: "button", key: "contextActions-RPX:labels.layout.horizontal.removeSpacing", icon: nf(D1e), action: _tt("remove") }];
const zDt = [{ type: "separator", key: "contextActions-RPX:labels.layout.separator.verticalSpacing" }, { type: "button", key: "contextActions-RPX:labels.layout.vertical.makeSpacingEqual", icon: nf(F1e), action: Itt("equal") }, { type: "button", key: "contextActions-RPX:labels.layout.vertical.increaseSpacing", icon: nf(H1e), action: Itt("increase") }, { type: "button", key: "contextActions-RPX:labels.layout.vertical.decreaseSpacing", icon: nf(L1e), action: Itt("decrease") }, { type: "button", key: "contextActions-RPX:labels.layout.vertical.removeSpacing", icon: nf(I1e), action: Itt("remove") }];
const $Dt = (e14, t10) => {
  const { lockLayout: n10 } = KO.of(t10);
  const r10 = (() => {
    const t11 = iit(e14);
    return t11.some((e15) => e15.$primary) ? t11 : [];
  })();
  const o10 = r10.length > 0;
  const a10 = r10.length > 1;
  return { type: "group", key: "contextActions-RPX:labels.layout.title", actions: [...((e15) => G1e(e15, n10 || !o10))([...U1e(_Dt, "toolbar"), ...VDt]), ...((e15) => G1e(e15, n10 || !a10))(U1e([...RDt, ...ADt, ...ODt, ...BDt, ...zDt], "toolbar"))] };
};
const WDt = (e14, t10, n10) => {
  if (!rj(e14)) return [];
  const r10 = $1e(e14, t10, "disableCopy");
  const { lockLayout: o10 } = KO.of(t10);
  return [{ type: "button", key: "contextActions-RPX:labels.cut", icon: nf(JQe), action: pB(), disabled: !r10 || o10 }, { type: "button", key: "contextActions-RPX:labels.copy", icon: nf(QQe), action: dB(), disabled: !r10 || o10 }, { type: "button", key: "contextActions-RPX:labels.paste", icon: nf(e1e), action: mB(), disabled: r10 || o10 }, { type: "button", key: "contextActions-RPX:labels.delete", icon: nf(t1e), action: Ttt(), disabled: !r10 || o10 }, $Dt(n10, t10)];
};
const jDt = { Transparent: "hidden", Solid: "solid", Dash: "dashed", Dot: "dotted", DashDot: "dashed", DashDotDot: "dashed", Double: "double" };
const ZDt = (e14) => jDt[e14] || "";
const GDt = (e14) => e14 / 2 + "pt";
const UDt = { None: { borderStyle: void 0, borderWidth: void 0 }, Solid: { borderStyle: "solid", borderWidth: "1pt" }, Dash: { borderStyle: "dashed", borderWidth: "1pt" }, Dot: { borderStyle: "dotted", borderWidth: "1pt" }, DashDot: { borderStyle: "dashed", borderWidth: "1pt" }, ThickSolid: { borderStyle: "solid", borderWidth: "1pt" }, Double: { borderStyle: "double", borderWidth: "1pt" }, ThickDashDotDot: { borderStyle: "dotted", borderWidth: "2pt" }, ThickDash: { borderStyle: "dashed", borderWidth: "2pt" }, ThickDashDot: { borderStyle: "dashed", borderWidth: "2pt" }, ThickDot: { borderStyle: "dotted", borderWidth: "2pt" }, ExtraThickSolid: { borderStyle: "solid", borderWidth: "3pt" }, ThickDouble: { borderStyle: "double", borderWidth: "2pt" } };
const qDt = (e14) => e14 ? UDt[e14] : { borderStyle: void 0, borderWidth: void 0 };
const YDt = (e14) => {
  const { BottomColor: t10, BottomStyle: n10, TopColor: r10, TopStyle: o10, LeftColor: a10, LeftStyle: i10, RightColor: s10, RightStyle: l10 } = e14;
  const { borderStyle: c10, borderWidth: u10 } = qDt(i10);
  const { borderStyle: d10, borderWidth: p10 } = qDt(l10);
  const { borderStyle: m10, borderWidth: h10 } = qDt(o10);
  const { borderStyle: f10, borderWidth: g10 } = qDt(n10);
  return { borderLeftColor: c10 ? a10 : void 0, borderRightColor: d10 ? s10 : void 0, borderTopColor: m10 ? r10 : void 0, borderBottomColor: f10 ? t10 : void 0, borderLeftStyle: c10, borderRightStyle: d10, borderTopStyle: m10, borderBottomStyle: f10, borderLeftWidth: u10, borderRightWidth: p10, borderTopWidth: h10, borderBottomWidth: g10 };
};
const [KDt, XDt, JDt] = Dp("rpx-barcode-item");
const [QDt, , eLt] = Dp("rpx-barcode-item-wrapper");
const [tLt] = JDt("model-dumper");
const [nLt] = JDt("error");
const [rLt] = JDt("stub");
const [oLt] = eLt("content");
const aLt = ["Rotate90Degrees", "Rotate270Degrees"];
const iLt = (e14, t10, n10, r10) => {
  if (!r10 || L$.zero.equal(r10)) return L$.zero;
  const o10 = e14.subtract(t10).subtract(n10);
  return o10.greaterThan(r10) ? o10.subtract(r10).divideByNum(2) : L$.zero;
};
const sLt = ({ message: e14 }) => {
  const { t: t10 } = vp("glyphs-RPX");
  return tp.createElement("div", { className: nLt }, `${t10("barcode.textError", "Error")}: ${e14}`);
};
sLt.displayName = "RpxBarcodeError";
const lLt = ({ viewModel: e14, assets: { style: t10 }, onSuccess: n10, onError: r10 }) => {
  const o10 = ep.useRef();
  const a10 = ep.useRef(null);
  return ep.useEffect(() => {
    e14 && ((e15) => {
      try {
        o10.current ? o10.current.setOption(e15) : o10.current = new l(a10.current, e15), n10();
      } catch (e16) {
        r10(e16.message);
      }
    })(e14);
  }, [r10, n10, e14]), tp.createElement("div", { className: QDt }, tp.createElement("div", { className: oLt, style: t10, ref: a10 }));
};
lLt.displayName = "RpxBarcodeJsWrapper";
const cLt = Z.Dsl.resultOf(kat.Control.decode({ Name: "Barcode1", Type: "Barcode", Style: "Ansi39" }));
const uLt = { Code2of5: "Code_2_of_5", Code2of5Interleaved: "Code25intlv", Matrix2of5: "Matrix_2_of_5", Code39Extended: "Code39x", Code128A: "Code_128_A", Code128B: "Code_128_B", Code128C: "Code_128_C", Code128Auto: "Code_128auto", Ansi39: "Code39", Code93: "Code_93", Code93Extended: "Code93x", Ansi39x: "Code39x", MsiPlessey: "MSI", Postnet: "PostNet", Ean8: "EAN_8", Ean13: "EAN_13", UpcA: "UPC_A", UpcE: "UPC_E0", RoyalMail4Scc: "RM4SCC", UccEan128: "UCCEAN128", PDF417: "Pdf417", Ean128Fnc1: "EAN128FNC1", Code11: "Code_11", SSCC18: "SSCC_18", IATA2of5: "IATA_2_of_5" };
const dLt = (e14) => {
  switch (uLt[e14] || e14) {
    case "RSS14":
    case "RSSLimited":
    case "RSS14Truncated":
    case "RSS14Stacked":
    case "RSS14StackedOmnidirectional":
      return "(01)20012345678909";
    case "ITF14":
      return "1234567890123";
    case "UPC_A":
      return "12345678901";
    case "EAN_13":
      return "123456789012";
    case "Codabar":
      return "A1234567B";
    case "Code25intlv":
    case "Code_128auto":
    case "Code_128_A":
    case "Code_128_B":
    case "Code_128_C":
      return "12345678";
    case "EAN_8":
    case "UCCEAN128":
    case "DataMatrix":
      return "1234567";
    case "UPC_E0":
    case "UPC_E1":
    case "JapanesePostal":
      return "123456";
    case "Aztec":
    case "QRCode":
    case "GS1QRCode":
    case "GS1DataMatrix":
    case "Pdf417":
    case "Code39":
    case "Code39x":
    case "Code_93":
    case "Code93x":
    case "Code49":
      return "SAMPLE";
    default:
      return "";
  }
};
const pLt = ["QRCode", "DataMatrix"];
const mLt = (e14, t10) => {
  const { Symbology: n10, CaptionPosition: r10, Alignment: o10, BarWidth: a10, NWRatio: i10, CheckSumEnabled: s10, Rotation: l10, BackColor: c10, ForeColor: u10, Text: d10, Width: p10, Height: m10, BarHeight: h10, QuietZoneBottom: f10, QuietZoneLeft: g10, QuietZoneRight: y10, QuietZoneTop: v10, SupplementBarHeight: b10, SupplementCaptionPosition: S10, SupplementDataField: C10, SupplementSpacing: x10, SupplementText: w10, AztecOptions: T10, QrCodeOptions: E10, DataMatrixOptions: F10, Code49Options: M10, Pdf417Options: k10, FontFamily: P10, FontLinethrough: N10, FontSize: D10, FontStyle: L10, FontUnderline: H10, FontWeight: I10 } = e14;
  const _10 = { style: {}, position: {}, stubLabel: "" };
  if (!oSt(n10)) return { viewModel: null, assets: __spreadProps(__spreadValues({}, _10), { stubLabel: "Unsupported" }) };
  const V10 = L$.fromTwips(p10, t10);
  const R10 = L$.fromTwips(m10, t10);
  const A10 = { Left: L$.fromTwips(g10, t10).css, Top: L$.fromTwips(v10, t10).css, Right: L$.fromTwips(y10, t10).css, Bottom: L$.fromTwips(f10, t10).css };
  const O10 = L$.fromTwips(h10, t10);
  const B10 = ((e15, t11) => {
    const n11 = {};
    return "Rotate90Degrees" === e15 ? (n11.transform = "rotate(90deg)", t11 || (n11.transformOrigin = "0 0", n11.left = "100%")) : "Rotate180Degrees" === e15 ? n11.transform = "rotate(180deg)" : "Rotate270Degrees" === e15 && (n11.transform = "rotate(270deg)", t11 || (n11.transformOrigin = "0 0", n11.top = "100%")), n11;
  })(l10, pLt.includes(n10));
  const z10 = ((e15, t11, n11, r11, o11) => {
    const a11 = L$.isValidString(e15) ? L$.parse(e15) : null;
    const [i11, s11, l11, c11] = [t11.Left, t11.Top, t11.Right, t11.Bottom].map((e16) => L$.parse(e16));
    let u11;
    let d11;
    let p11;
    let m11;
    switch (o11) {
      case "Rotate90Degrees":
        u11 = i11, d11 = l11, p11 = c11, m11 = s11;
        break;
      case "Rotate180Degrees":
        u11 = c11, d11 = s11, p11 = l11, m11 = i11;
        break;
      case "Rotate270Degrees":
        u11 = l11, d11 = i11, p11 = s11, m11 = c11;
        break;
      default:
        u11 = s11, d11 = c11, p11 = i11, m11 = l11;
    }
    let h11;
    return aLt.includes(o11) ? (h11 = iLt(n11, p11, m11, a11), p11 = p11.add(h11), m11 = m11.add(h11)) : (h11 = iLt(r11, u11, d11, a11), u11 = u11.add(h11), d11 = d11.add(h11)), { top: u11, left: p11, bottom: d11, right: m11 };
  })(O10.css, A10, V10, R10, l10);
  const { availableWidth: $10, availableHeight: W10 } = ((e15, t11, n11, r11) => {
    const o11 = e15.subtract(n11.left).subtract(n11.right);
    const a11 = t11.subtract(n11.top).subtract(n11.bottom);
    return aLt.includes(r11) ? { availableWidth: a11, availableHeight: o11 } : { availableWidth: o11, availableHeight: a11 };
  })(V10, R10, z10, l10);
  const j10 = ((e15) => {
    const { top: t11, left: n11, right: r11, bottom: o11 } = e15;
    return { paddingTop: t11.css, paddingLeft: n11.css, paddingRight: r11.css, paddingBottom: o11.css };
  })(z10);
  const Z10 = { Near: "Left", Far: "Right" };
  const G10 = { BarHeight: b10 || cLt.SupplementBarHeight, CaptionLocation: S10 || cLt.SupplementCaptionPosition, DataField: C10 || cLt.SupplementDataField, Spacing: x10 || cLt.SupplementSpacing, Value: w10 || cLt.SupplementText };
  const U10 = { Symbology: n10, QuietZone: { Bottom: "0in", Left: "0in", Right: "0in", Top: "0in" }, Width: $10.css, Height: W10.css, BarHeight: O10 || cLt.BarHeight, CaptionLocation: r10 || cLt.CaptionPosition, NarrowBarWidth: new L$(a10 || cLt.BarWidth, "pt").css, NWRatio: i10 || cLt.NWRatio, CheckSum: s10 || cLt.CheckSumEnabled, Value: d10 || dLt(n10), Style: { BackgroundColor: c10 || cLt.BackColor, Color: u10 || cLt.ForeColor, TextAlign: (K10 = o10 || cLt.Alignment, Z10[K10] || K10), FontFamily: P10 || cLt.FontFamily, FontSize: D10 || cLt.FontSize, FontStyle: L10 || cLt.FontStyle, FontWeight: I10 || cLt.FontWeight, TextDecoration: (q10 = H10, Y10 = N10, q10 ? Y10 ? "UnderlineLineThrough" : "Underline" : Y10 ? "LineThrough" : "none") }, SupplementOptions: G10, AztecOptions: T10 || cLt.AztecOptions, QrCodeOptions: E10 || cLt.QrCodeOptions, DataMatrixOptions: F10 || cLt.DataMatrixOptions, Code49Options: M10 || cLt.Code49Options, Pdf417Options: k10 || cLt.Pdf417Options };
  var q10, Y10;
  var K10;
  return { viewModel: __spreadValues({}, Jvt(U10)), assets: __spreadProps(__spreadValues({}, _10), { style: B10, position: j10 }) };
};
const hLt = ({ item: e14 }) => {
  const { userPreferences: { units: t10 } } = MO();
  const n10 = rf(ih);
  const r10 = { className: tLt, title: "Click to dump barcode JSON model to console...", onClick: () => {
    const n11 = mLt(e14, t10);
    console.log(JSON.stringify(n11));
  } };
  return tp.createElement("div", __spreadValues({}, r10), tp.createElement(Fm, { icon: n10 }));
};
hLt.displayName = "RpxBarcodeModelDumper";
const fLt = [...pnt, ...mnt, stt(Utt, "alignment", "enum", "Alignment", void 0, { enumKey: "string_alignment" }), stt(Utt, "backColor", "color", "BackColor"), stt(Utt, "barHeight", "rpx_dimensions", "BarHeight"), stt(Utt, "barWidth", "number", "BarWidth", void 0, { numberType: "Float", minValue: 0 }), stt(Utt, "captionGrouping", "boolean", "CaptionGrouping"), stt(Utt, "captionPosition", "enum", "CaptionPosition", void 0, { enumKey: "barcode_caption_position" }), stt(Utt, "fontFamily", "rpx_font_family", "FontFamily"), stt(Utt, "fontSize", "rpx_font_size", "FontSize", void 0, { units: "pt" }), stt(Utt, "fontWeight", "enum", "FontWeight", void 0, { enumKey: "font_weight" }), stt(Utt, "fontStyle", "enum", "FontStyle", void 0, { enumKey: "font_style" }), stt(Utt, "fontUnderline", "boolean", "FontUnderline"), stt(Utt, "fontLinethrough", "boolean", "FontLinethrough"), stt(Utt, "foreColor", "color", "ForeColor"), stt(Utt, "nwratio", "number", "NWRatio", void 0, { numberType: "Float", intervals: [{ min: 0, max: 0 }, { min: 2, max: 3 }] }), stt(Utt, "rotation", "enum", "Rotation", void 0, { enumKey: "barcode_rotation" }), stt(Utt, "barCodeStyle", "enum", "Symbology", void 0, { enumKey: "barcode_style" }), stt(Utt, "quietZoneLeft", "rpx_dimensions", "QuietZoneLeft"), stt(Utt, "quietZoneRight", "rpx_dimensions", "QuietZoneRight"), stt(Utt, "quietZoneTop", "rpx_dimensions", "QuietZoneTop"), stt(Utt, "quietZoneBottom", "rpx_dimensions", "QuietZoneBottom"), stt(Utt, "supplementText", "string", "SupplementText"), stt(Utt, "supplementBarHeight", "number", "SupplementBarHeight", void 0, { numberType: "Float", minValue: 0 }), stt(Utt, "supplementCaptionPosition", "enum", "SupplementCaptionPosition", void 0, { enumKey: "barcode_caption_position" }), stt(Utt, "supplementDataField", "string", "SupplementDataField"), stt(Utt, "supplementSpacing", "number", "SupplementSpacing", void 0, { numberType: "Float" }), stt(qtt, "autoSize", "boolean", "AutoSize"), stt(qtt, "checkSumEnabled", "boolean", "CheckSumEnabled"), stt(Ktt, "text", "string", "Text")];
const gLt = ({ Top: e14, Left: t10, Width: n10, Height: r10 }) => ({ Top: e14, Left: t10, Width: n10, Height: r10 });
const yLt = { type: "Barcode", glyph: ({ documentItem: e14, documentItem: { Border: t10 } }) => {
  const { Type: n10, $path: r10, BackColor: o10 } = e14;
  const { userPreferences: { units: a10 } } = MO();
  const [i10, s10] = ep.useState(null);
  const [l10, c10] = ep.useState(e14);
  const { t: u10 } = vp("glyphs-RPX");
  ep.useEffect(() => {
    l10 !== e14 && (c10(e14), s10(null));
  }, [l10, e14]);
  const d10 = ep.useMemo(() => YDt(t10), [t10]);
  const { viewModel: p10, assets: m10 } = ep.useMemo(() => ((e15, t11, n11) => {
    var _a2, _b2;
    if (!e15.assets.stubLabel) return e15;
    const { Name: r11, Symbology: o11 } = t11;
    const { friendlyNames: a11 } = BO("barcode_style", n11);
    const i11 = n11("glyphs-RPX:barcode.unsupportedSymbology", '[{{symbology}}] "{{itemName}}" preview is limited in design-time.', { itemName: r11, symbology: (_b2 = (_a2 = a11.find((e16) => e16.value === o11)) == null ? void 0 : _a2.name) != null ? _b2 : o11 });
    return AV(e15, { assets: { stubLabel: { $set: i11 } } });
  })(mLt(e14, a10), e14, u10), [e14, u10, a10]);
  const h10 = ep.useCallback(() => i10 && s10(null), [i10]);
  const f10 = s10;
  const g10 = rj(e14) && false;
  const y10 = { viewModel: p10, assets: m10, onSuccess: h10, onError: f10 };
  const v10 = { className: "rpx-barcode-item", style: __spreadValues(__spreadValues({ backgroundColor: o10 }, m10.position), d10), title: p10 ? "" : m10.stubLabel };
  return tp.createElement(tp.Fragment, null, rj(e14) && tp.createElement(Kmt, { documentItem: e14, withMover: true, withGrips: true, dataPath: e14.$path }), tp.createElement("div", __spreadProps(__spreadValues({}, v10), { "data-type": n10, "data-path": r10 }), p10 ? tp.createElement(lLt, __spreadValues({}, y10)) : tp.createElement("div", { className: rLt }, m10.stubLabel), i10 && tp.createElement(sLt, { message: i10 }), g10 && tp.createElement(hLt, { item: e14 })));
}, defaultModel: cLt, init: (e14, t10, n10, r10) => __spreadProps(__spreadValues(__spreadValues({}, r10 || cLt), n10), { Name: e14 }), getProperties: () => fLt, getContextActions: WDt, getReducer: (e14) => WV(0, {}, nz.of(e14).getDefaultReducer()), icon: nf(_oe), icon24: nf(Voe), nameTemplateKey: "nameTemplate-RPX:Barcode", labelKey: "documentItems-RPX:Barcode", features: { setRectangle: (e14, t10) => __spreadProps(__spreadValues({}, e14), { Left: t10.Left, Top: t10.Top, Width: t10.Width, Height: t10.Height }), getBoundingBox: gLt, getRectangle: gLt } };
const vLt = ({ value: e14, valuePath: t10, itemPath: n10, itemStyles: r10 }) => {
  const o10 = PA();
  const a10 = { value: e14, getTextAreaStyle: (e15) => e15 ? __spreadProps(__spreadValues({}, r10), { pointerEvents: "all" }) : {}, commitValue: (n11) => {
    n11 !== e14 && o10(iB(BY("", "", "string", t10), n11));
  }, dataPath: n10, parentClassName: "rpx-item" };
  return tp.createElement($st, __spreadValues({}, a10));
};
const bLt = (e14 = "", t10) => {
  const n10 = e14.split("\n").flatMap((e15, t11) => [e15, tp.createElement("br", { key: `${t11}` })], []);
  return t10 ? n10 : n10[0];
};
const SLt = (e14, t10) => {
  if (t10) {
    if ("left" === e14) return "right";
    if ("right" === e14) return "left";
  }
  return e14;
};
const CLt = (e14, t10) => {
  if (t10) {
    if ("vertical-lr" === e14) return "vertical-rl";
    if ("vertical-rl" === e14) return "vertical-lr";
  }
  return e14;
};
const xLt = (e14, t10) => t10 ? e14 : "normal";
const wLt = (e14, t10) => `calc(${e14}pt + ${t10})`;
const TLt = (e14) => (e14 || "Left").toLowerCase();
const ELt = (e14) => {
  switch (e14) {
    case "Middle":
      return "center";
    case "Bottom":
      return "flex-end";
    default:
      return "flex-start";
  }
};
const FLt = (e14) => {
  switch (e14) {
    case "WordWrap":
      return "break-word";
    case "CharWrap":
      return "break-all";
    default:
      return;
  }
};
const MLt = (e14, t10) => `${e14 ? "line-through" : ""} ${t10 ? "underline" : ""}`;
const kLt = (e14) => {
  const t10 = LA(Dnt);
  const n10 = Fct(Mct(e14.ClassName, t10), e14);
  const { BackColor: r10, ForeColor: o10, FontFamily: a10, FontSize: i10, FontStyle: s10, FontWeight: l10, TextAlign: c10, VerticalAlign: u10, FontLinethrough: d10, FontUnderline: p10, WordWrap: m10, VerticalText: h10 } = n10;
  return { backgroundColor: r10, fontFamily: a10, fontSize: i10, fontStyle: s10, fontWeight: "Bold" === l10 ? "bold" : "normal", color: o10, justifyContent: TLt(c10), textAlign: TLt(c10), textDecoration: MLt(d10, p10), alignItems: ELt(u10), writingMode: h10 ? "vertical-lr" : void 0, whiteSpace: "NoWrap" === m10 ? "nowrap" : void 0, wordBreak: FLt(m10) };
};
const PLt = (e14, t10) => "Transparent" === e14.backgroundColor ? __spreadProps(__spreadValues({}, e14), { backgroundColor: t10 }) : e14;
const [NLt, DLt, LLt] = Dp("rpx-checkbox-item");
const [HLt] = LLt("text");
const [ILt] = LLt("check");
const _Lt = DLt("top");
const VLt = DLt("bottom");
const RLt = DLt("middle");
const ALt = DLt("left");
const OLt = DLt("right");
const BLt = DLt("center");
const zLt = { TopLeft: `${_Lt} ${ALt}`, TopCenter: `${_Lt} ${BLt}`, TopRight: `${_Lt} ${OLt}`, MiddleCenter: `${RLt} ${BLt}`, MiddleRight: `${RLt} ${OLt}`, MiddleLeft: `${RLt} ${ALt}`, BottomLeft: `${VLt} ${ALt}`, BottomCenter: `${VLt} ${BLt}`, BottomRight: `${VLt} ${OLt}` };
const $Lt = (e14, t10) => {
  switch (t10) {
    case "MiddleCenter":
    case "MiddleRight":
    case "MiddleLeft":
      return "center";
    case "BottomLeft":
    case "BottomCenter":
    case "BottomRight":
      return "end";
    default:
      return e14;
  }
};
const WLt = (e14, t10) => {
  switch (t10) {
    case "MiddleCenter":
    case "TopCenter":
    case "BottomCenter":
      return "center";
    case "TopRight":
    case "MiddleRight":
    case "BottomRight":
      return "right";
    default:
      return e14;
  }
};
const jLt = Z.Dsl.resultOf(kat.Control.decode({ Name: "CheckBox1", Type: "CheckBox" }));
const ZLt = [...pnt, ...mnt, snt, unt, stt(qtt, "checkAlignment", "enum", "CheckAlignment", void 0, { enumKey: "content_alignment" }), stt(qtt, "checked", "boolean", "Checked"), stt(Ktt, "text", "string", "Text")];
const GLt = [dnt.ClassName, dnt.BackColor, dnt.ForeColor, dnt.FontFamily, dnt.FontSize, dnt.FontWeight, dnt.FontStyle, dnt.ShrinkToFit, dnt.FontUnderline, dnt.FontLinethrough, dnt.TextAlign, dnt.TextJustify, dnt.VerticalAlign, dnt.VerticalText, dnt.WordWrap];
const ULt = ({ Top: e14, Left: t10, Width: n10, Height: r10 }) => ({ Top: e14, Left: t10, Width: n10, Height: r10 });
const qLt = { type: "CheckBox", defaultModel: jLt, glyph: (e14) => {
  const { documentItem: t10, parentBackgroundColor: n10, documentItem: { Text: r10, PaddingBottom: o10, PaddingLeft: a10, PaddingRight: i10, PaddingTop: s10, Style: l10, Border: c10, CheckAlignment: u10, Checked: d10 } } = e14;
  const p10 = kp(NLt, zLt[u10] || `${RLt} ${ALt}`);
  const m10 = kLt(l10);
  const h10 = ep.useMemo(() => YDt(c10), [c10]);
  const f10 = ep.useMemo(() => PLt(m10, n10), [m10, n10]);
  const g10 = ep.useMemo(() => __spreadProps(__spreadValues(__spreadValues({}, f10), h10), { paddingBottom: o10, paddingLeft: a10, paddingRight: i10, paddingTop: s10, alignItems: $Lt(m10.alignItems, u10), justifyContent: WLt(m10.justifyContent, u10) }), [f10, h10, o10, a10, i10, s10, u10]);
  const y10 = { borderColor: g10.color };
  const v10 = ep.useMemo(() => bLt(r10, true), [r10]);
  return tp.createElement(tp.Fragment, null, rj(t10) && tp.createElement(Kmt, { documentItem: t10, withMover: true, withGrips: true, dataPath: t10.$path }), tp.createElement("div", { className: p10, style: g10 }, tp.createElement("div", { className: ILt, style: y10 }, d10 && tp.createElement(Fm, { icon: nf(pst), customCSS: "wd-svg" })), tp.createElement("div", { className: HLt }, v10), rj(t10) && tp.createElement(vLt, { value: r10 != null ? r10 : "", valuePath: "Text", itemPath: t10.$path, itemStyles: g10 })));
}, init: (e14, t10, n10, r10) => __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, r10 || jLt), { Text: e14 }), n10), { Name: e14 }), getProperties: (e14, t10) => "Style" === (t10 == null ? void 0 : t10[0]) ? GLt : ZLt, getContextActions: WDt, getReducer: (e14) => WV(0, {}, nz.of(e14).getDefaultReducer()), icon: nf(zoe), icon24: nf($oe), nameTemplateKey: "nameTemplate-RPX:CheckBox", labelKey: "documentItems-RPX:CheckBox", features: { setRectangle: (e14, t10) => __spreadProps(__spreadValues({}, e14), { Left: t10.Left, Top: t10.Top, Width: t10.Width, Height: t10.Height }), getBoundingBox: ULt, getRectangle: ULt } };
const YLt = (e14, t10, n10, r10, o10, a10) => {
  const i10 = t10 || 0;
  const s10 = (t11) => (t11 != null ? t11 : i10) * (e14 / 2) / 100 + "pt";
  return { borderTopLeftRadius: s10(n10), borderTopRightRadius: s10(r10), borderBottomLeftRadius: s10(a10), borderBottomRightRadius: s10(o10) };
};
const [KLt] = Dp("rpx-cross-section-box-item");
const XLt = Z.Dsl.resultOf(kat.Control.decode({ Name: "CrossSectionBox1", Type: "CrossSectionBox" }));
const _ob = cnt, { Width: JLt, Height: QLt, DataField: eHt } = _ob, tHt = __objRest(_ob, ["Width", "Height", "DataField"]);
const nHt = [...Object.values(tHt), stt(Xtt, "control.right", "rpx_dimensions", "Right", void 0, { checkReportGeometry: true, checkCrossSectionItemGeometry: true }), stt(Xtt, "control.bottom", "rpx_dimensions", "Bottom", void 0, { checkCrossSectionItemGeometry: true }), stt(Utt, "lineColor", "color", "LineColor"), stt(Utt, "lineStyle", "rpx_line_style", "LineStyle", void 0, { enumKey: "line_style" }), stt(Utt, "lineWeight", "number", "LineWeight", void 0, { numberType: "Float", minValue: 0, maxValue: 99 })];
const rHt = [...nHt];
const oHt = [...nHt, stt(Utt, "backColor", "color", "BackColor"), stt(Xtt, "crossSectionBoxRadius", "radius", "Radius")];
const aHt = (e14, t10) => e14;
const iHt = (e14, t10) => e14;
const sHt = (e14, t10 = []) => {
  if (0 === t10.length) return 0;
  const { Top: n10, Bottom: r10 } = e14;
  const o10 = e14.$path.split(".")[1];
  const a10 = t10.findIndex((e15) => e15.$path.split(".")[1] === o10);
  const i10 = t10.length - 1 - a10;
  if (a10 < 0) return console.error("Cannot calculate crossSectionItem height: parent section is not found"), 0;
  let s10 = t10[a10].Height - n10;
  for (let e15 = a10 + 1; e15 < i10; e15++) s10 += t10[e15].Height;
  return s10 += r10, s10;
};
const lHt = (e14, t10 = []) => {
  if (0 === t10.length) return 0;
  let n10 = 0;
  const r10 = t10.map((e15) => e15.Height);
  const o10 = r10.findIndex((t11) => (n10 += t11, e14.Top < n10));
  const a10 = r10.length - 1 - o10;
  let i10 = e14.Width - (r10[o10] - e14.Top);
  for (let e15 = o10 + 1; e15 < a10; e15++) i10 -= r10[e15];
  return i10;
};
const cHt = { type: "CrossSectionBox", defaultModel: XLt, glyph: (e14) => {
  const { documentItem: t10, documentItem: { Left: n10, Right: r10, BackColor: o10, LineWeight: a10, LineColor: i10, LineStyle: s10, Radius: { Default: l10, TopLeft: c10, TopRight: u10, BottomLeft: d10, BottomRight: p10 } } } = e14;
  const { instanceId: m10 } = qHe();
  const h10 = Pz();
  const f10 = nz.of(m10);
  const g10 = ep.useMemo(() => {
    var _a2;
    const e15 = f10.getFeature(t10.Type, "getRectangle");
    const o11 = Math.abs(r10 - n10);
    let a11 = 0;
    if (h10) {
      const n11 = nz.of(m10).getFeature(h10.Type, "getChildren");
      const r11 = (_a2 = n11 == null ? void 0 : n11(h10)) != null ? _a2 : [];
      const o12 = e15 == null ? void 0 : e15(t10, void 0, r11);
      a11 = (o12 == null ? void 0 : o12.Height) || 0;
    }
    const i11 = L$.fromTwips(o11 > a11 ? a11 : o11, "pt").value;
    return YLt(i11, l10, c10, u10, p10, d10);
  }, [d10, p10, l10, n10, r10, c10, u10, t10, f10, h10]);
  const y10 = __spreadProps(__spreadValues({}, g10), { backgroundColor: o10, borderWidth: GDt(a10), borderColor: i10, borderStyle: ZDt(s10) });
  return tp.createElement(tp.Fragment, null, rj(t10) && tp.createElement(Kmt, { documentItem: t10, withMover: true, withGrips: true, dataPath: t10.$path, gripsDisabled: true }), tp.createElement("div", { className: KLt, style: y10 }));
}, init: (e14, t10, n10, r10) => __spreadProps(__spreadValues(__spreadValues({}, r10 || XLt), n10), { Name: e14 }), getProperties: () => oHt, getContextActions: WDt, getReducer: (e14) => WV(0, { [Mtt.type]: aHt, [ktt.type]: iHt }, nz.of(e14).getDefaultReducer()), icon: nf(Uoe), icon24: nf(qoe), nameTemplateKey: "nameTemplate-RPX:CrossSectionBox", labelKey: "documentItems-RPX:CrossSectionBox", features: { getBoundingBox: ({ Top: e14, Left: t10, Right: n10 }) => ({ Top: e14, Left: t10, Width: n10 - t10, Height: 0 }), getRectangle: (e14, t10, n10 = []) => {
  const { Top: r10, Left: o10, Right: a10 } = e14;
  return { Top: r10, Left: o10, Width: a10 - o10, Height: sHt(e14, n10) };
}, setRectangle: (e14, t10, n10 = []) => __spreadProps(__spreadValues({}, e14), { Top: t10.Top, Left: t10.Left, Right: t10.Left + t10.Width, Bottom: n10.length ? lHt(t10, n10) : e14.Bottom }), isCrossSectionItem: true } };
const [uHt] = Dp("rpx-cross-section-line-item");
const dHt = Z.Dsl.resultOf(kat.Control.decode({ Name: "CrossSectionLine1", Type: "CrossSectionLine" }));
const pHt = (e14, t10) => e14;
const mHt = (e14, t10) => e14;
const hHt = { type: "CrossSectionLine", defaultModel: dHt, glyph: (e14) => {
  const { documentItem: t10, documentItem: { LineWeight: n10, LineColor: r10, LineStyle: o10 }, parentRectangle: a10 } = e14;
  const i10 = { borderLeftWidth: GDt(n10), borderLeftColor: r10, borderLeftStyle: ZDt(o10) };
  return tp.createElement(tp.Fragment, null, rj(t10) && tp.createElement(Qmt, { documentItem: t10, parentRectangle: a10, withMover: true, withGrips: true, dataPath: t10.$path, gripsDisabled: true }), tp.createElement("div", { className: uHt, style: i10 }));
}, init: (e14, t10, n10, r10) => __spreadProps(__spreadValues(__spreadValues({}, r10 || dHt), n10), { Name: e14 }), getProperties: () => rHt, getContextActions: WDt, getReducer: (e14) => WV(0, { [Mtt.type]: pHt, [ktt.type]: mHt }, nz.of(e14).getDefaultReducer()), icon: nf(Yoe), icon24: nf(Koe), nameTemplateKey: "nameTemplate-RPX:CrossSectionLine", labelKey: "documentItems-RPX:CrossSectionLine", features: { getBoundingBox: ({ Top: e14, Left: t10 }) => ({ Top: e14, Left: t10, Width: 50, Height: 0 }), getRectangle: (e14, t10, n10 = []) => {
  const { Top: r10, Left: o10 } = e14;
  return { Top: r10, Left: o10, Width: 50, Height: sHt(e14, n10) };
}, setRectangle: (e14, t10, n10 = []) => __spreadProps(__spreadValues({}, e14), { Top: t10.Top, Left: t10.Left, Right: t10.Left + t10.Width, Bottom: n10.length ? lHt(t10, n10) : e14.Bottom }), getPoints: (e14, t10, n10 = []) => {
  const { Top: r10, Left: o10 } = e14;
  return [{ x: o10, y: r10 }, { x: o10, y: r10 + sHt(e14, n10) }];
}, dndPreview: (e14) => {
  const { rect: { Left: t10, Top: n10, Width: r10, Height: o10 } } = e14;
  const a10 = { top: `${Nmt(n10, 1)}px`, left: `${Nmt(t10, 1)}px`, width: `${Nmt(r10, 1)}px`, height: `${Nmt(o10, 1)}px` };
  return tp.createElement("div", { className: "dnd-preview dnd-preview-cross-section-line", style: a10 });
}, isCrossSectionItem: true } };
const { Name: fHt, Visible: gHt, DataField: yHt, Tag: vHt, Left: bHt, Top: SHt } = cnt;
const CHt = [fHt, gHt, yHt, vHt, bHt, SHt];
const xHt = (e14) => __spreadProps(__spreadValues({}, e14), { $selected: "leaf", $primary: true });
const wHt = (e14) => __spreadProps(__spreadValues({}, e14), { $selected: "partial", $primary: true });
const THt = (e14) => __spreadProps(__spreadValues({}, lj(e14)), { $selected: "leaf", $primary: ij(e14) });
const EHt = (e14) => (t10, n10) => {
  const r10 = __spreadProps(__spreadValues({}, t10), { $selected: "partial", $primary: ij(t10) });
  const o10 = sj(t10) ? sB(n10.meta.path) : n10;
  return e14(r10, o10);
};
const FHt = (e14, t10) => (n10, r10) => {
  const o10 = t10(n10).filter((e15) => e15.path !== r10.meta.path);
  if (!o10.length) return __spreadProps(__spreadValues({}, lj(n10)), { $selected: "leaf", $primary: true });
  let a10 = __spreadProps(__spreadValues({}, lj(n10)), { $selected: "partial", $primary: ij(n10) });
  const i10 = o10.findIndex((e15) => !!e15.primary);
  const s10 = i10 < 0 ? 0 : i10;
  return a10 = e14(a10, sB(o10[s10].path)), o10.forEach((t11, n11) => {
    n11 !== s10 && (a10 = e14(a10, lB(t11.path)));
  }), a10;
};
const MHt = (e14, t10) => {
  const { payload: { left: n10, top: r10 } } = t10;
  return __spreadProps(__spreadValues({}, e14), { Left: He(n10) ? Iet(n10) : e14.Left, Top: He(r10) ? Iet(r10) : e14.Top });
};
const kHt = (e14, t10) => {
  const { payload: { left: n10, top: r10, width: o10, height: a10 } } = t10;
  return __spreadProps(__spreadValues({}, e14), { Left: He(n10) ? Iet(n10) : e14.Left, Top: He(r10) ? Iet(r10) : e14.Top, Width: He(o10) ? Iet(o10) : e14.Width, Height: He(a10) ? Iet(a10) : e14.Height });
};
const PHt = { type: "unknown", glyph: (e14) => {
  const { documentItem: t10, documentItem: { Type: n10 } } = e14;
  return tp.createElement(tp.Fragment, null, rj(t10) && tp.createElement(Kmt, { documentItem: t10, withMover: true, withGrips: true, dataPath: t10.$path }), tp.createElement("div", { className: "rpx-default-item" }, `"${n10}" has no glyph implemented`));
}, getReducer: (e14) => WV(0, { [iB.type]: xz, [sB.type]: xHt, [lB.type]: THt, [Mtt.type]: MHt, [ktt.type]: kHt }), icon: nf(_ae), nameTemplateKey: "nameTemplate-RPX:Unknown", labelKey: "documentItems-RPX:Unknown", getProperties: () => CHt, features: { dndPreview: (e14) => {
  const { rect: { Left: t10, Top: n10, Width: r10, Height: o10 } } = e14;
  const a10 = { top: `${Nmt(n10, 1)}px`, left: `${Nmt(t10, 1)}px`, width: `${Nmt(r10, 1)}px`, height: `${Nmt(o10, 1)}px` };
  return tp.createElement("div", { className: "dnd-preview default-dnd-preview", style: a10 });
}, isCrossSectionItem: false } };
const [NHt, DHt, LHt] = Dp("rpx-input-field-checkbox");
const [HHt] = LHt("icon");
const IHt = /^=?(true)$/i;
const _Ht = /^=?(false)$/i;
const VHt = { Check: pst, Circle: mst, Cross: hst, Diamond: fst, Square: gst, Star: yst };
function RHt(e14, t10) {
  return ((e15) => "string" == typeof e15 ? -1 !== e15.search(IHt) : !!e15)(e14) ? VHt[t10] || VHt.Check : ((e15) => "string" == typeof e15 ? -1 !== e15.search(_Ht) : !e15)(e14) ? null : vst;
}
const AHt = Z.Dsl.resultOf(kat.Control.decode({ Name: "InputFieldCheckBox1", Type: "InputFieldCheckBox" }));
const OHt = [...pnt, stt(Utt, "backColor", "color", "BackColor"), stt(Utt, "foreColor", "color", "ForeColor"), stt(Utt, "border.color", "color", "BorderColor"), stt(Utt, "border.style", "enum", "BorderStyle", void 0, { enumKey: "border_style_inputfield" }), stt(Utt, "border.width", "number", "BorderWidth", void 0, { numberType: "Integer", step: 1, minValue: 1 }), stt(Utt, "checkSize", "number", "CheckSize", void 0, { numberType: "Integer", step: 1 }), stt(Ktt, "checked", "boolean", "Checked"), stt(int, "fieldName", "string", "FieldName"), stt(int, "readonly", "boolean", "Readonly"), stt(int, "required", "boolean", "Required"), stt(int, "tabIndex", "number", "TabIndex", void 0, { numberType: "Integer", step: 1, emptyValue: "Null", minValue: 1 }), stt(int, "checkStyle", "enum", "CheckStyle", void 0, { enumKey: "check_style" })];
const BHt = ({ Top: e14, Left: t10, Width: n10, Height: r10 }) => ({ Top: e14, Left: t10, Width: n10, Height: r10 });
const zHt = { type: "InputFieldCheckBox", defaultModel: AHt, glyph: (e14) => {
  const { documentItem: t10, parentBackgroundColor: n10, documentItem: { Checked: r10, BackColor: o10, BorderStyle: a10, BorderWidth: i10, ForeColor: s10, CheckSize: l10, BorderColor: c10, CheckStyle: u10 } } = e14;
  const d10 = ep.useMemo(() => ({ backgroundColor: "Transparent" !== o10 ? o10 : n10, borderStyle: a10, borderWidth: i10, borderColor: c10 }), [o10, c10, a10, i10, n10]);
  const p10 = ep.useMemo(() => ({ color: s10, height: `${l10}pt` }), [l10, s10]);
  const m10 = { type: "svg", content: RHt(r10, u10), cssClass: kp(DHt("checked"), "wd-svg") };
  return tp.createElement(tp.Fragment, null, rj(t10) && tp.createElement(Kmt, { documentItem: t10, withMover: true, withGrips: true, dataPath: t10.$path }), tp.createElement("div", { className: NHt }, tp.createElement("div", { style: d10, className: HHt }, tp.createElement("div", { style: p10 }, m10 && tp.createElement(Fm, { icon: m10 })))));
}, init: (e14, t10, n10, r10) => __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, r10 || AHt), { Text: e14 }), n10), { Name: e14 }), getProperties: () => OHt, getContextActions: WDt, getReducer: (e14) => WV(0, {}, nz.of(e14).of("rpx").getDefaultReducer()), icon: nf(Qoe), icon24: nf(eae), nameTemplateKey: "nameTemplate-RPX:InputFieldCheckBox", labelKey: "documentItems-RPX:InputFieldCheckBox", features: { setRectangle: (e14, t10) => __spreadProps(__spreadValues({}, e14), { Left: t10.Left, Top: t10.Top, Width: t10.Width, Height: t10.Height }), getBoundingBox: BHt, getRectangle: BHt } };
const [$Ht, , WHt] = Dp("rpx-input-field-text");
const [jHt] = WHt("text");
const ZHt = Z.Dsl.resultOf(kat.Control.decode({ Name: "InputFieldText1", Type: "InputFieldText", FontFamily: "Arial" }));
const GHt = [...pnt, stt(Utt, "alignment", "enum", "Alignment", void 0, { enumKey: "string_alignment_inputfield" }), stt(Utt, "backColor", "color", "BackColor"), stt(Utt, "foreColor", "color", "ForeColor"), stt(Utt, "border.color", "color", "BorderColor"), stt(Utt, "border.style", "enum", "BorderStyle", void 0, { enumKey: "border_style_inputfield" }), stt(Utt, "border.width", "number", "BorderWidth", void 0, { numberType: "Integer", step: 1, minValue: 1 }), stt(ont, "fontFamily", "rpx_font_family", "FontFamily"), stt(ont, "fontSize", "rpx_font_size", "FontSize", void 0, { units: "pt" }), stt(ont, "fontWeight", "enum", "FontWeight", void 0, { enumKey: "font_weight" }), stt(ont, "fontStyle", "enum", "FontStyle", void 0, { enumKey: "font_style" }), stt(ont, "fontUnderline", "boolean", "FontUnderline"), stt(ont, "fontLinethrough", "boolean", "FontLinethrough"), stt(Utt, "outputFormat", "string", "OutputFormat"), stt(Ktt, "text", "string", "Text"), stt(int, "fieldName", "string", "FieldName"), stt(int, "maxLength", "number", "MaxLength", void 0, { numberType: "Integer", step: 1, emptyValue: "Null", minValue: 1 }), stt(int, "readonly", "boolean", "Readonly"), stt(int, "required", "boolean", "Required"), stt(int, "tabIndex", "number", "TabIndex", void 0, { numberType: "Integer", step: 1, emptyValue: "Null" }), stt(int, "multiLine", "boolean", "MultiLine"), stt(int, "spellCheck", "boolean", "SpellCheck"), stt(int, "password", "boolean", "Password")];
const UHt = ({ Top: e14, Left: t10, Width: n10, Height: r10 }) => ({ Top: e14, Left: t10, Width: n10, Height: r10 });
const qHt = { type: "InputFieldText", defaultModel: ZHt, glyph: (e14) => {
  const { documentItem: t10, parentBackgroundColor: n10, documentItem: { Text: r10, Alignment: o10, BackColor: a10, BorderColor: i10, BorderStyle: s10, BorderWidth: l10, FontFamily: c10, FontLinethrough: u10, FontSize: d10, FontStyle: p10, FontUnderline: m10, FontWeight: h10, ForeColor: f10, MultiLine: g10 } } = e14;
  const y10 = ep.useMemo(() => "None" === s10 ? {} : { borderColor: i10, borderStyle: s10, borderWidth: l10 }, [i10, s10, l10]);
  const v10 = ep.useMemo(() => __spreadProps(__spreadValues({}, y10), { backgroundColor: "Transparent" !== a10 ? a10 : n10, fontFamily: c10, fontSize: d10, fontStyle: p10, fontWeight: "Bold" === h10 ? "bold" : "normal", color: f10, textAlign: TLt(o10), justifyContent: TLt(o10), textDecoration: MLt(u10, m10) }), [o10, a10, c10, u10, d10, p10, m10, h10, f10, y10, n10]);
  const b10 = ep.useMemo(() => bLt(r10, g10), [r10, g10]);
  return tp.createElement(tp.Fragment, null, rj(t10) && tp.createElement(Kmt, { documentItem: t10, withMover: true, withGrips: true, dataPath: t10.$path }), tp.createElement("div", { style: v10, className: $Ht }, tp.createElement("div", { className: jHt }, b10), rj(t10) && tp.createElement(vLt, { value: r10 != null ? r10 : "", valuePath: "Text", itemPath: t10.$path, itemStyles: v10 })));
}, init: (e14, t10, n10, r10) => __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, r10 || ZHt), { Text: e14 }), n10), { Name: e14 }), getProperties: () => GHt, getContextActions: WDt, getReducer: (e14) => WV(0, {}, nz.of(e14).of("rpx").getDefaultReducer()), icon: nf(tae), icon24: nf(nae), nameTemplateKey: "nameTemplate-RPX:InputFieldText", labelKey: "documentItems-RPX:InputFieldText", features: { setRectangle: (e14, t10) => __spreadProps(__spreadValues({}, e14), { Left: t10.Left, Top: t10.Top, Width: t10.Width, Height: t10.Height }), getBoundingBox: UHt, getRectangle: UHt } };
const [YHt, , KHt] = Dp("rpx-label-item");
const [XHt, JHt] = KHt("text");
const QHt = Z.Dsl.resultOf(kat.Control.decode({ Name: "Label1", Type: "Label" }));
const eIt = [...pnt, ...mnt, snt, unt, stt(Ktt, "text", "string", "Text"), stt(Ktt, "hyperLink", "string", "HyperLink"), stt(qtt, "multiLine", "boolean", "MultiLine"), stt(qtt, "rightToLeft", "boolean", "RightToLeft"), stt(qtt, "angle", "number", "Angle", void 0, { numberType: "Integer", step: 10 }), stt(qtt, "minCondenseRate", "percent", "MinCondenseRate", void 0, { min: 10, max: 100, scale: 1 }), stt(Utt, "characterSpacing", "number", "CharacterSpacing", void 0, { numberType: "Float", minValue: 0 }), stt(Utt, "lineSpacing", "number", "LineSpacing", void 0, { numberType: "Float", minValue: 0 })];
const tIt = [dnt.ClassName, dnt.BackColor, dnt.ForeColor, dnt.FontFamily, dnt.FontSize, dnt.FontWeight, dnt.FontStyle, dnt.ShrinkToFit, dnt.FontUnderline, dnt.FontLinethrough, dnt.TextAlign, dnt.TextJustify, dnt.VerticalAlign, dnt.VerticalText, dnt.WordWrap];
const nIt = ({ Top: e14, Left: t10, Width: n10, Height: r10 }) => ({ Top: e14, Left: t10, Width: n10, Height: r10 });
const rIt = { type: "Label", defaultModel: QHt, glyph: (e14) => {
  const { documentItem: t10, parentBackgroundColor: n10, documentItem: { Text: r10, CharacterSpacing: o10, LineSpacing: a10, PaddingBottom: i10, PaddingLeft: s10, PaddingRight: l10, PaddingTop: c10, MultiLine: u10, RightToLeft: d10, Style: p10, Border: m10 } } = e14;
  const h10 = kLt(p10);
  const f10 = ep.useMemo(() => YDt(m10), [m10]);
  const g10 = ep.useMemo(() => PLt(h10, n10), [h10, n10]);
  const y10 = kp(XHt, { [JHt("rtl")]: d10 });
  const v10 = ep.useMemo(() => __spreadProps(__spreadValues(__spreadValues({}, g10), f10), { paddingBottom: i10, paddingLeft: s10, paddingRight: l10, paddingTop: c10, letterSpacing: o10, lineHeight: wLt(a10, h10.fontSize), justifyContent: SLt(h10.textAlign, d10), textAlign: SLt(h10.textAlign, d10), writingMode: CLt(h10.writingMode, d10), wordBreak: xLt(h10.wordBreak, u10) }), [g10, f10, o10, a10, i10, s10, l10, c10, d10, u10]);
  const b10 = ep.useMemo(() => bLt(r10, u10), [r10, u10]);
  return tp.createElement(tp.Fragment, null, rj(t10) && tp.createElement(Kmt, { documentItem: t10, withMover: true, withGrips: true, dataPath: t10.$path }), tp.createElement("div", { className: YHt, style: v10 }, tp.createElement("div", { className: y10 }, b10), rj(t10) && tp.createElement(vLt, { value: r10 != null ? r10 : "", valuePath: "Text", itemPath: t10.$path, itemStyles: v10 })));
}, init: (e14, t10, n10, r10) => {
  const o10 = r10 || QHt;
  return __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, o10), { Text: e14 }), n10), { Style: __spreadValues(__spreadValues({}, o10.Style), n10 == null ? void 0 : n10.Style), Name: e14 });
}, getProperties: (e14, t10) => "Style" === (t10 == null ? void 0 : t10[0]) ? tIt : eIt, getContextActions: WDt, getReducer: (e14) => WV(0, {}, nz.of(e14).of("rpx").getDefaultReducer()), icon: nf(rae), icon24: nf(oae), nameTemplateKey: "nameTemplate-RPX:Label", labelKey: "documentItems-RPX:Label", features: { setRectangle: (e14, t10) => __spreadProps(__spreadValues({}, e14), { Left: t10.Left, Top: t10.Top, Width: t10.Width, Height: t10.Height }), getBoundingBox: nIt, getRectangle: nIt } };
const [oIt] = Dp("rpx-line-item");
const aIt = (e14, t10, n10) => 0 === e14 ? L$.fromTwips(t10, n10).abs().css : 0 === t10 ? L$.fromTwips(e14).abs().css : L$.fromTwips(Math.sqrt(__pow(e14, 2) + __pow(t10, 2))).css;
const iIt = ({ LineColor: e14, LineStyle: t10, LineWeight: n10, X1: r10, X2: o10, Y1: a10, Y2: i10 }, s10) => {
  const l10 = r10 < o10;
  const c10 = a10 < i10;
  const u10 = a10 === i10;
  const d10 = o10 - r10;
  const p10 = i10 - a10;
  const m10 = (f10 = p10, 0 === (h10 = d10) ? Math.atan(f10 >= 0 ? -1 / 0 : 1 / 0) : Math.atan(f10 / h10));
  var h10, f10;
  const g10 = n10 < 1 ? 1 : n10;
  const y10 = `${Math.cos(m10).toFixed(4)} * (${GDt(g10)} /2)`;
  return { top: `calc(${l10 && !c10 && !u10 || c10 && !l10 && !u10 ? `100% - ${y10}` : `0pt - ${y10}`})`, left: `calc(${`${Math.sin(m10).toFixed(4)} * (${GDt(g10)} /2)`})`, borderColor: e14, borderStyle: `${ZDt(t10)} none none`, borderWidth: GDt(g10), height: GDt(g10), width: aIt(d10, p10, s10), transform: `rotate(${m10}rad)` };
};
const sIt = Z.Dsl.resultOf(kat.Control.decode({ Name: "Line1", Type: "Line" }));
const lIt = [cnt.Name, cnt.Tag, cnt.Visible, stt(Xtt, "x1", "rpx_length", "X1", void 0, { checkReportGeometry: true, checkSectionGeometry: true }), stt(Xtt, "x2", "rpx_length", "X2", void 0, { checkReportGeometry: true, checkSectionGeometry: true }), stt(Xtt, "y1", "rpx_length", "Y1", void 0, { checkReportGeometry: true, checkSectionGeometry: true }), stt(Xtt, "y2", "rpx_length", "Y2", void 0, { checkReportGeometry: true, checkSectionGeometry: true }), stt(Utt, "lineColor", "color", "LineColor"), stt(Utt, "lineStyle", "rpx_line_style", "LineStyle", void 0, { enumKey: "line_style" }), stt(Utt, "lineWeight", "number", "LineWeight", void 0, { numberType: "Float", minValue: 0, maxValue: 99 }), stt(Utt, "anchorBottom", "boolean", "AnchorBottom")];
const cIt = (e14, t10, n10) => 0 === n10 ? __spreadProps(__spreadValues({}, e14), { X1: Iet(t10.x), Y1: Iet(t10.y) }) : 1 === n10 ? __spreadProps(__spreadValues({}, e14), { X2: Iet(t10.x), Y2: Iet(t10.y) }) : e14;
const uIt = ({ X1: e14, Y1: t10, X2: n10, Y2: r10 }) => ({ Top: t10 >= r10 ? r10 : t10, Left: e14 >= n10 ? n10 : e14, Width: Math.abs(e14 - n10), Height: Math.abs(t10 - r10) });
const dIt = (e14, t10) => {
  const { X1: n10, Y1: r10, X2: o10, Y2: a10 } = e14;
  return __spreadProps(__spreadValues({}, e14), { X1: Iet(n10 >= o10 ? t10.Left + t10.Width : t10.Left), X2: Iet(n10 < o10 ? t10.Left + t10.Width : t10.Left), Y1: Iet(r10 >= a10 ? t10.Top + t10.Height : t10.Top), Y2: Iet(r10 < a10 ? t10.Top + t10.Height : t10.Top) });
};
const pIt = (e14, t10) => {
  const { payload: { left: n10, top: r10 } } = t10;
  const { X1: o10, X2: a10, Y1: i10, Y2: s10 } = e14;
  const l10 = o10 < a10 ? o10 : a10;
  const c10 = i10 < s10 ? i10 : s10;
  return __spreadProps(__spreadValues({}, e14), { X1: He(n10) ? Iet(o10 + n10 - l10) : o10, X2: He(n10) ? Iet(a10 + n10 - l10) : a10, Y1: He(r10) ? Iet(i10 + r10 - c10) : i10, Y2: He(r10) ? Iet(s10 + r10 - c10) : s10 });
};
const mIt = (e14, t10) => {
  const { payload: { left: n10, top: r10, width: o10, height: a10 } } = t10;
  const i10 = uIt(e14);
  const s10 = { Left: He(n10) ? n10 : i10.Left, Top: He(r10) ? r10 : i10.Top, Width: He(o10) ? o10 : i10.Width, Height: He(a10) ? a10 : i10.Height };
  return dIt(e14, s10);
};
const hIt = { type: "Line", defaultModel: sIt, init: (e14, t10, n10, r10) => __spreadProps(__spreadValues(__spreadValues({}, r10 || sIt), n10), { Name: e14 }), glyph: (e14) => {
  const { documentItem: t10, parentRectangle: n10 } = e14;
  const { userPreferences: { units: r10 } } = MO();
  const o10 = iIt(t10, r10);
  const a10 = { top: o10.top, left: o10.left, height: o10.height, width: o10.width, transform: o10.transform };
  return tp.createElement(tp.Fragment, null, rj(t10) && tp.createElement(Qmt, { documentItem: t10, parentRectangle: n10, withMover: true, withGrips: true, lineStyles: a10, dataPath: t10.$path }), tp.createElement("div", { className: oIt, style: o10 }));
}, getProperties: () => lIt, getContextActions: WDt, getReducer: (e14) => WV(0, { [Ntt.type]: (e15, { payload: { point: t10, index: n10 } }) => cIt(e15, t10, n10), [Mtt.type]: pIt, [ktt.type]: mIt }, nz.of(e14).of("rpx").getDefaultReducer()), icon: nf(aae), icon24: nf(iae), nameTemplateKey: "nameTemplate-RPX:Line", labelKey: "documentItems-RPX:Line", features: { getBoundingBox: uIt, getRectangle: uIt, setRectangle: dIt, dndPreview: (e14) => {
  const { documentItem: t10, rect: { Left: n10, Top: r10, Width: o10, Height: a10 } } = e14;
  const i10 = { top: `${Nmt(r10, 1)}px`, left: `${Nmt(n10, 1)}px`, width: `${Nmt(o10, 1)}px`, height: `${Nmt(a10, 1)}px` };
  const s10 = iIt(t10, "cm");
  return tp.createElement("div", { className: "dnd-preview", style: i10 }, tp.createElement("div", { className: "dnd-preview-line", style: s10 }));
}, getPoints: (e14) => [{ x: e14.X1, y: e14.Y1 }, { x: e14.X2, y: e14.Y2 }], setPoint: cIt } };
const [fIt] = Dp("rpx-page-break-item");
const gIt = Z.Dsl.resultOf(kat.Control.decode({ Name: "PageBreak1", Type: "PageBreak" }));
const yIt = [cnt.Name, cnt.Tag, cnt.Top, stt(qtt, "enabled", "boolean", "Enabled")];
const vIt = (e14, t10) => {
  const { payload: { top: n10 } } = t10;
  return __spreadProps(__spreadValues({}, e14), { Top: He(n10) ? Math.max(0, n10) : e14.Top });
};
const bIt = (e14, t10) => {
  const { payload: { top: n10 } } = t10;
  return __spreadProps(__spreadValues({}, e14), { Top: He(n10) ? Math.max(0, n10) : e14.Top });
};
const SIt = { type: "PageBreak", defaultModel: gIt, init: (e14, t10, n10, r10) => __spreadProps(__spreadValues(__spreadValues({}, r10 || gIt), n10), { Name: e14 }), glyph: (e14) => {
  const { documentItem: t10, parentRectangle: n10 } = e14;
  const { Top: r10 } = t10;
  const { userPreferences: { units: o10 } } = MO();
  const a10 = Pz();
  if (!a10) return null;
  const { PrintWidth: i10 } = a10;
  const s10 = { top: L$.fromTwips(r10, o10).css, width: L$.fromTwips(i10, o10).css };
  return tp.createElement(tp.Fragment, null, rj(t10) && tp.createElement(Qmt, { documentItem: t10, withMover: true, withGrips: true, gripsDisabled: true, dataPath: t10.$path, parentRectangle: n10 }), tp.createElement("div", { className: fIt, style: s10 }));
}, getProperties: () => yIt, getContextActions: WDt, getReducer: (e14) => WV(0, { [Mtt.type]: vIt, [ktt.type]: bIt }, nz.of(e14).of("rpx").getDefaultReducer()), icon: nf(dae), icon24: nf(pae), nameTemplateKey: "nameTemplate-RPX:PageBreak", labelKey: "documentItems-RPX:PageBreak", features: { getBoundingBox: ({ Top: e14 }) => ({ Top: e14, Left: 0, Width: 0, Height: 0 }), getRectangle: ({ Top: e14 }, t10) => {
  var _a2;
  return { Top: e14, Left: 0, Width: (_a2 = t10 == null ? void 0 : t10.Width) != null ? _a2 : 0, Height: 0 };
}, setRectangle: (e14, t10) => __spreadProps(__spreadValues({}, e14), { Top: t10.Top }), getPoints: ({ Top: e14 }, t10) => [{ x: 0, y: e14 }, { x: t10.Left + t10.Width, y: e14 }] } };
const [CIt, , xIt] = Dp("rpx-picture-item");
const [wIt] = xIt("image");
const TIt = (e14) => {
  switch (e14) {
    case "BottomLeft":
      return "bottom left";
    case "BottomRight":
      return "bottom right";
    case "Center":
      return "center";
    case "TopRight":
      return "top right";
    default:
      return "top left";
  }
};
const EIt = Z.Dsl.resultOf(kat.Control.decode({ Name: "Picture1", Type: "Picture" }));
const FIt = [...pnt, ...mnt, stt(Ktt, "hyperLink", "string", "HyperLink"), stt(Ktt, "image", "image", "Image"), stt(Ktt, "title", "string", "Title"), stt(Ktt, "description", "string", "Description"), stt(Utt, "lineColor", "color", "LineColor"), stt(Utt, "lineStyle", "rpx_line_style", "LineStyle", void 0, { enumKey: "line_style" }), stt(Utt, "lineWeight", "number", "LineWeight", void 0, { numberType: "Float" }), stt(Utt, "pictureAlignment", "enum", "PictureAlignment", "both", { enumKey: "picture_alignment" }), stt(Utt, "backColor", "color", "BackColor"), stt(Xtt, "sizeMode", "enum", "SizeMode", "both", { enumKey: "size_mode" })];
const MIt = ({ Top: e14, Left: t10, Width: n10, Height: r10 }) => ({ Top: e14, Left: t10, Width: n10, Height: r10 });
const kIt = { type: "Picture", defaultModel: EIt, glyph: (e14) => {
  const { documentItem: t10, documentItem: { Border: n10, LineColor: r10, LineStyle: o10, LineWeight: a10, BackColor: i10, PictureAlignment: s10, SizeMode: l10, Image: c10, MimeType: u10 } } = e14;
  const d10 = ep.useMemo(() => YDt(n10), [n10]);
  const p10 = ep.useMemo(() => __spreadProps(__spreadValues({}, d10), { backgroundColor: i10 }), [d10, i10]);
  const m10 = ep.useMemo(() => c10 ? `url("data:${u10};base64, ${c10}")` : void 0, [c10, u10]);
  const h10 = ep.useMemo(() => {
    return { borderWidth: GDt(a10), borderColor: r10, borderStyle: ZDt(o10), backgroundImage: m10, backgroundSize: (e15 = l10, "Clip" === e15 ? "auto auto" : "Stretch" === e15 ? "100% 100%" : "contain"), backgroundPosition: TIt(s10) };
    var e15;
  }, [r10, o10, a10, l10, s10, m10]);
  return tp.createElement(tp.Fragment, null, rj(t10) && tp.createElement(Kmt, { documentItem: t10, withMover: true, withGrips: true, dataPath: t10.$path }), tp.createElement("div", { className: CIt, style: p10 }, tp.createElement("div", { style: h10, className: wIt })));
}, init: (e14, t10, n10, r10) => __spreadProps(__spreadValues(__spreadValues({}, r10 || EIt), n10), { Name: e14 }), getProperties: () => FIt, getContextActions: WDt, getReducer: (e14) => WV(0, {}, nz.of(e14).of("rpx").getDefaultReducer()), icon: nf(Xoe), icon24: nf(Joe), nameTemplateKey: "nameTemplate-RPX:Picture", labelKey: "documentItems-RPX:Picture", features: { setRectangle: (e14, t10) => __spreadProps(__spreadValues({}, e14), { Left: t10.Left, Top: t10.Top, Width: t10.Width, Height: t10.Height }), getBoundingBox: MIt, getRectangle: MIt } };
const PIt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.accent, d: "M14.5 19c2.485 0 4.5-2.015 4.5-4.5S16.985 10 14.5 10 10 12.015 10 14.5s2.015 4.5 4.5 4.5Zm0-7c.276 0 .5.224.5.5V14h1.5c.276 0 .5.224.5.5s-.224.5-.5.5H15v1.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5V15h-1.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H14v-1.5c0-.276.224-.5.5-.5Z" }), tp.createElement("path", { className: Km.secondary, d: "M7 6.5c0 .276-.224.5-.5.5S6 6.776 6 6.5V5.335c0-.354.141-.694.391-.944S6.981 4 7.335 4h5.33c.354 0 .694.141.944.391s.391.59.391.944V6.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5V5.335c0-.089-.035-.174-.098-.237S12.754 5 12.665 5h-5.33c-.089 0-.174.035-.237.098S7 5.246 7 5.335V6.5ZM8.5 16H7.335c-.354 0-.694-.141-.944-.391S6 15.019 6 14.665V13.5c0-.276.224-.5.5-.5s.5.224.5.5v1.165c0 .089.035.174.098.237s.148.098.237.098H8.5c.276 0 .5.224.5.5s-.224.5-.5.5Z" }), tp.createElement("path", { className: Ym.text, d: "M6 2c-1.105 0-2 .895-2 2v12c0 1.105.895 2 2 2h4.257c-.253-.307-.474-.642-.657-1H6c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1h8c.552 0 1 .448 1 1v5.022c.343.031.678.094 1 .185V4c0-1.105-.895-2-2-2H6Z" }));
const NIt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.accent, d: "M14.5 19c2.485 0 4.5-2.015 4.5-4.5S16.985 10 14.5 10 10 12.015 10 14.5s2.015 4.5 4.5 4.5Zm0-7c.276 0 .5.224.5.5V14h1.5c.276 0 .5.224.5.5s-.224.5-.5.5H15v1.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5V15h-1.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H14v-1.5c0-.276.224-.5.5-.5Z" }), tp.createElement("path", { className: Km.secondary, d: "M7 4h6c.552 0 1 .448 1 1s-.448 1-1 1H7c-.552 0-1-.448-1-1s.448-1 1-1Zm0 10h1c.552 0 1 .448 1 1s-.448 1-1 1H7c-.552 0-1-.448-1-1s.448-1 1-1Z" }), tp.createElement("path", { className: Ym.text, d: "M6 2c-1.105 0-2 .895-2 2v12c0 1.105.895 2 2 2h4.257c-.253-.307-.474-.642-.657-1H6c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1h8c.552 0 1 .448 1 1v5.022c.343.031.678.094 1 .185V4c0-1.105-.895-2-2-2H6Z" }));
const DIt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.error, d: "M19 14.5c0 2.485-2.015 4.5-4.5 4.5S10 16.985 10 14.5s2.015-4.5 4.5-4.5 4.5 2.015 4.5 4.5Zm-2.646-1.146c.195-.196.195-.512 0-.708-.196-.195-.512-.195-.708 0L14.5 13.793l-1.146-1.147c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708l1.147 1.146-1.147 1.146c-.195.196-.195.512 0 .708.196.195.512.195.708 0l1.146-1.147 1.146 1.147c.196.195.512.195.708 0 .195-.196.195-.512 0-.708L15.207 14.5l1.147-1.146" }), tp.createElement("path", { className: Km.secondary, d: "M7 4h6c.552 0 1 .448 1 1s-.448 1-1 1H7c-.552 0-1-.448-1-1s.448-1 1-1Zm0 10h1c.552 0 1 .448 1 1s-.448 1-1 1H7c-.552 0-1-.448-1-1s.448-1 1-1Z" }), tp.createElement("path", { className: Ym.text, d: "M6 2c-1.105 0-2 .895-2 2v12c0 1.105.895 2 2 2h4.257c-.253-.307-.474-.642-.657-1H6c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1h8c.552 0 1 .448 1 1v5.022c.343.031.678.094 1 .185V4c0-1.105-.895-2-2-2H6Z" }));
const LIt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.accent, d: "M5.5 19c2.485 0 4.5-2.015 4.5-4.5S7.985 10 5.5 10 1 12.015 1 14.5 3.015 19 5.5 19Zm0-7c.276 0 .5.224.5.5V14h1.5c.276 0 .5.224.5.5s-.224.5-.5.5H6v1.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5V15H3.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H5v-1.5c0-.276.224-.5.5-.5Z" }), tp.createElement("path", { className: Km.secondary, d: "M7 4h1c.552 0 1 .448 1 1s-.448 1-1 1H7c-.552 0-1-.448-1-1s.448-1 1-1Zm5 10h1c.552 0 1 .448 1 1s-.448 1-1 1h-1c-.552 0-1-.448-1-1s.448-1 1-1Z" }), tp.createElement("path", { className: Ym.text, d: "M6 2c-1.105 0-2 .895-2 2v5.207c.322-.091.657-.154 1-.185V4c0-.552.448-1 1-1h4v3.5c0 .828.672 1.5 1.5 1.5H15v8c0 .552-.448 1-1 1h-3.6c-.183.358-.404.693-.657 1H14c1.105 0 2-.895 2-2V7.414c0-.398-.158-.779-.439-1.06l-3.915-3.915c-.281-.281-.662-.439-1.06-.439H6Zm8.793 5H11.5c-.276 0-.5-.224-.5-.5V3.207L14.793 7Z" }));
const HIt = tp.createElement("svg", { width: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("path", { className: Km.error, d: "M10 14.5c0 2.485-2.015 4.5-4.5 4.5S1 16.985 1 14.5 3.015 10 5.5 10s4.5 2.015 4.5 4.5Zm-2.646-1.146c.195-.196.195-.512 0-.708-.196-.195-.512-.195-.708 0L5.5 13.793l-1.146-1.147c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708L4.793 14.5l-1.147 1.146c-.195.196-.195.512 0 .708.196.195.512.195.708 0L5.5 15.207l1.146 1.147c.196.195.512.195.708 0 .195-.196.195-.512 0-.708L6.207 14.5l1.147-1.146Z" }), tp.createElement("path", { className: Km.secondary, d: "M7 4h1c.552 0 1 .448 1 1s-.448 1-1 1H7c-.552 0-1-.448-1-1s.448-1 1-1Zm5 10h1c.552 0 1 .448 1 1s-.448 1-1 1h-1c-.552 0-1-.448-1-1s.448-1 1-1Z" }), tp.createElement("path", { className: Ym.text, d: "M6 2c-1.105 0-2 .895-2 2v5.207c.322-.091.657-.154 1-.185V4c0-.552.448-1 1-1h4v3.5c0 .828.672 1.5 1.5 1.5H15v8c0 .552-.448 1-1 1h-3.6c-.183.358-.404.693-.657 1H14c1.105 0 2-.895 2-2V7.414c0-.398-.158-.779-.439-1.06l-3.915-3.915c-.281-.281-.662-.439-1.06-.439H6Zm8.793 5H11.5c-.276 0-.5-.224-.5-.5V3.207L14.793 7Z" }));
const IIt = Z.Dsl.resultOf(kat.Report.decode({ StyleSheet: [{ FontFamily: "Arial" }] }));
const _It = (e14, t10) => {
  const n10 = az.of(t10);
  return Object.fromEntries(Object.entries(e14).map(([e15, t11]) => [e15, __spreadProps(__spreadValues({}, t11), { Name: "Detail" === t11.Type ? n10.getDocumentItemTemplate(t11.Type) : n10.getNextDocumentItemName(t11.Type) })]));
};
const VIt = [stt(Ytt, "printWidth", "rpx_dimensions", "PrintWidth", void 0, { minValueMap: qY, maxValue: L$.parse("800in"), fractionDigitsMap: { cm: 2, in: 2 } }), stt(Ytt, "maxPages", "number", "MaxPages", void 0, { numberType: "Integer", minValue: 0, step: 1 }), stt(Ytt, "paramUI", "boolean", "ParamUI"), stt(tnt, "margin", "margin", "PageSettings"), stt(tnt, "gutterMargin", "rpx_length", "PageSettings.GutterMargin", void 0, { minValue: L$.parse("0in"), maxValue: L$.parse("6.5in"), fractionDigitsMap: { cm: 2, in: 2 } }), stt(tnt, "mirrorMargins", "boolean", "PageSettings.MirrorMargins"), stt(rnt, "paperSize", "paperSize", "PageSettings"), stt(rnt, "collate", "enum", "PageSettings.Collate", void 0, { enumKey: "collate" }), stt(rnt, "duplex", "enum", "PageSettings.Duplex", void 0, { enumKey: "duplex" }), stt(nnt, "watermarkImage", "image", "Watermark.Image"), stt(nnt, "watermarkAlignment", "enum", "Watermark.Alignment", void 0, { enumKey: "picture_alignment" }), stt(nnt, "watermarkSizeMode", "enum", "Watermark.SizeMode", void 0, { enumKey: "size_mode" }), stt(nnt, "watermarkPrintOnPages", "string", "Watermark.PrintOnPages"), stt(qtt, "scriptLanguage", "rpx_script_language", "ScriptLanguage"), stt(Ktt, "culture", "enum", "Culture", void 0, { enumKey: "culture" }), stt(Ktt, "userData", "string", "UserData"), stt("", "script", "string", "Script"), stt(ent, "version", "number", "Version", void 0, { numberType: "Float" }), stt(ent, "expressionErrorMessage", "string", "ExpressionErrorMessage")];
const RIt = ["Script", "Version", "ExpressionErrorMessage"];
const AIt = VIt.filter(({ valuePath: e14 }) => !RIt.includes(e14));
function OIt(e14, t10, n10) {
  let r10 = e14;
  for (const [o10, a10] of Object.entries(e14)) if (aj(a10)) {
    const e15 = t10(a10.Type);
    if (e15) {
      const t11 = e15(a10, n10);
      t11 !== a10 && (r10 = __spreadProps(__spreadValues({}, r10), { [o10]: t11 }));
    }
  }
  return r10;
}
function BIt(e14, t10, n10) {
  let r10 = e14;
  for (const o10 of e14) {
    const e15 = o10.$id;
    if (aj(o10)) {
      const a10 = t10(o10.Type);
      if (a10) {
        a10(o10, n10) !== o10 && (r10 = __spreadProps(__spreadValues({}, r10), { [e15]: o10 }));
      }
    }
  }
  return r10;
}
const zIt = (e14, t10) => (n10, r10) => {
  let o10 = n10;
  aj(n10);
  for (const a10 of e14) {
    const e15 = n10[a10];
    if (!e15) continue;
    let i10 = e15;
    i10 = Array.isArray(e15) ? BIt(e15, t10, r10) : OIt(e15, t10, r10), i10 !== e15 && (o10 = __spreadProps(__spreadValues({}, o10), { [a10]: i10 }));
  }
  return o10;
};
const $It = (e14, t10) => (n10, r10) => {
  var _a2;
  const o10 = (_a2 = r10 == null ? void 0 : r10.meta) == null ? void 0 : _a2.path;
  if (!o10) return n10;
  const a10 = o10.split(".");
  const [i10, s10, ...l10] = a10;
  if (!e14.includes(i10)) return n10;
  const c10 = n10[i10];
  if (!c10) return n10;
  const u10 = c10[s10];
  if (!u10) return n10;
  const d10 = t10(u10.Type);
  if (!d10) return n10;
  const p10 = d10(u10, __spreadProps(__spreadValues({}, r10), { meta: __spreadProps(__spreadValues({}, r10.meta), { path: l10.join(".") }) }));
  return p10 === u10 ? n10 : __spreadProps(__spreadValues({}, n10), { [i10]: __spreadProps(__spreadValues({}, c10), { [s10]: p10 }) });
};
const WIt = (e14, t10) => {
  var _a2;
  return He((_a2 = t10.meta) == null ? void 0 : _a2.path);
};
const jIt = (e14, t10) => {
  var _a2;
  return "" === ((_a2 = t10.meta) == null ? void 0 : _a2.path);
};
function ZIt(e14) {
  const t10 = { group: ["GroupHeader", "GroupFooter"], page: ["PageHeader", "PageFooter"], report: ["ReportHeader", "ReportFooter"] };
  const n10 = { PageHeader: "PageFooter", PageFooter: "PageHeader", ReportHeader: "ReportFooter", ReportFooter: "ReportHeader" };
  const r10 = (e15, t11) => {
    const { Sections: r11, GroupsOrder: o10 } = e15;
    const a10 = [];
    return t11.forEach((e16) => {
      const t12 = r11[e16].Type;
      if ("Detail" === t12) return;
      a10.includes(e16) || a10.push(e16);
      let i10 = "";
      if ("GroupHeader" === t12 || "GroupFooter" === t12) {
        const t13 = o10.findIndex((t14) => t14 === e16);
        if (t13 < 0) throw new Error(`Missing ${e16} in GroupsOrder!`);
        i10 = o10[o10.length - 1 - t13];
      } else {
        i10 = ((e17, t13) => {
          const n11 = t13.find(([t14, n12]) => n12.Type === e17);
          if (!n11) throw new Error(`Missing bound ${e17} section!`);
          return n11[0];
        })(n10[t12], Object.entries(r11));
      }
      a10.includes(i10) || a10.push(i10);
    }), a10;
  };
  return { addSectionsReducer: (n11, { payload: r11 }) => {
    const { type: o10, headerName: a10, footerName: i10, headerId: s10, footerId: l10 } = r11;
    const [c10, u10] = t10[o10];
    const d10 = __spreadValues({}, lj(n11));
    const { Sections: p10, GroupsOrder: m10 } = d10;
    if (Object.values(p10).find((e15) => "group" !== o10 && e15.Type === c10)) return n11;
    const h10 = __spreadProps(__spreadValues({}, e14.create(c10, a10)), { $path: `Sections.${s10}`, $selected: "leaf", $primary: true });
    const f10 = e14.create(u10, i10);
    f10.$path = `Sections.${l10}`;
    const g10 = __spreadValues({}, p10);
    g10[s10] = h10, g10[l10] = f10;
    const y10 = [...m10];
    return "group" === o10 && y10.splice(m10.length / 2, 0, s10, l10), __spreadProps(__spreadValues({}, d10), { Sections: g10, GroupsOrder: y10, $selected: "partial", $primary: true });
  }, removeSectionsByPathReducer: (e15, { meta: { path: t11 } }) => {
    if (!t11) return e15;
    const n11 = t11.split(".")[1];
    if (!n11 || !(n11 in e15.Sections)) return e15;
    const o10 = r10(e15, [n11]);
    if (0 === o10.length) return e15;
    const a10 = __spreadValues({}, e15.Sections);
    o10.forEach((e16) => {
      delete a10[e16];
    });
    const i10 = e15.GroupsOrder.filter((e16) => !o10.includes(e16));
    const s10 = !!o10.find((t12) => aj(e15.Sections[t12]));
    const l10 = !!o10.find((t12) => ij(e15.Sections[t12]));
    const c10 = !!Object.values(a10).find((e16) => aj(e16));
    return !s10 || c10 && !l10 ? __spreadProps(__spreadValues({}, e15), { GroupsOrder: i10, Sections: a10 }) : __spreadProps(__spreadValues({}, lj(e15)), { Sections: a10, GroupsOrder: i10, $primary: true, $selected: "leaf" });
  }, removeSectionsBySelectionReducer: (e15) => {
    const t11 = [];
    let n11 = false;
    for (const [r11, o11] of Object.entries(e15.Sections)) rj(o11) && (n11 = true, t11.push(r11));
    const o10 = n11 ? r10(e15, t11) : [];
    if (0 === o10.length) return e15;
    const a10 = __spreadValues({}, lj(e15.Sections));
    return o10.forEach((e16) => {
      delete a10[e16];
    }), __spreadProps(__spreadValues({}, e15), { Sections: a10, GroupsOrder: e15.GroupsOrder.filter((e16) => !o10.includes(e16)), $primary: true, $selected: "leaf" });
  } };
}
const GIt = (e14, { payload: { calcField: t10 } }) => AV(e14, { CalculatedFields: { $push: [t10] } });
const UIt = (e14, { payload: { index: t10 } }) => AV(e14, { CalculatedFields: { $splice: [[t10, 1]] } });
const qIt = (e14) => (t10) => (n10, r10) => {
  var _a2;
  const o10 = t10(n10, r10);
  if (o10 !== n10 && ((_a2 = r10 == null ? void 0 : r10.meta) == null ? void 0 : _a2.checkReportGeometry)) {
    const t11 = Object.values(o10.Sections).map((t12) => function(e15, t13) {
      return Object.values(e15.Controls).reduce((e16, n12) => {
        const r11 = t13.getFeature(n12.Type, "getRectangle");
        if (!r11) return e16;
        const o11 = r11(n12, { Top: 0, Left: 0, Width: 0, Height: 0 });
        const a10 = o11.Left + o11.Width;
        return Math.max(e16, a10);
      }, 0);
    }(t12, e14));
    const n11 = Math.max(...t11);
    if (n11 > o10.PrintWidth) return __spreadProps(__spreadValues({}, o10), { PrintWidth: n11 });
  }
  return o10;
};
const YIt = (e14, { payload: { dataSource: t10 } }) => AV(e14, { DataSource: { $set: t10 } });
const KIt = (e14, { payload: { fields: t10 } }) => AV(e14, { Fields: { $set: t10 } });
const XIt = (e14, { payload: { parameter: t10 } }) => AV(e14, { Parameters: { $push: [t10] } });
const JIt = (e14, { payload: { index: t10, direction: n10 } }) => {
  const { Parameters: r10 } = e14;
  const o10 = r10[t10];
  if ("up" === n10 && t10 > 0) {
    const n11 = r10[t10 - 1];
    return AV(e14, { Parameters: { $splice: [[t10 - 1, 2, o10, n11]] } });
  }
  if (t10 < r10.length - 1) {
    const n11 = r10[t10 + 1];
    return AV(e14, { Parameters: { $splice: [[t10, 2, n11, o10]] } });
  }
  return e14;
};
const QIt = (e14, { payload: { index: t10 } }) => AV(e14, { Parameters: { $splice: [[t10, 1]] } });
const e_t = (e14, { payload: { style: t10 } }) => AV(e14, { StyleSheet: { $push: [t10] } });
const t_t = (e14, { payload: { className: t10 } }) => {
  const n10 = e14.StyleSheet.reduce((e15, n11) => (n11.Parent === t10 && e15.push(n11.ClassName), e15), [t10]);
  const r10 = __spreadValues({}, e14.Sections);
  for (const e15 of Object.values(r10)) for (const t11 of Object.values(e15.Controls)) if (t11.hasOwnProperty("Style")) {
    const { Style: e16 } = t11;
    n10.includes(e16.ClassName) && (t11.Style = { ClassName: "Normal" });
  }
  const o10 = e14.StyleSheet.filter((e15) => !n10.includes(e15.ClassName));
  return AV(e14, { StyleSheet: { $set: o10 }, Sections: { $set: r10 } });
};
const n_t = "documentItems-RPX:Report";
const r_t = { type: "Report", defaultModel: IIt, init: (e14, t10, n10, r10 = IIt) => __spreadProps(__spreadValues(__spreadValues({}, r10), n10), { PageSettings: __spreadValues(__spreadValues({}, r10.PageSettings), n10 == null ? void 0 : n10.PageSettings), Sections: _It(r10.Sections, t10), GroupsOrder: [...r10.GroupsOrder], Name: e14 }), icon: nf(Hae), getReducer: (e14) => {
  const t10 = nz.of(e14).of("rpx");
  const n10 = t10.getReducer;
  const r10 = $It(["Sections"], n10);
  const o10 = zIt(["Sections"], n10);
  const a10 = t10.getDefaultReducer();
  const { addSectionsReducer: i10, removeSectionsByPathReducer: s10, removeSectionsBySelectionReducer: l10 } = ZIt(t10);
  const c10 = (e15) => {
    const n11 = sit(e15);
    if (!n11) return null;
    const r11 = t10.getFeature(n11.Type, "getRectangle");
    return r11 == null ? void 0 : r11(n11, { Width: e15.PrintWidth });
  };
  const u10 = (e15, n11 = false) => {
    const r11 = n11 ? ((e16) => {
      const t11 = [];
      if (rj(e16)) return t11;
      const n12 = Object.values(e16.Sections).find((e17) => e17.$primary);
      return Object.values(n12.Controls).forEach((e17) => {
        "leaf" === e17.$selected && t11.push(e17);
      }), t11;
    })(e15) : iit(e15);
    return r11.map((e16) => {
      var _a2;
      return { place: ((_a2 = t10.getFeature(e16.Type, "getRectangle")) == null ? void 0 : _a2(e16)) || { Left: 0, Top: 0, Width: 0, Height: 0 }, path: e16.$path };
    });
  };
  const d10 = (e15) => (t11, { payload: { alignTo: n11 } }) => {
    const r11 = c10(t11);
    if (!r11) return t11;
    const o11 = u10(t11, "vertical" === e15);
    if (o11.length <= 1) return t11;
    const a11 = "horizontal" === e15 ? o11.map((e16) => Y4(e16, r11, n11)) : o11.map((e16) => K4(e16, r11, n11));
    let i11 = t11;
    return a11.forEach((e16) => {
      const { Left: t12, Top: n12 } = e16.place;
      i11 = v10(g10)(i11, Mtt({ left: t12, top: n12 }, e16.path));
    }), i11;
  };
  const p10 = (e15, t11, n11, r11, o11) => t11.map((t12) => o11 ? q4(e15, t12, n11, r11, true) : q4(e15, t12, n11, r11));
  const m10 = (t11) => (n11, { payload: { spacingAdjustment: r11 } }) => {
    const o11 = c10(n11);
    if (!o11) return n11;
    const a11 = u10(n11, "vertical" === t11);
    if (a11.length <= 1) return n11;
    const i11 = ((e15) => {
      const t12 = sit(e15);
      if (t12) return t12.$path;
    })(n11);
    const { userPreferences: { surface: { gridSize: s11 } } } = KO.of(e14);
    const l11 = { place: __spreadValues({}, o11), path: i11 };
    const d11 = L$.parseSafe(s11).toTwips;
    const m11 = "horizontal" === t11 ? ((e15, t12, n12, r12) => {
      switch (n12) {
        case "equal":
          return G4("horizontal", e15);
        case "remove":
          return U4("horizontal", e15);
        case "increase":
          return p10("horizontal", e15, t12, r12);
        case "decrease":
          return p10("horizontal", e15, t12, r12, true);
        default:
          return e15;
      }
    })(a11, l11, r11, d11) : ((e15, t12, n12, r12) => {
      switch (n12) {
        case "equal":
          return G4("vertical", e15);
        case "remove":
          return U4("vertical", e15);
        case "increase":
          return p10("vertical", e15, t12, r12);
        case "decrease":
          return p10("vertical", e15, t12, r12, true);
        default:
          return e15;
      }
    })(a11, l11, r11, d11);
    let h11 = n11;
    return m11.forEach((e15) => {
      const { Left: t12, Top: n12 } = e15.place;
      h11 = v10(g10)(h11, Mtt({ left: t12, top: n12 }, e15.path));
    }), h11;
  };
  const h10 = WV(0, { [sB.type]: jV(lj, xHt), [lB.type]: jV(lj, xHt), [wtt.type]: (e15, t11) => {
    const n11 = Object.values(e15.Sections).find((e16) => "Detail" === e16.Type);
    if (!n11) throw new Error("Rpx report without details section detected!");
    const o11 = __spreadProps(__spreadValues({}, t11), { meta: __spreadProps(__spreadValues({}, t11.meta), { path: n11.$path }) });
    return r10(e15, o11);
  }, [Ett.type]: i10, [Pat.type]: YIt, [Nat.type]: KIt, [Dat.type]: GIt, [Lat.type]: UIt, [Hat.type]: XIt, [Iat.type]: JIt, [_at.type]: QIt, [Vat.type]: e_t, [Rat.type]: t_t, [Oat.type]: (t11) => {
    const { surface: { gridSize: n11 } } = KO.of(e14).userPreferences;
    const r11 = L$.parse(n11).toTwips;
    const o11 = u10(t11);
    let a11 = t11;
    return o11.forEach((e15) => {
      const { Left: t12, Top: n12 } = e15.place;
      a11 = g10(a11, Mtt({ left: Z4(t12, r11), top: Z4(n12, r11) }, e15.path));
    }), a11;
  }, [Bat.type]: (t11) => {
    const { surface: { gridSize: n11 } } = KO.of(e14).userPreferences;
    const r11 = L$.parse(n11).toTwips;
    const o11 = u10(t11);
    let a11 = t11;
    return o11.forEach((e15) => {
      const { Width: t12, Height: n12, Left: o12, Top: i11 } = e15.place;
      a11 = g10(a11, Mtt({ left: Z4(o12, r11), top: Z4(i11, r11) }, e15.path)), a11 = g10(a11, ktt({ height: Z4(n12, r11, false), width: Z4(t12, r11, false) }, e15.path));
    }), a11;
  }, [Aat.type]: (e15, { payload: { correlateHeight: t11, correlateWidth: n11 } }) => {
    const r11 = c10(e15);
    if (!r11) return e15;
    const { Width: o11, Height: a11 } = r11;
    let i11 = e15;
    return t11 && a11 && (i11 = v10(g10)(i11, ktt({ height: a11 }))), n11 && o11 && (i11 = v10(g10)(i11, ktt({ width: o11 }))), i11;
  }, [Ltt.type]: d10("horizontal"), [Htt.type]: d10("vertical"), [_tt.type]: m10("horizontal"), [Itt.type]: m10("vertical") }, a10);
  const f10 = (e15) => WV(0, { [sB.type]: jV(lj, wHt, e15), [lB.type]: EHt(e15), [cB.type]: FHt(e15, oit), [Ett.type]: i10, [Ftt.type]: GV(WIt, s10, l10) }, e15);
  const g10 = GV(WIt, GV(jIt, h10, f10(r10)), GV(rj, h10, f10(o10)));
  const y10 = /* @__PURE__ */ ((e15) => (t11) => (n11, r11) => {
    var _a2;
    const o11 = t11(n11, r11);
    if (o11 !== n11 && ((_a2 = r11 == null ? void 0 : r11.meta) == null ? void 0 : _a2.checkCrossSectionItemGeometry)) {
      const t12 = e15.getFeature(o11.Type, "getChildren")(o11);
      const n12 = {};
      const r12 = (t12.length - 1) / 2 - 1;
      if (t12.forEach((a11, i11) => {
        if (i11 > r12) return;
        const [, s11] = a11.$path.split(".");
        const l11 = Object.values(a11.Controls).filter((t13) => e15.getFeature(t13.Type, "isCrossSectionItem"));
        l11.forEach((e16) => {
          const r13 = t12[t12.length - 1 - i11].Height;
          const [, a12] = e16.$path.split("Controls.");
          e16.Bottom > r13 && j0(n12, `Sections.${s11}.Controls.${a12}.Bottom`, { $set: r13 }), e16.Right > o11.PrintWidth && j0(n12, `Sections.${s11}.Controls.${a12}.Right`, { $set: o11.PrintWidth });
        });
      }), n12) return AV(o11, n12);
    }
    return o11;
  })(t10);
  const v10 = qIt(t10);
  return v10(y10(g10));
}, getProperties: () => AIt, getContextActions: (e14, t10, n10) => {
  var _a2, _b2;
  const { lockLayout: r10 } = KO.of(t10);
  if (r10) return [...WDt(e14, t10, n10)];
  const o10 = az.of(t10);
  const a10 = o10.getNextDocumentItemName("GroupHeader");
  const i10 = o10.getNextDocumentItemName("GroupFooter");
  const s10 = o10.getNextDocumentItemName("ReportHeader");
  const l10 = o10.getNextDocumentItemName("ReportFooter");
  const c10 = o10.getNextDocumentItemName("PageHeader");
  const u10 = o10.getNextDocumentItemName("PageFooter");
  const d10 = Object.values(e14.Sections).filter((e15) => "ReportHeader" === e15.Type || "ReportFooter" === e15.Type || "PageFooter" === e15.Type || "PageHeader" === e15.Type);
  const p10 = (_a2 = d10.find((e15) => "ReportHeader" === e15.Type || "ReportFooter" === e15.Type)) == null ? void 0 : _a2.$path;
  const m10 = (_b2 = d10.find((e15) => "PageHeader" === e15.Type || "PageFooter" === e15.Type)) == null ? void 0 : _b2.$path;
  const h10 = { type: "button", icon: nf(p10 ? HIt : LIt), key: p10 ? "contextActions-RPX:labels.deleteReportHeaderFooter" : "contextActions-RPX:labels.addReportHeaderFooter", textKey: p10 ? "contextActions-RPX:labels.deleteReportHeaderFooter" : "contextActions-RPX:labels.addReportHeaderFooter", action: p10 ? Ftt(p10) : Ett({ type: "report", headerName: s10, footerName: l10 }) };
  const f10 = { type: "button", icon: nf(m10 ? DIt : NIt), key: m10 ? "contextActions-RPX:labels.deletePageHeaderFooter" : "contextActions-RPX:labels.addPageHeaderFooter", textKey: m10 ? "contextActions-RPX:labels.deletePageHeaderFooter" : "contextActions-RPX:labels.addPageHeaderFooter", action: m10 ? Ftt(m10) : Ett({ type: "page", headerName: c10, footerName: u10 }) };
  const g10 = { type: "button", icon: nf(PIt), key: "contextActions-RPX:labels.addGroupHeaderFooter", textKey: "contextActions-RPX:labels.addGroupHeaderFooter", action: Ett({ type: "group", headerName: a10, footerName: i10 }) };
  return [...WDt(e14, t10, n10), { type: "group", key: "contextActions-RPX:labels.report", actions: [h10, f10, g10] }];
}, labelKey: n_t, features: { getChildren: (e14) => xat(Object.values(e14.Sections), e14.GroupsOrder), getName: (e14, t10) => t10(n_t), disableCopy: true } };
const [o_t] = Dp("rpx-reportinfo-item");
const a_t = Z.Dsl.resultOf(kat.Control.decode({ Name: "ReportInfo1", Type: "ReportInfo" }));
const i_t = [cnt.Name, cnt.Tag, cnt.Left, cnt.Top, cnt.Width, cnt.Height, cnt.Visible, unt, ...mnt, stt(Ktt, "culture", "enum", "Culture", void 0, { enumKey: "culture" }), stt(Ktt, "calendar", "enum", "Calendar", void 0, { enumKey: "calendar" }), stt(Jtt, "summaryRunning", "enum", "SummaryRunning", "both", { enumKey: "summary_running" }), stt(Jtt, "summaryGroup", "string", "SummaryGroup"), stt(Utt, "formatString", "rpx_format_string", "FormatString"), stt(qtt, "multiLine", "boolean", "MultiLine"), stt(qtt, "canGrow", "boolean", "CanGrow"), stt(qtt, "canShrink", "boolean", "CanShrink"), stt(qtt, "rightToLeft", "boolean", "RightToLeft")];
const s_t = [dnt.ClassName, dnt.BackColor, dnt.ForeColor, dnt.FontFamily, dnt.FontSize, dnt.FontWeight, dnt.FontStyle, dnt.FontUnderline, dnt.FontLinethrough, dnt.TextAlign, dnt.VerticalAlign, dnt.WordWrap];
const l_t = ({ Top: e14, Left: t10, Width: n10, Height: r10 }) => ({ Top: e14, Left: t10, Width: n10, Height: r10 });
const c_t = { type: "ReportInfo", defaultModel: a_t, glyph: (e14) => {
  const { documentItem: t10, documentItem: { RightToLeft: n10, Name: r10, Style: o10, Border: a10, MultiLine: i10 } } = e14;
  const s10 = kLt(o10);
  const l10 = ep.useMemo(() => YDt(a10), [a10]);
  const c10 = ep.useMemo(() => __spreadProps(__spreadValues(__spreadValues({}, s10), l10), { textAlign: SLt(s10.textAlign, n10), writingMode: CLt(s10.writingMode, n10), justifyContent: SLt(s10.textAlign, n10), wordBreak: xLt(s10.wordBreak, i10) }), [s10, l10, n10, i10]);
  return tp.createElement(tp.Fragment, null, rj(t10) && tp.createElement(Kmt, { documentItem: t10, withMover: true, withGrips: true, dataPath: t10.$path }), tp.createElement("div", { className: o_t, style: c10 }, r10));
}, init: (e14, t10, n10, r10) => {
  const o10 = r10 || a_t;
  return __spreadProps(__spreadValues(__spreadValues({}, o10), n10), { Style: __spreadValues(__spreadValues({}, o10.Style), n10 == null ? void 0 : n10.Style), Name: e14 });
}, getProperties: (e14, t10) => "Style" === (t10 == null ? void 0 : t10[0]) ? s_t : i_t, getContextActions: WDt, getReducer: (e14) => WV(0, {}, nz.of(e14).of("rpx").getDefaultReducer()), icon: nf(mae), icon24: nf(hae), nameTemplateKey: "nameTemplate-RPX:ReportInfo", labelKey: "documentItems-RPX:ReportInfo", features: { setRectangle: (e14, t10) => __spreadProps(__spreadValues({}, e14), { Left: t10.Left, Top: t10.Top, Width: t10.Width, Height: t10.Height }), getBoundingBox: l_t, getRectangle: l_t } };
const [u_t] = Dp("rpx-rich-text");
const d_t = Z.Dsl.resultOf(kat.Control.decode({ Name: "RichTextBox1", Type: "RichTextBox" }));
const p_t = [...pnt, ...mnt, stt(Utt, "backColor", "color", "BackColor"), stt(qtt, "autoReplaceFields", "boolean", "AutoReplaceFields"), stt(qtt, "canGrow", "boolean", "CanGrow"), stt(qtt, "canShrink", "boolean", "CanShrink"), stt(qtt, "maxLength", "number", "MaxLength", void 0, { numberType: "Integer", minValue: 0, step: 1 }), stt(Ktt, "htmlValue", "string", "Data"), stt(Qtt, "MultiLine", "boolean", "MultiLine")];
const m_t = ({ Top: e14, Left: t10, Width: n10, Height: r10 }) => ({ Top: e14, Left: t10, Width: n10, Height: r10 });
const h_t = { type: "RichTextBox", defaultModel: d_t, glyph: (e14) => {
  const { documentItem: t10, parentBackgroundColor: n10, documentItem: { Data: r10, BackColor: o10, Border: a10 } } = e14;
  const i10 = __spreadProps(__spreadValues({}, ep.useMemo(() => YDt(a10), [a10])), { backgroundColor: "Transparent" !== o10 ? o10 : n10 });
  return tp.createElement(tp.Fragment, null, rj(t10) && tp.createElement(Kmt, { documentItem: t10, withMover: true, withGrips: true, dataPath: t10.$path }), tp.createElement("div", { className: u_t, style: i10 }, r10));
}, init: (e14, t10, n10, r10) => __spreadProps(__spreadValues(__spreadValues({}, r10 || d_t), n10), { Name: e14 }), getProperties: () => p_t, getContextActions: WDt, getReducer: (e14) => WV(0, {}, nz.of(e14).getDefaultReducer()), icon: nf(fae), icon24: nf(gae), nameTemplateKey: "nameTemplate-RPX:RichTextBox", labelKey: "documentItems-RPX:RichTextBox", features: { setRectangle: (e14, t10) => __spreadProps(__spreadValues({}, e14), { Left: t10.Left, Top: t10.Top, Width: t10.Width, Height: t10.Height }), getBoundingBox: m_t, getRectangle: m_t } };
const f_t = (e14, t10, n10) => WDt(e14, t10, n10);
const g_t = Z.Dsl.resultOf(kat.Section.decode({ Name: "section" }));
const y_t = (e14) => (t10, n10, r10, o10 = g_t) => __spreadProps(__spreadValues(__spreadValues({}, o10), r10), { Type: e14, Name: t10 });
const v_t = stt(Ytt, "name", "name", "Name");
const b_t = stt(Xtt, "height", "rpx_dimensions", "Height", void 0, { minValue: L$.parse("0in"), maxValue: L$.parse("10000in"), checkSectionGeometry: true, checkCrossSectionItemGeometry: true });
const S_t = stt(Utt, "backColor", "color", "BackColor");
const C_t = stt(qtt, "canGrow", "boolean", "CanGrow");
const x_t = stt(qtt, "canShrink", "boolean", "CanShrink");
const w_t = stt(qtt, "columnCount", "number", "ColumnCount", void 0, { numberType: "Integer", minValue: 1, step: 1 });
const T_t = stt(qtt, "columnDirection", "enum", "ColumnDirection", void 0, { enumKey: "column_direction" });
const E_t = stt(qtt, "columnSpacing", "number", "ColumnSpacing", void 0, { numberType: "Float", minValue: 0 });
const F_t = stt(qtt, "colKeepTogether", "boolean", "ColKeepTogether");
const M_t = stt(qtt, "columnLayout", "boolean", "ColumnLayout");
const k_t = stt(qtt, "groupKeepTogether", "enum", "GroupKeepTogether", void 0, { enumKey: "group_keep_together" });
const P_t = stt(qtt, "keepTogether", "boolean", "KeepTogether");
const N_t = stt(qtt, "newColumn", "enum", "NewColumn", void 0, { enumKey: "new_column" });
const D_t = stt(qtt, "newPage", "enum", "NewPage", void 0, { enumKey: "new_page" });
const L_t = stt(qtt, "printAtBottom", "boolean", "PrintAtBottom");
const H_t = stt(qtt, "repeatStyle", "enum", "RepeatStyle", void 0, { enumKey: "repeat_style" });
const I_t = stt(qtt, "repeatToFill", "boolean", "RepeatToFill");
const __t = stt(qtt, "underlayNext", "boolean", "UnderlayNext");
const V_t = stt(qtt, "visible", "boolean", "Visible");
const R_t = stt(Ktt, "dataField", "rpx_data_field", "DataField");
const A_t = stt(Ktt, "tag", "string", "Tag");
const O_t = [v_t, b_t, S_t, C_t, x_t, D_t, V_t, A_t];
const B_t = [v_t, b_t, S_t, C_t, x_t, V_t, A_t];
const z_t = [v_t, b_t, S_t, C_t, x_t, F_t, M_t, k_t, P_t, N_t, D_t, H_t, __t, V_t, R_t, A_t];
const $_t = [v_t, b_t, S_t, C_t, x_t, w_t, T_t, E_t, P_t, N_t, D_t, I_t, V_t, A_t];
const W_t = [v_t, b_t, S_t, C_t, x_t, M_t, P_t, N_t, D_t, L_t, V_t, A_t];
const j_t = [v_t, b_t, S_t, C_t, x_t, V_t, A_t];
const Z_t = [v_t, b_t, S_t, C_t, x_t, P_t, D_t, L_t, V_t, A_t];
const G_t = (e14) => (t10) => (n10, r10) => {
  var _a2;
  const o10 = t10(n10, r10);
  if (o10 !== n10 && ((_a2 = r10 == null ? void 0 : r10.meta) == null ? void 0 : _a2.checkSectionGeometry)) {
    const t11 = function(e15, t12) {
      return Object.values(e15.Controls).reduce((e16, n11) => {
        const r11 = t12.getFeature(n11.Type, "getRectangle");
        if (!r11) return e16;
        const o11 = r11(n11, { Top: 0, Left: 0, Width: 0, Height: 0 });
        const a10 = o11.Top + o11.Height;
        return Math.max(e16, a10);
      }, 0);
    }(o10, e14);
    if (t11 > o10.Height) return __spreadProps(__spreadValues({}, o10), { Height: Iet(t11) });
  }
  return o10;
};
const U_t = (e14) => {
  const t10 = {};
  const n10 = {};
  return Object.entries(e14.Controls).forEach(([e15, r10]) => {
    r10.$selected ? t10[e15] = r10 : n10[e15] = r10;
  }), { selectedReportItems: t10, unSelectedReportItems: n10 };
};
const q_t = (e14) => {
  const { selectedReportItems: t10, unSelectedReportItems: n10 } = U_t(e14);
  return AV(e14, { Controls: { $set: __spreadValues(__spreadValues({}, t10), n10) } });
};
const Y_t = (e14) => {
  const { selectedReportItems: t10, unSelectedReportItems: n10 } = U_t(e14);
  return AV(e14, { Controls: { $set: __spreadValues(__spreadValues({}, n10), t10) } });
};
const K_t = (e14) => {
  const t10 = nz.of(e14).of("rpx");
  const n10 = t10.getReducer;
  const r10 = $It(["Controls"], n10);
  const o10 = zIt(["Controls"], n10);
  const a10 = t10.getDefaultReducer();
  const { addControlReducer: i10, removeControlByPathReducer: s10, removeControlBySelectionReducer: l10 } = /* @__PURE__ */ function(e15) {
    return { addControlReducer: (t11, { payload: n11 }) => {
      const { id: r11, type: o11, name: a11, properties: i11, templateId: s11 } = n11;
      const l11 = e15.create(o11, a11, s11, i11);
      return l11.$path = `${t11.$path}.Controls.${r11}`, l11.Left = Iet(l11.Left), l11.Top = Iet(l11.Top), __spreadProps(__spreadValues({}, t11), { Controls: __spreadProps(__spreadValues({}, t11.Controls), { [r11]: l11 }) });
    }, removeControlByPathReducer: (e16, t11) => {
      var _a2;
      const n11 = (_a2 = t11.meta) == null ? void 0 : _a2.path;
      if (!n11) return e16;
      const r11 = n11.split(".");
      const o11 = r11[r11.length - 1];
      const a11 = e16.Controls;
      if (!o11 || !(o11 in a11)) return e16;
      const i11 = __spreadValues({}, a11);
      delete i11[o11];
      const s11 = rj(a11[o11]);
      const l11 = ij(a11[o11]);
      const c11 = Object.values(i11).some(rj);
      if (s11 && (!c11 || l11)) {
        const t12 = lj(__spreadProps(__spreadValues({}, e16), { Controls: i11 }));
        return t12.$primary = l11, t12.$selected = "leaf", t12;
      }
      return __spreadProps(__spreadValues({}, e16), { Controls: i11 });
    }, removeControlBySelectionReducer: (e16) => {
      const t11 = __spreadValues({}, e16.Controls);
      let n11 = false;
      for (const [r11, o11] of Object.entries(e16.Controls)) rj(o11) && (n11 = true, delete t11[r11]);
      return n11 ? __spreadProps(__spreadValues({}, e16), { Controls: t11, $selected: "leaf" }) : e16;
    } };
  }(t10);
  const c10 = WV(0, { [wtt.type]: i10, [Dtt.type]: (e15, { payload: { pasteId: t11, pasteCount: n11 } }) => __spreadProps(__spreadValues({}, e15), { $pasteId: t11, $pasteCount: n11 }) }, a10);
  const u10 = (e15) => WV(0, { [wtt.type]: i10, [Ttt.type]: GV(WIt, s10, l10), [sB.type]: jV(wHt, e15), [lB.type]: EHt(e15), [Vtt.type]: q_t, [Rtt.type]: Y_t }, e15);
  const d10 = GV(WIt, GV(jIt, c10, u10(r10)), GV(rj, c10, u10(o10)));
  return G_t(t10)(d10);
};
const X_t = "documentItems-RPX:Detail";
const J_t = { type: "Detail", defaultModel: g_t, init: y_t("Detail"), icon: nf(Oae), getReducer: K_t, getProperties: () => $_t, getContextActions: f_t, nameTemplateKey: "nameTemplate-RPX:Detail", labelKey: X_t, features: { getChildren: (e14) => Object.values(e14.Controls), getName: (e14, t10) => t10(X_t), disableCopy: true } };
const Q_t = "documentItems-RPX:PageHeader";
const eVt = { type: "PageHeader", defaultModel: g_t, init: y_t("PageHeader"), icon: nf(Aae), getReducer: K_t, getProperties: () => B_t, getContextActions: f_t, nameTemplateKey: "nameTemplate-RPX:PageHeader", labelKey: Q_t, features: { getChildren: (e14) => Object.values(e14.Controls), getName: (e14, t10) => t10(Q_t), canContainCrossSectionItems: true, disableCopy: true } };
const tVt = "documentItems-RPX:PageFooter";
const nVt = { type: "PageFooter", defaultModel: g_t, init: y_t("PageFooter"), icon: nf(Bae), getReducer: K_t, getProperties: () => j_t, getContextActions: f_t, nameTemplateKey: "nameTemplate-RPX:PageFooter", labelKey: tVt, features: { getChildren: (e14) => Object.values(e14.Controls), getName: (e14, t10) => t10(tVt), disableCopy: true } };
const rVt = "documentItems-RPX:GroupHeader";
const oVt = { type: "GroupHeader", defaultModel: g_t, init: y_t("GroupHeader"), icon: nf(Aae), getReducer: K_t, getProperties: () => z_t, getContextActions: f_t, nameTemplateKey: "nameTemplate-RPX:GroupHeader", labelKey: rVt, features: { getChildren: (e14) => Object.values(e14.Controls), getName: (e14, t10) => t10(rVt), canContainCrossSectionItems: true, disableCopy: true } };
const aVt = "documentItems-RPX:GroupFooter";
const iVt = { type: "GroupFooter", defaultModel: g_t, init: y_t("GroupFooter"), icon: nf(Bae), getReducer: K_t, getProperties: () => W_t, getContextActions: f_t, nameTemplateKey: "nameTemplate-RPX:GroupFooter", labelKey: aVt, features: { getChildren: (e14) => Object.values(e14.Controls), getName: (e14, t10) => t10(aVt), disableCopy: true } };
const sVt = "documentItems-RPX:ReportHeader";
const lVt = { type: "ReportHeader", defaultModel: g_t, init: y_t("ReportHeader"), icon: nf(Aae), getReducer: K_t, getProperties: () => O_t, getContextActions: f_t, nameTemplateKey: "nameTemplate-RPX:ReportHeader", labelKey: sVt, features: { getChildren: (e14) => Object.values(e14.Controls), getName: (e14, t10) => t10(sVt), canContainCrossSectionItems: true, disableCopy: true } };
const cVt = "documentItems-RPX:ReportFooter";
const uVt = { type: "ReportFooter", defaultModel: g_t, init: y_t("ReportFooter"), icon: nf(Bae), getReducer: K_t, getProperties: () => Z_t, getContextActions: f_t, nameTemplateKey: "nameTemplate-RPX:ReportFooter", labelKey: cVt, features: { getChildren: (e14) => Object.values(e14.Controls), getName: (e14, t10) => t10(cVt), disableCopy: true } };
const [dVt, pVt] = Dp("rpx-shape-item");
const mVt = Z.Dsl.resultOf(kat.Control.decode({ Name: "Shape1", Type: "Shape" }));
const hVt = [cnt.Name, cnt.Visible, cnt.Tag, cnt.Left, cnt.Top, cnt.Width, cnt.Height, stt(Utt, "shape", "shape", "Shape", void 0, { enumKey: "shape_style" }), stt(Utt, "backgroundStyle", "background_style", "BackgroundStyle", void 0, { enumKey: "background_style" }), stt(Utt, "gradientStyle", "gradient_style", "GradientStyle", void 0, { enumKey: "gradient_style" }), stt(Utt, "backgroundPattern", "background_pattern", "BackgroundPattern", void 0, { enumKey: "hatch_style" }), stt(Utt, "backColor", "color", "BackColor"), stt(Utt, "backColor2", "color", "BackColor2"), stt(Utt, "lineColor", "color", "LineColor"), stt(Utt, "lineStyle", "rpx_line_style", "LineStyle", void 0, { enumKey: "line_style" }), stt(Utt, "lineWeight", "number", "LineWeight", void 0, { numberType: "Float", step: 1 }), stt(Utt, "roundingRadius", "radius", "Radius")];
const fVt = { Solid: ["BackColor2", "GradientStyle", "BackgroundPattern"], Gradient: ["BackgroundPattern"], Pattern: ["GradientStyle"] };
const gVt = { Rectangle: ["Radius"], RoundRect: [], Ellipse: ["Radius"] };
const yVt = ({ Top: e14, Left: t10, Width: n10, Height: r10 }) => ({ Top: e14, Left: t10, Width: n10, Height: r10 });
const vVt = { type: "Shape", defaultModel: mVt, glyph: (e14) => {
  const t10 = ep.useRef(null);
  const { documentItem: n10, documentItem: { Shape: r10, BackColor: o10, BackColor2: a10, LineColor: i10, LineStyle: s10, LineWeight: l10, BackgroundStyle: c10, BackgroundPattern: u10, GradientStyle: d10, Width: p10, Height: m10, Radius: { Default: h10, TopLeft: f10, TopRight: g10, BottomRight: y10, BottomLeft: v10 } } } = e14;
  const b10 = kp(dVt, { [pVt("ellipse")]: "Ellipse" === r10 });
  let S10 = { backgroundColor: o10, borderWidth: GDt(l10), borderColor: i10, borderStyle: ZDt(s10) };
  if ("RoundRect" === r10) {
    const e15 = L$.fromTwips(p10 > m10 ? m10 : p10, "pt").value;
    const t11 = YLt(e15, h10, f10, g10, y10, v10);
    S10 = __spreadValues(__spreadValues({}, S10), t11);
  }
  if ("Pattern" === c10) {
    const e15 = Xce(u10, a10, o10);
    S10.backgroundColor = e15.backgroundColor, S10.backgroundImage = e15.backgroundImage;
  } else "Gradient" === c10 && (S10.backgroundImage = Jce(d10, o10, a10).backgroundImage);
  return tp.createElement(tp.Fragment, null, rj(n10) && tp.createElement(Kmt, { documentItem: n10, isRounded: "RoundRect" === r10, withMover: true, withGrips: true, dataPath: n10.$path, rectRef: t10 }), tp.createElement("div", { ref: t10, className: b10, style: S10 }));
}, init: (e14, t10, n10, r10) => __spreadProps(__spreadValues(__spreadValues({}, r10 || mVt), n10), { Name: e14 }), getProperties: (e14) => {
  const t10 = [...fVt[e14.BackgroundStyle] || [], ...gVt[e14.Shape] || []];
  return hVt.filter((e15) => !t10.includes(e15.valuePath));
}, getContextActions: WDt, getReducer: (e14) => WV(0, {}, nz.of(e14).getDefaultReducer()), icon: nf(yae), icon24: nf(vae), nameTemplateKey: "nameTemplate-RPX:Shape", labelKey: "documentItems-RPX:Shape", features: { setRectangle: (e14, t10) => __spreadProps(__spreadValues({}, e14), { Left: t10.Left, Top: t10.Top, Width: t10.Width, Height: t10.Height }), getBoundingBox: yVt, getRectangle: yVt } };
const [bVt] = Dp("rpx-subreport-item");
const SVt = Z.Dsl.resultOf(kat.Control.decode({ Name: "SubReport1", Type: "SubReport" }));
const CVt = [...pnt, ...mnt, stt(qtt, "canGrow", "boolean", "CanGrow"), stt(qtt, "canShrink", "boolean", "CanShrink"), stt(Ktt, "reportName", "string", "ReportName")];
const xVt = ({ Top: e14, Left: t10, Width: n10, Height: r10 }) => ({ Top: e14, Left: t10, Width: n10, Height: r10 });
const wVt = { type: "SubReport", defaultModel: SVt, glyph: (e14) => {
  const { documentItem: t10, documentItem: { ReportName: n10, Border: r10 } } = e14;
  const o10 = ep.useMemo(() => YDt(r10), [r10]);
  return tp.createElement(tp.Fragment, null, rj(t10) && tp.createElement(Kmt, { documentItem: t10, withMover: true, withGrips: true, dataPath: t10.$path }), tp.createElement("div", { className: bVt, style: o10 }, n10));
}, init: (e14, t10, n10, r10) => __spreadProps(__spreadValues(__spreadValues({}, r10 || SVt), n10), { Name: e14 }), getProperties: () => CVt, getContextActions: WDt, getReducer: (e14) => WV(0, {}, nz.of(e14).getDefaultReducer()), icon: nf(Cae), icon24: nf(xae), nameTemplateKey: "nameTemplate-RPX:SubReport", labelKey: "documentItems-RPX:SubReport", features: { setRectangle: (e14, t10) => __spreadProps(__spreadValues({}, e14), { Left: t10.Left, Top: t10.Top, Width: t10.Width, Height: t10.Height }), getBoundingBox: xVt, getRectangle: xVt } };
const [TVt, , EVt] = Dp("rpx-textbox-item");
const [FVt, MVt] = EVt("text");
const kVt = Z.Dsl.resultOf(kat.Control.decode({ Name: "TextBox1", Type: "TextBox" }));
const PVt = [...pnt, ...mnt, snt, unt, stt(Utt, "outputFormat", "string", "OutputFormat"), stt(Utt, "characterSpacing", "number", "CharacterSpacing", void 0, { numberType: "Float", minValue: 0 }), stt(Utt, "lineSpacing", "number", "LineSpacing", void 0, { numberType: "Float", minValue: 0 }), stt(qtt, "multiLine", "boolean", "MultiLine"), stt(qtt, "canGrow", "boolean", "CanGrow"), stt(qtt, "canShrink", "boolean", "CanShrink"), stt(qtt, "rightToLeft", "boolean", "RightToLeft"), stt(qtt, "minCondenseRate", "percent", "MinCondenseRate", void 0, { scale: 1, min: 10 }), stt(Ktt, "text", "string", "Text"), stt(Ktt, "hyperLink", "string", "HyperLink"), stt(Ktt, "culture", "enum", "Culture", void 0, { enumKey: "culture" }), stt(Ktt, "calendar", "enum", "Calendar", void 0, { enumKey: "calendar" }), stt(Ktt, "countNullValues", "boolean", "CountNullValues"), stt(Jtt, "summaryType", "enum", "SummaryType", void 0, { enumKey: "summary_type" }), stt(Jtt, "summaryFunc", "enum", "SummaryFunc", void 0, { enumKey: "summary_func" }), stt(Jtt, "summaryRunning", "enum", "SummaryRunning", void 0, { enumKey: "summary_running" }), stt(Jtt, "summaryGroup", "string", "SummaryGroup"), stt(Jtt, "distinctField", "string", "DistinctField")];
const NVt = [dnt.ClassName, dnt.BackColor, dnt.ForeColor, dnt.FontFamily, dnt.FontSize, dnt.FontWeight, dnt.FontStyle, dnt.ShrinkToFit, dnt.FontUnderline, dnt.FontLinethrough, dnt.TextAlign, dnt.TextJustify, dnt.VerticalAlign, dnt.VerticalText, dnt.WordWrap];
const DVt = ({ Top: e14, Left: t10, Width: n10, Height: r10 }) => ({ Top: e14, Left: t10, Width: n10, Height: r10 });
const LVt = { type: "TextBox", defaultModel: kVt, glyph: (e14) => {
  const { documentItem: t10, parentBackgroundColor: n10, documentItem: { Text: r10, CharacterSpacing: o10, LineSpacing: a10, PaddingBottom: i10, PaddingLeft: s10, PaddingRight: l10, PaddingTop: c10, MultiLine: u10, RightToLeft: d10, Style: p10, Border: m10 } } = e14;
  const h10 = kLt(p10);
  const f10 = ep.useMemo(() => YDt(m10), [m10]);
  const g10 = ep.useMemo(() => PLt(h10, n10), [h10, n10]);
  const y10 = kp(FVt, { [MVt("rtl")]: d10 });
  const v10 = ep.useMemo(() => __spreadProps(__spreadValues(__spreadValues({}, g10), f10), { paddingBottom: i10, paddingLeft: s10, paddingRight: l10, paddingTop: c10, letterSpacing: o10, lineHeight: wLt(a10, h10.fontSize), justifyContent: SLt(h10.textAlign, d10), textAlign: SLt(h10.textAlign, d10), writingMode: CLt(h10.writingMode, d10), wordBreak: xLt(h10.wordBreak, u10) }), [g10, f10, o10, a10, i10, s10, l10, c10, d10, u10]);
  const b10 = ep.useMemo(() => bLt(r10, u10), [r10, u10]);
  return tp.createElement(tp.Fragment, null, rj(t10) && tp.createElement(Kmt, { documentItem: t10, withMover: true, withGrips: true, dataPath: t10.$path }), tp.createElement("div", { className: TVt, style: v10 }, tp.createElement("div", { className: y10 }, b10), rj(t10) && tp.createElement(vLt, { value: r10 != null ? r10 : "", valuePath: "Text", itemPath: t10.$path, itemStyles: v10 })));
}, init: (e14, t10, n10, r10) => __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, r10 || kVt), { Text: e14 }), n10), { Name: e14 }), getProperties: (e14, t10) => "Style" === (t10 == null ? void 0 : t10[0]) ? NVt : PVt, getContextActions: WDt, getReducer: (e14) => WV(0, {}, nz.of(e14).getDefaultReducer()), icon: nf(Mae), icon24: nf(kae), nameTemplateKey: "nameTemplate-RPX:TextBox", labelKey: "documentItems-RPX:TextBox", features: { setRectangle: (e14, t10) => __spreadProps(__spreadValues({}, e14), { Left: t10.Left, Top: t10.Top, Width: t10.Width, Height: t10.Height }), getBoundingBox: DVt, getRectangle: DVt } };
const HVt = { type: "Unknown", defaultModel: { Type: "Unknown" }, icon: nf(_ae), glyph: ({ documentItem: e14 }) => {
  const { Name: t10 } = e14;
  const { t: n10 } = vp("documentItems-RPX");
  const r10 = n10("captions.basicSupportReportItemInfo", "{{itemLabel}} '{{itemName}}' has limited support in design-time.", { itemLabel: "", itemName: t10 });
  return tp.createElement(tp.Fragment, null, rj(e14) && tp.createElement(Kmt, { documentItem: e14, dataPath: e14.$path }), tp.createElement("div", { className: "rpx-unknown-item" }, r10));
}, features: { getRectangle: (e14) => ({ Top: e14.Item.Top || 0, Left: e14.Item.Left || 0, Width: e14.Item.Width || 2880, Height: e14.Item.Height || 288 }) } };
const IVt = (e14) => {
  var _a2;
  return { enabled: (_a2 = e14 == null ? void 0 : e14.enabled) != null ? _a2 : true, toolBoxContent: e14 == null ? void 0 : e14.toolBoxContent };
};
function _Vt(e14) {
  const t10 = [];
  for (const { Name: n10 } of e14.CalculatedFields) t10.push(n10);
  for (const { Key: n10 } of e14.Parameters) t10.push(n10);
  for (const n10 of Object.values(e14.Sections)) {
    t10.push(n10.Name);
    for (const e15 of Object.values(n10.Controls)) t10.push(e15.Name);
  }
  return t10;
}
const VVt = (e14) => {
  var _a2, _b2, _c2;
  const { instanceId: t10 = "ar-web-designer", appResources: n10, resourceBundles: r10, settings: o10, mutableAppSettings: a10 = {}, focusTimer: i10, title: s10, onPreferencesChange: l10, useInlineThemeCSS: c10 } = e14;
  const u10 = false !== ((_a2 = o10 == null ? void 0 : o10.rpx) == null ? void 0 : _a2.enabled);
  HO("enums", MDt), u10 && HO("enums-RPX", itt);
  const d10 = KO(t10, o10, { rpx: IVt, rdlx: NDt }, a10);
  _$(d10.units);
  const p10 = nz(t10);
  const m10 = p10.registerDocumentType("rdlx");
  var h10;
  if (p10.useDocumentType("rdlx"), (h10 = m10).registerDefaults(BTt), h10.register(IPt), h10.register(yNt), h10.register(eFt), h10.register(oFt), h10.register(FDt), h10.register(ySt), h10.register(JSt), h10.register($vt), h10.register(pvt), h10.register(gvt), h10.register(jvt), h10.register(Cvt), h10.register(pCt), h10.register(_xt), h10.register($xt), h10.register(TCt), h10.register(sxt), h10.register(rxt), h10.register(oxt), h10.register(XCt), h10.register(zCt), h10.register($Ct), h10.register(jCt), h10.register(ZCt), h10.register(WCt), h10.register(BCt), h10.register(Rxt), h10.register(Oxt), h10.register(nwt), h10.register(xPt), h10.register(Clt), h10.register(DPt), h10.register(APt), h10.register(EEt), h10.register(hNt), h10.register(GTt), h10.register(KTt), h10.register(DEt), h10.register(zNt), h10.register(gDt), h10.register(iPt), h10.register(Xkt), h10.register(pPt), h10.register(bkt), h10.register(J5), h10.register(S4), h10.register(H4), h10.register(g4), h10.register(p4), h10.register(R4), h10.register(Ekt), h10.register(I4e), h10.register(M5e), h10.register(F5e), h10.register($J), h10.register(WJ), h10.register(kkt), h10.register(TNt), h10.register(DFt), h10.register(RFt), h10.register(INt), h10.register(hwt), h10.register(sct), h10.register(gct), h10.register(SFt), h10.register(EFt), h10.register(QPt), h10.register(nNt), h10.register(sNt), h10.register(_Tt), h10.register(ATt), h10.register(uNt), h10.register(dNt), h10.register($Et), h10.register(UEt), p10.registerTemplates(Wgt, zgt, jgt, (_b2 = o10 == null ? void 0 : o10.rdlx) == null ? void 0 : _b2.initTemplates, $gt), u10) {
    const e15 = p10.registerDocumentType("rpx");
    p10.useDocumentType("rpx"), function(e16) {
      e16.registerDefaults(PHt), e16.register(HVt), e16.register(rIt), e16.register(hIt), e16.register(SIt), e16.register(kIt), e16.register(r_t), e16.register(c_t), e16.register(yLt), e16.register(qLt), e16.register(cHt), e16.register(hHt), e16.register(h_t), e16.register(J_t), e16.register(eVt), e16.register(nVt), e16.register(oVt), e16.register(iVt), e16.register(lVt), e16.register(uVt), e16.register(vVt), e16.register(wVt), e16.register(LVt), e16.register(qHt), e16.register(zHt);
    }(e15), p10.registerTemplates(HDt, LDt, IDt, (_c2 = o10 == null ? void 0 : o10.rpx) == null ? void 0 : _c2.initTemplates);
  }
  const f10 = __spreadValues({}, pG);
  n10 && Object.keys(n10).forEach((e15) => {
    f10[e15] = __spreadValues(__spreadValues({}, f10[e15] || {}), n10[e15]);
  });
  const g10 = ((e15 = "en", t11) => dG.createInstance({ lng: e15, fallbackLng: "en", resources: t11, interpolation: { escapeValue: false } }, (e16) => {
    if (e16) throw new Error(`Failed to init localization engine: ${e16}`);
  }))(d10.language, f10);
  r10 && r10.forEach(({ lng: e15, ns: t11, resources: n11 }) => g10.addResourceBundle(e15, t11, n11, true)), ((e15) => {
    mG = e15;
  })(g10);
  const y10 = az(t10, g10.t.bind(g10));
  u10 && y10.registerDocumentType("rpx", _Vt), y10.registerDocumentType("rdlx", () => []), tGe.create(t10, g10.t.bind(g10));
  return { props: { identifiers: { instanceId: t10, containerId: `${t10}-container`, sidebarControlsId: `${t10}-sb-controls` }, title: s10, focusTimer: i10, i18n: g10, coreContext: { instanceId: t10 }, settings: d10, onPreferencesChange: l10, useInlineThemeCSS: c10 } };
};
const RVt = (e14) => {
  const { value: t10, setProperty: n10, descriptor: r10 } = e14;
  const o10 = { value: dm.fromString(t10), palettes: [{ name: "Standard Colors", colors: Aie }], onSelect: (e15) => {
    n10(r10, e15);
  }, opacity: true };
  return tp.createElement(xH, __spreadValues({}, o10));
};
const [AVt, , OVt] = Dp("theme-color-editor");
const [BVt] = OVt("preview");
const zVt = (e14) => tp.createElement("div", { className: kp("gc-color__main", BVt), style: { backgroundColor: e14 } });
_D((e14) => {
  const { descriptor: t10, value: n10, setProperty: r10 } = e14;
  const { API: o10 } = ep.useContext(Sm);
  const [a10, i10] = ep.useState(n10);
  ep.useEffect(() => {
    i10(n10);
  }, [n10]);
  const s10 = ep.useCallback(() => o10.current.dropdowns.open(null), [o10]);
  const l10 = ep.useCallback((e15, n11) => {
    const o11 = n11.hex8;
    i10(o11), r10(t10, o11), s10();
  }, [t10, s10, r10]);
  const c10 = __spreadProps(__spreadValues({}, e14), { setProperty: l10 });
  const u10 = ep.useCallback(({ target: { value: e15 } }) => {
    i10(e15), s10();
  }, [s10]);
  const d10 = ep.useCallback((e15) => {
    if (e15.target.value === n10) return;
    const o11 = ((e16) => e16.startsWith("#") ? e16 : dm.fromString(e16).hex8)(e15.target.value);
    r10(t10, o11), i10(o11);
  }, [t10, r10, n10]);
  const p10 = { value: a10, block: true, size: "small", menuWidth: "auto", openOnFocus: false, content: tp.createElement(RVt, __spreadValues({}, c10)), placeholder: "<Empty>", onChange: u10, onBlur: d10, generatePreview: zVt, customCSS: AVt };
  return tp.createElement(tM, __spreadValues({}, p10));
});
const [$Vt, , WVt] = Dp("theme-editor-line");
WVt("block"), _D(_L), _D(XD), HD(XD), Dp("wd-theme-dialog");
const [jVt, , ZVt] = Dp("wd-add-rows-columns-dialog");
const [GVt] = ZVt("editors");
const UVt = HD(_L);
const qVt = HD(AL);
const YVt = (e14) => {
  const { onSave: t10, isRow: n10, positionEnum: r10 } = e14;
  const { dispatch: o10, closeDialog: a10 } = RA();
  const [i10, s10] = ep.useState(1);
  const [l10, c10] = ep.useState(r10[0].value);
  const { t: u10 } = vp("dialogs");
  const { t: d10 } = vp();
  const p10 = r10.map(({ value: e15, name: t11 }) => ({ value: e15, name: d10(t11) }));
  const m10 = { open: true, title: n10 ? u10("headingInsertRows", "Insert Rows") : u10("headingInsertColumns", "Insert Columns"), customCSS: kp("gc-message-box", jVt), shouldCloseOnOverlayClick: false, shouldCloseOnEsc: true, onClose: a10, controls: { align: "right", buttons: [{ accent: "full", text: u10("btnInsert", "Insert"), onClick: () => {
    o10(t10(i10, l10)), a10();
  } }, { accent: "none", text: u10("btnCancel", "Cancel"), onClick: () => {
    a10();
  } }] } };
  const h10 = { descriptor: $N("", u10("labelCount", "Count"), "", ""), setProperty: (e15, t11) => s10(t11), value: i10, id: "count-editor", minValue: 1, maxValue: 20, step: 1, titleIncrease: "+1", titleDecrease: "-1" };
  const f10 = { descriptor: $N("", u10("labelPosition", "Position"), "", ""), setProperty: (e15, t11) => c10(t11), value: l10, friendlyEnum: { values: p10.map((e15) => e15.value), friendlyNames: p10 } };
  return tp.createElement(Hk, __spreadValues({}, m10), tp.createElement("div", { className: kp("gc-modal__message", GVt) }, tp.createElement(UVt, __spreadValues({}, h10)), tp.createElement(qVt, __spreadValues({}, f10))));
};
const KVt = (e14 = "") => e14.startsWith('"') && e14.endsWith('"') && 2 === e14.split("").filter((e15) => '"' === e15).length;
function XVt(e14) {
  if (!e14) return null;
  const t10 = Jc.exec(e14, Jc("^=(?<name>[\\pL_\\d]+)\\s*\\((?<args>.*)\\)$", "gi"));
  if (!t10 || !t10.name || !t10.args) return null;
  const n10 = function(e15) {
    const t11 = [];
    const n11 = (e16) => {
      let n12 = e16.trim();
      n12.length ? KVt(n12) ? n12 = n12.slice(1, n12.length - 1) : /^-?\d+\.?\d*$/.test(n12) || (n12 = `=${n12}`) : n12 = "", t11.push(n12);
    };
    let r10 = "";
    let o10 = false;
    let a10 = 0;
    for (let t12 = 0; t12 < e15.length; t12++) {
      const i10 = e15[t12];
      "," !== i10 || o10 || 0 !== a10 ? ('"' === i10 ? o10 = !o10 : "(" !== i10 || o10 ? ")" !== i10 || o10 || a10-- : a10++, r10 += i10) : (n11(r10), r10 = "");
    }
    return "" !== r10 && n11(r10), t11;
  }(t10.args);
  switch (t10.name) {
    case ede.ICON_SET: {
      if (6 !== n10.length) break;
      const e15 = { IconSet: n10[0], Icon1Value: n10[1], Icon2Value: n10[2], Icon3Value: n10[3], Icon4Value: n10[4], Icon5Value: n10[5] };
      return sde(ade.ICON_SET, e15);
    }
    case ede.RANGE_BAR_PROGRESS: {
      if (7 !== n10.length) break;
      const e15 = { Minimum: n10[0], Maximum: n10[1], Color: n10[2], StartingValue: n10[3], Length: n10[4], ProgressIndicatorColor: n10[5], ProgressIndicatorLength: n10[6], DisplayProgressIndicator: true };
      return sde(ade.RANGE_BAR, e15);
    }
    case ede.RANGE_BAR: {
      if (5 !== n10.length) break;
      const e15 = { Minimum: n10[0], Maximum: n10[1], Color: n10[2], StartingValue: n10[3], Length: n10[4], DisplayProgressIndicator: false };
      return sde(ade.RANGE_BAR, e15);
    }
    case ede.DATA_BAR:
      if (6 === n10.length) {
        const e15 = { Value: n10[0], Minimum: n10[1], Maximum: n10[2], ZeroValue: n10[3], Color: n10[4], AlternateColor: n10[5], UseAlternateColor: true };
        return sde(ade.DATA_BAR, e15);
      }
      if (5 === n10.length) {
        const e15 = { Value: n10[0], Minimum: n10[1], Maximum: n10[2], ZeroValue: n10[3], Color: n10[4], UseAlternateColor: false };
        return sde(ade.DATA_BAR, e15);
      }
      break;
    case ede.GRADIENT: {
      if (3 !== n10.length) break;
      const e15 = { GradientType: n10[0], Color1: n10[1], Color2: n10[2] };
      return sde(ade.GRADIENT, e15);
    }
    case ede.HATCH: {
      if (3 !== n10.length) break;
      const e15 = { HatchStyle: n10[0], Color1: n10[1], Color2: n10[2] };
      return sde(ade.HATCH, e15);
    }
    case ede.COLOR_SCALE_2: {
      if (5 !== n10.length) break;
      const e15 = { Value: n10[0], Minimum: n10[1], Maximum: n10[2], MinimumColor: n10[3], MaximumColor: n10[4], UseMiddleColor: false };
      return sde(ade.COLOR_SCALE, e15);
    }
    case ede.COLOR_SCALE_3: {
      if (7 !== n10.length) break;
      const e15 = { Value: n10[0], Minimum: n10[1], Middle: n10[2], Maximum: n10[3], MinimumColor: n10[4], MiddleColor: n10[5], MaximumColor: n10[6], UseMiddleColor: true };
      return sde(ade.COLOR_SCALE, e15);
    }
  }
  return null;
}
const [JVt] = Dp("wd-data-visualizer-dialog");
const [QVt] = Dp("wd-data-visualizer");
const eRt = $N("", "propertyDescriptors:labels.dataVisualizer.visualizerType", "enum", "Type", void 0, { enumKey: "data_visualizer_image_type" });
const tRt = $N("", "propertyDescriptors:labels.dataVisualizer.visualizerType", "enum", "Type", void 0, { enumKey: "data_visualizer_color_type" });
const nRt = $N("", "", "data_visualizer_icon_set", "Content");
const rRt = $N("", "", "data_visualizer_range_bar", "Content");
const oRt = $N("", "", "data_visualizer_data_bar", "Content");
const aRt = $N("", "", "data_visualizer_gradient", "Content");
const iRt = $N("", "", "data_visualizer_hatch", "Content");
const sRt = $N("", "", "data_visualizer_color_scale", "Content");
const lRt = (e14) => {
  let t10;
  if (nde.some((t11) => t11 === e14)) t10 = eRt;
  else {
    if (!ode.some((t11) => t11 === e14)) throw Error(`Couldn't get VisualizerType descriptor for DataVisualizer type: ${e14}`);
    t10 = tRt;
  }
  return t10;
};
const cRt = { [ade.ICON_SET]: nRt, [ade.RANGE_BAR]: rRt, [ade.DATA_BAR]: oRt, [ade.GRADIENT]: aRt, [ade.HATCH]: iRt, [ade.COLOR_SCALE]: sRt };
const uRt = (e14) => {
  const t10 = cRt[e14];
  if (!t10) throw new Error(`Data Visualizer type '${e14}' is not valid`);
  return t10;
};
const dRt = (e14) => {
  switch (e14.Type) {
    case "textbox":
    case "image":
      return e14.Value;
    case "checkbox":
      return e14.Text;
    default:
      return "";
  }
};
const pRt = (e14) => {
  const t10 = dRt(e14[0]);
  return e14.every((e15) => dRt(e15) === t10) ? t10 : "";
};
const mRt = ({ properties: { objectValue: e14 }, descriptor: { valuePath: t10 } }) => {
  let n10 = jN(t10)(e14[0]) || "";
  for (let r11 = 1; r11 < e14.length && n10; r11++) {
    if ((jN(t10)(e14[r11]) || "") !== n10) {
      n10 = "";
      break;
    }
  }
  const r10 = bde(e14.map((e15) => e15.Type), t10);
  if (!r10.length) throw Error(`Couldn't determine DataVisualizer type for selected objects - items:${e14.map((e15) => e15.Type)}, valuePath: ${t10}`);
  const o10 = XVt(n10);
  return o10 && r10.some((e15) => e15 === o10.Type) ? o10 : r10[0] === ade.COLOR_SCALE ? sde(ade.COLOR_SCALE, { Value: pRt(e14) }) : sde(r10[0]);
};
const hRt = (e14) => {
  const { dispatch: t10, closeDialog: n10 } = RA();
  const { instanceId: r10, userPreferences: { units: o10 }, rdlx: { expressionSyntax: a10 } } = Uae();
  const i10 = A$();
  const s10 = h9();
  const l10 = p9();
  const { t: c10 } = vp();
  const { $index: u10, Type: d10 } = s10;
  const { descriptor: p10, properties: m10, properties: { objectValue: h10, objectPath: f10 } } = e14;
  const [g10, y10] = ep.useState({ descriptor: null, byPath: false, properties: { objectValue: [], defaultValue: [] }, prevProperties: null, value: null });
  ep.useEffect(() => {
    let t11 = __spreadValues({}, g10);
    const n11 = (e15) => {
      t11 = __spreadValues(__spreadValues({}, t11), e15);
    };
    p10 && g10.prevProperties !== m10 && n11({ value: mRt(e14) }), m10 !== g10.prevProperties && n11({ prevProperties: m10 }), y10(t11);
  }, [e14]);
  const v10 = ep.useMemo(() => dJ(d10, u10, l10, f10[0], h10[0].Name), [d10, u10, l10, f10, h10]);
  const b10 = () => {
    const { value: e15 } = g10;
    if (!e15) throw new Error("Data Visualizer value is not valid");
    return sde(e15.Type);
  };
  const S10 = ep.useCallback((e15, t11) => {
    const { value: n11 } = g10;
    let r11 = X2(n11, e15, t11);
    if ("Type" === e15.valuePath) {
      const e16 = Object.keys(ade).find((e17) => ade[e17] === t11);
      if (e16) {
        const t12 = sde(ade[e16], {}).Content;
        r11 = AV(r11, { Content: { $set: t12 } });
      }
    }
    y10(AV(g10, { value: { $set: r11 } }));
  }, [g10]);
  const C10 = ep.useCallback((e15) => {
    (e15 || []).forEach((e16) => S10(e16.descriptor, e16.value));
  }, [S10]);
  const x10 = ep.useCallback((e15, t11) => S10(e15, t11), [S10]);
  const w10 = (e15) => {
    const { value: n11 } = g10;
    const o11 = { descriptor: e15, objectValues: [n11], objectPaths: f10, defaultValues: [b10()], reportIndex: u10, reportType: d10, theme: l10, validationContext: v10, setProperty: S10 };
    t10(_A.of(r10).open("expressionEditor", o11));
  };
  const T10 = () => n10();
  const { value: E10 } = g10;
  if (!p10 || !E10) return null;
  const F10 = kp(JVt);
  const M10 = { open: true, title: c10("dialogs:dataVisualizer.title", "Data Visualizer"), controls: { align: "right", buttons: [{ text: c10("common:btnOk", "OK"), accent: "full", onClick: () => {
    const { byPath: r11 } = e14;
    const { value: o11 } = g10;
    if (!o11) throw new Error("Data Visualizer value is not valid");
    r11 ? (/* @__PURE__ */ ((e15, t11, n11, r12) => (o12) => {
      const a11 = xde(t11);
      gde(e15.valuePath, n11) ? o12(rz(r12.map((t12) => c2({ path: t12, descriptor: e15, value: a11 })))) : yde(e15.valuePath, n11) ? o12(rz(r12.map((t12) => u2({ path: t12, descriptorValuePairs: [{ descriptor: e15, value: a11 }, { descriptor: { valuePath: ude }, value: "Database" }, { descriptor: { valuePath: dde }, value: "NoRepeat" }] })))) : vde(e15.valuePath, n11) && o12(rz(r12.map((t12) => u2({ path: t12, descriptorValuePairs: [{ descriptor: e15, value: a11 }, { descriptor: { valuePath: mde }, value: "Database" }] }))));
    })(p10, o11, m10.objectValue.map((e15) => e15.Type), m10.objectPath))(t10) : (/* @__PURE__ */ ((e15, t11, n11) => (r12) => {
      const o12 = xde(t11);
      gde(e15.valuePath, n11) ? r12(o2({ descriptor: e15, value: o12 })) : yde(e15.valuePath, n11) ? r12(rz([o2({ descriptor: e15, value: o12 }), o2({ descriptor: { valuePath: ude }, value: "Database" }), o2({ descriptor: { valuePath: dde }, value: "NoRepeat" })])) : vde(e15.valuePath, n11) && r12(rz([o2({ descriptor: e15, value: o12 }), o2({ descriptor: { valuePath: mde }, value: "Database" })]));
    })(p10, o11, m10.objectValue.map((e15) => e15.Type)))(t10), n10();
  } }, { text: c10("common:btnCancel", "Cancel"), onClick: T10 }] }, onClose: T10, shouldCloseOnOverlayClick: false, customCSS: F10 };
  return tp.createElement(Hk, __spreadValues({}, M10), (() => {
    const { DataSets: e15 = [], DataSources: t11 = [] } = u10;
    const n11 = { setProperties: C10, setDataFieldProperty: x10 };
    const d11 = { instanceId: r10, units: o10, expressionSyntax: a10, validationContext: v10, dataSets: e15, dataSources: t11, dataScope: see(s10), semanticInfo: { semanticModel: i10, allowRebalancing: false, showAggregates: true, showCalculatedFields: true }, hideDataPicker: true, editExpression: w10 };
    const p11 = { propertyEditors: QVe, descriptors: (m11 = E10.Type, [lRt(m11), uRt(m11)]), objectValue: __spreadValues({ name: "dataVisualizer" }, E10), defaultValue: b10(), setProperty: S10, t: c10, customCSS: Lz };
    var m11;
    return tp.createElement("div", { className: QVt }, tp.createElement(Iue.Provider, { value: n11 }, tp.createElement(Vue.Provider, { value: d11 }, tp.createElement(Aue.Provider, { value: { theme: l10 } }, tp.createElement(wD, __spreadValues({}, p11))))));
  })());
};
hRt.displayName = "RdlxDataVisualizer";
const fRt = { confirm: (e14, t10) => tp.createElement(UA, __spreadValues({ key: e14 }, t10)), dataVisualizer: (e14, t10) => tp.createElement(hRt, __spreadValues({ key: e14 }, t10)), textEditor: (e14, t10) => tp.createElement(Oxe, __spreadValues({ key: e14 }, t10)), expressionEditor: (e14, t10) => tp.createElement(Fwe, __spreadValues({ key: e14 }, t10)), connectedExpressionEditor: (e14, t10) => tp.createElement(Mwe, __spreadValues({ key: e14 }, t10)), addRowsColumns: (e14, t10) => tp.createElement(YVt, __spreadValues({ key: e14 }, t10)), chartWizard: (e14, t10) => tp.createElement(iXe, __spreadValues({ key: e14 }, t10)) };
const gRt = { [Vwe]: (e14) => tp.createElement(Awe, { key: e14 }), [pSe]: (e14) => tp.createElement(mSe, { key: e14 }), [VCe]: (e14) => tp.createElement(RCe, { key: e14 }), [dGe]: (e14) => tp.createElement(pGe, { key: e14 }), [wBe]: (e14) => tp.createElement(TBe, { key: e14 }) };
const yRt = (e14) => ((e15 = {}) => {
  const t10 = { $callstack: [], context: null, panelStatesMap: {} };
  const n10 = Object.keys(e15);
  return n10.length && (t10.panelStatesMap = n10.reduce((t11, n11) => __spreadProps(__spreadValues({}, t11), { [n11]: e15[n11](void 0, { type: "@core/panels/DEFAULT" }) }), {})), (n11 = t10, r10) => {
    const { $callstack: o10, panelStatesMap: a10 } = n11;
    switch (r10.type) {
      case Wz: {
        const { panelId: t11, panelName: i10, context: s10, params: l10 } = r10.payload;
        const c10 = e15[t11];
        const u10 = a10[t11];
        if (!c10 || !u10) return console.error(`'${t11}' is NOT FOUND.`), n11;
        const d10 = o10.find((e16) => e16.key === t11);
        return d10 ? (console.error(`'${t11}' is already opened.`), n11) : AV(n11, { $callstack: { $unshift: [{ key: t11, name: i10 }] }, context: { $set: s10 != null ? s10 : n11.context }, panelStatesMap: { [t11]: { $apply: (e16) => c10(e16, e$(l10)) } } });
      }
      case jz: {
        if (0 === o10.length) return console.error("There're no open panels."), n11;
        const { panelId: t11 } = r10.payload;
        let a11 = null === t11 ? o10.length : 0;
        if (null !== t11) {
          const e16 = o10.findIndex((e17) => e17.key === t11);
          if (e16 < 0) return console.error(`'${t11}' is NOT FOUND.`), n11;
          a11 = e16;
        }
        const i10 = o10.slice(0, a11).reduce((t12, n12) => __spreadProps(__spreadValues({}, t12), { [n12.key]: { $apply: (t13) => e15[n12.key](t13, r10) } }), {});
        return AV(n11, { $callstack: { $splice: [[0, a11]] }, panelStatesMap: i10 });
      }
      case Zz: {
        const [t11, ...a11] = o10;
        if (!t11) return n11;
        const i10 = e15[t11.key];
        return AV(n11, { $callstack: { $set: a11 }, panelStatesMap: { [t11.key]: { $apply: (e16) => i10(e16, r10) } } });
      }
      case Gz:
        return t10;
      case qz: {
        const { panelId: t11, action: o11 } = r10.payload;
        const i10 = e15[t11];
        const s10 = a10[t11];
        return i10 && s10 ? AV(n11, { panelStatesMap: { [t11]: { $apply: (e16) => i10(e16, o11) } } }) : (console.error(`'${t11}' is NOT FOUND.`), n11);
      }
      default:
        return n11;
    }
  };
})(__spreadValues({ [Vwe]: Nwe, [pSe]: fSe, [VCe]: OCe, [dGe]: hGe, [wBe]: FBe }, e14));
const vRt = (e14, t10, n10, r10) => hm.of(e14).notifications.send({ type: "notification", payload: { level: t10, caption: n10, content: r10 } });
const bRt = (e14, t10, n10) => {
  const r10 = "fixedpagereport" === e14 ? Oq.decode : wq.decode;
  return (o10) => {
    const a10 = r10(o10);
    if ("error" === a10.type) {
      const e15 = n10("notifications:pasteFailedDecode.caption", { reason: a10.reason });
      return vRt(t10, "error", e15), null;
    }
    if (a10.warnings && a10.warnings.length && a10.warnings.forEach((e15) => {
      const r11 = n10("notifications:pasteWarningDecode.caption");
      const o11 = n10("notifications:pasteWarningDecode.text", { warning: e15 });
      vRt(t10, "warning", r11, o11);
    }), "fixedpagereport" !== e14) {
      let e15 = true;
      if (C3(a10.value, (t11, n11) => {
        var _a2;
        return "unknown" === n11.Type && "overflowplaceholder" === ((_a2 = n11.Item) == null ? void 0 : _a2.Type) && (e15 = false), e15 ? n11 : null;
      }), !e15) {
        const e16 = n10("notifications:pasteFailed.caption", { elementName: o10.Name });
        const r11 = n10("notifications:pasteFailed.text");
        return vRt(t10, "warning", e16, r11), null;
      }
    }
    return a10.value;
  };
};
const SRt = (e14, t10, n10) => {
  const r10 = document.getElementsByClassName(e14)[0].getBoundingClientRect();
  const o10 = t10.x - r10.left * n10;
  const a10 = t10.y - r10.top * n10;
  const i10 = N0e({ x: o10, y: a10 }, n10);
  const s10 = { x: L$.fromPixels(i10.x), y: L$.fromPixels(i10.y) };
  return { x: s10.x, y: s10.y };
};
const CRt = (e14, t10) => {
  const { Top: n10, Left: r10 } = e14.$place;
  const o10 = t10.x.add(L$.parse(r10)).css;
  const a10 = t10.y.add(L$.parse(n10)).css;
  return __spreadProps(__spreadValues({}, e14), { $place: __spreadProps(__spreadValues({}, e14.$place), { Left: o10, Top: a10 }) });
};
const xRt = (e14, t10) => {
  const n10 = (e15) => L$.parse(e15);
  const r10 = CRt(e14, t10);
  const { StartPoint: o10, EndPoint: a10, $place: { Top: i10, Left: s10 } } = r10;
  const l10 = t10.x.add(n10(i10));
  const c10 = t10.y.add(n10(s10));
  return __spreadProps(__spreadValues({}, r10), { StartPoint: { X: c10.add(n10(o10.X)).css, Y: l10.add(n10(o10.Y)).css }, EndPoint: { X: c10.add(n10(a10.X)).css, Y: l10.add(n10(a10.Y)).css } });
};
const wRt = (e14, t10) => {
  switch (e14.Type) {
    case "multisectionreport":
      return TRt(e14, t10);
    case "fixedpagereport":
      return FRt(e14, t10);
    case "dashboard":
      return ERt(e14, t10);
    default:
      return null;
  }
};
const TRt = (e14, t10) => {
  const n10 = e14.ReportSections[e14.$activeSectionIndex];
  return "Continuous" === (n10 == null ? void 0 : n10.Type) ? MRt(n10, t10) : null;
};
const ERt = (e14, t10) => {
  const n10 = e14.ReportSections[e14.$activeSectionIndex];
  if (!n10) return null;
  const { PageHeader: r10, PageFooter: o10, Body: a10 } = n10;
  let { y: i10 } = t10;
  const { x: s10 } = t10;
  const l10 = L$.parse(a10.$place.Height);
  const c10 = L$.parseSafe(r10 == null ? void 0 : r10.$place.Height);
  const u10 = L$.parseSafe(o10 == null ? void 0 : o10.$place.Height);
  const d10 = { height: l10.add(c10).add(u10), width: L$.parse(n10.Width) };
  return kRt({ x: s10, y: i10 }, d10) ? (r10 && !(r10 == null ? void 0 : r10.$selected) && (i10 = i10.subtract(c10)), o10 && (o10 == null ? void 0 : o10.$selected) && (i10 = i10.subtract(l10)), i10 = L$.max([i10, new L$(0, i10.units)]), { x: s10, y: i10 }) : null;
};
const FRt = (e14, t10) => {
  var _a2, _b2;
  const n10 = e14.Pages[e14.$activePageIndex];
  const r10 = { TopMargin: (_a2 = n10 == null ? void 0 : n10.TopMargin) != null ? _a2 : e14.Page.TopMargin, LeftMargin: (_b2 = n10 == null ? void 0 : n10.LeftMargin) != null ? _b2 : e14.Page.LeftMargin };
  return { x: t10.x.subtract(L$.parse(r10.LeftMargin)), y: t10.y.subtract(L$.parse(r10.TopMargin)) };
};
const MRt = (e14, t10) => {
  const { Page: n10, PageHeader: r10, PageFooter: o10 } = e14;
  const a10 = s3(e14);
  const i10 = { height: a10.sectionHeight, width: a10.sectionWidth };
  const s10 = t10.x.subtract(L$.parse(n10.LeftMargin));
  let l10 = t10.y.subtract(L$.parse(n10.TopMargin));
  return kRt({ x: s10, y: l10 }, i10) ? (r10 && !(r10 == null ? void 0 : r10.$selected) && (l10 = l10.subtract(a10.headerHeight)), o10 && (o10 == null ? void 0 : o10.$selected) && (l10 = l10.subtract(a10.bodyHeight)), l10 = L$.max([l10, new L$(0, l10.units)]), { x: s10, y: l10 }) : null;
};
const kRt = (e14, t10) => e14.x.greaterThan(new L$(0, e14.x.units)) && t10.width.greaterThan(e14.x) && e14.y.greaterThan(new L$(0, e14.y.units)) && t10.height.greaterThan(e14.y);
const PRt = (e14, t10) => e14.map((e15) => {
  const { ReportStyle: n10 } = e15;
  if (!n10) return e15;
  const { StyleId: r10 = "", StyleName: o10 = "" } = n10;
  const a10 = t10.find((e16) => e16.id === r10) || t10.find((e16) => e16.name === o10);
  return a10 ? AV(e15, { $style: { $set: a10.content } }) : e15;
});
const NRt = (e14) => ({ x: 200 * e14, y: e14 % 5 * 200 });
const DRt = (e14, t10, n10) => {
  const r10 = document.querySelector(`[data-path="${e14}"]`).getBoundingClientRect();
  const o10 = Dmt({ x: r10.left * n10, y: r10.top * n10 }, t10, n10);
  return { x: o10.x, y: o10.y, maxX: L$.fromPixels(r10.width).toTwips, maxY: L$.fromPixels(r10.height).toTwips };
};
function* LRt(e14, t10, n10) {
  const r10 = Vst.of(e14);
  const o10 = yield fUe(r10.get);
  if (!Dst(o10)) return;
  if ("rpx" !== o10.platform) return;
  const { workspaceId: a10 } = yield yUe(wz);
  if (a10 === pz) {
    const n11 = yield yUe(Ez);
    const { pasteId: r11, copiedDocumentItems: a11 } = o10.data;
    const { payload: { mousePosition: i10, contextAction: s10 } } = t10;
    const { surface: { zoomFactor: l10 } } = KO.of(e14).userPreferences;
    const c10 = function(e15, t11) {
      var _a2;
      const n12 = nz.of(e15).getFeature(t11.Type, "getChildren");
      const r12 = (_a2 = n12 == null ? void 0 : n12(t11)) != null ? _a2 : [];
      for (const e16 of r12) if (ij(e16)) return e16;
      return r12.find((e16) => "Detail" === e16.Type);
    }(e14, n11);
    const u10 = jat(a11.map((e15) => e15.rect));
    const d10 = c10.$pasteId !== r11 || i10 ? 0 : c10.$pasteCount || 0;
    const p10 = NRt(d10);
    const m10 = [];
    let h10 = "";
    const f10 = [];
    const g10 = az.of(e14).getNameFactory();
    const y10 = nz.of(e14);
    a11.forEach(({ documentItem: e15, rect: t11, isLeaf: r12, isPrimary: o11 }) => {
      if (y10.getFeature(e15.Type, "isCrossSectionItem") && !y10.getFeature(c10.Type, "canContainCrossSectionItems")) return;
      const a12 = y10.getFeature(e15.Type, "setRectangle");
      if (!a12) return;
      const d11 = { Left: t11.Left - u10.x + p10.x, Top: t11.Top - u10.y + p10.y, Width: t11.Width, Height: t11.Height };
      if (i10 && s10) {
        const e16 = Dmt(i10, n11.PageSettings, l10);
        const t12 = DRt(c10.$path, n11.PageSettings, l10);
        const r13 = e16.x - t12.x;
        const o12 = e16.y - t12.y;
        if (r13 < 0 || o12 < 0 || r13 > t12.maxX || o12 > t12.maxY) return;
        d11.Left += r13, d11.Top += o12;
      }
      const v10 = GB();
      const b10 = wtt({ id: v10, type: e15.Type, name: g10.getNextDocumentItemName(e15.Type), properties: a12(e15, d11) }, c10.$path);
      m10.push(b10);
      const S10 = `${c10.$path}.Controls.${v10}`;
      r12 && o11 ? h10 = S10 : f10.push(S10);
    }), !h10 && f10.length && (h10 = f10[0], f10.splice(0, 1)), m10.push(uB(h10, f10)), m10.push(Dtt(r11, i10 ? 0 : d10 + 1, c10.$path)), yield mUe(rz(m10));
  }
}
function HRt(e14, t10) {
  const { disableSystemClipboard: n10 } = KO.of(e14);
  function* r10(t11) {
    const { type: { platform: n11 } } = yield yUe(Tz);
    "rpx" === n11 ? yield function* (e15, t12, n12) {
      const { workspaceId: r11 } = yield yUe(wz);
      if (r11 === pz) {
        const n13 = t12.type === pB.type;
        const r12 = yield yUe(Ez);
        const o11 = Rmt(e15, r12, lit(r12));
        const a10 = { pasteId: Ve(7), copiedDocumentItems: o11, cut: n13 };
        const i10 = Vst.of(e15);
        yield fUe(i10.put, a10, "rpx"), n13 && (yield mUe(Ttt()));
      }
    }(e14, t11) : "rdlx" === n11 && (yield function* (e15, t12, n12) {
      const { workspaceId: r11 } = yield yUe(wz);
      const o11 = yield yUe(Ez);
      const a10 = Vst.of(e15);
      let i10 = null;
      const s10 = Ve(7);
      switch (r11) {
        case pz: {
          if (yj(o11).some((e17) => !GW(e17.Type))) return;
          const e16 = "fixedpagereport" === o11.Type ? Oq.encode : wq.encode;
          i10 = { pasteId: s10, items: V0e(o11).map(e16) }, t12.type === pB.type && (yield mUe(JG()));
          break;
        }
        case F$e: {
          const { selection: e16, controls: n13 } = o11.$paramsView;
          const r12 = n13.find((t13) => t13.name === e16);
          if (!r12) break;
          i10 = { pasteId: s10, pveControls: [r12] }, t12.type === pB.type && (yield mUe(COe.deleteControl()));
          break;
        }
      }
      i10 && (yield fUe(a10.put, i10, "rdlx"));
    }(e14, t11));
  }
  function* o10(n11) {
    const { type: { platform: r11 } } = yield yUe(Tz);
    "rpx" === r11 ? yield LRt(e14, n11) : "rdlx" === r11 && (yield function* (e15, t11, n12) {
      const r12 = Vst.of(e15);
      const o11 = yield fUe(r12.get);
      if (!Dst(o11)) return;
      if ("rdlx" !== o11.platform) return;
      const { rdlx: { reportPartsLibraries: { libraries: a10 } } } = yield yUe(l9);
      const { workspaceId: i10 } = yield yUe(wz);
      const { type: { type: s10 } } = yield yUe(Tz);
      const l10 = yield yUe(Ez);
      const c10 = o11.data;
      const { mousePosition: u10, contextAction: d10 } = t11.payload;
      const { surface: { zoomFactor: p10 } } = KO.of(e15).userPreferences;
      switch (i10) {
        case pz: {
          const { $index: { NamedItems: t12 }, Type: r13 } = l10;
          const { pasteId: o12, items: i11 } = c10;
          if (!i11) break;
          if ("master" !== s10 && i11.some(({ Type: e16 }) => "contentplaceholder" === e16)) break;
          const { rdlx: { reportStyles: m10 = [] } } = yield yUe(l9);
          let h10;
          if (d10) {
            if (!u10) break;
            const o13 = SRt("ar-page", u10, p10);
            const a11 = wRt(l10, o13);
            if (!a11) break;
            h10 = PRt(YZe(i11.map(bRt(r13, e15, n12)).filter(Ie).map((e16) => "line" === e16.Type ? xRt(e16, a11) : CRt(e16, a11)).map((e16) => zG(e16, t12))), m10);
          } else h10 = PRt(YZe(i11.map(bRt(r13, e15, n12)).filter(Ie).map((e16) => zG(e16, t12))), m10);
          const f10 = [];
          if (h10.forEach((e16) => {
            if ("partitem" === e16.Type) {
              const t13 = a10.find((t14) => t14.Name === e16.Library);
              !t13 || l10.Libraries.some(({ Name: e17 }) => e17 === t13.Name) || f10.includes(t13.Name) || f10.push(t13.Name);
            }
          }), f10.length > 0) {
            const e16 = a10.some((e17) => TLe(e17));
            const t13 = a10.some((e17) => wLe(e17));
            !e16 && t13 && (yield mUe(lWe.setLibrariesLoadingRequested()));
          }
          yield mUe(eU({ items: h10, pasteId: o12, contextAction: d10 }, { currentLayerName: l10.$currentLayerName, isChildReport: q7(l10) }));
          break;
        }
        case F$e:
          if (!c10.pveControls) break;
          yield mUe(COe.pasteControl(c10.pveControls[0]));
      }
    }(e14, n11, t10));
  }
  return Vst(e14, n10), function* () {
    yield EUe(dB.type, r10), yield EUe(pB.type, r10), yield TUe(mB.type, o10);
  };
}
var IRt = [{ lng: "en", ns: "arjswd", resources: { about: { applicationVersion: "Application version: {{applicationVersion}}", close: "Close", coreVersion: "Core version: {{coreVersion}}", title: "About {{applicationTitle}}" }, "application-logo": "", "application-title": "ActiveReportsJS Designer", collectionEditor: { AddBtnTitle: "Add Item", addBtnText: "Add", closeBtnTitle: "Close", deleteBtnTitle: "Delete", showBtnTitle: "Show", textEmpty: "Collection is empty", textItems: "items" }, common: { copyright: "\xA9\uFE0F MESCIUS inc. All rights reserved.", untitledReportName: "Untitled" }, commonEditorProps: { "bool-false-label": "False", "bool-true-label": "True", dataBinding: "Data Binding", "number-editor-decrease": "Decrease", "number-editor-increase": "Increase", placeholderEmpty: "<Empty>" }, dataPanel: { addCmdTitle: "Add", commonValuesLabel: "Common Values", dataSetsLabel: "Data Sets", dataSourcesLabel: "Data Sources", editParameter: "Edit parameter", noDataSets: "Report has no data sets", noDataSources: "Report has no data sources", noParameters: "Report has no parameters", parametersLabel: "Parameters", smartSuggestions: "Smart Suggestions" }, dataSetDialog: { alertTextClose: "Close", alertTextCollapse: "Collapse", alertTextExpand: "Expand", btnBack: "Back to Parent", btnExportTemplate: "Export...", btnValidate: "Validate", confirmSaveInvalid: "The changes were not validated. Do you want to save the changes?", modeEditSubtitle: "Edit Data Set", modeNewSubtitle: "New Data Set", parseQueryError: "Incorrect query string" }, dataSetProps: { category: { csv: "CSV Settings", fields: "Fields", filters: "Filters", name: "Name", query: "Query" }, columnSeparatorComma: "Comma", columnSeparatorSemicolon: "Semicolon", columnSeparatorSpace: "Space", columnSeparatorTab: "Tab", fieldsDataField: "Data Field", fieldsName: "Field Name", fieldsValue: "Value", fieldsValuePlaceholder: "Enter the expression", methodGet: "HTTP GET", methodPost: "HTTP POST", queryMode: { JSON: "JSON", Text: "Text" }, title: { calcFields: "Calculated Fields", columnSeparator: "Column Separator", datasets: "Nested Datasets", endpoint: "Uri/path", fields: "Database Fields", headers: "Headers", headingRow: "Heading Row", jpath: "Json Path", mergeColumnSeparators: "Merge Column Separators", mergeRowSeparators: "Merge Row Separators", method: "Method", postBody: "Post body", queries: "Parameters", queryType: "Type", rowSeparator: "Row Separator", startingRow: "Starting Row", value: "Value" } }, dataSourceDialog: { btnConnectionString: "Connection String", btnExportTemplate: "Export...", btnProperties: "Properties", parseErrorTitle: "Incorrect connection string", subtitle: "Edit Data Source" }, dataSourceProps: { btnLoadFromFile: "Load From File", category: { connectionString: "Connection string", data: "Data", dataFormat: "Data Format", endpoint: "Endpoint", jsonData: "JSON Data", name: "Name", parameters: "Parameters", sourceType: "Source Type" }, exprMenuDialog: "Expression...", exprMenuReset: "Reset", headersKey: "Header", headersValue: "Value", providerCSV: "CSV", providerJSON: "JSON", queriesKey: "Parameter", queriesValue: "Value", sourceEmbedded: "Embedded", sourceRemote: "Remote", title: { headers: "HTTP Headers", queries: "Query Parameters" } }, dataTab: { title: "Data" }, designer: { dateFormats: [], defaultSettings: { propertiesMode: "Basic", snapToGridEnabled: "false", snapToGuidesEnabled: "false", units: "in" }, fonts: ["Arial", "Arial Black", "Comic Sans MS", "Courier New", "Geneva", "Georgia", "Helvetica", "Impact", "Lucida Console", "Meiryo", "Meiryo UI", "MingLiU", "MingLiU-ExtB", "MS Gothic", "MS Mincho", "MS PGothic", "MS PMincho", "MS Song", "MS UI Gothic", "NSimSun", "Osaka", "PMingLiU", "PMingLiU-ExtB", "SimSun", "SimSun-ExtB", "Song", "Tahoma", "Times New Roman", "Trebuchet MS", "Verdana", "Yu Gothic"], reportStyles: [], reportTypes: ["CPL", "FPL", "Pageless"] }, dialogs: { cancel: "Cancel", confirmSavingChanges: { dontSaveLabel: "Don't save", saveLabel: "Save", wantSaveChanges: "Do you want to save changes to {{reportName}}?" }, saveChanges: "Save Changes" }, error: { api: { createReportFailed: "Failed to create report." }, cantLoadImages: "Cannot load images list", cantLoadReports: "Cannot load reports list", cantLoadThemes: "Cannot load themes list", customInitTemplate: { loadFailed: "Failed to load custom init template '{{id}}': {{error}}" }, dataProviderNotSupported: 'Data provider "{{provider}}" is not supported.', errorCode: "Error code: {{code}}", errorSerializingReport: "Internal error: cannot serialize report", hasUnsavedChanges: "Unable to load report. Designer has unsaved changes in the report.", internalError: "Internal Error", "invalid-report-displayName": "Invalid report displayName", "invalid-report-id": "Invalid report id", invalidReportDef: "Invalid report definition", invalidReportType: "Invalid report type", libraries: { importFailed: 'Library "{{path}}" importing failed', loadingFailed: 'Library "{{path}}" loading failed', unknownLibrary: { caption: "Report depends on unknown library", text: 'The library "{{libName}}" used in this report is not found' } }, noHostElement: "Cannot find the host element.", noReportOpened: "No report currently opened", "report-id-is-not-specified": "Report id is not specified", reportLoadFailed: 'The report "{{reportName}}" could not be opened.', theme: { notFoundOrInvalid: "The theme '{{theme}}' used in this report either is not found or has invalid content." }, unableGetReport: "Unable to get a report: {{message}}", unablePerformAction: "Unable to perform the action: {{message}}", unableSetReport: "Unable to set a report: {{message}}", unsupportedDocumentType: "Internal error: unsupported document type" }, exportTemplateDialog: { closeBtnText: "Close", title: "Export Template" }, expressions: { customCodeGroup: "Custom Code" }, menu: { about: "About" }, nameTemplates: { dataSetCalcFieldValue: "CalculatedField", dataSetFieldValue: "Field", reportParameter: "Parameter" }, notificationPanel: { collapse: "Collapse", dismiss: "Dismiss", dismissAll: "Dismiss All", expand: "Expand", oneError: "Error", oneNotification: "Notification", oneWarning: "Warning", showDetails: "Show Details" }, propertiesTab: { title: "Properties" }, queryValuesDialog: { btnSave: "Save & Run", title: "Parameter Values" }, sideBar: { collapse: "Collapse", expand: "Expand" }, warning: { unsavedChanges: "The report on this page has unsaved changes." } } }];
const _Rt = "arjswd";
const VRt = dG.createInstance();
const RRt = VRt.init({ fallbackLng: "en", lng: "en", resources: {}, defaultNS: _Rt, keySeparator: ".", returnObjects: true }).then(() => {
  var e14;
  VRt.addResourceBundle("en", _Rt, null === (e14 = IRt[0]) || void 0 === e14 ? void 0 : e14.resources);
});
const ARt = {};
function ORt(e14, t10) {
  if (void 0 !== e14.displayName && "string" != typeof e14.displayName) throw new Error(VRt.t("error.invalid-report-displayName", "Invalid report displayName"));
  switch (t10) {
    case "SaveResult":
      break;
    case "SaveAsResult":
      if (!e14.hasOwnProperty("id")) throw new Error(VRt.t("error.report-id-is-not-specified", "Report id is not specified"));
      if ("string" != typeof e14.id) throw new Error(VRt.t("error.invalid-report-id", "Invalid report id"));
      break;
    case "Report":
    case "NewReport":
      if (void 0 !== e14.id && "string" != typeof e14.id) throw new Error(VRt.t("error.invalid-report-id", "Invalid report id"));
  }
}
function BRt(e14) {
  return (...t10) => y(this, void 0, void 0, function* () {
    return e14(...t10);
  });
}
const zRt = { fontSet: "all", disableFocusTimer: false, storeUnsavedReport: false, storeUserPreferences: true, title: { disabled: false }, editor: { gridSize: "0.25in", rulers: { visible: true }, showGrid: true, snapToGrid: false, snapToGuides: false }, menu: { visible: true, documentExplorer: { visible: true }, groupEditor: { visible: true }, toolBox: { visible: true }, layerEditor: { visible: true }, logo: { visible: true, icon: { type: "svg", content: tp.createElement("svg", { viewBox: "0 0 106.37951 125.37", xmlns: "http://www.w3.org/2000/svg" }, tp.createElement("g", { transform: "translate(-342.36827,-243.46)" }, tp.createElement("path", { fill: "white", d: "m 417.39,300.05 c 0.89,-7.57 -0.9,-13.4 -1.77,-15.68 -0.26,-0.68 -0.44,-1.04 -0.44,-1.05 v 0 l -15.55,-37.15 c -0.69,-1.64 -2.3,-2.71 -4.08,-2.71 -1.78,0 -3.39,1.07 -4.08,2.71 L 342.71,362.7 c -0.77,1.85 -0.21,3.99 1.39,5.21 0.79,0.61 1.74,0.91 2.69,0.91 0.95,0 1.91,-0.31 2.7,-0.92 l 48.59,-37.52 c 7.5,-5.79 12.25,-11.71 15.2,-17.32 2.44,-4.64 3.65,-9.06 4.11,-13.01 z" }), tp.createElement("path", { fill: "white", d: "M 448.4,362.68 433.49,327.5 c -0.55,-1.29 -1.67,-2.24 -3.02,-2.57 -1.36,-0.33 -2.8,0 -3.87,0.89 l -10.27,8.52 c 0,0 -4.44,3.7 -4.01,9.06 0.02,0.24 0.05,0.49 0.09,0.74 0.53,3.32 2.98,7.2 9.39,11.2 l 20.16,12.8 c 0.73,0.46 1.55,0.69 2.37,0.69 1.02,0 2.04,-0.36 2.86,-1.05 1.47,-1.26 1.96,-3.32 1.21,-5.1 z" }))) } } }, propertyGrid: { propertiesTab: { visible: true }, mode: "Advanced", collapsibleCategories: { enabled: true }, saveExpandEditorsState: { enabled: true } }, statusBar: { visible: true, gridSizeEditor: { visible: true }, propertiesModeButton: { visible: true }, rulersButton: { visible: true }, toggleGridButton: { visible: true }, toggleUnitsButton: { visible: true } }, appBar: { visible: true, homeTab: { visible: true }, contextActionsTab: { visible: true }, parametersTab: { visible: true }, aboutButton: { visible: true } }, toolBar: { visible: true }, data: { slicers: { visible: false }, dataTab: { visible: true }, dataSources: { visible: true, canModify: true, shared: { enabled: false } }, dataSets: { visible: true, canModify: true }, parameters: { visible: true, canModify: true }, commonValues: { visible: true } } };
const $Rt = { report: ["$displayType", "$sizeType"], fixedpagereport: ["$displayType", "$sizeType"], multisectionreport: ["$displayType", "$sizeType"], dashboard: ["$displayType", "$sizeType"], fixedpagetablix: ["RepeatToFill"], dynamictablixmember: ["Group.PrintFooterAtBottom"], formattedtext: ["EncodeMailMergeFields", "MailMergeFields"], richtext: ["ToolTip"], subreport: ["MergeTransactions", "InheritStyleSheet"], fixedpagesubreport: ["MergeTransactions", "InheritStyleSheet"], pagesection: ["PrintOnFirstPage", "PrintOnLastPage"], inputfield: ["TabIndex"], Continuous: ["Visibility.Hidden"], dashboardsection: ["Visibility.Hidden"] };
const WRt = ["DataElementName", "DataElementOutput", "DataElementStyle", "DataInstanceName", "DataInstanceElementOutput", "Group.DataElementName", "Group.DataCollectionName", "Group.DataElementOutput", "Group.NewPage", "DetailDataElementName", "DetailDataCollectionName", "DetailDataElementOutput", "FixedPageDataElementName", "FixedPageDataElementOutput", "Style.NumeralLanguage", "Style.NumeralVariant", "Style.Calendar", "Style.UnicodeBiDi", "DataSetParameters", "NewPage", "Config.Bar.BottomWidth", "Config.Bar.NeckHeight", "Config.Bar.Overlap", "Config.Bar.TopWidth", "Config.Bar.Width", "Config.UnpivotData", "PageName", "AccessibleDescription"];
const jRt = (e14, t10) => ("barcode" !== t10.Type || !ZRt.symbology.includes(t10.Symbology) || ZRt.unsupportedProp !== e14.valuePath) && ("dvchart" !== t10.Type && "fixedpagedvchart" !== t10.Type || "Style" !== e14.valuePath || "padding" !== e14.type);
const ZRt = { symbology: ["Aztec", "DataMatrix", "GS1QRCode", "QRCode", "Pdf417", "GS1DataMatrix"], unsupportedProp: "CaptionLocation" };
const GRt = { filterProperties: (e14, t10) => {
  const n10 = $Rt[t10.Type];
  const r10 = n10 ? [...WRt, ...n10] : WRt;
  return e14.filter((e15) => !r10.includes(e15.valuePath) && jRt(e15, t10));
}, imageMimeTypes: ["image/png", "image/jpeg", "image/svg+xml"], rdlx: { expressionEditorNodesFilter: (URt = ["userId", "userLanguage", "math.bigMul", "inspection.isDBNull", "inspection.isError", "miscellaneous.getFields", "inspection.dbNull"], (e14) => {
  var t10, n10;
  for (const r10 of URt) {
    if ("string" == typeof e14 && e14.includes(r10)) return false;
    if ("object" == typeof e14 && (null === (n10 = null === (t10 = e14.name) || void 0 === t10 ? void 0 : t10.includes) || void 0 === n10 ? void 0 : n10.call(t10, r10))) return false;
  }
  return true;
}), reportItemsFeatures: { barcode: { symbologies: ["Aztec", "EAN_13", "EAN_8", "QRCode", "GS1QRCode", "Codabar", "Code39", "Code39x", "Code_93", "Code93x", "Code_128auto", "Code_128_A", "Code_128_B", "Code_128_C", "UCCEAN128", "Code49", "Pdf417", "DataMatrix", "GS1DataMatrix", "ITF14", "UPC_A", "UPC_E0", "UPC_E1", "Code25intlv", "RSS14", "RSSLimited", "RSS14Truncated", "RSS14Stacked", "RSS14StackedOmnidirectional", "JapanesePostal", "Ansi39", "Ansi39x"], hideUnsupportedBarcodeJSProperties: true }, chart: { canUseWizard: true, plotChartTypes: ["Column", "Bar", "Line", "Area", "Pie", "PolarColumn", "PolarBar", "RadarArea", "RadarBubble", "RadarScatter", "RadarLine", "Pyramid", "Funnel", "Bubble", "Scatter", "Gantt", "Candlestick", "HighLowClose", "HighLowOpenClose", "RangeArea", "RangeBar", "RangeColumn", "Gauge"] }, table: { autoFillHeader: true, autoFillFooter: false, canMergeCellsVertically: true }, tablix: { autoFillCorner: true, canUseWizard: true } }, reportThemes: { prohibitMultipleThemes: true }, toolBoxContent: { cpl: ["textbox", "checkbox", "container", "line", "shape", "inputfield", "tableofcontents", "image", "list", "table", "tablix", "chart", "bullet", "barcode", "sparkline", "subreport", "bandedlist", "richtext"], fpl: ["textbox", "checkbox", "container", "line", "shape", "inputfield", "tableofcontents", "image", "list", "table", "tablix", "chart", "bullet", "barcode", "sparkline", "subreport", "overflowplaceholder", "bandedlist", "richtext"] }, reportParameters: { hiddenProperties: ["SelectAllValue"] }, msl: { enabled: true }, dashboard: { enabled: true }, fpl: { enabled: true }, masterReports: { enabled: false }, reportParts: { enabled: true, libraries: [] } }, data: { dataTab: { visible: true }, dataSets: { visible: true, canModify: true }, dataSources: { visible: true, canModify: true, shared: { enabled: false } }, parameters: { visible: true, canModify: true }, commonValues: { visible: true }, slicers: { visible: true } }, rpx: { enabled: false } };
var URt;
const qRt = Object.assign(Object.assign({}, GRt), { instanceId: "", language: "en", lockLayout: false, disableSystemClipboard: false, fonts: [], rdlx: Object.assign(Object.assign({}, GRt.rdlx), { expressionSyntax: "i11n", reportStyles: ((e14, t10) => {
  const n10 = t10 ? Object.entries(t10).reduce((e15, [t11, n11]) => [...e15, ...Fj(t11, n11)], []) : Mj;
  return e14 ? e14.reduce((e15, t11) => ((e16, t12) => {
    const n11 = t12;
    for (const t13 in e16) wj[t13] && Array.isArray(e16[t13]) ? e16[t13].forEach((e17) => {
      e17.id && e17.name && e17.content && n11.push(Ej(e17, false, t13));
    }) : console.warn(`[RdlxReportStyles] : Wrong custom style for ${t13} target type`);
    return n11;
  })(t11, e15), n10) : n10;
})() }), themes: { default: "default", list: [], picker: { enabled: true } }, userPreferences: { rulers: { show: true, snapStep: { cm: 0.5, in: 0.25 } }, sidebar: { propertiesMode: "simple", propertiesSort: "categorized", width: 300, expandedCategoriesStates: JSON.stringify({}), expandedEditorsStates: JSON.stringify({}) }, surface: { gridSize: "0.25in", showGrid: true, snapToGrid: false, snapToLines: false, zoomFactor: 1 }, units: "in", theme: "default" } });
const YRt = ep.createContext({ identifiers: { instanceId: "", containerId: "", sidebarControlsId: "" }, settings: {}, about: { applicationTitle: "", applicationTitleCompact: "", applicationVersion: "", coreVersion: "", copyright: "" }, i18n: {} });
const KRt = () => ep.useContext(YRt);
const XRt = () => {
  const { settings: e14 } = KRt();
  return e14;
};
const JRt = () => MO();
const QRt = "JSON";
const eAt = "JSONEMBED";
const tAt = "CSV";
const nAt = "CSVEMBED";
const rAt = "Field1";
const oAt = (e14) => !("object" != typeof e14 || !e14 || e14 instanceof Date || Array.isArray(e14));
function aAt(e14, t10 = "DataSet1") {
  const n10 = [];
  const r10 = (e15) => {
    const t11 = {};
    return Object.entries(e15).forEach(([e16, n11]) => {
      o10(e16, n11).forEach(([e17, n12]) => {
        t11[e17] = n12;
      });
    }), t11;
  };
  const o10 = (e15, t11) => {
    if (Array.isArray(t11)) {
      const n11 = t11[0];
      return [[e15, [oAt(n11) ? r10(n11) : n11]]];
    }
    if (oAt(t11)) {
      const n11 = r10(t11);
      return Object.entries(n11).map(([t12, n12]) => [`${e15}.${t12}`, n12]);
    }
    return [[e15, t11]];
  };
  const a10 = (e15, t11, r11, o11) => {
    const i11 = [];
    n10.push({ fields: i11, name: o11, parent: t11, level: r11 }), e15.forEach(([e16, t12]) => {
      if (Array.isArray(t12)) {
        const s10 = ((e17, t13) => {
          var n11;
          if (t13(e17)) return e17;
          const r12 = (null === (n11 = /(\d+)(?!.*\d)$/.exec(e17)) || void 0 === n11 ? void 0 : n11[0]) || "";
          const o12 = e17.substr(0, e17.length - r12.length);
          let a11 = parseInt(r12 || "0", 10) + 1;
          for (; !t13(o12 + a11.toString()); ) a11++;
          return o12 + a11.toString();
        })(e16, (e17) => n10.every((t13) => t13.name !== e17));
        i11.push({ name: s10, dataField: e16 });
        const l10 = t12[0];
        const c10 = oAt(l10) ? Object.entries(l10) : [[rAt, l10]];
        a10(c10, { dataset: o11, field: s10 }, r11 + 1, s10);
      } else {
        const t13 = i11.some((t14) => t14.name === e16);
        t13 || i11.push({ name: e16, dataField: e16 });
      }
    });
  };
  const i10 = [];
  return (null != e14 ? e14 : []).forEach(({ name: e15, value: t11 }) => {
    o10(e15, t11).forEach(([e16, t12]) => {
      i10.push([e16, t12]);
    });
  }), a10(i10, null, 0, t10), n10;
}
function iAt(n10, r10) {
  return function(o10) {
    return y(this, void 0, void 0, function* () {
      const { dataSet: a10, dataSource: i10 } = o10;
      let s10 = [];
      if ([QRt, eAt, tAt, nAt].includes(i10.ConnectionProperties.DataProvider)) try {
        const o11 = function(e14) {
          var t10;
          if (!e14) return null;
          const n11 = null !== (t10 = e14.records[Symbol.iterator]().next().value) && void 0 !== t10 ? t10 : [];
          return e14.descriptors.map((e15, t11) => ({ name: e15.Name, value: n11[t11] }));
        }(yield e(r10)(t)(i10, Object.assign(Object.assign({}, a10), { Fields: [] }), (e14) => ((...e15) => (0, KO.of(n10).resourceProvider.getResourceUri)(...e15))(e14)));
        s10 = aAt(o11, a10.Name);
      } catch (e14) {
        throw console.error(e14), e14;
      }
      return { datasets: s10, parameters: a10.Query.QueryParameters || [] };
    });
  };
}
const sAt = { actionHandlers: true, resourceProvider: true };
function lAt(e14) {
  return e14.hasOwnProperty("definition");
}
const cAt = (e14) => {
  if (e14) {
    if (e14.responseJSON && e14.responseJSON.ErrorCode && e14.responseJSON.Error) {
      const t10 = e14.responseJSON;
      return `${t10.ErrorCode}: ${t10.Error}`;
    }
    if (e14.responseText) {
      const { responseText: t10, statusText: n10 } = e14;
      return n10 ? `${n10}: ${t10}` : t10;
    }
    if (e14.statusText) {
      const { status: t10, statusText: n10 } = e14;
      return t10 ? `${t10}: ${n10}` : n10;
    }
    return e14 instanceof Error ? `${e14.name}: ${e14.message}` : "string" == typeof e14 ? e14 : JSON.stringify(e14);
  }
};
const uAt = { imperial: { tablix: { Type: "tablix", Name: "Tablix1", RowHierarchy: { LevelSizes: ["1in"], Members: [{ Header: { Item: { Type: "textbox", Name: "TextBox3", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" }, LevelCount: 1 }, BodyIndex: 0, Group: { Name: "Tablix1_RowGroup1", GroupExpressions: [""] } }] }, ColumnHierarchy: { LevelSizes: ["0.25in"], Members: [{ Header: { Item: { Type: "textbox", Name: "TextBox2", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" }, LevelCount: 1 }, BodyIndex: 0, Group: { Name: "Tablix1_ColumnGroup1", GroupExpressions: [""] } }] }, Corner: [[{ Item: { Type: "textbox", Name: "TextBox1", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" } }]], Body: { Columns: ["1in"], Rows: [{ Height: "0.25in", Cells: [{ Item: { Type: "textbox", Name: "TextBox4", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" } }] }] }, Width: "2in", Height: "0.5in" }, table: { Type: "table", Name: "Table1", TableColumns: [{ Width: "1in" }, { Width: "1in" }, { Width: "1in" }], Header: { TableRows: [{ Height: "0.25in", TableCells: [{ Item: { Type: "textbox", Name: "TextBox1", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" } }, { Item: { Type: "textbox", Name: "TextBox2", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" } }, { Item: { Type: "textbox", Name: "TextBox3", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" } }] }], RepeatOnNewPage: true }, Details: { TableRows: [{ Height: "0.25in", TableCells: [{ Item: { Type: "textbox", Name: "TextBox4", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" } }, { Item: { Type: "textbox", Name: "TextBox5", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" } }, { Item: { Type: "textbox", Name: "TextBox6", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" } }] }] }, Footer: { TableRows: [{ Height: "0.25in", TableCells: [{ Item: { Type: "textbox", Name: "TextBox7", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" } }, { Item: { Type: "textbox", Name: "TextBox8", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" } }, { Item: { Type: "textbox", Name: "TextBox9", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" } }] }] }, Width: "3in", Height: "0.75in" }, checkbox: { Type: "checkbox", Name: "CheckBox1", Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "1in", Height: "0.25in" }, page: { RightMargin: "1in", LeftMargin: "1in", TopMargin: "1in", BottomMargin: "1in", Columns: 1, ColumnSpacing: "0in" } }, metric: { tablix: { Type: "tablix", Name: "Tablix1", RowHierarchy: { LevelSizes: ["2.5cm"], Members: [{ Header: { Item: { Type: "textbox", Name: "TextBox3", DataElementName: "TextBox13", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "2.5cm", Height: "0.75cm" }, LevelCount: 1 }, BodyIndex: 0, Group: { Name: "Tablix1_RowGroup1", GroupExpressions: [""], PageBreakDisabled: "false" } }] }, ColumnHierarchy: { LevelSizes: ["0.75cm"], Members: [{ Header: { Item: { Type: "textbox", Name: "TextBox2", DataElementName: "TextBox12", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "2.5cm", Height: "0.75cm" }, LevelCount: 1 }, BodyIndex: 0, Group: { Name: "Tablix1_ColumnGroup1", GroupExpressions: [""], PageBreakDisabled: "false" } }] }, Corner: [[{ Item: { Type: "textbox", Name: "TextBox1", DataElementName: "TextBox11", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "2.5cm", Height: "0.75cm" } }]], Body: { Columns: ["2.5cm"], Rows: [{ Height: "0.75cm", Cells: [{ Item: { Type: "textbox", Name: "TextBox4", DataElementName: "TextBox14", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "2.5cm", Height: "0.75cm" } }] }] }, Left: "0cm", Top: "0cm", Width: "5cm", Height: "1.5cm" }, table: { Type: "table", Name: "Table1", ZIndex: 1, TableColumns: [{ Width: "2.5cm" }, { Width: "2.5cm" }, { Width: "2.5cm" }], Header: { TableRows: [{ Height: "0.75cm", TableCells: [{ Item: { Type: "textbox", Name: "TextBox5", DataElementName: "TextBox2", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "0cm", Height: "0cm" } }, { Item: { Type: "textbox", Name: "TextBox6", DataElementName: "TextBox3", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "0cm", Height: "0cm" } }, { Item: { Type: "textbox", Name: "TextBox7", DataElementName: "TextBox4", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "0cm", Height: "0cm" } }] }], RepeatOnNewPage: true }, Details: { TableRows: [{ Height: "0.75cm", TableCells: [{ Item: { Type: "textbox", Name: "TextBox8", DataElementName: "TextBox5", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "0cm", Height: "0cm" } }, { Item: { Type: "textbox", Name: "TextBox9", DataElementName: "TextBox6", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "0cm", Height: "0cm" } }, { Item: { Type: "textbox", Name: "TextBox10", DataElementName: "TextBox7", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "0cm", Height: "0cm" } }] }], Group: { PageBreakDisabled: "false" } }, Footer: { TableRows: [{ Height: "0.75cm", TableCells: [{ Item: { Type: "textbox", Name: "TextBox11", DataElementName: "TextBox8", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "0cm", Height: "0cm" } }, { Item: { Type: "textbox", Name: "TextBox12", DataElementName: "TextBox9", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "0cm", Height: "0cm" } }, { Item: { Type: "textbox", Name: "TextBox13", DataElementName: "TextBox10", CanGrow: true, KeepTogether: true, Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Width: "0cm", Height: "0cm" } }] }] }, Left: "0cm", Top: "0cm", Width: "7.5cm", Height: "2.25cm" }, checkbox: { Type: "checkbox", Name: "CheckBox1", Style: { PaddingLeft: "2pt", PaddingRight: "2pt", PaddingTop: "2pt", PaddingBottom: "2pt" }, Left: "0cm", Top: "0cm", Width: "2.5cm", Height: "0.75cm" }, page: { RightMargin: "2.5cm", LeftMargin: "2.5cm", TopMargin: "2.5cm", BottomMargin: "2.5cm", Columns: 1, ColumnSpacing: "0cm" } } };
function dAt(e14) {
  if (e14.Body) {
    const { PageHeader: t10, PageFooter: n10, Body: r10, Page: o10, DataElementName: a10, Width: i10 } = e14;
    return Object.assign(Object.assign({}, e14), { Body: void 0, PageHeader: void 0, PageFooter: void 0, Page: void 0, DataElementName: void 0, Width: void 0, ReportSections: [{ Name: "ContinuousSection1", PageHeader: t10, Body: r10, PageFooter: n10, Page: o10, DataElementName: a10, Width: i10, DataElementOutput: "Auto", Type: "Continuous" }] });
  }
  return e14;
}
function pAt(e14, t10) {
  var n10, r10, o10, a10, i10;
  return y(this, void 0, void 0, function* () {
    const s10 = (e15 = "", t11 = VRt.t("error.invalidReportDef", "Invalid report definition")) => ({ success: false, id: e15, errorText: t11 });
    if (null == e14 || "object" != typeof e14) return s10();
    const l10 = e14;
    let c10 = null;
    if (lAt(l10)) c10 = l10.definition;
    else if (function(e15) {
      return e15.hasOwnProperty("id") && !lAt(e15);
    }(l10)) {
      if ("string" != typeof l10.id) return s10(`${null !== (n10 = l10.id) && void 0 !== n10 ? n10 : ""}`, VRt.t("error.invalid-report-id", "Invalid report id"));
      try {
        c10 = yield t10(l10.id);
      } catch (e15) {
        return s10(l10.id, cAt(e15));
      }
    }
    if (null == c10 || "object" != typeof c10) return s10(`${null !== (o10 = null !== (r10 = l10.displayName) && void 0 !== r10 ? r10 : l10.id) && void 0 !== o10 ? o10 : ""}`);
    const u10 = Z.Model.Report.decode(c10);
    return "success" === u10.type ? { success: true, result: dAt(c10) } : s10(`${null !== (i10 = null !== (a10 = l10.displayName) && void 0 !== a10 ? a10 : l10.id) && void 0 !== i10 ? i10 : ""}`, u10.reason);
  });
}
const mAt = (e14, t10, n10) => e14.map((e15) => hAt(e15)).map((e15) => yAt(e15, n10)).map((e15) => function(e16, t11, n11) {
  var r10, o10, a10, i10, s10, l10, c10, u10, d10, p10, m10, h10, f10, g10, y10, v10, b10;
  e16.ReportSections ? e16.ReportSections.forEach((e17) => {
    var n12;
    e17.Page = Object.assign(Object.assign({}, uAt[t11].page), null !== (n12 = e17.Page) && void 0 !== n12 ? n12 : {});
  }) : e16.Page = Object.assign(Object.assign({}, uAt[t11].page), null !== (r10 = e16.Page) && void 0 !== r10 ? r10 : {});
  const { textbox: S10 } = n11;
  if (!S10) return e16;
  const C10 = gAt(e16, "textbox").length > 0;
  const x10 = function(e17) {
    function t12(e18) {
      return "object" != typeof e18 || null == e18 ? [] : Array.isArray(e18) ? [].concat(...e18.map(t12)) : "Type" in e18 && "Name" in e18 ? [e18.Name].concat(...Object.values(e18).map(t12)) : [].concat(...Object.values(e18).map(t12));
    }
    return t12(e17);
  }(e16);
  function w10(e17) {
    const t12 = kG(e17, x10);
    return x10.push(t12), t12;
  }
  const T10 = (e17) => Object.assign(Object.assign({}, e17), { Name: w10("TextBox") });
  const E10 = gAt(e16, "tablix");
  if (C10 && !n11.foundReportItems.has("tablix") || E10.length > 0) {
    const n12 = null !== (o10 = E10[0]) && void 0 !== o10 ? o10 : fAt("tablix", t11, e16);
    n12.Name = w10("Tablix"), n12.Body = null !== (a10 = n12.Body) && void 0 !== a10 ? a10 : {}, n12.Body.Rows = null !== (i10 = n12.Body.Rows) && void 0 !== i10 ? i10 : [], 0 === n12.Body.Rows.length && n12.Body.Rows.push({}), n12.Body.Rows.forEach((e17) => {
      var t12;
      e17.Cells = null !== (t12 = e17.Cells) && void 0 !== t12 ? t12 : [], 0 === e17.Cells.length && e17.Cells.push({}), e17.Cells.forEach((e18) => {
        var t13;
        "textbox" !== (null === (t13 = e18.Item) || void 0 === t13 ? void 0 : t13.Type) && e18.Item || (e18.Item = T10(S10));
      });
    }), n12.Corner = null !== (s10 = n12.Corner) && void 0 !== s10 ? s10 : [], 0 === n12.Corner.length && n12.Corner.push([]), n12.Corner.forEach((e17) => {
      0 === e17.length && e17.push({}), e17.forEach((e18) => {
        var t12;
        "textbox" !== (null === (t12 = e18.Item) || void 0 === t12 ? void 0 : t12.Type) && e18.Item || (e18.Item = T10(S10));
      });
    });
    const r11 = (e17) => {
      var t12, n13, o11;
      e17.Header = null !== (t12 = e17.Header) && void 0 !== t12 ? t12 : {}, "textbox" !== (null === (n13 = e17.Header.Item) || void 0 === n13 ? void 0 : n13.Type) && e17.Header.Item || (e17.Header.Item = T10(S10)), null === (o11 = e17.Children) || void 0 === o11 || o11.forEach(r11);
    };
    n12.ColumnHierarchy = null !== (l10 = n12.ColumnHierarchy) && void 0 !== l10 ? l10 : {}, n12.ColumnHierarchy.Members = null !== (c10 = n12.ColumnHierarchy.Members) && void 0 !== c10 ? c10 : [], 0 === n12.ColumnHierarchy.Members.length && n12.ColumnHierarchy.Members.push({}), n12.ColumnHierarchy.Members.forEach(r11), n12.RowHierarchy = null !== (u10 = n12.RowHierarchy) && void 0 !== u10 ? u10 : {}, n12.RowHierarchy.Members = null !== (d10 = n12.RowHierarchy.Members) && void 0 !== d10 ? d10 : [], 0 === n12.RowHierarchy.Members.length && n12.RowHierarchy.Members.push({}), n12.RowHierarchy.Members.forEach(r11);
  }
  const F10 = gAt(e16, "table");
  if (C10 && !n11.foundReportItems.has("table") || F10.length > 0) {
    const n12 = null !== (p10 = F10[0]) && void 0 !== p10 ? p10 : fAt("table", t11, e16);
    n12.Name = w10("Table");
    const r11 = (e17) => {
      var t12;
      e17.TableCells = null !== (t12 = e17.TableCells) && void 0 !== t12 ? t12 : [], e17.TableCells.forEach((e18) => {
        "textbox" === e18.Item.Type && (e18.Item = T10(S10));
      });
    };
    n12.Header = null !== (m10 = n12.Header) && void 0 !== m10 ? m10 : {}, n12.Header.TableRows = null !== (h10 = n12.Header.TableRows) && void 0 !== h10 ? h10 : [], n12.Header.TableRows.forEach(r11), n12.Details = null !== (f10 = n12.Details) && void 0 !== f10 ? f10 : {}, n12.Details.TableRows = null !== (g10 = n12.Details.TableRows) && void 0 !== g10 ? g10 : [], n12.Details.TableRows.forEach(r11), n12.Footer = null !== (y10 = n12.Footer) && void 0 !== y10 ? y10 : {}, n12.Footer.TableRows = null !== (v10 = n12.Footer.TableRows) && void 0 !== v10 ? v10 : [], n12.Footer.TableRows.forEach(r11), n12.TableGroups = null !== (b10 = n12.TableGroups) && void 0 !== b10 ? b10 : [], n12.TableGroups.forEach((e17) => {
      var t12, n13;
      e17.Footer = e17.Footer || {}, e17.Footer.TableRows = null !== (t12 = e17.Footer.TableRows) && void 0 !== t12 ? t12 : [], e17.Footer.TableRows.forEach(r11), e17.Header = e17.Header || {}, e17.Header.TableRows = null !== (n13 = e17.Header.TableRows) && void 0 !== n13 ? n13 : [], e17.Header.TableRows.forEach(r11);
    });
  }
  if (C10 && !n11.foundReportItems.has("checkbox")) {
    const n12 = fAt("checkbox", t11, e16);
    n12.Name = w10("CheckBox"), n12.Style = S10.Style;
  }
  return e16;
}(e15, t10, n10)).map((e15) => JSON.stringify(e15));
const hAt = (e14) => JSON.parse(JSON.stringify(e14));
const fAt = (e14, t10, n10) => {
  var r10, o10, a10, i10, s10, l10, c10;
  const u10 = hAt(uAt[t10][e14]);
  if (n10.Body) n10.Body.ReportItems = null !== (r10 = n10.Body.ReportItems) && void 0 !== r10 ? r10 : [], n10.Body.ReportItems.push(u10);
  else if (n10.FixedPage) 0 === n10.FixedPage.Pages.length && n10.FixedPage.Pages.push({}), n10.FixedPage.Pages[0].ReportItems = null !== (o10 = n10.FixedPage.Pages[0].ReportItems) && void 0 !== o10 ? o10 : [], n10.FixedPage.Pages[0].ReportItems.push(u10);
  else if (n10.ReportSections) {
    0 === n10.ReportSections.length && n10.ReportSections.push({ Type: "Continuous", Name: "ReportSection1" });
    const e15 = n10.ReportSections[0];
    "Continuous" === e15.Type ? (e15.Body = null !== (a10 = e15.Body) && void 0 !== a10 ? a10 : {}, e15.Body.ReportItems = null !== (i10 = e15.Body.ReportItems) && void 0 !== i10 ? i10 : [], e15.Body.ReportItems.push(u10)) : (e15.FixedPage = null !== (s10 = e15.FixedPage) && void 0 !== s10 ? s10 : {}, e15.FixedPage.Pages = null !== (l10 = e15.FixedPage.Pages) && void 0 !== l10 ? l10 : [], 0 === e15.FixedPage.Pages.length && e15.FixedPage.Pages.push({}), e15.FixedPage.Pages[0].ReportItems = null !== (c10 = e15.FixedPage.Pages[0].ReportItems) && void 0 !== c10 ? c10 : [], e15.FixedPage.Pages[0].ReportItems.push(u10));
  }
  return u10;
};
function gAt(e14, t10) {
  var n10, r10, o10, a10, i10, s10, l10, c10, u10, d10, p10;
  if ("Body" in e14) return t10 ? (null !== (r10 = null === (n10 = null == e14 ? void 0 : e14.Body) || void 0 === n10 ? void 0 : n10.ReportItems) && void 0 !== r10 ? r10 : []).filter((e15) => e15.Type === t10) : null !== (a10 = null === (o10 = null == e14 ? void 0 : e14.Body) || void 0 === o10 ? void 0 : o10.ReportItems) && void 0 !== a10 ? a10 : [];
  if ("FixedPage" in e14) return t10 ? (null !== (l10 = null === (s10 = null === (i10 = e14.FixedPage) || void 0 === i10 ? void 0 : i10.Pages) || void 0 === s10 ? void 0 : s10[0].ReportItems) && void 0 !== l10 ? l10 : []).filter((e15) => e15.Type === t10) : null !== (d10 = null === (u10 = null === (c10 = e14.FixedPage) || void 0 === c10 ? void 0 : c10.Pages) || void 0 === u10 ? void 0 : u10[0].ReportItems) && void 0 !== d10 ? d10 : [];
  if ("ReportSections" in e14) {
    const n11 = [];
    return (null !== (p10 = e14.ReportSections) && void 0 !== p10 ? p10 : []).forEach((e15) => n11.push(...gAt(e15, t10))), n11;
  }
  return [];
}
function yAt(e14, t10) {
  var n10, r10, o10, a10, i10, s10;
  let l10 = [];
  "Body" in e14 ? l10 = null !== (r10 = null === (n10 = null == e14 ? void 0 : e14.Body) || void 0 === n10 ? void 0 : n10.ReportItems) && void 0 !== r10 ? r10 : [] : "FixedPage" in e14 ? l10 = null !== (i10 = null === (a10 = null === (o10 = e14.FixedPage) || void 0 === o10 ? void 0 : o10.Pages) || void 0 === a10 ? void 0 : a10[0].ReportItems) && void 0 !== i10 ? i10 : [] : "ReportSections" in e14 && (null !== (s10 = e14.ReportSections) && void 0 !== s10 ? s10 : []).forEach((e15) => yAt(e15, t10));
  for (let e15 = 0; e15 < l10.length; e15++) t10.foundReportItems.has(l10[e15].Type) ? (l10.splice(e15, 1), e15--) : (t10.foundReportItems.add(l10[e15].Type), "textbox" === l10[e15].Type && (t10.textbox = l10[e15]));
  return e14;
}
function vAt() {
  return { descriptors: VRt.t("designer.fonts", { returnObjects: true, defaultValue: ["Arial", "Arial Black", "Comic Sans MS", "Courier New", "Geneva", "Georgia", "Helvetica", "Impact", "Lucida Console", "Meiryo", "Meiryo UI", "MingLiU", "MingLiU-ExtB", "MS Gothic", "MS Mincho", "MS PGothic", "MS PMincho", "MS Song", "MS UI Gothic", "NSimSun", "Osaka", "PMingLiU", "PMingLiU-ExtB", "SimSun", "SimSun-ExtB", "Song", "Tahoma", "Times New Roman", "Trebuchet MS", "Verdana", "Yu Gothic"] }).map((e14) => Array.isArray(e14) ? { name: e14[0], locals: e14, source: [] } : { name: e14, source: [] }) };
}
function bAt(e14) {
  const t10 = function(e15) {
    return "default" === e15 ? vAt().descriptors : "registered" === e15 ? n.getFonts() : [...vAt().descriptors, ...n.getFonts()];
  }(e14);
  return ((e15) => [...new Set(e15)])(t10.map((e15) => e15.name));
}
const SAt = _V("@ar-designer/app/document/setInfo", (e14) => e14);
const CAt = _V("@ar-designer/app/overlay/show", (e14) => ({ message: e14 }));
const xAt = _V("@ar-designer/app/overlay/hide");
const wAt = _V("@ar-designer/app/refreshResources");
const TAt = _V("@ar-designer/app/setSideBarTab", (e14) => ({ id: e14 }));
const EAt = _V("@ar-designer/app/setControlItems", (e14) => ({ controlItems: e14 }));
var FAt = [];
var MAt = 0;
function kAt(e14) {
  try {
    DAt(), e14();
  } finally {
    LAt();
  }
}
function PAt(e14) {
  FAt.push(e14), MAt || (DAt(), HAt());
}
function NAt(e14) {
  try {
    return DAt(), e14();
  } finally {
    HAt();
  }
}
function DAt() {
  MAt++;
}
function LAt() {
  MAt--;
}
function HAt() {
  var e14;
  for (LAt(); !MAt && void 0 !== (e14 = FAt.shift()); ) kAt(e14);
}
var IAt = function(e14) {
  return function(t10) {
    return e14.some(function(e15) {
      return OAt(e15)(t10);
    });
  };
};
var _At = function(e14) {
  return function(t10) {
    return e14(t10);
  };
};
var VAt = function(e14) {
  return function(t10) {
    return t10.type === String(e14);
  };
};
var RAt = function(e14) {
  return function(t10) {
    return t10.type === e14;
  };
};
var AAt = function() {
  return BGe;
};
function OAt(e14) {
  var t10 = "*" === e14 ? AAt : NGe(e14) ? VAt : DGe(e14) ? IAt : VGe(e14) ? VAt : PGe(e14) ? _At : RGe(e14) ? RAt : null;
  if (null === t10) throw new Error("invalid pattern: " + e14);
  return t10(e14);
}
var BAt = { type: yGe };
var zAt = function(e14) {
  return e14 && e14.type === yGe;
};
function $At() {
  var e14 = function() {
    var e15;
    var t11 = false;
    var n10 = [];
    var r10 = n10;
    var o10 = function() {
      r10 === n10 && (r10 = n10.slice());
    };
    var a10 = function() {
      t11 = true;
      var e16 = n10 = r10;
      r10 = [], e16.forEach(function(e17) {
        e17(BAt);
      });
    };
    return (e15 = {})[SGe] = true, e15.put = function(e16) {
      if (!t11) if (zAt(e16)) a10();
      else {
        var o11 = n10 = r10;
        for (var i10 = 0, s10 = o11.length; i10 < s10; i10++) {
          var l10 = o11[i10];
          l10[bGe](e16) && (l10.cancel(), l10(e16));
        }
      }
    }, e15.take = function(e16, n11) {
      var a11, i10;
      void 0 === n11 && (n11 = AAt), t11 ? e16(BAt) : (e16[bGe] = n11, o10(), r10.push(e16), e16.cancel = (a11 = function() {
        o10(), jGe(r10, e16);
      }, i10 = false, function() {
        i10 || (i10 = true, a11());
      }));
    }, e15.close = a10, e15;
  }();
  var t10 = e14.put;
  return e14.put = function(e15) {
    e15[CGe] ? t10(e15) : PAt(function() {
      t10(e15);
    });
  }, e14;
}
var WAt = 0;
var jAt = 1;
var ZAt = 2;
var GAt = 3;
function UAt(e14, t10) {
  var n10 = e14[gGe];
  PGe(n10) && (t10.cancel = n10), e14.then(t10, function(e15) {
    t10(e15, true);
  });
}
var qAt = 0;
var YAt = function() {
  return ++qAt;
};
var KAt;
function XAt(e14) {
  e14.isRunning() && e14.cancel();
}
var JAt = ((KAt = {})[oUe] = function(e14, t10, n10) {
  var r10 = t10.channel, o10 = void 0 === r10 ? e14.channel : r10, a10 = t10.pattern, i10 = t10.maybe;
  var s10 = function(e15) {
    e15 instanceof Error ? n10(e15, true) : !zAt(e15) || i10 ? n10(e15) : n10(EGe);
  };
  try {
    o10.take(s10, kGe(a10) ? OAt(a10) : null);
  } catch (e15) {
    return void n10(e15, true);
  }
  n10.cancel = s10.cancel;
}, KAt[aUe] = function(e14, t10, n10) {
  var r10 = t10.channel, o10 = t10.action, a10 = t10.resolve;
  PAt(function() {
    var t11;
    try {
      t11 = (r10 ? r10.put : e14.dispatch)(o10);
    } catch (e15) {
      return void n10(e15, true);
    }
    a10 && LGe(t11) ? UAt(t11, n10) : n10(t11);
  });
}, KAt.ALL = function(e14, t10, n10, r10) {
  var o10 = r10.digestEffect;
  var a10 = qAt;
  var i10 = Object.keys(t10);
  if (0 !== i10.length) {
    var s10 = eUe(t10, n10);
    i10.forEach(function(e15) {
      o10(t10[e15], a10, s10[e15], e15);
    });
  } else n10(DGe(t10) ? [] : {});
}, KAt[iUe] = function(e14, t10, n10, r10) {
  var o10 = r10.digestEffect;
  var a10 = qAt;
  var i10 = Object.keys(t10);
  var s10 = DGe(t10) ? YGe(i10.length) : {};
  var l10 = {};
  var c10 = false;
  i10.forEach(function(e15) {
    var t11 = function(t12, r11) {
      c10 || (r11 || QGe(t12) ? (n10.cancel(), n10(t12, r11)) : (n10.cancel(), c10 = true, s10[e15] = t12, n10(s10)));
    };
    t11.cancel = zGe, l10[e15] = t11;
  }), n10.cancel = function() {
    c10 || (c10 = true, i10.forEach(function(e15) {
      return l10[e15].cancel();
    }));
  }, i10.forEach(function(e15) {
    c10 || o10(t10[e15], a10, l10[e15], e15);
  });
}, KAt[sUe] = function(e14, t10, n10, r10) {
  var o10 = t10.context, a10 = t10.fn, i10 = t10.args;
  var s10 = r10.task;
  try {
    var l10 = a10.apply(o10, i10);
    if (LGe(l10)) return void UAt(l10, n10);
    if (HGe(l10)) return void cOt(e14, l10, s10.context, qAt, tUe(a10), false, n10);
    n10(l10);
  } catch (e15) {
    n10(e15, true);
  }
}, KAt.CPS = function(e14, t10, n10) {
  var r10 = t10.context, o10 = t10.fn, a10 = t10.args;
  try {
    var i10 = function(e15, t11) {
      MGe(e15) ? n10(t11) : n10(e15, true);
    };
    o10.apply(r10, a10.concat(i10)), i10.cancel && (n10.cancel = i10.cancel);
  } catch (e15) {
    n10(e15, true);
  }
}, KAt[lUe] = function(e14, t10, n10, r10) {
  var o10 = t10.context, a10 = t10.fn, i10 = t10.args, s10 = t10.detached;
  var l10 = r10.task;
  var c10 = function(e15) {
    var t11 = e15.context, n11 = e15.fn, r11 = e15.args;
    try {
      var o11 = n11.apply(t11, r11);
      if (HGe(o11)) return o11;
      var a11 = false;
      return UGe(function(e16) {
        return a11 ? { value: e16, done: true } : (a11 = true, { value: o11, done: !LGe(o11) });
      });
    } catch (e16) {
      return UGe(function() {
        throw e16;
      });
    }
  }({ context: o10, fn: a10, args: i10 });
  var u10 = function(e15, t11) {
    return e15.isSagaIterator ? { name: e15.meta.name } : tUe(t11);
  }(c10, a10);
  NAt(function() {
    var t11 = cOt(e14, c10, l10.context, qAt, u10, s10, void 0);
    s10 ? n10(t11) : t11.isRunning() ? (l10.queue.addTask(t11), n10(t11)) : t11.isAborted() ? l10.queue.abort(t11.error()) : n10(t11);
  });
}, KAt.JOIN = function(e14, t10, n10, r10) {
  var o10 = r10.task;
  var a10 = function(e15, t11) {
    if (e15.isRunning()) {
      var n11 = { task: o10, cb: t11 };
      t11.cancel = function() {
        e15.isRunning() && jGe(e15.joiners, n11);
      }, e15.joiners.push(n11);
    } else e15.isAborted() ? t11(e15.error(), true) : t11(e15.result());
  };
  if (DGe(t10)) {
    if (0 === t10.length) return void n10([]);
    var i10 = eUe(t10, n10);
    t10.forEach(function(e15, t11) {
      a10(e15, i10[t11]);
    });
  } else a10(t10, n10);
}, KAt[cUe] = function(e14, t10, n10, r10) {
  var o10 = r10.task;
  t10 === xGe ? XAt(o10) : DGe(t10) ? t10.forEach(XAt) : XAt(t10), n10();
}, KAt[uUe] = function(e14, t10, n10) {
  var r10 = t10.selector, o10 = t10.args;
  try {
    n10(r10.apply(void 0, [e14.getState()].concat(o10)));
  } catch (e15) {
    n10(e15, true);
  }
}, KAt.ACTION_CHANNEL = function(e14, t10, n10) {
  var r10 = t10.pattern;
  var o10 = function(e15) {
    void 0 === e15 && (e15 = rUe());
    var t11 = false;
    var n11 = [];
    return { take: function(r11) {
      t11 && e15.isEmpty() ? r11(BAt) : e15.isEmpty() ? (n11.push(r11), r11.cancel = function() {
        jGe(n11, r11);
      }) : r11(e15.take());
    }, put: function(r11) {
      if (!t11) {
        if (0 === n11.length) return e15.put(r11);
        n11.shift()(r11);
      }
    }, flush: function(n12) {
      t11 && e15.isEmpty() ? n12(BAt) : n12(e15.flush());
    }, close: function() {
      if (!t11) {
        t11 = true;
        var e16 = n11;
        n11 = [];
        for (var r11 = 0, o11 = e16.length; r11 < o11; r11++) (0, e16[r11])(BAt);
      }
    } };
  }(t10.buffer);
  var a10 = OAt(r10);
  var i10 = function t11(n11) {
    zAt(n11) || e14.channel.take(t11, a10), o10.put(n11);
  };
  var s10 = o10.close;
  o10.close = function() {
    i10.cancel(), s10();
  }, e14.channel.take(i10, a10), n10(o10);
}, KAt.CANCELLED = function(e14, t10, n10, r10) {
  n10(r10.task.isCancelled());
}, KAt.FLUSH = function(e14, t10, n10) {
  t10.flush(n10);
}, KAt.GET_CONTEXT = function(e14, t10, n10, r10) {
  n10(r10.task.context[t10]);
}, KAt.SET_CONTEXT = function(e14, t10, n10, r10) {
  var o10 = r10.task;
  WGe(o10.context, t10), n10();
}, KAt);
function QAt(e14, t10) {
  return e14 + "?" + t10;
}
function eOt(e14) {
  var t10 = e14.name, n10 = e14.location;
  return n10 ? t10 + "  " + QAt(n10.fileName, n10.lineNumber) : t10;
}
function tOt(e14) {
  var t10 = (n10 = function(e15) {
    return e15.cancelledTasks;
  }, r10 = e14, (o10 = []).concat.apply(o10, r10.map(n10)));
  var n10, r10, o10;
  return t10.length ? ["Tasks cancelled due to error:"].concat(t10).join("\n") : "";
}
var nOt = null;
var rOt = [];
var oOt = function(e14) {
  e14.crashedEffect = nOt, rOt.push(e14);
};
var aOt = function() {
  nOt = null, rOt.length = 0;
};
var iOt = function(e14) {
  nOt = e14;
};
var sOt = function() {
  var e14 = rOt[0], t10 = rOt.slice(1);
  var n10 = e14.crashedEffect ? function(e15) {
    var t11 = nUe(e15);
    return t11 ? t11.code + "  " + QAt(t11.fileName, t11.lineNumber) : "";
  }(e14.crashedEffect) : null;
  return ["The above error occurred in task " + eOt(e14.meta) + (n10 ? " \n when executing effect " + n10 : "")].concat(t10.map(function(e15) {
    return "    created by " + eOt(e15.meta);
  }), [tOt(rOt)]).join("\n");
};
function lOt(e14, t10, n10, r10, o10, a10, i10) {
  var s10;
  void 0 === i10 && (i10 = zGe);
  var l10 = WAt;
  var c10;
  var u10;
  var d10 = null;
  var p10 = [];
  var m10 = Object.create(n10);
  var h10 = function(e15, t11, n11) {
    var r11 = [];
    var o11;
    var a11 = false;
    function i11(e16) {
      t11(), l11(), n11(e16, true);
    }
    function s11(t12) {
      r11.push(t12), t12.cont = function(s12, l12) {
        a11 || (jGe(r11, t12), t12.cont = zGe, l12 ? i11(s12) : (t12 === e15 && (o11 = s12), r11.length || (a11 = true, n11(o11))));
      };
    }
    function l11() {
      a11 || (a11 = true, r11.forEach(function(e16) {
        e16.cont = zGe, e16.cancel();
      }), r11 = []);
    }
    return s11(e15), { addTask: s11, cancelAll: l11, abort: i11, getTasks: function() {
      return r11;
    } };
  }(t10, function() {
    p10.push.apply(p10, h10.getTasks().map(function(e15) {
      return e15.meta.name;
    }));
  }, f10);
  function f10(t11, n11) {
    if (n11) {
      if (l10 = ZAt, oOt({ meta: o10, cancelledTasks: p10 }), g10.isRoot) {
        var r11 = sOt();
        aOt(), e14.onError(t11, { sagaStack: r11 });
      }
      u10 = t11, d10 && d10.reject(t11);
    } else t11 === TGe ? l10 = jAt : l10 !== jAt && (l10 = GAt), c10 = t11, d10 && d10.resolve(t11);
    g10.cont(t11, n11), g10.joiners.forEach(function(e15) {
      e15.cb(t11, n11);
    }), g10.joiners = null;
  }
  var g10 = ((s10 = {})[wGe] = true, s10.id = r10, s10.meta = o10, s10.isRoot = a10, s10.context = m10, s10.joiners = [], s10.queue = h10, s10.cancel = function() {
    l10 === WAt && (l10 = jAt, h10.cancelAll(), f10(TGe, false));
  }, s10.cont = i10, s10.end = f10, s10.setContext = function(e15) {
    WGe(m10, e15);
  }, s10.toPromise = function() {
    return d10 || ((e15 = {}).promise = new Promise(function(t11, n11) {
      e15.resolve = t11, e15.reject = n11;
    }), d10 = e15, l10 === ZAt ? d10.reject(u10) : l10 !== WAt && d10.resolve(c10)), d10.promise;
    var e15;
  }, s10.isRunning = function() {
    return l10 === WAt;
  }, s10.isCancelled = function() {
    return l10 === jAt || l10 === WAt && t10.status === jAt;
  }, s10.isAborted = function() {
    return l10 === ZAt;
  }, s10.result = function() {
    return c10;
  }, s10.error = function() {
    return u10;
  }, s10);
  return g10;
}
function cOt(e14, t10, n10, r10, o10, a10, i10) {
  var s10 = e14.finalizeRunEffect(function(t11, n11, r11) {
    if (LGe(t11)) UAt(t11, r11);
    else if (HGe(t11)) cOt(e14, t11, c10.context, n11, o10, false, r11);
    else if (t11 && t11[vGe]) {
      (0, JAt[t11.type])(e14, t11.payload, r11, u10);
    } else r11(t11);
  });
  d10.cancel = zGe;
  var l10 = { meta: o10, cancel: function() {
    l10.status === WAt && (l10.status = jAt, d10(TGe));
  }, status: WAt };
  var c10 = lOt(e14, l10, n10, r10, o10, a10, i10);
  var u10 = { task: c10, digestEffect: p10 };
  return i10 && (i10.cancel = c10.cancel), d10(), c10;
  function d10(e15, n11) {
    try {
      var o11;
      n11 ? (o11 = t10.throw(e15), aOt()) : JGe(e15) ? (l10.status = jAt, d10.cancel(), o11 = PGe(t10.return) ? t10.return(TGe) : { done: true, value: TGe }) : o11 = XGe(e15) ? PGe(t10.return) ? t10.return() : { done: true } : t10.next(e15), o11.done ? (l10.status !== jAt && (l10.status = GAt), l10.cont(o11.value)) : p10(o11.value, r10, d10);
    } catch (e16) {
      if (l10.status === jAt) throw e16;
      l10.status = ZAt, l10.cont(e16, true);
    }
  }
  function p10(t11, n11, r11, o11) {
    void 0 === o11 && (o11 = "");
    var a11 = YAt();
    var i11;
    function l11(n12, o12) {
      i11 || (i11 = true, r11.cancel = zGe, e14.sagaMonitor && (o12 ? e14.sagaMonitor.effectRejected(a11, n12) : e14.sagaMonitor.effectResolved(a11, n12)), o12 && iOt(t11), r11(n12, o12));
    }
    e14.sagaMonitor && e14.sagaMonitor.effectTriggered({ effectId: a11, parentEffectId: n11, label: o11, effect: t11 }), l11.cancel = zGe, r11.cancel = function() {
      i11 || (i11 = true, l11.cancel(), l11.cancel = zGe, e14.sagaMonitor && e14.sagaMonitor.effectCancelled(a11));
    }, s10(t11, a11, l11);
  }
}
function uOt(e14, t10) {
  var n10 = e14.channel, r10 = void 0 === n10 ? $At() : n10, o10 = e14.dispatch, a10 = e14.getState, i10 = e14.context, s10 = void 0 === i10 ? {} : i10, l10 = e14.sagaMonitor, c10 = e14.effectMiddlewares, u10 = e14.onError, d10 = void 0 === u10 ? qGe : u10;
  for (var p10 = arguments.length, m10 = new Array(p10 > 2 ? p10 - 2 : 0), h10 = 2; h10 < p10; h10++) m10[h10 - 2] = arguments[h10];
  var f10 = t10.apply(void 0, m10);
  var g10 = YAt();
  var y10;
  if (l10 && (l10.rootSagaStarted = l10.rootSagaStarted || zGe, l10.effectTriggered = l10.effectTriggered || zGe, l10.effectResolved = l10.effectResolved || zGe, l10.effectRejected = l10.effectRejected || zGe, l10.effectCancelled = l10.effectCancelled || zGe, l10.actionDispatched = l10.actionDispatched || zGe, l10.rootSagaStarted({ effectId: g10, saga: t10, args: m10 })), c10) {
    var v10 = uA.apply(void 0, c10);
    y10 = function(e15) {
      return function(t11, n11, r11) {
        return v10(function(t12) {
          return e15(t12, n11, r11);
        })(t11);
      };
    };
  } else y10 = $Ge;
  var b10 = { channel: r10, dispatch: KGe(o10), getState: a10, sagaMonitor: l10, onError: d10, finalizeRunEffect: y10 };
  return NAt(function() {
    var e15 = cOt(b10, f10, s10, g10, tUe(t10), true, void 0);
    return l10 && l10.effectResolved(g10, e15), e15;
  });
}
function dOt(e14) {
  var t10 = void 0 === e14 ? {} : e14, n10 = t10.context, r10 = void 0 === n10 ? {} : n10, o10 = t10.channel, a10 = void 0 === o10 ? $At() : o10, i10 = t10.sagaMonitor, s10 = np(t10, ["context", "channel", "sagaMonitor"]);
  var l10;
  function c10(e15) {
    var t11 = e15.getState, n11 = e15.dispatch;
    return l10 = uOt.bind(null, aR({}, s10, { context: r10, channel: a10, dispatch: n11, getState: t11, sagaMonitor: i10 })), function(e16) {
      return function(t12) {
        i10 && i10.actionDispatched && i10.actionDispatched(t12);
        var n12 = e16(t12);
        return a10.put(t12), n12;
      };
    };
  }
  return c10.run = function() {
    return l10.apply(void 0, arguments);
  }, c10.setContext = function(e15) {
    WGe(r10, e15);
  }, c10;
}
const pOt = "@app/datapanel/RESET";
const mOt = "@app/datapanel/EDIT_PARAM";
const hOt = "@app/datapanel/OPEN_SMART_SUGGESTIONS";
const fOt = "@app/datapanel/RESET_ACTIVE_EDITOR";
const gOt = "@app/datapanel/TOGGLE_COMNVALUES";
const yOt = "@app/datapanel/TOGGLE_EXPAND_DATASET";
const vOt = { reset: () => Kz.action(pOt), editParameter: (e14) => Kz.action(mOt, { index: e14 }), resetActiveEditor: () => Kz.action(fOt), toggleCommonValues: (e14 = null) => Kz.action(gOt, { onOff: e14 }), toggleExpandDataSet: (e14) => Kz.action(yOt, { dataSetName: e14 }), openSmartSuggestions: (e14) => Kz.action(hOt, { dataSetName: e14 }) };
const bOt = "@app/datapanel/RUN_ADD_DATASET";
const SOt = "@app/datapanel/RUN_EDIT_DATASET";
const COt = "@app/datapanel/RUN_CREATE_DATASOURCE";
const xOt = "@app/datapanel/RUN_DELETE_DATASOURCE";
const wOt = (e14) => Kz.action(COt, { templateId: e14 }), TOt = (e14) => Kz.action(xOt, { dataSourceName: e14 }), EOt = (e14, t10, n10) => Kz.action(bOt, { template: t10, templateId: e14, dataSourceName: n10 }), FOt = (e14) => Kz.action(SOt, { dataSetName: e14 });
const MOt = { commonValuesExpanded: true, expandedDatasetName: null, activeEditor: null, smartSuggestions: null };
const kOt = (e14 = MOt, t10) => {
  switch (null == t10 ? void 0 : t10.type) {
    case mOt:
      return AV(e14, { activeEditor: { $set: { type: "param", parameterIndex: t10.payload.index } } });
    case hOt:
      return AV(e14, { activeEditor: { $set: { type: "smart" } }, smartSuggestions: { $set: { dataSetName: t10.payload.dataSetName } } });
    case fOt:
      return AV(e14, { activeEditor: { $set: null } });
    case gOt:
      return AV(e14, { commonValuesExpanded: { $apply: (e15) => !e15 } });
    case pOt:
      return MOt;
    case yOt: {
      const n10 = t10.payload.dataSetName;
      return AV(e14, { expandedDatasetName: { $apply: (e15) => e15 === n10 ? null : n10 } });
    }
    default:
      return /* @__PURE__ */ ((e15, t11) => e15)(e14);
  }
};
const POt = "@dlg/dataset/INIT";
const NOt = "@dlg/dataset/RESET";
const DOt = "@dlg/dataset/SET_PROPERTY";
const LOt = "@dlg/dataset/SET_VALIDATION";
const HOt = "@dlg/dataset/APPLY_SCHEMA";
const IOt = "@dlg/dataset/CHG_CURRENT";
const _Ot = "@dlg/dataset/SWITCH_QUERY_TYPE";
const VOt = "@dlg/dataset/SET_JPATH_DIRTY";
const ROt = "@dlg/dataset/SET_JPATH_TREE";
const AOt = "@dlg/dataset/STORE_EXPRESSIONS";
const OOt = "@dlg/dataset/CANCEL_SAVE";
const BOt = { init: (e14) => Kz.action(POt, { initParams: e14 }), reset: () => Kz.action(NOt), setProperty: (e14, t10) => Kz.action(DOt, { name: e14, value: t10 }), setValidation: (e14) => Kz.action(LOt, e14), applySchema: (e14, t10) => Kz.action(HOt, { parameters: e14, datasets: t10 }), changeCurrentDataset: (e14) => Kz.action(IOt, { index: e14 }), switchQueryType: (e14) => Kz.action(_Ot, { queryType: e14 }), setJpathDirty: () => Kz.action(VOt), setJpathTree: (e14) => Kz.action(ROt, { nodes: e14 }), storeExpressionValues: (e14) => Kz.action(AOt, { values: e14 }), cancelSave: () => Kz.action(OOt) };
const zOt = "@dlg/dataset/VALIDATE_POPULATE_FIELDS";
const $Ot = "@dlg/dataset/SAVE_AND_CLOSE_DIALOG";
const WOt = (e14, t10, n10) => Kz.action(zOt, { dataset: e14, usedNames: t10, expressionValues: n10 }), jOt = () => Kz.action($Ot);
const ZOt = (e14) => ({ type: "key", value: e14 });
function GOt(e14, t10) {
  const n10 = [];
  return e14.forEach((e15, r10) => {
    0 !== e15.length && (r10 > 0 && n10.length > 0 && n10.push(t10), n10.push(...e15));
  }), n10;
}
function UOt(e14) {
  var t10, n10, r10;
  const o10 = e14.startsWith("=") ? e14 : `="${e14.replace(/"/g, '""')}"`;
  const a10 = zl.Tools.tokenize(o10);
  const i10 = [];
  let s10 = "";
  let l10 = 0;
  let c10 = false;
  for (let e15 = 0; e15 < a10.length; e15++) {
    const u10 = null === (t10 = a10[e15]) || void 0 === t10 ? void 0 : t10.token;
    const d10 = null === (n10 = a10[e15 - 1]) || void 0 === n10 ? void 0 : n10.token;
    const p10 = null === (r10 = a10[e15 + 1]) || void 0 === r10 ? void 0 : r10.token;
    if (0 !== e15 || "=" !== u10) {
      if ("(" === u10 && l10++, ")" === u10 && l10--, l10 || ")" === u10) s10 += (s10 && /\s/.exec(o10[a10[e15].position.character - 1]) ? " " : "") + u10;
      else if ("&" !== u10 || !d10.startsWith('"') && !p10.startsWith('"')) if (u10.startsWith('"')) {
        s10 && i10.push({ type: "expression", value: s10 });
        const e16 = [...u10.replace(/^"|"$/g, "").replace(/""/g, '"')];
        let t11 = "";
        for (let n11 = 0; n11 < e16.length; n11++) {
          const r11 = e16[n11];
          '"' === r11 && "\\" !== e16[n11 - 1] && (c10 = !c10), "?" !== r11 && "&" !== r11 && ("\\" === e16[n11 - 1] || c10 || ";" !== r11 && "=" !== r11) ? t11 += r11 : (t11 && (i10.push({ type: "string", value: t11 }), t11 = ""), i10.push({ type: "string", value: r11 }));
        }
        t11 && (i10.push({ type: "string", value: t11 }), t11 = ""), s10 = "";
      } else s10 += (s10 && /\s/.exec(o10[a10[e15].position.character - 1]) ? " " : "") + u10;
    }
  }
  return s10 && i10.push({ type: "expression", value: s10 }), i10;
}
const qOt = { "\r": "\\r", "\n": "\\n", "	": "\\t", '"': '\\"', "=": "\\=", ";": "\\;" };
const YOt = Object.keys(qOt).reduce((e14, t10) => Object.assign(Object.assign({}, e14), { [qOt[t10]]: t10 }), {});
const KOt = (e14) => {
  var t10;
  return null !== (t10 = qOt[e14]) && void 0 !== t10 ? t10 : e14;
};
const XOt = (e14) => {
  var t10;
  return null !== (t10 = YOt[e14]) && void 0 !== t10 ? t10 : e14;
};
const JOt = (e14) => e14.replace(/\\r|\\n|\\t|\\"|\\=|\\;/g, XOt);
function QOt(e14) {
  let t10 = false;
  return e14.map((e15) => {
    switch (e15.type) {
      case "expression":
        return e15;
      case "string":
        return { type: "string", value: [...e15.value].map((e16, n10, r10) => {
          if ("\\" === e16) {
            if (!t10) {
              const t11 = JOt(`${e16}${r10[n10 + 1] || ""}`);
              return r10[n10 + 1] = "", t11;
            }
            return e16;
          }
          return '"' === e16 && "\\" !== r10[n10 - 1] ? (t10 = !t10, e16) : e16;
        }).join("") };
      default:
        throw new Error("Unexpected type.");
    }
  });
}
function eBt(e14, t10 = true) {
  if (0 === e14.length) return "";
  const n10 = t10 ? QOt : (e15) => e15;
  if (e14.every((e15) => "string" === e15.type)) return n10(e14).map((e15) => e15.value).join("");
  let r10 = "";
  return n10(e14).forEach((e15) => {
    r10.endsWith('"') && "string" === e15.type ? r10 = `${r10.replace(/"$/, "")}${e15.value.replace(/"/g, '""')}"` : r10 += `${r10 ? " & " : ""}${"string" === e15.type ? `"${e15.value.replace(/"/g, '""')}"` : e15.value}`;
  }), `=${r10}`;
}
function tBt(e14) {
  return eBt(function(e15) {
    let t10 = false;
    return e15.map((e16) => {
      switch (e16.type) {
        case "key":
          return { type: "string", value: e16.value };
        case "expression":
          return e16;
        case "string":
          return { type: "string", value: [...e16.value].map((e17, n10, r10) => '"' === e17 && "\\" !== r10[n10 - 1] ? (t10 = !t10, e17) : t10 ? e17 : KOt(e17)).join("") };
        default:
          throw new Error("Unexpected type.");
      }
    });
  }(e14), false);
}
function nBt(e14) {
  return function(e15) {
    const t10 = [];
    const n10 = [];
    let r10 = "";
    let o10 = [];
    for (let a10 = 0; a10 < e15.length; a10++) {
      if ("string" !== e15[a10].type && 0 !== t10.length) throw new Error(`Unexpected expression: ${e15[a10].value}`);
      if (0 === t10.length) for (let n11 = a10; n11 < e15.length; n11++) {
        if ("?" === e15[n11].value) {
          a10 = n11, 0 === t10.length && t10.push({ type: "string", value: "" });
          break;
        }
        if (t10.push(e15[n11]), n11 === e15.length - 1) {
          a10 = n11;
          break;
        }
      }
      if (t10.length > 0 && ("&" === e15[a10].value || "?" === e15[a10].value)) {
        (r10 || o10.length) && (n10.push({ key: r10, value: eBt(o10) }), r10 = "", o10 = []);
        for (let t11 = a10 + 1; t11 < e15.length; t11++) {
          if ("=" === e15[t11].value || "&" === e15[t11].value) {
            a10 = t11 + 1;
            break;
          }
          if ("string" !== e15[t11].type) throw new Error(`Unexpected expression in query name: ${e15[t11].value}`);
          r10 += e15[t11].value, a10 = t11;
        }
        for (let t11 = a10; t11 < e15.length; t11++) {
          if ("&" === e15[t11].value) {
            a10 = t11 - 1;
            break;
          }
          o10.push(e15[t11]), a10 = t11;
        }
      }
    }
    r10 && o10.length && n10.push({ key: r10, value: eBt(o10) });
    return { endpoint: eBt(t10), queries: n10 };
  }("string" == typeof e14 ? UOt(e14) : e14);
}
function rBt(e14, t10) {
  const n10 = UOt(e14);
  const r10 = GOt(t10.map(({ key: e15, value: t11 }) => [ZOt(`${e15}=`), ...UOt(t11)]), ZOt("&"));
  return r10.length > 0 && (n10.push(ZOt("?")), n10.push(...r10)), n10;
}
function oBt(e14) {
  const t10 = UOt(e14);
  const n10 = [];
  let r10 = [];
  for (let e15 = 0; e15 < t10.length; e15++) if ("string" !== t10[e15].type || ";" !== t10[e15].value) r10.push(t10[e15]);
  else {
    if (r10.length > 0) {
      let e16 = "";
      for (let t11 = 0; t11 < r10.length; t11++) {
        if ("=" === r10[t11].value || ";" === r10[t11].value) {
          n10.push({ key: e16, value: r10.slice(t11 + 1) });
          break;
        }
        if ("string" !== r10[t11].type) throw new Error(`Unexpected expression in key name: ${r10[t11].value}`);
        e16 += r10[t11].value;
      }
    }
    r10 = [];
  }
  if (r10.length > 0) {
    let e15 = "";
    for (let t11 = 0; t11 < r10.length; t11++) {
      if ("=" === r10[t11].value || ";" === r10[t11].value) {
        n10.push({ key: e15, value: r10.slice(t11 + 1) });
        break;
      }
      if ("string" !== r10[t11].type) {
        n10.push({ key: "", value: r10 });
        break;
      }
      e15 += r10[t11].value;
    }
  }
  return n10;
}
function aBt(e14, t10) {
  return e14.filter((e15) => e15.key.startsWith(t10)).map(({ key: e15, value: n10 }) => ({ key: e15.substr(t10.length), value: eBt(n10) }));
}
const iBt = "Header$";
function sBt(e14) {
  var t10, n10, r10;
  const o10 = oBt(e14);
  const a10 = eBt((null === (t10 = o10.find((e15) => "method" === e15.key)) || void 0 === t10 ? void 0 : t10.value) || []) || "GET";
  const i10 = nBt((null === (n10 = o10.find((e15) => "uri" === e15.key)) || void 0 === n10 ? void 0 : n10.value) || []);
  const s10 = ["uri", "method", "body", "jpath", "HasHeaders", "DataStartLine", "RowsSeparator", "ColumnsSeparator", "JoinRowsSeparators", "JoinColumnsSeparators"];
  return { rawSettings: o10, settings: Object.assign(Object.assign({}, i10), { headers: aBt(o10, iBt), method: { type: a10, body: eBt((null === (r10 = o10.find((e15) => "body" === e15.key)) || void 0 === r10 ? void 0 : r10.value) || []) }, others: o10.filter((e15) => !s10.includes(e15.key) && !e15.key.startsWith(iBt)).map(({ key: e15, value: t11 }) => ({ key: e15, value: eBt(t11) })) }) };
}
function lBt(e14, t10) {
  var n10, r10;
  const o10 = t10 && !t10.startsWith("JSON") ? uBt : cBt;
  const { endpoint: a10, queries: i10 } = nBt(e14.endpoint);
  const s10 = GOt([a10.length > 0 || i10.length > 0 || e14.queries.length > 0 ? [ZOt("uri="), ...rBt(a10, [...i10, ...e14.queries])] : [], "GET" !== e14.method.type ? ((e15, t11) => t11 ? [ZOt(`${e15}=`), ...UOt(t11)] : [])("method", e14.method.type) : [], "POST" === e14.method.type && e14.method.body ? [ZOt("body="), ...UOt(e14.method.body)] : [], ...o10(e14), ...e14.headers.map(({ key: e15, value: t11 }) => [ZOt(`${iBt}${e15}=`), ...UOt(t11)]), ...null !== (r10 = null === (n10 = e14.others) || void 0 === n10 ? void 0 : n10.map(({ key: e15, value: t11 }) => [ZOt(`${e15}=`), ...UOt(t11)])) && void 0 !== r10 ? r10 : []], ZOt(";"));
  return tBt(s10);
}
function cBt(e14) {
  return [e14.jpath ? [ZOt("jpath="), ...UOt(e14.jpath)] : []];
}
function uBt(e14) {
  return [void 0 !== e14.HasHeaders ? [ZOt("HasHeaders="), ...UOt(String(e14.HasHeaders))] : [], void 0 !== e14.DataStartLine ? [ZOt("DataStartLine="), ...UOt(String(e14.DataStartLine))] : [], e14.RowsSeparator ? [ZOt("RowsSeparator="), ...UOt(e14.RowsSeparator)] : [], e14.ColumnsSeparator ? [ZOt("ColumnsSeparator="), ...UOt(e14.ColumnsSeparator)] : [], void 0 !== e14.JoinRowsSeparators ? [ZOt("JoinRowsSeparators="), ...UOt(String(e14.JoinRowsSeparators))] : [], void 0 !== e14.JoinColumnsSeparators ? [ZOt("JoinColumnsSeparators="), ...UOt(String(e14.JoinColumnsSeparators))] : []];
}
const dBt = (e14) => !(e14.endpoint || e14.jpath || e14.headers.length || e14.headers.length || "GET" !== e14.method.type);
function pBt(e14) {
  switch (e14) {
    case "Int32":
    case "Int64":
    case "UInt64":
      return "Integer";
    case "Decimal":
    case "Float":
    case "Double":
    case "Number":
      return "Float";
    case "Bool":
      return "Boolean";
    case "String":
      return "String";
    case "Date":
    case "TimeSpan":
      return "DateTime";
    default:
      return null;
  }
}
const mBt = { Type: "filter", items: [], operator: "and" };
const hBt = { initialized: false, currentDatasetIndex: 0, datasets: [{ name: "", parent: null, fields: [], calculatedFields: [], level: 0, datasetName: null, filters: Object.assign({}, mBt) }], query: { type: "Text", path: "" }, validation: { status: "ok" }, jpathTree: { state: "empty", nodes: void 0 }, expressionValues: {}, initialState: { mode: "add", dataProvider: "JSON", datasetName: pX.Name, datasets: [pX], initialDatasets: [], lastValidQuery: { type: "Text", path: "" } } };
const fBt = (e14 = hBt, t10) => {
  var n10, r10;
  if (null == t10) return e14;
  switch (t10.type) {
    case POt: {
      const { initParams: e15 } = t10.payload;
      return "edit" === e15.mode ? function(e16, t11) {
        const { mode: n11, datasetName: r11, datasets: o10 } = t11;
        if ("edit" !== n11) throw new Error("incorrect initial parameters");
        const a10 = [];
        const i10 = [];
        function s10(e17, t12) {
          const { Name: n12, Query: r12, Fields: o11, $calculatedFields: a11, Filters: i11 } = e17;
          return { parent: bBt(r12.DataSourceName), name: n12, datasetName: n12, level: t12, fields: o11, calculatedFields: a11, filters: i11 };
        }
        function l10(e17, t12) {
          o10.forEach((n12) => {
            var r12;
            const o11 = s10(n12, t12);
            (null === (r12 = o11.parent) || void 0 === r12 ? void 0 : r12.dataset) === e17 && (a10.push(o11), o11.datasetName && i10.push(o11.datasetName), l10(n12.Name, t12 + 1));
          });
        }
        const c10 = o10.find((e17) => e17.Name === r11);
        if (!c10) throw new Error("incorrect initial parameters (dataset not found)");
        let u10 = c10;
        for (; ; ) {
          const e17 = bBt(u10.Query.DataSourceName);
          const t12 = o10.find((t13) => t13.Name === (null == e17 ? void 0 : e17.dataset));
          if (null == t12) break;
          u10 = t12;
        }
        if (a10.push(s10(u10, 0)), i10.push(u10.Name), l10(u10.Name, 1), null != a10[0].parent) throw new Error("incorrect dataset (expected root)");
        const { Query: { CommandText: d10 } } = u10;
        const p10 = gBt(d10, t11.dataProvider);
        const m10 = a10.findIndex((e17) => e17.datasetName === r11);
        return { initialized: true, query: p10, initialState: Object.assign(Object.assign({}, t11), { initialDatasets: i10, lastValidQuery: p10 }), datasets: a10, currentDatasetIndex: m10 >= 0 ? m10 : 0, validation: { status: "ok" }, jpathTree: { state: "filled", nodes: [] }, expressionValues: {} };
      }(0, e15) : function(e16) {
        const { datasetName: t11, datasets: n11 } = e16;
        const r11 = n11.find((e17) => e17.Name === t11);
        if (!r11) throw new Error("incorrect initial parameters (dataset not found)");
        const o10 = gBt(r11.Query.CommandText, e16.dataProvider);
        const a10 = [];
        const i10 = [];
        function s10(e17, t12) {
          const { Name: n12, Query: r12, Fields: o11, $calculatedFields: a11, Filters: i11 } = e17;
          return { parent: bBt(r12.DataSourceName), name: n12, datasetName: n12, level: t12, fields: o11, calculatedFields: a11, filters: i11 };
        }
        function l10(e17, t12) {
          n11.forEach((n12) => {
            var r12;
            const o11 = s10(n12, t12);
            (null === (r12 = o11.parent) || void 0 === r12 ? void 0 : r12.dataset) === e17 && (a10.push(o11), o11.datasetName && i10.push(o11.datasetName), l10(n12.Name, t12 + 1));
          });
        }
        return a10.push(s10(r11, 0)), i10.push(r11.Name), l10(r11.Name, 1), { initialized: true, query: o10, initialState: Object.assign(Object.assign({}, e16), { initialDatasets: [], lastValidQuery: o10 }), datasets: a10, currentDatasetIndex: 0, validation: { status: "ok" }, jpathTree: { state: "empty", nodes: void 0 }, expressionValues: {} };
      }(e15);
    }
    case NOt:
      return hBt;
    case DOt: {
      const { name: n11, value: r11 } = t10.payload;
      if ("query.type" === t10.payload.name) return fBt(e14, BOt.switchQueryType(r11));
      if ("currentDatasetIndex" === t10.payload.name) {
        const t11 = parseInt(r11, 10);
        return fBt(e14, BOt.changeCurrentDataset(t11));
      }
      return function(e15, t11) {
        var n12;
        if ("validating" !== e15.validation.status && t11.type === DOt && t11.payload.name.startsWith("query")) {
          let t12 = { status: "ok" };
          const r12 = null === (n12 = e15.initialState) || void 0 === n12 ? void 0 : n12.lastValidQuery;
          return JSON.stringify(e15.query) !== JSON.stringify(r12) && (t12 = { status: "needsValidation" }), AV(e15, { validation: { $set: t12 } });
        }
        return e15;
      }(AV(e14, function(e15, t11) {
        const n12 = {};
        return e15.split(".").reduce((e16, n13, r12, o10) => (0 === r12 && (e16.$dirty = { $set: true }), r12 === o10.length - 1 ? e16[n13] = { $set: t11 } : e16[n13] = {}, e16[n13]), n12), n12;
      }(n11, r11)), t10);
    }
    case LOt: {
      const n11 = { validation: { $set: t10.payload } };
      return "ok" === t10.payload.status && (n11.initialState = { lastValidQuery: { $set: e14.query } }), AV(e14, n11);
    }
    case HOt: {
      const { datasets: o10 } = t10.payload;
      const a10 = o10.slice().sort((e15, t11) => e15.level - t11.level);
      const i10 = [];
      for (const t11 of a10) if (0 === t11.level) i10.push(t11.name);
      else {
        const o11 = e14.datasets.find((e15) => e15.datasetName === t11.name && e15.level === t11.level);
        o11 && (null === (n10 = o11.parent) || void 0 === n10 ? void 0 : n10.dataset) === (null === (r10 = t11.parent) || void 0 === r10 ? void 0 : r10.dataset) && i10.find((e15) => {
          var t12;
          return e15 === (null === (t12 = o11.parent) || void 0 === t12 ? void 0 : t12.dataset);
        }) && i10.push(t11.name);
      }
      const s10 = a10.reduce((e15, t11) => {
        var n11;
        return e15[t11.name] = null !== (n11 = i10.find((e16) => e16 === t11.name)) && void 0 !== n11 ? n11 : `$$$#generated#${t11.level}#${t11.name}#$$$`, e15;
      }, {});
      return Object.assign(Object.assign({}, e14), { validation: { status: "ok" }, initialState: Object.assign(Object.assign({}, e14.initialState), { lastValidQuery: e14.query }), datasets: o10.map((e15) => ({ fields: e15.fields.map((e16) => ({ Name: e16.name, DataField: e16.dataField, Aggregate: void 0, DataType: void 0, Value: void 0 })), name: e15.name, datasetName: s10[e15.name], parent: e15.parent ? Object.assign(Object.assign({}, e15.parent), { dataset: s10[e15.parent.dataset] }) : e15.parent, level: e15.level, calculatedFields: [], filters: Object.assign({}, mBt) })), currentDatasetIndex: 0 });
    }
    case IOt: {
      const { index: n11 } = t10.payload;
      return n11 >= 0 && n11 < e14.datasets.length ? Object.assign(Object.assign({}, e14), { currentDatasetIndex: n11 }) : e14;
    }
    case _Ot:
      return "Text" === t10.payload.queryType && "JSON" === e14.query.type ? AV(e14, { query: { $set: { type: "Text", path: yBt(e14.query) } } }) : "JSON" === t10.payload.queryType && "Text" === e14.query.type ? AV(e14, { query: { $set: gBt(e14.query.path || "", e14.initialState.dataProvider) } }) : e14;
    case VOt:
      return AV(e14, { jpathTree: { state: { $set: "isdirty" } } });
    case ROt: {
      const { nodes: n11 } = t10.payload;
      return AV(e14, { jpathTree: { $set: { state: "filled", nodes: n11 } } });
    }
    case AOt:
      return AV(e14, { expressionValues: { $apply: (e15) => Object.assign(Object.assign({}, e15), t10.payload.values) } });
    case OOt:
      return e14;
    default:
      return /* @__PURE__ */ ((e15, t11) => e15)(e14);
  }
};
function gBt(e14, t10) {
  var n10;
  if (t10 === tAt || t10 === nAt) return Object.assign(Object.assign({ type: "JSON" }, function(e15) {
    var t11, n11, r11, o10, a10, i10;
    const { rawSettings: s10, settings: l10 } = sBt(e15);
    return Object.assign(Object.assign({}, l10), { HasHeaders: "true" === eBt((null === (t11 = s10.find((e16) => "HasHeaders" === e16.key)) || void 0 === t11 ? void 0 : t11.value) || []), DataStartLine: Number(eBt((null === (n11 = s10.find((e16) => "DataStartLine" === e16.key)) || void 0 === n11 ? void 0 : n11.value) || [])) || 0, RowsSeparator: eBt((null === (r11 = s10.find((e16) => "RowsSeparator" === e16.key)) || void 0 === r11 ? void 0 : r11.value) || []) || "\r\n", ColumnsSeparator: eBt((null === (o10 = s10.find((e16) => "ColumnsSeparator" === e16.key)) || void 0 === o10 ? void 0 : o10.value) || []) || ",", JoinRowsSeparators: "true" === eBt((null === (a10 = s10.find((e16) => "JoinRowsSeparators" === e16.key)) || void 0 === a10 ? void 0 : a10.value) || []), JoinColumnsSeparators: "true" === eBt((null === (i10 = s10.find((e16) => "JoinColumnsSeparators" === e16.key)) || void 0 === i10 ? void 0 : i10.value) || []) });
  }(e14)), { dataProvider: t10 });
  const r10 = function(e15) {
    var t11;
    const { rawSettings: n11, settings: r11 } = sBt(e15);
    return Object.assign(Object.assign({}, r11), { jpath: eBt((null === (t11 = n11.find((e16) => "jpath" === e16.key)) || void 0 === t11 ? void 0 : t11.value) || []) });
  }(e14);
  return dBt(r10) && e14 && (e14.trim().startsWith("$") || (null === (n10 = r10.others) || void 0 === n10 ? void 0 : n10.length)) ? { type: "Text", path: e14 } : Object.assign(Object.assign({ type: "JSON" }, r10), { dataProvider: t10 });
}
function yBt(e14) {
  switch (e14.type) {
    case "Text":
      return e14.path;
    case "JSON":
      return lBt(e14, e14.dataProvider);
    default:
      return "";
  }
}
const vBt = (e14, t10) => `$dataset:${e14}/${t10}`;
const bBt = (e14) => {
  const t10 = /^\$dataset:(.*)\/(.*)$/.exec(e14);
  return 3 === (null == t10 ? void 0 : t10.length) ? { dataset: t10[1], field: t10[2] } : null;
};
function SBt(e14) {
  switch (e14) {
    case "Integer":
    case "Float":
      return "Sum";
    default:
      return null;
  }
}
function CBt(e14 = { Query: {} }, t10, n10, r10) {
  const o10 = /(.+?)(\[(.+?)(\|(.+))?\])?$/;
  const a10 = t10.fields;
  for (const e15 of a10) {
    const t11 = o10.exec(e15.DataField);
    if (t11 && t11[3]) {
      const n11 = pBt(t11[3]);
      e15.DataType = null != n11 ? n11 : "";
      const r11 = SBt(n11);
      e15.Aggregate = null !== r11 ? r11 : void 0;
    }
  }
  const i10 = { Name: { $set: t10.name }, Fields: { $set: a10 }, $calculatedFields: { $set: t10.calculatedFields }, Filters: { $set: t10.filters } };
  return null != n10 && (i10.Query = { CommandText: { $set: yBt(n10) } }), null != r10 && (i10.Query || (i10.Query = {}), i10.Query = Object.assign(Object.assign({}, i10.Query), { DataSourceName: { $set: vBt(r10.dataset, r10.field) } })), AV(e14, i10);
}
function xBt(e14, t10, n10) {
  return CBt(e14, t10, n10);
}
function wBt({ initialState: e14, datasets: t10, query: n10 }) {
  if (null == e14) throw new Error("Invalid initial state");
  const r10 = "edit" === e14.mode ? e14.datasets : [];
  const o10 = [];
  const a10 = [];
  t10.forEach((i11, s10) => {
    var l10, c10;
    let u10 = null;
    if (null != i11.parent) {
      const e15 = (null === (l10 = t10.find((e16) => {
        var t11;
        return e16.datasetName === (null === (t11 = i11.parent) || void 0 === t11 ? void 0 : t11.dataset);
      })) || void 0 === l10 ? void 0 : l10.name) || (null === (c10 = i11.parent) || void 0 === c10 ? void 0 : c10.dataset) || "$cant-get-here";
      u10 = Object.assign(Object.assign({}, i11.parent), { dataset: e15 });
    }
    const d10 = r10.find((e15) => e15.Name === i11.datasetName);
    const p10 = CBt(d10, i11, 0 === s10 ? n10 : void 0, u10);
    if (0 === s10 && null == d10) {
      const t11 = e14.datasets[0];
      p10.Query.DataSourceName = t11.Query.DataSourceName;
    }
    null != d10 ? a10.push({ name: d10.Name, data: p10 }) : o10.push(p10);
  });
  const i10 = [];
  return e14.initialDatasets.filter((e15) => !t10.some((t11) => t11.datasetName === e15)).forEach((e15) => {
    const t11 = r10.find(({ Name: t12 }) => t12 === e15);
    t11 && i10.push(t11);
  }), { deleted: i10, updated: a10, inserted: o10 };
}
const TBt = "@dlg/datasource/INIT";
const EBt = "@dlg/datasource/RESET";
const FBt = "@dlg/datasource/SET_NAME";
const MBt = "@dlg/datasource/SET_DATA_FORMAT";
const kBt = "@dlg/datasource/SET_SOURCE_TYPE";
const PBt = "@dlg/datasource/SET_SETTINGS_MODE";
const NBt = "@dlg/datasource/SET_CONN_STRING";
const DBt = "@dlg/datasource/SET_PROPERTY";
const LBt = (e14) => Kz.action(TBt, { initParams: e14 }), HBt = () => Kz.action(EBt), IBt = (e14) => Kz.action(FBt, { name: e14 }), _Bt = (e14) => Kz.action(MBt, { dataFormat: e14 }), VBt = (e14) => Kz.action(kBt, { sourceType: e14 }), RBt = (e14) => Kz.action(PBt, { mode: e14 }), ABt = (e14) => Kz.action(NBt, { connectionString: e14 }), OBt = (e14, t10) => Kz.action(DBt, { name: e14, value: t10 });
const BBt = "Header$";
function zBt(e14, t10, n10) {
  var r10, o10, a10, i10, s10;
  try {
    const l10 = oBt(e14);
    if ("JSON" === t10) {
      const e15 = null === (r10 = l10.find((e16) => "jsondata" === e16.key)) || void 0 === r10 ? void 0 : r10.value;
      if ("embedded" === n10 || e15) {
        return { type: "parsed", dataFormat: t10, sourceType: "embedded", jsondata: eBt((null === (o10 = l10.find((e16) => "jsondata" === e16.key)) || void 0 === o10 ? void 0 : o10.value) || []) };
      }
      {
        const { endpoint: e16, queries: r11 } = nBt((null === (a10 = l10.find((e17) => "endpoint" === e17.key || "jsondoc" === e17.key)) || void 0 === a10 ? void 0 : a10.value) || []);
        return { type: "parsed", dataFormat: t10, sourceType: n10, endpoint: e16, queries: r11, headers: aBt(l10, BBt), others: l10.filter((e17) => "endpoint" !== e17.key && "jsondoc" !== e17.key && !e17.key.startsWith(BBt)).map(({ key: e17, value: t11 }) => ({ key: e17, value: eBt(t11) })) };
      }
    }
    if ("CSV" === t10) {
      if ("remote" === n10) {
        const { endpoint: e15, queries: r11 } = nBt((null === (i10 = l10.find((e16) => "endpoint" === e16.key)) || void 0 === i10 ? void 0 : i10.value) || []);
        return { type: "parsed", dataFormat: t10, sourceType: n10, endpoint: e15, queries: r11, headers: aBt(l10, BBt), others: l10.filter((e16) => "endpoint" !== e16.key && !e16.key.startsWith(BBt)).map(({ key: e16, value: t11 }) => ({ key: e16, value: eBt(t11) })) };
      }
      return { type: "parsed", dataFormat: t10, sourceType: n10, data: eBt((null === (s10 = l10.find((e15) => "data" === e15.key)) || void 0 === s10 ? void 0 : s10.value) || []) };
    }
    throw new Error(`Unknown data format or source type: ${t10}, ${n10}`);
  } catch (t11) {
    return { type: "parseError", connectionString: e14, errors: [t11.message] };
  }
}
function $Bt(e14) {
  var t10, n10;
  if ("parsed" === e14.type) {
    if ("remote" === e14.sourceType && ("JSON" === e14.dataFormat || "CSV" === e14.dataFormat)) {
      const { endpoint: r10, queries: o10 } = nBt(e14.endpoint);
      const a10 = GOt([[ZOt("endpoint="), ...rBt(r10, [...o10, ...e14.queries])], ...e14.headers.map(({ key: e15, value: t11 }) => [ZOt(`${BBt}${e15}=`), ...UOt(t11)]), ...null !== (n10 = null === (t10 = e14.others) || void 0 === t10 ? void 0 : t10.map(({ key: e15, value: t11 }) => [ZOt(`${e15}=`), ...UOt(t11)])) && void 0 !== n10 ? n10 : []], ZOt(";"));
      return tBt(a10);
    }
    if ("embedded" === e14.sourceType) {
      if ("JSON" === e14.dataFormat) return tBt([ZOt("jsondata="), ...UOt(e14.jsondata)]);
      if ("CSV" === e14.dataFormat) return tBt([ZOt("data="), ...UOt(e14.data)]);
    }
  }
  if ("raw" === e14.type || "parseError" === e14.type) return e14.connectionString;
  throw new Error("Invalid internal properties type.");
}
const WBt = (e14, t10) => {
  if ("JSON" === e14) {
    if ("remote" === t10) return QRt;
    if ("embedded" === t10) return eAt;
  }
  if ("CSV" === e14) {
    if ("remote" === t10) return tAt;
    if ("embedded" === t10) return nAt;
  }
  throw new Error(`${e14} or ${t10} are not implemented`);
};
const jBt = (e14) => {
  switch (e14) {
    case QRt:
      return { dataFormat: "JSON", sourceType: "remote" };
    case eAt:
      return { dataFormat: "JSON", sourceType: "embedded" };
    case tAt:
      return { dataFormat: "CSV", sourceType: "remote" };
    case nAt:
      return { dataFormat: "CSV", sourceType: "embedded" };
    default:
      throw new Error(VRt.t("error.dataProviderNotSupported", 'Data provider "{{provider}}" is not supported.', { provider: e14 }));
  }
};
const ZBt = (e14, t10) => {
  if ("remote" === t10) return { type: "parsed", dataFormat: e14, sourceType: t10, endpoint: "", headers: [], queries: [] };
  if ("embedded" === t10) {
    if ("JSON" === e14) return { type: "parsed", dataFormat: e14, sourceType: t10, jsondata: "" };
    if ("CSV" === e14) return { type: "parsed", dataFormat: e14, sourceType: t10, data: "" };
  }
  throw new Error(`${t10} or ${e14} are not implemented`);
};
const GBt = { initialized: false, dataFormat: "JSON", sourceType: "remote", name: "", properties: ZBt("JSON", "remote"), initialState: { mode: "add", template: { Name: "" } } };
const UBt = (e14 = GBt, t10) => {
  var n10, r10;
  if (!t10) return e14;
  switch (t10.type) {
    case TBt: {
      const { initParams: o11 } = t10.payload;
      switch (null == o11 ? void 0 : o11.mode) {
        case "add": {
          const { Name: e15, ConnectionProperties: { DataProvider: t11 = QRt } = {} } = o11.template;
          const r11 = null !== (n10 = o11.usedDatasourceNames) && void 0 !== n10 ? n10 : [];
          const a10 = Object.assign(Object.assign({}, o11), { usedDatasourceNames: r11 });
          const { dataFormat: i10, sourceType: s10 } = jBt(t11);
          return { initialized: true, name: e15, initialState: a10, properties: zBt(o11.template.ConnectionProperties.ConnectString, i10, s10), dataFormat: i10, sourceType: s10 };
        }
        case "edit": {
          const { Name: t11 = "", ConnectionProperties: { DataProvider: n11 = QRt, ConnectString: a10 = "" } = {} } = o11.initialData;
          try {
            let { dataFormat: i10, sourceType: s10 } = jBt(n11);
            const l10 = zBt(a10, i10, s10);
            "parsed" === l10.type && ({ dataFormat: i10, sourceType: s10 } = l10);
            const c10 = (null !== (r10 = o11.usedDatasourceNames) && void 0 !== r10 ? r10 : []).filter((e15) => e15 !== t11);
            const u10 = Object.assign(Object.assign({}, o11), { usedDatasourceNames: c10 });
            const d10 = "raw" === e14.properties.type && "parsed" === l10.type ? { type: "raw", connectionString: a10 } : l10;
            return { initialized: true, name: t11, initialState: u10, properties: d10, dataFormat: i10, sourceType: s10 };
          } catch (t12) {
            return Object.assign(Object.assign({}, e14), { initialized: true, properties: { type: "parseError", connectionString: a10, errors: [t12.message] } });
          }
        }
        default:
          return e14;
      }
    }
    case EBt:
      return GBt;
    case FBt:
      return Object.assign(Object.assign({}, e14), { name: t10.payload.name });
    case MBt: {
      const { dataFormat: n11 } = t10.payload;
      if ("parsed" === e14.properties.type && e14.dataFormat !== n11) {
        const t11 = ZBt(n11, e14.sourceType);
        return Object.assign(Object.assign({}, e14), { dataFormat: n11, properties: t11 });
      }
      return Object.assign(Object.assign({}, e14), { dataFormat: n11 });
    }
    case kBt: {
      const { sourceType: n11 } = t10.payload;
      if ("parsed" === e14.properties.type && e14.sourceType !== n11) {
        const t11 = ZBt(e14.dataFormat, n11);
        return Object.assign(Object.assign({}, e14), { sourceType: n11, properties: t11 });
      }
      return Object.assign(Object.assign({}, e14), { sourceType: n11 });
    }
    case NBt:
      const o10 = zBt(t10.payload.connectionString, e14.dataFormat, e14.sourceType);
      switch (e14.properties.type) {
        case "raw":
        case "parseError":
          return "parsed" === o10.type ? Object.assign(Object.assign({}, e14), { properties: { type: "raw", connectionString: t10.payload.connectionString } }) : Object.assign(Object.assign({}, e14), { properties: o10 });
        case "parsed":
          return Object.assign(Object.assign({}, e14), { properties: o10 });
        default:
          return e14;
      }
    case PBt:
      if ("parseError" !== e14.properties.type) switch (t10.payload.mode) {
        case "raw":
          if ("parsed" === e14.properties.type) {
            const t11 = $Bt(e14.properties);
            return Object.assign(Object.assign({}, e14), { properties: { type: "raw", connectionString: t11 } });
          }
          break;
        case "parsed":
          if ("raw" === e14.properties.type) {
            const t11 = zBt(e14.properties.connectionString, e14.dataFormat, e14.sourceType);
            if ("parsed" === t11.type) return Object.assign(Object.assign({}, e14), { properties: t11 });
          }
          break;
        default:
          return e14;
      }
      return e14;
    case DBt:
      return "name" === t10.payload.name ? UBt(e14, IBt(t10.payload.value)) : "connectionString" === t10.payload.name ? UBt(e14, ABt(t10.payload.value)) : "dataFormat" === t10.payload.name ? UBt(e14, _Bt(t10.payload.value)) : "sourceType" === t10.payload.name ? UBt(e14, VBt(t10.payload.value)) : "parsed" === e14.properties.type ? AV(e14, { properties: qBt(t10.payload.name, t10.payload.value) }) : e14;
    default:
      return /* @__PURE__ */ ((e15, t11) => e15)(e14);
  }
};
const qBt = (e14, t10) => {
  const n10 = {};
  return e14.split(".").reduce((e15, n11, r10, o10) => (e15[n11] = {}, r10 === o10.length - 1 && (e15[n11].$set = t10), e15[n11]), n10), n10;
};
const YBt = _V("@@DESTROY");
const KBt = { documentName: "", sideBarTab: "propsTab", overlay: { visible: false }, controlItems: [{ type: "about" }] };
const XBt = WV(0, { [SAt.type]: (e14, { payload: { id: t10, name: n10 } }) => Object.assign(Object.assign({}, e14), { documentId: t10, documentName: n10 }), [CAt.type]: (e14, { payload: { message: t10 } }) => Object.assign(Object.assign({}, e14), { overlay: { visible: true, message: t10 } }), [xAt.type]: (e14) => Object.assign(Object.assign({}, e14), { overlay: { visible: false } }), [TAt.type]: (e14, { payload: { id: t10 } }) => Object.assign(Object.assign({}, e14), { sideBarTab: t10 }), [EAt.type]: (e14, { payload: { controlItems: t10 } }) => Object.assign(Object.assign({}, e14), { controlItems: t10 }) }, (e14 = KBt) => e14);
const JBt = _V("@app/setDsTemplates", (e14) => ({ templates: e14 }));
const QBt = { id: "0", title: "Create dataset...", shouldEdit: true, template: { Name: "DataSet", Query: { DataSourceName: "", CommandText: "jpath=$" } } };
const ezt = [{ id: "0", title: "Create JSON datasource...", shouldEdit: true, template: { Name: "DataSource", ConnectionProperties: { DataProvider: "JSON" } }, datasets: [QBt] }];
const tzt = (e14 = ezt, t10) => (null == t10 ? void 0 : t10.type) === JBt.type ? t10.payload.templates : e14;
function nzt(e14) {
  const t10 = VRt.t("warning.unsavedChanges", "The report on this page has unsaved changes.");
  return Object.assign(e14, { returnValue: t10 }), t10;
}
const rzt = (e14) => (t10, n10) => {
  const r10 = e14(t10, n10);
  if ("object" != typeof window) return r10;
  const { hasUnsavedChanges: o10 } = r10;
  return o10 && !window.onbeforeunload ? window.onbeforeunload = nzt : !o10 && window.onbeforeunload && (window.onbeforeunload = null), r10;
};
const ozt = (e14) => /* @__PURE__ */ function(e15) {
  let t10 = false;
  return (n10, r10) => t10 ? n10 : YBt.match(r10) ? void (t10 = true) : e15(n10, r10);
}(lA({ app: XBt, core: rzt(_gt(e14)), dialogs: qV, panels: yRt({}), rdlxFieldPicker: Ree, tablixWizard: Det(e14), chartWizard: WXe(e14), dataPanel: kOt, dataSourceTemplates: tzt, dataSetDialog: fBt, dataSourceDialog: UBt }));
const azt = (e14) => {
  const t10 = sd.decode(e14);
  if ("error" === t10.type) throw new Error(t10.reason);
  return t10.value;
};
const izt = (e14) => {
  const t10 = ld.decode(e14);
  if ("error" === t10.type) throw new Error(t10.reason);
  return t10.value;
};
const szt = (e14) => sd.encode(e14);
const lzt = (e14) => ld.encode(e14);
function czt(e14, t10) {
  return (null == t10 ? void 0 : t10.includes(e14)) ? kG(e14, t10) : e14;
}
function uzt(e14, t10, n10) {
  const r10 = t10.find((t11) => t11.Name === e14);
  if (!r10) throw new Error(`Cannot find dataset "${e14}"`);
  const o10 = bBt(r10.Query.DataSourceName);
  return o10 ? uzt(o10.dataset, t10, n10) : n10.find((e15) => e15.Name === r10.Query.DataSourceName);
}
function dzt(e14) {
  var t10;
  const { DataProvider: n10, ConnectString: r10 } = e14.ConnectionProperties;
  if (n10 === QRt) {
    return (null === (t10 = oBt(r10).find((e15) => "jsondata" === e15.key)) || void 0 === t10 ? void 0 : t10.value) ? eAt : QRt;
  }
  return n10 === QRt || n10 === eAt || n10 === tAt || n10 === nAt ? n10 : null;
}
function* pzt(e14) {
  const { dataSourceTemplates: t10, core: { id: n10, document: { present: { content: r10 } } } } = yield yUe();
  try {
    if (!r10) return;
    const { DataSources: o10 } = r10;
    const { templateId: a10 } = e14.payload;
    const i10 = t10.find((e15) => e15.id === a10);
    if (null != i10) {
      const e15 = czt(i10.template.Name || "DataSource", o10.map((e16) => e16.Name));
      const t11 = Object.assign(Object.assign({}, azt(i10.template)), { Name: e15, $templateId: a10 });
      if (i10.shouldEdit) {
        const e16 = { mode: "add", template: t11, usedDatasourceNames: o10.map((e17) => e17.Name) };
        yield mUe(_A.of(n10).open("datasource", e16));
      } else yield mUe(U2.rdlxAddDataSource({ datasource: t11 }));
    }
  } catch (e15) {
    console.error(e15), f$t.of(n10).notifications.error(VRt.t("error.internalError", "Internal Error"), e15.message);
  }
}
function* mzt(e14) {
  const { core: { id: t10, document: { present: { content: n10 } } } } = yield yUe();
  try {
    const { dataSourceName: t11 } = e14.payload;
    const { DataSets: r10, DataSources: o10 } = n10;
    const a10 = o10.find((e15) => e15.Name === t11);
    if (!a10) return;
    const i10 = r10.filter((e15) => e15.Query.DataSourceName === t11).map((e15) => U2.rdlxRemoveDataSet({ dataSet: e15 })).concat(U2.rdlxRemoveDataSource({ dataSource: a10 }));
    yield mUe(rz(i10));
  } catch (e15) {
    console.error(e15), f$t.of(t10).notifications.error(VRt.t("error.internalError", "Internal Error"), e15.message);
  }
}
function hzt(e14, t10, n10) {
  const r10 = t10.filter(({ parent: t11 }) => (null == t11 ? void 0 : t11.dataset) === e14.originalName);
  const o10 = [];
  for (const a10 of r10) {
    const r11 = Object.assign(Object.assign({}, a10.def), { Name: czt(a10.def.Name, n10), Query: Object.assign(Object.assign({}, a10.def.Query), { DataSourceName: vBt(e14.name, a10.parent.field) }) });
    n10.push(r11.Name), o10.push(r11);
    const i10 = hzt({ name: r11.Name, originalName: a10.def.Name }, t10, [...n10]);
    n10.push(...i10.map((e15) => e15.Name)), o10.push(...i10);
  }
  return o10;
}
function* fzt(e14) {
  var t10;
  const { report: { DataSets: n10, DataSources: r10 }, instanceId: o10 } = yield yUe((e15) => ({ report: e15.core.document.present.content, instanceId: e15.core.id }));
  try {
    const { template: a10, templateId: i10, dataSourceName: s10 } = e14.payload;
    const l10 = izt(a10.template);
    const c10 = r10.find((e15) => e15.Name === s10);
    const u10 = Object.assign(Object.assign({}, l10), { Name: czt(a10.template.Name || "DataSet", n10.map((e15) => e15.Name)), Query: Object.assign(Object.assign({}, l10.Query), { DataSourceName: s10 }), $templateId: i10 });
    const d10 = [u10, ...hzt({ name: u10.Name, originalName: a10.template.Name }, (null !== (t10 = a10.nestedTemplates) && void 0 !== t10 ? t10 : []).map((e15) => izt(e15)).map((e15) => ({ def: e15, parent: bBt(e15.Query.DataSourceName) })), n10.map((e15) => e15.Name))];
    const p10 = dzt(c10);
    if (a10.shouldEdit && p10) {
      const e15 = { mode: "add", datasetName: u10.Name, datasets: d10, dataProvider: p10 };
      yield mUe(_A.of(o10).open("datasetNew", e15));
    } else yield mUe(rz(d10.map((e15) => U2.rdlxAddDataSet({ dataSet: e15 }))));
  } catch (e15) {
    console.error(e15), f$t.of(o10).notifications.error(VRt.t("error.internalError", "Internal Error"), e15.message);
  }
}
function* gzt(e14) {
  const { report: { DataSets: t10, DataSources: n10 }, instanceId: r10 } = yield yUe((e15) => ({ report: e15.core.document.present.content, instanceId: e15.core.id }));
  try {
    const { dataSetName: o10 } = e14.payload;
    const a10 = dzt(uzt(o10, t10, n10));
    if (a10) {
      const e15 = { mode: "edit", datasetName: o10, datasets: t10, dataProvider: a10 };
      yield mUe(_A.of(r10).open("datasetNew", e15));
    }
  } catch (e15) {
    console.error(e15), f$t.of(r10).notifications.error(VRt.t("error.internalError", "Internal Error"), e15.message);
  }
}
function* yzt() {
  yield mUe(vOt.reset());
}
function* vzt() {
  yield TUe(bOt, fzt), yield TUe(SOt, gzt), yield TUe(COt, pzt), yield TUe(xOt, mzt), yield TUe([ape.type, ipe.type, spe.type], yzt);
}
const bzt = () => ({ placeholderEmpty: VRt.t("commonEditorProps.placeholderEmpty", "<Empty>") });
const Szt = "@dlg/QVAL/STORE_VALUES";
const Czt = (e14) => Kz.action(Szt, { values: e14 });
var xzt = W(Ll());
const wzt = xzt("Parameters[!.]([\\pL_\\d]+)\\.Value", "g");
const Tzt = HD(XD);
const Ezt = (e14) => (null == e14 ? void 0 : e14.length) > 0;
const Fzt = { text: (e14, t10) => tp.createElement(Tzt, Object.assign({}, e14, { key: t10, validate: Ezt }, bzt())) };
const Mzt = (e14) => e14.replace(/\./g, "|||dot|||");
function kzt(e14) {
  const t10 = {};
  return Object.keys(e14).forEach((n10) => {
    var r10;
    const o10 = ((e15) => xzt.replace(e15, wzt, "@$1"))(n10);
    t10[n10] = { title: o10, value: (null === (r10 = e14[n10]) || void 0 === r10 ? void 0 : r10.toString()) || "" };
  }), t10;
}
const Pzt = (e14) => {
  const { values: t10 } = e14;
  const { dispatch: n10, closeDialog: r10 } = RA();
  const [o10, a10] = ep.useState(kzt(t10));
  const i10 = () => r10();
  const s10 = Object.keys(o10).every((e15) => Ezt(o10[e15].value));
  const l10 = { text: VRt.t("queryValuesDialog.btnSave", "Save & Run"), accent: s10 ? "full" : "none", onClick: () => {
    s10 && (n10(Czt(o10)), r10());
  } };
  const c10 = { open: true, title: VRt.t("queryValuesDialog.title", "Parameter Values"), shouldCloseOnOverlayClick: false, onClose: i10, controls: { align: "spread", left: [], right: [l10, { text: VRt.t("dialogs.cancel", "Cancel"), onClick: i10 }] }, hideCloseButton: true, customCSS: "ed-dataset-dialog" };
  const u10 = Object.keys(o10).reduce((e15, t11) => Object.assign(Object.assign({}, e15), { [Mzt(t11)]: o10[t11].value }), { name: "$$$values" });
  const d10 = Object.keys(o10).map((e15) => $N("", o10[e15].title, "text", Mzt(e15), "both"));
  return tp.createElement(Hk, Object.assign({}, c10), tp.createElement("div", { className: "ed-dataset-dialog__content" }, tp.createElement(wD, { descriptors: d10, setProperty: (e15, t11) => {
    const n11 = e15.valuePath.replace(/\|\|\|dot\|\|\|/g, ".");
    a10(Object.assign(Object.assign({}, o10), { [n11]: Object.assign(Object.assign({}, o10[n11]), { value: t11 }) }));
  }, propertyEditors: Fzt, objectValue: u10 })));
};
Pzt.displayName = "QueryValuesDialog";
const Nzt = zl.createCompiler();
function Dzt(e14, t10) {
  const n10 = UOt(e14).map((e15) => {
    var n11;
    return "string" === e15.type ? e15 : { type: "string", value: null !== (n11 = t10[e15.value]) && void 0 !== n11 ? n11 : "" };
  });
  return eBt(n10);
}
function Lzt(e14, t10) {
  try {
    const n10 = Nzt(e14);
    const r10 = zl.Tools.Variant.isVariant(n10) ? n10 : n10(t10);
    return null != r10.Value ? `${r10.Value}` : "";
  } catch (e15) {
    return "";
  }
}
function Hzt(e14, t10, n10) {
  const r10 = e14.datasets.map((e15) => {
    var r11;
    return e15.name === t10 ? Object.assign(Object.assign({}, e15), { name: n10 }) : (null === (r11 = e15.parent) || void 0 === r11 ? void 0 : r11.dataset) === t10 ? Object.assign(Object.assign({}, e15), { parent: Object.assign(Object.assign({}, e15.parent), { dataset: n10 }) }) : e15;
  });
  return Object.assign(Object.assign({}, e14), { datasets: r10 });
}
function* Izt(e14) {
  var t10, n10;
  const { instanceId: r10, report: o10 } = yield yUe((e15) => ({ instanceId: e15.core.id, report: e15.core.document.present.content }));
  const { getDataSetSchema: a10 } = KO.of(r10);
  const { DataSources: i10, DataSets: s10, ReportParameters: l10 } = o10;
  yield mUe(BOt.setValidation({ status: "validating" }));
  const { dataset: c10 } = e14.payload;
  const u10 = i10.find((e15) => e15.Name === (null == c10 ? void 0 : c10.Query.DataSourceName));
  var d10, p10;
  if (null != u10) try {
    const [o11, i11] = [lzt(c10), szt(u10)];
    const m10 = function(e15, t11) {
      const n11 = {};
      return e15.forEach((e16) => UOt(e16).forEach((e17) => {
        "expression" === e17.type && (n11[e17.value] = Lzt(`=${e17.value}`, t11));
      })), n11;
    }([u10.ConnectionProperties.ConnectString, c10.Query.CommandText], function(e15) {
      const t11 = (e16) => "string" == typeof e16 ? Lzt(e16, { Data: {} }) : e16;
      return { Data: { parameters: e15.reduce((e16, n11) => {
        const r11 = n11.DefaultValue.Values;
        return r11.length && (e16[n11.Name.toLowerCase()] = n11.MultiValue ? r11.map(t11) : t11(r11[0])), e16;
      }, {}) } };
    }(l10));
    if (!function(e15) {
      return 0 === Object.keys(e15).length;
    }(m10)) {
      const a11 = function(e15, t11) {
        return Object.keys(e15).reduce((n11, r11) => {
          var o12, a12;
          return Object.assign(Object.assign({}, n11), { [r11]: null !== (a12 = null !== (o12 = t11[r11]) && void 0 !== o12 ? o12 : e15[r11]) && void 0 !== a12 ? a12 : "" });
        }, {});
      }(m10, e14.payload.expressionValues);
      const s11 = { values: a11 };
      yield mUe(_A.of(r10).open("queryValues", s11));
      const { run: l11, cancel: c11 } = yield (d10 = { run: pUe(Szt), cancel: pUe("@core/dialogs/close") }, p10 = dUe(iUe, d10), p10.combinator = true, p10);
      if (null != c11) return void (yield mUe(BOt.setValidation({ status: "needsValidation" })));
      const { values: u11 } = l11.payload;
      const h11 = Object.keys(u11).reduce((e15, t11) => Object.assign(Object.assign({}, e15), { [t11]: u11[t11].value }), {});
      yield mUe(BOt.storeExpressionValues(h11)), (null === (t10 = i11.ConnectionProperties) || void 0 === t10 ? void 0 : t10.ConnectString) && (i11.ConnectionProperties.ConnectString = Dzt(i11.ConnectionProperties.ConnectString, h11)), (null === (n10 = o11.Query) || void 0 === n10 ? void 0 : n10.CommandText) && (o11.Query.CommandText = Dzt(o11.Query.CommandText, h11));
    }
    const h10 = yield fUe(a10, { dataSource: i11, dataSet: o11 });
    !function({ datasets: e15 }) {
      for (let t11 = 0; t11 < e15.length; t11++) {
        if (e15.findIndex((n12) => n12.name === e15[t11].name) !== t11) throw new Error(`Duplicate datasets names: ${e15[t11].name}`);
        const n11 = (e15[t11].fields || []).filter((e16, t12, n12) => n12.findIndex((t13) => e16 === t13) !== t12);
        if (n11.length > 0) throw new Error(`Duplicate fields: ${n11.map((e16) => `'${e16}'`).join(", ")} at ${e15[t11].name}`);
      }
    }(h10);
    const f10 = s10.map((e15) => e15.Name).filter((t11) => !e14.payload.usedNames.includes(t11));
    const g10 = function(e15, t11) {
      return e15.datasets.reduce(({ sch: e16, names: n11 }, r11) => {
        if (!t11.includes(r11.name)) return { sch: e16, names: n11 };
        const o12 = kG(r11.name, n11);
        return { sch: Hzt(e16, r11.name, o12), names: [...n11, o12] };
      }, { sch: e15, names: t11 }).sch;
    }(h10, f10);
    yield mUe(BOt.applySchema(g10.parameters, g10.datasets)), yield mUe(BOt.setValidation({ status: "ok" }));
  } catch (e15) {
    yield mUe(BOt.setValidation({ status: "failed", errorMessages: e15.message || e15.toString() }));
  }
  else yield mUe(BOt.setValidation({ status: "failed", errorMessages: "Data source not found" }));
}
function* _zt() {
  try {
    const { instanceId: e14, dataSetDialogState: t10 } = yield yUe((e15) => ({ instanceId: e15.core.id, dataSetDialogState: e15.dataSetDialog }));
    yield mUe(BOt.reset()), yield mUe(rz(function(e15) {
      var t11;
      switch (null === (t11 = e15.initialState) || void 0 === t11 ? void 0 : t11.mode) {
        case "edit": {
          const { deleted: t12, updated: n10, inserted: r10 } = wBt(e15);
          const o10 = [...t12.map((e16) => U2.rdlxRemoveDataSet({ dataSet: e16 })), ...n10.map(({ name: e16, data: t13 }) => U2.rdlxSetDataSet({ dataSetName: e16, dataSet: t13 })), ...r10.map((e16) => U2.rdlxAddDataSet({ dataSet: e16 }))];
          return o10;
        }
        case "add": {
          const { deleted: t12, updated: n10, inserted: r10 } = wBt(e15);
          if (t12.length > 0 || n10.length > 0) throw new Error("invalid state, core dump");
          return r10.map((e16) => U2.rdlxAddDataSet({ dataSet: e16 }));
        }
        default:
          return [];
      }
    }(t10))), yield mUe(VV.close({ containerId: e14 }));
  } catch (e14) {
    yield mUe(BOt.setValidation({ status: "failed", errorMessages: y$t(e14) }));
  }
}
function* Vzt() {
  yield EUe(zOt, Izt), yield EUe($Ot, _zt);
}
class Rzt extends Error {
  constructor(e14, t10, n10, r10) {
    super(e14), this.response = t10, this.responseJSON = n10, this.responseText = r10, this.status = t10.status, this.statusText = t10.statusText, this.responseJSON = null != n10 ? n10 : {}, this.responseText = null != r10 ? r10 : "";
  }
}
const Azt = (e14) => void 0 !== e14.status;
const Ozt = _V("@ar-designer/documents/createNew", (e14) => e14);
const Bzt = _V("@ar-designer/documents/create", (e14) => e14);
_V("@ar-designer/documents/restore", (e14) => ({ id: e14 })), _V("@ar-designer/documents/dialog-results/restore", (e14) => ({ result: e14 }));
const zzt = _V("@ar-designer/documents/open", (e14) => e14);
const $zt = _V("@ar-designer/documents/load", (e14) => e14);
const Wzt = _V("@ar-designer/documents/save", (e14) => e14);
const jzt = _V("@ar-designer/documents/dialog-results/confirm-save", (e14) => ({ result: e14 }));
const Zzt = _V("@ar-designer/documents/preview", (e14) => e14);
const Gzt = { createDocument: Bzt, createNewDocument: Ozt, loadDocument: $zt, openDocument: zzt, previewDocument: Zzt, saveDocument: Wzt };
$A((e14) => e14.core.document.present, (e14) => e14);
const Uzt = $A((e14) => e14.core, ({ document: e14 }) => e14);
const qzt = $A((e14) => e14.core, (e14) => e14);
const Yzt = $A((e14) => e14.app, (e14) => e14);
const Kzt = $A((e14) => e14.app, ({ sideBarTab: e14 }) => e14);
$A((e14) => e14.app, ({ documentName: e14 }) => e14);
const Xzt = $A((e14) => e14.tablixWizard, (e14) => e14);
const Jzt = ["System", "Default", "DefaultDark", "DarkOled", "HighContrast", "HighContrastDark", "ActiveReports", "ActiveReportsDark"];
const Qzt = ["system", "default", "defaultDark", "darkOled", "highContrast", "highContrastDark"];
const e$t = ["activeReports", "activeReportsDark"];
const t$t = (e14, t10) => {
  var n10, r10;
  const o10 = "ja" === e14 ? (() => {
    const e15 = {};
    return e15.activeReports = Object.assign(Object.assign({}, uz.default), { name: "activeReports", accent: dm.fromHEX("#00A273"), accentText: dm.fromHEX("#00A273"), rulersSpanBackgroundPrimary: dm.fromHEX("#C0D8D1"), rulersSpanBackgroundSecondary: dm.fromHEX("#D6E3DF") }), e15.activeReportsDark = Object.assign(Object.assign({}, uz.defaultDark), { name: "activeReportsDark", accent: dm.fromHEX("#00A273"), accentText: dm.fromHEX("#00A273"), rulersSpanBackgroundPrimary: dm.fromHEX("#00e3a1").transparentize(0.8), rulersSpanBackgroundSecondary: dm.fromHEX("#00e3a1").transparentize(0.9) }), e15;
  })() : (() => {
    const e15 = {};
    return e15.activeReports = Object.assign(Object.assign({}, uz.default), { name: "activeReports", accent: dm.fromHEX("#ea8939"), accentText: dm.fromHEX("#e87b21"), accentSecondary: dm.fromHEX("#fecf00"), backgroundBody: dm.fromHEX("#f8ede3"), backgroundPanels: dm.fromHEX("#fdf7f1"), backgroundPanelsSection: dm.fromHEX("#ffdebf").transparentize(0.75), elemBackground: dm.fromHEX("#bf7f4a0d"), elemBackgroundHover: dm.fromHEX("#bf7f4a27"), btnGroupHeader: dm.fromHEX("#f6e5d7"), btnGroupHeaderHover: dm.fromHEX("#f2dac6"), backgroundPanelsBorder: dm.fromHEX("#e6cfbe").transparentize(0.25), dropdownBorder: dm.fromHEX("#e6cfbe").transparentize(0.25), bindingBound: dm.fromHEX("#fecf00"), rulersSpanBackgroundPrimary: dm.fromHEX("#ea8939").transparentize(0.7), rulersSpanBackgroundSecondary: dm.fromHEX("#ea8939").transparentize(0.85) }), e15.activeReportsDark = Object.assign(Object.assign({}, uz.defaultDark), { name: "activeReportsDark", accent: dm.fromHEX("#ea8939"), accentText: dm.fromHEX("#ff9945"), accentSecondary: dm.fromHEX("#fecf00"), rulersSpanBackgroundPrimary: dm.fromHEX("#ea8939").transparentize(0.7), rulersSpanBackgroundSecondary: dm.fromHEX("#ea8939").transparentize(0.85) }), e15;
  })();
  const a10 = null === (r10 = null === (n10 = null == t10 ? void 0 : t10.themeSelector) || void 0 === n10 ? void 0 : n10.availableThemes) || void 0 === r10 ? void 0 : r10.reduce((e15, t11) => {
    const n11 = r$t(t11);
    return n11 && e15.push(n11), e15;
  }, []);
  return a10 && Array.isArray(a10) && a10.length > 0 ? a10.map((e15) => o10[e15] || e15) : [...Qzt, ...Object.values(o10)];
};
function n$t(e14) {
  if (!e14) return;
  const t10 = e14[0].toUpperCase() + e14.substring(1);
  return Jzt.find((e15) => e15 === t10);
}
function r$t(e14) {
  if (!e14) return;
  const t10 = e14[0].toLowerCase() + e14.substring(1);
  return [...Qzt, ...e$t].find((e15) => e15 === t10);
}
function o$t(e14, t10, n10) {
  const r10 = function(e15, t11) {
    return e15 instanceof Rzt ? t11("error.errorCode", { code: e15.status }) : t11("notificationPanel.oneError", "Error");
  }(n10, t10);
  const o10 = function(e15) {
    return e15 instanceof Rzt ? cAt(e15) : e15 instanceof Error ? e15.message : "string" == typeof e15 ? e15 : void 0;
  }(n10);
  f$t.of(e14).notifications.error(r10, o10);
}
function a$t(e14, t10) {
  function* n10(n11) {
    const r11 = f$t.of(e14).app.about.applicationTitle;
    const o11 = t10("dialogs.confirmSavingChanges.wantSaveChanges", "Do you want to save changes to {{reportName}}?", { reportName: n11 });
    const a11 = [qA(t10("dialogs.confirmSavingChanges.saveLabel", "Save"), jzt("save"), true), qA(t10("dialogs.confirmSavingChanges.dontSaveLabel", "Don't save"), jzt("dontSave"), true)];
    const i11 = jzt("cancel");
    yield mUe(_A.of(e14).open("confirm", { title: r11, text: o11, choices: a11, onCancel: i11, noCancel: false }));
    const s11 = yield pUe(jzt.type);
    const { result: l11 } = s11.payload;
    return l11;
  }
  function* r10() {
    const t11 = f$t.of(e14).documents;
    if (!t11.hasUnsavedChanges()) return true;
    const { actionHandlers: r11 } = KO.of(e14);
    if (!(t11.isNew() ? !!r11.onSaveAs : !!r11.onSave)) return true;
    const { name: o11 } = t11.info();
    const a11 = yield fUe(n10, o11);
    if ("cancel" === a11) return false;
    if ("save" === a11) {
      if (!(yield fUe(d10, Gzt.saveDocument({}))).success) return false;
    }
    return true;
  }
  function o10(t11) {
    const n11 = KO.of(e14);
    const { createResourceProvider: r11 } = n11;
    if (!r11) return n11.resourceProvider;
    const o11 = r11(t11);
    return w$t(e14, o11);
  }
  function* a10(t11, n11, r11) {
    const { documentId: a11 } = Yzt(yield yUe());
    if (yield mUe(SAt({ id: n11, name: t11 })), kit.of(e14).updateDocumentInfo(t11), a11 !== n11 || r11) {
      KO.of(e14).resourceProvider = r11 || o10(n11);
    }
  }
  function* i10(e15) {
    const t11 = yield fUe(e15);
    const { rdlx: { sharedThemes: n11 } } = l9(yield yUe());
    const r11 = n11.items;
    const o11 = t11.length === r11.length;
    let a11 = !o11;
    if (o11) {
      a11 = zV.intersectionWith(t11, r11, zV.isEqual).length !== r11.length;
    }
    return a11 && (yield mUe(ppe({ themes: t11 }))), a11;
  }
  function* s10() {
    const { fetchThemes: t11 } = f$t.of(e14).settings.resourceProvider;
    yield i10(t11);
  }
  function* l10(e15) {
    const { resourceProvider: t11 } = e15;
    const { rdlx: { sharedThemes: n11 } } = l9(yield yUe());
    return { resourceProvider: t11, sharedThemes: n11 };
  }
  function* c10(e15, t11) {
    t11.resourceProvider = e15.resourceProvider, yield mUe(ppe({ themes: e15.sharedThemes.items }));
  }
  function u10(e15, t11) {
    return function* (n11) {
      yield mUe(CAt(t11)), yield e15(n11), yield mUe(xAt());
    };
  }
  function* d10({ payload: n11 }) {
    var r11, s11, l11;
    const { present: { type: c11, content: u11 } } = Uzt(yield yUe());
    if (!c11 || !u11) throw new Error(t10("error.noReportOpened", "No report currently opened"));
    const { documentName: d11, documentId: p11 } = Yzt(yield yUe());
    const m11 = n11.saveAs || !p11;
    let h11 = { type: c11, isFirstSave: !p11, saveAs: m11, success: false };
    try {
      const { actionHandlers: l12 } = KO.of(e14);
      const { serializeDocument: f11, removeDirty: g11 } = kit.of(e14);
      if ("rdlx" !== c11.platform || "report" !== c11.type && "dashboard" !== c11.type) throw new Error(t10("error.unsupportedDocumentType", "Internal error: unsupported document type"));
      const y11 = yield fUe(f11, { documentContent: u11, documentType: "rdlx" });
      if (m11) {
        if (!l12.onSaveAs) throw new Error("No saveAs handler defined");
        const e15 = yield l12.onSaveAs({ definition: y11, id: p11, displayName: d11 });
        if (e15) {
          const t11 = o10(e15.id);
          yield i10(t11.fetchThemes), h11 = Object.assign(Object.assign({}, h11), { success: true, id: e15.id, displayName: e15.displayName || e15.id });
        }
      } else {
        if (!l12.onSave) throw new Error("No save handler defined");
        const e15 = yield l12.onSave({ definition: y11, id: p11, displayName: d11 });
        e15 && (h11 = Object.assign(Object.assign({}, h11), { success: true, displayName: null !== (r11 = e15.displayName) && void 0 !== r11 ? r11 : d11, id: p11 }));
      }
      h11.success && (yield a10(h11.displayName, h11.id), yield fUe(g11)), null === (s11 = n11.onFinish) || void 0 === s11 || s11.call(n11, h11);
    } catch (r12) {
      o$t(e14, t10, r12), h11.success = false, null === (l11 = n11.onFinish) || void 0 === l11 || l11.call(n11, h11);
    }
    return h11;
  }
  const p10 = u10(d10, "");
  const m10 = u10(function* ({ payload: { options: n11, onFinish: s11 } }) {
    const { type: u11, whenDirty: d11, name: p11, id: m11 } = n11;
    const h11 = null != p11 ? p11 : t10("common.untitledReportName", "Untitled");
    const f11 = { type: u11, name: h11 };
    function g11(e15) {
      f11.success = e15, null == s11 || s11(f11);
    }
    if ("ask" === d11) {
      if (!(yield fUe(r10))) return g11(false), f11;
    }
    let y11 = [];
    const { createDocument: v10, removeDirty: b10 } = kit.of(e14);
    const S10 = KO.of(e14);
    const C10 = yield l10(S10);
    try {
      f$t.of(e14).notifications.dismissAll();
      const n12 = function(e15, t11) {
        if ("FPL" === e15) return { platform: "rdlx", type: "report", subType: "fpl" };
        if ("CPL" === e15) return { platform: "rdlx", type: "report", subType: "msl" };
        if ("Pageless" === e15) return { platform: "rdlx", type: "dashboard", subType: "msl" };
        throw new Error(t11("error.invalidReportType", "Invalid report type"));
      }(u11, t10);
      if ("rdlx" !== n12.platform) throw new Error("Unsupported document type");
      {
        const e15 = o10();
        S10.resourceProvider = e15, yield i10(e15.fetchThemes);
        const r11 = v10({ name: h11, type: n12 }, t10);
        if (S10.forceLoadPartsLibraries && (S10.rdlx.reportParts = { enabled: true, libraries: [] }, yield mUe(lWe.setAvailableLibraries([]))), r11.messages && (y11 = r11.messages), !r11.success) throw new Error("Unknown error while creating document");
      }
      y11.forEach(({ level: t11, caption: n13, content: r11 }) => {
        f$t.of(e14).notifications.send(t11, n13, r11);
      });
    } catch (n12) {
      return o$t(e14, t10, n12), yield c10(C10, S10), g11(false), f11;
    }
    return yield a10(h11, m11), yield fUe(b10), yield mUe(lO.ActionCreators.clearHistory()), g11(true), f11;
  }, "");
  function* h10({ payload: n11 }) {
    const { onFinish: o11 } = n11;
    const { actionHandlers: { onOpen: a11 } } = f$t.of(e14).settings;
    try {
      if (!a11) throw new Error("No onOpen handler specified");
      if (!(yield fUe(r10))) return void (null == o11 || o11({ success: false }));
      const e15 = yield fUe(a11);
      if (!e15) return void (null == o11 || o11({ success: false }));
      yield f10(Gzt.loadDocument({ options: { report: e15, whenDirty: "override" }, onFinish: o11 }));
    } catch (n12) {
      o$t(e14, t10, n12), null == o11 || o11({ success: false });
    }
  }
  const f10 = u10(function* ({ payload: n11 }) {
    var s11;
    const { options: { report: u11, whenDirty: d11 = "ask", isDirtyInitial: p11 = false }, onFinish: m11 } = n11;
    const h11 = u11.displayName || u11.id || t10("common.untitledReportName", "Untitled");
    const f11 = { id: u11.id, name: h11 };
    function g11(e15) {
      f11.success = e15, null == m11 || m11(f11);
    }
    let y11 = [];
    const v10 = kit.of(e14);
    const b10 = KO.of(e14);
    const S10 = yield l10(b10);
    const C10 = o10(u11.id);
    try {
      if ("ask" === d11) {
        if (!(yield fUe(r10))) return g11(false), f11;
      }
      let e15;
      if (lAt(u11)) e15 = u11.definition;
      else {
        const { id: t11 } = u11;
        const n13 = o10();
        e15 = yield n13.getResource(t11);
      }
      e15 = dAt(e15);
      const n12 = function(e16, t11) {
        var n13;
        if (e16.FixedPage) return { platform: "rdlx", type: "report", subType: "fpl" };
        if (e16.ReportSections) {
          const t12 = null === (n13 = e16.CustomProperties) || void 0 === n13 ? void 0 : n13.find((e17) => "ViewerType" === e17.Name);
          return "Dashboard" === (null == t12 ? void 0 : t12.Value) ? { platform: "rdlx", type: "dashboard", subType: "msl" } : { platform: "rdlx", type: "report", subType: "msl" };
        }
        throw new Error(t11("error.invalidReportType", "Invalid report type"));
      }(e15, t10);
      if (f11.type = function(e16, t11) {
        if ("rdlx" === e16.platform) {
          if ("report" === e16.type) {
            if ("fpl" === e16.subType) return "FPL";
            if ("msl" === e16.subType) return "CPL";
          }
          if ("dashboard" === e16.type && "msl" === e16.subType) return "Pageless";
        }
        throw new Error(t11("error.unsupportedDocumentType", "Internal error: unsupported document type"));
      }(n12, t10), b10.resourceProvider = C10, yield i10(C10.fetchThemes), b10.forceLoadPartsLibraries) {
        const t11 = (null !== (s11 = e15.Libraries) && void 0 !== s11 ? s11 : []).map((e16) => ({ path: e16.Path, name: e16.Name }));
        b10.rdlx.reportParts = { enabled: true, libraries: t11 }, yield mUe(lWe.setAvailableLibraries(t11));
      }
      const { messages: a11, success: l11 } = v10.loadDocument({ content: e15, type: n12, name: h11 }, t10);
      if (a11 && (y11 = a11), !l11) throw new Error("Unknown error while loading document");
    } catch (n12) {
      return function(e15, t11, n13, r11) {
        Azt(n13) ? o$t(e15, t11, n13) : f$t.of(e15).notifications.error(t11("error.reportLoadFailed", 'The report "{{reportName}}" could not be opened.', { reportName: r11 || "" }), n13.message);
      }(e14, t10, n12, h11), yield c10(S10, b10), g11(false), f11;
    }
    return yield a10(h11, f11.id, C10), p11 ? yield fUe(v10.setDirty) : yield fUe(v10.removeDirty), yield mUe(lO.ActionCreators.clearHistory()), g11(true), f11;
  }, "");
  function* g10({ payload: n11 }) {
    const { onFinish: o11 } = n11;
    const { actionHandlers: { onCreate: a11 } } = f$t.of(e14).settings;
    try {
      if (!a11) throw new Error("No onCreate handler specified");
      if (!(yield fUe(r10))) return void (null == o11 || o11({ success: false }));
      const e15 = yield fUe(a11);
      if (!e15) return void (null == o11 || o11({ success: false }));
      if (function(e16) {
        return !e16.hasOwnProperty("reportType");
      }(e15)) return void (yield f10(Gzt.loadDocument({ options: { report: e15 }, onFinish: o11 })));
      const t11 = Gzt.createNewDocument({ options: { type: e15.reportType, whenDirty: "override", name: e15.displayName, id: e15.id }, onFinish: o11 });
      yield m10(t11);
    } catch (n12) {
      o$t(e14, t10, n12), null == o11 || o11({ success: false });
    }
  }
  function* y10({ payload: n11 }) {
    var r11;
    const { onFinish: o11 } = n11;
    const a11 = f$t.of(e14);
    const { actionHandlers: { onRender: i11 }, resourceProvider: s11 } = a11.settings;
    if (!i11) return a11.notifications.warning("Preview is not supported."), void (null == o11 || o11());
    try {
      const { present: { content: n12 } } = Uzt(yield yUe());
      if (!n12) throw new Error(t10("error.noReportOpened", "No report currently opened"));
      const { documentId: o12, documentName: l11 } = Yzt(yield yUe());
      const { serializeDocument: c11 } = kit.of(e14);
      const u11 = c11({ documentType: "rdlx", documentContent: n12 });
      if (!u11) throw new Error(t10("error.errorSerializingReport", "Internal error: cannot serialize report"));
      const d11 = { id: o12, displayName: l11, definition: u11 };
      const p11 = null === (r11 = a11.store.getState()) || void 0 === r11 ? void 0 : r11.core.theme.name;
      yield i11(d11, s11, n$t(p11));
    } catch (n12) {
      o$t(e14, t10, n12);
    }
    null == o11 || o11();
  }
  return function* () {
    yield TUe(Gzt.createDocument.type, g10), yield TUe(Gzt.createNewDocument.type, m10), yield TUe(Gzt.loadDocument.type, f10), yield TUe(Gzt.openDocument.type, h10), yield TUe(Gzt.previewDocument.type, y10), yield TUe(Gzt.saveDocument.type, p10), yield TUe(wAt.type, s10);
  };
}
function* i$t(e14) {
  const { payload: { itemPaths: t10, reportLink: n10, nameDescriptor: r10 } } = e14;
  const o10 = xX(n10);
  if (!o10 || !o10.id) return;
  const a10 = [{ descriptor: r10, value: n10 }];
  yield mUe(rz(t10.map((e15) => U2.rdlxReportSetPropertiesByPath({ path: e15, descriptorValuePairs: a10 }))));
}
function s$t(e14, t10, n10) {
  function r10(e15) {
    return y(this, void 0, void 0, function* () {
      if (!e15) throw new Error("Invalid theme URI");
      const n11 = KO.of(t10);
      const r11 = yield n11.resourceProvider.getResource(e15);
      if (!r11 || !r11.Theme) {
        const t11 = VRt.t("error.theme.notFoundOrInvalid", "The theme '{{theme}}' used in this report either is not found or has invalid content.", { theme: e15 });
        throw new Error(t11);
      }
      return r11.Theme;
    });
  }
  const o10 = () => {
    const e15 = KO.of(t10);
    return { fetchImages: e15.resourceProvider.fetchImages, fetchReports: e15.resourceProvider.fetchReports, fetchMasterReports: () => Promise.resolve([]) };
  };
  return function* () {
    var e15;
    yield gUe(/* @__PURE__ */ function(e16, t11) {
      const n11 = (t12, n12, r12 = "") => {
        hm.of(e16).notifications.send({ type: "notification", payload: { level: t12, caption: n12, content: r12 } });
      };
      function* r11(r12) {
        var o12, a11;
        let i10;
        let s10;
        try {
          null === (o12 = tGe.of(e16)) || void 0 === o12 || o12.validateLibrary(r12), yield mUe(lWe.setLibraryLoadingStarted({ path: r12 }));
          const { resourceProvider: t12 } = KO.of(e16);
          i10 = yield t12.getResource(r12);
        } catch (e17) {
          const o13 = t11("error.libraries.loadingFailed", 'Library "{{path}}" loading failed', { path: r12, interpolation: { escapeValue: false } });
          yield mUe(lWe.setLibraryLoadingFailed({ path: r12, errorText: o13 })), n11("error", o13, `${e17}`);
        }
        if (i10) try {
          s10 = null === (a11 = tGe.of(e16)) || void 0 === a11 ? void 0 : a11.parseLibrary(r12, i10), yield mUe(lWe.setLibraryLoaded({ path: r12, parsedLibrary: s10 }));
        } catch (e17) {
          const o13 = t11("error.libraries.importFailed", 'Library "{{path}}" importing failed', { path: r12, interpolation: { escapeValue: false } });
          yield mUe(lWe.setLibraryInvalid({ path: r12, errorText: o13 })), n11("error", o13, `${e17}`);
        }
      }
      function* o11() {
        const { rdlx: { reportPartsLibraries: { libraries: e17 } } } = qzt(yield yUe());
        const t12 = e17.filter((e18) => "available" === e18.status);
        for (const { Path: e18 } of t12) yield r11(e18);
      }
      function* a10(e17) {
        const { content: { Libraries: o12 } } = e17.payload;
        const { rdlx: { reportPartsLibraries: { libraries: a11 } } } = qzt(yield yUe());
        const i10 = a11.map(({ Path: e18 }) => e18);
        for (const e18 of o12) i10.includes(e18.Path) ? yield r11(e18.Path) : n11("warning", t11("error.libraries.unknownLibrary.caption", "Report depends on unknown library"), t11("error.libraries.unknownLibrary.text", 'The library "{{libName}}" used in this report is not found', { libName: e18.Name }));
      }
      return function* () {
        yield EUe(ipe.type, a10), yield EUe(lWe.setLibrariesLoadingRequested.type, o11);
      };
    }(t10, n10)), yield gUe(a$t(t10, n10)), yield gUe(HRt(t10, n10)), yield gUe(/* @__PURE__ */ function(e16) {
      function* t11() {
        try {
          const { fetchImages: t12 } = e16();
          const n12 = yield t12();
          yield mUe(vpe.success(n12));
        } catch (e17) {
          yield mUe(vpe.failure(e17));
        }
      }
      function* n11() {
        try {
          const { fetchReports: t12 } = e16();
          const n12 = yield t12();
          yield mUe(Spe.success(n12));
        } catch (e17) {
          yield mUe(Spe.failure(e17));
        }
      }
      function* r11() {
        try {
          const { fetchMasterReports: t12 } = e16();
          const n12 = yield t12();
          yield mUe(xpe.success(n12));
        } catch (e17) {
          yield mUe(xpe.failure(e17));
        }
      }
      return function* () {
        yield TUe(ype.request, t11), yield TUe(bpe.request, n11), yield TUe(Cpe.request, r11);
      };
    }(o10)), yield TUe(U2.rdlxSelectSubreportName.type, i$t), yield gUe(/* @__PURE__ */ function(e16) {
      function* t11() {
        var _a2, _b2;
        const { type: t12, content: n11 } = Tz(yield yUe());
        if ("rdlx" !== (t12 == null ? void 0 : t12.platform) || !n11) return;
        const r11 = n11;
        const o11 = (_a2 = r11.$masterReportContent) == null ? void 0 : _a2.DataSets;
        if (!((o11 == null ? void 0 : o11.length) > 0 || r11.DataSets.length > 0)) return;
        const a10 = bj(r11);
        if (!a10) return;
        const i10 = (_b2 = r11.$index.NamedItems) == null ? void 0 : _b2.find((e17) => e17.name === a10.Name);
        if (!i10) return;
        const s10 = i10.$path || "";
        if ("tablix" === nz.of(e16).of("rdlx").getBaseType(a10.Type)) {
          const { rdlx: { reportItemsFeatures: { tablix: { canUseWizard: t13 } } } } = KO.of(e16);
          if (!t13) return;
          yield mUe(_A.of(e16).open("tablixWizard", { path: s10, report: r11 }));
        }
      }
      return function* () {
        yield EUe([p2.type, R5], t11);
      };
    }(t10)), yield gUe(/* @__PURE__ */ function(e16) {
      function* t11(e17) {
        yield mUe(OUe.deleteEmptyEncodings());
        const { chartModel: t12 } = yield yUe(BUe);
        const { path: n12, selection: r11 } = e17.payload;
        const o11 = [c5(n12, t12.Type), QG(t12)];
        r11 && o11.push(c5(r11)), yield mUe(rz(o11));
      }
      function* n11() {
        var _a2, _b2, _c2;
        const { type: t12, content: n12 } = Tz(yield yUe());
        if ("rdlx" !== (t12 == null ? void 0 : t12.platform) || !n12) return;
        const r11 = n12;
        const o11 = (_b2 = (_a2 = r11.$masterReportContent) == null ? void 0 : _a2.DataSets[0]) == null ? void 0 : _b2.Name;
        if (!((o11 == null ? void 0 : o11.length) > 0 || r11.DataSets.length > 0)) return;
        const a10 = bj(r11);
        if (!a10) return;
        const i10 = (_c2 = r11.$index.NamedItems) == null ? void 0 : _c2.find((e17) => e17.name === a10.Name);
        if (!i10) return;
        const s10 = i10.$path || "";
        const l10 = nz.of(e16).of("rdlx");
        if ("dvchart" !== l10.getBaseType(a10.Type)) return;
        const { rdlx: { reportItemsFeatures: { chart: { canUseWizard: c10 } } } } = KO.of(e16);
        if (!c10 || b6(r11)) return;
        const u10 = l10.getTemplates(a10.Type);
        if (!u10) return;
        const d10 = u10.length > 1;
        const p10 = d10 && 1 === r11.DataSets.length;
        const m10 = d10 && r11.DataSets.length > 1;
        const h10 = o11 || r11.DataSets[0].Name;
        const { Themes: f10 } = n12;
        const g10 = (a10.CustomProperties || []).find((e17) => "AllowWizard" === e17.Name);
        d10 && "True" !== (g10 == null ? void 0 : g10.Value) || (yield mUe(OUe.init(a10, s10, f10)), yield mUe(_A.of(e16).open("chartWizard", { shouldSkipSelectTypeStep: p10, shouldHidePlotTypeEditor: m10, defaultDataSetName: h10 })));
      }
      return function* () {
        yield EUe(PUe, t11), yield EUe([p2.type, R5], n11);
      };
    }(t10)), yield gUe(function({ getThemeContent: e16 }, t11, n11) {
      const r11 = (e17) => null !== e17.name && void 0 !== e17.name;
      function* o11(e17, t12, n12, r12 = false) {
        yield mUe(WUe(t12, n12, r12)), yield mUe(lO.ActionCreators.clearHistory()), e17 && (yield mUe(rB(void 0)));
      }
      function* a10(e17, t12 = false) {
        const { hasUnsavedChanges: n12 } = yield yUe(l9);
        if (r11(e17)) {
          const { id: r12, content: a11 } = e17;
          return r12 ? void (yield o11(!n12, a11, r12, t12)) : void (yield o11(!n12, $Ue, void 0, t12));
        }
        yield o11(!n12, $Ue, void 0, t12);
      }
      function* i10() {
        const { rdlx: { sharedThemes: { items: t12 }, defaultTheme: n12 } } = yield yUe(l9);
        if (!n12.id && !t12.length) return jUe(null);
        if (n12.id) return n12;
        const r12 = t12.find((e17) => e17.isDefault) || t12[0];
        try {
          const t13 = yield fUe(e16, r12.id);
          return jUe(t13, r12.id, r12.name);
        } catch (e17) {
          return { error: e17 };
        }
      }
      function* s10(e17, o12 = "") {
        const s11 = yield fUe(i10);
        const l11 = gc("rdl", e17);
        if (yield fUe(a10, s11, l11), !r11(s11) || l11) return;
        const c11 = n11("error:themes.textCannotLoad", "Report theme cannot be loaded");
        const u11 = [o12 || n11("error:themes.textNotFound", 'The theme "{{theme}}" used in this report is not found.', { theme: e17 }), s11.id ? n11("error:themes.textUseDefault", 'The default theme "{{theme}}" will be used instead.', { theme: s11.name }) : n11("error:themes.textNoThemes", "Please note there are no other themes available so now the report has no theme specified.")].join("\n\n");
        hm.of(t11).notifications.send({ type: "notification", payload: { level: "warning", caption: c11, content: u11 } });
      }
      function* l10({ id: t12, name: r12 }) {
        try {
          const n12 = yield fUe(e16, t12);
          yield mUe(hpe({ theme: n12, themeId: t12 }));
        } catch (e17) {
          const o12 = n11("error:themes.textTotFoundOrInvalid", "The theme {{theme}} used in this report either is not found or has invalid content.", { theme: r12 || t12 });
          yield fUe(s10, t12, o12);
        }
      }
      function* c10() {
        const { rdlx: { sharedThemes: e17 }, document: { present: { content: { Themes: t12 } } } } = yield yUe(l9);
        const n12 = t12[0];
        const r12 = n12 && xX(n12).id || null;
        if (!r12) return void (yield mUe(hpe({ theme: $Ue, themeId: "" })));
        const o12 = e17.items.find((e18) => e18.id === r12);
        o12 ? yield fUe(l10, o12) : yield fUe(s10, r12);
      }
      function* u10() {
        const e17 = yield fUe(i10);
        yield fUe(a10, e17);
      }
      function* d10() {
        const { document: { present: { content: { Themes: e17 } } } } = yield yUe(l9);
        (e17 == null ? void 0 : e17[0]) || (yield fUe(u10));
      }
      function* p10({ payload: { id: e17, name: t12 } }) {
        const { rdlx: { reportStyles: n12 = [] } } = yield yUe(l9);
        const r12 = n12.find((t13) => t13.id === e17) || n12.find((e18) => e18.name === t12);
        const o12 = v2({ id: e17, name: t12 });
        r12 ? yield mUe(rz([o12, b2({ style: r12.content })])) : yield mUe(o12);
      }
      return function* () {
        yield TUe([h2.type], c10), yield TUe([y2.type], p10), yield TUe([gpe.type], u10), yield TUe([spe.type], d10);
      };
    }({ getThemeContent: r10 }, t10, n10)), yield gUe(vzt), yield gUe(Vzt), yield pUe(YBt.type), yield (void 0 === e15 && (e15 = xGe), dUe(cUe, e15));
  };
}
const l$t = (e14, t10, n10) => {
  const r10 = dOt();
  let o10 = function() {
    for (var e15 = arguments.length, t11 = new Array(e15), n11 = 0; n11 < e15; n11++) t11[n11] = arguments[n11];
    return function(e16) {
      return function() {
        var n12 = e16.apply(void 0, arguments);
        var r11 = function() {
          throw new Error(rA(15));
        };
        var o11 = { getState: n12.getState, dispatch: function() {
          return r11.apply(void 0, arguments);
        } };
        var a11 = t11.map(function(e17) {
          return e17(o11);
        });
        return r11 = uA.apply(void 0, a11)(n12.dispatch), nA(nA({}, n12), {}, { dispatch: r11 });
      };
    };
  }(r10);
  const a10 = sA(ozt(e14), void 0, o10);
  return r10.run(s$t(0, e14, n10)), a10;
};
function c$t(e14) {
  const t10 = e14.getState();
  if (!t10) throw new Error("Redux state is empty!");
  return t10;
}
function u$t(e14) {
  let t10 = false;
  const n10 = [];
  function r10() {
    const r11 = n10.shift();
    r11 ? e14.dispatch(r11) : t10 = false;
  }
  function o10(r11) {
    t10 ? n10.push(r11) : (t10 = true, e14.dispatch(r11));
  }
  return { create: function() {
    return new Promise((e15) => {
      o10(Gzt.createDocument({ onFinish: (t11) => {
        e15(t11), r10();
      } }));
    });
  }, createNew: function(e15) {
    return new Promise((t11) => {
      o10(Gzt.createNewDocument({ options: e15, onFinish: (e16) => {
        t11(e16), r10();
      } }));
    });
  }, open: function() {
    return new Promise((e15) => {
      o10(Gzt.openDocument({ onFinish: (t11) => {
        e15(t11), r10();
      } }));
    });
  }, load: function(e15) {
    return new Promise((t11) => {
      o10(Gzt.loadDocument({ options: e15, onFinish: (e16) => {
        t11(e16), r10();
      } }));
    });
  }, save: function() {
    return new Promise((e15) => {
      o10(Gzt.saveDocument({ onFinish: (t11) => {
        e15(t11), r10();
      }, saveAs: false }));
    });
  }, saveAs: function() {
    return new Promise((e15) => {
      o10(Gzt.saveDocument({ onFinish: (t11) => {
        e15(t11), r10();
      }, saveAs: true }));
    });
  }, preview: function() {
    return new Promise((e15) => {
      o10(Gzt.previewDocument({ onFinish: () => {
        e15(), r10();
      } }));
    });
  }, hasUnsavedChanges: function() {
    const { core: { hasUnsavedChanges: t11 } } = c$t(e14);
    return t11;
  }, isNew: function() {
    const { app: { documentId: t11 } } = c$t(e14);
    return !t11;
  }, info: function() {
    const { app: { documentId: t11, documentName: n11 }, core: { document: { present: { type: r11 } } } } = c$t(e14);
    return { id: t11, name: n11, type: r11 };
  } };
}
const d$t = (e14) => {
  const t10 = () => hm.of(e14) || hm;
  const n10 = (e15, n11, r10) => t10().notifications.send({ type: "notification", payload: { level: e15, caption: n11, content: r10 } });
  return { send: n10, info: (e15, t11) => n10("info", e15, t11), error: (e15, t11) => n10("error", e15, t11), warning: (e15, t11) => n10("warning", e15, t11), dismissAll: () => t10().notifications.dismissAll() };
};
const p$t = (e14) => {
  const t10 = () => {
    var t11;
    return null === (t11 = e14.getState()) || void 0 === t11 ? void 0 : t11.core;
  };
  return { open: (n10) => {
    const r10 = t10();
    if (!r10) return;
    const { workspaceId: o10 } = r10;
    const a10 = lGe;
    Object.values(a10).includes(n10) && (e14.dispatch(tB({ workspaceId: o10, status: "panel" })), e14.dispatch(QO({ panelId: n10, workspaceId: o10 })));
  }, pin: () => {
    const n10 = t10();
    if (!n10) return;
    const { workspaceId: r10, menu: { editor: { pinned: o10, status: a10 } } } = n10;
    "collapsed" !== a10 && e14.dispatch(eB({ pinned: !o10, workspaceId: r10 }));
  }, close: () => {
    const n10 = t10();
    if (!n10) return;
    const { workspaceId: r10, menu: { editor: { pinned: o10 } } } = n10;
    o10 || (e14.dispatch(tB({ workspaceId: r10, status: "collapsed" })), e14.dispatch(QO({ workspaceId: r10, panelId: null })));
  } };
};
const m$t = (e14, t10) => {
  const n10 = hm.of(t10);
  return { open: (t11) => {
    t11 && (n10.sidebar.open(t11), e14.dispatch(TAt(t11)));
  }, close: () => {
    n10.sidebar.close();
  } };
};
const h$t = {};
function f$t(e14, t10, n10) {
  if (e14 in h$t) throw new Error(`DesignerAPI with id=${e14} already exists, use DesignerAPI.of`);
  const r10 = { app: { about: n10, focus: function() {
    const t11 = window.document.getElementById(e14);
    t11 && t11.focus();
  }, editor: Nit(e14, t10), panels: { menu: p$t(t10), sidebar: m$t(t10, e14) }, setControlItems: function(e15) {
    const n11 = (Array.isArray(e15) ? e15 : []).filter((e16) => !!(null == e16 ? void 0 : e16.type));
    t10.dispatch(EAt(n11));
  } }, documents: u$t(t10), notifications: d$t(e14), settings: KO.of(e14), store: t10 };
  return h$t[e14] = r10, r10;
}
f$t.of = (e14) => {
  if (e14 in h$t) return h$t[e14];
  throw new Error(`There is no DesignerAPI instance with id=${e14}`);
}, f$t.destroy = (e14) => {
  e14 in h$t && delete h$t[e14];
};
const g$t = (e14) => (t10, n10, r10) => () => y(void 0, void 0, void 0, function* () {
  try {
    return yield t10();
  } catch (t11) {
    return f$t.of(e14).notifications.error(r10, `${t11}`), n10;
  }
});
function y$t(e14) {
  return e14 instanceof Error ? e14.message : `${e14}`;
}
const v$t = (e14) => `${null != e14 ? e14 : ""}`;
const b$t = (e14) => null != e14 ? v$t(e14) : null;
const S$t = { report: ({ id: e14, displayName: t10 }, n10) => ({ id: v$t(e14), name: v$t(null != t10 ? t10 : e14), type: n10 }), theme: ({ id: e14, displayName: t10, info: n10 }) => ({ id: v$t(e14), name: v$t(null != t10 ? t10 : e14), isDefault: false, Colors: { Accent1: b$t(n10.Accent1), Accent2: b$t(n10.Accent2), Accent3: b$t(n10.Accent3), Accent4: b$t(n10.Accent4), Accent5: b$t(n10.Accent5), Accent6: b$t(n10.Accent6), Dark1: b$t(n10.Dark1), Dark2: b$t(n10.Dark2), Light1: b$t(n10.Light1), Light2: b$t(n10.Light2) }, Fonts: { MajorFontFamily: v$t(n10.MajorFontFamily), MinorFontFamily: v$t(n10.MinorFontFamily) } }), image: ({ id: e14, displayName: t10, mimeType: n10, thumbnail: r10 }) => {
  var o10;
  return { id: v$t(e14), mimeType: v$t(n10), thumbnail: v$t(null != r10 ? r10 : ""), name: v$t(null != t10 ? t10 : e14), value: v$t(null !== (o10 = bX(e14)) && void 0 !== o10 ? o10 : e14) };
} };
const C$t = () => y(void 0, void 0, void 0, function* () {
  return [];
});
const x$t = { getResourceUri: (e14) => e14, getResource: (e14) => function(e15) {
  return y(this, void 0, void 0, function* () {
    const t10 = yield fetch(e15);
    if (!t10.ok) throw new Rzt(t10.statusText, t10);
    return t10.json();
  });
}(e14), fork: () => x$t, getImagesList: C$t, getReportsList: C$t, getThemesList: C$t };
function w$t(e14, t10) {
  const n10 = Object.assign(Object.assign({}, x$t), t10);
  const { getImagesList: r10, getReportsList: o10, getThemesList: a10, getResource: i10, getResourceUri: s10, fork: l10 } = n10;
  const c10 = g$t(e14);
  const u10 = { getResourceUri: s10, getResource: i10, fork: l10, fetchReports: c10(() => y(this, void 0, void 0, function* () {
    var t11;
    const n11 = null === (t11 = f$t.of(e14).store.getState()) || void 0 === t11 ? void 0 : t11.core.document.present.type;
    const r11 = "dashboard" === (null == n11 ? void 0 : n11.type) ? "DBL" : "MSL";
    return (yield o10()).map((e15) => S$t.report(e15, r11));
  }), [], VRt.t("error.cantLoadReports", "Cannot load reports list")), fetchImages: c10(() => y(this, void 0, void 0, function* () {
    return (yield r10()).map(S$t.image);
  }), [], VRt.t("error.cantLoadImages", "Cannot load images list")), fetchThemes: c10(() => y(this, void 0, void 0, function* () {
    return (yield a10()).map(S$t.theme);
  }), [], VRt.t("error.cantLoadThemes", "Cannot load themes list")) };
  return u10;
}
function T$t(e14, t10) {
  return tp.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: `0 0 ${t10.width} ${t10.height}`, dangerouslySetInnerHTML: { __html: e14 } });
}
const E$t = ["en", "ja", "zh", "ko", "fr"];
const F$t = (e14) => {
  if ("string" != typeof e14) return null;
  const t10 = e14.toLowerCase();
  const [n10] = t10.split("-");
  return ((e15) => E$t.includes(e15))(n10) ? n10 : null;
};
const M$t = (e14) => {
  const t10 = F$t(e14);
  if (t10) return t10;
  const n10 = (null === navigator || void 0 === navigator ? void 0 : navigator.languages) || (null === navigator || void 0 === navigator ? void 0 : navigator.language) && [navigator.language] || [];
  for (const e15 of n10) {
    const t11 = F$t(e15);
    if (t11) return t11;
  }
  return null;
};
function k$t(e14) {
  if (e14) return { type: "font", iconCssClass: e14 };
  const t10 = VRt.t("application-logo", "");
  return t10 ? { type: "svg", content: T$t(t10, { width: 24, height: 24 }) } : zRt.menu.logo.icon;
}
function P$t(e14) {
  if (e14.defaultPropertyGridMode) return e14.defaultPropertyGridMode;
  const t10 = VRt.t("designer.defaultSettings.propertiesMode", "Basic");
  return "Basic" === t10 || "Advanced" === t10 ? t10 : zRt.propertyGrid.mode;
}
function N$t(e14) {
  const t10 = e14.toLowerCase();
  return "true" === t10 || "false" !== t10 && void 0;
}
function D$t() {
  var e14;
  return null !== (e14 = N$t(VRt.t("designer.defaultSettings.snapToGridEnabled", "false"))) && void 0 !== e14 ? e14 : zRt.editor.snapToGrid;
}
function L$t() {
  var e14;
  return null !== (e14 = N$t(VRt.t("designer.defaultSettings.snapToGuidesEnabled", "false"))) && void 0 !== e14 ? e14 : zRt.editor.snapToGuides;
}
function H$t(e14) {
  var t10, n10;
  const r10 = (e15) => "in" === e15 || "cm" === e15 ? e15 : null;
  return null !== (n10 = null !== (t10 = r10(e14)) && void 0 !== t10 ? t10 : r10(VRt.t("designer.defaultSettings.units", "in"))) && void 0 !== n10 ? n10 : qRt.userPreferences.units;
}
function I$t() {
  const e14 = VRt.t("designer.reportStyles", { returnObjects: true, defaultValue: [] });
  return Array.isArray(e14) && e14.length ? e14 : qRt.rdlx.reportStyles;
}
function _$t() {
  const e14 = VRt.t("designer.dateFormats", { returnObjects: true, defaultValue: [] });
  if (Array.isArray(e14) && e14.length > 0) return e14;
}
function V$t(e14, t10, n10) {
  var r10, o10, a10, i10, s10, l10, c10, u10, d10, p10, h10, f10;
  return y(this, void 0, void 0, function* () {
    const g10 = t10, { customInitTemplates: v10, disableOpenSaveHotkeys: b10, disableHistoryHotkeys: S10, language: C10, options: x10 = {}, editor: w10, appBar: T10, menu: E10, statusBar: F10, propertyGrid: M10, data: k10, units: P10, filterProperties: N10, dateFormats: D10, fontSet: L10, reportPartsLibraries: H10, themeConfig: I10 } = g10, _10 = m(g10, ["customInitTemplates", "disableOpenSaveHotkeys", "disableHistoryHotkeys", "language", "options", "editor", "appBar", "menu", "statusBar", "propertyGrid", "data", "units", "filterProperties", "dateFormats", "fontSet", "reportPartsLibraries", "themeConfig"]);
    const { createResourceProvider: V10, logo: R10, expressionSyntax: A10, customPreferencesStorage: O10, forceLoadPartsLibraries: B10 } = x10;
    const z10 = null !== (r10 = null == V10 ? void 0 : V10()) && void 0 !== r10 ? r10 : {};
    const $10 = w$t(e14, z10);
    const { result: W10, errors: j10 } = yield function(e15, t11) {
      var n11, r11;
      return y(this, void 0, void 0, function* () {
        if (!e15) return { result: { imperialTemplates: [], metricTemplates: [] }, errors: [] };
        const o11 = null !== (n11 = e15.imperialTemplates) && void 0 !== n11 ? n11 : [];
        const a11 = null !== (r11 = e15.metricTemplates) && void 0 !== r11 ? r11 : [];
        const [i11, s11] = yield Promise.all([Promise.all(o11.map((e16) => pAt(e16, t11))), Promise.all(a11.map((e16) => pAt(e16, t11)))]);
        const l11 = { foundReportItems: /* @__PURE__ */ new Set() };
        const c11 = { foundReportItems: /* @__PURE__ */ new Set() };
        const u11 = mAt(i11.filter((e16) => e16.success).map((e16) => e16.result), "imperial", l11);
        const d11 = mAt(s11.filter((e16) => e16.success).map((e16) => e16.result), "metric", c11);
        return { result: { imperialTemplates: u11, metricTemplates: d11 }, errors: [...i11, ...s11].filter((e16) => !e16.success).map(({ id: e16, errorText: t12 }) => ({ id: e16, errorText: t12 })) };
      });
    }(v10, $10.getResource);
    const Z10 = Object.assign(Object.assign(Object.assign(Object.assign({}, qRt), zRt), _10), { propertyGrid: Object.assign(Object.assign(Object.assign({}, zRt.propertyGrid), M10), { mode: null !== (o10 = null == M10 ? void 0 : M10.mode) && void 0 !== o10 ? o10 : P$t(x10), collapsibleCategories: { enabled: null !== (i10 = null === (a10 = null == M10 ? void 0 : M10.collapsibleCategories) || void 0 === a10 ? void 0 : a10.enabled) && void 0 !== i10 ? i10 : zRt.propertyGrid.collapsibleCategories.enabled }, saveExpandEditorsState: { enabled: null !== (l10 = null === (s10 = null == M10 ? void 0 : M10.saveExpandEditorsState) || void 0 === s10 ? void 0 : s10.enabled) && void 0 !== l10 ? l10 : zRt.propertyGrid.saveExpandEditorsState.enabled } }), filterProperties: N10 ? (e15, t11, n11) => {
      if ("rdlx" !== n11) throw new Error(`Internal error: '${n11}' platform is not supported.`);
      return N10(qRt.filterProperties(e15, t11, n11), t11);
    } : qRt.filterProperties, editor: Object.assign(Object.assign(Object.assign({}, zRt.editor), { snapToGrid: D$t(), snapToGuides: L$t() }), w10), menu: Object.assign(Object.assign(Object.assign({}, zRt.menu), E10), { logo: { visible: void 0 !== (null === (c10 = null == E10 ? void 0 : E10.logo) || void 0 === c10 ? void 0 : c10.visible) ? E10.logo.visible : zRt.menu.logo.visible, icon: void 0 !== (null === (u10 = null == E10 ? void 0 : E10.logo) || void 0 === u10 ? void 0 : u10.custom) ? { type: "font", iconCssClass: E10.logo.custom.class } : k$t(R10) } }), statusBar: Object.assign(Object.assign({}, zRt.statusBar), F10), language: null !== (d10 = M$t(C10)) && void 0 !== d10 ? d10 : qRt.language, fonts: bAt(null != L10 ? L10 : zRt.fontSet), instanceId: e14, disableOpenSaveHotkeys: b10, disableHistoryHotkeys: S10, createResourceProvider: V10, resourceProvider: $10, getDataSetSchema: iAt(e14, VRt), actionHandlers: {}, themes: { default: null !== (p10 = r$t(null == I10 ? void 0 : I10.initialTheme)) && void 0 !== p10 ? p10 : qRt.themes.default, list: t$t(C10 || "en", I10), picker: { enabled: null !== (f10 = null === (h10 = null == I10 ? void 0 : I10.themeSelector) || void 0 === h10 ? void 0 : h10.isEnabled) && void 0 !== f10 ? f10 : qRt.themes.picker.enabled } }, rdlx: Object.assign(Object.assign({}, qRt.rdlx), { initTemplates: W10, expressionSyntax: "rdl" === A10 ? "rdl" : qRt.rdlx.expressionSyntax, reportStyles: I$t(), reportCollapseWhitespace: true, reportParts: Object.assign(Object.assign({}, qRt.rdlx.reportParts), { libraries: (null != H10 ? H10 : []).map((e15) => ({ displayName: e15.displayName, name: e15.name, path: e15.id })) }) }), userPreferences: Object.assign(Object.assign({}, qRt.userPreferences), { units: H$t(P10) }), events: n10, dateFormats: null != D10 ? D10 : _$t(), appBar: Object.assign(Object.assign({}, zRt.appBar), T10), data: Object.assign(Object.assign(Object.assign({}, zRt.data), k10), { dataSources: Object.assign(Object.assign({}, zRt.data.dataSources), null == k10 ? void 0 : k10.dataSources) }), customPreferencesStorage: O10, forceLoadPartsLibraries: null != B10 && B10 });
    return { settings: Z10, customInitTemplatesErrors: j10 };
  });
}
const R$t = { "Ctrl+KeyO": ({ dispatch: e14 }) => e14(zzt({})), "Ctrl+KeyS": ({ dispatch: e14 }) => e14(Wzt({})) };
const A$t = (e14) => R$t[e14] || null;
const O$t = (e14, t10, n10, r10, o10) => {
  const a10 = ((e15) => {
    let t11 = CB(e15);
    const n11 = e15.nativeEvent.code;
    return n11 && (t11 += n11), t11;
  })(e14);
  return ["Ctrl+KeyZ", "Ctrl+KeyY"].includes(a10) && n10.disableHistoryHotkeys ? null : n10.disableOpenSaveHotkeys ? Vgt(a10, t10, o10, r10) : A$t(a10) || Vgt(a10, t10, o10, r10);
};
const B$t = (e14, t10, n10, r10, o10) => {
  const a10 = ((e15) => {
    let t11 = CB(e15);
    return e15.deltaY < 0 ? t11 += "WheelUp" : t11 += "WheelDown", t11;
  })(e14);
  return A$t(a10) || Vgt(a10, t10, o10, r10);
};
const z$t = () => {
  const { actionHandlers: e14, instanceId: t10, appBar: { visible: n10, homeTab: r10, contextActionsTab: o10, parametersTab: a10, aboutButton: i10 } } = MO();
  if (!n10) return null;
  const { dispatch: s10 } = RA();
  const { controlItems: l10 } = LA(Yzt);
  const c10 = f$t.of(t10).documents;
  const u10 = ep.useMemo(() => e14.onCreate ? () => c10.create() : void 0, [e14]);
  const d10 = ep.useMemo(() => e14.onRender ? () => c10.preview() : void 0, [e14]);
  const p10 = ep.useMemo(() => e14.onOpenFileMenu, [e14]);
  const m10 = ep.useMemo(() => e14.onOpen ? () => c10.open() : void 0, [e14]);
  const h10 = ep.useMemo(() => e14.onSave ? () => c10.save() : void 0, [e14]);
  const f10 = ep.useMemo(() => e14.onSaveAs ? () => c10.saveAs() : void 0, [e14]);
  const g10 = { File: !e14.onOpenFileMenu, Home: !r10.visible, ContextActions: !o10.visible, "RDLX-Parameters": !a10.visible, Insert: true };
  const y10 = l10.filter((e15) => "about" !== e15.type || i10.visible).map((e15) => {
    var n11;
    return "button" === e15.type && e15.icon && "svg" === e15.icon.type ? Object.assign(Object.assign({}, e15), { icon: Object.assign(Object.assign({}, e15.icon), { content: T$t(null !== (n11 = e15.icon.content) && void 0 !== n11 ? n11 : "", { width: 24, height: 24 }) }) }) : "about" === e15.type ? { type: "button", icon: Pm(Hm), title: VRt.t("menu.about", "About"), onClick: () => s10(_A.of(t10).open("about", {})) } : e15;
  });
  const v10 = { hiddenMenuItems: g10, controlItems: y10, onCreate: u10, onPreview: d10, onFile: p10, onOpen: m10, onSave: h10, onSaveAs: f10 };
  return tp.createElement(Bit, Object.assign({}, v10));
};
z$t.displayName = "App.AppBar";
const $$t = ({ aboutInfo: { applicationTitle: e14, applicationVersion: t10, coreVersion: n10, copyright: r10 } }) => tp.createElement("div", { className: "app-about" }, e14 && t10 ? tp.createElement(tp.Fragment, null, tp.createElement("p", { className: "app-name" }, e14), tp.createElement("p", { className: "app-version" }, VRt.t("about.applicationVersion", "Application version: {{applicationVersion}}", { applicationVersion: t10 })), n10 && tp.createElement("p", { className: "app-version" }, VRt.t("about.coreVersion", "Core version: {{coreVersion}}", { coreVersion: n10 }))) : null, r10 ? tp.createElement("p", { key: "copyright", className: "copyright" }, r10) : null);
const W$t = () => {
  const { closeDialog: e14 } = RA();
  const { about: t10 } = KRt();
  const n10 = { open: true, title: VRt.t("about.title", "About {{applicationTitle}}", { applicationTitle: t10.applicationTitleCompact }), controls: { align: "right", buttons: [{ text: VRt.t("about.close", "Close"), onClick: e14 }] }, onClose: e14, customCSS: "gcs-zi", shouldCloseOnOverlayClick: false };
  return tp.createElement(Hk, Object.assign({}, n10), tp.createElement($$t, { aboutInfo: t10 }));
};
const j$t = (e14) => (t10) => {
  const { value: n10, defaultValue: r10, environment: o10, descriptor: a10, setProperty: i10 } = t10;
  const s10 = PA();
  const { instanceId: l10 } = MO();
  const { rdlx: { expressionSyntax: c10 } } = Uae();
  const u10 = p9();
  const { Type: d10, $index: p10 } = h9();
  const m10 = dJ(d10, p10, u10, "", "");
  const h10 = ep.useCallback((e15, t11) => {
    i10(e15, "i11n" === c10 ? fu(t11) : t11);
  }, [c10, i10]);
  const f10 = ep.useMemo(() => "i11n" === c10 ? hu(n10) : n10, [c10, n10]);
  const g10 = ep.useMemo(() => "i11n" === c10 ? hu(r10) : r10, [c10, r10]);
  const y10 = { status: n10 === r10 ? "default" : "modified", menuId: "expressionsMenu", environment: o10, onSelect: (e15) => {
    switch (e15) {
      case "dialog": {
        const e16 = { descriptor: Object.assign(Object.assign({}, a10), { valuePath: "" }), objectValues: [f10], defaultValues: [g10], objectPaths: [""], reportIndex: p10, reportType: d10, theme: u10, validationContext: m10, title: a10.category, subtitle: a10.label, setProperty: (e17, t11) => (h10(a10, t11), { type: "noop" }) };
        s10(_A.of(l10).open("expressionEditor", e16));
        break;
      }
      case "reset":
        i10(a10, r10 || "");
    }
  }, titleToggle: VRt.t("commonEditorProps.dataBinding", "Data Binding") };
  const v10 = Object.assign(Object.assign({}, t10), { value: f10, defaultValue: g10, setProperty: h10 });
  return tp.createElement(jD, Object.assign({}, y10), tp.createElement(e14, Object.assign({}, v10)));
};
const Z$t = j$t(XD);
function G$t(e14, t10) {
  const n10 = {};
  return e14.forEach((e15) => {
    if (n10[e15.prop] = e15.valuePattern || "", e15.isKey && !t10(e15.prop, n10[e15.prop])) {
      let r10 = 1;
      do {
        n10[e15.prop] = `${e15.valuePattern || "_"}${r10++}`;
      } while (!t10(e15.prop, n10[e15.prop]));
    }
  }), n10;
}
const U$t = (e14) => {
  var { index: t10, propertyMap: n10, validatePropValue: r10 } = e14, o10 = m(e14, ["index", "propertyMap", "validatePropValue"]);
  const { value: a10, descriptor: i10 } = o10;
  const s10 = n10.map(({ prop: e15, title: n11, placeholder: s11 = n11, values: l10 = [], isExpr: c10 }) => {
    const u10 = Object.assign(Object.assign({}, i10), { valuePath: `${i10.valuePath}.${t10}.${e15}` });
    if (l10.length > 0) {
      const t11 = Object.assign(Object.assign({}, o10), { value: a10[e15], descriptor: u10, friendlyEnum: { values: l10.map(({ value: e16 }) => e16), friendlyNames: l10.map(({ value: e16, text: t12 }) => ({ name: t12, value: e16 })) } });
      return tp.createElement(AL, Object.assign({}, t11, { key: u10.valuePath }));
    }
    const d10 = r10 ? (n12) => r10(e15, n12, t10).valid : void 0;
    const p10 = a10[e15];
    const m10 = Object.assign(Object.assign({}, o10), { value: p10, descriptor: u10, validate: d10, placeholder: s11 });
    return c10 ? tp.createElement(Z$t, Object.assign({ key: e15 }, m10)) : tp.createElement(XD, Object.assign({ key: e15 }, m10));
  });
  return tp.createElement("div", { className: "arjs-collection-element" }, s10);
};
const q$t = ({ propertyMap: e14, setProperty: t10, value: n10, descriptor: r10, environment: o10, validate: a10, occupiedKeys: i10 = [] }) => {
  if (e14.some((e15) => e15.prop.includes("."))) throw new Error("CollectionEditor does not support keyPath or valuePath with dots");
  const s10 = (e15, t11, r11 = -1) => !i10.includes(t11) && !n10.some((n11, o11) => n11[e15] === t11 && o11 !== r11);
  function l10(t11, n11, r11) {
    var o11;
    const i11 = e14.find((e15) => e15.prop === t11);
    if (null == i11) return { valid: false, message: "invalid property name" };
    const l11 = null == a10 ? void 0 : a10(t11, n11, r11);
    if (l11 && !l11.valid) return l11;
    const c11 = null === (o11 = i11.validate) || void 0 === o11 ? void 0 : o11.call(i11, n11);
    return c11 && !c11.valid ? c11 : i11.isKey && "" === n11 ? { valid: false, message: "key value must be not empty" } : i11.isKey && null != s10 && !s10(t11, n11, r11) ? { valid: false, message: "key value must be unique" } : { valid: true };
  }
  const c10 = tp.createElement("div", { className: "arjs-collection-header" }, e14.map(({ title: e15, prop: t11 }) => tp.createElement(LE, { key: t11, text: e15, size: "small", uppercase: false, strikeThrough: false })));
  const u10 = { closeBtnTitle: VRt.t("collectionEditor.closeBtnTitle", "Close"), showBtnTitle: VRt.t("collectionEditor.showBtnTitle", "Show"), deleteBtnTitle: VRt.t("collectionEditor.deleteBtnTitle", "Delete"), addBtnText: VRt.t("collectionEditor.addBtnText", "Add"), addBtnTitle: VRt.t("collectionEditor.AddBtnTitle", "Add Item"), textEmpty: VRt.t("collectionEditor.textEmpty", "Collection is empty"), textItems: VRt.t("collectionEditor.textItems", "items") };
  return tp.createElement(bL, Object.assign({ descriptor: r10, header: c10, value: n10, setProperty: t10, createEditor: function(n11, a11) {
    return tp.createElement(U$t, { value: n11, index: a11, isUniqueKey: s10, descriptor: r10, environment: o10, setProperty: t10, propertyMap: e14, validatePropValue: l10 });
  }, onAdd: () => t10(r10, [...n10, G$t(e14, s10)]), onDelete: (e15) => {
    t10(r10, n10.filter((t11, n11) => n11 !== e15));
  } }, u10));
};
const Y$t = ({ value: e14, disabled: t10, setProperty: n10, descriptor: r10 }) => {
  const [o10, a10] = ep.useState(e14);
  ep.useEffect(() => {
    a10(e14);
  }, [e14]);
  const i10 = { value: o10, disabled: t10, onChange: (e15) => {
    a10(e15.target.value);
  }, onBlur: () => {
    n10 && r10 && n10(r10, o10);
  } };
  return tp.createElement(zN, Object.assign({ width: "100%", resize: "vertical", height: "150px", customCSS: "monospaced-editor" }, i10));
};
const K$t = (e14) => {
  var { onFileSelected: t10, accept: n10 } = e14, r10 = m(e14, ["onFileSelected", "accept"]);
  const o10 = ep.useRef();
  const a10 = { className: "open-file-dialog-hidden", type: "file", onChange: t10 };
  return n10 && (a10.accept = n10.join(",")), tp.createElement(tp.Fragment, null, tp.createElement("input", Object.assign({ ref: o10 }, a10)), tp.createElement(qm, Object.assign({ onClick: () => {
    var e15;
    return null === (e15 = o10.current) || void 0 === e15 ? void 0 : e15.click();
  } }, r10)));
};
const X$t = (e14) => {
  var { btnText: t10, acceptFiles: n10 } = e14, r10 = m(e14, ["btnText", "acceptFiles"]);
  const { setProperty: o10, descriptor: a10 } = r10;
  const i10 = { text: t10, onFileSelected: (e15) => {
    var t11;
    const n11 = null === (t11 = e15.target.files) || void 0 === t11 ? void 0 : t11[0];
    if (n11) {
      const e16 = new FileReader();
      e16.onload = (e17) => {
        const t12 = e17.target.result;
        o10 && a10 && o10(a10, t12);
      }, e16.readAsText(n11);
    }
  }, accept: n10 };
  return tp.createElement(tp.Fragment, null, tp.createElement(K$t, Object.assign({ width: "100%" }, i10)), tp.createElement(Y$t, Object.assign({}, r10)));
};
const J$t = HD(QD);
const Q$t = (e14) => {
  var { on: t10, off: n10, value: r10, setProperty: o10 } = e14, a10 = m(e14, ["on", "off", "value", "setProperty"]);
  return tp.createElement(J$t, Object.assign({ textTrue: t10.label, textFalse: n10.label }, a10, { setProperty: (e15, r11) => {
    o10(e15, r11 ? t10.value : n10.value);
  }, value: r10 === t10.value }));
};
function eWt(e14) {
  return e14.includes('"') ? { valid: false, message: "" } : { valid: true };
}
function tWt(e14) {
  return e14.Name.includes('"');
}
const nWt = (e14) => [{ prop: "Name", title: e14.t("dataSetProps.fieldsName", "Field Name"), valuePattern: e14.t("nameTemplates.dataSetFieldValue", "Field"), isKey: true, validate: eWt }, { prop: "DataField", title: e14.t("dataSetProps.fieldsDataField", "Data Field") }];
const rWt = (e14) => [{ prop: "Name", title: e14.t("dataSetProps.fieldsName", "Field Name"), valuePattern: e14.t("nameTemplates.dataSetCalcFieldValue", "CalculatedField"), isKey: true, validate: eWt }, { prop: "Value", title: e14.t("dataSetProps.fieldsValue", "Value"), placeholder: e14.t("dataSetProps.fieldsValuePlaceholder", "Enter the expression"), isExpr: true }];
const oWt = (e14) => {
  const { descriptor: t10, descriptor: { valuePath: n10 }, value: r10 } = e14;
  const o10 = VRt;
  const a10 = Object.assign(Object.assign({}, e14), { descriptor: Object.assign(Object.assign({}, t10), { valuePath: `${n10}.fields`, label: o10.t("dataSetProps.title.fields", "Database Fields") }), value: r10.fields, propertyMap: nWt(o10), occupiedKeys: r10.calculatedFields.map(({ Name: e15 }) => e15) });
  const i10 = Object.assign(Object.assign({}, e14), { descriptor: Object.assign(Object.assign({}, t10), { valuePath: `${n10}.calculatedFields`, label: o10.t("dataSetProps.title.calcFields", "Calculated Fields") }), value: r10.calculatedFields, propertyMap: rWt(o10), occupiedKeys: r10.fields.map(({ Name: e15 }) => e15) });
  return tp.createElement(tp.Fragment, null, tp.createElement(q$t, Object.assign({}, a10)), tp.createElement(q$t, Object.assign({}, i10)));
};
const aWt = $N("", "", "int", "currentDatasetIndex", "both");
const iWt = HD(XD);
const sWt = HD(AL);
const lWt = HD(({ value: e14, setProperty: t10, disabled: n10 }) => {
  const { datasets: r10, currentDatasetIndex: o10 } = e14;
  const a10 = (e15) => () => {
    t10(aWt, e15);
  };
  const i10 = r10[o10].datasetName;
  const s10 = ((e15, t11) => e15.map(t11).filter((e16) => null != e16))(r10, ({ name: e15, parent: t11 }, n11) => (null == t11 ? void 0 : t11.dataset) === i10 ? { name: e15, idx: n11 } : null);
  const l10 = { disabled: n10, size: "small", icon: Pm(Gh), accent: "icon", width: "100%" };
  return s10.length > 0 ? tp.createElement("div", { className: "nested-dataset-list" }, s10.map(({ name: e15, idx: t11 }) => tp.createElement(qm, Object.assign({ text: e15 }, l10, { onClick: a10(t11), key: t11 })))) : tp.createElement("div", null);
});
const cWt = HD(j$t(XD));
const uWt = j$t(Y$t);
const dWt = HD(uWt);
const pWt = HD(j$t((e14) => {
  const { descriptor: t10, setProperty: n10, fillItems: r10, nodes: o10 = [], handleRefresh: a10 } = e14;
  const i10 = ep.useRef(null);
  if (0 === o10.length && !r10) return tp.createElement(XD, Object.assign({}, e14));
  let s10 = null;
  if (o10.length >= 0) {
    const e15 = (e16) => {
      var r11;
      n10(t10, e16.value), null === (r11 = i10.current) || void 0 === r11 || r11.close();
    };
    s10 = tp.createElement(eI, { nodes: o10, onNodeClick: e15, outline: true });
  }
  r10 && (s10 = tp.createElement("div", { className: "treecombo-dropdown" }, tp.createElement(qm, { size: "small", accent: "full", text: "Refresh items", onClick: a10 }), s10));
  const l10 = kp("gc-combo");
  const c10 = { size: "small", menuAlign: "right", menuWidth: "auto", content: s10 };
  return tp.createElement("div", { className: l10, style: { width: "100%" } }, tp.createElement(XD, Object.assign({}, e14)), tp.createElement(UF, Object.assign({}, c10, { ref: i10 })));
}));
const mWt = HD(QD);
const hWt = HD(_L);
const fWt = (e14) => ({ values: ["GET", "POST"], friendlyNames: [{ name: e14.t("dataSetProps.methodGet", "HTTP GET"), value: "GET" }, { name: e14.t("dataSetProps.methodPost", "HTTP POST"), value: "POST" }] });
const gWt = (e14) => ({ values: [",", ";", "	", " "], friendlyNames: [{ name: e14.t("dataSetProps.columnSeparatorComma", "Comma"), value: "," }, { name: e14.t("dataSetProps.columnSeparatorSemicolon", "Semicolon"), value: ";" }, { name: e14.t("dataSetProps.columnSeparatorTab", "Tab"), value: "	" }, { name: e14.t("dataSetProps.columnSeparatorSpace", "Space"), value: " " }] });
const yWt = (e14) => [{ prop: "key", title: e14.t("dataSourceProps.headersKey", "Header"), isKey: true, valuePattern: "Header" }, { prop: "value", title: e14.t("dataSourceProps.headersValue", "Value"), isExpr: true }];
const vWt = (e14) => [{ prop: "key", title: e14.t("dataSourceProps.queriesKey", "Parameter"), isKey: true, valuePattern: "Parameter" }, { prop: "value", title: e14.t("dataSourceProps.queriesValue", "Value"), isExpr: true }];
function bWt(e14, t10, n10, r10) {
  if (0 !== r10) return [];
  const o10 = e14.t("dataSetProps.category.query", "Query");
  const a10 = n10 === tAt || n10 === QRt;
  const i10 = n10 === eAt || n10 === QRt;
  return "Text" === t10.type ? [$N(o10, e14.t("dataSetProps.title.queryType", "Type"), "queryType", "query.type", "both"), $N(o10, e14.t("dataSetProps.title.value", "Value"), "wideTextArea", "query.path", "both")] : [$N(o10, e14.t("dataSetProps.title.queryType", "Type"), "queryType", "query.type", "both"), ...a10 ? [$N(o10, e14.t("dataSetProps.title.endpoint", "Uri/path"), "expr", "query.endpoint", "both"), $N(o10, e14.t("dataSetProps.title.method", "Method"), "methodType", "query.method.type", "both"), ..."POST" === t10.method.type ? [$N(o10, e14.t("dataSetProps.title.postBody", "Post body"), "textAreaExpr", "query.method.body", "both")] : [], $N(o10, e14.t("dataSetProps.title.queries", "Parameters"), "queries", "query.queries", "both"), $N(o10, e14.t("dataSetProps.title.headers", "Headers"), "headers", "query.headers", "both")] : [], ...i10 ? [$N(o10, e14.t("dataSetProps.title.jpath", "Json Path"), "jpath", "query.jpath", "both", { tooltipText: "Please follow the link for more details https://goessner.net/articles/JsonPath/" })] : []];
}
function SWt(e14) {
  const t10 = e14.t("dataSetProps.category.csv", "CSV Settings");
  return [$N(t10, e14.t("dataSetProps.title.headingRow", "Heading Row"), "labeledToggle", "query.HasHeaders", "both"), $N(t10, e14.t("dataSetProps.title.startingRow", "Starting Row"), "labeledNumberEditor", "query.DataStartLine", "both"), $N(t10, e14.t("dataSetProps.title.columnSeparator", "Column Separator"), "columnSeparatorSelector", "query.ColumnsSeparator", "both"), $N(t10, e14.t("dataSetProps.title.mergeColumnSeparators", "Merge Column Separators"), "labeledToggle", "query.JoinColumnsSeparators", "both"), $N(t10, e14.t("dataSetProps.title.rowSeparator", "Row Separator"), "rowSeparatorSelector", "query.RowsSeparator", "both"), $N(t10, e14.t("dataSetProps.title.mergeRowSeparators", "Merge Row Separators"), "labeledToggle", "query.JoinRowsSeparators", "both")];
}
function CWt(e14, t10, n10) {
  const r10 = e14.t("dataSetProps.category.fields", "Fields");
  return [$N(r10, "", "fields", t10, "both"), ...n10 ? [$N(r10, e14.t("dataSetProps.title.datasets", "Nested Datasets"), "navdatasets", "", "both")] : []];
}
const xWt = ({ dispatch: e14, query: t10, datasets: n10, currentDatasetIndex: r10, dataProvider: o10, disableNavigate: a10, validateName: i10, jpathTree: s10, handleRefreshJTree: l10, reportParameters: c10 }) => {
  const u10 = n10[r10];
  const d10 = n10.findIndex((e15) => {
    var t11;
    return (null === (t11 = e15.parent) || void 0 === t11 ? void 0 : t11.dataset) === u10.datasetName;
  }) >= 0;
  const p10 = VRt;
  const h10 = /* @__PURE__ */ ((e15) => ({ textNoLabel: (e16, t11) => tp.createElement(XD, Object.assign({}, e16, { key: t11 }, bzt())), datasetName: (e16, t11) => {
    var { environment: n11 } = e16, r11 = m(e16, ["environment"]);
    return tp.createElement(XD, Object.assign({}, r11, { environment: n11, key: t11, validate: null == n11 ? void 0 : n11.validateName }, bzt()));
  }, text: (e16, t11) => tp.createElement(iWt, Object.assign({}, e16, { key: t11 }, bzt())), expr: (e16, t11) => tp.createElement(cWt, Object.assign({}, e16, { key: t11 }, bzt())), wideTextArea: (e16, t11) => tp.createElement(uWt, Object.assign({}, e16, { key: t11 })), textAreaExpr: (e16, t11) => tp.createElement(dWt, Object.assign({}, e16, { key: t11 })), navdatasets: (e16, t11) => {
    var n11;
    return tp.createElement(lWt, Object.assign({}, e16, { key: t11, disabled: null === (n11 = e16.environment) || void 0 === n11 ? void 0 : n11.disableNavigate }));
  }, fields: (e16, t11) => tp.createElement(oWt, Object.assign({}, e16, { key: t11 })), filters: (e16, t11) => tp.createElement(gke, Object.assign({}, e16, { key: t11 })), queryType: (t11, n11) => tp.createElement(Q$t, Object.assign({}, t11, { key: n11, on: { label: e15.t("dataSetProps.queryMode.JSON", "JSON"), value: "JSON" }, off: { label: e15.t("dataSetProps.queryMode.Text", "Text"), value: "Text" } })), methodType: (t11, n11) => tp.createElement(sWt, Object.assign({}, t11, { key: n11, friendlyEnum: fWt(e15) })), headers: (t11, n11) => tp.createElement(q$t, Object.assign({}, t11, { key: n11, propertyMap: yWt(e15) })), queries: (t11, n11) => tp.createElement(q$t, Object.assign({}, t11, { key: n11, propertyMap: vWt(e15) })), jpath: (e16, t11) => tp.createElement(pWt, Object.assign({}, e16, { key: t11 }, bzt())), labeledToggle: (t11, n11) => tp.createElement(mWt, Object.assign({}, t11, { key: n11, textFalse: e15.t("commonEditorProps.bool-false-label", "False"), textTrue: e15.t("commonEditorProps.bool-true-label", "True") })), labeledNumberEditor: (t11, n11) => tp.createElement(hWt, Object.assign({}, t11, { key: n11, minValue: 0, maxValue: 999999999, titleDecrease: e15.t("commonEditorProps.number-editor-decrease", "Decrease"), titleIncrease: e15.t("commonEditorProps.number-editor-increase", "Increase") })), rowSeparatorSelector: (e16, t11) => tp.createElement(sWt, Object.assign({}, e16, { key: t11, friendlyEnum: { values: ["\r", "\n", "\r\n"], friendlyNames: [{ name: "CR", value: "\r" }, { name: "LF", value: "\n" }, { name: "CRLF", value: "\r\n" }] } })), columnSeparatorSelector: (t11, n11) => tp.createElement(sWt, Object.assign({}, t11, { key: n11, friendlyEnum: gWt(e15) })) }))(p10);
  const f10 = function(e15, t11, n11, r11, o11) {
    const a11 = `datasets.${n11}`;
    const i11 = o11 === tAt || o11 === nAt;
    return [$N(e15.t("dataSetProps.category.name", "Name"), "", "datasetName", `${a11}.name`, "both"), ...bWt(e15, t11, o11, n11), ...i11 && "JSON" === t11.type ? SWt(e15) : [], ...CWt(e15, a11, r11), $N(e15.t("dataSetProps.category.filters", "Filters"), "", "filters", "Filters", "both")];
  }(p10, t10, r10, d10, o10);
  const g10 = { query: t10, datasets: n10, currentDatasetIndex: r10, name: "$name" };
  const y10 = { disableNavigate: a10, bindingMenus: { expressionsMenu: [{ type: "button", value: "reset", text: p10.t("dataSourceProps.exprMenuReset", "Reset") }, { type: "button", value: "dialog", text: p10.t("dataSourceProps.exprMenuDialog", "Expression...") }] }, validateName: i10, jpathTree: s10, handleRefreshJTree: l10 };
  const v10 = ep.useMemo(() => ({ dataSet: { Name: u10.name, Query: {}, Fields: [...u10.fields, ...u10.calculatedFields], Filters: u10.filters }, setDataSetProperty: (t11, n11) => {
    const o11 = `datasets.${r10}.${t11.valuePath.replace("Filters.", "filters.")}`;
    e14(BOt.setProperty(o11, n11));
  }, reportParameters: c10 }), [u10, c10, r10]);
  return tp.createElement(fke.Provider, { value: v10 }, tp.createElement(wD, { descriptors: f10, setProperty: (t11, n11) => {
    e14(BOt.setProperty(t11.valuePath, n11));
  }, propertyEditors: h10, objectValue: g10, environment: y10 }));
};
function wWt({ datasets: e14, currentDatasetIndex: t10 }) {
  var n10;
  const r10 = [];
  let o10 = null === (n10 = e14[t10].parent) || void 0 === n10 ? void 0 : n10.dataset;
  for (; null != o10; ) {
    const t11 = o10;
    const n11 = e14.findIndex((e15) => e15.datasetName === t11);
    if (!(n11 >= 0 && r10.length < 10)) break;
    {
      const { name: t12, parent: a10 } = e14[n11];
      r10.push({ name: t12, idx: n11 }), o10 = null == a10 ? void 0 : a10.dataset;
    }
  }
  return r10.reverse();
}
const TWt = ({ parentList: e14, currentDatasetName: t10, onClickItem: n10 }) => {
  if (0 === e14.length) return tp.createElement("div", null);
  const r10 = { size: "small", accent: "icon" };
  const o10 = Object.assign(Object.assign({}, r10), { background: "transparent", icon: Pm(Dm, { rotate: "180" }) });
  return tp.createElement("div", { className: "ed-dataset-navbar" }, tp.createElement(qm, Object.assign({}, r10, { accent: "full", title: VRt.t("dataSetDialog.btnBack", "Back to Parent"), icon: Pm(Nm), onClick: n10(e14[e14.length - 1].idx) })), tp.createElement("div", { className: "ed-dataset-breadcrumbs" }, e14.map(({ name: e15, idx: t11 }) => tp.createElement(qm, Object.assign({ key: t11, text: e15 }, o10, { onClick: n10(t11) }))), tp.createElement(qm, Object.assign({ text: t10 }, o10, { disabled: true }))));
};
const EWt = (e14) => {
  var t10;
  const { dispatch: n10, closeDialog: r10 } = RA();
  const { dataSources: o10, modelDatasets: a10, reportParameters: i10 } = e14, s10 = m(e14, ["dataSources", "modelDatasets", "reportParameters"]);
  const l10 = LA(({ dataSetDialog: e15 }) => e15);
  const { instanceId: c10 } = MO();
  if (!l10.initialized) return n10(BOt.init(s10)), null;
  const { query: u10, initialState: d10, currentDatasetIndex: p10, datasets: h10, datasets: [f10 = null], validation: g10, jpathTree: y10, expressionValues: v10 } = l10;
  const b10 = () => {
    n10(BOt.reset()), r10();
  };
  const S10 = null != f10 && "" !== (f10.name || "").trim() && function(e15) {
    for (let t11 = 0; t11 < e15.length; t11++) {
      const n11 = (e15[t11].fields || []).some(tWt);
      const r11 = (e15[t11].calculatedFields || []).some(tWt);
      if (n11 || r11) return false;
    }
    return true;
  }(l10.datasets);
  const C10 = null === (t10 = h10[p10]) || void 0 === t10 ? void 0 : t10.name;
  const x10 = "edit" === d10.mode ? d10.datasetName : d10.datasetName || "New data set";
  const w10 = C10 || x10;
  const T10 = () => {
    var e15;
    const t11 = null == d10 ? void 0 : d10.datasets.find((e16) => e16.Name === (null == d10 ? void 0 : d10.datasetName));
    if ("edit" === d10.mode) {
      const r11 = null !== (e15 = null == d10 ? void 0 : d10.initialDatasets) && void 0 !== e15 ? e15 : [];
      null != t11 && n10(WOt(xBt(t11, h10[0], u10), r11, v10));
    } else n10(WOt(xBt(t11, h10[0], u10), [], v10));
  };
  const E10 = { open: true, title: w10, subtitle: "edit" === (null == d10 ? void 0 : d10.mode) ? VRt.t("dataSetDialog.modeEditSubtitle", "Edit Data Set") : VRt.t("dataSetDialog.modeNewSubtitle", "New Data Set"), shouldCloseOnOverlayClick: false, onClose: b10, controls: { align: "spread", left: [{ text: VRt.t("dataSetDialog.btnValidate", "Validate"), onClick: T10, accent: "full", disabled: "validating" === g10.status }, { text: VRt.t("dataSetDialog.btnExportTemplate", "Export..."), onClick: () => n10(_A.of(c10).open("exportTemplate", { type: "dataset", settings: l10 })) }], right: [{ text: VRt.t("dialogs.saveChanges", "Save Changes"), accent: "full", onClick: () => {
    "ok" !== g10.status ? n10(_A.of(c10).open("confirm", { title: w10, text: VRt.t("dataSetDialog.confirmSaveInvalid", "The changes were not validated. Do you want to save the changes?"), choices: [qA(VRt.t("dialogs.confirmSavingChanges.saveLabel", "Save Changes"), jOt())], onCancel: BOt.cancelSave(), noCancel: false })) : n10(jOt());
  }, disabled: !S10 }, { text: VRt.t("dialogs.cancel", "Cancel"), onClick: b10 }] }, hideCloseButton: true, customCSS: "ed-dataset-dialog" };
  const { dataProvider: F10 } = l10.initialState;
  const M10 = { parentList: wWt({ datasets: h10, currentDatasetIndex: p10 }), currentDatasetName: h10[p10].name, onClickItem: (e15) => () => {
    n10(BOt.setProperty("currentDatasetIndex", `${e15}`));
  } };
  const k10 = function(e15, t11) {
    return e15.filter((e16) => !t11.includes(e16));
  };
  const P10 = k10(k10(a10.map((e15) => e15.Name), h10.map((e15) => e15.datasetName)).concat(h10.map((e15) => e15.name)), [C10]);
  const N10 = xzt("^\\p{L}[\\p{L}\\p{N}_]*$", "i");
  const D10 = { query: u10, currentDatasetIndex: p10, datasets: h10, dispatch: n10, dataProvider: F10, disableNavigate: !S10, validateName: (e15) => null != e15 && !P10.includes(e15) && !!N10.exec(e15), jpathTree: y10, handleRefreshJTree: T10, reportParameters: i10 };
  return tp.createElement(Hk, Object.assign({}, E10), "failed" === g10.status && tp.createElement(sV, { level: "error", title: VRt.t("dataSetDialog.parseQueryError", "Incorrect query string"), details: tp.createElement("span", null, g10.errorMessages), textClose: VRt.t("dataSetDialog.alertTextClose", "Close"), textExpand: VRt.t("dataSetDialog.alertTextExpand", "Expand"), textCollapse: VRt.t("dataSetDialog.alertTextCollapse", "Collapse") }), tp.createElement("div", { className: "ed-dataset-dialog__content" }, tp.createElement(TWt, Object.assign({}, M10)), tp.createElement(xWt, Object.assign({}, D10))));
};
EWt.displayName = "DataSetDialog";
const FWt = j$t(XD);
const MWt = j$t(Y$t);
const kWt = (e14) => ({ values: ["JSON", "CSV"], friendlyNames: [{ name: e14.t("dataSourceProps.providerJSON", "JSON"), value: "JSON" }, { name: e14.t("dataSourceProps.providerCSV", "CSV"), value: "CSV" }] });
const PWt = (e14) => [{ prop: "key", title: e14.t("dataSourceProps.headersKey", "Header"), isKey: true, valuePattern: "Header" }, { prop: "value", title: e14.t("dataSourceProps.headersValue", "Value"), isExpr: true }];
const NWt = (e14) => [{ prop: "key", title: e14.t("dataSourceProps.queriesKey", "Parameter"), isKey: true, valuePattern: "Parameter" }, { prop: "value", title: e14.t("dataSourceProps.queriesValue", "Value"), isExpr: true }];
const DWt = (e14, t10, n10, r10) => {
  const o10 = ((e15, t11) => [$N(e15.t("dataSourceProps.category.name", "Name"), "Name", "dataSourceName", "name", "both"), $N(e15.t("dataSourceProps.category.dataFormat", "Data Format"), "Data Format", "providerSelector", "dataFormat", "both"), $N(e15.t("dataSourceProps.category.sourceType", "Source Type"), "Source Type", "sourceRadioList", "sourceType", "both", { sourceType: t11 })])(e14, t10);
  return r10 ? [...o10, $N(e14.t("dataSourceProps.category.connectionString", "Connection string"), "Value", "textAreaExpr", "connectionString")] : [...o10, ..."remote" === t10 ? [$N(e14.t("dataSourceProps.category.endpoint", "Endpoint"), "Web Service Endpoint (URI)", "expr", "endpoint", "both", { tooltipText: "Endpoint URI tooltip" }), $N(e14.t("dataSourceProps.category.parameters", "Parameters"), e14.t("dataSourceProps.title.headers", "HTTP Headers"), "headers", "headers"), $N(e14.t("dataSourceProps.category.parameters", "Parameters"), e14.t("dataSourceProps.title.queries", "Query Parameters"), "queries", "queries")] : [], ..."embedded" === t10 && "JSON" === n10 ? [$N(e14.t("dataSourceProps.category.jsonData", "JSON Data"), "Value", "textAreaWithJsonFileLoad", "jsondata", "both")] : [], ..."embedded" === t10 && "CSV" === n10 ? [$N(e14.t("dataSourceProps.category.data", "Data"), "Value", "textAreaWithCsvFileLoad", "data", "both")] : []];
};
const LWt = ({ dispatch: e14, name: t10, dataFormat: n10, sourceType: r10, properties: o10, validateName: a10 }) => {
  const i10 = (t11, n11) => {
    e14(OBt(t11.valuePath, n11));
  };
  const s10 = VRt;
  const l10 = { bindingMenus: { expressionsMenu: [{ type: "button", value: "reset", text: s10.t("dataSourceProps.exprMenuReset", "Reset") }, { type: "button", value: "dialog", text: s10.t("dataSourceProps.exprMenuDialog", "Expression...") }] }, validateName: a10 };
  const c10 = /* @__PURE__ */ ((e15) => ({ dataSourceName: (e16, t11) => {
    var { environment: n11 } = e16, r11 = m(e16, ["environment"]);
    return tp.createElement(XD, Object.assign({}, r11, { environment: n11, key: t11, validate: null == n11 ? void 0 : n11.validateName }, bzt()));
  }, expr: (e16, t11) => tp.createElement(FWt, Object.assign({}, e16, { key: t11 }, bzt())), textAreaWithJsonFileLoad: (t11, n11) => tp.createElement(X$t, Object.assign({}, t11, { key: n11, btnText: e15.t("dataSourceProps.btnLoadFromFile", "Load From File"), acceptFiles: [".json"] })), textAreaWithCsvFileLoad: (t11, n11) => tp.createElement(X$t, Object.assign({}, t11, { key: n11, btnText: e15.t("dataSourceProps.btnLoadFromFile", "Load From File"), acceptFiles: [".csv"] })), textAreaExpr: (e16, t11) => tp.createElement(MWt, Object.assign({}, e16, { key: t11 })), providerSelector: (t11, n11) => tp.createElement(AL, Object.assign({}, t11, { key: n11, friendlyEnum: kWt(e15) })), headers: (t11, n11) => tp.createElement(q$t, Object.assign({}, t11, { key: n11, propertyMap: PWt(e15) })), queries: (t11, n11) => tp.createElement(q$t, Object.assign({}, t11, { key: n11, propertyMap: NWt(e15) })), sourceRadioList: (t11, n11) => tp.createElement(rI, Object.assign({}, t11, { key: n11 }, ((e16, t12, n12) => {
    var r11, o11;
    return { type: "radios", layout: { direction: "horizontal" }, items: [{ text: e16.t("dataSourceProps.sourceRemote", "Remote"), name: "sourceType", value: "remote", checked: "remote" === (null === (r11 = t12.meta) || void 0 === r11 ? void 0 : r11.sourceType) }, { text: e16.t("dataSourceProps.sourceEmbedded", "Embedded"), name: "sourceType", value: "embedded", checked: "embedded" === (null === (o11 = t12.meta) || void 0 === o11 ? void 0 : o11.sourceType) }], onChange: (e17) => n12(t12, e17) };
  })(e15, t11.descriptor, t11.setProperty))) }))(s10);
  if ("parsed" === o10.type) {
    const e15 = Object.assign(Object.assign({ name: t10 }, o10), { dataFormat: n10, sourceType: r10 });
    const a11 = DWt(s10, r10, n10);
    return tp.createElement(wD, { environment: l10, descriptors: a11, setProperty: i10, propertyEditors: c10, objectValue: e15 });
  }
  {
    const { connectionString: e15 } = o10;
    const a11 = DWt(s10, r10, n10, true);
    return tp.createElement(wD, { environment: l10, descriptors: a11, setProperty: i10, propertyEditors: c10, objectValue: { name: t10, connectionString: e15, sourceType: r10, dataFormat: n10 } });
  }
};
function HWt(e14) {
  const { properties: t10 } = e14;
  if ("raw" === t10.type) return t10.connectionString;
  if ("parseError" === t10.type) throw new Error("Unexpected properties state");
  return HWt(UBt(e14, RBt("raw")));
}
const IWt = (e14) => {
  const t10 = LA(({ dataSourceDialog: e15 }) => e15);
  const { initialized: n10, properties: r10, initialState: o10, name: a10, dataFormat: i10, sourceType: s10 } = t10;
  const { dispatch: l10, closeDialog: c10 } = RA();
  const { identifiers: { instanceId: u10 } } = KRt();
  if (!n10) return l10(LBt(e14)), null;
  const d10 = () => {
    l10(HBt()), c10();
  };
  function p10(e15) {
    const n11 = HWt(t10);
    return AV(e15, { Name: { $set: a10 }, ConnectionProperties: { DataProvider: { $set: WBt(i10, s10) }, ConnectString: { $set: n11 } } });
  }
  const m10 = () => d10();
  const { usedDatasourceNames: h10 } = o10;
  const f10 = xzt("^\\p{L}[\\p{L}\\p{N}_]*$", "i");
  const g10 = (e15) => !(null == e15 || "" === e15 || !f10.exec(e15) || null != h10 && h10.includes(e15));
  const y10 = g10(a10) && ("raw" === r10.type || "parsed" === r10.type);
  const v10 = "parsed" === r10.type ? VRt.t("dataSourceDialog.btnConnectionString", "Connection String") : VRt.t("dataSourceDialog.btnProperties", "Properties");
  const b10 = { open: true, title: a10, subtitle: VRt.t("dataSourceDialog.subtitle", "Edit Data Source"), onClose: m10, controls: { align: "spread", left: [{ text: v10, accent: "full", onClick: () => {
    "parseError" !== r10.type && l10(RBt("raw" === r10.type ? "parsed" : "raw"));
  } }, { text: VRt.t("dataSourceDialog.btnExportTemplate", "Export..."), onClick: () => l10(_A.of(u10).open("exportTemplate", { type: "datasource", settings: t10 })) }], right: [{ text: VRt.t("dialogs.saveChanges", "Save Changes"), accent: "full", onClick: () => {
    if ("parseError" !== r10.type) {
      switch (o10.mode) {
        case "edit": {
          const e15 = p10(o10.initialData);
          l10(U2.rdlxSetDataSource({ name: o10.initialData.Name, dataSource: e15 }));
          break;
        }
        default: {
          const e15 = p10(o10.template);
          l10(U2.rdlxAddDataSource({ datasource: e15 }));
          break;
        }
      }
      d10();
    }
  }, disabled: !y10 }, { text: VRt.t("dialogs.cancel", "Cancel"), onClick: m10 }] }, hideCloseButton: true, customCSS: "ed-datasource-dialog" };
  return tp.createElement(Hk, Object.assign({}, b10), "parseError" === r10.type && tp.createElement(sV, { level: "error", title: VRt.t("dataSourceDialog.parseErrorTitle", "Incorrect connection string"), details: tp.createElement("span", null, r10.errors.join(", ")), textClose: VRt.t("dataSetDialog.alertTextClose", "Close"), textExpand: VRt.t("dataSetDialog.alertTextExpand", "Expand"), textCollapse: VRt.t("dataSetDialog.alertTextCollapse", "Collapse") }), tp.createElement("div", { className: "ed-datasource-dialog__content" }, tp.createElement(LWt, { name: a10, dataFormat: i10, sourceType: s10, properties: r10, validateName: g10, dispatch: l10 })));
};
IWt.displayName = "DataSourceDialog";
const _Wt = (e14) => {
  const { closeDialog: t10 } = RA();
  const n10 = function(e15) {
    var t11, n11;
    if ("datasource" === e15.type) {
      const { settings: t12 } = e15;
      const n12 = { Name: t12.name, ConnectionProperties: { DataProvider: WBt(t12.dataFormat, t12.sourceType), ConnectString: "parsed" === t12.properties.type ? $Bt(t12.properties) : t12.properties.connectionString } };
      return JSON.stringify(n12);
    }
    if ("dataset" === e15.type) {
      const { settings: r11 } = e15;
      const o10 = r11.datasets.find((e16) => !e16.parent);
      const a10 = r11.initialState.datasets[0];
      const i10 = { Name: o10.name, Query: { DataSourceName: a10.Query.DataSourceName, CommandText: "Text" === r11.query.type ? r11.query.path : lBt(r11.query) }, Fields: (null === (t11 = o10.fields) || void 0 === t11 ? void 0 : t11.length) || (null === (n11 = o10.calculatedFields) || void 0 === n11 ? void 0 : n11.length) ? [...o10.fields, ...o10.calculatedFields] : void 0, Filters: o10.filters ? o10.filters : void 0 };
      return JSON.stringify(i10);
    }
    return "";
  }(e14);
  const r10 = { open: true, title: VRt.t("exportTemplateDialog.title", "Export Template"), controls: { align: "right", buttons: [{ text: VRt.t("exportTemplateDialog.closeBtnText", "Close"), onClick: t10 }] }, onClose: t10, customCSS: "gcs-zi" };
  return tp.createElement(Hk, Object.assign({}, r10), tp.createElement(zN, { height: "300px", width: "100%", value: n10 }));
};
const VWt = () => {
  const { settings: { menu: { visible: e14, documentExplorer: t10, toolBox: n10, groupEditor: r10, layerEditor: o10, logo: { visible: a10, icon: i10 } } } } = KRt();
  const s10 = ep.useMemo(() => ({ documentExplorer: !t10.visible, toolbox: !n10.visible, layers: !o10.visible, groupEditor: !r10.visible }), [t10.visible, n10.visible, r10.visible, o10.visible]);
  const l10 = ep.useMemo(() => false === a10 ? { visible: false } : { visible: true, custom: i10 }, [i10, a10]);
  if (!e14) return null;
  const c10 = { applicationName: "", hiddenElements: s10, logo: l10 };
  return tp.createElement(Gct, Object.assign({}, c10));
};
VWt.displayName = "App.Menu";
const RWt = () => {
  const e14 = { position: "bottom-left", autoHideTimeout: 5e3, rounded: true, showDetailsLabel: VRt.t("notificationPanel.showDetails", "Show Details"), dismissAllLabel: VRt.t("notificationPanel.dismissAll", "Dismiss All"), dismissLabel: VRt.t("notificationPanel.dismiss", "Dismiss"), expandTitle: VRt.t("notificationPanel.expand", "Expand"), collapseTitle: VRt.t("notificationPanel.collapse", "Collapse"), errorCategoryLabel: (e15) => VRt.t("notificationPanel.oneError", "Error", { count: e15 }), warningCategoryLabel: (e15) => VRt.t("notificationPanel.oneWarning", "Warning", { count: e15 }), infoCategoryLabel: (e15) => VRt.t("notificationPanel.oneNotification", "Notification", { count: e15 }) };
  return tp.createElement(TP, Object.assign({}, e14));
};
const [AWt] = ((e14) => Dp(e14))("wd-app-overlay");
const OWt = ({ app: { overlay: e14 } }) => e14;
const BWt = () => {
  const { visible: e14, message: t10 } = LA(OWt);
  return e14 ? tp.createElement("div", { className: AWt }, tp.createElement("div", { className: "loader" }, tp.createElement(TE, { key: "loader", background: "transparent", block: true })), t10 && tp.createElement("span", null, t10)) : null;
};
const zWt = tp.createElement("svg", { viewBox: "0 0 24 24" }, tp.createElement("path", { className: "gc-icon-color--text", d: "M12 3C7.58 3 4 4.79 4 7s3.58 4 8 4 8-1.79 8-4-3.58-4-8-4M4 9v3c0 2.21 3.58 4 8 4s8-1.79 8-4V9c0 2.21-3.58 4-8 4s-8-1.79-8-4m0 5v3c0 2.21 3.58 4 8 4s8-1.79 8-4v-3c0 2.21-3.58 4-8 4s-8-1.79-8-4z" }));
const $Wt = tp.createElement("svg", { viewBox: "0 0 24 24" }, tp.createElement("path", { className: "gc-icon-color--text", d: "M12 8a4 4 0 0 1 4 4 4 4 0 0 1-4 4 4 4 0 0 1-4-4 4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2 2 2 0 0 0 2 2 2 2 0 0 0 2-2 2 2 0 0 0-2-2m-2 12c-.25 0-.46-.18-.5-.42l-.37-2.65c-.63-.25-1.17-.59-1.69-.99l-2.49 1.01c-.22.08-.49 0-.61-.22l-2-3.46c-.13-.22-.07-.49.12-.64l2.11-1.66L4.5 12l.07-1-2.11-1.63c-.19-.15-.25-.42-.12-.64l2-3.46c.12-.22.39-.31.61-.22l2.49 1c.52-.39 1.06-.73 1.69-.98l.37-2.65c.04-.24.25-.42.5-.42h4c.25 0 .46.18.5.42l.37 2.65c.63.25 1.17.59 1.69.98l2.49-1c.22-.09.49 0 .61.22l2 3.46c.13.22.07.49-.12.64L19.43 11l.07 1-.07 1 2.11 1.63c.19.15.25.42.12.64l-2 3.46c-.12.22-.39.31-.61.22l-2.49-1c-.52.39-1.06.73-1.69.98l-.37 2.65c-.04.24-.25.42-.5.42h-4m1.25-18l-.37 2.61c-1.2.25-2.26.89-3.03 1.78L5.44 7.35l-.75 1.3L6.8 10.2c-.4 1.17-.4 2.44 0 3.6l-2.12 1.56.75 1.3 2.43-1.04c.77.88 1.82 1.52 3.01 1.76l.37 2.62h1.52l.37-2.61c1.19-.25 2.24-.89 3.01-1.77l2.43 1.04.75-1.3-2.12-1.55c.4-1.17.4-2.44 0-3.61l2.11-1.55-.75-1.3-2.41 1.04c-.77-.89-1.83-1.53-3.03-1.77L12.75 4h-1.5z" }));
const WWt = T0("", 0, {});
const jWt = ({ parameterIndex: e14, validationContext: t10 }) => {
  const { ReportParameters: n10, DataSources: r10, DataSets: o10, Type: a10, $index: i10 } = h9();
  const s10 = PA();
  const l10 = p9();
  const { identifiers: { instanceId: c10 } } = KRt();
  const u10 = { path: `ReportParameters.${e14}`, reportParameter: n10[e14] || {}, dispatch: s10, dataSets: o10.filter((e15) => !((e16) => e16.Query.DataSourceName.startsWith("$dataset:"))(e15)), dataSources: r10, parametersNames: (n10 || []).map((e15) => e15.Name), validationContext: t10, semanticModel: null, editExpression: (n11) => {
    const r11 = `ReportParameters.${e14}`;
    const o11 = { descriptor: n11, objectValues: [u10.reportParameter], defaultValues: [WWt], objectPaths: [""], reportIndex: i10, reportType: a10, theme: l10, validationContext: t10, setProperty: (e15, t11) => {
      s10(U2.rdlxReportSetPropertyByPath({ path: r11, descriptor: e15, value: t11 }));
    } };
    s10(_A.of(c10).open("expressionEditor", o11));
  } };
  return tp.createElement(yBe, Object.assign({}, u10));
};
const ZWt = (e14) => {
  var { dataSource: t10 } = e14, n10 = m(e14, ["dataSource"]);
  const { DataProvider: r10, ConnectString: o10 } = t10.ConnectionProperties;
  const a10 = ep.useMemo(() => {
    var e15;
    let t11 = r10;
    if (r10 === QRt) {
      t11 = (null === (e15 = oBt(o10).find((e16) => "jsondata" === e16.key)) || void 0 === e15 ? void 0 : e15.value) ? eAt : QRt;
    }
    return t11;
  }, [r10, o10]);
  const i10 = Object.assign(Object.assign({}, n10), { dataSource: Object.assign(Object.assign({}, t10), { $dataProvider: a10, ConnectionProperties: Object.assign(Object.assign({}, t10.ConnectionProperties), { DataProvider: a10 }) }) });
  return tp.createElement(ZOe, Object.assign({}, i10));
};
const [GWt, , UWt] = Dp("wd-sidebar-panel");
UWt("placeholder");
const [qWt] = UWt("heading");
const [YWt] = UWt("content");
const KWt = ({ children: e14, title: t10, collapsed: n10, loading: r10, textAdd: o10, items: a10, onAdd: i10, customAdd: s10 }) => {
  const l10 = rf(Xm);
  const c10 = { text: t10, level: "info", size: "small", weight: "bold", strikeThrough: false, loading: r10, customCSS: qWt };
  const u10 = { defaultAccent: "icon", defaultBackground: "transparent", rounded: true, items: [] };
  return a10 ? c10.actions = Object.assign(Object.assign({}, u10), { items: a10 }) : i10 && (c10.actions = Object.assign(Object.assign({}, u10), { items: [{ type: "button", icon: l10, text: null != o10 ? o10 : VRt.t("dataPanel.addCmdTitle", "Add"), onClick: i10 }] })), tp.createElement("div", { className: GWt }, tp.createElement(LE, Object.assign({}, c10)), s10 && tp.createElement("div", null, s10), true !== n10 && tp.createElement("div", { className: YWt }, e14));
};
const XWt = (e14, t10) => t10 ? xzt(e14, t10) : xzt(e14);
const JWt = ["Avg", "Count", "CountDistinct", "First", "Last", "Max", "Median", "Min", "Mode", "StDev", "StDevP", "Sum", "Var", "VarP"].reduce((e14, t10) => Object.assign(e14, { [t10.toLowerCase()]: t10 }), {});
const QWt = Object.keys(JWt);
const ejt = (e14) => e14 && QWt.includes(e14.toLowerCase()) || false;
function tjt(e14, t10 = null, n10 = null) {
  let r10 = e14 || "";
  const o10 = r10.length > 0 && "=" === r10[0] || false;
  o10 && (r10 = r10.substring(1));
  const a10 = `${ejt(t10) ? t10 : "Count"}(${r10 || '""'}${n10 && `, "${n10}"` || ""})`;
  return o10 && `=${a10}` || a10;
}
const njt = (e14, t10 = null, n10 = null) => {
  if (!e14) throw new Error("Field name cannot be null/undefined/empty");
  let r10;
  if (xzt.match(e14, XWt("^((?:\\pL[\\pL_\\d]*)|(?:_[\\pL_\\d]+))$")) ? r10 = ((e15) => `Fields!${e15}.Value`)(e14) : xzt.match(e14, XWt('^([^"]+)$')) && (r10 = ((e15) => `Fields.Item("${e15}").Value`)(e14)), !r10) throw new Error(`Field name has invalid/unsupported structure: ${e14}`);
  return n10 || t10 ? tjt(r10, n10, t10) : r10;
};
const rjt = (e14) => {
  const t10 = [...e14].sort((e15, t11) => {
    const n10 = e15.index[0] - t11.index[0];
    return 0 !== n10 ? n10 : 1 === e15.index.length ? -1 : 1 === t11.index.length ? 1 : e15.index[1] - t11.index[1];
  });
  return t10.map(({ name: e15, variationFormat: t11, format: n10 }) => {
    const r10 = t11 ? `=${function(e16, t12, n11 = null, r11 = null) {
      if (!t12) throw new Error("Field variation format cannot be null/undefined/empty");
      const o10 = njt(e16);
      const a10 = t12.startsWith("=") ? t12.substring(1) : t12;
      const i10 = y1(a10, { fieldExpression: o10 });
      return r11 || n11 ? tjt(i10, r11 || "First", n11) : i10;
    }(e15, t11)}` : `=${njt(e15)}`;
    return { label: e15, expr: r10, format: n10 };
  });
};
const ojt = tp.createElement("svg", { version: "1.0", xmlns: "http://www.w3.org/2000/svg", width: "200.000000pt", height: "200.000000pt", viewBox: "0 0 200.000000 200.000000", preserveAspectRatio: "xMidYMid meet" }, tp.createElement("g", { transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)", fill: "#000000", stroke: "none" }, tp.createElement("path", { d: "M1160 1869 c-157 -20 -278 -63 -319 -115 -20 -25 -21 -38 -21 -250\n        l0 -224 -297 0 c-280 0 -300 -1 -331 -20 -18 -11 -41 -34 -52 -52 -19 -32 -20\n        -52 -20 -508 0 -456 1 -476 20 -508 11 -18 34 -41 52 -52 32 -19 52 -20 618\n        -20 566 0 586 1 618 20 65 40 72 64 72 266 l0 181 58 7 c144 17 277 72 308\n        127 10 19 13 130 14 515 0 484 0 492 -21 518 -75 95 -415 151 -699 115z m463\n        -93 c79 -18 177 -60 177 -76 0 -17 -99 -59 -182 -77 -103 -24 -433 -24 -536 0\n        -82 18 -182 60 -182 76 0 26 135 74 255 90 97 14 385 5 468 -13z m-523 -237\n        c45 -8 146 -14 250 -14 188 0 284 13 388 50 l62 23 0 -115 0 -114 -54 -25\n        c-94 -43 -192 -57 -396 -58 -204 0 -300 14 -396 58 l-54 25 0 114 0 115 63\n        -23 c34 -12 96 -29 137 -36z m683 -491 c-10 -10 -44 -27 -75 -38 -56 -20 -195\n        -46 -202 -39 -2 2 -6 56 -7 120 l-4 115 86 12 c48 6 115 22 150 34 l64 23 3\n        -104 c2 -90 0 -107 -15 -123z m-383 132 c17 -17 20 -33 20 -100 l0 -80 -610 0\n        -610 0 0 80 c0 132 -60 120 610 120 557 0 570 0 590 -20z m388 -428 c-20 -23\n        -84 -49 -170 -66 -127 -26 -118 -33 -118 92 l0 109 83 12 c46 7 112 22 148 35\n        l64 22 3 -94 c2 -66 -1 -99 -10 -110z m-1408 108 l0 -60 -90 0 -90 0 0 60 0\n        60 90 0 90 0 0 -60z m260 0 l0 -60 -90 0 -90 0 0 60 0 60 90 0 90 0 0 -60z\n        m260 0 l0 -60 -90 0 -90 0 0 60 0 60 90 0 90 0 0 -60z m260 0 l0 -60 -90 0\n        -90 0 0 60 0 60 90 0 90 0 0 -60z m260 0 l0 -60 -90 0 -90 0 0 60 0 60 90 0\n        90 0 0 -60z m-1040 -200 l0 -60 -90 0 -90 0 0 60 0 60 90 0 90 0 0 -60z m260\n        0 l0 -60 -90 0 -90 0 0 60 0 60 90 0 90 0 0 -60z m260 0 l0 -60 -90 0 -90 0 0\n        60 0 60 90 0 90 0 0 -60z m260 0 l0 -60 -90 0 -90 0 0 60 0 60 90 0 90 0 0\n        -60z m260 0 l0 -60 -90 0 -90 0 0 60 0 60 90 0 90 0 0 -60z m-1040 -200 l0\n        -60 -90 0 -90 0 0 60 0 60 90 0 90 0 0 -60z m260 0 l0 -60 -90 0 -90 0 0 60 0\n        60 90 0 90 0 0 -60z m260 0 l0 -60 -90 0 -90 0 0 60 0 60 90 0 90 0 0 -60z\n        m260 0 l0 -60 -90 0 -90 0 0 60 0 60 90 0 90 0 0 -60z m260 0 l0 -60 -90 0\n        -90 0 0 60 0 60 90 0 90 0 0 -60z m-1040 -200 l0 -60 -70 0 c-86 0 -110 18\n        -110 80 l0 40 90 0 90 0 0 -60z m260 0 l0 -60 -90 0 -90 0 0 60 0 60 90 0 90\n        0 0 -60z m260 0 l0 -60 -90 0 -90 0 0 60 0 60 90 0 90 0 0 -60z m260 0 l0 -60\n        -90 0 -90 0 0 60 0 60 90 0 90 0 0 -60z m260 20 c0 -62 -24 -80 -110 -80 l-70\n        0 0 60 0 60 90 0 90 0 0 -40z" })));
const ajt = ({ dataSetName: e14, fields: t10 }) => {
  const { fieldsDragRef: n10, fieldsDragPreview: r10 } = ((e15, t11) => {
    const [, n11, r11] = Yne({ item: { type: "fields", reportItemType: "table", fields: e15, dataSetName: t11, fillData: { columns: rjt(e15) }, properties: { DataSetName: t11, Type: "table" } }, canDrag: () => 0 !== e15.length });
    return { fieldsDragRef: n11, fieldsDragPreview: r11 };
  })(t10, e14);
  ep.useEffect(() => {
    null == r10 || r10(Coe(), { captureDraggingState: true });
  }, [t10, e14]);
  const o10 = PA();
  const a10 = h9().$currentLayerName;
  return tp.createElement("div", { onDoubleClick: () => {
    o10(tU({ fillData: { columns: rjt(t10) }, properties: { DataSetName: e14, Type: "table" } }, { currentLayerName: a10 }));
  }, ref: n10 }, ojt);
};
const ijt = [QRt, eAt, tAt, nAt];
const sjt = ({ children: e14 }) => tp.createElement("div", { className: "panel-group ar-shutter" }, tp.createElement("div", { className: "panel panel-default ar-shutter-content" }, tp.createElement("div", { className: "ar-shutter-body" }, e14)));
const ljt = ({ text: e14, onClick: t10 }) => tp.createElement("div", { key: "header-button", className: "panel-heading ar-with-buttons left" }, tp.createElement("button", { type: "button", className: "btn btn-default gc-rounded", onClick: t10 }, tp.createElement(Fm, { icon: Pm(Nm), customCSS: "gc-icon gc-btn__icon gc-accent-color wd-svg" })), e14);
function cjt(e14) {
  const t10 = e14.reduce((e15, t11) => Object.assign(Object.assign({}, e15), { [t11.Name]: Object.assign(Object.assign({}, t11), { level: 0, children: [] }) }), {});
  const n10 = [];
  e14.forEach((e15) => {
    var r11;
    const o10 = t10[e15.Name];
    const a10 = null === (r11 = bBt(o10.Query.DataSourceName)) || void 0 === r11 ? void 0 : r11.dataset;
    const i10 = null != a10 ? t10[a10] : null;
    null == i10 ? n10.push(o10) : i10.children.push(o10);
  });
  const r10 = [];
  return function e15(t11, n11) {
    t11.forEach((t12) => {
      var { children: o10 } = t12, a10 = m(t12, ["children"]);
      r10.push(Object.assign(Object.assign({}, a10), { level: n11 })), e15(o10, n11 + 1);
    });
  }(n10, 0), r10;
}
const ujt = (e14) => {
  const t10 = e14.core.document.present.content;
  return { reportParameters: t10.ReportParameters, dataSources: t10.DataSources, datasetList: cjt(t10.DataSets), $index: t10.$index, theme: e14.core.rdlx.theme, reportType: t10.Type, reportId: e14.app.documentId, panel: e14.dataPanel, templates: e14.dataSourceTemplates };
};
function djt(e14) {
  return e14.ConnectionProperties.DataProvider;
}
const pjt = () => {
  var e14, t10;
  const { data: { dataSources: { visible: n10, canModify: r10 }, dataSets: { visible: o10, canModify: a10 }, parameters: { visible: i10, canModify: s10 }, commonValues: { visible: l10 } } } = JRt();
  const c10 = r10;
  const [u10, d10] = ep.useState([]);
  const p10 = LA(ujt), { reportParameters: h10, dataSources: f10, datasetList: g10, reportId: y10, panel: v10, templates: b10 } = p10, S10 = m(p10, ["reportParameters", "dataSources", "datasetList", "reportId", "panel", "templates"]);
  const C10 = PA();
  const { instanceId: x10, rdlx: { expressionEditorNodesFilter: w10 } } = JRt();
  const T10 = (e15) => () => C10(wOt(e15));
  const E10 = {};
  c10 && b10 && b10.length > 0 && (1 === b10.length ? E10.onAdd = T10(b10[0].id) : E10.items = [{ type: "dropdown", text: VRt.t("dataPanel.addCmdTitle", "Add"), background: "transparent", icon: Pm(_m), hiddenChevron: true, items: b10.map(({ title: e15, id: t11 }) => ({ type: "button", icon: { type: "font", iconCssClass: "mdi database-add" }, text: e15, onClick: T10(t11) })) }]);
  const F10 = (e15) => {
    const { $templateId: t11 } = e15;
    return null == b10 ? void 0 : b10.find((e16) => e16.id === t11);
  };
  const M10 = (e15) => {
    var t11, n11;
    const r11 = djt(e15);
    return null !== (n11 = null === (t11 = F10(e15)) || void 0 === t11 ? void 0 : t11.datasets) && void 0 !== n11 ? n11 : ijt.includes(r11) ? [QBt] : [];
  };
  const k10 = (e15) => {
    var t11;
    const n11 = null === (t11 = bBt(e15.Query.DataSourceName)) || void 0 === t11 ? void 0 : t11.dataset;
    if ("string" == typeof n11) {
      const e16 = g10.find((e17) => e17.Name === n11);
      return e16 ? k10(e16) : null;
    }
    return e15;
  };
  const P10 = (e15) => () => C10(TOt(e15.Name));
  const N10 = (e15, t11) => {
    const n11 = M10(e15).find((e16) => e16.id === t11);
    n11 && C10(EOt(t11, n11, e15.Name));
  };
  const D10 = (e15) => {
    var t11;
    const n11 = M10(e15);
    const o11 = "TESTING" === e15.ConnectionProperties.DataProvider;
    const i11 = r10 && false !== (null === (t11 = F10(e15)) || void 0 === t11 ? void 0 : t11.canEdit) && !o11 && L10(e15);
    const s11 = { dataSource: e15, onEdit: i11 ? () => ((e16) => {
      const t12 = { mode: "edit", initialData: e16, usedDatasourceNames: f10.map((e17) => e17.Name) };
      C10(_A.of(x10).open("datasource", t12));
    })(e15) : void 0, onDelete: r10 ? P10(e15) : void 0 };
    if (a10 && n11.length > 0 && !o11) if (1 === n11.length) s11.onAddDataSet = () => N10(e15, n11[0].id);
    else {
      const t12 = n11.map(({ title: t13, id: n12 }) => ({ type: "button", icon: { type: "font", iconCssClass: "mdi mdi-database-add" }, text: t13, onClick: () => N10(e15, n12) }));
      s11.customAdd = tp.createElement(UF, { items: t12, text: "", size: "small", background: "transparent", hiddenChevron: true, icon: Pm(_m) });
    }
    return s11;
  };
  function L10(e15) {
    if (e15) {
      const t11 = djt(e15);
      return ijt.includes(t11);
    }
    return false;
  }
  const H10 = (e15, t11) => {
    var n11;
    const r11 = f10.find((t12) => t12.Name === e15.Query.DataSourceName);
    const o11 = "TESTING" === (null == r11 ? void 0 : r11.ConnectionProperties.DataProvider);
    const i11 = bBt(e15.Query.DataSourceName);
    const s11 = false !== (null === (n11 = ((e16) => {
      var t12;
      const n12 = k10(e16);
      const r12 = null == f10 ? void 0 : f10.find((e17) => {
        var t13;
        return e17.Name === (null === (t13 = null == n12 ? void 0 : n12.Query) || void 0 === t13 ? void 0 : t13.DataSourceName);
      });
      if (r12) {
        const e17 = F10(r12);
        const { $templateId: o12 } = n12;
        return null === (t12 = null == e17 ? void 0 : e17.datasets) || void 0 === t12 ? void 0 : t12.find((e18) => e18.id === o12);
      }
    })(e15)) || void 0 === n11 ? void 0 : n11.canEdit) && L10(function(e16, t12, n12) {
      if (n12) return n12;
      const r12 = k10(e16);
      return r12 ? t12.find((e17) => e17.Name === r12.Query.DataSourceName) : void 0;
    }(e15, f10, r11)) && !o11;
    const l11 = { text: "Explore", onClick: () => ((e16) => {
      C10(vOt.openSmartSuggestions(e16.Name));
    })(e15) };
    return { dataSet: e15, expanded: v10.expandedDatasetName === e15.Name, disableEdit: !s11, onClick: () => ((e16) => C10(vOt.toggleExpandDataSet(e16.Name)))(e15), onDelete: a10 ? () => ((e16) => C10(U2.rdlxRemoveDataSet({ dataSet: e16 })))(e15) : void 0, basedOnOverride: null != i11 ? "" : void 0, onEdit: a10 ? () => ((e16) => C10(FOt(e16.Name)))(e15) : void 0, index: t11, onEditParameter: () => {
    }, customCSS: `dataset-list-level-${e15.level}`, customActions: 0 === u10.length ? [] : [l11], onSelectedFieldsChange: (e16) => d10(e16), selectedFields: u10 };
  };
  const I10 = { title: VRt.t("dataPanel.commonValuesLabel", "Common Values"), collapsed: !v10.commonValuesExpanded, items: [{ type: "button", icon: Pm(Lm, { rotate: v10.commonValuesExpanded ? void 0 : "180" }), onClick: () => C10(vOt.toggleCommonValues()) }] };
  const _10 = { commonNodesFilter: w10, reportType: S10.reportType };
  return ep.useEffect(() => {
    var e15;
    "param" === (null === (e15 = v10.activeEditor) || void 0 === e15 ? void 0 : e15.type) && v10.activeEditor.parameterIndex >= h10.length && C10(vOt.resetActiveEditor());
  }, [v10.activeEditor, h10.length, C10]), tp.createElement("div", { className: "ar-data-panel" }, tp.createElement(bF, { autoHide: true }, !v10.activeEditor && tp.createElement("div", { className: "panel-group" }, n10 && (c10 || f10.length > 0) && tp.createElement(KWt, Object.assign({ title: VRt.t("dataPanel.dataSourcesLabel", "Data Sources") }, E10), 0 === f10.length && tp.createElement("span", { className: "wd-sidebar-panel__placeholder" }, VRt.t("dataPanel.noDataSources", "Report has no data sources")), f10.map((e15) => tp.createElement(ZWt, Object.assign({ key: e15.Name }, D10(e15))))), o10 && tp.createElement(KWt, { title: VRt.t("dataPanel.dataSetsLabel", "Data Sets") }, 0 === g10.length && tp.createElement("span", { className: "wd-sidebar-panel__placeholder" }, VRt.t("dataPanel.noDataSets", "Report has no data sets")), g10.map((e15, t11) => tp.createElement(pBe, Object.assign({ key: e15.Name }, H10(e15, t11))))), i10 && tp.createElement(KWt, { title: VRt.t("dataPanel.parametersLabel", "Parameters"), onAdd: s10 ? function() {
    const e15 = VRt.t("nameTemplates.reportParameter", "Parameter");
    const t11 = kG(e15, h10.map((e16) => e16.Name));
    const n11 = T0(t11, 0, {});
    C10(U2.rdlxAddParameter({ param: n11 })), C10(vOt.editParameter(h10.length));
  } : void 0 }, 0 === h10.length && tp.createElement("span", { className: "wd-sidebar-panel__placeholder" }, VRt.t("dataPanel.noParameters", "Report has no parameters")), tp.createElement(SBe, { reportParameters: h10, onClick: (e15, t11) => C10(vOt.editParameter(t11)), onDelete: (e15) => C10(U2.rdlxRemoveParameter({ index: e15 })), onMoveUp: (e15) => {
    e15 > 0 && C10(U2.rdlxMoveParamUp(e15));
  }, onMoveDown: (e15) => {
    e15 < h10.length - 1 && C10(U2.rdlxMoveParamDown(e15));
  } })), l10 && tp.createElement(KWt, Object.assign({}, I10), tp.createElement($Oe, Object.assign({}, _10)))), "param" === (null === (e14 = v10.activeEditor) || void 0 === e14 ? void 0 : e14.type) && tp.createElement("div", { className: "ar-panel-overlay-container show", id: "parameter-editor-shutter" }, tp.createElement(sjt, null, tp.createElement(ljt, { text: VRt.t("dataPanel.editParameter", "Edit parameter"), onClick: () => C10(vOt.resetActiveEditor()) }), v10.activeEditor.parameterIndex < h10.length && tp.createElement(jWt, { parameterIndex: v10.activeEditor.parameterIndex, validationContext: function(e15) {
    const t11 = `ReportParameters.${e15}`;
    return dJ(S10.reportType, S10.$index, S10.theme, t11);
  }(v10.activeEditor.parameterIndex) }))), "smart" === (null === (t10 = v10.activeEditor) || void 0 === t10 ? void 0 : t10.type) && tp.createElement("div", { className: "ar-panel-overlay-container show", id: "smart-suggestions-editor-shutter" }, tp.createElement(sjt, null, tp.createElement(ljt, { text: VRt.t("dataPanel.smartSuggestions", "Smart Suggestions"), onClick: () => C10(vOt.resetActiveEditor()) }), v10.smartSuggestions && tp.createElement(ajt, { dataSetName: v10.smartSuggestions.dataSetName, fields: u10 })))));
};
const mjt = () => {
  const { propertyGrid: { propertiesTab: { visible: e14 }, collapsibleCategories: { enabled: t10 }, saveExpandEditorsState: { enabled: n10 } } } = XRt();
  const { data: { dataTab: { visible: r10 } }, userPreferences: { sidebar: { width: o10 } } } = JRt();
  const { identifiers: { sidebarControlsId: a10, instanceId: i10 } } = KRt();
  const s10 = LA(Kzt);
  const l10 = PA();
  const c10 = KO.of(i10);
  const u10 = ep.useCallback((e15) => l10(TAt(e15 || "")), [l10]);
  const d10 = ep.useCallback((e15) => {
    c10.userPreferences.sidebar.width = e15;
  }, []);
  const p10 = [];
  if (e14 && p10.push("propsTab"), r10 && p10.push("dataTab"), 0 === p10.length) return null;
  const m10 = { defaultPanelId: p10.includes(s10) ? s10 : p10[0], defaultWidth: o10 > 0 ? o10 : void 0, minResizeWidth: 300, controlsContainerId: a10, collapseTitle: VRt.t("sideBar.collapse", "Collapse"), expandTitle: VRt.t("sideBar.expand", "Expand"), dataAid: "sidebar", onPanelChange: u10, onResizeEnd: d10 };
  const h10 = VRt.t("propertiesTab.title", "Properties");
  const f10 = VRt.t("dataTab.title", "Data");
  const g10 = Object.assign({}, gRt);
  return tp.createElement(PN, Object.assign({ key: "sidebar" }, m10), false !== e14 && tp.createElement(dN, { id: "propsTab", toggle: { icon: Pm($Wt), text: h10, title: h10 }, customScroll: true }, tp.createElement(bF, null, tp.createElement(lut, { collapsibleCategories: t10, saveExpandEditorsState: n10 })), tp.createElement(h$, { panels: g10 })), false !== e14 && false !== r10 && tp.createElement(dN, { id: "dataTab", toggle: { icon: Pm(zWt), text: f10, title: f10 }, customScroll: true }, tp.createElement(pjt, null)));
};
mjt.displayName = "App.DesignerSideBar";
const hjt = () => {
  const [e14] = Nz();
  return e14 === M$e.workspaceId ? tp.createElement(M$e.Sidebar, null) : tp.createElement(mjt, null);
};
hjt.displayName = "App.SideBar";
const fjt = () => {
  const { settings: { statusBar: { visible: e14, propertiesModeButton: t10, toggleUnitsButton: n10, toggleGridButton: r10, rulersButton: o10, gridSizeEditor: a10 } } } = KRt();
  if (!e14) return null;
  const i10 = ep.useMemo(() => ({ propertiesMode: false === t10.visible, units: false === n10.visible, gridToggle: false === r10.visible, rulersToggle: false === o10.visible, gridSizeEditor: false === a10.visible, zoom: !$z.zoom }), [a10.visible, t10.visible, o10.visible, r10.visible, n10.visible]);
  return tp.createElement(kut, { hiddenElements: i10 });
};
fjt.displayName = "App.StatusBar";
const gjt = () => {
  const { settings: { toolBar: { visible: e14 } } } = KRt();
  return e14 ? tp.createElement(Wct, null) : null;
};
gjt.displayName = "App.ToolBar";
const yjt = ({ coreProps: { identifiers: { instanceId: e14, sidebarControlsId: t10 }, settings: n10 }, coreProps: r10 }) => {
  const { workspaceId: o10, hasUnsavedChanges: a10, rdlx: { reportStyles: i10 } } = Ait();
  const s10 = XRt();
  const l10 = Oit();
  const { onKeyDown: c10, containerRef: u10 } = ((e15, t11, n11, r11) => {
    const o11 = PA();
    const { contextActions: a11 } = Ait();
    const i11 = ep.useRef(null);
    const s11 = r11.content;
    const l11 = ep.useCallback((i12, l12) => {
      const c11 = i12(l12, e15, t11, n11, r11);
      c11 && (l12.stopPropagation(), l12.preventDefault(), c11({ contextActions: a11, document: s11, settings: e15, dispatch: o11 }));
    }, [a11, o11, s11, r11, e15, t11, n11]);
    return ep.useEffect(() => {
      const e16 = i11.current;
      const t12 = (e17) => {
        SB(e17) && l11(B$t, e17);
      };
      return null == e16 || e16.addEventListener("wheel", t12), () => null == e16 ? void 0 : e16.removeEventListener("wheel", t12);
    }, [l11]), { onKeyDown: (e16) => {
      l11(O$t, e16);
    }, containerRef: i11 };
  })(n10, s10, o10, l10);
  const d10 = l10.content;
  const { DataSources: p10, DataSets: m10, ReportParameters: h10 } = null != d10 ? d10 : { DataSources: [], DataSets: [], ReportParameters: [] };
  const f10 = ep.useRef([]);
  const g10 = ep.useRef(null);
  const y10 = ep.useCallback((e15) => {
    var t11;
    null === (t11 = g10.current) || void 0 === t11 || t11.onMenuTransition(e15);
  }, []);
  const v10 = ep.useCallback(() => ({ start: () => {
    y10(true);
  }, end: () => {
    y10(false);
  } }), [y10]);
  ep.useEffect(() => {
    const t11 = hm.of(e14);
    return f10.current = [t11.menu.onTransition(v10()), t11.sidebar.onTransition(v10())], () => f10.current.forEach((e15) => e15());
  }, [e14, v10]);
  const { content: b10 } = l10;
  const [S10, C10] = ep.useState("");
  ep.useEffect(() => {
    const { documentChanged: t11 } = f$t.of(e14).settings.events;
    if (t11.event.hasListeners() && b10) {
      const { serializeDocument: n11 } = kit.of(e14);
      const r11 = n11({ documentType: "rdlx", documentContent: b10 });
      const o11 = JSON.stringify(r11);
      o11 !== S10 && (t11.trigger({ definition: r11, isDirty: a10 }), C10(o11));
    } else C10("");
  }, [b10]);
  const x10 = ep.useMemo(() => Object.assign(Object.assign({}, fRt), { about: (e15) => tp.createElement(W$t, { key: e15 }), datasource: (e15, t11) => tp.createElement(IWt, Object.assign({}, t11, { key: e15 })), datasetNew: (e15, t11) => tp.createElement(EWt, Object.assign({}, t11, { key: e15, dataSources: p10, modelDatasets: m10, reportParameters: h10 })), queryValues: (e15, t11) => tp.createElement(Pzt, Object.assign({}, t11, { key: e15 })), tablixWizard: (e15, t11) => tp.createElement(ret, Object.assign({ key: e15 }, t11, { reportStyles: i10, stateSelector: Xzt })), tablixWizardWarning: (e15, t11) => tp.createElement(uet, Object.assign({ key: e15 }, t11)), exportTemplate: (e15, t11) => tp.createElement(_Wt, Object.assign({ key: e15 }, t11)) }), []);
  return tp.createElement(bne, { backend: xoe }, tp.createElement("div", { className: "wd-web-designer", onKeyDown: c10, tabIndex: -1, ref: u10 }, tp.createElement(Zct, Object.assign({}, r10), tp.createElement(RWt, null), tp.createElement(DV, { area: "appbar" }, tp.createElement(z$t, null)), tp.createElement(DV, { area: "menu" }, tp.createElement(VWt, null)), tp.createElement(DV, { area: "toolbar" }, tp.createElement(gjt, null), tp.createElement(iN, { id: t10 })), tp.createElement(DV, { area: "surface" }, tp.createElement(Lht, { makeSharedImageUrl: s10.resourceProvider.getResourceUri, decorationLayerRef: g10 }), tp.createElement(BWt, null)), tp.createElement(DV, { area: "statusbar" }, tp.createElement(fjt, null)), tp.createElement(DV, { area: "sidebar" }, tp.createElement(hjt, null)), tp.createElement(jA, { id: e14, dialogs: x10 }))));
};
yjt.displayName = "WebDesigner";
const vjt = yjt;
function bjt(e14, t10, n10) {
  var r10;
  return null !== (r10 = null != t10 ? t10 : e14) && void 0 !== r10 ? r10 : n10;
}
const Sjt = (e14) => `cf_${e14.replace(/\.|\(|\)/g, "")}`;
function Cjt(e14, t10) {
  const n10 = { lng: e14, ns: "expressionFields", resources: { functions: { info: { customFunctions: {} }, titles: { cfg_customcode: t10.t("expressions.customCodeGroup", "Custom Code") } } } };
  return r.getFunctions().forEach((e15) => {
    var t11, r10, o10, a10, i10, s10;
    n10.resources.functions.info.customFunctions[Sjt(e15.name)] = { label: e15.name, description: null !== (r10 = null === (t11 = e15.info) || void 0 === t11 ? void 0 : t11.description) && void 0 !== r10 ? r10 : "", example: null !== (a10 = null === (o10 = e15.info) || void 0 === o10 ? void 0 : o10.example) && void 0 !== a10 ? a10 : "", syntax: null !== (s10 = null === (i10 = e15.info) || void 0 === i10 ? void 0 : i10.syntax) && void 0 !== s10 ? s10 : "" };
  }), n10;
}
const xjt = "ARJSDesignerPreferences";
const wjt = { load: () => {
  var e14;
  try {
    return JSON.parse(null !== (e14 = localStorage.getItem(xjt)) && void 0 !== e14 ? e14 : "null");
  } catch (e15) {
    return null;
  }
}, save: (e14) => localStorage.setItem(xjt, JSON.stringify(e14)) };
function Tjt(e14) {
  const t10 = ["CPL", "FPL", "Pageless"];
  const n10 = e14("designer.reportTypes", { defaultValue: t10, returnObjects: true });
  const r10 = Array.isArray(n10) ? n10[0] : void 0;
  return t10.includes(r10) ? r10 : t10[0];
}
const Ejt = (e14, t10, n10, o10) => y(void 0, void 0, void 0, function* () {
  var a10, i10, s10, l10, c10, u10, d10, p10, m10, h10, f10;
  const g10 = ((e15) => "string" == typeof e15 ? document.querySelector(e15) : e15 instanceof Element ? e15 : e15 && "jquery" in e15 ? e15[0] : null)(e14);
  if (!g10) throw new Error(VRt.t("error.noHostElement", "Cannot find the host element."));
  yield RRt, yield VRt.changeLanguage(n10.language || "en");
  const { settings: y10, customInitTemplatesErrors: v10 } = yield V$t(t10, n10, o10);
  const b10 = null !== (a10 = function(e15) {
    return ARt[e15];
  }(y10.language)) && void 0 !== a10 ? a10 : [];
  const S10 = null !== (i10 = y10.customPreferencesStorage) && void 0 !== i10 ? i10 : wjt;
  const { props: { identifiers: C10, settings: x10 }, props: w10 } = VVt({ instanceId: t10, focusTimer: { disabled: true === y10.disableFocusTimer }, resourceBundles: [...b10, Cjt(null !== (s10 = n10.language) && void 0 !== s10 ? s10 : "en", VRt)], title: { disabled: true }, settings: y10, mutableAppSettings: sAt, onPreferencesChange: y10.storeUserPreferences ? (T10 = S10, (e15) => {
    T10.save(e15);
  }) : void 0 });
  var T10;
  const E10 = Object.assign(Object.assign({}, x10), { customExpressionFunctions: r.getFunctions().map((e15) => ({ value: `Code.${e15.name}()`, key: Sjt(e15.name), group: "cfg_customcode" })) });
  (({ lockLayout: e15, editor: { rulers: t11 }, data: { dataSets: n11, dataSources: r10, dataTab: o11, parameters: a11, commonValues: i11 }, rdlx: { toolBoxContent: s11, reportItemsFeatures: l11, expressionSyntax: c11 }, customExpressionFunctions: u11 }) => {
    EX({ reportItems: null == s11 ? void 0 : s11.cpl, reportItemsFeatures: l11, lockLayout: e15, expressionSyntax: c11, customExpressionFunctions: u11, dataTab: { visible: o11.visible, dataSources: { visible: r10.visible, canModify: r10.canModify }, dataSets: { visible: n11.visible, canModify: n11.canModify }, parameters: { visible: a11.visible, canModify: a11.canModify }, commonValues: { visible: i11.visible } }, rulers: { visible: null == t11 ? void 0 : t11.visible, snapStep: null == t11 ? void 0 : t11.snapStep } });
  })(E10);
  const F10 = VRt.getFixedT(E10.language);
  const M10 = l$t(t10, 0, F10);
  ((e15, t11) => {
    t11.dispatch, kit(e15, t11);
  })(t10, M10), E10.storeUserPreferences && (({ editor: e15, propertyGrid: t11, units: n11, themeConfig: r10 }, o11, a11) => {
    var i11, s11, l11, c11, u11, d11, p11;
    const m11 = KO.of(a11);
    let h11;
    "Advanced" === (null == t11 ? void 0 : t11.mode) ? h11 = "advanced" : "Basic" === (null == t11 ? void 0 : t11.mode) && (h11 = "simple");
    const { userPreferences: f11 } = qRt;
    const g11 = o11.load();
    const y11 = bjt(null == g11 ? void 0 : g11.surface.gridSize, null == e15 ? void 0 : e15.gridSize, f11.surface.gridSize);
    const v11 = bjt(null == g11 ? void 0 : g11.surface.showGrid, null == e15 ? void 0 : e15.showGrid, f11.surface.showGrid);
    const b11 = bjt(null == g11 ? void 0 : g11.surface.snapToGrid, null == e15 ? void 0 : e15.snapToGrid, f11.surface.snapToGrid);
    const S11 = bjt(null == g11 ? void 0 : g11.surface.snapToLines, null == e15 ? void 0 : e15.snapToGuides, f11.surface.snapToLines);
    const C11 = bjt(null == g11 ? void 0 : g11.surface.zoomFactor, void 0, f11.surface.zoomFactor);
    const x11 = bjt(null == g11 ? void 0 : g11.rulers.show, null === (i11 = null == e15 ? void 0 : e15.rulers) || void 0 === i11 ? void 0 : i11.visible, f11.rulers.show);
    const w11 = bjt(null == g11 ? void 0 : g11.rulers.snapStep.cm, null === (l11 = null === (s11 = null == e15 ? void 0 : e15.rulers) || void 0 === s11 ? void 0 : s11.snapStep) || void 0 === l11 ? void 0 : l11.cm, f11.rulers.snapStep.cm);
    const T11 = bjt(null == g11 ? void 0 : g11.rulers.snapStep.in, null === (u11 = null === (c11 = null == e15 ? void 0 : e15.rulers) || void 0 === c11 ? void 0 : c11.snapStep) || void 0 === u11 ? void 0 : u11.in, f11.rulers.snapStep.in);
    const E11 = bjt(null == g11 ? void 0 : g11.sidebar.propertiesMode, h11, f11.sidebar.propertiesMode);
    const F11 = bjt(null == g11 ? void 0 : g11.sidebar.propertiesSort, void 0, f11.sidebar.propertiesSort);
    const M11 = bjt(null == g11 ? void 0 : g11.sidebar.width, void 0, f11.sidebar.width);
    const k11 = bjt(null == g11 ? void 0 : g11.units, n11, f11.units);
    const P11 = (e16, t12) => {
      if (t12 && e16) return t12.some((t13) => t13 === n$t(e16)) ? e16 : void 0;
    };
    const N11 = bjt(P11(null == g11 ? void 0 : g11.theme, null === (d11 = null == r10 ? void 0 : r10.themeSelector) || void 0 === d11 ? void 0 : d11.availableThemes), P11(r$t(null == r10 ? void 0 : r10.initialTheme), null === (p11 = null == r10 ? void 0 : r10.themeSelector) || void 0 === p11 ? void 0 : p11.availableThemes), f11.theme);
    const D10 = AV(f11, { surface: { gridSize: { $set: y11 }, showGrid: { $set: v11 }, snapToGrid: { $set: b11 }, snapToLines: { $set: S11 }, zoomFactor: { $set: C11 } }, rulers: { show: { $set: x11 }, snapStep: { cm: { $set: w11 }, in: { $set: T11 } } }, sidebar: { propertiesMode: { $set: E11 }, propertiesSort: { $set: F11 }, width: { $set: M11 } }, units: { $set: k11 }, theme: { $set: N11 } });
    m11.userPreferences = D10;
  })(n10, S10, t10);
  const k10 = (() => {
    const e15 = VRt.t("application-title", "ActiveReportsJS Designer");
    return { applicationTitle: e15, applicationTitleCompact: e15, applicationVersion: "5.0.4", coreVersion: "13.0.0-dev.357", copyright: VRt.t("common.copyright", "Copyright \xA9\uFE0F MESCIUS inc. All rights reserved.") };
  })();
  const P10 = { identifiers: C10, settings: E10, about: k10, i18n: VRt };
  const N10 = f$t(t10, M10, k10);
  if ((null === (l10 = y10.rdlx.reportParts) || void 0 === l10 ? void 0 : l10.enabled) && (null !== (p10 = null === (d10 = null === (u10 = null === (c10 = y10.rdlx) || void 0 === c10 ? void 0 : c10.reportParts) || void 0 === u10 ? void 0 : u10.libraries) || void 0 === d10 ? void 0 : d10.length) && void 0 !== p10 ? p10 : 0) > 0) {
    const e15 = null === (f10 = null === (h10 = null === (m10 = y10.rdlx) || void 0 === m10 ? void 0 : m10.reportParts) || void 0 === h10 ? void 0 : h10.libraries) || void 0 === f10 ? void 0 : f10.filter((e16, t11, n11) => n11.findIndex((t12) => t12.path === e16.path) === t11);
    M10.dispatch(lWe.setAvailableLibraries(e15 || []));
  }
  mE.render(tp.createElement(oR, { store: M10 }, tp.createElement(YRt.Provider, { value: P10 }, tp.createElement(vjt, { coreProps: w10 }))), g10), yield N10.documents.createNew({ type: Tjt(F10), whenDirty: "ask" });
  for (const e15 of v10) N10.notifications.warning(F10("error.customInitTemplate.loadFailed", "Failed to load custom init template '{{id}}': {{error}}", { replace: { id: e15.id, error: e15.errorText }, interpolation: { escapeValue: false } }));
  return N10;
});
var Fjt = {};
var Mjt = {};
Mjt.byteLength = function(e14) {
  var t10 = Hjt(e14);
  var n10 = t10[0];
  var r10 = t10[1];
  return 3 * (n10 + r10) / 4 - r10;
}, Mjt.toByteArray = function(e14) {
  var t10;
  var n10 = Hjt(e14);
  var r10 = n10[0];
  var o10 = n10[1];
  var a10 = new Njt(function(e15, t11, n11) {
    return 3 * (t11 + n11) / 4 - n11;
  }(0, r10, o10));
  var i10 = 0;
  var s10 = o10 > 0 ? r10 - 4 : r10;
  var l10;
  for (l10 = 0; l10 < s10; l10 += 4) t10 = Pjt[e14.charCodeAt(l10)] << 18 | Pjt[e14.charCodeAt(l10 + 1)] << 12 | Pjt[e14.charCodeAt(l10 + 2)] << 6 | Pjt[e14.charCodeAt(l10 + 3)], a10[i10++] = t10 >> 16 & 255, a10[i10++] = t10 >> 8 & 255, a10[i10++] = 255 & t10;
  2 === o10 && (t10 = Pjt[e14.charCodeAt(l10)] << 2 | Pjt[e14.charCodeAt(l10 + 1)] >> 4, a10[i10++] = 255 & t10);
  1 === o10 && (t10 = Pjt[e14.charCodeAt(l10)] << 10 | Pjt[e14.charCodeAt(l10 + 1)] << 4 | Pjt[e14.charCodeAt(l10 + 2)] >> 2, a10[i10++] = t10 >> 8 & 255, a10[i10++] = 255 & t10);
  return a10;
}, Mjt.fromByteArray = function(e14) {
  var t10;
  var n10 = e14.length;
  var r10 = n10 % 3;
  var o10 = [];
  var a10 = 16383;
  for (var i10 = 0, s10 = n10 - r10; i10 < s10; i10 += a10) o10.push(Ijt(e14, i10, i10 + a10 > s10 ? s10 : i10 + a10));
  1 === r10 ? (t10 = e14[n10 - 1], o10.push(kjt[t10 >> 2] + kjt[t10 << 4 & 63] + "==")) : 2 === r10 && (t10 = (e14[n10 - 2] << 8) + e14[n10 - 1], o10.push(kjt[t10 >> 10] + kjt[t10 >> 4 & 63] + kjt[t10 << 2 & 63] + "="));
  return o10.join("");
};
var kjt = [];
var Pjt = [];
var Njt = "undefined" != typeof Uint8Array ? Uint8Array : Array;
var Djt = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var Ljt = 0; Ljt < 64; ++Ljt) kjt[Ljt] = Djt[Ljt], Pjt[Djt.charCodeAt(Ljt)] = Ljt;
function Hjt(e14) {
  var t10 = e14.length;
  if (t10 % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
  var n10 = e14.indexOf("=");
  return -1 === n10 && (n10 = t10), [n10, n10 === t10 ? 0 : 4 - n10 % 4];
}
function Ijt(e14, t10, n10) {
  var r10;
  var o10 = [];
  for (var a10 = t10; a10 < n10; a10 += 3) r10 = (e14[a10] << 16 & 16711680) + (e14[a10 + 1] << 8 & 65280) + (255 & e14[a10 + 2]), o10.push(kjt[(i10 = r10) >> 18 & 63] + kjt[i10 >> 12 & 63] + kjt[i10 >> 6 & 63] + kjt[63 & i10]);
  var i10;
  return o10.join("");
}
Pjt["-".charCodeAt(0)] = 62, Pjt["_".charCodeAt(0)] = 63;
var _jt = {};
_jt.read = function(e14, t10, n10, r10, o10) {
  var a10, i10;
  var s10 = 8 * o10 - r10 - 1;
  var l10 = (1 << s10) - 1;
  var c10 = l10 >> 1;
  var u10 = -7;
  var d10 = n10 ? o10 - 1 : 0;
  var p10 = n10 ? -1 : 1;
  var m10 = e14[t10 + d10];
  for (d10 += p10, a10 = m10 & (1 << -u10) - 1, m10 >>= -u10, u10 += s10; u10 > 0; a10 = 256 * a10 + e14[t10 + d10], d10 += p10, u10 -= 8) ;
  for (i10 = a10 & (1 << -u10) - 1, a10 >>= -u10, u10 += r10; u10 > 0; i10 = 256 * i10 + e14[t10 + d10], d10 += p10, u10 -= 8) ;
  if (0 === a10) a10 = 1 - c10;
  else {
    if (a10 === l10) return i10 ? NaN : 1 / 0 * (m10 ? -1 : 1);
    i10 += Math.pow(2, r10), a10 -= c10;
  }
  return (m10 ? -1 : 1) * i10 * Math.pow(2, a10 - r10);
}, _jt.write = function(e14, t10, n10, r10, o10, a10) {
  var i10, s10, l10;
  var c10 = 8 * a10 - o10 - 1;
  var u10 = (1 << c10) - 1;
  var d10 = u10 >> 1;
  var p10 = 23 === o10 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
  var m10 = r10 ? 0 : a10 - 1;
  var h10 = r10 ? 1 : -1;
  var f10 = t10 < 0 || 0 === t10 && 1 / t10 < 0 ? 1 : 0;
  for (t10 = Math.abs(t10), isNaN(t10) || t10 === 1 / 0 ? (s10 = isNaN(t10) ? 1 : 0, i10 = u10) : (i10 = Math.floor(Math.log(t10) / Math.LN2), t10 * (l10 = Math.pow(2, -i10)) < 1 && (i10--, l10 *= 2), (t10 += i10 + d10 >= 1 ? p10 / l10 : p10 * Math.pow(2, 1 - d10)) * l10 >= 2 && (i10++, l10 /= 2), i10 + d10 >= u10 ? (s10 = 0, i10 = u10) : i10 + d10 >= 1 ? (s10 = (t10 * l10 - 1) * Math.pow(2, o10), i10 += d10) : (s10 = t10 * Math.pow(2, d10 - 1) * Math.pow(2, o10), i10 = 0)); o10 >= 8; e14[n10 + m10] = 255 & s10, m10 += h10, s10 /= 256, o10 -= 8) ;
  for (i10 = i10 << o10 | s10, c10 += o10; c10 > 0; e14[n10 + m10] = 255 & i10, m10 += h10, i10 /= 256, c10 -= 8) ;
  e14[n10 + m10 - h10] |= 128 * f10;
};
var Vjt = {}.toString;
var Rjt = Array.isArray || function(e14) {
  return "[object Array]" == Vjt.call(e14);
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
!function(e14) {
  var t10 = Mjt;
  var n10 = _jt;
  var r10 = Rjt;
  function o10() {
    return i10.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
  }
  function a10(e15, t11) {
    if (o10() < t11) throw new RangeError("Invalid typed array length");
    return i10.TYPED_ARRAY_SUPPORT ? (e15 = new Uint8Array(t11)).__proto__ = i10.prototype : (null === e15 && (e15 = new i10(t11)), e15.length = t11), e15;
  }
  function i10(e15, t11, n11) {
    if (!(i10.TYPED_ARRAY_SUPPORT || this instanceof i10)) return new i10(e15, t11, n11);
    if ("number" == typeof e15) {
      if ("string" == typeof t11) throw new Error("If encoding is specified then the first argument must be a string");
      return c10(this, e15);
    }
    return s10(this, e15, t11, n11);
  }
  function s10(e15, t11, n11, o11) {
    if ("number" == typeof t11) throw new TypeError('"value" argument must not be a number');
    return "undefined" != typeof ArrayBuffer && t11 instanceof ArrayBuffer ? function(e16, t12, n12, r11) {
      if (t12.byteLength, n12 < 0 || t12.byteLength < n12) throw new RangeError("'offset' is out of bounds");
      if (t12.byteLength < n12 + (r11 || 0)) throw new RangeError("'length' is out of bounds");
      t12 = void 0 === n12 && void 0 === r11 ? new Uint8Array(t12) : void 0 === r11 ? new Uint8Array(t12, n12) : new Uint8Array(t12, n12, r11);
      i10.TYPED_ARRAY_SUPPORT ? (e16 = t12).__proto__ = i10.prototype : e16 = u10(e16, t12);
      return e16;
    }(e15, t11, n11, o11) : "string" == typeof t11 ? function(e16, t12, n12) {
      "string" == typeof n12 && "" !== n12 || (n12 = "utf8");
      if (!i10.isEncoding(n12)) throw new TypeError('"encoding" must be a valid string encoding');
      var r11 = 0 | p10(t12, n12);
      e16 = a10(e16, r11);
      var o12 = e16.write(t12, n12);
      o12 !== r11 && (e16 = e16.slice(0, o12));
      return e16;
    }(e15, t11, n11) : function(e16, t12) {
      if (i10.isBuffer(t12)) {
        var n12 = 0 | d10(t12.length);
        return 0 === (e16 = a10(e16, n12)).length || t12.copy(e16, 0, 0, n12), e16;
      }
      if (t12) {
        if ("undefined" != typeof ArrayBuffer && t12.buffer instanceof ArrayBuffer || "length" in t12) return "number" != typeof t12.length || (o12 = t12.length) != o12 ? a10(e16, 0) : u10(e16, t12);
        if ("Buffer" === t12.type && r10(t12.data)) return u10(e16, t12.data);
      }
      var o12;
      throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
    }(e15, t11);
  }
  function l10(e15) {
    if ("number" != typeof e15) throw new TypeError('"size" argument must be a number');
    if (e15 < 0) throw new RangeError('"size" argument must not be negative');
  }
  function c10(e15, t11) {
    if (l10(t11), e15 = a10(e15, t11 < 0 ? 0 : 0 | d10(t11)), !i10.TYPED_ARRAY_SUPPORT) for (var n11 = 0; n11 < t11; ++n11) e15[n11] = 0;
    return e15;
  }
  function u10(e15, t11) {
    var n11 = t11.length < 0 ? 0 : 0 | d10(t11.length);
    e15 = a10(e15, n11);
    for (var r11 = 0; r11 < n11; r11 += 1) e15[r11] = 255 & t11[r11];
    return e15;
  }
  function d10(e15) {
    if (e15 >= o10()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + o10().toString(16) + " bytes");
    return 0 | e15;
  }
  function p10(e15, t11) {
    if (i10.isBuffer(e15)) return e15.length;
    if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e15) || e15 instanceof ArrayBuffer)) return e15.byteLength;
    "string" != typeof e15 && (e15 = "" + e15);
    var n11 = e15.length;
    if (0 === n11) return 0;
    var r11 = false;
    for (; ; ) switch (t11) {
      case "ascii":
      case "latin1":
      case "binary":
        return n11;
      case "utf8":
      case "utf-8":
      case void 0:
        return O10(e15).length;
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return 2 * n11;
      case "hex":
        return n11 >>> 1;
      case "base64":
        return B10(e15).length;
      default:
        if (r11) return O10(e15).length;
        t11 = ("" + t11).toLowerCase(), r11 = true;
    }
  }
  function m10(e15, t11, n11) {
    var r11 = false;
    if ((void 0 === t11 || t11 < 0) && (t11 = 0), t11 > this.length) return "";
    if ((void 0 === n11 || n11 > this.length) && (n11 = this.length), n11 <= 0) return "";
    if ((n11 >>>= 0) <= (t11 >>>= 0)) return "";
    for (e15 || (e15 = "utf8"); ; ) switch (e15) {
      case "hex":
        return k10(this, t11, n11);
      case "utf8":
      case "utf-8":
        return T10(this, t11, n11);
      case "ascii":
        return F10(this, t11, n11);
      case "latin1":
      case "binary":
        return M10(this, t11, n11);
      case "base64":
        return w10(this, t11, n11);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return P10(this, t11, n11);
      default:
        if (r11) throw new TypeError("Unknown encoding: " + e15);
        e15 = (e15 + "").toLowerCase(), r11 = true;
    }
  }
  function h10(e15, t11, n11) {
    var r11 = e15[t11];
    e15[t11] = e15[n11], e15[n11] = r11;
  }
  function f10(e15, t11, n11, r11, o11) {
    if (0 === e15.length) return -1;
    if ("string" == typeof n11 ? (r11 = n11, n11 = 0) : n11 > 2147483647 ? n11 = 2147483647 : n11 < -2147483648 && (n11 = -2147483648), n11 = +n11, isNaN(n11) && (n11 = o11 ? 0 : e15.length - 1), n11 < 0 && (n11 = e15.length + n11), n11 >= e15.length) {
      if (o11) return -1;
      n11 = e15.length - 1;
    } else if (n11 < 0) {
      if (!o11) return -1;
      n11 = 0;
    }
    if ("string" == typeof t11 && (t11 = i10.from(t11, r11)), i10.isBuffer(t11)) return 0 === t11.length ? -1 : g10(e15, t11, n11, r11, o11);
    if ("number" == typeof t11) return t11 &= 255, i10.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? o11 ? Uint8Array.prototype.indexOf.call(e15, t11, n11) : Uint8Array.prototype.lastIndexOf.call(e15, t11, n11) : g10(e15, [t11], n11, r11, o11);
    throw new TypeError("val must be string, number or Buffer");
  }
  function g10(e15, t11, n11, r11, o11) {
    var a11 = 1;
    var i11 = e15.length;
    var s11 = t11.length;
    if (void 0 !== r11 && ("ucs2" === (r11 = String(r11).toLowerCase()) || "ucs-2" === r11 || "utf16le" === r11 || "utf-16le" === r11)) {
      if (e15.length < 2 || t11.length < 2) return -1;
      a11 = 2, i11 /= 2, s11 /= 2, n11 /= 2;
    }
    function l11(e16, t12) {
      return 1 === a11 ? e16[t12] : e16.readUInt16BE(t12 * a11);
    }
    var c11;
    if (o11) {
      var u11 = -1;
      for (c11 = n11; c11 < i11; c11++) if (l11(e15, c11) === l11(t11, -1 === u11 ? 0 : c11 - u11)) {
        if (-1 === u11 && (u11 = c11), c11 - u11 + 1 === s11) return u11 * a11;
      } else -1 !== u11 && (c11 -= c11 - u11), u11 = -1;
    } else for (n11 + s11 > i11 && (n11 = i11 - s11), c11 = n11; c11 >= 0; c11--) {
      var d11 = true;
      for (var p11 = 0; p11 < s11; p11++) if (l11(e15, c11 + p11) !== l11(t11, p11)) {
        d11 = false;
        break;
      }
      if (d11) return c11;
    }
    return -1;
  }
  function y10(e15, t11, n11, r11) {
    n11 = Number(n11) || 0;
    var o11 = e15.length - n11;
    r11 ? (r11 = Number(r11)) > o11 && (r11 = o11) : r11 = o11;
    var a11 = t11.length;
    if (a11 % 2 != 0) throw new TypeError("Invalid hex string");
    r11 > a11 / 2 && (r11 = a11 / 2);
    for (var i11 = 0; i11 < r11; ++i11) {
      var s11 = parseInt(t11.substr(2 * i11, 2), 16);
      if (isNaN(s11)) return i11;
      e15[n11 + i11] = s11;
    }
    return i11;
  }
  function v10(e15, t11, n11, r11) {
    return z10(O10(t11, e15.length - n11), e15, n11, r11);
  }
  function b10(e15, t11, n11, r11) {
    return z10(function(e16) {
      var t12 = [];
      for (var n12 = 0; n12 < e16.length; ++n12) t12.push(255 & e16.charCodeAt(n12));
      return t12;
    }(t11), e15, n11, r11);
  }
  function S10(e15, t11, n11, r11) {
    return b10(e15, t11, n11, r11);
  }
  function C10(e15, t11, n11, r11) {
    return z10(B10(t11), e15, n11, r11);
  }
  function x10(e15, t11, n11, r11) {
    return z10(function(e16, t12) {
      var n12, r12, o11;
      var a11 = [];
      for (var i11 = 0; i11 < e16.length && !((t12 -= 2) < 0); ++i11) r12 = (n12 = e16.charCodeAt(i11)) >> 8, o11 = n12 % 256, a11.push(o11), a11.push(r12);
      return a11;
    }(t11, e15.length - n11), e15, n11, r11);
  }
  function w10(e15, n11, r11) {
    return 0 === n11 && r11 === e15.length ? t10.fromByteArray(e15) : t10.fromByteArray(e15.slice(n11, r11));
  }
  function T10(e15, t11, n11) {
    n11 = Math.min(e15.length, n11);
    var r11 = [];
    var o11 = t11;
    for (; o11 < n11; ) {
      var a11 = e15[o11];
      var i11 = null;
      var s11 = a11 > 239 ? 4 : a11 > 223 ? 3 : a11 > 191 ? 2 : 1;
      var l11, c11, u11, d11;
      if (o11 + s11 <= n11) switch (s11) {
        case 1:
          a11 < 128 && (i11 = a11);
          break;
        case 2:
          128 == (192 & (l11 = e15[o11 + 1])) && (d11 = (31 & a11) << 6 | 63 & l11) > 127 && (i11 = d11);
          break;
        case 3:
          l11 = e15[o11 + 1], c11 = e15[o11 + 2], 128 == (192 & l11) && 128 == (192 & c11) && (d11 = (15 & a11) << 12 | (63 & l11) << 6 | 63 & c11) > 2047 && (d11 < 55296 || d11 > 57343) && (i11 = d11);
          break;
        case 4:
          l11 = e15[o11 + 1], c11 = e15[o11 + 2], u11 = e15[o11 + 3], 128 == (192 & l11) && 128 == (192 & c11) && 128 == (192 & u11) && (d11 = (15 & a11) << 18 | (63 & l11) << 12 | (63 & c11) << 6 | 63 & u11) > 65535 && d11 < 1114112 && (i11 = d11);
      }
      null === i11 ? (i11 = 65533, s11 = 1) : i11 > 65535 && (i11 -= 65536, r11.push(i11 >>> 10 & 1023 | 55296), i11 = 56320 | 1023 & i11), r11.push(i11), o11 += s11;
    }
    return function(e16) {
      var t12 = e16.length;
      if (t12 <= E10) return String.fromCharCode.apply(String, e16);
      var n12 = "";
      var r12 = 0;
      for (; r12 < t12; ) n12 += String.fromCharCode.apply(String, e16.slice(r12, r12 += E10));
      return n12;
    }(r11);
  }
  e14.Buffer = i10, e14.SlowBuffer = function(e15) {
    +e15 != e15 && (e15 = 0);
    return i10.alloc(+e15);
  }, e14.INSPECT_MAX_BYTES = 50, i10.TYPED_ARRAY_SUPPORT = void 0 !== $.TYPED_ARRAY_SUPPORT ? $.TYPED_ARRAY_SUPPORT : function() {
    try {
      var e15 = new Uint8Array(1);
      return e15.__proto__ = { __proto__: Uint8Array.prototype, foo: function() {
        return 42;
      } }, 42 === e15.foo() && "function" == typeof e15.subarray && 0 === e15.subarray(1, 1).byteLength;
    } catch (e16) {
      return false;
    }
  }(), e14.kMaxLength = o10(), i10.poolSize = 8192, i10._augment = function(e15) {
    return e15.__proto__ = i10.prototype, e15;
  }, i10.from = function(e15, t11, n11) {
    return s10(null, e15, t11, n11);
  }, i10.TYPED_ARRAY_SUPPORT && (i10.prototype.__proto__ = Uint8Array.prototype, i10.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && i10[Symbol.species] === i10 && Object.defineProperty(i10, Symbol.species, { value: null, configurable: true })), i10.alloc = function(e15, t11, n11) {
    return function(e16, t12, n12, r11) {
      return l10(t12), t12 <= 0 ? a10(e16, t12) : void 0 !== n12 ? "string" == typeof r11 ? a10(e16, t12).fill(n12, r11) : a10(e16, t12).fill(n12) : a10(e16, t12);
    }(null, e15, t11, n11);
  }, i10.allocUnsafe = function(e15) {
    return c10(null, e15);
  }, i10.allocUnsafeSlow = function(e15) {
    return c10(null, e15);
  }, i10.isBuffer = function(e15) {
    return !(null == e15 || !e15._isBuffer);
  }, i10.compare = function(e15, t11) {
    if (!i10.isBuffer(e15) || !i10.isBuffer(t11)) throw new TypeError("Arguments must be Buffers");
    if (e15 === t11) return 0;
    var n11 = e15.length;
    var r11 = t11.length;
    for (var o11 = 0, a11 = Math.min(n11, r11); o11 < a11; ++o11) if (e15[o11] !== t11[o11]) {
      n11 = e15[o11], r11 = t11[o11];
      break;
    }
    return n11 < r11 ? -1 : r11 < n11 ? 1 : 0;
  }, i10.isEncoding = function(e15) {
    switch (String(e15).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return true;
      default:
        return false;
    }
  }, i10.concat = function(e15, t11) {
    if (!r10(e15)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (0 === e15.length) return i10.alloc(0);
    var n11;
    if (void 0 === t11) for (t11 = 0, n11 = 0; n11 < e15.length; ++n11) t11 += e15[n11].length;
    var o11 = i10.allocUnsafe(t11);
    var a11 = 0;
    for (n11 = 0; n11 < e15.length; ++n11) {
      var s11 = e15[n11];
      if (!i10.isBuffer(s11)) throw new TypeError('"list" argument must be an Array of Buffers');
      s11.copy(o11, a11), a11 += s11.length;
    }
    return o11;
  }, i10.byteLength = p10, i10.prototype._isBuffer = true, i10.prototype.swap16 = function() {
    var e15 = this.length;
    if (e15 % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (var t11 = 0; t11 < e15; t11 += 2) h10(this, t11, t11 + 1);
    return this;
  }, i10.prototype.swap32 = function() {
    var e15 = this.length;
    if (e15 % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (var t11 = 0; t11 < e15; t11 += 4) h10(this, t11, t11 + 3), h10(this, t11 + 1, t11 + 2);
    return this;
  }, i10.prototype.swap64 = function() {
    var e15 = this.length;
    if (e15 % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (var t11 = 0; t11 < e15; t11 += 8) h10(this, t11, t11 + 7), h10(this, t11 + 1, t11 + 6), h10(this, t11 + 2, t11 + 5), h10(this, t11 + 3, t11 + 4);
    return this;
  }, i10.prototype.toString = function() {
    var e15 = 0 | this.length;
    return 0 === e15 ? "" : 0 === arguments.length ? T10(this, 0, e15) : m10.apply(this, arguments);
  }, i10.prototype.equals = function(e15) {
    if (!i10.isBuffer(e15)) throw new TypeError("Argument must be a Buffer");
    return this === e15 || 0 === i10.compare(this, e15);
  }, i10.prototype.inspect = function() {
    var t11 = "";
    var n11 = e14.INSPECT_MAX_BYTES;
    return this.length > 0 && (t11 = this.toString("hex", 0, n11).match(/.{2}/g).join(" "), this.length > n11 && (t11 += " ... ")), "<Buffer " + t11 + ">";
  }, i10.prototype.compare = function(e15, t11, n11, r11, o11) {
    if (!i10.isBuffer(e15)) throw new TypeError("Argument must be a Buffer");
    if (void 0 === t11 && (t11 = 0), void 0 === n11 && (n11 = e15 ? e15.length : 0), void 0 === r11 && (r11 = 0), void 0 === o11 && (o11 = this.length), t11 < 0 || n11 > e15.length || r11 < 0 || o11 > this.length) throw new RangeError("out of range index");
    if (r11 >= o11 && t11 >= n11) return 0;
    if (r11 >= o11) return -1;
    if (t11 >= n11) return 1;
    if (this === e15) return 0;
    var a11 = (o11 >>>= 0) - (r11 >>>= 0);
    var s11 = (n11 >>>= 0) - (t11 >>>= 0);
    var l11 = Math.min(a11, s11);
    var c11 = this.slice(r11, o11);
    var u11 = e15.slice(t11, n11);
    for (var d11 = 0; d11 < l11; ++d11) if (c11[d11] !== u11[d11]) {
      a11 = c11[d11], s11 = u11[d11];
      break;
    }
    return a11 < s11 ? -1 : s11 < a11 ? 1 : 0;
  }, i10.prototype.includes = function(e15, t11, n11) {
    return -1 !== this.indexOf(e15, t11, n11);
  }, i10.prototype.indexOf = function(e15, t11, n11) {
    return f10(this, e15, t11, n11, true);
  }, i10.prototype.lastIndexOf = function(e15, t11, n11) {
    return f10(this, e15, t11, n11, false);
  }, i10.prototype.write = function(e15, t11, n11, r11) {
    if (void 0 === t11) r11 = "utf8", n11 = this.length, t11 = 0;
    else if (void 0 === n11 && "string" == typeof t11) r11 = t11, n11 = this.length, t11 = 0;
    else {
      if (!isFinite(t11)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
      t11 |= 0, isFinite(n11) ? (n11 |= 0, void 0 === r11 && (r11 = "utf8")) : (r11 = n11, n11 = void 0);
    }
    var o11 = this.length - t11;
    if ((void 0 === n11 || n11 > o11) && (n11 = o11), e15.length > 0 && (n11 < 0 || t11 < 0) || t11 > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    r11 || (r11 = "utf8");
    var a11 = false;
    for (; ; ) switch (r11) {
      case "hex":
        return y10(this, e15, t11, n11);
      case "utf8":
      case "utf-8":
        return v10(this, e15, t11, n11);
      case "ascii":
        return b10(this, e15, t11, n11);
      case "latin1":
      case "binary":
        return S10(this, e15, t11, n11);
      case "base64":
        return C10(this, e15, t11, n11);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return x10(this, e15, t11, n11);
      default:
        if (a11) throw new TypeError("Unknown encoding: " + r11);
        r11 = ("" + r11).toLowerCase(), a11 = true;
    }
  }, i10.prototype.toJSON = function() {
    return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
  };
  var E10 = 4096;
  function F10(e15, t11, n11) {
    var r11 = "";
    n11 = Math.min(e15.length, n11);
    for (var o11 = t11; o11 < n11; ++o11) r11 += String.fromCharCode(127 & e15[o11]);
    return r11;
  }
  function M10(e15, t11, n11) {
    var r11 = "";
    n11 = Math.min(e15.length, n11);
    for (var o11 = t11; o11 < n11; ++o11) r11 += String.fromCharCode(e15[o11]);
    return r11;
  }
  function k10(e15, t11, n11) {
    var r11 = e15.length;
    (!t11 || t11 < 0) && (t11 = 0), (!n11 || n11 < 0 || n11 > r11) && (n11 = r11);
    var o11 = "";
    for (var a11 = t11; a11 < n11; ++a11) o11 += A10(e15[a11]);
    return o11;
  }
  function P10(e15, t11, n11) {
    var r11 = e15.slice(t11, n11);
    var o11 = "";
    for (var a11 = 0; a11 < r11.length; a11 += 2) o11 += String.fromCharCode(r11[a11] + 256 * r11[a11 + 1]);
    return o11;
  }
  function N10(e15, t11, n11) {
    if (e15 % 1 != 0 || e15 < 0) throw new RangeError("offset is not uint");
    if (e15 + t11 > n11) throw new RangeError("Trying to access beyond buffer length");
  }
  function D10(e15, t11, n11, r11, o11, a11) {
    if (!i10.isBuffer(e15)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (t11 > o11 || t11 < a11) throw new RangeError('"value" argument is out of bounds');
    if (n11 + r11 > e15.length) throw new RangeError("Index out of range");
  }
  function L10(e15, t11, n11, r11) {
    t11 < 0 && (t11 = 65535 + t11 + 1);
    for (var o11 = 0, a11 = Math.min(e15.length - n11, 2); o11 < a11; ++o11) e15[n11 + o11] = (t11 & 255 << 8 * (r11 ? o11 : 1 - o11)) >>> 8 * (r11 ? o11 : 1 - o11);
  }
  function H10(e15, t11, n11, r11) {
    t11 < 0 && (t11 = 4294967295 + t11 + 1);
    for (var o11 = 0, a11 = Math.min(e15.length - n11, 4); o11 < a11; ++o11) e15[n11 + o11] = t11 >>> 8 * (r11 ? o11 : 3 - o11) & 255;
  }
  function I10(e15, t11, n11, r11, o11, a11) {
    if (n11 + r11 > e15.length) throw new RangeError("Index out of range");
    if (n11 < 0) throw new RangeError("Index out of range");
  }
  function _10(e15, t11, r11, o11, a11) {
    return a11 || I10(e15, 0, r11, 4), n10.write(e15, t11, r11, o11, 23, 4), r11 + 4;
  }
  function V10(e15, t11, r11, o11, a11) {
    return a11 || I10(e15, 0, r11, 8), n10.write(e15, t11, r11, o11, 52, 8), r11 + 8;
  }
  i10.prototype.slice = function(e15, t11) {
    var n11 = this.length;
    var r11;
    if ((e15 = ~~e15) < 0 ? (e15 += n11) < 0 && (e15 = 0) : e15 > n11 && (e15 = n11), (t11 = void 0 === t11 ? n11 : ~~t11) < 0 ? (t11 += n11) < 0 && (t11 = 0) : t11 > n11 && (t11 = n11), t11 < e15 && (t11 = e15), i10.TYPED_ARRAY_SUPPORT) (r11 = this.subarray(e15, t11)).__proto__ = i10.prototype;
    else {
      var o11 = t11 - e15;
      r11 = new i10(o11, void 0);
      for (var a11 = 0; a11 < o11; ++a11) r11[a11] = this[a11 + e15];
    }
    return r11;
  }, i10.prototype.readUIntLE = function(e15, t11, n11) {
    e15 |= 0, t11 |= 0, n11 || N10(e15, t11, this.length);
    var r11 = this[e15];
    var o11 = 1;
    var a11 = 0;
    for (; ++a11 < t11 && (o11 *= 256); ) r11 += this[e15 + a11] * o11;
    return r11;
  }, i10.prototype.readUIntBE = function(e15, t11, n11) {
    e15 |= 0, t11 |= 0, n11 || N10(e15, t11, this.length);
    var r11 = this[e15 + --t11];
    var o11 = 1;
    for (; t11 > 0 && (o11 *= 256); ) r11 += this[e15 + --t11] * o11;
    return r11;
  }, i10.prototype.readUInt8 = function(e15, t11) {
    return t11 || N10(e15, 1, this.length), this[e15];
  }, i10.prototype.readUInt16LE = function(e15, t11) {
    return t11 || N10(e15, 2, this.length), this[e15] | this[e15 + 1] << 8;
  }, i10.prototype.readUInt16BE = function(e15, t11) {
    return t11 || N10(e15, 2, this.length), this[e15] << 8 | this[e15 + 1];
  }, i10.prototype.readUInt32LE = function(e15, t11) {
    return t11 || N10(e15, 4, this.length), (this[e15] | this[e15 + 1] << 8 | this[e15 + 2] << 16) + 16777216 * this[e15 + 3];
  }, i10.prototype.readUInt32BE = function(e15, t11) {
    return t11 || N10(e15, 4, this.length), 16777216 * this[e15] + (this[e15 + 1] << 16 | this[e15 + 2] << 8 | this[e15 + 3]);
  }, i10.prototype.readIntLE = function(e15, t11, n11) {
    e15 |= 0, t11 |= 0, n11 || N10(e15, t11, this.length);
    var r11 = this[e15];
    var o11 = 1;
    var a11 = 0;
    for (; ++a11 < t11 && (o11 *= 256); ) r11 += this[e15 + a11] * o11;
    return r11 >= (o11 *= 128) && (r11 -= Math.pow(2, 8 * t11)), r11;
  }, i10.prototype.readIntBE = function(e15, t11, n11) {
    e15 |= 0, t11 |= 0, n11 || N10(e15, t11, this.length);
    var r11 = t11;
    var o11 = 1;
    var a11 = this[e15 + --r11];
    for (; r11 > 0 && (o11 *= 256); ) a11 += this[e15 + --r11] * o11;
    return a11 >= (o11 *= 128) && (a11 -= Math.pow(2, 8 * t11)), a11;
  }, i10.prototype.readInt8 = function(e15, t11) {
    return t11 || N10(e15, 1, this.length), 128 & this[e15] ? -1 * (255 - this[e15] + 1) : this[e15];
  }, i10.prototype.readInt16LE = function(e15, t11) {
    t11 || N10(e15, 2, this.length);
    var n11 = this[e15] | this[e15 + 1] << 8;
    return 32768 & n11 ? 4294901760 | n11 : n11;
  }, i10.prototype.readInt16BE = function(e15, t11) {
    t11 || N10(e15, 2, this.length);
    var n11 = this[e15 + 1] | this[e15] << 8;
    return 32768 & n11 ? 4294901760 | n11 : n11;
  }, i10.prototype.readInt32LE = function(e15, t11) {
    return t11 || N10(e15, 4, this.length), this[e15] | this[e15 + 1] << 8 | this[e15 + 2] << 16 | this[e15 + 3] << 24;
  }, i10.prototype.readInt32BE = function(e15, t11) {
    return t11 || N10(e15, 4, this.length), this[e15] << 24 | this[e15 + 1] << 16 | this[e15 + 2] << 8 | this[e15 + 3];
  }, i10.prototype.readFloatLE = function(e15, t11) {
    return t11 || N10(e15, 4, this.length), n10.read(this, e15, true, 23, 4);
  }, i10.prototype.readFloatBE = function(e15, t11) {
    return t11 || N10(e15, 4, this.length), n10.read(this, e15, false, 23, 4);
  }, i10.prototype.readDoubleLE = function(e15, t11) {
    return t11 || N10(e15, 8, this.length), n10.read(this, e15, true, 52, 8);
  }, i10.prototype.readDoubleBE = function(e15, t11) {
    return t11 || N10(e15, 8, this.length), n10.read(this, e15, false, 52, 8);
  }, i10.prototype.writeUIntLE = function(e15, t11, n11, r11) {
    (e15 = +e15, t11 |= 0, n11 |= 0, r11) || D10(this, e15, t11, n11, Math.pow(2, 8 * n11) - 1, 0);
    var o11 = 1;
    var a11 = 0;
    for (this[t11] = 255 & e15; ++a11 < n11 && (o11 *= 256); ) this[t11 + a11] = e15 / o11 & 255;
    return t11 + n11;
  }, i10.prototype.writeUIntBE = function(e15, t11, n11, r11) {
    (e15 = +e15, t11 |= 0, n11 |= 0, r11) || D10(this, e15, t11, n11, Math.pow(2, 8 * n11) - 1, 0);
    var o11 = n11 - 1;
    var a11 = 1;
    for (this[t11 + o11] = 255 & e15; --o11 >= 0 && (a11 *= 256); ) this[t11 + o11] = e15 / a11 & 255;
    return t11 + n11;
  }, i10.prototype.writeUInt8 = function(e15, t11, n11) {
    return e15 = +e15, t11 |= 0, n11 || D10(this, e15, t11, 1, 255, 0), i10.TYPED_ARRAY_SUPPORT || (e15 = Math.floor(e15)), this[t11] = 255 & e15, t11 + 1;
  }, i10.prototype.writeUInt16LE = function(e15, t11, n11) {
    return e15 = +e15, t11 |= 0, n11 || D10(this, e15, t11, 2, 65535, 0), i10.TYPED_ARRAY_SUPPORT ? (this[t11] = 255 & e15, this[t11 + 1] = e15 >>> 8) : L10(this, e15, t11, true), t11 + 2;
  }, i10.prototype.writeUInt16BE = function(e15, t11, n11) {
    return e15 = +e15, t11 |= 0, n11 || D10(this, e15, t11, 2, 65535, 0), i10.TYPED_ARRAY_SUPPORT ? (this[t11] = e15 >>> 8, this[t11 + 1] = 255 & e15) : L10(this, e15, t11, false), t11 + 2;
  }, i10.prototype.writeUInt32LE = function(e15, t11, n11) {
    return e15 = +e15, t11 |= 0, n11 || D10(this, e15, t11, 4, 4294967295, 0), i10.TYPED_ARRAY_SUPPORT ? (this[t11 + 3] = e15 >>> 24, this[t11 + 2] = e15 >>> 16, this[t11 + 1] = e15 >>> 8, this[t11] = 255 & e15) : H10(this, e15, t11, true), t11 + 4;
  }, i10.prototype.writeUInt32BE = function(e15, t11, n11) {
    return e15 = +e15, t11 |= 0, n11 || D10(this, e15, t11, 4, 4294967295, 0), i10.TYPED_ARRAY_SUPPORT ? (this[t11] = e15 >>> 24, this[t11 + 1] = e15 >>> 16, this[t11 + 2] = e15 >>> 8, this[t11 + 3] = 255 & e15) : H10(this, e15, t11, false), t11 + 4;
  }, i10.prototype.writeIntLE = function(e15, t11, n11, r11) {
    if (e15 = +e15, t11 |= 0, !r11) {
      var o11 = Math.pow(2, 8 * n11 - 1);
      D10(this, e15, t11, n11, o11 - 1, -o11);
    }
    var a11 = 0;
    var i11 = 1;
    var s11 = 0;
    for (this[t11] = 255 & e15; ++a11 < n11 && (i11 *= 256); ) e15 < 0 && 0 === s11 && 0 !== this[t11 + a11 - 1] && (s11 = 1), this[t11 + a11] = (e15 / i11 >> 0) - s11 & 255;
    return t11 + n11;
  }, i10.prototype.writeIntBE = function(e15, t11, n11, r11) {
    if (e15 = +e15, t11 |= 0, !r11) {
      var o11 = Math.pow(2, 8 * n11 - 1);
      D10(this, e15, t11, n11, o11 - 1, -o11);
    }
    var a11 = n11 - 1;
    var i11 = 1;
    var s11 = 0;
    for (this[t11 + a11] = 255 & e15; --a11 >= 0 && (i11 *= 256); ) e15 < 0 && 0 === s11 && 0 !== this[t11 + a11 + 1] && (s11 = 1), this[t11 + a11] = (e15 / i11 >> 0) - s11 & 255;
    return t11 + n11;
  }, i10.prototype.writeInt8 = function(e15, t11, n11) {
    return e15 = +e15, t11 |= 0, n11 || D10(this, e15, t11, 1, 127, -128), i10.TYPED_ARRAY_SUPPORT || (e15 = Math.floor(e15)), e15 < 0 && (e15 = 255 + e15 + 1), this[t11] = 255 & e15, t11 + 1;
  }, i10.prototype.writeInt16LE = function(e15, t11, n11) {
    return e15 = +e15, t11 |= 0, n11 || D10(this, e15, t11, 2, 32767, -32768), i10.TYPED_ARRAY_SUPPORT ? (this[t11] = 255 & e15, this[t11 + 1] = e15 >>> 8) : L10(this, e15, t11, true), t11 + 2;
  }, i10.prototype.writeInt16BE = function(e15, t11, n11) {
    return e15 = +e15, t11 |= 0, n11 || D10(this, e15, t11, 2, 32767, -32768), i10.TYPED_ARRAY_SUPPORT ? (this[t11] = e15 >>> 8, this[t11 + 1] = 255 & e15) : L10(this, e15, t11, false), t11 + 2;
  }, i10.prototype.writeInt32LE = function(e15, t11, n11) {
    return e15 = +e15, t11 |= 0, n11 || D10(this, e15, t11, 4, 2147483647, -2147483648), i10.TYPED_ARRAY_SUPPORT ? (this[t11] = 255 & e15, this[t11 + 1] = e15 >>> 8, this[t11 + 2] = e15 >>> 16, this[t11 + 3] = e15 >>> 24) : H10(this, e15, t11, true), t11 + 4;
  }, i10.prototype.writeInt32BE = function(e15, t11, n11) {
    return e15 = +e15, t11 |= 0, n11 || D10(this, e15, t11, 4, 2147483647, -2147483648), e15 < 0 && (e15 = 4294967295 + e15 + 1), i10.TYPED_ARRAY_SUPPORT ? (this[t11] = e15 >>> 24, this[t11 + 1] = e15 >>> 16, this[t11 + 2] = e15 >>> 8, this[t11 + 3] = 255 & e15) : H10(this, e15, t11, false), t11 + 4;
  }, i10.prototype.writeFloatLE = function(e15, t11, n11) {
    return _10(this, e15, t11, true, n11);
  }, i10.prototype.writeFloatBE = function(e15, t11, n11) {
    return _10(this, e15, t11, false, n11);
  }, i10.prototype.writeDoubleLE = function(e15, t11, n11) {
    return V10(this, e15, t11, true, n11);
  }, i10.prototype.writeDoubleBE = function(e15, t11, n11) {
    return V10(this, e15, t11, false, n11);
  }, i10.prototype.copy = function(e15, t11, n11, r11) {
    if (n11 || (n11 = 0), r11 || 0 === r11 || (r11 = this.length), t11 >= e15.length && (t11 = e15.length), t11 || (t11 = 0), r11 > 0 && r11 < n11 && (r11 = n11), r11 === n11) return 0;
    if (0 === e15.length || 0 === this.length) return 0;
    if (t11 < 0) throw new RangeError("targetStart out of bounds");
    if (n11 < 0 || n11 >= this.length) throw new RangeError("sourceStart out of bounds");
    if (r11 < 0) throw new RangeError("sourceEnd out of bounds");
    r11 > this.length && (r11 = this.length), e15.length - t11 < r11 - n11 && (r11 = e15.length - t11 + n11);
    var o11 = r11 - n11;
    var a11;
    if (this === e15 && n11 < t11 && t11 < r11) for (a11 = o11 - 1; a11 >= 0; --a11) e15[a11 + t11] = this[a11 + n11];
    else if (o11 < 1e3 || !i10.TYPED_ARRAY_SUPPORT) for (a11 = 0; a11 < o11; ++a11) e15[a11 + t11] = this[a11 + n11];
    else Uint8Array.prototype.set.call(e15, this.subarray(n11, n11 + o11), t11);
    return o11;
  }, i10.prototype.fill = function(e15, t11, n11, r11) {
    if ("string" == typeof e15) {
      if ("string" == typeof t11 ? (r11 = t11, t11 = 0, n11 = this.length) : "string" == typeof n11 && (r11 = n11, n11 = this.length), 1 === e15.length) {
        var o11 = e15.charCodeAt(0);
        o11 < 256 && (e15 = o11);
      }
      if (void 0 !== r11 && "string" != typeof r11) throw new TypeError("encoding must be a string");
      if ("string" == typeof r11 && !i10.isEncoding(r11)) throw new TypeError("Unknown encoding: " + r11);
    } else "number" == typeof e15 && (e15 &= 255);
    if (t11 < 0 || this.length < t11 || this.length < n11) throw new RangeError("Out of range index");
    if (n11 <= t11) return this;
    var a11;
    if (t11 >>>= 0, n11 = void 0 === n11 ? this.length : n11 >>> 0, e15 || (e15 = 0), "number" == typeof e15) for (a11 = t11; a11 < n11; ++a11) this[a11] = e15;
    else {
      var s11 = i10.isBuffer(e15) ? e15 : O10(new i10(e15, r11).toString());
      var l11 = s11.length;
      for (a11 = 0; a11 < n11 - t11; ++a11) this[a11 + t11] = s11[a11 % l11];
    }
    return this;
  };
  var R10 = /[^+\/0-9A-Za-z-_]/g;
  function A10(e15) {
    return e15 < 16 ? "0" + e15.toString(16) : e15.toString(16);
  }
  function O10(e15, t11) {
    var n11;
    t11 = t11 || 1 / 0;
    var r11 = e15.length;
    var o11 = null;
    var a11 = [];
    for (var i11 = 0; i11 < r11; ++i11) {
      if ((n11 = e15.charCodeAt(i11)) > 55295 && n11 < 57344) {
        if (!o11) {
          if (n11 > 56319) {
            (t11 -= 3) > -1 && a11.push(239, 191, 189);
            continue;
          }
          if (i11 + 1 === r11) {
            (t11 -= 3) > -1 && a11.push(239, 191, 189);
            continue;
          }
          o11 = n11;
          continue;
        }
        if (n11 < 56320) {
          (t11 -= 3) > -1 && a11.push(239, 191, 189), o11 = n11;
          continue;
        }
        n11 = 65536 + (o11 - 55296 << 10 | n11 - 56320);
      } else o11 && (t11 -= 3) > -1 && a11.push(239, 191, 189);
      if (o11 = null, n11 < 128) {
        if ((t11 -= 1) < 0) break;
        a11.push(n11);
      } else if (n11 < 2048) {
        if ((t11 -= 2) < 0) break;
        a11.push(n11 >> 6 | 192, 63 & n11 | 128);
      } else if (n11 < 65536) {
        if ((t11 -= 3) < 0) break;
        a11.push(n11 >> 12 | 224, n11 >> 6 & 63 | 128, 63 & n11 | 128);
      } else {
        if (!(n11 < 1114112)) throw new Error("Invalid code point");
        if ((t11 -= 4) < 0) break;
        a11.push(n11 >> 18 | 240, n11 >> 12 & 63 | 128, n11 >> 6 & 63 | 128, 63 & n11 | 128);
      }
    }
    return a11;
  }
  function B10(e15) {
    return t10.toByteArray(function(e16) {
      if ((e16 = function(e17) {
        return e17.trim ? e17.trim() : e17.replace(/^\s+|\s+$/g, "");
      }(e16).replace(R10, "")).length < 2) return "";
      for (; e16.length % 4 != 0; ) e16 += "=";
      return e16;
    }(e15));
  }
  function z10(e15, t11, n11, r11) {
    for (var o11 = 0; o11 < r11 && !(o11 + n11 >= t11.length || o11 >= e15.length); ++o11) t11[o11 + n11] = e15[o11];
    return o11;
  }
}(Fjt);
const _lbm_l7={"en":{"0":{"bn":"UHmk[X6{[TCPc4RhSn:2cnRvDmmweTCv[XWlJHFhenGtbXRhcHmk[X6{[TCs[YlheH9hdoWvJFGkeHm3[WKmdH:zeIOLVxqV[X2xc4Kidolhb3W6dzCidnVhZY[ibXyiZnymJH[wdjCmenGteXG1bX:vMhqK[jC6c4VhdIWzZ3iid3WlJHFhcHmk[X6{[TxheHimJHumfTCqdzCqcjC6c4WzJIC2dnOpZYOmJHOwcn[qdn2ieHmwcjCmcXGqcD5LSX2ibXxheYNvd3Gt[YOBcXW{Z3m2dz6kc31h[n:zJHG{d3m{eHGvZ3Vv","bg":"UHmk[X6{[TCPc4RhSn:2cnR>"},"1":{"bn":"SY[icIWieHmwcjCX[YK{bX:vDmCwe3Wz[XRhZolhRXO1bY[mVnWxc4K1d1qU","bg":"SY[icIWieHmwcjCmcnS{JHmvJIulZYm{gTClZYlpdzl>","bgn":"SY[icIWieHmwcjC3[YK{bX:v"},"3":{"bn":"SY[icIWieHmwcjCX[YK{bX:vDmCwe3Wz[XRhZolhRXO1bY[mVnWxc4K1d1qU","bg":"WIKqZXxh[YixbYKm[B>>"},"4":{"bn":"TX63ZXyq[DCtbXOmcoOmJHumfT5LSH:2ZnymJHOp[XOsJISp[TCtbXOmcoOmJHumfTCqcjC6c4WzJICzc3qmZ4RhZX6lJHGl[DCiJI[icHmlJHyqZ3Wvd3VvDlmnJImweTCv[XWlJHG{d3m{eHGvZ3VtJICt[XG{[TCkc361ZXO1JIW{MoOicHW{RH2md3OqeYNvZ3:uMh>>","bg":"TX63ZXyq[DCNbXOmcoOmJFumfR>>"}},"ko":{"0":{"bn":"76398K318JTh8Jrl77X9JPzxwvzeiDEtjKhh8KfH8Jr275vJ75vlMjBLRXO1bY[mVnWxc4K1d1qU77X9JPzMqP3Xjf3WnPvhqPvquDEtoLEunrkum[xh76398K318JTh8Jrl7sDBJP3WiPzbmP3WrfvMjPvMqD5hDvvtvPzenDEthr{umb4toZBhd3Gt[YNub3:zRH2md3OqeYNvZ3:uJPvZlPvLmDByOkdxMUB2PEQtoM{sp[xh77z58K3ZJPvxmPvfkfvMjPvMqD5>","bg":"76398K318JTh8Jrl77X9JPzxwvzeiDEtjKhh8KfH8K3N"},"1":{"bn":"RXO1bY[mVnWxc4K1d1qUJP3QjfrxhP3NlB>>","bg":"8Z,K7sDB7sDBJIulZYm{gfzewDEun5Utm6Bh8LLG77PN76Dq75vJ75vlMh>>","bgn":"8Z,K7sDB8ZzR"},"3":{"bn":"RXO1bY[mVnWxc4K1d1qUJP3QjfrxhP3NlB>>","bg":"8Z,K7sDB8ZzR8K31JPvokPvkkPvRrB>>"},"4":{"bn":"76398K318JTh8Jrl7sDBJPzdpP3brP3WnPzohDEtmZstjsYsj5ksj7RvJBssoc{tocUtiLEtjrUuhrUsqcxh8[nW8K358[X1JPzkwPzMoPr5tDEstKUsop4sj5ksj7RvJBsssMkto[hh8JLt8[Xu8K3BJIOicHW{MXuwdlCu[YOkbYW{MnOwcTEsnKEsjqRhNUZ4ND1xOUh{8Kz977HdJPvtvPzenDEstKUsop4sj5ksj7Rv","bg":"8K7Z77r876DdJPvewPzeuPzFpPzLqDEuhrR>"}},"ja":{"0":{"bn":"55Pq55Ll55L855P{55L655Lu55P955HN7LbM55Hl55HM55LL55H,55Hc55LU55DDDlGkeHm3[WKmdH:zeIOLV,PEi,PDuvPDqPPEjvPDlvT:w,fVrPPCnfPDj,PCr,PCs,PBhfbdjfXLvfPCrvPErfPDqPPDv,PEt,PDvfPDlvjpsfXvnvPCm,PCqvPCk,PCpPPCmfPCiPPBhh>>","bg":"55Pq55Ll55L855P{55L655Lu55P955HN7LbM55Hl55HM55LL55H,55Hc55LU"},"1":{"bn":"55Pi55L455Ln55L66rDr6czQ6Mzb67T,JFGkeHm3[WKmdH:zeIOLV,PEi,PDuvPDqPPEjh>>","bg":"55PJ55Pq55Ll55Lj55Ps6qzg7[nRJPbvj,PDjoulZYm{gfbYqR>>","bgn":"55PJ55Pq55Ll55Lj55Ps65nJ"},"3":{"bn":"55Pi55L455Ln55L66rDr6czQ6Mzb67T,JFGkeHm3[WKmdH:zeIOLV,PEi,PDuvPDqPPEjh>>","bg":"55PJ55Pq55Ll55Lj55Ps6qzg7[nR6ZjI55LN"},"4":{"bn":"65Ti6Zr655Hr55Pq55Ll55L855P{55L655Lu55P955Ho55H[55DDDvPErfPDqPPDv,PEt,PDvfPDsfPEwPPDlvXHkffjvvjrkfPCm,PBhfbdjfXLvfPCrvPErfPDqPPDv,PEt,PDvfPDlvjpsfXvnvPCm,PCqvPCk,PCpPPCmfPCiPPBhh>>","bg":"65Ti6Zr655Hr55Pq55Ll55L855P{55L655Lu55P9"}},"fr":{"0":{"bn":"UHmk[X6k[TCvc35heIKweYcErXVvDm[weYNhZY[mfjCj[YOwbX5h[De2cnVhZ3{ErTCl[TCtbXOmcnOmJI[icHml[TCxc4WzJHW5x7mkeYSmdjCCZ4SqenWT[YCwdoS{TmNLSHW{JHOtx7m{JISmcYCwdnGqdnW{JIOwcoRh[Hm{dH:vbXKt[YNhdH:2djEErY[icIWieHmwcj5LTYOqJI[weYNhZY[mfjCiZ3imeNPqJIWv[TCtbXOmcnOmMDCtZTCkcNPqJIOmJISzc4W3[TClZX6{JI[weIKmJHVucXGqcDCl[TCkc36nbYKuZYSqc35h[DeiZ3iieD5LSXOzbY[mfj2vc4W{MoOicHW{RH2md3OqeYNvZ3:uJICweYJheX6mJHG{d3m{eHGvZ3Vv","bg":"UHmk[X6k[TCvc35heIKweYcErXV>"},"1":{"bn":"WnWzd3mwcjClK9PqenGteXG1bX:vDmCidjCCZ4SqenWT[YCwdoS{TmN>","bg":"UDgErY[icIWieHmwcjC{[TC1[YKubX6mJHSicoNhf3SifYO:JHqweYJpdzl>","bgn":"WnWzd3mwcjClK9PqenGteXG1bX:v"},"3":{"bn":"WnWzd3mwcjClK9PqenGteXG1bX:vDmCidjCjfTCCZ4SqenWT[YCwdoS{TmN>","bg":"SNPqcX:vd4SzZYSqc35h[YixbYMErXV>"},"4":{"bn":"R3ym[jCl[TCtbXOmcnOmJHmvenGtbXSmMhqXx7mzbX[q[YphcHFhZ3{ErTCl[TCtbXOmcnOmJHSicoNhen:1dnVhdIKwbnW1JHW1JHGrc4W1[YpheX6mJHyqZ3WvZ3VhenGtbXSmMhqUbTC3c4W{JHG3[YphZnW{c3mvJHRoZYO{bYO1ZX6k[TxhdzeqcDC3c4W{JICtZXm1JHOwcoSiZ4SmfjCvc4W{MoOicHW{RH2md3OqeYNvZ3:uMh>>","bg":"R3ym[jCl[TCtbXOmcnOmJHmvenGtbXSm"}}};
const Ajt = (e14 = "") => {
  var t10;
  return null !== (t10 = _lbm_l7[e14.trim().substring(0, 2)]) && void 0 !== t10 ? t10 : _lbm_l7.en;
};
const Ojt = (e14, t10, n10) => [1 === e14 && void 0 === n10 ? Ajt(t10)[1].bgn : Ajt(t10)[e14].bg].map((e15) => Fjt.Buffer.from(Array.from(e15).map((e16) => e16.charCodeAt(0) - 1).map((e16) => String.fromCharCode(e16)).join(""), `base${Math.sqrt(4096)}`).toString().replace("{days}", `${n10}`))[0];
const Bjt = (e14, t10) => Fjt.Buffer.from(Array.from(Ajt(e14)[t10].bn).map((e15) => e15.charCodeAt(0) - 1).map((e15) => String.fromCharCode(e15)).join(""), `base${Math.sqrt(4096)}`).toString();
const zjt = { 1: (e14) => Bjt(e14, 1), 4: (e14) => Bjt(e14, 4), 3: (e14) => Bjt(e14, 3), 0: (e14) => Bjt(e14, 0) };
const $jt = { 1: (e14, t10) => Ojt(1, e14, t10.Left), 4: (e14) => Ojt(4, e14), 3: (e14) => Ojt(3, e14), 0: (e14) => Ojt(0, e14) };
const Wjt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e14) {
  return typeof e14;
} : function(e14) {
  return e14 && "function" == typeof Symbol && e14.constructor === Symbol && e14 !== Symbol.prototype ? "symbol" : typeof e14;
};
const jjt = "undefined" != typeof window;
const Zjt = String.fromCharCode;
const Gjt = jjt && window.Uint8Array || function(e14) {
  let t10;
  if ("number" == typeof e14) {
    t10 = new Array(e14);
    for (let n10 = 0; n10 < e14; ++n10) t10[n10] = 0;
  } else t10 = e14.slice(0);
  t10.buffer = t10, t10.byteLength = t10.length, "object" === (void 0 === e14 ? "undefined" : Wjt(e14)) && e14.buffer && (t10.buffer = e14.buffer);
  return t10;
};
const Ujt = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
const qjt = "object" === ("undefined" == typeof global ? "undefined" : Wjt(global)) && global && global.Object === Object && global;
const Yjt = "object" === ("undefined" == typeof self ? "undefined" : Wjt(self)) && self && self.Object === Object && self;
const Kjt = qjt || Yjt || Function("return this")();
function Xjt(e14, t10, n10, r10) {
  return 1 === e14.length || e14.splice(n10, 1, r10(e14.splice(t10, 1, r10(e14[n10]))[0])), e14;
}
function Jjt(e14) {
  const t10 = e14.split("");
  const n10 = function(e15) {
    return function(e16) {
      const t11 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
      const n11 = e16.charCodeAt(0);
      return n11 >= 65 && n11 <= 90 ? e16.toLowerCase() : n11 >= 97 && n11 <= 122 ? e16.toUpperCase() : n11 >= 48 && n11 <= 57 ? Zjt(48 + (n11 - 48 + 10 + t11) % 10) : e16;
    }(e15, -1);
  };
  for (let e15 = t10.length - 5; e15 >= 0; e15--) Xjt(t10, e15 + 1, e15 + 3, n10), Xjt(t10, e15, e15 + 2, n10);
  return t10.join("");
}
function Qjt(e14) {
  let t10;
  let n10;
  let r10;
  let o10;
  let a10;
  let i10;
  let s10;
  let l10;
  const c10 = [];
  let u10 = "";
  let d10;
  let p10;
  let m10;
  const h10 = Ujt;
  if (p10 = e14, d10 = p10.length % 3, d10 > 0) for (; d10++ < 3; ) u10 += "=", p10 += "\0";
  for (d10 = 0; d10 < p10.length; d10 += 3) t10 = p10.charCodeAt(d10), n10 = p10.charCodeAt(d10 + 1), r10 = p10.charCodeAt(d10 + 2), o10 = t10 << 16 | n10 << 8 | r10, a10 = o10 >> 18 & 63, i10 = o10 >> 12 & 63, s10 = o10 >> 6 & 63, l10 = 63 & o10, c10[d10 / 3] = h10.charAt(a10) + h10.charAt(i10) + h10.charAt(s10) + h10.charAt(l10);
  return m10 = c10.join(""), m10 = m10.slice(0, m10.length - u10.length) + u10, m10;
}
function eZt(e14) {
  let t10;
  let n10;
  let r10;
  let o10;
  let a10;
  let i10;
  let s10;
  let l10;
  const c10 = [];
  let u10;
  let d10;
  const p10 = Ujt;
  d10 = e14;
  for (let e15 = 0; e15 < d10.length; e15 += 4) o10 = p10.indexOf(d10.charAt(e15)), a10 = p10.indexOf(d10.charAt(e15 + 1)), i10 = p10.indexOf(d10.charAt(e15 + 2)), s10 = p10.indexOf(d10.charAt(e15 + 3)), l10 = o10 << 18 | a10 << 12 | i10 << 6 | s10, t10 = l10 >>> 16 & 255, n10 = l10 >>> 8 & 255, r10 = 255 & l10, c10[e15 / 4] = Zjt(t10, n10, r10), 64 === s10 && (c10[e15 / 4] = Zjt(t10, n10)), 64 === i10 && (c10[e15 / 4] = Zjt(t10));
  return u10 = c10.join(""), u10;
}
function tZt(e14) {
  return (jjt && window.atob || eZt)(e14);
}
function nZt(e14) {
  return (jjt && window.btoa || Qjt)(e14);
}
function rZt(e14) {
  if (!e14) return "";
  let t10 = Jjt(e14);
  t10 = t10.split("").reverse().join("");
  const n10 = Math.ceil(t10.length / 2);
  return t10 = t10.substr(n10) + t10.substr(0, n10), t10 = t10.replace("#", "="), t10 = t10.replace("&", "=="), function(e15) {
    return decodeURIComponent(Array.prototype.map.call(tZt(e15), (e16) => `%${`00${e16.charCodeAt(0).toString(16)}`.slice(-2)}`).join(""));
  }(t10);
}
function oZt(e14) {
  const t10 = tZt(e14);
  const n10 = t10.length;
  const r10 = new Gjt(n10);
  for (let e15 = 0; e15 < n10; e15++) r10[e15] = t10.charCodeAt(e15);
  return r10.buffer;
}
function aZt(e14) {
  const t10 = new ArrayBuffer(e14.length);
  const n10 = new Gjt(t10);
  for (let t11 = 0, r10 = e14.length; t11 < r10; t11++) n10[t11] = e14.charCodeAt(t11);
  return t10;
}
function iZt(e14) {
  return "oncomplete" in e14 && (e14.then = function(t10, n10) {
    e14.resolve = t10, e14.reject = n10;
  }, e14.oncomplete = function(t10) {
    e14.resolve(e14.result);
  }, e14.onerror = function() {
    e14.reject();
  }), e14;
}
function sZt(e14, t10, n10, r10) {
  const o10 = jjt ? window.msCrypto ? window.msCrypto : window.crypto : void 0;
  const a10 = function(e15, t11) {
    try {
      t11 = `#${t11}`;
      const n11 = e15.indexOf(t11);
      if (n11 > -1) return { prefix: e15.substring(0, n11), licData: JSON.parse(rZt(e15.substr(n11 + t11.length))) };
    } catch (e16) {
    }
    return false;
  }(e14, t10.aC);
  if (!a10) return r10();
  const { licData: i10 } = a10;
  const s10 = `${a10.prefix}#${t10.aC}`;
  const l10 = (c10 = oZt((u10 = s10 + JSON.stringify(i10.D), nZt(encodeURIComponent(u10).replace(/%([0-9A-F]{2})/g, (e15, t11) => Zjt(parseInt(t11, 16)))))), Zjt.apply(null, new Gjt(c10)));
  var c10;
  var u10;
  function d10() {
    return function(e15) {
      let t11 = 0;
      let n11 = 5381;
      let r11 = 0;
      for (let o12 = e15.length - 1; o12 >= 0; o12--) {
        const a11 = e15.charCodeAt(o12);
        t11 = a11 + (t11 << 6) + (t11 << 16) - t11, n11 = a11 + ((n11 << 5) + n11), r11 = a11 + ((r11 << 5) - r11), r11 &= r11;
      }
      let o11 = t11 ^ n11 ^ r11;
      return o11 < 0 && (o11 = ~o11), o11.toString(16).toUpperCase();
    }(s10 + JSON.stringify(i10.D)) === i10.H ? n10(i10.D) : r10();
  }
  const p10 = rZt("JYx3Gb#8Pb5R");
  const m10 = rZt("VdgJHc#wJb59");
  if (Kjt[p10] && Kjt[p10][m10] && !location.protocol.match(/^https/i)) return d10();
  if (!o10 || !o10.subtle) return d10();
  {
    let e15 = { alg: "PS256", e: "AQAB", kty: "RSA", n: (h10 = t10.pK, h10.replace(/\+/g, "-").replace(/\//g, "_").replace(/\=+$/, "")) };
    e15 = window.msCrypto ? aZt(JSON.stringify(e15)) : e15;
    const a11 = { name: "RSA-PSS", saltLength: 32, hash: { name: "SHA-256" } };
    iZt(o10.subtle.importKey("jwk", e15, a11, false, ["verify"])).then((e16) => {
      iZt(o10.subtle.verify(a11, e16, oZt(i10.S), aZt(l10))).then((e17) => e17 ? n10(i10.D) : r10());
    }, () => d10());
  }
  var h10;
}
function lZt() {
  if (!window) return false;
  const { hostname: e14, protocol: t10 } = window.location;
  return !!["file:", "vscode-webview:"].includes(t10) || uZt(e14, ["127.0.0.1", "[::1]", "localhost"]);
}
function cZt(e14) {
  return y(this, void 0, void 0, function* () {
    return e14 ? function(e15) {
      return y(this, void 0, void 0, function* () {
        return new Promise((t10, n10) => {
          sZt(e15, { pK: "l6/zrbWoSbcLFwEetFh38rH3ErBZE9H+Cqix3R+wTlfA1wD5B+lUcCQn+EJ60I4RGrm0x1sFjkiLWwB0jAn6BWZv0W4WbqAKriOdeoivxDp1Wmjs3qkEDhvbsjPtfvwx2BHil6o+/tDrdMJQSGs18WZm2PoQLQuL+9VhZ4FNRHUQU3Jtioke/OZEGHJOdYVwvCGalzBad6QFOiVbDBQPePpS3++GJzOxN8SN/7lyS5/IdKiy3WJRaVGkB370+HbN6hKraDfUgReLX26yxRaKC/5aWnGAJ2NnWLoGyAGRcwT9dVjo4bcAZNrrA0U9JVKQxaSskhdv2p49XzJkltXx5w==", aC: "B1" }, (e16) => {
            if (!e16.Prd || !e16.Prd.some((e17) => "NKLV" === e17.C)) return t10({ Type: 4 });
            const n11 = e16.Dms;
            if (null != n11) {
              const e17 = window.location.hostname;
              if (!lZt() && !uZt(e17, n11.split(","))) return t10({ Type: 4 });
            }
            const r10 = function(e17) {
              if (null == e17) return;
              const t11 = new Date(parseInt(e17.substr(0, 4), 10) || 0, parseInt(e17.substr(4, 2), 10) - 1 || 0, parseInt(e17.substr(6, 2), 10) || 0);
              const n12 = /* @__PURE__ */ new Date();
              return Math.ceil((+t11 - +n12) / 864e5);
            }(e16.Exp);
            return void 0 !== r10 && r10 <= 0 ? t10({ Type: 3 }) : void 0 !== r10 && Number.isNaN(r10) ? t10({ Type: 4 }) : e16.Evl ? t10({ Type: 1, Left: r10 }) : t10({ Type: 2 });
          }, () => t10({ Type: 4 }));
        });
      });
    }(e14) : lZt() ? { Type: 1 } : { Type: 0 };
  });
}
function uZt(e14, t10) {
  let n10;
  const r10 = t10.length;
  let o10;
  let a10 = false;
  for (n10 = 0; n10 < r10; n10++) {
    if (o10 = t10[n10], o10 && 0 === o10.lastIndexOf("*.", 0) && (a10 = true), o10 = a10 ? o10.slice(2) : o10, o10 === e14) return true;
    if (a10) {
      const t11 = e14.indexOf(`.${o10}`);
      if (t11 > 0 && t11 === e14.length - o10.length - 1) return true;
    }
  }
  return false;
}
function dZt(e14) {
  return "override" === e14 || "throw" === e14 ? e14 : "ask";
}
class pZt {
  static create(e14, t10 = {}, n10) {
    return y(this, void 0, void 0, function* () {
      const r10 = "arjs-designer-" + pZt.instanceCount++;
      const a10 = Ejt(e14, r10, t10, n10);
      const i10 = cZt(o());
      const [s10, l10] = yield Promise.all([i10, a10]);
      return new pZt(r10, l10, s10);
    });
  }
  constructor(e14, t10, n10) {
    var r10;
    this.instanceId = e14, this.middlewareApi = t10, this._lb = null, 2 !== n10.Type && (!function(e15, t11) {
      const n11 = document.createElement("div");
      n11.className = "eval-text", n11.innerText = zjt[e15.Type](t11);
      const r11 = document.getElementsByClassName("ar-view")[0];
      r11 && r11.appendChild(n11);
    }(n10, VRt.language), this._lb = function(e15, t11) {
      return { type: "button", badge: { content: $jt[e15.Type](t11, e15), level: 1 === e15.Type ? "warning" : "error", position: "inline", rounded: true, customCSS: "gc-app-license-badge" }, customCSS: "gc-app-window-button" };
    }(n10, VRt.language), this.middlewareApi.app.setControlItems([this._lb])), this._licenseState = { isRestricted: 1 !== n10.Type && 2 !== n10.Type, message: null === (r10 = $jt[n10.Type]) || void 0 === r10 ? void 0 : r10.call($jt, VRt.language, n10) };
  }
  get notifications() {
    return this.middlewareApi.notifications;
  }
  createReport(e14, t10 = "ask") {
    return y(this, void 0, void 0, function* () {
      if ("throw" === t10 && this.middlewareApi.documents.hasUnsavedChanges()) throw new Error(VRt.t("error.hasUnsavedChanges", "Unable to load report. Designer has unsaved changes in the report."));
      const n10 = { whenDirty: dZt(t10), type: e14.reportType };
      yield this.middlewareApi.documents.createNew(n10);
    });
  }
  setReport(e14, t10 = "ask", n10 = false) {
    return y(this, void 0, void 0, function* () {
      if (this._licenseState.isRestricted) return void this.notifications.send("error", VRt.t("error.unableSetReport", "Unable to set a report: {{message}}", { message: this._licenseState.message }));
      if ("throw" === t10 && this.middlewareApi.documents.hasUnsavedChanges()) throw new Error(VRt.t("error.hasUnsavedChanges", "Unable to load report. Designer has unsaved changes in the report."));
      const r10 = { report: e14, whenDirty: dZt(t10), isDirtyInitial: n10 };
      yield this.middlewareApi.documents.load(r10);
    });
  }
  getReport() {
    var e14;
    if (this._licenseState.isRestricted) throw new Error(VRt.t("error.unableGetReport", "Unable to get a report: {{message}}", { message: this._licenseState.message }));
    const t10 = this.middlewareApi.store.getState();
    if (!t10) throw new Error("Unknown error");
    const n10 = Uzt(t10).present;
    if (!n10.content) throw new Error(VRt.t("error.noReportOpened", "No report currently opened"));
    const { serializeDocument: r10 } = kit.of(this.instanceId);
    const o10 = r10({ documentType: "rdlx", documentContent: n10.content });
    if (!o10) throw new Error(VRt.t("error.errorSerializingReport", "Internal error: cannot serialize report"));
    return { isDirty: t10.core.hasUnsavedChanges, displayName: t10.core.documentName || "Untitled", id: null !== (e14 = t10.app.documentId) && void 0 !== e14 ? e14 : null, definition: o10 };
  }
  setActionHandlers(e14) {
    this.middlewareApi.settings.actionHandlers = this._licenseState.isRestricted ? {} : function(e15) {
      const t10 = {};
      const { onSave: n10, onSaveAs: r10, onCreate: o10, onOpen: a10, onOpenFileMenu: i10, onRender: s10 } = e15;
      if (n10) {
        const e16 = BRt(n10);
        t10.onSave = ({ id: t11, displayName: n11, definition: r11 }) => e16({ id: t11, displayName: n11, definition: r11 }).then((e17) => {
          if (e17) return ORt(e17, "SaveResult"), { displayName: e17.displayName };
        });
      }
      if (r10) {
        const e16 = BRt(r10);
        t10.onSaveAs = ({ id: t11, displayName: n11, definition: r11 }) => e16({ id: t11, displayName: n11, definition: r11 }).then((e17) => {
          if (e17) return ORt(e17, "SaveAsResult"), { id: e17.id, displayName: e17.displayName };
        });
      }
      if (o10) {
        const e16 = BRt(o10);
        t10.onCreate = () => e16().then((e17) => {
          if (e17) return ORt(e17, "NewReport"), e17;
        });
      }
      if (a10) {
        const e16 = BRt(a10);
        t10.onOpen = () => e16().then((e17) => {
          if (e17) return ORt(e17, "Report"), e17;
        });
      }
      return t10.onRender = s10 ? BRt(s10) : void 0, t10.onOpenFileMenu = i10, t10;
    }(e14);
  }
  setResourceProvider(e14) {
    this.middlewareApi.settings.resourceProvider = w$t(this.instanceId, e14), this.middlewareApi.store.dispatch(wAt());
  }
  processCommand(e14) {
    return y(this, void 0, void 0, function* () {
      if (this._licenseState.isRestricted) return void this.notifications.send("error", VRt.t("error.unablePerformAction", "Unable to perform the action: {{message}}", { message: this._licenseState.message }));
      const t10 = this.middlewareApi.documents;
      switch (e14) {
        case "create":
          return void (yield t10.create());
        case "open":
          return void (yield t10.open());
        case "save":
          return void (yield t10.save());
        case "saveAs":
          return void (yield t10.saveAs());
        case "render":
          return void t10.preview();
        default:
          throw new Error(`Invalid designer command: ${e14}`);
      }
    });
  }
  setDataSourceTemplates(e14) {
    this.middlewareApi.store.dispatch(JBt(e14));
  }
  setControlItems(e14) {
    this.middlewareApi.app.setControlItems([this._lb, ...e14]);
  }
  focus() {
    return this.middlewareApi.app.focus();
  }
  get editor() {
    return this.middlewareApi.app.editor;
  }
  get panels() {
    return this.middlewareApi.app.panels;
  }
  getReportPartsLibraries() {
    var e14, t10;
    return (null !== (t10 = null === (e14 = this.middlewareApi.settings.rdlx.reportParts) || void 0 === e14 ? void 0 : e14.libraries) && void 0 !== t10 ? t10 : []).map((e15) => ({ displayName: e15.displayName, name: e15.name, id: e15.path }));
  }
  setReportPartsLibraries(e14) {
    const t10 = e14.map((e15) => ({ displayName: e15.displayName, name: e15.name, path: e15.id })).filter((e15, t11, n10) => n10.findIndex((t12) => t12.path === e15.path) === t11);
    this.middlewareApi.settings.rdlx.reportParts = { enabled: true, libraries: t10 }, this.middlewareApi.store.dispatch(lWe.setAvailableLibraries(t10));
  }
}
pZt.instanceCount = 0;
const mZt = Ert.literal("ask", "override", "throw");
const hZt = Ert.typeReq({ reportType: Ert.literal("CPL", "FPL", "Pageless") }, ["reportType"]);
function fZt(e14, t10, n10) {
  const r10 = e14.decode(t10);
  if ("error" === r10.type) throw new Error(n10(r10.reason));
  return r10.value;
}
class gZt {
  constructor() {
    this._eventHandlers = {}, this._trigger = (e14) => {
      for (const t10 of Object.values(this._eventHandlers)) t10(e14);
    };
  }
  static createFor() {
    const e14 = new gZt();
    return { event: e14, trigger: e14._trigger };
  }
  register(e14) {
    if ("function" != typeof e14) throw new Error("callback is not a function");
    const t10 = gZt.generateKey();
    return this._eventHandlers[t10] = e14, () => {
      delete this._eventHandlers[t10];
    };
  }
  hasListeners() {
    return Object.keys(this._eventHandlers).length > 0;
  }
}
gZt._lastKey = +/* @__PURE__ */ new Date(), gZt.generateKey = () => {
  const e14 = 65539 * gZt._lastKey % 4294967087;
  return gZt._lastKey = e14, e14;
}, window.arjsDesigner = window.arjsDesigner || {}, window.arjsDesigner.addLocalization = (e14, t10) => {
  !function(e15, t11) {
    y(this, void 0, void 0, function* () {
      yield RRt;
      const n10 = Array.isArray(t11) && t11.find((e16) => e16.ns === _Rt);
      n10 && !VRt.hasResourceBundle(e15, _Rt) && VRt.addResourceBundle(e15, n10.ns, n10.resources);
      const r10 = Array.isArray(t11) && t11.find((e16) => "core" === e16.ns);
      r10 && !VRt.hasResourceBundle(e15, r10.ns) && VRt.addResourceBundle(e15, r10.ns, r10.resources);
    });
  }(e14, t10.arjswd), function(e15, t11) {
    ARt[e15] = t11;
  }(e14, t10.wdCore);
}, window.arjsDesigner.loadLocalizations && window.arjsDesigner.loadLocalizations();
class yZt {
  constructor(e14, t10 = {}) {
    this.events = { documentChanged: gZt.createFor() }, this.impl = pZt.create(e14, t10, this.events);
  }
  createReport(e14, t10 = "ask") {
    return y(this, void 0, void 0, function* () {
      const n10 = yield this.impl;
      try {
        return yield n10.createReport(fZt(hZt, e14, (e15) => `Invalid argument "reportInfo". ${e15}.`), fZt(mZt, t10, (e15) => `Invalid argument "whenDirty". ${e15}.`));
      } catch (e15) {
        throw n10.notifications.error(VRt.t("error.api.createReportFailed", "Failed to create report."), y$t(e15)), e15;
      }
    });
  }
  setReport(e14, t10 = "ask", n10 = false) {
    return y(this, void 0, void 0, function* () {
      return (yield this.impl).setReport(e14, t10, n10);
    });
  }
  getReport() {
    return y(this, void 0, void 0, function* () {
      return (yield this.impl).getReport();
    });
  }
  setActionHandlers(e14) {
    return y(this, void 0, void 0, function* () {
      return (yield this.impl).setActionHandlers(e14);
    });
  }
  setResourceProvider(e14) {
    return y(this, void 0, void 0, function* () {
      return (yield this.impl).setResourceProvider(e14);
    });
  }
  processCommand(e14) {
    return y(this, void 0, void 0, function* () {
      return (yield this.impl).processCommand(e14);
    });
  }
  setDataSourceTemplates(e14) {
    return y(this, void 0, void 0, function* () {
      return (yield this.impl).setDataSourceTemplates(e14);
    });
  }
  setControlItems(e14) {
    this.impl.then((t10) => t10.setControlItems(e14));
  }
  get documentChanged() {
    return this.events.documentChanged.event;
  }
  focus() {
    this.impl.then((e14) => e14.focus());
  }
  getEditorAPI() {
    return y(this, void 0, void 0, function* () {
      return (yield this.impl).editor;
    });
  }
  getPanelsAPI() {
    return Promise.resolve({ menu: { open: (e14) => y(this, void 0, void 0, function* () {
      (yield this.impl).panels.menu.open(e14);
    }), pin: () => y(this, void 0, void 0, function* () {
      (yield this.impl).panels.menu.pin();
    }), close: () => y(this, void 0, void 0, function* () {
      (yield this.impl).panels.menu.close();
    }) }, sidebar: { open: (e14) => y(this, void 0, void 0, function* () {
      (yield this.impl).panels.sidebar.open(e14);
    }), close: () => y(this, void 0, void 0, function* () {
      (yield this.impl).panels.menu.close();
    }) } });
  }
  getNotificationsAPI() {
    return Promise.resolve({ send: (e14, t10, n10) => y(this, void 0, void 0, function* () {
      (yield this.impl).notifications.send(e14, t10, n10);
    }), info: (e14, t10) => y(this, void 0, void 0, function* () {
      (yield this.impl).notifications.info(e14, t10);
    }), error: (e14, t10) => y(this, void 0, void 0, function* () {
      (yield this.impl).notifications.error(e14, t10);
    }), warning: (e14, t10) => y(this, void 0, void 0, function* () {
      (yield this.impl).notifications.warning(e14, t10);
    }), dismissAll: () => y(this, void 0, void 0, function* () {
      (yield this.impl).notifications.dismissAll();
    }) });
  }
  getReportPartsLibraries() {
    return y(this, void 0, void 0, function* () {
      return (yield this.impl).getReportPartsLibraries();
    });
  }
  setReportPartsLibraries(e14) {
    return y(this, void 0, void 0, function* () {
      return (yield this.impl).setReportPartsLibraries(e14);
    });
  }
}
export {
  yZt as Designer
};
